
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec2fd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec2fd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lb2Ei", function(module, exports) {

$parcel$export(module.exports, "isWhitelabelPreviewHost", () => $f6acae106a2feb5f$export$ae244597126d25b3);
$parcel$export(module.exports, "isPlatformHost", () => $f6acae106a2feb5f$export$605514fb9d037f1e);
$parcel$export(module.exports, "isCustomDomainHost", () => $f6acae106a2feb5f$export$43176103e8743dd4);
// Hostname gate for WHITELABEL-1 layer 4 (shell boot).
//
// Mirrors `isDemoHost()` (demoHost.js) — a pure, dependency-free hostname
// classifier the shell can call at module-load time, before anything else
// has mounted. `isPlatformHost` below is the CLIENT-SIDE twin of the
// server's `isPlatformHost` (server/src/core/services/CustomDomainService.js)
// — same three suffixes, same "empty/SSR host → treat as platform" fail-safe.
// It is NOT a re-derivation of the server's actual host→scope MAPPING (which
// org/workspace a given custom domain resolves to) — that stays entirely
// server-side (`resolveScopeForHost`, `customDomainScope` middleware); this
// file only answers "is the current host one of Symbols' own platform hosts,
// or something else" — the same category judgment
// `server 4fbe1ba0`'s `customDomainScope` middleware makes before it will
// even attempt a DB read.
//
// Per CLAUDE.md "never hardcode a domain": the three suffixes below are the
// PLATFORM's own domains (symbols.app / symbo.ls / localhost) — the fixed
// rule every request is classified against, mirrored 1:1 from the server's
// default `PLATFORM_HOST_SUFFIXES`. No customer domain (e.g. an enterprise
// org's `app.<their-domain>`) is ever named here or anywhere in this file.
//
// Local simulation (no DNS / no `customDomains` row needed): set
// `localStorage.symbols_force_custom_domain='1'` (persists across reloads)
// OR append `?customDomain=1` to any URL (one visit) — same override
// convention as `isDemoHost()`'s `symbols_force_demo` / `?demo=1`.
const $f6acae106a2feb5f$var$PLATFORM_HOST_SUFFIXES = [
    'symbols.app',
    'symbo.ls',
    'localhost'
];
// WHITELABEL-DEPLOY-PREVIEW-BASE-1 — the shared preview zone a white-label
// org resolves under (`<slug>.pr.symbols.app`) before it owns a domain of
// its own. Mirrors the server's `WHITELABEL_PREVIEW_BASE` default 1:1 (see
// `server/src/core/services/CustomDomainService.js`) — hardcoded here, not
// env-read, for the same reason `PLATFORM_HOST_SUFFIXES` above is: this
// classifier runs at module-load time, before any build-time env is wired.
const $f6acae106a2feb5f$var$WHITELABEL_PREVIEW_BASE = 'pr.symbols.app';
const $f6acae106a2feb5f$export$ae244597126d25b3 = (hostname)=>{
    const h = typeof hostname === 'string' ? hostname.split(':')[0].trim().toLowerCase() : '';
    if (!h) return false;
    return h === $f6acae106a2feb5f$var$WHITELABEL_PREVIEW_BASE || h.endsWith(`.${$f6acae106a2feb5f$var$WHITELABEL_PREVIEW_BASE}`);
};
const $f6acae106a2feb5f$export$605514fb9d037f1e = (hostname)=>{
    const h = typeof hostname === 'string' ? hostname.split(':')[0].trim().toLowerCase() : '';
    if (!h) return true;
    if ($f6acae106a2feb5f$export$ae244597126d25b3(h)) return false;
    return $f6acae106a2feb5f$var$PLATFORM_HOST_SUFFIXES.some((suffix)=>h === suffix || h.endsWith(`.${suffix}`));
};
const $f6acae106a2feb5f$export$43176103e8743dd4 = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        // Test overrides FIRST — let any host (incl. a real platform host, for
        // local dev) simulate a host-resolved boot without a live DNS + verified
        // `customDomains` row.
        if (window.localStorage.getItem('symbols_force_custom_domain') === '1') return true;
        if ((window.location.search || '').includes('customDomain=1')) return true;
        return !$f6acae106a2feb5f$export$605514fb9d037f1e(window.location.hostname || '');
    } catch (_) {
        // localStorage / location may throw in sandboxed contexts — fail toward
        // "platform host" so a broken read never accidentally root-maps
        // my.symbols.app.
        return false;
    }
};

});

parcelRegister("hmkNw", function(module, exports) {

$parcel$export(module.exports, "channels", () => $ca349fb9f1953d34$export$9659c395d9de169e);
$parcel$export(module.exports, "channelNames", () => $ca349fb9f1953d34$export$fa22149e93fb7e8e);
$parcel$export(module.exports, "resolveChannel", () => $ca349fb9f1953d34$export$23106789b3d0c0e3);
$parcel$export(module.exports, "setChannel", () => $ca349fb9f1953d34$export$ad4da790fc3f971a);
$parcel$export(module.exports, "currentChannel", () => $ca349fb9f1953d34$export$e76fc4f1971356db);
$parcel$export(module.exports, "channelByApiUrl", () => $ca349fb9f1953d34$export$61df76ed73824ede);
$parcel$export(module.exports, "apiUrl", () => $ca349fb9f1953d34$export$e9ddf1da8d18d6f);
$parcel$export(module.exports, "socketUrl", () => $ca349fb9f1953d34$export$7ba24559de2e3800);
$parcel$export(module.exports, "shellUrl", () => $ca349fb9f1953d34$export$fe7c4d79648da74);
$parcel$export(module.exports, "previewUrl", () => $ca349fb9f1953d34$export$3239d996d035c0a2);
$parcel$export(module.exports, "previewProjectUrl", () => $ca349fb9f1953d34$export$28766a4029df7284);
$parcel$export(module.exports, "mermaidUrl", () => $ca349fb9f1953d34$export$3f5943486608d618);
$parcel$export(module.exports, "deployTarget", () => $ca349fb9f1953d34$export$dd4ee7b901274235);
$parcel$export(module.exports, "screenshotCdnHost", () => $ca349fb9f1953d34$export$e180c1129b6b96b7);
$parcel$export(module.exports, "screenshotCdnUrl", () => $ca349fb9f1953d34$export$d5e7787888b413b9);
$parcel$export(module.exports, "isKnownChannel", () => $ca349fb9f1953d34$export$954d715b7f626f);
$parcel$export(module.exports, "defaultChannel", () => $ca349fb9f1953d34$export$ce6c8d43e3ceca7a);
$parcel$export(module.exports, "normalizeOwnerSegment", () => $ca349fb9f1953d34$export$2185b6a2cd449994);
$parcel$export(module.exports, "normalizeProjectSlug", () => $ca349fb9f1953d34$export$9933f4434a390e71);
$parcel$export(module.exports, "normalizeProjectKey", () => $ca349fb9f1953d34$export$c5b3f7b0f9672b33);
$parcel$export(module.exports, "parseSymboLsHost", () => $ca349fb9f1953d34$export$d894e8cd9fb6a8fd);
var $ca349fb9f1953d34$export$9659c395d9de169e = {
    channels: {
        local: {
            api: "http://localhost:8080",
            socket: "http://localhost:8080",
            shell: "http://my.localhost:1355",
            preview: "http://preview.localhost:1355",
            mermaidApex: "localhost:1355",
            deploy: {}
        },
        development: {
            api: "https://dev.api.symbols.app",
            socket: "https://dev.api.symbols.app",
            shell: "https://dev.my.symbols.app",
            preview: "https://dev.preview.symbols.app",
            mermaidApex: "dev.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-dev",
                previewWorker: "smbls-preview-dev",
                mermaidWorker: "mermaid-dev"
            }
        },
        "demo-dev": {
            api: "https://dev.api.symbols.app",
            socket: "https://dev.api.symbols.app",
            shell: "https://dev.demo.symbols.app",
            preview: "https://dev.preview.symbols.app",
            mermaidApex: "dev.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-demo-dev",
                previewWorker: "smbls-preview-dev",
                mermaidWorker: "mermaid-dev"
            }
        },
        next: {
            api: "https://next.api.symbols.app",
            socket: "https://next.api.symbols.app",
            shell: "https://next.my.symbols.app",
            preview: "https://next.preview.symbols.app",
            mermaidApex: "next.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-next",
                previewWorker: "smbls-preview-next",
                mermaidWorker: "mermaid-next"
            }
        },
        test: {
            api: "https://test.api.symbols.app",
            socket: "https://test.api.symbols.app",
            shell: "https://test.my.symbols.app",
            preview: "https://test.preview.symbols.app",
            mermaidApex: "test.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-test",
                previewWorker: "smbls-preview-test",
                mermaidWorker: "mermaid-test"
            }
        },
        upcoming: {
            api: "https://upcoming.api.symbols.app",
            socket: "https://upcoming.api.symbols.app",
            shell: "https://upcoming.my.symbols.app",
            preview: "https://upcoming.preview.symbols.app",
            mermaidApex: "upcoming.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-upcoming",
                previewWorker: "smbls-preview-upcoming",
                mermaidWorker: "mermaid-upcoming"
            }
        },
        staging: {
            api: "https://staging.api.symbols.app",
            socket: "https://staging.api.symbols.app",
            shell: "https://staging.my.symbols.app",
            preview: "https://staging.preview.symbols.app",
            mermaidApex: "staging.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-staging",
                previewWorker: "smbls-preview-staging",
                mermaidWorker: "mermaid-staging"
            }
        },
        demo: {
            api: "https://api.symbols.app",
            socket: "https://api.symbols.app",
            shell: "https://demo.symbols.app",
            preview: "https://preview.symbols.app",
            mermaidApex: "at.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-demo",
                previewWorker: "smbls-preview",
                mermaidWorker: "mermaid"
            }
        },
        production: {
            api: "https://api.symbols.app",
            socket: "https://api.symbols.app",
            shell: "https://my.symbols.app",
            preview: "https://preview.symbols.app",
            mermaidApex: "at.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-prod",
                previewWorker: "smbls-preview",
                mermaidWorker: "mermaid"
            }
        }
    },
    defaultChannel: "production",
    screenshotCdn: "screenshots.api.symbols.app"
};
var $ca349fb9f1953d34$export$fa22149e93fb7e8e = Object.keys($ca349fb9f1953d34$export$9659c395d9de169e.channels), $ca349fb9f1953d34$var$a = (e)=>!!(e && $ca349fb9f1953d34$export$9659c395d9de169e.channels[e]), $ca349fb9f1953d34$export$23106789b3d0c0e3 = (e)=>$ca349fb9f1953d34$var$a(e) ? $ca349fb9f1953d34$export$9659c395d9de169e.channels[e] : $ca349fb9f1953d34$export$9659c395d9de169e.channels[$ca349fb9f1953d34$export$9659c395d9de169e.defaultChannel], $ca349fb9f1953d34$export$ad4da790fc3f971a = (e)=>{
    typeof globalThis > "u" || (globalThis.__SYMBOLS_CHANNEL__ = $ca349fb9f1953d34$var$a(e) ? e : null, $ca349fb9f1953d34$var$h = void 0);
}, $ca349fb9f1953d34$var$h, $ca349fb9f1953d34$var$m = (e)=>null, $ca349fb9f1953d34$export$e76fc4f1971356db = ()=>{
    if ($ca349fb9f1953d34$var$h !== void 0) return $ca349fb9f1953d34$var$h;
    let e = typeof globalThis < "u" ? globalThis.__SYMBOLS_CHANNEL__ : null, s = $ca349fb9f1953d34$var$m("SYMBOLS_CHANNEL"), t = $ca349fb9f1953d34$var$m("NODE_ENV"), o = $ca349fb9f1953d34$var$m("SYMBOLS_API_URL") || $ca349fb9f1953d34$var$m("SYMBOLS_API_BASE_URL"), n = o ? $ca349fb9f1953d34$export$61df76ed73824ede(String(o).trim().replace(/\/+$/, "")) : null;
    return $ca349fb9f1953d34$var$h = $ca349fb9f1953d34$var$a(e) && e || $ca349fb9f1953d34$var$a(s) && s || $ca349fb9f1953d34$var$a(n) && n || $ca349fb9f1953d34$var$a(t) && t || $ca349fb9f1953d34$export$9659c395d9de169e.defaultChannel, $ca349fb9f1953d34$var$h === $ca349fb9f1953d34$export$9659c395d9de169e.defaultChannel && !$ca349fb9f1953d34$var$a(e) && !$ca349fb9f1953d34$var$a(s) && !$ca349fb9f1953d34$var$a(n) && $ca349fb9f1953d34$var$a(t), $ca349fb9f1953d34$var$h;
}, $ca349fb9f1953d34$var$v = [
    "production",
    "staging",
    "upcoming",
    "next",
    "test",
    "development",
    "local",
    "demo",
    "demo-dev"
], $ca349fb9f1953d34$var$f = (e)=>{
    let s = $ca349fb9f1953d34$var$v.indexOf(e);
    return s === -1 ? $ca349fb9f1953d34$var$v.length : s;
}, $ca349fb9f1953d34$export$61df76ed73824ede = (e)=>{
    if (!e) return null;
    let s = Object.keys($ca349fb9f1953d34$export$9659c395d9de169e.channels).filter((t)=>$ca349fb9f1953d34$export$9659c395d9de169e.channels[t].api === e);
    return s.length === 0 ? null : s.length === 1 ? s[0] : s.sort((t, o)=>$ca349fb9f1953d34$var$f(t) - $ca349fb9f1953d34$var$f(o))[0];
}, $ca349fb9f1953d34$export$e9ddf1da8d18d6f = (e = $ca349fb9f1953d34$export$e76fc4f1971356db())=>$ca349fb9f1953d34$var$m("SYMBOLS_API_URL") || $ca349fb9f1953d34$export$23106789b3d0c0e3(e).api, $ca349fb9f1953d34$export$7ba24559de2e3800 = (e = $ca349fb9f1953d34$export$e76fc4f1971356db())=>$ca349fb9f1953d34$var$m("SYMBOLS_SOCKET_URL") || $ca349fb9f1953d34$export$23106789b3d0c0e3(e).socket, $ca349fb9f1953d34$export$fe7c4d79648da74 = (e = $ca349fb9f1953d34$export$e76fc4f1971356db())=>$ca349fb9f1953d34$export$23106789b3d0c0e3(e).shell || null, $ca349fb9f1953d34$export$3239d996d035c0a2 = (e = $ca349fb9f1953d34$export$e76fc4f1971356db())=>$ca349fb9f1953d34$export$23106789b3d0c0e3(e).preview || null, $ca349fb9f1953d34$export$28766a4029df7284 = ({ owner: e, key: s, env: t = "production" } = {}, o = $ca349fb9f1953d34$export$e76fc4f1971356db())=>{
    let n = $ca349fb9f1953d34$export$3239d996d035c0a2(o);
    if (!n || !e || !s) return null;
    let l = n.match(/^(https?:\/\/)(.+)$/);
    if (!l) return null;
    let [, i, r] = l, c = `${encodeURIComponent(e)}--${encodeURIComponent(s)}`, y = `${i}${c}.${r}/`;
    return !t || t === "production" || t === "prod" ? y : `${y}?env=${encodeURIComponent(t)}`;
}, $ca349fb9f1953d34$export$3f5943486608d618 = ({ owner: e, key: s, env: t = "production" } = {}, o = $ca349fb9f1953d34$export$e76fc4f1971356db())=>{
    let n = $ca349fb9f1953d34$export$23106789b3d0c0e3(o).mermaidApex;
    if (!n || !e || !s) return null;
    let i = !t || t === "production" || t === "prod" ? "" : `--${encodeURIComponent(t)}`, r = `${encodeURIComponent(e)}--${encodeURIComponent(s)}${i}`;
    return `${n.startsWith("localhost") ? "http" : "https"}://${r}.${n}`;
}, $ca349fb9f1953d34$export$dd4ee7b901274235 = (e = $ca349fb9f1953d34$export$e76fc4f1971356db())=>$ca349fb9f1953d34$export$23106789b3d0c0e3(e).deploy || {}, $ca349fb9f1953d34$export$e180c1129b6b96b7 = ()=>$ca349fb9f1953d34$var$m("SYMBOLS_SCREENSHOT_CDN") || $ca349fb9f1953d34$export$9659c395d9de169e.screenshotCdn, $ca349fb9f1953d34$export$d5e7787888b413b9 = ({ owner: e, key: s, page: t = "root", componentKey: o, env: n = "production", width: l } = {})=>{
    if (!e || !s) return null;
    let i = o ? `component/${encodeURIComponent(o)}` : encodeURIComponent(String(t || "root").replace(/^\/+/, "").replace(/\//g, "-") || "root"), r = [];
    n && n !== "production" && r.push(`env=${encodeURIComponent(n)}`), l && r.push(`w=${Number(l)}`);
    let c = r.length ? `?${r.join("&")}` : "";
    return `https://${$ca349fb9f1953d34$export$e180c1129b6b96b7()}/${encodeURIComponent(e)}/${encodeURIComponent(s)}/${i}.webp${c}`;
}, $ca349fb9f1953d34$export$954d715b7f626f = $ca349fb9f1953d34$var$a, $ca349fb9f1953d34$export$ce6c8d43e3ceca7a = $ca349fb9f1953d34$export$9659c395d9de169e.defaultChannel, $ca349fb9f1953d34$export$2185b6a2cd449994 = (e)=>e == null || typeof e != "string" ? "" : String(e).toLowerCase().trim().replace(/[^a-z0-9-]+/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "").slice(0, 32) || "", $ca349fb9f1953d34$export$9933f4434a390e71 = (e)=>e == null || typeof e != "string" ? "" : String(e).toLowerCase().trim().replace(/[^a-z0-9-]+/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "").slice(0, 48) || "", $ca349fb9f1953d34$export$c5b3f7b0f9672b33 = (e, s = {})=>{
    let t = String(e || "").trim();
    if (!t) return "";
    /\.symbo\.ls$/iu.test(t) && (t = t.replace(/\.symbo\.ls$/iu, "")), t.includes("/") && (t = t.split("/").pop());
    let o = typeof s.owner == "string" ? s.owner.trim() : "";
    return o && t.startsWith(`${o}--`) ? t = t.slice(o.length + 2) : !o && t.includes("--") && (t = t.slice(t.indexOf("--") + 2)), t;
}, $ca349fb9f1953d34$var$w = {
    at: "production",
    prod: "production",
    production: "production",
    dev: "development",
    development: "development",
    next: "next",
    upcoming: "upcoming",
    test: "test",
    staging: "staging"
}, $ca349fb9f1953d34$export$d894e8cd9fb6a8fd = (e)=>{
    if (typeof e != "string" || !e) return null;
    let s = e.toLowerCase().replace(/^www\./, "").replace(/\/$/, "");
    if (!s.endsWith(".symbo.ls")) return null;
    let t = s.split(".");
    if (t.length < 4 || t.slice(-2).join(".") !== "symbo.ls") return null;
    if (t.length === 4) {
        let l = t[1], i = t[0], r = $ca349fb9f1953d34$var$w[l];
        if (r && i.includes("--")) {
            let c = i.split("--");
            if (c.length === 2 || c.length === 3) {
                let [y, b, g] = c;
                if (y && b) {
                    let x = g ? $ca349fb9f1953d34$var$w[g] || g : null;
                    return {
                        projectKey: b,
                        owner: y,
                        env: x || r,
                        sysEnv: r
                    };
                }
            }
        }
    }
    if (t.length >= 5) return {
        projectKey: t[1],
        owner: t[2],
        env: t[0]
    };
    let o = t[1], n = t[0];
    if (n.includes("--")) {
        let [l, i] = n.split("--", 2);
        return !l || !i ? null : {
            projectKey: l,
            owner: o,
            env: i
        };
    }
    return {
        projectKey: n,
        owner: o,
        env: "production"
    };
};

});

parcelRegister("1X0Je", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bbddcaba382b77$export$2e2bcd8739ae039);
// Pages are wired as a NAMESPACE for frank (the platform serializer): this
// package's pages are named page objects the workspace shell imports directly
// and maps onto ITS route table — the package never owned routes. Frank's
// extract guard compares pages/*.js on disk against extracted entries and
// refuses to push when files exist but zero entries extract (the guard that
// stopped the 2026-04 silverbreeze zero-page overwrites). A namespace keeps it
// honest without fabricating a route map: entries are keyed by export name,
// not '/route', and shared-library merge only auto-mounts ROUTE keys, so
// consumers cannot accidentally mount these.

var $kQTex = parcelRequire("kQTex");

var $gbEhA = parcelRequire("gbEhA");
parcelRequire("guSQX");
var $cvFPD = parcelRequire("cvFPD");
var $j7gGM = parcelRequire("j7gGM");
var $guSQX = parcelRequire("guSQX");

var $dyqu6 = parcelRequire("dyqu6");

var $eMkMf = parcelRequire("eMkMf");

var $eV30a = parcelRequire("eV30a");

var $8tiQv = parcelRequire("8tiQv");
// The interface-translation config, and the ONE place it may live.
//
// It used to sit on the workspace shell's own context. Measured with
// `frank.toJSON` on packages/workspace: `defaultLang: ""`, `languages: ""`,
// `translations.en: 0 keys`. `smbls` and every `@symbo-ls/*` package are on
// frank's EXTERNAL_PACKAGES list, so a value the shell imported from one of
// them and dropped straight into a section bag published as `""`. The shell
// shipped a polyglot config with no default language, no language list and no
// English base — silently, because the build itself did not throw.
//
// It cannot be repaired from outside either. `mergeOneLibrary`
// (smbls/packages/utils/sharedLibraries.js) fills a consumer's key only when
// `!(k in context[key])`, and its stub-phantom rescue covers OBJECT_BAGS
// (components/pages/functions/snippets/methods) alone — `polyglot` is not in
// that set, so the shell's own `""` would have beaten a real library value.
// The config must not be declared stubbed in the first place.
//
// HERE it is project-local: `functions/languages.js` is the platform's
// language registry and `i18nStaticEnglish()` assembles the English base from
// `i18n/en/*.json`, both inside this package, so frank serializes real values.
// And because `mergeOneLibrary`'s last branch copies a whole top-level key when
// the consumer does not define it (`else if (!(key in context))`), every
// consumer inherits the real object — provided no consumer declares a
// `polyglot` of its own. All five apps declare this library (workspace, canvas,
// marketplace, preview, analytics), so all five get translations, not just the
// shell. That matters beyond tidiness: the account page also mounts under
// canvas, and `replaceLiteralsWithObjectFields` (smbls/packages/utils/
// string.js) returns '' — an EMPTY label, not the key — when the `polyglot`
// filter is not registered.
//
// No `plugins` entry here on purpose. `createDomql` registers the polyglot
// plugin AND its functions itself whenever it sees `context.polyglot` and no
// plugin named `polyglot`. Importing the plugin to declare it would reintroduce
// the very cross-package stub this move exists to remove.
//
// `storageLangKey` MUST be `lang`: polyglot's own default is `smbls_lang`, and
// `initPolyglot` reads this key on the root render. Left at the default it
// would read an unset key, fall back to `defaultLang`, and write English over
// whatever bootShell resolved.
//
// `translations` carries THE BASE LANGUAGE ONLY — English — bundled, never
// fetched. It is the fallback for every miss, and
// `replaceLiteralsWithObjectFields` / polyglot's `translate()` return the KEY
// ITSELF when no step resolves, so a base language that needed a round trip
// would put a raw `common.action.save` on screen the first time anything went
// wrong. Every OTHER language is a lazily-imported, content-hashed chunk per
// namespace: `functions/i18nLoader.js` holds the registry, the Parcel
// measurements behind the split, and the reason a template-literal dynamic
// import is not an option.
//
// It carried every shipped language until 2026-09-02. That was right at 77
// keys and wrong at the platform's target size: English alone is ~100 KB at
// ~2900 keys and each further language would add ~120 KB to the FIRST paint of
// every visitor, in a language almost none of them will pick.
//
// `namespaces` is the LOAD list — the bundles this session needs in whatever
// language it ends up in. bootShell narrows it per route from the running
// app's manifest (`i18nNamespaces`) and `setLang` re-loads exactly that set on
// a switch. Declared HERE as well so it exists on every context, including one
// bootShell never ran for (a sub-app mounted by the shell's dispatch gets the
// library merge but not the boot sequence).
//
// ON A PUBLISHED RECORD there are no chunks to import, so a non-English
// language must be BAKED into this object to be switchable there. English is
// baked by construction: frank runs this module body in Node, so
// `i18nStaticTranslations()` returns real strings and they serialize as data.
const $16bbddcaba382b77$var$polyglot = {
    defaultLang: $cvFPD.DEFAULT_LANG,
    languages: $cvFPD.PLATFORM_LANGUAGES.map((l)=>l.code),
    storageLangKey: 'lang',
    namespaces: [
        'common',
        'auth',
        'account',
        'settings',
        // Added with the shared-package extraction (2026-09-02). Every one of
        // these has real en+ka bundles on disk; a namespace listed here but not
        // shipped is dropped by the loader's own intersection, and one SHIPPED but
        // not listed here resolves English only — the switch simply never reaches
        // it, silently, because English is bundled.
        'shell',
        'editor',
        'members',
        'learn',
        'ai',
        'publish',
        'apps',
        'workspace',
        'admin',
        'data',
        // Store copy is SHELL CHROME (2026-09-03) — kept in step with bootShell's
        // own BOOT_NAMESPACES, which a parity gate pins
        // (__tests__/i18nBootMountDelivery.test.js). Every installed app's navbar
        // tab and launcher tile resolves its label through the one store-copy
        // resolver (`functions/storeItemText.js` -> `marketplace.app.<slug>.name`),
        // so an app reads the same name here as in the store it came from.
        'marketplace'
    ],
    translations: $j7gGM.i18nStaticTranslations()
};
var // The runtime packages this library dynamic-imports (dependencies.js), on the
// platform record. frank builds the payload from THIS module, so a package
// that dependencies.js declares but this export leaves out never reaches the
// system/shared record (measured 2026-10-31 on a dev push rehearsal: the only
// dependency op was `prismjs: "latest"`, the 6 pins were lost).
//
// `dependenciesOnDemand` lists the SAME pins (Nika 2026-10-31: "each loaded
// only when a page uses it"). Every entry is an `await import('<pkg>')`
// inside a handler (FA206), so nothing needs it before the first render.
// smbls prepare.js: `prepareDependencies` skips an on-demand entry and
// `splitDependencies` never defers it to the after-render preload, so no page
// loads these 6 at boot. `getImportMapScript` (@symbo.ls/utils cdn.js) reads
// `dependencies` only, so this library's own page still maps each name and
// `import('<pkg>')` resolves on use. `mergeOneLibrary` copies both keys into
// a consumer the same way (add-missing), and the on-demand key acts by name:
// a consumer's or another library's entry of the same name is not preloaded
// either. __tests__/contextDependenciesOnDemand.test.js pins all of this.
//
// A CONSUMER page resolves `import('<pkg>')` only when its OWN importmap maps
// the name: mermaid serves libraries unmerged (mermaid bundle.js) and builds
// the importmap from the consumer's `dependencies` alone, and frank keeps
// the handler's import literal (no `__SMBLS_PKGS__` read), so a boot preload
// of a library entry never made that import resolve. Dropping the preload
// costs a consumer nothing; mapping library entries into a consumer's
// importmap is a framework (mermaid) change.
$16bbddcaba382b77$export$2e2bcd8739ae039 = {
    pages: $gbEhA,
    components: $kQTex,
    functions: $guSQX,
    methods: $dyqu6,
    state: $eMkMf,
    designSystem: $eV30a.default,
    dependencies: $8tiQv.default,
    dependenciesOnDemand: {
        ...(0, $8tiQv.default)
    },
    polyglot: $16bbddcaba382b77$var$polyglot
};

});
parcelRegister("kQTex", function(module, exports) {
// @symbo.ls/{windows,dropdown,tooltip} components (ModalRoot, ModalLayer,
// the dialog templates, DropdownRoot/Trigger + legacy Dropdown* shapes,
// TooltipRoot/Trigger + legacy Tooltip* shapes) are NOT re-exported here.
// The smbls runtime merges them into every context itself (prepareContext,
// smbls cedec5903 — same guard as @symbo.ls/polyglot; opt out per system
// with `context.windows|dropdown|tooltip = false`). A top-level bag
// re-export of an externalized specifier publishes as "" and that ""
// shadowed the real values in consumers (FRANK-PAGES-BAG-1,
// WORKSPACE-SHELL-UNDECLARED-IMPORTS-1); the plugin headers now forbid it.

var $8pnHz = parcelRequire("8pnHz");

var $60N5k = parcelRequire("60N5k");

var $7HU5f = parcelRequire("7HU5f");

var $k4bQc = parcelRequire("k4bQc");

var $kWFE3 = parcelRequire("kWFE3");

var $2PO9F = parcelRequire("2PO9F");

var $4ei3X = parcelRequire("4ei3X");

var $aR9lQ = parcelRequire("aR9lQ");

var $hTQjv = parcelRequire("hTQjv");

var $5Jwoo = parcelRequire("5Jwoo");

var $cbGeH = parcelRequire("cbGeH");

var $jdbZY = parcelRequire("jdbZY");

var $l82Az = parcelRequire("l82Az");

var $19uAL = parcelRequire("19uAL");

var $i41vD = parcelRequire("i41vD");

var $3JSwc = parcelRequire("3JSwc");

var $agmHi = parcelRequire("agmHi");

var $iJo40 = parcelRequire("iJo40");

var $8G5VK = parcelRequire("8G5VK");

var $dngBU = parcelRequire("dngBU");

var $ee5Fb = parcelRequire("ee5Fb");

var $8MiLp = parcelRequire("8MiLp");

var $lXaM8 = parcelRequire("lXaM8");

var $ZviK2 = parcelRequire("ZviK2");

var $crhkn = parcelRequire("crhkn");

var $4VxOT = parcelRequire("4VxOT");

var $8VqFn = parcelRequire("8VqFn");

var $grZn4 = parcelRequire("grZn4");

var $3erwy = parcelRequire("3erwy");

var $i3LgR = parcelRequire("i3LgR");

var $6P0et = parcelRequire("6P0et");

var $422PO = parcelRequire("422PO");

var $6kXqC = parcelRequire("6kXqC");

var $kvJNN = parcelRequire("kvJNN");

var $5Kt5i = parcelRequire("5Kt5i");

var $angsT = parcelRequire("angsT");

var $4bDXo = parcelRequire("4bDXo");

var $90sUK = parcelRequire("90sUK");

var $heR8J = parcelRequire("heR8J");

var $7udiq = parcelRequire("7udiq");

var $eoJr3 = parcelRequire("eoJr3");

var $1oTHf = parcelRequire("1oTHf");

var $aFEwk = parcelRequire("aFEwk");

var $9Ht0m = parcelRequire("9Ht0m");

var $5ytgv = parcelRequire("5ytgv");

var $8UxUv = parcelRequire("8UxUv");

var $8wp52 = parcelRequire("8wp52");

var $fa8nh = parcelRequire("fa8nh");

var $5uQ8N = parcelRequire("5uQ8N");

var $4hXc3 = parcelRequire("4hXc3");

var $eHVf7 = parcelRequire("eHVf7");

var $hBOPV = parcelRequire("hBOPV");

var $gSI3w = parcelRequire("gSI3w");

var $f8wM8 = parcelRequire("f8wM8");

var $ajIJv = parcelRequire("ajIJv");

var $iToPu = parcelRequire("iToPu");

var $duAq3 = parcelRequire("duAq3");

var $hPOOF = parcelRequire("hPOOF");

var $jexpo = parcelRequire("jexpo");

var $XQdJz = parcelRequire("XQdJz");

var $lUIcz = parcelRequire("lUIcz");

var $65E03 = parcelRequire("65E03");

var $fyymM = parcelRequire("fyymM");

var $huryk = parcelRequire("huryk");

var $ivtZq = parcelRequire("ivtZq");

var $9BuYc = parcelRequire("9BuYc");

var $6g7r0 = parcelRequire("6g7r0");

var $8RJFW = parcelRequire("8RJFW");

var $gFO4G = parcelRequire("gFO4G");

var $4vbFx = parcelRequire("4vbFx");

var $4ot0c = parcelRequire("4ot0c");

var $4jWBv = parcelRequire("4jWBv");

var $2Y3ZC = parcelRequire("2Y3ZC");

var $2NZLH = parcelRequire("2NZLH");

var $9Oc4t = parcelRequire("9Oc4t");

var $57Nb9 = parcelRequire("57Nb9");

var $334b0 = parcelRequire("334b0");

var $946QX = parcelRequire("946QX");

var $17dNB = parcelRequire("17dNB");

var $g3ftr = parcelRequire("g3ftr");

var $6T65T = parcelRequire("6T65T");

var $3ywb8 = parcelRequire("3ywb8");

var $6dIo9 = parcelRequire("6dIo9");

var $1bajT = parcelRequire("1bajT");

var $lEzlR = parcelRequire("lEzlR");

var $8MK2B = parcelRequire("8MK2B");

var $25iav = parcelRequire("25iav");

var $9LcDL = parcelRequire("9LcDL");

var $PepXP = parcelRequire("PepXP");

var $dI7M1 = parcelRequire("dI7M1");

var $9dwcZ = parcelRequire("9dwcZ");

var $3Unag = parcelRequire("3Unag");

var $i7Cwa = parcelRequire("i7Cwa");

var $anekH = parcelRequire("anekH");

var $iSjpO = parcelRequire("iSjpO");

var $jz85T = parcelRequire("jz85T");

var $bgri5 = parcelRequire("bgri5");

var $cVgHD = parcelRequire("cVgHD");

var $6l5up = parcelRequire("6l5up");

var $l2dag = parcelRequire("l2dag");

var $QWd3l = parcelRequire("QWd3l");

var $9Y2Gx = parcelRequire("9Y2Gx");

var $lacrQ = parcelRequire("lacrQ");

var $dKynU = parcelRequire("dKynU");

var $6FHpI = parcelRequire("6FHpI");

var $2i7tj = parcelRequire("2i7tj");

var $9lJSC = parcelRequire("9lJSC");

var $1zLpu = parcelRequire("1zLpu");

var $5b7A3 = parcelRequire("5b7A3");

var $QpQpJ = parcelRequire("QpQpJ");

var $53EEE = parcelRequire("53EEE");

var $boLZC = parcelRequire("boLZC");

var $722a7 = parcelRequire("722a7");

var $9cXQa = parcelRequire("9cXQa");

var $3QmN9 = parcelRequire("3QmN9");

var $42HIn = parcelRequire("42HIn");

var $2w1Rh = parcelRequire("2w1Rh");

var $YUaO6 = parcelRequire("YUaO6");

var $5rbnd = parcelRequire("5rbnd");

var $dvkXw = parcelRequire("dvkXw");

var $68SJI = parcelRequire("68SJI");

var $bniHL = parcelRequire("bniHL");

var $bNJ8P = parcelRequire("bNJ8P");

var $1x6Ci = parcelRequire("1x6Ci");

var $fsZBt = parcelRequire("fsZBt");

var $wve4y = parcelRequire("wve4y");

var $k4OXE = parcelRequire("k4OXE");

var $bRZM1 = parcelRequire("bRZM1");

var $6q2m8 = parcelRequire("6q2m8");

var $kmFWr = parcelRequire("kmFWr");

var $cG84U = parcelRequire("cG84U");

var $buRKN = parcelRequire("buRKN");

var $cSSYh = parcelRequire("cSSYh");

var $3Ztwo = parcelRequire("3Ztwo");

var $16SWn = parcelRequire("16SWn");

var $5D1TR = parcelRequire("5D1TR");

var $9CdwW = parcelRequire("9CdwW");

var $aoTCe = parcelRequire("aoTCe");

var $39Kwr = parcelRequire("39Kwr");

var $btldR = parcelRequire("btldR");

var $aWjer = parcelRequire("aWjer");

var $a1063 = parcelRequire("a1063");

var $2jzBU = parcelRequire("2jzBU");

var $kRjfO = parcelRequire("kRjfO");

var $3KoGt = parcelRequire("3KoGt");

var $fgj8P = parcelRequire("fgj8P");

var $eL04l = parcelRequire("eL04l");

var $4j3T6 = parcelRequire("4j3T6");

var $1GKsk = parcelRequire("1GKsk");

var $kBwpZ = parcelRequire("kBwpZ");

var $gLrcS = parcelRequire("gLrcS");

var $1PgFA = parcelRequire("1PgFA");

var $KNCM2 = parcelRequire("KNCM2");

var $kFWwG = parcelRequire("kFWwG");

var $dziRv = parcelRequire("dziRv");

var $pku4a = parcelRequire("pku4a");

var $83ZB1 = parcelRequire("83ZB1");

var $eWL94 = parcelRequire("eWL94");

var $3xzmz = parcelRequire("3xzmz");

var $jibsX = parcelRequire("jibsX");

var $dXJxf = parcelRequire("dXJxf");

var $cSZ5I = parcelRequire("cSZ5I");

var $lMynu = parcelRequire("lMynu");

var $brgv2 = parcelRequire("brgv2");

var $jj2PM = parcelRequire("jj2PM");

var $2Wt9r = parcelRequire("2Wt9r");

var $7keBB = parcelRequire("7keBB");

var $cM2BL = parcelRequire("cM2BL");

var $cdWPR = parcelRequire("cdWPR");

var $crzYn = parcelRequire("crzYn");

var $bxRll = parcelRequire("bxRll");

var $hQgn2 = parcelRequire("hQgn2");

var $gwsNu = parcelRequire("gwsNu");

var $k8tyG = parcelRequire("k8tyG");

var $l6dib = parcelRequire("l6dib");

var $a3joQ = parcelRequire("a3joQ");

var $5u9fY = parcelRequire("5u9fY");

var $ab4lJ = parcelRequire("ab4lJ");

var $1NRNm = parcelRequire("1NRNm");

var $lQ7tY = parcelRequire("lQ7tY");

var $5emKl = parcelRequire("5emKl");

var $ifSTk = parcelRequire("ifSTk");

var $aKMQu = parcelRequire("aKMQu");

var $jgejL = parcelRequire("jgejL");

var $79ery = parcelRequire("79ery");

var $jUFla = parcelRequire("jUFla");

var $4lnWj = parcelRequire("4lnWj");

var $aA8Qp = parcelRequire("aA8Qp");

var $688r3 = parcelRequire("688r3");

var $gTzw7 = parcelRequire("gTzw7");

var $dmw3V = parcelRequire("dmw3V");

var $2c3u4 = parcelRequire("2c3u4");

var $8HO8k = parcelRequire("8HO8k");

var $4LS6x = parcelRequire("4LS6x");

var $6f0SR = parcelRequire("6f0SR");

var $a0VaR = parcelRequire("a0VaR");

var $3Jt47 = parcelRequire("3Jt47");

var $5DHHM = parcelRequire("5DHHM");

var $gz3Jr = parcelRequire("gz3Jr");

var $h1XLQ = parcelRequire("h1XLQ");

var $aTPXf = parcelRequire("aTPXf");

var $guX97 = parcelRequire("guX97");

var $b8HiZ = parcelRequire("b8HiZ");

var $jDN2N = parcelRequire("jDN2N");

var $4i8Bg = parcelRequire("4i8Bg");

var $QxmOO = parcelRequire("QxmOO");

var $7vocS = parcelRequire("7vocS");

var $w3B2S = parcelRequire("w3B2S");

var $gGzRt = parcelRequire("gGzRt");

var $8gvzB = parcelRequire("8gvzB");

var $SMppT = parcelRequire("SMppT");

var $2aOwz = parcelRequire("2aOwz");

var $12H5K = parcelRequire("12H5K");

var $1cwKO = parcelRequire("1cwKO");

var $iJu6a = parcelRequire("iJu6a");

var $dk3YI = parcelRequire("dk3YI");

var $8iu1V = parcelRequire("8iu1V");

var $4MOhO = parcelRequire("4MOhO");

var $7tIhN = parcelRequire("7tIhN");

var $6pGEl = parcelRequire("6pGEl");

var $j2DKy = parcelRequire("j2DKy");

var $d4P6G = parcelRequire("d4P6G");

var $6oYAR = parcelRequire("6oYAR");

var $jPMVK = parcelRequire("jPMVK");

var $aTuB1 = parcelRequire("aTuB1");

var $e0CcM = parcelRequire("e0CcM");

var $2PsF8 = parcelRequire("2PsF8");

var $8tbjz = parcelRequire("8tbjz");

var $hxjuK = parcelRequire("hxjuK");

var $hb5Di = parcelRequire("hb5Di");

var $lckKv = parcelRequire("lckKv");

var $iWna3 = parcelRequire("iWna3");

var $fiE2A = parcelRequire("fiE2A");

var $30LIk = parcelRequire("30LIk");

var $kMzF2 = parcelRequire("kMzF2");

var $fC6iK = parcelRequire("fC6iK");

var $bBBHp = parcelRequire("bBBHp");

var $ij1Fw = parcelRequire("ij1Fw");

var $bKKAQ = parcelRequire("bKKAQ");

var $f6Vk1 = parcelRequire("f6Vk1");

var $55PRG = parcelRequire("55PRG");

var $lRKvL = parcelRequire("lRKvL");

var $9c7Zr = parcelRequire("9c7Zr");

var $8UsF1 = parcelRequire("8UsF1");

var $78wxz = parcelRequire("78wxz");

var $96PlG = parcelRequire("96PlG");

var $1c57g = parcelRequire("1c57g");

var $9mR49 = parcelRequire("9mR49");

var $9iHy6 = parcelRequire("9iHy6");

var $7GjaV = parcelRequire("7GjaV");

var $8n8J3 = parcelRequire("8n8J3");

var $8PTMd = parcelRequire("8PTMd");

var $bvG9T = parcelRequire("bvG9T");

var $41uEo = parcelRequire("41uEo");

var $i2jlE = parcelRequire("i2jlE");

var $dhQbH = parcelRequire("dhQbH");

var $eCwCc = parcelRequire("eCwCc");

var $5dp4c = parcelRequire("5dp4c");

var $gktT6 = parcelRequire("gktT6");

var $4mfko = parcelRequire("4mfko");

var $5V8G0 = parcelRequire("5V8G0");

var $evNXA = parcelRequire("evNXA");

var $3LvzD = parcelRequire("3LvzD");

var $iMFJ7 = parcelRequire("iMFJ7");

var $4oHg5 = parcelRequire("4oHg5");

var $bSKEi = parcelRequire("bSKEi");

var $9JGG7 = parcelRequire("9JGG7");

var $g5HV1 = parcelRequire("g5HV1");

var $826jW = parcelRequire("826jW");

var $l12sZ = parcelRequire("l12sZ");

var $9UgmD = parcelRequire("9UgmD");

var $f2VIv = parcelRequire("f2VIv");

var $dffuU = parcelRequire("dffuU");

var $bFPdt = parcelRequire("bFPdt");

var $4YSoS = parcelRequire("4YSoS");

var $aWIip = parcelRequire("aWIip");

var $hKCTj = parcelRequire("hKCTj");

var $aRm2v = parcelRequire("aRm2v");

var $1b1YZ = parcelRequire("1b1YZ");

var $9cuzK = parcelRequire("9cuzK");

var $aFAVR = parcelRequire("aFAVR");

var $fGbQV = parcelRequire("fGbQV");

var $aU53X = parcelRequire("aU53X");

var $kUZsQ = parcelRequire("kUZsQ");

var $3qumM = parcelRequire("3qumM");

var $kg5mN = parcelRequire("kg5mN");

var $fJMZw = parcelRequire("fJMZw");

var $jrxOi = parcelRequire("jrxOi");

var $2EVNH = parcelRequire("2EVNH");

var $aTXvN = parcelRequire("aTXvN");

var $40ace = parcelRequire("40ace");

var $gfX3l = parcelRequire("gfX3l");

var $kIo44 = parcelRequire("kIo44");

var $cKe5X = parcelRequire("cKe5X");

var $kHUTZ = parcelRequire("kHUTZ");

var $gto75 = parcelRequire("gto75");

var $gNIod = parcelRequire("gNIod");

var $3mGlV = parcelRequire("3mGlV");

var $dq2gm = parcelRequire("dq2gm");

var $ddYOf = parcelRequire("ddYOf");

var $jnMI8 = parcelRequire("jnMI8");

var $2zb3W = parcelRequire("2zb3W");

var $89Iq9 = parcelRequire("89Iq9");

var $7evUq = parcelRequire("7evUq");

var $kbO9I = parcelRequire("kbO9I");

var $gK6O1 = parcelRequire("gK6O1");

var $jWDyl = parcelRequire("jWDyl");

var $eqDg1 = parcelRequire("eqDg1");

var $lPQ46 = parcelRequire("lPQ46");

var $2SfFY = parcelRequire("2SfFY");

var $aX9VO = parcelRequire("aX9VO");

var $xk9sQ = parcelRequire("xk9sQ");

var $6HheX = parcelRequire("6HheX");

var $8pn2a = parcelRequire("8pn2a");

var $gXhoO = parcelRequire("gXhoO");

var $5W12D = parcelRequire("5W12D");

var $aqF41 = parcelRequire("aqF41");

var $5a3jD = parcelRequire("5a3jD");

var $cEFVO = parcelRequire("cEFVO");

var $hDEG5 = parcelRequire("hDEG5");

var $fqlx7 = parcelRequire("fqlx7");

var $fv7w7 = parcelRequire("fv7w7");

var $9RnXx = parcelRequire("9RnXx");

var $52P3m = parcelRequire("52P3m");

var $jRZCg = parcelRequire("jRZCg");

var $bQFOG = parcelRequire("bQFOG");

var $6UOpF = parcelRequire("6UOpF");

var $hg33k = parcelRequire("hg33k");

var $9GdJK = parcelRequire("9GdJK");

var $kvDhE = parcelRequire("kvDhE");

var $5mEi1 = parcelRequire("5mEi1");

var $8CdFi = parcelRequire("8CdFi");

var $bh6kd = parcelRequire("bh6kd");

var $dVCfH = parcelRequire("dVCfH");

var $9anS6 = parcelRequire("9anS6");

var $kzmyu = parcelRequire("kzmyu");

var $754l3 = parcelRequire("754l3");
$parcel$exportWildcard(module.exports, $8pnHz);
$parcel$exportWildcard(module.exports, $60N5k);
$parcel$exportWildcard(module.exports, $7HU5f);
$parcel$exportWildcard(module.exports, $k4bQc);
$parcel$exportWildcard(module.exports, $kWFE3);
$parcel$exportWildcard(module.exports, $2PO9F);
$parcel$exportWildcard(module.exports, $4ei3X);
$parcel$exportWildcard(module.exports, $aR9lQ);
$parcel$exportWildcard(module.exports, $hTQjv);
$parcel$exportWildcard(module.exports, $5Jwoo);
$parcel$exportWildcard(module.exports, $cbGeH);
$parcel$exportWildcard(module.exports, $jdbZY);
$parcel$exportWildcard(module.exports, $l82Az);
$parcel$exportWildcard(module.exports, $19uAL);
$parcel$exportWildcard(module.exports, $i41vD);
$parcel$exportWildcard(module.exports, $3JSwc);
$parcel$exportWildcard(module.exports, $agmHi);
$parcel$exportWildcard(module.exports, $iJo40);
$parcel$exportWildcard(module.exports, $8G5VK);
$parcel$exportWildcard(module.exports, $dngBU);
$parcel$exportWildcard(module.exports, $ee5Fb);
$parcel$exportWildcard(module.exports, $8MiLp);
$parcel$exportWildcard(module.exports, $lXaM8);
$parcel$exportWildcard(module.exports, $ZviK2);
$parcel$exportWildcard(module.exports, $crhkn);
$parcel$exportWildcard(module.exports, $4VxOT);
$parcel$exportWildcard(module.exports, $8VqFn);
$parcel$exportWildcard(module.exports, $grZn4);
$parcel$exportWildcard(module.exports, $3erwy);
$parcel$exportWildcard(module.exports, $i3LgR);
$parcel$exportWildcard(module.exports, $6P0et);
$parcel$exportWildcard(module.exports, $422PO);
$parcel$exportWildcard(module.exports, $6kXqC);
$parcel$exportWildcard(module.exports, $kvJNN);
$parcel$exportWildcard(module.exports, $5Kt5i);
$parcel$exportWildcard(module.exports, $angsT);
$parcel$exportWildcard(module.exports, $4bDXo);
$parcel$exportWildcard(module.exports, $90sUK);
$parcel$exportWildcard(module.exports, $heR8J);
$parcel$exportWildcard(module.exports, $7udiq);
$parcel$exportWildcard(module.exports, $eoJr3);
$parcel$exportWildcard(module.exports, $1oTHf);
$parcel$exportWildcard(module.exports, $aFEwk);
$parcel$exportWildcard(module.exports, $9Ht0m);
$parcel$exportWildcard(module.exports, $5ytgv);
$parcel$exportWildcard(module.exports, $8UxUv);
$parcel$exportWildcard(module.exports, $8wp52);
$parcel$exportWildcard(module.exports, $fa8nh);
$parcel$exportWildcard(module.exports, $5uQ8N);
$parcel$exportWildcard(module.exports, $4hXc3);
$parcel$exportWildcard(module.exports, $eHVf7);
$parcel$exportWildcard(module.exports, $hBOPV);
$parcel$exportWildcard(module.exports, $gSI3w);
$parcel$exportWildcard(module.exports, $f8wM8);
$parcel$exportWildcard(module.exports, $ajIJv);
$parcel$exportWildcard(module.exports, $iToPu);
$parcel$exportWildcard(module.exports, $duAq3);
$parcel$exportWildcard(module.exports, $hPOOF);
$parcel$exportWildcard(module.exports, $jexpo);
$parcel$exportWildcard(module.exports, $XQdJz);
$parcel$exportWildcard(module.exports, $lUIcz);
$parcel$exportWildcard(module.exports, $65E03);
$parcel$exportWildcard(module.exports, $fyymM);
$parcel$exportWildcard(module.exports, $huryk);
$parcel$exportWildcard(module.exports, $ivtZq);
$parcel$exportWildcard(module.exports, $9BuYc);
$parcel$exportWildcard(module.exports, $6g7r0);
$parcel$exportWildcard(module.exports, $8RJFW);
$parcel$exportWildcard(module.exports, $gFO4G);
$parcel$exportWildcard(module.exports, $4vbFx);
$parcel$exportWildcard(module.exports, $4ot0c);
$parcel$exportWildcard(module.exports, $4jWBv);
$parcel$exportWildcard(module.exports, $2Y3ZC);
$parcel$exportWildcard(module.exports, $2NZLH);
$parcel$exportWildcard(module.exports, $9Oc4t);
$parcel$exportWildcard(module.exports, $57Nb9);
$parcel$exportWildcard(module.exports, $334b0);
$parcel$exportWildcard(module.exports, $946QX);
$parcel$exportWildcard(module.exports, $17dNB);
$parcel$exportWildcard(module.exports, $g3ftr);
$parcel$exportWildcard(module.exports, $6T65T);
$parcel$exportWildcard(module.exports, $3ywb8);
$parcel$exportWildcard(module.exports, $6dIo9);
$parcel$exportWildcard(module.exports, $1bajT);
$parcel$exportWildcard(module.exports, $lEzlR);
$parcel$exportWildcard(module.exports, $8MK2B);
$parcel$exportWildcard(module.exports, $25iav);
$parcel$exportWildcard(module.exports, $9LcDL);
$parcel$exportWildcard(module.exports, $PepXP);
$parcel$exportWildcard(module.exports, $dI7M1);
$parcel$exportWildcard(module.exports, $9dwcZ);
$parcel$exportWildcard(module.exports, $3Unag);
$parcel$exportWildcard(module.exports, $i7Cwa);
$parcel$exportWildcard(module.exports, $anekH);
$parcel$exportWildcard(module.exports, $iSjpO);
$parcel$exportWildcard(module.exports, $jz85T);
$parcel$exportWildcard(module.exports, $bgri5);
$parcel$exportWildcard(module.exports, $cVgHD);
$parcel$exportWildcard(module.exports, $6l5up);
$parcel$exportWildcard(module.exports, $l2dag);
$parcel$exportWildcard(module.exports, $QWd3l);
$parcel$exportWildcard(module.exports, $9Y2Gx);
$parcel$exportWildcard(module.exports, $lacrQ);
$parcel$exportWildcard(module.exports, $dKynU);
$parcel$exportWildcard(module.exports, $6FHpI);
$parcel$exportWildcard(module.exports, $2i7tj);
$parcel$exportWildcard(module.exports, $9lJSC);
$parcel$exportWildcard(module.exports, $1zLpu);
$parcel$exportWildcard(module.exports, $5b7A3);
$parcel$exportWildcard(module.exports, $QpQpJ);
$parcel$exportWildcard(module.exports, $53EEE);
$parcel$exportWildcard(module.exports, $boLZC);
$parcel$exportWildcard(module.exports, $722a7);
$parcel$exportWildcard(module.exports, $9cXQa);
$parcel$exportWildcard(module.exports, $3QmN9);
$parcel$exportWildcard(module.exports, $42HIn);
$parcel$exportWildcard(module.exports, $2w1Rh);
$parcel$exportWildcard(module.exports, $YUaO6);
$parcel$exportWildcard(module.exports, $5rbnd);
$parcel$exportWildcard(module.exports, $dvkXw);
$parcel$exportWildcard(module.exports, $68SJI);
$parcel$exportWildcard(module.exports, $bniHL);
$parcel$exportWildcard(module.exports, $bNJ8P);
$parcel$exportWildcard(module.exports, $1x6Ci);
$parcel$exportWildcard(module.exports, $fsZBt);
$parcel$exportWildcard(module.exports, $wve4y);
$parcel$exportWildcard(module.exports, $k4OXE);
$parcel$exportWildcard(module.exports, $bRZM1);
$parcel$exportWildcard(module.exports, $6q2m8);
$parcel$exportWildcard(module.exports, $kmFWr);
$parcel$exportWildcard(module.exports, $cG84U);
$parcel$exportWildcard(module.exports, $buRKN);
$parcel$exportWildcard(module.exports, $cSSYh);
$parcel$exportWildcard(module.exports, $3Ztwo);
$parcel$exportWildcard(module.exports, $16SWn);
$parcel$exportWildcard(module.exports, $5D1TR);
$parcel$exportWildcard(module.exports, $9CdwW);
$parcel$exportWildcard(module.exports, $aoTCe);
$parcel$exportWildcard(module.exports, $39Kwr);
$parcel$exportWildcard(module.exports, $btldR);
$parcel$exportWildcard(module.exports, $aWjer);
$parcel$exportWildcard(module.exports, $a1063);
$parcel$exportWildcard(module.exports, $2jzBU);
$parcel$exportWildcard(module.exports, $kRjfO);
$parcel$exportWildcard(module.exports, $3KoGt);
$parcel$exportWildcard(module.exports, $fgj8P);
$parcel$exportWildcard(module.exports, $eL04l);
$parcel$exportWildcard(module.exports, $4j3T6);
$parcel$exportWildcard(module.exports, $1GKsk);
$parcel$exportWildcard(module.exports, $kBwpZ);
$parcel$exportWildcard(module.exports, $gLrcS);
$parcel$exportWildcard(module.exports, $1PgFA);
$parcel$exportWildcard(module.exports, $KNCM2);
$parcel$exportWildcard(module.exports, $kFWwG);
$parcel$exportWildcard(module.exports, $dziRv);
$parcel$exportWildcard(module.exports, $pku4a);
$parcel$exportWildcard(module.exports, $83ZB1);
$parcel$exportWildcard(module.exports, $eWL94);
$parcel$exportWildcard(module.exports, $3xzmz);
$parcel$exportWildcard(module.exports, $jibsX);
$parcel$exportWildcard(module.exports, $dXJxf);
$parcel$exportWildcard(module.exports, $cSZ5I);
$parcel$exportWildcard(module.exports, $lMynu);
$parcel$exportWildcard(module.exports, $brgv2);
$parcel$exportWildcard(module.exports, $jj2PM);
$parcel$exportWildcard(module.exports, $2Wt9r);
$parcel$exportWildcard(module.exports, $7keBB);
$parcel$exportWildcard(module.exports, $cM2BL);
$parcel$exportWildcard(module.exports, $cdWPR);
$parcel$exportWildcard(module.exports, $crzYn);
$parcel$exportWildcard(module.exports, $bxRll);
$parcel$exportWildcard(module.exports, $hQgn2);
$parcel$exportWildcard(module.exports, $gwsNu);
$parcel$exportWildcard(module.exports, $k8tyG);
$parcel$exportWildcard(module.exports, $l6dib);
$parcel$exportWildcard(module.exports, $a3joQ);
$parcel$exportWildcard(module.exports, $5u9fY);
$parcel$exportWildcard(module.exports, $ab4lJ);
$parcel$exportWildcard(module.exports, $1NRNm);
$parcel$exportWildcard(module.exports, $lQ7tY);
$parcel$exportWildcard(module.exports, $5emKl);
$parcel$exportWildcard(module.exports, $ifSTk);
$parcel$exportWildcard(module.exports, $aKMQu);
$parcel$exportWildcard(module.exports, $jgejL);
$parcel$exportWildcard(module.exports, $79ery);
$parcel$exportWildcard(module.exports, $jUFla);
$parcel$exportWildcard(module.exports, $4lnWj);
$parcel$exportWildcard(module.exports, $aA8Qp);
$parcel$exportWildcard(module.exports, $688r3);
$parcel$exportWildcard(module.exports, $gTzw7);
$parcel$exportWildcard(module.exports, $dmw3V);
$parcel$exportWildcard(module.exports, $2c3u4);
$parcel$exportWildcard(module.exports, $8HO8k);
$parcel$exportWildcard(module.exports, $4LS6x);
$parcel$exportWildcard(module.exports, $6f0SR);
$parcel$exportWildcard(module.exports, $a0VaR);
$parcel$exportWildcard(module.exports, $3Jt47);
$parcel$exportWildcard(module.exports, $5DHHM);
$parcel$exportWildcard(module.exports, $gz3Jr);
$parcel$exportWildcard(module.exports, $h1XLQ);
$parcel$exportWildcard(module.exports, $aTPXf);
$parcel$exportWildcard(module.exports, $guX97);
$parcel$exportWildcard(module.exports, $b8HiZ);
$parcel$exportWildcard(module.exports, $jDN2N);
$parcel$exportWildcard(module.exports, $4i8Bg);
$parcel$exportWildcard(module.exports, $QxmOO);
$parcel$exportWildcard(module.exports, $7vocS);
$parcel$exportWildcard(module.exports, $w3B2S);
$parcel$exportWildcard(module.exports, $gGzRt);
$parcel$exportWildcard(module.exports, $8gvzB);
$parcel$exportWildcard(module.exports, $SMppT);
$parcel$exportWildcard(module.exports, $2aOwz);
$parcel$exportWildcard(module.exports, $12H5K);
$parcel$exportWildcard(module.exports, $1cwKO);
$parcel$exportWildcard(module.exports, $iJu6a);
$parcel$exportWildcard(module.exports, $dk3YI);
$parcel$exportWildcard(module.exports, $8iu1V);
$parcel$exportWildcard(module.exports, $4MOhO);
$parcel$exportWildcard(module.exports, $7tIhN);
$parcel$exportWildcard(module.exports, $6pGEl);
$parcel$exportWildcard(module.exports, $j2DKy);
$parcel$exportWildcard(module.exports, $d4P6G);
$parcel$exportWildcard(module.exports, $6oYAR);
$parcel$exportWildcard(module.exports, $jPMVK);
$parcel$exportWildcard(module.exports, $aTuB1);
$parcel$exportWildcard(module.exports, $e0CcM);
$parcel$exportWildcard(module.exports, $2PsF8);
$parcel$exportWildcard(module.exports, $8tbjz);
$parcel$exportWildcard(module.exports, $hxjuK);
$parcel$exportWildcard(module.exports, $hb5Di);
$parcel$exportWildcard(module.exports, $lckKv);
$parcel$exportWildcard(module.exports, $iWna3);
$parcel$exportWildcard(module.exports, $fiE2A);
$parcel$exportWildcard(module.exports, $30LIk);
$parcel$exportWildcard(module.exports, $kMzF2);
$parcel$exportWildcard(module.exports, $fC6iK);
$parcel$exportWildcard(module.exports, $bBBHp);
$parcel$exportWildcard(module.exports, $ij1Fw);
$parcel$exportWildcard(module.exports, $bKKAQ);
$parcel$exportWildcard(module.exports, $f6Vk1);
$parcel$exportWildcard(module.exports, $55PRG);
$parcel$exportWildcard(module.exports, $lRKvL);
$parcel$exportWildcard(module.exports, $9c7Zr);
$parcel$exportWildcard(module.exports, $8UsF1);
$parcel$exportWildcard(module.exports, $78wxz);
$parcel$exportWildcard(module.exports, $96PlG);
$parcel$exportWildcard(module.exports, $1c57g);
$parcel$exportWildcard(module.exports, $9mR49);
$parcel$exportWildcard(module.exports, $9iHy6);
$parcel$exportWildcard(module.exports, $7GjaV);
$parcel$exportWildcard(module.exports, $8n8J3);
$parcel$exportWildcard(module.exports, $8PTMd);
$parcel$exportWildcard(module.exports, $bvG9T);
$parcel$exportWildcard(module.exports, $41uEo);
$parcel$exportWildcard(module.exports, $i2jlE);
$parcel$exportWildcard(module.exports, $dhQbH);
$parcel$exportWildcard(module.exports, $eCwCc);
$parcel$exportWildcard(module.exports, $5dp4c);
$parcel$exportWildcard(module.exports, $gktT6);
$parcel$exportWildcard(module.exports, $4mfko);
$parcel$exportWildcard(module.exports, $5V8G0);
$parcel$exportWildcard(module.exports, $evNXA);
$parcel$exportWildcard(module.exports, $3LvzD);
$parcel$exportWildcard(module.exports, $iMFJ7);
$parcel$exportWildcard(module.exports, $4oHg5);
$parcel$exportWildcard(module.exports, $bSKEi);
$parcel$exportWildcard(module.exports, $9JGG7);
$parcel$exportWildcard(module.exports, $g5HV1);
$parcel$exportWildcard(module.exports, $826jW);
$parcel$exportWildcard(module.exports, $l12sZ);
$parcel$exportWildcard(module.exports, $9UgmD);
$parcel$exportWildcard(module.exports, $f2VIv);
$parcel$exportWildcard(module.exports, $dffuU);
$parcel$exportWildcard(module.exports, $bFPdt);
$parcel$exportWildcard(module.exports, $4YSoS);
$parcel$exportWildcard(module.exports, $aWIip);
$parcel$exportWildcard(module.exports, $hKCTj);
$parcel$exportWildcard(module.exports, $aRm2v);
$parcel$exportWildcard(module.exports, $1b1YZ);
$parcel$exportWildcard(module.exports, $9cuzK);
$parcel$exportWildcard(module.exports, $aFAVR);
$parcel$exportWildcard(module.exports, $fGbQV);
$parcel$exportWildcard(module.exports, $aU53X);
$parcel$exportWildcard(module.exports, $kUZsQ);
$parcel$exportWildcard(module.exports, $3qumM);
$parcel$exportWildcard(module.exports, $kg5mN);
$parcel$exportWildcard(module.exports, $fJMZw);
$parcel$exportWildcard(module.exports, $jrxOi);
$parcel$exportWildcard(module.exports, $2EVNH);
$parcel$exportWildcard(module.exports, $aTXvN);
$parcel$exportWildcard(module.exports, $40ace);
$parcel$exportWildcard(module.exports, $gfX3l);
$parcel$exportWildcard(module.exports, $kIo44);
$parcel$exportWildcard(module.exports, $cKe5X);
$parcel$exportWildcard(module.exports, $kHUTZ);
$parcel$exportWildcard(module.exports, $gto75);
$parcel$exportWildcard(module.exports, $gNIod);
$parcel$exportWildcard(module.exports, $3mGlV);
$parcel$exportWildcard(module.exports, $dq2gm);
$parcel$exportWildcard(module.exports, $ddYOf);
$parcel$exportWildcard(module.exports, $jnMI8);
$parcel$exportWildcard(module.exports, $2zb3W);
$parcel$exportWildcard(module.exports, $89Iq9);
$parcel$exportWildcard(module.exports, $7evUq);
$parcel$exportWildcard(module.exports, $kbO9I);
$parcel$exportWildcard(module.exports, $gK6O1);
$parcel$exportWildcard(module.exports, $jWDyl);
$parcel$exportWildcard(module.exports, $eqDg1);
$parcel$exportWildcard(module.exports, $lPQ46);
$parcel$exportWildcard(module.exports, $2SfFY);
$parcel$exportWildcard(module.exports, $aX9VO);
$parcel$exportWildcard(module.exports, $xk9sQ);
$parcel$exportWildcard(module.exports, $6HheX);
$parcel$exportWildcard(module.exports, $8pn2a);
$parcel$exportWildcard(module.exports, $gXhoO);
$parcel$exportWildcard(module.exports, $5W12D);
$parcel$exportWildcard(module.exports, $aqF41);
$parcel$exportWildcard(module.exports, $5a3jD);
$parcel$exportWildcard(module.exports, $cEFVO);
$parcel$exportWildcard(module.exports, $hDEG5);
$parcel$exportWildcard(module.exports, $fqlx7);
$parcel$exportWildcard(module.exports, $fv7w7);
$parcel$exportWildcard(module.exports, $9RnXx);
$parcel$exportWildcard(module.exports, $52P3m);
$parcel$exportWildcard(module.exports, $jRZCg);
$parcel$exportWildcard(module.exports, $bQFOG);
$parcel$exportWildcard(module.exports, $6UOpF);
$parcel$exportWildcard(module.exports, $hg33k);
$parcel$exportWildcard(module.exports, $9GdJK);
$parcel$exportWildcard(module.exports, $kvDhE);
$parcel$exportWildcard(module.exports, $5mEi1);
$parcel$exportWildcard(module.exports, $8CdFi);
$parcel$exportWildcard(module.exports, $bh6kd);
$parcel$exportWildcard(module.exports, $dVCfH);
$parcel$exportWildcard(module.exports, $9anS6);
$parcel$exportWildcard(module.exports, $kzmyu);
$parcel$exportWildcard(module.exports, $754l3);

});
parcelRegister("8pnHz", function(module, exports) {

$parcel$export(module.exports, "ActivityChart", () => $61f30b351ef59a76$export$ab993c84f50b229f);
$parcel$export(module.exports, "ActivityChartCell", () => $61f30b351ef59a76$export$61fc6bdb6b750b08);
// ActivityChart — GitHub-style 52-week heatmap. Generic and reusable.
//
// Configuration via parent props (read on the element itself in v3.14):
//   data           — { 'YYYY-MM-DD': { score: number, breakdown?: object } }
//   title          — header label (default: 'ACTIVITY · LAST YEAR')
//   accent         — base color token for filled cells (default: 'green')
//   onCellClick    — (date, entry, root) handler when a non-empty cell is clicked
//   showLegend     — boolean (default: true)
//
// Reads `data` from `s.root._chartActivityData` by default if no `data` prop;
// callers control the same root key when fetching activity. Use the
// `chartId` prop to namespace multiple charts on the same page.
//
// Tickets/MyView and the new /u/:slug profile page both mount this; the
// caller is responsible for fetching data and writing it to the matching
// root key (e.g. `_activityData` for tickets, `_profileActivity` for profile).
const $61f30b351ef59a76$var$WEEKS = 52;
const $61f30b351ef59a76$var$DAYS = 7;
const $61f30b351ef59a76$export$ab993c84f50b229f = {
    scope: {
        // Total cell count — plain computed value (not a function body), so this
        // bakes to a literal number at serialization time; still safer to keep
        // off the raw WEEKS/DAYS module consts, which are ONLY safe today because
        // they're read at object-literal build time, never inside a factory.
        total: $61f30b351ef59a76$var$WEEKS * $61f30b351ef59a76$var$DAYS,
        // Resolve the data source. Data lives on either:
        //   - `el.parent.data` (a static object passed as a prop)
        //   - `s.root[el.parent.dataKey]` (a key into root state, default `_chartActivityData`)
        readData: (el, s)=>{
            const owner = el.parent;
            if (owner?.data && typeof owner.data === 'object') return owner.data;
            const key = owner?.dataKey || '_chartActivityData';
            return s.root?.[key] || {};
        },
        shade: (accent, n)=>`${accent}.${n}`
    },
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        fontSize: 'Y2',
        // `heading` FIRST, `title` only as the back-compat fallback: `title` is a
        // global HTML attribute, so neither rewrite form works on it when a child
        // reads it as CONTENT (docs/I18N-CONVENTION.md §1.2). Both paths resolve
        // through polyglot, so a call site may pass a bundle KEY or a plain
        // string — polyglot returns a non-key verbatim.
        Text: {
            text: (el)=>el.call('polyglot', el.parent.parent.heading || el.parent.parent.title || 'account.userProfile.activity.title')
        }
    },
    Grid: {
        display: 'grid',
        gridTemplateColumns: `repeat(${$61f30b351ef59a76$var$WEEKS}, 1fr)`,
        gridTemplateRows: `repeat(${$61f30b351ef59a76$var$DAYS}, 1fr)`,
        gridAutoFlow: 'column',
        gap: 'X',
        padding: 'Z 0',
        childExtends: 'ActivityChartCell',
        childrenAs: 'state',
        children: (el, s)=>{
            const data = el.scope.readData(el, s);
            const today = new Date();
            const cells = [];
            for(let i = el.scope.total - 1; i >= 0; i--){
                const d = new Date(today);
                d.setDate(d.getDate() - i);
                const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                const entry = data[key] || {};
                cells.push({
                    date: key,
                    score: entry.score || 0,
                    marker: entry.marker || entry.standups || 0,
                    breakdown: entry.breakdown || {}
                });
            }
            return cells;
        }
    },
    Legend: {
        tag: 'div',
        hide: (el)=>el.parent.showLegend === false,
        flow: 'x',
        gap: 'Z',
        align: 'center right',
        fontSize: 'Y1',
        color: 'caption',
        Less: {
            tag: 'span',
            text: '{{ account.userProfile.activity.less | polyglot }}'
        },
        Box_1: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            // Fill-contrast swatch (was a bordered/transparent square) — matches
            // the solid-fill siblings below it instead of standing out as the
            // only outlined legend key.
            background: 'overlay'
        },
        Box_2: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: (el)=>el.scope.shade(el.parent.parent.accent || 'green', 15)
        },
        Box_3: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: (el)=>el.scope.shade(el.parent.parent.accent || 'green', 3)
        },
        Box_4: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: (el)=>el.scope.shade(el.parent.parent.accent || 'green', 5)
        },
        Box_5: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: (el)=>el.scope.shade(el.parent.parent.accent || 'green', 7)
        },
        More: {
            tag: 'span',
            text: '{{ account.userProfile.activity.more | polyglot }}'
        }
    }
};
const $61f30b351ef59a76$export$61fc6bdb6b750b08 = {
    // FA204 / frank trap — `_intensity`'s logic lives here as a scoped
    // helper (duplicated rather than shared with ActivityChart's `shade`
    // above, since scope object properties can't reference sibling scope
    // properties as bare identifiers) — see the header comment above
    // ActivityChart for the full rationale.
    scope: {
        intensity: (score, accent = 'green', hasMarker)=>{
            const shade = (n)=>`${accent}.${n}`;
            // Empty cells read via a neutral FILL (matches every other intensity
            // step being a fill), not a border-only outline — the border-habit
            // sweep (tickets/opus.md) replaced the old `borderColor: 'line'` ring
            // with this.
            if (!score && !hasMarker) return 'overlay';
            if (hasMarker && !score) return shade(15);
            if (score <= 2) return shade(15);
            if (score <= 5) return shade(3);
            if (score <= 10) return shade(5);
            return shade(7);
        }
    },
    width: '100%',
    aspectRatio: '1',
    round: 'X',
    background: (el, s)=>{
        const accent = el.parent.parent.accent || 'green';
        return el.scope.intensity(s.score, accent, s.marker > 0);
    },
    cursor: (el, s)=>{
        if (!s.score && !s.marker) return 'default';
        return el.parent.parent.onCellClick ? 'pointer' : 'default';
    },
    transition: 'background 120ms ease',
    // Was a static `borderColor: 'line'` ring on empty cells (the border
    // habit) — the cell's own `background` (via `el.scope.intensity`) now
    // carries the empty/filled distinction as a fill step instead of a stroke.
    ':hover': {
        outline: 'hairline solid title'
    },
    title: (el, s)=>{
        if (!s.score && !s.marker) return s.date;
        const parts = [];
        if (s.marker) parts.push("\u2726");
        const bd = s.breakdown || {};
        for (const [k, n] of Object.entries(bd))parts.push(`${n} ${k}${n > 1 ? 's' : ''}`);
        return `${s.date} \xb7 ${s.score}pt${s.score === 1 ? '' : 's'}${parts.length ? " \u2014 " + parts.join(', ') : ''}`;
    },
    onClick: (e, el, s)=>{
        if (!s.score && !s.marker) return;
        const handler = el.parent.parent.onCellClick;
        if (typeof handler === 'function') handler(s.date, s, s.root);
    }
};

});

parcelRegister("60N5k", function(module, exports) {

$parcel$export(module.exports, "AppControl", () => $4608d1665e698f1a$export$dbf7b988e4a15500);
// Browser-neutral geometry for workspace controls. Visual roles (primary,
// tonal, ghost, segmented, navigation) remain with the component that extends
// this base. A control's padding is always INSIDE its declared footprint.
const $4608d1665e698f1a$export$dbf7b988e4a15500 = {
    tag: 'button',
    type: 'button',
    compact: false,
    dataControlSize: (el)=>el.compact ? 'compact' : 'regular',
    '&[data-control-size]': {
        boxSizing: 'border-box',
        appearance: 'none',
        fontFamily: 'inherit',
        lineHeight: '1.25',
        touchAction: 'manipulation',
        flexShrink: '0'
    },
    '&[data-control-size="regular"]': {
        minHeight: 'controlH',
        minWidth: 'controlH'
    },
    '&[data-control-size="compact"]': {
        minHeight: 'controlHCompact',
        minWidth: 'controlHCompact',
        '@coarse': {
            minHeight: 'controlH',
            minWidth: 'controlH'
        }
    },
    ':focus-visible': {
        shadow: 'focusRingInset'
    }
};

});

parcelRegister("7HU5f", function(module, exports) {

$parcel$export(module.exports, "NavbarRailControl", () => $59c80d9823c8a73c$export$e8620f3bacf67c9a);
// The same navbar action in its two presentations: an icon on a top bar or
// collapsed rail, a readable row on an expanded rail. The label comes from
// the action's existing localized title; its handlers and guards stay owned
// by the action itself.
const $59c80d9823c8a73c$export$e8620f3bacf67c9a = {
    extends: [
        'AppControl',
        'NavbarTooltipTrigger'
    ],
    compact: true,
    padding: '0',
    touchAction: 'manipulation',
    '@coarse': {
        minHeight: 'controlH',
        minWidth: 'controlH',
        ':after': {
            display: 'none'
        }
    },
    'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
    '&[data-nav-rail]': {
        height: 'controlHCompact',
        minHeight: 'controlHCompact',
        minWidth: 'controlHCompact',
        boxSizing: 'border-box',
        aspectRatio: 'auto',
        fontSize: 'inherit',
        flexShrink: '0',
        // Keep the media override with the compact selector so it is emitted
        // after that selector at the same specificity.
        '@coarse': {
            height: 'controlH',
            minHeight: 'controlH',
            minWidth: 'controlH'
        }
    },
    '&[data-nav-rail="narrow"]': {
        width: 'controlHCompact',
        padding: '0',
        '@coarse': {
            width: 'controlH'
        }
    },
    '&[data-nav-rail="wide"]': {
        width: '100%',
        maxWidth: '100%',
        aspectRatio: 'auto',
        justifyContent: 'flex-start',
        gap: 'Z',
        padding: 'Y Z',
        round: 'radiusControl',
        boxSizing: 'border-box',
        textAlign: 'left'
    },
    '&[data-nav-rail] > [data-key="Icon"]': {
        boxSize: 'iconSm',
        flexShrink: '0',
        order: '-1'
    },
    tooltipText: (el, s)=>{
        if ((el.call('navbarLayoutRead', s.root) || {}).expanded) return '';
        const title = el.title;
        return typeof title === 'function' ? title(el, s, el.context) : title;
    },
    NavLabel: {
        tag: 'span',
        hide: (el, s)=>!(el.call('navbarLayoutRead', s.root) || {}).expanded,
        text: (el, s)=>{
            const control = el.parent;
            const title = control.title;
            return typeof title === 'function' ? title(control, s, control.context) : title;
        },
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: '400'
    }
};

});

parcelRegister("k4bQc", function(module, exports) {

$parcel$export(module.exports, "AiContextChip", () => $e9bd5dbbc95a6a6f$export$1a07aed030e8f56a);
$parcel$export(module.exports, "AiContextBar", () => $e9bd5dbbc95a6a6f$export$fbefa53436d7b182);
// AiContextBar + AiContextChip — the ONE rendering of "what the AI can see"
// (O1, tickets/opus.md — design decided 2026-08-16, built by brand).
//
// The bar feeds ITSELF: it calls buildAiAwareness(root, composerState) — the
// derived set beside buildPageContext in workspace/functions/pageContext.js, so
// the chips can never claim more than the wire carries. Surfaces feed it
// nothing; a surface participates by writing its own state key, which the
// resolver's ladder already reads. Adding a surface = one branch in
// pageContext.js — never a new chip row.
//
// `composerState` = the state this bar inherits from its host composer (the
// draft bag: draft/files/refs/images). Two composers can be live at once, so
// the bag is never mirrored to root — the bar simply passes `s`.
//
// It REPLACES four near-copy renderings: canvas SelectionChips/CvSelectionChip,
// PromptGallery.AttachmentChips/PromptAttachmentChip, the sidebar
// PickedContextChip, and ChatMessage.PickedAttached. One grammar for all of
// them: borderless pills on the house washes (design-direction: fill contrast,
// no hairlines), the `sent` truth as a quiet caption suffix, one small remove
// button that dispatches the item's descriptor via el.call — never a handler
// of its own.
//
// Reactivity: canvas selection is a plain in-place mutation; `_cvSelectionTick`
// is the ONLY bridge — subscribed below (plus the other flat inputs). Reads of
// s.refs/s.files/s.images inside the factories track the composer bag.
// The tag is a polyglot KEY per delivery state, resolved at the render site —
// `structured` is the silent default and carries no tag at all.
const $e9bd5dbbc95a6a6f$var$SENT_TAG = {
    structured: '',
    'text-only': 'ai.contextBar.tag.textOnly',
    truncated: 'ai.contextBar.tag.truncated',
    dropped: 'ai.contextBar.tag.dropped'
};
const $e9bd5dbbc95a6a6f$export$1a07aed030e8f56a = {
    // A chip that carries a `refKey` is THE ALTERABLE REFERENCE (the open
    // record): a real button that toggles the record in and out of the prompt
    // (root._aiRefMutedFor — see pageContext.js). Everything else stays an
    // informational span.
    tag: (el, s)=>s.refKey ? 'button' : 'span',
    type: (el, s)=>s.refKey ? 'button' : undefined,
    cursor: (el, s)=>s.refKey ? 'pointer' : undefined,
    borderWidth: '0',
    flow: 'x',
    align: 'center start',
    gap: 'Y',
    // The glyph plate (spec §7.2) sits close to the pill's start; a chip with no glyph keeps the even inset.
    // Single-value props only — a reactive multi-part spacing value emits nothing on this runtime.
    paddingBlock: 'X',
    paddingRight: 'Z',
    paddingLeft: (el, s)=>s.icon ? 'X' : 'Z',
    round: 'radiusPill',
    maxWidth: 'F',
    // the status mark's containing block (SentMark below)
    position: 'relative',
    minWidth: '0',
    fontSize: 'Y2',
    // Implicit focus = the quiet `overlay` wash; an item the user HANDED over
    // (attached) = the `selected` wash. Same pill, one step of emphasis apart.
    // A toggleable reference answers hover with the `hover` wash so it reads
    // as pressable; the other chips never do.
    background: (el, s)=>s.tier === 'attached' ? 'selected' : 'overlay',
    ':hover': (el, s)=>s.refKey ? {
            background: 'hover'
        } : {},
    // THE ONE STATE LOGIC (dropdowns spec §5): only the chip that is a real button (the alterable reference)
    // answers the pointer — its plate INVERTS; keyboard focus inverts it too and draws the house ring.
    '&[type="button"]:hover [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed'
    },
    '&:focus-visible [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed'
    },
    ':focus-visible': {
        shadow: 'focusRing'
    },
    // Dropped items read as the quiet ink — the label stays legible, the state
    // is unmistakable, no strike-through noise. A muted reference IS a dropped
    // item, so the existing truth grammar covers the toggle for free.
    // D-2 (2026-09-24): this text can sit on a washed dark row, where `inactive`
    // reads 4.29:1 on `hover` and 3.33:1 on `selected` — both under 4.5 — so the
    // quiet ink here is `caption`. (A chip washes `hover` on hover and `selected` when attached.)
    color: (el, s)=>s.sent === 'dropped' ? 'caption' : 'title',
    // `s.title` is the item's own name (tenant content) and passes through
    // `translate()` unchanged; the sentence around it comes from a key with a
    // {name} hole, so a translation orders the two parts its own way.
    title: (el, s)=>{
        const name = el.call('polyglot', s.title || '');
        if (s.refKey) {
            const key = s.muted ? 'ai.contextBar.chip.mutedTitle' : 'ai.contextBar.chip.refTitle';
            return el.call('polyglot', key).replace('{name}', name);
        }
        const tag = $e9bd5dbbc95a6a6f$var$SENT_TAG[s.sent];
        return tag ? name + " \u2014 " + el.call('polyglot', tag) : name;
    },
    onClick: (e, el, s)=>{
        if (!s.refKey) return;
        e.preventDefault();
        e.stopPropagation();
        if (s.root && s.root.update) s.root.update({
            _aiRefMutedFor: s.muted ? null : s.refKey
        });
    },
    // The glyph on a borderless round plate (spec §4 chip: `glyphPlateXs`); the holder restyles it through
    // `data-glyph-plate` (the MenuPanelItem keycap pattern).
    Plate: {
        if: (el, s)=>!!s.icon,
        dataGlyphPlate: true,
        ariaHidden: 'true',
        display: 'flex',
        align: 'center center',
        flexShrink: '0',
        boxSize: 'glyphPlateXs',
        round: 'radiusPill',
        color: 'currentColor',
        transition: 'background-color A defaultBezier, color A defaultBezier',
        Icon: {
            name: (el, s)=>s.icon,
            boxSize: 'iconSm'
        }
    },
    // The visible name. Resolved through polyglot exactly like the `title:`
    // tooltip above, and for the same reason SentTag had to be: an item's title
    // can BE a bundle key — an attached ref with no name of its own carries its
    // KIND as `ai.sources.kind.<type>` (workspace/functions/pageContext.js) —
    // and an unresolved key paints itself onto the chip. Tenant content is
    // unaffected: `translate()` returns its input on a miss, which is what makes
    // one call correct for both.
    Label: {
        tag: 'span',
        text: (el, s)=>el.call('polyglot', s.title || ''),
        fontWeight: '500',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: '0'
    },
    // The fourth state made visible: text-only / partial / not sent. Structured
    // items carry no suffix — the absence is the "fully sent" signal.
    //
    // SENT_TAG holds polyglot KEYS, so the text has to go through polyglot the
    // same way `title:` above already does. Without that this span painted the
    // literal key — `ai.contextBar.tag.textOnly` — next to the chip's label,
    // caught on screen during the VaultOS v2 integration run (2026-09-07). The
    // `title:` attribute translated correctly the whole time, which is exactly
    // why nobody saw it: the tooltip read right and only the visible chip was
    // wrong.
    //
    // SentTag DEFECT (dropdowns spec §7.2, the ka frame): the visible word ("ნაწილობრივ") starved the label to
    // "Q3 …". The word leaves the visible row (approved 2026-10-01): SentMark shows the state in the chip's
    // corner, the word stays in the chip's `title` above AND in the accessibility tree — the sr-only idiom
    // (PageSrTitle: the 1px clip box, the one raw-px exception; never display/visibility/opacity, which drop it).
    SentMark: {
        if: (el, s)=>!!$e9bd5dbbc95a6a6f$var$SENT_TAG[s.sent],
        ariaHidden: 'true',
        position: 'absolute',
        top: '-X',
        right: '-X',
        boxSize: 'glyphDot',
        round: 'radiusPill',
        background: 'caption',
        pointerEvents: 'none'
    },
    SentTag: {
        tag: 'span',
        if: (el, s)=>!!$e9bd5dbbc95a6a6f$var$SENT_TAG[s.sent],
        text: (el, s)=>el.call('polyglot', $e9bd5dbbc95a6a6f$var$SENT_TAG[s.sent]),
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        padding: '0',
        border: '0',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap'
    },
    RemoveBtn: {
        tag: 'button',
        type: 'button',
        if: (el, s)=>!!(s.removeVia && s.removeVia.fn),
        'aria-label': (el, s)=>el.call('polyglot', 'ai.contextBar.chip.remove').replace('{name}', el.call('polyglot', s.title || '')),
        flexShrink: '0',
        padding: 'X',
        margin: '0 -X 0 0',
        round: '50%',
        background: 'transparent',
        borderWidth: '0',
        color: 'caption',
        cursor: 'pointer',
        lineHeight: '0',
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        Icon: {
            name: 'x',
            boxSize: 'iconSm'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const via = s.removeVia;
            if (!via || !via.fn) return;
            try {
                el.call(via.fn, via.arg);
            } catch (_) {
            /* unregistered on this surface — the chip stays, nothing throws */ }
        }
    }
};
const $e9bd5dbbc95a6a6f$export$fbefa53436d7b182 = {
    // Every flat root input the resolver reads. `_cvSelectionTick` is mandatory
    // (see header); the record keys make an opened ticket/doc/person appear
    // without a composer keystroke.
    subscribeTo: [
        '_cvSelectionTick',
        'pickedElements',
        'currentPath',
        '_canvasSlot',
        // The split's second pane can hold the note editor too (pageContext
        // editorOnScreen): its close must drop the note chip at once.
        '_canvasSlotSecond',
        'workspace',
        'org',
        'selectedTicket',
        'selectedEvent',
        'showEventDetail',
        'selectedDocument',
        'profileEmail',
        'selectedPerson',
        '_selectedAgent',
        '_selectedTeamMember',
        '_createAgentOpen',
        '_createMemberOpen',
        'selectedAnnouncement',
        // An open note lives on `editorDoc` (the editor's write key); the open
        // canvas project's name lives on `data` (loads after the route) — both
        // feed detectOpenRecord (AI-CONTEXT-AWARENESS-O1-1 live pass).
        'editorDoc',
        'data',
        '_promptFocused',
        // The alterable-reference toggle — the chip writes it, the whole bar
        // re-derives (sent truth, mute rendering) on the flip.
        '_aiRefMutedFor',
        // STRUCTURED attachments (spec §4.1) — `root.aiAttached` is written by
        // attachAiRef / detachAiRef / attachAiCanvas from a page, a drop handler
        // or a chip's own remove. Without this key the bar never re-derives and a
        // dropped ref renders no chip at all until some other input happens to
        // tick — the exact class of bug the `_cvSelectionTick` note above records.
        'aiAttached'
    ],
    scope: {
        awareness (el, s) {
            try {
                const out = el.call('buildAiAwareness', s.root, s);
                return out && typeof out === 'object' ? out : {
                    scope: null,
                    focus: [],
                    attached: []
                };
            } catch (_) {
                return {
                    scope: null,
                    focus: [],
                    attached: []
                };
            }
        },
        // The bar shows when there is something beyond the bare route to show, or
        // while the user is composing (then the scope line + route answer "what
        // will this prompt be about?" before a keystroke).
        //
        // Focus-gated mounts (`focusGated: true` — the global composer's
        // PromptBand; 2026-08-26 per Nika "hide path thing above chat prompt
        // area if textarea is not focused"): while the textarea is NOT focused
        // the bar carries ONLY user-attached items — the scope line and the
        // open-record context follow the composer's attention instead of
        // standing over the page. Ungated mounts (the assistant drawer's
        // composer) keep the original formula.
        visible (el, s) {
            const a = el.scope.awareness(el, s);
            // An attached-only mount (the composer's strip, DESIGN-COMPOSER-FOCUS-
            // POPOVER-CONTEXT-INSPECT-1) shows what the member HANDED the assistant
            // and nothing else — the context itself lives in the focus panel.
            if (el.attachedOnly) return !!a.attached.length;
            const focused = !!(s.root && s.root._promptFocused);
            if (el.focusGated && !focused) return !!a.attached.length;
            const beyondRoute = a.focus.some((i)=>i.kind !== 'route' && i.kind !== 'rows');
            // A surface where the resolver is not registered (standalone canvas app)
            // yields an empty set — never show an empty bar there.
            return !!(a.attached.length || beyondRoute || focused && a.scope);
        }
    },
    hide: (el, s)=>!el.scope.visible(el, s),
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    // SCOPE — one line, never a chip. Must render, or the bar reads as a fence.
    // On a focus-gated mount the line follows the textarea's focus: the bar can
    // stay visible for attached items while blurred, but the path line itself
    // never stands over the page unfocused.
    ScopeLine: {
        tag: 'p',
        if: (el, s)=>!el.parent?.attachedOnly && (!el.parent?.focusGated || !!s.root?._promptFocused),
        margin: '0',
        fontSize: 'X',
        color: 'caption',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '0',
        // The sentence is ONE key with a `{scope}` hole — the same grammar as the
        // chip titles above — so a translation orders "AI can reach" and the line
        // its own way. The line carries tenant content (a workspace name), so the
        // hole is filled by a FUNCTION: a bare string would have `$&` / `$1` in a
        // name read as replacement patterns.
        text: (el, s)=>{
            const a = el.scope.awareness(el, s);
            return a.scope && a.scope.line ? el.call('polyglot', 'ai.contextBar.scopeLine').replace('{scope}', ()=>a.scope.line) : '';
        }
    },
    // FOCUS then ATTACHED, one row, one grammar. `tier` rides each item so the
    // chip can pick its wash without knowing which list it came from. On a
    // focus-gated mount the FOCUS tier (open-record context) follows the
    // textarea's focus like the scope line — only ATTACHED items (state the
    // user made) survive a blur.
    Chips: {
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Z',
        minWidth: '0',
        if: (el, s)=>{
            const a = el.scope.awareness(el, s);
            const blurredGate = el.parent?.attachedOnly || el.parent?.focusGated && !s.root?._promptFocused;
            return !!((blurredGate ? 0 : a.focus.length) || a.attached.length);
        },
        children: (el, s)=>{
            const a = el.scope.awareness(el, s);
            const blurredGate = el.parent?.attachedOnly || el.parent?.focusGated && !s.root?._promptFocused;
            const focusItems = blurredGate ? [] : a.focus;
            return [
                ...focusItems.map((i)=>({
                        ...i,
                        key: i.id,
                        tier: 'focus'
                    })),
                ...a.attached.map((i)=>({
                        ...i,
                        key: i.id,
                        tier: 'attached'
                    }))
            ];
        },
        childExtends: 'AiContextChip',
        childrenAs: 'state'
    }
};

});

parcelRegister("kWFE3", function(module, exports) {

$parcel$export(module.exports, "GeexSegmentedBar", () => $f3f98743d1914f64$export$255fe53e170e5666);
// GeexSegmentedBar — Geex frame 26 (workspace/design-refs/geex/
// 26-analytics-segmented-progress.png, "New iOS Users"): one full-width
// segmented bar (solid ink lead segment, tonal steps for the rest) with
// per-segment giant numerals + a square legend marker + name + delta on
// one baseline each. Generalizes the inline composition already shipped
// at workspace/packages/workspace/pages/main.js ("Geex frame 26" —
// read-only, do not edit; this primitive lets OTHER surfaces reuse the
// same visual language via data props instead of copy-pasting markup).
//
// items: [{ label, value, delta? }] — value is the raw magnitude
// (rendered via String()); delta is a plain number, formatted as a signed
// percent ('+1.12%' / '-1.3%'). Segment widths are each item's share of
// the total. First item is the "lead" segment (solid ink); the rest step
// down in tone.
// ink: base foreground token (default 'title' — the adaptive semantic so
// this reads correctly on any neutral surface out of the box). On a hue
// poster, pass the surface's binary ink ('black'/'white') explicitly.
// hue: optional — when set, non-lead segments/markers shade the SAME hue
// (poster-tonal steps, `hue+15`/`hue-15`) instead of ink-alpha. Omit for a
// neutral surface (ink-alpha steps only).
// FA204 / frank trap — helpers live in `scope`, NOT module scope: a bare
// module-scope const silently reads as undefined once the component is
// frank.toJSON'd (children factories then throw and the whole subtree never
// mounts). el.scope.<name> resolves from any descendant handler.
const $f3f98743d1914f64$export$255fe53e170e5666 = {
    scope: {
        segTone: (ink, hue, i)=>{
            if (i === 0) return ink;
            return hue ? i % 2 ? `${hue}-15` : `${hue}+15` : i % 2 ? `${ink}.35` : `${ink}.15`;
        },
        fmtDelta: (n)=>{
            const v = Number(n) || 0;
            return `${v > 0 ? '+' : ''}${v}%`;
        }
    },
    flow: 'y',
    gap: 'B',
    width: '100%',
    items: [],
    ink: 'title',
    Bar: {
        flow: 'x',
        width: '100%',
        height: 'Z2',
        round: 'radiusPill',
        overflow: 'hidden',
        background: (el)=>`${el.parent.ink || 'title'}.12`,
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const items = parent.items || [];
            const total = items.reduce((n, it)=>n + Math.max(Number(it.value) || 0, 0), 0) || 1;
            return items.map((it, i)=>({
                    key: it.label || `seg${i}`,
                    segFlex: Math.max(Number(it.value) || 0, 0) / total,
                    segColor: el.scope.segTone(parent.ink || 'title', parent.hue, i)
                }));
        },
        childExtends: {
            transition: 'A defaultBezier flex',
            // Floor only nonzero shares — a floored sliver appended to a ~full
            // bar reads as an artifact nub; a zero segment should just vanish.
            flex: (el, s)=>String(s.segFlex > 0 ? Math.max(s.segFlex, 0.02) : 0),
            background: (el, s)=>s.segColor
        }
    },
    Rows: {
        flow: 'y',
        gap: 'D',
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const ink = parent.ink || 'title';
            const hue = parent.hue;
            return (parent.items || []).map((it, i)=>({
                    key: it.label || `row${i}`,
                    label: it.label || '',
                    value: it.value,
                    delta: it.delta,
                    markColor: el.scope.segTone(ink, hue, i),
                    ink: ink
                }));
        },
        childExtends: {
            flow: 'y',
            gap: 'X',
            Num: {
                tag: 'span',
                fontSize: 'F',
                fontWeight: '700',
                fontFamily: 'Code',
                lineHeight: '0.95',
                color: (el, s)=>s.ink,
                text: (el, s)=>String(s.value ?? 0)
            },
            LegendRow: {
                flow: 'x',
                align: 'baseline space-between',
                gap: 'Y',
                Left: {
                    flow: 'x',
                    align: 'center start',
                    gap: 'Y',
                    Mark: {
                        width: 'X2',
                        height: 'X2',
                        flexShrink: '0',
                        background: (el, s)=>s.markColor
                    },
                    Name: {
                        tag: 'span',
                        fontSize: 'Z',
                        opacity: '0.55',
                        color: (el, s)=>s.ink,
                        // `items[].label` is a KEY-IN-STATE carrier: a consumer may hand this
                        // chart a bundle key (workspace/pages/admin/usage.js feeds
                        // `admin.usage.attr.systemEmpty`). Resolved HERE, at the render site —
                        // `translate()` returns its input unchanged when nothing resolves, so a
                        // tenant-supplied label passes through untouched.
                        text: (el, s)=>el.call('polyglot', s.label || '')
                    }
                },
                Delta: {
                    tag: 'span',
                    fontSize: 'Z',
                    fontWeight: '700',
                    fontFamily: 'Code',
                    color: (el, s)=>s.ink,
                    hide: (el, s)=>s.delta === undefined || s.delta === null,
                    text: (el, s)=>el.scope.fmtDelta(s.delta)
                }
            }
        }
    }
};

});

parcelRegister("2PO9F", function(module, exports) {

$parcel$export(module.exports, "GeexTonalBars", () => $21073fe391b3d9cd$export$cad5ffc642e43f9e);
// GeexTonalBars — Geex frame 06 (workspace/design-refs/geex/
// 06-analytics-tonal-bars.png, "Income & Expenses"): a flat bar chart with
// NO axis/gridlines — bars alternate a flat ink-alpha (or hue-tonal, see
// `hue`) fill with a HATCHED texture variant (repeating-linear-gradient on
// the bar FILL only — the ticket's sanctioned data-texture device), a
// period rail in ink.45 above, and the value rendered directly above each
// bar.
//
// items: [{ label, value, hatched?, title? }] — value drives bar height
// (proportional to the series max, min-floored so a zero value still
// reads as a sliver, never nothing). hatched defaults to alternating by
// index (even = solid, odd = hatched) when not explicitly set per item.
// title: optional — the hover text of that period's label and bar (e.g. the
// full date and the exact total); none, no title attribute.
// ink: base foreground token (default 'title'). hue: optional — poster-
// tonal steps (`hue+10`/`hue-10`) instead of ink-alpha when set.
// height: plot-band height — a spacing-scale token (chart geometry rides
// the same em-based sequence as everything else; default 'E1', ~144px at
// base scale).
// FA204 / frank trap — helper lives in `scope`, not module scope (a bare
// module-scope const reads as undefined post-frank.toJSON and kills the
// Plot children factory; the Rail rendered while the bars silently didn't).
const $21073fe391b3d9cd$export$cad5ffc642e43f9e = {
    scope: {
        barTone: (ink, hue, i)=>hue ? i % 2 ? `${hue}-10` : `${hue}+10` : i % 2 ? `${ink}.15` : `${ink}.35`
    },
    flow: 'y',
    gap: 'Y',
    width: '100%',
    items: [],
    ink: 'title',
    height: 'E1',
    Rail: {
        display: 'grid',
        gridTemplateColumns: (el)=>`repeat(${(el.parent.items || []).length || 1}, 1fr)`,
        gap: 'X',
        childrenAs: 'state',
        children: (el, s)=>(el.parent.items || []).map((it, i)=>({
                    key: it.label || `p${i}`,
                    label: it.label || '',
                    title: it.title || ''
                })),
        childExtends: {
            tag: 'span',
            fontSize: 'Z',
            textAlign: 'center',
            // The QUIET INK, never an opacity: ink at 0.45 read 4.14:1 dark and
            // 3.27:1 light (admin census, 2026-09-24). `inactive` in light and
            // `caption` in dark clear 4.5 on the sheet, a card and the stage.
            color: 'inactive',
            '@dark': {
                color: 'caption'
            },
            title: (el, s)=>s.title || null,
            // `items[].label` is a KEY-IN-STATE carrier: a consumer may hand this
            // chart a bundle key (workspace/pages/admin/usage.js feeds
            // `admin.usage.attr.systemEmpty`). Resolved HERE, at the render site —
            // `translate()` returns its input unchanged when nothing resolves, so a
            // tenant-supplied label passes through untouched.
            text: (el, s)=>el.call('polyglot', s.label || '')
        }
    },
    Plot: {
        display: 'grid',
        gridTemplateColumns: (el)=>`repeat(${(el.parent.items || []).length || 1}, 1fr)`,
        alignItems: 'end',
        gap: 'X',
        height: (el)=>el.parent.height || 'E1',
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const items = parent.items || [];
            const max = items.reduce((n, it)=>Math.max(n, Number(it.value) || 0), 0) || 1;
            const ink = parent.ink || 'title';
            const hue = parent.hue;
            return items.map((it, i)=>({
                    key: it.label || `bar${i}`,
                    pct: Math.max((Number(it.value) || 0) / max, 0.02) * 100,
                    hatched: typeof it.hatched === 'boolean' ? it.hatched : i % 2 === 1,
                    tone: el.scope.barTone(ink, hue, i),
                    value: it.value,
                    ink: ink,
                    title: it.title || ''
                }));
        },
        childExtends: {
            flow: 'y',
            justifyContent: 'flex-end',
            alignItems: 'center',
            height: '100%',
            gap: 'X',
            title: (el, s)=>s.title || null,
            Value: {
                tag: 'span',
                fontSize: 'Z',
                fontFamily: 'Code',
                fontWeight: '700',
                color: (el, s)=>s.ink,
                text: (el, s)=>String(s.value ?? '')
            },
            Fill: {
                width: '100%',
                height: (el, s)=>`${s.pct}%`,
                transition: 'A defaultBezier height',
                color: (el, s)=>s.tone,
                background: (el, s)=>s.hatched ? 'transparent' : 'currentColor',
                backgroundImage: (el, s)=>s.hatched ? // at 14 px), not raw pixels — they follow the chart's own size
                    'repeating-linear-gradient(135deg, currentColor 0, currentColor var(--spacing-X), transparent var(--spacing-X), transparent var(--spacing-Y1))' : 'none'
            }
        }
    }
};

});

parcelRegister("4ei3X", function(module, exports) {

$parcel$export(module.exports, "GeexGridBars", () => $31467b27088bf1df$export$47046a9d669f9534);
// GeexGridBars — Geex frame 08 (workspace/design-refs/geex/
// 08-analytics-grid-bars-orange.png, "Cash Receipts"): a faint same-hue
// grid rules the whole plot (via a repeating-linear-gradient background —
// no border/outline properties, so the borderless law holds); each
// column's value reads as a thin solid-ink CAP resting at the value
// height, not a filled column — the grid itself supplies the "how tall"
// reference. Optional `hatched` per item renders that column's body with
// the sanctioned hatch texture (the reference frame's "incomplete period"
// accent).
//
// items: [{ label, value, hatched? }].
// ink: base foreground (default 'title'). hue: optional — grid ruling +
// spacer tone shade the hue instead of ink-alpha (poster context).
// height: plot-band height — a spacing-scale token (default 'E2', ~161px
// at base scale).
const $31467b27088bf1df$export$47046a9d669f9534 = {
    flow: 'y',
    gap: 'Y',
    items: [],
    ink: 'title',
    height: 'E2',
    Rail: {
        display: 'grid',
        gridTemplateColumns: (el)=>`repeat(${(el.parent.items || []).length || 1}, 1fr)`,
        gap: 'X',
        childrenAs: 'state',
        children: (el, s)=>(el.parent.items || []).map((it, i)=>({
                    key: it.label || `p${i}`,
                    label: it.label || ''
                })),
        childExtends: {
            tag: 'span',
            fontSize: 'Z',
            textAlign: 'center',
            opacity: '0.45',
            color: (el, s)=>el.parent.parent.ink || 'title',
            // `items[].label` is a KEY-IN-STATE carrier: a consumer may hand this
            // chart a bundle key (workspace/pages/admin/usage.js feeds
            // `admin.usage.attr.systemEmpty`). Resolved HERE, at the render site —
            // `translate()` returns its input unchanged when nothing resolves, so a
            // tenant-supplied label passes through untouched.
            text: (el, s)=>el.call('polyglot', s.label || '')
        }
    },
    Plot: {
        position: 'relative',
        height: (el)=>el.parent.height || 'E2',
        round: 'radiusCard',
        overflow: 'hidden',
        color: (el)=>`${el.parent.hue || el.parent.ink || 'title'}.15`,
        backgroundImage: 'repeating-linear-gradient(to right, currentColor 0, currentColor 1px, transparent 1px, transparent 24px), repeating-linear-gradient(to bottom, currentColor 0, currentColor 1px, transparent 1px, transparent 24px)',
        Cols: {
            position: 'absolute',
            inset: '0',
            display: 'grid',
            gridTemplateColumns: (el)=>`repeat(${(el.parent.parent.items || []).length || 1}, 1fr)`,
            gap: 'X',
            padding: '0 X',
            childrenAs: 'state',
            children: (el, s)=>{
                const parent = el.parent.parent;
                const items = parent.items || [];
                const max = items.reduce((n, it)=>Math.max(n, Number(it.value) || 0), 0) || 1;
                return items.map((it, i)=>({
                        key: it.label || `col${i}`,
                        pct: Math.max((Number(it.value) || 0) / max, 0.04) * 100,
                        hatched: !!it.hatched,
                        value: it.value,
                        ink: parent.ink || 'title',
                        hue: parent.hue
                    }));
            },
            childExtends: {
                flow: 'y',
                justifyContent: 'flex-end',
                alignItems: 'center',
                height: '100%',
                gap: 'V',
                Value: {
                    tag: 'span',
                    fontSize: 'Z',
                    fontFamily: 'Code',
                    fontWeight: '700',
                    color: (el, s)=>s.ink,
                    text: (el, s)=>String(s.value ?? '')
                },
                Cap: {
                    width: '100%',
                    height: 'X',
                    background: (el, s)=>s.ink
                },
                Spacer: {
                    width: '100%',
                    height: (el, s)=>`${s.pct}%`,
                    color: (el, s)=>`${s.hue || s.ink}.35`,
                    background: 'transparent',
                    backgroundImage: (el, s)=>s.hatched ? 'repeating-linear-gradient(135deg, currentColor 0, currentColor 3px, transparent 3px, transparent 7px)' : 'none'
                }
            }
        }
    }
};

});

parcelRegister("aR9lQ", function(module, exports) {

$parcel$export(module.exports, "GeexRankedStack", () => $7e761b9b19c750b8$export$14556f0504966100);
// GeexRankedStack — Geex frame 07 (workspace/design-refs/geex/
// 06-analytics-tonal-bars.png, "My Daily Spendings" — the paired frame
// ships in the same source PNG as GeexTonalBars/06 on the geex share
// grid): stacked blocks of decreasing width, white-to-hue tonal steps,
// giant % + label per block, one money-figure footer row. No axes — the
// block-width rhythm alone carries "biggest share first".
//
// items: [{ label, value, amount? }] — value is the percent number (58,
// not '58%'); amount is an optional pre-formatted footer figure
// ('$2,281.50'). Footer row only renders when at least one item has an
// amount.
// ink: base foreground (default 'title'). hue: optional — pale-to-base
// hue tonal steps instead of ink-alpha (poster context).
// FA204 / frank trap — helper lives in `scope`, not module scope (a bare
// module-scope const reads as undefined post-frank.toJSON; the Stack's
// children factory died while the helper-free Footer still rendered).
const $7e761b9b19c750b8$export$14556f0504966100 = {
    scope: {
        blockTone: (ink, hue, i)=>{
            if (hue) {
                const steps = [
                    40,
                    25,
                    12,
                    0
                ];
                const step = steps[Math.min(i, steps.length - 1)];
                return step ? `${hue}+${step}` : hue;
            }
            const alphas = [
                5,
                14,
                24,
                36
            ];
            return `${ink}.${alphas[Math.min(i, alphas.length - 1)]}`;
        }
    },
    flow: 'y',
    gap: 'V',
    width: '100%',
    items: [],
    ink: 'title',
    Stack: {
        flow: 'y',
        gap: 'V',
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const items = parent.items || [];
            const n = items.length || 1;
            const ink = parent.ink || 'title';
            const hue = parent.hue;
            return items.map((it, i)=>({
                    key: it.label || `block${i}`,
                    pct: Math.max(100 - i * (40 / Math.max(n - 1, 1)), 50),
                    tone: el.scope.blockTone(ink, hue, i),
                    value: it.value,
                    label: it.label || '',
                    ink: ink
                }));
        },
        childExtends: {
            round: 'radiusCard',
            padding: 'C B',
            width: (el, s)=>`${s.pct}%`,
            background: (el, s)=>s.tone,
            transition: 'A defaultBezier width, A defaultBezier background',
            Value: {
                tag: 'span',
                display: 'block',
                fontSize: 'G',
                fontWeight: '700',
                fontFamily: 'Code',
                lineHeight: '0.95',
                color: (el, s)=>s.ink,
                text: (el, s)=>`${s.value ?? 0}%`
            },
            Label: {
                tag: 'span',
                display: 'block',
                fontSize: 'Z',
                opacity: '0.55',
                color: (el, s)=>s.ink,
                // `items[].label` is a KEY-IN-STATE carrier: a consumer may hand this
                // chart a bundle key (workspace/pages/admin/usage.js feeds
                // `admin.usage.attr.systemEmpty`). Resolved HERE, at the render site —
                // `translate()` returns its input unchanged when nothing resolves, so a
                // tenant-supplied label passes through untouched.
                text: (el, s)=>el.call('polyglot', s.label || '')
            }
        }
    },
    Footer: {
        flow: 'x',
        align: 'baseline space-between',
        gap: 'B',
        hide: (el)=>!(el.parent.items || []).some((it)=>it.amount),
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const ink = parent.ink || 'title';
            return (parent.items || []).map((it, i)=>({
                    key: it.label || `foot${i}`,
                    label: it.label || '',
                    amount: it.amount || '',
                    ink: ink
                }));
        },
        childExtends: {
            flow: 'y',
            gap: 'X',
            Label: {
                tag: 'span',
                fontSize: 'Z',
                opacity: '0.45',
                color: (el, s)=>s.ink,
                text: (el, s)=>el.call('polyglot', s.label || '')
            },
            Amount: {
                tag: 'span',
                fontSize: 'Z',
                fontWeight: '700',
                fontFamily: 'Code',
                color: (el, s)=>s.ink,
                text: (el, s)=>s.amount
            }
        }
    }
};

});

parcelRegister("hTQjv", function(module, exports) {

$parcel$export(module.exports, "GeexValueRules", () => $d08027184cb7d4fe$export$447260a19b5a6e1d);
// GeexValueRules — Geex frame 09 (workspace/design-refs/geex/
// 08-analytics-grid-bars-orange.png, "Saved & Invested" — the paired frame
// ships in the same source PNG as GeexGridBars/08 on the geex share grid):
// sparse vertical ink ticks at data points (thin marks + a value label, no
// axis/gridlines — height alone encodes magnitude) plus one pattern-filled
// proportional footer bar for the category breakdown.
//
// items: [{ label, value }] — the sparse tick series; value is the raw
// number driving tick height (max-normalized), evenly spread left-to-right.
// segments: [{ label, value, texture? }] — footer proportional bar; value
// is the percent share, texture is 'solid' | 'hatched' | 'faint' (defaults
// to that exact 3-step cycle by index — the reference frame's device).
// ink / hue: same contract as the other primitives — hue tints the
// 'hatched'/'faint' footer segments when set, else ink-alpha.
// height: tick-plot height — a spacing-scale token (default 'E', ~117px
// at base scale).
// FA204 / frank trap — helper lives in `scope`, not module scope (a bare
// module-scope const reads as undefined post-frank.toJSON and kills the
// footer-segment factories).
const $d08027184cb7d4fe$export$447260a19b5a6e1d = {
    scope: {
        segTone: (ink, hue, texture)=>{
            const base = hue || ink;
            if (texture === 'hatched') return {
                color: `${base}.55`,
                image: true
            };
            if (texture === 'faint') return {
                color: `${base}.12`,
                image: false
            };
            return {
                color: ink,
                image: false
            };
        }
    },
    flow: 'y',
    gap: 'C',
    // The Plot's children are absolutely positioned, so nothing gives this
    // primitive intrinsic width — without an explicit width the root
    // collapses when a consumer centers it and every tick lands at x≈0.
    width: '100%',
    items: [],
    segments: [],
    ink: 'title',
    height: 'E',
    Plot: {
        position: 'relative',
        height: (el)=>el.parent.height || 'E',
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const items = parent.items || [];
            const n = items.length || 1;
            const max = items.reduce((m, it)=>Math.max(m, Number(it.value) || 0), 0) || 1;
            const ink = parent.ink || 'title';
            return items.map((it, i)=>({
                    key: it.label || `tick${i}`,
                    left: n > 1 ? i / (n - 1) * 82 : 0,
                    pct: Math.max((Number(it.value) || 0) / max, 0.08) * 100,
                    label: it.label || '',
                    ink: ink
                }));
        },
        childExtends: {
            position: 'absolute',
            left: (el, s)=>`${s.left}%`,
            bottom: (el, s)=>`${s.pct}%`,
            flow: 'x',
            align: 'center start',
            gap: 'X',
            Tick: {
                width: 'V',
                height: 'C',
                background: (el, s)=>s.ink,
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z',
                fontFamily: 'Code',
                fontWeight: '700',
                whiteSpace: 'nowrap',
                color: (el, s)=>s.ink,
                // `items[].label` is a KEY-IN-STATE carrier: a consumer may hand this
                // chart a bundle key (workspace/pages/admin/usage.js feeds
                // `admin.usage.attr.systemEmpty`). Resolved HERE, at the render site —
                // `translate()` returns its input unchanged when nothing resolves, so a
                // tenant-supplied label passes through untouched.
                text: (el, s)=>el.call('polyglot', s.label || '')
            }
        }
    },
    Footer: {
        flow: 'y',
        gap: 'X',
        hide: (el)=>!(el.parent.segments || []).length,
        Bar: {
            flow: 'x',
            width: '100%',
            height: 'C',
            round: 'X',
            overflow: 'hidden',
            childrenAs: 'state',
            children: (el, s)=>{
                const parent = el.parent.parent;
                const ink = parent.ink || 'title';
                const hue = parent.hue;
                const cycle = [
                    'solid',
                    'hatched',
                    'faint'
                ];
                return (parent.segments || []).map((sg, i)=>({
                        key: sg.label || `seg${i}`,
                        flexPct: Math.max(Number(sg.value) || 0, 1),
                        texture: sg.texture || cycle[i % cycle.length],
                        ink: ink,
                        hue: hue
                    }));
            },
            childExtends: {
                flex: (el, s)=>String(s.flexPct),
                height: '100%',
                color: (el, s)=>el.scope.segTone(s.ink, s.hue, s.texture).color,
                background: (el, s)=>el.scope.segTone(s.ink, s.hue, s.texture).image ? 'transparent' : 'currentColor',
                backgroundImage: (el, s)=>el.scope.segTone(s.ink, s.hue, s.texture).image ? 'repeating-linear-gradient(135deg, currentColor 0, currentColor 3px, transparent 3px, transparent 7px)' : 'none'
            }
        },
        Captions: {
            flow: 'x',
            childrenAs: 'state',
            children: (el, s)=>{
                const parent = el.parent.parent;
                const ink = parent.ink || 'title';
                return (parent.segments || []).map((sg, i)=>({
                        key: sg.label || `cap${i}`,
                        flexPct: Math.max(Number(sg.value) || 0, 1),
                        value: sg.value,
                        label: sg.label || '',
                        ink: ink
                    }));
            },
            childExtends: {
                flow: 'y',
                gap: 'V',
                flex: (el, s)=>String(s.flexPct),
                Value: {
                    tag: 'span',
                    fontSize: 'B',
                    fontWeight: '700',
                    fontFamily: 'Code',
                    color: (el, s)=>s.ink,
                    text: (el, s)=>`${s.value ?? 0}%`
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Z',
                    opacity: '0.45',
                    color: (el, s)=>s.ink,
                    text: (el, s)=>el.call('polyglot', s.label || '')
                }
            }
        }
    }
};

});

parcelRegister("5Jwoo", function(module, exports) {

$parcel$export(module.exports, "GeexStackedColumn", () => $42ca48330b478aca$export$31aad2c737d177b9);
// GeexStackedColumn — Geex frame 27 (workspace/design-refs/geex/
// 26-analytics-segmented-progress.png, "Customer Orders" — the paired
// frame ships in the same source PNG as GeexSegmentedBar/26 on the geex
// share grid): plain tonal bars per period, except the dominant
// (highest-value) column, which stacks ink-scale bands top-to-bottom with
// its value in a solid-ink chip — "one column tells the story, the rest
// are just context." Optional total/delta footer row.
//
// items: [{ label, value, dominant? }] — dominant defaults to the
// max-value item when no item explicitly flags one.
// total / totalLabel / delta — optional footer figures ("272" / "Total
// orders" / 2.11 → "+2.11%").
// ink: base foreground (default 'title'). onInk: text color for the
// dominant chip's solid-ink fill (default 'title-reversed' — the DS's
// pre-built inverse-of-title pair; on a fixed poster ink, pass the
// poster's own background hue/token explicitly since 'title-reversed'
// only inverts the ADAPTIVE pair). hue: optional — non-dominant bars
// shade the hue instead of ink-alpha. height: plot height — a
// spacing-scale token (default 'E1', ~144px at base scale).
const $42ca48330b478aca$export$31aad2c737d177b9 = {
    // FA204 — STACK_BANDS is used only by this component's descendant
    // handler (Bar.children below); carried via `scope` so frank
    // serialization keeps it (a bare module-scope const can silently read
    // as undefined once a component is frank.toJSON'd — el.scope.<name>
    // resolves from any descendant handler, same as MarketplaceKindRail's
    // `scope: { hydrate, cardComponent }`).
    scope: {
        STACK_BANDS: [
            1,
            0.7,
            0.45,
            0.25
        ]
    },
    flow: 'y',
    gap: 'C',
    items: [],
    ink: 'title',
    onInk: 'title-reversed',
    height: 'E1',
    Plot: {
        display: 'grid',
        gridTemplateColumns: (el)=>`repeat(${(el.parent.items || []).length || 1}, 1fr)`,
        alignItems: 'end',
        gap: 'X',
        height: (el)=>el.parent.height || 'E1',
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const items = parent.items || [];
            const max = items.reduce((m, it)=>Math.max(m, Number(it.value) || 0), 0) || 1;
            const hasExplicitDominant = items.some((it)=>it.dominant);
            const ink = parent.ink || 'title';
            const onInk = parent.onInk || 'title-reversed';
            const hue = parent.hue;
            return items.map((it, i)=>{
                const value = Number(it.value) || 0;
                const dominant = hasExplicitDominant ? !!it.dominant : value === max;
                return {
                    key: it.label || `col${i}`,
                    pct: Math.max(value / max, 0.05) * 100,
                    dominant: dominant,
                    value: it.value,
                    label: it.label || '',
                    tone: hue ? `${hue}+20` : `${ink}.15`,
                    ink: ink,
                    onInk: onInk
                };
            });
        },
        childExtends: {
            flow: 'y',
            gap: 'V',
            height: '100%',
            Col: {
                flow: 'y',
                justifyContent: 'flex-end',
                alignItems: 'center',
                flex: '1',
                gap: 'V',
                Chip: {
                    padding: 'Y2 X2',
                    round: 'radiusPill',
                    background: (el, s)=>s.dominant ? s.ink : 'transparent',
                    Text: {
                        tag: 'span',
                        fontSize: 'X2',
                        fontWeight: '700',
                        fontFamily: 'Code',
                        color: (el, s)=>s.dominant ? s.onInk : s.ink,
                        text: (el, s)=>String(s.value ?? '')
                    }
                },
                Bar: {
                    width: '100%',
                    height: (el, s)=>`${s.pct}%`,
                    flow: 'y',
                    overflow: 'hidden',
                    background: (el, s)=>s.dominant ? 'transparent' : s.tone,
                    childrenAs: 'state',
                    children: (el, s)=>s.dominant ? el.scope.STACK_BANDS.map((op, i)=>({
                                key: `band${i}`,
                                op: op,
                                ink: s.ink
                            })) : [],
                    childExtends: {
                        width: '100%',
                        flex: '1',
                        background: (el, s)=>`${s.ink}.${Math.round(s.op * 90)}`
                    }
                }
            },
            Label: {
                tag: 'span',
                fontSize: 'Z',
                textAlign: 'center',
                opacity: '0.45',
                color: (el, s)=>s.ink,
                // `items[].label` is a KEY-IN-STATE carrier: a consumer may hand this
                // chart a bundle key (workspace/pages/admin/usage.js feeds
                // `admin.usage.attr.systemEmpty`). Resolved HERE, at the render site —
                // `translate()` returns its input unchanged when nothing resolves, so a
                // tenant-supplied label passes through untouched.
                text: (el, s)=>el.call('polyglot', s.label || '')
            }
        }
    },
    Footer: {
        flow: 'x',
        align: 'baseline space-between',
        gap: 'B',
        hide: (el)=>el.parent.total === undefined || el.parent.total === null,
        Left: {
            flow: 'y',
            gap: 'X',
            Total: {
                tag: 'span',
                fontSize: 'F',
                fontWeight: '700',
                fontFamily: 'Code',
                lineHeight: '0.95',
                color: (el)=>el.parent.parent.ink || 'title',
                text: (el)=>String(el.parent.parent.total ?? '')
            },
            TotalLabel: {
                tag: 'span',
                fontSize: 'Z',
                opacity: '0.45',
                color: (el)=>el.parent.parent.ink || 'title',
                text: (el)=>el.parent.parent.totalLabel || ''
            }
        },
        Delta: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '700',
            fontFamily: 'Code',
            color: (el)=>el.parent.ink || 'title',
            hide: (el)=>el.parent.delta === undefined || el.parent.delta === null,
            text: (el)=>{
                const n = Number(el.parent.delta) || 0;
                return `${n > 0 ? '+' : ''}${n}%`;
            }
        }
    }
};

});

parcelRegister("cbGeH", function(module, exports) {

$parcel$export(module.exports, "GeexBlobPercent", () => $8df74650b265ceea$export$9b7638e62d9fa685);
// GeexBlobPercent — Geex frame 05 (workspace/design-refs/geex/
// 05-widgets-shopping-blobs.png, "Monthly Expenses" right phone): organic
// pastel blobs (CSS asymmetric border-radius, no imagery) sized by share,
// giant % centered inside in solid ink; legend dots + values at foot. Use
// SPARINGLY — one per surface (brief: "playful share views... use
// sparingly").
//
// items: [{ label, value, amount?, hue? }] — value is the percent share
// (drives blob diameter via sqrt, so AREA reads proportional to share);
// amount is an optional pre-formatted footer figure. Per-item `hue`
// overrides the rotation for that one blob/dot.
// ink: base foreground (default 'title'). hue: optional single rotation
// seed — when set, blobs/dots cycle a small pastel family (`hue+30`-class
// tints) instead of falling back to plain ink-alpha tones.
// FA204 — the shape/rotation tables are used only by this component's
// descendant handlers (Field.children/Legend.children below); carried via
// `scope` so frank serialization keeps them (a bare module-scope const can
// silently read as undefined once a component is frank.toJSON'd —
// el.scope.<name> resolves from any descendant handler, same as
// MarketplaceKindRail's `scope: { hydrate, cardComponent }`).
const $8df74650b265ceea$export$9b7638e62d9fa685 = {
    scope: {
        // Helpers TOO must live here, not at module scope — the tables alone
        // being scoped wasn't enough: the module-scope _tone/_dotTone fns read
        // as undefined post-frank.toJSON and both children factories died.
        blobTone: (ink, hue, itemHue, i, rotation)=>{
            if (itemHue) return `${itemHue}+30`;
            if (hue) return `${rotation[i % rotation.length]}+30`;
            return `${ink}.15`;
        },
        dotTone: (ink, hue, itemHue, i, rotation)=>{
            if (itemHue) return `${itemHue}+30`;
            if (hue) return `${rotation[i % rotation.length]}+30`;
            return `${ink}.35`;
        },
        BLOB_SHAPES: [
            '42% 58% 65% 35% / 55% 45% 60% 40%',
            '60% 40% 45% 55% / 40% 60% 45% 55%',
            '38% 62% 55% 45% / 60% 40% 65% 35%',
            '55% 45% 40% 60% / 45% 60% 40% 55%'
        ],
        PASTEL_ROTATION: [
            'pink',
            'phosphorus',
            'cerulean',
            'yellow'
        ]
    },
    flow: 'y',
    gap: 'C',
    items: [],
    ink: 'title',
    Field: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 'C',
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const items = parent.items || [];
            const ink = parent.ink || 'title';
            const hue = parent.hue;
            const shapes = el.scope.BLOB_SHAPES;
            const rotation = el.scope.PASTEL_ROTATION;
            return items.map((it, i)=>({
                    key: it.label || `blob${i}`,
                    value: it.value,
                    size: Math.max(Math.sqrt(Math.max(Number(it.value) || 0, 4)) * 14, 64),
                    shape: shapes[i % shapes.length],
                    tone: el.scope.blobTone(ink, hue, it.hue, i, rotation),
                    ink: ink
                }));
        },
        childExtends: {
            flow: 'y',
            align: 'center center',
            flexShrink: '0',
            width: (el, s)=>`${s.size}px`,
            height: (el, s)=>`${s.size}px`,
            borderRadius: (el, s)=>s.shape,
            background: (el, s)=>s.tone,
            Value: {
                tag: 'span',
                fontSize: 'G',
                fontWeight: '700',
                fontFamily: 'Code',
                color: (el, s)=>s.ink,
                text: (el, s)=>`${s.value ?? 0}%`
            }
        }
    },
    Legend: {
        tag: 'div',
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'C',
        hide: (el)=>!(el.parent.items || []).length,
        childrenAs: 'state',
        children: (el, s)=>{
            const parent = el.parent;
            const items = parent.items || [];
            const ink = parent.ink || 'title';
            const hue = parent.hue;
            const rotation = el.scope.PASTEL_ROTATION;
            return items.map((it, i)=>({
                    key: it.label || `leg${i}`,
                    label: it.label || '',
                    amount: it.amount || '',
                    dot: el.scope.dotTone(ink, hue, it.hue, i, rotation),
                    ink: ink
                }));
        },
        childExtends: {
            flow: 'y',
            gap: 'V',
            Top: {
                flow: 'x',
                align: 'center start',
                gap: 'V',
                Dot: {
                    width: 'V1',
                    height: 'V1',
                    round: '50%',
                    flexShrink: '0',
                    background: (el, s)=>s.dot
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Z',
                    opacity: '0.55',
                    color: (el, s)=>s.ink,
                    // `items[].label` is a KEY-IN-STATE carrier: a consumer may hand this
                    // chart a bundle key (workspace/pages/admin/usage.js feeds
                    // `admin.usage.attr.systemEmpty`). Resolved HERE, at the render site —
                    // `translate()` returns its input unchanged when nothing resolves, so a
                    // tenant-supplied label passes through untouched.
                    text: (el, s)=>el.call('polyglot', s.label || '')
                }
            },
            Amount: {
                tag: 'span',
                fontSize: 'Z',
                fontWeight: '700',
                fontFamily: 'Code',
                color: (el, s)=>s.ink,
                hide: (el, s)=>!s.amount,
                text: (el, s)=>s.amount
            }
        }
    }
};

});

parcelRegister("jdbZY", function(module, exports) {

$parcel$export(module.exports, "UserProfile", () => $dfc889e3a2ed30e4$export$b7b58f2e100445f7);
$parcel$export(module.exports, "UserProfileTab", () => $dfc889e3a2ed30e4$export$c878c053d8e0e282);
$parcel$export(module.exports, "UserProfileProjectCard", () => $dfc889e3a2ed30e4$export$4aaf3b4c2e0abf44);
$parcel$export(module.exports, "UserProfileIntegrationRow", () => $dfc889e3a2ed30e4$export$513685da8a00fc3);
$parcel$export(module.exports, "UserProfileFollowRow", () => $dfc889e3a2ed30e4$export$d6f6805468308970);
// UserProfile — public-facing user profile component used by /u/:slug.
//
// Sections:
//   Hero            — avatar, display name, bio, Follow button, location
//   ActivityChart   — last 365 days of activity, GitHub-style heatmap
//   Tabs            — Projects | Integrations | Agents | Followers | Following
//   <Tab content>
//
// Reads the viewed user from `s.root._profileViewed` (populated by
// pages/userProfile.js#onCreate). The Follow button writes to
// `s.root.followingEmails` via the same helper the marketplace uses.
//
// This component is wired into the project's components/index.js so
// pages/userProfile.js can mount it. Activity chart reuses the shared
// `ActivityChart` (designed to be data-source agnostic).

var $76fm2 = parcelRequire("76fm2");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $eVQcI = parcelRequire("eVQcI");
const $dfc889e3a2ed30e4$export$b7b58f2e100445f7 = {
    // FA204 / frank trap — every helper below lives in `scope`, not module
    // scope: a bare module-scope const/function silently reads as undefined
    // once this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Called via
    // `el.scope.<name>(...)` from any descendant factory/handler (`scope:`
    // merges onto every instance in this tree). Regular method syntax (not
    // arrows) — `el.scope.foo()` binds `this` to `el.scope`, so sibling
    // helpers call each other via `this.<name>(...)`. `readFollows`/
    // `writeFollows`/`isFollowing`/`toggleFollow`/`isSelf` are DUPLICATED into
    // UserProfileFollowRow's own scope below — `el.scope` only resolves
    // within the tree of the specific top-level export it's defined on, not
    // across sibling top-level exports in this file.
    scope: {
        // Debounced field saver — keyed per field so name + bio + location
        // don't cancel each other's writes. Mirrors the pattern in
        // MemberProfile._patchUser.
        saveTimers: {},
        debouncedSave (root, userId, patch) {
            if (!root || !userId) return;
            // Optimistic local update so the UI tracks the user's typing.
            const merged = {
                ...root._profileViewed || {},
                ...patch
            };
            // Sync both directories so values persist after navigate. Closes #2220.
            root.update({
                _profileViewed: merged,
                _profileSaving: true,
                // Session flag — the FIRST edit this page-view has actually made.
                // SaveStatus.hide below gates on this alongside _profileEditing/
                // isSelf so the "Saved" fallback text can't render the instant edit
                // mode opens, before any keystroke has triggered a save.
                _profileHasSaved: true,
                people: (0, $76fm2.patchPeopleList)(root.people, userId, patch),
                peopleAll: (0, $76fm2.patchPeopleList)(root.peopleAll, userId, patch)
            });
            const field = Object.keys(patch)[0];
            clearTimeout(this.saveTimers[field]);
            this.saveTimers[field] = setTimeout(async ()=>{
                try {
                    // Must be the id-targeted route, NOT `workspaceProject.userProfiles`.
                    // That entity is CALLER-scoped: it used to ride the `/sb` proxy, whose
                    // `_scopeUrl` did `params.set('user_id', 'eq.' + caller)` — `set`, so the
                    // `id` we passed was accepted and then silently overwritten — and it now
                    // resolves to the self-scoped `PATCH /core/user-profile`, which ignores
                    // `id` by design. Either way, editing ANOTHER user's profile here wrote
                    // to the acting user's own row and returned 200. `_profileViewed.userId`
                    // is frequently someone else, so this surface was affected.
                    // `updateUserHrProfile` throws rather than defaulting to the caller.
                    await (0, $1NxyO.getSDK)().updateUserHrProfile(userId, patch);
                    root.update({
                        _profileSaving: false,
                        _profileSaveError: null
                    });
                } catch (err) {
                    console.warn('[userProfile] save failed', err?.message || err);
                    // A KEY, not copy — `debouncedSave` is a scope method with no
                    // element, so the SaveStatus render site resolves it. A server
                    // message passes through polyglot unchanged.
                    root.update({
                        _profileSaving: false,
                        _profileSaveError: err?.message || 'account.userProfile.saveFailed'
                    });
                }
            }, 500);
        },
        toggleEditMode (root) {
            if (!root) return;
            root.update({
                _profileEditing: !root._profileEditing
            });
        },
        // Hydrate the user's followers/following list from localStorage. The
        // store mirrors what marketplace persists so the same source of
        // truth backs the workspace and marketplace surfaces. Loaded once
        // per profile mount.
        readFollows () {
            if (typeof localStorage === 'undefined') return [];
            try {
                const raw = localStorage.getItem('marketplace.follows');
                return Array.isArray(JSON.parse(raw || '[]')) ? JSON.parse(raw) : [];
            } catch  {
                return [];
            }
        },
        writeFollows (list) {
            if (typeof localStorage === 'undefined') return;
            try {
                localStorage.setItem('marketplace.follows', JSON.stringify(list));
            } catch  {}
        },
        isFollowing (root, email) {
            if (!root || !email) return false;
            return (root.followingEmails || []).map((e)=>(e || '').toLowerCase()).includes(email.toLowerCase());
        },
        toggleFollow (root, email) {
            if (!root || !email) return;
            const cur = (root.followingEmails || this.readFollows()).map((e)=>(e || '').toLowerCase());
            const lower = email.toLowerCase();
            const next = cur.includes(lower) ? cur.filter((e)=>e !== lower) : [
                ...cur,
                lower
            ];
            root.update({
                followingEmails: next
            });
            this.writeFollows(next);
        },
        // Self-check — true when the profile being viewed belongs to the
        // signed-in user. Robust against an unpopulated `currentUserEmail`:
        //   1. honors the `_isSelf` marker the slug resolver stamps on the
        //      viewed record when getMe() matched the slug (pages/userProfile.js)
        //   2. matches by user id (currentUserId <-> viewed userId)
        //   3. matches by email (case-insensitive)
        // Any one signal hiding the Follow control is correct — better to hide
        // it on a near-miss than to let a user follow themselves (self-follow).
        isSelf (root, email) {
            if (!root) return false;
            const viewed = root._profileViewed || {};
            if (viewed._isSelf) return true;
            const meId = (root.currentUserId || '').toString();
            const viewedId = (viewed.userId || viewed.id || viewed._id || '').toString();
            if (meId && viewedId && meId === viewedId) return true;
            const meEmail = (root.currentUserEmail || '').toLowerCase();
            const cmp = (email || viewed.email || '').toLowerCase();
            if (!cmp) return false;
            return meEmail === cmp;
        },
        // Mock followers / following — until the backend lands, we synthesize
        // names from people directory + the current user's follow list. For
        // the viewed user's perspective: their `following` is everyone whose
        // row appears in the local follow store; their `followers` is the
        // inverse view computed from a global follow store (capped at 8 to
        // keep the UI lightweight).
        profileFollows (root, viewedEmail) {
            const me = (root?.currentUserEmail || '').toLowerCase();
            if (!viewedEmail) return {
                followers: [],
                following: []
            };
            const all = (root.peopleAll || []).concat(root.people || []);
            if (viewedEmail.toLowerCase() === me) {
                const followingEmails = (root.followingEmails || this.readFollows()).map((e)=>(e || '').toLowerCase());
                const following = followingEmails.map((e)=>(0, $76fm2.findPerson)(root, e) || {
                        email: e,
                        name: e.split('@')[0]
                    });
                // Followers — synthesize from team people. Without backend support,
                // we surface up to 4 active members as "followers" so the UI has
                // shape; a real backend will replace this read.
                const followers = all.slice(0, 4).filter((p)=>(p.email || '').toLowerCase() !== me);
                return {
                    followers: followers,
                    following: following
                };
            }
            // Viewing someone else: followers = anyone who follows them (best
            // effort, including the current user if applicable); following =
            // empty until the backend lands.
            const followers = [];
            const myFollows = (root.followingEmails || this.readFollows()).map((e)=>(e || '').toLowerCase());
            if (myFollows.includes(viewedEmail.toLowerCase())) {
                // A KEY, not copy — no element here either. The two follower render
                // sites (UserProfilePersonRow's Name / Avatar initial) resolve it, and
                // a real person's name passes through polyglot unchanged.
                const me_p = (0, $76fm2.findPerson)(root, root.currentUserEmail) || {
                    email: root.currentUserEmail,
                    name: 'account.userProfile.you'
                };
                followers.push(me_p);
            }
            return {
                followers: followers,
                following: []
            };
        },
        // Persisted "agents" are conceptual integrations the user has
        // installed. Until the dedicated agents endpoint lands we surface
        // nothing; the tab still renders an empty state so the UX is
        // future-ready.
        profileAgents (root, viewedEmail) {
            if (!viewedEmail) return [];
            // For the current user: surface entries from `_integrationHub`
            // (populated by marketplace's hydrate). Other users return [].
            if ((root.currentUserEmail || '').toLowerCase() !== viewedEmail.toLowerCase()) return [];
            const hub = root._integrationHub;
            const items = (hub?.integrations || []).filter((i)=>i.kind === 'mcp');
            return items.map((i)=>({
                    id: i.id || i.kind,
                    name: i.name || i.kind,
                    description: i.description || ''
                }));
        },
        profileIntegrations (root, viewedEmail) {
            if (!viewedEmail) return [];
            if ((root.currentUserEmail || '').toLowerCase() !== viewedEmail.toLowerCase()) return [];
            const hub = root._integrationHub;
            const items = (hub?.integrations || []).filter((i)=>i.kind !== 'mcp');
            return items.map((i)=>({
                    id: i.id || i.kind,
                    name: i.name || i.kind,
                    description: i.description || ''
                }));
        },
        profileProjects (root) {
            const list = root._profileProjects;
            if (!Array.isArray(list)) return [];
            return list;
        }
    },
    flow: 'y',
    gap: 'C',
    padding: 'C B1',
    maxWidth: 'L+L',
    width: '100%',
    margin: '0 auto',
    Hero: {
        flow: 'x',
        gap: 'B',
        align: 'center',
        padding: 'B 0',
        // Was `borderBottom: 'hairline solid line'` — divider-as-chrome, banned
        // by design-direction.md §8 / DESIGN_LANGUAGE §2.5. UserProfile's own
        // root `gap: 'C'` between Hero/ActivitySection/Tabs/TabContent already
        // gives every section boundary a full large-token whitespace gap on top
        // of this padding, so the line was pure decoration, not the separation
        // mechanism.
        Avatar: {
            align: 'center center',
            boxSize: 'F',
            minWidth: 'F',
            round: '50%',
            src: (el, s)=>el.call('avatarUrlFor', s.root?._profileViewed?.email)
        },
        Info: {
            flow: 'y',
            gap: 'V',
            flex: '1',
            Name: {
                hide: (el, s)=>s.root?._profileEditing && el.scope.isSelf(s.root, s.root?._profileViewed?.email),
                tag: 'h1',
                margin: '0',
                fontSize: 'D',
                fontWeight: '700',
                letterSpacing: '-0.02em',
                color: 'title',
                text: (el, s)=>s.root?._profileViewed?.name || s.root?._profileSlug || el.call('polyglot', 'account.userProfile.fallbackName')
            },
            NameField: {
                hide: (el, s)=>!(s.root?._profileEditing && el.scope.isSelf(s.root, s.root?._profileViewed?.email)),
                tag: 'input',
                type: 'text',
                // Display-size text (D, above 16px at every root): the shell's touch
                // focus-zoom floor (workspace app.js) would cut it to its parent's
                // size, and a field this large never zooms anyway.
                dataDisplayText: true,
                padding: 'X Z',
                borderRadius: 'Z',
                border: 'hairline solid line',
                background: 'document',
                color: 'title',
                fontSize: 'D',
                fontWeight: '700',
                letterSpacing: '-0.02em',
                width: '100%',
                maxWidth: 'I',
                placeholder: (el)=>el.call('polyglot', 'account.userProfile.placeholder.name'),
                value: (el, s)=>s.root?._profileViewed?.name || '',
                onInput: (e, el, s)=>{
                    const userId = s.root?._profileViewed?.userId;
                    el.scope.debouncedSave(s.root, userId, {
                        name: e.target.value
                    });
                }
            },
            Handle: {
                tag: 'span',
                fontSize: 'A',
                color: 'caption',
                text: (el, s)=>{
                    const v = s.root?._profileViewed || {};
                    const slug = v.slug || (v.email || '').split('@')[0] || s.root?._profileSlug;
                    return slug ? `@${slug}` : '';
                }
            },
            Bio: {
                hide: (el, s)=>{
                    if (s.root?._profileEditing && el.scope.isSelf(s.root, s.root?._profileViewed?.email)) return true;
                    return !(s.root?._profileViewed?.bio || s.root?._profileViewed?.position);
                },
                tag: 'p',
                margin: '0',
                marginTop: 'V',
                fontSize: 'A',
                color: 'subtitle',
                lineHeight: '1.5',
                maxWidth: 'K_default',
                text: (el, s)=>{
                    const v = s.root?._profileViewed || {};
                    return v.bio || v.position || '';
                }
            },
            // Edit-mode bio — surfaces only when the viewer is the owner and
            // _profileEditing is on. Writes back through `el.scope.debouncedSave`
            // (sdk.updateUserHrProfile — id-targeted). The legacy `position`
            // column doubles as the bio for accounts that don't have a
            // dedicated `bio` field — we write `bio` first, then `position`
            // as a fallback for back-compat.
            BioField: {
                hide: (el, s)=>!(s.root?._profileEditing && el.scope.isSelf(s.root, s.root?._profileViewed?.email)),
                tag: 'textarea',
                marginTop: 'V',
                width: '100%',
                maxWidth: 'K_default',
                minHeight: 'D',
                padding: 'Z A',
                borderRadius: 'Z',
                border: 'hairline solid line',
                background: 'document',
                color: 'title',
                fontSize: 'A',
                fontFamily: 'inherit',
                lineHeight: '1.5',
                resize: 'vertical',
                placeholder: (el)=>el.call('polyglot', 'account.userProfile.placeholder.bio'),
                value: (el, s)=>{
                    const v = s.root?._profileViewed || {};
                    return v.bio ?? v.position ?? '';
                },
                onInput: (e, el, s)=>{
                    const userId = s.root?._profileViewed?.userId;
                    el.scope.debouncedSave(s.root, userId, {
                        bio: e.target.value,
                        position: e.target.value
                    });
                }
            },
            Meta: {
                flow: 'x',
                gap: 'A',
                marginTop: 'V',
                fontSize: 'Z',
                color: 'caption',
                flexWrap: 'wrap',
                Location: {
                    tag: 'span',
                    hide: (el, s)=>{
                        if (s.root?._profileEditing && el.scope.isSelf(s.root, s.root?._profileViewed?.email)) return true;
                        return !(s.root?._profileViewed?.location || s.root?._profileViewed?.city);
                    },
                    text: (el, s)=>{
                        const v = s.root?._profileViewed || {};
                        return `\u{1F4CD} ${v.location || v.city || ''}`;
                    }
                },
                LocationField: {
                    hide: (el, s)=>!(s.root?._profileEditing && el.scope.isSelf(s.root, s.root?._profileViewed?.email)),
                    tag: 'input',
                    type: 'text',
                    padding: 'X Z',
                    borderRadius: 'Y',
                    border: 'hairline solid line',
                    background: 'document',
                    color: 'title',
                    fontSize: 'Z',
                    minWidth: 'F',
                    placeholder: (el)=>el.call('polyglot', 'account.userProfile.placeholder.location'),
                    value: (el, s)=>{
                        const v = s.root?._profileViewed || {};
                        return v.location || v.city || '';
                    },
                    onInput: (e, el, s)=>{
                        const userId = s.root?._profileViewed?.userId;
                        el.scope.debouncedSave(s.root, userId, {
                            location: e.target.value
                        });
                    }
                },
                SaveStatus: {
                    // Was missing a "has a save actually happened this session" gate:
                    // the moment edit mode opens, _profileSaving/_profileSaveError are
                    // both falsy, so the text factory below fell through to 'Saved'
                    // before any keystroke. _profileHasSaved (set by debouncedSave
                    // above) closes that gap.
                    hide: (el, s)=>!s.root?._profileEditing || !s.root?._profileHasSaved || !el.scope.isSelf(s.root, s.root?._profileViewed?.email),
                    tag: 'span',
                    fontSize: 'Y',
                    fontStyle: 'italic',
                    color: (el, s)=>s.root?._profileSaveError ? 'red' : 'caption',
                    text: (el, s)=>{
                        if (s.root?._profileSaveError) return `\u{26A0} ${el.call('polyglot', s.root._profileSaveError)}`;
                        if (s.root?._profileSaving) return el.call('polyglot', 'account.userProfile.saving');
                        return el.call('polyglot', 'account.userProfile.saved');
                    }
                },
                Joined: {
                    tag: 'span',
                    hide: (el, s)=>!s.root?._profileViewed?.startDate,
                    text: (el, s)=>{
                        const d = s.root?._profileViewed?.startDate;
                        if (!d) return '';
                        try {
                            const dt = new Date(d);
                            return el.call('polyglot', 'account.userProfile.joined').replace('{date}', el.call('localizedDate', dt, {
                                month: 'short',
                                year: 'numeric'
                            }));
                        } catch  {
                            return '';
                        }
                    }
                }
            }
        },
        Actions: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            FollowBtn: {
                extends: 'Button',
                // Self-follow guard (#self-follow). Two compounding causes made the
                // Follow control stay visible on your own profile (both verified live):
                //   1. `Button` sets a STATIC inline `display: inline-flex`; the reactive
                //      `hide` writes `display: none` via an atomic class, which loses to
                //      the inline style — so the button never hid. `display: null` clears
                //      that inline value so the reactive `hide` can win (the InspectBtn /
                //      CanvasPromptTextarea pattern).
                //   2. The viewer identity (currentUserId / currentUserEmail) and the
                //      resolved profile (_profileViewed) land AFTER first paint, so the
                //      `hide` factory must read all of them up front (via `isSelf`)
                //      before any early return, so its effect tracks every signal from
                //      the first pass and re-evaluates once identity hydrates.
                display: null,
                hide: (el, s)=>{
                    const self = el.scope.isSelf(s.root, s.root?._profileViewed?.email);
                    if (!s.root?._profileViewed?.email) return true;
                    return self;
                },
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                fontSize: 'Z2',
                fontWeight: '700',
                cursor: 'pointer',
                // Was an outlined button (`border` + conditional `borderColor`) —
                // banned outright by design-direction.md §8's ban list. §6.2's
                // button law is solid ink OR ghost fill, never outline: the
                // "Following" (secondary) state moves from transparent+border to
                // the `overlay` ghost fill; "Follow" (primary) was already a solid
                // blue fill, so its border was invisible border-on-same-colour
                // already — dropping it is a no-op there.
                background: (el, s)=>el.scope.isFollowing(s.root, s.root?._profileViewed?.email) ? 'overlay' : 'blue',
                color: (el, s)=>el.scope.isFollowing(s.root, s.root?._profileViewed?.email) ? 'caption' : 'white',
                text: (el, s)=>el.call('polyglot', el.scope.isFollowing(s.root, s.root?._profileViewed?.email) ? 'account.userProfile.following' : 'account.userProfile.follow'),
                onClick: (e, el, s)=>el.scope.toggleFollow(s.root, s.root?._profileViewed?.email)
            },
            EditBtn: {
                extends: 'Button',
                // Inverse of FollowBtn — shown ONLY on your own profile. Same two fixes:
                // `display: null` so the reactive `hide` beats the static inline
                // `display`, and `isSelf` read up front so the effect tracks identity
                // and re-evaluates on late hydration. Hidden when NOT your own profile,
                // or before the viewed record resolves.
                display: null,
                hide: (el, s)=>{
                    const self = el.scope.isSelf(s.root, s.root?._profileViewed?.email);
                    if (!s.root?._profileViewed?.email) return true;
                    return !self;
                },
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                // Was an outlined button — same fix + rationale as FollowBtn above.
                background: (el, s)=>s.root?._profileEditing ? 'blue' : 'overlay',
                color: (el, s)=>s.root?._profileEditing ? 'fillInk' : 'caption',
                fontSize: 'Z2',
                fontWeight: '700',
                cursor: 'pointer',
                ':hover': {
                    color: 'title'
                },
                text: (el, s)=>el.call('polyglot', s.root?._profileEditing ? 'account.userProfile.editDone' : 'account.userProfile.edit'),
                onClick: (e, el, s)=>el.scope.toggleEditMode(s.root)
            }
        }
    },
    ActivitySection: {
        flow: 'y',
        gap: 'Z',
        padding: 'B 0',
        // Divider-as-chrome — same fix + rationale as Hero above.
        heading: 'account.userProfile.activity.title',
        accent: 'green',
        dataKey: '_profileActivity',
        showLegend: true,
        ActivityChart: {}
    },
    Tabs: {
        flow: 'x',
        gap: 'V',
        padding: 'B 0 0',
        // Divider-as-chrome — same fix + rationale as Hero above; the root
        // `gap: 'C'` before TabContent plus TabContent's own top padding 'B'
        // already separate the tab row from its panel.
        childExtends: 'UserProfileTab',
        childrenAs: 'state',
        children: ()=>[
                {
                    key: 'projects',
                    label: 'account.userProfile.tab.projects'
                },
                {
                    key: 'integrations',
                    label: 'account.userProfile.tab.integrations'
                },
                {
                    key: 'agents',
                    label: 'account.userProfile.tab.agents'
                },
                {
                    key: 'followers',
                    label: 'account.userProfile.tab.followers'
                },
                {
                    key: 'following',
                    label: 'account.userProfile.tab.following'
                }
            ]
    },
    TabContent: {
        flow: 'y',
        gap: 'A',
        padding: 'B 0',
        minHeight: 'I',
        ProjectsPane: {
            hide: (el, s)=>(s.root?._profileTab || 'projects') !== 'projects',
            flow: 'y',
            gap: 'A',
            Empty: {
                hide: (el, s)=>el.scope.profileProjects(s.root).length > 0,
                tag: 'p',
                margin: '0',
                padding: 'A',
                textAlign: 'center',
                color: 'caption',
                fontSize: 'Z',
                text: '{{ account.userProfile.empty.projects | polyglot }}'
            },
            Grid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 320px), 1fr))',
                gap: 'A',
                childExtends: 'UserProfileProjectCard',
                childrenAs: 'state',
                children: (el, s)=>el.scope.profileProjects(s.root)
            }
        },
        IntegrationsPane: {
            hide: (el, s)=>(s.root?._profileTab || 'projects') !== 'integrations',
            flow: 'y',
            gap: 'Z',
            Empty: {
                hide: (el, s)=>el.scope.profileIntegrations(s.root, s.root?._profileViewed?.email).length > 0,
                tag: 'p',
                margin: '0',
                padding: 'A',
                textAlign: 'center',
                color: 'caption',
                fontSize: 'Z',
                text: '{{ account.userProfile.empty.integrations | polyglot }}'
            },
            List: {
                flow: 'y',
                gap: 'Z',
                childExtends: 'UserProfileIntegrationRow',
                childrenAs: 'state',
                children: (el, s)=>el.scope.profileIntegrations(s.root, s.root?._profileViewed?.email)
            }
        },
        AgentsPane: {
            hide: (el, s)=>(s.root?._profileTab || 'projects') !== 'agents',
            flow: 'y',
            gap: 'Z',
            Empty: {
                hide: (el, s)=>el.scope.profileAgents(s.root, s.root?._profileViewed?.email).length > 0,
                tag: 'p',
                margin: '0',
                padding: 'A',
                textAlign: 'center',
                color: 'caption',
                fontSize: 'Z',
                text: '{{ account.userProfile.empty.agents | polyglot }}'
            },
            List: {
                flow: 'y',
                gap: 'Z',
                childExtends: 'UserProfileIntegrationRow',
                childrenAs: 'state',
                children: (el, s)=>el.scope.profileAgents(s.root, s.root?._profileViewed?.email)
            }
        },
        FollowersPane: {
            hide: (el, s)=>(s.root?._profileTab || 'projects') !== 'followers',
            flow: 'y',
            gap: 'Z',
            Empty: {
                hide: (el, s)=>el.scope.profileFollows(s.root, s.root?._profileViewed?.email).followers.length > 0,
                tag: 'p',
                margin: '0',
                padding: 'A',
                textAlign: 'center',
                color: 'caption',
                fontSize: 'Z',
                text: '{{ account.userProfile.empty.followers | polyglot }}'
            },
            List: {
                flow: 'y',
                gap: 'Z',
                childExtends: 'UserProfileFollowRow',
                childrenAs: 'state',
                children: (el, s)=>el.scope.profileFollows(s.root, s.root?._profileViewed?.email).followers
            }
        },
        FollowingPane: {
            hide: (el, s)=>(s.root?._profileTab || 'projects') !== 'following',
            flow: 'y',
            gap: 'Z',
            Empty: {
                hide: (el, s)=>el.scope.profileFollows(s.root, s.root?._profileViewed?.email).following.length > 0,
                tag: 'p',
                margin: '0',
                padding: 'A',
                textAlign: 'center',
                color: 'caption',
                fontSize: 'Z',
                text: '{{ account.userProfile.empty.following | polyglot }}'
            },
            List: {
                flow: 'y',
                gap: 'Z',
                childExtends: 'UserProfileFollowRow',
                childrenAs: 'state',
                children: (el, s)=>el.scope.profileFollows(s.root, s.root?._profileViewed?.email).following
            }
        }
    }
};
const $dfc889e3a2ed30e4$export$c878c053d8e0e282 = {
    tag: 'button',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: 'Z A',
    fontSize: 'Z',
    fontWeight: '700',
    // Was `position: 'relative'` to host the Underline child below — dead
    // once that's gone.
    color: (el, s)=>(s.root?._profileTab || 'projects') === s.key ? 'title' : 'caption',
    ':hover': {
        color: 'title'
    },
    text: (el, s)=>el.call('polyglot', s.label || ''),
    onClick: (e, el, s)=>s.root?.update({
            _profileTab: s.key
        })
};
const $dfc889e3a2ed30e4$export$4aaf3b4c2e0abf44 = {
    // FA204 / frank trap — see UserProfile.scope above for the full note.
    // `gradientFor` is only needed here, so it's not duplicated anywhere else.
    scope: {
        gradientFor (id) {
            let h = 0;
            for(let i = 0; i < (id || '').length; i++)h = h * 31 + id.charCodeAt(i) >>> 0;
            const hue = h % 360;
            return `linear-gradient(135deg, hsl(${hue} 60% 38%) 0%, hsl(${(hue + 50) % 360} 55% 22%) 100%)`;
        }
    },
    flow: 'y',
    gap: '0',
    borderRadius: 'Z',
    overflow: 'hidden',
    // Was a full `hairline solid line` outline — a card outline, banned by
    // design-direction.md §8's ban list. `background: 'dialog'` (an opaque,
    // one-step-up surface, DESIGN_LANGUAGE §2.2) already separates the card
    // from its grid without a stroke.
    background: 'dialog',
    cursor: 'pointer',
    transition: '180ms defaultBezier box-shadow, 180ms defaultBezier transform',
    // Hover swaps the accent-border cue for the real elevation token instead
    // (§2.3 — `float` is exactly the "floating/lifting card" moment) rather
    // than reintroducing a stroke.
    ':hover': {
        shadow: 'float',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        const owner = s.workspace?.organization?.slug || s.workspace?.slug || '';
        const key = s.key || '';
        if (owner && key && typeof window !== 'undefined') window.open(`/${owner}/${key}`, '_self');
    },
    Cover: {
        aspectRatio: '16 / 9',
        width: '100%',
        background: (el, s)=>{
            const owner = s.workspace?.organization?.slug || s.workspace?.slug || '';
            const key = s.key || '';
            const grad = el.scope.gradientFor(`${owner}/${key}`);
            const url = owner && key ? (0, $eVQcI.projectScreenshotUrl)({
                owner: owner,
                key: key
            }) || '' : '';
            if (url) return `url("${url}") center / cover no-repeat, ${grad}`;
            return grad;
        },
        __order: [
            'aspectRatio',
            'width',
            'background'
        ]
    },
    Body: {
        flow: 'y',
        gap: 'V',
        padding: 'Z A',
        Name: {
            tag: 'h4',
            margin: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.name || s.key || ''
        },
        Desc: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.description || ''
        }
    }
};
const $dfc889e3a2ed30e4$export$513685da8a00fc3 = {
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    borderRadius: 'Z',
    // Was a card-outline `hairline solid line` border — banned (design-
    // direction.md §8). The row already sits in a `gap`-spaced list AND
    // carries its own opaque `background: 'dialog'` fill, so the border was
    // fully redundant with the separation the fill+gap already provide.
    background: 'dialog',
    Icon: {
        align: 'center center',
        width: 'B',
        height: 'B',
        minWidth: 'B',
        borderRadius: 'Y',
        background: 'overlay',
        color: 'title',
        fontWeight: '700',
        fontSize: 'A',
        text: (el, s)=>(s.name || '?')[0].toUpperCase()
    },
    Body: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        Name: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.name || ''
        },
        Desc: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            text: (el, s)=>s.description || ''
        }
    }
};
const $dfc889e3a2ed30e4$export$d6f6805468308970 = {
    // FA204 / frank trap — see UserProfile.scope above for the full note.
    // readFollows/writeFollows/isFollowing/toggleFollow/isSelf are
    // DUPLICATED from UserProfile's own scope — `el.scope` doesn't resolve
    // across sibling top-level exports in this file, only within the tree of
    // the export it's declared on.
    scope: {
        readFollows () {
            if (typeof localStorage === 'undefined') return [];
            try {
                const raw = localStorage.getItem('marketplace.follows');
                return Array.isArray(JSON.parse(raw || '[]')) ? JSON.parse(raw) : [];
            } catch  {
                return [];
            }
        },
        writeFollows (list) {
            if (typeof localStorage === 'undefined') return;
            try {
                localStorage.setItem('marketplace.follows', JSON.stringify(list));
            } catch  {}
        },
        isFollowing (root, email) {
            if (!root || !email) return false;
            return (root.followingEmails || []).map((e)=>(e || '').toLowerCase()).includes(email.toLowerCase());
        },
        toggleFollow (root, email) {
            if (!root || !email) return;
            const cur = (root.followingEmails || this.readFollows()).map((e)=>(e || '').toLowerCase());
            const lower = email.toLowerCase();
            const next = cur.includes(lower) ? cur.filter((e)=>e !== lower) : [
                ...cur,
                lower
            ];
            root.update({
                followingEmails: next
            });
            this.writeFollows(next);
        },
        isSelf (root, email) {
            if (!root) return false;
            const viewed = root._profileViewed || {};
            if (viewed._isSelf) return true;
            const meId = (root.currentUserId || '').toString();
            const viewedId = (viewed.userId || viewed.id || viewed._id || '').toString();
            if (meId && viewedId && meId === viewedId) return true;
            const meEmail = (root.currentUserEmail || '').toLowerCase();
            const cmp = (email || viewed.email || '').toLowerCase();
            if (!cmp) return false;
            return meEmail === cmp;
        }
    },
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Z',
    borderRadius: 'Z',
    Avatar: {
        align: 'center center',
        boxSize: 'B',
        minWidth: 'B',
        round: '50%',
        cursor: 'pointer',
        src: (el, s)=>el.call('avatarUrlFor', s.email),
        onClick: (e, el, s)=>{
            const slug = (s.email || '').split('@')[0];
            if (slug && typeof window !== 'undefined') {
                window.history.pushState({}, '', `/user/${slug}`);
                // `window.PopStateEvent` (not the bare global) — frank's
                // known-globals allowlist doesn't recognize `PopStateEvent` by name;
                // same object, just resolved off the already-guarded `window`.
                window.dispatchEvent(new window.PopStateEvent('popstate'));
            }
        }
    },
    Meta: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>el.call('polyglot', s.name || '') || (s.email || '').split('@')[0]
        },
        Email: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            text: (el, s)=>s.email || ''
        }
    },
    FollowBtn: {
        extends: 'Button',
        hide: (el, s)=>{
            if (!s.email) return true;
            return el.scope.isSelf(s.root, s.email);
        },
        padding: 'X A',
        borderRadius: 'Y',
        fontSize: 'Y',
        fontWeight: '700',
        cursor: 'pointer',
        // Was an outlined button — same fix + rationale as Hero's FollowBtn.
        background: (el, s)=>el.scope.isFollowing(s.root, s.email) ? 'overlay' : 'blue',
        color: (el, s)=>el.scope.isFollowing(s.root, s.email) ? 'caption' : 'fillInk',
        text: (el, s)=>el.call('polyglot', el.scope.isFollowing(s.root, s.email) ? 'account.userProfile.following' : 'account.userProfile.follow'),
        onClick: (e, el, s)=>el.scope.toggleFollow(s.root, s.email)
    }
};

});
parcelRegister("76fm2", function(module, exports) {

$parcel$export(module.exports, "peopleByEmail", () => $52b50104a988e30b$export$382bec5fef9c5392);
$parcel$export(module.exports, "firstName", () => $52b50104a988e30b$export$6514a1206b6ef315);
$parcel$export(module.exports, "findPerson", () => $52b50104a988e30b$export$9cba0ebbc6894563);
$parcel$export(module.exports, "avatarUrl", () => $52b50104a988e30b$export$3e7937c9301724ed);
$parcel$export(module.exports, "avatarUrlFor", () => $52b50104a988e30b$export$a2abf70522ed0b3b);
$parcel$export(module.exports, "activeMembers", () => $52b50104a988e30b$export$622cce44779cc764);
$parcel$export(module.exports, "isSelf", () => $52b50104a988e30b$export$b56c5b9b8805de6e);
$parcel$export(module.exports, "viewedEmail", () => $52b50104a988e30b$export$2e8b924842b44174);
$parcel$export(module.exports, "patchPeopleList", () => $52b50104a988e30b$export$14c217f4f9e1b27c);
$parcel$export(module.exports, "viewedPerson", () => $52b50104a988e30b$export$b34bfb05be6e8cb0);
$parcel$export(module.exports, "findMe", () => $52b50104a988e30b$export$60234ffb840d2c6b);
// People lookup helpers. WeakMap-cached by root.people identity for O(1) lookups.
//
// FA204 / frank trap — _ensureMap/_fuzzyMatch/_peopleByEmailCache/
// _fuzzyByPrefixCache/_ACTIVE_ROLES/_ACTIVE_TEAM_CATEGORIES/
// _activeMembersCache used to live at module scope, referenced bare from
// every export below. Each export now carries its own self-contained inline
// copy of the pure helpers/tables. The WeakMap memoization caches are
// GENUINE cross-call state (their whole point is to survive across
// separate peopleByEmail/findPerson/activeMembers calls) with no argument-
// less escape hatch available — every caller here DOES receive/derive a
// real `root`, so each cache is re-homed onto `root.__peopleUtilsCache`
// (lazily created), the same `root.__x` idiom as navbarTabMenu.js's
// `root.__navbarSaveQueue`, instead of a fresh-per-call WeakMap (which
// would still be correct but would never hit — no different from dropping
// the cache outright).
// All functions support both direct calls (fn(root, ...)) and el.call('fn', ...) where
// root is inferred from this.state.root when omitted.
function $52b50104a988e30b$export$382bec5fef9c5392(root) {
    function _ensureMap(root, people) {
        if (!people || !people.length) return Object.freeze({});
        let bag = root && root.__peopleUtilsCache;
        if (root && !bag) bag = root.__peopleUtilsCache = {};
        let cache = bag ? bag.byEmail : null;
        if (cache && typeof cache.get !== 'function') cache = null;
        if (bag && !cache) cache = bag.byEmail = new WeakMap();
        let cached = cache && cache.get(people);
        if (cached) return cached;
        cached = Object.create(null);
        for (const p of people)if (p && p.email) cached[p.email] = p;
        if (cache) cache.set(people, cached);
        return cached;
    }
    const r = root != null ? root : this && this.state && this.state.root;
    return _ensureMap(r, r && r.people || null);
}
const $52b50104a988e30b$export$6514a1206b6ef315 = (name, fallback = '')=>(name || '').split(/\s+/)[0] || name || fallback;
function $52b50104a988e30b$export$9cba0ebbc6894563(rootOrEmail, maybeEmail) {
    function _ensureMap(root, people) {
        if (!people || !people.length) return Object.freeze({});
        let bag = root && root.__peopleUtilsCache;
        if (root && !bag) bag = root.__peopleUtilsCache = {};
        let cache = bag ? bag.byEmail : null;
        if (cache && typeof cache.get !== 'function') cache = null;
        if (bag && !cache) cache = bag.byEmail = new WeakMap();
        let cached = cache && cache.get(people);
        if (cached) return cached;
        cached = Object.create(null);
        for (const p of people)if (p && p.email) cached[p.email] = p;
        if (cache) cache.set(people, cached);
        return cached;
    }
    // Fuzzy match by email prefix when exact lookup fails. Matches the part
    // before `@` against each person's name first-word or email prefix. Used
    // so chat messages from aliased emails (e.g. tornike@symbols.app when the
    // record is svinchy@symbols.app / Tornike Svintradze) still resolve to the
    // person's full name.
    function _fuzzyMatch(root, people, email) {
        if (!people || !people.length || !email) return null;
        const at = email.indexOf('@');
        if (at < 2) return null;
        const prefix = email.slice(0, at).toLowerCase();
        const domain = email.slice(at + 1).toLowerCase();
        let bag = root && root.__peopleUtilsCache;
        if (root && !bag) bag = root.__peopleUtilsCache = {};
        let cache = bag ? bag.fuzzyByPrefix : null;
        if (cache && typeof cache.get !== 'function') cache = null;
        if (bag && !cache) cache = bag.fuzzyByPrefix = new WeakMap();
        let cached = cache && cache.get(people);
        if (!cached) {
            cached = Object.create(null);
            for (const p of people){
                if (!p || !p.email) continue;
                const pAt = p.email.indexOf('@');
                if (pAt < 0) continue;
                const pPrefix = p.email.slice(0, pAt).toLowerCase();
                const pDomain = p.email.slice(pAt + 1).toLowerCase();
                cached[pPrefix + '@' + pDomain] = p;
                cached[pPrefix] = p;
                const first = (p.name || '').split(/\s+/)[0] || p.name || '';
                if (first) cached[first.toLowerCase()] = cached[first.toLowerCase()] || p;
            }
            if (cache) cache.set(people, cached);
        }
        return cached[prefix + '@' + domain] || cached[prefix] || null;
    }
    if (typeof rootOrEmail === 'string' && maybeEmail === undefined) {
        const root = this && this.state && this.state.root;
        if (!root) return null;
        const scoped = root.people || null;
        const full = root.peopleAll || null;
        return _ensureMap(root, scoped)[rootOrEmail] || _fuzzyMatch(root, scoped, rootOrEmail) || _ensureMap(root, full)[rootOrEmail] || _fuzzyMatch(root, full, rootOrEmail) || null;
    }
    if (!rootOrEmail || !maybeEmail) return null;
    const scoped = rootOrEmail.people || null;
    const full = rootOrEmail.peopleAll || null;
    return _ensureMap(rootOrEmail, scoped)[maybeEmail] || _fuzzyMatch(rootOrEmail, scoped, maybeEmail) || _ensureMap(rootOrEmail, full)[maybeEmail] || _fuzzyMatch(rootOrEmail, full, maybeEmail) || null;
}
const $52b50104a988e30b$export$3e7937c9301724ed = (seed)=>`https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(seed || '?')}`;
function $52b50104a988e30b$export$a2abf70522ed0b3b(root, email) {
    // FA204 / frank trap — self-contained inline copy of findPerson/avatarUrl,
    // see the file header. Kept identical to the exports above.
    function _findPerson(rootOrEmail, maybeEmail, thisArg) {
        function _ensureMap(root, people) {
            if (!people || !people.length) return Object.freeze({});
            let bag = root && root.__peopleUtilsCache;
            if (root && !bag) bag = root.__peopleUtilsCache = {};
            let cache = bag ? bag.byEmail : null;
            if (cache && typeof cache.get !== 'function') cache = null;
            if (bag && !cache) cache = bag.byEmail = new WeakMap();
            let cached = cache && cache.get(people);
            if (cached) return cached;
            cached = Object.create(null);
            for (const p of people)if (p && p.email) cached[p.email] = p;
            if (cache) cache.set(people, cached);
            return cached;
        }
        function _fuzzyMatch(root, people, email) {
            if (!people || !people.length || !email) return null;
            const at = email.indexOf('@');
            if (at < 2) return null;
            const prefix = email.slice(0, at).toLowerCase();
            const domain = email.slice(at + 1).toLowerCase();
            let bag = root && root.__peopleUtilsCache;
            if (root && !bag) bag = root.__peopleUtilsCache = {};
            let cache = bag ? bag.fuzzyByPrefix : null;
            if (cache && typeof cache.get !== 'function') cache = null;
            if (bag && !cache) cache = bag.fuzzyByPrefix = new WeakMap();
            let cached = cache && cache.get(people);
            if (!cached) {
                cached = Object.create(null);
                for (const p of people){
                    if (!p || !p.email) continue;
                    const pAt = p.email.indexOf('@');
                    if (pAt < 0) continue;
                    const pPrefix = p.email.slice(0, pAt).toLowerCase();
                    const pDomain = p.email.slice(pAt + 1).toLowerCase();
                    cached[pPrefix + '@' + pDomain] = p;
                    cached[pPrefix] = p;
                    const first = (p.name || '').split(/\s+/)[0] || p.name || '';
                    if (first) cached[first.toLowerCase()] = cached[first.toLowerCase()] || p;
                }
                if (cache) cache.set(people, cached);
            }
            return cached[prefix + '@' + domain] || cached[prefix] || null;
        }
        if (typeof rootOrEmail === 'string' && maybeEmail === undefined) {
            const root = thisArg && thisArg.state && thisArg.state.root;
            if (!root) return null;
            const scoped = root.people || null;
            const full = root.peopleAll || null;
            return _ensureMap(root, scoped)[rootOrEmail] || _fuzzyMatch(root, scoped, rootOrEmail) || _ensureMap(root, full)[rootOrEmail] || _fuzzyMatch(root, full, rootOrEmail) || null;
        }
        if (!rootOrEmail || !maybeEmail) return null;
        const scoped = rootOrEmail.people || null;
        const full = rootOrEmail.peopleAll || null;
        return _ensureMap(rootOrEmail, scoped)[maybeEmail] || _fuzzyMatch(rootOrEmail, scoped, maybeEmail) || _ensureMap(rootOrEmail, full)[maybeEmail] || _fuzzyMatch(rootOrEmail, full, maybeEmail) || null;
    }
    function _avatarUrl(seed) {
        return `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(seed || '?')}`;
    }
    let r = root, e = email;
    if (typeof root === 'string' && email === undefined) {
        e = root;
        r = this && this.state && this.state.root;
    }
    const p = _findPerson(r, e, this);
    return _avatarUrl(p && p.name || e);
}
function $52b50104a988e30b$export$622cce44779cc764(root) {
    const ACTIVE_ROLES = new Set([
        'member',
        'manager',
        'admin',
        'superadmin'
    ]);
    // Team categories that count as ACTIVE membership (Nika's 2026-06-06 model:
    // "a member is active when they belong to ≥1 active-status team"). Mirrors
    // peopleGroups.isActiveTeamCategory + team-and-agents _INACTIVE_CATEGORIES.
    const ACTIVE_TEAM_CATEGORIES = new Set([
        'active',
        'manager'
    ]);
    const r = root != null ? root : this && this.state && this.state.root;
    const people = r && r.people || [];
    if (!people.length) return people;
    const byUser = r?.roles?.byUser || {};
    // Cache key must incorporate byUser since it changes when roles load.
    // Use a two-key WeakMap trick: cache on people array, invalidate when
    // byUser reference changes via version bump (root.roles.version) OR when
    // teamsByEmail changes (a membership move doesn't bump roles.version, but
    // it DOES change active/inactive membership — see the team check below).
    const version = r?.roles?.version ?? 0;
    const teamsByEmail = r?.teamsByEmail || null;
    // Primary membership index — keyed on the stable non-PII userId that rides
    // every roster row. A non-mgmt viewer's rows carry NO email (server
    // memberProjection.js), so the email map can never match for them; joining
    // id-first restores team resolution platform-wide (tickets/fable.md P0
    // regression) while the email map stays as the mgmt/optimistic fallback.
    const teamsByUserId = r?.teamsByUserId || null;
    let bag = r && r.__peopleUtilsCache;
    if (r && !bag) bag = r.__peopleUtilsCache = {};
    let cache = bag ? bag.activeMembers : null;
    if (cache && typeof cache.get !== 'function') cache = null;
    if (bag && !cache) cache = bag.activeMembers = new WeakMap();
    let cached = cache && cache.get(people);
    if (cached && cached.version === version && cached.teamsByEmail === teamsByEmail && cached.teamsByUserId === teamsByUserId) return cached.result;
    const result = people.filter((p)=>{
        // Status check FIRST — `status: 'left'` (departed) and `'inactive'`
        // (read-only access) both drop the person from active-members lists
        // (calendar columns, sidebar PeopleSection TEAM group, chat/meet pickers).
        if (p.status === 'left' || p.status === 'inactive') return false;
        // Team-based inactivity (Nika's model): when a person's team memberships
        // are loaded and NONE is an active/manager team, they're inactive —
        // e.g. only in Class B/C / external / archived teams. This is how
        // advisors/investors/shareholders get dropped from calendar columns,
        // chat/meet pickers, and the sidebar TEAM group, consistent with
        // /team-members + /team-and-agents. Skipped when no membership data has
        // loaded for them yet, to avoid over-excluding during the boot window.
        if (teamsByUserId || teamsByEmail) {
            // id-first (works for non-mgmt viewers whose rows have no email),
            // email fallback (mgmt viewers + optimistic writes keyed by email).
            const byId = teamsByUserId && p.userId != null ? teamsByUserId[String(p.userId)] : null;
            const memberships = Array.isArray(byId) && byId.length && byId || teamsByEmail && teamsByEmail[String(p.email || '').toLowerCase()];
            if (Array.isArray(memberships) && memberships.length && !memberships.some((m)=>m && ACTIVE_TEAM_CATEGORIES.has(m.category))) return false;
        }
        // Legacy fallback: person still has .roles from a pre-§90 render.
        if (Array.isArray(p.roles) && p.roles.length > 0) return p.roles.some((role)=>ACTIVE_ROLES.has(role));
        const assignedRole = byUser[p.userId] || 'member';
        return ACTIVE_ROLES.has(assignedRole);
    });
    if (cache) cache.set(people, {
        version: version,
        teamsByEmail: teamsByEmail,
        teamsByUserId: teamsByUserId,
        result: result
    });
    return result;
}
function $52b50104a988e30b$export$b56c5b9b8805de6e(s) {
    const state = s != null ? s : this && this.state;
    const root = state && state.root;
    if (!root) return true;
    const viewed = typeof window !== 'undefined' ? new URLSearchParams(window.location && window.location.search || '').get('u') : null;
    return !viewed || viewed === root.currentUserEmail;
}
const $52b50104a988e30b$export$2e8b924842b44174 = (s)=>{
    const fromQuery = typeof window !== 'undefined' ? new URLSearchParams(window.location && window.location.search || '').get('u') : null;
    return fromQuery || s && s.root && s.root.currentUserEmail || '';
};
const $52b50104a988e30b$export$14c217f4f9e1b27c = (list, userId, patch)=>(list || []).map((p)=>p.userId === userId ? {
            ...p,
            ...patch
        } : p);
const $52b50104a988e30b$export$b34bfb05be6e8cb0 = (s, { allowQuery: allowQuery = false } = {})=>{
    // FA204 / frank trap — self-contained inline copies of viewedEmail/
    // findPerson, see the file header.
    function _viewedEmail(s) {
        const fromQuery = typeof window !== 'undefined' ? new URLSearchParams(window.location && window.location.search || '').get('u') : null;
        return fromQuery || s && s.root && s.root.currentUserEmail || '';
    }
    function _findPerson(root, email) {
        function _ensureMap(root, people) {
            if (!people || !people.length) return Object.freeze({});
            let bag = root && root.__peopleUtilsCache;
            if (root && !bag) bag = root.__peopleUtilsCache = {};
            let cache = bag ? bag.byEmail : null;
            if (cache && typeof cache.get !== 'function') cache = null;
            if (bag && !cache) cache = bag.byEmail = new WeakMap();
            let cached = cache && cache.get(people);
            if (cached) return cached;
            cached = Object.create(null);
            for (const p of people)if (p && p.email) cached[p.email] = p;
            if (cache) cache.set(people, cached);
            return cached;
        }
        function _fuzzyMatch(root, people, email) {
            if (!people || !people.length || !email) return null;
            const at = email.indexOf('@');
            if (at < 2) return null;
            const prefix = email.slice(0, at).toLowerCase();
            const domain = email.slice(at + 1).toLowerCase();
            let bag = root && root.__peopleUtilsCache;
            if (root && !bag) bag = root.__peopleUtilsCache = {};
            let cache = bag ? bag.fuzzyByPrefix : null;
            if (cache && typeof cache.get !== 'function') cache = null;
            if (bag && !cache) cache = bag.fuzzyByPrefix = new WeakMap();
            let cached = cache && cache.get(people);
            if (!cached) {
                cached = Object.create(null);
                for (const p of people){
                    if (!p || !p.email) continue;
                    const pAt = p.email.indexOf('@');
                    if (pAt < 0) continue;
                    const pPrefix = p.email.slice(0, pAt).toLowerCase();
                    const pDomain = p.email.slice(pAt + 1).toLowerCase();
                    cached[pPrefix + '@' + pDomain] = p;
                    cached[pPrefix] = p;
                    const first = (p.name || '').split(/\s+/)[0] || p.name || '';
                    if (first) cached[first.toLowerCase()] = cached[first.toLowerCase()] || p;
                }
                if (cache) cache.set(people, cached);
            }
            return cached[prefix + '@' + domain] || cached[prefix] || null;
        }
        if (!root || !email) return null;
        const scoped = root.people || null;
        const full = root.peopleAll || null;
        return _ensureMap(root, scoped)[email] || _fuzzyMatch(root, scoped, email) || _ensureMap(root, full)[email] || _fuzzyMatch(root, full, email) || null;
    }
    const root = s && s.root;
    if (!root) return null;
    const email = allowQuery ? _viewedEmail(s) : root.currentUserEmail;
    return _findPerson(root, email);
};
const $52b50104a988e30b$export$60234ffb840d2c6b = (s, { allowQuery: allowQuery = true } = {})=>{
    return $52b50104a988e30b$export$b34bfb05be6e8cb0(s, {
        allowQuery: allowQuery
    }) || $52b50104a988e30b$export$9cba0ebbc6894563(s && s.root, s && s.root && s.root.currentUserEmail) || {};
};

});

parcelRegister("lUr30", function(module, exports) {

$parcel$export(module.exports, "getMe", () => $ff33cefb5fdd4ae2$export$dd7946daa6163e94);
$parcel$export(module.exports, "login", () => $ff33cefb5fdd4ae2$export$596d806903d1f59e);
$parcel$export(module.exports, "sdkLogout", () => $ff33cefb5fdd4ae2$export$f2a9f997ac690fb6);
$parcel$export(module.exports, "isAuthenticated", () => $ff33cefb5fdd4ae2$export$83d11f23a23d4a7c);
$parcel$export(module.exports, "readCachedUserProfile", () => $ff33cefb5fdd4ae2$export$a24ab8240260af13);
$parcel$export(module.exports, "readCachedOrgs", () => $ff33cefb5fdd4ae2$export$c786d21d507f22d7);
$parcel$export(module.exports, "getUserProfileCached", () => $ff33cefb5fdd4ae2$export$6818d085173e34c9);
$parcel$export(module.exports, "listOrganizationsCached", () => $ff33cefb5fdd4ae2$export$f6a9c14df9bfd7f6);
$parcel$export(module.exports, "invalidateUserDataCache", () => $ff33cefb5fdd4ae2$export$79e8e60799502aab);
$parcel$export(module.exports, "fetchPublicProjectFromSDK", () => $ff33cefb5fdd4ae2$export$70dbaf04604f685);
$parcel$export(module.exports, "fetchPublicProjectVisibilityFromSDK", () => $ff33cefb5fdd4ae2$export$1d28c40907c073c9);
$parcel$export(module.exports, "unlockPublicProjectFromSDK", () => $ff33cefb5fdd4ae2$export$e034e50a1c9f351e);
$parcel$export(module.exports, "fetchProjectFromSDK", () => $ff33cefb5fdd4ae2$export$d3c48d303d08f280);
$parcel$export(module.exports, "envCfgCacheKey", () => $ff33cefb5fdd4ae2$export$f67160ad60e7d39b);
$parcel$export(module.exports, "resolveEnvPublishConfig", () => $ff33cefb5fdd4ae2$export$170e607e5e4505d9);
$parcel$export(module.exports, "getSDK", () => (parcelRequire("1NxyO")).getSDK);
$parcel$export(module.exports, "awaitSDKInit", () => (parcelRequire("1NxyO")).awaitSDKInit);
$parcel$export(module.exports, "awaitCrossAppHydration", () => (parcelRequire("1NxyO")).awaitCrossAppHydration);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");

var $1NxyO = parcelRequire("1NxyO");
async function $ff33cefb5fdd4ae2$export$dd7946daa6163e94(opts) {
    const result = await (0, $1NxyO.getSDK)(opts).getMe();
    return result?.data || null;
}
async function $ff33cefb5fdd4ae2$export$596d806903d1f59e(email, password, opts) {
    return (0, $1NxyO.getSDK)(opts).login(email, password);
}
async function $ff33cefb5fdd4ae2$export$f2a9f997ac690fb6(opts) {
    return (0, $1NxyO.getSDK)(opts).logout();
}
function $ff33cefb5fdd4ae2$export$83d11f23a23d4a7c(opts) {
    return (0, $1NxyO.getSDK)(opts).isReady();
}
function $ff33cefb5fdd4ae2$export$a24ab8240260af13() {
    const USER_PROFILE_KEY = '__canvas_user_profile_v1';
    function readCache(key) {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return null;
            const entry = JSON.parse(raw);
            if (!entry?.at) return null;
            return entry;
        } catch  {
            return null;
        }
    }
    return readCache(USER_PROFILE_KEY)?.data || null;
}
function $ff33cefb5fdd4ae2$export$c786d21d507f22d7() {
    const USER_ORGS_KEY = '__canvas_user_orgs_v1';
    function readCache(key) {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return null;
            const entry = JSON.parse(raw);
            if (!entry?.at) return null;
            return entry;
        } catch  {
            return null;
        }
    }
    return readCache(USER_ORGS_KEY)?.data || null;
}
async function $ff33cefb5fdd4ae2$export$6818d085173e34c9(opts) {
    function sdkUserDataCache() {
        return globalThis.__sdkUserDataCache = globalThis.__sdkUserDataCache || {
            userProfilePromise: null,
            userOrgsPromise: null
        };
    }
    const USER_PROFILE_TTL_MS = 300000;
    const USER_PROFILE_KEY = '__canvas_user_profile_v1';
    function readCache(key) {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return null;
            const entry = JSON.parse(raw);
            if (!entry?.at) return null;
            return entry;
        } catch  {
            return null;
        }
    }
    function writeCache(key, data) {
        try {
            localStorage.setItem(key, JSON.stringify({
                at: Date.now(),
                data: data
            }));
        } catch  {}
    }
    const cache = sdkUserDataCache();
    const entry = readCache(USER_PROFILE_KEY);
    if (entry && Date.now() - entry.at < USER_PROFILE_TTL_MS) return entry.data;
    if (cache.userProfilePromise) return cache.userProfilePromise;
    const sdk = (0, $1NxyO.getSDK)(opts);
    cache.userProfilePromise = Promise.resolve(sdk.getUserProfile()).then((r)=>{
        const data = r?.data || r || null;
        if (data) writeCache(USER_PROFILE_KEY, data);
        return data;
    }).catch((err)=>{
        // Fall back to stale cache on 429/network errors — stale user data
        // beats a broken dashboard. Only re-throw when we have nothing.
        if (entry?.data) return entry.data;
        throw err;
    }).finally(()=>{
        cache.userProfilePromise = null;
    });
    return cache.userProfilePromise;
}
async function $ff33cefb5fdd4ae2$export$f6a9c14df9bfd7f6(opts) {
    function sdkUserDataCache() {
        return globalThis.__sdkUserDataCache = globalThis.__sdkUserDataCache || {
            userProfilePromise: null,
            userOrgsPromise: null
        };
    }
    const USER_ORGS_TTL_MS = 300000;
    const USER_ORGS_KEY = '__canvas_user_orgs_v1';
    function readCache(key) {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return null;
            const entry = JSON.parse(raw);
            if (!entry?.at) return null;
            return entry;
        } catch  {
            return null;
        }
    }
    function writeCache(key, data) {
        try {
            localStorage.setItem(key, JSON.stringify({
                at: Date.now(),
                data: data
            }));
        } catch  {}
    }
    const cache = sdkUserDataCache();
    const entry = readCache(USER_ORGS_KEY);
    if (entry && Date.now() - entry.at < USER_ORGS_TTL_MS) return entry.data;
    if (cache.userOrgsPromise) return cache.userOrgsPromise;
    const sdk = (0, $1NxyO.getSDK)(opts);
    cache.userOrgsPromise = Promise.resolve(sdk.listOrganizations()).then((r)=>{
        const data = Array.isArray(r) ? r : r?.data || r?.organizations || [];
        writeCache(USER_ORGS_KEY, data);
        return data;
    }).catch((err)=>{
        if (entry?.data) return entry.data;
        throw err;
    }).finally(()=>{
        cache.userOrgsPromise = null;
    });
    return cache.userOrgsPromise;
}
function $ff33cefb5fdd4ae2$export$79e8e60799502aab() {
    function sdkUserDataCache() {
        return globalThis.__sdkUserDataCache = globalThis.__sdkUserDataCache || {
            userProfilePromise: null,
            userOrgsPromise: null
        };
    }
    try {
        for(let i = localStorage.length - 1; i >= 0; i--){
            const k = localStorage.key(i);
            if (k && k.startsWith('__canvas_')) localStorage.removeItem(k);
        }
    } catch  {}
    const cache = sdkUserDataCache();
    cache.userProfilePromise = null;
    cache.userOrgsPromise = null;
}
// ── Project ─────────────────────────────────────────────────────────────────
// A project payload's `globalScope` bag needs the platform's closure-eval
// revival (destringifyGlobalScope, smbls/packages/utils/object.js — every
// sibling constant/helper declared as a `var` in ONE shared closure, exactly
// what createDomql.js gives a standalone project boot), never the generic
// per-string eval deepDestringifyFunctions gives every other payload field.
// Capture the bag RAW (still frank-serialized strings) before the generic
// walk below consumes it — once deepDestringifyFunctions has run, each
// helper is already a standalone function and the resolver has nothing left
// to build a closure around, so a helper reading a sibling constant/helper
// throws ReferenceError only when called, not when checked
// (FW-GLOBALSCOPE-HELPER-CLOSURE-LOST-IN-PAYLOAD-REVIVE-1).
//
// `deferRevive` (workspace boot fix step 4): top-level parts named here come
// back RAW — still frank strings — for a caller that revives each entry on its
// first read (the workspace app loader: components are 60 % of an app's code
// revive, measured 2026-09-29). Every other part is revived as before, and a
// caller that does not ask gets the whole payload revived, unchanged.
const $ff33cefb5fdd4ae2$var$_reviveProjectPayload = (data, deferRevive)=>{
    const rawGlobalScope = data && typeof data === 'object' ? data.globalScope : null;
    const defer = Array.isArray(deferRevive) && data && typeof data === 'object' ? deferRevive.filter((part)=>Object.prototype.hasOwnProperty.call(data, part)) : [];
    let revived;
    if (defer.length) {
        const eager = {};
        for (const part of Object.keys(data))if (!defer.includes(part)) eager[part] = data[part];
        revived = (0, $2C0hZ.deepDestringifyFunctions)(eager);
        for (const part of defer)revived[part] = data[part];
    } else revived = (0, $2C0hZ.deepDestringifyFunctions)(data);
    if (rawGlobalScope && typeof rawGlobalScope === 'object' && revived) revived.globalScope = (0, $2C0hZ.destringifyGlobalScope)(rawGlobalScope);
    return revived;
};
async function $ff33cefb5fdd4ae2$export$70dbaf04604f685(owner, key, { envKey: envKey, raw: raw = false, ...sdkOpts } = {}) {
    // Owner + key or nothing: a bare key can name several owners' projects
    // (the public by-key routes answer it 409 ambiguous_key). Every caller has
    // the owner; one without it reads nothing rather than another owner's site.
    if (!envKey || !owner || !key) return null;
    const sdk = (0, $1NxyO.getSDK)(sdkOpts);
    const result = await sdk.getPublicProjectDataByKey({
        owner: owner,
        key: key
    }, {
        envKey: envKey
    });
    const data = result?.data || result;
    if (!data) return null;
    return typeof data === 'string' || raw ? data : $ff33cefb5fdd4ae2$var$_reviveProjectPayload(data);
}
async function $ff33cefb5fdd4ae2$export$1d28c40907c073c9(owner, key, sdkOpts = {}) {
    if (!owner || !key) return null;
    const sdk = (0, $1NxyO.getSDK)(sdkOpts);
    return sdk.getPublicProjectVisibility({
        owner: owner,
        key: key
    });
}
async function $ff33cefb5fdd4ae2$export$e034e50a1c9f351e(owner, key, { envKey: envKey, password: password, raw: raw = false, ...sdkOpts } = {}) {
    if (!envKey || !password || !owner || !key) return null;
    const sdk = (0, $1NxyO.getSDK)(sdkOpts);
    const result = await sdk.unlockPublicProjectDataByKey({
        owner: owner,
        key: key
    }, {
        envKey: envKey,
        password: password
    });
    const data = result?.data || result;
    if (!data) return null;
    return typeof data === 'string' || raw ? data : $ff33cefb5fdd4ae2$var$_reviveProjectPayload(data);
}
async function $ff33cefb5fdd4ae2$export$d3c48d303d08f280(owner, key, options = {}) {
    const sdk = (0, $1NxyO.getSDK)(options);
    const result = await sdk.getProjectDataByKey({
        owner: owner,
        key: key
    }, {
        branch: options.branch || 'main',
        version: options.version || 'latest',
        // Workspace-module read grant (GA onboarding): membership of the
        // workspace that INSTALLED this project authorizes the read, so
        // invited members without a project-level role can still load the
        // module. Older sdk/server pairs ignore the extra key harmlessly.
        ...options.workspaceId ? {
            workspaceId: options.workspaceId
        } : {}
    });
    const data = result?.data || result;
    if (!data) return null;
    // WS-MODULE-PAYLOAD-CACHE-1 (BF-SIGNIN-LAYOUT-LATENCY-1): write-through
    // persistent cache for the workspace-module payload. This is the ONLY
    // seam where the PRE-revive payload exists (function fields still
    // frank-serialized strings), so caching is a plain JSON round-trip —
    // never a re-frank of live functions. The caller names the slot
    // (payloadCacheKey); identity (owner/key/branch) and the payload's own
    // version ride inside the row. A write failure must never break the
    // fetch — and a half-written slot must never survive to serve.
    if (options.payloadCacheKey && data && typeof data === 'object') try {
        globalThis.localStorage?.setItem(options.payloadCacheKey, JSON.stringify({
            v: 1,
            at: Date.now(),
            wsId: options.workspaceId || null,
            owner: owner,
            key: key,
            branch: options.branch || 'main',
            version: data.version || data.latestVersion || null,
            data: data
        }));
    } catch (_) {
        try {
            globalThis.localStorage?.removeItem(options.payloadCacheKey);
        } catch (_2) {}
    }
    // `options.raw` — see fetchPublicProjectFromSDK (security review B3).
    // `options.revive === false` — a background cache refresh needs only the
    // serialized payload and version. Skip compilation there; the next
    // foreground load revives what it uses.
    return typeof data === 'string' || options.raw === true || options.revive === false ? data : $ff33cefb5fdd4ae2$var$_reviveProjectPayload(data, options.deferRevive);
}
const $ff33cefb5fdd4ae2$export$f67160ad60e7d39b = (projectRef, envKey)=>{
    function splitProjectRef(ref) {
        if (!ref) return ref;
        if (typeof ref === 'object') return ref;
        const idx = String(ref).indexOf('/');
        if (idx === -1) return ref;
        return {
            owner: ref.slice(0, idx),
            key: ref.slice(idx + 1)
        };
    }
    const ref = splitProjectRef(projectRef);
    const id = ref && typeof ref === 'object' ? `${ref.owner}/${ref.key}` : String(ref || '');
    return `symbols.envcfg.v1.${id}.${envKey}`;
};
async function $ff33cefb5fdd4ae2$export$170e607e5e4505d9(projectKey, envKey, sdkOpts = {}) {
    // FA204 / frank trap — self-contained inline copies of _splitProjectRef/
    // envCfgCacheKey/_envCfgFetch/_ENV_CFG_TTL, see the export above for the
    // canonical envCfgCacheKey shape kept alive for its own test suite.
    function splitProjectRef(ref) {
        if (!ref) return ref;
        if (typeof ref === 'object') return ref;
        const idx = String(ref).indexOf('/');
        if (idx === -1) return ref;
        return {
            owner: ref.slice(0, idx),
            key: ref.slice(idx + 1)
        };
    }
    function cacheKeyFor(projectRef, envKey) {
        const ref = splitProjectRef(projectRef);
        const id = ref && typeof ref === 'object' ? `${ref.owner}/${ref.key}` : String(ref || '');
        return `symbols.envcfg.v1.${id}.${envKey}`;
    }
    async function envCfgFetch(projectKey, envKey, sdkOpts) {
        // Owner + key or nothing: a bare key can name several owners' projects
        // (the server answers it 409 `ambiguous_key`), and an env config read for
        // the wrong owner pins the wrong project's version. Every caller sends the
        // owner (fetchProject.js 'owner/key', the module loader { owner, key });
        // a ref without one resolves no config, and the caller keeps its default.
        const ref = splitProjectRef(projectKey);
        if (!ref || typeof ref !== 'object' || !ref.owner || !ref.key) return null;
        const sdk = (0, $1NxyO.getSDK)(sdkOpts);
        const workspaceId = sdkOpts?.workspaceId;
        const project = await sdk.getProjectByKey({
            owner: ref.owner,
            key: ref.key
        }, {
            workspaceId: workspaceId
        });
        const projectId = project?._id || project?.id;
        if (!projectId) return null;
        const envs = await sdk.listEnvironments(projectId, {
            workspaceId: workspaceId
        });
        const cfg = envs?.environments?.[envKey];
        if (!cfg || cfg.enabled === false) return null;
        const branch = cfg.branch || 'main';
        // 'published' must pin to Project.publishedVersion, the same contract
        // the server's own /public/:env route resolves
        // (ProjectController._resolveEnvServeTarget) — every mode but 'version'
        // used to fall through to 'latest' here, so a plain push reached every
        // tenant whose env was left on 'published'. Falls back to 'latest' only
        // when the project has never published a version at all.
        const version = cfg.mode === 'version' && cfg.version ? cfg.version : cfg.mode === 'published' && project?.publishedVersion?.value ? project.publishedVersion.value : 'latest';
        return {
            branch: branch,
            version: version
        };
    }
    const ENV_CFG_TTL = 600000;
    if (!projectKey || !envKey) return null;
    // One-way migration: pre-fix builds stringified object refs into the key
    // ('symbols.envcfg.v1.[object Object].<env>' — one slot shared by every
    // project). Never read it — delete on sight so it can't serve another
    // project's config.
    try {
        if (typeof localStorage !== 'undefined') localStorage.removeItem(`symbols.envcfg.v1.[object Object].${envKey}`);
    } catch (_) {
    /* best-effort */ }
    let cached;
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem(cacheKeyFor(projectKey, envKey));
        cached = raw ? JSON.parse(raw) : null;
    } catch (_) {
        cached = null;
    }
    const live = envCfgFetch(projectKey, envKey, sdkOpts).then((cfg)=>{
        try {
            if (typeof localStorage !== 'undefined') localStorage.setItem(cacheKeyFor(projectKey, envKey), JSON.stringify({
                cfg: cfg,
                at: Date.now()
            }));
        } catch (_) {
        /* cache is best-effort */ }
        return cfg;
    }).catch((e)=>{
        // A fresh-enough cache absorbs a transient failure; without one the
        // caller sees the rejection exactly as before.
        if (cached && Date.now() - (cached.at || 0) < ENV_CFG_TTL) return cached.cfg ?? null;
        throw e;
    });
    if (cached && Date.now() - (cached.at || 0) < ENV_CFG_TTL) {
        // Fresh hit — answer now, let the refresh above land for the next boot.
        live.catch(()=>{});
        return cached.cfg ?? null;
    }
    return live;
}

});
parcelRegister("byww3", function(module, exports) {

var $28ol3 = parcelRequire("28ol3");

var $dSdIt = parcelRequire("dSdIt");

var $czfS0 = parcelRequire("czfS0");

var $2C0hZ = parcelRequire("2C0hZ");

var $gjNoZ = parcelRequire("gjNoZ");

var $jobwP = parcelRequire("jobwP");

var $4Fc4U = parcelRequire("4Fc4U");

var $lWD5b = parcelRequire("lWD5b");

var $1hhFt = parcelRequire("1hhFt");

var $TarXh = parcelRequire("TarXh");

var $fXgyh = parcelRequire("fXgyh");

var $hi618 = parcelRequire("hi618");

var $fDTgW = parcelRequire("fDTgW");

var $gx70P = parcelRequire("gx70P");

var $4tyEL = parcelRequire("4tyEL");

var $5UBxb = parcelRequire("5UBxb");

var $etvrx = parcelRequire("etvrx");

var $avbFu = parcelRequire("avbFu");

var $cjyfe = parcelRequire("cjyfe");

var $iFk3S = parcelRequire("iFk3S");

var $kkSVW = parcelRequire("kkSVW");

var $69Bo3 = parcelRequire("69Bo3");

var $6Jwvb = parcelRequire("6Jwvb");

var $BEBTO = parcelRequire("BEBTO");

var $850OO = parcelRequire("850OO");

var $hjm5u = parcelRequire("hjm5u");

var $5pnrT = parcelRequire("5pnrT");

var $dc7wk = parcelRequire("dc7wk");

var $5zSXA = parcelRequire("5zSXA");

var $ao1Fr = parcelRequire("ao1Fr");

var $40QVJ = parcelRequire("40QVJ");

var $bun4U = parcelRequire("bun4U");

var $b6b22 = parcelRequire("b6b22");

var $9G1Z5 = parcelRequire("9G1Z5");

var $4FES3 = parcelRequire("4FES3");

var $5Jazt = parcelRequire("5Jazt");

var $gdfnU = parcelRequire("gdfnU");

var $eLA0f = parcelRequire("eLA0f");

var $cdzjF = parcelRequire("cdzjF");

var $749b5 = parcelRequire("749b5");

var $4vxEg = parcelRequire("4vxEg");

var $7gmTd = parcelRequire("7gmTd");

var $67pwd = parcelRequire("67pwd");

var $6Bm4P = parcelRequire("6Bm4P");

var $j3Hh3 = parcelRequire("j3Hh3");

var $3YUdU = parcelRequire("3YUdU");
$parcel$exportWildcard(module.exports, $28ol3);
$parcel$exportWildcard(module.exports, $dSdIt);
$parcel$exportWildcard(module.exports, $czfS0);
$parcel$exportWildcard(module.exports, $2C0hZ);
$parcel$exportWildcard(module.exports, $gjNoZ);
$parcel$exportWildcard(module.exports, $jobwP);
$parcel$exportWildcard(module.exports, $4Fc4U);
$parcel$exportWildcard(module.exports, $lWD5b);
$parcel$exportWildcard(module.exports, $1hhFt);
$parcel$exportWildcard(module.exports, $TarXh);
$parcel$exportWildcard(module.exports, $fXgyh);
$parcel$exportWildcard(module.exports, $hi618);
$parcel$exportWildcard(module.exports, $fDTgW);
$parcel$exportWildcard(module.exports, $gx70P);
$parcel$exportWildcard(module.exports, $4tyEL);
$parcel$exportWildcard(module.exports, $5UBxb);
$parcel$exportWildcard(module.exports, $etvrx);
$parcel$exportWildcard(module.exports, $avbFu);
$parcel$exportWildcard(module.exports, $cjyfe);
$parcel$exportWildcard(module.exports, $iFk3S);
$parcel$exportWildcard(module.exports, $kkSVW);
$parcel$exportWildcard(module.exports, $69Bo3);
$parcel$exportWildcard(module.exports, $6Jwvb);
$parcel$exportWildcard(module.exports, $BEBTO);
$parcel$exportWildcard(module.exports, $850OO);
$parcel$exportWildcard(module.exports, $hjm5u);
$parcel$exportWildcard(module.exports, $5pnrT);
$parcel$exportWildcard(module.exports, $dc7wk);
$parcel$exportWildcard(module.exports, $5zSXA);
$parcel$exportWildcard(module.exports, $ao1Fr);
$parcel$exportWildcard(module.exports, $40QVJ);
$parcel$exportWildcard(module.exports, $bun4U);
$parcel$exportWildcard(module.exports, $b6b22);
$parcel$exportWildcard(module.exports, $9G1Z5);
$parcel$exportWildcard(module.exports, $4FES3);
$parcel$exportWildcard(module.exports, $5Jazt);
$parcel$exportWildcard(module.exports, $gdfnU);
$parcel$exportWildcard(module.exports, $eLA0f);
$parcel$exportWildcard(module.exports, $cdzjF);
$parcel$exportWildcard(module.exports, $749b5);
$parcel$exportWildcard(module.exports, $4vxEg);
$parcel$exportWildcard(module.exports, $7gmTd);
$parcel$exportWildcard(module.exports, $67pwd);
$parcel$exportWildcard(module.exports, $6Bm4P);
$parcel$exportWildcard(module.exports, $j3Hh3);
$parcel$exportWildcard(module.exports, $3YUdU);

});
parcelRegister("28ol3", function(module, exports) {

$parcel$export(module.exports, "generateKey", () => $18df3547f1551f38$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "createSnapshotId", () => $18df3547f1551f38$export$6f8fb29fbb5b5b63);
$parcel$export(module.exports, "createKey", () => $18df3547f1551f38$export$e2280c1995141b13);

var $2C0hZ = parcelRequire("2C0hZ");
const $18df3547f1551f38$export$3a7728e868aa3ebd = function() {
    let t = 0;
    function e() {
        return t++, t;
    }
    return e;
}(), $18df3547f1551f38$export$6f8fb29fbb5b5b63 = $18df3547f1551f38$export$3a7728e868aa3ebd, $18df3547f1551f38$export$e2280c1995141b13 = (t, e, r)=>((0, $2C0hZ.exec)(r, t) || r || t.key || $18df3547f1551f38$export$3a7728e868aa3ebd()).toString();

});
parcelRegister("2C0hZ", function(module, exports) {

$parcel$export(module.exports, "exec", () => $1e6f5ac94c515a97$export$78e3044358792147);
$parcel$export(module.exports, "map", () => $1e6f5ac94c515a97$export$871de8747c9eaa88);
$parcel$export(module.exports, "merge", () => $1e6f5ac94c515a97$export$4950aa0f605343fb);
$parcel$export(module.exports, "deepMerge", () => $1e6f5ac94c515a97$export$6969335ea1e4e77c);
$parcel$export(module.exports, "clone", () => $1e6f5ac94c515a97$export$9cd59f9826255e47);
$parcel$export(module.exports, "deepClone", () => $1e6f5ac94c515a97$export$b7d58db314e0ac27);
$parcel$export(module.exports, "deepStringifyFunctions", () => $1e6f5ac94c515a97$export$a1b87aa71164cd70);
$parcel$export(module.exports, "objectToString", () => $1e6f5ac94c515a97$export$830c053460e5ddf6);
$parcel$export(module.exports, "hasFunction", () => $1e6f5ac94c515a97$export$6b15be743c368efa);
$parcel$export(module.exports, "isLazyFunction", () => $1e6f5ac94c515a97$export$6cfb5145cbf1ec4e);
$parcel$export(module.exports, "getFunctionSource", () => $1e6f5ac94c515a97$export$a374627124b18c6e);
$parcel$export(module.exports, "isFailedRevival", () => $1e6f5ac94c515a97$export$f4a1cfa22132b38b);
$parcel$export(module.exports, "deepDestringifyFunctions", () => $1e6f5ac94c515a97$export$4db1ad98392a09bb);
$parcel$export(module.exports, "markRevived", () => $1e6f5ac94c515a97$export$c181437b60f47082);
$parcel$export(module.exports, "isStringTag", () => $1e6f5ac94c515a97$export$e460d7db2a4a154);
$parcel$export(module.exports, "REVIVED_MARK", () => $1e6f5ac94c515a97$export$57389ef7e3b22c9d);
$parcel$export(module.exports, "isRevived", () => $1e6f5ac94c515a97$export$e2bf8de10390618e);
$parcel$export(module.exports, "destringifyGlobalScope", () => $1e6f5ac94c515a97$export$9cab894253c5c18e);
$parcel$export(module.exports, "stringToObject", () => $1e6f5ac94c515a97$export$a6c9a3ccba61521e);
$parcel$export(module.exports, "hasOwnProperty", () => $1e6f5ac94c515a97$export$5a15a386532a5ea4);
$parcel$export(module.exports, "isEmpty", () => $1e6f5ac94c515a97$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isEmptyObject", () => $1e6f5ac94c515a97$export$83b788b1a3698c03);
$parcel$export(module.exports, "makeObjectWithoutPrototype", () => $1e6f5ac94c515a97$export$d6d64087a1bd2d);
$parcel$export(module.exports, "overwrite", () => $1e6f5ac94c515a97$export$d3305692eb3e9a81);
$parcel$export(module.exports, "overwriteShallow", () => $1e6f5ac94c515a97$export$1c07155dfdd98f41);
$parcel$export(module.exports, "overwriteDeep", () => $1e6f5ac94c515a97$export$f0b277b530b4fffd);
$parcel$export(module.exports, "isEqualDeep", () => $1e6f5ac94c515a97$export$683c7d6569f339f4);
$parcel$export(module.exports, "deepContains", () => $1e6f5ac94c515a97$export$273cb3019e2f952c);
$parcel$export(module.exports, "removeFromObject", () => $1e6f5ac94c515a97$export$bdd7fc6cf95d63b);
$parcel$export(module.exports, "createObjectWithoutPrototype", () => $1e6f5ac94c515a97$export$c2a75c92f46bb782);
$parcel$export(module.exports, "createNestedObject", () => $1e6f5ac94c515a97$export$a9706fb8026b394a);
$parcel$export(module.exports, "removeNestedKeyByPath", () => $1e6f5ac94c515a97$export$33f72cab96f733af);
$parcel$export(module.exports, "setInObjectByPath", () => $1e6f5ac94c515a97$export$9c3074cc3d55a00f);
$parcel$export(module.exports, "getInObjectByPath", () => $1e6f5ac94c515a97$export$12bc5d09cd221028);
$parcel$export(module.exports, "detectInfiniteLoop", () => $1e6f5ac94c515a97$export$ad59efee0c629be2);
$parcel$export(module.exports, "isCyclic", () => $1e6f5ac94c515a97$export$831fcc412582ee80);
$parcel$export(module.exports, "excludeKeysFromObject", () => $1e6f5ac94c515a97$export$efc42697dda340d9);

var $fXgyh = parcelRequire("fXgyh");

var $czfS0 = parcelRequire("czfS0");

var $jobwP = parcelRequire("jobwP");

var $TarXh = parcelRequire("TarXh");

var $4Fc4U = parcelRequire("4Fc4U");

var $cjyfe = parcelRequire("cjyfe");

var $hjm5u = parcelRequire("hjm5u");

const $1e6f5ac94c515a97$var$I = "production", $1e6f5ac94c515a97$var$S = (e)=>e.charCodeAt(0) === 95 && e.charCodeAt(1) === 95, $1e6f5ac94c515a97$export$78e3044358792147 = (e, t, n, o)=>{
    if ((0, $czfS0.isFunction)(e)) return t ? typeof e.call != "function" ? e : e.call(t, t, n || t.state, o || t.context) : void 0;
    if (e != null && t?.context?.plugins && ((0, $czfS0.isArray)(e) || (0, $czfS0.isObject)(e) && !(0, $4Fc4U.isDOMNode)(e))) {
        const r = t.context.plugins;
        for (const i of r)if (i.resolveHandler) {
            const s = i.resolveHandler(e, t);
            if (typeof s == "function") return $1e6f5ac94c515a97$export$78e3044358792147(s, t, n, o);
        }
    }
    return e;
}, $1e6f5ac94c515a97$export$871de8747c9eaa88 = (e, t, n)=>{
    for(const o in t)e[o] = $1e6f5ac94c515a97$export$78e3044358792147(t[o], n);
}, $1e6f5ac94c515a97$export$4950aa0f605343fb = (e, t, n = [])=>{
    const o = n instanceof Set;
    for(const r in t)Object.prototype.hasOwnProperty.call(t, r) && ($1e6f5ac94c515a97$var$S(r) || (o ? n.has(r) : n.includes(r)) || e[r] === void 0 && (e[r] = t[r]));
    return e;
}, $1e6f5ac94c515a97$export$6969335ea1e4e77c = (e, t, n = (0, $cjyfe.METHODS_EXL))=>$1e6f5ac94c515a97$var$b(e, t, n, null), $1e6f5ac94c515a97$var$b = (e, t, n, o)=>{
    if (e === t) return e;
    if (o) {
        for(let i = 0; i < o.length; i += 2)if (o[i] === e && o[i + 1] === t) return e;
    }
    const r = n instanceof Set;
    for(const i in t){
        if (!Object.prototype.hasOwnProperty.call(t, i) || $1e6f5ac94c515a97$var$S(i) || i === "constructor" || i === "prototype" || (r ? n.has(i) : n.includes(i))) continue;
        const s = e[i], c = t[i];
        if ((0, $czfS0.isObjectLike)(s) && (0, $czfS0.isObjectLike)(c)) {
            const f = o || [];
            f.push(e, t), $1e6f5ac94c515a97$var$b(s, c, n, f), f.length -= 2;
        } else s === void 0 && (e[i] = c);
    }
    return e;
}, $1e6f5ac94c515a97$export$9cd59f9826255e47 = (e, t = [])=>{
    const n = t instanceof Set, o = {};
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && ($1e6f5ac94c515a97$var$S(r) || (n ? t.has(r) : t.includes(r)) || (o[r] = e[r]));
    return o;
}, $1e6f5ac94c515a97$export$b7d58db314e0ac27 = (e, t = {})=>{
    const { exclude: n = [], cleanUndefined: o = !1, cleanNull: r = !1, visited: i = new WeakMap, handleExtends: s = !1 } = t;
    if (!(0, $czfS0.isObjectLike)(e) || (0, $4Fc4U.isDOMNode)(e)) return e;
    if (i.has(e)) return i.get(e);
    const c = n instanceof Set ? n : n.length > 3 ? new Set(n) : null, f = (u)=>c ? c.has(u) : n.includes(u), p = (0, $czfS0.isArray)(e) ? [] : {};
    i.set(e, p);
    const l = [
        [
            e,
            p
        ]
    ];
    for(; l.length;){
        const [u, h] = l.pop();
        for(const y in u){
            if (!Object.prototype.hasOwnProperty.call(u, y) || $1e6f5ac94c515a97$var$S(y) || y === "__proto__" || f(y)) continue;
            const a = u[y];
            if (!(o && a === void 0) && !(r && a === null)) {
                if ((0, $4Fc4U.isDOMNode)(a)) {
                    h[y] = a;
                    continue;
                }
                if (s && y === "extends" && (0, $czfS0.isArray)(a)) {
                    h[y] = (0, $jobwP.unstackArrayOfObjects)(a, n);
                    continue;
                }
                if ((0, $czfS0.isFunction)(a)) {
                    h[y] = a;
                    continue;
                }
                if ((0, $czfS0.isObjectLike)(a)) {
                    if (i.has(a)) h[y] = i.get(a);
                    else {
                        const d = (0, $czfS0.isArray)(a) ? [] : {};
                        i.set(a, d), h[y] = d, l.push([
                            a,
                            d
                        ]);
                    }
                } else h[y] = a;
            }
        }
    }
    return p;
}, $1e6f5ac94c515a97$export$a1b87aa71164cd70 = (e, t = {})=>{
    (e.node || e.__ref || e.parent || e.__element || e.parse) && ((e.__element || e.parent?.__element).warn("Trying to clone element or state at", e), e = e.parse?.());
    for(const n in e){
        const o = e[n];
        if ((0, $czfS0.isFunction)(o)) t[n] = o.toString();
        else if ((0, $czfS0.isObject)(o)) t[n] = {}, $1e6f5ac94c515a97$export$a1b87aa71164cd70(o, t[n]);
        else if ((0, $czfS0.isArray)(o)) {
            const r = t[n] = [];
            for(let i = 0; i < o.length; i++){
                const s = o[i];
                (0, $czfS0.isObject)(s) ? (r[i] = {}, $1e6f5ac94c515a97$export$a1b87aa71164cd70(s, r[i])) : (0, $czfS0.isFunction)(s) ? r[i] = s.toString() : r[i] = s;
            }
        } else t[n] = o;
    }
    return t;
}, $1e6f5ac94c515a97$var$fe = /^[A-Za-z_$][A-Za-z0-9_$]*$/, $1e6f5ac94c515a97$var$le = (e)=>`'${String(e).replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/\r/g, "\\r").replace(/\n/g, "\\n")}'`, $1e6f5ac94c515a97$var$M = (e)=>{
    const t = String(e);
    return (0, $TarXh.stringIncludesAny)(t, [
        `
`,
        "'"
    ]) ? "`" + t.replace(/\\/g, "\\\\").replace(/`/g, "\\`").replace(/\$\{/g, "\\${") + "`" : "'" + t.replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/\r/g, "\\r") + "'";
}, $1e6f5ac94c515a97$export$830c053460e5ddf6 = (e = {}, t = 0)=>{
    if (e === null || typeof e != "object" || e instanceof RegExp) return String(e);
    let n = !1;
    for(const i in e){
        n = !0;
        break;
    }
    if (!n) return "{}";
    const o = "  ".repeat(t);
    let r = `{
`;
    for(const i in e){
        if (!Object.prototype.hasOwnProperty.call(e, i)) continue;
        const s = e[i], c = $1e6f5ac94c515a97$var$fe.test(i) ? i : $1e6f5ac94c515a97$var$le(i);
        if (r += `${o}  ${c}: `, s instanceof RegExp) r += String(s);
        else if ((0, $czfS0.isArray)(s)) {
            r += `[
`;
            for (const f of s)f instanceof RegExp ? r += `${o}    ${String(f)},
` : (0, $czfS0.isObjectLike)(f) && f !== null ? r += `${o}    ${$1e6f5ac94c515a97$export$830c053460e5ddf6(f, t + 2)},
` : (0, $czfS0.isString)(f) ? r += `${o}    ${$1e6f5ac94c515a97$var$M(f)},
` : r += `${o}    ${f},
`;
            r += `${o}  ]`;
        } else (0, $czfS0.isObjectLike)(s) ? r += $1e6f5ac94c515a97$export$830c053460e5ddf6(s, t + 1) : (0, $czfS0.isString)(s) ? r += $1e6f5ac94c515a97$var$M(s) : r += s;
        r += `,
`;
    }
    return r += `${o}}`, r;
}, $1e6f5ac94c515a97$var$ue = [
    /^\(\s*\{[^}]*\}\s*\)\s*=>/,
    /^(\([^)]*\)|[^=]*)\s*=>/,
    /^function[\s(]/,
    /^async\s+/,
    /^\(\s*function/,
    /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/,
    /^(?:\*\s*)?[a-zA-Z_$][\w$]*\s*\((?:[^()]|\([^()]*\))*\)\s*\{[\s\S]*\}$/
], $1e6f5ac94c515a97$var$ae = /^["[{]/, $1e6f5ac94c515a97$var$pe = /^(export|import)\s/, $1e6f5ac94c515a97$export$6b15be743c368efa = (e)=>{
    if (!e) return !1;
    const t = e.trim();
    if (t === "" || t === "{}" || t === "[]") return !1;
    const n = t.includes("=>");
    if (!n && t.charCodeAt(0) !== 40 && !t.startsWith("function") && !t.startsWith("async") && !(t.charCodeAt(t.length - 1) === 125 && t.includes("(")) || $1e6f5ac94c515a97$var$pe.test(t) || !$1e6f5ac94c515a97$var$ue.some((i)=>i.test(t))) return !1;
    const r = t.charCodeAt(0);
    return !(r === 123 && !n || r === 91 || $1e6f5ac94c515a97$var$ae.test(t) && !n);
}, $1e6f5ac94c515a97$var$Y = (e)=>(0, eval)(e), $1e6f5ac94c515a97$var$ye = (e, t)=>{
    const n = /^(\s*(?:async\s+)?function\s*[\w$]*\s*\([^)]*\)\s*)\{/.exec(e);
    if (!n) return null;
    const o = n[0].length, r = [];
    let i = o, s = 1, c = null;
    const f = e.length, p = new RegExp("^(?:const|let|var)\\s+" + t + "\\b");
    for(; i < f && s > 0;){
        const u = e[i];
        if (u === "/" && e[i + 1] === "/") {
            const h = e.indexOf(`
`, i);
            i = h === -1 ? f : h;
            continue;
        }
        if (u === "/" && e[i + 1] === "*") {
            const h = e.indexOf("*/", i + 2);
            i = h === -1 ? f : h + 2;
            continue;
        }
        if (u === '"' || u === "'" || u === "`") {
            const h = u;
            for(i++; i < f;){
                if (e[i] === "\\") {
                    i += 2;
                    continue;
                }
                if (e[i] === h) {
                    i++;
                    break;
                }
                if (h === "`" && e[i] === "$" && e[i + 1] === "{") {
                    i += 2;
                    let y = 1;
                    for(; i < f && y > 0;)e[i] === "{" ? y++ : e[i] === "}" && y--, i++;
                    continue;
                }
                i++;
            }
            continue;
        }
        if (u === "{") {
            s++, i++;
            continue;
        }
        if (u === "}") {
            s--, i++;
            continue;
        }
        if (s === 1 && p.test(e.slice(i))) {
            const h = i;
            let y = 0, a = i;
            for(; a < f;){
                const d = e[a];
                if (d === '"' || d === "'" || d === "`") {
                    const k = d;
                    for(a++; a < f;){
                        if (e[a] === "\\") {
                            a += 2;
                            continue;
                        }
                        if (e[a] === k) {
                            a++;
                            break;
                        }
                        a++;
                    }
                    continue;
                }
                if (d === "(" || d === "[" || d === "{") {
                    y++, a++;
                    continue;
                }
                if (d === ")" || d === "]" || d === "}") {
                    if (y === 0) break;
                    y--, a++;
                    continue;
                }
                if (y === 0 && (d === ";" || d === `
`)) {
                    a++;
                    break;
                }
                a++;
            }
            r.push([
                h,
                a
            ]), i = a;
            continue;
        }
        i++;
    }
    if (!r.length) return null;
    let l = e;
    for(let u = r.length - 1; u >= 0; u--)l = l.slice(0, r[u][0]) + l.slice(r[u][1]);
    return l;
}, $1e6f5ac94c515a97$var$$ = (e, t, n, o)=>{
    const r = String(e).trimStart();
    if (/^(export|import)\s/.test(r)) return e;
    e = (0, $hjm5u.repairLegacyArrowScopePreamble)(e);
    try {
        return n.window.eval(`(${e})`);
    } catch (i) {
        const s = i && i.message ? i.message : String(i), c = /await is only valid in async/.test(s), f = /Identifier '([^']+)' has already been declared/.exec(s);
        let p = null;
        if (c) {
            const l = String(e).trim();
            if (/^function[\s(]/.test(l)) try {
                p = n.window.eval("(async " + l + ")");
            } catch  {}
        } else if (f) {
            let l = String(e), u = f[1];
            for(let h = 0; h < 5; h++){
                const y = $1e6f5ac94c515a97$var$ye(l, u);
                if (!y || y === l) break;
                l = y;
                try {
                    p = n.window.eval("(" + l + ")");
                    break;
                } catch (a) {
                    const d = /Identifier '([^']+)' has already been declared/.exec(a && a.message || String(a));
                    if (!d || d[1] !== u) break;
                }
            }
        }
        if (!p && /Unexpected (token '\{'|identifier)/.test(s)) try {
            const l = n.window.eval("({" + e + "})");
            if (l && typeof l == "object") {
                const u = Object.keys(l);
                u.length === 1 && typeof l[u[0]] == "function" && (p = l[u[0]]);
            }
        } catch  {}
        return p || (typeof console < "u" && console.warn && console.warn(`[smbls] deepDestringifyFunctions: eval failed on ${t} \u2014 ` + (o ? "revived lazily, so its source compiled on this first use; it acts as the string it replaces (a call returns the source text, el.call treats it as not callable). Reason: " : "value will be left as a string. Reason: ") + s + `.
First 200 chars of source: ` + String(e).slice(0, 200)), e);
    }
}, $1e6f5ac94c515a97$var$v = 1, $1e6f5ac94c515a97$var$L = 2, $1e6f5ac94c515a97$var$E = new WeakMap, $1e6f5ac94c515a97$var$de = /^(async\s+)?function(?![\w$])\s*(\*)?\s*([A-Za-z_$][\w$]*)?\s*\((?:[^()'"`/]|\([^()'"`/]*\))*\)\s*\{/, $1e6f5ac94c515a97$var$he = /^(async\s+)?[A-Za-z_$][\w$]*\s*=>/, $1e6f5ac94c515a97$var$ge = /^(async\s*)?\((?:[^()'"`/]|\([^()'"`/]*\))*\)\s*=>/, $1e6f5ac94c515a97$var$_e = /^(async\s+)?([A-Za-z_$][\w$]*)\s*\((?:[^()'"`/]|\([^()'"`/]*\))*\)\s*\{/, $1e6f5ac94c515a97$var$we = new Set([
    "if",
    "for",
    "while",
    "switch",
    "catch",
    "with",
    "do",
    "return",
    "typeof",
    "void",
    "delete",
    "new",
    "in",
    "of",
    "instanceof",
    "function",
    "class",
    "const",
    "let",
    "var",
    "await",
    "yield",
    "import",
    "export",
    "try",
    "else",
    "throw",
    "case",
    "default",
    "break",
    "continue",
    "debugger",
    "finally",
    "super",
    "this",
    "null",
    "true",
    "false",
    "async",
    "get",
    "set",
    "static"
]), $1e6f5ac94c515a97$var$Z = (e)=>e >= 48 && e <= 57 || e >= 65 && e <= 90 || e >= 97 && e <= 122 || e === 36 || e === 95, $1e6f5ac94c515a97$var$Oe = (e, t, n)=>{
    let o = e.indexOf(t, n);
    for(; o !== -1;){
        const r = o + t.length;
        if ((o === 0 || !$1e6f5ac94c515a97$var$Z(e.charCodeAt(o - 1))) && (r >= e.length || !$1e6f5ac94c515a97$var$Z(e.charCodeAt(r)))) return !0;
        o = e.indexOf(t, r);
    }
    return !1;
}, $1e6f5ac94c515a97$var$B = (e)=>{
    let t = e.length - 1;
    for(; t >= 0 && e.charCodeAt(t) <= 32;)t--;
    return t < 0 ? -1 : e.charCodeAt(t);
}, $1e6f5ac94c515a97$var$Se = (e)=>{
    let t = e, n = 0;
    for(; n < t.length && t.charCodeAt(n) <= 32;)n++;
    n && (t = t.slice(n));
    let o = $1e6f5ac94c515a97$var$de.exec(t);
    if (o) {
        if (o[2] || $1e6f5ac94c515a97$var$B(t) !== 125) return null;
        const r = o[3] || "";
        return r && $1e6f5ac94c515a97$var$Oe(t, r, o[0].indexOf("(")) || t.indexOf("arguments.callee") !== -1 ? null : {
            src: e,
            name: r,
            kind: o[1] ? $1e6f5ac94c515a97$var$L : $1e6f5ac94c515a97$var$v,
            async: !!o[1],
            fn: void 0
        };
    }
    return o = $1e6f5ac94c515a97$var$he.exec(t) || $1e6f5ac94c515a97$var$ge.exec(t), o ? {
        src: e,
        name: "",
        kind: $1e6f5ac94c515a97$var$L,
        async: !!o[1],
        fn: void 0
    } : (o = $1e6f5ac94c515a97$var$_e.exec(t), o && !$1e6f5ac94c515a97$var$we.has(o[2]) && $1e6f5ac94c515a97$var$B(t) === 125 ? t.indexOf("arguments.callee") !== -1 ? null : {
        src: e,
        name: o[2],
        kind: $1e6f5ac94c515a97$var$L,
        async: !!o[1],
        fn: void 0
    } : null);
}, $1e6f5ac94c515a97$var$U = (e)=>e.index === -1 ? `"${e.key}"` : `array index ${e.index} (prop "${e.key}")`, $1e6f5ac94c515a97$var$R = (e)=>{
    const t = $1e6f5ac94c515a97$var$$(e.src, $1e6f5ac94c515a97$var$U(e), e.opts, !0);
    let n = null;
    return typeof t == "function" ? n = t : (e.value = t, typeof t != "string" && typeof console < "u" && console.warn && console.warn(`[smbls] deepDestringifyFunctions: ${$1e6f5ac94c515a97$var$U(e)} did not evaluate to a function \u2014 the lazily revived function returns that value.
First 200 chars of source: ` + String(e.src).slice(0, 200))), e.fn = n, e.opts = null, n;
}, $1e6f5ac94c515a97$var$Ee = (e, t, n)=>Reflect.construct(e, t, n);
function $1e6f5ac94c515a97$var$xe() {
    const e = $1e6f5ac94c515a97$var$E.get(this);
    return e ? e.src.trim() : Function.prototype.toString.call(this);
}
const $1e6f5ac94c515a97$var$Ae = {
    length: {
        get () {
            const e = $1e6f5ac94c515a97$var$E.get(this);
            if (!e) return 0;
            const t = e.fn === void 0 ? $1e6f5ac94c515a97$var$R(e) : e.fn;
            return t ? t.length : 0;
        },
        configurable: !0
    },
    name: {
        get () {
            const e = $1e6f5ac94c515a97$var$E.get(this);
            return e ? e.name : "";
        },
        configurable: !0
    },
    toString: {
        value: $1e6f5ac94c515a97$var$xe,
        writable: !0,
        configurable: !0
    }
}, $1e6f5ac94c515a97$var$$e = Object.getPrototypeOf(async function() {}), $1e6f5ac94c515a97$var$ke = (e)=>{
    let t;
    return e.kind === $1e6f5ac94c515a97$var$v ? t = function() {
        const n = e.fn === void 0 ? $1e6f5ac94c515a97$var$R(e) : e.fn;
        return n === null ? e.value : new.target ? $1e6f5ac94c515a97$var$Ee(n, arguments, new.target) : n.apply(this, arguments);
    } : t = ({
        lazy () {
            const n = e.fn === void 0 ? $1e6f5ac94c515a97$var$R(e) : e.fn;
            return n === null ? e.value : n.apply(this, arguments);
        }
    }).lazy, $1e6f5ac94c515a97$var$E.set(t, e), Object.defineProperties(t, $1e6f5ac94c515a97$var$Ae), e.async && Object.setPrototypeOf(t, $1e6f5ac94c515a97$var$$e), t;
}, $1e6f5ac94c515a97$var$G = (e, t, n, o)=>{
    const r = $1e6f5ac94c515a97$var$Se(e);
    return r ? (r.key = t, r.index = n, r.opts = o, $1e6f5ac94c515a97$var$ke(r)) : $1e6f5ac94c515a97$var$$(e, n === -1 ? `"${t}"` : `array index ${n} (prop "${t}")`, o);
}, $1e6f5ac94c515a97$export$6cfb5145cbf1ec4e = (e)=>typeof e == "function" && $1e6f5ac94c515a97$var$E.has(e), $1e6f5ac94c515a97$export$a374627124b18c6e = (e)=>{
    const t = $1e6f5ac94c515a97$var$E.get(e);
    return t ? t.src.trim() : Function.prototype.toString.call(e);
}, $1e6f5ac94c515a97$export$f4a1cfa22132b38b = (e)=>{
    const t = typeof e == "function" ? $1e6f5ac94c515a97$var$E.get(e) : void 0;
    return t ? (t.fn === void 0 ? $1e6f5ac94c515a97$var$R(t) : t.fn) === null : !1;
}, $1e6f5ac94c515a97$var$Pe = new Set([
    "components",
    "pages",
    "functions",
    "methods",
    "snippets",
    "app",
    "globalScope"
]), $1e6f5ac94c515a97$var$K = {
    window: {
        eval: $1e6f5ac94c515a97$var$Y
    }
}, $1e6f5ac94c515a97$export$4db1ad98392a09bb = (e, t = {}, n = $1e6f5ac94c515a97$var$K)=>{
    if (!e || typeof e != "object") return t;
    (!n || !n.window || typeof n.window.eval != "function") && (n = {
        ...n,
        window: {
            eval: $1e6f5ac94c515a97$var$Y
        }
    });
    const o = n.lazy === !0, r = n.lazy === "context", i = (c, f, p)=>o || r && (c === e ? $1e6f5ac94c515a97$var$Pe.has(f) : p), s = [
        [
            e,
            t,
            o
        ]
    ];
    for(; s.length;){
        const [c, f, p] = s.pop();
        for(const l in c){
            if (!Object.prototype.hasOwnProperty.call(c, l) || (0, $cjyfe.PROTOTYPE_KEYS).has(l)) continue;
            const u = c[l];
            if ((0, $czfS0.isString)(u)) $1e6f5ac94c515a97$export$6b15be743c368efa(u) ? f[l] = p ? $1e6f5ac94c515a97$var$G(u, l, -1, n) : $1e6f5ac94c515a97$var$$(u, `"${l}"`, n) : f[l] = u;
            else if ((0, $czfS0.isArray)(u)) {
                const h = f[l] = [], y = i(c, l, p);
                for(let a = 0; a < u.length; a++){
                    const d = u[a];
                    if ((0, $czfS0.isString)(d)) h.push($1e6f5ac94c515a97$export$6b15be743c368efa(d) ? y ? $1e6f5ac94c515a97$var$G(d, l, a, n) : $1e6f5ac94c515a97$var$$(d, `array index ${a} (prop "${l}")`, n) : d);
                    else if ((0, $czfS0.isObject)(d)) {
                        const k = $1e6f5ac94c515a97$var$ne(d);
                        if (k !== null) h.push(k);
                        else {
                            const m = {};
                            h.push(m), s.push([
                                d,
                                m,
                                y
                            ]);
                        }
                    } else h.push(d);
                }
            } else if ((0, $czfS0.isObject)(u)) {
                const h = $1e6f5ac94c515a97$var$ne(u);
                if (h !== null) {
                    f[l] = h;
                    continue;
                }
                const y = f[l] && typeof f[l] == "object" && !(0, $czfS0.isArray)(f[l]) ? f[l] : f[l] = {};
                s.push([
                    u,
                    y,
                    i(c, l, p)
                ]);
            } else f[l] = u;
        }
    }
    return $1e6f5ac94c515a97$export$c181437b60f47082(t);
}, $1e6f5ac94c515a97$var$H = "Set", $1e6f5ac94c515a97$var$q = "Map", $1e6f5ac94c515a97$var$V = "RegExp", $1e6f5ac94c515a97$var$J = "WeakMap", $1e6f5ac94c515a97$var$X = "WeakSet", $1e6f5ac94c515a97$var$Q = "String", $1e6f5ac94c515a97$var$j = (e)=>{
    if (!e || typeof e != "object" || e.__type !== $1e6f5ac94c515a97$var$Q || !(0, $czfS0.isString)(e.value)) return !1;
    const t = Object.keys(e);
    return t.length === 2 && t.includes("value");
}, $1e6f5ac94c515a97$export$e460d7db2a4a154 = $1e6f5ac94c515a97$var$j, $1e6f5ac94c515a97$export$57389ef7e3b22c9d = Symbol.for("smbls.revived"), $1e6f5ac94c515a97$export$c181437b60f47082 = (e)=>{
    if (e && typeof e == "object") try {
        e[$1e6f5ac94c515a97$export$57389ef7e3b22c9d] = !0;
    } catch  {}
    return e;
}, $1e6f5ac94c515a97$export$e2bf8de10390618e = (e)=>!!(e && typeof e == "object" && e[$1e6f5ac94c515a97$export$57389ef7e3b22c9d] === !0), $1e6f5ac94c515a97$var$te = (e)=>{
    const t = Object.keys(e);
    return t.length === 1 && t[0] === "__type";
}, $1e6f5ac94c515a97$var$N = (e, t, n)=>{
    if (!e || typeof e != "object") return e;
    if ($1e6f5ac94c515a97$var$j(e)) return e.value;
    const o = (c)=>$1e6f5ac94c515a97$var$N(c, t || (t = new WeakMap)), r = (c)=>n && (0, $czfS0.isString)(c) ? n(c) : $1e6f5ac94c515a97$var$N(c, t, n);
    if (e.__type === $1e6f5ac94c515a97$var$H && (0, $czfS0.isArray)(e.values)) return new Set(e.values.map(o));
    if (e.__type === $1e6f5ac94c515a97$var$q && (0, $czfS0.isArray)(e.entries)) return new Map(e.entries.map((c)=>(0, $czfS0.isArray)(c) ? [
            o(c[0]),
            o(c[1])
        ] : c));
    if (e.__type === $1e6f5ac94c515a97$var$J && $1e6f5ac94c515a97$var$te(e)) return new WeakMap;
    if (e.__type === $1e6f5ac94c515a97$var$X && $1e6f5ac94c515a97$var$te(e)) return new WeakSet;
    if (e.__type === $1e6f5ac94c515a97$var$V && (0, $czfS0.isString)(e.source)) try {
        return new RegExp(e.source, (0, $czfS0.isString)(e.flags) ? e.flags : "");
    } catch  {
        return e;
    }
    if (t || (t = new WeakMap), t.has(e)) return t.get(e);
    let i = !1;
    if ((0, $czfS0.isArray)(e)) {
        const c = new Array(e.length);
        t.set(e, c);
        for(let f = 0; f < e.length; f++)c[f] = r(e[f]), c[f] !== e[f] && (i = !0);
        return i || t.set(e, e), i ? c : e;
    }
    const s = {};
    t.set(e, s);
    for (const c of Object.keys(e)){
        if ((0, $cjyfe.PROTOTYPE_KEYS).has(c)) {
            i = !0;
            continue;
        }
        s[c] = r(e[c]), s[c] !== e[c] && (i = !0);
    }
    return i || t.set(e, e), i ? s : e;
}, $1e6f5ac94c515a97$var$ne = (e)=>{
    if (!e || typeof e != "object") return null;
    const t = e.__type;
    if (t !== $1e6f5ac94c515a97$var$V && t !== $1e6f5ac94c515a97$var$H && t !== $1e6f5ac94c515a97$var$q && t !== $1e6f5ac94c515a97$var$J && t !== $1e6f5ac94c515a97$var$X && t !== $1e6f5ac94c515a97$var$Q) return null;
    const n = $1e6f5ac94c515a97$var$N(e);
    return n === e ? null : n;
}, $1e6f5ac94c515a97$var$Re = (e)=>$1e6f5ac94c515a97$export$6b15be743c368efa(e) ? $1e6f5ac94c515a97$var$$(e, "globalScope constant member", $1e6f5ac94c515a97$var$K) : e, $1e6f5ac94c515a97$export$9cab894253c5c18e = (e)=>{
    if (!e || typeof e != "object") return e;
    const t = {}, n = [];
    for (const s of Object.keys(e)){
        if ((0, $cjyfe.PROTOTYPE_KEYS).has(s)) continue;
        const c = e[s];
        (0, $czfS0.isString)(c) && $1e6f5ac94c515a97$export$6b15be743c368efa(c) ? n.push([
            s,
            c
        ]) : t[s] = $1e6f5ac94c515a97$var$N(c, void 0, $1e6f5ac94c515a97$var$Re);
    }
    if (n.length === 0) return t;
    const o = (s)=>/^[A-Za-z_$][\w$]*$/.test(s), r = n.filter(([s])=>o(s)), i = Object.keys(t).filter(o).map((s)=>`var ${s} = __gs__[${JSON.stringify(s)}];`).join(`
`);
    try {
        const s = r.map(([p, l])=>`var ${p} = (${l});`).join(`
`), c = "{ " + r.map(([p])=>`${JSON.stringify(p)}: ${p}`).join(", ") + " }", f = (0, $fXgyh.window).eval(`(function(__gs__) { ${i}
${s}
 return ${c}; })`)(t);
        Object.assign(t, f);
    } catch  {
        for (const [c, f] of r)try {
            const p = Object.keys(t).filter(o).map((l)=>`var ${l} = __gs__[${JSON.stringify(l)}];`).join(`
`);
            t[c] = (0, $fXgyh.window).eval(`(function(__gs__) { ${p}
 return (${f}); })`)(t);
        } catch  {
            try {
                t[c] = (0, $fXgyh.window).eval(`(${f})`);
            } catch  {
                t[c] = f;
            }
        }
    }
    for (const [s, c] of n)if (!o(s)) try {
        t[s] = (0, $fXgyh.window).eval(`(${c})`);
    } catch  {
        t[s] = c;
    }
    return t;
}, $1e6f5ac94c515a97$export$a6c9a3ccba61521e = (e, t = {
    verbose: !0
})=>{
    try {
        return e ? (0, $fXgyh.window).eval("(" + e + ")") : {};
    } catch (n) {
        t.verbose && console.warn(n);
    }
}, $1e6f5ac94c515a97$export$5a15a386532a5ea4 = (e, ...t)=>Object.prototype.hasOwnProperty.call(e, ...t), $1e6f5ac94c515a97$export$dd1bc94b04021eeb = (e)=>{
    for(const t in e)return !1;
    return !0;
}, $1e6f5ac94c515a97$export$83b788b1a3698c03 = (e)=>(0, $czfS0.isObject)(e) && $1e6f5ac94c515a97$export$dd1bc94b04021eeb(e), $1e6f5ac94c515a97$export$d6d64087a1bd2d = ()=>Object.create(null), $1e6f5ac94c515a97$export$d3305692eb3e9a81 = (e, t, n = {})=>{
    const o = n.exclude || [], r = n.preventUnderscore;
    for(const i in t)o.includes(i) || !r && $1e6f5ac94c515a97$var$S(i) || i === "constructor" || i === "prototype" || t[i] !== void 0 && (e[i] = t[i]);
    return e;
}, $1e6f5ac94c515a97$export$1c07155dfdd98f41 = (e, t, n = [])=>{
    const o = n instanceof Set;
    for(const r in t)$1e6f5ac94c515a97$var$S(r) || r === "constructor" || r === "prototype" || (o ? n.has(r) : n.includes(r)) || (e[r] = t[r]);
    return e;
}, $1e6f5ac94c515a97$export$f0b277b530b4fffd = (e, t, n = {}, o = new WeakMap)=>{
    if (!(0, $czfS0.isObjectLike)(e) || !(0, $czfS0.isObjectLike)(t) || (0, $4Fc4U.isDOMNode)(e) || (0, $4Fc4U.isDOMNode)(t)) return t;
    if (o.has(e)) return o.get(e);
    o.set(e, e);
    const r = n.exclude, i = r ? r instanceof Set ? r : new Set(r) : null, s = !n.preventForce;
    for(const c in t){
        if (!Object.prototype.hasOwnProperty.call(t, c) || i && i.has(c) || s && $1e6f5ac94c515a97$var$S(c) || c === "constructor" || c === "prototype") continue;
        const f = e[c], p = t[c];
        (0, $4Fc4U.isDOMNode)(p) ? e[c] = p : (0, $czfS0.isObjectLike)(f) && (0, $czfS0.isObjectLike)(p) ? e[c] = $1e6f5ac94c515a97$export$f0b277b530b4fffd(f, p, n, o) : p !== void 0 && (e[c] = p);
    }
    return e;
}, $1e6f5ac94c515a97$export$683c7d6569f339f4 = (e, t, n = new Set)=>{
    if (typeof e != "object" || typeof t != "object" || e === null || t === null) return e === t;
    if (n.has(e) || n.has(t)) return !0;
    n.add(e), n.add(t);
    const o = Object.keys(e), r = Object.keys(t);
    if (o.length !== r.length) return !1;
    for(let i = 0; i < o.length; i++){
        const s = o[i];
        if (!Object.prototype.hasOwnProperty.call(t, s) || !$1e6f5ac94c515a97$export$683c7d6569f339f4(e[s], t[s], n)) return !1;
    }
    return !0;
}, $1e6f5ac94c515a97$var$me = new Set([
    "node",
    "__ref"
]), $1e6f5ac94c515a97$export$273cb3019e2f952c = (e, t, n = $1e6f5ac94c515a97$var$me)=>{
    if (e === t) return !0;
    if (!(0, $czfS0.isObjectLike)(e) || !(0, $czfS0.isObjectLike)(t) || (0, $4Fc4U.isDOMNode)(e) || (0, $4Fc4U.isDOMNode)(t)) return e === t;
    const o = n instanceof Set ? n : new Set(n), r = new WeakSet;
    function i(s, c) {
        if (r.has(c)) return !0;
        r.add(c);
        for(const f in c){
            if (!Object.prototype.hasOwnProperty.call(c, f) || o.has(f)) continue;
            if (!Object.prototype.hasOwnProperty.call(s, f)) return !1;
            const p = c[f], l = s[f];
            if ((0, $4Fc4U.isDOMNode)(p) || (0, $4Fc4U.isDOMNode)(l)) {
                if (p !== l) return !1;
            } else if ((0, $czfS0.isObjectLike)(p) && (0, $czfS0.isObjectLike)(l)) {
                if (!i(l, p)) return !1;
            } else if (p !== l) return !1;
        }
        return !0;
    }
    return i(e, t);
}, $1e6f5ac94c515a97$export$bdd7fc6cf95d63b = (e, t)=>{
    if (t == null) return e;
    if ((0, $czfS0.is)(t)("string", "number")) delete e[t];
    else if ((0, $czfS0.isArray)(t)) for(let n = 0; n < t.length; n++)delete e[t[n]];
    else throw new Error("Invalid input: props must be a string or an array of strings");
    return e;
}, $1e6f5ac94c515a97$export$c2a75c92f46bb782 = (e)=>{
    if (e === null || typeof e != "object") return e;
    const t = Object.create(null);
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = $1e6f5ac94c515a97$export$c2a75c92f46bb782(e[n]));
    return t;
}, $1e6f5ac94c515a97$export$a9706fb8026b394a = (e, t)=>{
    if (e.length === 0) return t;
    const n = {};
    let o = n;
    for(let r = 0; r < e.length; r++)r === e.length - 1 && t ? o[e[r]] = t : (o[e[r]] = {}, o = o[e[r]]);
    return n;
}, $1e6f5ac94c515a97$export$33f72cab96f733af = (e, t)=>{
    if (!Array.isArray(t)) throw new Error("Path must be an array.");
    let n = e;
    for(let r = 0; r < t.length - 1; r++){
        if (n[t[r]] === void 0) return;
        n = n[t[r]];
    }
    const o = t[t.length - 1];
    n && Object.prototype.hasOwnProperty.call(n, o) && delete n[o];
}, $1e6f5ac94c515a97$export$9c3074cc3d55a00f = (e, t, n)=>{
    if (!Array.isArray(t)) throw new Error("Path must be an array.");
    let o = e;
    for(let r = 0; r < t.length - 1; r++)(!o[t[r]] || typeof o[t[r]] != "object") && (o[t[r]] = {}), o = o[t[r]];
    return o[t[t.length - 1]] = n, e;
}, $1e6f5ac94c515a97$export$12bc5d09cd221028 = (e, t)=>{
    if (!Array.isArray(t)) throw new Error("Path must be an array.");
    let n = e;
    for(let o = 0; o < t.length; o++){
        if (n == null) return;
        n = n[t[o]];
    }
    return n;
}, $1e6f5ac94c515a97$export$ad59efee0c629be2 = (e)=>{
    let n = [], o = 0;
    for(let r = 0; r < e.length; r++)if (n.length < 2) n.push(e[r]);
    else if (e[r] === n[r % 2] ? o++ : (n = [
        e[r - 1],
        e[r]
    ], o = 1), o >= 20) return ($1e6f5ac94c515a97$var$I === "test" || $1e6f5ac94c515a97$var$I === "development") && console.warn("Warning: Potential infinite loop detected due to repeated sequence:", n), !0;
}, $1e6f5ac94c515a97$export$831fcc412582ee80 = (e)=>{
    const t = new WeakSet;
    function n(o) {
        if (o && typeof o == "object") {
            if (t.has(o)) return !0;
            t.add(o);
            for(const r in o)if (Object.prototype.hasOwnProperty.call(o, r) && n(o[r])) return console.log(o, "cycle at " + r), !0;
        }
        return !1;
    }
    return n(e);
}, $1e6f5ac94c515a97$export$efc42697dda340d9 = (e, t)=>{
    const n = t instanceof Set ? t : new Set(t), o = {};
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && !n.has(r) && (o[r] = e[r]);
    return o;
};

});
parcelRegister("fXgyh", function(module, exports) {

$parcel$export(module.exports, "global", () => $b9d9348bcc94a7dc$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $b9d9348bcc94a7dc$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $b9d9348bcc94a7dc$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $b9d9348bcc94a7dc$export$5a7bfc01df82fcd1);
const $b9d9348bcc94a7dc$export$90b4d2ff6acb88af = globalThis, $b9d9348bcc94a7dc$export$82c2e460fb230c2a = globalThis, $b9d9348bcc94a7dc$export$8291e5b88f90ce4 = globalThis, $b9d9348bcc94a7dc$export$5a7bfc01df82fcd1 = $b9d9348bcc94a7dc$export$8291e5b88f90ce4.document;

});

parcelRegister("czfS0", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $926510679e33f1b7$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isString", () => $926510679e33f1b7$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $926510679e33f1b7$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $926510679e33f1b7$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $926510679e33f1b7$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNull", () => $926510679e33f1b7$export$630801d484da15df);
$parcel$export(module.exports, "isArray", () => $926510679e33f1b7$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $926510679e33f1b7$export$871608497c498473);
$parcel$export(module.exports, "isObjectLike", () => $926510679e33f1b7$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isDefined", () => $926510679e33f1b7$export$4e62c701997796c1);
$parcel$export(module.exports, "isUndefined", () => $926510679e33f1b7$export$fce6876652108ab);
$parcel$export(module.exports, "TYPES", () => $926510679e33f1b7$export$426db7a6155b7a80);
$parcel$export(module.exports, "is", () => $926510679e33f1b7$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isNot", () => $926510679e33f1b7$export$612ae635ef713eeb);

var $4Fc4U = parcelRequire("4Fc4U");
const $926510679e33f1b7$export$a6cdc56e425d0d0a = (t)=>t === null ? !1 : typeof t == "object" && t.constructor === Object, $926510679e33f1b7$export$844ec244b1367d54 = (t)=>typeof t == "string", $926510679e33f1b7$export$7e4aa119212bc614 = (t)=>typeof t == "number", $926510679e33f1b7$export$f6e2535fb5126e54 = (t)=>typeof t == "function", $926510679e33f1b7$export$f9ce7b637dfbe238 = (t)=>t === !0 || t === !1, $926510679e33f1b7$export$630801d484da15df = (t)=>t === null, $926510679e33f1b7$export$43bee75e5e14138e = (t)=>Array.isArray(t), $926510679e33f1b7$export$871608497c498473 = (t)=>t instanceof Date, $926510679e33f1b7$export$c10d0b04eaa80a43 = (t)=>t === null ? !1 : typeof t == "object", $926510679e33f1b7$export$4e62c701997796c1 = (t)=>t !== void 0, $926510679e33f1b7$export$fce6876652108ab = (t)=>t === void 0, $926510679e33f1b7$export$426db7a6155b7a80 = {
    boolean: $926510679e33f1b7$export$f9ce7b637dfbe238,
    array: $926510679e33f1b7$export$43bee75e5e14138e,
    object: $926510679e33f1b7$export$a6cdc56e425d0d0a,
    string: $926510679e33f1b7$export$844ec244b1367d54,
    date: $926510679e33f1b7$export$871608497c498473,
    number: $926510679e33f1b7$export$7e4aa119212bc614,
    null: $926510679e33f1b7$export$630801d484da15df,
    function: $926510679e33f1b7$export$f6e2535fb5126e54,
    objectLike: $926510679e33f1b7$export$c10d0b04eaa80a43,
    node: (0, $4Fc4U.isNode),
    htmlElement: (0, $4Fc4U.isHtmlElement),
    defined: $926510679e33f1b7$export$4e62c701997796c1
}, $926510679e33f1b7$export$226b3eccf92c9ed9 = (t)=>(...e)=>e.some((o)=>$926510679e33f1b7$export$426db7a6155b7a80[o](t)), $926510679e33f1b7$export$612ae635ef713eeb = (t)=>(...e)=>!e.some((o)=>$926510679e33f1b7$export$426db7a6155b7a80[o](t));

});
parcelRegister("4Fc4U", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $36545c3b785ef9d7$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isHtmlElement", () => $36545c3b785ef9d7$export$211442cb55fb93);
$parcel$export(module.exports, "isDOMNode", () => $36545c3b785ef9d7$export$b8eb4d3b76e486c2);

var $fXgyh = parcelRequire("fXgyh");
const $36545c3b785ef9d7$export$8ee0fc9ee280b4ee = (e)=>(typeof Node == "object" ? e instanceof (0, $fXgyh.window).Node : e && typeof e == "object" && typeof e.nodeType == "number" && typeof e.nodeName == "string") || !1, $36545c3b785ef9d7$export$211442cb55fb93 = (e)=>(typeof HTMLElement == "object" ? e instanceof (0, $fXgyh.window).HTMLElement : e && typeof e == "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string") || !1, $36545c3b785ef9d7$export$b8eb4d3b76e486c2 = (e)=>e === null || typeof e != "object" ? !1 : typeof (0, $fXgyh.window) < "u" && ((0, $fXgyh.window).Node && e instanceof (0, $fXgyh.window).Node || (0, $fXgyh.window).Window && e instanceof (0, $fXgyh.window).Window || e === (0, $fXgyh.window) || (0, $fXgyh.document) !== void 0 && e === (0, $fXgyh.document));

});


parcelRegister("jobwP", function(module, exports) {

$parcel$export(module.exports, "arrayContainsOtherArray", () => $e1d9338d2fe95fe5$export$de875babef361e5d);
$parcel$export(module.exports, "getFrequencyInArray", () => $e1d9338d2fe95fe5$export$2b3f138fefbb2e97);
$parcel$export(module.exports, "removeFromArray", () => $e1d9338d2fe95fe5$export$8af121ae7401c4);
$parcel$export(module.exports, "swapItemsInArray", () => $e1d9338d2fe95fe5$export$7e6517ca043a4c76);
$parcel$export(module.exports, "joinArrays", () => $e1d9338d2fe95fe5$export$fc359ae9633f7296);
$parcel$export(module.exports, "unstackArrayOfObjects", () => $e1d9338d2fe95fe5$export$86332fe6637020e6);
$parcel$export(module.exports, "cutArrayBeforeValue", () => $e1d9338d2fe95fe5$export$e1c90dd42d36d8f4);
$parcel$export(module.exports, "cutArrayAfterValue", () => $e1d9338d2fe95fe5$export$e9b4b966d876219d);
$parcel$export(module.exports, "removeValueFromArray", () => $e1d9338d2fe95fe5$export$7268a0a9258a5297);
$parcel$export(module.exports, "removeValueFromArrayAll", () => $e1d9338d2fe95fe5$export$91b305d65813a3f8);
$parcel$export(module.exports, "addItemAfterEveryElement", () => $e1d9338d2fe95fe5$export$aefdd0c3cb403b10);
$parcel$export(module.exports, "reorderArrayByValues", () => $e1d9338d2fe95fe5$export$402525ce1e0ae04f);
$parcel$export(module.exports, "arraysEqual", () => $e1d9338d2fe95fe5$export$234180f8206db11b);
$parcel$export(module.exports, "filterArrays", () => $e1d9338d2fe95fe5$export$e43a5cd3407a4eed);
$parcel$export(module.exports, "filterArraysFast", () => $e1d9338d2fe95fe5$export$34fca6752b16443b);
$parcel$export(module.exports, "checkIfStringIsInArray", () => $e1d9338d2fe95fe5$export$8a158988a0fbe64f);
$parcel$export(module.exports, "removeDuplicatesInArray", () => $e1d9338d2fe95fe5$export$21c00e23a20acdb3);
$parcel$export(module.exports, "addProtoToArray", () => $e1d9338d2fe95fe5$export$3369abff3c322c4c);

var $2C0hZ = parcelRequire("2C0hZ");

var $czfS0 = parcelRequire("czfS0");
const $e1d9338d2fe95fe5$export$de875babef361e5d = (e, t)=>t.every((r)=>e.includes(r)), $e1d9338d2fe95fe5$export$2b3f138fefbb2e97 = (e, t)=>{
    let r = 0;
    for(let n = 0; n < e.length; n++)e[n] === t && r++;
    return r;
}, $e1d9338d2fe95fe5$export$8af121ae7401c4 = (e, t)=>{
    if ((0, $czfS0.isString)(t) && (t = parseInt(t)), (0, $czfS0.isNumber)(t)) {
        if (t < 0 || t >= e.length || isNaN(t)) throw new Error("Invalid index");
        e.splice(t, 1);
    } else throw new Error("Invalid index");
    return e;
}, $e1d9338d2fe95fe5$export$7e6517ca043a4c76 = (e, t, r)=>{
    t < 0 || r < 0 || t >= e.length || r >= e.length || ([e[t], e[r]] = [
        e[r],
        e[t]
    ]);
}, $e1d9338d2fe95fe5$export$fc359ae9633f7296 = (...e)=>[].concat(...e), $e1d9338d2fe95fe5$export$86332fe6637020e6 = (e, t = [])=>e.reduce((r, n)=>(0, $2C0hZ.deepMerge)(r, (0, $2C0hZ.deepClone)(n, {
            exclude: t
        }), t), {}), $e1d9338d2fe95fe5$export$e1c90dd42d36d8f4 = (e, t)=>{
    const r = e.indexOf(t);
    return r !== -1 ? e.slice(0, r) : e;
}, $e1d9338d2fe95fe5$export$e9b4b966d876219d = (e, t)=>{
    if (!(0, $czfS0.isArray)(e)) return;
    const r = e.indexOf(t);
    return r !== -1 ? e.slice(r + 1) : e;
}, $e1d9338d2fe95fe5$export$7268a0a9258a5297 = (e, t)=>{
    const r = e.indexOf(t);
    if (r > -1) {
        const n = [
            ...e
        ];
        return n.splice(r, 1), n;
    }
    return e;
}, $e1d9338d2fe95fe5$export$91b305d65813a3f8 = (e, t)=>e.filter((r)=>r !== t), $e1d9338d2fe95fe5$export$aefdd0c3cb403b10 = (e, t)=>{
    const r = [];
    for(let n = 0; n < e.length; n++)r.push(e[n]), n < e.length - 1 && r.push(t);
    return r;
}, $e1d9338d2fe95fe5$export$402525ce1e0ae04f = (e, t, r)=>{
    const n = [
        ...e
    ], s = n.indexOf(t), o = n.indexOf(r);
    if (s !== -1 && o !== -1) {
        const i = n.splice(s, 1)[0], u = o < s ? o : o + 1;
        n.splice(u, 0, i);
    }
    return n;
}, $e1d9338d2fe95fe5$export$234180f8206db11b = (e, t)=>{
    if (e.length !== t.length) return !1;
    for(let r = 0; r < e.length; r++)if (e[r] !== t[r]) return !1;
    return !0;
}, $e1d9338d2fe95fe5$export$e43a5cd3407a4eed = (e, t)=>e.filter((r)=>!t.includes(r)), $e1d9338d2fe95fe5$export$34fca6752b16443b = (e, t)=>{
    const r = new Set(t);
    return e.filter((n)=>!r.has(n));
}, $e1d9338d2fe95fe5$export$8a158988a0fbe64f = (e, t)=>{
    if (!e) return 0;
    let r = 0;
    for(let n = 0; n < t.length; n++)e.includes(t[n]) && r++;
    return r;
}, $e1d9338d2fe95fe5$export$21c00e23a20acdb3 = (e)=>(0, $czfS0.isArray)(e) ? [
        ...new Set(e)
    ] : e, $e1d9338d2fe95fe5$export$3369abff3c322c4c = (e, t)=>{
    for(const r in t)Object.defineProperty(e, r, {
        value: t[r],
        enumerable: !1,
        configurable: !0,
        writable: !0
    });
};

});

parcelRegister("TarXh", function(module, exports) {

$parcel$export(module.exports, "escapeRegExp", () => $0a5d3e4cb43cf893$export$7c57da42ce8e346f);
$parcel$export(module.exports, "stringIncludesAny", () => $0a5d3e4cb43cf893$export$5e62532c096c05e0);
$parcel$export(module.exports, "trimStringFromSymbols", () => $0a5d3e4cb43cf893$export$4cb168a4c77839cc);
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", () => $0a5d3e4cb43cf893$export$7cb52b7decbd2220);
$parcel$export(module.exports, "lowercaseFirstLetter", () => $0a5d3e4cb43cf893$export$f08459d87829d2ee);
$parcel$export(module.exports, "findKeyPosition", () => $0a5d3e4cb43cf893$export$e03c69ff1d8102d5);
$parcel$export(module.exports, "replaceOctalEscapeSequences", () => $0a5d3e4cb43cf893$export$ed5844ba7edb0ac0);
$parcel$export(module.exports, "encodeNewlines", () => $0a5d3e4cb43cf893$export$56079d9b77cc851c);
$parcel$export(module.exports, "decodeNewlines", () => $0a5d3e4cb43cf893$export$d5a58d286266e59c);
$parcel$export(module.exports, "customEncodeURIComponent", () => $0a5d3e4cb43cf893$export$afdf0655b23d957b);
$parcel$export(module.exports, "customDecodeURIComponent", () => $0a5d3e4cb43cf893$export$f0dfcf6020c0b258);

var $5pnrT = parcelRequire("5pnrT");
const $0a5d3e4cb43cf893$export$7c57da42ce8e346f = (e)=>e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), $0a5d3e4cb43cf893$export$5e62532c096c05e0 = (e, r)=>{
    for (const t of r)if (e.includes(t)) return !0;
    return !1;
}, $0a5d3e4cb43cf893$export$4cb168a4c77839cc = (e, r)=>{
    const t = new RegExp(`[${r.join("\\")}]`, "g");
    return e.replace(t, "");
}, $0a5d3e4cb43cf893$var$L = {
    2: /{{\s*((?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}/g,
    3: /{{{(\s*(?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}}/g
}, $0a5d3e4cb43cf893$var$m = (e, r)=>r.split(".").reduce((t, c)=>t?.[c], e), $0a5d3e4cb43cf893$var$j = (e, r)=>{
    if (!e || !e.__ref) return !0;
    let t = e;
    for(; t;){
        if (t.allowRuntimeTemplates === !0) return !0;
        const c = t.__ref && t.__ref.__authoredTemplates;
        if (c && c.has(r)) return !0;
        t = t.parent;
    }
    return !1;
};
function $0a5d3e4cb43cf893$export$7cb52b7decbd2220(e, r, t = {}) {
    const { bracketsLength: c = 2, authored: u = !1 } = t, h = c === 3 ? "{{{" : "{{";
    if (!e.includes(h) || u !== !0 && !$0a5d3e4cb43cf893$var$j(this, e)) return e;
    const p = $0a5d3e4cb43cf893$var$L[c], g = r || this.state || {}, s = this;
    return e.replace(p, (x, n, b, f)=>{
        const a = b.trim();
        if (f) {
            const l = s?.context, o = l?.functions?.[f] || l?.utils?.[f] || l?.methods?.[f] || l?.snippets?.[f] || s?.[f];
            if (o && typeof o == "function") try {
                return String(o.call(s, a) ?? "");
            } catch  {
                return "";
            }
            return "";
        }
        if (n) {
            const l = (n.match(/\.\.\//g) || []).length;
            let o = g;
            for(let i = 0; i < l; i++){
                if (!o || !o.parent) return "";
                o = o.parent;
            }
            if (a === "parent") return String(o.value ?? "");
            const d = $0a5d3e4cb43cf893$var$m(o, a);
            return d != null && typeof d == "object" ? "" : String(d ?? "");
        } else {
            const l = $0a5d3e4cb43cf893$var$m(g, a);
            if (l != null && typeof l != "object") return String(l);
            const o = s?.context?.polyglot;
            if (o?.translations) {
                const d = (0, $5pnrT.polyglotFallbackLang)(g?.root?.lang || g?.lang || s?.context?.state?.lang, o), i = o.translations[d];
                if (i) {
                    const S = $0a5d3e4cb43cf893$var$m(i, a);
                    if (S != null && typeof S != "object") return String(S);
                    for(const w in i){
                        const y = i[w];
                        if (y && typeof y == "object" && !Array.isArray(y)) {
                            const _ = $0a5d3e4cb43cf893$var$m(y, a);
                            if (_ != null && typeof _ != "object") return String(_);
                        }
                    }
                }
                const C = $0a5d3e4cb43cf893$var$m(o.translations, a);
                if (C != null && typeof C != "object") return String(C);
            }
            return "";
        }
    });
}
const $0a5d3e4cb43cf893$export$f08459d87829d2ee = (e)=>`${e.charAt(0).toLowerCase()}${e.slice(1)}`, $0a5d3e4cb43cf893$export$e03c69ff1d8102d5 = (e, r)=>{
    const t = e.split(`
`);
    let c = -1, u = -1, h = -1, p = -1;
    const g = new RegExp(`\\b${r}\\b\\s*:\\s*`);
    let s = 0, x = !1;
    for(let n = 0; n < t.length; n++)if (g.test(t[n]) && !x) {
        if (x = !0, c = n + 1, h = t[n].indexOf(r) + 1, t[n].includes("{}")) {
            u = c, p = t[n].indexOf("{}") + 3;
            break;
        }
        const b = t[n].slice(h + r.length);
        if (b.includes("{") || b.includes("[")) s = 1;
        else {
            u = n + 1, p = t[n].length + 1;
            break;
        }
    } else if (x && (s += (t[n].match(/{/g) || []).length, s += (t[n].match(/\[/g) || []).length, s -= (t[n].match(/}/g) || []).length, s -= (t[n].match(/]/g) || []).length, s === 0)) {
        u = n + 1, p = t[n].lastIndexOf("}") !== -1 ? t[n].lastIndexOf("}") + 2 : t[n].length + 1;
        break;
    }
    return {
        startColumn: h,
        endColumn: p,
        startLineNumber: c,
        endLineNumber: u
    };
}, $0a5d3e4cb43cf893$var$R = /\\([0-7]{1,3})/g, $0a5d3e4cb43cf893$export$ed5844ba7edb0ac0 = (e)=>e.replace($0a5d3e4cb43cf893$var$R, (r, t)=>String.fromCharCode(parseInt(t, 8))), $0a5d3e4cb43cf893$export$56079d9b77cc851c = (e)=>e.replace(/\n/g, "/////n").replace(/`/g, "/////tilde").replace(/\$/g, "/////dlrsgn"), $0a5d3e4cb43cf893$export$d5a58d286266e59c = (e)=>e.replace(/\/\/\/\/\/n/g, `
`).replace(/\/\/\/\/\/tilde/g, "`").replace(/\/\/\/\/\/dlrsgn/g, "$"), $0a5d3e4cb43cf893$var$N = /[^a-zA-Z0-9\s]/g, $0a5d3e4cb43cf893$export$afdf0655b23d957b = (e)=>e.replace($0a5d3e4cb43cf893$var$N, (r)=>"%" + r.charCodeAt(0).toString(16).toUpperCase()), $0a5d3e4cb43cf893$export$f0dfcf6020c0b258 = (e)=>e.replace(/%[0-9A-Fa-f]{2}/g, (r)=>String.fromCharCode(parseInt(r.slice(1), 16)));

});
parcelRegister("5pnrT", function(module, exports) {

$parcel$export(module.exports, "POLYGLOT_LANG_STORAGE_KEY", () => $3f017a026d236ee2$export$3c0d1621bcc57436);
$parcel$export(module.exports, "POLYGLOT_TRANSLATIONS_FROM_LANG", () => $3f017a026d236ee2$export$ffec22f90a72be2b);
$parcel$export(module.exports, "polyglotTranslations", () => $3f017a026d236ee2$export$972b6166a2b4614f);
$parcel$export(module.exports, "resolvePolyglotTranslations", () => $3f017a026d236ee2$export$6cd41a1bbd5e8f35);
$parcel$export(module.exports, "withPolyglotTranslations", () => $3f017a026d236ee2$export$117102322531097);
$parcel$export(module.exports, "polyglotLangStorageKey", () => $3f017a026d236ee2$export$171ec2eb9f496ca2);
$parcel$export(module.exports, "polyglotDefaultLang", () => $3f017a026d236ee2$export$cb135cc39c6905d6);
$parcel$export(module.exports, "polyglotFallbackLang", () => $3f017a026d236ee2$export$3f8782ebdf4153c8);
$parcel$export(module.exports, "polyglotEarlyStartLang", () => $3f017a026d236ee2$export$4b1815d85f30d652);
$parcel$export(module.exports, "polyglotLanguages", () => $3f017a026d236ee2$export$7aff225fe14bd8b2);
$parcel$export(module.exports, "polyglotAddressLang", () => $3f017a026d236ee2$export$5668c7f8dc620c67);
$parcel$export(module.exports, "polyglotStartRule", () => $3f017a026d236ee2$export$31c423619641c4be);
$parcel$export(module.exports, "pickStartLang", () => $3f017a026d236ee2$export$6902338b441b7011);
$parcel$export(module.exports, "polyglotStartLang", () => $3f017a026d236ee2$export$8ceb143712d1718b);
$parcel$export(module.exports, "currentPathname", () => $3f017a026d236ee2$export$dcb6b9796f2c35a3);
$parcel$export(module.exports, "polyglotStartupScript", () => $3f017a026d236ee2$export$11969d7ddb2f06a9);


var $gjNoZ = parcelRequire("gjNoZ");
const $3f017a026d236ee2$export$3c0d1621bcc57436 = "smbls_lang", $3f017a026d236ee2$export$ffec22f90a72be2b = "designSystem.lang", $3f017a026d236ee2$var$b = (t, n)=>{
    let e = t;
    for (const o of n.split(".")){
        if (!e || typeof e != "object" || !Object.prototype.hasOwnProperty.call(e, o)) return;
        e = e[o];
    }
    return e;
}, $3f017a026d236ee2$var$c = (t)=>!!t && typeof t == "object" && !Array.isArray(t), $3f017a026d236ee2$var$x = (t)=>[
        t,
        t.config,
        t.settings
    ], $3f017a026d236ee2$export$972b6166a2b4614f = (t, n)=>{
    if (!n || typeof n != "object") return;
    const e = n.translations, o = n.translationsFrom, s = typeof o == "string" && o ? $3f017a026d236ee2$var$b(t, o) : void 0;
    if (!$3f017a026d236ee2$var$c(s)) return e;
    if (e === void 0 || e === s) return s;
    if (!$3f017a026d236ee2$var$c(e)) return e;
    const r = {
        ...s
    };
    for(const a in e){
        const i = e[a];
        r[a] = $3f017a026d236ee2$var$c(i) && $3f017a026d236ee2$var$c(s[a]) ? {
            ...s[a],
            ...i
        } : i;
    }
    return r;
}, $3f017a026d236ee2$var$u = (t)=>!!t && typeof t == "object" && typeof t.translationsFrom == "string" && !!t.translationsFrom, $3f017a026d236ee2$export$6cd41a1bbd5e8f35 = (t)=>{
    if (!t || typeof t != "object") return t;
    for (const n of $3f017a026d236ee2$var$x(t)){
        const e = n && typeof n == "object" ? n.polyglot : null;
        if (!$3f017a026d236ee2$var$u(e)) continue;
        const o = $3f017a026d236ee2$export$972b6166a2b4614f(t, e);
        o !== void 0 && o !== e.translations && (e.translations = o);
    }
    return t;
}, $3f017a026d236ee2$export$117102322531097 = (t)=>{
    if (!t || typeof t != "object") return t;
    let n = t;
    const e = ()=>n === t ? n = {
            ...t
        } : n;
    if ($3f017a026d236ee2$var$u(t.polyglot)) {
        const o = $3f017a026d236ee2$export$972b6166a2b4614f(t, t.polyglot);
        o !== void 0 && o !== t.polyglot.translations && (e().polyglot = {
            ...t.polyglot,
            translations: o
        });
    }
    for (const o of [
        "config",
        "settings"
    ]){
        const s = t[o], r = s && typeof s == "object" ? s.polyglot : null;
        if (!$3f017a026d236ee2$var$u(r)) continue;
        const a = $3f017a026d236ee2$export$972b6166a2b4614f(t, r);
        a !== void 0 && a !== r.translations && (e()[o] = {
            ...s,
            polyglot: {
                ...r,
                translations: a
            }
        });
    }
    return n;
}, $3f017a026d236ee2$export$171ec2eb9f496ca2 = (t)=>t && t.storageLangKey || $3f017a026d236ee2$export$3c0d1621bcc57436, $3f017a026d236ee2$export$cb135cc39c6905d6 = (t)=>{
    let n = t && t.defaultLang;
    if (typeof n == "function") try {
        n = n(t);
    } catch  {
        n = null;
    }
    return typeof n == "string" && n && !(0, $gjNoZ.isStringFunction)(n) ? n : null;
}, $3f017a026d236ee2$export$3f8782ebdf4153c8 = (t, n)=>t || $3f017a026d236ee2$export$cb135cc39c6905d6(n) || "en", $3f017a026d236ee2$var$m = "@symbo.ls/fetch:EARLY", $3f017a026d236ee2$export$4b1815d85f30d652 = (t)=>{
    try {
        const n = t && t[Symbol.for($3f017a026d236ee2$var$m)], e = n && n.startLang;
        return typeof e == "string" && e ? e : null;
    } catch  {
        return null;
    }
}, $3f017a026d236ee2$export$7aff225fe14bd8b2 = (t, n = !0)=>{
    let e = t && t.languages;
    if (typeof e == "function") try {
        e = e(t);
    } catch  {
        e = null;
    }
    return Array.isArray(e) && e.length ? e.filter((o)=>typeof o == "string") : n ? Object.keys(t && t.translations || {}) : [];
}, $3f017a026d236ee2$export$5668c7f8dc620c67 = (t, n)=>{
    if (!n) return null;
    const e = $3f017a026d236ee2$export$7aff225fe14bd8b2(n), o = /^\/([^/?#]+)/.exec(String(t || ""));
    if (!o) return null;
    const s = o[1].toLowerCase();
    for (const r of e)if (typeof r == "string" && r.toLowerCase() === s) return r;
    return null;
}, $3f017a026d236ee2$export$31c423619641c4be = (t, n)=>{
    const e = $3f017a026d236ee2$export$7aff225fe14bd8b2(t), o = t && t.addressLang, s = o && typeof o == "object" && !Array.isArray(o), r = s ? o.mode : o, a = {
        languages: e,
        address: r === !1 ? !1 : r === "fallback" || r === "strict" ? r : !0,
        fallback: $3f017a026d236ee2$export$3f8782ebdf4153c8(n, t)
    }, i = s && Array.isArray(o.except) ? o.except.filter((f)=>typeof f == "string" && f) : [];
    return i.length && (a.except = i), a;
}, $3f017a026d236ee2$export$6902338b441b7011 = (t, n, e)=>{
    if (t && t.except && t.except.length) {
        const s = String(n || "").split(/[?#]/)[0].split("/").filter(Boolean);
        for(let r = 0; r < t.except.length; r++){
            const a = String(t.except[r]).split("/").filter(Boolean);
            if (a[a.length - 1] === "*" && a.pop(), a.length > s.length) continue;
            let i = !0;
            for(let f = 0; f < a.length && i; f++)a[f].charAt(0) !== ":" && a[f] !== s[f] && (i = !1);
            if (i) {
                t = {
                    languages: t.languages,
                    address: t.address !== !1,
                    fallback: t.fallback
                };
                break;
            }
        }
    }
    let o = null;
    if (t && t.address !== !1) {
        const s = /^\/([^/?#]+)/.exec(String(n || "")), r = t && t.languages || [];
        if (s) {
            const a = s[1].toLowerCase();
            for(let i = 0; i < r.length && !o; i++)String(r[i]).toLowerCase() === a && (o = r[i]);
        }
    }
    return o && (t.address !== "fallback" || !e) ? o : t && t.address === "strict" ? t.fallback || "" : e || t && t.fallback || "";
}, $3f017a026d236ee2$export$8ceb143712d1718b = ({ polyglot: t, pathname: n, stored: e, stateLang: o, started: s } = {})=>typeof s == "string" && s || $3f017a026d236ee2$export$6902338b441b7011($3f017a026d236ee2$export$31c423619641c4be(t, o), n, e), $3f017a026d236ee2$export$dcb6b9796f2c35a3 = (t)=>{
    try {
        const n = t && t.location || typeof globalThis < "u" && globalThis.location;
        return n && typeof n.pathname == "string" ? n.pathname : "";
    } catch  {
        return "";
    }
}, $3f017a026d236ee2$export$11969d7ddb2f06a9 = ({ polyglot: t, translations: n, lang: e, pathname: o, attrs: s = "" } = {})=>{
    if (!n || typeof n != "object") return "";
    const r = t && t.storagePrefix || "", a = t && t.storageLangKey || "", i = [];
    for(const f in n){
        const l = n[f];
        l && typeof l == "object" && i.push(`localStorage.setItem(${JSON.stringify(r + f)},${JSON.stringify(JSON.stringify(l))})`);
    }
    if (a) {
        const f = e || $3f017a026d236ee2$export$5668c7f8dc620c67(o, t) || $3f017a026d236ee2$export$3f8782ebdf4153c8(void 0, t);
        i.push(`if(!localStorage.getItem(${JSON.stringify(a)}))localStorage.setItem(${JSON.stringify(a)},${JSON.stringify(f)})`);
    }
    return i.length ? `<script${s}>try{${i.join(";")}}catch(e){}<\/script>` : "";
};

});
parcelRegister("gjNoZ", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $be14bde5e7b6586b$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "debounceOnContext", () => $be14bde5e7b6586b$export$d3757b91c00af798);
$parcel$export(module.exports, "memoize", () => $be14bde5e7b6586b$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "isStringFunction", () => $be14bde5e7b6586b$export$6f017d9966fe4675);
$parcel$export(module.exports, "hasHandlerPlugin", () => $be14bde5e7b6586b$export$2390d6692fc3136c);
$parcel$export(module.exports, "resolveHandler", () => $be14bde5e7b6586b$export$b8a07dcb2ff3a5ee);
$parcel$export(module.exports, "runPluginHook", () => $be14bde5e7b6586b$export$debb685cc6ca2768);
$parcel$export(module.exports, "cloneFunction", () => $be14bde5e7b6586b$export$5c7d787bf6cea16b);
function $be14bde5e7b6586b$export$61fc7d43ac8f84b0(t, e, o) {
    let n;
    return function() {
        const r = this, s = arguments, u = function() {
            n = null, o || t.apply(r, s);
        }, c = o && !n;
        clearTimeout(n), n = setTimeout(u, e), c && t.apply(r, s);
    };
}
const $be14bde5e7b6586b$export$d3757b91c00af798 = (t, e, o = 300)=>{
    let n;
    return (...r)=>{
        clearTimeout(n), n = setTimeout(()=>{
            e.apply(t, r);
        }, o);
    };
}, $be14bde5e7b6586b$export$fc10aeed3a532e2a = (t)=>{
    const e = {};
    return (...o)=>{
        const n = o[0];
        if (n in e) return e[n];
        {
            const r = t(n);
            return e[n] = r, r;
        }
    };
}, $be14bde5e7b6586b$var$i = /^\s*(?:async\s+)?(?:function\b|\([^)]*\)\s*=>|[a-zA-Z_$][\w$]*\s*=>)/, $be14bde5e7b6586b$export$6f017d9966fe4675 = (t)=>$be14bde5e7b6586b$var$i.test(t), $be14bde5e7b6586b$export$2390d6692fc3136c = (t)=>{
    const e = t?.plugins;
    if (!e || !e.length) return !1;
    for (const o of e)if (o.resolveHandler) return !0;
    return !1;
}, $be14bde5e7b6586b$export$b8a07dcb2ff3a5ee = (t, e)=>{
    if (typeof t == "function") return t;
    const o = e?.context?.plugins;
    if (!o) return t;
    for (const n of o)if (n.resolveHandler) {
        const r = n.resolveHandler(t, e);
        if (typeof r == "function") return r;
    }
    return t;
}, $be14bde5e7b6586b$export$debb685cc6ca2768 = (t, e, ...o)=>{
    const n = e?.context?.plugins;
    if (!n) return !1;
    let r = !1;
    for (const s of n)typeof s[t] == "function" && (s[t](e, ...o), r = !0);
    return r;
};
function $be14bde5e7b6586b$export$5c7d787bf6cea16b(t, e = window) {
    const o = function() {
        return t.apply(e, arguments);
    };
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && (o[n] = t[n]);
    return o;
}

});



parcelRegister("cjyfe", function(module, exports) {

$parcel$export(module.exports, "DOMQ_PROPERTIES", () => $8f71d2accb7a74a8$export$c7d5e7f7bf0dae25);
$parcel$export(module.exports, "PARSED_DOMQ_PROPERTIES", () => $8f71d2accb7a74a8$export$965c4b042127881f);
$parcel$export(module.exports, "STATE_PROPERTIES", () => $8f71d2accb7a74a8$export$a42fe85dc7bbfd49);
$parcel$export(module.exports, "STATE_METHODS", () => $8f71d2accb7a74a8$export$76c843b7166304af);
$parcel$export(module.exports, "PROPS_METHODS", () => $8f71d2accb7a74a8$export$36cad52ffe088573);
$parcel$export(module.exports, "METHODS", () => $8f71d2accb7a74a8$export$f0748ddc99f937c7);
$parcel$export(module.exports, "isBuiltinElementMethod", () => $8f71d2accb7a74a8$export$fe7c23b39c8941a6);
$parcel$export(module.exports, "ELEMENT_METHOD_OVERRIDE_POINTS", () => $8f71d2accb7a74a8$export$c2621bc2bb398b8c);
$parcel$export(module.exports, "isProtectedElementMethod", () => $8f71d2accb7a74a8$export$1f56b4ea59b0c0f5);
$parcel$export(module.exports, "PROTOTYPE_KEYS", () => $8f71d2accb7a74a8$export$3fcdd1405bde988f);
$parcel$export(module.exports, "METHODS_EXL", () => $8f71d2accb7a74a8$export$7f0c3d30e5984c9d);
$parcel$export(module.exports, "DOMQL_EVENTS", () => $8f71d2accb7a74a8$export$194d3d0e15158f0b);
const $8f71d2accb7a74a8$export$c7d5e7f7bf0dae25 = new Set([
    "attr",
    "style",
    "text",
    "html",
    "content",
    "data",
    "classlist",
    "state",
    "scope",
    "root",
    "deps",
    "extend",
    "extends",
    "$router",
    "routes",
    "children",
    "childExtend",
    "childExtends",
    "childExtendRecursive",
    "childExtendsRecursive",
    "props",
    "if",
    "define",
    "__name",
    "__ref",
    "__hash",
    "__text",
    "key",
    "tag",
    "query",
    "parent",
    "node",
    "variables",
    "on",
    "fetch",
    "component",
    "context",
    "preventContentUpdate",
    "preventContentRecreate"
]), $8f71d2accb7a74a8$export$965c4b042127881f = new Set([
    "attr",
    "style",
    "text",
    "html",
    "content",
    "data",
    "class",
    "state",
    "scope",
    "children",
    "props",
    "if",
    "key",
    "tag",
    "query",
    "on",
    "context"
]), $8f71d2accb7a74a8$export$a42fe85dc7bbfd49 = [
    "ref",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "root"
], $8f71d2accb7a74a8$export$76c843b7166304af = new Set([
    "update",
    "parse",
    "clean",
    "create",
    "destroy",
    "add",
    "toggle",
    "remove",
    "apply",
    "set",
    "reset",
    "replace",
    "quietReplace",
    "quietUpdate",
    "applyReplace",
    "applyFunction",
    "keys",
    "values",
    "ref",
    "rootUpdate",
    "parentUpdate",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "root",
    "setByPath",
    "setPathCollection",
    "removeByPath",
    "removePathCollection",
    "getByPath"
]), $8f71d2accb7a74a8$export$36cad52ffe088573 = new Set([
    "update",
    "__element"
]), $8f71d2accb7a74a8$export$f0748ddc99f937c7 = new Set([
    "set",
    "reset",
    "update",
    "remove",
    "updateContent",
    "removeContent",
    "lookup",
    "lookdown",
    "lookdownAll",
    "whenConnected",
    "getRef",
    "getPath",
    "setNodeStyles",
    "spotByPath",
    "keys",
    "parse",
    "setProps",
    "parseDeep",
    "variables",
    "if",
    "log",
    "verbose",
    "warn",
    "error",
    "call",
    "nextElement",
    "previousElement",
    "getRootState",
    "getRoot",
    "getRootData",
    "getRootContext",
    "getContext",
    "getQuery",
    "getDB",
    "getChildren",
    "getAdoption",
    "facesReady",
    "checkFaces",
    "preventContentUpdate",
    "preventContentRecreate"
]), $8f71d2accb7a74a8$export$fe7c23b39c8941a6 = (e)=>$8f71d2accb7a74a8$export$f0748ddc99f937c7.has(e), $8f71d2accb7a74a8$export$c2621bc2bb398b8c = new Set([
    "log",
    "warn",
    "error",
    "verbose"
]), $8f71d2accb7a74a8$export$1f56b4ea59b0c0f5 = (e)=>$8f71d2accb7a74a8$export$f0748ddc99f937c7.has(e) && !$8f71d2accb7a74a8$export$c2621bc2bb398b8c.has(e), $8f71d2accb7a74a8$export$3fcdd1405bde988f = new Set([
    "__proto__",
    "constructor",
    "prototype"
]), $8f71d2accb7a74a8$export$7f0c3d30e5984c9d = new Set([
    "node",
    "context",
    "extends",
    "__element",
    "__ref",
    ...$8f71d2accb7a74a8$export$f0748ddc99f937c7,
    ...$8f71d2accb7a74a8$export$76c843b7166304af,
    ...$8f71d2accb7a74a8$export$36cad52ffe088573
]), $8f71d2accb7a74a8$export$194d3d0e15158f0b = new Set([
    "init",
    "beforeClassAssign",
    "render",
    "renderRouter",
    "attachNode",
    "stateInit",
    "stateCreated",
    "beforeStateUpdate",
    "stateUpdate",
    "beforeUpdate",
    "done",
    "create",
    "complete",
    "frame",
    "update",
    "fetchError",
    "fetchComplete"
]);

});

parcelRegister("hjm5u", function(module, exports) {

$parcel$export(module.exports, "scopeReceiverExpression", () => $c9a5582432b3da8e$export$8c5c68fce0e10593);
$parcel$export(module.exports, "scopeElementParam", () => $c9a5582432b3da8e$export$93b8642a5e198e82);
$parcel$export(module.exports, "repairLegacyArrowScopePreamble", () => $c9a5582432b3da8e$export$a3122631891d550f);
const $c9a5582432b3da8e$var$g = [
    "$R?.scope ?? $R?.context?.globalScope ?? {}",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && Object.getPrototypeOf(s) !== g) Object.setPrototypeOf(s, g); return s ?? g ?? {}; })()",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) Object.setPrototypeOf(s, g); return s ?? g ?? {}; })()",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) { try { Object.setPrototypeOf(s, g) } catch (_) {} } return s ?? g ?? {}; })()",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) { let __p = g, __cyc = false; while (__p) { if (__p === s) { __cyc = true; break } __p = Object.getPrototypeOf(__p) } if (!__cyc) { try { Object.setPrototypeOf(s, g) } catch (_) {} } } return s ?? g ?? {}; })()",
    "(() => { const r = $R; const s = r?.scope; const g = r?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) { let __p = g, __cyc = false; while (__p) { if (__p === s) { __cyc = true; break } __p = Object.getPrototypeOf(__p) } if (!__cyc) { try { Object.setPrototypeOf(s, g) } catch (_) {} } } return s ?? g ?? (r && typeof r === 'object' && r !== globalThis ? r : {}); })()"
], $c9a5582432b3da8e$var$i = (t, o)=>t.split("$R").join(o), $c9a5582432b3da8e$var$y = $c9a5582432b3da8e$var$g.map((t)=>[
        $c9a5582432b3da8e$var$i(t, "this"),
        t
    ]), $c9a5582432b3da8e$export$8c5c68fce0e10593 = (t)=>$c9a5582432b3da8e$var$i($c9a5582432b3da8e$var$g[$c9a5582432b3da8e$var$g.length - 1], t), $c9a5582432b3da8e$var$f = "const __scope = ", $c9a5582432b3da8e$var$O = /^\(globalThis\[Symbol\.for\('smbls\.libraryScope'\)\] \|\| \(\(_, v\) => v\)\)\("(?:[^"\\]|\\.)*", /, $c9a5582432b3da8e$var$b = /^\s*(?:async\s*)?(?:\(([^()[\]{}'"`/]*)\)|([A-Za-z_$][\w$]*))\s*=>\s*\{\s*/, $c9a5582432b3da8e$var$u = /^[A-Za-z_$][\w$]*$/, $c9a5582432b3da8e$var$n = (t, o)=>typeof t == "string" && new RegExp("^" + o + "\\d*$").test(t), $c9a5582432b3da8e$export$93b8642a5e198e82 = (t, o)=>{
    if (t.length >= 2 && $c9a5582432b3da8e$var$n(t[0], "el")) return t[0];
    if (t.length >= 2 && $c9a5582432b3da8e$var$n(t[1], "el")) return t[1];
    if (t.length >= 1 && $c9a5582432b3da8e$var$n(t[0], "el") || $c9a5582432b3da8e$var$n(t[0], "element") || $c9a5582432b3da8e$var$n(t[0], "node")) return t[0];
    if (typeof o == "function") {
        const e = o();
        if (e && t.includes(e)) return e;
    }
    return t.find((e)=>$c9a5582432b3da8e$var$n(e, "element")) || null;
}, $c9a5582432b3da8e$export$a3122631891d550f = (t)=>{
    if (typeof t != "string" || t.indexOf($c9a5582432b3da8e$var$f) === -1 || t.indexOf("this") === -1) return t;
    const o = $c9a5582432b3da8e$var$b.exec(t);
    if (!o) return t;
    let e = o[0].length;
    if (!t.startsWith($c9a5582432b3da8e$var$f, e)) return t;
    e += $c9a5582432b3da8e$var$f.length;
    const c = $c9a5582432b3da8e$var$O.exec(t.slice(e, e + 400));
    c && (e += c[0].length);
    const r = $c9a5582432b3da8e$var$y.find(([s])=>t.startsWith(s, e));
    if (!r) return t;
    const l = e + r[0].length;
    if (t[l] !== (c ? ")" : ";")) return t;
    const _ = (o[1] !== void 0 ? o[1] : o[2]).split(",").map((s)=>s.split("=")[0].trim()).filter(Boolean);
    if (_.some((s)=>!$c9a5582432b3da8e$var$u.test(s))) return t;
    const p = $c9a5582432b3da8e$export$93b8642a5e198e82(_);
    return p ? t.slice(0, e) + $c9a5582432b3da8e$var$i(r[1], p) + t.slice(l) : t;
};

});



parcelRegister("dSdIt", function(module, exports) {

$parcel$export(module.exports, "NODE_ENV", () => $a19af5440453de3a$export$dd8826725fa2a3d4);
$parcel$export(module.exports, "ENV", () => $a19af5440453de3a$export$83401e34d5e11bf4);
$parcel$export(module.exports, "isProduction", () => $a19af5440453de3a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $a19af5440453de3a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "isTesting", () => $a19af5440453de3a$export$9592e006a670b581);
$parcel$export(module.exports, "isStaging", () => $a19af5440453de3a$export$23da1d24a38b0bde);
$parcel$export(module.exports, "isLocal", () => $a19af5440453de3a$export$6dd1bbd39f571125);
$parcel$export(module.exports, "isDevelopment", () => $a19af5440453de3a$export$df77466336fe5355);
$parcel$export(module.exports, "getNev", () => $a19af5440453de3a$export$d84272657cb7c466);
$parcel$export(module.exports, "isNotProduction", () => $a19af5440453de3a$export$eda5083784a7e709);
$parcel$export(module.exports, "isLoudDevRuntime", () => $a19af5440453de3a$export$3452e66ea0c4d82f);
// @preserve-env
const $a19af5440453de3a$export$dd8826725fa2a3d4 = "production", $a19af5440453de3a$export$83401e34d5e11bf4 = $a19af5440453de3a$export$dd8826725fa2a3d4, $a19af5440453de3a$export$f15d00aa73aafac4 = (t = $a19af5440453de3a$export$dd8826725fa2a3d4)=>t === "production", $a19af5440453de3a$export$410cbc2864fa25b5 = (t = $a19af5440453de3a$export$dd8826725fa2a3d4)=>t === "testing" || t === "test", $a19af5440453de3a$export$9592e006a670b581 = $a19af5440453de3a$export$410cbc2864fa25b5, $a19af5440453de3a$export$23da1d24a38b0bde = (t = $a19af5440453de3a$export$dd8826725fa2a3d4)=>t === "staging", $a19af5440453de3a$export$6dd1bbd39f571125 = (t = $a19af5440453de3a$export$dd8826725fa2a3d4)=>t === "local", $a19af5440453de3a$export$df77466336fe5355 = (t = $a19af5440453de3a$export$dd8826725fa2a3d4)=>t === "development" || t === "dev" || t === "local", $a19af5440453de3a$export$d84272657cb7c466 = (t, e = $a19af5440453de3a$export$dd8826725fa2a3d4)=>e[t], $a19af5440453de3a$export$eda5083784a7e709 = (t = $a19af5440453de3a$export$dd8826725fa2a3d4)=>!$a19af5440453de3a$export$f15d00aa73aafac4(t), $a19af5440453de3a$export$3452e66ea0c4d82f = (t)=>{
    if (!t && true) return !1;
    const e = t && "env" in t ? t.env : void 0;
    if (e && e !== "production") return !0;
    const n = t && "hostname" in t ? t.hostname : typeof location < "u" ? location.hostname : void 0;
    return typeof n == "string" && n ? n === "localhost" || n === "127.0.0.1" || n.endsWith(".localhost") : !1;
};

});

parcelRegister("lWD5b", function(module, exports) {

$parcel$export(module.exports, "createIfConditionFlag", () => $ff9d54c4ffabd653$export$62115f5848b33107);

var $czfS0 = parcelRequire("czfS0");

var $2C0hZ = parcelRequire("2C0hZ");
const $ff9d54c4ffabd653$export$62115f5848b33107 = (e, c)=>{
    const { __ref: t } = e, i = e.if;
    if ((0, $czfS0.isFunction)(i)) {
        let o;
        try {
            o = i(e, e.state, e.context);
        } catch (r) {
            typeof console < "u" && console.warn("[DOMQL] if condition error:", r), delete t.__if;
            return;
        }
        o ? t.__if = !0 : delete t.__if;
    } else i != null && typeof i == "object" ? (0, $2C0hZ.exec)(i, e) ? t.__if = !0 : delete t.__if : t.__if = !0;
};

});

parcelRegister("1hhFt", function(module, exports) {

$parcel$export(module.exports, "logIf", () => $0ee515754db3fff1$export$f3730dd3d285b7c6);
$parcel$export(module.exports, "logGroupIf", () => $0ee515754db3fff1$export$7cea94b68a0c230b);
const $0ee515754db3fff1$export$f3730dd3d285b7c6 = (l, ...o)=>{
    l && o.map((s)=>console.log(s));
}, $0ee515754db3fff1$export$7cea94b68a0c230b = (l, o, ...s)=>{
    l && (console.group(o), s.map((c)=>console.log(c)), console.groupEnd(o));
};

});

parcelRegister("hi618", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $c968c90783180221$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "setCookie", () => $c968c90783180221$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $c968c90783180221$export$4be65e66cfa2648a);
$parcel$export(module.exports, "removeCookie", () => $c968c90783180221$export$6a874b7a74007875);
$parcel$export(module.exports, "getLocalStorage", () => $c968c90783180221$export$d3720feff416e85b);
$parcel$export(module.exports, "setLocalStorage", () => $c968c90783180221$export$1f73f60bdb811cb1);

var $czfS0 = parcelRequire("czfS0");

var $fXgyh = parcelRequire("fXgyh");
const $c968c90783180221$export$d0a8044dce8ff2fc = typeof navigator > "u" ? !1 : /Mobi/.test(navigator.userAgent), $c968c90783180221$export$110700823644f4a6 = (t, e, n = 365)=>{
    if ((0, $czfS0.isUndefined)((0, $fXgyh.document)) || (0, $czfS0.isUndefined)((0, $fXgyh.document).cookie)) return;
    const r = new Date;
    r.setTime(r.getTime() + n * 86400000);
    const s = `expires=${r.toUTCString()}`;
    (0, $fXgyh.document).cookie = `${t}=${e};${s};path=/`;
}, $c968c90783180221$export$4be65e66cfa2648a = (t)=>{
    if ((0, $czfS0.isUndefined)((0, $fXgyh.document)) || (0, $czfS0.isUndefined)((0, $fXgyh.document).cookie)) return;
    const e = `${t}=`, r = decodeURIComponent((0, $fXgyh.document).cookie).split(";");
    for(let s = 0; s < r.length; s++){
        let i = r[s];
        for(; i.charAt(0) === " ";)i = i.substring(1);
        if (i.indexOf(e) === 0) return i.substring(e.length, i.length);
    }
    return "";
}, $c968c90783180221$export$6a874b7a74007875 = (t)=>{
    (0, $czfS0.isUndefined)((0, $fXgyh.document)) || (0, $czfS0.isUndefined)((0, $fXgyh.document).cookie) || ((0, $fXgyh.document).cookie = t + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
};
function $c968c90783180221$export$d3720feff416e85b(t) {
    let e;
    try {
        if (!window.localStorage) return;
        e = window.localStorage.getItem(t);
    } catch  {
        return;
    }
    if (e !== null) try {
        return JSON.parse(e);
    } catch  {
        return;
    }
}
function $c968c90783180221$export$1f73f60bdb811cb1(t, e) {
    if (e != null) try {
        if (!window.localStorage) return;
        const n = typeof e == "object" ? JSON.stringify(e) : e;
        window.localStorage.setItem(t, n);
    } catch  {}
}

});

parcelRegister("fDTgW", function(module, exports) {

$parcel$export(module.exports, "HTML_TAGS", () => $b6355f78792778cb$export$4c3fa92ca590c71f);
$parcel$export(module.exports, "SVG_TAGS", () => $b6355f78792778cb$export$23d5ae6d2560d158);
$parcel$export(module.exports, "isValidHtmlTag", () => $b6355f78792778cb$export$52675ca41d41c093);
const $b6355f78792778cb$export$4c3fa92ca590c71f = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style",
        "noscript",
        "script"
    ],
    body: new Set([
        "string",
        "style",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "search",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "hgroup",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "hgroup",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        "svg",
        "path",
        "circle",
        "ellipse",
        "line",
        "polygon",
        "polyline",
        "rect",
        "g",
        "defs",
        "symbol",
        "use",
        "text",
        "tspan",
        "image",
        "clipPath",
        "mask",
        "pattern",
        "marker",
        "linearGradient",
        "radialGradient",
        "stop",
        "filter",
        "feGaussianBlur",
        "feOffset",
        "feMerge",
        "feMergeNode",
        "feBlend",
        "feColorMatrix",
        "feFlood",
        "feComposite",
        "foreignObject"
    ])
}, $b6355f78792778cb$export$23d5ae6d2560d158 = new Set([
    "svg",
    "path",
    "circle",
    "ellipse",
    "line",
    "polygon",
    "polyline",
    "rect",
    "g",
    "defs",
    "symbol",
    "use",
    "text",
    "tspan",
    "image",
    "clipPath",
    "mask",
    "pattern",
    "marker",
    "linearGradient",
    "radialGradient",
    "stop",
    "filter",
    "feGaussianBlur",
    "feOffset",
    "feMerge",
    "feMergeNode",
    "feBlend",
    "feColorMatrix",
    "feFlood",
    "feComposite",
    "foreignObject"
]), $b6355f78792778cb$export$52675ca41d41c093 = (e)=>$b6355f78792778cb$export$4c3fa92ca590c71f.body.has(e);

});

parcelRegister("gx70P", function(module, exports) {

$parcel$export(module.exports, "matchesComponentNaming", () => $c0952ae705b61b11$export$7ee0520502076834);
$parcel$export(module.exports, "getCapitalCaseKeys", () => $c0952ae705b61b11$export$ef62ecae187000fa);
$parcel$export(module.exports, "getSpreadChildren", () => $c0952ae705b61b11$export$e3565e6b9e497c79);
$parcel$export(module.exports, "isContextComponent", () => $c0952ae705b61b11$export$5869b4db06e1780c);

var $5UBxb = parcelRequire("5UBxb");

var $czfS0 = parcelRequire("czfS0");
const $c0952ae705b61b11$export$7ee0520502076834 = (t)=>{
    if (!(0, $czfS0.isString)(t) || !t.length) return !1;
    const e = t.charCodeAt(0);
    return e >= 65 && e <= 90;
};
function $c0952ae705b61b11$export$ef62ecae187000fa(t) {
    return Object.keys(t).filter((e)=>/^[A-Z]/.test(e));
}
function $c0952ae705b61b11$export$e3565e6b9e497c79(t) {
    return Object.keys(t).filter((e)=>/^\d+$/.test(e));
}
function $c0952ae705b61b11$export$5869b4db06e1780c(t, e, n) {
    const { context: o } = e || {}, [s] = (0, $5UBxb.createExtendsFromKeys)(n), r = n || s;
    return o?.components?.[r] || o?.pages?.[r];
}

});
parcelRegister("5UBxb", function(module, exports) {

$parcel$export(module.exports, "collectExtendsList", () => $44df4c3d2bf55183$export$59fa98fbbc577a08);
$parcel$export(module.exports, "toPriorityOrder", () => $44df4c3d2bf55183$export$e5703851d4f70876);
$parcel$export(module.exports, "createExtendsFromKeys", () => $44df4c3d2bf55183$export$f99aa3442ed267f1);
$parcel$export(module.exports, "createExtends", () => $44df4c3d2bf55183$export$7c6fdf32f38bef77);
$parcel$export(module.exports, "addExtends", () => $44df4c3d2bf55183$export$3200adf97fb998d9);
$parcel$export(module.exports, "concatAddExtends", () => $44df4c3d2bf55183$export$cfa74393132ebcec);
$parcel$export(module.exports, "generateHash", () => $44df4c3d2bf55183$export$daf4c137c5f56404);
$parcel$export(module.exports, "extendStackRegistry", () => $44df4c3d2bf55183$export$476cb8ab9adcdb0d);
$parcel$export(module.exports, "extendCachedRegistry", () => $44df4c3d2bf55183$export$bc442b6cc8c83971);
$parcel$export(module.exports, "getHashedExtend", () => $44df4c3d2bf55183$export$46ce3405574370c6);
$parcel$export(module.exports, "setHashedExtend", () => $44df4c3d2bf55183$export$8c8f2806a2edf07f);
$parcel$export(module.exports, "getExtendsStackRegistry", () => $44df4c3d2bf55183$export$c4fe3c170ecffa69);
$parcel$export(module.exports, "extractArrayExtend", () => $44df4c3d2bf55183$export$2c118161a655606a);
$parcel$export(module.exports, "flattenExtend", () => $44df4c3d2bf55183$export$802e3e1ed5ecb3f2);
$parcel$export(module.exports, "deepExtend", () => $44df4c3d2bf55183$export$54e9fb29908872fa);
$parcel$export(module.exports, "mapStringsWithContextComponents", () => $44df4c3d2bf55183$export$325609fc8b225e02);
$parcel$export(module.exports, "deepMergeExtends", () => $44df4c3d2bf55183$export$e0fa903e42ff191c);
$parcel$export(module.exports, "cloneAndMergeArrayExtend", () => $44df4c3d2bf55183$export$e2e460d82983fb19);
$parcel$export(module.exports, "SHADOWED_COMPONENTS", () => $44df4c3d2bf55183$export$12e31956818b1112);
$parcel$export(module.exports, "shadowedComponentsOf", () => $44df4c3d2bf55183$export$5d45cc29c7be5fee);
$parcel$export(module.exports, "recordShadowedComponent", () => $44df4c3d2bf55183$export$65341a0947ab8813);
$parcel$export(module.exports, "resolveComponentTier", () => $44df4c3d2bf55183$export$40eb3eae1d715a09);
$parcel$export(module.exports, "jointStacks", () => $44df4c3d2bf55183$export$f9f936cf352c3af2);
$parcel$export(module.exports, "getExtendsStack", () => $44df4c3d2bf55183$export$f39bb847e2d05ef6);
$parcel$export(module.exports, "addExtend", () => $44df4c3d2bf55183$export$2f41615046006887);
$parcel$export(module.exports, "getExtendsInElement", () => $44df4c3d2bf55183$export$a23334bdec459c3a);
$parcel$export(module.exports, "createElementExtends", () => $44df4c3d2bf55183$export$5adee993743866c4);
$parcel$export(module.exports, "inheritChildPropsExtends", () => $44df4c3d2bf55183$export$330789d8e1f3b311);
$parcel$export(module.exports, "inheritChildExtends", () => $44df4c3d2bf55183$export$dde729987f06f311);
$parcel$export(module.exports, "inheritRecursiveChildExtends", () => $44df4c3d2bf55183$export$4426caec5c659cae);
$parcel$export(module.exports, "createExtendsStack", () => $44df4c3d2bf55183$export$5625cedc68348886);
$parcel$export(module.exports, "finalizeExtends", () => $44df4c3d2bf55183$export$eef12a49036578e9);
$parcel$export(module.exports, "applyExtends", () => $44df4c3d2bf55183$export$1ac92e2b1d1a0b6d);

var $jobwP = parcelRequire("jobwP");

var $gx70P = parcelRequire("gx70P");

var $2C0hZ = parcelRequire("2C0hZ");

var $czfS0 = parcelRequire("czfS0");
const $44df4c3d2bf55183$var$v = "production", $44df4c3d2bf55183$var$j = (t)=>t.sourcemap !== !1 && $44df4c3d2bf55183$var$v !== "production", $44df4c3d2bf55183$export$59fa98fbbc577a08 = (t)=>{
    if (!t) return [];
    const r = [], s = t.extends;
    s && ((0, $czfS0.isArray)(s) ? r.push(...s) : r.push(s));
    const n = t.extend;
    return n && ((0, $czfS0.isArray)(n) ? r.push(...n) : r.push(n)), r;
}, $44df4c3d2bf55183$export$e5703851d4f70876 = (t)=>{
    if (!(0, $czfS0.isArray)(t)) return t;
    const r = [];
    for(let s = t.length - 1; s >= 0; s--){
        const n = t[s];
        r.push((0, $czfS0.isArray)(n) ? $44df4c3d2bf55183$export$e5703851d4f70876(n) : n);
    }
    return r;
}, $44df4c3d2bf55183$export$f99aa3442ed267f1 = (t)=>{
    if (t.includes("+")) return t.split("+").filter((0, $gx70P.matchesComponentNaming));
    if (t.includes("_")) {
        const [r] = t.split("_");
        return [
            r
        ];
    }
    if (t.includes(".") && !(0, $gx70P.matchesComponentNaming)(t.split(".")[1])) {
        const [r] = t.split(".");
        return [
            r
        ];
    }
    return [
        t
    ];
}, $44df4c3d2bf55183$export$7c6fdf32f38bef77 = (t, r, s)=>{
    let n = [];
    const e = $44df4c3d2bf55183$export$f99aa3442ed267f1(s);
    e && (n = [
        ...e
    ]);
    const o = $44df4c3d2bf55183$export$e5703851d4f70876($44df4c3d2bf55183$export$59fa98fbbc577a08(t));
    return o.length && (n = [
        ...n,
        ...o
    ]), n;
}, $44df4c3d2bf55183$export$3200adf97fb998d9 = (t, r)=>{
    const { __ref: s } = r;
    let { __extends: n } = s;
    if (!t) return n;
    const e = r.variant, o = r.context;
    if (e && o?.components && !Array.isArray(t) && typeof t == "string") {
        const i = `${t}.${e}`;
        o.components[i] && (t = i);
    }
    return n.includes(t) || (n = Array.isArray(t) ? [
        ...n,
        ...t
    ] : [
        ...n,
        t
    ], s.__extends = n), n;
}, $44df4c3d2bf55183$export$cfa74393132ebcec = (t, r)=>{
    if (!t) return r;
    const { extends: s } = r, n = (0, $czfS0.isArray)(s) ? s : [
        s
    ], e = (0, $czfS0.isArray)(t) ? t : [
        t
    ];
    return {
        ...r,
        extends: (0, $jobwP.joinArrays)(e, n)
    };
}, $44df4c3d2bf55183$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2), $44df4c3d2bf55183$export$476cb8ab9adcdb0d = {}, $44df4c3d2bf55183$export$bc442b6cc8c83971 = {}, $44df4c3d2bf55183$export$46ce3405574370c6 = (t)=>$44df4c3d2bf55183$export$476cb8ab9adcdb0d[t.__hash], $44df4c3d2bf55183$export$8c8f2806a2edf07f = (t, r)=>{
    const s = $44df4c3d2bf55183$export$daf4c137c5f56404();
    return (0, $czfS0.isString)(t) || (t.__hash = s), s !== "__proto__" && s !== "constructor" && s !== "prototype" && ($44df4c3d2bf55183$export$476cb8ab9adcdb0d[s] = r), r;
}, $44df4c3d2bf55183$export$c4fe3c170ecffa69 = (t, r)=>t.__hash ? r.concat($44df4c3d2bf55183$export$46ce3405574370c6(t)) : $44df4c3d2bf55183$export$8c8f2806a2edf07f(t, r), $44df4c3d2bf55183$export$2c118161a655606a = (t, r, s, n = new Set, e, o, i)=>{
    for (const c of t)(0, $czfS0.isArray)(c) ? $44df4c3d2bf55183$export$2c118161a655606a(c, r, s, n, e, o, i) : $44df4c3d2bf55183$export$802e3e1ed5ecb3f2(c, r, s, n, e, void 0, o, i);
    return r;
}, $44df4c3d2bf55183$export$54e9fb29908872fa = (t, r, s, n = new Set, e, o, i)=>{
    const c = $44df4c3d2bf55183$export$59fa98fbbc577a08(t), f = {
        ...t
    };
    delete f.extends, delete f.extend;
    let d = !1;
    for(const l in f){
        d = !0;
        break;
    }
    return d && (r.push(f), e && e.push(o)), c.length && $44df4c3d2bf55183$export$802e3e1ed5ecb3f2($44df4c3d2bf55183$export$e5703851d4f70876(c), r, s, n, e, o, i, t), r;
}, $44df4c3d2bf55183$export$802e3e1ed5ecb3f2 = (t, r, s, n = new Set, e, o, i, c)=>{
    if (!t || n.has(t)) return r;
    if ((0, $czfS0.isArray)(t)) return $44df4c3d2bf55183$export$2c118161a655606a(t, r, s, n, e, i, c);
    let f = o;
    return (0, $czfS0.isString)(t) ? (f = t, t = $44df4c3d2bf55183$export$325609fc8b225e02(t, s, void 0, void 0, c)) : i && (0, $czfS0.isObject)(t) && i.has(t) && (f = i.get(t)), n.has(t) || (n.add(t), t?.extends || t?.extend ? $44df4c3d2bf55183$export$54e9fb29908872fa(t, r, s, n, e, f, i) : t && (r.push(t), e && e.push(f))), r;
}, $44df4c3d2bf55183$var$X = new Set([
    "parent",
    "node",
    "__ref",
    "__proto__",
    "extends",
    "extend",
    "childExtends",
    "childExtendsRecursive"
]), $44df4c3d2bf55183$export$e0fa903e42ff191c = (t, r, s, n, e)=>{
    r = (0, $2C0hZ.deepClone)(r);
    for(const o in r){
        if ($44df4c3d2bf55183$var$X.has(o)) continue;
        const i = t[o], c = r[o];
        if (c !== void 0 && Object.prototype.hasOwnProperty.call(r, o) && o !== "__proto__" && o !== "constructor" && o !== "prototype") {
            if (i === void 0) t[o] = c, s && n ? (0, $czfS0.isObject)(c) && !(0, $czfS0.isArray)(c) ? (s[o] = s[o] || {}, $44df4c3d2bf55183$var$T(s[o], c, n)) : s[o] = n : s && e?.[o] && (s[o] = e[o]);
            else if ((0, $czfS0.isObject)(i) && (0, $czfS0.isObject)(c)) {
                const f = s ? s[o] = s[o] || {} : void 0, d = e?.[o];
                (0, $gx70P.matchesComponentNaming)(o) ? t[o] = $44df4c3d2bf55183$export$e0fa903e42ff191c(i, c, f, n, d) : $44df4c3d2bf55183$export$e0fa903e42ff191c(i, c, f, n, d);
            }
            if (o === "extends" || o === "childExtends" || o === "childExtendsRecursive") {
                if ((0, $czfS0.isArray)(i) && (0, $czfS0.isArray)(c)) t[o] = i.concat(c);
                else if ((0, $czfS0.isArray)(i) && (0, $czfS0.isObject)(c)) {
                    const f = $44df4c3d2bf55183$export$e0fa903e42ff191c({}, i);
                    t[o] = $44df4c3d2bf55183$export$e0fa903e42ff191c(f, c);
                }
            }
        }
    }
    return t;
}, $44df4c3d2bf55183$var$T = (t, r, s, n)=>{
    if (n || (n = new WeakSet), !n.has(r)) {
        n.add(r);
        for(const e in r){
            if (!Object.prototype.hasOwnProperty.call(r, e) || e === "__proto__" || e === "constructor" || e === "prototype") continue;
            const o = r[e];
            (0, $czfS0.isObject)(o) && !(0, $czfS0.isArray)(o) ? (t[e] = t[e] || {}, $44df4c3d2bf55183$var$T(t[e], o, s, n)) : t[e] = s;
        }
    }
}, $44df4c3d2bf55183$export$e2e460d82983fb19 = (t, r, s)=>t.reduce((n, e, o)=>{
        const i = (0, $2C0hZ.deepClone)(e), c = s ? s[o] : void 0;
        return $44df4c3d2bf55183$export$e0fa903e42ff191c(n, i, r, c);
    }, {}), $44df4c3d2bf55183$export$12e31956818b1112 = Symbol.for("smbls.shadowedComponents"), $44df4c3d2bf55183$export$5d45cc29c7be5fee = (t, r)=>{
    const s = t && t[$44df4c3d2bf55183$export$12e31956818b1112];
    return s ? s.get(r) : void 0;
}, $44df4c3d2bf55183$export$65341a0947ab8813 = (t, r, s)=>{
    if (!t || !s || typeof s != "object" || (0, $czfS0.isArray)(s) || t.components && t.components[r] === s) return;
    let n = t[$44df4c3d2bf55183$export$12e31956818b1112];
    n || (n = new Map, Object.defineProperty(t, $44df4c3d2bf55183$export$12e31956818b1112, {
        configurable: !0,
        enumerable: !1,
        writable: !0,
        value: n
    }));
    const e = n.get(r);
    e ? e.includes(s) || e.push(s) : n.set(r, [
        s
    ]);
}, $44df4c3d2bf55183$export$40eb3eae1d715a09 = (t, r, s, n)=>{
    const e = $44df4c3d2bf55183$export$5d45cc29c7be5fee(n, r), o = e ? e.length + 1 : 1;
    let i = null, c = !1;
    for(let f = 0; f <= o; f++){
        const d = f === 0 ? t[r] : f === o ? t["smbls." + r] : e[f - 1];
        if (d) {
            if (d === s) c = !0;
            else {
                if (c) return d;
                i === null && (i = d);
            }
        }
    }
    return c ? null : i;
}, $44df4c3d2bf55183$export$325609fc8b225e02 = (t, r, s = {}, n, e)=>{
    const o = r?.components || s.components, i = r?.pages || s.pages;
    if ((0, $czfS0.isString)(t)) {
        const c = o && (o[t + "." + n] || $44df4c3d2bf55183$export$40eb3eae1d715a09(o, t, e, r)), f = i && t.charCodeAt(0) === 47 && i[t];
        if (c) return c;
        if (f) return f;
        s.verbose && ($44df4c3d2bf55183$var$v === "test" || $44df4c3d2bf55183$var$v === "development") && console.warn("Extend is string but component was not found:", t);
        return;
    }
    return t;
}, $44df4c3d2bf55183$export$f9f936cf352c3af2 = (t, r)=>[].concat(t.slice(0, 1)).concat(r.slice(0, 1)).concat(t.slice(1)).concat(r.slice(1)), $44df4c3d2bf55183$export$f39bb847e2d05ef6 = (t, r, s, n)=>{
    if (!t) return [];
    if (t.__hash) return $44df4c3d2bf55183$export$46ce3405574370c6(t) || [];
    const o = $44df4c3d2bf55183$export$802e3e1ed5ecb3f2(t, [], r, new Set, s, void 0, n);
    return s ? o : $44df4c3d2bf55183$export$c4fe3c170ecffa69(t, o);
}, $44df4c3d2bf55183$export$2f41615046006887 = (t, r)=>{
    if (!t) return r;
    const s = (0, $czfS0.isArray)(t) ? t : [
        t
    ];
    return (0, $jobwP.joinArrays)(s, r);
}, $44df4c3d2bf55183$export$a23334bdec459c3a = (t)=>{
    let r = [];
    function s(n) {
        for(const e in n)Object.prototype.hasOwnProperty.call(n, e) && ((0, $gx70P.matchesComponentNaming)(e) && r.push(e), e === "extends" && (typeof n[e] == "string" ? r.push(n[e]) : Array.isArray(n[e]) && (r = r.concat(n[e]))), typeof n[e] == "object" && n[e] !== null && s(n[e]));
    }
    return s(t), r;
}, $44df4c3d2bf55183$export$5adee993743866c4 = (t, r, s = {})=>{
    const { __ref: n } = t, e = t.context || r.context, o = t.variant, i = $44df4c3d2bf55183$export$59fa98fbbc577a08(t);
    if (i.length) {
        const c = $44df4c3d2bf55183$export$e5703851d4f70876(i), [f, ...d] = c, l = typeof f == "string" && o && e?.components ? `${f}.${o}` : null;
        l && e.components[l] ? $44df4c3d2bf55183$export$3200adf97fb998d9([
            l,
            ...d
        ], t) : $44df4c3d2bf55183$export$3200adf97fb998d9(c, t);
    }
    return $44df4c3d2bf55183$export$330789d8e1f3b311(t, r, s), $44df4c3d2bf55183$export$dde729987f06f311(t, r, s), $44df4c3d2bf55183$export$4426caec5c659cae(t, r, s), t.component && $44df4c3d2bf55183$export$3200adf97fb998d9($44df4c3d2bf55183$export$e5703851d4f70876((0, $2C0hZ.exec)(t.component, t)), t), e.defaultExtends && $44df4c3d2bf55183$export$3200adf97fb998d9($44df4c3d2bf55183$export$e5703851d4f70876(e.defaultExtends), t), (0, $jobwP.removeDuplicatesInArray)(n.__extends);
}, $44df4c3d2bf55183$export$330789d8e1f3b311 = (t, r, s = {})=>{
    const { __ref: n } = t;
    return s.ignoreChildExtends || t.ignoreChildExtends || r.childProps?.extends && $44df4c3d2bf55183$export$3200adf97fb998d9($44df4c3d2bf55183$export$e5703851d4f70876(r.childProps.extends), t), n.__extends;
}, $44df4c3d2bf55183$export$dde729987f06f311 = (t, r, s = {})=>{
    const { __ref: n } = t, e = s.ignoreChildExtends || t.ignoreChildExtends, o = r.childExtends;
    return !e && o && $44df4c3d2bf55183$export$3200adf97fb998d9($44df4c3d2bf55183$export$e5703851d4f70876(o), t), n.__extends;
}, $44df4c3d2bf55183$export$4426caec5c659cae = (t, r, s = {})=>{
    const { __ref: n } = t, e = r.childExtendsRecursive, o = s.ignoreChildExtendsRecursive || t.ignoreChildExtendsRecursive, i = t.key === "__text";
    return e && !i && !o && $44df4c3d2bf55183$export$3200adf97fb998d9($44df4c3d2bf55183$export$e5703851d4f70876(e), t), n.__extends;
}, $44df4c3d2bf55183$export$5625cedc68348886 = (t, r, s = {})=>{
    const { __ref: n } = t, e = t.context || r.context, o = t.variant, i = $44df4c3d2bf55183$var$j(s), c = i ? [
        ...n.__extends
    ] : null, f = (0, $jobwP.removeDuplicatesInArray)(n.__extends.map((d, l)=>$44df4c3d2bf55183$export$325609fc8b225e02(d, e, s, l === 0 && o, t)));
    if (i) {
        const d = new WeakMap;
        for(let x = 0; x < f.length; x++){
            const y = f[x], O = c[x];
            y && (0, $czfS0.isObject)(y) && (0, $czfS0.isString)(O) && d.set(y, O);
        }
        const l = [], $ = $44df4c3d2bf55183$export$f39bb847e2d05ef6(f, e, l, d);
        n.__extendsStack = $, n.__extendsNames = l;
    } else {
        const d = $44df4c3d2bf55183$export$f39bb847e2d05ef6(f, e);
        n.__extendsStack = d;
    }
    return n.__extendsStack;
}, $44df4c3d2bf55183$export$eef12a49036578e9 = (t, r, s = {})=>{
    const { __ref: n } = t, { __extendsStack: e } = n;
    if ($44df4c3d2bf55183$var$j(s)) {
        const o = {}, i = n.__extendsNames || [], c = $44df4c3d2bf55183$export$e2e460d82983fb19(e, o, i), f = {};
        $44df4c3d2bf55183$export$e0fa903e42ff191c(t, c, f, void 0, o), n.__sourcemap = f;
    } else {
        const o = $44df4c3d2bf55183$export$e2e460d82983fb19(e);
        $44df4c3d2bf55183$export$e0fa903e42ff191c(t, o);
    }
    return t;
}, $44df4c3d2bf55183$export$1ac92e2b1d1a0b6d = (t, r, s = {})=>($44df4c3d2bf55183$export$5adee993743866c4(t, r, s), $44df4c3d2bf55183$export$5625cedc68348886(t, r, s), $44df4c3d2bf55183$export$eef12a49036578e9(t, r, s), t);

});


parcelRegister("4tyEL", function(module, exports) {

$parcel$export(module.exports, "createProps", () => $3424c0e49b94bbe2$export$c94ea207b45fef3a);
$parcel$export(module.exports, "pickupPropsFromElement", () => $3424c0e49b94bbe2$export$411043fa9345828f);
$parcel$export(module.exports, "pickupElementFromProps", () => $3424c0e49b94bbe2$export$fa8664b35a0bcdc9);
$parcel$export(module.exports, "propertizeElement", () => $3424c0e49b94bbe2$export$4ff756f42aa6b6a4);
$parcel$export(module.exports, "propertizeUpdate", () => $3424c0e49b94bbe2$export$2bbd9d589d78c8ea);
$parcel$export(module.exports, "objectizeStringProperty", () => $3424c0e49b94bbe2$export$5e9fe7243e559e3c);
$parcel$export(module.exports, "propExists", () => $3424c0e49b94bbe2$export$fd415051acfc22d4);
$parcel$export(module.exports, "inheritParentProps", () => $3424c0e49b94bbe2$export$d25057a75c14aff7);
$parcel$export(module.exports, "update", () => $3424c0e49b94bbe2$export$722fbec263ad908a);
$parcel$export(module.exports, "setPropsPrototype", () => $3424c0e49b94bbe2$export$e290b82348b6726c);
$parcel$export(module.exports, "removeDuplicateProps", () => $3424c0e49b94bbe2$export$44466878677fcc43);
$parcel$export(module.exports, "syncProps", () => $3424c0e49b94bbe2$export$b23ca50362483f82);
$parcel$export(module.exports, "createPropsStack", () => $3424c0e49b94bbe2$export$1327128ea5b9a1e8);
$parcel$export(module.exports, "applyProps", () => $3424c0e49b94bbe2$export$d76b848a0167f48b);
$parcel$export(module.exports, "initProps", () => $3424c0e49b94bbe2$export$a121566aadcfe021);
$parcel$export(module.exports, "updateProps", () => $3424c0e49b94bbe2$export$c8dce3c08436e91e);

var $cjyfe = parcelRequire("cjyfe");

var $5BW66 = parcelRequire("5BW66");

var $2C0hZ = parcelRequire("2C0hZ");

var $czfS0 = parcelRequire("czfS0");

var $TarXh = parcelRequire("TarXh");

var $gjNoZ = parcelRequire("gjNoZ");
const $3424c0e49b94bbe2$var$P = /^[A-Z]/, $3424c0e49b94bbe2$var$E = /^\d+$/, $3424c0e49b94bbe2$var$y = new Set([
    ":",
    "@",
    "[",
    "*",
    "+",
    "~",
    "&",
    ">",
    "$",
    "-",
    ".",
    "!"
]), $3424c0e49b94bbe2$var$z = new Set([
    "extend",
    "props",
    "text",
    "tag",
    "on",
    "if",
    "childExtend",
    "children",
    "childrenAs",
    "state",
    "html",
    "attr",
    "define",
    "content"
]), $3424c0e49b94bbe2$var$G = (t)=>{
    if (!t || typeof t != "object" || Array.isArray(t)) return !1;
    for(const s in t)if ($3424c0e49b94bbe2$var$z.has(s) || $3424c0e49b94bbe2$var$P.test(s)) return !0;
    return !1;
}, $3424c0e49b94bbe2$export$c94ea207b45fef3a = (t, s, n)=>{
    const { props: e, __ref: r } = t;
    if (r.__propsStack = [], e) r.__initialProps = e;
    else return {};
    return (0, $czfS0.isObjectLike)(e) ? {
        ...e
    } : (r.__propsStack.push(e), {});
};
function $3424c0e49b94bbe2$export$411043fa9345828f(t, s = {}) {
    const n = s.cachedKeys || [];
    for(const e in t){
        const r = t[e];
        if (e.length > 2 && e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e[2] === e[2].toUpperCase() && ((0, $czfS0.isFunction)(r) || r != null && (0, $gjNoZ.hasHandlerPlugin)(this.context))) {
            const R = (0, $TarXh.lowercaseFirstLetter)(e.slice(2));
            t.on && (t.on[R] = r), delete t[e];
            continue;
        }
        if (e === "childProps") {
            t.props[e] = r, delete t[e], n.push(e);
            continue;
        }
        const f = this.define?.[e], c = this.context?.define?.[e], u = (0, $czfS0.isObject)(f) || (0, $czfS0.isFunction)(f), h = (0, $czfS0.isObject)(c) || (0, $czfS0.isFunction)(c);
        if (u || h) continue;
        const l = e.charAt(0);
        if ($3424c0e49b94bbe2$var$y.has(l)) {
            t.props[e] = r, delete t[e], n.push(e);
            continue;
        }
        const d = $3424c0e49b94bbe2$var$P.test(e) || $3424c0e49b94bbe2$var$E.test(e) || $3424c0e49b94bbe2$var$G(r), _ = (0, $cjyfe.DOMQ_PROPERTIES).has(e);
        !d && !_ && (e in t.props || (t.props[e] = r), delete t[e], n.push(e));
    }
    return t;
}
function $3424c0e49b94bbe2$export$fa8664b35a0bcdc9(t = this, s) {
    const n = s.cachedKeys || [];
    for(const e in t.props){
        const r = t.props[e], o = e.length > 2 && e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110, i = (0, $czfS0.isFunction)(r) || r != null && (0, $gjNoZ.hasHandlerPlugin)(this.context);
        if (o && i) {
            (0, $5BW66.addEventFromProps)(e, t), delete t.props[e];
            continue;
        }
        if (n.includes(e) || e === "childProps") continue;
        const f = e.charAt(0);
        if ($3424c0e49b94bbe2$var$y.has(f)) continue;
        const c = this.define?.[e], u = this.context?.define?.[e], h = (0, $czfS0.isObject)(c) || (0, $czfS0.isFunction)(c), l = (0, $czfS0.isObject)(u) || (0, $czfS0.isFunction)(u), d = $3424c0e49b94bbe2$var$P.test(e) || $3424c0e49b94bbe2$var$E.test(e), _ = (0, $cjyfe.DOMQ_PROPERTIES).has(e);
        (d || _ || h || l) && (t[e] === void 0 || r === null) && (t[e] = r, t.props && delete t.props[e]);
    }
    return t;
}
function $3424c0e49b94bbe2$export$4ff756f42aa6b6a4(t = this) {
    const s = [];
    return $3424c0e49b94bbe2$export$411043fa9345828f.call(this, t, {
        cachedKeys: s
    }), $3424c0e49b94bbe2$export$fa8664b35a0bcdc9.call(this, t, {
        cachedKeys: s
    }), t;
}
function $3424c0e49b94bbe2$export$2bbd9d589d78c8ea(t = {}) {
    return t.on || (t.on = {}), t.props || (t.props = {}), $3424c0e49b94bbe2$export$4ff756f42aa6b6a4.call(this, t);
}
const $3424c0e49b94bbe2$export$5e9fe7243e559e3c = (t)=>(0, $czfS0.is)(t)("string", "number") ? {
        inheritedString: t
    } : t, $3424c0e49b94bbe2$export$fd415051acfc22d4 = (t, s)=>!t || !s.length ? !1 : s.includes(t), $3424c0e49b94bbe2$export$d25057a75c14aff7 = (t, s)=>{
    const { __ref: n } = t, e = n.__propsStack || [], r = s.props;
    if (!r) return e;
    const o = r[t.key], i = r.childProps || s.childProps, f = t.props?.ignoreChildProps;
    if (i && !f) {
        const c = $3424c0e49b94bbe2$export$5e9fe7243e559e3c(i);
        e.unshift(c);
    }
    if (o) {
        const c = $3424c0e49b94bbe2$export$5e9fe7243e559e3c(o);
        e.unshift(c);
    }
    return e;
};
function $3424c0e49b94bbe2$export$722fbec263ad908a(t, s) {
    this.__element.update({
        props: t
    }, s);
}
function $3424c0e49b94bbe2$export$e290b82348b6726c(t) {
    const s = {
        update: $3424c0e49b94bbe2$export$722fbec263ad908a.bind(t.props),
        __element: t
    };
    Object.setPrototypeOf(t.props, s);
}
const $3424c0e49b94bbe2$export$44466878677fcc43 = (t)=>{
    const s = new Set;
    return t.filter((n)=>!n || (0, $cjyfe.PROPS_METHODS).has(n) || s.has(n) ? !1 : (s.add(n), !0));
}, $3424c0e49b94bbe2$export$b23ca50362483f82 = (t, s, n)=>(s.props = t.reduce((e, r)=>{
        if ((0, $cjyfe.PROPS_METHODS).has(r)) return e;
        for(; (0, $czfS0.isFunction)(r);)r = (0, $2C0hZ.exec)(r, s);
        return (0, $2C0hZ.deepMerge)(e, (0, $2C0hZ.deepClone)(r, {
            exclude: (0, $cjyfe.PROPS_METHODS)
        }));
    }, {}), $3424c0e49b94bbe2$export$e290b82348b6726c(s), s.props), $3424c0e49b94bbe2$export$1327128ea5b9a1e8 = (t, s)=>{
    const { props: n, __ref: e } = t;
    let r = e.__propsStack || [];
    if (s?.props && (r = [
        ...$3424c0e49b94bbe2$export$d25057a75c14aff7(t, s)
    ]), (0, $czfS0.isObject)(n) ? r.push(n) : n === "inherit" && s?.props ? r.push(s.props) : n && r.push(n), (0, $czfS0.isArray)(e.__extendsStack)) for(let o = 0; o < e.__extendsStack.length; o++){
        const i = e.__extendsStack[o];
        i.props && i.props !== n && r.push(i.props);
    }
    return e.__propsStack = $3424c0e49b94bbe2$export$44466878677fcc43(r), e.__propsStack;
}, $3424c0e49b94bbe2$export$d76b848a0167f48b = (t, s)=>{
    const { __ref: n } = t, e = $3424c0e49b94bbe2$export$1327128ea5b9a1e8(t, s);
    e.length ? $3424c0e49b94bbe2$export$b23ca50362483f82(e, t) : (n.__propsStack = [], t.props = {});
}, $3424c0e49b94bbe2$export$a121566aadcfe021 = function(t, s, n) {
    const { __ref: e } = t;
    if (e.__if) $3424c0e49b94bbe2$export$d76b848a0167f48b(t, s);
    else try {
        $3424c0e49b94bbe2$export$d76b848a0167f48b(t, s);
    } catch (r) {
        t.context?.designSystem?.verbose && console.warn("initProps error at", e.path?.join("."), r), t.props = {}, e.__propsStack = [];
    }
    return $3424c0e49b94bbe2$export$e290b82348b6726c(t), t;
}, $3424c0e49b94bbe2$export$c8dce3c08436e91e = (t, s, n)=>{
    const { __ref: e } = s;
    let o = [
        ...e.__propsStack || []
    ];
    const i = $3424c0e49b94bbe2$export$d25057a75c14aff7(s, n);
    return i.length && (o = [
        ...i,
        ...o
    ]), t && (o = [
        t,
        ...o
    ]), e.__propsStack = $3424c0e49b94bbe2$export$44466878677fcc43(o), e.__propsStack.length && $3424c0e49b94bbe2$export$b23ca50362483f82(e.__propsStack, s), s;
};

});
parcelRegister("5BW66", function(module, exports) {

$parcel$export(module.exports, "addEventFromProps", () => $415d796778510015$export$4c071752ff9c2992);

var $TarXh = parcelRequire("TarXh");

var $czfS0 = parcelRequire("czfS0");
function $415d796778510015$export$4c071752ff9c2992(r, c) {
    const { props: f, on: t } = c, o = (0, $TarXh.lowercaseFirstLetter)(r.split("on")[1]), e = t[o], n = f[r];
    (0, $czfS0.isFunction)(e) ? t[o] = (...s)=>{
        if (e(...s) !== !1 && (0, $czfS0.isFunction)(n)) return n(...s);
    } : t[o] = n;
}

});


parcelRegister("etvrx", function(module, exports) {

$parcel$export(module.exports, "returnValueAsText", () => $a89c2a174a3ecf9a$export$dfa23c5e4a54ab0c);
$parcel$export(module.exports, "createBasedOnType", () => $a89c2a174a3ecf9a$export$927f99b3b8be13bc);
$parcel$export(module.exports, "addRef", () => $a89c2a174a3ecf9a$export$67a43d775655c9fa);
$parcel$export(module.exports, "createParent", () => $a89c2a174a3ecf9a$export$afa4f66aa2aa78ad);
$parcel$export(module.exports, "createRoot", () => $a89c2a174a3ecf9a$export$882461b6382ed46c);
$parcel$export(module.exports, "createPath", () => $a89c2a174a3ecf9a$export$fe53371bee54353d);
$parcel$export(module.exports, "addContext", () => $a89c2a174a3ecf9a$export$f02680d0c92070c1);
$parcel$export(module.exports, "addCaching", () => $a89c2a174a3ecf9a$export$ffc78f972bfbae8a);
$parcel$export(module.exports, "createElement", () => $a89c2a174a3ecf9a$export$c8a8987d4410bf2d);

var $5UBxb = parcelRequire("5UBxb");

var $28ol3 = parcelRequire("28ol3");

var $4Fc4U = parcelRequire("4Fc4U");

var $4tyEL = parcelRequire("4tyEL");

var $fDTgW = parcelRequire("fDTgW");

var $czfS0 = parcelRequire("czfS0");
const $a89c2a174a3ecf9a$var$f = "production", $a89c2a174a3ecf9a$export$dfa23c5e4a54ab0c = (r, e, o)=>{
    const t = e.childExtends && e.childExtends.tag, n = e.childProps && e.childProps.tag, s = (0, $fDTgW.HTML_TAGS).body.has(o) && o;
    return {
        text: r,
        tag: t || n || s || "string"
    };
}, $a89c2a174a3ecf9a$export$927f99b3b8be13bc = (r, e, o)=>{
    if (r === void 0) return ($a89c2a174a3ecf9a$var$f === "test" || $a89c2a174a3ecf9a$var$f === "development") && console.warn(o, "element is undefined in", e?.__ref?.path), {};
    if (r !== null) return r === !0 ? {} : (0, $czfS0.is)(r)("string", "number") ? $a89c2a174a3ecf9a$export$dfa23c5e4a54ab0c(r, e, o) : (0, $czfS0.isFunction)(r) ? {
        props: r
    } : r;
}, $a89c2a174a3ecf9a$export$67a43d775655c9fa = (r, e)=>{
    const o = {};
    return o.origin = r, o.parent = e, o;
}, $a89c2a174a3ecf9a$export$afa4f66aa2aa78ad = (r, e, o, t, n)=>{
    if (!e) return n;
    if ((0, $4Fc4U.isNode)(e)) {
        const s = {
            key: ":root",
            node: e
        };
        return n[`${o}_parent`] = s, s;
    }
    return e;
}, $a89c2a174a3ecf9a$export$882461b6382ed46c = (r, e)=>{
    const { __ref: o } = r, { __ref: t } = e, n = e && e.key === ":root";
    o?.root || (o.root = n ? r : t?.root);
}, $a89c2a174a3ecf9a$export$fe53371bee54353d = (r, e, o)=>{
    let { __ref: t } = e;
    return t || (t = e.ref = {}), t.path || (t.path = []), t.path.concat(o);
}, $a89c2a174a3ecf9a$export$f02680d0c92070c1 = (r, e, o, t, n)=>(t.context && !n.context && !r.context && (n.context = t.context), t.context || e.context || n.context || r.context), $a89c2a174a3ecf9a$export$ffc78f972bfbae8a = (r, e, o)=>{
    const t = $a89c2a174a3ecf9a$export$67a43d775655c9fa(r, e);
    return r.__ref = t, t.__defineCache || (t.__defineCache = {}), t.__exec || (t.__exec = {}), t.__execProps || (t.__execProps = {}), t.__class || (t.__class = {}), t.__classNames || (t.__classNames = {}), t.__attr || (t.__attr = {}), t.__changes || (t.__changes = []), t.__children || (t.__children = []), t.__extends = (0, $5UBxb.createExtends)(r, e, o), t.path = $a89c2a174a3ecf9a$export$fe53371bee54353d(r, e, o), t;
}, $a89c2a174a3ecf9a$export$c8a8987d4410bf2d = (r, e, o, t, n)=>{
    const c = r?.__hash ? {
        extends: [
            r
        ]
    } : $a89c2a174a3ecf9a$export$927f99b3b8be13bc(r, e, o);
    if (!c) return;
    const i = $a89c2a174a3ecf9a$export$afa4f66aa2aa78ad(c, e, o, t, n), _ = (0, $28ol3.createKey)(c, i, o);
    $a89c2a174a3ecf9a$export$ffc78f972bfbae8a(c, i, _);
    const a = (0, $4tyEL.createProps)(c, i, _), x = $a89c2a174a3ecf9a$export$f02680d0c92070c1(c, i, _, t, n), d = c.on || {};
    return {
        ...c,
        key: _,
        props: a,
        parent: i,
        context: x,
        on: d
    };
};

});

parcelRegister("avbFu", function(module, exports) {

$parcel$export(module.exports, "checkForStateTypes", () => $7a55d9b3792243a5$export$1a615c2b5db1076e);
$parcel$export(module.exports, "getRootStateInKey", () => $7a55d9b3792243a5$export$c138e045c9d99c0);
$parcel$export(module.exports, "getParentStateInKey", () => $7a55d9b3792243a5$export$f7dd4f6f6830b29d);
$parcel$export(module.exports, "getChildStateInKey", () => $7a55d9b3792243a5$export$e6d108f71cc7e736);
$parcel$export(module.exports, "findInheritedState", () => $7a55d9b3792243a5$export$487549069bb5d2a9);
$parcel$export(module.exports, "checkIfInherits", () => $7a55d9b3792243a5$export$e187d7e20e9fd8fa);
$parcel$export(module.exports, "createInheritedState", () => $7a55d9b3792243a5$export$c546cc738d4564ba);
$parcel$export(module.exports, "isState", () => $7a55d9b3792243a5$export$e5d60a6bbabd36f);
$parcel$export(module.exports, "createNestedObjectByKeyPath", () => $7a55d9b3792243a5$export$a1831dd7b6191ba4);
$parcel$export(module.exports, "applyDependentState", () => $7a55d9b3792243a5$export$af8fd5cebbe79a02);
$parcel$export(module.exports, "STATE_DATA_MERGE_EXL", () => $7a55d9b3792243a5$export$9ae6b63ab6392e6);
$parcel$export(module.exports, "mergeStateData", () => $7a55d9b3792243a5$export$897f3e8c17a189ff);
$parcel$export(module.exports, "overwriteState", () => $7a55d9b3792243a5$export$dd6f28ea13b47393);
$parcel$export(module.exports, "polyglotSeededKeys", () => $7a55d9b3792243a5$export$1263c61fc9fb9e16);
$parcel$export(module.exports, "isPolyglotWritableKey", () => $7a55d9b3792243a5$export$40bbfddac06f7c90);
$parcel$export(module.exports, "isPolyglotRetranslatableKey", () => $7a55d9b3792243a5$export$f26ece3c5f2ba464);
$parcel$export(module.exports, "markPolyglotSeeded", () => $7a55d9b3792243a5$export$f929ccc96fde13c9);

var $jobwP = parcelRequire("jobwP");

var $cjyfe = parcelRequire("cjyfe");

var $dSdIt = parcelRequire("dSdIt");

var $2C0hZ = parcelRequire("2C0hZ");

var $czfS0 = parcelRequire("czfS0");
const $7a55d9b3792243a5$export$1a615c2b5db1076e = (e)=>{
    const { state: t, props: o, __ref: n } = e, r = o?.state || t;
    return (0, $czfS0.is)(r)("string", "number") ? (n.__state = r, {
        value: r
    }) : r === !0 ? (n.__state = e.key, {}) : r ? (n.__hasRootState = !0, r) : !1;
}, $7a55d9b3792243a5$export$c138e045c9d99c0 = (e, t)=>{
    if (!e.includes("~/")) return;
    if (e.split("~/").length > 1) return t.root;
}, $7a55d9b3792243a5$export$f7dd4f6f6830b29d = (e, t)=>{
    if (!e.includes("../")) return;
    const n = e.split("../").length - 1;
    for(let r = 0; r < n; r++){
        if (!t.parent) return null;
        t = t.parent;
    }
    return t;
}, $7a55d9b3792243a5$export$e6d108f71cc7e736 = (e, t, o = {})=>{
    const n = (0, $czfS0.isString)(e) ? e.split("/") : [
        e
    ], r = n.length - 1;
    for(let s = 0; s < r; s++){
        const i = n[s], l = n[s + 1];
        if (i === "__proto__" || l === "__proto__") return;
        let c = t[i];
        c || (c = t[i] = {}), c[l] || (c[l] = {}), e = l, t = c;
    }
    return o.returnParent ? t : t[e];
}, $7a55d9b3792243a5$export$487549069bb5d2a9 = (e, t, o = {})=>{
    let r = e.__ref.__state;
    if (!$7a55d9b3792243a5$export$e187d7e20e9fd8fa(e)) return;
    const s = $7a55d9b3792243a5$export$c138e045c9d99c0(r, t.state);
    let i = t.state;
    if (s) i = s, r = r.replaceAll("~/", "");
    else {
        const l = $7a55d9b3792243a5$export$f7dd4f6f6830b29d(r, t.state);
        l && (i = l, r = r.replaceAll("../", ""));
    }
    if (i) return $7a55d9b3792243a5$export$e6d108f71cc7e736(r, i, o);
}, $7a55d9b3792243a5$export$c546cc738d4564ba = (e, t)=>{
    const o = e.__ref, n = $7a55d9b3792243a5$export$487549069bb5d2a9(e, t);
    if (n === void 0) return e.state;
    if ((0, $czfS0.is)(n)("object", "array")) return (0, $2C0hZ.deepClone)(n);
    if ((0, $czfS0.is)(n)("string", "number", "boolean")) return o.__stateType = typeof n, {
        value: n
    };
}, $7a55d9b3792243a5$export$e187d7e20e9fd8fa = (e)=>{
    const { __ref: t } = e, o = t?.__state;
    return !!(o && (0, $czfS0.is)(o)("number", "string", "boolean"));
}, $7a55d9b3792243a5$export$e5d60a6bbabd36f = function(e) {
    return (0, $czfS0.isObjectLike)(e) ? !!(e.update && e.parse && e.clean && e.create && e.parent && e.destroy && e.rootUpdate && e.parentUpdate && e.keys && e.values && e.toggle && e.replace && e.quietUpdate && e.quietReplace && e.add && e.apply && e.applyReplace && e.setByPath && e.setPathCollection && e.removeByPath && e.removePathCollection && e.getByPath && e.applyFunction && e.__element && e.__children) : !1;
}, $7a55d9b3792243a5$export$a1831dd7b6191ba4 = (e, t)=>{
    if (!e) return t || {};
    const o = e.split("/"), n = {};
    let r = n;
    const s = o.length - 1;
    for(let i = 0; i <= s; i++)r[o[i]] = i === s ? t || {} : {}, r = r[o[i]];
    return n;
}, $7a55d9b3792243a5$export$af8fd5cebbe79a02 = (e, t)=>{
    const { __element: o } = t, n = o?.state;
    if (!n) return;
    const r = (0, $2C0hZ.deepClone)(n, (0, $cjyfe.STATE_METHODS)), s = {
        [e.key]: r
    }, i = (0, $czfS0.isObject)(n.__depends) ? {
        ...n.__depends,
        ...s
    } : s;
    return Array.isArray(n) ? (0, $jobwP.addProtoToArray)(n, {
        ...Object.getPrototypeOf(n),
        __depends: i
    }) : Object.setPrototypeOf(n, {
        ...Object.getPrototypeOf(n),
        __depends: i
    }), r;
}, $7a55d9b3792243a5$export$9ae6b63ab6392e6 = new Set([
    "parent",
    "root"
]), $7a55d9b3792243a5$var$y = new Set, $7a55d9b3792243a5$var$k = (e)=>{
    $7a55d9b3792243a5$var$y.has(e) || ($7a55d9b3792243a5$var$y.add(e), (0, $dSdIt.isLoudDevRuntime)() && console.warn(`[smbls/state] the declared state key "${e}" names a state bookkeeping slot (parent / root) and was NOT copied into the state. Rename the key (e.g. "` + e.split(".").pop() + 'Data").'));
}, $7a55d9b3792243a5$var$g = (e, t, o, n)=>{
    if (e === t) return e;
    for(let r = 0; r < n.length; r += 2)if (n[r] === e && n[r + 1] === t) return e;
    for(const r in t){
        if (!Object.prototype.hasOwnProperty.call(t, r) || r.charCodeAt(0) === 95 && r.charCodeAt(1) === 95 || r === "constructor" || r === "prototype") continue;
        const s = o ? o + "." + r : r;
        if ($7a55d9b3792243a5$export$9ae6b63ab6392e6.has(r)) {
            $7a55d9b3792243a5$var$k(s);
            continue;
        }
        const i = e[r], l = t[r];
        (0, $czfS0.isObjectLike)(i) && (0, $czfS0.isObjectLike)(l) ? (n.push(e, t), $7a55d9b3792243a5$var$g(i, l, s, n), n.length -= 2) : i === void 0 && (e[r] = l);
    }
    return e;
}, $7a55d9b3792243a5$export$897f3e8c17a189ff = (e, t)=>!(0, $czfS0.isObjectLike)(e) || !(0, $czfS0.isObjectLike)(t) ? e : $7a55d9b3792243a5$var$g(e, t, "", []), $7a55d9b3792243a5$export$dd6f28ea13b47393 = (e, t, o = {})=>{
    const { overwrite: n } = o;
    if (!n) return;
    const r = n === "shallow";
    if (n === "merge") {
        (0, $2C0hZ.deepMerge)(e, t, (0, $cjyfe.STATE_METHODS));
        return;
    }
    (r ? (0, $2C0hZ.overwriteShallow) : (0, $2C0hZ.overwriteDeep))(e, t, (0, $cjyfe.STATE_METHODS));
}, $7a55d9b3792243a5$var$h = "__polyglotSeededKeys", $7a55d9b3792243a5$export$1263c61fc9fb9e16 = (e)=>{
    if (!(0, $czfS0.isObject)(e)) return new Set;
    let t = e[$7a55d9b3792243a5$var$h];
    if (!(t instanceof Set)) {
        t = new Set;
        try {
            Object.defineProperty(e, $7a55d9b3792243a5$var$h, {
                value: t,
                enumerable: !1,
                writable: !0,
                configurable: !0
            });
        } catch  {}
    }
    return t;
}, $7a55d9b3792243a5$export$40bbfddac06f7c90 = (e, t, o)=>$7a55d9b3792243a5$export$1263c61fc9fb9e16(e).has(t) ? !0 : !(0, $czfS0.isObject)(o) || o[t] === void 0, $7a55d9b3792243a5$var$S = "__polyglotSeededValues", $7a55d9b3792243a5$var$b = (e)=>{
    if (!(0, $czfS0.isObject)(e)) return new Map;
    let t = e[$7a55d9b3792243a5$var$S];
    if (!(t instanceof Map)) {
        t = new Map;
        try {
            Object.defineProperty(e, $7a55d9b3792243a5$var$S, {
                value: t,
                enumerable: !1,
                writable: !0,
                configurable: !0
            });
        } catch  {}
    }
    return t;
}, $7a55d9b3792243a5$var$m = (e)=>{
    if (e === null || typeof e != "object") return typeof e + ":" + String(e);
    try {
        return "json:" + JSON.stringify(e);
    } catch  {
        return null;
    }
}, $7a55d9b3792243a5$export$f26ece3c5f2ba464 = (e, t, o)=>{
    if (!$7a55d9b3792243a5$export$1263c61fc9fb9e16(e).has(t)) return !1;
    const n = $7a55d9b3792243a5$var$b(e);
    if (!n.has(t)) return !0;
    const r = (0, $czfS0.isObject)(o) || Array.isArray(o) ? o[t] : void 0, s = $7a55d9b3792243a5$var$m(r);
    return s !== null && s === n.get(t);
}, $7a55d9b3792243a5$export$f929ccc96fde13c9 = (e, t, ...o)=>($7a55d9b3792243a5$export$1263c61fc9fb9e16(e).add(t), o.length && $7a55d9b3792243a5$var$b(e).set(t, $7a55d9b3792243a5$var$m(o[0])), t);

});

parcelRegister("iFk3S", function(module, exports) {

$parcel$export(module.exports, "createScope", () => $d96b9e1f11709df3$export$41a9651decfe2bde);
const $d96b9e1f11709df3$var$f = (o, t)=>{
    let c = t;
    for(; c;){
        if (c === o) return !0;
        c = Object.getPrototypeOf(c);
    }
    return !1;
}, $d96b9e1f11709df3$export$41a9651decfe2bde = (o, t)=>{
    const { __ref: c } = o, e = o.context || t.context || c.root?.context;
    e && !e.globalScope && (e.globalScope = {});
    const p = t.scope || c.root?.scope, s = e?.globalScope;
    if (!o.scope) p ? o.scope = p : s ? o.scope = Object.create(s) : o.scope = {};
    else if (typeof o.scope == "object" && o.scope !== null && Object.getPrototypeOf(o.scope) === Object.prototype) {
        const r = p || s;
        r && !$d96b9e1f11709df3$var$f(o.scope, r) && Object.setPrototypeOf(o.scope, r);
    }
};

});

parcelRegister("kkSVW", function(module, exports) {

$parcel$export(module.exports, "spotByPath", () => tt);
$parcel$export(module.exports, "lookup", () => et);
$parcel$export(module.exports, "lookdown", () => nt);
$parcel$export(module.exports, "lookdownAll", () => ot);
$parcel$export(module.exports, "setNodeStyles", () => T);
$parcel$export(module.exports, "remove", () => rt);
$parcel$export(module.exports, "get", () => st);
$parcel$export(module.exports, "setProps", () => it);
$parcel$export(module.exports, "getRef", () => ct);
$parcel$export(module.exports, "getChildren", () => lt);
$parcel$export(module.exports, "getPath", () => ft);
$parcel$export(module.exports, "setActiveRootState", () => ut);
$parcel$export(module.exports, "promoteActiveRootState", () => at);
$parcel$export(module.exports, "getRootState", () => ht);
$parcel$export(module.exports, "getRoot", () => pt);
$parcel$export(module.exports, "getRootData", () => dt);
$parcel$export(module.exports, "getRootContext", () => _t);
$parcel$export(module.exports, "getContext", () => gt);
$parcel$export(module.exports, "defineSetter", () => mt);
$parcel$export(module.exports, "keys", () => j);
$parcel$export(module.exports, "parse", () => F);
$parcel$export(module.exports, "parseDeep", () => w);
$parcel$export(module.exports, "verbose", () => Q);
$parcel$export(module.exports, "log", () => xt);
$parcel$export(module.exports, "warn", () => yt);
$parcel$export(module.exports, "error", () => O);
$parcel$export(module.exports, "nextElement", () => St);
$parcel$export(module.exports, "previousElement", () => vt);
$parcel$export(module.exports, "variables", () => wt);
$parcel$export(module.exports, "call", () => Ot);
$parcel$export(module.exports, "getDB", () => Rt);
$parcel$export(module.exports, "getQuery", () => $t);
$parcel$export(module.exports, "isMethod", () => kt);

var $BEBTO = parcelRequire("BEBTO");

var $cjyfe = parcelRequire("cjyfe");

var $czfS0 = parcelRequire("czfS0");

var $2C0hZ = parcelRequire("2C0hZ");

var $dSdIt = parcelRequire("dSdIt");

var $jobwP = parcelRequire("jobwP");

var $69Bo3 = parcelRequire("69Bo3");
const a = "production";
function tt(e) {
    const t = this, { __ref: n } = t, o = [].concat(e);
    let r = n.root[o[0]];
    if (!o || !o.length) return console.log(o, "on", t.key, "is undefined");
    for(; r.key === o[0] && (o.shift(), !!o.length);)if (r = r[o[0]], !r) return;
    return r;
}
function et(e) {
    const t = this;
    let { parent: n } = t;
    if ((0, $czfS0.isFunction)(e)) return n.state && e(n, n.state, n.context) ? n : n.parent ? n.lookup(e) : void 0;
    if (t[e]) return t[e];
    for(; n.param !== e;){
        if (n[e]) return n[e];
        if (n = n.parent, !n) return;
    }
    return n;
}
function nt(e) {
    const t = this, { __ref: n } = t, o = n?.__children;
    if (o) for(let r = 0; r < o.length; r++){
        const s = o[r], i = t[s];
        if (s === e) return i;
        if ((0, $czfS0.isFunction)(e)) {
            const l = e(i, i.state, i.context);
            if (i.state && l) return i;
        }
        const c = i?.lookdown?.(e);
        if (c) return c;
    }
}
function ot(e, t = []) {
    const n = this, { __ref: o } = n, r = o?.__children;
    if (r) {
        for(let s = 0; s < r.length; s++){
            const i = r[s], c = n[i];
            if (i === e) t.push(c);
            else if ((0, $czfS0.isFunction)(e)) {
                const l = e(c, c.state, c.context);
                c.state && l && t.push(c);
            }
            c?.lookdownAll?.(e, t);
        }
        return t.length ? t : void 0;
    }
}
function T(e = {}) {
    const t = this;
    if (t.node?.style) {
        for(const n in e){
            const o = e[n], r = t[n];
            if ((0, $czfS0.isObject)(o) && r) T.call(r, o);
            else if (o != null) {
                const s = n.replace(/[A-Z]/g, (c)=>"-" + c.toLowerCase()), i = String(o).replace(/\s*!important\s*$/, "");
                t.node.style.setProperty(s, i, "important");
            }
        }
        return t;
    }
}
function rt(e) {
    const t = this;
    if ((0, $BEBTO.triggerEventOn)("beforeRemove", t, e) === !1) return t;
    (0, $czfS0.isFunction)(t.node.remove) ? t.node.remove() : (0, $dSdIt.isProduction)() || t.log(), delete t.parent[t.key], t.parent.__ref && (t.parent.__ref.__children = (0, $jobwP.removeValueFromArray)(t.parent.__ref.__children, t.key)), (0, $BEBTO.triggerEventOn)("remove", t, e);
}
function st(e) {
    return this[e];
}
function it(e, t) {
    const n = this;
    if (e) return n.update(e, t), n;
}
function ct(e) {
    return e ? this.__ref && this.__ref[e] : this.__ref;
}
function lt() {
    const e = this.getRef("__children");
    return Array.isArray(e) ? e.map((t)=>this[t]) : [];
}
function ft() {
    return this.getRef().path;
}
let _ = null;
const ut = (e)=>{
    _ = e || null;
}, at = (e, t)=>{
    e && t && _ === e && (_ = t);
}, v = ()=>_ || null;
function ht(e) {
    let t = null;
    const n = (o)=>o.__element && o.root?.isRootState;
    if (!this) t = v();
    else if (n(this)) t = this.root;
    else if (this.__ref && this.__ref.path) {
        const o = this.state && n(this.state), r = (0, $czfS0.isFunction)(this.state) && this.parent.state && n(this.parent.state);
        (o || r) && (t = this.state.root || this.parent.state.root);
    }
    return t || (t = v()), e ? t?.[e] : t;
}
function pt(e) {
    const t = this?.__ref?.root || this.getRootState()?.__element;
    if (!t) throw new Error(`[smbls] getRoot() could not resolve a root element for "${this?.key || "<unknown>"}" \u2014 it has no __ref (never went through create()) and no root state is registered. Answering undefined here used to no-op silently for every caller.`);
    return Object.keys(t).length > 0 && e ? t[e] : t;
}
function dt(e) {
    return this.getRoot("data") && Object.keys(this.getRoot("data")).length > 0 && e ? this.getRoot("data")[e] : this.getRoot("data");
}
function _t(e) {
    const t = this.getRoot()?.context;
    return e ? t[e] : t;
}
function gt(e) {
    const t = this.context;
    return e ? t[e] : t;
}
const mt = (e, t, n, o)=>Object.defineProperty(e, t, {
        get: n,
        set: o
    });
function j() {
    const e = this, t = [];
    for(const n in e)!Object.prototype.hasOwnProperty.call(e, n) || (0, $cjyfe.DOMQ_PROPERTIES).has(n) && !(0, $cjyfe.PARSED_DOMQ_PROPERTIES).has(n) || t.push(n);
    return t;
}
function F(e = []) {
    const t = this, n = {}, o = j.call(t), r = o.includes("children"), s = e.length ? new Set(e) : null;
    for(let i = 0; i < o.length; i++){
        const c = o[i];
        if (s && s.has(c) || !Object.prototype.hasOwnProperty.call(t, c) || r && c === "content") continue;
        const l = t[c];
        if (c === "state") {
            if (t.__ref && !t.__ref.__hasRootState) continue;
            const f = (0, $czfS0.isFunction)(l && l.parse) ? l.parse() : l;
            n[c] = (0, $czfS0.isFunction)(f) ? f : JSON.parse(JSON.stringify(f || {}));
        } else if (c === "scope") {
            if (t.__ref && !t.__ref.__hasRootScope) continue;
            n[c] = JSON.parse(JSON.stringify(l || {}));
        } else if (c === "props") {
            const { __element: f, update: u, ...h } = t[c];
            n[c] = h;
        } else (0, $czfS0.isDefined)(l) && Object.prototype.hasOwnProperty.call(t, c) && (n[c] = l);
    }
    return n;
}
function w(e = [], t = new WeakSet) {
    const n = this;
    if (t.has(n)) return;
    t.add(n);
    const o = F.call(n, e), r = e.length ? new Set(e) : null;
    for(const s in o){
        if (r && r.has(s) || !Object.prototype.hasOwnProperty.call(n, s)) continue;
        const i = o[s];
        Array.isArray(i) ? o[s] = i.map((c)=>(0, $czfS0.isObjectLike)(c) ? w.call(c, e, t) : c) : (0, $czfS0.isObjectLike)(i) && (o[s] = w.call(i, e, t));
    }
    return o;
}
function Q(...e) {
    if (a !== "test" && a !== "development") return;
    const t = this, { __ref: n } = t;
    return console.groupCollapsed(t.key), e.length ? e.forEach((o)=>console.log(`%c${o}:
`, "font-weight: bold", t[o])) : (console.log(n.path), t.keys().forEach((r)=>console.log(`%c${r}:`, "font-weight: bold", t[r]))), console.log(t), console.groupEnd(t.key), t;
}
function xt(...e) {
    (a === "test" || a === "development") && console.log(...e);
}
function yt(...e) {
    (a === "test" || a === "development") && console.warn(...e);
}
function O(...e) {
    if (a === "test" || a === "development") {
        if (e[e.length - 1]?.debugger) debugger;
        throw e[e.length - 1]?.verbose && Q.call(this), new Error(...e);
    }
}
function St() {
    const e = this, { key: t, parent: n } = e, { __children: o } = n.__ref, r = o.indexOf(t), s = o[r + 1];
    return n[s];
}
function vt(e) {
    const t = e || this, { key: n, parent: o } = t, { __children: r } = o.__ref;
    if (!r) return;
    const s = r.indexOf(n);
    return o[r[s - 1]];
}
function wt(e = {}) {
    const t = this;
    t.data || (t.data = {}), t.data.varCaches || (t.data.varCaches = {});
    const n = t.data.varCaches, o = {};
    let r;
    for(const s in e)e[s] !== n[s] && (r = !0, o[s] = e[s]);
    return {
        changed: (s)=>{
            if (!r) return;
            const i = s(o, (0, $2C0hZ.deepClone)(n));
            for(const c in o)n[c] = o[c];
            return i;
        },
        timeout: (s, i)=>{
            if (!r) return;
            const c = setTimeout(()=>{
                s(o), clearTimeout(c);
            }, i);
        }
    };
}
function Ot(e, ...t) {
    const n = this.context, o = n.utils?.[e] || n.functions?.[e] || n.methods?.[e] || n.snippets?.[e];
    if (o && !(0, $2C0hZ.isFailedRevival)(o)) try {
        const r = o.call(this, ...t);
        return r && typeof r.then == "function" && r.catch((s)=>{
            O.call(this, s);
        }), r;
    } catch (r) {
        if (O.call(this, r), n?.strictMode) throw r;
    }
}
const L = "[smbls] getDB needs @symbo.ls/fetch, which the smbls embed bundle does not include: add @symbo.ls/fetch to the page's importmap (the runtime import then resolves) or use the full smbls bundle.";

const g = ()=>Promise.resolve((parcelRequire("4skhB"))).catch((e)=>{
        throw new Error(L, {
            cause: e
        });
    });
async function Rt() {
    const e = this, t = e.context?.fetch;
    if (!t) return null;
    if (typeof t.select == "function") {
        if (!t.__authInitialized && t.getSession) {
            const { initAdapterAuth: r } = await g();
            await r(t, e.context);
        }
        return t;
    }
    if (t.__resolved) {
        if (!t.__resolved.__authInitialized && t.__resolved.getSession) {
            const { initAdapterAuth: r } = await g();
            await r(t.__resolved, e.context);
        }
        return t.__resolved;
    }
    if (t.__resolving) return t.__resolving;
    const n = g().then(({ resolveDb: r })=>r(t));
    t.__resolving = n;
    const o = await n;
    if (t.__resolved = o, e.context.fetch = o, delete t.__resolving, o?.getSession) {
        const { initAdapterAuth: r } = await g();
        await r(o, e.context);
    }
    return o;
}
function $t(e) {
    const t = this, n = e || (0, $69Bo3.OPTIONS).useStateQuery || t.context?.useStateQuery;
    if (!n) return null;
    const o = {};
    if (x(t, o), n === !0) return o;
    const r = H[n];
    return r ? r(o) : o;
}
const x = (e, t)=>{
    const n = e.__ref;
    if (!n) return;
    const o = n.__state;
    o && typeof o == "string" && M(t, o);
    const r = n.__children;
    if (r) for(let c = 0; c < r.length; c++){
        const l = e[r[c]];
        l && l.__ref && x(l, t);
    }
    const s = n.contentElementKey || "content", i = e[s];
    i && i.__ref && x(i, t);
}, M = (e, t)=>{
    const o = t.replaceAll("../", "").replaceAll("~/", "").split("/");
    let r = e;
    for(let s = 0; s < o.length; s++){
        const i = o[s];
        s === o.length - 1 ? r[i] || (r[i] = !0) : (r[i] === !0 && (r[i] = {}), r[i] || (r[i] = {}), r = r[i]);
    }
}, R = (e, t = 0)=>{
    const n = "  ".repeat(t), o = Object.entries(e);
    return o.length ? o.map(([s, i])=>i === !0 ? `${n}${s}` : `${n}${s} {
${R(i, t + 1)}
${n}}`).join(`
`) : "";
}, G = (e)=>`{
${R(e, 1)}
}`, J = (e)=>{
    const t = {
        fields: {},
        include: []
    }, n = (o, r)=>{
        const s = [];
        for(const i in o)if (o[i] === !0) s.push(i);
        else {
            const c = r ? `${r}.${i}` : i;
            t.include.push(c), n(o[i], c);
        }
        s.length && (t.fields[r || "_root"] = s);
    };
    return n(e, ""), t;
}, B = (e)=>{
    const t = (s)=>{
        const i = [], c = [];
        for(const l in s)if (s[l] === !0) i.push(l);
        else {
            const f = t(s[l]), u = [];
            f.select && u.push(`$select=${f.select}`), f.expand && u.push(`$expand=${f.expand}`), c.push(u.length ? `${l}(${u.join(";")})` : l);
        }
        return {
            select: i.length ? i.join(",") : "",
            expand: c.length ? c.join(",") : ""
        };
    }, { select: n, expand: o } = t(e), r = [];
    return n && r.push(`$select=${n}`), o && r.push(`$expand=${o}`), r.join("&");
}, V = (e, t)=>{
    const n = [], o = [], r = new Set, s = (u, h, m)=>{
        r.add(h), m && o.push(`LEFT JOIN ${h} ON ${h}.${m}_id = ${m}.id`);
        for(const d in u)u[d] === !0 ? n.push(`${h}.${d}`) : s(u[d], d, h);
    }, i = Object.keys(e);
    i.length === 1 && e[i[0]] !== !0 ? s(e[i[0]], i[0], null) : s(e, "_root", null);
    const c = [
        ...r
    ][0] || "_root", l = n.length ? n.join(", ") : "*", f = o.length ? `
` + o.join(`
`) : "";
    return `SELECT ${l}
FROM ${c}${f}`;
}, z = (e)=>{
    const t = [], n = (o, r)=>{
        for(const s in o){
            const i = r ? `${r}/${s}` : s;
            o[s] === !0 ? t.push(i) : n(o[s], i);
        }
    };
    return n(e, ""), t;
}, H = {
    graphql: G,
    "json-api": J,
    odata: B,
    sql: V,
    paths: z
};
function kt(e, t) {
    return !!((0, $cjyfe.METHODS).has(e) || t?.context?.methods?.[e]);
}

});
parcelRegister("BEBTO", function(module, exports) {

$parcel$export(module.exports, "applyEvent", () => $0712f52bc9c64383$export$27ca81ea148fa005);
$parcel$export(module.exports, "triggerEventOn", () => $0712f52bc9c64383$export$1bc010482b845252);
$parcel$export(module.exports, "applyEventUpdate", () => $0712f52bc9c64383$export$906113ec468a9c43);
$parcel$export(module.exports, "triggerEventOnUpdate", () => $0712f52bc9c64383$export$8fe90418b8a0fc1e);

var $czfS0 = parcelRequire("czfS0");

var $gjNoZ = parcelRequire("gjNoZ");
const $0712f52bc9c64383$var$a = (t, r)=>{
    const o = "on" + t.charAt(0).toUpperCase() + t.slice(1);
    return r[o];
}, $0712f52bc9c64383$export$27ca81ea148fa005 = (t, r, o, s, e)=>{
    if (t = (0, $gjNoZ.resolveHandler)(t, r), !!(0, $czfS0.isFunction)(t)) try {
        const n = t.call(r, r, o || r.state, s || r.context, e);
        return n && typeof n.then == "function" && n.catch((c)=>{
            r.error = c, c instanceof ReferenceError ? console.warn("[DOMQL] Async event warning:", c.message) : console.error("[DOMQL] Async event error:", c);
        }), n;
    } catch (n) {
        if (r.error = n, n instanceof ReferenceError ? console.warn("[DOMQL] Event handler warning:", n.message) : console.error("[DOMQL] Event handler error:", n), r.context?.strictMode) throw n;
    }
}, $0712f52bc9c64383$export$1bc010482b845252 = (t, r, o)=>{
    if (!r) throw new Error("Element is required");
    (0, $gjNoZ.runPluginHook)(t, r, o);
    const s = $0712f52bc9c64383$var$a(t, r);
    if (s) {
        const { state: e, context: n } = r;
        return $0712f52bc9c64383$export$27ca81ea148fa005(s, r, e, n, o);
    }
}, $0712f52bc9c64383$export$906113ec468a9c43 = (t, r, o, s, e, n)=>{
    if (t = (0, $gjNoZ.resolveHandler)(t, o), !!(0, $czfS0.isFunction)(t)) try {
        const c = t.call(o, r, o, s || o.state, e || o.context, n);
        return c && typeof c.then == "function" && c.catch((i)=>{
            o.error = i, console.error("[DOMQL] Async event update error:", i);
        }), c;
    } catch (c) {
        if (o.error = c, console.error("[DOMQL] Event update error:", c), o.context?.strictMode) throw c;
    }
}, $0712f52bc9c64383$export$8fe90418b8a0fc1e = (t, r, o, s)=>{
    (0, $gjNoZ.runPluginHook)(t, o, r, s);
    const e = $0712f52bc9c64383$var$a(t, o);
    if (e) {
        const { state: n, context: c } = o;
        return $0712f52bc9c64383$export$906113ec468a9c43(e, r, o, n, c, s);
    }
};

});

parcelRegister("69Bo3", function(module, exports) {

$parcel$export(module.exports, "cache", () => $47b095a06e5dcd17$export$69a3209f1a06c04d);
$parcel$export(module.exports, "OPTIONS", () => $47b095a06e5dcd17$export$8eb3892b442747bd);
const $47b095a06e5dcd17$export$69a3209f1a06c04d = {}, $47b095a06e5dcd17$export$8eb3892b442747bd = {};

});

parcelRegister("4skhB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "registerAdapter", () => $33e982b025a1d2ac$export$ddf4d3602a252674);
$parcel$export(module.exports, "hasAdapter", () => $33e982b025a1d2ac$export$f0289369b1209a3f);
$parcel$export(module.exports, "createAdapter", () => $33e982b025a1d2ac$export$968afe682db9f0d4);
$parcel$export(module.exports, "resolveDb", () => $33e982b025a1d2ac$export$a4b5c162303531b1);
$parcel$export(module.exports, "fetchRunsOf", () => $33e982b025a1d2ac$export$2e164cec79048072);
$parcel$export(module.exports, "initAdapterAuth", () => $33e982b025a1d2ac$export$d225206060a26402);
$parcel$export(module.exports, "seedFromPage", () => $33e982b025a1d2ac$export$adce894ae82cc8eb);
$parcel$export(module.exports, "executeFetch", () => $33e982b025a1d2ac$export$8ced815accfd9df6);
$parcel$export(module.exports, "queryClient", () => $33e982b025a1d2ac$export$7c07b633a151f9c5);
$parcel$export(module.exports, "fetchFunctions", () => $33e982b025a1d2ac$export$469c76e42c7829b7);
$parcel$export(module.exports, "revalidateSeed", () => $33e982b025a1d2ac$export$d0243251426106e4);
$parcel$export(module.exports, "fetchPlugin", () => $33e982b025a1d2ac$export$3e7aa3050ca4b6c);
$parcel$export(module.exports, "default", () => $33e982b025a1d2ac$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EARLY_KEY", () => (parcelRequire("avEQR")).EARLY_KEY);
$parcel$export(module.exports, "SEED_BLOCK", () => (parcelRequire("avEQR")).SEED_BLOCK);
$parcel$export(module.exports, "STALE_ATTRIBUTE", () => (parcelRequire("avEQR")).STALE_ATTRIBUTE);
$parcel$export(module.exports, "createEarlySeedBlock", () => (parcelRequire("avEQR")).createEarlySeedBlock);
$parcel$export(module.exports, "createEarlySeedScript", () => (parcelRequire("avEQR")).createEarlySeedScript);
$parcel$export(module.exports, "earlyKey", () => (parcelRequire("avEQR")).earlyKey);
$parcel$export(module.exports, "parseDuration", () => (parcelRequire("dFO0P")).parseDuration);
$parcel$export(module.exports, "requestsInFlight", () => (parcelRequire("9ZqBV")).requestsInFlight);
$parcel$export(module.exports, "seedIsStale", () => (parcelRequire("avEQR")).seedIsStale);
$parcel$export(module.exports, "whenRequestsIdle", () => (parcelRequire("9ZqBV")).whenRequestsIdle);
$parcel$export(module.exports, "whenSeedTaken", () => (parcelRequire("avEQR")).whenSeedTaken);
parcelRequire("byww3");
var $5zSXA = parcelRequire("5zSXA");
var $2C0hZ = parcelRequire("2C0hZ");
var $czfS0 = parcelRequire("czfS0");
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $avEQR = parcelRequire("avEQR");

var $bceDf = parcelRequire("bceDf");

var $dFO0P = parcelRequire("dFO0P");

var $9MmMs = parcelRequire("9MmMs");


var $9ZqBV = parcelRequire("9ZqBV");
const $33e982b025a1d2ac$var$xe = [
    "select",
    "rpc",
    "insert",
    "update",
    "upsert",
    "delete",
    "subscribe"
];


const $33e982b025a1d2ac$var$ye = {
    rest: ()=>Promise.resolve($9MmMs),
    local: ()=>(parcelRequire("jJAFY")),
    symbols: ()=>(parcelRequire("hMlqH"))
}, $33e982b025a1d2ac$var$mt = Symbol.for("@symbo.ls/fetch:CUSTOM_ADAPTERS"), $33e982b025a1d2ac$var$H = (()=>{
    if (typeof globalThis < "u" && globalThis[$33e982b025a1d2ac$var$mt]) return globalThis[$33e982b025a1d2ac$var$mt];
    const t = {};
    if (typeof globalThis < "u") try {
        return Object.defineProperty(globalThis, $33e982b025a1d2ac$var$mt, {
            value: t,
            writable: !1,
            configurable: !1,
            enumerable: !1
        }), globalThis[$33e982b025a1d2ac$var$mt];
    } catch  {}
    return t;
})(), $33e982b025a1d2ac$var$Dt = Symbol.for("@symbo.ls/fetch:PENDING_ADAPTERS"), $33e982b025a1d2ac$var$Bt = (()=>{
    if (typeof globalThis < "u" && globalThis[$33e982b025a1d2ac$var$Dt]) return globalThis[$33e982b025a1d2ac$var$Dt];
    const t = {};
    if (typeof globalThis < "u") try {
        return Object.defineProperty(globalThis, $33e982b025a1d2ac$var$Dt, {
            value: t,
            writable: !1,
            configurable: !1,
            enumerable: !1
        }), globalThis[$33e982b025a1d2ac$var$Dt];
    } catch  {}
    return t;
})(), $33e982b025a1d2ac$var$Je = 5e3, $33e982b025a1d2ac$var$He = (t)=>new Promise((e)=>{
        if ($33e982b025a1d2ac$var$H[t]) return e($33e982b025a1d2ac$var$H[t]);
        const r = $33e982b025a1d2ac$var$Bt[t] ||= [];
        let s = !1;
        const n = ()=>{
            s || (s = !0, e($33e982b025a1d2ac$var$H[t] || null));
        };
        r.push(n), setTimeout(n, $33e982b025a1d2ac$var$Je);
    }), $33e982b025a1d2ac$export$ddf4d3602a252674 = (t, e)=>{
    $33e982b025a1d2ac$var$H[t] = e;
    const r = $33e982b025a1d2ac$var$Bt[t];
    if (r && r.length) {
        $33e982b025a1d2ac$var$Bt[t] = [];
        for (const s of r)s();
    }
}, $33e982b025a1d2ac$export$f0289369b1209a3f = (t)=>typeof t == "string" && !!($33e982b025a1d2ac$var$H[t] || $33e982b025a1d2ac$var$ye[t]), $33e982b025a1d2ac$export$968afe682db9f0d4 = (t)=>{
    const e = {};
    for (const r of $33e982b025a1d2ac$var$xe)t[r] && (e[r] = t[r]);
    return e.name = t.name || "custom", e;
}, $33e982b025a1d2ac$export$a4b5c162303531b1 = async (t, e)=>{
    if (!t) return null;
    if (typeof t.select == "function") return t;
    const { adapter: r, ...s } = t, n = typeof r == "string" ? r : typeof t == "string" ? t : null;
    if (!n) return null;
    let a = $33e982b025a1d2ac$var$H[n] || $33e982b025a1d2ac$var$ye[n];
    if (!a && (a = await $33e982b025a1d2ac$var$He(n), !a)) throw new Error(`Unknown db adapter: "${n}". Use registerAdapter() for adapters with optional deps.`);
    const i = await a();
    if (!i || typeof i.setup != "function") throw new Error(`Adapter "${n}" loader returned a module without a setup() function. Got keys: [${Object.keys(i || {}).join(", ")}]. Likely a bundler chunk-resolution issue.`);
    return i.setup(s, e);
}, $33e982b025a1d2ac$var$dt = (t)=>!!t && !!t.isolateFetchCache, $33e982b025a1d2ac$var$Kt = Symbol.for("@symbo.ls/fetch:runs"), $33e982b025a1d2ac$var$Se = (t)=>(t.method === "select" || t.method === "rpc") && !$33e982b025a1d2ac$var$pt(t) && !t.infinite && !$33e982b025a1d2ac$var$tt(t), $33e982b025a1d2ac$var$Xe = (t, e, r)=>{
    if (typeof r != "number") return;
    let s = t[$33e982b025a1d2ac$var$Kt];
    if (!s) {
        s = new Map;
        try {
            Object.defineProperty(t, $33e982b025a1d2ac$var$Kt, {
                value: s,
                configurable: !0
            });
        } catch  {
            return;
        }
    }
    let n = s.get(e);
    n || s.set(e, n = new Set), n.add(r);
}, $33e982b025a1d2ac$export$2e164cec79048072 = (t, e = (0, $5zSXA.elementPath))=>{
    const r = t && t[$33e982b025a1d2ac$var$Kt], s = {};
    if (!r) return s;
    for (const [n, a] of r){
        if (!n || !n.__ref) continue;
        let i;
        try {
            i = e(n);
        } catch  {
            continue;
        }
        if (typeof i != "string") continue;
        const c = s[i] || (s[i] = []);
        for (const o of a)c.includes(o) || c.push(o);
        c.sort((o, f)=>o - f);
    }
    return s;
}, $33e982b025a1d2ac$var$be = ()=>({
        cache: new Map,
        subscribers: new Map,
        active: new Map,
        invalidatedAt: new Map,
        reconnectedAt: 0,
        mounted: new Set
    }), $33e982b025a1d2ac$var$N = $33e982b025a1d2ac$var$be(), $33e982b025a1d2ac$var$we = new WeakMap, $33e982b025a1d2ac$var$L = (t)=>{
    if (!$33e982b025a1d2ac$var$dt(t)) return $33e982b025a1d2ac$var$N;
    let e = $33e982b025a1d2ac$var$we.get(t);
    return e || $33e982b025a1d2ac$var$we.set(t, e = $33e982b025a1d2ac$var$be()), e;
};
let $33e982b025a1d2ac$var$ht = 0;
const $33e982b025a1d2ac$var$kt = new WeakMap, $33e982b025a1d2ac$var$Pt = (t, e, r, s, n = t.page, a = t.cursor)=>{
    if (t.cache?.key) return t.cache.key;
    const { from: i, method: c, infinite: o } = t, f = r ? `${r}:` : "", p = s ? `:${s}` : "", d = n ? ":p" + JSON.stringify(n) : "", A = a != null ? ":c" + JSON.stringify(a) : "";
    return `${i}:${c}:${f}${JSON.stringify(e || "")}${o ? ":infinite" : ""}${d}${A}${p}`;
}, $33e982b025a1d2ac$var$V = (t, e)=>t.cache.get(e) || null, $33e982b025a1d2ac$var$nt = (t, e, r, s, n = ++$33e982b025a1d2ac$var$ht, a = !1)=>{
    const i = {
        data: r,
        error: s,
        time: Date.now(),
        stale: a,
        seq: n
    };
    t.cache.set(e, i);
    const c = t.subscribers.get(e);
    if (c) for (const o of c)(0, $czfS0.isFunction)(o) && o(i);
    return i;
}, $33e982b025a1d2ac$var$Ft = (t, e, r)=>{
    const s = e ? t.cache.get(e) : null;
    return s && !s.error && s.seq > r ? s : null;
}, $33e982b025a1d2ac$var$Yt = (t, e, r)=>(t.invalidatedAt.get(e) || 0) > r, $33e982b025a1d2ac$var$Wt = (t, e, r)=>{
    const s = $33e982b025a1d2ac$var$kt.get(r) || 0;
    return s > t.reconnectedAt && !$33e982b025a1d2ac$var$Yt(t, e, s);
}, $33e982b025a1d2ac$var$Ct = (t, e)=>{
    t.invalidatedAt.set(e, ++$33e982b025a1d2ac$var$ht);
}, $33e982b025a1d2ac$var$ge = (t, e)=>{
    t.cache.delete(e), $33e982b025a1d2ac$var$Ct(t, e);
}, $33e982b025a1d2ac$var$Ur = (t, e, r)=>{
    const { subscribers: s } = t;
    return s.has(e) || s.set(e, new Set), s.get(e).add(r), ()=>{
        const n = s.get(e);
        n && (n.delete(r), n.size === 0 && s.delete(e));
    };
}, $33e982b025a1d2ac$var$Mt = (t)=>!t && t !== !1 ? {
        staleTime: 6e4,
        gcTime: 3e5
    } : t === !1 ? null : t === !0 ? {
        staleTime: 6e4,
        gcTime: 3e5
    } : typeof t == "number" ? {
        staleTime: t,
        gcTime: Math.max(t * 5, 3e5)
    } : (0, $czfS0.isString)(t) ? {
        staleTime: (0, $dFO0P.parseDuration)(t),
        gcTime: 3e5
    } : {
        staleTime: (0, $dFO0P.parseDuration)(t.stale || t.staleTime) || 6e4,
        gcTime: (0, $dFO0P.parseDuration)(t.gc || t.gcTime || t.expire) || 3e5,
        key: t.key
    }, $33e982b025a1d2ac$var$ve = (t)=>!!t.ref && t.element.__ref === t.ref, $33e982b025a1d2ac$var$Ze = ({ config: t, element: e, context: r })=>{
    try {
        return $33e982b025a1d2ac$var$xt(t, e, r);
    } catch  {
        return null;
    }
};
let $33e982b025a1d2ac$var$Ot = null;
const $33e982b025a1d2ac$var$tr = ()=>{
    $33e982b025a1d2ac$var$Ot || ($33e982b025a1d2ac$var$Ot = setInterval(()=>{
        const t = Date.now(), { cache: e, subscribers: r, active: s, invalidatedAt: n, mounted: a } = $33e982b025a1d2ac$var$N;
        for (const [i, c] of e){
            const o = r.get(i);
            !(o && o.size > 0) && t - c.time > (c.gcTime || 3e5) && e.delete(i);
        }
        for (const [i] of n)!e.has(i) && !s.has(i) && n.delete(i);
        for (const i of a)$33e982b025a1d2ac$var$ve(i) || a.delete(i);
    }, 3e4), $33e982b025a1d2ac$var$Ot.unref && $33e982b025a1d2ac$var$Ot.unref());
};
$33e982b025a1d2ac$var$tr();
const $33e982b025a1d2ac$var$Te = 3, $33e982b025a1d2ac$var$Ae = 3e4, $33e982b025a1d2ac$var$Gt = (t)=>Math.min(1e3 * 2 ** t, $33e982b025a1d2ac$var$Ae), $33e982b025a1d2ac$var$er = (t, e)=>{
    for (const r of [
        t?.status,
        e?.status,
        e?.statusCode
    ]){
        const s = typeof r == "string" && /^\d{3}$/.test(r) ? Number(r) : r;
        if (Number.isInteger(s) && s >= 100 && s < 600) return s;
    }
    return null;
}, $33e982b025a1d2ac$var$rr = (t)=>t >= 400 && t < 500 && t !== 408 && t !== 429, $33e982b025a1d2ac$var$sr = (t)=>{
    if (t == null) return null;
    const e = String(t).trim();
    if (/^\d+$/.test(e)) return Number(e) * 1e3;
    if (!/[a-z]/i.test(e)) return null;
    const r = Date.parse(e);
    return Number.isNaN(r) ? null : Math.max(0, r - Date.now());
}, $33e982b025a1d2ac$var$Ee = (t, e)=>{
    const r = t.retry;
    return r === void 0 && e ? {
        count: 0
    } : r === !1 ? {
        count: 0
    } : r === !0 || r === void 0 ? {
        count: $33e982b025a1d2ac$var$Te,
        delay: $33e982b025a1d2ac$var$Gt
    } : typeof r == "number" ? {
        count: r,
        delay: $33e982b025a1d2ac$var$Gt
    } : {
        count: r.count ?? $33e982b025a1d2ac$var$Te,
        delay: (0, $czfS0.isFunction)(r.delay) ? r.delay : typeof r.delay == "number" ? ()=>r.delay : $33e982b025a1d2ac$var$Gt
    };
}, $33e982b025a1d2ac$var$me = async (t, e)=>{
    const { count: r, delay: s } = e;
    let n, a = !1;
    const i = (c, o, f)=>{
        if (c >= r) return null;
        const p = $33e982b025a1d2ac$var$er(o, f);
        if (p !== null && $33e982b025a1d2ac$var$rr(p)) return null;
        if (p === 429) {
            if (a) return null;
            a = !0;
            const d = $33e982b025a1d2ac$var$sr(o?.retryAfter ?? f?.retryAfter);
            if (d !== null) return d <= $33e982b025a1d2ac$var$Ae ? {
                ms: d
            } : null;
        }
        return {
            ms: (0, $czfS0.isFunction)(s) ? s(c, f) : s
        };
    };
    for(let c = 0; c <= r; c++)try {
        const o = await t();
        if (o?.error) {
            n = o.error;
            const f = i(c, o, n);
            if (f) {
                await new Promise((p)=>setTimeout(p, f.ms));
                continue;
            }
            return o;
        }
        return o;
    } catch (o) {
        n = o;
        const f = i(c, null, o);
        if (f) {
            await new Promise((p)=>setTimeout(p, f.ms));
            continue;
        }
        throw o;
    }
    return {
        data: null,
        error: n
    };
}, $33e982b025a1d2ac$var$at = {
    focus: new Set,
    online: new Set
};
let $33e982b025a1d2ac$var$De = !1;
const $33e982b025a1d2ac$var$ke = ()=>{
    if ($33e982b025a1d2ac$var$De || typeof window > "u") return;
    $33e982b025a1d2ac$var$De = !0;
    const t = ()=>{
        for (const r of $33e982b025a1d2ac$var$at.focus)r();
    }, e = ()=>{
        $33e982b025a1d2ac$var$N.reconnectedAt = ++$33e982b025a1d2ac$var$ht;
        for (const r of $33e982b025a1d2ac$var$at.online)r();
    };
    window.addEventListener("visibilitychange", ()=>{
        document.visibilityState === "visible" && t();
    }), window.addEventListener("focus", t), window.addEventListener("online", e);
}, $33e982b025a1d2ac$var$Pe = (t, e)=>{
    const r = e.__ref;
    if (t === !0) return {
        from: r.__state || e.key,
        method: "select",
        query: !0,
        on: "create"
    };
    if ((0, $czfS0.isString)(t)) return {
        from: t,
        method: "select",
        query: !0,
        on: "create"
    };
    if ((0, $czfS0.isObject)(t)) {
        const s = {
            ...t
        };
        return s.from = s.from || r.__state || e.key, s.method = s.method || "select", s.on = $33e982b025a1d2ac$var$nr(s.on), s.query === void 0 && (s.query = !0), s;
    }
    return null;
}, $33e982b025a1d2ac$var$nr = (t)=>{
    if (!(0, $czfS0.isArray)(t)) return (0, $czfS0.isString)(t) && t ? t : "create";
    const e = [];
    for (const r of t)(0, $czfS0.isString)(r) && r && !e.includes(r) && e.push(r);
    return e.length ? e.length === 1 ? e[0] : e : "create";
}, $33e982b025a1d2ac$var$Fe = (t)=>(0, $czfS0.isArray)(t.on) ? t.on : [
        t.on || "create"
    ], $33e982b025a1d2ac$var$X = (t, e)=>(0, $czfS0.isArray)(t.on) ? t.on.includes(e) : (t.on || "create") === e, $33e982b025a1d2ac$var$ar = [
    "insert",
    "update",
    "upsert",
    "delete"
], $33e982b025a1d2ac$var$Ce = (t)=>$33e982b025a1d2ac$var$ar.includes(t), $33e982b025a1d2ac$var$pt = (t)=>t.mutation === !0 ? !0 : t.mutation === !1 || t.method !== "rpc" ? !1 : $33e982b025a1d2ac$var$X(t, "submit") || $33e982b025a1d2ac$var$X(t, "click") || t.invalidates != null, $33e982b025a1d2ac$var$Z = (t, e)=>{
    const r = t?.state?.root || e?.state?.root;
    if (r?.lang) return r.lang;
}, $33e982b025a1d2ac$var$_t = (t, e)=>{
    const s = (t?.state?.root || e?.state?.root)?.__fetchScope;
    return s ? String(s) : void 0;
}, $33e982b025a1d2ac$var$ot = (t, e, r)=>{
    let s;
    if (!t) s = void 0;
    else if ((0, $czfS0.isFunction)(t)) s = t(e, e.state);
    else {
        s = {};
        for(const n in t){
            const a = t[n];
            s[n] = (0, $czfS0.isFunction)(a) ? a(e, e.state) : a;
        }
    }
    return s;
}, $33e982b025a1d2ac$var$G = (t, e)=>(0, $czfS0.isFunction)(t) ? t(e, e.state) : t, $33e982b025a1d2ac$var$xt = (t, e, r)=>$33e982b025a1d2ac$var$Pt(t, $33e982b025a1d2ac$var$ot(t.params, e, r), $33e982b025a1d2ac$var$_t(e, r), $33e982b025a1d2ac$var$Z(e, r), $33e982b025a1d2ac$var$G(t.page, e), $33e982b025a1d2ac$var$G(t.cursor, e)), $33e982b025a1d2ac$export$d225206060a26402 = async (t, e)=>{
    if (!t || t.__authInitialized || (t.__authInitialized = !0, !t.getSession)) return;
    const r = (s, n)=>{
        const a = e.state?.root;
        a?.update && a.update({
            auth: {
                user: s,
                session: n,
                loading: !1
            }
        });
    };
    try {
        const s = await t.getSession();
        r(s?.user || null, s);
    } catch (s) {
        console.warn("[fetch] Failed to restore auth session:", s.message);
    }
    t.onAuthStateChange && t.onAuthStateChange((s, n)=>{
        r(n?.user || null, n);
    });
}, $33e982b025a1d2ac$var$or = async (t, e)=>{
    if ((0, $czfS0.isFunction)(t.select)) return t.auth !== !1 && await $33e982b025a1d2ac$export$d225206060a26402(t, e), t;
    if (t.__resolved) return t.auth !== !1 && await $33e982b025a1d2ac$export$d225206060a26402(t.__resolved, e), t.__resolved;
    if (t.__resolving) return t.__resolving;
    t.__resolving = $33e982b025a1d2ac$export$a4b5c162303531b1(t, {
        serverRender: $33e982b025a1d2ac$var$dt(e)
    });
    let r;
    try {
        r = await t.__resolving;
    } finally{
        delete t.__resolving;
    }
    return r ? (r.auth = t.auth, r.url = t.url, r.key = t.key, t.__resolved = r, e.fetch = r, t.auth !== !1 && await $33e982b025a1d2ac$export$d225206060a26402(r, e), r) : null;
}, $33e982b025a1d2ac$var$Ht = async (t, e, r, s)=>{
    try {
        return await $33e982b025a1d2ac$var$or(t, e);
    } catch (n) {
        return r && ($33e982b025a1d2ac$var$z(r, $33e982b025a1d2ac$var$Rt(n)), $33e982b025a1d2ac$var$I(r, "onFetchError", n), $33e982b025a1d2ac$var$U(s, r, "onFetchError", n)), null;
    }
}, $33e982b025a1d2ac$var$I = (t, e, ...r)=>{
    const s = (0, $czfS0.isFunction)(t[e]) ? t[e] : null;
    s && s.call(t, ...r, t, t.state, t.context);
}, $33e982b025a1d2ac$var$U = (t, e, r, ...s)=>{
    const n = t && (0, $czfS0.isFunction)(t[r]) ? t[r] : null;
    n && n.call(e, ...s, e, e.state, e.context);
}, $33e982b025a1d2ac$var$yt = (t)=>{
    const e = {}, r = t.node;
    if (!r) return e;
    if (r.tagName === "FORM") {
        const n = new FormData(r);
        for (const [a, i] of n.entries())e[a] = i;
        return e;
    }
    const s = r.querySelectorAll("input, textarea, select");
    for(let n = 0; n < s.length; n++){
        const a = s[n], i = a.name || a.getAttribute("name");
        i && (a.type === "checkbox" ? e[i] = a.checked : a.type === "file" ? e[i] = a.files : e[i] = a.value);
    }
    return e;
}, $33e982b025a1d2ac$var$tt = (t)=>t.responseType === "stream" || t.responseType === "response", $33e982b025a1d2ac$var$ir = [
    "Blob",
    "File",
    "ArrayBuffer",
    "ReadableStream",
    "Response"
], $33e982b025a1d2ac$var$Vt = (t)=>t !== null && typeof t == "object" && (ArrayBuffer.isView(t) || $33e982b025a1d2ac$var$ir.includes(Object.prototype.toString.call(t).slice(8, -1))), $33e982b025a1d2ac$var$B = (t, e, r, s = {})=>{
    if (!r && $33e982b025a1d2ac$var$Vt(e)) return;
    const n = r && r.startsWith("~/"), a = n && t.state?.root || t.state;
    if (a?.update) {
        if (n) {
            const i = r.slice(2);
            e && typeof e == "object" && !Array.isArray(e) && !$33e982b025a1d2ac$var$Vt(e) && i in e ? a.update(e, {
                preventFetch: !0,
                ...s
            }) : a.update({
                [i]: e
            }, {
                preventFetch: !0,
                ...s
            });
        } else {
            const i = r ? {
                [r]: e
            } : e;
            a.update(i, {
                preventFetch: !0,
                ...s
            });
        }
    }
}, $33e982b025a1d2ac$var$it = (t, e, r)=>{
    const s = e.partialAs;
    if (!s || !(0, $czfS0.isString)(s)) return;
    const n = s.startsWith("~/"), a = n && t.state?.root || t.state;
    a?.update && a.update({
        [n ? s.slice(2) : s]: r
    }, {
        preventFetch: !0
    });
}, $33e982b025a1d2ac$var$Lt = Object.freeze({
    isFetching: !1,
    isLoading: !1,
    isStale: !1,
    isSuccess: !0,
    error: null,
    status: "success",
    fetchStatus: "idle"
}), $33e982b025a1d2ac$var$cr = Object.freeze({
    isFetching: !0,
    isLoading: !1,
    isStale: !1,
    isSuccess: !1,
    error: null,
    status: "pending",
    fetchStatus: "fetching"
}), $33e982b025a1d2ac$var$Rt = (t)=>({
        isFetching: !1,
        isLoading: !1,
        isStale: !1,
        isSuccess: !1,
        error: t,
        status: "error",
        fetchStatus: "idle"
    }), $33e982b025a1d2ac$var$z = (t, e)=>{
    const r = t?.__ref;
    r && (r.__fetchStatus = {
        ...e,
        isError: !!e.error
    }, r.__fetching = e.isFetching, r.__fetchError = e.error);
}, $33e982b025a1d2ac$var$Xt = (t, e, r)=>{
    const s = t.__pages && t.__pages.length ? t.__pages : [
        r
    ];
    (0, $czfS0.isFunction)(e.getNextPageParam) && (t.__nextPageParam = e.getNextPageParam(s[s.length - 1], s), t.__hasNextPage = t.__nextPageParam != null), (0, $czfS0.isFunction)(e.getPreviousPageParam) && (t.__prevPageParam = e.getPreviousPageParam(s[0], s), t.__hasPreviousPage = t.__prevPageParam != null);
}, $33e982b025a1d2ac$var$qt = (t)=>(0, $czfS0.isObject)(t.infinite) ? t.infinite : null, $33e982b025a1d2ac$var$ur = (t, e)=>{
    let r = t;
    for (const s of e.split(".")){
        if (r == null) return;
        r = r[s];
    }
    return r;
}, $33e982b025a1d2ac$var$Me = (t, e, r)=>{
    const [s, ...n] = e.split("."), a = (0, $czfS0.isArray)(t) ? [
        ...t
    ] : {
        ...t
    };
    return a[s] = n.length ? $33e982b025a1d2ac$var$Me((0, $czfS0.isObject)(t?.[s]) ? t[s] : {}, n.join("."), r) : r, a;
}, $33e982b025a1d2ac$var$Oe = (t, e)=>{
    const r = $33e982b025a1d2ac$var$qt(t)?.rows;
    return (0, $czfS0.isFunction)(r) ? r(e) : (0, $czfS0.isString)(r) ? $33e982b025a1d2ac$var$ur(e, r) : e;
}, $33e982b025a1d2ac$var$Zt = (t, e)=>(0, $czfS0.isFunction)($33e982b025a1d2ac$var$qt(t)?.merge) ? e != null : (0, $czfS0.isArray)($33e982b025a1d2ac$var$Oe(t, e)), $33e982b025a1d2ac$var$te = (t, e, r)=>{
    const s = $33e982b025a1d2ac$var$qt(t);
    if (s && (0, $czfS0.isFunction)(s.merge)) return s.merge(e, r, r.state);
    const n = [].concat(...e.map((a)=>$33e982b025a1d2ac$var$Oe(t, a) || []));
    return s && (0, $czfS0.isString)(s.rows) ? $33e982b025a1d2ac$var$Me(e[e.length - 1], s.rows, n) : n;
}, $33e982b025a1d2ac$var$fr = (t, e, r)=>{
    const s = $33e982b025a1d2ac$var$qt(t)?.param;
    return (0, $czfS0.isFunction)(s) ? s(r, {
        ...e
    }) : {
        ...e,
        [(0, $czfS0.isString)(s) ? s : "cursor"]: r
    };
}, $33e982b025a1d2ac$var$ee = (t, e, r, s, n, a)=>{
    const { from: i, single: c, limit: o, offset: f, order: p, headers: d, baseUrl: A, responseType: u } = t, _ = {
        from: i,
        select: e,
        params: r,
        single: c,
        limit: o,
        offset: f,
        order: p,
        headers: d,
        baseUrl: A
    };
    if (u !== void 0 && (_.responseType = u), s && (_.headers = {
        ..._.headers,
        "Accept-Language": s
    }), n !== void 0) {
        if ((0, $czfS0.isObject)(n)) n.offset !== void 0 && (_.offset = n.offset), n.limit !== void 0 && (_.limit = n.limit), n.cursor !== void 0 && (_.params = {
            ..._.params,
            cursor: n.cursor
        });
        else if (typeof n == "number") {
            const b = t.pageSize || o || 20;
            _.offset = (n - 1) * b, _.limit = b;
        }
    }
    return a !== void 0 && (_.params = $33e982b025a1d2ac$var$fr(t, _.params, a)), _;
}, $33e982b025a1d2ac$var$Nt = (t)=>typeof t.__slot == "number" ? t.__slot : t, $33e982b025a1d2ac$var$lr = (t, e, r)=>{
    t.__fetchAsked || (t.__fetchAsked = new Map), t.__fetchAsked.set($33e982b025a1d2ac$var$Nt(e), r);
}, $33e982b025a1d2ac$var$dr = (t, e, r)=>{
    const s = t.__fetchAsked && t.__fetchAsked.get($33e982b025a1d2ac$var$Nt(e));
    return s === void 0 || s === r;
}, $33e982b025a1d2ac$var$hr = (t, e, r, s)=>{
    const n = t.__fetchTaken && t.__fetchTaken.get($33e982b025a1d2ac$var$Nt(e));
    return !n || n.key !== r || n.seq < s;
}, $33e982b025a1d2ac$var$pr = (t, e, r, s)=>{
    t.__fetchTaken || (t.__fetchTaken = new Map), t.__fetchTaken.set($33e982b025a1d2ac$var$Nt(e), {
        key: r,
        seq: s
    });
}, $33e982b025a1d2ac$var$K = async (t, e, r, s = {})=>{
    const n = r?.fetch;
    if (!n || !e || !e.__ref) return;
    const a = e.__ref, i = $33e982b025a1d2ac$var$_t(e, r);
    (!a.__fetchScopeOwner || a.__fetchScopeOwner.scope !== i) && (a.__fetchScopeOwner = {
        scope: i
    });
    const c = a.__fetchScopeOwner, o = ()=>e.__ref === a && a.__fetchScopeOwner === c && $33e982b025a1d2ac$var$_t(e, r) === i;
    if (t.enabled === !1 || (0, $czfS0.isFunction)(t.enabled) && !t.enabled(e, e.state) || t.skip === !0 || (0, $czfS0.isFunction)(t.skip) && t.skip(e, e.state)) return;
    $33e982b025a1d2ac$var$dt(r) && $33e982b025a1d2ac$var$Se(t) && $33e982b025a1d2ac$var$Xe(r, e, t.__slot);
    const f = await $33e982b025a1d2ac$var$Ht(n, r, e, t);
    if (!f || !o()) return;
    const { from: p, method: d, query: A, params: u, cache: _, transform: b, single: Q, auth: w, fields: v, as: k, limit: D, offset: T, order: bt, headers: $, baseUrl: wt, responseType: F, page: j, cursor: gt, infinite: x, placeholderData: et, initialData: C, select: M, keepPreviousData: ct } = t, rt = (l)=>((0, $czfS0.isFunction)(M) && (l = M(l, e, e.state)), b && (l = b(l, e, e.state)), l), ut = (l)=>{
        $33e982b025a1d2ac$var$z(e, $33e982b025a1d2ac$var$Rt(l)), $33e982b025a1d2ac$var$it(e, t, !1), $33e982b025a1d2ac$var$I(e, "onFetchError", l), $33e982b025a1d2ac$var$U(t, e, "onFetchError", l);
    };
    let Ut = (0, $czfS0.isString)(M) ? M : void 0;
    if (A && (0, $czfS0.isFunction)(e.getQuery)) {
        const l = e.getQuery(f.name || "paths");
        l && (Ut = l.select || l.length && l.join(",") || Ut);
    }
    const Qt = $33e982b025a1d2ac$var$ot(u, e, r), ae = $33e982b025a1d2ac$var$G(j, e), oe = $33e982b025a1d2ac$var$G(gt, e), ft = $33e982b025a1d2ac$var$pt(t), vt = $33e982b025a1d2ac$var$tt(t) || ft ? null : $33e982b025a1d2ac$var$Mt(_), ze = $33e982b025a1d2ac$var$Ee(t, ft || $33e982b025a1d2ac$var$Ce(d)), ie = $33e982b025a1d2ac$var$Z(e, r), y = vt ? $33e982b025a1d2ac$var$Pt(t, Qt, i, ie, ae, oe) : null, P = $33e982b025a1d2ac$var$L(r), zt = !!y && !x;
    zt && $33e982b025a1d2ac$var$lr(a, t, y);
    const st = (l)=>!zt || $33e982b025a1d2ac$var$dr(a, t, y) && $33e982b025a1d2ac$var$hr(a, t, y, l), ce = (l)=>{
        zt && $33e982b025a1d2ac$var$pr(a, t, y, l);
    };
    if (!a.__fetchInitialized && y && (a.__fetchInitialized = !0, C !== void 0)) {
        const l = (0, $czfS0.isFunction)(C) ? C() : C;
        $33e982b025a1d2ac$var$nt(P, y, l, null);
    }
    if ((d === "select" || d === "rpc") && y && vt && !s.refresh && !s.force) {
        const l = $33e982b025a1d2ac$var$V(P, y);
        if (l && !l.error) {
            const g = Date.now() - l.time, S = l.stale || g > (vt.staleTime || 0), E = x && $33e982b025a1d2ac$var$Zt(t, l.data);
            E && !a.__pages && (a.__pages = [
                l.data
            ], $33e982b025a1d2ac$var$Xt(a, t, l.data));
            const m = rt(E ? $33e982b025a1d2ac$var$te(t, [
                l.data
            ], e) : l.data);
            if (!o()) return;
            if (!S) {
                $33e982b025a1d2ac$var$z(e, $33e982b025a1d2ac$var$Lt), $33e982b025a1d2ac$var$B(e, m, k), $33e982b025a1d2ac$var$it(e, t, !!l.partial), a.__seededOnCreate && a.__seededOnCreate.delete(y) && ($33e982b025a1d2ac$var$I(e, "onFetchComplete", m), $33e982b025a1d2ac$var$U(t, e, "onFetchComplete", m));
                return;
            }
            $33e982b025a1d2ac$var$B(e, m, k), $33e982b025a1d2ac$var$it(e, t, !!l.partial);
        } else if (et !== void 0) {
            const g = (0, $czfS0.isFunction)(et) ? et(e, e.state) : et;
            g !== void 0 && $33e982b025a1d2ac$var$B(e, g, k);
        }
    }
    const Tt = y && !s.force ? P.active.get(y) : null;
    if (Tt && $33e982b025a1d2ac$var$Wt(P, y, Tt)) {
        const l = $33e982b025a1d2ac$var$kt.get(Tt) || 0;
        try {
            const g = await Promise.race([
                Tt,
                new Promise((S, E)=>setTimeout(()=>E("DEDUP_TIMEOUT"), 15e3))
            ]);
            if (!o()) return;
            if (g?.error) st(l) && ut(g.error);
            else if (g?.data !== void 0) {
                const S = !x && $33e982b025a1d2ac$var$Ft(P, y, l), E = S ? S.seq : l;
                if (!st(E)) return;
                let m = S ? S.data : g.data;
                x && $33e982b025a1d2ac$var$Zt(t, m) && (a.__pages = [
                    m
                ], $33e982b025a1d2ac$var$Xt(a, t, m), m = $33e982b025a1d2ac$var$te(t, a.__pages, e));
                const R = rt(m);
                if (!o()) return;
                ce(E), $33e982b025a1d2ac$var$B(e, R, k), $33e982b025a1d2ac$var$it(e, t, !1), $33e982b025a1d2ac$var$I(e, "onFetchComplete", R), $33e982b025a1d2ac$var$U(t, e, "onFetchComplete", R);
            }
        } catch (g) {
            if (!o()) return;
            g !== "DEDUP_TIMEOUT" && st(l) && ut(g);
        }
        return;
    }
    const $e = !$33e982b025a1d2ac$var$V(P, y)?.data;
    $33e982b025a1d2ac$var$z(e, {
        isFetching: !0,
        isLoading: $e,
        isStale: !1,
        isSuccess: !1,
        error: null,
        status: "pending",
        fetchStatus: "fetching"
    }), $33e982b025a1d2ac$var$I(e, "onFetchStart"), $33e982b025a1d2ac$var$U(t, e, "onFetchStart");
    const Y = r?.analyze?.emitNetwork, $t = Y ? typeof performance < "u" ? performance.now() : Date.now() : 0;
    Y && Y({
        phase: "start",
        mode: "query",
        from: p,
        method: d,
        cacheKey: y,
        lang: ie
    });
    const ue = ()=>{
        Y && Y({
            phase: "success",
            mode: "query",
            ok: !0,
            from: p,
            method: d,
            cacheKey: y,
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - $t
        });
    }, je = async ()=>{
        if (!o()) return;
        if (w !== !1 && f.auth !== !1 && f.getSession) {
            const S = await f.getSession();
            if (!o()) return;
            if (w === !0 && !S) {
                const E = {
                    message: "Not authenticated"
                };
                return ut(E), {
                    data: null,
                    error: E
                };
            }
        }
        const l = f[d];
        if (!(0, $czfS0.isFunction)(l)) return {
            data: null,
            error: {
                message: `Method "${d}" not found on adapter`
            }
        };
        const g = $33e982b025a1d2ac$var$ee(t, Ut, Qt, $33e982b025a1d2ac$var$Z(e, r), ae, oe);
        if (d === "insert" || d === "update" || d === "upsert") {
            let S;
            if (v === !0 || $33e982b025a1d2ac$var$X(t, "submit")) S = $33e982b025a1d2ac$var$yt(e);
            else if ((0, $czfS0.isArray)(v)) {
                const E = $33e982b025a1d2ac$var$yt(e);
                S = {};
                for (const m of v)S[m] = E[m];
            } else e.state?.parse ? S = e.state.parse() : (0, $czfS0.isObject)(e.state) && (S = {
                ...e.state
            });
            b && (S = b(S, e, e.state)), g.data = S;
        }
        if (d === "rpc") {
            if ($33e982b025a1d2ac$var$X(t, "submit")) {
                const S = $33e982b025a1d2ac$var$yt(e);
                g.params = t.transformParams ? t.transformParams(S, e, e.state) : S;
            }
            g.read = !ft && t.read !== !1;
        }
        if (d === "subscribe") {
            if ((0, $czfS0.isFunction)(a.__unsubscribe)) {
                const E = a.__unsubscribe;
                a.__unsubscribe = null;
                try {
                    E();
                } catch  {}
            }
            const S = f.subscribe({
                from: p,
                params: Qt,
                on: t.subscribeOn
            }, (E, m, R)=>{
                o() && ($33e982b025a1d2ac$var$B(e, E, k), $33e982b025a1d2ac$var$I(e, "onFetchComplete", E), $33e982b025a1d2ac$var$U(t, e, "onFetchComplete", E));
            });
            return o() ? (a.__unsubscribe = S, {
                data: null,
                error: null,
                subscribed: !0
            }) : ((0, $czfS0.isFunction)(S) && S(), {
                data: null,
                error: null,
                subscribed: !0
            });
        }
        return l(g);
    }, W = ++$33e982b025a1d2ac$var$ht, At = $33e982b025a1d2ac$var$me(je, ze);
    $33e982b025a1d2ac$var$kt.set(At, W), y && P.active.set(y, At);
    try {
        const l = await At;
        if (y && l && !ft && (0, $avEQR.claimSeeded)(l, y), ft && t.invalidates && l && !l.error && !l.subscribed && $33e982b025a1d2ac$var$Le(P, t.invalidates, p), !o() || l?.subscribed) return;
        const { data: g, error: S } = l || {};
        if (S) {
            y && !$33e982b025a1d2ac$var$Ft(P, y, W) && $33e982b025a1d2ac$var$nt(P, y, null, S, W), st(W) && ut(S), Y && Y({
                phase: "error",
                mode: "query",
                from: p,
                method: d,
                cacheKey: y,
                error: S.message || S,
                durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - $t
            });
            return;
        }
        if (g !== void 0) {
            let E = g, m = W;
            if ((d === "select" || d === "rpc") && y) {
                const jt = !x && $33e982b025a1d2ac$var$Ft(P, y, W);
                if (jt) E = jt.data, m = jt.seq;
                else {
                    const Be = $33e982b025a1d2ac$var$nt(P, y, g, null, W, $33e982b025a1d2ac$var$Yt(P, y, W));
                    Be.gcTime = vt?.gcTime || 3e5;
                }
            }
            if (!st(m)) {
                ue();
                return;
            }
            let R = E;
            if (x && $33e982b025a1d2ac$var$Zt(t, g) && ((!a.__pages || !s.direction) && (a.__pages = []), s.direction === "previous" ? a.__pages.unshift(g) : a.__pages.push(g), R = $33e982b025a1d2ac$var$te(t, a.__pages, e), $33e982b025a1d2ac$var$Xt(a, t, g)), R = rt(R), !o()) return;
            ce(m), $33e982b025a1d2ac$var$z(e, $33e982b025a1d2ac$var$Lt), (!ct || R !== void 0) && $33e982b025a1d2ac$var$B(e, R, k), $33e982b025a1d2ac$var$it(e, t, !1), $33e982b025a1d2ac$var$I(e, "onFetchComplete", R), $33e982b025a1d2ac$var$U(t, e, "onFetchComplete", R), ue();
        }
    } catch (l) {
        if (!o()) return;
        st(W) && ut(l), Y && Y({
            phase: "error",
            mode: "query",
            from: p,
            method: d,
            cacheKey: y,
            error: l.message || String(l),
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - $t
        });
    } finally{
        y && P.active.get(y) === At && P.active.delete(y);
    }
}, $33e982b025a1d2ac$var$_r = (t, e, r)=>{
    const s = e.__ref;
    if (s) {
        s.__fetchListeners || (s.__fetchListeners = []);
        for (const n of $33e982b025a1d2ac$var$Fe(t))$33e982b025a1d2ac$var$yr(n, t, e, r);
    }
}, $33e982b025a1d2ac$var$yr = (t, e, r, s)=>{
    const n = r.__ref, a = e.__runner || $33e982b025a1d2ac$var$K;
    if (t === "submit") {
        const i = (o)=>{
            o.preventDefault(), a(e, r, s);
        }, c = r.node;
        c && (c.addEventListener("submit", i), n.__fetchListeners.push(()=>c.removeEventListener("submit", i)));
    } else if (t === "click") {
        const i = ()=>a(e, r, s), c = r.node;
        c && (c.addEventListener("click", i), n.__fetchListeners.push(()=>c.removeEventListener("click", i)));
    } else t === "stateChange" && $33e982b025a1d2ac$var$Sr(e, r, s, a);
}, $33e982b025a1d2ac$var$Sr = (t, e, r, s)=>{
    const n = e.__ref;
    let a;
    const i = (0, $4VQqJ.createEffect)(()=>{
        let c;
        try {
            c = JSON.stringify([
                $33e982b025a1d2ac$var$ot(t.params, e, r) ?? null,
                (0, $czfS0.isFunction)(t.enabled) ? !!t.enabled(e, e.state) : t.enabled !== !1,
                (0, $czfS0.isFunction)(t.skip) ? !!t.skip(e, e.state) : t.skip === !0,
                $33e982b025a1d2ac$var$G(t.page, e) ?? null
            ]);
        } catch  {
            return;
        }
        if (a === void 0) {
            a = c;
            return;
        }
        c !== a && (a = c, queueMicrotask(()=>s(t, e, r)));
    });
    Array.isArray(n.__effects) ? n.__effects.push(i) : n.__fetchListeners.push(()=>i.dispose());
}, $33e982b025a1d2ac$var$br = (t, e, r)=>{
    const s = e.__ref;
    s.__fetchCleanups || (s.__fetchCleanups = []), $33e982b025a1d2ac$var$ke();
    const n = t.refetchInterval;
    if (n) {
        const o = typeof n == "number" ? n : (0, $dFO0P.parseDuration)(n);
        if (o > 0) {
            const f = setInterval(()=>{
                (t.refetchIntervalInBackground || typeof document > "u" || document.visibilityState === "visible") && $33e982b025a1d2ac$var$K(t, e, r, {
                    force: !0
                });
            }, o);
            s.__fetchCleanups.push(()=>clearInterval(f));
        }
    }
    const a = $33e982b025a1d2ac$var$tt(t), i = t.refetchOnWindowFocus === void 0 ? !a : t.refetchOnWindowFocus !== !1, c = t.refetchOnReconnect === void 0 ? !a : t.refetchOnReconnect !== !1;
    if (i) {
        const o = ()=>{
            const f = $33e982b025a1d2ac$var$xt(t, e, r), p = $33e982b025a1d2ac$var$V($33e982b025a1d2ac$var$L(r), f), d = $33e982b025a1d2ac$var$Mt(t.cache);
            (!p || p.stale || Date.now() - p.time > (d?.staleTime || 0)) && $33e982b025a1d2ac$var$K(t, e, r, {
                refresh: !0
            });
        };
        $33e982b025a1d2ac$var$at.focus.add(o), s.__fetchCleanups.push(()=>$33e982b025a1d2ac$var$at.focus.delete(o));
    }
    if (c) {
        const o = ()=>$33e982b025a1d2ac$var$K(t, e, r, {
                refresh: !0
            });
        $33e982b025a1d2ac$var$at.online.add(o), s.__fetchCleanups.push(()=>$33e982b025a1d2ac$var$at.online.delete(o));
    }
}, $33e982b025a1d2ac$var$wr = (t, e, r)=>{
    const s = t.__ref;
    if (s.__fetchLangQueries = r, s.__fetchLangEffect) return;
    let n, a = !1;
    const i = (0, $4VQqJ.createEffect)(()=>{
        const c = $33e982b025a1d2ac$var$Z(t, e);
        if (!a) {
            a = !0, n = c;
            return;
        }
        if (c === n) return;
        const o = n;
        n = c, !(!o || !c) && queueMicrotask(()=>{
            for (const f of s.__fetchLangQueries || [])$33e982b025a1d2ac$var$K(f, t, e);
        });
    });
    s.__fetchLangEffect = i, Array.isArray(s.__effects) ? s.__effects.push(i) : (s.__fetchListeners || (s.__fetchListeners = []), s.__fetchListeners.push(()=>i.dispose()));
}, $33e982b025a1d2ac$var$gr = (t, e, r)=>{
    if (!e.optimistic) return null;
    const s = t.__ref, n = e.as, a = t.state?.parse ? t.state.parse() : (0, $czfS0.isObject)(t.state) ? {
        ...t.state
    } : t.state;
    s.__optimisticSnapshot = a;
    const i = (0, $czfS0.isFunction)(e.optimistic) ? e.optimistic(r, a, t) : e.optimistic;
    return i !== void 0 && $33e982b025a1d2ac$var$B(t, i, n), a;
}, $33e982b025a1d2ac$var$re = (t, e)=>{
    const r = t.__ref;
    if (!r || !e.optimistic) return;
    const s = r.__optimisticSnapshot;
    s !== void 0 && ($33e982b025a1d2ac$var$B(t, s, e.as), delete r.__optimisticSnapshot);
}, $33e982b025a1d2ac$var$St = (t)=>{
    if (!t) return ()=>!0;
    if ((0, $czfS0.isString)(t)) return (e)=>e.includes(t);
    if ((0, $czfS0.isArray)(t)) {
        const e = t.join(":");
        return (r)=>r.includes(e);
    }
    return t instanceof RegExp ? (e)=>(t.lastIndex = 0, t.test(e)) : (0, $czfS0.isFunction)(t) ? (e)=>{
        try {
            return !!t(e);
        } catch  {
            return !1;
        }
    } : ()=>!1;
}, $33e982b025a1d2ac$var$vr = (t, e)=>{
    const r = [];
    for (const s of t.mounted){
        if (!$33e982b025a1d2ac$var$ve(s)) {
            t.mounted.delete(s);
            continue;
        }
        const n = $33e982b025a1d2ac$var$Ze(s);
        n && e(n) && r.push($33e982b025a1d2ac$var$K(s.config, s.element, s.context, {
            refresh: !0
        }));
    }
    return Promise.allSettled(r).then(()=>{});
}, $33e982b025a1d2ac$var$It = (t, e)=>{
    (0, $avEQR.dropEarly)();
    for (const [r, s] of t.cache)e(r) && (s.stale = !0, $33e982b025a1d2ac$var$Ct(t, r));
    for (const [r] of t.active)!t.cache.has(r) && e(r) && $33e982b025a1d2ac$var$Ct(t, r);
    return $33e982b025a1d2ac$var$vr(t, e);
}, $33e982b025a1d2ac$var$Le = (t, e, r)=>{
    const s = ((0, $czfS0.isArray)(e) ? e : [
        e
    ]).map((n)=>n === !0 || n === "*" ? (a)=>a.startsWith(r + ":") : n ? $33e982b025a1d2ac$var$St(n) : ()=>!1);
    return $33e982b025a1d2ac$var$It(t, (n)=>s.some((a)=>a(n)));
}, $33e982b025a1d2ac$var$se = (t, e)=>{
    for (const [r] of t.cache)e(r) && $33e982b025a1d2ac$var$ge(t, r);
    for (const [r] of t.active)e(r) && $33e982b025a1d2ac$var$Ct(t, r);
}, $33e982b025a1d2ac$var$ne = ()=>!0, $33e982b025a1d2ac$var$Re = (t, e)=>$33e982b025a1d2ac$var$V(t, e)?.data ?? void 0, $33e982b025a1d2ac$var$qe = (t, e, r)=>{
    const s = $33e982b025a1d2ac$var$V(t, e), n = (0, $czfS0.isFunction)(r) ? r(s?.data) : r;
    $33e982b025a1d2ac$var$nt(t, e, n, null);
}, $33e982b025a1d2ac$var$Tr = async (t, e, r)=>{
    const s = r?.fetch;
    if (!s) return;
    const n = await $33e982b025a1d2ac$var$Ht(s, r, e, t);
    if (!n) return;
    const a = e.__ref, { method: i, from: c, fields: o, transform: f, as: p, auth: d, headers: A, baseUrl: u, responseType: _, invalidates: b, optimistic: Q, onMutate: w, onSuccess: v, onError: k, onSettled: D } = t;
    let T;
    if (o === !0 || $33e982b025a1d2ac$var$X(t, "submit")) T = $33e982b025a1d2ac$var$yt(e);
    else if ((0, $czfS0.isArray)(o)) {
        const F = $33e982b025a1d2ac$var$yt(e);
        T = {};
        for (const j of o)T[j] = F[j];
    } else e.state?.parse ? T = e.state.parse() : (0, $czfS0.isObject)(e.state) && (T = {
        ...e.state
    });
    f && (T = f(T, e, e.state)), (0, $czfS0.isFunction)(w) && w(T, e, e.state);
    const bt = Q ? $33e982b025a1d2ac$var$gr(e, t, T) : null;
    $33e982b025a1d2ac$var$z(e, {
        isFetching: !0,
        isLoading: !1,
        isStale: !1,
        isSuccess: !1,
        error: null,
        status: "pending",
        fetchStatus: "fetching"
    }), $33e982b025a1d2ac$var$I(e, "onFetchStart"), $33e982b025a1d2ac$var$U(t, e, "onFetchStart");
    const $ = r?.analyze?.emitNetwork, wt = $ ? typeof performance < "u" ? performance.now() : Date.now() : 0;
    $ && $({
        phase: "start",
        mode: "mutation",
        from: c,
        method: i
    });
    try {
        if (d !== !1 && n.auth !== !1 && n.getSession) {
            const ct = await n.getSession();
            if (d === !0 && !ct) {
                bt !== void 0 && $33e982b025a1d2ac$var$re(e, t);
                const rt = {
                    message: "Not authenticated"
                };
                $33e982b025a1d2ac$var$I(e, "onFetchError", rt), $33e982b025a1d2ac$var$U(t, e, "onFetchError", rt);
                return;
            }
        }
        const F = n[i];
        if (!(0, $czfS0.isFunction)(F)) return;
        const j = {
            from: c,
            data: T,
            headers: A,
            baseUrl: u
        };
        _ !== void 0 && (j.responseType = _), t.params && (j.params = $33e982b025a1d2ac$var$ot(t.params, e, r));
        const gt = $33e982b025a1d2ac$var$Z(e, r);
        gt && (j.headers = {
            ...j.headers,
            "Accept-Language": gt
        });
        const x = $33e982b025a1d2ac$var$Ee(t, !0), et = await $33e982b025a1d2ac$var$me(()=>F(j), x), { data: C, error: M } = et || {};
        if (M) {
            bt !== void 0 && $33e982b025a1d2ac$var$re(e, t), $33e982b025a1d2ac$var$z(e, $33e982b025a1d2ac$var$Rt(M)), $33e982b025a1d2ac$var$I(e, "onFetchError", M), $33e982b025a1d2ac$var$U(t, e, "onFetchError", M), (0, $czfS0.isFunction)(k) && k(M, T, e), (0, $czfS0.isFunction)(D) && D(null, M, T, e), $ && $({
                phase: "error",
                mode: "mutation",
                from: c,
                method: i,
                error: M.message || String(M),
                durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - wt
            });
            return;
        }
        if (delete a.__optimisticSnapshot, $33e982b025a1d2ac$var$z(e, $33e982b025a1d2ac$var$Lt), C !== void 0 && (p || !$33e982b025a1d2ac$var$Vt(C))) {
            const ct = p ? {
                [p]: C
            } : C;
            e.state?.update && e.state.update(ct, {
                preventFetch: !0
            });
        }
        $33e982b025a1d2ac$var$I(e, "onFetchComplete", C), $33e982b025a1d2ac$var$U(t, e, "onFetchComplete", C), (0, $czfS0.isFunction)(v) && v(C, T, e), (0, $czfS0.isFunction)(D) && D(C, null, T, e), $ && $({
            phase: "success",
            mode: "mutation",
            ok: !0,
            from: c,
            method: i,
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - wt
        }), b && $33e982b025a1d2ac$var$Le($33e982b025a1d2ac$var$L(r), b, c);
    } catch (F) {
        bt !== void 0 && $33e982b025a1d2ac$var$re(e, t), $33e982b025a1d2ac$var$z(e, $33e982b025a1d2ac$var$Rt(F)), $33e982b025a1d2ac$var$I(e, "onFetchError", F), $33e982b025a1d2ac$var$U(t, e, "onFetchError", F), (0, $czfS0.isFunction)(k) && k(F, T, e), (0, $czfS0.isFunction)(D) && D(null, F, T, e), $ && $({
            phase: "error",
            mode: "mutation",
            from: c,
            method: i,
            error: F.message || String(F),
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - wt
        });
    } finally{
        a.__fetching = !1;
    }
}, $33e982b025a1d2ac$var$Ar = (t)=>{
    const e = (r)=>{
        try {
            r();
        } catch  {}
    };
    for (const r of t.__fetchCleanups || [])e(r);
    for (const r of t.__fetchListeners || [])e(r);
    (0, $czfS0.isFunction)(t.__unsubscribe) && e(t.__unsubscribe);
    for (const r of t.__fetchMounted || [])$33e982b025a1d2ac$var$L(r.context).mounted.delete(r);
    t.__fetchCleanups = [], t.__fetchListeners = [], t.__unsubscribe = null, t.__fetchMounted = [];
}, $33e982b025a1d2ac$var$Ne = (t, e)=>{
    if (!t) return null;
    if ((0, $czfS0.isFunction)(t.select)) return t;
    if (t.__resolved) return t.__resolved;
    if (t.__resolving) return null;
    const r = typeof t.adapter == "string" ? t.adapter : null;
    if (r !== "rest" || $33e982b025a1d2ac$var$H[r] || !t.url) return null;
    const { adapter: s, ...n } = t, a = $9MmMs.restAdapter(n.url, n.headers, n.auth, n.fetchOptions, n.early, n.reads, n.seed);
    return a.auth = t.auth, a.url = t.url, a.key = t.key, t.__resolved = a, e.fetch = a, a;
}, $33e982b025a1d2ac$var$Er = (t)=>$33e982b025a1d2ac$var$X(t, "create") && (t.method === "select" || t.method === "rpc") && !$33e982b025a1d2ac$var$pt(t) && !t.infinite && !$33e982b025a1d2ac$var$tt(t), $33e982b025a1d2ac$export$adce894ae82cc8eb = (t)=>{
    const e = t && t.context;
    if (!e || !e.fetch || $33e982b025a1d2ac$var$dt(e)) return;
    const r = t.__ref;
    if (!r || !t.fetch || !((0, $bceDf.seedWaiting)() || (0, $avEQR.hasBuiltRuns)())) return;
    let s;
    try {
        s = (0, $2C0hZ.exec)(t.fetch, t);
    } catch  {
        return;
    }
    if (!s) return;
    const n = (0, $czfS0.isArray)(s) ? s : [
        s
    ], a = $33e982b025a1d2ac$var$Ne(e.fetch, e), i = a && (0, $czfS0.isFunction)(a.seeded) ? (0, $avEQR.builtRuns)((0, $5zSXA.elementPath)(t)) : null;
    for(let c = 0; c < n.length; c++){
        let o;
        try {
            o = $33e982b025a1d2ac$var$Pe((0, $2C0hZ.exec)(n[c], t), t);
        } catch  {
            continue;
        }
        if (!o) continue;
        const f = !!i && i.includes(c);
        if (f) {
            if (!$33e982b025a1d2ac$var$Se(o)) continue;
        } else {
            if (!$33e982b025a1d2ac$var$Er(o) || o.enabled === !1 || o.skip === !0) continue;
            try {
                if ((0, $czfS0.isFunction)(o.enabled) && !o.enabled(t, t.state) || (0, $czfS0.isFunction)(o.skip) && o.skip(t, t.state)) continue;
            } catch  {
                continue;
            }
        }
        const p = $33e982b025a1d2ac$var$Mt(o.cache);
        if (!p) continue;
        const d = $33e982b025a1d2ac$var$Ne(e.fetch, e);
        if (!d || !(0, $czfS0.isFunction)(d.seeded)) return;
        $33e982b025a1d2ac$var$Dr(o, p, d, t, e, r, f);
    }
}, $33e982b025a1d2ac$var$Dr = (t, e, r, s, n, a, i)=>{
    let c = (0, $czfS0.isString)(t.select) ? t.select : void 0, o, f, p, d, A;
    try {
        if (t.query && (0, $czfS0.isFunction)(s.getQuery)) {
            const v = s.getQuery(r.name || "paths");
            v && (c = v.select || v.length && v.join(",") || c);
        }
        o = $33e982b025a1d2ac$var$ot(t.params, s, n), f = $33e982b025a1d2ac$var$G(t.page, s), p = $33e982b025a1d2ac$var$G(t.cursor, s);
        const w = $33e982b025a1d2ac$var$Z(s, n);
        d = $33e982b025a1d2ac$var$Pt(t, o, $33e982b025a1d2ac$var$_t(s, n), w, f, p), A = $33e982b025a1d2ac$var$ee(t, c, o, w, f, p);
    } catch  {
        return;
    }
    const u = $33e982b025a1d2ac$var$L(n), _ = $33e982b025a1d2ac$var$V(u, d);
    let b, Q = !1;
    if (_ && !_.error) {
        if (!i || _.stale || Date.now() - _.time > (e.staleTime || 0)) return;
        b = _.data;
    } else {
        t.method === "rpc" && (A.read = t.read !== !1);
        const w = r.seeded({
            method: t.method,
            ...A
        });
        if (!w || w.error || w.data === void 0) return;
        const v = $33e982b025a1d2ac$var$nt(u, d, w.data, null);
        v.gcTime = e.gcTime || 3e5, w.partial && (v.stale = !0, v.partial = !0, Q = !0), (0, $avEQR.claimSeeded)(w, d), b = w.data;
    }
    a.__fetchInitialized = !0, Q && $33e982b025a1d2ac$var$z(s, $33e982b025a1d2ac$var$cr);
    try {
        (0, $czfS0.isFunction)(t.select) && (b = t.select(b, s, s.state)), t.transform && (b = t.transform(b, s, s.state));
    } catch  {
        return;
    }
    if (Q) {
        $33e982b025a1d2ac$var$B(s, b, t.as), $33e982b025a1d2ac$var$it(s, t, !0);
        return;
    }
    $33e982b025a1d2ac$var$z(s, $33e982b025a1d2ac$var$Lt), $33e982b025a1d2ac$var$B(s, b, t.as), (a.__seededOnCreate || (a.__seededOnCreate = new Set)).add(d);
}, $33e982b025a1d2ac$export$8ced815accfd9df6 = (t, e, r, s)=>{
    if (!t || !s?.fetch) return;
    const a = (0, $2C0hZ.exec)(t, e);
    if (!a) return;
    const i = [], c = (0, $czfS0.isArray)(a) ? a : [
        a
    ];
    for(let u = 0; u < c.length; u++){
        const _ = $33e982b025a1d2ac$var$Pe((0, $czfS0.isArray)(a) ? (0, $2C0hZ.exec)(c[u], e) : c[u], e);
        _ && (_.__slot = u, i.push(_));
    }
    const o = e.__ref, f = $33e982b025a1d2ac$var$L(s);
    if (o.__fetchMounted) for (const u of o.__fetchMounted)f.mounted.delete(u);
    o.__fetchMounted = [], !o.__fetchDisposer && (0, $czfS0.isArray)(o.__effects) && (o.__fetchDisposer = {
        dispose: ()=>$33e982b025a1d2ac$var$Ar(o)
    }, o.__effects.push(o.__fetchDisposer));
    const p = !$33e982b025a1d2ac$var$dt(s);
    p && $33e982b025a1d2ac$var$ke();
    const d = [];
    for (const u of i){
        const _ = $33e982b025a1d2ac$var$Ce(u.method), b = _ ? $33e982b025a1d2ac$var$Tr : $33e982b025a1d2ac$var$K, Q = !_ && !$33e982b025a1d2ac$var$pt(u) && u.method !== "subscribe", w = $33e982b025a1d2ac$var$X(u, "create");
        if (w && b(u, e, s), (!w || $33e982b025a1d2ac$var$Fe(u).length > 1) && queueMicrotask(()=>$33e982b025a1d2ac$var$_r({
                ...u,
                __runner: b
            }, e, s)), Q && w && (p && (u.refetchInterval || u.refetchOnWindowFocus !== !1 || u.refetchOnReconnect !== !1) && $33e982b025a1d2ac$var$br(u, e, s), p && !$33e982b025a1d2ac$var$tt(u) && d.push(u), !$33e982b025a1d2ac$var$tt(u))) {
            const v = {
                element: e,
                ref: o,
                config: u,
                context: s
            };
            f.mounted.add(v), o.__fetchMounted.push(v);
        }
    }
    (d.length || o.__fetchLangEffect) && $33e982b025a1d2ac$var$wr(e, s, d), o.refetch = (u)=>{
        for (const _ of i)$33e982b025a1d2ac$var$K(_, e, s, {
            force: !0,
            ...u
        });
    };
    const A = i.find((u)=>u.infinite);
    o.fetchNextPage = ()=>{
        const u = A;
        if (!u) return;
        const _ = o.__nextPageParam;
        if (_ == null) return;
        const b = {
            ...u,
            cursor: _
        };
        $33e982b025a1d2ac$var$K(b, e, s, {
            direction: "next",
            force: !0
        });
    }, o.fetchPreviousPage = ()=>{
        const u = A;
        if (!u) return;
        const _ = o.__prevPageParam;
        if (_ == null) return;
        const b = {
            ...u,
            cursor: _
        };
        $33e982b025a1d2ac$var$K(b, e, s, {
            direction: "previous",
            force: !0
        });
    };
}, $33e982b025a1d2ac$var$Ue = async (t, e, r, s)=>{
    const n = s?.fetch;
    if (!n || !e) return;
    const a = {
        method: "select",
        ...e
    }, { method: i } = a, c = $33e982b025a1d2ac$var$pt(a), o = $33e982b025a1d2ac$var$tt(a) || c ? null : $33e982b025a1d2ac$var$Mt(a.cache), f = r ? $33e982b025a1d2ac$var$ot(a.params, r, s) : a.params, p = r ? $33e982b025a1d2ac$var$G(a.page, r) : a.page, d = r ? $33e982b025a1d2ac$var$G(a.cursor, r) : a.cursor, A = $33e982b025a1d2ac$var$Z(r, s), u = o ? $33e982b025a1d2ac$var$Pt(a, f, $33e982b025a1d2ac$var$_t(r, s), A, p, d) : null;
    if (u) {
        const D = $33e982b025a1d2ac$var$V(t, u);
        if (D && !D.error && !D.stale && Date.now() - D.time <= (o.staleTime || 0)) return {
            data: D.data,
            error: null
        };
        const T = t.active.get(u);
        if (T && $33e982b025a1d2ac$var$Wt(t, u, T)) return T;
    }
    const _ = await $33e982b025a1d2ac$var$Ht(n, s, r, e);
    if (!_) return;
    const b = _[i];
    if (!(0, $czfS0.isFunction)(b)) return;
    const Q = $33e982b025a1d2ac$var$ee(a, (0, $czfS0.isString)(a.select) ? a.select : void 0, f, A, p, d);
    i === "rpc" && (Q.read = !c && a.read !== !1);
    const w = u ? t.active.get(u) : null;
    if (w && $33e982b025a1d2ac$var$Wt(t, u, w)) return w;
    const v = ++$33e982b025a1d2ac$var$ht, k = (async ()=>{
        const D = await b(Q);
        if (u && D?.data !== void 0 && !D?.error && !$33e982b025a1d2ac$var$Ft(t, u, v)) {
            const T = $33e982b025a1d2ac$var$nt(t, u, D.data, null, v, $33e982b025a1d2ac$var$Yt(t, u, v));
            T.gcTime = o.gcTime || 3e5;
        }
        return D;
    })();
    $33e982b025a1d2ac$var$kt.set(k, v), u && t.active.set(u, k);
    try {
        return await k;
    } finally{
        u && t.active.get(u) === k && t.active.delete(u);
    }
}, $33e982b025a1d2ac$export$7c07b633a151f9c5 = {
    invalidateQueries: (t)=>$33e982b025a1d2ac$var$It($33e982b025a1d2ac$var$N, $33e982b025a1d2ac$var$St(t)),
    removeQueries: (t)=>{
        $33e982b025a1d2ac$var$se($33e982b025a1d2ac$var$N, t ? $33e982b025a1d2ac$var$St(t) : $33e982b025a1d2ac$var$ne);
    },
    getQueryData: (t)=>$33e982b025a1d2ac$var$Re($33e982b025a1d2ac$var$N, t),
    setQueryData: (t, e)=>{
        $33e982b025a1d2ac$var$qe($33e982b025a1d2ac$var$N, t, e);
    },
    prefetchQuery: (t, e)=>$33e982b025a1d2ac$var$Ue($33e982b025a1d2ac$var$L(e), t, null, e),
    getCache: ()=>$33e982b025a1d2ac$var$N.cache,
    clear: ()=>$33e982b025a1d2ac$var$se($33e982b025a1d2ac$var$N, $33e982b025a1d2ac$var$ne),
    dropNonLang: (t)=>{
        if (!t) return;
        const e = `:${t}`;
        for (const [r] of $33e982b025a1d2ac$var$N.cache)r.match(/:([a-z]{2,3})$/i) && (r.endsWith(e) || $33e982b025a1d2ac$var$ge($33e982b025a1d2ac$var$N, r));
    }
}, $33e982b025a1d2ac$var$Qe = (t, e)=>(0, $czfS0.isObject)(t) ? $33e982b025a1d2ac$var$xt({
        method: "select",
        ...t
    }, e, e?.context) : t, $33e982b025a1d2ac$export$469c76e42c7829b7 = {
    invalidateQueries (t) {
        return $33e982b025a1d2ac$var$It($33e982b025a1d2ac$var$L(this?.context), $33e982b025a1d2ac$var$St(t));
    },
    removeQueries (t) {
        $33e982b025a1d2ac$var$se($33e982b025a1d2ac$var$L(this?.context), t ? $33e982b025a1d2ac$var$St(t) : $33e982b025a1d2ac$var$ne);
    },
    getQueryData (t) {
        return $33e982b025a1d2ac$var$Re($33e982b025a1d2ac$var$L(this?.context), $33e982b025a1d2ac$var$Qe(t, this));
    },
    setQueryData (t, e) {
        $33e982b025a1d2ac$var$qe($33e982b025a1d2ac$var$L(this?.context), $33e982b025a1d2ac$var$Qe(t, this), e);
    },
    prefetchQuery (t) {
        return $33e982b025a1d2ac$var$Ue($33e982b025a1d2ac$var$L(this?.context), t, this, this?.context);
    }
}, $33e982b025a1d2ac$export$d0243251426106e4 = async (t)=>{
    const e = await (0, $avEQR.takeStaleSeed)();
    if (!e) return null;
    const { taken: r, config: s } = e, n = new Set, a = [];
    for (const o of r)o.cacheKey ? n.add(o.cacheKey) : a.push(o);
    (0, $avEQR.dropEarly)();
    const i = [], c = async (o)=>{
        try {
            const f = await o.again.send();
            if (!f || f.error) return;
            const p = o.result ? o.result.data : void 0;
            if ($33e982b025a1d2ac$var$kr(f.data, p)) return;
            const { method: d, from: A, params: u } = o.again;
            i.push({
                method: d,
                from: A,
                params: u,
                data: f.data,
                previous: p
            });
        } catch  {}
    };
    if (await Promise.all([
        n.size ? $33e982b025a1d2ac$var$It($33e982b025a1d2ac$var$N, (o)=>n.has(o)) : null,
        ...a.map(c)
    ]), i.length && (0, $czfS0.isFunction)(s.onRefresh)) try {
        s.onRefresh(i, t);
    } catch (o) {
        console.error("[@symbo.ls/fetch] seed.onRefresh failed:", o);
    }
    return {
        queries: n.size,
        reads: a.length,
        changed: i.length
    };
}, $33e982b025a1d2ac$var$kr = (t, e)=>{
    if (t === e) return !0;
    try {
        return JSON.stringify(t) === JSON.stringify(e);
    } catch  {
        return !1;
    }
}, $33e982b025a1d2ac$export$3e7aa3050ca4b6c = {
    name: "fetch",
    init (t) {
        t.fetch && $33e982b025a1d2ac$export$adce894ae82cc8eb(t);
    },
    create (t) {
        const e = t.fetch;
        e && (t.parent || $33e982b025a1d2ac$var$L(t.context).active.clear(), $33e982b025a1d2ac$export$8ced815accfd9df6(e, t, t.state, t.context));
    }
};
var $33e982b025a1d2ac$export$2e2bcd8739ae039 = $33e982b025a1d2ac$export$8ced815accfd9df6;

});
parcelRegister("kfWEd", function(module, exports) {
$parcel$export(module.exports, "batch", () => (parcelRequire("4VQqJ")).batch);
$parcel$export(module.exports, "countUntrackedReads", () => (parcelRequire("4VQqJ")).countUntrackedReads);
$parcel$export(module.exports, "createEffect", () => (parcelRequire("4VQqJ")).createEffect);
$parcel$export(module.exports, "createScopeStore", () => (parcelRequire("4VQqJ")).createScopeStore);
$parcel$export(module.exports, "createSignal", () => (parcelRequire("4VQqJ")).createSignal);
$parcel$export(module.exports, "createStore", () => (parcelRequire("4VQqJ")).createStore);
$parcel$export(module.exports, "getObserver", () => (parcelRequire("4VQqJ")).getObserver);
$parcel$export(module.exports, "getSignals", () => (parcelRequire("4VQqJ")).getSignals);
$parcel$export(module.exports, "isStore", () => (parcelRequire("4VQqJ")).isStore);
$parcel$export(module.exports, "setObserver", () => (parcelRequire("4VQqJ")).setObserver);
$parcel$export(module.exports, "settled", () => (parcelRequire("4VQqJ")).settled);
$parcel$export(module.exports, "untrack", () => (parcelRequire("4VQqJ")).untrack);
$parcel$export(module.exports, "warnStateKeyShadowsMethod", () => (parcelRequire("4VQqJ")).warnStateKeyShadowsMethod);
parcelRequire("4VQqJ");

});
parcelRegister("4VQqJ", function(module, exports) {

$parcel$export(module.exports, "createSignal", () => $397527d33fcb15aa$export$c1e1e1ecbbe76a5);
$parcel$export(module.exports, "createEffect", () => $397527d33fcb15aa$export$7ea7134f704deda4);
$parcel$export(module.exports, "batch", () => $397527d33fcb15aa$export$712ea50be43a7858);
$parcel$export(module.exports, "getObserver", () => $397527d33fcb15aa$export$619cdeadfd90f3e4);
$parcel$export(module.exports, "setObserver", () => $397527d33fcb15aa$export$e1c3d8e1a0880d23);
$parcel$export(module.exports, "untrack", () => $397527d33fcb15aa$export$363ebc4b78b8f807);
$parcel$export(module.exports, "settled", () => $397527d33fcb15aa$export$3910381886d0de18);
$parcel$export(module.exports, "countUntrackedReads", () => $397527d33fcb15aa$export$cea3cecebd45420e);
$parcel$export(module.exports, "createStore", () => $397527d33fcb15aa$export$f51a9068ac82ea43);
$parcel$export(module.exports, "createScopeStore", () => $397527d33fcb15aa$export$dfd36abd169cef99);
$parcel$export(module.exports, "isStore", () => $397527d33fcb15aa$export$9abf972af34a1547);
$parcel$export(module.exports, "getSignals", () => $397527d33fcb15aa$export$c50078d4faa171f0);
$parcel$export(module.exports, "warnStateKeyShadowsMethod", () => $397527d33fcb15aa$export$f338bed42a74a3fe);

var $2ehCU = parcelRequire("2ehCU");

var $5a83z = parcelRequire("5a83z");

var $58lC3 = parcelRequire("58lC3");

var $4dThk = parcelRequire("4dThk");

var $5F9Db = parcelRequire("5F9Db");
const $397527d33fcb15aa$var$e = (0, $58lC3.resolveSignalEngine)({
    ...$2ehCU,
    ...$5a83z,
    VERSION: (0, $4dThk.VERSION)
}, (0, $4dThk.VERSION)), $397527d33fcb15aa$export$c1e1e1ecbbe76a5 = $397527d33fcb15aa$var$e.createSignal, $397527d33fcb15aa$export$234a23cdc77e6a3d = $397527d33fcb15aa$var$e.createComputed, $397527d33fcb15aa$export$7ea7134f704deda4 = $397527d33fcb15aa$var$e.createEffect, $397527d33fcb15aa$export$712ea50be43a7858 = $397527d33fcb15aa$var$e.batch, $397527d33fcb15aa$export$619cdeadfd90f3e4 = $397527d33fcb15aa$var$e.getObserver, $397527d33fcb15aa$export$e1c3d8e1a0880d23 = $397527d33fcb15aa$var$e.setObserver, $397527d33fcb15aa$export$363ebc4b78b8f807 = $397527d33fcb15aa$var$e.untrack || ((t)=>{
    const r = $397527d33fcb15aa$var$e.getObserver();
    if (!r) return t();
    $397527d33fcb15aa$var$e.setObserver(null);
    try {
        return t();
    } finally{
        $397527d33fcb15aa$var$e.setObserver(r);
    }
}), $397527d33fcb15aa$export$3910381886d0de18 = $397527d33fcb15aa$var$e.settled || (()=>Promise.resolve()), $397527d33fcb15aa$export$cea3cecebd45420e = $397527d33fcb15aa$var$e.countUntrackedReads || ((t)=>(t(), 0)), $397527d33fcb15aa$export$f51a9068ac82ea43 = $397527d33fcb15aa$var$e.createStore, $397527d33fcb15aa$export$dfd36abd169cef99 = $397527d33fcb15aa$var$e.createScopeStore, $397527d33fcb15aa$export$9abf972af34a1547 = $397527d33fcb15aa$var$e.isStore, $397527d33fcb15aa$export$c50078d4faa171f0 = $397527d33fcb15aa$var$e.getSignals, $397527d33fcb15aa$export$e57bed44fbdb06f = $397527d33fcb15aa$var$e.STORE_METHOD_NAMES, $397527d33fcb15aa$export$ae3485d217363a19 = $397527d33fcb15aa$var$e.RESERVED_STORE_METHODS, $397527d33fcb15aa$export$f338bed42a74a3fe = $397527d33fcb15aa$var$e.warnStateKeyShadowsMethod, $397527d33fcb15aa$export$f62a3f54d4c65d24 = $397527d33fcb15aa$var$e.__resetStateShadowWarnings, $397527d33fcb15aa$export$a4ad2735b021c132 = $397527d33fcb15aa$var$e.VERSION;

});
parcelRegister("2ehCU", function(module, exports) {

$parcel$export(module.exports, "getObserver", () => $19fa8fddf151ac3f$export$619cdeadfd90f3e4);
$parcel$export(module.exports, "setObserver", () => $19fa8fddf151ac3f$export$e1c3d8e1a0880d23);
$parcel$export(module.exports, "untrack", () => $19fa8fddf151ac3f$export$363ebc4b78b8f807);
$parcel$export(module.exports, "noteUntrackedRead", () => $19fa8fddf151ac3f$export$25d88d4d01a8ea47);
$parcel$export(module.exports, "countUntrackedReads", () => $19fa8fddf151ac3f$export$cea3cecebd45420e);
$parcel$export(module.exports, "createSignal", () => $19fa8fddf151ac3f$export$c1e1e1ecbbe76a5);
$parcel$export(module.exports, "createComputed", () => $19fa8fddf151ac3f$export$234a23cdc77e6a3d);
$parcel$export(module.exports, "WRITE_JOURNAL", () => $19fa8fddf151ac3f$export$1dbbdf76843bcfa3);
$parcel$export(module.exports, "journalWrite", () => $19fa8fddf151ac3f$export$962fe61a1a012886);
$parcel$export(module.exports, "createEffect", () => $19fa8fddf151ac3f$export$7ea7134f704deda4);
$parcel$export(module.exports, "batch", () => $19fa8fddf151ac3f$export$712ea50be43a7858);
$parcel$export(module.exports, "settled", () => $19fa8fddf151ac3f$export$3910381886d0de18);
let $19fa8fddf151ac3f$var$s = null, $19fa8fddf151ac3f$var$d = 0;
const $19fa8fddf151ac3f$var$_ = [], $19fa8fddf151ac3f$export$619cdeadfd90f3e4 = ()=>$19fa8fddf151ac3f$var$s, $19fa8fddf151ac3f$export$e1c3d8e1a0880d23 = (e)=>{
    $19fa8fddf151ac3f$var$s = e;
};
function $19fa8fddf151ac3f$export$363ebc4b78b8f807(e) {
    const t = $19fa8fddf151ac3f$var$s;
    if (!t) return e();
    $19fa8fddf151ac3f$var$s = null;
    try {
        return e();
    } finally{
        $19fa8fddf151ac3f$var$s = t;
    }
}
let $19fa8fddf151ac3f$var$E = 0, $19fa8fddf151ac3f$var$h = 0;
function $19fa8fddf151ac3f$export$25d88d4d01a8ea47() {
    $19fa8fddf151ac3f$var$E !== 0 && $19fa8fddf151ac3f$var$h++;
}
function $19fa8fddf151ac3f$export$cea3cecebd45420e(e) {
    const t = $19fa8fddf151ac3f$var$h;
    $19fa8fddf151ac3f$var$E++;
    let n;
    try {
        e();
    } finally{
        n = $19fa8fddf151ac3f$var$h - t, --$19fa8fddf151ac3f$var$E === 0 && ($19fa8fddf151ac3f$var$h = 0);
    }
    return n;
}
let $19fa8fddf151ac3f$var$y = 0;
const $19fa8fddf151ac3f$var$x = [];
function $19fa8fddf151ac3f$export$c1e1e1ecbbe76a5(e) {
    const t = new Set;
    function n() {
        return $19fa8fddf151ac3f$var$s && (t.add($19fa8fddf151ac3f$var$s), $19fa8fddf151ac3f$var$s._sources.add(u)), e;
    }
    function r(l) {
        l !== e && (e = l, $19fa8fddf151ac3f$var$N(t));
    }
    function o() {
        return e;
    }
    const u = {
        get: n,
        set: r,
        peek: o,
        _subscribers: t,
        _type: "signal"
    };
    return u;
}
function $19fa8fddf151ac3f$export$234a23cdc77e6a3d(e) {
    let t, n = !0;
    const r = new Set, o = {
        _sources: new Set,
        _type: "computed",
        _subscribers: r,
        _execute () {
            $19fa8fddf151ac3f$var$T(o);
            const u = $19fa8fddf151ac3f$var$s;
            $19fa8fddf151ac3f$var$s = o;
            try {
                t = e(), n = !1;
            } finally{
                $19fa8fddf151ac3f$var$s = u;
            }
        },
        _notify () {
            n = !0, r.size > 0 && $19fa8fddf151ac3f$var$R(r);
        },
        get () {
            return $19fa8fddf151ac3f$var$s && (r.add($19fa8fddf151ac3f$var$s), $19fa8fddf151ac3f$var$s._sources.add(o)), n && o._execute(), t;
        },
        peek () {
            return n && o._execute(), t;
        }
    };
    return o._execute(), o;
}
let $19fa8fddf151ac3f$var$c = new Set, $19fa8fddf151ac3f$var$b = !1;
const $19fa8fddf151ac3f$export$1dbbdf76843bcfa3 = [];
function $19fa8fddf151ac3f$export$962fe61a1a012886(e) {
    $19fa8fddf151ac3f$export$1dbbdf76843bcfa3.push(e), $19fa8fddf151ac3f$export$1dbbdf76843bcfa3.length > 32 && $19fa8fddf151ac3f$export$1dbbdf76843bcfa3.shift();
}
function $19fa8fddf151ac3f$export$7ea7134f704deda4(e, t) {
    const n = t?.depth ?? 0, r = {
        _sources: new Set,
        _type: "effect",
        _depth: n,
        _label: t?.label,
        _disposed: !1,
        _subscribers: new Set,
        _execute () {
            if (r._disposed) return;
            $19fa8fddf151ac3f$var$T(r);
            const o = $19fa8fddf151ac3f$var$s;
            $19fa8fddf151ac3f$var$s = r;
            try {
                e();
            } catch (u) {
                console.error("[smbls] effect error:", u);
            } finally{
                $19fa8fddf151ac3f$var$s = o;
            }
        },
        _notify () {
            r._disposed || ($19fa8fddf151ac3f$var$d > 0 ? $19fa8fddf151ac3f$var$_.push(r) : $19fa8fddf151ac3f$var$y > 0 ? $19fa8fddf151ac3f$var$x.push(r) : $19fa8fddf151ac3f$var$m(r));
        },
        dispose () {
            r._disposed = !0, $19fa8fddf151ac3f$var$T(r);
        }
    };
    return r._execute(), r;
}
function $19fa8fddf151ac3f$export$712ea50be43a7858(e) {
    $19fa8fddf151ac3f$var$d++;
    try {
        e();
    } finally{
        $19fa8fddf151ac3f$var$d--, $19fa8fddf151ac3f$var$d === 0 && $19fa8fddf151ac3f$var$F();
    }
}
let $19fa8fddf151ac3f$var$g = !1;
const $19fa8fddf151ac3f$var$k = 1e3, $19fa8fddf151ac3f$var$M = 8, $19fa8fddf151ac3f$var$C = 256, $19fa8fddf151ac3f$var$I = 4;
function $19fa8fddf151ac3f$var$D() {
    return typeof performance < "u" ? performance.now() : Date.now();
}
function $19fa8fddf151ac3f$var$m(e) {
    $19fa8fddf151ac3f$var$c.add(e), !$19fa8fddf151ac3f$var$g && ($19fa8fddf151ac3f$var$b || ($19fa8fddf151ac3f$var$b = !0, queueMicrotask($19fa8fddf151ac3f$var$A)));
}
const $19fa8fddf151ac3f$var$a = [];
function $19fa8fddf151ac3f$var$P() {
    if ($19fa8fddf151ac3f$var$c.size === 1) {
        const [t] = $19fa8fddf151ac3f$var$c;
        return $19fa8fddf151ac3f$var$c.clear(), t._disposed ? 0 : (t._execute(), 1);
    }
    $19fa8fddf151ac3f$var$a.length = 0;
    for (const t of $19fa8fddf151ac3f$var$c)$19fa8fddf151ac3f$var$a.push(t);
    $19fa8fddf151ac3f$var$c.clear(), $19fa8fddf151ac3f$var$a.sort((t, n)=>t._depth - n._depth);
    let e = 0;
    for(let t = 0; t < $19fa8fddf151ac3f$var$a.length; t++){
        const n = $19fa8fddf151ac3f$var$a[t];
        n._disposed || (n._execute(), e++);
    }
    return $19fa8fddf151ac3f$var$a.length = 0, e;
}
function $19fa8fddf151ac3f$var$A(e = 0, t = 0) {
    if ($19fa8fddf151ac3f$var$b = !1, $19fa8fddf151ac3f$var$c.size === 0) {
        $19fa8fddf151ac3f$var$p.length && $19fa8fddf151ac3f$var$w();
        return;
    }
    $19fa8fddf151ac3f$var$g = !0;
    const n = $19fa8fddf151ac3f$var$D();
    let r = !1;
    try {
        for(; $19fa8fddf151ac3f$var$c.size > 0;){
            if (++e > $19fa8fddf151ac3f$var$k) {
                const o = new Map;
                for (const f of $19fa8fddf151ac3f$var$c){
                    let i = f._label;
                    if (typeof i == "function") try {
                        i = i();
                    } catch  {
                        i = "<label error>";
                    }
                    if (i = i || "<unlabeled>", o.set(i, (o.get(i) || 0) + 1), o.size >= 12) break;
                }
                const u = [
                    ...o.entries()
                ].map(([f, i])=>i > 1 ? `${f} \xD7${i}` : f).join(", "), l = new Map;
                for (const f of $19fa8fddf151ac3f$export$1dbbdf76843bcfa3)l.set(f, (l.get(f) || 0) + 1);
                const U = [
                    ...l.entries()
                ].map(([f, i])=>i > 1 ? `${f} \xD7${i}` : f).join(", ");
                console.error("[smbls] reactive effect cascade exceeded", $19fa8fddf151ac3f$var$k, "passes in a single flush \u2014 breaking to avoid hanging the thread.", "This usually means an effect (or an onUpdate/subscribeTo handler", "it calls into) unconditionally writes back a signal it depends on.", "Still queued at break (the loop participants):", u || "<queue empty>", "\u2014 last notifying store writes:", U || "<none recorded>"), $19fa8fddf151ac3f$var$c.clear();
                break;
            }
            if (t += $19fa8fddf151ac3f$var$P(), $19fa8fddf151ac3f$var$c.size > 0 && (t >= $19fa8fddf151ac3f$var$C || e >= $19fa8fddf151ac3f$var$I) && $19fa8fddf151ac3f$var$D() - n > $19fa8fddf151ac3f$var$M) {
                r = !0, setTimeout(()=>$19fa8fddf151ac3f$var$A(e, t), 0);
                break;
            }
        }
    } finally{
        r || ($19fa8fddf151ac3f$var$g = !1, $19fa8fddf151ac3f$var$p.length && $19fa8fddf151ac3f$var$w());
    }
}
const $19fa8fddf151ac3f$var$p = [];
function $19fa8fddf151ac3f$var$z() {
    return $19fa8fddf151ac3f$var$c.size === 0 && !$19fa8fddf151ac3f$var$b && !$19fa8fddf151ac3f$var$g && $19fa8fddf151ac3f$var$_.length === 0 && $19fa8fddf151ac3f$var$d === 0;
}
function $19fa8fddf151ac3f$var$w() {
    if ($19fa8fddf151ac3f$var$p.length === 0 || !$19fa8fddf151ac3f$var$z()) return;
    const e = $19fa8fddf151ac3f$var$p.splice(0);
    for(let t = 0; t < e.length; t++)e[t]();
}
function $19fa8fddf151ac3f$export$3910381886d0de18() {
    return new Promise((e)=>{
        $19fa8fddf151ac3f$var$p.push(e), queueMicrotask($19fa8fddf151ac3f$var$w);
    });
}
function $19fa8fddf151ac3f$var$F() {
    for(let e = 0; e < $19fa8fddf151ac3f$var$_.length; e++)$19fa8fddf151ac3f$var$m($19fa8fddf151ac3f$var$_[e]);
    $19fa8fddf151ac3f$var$_.length = 0;
}
function $19fa8fddf151ac3f$var$R(e) {
    $19fa8fddf151ac3f$var$y++;
    try {
        for (const t of e)t._notify();
    } finally{
        if ($19fa8fddf151ac3f$var$y--, $19fa8fddf151ac3f$var$y === 0 && $19fa8fddf151ac3f$var$x.length > 0) {
            const t = $19fa8fddf151ac3f$var$x.splice(0);
            for(let n = 0; n < t.length; n++)$19fa8fddf151ac3f$var$m(t[n]);
        }
    }
}
function $19fa8fddf151ac3f$var$N(e) {
    $19fa8fddf151ac3f$var$R(e);
}
function $19fa8fddf151ac3f$var$T(e) {
    for (const t of e._sources)t._subscribers.delete(e);
    e._sources.clear();
}

});

parcelRegister("5a83z", function(module, exports) {

$parcel$export(module.exports, "STORE_METHOD_NAMES", () => $3c2422cab46d1f64$export$e57bed44fbdb06f);
$parcel$export(module.exports, "RESERVED_STORE_METHODS", () => $3c2422cab46d1f64$export$ae3485d217363a19);
$parcel$export(module.exports, "warnStateKeyShadowsMethod", () => $3c2422cab46d1f64$export$f338bed42a74a3fe);
$parcel$export(module.exports, "__resetStateShadowWarnings", () => $3c2422cab46d1f64$export$f62a3f54d4c65d24);
$parcel$export(module.exports, "createStore", () => $3c2422cab46d1f64$export$f51a9068ac82ea43);
$parcel$export(module.exports, "isStore", () => $3c2422cab46d1f64$export$9abf972af34a1547);
$parcel$export(module.exports, "getSignals", () => $3c2422cab46d1f64$export$c50078d4faa171f0);
$parcel$export(module.exports, "createScopeStore", () => $3c2422cab46d1f64$export$dfd36abd169cef99);

var $2ehCU = parcelRequire("2ehCU");
const $3c2422cab46d1f64$var$O = Symbol("store"), $3c2422cab46d1f64$var$m = Symbol("signals"), $3c2422cab46d1f64$export$e57bed44fbdb06f = [
    "update",
    "parse",
    "clean",
    "keys",
    "values",
    "replace",
    "add",
    "remove",
    "destroy",
    "quietUpdate"
], $3c2422cab46d1f64$export$ae3485d217363a19 = new Set($3c2422cab46d1f64$export$e57bed44fbdb06f), $3c2422cab46d1f64$var$E = new Set, $3c2422cab46d1f64$var$U = (n, i)=>n ? n + "." + i : String(i);
function $3c2422cab46d1f64$export$f338bed42a74a3fe(n, i) {
    const u = (i || "") + "::" + n;
    if ($3c2422cab46d1f64$var$E.has(u)) return;
    $3c2422cab46d1f64$var$E.add(u);
    const a = i ? `state.${i}` : "state", s = `[smbls/state] "${n}" is a reserved store-method name and was written as DATA at ${a}.${n}. The value is preserved and readable \u2014 data wins over the method \u2014 but "${a}.${n}(\u2026)" no longer reaches the store method on this node. Use "${a}.$${n}(\u2026)" for the method, or rename the data key. Reserved: ${$3c2422cab46d1f64$export$e57bed44fbdb06f.join(", ")}.`;
    typeof console < "u" && console.warn && console.warn(s);
}
function $3c2422cab46d1f64$export$f62a3f54d4c65d24() {
    $3c2422cab46d1f64$var$E.clear();
}
const $3c2422cab46d1f64$var$R = (n)=>!n || typeof n != "object" || Array.isArray(n) || n[$3c2422cab46d1f64$var$O] || Object.isFrozen(n) || typeof Node < "u" && n instanceof Node || n.__ref || n.nodeType || n.nodeName || !$3c2422cab46d1f64$var$A(n), $3c2422cab46d1f64$var$G = 12, $3c2422cab46d1f64$var$A = (n)=>{
    if (!n || typeof n != "object") return !1;
    const i = Object.getPrototypeOf(n);
    return i === Object.prototype || i === null;
};
function $3c2422cab46d1f64$var$S(n, i, u) {
    if (n === i) return !0;
    if (u > $3c2422cab46d1f64$var$G) return !1;
    if (Array.isArray(n) || Array.isArray(i)) {
        if (!Array.isArray(n) || !Array.isArray(i) || n.length !== i.length) return !1;
        for(let a = 0; a < n.length; a++)if (!$3c2422cab46d1f64$var$S(n[a], i[a], u + 1)) return !1;
        return !0;
    }
    if ($3c2422cab46d1f64$var$A(n) && $3c2422cab46d1f64$var$A(i)) {
        const a = Object.keys(n), s = Object.keys(i);
        if (a.length !== s.length) return !1;
        for (const l of a)if (!Object.prototype.hasOwnProperty.call(i, l) || !$3c2422cab46d1f64$var$S(n[l], i[l], u + 1)) return !1;
        return !0;
    }
    return !1;
}
function $3c2422cab46d1f64$export$f51a9068ac82ea43(n, i, u, a) {
    u === void 0 && (u = 0), a === void 0 && (a = "");
    const s = {}, l = {}, w = (t)=>Object.prototype.hasOwnProperty.call(s, t) && Object.prototype.hasOwnProperty.call(l, t), c = (t)=>{
        if (!a || !i || typeof i.isDataOnlyKey != "function") return !1;
        const e = a.indexOf(".");
        return !!i.isDataOnlyKey(e === -1 ? a : a.slice(0, e), t);
    }, f = i && i.maxDepth || 8;
    if (n && typeof n == "object") for(const t in n){
        if (t === "__proto__" || !Object.prototype.hasOwnProperty.call(n, t)) continue;
        if (t.startsWith("__")) {
            l[t] = n[t];
            continue;
        }
        $3c2422cab46d1f64$export$ae3485d217363a19.has(t) && !c(t) && $3c2422cab46d1f64$export$f338bed42a74a3fe(t, a);
        const e = n[t];
        u < f && e && typeof e == "object" && !$3c2422cab46d1f64$var$R(e) ? (l[t] = e, s[t] = (0, $2ehCU.createSignal)($3c2422cab46d1f64$export$f51a9068ac82ea43(e, i, u + 1, $3c2422cab46d1f64$var$U(a, t)))) : (l[t] = e, s[t] = (0, $2ehCU.createSignal)(e));
    }
    const o = new Proxy(l, {
        get (t, e) {
            if (e === $3c2422cab46d1f64$var$O) return !0;
            if (e === $3c2422cab46d1f64$var$m) return s;
            if (e === "__raw") return t;
            if (e === "$update") return h;
            if (e === "$parse") return q;
            if (e === "$clean") return g;
            if (e === "$keys") return N;
            if (e === "$values") return W;
            if (e === "$replace") return C;
            if (e === "$add") return M;
            if (e === "$remove") return V;
            if (e === "$destroy") return z;
            if (e === "$quietUpdate") return K;
            if (e === "$settled") return H;
            if ($3c2422cab46d1f64$export$ae3485d217363a19.has(e) && !Object.prototype.hasOwnProperty.call(s, e)) switch(e){
                case "update":
                    return h;
                case "parse":
                    return q;
                case "clean":
                    return g;
                case "keys":
                    return N;
                case "values":
                    return W;
                case "replace":
                    return C;
                case "add":
                    return M;
                case "remove":
                    return V;
                case "destroy":
                    return z;
                case "quietUpdate":
                    return K;
            }
            if (e === "__element") return t.__element;
            if (e === "parent") return t.parent;
            if (e === "root") return t.root;
            if (Object.prototype.hasOwnProperty.call(s, e)) {
                const y = s[e].get();
                if (y !== void 0 || !(e !== "root" && t.root && t.root !== o)) return y;
            }
            if (t[e] !== void 0) return typeof e == "string" && (0, $2ehCU.noteUntrackedRead)(), t[e];
            const r = typeof e == "string" && !e.startsWith("__") && e !== "then" && e !== "constructor" && (0, $2ehCU.getObserver)() != null;
            if (e !== "root" && t.root && t.root !== o) {
                const y = t.root[e];
                return r && !Object.prototype.hasOwnProperty.call(s, e) && (s[e] = (0, $2ehCU.createSignal)(void 0), s[e].get()), y;
            }
            if (r) return s[e] = (0, $2ehCU.createSignal)(void 0), s[e].get();
            typeof e == "string" && e.charCodeAt(0) === 95 && e.charCodeAt(1) === 95 && (0, $2ehCU.noteUntrackedRead)();
        },
        set (t, e, r) {
            if (e === "__proto__") return !1;
            if (e === "__element" || e === "parent" || e === "root" || typeof e == "string" && e.startsWith("__") && !Object.prototype.hasOwnProperty.call(s, e)) return t[e] = r, !0;
            $3c2422cab46d1f64$export$ae3485d217363a19.has(e) && !c(e) && $3c2422cab46d1f64$export$f338bed42a74a3fe(e, a);
            const y = $3c2422cab46d1f64$var$U(a, e);
            if (Object.prototype.hasOwnProperty.call(s, e)) {
                if (r && typeof r == "object" && !$3c2422cab46d1f64$var$R(r)) {
                    if (r === t[e]) return !0;
                    const P = s[e].peek(), L = P && P[$3c2422cab46d1f64$var$O] ? P.$parse() : P;
                    if ($3c2422cab46d1f64$var$S(r, L, 0)) return !0;
                    t[e] = r, (0, $2ehCU.journalWrite)(y), s[e].set($3c2422cab46d1f64$export$f51a9068ac82ea43(r, i, u + 1, y));
                } else {
                    if (Array.isArray(r) && r !== t[e] && Array.isArray(s[e].peek()) && $3c2422cab46d1f64$var$S(r, s[e].peek(), 0)) return !0;
                    s[e].peek() !== r && (0, $2ehCU.journalWrite)(y), t[e] = r, s[e].set(r);
                }
            } else t[e] = r, r && typeof r == "object" && !$3c2422cab46d1f64$var$R(r) ? s[e] = (0, $2ehCU.createSignal)($3c2422cab46d1f64$export$f51a9068ac82ea43(r, i, u + 1, y)) : s[e] = (0, $2ehCU.createSignal)(r);
            return !0;
        },
        has (t, e) {
            return (0, $2ehCU.noteUntrackedRead)(), typeof e == "string" && e.charCodeAt(0) === 36 && $3c2422cab46d1f64$export$ae3485d217363a19.has(e.slice(1)) ? !0 : e in t;
        },
        ownKeys (t) {
            return (0, $2ehCU.noteUntrackedRead)(), Object.keys(s).filter(w);
        },
        getOwnPropertyDescriptor (t, e) {
            return (0, $2ehCU.noteUntrackedRead)(), w(e) ? {
                enumerable: !0,
                configurable: !0,
                value: s[e].peek()
            } : Object.getOwnPropertyDescriptor(t, e);
        },
        deleteProperty (t, e) {
            if (Object.prototype.hasOwnProperty.call(s, e)) {
                const r = s[e];
                r.peek() !== void 0 && (0, $2ehCU.journalWrite)($3c2422cab46d1f64$var$U(a, e)), r.set(void 0), r._subscribers.size === 0 && delete s[e];
            }
            return delete t[e], !0;
        }
    });
    function j(t, e) {
        const r = l.__element;
        return !r || typeof r.onBeforeStateUpdate != "function" || e?.preventBeforeStateUpdateListener ? !0 : r.onBeforeStateUpdate(r, o, r.context, {
            changes: t,
            options: e
        }) !== !1;
    }
    function h(t, e) {
        if (t && typeof t == "object" && !j(t, e)) return o;
        (0, $2ehCU.batch)(()=>{
            for(const y in t)y !== "__proto__" && (o[y] = t[y]);
        });
        const r = l.__element;
        return r && r.onUpdate && !e?.quiet && r.onUpdate(r, o, r.context), o;
    }
    function K(t) {
        return h(t, {
            quiet: !0
        });
    }
    function H() {
        return (0, $2ehCU.settled)().then(()=>o);
    }
    function q(t) {
        if ((0, $2ehCU.noteUntrackedRead)(), t || (t = new Set), t.has(o)) return "[Circular]";
        t.add(o);
        const e = {};
        for(const r in s){
            if (r === "parent" || r === "root" || r.startsWith("__") || !Object.prototype.hasOwnProperty.call(l, r)) continue;
            const y = s[r].peek();
            y && y[$3c2422cab46d1f64$var$O] ? e[r] = y.$parse(t) : e[r] = y;
        }
        return e;
    }
    function g() {
        return (0, $2ehCU.batch)(()=>{
            for(const t in s)delete o[t];
        }), o;
    }
    function N() {
        return (0, $2ehCU.noteUntrackedRead)(), Object.keys(s).filter(w);
    }
    function W() {
        return (0, $2ehCU.noteUntrackedRead)(), Object.keys(s).filter(w).map((t)=>s[t].peek());
    }
    function C(t, e) {
        return t && typeof t == "object" && !j(t, e) || (0, $2ehCU.batch)(()=>{
            for(const r in s)r in t || delete o[r];
            for(const r in t)r !== "__proto__" && (o[r] = t[r]);
        }), o;
    }
    function M(t, e) {
        const r = Object.prototype.hasOwnProperty.call(s, t) ? s[t].peek() : l[t];
        if (Array.isArray(r)) return o[t] = [
            ...r,
            e
        ], o;
        if (r && typeof r == "object" && !Array.isArray(r)) {
            if ($3c2422cab46d1f64$var$A(e)) r[$3c2422cab46d1f64$var$O] ? r.$update(e) : o[t] = {
                ...r,
                ...e
            };
            else {
                const y = String(Object.keys(r).length);
                r[$3c2422cab46d1f64$var$O] ? r.$update({
                    [y]: e
                }) : o[t] = {
                    ...r,
                    [y]: e
                };
            }
            return o;
        }
        return o[t] = e, o;
    }
    function V(t) {
        return delete o[t], o;
    }
    function z() {
        g(), l.__element = null, l.parent = null;
    }
    return o;
}
function $3c2422cab46d1f64$export$9abf972af34a1547(n) {
    return n && n[$3c2422cab46d1f64$var$O] === !0;
}
function $3c2422cab46d1f64$export$c50078d4faa171f0(n) {
    return n[$3c2422cab46d1f64$var$m];
}
function $3c2422cab46d1f64$export$dfd36abd169cef99(n, i) {
    const u = {}, a = {};
    if (n && typeof n == "object") for(const c in n)a[c] = n[c], u[c] = (0, $2ehCU.createSignal)(n[c]);
    const s = (c)=>{
        if (Object.prototype.hasOwnProperty.call(u, c)) return u;
        let f = i;
        for(; f;){
            const o = f[$3c2422cab46d1f64$var$m];
            if (o && Object.prototype.hasOwnProperty.call(o, c)) return o;
            f = f[$3c2422cab46d1f64$var$O] ? f[$3c2422cab46d1f64$var$$] : null;
        }
        return null;
    }, l = ()=>{
        let c = i;
        for(; c && c[$3c2422cab46d1f64$var$O];)c = c[$3c2422cab46d1f64$var$$];
        return c && typeof c == "object" ? c : null;
    };
    return new Proxy(a, {
        get (c, f) {
            return f === $3c2422cab46d1f64$var$O ? !0 : f === $3c2422cab46d1f64$var$m ? u : f === $3c2422cab46d1f64$var$$ ? i : f === "__raw" ? c : Object.prototype.hasOwnProperty.call(u, f) ? u[f].get() : i && f !== "then" && f !== "constructor" ? i[f] : c[f];
        },
        set (c, f, o) {
            const j = s(f);
            if (j) return j === u && (c[f] = o), j[f].set(o), !0;
            const h = l();
            return h && Object.prototype.hasOwnProperty.call(h, f) ? (h[f] = o, !0) : (c[f] = o, u[f] = (0, $2ehCU.createSignal)(o), !0);
        },
        has (c, f) {
            if ((0, $2ehCU.noteUntrackedRead)(), f in u || f in c) return !0;
            let o = i;
            for(; o;){
                if (f in o) return !0;
                o = o[$3c2422cab46d1f64$var$O] ? o[$3c2422cab46d1f64$var$$] : null;
            }
            return !1;
        },
        ownKeys () {
            return (0, $2ehCU.noteUntrackedRead)(), Object.keys(u);
        },
        getOwnPropertyDescriptor (c, f) {
            return (0, $2ehCU.noteUntrackedRead)(), f in u ? {
                enumerable: !0,
                configurable: !0,
                value: u[f].peek()
            } : Object.getOwnPropertyDescriptor(c, f);
        }
    });
}
const $3c2422cab46d1f64$var$$ = Symbol("scope.parent");

});

parcelRegister("58lC3", function(module, exports) {

$parcel$export(module.exports, "resolveSignalEngine", () => $3bce76eed3e4e70e$export$d166d8476784c7c1);

var $4dThk = parcelRequire("4dThk");

var $5F9Db = parcelRequire("5F9Db");
const $3bce76eed3e4e70e$export$119a061663ce6b8f = "__SMBLS_SIGNAL_ENGINE__", $3bce76eed3e4e70e$export$d166d8476784c7c1 = (e, i, s)=>{
    const t = i || (0, $4dThk.VERSION), n = s || (typeof globalThis < "u" ? globalThis : null);
    if (!n) return e;
    const o = n[$3bce76eed3e4e70e$export$119a061663ce6b8f];
    return o && o.engine && o.version === t ? ((0, $5F9Db.registerSignalInstance)(t, n, !0), o.engine) : (o || (n[$3bce76eed3e4e70e$export$119a061663ce6b8f] = {
        version: t,
        engine: e
    }), (0, $5F9Db.registerSignalInstance)(t, n, !1), e);
}, $3bce76eed3e4e70e$export$b69457ee2211ecba = (e)=>{
    const i = e || (typeof globalThis < "u" ? globalThis : null);
    i && delete i[$3bce76eed3e4e70e$export$119a061663ce6b8f];
};

});
parcelRegister("4dThk", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $3133418110f35da7$export$a4ad2735b021c132);
const $3133418110f35da7$export$a4ad2735b021c132 = "3.14.790";

});

parcelRegister("5F9Db", function(module, exports) {

$parcel$export(module.exports, "registerSignalInstance", () => $41f84099166ec973$export$f69cc5c3d7f5d723);

var $4dThk = parcelRequire("4dThk");
const $41f84099166ec973$export$655580531144b845 = "__SMBLS_SIGNAL_INSTANCES__", $41f84099166ec973$export$f69cc5c3d7f5d723 = (o, n, t)=>{
    const s = n || (typeof globalThis < "u" ? globalThis : null);
    if (!s) return null;
    const e = s[$41f84099166ec973$export$655580531144b845] || (s[$41f84099166ec973$export$655580531144b845] = {
        versions: [],
        engines: 0,
        reported: !1
    });
    return typeof e.engines != "number" && (e.engines = e.versions.length), e.versions.push(o || (0, $4dThk.VERSION)), t || e.engines++, e.engines > 1 && !e.reported && (e.reported = !0, console.error("[smbls] duplicate @symbo.ls/signal instance \u2014", e.engines, "copies of the reactive engine are loaded on this page:", e.versions.join(", ") + ".", "Each copy keeps its own observer and effect queue, so an effect created", "by one copy never re-fires from another copy's store writes, and one", "copy's cascade breaker cannot see the other's queue.", "Copies of the SAME version adopt a single engine automatically, so", "this means the versions above DIFFER: a fossil copy is resolving beside", "the current one. That is a dependency-graph fault, not an application", "bug \u2014 align the version wherever @symbo.ls/signal is imported, then", "regenerate the lockfile so exactly one version resolves.")), e;
}, $41f84099166ec973$export$23928a49db98d987 = (o)=>{
    const n = o || (typeof globalThis < "u" ? globalThis : null);
    n && delete n[$41f84099166ec973$export$655580531144b845];
};

});




parcelRegister("avEQR", function(module, exports) {

$parcel$export(module.exports, "EARLY_KEY", () => $7a6c7ce93b8191a1$export$1ebc832167c7c8cf);
$parcel$export(module.exports, "EARLY_MAX_AGE", () => $7a6c7ce93b8191a1$export$c1839c6750cf6c2a);
$parcel$export(module.exports, "earlyKey", () => $7a6c7ce93b8191a1$export$76bd00b97968d76f);
$parcel$export(module.exports, "isScalarParams", () => $7a6c7ce93b8191a1$export$31bf39769c2764aa);
$parcel$export(module.exports, "queryHeaderEntries", () => $7a6c7ce93b8191a1$export$90ff3bb6eba61b0a);
$parcel$export(module.exports, "withReads", () => $7a6c7ce93b8191a1$export$28c96a9bb6828c09);
$parcel$export(module.exports, "openEarly", () => $7a6c7ce93b8191a1$export$ad66f4518cd0ac2d);
$parcel$export(module.exports, "takeEarly", () => $7a6c7ce93b8191a1$export$ede2d0f4ffa0ca06);
$parcel$export(module.exports, "noteTaken", () => $7a6c7ce93b8191a1$export$d1da4614d68fb5f5);
$parcel$export(module.exports, "dropEarly", () => $7a6c7ce93b8191a1$export$7e0c813ad8def08b);
$parcel$export(module.exports, "SEED_BLOCK", () => $7a6c7ce93b8191a1$export$5ea7f9f3162af610);
$parcel$export(module.exports, "createEarlySeedBlock", () => $7a6c7ce93b8191a1$export$2361b9cbdfb29e6c);
$parcel$export(module.exports, "hasBuiltRuns", () => $7a6c7ce93b8191a1$export$200e642c479d303d);
$parcel$export(module.exports, "builtRuns", () => $7a6c7ce93b8191a1$export$e0373960a9c97939);
$parcel$export(module.exports, "STALE_ATTRIBUTE", () => $7a6c7ce93b8191a1$export$32582244ad79aa74);
$parcel$export(module.exports, "whenSeedTaken", () => $7a6c7ce93b8191a1$export$8942553480e6a9e7);
$parcel$export(module.exports, "noteSeededResult", () => $7a6c7ce93b8191a1$export$5f0810d9654e14ef);
$parcel$export(module.exports, "claimSeeded", () => $7a6c7ce93b8191a1$export$fa179a5dc1d45d95);
$parcel$export(module.exports, "seedIsStale", () => $7a6c7ce93b8191a1$export$a827e082d903bf32);
$parcel$export(module.exports, "takeStaleSeed", () => $7a6c7ce93b8191a1$export$d1cf15123f81894);
$parcel$export(module.exports, "createEarlySeedScript", () => $7a6c7ce93b8191a1$export$de191d17f0c3dd2);
parcelRequire("byww3");
var $eLA0f = parcelRequire("eLA0f");

var $dFO0P = parcelRequire("dFO0P");
const $7a6c7ce93b8191a1$export$1ebc832167c7c8cf = "@symbo.ls/fetch:EARLY", $7a6c7ce93b8191a1$export$c1839c6750cf6c2a = 3e4, $7a6c7ce93b8191a1$export$76bd00b97968d76f = (e, t)=>{
    const r = new URL(e);
    return r.searchParams.sort(), r.toString() + " " + (t || "");
}, $7a6c7ce93b8191a1$export$31bf39769c2764aa = (e)=>{
    if (e == null) return !0;
    if (typeof e != "object" || Array.isArray(e)) return !1;
    const t = Object.getPrototypeOf(e);
    if (t !== Object.prototype && t !== null) return !1;
    for(const r in e){
        const s = e[r];
        if (!(s === void 0 || typeof s == "string" || typeof s == "boolean") && !(typeof s == "number" && isFinite(s))) return !1;
    }
    return !0;
}, $7a6c7ce93b8191a1$export$66681c0ce3547f49 = (e, t)=>{
    const r = (l)=>String(l).split("/").filter(Boolean), s = r(t);
    let n = null;
    for(let l = 0; l < e.length; l++){
        const i = r(e[l]), c = i[i.length - 1] === "*", o = c ? i.length - 1 : i.length;
        if (c ? s.length < o : s.length !== o) continue;
        const g = {};
        let d = c ? -1 : 0, y = !0;
        for(let u = 0; u < o; u++)if (i[u].charAt(0) === ":") {
            try {
                g[i[u].slice(1)] = decodeURIComponent(s[u]);
            } catch  {
                y = !1;
                break;
            }
            d += 1;
        } else if (i[u] === s[u]) d += 3;
        else {
            y = !1;
            break;
        }
        y && (!n || d > n.score) && (n = {
            index: l,
            params: g,
            score: d
        });
    }
    return n && {
        index: n.index,
        params: n.params
    };
}, $7a6c7ce93b8191a1$var$a = ()=>Symbol.for($7a6c7ce93b8191a1$export$1ebc832167c7c8cf), $7a6c7ce93b8191a1$export$90ff3bb6eba61b0a = (e, t)=>{
    const r = [];
    for(const s in e || {}){
        const n = s.toLowerCase(), l = {
            name: s,
            header: n,
            param: e[s],
            found: !1,
            value: void 0
        };
        for(const i in t || {})i.toLowerCase() === n && (l.found = !0, l.value = t[i]);
        r.push(l);
    }
    return r;
}, $7a6c7ce93b8191a1$export$28c96a9bb6828c09 = (e, t)=>{
    if (!e || typeof e != "object" || !t || typeof t != "object") return e;
    const r = {
        ...e
    };
    return r.query === void 0 && t.query !== void 0 && (r.query = t.query), r.rpc === void 0 && t.rpc !== void 0 && (r.rpc = t.rpc), r;
}, $7a6c7ce93b8191a1$export$ad66f4518cd0ac2d = (e, t, r)=>{
    const s = $7a6c7ce93b8191a1$var$a();
    if ($7a6c7ce93b8191a1$export$258c7fa39b98ba91(r), !e || typeof e != "object") {
        const i = globalThis[s];
        return i && i.seeded ? {
            carried: {},
            rpc: !1,
            maxAge: $7a6c7ce93b8191a1$export$c1839c6750cf6c2a,
            seeded: !0
        } : null;
    }
    globalThis[s] || (globalThis[s] = {
        entries: {}
    });
    const n = {};
    for (const { header: i, found: c, value: o } of $7a6c7ce93b8191a1$export$90ff3bb6eba61b0a(e.query, t))c && (n[i] = o);
    const l = typeof e.maxAge == "number" && e.maxAge >= 0 ? e.maxAge : $7a6c7ce93b8191a1$export$c1839c6750cf6c2a;
    return {
        carried: n,
        rpc: e.rpc === "get",
        maxAge: l,
        seeded: !!globalThis[s].seeded
    };
}, $7a6c7ce93b8191a1$export$ede2d0f4ffa0ca06 = (e, t = $7a6c7ce93b8191a1$export$c1839c6750cf6c2a, r)=>{
    const s = globalThis[$7a6c7ce93b8191a1$var$a()], n = s && s.entries && s.entries[e];
    return !n || (delete s.entries[e], !(Date.now() - n.time <= t)) ? null : n.seeded ? (s.stale && r && (n.seeded.taken = $7a6c7ce93b8191a1$export$d1da4614d68fb5f5(s, e, r())), Promise.resolve(n.seeded)) : n.ready ? Promise.resolve(n.ready) : Promise.resolve(n.answer).then((l)=>l && l.ok && !l.bodyUsed ? l : null, ()=>null);
}, $7a6c7ce93b8191a1$export$7e0c813ad8def08b = ()=>{
    const e = globalThis[$7a6c7ce93b8191a1$var$a()];
    e && e.entries && (e.entries = {});
}, $7a6c7ce93b8191a1$var$m = (e)=>(Array.isArray(e) ? e : []).filter((t)=>t && typeof t.url == "string" && typeof t.body == "string").map((t)=>({
            k: $7a6c7ce93b8191a1$export$76bd00b97968d76f(t.url, t.lang || ""),
            s: t.status || 200,
            t: t.type || "application/json",
            b: t.body
        })), $7a6c7ce93b8191a1$export$5ea7f9f3162af610 = 'script[type="application/json"][data-fetch-seed]', $7a6c7ce93b8191a1$export$2361b9cbdfb29e6c = (e, t)=>{
    const r = $7a6c7ce93b8191a1$var$m(e);
    return r.length ? (t && typeof t == "object" && Object.keys(t).length && r.push({
        r: t
    }), '<script type="application/json" data-fetch-seed>' + (0, $eLA0f.jsonForScript)(r) + "<\/script>") : "";
}, $7a6c7ce93b8191a1$var$x = ()=>{
    const e = globalThis[$7a6c7ce93b8191a1$var$a()];
    return !e || !e.runs ? null : Date.now() - e.runsTime <= $7a6c7ce93b8191a1$export$c1839c6750cf6c2a ? e.runs : (e.runs = null, null);
}, $7a6c7ce93b8191a1$export$200e642c479d303d = ()=>!!$7a6c7ce93b8191a1$var$x(), $7a6c7ce93b8191a1$export$e0373960a9c97939 = (e)=>{
    const t = $7a6c7ce93b8191a1$var$x(), r = t && typeof e == "string" ? t[e] : null;
    return Array.isArray(r) && r.length ? r : null;
}, $7a6c7ce93b8191a1$export$258c7fa39b98ba91 = (e)=>{
    const t = (0, $eLA0f.readJsonDataBlock)(globalThis.document, $7a6c7ce93b8191a1$export$5ea7f9f3162af610, {
        remove: !0
    }), r = e === !1 ? null : t && t.value;
    if (!Array.isArray(r) || !r.length) {
        const o = globalThis[$7a6c7ce93b8191a1$var$a()];
        o && o.stale || ($7a6c7ce93b8191a1$var$f = null);
        return;
    }
    const s = $7a6c7ce93b8191a1$var$a(), n = globalThis[s] || (globalThis[s] = {
        entries: {}
    });
    n.entries || (n.entries = {}), n.seeded = !0;
    const l = Date.now();
    for (const o of r){
        if (o && o.r && typeof o.r == "object" && !Array.isArray(o.r)) {
            n.runs = Object.assign(n.runs || {}, o.r), n.runsTime = Date.now();
            continue;
        }
        !o || typeof o.k != "string" || typeof o.b != "string" || n.entries[o.k] || (n.entries[o.k] = {
            time: l,
            seeded: {
                seeded: !0,
                status: o.s || 200,
                type: o.t || "application/json",
                body: o.b
            }
        });
    }
    const i = (0, $eLA0f.readBrenderStamp)(globalThis.document) || {
        stamp: null,
        time: null
    }, c = $7a6c7ce93b8191a1$var$R(e, i.stamp, i.time);
    c ? (n.stale = c, n.seedConfig = e && typeof e == "object" ? e : null) : $7a6c7ce93b8191a1$var$f = null;
}, $7a6c7ce93b8191a1$export$32582244ad79aa74 = "data-smbls-stale", $7a6c7ce93b8191a1$var$R = (e, t, r)=>{
    const s = globalThis.document && globalThis.document.documentElement;
    if (s && typeof s.hasAttribute == "function" && s.hasAttribute($7a6c7ce93b8191a1$export$32582244ad79aa74)) return !0;
    if (!e || typeof e != "object") return !1;
    if (e.maxAge != null && r !== null) {
        const n = (0, $dFO0P.parseDuration)(e.maxAge);
        if (n > 0 && Date.now() - r > n) return !0;
    }
    if (typeof e.isStale != "function") return !1;
    try {
        const n = e.isStale(t, {
            time: r
        });
        return n && typeof n.then == "function" ? Promise.resolve(n).then(Boolean, ()=>!1) : !!n;
    } catch  {
        return !1;
    }
}, $7a6c7ce93b8191a1$export$d1da4614d68fb5f5 = (e, t, r)=>{
    const s = {
        key: t,
        again: r,
        result: null,
        cacheKey: null
    };
    if ((e.taken || (e.taken = [])).push(s), $7a6c7ce93b8191a1$var$f) {
        const n = $7a6c7ce93b8191a1$var$f;
        $7a6c7ce93b8191a1$var$f = null;
        for (const l of n)try {
            l();
        } catch  {}
    }
    return s;
};
let $7a6c7ce93b8191a1$var$f = null;
const $7a6c7ce93b8191a1$export$8942553480e6a9e7 = (e)=>{
    const t = globalThis[$7a6c7ce93b8191a1$var$a()];
    return t && t.seeded && !t.stale || t && t.stale && t.revalidated ? !1 : t && t.stale && t.taken && t.taken.length ? (e(), !0) : (($7a6c7ce93b8191a1$var$f || ($7a6c7ce93b8191a1$var$f = new Set)).add(e), !0);
}, $7a6c7ce93b8191a1$export$5f0810d9654e14ef = (e, t)=>{
    const r = globalThis[$7a6c7ce93b8191a1$var$a()];
    !r || !e || typeof e != "object" || (t.result = e, (r.results || (r.results = new WeakMap)).set(e, t));
}, $7a6c7ce93b8191a1$export$fa179a5dc1d45d95 = (e, t)=>{
    const r = globalThis[$7a6c7ce93b8191a1$var$a()], s = r && r.results && e ? r.results.get(e) : null;
    s && (s.cacheKey = t);
}, $7a6c7ce93b8191a1$export$a827e082d903bf32 = ()=>{
    const e = globalThis[$7a6c7ce93b8191a1$var$a()];
    return !!(e && e.stale && !e.revalidated);
}, $7a6c7ce93b8191a1$export$d1cf15123f81894 = async ()=>{
    const e = globalThis[$7a6c7ce93b8191a1$var$a()];
    if (!e || !e.stale || e.revalidated) return null;
    e.revalidated = !0;
    const t = await e.stale, r = e.taken || [];
    return e.taken = [], e.results = null, t ? {
        taken: r,
        config: e.seedConfig || {}
    } : null;
}, $7a6c7ce93b8191a1$export$de191d17f0c3dd2 = (e)=>{
    const t = $7a6c7ce93b8191a1$var$m(e);
    if (!t.length) return "";
    const r = (0, $eLA0f.jsonForScript)(t);
    return "<script>(function(){try{var k=Symbol.for(" + JSON.stringify($7a6c7ce93b8191a1$export$1ebc832167c7c8cf) + "),r=globalThis[k]||(globalThis[k]={entries:{}}),t=Date.now(),l=" + r + ';r.seeded=true;r.entries=r.entries||{};for(var i=0;i<l.length;i++){var e=l[i];r.entries[e.k]={time:t,answer:Promise.resolve(new Response(e.b,{status:e.s,headers:{"content-type":e.t}}))}}}catch(e){}})()<\/script>';
};

});
parcelRegister("dFO0P", function(module, exports) {

$parcel$export(module.exports, "parseDuration", () => $9f45e61ef68de544$export$ecae829bb3747ea6);
const $9f45e61ef68de544$export$ecae829bb3747ea6 = (r)=>{
    if (!r) return 0;
    if (typeof r == "number") return r;
    const e = r.match(/^(\d+)(ms|s|m|h)$/);
    if (!e) return 0;
    const t = parseInt(e[1]), n = e[2];
    return n === "ms" ? t : n === "s" ? t * 1e3 : n === "m" ? t * 6e4 : n === "h" ? t * 36e5 : 0;
};

});


parcelRegister("bceDf", function(module, exports) {

$parcel$export(module.exports, "takeSeededNow", () => $826c2a4d88646579$export$838e5f29b32922a1);
$parcel$export(module.exports, "seedWaiting", () => $826c2a4d88646579$export$31e50a83330938dc);

var $avEQR = parcelRequire("avEQR");

var $kOTDQ = parcelRequire("kOTDQ");
const $826c2a4d88646579$var$i = ()=>globalThis[Symbol.for((0, $avEQR.EARLY_KEY))], $826c2a4d88646579$export$838e5f29b32922a1 = (e, r = (0, $avEQR.EARLY_MAX_AGE), n, u)=>{
    const t = $826c2a4d88646579$var$i(), s = t && t.entries && t.entries[e];
    if (!s || !s.seeded || !(Date.now() - s.time <= r)) return null;
    const o = u(s.seeded);
    return o ? (delete t.entries[e], t.stale && n && (0, $avEQR.noteSeededResult)(o, (0, $avEQR.noteTaken)(t, e, n())), o) : null;
}, $826c2a4d88646579$export$31e50a83330938dc = ()=>{
    const e = $826c2a4d88646579$var$i();
    if (e && e.atInit && (0, $kOTDQ.earlyReady)()) return !0;
    if (e && e.seeded) {
        for(const n in e.entries)if (e.entries[n] && e.entries[n].seeded) return !0;
        return !1;
    }
    const r = globalThis.document;
    return !!(r && typeof r.querySelector == "function" && r.querySelector((0, $avEQR.SEED_BLOCK)));
};

});
parcelRegister("kOTDQ", function(module, exports) {

$parcel$export(module.exports, "takeEarlySlice", () => $f283a36d4f5d4172$export$e0169bb80bb69260);
$parcel$export(module.exports, "adoptEarlyNow", () => $f283a36d4f5d4172$export$ae7e2da33812c0ab);
$parcel$export(module.exports, "earlyReady", () => $f283a36d4f5d4172$export$e286297e52d90cd5);

var $avEQR = parcelRequire("avEQR");
const $f283a36d4f5d4172$export$87458d4c112e7482 = (t, s, a)=>{
    const r = new URL(t);
    return r.searchParams.delete(a || "limit"), r.searchParams.sort(), r.toString() + " " + (s || "");
}, $f283a36d4f5d4172$var$b = (t, s, a)=>{
    if (!t || !t.slices) return null;
    const r = new URL(s).searchParams;
    for (const n of t.sliceParams || [
        "limit"
    ]){
        const i = +r.get(n), e = i > 0 && t.slices[$f283a36d4f5d4172$export$87458d4c112e7482(s, a, n)];
        if (e && e.length) return {
            slots: e,
            limit: i
        };
    }
    return null;
}, $f283a36d4f5d4172$var$d = (t, s, a, r)=>Array.isArray(t) ? {
        seeded: !0,
        status: a,
        type: r,
        body: JSON.stringify(t.slice(0, s))
    } : null, $f283a36d4f5d4172$var$m = (t, s, a, r)=>{
    const n = globalThis[Symbol.for((0, $avEQR.EARLY_KEY))], i = $f283a36d4f5d4172$var$b(n, t, s);
    if (!i) return null;
    const { slots: e, limit: c } = i;
    for(let o = 0; o < e.length; o++){
        const l = n.entries && n.entries[e[o]];
        if (!(!l || !r(l, c))) return delete n.entries[e[o]], e.splice(o, 1), [
            l,
            c,
            Date.now() - l.time <= a
        ];
    }
    return null;
}, $f283a36d4f5d4172$export$e0169bb80bb69260 = (t, s, a = (0, $avEQR.EARLY_MAX_AGE))=>{
    const r = $f283a36d4f5d4172$var$m(t, s, a, (e, c)=>e.limit >= c);
    if (!r || !r[2]) return null;
    const [n, i] = r;
    if (n.ready) try {
        return Promise.resolve($f283a36d4f5d4172$var$d(JSON.parse(n.ready.body), i, n.ready.status, n.ready.type));
    } catch  {
        return null;
    }
    return Promise.resolve(n.answer).then((e)=>{
        if (!e || !e.ok || e.bodyUsed) return null;
        const c = e.headers && e.headers.get("content-type") || "application/json";
        return e.json().then((o)=>$f283a36d4f5d4172$var$d(o, i, e.status, c));
    }).catch(()=>null);
}, $f283a36d4f5d4172$export$ae7e2da33812c0ab = (t, s, a, r, n)=>{
    const i = globalThis[Symbol.for((0, $avEQR.EARLY_KEY))];
    if (!i || !i.atInit || !i.entries) return null;
    const e = (l)=>l.ready && Date.now() - l.time <= r, c = i.entries[t];
    if (c) {
        const l = e(c) && n(c.ready);
        return l && delete i.entries[t], l || null;
    }
    let o = null;
    return $f283a36d4f5d4172$var$m(s, a, r, (l, f)=>{
        if (!e(l)) return !1;
        let u = l.ready;
        if (l.limit >= f) try {
            u = $f283a36d4f5d4172$var$d(JSON.parse(u.body), f, u.status, u.type);
        } catch  {
            u = null;
        }
        return o = u && n(u), o && l.limit < f && (o.partial = !0), !!o;
    }), o;
}, $f283a36d4f5d4172$export$e286297e52d90cd5 = ()=>{
    const t = globalThis[Symbol.for((0, $avEQR.EARLY_KEY))];
    if (!t || !t.atInit || !t.entries) return !1;
    for(const s in t.entries)if (t.entries[s] && t.entries[s].ready) return !0;
    return !1;
};

});


parcelRegister("9MmMs", function(module, exports) {

$parcel$export(module.exports, "buildUrl", () => $71ea44806ef722bf$export$b5cd97dee32de81d);
$parcel$export(module.exports, "selectQuery", () => $71ea44806ef722bf$export$b984dc8122fd896d);
$parcel$export(module.exports, "headerEntries", () => $71ea44806ef722bf$export$d3b4596ecd7dc9b);
$parcel$export(module.exports, "withQuery", () => $71ea44806ef722bf$export$e0f4c6d2a1e99ce0);
$parcel$export(module.exports, "setup", () => $71ea44806ef722bf$export$de27182ff8187d6c);
$parcel$export(module.exports, "restAdapter", () => $71ea44806ef722bf$export$f4134a2321012fb);

var $avEQR = parcelRequire("avEQR");

var $bceDf = parcelRequire("bceDf");

var $9ZqBV = parcelRequire("9ZqBV");

var $kOTDQ = parcelRequire("kOTDQ");
const $71ea44806ef722bf$export$b5cd97dee32de81d = (t, r, s)=>{
    const i = r && !r.startsWith("/") ? "/" : "", o = new URL(`${t}${i}${r}`);
    if (s) for(const d in s){
        const c = s[d];
        c != null && o.searchParams.set(d, typeof c == "object" ? JSON.stringify(c) : c);
    }
    return o.toString();
}, $71ea44806ef722bf$export$b984dc8122fd896d = ({ params: t, select: r, limit: s, offset: i, order: o, single: d })=>{
    const c = {
        ...t
    };
    return r && (c.select = r), s && (c.limit = s), i && (c.offset = i), d && (c.single = !0), o && (typeof o == "string" ? c.order = o : Array.isArray(o) ? c.order = o.map(($)=>`${$.by}:${$.asc === !1 ? "desc" : "asc"}`).join(",") : o.by && (c.order = `${o.by}:${o.asc === !1 ? "desc" : "asc"}`)), c;
}, $71ea44806ef722bf$var$v = (t)=>Object.prototype.toString.call(t).slice(8, -1), $71ea44806ef722bf$var$L = [
    "auto",
    "json",
    "text",
    "blob",
    "arrayBuffer",
    "stream",
    "response"
], $71ea44806ef722bf$var$ct = {
    json: async (t)=>{
        const r = await t.text();
        return r ? JSON.parse(r) : null;
    },
    text: (t)=>t.text(),
    blob: (t)=>t.blob(),
    arrayBuffer: (t)=>t.arrayBuffer(),
    stream: (t)=>t.body,
    response: (t)=>t
}, $71ea44806ef722bf$var$ut = (t)=>{
    const r = t.headers.get("content-type");
    return r && r.includes("json") ? t.json() : t.text();
}, $71ea44806ef722bf$var$it = async (t)=>{
    const r = await t.text(), s = t.headers.get("content-type");
    if (r && s && s.includes("json")) try {
        return JSON.parse(r);
    } catch  {}
    return r;
}, $71ea44806ef722bf$var$K = (t, r)=>t?.message || t?.error || r.statusText || `HTTP ${r.status}`, $71ea44806ef722bf$var$V = (t, r, s)=>{
    const i = {
        data: r,
        error: s,
        status: t.status
    }, o = t.headers.get("retry-after");
    return o !== null && (i.retryAfter = o), i;
}, $71ea44806ef722bf$var$I = (t, r)=>{
    const s = t.body, i = r === "json" || r === "auto" && /json/i.test(t.type);
    if (!i && r !== "auto" && r !== "text") return null;
    let o;
    try {
        o = i ? s ? JSON.parse(s) : null : s;
    } catch  {
        return !1;
    }
    return {
        data: o,
        error: null,
        status: t.status
    };
}, $71ea44806ef722bf$var$x = async (t, r, s, i)=>{
    const o = s ?? "auto";
    if (!$71ea44806ef722bf$var$L.includes(o)) throw new TypeError(`@symbo.ls/fetch rest: unknown responseType "${o}" \u2014 use one of: ${$71ea44806ef722bf$var$L.join(", ")}`);
    (0, $9ZqBV.requestStarted)();
    try {
        return await $71ea44806ef722bf$var$X(t, r, o, i);
    } finally{
        (0, $9ZqBV.requestFinished)();
    }
}, $71ea44806ef722bf$var$X = async (t, r, s, i)=>{
    let o = i ? await i : null;
    if (o && o.seeded === !0) {
        const c = $71ea44806ef722bf$var$I(o, s);
        if (o.taken && c !== !1) {
            const $ = c || await $71ea44806ef722bf$var$X(t, r, s, Promise.resolve(new Response(o.body, {
                status: o.status,
                headers: {
                    "content-type": o.type
                }
            })));
            return (0, $avEQR.noteSeededResult)($, o.taken), $;
        }
        if (c) return c;
        o = c === !1 ? null : new Response(o.body, {
            status: o.status,
            headers: {
                "content-type": o.type
            }
        });
    }
    const d = o || await globalThis.fetch(t, r);
    if (s === "auto") {
        const c = await $71ea44806ef722bf$var$ut(d);
        return d.ok ? {
            data: c,
            error: null,
            status: d.status
        } : $71ea44806ef722bf$var$V(d, c, $71ea44806ef722bf$var$K(c, d));
    }
    if (!d.ok) {
        const c = await $71ea44806ef722bf$var$it(s === "response" ? d.clone() : d);
        return $71ea44806ef722bf$var$V(d, s === "response" ? d : c, $71ea44806ef722bf$var$K(c, d));
    }
    return {
        data: await $71ea44806ef722bf$var$ct[s](d),
        error: null,
        status: d.status
    };
}, $71ea44806ef722bf$var$dt = [
    "FormData",
    "Blob",
    "File",
    "URLSearchParams",
    "ReadableStream",
    "ArrayBuffer"
], $71ea44806ef722bf$var$ft = (t)=>t !== null && typeof t == "object" && (ArrayBuffer.isView(t) || $71ea44806ef722bf$var$dt.includes($71ea44806ef722bf$var$v(t))), $71ea44806ef722bf$export$d3b4596ecd7dc9b = (t)=>Array.isArray(t) ? t : typeof t.entries == "function" ? t.entries() : Object.entries(t), $71ea44806ef722bf$var$W = (...t)=>{
    const r = {}, s = new Map;
    for (const i of t)if (i) for (const [o, d] of $71ea44806ef722bf$export$d3b4596ecd7dc9b(i)){
        const c = o.toLowerCase();
        if (s.has(c) && delete r[s.get(c)], d == null) {
            s.delete(c);
            continue;
        }
        s.set(c, o), r[o] = d;
    }
    return r;
}, $71ea44806ef722bf$var$ht = {
    "Content-Type": "application/json"
}, $71ea44806ef722bf$var$pt = {
    "Content-Type": void 0
}, $71ea44806ef722bf$var$wt = (t)=>{
    if (!t || typeof t != "object") return null;
    const r = {};
    for (const { header: s, param: i } of (0, $avEQR.queryHeaderEntries)(t.query))r[s] = i;
    return {
        params: r,
        rpc: t.rpc === "get"
    };
}, $71ea44806ef722bf$var$gt = "content-type", $71ea44806ef722bf$export$e0f4c6d2a1e99ce0 = (t, r)=>{
    const s = Object.keys(r);
    if (!s.length) return t;
    const i = new URL(t);
    for (const o of s)i.searchParams.set(o, r[o]);
    return i.toString();
}, $71ea44806ef722bf$export$de27182ff8187d6c = async ({ url: t, headers: r, auth: s, fetchOptions: i, early: o, reads: d, seed: c })=>{
    if (!t) throw new Error("@symbo.ls/fetch rest: url is required");
    return $71ea44806ef722bf$export$f4134a2321012fb(t, r, s, i, o, d, c);
}, $71ea44806ef722bf$export$f4134a2321012fb = (t, r = {}, s, i = {}, o, d, c)=>{
    let $ = s?.token || null;
    const g = (0, $avEQR.openEarly)((0, $avEQR.withReads)(o, d), r, c), m = $71ea44806ef722bf$var$wt(d), R = (e)=>{
        if (!m) return null;
        const n = {}, a = {}, l = {};
        for(const u in e){
            const f = u.toLowerCase();
            if (f === "authorization") return null;
            if (f === $71ea44806ef722bf$var$gt) continue;
            a[u] = e[u];
            const y = m.params[f];
            y ? l[y] = e[u] : n[u] = e[u];
        }
        return {
            headers: n,
            adoptHeaders: a,
            query: l
        };
    }, Y = (e)=>{
        let n = "";
        for(const a in e){
            const l = a.toLowerCase();
            if (l === "accept-language") n = String(e[a]);
            else if (g.carried[l] !== e[a]) return null;
        }
        return n;
    }, N = (e, n)=>{
        if (!g) return null;
        const a = Y(n);
        if (a === null) return null;
        try {
            const l = e();
            return (0, $avEQR.takeEarly)((0, $avEQR.earlyKey)(l, a), g.maxAge) || (0, $kOTDQ.takeEarlySlice)(l, a, g.maxAge);
        } catch  {
            return null;
        }
    }, _ = (e, n, a)=>{
        if (!g) return null;
        const l = Y(n), u = a ?? "auto";
        if (l === null || !$71ea44806ef722bf$var$L.includes(u)) return null;
        try {
            return (0, $kOTDQ.adoptEarlyNow)((0, $avEQR.earlyKey)(e, l), e, l, g.maxAge, (f)=>$71ea44806ef722bf$var$I(f, u) || null);
        } catch  {
            return null;
        }
    }, J = (e, n, a, l, u, f, y)=>{
        if (!g || !g.seeded) return null;
        let S = "";
        for(const b in n){
            const p = b.toLowerCase();
            if (p === "accept-language") S = String(n[b]);
            else if (p !== "accept") return null;
        }
        try {
            return (0, $avEQR.takeEarly)((0, $avEQR.earlyKey)(e, S), g.maxAge, ()=>D(a, l, u, e, f, y));
        } catch  {
            return null;
        }
    }, F = (e, n, a, l, u, f, y)=>{
        if (!g || !g.seeded) return null;
        let S = "";
        for(const p in n){
            const h = p.toLowerCase();
            if (h === "accept-language") S = String(n[p]);
            else if (h !== "accept") return null;
        }
        const b = y ?? "auto";
        if (!$71ea44806ef722bf$var$L.includes(b)) return null;
        try {
            return (0, $bceDf.takeSeededNow)((0, $avEQR.earlyKey)(e, S), g.maxAge, ()=>D(a, l, u, e, f, y), (p)=>$71ea44806ef722bf$var$I(p, b) || null);
        } catch  {
            return null;
        }
    }, D = (e, n, a, l, u, f)=>({
            method: e,
            from: n,
            params: a,
            send: ()=>$71ea44806ef722bf$var$x(l, u, f, null)
        }), G = ()=>$ ? {
            Authorization: `Bearer ${$}`
        } : null, k = (e)=>$71ea44806ef722bf$var$W(r, G(), e), A = (e)=>({
            ...i,
            ...e
        }), T = (e, n, a)=>{
        if (!$71ea44806ef722bf$var$ft(n)) return A({
            method: e,
            headers: $71ea44806ef722bf$var$W(r, G(), $71ea44806ef722bf$var$ht, a),
            body: JSON.stringify(n)
        });
        const l = {
            method: e,
            headers: $71ea44806ef722bf$var$W(r, G(), $71ea44806ef722bf$var$pt, a),
            body: n
        };
        return $71ea44806ef722bf$var$v(n) === "ReadableStream" && (l.duplex = "half"), A(l);
    }, j = (e, n)=>{
        const a = n || t;
        if (e && (e.startsWith("http://") || e.startsWith("https://"))) return e;
        const l = e && !e.startsWith("/") ? "/" : "";
        return `${a}${l}${e || ""}`;
    };
    return {
        name: "rest",
        setToken: (e)=>{
            $ = e;
        },
        getSession: async ()=>{
            if (!s?.sessionUrl) return $ ? {
                token: $
            } : null;
            const e = await $71ea44806ef722bf$var$x(j(s.sessionUrl, s.baseUrl), A({
                headers: k()
            }));
            return e.error ? null : e.data;
        },
        signIn: async (e)=>{
            if (!s?.signInUrl) throw new Error("rest: auth.signInUrl not configured");
            const n = await $71ea44806ef722bf$var$x(j(s.signInUrl, s.baseUrl), T("POST", e));
            return n.data?.token && ($ = n.data.token), n;
        },
        signOut: async ()=>(s?.signOutUrl && await $71ea44806ef722bf$var$x(j(s.signOutUrl, s.baseUrl), A({
                method: "POST",
                headers: k()
            })), $ = null, {
                error: null
            }),
        select: ({ from: e, params: n, select: a, limit: l, offset: u, order: f, single: y, headers: S, baseUrl: b, responseType: p })=>{
            const h = $71ea44806ef722bf$export$b5cd97dee32de81d(b || t, e || "", $71ea44806ef722bf$export$b984dc8122fd896d({
                params: n,
                select: a,
                limit: l,
                offset: u,
                order: f,
                single: y
            })), P = k(S), w = R(P);
            if (w) {
                const O = A({
                    headers: w.headers
                }), U = $71ea44806ef722bf$export$e0f4c6d2a1e99ce0(h, w.query);
                return $71ea44806ef722bf$var$x(U, O, p, J(U, w.headers, "select", e, n, O, p) || N(()=>h, w.adoptHeaders));
            }
            const E = A({
                headers: P
            });
            return $71ea44806ef722bf$var$x(h, E, p, J(h, E.headers, "select", e, n, E, p) || N(()=>h, E.headers));
        },
        seeded: ({ method: e, from: n, params: a, select: l, limit: u, offset: f, order: y, single: S, headers: b, baseUrl: p, responseType: h, read: P })=>{
            if (!g) return null;
            if (e === "select") {
                const w = $71ea44806ef722bf$export$b5cd97dee32de81d(p || t, n || "", $71ea44806ef722bf$export$b984dc8122fd896d({
                    params: a,
                    select: l,
                    limit: u,
                    offset: f,
                    order: y,
                    single: S
                })), E = k(b), O = R(E);
                if (O) {
                    const Z = A({
                        headers: O.headers
                    });
                    return g.seeded && F($71ea44806ef722bf$export$e0f4c6d2a1e99ce0(w, O.query), O.headers, "select", n, a, Z, h) || _(w, O.adoptHeaders, h);
                }
                const U = A({
                    headers: E
                });
                return g.seeded && F(w, U.headers, "select", n, a, U, h) || _(w, U.headers, h);
            }
            if (e === "rpc") {
                if (!(P === !0 && m && m.rpc && (0, $avEQR.isScalarParams)(a))) return null;
                const w = R(k(b));
                if (!w) return null;
                let E;
                try {
                    E = $71ea44806ef722bf$export$b5cd97dee32de81d(p || t, `rpc/${n}`, a);
                } catch  {
                    return null;
                }
                const O = A({
                    method: "GET",
                    headers: w.headers
                });
                return g.seeded && F($71ea44806ef722bf$export$e0f4c6d2a1e99ce0(E, w.query), w.headers, "rpc", n, a, O, h) || _(E, w.adoptHeaders, h);
            }
            return null;
        },
        rpc: async ({ from: e, params: n, headers: a, baseUrl: l, responseType: u, read: f })=>{
            const y = (0, $avEQR.isScalarParams)(n), S = ()=>$71ea44806ef722bf$export$b5cd97dee32de81d(l || t, `rpc/${e}`, n), b = (U)=>$71ea44806ef722bf$var$x(j(`rpc/${e}`, l), T("POST", n, a), u, U), p = k(a), h = f === !0 && m && m.rpc && y ? R(p) : null;
            let P = null;
            if (h) try {
                P = S();
            } catch  {
                P = null;
            }
            if (!P) return b(g && g.rpc && y ? N(S, p) : null);
            const w = A({
                method: "GET",
                headers: h.headers
            }), E = $71ea44806ef722bf$export$e0f4c6d2a1e99ce0(P, h.query), O = await $71ea44806ef722bf$var$x(E, w, u, J(E, h.headers, "rpc", e, n, w, u) || N(()=>P, h.adoptHeaders));
            return O.status === 405 ? b(null) : O;
        },
        insert: ({ from: e, data: n, headers: a, baseUrl: l, responseType: u })=>$71ea44806ef722bf$var$x(j(e, l), T("POST", n, a), u),
        update: ({ from: e, data: n, params: a, method: l, headers: u, baseUrl: f, responseType: y })=>{
            const S = a?.id || n?.id, b = S ? `${e}/${S}` : e;
            return $71ea44806ef722bf$var$x(j(b, f), T(l || "PATCH", n, u), y);
        },
        upsert: ({ from: e, data: n, params: a, method: l, headers: u, baseUrl: f, responseType: y })=>{
            const S = a?.id || n?.id, b = S ? `${e}/${S}` : e;
            return $71ea44806ef722bf$var$x(j(b, f), T(l || "PUT", n, u), y);
        },
        delete: ({ from: e, params: n, headers: a, baseUrl: l, responseType: u })=>{
            const f = n?.id, y = f ? `${e}/${f}` : e;
            return $71ea44806ef722bf$var$x(j(y, l), A({
                method: "DELETE",
                headers: k(a)
            }), u);
        }
    };
};

});
parcelRegister("9ZqBV", function(module, exports) {

$parcel$export(module.exports, "requestStarted", () => $745e73ea34d8b92b$export$f115ce00601d045d);
$parcel$export(module.exports, "requestFinished", () => $745e73ea34d8b92b$export$10d6cc00767f8fe9);
$parcel$export(module.exports, "requestsInFlight", () => $745e73ea34d8b92b$export$2aa58f06081c58d9);
$parcel$export(module.exports, "whenRequestsIdle", () => $745e73ea34d8b92b$export$1862fda85eecc14f);
const $745e73ea34d8b92b$var$o = Symbol.for("@symbo.ls/fetch:IN_FLIGHT"), $745e73ea34d8b92b$var$s = ()=>globalThis[$745e73ea34d8b92b$var$o] || (globalThis[$745e73ea34d8b92b$var$o] = {
        count: 0,
        waiters: []
    }), $745e73ea34d8b92b$export$f115ce00601d045d = ()=>{
    $745e73ea34d8b92b$var$s().count++;
}, $745e73ea34d8b92b$export$10d6cc00767f8fe9 = ()=>{
    const t = $745e73ea34d8b92b$var$s();
    if (t.count = t.count > 0 ? t.count - 1 : 0, t.count === 0 && t.waiters.length) {
        const e = t.waiters;
        t.waiters = [];
        for (const n of e)n();
    }
}, $745e73ea34d8b92b$export$2aa58f06081c58d9 = ()=>$745e73ea34d8b92b$var$s().count, $745e73ea34d8b92b$export$1862fda85eecc14f = ()=>{
    const t = $745e73ea34d8b92b$var$s();
    return t.count === 0 ? Promise.resolve() : new Promise((e)=>{
        t.waiters.push(e);
    });
};

});


parcelRegister("jJAFY", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("h97Ux"))) : import("h97Ux")).then(()=>parcelRequire('lOfgC'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hMlqH", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6k2pq"))) : import("6k2pq")).then(()=>parcelRequire('efwpX'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});



parcelRegister("6Jwvb", function(module, exports) {

$parcel$export(module.exports, "captureSnapshot", () => $4e702840542c85f0$export$537d05c9e22d9551);

var $28ol3 = parcelRequire("28ol3");
const $4e702840542c85f0$var$p = {
    snapshotId: (0, $28ol3.createSnapshotId)
}, $4e702840542c85f0$export$537d05c9e22d9551 = (s, e)=>{
    const o = s.__ref, { currentSnapshot: a, calleeElement: t } = e;
    if (!t || t === s) {
        const r = $4e702840542c85f0$var$p.snapshotId();
        return o.__currentSnapshot = r, [
            r,
            s
        ];
    }
    const n = t.__ref.__currentSnapshot;
    return a < n ? [
        n,
        t,
        !0
    ] : [
        n,
        t
    ];
};

});

parcelRegister("850OO", function(module, exports) {

$parcel$export(module.exports, "UNIVERSAL_RESERVED_KEYS", () => $5e1f6ce95a1bebba$export$4576588f065b4083);
$parcel$export(module.exports, "isUniversallyReservedKey", () => $5e1f6ce95a1bebba$export$e8eb3f609e2673bd);
const $5e1f6ce95a1bebba$export$4576588f065b4083 = new Set([
    "__proto__",
    "constructor",
    "prototype",
    "_id",
    "__v",
    "id",
    "createdAt",
    "updatedAt",
    "schema"
]), $5e1f6ce95a1bebba$export$e8eb3f609e2673bd = (t)=>typeof t == "string" && $5e1f6ce95a1bebba$export$4576588f065b4083.has(t);

});

parcelRegister("dc7wk", function(module, exports) {

$parcel$export(module.exports, "evaluateText", () => $99b23ac626bff4f8$export$e79a9b7f6dbda391);
$parcel$export(module.exports, "markTextNotReady", () => $99b23ac626bff4f8$export$70002ae57ca72d18);
const $99b23ac626bff4f8$var$r = Symbol.for("@symbo.ls/utils:textReady"), $99b23ac626bff4f8$var$l = ()=>{
    let e = globalThis[$99b23ac626bff4f8$var$r];
    if (!e) {
        e = {
            depth: 0,
            ready: !0
        };
        try {
            Object.defineProperty(globalThis, $99b23ac626bff4f8$var$r, {
                value: e,
                configurable: !0
            });
        } catch  {
            globalThis[$99b23ac626bff4f8$var$r] = e;
        }
    }
    return e;
};
function $99b23ac626bff4f8$export$e79a9b7f6dbda391(e) {
    const t = $99b23ac626bff4f8$var$l(), a = t.ready;
    t.depth++, t.ready = !0;
    try {
        return {
            value: e(),
            ready: t.ready
        };
    } finally{
        t.depth--, t.ready = a;
    }
}
function $99b23ac626bff4f8$export$70002ae57ca72d18() {
    const e = globalThis[$99b23ac626bff4f8$var$r];
    e && e.depth > 0 && (e.ready = !1);
}

});

parcelRegister("5zSXA", function(module, exports) {

$parcel$export(module.exports, "elementPath", () => $40fada923f70bc1e$export$9f3e85f8c56feaaa);
const $40fada923f70bc1e$export$9f3e85f8c56feaaa = (n)=>{
    const t = n.__ref;
    if (t && t.__hydrationPath !== void 0) return t.__hydrationPath;
    const r = n.parent, a = r && r.__ref ? $40fada923f70bc1e$export$9f3e85f8c56feaaa(r) : null, _ = a === null ? "" : a ? a + "." + n.key : String(n.key);
    return t && (t.__hydrationPath = _), _;
};

});

parcelRegister("ao1Fr", function(module, exports) {

$parcel$export(module.exports, "HOST_SOURCES_GLOBAL", () => $78fd705ffff0669f$export$2390306ad5cbb2f4);
$parcel$export(module.exports, "HOST_PACKAGE_PATH_BASE", () => $78fd705ffff0669f$export$195d167ee94c651);
$parcel$export(module.exports, "hostPackageAssetPath", () => $78fd705ffff0669f$export$4527465b448fba62);
$parcel$export(module.exports, "HOST_SOURCES_TAG_ATTR", () => $78fd705ffff0669f$export$597c5808c8c42f56);
$parcel$export(module.exports, "HOST_PACKAGE_LOADER_KEY", () => $78fd705ffff0669f$export$4ea9bdc5392b4f7f);
$parcel$export(module.exports, "runtimeProvidesHostPackageLoader", () => $78fd705ffff0669f$export$89b60764f411b487);
$parcel$export(module.exports, "HOST_PACKAGE_ERROR_CODES", () => $78fd705ffff0669f$export$2a11a71987eedec6);
$parcel$export(module.exports, "LAZY_HOST_IMPORT_FORMS", () => $78fd705ffff0669f$export$7265364c77a18d46);
$parcel$export(module.exports, "isHostPackageSpecifier", () => $78fd705ffff0669f$export$efb559f8c0c1bfb2);
$parcel$export(module.exports, "lazyHostImportExpr", () => $78fd705ffff0669f$export$15da0c6657323ebc);
$parcel$export(module.exports, "classifyHostPackageReads", () => $78fd705ffff0669f$export$798b3be9b10ae607);
$parcel$export(module.exports, "hostPackageSourcesScript", () => $78fd705ffff0669f$export$24e6bfe9cdd547d5);
$parcel$export(module.exports, "hostPackageSourcesTag", () => $78fd705ffff0669f$export$ab244c7fd0cbcd86);

var $749b5 = parcelRequire("749b5");

const $78fd705ffff0669f$export$2390306ad5cbb2f4 = "__SMBLS_HOST_SOURCES__", $78fd705ffff0669f$export$195d167ee94c651 = (0, $749b5.SMBLS_PATH_PREFIX) + "host/", $78fd705ffff0669f$export$4527465b448fba62 = (t, s)=>{
    if (typeof s != "string" || !/^[0-9a-f]{16,}$/.test(s)) return "";
    const o = String(t || "").split("/").pop().replace(/[^A-Za-z0-9_-]/g, "") || "package";
    return $78fd705ffff0669f$export$195d167ee94c651 + o + "." + s.slice(0, 16) + ".js";
}, $78fd705ffff0669f$export$597c5808c8c42f56 = "data-smbls-host-packages", $78fd705ffff0669f$export$4ea9bdc5392b4f7f = "smbls.importHostPackage", $78fd705ffff0669f$export$89b60764f411b487 = (t)=>typeof t == "string" && t.includes($78fd705ffff0669f$export$4ea9bdc5392b4f7f), $78fd705ffff0669f$export$2a11a71987eedec6 = Object.freeze({
    UNKNOWN: "SMBLS_HOST_PACKAGE_UNKNOWN",
    NO_SOURCE: "SMBLS_HOST_PACKAGE_NO_SOURCE",
    NO_DOM: "SMBLS_HOST_PACKAGE_NO_DOM",
    NO_GLOBAL: "SMBLS_HOST_PACKAGE_NO_GLOBAL",
    LOAD_FAILED: "SMBLS_HOST_PACKAGE_LOAD_FAILED",
    TIMEOUT: "SMBLS_HOST_PACKAGE_TIMEOUT",
    NO_LOADER: "SMBLS_HOST_PACKAGE_NO_LOADER"
}), $78fd705ffff0669f$export$7265364c77a18d46 = Object.freeze([
    Object.freeze({
        prefix: "Promise.resolve(",
        suffix: ").then(function (__smblsSpec) { var __smblsHit = (globalThis.__SMBLS_PKGS__ || {})[__smblsSpec]; if (__smblsHit) return __smblsHit; var __smblsLoad = globalThis[Symbol.for('smbls.importHostPackage')]; if (typeof __smblsLoad === 'function') return __smblsLoad(__smblsSpec); throw Object.assign(new Error('[smbls] host package ' + __smblsSpec + ' cannot load on demand: no smbls runtime on the page provides importHostPackage'), { code: 'SMBLS_HOST_PACKAGE_NO_LOADER', specifier: __smblsSpec, retryable: false }) })"
    })
]), $78fd705ffff0669f$var$A = /^[A-Za-z0-9@._/-]{1,214}$/, $78fd705ffff0669f$export$efb559f8c0c1bfb2 = (t)=>typeof t == "string" && $78fd705ffff0669f$var$A.test(t), $78fd705ffff0669f$export$15da0c6657323ebc = (t)=>{
    if (!$78fd705ffff0669f$export$efb559f8c0c1bfb2(t)) throw new TypeError("[smbls] lazyHostImportExpr: not a package specifier: " + JSON.stringify(t));
    const s = $78fd705ffff0669f$export$7265364c77a18d46[$78fd705ffff0669f$export$7265364c77a18d46.length - 1];
    return s.prefix + "'" + t + "'" + s.suffix;
}, $78fd705ffff0669f$export$798b3be9b10ae607 = (t, s, e)=>{
    if (typeof t != "string" || typeof s != "string" || !s) return "none";
    const o = e && Number.isFinite(e.start) ? Math.max(0, e.start) : 0, _ = e && Number.isFinite(e.end) ? Math.min(t.length, e.end) : t.length;
    let r = 0, n = o;
    for(; n < _;){
        const a = t.indexOf(s, n);
        if (a === -1 || a + s.length > _) break;
        if (!$78fd705ffff0669f$var$L(t, s, a, o, _)) {
            n = a + s.length;
            continue;
        }
        const i = $78fd705ffff0669f$var$b(t, s, a, o, _);
        if (i === -1) return "static";
        r++, n = i;
    }
    return r > 0 ? "lazy" : "none";
}, $78fd705ffff0669f$var$O = "'\"`", $78fd705ffff0669f$var$E = /\\(?:u00(?:22|27|60)|x(?:22|27|60))$/i, $78fd705ffff0669f$var$L = (t, s, e, o, _)=>{
    const r = e === o || $78fd705ffff0669f$var$O.includes(t[e - 1]) || $78fd705ffff0669f$var$E.test(t.slice(Math.max(o, e - 6), e)), n = e + s.length, a = n === _ || $78fd705ffff0669f$var$O.includes(t[n]) || t[n] === "\\" || t[n] === "/";
    return r && a;
}, $78fd705ffff0669f$var$b = (t, s, e, o, _)=>{
    for (const r of $78fd705ffff0669f$export$7265364c77a18d46){
        const n = r.prefix + "'", a = "'" + r.suffix, i = e - n.length, S = e + s.length + a.length;
        if (!(i < o || S > _) && t.startsWith(n, i) && t.startsWith(a, e + s.length)) return S;
    }
    return -1;
}, $78fd705ffff0669f$var$T = /^[A-Za-z_$][A-Za-z0-9_$]*$/, $78fd705ffff0669f$var$m = (t)=>{
    if (!t || typeof t != "object") return null;
    const { src: s, integrity: e, global: o, version: _ } = t;
    if (typeof s != "string" || !s || /\s/.test(s) || typeof o != "string" || !$78fd705ffff0669f$var$T.test(o)) return null;
    const r = {
        src: s
    };
    return typeof e == "string" && e && (r.integrity = e), r.global = o, typeof _ == "string" && _ && (r.version = _), r;
}, $78fd705ffff0669f$var$d = (t)=>JSON.stringify(t).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029"), $78fd705ffff0669f$export$24e6bfe9cdd547d5 = (t)=>{
    if (!t || typeof t != "object") return "";
    const s = {};
    let e = !1;
    for (const o of Object.keys(t)){
        if (!$78fd705ffff0669f$export$efb559f8c0c1bfb2(o)) continue;
        const _ = $78fd705ffff0669f$var$m(t[o]);
        _ && (s[o] = _, e = !0);
    }
    return e ? "(function (g) { var s = g." + $78fd705ffff0669f$export$2390306ad5cbb2f4 + " || (g." + $78fd705ffff0669f$export$2390306ad5cbb2f4 + " = {}); var d = " + $78fd705ffff0669f$var$d(s) + "; for (var k in d) { if (!Object.prototype.hasOwnProperty.call(s, k)) s[k] = d[k] } })(typeof globalThis !== 'undefined' ? globalThis : window);" : "";
}, $78fd705ffff0669f$export$ab244c7fd0cbcd86 = (t)=>{
    const s = $78fd705ffff0669f$export$24e6bfe9cdd547d5(t);
    return s ? "<script " + $78fd705ffff0669f$export$597c5808c8c42f56 + '="lazy">' + s + "<\/script>" : "";
};

});
parcelRegister("749b5", function(module, exports) {

$parcel$export(module.exports, "SMBLS_PATH_PREFIX", () => $525006ac4acff647$export$d4b600024327a5ea);
$parcel$export(module.exports, "WORKER_SCRIPT_BASE", () => $525006ac4acff647$export$ab6a6139cbf8ed93);
$parcel$export(module.exports, "WORKER_SCRIPT_NAME", () => $525006ac4acff647$export$2d072c8752e3666f);
$parcel$export(module.exports, "workerScriptPath", () => $525006ac4acff647$export$d4bb0c3903b6f16c);
$parcel$export(module.exports, "workerNameFromPath", () => $525006ac4acff647$export$8ed83da242ad082);
const $525006ac4acff647$export$d4b600024327a5ea = "/__smbls/", $525006ac4acff647$export$ab6a6139cbf8ed93 = $525006ac4acff647$export$d4b600024327a5ea + "workers/", $525006ac4acff647$export$2d072c8752e3666f = /^[A-Za-z_$][\w$-]*$/, $525006ac4acff647$export$d4bb0c3903b6f16c = (t)=>$525006ac4acff647$export$ab6a6139cbf8ed93 + t + ".js", $525006ac4acff647$export$8ed83da242ad082 = (t)=>{
    if (typeof t != "string" || !t.startsWith($525006ac4acff647$export$ab6a6139cbf8ed93)) return null;
    const s = t.slice($525006ac4acff647$export$ab6a6139cbf8ed93.length);
    if (!s.endsWith(".js")) return null;
    const e = s.slice(0, -3);
    return $525006ac4acff647$export$2d072c8752e3666f.test(e) ? e : null;
};

});


parcelRegister("40QVJ", function(module, exports) {

$parcel$export(module.exports, "toggleFullscreen", () => $2ec0385abe18475e$export$1aba1ee5e6dc1474);
async function $2ec0385abe18475e$export$1aba1ee5e6dc1474(t) {
    if (document.fullscreenElement) await document.exitFullscreen();
    else try {
        await (this.node || document).requestFullscreen();
    } catch (e) {
        console.warn(`Error attempting to enable fullscreen mode: ${e.message} (${e.name})`);
    }
}

});

parcelRegister("bun4U", function(module, exports) {

$parcel$export(module.exports, "splitPackageSpecifier", () => $85d465e68ece8c69$export$a424cfc45d0d8828);
$parcel$export(module.exports, "CDN_PROVIDERS", () => $85d465e68ece8c69$export$14b025088496860c);
$parcel$export(module.exports, "PACKAGE_MANAGER_TO_CDN", () => $85d465e68ece8c69$export$1a8b9f70f9282ea1);
$parcel$export(module.exports, "getCdnProviderFromConfig", () => $85d465e68ece8c69$export$b5e67ffeac229970);
$parcel$export(module.exports, "stripVersionRangePrefix", () => $85d465e68ece8c69$export$b8f42296d1a089ec);
$parcel$export(module.exports, "getCDNUrl", () => $85d465e68ece8c69$export$8407093f131dcef1);
$parcel$export(module.exports, "getCDNDirUrl", () => $85d465e68ece8c69$export$da18e1348baf8d36);
$parcel$export(module.exports, "isUnresolvableDependency", () => $85d465e68ece8c69$export$58374e3b341c1e91);
$parcel$export(module.exports, "isMalformedDependency", () => $85d465e68ece8c69$export$4c8794f34acbde72);
$parcel$export(module.exports, "isValidDependencyMap", () => $85d465e68ece8c69$export$c19ee2cbea6cdebe);
$parcel$export(module.exports, "getImportMapScript", () => $85d465e68ece8c69$export$fe7cd7f7aa440aad);

const $85d465e68ece8c69$var$l = (t)=>t !== "latest" ? `@${t}` : "", $85d465e68ece8c69$var$i = (t)=>t ? `/${t}` : "", $85d465e68ece8c69$export$a424cfc45d0d8828 = (t)=>{
    const s = typeof t == "string" ? t.replace(/\/+$/, "") : "";
    if (!s) return {
        name: "",
        subpath: ""
    };
    const r = s.split("/"), e = s.startsWith("@") ? 2 : 1;
    return {
        name: r.slice(0, e).join("/"),
        subpath: r.slice(e).join("/")
    };
}, $85d465e68ece8c69$export$14b025088496860c = {
    skypack: {
        url: "https://cdn.skypack.dev",
        formatUrl: (t, s, r)=>`${$85d465e68ece8c69$export$14b025088496860c.skypack.url}/${t}${$85d465e68ece8c69$var$l(s)}${$85d465e68ece8c69$var$i(r)}`
    },
    esmsh: {
        url: "https://esm.sh",
        formatUrl: (t, s, r)=>`${$85d465e68ece8c69$export$14b025088496860c.esmsh.url}/${t}${$85d465e68ece8c69$var$l(s)}${$85d465e68ece8c69$var$i(r)}`
    },
    unpkg: {
        url: "https://unpkg.com",
        formatUrl: (t, s, r)=>`${$85d465e68ece8c69$export$14b025088496860c.unpkg.url}/${t}${$85d465e68ece8c69$var$l(s)}${$85d465e68ece8c69$var$i(r)}?module`
    },
    jsdelivr: {
        url: "https://cdn.jsdelivr.net/npm",
        formatUrl: (t, s, r)=>`${$85d465e68ece8c69$export$14b025088496860c.jsdelivr.url}/${t}${$85d465e68ece8c69$var$l(s)}${$85d465e68ece8c69$var$i(r)}/+esm`
    },
    symbols: {
        url: "https://pkg.symbo.ls",
        formatUrl: (t, s, r)=>`${$85d465e68ece8c69$export$14b025088496860c.symbols.url}/${t}${$85d465e68ece8c69$var$l(s)}${$85d465e68ece8c69$var$i(r)}/+esm`
    }
}, $85d465e68ece8c69$export$1a8b9f70f9282ea1 = {
    "esm.sh": "esmsh",
    unpkg: "unpkg",
    skypack: "skypack",
    jsdelivr: "jsdelivr",
    "pkg.symbo.ls": "symbols"
}, $85d465e68ece8c69$export$b5e67ffeac229970 = (t = {})=>{
    const { packageManager: s } = t;
    return $85d465e68ece8c69$export$1a8b9f70f9282ea1[s] || null;
}, $85d465e68ece8c69$export$b8f42296d1a089ec = (t)=>{
    if (typeof t != "string") return t;
    const s = t.trim().match(/^[\^~](\d.*)$/);
    return s ? s[1] : t;
}, $85d465e68ece8c69$export$8407093f131dcef1 = (t, s = "latest", r = "esmsh")=>{
    const e = $85d465e68ece8c69$export$14b025088496860c[r] || $85d465e68ece8c69$export$14b025088496860c.esmsh, { name: p, subpath: m } = $85d465e68ece8c69$export$a424cfc45d0d8828(t);
    return e.formatUrl(p || t, $85d465e68ece8c69$export$b8f42296d1a089ec(s), m);
}, $85d465e68ece8c69$export$da18e1348baf8d36 = (t, s = "latest", r = "esmsh")=>{
    const e = $85d465e68ece8c69$export$14b025088496860c[r] || $85d465e68ece8c69$export$14b025088496860c.esmsh, p = $85d465e68ece8c69$export$b8f42296d1a089ec(s), { name: m, subpath: c } = $85d465e68ece8c69$export$a424cfc45d0d8828(t);
    return `${e.url}/${m || t}${$85d465e68ece8c69$var$l(p)}${$85d465e68ece8c69$var$i(c)}/`;
}, $85d465e68ece8c69$var$_ = /^node:|^@symbo-ls\//, $85d465e68ece8c69$export$58374e3b341c1e91 = (t)=>typeof t == "string" && $85d465e68ece8c69$var$_.test(t), $85d465e68ece8c69$var$U = /[<>…]/, $85d465e68ece8c69$export$4c8794f34acbde72 = (t)=>typeof t == "string" && $85d465e68ece8c69$var$U.test(t), $85d465e68ece8c69$export$c19ee2cbea6cdebe = (t)=>!!t && typeof t == "object" && !Array.isArray(t), $85d465e68ece8c69$export$fe7cd7f7aa440aad = (t, s = "skypack", r = {})=>{
    const e = t.dependencies;
    if (!$85d465e68ece8c69$export$c19ee2cbea6cdebe(e)) return "";
    const p = Object.keys(e);
    if (!p.length) return "";
    const m = r.pin || {}, c = {};
    for (const n of p){
        if ($85d465e68ece8c69$export$58374e3b341c1e91(n) || $85d465e68ece8c69$export$4c8794f34acbde72(n)) continue;
        const a = m[n] || e[n] || "latest";
        c[n] = $85d465e68ece8c69$export$8407093f131dcef1(n, a, s), n.endsWith("/") || (c[n + "/"] = $85d465e68ece8c69$export$da18e1348baf8d36(n, a, s));
    }
    if (!Object.keys(c).length) return "";
    const g = '<script type="importmap">', y = "<\/script>", f = `{
    "imports": ${JSON.stringify(c, null, 2)}
  }`;
    return `${g}${f}${y}`;
};

});

parcelRegister("b6b22", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $8148cff697b1c83a$export$3ae94a2503e890a1);
const $8148cff697b1c83a$export$3ae94a2503e890a1 = (e)=>{
    if (!e) return "";
    const t = new Date(e), n = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(t), o = new Intl.DateTimeFormat("en", {
        month: "short"
    }).format(t);
    return `${new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(t)} ${o}, ${n}`;
};

});

parcelRegister("9G1Z5", function(module, exports) {

$parcel$export(module.exports, "detectHeightOnInit", () => $70b993580ebdb515$export$ffafacae975780e6);
const $70b993580ebdb515$export$ffafacae975780e6 = (e, t)=>{
    const r = setTimeout(()=>{
        const { props: n } = e;
        if (!t.clientHeight) {
            const { node: { clientHeight: i } } = e;
            i && (t.clientHeight = i);
        }
        if (t.active) {
            if (n.height === "auto") return;
            e.update({
                height: t.clientHeight
            }, {
                preventBeforeUpdateListener: !0,
                preventChildrenUpdate: !0
            });
            const i = setTimeout(()=>{
                e.update({
                    height: "auto"
                }, {
                    preventBeforeUpdateListener: !0,
                    preventChildrenUpdate: !0
                }), clearTimeout(i);
            }, 450);
        } else e.update({
            height: "0"
        }, {
            preventBeforeUpdateListener: !0,
            preventChildrenUpdate: !0
        });
        clearTimeout(r);
    });
};

});

parcelRegister("4FES3", function(module, exports) {

$parcel$export(module.exports, "fibonacciNumberByIndex", () => $366ab1ddb0a3710b$export$6d35f41941932cbd);
const $366ab1ddb0a3710b$export$6d35f41941932cbd = function(i) {
    const e = [
        0,
        1
    ];
    for(let c = 2; c <= i; c++)e[c] = e[c - 1] + e[c - 2];
    return e[i];
};

});

parcelRegister("5Jazt", function(module, exports) {

$parcel$export(module.exports, "isPhoto", () => $42b95aef763f99ed$export$722f9ea87a439ca4);
const $42b95aef763f99ed$export$722f9ea87a439ca4 = (t)=>[
        "jpeg",
        "gif",
        "jpg",
        "png",
        "tiff",
        "woff"
    ].includes(t);

});

parcelRegister("gdfnU", function(module, exports) {

$parcel$export(module.exports, "loadJavascriptFile", () => $bcd9cb4803aa93f6$export$f5254c626a3f7f04);
$parcel$export(module.exports, "loadJavascriptFileSync", () => $bcd9cb4803aa93f6$export$f846581269718859);
$parcel$export(module.exports, "loadJavascriptFileEmbedSync", () => $bcd9cb4803aa93f6$export$2e2cf34468b4616);
$parcel$export(module.exports, "loadCssFile", () => $bcd9cb4803aa93f6$export$adc703d835881894);
$parcel$export(module.exports, "loadJavascript", () => $bcd9cb4803aa93f6$export$8b7778d7ecfcc995);
$parcel$export(module.exports, "loadRemoteScript", () => $bcd9cb4803aa93f6$export$c432db100969a36b);
$parcel$export(module.exports, "loadRemoteCSS", () => $bcd9cb4803aa93f6$export$d146908f5d25486);
const $bcd9cb4803aa93f6$export$f5254c626a3f7f04 = (i, e = !1, a = document, o = "text/javascript")=>new Promise((s, r)=>{
        try {
            const n = a.createElement("script");
            n.type = o, n.async = e, n.src = i, n.addEventListener("load", (t)=>{
                s({
                    status: !0
                });
            }), n.addEventListener("error", (t)=>{
                r(new Error({
                    status: !1,
                    message: `Failed to load the script ${i}`
                }));
            }), a.body.appendChild(n);
        } catch (n) {
            r(n);
        }
    }), $bcd9cb4803aa93f6$export$f846581269718859 = (i, e = document, a = "text/javascript")=>new Promise((o, s)=>{
        const r = e.createElement("script");
        r.type = a, r.src = i;
        const n = e.createElement("div");
        n.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;", e.body.appendChild(n), r.onload = ()=>{
            e.body.removeChild(n), o();
        }, r.onerror = ()=>{
            e.body.removeChild(n), s(new Error(`Failed to load: ${i}`));
        }, e.body.appendChild(r);
    }), $bcd9cb4803aa93f6$export$2e2cf34468b4616 = (i, e = document, a, o = "text/javascript")=>{
    const s = new window.XMLHttpRequest;
    if (s.open("GET", i, !1), s.send(), s.status === 200) {
        const r = e.createElement("script");
        r.type = o, r.text = s.responseText, e.body.appendChild(r), typeof a == "function" && a();
    } else throw new Error(`Failed to load the script ${i}`);
}, $bcd9cb4803aa93f6$export$adc703d835881894 = (i, e = !1, a = document, o = "text/javascript")=>new Promise((s, r)=>{
        try {
            const n = a.createElement("link");
            n.rel = "stylesheet", n.href = i, n.addEventListener("load", (t)=>{
                s({
                    status: !0
                });
            }), a.head.appendChild(n);
        } catch (n) {
            r(n);
        }
    }), $bcd9cb4803aa93f6$export$8b7778d7ecfcc995 = (i, e = !1, a = document, o = "text/javascript", s = "smbls-script")=>{
    try {
        const r = a.createElement("script");
        r.type = o, r.async = e, r.id = s, r.innerHTML = i, a.body.appendChild(r);
    } catch (r) {
        console.warn(r);
    }
};
function $bcd9cb4803aa93f6$export$c432db100969a36b(i, e = {}) {
    const { window: a = globalThis } = e, { document: o = a.document } = e;
    return new Promise((s, r)=>{
        const n = o.querySelector(`script[src="${i}"]`);
        if (n) return s(n);
        const t = o.createElement("script");
        t.src = i, t.async = e.async === !0, t.type = e.type || "text/javascript", e.id && (t.id = e.id), e.integrity && (t.integrity = e.integrity), e.crossOrigin && (t.crossOrigin = e.crossOrigin), t.onload = ()=>{
            t.onerror = t.onload = null, s(t);
        }, t.onerror = ()=>{
            t.onerror = t.onload = null, r(new Error(`Failed to load script: ${i}`));
        }, o.head.appendChild(t);
    });
}
async function $bcd9cb4803aa93f6$export$d146908f5d25486(i, e = {}) {
    const { window: a = globalThis } = e, { document: o = a.document } = e;
    return new Promise((s, r)=>{
        const n = o.querySelector(`link[href="${i}"]`);
        if (n) return s(n);
        const t = o.createElement("link");
        t.href = i, t.rel = e.rel || "stylesheet", t.type = "text/css", t.media = e.media || "all", e.id && (t.id = e.id), e.integrity && (t.integrity = e.integrity), e.crossOrigin && (t.crossOrigin = e.crossOrigin), t.onload = ()=>{
            t.onerror = t.onload = null, s(t);
        }, t.onerror = ()=>{
            t.onerror = t.onload = null, r(new Error(`Failed to load stylesheet: ${i}`));
        }, o.head.appendChild(t);
    });
}

});

parcelRegister("eLA0f", function(module, exports) {

$parcel$export(module.exports, "escapeHtml", () => $ac0161ee7e4149f0$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "jsonForScript", () => $ac0161ee7e4149f0$export$43823005b7533a32);
$parcel$export(module.exports, "readJsonDataBlock", () => $ac0161ee7e4149f0$export$74e00eeea0f293d7);
$parcel$export(module.exports, "BRENDER_REGISTRY_BLOCK", () => $ac0161ee7e4149f0$export$109cdce7561175ec);
$parcel$export(module.exports, "BRENDER_REGISTRY_TREE_BLOCK", () => $ac0161ee7e4149f0$export$97516625093b2576);
$parcel$export(module.exports, "decodeBrenderRegistry", () => $ac0161ee7e4149f0$export$85d19d07114a360e);
$parcel$export(module.exports, "DESIGN_SYSTEM_LINK", () => $ac0161ee7e4149f0$export$6b83f132ccc9b185);
$parcel$export(module.exports, "DESIGN_SYSTEM_DEFERRED", () => $ac0161ee7e4149f0$export$4b79ec003cde8a2);
$parcel$export(module.exports, "DESIGN_SYSTEM_BLOCK", () => $ac0161ee7e4149f0$export$f2740a712848d63f);
$parcel$export(module.exports, "designSystemLink", () => $ac0161ee7e4149f0$export$16af04af82bbc067);
$parcel$export(module.exports, "designSystemBlock", () => $ac0161ee7e4149f0$export$e451ac3b6d7ffb78);
$parcel$export(module.exports, "BRENDER_STAMP_META", () => $ac0161ee7e4149f0$export$ae3b88e65c5a108d);
$parcel$export(module.exports, "brenderStampMeta", () => $ac0161ee7e4149f0$export$d731a8ea2eebcb26);
$parcel$export(module.exports, "readBrenderStamp", () => $ac0161ee7e4149f0$export$ac92b8479bcae607);
$parcel$export(module.exports, "BRENDER_LAZY_META", () => $ac0161ee7e4149f0$export$b91d6ff8b136f40e);
$parcel$export(module.exports, "brenderLazyMeta", () => $ac0161ee7e4149f0$export$83728a92dee37fb3);
$parcel$export(module.exports, "readBrenderLazyGroups", () => $ac0161ee7e4149f0$export$66d69859b7043b8);
$parcel$export(module.exports, "insertAfterImportMap", () => $ac0161ee7e4149f0$export$7f89bc5f958d5489);
$parcel$export(module.exports, "hashContent", () => $ac0161ee7e4149f0$export$2044196108155be5);
$parcel$export(module.exports, "generateHeadArrayTags", () => $ac0161ee7e4149f0$export$14af7038b75d1267);
$parcel$export(module.exports, "alternateLinkKey", () => $ac0161ee7e4149f0$export$bed7cb06e4881da3);
$parcel$export(module.exports, "faviconLinkKey", () => $ac0161ee7e4149f0$export$4567920a14d35245);
$parcel$export(module.exports, "themeColorKey", () => $ac0161ee7e4149f0$export$9e7d9ddf7526e1a7);
$parcel$export(module.exports, "HOST_FORCED_ATTR", () => $ac0161ee7e4149f0$export$e7f1c072b18ec950);
$parcel$export(module.exports, "HOST_FORCED_VALUE", () => $ac0161ee7e4149f0$export$ce92810fafe3f52);
$parcel$export(module.exports, "HOST_FORCED_ROBOTS", () => $ac0161ee7e4149f0$export$70e32431b046b601);
$parcel$export(module.exports, "generateMetaTags", () => $ac0161ee7e4149f0$export$1beeb737204e5202);
$parcel$export(module.exports, "fileEntryUrl", () => $ac0161ee7e4149f0$export$7e2a547957145cb7);
$parcel$export(module.exports, "resolveFileReferences", () => $ac0161ee7e4149f0$export$d49698a04f41960c);
$parcel$export(module.exports, "getPageMetadata", () => $ac0161ee7e4149f0$export$d6de83dbd93927be);

var $czfS0 = parcelRequire("czfS0");

var $gjNoZ = parcelRequire("gjNoZ");

var $7gmTd = parcelRequire("7gmTd");

var $cdzjF = parcelRequire("cdzjF");



var $5pnrT = parcelRequire("5pnrT");
const $ac0161ee7e4149f0$export$4cf11838cdc2a8a8 = (t)=>{
    if (t == null) return "";
    const r = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
    };
    return t.toString().replace(/[&<>"']/g, (e)=>r[e]);
}, $ac0161ee7e4149f0$export$43823005b7533a32 = (t)=>JSON.stringify(t).replace(/</g, "\\u003c").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029"), $ac0161ee7e4149f0$export$74e00eeea0f293d7 = (t, r, { remove: e = !1, warn: o } = {})=>{
    if (!t || typeof t.querySelector != "function") return null;
    let c = null;
    try {
        c = t.querySelector(r);
    } catch  {
        return null;
    }
    if (!c) return null;
    e && c.parentNode && c.parentNode.removeChild(c);
    let n;
    try {
        n = JSON.parse(c.textContent || "");
    } catch (i) {
        o && o(i);
    }
    return {
        value: n,
        block: c
    };
}, $ac0161ee7e4149f0$export$109cdce7561175ec = 'script[type="application/json"][data-brender="registry"]', $ac0161ee7e4149f0$export$97516625093b2576 = 'script[type="application/json"][data-brender="registry-tree"]', $ac0161ee7e4149f0$export$85d19d07114a360e = (t)=>{
    if (!(0, $czfS0.isObject)(t) || t.f !== "tree" || !Array.isArray(t.e) || t.e.length % 3) return null;
    const r = t.e, e = [], o = {};
    let c = 0;
    for(let n = 0, i = 0; n < r.length; n += 3, i++){
        const l = r[n], g = r[n + 1], h = r[n + 2];
        if (!Number.isInteger(l) || l < 0 || l > i || typeof g != "string" || !Number.isInteger(h)) return null;
        const d = l ? e[i - l] + "." + g : g;
        c += h, e.push(d), o[d] = "br-" + c;
    }
    return o;
}, $ac0161ee7e4149f0$export$6b83f132ccc9b185 = 'link[rel="preload"][data-smbls="design-system"]', $ac0161ee7e4149f0$export$4b79ec003cde8a2 = 'meta[name="smbls-design-system"][data-smbls="design-system"]', $ac0161ee7e4149f0$export$f2740a712848d63f = 'script[type="application/json"][data-smbls="design-system"]', $ac0161ee7e4149f0$var$U = (t)=>(0, $czfS0.isObject)(t) && (0, $czfS0.isObject)(t.config) && Array.isArray(t.rules), $ac0161ee7e4149f0$export$16af04af82bbc067 = (t, r)=>r && r.defer === !0 ? '<meta name="smbls-design-system" content="' + $ac0161ee7e4149f0$export$4cf11838cdc2a8a8(t) + '" data-smbls="design-system">' : '<link rel="preload" href="' + $ac0161ee7e4149f0$export$4cf11838cdc2a8a8(t) + '" as="fetch" crossorigin="anonymous" data-smbls="design-system">', $ac0161ee7e4149f0$export$e451ac3b6d7ffb78 = (t)=>$ac0161ee7e4149f0$var$U(t) ? '<script type="application/json" data-smbls="design-system">' + $ac0161ee7e4149f0$export$43823005b7533a32(t) + "<\/script>" : "", $ac0161ee7e4149f0$export$ae3b88e65c5a108d = 'meta[name="brender-stamp"]', $ac0161ee7e4149f0$export$d731a8ea2eebcb26 = ({ stamp: t, time: r } = {})=>'<meta name="brender-stamp" content="' + $ac0161ee7e4149f0$export$4cf11838cdc2a8a8(t) + '" data-time="' + (typeof r == "number" && isFinite(r) ? Math.round(r) : "") + '">', $ac0161ee7e4149f0$export$ac92b8479bcae607 = (t)=>{
    if (!t || typeof t.querySelector != "function") return null;
    let r = null;
    try {
        r = t.querySelector($ac0161ee7e4149f0$export$ae3b88e65c5a108d);
    } catch  {
        return null;
    }
    if (!r) return null;
    const e = parseInt(r.getAttribute("data-time"), 10);
    return {
        stamp: r.getAttribute("content") || "",
        time: isFinite(e) ? e : null
    };
}, $ac0161ee7e4149f0$export$b91d6ff8b136f40e = 'meta[name="brender-lazy"]', $ac0161ee7e4149f0$export$83728a92dee37fb3 = (t)=>{
    const r = Array.isArray(t) ? t.filter((e)=>typeof e == "string" && /^[^\s"<>&]+$/.test(e)) : [];
    return r.length ? '<meta name="brender-lazy" content="' + $ac0161ee7e4149f0$export$4cf11838cdc2a8a8(r.join(" ")) + '">' : "";
}, $ac0161ee7e4149f0$export$66d69859b7043b8 = (t)=>{
    if (!t || typeof t.querySelector != "function") return [];
    let r = null;
    try {
        r = t.querySelector($ac0161ee7e4149f0$export$b91d6ff8b136f40e);
    } catch  {
        return [];
    }
    return r ? String(r.getAttribute("content") || "").split(/\s+/).filter(Boolean) : [];
}, $ac0161ee7e4149f0$var$W = /<script\b(?:[^>"']|"[^"]*"|'[^']*')*\btype\s*=\s*["']?importmap["']?(?:[^>"']|"[^"]*"|'[^']*')*>[\s\S]*?<\/script\s*>/gi, $ac0161ee7e4149f0$export$7f89bc5f958d5489 = (t, r)=>{
    let e = -1;
    for (const o of String(t).matchAll($ac0161ee7e4149f0$var$W))e = o.index + o[0].length;
    return e === -1 ? null : t.slice(0, e) + `
  ` + r + t.slice(e);
}, $ac0161ee7e4149f0$var$O = (t)=>Object.entries(t || {}).filter(([r, e])=>e !== void 0).map(([r, e])=>`${r}="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(e)}"`).join(" "), $ac0161ee7e4149f0$export$2044196108155be5 = (t)=>{
    let r = 5381;
    const e = String(t);
    for(let o = 0; o < e.length; o++)r = (r * 33 ^ e.charCodeAt(o)) >>> 0;
    return r.toString(36);
}, $ac0161ee7e4149f0$var$Y = new Set([
    "jsonLd",
    "styles",
    "scripts"
]), $ac0161ee7e4149f0$var$H = new Set([
    "source"
]), $ac0161ee7e4149f0$export$14af7038b75d1267 = (t)=>{
    const r = [];
    if (Array.isArray(t.jsonLd)) for (const e of t.jsonLd){
        if (e == null) continue;
        const o = typeof e == "string" ? e : JSON.stringify(e), c = String(o).replace(/<\/script/gi, "<\\/script");
        r.push(`<script type="application/ld+json" data-smbls-jsonld="${$ac0161ee7e4149f0$export$2044196108155be5(o)}">${c}<\/script>`);
    }
    if (Array.isArray(t.styles)) for (const e of t.styles){
        if (e == null || !String(e).trim()) continue;
        const o = String(e).replace(/<\/style/gi, "<\\/style");
        r.push(`<style data-smbls-style="${$ac0161ee7e4149f0$export$2044196108155be5(o)}">${o}</style>`);
    }
    if (Array.isArray(t.scripts)) for (const e of t.scripts){
        if (!e) continue;
        const o = typeof e == "string", c = o ? e : e.src;
        if (!c && !e.body) continue;
        const n = [];
        c && n.push(`src="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(c)}"`), o || (e.type && n.push(`type="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(e.type)}"`), e.async && n.push("async"), e.defer && n.push("defer"), e.integrity && n.push(`integrity="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(e.integrity)}"`), e.crossorigin && n.push(`crossorigin="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(e.crossorigin)}"`), e.referrerpolicy && n.push(`referrerpolicy="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(e.referrerpolicy)}"`), e.nomodule && n.push("nomodule"));
        const i = ` data-smbls-script="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(c || $ac0161ee7e4149f0$export$2044196108155be5(e.body || ""))}"`;
        if (!o && e.body) {
            const l = String(e.body).replace(/<\/script/gi, "<\\/script");
            r.push(`<script ${n.join(" ")}${i}>${l}<\/script>`);
        } else r.push(`<script ${n.join(" ")}${i}><\/script>`);
    }
    return r;
}, $ac0161ee7e4149f0$export$bed7cb06e4881da3 = (t)=>`${t.hreflang || ""}|${t.href || ""}`, $ac0161ee7e4149f0$export$4567920a14d35245 = (t)=>(0, $czfS0.isObject)(t) ? $ac0161ee7e4149f0$export$2044196108155be5(JSON.stringify(t)) : String(t), $ac0161ee7e4149f0$export$9e7d9ddf7526e1a7 = (t)=>(0, $czfS0.isObject)(t) ? $ac0161ee7e4149f0$export$2044196108155be5(JSON.stringify(t)) : String(t), $ac0161ee7e4149f0$var$Q = (t, r, e)=>t === "favicons" ? Array.isArray(r) && (typeof e == "string" || (0, $czfS0.isObject)(e)) ? ` data-smbls-favicon="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8($ac0161ee7e4149f0$export$4567920a14d35245(e))}"` : "" : (t === "icon" || t === "favicon") && typeof r == "string" ? ` data-smbls-single-icon="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(r)}"` : "", $ac0161ee7e4149f0$var$X = (t)=>(0, $czfS0.isObject)(t) ? ` data-smbls-alternate="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8($ac0161ee7e4149f0$export$bed7cb06e4881da3(t))}"` : "", $ac0161ee7e4149f0$export$e7f1c072b18ec950 = "data-smbls-host", $ac0161ee7e4149f0$export$ce92810fafe3f52 = "forced", $ac0161ee7e4149f0$export$70e32431b046b601 = `meta[name="robots"][${$ac0161ee7e4149f0$export$e7f1c072b18ec950}="${$ac0161ee7e4149f0$export$ce92810fafe3f52}"]`, $ac0161ee7e4149f0$export$1beeb737204e5202 = (t, r)=>{
    const e = !r;
    e && (t = {
        ...t,
        robots: "noindex"
    });
    let o = !1;
    const c = Object.entries(t).reduce((n, [i, l])=>{
        if (!l && l !== 0 && l !== !1 || $ac0161ee7e4149f0$var$Y.has(i) || $ac0161ee7e4149f0$var$H.has(i)) return n;
        if (i === "title") return n.push(`<title>${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(l)}</title>`), n;
        if (i === "robots" && e) return n.push(`<meta name="robots" content="noindex" ${$ac0161ee7e4149f0$export$e7f1c072b18ec950}="${$ac0161ee7e4149f0$export$ce92810fafe3f52}">`), n;
        if (i === "canonical") return n.push(`<link rel="canonical" href="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(l)}">`), n;
        if (i === "manifest") return n.push(`<link rel="manifest" href="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(l)}">`), n;
        if (i === "favicon" || i === "favicons" || i === "icon" || i === "icons") return (Array.isArray(l) ? l : [
            l
        ]).forEach((s)=>{
            const y = $ac0161ee7e4149f0$var$Q(i, l, s);
            if (typeof s == "string") n.push(`<link rel="icon" href="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(s)}"${y}>`);
            else if (typeof s == "object") {
                const p = $ac0161ee7e4149f0$var$O(s);
                /rel=/.test(p) ? n.push(`<link ${p}${y}>`) : n.push(`<link rel="icon" ${p}${y}>`);
            }
        }), n;
        if (i === "alternate") return (Array.isArray(l) ? l : [
            l
        ]).forEach((s)=>{
            if (s && typeof s == "object") {
                const y = Object.entries(s).filter(([p, b])=>b !== void 0).map(([p, b])=>`${p}="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(b)}"`).join(" ");
                n.push(`<link rel="alternate" ${y}${$ac0161ee7e4149f0$var$X(s)}>`);
            }
        }), n;
        if (i === "theme-color" && Array.isArray(l)) return l.forEach((f)=>{
            if (!(0, $czfS0.isObject)(f)) return;
            const s = $ac0161ee7e4149f0$var$O({
                name: "theme-color",
                content: f.content,
                media: f.media
            });
            n.push(`<meta ${s} data-smbls-theme-color="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8($ac0161ee7e4149f0$export$9e7d9ddf7526e1a7(f))}">`);
        }), n;
        const g = (f, s, y = "name")=>{
            if (typeof s == "string" || typeof s == "number" || typeof s == "boolean") n.push(`<meta ${y}="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(f)}" content="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(s)}">`);
            else if (Array.isArray(s)) s.forEach((p)=>{
                if (typeof p == "string" || typeof p == "number" || typeof p == "boolean") n.push(`<meta ${y}="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(f)}" content="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(p)}">`);
                else if (typeof p == "object") {
                    const b = Object.entries(p).filter(([u, m])=>m !== void 0).map(([u, m])=>`${u}="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(m)}"`).join(" ");
                    n.push(`<meta ${b}>`);
                }
            });
            else if (typeof s == "object") {
                const p = Object.entries(s).filter(([b, u])=>u !== void 0).map(([b, u])=>`${b}="${$ac0161ee7e4149f0$export$4cf11838cdc2a8a8(u)}"`).join(" ");
                n.push(`<meta ${p}>`);
            }
        };
        if (i.startsWith("http-equiv:")) {
            const f = i.replace("http-equiv:", "");
            return g(f, l, "http-equiv"), n;
        }
        if (i.startsWith("itemprop:")) {
            const f = i.replace("itemprop:", "");
            return g(f, l, "itemprop"), n;
        }
        const d = [
            "og:",
            "twitter:",
            "fb:",
            "article:",
            "profile:",
            "book:",
            "business:",
            "music:",
            "product:",
            "video:",
            "DC:",
            "DCTERMS:"
        ].find((f)=>i.startsWith(f));
        if (d) {
            const f = i.replace(d, "");
            return g(`${d.replace(":", "")}:${f}`, l, d === "twitter:" || d === "DC:" || d === "DCTERMS:" ? "name" : "property"), n;
        }
        if (i.startsWith("apple:") || i.startsWith("msapplication:")) {
            const f = i.startsWith("apple:") ? "apple-" : "msapplication-", s = i.replace(/^apple:|^msapplication:/, "");
            return g(`${f}${s}`, l, "name"), n;
        }
        return i === "viewport" && (o = !0), g(i, l), n;
    }, [
        '<meta charset="UTF-8">'
    ]);
    return o || c.splice(1, 0, '<meta name="viewport" content="width=device-width, initial-scale=1">'), c.push(...$ac0161ee7e4149f0$export$14af7038b75d1267(t)), c.join(`
`);
}, $ac0161ee7e4149f0$var$k = (t)=>typeof t == "string" && t.length > 0 && !t.startsWith("/") && !t.startsWith("http"), $ac0161ee7e4149f0$var$A = (t)=>typeof t == "string" && t.length > 0, $ac0161ee7e4149f0$export$7e2a547957145cb7 = (t)=>{
    if (!t || typeof t != "object") return null;
    if ($ac0161ee7e4149f0$var$A(t.src)) return t.src;
    const r = t.content;
    return !r || typeof r != "object" ? null : $ac0161ee7e4149f0$var$A(r.src) ? r.src : $ac0161ee7e4149f0$var$A(r.storageUrl) ? r.storageUrl : null;
}, $ac0161ee7e4149f0$var$V = new Set([
    "icon",
    "favicon",
    "icons",
    "favicons"
]), $ac0161ee7e4149f0$var$x = (t, r)=>{
    if (typeof t == "string") return r(t);
    if (!(0, $czfS0.isObject)(t)) return t;
    const e = {
        ...t
    };
    return $ac0161ee7e4149f0$var$A(e.href) && (e.href = r(e.href)), $ac0161ee7e4149f0$var$A(e.src) && (e.src = r(e.src)), e;
};
function $ac0161ee7e4149f0$export$d49698a04f41960c(t, r) {
    if (!r || typeof r != "object") return t;
    const e = (c)=>!$ac0161ee7e4149f0$var$k(c) || !Object.prototype.hasOwnProperty.call(r, c) ? c : $ac0161ee7e4149f0$export$7e2a547957145cb7(r[c]) || c, o = {
        ...t
    };
    for (const [c, n] of Object.entries(o))$ac0161ee7e4149f0$var$V.has(c) ? o[c] = Array.isArray(n) ? n.map((i)=>$ac0161ee7e4149f0$var$x(i, e)) : $ac0161ee7e4149f0$var$x(n, e) : typeof n == "string" ? o[c] = e(n) : Array.isArray(n) && (o[c] = n.map((i)=>typeof i == "string" ? e(i) : i));
    return o;
}
function $ac0161ee7e4149f0$var$E(t, r) {
    if (!t || !r) return;
    const e = r.split(".");
    let o = t;
    for (const c of e){
        if (o == null || typeof o != "object") return;
        o = o[c];
    }
    return o;
}
function $ac0161ee7e4149f0$var$et(t, r) {
    const e = $ac0161ee7e4149f0$var$E(t, r);
    if (typeof e == "number") return Number.isFinite(e) ? e : void 0;
    if (typeof e == "string" && !(0, $gjNoZ.isStringFunction)(e)) return e;
}
function $ac0161ee7e4149f0$var$rt(t, r, e, o) {
    const n = (r.config || r.settings || {}).polyglot || r.polyglot, i = (0, $5pnrT.polyglotFallbackLang)(e?.lang, n), g = ((0, $5pnrT.polyglotTranslations)(r, n) || {})[i] || {}, h = [
        e?.state,
        o,
        r.state
    ].filter((s)=>s && typeof s == "object"), d = (s)=>{
        for (const y of h){
            const p = $ac0161ee7e4149f0$var$et(y, s);
            if (p !== void 0) return p;
        }
    }, f = {
        ...t
    };
    for (const [s, y] of Object.entries(f))typeof y != "string" || !y.includes("{{") || (f[s] = y.replace(/\{\{\s*([^|{}]+?)\s*(?:\|\s*(\w+)\s*)?\}\}/g, (p, b, u)=>{
        const m = b.trim();
        if (u === "polyglot") return g[m] ?? $ac0161ee7e4149f0$var$E(g, m) ?? p;
        if (u === "getLocalStateLang") return d(m + i) ?? p;
        const $ = d(m);
        return $ !== void 0 ? $ : g[m] ?? $ac0161ee7e4149f0$var$E(g, m) ?? p;
    }));
    return f;
}
function $ac0161ee7e4149f0$var$T(t) {
    if (!(0, $czfS0.isObject)(t)) return {};
    const r = {
        ...t
    };
    for (const [e, o] of Object.entries(r))if (typeof o == "function") {
        const c = o.toString(), n = c.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (n) {
            r[e] = `{{ ${n[1]} | getLocalStateLang }}`;
            continue;
        }
        const i = c.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (i) {
            r[e] = `{{ ${i[1]} | polyglot }}`;
            continue;
        }
        const l = c.match(/s\.(\w+(?:\.\w+)+)/);
        if (l) {
            r[e] = `{{ ${l[1]} }}`;
            continue;
        }
        delete r[e];
    } else if (typeof o == "string") {
        const c = o.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (c) {
            r[e] = `{{ ${c[1]} | getLocalStateLang }}`;
            continue;
        }
        const n = o.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (n) {
            r[e] = `{{ ${n[1]} | polyglot }}`;
            continue;
        }
        if (o.includes("=>") && o.includes("s.")) {
            const i = o.match(/s\.(\w+(?:\.\w+)+)/);
            if (i) {
                r[e] = `{{ ${i[1]} }}`;
                continue;
            }
        }
        (0, $gjNoZ.isStringFunction)(o) && delete r[e];
    }
    return r;
}
const $ac0161ee7e4149f0$var$D = (t)=>t.replace(/^\//, "").split("/"), $ac0161ee7e4149f0$var$nt = (t)=>{
    try {
        return decodeURIComponent(t);
    } catch  {
        return t;
    }
}, $ac0161ee7e4149f0$var$st = (t, r)=>{
    if (typeof t != "string" || typeof r != "string") return null;
    const e = $ac0161ee7e4149f0$var$D(r).filter(Boolean), o = {};
    return t !== "/*" && $ac0161ee7e4149f0$var$D(t).forEach((c, n)=>{
        const i = /^:(.+)/.exec(c);
        i && e[n] && (o[i[1]] = $ac0161ee7e4149f0$var$nt(e[n]));
    }), {
        route: t,
        routePath: "/" + (e[0] || ""),
        params: o
    };
}, $ac0161ee7e4149f0$var$ot = (t, r)=>(0, $7gmTd.sharedLibraryBagEntry)("components", r, t.components, t.sharedLibraries);
function $ac0161ee7e4149f0$export$d6de83dbd93927be(t, r, e, { isProduction: o = !1, channel: c = "production" } = {}) {
    const n = t.pages?.[r], i = (0, $czfS0.isObject)(n?.state) && n?.state, l = (0, $cdzjF.routeEntryMetadata)(n, (u)=>$ac0161ee7e4149f0$var$ot(t, u)) || i || {}, g = $ac0161ee7e4149f0$var$T(l), h = new Set(Object.keys(g)), d = t.app?.metadata || {}, f = $ac0161ee7e4149f0$var$T(d);
    let s = {};
    if (t.integrations?.seo ? s = {
        ...t.integrations.seo,
        ...f,
        ...g
    } : Object.keys(f).length ? s = {
        ...f,
        ...g
    } : s = {
        ...g
    }, !s.title) {
        const u = t.name || t.key;
        u ? o ? s.title = u : c === "development" ? s.title = `${u} / dev:symbo.ls` : c === "staging" ? s.title = `${u} / staging:symbo.ls` : s.title = `${u} / symbo.ls` : s.title = "Symbols demo";
    }
    s = $ac0161ee7e4149f0$var$rt(s, t, e, $ac0161ee7e4149f0$var$st(r, e?.actualPathname)), s.title && (h.has("title") || !s["og:title"]) && (h.has("og:title") || (s["og:title"] = s.title)), s.description && (h.has("description") || !s["og:description"]) && (h.has("og:description") || (s["og:description"] = s.description)), s.title && !s["twitter:title"] && (s["twitter:title"] = s.title), s.description && !s["twitter:description"] && (s["twitter:description"] = s.description);
    const y = h.has("og:url") ? s["og:url"] : h.has("url") ? s.url : void 0, p = e?.actualPathname || r;
    if (y) s["og:url"] = y;
    else if (s["og:url"] || s.url) {
        const u = (s["og:url"] || s.url || "").replace(/\/$/, "");
        if (u && p && p !== "/") {
            const m = p.startsWith("/") ? p : "/" + p;
            s["og:url"] = u + m;
        }
    }
    s = $ac0161ee7e4149f0$export$d49698a04f41960c(s, (0, $7gmTd.sharedLibraryFiles)(t.files, t.sharedLibraries));
    const b = t.name || t.app?.metadata?.title || t.app?.name || "";
    for (const [u, m] of Object.entries(s))if (typeof m == "string" && m.includes("{{")) {
        const $ = m.replace(/\{\{[^}]*\}\}/g, "").trim();
        $ ? s[u] = $ : u === "title" ? s[u] = b : delete s[u];
    }
    return s;
}

});
parcelRegister("7gmTd", function(module, exports) {

$parcel$export(module.exports, "normalizeLibraryKey", () => $549bc87046462fe7$export$8254761f7cf4c0e0);
$parcel$export(module.exports, "deepDefaults", () => $549bc87046462fe7$export$62d7a9f86a83f052);
$parcel$export(module.exports, "normalizeIgnoreList", () => $549bc87046462fe7$export$83151c6fb65b8376);
$parcel$export(module.exports, "sharedLibrary", () => $549bc87046462fe7$export$fb2516c7a81b56f4);
$parcel$export(module.exports, "isWrappedLibrary", () => $549bc87046462fe7$export$44738c829197fd45);
$parcel$export(module.exports, "__resetBuiltinMethodWarnings", () => $549bc87046462fe7$export$fff5f1a0a674e455);
$parcel$export(module.exports, "LIBRARY_SCOPES_KEY", () => $549bc87046462fe7$export$2fa805cc314a53ac);
$parcel$export(module.exports, "bindLibraryGlobalScopes", () => $549bc87046462fe7$export$d3d1283babad0132);
$parcel$export(module.exports, "bareLibraryKey", () => $549bc87046462fe7$export$b2e7fc8a3bd3ae9f);
$parcel$export(module.exports, "librarySpecsFor", () => $549bc87046462fe7$export$49bfc5fe1bf6e07c);
$parcel$export(module.exports, "libraryPackageSpecs", () => $549bc87046462fe7$export$749cab5d7099972c);
$parcel$export(module.exports, "warnLibraryAliasCollision", () => $549bc87046462fe7$export$7a97c6aa71f46867);
$parcel$export(module.exports, "LIBRARY_PACKAGES", () => $549bc87046462fe7$export$77da5ddbcec3aec5);
$parcel$export(module.exports, "exposeBagGlobalScopes", () => $549bc87046462fe7$export$713b92c67ba03ad2);
$parcel$export(module.exports, "mergeSharedLibraries", () => $549bc87046462fe7$export$b9e6b90332b83419);
$parcel$export(module.exports, "sharedLibraryFiles", () => $549bc87046462fe7$export$4d3e70706128d912);
$parcel$export(module.exports, "sharedLibraryDependencies", () => $549bc87046462fe7$export$ca97f6691f226c13);
$parcel$export(module.exports, "servedSharedLibraries", () => $549bc87046462fe7$export$864fd6e0404d37ab);
$parcel$export(module.exports, "sharedLibraryBagEntry", () => $549bc87046462fe7$export$9d09d5e7fb92b5e6);
$parcel$export(module.exports, "mergeSharedLibraryDesignSystems", () => $549bc87046462fe7$export$2aaefd95de023181);
$parcel$export(module.exports, "mergeSharedLibraryTranslations", () => $549bc87046462fe7$export$812bdcf565c9516c);
$parcel$export(module.exports, "fetchLibraryData", () => $549bc87046462fe7$export$68e1f259e57c59d);
$parcel$export(module.exports, "resolveSharedLibraries", () => $549bc87046462fe7$export$d79adda69733feb);

var $czfS0 = parcelRequire("czfS0");

var $cjyfe = parcelRequire("cjyfe");

var $dSdIt = parcelRequire("dSdIt");

var $2C0hZ = parcelRequire("2C0hZ");



var $5pnrT = parcelRequire("5pnrT");

var $5UBxb = parcelRequire("5UBxb");
const $549bc87046462fe7$var$N = "system", $549bc87046462fe7$var$Bn = "https://smbls-kv.nika-980.workers.dev", $549bc87046462fe7$var$$n = "https://api.symbols.app", $549bc87046462fe7$var$Tn = "/v1/library-icons/";
function $549bc87046462fe7$export$8254761f7cf4c0e0(n) {
    const t = String(n || "").trim();
    if (!t) return {
        owner: $549bc87046462fe7$var$N,
        key: "",
        full: ""
    };
    let o = null, e = t;
    if (t.includes("/")) {
        const s = t.indexOf("/");
        o = t.slice(0, s), e = t.slice(s + 1);
    }
    e = e.replace(/\.symbo\.ls$/iu, ""), o || (o = $549bc87046462fe7$var$N);
    const r = e ? `${o}/${e}` : "";
    return {
        owner: o,
        key: e,
        full: r
    };
}
const $549bc87046462fe7$var$d = (n, t)=>Object.prototype.hasOwnProperty.call(n, t), $549bc87046462fe7$var$_ = (0, $cjyfe.PROTOTYPE_KEYS), $549bc87046462fe7$var$jn = (n)=>(0, $czfS0.isObject)(n) || n !== null && typeof n == "object" && !Array.isArray(n) && Object.getPrototypeOf(n) === null, $549bc87046462fe7$var$g = (n, t, o, e)=>{
    const r = Array.isArray(n);
    if (!r && !$549bc87046462fe7$var$jn(n)) return n;
    if (e && e.has(n)) return e.get(n);
    const s = e || new Map, c = r ? [] : {};
    if (s.set(n, c), r) for(let i = 0; i < n.length; i++)c[i] = $549bc87046462fe7$var$g(n[i], t, o, s);
    else for(const i in n){
        if (!$549bc87046462fe7$var$d(n, i) || $549bc87046462fe7$var$_.has(i)) continue;
        const a = o ? `${o}/${i}` : i;
        t && t.has(a) || (c[i] = $549bc87046462fe7$var$g(n[i], t, a, s));
    }
    return s.delete(n), c;
}, $549bc87046462fe7$export$62d7a9f86a83f052 = (n, t, o, e)=>{
    for(const r in t){
        if (!$549bc87046462fe7$var$d(t, r) || $549bc87046462fe7$var$_.has(r)) continue;
        const s = e ? `${e}/${r}` : r;
        o && o.has(s) || (r in n ? (0, $czfS0.isObject)(n[r]) && (0, $czfS0.isObject)(t[r]) && $549bc87046462fe7$export$62d7a9f86a83f052(n[r], t[r], o, s) : n[r] = $549bc87046462fe7$var$g(t[r], o, s));
    }
}, $549bc87046462fe7$var$A = (n, t, o)=>{
    if (!(0, $czfS0.isObject)(n) || !t.size) return n;
    const e = `${o}/`;
    let r = !1;
    for (const c of t)if (c.startsWith(e)) {
        r = !0;
        break;
    }
    if (!r) return n;
    const s = {};
    for(const c in n){
        if (!Object.prototype.hasOwnProperty.call(n, c) || $549bc87046462fe7$var$_.has(c)) continue;
        const i = `${o}/${c}`;
        t.has(i) || (s[c] = $549bc87046462fe7$var$A(n[c], t, i));
    }
    return s;
}, $549bc87046462fe7$var$Dn = (n, t)=>{
    if (n !== t || !(0, $czfS0.isObject)(n)) return n;
    const o = {};
    for(const e in n)$549bc87046462fe7$var$d(n, e) && !$549bc87046462fe7$var$_.has(e) && (o[e] = n[e]);
    return o;
}, $549bc87046462fe7$var$W = new Set, $549bc87046462fe7$var$Pn = new Set([
    "components",
    "pages",
    "functions",
    "snippets",
    "methods"
]), $549bc87046462fe7$var$k = (n, t)=>t === "" && $549bc87046462fe7$var$Pn.has(n), $549bc87046462fe7$var$B = [
    "fontFamily",
    "fontfamily",
    "font_family",
    "FONT_FAMILY"
], $549bc87046462fe7$var$z = (n)=>{
    const t = new Map;
    if (!(0, $czfS0.isObject)(n)) return t;
    for (const o of $549bc87046462fe7$var$B){
        const e = n[o];
        if ((0, $czfS0.isObject)(e)) for(const r in e)!(0, $czfS0.isObject)(e[r]) || !e[r].isDefault || (t.has(o) || t.set(o, new Set), t.get(o).add(r));
    }
    return t;
}, $549bc87046462fe7$var$J = (n, t)=>{
    for (const o of $549bc87046462fe7$var$B){
        const e = n[o];
        if (!(0, $czfS0.isObject)(e)) continue;
        const r = t.get(o);
        let s = null;
        for(const c in e){
            const i = e[c];
            if (!(0, $czfS0.isObject)(i) || !i.isDefault || r && r.has(c)) continue;
            const a = {
                ...i
            };
            delete a.isDefault, s || (s = {
                ...e
            }), s[c] = a;
        }
        s && (n[o] = s);
    }
}, $549bc87046462fe7$var$Nn = (n)=>{
    const t = new Map;
    if (!(0, $czfS0.isObject)(n)) return t;
    for (const o of $549bc87046462fe7$var$B){
        const e = n[o];
        (0, $czfS0.isObject)(e) && t.set(o, new Set(Object.keys(e)));
    }
    return t;
}, $549bc87046462fe7$var$q = (n, t)=>{
    if ((0, $czfS0.isObject)(n)) for (const o of $549bc87046462fe7$var$B){
        const e = n[o];
        if (!(0, $czfS0.isObject)(e)) continue;
        const r = t.get(o);
        let s = null;
        for(const c in e){
            const i = e[c];
            !(0, $czfS0.isObject)(i) || i.isSharedLibrary || r && r.has(c) || (s || (s = {
                ...e
            }), s[c] = {
                ...i,
                isSharedLibrary: !0
            });
        }
        s && (n[o] = s);
    }
}, $549bc87046462fe7$var$Mn = (n)=>n.replace(/\.js$/iu, ""), $549bc87046462fe7$export$83151c6fb65b8376 = (n)=>{
    const t = new Set;
    if (!Array.isArray(n)) return t;
    for (const o of n){
        if (!(0, $czfS0.isString)(o)) continue;
        const e = o.split("/").map((r)=>$549bc87046462fe7$var$Mn(r.trim())).filter(Boolean).join("/");
        e && t.add(e);
    }
    return t;
}, $549bc87046462fe7$export$fb2516c7a81b56f4 = (n, t = {})=>({
        library: n,
        ignoreList: Array.isArray(t.ignoreList) ? t.ignoreList : []
    }), $549bc87046462fe7$export$44738c829197fd45 = (n)=>(0, $czfS0.isObject)(n) && Array.isArray(n.ignoreList) && ("library" in n || "key" in n || "name" in n), $549bc87046462fe7$var$X = (n)=>n.library !== void 0 ? n.library : n.key ?? n.name, $549bc87046462fe7$var$U = new Set, $549bc87046462fe7$export$fff5f1a0a674e455 = ()=>{
    $549bc87046462fe7$var$U.clear();
}, $549bc87046462fe7$var$Fn = (n, t)=>{
    const o = t.filter((e)=>!$549bc87046462fe7$var$U.has(e));
    if (o.length) {
        for (const e of o)$549bc87046462fe7$var$U.add(e);
        (0, $dSdIt.isLoudDevRuntime)() && console.warn(`[smbls] shared library "${n}" ships ${o.map((e)=>`methods.${e}`).join(", ")} \u2014 named like a built-in element method. Refused: the built-in wins; a library cannot replace an element method on the consuming app. If the app wants this version, declare it in the app's OWN methods.`);
    }
}, $549bc87046462fe7$var$Un = (n, t, o)=>{
    let e = null;
    for(const r in n)if ((0, $cjyfe.isProtectedElementMethod)(r) && (t.has(`methods/${r}`) || o.push(r), !e)) {
        e = {};
        for(const s in n)!$549bc87046462fe7$var$d(n, s) || $549bc87046462fe7$var$_.has(s) || (0, $cjyfe.isProtectedElementMethod)(s) || (e[s] = n[s]);
    }
    return e || n;
}, $549bc87046462fe7$var$m = (n, t)=>{
    const o = $549bc87046462fe7$export$83151c6fb65b8376(n.sharedLibIgnore);
    return n.sharePages === !1 && o.add("pages"), o.size ? new Set([
        ...t,
        ...o
    ]) : t;
}, $549bc87046462fe7$var$C = [
    "functions",
    "methods",
    "snippets"
], $549bc87046462fe7$var$Z = [
    "components",
    "pages"
], $549bc87046462fe7$var$Q = Symbol.for("smbls.libraryScope"), $549bc87046462fe7$export$2fa805cc314a53ac = "__libraryScopes", $549bc87046462fe7$var$V = new Map, $549bc87046462fe7$var$Cn = ()=>Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4), $549bc87046462fe7$var$Vn = /const __scope = |const __peers_* = |const _s_* = el\?\.scope|\?\.context\?\.globalScope\?\./, $549bc87046462fe7$var$x = (n)=>{
    try {
        return (0, $2C0hZ.getFunctionSource)(n);
    } catch  {
        return null;
    }
}, $549bc87046462fe7$var$v = (n)=>{
    if (typeof n != "function") return null;
    const t = $549bc87046462fe7$var$x(n);
    return (0, $czfS0.isString)(t) && $549bc87046462fe7$var$Vn.test(t) && (0, $2C0hZ.hasFunction)(t) ? t : null;
}, $549bc87046462fe7$var$nn = (n)=>(0, $czfS0.isString)(n) && (0, $2C0hZ.hasFunction)(n) || $549bc87046462fe7$var$v(n) !== null, $549bc87046462fe7$var$Gn = (n)=>{
    const t = n.globalScope;
    return (0, $czfS0.isObject)(t) && Object.keys(t).some((o)=>$549bc87046462fe7$var$nn(t[o])) ? !0 : $549bc87046462fe7$var$C.some((o)=>{
        const e = n[o];
        return !!e && typeof e == "object" && Object.keys(e).some((r)=>$549bc87046462fe7$var$nn(e[r]));
    });
}, $549bc87046462fe7$var$Hn = (n, t, o)=>{
    const e = n.globalScope, r = t.globalScope;
    if (o.has("globalScope") || !(0, $czfS0.isObject)(e) || !(0, $czfS0.isObject)(r) || !$549bc87046462fe7$var$Gn(t)) return 0;
    let s = 0;
    for (const c of Object.keys(r))o.has(`globalScope/${c}`) || $549bc87046462fe7$var$d(e, c) && s++;
    return s;
}, $549bc87046462fe7$var$Yn = [
    [
        /const __scope = (\(\(\) => \{ const r = [\s\S]*?\}\)\(\));/g,
        "const __scope = $RESOLVE($1);"
    ],
    [
        /const __scope = this \?\? \{\};/g,
        "const __scope = $RESOLVE(this ?? {});"
    ],
    [
        /const (__peers_*) = (this && this !== globalThis && this\.context && this\.context\.globalScope \? this\.scope \?\? this\.context\.globalScope : this);/g,
        "const $1 = $RESOLVE($2);"
    ],
    [
        /const (_s_*) = (el\?\.scope \?\? el\?\.context\?\.globalScope \?\? \{\});/g,
        "const $1 = $RESOLVE($2);"
    ],
    [
        /(?<![\w$.])(this|[A-Za-z_$][\w$]*)\?\.context\?\.globalScope\?\./g,
        "$RESOLVE($1?.context?.globalScope)?."
    ]
], $549bc87046462fe7$var$Kn = (n)=>{
    const t = n.split(""), o = [];
    let e = 0, r = 0;
    const s = (i, a)=>{
        for(let u = i; u < a; u++)t[u] !== `
` && (t[u] = "~");
    }, c = ()=>{
        const i = e;
        for(; e < n.length;){
            const a = n[e];
            if (a === "\\") {
                e += 2;
                continue;
            }
            if (a === "`") {
                s(i, e), e++;
                return;
            }
            if (a === "$" && n[e + 1] === "{") {
                s(i, e), e += 2, o.push(r), r++;
                return;
            }
            e++;
        }
        s(i, e);
    };
    for(; e < n.length;){
        const i = n[e];
        if (i === "/" && n[e + 1] === "/") {
            const a = n.indexOf(`
`, e), u = a === -1 ? n.length : a;
            s(e, u), e = u;
            continue;
        }
        if (i === "/" && n[e + 1] === "*") {
            const a = n.indexOf("*/", e + 2), u = a === -1 ? n.length : a + 2;
            s(e, u), e = u;
            continue;
        }
        if (i === '"' || i === "'") {
            const a = i, u = ++e;
            for(; e < n.length && n[e] !== a && n[e] !== `
`;)n[e] === "\\" && e++, e++;
            s(u, e), e++;
            continue;
        }
        if (i === "`") {
            e++, c();
            continue;
        }
        if (i === "{") {
            r++, e++;
            continue;
        }
        if (i === "}") {
            if (r--, o.length && r === o[o.length - 1]) {
                o.pop(), e++, c();
                continue;
            }
            e++;
            continue;
        }
        e++;
    }
    return t.join("");
}, $549bc87046462fe7$var$en = (n, t)=>{
    if (!(0, $czfS0.isString)(n) || !n.includes("__scope = ") && !n.includes("__peers") && !/const _s_* = /.test(n) && !n.includes("?.context?.globalScope?.") || !(0, $2C0hZ.hasFunction)(n)) return n;
    const o = `(globalThis[Symbol.for('smbls.libraryScope')] || ((_, v) => v))(${JSON.stringify(t)}, `;
    let e = n;
    for (const [r, s] of $549bc87046462fe7$var$Yn){
        const c = $549bc87046462fe7$var$Kn(e);
        e = e.replace(r, (...i)=>{
            const a = i[i.length - 2];
            return c[a] === "~" || c[a] !== e[a] ? i[0] : s.replace(/\$RESOLVE\(/g, o).replace(/\$(\d)/g, (u, f)=>i[Number(f)]);
        });
    }
    return e;
}, $549bc87046462fe7$var$G = (n, t)=>{
    if ((0, $czfS0.isString)(n)) return $549bc87046462fe7$var$en(n, t);
    const o = $549bc87046462fe7$var$v(n);
    return o === null ? n : $549bc87046462fe7$var$en(o, t);
}, $549bc87046462fe7$var$Wn = {
    lazy: !0,
    window: globalThis
}, $549bc87046462fe7$var$tn = (n, t)=>{
    const o = $549bc87046462fe7$var$G(n, t);
    if (o === n || !(0, $czfS0.isString)(o)) return o;
    try {
        const e = (0, $2C0hZ.deepDestringifyFunctions)({
            v: o
        }, {}, $549bc87046462fe7$var$Wn).v;
        return typeof e != "function" ? o : (Object.defineProperty(e, "toJSON", {
            value: ()=>o,
            configurable: !0
        }), e);
    } catch  {
        return o;
    }
}, $549bc87046462fe7$var$H = (n)=>{
    if (!n || typeof n != "object") return !1;
    if (Array.isArray(n)) return !0;
    const t = Object.getPrototypeOf(n);
    return t === Object.prototype || t === null;
}, $549bc87046462fe7$var$zn = (n, t)=>{
    const o = new WeakMap, e = (r)=>{
        if ((0, $czfS0.isString)(r) || typeof r == "function") return $549bc87046462fe7$var$tn(r, t);
        if ((0, $2C0hZ.isStringTag)(r) || !$549bc87046462fe7$var$H(r)) return r;
        if (o.has(r)) return o.get(r);
        const s = Array.isArray(r) ? [] : Object.getPrototypeOf(r) === null ? Object.create(null) : {};
        o.set(r, s);
        for (const c of Object.keys(r))$549bc87046462fe7$var$_.has(c) || (s[c] = e(r[c]));
        return s;
    };
    return e(n);
}, $549bc87046462fe7$var$Jn = (n, t)=>{
    const o = {
        ...n
    };
    o.globalScope = $549bc87046462fe7$var$rn(n.globalScope, t);
    for (const e of $549bc87046462fe7$var$C){
        const r = n[e];
        if (!$549bc87046462fe7$var$H(r)) continue;
        const s = {};
        for (const c of Object.keys(r))$549bc87046462fe7$var$_.has(c) || (s[c] = $549bc87046462fe7$var$tn(r[c], t));
        o[e] = s;
    }
    for (const e of $549bc87046462fe7$var$Z)$549bc87046462fe7$var$H(n[e]) && (o[e] = $549bc87046462fe7$var$zn(n[e], t));
    return o;
}, $549bc87046462fe7$var$on = new WeakMap, $549bc87046462fe7$var$qn = (n, t, o)=>{
    let e = $549bc87046462fe7$var$on.get(n);
    e || $549bc87046462fe7$var$on.set(n, e = new Map);
    let r = e.get(t);
    if (r) return r;
    const s = (c, i)=>$549bc87046462fe7$var$d(o, c) && o[c] === i;
    return r = new Proxy(n, {
        get (c, i) {
            if (typeof i == "symbol" || $549bc87046462fe7$var$d(c, i)) return Reflect.get(c, i);
            const a = Reflect.get(c, i);
            return $549bc87046462fe7$var$d(t, i) && (a === void 0 || s(i, a)) || a === void 0 ? t[i] : a;
        },
        set (c, i, a) {
            return typeof i != "symbol" && !$549bc87046462fe7$var$d(c, i) && $549bc87046462fe7$var$d(t, i) ? (t[i] = a, !0) : Reflect.set(c, i, a);
        },
        has: (c, i)=>Reflect.has(c, i) || i in t
    }), e.set(t, r), r;
}, $549bc87046462fe7$var$Xn = (n)=>!!n && typeof n == "object" && !!n.__raw && typeof n.__raw == "object", $549bc87046462fe7$var$Zn = (n, t)=>{
    const o = $549bc87046462fe7$var$V.get(n);
    return o ? t === o.consumerGs ? o.libGs : $549bc87046462fe7$var$Xn(t) ? $549bc87046462fe7$var$qn(t, o.libGs, o.consumerGs) : t : t;
}, $549bc87046462fe7$var$Qn = ()=>{
    typeof globalThis[$549bc87046462fe7$var$Q] != "function" && Object.defineProperty(globalThis, $549bc87046462fe7$var$Q, {
        value: $549bc87046462fe7$var$Zn,
        configurable: !0
    });
}, $549bc87046462fe7$var$T = (n)=>{
    const t = n[$549bc87046462fe7$export$2fa805cc314a53ac];
    return Array.isArray(t) ? t : null;
}, $549bc87046462fe7$var$Y = (n)=>$549bc87046462fe7$export$44738c829197fd45(n) ? n.library : n, $549bc87046462fe7$var$xn = (n, t, o)=>{
    const e = $549bc87046462fe7$var$T(n);
    return !!e && e.some((r)=>r && r.index === t && (!r.key || r.key === o.key) && (0, $czfS0.isString)(r.id) && $549bc87046462fe7$var$vn(n, r.id));
}, $549bc87046462fe7$var$vn = (n, t)=>{
    const o = JSON.stringify(t), e = new Set, r = (s)=>{
        if ((0, $czfS0.isString)(s)) return s.includes(o);
        if (!s || typeof s != "object" || e.has(s)) return !1;
        e.add(s);
        for(const c in s)if (r(s[c])) return !0;
        return !1;
    };
    for (const s of [
        "globalScope",
        ...$549bc87046462fe7$var$C,
        ...$549bc87046462fe7$var$Z
    ])if (r(n[s])) return !0;
    return !1;
}, $549bc87046462fe7$var$rn = (n, t)=>{
    const o = {};
    for (const e of Object.keys(n))$549bc87046462fe7$var$_.has(e) || (o[e] = $549bc87046462fe7$var$G(n[e], t));
    return o;
}, $549bc87046462fe7$var$sn = new WeakMap, $549bc87046462fe7$export$d3d1283babad0132 = (n, t = null)=>{
    const o = n && $549bc87046462fe7$var$T(n);
    if (!o || !o.length) return 0;
    const e = n.globalScope;
    if (!(0, $czfS0.isObject)(e)) return 0;
    const r = Array.isArray(n.sharedLibraries) ? n.sharedLibraries : [];
    let s = $549bc87046462fe7$var$sn.get(e);
    s || $549bc87046462fe7$var$sn.set(e, s = new Set), $549bc87046462fe7$var$Qn();
    let c = 0;
    for (const i of o){
        if (!i || !(0, $czfS0.isString)(i.id) || s.has(i.id)) continue;
        const a = $549bc87046462fe7$var$Y(r[i.index]);
        if (!a || !(0, $czfS0.isObject)(a.globalScope) || i.key && a.key !== i.key) continue;
        const u = (h)=>typeof h == "function" ? $549bc87046462fe7$var$x(h) : h, f = (h, L)=>{
            if (h === L) return !0;
            const I = u(h), K = u(L);
            return (0, $czfS0.isString)(I) || (0, $czfS0.isString)(K) ? I === K : JSON.stringify(h) === JSON.stringify(L);
        }, l = (0, $czfS0.isObject)(t) ? (Array.isArray(i.landed) ? i.landed : []).filter((h)=>(0, $czfS0.isString)(h) && $549bc87046462fe7$var$d(a.globalScope, h) && $549bc87046462fe7$var$d(t, h) && f(t[h], $549bc87046462fe7$var$G(a.globalScope[h], i.id))) : [], y = (0, $2C0hZ.destringifyGlobalScope)($549bc87046462fe7$var$rn(a.globalScope, i.id));
        Object.setPrototypeOf(y, e), $549bc87046462fe7$var$V.set(i.id, {
            libGs: y,
            consumerGs: e
        });
        for (const h of l)e[h] = y[h];
        s.add(i.id), c++;
    }
    return c;
}, $549bc87046462fe7$var$ne = /^@symbo[-.]ls\//, $549bc87046462fe7$export$b2e7fc8a3bd3ae9f = (n)=>n.includes("/") ? n.slice(n.indexOf("/") + 1) : n, $549bc87046462fe7$export$49bfc5fe1bf6e07c = (n)=>[
        `@symbo-ls/${n}`,
        `@symbo.ls/${n}`
    ], $549bc87046462fe7$export$749cab5d7099972c = (n, t)=>{
    const o = [];
    if (!Array.isArray(n) || !n.length) return o;
    const e = new Map, r = (c, i, a)=>{
        for (const u of $549bc87046462fe7$export$49bfc5fe1bf6e07c(c)){
            const f = e.get(u);
            if (f === void 0) {
                e.set(u, i), o.push([
                    u,
                    i
                ]);
                continue;
            }
            f !== i && a && typeof t == "function" && t({
                spec: u,
                kept: f,
                refused: i
            });
        }
    }, s = [];
    for (const c of n){
        const i = $549bc87046462fe7$var$Y(c);
        if (!i || typeof i != "object" || i.__isStub) continue;
        const a = i.key || i.name || i.__libraryKey, u = [];
        for (const f of [
            i.key,
            i.name,
            i.__libraryKey,
            i.__libraryName
        ]){
            if (typeof f != "string" || !f || f !== a && !$549bc87046462fe7$var$ne.test(f)) continue;
            const l = $549bc87046462fe7$export$b2e7fc8a3bd3ae9f(f);
            l && !u.includes(l) && u.push(l);
        }
        u.forEach((f, l)=>{
            l === 0 && a && $549bc87046462fe7$export$b2e7fc8a3bd3ae9f(a) === f ? r(f, i, !1) : s.push([
                f,
                i
            ]);
        });
    }
    for (const [c, i] of s)r(c, i, !0);
    return o;
}, $549bc87046462fe7$export$7a97c6aa71f46867 = ({ spec: n, kept: t, refused: o })=>{
    typeof console;
}, $549bc87046462fe7$var$ln = [
    "functions",
    "methods",
    "snippets"
], $549bc87046462fe7$export$77da5ddbcec3aec5 = Symbol.for("smbls.libraryPackages"), $549bc87046462fe7$var$O = new WeakMap, $549bc87046462fe7$var$re = (n)=>!!n && typeof n == "object" && !Array.isArray(n), $549bc87046462fe7$var$se = (n)=>({
        get globalScope () {
            return n();
        }
    }), $549bc87046462fe7$var$fn = (n, t, o)=>{
    const e = {};
    for (const r of Object.keys(n))$549bc87046462fe7$var$_.has(r) || (e[r] = n[r]);
    return Object.defineProperty(e, "context", {
        configurable: !0,
        enumerable: !1,
        writable: !0,
        value: $549bc87046462fe7$var$se(t)
    }), $549bc87046462fe7$var$O.set(e, o), e;
}, $549bc87046462fe7$var$un = (n)=>!$549bc87046462fe7$var$re(n) || !$549bc87046462fe7$var$O.has(n) && Object.prototype.hasOwnProperty.call(n, "context"), $549bc87046462fe7$export$713b92c67ba03ad2 = (n)=>{
    if (!n || typeof n != "object") return;
    const t = ()=>n.globalScope;
    for (const e of $549bc87046462fe7$var$ln){
        const r = n[e];
        $549bc87046462fe7$var$un(r) || $549bc87046462fe7$var$O.get(r) === n || (n[e] = $549bc87046462fe7$var$fn(r, t, n));
    }
    if (Array.isArray(n.sharedLibraries)) {
        const e = $549bc87046462fe7$var$T(n) || [];
        n.sharedLibraries = n.sharedLibraries.map((r, s)=>{
            const c = $549bc87046462fe7$export$44738c829197fd45(r) && r && "library" in r, i = $549bc87046462fe7$var$Y(r);
            if (!i || typeof i != "object" || i.__isStub || $549bc87046462fe7$var$O.get(i) === n) return r;
            const a = e.find((l)=>l && l.index === s && (!l.key || l.key === i.key)), u = ()=>{
                const l = a && $549bc87046462fe7$var$V.get(a.id);
                return l && l.consumerGs === n.globalScope ? l.libGs : n.globalScope;
            }, f = {
                ...i
            };
            for (const l of $549bc87046462fe7$var$ln)$549bc87046462fe7$var$un(i[l]) || (f[l] = $549bc87046462fe7$var$fn(i[l], u, n));
            return $549bc87046462fe7$var$O.set(f, n), c ? {
                ...r,
                library: f
            } : f;
        });
    }
    const o = n.globalScope;
    if (o && typeof o == "object") {
        const e = {};
        for (const [r, s] of $549bc87046462fe7$export$749cab5d7099972c(n.sharedLibraries, $549bc87046462fe7$export$7a97c6aa71f46867))e[r] = s;
        try {
            Object.defineProperty(o, $549bc87046462fe7$export$77da5ddbcec3aec5, {
                configurable: !0,
                enumerable: !1,
                writable: !0,
                value: e
            });
        } catch  {}
    }
}, $549bc87046462fe7$var$j = "polyglot/translations", $549bc87046462fe7$var$ie = (n, t)=>{
    let o = n;
    for (const e of t.split(".")){
        if (!o || typeof o != "object" || !$549bc87046462fe7$var$d(o, e)) return !1;
        o = o[e];
    }
    return o !== void 0;
}, $549bc87046462fe7$var$pn = (n, t, o, e, r = !1)=>{
    for(const s in t){
        if (!$549bc87046462fe7$var$d(t, s) || $549bc87046462fe7$var$_.has(s)) continue;
        const c = `${e}/${s}`;
        if (!o.has(c)) {
            if ($549bc87046462fe7$var$d(n, s)) (0, $czfS0.isObject)(n[s]) && (0, $czfS0.isObject)(t[s]) && $549bc87046462fe7$var$pn(n[s], t[s], o, c);
            else {
                if (r && s.includes(".") && $549bc87046462fe7$var$ie(n, s)) continue;
                n[s] = $549bc87046462fe7$var$g(t[s], o, c);
            }
        }
    }
}, $549bc87046462fe7$var$yn = (n, t, o)=>{
    if (!("translations" in n)) {
        n.translations = $549bc87046462fe7$var$g(t, o, $549bc87046462fe7$var$j);
        return;
    }
    const e = n.translations;
    if (!(0, $czfS0.isObject)(e) || !(0, $czfS0.isObject)(t) || n.fetch) return;
    let r = null;
    for(const s in t){
        if (!$549bc87046462fe7$var$d(t, s) || $549bc87046462fe7$var$_.has(s)) continue;
        const c = `${$549bc87046462fe7$var$j}/${s}`;
        if (!o.has(c)) {
            if ($549bc87046462fe7$var$d(e, s)) {
                (0, $czfS0.isObject)(e[s]) && (0, $czfS0.isObject)(t[s]) && $549bc87046462fe7$var$pn(e[s], t[s], o, c, !0);
                continue;
            }
            (0, $czfS0.isObject)(t[s]) && (r || (r = new Set((0, $5pnrT.polyglotLanguages)(n, !1))), r.has(s) && (e[s] = $549bc87046462fe7$var$g(t[s], o, c)));
        }
    }
}, $549bc87046462fe7$var$ce = (n, t)=>{
    const o = {};
    for(const e in n){
        if (!$549bc87046462fe7$var$d(n, e) || $549bc87046462fe7$var$_.has(e)) continue;
        const r = `polyglot/${e}`;
        t.has(r) || (o[e] = e === "translations" ? $549bc87046462fe7$var$g(n[e], t, r) : $549bc87046462fe7$var$A(n[e], t, r));
    }
    return o;
}, $549bc87046462fe7$var$hn = (n)=>(0, $5pnrT.withPolyglotTranslations)(n), $549bc87046462fe7$var$ae = (n, t, o, e = "library", r = -1)=>{
    const s = $549bc87046462fe7$var$hn(t), c = $549bc87046462fe7$var$m(s, o), i = !$549bc87046462fe7$var$xn(n, r, s) && $549bc87046462fe7$var$Hn(n, s, c) > 0 ? `${e}#${$549bc87046462fe7$var$Cn()}` : null, a = i ? $549bc87046462fe7$var$Jn(s, i) : s, u = i ? new Set(Object.keys(n.globalScope)) : null, f = [];
    for(const l in a)if (Object.prototype.hasOwnProperty.call(a, l) && !(l === "sharePages" || l === "sharedLibIgnore") && l !== $549bc87046462fe7$export$2fa805cc314a53ac && !l.startsWith("__") && !$549bc87046462fe7$var$_.has(l) && l !== "app" && !c.has(l)) {
        if ((0, $czfS0.isObject)(a[l]) && (0, $czfS0.isObject)(n[l])) {
            if (l === "designSystem") $549bc87046462fe7$export$62d7a9f86a83f052(n[l], a[l], c, l);
            else {
                for(const y in a[l])if (!$549bc87046462fe7$var$_.has(y) && !c.has(`${l}/${y}`) && !(l === "polyglot" && y === "translations")) {
                    if (l === "methods" && (0, $cjyfe.isProtectedElementMethod)(y)) {
                        y in n[l] || f.push(y);
                        continue;
                    }
                    y in n[l] ? $549bc87046462fe7$var$k(l, n[l][y]) && !$549bc87046462fe7$var$k(l, a[l][y]) ? n[l][y] = a[l][y] : l === "components" && (0, $5UBxb.recordShadowedComponent)(n, y, a[l][y]) : n[l][y] = a[l][y];
                }
                l === "polyglot" && $549bc87046462fe7$var$d(a.polyglot, "translations") && !c.has($549bc87046462fe7$var$j) && $549bc87046462fe7$var$yn(n.polyglot, a.polyglot.translations, c);
            }
        } else if (!(l in n)) {
            const y = a[l], h = l === "methods" && y && typeof y == "object" ? $549bc87046462fe7$var$Un(y, c, f) : y;
            l === "designSystem" ? n[l] = $549bc87046462fe7$var$g(h, c, l) : l === "polyglot" && (0, $czfS0.isObject)(h) ? n[l] = $549bc87046462fe7$var$ce(h, c) : n[l] = $549bc87046462fe7$var$Dn($549bc87046462fe7$var$A(h, c, l), s[l]);
        }
    }
    i && ($549bc87046462fe7$var$T(n) || (n[$549bc87046462fe7$export$2fa805cc314a53ac] = []), n[$549bc87046462fe7$export$2fa805cc314a53ac].push({
        id: i,
        index: r,
        key: (0, $czfS0.isString)(s.key) ? s.key : null,
        landed: Object.keys(a.globalScope).filter((l)=>!u.has(l))
    })), f.length && $549bc87046462fe7$var$Fn(e, f);
}, $549bc87046462fe7$var$le = (n, t, o)=>{
    if (n !== t) {
        const e = $549bc87046462fe7$var$X(n);
        if ((0, $czfS0.isString)(e) && e) return e;
        if (n.key || n.name) return n.key || n.name;
    }
    return t && (t.key || t.name) || `sharedLibraries[${o}]`;
}, $549bc87046462fe7$var$fe = `${$549bc87046462fe7$var$N}/default`, $549bc87046462fe7$var$ue = (n)=>(0, $czfS0.isString)(n) && n !== "" && $549bc87046462fe7$export$8254761f7cf4c0e0(n).full === $549bc87046462fe7$var$fe, $549bc87046462fe7$var$pe = (n, t)=>{
    if ((0, $czfS0.isString)(t.key) && t.key) return t.key;
    if (n !== t) {
        if ((0, $czfS0.isString)(n.key) && n.key) return n.key;
        if ((0, $czfS0.isString)(n.name) && n.name) return n.name;
    }
    return null;
}, $549bc87046462fe7$var$R = (n)=>{
    const t = [], o = [];
    for(let e = 0; e < n.length; e++){
        const r = n[e];
        let s = r, c = $549bc87046462fe7$var$W;
        if ($549bc87046462fe7$export$44738c829197fd45(s) && (c = $549bc87046462fe7$export$83151c6fb65b8376(s.ignoreList), s = s.library), !(0, $czfS0.isObject)(s)) continue;
        const i = {
            entry: r,
            lib: s,
            ignore: c,
            index: e
        };
        $549bc87046462fe7$var$ue($549bc87046462fe7$var$pe(r, s)) ? o.push(i) : t.push(i);
    }
    return {
        linked: t,
        bases: o
    };
}, $549bc87046462fe7$var$dn = (n, t, o)=>{
    const e = t(), r = $549bc87046462fe7$var$z(e), s = $549bc87046462fe7$var$Nn(e), { linked: c, bases: i } = $549bc87046462fe7$var$R(n);
    for (const f of c)o(f);
    const a = !r.size && i.length ? $549bc87046462fe7$var$z(t()) : null;
    for (const f of i)o(f);
    return {
        claims: r.size ? r : a && a.size ? a : null,
        ownFamilies: s
    };
}, $549bc87046462fe7$export$b9e6b90332b83419 = (n, t)=>{
    if (!t || !t.length) return;
    const { claims: o, ownFamilies: e } = $549bc87046462fe7$var$dn(t, ()=>n.designSystem, ({ entry: r, lib: s, ignore: c, index: i })=>$549bc87046462fe7$var$ae(n, s, c, $549bc87046462fe7$var$le(r, s, i), i));
    $549bc87046462fe7$var$q(n.designSystem, e), o && $549bc87046462fe7$var$J(n.designSystem, o);
}, $549bc87046462fe7$export$4d3e70706128d912 = (n, t)=>{
    const o = (0, $czfS0.isObject)(n) ? n : null;
    if (!Array.isArray(t) || !t.length) return o || {};
    const e = o ? {
        ...o
    } : {}, { linked: r, bases: s } = $549bc87046462fe7$var$R(t);
    for (const { lib: c, ignore: i } of [
        ...r,
        ...s
    ]){
        const a = $549bc87046462fe7$var$m(c, i);
        if (a.has("files")) continue;
        const u = c.files;
        if ((0, $czfS0.isObject)(u)) for(const f in u)!Object.prototype.hasOwnProperty.call(u, f) || $549bc87046462fe7$var$_.has(f) || a.has(`files/${f}`) || f in e || (e[f] = u[f]);
    }
    return e;
}, $549bc87046462fe7$var$bn = (n)=>{
    const t = {};
    for(const o in n)$549bc87046462fe7$var$d(n, o) && !$549bc87046462fe7$var$_.has(o) && (t[o] = n[o]);
    return t;
}, $549bc87046462fe7$export$ca97f6691f226c13 = (n, t)=>{
    const o = (0, $czfS0.isObject)(n) ? $549bc87046462fe7$var$bn(n) : n;
    if (!Array.isArray(t) || !t.length) return o;
    let e = o;
    const { linked: r, bases: s } = $549bc87046462fe7$var$R(t);
    for (const { lib: c, ignore: i } of [
        ...r,
        ...s
    ]){
        if (!$549bc87046462fe7$var$d(c, "dependencies")) continue;
        const a = $549bc87046462fe7$var$m(c, i);
        if (a.has("dependencies")) continue;
        const u = c.dependencies;
        if ((0, $czfS0.isObject)(u) && (0, $czfS0.isObject)(e)) for(const f in u)!$549bc87046462fe7$var$d(u, f) || $549bc87046462fe7$var$_.has(f) || a.has(`dependencies/${f}`) || f in e || (e[f] = u[f]);
        else e === void 0 && (e = (0, $czfS0.isObject)(u) ? $549bc87046462fe7$var$bn($549bc87046462fe7$var$A(u, a, "dependencies")) : u);
    }
    if (!(0, $czfS0.isObject)(e)) return e;
    for (const [c] of $549bc87046462fe7$export$749cab5d7099972c(t))delete e[c];
    return e;
}, $549bc87046462fe7$var$ye = (n)=>n === "key" || n === "name" || n === "owner" || n === "sharePages" || n === "sharedLibIgnore" || n.startsWith("__"), $549bc87046462fe7$var$he = (n)=>{
    const t = [];
    for (const o of [
        n,
        n.config,
        n.settings
    ]){
        const e = (0, $czfS0.isObject)(o) ? o.polyglot : null, r = (0, $czfS0.isObject)(e) ? e.translationsFrom : null;
        (0, $czfS0.isString)(r) && r && t.push(r.split(".").join("/"));
    }
    return t;
}, $549bc87046462fe7$var$de = (n, t)=>$549bc87046462fe7$var$ye(n.split("/")[0]) ? !1 : !t.some((o)=>o === n || o.startsWith(`${n}/`) || n.startsWith(`${o}/`)), $549bc87046462fe7$var$be = (n, t)=>{
    const o = $549bc87046462fe7$var$he(n), e = new Set;
    for (const s of t)$549bc87046462fe7$var$de(s, o) && e.add(s);
    if (!e.size) return n;
    let r = null;
    for(const s in n){
        if (!$549bc87046462fe7$var$d(n, s)) continue;
        const c = n[s], i = e.has(s) ? void 0 : $549bc87046462fe7$var$A(c, e, s);
        !e.has(s) && i === c || (r || (r = {
            ...n
        }), e.has(s) ? delete r[s] : r[s] = i);
    }
    return r || n;
}, $549bc87046462fe7$export$864fd6e0404d37ab = (n)=>{
    if (!Array.isArray(n) || !n.length) return n;
    let t = null;
    for(let o = 0; o < n.length; o++){
        const e = n[o], r = $549bc87046462fe7$export$44738c829197fd45(e), s = r ? e.library : e;
        if (!(0, $czfS0.isObject)(s)) continue;
        const c = $549bc87046462fe7$var$m(s, r ? $549bc87046462fe7$export$83151c6fb65b8376(e.ignoreList) : $549bc87046462fe7$var$W), i = c.size ? $549bc87046462fe7$var$be(s, c) : s;
        i !== s && (t || (t = n.slice()), t[o] = r ? {
            ...e,
            library: i
        } : i);
    }
    return t || n;
}, $549bc87046462fe7$export$9d09d5e7fb92b5e6 = (n, t, o, e)=>{
    if (typeof t != "string" || $549bc87046462fe7$var$_.has(t)) return;
    const r = o && typeof o == "object" && Object.prototype.hasOwnProperty.call(o, t) ? o[t] : void 0;
    if (r !== void 0 && !$549bc87046462fe7$var$k(n, r) || !Array.isArray(e) || !e.length) return r;
    const { linked: s, bases: c } = $549bc87046462fe7$var$R(e);
    for (const { lib: i, ignore: a } of [
        ...s,
        ...c
    ]){
        const u = $549bc87046462fe7$var$m(i, a);
        if (u.has(n) || u.has(`${n}/${t}`)) continue;
        const f = i[n];
        if (!(!(0, $czfS0.isObject)(f) || !Object.prototype.hasOwnProperty.call(f, t)) && !$549bc87046462fe7$var$k(n, f[t])) return f[t];
    }
    return r;
}, $549bc87046462fe7$export$2aaefd95de023181 = (n, t, o = $549bc87046462fe7$export$62d7a9f86a83f052)=>{
    if (!(0, $czfS0.isObject)(n) || !Array.isArray(t) || !t.length) return n;
    const { claims: e, ownFamilies: r } = $549bc87046462fe7$var$dn(t, ()=>n, ({ lib: s, ignore: c })=>{
        const i = s.designSystem;
        if (!i || typeof i != "object") return;
        const a = $549bc87046462fe7$var$m(s, c);
        a.has("designSystem") || o(n, i, a, "designSystem");
    });
    return $549bc87046462fe7$var$q(n, r), e && $549bc87046462fe7$var$J(n, e), n;
}, $549bc87046462fe7$export$812bdcf565c9516c = (n, t)=>{
    if (!(0, $czfS0.isObject)(n) || !Array.isArray(t) || !t.length) return n;
    const { linked: o, bases: e } = $549bc87046462fe7$var$R(t);
    for (const { lib: r, ignore: s } of [
        ...o,
        ...e
    ]){
        const c = $549bc87046462fe7$var$hn(r), i = c.polyglot;
        if (!(0, $czfS0.isObject)(i) || !$549bc87046462fe7$var$d(i, "translations")) continue;
        const a = $549bc87046462fe7$var$m(c, s);
        a.has("polyglot") || a.has($549bc87046462fe7$var$j) || $549bc87046462fe7$var$yn(n, i.translations, a);
    }
    return n;
};
async function $549bc87046462fe7$export$68e1f259e57c59d(n, t = {}) {
    const o = t.provider || "kv";
    if (o === "same-origin") return $549bc87046462fe7$var$ge(n, t);
    if (o === "api") return $549bc87046462fe7$var$_n(n, t);
    const e = await $549bc87046462fe7$var$Se(n, t);
    return e || $549bc87046462fe7$var$_n(n, t);
}
async function $549bc87046462fe7$var$Se(n, t = {}) {
    const o = t.kvBaseUrl || $549bc87046462fe7$var$Bn, e = t.env || "production", r = `${o}/kv/${encodeURIComponent(n)}?env=${e}`;
    try {
        const s = await fetch(r, {
            method: "GET"
        });
        return s.ok && (await s.json())?.value || null;
    } catch  {
        return null;
    }
}
async function $549bc87046462fe7$var$ge(n, t = {}) {
    const o = t.sameOriginBase;
    if (!o) return null;
    const e = Array.isArray(t.names) && t.names.length ? `?names=${t.names.map(encodeURIComponent).join(",")}` : "", r = `${o}${$549bc87046462fe7$var$Tn}${encodeURIComponent(n)}${e}`;
    try {
        const s = await fetch(r, {
            method: "GET"
        });
        return s.ok ? await s.json() : null;
    } catch  {
        return null;
    }
}
async function $549bc87046462fe7$var$_n(n, t = {}) {
    const o = t.apiBaseUrl || $549bc87046462fe7$var$$n, { owner: e, key: r } = $549bc87046462fe7$export$8254761f7cf4c0e0(n);
    try {
        const s = `${o}/core/projects/libraries/available?search=${encodeURIComponent(r)}&owner=${encodeURIComponent(e)}&limit=10`, c = await fetch(s, {
            method: "GET"
        });
        if (!c.ok) return null;
        const i = await c.json(), u = (i?.items || i?.data || (Array.isArray(i) ? i : [])).find((L)=>{
            const { key: I } = $549bc87046462fe7$export$8254761f7cf4c0e0(L?.key);
            return I.toLowerCase() === r.toLowerCase();
        });
        if (!u?.id && !u?._id) return null;
        const f = u.id || u._id, l = `${o}/core/projects/${encodeURIComponent(f)}/data?branch=main`, y = await fetch(l, {
            method: "GET"
        });
        if (!y.ok) return null;
        const h = await y.json();
        return h?.data || h || null;
    } catch  {
        return null;
    }
}
async function $549bc87046462fe7$var$Sn(n, t = {}) {
    if ((0, $czfS0.isObject)(n)) return n;
    if ((0, $czfS0.isString)(n)) {
        const { full: o } = $549bc87046462fe7$export$8254761f7cf4c0e0(n);
        if (!o) return null;
        try {
            const e = await $549bc87046462fe7$export$68e1f259e57c59d(o, t);
            return e || console.warn(`[smbls] Shared library "${o}" not found`), e;
        } catch (e) {
            return console.warn(`[smbls] Failed to fetch shared library "${o}":`, e.message), null;
        }
    }
    return null;
}
async function $549bc87046462fe7$export$d79adda69733feb(n, t = {}) {
    return !n || !n.length ? [] : (await Promise.all(n.map(async (e)=>{
        if ($549bc87046462fe7$export$44738c829197fd45(e)) {
            const r = await $549bc87046462fe7$var$Sn($549bc87046462fe7$var$X(e), t);
            return r ? {
                library: r,
                ignoreList: e.ignoreList
            } : null;
        }
        return $549bc87046462fe7$var$Sn(e, t);
    }))).filter(Boolean);
}

});

parcelRegister("cdzjF", function(module, exports) {

$parcel$export(module.exports, "ROUTE_HEAD_KEYS", () => $8e5218044565d636$export$d49c88b48b59cd34);
$parcel$export(module.exports, "routeEntryPage", () => $8e5218044565d636$export$938f5ea6d68fcf17);
$parcel$export(module.exports, "isSameRoutePage", () => $8e5218044565d636$export$d18233be7514391f);
$parcel$export(module.exports, "routeEntryMetadata", () => $8e5218044565d636$export$ec70affde4500e65);

var $czfS0 = parcelRequire("czfS0");

var $5UBxb = parcelRequire("5UBxb");

var $cjyfe = parcelRequire("cjyfe");

const $8e5218044565d636$export$d49c88b48b59cd34 = Object.freeze([
    "metadata",
    "helmet"
]), $8e5218044565d636$var$A = 8, $8e5218044565d636$export$938f5ea6d68fcf17 = (e)=>{
    if ((0, $czfS0.isString)(e)) return e || null;
    if (!e || typeof e != "object" || Array.isArray(e) || !(0, $czfS0.isString)(e.extends) || !e.extends) return null;
    for(const t in e)if (t !== "extends" && !$8e5218044565d636$export$d49c88b48b59cd34.includes(t)) return null;
    return e.extends;
}, $8e5218044565d636$export$d18233be7514391f = (e, t)=>{
    if (e === t) return !0;
    const r = $8e5218044565d636$export$938f5ea6d68fcf17(e);
    return r !== null && r === $8e5218044565d636$export$938f5ea6d68fcf17(t);
}, $8e5218044565d636$var$p = (e, t)=>{
    if (!(0, $czfS0.isString)(t) || !t || (0, $cjyfe.PROTOTYPE_KEYS).has(t)) return null;
    if (typeof e == "function") return e(t) || null;
    if (!e || typeof e != "object") return null;
    const r = (n)=>Object.prototype.hasOwnProperty.call(e, n) ? e[n] : void 0;
    return r(t) || r(`smbls.${t}`) || null;
}, $8e5218044565d636$var$m = (e, t)=>{
    if ((0, $czfS0.isString)(e)) {
        if (!e.includes(">")) return $8e5218044565d636$var$p(t, e);
        const r = e.split(">").map((o)=>o.trim());
        let n = $8e5218044565d636$var$p(t, r[0]);
        for(let o = 1; o < r.length && n; o++)n = (0, $cjyfe.PROTOTYPE_KEYS).has(r[o]) ? null : n[r[o]];
        return n && typeof n == "object" ? n : null;
    }
    return e && typeof e == "object" && !Array.isArray(e) ? e : null;
}, $8e5218044565d636$var$u = (e)=>!!e && typeof e == "object" && !Array.isArray(e), $8e5218044565d636$var$h = (e, t)=>{
    const r = {
        ...e
    };
    for(const n in t)(0, $cjyfe.PROTOTYPE_KEYS).has(n) || (r[n] = $8e5218044565d636$var$u(r[n]) && $8e5218044565d636$var$u(t[n]) ? $8e5218044565d636$var$h(r[n], t[n]) : t[n]);
    return r;
}, $8e5218044565d636$var$L = (e, t)=>{
    const r = [];
    let n = 0;
    const o = (s, l)=>{
        if (!(l.has(s) || n >= $8e5218044565d636$var$A)) {
            l.add(s), n++;
            for (const S of (0, $5UBxb.collectExtendsList)(s)){
                const c = $8e5218044565d636$var$m(S, t);
                c && o(c, l);
            }
            s.metadata !== void 0 && r.push(s.metadata);
        }
    };
    for (const s of (0, $5UBxb.collectExtendsList)(e)){
        const l = $8e5218044565d636$var$m(s, t);
        l && l !== e && o(l, new Set([
            e
        ]));
    }
    return r;
}, $8e5218044565d636$var$D = (e)=>{
    let t;
    for (const r of e)t === void 0 ? t = $8e5218044565d636$var$u(r) ? {
        ...r
    } : r : $8e5218044565d636$var$u(t) && $8e5218044565d636$var$u(r) ? t = $8e5218044565d636$var$h(t, r) : t = r;
    return t;
}, $8e5218044565d636$export$ec70affde4500e65 = (e, t)=>{
    const r = (0, $czfS0.isString)(e) ? {
        extends: e
    } : e;
    if (!r || typeof r != "object" || Array.isArray(r)) return;
    const n = r.metadata !== void 0 ? r.metadata : r.helmet, o = $8e5218044565d636$var$D($8e5218044565d636$var$L(r, t));
    return n === void 0 ? o : $8e5218044565d636$var$u(n) && $8e5218044565d636$var$u(o) ? {
        ...o,
        ...n
    } : n;
};

});


parcelRegister("4vxEg", function(module, exports) {

$parcel$export(module.exports, "findClosestNumber", () => $3484288c2f39ca6a$export$97a41db892f2d4c);
$parcel$export(module.exports, "findClosestNumberInFactory", () => $3484288c2f39ca6a$export$63c606e1170dd201);

var $czfS0 = parcelRequire("czfS0");
const $3484288c2f39ca6a$export$97a41db892f2d4c = (t, e)=>((0, $czfS0.isArray)(e) ? e : Object.values(e)).reduce((s, i)=>Math.abs(i - t) < Math.abs(s - t) ? i : s), $3484288c2f39ca6a$export$63c606e1170dd201 = (t, e)=>(t = parseFloat(t), (0, $czfS0.isObject)(e) && (e = Object.values(e)), $3484288c2f39ca6a$export$97a41db892f2d4c(t, e));

});

parcelRegister("67pwd", function(module, exports) {

$parcel$export(module.exports, "libraryIdentifier", () => $474730fc5b04e461$export$8e236c3aef735ca2);
$parcel$export(module.exports, "payloadHasComputedIconName", () => $474730fc5b04e461$export$305d5b618172071c);
$parcel$export(module.exports, "planLibraryIconPrune", () => $474730fc5b04e461$export$56930741b0b430);
$parcel$export(module.exports, "libraryIconPruneReplacer", () => $474730fc5b04e461$export$b0bb332d184f020f);
$parcel$export(module.exports, "createPrunedLibraryIconLoader", () => $474730fc5b04e461$export$edaa4ff184ef02f);
$parcel$export(module.exports, "installPrunedLibraryIconLoader", () => $474730fc5b04e461$export$523de3b3edc1efaf);

var $czfS0 = parcelRequire("czfS0");

var $7gmTd = parcelRequire("7gmTd");

var $6Bm4P = parcelRequire("6Bm4P");

const $474730fc5b04e461$var$L = /[A-Za-z_$][A-Za-z0-9_$-]*/g, $474730fc5b04e461$var$S = /[A-Za-z_$][A-Za-z0-9_$]*(?: [A-Za-z0-9_$]+){1,5}/g, $474730fc5b04e461$var$R = (e, o)=>{
    $474730fc5b04e461$var$L.lastIndex = 0;
    let t;
    for(; t = $474730fc5b04e461$var$L.exec(e);){
        const r = t[0];
        if (o.add(r), r.indexOf("-") !== -1) for (const c of r.split("-"))c && o.add(c);
    }
    $474730fc5b04e461$var$S.lastIndex = 0;
    let n;
    for(; n = $474730fc5b04e461$var$S.exec(e);){
        const r = n[0].split(" ");
        for(let c = 0; c < r.length - 1; c++)for(let s = 2; s <= 6 && c + s <= r.length; s++)o.add((0, $6Bm4P.toCamelCase)(r.slice(c, c + s).join(" ")));
    }
    return o;
}, $474730fc5b04e461$var$A = (e)=>(0, $7gmTd.isWrappedLibrary)(e) ? e.library : e, $474730fc5b04e461$var$w = [
    "components",
    "pages",
    "snippets"
], $474730fc5b04e461$var$M = [
    "name",
    "icon"
], $474730fc5b04e461$export$8e236c3aef735ca2 = (e)=>{
    if (!(0, $czfS0.isObject)(e)) return null;
    const o = e.key;
    if (!o) return null;
    const t = e.owner, n = (0, $czfS0.isObject)(t) ? t.slug : t;
    return n ? `${n}/${o}` : String(o);
}, $474730fc5b04e461$var$B = /^\s*(?:async\s+)?(?:function\b|\(|[A-Za-z_$][A-Za-z0-9_$]*\s*=>)/, $474730fc5b04e461$export$305d5b618172071c = (e)=>{
    const o = new Set, t = (n)=>{
        if (Array.isArray(n)) {
            for (const r of n)if (t(r)) return !0;
            return !1;
        }
        if (!(0, $czfS0.isObject)(n) || o.has(n)) return !1;
        o.add(n);
        for (const r of $474730fc5b04e461$var$M){
            const c = n[r];
            if (typeof c == "string" && $474730fc5b04e461$var$B.test(c)) return !0;
        }
        for (const r of Object.keys(n))if (t(n[r])) return !0;
        return !1;
    };
    for (const n of $474730fc5b04e461$var$w)if (t(e[n])) return !0;
    for (const n of e.sharedLibraries || []){
        const r = $474730fc5b04e461$var$A(n);
        if ((0, $czfS0.isObject)(r)) {
            for (const c of $474730fc5b04e461$var$w)if (t(r[c])) return !0;
        }
    }
    return !1;
}, $474730fc5b04e461$export$56930741b0b430 = (e, o = {})=>{
    if (!(0, $czfS0.isObject)(e) || !Array.isArray(e.sharedLibraries)) return null;
    const t = (0, $czfS0.isObject)(e.settings) ? e.settings.libraryIconPrune : void 0;
    if (t === !1) return null;
    const n = !!(o && o.lateLoad);
    if (t !== !0 && !n && $474730fc5b04e461$export$305d5b618172071c(e)) return null;
    const r = [];
    for (const d of e.sharedLibraries){
        const g = $474730fc5b04e461$var$A(d), p = (0, $czfS0.isObject)(g) && g.designSystem, h = (0, $czfS0.isObject)(p) && p.icons;
        if (!(0, $czfS0.isObject)(h)) continue;
        const b = $474730fc5b04e461$export$8e236c3aef735ca2(g);
        b && r.push({
            id: b,
            icons: h,
            designSystem: p
        });
    }
    if (!r.length) return null;
    const c = new Set(r.map((d)=>d.designSystem)), s = JSON.stringify(e, function(d, g) {
        if (d !== "__ssr" && !(d === "icons" && c.has(this))) return g;
    });
    if (typeof s != "string") return null;
    const i = $474730fc5b04e461$var$R(s, new Set), f = new Map, u = [];
    let a = 0, y = 0, _ = 0;
    for (const d of r){
        const g = [];
        for (const p of Object.keys(d.icons)){
            if (i.has(p)) {
                y++;
                continue;
            }
            g.push(p);
            const h = d.icons[p];
            _ += p.length + (typeof h == "string" ? h.length : 0);
        }
        g.length && (a += g.length, f.set(d.icons, new Set(g)), u.push({
            id: d.id,
            icons: g
        }));
    }
    return a ? {
        drops: f,
        prune: {
            libraries: u
        },
        report: {
            icons: a,
            kept: y,
            bytes: _
        }
    } : null;
}, $474730fc5b04e461$export$b0bb332d184f020f = (e)=>function(o, t) {
        const n = e.get(this);
        if (!(n && n.has(o))) return t;
    }, $474730fc5b04e461$var$O = (e)=>{
    const o = (0, $czfS0.isObject)(e) && (0, $czfS0.isObject)(e.designSystem) && e.designSystem.icons;
    return (0, $czfS0.isObject)(o) ? o : null;
}, $474730fc5b04e461$var$x = ()=>null, $474730fc5b04e461$var$E = 512, $474730fc5b04e461$var$$ = (e, o)=>{
    const t = new Map;
    let n = null;
    const r = (s, i, f)=>{
        const u = (a)=>{
            for (const y of i)f.get(y)(a && Object.prototype.hasOwnProperty.call(a, y) ? a : null);
        };
        (0, $7gmTd.fetchLibraryData)(s, {
            ...o,
            names: i
        }).then($474730fc5b04e461$var$O, $474730fc5b04e461$var$x).then(u);
    }, c = ()=>{
        const s = n;
        n = null;
        for (const [i, f] of s){
            const u = [
                ...f.keys()
            ];
            for(let a = 0; a < u.length; a += $474730fc5b04e461$var$E)r(i, u.slice(a, a + $474730fc5b04e461$var$E), f);
        }
    };
    return (s)=>{
        const i = e.get(s);
        if (!i) return null;
        let f = t.get(s);
        if (!f) {
            n || (n = new Map, Promise.resolve().then(c));
            let u = n.get(i);
            u || n.set(i, u = new Map), f = new Promise((a)=>u.set(s, a)), t.set(s, f);
        }
        return f;
    };
}, $474730fc5b04e461$export$edaa4ff184ef02f = (e, o = {})=>{
    const t = new Map;
    for (const s of e && e.libraries || [])if (!(!s || !s.id || !Array.isArray(s.icons))) for (const i of s.icons)t.has(i) || t.set(i, s.id);
    if (!t.size) return null;
    const n = e && typeof e.sameOriginBase == "string" && e.sameOriginBase;
    if (n) return $474730fc5b04e461$var$$(t, {
        ...o,
        provider: "same-origin",
        sameOriginBase: n
    });
    const r = new Map, c = (s)=>{
        let i = r.get(s);
        return i || (i = Promise.resolve().then(()=>(0, $7gmTd.fetchLibraryData)(s, o)).then($474730fc5b04e461$var$O), r.set(s, i)), i;
    };
    return (s)=>{
        const i = t.get(s);
        return i ? c(i) : null;
    };
}, $474730fc5b04e461$export$523de3b3edc1efaf = (e, o = {})=>{
    if (!(0, $czfS0.isObject)(e)) return !1;
    const t = e.__libraryIconPrune;
    if (!(0, $czfS0.isObject)(t)) return !1;
    const n = e.designSystem;
    if (!(0, $czfS0.isObject)(n) || n.iconsLoader) return !1;
    const r = $474730fc5b04e461$export$edaa4ff184ef02f(t, o);
    return r ? (n.iconsLoader = r, !0) : !1;
};

});
parcelRegister("6Bm4P", function(module, exports) {

$parcel$export(module.exports, "copyStringToClipboard", () => $4ce752c58473276d$export$4cdfed7d7fed21b8);
$parcel$export(module.exports, "copyJavaScriptToClipboard", () => $4ce752c58473276d$export$62b326c3a2efe2fb);
$parcel$export(module.exports, "removeChars", () => $4ce752c58473276d$export$3cc82ee301fb0516);
$parcel$export(module.exports, "toCamelCase", () => $4ce752c58473276d$export$86f54f62aa7a7514);
$parcel$export(module.exports, "toTitleCase", () => $4ce752c58473276d$export$f06f8b3003f18927);
$parcel$export(module.exports, "toDashCase", () => $4ce752c58473276d$export$6401d9e8afa09755);
$parcel$export(module.exports, "toDescriptionCase", () => $4ce752c58473276d$export$c82070d8669cc24e);
$parcel$export(module.exports, "arrayzeValue", () => $4ce752c58473276d$export$d1ef4b1a340dec10);

var $czfS0 = parcelRequire("czfS0");
const $4ce752c58473276d$export$4cdfed7d7fed21b8 = async (e)=>{
    try {
        await navigator.clipboard.writeText(e);
    } catch (r) {
        console.warn("Failed to copy text: ", r);
    }
}, $4ce752c58473276d$export$62b326c3a2efe2fb = async (e)=>{
    try {
        const r = new Blob([
            e
        ], {
            type: "text/javascript"
        }), t = new window.ClipboardItem({
            "text/plain": r
        });
        await navigator.clipboard.write([
            t
        ]), console.log("JavaScript code copied to clipboard as text/javascript");
    } catch (r) {
        console.error("Failed to copy JavaScript code: ", r);
    }
}, $4ce752c58473276d$export$3cc82ee301fb0516 = (e)=>e.replace(/[^a-zA-Z0-9_]/g, ""), $4ce752c58473276d$export$86f54f62aa7a7514 = (e)=>(typeof e != "string" && (e = String(e || "")), e.replace(/(?:^\w|[A-Z]|\b\w)/g, function(r, t) {
        return t === 0 ? r.toLowerCase() : r.toUpperCase();
    }).replace(/\s+/g, "")), $4ce752c58473276d$export$f06f8b3003f18927 = (e)=>e && e.replace(/\w\S*/g, (r)=>r.charAt(0).toUpperCase() + r.substr(1).toLowerCase()), $4ce752c58473276d$export$6401d9e8afa09755 = (e)=>e.replace(/[^a-zA-Z0-9]/g, " ").trim().toLowerCase().replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, ""), $4ce752c58473276d$export$c82070d8669cc24e = (e = "")=>{
    if (typeof e != "string") return;
    const r = e.replace(/([A-Z])/g, " $1");
    return r.charAt(0).toUpperCase() + r.slice(1);
}, $4ce752c58473276d$export$d1ef4b1a340dec10 = (e)=>{
    if ((0, $czfS0.isArray)(e)) return e;
    if ((0, $czfS0.isString)(e)) return e.split(" ");
    if ((0, $czfS0.isObject)(e)) return Object.values(e);
    if ((0, $czfS0.isNumber)(e)) return [
        e
    ];
};

});


parcelRegister("j3Hh3", function(module, exports) {

$parcel$export(module.exports, "getEmotionStylesheet", () => $ddffdd72c8164824$export$6163c5ef8e6b8537);
const $ddffdd72c8164824$export$6163c5ef8e6b8537 = ()=>{
    const s = document.styleSheets[0];
    let o = "";
    if (s) try {
        const e = s.cssRules || s.rules;
        for(let t = 0; t < e.length; t++)o += e[t].cssText;
    } catch (e) {
        console.error("Unable to access CSS rules. This may be due to CORS restrictions:", e);
    }
    return o;
};

});

parcelRegister("3YUdU", function(module, exports) {

$parcel$export(module.exports, "resolveAsset", () => $2e62967d99bf606f$export$c60880f504524a89);
$parcel$export(module.exports, "srcsetFor", () => $2e62967d99bf606f$export$cc734a7c9455c1b3);
$parcel$export(module.exports, "buildImgSrcset", () => $2e62967d99bf606f$export$48745ce9fb63d5f0);
$parcel$export(module.exports, "buildSourcesAndImg", () => $2e62967d99bf606f$export$95efbd354ca64535);
const $2e62967d99bf606f$export$c60880f504524a89 = (t)=>{
    const s = t && t.src;
    if (!s || typeof s != "string") return null;
    const n = t.context;
    if (!n) return null;
    const r = n.assets && n.assets[s] || n.files && n.files[s];
    if (!r) return null;
    if (typeof r == "string") return {
        src: r,
        type: null,
        variants: null
    };
    if (typeof r == "object") {
        if (typeof r.src == "string") return r;
        const e = r.content, c = e && e.src;
        if (typeof c == "string") return {
            ...r,
            src: c,
            type: r.type ?? e.type ?? null,
            variants: r.variants ?? e.variants ?? null
        };
    }
    return null;
}, $2e62967d99bf606f$export$cc734a7c9455c1b3 = (t, { keepOneX: s = !0 } = {})=>{
    if (!Array.isArray(t) || !t.length) return "";
    const n = t.some((e)=>typeof e.width == "number"), r = [];
    for (const e of t)n && typeof e.width == "number" ? r.push(`${e.src} ${e.width}w`) : n || (e.scale === 1 && s ? r.push(e.src) : e.scale && e.scale !== 1 && r.push(`${e.src} ${e.scale}x`));
    return r.join(", ");
}, $2e62967d99bf606f$export$48745ce9fb63d5f0 = (t)=>{
    if (!t || !Array.isArray(t.variants)) return "";
    const s = t.variants.filter((n)=>n.format === t.type);
    return $2e62967d99bf606f$export$cc734a7c9455c1b3(s, {
        keepOneX: !1
    });
}, $2e62967d99bf606f$export$95efbd354ca64535 = (t, s)=>{
    if (!t || typeof t != "object" || typeof t.src != "string") return [];
    if (!Array.isArray(t.variants) || !t.variants.length) return [
        {
            tag: "img",
            attr: {
                src: t.src,
                alt: s || ""
            }
        }
    ];
    const n = new Map;
    for (const o of t.variants)n.has(o.format) || n.set(o.format, []), n.get(o.format).push(o);
    const r = [];
    for (const [o, u] of n)o !== t.type && r.push({
        tag: "source",
        attr: {
            type: o,
            srcset: $2e62967d99bf606f$export$cc734a7c9455c1b3(u, {
                keepOneX: !0
            })
        }
    });
    const e = n.get(t.type) || [], c = $2e62967d99bf606f$export$cc734a7c9455c1b3(e, {
        keepOneX: !1
    }), f = {
        src: t.src,
        alt: s || ""
    };
    return c && (f.srcset = c), [
        ...r,
        {
            tag: "img",
            attr: f
        }
    ];
};

});


parcelRegister("1NxyO", function(module, exports) {

$parcel$export(module.exports, "getSDK", () => $14f46676938d5cc1$export$9d1e2f4275173627);
$parcel$export(module.exports, "awaitSDKInit", () => $14f46676938d5cc1$export$c4807e473bcddd07);
$parcel$export(module.exports, "awaitCrossAppHydration", () => $14f46676938d5cc1$export$d2a1061a191938fc);
// SDK singleton client — split out of sdk.js so every OTHER export in that
// file (getMe/login/sdkLogout/isAuthenticated/getUserProfileCached/
// listOrganizationsCached/fetchPublicProjectFromSDK/
// fetchPublicProjectVisibilityFromSDK/unlockPublicProjectFromSDK/
// fetchProjectFromSDK/resolveEnvPublishConfig/…) can `import { getSDK } from
// './sdkClient.js'` instead of bare-calling a same-file sibling export.
//
// FA204 / frank trap (project_frank_drops_module_local_helpers): a
// same-file sibling-export/module-local read is unresolvable once the
// reading function is individually frank.toJSON'd for platform delivery; a
// cross-file ESM import resolves fine via frank's globalScope prototype-
// chain fallback. `getSDK` used to be bare-called from a DOZEN sibling
// exports in sdk.js — the usual per-export inline-copy recipe would mean
// duplicating this whole stateful singleton (SDK construction, the
// init-await Proxy, the deferred-subscribe shim) a dozen times, each an
// INDEPENDENT copy that would silently diverge from real singleton
// semantics (a fresh-per-call `_sdkByKey` Map is not a cache at all).
// Moving it here once, imported everywhere it's read, gets the same
// frank-safety with a single, genuinely-shared implementation.
//
// `_sdkByKey`/`_initPromiseByKey`/`_crossAppHydration` are re-homed onto
// `globalThis.__sdkClientState` (the aiService.js/pointerCapability.js
// template) rather than plain module `let`/`Map()` — this file's OWN
// `getSDK`/`awaitSDKInit` still reference each other/module-locals bare
// (a same-file trap, just a much smaller one now), so each of THIS file's
// three exports below carries its own self-contained inline copy of
// whichever locals it needs, same recipe as every other file in this sweep.

var $S1wNg = parcelRequire("S1wNg");

var $hmkNw = parcelRequire("hmkNw");

var $b1lQC = parcelRequire("b1lQC");

var $kkyxm = parcelRequire("kkyxm");

var $3xVCk = parcelRequire("3xVCk");

var $5Wuyg = parcelRequire("5Wuyg");

var $29wU0 = parcelRequire("29wU0");

var $jhJrJ = parcelRequire("jhJrJ");
function $14f46676938d5cc1$export$9d1e2f4275173627({ useLocal: useLocal = false, useNext: useNext = false } = {}) {
    // FA204 / frank trap — self-contained inline copy of the shared-state
    // accessor; every one of this file's exports carries its own.
    function sdkClientState() {
        return globalThis.__sdkClientState = globalThis.__sdkClientState || {
            sdkByKey: new Map(),
            initPromiseByKey: new Map(),
            // Resolves once the cross-app iframe handoff has settled (or
            // immediately when there is nothing to do). Boot awaits this BEFORE
            // deciding a user is signed out, so a dev canvas does not redirect to
            // /login while the peer's session is still in flight. See
            // `awaitCrossAppHydration` below.
            crossAppHydration: null
        };
    }
    // SDK token provider for /workspace/* surfaces.
    //
    // The wrapper at <channel>.api.symbols.app/workspace (and the local
    // express bridge) authenticates by reading `Authorization: Bearer <jwt>`.
    // It resolves scope from the SDK Mongo token (`symbols_access_token`):
    // `workspace-project/src/auth.js claimsToScope` calls the injected
    // userResolver, which reads `User.activeOrganization` from Mongo LIVE and
    // derives the home workspace — so an org-switch or workspace-rename takes
    // effect immediately. (The old governance Supabase-JWT fallback was
    // removed with that project.)
    async function workspaceTokenProvider() {
        if (typeof window === 'undefined') return null;
        // PERSONA (per-tab) — the sessionStorage overlay wins over the admin's
        // own localStorage token. This provider is wired into EVERY
        // /workspace-project/* request (chat, calendar, documents, tickets) and
        // read localStorage directly, bypassing TokenManager entirely; while a
        // persona was active that meant those surfaces kept answering with FULL
        // admin data while the rest of the app was narrowed — one app, two
        // identities, no error anywhere. The key is TokenManager's
        // `personaStorageKey` (`symbols_` + `persona_access_token`), which is
        // sessionStorage and therefore per-tab by construction; the literal is
        // inlined per the FA204 discipline this file already follows.
        try {
            const personaToken = window.sessionStorage.getItem('symbols_persona_access_token');
            if (personaToken) return personaToken;
        } catch  {
        /* locked storage — fall through to the base session token */ }
        try {
            return window.localStorage.getItem('symbols_access_token');
        } catch  {
            return null;
        }
    }
    // Synchronous read of the active-workspace id used to stamp telemetry
    // envelopes. Matches the canonical client-side source bootShell already
    // reads (`localStorage.activeWorkspace`). Returns null when the value
    // is unavailable (first-time visitor, SSR, locked storage) — the server
    // then falls through to its scope resolver for authenticated requests.
    function readActiveWorkspaceId() {
        if (typeof window === 'undefined') return null;
        try {
            return (0, $jhJrJ.getActiveWorkspacePointer)() || null;
        } catch  {
            return null;
        }
    }
    // ── SDK instances per apiUrl ────────────────────────────────────────────
    // The SDK (see sdk/src/config/environment.js) picks its own apiUrl based
    // on `SYMBOLS_APP_ENVIRONMENT`; we only override with an explicit
    // `apiUrl` when the caller opts into `--local` or `--next` so we don't
    // re-hardcode the production URL here. Channel URLs come from
    // @symbo.ls/channels — single source of truth across sdk, smbls, server,
    // editor, workspace, platform.
    function resolveApiUrl({ useLocal: useLocal, useNext: useNext } = {}) {
        if (useLocal) return (0, $hmkNw.apiUrl)('local');
        if (useNext) return (0, $hmkNw.apiUrl)('next');
        // Single source of truth — `workspaceApiBase` resolves through
        // `@symbo.ls/channels` after honoring runtime + localStorage
        // overrides + hostname autodetect (project-preview wildcards
        // like `<owner>--<key>.dev.preview.symbols.app` resolve to the
        // matching tier's API). The SDK and every other workspace API
        // consumer (agentMessages, dashboard slug check) share this base
        // so flipping one knob
        // (`localStorage.symbols_api_channel='localNext'`, or
        // `localStorage.symbols_workspace_api='https://...'`) routes every
        // /workspace/* and /core/* call at once.
        if (typeof window !== 'undefined') return (0, $29wU0.workspaceApiBase)();
        return undefined;
    }
    // These methods read local state synchronously and must not be wrapped —
    // callers use them as guards (!!sdk.getAuthToken()) before async work.
    const SYNC_PASS = new Set([
        'getAuthToken',
        'isReady',
        'getToken',
        'logout'
    ]);
    // `subscribeUserEvents` is auto-proxied onto the SDK from AuthService
    // AFTER `sdk.initialize()` resolves — it's NOT on the SDK at construction
    // time. The shell calls `el.sdk.subscribeUserEvents({...})` from
    // onCreate, which runs before init can complete, so a naive sync-pass
    // returns `undefined` and throws TypeError. We can't make it
    // Promise<fn> either — callers need a sync unsubscribe handle to bind
    // into `el.onRemove`. Solution: return a shim that schedules the real
    // subscribe-after-init and returns a sync cancel token that no-ops if
    // the deferred subscribe is still pending.
    function deferredSubscribeUserEvents(sdk, initPromise) {
        return (handlers)=>{
            let realUnsub = null;
            let cancelled = false;
            initPromise.then(()=>{
                if (cancelled) return;
                const fn = sdk.subscribeUserEvents;
                // Capability check, not error. Older SDK versions (pre-
                // AuthService proxy expansion) don't expose subscribeUserEvents
                // — the workspace shell tolerates that gracefully (no realtime,
                // but no spam either). Was a `console.warn` that flooded every
                // mount on version-skewed deploys; the call site is purely
                // additive, not load-bearing.
                if (typeof fn !== 'function') return;
                try {
                    realUnsub = fn.call(sdk, handlers);
                } catch (err) {
                    console.warn('[sdk] subscribeUserEvents threw:', err?.message || err);
                }
            }).catch(()=>{});
            return ()=>{
                cancelled = true;
                if (typeof realUnsub === 'function') try {
                    realUnsub();
                } catch (_) {}
            };
        };
    }
    // THE FOUR SYNCHRONOUS READS BEFORE INIT. The boot exposes this proxy as
    // el.sdk before `initialize()` settles (shared bootPrepare, both builds),
    // and the SDK builds its services IN initialize() — so before it
    // `getAuthToken()` threw "Service 'auth' not found". The answer must not
    // depend on timing: until the init settles the token reads come from the
    // stored session (what the TokenManager loads on init), isReady() is
    // false, and logout() waits for the init it would otherwise race
    // (sdkClient.lateInit.test.js).
    function syncBeforeInit(target, prop, value, initPromise) {
        // Only BEFORE init settles (tracked from the wrap, see wrapWithInitAwait):
        // after it, an error is a real error and is rethrown — never hidden
        // behind the stored token (one-boot review D10).
        return (...args)=>{
            try {
                return value.apply(target, args);
            } catch (err) {
                if (!initPromise || initPromise.__settled) throw err;
                if (prop === 'isReady') return false;
                if (prop === 'logout') return initPromise.then(()=>value.apply(target, args));
                // exactly the key the SDK's TokenManager loads on init — the same
                // identity it will answer with, and never a token that is not there
                try {
                    return globalThis.localStorage?.getItem?.('symbols_access_token') || null;
                } catch (_) {
                    return null;
                }
            }
        };
    }
    // Wrap the SDK so every method call awaits initialization first.
    // Property reads for non-function values (e.g. sdk.environment,
    // sdk.rootBus) pass through synchronously.
    function wrapWithInitAwait(sdk, initPromise) {
        // settle tracking starts with the wrap, so the first read after init
        // already sees it settled
        if (initPromise && !initPromise.__settleTracked) {
            initPromise.__settleTracked = true;
            initPromise.__settled = false;
            initPromise.then(()=>initPromise.__settled = true, ()=>initPromise.__settled = true);
        }
        return new Proxy(sdk, {
            get (target, prop) {
                if (prop === 'subscribeUserEvents') return deferredSubscribeUserEvents(target, initPromise);
                const value = target[prop];
                if (typeof value !== 'function') return value;
                if (SYNC_PASS.has(prop)) return syncBeforeInit(target, prop, value, initPromise);
                return (...args)=>initPromise.then(()=>value.apply(target, args));
            }
        });
    }
    // Default: derive apiUrl from the active channel via workspaceApiBase()
    // (which honors hostname autodetect + localStorage overrides + build-
    // time NODE_ENV). `useNext: true` is opt-in only — it forces the `next`
    // channel regardless of host, kept as an escape hatch for explicit
    // testing against next.api.
    // THE NULL CLIENT — for a host where the SDK class never arrived.
    //
    // `SDK` comes from a top-level `import { SDK } from '@symbo.ls/sdk'`, and
    // frank stubs every cross-package specifier (`stubExternalsPlugin`,
    // smbls/plugins/frank/toJSON.js). On a served record the read collapses, so
    // `new SDK(opts)` threw `__scope.__import_sdk2.SDK is not a constructor` as
    // an UNHANDLED REJECTION — measured on the served UI-kit catalog
    // (2026-09-20) from TicketsDetailModal and PromptGalleryChip, neither of
    // which needs a live backend to render. A rejection there takes the whole
    // surface down; a client that answers "nothing" does not.
    //
    // WHAT IT PROMISES, stated so a caller can rely on it:
    //   • `isNullClient === true` — the hard signal. A caller that must NOT
    //     pretend it reached a backend reads this, not a method result.
    //   • the four SYNC_PASS guards stay SYNCHRONOUS (`!!sdk.getAuthToken()` is
    //     used as a signed-in test; a promise there reads truthy and sends a
    //     signed-out user down the signed-in path).
    //   • `rootBus.on` answers a no-op unsubscribe — six shared components
    //     dereference it directly.
    //   • `subscribeUserEvents` answers a SYNCHRONOUS unsubscribe, the same
    //     contract `deferredSubscribeUserEvents` above keeps, because the shell
    //     binds the return straight into `el.onRemove`.
    //   • every other method resolves `null` — the unwrapped shape the real
    //     `execute` resolves (BaseService._call already unwraps `{success,data}`
    //     → `data`), so `commentRowsFrom(null)` and every `?.` guard behave.
    //   • `then`/`catch`/`finally` and every Symbol answer undefined, so the
    //     client is never mistaken for a thenable by an `await`.
    // It warns ONCE per host. A per-call warning floods the console of a host
    // that simply has no backend.
    //
    // FA204 / frank trap — inlined here rather than hoisted to module scope,
    // the same discipline every other export in this file follows.
    function nullSDKClient(state) {
        if (!state.nullClient) {
            console.warn("[sdk] @symbo.ls/sdk resolved without a constructor in this host \u2014 serving a null client. Every call answers null and no backend is reached.");
            const noop = ()=>{};
            const bus = {
                on: ()=>noop,
                off: noop,
                emit: noop,
                once: ()=>noop
            };
            const sync = {
                getAuthToken: ()=>null,
                getToken: ()=>null,
                isReady: ()=>false,
                logout: noop
            };
            state.nullClient = new Proxy({}, {
                get (_target, prop) {
                    if (typeof prop !== 'string') return undefined;
                    if (prop === 'then' || prop === 'catch' || prop === 'finally') return undefined;
                    if (prop === 'isNullClient') return true;
                    if (prop === 'rootBus') return bus;
                    if (prop === 'environment') return null;
                    if (prop === 'subscribeUserEvents') return ()=>noop;
                    if (prop in sync) return sync[prop];
                    return ()=>Promise.resolve(null);
                }
            });
        }
        return state.nullClient;
    }
    const apiUrl = resolveApiUrl({
        useLocal: useLocal,
        useNext: useNext
    });
    const cacheKey = apiUrl || 'default';
    const state = sdkClientState();
    if (typeof (0, $S1wNg.SDK) !== 'function') return nullSDKClient(state);
    // FAIL CLOSED: in a browser, '' means workspaceApiBase found no host rule
    // and no injected deployment identity. An SDK built without apiUrl falls to
    // its registry default (production) — the wrong plane. Serve the null
    // client instead (workspaceApiBase.failClosed.test.js).
    if (typeof window !== 'undefined' && apiUrl === '') return nullSDKClient(state);
    if (!state.sdkByKey.has(cacheKey)) {
        // HOTFIX 2026-10-08 (P0): the `smbls_session` cookie on Domain=symbols.app
        // carried the access + refresh token to EVERY *.symbols.app page — user
        // project code on `<owner>--<key>.preview.symbols.app` included — and dev +
        // prod shared it. Never read it (was hydrateAuthFromCookie), never write it
        // (was installAuthSync); delete the copy a previous build left. Cross-host
        // sign-in goes through the iframe bridge below
        // (__tests__/sdkClientNoSessionCookie.test.js).
        try {
            if (typeof (0, $b1lQC.clearAuthCookie) === 'function') (0, $b1lQC.clearAuthCookie)();
        } catch (_) {
        /* no document (SSR) — nothing to delete */ }
        // The cookie strategy above only works on prod `.symbols.app` — Chrome
        // silently drops cookies with `domain=.localhost`, which is why local
        // dev needs the iframe handoff instead. `hydrateAuthFromIframeBridge`
        // was written and exported for exactly that, but had NO callers, so a
        // dev canvas never picked up the workspace session and bounced to
        // /login. bootShell's own comment ("cookie/iframe handoff lands
        // asynchronously") already assumed this ran.
        //
        // Self-guarding: resolves false immediately when the local session is
        // already fresh, when there is no peer origin, or when the peer
        // resolves to this same origin — so it is a no-op in prod and on a
        // signed-in tab.
        //
        // ACCESS-ONLY (2026-10-09): the bridge hands over the access token only
        // (sessionBridgeTokens.js). `reacquireBridgeSession({ ifStale: true })`
        // also never borrows on an origin that owns its own refresh token, and
        // drops a copied refresh token an older build left here. The SDK's
        // `hydrateAuthFromIframeBridge` stays as the fallback for a realm without
        // the new helper.
        //
        // OWNER vs PEER vs COPY (review M2 + D1, 2026-10-09; Nika: "No, avoid the
        // sign-out"). symbols_session_source: 'own' = a sign-in on THIS origin wrote
        // the refresh token (markOwnSession / the SDK); 'bridge' = adopted from the
        // /_session-bridge peer. An origin with an own refresh token owns the login:
        // no reacquirer — when the server refuses it, it signs out, never borrows.
        // A refresh token WITHOUT the 'own' mark:
        //   - on the shell (not a borrower): its own login from before the mark
        //     existed → mark it 'own';
        //   - on the canvas (the borrower): a COPY an older bridge build handed
        //     over. Take it out of storage BEFORE the SDK loads (so the SDK can
        //     never rotate the shell's token), ask the bridge, and adopt its token.
        //     If the bridge has no session, the token was this origin's own login:
        //     put it back, mark it 'own'. Never a sign-out either way.
        let ownsRefreshToken = false;
        let legacyRefreshCopy = null;
        let restoredOwnRefresh = false;
        // D1 (live on canvas.dev, 2026-10-11): restore a copy as 'own' ONLY on
        // the peer's explicit ok:false, and never on a 'bridge'-marked origin.
        let copyWasBridgeMarked = false;
        let peerSaidNoSession = false;
        try {
            if (typeof window !== 'undefined') {
                const ls = window.localStorage;
                const refresh = ls.getItem('symbols_refresh_token');
                if (refresh && ls.getItem('symbols_session_source') !== 'own') {
                    if (typeof (0, $3xVCk.isSessionBridgeBorrower) === 'function' && (0, $3xVCk.isSessionBridgeBorrower)() && typeof (0, $kkyxm.reacquireBridgeSession) === 'function') {
                        legacyRefreshCopy = refresh;
                        copyWasBridgeMarked = ls.getItem('symbols_session_source') === 'bridge';
                        ls.removeItem('symbols_refresh_token');
                    } else ls.setItem('symbols_session_source', 'own');
                }
                ownsRefreshToken = !!ls.getItem('symbols_refresh_token');
            }
        } catch (_) {
        /* locked storage — treat as no own login */ }
        // The SDK (>= 3.14.813) passes its re-ask options ({ timeoutMs, onNoSession }).
        const bridgeReacquirer = !ownsRefreshToken && typeof (0, $kkyxm.reacquireBridgeSession) === 'function' ? (opts)=>(0, $kkyxm.reacquireBridgeSession)(opts) : undefined;
        const restoreOwnRefresh = ()=>{
            try {
                window.localStorage.setItem('symbols_refresh_token', legacyRefreshCopy);
                window.localStorage.setItem('symbols_session_source', 'own');
                restoredOwnRefresh = true;
            } catch (_) {
            /* locked storage — nothing to restore into */ }
            return null;
        };
        const bridgeHydration = Promise.resolve(legacyRefreshCopy ? (0, $kkyxm.reacquireBridgeSession)({
            // The FIRST (cold) ask: staging answered at 4,202 / 4,460 ms, past the
            // helper's 4 s default (2026-10-11). Later re-asks keep the 4 s.
            timeoutMs: 8000,
            onNoSession: ()=>{
                peerSaidNoSession = true;
            }
        }).then((got)=>got || (peerSaidNoSession && !copyWasBridgeMarked ? restoreOwnRefresh() : null), ()=>null) : typeof (0, $kkyxm.reacquireBridgeSession) === 'function' ? (0, $kkyxm.reacquireBridgeSession)({
            ifStale: true,
            timeoutMs: 8000
        }) : (0, $b1lQC.hydrateAuthFromIframeBridge)()).catch(()=>null);
        state.crossAppHydration = bridgeHydration.then((v)=>!!v);
        const opts = {
            debug: false
        };
        if (apiUrl) opts.apiUrl = apiUrl;
        const sdk = new (0, $S1wNg.SDK)(opts);
        // `workspaceProjectTokenProvider` supplies the bearer for
        // /workspace-project/* — it prefers the SDK Mongo token
        // (`workspaceTokenProvider` above).
        //
        // Workspace/org switching goes through `sdk.switchWorkspace(wsId)`,
        // which writes the active workspace to Mongo (the source of truth the
        // workspace-project userResolver reads). The old governance-Supabase
        // federation re-mint callback was removed with that project.
        //
        // `tracking.workspaceId` stamps `envelope.workspace_id` on every
        // /core/analyzed/ingest call. Reads the same `activeWorkspace`
        // localStorage key bootShell uses, so returning users get correct
        // cross-tenant attribution even during the auth/me race window.
        // Authenticated steady-state is resolved server-side from the auth
        // context regardless; this only covers the in-flight pre-attachUser
        // window + anonymous events.
        const initRaw = sdk.initialize({
            workspaceProjectTokenProvider: workspaceTokenProvider,
            // ACCESS-ONLY peer session: on expiry the SDK asks the bridge again
            // instead of signing out (TokenManager.setSessionReacquirer; an SDK
            // without it ignores this key and the renewal below covers it).
            // Undefined on an owner origin — see OWNER vs PEER above.
            reacquireSession: bridgeReacquirer,
            tracking: {
                // ANALYZING-DOUBLE-BOOT-1 (tickets/analytics.md): the SDK's
                // TrackingService is ENABLED BY DEFAULT and boots its OWN
                // createAnalyzing client (appName default 'workspace') — a SECOND
                // full analytics session per page load beside the shell's
                // bootAnalyzing client, with its own session id and its own
                // workspace stamp (this localStorage read vs the shell resolver —
                // the measured different-tenant pair). The shell's client is the
                // featured one (capture wiring, identify, session rotation), so
                // the SDK's stays OFF here. workspaceId kept so a deliberate
                // re-enable stamps correctly.
                enabled: false,
                workspaceId: readActiveWorkspaceId()
            }
        }).catch((err)=>{
            console.warn('[sdk] initialize failed:', err?.message || err);
        });
        // Once init AND the cold-boot handoff settle: a borrowed session the
        // TokenManager did not load (it reads storage at construction, the
        // handoff lands later) is adopted as access-only, then the renewal for an
        // SDK without the reacquirer hook is armed (sessionBridgeRenewal.js).
        const settled = Promise.all([
            initRaw,
            bridgeHydration
        ]).then(([, borrowed])=>{
            const tm = sdk._tokenManager;
            if (restoredOwnRefresh) // The copy was this origin's own login: let the TokenManager load it.
            {
                if (tm && typeof tm.loadTokens === 'function') tm.loadTokens();
            } else if (tm && borrowed && typeof borrowed === 'object' && borrowed.access_token && !tm.hasRefreshToken?.() && tm.getAccessToken?.() !== borrowed.access_token) {
                if (typeof tm.adoptAccessToken === 'function') tm.adoptAccessToken(borrowed);
                else if (typeof tm.setTokens === 'function') tm.setTokens({
                    access_token: borrowed.access_token,
                    expires_in: borrowed.expires_at ? Math.max(1, Math.floor((borrowed.expires_at - Date.now()) / 1000)) : undefined,
                    token_type: 'Bearer'
                });
            }
            if (typeof (0, $5Wuyg.installBridgeSessionRenewal) === 'function') (0, $5Wuyg.installBridgeSessionRenewal)(sdk);
        }).catch(()=>{});
        // While a copied refresh token is being judged, no SDK call may run (it
        // would sign out on the stripped session): init waits for the bridge.
        const initPromise = legacyRefreshCopy ? settled.then(()=>initRaw) : initRaw;
        state.initPromiseByKey.set(cacheKey, initPromise);
        state.sdkByKey.set(cacheKey, wrapWithInitAwait(sdk, initPromise));
    }
    return state.sdkByKey.get(cacheKey);
}
async function $14f46676938d5cc1$export$c4807e473bcddd07(opts = {}) {
    // Same frank stub, same host, second construction site. `getSDKInline`
    // below carries its own byte-identical `new SDK(opts)`, so without this
    // line a served record throws here too — and this one is AWAITED, so it
    // rejects a caller that was only asking "is init done yet". A null client
    // never initializes, so a settled promise is the honest answer. See the
    // null-client note in `getSDK` above.
    if (typeof (0, $S1wNg.SDK) !== 'function') return;
    // FA204 / frank trap — self-contained inline copies of the shared-state
    // accessor and the FULL `getSDK` singleton accessor (a bare sibling-
    // export call is exactly as unresolvable post-frank.toJSON as a
    // module-local read — duplicating the whole thing once here is the
    // tradeoff that keeps every OTHER file in the app importing `getSDK`
    // cross-file instead of duplicating it). Kept byte-identical to the
    // export above.
    function sdkClientState() {
        return globalThis.__sdkClientState = globalThis.__sdkClientState || {
            sdkByKey: new Map(),
            initPromiseByKey: new Map(),
            crossAppHydration: null
        };
    }
    function getSDKInline({ useLocal: useLocal = false, useNext: useNext = false } = {}) {
        async function workspaceTokenProvider() {
            if (typeof window === 'undefined') return null;
            try {
                return window.localStorage.getItem('symbols_access_token');
            } catch  {
                return null;
            }
        }
        function readActiveWorkspaceId() {
            if (typeof window === 'undefined') return null;
            try {
                return (0, $jhJrJ.getActiveWorkspacePointer)() || null;
            } catch  {
                return null;
            }
        }
        function resolveApiUrl({ useLocal: useLocal, useNext: useNext } = {}) {
            if (useLocal) return (0, $hmkNw.apiUrl)('local');
            if (useNext) return (0, $hmkNw.apiUrl)('next');
            if (typeof window !== 'undefined') return (0, $29wU0.workspaceApiBase)();
            return undefined;
        }
        const SYNC_PASS = new Set([
            'getAuthToken',
            'isReady',
            'getToken',
            'logout'
        ]);
        function deferredSubscribeUserEvents(sdk, initPromise) {
            return (handlers)=>{
                let realUnsub = null;
                let cancelled = false;
                initPromise.then(()=>{
                    if (cancelled) return;
                    const fn = sdk.subscribeUserEvents;
                    if (typeof fn !== 'function') return;
                    try {
                        realUnsub = fn.call(sdk, handlers);
                    } catch (err) {
                        console.warn('[sdk] subscribeUserEvents threw:', err?.message || err);
                    }
                }).catch(()=>{});
                return ()=>{
                    cancelled = true;
                    if (typeof realUnsub === 'function') try {
                        realUnsub();
                    } catch (_) {}
                };
            };
        }
        // THE FOUR SYNCHRONOUS READS BEFORE INIT. The boot exposes this proxy as
        // el.sdk before `initialize()` settles (shared bootPrepare, both builds),
        // and the SDK builds its services IN initialize() — so before it
        // `getAuthToken()` threw "Service 'auth' not found". The answer must not
        // depend on timing: until the init settles the token reads come from the
        // stored session (what the TokenManager loads on init), isReady() is
        // false, and logout() waits for the init it would otherwise race
        // (sdkClient.lateInit.test.js).
        function syncBeforeInit(target, prop, value, initPromise) {
            // Only BEFORE init settles (tracked from the wrap, see wrapWithInitAwait):
            // after it, an error is a real error and is rethrown — never hidden
            // behind the stored token (one-boot review D10).
            return (...args)=>{
                try {
                    return value.apply(target, args);
                } catch (err) {
                    if (!initPromise || initPromise.__settled) throw err;
                    if (prop === 'isReady') return false;
                    if (prop === 'logout') return initPromise.then(()=>value.apply(target, args));
                    // exactly the key the SDK's TokenManager loads on init — the same
                    // identity it will answer with, and never a token that is not there
                    try {
                        return globalThis.localStorage?.getItem?.('symbols_access_token') || null;
                    } catch (_) {
                        return null;
                    }
                }
            };
        }
        function wrapWithInitAwait(sdk, initPromise) {
            // settle tracking starts with the wrap, so the first read after init
            // already sees it settled
            if (initPromise && !initPromise.__settleTracked) {
                initPromise.__settleTracked = true;
                initPromise.__settled = false;
                initPromise.then(()=>initPromise.__settled = true, ()=>initPromise.__settled = true);
            }
            return new Proxy(sdk, {
                get (target, prop) {
                    if (prop === 'subscribeUserEvents') return deferredSubscribeUserEvents(target, initPromise);
                    const value = target[prop];
                    if (typeof value !== 'function') return value;
                    if (SYNC_PASS.has(prop)) return syncBeforeInit(target, prop, value, initPromise);
                    return (...args)=>initPromise.then(()=>value.apply(target, args));
                }
            });
        }
        const apiUrl = resolveApiUrl({
            useLocal: useLocal,
            useNext: useNext
        });
        const cacheKey = apiUrl || 'default';
        const state = sdkClientState();
        // Fail closed, as getSDK above: no API plane → no SDK, nothing to await.
        if (typeof window !== 'undefined' && apiUrl === '') return null;
        if (!state.sdkByKey.has(cacheKey)) {
            // HOTFIX 2026-10-08 (P0) — see getSDK: never read or write the
            // `smbls_session` cookie; delete the copy a previous build left.
            try {
                if (typeof (0, $b1lQC.clearAuthCookie) === 'function') (0, $b1lQC.clearAuthCookie)();
            } catch (_) {
            /* no document (SSR) — nothing to delete */ }
            // OWNER vs PEER vs COPY — byte-identical to getSDK above (review M2 + D1).
            // OWNER vs PEER vs COPY (review M2 + D1, 2026-10-09; Nika: "No, avoid the
            // sign-out"). symbols_session_source: 'own' = a sign-in on THIS origin wrote
            // the refresh token (markOwnSession / the SDK); 'bridge' = adopted from the
            // /_session-bridge peer. An origin with an own refresh token owns the login:
            // no reacquirer — when the server refuses it, it signs out, never borrows.
            // A refresh token WITHOUT the 'own' mark:
            //   - on the shell (not a borrower): its own login from before the mark
            //     existed → mark it 'own';
            //   - on the canvas (the borrower): a COPY an older bridge build handed
            //     over. Take it out of storage BEFORE the SDK loads (so the SDK can
            //     never rotate the shell's token), ask the bridge, and adopt its token.
            //     If the bridge has no session, the token was this origin's own login:
            //     put it back, mark it 'own'. Never a sign-out either way.
            let ownsRefreshToken = false;
            let legacyRefreshCopy = null;
            let restoredOwnRefresh = false;
            // D1 (live on canvas.dev, 2026-10-11): restore a copy as 'own' ONLY on
            // the peer's explicit ok:false, and never on a 'bridge'-marked origin.
            let copyWasBridgeMarked = false;
            let peerSaidNoSession = false;
            try {
                if (typeof window !== 'undefined') {
                    const ls = window.localStorage;
                    const refresh = ls.getItem('symbols_refresh_token');
                    if (refresh && ls.getItem('symbols_session_source') !== 'own') {
                        if (typeof (0, $3xVCk.isSessionBridgeBorrower) === 'function' && (0, $3xVCk.isSessionBridgeBorrower)() && typeof (0, $kkyxm.reacquireBridgeSession) === 'function') {
                            legacyRefreshCopy = refresh;
                            copyWasBridgeMarked = ls.getItem('symbols_session_source') === 'bridge';
                            ls.removeItem('symbols_refresh_token');
                        } else ls.setItem('symbols_session_source', 'own');
                    }
                    ownsRefreshToken = !!ls.getItem('symbols_refresh_token');
                }
            } catch (_) {
            /* locked storage — treat as no own login */ }
            // The SDK (>= 3.14.813) passes its re-ask options ({ timeoutMs, onNoSession }).
            const bridgeReacquirer = !ownsRefreshToken && typeof (0, $kkyxm.reacquireBridgeSession) === 'function' ? (opts)=>(0, $kkyxm.reacquireBridgeSession)(opts) : undefined;
            const restoreOwnRefresh = ()=>{
                try {
                    window.localStorage.setItem('symbols_refresh_token', legacyRefreshCopy);
                    window.localStorage.setItem('symbols_session_source', 'own');
                    restoredOwnRefresh = true;
                } catch (_) {
                /* locked storage — nothing to restore into */ }
                return null;
            };
            const bridgeHydration = Promise.resolve(legacyRefreshCopy ? (0, $kkyxm.reacquireBridgeSession)({
                // The FIRST (cold) ask: staging answered at 4,202 / 4,460 ms, past the
                // helper's 4 s default (2026-10-11). Later re-asks keep the 4 s.
                timeoutMs: 8000,
                onNoSession: ()=>{
                    peerSaidNoSession = true;
                }
            }).then((got)=>got || (peerSaidNoSession && !copyWasBridgeMarked ? restoreOwnRefresh() : null), ()=>null) : typeof (0, $kkyxm.reacquireBridgeSession) === 'function' ? (0, $kkyxm.reacquireBridgeSession)({
                ifStale: true,
                timeoutMs: 8000
            }) : (0, $b1lQC.hydrateAuthFromIframeBridge)()).catch(()=>null);
            state.crossAppHydration = bridgeHydration.then((v)=>!!v);
            const opts = {
                debug: false
            };
            if (apiUrl) opts.apiUrl = apiUrl;
            const sdk = new (0, $S1wNg.SDK)(opts);
            const initRaw = sdk.initialize({
                workspaceProjectTokenProvider: workspaceTokenProvider,
                reacquireSession: bridgeReacquirer,
                tracking: {
                    // ANALYZING-DOUBLE-BOOT-1 (tickets/analytics.md): the SDK's
                    // TrackingService is ENABLED BY DEFAULT and boots its OWN
                    // createAnalyzing client (appName default 'workspace') — a SECOND
                    // full analytics session per page load beside the shell's
                    // bootAnalyzing client, with its own session id and its own
                    // workspace stamp (this localStorage read vs the shell resolver —
                    // the measured different-tenant pair). The shell's client is the
                    // featured one (capture wiring, identify, session rotation), so
                    // the SDK's stays OFF here. workspaceId kept so a deliberate
                    // re-enable stamps correctly.
                    enabled: false,
                    workspaceId: readActiveWorkspaceId()
                }
            }).catch((err)=>{
                console.warn('[sdk] initialize failed:', err?.message || err);
            });
            const settled = Promise.all([
                initRaw,
                bridgeHydration
            ]).then(([, borrowed])=>{
                const tm = sdk._tokenManager;
                if (restoredOwnRefresh) // The copy was this origin's own login: let the TokenManager load it.
                {
                    if (tm && typeof tm.loadTokens === 'function') tm.loadTokens();
                } else if (tm && borrowed && typeof borrowed === 'object' && borrowed.access_token && !tm.hasRefreshToken?.() && tm.getAccessToken?.() !== borrowed.access_token) {
                    if (typeof tm.adoptAccessToken === 'function') tm.adoptAccessToken(borrowed);
                    else if (typeof tm.setTokens === 'function') tm.setTokens({
                        access_token: borrowed.access_token,
                        expires_in: borrowed.expires_at ? Math.max(1, Math.floor((borrowed.expires_at - Date.now()) / 1000)) : undefined,
                        token_type: 'Bearer'
                    });
                }
                if (typeof (0, $5Wuyg.installBridgeSessionRenewal) === 'function') (0, $5Wuyg.installBridgeSessionRenewal)(sdk);
            }).catch(()=>{});
            // While a copied refresh token is being judged, no SDK call may run (it
            // would sign out on the stripped session): init waits for the bridge.
            const initPromise = legacyRefreshCopy ? settled.then(()=>initRaw) : initRaw;
            state.initPromiseByKey.set(cacheKey, initPromise);
            state.sdkByKey.set(cacheKey, wrapWithInitAwait(sdk, initPromise));
        }
        return state.sdkByKey.get(cacheKey);
    }
    function resolveApiUrl({ useLocal: useLocal, useNext: useNext } = {}) {
        if (useLocal) return (0, $hmkNw.apiUrl)('local');
        if (useNext) return (0, $hmkNw.apiUrl)('next');
        if (typeof window !== 'undefined') return (0, $29wU0.workspaceApiBase)();
        return undefined;
    }
    const cacheKey = resolveApiUrl(opts) || 'default';
    getSDKInline(opts);
    return sdkClientState().initPromiseByKey.get(cacheKey);
}
function $14f46676938d5cc1$export$d2a1061a191938fc() {
    function sdkClientState() {
        return globalThis.__sdkClientState = globalThis.__sdkClientState || {
            sdkByKey: new Map(),
            initPromiseByKey: new Map(),
            crossAppHydration: null
        };
    }
    return sdkClientState().crossAppHydration || Promise.resolve(false);
}

});
parcelRegister("S1wNg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isLocalhost", () => $0a263aacc9f32994$export$ec8a6426516240fc);
$parcel$export(module.exports, "SDK", () => $0a263aacc9f32994$export$f7af2da260061f5e);
$parcel$export(module.exports, "default", () => $0a263aacc9f32994$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseService", () => (parcelRequire("em51x")).BaseService);
$parcel$export(module.exports, "DEFAULT_TOKEN_KEYS", () => (parcelRequire("41Z4i")).DEFAULT_TOKEN_KEYS);
$parcel$export(module.exports, "PERMISSION_MAP", () => (parcelRequire("36Jqh")).PERMISSION_MAP);
$parcel$export(module.exports, "PERSONA_TARGET_ROLES", () => (parcelRequire("4Ccat")).PERSONA_TARGET_ROLES);
$parcel$export(module.exports, "PROJECT_ROLE_PERMISSIONS", () => (parcelRequire("36Jqh")).PROJECT_ROLE_PERMISSIONS);
$parcel$export(module.exports, "ROLE_PERMISSIONS", () => (parcelRequire("36Jqh")).ROLE_PERMISSIONS);
$parcel$export(module.exports, "TIER_FEATURES", () => (parcelRequire("36Jqh")).TIER_FEATURES);
$parcel$export(module.exports, "createActivityEntryService", () => (parcelRequire("861m8")).createActivityEntryService);
$parcel$export(module.exports, "createAdminService", () => (parcelRequire("861m8")).createAdminService);
$parcel$export(module.exports, "createAgreementService", () => (parcelRequire("861m8")).createAgreementService);
$parcel$export(module.exports, "createAiBoardsService", () => (parcelRequire("861m8")).createAiBoardsService);
$parcel$export(module.exports, "createAllocationRuleService", () => (parcelRequire("861m8")).createAllocationRuleService);
$parcel$export(module.exports, "createAnalyzedService", () => (parcelRequire("861m8")).createAnalyzedService);
$parcel$export(module.exports, "createAssistantsService", () => (parcelRequire("861m8")).createAssistantsService);
$parcel$export(module.exports, "createAttachmentService", () => (parcelRequire("861m8")).createAttachmentService);
$parcel$export(module.exports, "createAuthService", () => (parcelRequire("861m8")).createAuthService);
$parcel$export(module.exports, "createAvailabilityRuleService", () => (parcelRequire("861m8")).createAvailabilityRuleService);
$parcel$export(module.exports, "createBookingService", () => (parcelRequire("861m8")).createBookingService);
$parcel$export(module.exports, "createBootService", () => (parcelRequire("861m8")).createBootService);
$parcel$export(module.exports, "createBranchService", () => (parcelRequire("861m8")).createBranchService);
$parcel$export(module.exports, "createBuildsService", () => (parcelRequire("861m8")).createBuildsService);
$parcel$export(module.exports, "createCalendarService", () => (parcelRequire("861m8")).createCalendarService);
$parcel$export(module.exports, "createCanvasLayoutService", () => (parcelRequire("861m8")).createCanvasLayoutService);
$parcel$export(module.exports, "createChannelService", () => (parcelRequire("861m8")).createChannelService);
$parcel$export(module.exports, "createCollabService", () => (parcelRequire("861m8")).createCollabService);
$parcel$export(module.exports, "createCommentService", () => (parcelRequire("861m8")).createCommentService);
$parcel$export(module.exports, "createCompanyProfileService", () => (parcelRequire("861m8")).createCompanyProfileService);
$parcel$export(module.exports, "createConversationService", () => (parcelRequire("861m8")).createConversationService);
$parcel$export(module.exports, "createCreditsService", () => (parcelRequire("861m8")).createCreditsService);
$parcel$export(module.exports, "createCrmService", () => (parcelRequire("861m8")).createCrmService);
$parcel$export(module.exports, "createCrossAppAuth", () => (parcelRequire("41Z4i")).createCrossAppAuth);
$parcel$export(module.exports, "createDealService", () => (parcelRequire("861m8")).createDealService);
$parcel$export(module.exports, "createDnsService", () => (parcelRequire("861m8")).createDnsService);
$parcel$export(module.exports, "createDocService", () => (parcelRequire("861m8")).createDocService);
$parcel$export(module.exports, "createEntityDispatcher", () => (parcelRequire("eatmv")).createEntityDispatcher);
$parcel$export(module.exports, "createFeatureFlagService", () => (parcelRequire("861m8")).createFeatureFlagService);
$parcel$export(module.exports, "createFieldDefService", () => (parcelRequire("861m8")).createFieldDefService);
$parcel$export(module.exports, "createFileService", () => (parcelRequire("861m8")).createFileService);
$parcel$export(module.exports, "createFleetService", () => (parcelRequire("861m8")).createFleetService);
$parcel$export(module.exports, "createGrowthService", () => (parcelRequire("861m8")).createGrowthService);
$parcel$export(module.exports, "createImportsService", () => (parcelRequire("861m8")).createImportsService);
$parcel$export(module.exports, "createIntegrationService", () => (parcelRequire("861m8")).createIntegrationService);
$parcel$export(module.exports, "createInteractionService", () => (parcelRequire("861m8")).createInteractionService);
$parcel$export(module.exports, "createInvoiceService", () => (parcelRequire("861m8")).createInvoiceService);
$parcel$export(module.exports, "createLeadService", () => (parcelRequire("861m8")).createLeadService);
$parcel$export(module.exports, "createLeadSourceService", () => (parcelRequire("861m8")).createLeadSourceService);
$parcel$export(module.exports, "createMailService", () => (parcelRequire("861m8")).createMailService);
$parcel$export(module.exports, "createMcpConnectorService", () => (parcelRequire("861m8")).createMcpConnectorService);
$parcel$export(module.exports, "createMeetService", () => (parcelRequire("861m8")).createMeetService);
$parcel$export(module.exports, "createMetricsService", () => (parcelRequire("861m8")).createMetricsService);
$parcel$export(module.exports, "createOnboardingResearchService", () => (parcelRequire("861m8")).createOnboardingResearchService);
$parcel$export(module.exports, "createOrganizationService", () => (parcelRequire("861m8")).createOrganizationService);
$parcel$export(module.exports, "createPartyService", () => (parcelRequire("861m8")).createPartyService);
$parcel$export(module.exports, "createPaymentService", () => (parcelRequire("861m8")).createPaymentService);
$parcel$export(module.exports, "createPersonaService", () => (parcelRequire("861m8")).createPersonaService);
$parcel$export(module.exports, "createPlanService", () => (parcelRequire("861m8")).createPlanService);
$parcel$export(module.exports, "createPriceService", () => (parcelRequire("861m8")).createPriceService);
$parcel$export(module.exports, "createProductService", () => (parcelRequire("861m8")).createProductService);
$parcel$export(module.exports, "createProjectService", () => (parcelRequire("861m8")).createProjectService);
$parcel$export(module.exports, "createProposedActionService", () => (parcelRequire("861m8")).createProposedActionService);
$parcel$export(module.exports, "createPublicCollectionService", () => (parcelRequire("861m8")).createPublicCollectionService);
$parcel$export(module.exports, "createPullRequestService", () => (parcelRequire("861m8")).createPullRequestService);
$parcel$export(module.exports, "createRecordCollectionService", () => (parcelRequire("861m8")).createRecordCollectionService);
$parcel$export(module.exports, "createRecurrenceService", () => (parcelRequire("861m8")).createRecurrenceService);
$parcel$export(module.exports, "createRefsService", () => (parcelRequire("861m8")).createRefsService);
$parcel$export(module.exports, "createRegistryService", () => (parcelRequire("861m8")).createRegistryService);
$parcel$export(module.exports, "createResourceLinkService", () => (parcelRequire("861m8")).createResourceLinkService);
$parcel$export(module.exports, "createSegmentService", () => (parcelRequire("861m8")).createSegmentService);
$parcel$export(module.exports, "createShareLinkService", () => (parcelRequire("861m8")).createShareLinkService);
$parcel$export(module.exports, "createSharedAssetService", () => (parcelRequire("861m8")).createSharedAssetService);
$parcel$export(module.exports, "createStorefrontService", () => (parcelRequire("861m8")).createStorefrontService);
$parcel$export(module.exports, "createSubscriptionService", () => (parcelRequire("861m8")).createSubscriptionService);
$parcel$export(module.exports, "createTagService", () => (parcelRequire("861m8")).createTagService);
$parcel$export(module.exports, "createTicketService", () => (parcelRequire("861m8")).createTicketService);
$parcel$export(module.exports, "createTrackingService", () => (parcelRequire("861m8")).createTrackingService);
$parcel$export(module.exports, "createTransactionService", () => (parcelRequire("861m8")).createTransactionService);
$parcel$export(module.exports, "createVoiceService", () => (parcelRequire("861m8")).createVoiceService);
$parcel$export(module.exports, "createWaitlistService", () => (parcelRequire("861m8")).createWaitlistService);
$parcel$export(module.exports, "createWatcherService", () => (parcelRequire("861m8")).createWatcherService);
$parcel$export(module.exports, "createWorkflowService", () => (parcelRequire("861m8")).createWorkflowService);
$parcel$export(module.exports, "createWorkspaceProjectService", () => (parcelRequire("861m8")).createWorkspaceProjectService);
$parcel$export(module.exports, "createWorkspaceService", () => (parcelRequire("861m8")).createWorkspaceService);
$parcel$export(module.exports, "environment", () => (parcelRequire("gN40b")).default);
$parcel$export(module.exports, "isTierLocked", () => (parcelRequire("5SFNa")).isTierLocked);
$parcel$export(module.exports, "parentDomain", () => (parcelRequire("dNwK1")).parentDomain);
$parcel$export(module.exports, "readCookie", () => (parcelRequire("dNwK1")).readCookie);
$parcel$export(module.exports, "readTierLock", () => (parcelRequire("5SFNa")).readTierLock);
$parcel$export(module.exports, "registerEntity", () => (parcelRequire("eatmv")).registerEntity);
$parcel$export(module.exports, "workspaceProjectBaseUrl", () => (parcelRequire("5tLYA")).workspaceProjectBaseUrl);
$parcel$export(module.exports, "writeCookie", () => (parcelRequire("dNwK1")).writeCookie);

var $861m8 = parcelRequire("861m8");
var $4Ccat = parcelRequire("4Ccat");
var $5tLYA = parcelRequire("5tLYA");

var $huLI0 = parcelRequire("huLI0");

var $gN40b = parcelRequire("gN40b");

var $6v49f = parcelRequire("6v49f");

var $h5XS2 = parcelRequire("h5XS2");

var $bYl6S = parcelRequire("bYl6S");

var $eatmv = parcelRequire("eatmv");

var $em51x = parcelRequire("em51x");

var $41Z4i = parcelRequire("41Z4i");

var $dNwK1 = parcelRequire("dNwK1");

var $36Jqh = parcelRequire("36Jqh");

var $5SFNa = parcelRequire("5SFNa");
const $0a263aacc9f32994$var$je = ()=>typeof window < "u", $0a263aacc9f32994$export$ec8a6426516240fc = ()=>{
    if (!$0a263aacc9f32994$var$je()) return !1;
    const c = window.location && window.location.hostname;
    return c === "localhost" || c?.endsWith(".localhost") || c === "127.0.0.1" || c === "::1" || c === "" || !c;
};
class $0a263aacc9f32994$export$f7af2da260061f5e {
    constructor(e = {}){
        if (this._services = new Map, this._context = {}, this._options = this._validateOptions(e), this._tokenManager = null, this._options.tokenStorage) {
            const t = (0, $bYl6S.getTokenManager)({
                apiUrl: this._options.apiUrl,
                storageType: this._options.tokenStorage
            });
            t.config.storageType !== this._options.tokenStorage && (0, $h5XS2.logger).warn(`[SDK] tokenStorage "${this._options.tokenStorage}" ignored: this page's TokenManager already uses "${t.config.storageType}"`);
        }
        this._options.apiUrl && (this._context.apiUrl = this._options.apiUrl), (0, $h5XS2.setDebug)(this._options.debug), this.environment = (0, $gN40b.default), this.rootBus = (0, $6v49f.rootBus), this._createServiceProxies(), this.execute = (0, $eatmv.createEntityDispatcher)(this);
    }
    async initialize(e = {}) {
        const { reacquireSession: t, ...i } = e || {};
        return this._context = {
            ...this._context,
            ...i
        }, await Promise.all([
            this._initService("auth", (0, $861m8.createAuthService)({
                context: this._context,
                options: this._options
            })),
            this._initService("collab", (0, $861m8.createCollabService)({
                context: this._context,
                options: this._options
            })),
            this._initService("project", (0, $861m8.createProjectService)({
                context: this._context,
                options: this._options
            })),
            this._initService("plan", (0, $861m8.createPlanService)({
                context: this._context,
                options: this._options
            })),
            this._initService("subscription", (0, $861m8.createSubscriptionService)({
                context: this._context,
                options: this._options
            })),
            this._initService("file", (0, $861m8.createFileService)({
                context: this._context,
                options: this._options
            })),
            this._initService("payment", (0, $861m8.createPaymentService)({
                context: this._context,
                options: this._options
            })),
            this._initService("dns", (0, $861m8.createDnsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("branch", (0, $861m8.createBranchService)({
                context: this._context,
                options: this._options
            })),
            this._initService("pullRequest", (0, $861m8.createPullRequestService)({
                context: this._context,
                options: this._options
            })),
            this._initService("admin", (0, $861m8.createAdminService)({
                context: this._context,
                options: this._options
            })),
            this._initService("screenshot", (0, $861m8.createScreenshotService)({
                context: this._context,
                options: this._options
            })),
            this._initService("tracking", (0, $861m8.createTrackingService)({
                context: this._context,
                options: this._options
            })),
            this._initService("waitlist", (0, $861m8.createWaitlistService)({
                context: this._context,
                options: this._options
            })),
            this._initService("onboardingResearch", (0, $861m8.createOnboardingResearchService)({
                context: this._context,
                options: this._options
            })),
            this._initService("imports", (0, $861m8.createImportsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("metrics", (0, $861m8.createMetricsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("integration", (0, $861m8.createIntegrationService)({
                context: this._context,
                options: this._options
            })),
            this._initService("featureFlag", (0, $861m8.createFeatureFlagService)({
                context: this._context,
                options: this._options
            })),
            this._initService("organization", (0, $861m8.createOrganizationService)({
                context: this._context,
                options: this._options
            })),
            this._initService("workspace", (0, $861m8.createWorkspaceService)({
                context: this._context,
                options: this._options
            })),
            this._initService("boot", (0, $861m8.createBootService)({
                context: this._context,
                options: this._options
            })),
            this._initService("mcpConnector", (0, $861m8.createMcpConnectorService)({
                context: this._context,
                options: this._options
            })),
            this._initService("voice", (0, $861m8.createVoiceService)({
                context: this._context,
                options: this._options
            })),
            this._initService("workspaceProject", (0, $861m8.createWorkspaceProjectService)({
                context: this._context,
                options: this._options
            })),
            this._initService("aiChat", (0, $861m8.createAiChatService)({
                context: this._context,
                options: this._options
            })),
            this._initService("ai", (0, $861m8.createAiService)({
                context: this._context,
                options: this._options
            })),
            this._initService("docs", (0, $861m8.createDocService)({
                context: this._context,
                options: this._options
            })),
            this._initService("tickets", (0, $861m8.createTicketService)({
                context: this._context,
                options: this._options
            })),
            this._initService("fleet", (0, $861m8.createFleetService)({
                context: this._context,
                options: this._options
            })),
            this._initService("assistants", (0, $861m8.createAssistantsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("aiBoards", (0, $861m8.createAiBoardsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("analyzed", (0, $861m8.createAnalyzedService)({
                context: this._context,
                options: this._options
            })),
            this._initService("growth", (0, $861m8.createGrowthService)({
                context: this._context,
                options: this._options
            })),
            this._initService("proposedActions", (0, $861m8.createProposedActionService)({
                context: this._context,
                options: this._options
            })),
            this._initService("workflows", (0, $861m8.createWorkflowService)({
                context: this._context,
                options: this._options
            })),
            this._initService("fieldDefs", (0, $861m8.createFieldDefService)({
                context: this._context,
                options: this._options
            })),
            this._initService("recordCollections", (0, $861m8.createRecordCollectionService)({
                context: this._context,
                options: this._options
            })),
            this._initService("parties", (0, $861m8.createPartyService)({
                context: this._context,
                options: this._options
            })),
            this._initService("interactions", (0, $861m8.createInteractionService)({
                context: this._context,
                options: this._options
            })),
            this._initService("leads", (0, $861m8.createLeadService)({
                context: this._context,
                options: this._options
            })),
            this._initService("deals", (0, $861m8.createDealService)({
                context: this._context,
                options: this._options
            })),
            this._initService("leadSources", (0, $861m8.createLeadSourceService)({
                context: this._context,
                options: this._options
            })),
            this._initService("channels", (0, $861m8.createChannelService)({
                context: this._context,
                options: this._options
            })),
            this._initService("crm", (0, $861m8.createCrmService)({
                context: this._context,
                options: this._options
            })),
            this._initService("segments", (0, $861m8.createSegmentService)({
                context: this._context,
                options: this._options
            })),
            this._initService("products", (0, $861m8.createProductService)({
                context: this._context,
                options: this._options
            })),
            this._initService("prices", (0, $861m8.createPriceService)({
                context: this._context,
                options: this._options
            })),
            this._initService("companyProfile", (0, $861m8.createCompanyProfileService)({
                context: this._context,
                options: this._options
            })),
            this._initService("agreements", (0, $861m8.createAgreementService)({
                context: this._context,
                options: this._options
            })),
            this._initService("invoices", (0, $861m8.createInvoiceService)({
                context: this._context,
                options: this._options
            })),
            this._initService("transactions", (0, $861m8.createTransactionService)({
                context: this._context,
                options: this._options
            })),
            this._initService("comments", (0, $861m8.createCommentService)({
                context: this._context,
                options: this._options
            })),
            this._initService("attachments", (0, $861m8.createAttachmentService)({
                context: this._context,
                options: this._options
            })),
            this._initService("watchers", (0, $861m8.createWatcherService)({
                context: this._context,
                options: this._options
            })),
            this._initService("activityEntries", (0, $861m8.createActivityEntryService)({
                context: this._context,
                options: this._options
            })),
            this._initService("tags", (0, $861m8.createTagService)({
                context: this._context,
                options: this._options
            })),
            this._initService("registry", (0, $861m8.createRegistryService)({
                context: this._context,
                options: this._options
            })),
            this._initService("bookings", (0, $861m8.createBookingService)({
                context: this._context,
                options: this._options
            })),
            this._initService("availabilityRules", (0, $861m8.createAvailabilityRuleService)({
                context: this._context,
                options: this._options
            })),
            this._initService("conversations", (0, $861m8.createConversationService)({
                context: this._context,
                options: this._options
            })),
            this._initService("recurrences", (0, $861m8.createRecurrenceService)({
                context: this._context,
                options: this._options
            })),
            this._initService("mail", (0, $861m8.createMailService)({
                context: this._context,
                options: this._options
            })),
            this._initService("resourceLinks", (0, $861m8.createResourceLinkService)({
                context: this._context,
                options: this._options
            })),
            this._initService("shareLinks", (0, $861m8.createShareLinkService)({
                context: this._context,
                options: this._options
            })),
            this._initService("allocationRule", (0, $861m8.createAllocationRuleService)({
                context: this._context,
                options: this._options
            })),
            this._initService("sharedAsset", (0, $861m8.createSharedAssetService)({
                context: this._context,
                options: this._options
            })),
            this._initService("credits", (0, $861m8.createCreditsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("canvasLayout", (0, $861m8.createCanvasLayoutService)({
                context: this._context,
                options: this._options
            })),
            this._initService("refs", (0, $861m8.createRefsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("builds", (0, $861m8.createBuildsService)({
                context: this._context,
                options: this._options
            })),
            this._initService("meet", (0, $861m8.createMeetService)({
                context: this._context,
                options: this._options
            })),
            this._initService("calendar", (0, $861m8.createCalendarService)({
                context: this._context,
                options: this._options
            })),
            this._initService("storefront", (0, $861m8.createStorefrontService)({
                context: this._context,
                options: this._options
            })),
            this._initService("publicRecords", (0, $861m8.createPublicCollectionService)({
                context: this._context,
                options: this._options
            })),
            this._initService("persona", (0, $861m8.createPersonaService)({
                context: this._context,
                options: this._options
            }))
        ]), this._tokenManager = (0, $bYl6S.getTokenManager)(), typeof t == "function" && this._tokenManager.setSessionReacquirer(t), this;
    }
    adoptTokens({ accessToken: e, refreshToken: t, expiresAt: i, expiresIn: r } = {}) {
        if (!e) return !1;
        const s = this._tokenManager || (0, $bYl6S.getTokenManager)({
            apiUrl: this._options.apiUrl,
            ...this._options.tokenStorage ? {
                storageType: this._options.tokenStorage
            } : {}
        });
        let o = Number(r) || 0;
        return !o && Number(i) > Date.now() && (o = Math.round((Number(i) - Date.now()) / 1e3)), s.setTokens({
            access_token: e,
            refresh_token: t || void 0,
            ...o ? {
                expires_in: o
            } : {}
        }), !0;
    }
    async _initService(e, t) {
        this._context.services = {
            ...this._context.services,
            [e]: t
        }, await t.init({
            context: this._context,
            options: this._options
        }), this._services.set(e, t);
    }
    _validateOptions(e) {
        const t = {
            useNewServices: !0,
            apiUrl: (0, $gN40b.default).apiUrl,
            socketUrl: (0, $gN40b.default).socketUrl,
            timeout: 3e4,
            debug: !1,
            tracking: {
                enabled: !1
            }
        };
        return {
            ...t,
            ...e,
            tracking: {
                ...t.tracking,
                ...e.tracking || {}
            }
        };
    }
    getService(e) {
        if (!this._services.has(e)) throw new Error(`Service '${e}' not found`);
        return this._services.get(e);
    }
    updateContext(e) {
        const { ...t } = e || {};
        this._context = {
            ...this._context,
            ...t
        };
        for (const i of this._services.values())i.updateContext(this._context);
    }
    async switchOrg(e, t = {}) {
        if (!e) throw new Error("[sdk.switchOrg] newOrgId is required");
        const i = this._context.activeOrgId;
        if (i === e) return {
            changed: !1,
            orgId: e
        };
        const { skipPersist: r = !1, skipWorkspaceHop: s = !1, homeWorkspaceId: o = null } = t;
        let h = null;
        !r && typeof this.setActiveOrganization == "function" && (h = await this.setActiveOrganization(e)), this.updateContext({
            activeOrgId: e
        });
        const p = [];
        for (const [a, x] of this._services.entries())typeof x.switchOrg == "function" && p.push(Promise.resolve(x.switchOrg(e, i)).catch((l)=>{
            (0, $h5XS2.logger).error(`[sdk.switchOrg] Service '${a}' switchOrg failed:`, l);
        }));
        await Promise.all(p);
        let v = null;
        if (!s && o && typeof this.switchWorkspace == "function") try {
            v = await this.switchWorkspace(o);
        } catch (a) {
            (0, $h5XS2.logger).warn("[sdk.switchOrg] switchWorkspace hop failed:", a?.message || a);
        }
        return this.rootBus?.emit?.("sdk.orgSwitched", {
            previousOrgId: i,
            newOrgId: e,
            persist: h,
            workspaceHop: v
        }), {
            changed: !0,
            previousOrgId: i,
            newOrgId: e,
            persist: h,
            workspaceHop: v
        };
    }
    async switchWorkspace(e) {
        if (!e) throw new Error("[sdk.switchWorkspace] workspaceId is required");
        const t = this._context.activeWorkspaceId;
        if (t === e) return {
            ok: !0,
            changed: !1,
            workspaceId: e
        };
        typeof this.setActiveWorkspace == "function" && await this.setActiveWorkspace(e), this.updateContext({
            activeWorkspaceId: e
        });
        const i = [];
        for (const [r, s] of this._services.entries())typeof s.switchWorkspace == "function" && i.push(Promise.resolve(s.switchWorkspace(e, t)).catch((o)=>{
            (0, $h5XS2.logger).error(`[sdk.switchWorkspace] Service '${r}' switchWorkspace failed:`, o);
        }));
        if (await Promise.all(i), typeof globalThis < "u" && globalThis.localStorage) try {
            globalThis.localStorage.setItem("activeWorkspace", e);
        } catch  {}
        return this.rootBus?.emit?.("sdk.workspaceSwitched", {
            previousWorkspaceId: t,
            newWorkspaceId: e
        }), {
            ok: !0,
            changed: !0,
            previousWorkspaceId: t,
            newWorkspaceId: e
        };
    }
    isReady() {
        const e = Array.from(this._services.values());
        return e.length > 0 && e.every((t)=>t.isReady());
    }
    getStatus() {
        return {
            ready: this.isReady(),
            services: Array.from(this._services.entries()).map(([e, t])=>({
                    name: e,
                    ...t.getStatus()
                })),
            context: {
                ...this._context
            }
        };
    }
    async boot(e) {
        const t = await this.getService("boot").boot(e);
        try {
            const i = t?.data?.me?.user || null;
            i && this.getService("auth")?.adoptSessionUser?.(i);
        } catch  {}
        return t;
    }
    _createServiceProxies() {
        for (const [e, t] of Object.entries((0, $huLI0.SERVICE_METHODS)))this[e] || (this[e] = (...i)=>{
            const r = this.getService(t);
            if (!r[e]) throw new Error(`Method '${e}' not found on service '${t}'`);
            return r[e](...i);
        });
    }
    async destroy() {
        try {
            const e = Array.from(this._services.entries()).filter(([, t])=>typeof t.destroy == "function").map(async ([t, i])=>{
                await i.destroy(), (0, $h5XS2.logger).log(`Service ${t} destroyed successfully`);
            });
            return await Promise.all(e), this._services.clear(), this._context = {}, !0;
        } catch (e) {
            throw (0, $h5XS2.logger).error("Error during SDK destruction:", e), e;
        }
    }
}
var $0a263aacc9f32994$export$2e2bcd8739ae039 = $0a263aacc9f32994$export$f7af2da260061f5e;

});
parcelRegister("861m8", function(module, exports) {

$parcel$export(module.exports, "createAuthService", () => $5e4fef8f095dc7b5$export$8f30b9a05eb146a5);
$parcel$export(module.exports, "createCollabService", () => $5e4fef8f095dc7b5$export$691774002b31f671);
$parcel$export(module.exports, "createProjectService", () => $5e4fef8f095dc7b5$export$d2db3a7443ba9beb);
$parcel$export(module.exports, "createPlanService", () => $5e4fef8f095dc7b5$export$f0b1369ebf33366b);
$parcel$export(module.exports, "createSubscriptionService", () => $5e4fef8f095dc7b5$export$679dc0611cbaf435);
$parcel$export(module.exports, "createFileService", () => $5e4fef8f095dc7b5$export$4064f974fd81a6bd);
$parcel$export(module.exports, "createPaymentService", () => $5e4fef8f095dc7b5$export$431e60f339189fc2);
$parcel$export(module.exports, "createDnsService", () => $5e4fef8f095dc7b5$export$e6d31e0575ba2870);
$parcel$export(module.exports, "createBranchService", () => $5e4fef8f095dc7b5$export$8cd6113019ef923a);
$parcel$export(module.exports, "createPullRequestService", () => $5e4fef8f095dc7b5$export$7a55342272230f5c);
$parcel$export(module.exports, "createAdminService", () => $5e4fef8f095dc7b5$export$43743e06143bac7e);
$parcel$export(module.exports, "createScreenshotService", () => $5e4fef8f095dc7b5$export$3b449cb935acca09);
$parcel$export(module.exports, "createTrackingService", () => $5e4fef8f095dc7b5$export$e6575b0c70a26da5);
$parcel$export(module.exports, "createWaitlistService", () => $5e4fef8f095dc7b5$export$ead6d97b2fb25b5f);
$parcel$export(module.exports, "createOnboardingResearchService", () => $5e4fef8f095dc7b5$export$fef7825642f09d3c);
$parcel$export(module.exports, "createImportsService", () => $5e4fef8f095dc7b5$export$2521304a036c8552);
$parcel$export(module.exports, "createMetricsService", () => $5e4fef8f095dc7b5$export$3f15454bfb4240bb);
$parcel$export(module.exports, "createIntegrationService", () => $5e4fef8f095dc7b5$export$6e7d2c03a2cb2554);
$parcel$export(module.exports, "createFeatureFlagService", () => $5e4fef8f095dc7b5$export$bd53689910224e3);
$parcel$export(module.exports, "createOrganizationService", () => $5e4fef8f095dc7b5$export$94bb759057b63067);
$parcel$export(module.exports, "createWorkspaceService", () => $5e4fef8f095dc7b5$export$bb7722ac44faca6f);
$parcel$export(module.exports, "createBootService", () => $5e4fef8f095dc7b5$export$eccc626cf9b9218c);
$parcel$export(module.exports, "createMcpConnectorService", () => $5e4fef8f095dc7b5$export$fa5f97e3e48c2609);
$parcel$export(module.exports, "createVoiceService", () => $5e4fef8f095dc7b5$export$6b9f3d7c1993ba70);
$parcel$export(module.exports, "createWorkspaceProjectService", () => $5e4fef8f095dc7b5$export$fa3fda96a7de1da5);
$parcel$export(module.exports, "createAiChatService", () => $5e4fef8f095dc7b5$export$16d21b8548a9df26);
$parcel$export(module.exports, "createAiService", () => $5e4fef8f095dc7b5$export$fb7854531194d437);
$parcel$export(module.exports, "createDocService", () => $5e4fef8f095dc7b5$export$5c7fc7a1908083d4);
$parcel$export(module.exports, "createTicketService", () => $5e4fef8f095dc7b5$export$4f9899149c970eab);
$parcel$export(module.exports, "createFleetService", () => $5e4fef8f095dc7b5$export$ce19476481a02d49);
$parcel$export(module.exports, "createAssistantsService", () => $5e4fef8f095dc7b5$export$94919bcb4b445d69);
$parcel$export(module.exports, "createAiBoardsService", () => $5e4fef8f095dc7b5$export$d86db401103f3ef9);
$parcel$export(module.exports, "createAnalyzedService", () => $5e4fef8f095dc7b5$export$e9d2b606ea409a3b);
$parcel$export(module.exports, "createGrowthService", () => $5e4fef8f095dc7b5$export$c5b89edf7e37991b);
$parcel$export(module.exports, "createResourceLinkService", () => $5e4fef8f095dc7b5$export$af7204518580bbee);
$parcel$export(module.exports, "createShareLinkService", () => $5e4fef8f095dc7b5$export$5c692a7aa4a1fe12);
$parcel$export(module.exports, "createAllocationRuleService", () => $5e4fef8f095dc7b5$export$8ff68545e204df5f);
$parcel$export(module.exports, "createSharedAssetService", () => $5e4fef8f095dc7b5$export$545998207dbe2dbd);
$parcel$export(module.exports, "createCreditsService", () => $5e4fef8f095dc7b5$export$af05bc79f915caf2);
$parcel$export(module.exports, "createCanvasLayoutService", () => $5e4fef8f095dc7b5$export$834526975d245dca);
$parcel$export(module.exports, "createRefsService", () => $5e4fef8f095dc7b5$export$214453a654078a66);
$parcel$export(module.exports, "createBuildsService", () => $5e4fef8f095dc7b5$export$34d18d2335ffbd33);
$parcel$export(module.exports, "createStorefrontService", () => $5e4fef8f095dc7b5$export$8ca249638fcb195e);
$parcel$export(module.exports, "createPublicCollectionService", () => $5e4fef8f095dc7b5$export$337b3540ce6caa75);
$parcel$export(module.exports, "createMeetService", () => $5e4fef8f095dc7b5$export$5d9c7e55043e673d);
$parcel$export(module.exports, "createCalendarService", () => $5e4fef8f095dc7b5$export$e091ddcae2ef77d8);
$parcel$export(module.exports, "createPersonaService", () => $5e4fef8f095dc7b5$export$325705d1c87dda20);
$parcel$export(module.exports, "createProposedActionService", () => $5e4fef8f095dc7b5$export$a5389cb2745c6ee9);
$parcel$export(module.exports, "createWorkflowService", () => $5e4fef8f095dc7b5$export$6900f333cd6d6e73);
$parcel$export(module.exports, "createFieldDefService", () => $5e4fef8f095dc7b5$export$96e440378c80cbf7);
$parcel$export(module.exports, "createRecordCollectionService", () => $5e4fef8f095dc7b5$export$e5f81c5eebedc856);
$parcel$export(module.exports, "createPartyService", () => $5e4fef8f095dc7b5$export$1bb41d915f1150ac);
$parcel$export(module.exports, "createInteractionService", () => $5e4fef8f095dc7b5$export$bbd74fafbccc5f92);
$parcel$export(module.exports, "createLeadService", () => $5e4fef8f095dc7b5$export$d82be99917388d33);
$parcel$export(module.exports, "createDealService", () => $5e4fef8f095dc7b5$export$5026632a5ab3d0a8);
$parcel$export(module.exports, "createLeadSourceService", () => $5e4fef8f095dc7b5$export$d06c527a32d17c58);
$parcel$export(module.exports, "createChannelService", () => $5e4fef8f095dc7b5$export$6134b36416df934b);
$parcel$export(module.exports, "createCrmService", () => $5e4fef8f095dc7b5$export$fa9158a821e39ebc);
$parcel$export(module.exports, "createSegmentService", () => $5e4fef8f095dc7b5$export$d05082ff888c46ad);
$parcel$export(module.exports, "createProductService", () => $5e4fef8f095dc7b5$export$5b96c0293fd74684);
$parcel$export(module.exports, "createPriceService", () => $5e4fef8f095dc7b5$export$53581d3897af2d2c);
$parcel$export(module.exports, "createCompanyProfileService", () => $5e4fef8f095dc7b5$export$b4dae7c4d1c73105);
$parcel$export(module.exports, "createAgreementService", () => $5e4fef8f095dc7b5$export$703a91939632f051);
$parcel$export(module.exports, "createInvoiceService", () => $5e4fef8f095dc7b5$export$8d89bbc47259f11b);
$parcel$export(module.exports, "createTransactionService", () => $5e4fef8f095dc7b5$export$299e8d74e696d53c);
$parcel$export(module.exports, "createCommentService", () => $5e4fef8f095dc7b5$export$72c42a90d67d327e);
$parcel$export(module.exports, "createAttachmentService", () => $5e4fef8f095dc7b5$export$d1bdfa7122d4c267);
$parcel$export(module.exports, "createWatcherService", () => $5e4fef8f095dc7b5$export$c017144b7e854417);
$parcel$export(module.exports, "createActivityEntryService", () => $5e4fef8f095dc7b5$export$9b42bc5ff7ef3552);
$parcel$export(module.exports, "createTagService", () => $5e4fef8f095dc7b5$export$aef79b5332e30eaa);
$parcel$export(module.exports, "createRegistryService", () => $5e4fef8f095dc7b5$export$1fd83c269f9a7fd6);
$parcel$export(module.exports, "createBookingService", () => $5e4fef8f095dc7b5$export$996e624e894888cc);
$parcel$export(module.exports, "createAvailabilityRuleService", () => $5e4fef8f095dc7b5$export$82c1bfa78c169c45);
$parcel$export(module.exports, "createConversationService", () => $5e4fef8f095dc7b5$export$b80675961554d745);
$parcel$export(module.exports, "createRecurrenceService", () => $5e4fef8f095dc7b5$export$9f35caca53cb501b);
$parcel$export(module.exports, "createMailService", () => $5e4fef8f095dc7b5$export$4e2f1b75a5fab12);
$parcel$export(module.exports, "PERSONA_TARGET_ROLES", () => (parcelRequire("4Ccat")).PERSONA_TARGET_ROLES);
$parcel$export(module.exports, "workspaceProjectBaseUrl", () => (parcelRequire("5tLYA")).workspaceProjectBaseUrl);

var $fAScj = parcelRequire("fAScj");

var $kbO4k = parcelRequire("kbO4k");

var $8CNWJ = parcelRequire("8CNWJ");

var $OXh1D = parcelRequire("OXh1D");

var $5grt8 = parcelRequire("5grt8");

var $6L1kJ = parcelRequire("6L1kJ");

var $g0NMY = parcelRequire("g0NMY");

var $4QZMS = parcelRequire("4QZMS");

var $2UXJP = parcelRequire("2UXJP");

var $dATb7 = parcelRequire("dATb7");

var $f1HwY = parcelRequire("f1HwY");

var $fSRU6 = parcelRequire("fSRU6");

var $baGSE = parcelRequire("baGSE");

var $5ulAg = parcelRequire("5ulAg");

var $kfmJN = parcelRequire("kfmJN");

var $5gzYb = parcelRequire("5gzYb");

var $coWlv = parcelRequire("coWlv");

var $hn31Z = parcelRequire("hn31Z");

var $1q0WH = parcelRequire("1q0WH");

var $2ylZH = parcelRequire("2ylZH");

var $bt9uV = parcelRequire("bt9uV");

var $45c85 = parcelRequire("45c85");

var $dmndo = parcelRequire("dmndo");

var $joPWZ = parcelRequire("joPWZ");

var $eny6R = parcelRequire("eny6R");

var $i8omg = parcelRequire("i8omg");

var $6Lnup = parcelRequire("6Lnup");

var $cDyZB = parcelRequire("cDyZB");

var $bRZWw = parcelRequire("bRZWw");

var $ko4Dy = parcelRequire("ko4Dy");

var $hZpeq = parcelRequire("hZpeq");

var $8z4Wp = parcelRequire("8z4Wp");

var $gm2mj = parcelRequire("gm2mj");

var $gV6h4 = parcelRequire("gV6h4");

var $guDnT = parcelRequire("guDnT");

var $5tLYA = parcelRequire("5tLYA");

var $3qLQL = parcelRequire("3qLQL");

var $uPAry = parcelRequire("uPAry");

var $5hQ2H = parcelRequire("5hQ2H");

var $EyYmL = parcelRequire("EyYmL");

var $cHtb1 = parcelRequire("cHtb1");

var $4SXQx = parcelRequire("4SXQx");

var $eFRuB = parcelRequire("eFRuB");

var $fR4bG = parcelRequire("fR4bG");

var $czCQ4 = parcelRequire("czCQ4");

var $3y8Ff = parcelRequire("3y8Ff");

var $lEGsd = parcelRequire("lEGsd");

var $62BpU = parcelRequire("62BpU");

var $90yaS = parcelRequire("90yaS");

var $cI0b7 = parcelRequire("cI0b7");

var $eypFE = parcelRequire("eypFE");

var $9BpV2 = parcelRequire("9BpV2");

var $6p5r3 = parcelRequire("6p5r3");

var $hEz4S = parcelRequire("hEz4S");

var $dXbir = parcelRequire("dXbir");

var $g2Zqa = parcelRequire("g2Zqa");

var $8AFid = parcelRequire("8AFid");

var $SoT0z = parcelRequire("SoT0z");

var $gbH35 = parcelRequire("gbH35");

var $ed6J1 = parcelRequire("ed6J1");

var $5pEx7 = parcelRequire("5pEx7");

var $18tk4 = parcelRequire("18tk4");

var $7GVWM = parcelRequire("7GVWM");

var $lVGN7 = parcelRequire("lVGN7");

var $4WnFd = parcelRequire("4WnFd");

var $d3wfo = parcelRequire("d3wfo");

var $lQAED = parcelRequire("lQAED");

var $j6CXP = parcelRequire("j6CXP");

var $g3MVt = parcelRequire("g3MVt");

var $8UO8l = parcelRequire("8UO8l");

var $hvDlp = parcelRequire("hvDlp");

var $3bJnZ = parcelRequire("3bJnZ");

var $llyqc = parcelRequire("llyqc");

var $8rBBj = parcelRequire("8rBBj");

var $5m933 = parcelRequire("5m933");

var $4Ccat = parcelRequire("4Ccat");
const $5e4fef8f095dc7b5$var$r = (e, ye)=>new e(ye), $5e4fef8f095dc7b5$export$8f30b9a05eb146a5 = (e)=>$5e4fef8f095dc7b5$var$r((0, $fAScj.AuthService), e), $5e4fef8f095dc7b5$export$691774002b31f671 = (e)=>$5e4fef8f095dc7b5$var$r((0, $baGSE.CollabService), e), $5e4fef8f095dc7b5$export$d2db3a7443ba9beb = (e)=>$5e4fef8f095dc7b5$var$r((0, $5ulAg.ProjectService), e), $5e4fef8f095dc7b5$export$f0b1369ebf33366b = (e)=>$5e4fef8f095dc7b5$var$r((0, $kfmJN.PlanService), e), $5e4fef8f095dc7b5$export$679dc0611cbaf435 = (e)=>$5e4fef8f095dc7b5$var$r((0, $5gzYb.SubscriptionService), e), $5e4fef8f095dc7b5$export$4064f974fd81a6bd = (e)=>$5e4fef8f095dc7b5$var$r((0, $coWlv.FileService), e), $5e4fef8f095dc7b5$export$431e60f339189fc2 = (e)=>$5e4fef8f095dc7b5$var$r((0, $hn31Z.PaymentService), e), $5e4fef8f095dc7b5$export$e6d31e0575ba2870 = (e)=>$5e4fef8f095dc7b5$var$r((0, $1q0WH.DnsService), e), $5e4fef8f095dc7b5$export$8cd6113019ef923a = (e)=>$5e4fef8f095dc7b5$var$r((0, $2ylZH.BranchService), e), $5e4fef8f095dc7b5$export$7a55342272230f5c = (e)=>$5e4fef8f095dc7b5$var$r((0, $bt9uV.PullRequestService), e), $5e4fef8f095dc7b5$export$43743e06143bac7e = (e)=>$5e4fef8f095dc7b5$var$r((0, $45c85.AdminService), e), $5e4fef8f095dc7b5$export$3b449cb935acca09 = (e)=>$5e4fef8f095dc7b5$var$r((0, $dmndo.ScreenshotService), e), $5e4fef8f095dc7b5$export$e6575b0c70a26da5 = (e)=>$5e4fef8f095dc7b5$var$r((0, $joPWZ.TrackingService), e), $5e4fef8f095dc7b5$export$ead6d97b2fb25b5f = (e)=>$5e4fef8f095dc7b5$var$r((0, $eny6R.WaitlistService), e), $5e4fef8f095dc7b5$export$fef7825642f09d3c = (e)=>$5e4fef8f095dc7b5$var$r((0, $i8omg.OnboardingResearchService), e), $5e4fef8f095dc7b5$export$2521304a036c8552 = (e)=>$5e4fef8f095dc7b5$var$r((0, $6Lnup.ImportsService), e), $5e4fef8f095dc7b5$export$3f15454bfb4240bb = (e)=>$5e4fef8f095dc7b5$var$r((0, $cDyZB.MetricsService), e), $5e4fef8f095dc7b5$export$6e7d2c03a2cb2554 = (e)=>$5e4fef8f095dc7b5$var$r((0, $bRZWw.IntegrationService), e), $5e4fef8f095dc7b5$export$bd53689910224e3 = (e)=>$5e4fef8f095dc7b5$var$r((0, $ko4Dy.FeatureFlagService), e), $5e4fef8f095dc7b5$export$94bb759057b63067 = (e)=>$5e4fef8f095dc7b5$var$r((0, $hZpeq.OrganizationService), e), $5e4fef8f095dc7b5$export$bb7722ac44faca6f = (e)=>$5e4fef8f095dc7b5$var$r((0, $8z4Wp.WorkspaceService), e), $5e4fef8f095dc7b5$export$eccc626cf9b9218c = (e)=>$5e4fef8f095dc7b5$var$r((0, $gm2mj.BootService), e), $5e4fef8f095dc7b5$export$fa5f97e3e48c2609 = (e)=>$5e4fef8f095dc7b5$var$r((0, $gV6h4.McpConnectorService), e), $5e4fef8f095dc7b5$export$6b9f3d7c1993ba70 = (e)=>$5e4fef8f095dc7b5$var$r((0, $guDnT.VoiceService), e), $5e4fef8f095dc7b5$export$fa3fda96a7de1da5 = (e)=>$5e4fef8f095dc7b5$var$r((0, $5tLYA.WorkspaceProjectService), e), $5e4fef8f095dc7b5$export$16d21b8548a9df26 = (e)=>$5e4fef8f095dc7b5$var$r((0, $kbO4k.AiChatService), e), $5e4fef8f095dc7b5$export$fb7854531194d437 = (e)=>$5e4fef8f095dc7b5$var$r((0, $8CNWJ.AiService), e), $5e4fef8f095dc7b5$export$5c7fc7a1908083d4 = (e)=>$5e4fef8f095dc7b5$var$r((0, $OXh1D.DocService), e), $5e4fef8f095dc7b5$export$4f9899149c970eab = (e)=>$5e4fef8f095dc7b5$var$r((0, $5grt8.TicketService), e), $5e4fef8f095dc7b5$export$ce19476481a02d49 = (e)=>$5e4fef8f095dc7b5$var$r((0, $6L1kJ.FleetService), e), $5e4fef8f095dc7b5$export$94919bcb4b445d69 = (e)=>$5e4fef8f095dc7b5$var$r((0, $g0NMY.AssistantsService), e), $5e4fef8f095dc7b5$export$d86db401103f3ef9 = (e)=>$5e4fef8f095dc7b5$var$r((0, $4QZMS.AiBoardsService), e), $5e4fef8f095dc7b5$export$e9d2b606ea409a3b = (e)=>$5e4fef8f095dc7b5$var$r((0, $2UXJP.AnalyzedService), e), $5e4fef8f095dc7b5$export$c5b89edf7e37991b = (e)=>$5e4fef8f095dc7b5$var$r((0, $dATb7.GrowthService), e), $5e4fef8f095dc7b5$export$af7204518580bbee = (e)=>$5e4fef8f095dc7b5$var$r((0, $f1HwY.ResourceLinkService), e), $5e4fef8f095dc7b5$export$5c692a7aa4a1fe12 = (e)=>$5e4fef8f095dc7b5$var$r((0, $fSRU6.ShareLinkService), e), $5e4fef8f095dc7b5$export$8ff68545e204df5f = (e)=>$5e4fef8f095dc7b5$var$r((0, $3qLQL.AllocationRuleService), e), $5e4fef8f095dc7b5$export$545998207dbe2dbd = (e)=>$5e4fef8f095dc7b5$var$r((0, $uPAry.SharedAssetService), e), $5e4fef8f095dc7b5$export$af05bc79f915caf2 = (e)=>$5e4fef8f095dc7b5$var$r((0, $5hQ2H.CreditsService), e), $5e4fef8f095dc7b5$export$834526975d245dca = (e)=>$5e4fef8f095dc7b5$var$r((0, $g3MVt.CanvasLayoutService), e), $5e4fef8f095dc7b5$export$214453a654078a66 = (e)=>$5e4fef8f095dc7b5$var$r((0, $8UO8l.RefsService), e), $5e4fef8f095dc7b5$export$34d18d2335ffbd33 = (e)=>$5e4fef8f095dc7b5$var$r((0, $llyqc.BuildsService), e), $5e4fef8f095dc7b5$export$8ca249638fcb195e = (e)=>$5e4fef8f095dc7b5$var$r((0, $8rBBj.StorefrontService), e), $5e4fef8f095dc7b5$export$337b3540ce6caa75 = (e)=>$5e4fef8f095dc7b5$var$r((0, $5m933.PublicCollectionService), e), $5e4fef8f095dc7b5$export$5d9c7e55043e673d = (e)=>$5e4fef8f095dc7b5$var$r((0, $hvDlp.MeetService), e), $5e4fef8f095dc7b5$export$e091ddcae2ef77d8 = (e)=>$5e4fef8f095dc7b5$var$r((0, $3bJnZ.CalendarService), e), $5e4fef8f095dc7b5$export$325705d1c87dda20 = (e)=>$5e4fef8f095dc7b5$var$r((0, $4Ccat.PersonaService), e), $5e4fef8f095dc7b5$export$a5389cb2745c6ee9 = (e)=>$5e4fef8f095dc7b5$var$r((0, $EyYmL.ProposedActionService), e), $5e4fef8f095dc7b5$export$6900f333cd6d6e73 = (e)=>$5e4fef8f095dc7b5$var$r((0, $cHtb1.WorkflowService), e), $5e4fef8f095dc7b5$export$96e440378c80cbf7 = (e)=>$5e4fef8f095dc7b5$var$r((0, $4SXQx.FieldDefService), e), $5e4fef8f095dc7b5$export$e5f81c5eebedc856 = (e)=>$5e4fef8f095dc7b5$var$r((0, $eFRuB.RecordCollectionService), e), $5e4fef8f095dc7b5$export$1bb41d915f1150ac = (e)=>$5e4fef8f095dc7b5$var$r((0, $fR4bG.PartyService), e), $5e4fef8f095dc7b5$export$bbd74fafbccc5f92 = (e)=>$5e4fef8f095dc7b5$var$r((0, $czCQ4.InteractionService), e), $5e4fef8f095dc7b5$export$d82be99917388d33 = (e)=>$5e4fef8f095dc7b5$var$r((0, $lEGsd.LeadService), e), $5e4fef8f095dc7b5$export$5026632a5ab3d0a8 = (e)=>$5e4fef8f095dc7b5$var$r((0, $62BpU.DealService), e), $5e4fef8f095dc7b5$export$d06c527a32d17c58 = (e)=>$5e4fef8f095dc7b5$var$r((0, $90yaS.LeadSourceService), e), $5e4fef8f095dc7b5$export$6134b36416df934b = (e)=>$5e4fef8f095dc7b5$var$r((0, $cI0b7.ChannelService), e), $5e4fef8f095dc7b5$export$fa9158a821e39ebc = (e)=>$5e4fef8f095dc7b5$var$r((0, $eypFE.CrmService), e), $5e4fef8f095dc7b5$export$d05082ff888c46ad = (e)=>$5e4fef8f095dc7b5$var$r((0, $3y8Ff.SegmentService), e), $5e4fef8f095dc7b5$export$5b96c0293fd74684 = (e)=>$5e4fef8f095dc7b5$var$r((0, $9BpV2.ProductService), e), $5e4fef8f095dc7b5$export$53581d3897af2d2c = (e)=>$5e4fef8f095dc7b5$var$r((0, $6p5r3.PriceService), e), $5e4fef8f095dc7b5$export$b4dae7c4d1c73105 = (e)=>$5e4fef8f095dc7b5$var$r((0, $hEz4S.CompanyProfileService), e), $5e4fef8f095dc7b5$export$703a91939632f051 = (e)=>$5e4fef8f095dc7b5$var$r((0, $dXbir.AgreementService), e), $5e4fef8f095dc7b5$export$8d89bbc47259f11b = (e)=>$5e4fef8f095dc7b5$var$r((0, $g2Zqa.InvoiceService), e), $5e4fef8f095dc7b5$export$299e8d74e696d53c = (e)=>$5e4fef8f095dc7b5$var$r((0, $8AFid.TransactionService), e), $5e4fef8f095dc7b5$export$72c42a90d67d327e = (e)=>$5e4fef8f095dc7b5$var$r((0, $SoT0z.CommentService), e), $5e4fef8f095dc7b5$export$d1bdfa7122d4c267 = (e)=>$5e4fef8f095dc7b5$var$r((0, $gbH35.AttachmentService), e), $5e4fef8f095dc7b5$export$c017144b7e854417 = (e)=>$5e4fef8f095dc7b5$var$r((0, $ed6J1.WatcherService), e), $5e4fef8f095dc7b5$export$9b42bc5ff7ef3552 = (e)=>$5e4fef8f095dc7b5$var$r((0, $5pEx7.ActivityEntryService), e), $5e4fef8f095dc7b5$export$aef79b5332e30eaa = (e)=>$5e4fef8f095dc7b5$var$r((0, $18tk4.TagService), e), $5e4fef8f095dc7b5$export$1fd83c269f9a7fd6 = (e)=>$5e4fef8f095dc7b5$var$r((0, $7GVWM.RegistryService), e), $5e4fef8f095dc7b5$export$996e624e894888cc = (e)=>$5e4fef8f095dc7b5$var$r((0, $lVGN7.BookingService), e), $5e4fef8f095dc7b5$export$82c1bfa78c169c45 = (e)=>$5e4fef8f095dc7b5$var$r((0, $4WnFd.AvailabilityRuleService), e), $5e4fef8f095dc7b5$export$b80675961554d745 = (e)=>$5e4fef8f095dc7b5$var$r((0, $d3wfo.ConversationService), e), $5e4fef8f095dc7b5$export$9f35caca53cb501b = (e)=>$5e4fef8f095dc7b5$var$r((0, $lQAED.RecurrenceService), e), $5e4fef8f095dc7b5$export$4e2f1b75a5fab12 = (e)=>$5e4fef8f095dc7b5$var$r((0, $j6CXP.MailService), e);

});
parcelRegister("fAScj", function(module, exports) {

$parcel$export(module.exports, "AuthService", () => $b5a44255b2c04ae5$export$69d4516a6fd8e701);

var $em51x = parcelRequire("em51x");

var $aDFzZ = parcelRequire("aDFzZ");

var $36Jqh = parcelRequire("36Jqh");

var $h5XS2 = parcelRequire("h5XS2");

var $gYAeI = parcelRequire("gYAeI");

var $7sTYS = parcelRequire("7sTYS");
var $b5a44255b2c04ae5$require$Buffer = $7sTYS.Buffer;
const $b5a44255b2c04ae5$var$f = "plugin_auth_session";
class $b5a44255b2c04ae5$export$69d4516a6fd8e701 extends (0, $em51x.BaseService) {
    constructor(e){
        super(e), this._userRoles = new Set([
            "guest",
            "editor",
            "admin",
            "owner"
        ]), this._projectTiers = new Set([
            "ready",
            "starter",
            "pro1",
            "pro2",
            "enterprise"
        ]), this._projectRoleCache = new Map, this._roleCacheExpiry = 300000, this._pluginSession = null, this._authListeners = new Set, this._resolvePluginSession(e?.session || e?.pluginSession || e?.options?.pluginSession || e?.context?.pluginSession || null);
    }
    async getSignupPolicy() {
        return this._call("getSignupPolicy", "/auth/signup-policy");
    }
    async register(e, t = {}) {
        try {
            const { payload: s, session: r } = this._preparePluginPayload({
                ...e || {}
            }, t.session), a = await this._request("/auth/register", {
                method: "POST",
                body: JSON.stringify(s),
                methodName: "register"
            });
            if (a.success) {
                r && this._clearPluginSession(r);
                const o = a.data?.user?.username;
                return o && this._createSubdomainRecords(o).catch((n)=>{
                    (0, $h5XS2.logger).warn("Failed to create DNS records for user:", n?.message || n);
                }), a.data;
            }
            throw new Error(a.message);
        } catch (s) {
            throw new Error(`Registration failed: ${s.message}`, {
                cause: s
            });
        }
    }
    async login(e, t, s = {}) {
        try {
            const { payload: r, session: a } = this._preparePluginPayload({
                email: e,
                password: t
            }, s.session), o = await this._request("/auth/login", {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "login"
            });
            if (o.success && o.data && o.data.tokens) {
                const { tokens: n } = o.data, i = {
                    access_token: n.accessToken,
                    refresh_token: n.refreshToken,
                    expires_in: n.accessTokenExp?.expiresIn,
                    token_type: "Bearer"
                };
                this._tokenManager && this._tokenManager.setTokens(i), this._currentUser = o.data?.user || null, this._emitAuth?.("SIGNED_IN");
            }
            if (o.success) return a && this._clearPluginSession(a), o.data;
            throw new Error(o.message);
        } catch (r) {
            throw new Error(`Login failed: ${r.message}`, {
                cause: r
            });
        }
    }
    async startDemo({ email: e } = {}) {
        try {
            const t = await this._request("/demo/start", {
                method: "POST",
                body: JSON.stringify({
                    email: e
                }),
                methodName: "startDemo"
            });
            if (t.success && t.data) {
                const { accessToken: s, refreshToken: r } = t.data;
                return s && (this._tokenManager && this._tokenManager.setTokens({
                    access_token: s,
                    refresh_token: r || null,
                    token_type: "Bearer"
                }), this._emitAuth?.("SIGNED_IN")), t.data;
            }
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Demo start failed: ${t.message}`, {
                cause: t
            });
        }
    }
    async enterDemo() {
        try {
            const e = await this._request("/demo/enter", {
                method: "POST",
                body: JSON.stringify({}),
                methodName: "enterDemo"
            });
            if (e.success && e.data) {
                const { accessToken: t, refreshToken: s } = e.data;
                return t && this._tokenManager && this._tokenManager.setTokens({
                    access_token: t,
                    refresh_token: s || null,
                    token_type: "Bearer"
                }), this._emitAuth?.("SIGNED_IN"), e.data;
            }
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Demo enter failed: ${e.message}`, {
                cause: e
            });
        }
    }
    async claimDemoAccount({ email: e, password: t, name: s } = {}) {
        return this._call("claimDemoAccount", "/demo/claim", {
            method: "POST",
            body: {
                email: e,
                password: t,
                name: s
            }
        });
    }
    async cloneDemoWorkspace({ demoOrgId: e } = {}) {
        return this._call("cloneDemoWorkspace", "/demo/clone", {
            method: "POST",
            body: {
                demoOrgId: e
            }
        });
    }
    async logout() {
        this._requireReady("logout");
        const e = this._tokenManager, t = !!e?.isBorrowedSession?.();
        e && !t && e.adoptStoredTokensIfSameUser?.();
        const s = e && !t ? e.getRefreshToken() : null, r = e?.tokens?.accessToken || null;
        try {
            await this._request("/auth/logout", {
                method: "POST",
                body: JSON.stringify(s ? {
                    refreshToken: s
                } : {}),
                headers: r ? {
                    Authorization: `${e.tokens.tokenType || "Bearer"} ${r}`
                } : {},
                methodName: "logout"
            });
        } catch (a) {
            throw this._clearLocalSession(), new Error(`Logout failed: ${a.message}`, {
                cause: a
            });
        }
        this._clearLocalSession();
    }
    _clearLocalSession() {
        this._tokenManager && this._tokenManager.clearTokens(), this._currentUser = null, this._emitAuth?.("SIGNED_OUT");
    }
    async refreshToken(e) {
        try {
            const t = await this._request("/auth/refresh", {
                method: "POST",
                body: JSON.stringify({
                    refreshToken: e
                }),
                methodName: "refreshToken"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Token refresh failed: ${t.message}`, {
                cause: t
            });
        }
    }
    async googleAuth(e, t = null, s = {}) {
        try {
            const { payload: r, session: a } = this._preparePluginPayload({
                idToken: e
            }, s.session);
            t && (r.inviteToken = t);
            const o = await this._request("/auth/google", {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "googleAuth"
            });
            if (o.success && o.data && o.data.tokens) {
                const { tokens: n } = o.data, i = {
                    access_token: n.accessToken,
                    refresh_token: n.refreshToken,
                    expires_in: n.accessTokenExp?.expiresIn,
                    token_type: "Bearer"
                };
                this._tokenManager && this._tokenManager.setTokens(i), this._currentUser = o.data?.user || null, this._emitAuth?.("SIGNED_IN");
            }
            if (o.success) return a && this._clearPluginSession(a), o.data;
            throw new Error(o.message);
        } catch (r) {
            throw new Error(`Google auth failed: ${r.message}`, {
                cause: r
            });
        }
    }
    async githubAuth(e, t = null, s = {}) {
        try {
            const { payload: r, session: a } = this._preparePluginPayload({
                code: e
            }, s.session);
            t && (r.inviteToken = t);
            const o = await this._request("/auth/github", {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "githubAuth"
            });
            if (o.success && o.data && o.data.tokens) {
                const { tokens: n } = o.data, i = {
                    access_token: n.accessToken,
                    refresh_token: n.refreshToken,
                    expires_in: n.accessTokenExp?.expiresIn,
                    token_type: "Bearer"
                };
                this._tokenManager && this._tokenManager.setTokens(i), this._currentUser = o.data?.user || null, this._emitAuth?.("SIGNED_IN");
            }
            if (o.success) return a && this._clearPluginSession(a), o.data;
            throw new Error(o.message);
        } catch (r) {
            throw new Error(`GitHub auth failed: ${r.message}`, {
                cause: r
            });
        }
    }
    async googleAuthCallback(e, t, s = null, r = {}) {
        try {
            const { payload: a, session: o } = this._preparePluginPayload({
                code: e,
                redirectUri: t
            }, r.session);
            s && (a.inviteToken = s);
            const n = await this._request("/auth/google/callback", {
                method: "POST",
                body: JSON.stringify(a),
                methodName: "googleAuthCallback"
            });
            if (n.success && n.data && n.data.tokens) {
                const { tokens: i } = n.data, u = {
                    access_token: i.accessToken,
                    refresh_token: i.refreshToken,
                    expires_in: i.accessTokenExp?.expiresIn,
                    token_type: "Bearer"
                };
                this._tokenManager && this._tokenManager.setTokens(u), this._currentUser = n.data?.user || null, this._emitAuth?.("SIGNED_IN");
            }
            if (n.success) return o && this._clearPluginSession(o), n.data;
            throw new Error(n.message);
        } catch (a) {
            throw new Error(`Google auth callback failed: ${a.message}`, {
                cause: a
            });
        }
    }
    async exchangeNativeAuthToken(e, t, s = null) {
        if (!e) throw new Error("[sdk.exchangeNativeAuthToken] xt is required");
        try {
            const r = {
                xt: e
            };
            t && (r.state = t), s && (r.inviteToken = s);
            const a = await this._request("/auth/native/exchange", {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "exchangeNativeAuthToken"
            });
            if (a.success && a.data && a.data.tokens) {
                const { tokens: o } = a.data, n = {
                    access_token: o.accessToken,
                    refresh_token: o.refreshToken,
                    expires_in: o.accessTokenExp?.expiresIn,
                    token_type: "Bearer"
                };
                this._tokenManager && this._tokenManager.setTokens(n), this._currentUser = a.data.user || this._currentUser, this._emitAuth?.("SIGNED_IN");
            }
            if (a.success) return a.data;
            throw new Error(a.message);
        } catch (r) {
            const a = new Error(`Native auth exchange failed: ${r.message}`, {
                cause: r
            });
            throw r?.status !== void 0 && (a.status = r.status), a;
        }
    }
    async getSignInSessionInfo(e) {
        try {
            const t = await this._request(`/auth/session/info?session=${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "getSignInSessionInfo"
            });
            return {
                status: t?.status ?? null,
                createdAt: t?.created_at ?? null,
                requesterIp: t?.requester_ip ?? null,
                client: t?.client ?? null,
                codeRequired: !!t?.code_required
            };
        } catch (t) {
            throw new Error(`Sign-in session lookup failed: ${t.message}`, {
                cause: t
            });
        }
    }
    async activateSignInSession(e, t) {
        this._requireReady("activateSignInSession");
        try {
            return await this._request("/auth/session/activate", {
                method: "POST",
                body: JSON.stringify(t ? {
                    session_id: e,
                    user_code: t
                } : {
                    session_id: e
                }),
                methodName: "activateSignInSession"
            });
        } catch (s) {
            throw new Error(`Sign-in session activation failed: ${s.message}`, {
                cause: s
            });
        }
    }
    async requestPasswordReset(e) {
        try {
            const t = await this._request("/auth/request-password-reset", {
                method: "POST",
                body: JSON.stringify({
                    email: e
                }),
                methodName: "requestPasswordReset"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Password reset request failed: ${t.message}`, {
                cause: t
            });
        }
    }
    async confirmPasswordReset(e, t) {
        try {
            const s = await this._request("/auth/reset-password-confirm", {
                method: "POST",
                body: JSON.stringify({
                    token: e,
                    password: t
                }),
                methodName: "confirmPasswordReset"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Password reset confirmation failed: ${s.message}`, {
                cause: s
            });
        }
    }
    async confirmRegistration(e, { password: t } = {}) {
        try {
            const s = await this._request("/auth/register-confirmation", {
                method: "POST",
                body: JSON.stringify(t ? {
                    token: e,
                    password: t
                } : {
                    token: e
                }),
                methodName: "confirmRegistration"
            });
            if (s.success) {
                const r = s.data?.tokens;
                return r?.accessToken && (this._tokenManager && this._tokenManager.setTokens({
                    access_token: r.accessToken,
                    refresh_token: r.refreshToken,
                    expires_in: r.accessTokenExp?.expiresIn,
                    token_type: "Bearer"
                }), this._currentUser = null, this._emitAuth?.("SIGNED_IN")), s.data;
            }
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Registration confirmation failed: ${s.message}`, {
                cause: s
            });
        }
    }
    async previewRegisterConfirmation(e) {
        try {
            const t = await this._request("/auth/register-confirmation/preview", {
                method: "POST",
                body: JSON.stringify({
                    token: e
                }),
                methodName: "previewRegisterConfirmation"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Confirmation preview failed: ${t.message}`, {
                cause: t
            });
        }
    }
    async setInitialPassword(e, t) {
        try {
            const s = await this._request("/auth/set-initial-password", {
                method: "POST",
                body: JSON.stringify({
                    token: e,
                    password: t
                }),
                methodName: "setInitialPassword"
            });
            if (s.success) return s.data ?? {
                success: !0
            };
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Set password failed: ${s.message}`, {
                cause: s
            });
        }
    }
    async requestPasswordChange() {
        this._requireReady("requestPasswordChange");
        try {
            const e = await this._request("/auth/request-password-change", {
                method: "POST",
                methodName: "requestPasswordChange"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Password change request failed: ${e.message}`, {
                cause: e
            });
        }
    }
    async confirmPasswordChange(e, t, s) {
        this._requireReady("confirmPasswordChange");
        try {
            const r = await this._request("/auth/confirm-password-change", {
                method: "POST",
                body: JSON.stringify({
                    currentPassword: e,
                    newPassword: t,
                    code: s
                }),
                methodName: "confirmPasswordChange"
            });
            if (r.success) return r.data;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Password change confirmation failed: ${r.message}`, {
                cause: r
            });
        }
    }
    async getMe(e = {}) {
        this._requireReady("getMe");
        const t = this._resolvePluginSession(e.session), s = t || "__default__";
        if (this._getMeInflight ||= new Map, this._getMeInflight.has(s)) return this._getMeInflight.get(s);
        const r = this._fetchMe(t, s);
        return this._getMeInflight.set(s, r), r;
    }
    async _fetchMe(e, t) {
        try {
            const s = e ? await this._request(`/auth/me?session=${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "getMe"
            }) : await this._request("/auth/me", {
                method: "GET",
                methodName: "getMe"
            });
            if (s.success) return this._currentUser = s.data?.user || s.data || null, this._emitAuth?.("USER_UPDATED"), setTimeout(()=>{
                this._getMeInflight?.delete(t);
            }, 50), s.data;
            throw new Error(s.message);
        } catch (s) {
            throw this._getMeInflight?.delete(t), new Error(`Failed to get user profile: ${s.message}`, {
                cause: s
            });
        }
    }
    async updateMe(e) {
        this._requireReady("updateMe");
        try {
            const t = await this._request("/auth/me", {
                method: "PATCH",
                body: JSON.stringify(e || {}),
                methodName: "updateMe"
            });
            if (t.success) return this._currentUser = t.data?.user || t.data || this._currentUser, this._emitAuth?.("USER_UPDATED"), t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update user profile: ${t.message}`, {
                cause: t
            });
        }
    }
    async getPermissions(e) {
        this._requireReady("getPermissions");
        try {
            const t = e ? `/auth/permissions?org=${encodeURIComponent(e)}` : "/auth/permissions", s = await this._request(t, {
                method: "GET",
                methodName: "getPermissions"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (t) {
            throw new Error(`Failed to fetch permissions: ${t.message}`, {
                cause: t
            });
        }
    }
    getAuthToken() {
        return this._tokenManager ? this._tokenManager.getAccessToken() : null;
    }
    getSession() {
        const e = this._tokenManager;
        if (!e || !e.hasTokens?.()) return null;
        const t = e.getAccessToken?.(), s = e.getRefreshToken?.();
        return t ? {
            access_token: t,
            refresh_token: s,
            expires_at: e.tokens?.expiresAt || null,
            token_type: "bearer",
            user: this._currentUser || this._userFromTokenClaims() || null
        } : null;
    }
    adoptSessionUser(e) {
        !e || typeof e != "object" || (this._currentUser = e, this._emitAuth?.("USER_UPDATED"));
    }
    _userFromTokenClaims() {
        try {
            const e = this._tokenManager?.getAccessToken?.();
            if (!e) return null;
            const t = String(e).split(".")[1];
            if (!t) return null;
            const s = t.replace(/-/g, "+").replace(/_/g, "/"), r = s + "=".repeat((4 - s.length % 4) % 4), a = typeof atob == "function" ? atob(r) : $b5a44255b2c04ae5$require$Buffer.from(r, "base64").toString("utf8"), o = JSON.parse(a), n = o.sub || o.user_id || o.id || o._id || null;
            if (!n) return null;
            const i = {
                id: n,
                _id: o._id || n,
                app_metadata: o
            };
            return o.email && (i.email = o.email), o.username && (i.username = o.username), i;
        } catch  {
            return null;
        }
    }
    onAuthStateChange(e) {
        if (typeof e != "function") return ()=>{};
        this._authListeners.add(e);
        try {
            e("INITIAL_SESSION", this.getSession());
        } catch  {}
        return ()=>{
            this._authListeners.delete(e);
        };
    }
    _emitAuth(e) {
        const t = this.getSession();
        for (const s of this._authListeners)try {
            s(e, t);
        } catch  {}
    }
    async getStoredAuthState() {
        try {
            if (!this._tokenManager) return {
                userId: !1,
                authToken: !1
            };
            const e = this._tokenManager.getTokenStatus();
            if (!e.hasTokens) return {
                userId: !1,
                authToken: !1
            };
            if (!e.isValid && (e.hasRefreshToken || this._tokenManager.hasSessionReacquirer?.())) try {
                await this._tokenManager.ensureValidToken();
            } catch (s) {
                (0, $h5XS2.logger).warn("[AuthService] Token refresh failed:", s.message);
                const r = s?.message || "";
                return s?.status === 401 || s?.status === 403 || r.includes("invalid") || r.includes("expired") ? (this._tokenManager.clearTokens(), {
                    userId: !1,
                    authToken: !1,
                    error: `Authentication failed: ${s.message}`
                }) : {
                    userId: !1,
                    authToken: this._tokenManager.getAccessToken(),
                    error: `Network error during token refresh: ${s.message}`,
                    hasTokens: !0
                };
            }
            const t = this._tokenManager.getAccessToken();
            if (!t) return {
                userId: !1,
                authToken: !1
            };
            try {
                const s = await this.getMe();
                return {
                    userId: s.user.id,
                    authToken: t,
                    ...s,
                    error: null
                };
            } catch (s) {
                return (0, $h5XS2.logger).warn("[AuthService] Failed to get user data:", s.message), s?.status === 401 || s?.status === 403 ? (this._tokenManager.clearTokens(), {
                    userId: !1,
                    authToken: !1,
                    error: `Authentication failed: ${s.message}`
                }) : {
                    userId: !1,
                    authToken: t,
                    error: `Failed to get user data: ${s.message}`,
                    hasTokens: !0
                };
            }
        } catch (e) {
            return (0, $h5XS2.logger).error("[AuthService] Unexpected error in getStoredAuthState:", e), {
                userId: !1,
                authToken: !1,
                error: `Failed to get stored auth state: ${e.message}`
            };
        }
    }
    async getUserProfile() {
        this._requireReady("getUserProfile");
        try {
            const e = await this._request("/users/profile", {
                method: "GET",
                methodName: "getUserProfile"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get user profile: ${e.message}`, {
                cause: e
            });
        }
    }
    async updateUserProfile(e) {
        this._requireReady("updateUserProfile");
        try {
            const t = await this._request("/users/profile", {
                method: "PATCH",
                body: JSON.stringify(e),
                methodName: "updateUserProfile"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update user profile: ${t.message}`, {
                cause: t
            });
        }
    }
    async updateUserHrProfile(e, t) {
        if (this._requireReady("updateUserHrProfile"), !e) throw new Error("updateUserHrProfile requires a target userId \u2014 refusing to fall back to the caller");
        try {
            const s = await this._request(`/users/${encodeURIComponent(e)}/hr-profile`, {
                method: "PATCH",
                body: JSON.stringify(t || {}),
                methodName: "updateUserHrProfile"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to update user HR profile: ${s.message}`, {
                cause: s
            });
        }
    }
    async getUserProjects() {
        this._requireReady("getUserProjects");
        try {
            const e = await this._request("/users/projects", {
                method: "GET",
                methodName: "getUserProjects"
            });
            if (e.success) return e.data.map((t)=>({
                    ...t,
                    ...t.icon && {
                        icon: {
                            src: `${this._apiUrl}/core/files/public/${t.icon.id}/download`,
                            ...t.icon
                        }
                    }
                }));
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get user projects: ${e.message}`, {
                cause: e
            });
        }
    }
    async getUser(e) {
        if (this._requireReady("getUser"), !e) throw new Error("User ID is required");
        try {
            const t = await this._request(`/users/${e}`, {
                method: "GET",
                methodName: "getUser"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to get user: ${t.message}`, {
                cause: t
            });
        }
    }
    async listMembers(e) {
        this._requireReady("listMembers");
        try {
            const t = typeof e == "string" ? {
                workspaceId: e
            } : e || {}, s = new URLSearchParams;
            t.workspaceId ? s.set("workspaceId", t.workspaceId) : t.orgSlug && s.set("orgSlug", t.orgSlug);
            const r = s.toString() ? `?${s.toString()}` : "", a = await this._request(`/users/members${r}`, {
                method: "GET",
                methodName: "listMembers"
            });
            return a?.success ? a.data : a?.data || a;
        } catch (t) {
            throw new Error(`Failed to list people: ${t.message}`, {
                cause: t
            });
        }
    }
    async listAgents(e) {
        this._requireReady("listAgents");
        try {
            const t = e ? `?orgId=${encodeURIComponent(e)}` : "", s = await this._request(`/users/agents${t}`, {
                method: "GET",
                methodName: "listAgents"
            });
            return s?.success ? s.data : s?.data || s;
        } catch (t) {
            throw new Error(`Failed to list agents: ${t.message}`, {
                cause: t
            });
        }
    }
    async createAgent(e = {}) {
        this._requireReady("createAgent");
        try {
            const t = await this._request("/users/agents", {
                method: "POST",
                body: JSON.stringify(e),
                methodName: "createAgent"
            });
            return t?.success ? t.data : t?.data || t;
        } catch (t) {
            throw new Error(`Failed to create agent: ${t.message}`, {
                cause: t
            });
        }
    }
    async getAgent(e) {
        if (this._requireReady("getAgent"), !e) throw new Error("agentId is required");
        try {
            const t = await this._request(`/users/agents/${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "getAgent"
            });
            return t?.success ? t.data : t?.data || t;
        } catch (t) {
            throw new Error(`Failed to get agent: ${t.message}`, {
                cause: t
            });
        }
    }
    async updateAgent(e, t = {}) {
        if (this._requireReady("updateAgent"), !e) throw new Error("agentId is required");
        try {
            const s = await this._request(`/users/agents/${encodeURIComponent(e)}`, {
                method: "PATCH",
                body: JSON.stringify(t),
                methodName: "updateAgent"
            });
            return s?.success ? s.data : s?.data || s;
        } catch (s) {
            throw new Error(`Failed to update agent: ${s.message}`, {
                cause: s
            });
        }
    }
    async getAgentToolCatalog() {
        this._requireReady("getAgentToolCatalog");
        try {
            const e = await this._request("/users/agents/tool-catalog", {
                method: "GET",
                methodName: "getAgentToolCatalog"
            });
            return e?.success ? e.data : e?.data || e;
        } catch (e) {
            throw new Error(`Failed to get agent tool catalog: ${e.message}`, {
                cause: e
            });
        }
    }
    async getUserByEmail(e) {
        if (this._requireReady("getUserByEmail"), !e) throw new Error("Email is required");
        try {
            const t = await this._request(`/auth/user?email=${e}`, {
                method: "GET",
                methodName: "getUserByEmail"
            });
            if (t.success) return t.data.user;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to get user by email: ${t.message}`, {
                cause: t
            });
        }
    }
    async getUserByUsername(e) {
        if (!e) throw new Error("Username is required");
        const t = await this._call("getUserByUsername", `/auth/user?username=${encodeURIComponent(e)}`);
        return t?.user || t;
    }
    async checkUsernameAvailable({ username: e } = {}) {
        if (!e) throw new Error("username is required");
        return this._call("checkUsernameAvailable", `/auth/username-available?u=${encodeURIComponent(e)}`);
    }
    async getMyProjectRole(e) {
        if (this._requireReady("getMyProjectRole"), !e) throw new Error("Project ID is required");
        if (!this.hasValidTokens()) return "guest";
        const t = `role_${e}`, s = this._projectRoleCache.get(t);
        if (s && Date.now() - s.timestamp < this._roleCacheExpiry) return s.role;
        try {
            const r = await this._request(`/projects/${e}/role`, {
                method: "GET",
                methodName: "getMyProjectRole"
            });
            if (r.success) {
                const { role: a } = r.data;
                return this._projectRoleCache.set(t, {
                    role: a,
                    timestamp: Date.now()
                }), a;
            }
            throw new Error(r.message);
        } catch (r) {
            const a = r?.message || "";
            if (/401|403|unauthorized|no token|invalid token/iu.test(a)) return "guest";
            throw new Error(`Failed to get project role: ${a}`, {
                cause: r
            });
        }
    }
    async getMyProjectRoleByKey(e) {
        this._requireReady("getMyProjectRoleByKey");
        let t = null, s = null;
        if (e && typeof e == "object" ? (t = e.owner || null, s = e.key) : s = e, !s) throw new Error("Project key is required");
        if (!this.hasValidTokens()) return "guest";
        const r = t ? `role_key_${t}/${s}` : `role_key_${s}`, a = this._projectRoleCache.get(r);
        if (a && Date.now() - a.timestamp < this._roleCacheExpiry) return a.role;
        const o = t ? `${encodeURIComponent(t)}/${encodeURIComponent(s)}` : encodeURIComponent(s);
        try {
            const n = await this._request(`/projects/key/${o}/role`, {
                method: "GET",
                methodName: "getMyProjectRoleByKey"
            });
            if (n.success) {
                const { role: i } = n.data;
                return this._projectRoleCache.set(r, {
                    role: i,
                    timestamp: Date.now()
                }), i;
            }
            throw new Error(n.message);
        } catch (n) {
            if (n?.status === 401 || n?.status === 403) return "guest";
            const i = (0, $gYAeI.ambiguousKeyError)(n, e);
            if (i) throw i;
            const u = n?.message || "";
            throw new Error(`Failed to get project role by key: ${u}`, {
                cause: n
            });
        }
    }
    clearProjectRoleCache(e = null) {
        if (e) {
            this._projectRoleCache.delete(`role_${e}`);
            for (const [t] of this._projectRoleCache)t.startsWith("role_key_") && this._projectRoleCache.delete(t);
        } else this._projectRoleCache.clear();
    }
    async getProjectRoleWithFallback(e, t = null) {
        if (this._requireReady("getProjectRoleWithFallback"), !e) throw new Error("Project ID is required");
        if (t && Array.isArray(t)) {
            const s = t.find((r)=>r.id === e);
            if (s && s.role) return s.role;
        }
        return await this.getMyProjectRole(e);
    }
    async getProjectRoleByKeyWithFallback(e, t = null) {
        this._requireReady("getProjectRoleByKeyWithFallback");
        let s = e && typeof e == "object" ? e : null;
        if (!s && typeof e == "string") {
            const r = e.indexOf("/");
            s = r > 0 ? {
                owner: e.slice(0, r),
                key: e.slice(r + 1)
            } : {
                owner: null,
                key: e
            };
        }
        if (!s || !s.key) throw new Error("Project key is required");
        if (s.owner && t && Array.isArray(t)) {
            const r = (o)=>(o && o.owner && typeof o.owner == "object" ? o.owner.slug : o?.owner) || o?.ownerSlug || null, a = t.find((o)=>o && o.key === s.key && r(o) === s.owner);
            if (a && a.role) return a.role;
        }
        return await this.getMyProjectRoleByKey(s.owner ? {
            owner: s.owner,
            key: s.key
        } : s.key);
    }
    getTokenDebugInfo() {
        if (!this._tokenManager) return {
            tokenManagerExists: !1,
            error: "TokenManager not initialized"
        };
        const e = this._tokenManager.getTokenStatus(), { tokens: t } = this._tokenManager;
        return {
            tokenManagerExists: !0,
            tokenStatus: e,
            hasAccessToken: !!t.accessToken,
            hasRefreshToken: !!t.refreshToken,
            accessTokenPreview: t.accessToken ? `${t.accessToken.substring(0, 20)}...` : null,
            expiresAt: t.expiresAt,
            timeToExpiry: e.timeToExpiry,
            authHeader: this._tokenManager.getAuthHeader()
        };
    }
    isAuthenticated() {
        return this._tokenManager ? this._tokenManager.hasTokens() : !1;
    }
    hasValidTokens() {
        return this._tokenManager ? this._tokenManager.hasTokens() && this._tokenManager.isAccessTokenValid() : !1;
    }
    async getCurrentUser() {
        try {
            return await this.getMe();
        } catch (e) {
            throw new Error(`Failed to get current user: ${e.message}`, {
                cause: e
            });
        }
    }
    validateRegistrationData(e) {
        const t = [];
        return !e.email || typeof e.email != "string" ? t.push("Email is required and must be a string") : this._isValidEmail(e.email) || t.push("Email must be a valid email address"), !e.password || typeof e.password != "string" ? t.push("Password is required and must be a string") : e.password.length < 8 && t.push("Password must be at least 8 characters long"), e.username && typeof e.username != "string" ? t.push("Username must be a string") : e.username && e.username.length < 3 && t.push("Username must be at least 3 characters long"), {
            isValid: t.length === 0,
            errors: t
        };
    }
    async registerWithValidation(e, t = {}) {
        const s = this.validateRegistrationData(e);
        if (!s.isValid) throw new Error(`Validation failed: ${s.errors.join(", ")}`);
        return await this.register(e, t);
    }
    async loginWithValidation(e, t, s = {}) {
        if (!e || typeof e != "string") throw new Error("Email is required and must be a string");
        if (!t || typeof t != "string") throw new Error("Password is required and must be a string");
        if (!this._isValidEmail(e)) throw new Error("Email must be a valid email address");
        return await this.login(e, t, s);
    }
    _isValidEmail(e) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(e);
    }
    hasPermission(e) {
        const t = this._context?.state;
        return t ? this.hasGlobalPermission(t.globalRole, e) ? !0 : this.checkProjectPermission(t.projectRole, e) : !1;
    }
    hasGlobalPermission(e, t) {
        return (0, $36Jqh.ROLE_PERMISSIONS)[e]?.includes(t) || !1;
    }
    checkProjectPermission(e, t) {
        return (0, $36Jqh.PROJECT_ROLE_PERMISSIONS)[e]?.includes(t) || !1;
    }
    checkProjectFeature(e, t) {
        if (t.startsWith("aiCopilot") || t.startsWith("aiChatbot")) {
            const [s] = t.split(":"), r = (0, $36Jqh.TIER_FEATURES)[e]?.find((o)=>o.startsWith(s));
            if (!r) return !1;
            const [, a] = r.split(":");
            return parseInt(a, 10) || 0;
        }
        return (0, $36Jqh.TIER_FEATURES)[e]?.includes(t) || !1;
    }
    async canPerformOperation(e, t, s = {}) {
        if (this._requireReady(), !e) throw new Error("Project ID is required");
        const { checkFeatures: r = !0, requireAll: a = !0 } = s, o = this._permissionMap[t];
        if (!o) return !1;
        const { permissions: n = [], features: i = [] } = o;
        try {
            const u = await Promise.all(n.map((l)=>this.checkProjectPermission(e, l)));
            if (!(a ? u.every(Boolean) : u.some(Boolean))) return !1;
            if (r && i.length > 0) {
                const l = i.map((d)=>{
                    const m = this.hasProjectFeature(e, d);
                    return d.includes(":") ? typeof m == "number" && m > 0 : m;
                });
                if (!(a ? l.every(Boolean) : l.some(Boolean))) return !1;
            }
            return !0;
        } catch (u) {
            return this._setError(u), !1;
        }
    }
    async withPermission(e, t, s) {
        if (this._requireReady(), !e) throw new Error("Project ID is required");
        if (!await this.canPerformOperation(e, t)) throw new Error(`Permission denied: Cannot perform ${t} operation`);
        return s();
    }
    destroy() {
        this._tokenManager && (this._tokenManager.destroy(), this._tokenManager = null), this._projectRoleCache.clear(), this._setReady(!1);
    }
    _preparePluginPayload(e, t = null) {
        const s = e && typeof e == "object" ? {
            ...e
        } : {}, r = this._resolvePluginSession(t);
        return r && !Object.hasOwn(s, "session") ? (s.session = r, {
            payload: s,
            session: r
        }) : {
            payload: s,
            session: null
        };
    }
    _resolvePluginSession(e = null) {
        if (e) return this._cachePluginSession(e);
        if (this._pluginSession) return this._pluginSession;
        const t = this._options?.pluginSession;
        if (t) return this._cachePluginSession(t);
        const s = this._context?.pluginSession;
        if (s) return this._cachePluginSession(s);
        if (typeof window < "u") {
            try {
                const r = new URL(window.location.href).searchParams.get("session");
                if (r) return this._cachePluginSession(r);
            } catch  {}
            try {
                if (window.localStorage) {
                    const r = window.localStorage.getItem($b5a44255b2c04ae5$var$f);
                    if (r) return this._pluginSession = r, r;
                }
            } catch  {}
        }
        return null;
    }
    _cachePluginSession(e) {
        if (!e) return null;
        if (this._pluginSession = e, typeof window < "u") try {
            window.localStorage && window.localStorage.setItem($b5a44255b2c04ae5$var$f, e);
        } catch  {}
        return e;
    }
    setPluginSession(e) {
        this._cachePluginSession(e);
    }
    _clearPluginSession(e = null) {
        if ((!e || this._pluginSession === e) && (this._pluginSession = null), typeof window < "u") try {
            window.localStorage && window.localStorage.removeItem($b5a44255b2c04ae5$var$f);
        } catch  {}
    }
    async getMyOrgNotifications() {
        this._requireReady("getMyOrgNotifications");
        const e = await this._request("/auth/me/org-notifications", {
            method: "GET",
            methodName: "getMyOrgNotifications"
        });
        return e?.success ? e.data : {
            counts: {}
        };
    }
    async setActiveOrganization(e) {
        if (this._requireReady("setActiveOrganization"), !e) throw new Error("[sdk.setActiveOrganization] orgId is required");
        const s = (await this._request("/auth/me/active-org", {
            method: "PATCH",
            body: JSON.stringify({
                orgId: String(e)
            }),
            methodName: "setActiveOrganization"
        }))?.data?.activeOrganization || String(e);
        return this._currentUser && typeof this._currentUser == "object" && (this._currentUser.activeOrganization = s), {
            activeOrganization: s
        };
    }
    async setActiveWorkspace(e) {
        if (this._requireReady("setActiveWorkspace"), !e) throw new Error("[sdk.setActiveWorkspace] workspaceId is required");
        const s = (await this._request("/auth/me/active-workspace", {
            method: "PATCH",
            body: JSON.stringify({
                workspaceId: String(e)
            }),
            methodName: "setActiveWorkspace"
        }))?.data?.activeWorkspace || String(e);
        return this._currentUser && typeof this._currentUser == "object" && (this._currentUser.activeWorkspace = s), {
            activeWorkspace: s
        };
    }
    subscribeUserEvents(e = {}) {
        if (!this._tokenManager) return ()=>{};
        const t = this._tokenManager.getAccessToken?.();
        if (!t) return ()=>{};
        const s = this._apiUrl;
        if (!s) return ()=>{};
        let r;
        try {
            r = (0, $aDFzZ.io)(s, {
                path: "/user-socket",
                transports: [
                    "websocket",
                    "polling"
                ],
                auth: {
                    token: t
                },
                autoConnect: !0,
                reconnection: !0,
                reconnectionDelay: 1e3,
                reconnectionDelayMax: 1e4
            });
        } catch (o) {
            return (0, $h5XS2.logger).warn("[sdk.subscribeUserEvents] socket init failed:", o?.message || o), ()=>{};
        }
        let a = !1;
        r.on("connect_error", (o)=>{
            o?.message && !a && (a = !0, (0, $h5XS2.logger).warn("[sdk.subscribeUserEvents] connect_error:", o.message));
        });
        for (const [o, n] of Object.entries(e))typeof n == "function" && r.on(o, n);
        return ()=>{
            try {
                r.removeAllListeners();
            } catch  {}
            try {
                r.disconnect();
            } catch  {}
        };
    }
    subscribePresence({ scope: e, userKey: t, meta: s, onCursor: r } = {}, a) {
        if (!this._tokenManager || typeof a != "function" || !e) return ()=>{};
        const o = this._tokenManager.getAccessToken?.();
        if (!o) return ()=>{};
        const n = this._apiUrl;
        if (!n) return ()=>{};
        let i;
        try {
            i = (0, $aDFzZ.io)(n, {
                path: "/user-socket",
                transports: [
                    "websocket",
                    "polling"
                ],
                auth: {
                    token: o
                },
                autoConnect: !0,
                reconnection: !0,
                reconnectionDelay: 1e3,
                reconnectionDelayMax: 1e4
            });
        } catch (c) {
            return (0, $h5XS2.logger).warn("[sdk.subscribePresence] socket init failed:", c?.message || c), ()=>{};
        }
        const u = ()=>{
            try {
                i.emit("presence:join", {
                    scope: e,
                    userKey: t,
                    meta: s || {}
                });
            } catch  {}
        };
        i.on("connect", u), i.on("presence:sync", (c)=>{
            if (!(!c || c.scope !== e)) try {
                a(c.state || {});
            } catch  {}
        }), typeof r == "function" && i.on("presence:cursor", (c)=>{
            if (!(!c || c.scope !== e)) try {
                r(c);
            } catch  {}
        });
        let g = !1;
        i.on("connect_error", (c)=>{
            c?.message && !g && (g = !0, (0, $h5XS2.logger).warn("[sdk.subscribePresence] connect_error:", c.message));
        });
        const l = ()=>{
            try {
                i.removeAllListeners();
            } catch  {}
            try {
                i.disconnect();
            } catch  {}
        };
        return l.sendCursor = (c = {})=>{
            try {
                i.emit("presence:cursor", {
                    ...c,
                    scope: e,
                    userKey: t
                });
            } catch  {}
        }, l;
    }
    async getMyFreebusy({ from: e, to: t }) {
        if (this._requireReady("getMyFreebusy"), !e || !t) throw new Error("from + to (ISO 8601) required");
        const s = new URLSearchParams({
            from: e,
            to: t
        }).toString(), r = await this._request(`/auth/me/freebusy?${s}`, {
            method: "GET",
            methodName: "getMyFreebusy"
        });
        return r?.success ? r.data : {
            slots: []
        };
    }
    async getMyProjects() {
        this._requireReady("getMyProjects");
        const e = await this._request("/auth/me/projects", {
            method: "GET",
            methodName: "getMyProjects"
        });
        return e?.success ? e.data : {
            projects: []
        };
    }
    async getMyTeams() {
        this._requireReady("getMyTeams");
        const e = await this._request("/auth/me/teams", {
            method: "GET",
            methodName: "getMyTeams"
        });
        return e?.success ? e.data : {
            teams: []
        };
    }
    async getMyOrgMemberships() {
        this._requireReady("getMyOrgMemberships");
        const e = await this._request("/auth/me/org-memberships", {
            method: "GET",
            methodName: "getMyOrgMemberships"
        });
        return e?.success ? e.data : {
            memberships: []
        };
    }
    async resendVerification() {
        return this._call("resendVerification", "/auth/resend-verification", {
            method: "POST"
        });
    }
    async verifyEmail(e) {
        if (!e) throw new Error("token is required");
        return this._call("verifyEmail", `/auth/verify-email/${encodeURIComponent(e)}`);
    }
    async getOrgMemberRoles(e) {
        if (this._requireReady("getOrgMemberRoles"), !e) throw new Error("orgId is required");
        const t = await this._request(`/auth/org/${encodeURIComponent(e)}/member-roles`, {
            method: "GET",
            methodName: "getOrgMemberRoles"
        });
        return t?.success ? t.data : {
            members: []
        };
    }
}

});
parcelRegister("em51x", function(module, exports) {

$parcel$export(module.exports, "BaseService", () => $a737045f4878b351$export$3b34f4e23c444fa8);

var $gN40b = parcelRequire("gN40b");

var $bYl6S = parcelRequire("bYl6S");

var $h5XS2 = parcelRequire("h5XS2");
const $a737045f4878b351$export$8cddcc3cb0b99ba = "NETWORK_UNREACHABLE", $a737045f4878b351$var$U = /failed to fetch|networkerror|load failed/i, $a737045f4878b351$var$D = (u)=>u instanceof TypeError && $a737045f4878b351$var$U.test(u?.message || ""), $a737045f4878b351$var$H = new Set([
    "GET",
    "HEAD",
    "OPTIONS"
]), $a737045f4878b351$var$W = new Set([
    "setActiveOrganization",
    "setActiveWorkspace",
    "getMe",
    "endPersona"
]), $a737045f4878b351$var$J = 300, $a737045f4878b351$var$O = (u, t, e, a, r)=>a >= r || u?.code !== $a737045f4878b351$export$8cddcc3cb0b99ba || u?.status !== void 0 ? !1 : $a737045f4878b351$var$H.has(t) || $a737045f4878b351$var$W.has(e), $a737045f4878b351$var$x = (u)=>$a737045f4878b351$var$J * Math.pow(3, u) * (.75 + Math.random() * .5), $a737045f4878b351$var$C = 3, $a737045f4878b351$var$F = new Set([
    "GET",
    "HEAD"
]), $a737045f4878b351$var$N = (u)=>new Promise((t)=>setTimeout(t, u)), $a737045f4878b351$var$R = (u, t)=>{
    const e = $a737045f4878b351$var$D(u), a = e ? `Network unreachable for ${t} \u2014 check connection / VPN / DNS / adblocker. (${u.message})` : `Request failed: ${u.message}`, r = new Error(a, {
        cause: u
    });
    return u?.status && (r.status = u.status), e && (r.code = $a737045f4878b351$export$8cddcc3cb0b99ba), r;
}, $a737045f4878b351$var$T = new Map, $a737045f4878b351$var$$ = (u, t)=>u === "GET" && t.dedupe !== !1 && t.signal === void 0 && t.body === void 0, $a737045f4878b351$var$I = (u, t)=>{
    const e = t || {};
    let a = u;
    for (const r of Object.keys(e).sort())a += `
${r.toLowerCase()}:${e[r]}`;
    return a;
}, $a737045f4878b351$var$G = (u)=>{
    if (!u || typeof u != "object") return u;
    try {
        return typeof structuredClone == "function" ? structuredClone(u) : JSON.parse(JSON.stringify(u));
    } catch  {
        return u;
    }
}, $a737045f4878b351$var$j = (u, t)=>{
    const e = $a737045f4878b351$var$T.get(u);
    if (e) return e.then($a737045f4878b351$var$G);
    const a = t();
    $a737045f4878b351$var$T.set(u, a);
    const r = ()=>{
        $a737045f4878b351$var$T.get(u) === a && $a737045f4878b351$var$T.delete(u);
    };
    return a.then(r, r), a;
}, $a737045f4878b351$export$7d86fa3d9549b847 = {
    size: ()=>$a737045f4878b351$var$T.size,
    clear: ()=>$a737045f4878b351$var$T.clear()
};
class $a737045f4878b351$export$3b34f4e23c444fa8 {
    constructor({ context: t, options: e } = {}){
        this._context = t || {}, this._options = e || {}, this._ready = !1, this._error = null, this._apiUrl = null, this._tokenManager = null;
    }
    init({ context: t }) {
        try {
            const { apiUrl: e } = t || this._context;
            if (this._apiUrl = e || (0, $gN40b.default).apiUrl, !this._apiUrl) throw new Error("Service base URL not configured");
            this._tokenManager = (0, $bYl6S.getTokenManager)({
                apiUrl: this._apiUrl,
                onTokenError: (r)=>{
                    (0, $h5XS2.logger).error("Token management error:", r);
                }
            });
            const a = t || this._context;
            a.authToken && !this._tokenManager.getAccessToken() && this._tokenManager.setTokens({
                access_token: a.authToken
            }), this._setReady();
        } catch (e) {
            throw this._setError(e), e;
        }
    }
    updateContext(t) {
        t && typeof t == "object" && Object.assign(this._context, t);
    }
    getStatus() {
        return {
            ready: this._ready,
            error: this._error,
            context: {
                ...this._context
            }
        };
    }
    isReady() {
        return this._ready;
    }
    _resolveWorkspaceId(t, { fallbackToStorage: e = !1 } = {}) {
        return t != null && t !== "" ? t : this._context?.activeWorkspaceId ? this._context.activeWorkspaceId : e ? this._readActiveWorkspaceStorage() : void 0;
    }
    _resolveScope(t = {}) {
        return {
            orgId: t?.orgId ?? this._context?.activeOrgId ?? void 0,
            workspaceId: t?.workspaceId ?? this._context?.activeWorkspaceId ?? void 0
        };
    }
    _readActiveWorkspaceStorage() {
        try {
            const t = globalThis.sessionStorage?.getItem("activeWorkspace");
            if (t) return t;
        } catch  {}
        try {
            return globalThis.localStorage?.getItem("activeWorkspace") || null;
        } catch  {
            return null;
        }
    }
    _setReady(t = !0) {
        this._ready = t, this._error = null;
    }
    _setError(t) {
        this._ready = !1, this._error = t;
    }
    _getTrackingService() {
        const e = this._context?.services?.tracking;
        return !e || typeof e.trackError != "function" ? null : e;
    }
    _shouldTrackErrors() {
        return this?.constructor?.name !== "TrackingService";
    }
    _trackServiceError(t, e = {}) {
        if (this._shouldTrackErrors()) try {
            const a = this._getTrackingService();
            if (!a) return;
            const r = {
                service: this?.constructor?.name || "UnknownService",
                apiUrl: this._apiUrl || null,
                ...e
            };
            a.trackError(t instanceof Error ? t : new Error(String(t)), r);
        } catch  {}
    }
    _requireAuth() {
        if (!this.getAuthToken()) throw new Error("Authentication required");
    }
    _requireReady(t = "unknown") {
        if (!this.isReady()) throw new Error(`Service not initialized for method: ${t}`);
    }
    async _request(t, e = {}) {
        const a = `${this._apiUrl}/core${t}`, r = String(e.method || "GET").toUpperCase(), o = {};
        if (!$a737045f4878b351$var$F.has(r) && !(e.body instanceof FormData) && (o["Content-Type"] = "application/json"), this._requiresInit(e.methodName) && this._tokenManager) try {
            if (await this._tokenManager.ensureValidToken()) {
                const i = this._tokenManager.getAuthHeader();
                i && (o.Authorization = i);
            }
        } catch (s) {
            (0, $h5XS2.logger).warn("Token management failed, proceeding without authentication:", s);
        }
        const g = e.maxRetries ?? $a737045f4878b351$var$C, d = async ()=>{
            for(let s = 0;; s++)try {
                const i = await fetch(a, {
                    ...e,
                    headers: {
                        ...o,
                        ...e.headers
                    }
                });
                if (!i.ok) {
                    let n = {
                        message: `HTTP ${i.status}: ${i.statusText}`
                    };
                    try {
                        n = await i.json();
                    } catch  {}
                    this._trackServiceError(new Error(n.message || n.error || `HTTP ${i.status}: ${i.statusText}`), {
                        endpoint: t,
                        methodName: e.methodName,
                        status: i.status,
                        statusText: i.statusText
                    });
                    const f = new Error(n.message || n.error || "Request failed", {
                        cause: n
                    });
                    throw f.status = i.status, f;
                }
                return i.status === 204 ? null : i.json();
            } catch (i) {
                const n = i?.status !== void 0 ? i : $a737045f4878b351$var$R(i, a);
                if ($a737045f4878b351$var$O(n, r, e.methodName, s, g)) {
                    await $a737045f4878b351$var$N($a737045f4878b351$var$x(s));
                    continue;
                }
                throw this._trackServiceError(n, {
                    endpoint: t,
                    methodName: e.methodName
                }), n;
            }
        };
        if ($a737045f4878b351$var$$(r, e)) {
            const s = $a737045f4878b351$var$I(a, {
                ...o,
                ...e.headers
            });
            return $a737045f4878b351$var$j(s, d);
        }
        return d();
    }
    async _requestExternal(t, e = {}) {
        const { methodName: a, authHeader: r, ...o } = e, g = {};
        if (o.body !== void 0 && !(o.body instanceof FormData) && (g["Content-Type"] = "application/json", o.body !== null && typeof o.body == "object" && (Array.isArray(o.body) || Object.getPrototypeOf(o.body) === Object.prototype) && (o.body = JSON.stringify(o.body))), r === void 0 && this._requiresInit(a) && this._tokenManager) try {
            await this._tokenManager.ensureValidToken();
            const n = this._tokenManager.getAuthHeader();
            n && (g.Authorization = n);
        } catch (n) {
            (0, $h5XS2.logger).warn("Token management failed, proceeding without authentication:", n);
        }
        else r && (g.Authorization = r);
        const d = String(o.method || "GET").toUpperCase(), s = e.maxRetries ?? $a737045f4878b351$var$C, i = async ()=>{
            for(let n = 0;; n++)try {
                const f = await fetch(t, {
                    ...o,
                    headers: {
                        ...g,
                        ...o.headers
                    }
                });
                if (!f.ok) {
                    let _ = {
                        message: `HTTP ${f.status}: ${f.statusText}`
                    };
                    try {
                        _ = await f.json();
                    } catch  {}
                    this._trackServiceError(new Error(_.message || _.error || `HTTP ${f.status}: ${f.statusText}`), {
                        endpoint: t,
                        methodName: a,
                        status: f.status,
                        statusText: f.statusText
                    });
                    const c = new Error(_.message || _.error || "Request failed", {
                        cause: _
                    });
                    throw c.status = f.status, c;
                }
                if (f.status === 204) return null;
                const p = await f.text();
                if (!p) return null;
                try {
                    return JSON.parse(p);
                } catch  {
                    return p;
                }
            } catch (f) {
                const p = f?.status !== void 0 ? f : $a737045f4878b351$var$R(f, t);
                if ($a737045f4878b351$var$O(p, d, a, n, s)) {
                    await $a737045f4878b351$var$N($a737045f4878b351$var$x(n));
                    continue;
                }
                throw this._trackServiceError(p, {
                    endpoint: t,
                    methodName: a
                }), p;
            }
        };
        if ($a737045f4878b351$var$$(d, o)) {
            const n = $a737045f4878b351$var$I(t, {
                ...g,
                ...o.headers
            });
            return $a737045f4878b351$var$j(n, i);
        }
        return i();
    }
    async _requestStream(t, e = {}) {
        const { methodName: a, authHeader: r, ...o } = e, g = {};
        if (o.body !== void 0 && !(o.body instanceof FormData) && (g["Content-Type"] = "application/json", o.body !== null && typeof o.body == "object" && (Array.isArray(o.body) || Object.getPrototypeOf(o.body) === Object.prototype) && (o.body = JSON.stringify(o.body))), r === void 0 && this._requiresInit(a) && this._tokenManager) try {
            await this._tokenManager.ensureValidToken();
            const d = this._tokenManager.getAuthHeader();
            d && (g.Authorization = d);
        } catch (d) {
            (0, $h5XS2.logger).warn("Token management failed, proceeding without authentication:", d);
        }
        else r && (g.Authorization = r);
        try {
            return await fetch(t, {
                ...o,
                headers: {
                    ...g,
                    ...o.headers
                }
            });
        } catch (d) {
            if (d?.name === "AbortError" || o.signal?.aborted) throw d;
            const s = $a737045f4878b351$var$R(d, t);
            throw this._trackServiceError(s, {
                endpoint: t,
                methodName: a
            }), s;
        }
    }
    async _call(t, e, { method: a = "GET", body: r, headers: o, raw: g = !1 } = {}) {
        this._requireReady(t);
        const d = {
            method: a,
            methodName: t
        };
        o && (d.headers = o), r !== void 0 && (d.body = r instanceof FormData ? r : JSON.stringify(r));
        const s = await this._request(e, d);
        if (g) {
            if (!s || s.success === !1) throw new Error(s?.message || `${t} failed`);
            return s;
        }
        if (s && typeof s == "object" && "success" in s) {
            if (s.success) return s.data;
            throw new Error(s.message || `${t} failed`);
        }
        return s;
    }
    _requiresInit(t) {
        return !new Set([
            "getSignupPolicy",
            "register",
            "login",
            "logout",
            "googleAuth",
            "googleAuthCallback",
            "githubAuth",
            "exchangeNativeAuthToken",
            "requestPasswordReset",
            "confirmPasswordReset",
            "confirmRegistration",
            "previewRegisterConfirmation",
            "setInitialPassword",
            "getSignInSessionInfo",
            "verifyEmail",
            "getPlans",
            "getPlan",
            "listPublicProjects",
            "getPublicProject",
            "listWorkspacePresets",
            "getIntegrationsCatalog",
            "meetGuestMeta",
            "meetGuestRequest",
            "meetGuestStatus",
            "meetGuestToken",
            "startDemo",
            "enterDemo",
            "getSharedResource",
            "listStorefrontProducts",
            "getStorefrontProduct",
            "listStorefrontCollection",
            "listStorefrontJobs",
            "getStorefrontJob",
            "applyToStorefrontJob",
            "listPublicRecords",
            "getPublicRecord",
            "submitPublicRecord",
            "votePublicRecord",
            "registerStorefrontCustomer",
            "loginStorefrontCustomer",
            "requestStorefrontCustomerOtp",
            "verifyStorefrontCustomerOtp",
            "resetStorefrontCustomerPassword",
            "getStorefrontCustomerMe",
            "getStorefrontAuthProviders",
            "signInStorefrontCustomerWithOAuth",
            "resolveStorefront",
            "getStorefrontCheckout",
            "placeStorefrontOrder",
            "getStorefrontOrderStatus",
            "payStorefrontOrderTest",
            "listStorefrontOrders",
            "getStorefrontOrder",
            "getStorefrontCart",
            "replaceStorefrontCart",
            "clearStorefrontCart",
            "listStorefrontAddresses",
            "createStorefrontAddress",
            "updateStorefrontAddress",
            "deleteStorefrontAddress",
            "updateStorefrontCustomerMe",
            "changeStorefrontCustomerPassword",
            "deleteStorefrontCustomerAccount",
            "listStorefrontAppointments",
            "getStorefrontBalances",
            "listStorefrontLoyalty",
            "leadSources.submitForm",
            "getOnboardingConfig",
            "startResearch",
            "getResearch"
        ]).has(t);
    }
    async _createSubdomainRecords(t) {
        const e = this._context?.dnsWorkerUrl || (0, $gN40b.default).dnsWorkerUrl, a = this._context?.dnsApiKey || (0, $gN40b.default).dnsApiKey;
        if (!e) {
            (0, $h5XS2.logger).warn("DNS worker URL not configured, skipping subdomain registration");
            return;
        }
        const r = await fetch(`${e}/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...a ? {
                    Authorization: `Bearer ${a}`
                } : {}
            },
            body: JSON.stringify({
                name: t
            })
        });
        if (!r.ok) {
            const o = await r.json().catch(()=>({
                    error: r.statusText
                }));
            throw new Error(o.error || `DNS registration failed (${r.status})`);
        }
        return r.json();
    }
    async _mintStreamTicket(t) {
        const e = t ? {
            workspace: String(t)
        } : {}, r = (await this._call("mintStreamTicket", "/auth/stream-ticket", {
            method: "POST",
            body: e
        }))?.ticket;
        if (!r) throw new Error("stream-ticket mint returned no ticket");
        return r;
    }
    _sseSubscribe(t, e = {}, a, r = {}) {
        if (typeof a != "function") throw new Error("_sseSubscribe: onEvent must be a function");
        const o = r?.flatParams === !0, g = r?.anonymous === !0, d = Array.isArray(r?.events) && r.events.length ? r.events : [
            {
                name: "tickets.snapshot",
                frame: (l)=>({
                        type: "snapshot",
                        tickets: l.tickets || l
                    })
            },
            {
                name: "tickets.insert",
                frame: (l)=>({
                        type: "tickets.insert",
                        ticket: l.ticket || l
                    })
            },
            {
                name: "tickets.update",
                frame: (l)=>({
                        type: "tickets.update",
                        ticket: l.ticket || l
                    })
            },
            {
                name: "tickets.delete",
                frame: (l)=>({
                        type: "tickets.delete",
                        ticket: l.ticket || l
                    })
            }
        ];
        let s = null, i = null, n = !1, f = 0;
        const p = 8e3, _ = e?.workspaceId || e?.workspace || null, c = (l)=>{
            const y = new URLSearchParams;
            l && y.set("ticket", l);
            for (const [k, S] of Object.entries(e || {}))S != null && y.set(o ? k : `filter[${k}]`, String(S));
            const h = y.toString();
            return `${this._apiUrl}/core${t}${h ? `?${h}` : ""}`;
        }, m = ()=>{
            f += 1;
            const l = Math.min(1e3 * Math.pow(2, f - 1), p);
            i = setTimeout(()=>{
                n || w();
            }, l);
        }, w = async ()=>{
            if (n) return;
            let l;
            if (typeof EventSource < "u") l = EventSource;
            else {
                const k = "eventsource";
                try {
                    const S = await import(k);
                    l = S.default || S.EventSource || S;
                } catch  {
                    throw new Error("[sdk._sseSubscribe] EventSource is not available in this environment. In Node.js, install the optional `eventsource` npm package: `bun add eventsource` or `npm install eventsource`.");
                }
            }
            let y = null;
            if (!g && this._tokenManager?.getAccessToken?.()) try {
                y = await this._mintStreamTicket(_);
            } catch  {
                if (n) return;
                m();
                return;
            }
            if (n) return;
            const h = c(y);
            s = new l(h);
            for (const { name: k, frame: S } of d)s.addEventListener(k, (A)=>{
                try {
                    const b = JSON.parse(A.data), P = typeof S == "function" ? S(b, k) : b;
                    P !== void 0 && a(P);
                } catch  {}
            });
            s.addEventListener("error", ()=>{
                if (!n) {
                    try {
                        s.close();
                    } catch  {}
                    s = null, m();
                }
            }), s.addEventListener("open", ()=>{
                f = 0;
            });
        };
        return w(), function() {
            if (n = !0, i && (clearTimeout(i), i = null), s) {
                try {
                    s.close();
                } catch  {}
                s = null;
            }
        };
    }
    _streamPost(t, e, { onChunk: a, onDone: r, onError: o } = {}) {
        this._requireReady("_streamPost");
        const g = `${this._apiUrl}/core${t}`, d = new AbortController, s = {
            "Content-Type": "application/json",
            Accept: "text/event-stream"
        };
        if (this._tokenManager) {
            const n = this._tokenManager.getAccessToken?.();
            n && (s.Authorization = `Bearer ${n}`);
        }
        const i = (n, f)=>{
            if (typeof n == "function") try {
                n(f);
            } catch  {}
        };
        return (async ()=>{
            let n;
            try {
                n = await fetch(g, {
                    method: "POST",
                    headers: s,
                    body: JSON.stringify(e || {}),
                    signal: d.signal
                });
            } catch (c) {
                c?.name !== "AbortError" && i(o, c);
                return;
            }
            if (!n.ok || !n.body) {
                const c = await n.text().catch(()=>""), m = new Error(n.status >= 500 ? "The AI service is temporarily unavailable \u2014 please try again." : `The AI request was rejected (HTTP ${n.status}).`);
                m.status = n.status, m.code = `STREAM_HTTP_${n.status}`, m.detail = c.slice(0, 300), i(o, m);
                return;
            }
            const f = n.body.getReader(), p = new TextDecoder;
            let _ = "";
            try {
                for(;;){
                    const { done: c, value: m } = await f.read();
                    if (c) break;
                    _ += p.decode(m, {
                        stream: !0
                    });
                    const w = _.split(`
`);
                    _ = w.pop() || "";
                    for (const l of w){
                        if (!l.startsWith("data: ")) continue;
                        const y = l.slice(6).trim();
                        if (!y || y === "[DONE]") continue;
                        let h;
                        try {
                            h = JSON.parse(y);
                        } catch  {
                            continue;
                        }
                        if (h.error) {
                            i(o, new Error(h.error));
                            continue;
                        }
                        if (h.done) {
                            i(r, h);
                            continue;
                        }
                        typeof h.text == "string" && i(a, h.text);
                    }
                }
            } catch (c) {
                c?.name !== "AbortError" && i(o, c);
            } finally{
                try {
                    f.cancel()?.catch?.(()=>{});
                } catch  {}
            }
        })(), ()=>{
            try {
                d.abort();
            } catch  {}
        };
    }
    _streamSSE(t, { onEvent: e, onError: a } = {}) {
        const r = {
            Accept: "text/event-stream"
        };
        if (this._tokenManager) {
            const c = this._tokenManager.getAccessToken?.();
            c && (r.Authorization = `Bearer ${c}`);
        }
        const o = (c, m)=>{
            if (typeof c == "function") try {
                c(m);
            } catch  {}
        }, g = (c)=>{
            let m = "message";
            const w = [];
            for (const h of c.split(`
`))h.startsWith("event:") ? m = h.slice(6).trim() : h.startsWith("data:") && w.push(h.slice(5).replace(/^ /, ""));
            if (!w.length) return null;
            const l = w.join(`
`);
            if (l === "[DONE]") return null;
            let y;
            try {
                y = JSON.parse(l);
            } catch  {
                return null;
            }
            return {
                event: m,
                data: y
            };
        };
        let d = null, s = !1, i = 0, n = null;
        const f = 8e3, p = ()=>{
            if (s) return;
            i += 1;
            const c = Math.min(1e3 * Math.pow(2, i - 1), f);
            n = setTimeout(()=>{
                n = null, s || _();
            }, c);
        }, _ = ()=>{
            s || (d = new AbortController, (async ()=>{
                let c;
                try {
                    c = await fetch(t, {
                        method: "GET",
                        headers: r,
                        signal: d.signal
                    });
                } catch (h) {
                    if (s || h?.name === "AbortError") return;
                    p();
                    return;
                }
                if (s) return;
                if (!c.ok || !c.body) {
                    const h = await c.text().catch(()=>""), k = new Error(c.status >= 500 ? "The AI service is temporarily unavailable \u2014 please try again." : `The AI request was rejected (HTTP ${c.status}).`);
                    k.status = c.status, k.code = `STREAM_HTTP_${c.status}`, k.detail = h.slice(0, 300), o(a, k);
                    return;
                }
                i = 0;
                const m = c.body.getReader(), w = new TextDecoder;
                let l = "", y = null;
                try {
                    for(;;){
                        const { done: h, value: k } = await m.read();
                        if (h) break;
                        l += w.decode(k, {
                            stream: !0
                        });
                        const S = l.split(`

`);
                        l = S.pop() || "";
                        for (const A of S){
                            const b = g(A);
                            b && o(e, b);
                        }
                    }
                } catch (h) {
                    y = h;
                } finally{
                    try {
                        m.cancel()?.catch?.(()=>{});
                    } catch  {}
                }
                s || y && y.name === "AbortError" || p();
            })());
        };
        return _(), function() {
            if (s = !0, n && (clearTimeout(n), n = null), d) {
                try {
                    d.abort();
                } catch  {}
                d = null;
            }
        };
    }
    destroy() {
        this._tokenManager && (this._tokenManager.destroy(), this._tokenManager = null), this._ready = !1, this._setReady(!1);
    }
}

});
parcelRegister("gN40b", function(module, exports) {

$parcel$export(module.exports, "default", () => $c39453a6879fb770$export$2e2bcd8739ae039);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");

var $hmkNw = parcelRequire("hmkNw");

var $h5XS2 = parcelRequire("h5XS2");
const $c39453a6879fb770$var$s = {
    common: {
        googleClientId: "93720420804-eaafvil4gpj2mnpqpo1he5el0ph6ekhc.apps.googleusercontent.com",
        assistantsApiUrl: "https://fly-control.symbols.app",
        features: {
            newUserOnboarding: !0,
            betaFeatures: !1,
            trackingEnabled: !0
        }
    },
    local: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liAFrsR0StbAO6PO",
        grafanaAppName: "Symbols Localhost",
        features: {
            trackingEnabled: !1,
            betaFeatures: !0,
            newUserOnboarding: !0
        },
        typesenseCollectionName: "docs"
    },
    development: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liHxyWFBxS8f1gnF",
        grafanaAppName: "Symbols Dev",
        typesenseCollectionName: "docs"
    },
    test: {
        githubClientId: "Ov23liHxyWFBxS8f1gnF",
        grafanaAppName: "Symbols Test",
        typesenseCollectionName: "docs"
    },
    next: {
        githubClientId: "Ov23liHxyWFBxS8f1gnF",
        grafanaAppName: "Symbols Next",
        typesenseCollectionName: "docs"
    },
    upcoming: {
        githubClientId: "Ov23liWF7NvdZ056RV5J",
        grafanaAppName: "Symbols Upcoming",
        typesenseCollectionName: "docs"
    },
    staging: {
        githubClientId: "Ov23ligwZDQVD0VfuWNa",
        grafanaAppName: "Symbols Staging",
        typesenseCollectionName: "docs"
    },
    preview: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liFAlOEIXtX3dBtR",
        grafanaAppName: "Symbols Preview",
        typesenseCollectionName: "docs"
    },
    production: {
        dnsWorkerUrl: "https://dns.symbo.ls",
        githubClientId: "Ov23liFAlOEIXtX3dBtR",
        grafanaAppName: "Symbols",
        typesenseCollectionName: "docs"
    }
};
$c39453a6879fb770$var$s.testing = $c39453a6879fb770$var$s.test;
const $c39453a6879fb770$var$d = (e)=>{
    let t = "", o = "", r = "";
    try {
        const n = new URL(e);
        t = n.hostname, r = n.protocol.replace(":", ""), o = n.port || (r === "https" ? "443" : "80");
    } catch  {}
    return {
        typesenseSearchUrl: `${e}/search/docs/multi_search`,
        typesenseSearchPath: "/search/docs",
        typesenseHost: t,
        typesensePort: o,
        typesenseProtocol: r,
        typesenseApiKey: "proxy"
    };
}, $c39453a6879fb770$var$m = ()=>{
    const e = "production";
    if (!$c39453a6879fb770$var$s[e]) throw new Error(`Unknown environment "${e}"`);
    return e;
}, $c39453a6879fb770$export$44487a86467333c3 = ()=>{
    try {
        const e = $c39453a6879fb770$var$m(), t = {
            ...$c39453a6879fb770$var$s.common,
            ...$c39453a6879fb770$var$s[e]
        }, o = e === "testing" ? "test" : e, r = typeof globalThis < "u" && globalThis.__SYMBOLS_CHANNEL__ ? (0, $hmkNw.apiUrl)() : (0, $hmkNw.apiUrl)(o), n = {
            ...t,
            features: {
                ...$c39453a6879fb770$var$s.common.features || {},
                ...$c39453a6879fb770$var$s[e] && $c39453a6879fb770$var$s[e].features || {}
            },
            socketUrl: typeof globalThis < "u" && globalThis.__SYMBOLS_CHANNEL__ ? (0, $hmkNw.socketUrl)() : (0, $hmkNw.socketUrl)(o),
            apiUrl: r,
            githubClientId: t.githubClientId,
            grafanaUrl: null,
            dnsWorkerUrl: t.dnsWorkerUrl,
            assistantsApiUrl: t.assistantsApiUrl,
            dnsApiKey: "",
            ...$c39453a6879fb770$var$d(r),
            typesenseCollectionName: t.typesenseCollectionName,
            channel: o,
            isDevelopment: (0, $dSdIt.isDevelopment)(e),
            isTest: e === "test" || e === "testing",
            isTesting: e === "test" || e === "testing",
            isStaging: e === "staging",
            isPreview: e === "preview",
            isProduction: e === "production"
        }, l = [
            "socketUrl",
            "apiUrl",
            "githubClientId",
            "googleClientId"
        ].filter((c)=>!n[c]);
        return l.length > 0 && (0, $h5XS2.logger).error(`Missing required configuration: ${l.join(", ")}`), $parcel$global.window && ($parcel$global.window.finalConfig = n), n;
    } catch (e) {
        return (0, $h5XS2.logger).error("Failed to load environment configuration:", e), {
            ...$c39453a6879fb770$var$s.development
        };
    }
};
var $c39453a6879fb770$export$2e2bcd8739ae039 = $c39453a6879fb770$export$44487a86467333c3();

});
parcelRegister("h5XS2", function(module, exports) {

$parcel$export(module.exports, "setDebug", () => $c721585dd7594e67$export$9c61b55a0b327dd9);
$parcel$export(module.exports, "logger", () => $c721585dd7594e67$export$af88d00dbe7f521);
const $c721585dd7594e67$var$o = typeof window < "u" && true;
let $c721585dd7594e67$var$e = !1;
const $c721585dd7594e67$export$9c61b55a0b327dd9 = (r)=>{
    $c721585dd7594e67$var$e = r;
}, $c721585dd7594e67$var$n = ()=>{}, $c721585dd7594e67$export$af88d00dbe7f521 = {
    get log () {
        return $c721585dd7594e67$var$e || $c721585dd7594e67$var$o ? console.log.bind(console) : $c721585dd7594e67$var$n;
    },
    get warn () {
        return $c721585dd7594e67$var$e || $c721585dd7594e67$var$o ? console.warn.bind(console) : $c721585dd7594e67$var$n;
    },
    get error () {
        return $c721585dd7594e67$var$e || $c721585dd7594e67$var$o ? console.error.bind(console) : $c721585dd7594e67$var$n;
    }
};

});


parcelRegister("bYl6S", function(module, exports) {

$parcel$export(module.exports, "getTokenManager", () => $8b75ac4983722400$export$fb76b54a25406f25);

var $h5XS2 = parcelRequire("h5XS2");

var $7sTYS = parcelRequire("7sTYS");
var $8b75ac4983722400$require$Buffer = $7sTYS.Buffer;
const $8b75ac4983722400$var$l = /failed to fetch|networkerror|load failed|network request failed/i, $8b75ac4983722400$export$954f38dfca662ae = (n)=>!!n && (n.code === "NETWORK_UNREACHABLE" || n instanceof TypeError && $8b75ac4983722400$var$l.test(n.message || "") || n.name === "TypeError" && $8b75ac4983722400$var$l.test(n.message || "")), $8b75ac4983722400$var$T = (n)=>{
    if (!n || typeof n != "string") return null;
    const e = n.split(".");
    if (e.length !== 3) return null;
    try {
        let s = e[1].replace(/-/g, "+").replace(/_/g, "/");
        for(; s.length % 4;)s += "=";
        const r = typeof atob == "function" ? atob(s) : $8b75ac4983722400$require$Buffer.from(s, "base64").toString("utf8"), t = JSON.parse(r);
        return t && typeof t == "object" ? t : null;
    } catch  {
        return null;
    }
}, $8b75ac4983722400$var$h = (n)=>{
    const e = $8b75ac4983722400$var$T(n), s = e?.userId ?? e?.sub;
    return s == null || s === "" ? null : String(s);
};
class $8b75ac4983722400$export$aa9349e63a87bac1 {
    constructor(e = {}){
        this.config = {
            storagePrefix: "symbols_",
            storageType: typeof window > "u" ? "memory" : "localStorage",
            refreshBuffer: 60000,
            maxRetries: 3,
            apiUrl: e.apiUrl || "/api",
            onTokenRefresh: e.onTokenRefresh || null,
            onTokenExpired: e.onTokenExpired || null,
            onTokenError: e.onTokenError || null,
            reacquireSession: typeof e.reacquireSession == "function" ? e.reacquireSession : null,
            reacquireTimeoutMs: 8e3,
            ...e
        }, this.tokens = {
            accessToken: null,
            refreshToken: null,
            expiresAt: null,
            expiresIn: null
        }, this.refreshPromise = null, this._reacquirePromise = null, this._reacquiredShortLived = !1, this.refreshTimeout = null, this.retryCount = 0, this._personaToken = null, this.loadTokens(), this.loadPersonaToken();
    }
    get storageKeys() {
        return {
            accessToken: `${this.config.storagePrefix}access_token`,
            refreshToken: `${this.config.storagePrefix}refresh_token`,
            expiresAt: `${this.config.storagePrefix}expires_at`,
            expiresIn: `${this.config.storagePrefix}expires_in`,
            sessionSource: `${this.config.storagePrefix}session_source`
        };
    }
    get personaStorageKey() {
        return `${this.config.storagePrefix}persona_access_token`;
    }
    get _tabStorage() {
        if (typeof window > "u") return this._memoryStorage;
        try {
            const e = window.sessionStorage, s = `${this.config.storagePrefix}__tm_persona_test__`;
            return e.setItem(s, "1"), e.removeItem(s), e;
        } catch  {
            return this._memoryStorage;
        }
    }
    get storage() {
        if (typeof window > "u") return this._memoryStorage;
        const e = (t)=>{
            try {
                const o = t(), i = `${this.config.storagePrefix}__tm_test__`;
                return o.setItem(i, "1"), o.removeItem(i), o;
            } catch  {
                return null;
            }
        }, s = e(()=>window.localStorage), r = e(()=>window.sessionStorage);
        switch(this.config.storageType){
            case "sessionStorage":
                return r || this._memoryStorage;
            case "memory":
                return this._memoryStorage;
            default:
                return s || this._memoryStorage;
        }
    }
    _memoryStorage = {
        _data: {},
        getItem: (e)=>this._memoryStorage._data[e] || null,
        setItem: (e, s)=>{
            this._memoryStorage._data[e] = s;
        },
        removeItem: (e)=>{
            delete this._memoryStorage._data[e];
        },
        clear: ()=>{
            this._memoryStorage._data = {};
        }
    };
    setTokens(e) {
        const { access_token: s, refresh_token: r, expires_in: t, token_type: o = "Bearer" } = e;
        if (!s) throw new Error("Access token is required");
        const i = Date.now(), c = t ? i + t * 1e3 : null;
        return this.tokens = {
            accessToken: s,
            refreshToken: r || this.tokens.refreshToken,
            expiresAt: c,
            expiresIn: t,
            tokenType: o
        }, this.saveTokens(), this.tokens.refreshToken && this._markSessionSource("own"), this.scheduleRefresh(), this.config.onTokenRefresh && this.config.onTokenRefresh(this.tokens), this.tokens;
    }
    getAccessToken() {
        return this._personaToken || this.tokens.accessToken;
    }
    setPersonaToken(e) {
        if (typeof e != "string" || !e) return (0, $h5XS2.logger).warn("[TokenManager] refusing to install an empty persona token"), !1;
        this._personaToken = e;
        try {
            this._tabStorage.setItem(this.personaStorageKey, e);
        } catch (s) {
            (0, $h5XS2.logger).warn("[TokenManager] persona overlay not persisted to sessionStorage:", s);
        }
        return !0;
    }
    getPersonaToken() {
        return this._personaToken;
    }
    hasPersonaToken() {
        return !!this._personaToken;
    }
    clearPersonaToken() {
        this._personaToken = null;
        try {
            this._tabStorage.removeItem(this.personaStorageKey);
        } catch  {}
    }
    loadPersonaToken() {
        try {
            const e = this._tabStorage.getItem(this.personaStorageKey);
            this._personaToken = typeof e == "string" && e ? e : null;
        } catch  {
            this._personaToken = null;
        }
    }
    setSessionReacquirer(e) {
        this.config.reacquireSession = typeof e == "function" ? e : null;
    }
    hasSessionReacquirer() {
        return typeof this.config.reacquireSession == "function";
    }
    async reacquireSession() {
        return (await this._reacquire()).token;
    }
    _reacquireInBackground() {
        if (this._reacquirePromise) return;
        const e = this.tokens.accessToken;
        this._reacquire().then(({ token: s, noSession: r })=>{
            s || !r || this.tokens.accessToken !== e || this.hasRefreshToken() || (this.clearTokens(), this.config.onTokenExpired && this.config.onTokenExpired());
        }).catch((s)=>{
            (0, $h5XS2.logger).warn("[TokenManager] background session re-ask failed:", s?.message || s);
        });
    }
    async _reacquire() {
        if (!this.hasSessionReacquirer()) return {
            token: null,
            noSession: !1
        };
        if (this._reacquirePromise) return this._reacquirePromise;
        this._reacquirePromise = (async ()=>{
            let e = !1, s = null;
            try {
                s = await this.config.reacquireSession({
                    timeoutMs: this.config.reacquireTimeoutMs,
                    onNoSession: ()=>{
                        e = !0;
                    }
                });
            } catch (r) {
                return (0, $h5XS2.logger).warn("[TokenManager] session reacquirer failed:", r?.message || r), {
                    token: null,
                    noSession: e
                };
            }
            return this.adoptAccessToken(s) ? (this._reacquiredToken = this.tokens.accessToken, this._reacquiredShortLived = !this.isAccessTokenValid(), {
                token: this.getAccessToken(),
                noSession: !1
            }) : {
                token: null,
                noSession: e
            };
        })();
        try {
            return await this._reacquirePromise;
        } finally{
            this._reacquirePromise = null;
        }
    }
    adoptAccessToken(e) {
        const s = e?.access_token || e?.accessToken;
        if (!s || typeof s != "string") return !1;
        const r = Date.now();
        let t = Number(e.expires_at ?? e.expiresAt) || null;
        if (!t && Number(e.expires_in) && (t = r + Number(e.expires_in) * 1e3), t && t <= r) return !1;
        this.tokens = {
            accessToken: s,
            refreshToken: null,
            expiresAt: t,
            expiresIn: t ? Math.max(0, Math.floor((t - r) / 1e3)) : null,
            tokenType: "Bearer"
        }, this.saveTokens();
        try {
            const { storage: o } = this, i = this.storageKeys;
            o.removeItem(i.refreshToken), t || (o.removeItem(i.expiresAt), o.removeItem(i.expiresIn));
        } catch  {}
        return this._markSessionSource("bridge"), this.scheduleRefresh(), this.retryCount = 0, this.config.onTokenRefresh && this.config.onTokenRefresh(this.tokens), !0;
    }
    _markSessionSource(e) {
        try {
            this.storage.setItem(this.storageKeys.sessionSource, e);
        } catch  {}
    }
    getRefreshToken() {
        return this.tokens.refreshToken;
    }
    isBorrowedSession() {
        try {
            return this.storage.getItem(this.storageKeys.sessionSource) === "bridge";
        } catch  {
            return !1;
        }
    }
    getAuthHeader() {
        const e = this.getAccessToken();
        return e ? `${this.tokens.tokenType || "Bearer"} ${e}` : null;
    }
    _decodeJwtExpMs() {
        const e = this.tokens.accessToken;
        if (!e || typeof e != "string") return null;
        const s = e.split(".");
        if (s.length !== 3) return null;
        try {
            let r = s[1].replace(/-/g, "+").replace(/_/g, "/");
            for(; r.length % 4;)r += "=";
            const t = typeof atob == "function" ? atob(r) : $8b75ac4983722400$require$Buffer.from(r, "base64").toString("utf8"), o = JSON.parse(t), i = typeof o?.exp == "number" ? o.exp : null;
            return i != null ? i * 1e3 : null;
        } catch  {
            return null;
        }
    }
    _resolveAccessTokenExpiryMs() {
        return this.tokens.expiresAt ? this.tokens.expiresAt : this._decodeJwtExpMs();
    }
    isAccessTokenValid() {
        if (!this.tokens.accessToken) return !1;
        const e = this._resolveAccessTokenExpiryMs();
        if (!e) return !0;
        const s = Date.now(), r = s < e - this.config.refreshBuffer;
        return r || (0, $h5XS2.logger).log("[TokenManager] Access token is expired or near expiry:", {
            now: new Date(s).toISOString(),
            expiresAt: new Date(e).toISOString(),
            refreshBuffer: this.config.refreshBuffer
        }), r;
    }
    isAccessTokenActuallyValid() {
        if (!this.tokens.accessToken) return !1;
        const e = this._resolveAccessTokenExpiryMs();
        return e ? Date.now() < e : !0;
    }
    hasTokens() {
        return !!this.tokens.accessToken;
    }
    hasRefreshToken() {
        return !!this.tokens.refreshToken;
    }
    async ensureValidToken() {
        if (!this.hasTokens()) return null;
        if (this.isAccessTokenValid()) return this.getAccessToken();
        if (!this.hasRefreshToken()) {
            if (this._reacquiredToken && this._reacquiredToken === this.tokens.accessToken && this._reacquiredShortLived && this.isAccessTokenActuallyValid()) return this.getAccessToken();
            if (this.hasSessionReacquirer()) {
                if (this.isAccessTokenActuallyValid()) return this._reacquireInBackground(), this.getAccessToken();
                const { token: e } = await this._reacquire();
                if (e) return e;
            }
            return this.clearTokens(), this.config.onTokenExpired && this.config.onTokenExpired(), null;
        }
        try {
            return await this.refreshTokens(), this.getAccessToken();
        } catch (e) {
            throw $8b75ac4983722400$export$954f38dfca662ae(e) ? ((0, $h5XS2.logger).warn("[TokenManager] refresh unreachable \u2014 keeping session for retry"), e) : (this.clearTokens(), this.config.onTokenError && this.config.onTokenError(e), e);
        }
    }
    async refreshTokens() {
        if (this.refreshPromise) return this.refreshPromise;
        if (!this.hasRefreshToken()) throw new Error("No refresh token available");
        if (this.retryCount >= this.config.maxRetries) throw new Error("Max refresh retries exceeded");
        this.refreshPromise = this._performRefresh();
        try {
            const e = await this.refreshPromise;
            return this.retryCount = 0, e;
        } catch (e) {
            throw $8b75ac4983722400$export$954f38dfca662ae(e) || this.retryCount++, e;
        } finally{
            this.refreshPromise = null;
        }
    }
    async _performRefresh() {
        const e = ()=>this._performRefreshExclusive();
        return typeof navigator < "u" && navigator.locks && typeof navigator.locks.request == "function" ? navigator.locks.request("symbols_token_rotation", e) : e();
    }
    async _performRefreshExclusive() {
        if (this._adoptStoredTokens() && this.isAccessTokenValid()) return this.tokens;
        const e = this.getRefreshToken();
        try {
            return await this._rotateWith(e);
        } catch (s) {
            if ($8b75ac4983722400$export$954f38dfca662ae(s)) throw s;
            const r = this._adoptStoredTokens(), t = this.getRefreshToken();
            if (r && t && t !== e) return (0, $h5XS2.logger).warn("[TokenManager] refresh lost a cross-tab rotation race \u2014 adopting the winner's tokens"), this.isAccessTokenValid() ? this.tokens : this._rotateWith(t);
            throw s;
        }
    }
    async _rotateWith(e) {
        const s = await fetch(`${this.config.apiUrl}/core/auth/refresh`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                refreshToken: e
            })
        });
        if (!s.ok) {
            const t = await s.json().catch(()=>({})), o = new Error(t.message || `Token refresh failed: ${s.status}`);
            throw o.status = s.status, t.reason && (o.reason = t.reason), t.code && (o.code = t.code), o;
        }
        const r = await s.json();
        if (r.success && r.data && r.data.tokens) {
            const { tokens: t } = r.data, o = {
                access_token: t.accessToken,
                refresh_token: t.refreshToken,
                expires_in: t.accessTokenExp?.expiresIn,
                token_type: "Bearer"
            };
            return this.setTokens(o);
        }
        return this.setTokens(r);
    }
    _adoptStoredTokens() {
        try {
            const { storage: e } = this, s = this.storageKeys, r = e.getItem(s.accessToken), t = e.getItem(s.refreshToken);
            if (!r && !t || !(r !== this.tokens.accessToken || t !== this.tokens.refreshToken)) return !1;
            const i = e.getItem(s.expiresAt), c = e.getItem(s.expiresIn);
            return this.tokens = {
                accessToken: r,
                refreshToken: t,
                expiresAt: i ? parseInt(i, 10) : null,
                expiresIn: c ? parseInt(c, 10) : null,
                tokenType: "Bearer"
            }, this.scheduleRefresh(), !0;
        } catch  {
            return !1;
        }
    }
    adoptStoredTokensIfSameUser() {
        try {
            const e = $8b75ac4983722400$var$h(this.tokens.refreshToken) || $8b75ac4983722400$var$h(this.tokens.accessToken);
            if (!e) return !1;
            const { storage: s } = this, r = this.storageKeys, t = s.getItem(r.refreshToken), o = s.getItem(r.accessToken);
            return !t || !o || $8b75ac4983722400$var$h(t) !== e || $8b75ac4983722400$var$h(o) !== e ? !1 : this._adoptStoredTokens();
        } catch  {
            return !1;
        }
    }
    scheduleRefresh() {
        if (this.refreshTimeout && (clearTimeout(this.refreshTimeout), this.refreshTimeout = null), !this.tokens.expiresAt || !this.hasRefreshToken()) return;
        const e = Date.now(), s = this.tokens.expiresAt - this.config.refreshBuffer, r = Math.max(0, s - e);
        this.refreshTimeout = setTimeout(async ()=>{
            try {
                await this.refreshTokens();
            } catch (t) {
                (0, $h5XS2.logger).error("Automatic token refresh failed:", t), this.config.onTokenError && this.config.onTokenError(t);
            }
        }, r);
    }
    saveTokens() {
        try {
            const { storage: e } = this, s = this.storageKeys;
            this.tokens.accessToken && e.setItem(s.accessToken, this.tokens.accessToken), this.tokens.refreshToken && e.setItem(s.refreshToken, this.tokens.refreshToken), this.tokens.expiresAt && e.setItem(s.expiresAt, this.tokens.expiresAt.toString()), this.tokens.expiresIn && e.setItem(s.expiresIn, this.tokens.expiresIn.toString());
        } catch (e) {
            (0, $h5XS2.logger).error("[TokenManager] Error saving tokens to storage:", e);
        }
    }
    loadTokens() {
        try {
            const { storage: e } = this, s = this.storageKeys, r = e.getItem(s.accessToken), t = e.getItem(s.refreshToken), o = e.getItem(s.expiresAt), i = e.getItem(s.expiresIn);
            r && (this.tokens = {
                accessToken: r,
                refreshToken: t,
                expiresAt: o ? parseInt(o, 10) : null,
                expiresIn: i ? parseInt(i, 10) : null,
                tokenType: "Bearer"
            }, this.scheduleRefresh());
        } catch (e) {
            (0, $h5XS2.logger).error("[TokenManager] Error loading tokens from storage:", e), this.tokens = {
                accessToken: null,
                refreshToken: null,
                expiresAt: null,
                expiresIn: null
            };
        }
    }
    clearTokens() {
        this.tokens = {
            accessToken: null,
            refreshToken: null,
            expiresAt: null,
            expiresIn: null
        }, this.clearPersonaToken();
        const { storage: e } = this, s = this.storageKeys;
        Object.values(s).forEach((r)=>{
            e.removeItem(r);
        }), this.refreshTimeout && (clearTimeout(this.refreshTimeout), this.refreshTimeout = null), this.retryCount = 0;
    }
    getTokenStatus() {
        const e = this.hasTokens(), s = this.isAccessTokenValid(), r = this._resolveAccessTokenExpiryMs(), t = r ? r - Date.now() : null;
        let o = "missing";
        return e && (s || this.hasRefreshToken() || this.hasSessionReacquirer() ? o = "valid" : o = "expired"), {
            status: o,
            hasTokens: e,
            isValid: s,
            hasRefreshToken: this.hasRefreshToken(),
            expiresAt: r,
            timeToExpiry: t,
            willExpireSoon: t ? t < this.config.refreshBuffer : !1
        };
    }
    destroy() {
        this.refreshTimeout && (clearTimeout(this.refreshTimeout), this.refreshTimeout = null), this.refreshPromise = null;
    }
}
const $8b75ac4983722400$var$u = "__SMBLS_TOKEN_MANAGER__", $8b75ac4983722400$export$fb76b54a25406f25 = (n)=>(globalThis[$8b75ac4983722400$var$u] || (globalThis[$8b75ac4983722400$var$u] = new $8b75ac4983722400$export$aa9349e63a87bac1(n)), globalThis[$8b75ac4983722400$var$u]), $8b75ac4983722400$export$c04fee7f4b026514 = (n)=>new $8b75ac4983722400$export$aa9349e63a87bac1(n);

});
parcelRegister("7sTYS", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $56f6928ee5dc238e$export$a143d493d941bafc, (v) => $56f6928ee5dc238e$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $56f6928ee5dc238e$export$f99ded8fe4b79145, (v) => $56f6928ee5dc238e$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $56f6928ee5dc238e$export$a143d493d941bafc;
var $56f6928ee5dc238e$export$e4cf37d7f6fb9e0a;
var $56f6928ee5dc238e$export$f99ded8fe4b79145;
var $56f6928ee5dc238e$export$599f31c3813fae4d;
'use strict';

var $bROtV = parcelRequire("bROtV");

var $5vhjz = parcelRequire("5vhjz");
const $56f6928ee5dc238e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$56f6928ee5dc238e$export$a143d493d941bafc = $56f6928ee5dc238e$var$Buffer;
$56f6928ee5dc238e$export$e4cf37d7f6fb9e0a = $56f6928ee5dc238e$var$SlowBuffer;
$56f6928ee5dc238e$export$f99ded8fe4b79145 = 50;
const $56f6928ee5dc238e$var$K_MAX_LENGTH = 0x7fffffff;
$56f6928ee5dc238e$export$599f31c3813fae4d = $56f6928ee5dc238e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $56f6928ee5dc238e$var$Buffer.TYPED_ARRAY_SUPPORT = $56f6928ee5dc238e$var$typedArraySupport();
if (!$56f6928ee5dc238e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $56f6928ee5dc238e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($56f6928ee5dc238e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$56f6928ee5dc238e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($56f6928ee5dc238e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$56f6928ee5dc238e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $56f6928ee5dc238e$var$createBuffer(length) {
    if (length > $56f6928ee5dc238e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $56f6928ee5dc238e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $56f6928ee5dc238e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $56f6928ee5dc238e$var$allocUnsafe(arg);
    }
    return $56f6928ee5dc238e$var$from(arg, encodingOrOffset, length);
}
$56f6928ee5dc238e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $56f6928ee5dc238e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $56f6928ee5dc238e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $56f6928ee5dc238e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($56f6928ee5dc238e$var$isInstance(value, ArrayBuffer) || value && $56f6928ee5dc238e$var$isInstance(value.buffer, ArrayBuffer)) return $56f6928ee5dc238e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($56f6928ee5dc238e$var$isInstance(value, SharedArrayBuffer) || value && $56f6928ee5dc238e$var$isInstance(value.buffer, SharedArrayBuffer))) return $56f6928ee5dc238e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $56f6928ee5dc238e$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $56f6928ee5dc238e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $56f6928ee5dc238e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $56f6928ee5dc238e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $56f6928ee5dc238e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($56f6928ee5dc238e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($56f6928ee5dc238e$var$Buffer, Uint8Array);
function $56f6928ee5dc238e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $56f6928ee5dc238e$var$alloc(size, fill, encoding) {
    $56f6928ee5dc238e$var$assertSize(size);
    if (size <= 0) return $56f6928ee5dc238e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $56f6928ee5dc238e$var$createBuffer(size).fill(fill, encoding) : $56f6928ee5dc238e$var$createBuffer(size).fill(fill);
    return $56f6928ee5dc238e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $56f6928ee5dc238e$var$Buffer.alloc = function(size, fill, encoding) {
    return $56f6928ee5dc238e$var$alloc(size, fill, encoding);
};
function $56f6928ee5dc238e$var$allocUnsafe(size) {
    $56f6928ee5dc238e$var$assertSize(size);
    return $56f6928ee5dc238e$var$createBuffer(size < 0 ? 0 : $56f6928ee5dc238e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $56f6928ee5dc238e$var$Buffer.allocUnsafe = function(size) {
    return $56f6928ee5dc238e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $56f6928ee5dc238e$var$Buffer.allocUnsafeSlow = function(size) {
    return $56f6928ee5dc238e$var$allocUnsafe(size);
};
function $56f6928ee5dc238e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$56f6928ee5dc238e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $56f6928ee5dc238e$var$byteLength(string, encoding) | 0;
    let buf = $56f6928ee5dc238e$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $56f6928ee5dc238e$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $56f6928ee5dc238e$var$checked(array.length) | 0;
    const buf = $56f6928ee5dc238e$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $56f6928ee5dc238e$var$fromArrayView(arrayView) {
    if ($56f6928ee5dc238e$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $56f6928ee5dc238e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $56f6928ee5dc238e$var$fromArrayLike(arrayView);
}
function $56f6928ee5dc238e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $56f6928ee5dc238e$var$Buffer.prototype);
    return buf;
}
function $56f6928ee5dc238e$var$fromObject(obj) {
    if ($56f6928ee5dc238e$var$Buffer.isBuffer(obj)) {
        const len = $56f6928ee5dc238e$var$checked(obj.length) | 0;
        const buf = $56f6928ee5dc238e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $56f6928ee5dc238e$var$numberIsNaN(obj.length)) return $56f6928ee5dc238e$var$createBuffer(0);
        return $56f6928ee5dc238e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $56f6928ee5dc238e$var$fromArrayLike(obj.data);
}
function $56f6928ee5dc238e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $56f6928ee5dc238e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $56f6928ee5dc238e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $56f6928ee5dc238e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $56f6928ee5dc238e$var$Buffer.alloc(+length);
}
$56f6928ee5dc238e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $56f6928ee5dc238e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$56f6928ee5dc238e$var$Buffer.compare = function compare(a, b) {
    if ($56f6928ee5dc238e$var$isInstance(a, Uint8Array)) a = $56f6928ee5dc238e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($56f6928ee5dc238e$var$isInstance(b, Uint8Array)) b = $56f6928ee5dc238e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$56f6928ee5dc238e$var$Buffer.isBuffer(a) || !$56f6928ee5dc238e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$56f6928ee5dc238e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$56f6928ee5dc238e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $56f6928ee5dc238e$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $56f6928ee5dc238e$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($56f6928ee5dc238e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$56f6928ee5dc238e$var$Buffer.isBuffer(buf)) buf = $56f6928ee5dc238e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$56f6928ee5dc238e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $56f6928ee5dc238e$var$byteLength(string, encoding) {
    if ($56f6928ee5dc238e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $56f6928ee5dc238e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $56f6928ee5dc238e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $56f6928ee5dc238e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $56f6928ee5dc238e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$56f6928ee5dc238e$var$Buffer.byteLength = $56f6928ee5dc238e$var$byteLength;
function $56f6928ee5dc238e$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $56f6928ee5dc238e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $56f6928ee5dc238e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $56f6928ee5dc238e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $56f6928ee5dc238e$var$latin1Slice(this, start, end);
        case 'base64':
            return $56f6928ee5dc238e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $56f6928ee5dc238e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$56f6928ee5dc238e$var$Buffer.prototype._isBuffer = true;
function $56f6928ee5dc238e$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$56f6928ee5dc238e$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$56f6928ee5dc238e$var$swap(this, i, i + 1);
    return this;
};
$56f6928ee5dc238e$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $56f6928ee5dc238e$var$swap(this, i, i + 3);
        $56f6928ee5dc238e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$56f6928ee5dc238e$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $56f6928ee5dc238e$var$swap(this, i, i + 7);
        $56f6928ee5dc238e$var$swap(this, i + 1, i + 6);
        $56f6928ee5dc238e$var$swap(this, i + 2, i + 5);
        $56f6928ee5dc238e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$56f6928ee5dc238e$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $56f6928ee5dc238e$var$utf8Slice(this, 0, length);
    return $56f6928ee5dc238e$var$slowToString.apply(this, arguments);
};
$56f6928ee5dc238e$var$Buffer.prototype.toLocaleString = $56f6928ee5dc238e$var$Buffer.prototype.toString;
$56f6928ee5dc238e$var$Buffer.prototype.equals = function equals(b) {
    if (!$56f6928ee5dc238e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $56f6928ee5dc238e$var$Buffer.compare(this, b) === 0;
};
$56f6928ee5dc238e$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $56f6928ee5dc238e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($56f6928ee5dc238e$var$customInspectSymbol) $56f6928ee5dc238e$var$Buffer.prototype[$56f6928ee5dc238e$var$customInspectSymbol] = $56f6928ee5dc238e$var$Buffer.prototype.inspect;
$56f6928ee5dc238e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($56f6928ee5dc238e$var$isInstance(target, Uint8Array)) target = $56f6928ee5dc238e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$56f6928ee5dc238e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $56f6928ee5dc238e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($56f6928ee5dc238e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $56f6928ee5dc238e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($56f6928ee5dc238e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $56f6928ee5dc238e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $56f6928ee5dc238e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $56f6928ee5dc238e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$56f6928ee5dc238e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$56f6928ee5dc238e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $56f6928ee5dc238e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$56f6928ee5dc238e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $56f6928ee5dc238e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $56f6928ee5dc238e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($56f6928ee5dc238e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $56f6928ee5dc238e$var$utf8Write(buf, string, offset, length) {
    return $56f6928ee5dc238e$var$blitBuffer($56f6928ee5dc238e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $56f6928ee5dc238e$var$asciiWrite(buf, string, offset, length) {
    return $56f6928ee5dc238e$var$blitBuffer($56f6928ee5dc238e$var$asciiToBytes(string), buf, offset, length);
}
function $56f6928ee5dc238e$var$base64Write(buf, string, offset, length) {
    return $56f6928ee5dc238e$var$blitBuffer($56f6928ee5dc238e$var$base64ToBytes(string), buf, offset, length);
}
function $56f6928ee5dc238e$var$ucs2Write(buf, string, offset, length) {
    return $56f6928ee5dc238e$var$blitBuffer($56f6928ee5dc238e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$56f6928ee5dc238e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $56f6928ee5dc238e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $56f6928ee5dc238e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $56f6928ee5dc238e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $56f6928ee5dc238e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $56f6928ee5dc238e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$56f6928ee5dc238e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $56f6928ee5dc238e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bROtV.fromByteArray(buf);
    else return $bROtV.fromByteArray(buf.slice(start, end));
}
function $56f6928ee5dc238e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $56f6928ee5dc238e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $56f6928ee5dc238e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $56f6928ee5dc238e$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $56f6928ee5dc238e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $56f6928ee5dc238e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $56f6928ee5dc238e$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $56f6928ee5dc238e$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $56f6928ee5dc238e$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $56f6928ee5dc238e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $56f6928ee5dc238e$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$56f6928ee5dc238e$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $56f6928ee5dc238e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $56f6928ee5dc238e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$56f6928ee5dc238e$var$Buffer.prototype.readUintLE = $56f6928ee5dc238e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$56f6928ee5dc238e$var$Buffer.prototype.readUintBE = $56f6928ee5dc238e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$56f6928ee5dc238e$var$Buffer.prototype.readUint8 = $56f6928ee5dc238e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$56f6928ee5dc238e$var$Buffer.prototype.readUint16LE = $56f6928ee5dc238e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$56f6928ee5dc238e$var$Buffer.prototype.readUint16BE = $56f6928ee5dc238e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$56f6928ee5dc238e$var$Buffer.prototype.readUint32LE = $56f6928ee5dc238e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$56f6928ee5dc238e$var$Buffer.prototype.readUint32BE = $56f6928ee5dc238e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$56f6928ee5dc238e$var$Buffer.prototype.readBigUInt64LE = $56f6928ee5dc238e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $56f6928ee5dc238e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $56f6928ee5dc238e$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$56f6928ee5dc238e$var$Buffer.prototype.readBigUInt64BE = $56f6928ee5dc238e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $56f6928ee5dc238e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $56f6928ee5dc238e$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$56f6928ee5dc238e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$56f6928ee5dc238e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$56f6928ee5dc238e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$56f6928ee5dc238e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$56f6928ee5dc238e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$56f6928ee5dc238e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$56f6928ee5dc238e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$56f6928ee5dc238e$var$Buffer.prototype.readBigInt64LE = $56f6928ee5dc238e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $56f6928ee5dc238e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $56f6928ee5dc238e$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$56f6928ee5dc238e$var$Buffer.prototype.readBigInt64BE = $56f6928ee5dc238e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $56f6928ee5dc238e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $56f6928ee5dc238e$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$56f6928ee5dc238e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 4, this.length);
    return $5vhjz.read(this, offset, true, 23, 4);
};
$56f6928ee5dc238e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 4, this.length);
    return $5vhjz.read(this, offset, false, 23, 4);
};
$56f6928ee5dc238e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 8, this.length);
    return $5vhjz.read(this, offset, true, 52, 8);
};
$56f6928ee5dc238e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkOffset(offset, 8, this.length);
    return $5vhjz.read(this, offset, false, 52, 8);
};
function $56f6928ee5dc238e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$56f6928ee5dc238e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$56f6928ee5dc238e$var$Buffer.prototype.writeUintLE = $56f6928ee5dc238e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $56f6928ee5dc238e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeUintBE = $56f6928ee5dc238e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $56f6928ee5dc238e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeUint8 = $56f6928ee5dc238e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeUint16LE = $56f6928ee5dc238e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeUint16BE = $56f6928ee5dc238e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeUint32LE = $56f6928ee5dc238e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeUint32BE = $56f6928ee5dc238e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $56f6928ee5dc238e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $56f6928ee5dc238e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $56f6928ee5dc238e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $56f6928ee5dc238e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$56f6928ee5dc238e$var$Buffer.prototype.writeBigUInt64LE = $56f6928ee5dc238e$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $56f6928ee5dc238e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$56f6928ee5dc238e$var$Buffer.prototype.writeBigUInt64BE = $56f6928ee5dc238e$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $56f6928ee5dc238e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$56f6928ee5dc238e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $56f6928ee5dc238e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $56f6928ee5dc238e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$56f6928ee5dc238e$var$Buffer.prototype.writeBigInt64LE = $56f6928ee5dc238e$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $56f6928ee5dc238e$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$56f6928ee5dc238e$var$Buffer.prototype.writeBigInt64BE = $56f6928ee5dc238e$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $56f6928ee5dc238e$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $56f6928ee5dc238e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $56f6928ee5dc238e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5vhjz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$56f6928ee5dc238e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $56f6928ee5dc238e$var$writeFloat(this, value, offset, true, noAssert);
};
$56f6928ee5dc238e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $56f6928ee5dc238e$var$writeFloat(this, value, offset, false, noAssert);
};
function $56f6928ee5dc238e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $56f6928ee5dc238e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5vhjz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$56f6928ee5dc238e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $56f6928ee5dc238e$var$writeDouble(this, value, offset, true, noAssert);
};
$56f6928ee5dc238e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $56f6928ee5dc238e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$56f6928ee5dc238e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$56f6928ee5dc238e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$56f6928ee5dc238e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$56f6928ee5dc238e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $56f6928ee5dc238e$var$Buffer.isBuffer(val) ? val : $56f6928ee5dc238e$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $56f6928ee5dc238e$var$errors = {};
function $56f6928ee5dc238e$var$E(sym, getMessage, Base) {
    $56f6928ee5dc238e$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$56f6928ee5dc238e$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$56f6928ee5dc238e$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$56f6928ee5dc238e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $56f6928ee5dc238e$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $56f6928ee5dc238e$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $56f6928ee5dc238e$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $56f6928ee5dc238e$var$checkBounds(buf, offset, byteLength) {
    $56f6928ee5dc238e$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $56f6928ee5dc238e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $56f6928ee5dc238e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $56f6928ee5dc238e$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $56f6928ee5dc238e$var$checkBounds(buf, offset, byteLength);
}
function $56f6928ee5dc238e$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $56f6928ee5dc238e$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $56f6928ee5dc238e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $56f6928ee5dc238e$var$validateNumber(value, type);
        throw new $56f6928ee5dc238e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $56f6928ee5dc238e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $56f6928ee5dc238e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $56f6928ee5dc238e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $56f6928ee5dc238e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($56f6928ee5dc238e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $56f6928ee5dc238e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $56f6928ee5dc238e$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $56f6928ee5dc238e$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $56f6928ee5dc238e$var$base64ToBytes(str) {
    return $bROtV.toByteArray($56f6928ee5dc238e$var$base64clean(str));
}
function $56f6928ee5dc238e$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $56f6928ee5dc238e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $56f6928ee5dc238e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $56f6928ee5dc238e$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $56f6928ee5dc238e$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $56f6928ee5dc238e$var$BufferBigIntNotDefined : fn;
}
function $56f6928ee5dc238e$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("bROtV", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a3bcd875615b3c5$export$d622b2ad8d90c771, (v) => $8a3bcd875615b3c5$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a3bcd875615b3c5$export$6100ba28696e12de, (v) => $8a3bcd875615b3c5$export$6100ba28696e12de = v);
var $8a3bcd875615b3c5$export$a48f0734ac7c2329;
var $8a3bcd875615b3c5$export$d622b2ad8d90c771;
var $8a3bcd875615b3c5$export$6100ba28696e12de;
'use strict';
$8a3bcd875615b3c5$export$a48f0734ac7c2329 = $8a3bcd875615b3c5$var$byteLength;
$8a3bcd875615b3c5$export$d622b2ad8d90c771 = $8a3bcd875615b3c5$var$toByteArray;
$8a3bcd875615b3c5$export$6100ba28696e12de = $8a3bcd875615b3c5$var$fromByteArray;
var $8a3bcd875615b3c5$var$lookup = [];
var $8a3bcd875615b3c5$var$revLookup = [];
var $8a3bcd875615b3c5$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a3bcd875615b3c5$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a3bcd875615b3c5$var$i = 0, $8a3bcd875615b3c5$var$len = $8a3bcd875615b3c5$var$code.length; $8a3bcd875615b3c5$var$i < $8a3bcd875615b3c5$var$len; ++$8a3bcd875615b3c5$var$i){
    $8a3bcd875615b3c5$var$lookup[$8a3bcd875615b3c5$var$i] = $8a3bcd875615b3c5$var$code[$8a3bcd875615b3c5$var$i];
    $8a3bcd875615b3c5$var$revLookup[$8a3bcd875615b3c5$var$code.charCodeAt($8a3bcd875615b3c5$var$i)] = $8a3bcd875615b3c5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a3bcd875615b3c5$var$revLookup['-'.charCodeAt(0)] = 62;
$8a3bcd875615b3c5$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a3bcd875615b3c5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a3bcd875615b3c5$var$byteLength(b64) {
    var lens = $8a3bcd875615b3c5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a3bcd875615b3c5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a3bcd875615b3c5$var$toByteArray(b64) {
    var tmp;
    var lens = $8a3bcd875615b3c5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a3bcd875615b3c5$var$Arr($8a3bcd875615b3c5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i)] << 18 | $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i)] << 2 | $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i)] << 10 | $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a3bcd875615b3c5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a3bcd875615b3c5$var$tripletToBase64(num) {
    return $8a3bcd875615b3c5$var$lookup[num >> 18 & 0x3F] + $8a3bcd875615b3c5$var$lookup[num >> 12 & 0x3F] + $8a3bcd875615b3c5$var$lookup[num >> 6 & 0x3F] + $8a3bcd875615b3c5$var$lookup[num & 0x3F];
}
function $8a3bcd875615b3c5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a3bcd875615b3c5$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a3bcd875615b3c5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a3bcd875615b3c5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a3bcd875615b3c5$var$lookup[tmp >> 2] + $8a3bcd875615b3c5$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a3bcd875615b3c5$var$lookup[tmp >> 10] + $8a3bcd875615b3c5$var$lookup[tmp >> 4 & 0x3F] + $8a3bcd875615b3c5$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("5vhjz", function(module, exports) {

$parcel$export(module.exports, "read", () => $401d47567520b176$export$aafa59e2e03f2942, (v) => $401d47567520b176$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $401d47567520b176$export$68d8715fc104d294, (v) => $401d47567520b176$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $401d47567520b176$export$aafa59e2e03f2942;
var $401d47567520b176$export$68d8715fc104d294;
$401d47567520b176$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$401d47567520b176$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("aDFzZ", function(module, exports) {

$parcel$export(module.exports, "io", () => $7bedccbe0d733f49$export$841407ceb083bd74);

var $dhqB5 = parcelRequire("dhqB5");

var $l4txc = parcelRequire("l4txc");

var $hiwZu = parcelRequire("hiwZu");

var $1ZzuU = parcelRequire("1ZzuU");
parcelRequire("hVjyf");
var $5U9Lj = parcelRequire("5U9Lj");
var $fudwc = parcelRequire("fudwc");
var $hT6IR = parcelRequire("hT6IR");
var $eGBVx = parcelRequire("eGBVx");
/**
 * Managers cache.
 */ const $7bedccbe0d733f49$var$cache = {};
function $7bedccbe0d733f49$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $dhqB5.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $7bedccbe0d733f49$var$cache[id] && path in $7bedccbe0d733f49$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $l4txc.Manager)(source, opts);
    else {
        if (!$7bedccbe0d733f49$var$cache[id]) $7bedccbe0d733f49$var$cache[id] = new (0, $l4txc.Manager)(source, opts);
        io = $7bedccbe0d733f49$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($7bedccbe0d733f49$export$841407ceb083bd74, {
    Manager: $l4txc.Manager,
    Socket: $hiwZu.Socket,
    io: $7bedccbe0d733f49$export$841407ceb083bd74,
    connect: $7bedccbe0d733f49$export$841407ceb083bd74
});

});
parcelRegister("dhqB5", function(module, exports) {

$parcel$export(module.exports, "url", () => $9ab17e834dd622d9$export$128fa18b7194ef);
parcelRequire("hVjyf");
var $4M7Yn = parcelRequire("4M7Yn");
function $9ab17e834dd622d9$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $4M7Yn.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("hVjyf", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("3UFv5")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("3sWLn")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("4M7Yn")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("5pKL0")).nextTick);

var $3UFv5 = parcelRequire("3UFv5");

var $1b7HP = parcelRequire("1b7HP");

var $5w4dD = parcelRequire("5w4dD");

var $3sWLn = parcelRequire("3sWLn");

var $4M7Yn = parcelRequire("4M7Yn");

var $5pKL0 = parcelRequire("5pKL0");

var $5U9Lj = parcelRequire("5U9Lj");

var $fudwc = parcelRequire("fudwc");

var $fudwc = parcelRequire("fudwc");

var $hT6IR = parcelRequire("hT6IR");

var $hT6IR = parcelRequire("hT6IR");

var $eGBVx = parcelRequire("eGBVx");
const $d0c6ed08330a9faa$export$a51d6b395ff4c65a = (0, $3UFv5.Socket).protocol;

});
parcelRegister("3UFv5", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $2d96cb3285e39ad4$export$4798917dbf149b79);

var $5w4dD = parcelRequire("5w4dD");

var $3sWLn = parcelRequire("3sWLn");

var $h3UEI = parcelRequire("h3UEI");

var $4M7Yn = parcelRequire("4M7Yn");

var $gRYSW = parcelRequire("gRYSW");

var $YyfvN = parcelRequire("YyfvN");

var $5pKL0 = parcelRequire("5pKL0");
const $2d96cb3285e39ad4$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $2d96cb3285e39ad4$var$OFFLINE_EVENT_LISTENERS = [];
if ($2d96cb3285e39ad4$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $2d96cb3285e39ad4$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $2d96cb3285e39ad4$export$4798917dbf149b79 extends (0, $gRYSW.Emitter) {
    constructor(uri, opts = {}){
        var _a, _b;
        super();
        this.binaryType = (0, $5pKL0.defaultBinaryType);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._upgrades = [];
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $4M7Yn.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $4M7Yn.parse)(opts.host).host;
        (0, $3sWLn.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        if (opts.transportImplementations && opts.transports) throw new Error("specifying both 'transportImplementations' and 'transports' options is not supported");
        if (opts.transportImplementations || ((_a = opts.transports) === null || _a === void 0 ? void 0 : _a.length) && typeof opts.transports[0] === "function") {
            // 'transports' option as an array of transport implementations is kept for backward compatibility
            this.transports = [];
            this._transportsByName = Object.create(null);
            ((_b = opts.transportImplementations) !== null && _b !== void 0 ? _b : opts.transports).forEach((t)=>{
                const transportName = t.prototype.name;
                this.transports.push(transportName);
                this._transportsByName[transportName] = t;
            });
        } else {
            this.transports = opts.transports ? [
                ...opts.transports
            ] : [
                "polling",
                "websocket",
                "webtransport"
            ];
            this._transportsByName = (0, $5w4dD.transports);
        }
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $h3UEI.decode)(this.opts.query);
        if ($2d96cb3285e39ad4$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $2d96cb3285e39ad4$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $5pKL0.createCookieJar)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $YyfvN.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $2d96cb3285e39ad4$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $2d96cb3285e39ad4$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $2d96cb3285e39ad4$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $2d96cb3285e39ad4$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._upgrades = this._filterUpgrades(data.upgrades);
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $3sWLn.byteLength)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $5pKL0.nextTick)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type - packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $2d96cb3285e39ad4$export$4798917dbf149b79.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($2d96cb3285e39ad4$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $2d96cb3285e39ad4$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $2d96cb3285e39ad4$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
$2d96cb3285e39ad4$export$4798917dbf149b79.protocol = (0, $YyfvN.protocol);

});
parcelRegister("5w4dD", function(module, exports) {

$parcel$export(module.exports, "transports", () => $404336b7c5212e2c$export$46dec00755c1153b);

var $fudwc = parcelRequire("fudwc");

var $hT6IR = parcelRequire("hT6IR");

var $eGBVx = parcelRequire("eGBVx");
const $404336b7c5212e2c$export$46dec00755c1153b = {
    websocket: (0, $hT6IR.WS),
    webtransport: (0, $eGBVx.WT),
    polling: (0, $fudwc.XHR)
};

});
parcelRegister("fudwc", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $b46424d80fe8abc6$export$a2d42eb087c10497);

var $lYy9S = parcelRequire("lYy9S");

var $gRYSW = parcelRequire("gRYSW");

var $3sWLn = parcelRequire("3sWLn");

var $5pKL0 = parcelRequire("5pKL0");

var $e9C6x = parcelRequire("e9C6x");
function $b46424d80fe8abc6$var$empty() {}
class $b46424d80fe8abc6$export$c959f2344155d309 extends (0, $lYy9S.Polling) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data - data to send.
     * @param {Function} fn - called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $b46424d80fe8abc6$export$7fa6c5b6f8193917 extends (0, $gRYSW.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $3sWLn.installTimerFunctions)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $3sWLn.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $b46424d80fe8abc6$export$7fa6c5b6f8193917.requestsCount++;
            $b46424d80fe8abc6$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $b46424d80fe8abc6$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $b46424d80fe8abc6$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$b46424d80fe8abc6$export$7fa6c5b6f8193917.requestsCount = 0;
$b46424d80fe8abc6$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $b46424d80fe8abc6$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $5pKL0.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $b46424d80fe8abc6$var$unloadHandler, false);
    }
}
function $b46424d80fe8abc6$var$unloadHandler() {
    for(let i in $b46424d80fe8abc6$export$7fa6c5b6f8193917.requests)if ($b46424d80fe8abc6$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $b46424d80fe8abc6$export$7fa6c5b6f8193917.requests[i].abort();
}
const $b46424d80fe8abc6$var$hasXHR2 = function() {
    const xhr = $b46424d80fe8abc6$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $b46424d80fe8abc6$export$a2d42eb087c10497 extends $b46424d80fe8abc6$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $b46424d80fe8abc6$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $b46424d80fe8abc6$export$7fa6c5b6f8193917($b46424d80fe8abc6$var$newRequest, this.uri(), opts);
    }
}
function $b46424d80fe8abc6$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $e9C6x.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $5pKL0.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("lYy9S", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $fff9b2b5e4850539$export$265ee5eefd4c309b);

var $1b7HP = parcelRequire("1b7HP");

var $3sWLn = parcelRequire("3sWLn");

var $YyfvN = parcelRequire("YyfvN");
class $fff9b2b5e4850539$export$265ee5eefd4c309b extends (0, $1b7HP.Transport) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $YyfvN.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $YyfvN.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $3sWLn.randomString)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}

});
parcelRegister("1b7HP", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $0dbccbc149e137a6$export$86495b081fef8e52);
parcelRequire("YyfvN");
var $e7BYe = parcelRequire("e7BYe");

var $gRYSW = parcelRequire("gRYSW");

var $3sWLn = parcelRequire("3sWLn");

var $h3UEI = parcelRequire("h3UEI");
class $0dbccbc149e137a6$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $0dbccbc149e137a6$export$86495b081fef8e52 extends (0, $gRYSW.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $3sWLn.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $0dbccbc149e137a6$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $e7BYe.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $h3UEI.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("YyfvN", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0b602be31493b266$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0b602be31493b266$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $0b602be31493b266$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $0b602be31493b266$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $0b602be31493b266$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("jKMQD")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("e7BYe")).decodePacket);

var $jKMQD = parcelRequire("jKMQD");

var $e7BYe = parcelRequire("e7BYe");

var $bD5cm = parcelRequire("bD5cm");
const $0b602be31493b266$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0b602be31493b266$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $jKMQD.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0b602be31493b266$var$SEPARATOR));
        });
    });
};
const $0b602be31493b266$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0b602be31493b266$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $e7BYe.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0b602be31493b266$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $jKMQD.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0b602be31493b266$var$TEXT_DECODER;
function $0b602be31493b266$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0b602be31493b266$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0b602be31493b266$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0b602be31493b266$var$TEXT_DECODER) $0b602be31493b266$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($0b602be31493b266$var$totalLength(chunks) < 1) break;
                    const header = $0b602be31493b266$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0b602be31493b266$var$totalLength(chunks) < 2) break;
                    const headerArray = $0b602be31493b266$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0b602be31493b266$var$totalLength(chunks) < 8) break;
                    const headerArray = $0b602be31493b266$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $bD5cm.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($0b602be31493b266$var$totalLength(chunks) < expectedLength) break;
                    const data = $0b602be31493b266$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $e7BYe.decodePacket)(isBinary ? data : $0b602be31493b266$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $bD5cm.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $0b602be31493b266$export$a51d6b395ff4c65a = 4;

});
parcelRegister("jKMQD", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $e618345e0bb68689$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $e618345e0bb68689$export$ec0c9b9013ee0ef5);

var $bD5cm = parcelRequire("bD5cm");
const $e618345e0bb68689$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $e618345e0bb68689$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $e618345e0bb68689$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $e618345e0bb68689$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($e618345e0bb68689$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $e618345e0bb68689$var$encodeBlobAsBase64(data, callback);
    } else if ($e618345e0bb68689$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $e618345e0bb68689$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $e618345e0bb68689$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $bD5cm.PACKET_TYPES)[type] + (data || ""));
};
const $e618345e0bb68689$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $e618345e0bb68689$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $e618345e0bb68689$var$TEXT_ENCODER;
function $e618345e0bb68689$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($e618345e0bb68689$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($e618345e0bb68689$var$toArray).then(callback);
    else if ($e618345e0bb68689$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $e618345e0bb68689$var$isView(packet.data))) return callback($e618345e0bb68689$var$toArray(packet.data));
    $e618345e0bb68689$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$e618345e0bb68689$var$TEXT_ENCODER) $e618345e0bb68689$var$TEXT_ENCODER = new TextEncoder();
        callback($e618345e0bb68689$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("bD5cm", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $87775e7dd6fd09a7$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $87775e7dd6fd09a7$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $87775e7dd6fd09a7$export$c718b5840781f8a7);
const $87775e7dd6fd09a7$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$87775e7dd6fd09a7$export$c169aefb7330cccb["open"] = "0";
$87775e7dd6fd09a7$export$c169aefb7330cccb["close"] = "1";
$87775e7dd6fd09a7$export$c169aefb7330cccb["ping"] = "2";
$87775e7dd6fd09a7$export$c169aefb7330cccb["pong"] = "3";
$87775e7dd6fd09a7$export$c169aefb7330cccb["message"] = "4";
$87775e7dd6fd09a7$export$c169aefb7330cccb["upgrade"] = "5";
$87775e7dd6fd09a7$export$c169aefb7330cccb["noop"] = "6";
const $87775e7dd6fd09a7$export$47791e8004edd485 = Object.create(null);
Object.keys($87775e7dd6fd09a7$export$c169aefb7330cccb).forEach((key)=>{
    $87775e7dd6fd09a7$export$47791e8004edd485[$87775e7dd6fd09a7$export$c169aefb7330cccb[key]] = key;
});
const $87775e7dd6fd09a7$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("e7BYe", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $a47f2c493f032ffe$export$4647901878f33f31);

var $bD5cm = parcelRequire("bD5cm");

var $euM4h = parcelRequire("euM4h");
const $a47f2c493f032ffe$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a47f2c493f032ffe$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a47f2c493f032ffe$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a47f2c493f032ffe$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $bD5cm.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $bD5cm.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $bD5cm.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $bD5cm.PACKET_TYPES_REVERSE)[type]
    };
};
const $a47f2c493f032ffe$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a47f2c493f032ffe$var$withNativeArrayBuffer) {
        const decoded = (0, $euM4h.decode)(data);
        return $a47f2c493f032ffe$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a47f2c493f032ffe$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("euM4h", function(module, exports) {

$parcel$export(module.exports, "decode", () => $02b92e0dd0022aea$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $02b92e0dd0022aea$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $02b92e0dd0022aea$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $02b92e0dd0022aea$var$chars.length; i++)$02b92e0dd0022aea$var$lookup[$02b92e0dd0022aea$var$chars.charCodeAt(i)] = i;
const $02b92e0dd0022aea$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $02b92e0dd0022aea$var$chars[bytes[i] >> 2];
        base64 += $02b92e0dd0022aea$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $02b92e0dd0022aea$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $02b92e0dd0022aea$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $02b92e0dd0022aea$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $02b92e0dd0022aea$var$lookup[base64.charCodeAt(i)];
        encoded2 = $02b92e0dd0022aea$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $02b92e0dd0022aea$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $02b92e0dd0022aea$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("gRYSW", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $c480d31d41c52bc1$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $c480d31d41c52bc1$export$4293555f241ae35a(obj) {
    if (obj) return $c480d31d41c52bc1$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $c480d31d41c52bc1$var$mixin(obj) {
    for(var key in $c480d31d41c52bc1$export$4293555f241ae35a.prototype)obj[key] = $c480d31d41c52bc1$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $c480d31d41c52bc1$export$4293555f241ae35a.prototype.on = $c480d31d41c52bc1$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $c480d31d41c52bc1$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $c480d31d41c52bc1$export$4293555f241ae35a.prototype.off = $c480d31d41c52bc1$export$4293555f241ae35a.prototype.removeListener = $c480d31d41c52bc1$export$4293555f241ae35a.prototype.removeAllListeners = $c480d31d41c52bc1$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $c480d31d41c52bc1$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$c480d31d41c52bc1$export$4293555f241ae35a.prototype.emitReserved = $c480d31d41c52bc1$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $c480d31d41c52bc1$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $c480d31d41c52bc1$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("3sWLn", function(module, exports) {

$parcel$export(module.exports, "pick", () => $286191c0cd2a7dd8$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $286191c0cd2a7dd8$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $286191c0cd2a7dd8$export$a48f0734ac7c2329);
$parcel$export(module.exports, "randomString", () => $286191c0cd2a7dd8$export$7fa8378418b4411e);

var $5pKL0 = parcelRequire("5pKL0");
function $286191c0cd2a7dd8$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $286191c0cd2a7dd8$var$NATIVE_SET_TIMEOUT = (0, $5pKL0.globalThisShim).setTimeout;
const $286191c0cd2a7dd8$var$NATIVE_CLEAR_TIMEOUT = (0, $5pKL0.globalThisShim).clearTimeout;
function $286191c0cd2a7dd8$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $286191c0cd2a7dd8$var$NATIVE_SET_TIMEOUT.bind((0, $5pKL0.globalThisShim));
        obj.clearTimeoutFn = $286191c0cd2a7dd8$var$NATIVE_CLEAR_TIMEOUT.bind((0, $5pKL0.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $5pKL0.globalThisShim).setTimeout.bind((0, $5pKL0.globalThisShim));
        obj.clearTimeoutFn = (0, $5pKL0.globalThisShim).clearTimeout.bind((0, $5pKL0.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $286191c0cd2a7dd8$var$BASE64_OVERHEAD = 1.33;
function $286191c0cd2a7dd8$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $286191c0cd2a7dd8$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $286191c0cd2a7dd8$var$BASE64_OVERHEAD);
}
function $286191c0cd2a7dd8$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $286191c0cd2a7dd8$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

});
parcelRegister("5pKL0", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $3f138e87b43cf7e5$export$bdd553fddd433dcb);
$parcel$export(module.exports, "globalThisShim", () => $3f138e87b43cf7e5$export$394f9358f6231289);
$parcel$export(module.exports, "defaultBinaryType", () => $3f138e87b43cf7e5$export$790dcbc41e2d75d5);
$parcel$export(module.exports, "createCookieJar", () => $3f138e87b43cf7e5$export$19413efcf2fac759);
const $3f138e87b43cf7e5$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $3f138e87b43cf7e5$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $3f138e87b43cf7e5$export$790dcbc41e2d75d5 = "arraybuffer";
function $3f138e87b43cf7e5$export$19413efcf2fac759() {}

});


parcelRegister("h3UEI", function(module, exports) {

$parcel$export(module.exports, "encode", () => $c6beaa20560ae656$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $c6beaa20560ae656$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $c6beaa20560ae656$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $c6beaa20560ae656$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});



parcelRegister("e9C6x", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $a4df76b4bf3f1e58$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $a4df76b4bf3f1e58$var$value = false;
try {
    $a4df76b4bf3f1e58$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $a4df76b4bf3f1e58$export$5235bbd4a1ef06e = $a4df76b4bf3f1e58$var$value;

});


parcelRegister("hT6IR", function(module, exports) {

$parcel$export(module.exports, "WS", () => $d05cc9ae37cfd214$export$911baa0677ac404c);

var $1b7HP = parcelRequire("1b7HP");

var $3sWLn = parcelRequire("3sWLn");
parcelRequire("YyfvN");
var $jKMQD = parcelRequire("jKMQD");

var $5pKL0 = parcelRequire("5pKL0");
// detect ReactNative environment
const $d05cc9ae37cfd214$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $d05cc9ae37cfd214$export$570bf71d2367e261 extends (0, $1b7HP.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $d05cc9ae37cfd214$var$isReactNative ? {} : (0, $3sWLn.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $jKMQD.encodePacket)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $5pKL0.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $3sWLn.randomString)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $d05cc9ae37cfd214$var$WebSocketCtor = (0, $5pKL0.globalThisShim).WebSocket || (0, $5pKL0.globalThisShim).MozWebSocket;
class $d05cc9ae37cfd214$export$911baa0677ac404c extends $d05cc9ae37cfd214$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$d05cc9ae37cfd214$var$isReactNative ? protocols ? new $d05cc9ae37cfd214$var$WebSocketCtor(uri, protocols) : new $d05cc9ae37cfd214$var$WebSocketCtor(uri) : new $d05cc9ae37cfd214$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

});

parcelRegister("eGBVx", function(module, exports) {

$parcel$export(module.exports, "WT", () => $ab1268756335753c$export$961c930859384407);

var $1b7HP = parcelRequire("1b7HP");

var $5pKL0 = parcelRequire("5pKL0");

var $YyfvN = parcelRequire("YyfvN");
class $ab1268756335753c$export$961c930859384407 extends (0, $1b7HP.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $YyfvN.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $YyfvN.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $5pKL0.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("4M7Yn", function(module, exports) {

$parcel$export(module.exports, "parse", () => $37a1d45b51bfb02a$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $37a1d45b51bfb02a$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $37a1d45b51bfb02a$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $37a1d45b51bfb02a$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $37a1d45b51bfb02a$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$37a1d45b51bfb02a$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $37a1d45b51bfb02a$var$pathNames(uri, uri['path']);
    uri.queryKey = $37a1d45b51bfb02a$var$queryKey(uri, uri['query']);
    return uri;
}
function $37a1d45b51bfb02a$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $37a1d45b51bfb02a$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});


parcelRegister("5U9Lj", function(module, exports) {

var $lYy9S = parcelRequire("lYy9S");
class $44c9c14638936b58$export$1e7deca84b429035 extends (0, $lYy9S.Polling) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}

});



parcelRegister("l4txc", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $f570e1a3ff6b7356$export$d0d38e7dec7a1a61);
parcelRequire("hVjyf");
var $3sWLn = parcelRequire("3sWLn");
var $5pKL0 = parcelRequire("5pKL0");
var $3UFv5 = parcelRequire("3UFv5");

var $hiwZu = parcelRequire("hiwZu");

var $1ZzuU = parcelRequire("1ZzuU");

var $jOTOU = parcelRequire("jOTOU");

var $eKOKo = parcelRequire("eKOKo");

var $gRYSW = parcelRequire("gRYSW");
class $f570e1a3ff6b7356$export$d0d38e7dec7a1a61 extends (0, $gRYSW.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $3sWLn.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $eKOKo.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $1ZzuU;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $3UFv5.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $jOTOU.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $jOTOU.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $jOTOU.on)(socket, "ping", this.onping.bind(this)), (0, $jOTOU.on)(socket, "data", this.ondata.bind(this)), (0, $jOTOU.on)(socket, "error", this.onerror.bind(this)), (0, $jOTOU.on)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $jOTOU.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $5pKL0.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $hiwZu.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("hiwZu", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $033ff689ee98e07f$export$4798917dbf149b79);

var $1ZzuU = parcelRequire("1ZzuU");

var $jOTOU = parcelRequire("jOTOU");

var $gRYSW = parcelRequire("gRYSW");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $033ff689ee98e07f$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $033ff689ee98e07f$export$4798917dbf149b79 extends (0, $gRYSW.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $jOTOU.on)(io, "open", this.onopen.bind(this)),
            (0, $jOTOU.on)(io, "packet", this.onpacket.bind(this)),
            (0, $jOTOU.on)(io, "error", this.onerror.bind(this)),
            (0, $jOTOU.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($033ff689ee98e07f$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $1ZzuU.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $1ZzuU.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $1ZzuU.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $1ZzuU.PacketType).EVENT:
            case (0, $1ZzuU.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $1ZzuU.PacketType).ACK:
            case (0, $1ZzuU.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $1ZzuU.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $1ZzuU.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $1ZzuU.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $1ZzuU.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("1ZzuU", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1737060263092494$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1737060263092494$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1737060263092494$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1737060263092494$export$f9de6ca0bc043724);
$parcel$export(module.exports, "isPacketValid", () => $1737060263092494$export$1a38ed17dcb5458e);

var $gRYSW = parcelRequire("gRYSW");

var $gRdKG = parcelRequire("gRdKG");

var $cm1GB = parcelRequire("cm1GB");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1737060263092494$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1737060263092494$export$a51d6b395ff4c65a = 5;
var $1737060263092494$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1737060263092494$export$84d4095e16c6fc19 || ($1737060263092494$export$84d4095e16c6fc19 = {}));
class $1737060263092494$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1737060263092494$export$84d4095e16c6fc19.EVENT || obj.type === $1737060263092494$export$84d4095e16c6fc19.ACK) {
            if ((0, $cm1GB.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1737060263092494$export$84d4095e16c6fc19.EVENT ? $1737060263092494$export$84d4095e16c6fc19.BINARY_EVENT : $1737060263092494$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1737060263092494$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1737060263092494$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $gRdKG.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $1737060263092494$export$f9de6ca0bc043724 extends (0, $gRYSW.Emitter) {
    /**
     * Decoder constructor
     */ constructor(opts){
        super();
        this.opts = Object.assign({
            reviver: undefined,
            maxAttachments: 10
        }, typeof opts === "function" ? {
            reviver: opts
        } : opts);
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1737060263092494$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1737060263092494$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1737060263092494$export$84d4095e16c6fc19.EVENT : $1737060263092494$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1737060263092494$var$BinaryReconstructor(packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $cm1GB.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1737060263092494$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1737060263092494$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1737060263092494$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            const n = Number(buf);
            if (!$1737060263092494$var$isInteger(n) || n < 1) throw new Error("Illegal attachments");
            else if (n > this.opts.maxAttachments) throw new Error("too many attachments");
            p.attachments = n;
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1737060263092494$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.opts.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1737060263092494$export$84d4095e16c6fc19.CONNECT:
                return $1737060263092494$var$isObject(payload);
            case $1737060263092494$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1737060263092494$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1737060263092494$var$isObject(payload);
            case $1737060263092494$export$84d4095e16c6fc19.EVENT:
            case $1737060263092494$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1737060263092494$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1737060263092494$export$84d4095e16c6fc19.ACK:
            case $1737060263092494$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1737060263092494$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $gRdKG.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $1737060263092494$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $1737060263092494$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $1737060263092494$var$isAckIdValid(id) {
    return id === undefined || $1737060263092494$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1737060263092494$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $1737060263092494$var$isDataValid(type, payload) {
    switch(type){
        case $1737060263092494$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $1737060263092494$var$isObject(payload);
        case $1737060263092494$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $1737060263092494$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1737060263092494$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $1737060263092494$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $1737060263092494$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $1737060263092494$var$isObject(payload);
        default:
            return false;
    }
}
function $1737060263092494$export$1a38ed17dcb5458e(packet) {
    return $1737060263092494$var$isNamespaceValid(packet.nsp) && $1737060263092494$var$isAckIdValid(packet.id) && $1737060263092494$var$isDataValid(packet.type, packet.data);
}

});
parcelRegister("gRdKG", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $c45c436925786a81$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $c45c436925786a81$export$a00da3b1ec037a04);

var $cm1GB = parcelRequire("cm1GB");
function $c45c436925786a81$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $c45c436925786a81$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $c45c436925786a81$var$_deconstructPacket(data, buffers, toJSON) {
    if (!data) return data;
    if ((0, $cm1GB.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $c45c436925786a81$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        if (data.toJSON && typeof data.toJSON === "function" && !toJSON) return $c45c436925786a81$var$_deconstructPacket(data.toJSON(), buffers, true);
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $c45c436925786a81$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $c45c436925786a81$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $c45c436925786a81$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $c45c436925786a81$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $c45c436925786a81$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $c45c436925786a81$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("cm1GB", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $8fe8d8f51fff9c21$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $8fe8d8f51fff9c21$export$5234c529abdb5610);
const $8fe8d8f51fff9c21$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $8fe8d8f51fff9c21$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $8fe8d8f51fff9c21$var$toString = Object.prototype.toString;
const $8fe8d8f51fff9c21$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $8fe8d8f51fff9c21$var$toString.call(Blob) === "[object BlobConstructor]";
const $8fe8d8f51fff9c21$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $8fe8d8f51fff9c21$var$toString.call(File) === "[object FileConstructor]";
function $8fe8d8f51fff9c21$export$37488ff1135b1696(obj) {
    return $8fe8d8f51fff9c21$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $8fe8d8f51fff9c21$var$isView(obj)) || $8fe8d8f51fff9c21$var$withNativeBlob && obj instanceof Blob || $8fe8d8f51fff9c21$var$withNativeFile && obj instanceof File;
}
function $8fe8d8f51fff9c21$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($8fe8d8f51fff9c21$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($8fe8d8f51fff9c21$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $8fe8d8f51fff9c21$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $8fe8d8f51fff9c21$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("jOTOU", function(module, exports) {

$parcel$export(module.exports, "on", () => $e6ddfc90a260ed5e$export$af631764ddc44097);
function $e6ddfc90a260ed5e$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("eKOKo", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $abdcb9ede57e0ce9$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $abdcb9ede57e0ce9$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $abdcb9ede57e0ce9$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $abdcb9ede57e0ce9$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $abdcb9ede57e0ce9$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $abdcb9ede57e0ce9$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $abdcb9ede57e0ce9$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});



parcelRegister("36Jqh", function(module, exports) {

$parcel$export(module.exports, "PERMISSION_MAP", () => $24352aa7bd597d47$export$ab0bc397c9aa3b6c);
$parcel$export(module.exports, "ROLE_PERMISSIONS", () => $24352aa7bd597d47$export$56b2c64857920c31);
$parcel$export(module.exports, "TIER_FEATURES", () => $24352aa7bd597d47$export$25676848916b971e);
$parcel$export(module.exports, "PROJECT_ROLE_PERMISSIONS", () => $24352aa7bd597d47$export$ab8a6d70986e26e6);
const $24352aa7bd597d47$export$ab0bc397c9aa3b6c = {
    edit: {
        permissions: [
            "editMode",
            "showCode"
        ],
        features: [
            "editMode"
        ]
    },
    view: {
        permissions: [
            "showContent",
            "platformSettings"
        ],
        features: [
            "canvasPages"
        ]
    },
    design: {
        permissions: [
            "editMode",
            "showCode"
        ],
        features: [
            "accessToSymbolsLibrary",
            "marketplace"
        ]
    },
    manage: {
        permissions: [
            "projectSettings",
            "iam"
        ],
        features: [
            "workspaceAdministration",
            "teamRolesAndPermissions"
        ]
    },
    configure: {
        permissions: [
            "projectSettings",
            "branchProtection"
        ],
        features: [
            "customBackendIntegration",
            "integrationsSDK"
        ]
    },
    invite: {
        permissions: [
            "inviteMembers"
        ],
        features: [
            "inviteMembersIAM"
        ]
    },
    branch: {
        permissions: [
            "versions",
            "branchProtection"
        ],
        features: [
            "branching",
            "versionHistory"
        ]
    },
    merge: {
        permissions: [
            "versions",
            "branchProtection"
        ],
        features: [
            "branching"
        ]
    },
    export: {
        permissions: [
            "showCode"
        ],
        features: [
            "downloadAsSVG",
            "downloadAsReact",
            "exportToFigma"
        ]
    },
    import: {
        permissions: [
            "editMode"
        ],
        features: [
            "importFromFigma"
        ]
    },
    aiCopilot: {
        permissions: [
            "editMode"
        ],
        features: [
            "aiCopilot:3",
            "aiCopilot:5",
            "aiCopilot:15"
        ]
    },
    aiChatbot: {
        permissions: [
            "showContent"
        ],
        features: [
            "aiChatbot:3",
            "aiChatbot:5",
            "aiChatbot:15"
        ]
    },
    analytics: {
        permissions: [
            "projectSettings"
        ],
        features: [
            "analytics",
            "crashalytics"
        ]
    },
    payment: {
        permissions: [
            "projectSettings",
            "iam"
        ],
        features: [
            "stripeConnect"
        ]
    },
    deployment: {
        permissions: [
            "projectSettings"
        ],
        features: [
            "dompilerCloud",
            "customDomain"
        ]
    },
    docs: {
        permissions: [
            "showContent"
        ],
        features: [
            "autoDesignDocs"
        ]
    },
    share: {
        permissions: [
            "inviteMembers"
        ],
        features: [
            "sharing",
            "sharedLibraries"
        ]
    }
}, $24352aa7bd597d47$export$56b2c64857920c31 = {
    guest: [
        "viewPublicProjects"
    ],
    user: [
        "viewPublicProjects"
    ],
    admin: [
        "viewPublicProjects",
        "governance"
    ],
    superAdmin: [
        "viewPublicProjects",
        "governance",
        "managePlatform"
    ]
}, $24352aa7bd597d47$export$25676848916b971e = {
    ready: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "canvasPages",
        "versionHistory",
        "downloadAsSVG",
        "branching",
        "noWatermark"
    ],
    free: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "marketplace",
        "downloadAsReact",
        "vscodeSync",
        "chromeExtension",
        "canvasPages",
        "versionHistory",
        "importFromFigma",
        "privateProjects",
        "sharing",
        "aiCopilot:3",
        "aiChatbot:3"
    ],
    pro1: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "marketplace",
        "downloadAsReact",
        "vscodeSync",
        "chromeExtension",
        "canvasPages",
        "versionHistory",
        "sharedLibraries",
        "downloadAsSVG",
        "customDomain",
        "branching",
        "plugins",
        "autoDesignDocs",
        "importFromFigma",
        "exportToFigma",
        "customBackendIntegration",
        "privateProjects",
        "sharing",
        "inviteMembersIAM",
        "aiCopilot:5",
        "aiChatbot:5"
    ],
    pro2: [
        "editMode",
        "freeDomain",
        "accessToSymbolsLibrary",
        "marketplace",
        "downloadAsReact",
        "vscodeSync",
        "chromeExtension",
        "canvasPages",
        "versionHistory",
        "sharedLibraries",
        "downloadAsSVG",
        "customDomain",
        "branching",
        "plugins",
        "autoDesignDocs",
        "noWatermark",
        "importFromFigma",
        "exportToFigma",
        "customBackendIntegration",
        "integrationsSDK",
        "backendFunctions",
        "privateProjects",
        "sharing",
        "inviteMembersIAM",
        "workspaceAdministration",
        "teamRolesAndPermissions",
        "aiCopilot:15",
        "aiChatbot:15"
    ],
    enterprise: [
        "analytics",
        "crashalytics",
        "projectManagementTools",
        "testingTools",
        "stripeConnect",
        "dompilerCloud"
    ]
}, $24352aa7bd597d47$export$ab8a6d70986e26e6 = {
    unauthenticated: [
        "platformSettings",
        "showContent"
    ],
    guest: [
        "platformSettings",
        "showContent"
    ],
    editor: [
        "platformSettings",
        "showContent",
        "showCode",
        "editMode",
        "versions"
    ],
    admin: [
        "platformSettings",
        "showContent",
        "showCode",
        "editMode",
        "versions",
        "inviteMembers",
        "branchProtection",
        "projectSettings"
    ],
    owner: [
        "platformSettings",
        "showContent",
        "showCode",
        "editMode",
        "versions",
        "inviteMembers",
        "branchProtection",
        "projectSettings",
        "copyPasteAllowanceSetting",
        "iam"
    ]
};

});

parcelRegister("gYAeI", function(module, exports) {

$parcel$export(module.exports, "ambiguousKeyError", () => $c5be5bbc11e2b8cd$export$7c21a7384fd2526a);
function $c5be5bbc11e2b8cd$export$7c21a7384fd2526a(a, n) {
    let t = null, o = a;
    for(let e = 0; o && e < 4; e++){
        if (o && typeof o == "object" && !(o instanceof Error) && o.error === "ambiguous_key") {
            t = o;
            break;
        }
        if (o instanceof Error && o.code === "ambiguous_key") return o;
        o = o.cause;
    }
    if (!t) return null;
    const s = n && typeof n == "object" ? n.key : n, i = (Array.isArray(t.candidates) ? t.candidates : []).filter((e)=>e && e.owner && e.key).map((e)=>({
            owner: e.owner,
            key: e.key
        })), u = i.map((e)=>`${e.owner}/${e.key}`).join(", "), r = new Error(`Project key '${s}' names more than one project${u ? `: ${u}` : ""} \u2014 pass { owner, key }`, {
        cause: a
    });
    return r.code = "ambiguous_key", r.status = 409, r.key = s, r.candidates = i, r;
}

});


parcelRegister("kbO4k", function(module, exports) {

$parcel$export(module.exports, "AiChatService", () => $eb2bac58c9deabfb$export$3d55f7e3752192f4);

var $em51x = parcelRequire("em51x");
class $eb2bac58c9deabfb$export$3d55f7e3752192f4 extends (0, $em51x.BaseService) {
    _aiChatScope(e) {
        return this._resolveScope(e);
    }
    _scopeQs(e, a) {
        const t = this._aiChatScope(a);
        t.orgId !== void 0 && e.set("orgId", String(t.orgId)), t.workspaceId !== void 0 && e.set("workspaceId", String(t.workspaceId));
        const s = e.toString();
        return s ? `?${s}` : "";
    }
    _scopePayload(e) {
        const a = this._aiChatScope(e), t = {
            ...e
        };
        return a.orgId !== void 0 && (t.orgId = a.orgId), a.workspaceId !== void 0 && (t.workspaceId = a.workspaceId), t;
    }
    threads = {
        list: ({ includeArchived: e = !1, orgId: a, workspaceId: t } = {})=>{
            const s = new URLSearchParams;
            e && s.set("includeArchived", "true");
            const o = this._scopeQs(s, {
                orgId: a,
                workspaceId: t
            });
            return this._call("aiChat.threads.list", `/ai-chat/threads${o}`);
        },
        get: (e, { orgId: a, workspaceId: t } = {})=>{
            const s = this._scopeQs(new URLSearchParams, {
                orgId: a,
                workspaceId: t
            });
            return this._call("aiChat.threads.get", `/ai-chat/threads/${encodeURIComponent(e)}${s}`);
        },
        create: (e = {}, { orgId: a, workspaceId: t } = {})=>{
            const s = this._scopeQs(new URLSearchParams, {
                orgId: a,
                workspaceId: t
            });
            return this._call("aiChat.threads.create", `/ai-chat/threads${s}`, {
                method: "POST",
                body: {
                    payload: e
                }
            });
        },
        remove: (e)=>this._call("aiChat.threads.remove", `/ai-chat/threads/${encodeURIComponent(e)}`, {
                method: "DELETE"
            })
    };
    messages = {
        list: (e, { limit: a, beforeId: t, orgId: s, workspaceId: o } = {})=>{
            const r = new URLSearchParams;
            a && r.set("limit", String(a)), t && r.set("beforeId", t);
            const i = this._scopeQs(r, {
                orgId: s,
                workspaceId: o
            });
            return this._call("aiChat.messages.list", `/ai-chat/threads/${encodeURIComponent(e)}/messages${i}`);
        }
    };
    completion(e) {
        return this._call("aiChat.completion", "/ai-chat/completion", {
            method: "POST",
            body: {
                payload: this._scopePayload(e)
            }
        });
    }
    stream(e, { onChunk: a, onDone: t, onError: s } = {}) {
        return this._streamPost("/ai-chat/stream", {
            payload: this._scopePayload(e)
        }, {
            onChunk: a,
            onDone: t,
            onError: s
        });
    }
    meetAnalyze(e) {
        return this._call("aiChat.meetAnalyze", "/ai-chat/meet-analyze", {
            method: "POST",
            body: {
                payload: e
            }
        });
    }
}
const $eb2bac58c9deabfb$export$16d21b8548a9df26 = (c)=>new $eb2bac58c9deabfb$export$3d55f7e3752192f4(c);

});

parcelRegister("8CNWJ", function(module, exports) {

$parcel$export(module.exports, "AiService", () => $64789da7dedeb71e$export$ad07b006b681e00d);

var $em51x = parcelRequire("em51x");

var $h5XS2 = parcelRequire("h5XS2");

var $6HsHs = parcelRequire("6HsHs");
const $64789da7dedeb71e$var$Z = (d, t)=>{
    const e = d && d.reason;
    if (e && e.name === "AbortError") return e;
    if (t && t.name === "AbortError") return t;
    const r = new Error("[sdk.ai] the turn was aborted", {
        cause: e || t
    });
    return r.name = "AbortError", r;
}, $64789da7dedeb71e$var$tt = "symbols_ai_model_mode", $64789da7dedeb71e$var$et = "symbols_ai_auth_mode", $64789da7dedeb71e$var$G = "auto", $64789da7dedeb71e$var$rt = "ask", $64789da7dedeb71e$var$H = [
    "auto",
    "simone",
    "openai",
    "openrouter",
    "anthropic",
    "gemini",
    "research",
    "cheap"
], $64789da7dedeb71e$var$ct = 1e3, $64789da7dedeb71e$export$b41b3a90188cd2c7 = 4e3, $64789da7dedeb71e$export$fb249ce5239a25c2 = 5e3, $64789da7dedeb71e$export$efce8a316e893691 = 660000, $64789da7dedeb71e$var$ht = new Set([
    "message.delta",
    "message.created",
    "message.reset",
    "tool.call_required",
    "tool.activity",
    "agent.started",
    "agent.completed"
]), $64789da7dedeb71e$var$st = (d)=>(d?.content || []).filter((t)=>t && t.type === "text").map((t)=>t.text).join(""), $64789da7dedeb71e$export$245cebb77c4f9715 = (d, { userMessageId: t = null, sinceTs: e = 0 } = {})=>{
    const r = Array.isArray(d?.messages) ? d.messages : [];
    let s = r;
    const c = t ? String(t) : "", u = c ? r.findIndex((h)=>String(h?.id || h?._id || "") === c) : -1;
    u >= 0 ? s = r.slice(u + 1) : e && (s = r.filter((h)=>(Date.parse(h?.createdAt || h?.created_at || "") || 0) >= e - 5e3));
    const a = [
        ...s
    ].reverse().find((h)=>h?.role === "assistant" && !$64789da7dedeb71e$export$135c8ad8393066fc(h) && $64789da7dedeb71e$var$st(h)) || null;
    let w = null;
    const n = d?.conversation?.metadata?.pendingClientCall, g = n && String(n.callId || "");
    return g && n.fn && (r.some((_)=>_?.metadata?.kind === "workspace_client_action" && String(_.metadata.callId || "") === g) || (w = {
        callId: g,
        tool: String(n.tool || n.fn),
        fn: String(n.fn),
        args: Array.isArray(n.args) ? n.args : [],
        confirm: !!n.confirm,
        readOnly: !!n.readOnly
    })), {
        answer: a,
        pending: w
    };
}, $64789da7dedeb71e$var$ft = (d)=>{
    let t = 2166136261;
    for(let e = 0; e < d.length; e++)t ^= d.charCodeAt(e), t = t * 16777619 >>> 0;
    return t.toString(16).padStart(8, "0");
}, $64789da7dedeb71e$export$fcbc06e5eebc1d68 = "build", $64789da7dedeb71e$export$c2e957a874b1e24b = "answer", $64789da7dedeb71e$export$d9c2a636a310d51e = "action", $64789da7dedeb71e$export$135c8ad8393066fc = (d)=>!!d && typeof d == "object" && (Array.isArray(d.content) && d.content.some((t)=>t && t.type === "tool_call") || d.metadata && d.metadata.kind === "tool_call"), $64789da7dedeb71e$export$8d4337dd7d76ff43 = (d)=>{
    const t = d && d.metadata && d.metadata.suggestions;
    return Array.isArray(t) ? t : [];
}, $64789da7dedeb71e$export$950daa9d78bf9540 = (d)=>{
    const t = d && d.metadata && d.metadata.sources;
    return Array.isArray(t) ? t : [];
}, $64789da7dedeb71e$export$2d91f8b623d1390 = (d)=>{
    const t = d && d.metadata && d.metadata.confidence;
    return t && typeof t == "object" ? t : null;
};
class $64789da7dedeb71e$export$ad07b006b681e00d extends (0, $em51x.BaseService) {
    getModelMode() {
        try {
            return localStorage.getItem($64789da7dedeb71e$var$tt) || $64789da7dedeb71e$var$G;
        } catch  {
            return $64789da7dedeb71e$var$G;
        }
    }
    setModelMode(t) {
        if (!$64789da7dedeb71e$var$H.includes(t)) throw new Error(`[sdk.ai] unknown modelMode "${t}". Valid: ${$64789da7dedeb71e$var$H.join(", ")}`);
        try {
            localStorage.setItem($64789da7dedeb71e$var$tt, t);
        } catch  {}
    }
    modes() {
        const t = this.getModelMode();
        return $64789da7dedeb71e$var$H.map((e)=>({
                key: e,
                label: e === "auto" ? "Auto" : e.charAt(0).toUpperCase() + e.slice(1),
                active: e === t
            }));
    }
    async describeProviders() {
        try {
            return await this._request("/ai/providers", {
                method: "GET",
                methodName: "ai.describeProviders"
            });
        } catch (t) {
            return (0, $h5XS2.logger).warn("[sdk.ai] describeProviders failed:", t), {
                defaultMode: $64789da7dedeb71e$var$G,
                providers: [],
                demotedProviders: []
            };
        }
    }
    getMode() {
        return "workspace";
    }
    setMode() {
        console.warn("[sdk.ai] setMode is deprecated; use setModelMode");
    }
    getAuthMode() {
        try {
            return localStorage.getItem($64789da7dedeb71e$var$et) || $64789da7dedeb71e$var$rt;
        } catch  {
            return $64789da7dedeb71e$var$rt;
        }
    }
    setAuthMode(t) {
        if (t !== "ask" && t !== "auto") throw new Error(`[sdk.ai] unknown authMode "${t}". Valid: 'ask', 'auto'`);
        try {
            localStorage.setItem($64789da7dedeb71e$var$et, t);
        } catch  {}
    }
    async dispatch(t = {}, e = {}) {
        const r = String(t.text || t.content || "").trim();
        if (/^\/new(\s|$)/i.test(r) || t.build === !0) {
            const c = r.replace(/^\/new\s*/i, "");
            return this._dispatchBuild({
                ...t,
                text: c,
                content: c
            }, e);
        }
        return new Promise((c)=>{
            let u = "";
            this._streamWorkspaceTurn({
                ...t,
                content: r || t.content,
                text: r
            }, {
                onChunk: (a)=>{
                    u += a, e.onChunk?.(a);
                },
                onDone: (a)=>{
                    const w = {
                        intent: $64789da7dedeb71e$export$c2e957a874b1e24b,
                        text: a?.text || u,
                        conversationId: a?.conversationId || null,
                        messageId: a?.messageId || null,
                        suggestions: Array.isArray(a?.suggestions) ? a.suggestions : [],
                        sources: Array.isArray(a?.sources) ? a.sources : [],
                        confidence: a?.confidence || null,
                        metadata: a?.metadata || null
                    };
                    e.onDone?.(w), c(w);
                },
                onError: (a)=>{
                    e.onError?.(a), c({
                        intent: $64789da7dedeb71e$export$c2e957a874b1e24b,
                        text: u,
                        error: a?.message || String(a)
                    });
                },
                onToolCall: e.onToolCall,
                onToolEvent: e.onToolEvent,
                onProcessActive: e.onProcessActive
            });
        });
    }
    _dispatchBuild(t, e = {}) {
        const { onChunk: r, onDone: s, onError: c } = e;
        return new Promise((u)=>{
            let a = !1;
            const w = (n)=>{
                a || (a = !0, u(n));
            };
            try {
                this._streamPost("/ai-chat/dispatch", {
                    text: t.text || t.content || "",
                    mode: "simone",
                    authMode: this.getAuthMode(),
                    model: t.model || null,
                    projectId: t.projectId || t.context && t.context.projectId || null,
                    context: t.context || null
                }, {
                    onChunk: (n)=>{
                        r?.(n);
                    },
                    onDone: (n)=>{
                        const g = {
                            intent: n?.intent || $64789da7dedeb71e$export$fcbc06e5eebc1d68,
                            spec: n?.spec,
                            ...n?.text ? {
                                text: n.text
                            } : {},
                            ...n?.actions ? {
                                actions: n.actions
                            } : {}
                        };
                        s?.(g), w(g);
                    },
                    onError: (n)=>{
                        c?.(n), w({
                            intent: $64789da7dedeb71e$export$fcbc06e5eebc1d68,
                            spec: null,
                            error: n?.message || String(n)
                        });
                    }
                });
            } catch (n) {
                c?.(n), w({
                    intent: $64789da7dedeb71e$export$fcbc06e5eebc1d68,
                    spec: null,
                    error: n?.message || String(n)
                });
            }
        });
    }
    async _executeActions(t) {
        const e = [];
        for (const r of t){
            const s = r?.sdkCall;
            if (!s?.service || !s?.method) {
                e.push({
                    action: r,
                    error: new Error("[sdk.ai] action missing sdkCall.service/method")
                });
                continue;
            }
            try {
                const u = (this._context?.services || this._sdk)?.[s.service];
                if (!u || typeof u[s.method] != "function") throw new Error(`[sdk.ai] unknown action ${s.service}.${s.method}`);
                const a = await u[s.method](...s.args || []);
                e.push({
                    action: r,
                    result: a
                });
            } catch (c) {
                e.push({
                    action: r,
                    error: c
                });
            }
        }
        return e;
    }
    executeActions(t) {
        return this._executeActions(t);
    }
    stream(t = {}, e = {}) {
        return this._streamHttp(t, e);
    }
    _streamHttp(t, e) {
        return this._streamWorkspaceTurn(t, e);
    }
    _streamWorkspaceTurn(t, e = {}) {
        const { onChunk: r, onDone: s, onError: c, onToolCall: u, onToolEvent: a, onProcessActive: w, onReset: n } = e, g = t?.projectId || this._context?.activeProjectId, h = this._planeTag();
        let _, I;
        if (g) _ = `${this._apiUrl}/core/agents/projects/${encodeURIComponent(g)}/conversations`, I = `symbols_ai_conversation_project_${g}_${h}`;
        else {
            const m = this._activeWorkspaceId();
            if (!m) return c?.(new Error("[sdk.ai] no active workspace or project selected")), ()=>{};
            _ = `${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(m)}/conversations`, I = `symbols_ai_conversation_${m}_${h}`;
        }
        let E = !1, i = !1, p = null, k = !1, v = !1, K = ()=>{}, B = null, A = null, b = !1, N = null, J = !1;
        const W = Date.now(), V = new Set, q = ()=>{
            try {
                K();
            } catch  {}
        }, R = ()=>{
            B && (clearTimeout(B), B = null);
        }, y = ()=>{
            b = !0, A && (clearTimeout(A), A = null);
        }, U = (m)=>(m || []).filter((f)=>f && f.type === "text").map((f)=>f.text).join(""), M = (m, f, o, l)=>{
            E || i || (E = !0, R(), y(), k || r?.(m), s?.({
                text: m,
                conversationId: p,
                messageId: f || null,
                suggestions: Array.isArray(o) ? o : [],
                sources: $64789da7dedeb71e$export$950daa9d78bf9540({
                    metadata: l
                }),
                confidence: $64789da7dedeb71e$export$2d91f8b623d1390({
                    metadata: l
                }),
                metadata: l || null
            }), q());
        }, O = (m)=>m && m.metadata || null, D = (m)=>{
            if (!(E || i)) {
                E = !0, R(), y();
                try {
                    const f = p || t && t.conversationId || null;
                    m && !m.conversationId && f && (m.conversationId = f);
                } catch  {}
                c?.(m), q();
            }
        }, P = (m)=>{
            const f = String(m?.callId || "");
            !f || V.has(f) || E || i || (V.add(f), v = !0, R(), Promise.resolve(u ? u(f, m.tool, m.args, m) : {
                ok: !1,
                error: "No client-tool handler registered for this surface."
            }).catch((o)=>({
                    ok: !1,
                    error: String(o?.message || o)
                })).then((o)=>this.submitToolResult(p, f, o === void 0 ? {
                    ok: !0
                } : o, {
                    projectId: t?.projectId
                })).then((o)=>{
                if (!o) return;
                if (o.accepted) {
                    p && Y(p, N);
                    return;
                }
                if (o.suspended) {
                    o.fn && o.callId && P(o);
                    return;
                }
                const l = $64789da7dedeb71e$export$135c8ad8393066fc(o.assistantMessage) ? "" : U(o.assistantMessage?.content);
                l && M(l, o.assistantMessage?._id || o.assistantMessage?.id || null, $64789da7dedeb71e$export$8d4337dd7d76ff43(o.assistantMessage), O(o.assistantMessage));
            }).catch(()=>{}).finally(()=>{
                v = !1;
            }));
        }, Y = (m, f)=>{
            if (y(), E || i) return;
            b = !1, f && (N = f);
            const o = Date.now(), l = N && (N.id || N._id) || null, S = (x)=>{
                b || E || i || (A = setTimeout(L, x), A && typeof A.unref == "function" && A.unref());
            }, L = async ()=>{
                if (A = null, !(b || E || i)) {
                    if (Date.now() - o > $64789da7dedeb71e$export$efce8a316e893691) {
                        y();
                        return;
                    }
                    if (!v) try {
                        const x = await this._requestExternal(`${_}/${m}`, {
                            method: "GET",
                            methodName: "ai.getConversation"
                        });
                        if (b || E || i) return;
                        const T = x && typeof x == "object" && "data" in x ? x.data : x, { answer: C, pending: Q } = $64789da7dedeb71e$export$245cebb77c4f9715(T, {
                            userMessageId: l,
                            sinceTs: W
                        });
                        if (C) {
                            M($64789da7dedeb71e$var$st(C), C.id || C._id || null, $64789da7dedeb71e$export$8d4337dd7d76ff43(C), O(C));
                            return;
                        }
                        Q && P(Q);
                    } catch (x) {
                        if (x && x.status === 404) {
                            y();
                            return;
                        }
                    }
                    S($64789da7dedeb71e$export$fb249ce5239a25c2);
                }
            };
            S($64789da7dedeb71e$export$b41b3a90188cd2c7);
        }, z = (m)=>{
            if (E || i || !m || m.status !== 404 || J) return !1;
            J = !0;
            try {
                this._clearStorage(I);
            } catch  {}
            return q(), X(!0).catch((f)=>D(f)), !0;
        }, X = async (m)=>{
            let f;
            try {
                const o = !m && t && t.conversationId;
                f = o && !String(o).startsWith("s-") ? String(o) : await this._resolveConversationId(I, _, {
                    forceNew: m || !!(t && t.newConversation)
                }), p = f;
                try {
                    this._writeStorage(I, f);
                } catch  {}
            } catch (o) {
                D(o);
                return;
            }
            i || (K = this._streamSSE(`${_}/${f}/stream`, {
                onEvent: ({ event: o, data: l })=>{
                    if (!(E || i)) {
                        if ($64789da7dedeb71e$var$ht.has(o) && y(), o === "message.delta" && l?.message) {
                            k = !0, r?.(l.message);
                            return;
                        }
                        if (o === "tool.call_required" && l?.callId) {
                            P(l);
                            return;
                        }
                        if (o === "tool.activity") {
                            a?.(l || {});
                            return;
                        }
                        if (o === "message.reset") {
                            n?.();
                            return;
                        }
                        if (o === "agent.started" || o === "agent.completed") {
                            w?.({
                                event: o,
                                ...l || {}
                            });
                            return;
                        }
                        if (o === "conversation.snapshot") {
                            const S = Array.isArray(l?.messages) ? l.messages : [], L = (T)=>(Date.parse(T?.createdAt || T?.created_at || "") || 0) >= W - 5e3, x = [
                                ...S
                            ].reverse().find((T)=>T?.role === "assistant" && !$64789da7dedeb71e$export$135c8ad8393066fc(T) && U(T.content) && L(T));
                            x && M(U(x.content), x.id || x._id || null, $64789da7dedeb71e$export$8d4337dd7d76ff43(x), O(x));
                            return;
                        }
                        if (o === "message.created" && l?.role === "assistant") {
                            if ($64789da7dedeb71e$export$135c8ad8393066fc(l)) return;
                            const S = U(l.content);
                            S && M(S, l.id || l._id || null, $64789da7dedeb71e$export$8d4337dd7d76ff43(l), O(l));
                        }
                    }
                },
                onError: (o)=>{
                    z(o) || D(o);
                }
            }), this._requestExternal(`${_}/${f}/messages`, {
                method: "POST",
                body: {
                    content: t.content || t.text || "",
                    modelMode: this.getModelMode(),
                    targetAgentId: t && (t.targetAgentId || t.context && t.context.targetAgentId) || null,
                    context: t && t.context || null,
                    earlyAck: !0,
                    ...Array.isArray(t?.attachments) && t.attachments.length ? {
                        attachments: t.attachments
                    } : {}
                },
                methodName: "ai.appendMessage"
            }).then((o)=>{
                if (E || i) return;
                const l = this._unwrap(o);
                if (l && l.suspended && l.fn && l.callId) {
                    P(l);
                    return;
                }
                const S = $64789da7dedeb71e$export$135c8ad8393066fc(l?.assistantMessage) ? "" : U(l?.assistantMessage?.content);
                if (S) {
                    M(S, l?.assistantMessage?._id || l?.assistantMessage?.id || null, $64789da7dedeb71e$export$8d4337dd7d76ff43(l?.assistantMessage), O(l?.assistantMessage));
                    return;
                }
                if (l && l.accepted) {
                    Y(f, l.userMessage);
                    return;
                }
                R(), !v && (B = setTimeout(()=>{
                    this._fallbackToLatestAssistant(_, f, M, D, W);
                }, $64789da7dedeb71e$var$ct));
            }).catch((o)=>{
                o && o.status === 409 || z(o) || D(o);
            }));
        };
        return X(!1), ()=>{
            i = !0, R(), y(), q();
        };
    }
    async _resolveConversationId(t, e, { forceNew: r = !1 } = {}) {
        const s = r ? null : this._readStorage(t);
        if (s) return s;
        const c = await this._requestExternal(e, {
            method: "POST",
            body: {},
            methodName: "ai.createConversation"
        }), a = (c && typeof c == "object" && "data" in c ? c.data : c)?.id;
        if (!a) throw new Error("[sdk.ai] createConversation returned no id");
        return this._writeStorage(t, a), a;
    }
    async _fallbackToLatestAssistant(t, e, r, s, c = 0) {
        try {
            const u = await this._requestExternal(`${t}/${e}`, {
                method: "GET",
                methodName: "ai.getConversation"
            }), w = (u && typeof u == "object" && "data" in u ? u.data : u)?.messages || [], n = (i)=>(i?.content || []).filter((p)=>p && p.type === "text").map((p)=>p.text).join(""), g = (i)=>c ? (Date.parse(i?.createdAt || i?.created_at || "") || 0) >= c - 5e3 : !0, h = [
                ...w
            ].reverse().find((i)=>i?.role === "assistant" && !$64789da7dedeb71e$export$135c8ad8393066fc(i) && n(i) && g(i)), _ = h ? n(h) : "", I = h && h.metadata && Array.isArray(h.metadata.suggestions) ? h.metadata.suggestions : [], E = h && h.metadata || null;
            _ ? r(_, h && (h.id || h._id) || null, I, E) : s(new Error("[sdk.ai] no assistant response"));
        } catch (u) {
            s(u);
        }
    }
    _conversationBase(t = {}) {
        const e = t?.projectId || this._context?.activeProjectId;
        if (e) return `${this._apiUrl}/core/agents/projects/${encodeURIComponent(e)}/conversations`;
        const r = this._activeWorkspaceId();
        if (!r) throw new Error("[sdk.ai] no active workspace or project selected");
        return `${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(r)}/conversations`;
    }
    async listExtensions(t = {}) {
        const e = this._activeWorkspaceId(t?.workspaceId);
        if (!e) return [];
        const r = await this._requestExternal(`${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(e)}/extensions`, {
            method: "GET",
            methodName: "ai.listExtensions"
        });
        return this._unwrap(r) || [];
    }
    async createExtension(t = {}) {
        const e = this._activeWorkspaceId(t?.workspaceId);
        if (!e) throw new Error("[sdk.ai] no active workspace for createExtension");
        const r = await this._requestExternal(`${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(e)}/extensions`, {
            method: "POST",
            body: {
                name: t.name,
                source: t.source,
                scope: t.scope
            },
            methodName: "ai.createExtension"
        });
        return this._unwrap(r);
    }
    async updateExtension(t, e = {}) {
        const r = this._activeWorkspaceId(e?.workspaceId);
        if (!r) throw new Error("[sdk.ai] no active workspace for updateExtension");
        if (!t) throw new Error("[sdk.ai] projectId required for updateExtension");
        const s = await this._requestExternal(`${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(r)}/extensions/${encodeURIComponent(t)}`, {
            method: "PATCH",
            body: {
                source: e.source,
                scope: e.scope
            },
            methodName: "ai.updateExtension"
        });
        return this._unwrap(s);
    }
    _unwrap(t) {
        return t && typeof t == "object" && "data" in t ? t.data : t;
    }
    async listConversations(t = {}) {
        const e = await this._requestExternal(this._conversationBase(t), {
            method: "GET",
            methodName: "ai.listConversations"
        });
        return this._unwrap(e) || [];
    }
    async getConversation(t, e = {}) {
        const r = await this._requestExternal(`${this._conversationBase(e)}/${encodeURIComponent(t)}`, {
            method: "GET",
            methodName: "ai.getConversation"
        });
        return this._unwrap(r);
    }
    async submitToolResult(t, e, r, s = {}) {
        const c = ()=>this._requestExternal(`${this._conversationBase(s)}/${encodeURIComponent(t)}/tool-result`, {
                method: "POST",
                body: {
                    callId: e,
                    result: r,
                    earlyAck: !0,
                    ...s?.modelMode ? {
                        modelMode: s.modelMode
                    } : {}
                },
                methodName: "ai.submitToolResult"
            }), u = [
            1500,
            4e3
        ], a = (n)=>{
            const g = n?.status;
            return g === 409 || typeof g == "number" && g >= 500 || n?.code === "NETWORK_UNREACHABLE" ? !0 : /failed to fetch|network unreachable|networkerror|load failed|socket|ECONNRESET|timeout/i.test(String(n?.message || ""));
        };
        let w;
        for(let n = 0; n <= u.length; n++)try {
            const g = await c();
            return this._unwrap(g);
        } catch (g) {
            if (w = g, !a(g) || n === u.length) throw g;
            await new Promise((h)=>setTimeout(h, u[n]));
        }
        throw w;
    }
    async turn(t = {}, e = {}) {
        const r = this._activeWorkspaceId(e?.workspaceId);
        if (!r) throw new Error("[sdk.ai] no active workspace selected");
        const s = `${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(r)}/turn`, c = this._turnBody(t), u = await this._requestExternal(s, {
            method: "POST",
            body: c,
            methodName: "ai.turn",
            ...e && e.signal ? {
                signal: e.signal
            } : {}
        }), a = this._unwrap(u);
        return {
            text: a && a.text || "",
            usage: a && a.usage || null,
            raw: a
        };
    }
    _turnBody(t = {}) {
        return {
            ...Array.isArray(t.messages) && t.messages.length ? {
                messages: t.messages
            } : {
                content: String(t.content || t.text || "")
            },
            ...t.system ? {
                system: t.system
            } : {},
            ...t.systemRef ? {
                systemRef: String(t.systemRef)
            } : {},
            ...t.allowTools === !1 ? {
                allowTools: !1
            } : {},
            modelMode: t.modelMode || this.getModelMode() || "auto"
        };
    }
    async turnStream(t = {}, e = {}) {
        const r = this._activeWorkspaceId(e?.workspaceId);
        if (!r) throw new Error("[sdk.ai] no active workspace selected");
        const s = e?.signal || null, c = typeof e?.onDelta == "function" ? e.onDelta : null, u = typeof e?.onReset == "function" ? e.onReset : null, a = (i, ...p)=>{
            if (i) try {
                i(...p);
            } catch  {}
        }, w = `${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(r)}/turn`, n = await this._requestStream(w, {
            method: "POST",
            body: {
                ...this._turnBody(t),
                stream: !0
            },
            headers: {
                Accept: "text/event-stream"
            },
            methodName: "ai.turnStream",
            ...s ? {
                signal: s
            } : {}
        }), g = n.headers && n.headers.get && n.headers.get("content-type") || "";
        if (!n.ok || !/text\/event-stream/i.test(g) || !n.body) return this._turnStreamJsonAnswer(n, w, (i)=>a(c, i, i));
        let h = "", _ = null;
        try {
            await (0, $6HsHs.readSseStream)(n.body, ({ event: i, data: p })=>{
                let k;
                try {
                    k = JSON.parse(p);
                } catch  {
                    return;
                }
                if (i === "delta") {
                    const v = typeof k?.text == "string" ? k.text : "";
                    if (!v) return;
                    h += v, a(c, v, h);
                } else if (i === "reset") h = "", a(u, k && k.reason || ""), a(c, "", "");
                else {
                    if (i === "done") return _ = {
                        done: k || {}
                    }, !1;
                    if (i === "error") return _ = {
                        error: k || {}
                    }, !1;
                }
            });
        } catch (i) {
            if (s && s.aborted) throw $64789da7dedeb71e$var$Z(s, i);
            const p = new Error("[sdk.ai] the turn stream broke before the answer was complete", {
                cause: i
            });
            throw p.code = "STREAM_INTERRUPTED", this._trackServiceError(p, {
                endpoint: w,
                methodName: "ai.turnStream"
            }), p;
        }
        if (_ && _.error) {
            const i = new Error(_.error.message || "AI turn failed", {
                cause: _.error
            });
            throw _.error.code && (i.code = _.error.code), this._trackServiceError(i, {
                endpoint: w,
                methodName: "ai.turnStream"
            }), i;
        }
        if (!_) {
            if (s && s.aborted) throw $64789da7dedeb71e$var$Z(s);
            const i = new Error("[sdk.ai] the turn stream ended before the answer was complete");
            throw i.code = "STREAM_TRUNCATED", this._trackServiceError(i, {
                endpoint: w,
                methodName: "ai.turnStream"
            }), i;
        }
        const I = _.done, E = typeof I.text == "string" ? I.text : h;
        return E !== h && a(c, "", E), {
            text: E,
            usage: I.usage || null,
            raw: I
        };
    }
    async _turnStreamJsonAnswer(t, e, r) {
        let s = null;
        try {
            const u = await t.text();
            s = u ? JSON.parse(u) : null;
        } catch  {
            s = null;
        }
        if (t.ok && s && s.success !== !1) {
            const u = s.data && typeof s.data == "object" ? s.data : s, a = u && u.text || "";
            return a && r(a), {
                text: a,
                usage: u && u.usage || null,
                raw: u
            };
        }
        const c = new Error(s && (s.message || s.error) || `HTTP ${t.status}: ${t.statusText}`, {
            cause: s
        });
        throw c.status = t.status, s && typeof s.code == "string" && (c.code = s.code), this._trackServiceError(c, {
            endpoint: e,
            methodName: "ai.turnStream",
            status: t.status,
            statusText: t.statusText
        }), c;
    }
    async usage(t = {}) {
        const e = this._activeWorkspaceId(t?.workspaceId);
        if (!e) throw new Error("[sdk.ai] no active workspace selected");
        const r = await this._requestExternal(`${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(e)}/ai-usage`, {
            method: "GET",
            methodName: "ai.usage"
        });
        return this._unwrap(r);
    }
    async turnStats(t = {}) {
        const e = this._activeWorkspaceId(t?.workspaceId);
        if (!e) throw new Error("[sdk.ai] no active workspace selected");
        const r = Number(t?.days), s = Number.isFinite(r) && r > 0 ? `?days=${Math.trunc(r)}` : "", c = await this._requestExternal(`${this._apiUrl}/core/agents/workspaces/${encodeURIComponent(e)}/ai-turn-stats${s}`, {
            method: "GET",
            methodName: "ai.turnStats"
        });
        return this._unwrap(c);
    }
    async createConversation(t = {}) {
        const e = t && (t.targetAgentId || t.context && t.context.targetAgentId) || null, r = await this._requestExternal(this._conversationBase(t), {
            method: "POST",
            body: {
                title: t.title,
                ...e ? {
                    targetAgentId: e
                } : {}
            },
            methodName: "ai.createConversation"
        });
        return this._unwrap(r);
    }
    async patchConversation(t, e = {}, r = {}) {
        const s = await this._requestExternal(`${this._conversationBase(r)}/${encodeURIComponent(t)}`, {
            method: "PATCH",
            body: e,
            methodName: "ai.patchConversation"
        });
        return this._unwrap(s);
    }
    async deleteConversation(t, e = {}) {
        return await this._requestExternal(`${this._conversationBase(e)}/${encodeURIComponent(t)}`, {
            method: "DELETE",
            methodName: "ai.deleteConversation"
        }), !0;
    }
    completion(t = {}, e = {}) {
        const r = t.systemPromptOverride || t.system;
        return this.turn({
            ...t,
            ...r ? {
                system: r
            } : {}
        }, e);
    }
    meetAnalyze(t) {
        return this._call("ai.meetAnalyze", "/ai-chat/meet-analyze", {
            method: "POST",
            body: {
                payload: t
            }
        });
    }
    _activeWorkspaceId(t) {
        return this._resolveWorkspaceId(t, {
            fallbackToStorage: !0
        });
    }
    _planeTag() {
        return $64789da7dedeb71e$var$ft(String(this._apiUrl || ""));
    }
    _readStorage(t) {
        try {
            return localStorage.getItem(t);
        } catch  {
            return null;
        }
    }
    _writeStorage(t, e) {
        try {
            localStorage.setItem(t, e);
        } catch  {}
    }
    _clearStorage(t) {
        try {
            localStorage.removeItem(t);
        } catch  {}
    }
}
const $64789da7dedeb71e$export$fb7854531194d437 = (d)=>new $64789da7dedeb71e$export$ad07b006b681e00d(d);

});
parcelRegister("6HsHs", function(module, exports) {

$parcel$export(module.exports, "readSseStream", () => $4e0d0572463cf916$export$a456a9f1c8414b48);
function $4e0d0572463cf916$export$aca003e140b7679c(u, { onComment: d } = {}) {
    let e = "", f = !1, r = "", l = null, c = "";
    const a = ()=>{
        const n = l, s = r;
        l = null, r = "", n && u({
            event: s || "message",
            data: n.join(`
`),
            id: c
        });
    }, o = (n)=>{
        if (n === "") {
            a();
            return;
        }
        if (n[0] === ":") {
            d && d(n.slice(1).replace(/^ /, ""));
            return;
        }
        const s = n.indexOf(":"), t = s === -1 ? n : n.slice(0, s);
        let i = s === -1 ? "" : n.slice(s + 1);
        i[0] === " " && (i = i.slice(1)), t === "event" ? r = i : t === "data" ? (l || (l = [])).push(i) : t === "id" && (i.includes("\0") || (c = i));
    };
    return {
        push (n) {
            if (!n) return;
            e += n, f || (e[0] === "\uFEFF" && (e = e.slice(1)), f = e.length > 0);
            let s = 0;
            for(let t = 0; t < e.length; t++){
                const i = e[t];
                if (!(i !== `
` && i !== "\r")) {
                    if (i === "\r" && t === e.length - 1) break;
                    o(e.slice(s, t)), i === "\r" && e[t + 1] === `
` && t++, s = t + 1;
                }
            }
            e = e.slice(s);
        },
        end () {
            e.endsWith("\r") && o(e.slice(0, -1)), e = "", l = null, r = "";
        }
    };
}
async function $4e0d0572463cf916$export$a456a9f1c8414b48(u, d, { onComment: e } = {}) {
    const f = u.getReader(), r = new TextDecoder;
    let l = !1;
    const c = $4e0d0572463cf916$export$aca003e140b7679c((a)=>{
        l || d(a) === !1 && (l = !0);
    }, {
        onComment: e
    });
    try {
        for(; !l;){
            const { done: a, value: o } = await f.read();
            if (a) {
                c.push(r.decode()), c.end();
                break;
            }
            c.push(r.decode(o, {
                stream: !0
            }));
        }
    } finally{
        try {
            f.cancel()?.catch?.(()=>{});
        } catch  {}
    }
}

});


parcelRegister("OXh1D", function(module, exports) {

$parcel$export(module.exports, "DocService", () => $0992a62109408cf4$export$ae6d03039543f4a1);

var $em51x = parcelRequire("em51x");
class $0992a62109408cf4$export$ae6d03039543f4a1 extends (0, $em51x.BaseService) {
    _scopeQuery() {
        const { orgId: e, workspaceId: t } = this._resolveScope(), s = new URLSearchParams;
        t && s.set("workspaceId", String(t)), e && s.set("orgId", String(e));
        const c = s.toString();
        return c ? `?${c}` : "";
    }
    list(e = {}, t = {}) {
        return this._call("docs.list", `/docs/list${this._scopeQuery()}`, {
            method: "POST",
            body: {
                filter: e,
                options: t
            }
        });
    }
    get(e) {
        return this._call("docs.get", `/docs/${encodeURIComponent(e)}${this._scopeQuery()}`);
    }
    tree(e) {
        return this._call("docs.tree", `/docs/${encodeURIComponent(e)}/tree${this._scopeQuery()}`);
    }
    folders() {
        return this._call("docs.folders", `/docs/folders${this._scopeQuery()}`);
    }
    create(e) {
        return typeof e == "string" ? this._call("docs.create", `/docs${this._scopeQuery()}`, {
            method: "POST",
            body: e,
            headers: {
                "Content-Type": "text/markdown"
            }
        }) : this._call("docs.create", `/docs${this._scopeQuery()}`, {
            method: "POST",
            body: {
                payload: e
            }
        });
    }
    update(e, t, { ifMatch: s } = {}) {
        const c = {};
        return s && (c["If-Match"] = s), typeof t == "string" ? (c["Content-Type"] = "text/markdown", this._call("docs.update", `/docs/${encodeURIComponent(e)}${this._scopeQuery()}`, {
            method: "PUT",
            body: t,
            headers: c
        })) : this._call("docs.update", `/docs/${encodeURIComponent(e)}${this._scopeQuery()}`, {
            method: "PUT",
            body: {
                payload: t
            },
            headers: c
        });
    }
    remove(e) {
        return this._call("docs.remove", `/docs/${encodeURIComponent(e)}${this._scopeQuery()}`, {
            method: "DELETE"
        });
    }
    subscribe(e = {}, t) {
        const { orgId: s, workspaceId: c } = this._resolveScope(), d = {
            ...c ? {
                workspaceId: c
            } : {},
            ...s ? {
                orgId: s
            } : {},
            ...e
        };
        return this._sseSubscribe("/docs/stream", d, t, {
            events: [
                {
                    name: "docs.snapshot",
                    frame: (o)=>({
                            type: "snapshot",
                            docs: o.docs || o
                        })
                },
                {
                    name: "docs.insert",
                    frame: (o)=>({
                            type: "docs.insert",
                            doc: o.doc || o
                        })
                },
                {
                    name: "docs.update",
                    frame: (o)=>({
                            type: "docs.update",
                            doc: o.doc || o
                        })
                },
                {
                    name: "docs.delete",
                    frame: (o)=>({
                            type: "docs.delete",
                            doc: o.doc || o
                        })
                }
            ]
        });
    }
    documents = {
        list: (e)=>this.list({
                type: "document"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "document"
            }),
        update: (e, t, s)=>this.update(e, t, s)
    };
    kbArticles = {
        list: (e)=>this.list({
                type: "kb_article"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "kb_article"
            }),
        update: (e, t, s)=>this.update(e, t, s),
        children: (e)=>this.list({
                "refs.parent": e
            })
    };
    notes = {
        list: (e)=>this.list({
                type: "note"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "note"
            }),
        update: (e, t, s)=>this.update(e, t, s)
    };
    userDocs = {
        list: (e)=>this.list({
                type: "user_document"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "user_document"
            }),
        update: (e, t, s)=>this.update(e, t, s)
    };
}
const $0992a62109408cf4$export$5c7fc7a1908083d4 = (r)=>new $0992a62109408cf4$export$ae6d03039543f4a1(r);

});

parcelRegister("5grt8", function(module, exports) {

$parcel$export(module.exports, "TicketService", () => $3d53c11e9e676e7e$export$81ac39d24a8a1ff0);

var $em51x = parcelRequire("em51x");
class $3d53c11e9e676e7e$export$81ac39d24a8a1ff0 extends (0, $em51x.BaseService) {
    _workspaceScope() {
        return this._resolveWorkspaceId(void 0, {
            fallbackToStorage: !0
        });
    }
    list(e = {}, t = {}) {
        const s = e.workspaceId || e.workspace || e.workspace_id ? null : this._workspaceScope(), c = s ? {
            ...e,
            workspaceId: s
        } : e;
        return this._call("tickets.list", "/tickets/list", {
            method: "POST",
            body: {
                filter: c,
                options: t
            }
        });
    }
    async listAll(e = {}, t = {}, { pageSize: s = 500, maxPages: c = 100 } = {}) {
        const o = Math.max(1, Math.min(Number(s) || 500, 500)), n = [];
        let r = null, a = 0, p = Number(t.skip) || 0;
        for(; a < c; a++){
            const i = await this.list(e, {
                ...t,
                limit: o,
                skip: p
            }), l = Array.isArray(i) ? i : i && i.data || [], k = Number(i && i.count);
            if (Number.isFinite(k) && (r = k), n.push(...l), i && typeof i.hasMore == "boolean") {
                if (!i.hasMore) return {
                    items: n,
                    count: r,
                    complete: !0,
                    pages: a + 1
                };
                p = Number.isFinite(Number(i.nextSkip)) && i.nextSkip !== null ? Number(i.nextSkip) : p + l.length;
            } else {
                if (l.length < o) return {
                    items: n,
                    count: r,
                    complete: !0,
                    pages: a + 1
                };
                if (r !== null && n.length >= r) return {
                    items: n,
                    count: r,
                    complete: !0,
                    pages: a + 1
                };
                p += l.length;
            }
            if (!l.length) break;
        }
        return {
            items: n,
            count: r,
            complete: !1,
            pages: a,
            incomplete: `read ${n.length} ticket(s) in ${a} page(s) without reaching the end${r === null ? " and the server reported no count" : ` of ${r}`}`
        };
    }
    columnCounts(e = {}, { groupBy: t } = {}) {
        const s = e.workspaceId || e.workspace || e.workspace_id ? null : this._workspaceScope(), c = s ? {
            ...e,
            workspaceId: s
        } : e;
        return this._call("tickets.columnCounts", "/tickets/column-counts", {
            method: "POST",
            body: t == null ? {
                filter: c
            } : {
                filter: c,
                groupBy: t
            }
        });
    }
    get(e) {
        const t = this._workspaceScope(), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
        return this._call("tickets.get", `/tickets/${encodeURIComponent(e)}${s}`);
    }
    epicCounts() {
        const e = this._workspaceScope(), t = e ? `?workspaceId=${encodeURIComponent(e)}` : "";
        return this._call("tickets.epicCounts", `/tickets/epic-counts${t}`);
    }
    agentQueue({ assigneeEmail: e, limit: t = 50 } = {}) {
        const s = new URLSearchParams;
        return e && s.set("assignee_email", e), t && s.set("limit", String(t)), this._call("tickets.agentQueue", `/tickets/agent-queue?${s}`);
    }
    create(e) {
        const t = this._workspaceScope(), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
        return typeof e == "string" ? this._call("tickets.create", `/tickets${s}`, {
            method: "POST",
            body: e,
            headers: {
                "Content-Type": "text/markdown"
            }
        }) : this._call("tickets.create", `/tickets${s}`, {
            method: "POST",
            body: {
                payload: e
            }
        });
    }
    update(e, t, { ifMatch: s } = {}) {
        const c = {};
        s && (c["If-Match"] = s);
        const o = this._workspaceScope(), n = o ? `?workspaceId=${encodeURIComponent(o)}` : "";
        return typeof t == "string" ? (c["Content-Type"] = "text/markdown", this._call("tickets.update", `/tickets/${encodeURIComponent(e)}${n}`, {
            method: "PUT",
            body: t,
            headers: c
        })) : this._call("tickets.update", `/tickets/${encodeURIComponent(e)}${n}`, {
            method: "PUT",
            body: {
                payload: t
            },
            headers: c
        });
    }
    remove(e) {
        const t = this._workspaceScope(), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
        return this._call("tickets.remove", `/tickets/${encodeURIComponent(e)}${s}`, {
            method: "DELETE"
        });
    }
    assign(e, t) {
        return this._call("tickets.assign", `/tickets/${encodeURIComponent(e)}/assign`, {
            method: "POST",
            body: {
                assigneeEmail: t
            }
        });
    }
    claim(e, t, { expectedUpdatedAt: s = null, columnKey: c = null } = {}) {
        const o = this._workspaceScope(), n = o ? `?workspaceId=${encodeURIComponent(o)}` : "";
        return this._call("tickets.claim", `/tickets/${encodeURIComponent(e)}/claim${n}`, {
            method: "POST",
            body: {
                agentKey: t,
                expectedUpdatedAt: s,
                columnKey: c,
                ...o ? {
                    workspaceId: o
                } : {}
            }
        });
    }
    release(e, t, { expectedUpdatedAt: s = null, force: c = !1, columnKey: o = null } = {}) {
        const n = this._workspaceScope(), r = n ? `?workspaceId=${encodeURIComponent(n)}` : "";
        return this._call("tickets.release", `/tickets/${encodeURIComponent(e)}/release${r}`, {
            method: "POST",
            body: {
                agentKey: t,
                expectedUpdatedAt: s,
                force: c,
                columnKey: o,
                ...n ? {
                    workspaceId: n
                } : {}
            }
        });
    }
    approve(e, { note: t = "", approval: s = {} } = {}) {
        const c = this._workspaceScope(), o = c ? `?workspaceId=${encodeURIComponent(c)}` : "";
        return this._call("tickets.approve", `/tickets/${encodeURIComponent(e)}/approval${o}`, {
            method: "POST",
            body: {
                action: "grant",
                note: t,
                approval: s
            }
        });
    }
    reject(e, { note: t = "" } = {}) {
        const s = this._workspaceScope(), c = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
        return this._call("tickets.reject", `/tickets/${encodeURIComponent(e)}/approval${c}`, {
            method: "POST",
            body: {
                action: "revoke",
                note: t
            }
        });
    }
    comments = {
        list: (e, t = {})=>{
            const s = new URLSearchParams, c = this._workspaceScope();
            c && s.set("workspaceId", c);
            for (const n of [
                "limit",
                "skip",
                "sortBy",
                "sortDir",
                "includeCount"
            ])t?.[n] !== void 0 && t[n] !== null && s.set(n, String(t[n]));
            const o = s.toString();
            return this._call("tickets.comments.list", `/tickets/${encodeURIComponent(e)}/comments${o ? `?${o}` : ""}`);
        },
        create: (e, t)=>{
            const s = this._workspaceScope(), c = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._call("tickets.comments.create", `/tickets/${encodeURIComponent(e)}/comments${c}`, {
                method: "POST",
                body: {
                    body: t
                }
            });
        },
        update: (e, t)=>{
            const s = this._workspaceScope(), c = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._call("tickets.comments.update", `/tickets/comments/${encodeURIComponent(e)}${c}`, {
                method: "PUT",
                body: {
                    body: t
                }
            });
        },
        remove: (e)=>{
            const t = this._workspaceScope(), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._call("tickets.comments.remove", `/tickets/comments/${encodeURIComponent(e)}${s}`, {
                method: "DELETE"
            });
        }
    };
    release = {
        listForStaging: ({ limit: e } = {})=>{
            const t = e ? `?limit=${encodeURIComponent(e)}` : "";
            return this._call("tickets.release.staging", `/tickets/release/staging${t}`);
        },
        listForProd: ({ limit: e } = {})=>{
            const t = e ? `?limit=${encodeURIComponent(e)}` : "";
            return this._call("tickets.release.prod", `/tickets/release/prod${t}`);
        },
        list: ({ limit: e, skip: t } = {})=>{
            const s = new URLSearchParams;
            e && s.set("limit", String(e)), t && s.set("skip", String(t));
            const c = s.toString();
            return this._call("tickets.release.list", `/tickets/release${c ? `?${c}` : ""}`);
        },
        create: (e = {})=>this._call("tickets.release.create", "/tickets/release", {
                method: "POST",
                body: e || {}
            }),
        promoteToStaging: (e = {})=>this._call("tickets.release.promoteToStaging", "/tickets/release/promote-staging", {
                method: "POST",
                body: e || {}
            })
    };
    _cycleQs(e) {
        const t = this._resolveWorkspaceId(e, {
            fallbackToStorage: !0
        });
        return t ? `?workspaceId=${encodeURIComponent(t)}` : "";
    }
    cycle = {
        list: ({ limit: e, workspaceId: t } = {})=>{
            const s = new URLSearchParams;
            e && s.set("limit", String(e));
            const c = this._resolveWorkspaceId(t, {
                fallbackToStorage: !0
            });
            c && s.set("workspaceId", String(c));
            const o = s.toString() ? `?${s.toString()}` : "";
            return this._call("tickets.cycle.list", `/tickets/cycle${o}`);
        },
        get: (e, { workspaceId: t } = {})=>this._call("tickets.cycle.get", `/tickets/cycle/${encodeURIComponent(e)}${this._cycleQs(t)}`),
        create: (e = {}, { workspaceId: t } = {})=>this._call("tickets.cycle.create", `/tickets/cycle${this._cycleQs(t)}`, {
                method: "POST",
                body: e || {}
            }),
        update: (e, t = {}, { workspaceId: s } = {})=>this._call("tickets.cycle.update", `/tickets/cycle/${encodeURIComponent(e)}${this._cycleQs(s)}`, {
                method: "PUT",
                body: t || {}
            }),
        activate: (e, { workspaceId: t } = {})=>this._call("tickets.cycle.activate", `/tickets/cycle/${encodeURIComponent(e)}/activate${this._cycleQs(t)}`, {
                method: "POST"
            }),
        archive: (e, { workspaceId: t } = {})=>this._call("tickets.cycle.archive", `/tickets/cycle/${encodeURIComponent(e)}/archive${this._cycleQs(t)}`, {
                method: "POST"
            }),
        listTickets: (e, { workspaceId: t } = {})=>this._call("tickets.cycle.tickets.list", `/tickets/cycle/${encodeURIComponent(e)}/tickets${this._cycleQs(t)}`),
        addTicket: (e, t, { workspaceId: s } = {})=>this._call("tickets.cycle.tickets.add", `/tickets/cycle/${encodeURIComponent(e)}/tickets${this._cycleQs(s)}`, {
                method: "POST",
                body: {
                    ticketId: t
                }
            }),
        removeTicket: (e, t, { workspaceId: s } = {})=>this._call("tickets.cycle.tickets.remove", `/tickets/cycle/${encodeURIComponent(e)}/tickets/${encodeURIComponent(t)}${this._cycleQs(s)}`, {
                method: "DELETE"
            })
    };
    columns = {
        list: ()=>this._call("tickets.columns.list", "/tickets/columns"),
        create: (e)=>this._call("tickets.columns.create", "/tickets/columns", {
                method: "POST",
                body: {
                    payload: e
                }
            }),
        update: (e, t)=>this._call("tickets.columns.update", `/tickets/columns/${encodeURIComponent(e)}`, {
                method: "PUT",
                body: t
            })
    };
    tree(e) {
        return this._call("tickets.tree", `/tickets/${encodeURIComponent(e)}/tree`);
    }
    epics = {
        list: (e)=>this.list({
                type: "epic"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "epic"
            }),
        update: (e, t, s)=>this.update(e, t, s),
        tree: (e)=>this.tree(e),
        stories: (e)=>this.list({
                type: "user_story",
                "refs.parent": e
            })
    };
    stories = {
        list: (e)=>this.list({
                type: "user_story"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "user_story"
            }),
        update: (e, t, s)=>this.update(e, t, s),
        children: (e)=>this.list({
                type: {
                    $in: [
                        "task",
                        "bug"
                    ]
                },
                "refs.parent": e
            })
    };
    tasks = {
        list: (e)=>this.list({
                type: "task"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "task"
            }),
        update: (e, t, s)=>this.update(e, t, s)
    };
    bugs = {
        list: (e)=>this.list({
                type: "bug"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "bug"
            }),
        update: (e, t, s)=>this.update(e, t, s)
    };
    spikes = {
        list: (e)=>this.list({
                type: "spike"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "spike"
            }),
        update: (e, t, s)=>this.update(e, t, s)
    };
    decisions = {
        list: (e)=>this.list({
                type: "decision"
            }, e),
        get: (e)=>this.get(e),
        create: (e)=>this.create({
                ...e,
                type: "decision"
            }),
        update: (e, t, s)=>this.update(e, t, s)
    };
    resolutions({ limit: e = 100, skip: t = 0, workspaceId: s } = {}) {
        const c = new URLSearchParams;
        e !== 100 && c.set("limit", String(e)), t && c.set("skip", String(t));
        const o = s || this._workspaceScope();
        o && c.set("workspaceId", o);
        const n = c.toString();
        return this._call("tickets.resolutions", `/tickets/resolutions${n ? `?${n}` : ""}`);
    }
    attachments = {
        upload: (e, t)=>{
            const s = this._workspaceScope(), c = s ? `?workspaceId=${encodeURIComponent(s)}` : "", o = new FormData;
            return o.append("file", t), this._call("tickets.attachments.upload", `/tickets/${encodeURIComponent(e)}/attachments${c}`, {
                method: "POST",
                body: o
            });
        },
        list: (e)=>{
            const t = this._workspaceScope(), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._call("tickets.attachments.list", `/tickets/${encodeURIComponent(e)}/attachments${s}`);
        },
        remove: (e, t)=>{
            const s = this._workspaceScope(), c = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._call("tickets.attachments.remove", `/tickets/${encodeURIComponent(e)}/attachments/${encodeURIComponent(t)}${c}`, {
                method: "DELETE"
            });
        }
    };
    subscribe(e = {}, t) {
        const s = e.workspaceId || e.workspace || e.workspace_id ? null : this._workspaceScope(), c = s ? {
            ...e,
            workspaceId: s
        } : e;
        return this._sseSubscribe("/tickets/stream", c, t, {
            flatParams: !0
        });
    }
}
const $3d53c11e9e676e7e$export$4f9899149c970eab = (d)=>new $3d53c11e9e676e7e$export$81ac39d24a8a1ff0(d);

});

parcelRegister("6L1kJ", function(module, exports) {

$parcel$export(module.exports, "FleetService", () => $4eb82aaa5df1ad27$export$7b639b94d0b7f4c4);

var $em51x = parcelRequire("em51x");
class $4eb82aaa5df1ad27$export$7b639b94d0b7f4c4 extends (0, $em51x.BaseService) {
    _workspaceScope() {
        return this._resolveWorkspaceId(void 0, {
            fallbackToStorage: !0
        });
    }
    _scoped(e = {}) {
        const t = e.workspaceId || e.workspace || e.workspace_id ? null : this._workspaceScope();
        return t ? {
            ...e,
            workspaceId: t
        } : e;
    }
    _query(e = {}) {
        const t = new URLSearchParams;
        for (const [n, r] of Object.entries(this._scoped(e)))r == null || r === "" || t.set(n, r instanceof Date ? r.toISOString() : String(r));
        const s = t.toString();
        return s ? `?${s}` : "";
    }
    _rows(e) {
        return Array.isArray(e) ? e : [
            e
        ];
    }
    async _drain(e, t = {}, { pageSize: s = 500, maxPages: n = 100 } = {}) {
        const r = Math.max(1, Math.min(Number(s) || 500, 500)), o = [];
        let u = t.cursor || void 0, i = 0;
        for(; i < n; i++){
            const l = await e({
                ...t,
                limit: r,
                cursor: u
            }), a = l && l.data || [];
            o.push(...a);
            const c = l && l.paging || {};
            if (!c.hasMore || !c.nextCursor) return {
                items: o,
                complete: !0,
                pages: i + 1
            };
            if (u = c.nextCursor, !a.length) break;
        }
        return {
            items: o,
            complete: !1,
            pages: i,
            incomplete: `read ${o.length} row(s) in ${i} page(s) without reaching the end`
        };
    }
    listRuns(e = {}) {
        const t = this._query(e);
        return this._call("fleet.listRuns", `/fleet/runs${t}`, {
            raw: !0
        });
    }
    listAllRuns(e = {}, t = {}) {
        return this._drain((s)=>this.listRuns(s), e, t);
    }
    appendRuns(e) {
        return this._call("fleet.appendRuns", "/fleet/runs", {
            method: "POST",
            body: this._scoped({
                rows: this._rows(e)
            }),
            raw: !0
        });
    }
    listMetrics(e = {}) {
        const t = this._query(e);
        return this._call("fleet.listMetrics", `/fleet/metrics${t}`, {
            raw: !0
        });
    }
    listAllMetrics(e = {}, t = {}) {
        return this._drain((s)=>this.listMetrics(s), e, t);
    }
    appendMetrics(e) {
        return this._call("fleet.appendMetrics", "/fleet/metrics", {
            method: "POST",
            body: this._scoped({
                rows: this._rows(e)
            }),
            raw: !0
        });
    }
    listEvents(e = {}) {
        const t = this._query(e);
        return this._call("fleet.listEvents", `/fleet/events${t}`, {
            raw: !0
        });
    }
    listAllEvents(e = {}, t = {}) {
        return this._drain((s)=>this.listEvents(s), e, t);
    }
    appendEvents(e) {
        return this._call("fleet.appendEvents", "/fleet/events", {
            method: "POST",
            body: this._scoped({
                rows: this._rows(e)
            }),
            raw: !0
        });
    }
    listConfig(e = {}) {
        const t = this._query(e);
        return this._call("fleet.listConfig", `/fleet/config${t}`);
    }
    getConfig(e, t = {}) {
        const s = this._query(t);
        return this._call("fleet.getConfig", `/fleet/config/${encodeURIComponent(e)}${s}`);
    }
    setConfig(e, t = {}, { ifVersion: s, workspaceId: n } = {}) {
        const r = {
            ...t
        };
        return s != null && (r.ifVersion = s), n && (r.workspaceId = n), this._call("fleet.setConfig", `/fleet/config/${encodeURIComponent(e)}`, {
            method: "PUT",
            body: this._scoped(r),
            raw: !0
        });
    }
}

});

parcelRegister("g0NMY", function(module, exports) {

$parcel$export(module.exports, "AssistantsService", () => $ba834476ad146fcc$export$90ced57271493f1);
$parcel$export(module.exports, "ASSISTANTS_ENTITY_ROUTE", () => $ba834476ad146fcc$export$b8657133e5983dc);

var $em51x = parcelRequire("em51x");

var $gN40b = parcelRequire("gN40b");
class $ba834476ad146fcc$export$90ced57271493f1 extends (0, $em51x.BaseService) {
    _base() {
        const s = this._options?.assistantsApiUrl || (0, $gN40b.default).assistantsApiUrl || "";
        if (!s) {
            const t = new Error("[assistants] no assistantsApiUrl configured");
            throw t.code = "not_configured", t;
        }
        return String(s).replace(/\/+$/, "") + "/admin/assistants";
    }
    _id(s) {
        const t = String(s || "");
        if (!/^[a-z0-9][a-z0-9-]{0,62}$/.test(t)) {
            const e = new Error("[assistants] id is an assistant id");
            throw e.code = "invalid", e;
        }
        return t;
    }
    async _call(s, t, e = {}) {
        this._requireReady(s);
        try {
            return await this._requestExternal(this._base() + t, {
                ...e,
                methodName: s,
                maxRetries: e.method && e.method !== "GET" ? 0 : void 0
            });
        } catch (a) {
            const r = a?.cause?.error;
            throw r && typeof r == "object" && r.message && (a.message = r.message), a;
        }
    }
    async list() {
        return this._call("assistants.list", "");
    }
    async get({ id: s } = {}) {
        return this._call("assistants.get", "/" + this._id(s));
    }
    async update({ id: s, version: t, set: e, note: a } = {}) {
        return this._call("assistants.update", "/" + this._id(s), {
            method: "PATCH",
            body: {
                version: t,
                set: e,
                ...a ? {
                    note: a
                } : {}
            }
        });
    }
    async revisions({ id: s } = {}) {
        return this._call("assistants.revisions", "/" + this._id(s) + "/revisions");
    }
    async rollback({ id: s, revision: t, version: e } = {}) {
        return this._call("assistants.rollback", "/" + this._id(s) + "/rollback", {
            method: "POST",
            body: {
                revision: t,
                version: e
            }
        });
    }
    async usage({ id: s } = {}) {
        return this._call("assistants.usage", "/" + this._id(s) + "/usage");
    }
    async resetCounter({ id: s, kind: t, scope: e, ip: a, ipHash: r } = {}) {
        return this._call("assistants.resetCounter", "/" + this._id(s) + "/counters/reset", {
            method: "POST",
            body: {
                kind: t,
                scope: e,
                ...a ? {
                    ip: a
                } : {},
                ...r ? {
                    ipHash: r
                } : {}
            }
        });
    }
    async testChat({ id: s, message: t, history: e, mode: a, lang: r } = {}) {
        return this._call("assistants.testChat", "/" + this._id(s) + "/chat", {
            method: "POST",
            body: {
                message: t,
                ...e ? {
                    history: e
                } : {},
                ...a ? {
                    mode: a
                } : {},
                ...r ? {
                    lang: r
                } : {}
            }
        });
    }
}
const $ba834476ad146fcc$export$b8657133e5983dc = Object.freeze({
    service: "assistants",
    methods: Object.freeze({
        list: "list",
        get: "get",
        update: "update",
        revisions: "revisions",
        rollback: "rollback",
        usage: "usage",
        resetCounter: "resetCounter",
        testChat: "testChat"
    })
});

});

parcelRegister("4QZMS", function(module, exports) {

$parcel$export(module.exports, "AiBoardsService", () => $388bf271d3ee80f2$export$aa99951f1e87b512);
$parcel$export(module.exports, "AI_BOARDS_ENTITY_ROUTE", () => $388bf271d3ee80f2$export$9bc62417a8d03653);

var $em51x = parcelRequire("em51x");
const $388bf271d3ee80f2$var$I = [
    "onEvent",
    "onStart",
    "onHead",
    "onItem",
    "onDrop",
    "onSlide"
], $388bf271d3ee80f2$export$bdf20912c3266e6b = Object.freeze({
    generate: Object.freeze([
        "prompt",
        "threadId",
        "shellWidgets",
        "modelMode",
        "capabilities",
        "mode",
        "appCatalog",
        "context"
    ]),
    refine: Object.freeze([
        "prompt",
        "boardId",
        "spec",
        "shellWidgets",
        "modelMode",
        "capabilities",
        "mode",
        "context"
    ])
}), $388bf271d3ee80f2$var$m = (o, e)=>{
    const t = {};
    for (const r of e)o[r] !== void 0 && o[r] !== null && (t[r] = o[r]);
    return t;
}, $388bf271d3ee80f2$var$O = (o)=>o.stream === !0 || o.stream !== !1 && $388bf271d3ee80f2$var$I.some((e)=>typeof o[e] == "function"), $388bf271d3ee80f2$var$T = (o)=>{
    let e = "message";
    const t = [];
    for (const r of o.split(`
`))r.startsWith("event:") ? e = r.slice(6).trim() : r.startsWith("data:") && t.push(r.slice(5).replace(/^ /, ""));
    if (!t.length) return null;
    try {
        return {
            event: e,
            data: JSON.parse(t.join(`
`))
        };
    } catch  {
        return null;
    }
}, $388bf271d3ee80f2$var$h = (o, { code: e, status: t, details: r } = {})=>{
    const s = new Error(o);
    return e && (s.code = e), t !== void 0 && (s.status = t), r !== void 0 && (s.details = r), s;
};
class $388bf271d3ee80f2$export$aa99951f1e87b512 extends (0, $em51x.BaseService) {
    _boardsWorkspace(e = {}) {
        const t = this._resolveWorkspaceId(e?.workspaceId);
        if (!t) throw $388bf271d3ee80f2$var$h("ai.boards needs a workspace (pass workspaceId or set an active workspace)", {
            code: "workspace_required"
        });
        return encodeURIComponent(String(t));
    }
    _boardsError(e) {
        const t = e?.cause;
        throw t && typeof t == "object" && (!e.code && typeof t.error == "string" && (e.code = t.error), e.details === void 0 && t.details !== void 0 && (e.details = t.details)), e;
    }
    async _authHeader() {
        if (!this._tokenManager) return null;
        try {
            await this._tokenManager.ensureValidToken?.();
        } catch  {}
        return this._tokenManager.getAuthHeader?.() || null;
    }
    async _postBoardStream(e, t, r, s) {
        this._requireReady(s);
        const c = {
            "Content-Type": "application/json",
            Accept: "text/event-stream"
        }, u = await this._authHeader();
        u && (c.Authorization = u);
        const d = await fetch(`${this._apiUrl}/core${e}`, {
            method: "POST",
            headers: c,
            body: JSON.stringify(t),
            ...r.signal ? {
                signal: r.signal
            } : {}
        });
        if (!d.ok || !d.body) {
            const a = await d.text().catch(()=>"");
            let n = null;
            try {
                n = JSON.parse(a);
            } catch  {}
            throw $388bf271d3ee80f2$var$h(n?.message || `The board request was rejected (HTTP ${d.status}).`, {
                code: n?.error || `HTTP_${d.status}`,
                status: d.status,
                details: n?.details
            });
        }
        const y = (a, n)=>{
            if (typeof a == "function") try {
                a(n);
            } catch  {}
        }, E = {
            "board.start": r.onStart,
            "board.head": r.onHead,
            "board.item": r.onItem,
            "board.drop": r.onDrop,
            "board.slide": r.onSlide
        };
        let b = null, p = null;
        const _ = (a)=>{
            if (y(r.onEvent, a), a.event === "board.done") b = a.data;
            else if (a.event === "board.error") {
                const n = a.data || {};
                p = $388bf271d3ee80f2$var$h(n.message || "The board could not be built.", {
                    code: n.code || "board_error",
                    status: n.status,
                    details: n.details
                });
            } else y(E[a.event], a.data);
        }, w = d.body.getReader(), k = new TextDecoder;
        let l = "";
        try {
            for(;;){
                const { done: a, value: n } = await w.read();
                if (a) break;
                l += k.decode(n, {
                    stream: !0
                });
                const v = l.split(`

`);
                l = v.pop() || "";
                for (const B of v){
                    const S = $388bf271d3ee80f2$var$T(B);
                    S && _(S);
                }
            }
            if (l += k.decode(), l.trim()) {
                const a = $388bf271d3ee80f2$var$T(l);
                a && _(a);
            }
        } finally{
            try {
                w.cancel()?.catch?.(()=>{});
            } catch  {}
        }
        if (p) throw p;
        if (!b) throw $388bf271d3ee80f2$var$h("The board stream ended before the board was complete.", {
            code: "stream_incomplete"
        });
        return b;
    }
    async vocabulary(e = {}) {
        const t = this._boardsWorkspace(e);
        return this._call("aiBoards.vocabulary", `/ai-boards/workspaces/${t}/vocabulary`).catch((r)=>this._boardsError(r));
    }
    async records(e = {}) {
        const t = this._boardsWorkspace(e), r = Number.isFinite(e.tzOffsetMinutes) ? e.tzOffsetMinutes : -new Date().getTimezoneOffset(), s = typeof e.lang == "string" ? e.lang.trim() : "";
        return this._call("aiBoards.records", `/ai-boards/workspaces/${t}/records`, {
            method: "POST",
            body: {
                block: e.block,
                tzOffsetMinutes: r,
                ...s ? {
                    lang: s
                } : {}
            }
        }).catch((c)=>this._boardsError(c));
    }
    async summary(e = {}) {
        const t = this._boardsWorkspace(e), r = Number.isFinite(e.tzOffsetMinutes) ? e.tzOffsetMinutes : -new Date().getTimezoneOffset(), s = Number.isInteger(e.hour) ? e.hour : new Date().getHours(), c = {
            signals: Array.isArray(e.signals) ? e.signals : [],
            hour: s,
            tzOffsetMinutes: r
        };
        return typeof e.locale == "string" && (c.locale = e.locale), this._call("aiBoards.summary", `/ai-boards/workspaces/${t}/summary`, {
            method: "POST",
            body: c
        }).catch((u)=>this._boardsError(u));
    }
    get forwardedFields() {
        return $388bf271d3ee80f2$export$bdf20912c3266e6b;
    }
    get supportsMode() {
        return $388bf271d3ee80f2$export$bdf20912c3266e6b.generate.includes("mode");
    }
    async generate(e = {}) {
        const t = this._boardsWorkspace(e), r = $388bf271d3ee80f2$var$m(e, $388bf271d3ee80f2$export$bdf20912c3266e6b.generate);
        return $388bf271d3ee80f2$var$O(e) ? this._postBoardStream(`/ai-boards/workspaces/${t}/generate`, r, e, "aiBoards.generate") : this._call("aiBoards.generate", `/ai-boards/workspaces/${t}/generate`, {
            method: "POST",
            body: r
        }).catch((s)=>this._boardsError(s));
    }
    async refine(e = {}) {
        const t = this._boardsWorkspace(e), r = $388bf271d3ee80f2$var$m(e, $388bf271d3ee80f2$export$bdf20912c3266e6b.refine);
        return $388bf271d3ee80f2$var$O(e) ? this._postBoardStream(`/ai-boards/workspaces/${t}/refine`, r, e, "aiBoards.refine") : this._call("aiBoards.refine", `/ai-boards/workspaces/${t}/refine`, {
            method: "POST",
            body: r
        }).catch((s)=>this._boardsError(s));
    }
    async list(e = {}) {
        const t = this._boardsWorkspace(e), r = e.includeSpec ? "?includeSpec=1" : "";
        return this._call("aiBoards.list", `/ai-boards/workspaces/${t}/boards${r}`).catch((s)=>this._boardsError(s));
    }
    async get(e = {}) {
        const t = this._boardsWorkspace(e), r = encodeURIComponent(String(e.id || ""));
        return this._call("aiBoards.get", `/ai-boards/workspaces/${t}/boards/${r}`).catch((s)=>this._boardsError(s));
    }
    async save(e = {}) {
        const t = this._boardsWorkspace(e), r = $388bf271d3ee80f2$var$m(e, [
            "spec",
            "title",
            "visibility",
            "layout",
            "pinnedItemIds",
            "threadId"
        ]);
        return this._call("aiBoards.save", `/ai-boards/workspaces/${t}/boards`, {
            method: "POST",
            body: r
        }).catch((s)=>this._boardsError(s));
    }
    async update(e = {}) {
        const t = this._boardsWorkspace(e), r = encodeURIComponent(String(e.id || ""));
        return this._call("aiBoards.update", `/ai-boards/workspaces/${t}/boards/${r}`, {
            method: "PATCH",
            body: e.patch || {}
        }).catch((s)=>this._boardsError(s));
    }
    async remove(e = {}) {
        const t = this._boardsWorkspace(e), r = encodeURIComponent(String(e.id || ""));
        return this._call("aiBoards.remove", `/ai-boards/workspaces/${t}/boards/${r}`, {
            method: "DELETE"
        }).catch((s)=>this._boardsError(s));
    }
}
const $388bf271d3ee80f2$var$i = (o)=>{
    if (!o || typeof o != "object" || Array.isArray(o)) return {};
    const { params: e, filter: t, ...r } = o;
    return {
        ...t && typeof t == "object" ? t : {},
        ...e && typeof e == "object" ? e : {},
        ...r
    };
}, $388bf271d3ee80f2$export$9bc62417a8d03653 = Object.freeze({
    service: "aiBoards",
    methods: Object.freeze({
        vocabulary: "vocabulary",
        records: "records",
        summary: "summary",
        generate: "generate",
        refine: "refine",
        list: "list",
        get: "get",
        save: "save",
        create: "save",
        update: "update",
        remove: "remove",
        delete: "remove"
    }),
    argMap: Object.freeze({
        vocabulary: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        records: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        summary: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        generate: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        refine: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        list: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        get: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        save: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        create: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        update: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        remove: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ],
        delete: (o)=>[
                $388bf271d3ee80f2$var$i(o)
            ]
    })
});
var $388bf271d3ee80f2$export$2e2bcd8739ae039 = $388bf271d3ee80f2$export$aa99951f1e87b512;

});

parcelRegister("2UXJP", function(module, exports) {

$parcel$export(module.exports, "AnalyzedService", () => $21ff267ae6f155bc$export$a5668421b7304135);

var $em51x = parcelRequire("em51x");
const $21ff267ae6f155bc$var$n = (d, e, s)=>{
    const t = e?.workspaceId ?? s?.workspaceId;
    t != null && t !== "" && d.set("workspaceId", String(t));
}, $21ff267ae6f155bc$var$a = (d, e)=>{
    const s = e?.family;
    s != null && s !== "" && d.set("family", String(s));
}, $21ff267ae6f155bc$var$o = (d, e)=>{
    const s = e?.tz;
    s != null && s !== "" && d.set("tz", String(s));
}, $21ff267ae6f155bc$var$r = (d, e)=>{
    const s = e?.since;
    s == null || s === "" || d.set("since", s instanceof Date ? s.toISOString() : String(s));
}, $21ff267ae6f155bc$var$I = (d, e)=>{
    const s = e?.until;
    s == null || s === "" || d.set("until", s instanceof Date ? s.toISOString() : String(s));
}, $21ff267ae6f155bc$var$l = (d, e)=>{
    const s = e?.steps;
    s == null || s === "" || d.set("steps", Array.isArray(s) ? s.map(String).join(",") : String(s));
}, $21ff267ae6f155bc$export$eed244bc17a5ad39 = [
    "utmSource",
    "utmMedium",
    "utmCampaign"
], $21ff267ae6f155bc$export$51795db002a9f09d = "__none__", $21ff267ae6f155bc$var$u = (d, e)=>{
    for (const s of $21ff267ae6f155bc$export$eed244bc17a5ad39){
        const t = e?.[s];
        t != null && t !== "" && d.set(s, String(t));
    }
};
class $21ff267ae6f155bc$export$a5668421b7304135 extends (0, $em51x.BaseService) {
    ingest(e) {
        return this._call("analyzed.ingest", "/analyzed/ingest", {
            method: "POST",
            body: e
        });
    }
    ingestPublic(e, s) {
        return this._call("analyzed.ingestPublic", "/analyzed/ingest-public", {
            method: "POST",
            headers: {
                "x-mermaid-signature": s
            },
            body: e
        });
    }
    listSessions(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.userId && t.set("userId", e.userId), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), e.since && t.set("since", e.since), e.country && t.set("country", e.country), $21ff267ae6f155bc$var$u(t, e), e.visitorId && t.set("visitorId", String(e.visitorId)), s.limit != null && t.set("limit", String(s.limit)), s.offset != null && t.set("offset", String(s.offset));
        const c = t.toString();
        return this._call("analyzed.listSessions", `/analyzed/sessions${c ? `?${c}` : ""}`);
    }
    getSession(e, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, null, s);
        const c = t.toString();
        return this._call("analyzed.getSession", `/analyzed/sessions/${encodeURIComponent(e)}${c ? `?${c}` : ""}`);
    }
    listEvents(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.sessionId && t.set("sessionId", e.sessionId), e.logType && t.set("logType", e.logType), e.message != null && e.message !== "" && t.set("message", String(e.message)), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), e.since && t.set("since", e.since), s.order && t.set("order", s.order), s.limit != null && t.set("limit", String(s.limit)), s.offset != null && t.set("offset", String(s.offset));
        const c = t.toString();
        return this._call("analyzed.listEvents", `/analyzed/events${c ? `?${c}` : ""}`);
    }
    listUsers(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), e.since && t.set("since", e.since), $21ff267ae6f155bc$var$u(t, e), s.limit != null && t.set("limit", String(s.limit)), s.offset != null && t.set("offset", String(s.offset));
        const c = t.toString();
        return this._call("analyzed.listUsers", `/analyzed/users${c ? `?${c}` : ""}`);
    }
    activeUsers(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), s.limit != null && t.set("limit", String(s.limit)), s.offset != null && t.set("offset", String(s.offset));
        const c = t.toString();
        return this._call("analyzed.activeUsers", `/analyzed/active-users${c ? `?${c}` : ""}`);
    }
    changes(e = {}) {
        const s = new URLSearchParams;
        $21ff267ae6f155bc$var$n(s, e), $21ff267ae6f155bc$var$a(s, e), $21ff267ae6f155bc$var$o(s, e), e.range && s.set("range", e.range), e.projectId && s.set("projectId", e.projectId), e.excludeProjectId && s.set("excludeProjectId", e.excludeProjectId);
        const t = s.toString();
        return this._call("analyzed.changes", `/analyzed/changes${t ? `?${t}` : ""}`);
    }
    demographics(e = {}) {
        const s = new URLSearchParams;
        $21ff267ae6f155bc$var$n(s, e), $21ff267ae6f155bc$var$a(s, e), e.projectId && s.set("projectId", e.projectId), e.excludeProjectId && s.set("excludeProjectId", e.excludeProjectId), e.since && s.set("since", e.since);
        const t = s.toString();
        return this._call("analyzed.demographics", `/analyzed/demographics${t ? `?${t}` : ""}`);
    }
    now(e = {}) {
        const s = new URLSearchParams;
        $21ff267ae6f155bc$var$n(s, e), $21ff267ae6f155bc$var$a(s, e), $21ff267ae6f155bc$var$o(s, e), e.projectId && s.set("projectId", e.projectId), e.excludeProjectId && s.set("excludeProjectId", e.excludeProjectId);
        const t = s.toString();
        return this._call("analyzed.now", `/analyzed/now${t ? `?${t}` : ""}`);
    }
    weekly(e = {}) {
        const s = new URLSearchParams;
        $21ff267ae6f155bc$var$n(s, e), $21ff267ae6f155bc$var$a(s, e), $21ff267ae6f155bc$var$o(s, e), e.projectId && s.set("projectId", e.projectId), e.excludeProjectId && s.set("excludeProjectId", e.excludeProjectId);
        const t = s.toString();
        return this._call("analyzed.weekly", `/analyzed/weekly${t ? `?${t}` : ""}`);
    }
    listBugs(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), e.since && t.set("since", e.since), s.limit != null && t.set("limit", String(s.limit)), s.offset != null && t.set("offset", String(s.offset));
        const c = t.toString();
        return this._call("analyzed.listBugs", `/analyzed/bugs${c ? `?${c}` : ""}`);
    }
    totals(e = {}) {
        const s = new URLSearchParams;
        $21ff267ae6f155bc$var$n(s, e), $21ff267ae6f155bc$var$a(s, e), $21ff267ae6f155bc$var$o(s, e), e.projectId && s.set("projectId", e.projectId), e.excludeProjectId && s.set("excludeProjectId", e.excludeProjectId), $21ff267ae6f155bc$var$r(s, e), $21ff267ae6f155bc$var$u(s, e);
        const t = s.toString();
        return this._call("analyzed.totals", `/analyzed/totals${t ? `?${t}` : ""}`);
    }
    pages(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), $21ff267ae6f155bc$var$r(t, e), s.limit != null && t.set("limit", String(s.limit)), s.offset != null && t.set("offset", String(s.offset));
        const c = t.toString();
        return this._call("analyzed.pages", `/analyzed/pages${c ? `?${c}` : ""}`);
    }
    referrers(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), $21ff267ae6f155bc$var$r(t, e), s.limit != null && t.set("limit", String(s.limit));
        const c = t.toString();
        return this._call("analyzed.referrers", `/analyzed/referrers${c ? `?${c}` : ""}`);
    }
    daily(e = {}) {
        const s = new URLSearchParams;
        $21ff267ae6f155bc$var$n(s, e), $21ff267ae6f155bc$var$a(s, e), $21ff267ae6f155bc$var$o(s, e), e.days != null && e.days !== "" && s.set("days", String(e.days)), e.projectId && s.set("projectId", e.projectId), e.excludeProjectId && s.set("excludeProjectId", e.excludeProjectId);
        const t = s.toString();
        return this._call("analyzed.daily", `/analyzed/daily${t ? `?${t}` : ""}`);
    }
    campaigns(e = {}, s = {}) {
        const t = new URLSearchParams;
        $21ff267ae6f155bc$var$n(t, e, s), $21ff267ae6f155bc$var$a(t, e), e.groupBy && t.set("groupBy", String(e.groupBy)), e.projectId && t.set("projectId", e.projectId), e.excludeProjectId && t.set("excludeProjectId", e.excludeProjectId), $21ff267ae6f155bc$var$r(t, e), $21ff267ae6f155bc$var$u(t, e), s.limit != null && t.set("limit", String(s.limit)), s.offset != null && t.set("offset", String(s.offset));
        const c = t.toString();
        return this._call("analyzed.campaigns", `/analyzed/campaigns${c ? `?${c}` : ""}`);
    }
    funnel(e = {}) {
        const s = new URLSearchParams;
        $21ff267ae6f155bc$var$n(s, e), $21ff267ae6f155bc$var$a(s, e), $21ff267ae6f155bc$var$o(s, e), e.projectId && s.set("projectId", e.projectId), e.excludeProjectId && s.set("excludeProjectId", e.excludeProjectId), $21ff267ae6f155bc$var$r(s, e), $21ff267ae6f155bc$var$I(s, e), $21ff267ae6f155bc$var$l(s, e);
        const t = s.toString();
        return this._call("analyzed.funnel", `/analyzed/funnel${t ? `?${t}` : ""}`);
    }
}

});

parcelRegister("dATb7", function(module, exports) {

$parcel$export(module.exports, "GrowthService", () => $9e59706891e2ce55$export$1a9998b46cdd63cd);

var $em51x = parcelRequire("em51x");
const $9e59706891e2ce55$var$u = /^[A-Za-z][A-Za-z0-9_]{0,39}$/, $9e59706891e2ce55$var$l = [
    "limit",
    "offset",
    "order",
    "sort"
], $9e59706891e2ce55$var$o = (t)=>t == null || t === "" ? null : t instanceof Date ? Number.isNaN(t.getTime()) ? null : t.toISOString() : typeof t == "string" ? t : typeof t == "number" ? Number.isFinite(t) ? String(t) : null : typeof t == "boolean" ? String(t) : null, $9e59706891e2ce55$var$m = (t)=>{
    if (!Array.isArray(t)) return $9e59706891e2ce55$var$o(t);
    const r = t.map($9e59706891e2ce55$var$o).filter((n)=>n !== null);
    return r.length ? r.join(",") : null;
}, $9e59706891e2ce55$var$a = (t, r)=>{
    if (!(!r || typeof r != "object" || Array.isArray(r))) for (const n of Object.keys(r)){
        if (!$9e59706891e2ce55$var$u.test(n)) continue;
        const e = $9e59706891e2ce55$var$m(r[n]);
        e !== null && t.set(n, e);
    }
};
class $9e59706891e2ce55$export$1a9998b46cdd63cd extends (0, $em51x.BaseService) {
    funnel(r = {}) {
        const n = new URLSearchParams;
        $9e59706891e2ce55$var$a(n, r);
        const e = n.toString();
        return this._call("growth.funnel", `/growth/funnel${e ? `?${e}` : ""}`);
    }
    accounts(r = {}, n = {}) {
        const e = new URLSearchParams;
        $9e59706891e2ce55$var$a(e, r);
        for (const s of $9e59706891e2ce55$var$l){
            const c = $9e59706891e2ce55$var$o(n?.[s]);
            c !== null && e.set(s, c);
        }
        const i = e.toString();
        return this._call("growth.accounts", `/growth/accounts${i ? `?${i}` : ""}`);
    }
    activation(r) {
        const n = r == null ? "" : String(r).trim();
        return n ? this._call("growth.activation", `/workspaces/${encodeURIComponent(n)}/activation`) : Promise.reject(new Error("growth.activation: workspaceId is required"));
    }
}
var $9e59706891e2ce55$export$2e2bcd8739ae039 = $9e59706891e2ce55$export$1a9998b46cdd63cd;

});

parcelRegister("f1HwY", function(module, exports) {

$parcel$export(module.exports, "ResourceLinkService", () => $af08b75112693bef$export$3877a1e8fb8acc84);

var $em51x = parcelRequire("em51x");
class $af08b75112693bef$export$3877a1e8fb8acc84 extends (0, $em51x.BaseService) {
    list({ type: e, id: s } = {}) {
        const r = new URLSearchParams;
        e && r.set("type", e), s && r.set("id", s);
        const o = r.toString();
        return this._call("resourceLinks.list", `/resource-links${o ? "?" + o : ""}`);
    }
    create({ aType: e, aId: s, bType: r, bId: o } = {}) {
        return this._call("resourceLinks.create", "/resource-links", {
            method: "POST",
            body: {
                aType: e,
                aId: s,
                bType: r,
                bId: o
            }
        });
    }
    remove(e) {
        return this._call("resourceLinks.remove", `/resource-links/${encodeURIComponent(e)}`, {
            method: "DELETE"
        });
    }
    removeByPair({ aType: e, aId: s, bType: r, bId: o } = {}) {
        return this._call("resourceLinks.removeByPair", "/resource-links/pair", {
            method: "DELETE",
            body: {
                aType: e,
                aId: s,
                bType: r,
                bId: o
            }
        });
    }
}
const $af08b75112693bef$export$af7204518580bbee = (t)=>new $af08b75112693bef$export$3877a1e8fb8acc84(t);

});

parcelRegister("fSRU6", function(module, exports) {

$parcel$export(module.exports, "ShareLinkService", () => $b905b6545c508135$export$800f01654bc93ed7);

var $em51x = parcelRequire("em51x");
const $b905b6545c508135$export$28526350fd8c742d = 30;
class $b905b6545c508135$export$800f01654bc93ed7 extends (0, $em51x.BaseService) {
    _scopeQuery(r) {
        const { orgId: e, workspaceId: t } = this._resolveScope(), i = new URLSearchParams(r || {});
        t && i.set("workspaceId", String(t)), e && i.set("orgId", String(e));
        const o = i.toString();
        return o ? `?${o}` : "";
    }
    createShareLink({ targetType: r, targetId: e, expiresInDays: t } = {}) {
        if (!r) throw new Error("targetType is required");
        if (!e) throw new Error("targetId is required");
        const i = {
            targetType: r,
            targetId: e
        };
        return t !== void 0 && (i.expiresInDays = t), this._call("createShareLink", `/share-links${this._scopeQuery()}`, {
            method: "POST",
            body: i
        });
    }
    listShareLinks({ targetType: r, targetId: e } = {}) {
        if (!r) throw new Error("targetType is required");
        if (!e) throw new Error("targetId is required");
        return this._call("listShareLinks", `/share-links${this._scopeQuery({
            targetType: r,
            targetId: e
        })}`);
    }
    revokeShareLink(r) {
        if (!r) throw new Error("id is required");
        return this._call("revokeShareLink", `/share-links/${encodeURIComponent(r)}/revoke${this._scopeQuery()}`, {
            method: "POST"
        });
    }
    getSharedResource(r) {
        if (!r) throw new Error("token is required");
        return this._call("getSharedResource", `/share/${encodeURIComponent(r)}`);
    }
    getSharedResourceContentUrl(r) {
        if (!r) throw new Error("token is required");
        return `${this._apiUrl}/core/share/${encodeURIComponent(r)}/content`;
    }
    shareUrl(r, e) {
        if (!r) throw new Error("path or token is required");
        const t = String(r).startsWith("/s/") ? String(r) : `/s/${r}`;
        return e ? `${String(e).replace(/\/+$/, "")}${t}` : t;
    }
}
const $b905b6545c508135$export$5c692a7aa4a1fe12 = (s)=>new $b905b6545c508135$export$800f01654bc93ed7(s);

});

parcelRegister("baGSE", function(module, exports) {

$parcel$export(module.exports, "CollabService", () => $8221e4077fb84aa7$export$288862ac894bd87);

var $em51x = parcelRequire("em51x");

var $3mJfE = parcelRequire("3mJfE");

var $6v49f = parcelRequire("6v49f");

var $dzhXn = parcelRequire("dzhXn");
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");

var $8JNLO = parcelRequire("8JNLO");

var $h5XS2 = parcelRequire("h5XS2");
let $8221e4077fb84aa7$var$b = null;

const $8221e4077fb84aa7$var$O = ()=>($8221e4077fb84aa7$var$b || ($8221e4077fb84aa7$var$b = (parcelRequire("jchVc")).catch((l)=>{
        throw $8221e4077fb84aa7$var$b = null, l;
    })), $8221e4077fb84aa7$var$b), $8221e4077fb84aa7$var$P = [
    "node",
    "__ref",
    "__element",
    "parent",
    "parse"
];
function $8221e4077fb84aa7$var$M(l, e = new WeakMap) {
    if (l === null || typeof l != "object") return typeof l == "function" ? l.toString() : l;
    if (e.has(l)) return e.get(l);
    const t = Array.isArray(l) ? [] : {};
    if (e.set(l, t), Array.isArray(l)) {
        for(let n = 0; n < l.length; n++)t[n] = $8221e4077fb84aa7$var$M(l[n], e);
        return t;
    }
    const o = Object.keys(l);
    for(let n = 0; n < o.length; n++){
        const i = o[n];
        $8221e4077fb84aa7$var$P.includes(i) || (t[i] = $8221e4077fb84aa7$var$M(l[i], e));
    }
    return t;
}
class $8221e4077fb84aa7$export$288862ac894bd87 extends (0, $em51x.BaseService) {
    constructor(e){
        super(e), this._client = null, this._stateManager = null, this._connected = !1, this._connecting = !1, this._connectPromise = null, this._connectionMeta = null, this._pendingConnectReject = null, this._undoStack = [], this._redoStack = [], this._isUndoRedo = !1, this._pendingOps = [], this._onSocketConnect = this._onSocketConnect.bind(this), this._onSocketDisconnect = this._onSocketDisconnect.bind(this), this._onSocketError = this._onSocketError.bind(this);
    }
    init({ context: e }) {
        if (super.init({
            context: e
        }), e?.state) try {
            this._stateManager = new (0, $3mJfE.RootStateManager)(e.state);
        } catch (t) {
            throw this._setError(t), t;
        }
        this._setReady();
    }
    updateContext(e = {}) {
        super.updateContext(e), e.state && (this._stateManager = new (0, $3mJfE.RootStateManager)(e.state));
    }
    _ensureStateManager() {
        if (!this._stateManager) {
            if (!this._context?.state) throw new Error("[CollabService] Cannot operate without root state");
            this._stateManager = new (0, $3mJfE.RootStateManager)(this._context.state);
        }
        const e = this._stateManager?.root;
        e && !e.__element && (e.__element = {
            call: (t, ...o)=>{
                switch(t){
                    case "openNotification":
                        {
                            const [n = {}] = o, { type: i = "info", title: s = "", message: c = "" } = n;
                            (i === "error" ? (0, $h5XS2.logger).error : (0, $h5XS2.logger).log)(`[Notification] ${s}${c ? ` \u2013 ${c}` : ""}`);
                            return;
                        }
                    case "deepStringifyFunctions":
                        return (0, $2C0hZ.deepStringifyFunctions)(...o);
                    default:
                        return {};
                }
            }
        });
    }
    async connect(e = {}) {
        if (this._connectPromise) return this._connectPromise;
        this._connectPromise = (async ()=>{
            this._connecting = !0, this._connected = !1;
            const t = $8221e4077fb84aa7$var$O();
            t.catch(()=>{}), (0, $dzhXn.primeCodeValidation)().catch(()=>{}), this._ensureStateManager();
            const o = {
                ...this._context,
                ...e
            };
            let { authToken: n } = o;
            const { projectId: i, branch: s = "main", pro: c } = o;
            if (!n && this._tokenManager) {
                try {
                    n = await this._tokenManager.ensureValidToken();
                } catch (a) {
                    (0, $h5XS2.logger).warn("[CollabService] Failed to obtain auth token from token manager", a);
                }
                !n && typeof this._tokenManager.getAccessToken == "function" && (n = this._tokenManager.getAccessToken());
            }
            if (!n) throw new Error("[CollabService] Cannot connect without auth token");
            if (this._context = {
                ...this._context,
                authToken: n,
                projectId: i,
                branch: s,
                pro: c
            }, !i) throw (this._stateManager?.root).__element.call("openNotification", {
                type: "error",
                title: "projectId is required",
                message: "projectId is required for CollabService connection"
            }), new Error("projectId is required for CollabService connection");
            this._client && await this.disconnect();
            const { CollabClient: d } = await t;
            this._client = new d({
                jwt: n,
                projectId: i,
                branch: s,
                live: !!c
            });
            const { socket: r } = this._client;
            this._attachSocketLifecycleListeners();
            try {
                await new Promise((a, m)=>{
                    if (!r) {
                        m(new Error("[CollabService] Socket instance missing"));
                        return;
                    }
                    if (r.connected) {
                        a();
                        return;
                    }
                    const C = ()=>{
                        r.off("connect", w), r.off("connect_error", u), r.off("error", u), r.off("disconnect", y), this._pendingConnectReject === u && (this._pendingConnectReject = null);
                    }, w = ()=>{
                        C(), a();
                    }, u = (p)=>{
                        C(), m(p instanceof Error ? p : new Error(String(p || "Unknown connection error")));
                    }, y = (p)=>{
                        u(p instanceof Error ? p : new Error(`[CollabService] Socket disconnected before connect: ${p || "unknown"}`));
                    };
                    this._pendingConnectReject = u, r.once("connect", w), r.once("connect_error", u), r.once("error", u), r.once("disconnect", y);
                });
            } catch (a) {
                throw this._detachSocketLifecycleListeners(), r?.disconnect(), this._client = null, this._connectionMeta = null, a;
            }
            r?.connected && !this._connected && this._onSocketConnect();
            const S = 600;
            let g = null;
            const f = (a)=>{
                g = a;
            };
            r?.once("disconnect", f);
            try {
                await new Promise((a)=>setTimeout(a, S));
            } finally{
                r?.off("disconnect", f);
            }
            if (g || !r?.connected) {
                const a = g || (r?.disconnected ? "socket reports disconnected" : "unknown");
                throw this._detachSocketLifecycleListeners(), r?.disconnect(), this._client = null, this._connectionMeta = null, new Error(`[CollabService] Server closed the socket immediately after connect (reason: ${a}). Likely server-side auth/permission rejection on the collab namespace (e.g. checkAuthorization viewer denied for this user/project).`);
            }
            return r?.on("ops", ({ changes: a })=>{
                (0, $h5XS2.logger).log("ops event"), this._stateManager.applyChanges(a, {
                    fromSocket: !0
                });
            }), r?.on("commit", ({ version: a })=>{
                a && this._stateManager.setVersion(a), (0, $6v49f.rootBus).emit("checkpoint:done", {
                    version: a,
                    origin: "auto"
                });
            }), r?.on("clients", this._handleClientsEvent.bind(this)), r?.on("bundle:done", this._handleBundleDoneEvent.bind(this)), r?.on("bundle:error", this._handleBundleErrorEvent.bind(this)), this._pendingOps.length && ((0, $h5XS2.logger).log(`[CollabService] Flushing ${this._pendingOps.length} offline operation batch(es)`), this._pendingOps.forEach(({ changes: a, granularChanges: m, orders: C, options: w })=>{
                const { message: u } = w || {}, y = Date.now(), p = {
                    changes: a,
                    granularChanges: m,
                    orders: C,
                    ts: y
                };
                u && (p.message = u), this.socket.emit("ops", p);
            }), this._pendingOps.length = 0), await this._client.ready, this._connectionMeta = {
                projectId: i,
                branch: s,
                live: !!c
            }, this.getConnectionInfo();
        })();
        try {
            return await this._connectPromise;
        } finally{
            this._connecting = !1, this._connectPromise = null;
        }
    }
    disconnect() {
        this._client?.socket && (this._pendingConnectReject && (this._pendingConnectReject(new Error("[CollabService] Connection attempt aborted")), this._pendingConnectReject = null), this._detachSocketLifecycleListeners(), typeof this._client.dispose == "function" ? this._client.dispose() : this._client.socket.disconnect()), this._client = null, this._connected = !1, this._connecting = !1, this._connectionMeta = null, this._pendingConnectReject = null, (0, $h5XS2.logger).log("[CollabService] Disconnected");
    }
    isConnected() {
        return !!(this._connected && this._client?.socket?.connected);
    }
    getConnectionInfo() {
        return {
            connected: this.isConnected(),
            connecting: this._connecting,
            projectId: this._connectionMeta?.projectId ?? null,
            branch: this._connectionMeta?.branch ?? null,
            live: this._connectionMeta?.live ?? null,
            pendingOps: this._pendingOps.length,
            undoStackSize: this.getUndoStackSize(),
            redoStackSize: this.getRedoStackSize()
        };
    }
    get ydoc() {
        return this._client?.ydoc;
    }
    get socket() {
        return this._client?.socket;
    }
    toggleLive(e) {
        this._client?.toggleLive(e);
    }
    sendCursor(e) {
        this._client?.sendCursor(e);
    }
    sendPresence(e) {
        this._client?.sendPresence(e);
    }
    updateData(e, t = {}) {
        this._ensureStateManager();
        const { isUndo: o = !1, isRedo: n = !1 } = t;
        !o && !n && !this._isUndoRedo && this._trackForUndo(e, t);
        const i = this._stateManager?.root, { granularChanges: s, orders: c } = (0, $8JNLO.preprocessChanges)(i, e, t);
        t.append && t.append.length && s.push(...t.append), this._stateManager.applyChanges(e, {
            ...t
        });
        const d = $8221e4077fb84aa7$var$M(s), r = $8221e4077fb84aa7$var$M(e), { message: S } = t;
        if (!this.isConnected()) return (0, $h5XS2.logger).warn("[CollabService] Not connected, queuing real-time update"), this._pendingOps.push({
            changes: r,
            granularChanges: d,
            orders: c,
            options: t
        }), {
            success: !0,
            queued: !0
        };
        if (this.socket?.connected) {
            const g = Date.now(), f = {
                changes: r,
                granularChanges: d,
                orders: c,
                ts: g
            };
            S && (f.message = S), this.socket.emit("ops", f);
        }
        return {
            success: !0
        };
    }
    _trackForUndo(e, t) {
        const o = e.map((i)=>{
            const [s, c] = i, d = this._getValueAtPath(c);
            return s === "delete" ? [
                "update",
                c,
                d
            ] : typeof d < "u" ? [
                "update",
                c,
                d
            ] : [
                "delete",
                c
            ];
        });
        this._undoStack.push({
            operations: o,
            originalOperations: e,
            options: t,
            timestamp: Date.now()
        }), this._redoStack.length = 0;
        const n = this._options?.maxUndoSteps || 50;
        this._undoStack.length > n && this._undoStack.shift();
    }
    _getValueAtPath(e) {
        const t = this._stateManager?.root;
        if (!t || !t.getByPath) return null;
        try {
            return t.getByPath(e);
        } catch (o) {
            return (0, $h5XS2.logger).warn("[CollabService] Could not get value at path:", e, o), null;
        }
    }
    undo() {
        if (!this._undoStack.length) throw (this._stateManager?.root).__element.call("openNotification", {
            type: "error",
            title: "Nothing to undo"
        }), new Error("Nothing to undo");
        if (!this.isConnected()) {
            (0, $h5XS2.logger).warn("[CollabService] Not connected, cannot undo");
            return;
        }
        const e = this._undoStack.pop(), { operations: t, originalOperations: o, options: n } = e;
        this._redoStack.push({
            operations: o,
            originalOperations: t,
            options: n,
            timestamp: Date.now()
        }), this._isUndoRedo = !0;
        try {
            this.updateData(t, {
                ...n,
                isUndo: !0,
                message: `Undo: ${n.message || "operation"}`
            });
        } finally{
            this._isUndoRedo = !1;
        }
        return t;
    }
    redo() {
        if (!this._redoStack.length) throw (this._stateManager?.root).__element.call("openNotification", {
            type: "error",
            title: "Nothing to redo"
        }), new Error("Nothing to redo");
        if (!this.isConnected()) {
            (0, $h5XS2.logger).warn("[CollabService] Not connected, cannot redo");
            return;
        }
        const e = this._redoStack.pop(), { operations: t, originalOperations: o, options: n } = e;
        this._undoStack.push({
            operations: o,
            originalOperations: t,
            options: n,
            timestamp: Date.now()
        }), this._isUndoRedo = !0;
        try {
            this.updateData(t, {
                ...n,
                isRedo: !0,
                message: `Redo: ${n.message || "operation"}`
            });
        } finally{
            this._isUndoRedo = !1;
        }
        return t;
    }
    canUndo() {
        return this._undoStack.length > 0;
    }
    canRedo() {
        return this._redoStack.length > 0;
    }
    getUndoStackSize() {
        return this._undoStack.length;
    }
    getRedoStackSize() {
        return this._redoStack.length;
    }
    clearUndoHistory() {
        this._undoStack.length = 0, this._redoStack.length = 0;
    }
    addItem(e, t, o = {}) {
        try {
            (0, $dzhXn.validateParams).type(e), (0, $dzhXn.validateParams).data(t, e);
            const { value: n, ...i } = t, s = [
                [
                    "update",
                    [
                        e,
                        t.key
                    ],
                    n
                ],
                [
                    "update",
                    [
                        "schema",
                        e,
                        t.key
                    ],
                    i || {}
                ]
            ], c = {
                ...o,
                skipComponentsChangedEvent: !0
            };
            return this.updateData(s, c);
        } catch (n) {
            throw new Error(`Failed to add item: ${n.message}`, {
                cause: n
            });
        }
    }
    addMultipleItems(e, t = {}) {
        const o = [];
        try {
            return e.forEach(([n, i])=>{
                (0, $dzhXn.validateParams).type(n), (0, $dzhXn.validateParams).data(i, n);
                const { value: s, ...c } = i;
                o.push([
                    "update",
                    [
                        n,
                        i.key
                    ],
                    s
                ], [
                    "update",
                    [
                        "schema",
                        n,
                        i.key
                    ],
                    c
                ]);
            }), this.updateData([
                ...o,
                ...t.append || []
            ], {
                message: `Created ${o.length} items`,
                ...t
            }), o;
        } catch (n) {
            throw (this._stateManager?.root).__element.call("openNotification", {
                type: "error",
                title: "Failed to add item",
                message: n.message
            }), new Error(`Failed to add item: ${n.message}`, {
                cause: n
            });
        }
    }
    updateItem(e, t, o = {}) {
        try {
            (0, $dzhXn.validateParams).type(e), (0, $dzhXn.validateParams).data(t, e);
            const { value: n, ...i } = t, s = [
                [
                    "update",
                    [
                        e,
                        t.key
                    ],
                    n
                ],
                [
                    "update",
                    [
                        "schema",
                        e,
                        t.key
                    ],
                    i
                ]
            ];
            return this.updateData(s, o);
        } catch (n) {
            throw (this._stateManager?.root).__element.call("openNotification", {
                type: "error",
                title: "Failed to update item",
                message: n.message
            }), new Error(`Failed to update item: ${n.message}`, {
                cause: n
            });
        }
    }
    deleteItem(e, t, o = {}) {
        try {
            (0, $dzhXn.validateParams).type(e), (0, $dzhXn.validateParams).key(t, e);
            const n = [
                [
                    "delete",
                    [
                        e,
                        t
                    ]
                ],
                [
                    "delete",
                    [
                        "schema",
                        e,
                        t
                    ]
                ],
                ...o.append || []
            ];
            return this.updateData(n, {
                message: `Deleted ${t} from ${e}`,
                ...o
            });
        } catch (n) {
            throw (this._stateManager?.root).__element.call("openNotification", {
                type: "error",
                title: "Failed to delete item",
                message: n.message
            }), new Error(`Failed to delete item: ${n.message}`, {
                cause: n
            });
        }
    }
    _handleClientsEvent(e = {}) {
        const t = this._stateManager?.root;
        t && typeof t.replace == "function" && (t.clients = e), (0, $6v49f.rootBus).emit("clients:updated", e);
    }
    _handleBundleDoneEvent({ project: e, ticket: t, dependencies: o = {}, schema: n = {} } = {}) {
        (0, $h5XS2.logger).log("[CollabService] Bundle done", {
            project: e,
            ticket: t
        });
        try {
            this._ensureStateManager();
            const { dependencies: c = {} } = n || {}, d = [
                [
                    "update",
                    [
                        "dependencies"
                    ],
                    o
                ],
                [
                    "update",
                    [
                        "schema",
                        "dependencies"
                    ],
                    c
                ]
            ];
            this._stateManager.applyChanges(d, {
                fromSocket: !0,
                preventFetchDeps: !0,
                preventUpdate: [
                    "Iframe"
                ]
            });
        } catch (c) {
            (0, $h5XS2.logger).error("[CollabService] Failed to update deps after bundle", c);
        }
        const s = this._stateManager?.root?.__element;
        s?.call && s.call("openNotification", {
            type: "success",
            title: "Dependencies ready",
            message: `Project ${e} dependencies have been bundled successfully.`
        }), (0, $6v49f.rootBus).emit("bundle:done", {
            project: e,
            ticket: t
        });
    }
    _handleBundleErrorEvent({ project: e, ticket: t, error: o } = {}) {
        (0, $h5XS2.logger).error("[CollabService] Bundle error", {
            project: e,
            ticket: t,
            error: o
        });
        const i = this._stateManager?.root?.__element;
        i?.call && i.call("openNotification", {
            type: "error",
            title: "Dependency bundle failed",
            message: o || `An error occurred while bundling dependencies for project ${e}.`
        }), (0, $6v49f.rootBus).emit("bundle:error", {
            project: e,
            ticket: t,
            error: o
        });
    }
    _attachSocketLifecycleListeners() {
        const e = this._client?.socket;
        e && (e.on("connect", this._onSocketConnect), e.on("disconnect", this._onSocketDisconnect), e.on("connect_error", this._onSocketError));
    }
    _detachSocketLifecycleListeners() {
        const e = this._client?.socket;
        e && (e.off("connect", this._onSocketConnect), e.off("disconnect", this._onSocketDisconnect), e.off("connect_error", this._onSocketError));
    }
    _onSocketConnect() {
        this._connected = !0;
    }
    _onSocketDisconnect(e) {
        this._connected = !1, e && e !== "io client disconnect" && (0, $h5XS2.logger).warn("[CollabService] Socket disconnected", e);
    }
    _onSocketError(e) {
        (0, $h5XS2.logger).warn("[CollabService] Socket connection error", e);
    }
    checkpoint({ timeout: e = 1e4 } = {}) {
        return this.isConnected() ? new Promise((t, o)=>{
            let n = null;
            const i = ()=>{
                n && (clearTimeout(n), n = null), this.socket?.off("commit", s);
            }, s = ({ version: c })=>{
                i(), (0, $6v49f.rootBus).emit("checkpoint:done", {
                    version: c,
                    origin: "manual"
                }), t(c);
            };
            this.socket?.once("commit", s), n = setTimeout(()=>{
                i(), o(new Error(`[CollabService] checkpoint timed out after ${e}ms \u2014 server never emitted commit event in response to socket.emit("checkpoint"). Likely a server-side commit pipeline failure (apiCommitChanges / commit-socket-ops endpoint).`));
            }, e), this.socket?.emit("checkpoint");
        }) : ((0, $h5XS2.logger).warn("[CollabService] Not connected, cannot request checkpoint"), Promise.reject(new Error("Not connected")));
    }
}

});
parcelRegister("3mJfE", function(module, exports) {

$parcel$export(module.exports, "RootStateManager", () => $273687288b1f5ef1$export$bad7ee462cdca89e);

var $byww3 = parcelRequire("byww3");
parcelRequire("6v49f");
const { isFunction: $273687288b1f5ef1$var$r } = $byww3.default || $byww3;
class $273687288b1f5ef1$export$bad7ee462cdca89e {
    constructor(t){
        this._rootState = t;
    }
    async applyChanges(t = [], e = {}) {
        return !this._rootState || !$273687288b1f5ef1$var$r(this._rootState.setPathCollection) ? void 0 : await this._rootState.setPathCollection(t, {
            preventUpdate: !0,
            ...e
        });
    }
    setVersion(t) {
        this._rootState && (this._rootState.version = t);
    }
    get root() {
        return this._rootState;
    }
}

});
parcelRegister("6v49f", function(module, exports) {

$parcel$export(module.exports, "rootBus", () => $4bb8db11baf57bca$export$e0fc392f6e1a6161);

var $h5XS2 = parcelRequire("h5XS2");
const $4bb8db11baf57bca$var$n = ()=>{
    if (globalThis.__SMBLS_ROOT_BUS__) return globalThis.__SMBLS_ROOT_BUS__;
    const s = {}, l = {}, _ = {
        on (r, t) {
            if ((s[r] ||= []).push(t), Object.hasOwn(l, r)) try {
                t(l[r]);
            } catch (o) {
                (0, $h5XS2.logger).error("[rootBus] handler error for (replay)", r, o);
            }
        },
        off (r, t) {
            const o = s[r];
            if (!o) return;
            const e = o.indexOf(t);
            e !== -1 && o.splice(e, 1);
        },
        emit (r, t) {
            l[r] = t;
            const o = s[r];
            !o || !o.length || o.slice().forEach((e)=>{
                try {
                    e(t);
                } catch (c) {
                    (0, $h5XS2.logger).error("[rootBus] handler error for", r, c);
                }
            });
        }
    };
    return Object.defineProperty(_, "_listeners", {
        value: s,
        enumerable: !1
    }), globalThis.__SMBLS_ROOT_BUS__ = _, _;
}, $4bb8db11baf57bca$export$e0fc392f6e1a6161 = $4bb8db11baf57bca$var$n();
var $4bb8db11baf57bca$export$2e2bcd8739ae039 = $4bb8db11baf57bca$export$e0fc392f6e1a6161;

});


parcelRegister("dzhXn", function(module, exports) {

$parcel$export(module.exports, "primeCodeValidation", () => $9e0c790f6685232e$export$3a96a415d65ecfec);
$parcel$export(module.exports, "validateParams", () => $9e0c790f6685232e$export$1f3bf48e9edf7d72);
let $9e0c790f6685232e$var$s = null, $9e0c790f6685232e$var$c = null;


function $9e0c790f6685232e$export$3a96a415d65ecfec() {
    return $9e0c790f6685232e$var$c || ($9e0c790f6685232e$var$c = Promise.all([
        Promise.resolve((parcelRequire("gQuVO"))),
        (parcelRequire("8GDFe"))
    ]).then(([e, t])=>($9e0c790f6685232e$var$s = {
            acorn: e,
            walk: t
        }, $9e0c790f6685232e$var$s)).catch((e)=>{
        throw $9e0c790f6685232e$var$c = null, e;
    })), $9e0c790f6685232e$var$c;
}
const $9e0c790f6685232e$var$o = [
    "abstract",
    "arguments",
    "await",
    "boolean",
    "break",
    "byte",
    "case",
    "catch",
    "char",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "double",
    "else",
    "enum",
    "eval",
    "export",
    "extends",
    "false",
    "final",
    "finally",
    "float",
    "for",
    "function",
    "goto",
    "if",
    "implements",
    "import",
    "in",
    "instanceof",
    "int",
    "interface",
    "let",
    "long",
    "native",
    "new",
    "null",
    "package",
    "private",
    "protected",
    "public",
    "return",
    "short",
    "static",
    "super",
    "switch",
    "synchronized",
    "this",
    "throw",
    "throws",
    "transient",
    "true",
    "try",
    "typeof",
    "var",
    "void",
    "volatile",
    "while",
    "with",
    "yield"
], $9e0c790f6685232e$var$l = [
    "snippets",
    "functions"
], $9e0c790f6685232e$var$p = (e)=>{
    if (!$9e0c790f6685232e$var$s) return $9e0c790f6685232e$export$3a96a415d65ecfec().catch(()=>{}), !0;
    const { acorn: t, walk: a } = $9e0c790f6685232e$var$s;
    try {
        const i = e.replace(/\/\/\/\/\/n/gu, `
`), d = t.parse(i, {
            ecmaVersion: "latest",
            sourceType: "module",
            allowReserved: !0
        }), f = (r)=>{
            if (r.type === "FunctionDeclaration") {
                const n = r.id?.name;
                if (n && $9e0c790f6685232e$var$o.includes(n)) throw new Error(`Found reserved keyword "${n}" used as function name`);
                r.params.forEach((u)=>{
                    if (u.type === "Identifier" && $9e0c790f6685232e$var$o.includes(u.name)) throw new Error(`Found reserved keyword "${u.name}" used as parameter name`);
                });
            }
            if (r.type === "VariableDeclarator") {
                const n = r.id?.name;
                if (n && $9e0c790f6685232e$var$o.includes(n)) throw new Error(`Found reserved keyword "${n}" used as variable name`);
            }
            if (r.type === "Identifier" && r.parent?.type === "VariableDeclarator" && $9e0c790f6685232e$var$o.includes(r.name)) throw new Error(`Found reserved keyword "${r.name}" used as variable name`);
        };
        a.full(d, (r)=>{
            f(r);
        });
    } catch (i) {
        if (i.message.includes("reserved keyword")) throw i;
        return !0;
    }
}, $9e0c790f6685232e$export$1f3bf48e9edf7d72 = {
    type: (e)=>{
        if (!e) throw new Error("Type parameter is required");
        if (typeof e != "string") throw new Error("Type must be a string");
        return !0;
    },
    key: (e, t)=>{
        if (!e) throw new Error("Key parameter is required");
        if (typeof e != "string") throw new Error("Key must be a string");
        if ($9e0c790f6685232e$var$l.includes(t) && $9e0c790f6685232e$var$o.includes(e)) throw new Error(`Key "${e}" is a reserved JavaScript keyword and cannot be used`);
        return !0;
    },
    data: (e, t)=>{
        if (!e) throw new Error("Data parameter is required");
        if (typeof e != "object") throw new Error("Data must be an object");
        if (!e.key) throw new Error("Data must contain a key property");
        if ($9e0c790f6685232e$var$l.includes(t)) {
            if ($9e0c790f6685232e$var$o.includes(e.key)) throw new Error(`Key "${e.key}" is a reserved JavaScript keyword and cannot be used`);
            if (e.value) {
                const a = e.value;
                typeof a == "string" && $9e0c790f6685232e$var$p(a);
            }
        }
        return !0;
    }
};

});
parcelRegister("gQuVO", function(module, exports) {

$parcel$export(module.exports, "isIdentifierStart", () => $6fb78ed28ed3b042$export$56b48cc5d7560ffb);
$parcel$export(module.exports, "isIdentifierChar", () => $6fb78ed28ed3b042$export$332f4d7bee38db93);
$parcel$export(module.exports, "TokenType", () => $6fb78ed28ed3b042$export$f435f793048e7a0f);
$parcel$export(module.exports, "keywordTypes", () => $6fb78ed28ed3b042$export$d53f8326294b31d8);
$parcel$export(module.exports, "tokTypes", () => $6fb78ed28ed3b042$export$b54c7ea7aabba5c8);
$parcel$export(module.exports, "lineBreak", () => $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6);
$parcel$export(module.exports, "lineBreakG", () => $6fb78ed28ed3b042$export$866e20207bbc41f2);
$parcel$export(module.exports, "isNewLine", () => $6fb78ed28ed3b042$export$2c19a3e3b4008fff);
$parcel$export(module.exports, "nonASCIIwhitespace", () => $6fb78ed28ed3b042$export$268622f0f1cbc82b);
$parcel$export(module.exports, "Position", () => $6fb78ed28ed3b042$export$13807d9ee5a34a42);
$parcel$export(module.exports, "SourceLocation", () => $6fb78ed28ed3b042$export$7387db7caf96fcdb);
$parcel$export(module.exports, "getLineInfo", () => $6fb78ed28ed3b042$export$7af82191547c5ff7);
$parcel$export(module.exports, "defaultOptions", () => $6fb78ed28ed3b042$export$ba43bf67f3d48107);
$parcel$export(module.exports, "Parser", () => $6fb78ed28ed3b042$export$7acfa6ed01010e37);
$parcel$export(module.exports, "TokContext", () => $6fb78ed28ed3b042$export$68e7b4c4d99215d9);
$parcel$export(module.exports, "tokContexts", () => $6fb78ed28ed3b042$export$2b5f701edfbd6f00);
$parcel$export(module.exports, "Node", () => $6fb78ed28ed3b042$export$85c928794f8d04d4);
$parcel$export(module.exports, "Token", () => $6fb78ed28ed3b042$export$50792b0e93539fde);
$parcel$export(module.exports, "version", () => $6fb78ed28ed3b042$export$83d89fbfd8236492);
$parcel$export(module.exports, "parse", () => $6fb78ed28ed3b042$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseExpressionAt", () => $6fb78ed28ed3b042$export$61f24eb03dd7ce92);
$parcel$export(module.exports, "tokenizer", () => $6fb78ed28ed3b042$export$5f8c09e3ae6f64e1);
// This file was generated. Do not modify manually!
var $6fb78ed28ed3b042$var$astralIdentifierCodes = [
    509,
    0,
    227,
    0,
    150,
    4,
    294,
    9,
    1368,
    2,
    2,
    1,
    6,
    3,
    41,
    2,
    5,
    0,
    166,
    1,
    574,
    3,
    9,
    9,
    7,
    9,
    32,
    4,
    318,
    1,
    31,
    4,
    33,
    15,
    71,
    10,
    50,
    3,
    123,
    2,
    54,
    14,
    32,
    10,
    3,
    1,
    11,
    3,
    46,
    10,
    8,
    0,
    46,
    9,
    7,
    2,
    37,
    13,
    2,
    9,
    6,
    1,
    45,
    0,
    13,
    2,
    49,
    13,
    9,
    3,
    2,
    11,
    83,
    11,
    7,
    0,
    3,
    0,
    158,
    11,
    6,
    9,
    7,
    3,
    56,
    1,
    2,
    6,
    3,
    1,
    3,
    2,
    10,
    0,
    11,
    1,
    3,
    6,
    4,
    4,
    68,
    8,
    2,
    0,
    3,
    0,
    2,
    3,
    2,
    4,
    2,
    0,
    15,
    1,
    83,
    17,
    10,
    9,
    5,
    0,
    82,
    19,
    13,
    9,
    214,
    6,
    3,
    8,
    28,
    1,
    83,
    16,
    16,
    9,
    82,
    12,
    9,
    9,
    7,
    19,
    58,
    14,
    5,
    9,
    243,
    14,
    166,
    9,
    71,
    5,
    2,
    1,
    3,
    3,
    2,
    0,
    2,
    1,
    13,
    9,
    120,
    6,
    3,
    6,
    4,
    0,
    29,
    9,
    41,
    6,
    2,
    3,
    9,
    0,
    10,
    10,
    47,
    15,
    199,
    7,
    137,
    9,
    54,
    7,
    2,
    7,
    17,
    9,
    57,
    21,
    2,
    13,
    123,
    5,
    4,
    0,
    2,
    1,
    2,
    6,
    2,
    0,
    9,
    9,
    49,
    4,
    2,
    1,
    2,
    4,
    9,
    9,
    55,
    9,
    7,
    0,
    259,
    3,
    10,
    1,
    2,
    0,
    49,
    6,
    4,
    4,
    14,
    10,
    5350,
    0,
    7,
    14,
    11465,
    27,
    2343,
    9,
    87,
    9,
    39,
    4,
    60,
    6,
    26,
    9,
    535,
    9,
    470,
    0,
    2,
    54,
    8,
    3,
    82,
    0,
    12,
    1,
    19628,
    1,
    4178,
    9,
    519,
    45,
    3,
    22,
    481,
    1,
    61,
    4,
    4,
    5,
    9,
    7,
    3,
    6,
    31,
    3,
    149,
    2,
    12,
    2,
    9,
    1,
    3,
    0,
    33,
    1,
    1357,
    49,
    513,
    54,
    5,
    49,
    9,
    0,
    15,
    0,
    23,
    4,
    2,
    14,
    1361,
    6,
    2,
    16,
    3,
    6,
    2,
    1,
    2,
    4,
    101,
    0,
    161,
    6,
    10,
    9,
    357,
    0,
    62,
    13,
    499,
    13,
    245,
    1,
    2,
    9,
    233,
    0,
    3,
    0,
    8,
    1,
    6,
    0,
    475,
    6,
    110,
    6,
    6,
    9,
    4759,
    9,
    787719,
    239
];
// This file was generated. Do not modify manually!
var $6fb78ed28ed3b042$var$astralIdentifierStartCodes = [
    0,
    11,
    2,
    25,
    2,
    18,
    2,
    1,
    2,
    14,
    3,
    13,
    35,
    122,
    70,
    52,
    268,
    28,
    4,
    48,
    48,
    31,
    14,
    29,
    6,
    37,
    11,
    29,
    3,
    35,
    5,
    7,
    2,
    4,
    43,
    157,
    19,
    35,
    5,
    35,
    5,
    39,
    9,
    51,
    13,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    2,
    10,
    2,
    14,
    2,
    6,
    2,
    1,
    4,
    51,
    13,
    310,
    10,
    21,
    11,
    7,
    25,
    5,
    2,
    41,
    2,
    13,
    65,
    5,
    3,
    0,
    2,
    43,
    2,
    1,
    4,
    0,
    3,
    22,
    11,
    22,
    10,
    30,
    66,
    18,
    2,
    1,
    11,
    21,
    11,
    25,
    7,
    25,
    39,
    55,
    7,
    1,
    65,
    0,
    16,
    3,
    2,
    2,
    2,
    28,
    43,
    28,
    4,
    28,
    36,
    7,
    2,
    27,
    28,
    53,
    11,
    21,
    11,
    18,
    14,
    17,
    111,
    72,
    56,
    50,
    14,
    50,
    14,
    35,
    39,
    27,
    10,
    22,
    251,
    41,
    7,
    1,
    17,
    5,
    18,
    21,
    18,
    28,
    11,
    0,
    9,
    21,
    43,
    17,
    47,
    20,
    28,
    22,
    13,
    52,
    58,
    1,
    3,
    0,
    14,
    44,
    33,
    24,
    27,
    35,
    30,
    0,
    3,
    0,
    9,
    34,
    4,
    0,
    13,
    47,
    15,
    3,
    22,
    0,
    2,
    0,
    36,
    17,
    2,
    24,
    20,
    1,
    64,
    6,
    2,
    0,
    2,
    3,
    2,
    14,
    2,
    9,
    8,
    46,
    39,
    7,
    3,
    1,
    3,
    21,
    2,
    6,
    2,
    1,
    2,
    4,
    4,
    0,
    19,
    0,
    13,
    4,
    31,
    9,
    2,
    0,
    3,
    0,
    2,
    37,
    2,
    0,
    26,
    0,
    2,
    0,
    45,
    52,
    19,
    3,
    21,
    2,
    31,
    47,
    21,
    1,
    2,
    0,
    185,
    46,
    42,
    3,
    37,
    47,
    21,
    0,
    60,
    42,
    14,
    0,
    72,
    26,
    38,
    6,
    186,
    43,
    117,
    63,
    32,
    7,
    3,
    0,
    3,
    7,
    2,
    1,
    2,
    23,
    16,
    0,
    2,
    0,
    95,
    7,
    3,
    38,
    17,
    0,
    2,
    0,
    29,
    0,
    11,
    39,
    8,
    0,
    22,
    0,
    12,
    45,
    20,
    0,
    19,
    72,
    18,
    0,
    182,
    32,
    32,
    8,
    2,
    36,
    18,
    0,
    50,
    29,
    113,
    6,
    2,
    1,
    2,
    37,
    22,
    0,
    26,
    5,
    2,
    1,
    2,
    31,
    15,
    0,
    24,
    43,
    22,
    0,
    239,
    18,
    16,
    0,
    2,
    12,
    2,
    33,
    125,
    0,
    80,
    921,
    103,
    111,
    6,
    206,
    13,
    310,
    2314,
    96,
    16,
    1071,
    18,
    5,
    26,
    3994,
    6,
    582,
    6842,
    29,
    1763,
    568,
    8,
    30,
    18,
    78,
    18,
    29,
    19,
    47,
    17,
    3,
    32,
    20,
    6,
    18,
    433,
    44,
    212,
    63,
    33,
    24,
    3,
    24,
    45,
    74,
    6,
    0,
    67,
    12,
    65,
    1,
    2,
    0,
    15,
    4,
    10,
    7386,
    37,
    33,
    96,
    114,
    14,
    913,
    15,
    50,
    7710,
    3,
    2,
    6,
    2,
    1,
    2,
    296,
    10,
    0,
    30,
    2,
    3,
    0,
    15,
    4,
    8,
    395,
    2309,
    106,
    6,
    12,
    4,
    8,
    8,
    9,
    5991,
    84,
    2,
    70,
    2,
    1,
    3,
    0,
    3,
    1,
    3,
    3,
    2,
    11,
    2,
    0,
    2,
    6,
    2,
    64,
    2,
    3,
    3,
    7,
    2,
    6,
    2,
    27,
    2,
    3,
    2,
    4,
    2,
    0,
    4,
    6,
    2,
    340,
    2,
    24,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    30,
    2,
    24,
    2,
    7,
    1845,
    129,
    15,
    6,
    55,
    50,
    49,
    61,
    147,
    44,
    11,
    6,
    17,
    0,
    322,
    29,
    19,
    43,
    485,
    27,
    229,
    29,
    3,
    0,
    208,
    30,
    2,
    2,
    2,
    1,
    2,
    6,
    3,
    4,
    10,
    1,
    225,
    6,
    2,
    3,
    2,
    1,
    2,
    14,
    2,
    196,
    60,
    67,
    8,
    0,
    1205,
    3,
    2,
    26,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    9,
    2,
    3,
    2,
    0,
    2,
    0,
    7,
    0,
    5,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    3,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    3,
    3,
    2,
    6,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    9,
    2,
    16,
    6,
    2,
    2,
    4,
    2,
    16,
    4421,
    42719,
    33,
    4382,
    2,
    5773,
    3,
    7472,
    16,
    621,
    2467,
    541,
    1507,
    4938,
    6,
    8489,
    39815,
    11327
];
// This file was generated. Do not modify manually!
var $6fb78ed28ed3b042$var$nonASCIIidentifierChars = "\u200c\u200d\xb7\u0300-\u036f\u0387\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7-\u05c9\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u07fd\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u0897-\u089f\u08ca-\u08e1\u08e3-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u09fe\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0afa-\u0aff\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b53-\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c00-\u0c04\u0c3c\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c81-\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0cf3\u0d00-\u0d03\u0d3b\u0d3c\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d81-\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0de6-\u0def\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0ebc\u0ec8-\u0ece\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u180f-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19d0-\u19da\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1ab0-\u1abd\u1abf-\u1af0\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf4\u1cf7-\u1cf9\u1dc0-\u1dff\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\u30fb\ua620-\ua629\ua66f\ua674-\ua67d\ua69e\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua82c\ua880\ua881\ua8b4-\ua8c5\ua8d0-\ua8d9\ua8e0-\ua8f1\ua8ff-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\ua9e5\ua9f0-\ua9f9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b-\uaa7d\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f\uff65";
// This file was generated. Do not modify manually!
var $6fb78ed28ed3b042$var$nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u052f\u0531-\u0556\u0558\u0559\u0560-\u0588\u058b\u058c\u05d0-\u05ea\u05ef-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0860-\u086a\u0870-\u0887\u0889-\u088f\u08a0-\u08c9\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u09fc\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0af9\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d\u0c58-\u0c5a\u0c5c\u0c5d\u0c60\u0c61\u0c80\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cdc-\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d04-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d54-\u0d56\u0d5f-\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u1711\u171f-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1878\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191e\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4c\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1c80-\u1c8a\u1c90-\u1cba\u1cbd-\u1cbf\u1ce9-\u1cec\u1cee-\u1cf3\u1cf5\u1cf6\u1cfa\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u208f-\u209f\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309b-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31bf\u31f0-\u31ff\u3400-\u4dbf\u4e00-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua69d\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua7dd\ua7e2\ua7f1-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua8fd\ua8fe\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\ua9e0-\ua9e4\ua9e6-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa7e-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab69\uab6c\uab6d\uab70-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
// These are a run-length and offset encoded representation of the
// >0xffff code points that are a valid part of identifiers. The
// offset starts at 0x10000, and each pair of numbers represents an
// offset to the next range, and then a size of the range.
// Reserved word lists for various dialects of the language
var $6fb78ed28ed3b042$var$reservedWords = {
    3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
    5: "class enum extends super const export import",
    6: "enum",
    strict: "implements interface let package private protected public static yield",
    strictBind: "eval arguments"
};
// And the keywords
var $6fb78ed28ed3b042$var$ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this";
var $6fb78ed28ed3b042$var$keywords$1 = {
    5: $6fb78ed28ed3b042$var$ecma5AndLessKeywords,
    "5module": $6fb78ed28ed3b042$var$ecma5AndLessKeywords + " export import",
    6: $6fb78ed28ed3b042$var$ecma5AndLessKeywords + " const class extends export import super"
};
var $6fb78ed28ed3b042$var$keywordRelationalOperator = /^in(stanceof)?$/;
// ## Character categories
var $6fb78ed28ed3b042$var$nonASCIIidentifierStart = new RegExp("[" + $6fb78ed28ed3b042$var$nonASCIIidentifierStartChars + "]");
var $6fb78ed28ed3b042$var$nonASCIIidentifier = new RegExp("[" + $6fb78ed28ed3b042$var$nonASCIIidentifierStartChars + $6fb78ed28ed3b042$var$nonASCIIidentifierChars + "]");
// This has a complexity linear to the value of the code. The
// assumption is that looking up astral identifier characters is
// rare.
function $6fb78ed28ed3b042$var$isInAstralSet(code, set) {
    var pos = 0x10000;
    for(var i = 0; i < set.length; i += 2){
        pos += set[i];
        if (pos > code) return false;
        pos += set[i + 1];
        if (pos >= code) return true;
    }
    return false;
}
// Test whether a given character code starts an identifier.
function $6fb78ed28ed3b042$export$56b48cc5d7560ffb(code, astral) {
    if (code < 65) return code === 36;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 0xffff) return code >= 0xaa && $6fb78ed28ed3b042$var$nonASCIIidentifierStart.test(String.fromCharCode(code));
    if (astral === false) return false;
    return $6fb78ed28ed3b042$var$isInAstralSet(code, $6fb78ed28ed3b042$var$astralIdentifierStartCodes);
}
// Test whether a given character is part of an identifier.
function $6fb78ed28ed3b042$export$332f4d7bee38db93(code, astral) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code <= 0xffff) return code >= 0xaa && $6fb78ed28ed3b042$var$nonASCIIidentifier.test(String.fromCharCode(code));
    if (astral === false) return false;
    return $6fb78ed28ed3b042$var$isInAstralSet(code, $6fb78ed28ed3b042$var$astralIdentifierStartCodes) || $6fb78ed28ed3b042$var$isInAstralSet(code, $6fb78ed28ed3b042$var$astralIdentifierCodes);
}
// ## Token types
// The assignment of fine-grained, information-carrying type objects
// allows the tokenizer to store the information it has about a
// token in a way that is very cheap for the parser to look up.
// All token type variables start with an underscore, to make them
// easy to recognize.
// The `beforeExpr` property is used to disambiguate between regular
// expressions and divisions. It is set on all token types that can
// be followed by an expression (thus, a slash after them would be a
// regular expression).
//
// The `startsExpr` property is used to check if the token ends a
// `yield` expression. It is set on all token types that either can
// directly start an expression (like a quotation mark) or can
// continue an expression (like the body of a string).
//
// `isLoop` marks a keyword as starting a loop, which is important
// to know when parsing a label, in order to allow or disallow
// continue jumps to that label.
var $6fb78ed28ed3b042$export$f435f793048e7a0f = function TokenType(label, conf) {
    if (conf === void 0) conf = {};
    this.label = label;
    this.keyword = conf.keyword;
    this.beforeExpr = !!conf.beforeExpr;
    this.startsExpr = !!conf.startsExpr;
    this.isLoop = !!conf.isLoop;
    this.isAssign = !!conf.isAssign;
    this.prefix = !!conf.prefix;
    this.postfix = !!conf.postfix;
    this.binop = conf.binop || null;
    this.updateContext = null;
};
function $6fb78ed28ed3b042$var$binop(name, prec) {
    return new $6fb78ed28ed3b042$export$f435f793048e7a0f(name, {
        beforeExpr: true,
        binop: prec
    });
}
var $6fb78ed28ed3b042$var$beforeExpr = {
    beforeExpr: true
}, $6fb78ed28ed3b042$var$startsExpr = {
    startsExpr: true
};
// Map keyword names to token types.
var $6fb78ed28ed3b042$export$d53f8326294b31d8 = {};
// Succinct definitions of keyword token types
function $6fb78ed28ed3b042$var$kw(name, options) {
    if (options === void 0) options = {};
    options.keyword = name;
    return $6fb78ed28ed3b042$export$d53f8326294b31d8[name] = new $6fb78ed28ed3b042$export$f435f793048e7a0f(name, options);
}
var $6fb78ed28ed3b042$export$b54c7ea7aabba5c8 = {
    num: new $6fb78ed28ed3b042$export$f435f793048e7a0f("num", $6fb78ed28ed3b042$var$startsExpr),
    regexp: new $6fb78ed28ed3b042$export$f435f793048e7a0f("regexp", $6fb78ed28ed3b042$var$startsExpr),
    string: new $6fb78ed28ed3b042$export$f435f793048e7a0f("string", $6fb78ed28ed3b042$var$startsExpr),
    name: new $6fb78ed28ed3b042$export$f435f793048e7a0f("name", $6fb78ed28ed3b042$var$startsExpr),
    privateId: new $6fb78ed28ed3b042$export$f435f793048e7a0f("privateId", $6fb78ed28ed3b042$var$startsExpr),
    eof: new $6fb78ed28ed3b042$export$f435f793048e7a0f("eof"),
    // Punctuation token types.
    bracketL: new $6fb78ed28ed3b042$export$f435f793048e7a0f("[", {
        beforeExpr: true,
        startsExpr: true
    }),
    bracketR: new $6fb78ed28ed3b042$export$f435f793048e7a0f("]"),
    braceL: new $6fb78ed28ed3b042$export$f435f793048e7a0f("{", {
        beforeExpr: true,
        startsExpr: true
    }),
    braceR: new $6fb78ed28ed3b042$export$f435f793048e7a0f("}"),
    parenL: new $6fb78ed28ed3b042$export$f435f793048e7a0f("(", {
        beforeExpr: true,
        startsExpr: true
    }),
    parenR: new $6fb78ed28ed3b042$export$f435f793048e7a0f(")"),
    comma: new $6fb78ed28ed3b042$export$f435f793048e7a0f(",", $6fb78ed28ed3b042$var$beforeExpr),
    semi: new $6fb78ed28ed3b042$export$f435f793048e7a0f(";", $6fb78ed28ed3b042$var$beforeExpr),
    colon: new $6fb78ed28ed3b042$export$f435f793048e7a0f(":", $6fb78ed28ed3b042$var$beforeExpr),
    dot: new $6fb78ed28ed3b042$export$f435f793048e7a0f("."),
    question: new $6fb78ed28ed3b042$export$f435f793048e7a0f("?", $6fb78ed28ed3b042$var$beforeExpr),
    questionDot: new $6fb78ed28ed3b042$export$f435f793048e7a0f("?."),
    arrow: new $6fb78ed28ed3b042$export$f435f793048e7a0f("=>", $6fb78ed28ed3b042$var$beforeExpr),
    template: new $6fb78ed28ed3b042$export$f435f793048e7a0f("template"),
    invalidTemplate: new $6fb78ed28ed3b042$export$f435f793048e7a0f("invalidTemplate"),
    ellipsis: new $6fb78ed28ed3b042$export$f435f793048e7a0f("...", $6fb78ed28ed3b042$var$beforeExpr),
    backQuote: new $6fb78ed28ed3b042$export$f435f793048e7a0f("`", $6fb78ed28ed3b042$var$startsExpr),
    dollarBraceL: new $6fb78ed28ed3b042$export$f435f793048e7a0f("${", {
        beforeExpr: true,
        startsExpr: true
    }),
    // Operators. These carry several kinds of properties to help the
    // parser use them properly (the presence of these properties is
    // what categorizes them as operators).
    //
    // `binop`, when present, specifies that this operator is a binary
    // operator, and will refer to its precedence.
    //
    // `prefix` and `postfix` mark the operator as a prefix or postfix
    // unary operator.
    //
    // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
    // binary operators with a very low precedence, that should result
    // in AssignmentExpression nodes.
    eq: new $6fb78ed28ed3b042$export$f435f793048e7a0f("=", {
        beforeExpr: true,
        isAssign: true
    }),
    assign: new $6fb78ed28ed3b042$export$f435f793048e7a0f("_=", {
        beforeExpr: true,
        isAssign: true
    }),
    incDec: new $6fb78ed28ed3b042$export$f435f793048e7a0f("++/--", {
        prefix: true,
        postfix: true,
        startsExpr: true
    }),
    prefix: new $6fb78ed28ed3b042$export$f435f793048e7a0f("!/~", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    logicalOR: $6fb78ed28ed3b042$var$binop("||", 1),
    logicalAND: $6fb78ed28ed3b042$var$binop("&&", 2),
    bitwiseOR: $6fb78ed28ed3b042$var$binop("|", 3),
    bitwiseXOR: $6fb78ed28ed3b042$var$binop("^", 4),
    bitwiseAND: $6fb78ed28ed3b042$var$binop("&", 5),
    equality: $6fb78ed28ed3b042$var$binop("==/!=/===/!==", 6),
    relational: $6fb78ed28ed3b042$var$binop("</>/<=/>=", 7),
    bitShift: $6fb78ed28ed3b042$var$binop("<</>>/>>>", 8),
    plusMin: new $6fb78ed28ed3b042$export$f435f793048e7a0f("+/-", {
        beforeExpr: true,
        binop: 9,
        prefix: true,
        startsExpr: true
    }),
    modulo: $6fb78ed28ed3b042$var$binop("%", 10),
    star: $6fb78ed28ed3b042$var$binop("*", 10),
    slash: $6fb78ed28ed3b042$var$binop("/", 10),
    starstar: new $6fb78ed28ed3b042$export$f435f793048e7a0f("**", {
        beforeExpr: true
    }),
    coalesce: $6fb78ed28ed3b042$var$binop("??", 1),
    // Keyword token types.
    _break: $6fb78ed28ed3b042$var$kw("break"),
    _case: $6fb78ed28ed3b042$var$kw("case", $6fb78ed28ed3b042$var$beforeExpr),
    _catch: $6fb78ed28ed3b042$var$kw("catch"),
    _continue: $6fb78ed28ed3b042$var$kw("continue"),
    _debugger: $6fb78ed28ed3b042$var$kw("debugger"),
    _default: $6fb78ed28ed3b042$var$kw("default", $6fb78ed28ed3b042$var$beforeExpr),
    _do: $6fb78ed28ed3b042$var$kw("do", {
        isLoop: true,
        beforeExpr: true
    }),
    _else: $6fb78ed28ed3b042$var$kw("else", $6fb78ed28ed3b042$var$beforeExpr),
    _finally: $6fb78ed28ed3b042$var$kw("finally"),
    _for: $6fb78ed28ed3b042$var$kw("for", {
        isLoop: true
    }),
    _function: $6fb78ed28ed3b042$var$kw("function", $6fb78ed28ed3b042$var$startsExpr),
    _if: $6fb78ed28ed3b042$var$kw("if"),
    _return: $6fb78ed28ed3b042$var$kw("return", $6fb78ed28ed3b042$var$beforeExpr),
    _switch: $6fb78ed28ed3b042$var$kw("switch"),
    _throw: $6fb78ed28ed3b042$var$kw("throw", $6fb78ed28ed3b042$var$beforeExpr),
    _try: $6fb78ed28ed3b042$var$kw("try"),
    _var: $6fb78ed28ed3b042$var$kw("var"),
    _const: $6fb78ed28ed3b042$var$kw("const"),
    _while: $6fb78ed28ed3b042$var$kw("while", {
        isLoop: true
    }),
    _with: $6fb78ed28ed3b042$var$kw("with"),
    _new: $6fb78ed28ed3b042$var$kw("new", {
        beforeExpr: true,
        startsExpr: true
    }),
    _this: $6fb78ed28ed3b042$var$kw("this", $6fb78ed28ed3b042$var$startsExpr),
    _super: $6fb78ed28ed3b042$var$kw("super", $6fb78ed28ed3b042$var$startsExpr),
    _class: $6fb78ed28ed3b042$var$kw("class", $6fb78ed28ed3b042$var$startsExpr),
    _extends: $6fb78ed28ed3b042$var$kw("extends", $6fb78ed28ed3b042$var$beforeExpr),
    _export: $6fb78ed28ed3b042$var$kw("export"),
    _import: $6fb78ed28ed3b042$var$kw("import", $6fb78ed28ed3b042$var$startsExpr),
    _null: $6fb78ed28ed3b042$var$kw("null", $6fb78ed28ed3b042$var$startsExpr),
    _true: $6fb78ed28ed3b042$var$kw("true", $6fb78ed28ed3b042$var$startsExpr),
    _false: $6fb78ed28ed3b042$var$kw("false", $6fb78ed28ed3b042$var$startsExpr),
    _in: $6fb78ed28ed3b042$var$kw("in", {
        beforeExpr: true,
        binop: 7
    }),
    _instanceof: $6fb78ed28ed3b042$var$kw("instanceof", {
        beforeExpr: true,
        binop: 7
    }),
    _typeof: $6fb78ed28ed3b042$var$kw("typeof", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _void: $6fb78ed28ed3b042$var$kw("void", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    }),
    _delete: $6fb78ed28ed3b042$var$kw("delete", {
        beforeExpr: true,
        prefix: true,
        startsExpr: true
    })
};
// Matches a whole line break (where CRLF is considered a single
// line break). Used to count lines.
var $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6 = /\r\n?|\n|\u2028|\u2029/;
var $6fb78ed28ed3b042$export$866e20207bbc41f2 = new RegExp($6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.source, "g");
function $6fb78ed28ed3b042$export$2c19a3e3b4008fff(code) {
    return code === 10 || code === 13 || code === 0x2028 || code === 0x2029;
}
function $6fb78ed28ed3b042$var$nextLineBreak(code, from, end) {
    if (end === void 0) end = code.length;
    for(var i = from; i < end; i++){
        var next = code.charCodeAt(i);
        if ($6fb78ed28ed3b042$export$2c19a3e3b4008fff(next)) return i < end - 1 && next === 13 && code.charCodeAt(i + 1) === 10 ? i + 2 : i + 1;
    }
    return -1;
}
var $6fb78ed28ed3b042$export$268622f0f1cbc82b = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
var $6fb78ed28ed3b042$var$skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
var $6fb78ed28ed3b042$var$ref = Object.prototype;
var $6fb78ed28ed3b042$var$hasOwnProperty = $6fb78ed28ed3b042$var$ref.hasOwnProperty;
var $6fb78ed28ed3b042$var$toString = $6fb78ed28ed3b042$var$ref.toString;
var $6fb78ed28ed3b042$var$hasOwn = Object.hasOwn || function(obj, propName) {
    return $6fb78ed28ed3b042$var$hasOwnProperty.call(obj, propName);
};
var $6fb78ed28ed3b042$var$isArray = Array.isArray || function(obj) {
    return $6fb78ed28ed3b042$var$toString.call(obj) === "[object Array]";
};
var $6fb78ed28ed3b042$var$regexpCache = Object.create(null);
function $6fb78ed28ed3b042$var$wordsRegexp(words) {
    return $6fb78ed28ed3b042$var$regexpCache[words] || ($6fb78ed28ed3b042$var$regexpCache[words] = new RegExp("^(?:" + words.replace(/ /g, "|") + ")$"));
}
function $6fb78ed28ed3b042$var$codePointToString(code) {
    // UTF-16 Decoding
    if (code <= 0xFFFF) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xD800, (code & 1023) + 0xDC00);
}
var $6fb78ed28ed3b042$var$loneSurrogate = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/;
// These are used when `options.locations` is on, for the
// `startLoc` and `endLoc` properties.
var $6fb78ed28ed3b042$export$13807d9ee5a34a42 = function Position(line, col) {
    this.line = line;
    this.column = col;
};
$6fb78ed28ed3b042$export$13807d9ee5a34a42.prototype.offset = function offset(n) {
    return new $6fb78ed28ed3b042$export$13807d9ee5a34a42(this.line, this.column + n);
};
var $6fb78ed28ed3b042$export$7387db7caf96fcdb = function SourceLocation(p, start, end) {
    this.start = start;
    this.end = end;
    if (p.sourceFile !== null) this.source = p.sourceFile;
};
// The `getLineInfo` function is mostly useful when the
// `locations` option is off (for performance reasons) and you
// want to find the line/column position for a given character
// offset. `input` should be the code string that the offset refers
// into.
function $6fb78ed28ed3b042$export$7af82191547c5ff7(input, offset) {
    for(var line = 1, cur = 0;;){
        var nextBreak = $6fb78ed28ed3b042$var$nextLineBreak(input, cur, offset);
        if (nextBreak < 0) return new $6fb78ed28ed3b042$export$13807d9ee5a34a42(line, offset - cur);
        ++line;
        cur = nextBreak;
    }
}
// A second argument must be given to configure the parser process.
// These options are recognized (only `ecmaVersion` is required):
var $6fb78ed28ed3b042$export$ba43bf67f3d48107 = {
    // `ecmaVersion` indicates the ECMAScript version to parse. Must be
    // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
    // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
    // (the latest version the library supports). This influences
    // support for strict mode, the set of reserved words, and support
    // for new syntax features.
    ecmaVersion: null,
    // `sourceType` indicates the mode the code should be parsed in.
    // Can be either `"script"`, `"module"` or `"commonjs"`. This influences global
    // strict mode and parsing of `import` and `export` declarations.
    sourceType: "script",
    // When set to true, enable strict parsing mode even if `sourceType`
    // is `"script"`.
    strict: false,
    // `onInsertedSemicolon` can be a callback that will be called when
    // a semicolon is automatically inserted. It will be passed the
    // position of the inserted semicolon as an offset, and if
    // `locations` is enabled, it is given the location as a `{line,
    // column}` object as second argument.
    onInsertedSemicolon: null,
    // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
    // trailing commas.
    onTrailingComma: null,
    // By default, reserved words are only enforced if ecmaVersion >= 5.
    // Set `allowReserved` to a boolean value to explicitly turn this on
    // an off. When this option has the value "never", reserved words
    // and keywords can also not be used as property names.
    allowReserved: null,
    // When enabled, a return at the top level is not considered an
    // error.
    allowReturnOutsideFunction: false,
    // When enabled, import/export statements are not constrained to
    // appearing at the top of the program, and an import.meta expression
    // in a script isn't considered an error.
    allowImportExportEverywhere: false,
    // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
    // When enabled, await identifiers are allowed to appear at the top-level scope,
    // but they are still not allowed in non-async functions.
    allowAwaitOutsideFunction: null,
    // When enabled, super identifiers are not constrained to
    // appearing in methods and do not raise an error when they appear elsewhere.
    allowSuperOutsideMethod: null,
    // When enabled, hashbang directive in the beginning of file is
    // allowed and treated as a line comment. Enabled by default when
    // `ecmaVersion` >= 2023.
    allowHashBang: false,
    // By default, the parser will verify that private properties are
    // only used in places where they are valid and have been declared.
    // Set this to false to turn such checks off.
    checkPrivateFields: true,
    // When `locations` is on, `loc` properties holding objects with
    // `start` and `end` properties in `{line, column}` form (with
    // line being 1-based and column 0-based) will be attached to the
    // nodes.
    locations: false,
    // Pass an optional `{line, column}` object to use for the start of
    // the parse. This is mostly useful when using `parseExpressionAt`
    // with `locations: true`, to prevent the parser from having to
    // determine the line position at the start position.
    startLocation: null,
    // A function can be passed as `onToken` option, which will
    // cause Acorn to call that function with object in the same
    // format as tokens returned from `tokenizer().getToken()`. Note
    // that you are not allowed to call the parser from the
    // callback—that will corrupt its internal state.
    onToken: null,
    // A function can be passed as `onComment` option, which will
    // cause Acorn to call that function with `(block, text, start,
    // end)` parameters whenever a comment is skipped. `block` is a
    // boolean indicating whether this is a block (`/* */`) comment,
    // `text` is the content of the comment, and `start` and `end` are
    // character offsets that denote the start and end of the comment.
    // When the `locations` option is on, two more parameters are
    // passed, the full `{line, column}` locations of the start and
    // end of the comments. Note that you are not allowed to call the
    // parser from the callback—that will corrupt its internal state.
    // When this option has an array as value, objects representing the
    // comments are pushed to it.
    onComment: null,
    // Nodes have their start and end characters offsets recorded in
    // `start` and `end` properties (directly on the node, rather than
    // the `loc` object, which holds line/column data. To also add a
    // [semi-standardized][range] `range` property holding a `[start,
    // end]` array with the same numbers, set the `ranges` option to
    // `true`.
    //
    // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
    ranges: false,
    // It is possible to parse multiple files into a single AST by
    // passing the tree produced by parsing the first file as
    // `program` option in subsequent parses. This will add the
    // toplevel forms of the parsed file to the `Program` (top) node
    // of an existing parse tree.
    program: null,
    // When `locations` is on, you can pass this to record the source
    // file in every node's `loc` object.
    sourceFile: null,
    // This value, if given, is stored in every node, whether
    // `locations` is on or off.
    directSourceFile: null,
    // When enabled, parenthesized expressions are represented by
    // (non-standard) ParenthesizedExpression nodes
    preserveParens: false
};
// Interpret and default an options object
var $6fb78ed28ed3b042$var$warnedAboutEcmaVersion = false;
function $6fb78ed28ed3b042$var$getOptions(opts) {
    var options = {};
    for(var opt in $6fb78ed28ed3b042$export$ba43bf67f3d48107)options[opt] = opts && $6fb78ed28ed3b042$var$hasOwn(opts, opt) ? opts[opt] : $6fb78ed28ed3b042$export$ba43bf67f3d48107[opt];
    if (options.ecmaVersion === "latest") options.ecmaVersion = 1e8;
    else if (options.ecmaVersion == null) {
        if (!$6fb78ed28ed3b042$var$warnedAboutEcmaVersion && typeof console === "object" && console.warn) {
            $6fb78ed28ed3b042$var$warnedAboutEcmaVersion = true;
            console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.");
        }
        options.ecmaVersion = 11;
    } else if (options.ecmaVersion >= 2015) options.ecmaVersion -= 2009;
    if (options.allowReserved == null) options.allowReserved = options.ecmaVersion < 5;
    if (!opts || opts.allowHashBang == null) options.allowHashBang = options.ecmaVersion >= 14;
    if ($6fb78ed28ed3b042$var$isArray(options.onToken)) {
        var tokens = options.onToken;
        options.onToken = function(token) {
            return tokens.push(token);
        };
    }
    if ($6fb78ed28ed3b042$var$isArray(options.onComment)) options.onComment = $6fb78ed28ed3b042$var$pushComment(options, options.onComment);
    if (options.sourceType === "commonjs" && options.allowAwaitOutsideFunction) throw new Error("Cannot use allowAwaitOutsideFunction with sourceType: commonjs");
    return options;
}
function $6fb78ed28ed3b042$var$pushComment(options, array) {
    return function(block, text, start, end, startLoc, endLoc) {
        var comment = {
            type: block ? "Block" : "Line",
            value: text,
            start: start,
            end: end
        };
        if (options.locations) comment.loc = new $6fb78ed28ed3b042$export$7387db7caf96fcdb(this, startLoc, endLoc);
        if (options.ranges) comment.range = [
            start,
            end
        ];
        array.push(comment);
    };
}
// Each scope gets a bitset that may contain these flags
var $6fb78ed28ed3b042$var$SCOPE_TOP = 1, $6fb78ed28ed3b042$var$SCOPE_FUNCTION = 2, $6fb78ed28ed3b042$var$SCOPE_ASYNC = 4, $6fb78ed28ed3b042$var$SCOPE_GENERATOR = 8, $6fb78ed28ed3b042$var$SCOPE_ARROW = 16, $6fb78ed28ed3b042$var$SCOPE_SIMPLE_CATCH = 32, $6fb78ed28ed3b042$var$SCOPE_SUPER = 64, $6fb78ed28ed3b042$var$SCOPE_DIRECT_SUPER = 128, $6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK = 256, $6fb78ed28ed3b042$var$SCOPE_CLASS_FIELD_INIT = 512, $6fb78ed28ed3b042$var$SCOPE_SWITCH = 1024, $6fb78ed28ed3b042$var$SCOPE_VAR = $6fb78ed28ed3b042$var$SCOPE_TOP | $6fb78ed28ed3b042$var$SCOPE_FUNCTION | $6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK;
function $6fb78ed28ed3b042$var$functionFlags(async, generator) {
    return $6fb78ed28ed3b042$var$SCOPE_FUNCTION | (async ? $6fb78ed28ed3b042$var$SCOPE_ASYNC : 0) | (generator ? $6fb78ed28ed3b042$var$SCOPE_GENERATOR : 0);
}
// Used in checkLVal* and declareName to determine the type of a binding
var $6fb78ed28ed3b042$var$BIND_NONE = 0, $6fb78ed28ed3b042$var$BIND_VAR = 1, $6fb78ed28ed3b042$var$BIND_LEXICAL = 2, $6fb78ed28ed3b042$var$BIND_FUNCTION = 3, $6fb78ed28ed3b042$var$BIND_SIMPLE_CATCH = 4, $6fb78ed28ed3b042$var$BIND_OUTSIDE = 5; // Special case for function names as bound inside the function
var $6fb78ed28ed3b042$export$7acfa6ed01010e37 = function Parser(options, input, startPos) {
    this.options = options = $6fb78ed28ed3b042$var$getOptions(options);
    this.sourceFile = options.sourceFile;
    this.keywords = $6fb78ed28ed3b042$var$wordsRegexp($6fb78ed28ed3b042$var$keywords$1[options.ecmaVersion >= 6 ? 6 : options.sourceType === "module" ? "5module" : 5]);
    var reserved = "";
    if (options.allowReserved !== true) {
        reserved = $6fb78ed28ed3b042$var$reservedWords[options.ecmaVersion >= 6 ? 6 : options.ecmaVersion === 5 ? 5 : 3];
        if (options.sourceType === "module") reserved += " await";
    }
    this.reservedWords = $6fb78ed28ed3b042$var$wordsRegexp(reserved);
    var reservedStrict = (reserved ? reserved + " " : "") + $6fb78ed28ed3b042$var$reservedWords.strict;
    this.reservedWordsStrict = $6fb78ed28ed3b042$var$wordsRegexp(reservedStrict);
    this.reservedWordsStrictBind = $6fb78ed28ed3b042$var$wordsRegexp(reservedStrict + " " + $6fb78ed28ed3b042$var$reservedWords.strictBind);
    this.input = String(input);
    // Used to signal to callers of `readWord1` whether the word
    // contained any escape sequences. This is needed because words with
    // escape sequences must not be interpreted as keywords.
    this.containsEsc = false;
    // Set up token state
    // The current position of the tokenizer in the input.
    this.pos = startPos || 0;
    this.curLine = 1;
    if (options.startLocation) {
        this.lineStart = this.pos - options.startLocation.column;
        this.curLine = options.startLocation.line;
    } else if (startPos) {
        this.lineStart = this.input.lastIndexOf("\n", startPos - 1) + 1;
        if (this.options.locations) this.curLine = this.input.slice(0, this.lineStart).split($6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6).length;
    } else this.lineStart = 0;
    // Properties of the current token:
    // Its type
    this.type = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eof;
    // For tokens that include more information than their type, the value
    this.value = null;
    // Its start and end offset
    this.start = this.end = this.pos;
    // And, if locations are used, the {line, column} object
    // corresponding to those offsets
    this.startLoc = this.endLoc = this.curPosition();
    // Position information for the previous token
    this.lastTokEndLoc = this.lastTokStartLoc = null;
    this.lastTokStart = this.lastTokEnd = this.pos;
    // The context stack is used to superficially track syntactic
    // context to predict whether a regular expression is allowed in a
    // given position.
    this.context = this.initialContext();
    this.exprAllowed = true;
    // Figure out if it's a module code.
    this.inModule = options.sourceType === "module";
    this.strict = this.inModule || options.strict === true || this.strictDirective(this.pos);
    // Used to signify the start of a potential arrow function
    this.potentialArrowAt = -1;
    this.potentialArrowInForAwait = false;
    // Positions to delayed-check that yield/await does not exist in default parameters.
    this.yieldPos = this.awaitPos = this.awaitIdentPos = 0;
    // Labels in scope.
    this.labels = [];
    // Thus-far undefined exports.
    this.undefinedExports = Object.create(null);
    // If enabled, skip leading hashbang line.
    if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === "#!") this.skipLineComment(2);
    // Scope tracking for duplicate variable names (see scope.js)
    this.scopeStack = [];
    this.enterScope(this.options.sourceType === "commonjs" ? $6fb78ed28ed3b042$var$SCOPE_FUNCTION : $6fb78ed28ed3b042$var$SCOPE_TOP);
    // For RegExp validation
    this.regexpState = null;
    // The stack of private names.
    // Each element has two properties: 'declared' and 'used'.
    // When it exited from the outermost class definition, all used private names must be declared.
    this.privateNameStack = [];
};
var $6fb78ed28ed3b042$var$prototypeAccessors = {
    inFunction: {
        configurable: true
    },
    inGenerator: {
        configurable: true
    },
    inAsync: {
        configurable: true
    },
    canAwait: {
        configurable: true
    },
    allowReturn: {
        configurable: true
    },
    allowSuper: {
        configurable: true
    },
    allowDirectSuper: {
        configurable: true
    },
    treatFunctionsAsVar: {
        configurable: true
    },
    allowNewDotTarget: {
        configurable: true
    },
    allowUsing: {
        configurable: true
    },
    inClassStaticBlock: {
        configurable: true
    }
};
$6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype.parse = function parse() {
    var this$1$1 = this;
    var node = this.options.program || this.startNode();
    this.nextToken();
    return this.catchStackOverflow(function() {
        return this$1$1.parseTopLevel(node);
    });
};
$6fb78ed28ed3b042$var$prototypeAccessors.inFunction.get = function() {
    return (this.currentVarScope().flags & $6fb78ed28ed3b042$var$SCOPE_FUNCTION) > 0;
};
$6fb78ed28ed3b042$var$prototypeAccessors.inGenerator.get = function() {
    return (this.currentVarScope().flags & $6fb78ed28ed3b042$var$SCOPE_GENERATOR) > 0;
};
$6fb78ed28ed3b042$var$prototypeAccessors.inAsync.get = function() {
    return (this.currentVarScope().flags & $6fb78ed28ed3b042$var$SCOPE_ASYNC) > 0;
};
$6fb78ed28ed3b042$var$prototypeAccessors.canAwait.get = function() {
    for(var i = this.scopeStack.length - 1; i >= 0; i--){
        var ref = this.scopeStack[i];
        var flags = ref.flags;
        if (flags & ($6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK | $6fb78ed28ed3b042$var$SCOPE_CLASS_FIELD_INIT)) return false;
        if (flags & $6fb78ed28ed3b042$var$SCOPE_FUNCTION) return (flags & $6fb78ed28ed3b042$var$SCOPE_ASYNC) > 0;
    }
    return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
$6fb78ed28ed3b042$var$prototypeAccessors.allowReturn.get = function() {
    if (this.inFunction) return true;
    if (this.options.allowReturnOutsideFunction && this.currentVarScope().flags & $6fb78ed28ed3b042$var$SCOPE_TOP) return true;
    return false;
};
$6fb78ed28ed3b042$var$prototypeAccessors.allowSuper.get = function() {
    var ref = this.currentThisScope();
    var flags = ref.flags;
    return (flags & $6fb78ed28ed3b042$var$SCOPE_SUPER) > 0 || this.options.allowSuperOutsideMethod;
};
$6fb78ed28ed3b042$var$prototypeAccessors.allowDirectSuper.get = function() {
    return (this.currentThisScope().flags & $6fb78ed28ed3b042$var$SCOPE_DIRECT_SUPER) > 0;
};
$6fb78ed28ed3b042$var$prototypeAccessors.treatFunctionsAsVar.get = function() {
    return this.treatFunctionsAsVarInScope(this.currentScope());
};
$6fb78ed28ed3b042$var$prototypeAccessors.allowNewDotTarget.get = function() {
    for(var i = this.scopeStack.length - 1; i >= 0; i--){
        var ref = this.scopeStack[i];
        var flags = ref.flags;
        if (flags & ($6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK | $6fb78ed28ed3b042$var$SCOPE_CLASS_FIELD_INIT) || flags & $6fb78ed28ed3b042$var$SCOPE_FUNCTION && !(flags & $6fb78ed28ed3b042$var$SCOPE_ARROW)) return true;
    }
    return false;
};
$6fb78ed28ed3b042$var$prototypeAccessors.allowUsing.get = function() {
    var ref = this.currentScope();
    var flags = ref.flags;
    if (flags & $6fb78ed28ed3b042$var$SCOPE_SWITCH) return false;
    if (!this.inModule && flags & $6fb78ed28ed3b042$var$SCOPE_TOP) return false;
    return true;
};
$6fb78ed28ed3b042$var$prototypeAccessors.inClassStaticBlock.get = function() {
    return (this.currentVarScope().flags & $6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK) > 0;
};
$6fb78ed28ed3b042$export$7acfa6ed01010e37.extend = function extend() {
    var plugins = [], len = arguments.length;
    while(len--)plugins[len] = arguments[len];
    var cls = this;
    for(var i = 0; i < plugins.length; i++)cls = plugins[i](cls);
    return cls;
};
$6fb78ed28ed3b042$export$7acfa6ed01010e37.parse = function parse(input, options) {
    return new this(options, input).parse();
};
$6fb78ed28ed3b042$export$7acfa6ed01010e37.parseExpressionAt = function parseExpressionAt(input, pos, options) {
    var parser = new this(options, input, pos);
    parser.nextToken();
    return parser.parseExpression();
};
$6fb78ed28ed3b042$export$7acfa6ed01010e37.tokenizer = function tokenizer(input, options) {
    return new this(options, input);
};
Object.defineProperties($6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype, $6fb78ed28ed3b042$var$prototypeAccessors);
var $6fb78ed28ed3b042$var$pp$9 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
// ## Parser utilities
var $6fb78ed28ed3b042$var$literal = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
$6fb78ed28ed3b042$var$pp$9.strictDirective = function(start) {
    if (this.options.ecmaVersion < 5) return false;
    for(;;){
        // Try to find string literal.
        $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = start;
        start += $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input)[0].length;
        var match = $6fb78ed28ed3b042$var$literal.exec(this.input.slice(start));
        if (!match) return false;
        if ((match[1] || match[2]) === "use strict") {
            $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = start + match[0].length;
            var spaceAfter = $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input), end = spaceAfter.index + spaceAfter[0].length;
            var next = this.input.charAt(end);
            return next === ";" || next === "}" || $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(spaceAfter[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(next) || next === "!" && this.input.charAt(end + 1) === "=" || next === "i" && $6fb78ed28ed3b042$var$keywordOpAt(this, end));
        }
        start += match[0].length;
        // Skip semicolon, if any.
        $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = start;
        start += $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input)[0].length;
        if (this.input[start] === ";") start++;
    }
};
// Scan for `in` or `instanceof` at the given position, knowing that
// there's an `i` there.
function $6fb78ed28ed3b042$var$keywordOpAt(parser, pos) {
    var end = pos + 1, stop = Math.min(parser.input.length, pos + 11);
    while(end < stop){
        var ch = parser.fullCharCodeAt(end);
        if (!$6fb78ed28ed3b042$export$332f4d7bee38db93(ch, true)) break;
        end += ch <= 0xffff ? 1 : 2;
    }
    return end === pos + 2 && parser.input.slice(pos, end) === "in" || end === pos + 10 && parser.input.slice(pos, end) === "instanceof";
}
// Predicate that tests whether the next token is of the given
// type, and if yes, consumes it as a side effect.
$6fb78ed28ed3b042$var$pp$9.eat = function(type) {
    if (this.type === type) {
        this.next();
        return true;
    } else return false;
};
// Tests whether parsed token is a contextual keyword.
$6fb78ed28ed3b042$var$pp$9.isContextual = function(name) {
    return this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name && this.value === name && !this.containsEsc;
};
// Consumes contextual keyword if possible.
$6fb78ed28ed3b042$var$pp$9.eatContextual = function(name) {
    if (!this.isContextual(name)) return false;
    this.next();
    return true;
};
$6fb78ed28ed3b042$var$pp$9.catchStackOverflow = function(f) {
    try {
        return f();
    } catch (e) {
        if (e instanceof Error && (/\bstack\b.*\b(exceeded|overflow)\b/i.test(e.message) || /\btoo much recursion\b/i.test(e.message))) this.raise(this.start, "Not enough stack space to parse input");
        else throw e;
    }
};
// Asserts that following token is given contextual keyword.
$6fb78ed28ed3b042$var$pp$9.expectContextual = function(name) {
    if (!this.eatContextual(name)) this.unexpected();
};
// Test whether a semicolon can be inserted at the current position.
$6fb78ed28ed3b042$var$pp$9.canInsertSemicolon = function() {
    return this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eof || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR || $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start));
};
$6fb78ed28ed3b042$var$pp$9.insertSemicolon = function() {
    if (this.canInsertSemicolon()) {
        if (this.options.onInsertedSemicolon) this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc);
        return true;
    }
};
// Consume a semicolon, or, failing that, see if we are allowed to
// pretend that there is a semicolon at this position.
$6fb78ed28ed3b042$var$pp$9.semicolon = function() {
    if (!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi) && !this.insertSemicolon()) this.unexpected();
};
$6fb78ed28ed3b042$var$pp$9.afterTrailingComma = function(tokType, notNext) {
    if (this.type === tokType) {
        if (this.options.onTrailingComma) this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc);
        if (!notNext) this.next();
        return true;
    }
};
// Expect a token of a given type. If found, consume it, otherwise,
// raise an unexpected token error.
$6fb78ed28ed3b042$var$pp$9.expect = function(type) {
    this.eat(type) || this.unexpected();
};
// Raise an unexpected token error.
$6fb78ed28ed3b042$var$pp$9.unexpected = function(pos) {
    this.raise(pos != null ? pos : this.start, "Unexpected token");
};
var $6fb78ed28ed3b042$var$DestructuringErrors = function DestructuringErrors() {
    this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
$6fb78ed28ed3b042$var$pp$9.checkPatternErrors = function(refDestructuringErrors, isAssign) {
    if (!refDestructuringErrors) return;
    if (refDestructuringErrors.trailingComma > -1) this.raiseRecoverable(refDestructuringErrors.trailingComma, "Comma is not permitted after the rest element");
    var parens = isAssign ? refDestructuringErrors.parenthesizedAssign : refDestructuringErrors.parenthesizedBind;
    if (parens > -1) this.raiseRecoverable(parens, isAssign ? "Assigning to rvalue" : "Parenthesized pattern");
};
$6fb78ed28ed3b042$var$pp$9.checkExpressionErrors = function(refDestructuringErrors, andThrow) {
    if (!refDestructuringErrors) return false;
    var shorthandAssign = refDestructuringErrors.shorthandAssign;
    var doubleProto = refDestructuringErrors.doubleProto;
    if (!andThrow) return shorthandAssign >= 0 || doubleProto >= 0;
    if (shorthandAssign >= 0) this.raise(shorthandAssign, "Shorthand property assignments are valid only in destructuring patterns");
    if (doubleProto >= 0) this.raiseRecoverable(doubleProto, "Redefinition of __proto__ property");
};
$6fb78ed28ed3b042$var$pp$9.checkYieldAwaitInDefaultParams = function() {
    if (this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos)) this.raise(this.yieldPos, "Yield expression cannot be a default value");
    if (this.awaitPos) this.raise(this.awaitPos, "Await expression cannot be a default value");
};
$6fb78ed28ed3b042$var$pp$9.isSimpleAssignTarget = function(expr) {
    if (expr.type === "ParenthesizedExpression") return this.isSimpleAssignTarget(expr.expression);
    return expr.type === "Identifier" || expr.type === "MemberExpression";
};
var $6fb78ed28ed3b042$var$pp$8 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
// ### Statement parsing
// Parse a program. Initializes the parser, reads any number of
// statements, and wraps them in a Program node.  Optionally takes a
// `program` argument.  If present, the statements will be appended
// to its body instead of creating a new node.
$6fb78ed28ed3b042$var$pp$8.parseTopLevel = function(node) {
    var exports$1 = Object.create(null);
    if (!node.body) node.body = [];
    while(this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eof){
        var stmt = this.parseStatement(null, true, exports$1);
        node.body.push(stmt);
    }
    if (this.inModule) for(var i = 0, list = Object.keys(this.undefinedExports); i < list.length; i += 1){
        var name = list[i];
        this.raiseRecoverable(this.undefinedExports[name].start, "Export '" + name + "' is not defined");
    }
    this.adaptDirectivePrologue(node.body);
    this.next();
    node.sourceType = this.options.sourceType === "commonjs" ? "script" : this.options.sourceType;
    return this.finishNode(node, "Program");
};
var $6fb78ed28ed3b042$var$loopLabel = {
    kind: "loop"
}, $6fb78ed28ed3b042$var$switchLabel = {
    kind: "switch"
};
$6fb78ed28ed3b042$var$pp$8.isLet = function(context) {
    if (this.options.ecmaVersion < 6 || !this.isContextual("let")) return false;
    $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, nextCh = this.fullCharCodeAt(next);
    // For ambiguous cases, determine if a LexicalDeclaration (or only a
    // Statement) is allowed here. If context is not empty then only a Statement
    // is allowed. However, `let [` is an explicit negative lookahead for
    // ExpressionStatement, so special-case it first.
    if (nextCh === 91 || nextCh === 92) return true;
     // '[', '\'
    if (context) return false;
    if (nextCh === 123) return true;
     // '{'
    if ($6fb78ed28ed3b042$export$56b48cc5d7560ffb(nextCh)) {
        var start = next;
        do next += nextCh <= 0xffff ? 1 : 2;
        while ($6fb78ed28ed3b042$export$332f4d7bee38db93(nextCh = this.fullCharCodeAt(next)));
        if (nextCh === 92) return true;
        var ident = this.input.slice(start, next);
        if (!$6fb78ed28ed3b042$var$keywordRelationalOperator.test(ident)) return true;
    }
    return false;
};
// check 'async [no LineTerminator here] function'
// - 'async /*foo*/ function' is OK.
// - 'async /*\n*/ function' is invalid.
$6fb78ed28ed3b042$var$pp$8.isAsyncFunction = function() {
    if (this.options.ecmaVersion < 8 || !this.isContextual("async")) return false;
    $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, after;
    return !$6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.pos, next)) && this.input.slice(next, next + 8) === "function" && (next + 8 === this.input.length || !($6fb78ed28ed3b042$export$332f4d7bee38db93(after = this.fullCharCodeAt(next + 8)) || after === 92 /* '\' */ ));
};
$6fb78ed28ed3b042$var$pp$8.isUsingKeyword = function(isAwaitUsing, isFor) {
    if (this.options.ecmaVersion < 17 || !this.isContextual(isAwaitUsing ? "await" : "using")) return false;
    $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = this.pos;
    var skip = $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length;
    if ($6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.pos, next))) return false;
    if (isAwaitUsing) {
        var usingEndPos = next + 5 /* using */ , after;
        if (this.input.slice(next, usingEndPos) !== "using" || usingEndPos === this.input.length || $6fb78ed28ed3b042$export$332f4d7bee38db93(after = this.fullCharCodeAt(usingEndPos)) || after === 92 /* '\' */ ) return false;
        $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = usingEndPos;
        var skipAfterUsing = $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input);
        next = usingEndPos + skipAfterUsing[0].length;
        if (skipAfterUsing && $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(usingEndPos, next))) return false;
    }
    var ch = this.fullCharCodeAt(next);
    if (!$6fb78ed28ed3b042$export$56b48cc5d7560ffb(ch) && ch !== 92 /* '\' */ ) return false;
    var idStart = next;
    do next += ch <= 0xffff ? 1 : 2;
    while ($6fb78ed28ed3b042$export$332f4d7bee38db93(ch = this.fullCharCodeAt(next)));
    if (ch === 92) return true;
    var id = this.input.slice(idStart, next);
    if ($6fb78ed28ed3b042$var$keywordRelationalOperator.test(id)) return false;
    if (isFor && !isAwaitUsing && id === "of") {
        // Look ahead for using declaration with initializer, i.e., `for (using of = ...)`
        $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = next;
        var skipAfterOf = $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input);
        next = next + skipAfterOf[0].length;
        if (this.input.charCodeAt(next) !== 61 /* '=' */  || // Check for ==, === and => operators
        (ch = this.input.charCodeAt(next + 1)) === 61 /* '=' */  || ch === 62 /* '>' */ ) return false;
    }
    return true;
};
$6fb78ed28ed3b042$var$pp$8.isAwaitUsing = function(isFor) {
    return this.isUsingKeyword(true, isFor);
};
$6fb78ed28ed3b042$var$pp$8.isUsing = function(isFor) {
    return this.isUsingKeyword(false, isFor);
};
// Parse a single statement.
//
// If expecting a statement and finding a slash operator, parse a
// regular expression literal. This is to handle cases like
// `if (foo) /blah/.exec(foo)`, where looking at the previous token
// does not help.
$6fb78ed28ed3b042$var$pp$8.parseStatement = function(context, topLevel, exports$1) {
    var starttype = this.type, node = this.startNode(), kind;
    if (this.isLet(context)) {
        starttype = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._var;
        kind = "let";
    }
    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.
    switch(starttype){
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._break:
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._continue:
            return this.parseBreakContinueStatement(node, starttype.keyword);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._debugger:
            return this.parseDebuggerStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._do:
            return this.parseDoStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._for:
            return this.parseForStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._function:
            // Function as sole body of either an if statement or a labeled statement
            // works, but not when it is part of a labeled statement that is the sole
            // body of an if statement.
            if (context && (this.strict || context !== "if" && context !== "label") && this.options.ecmaVersion >= 6) this.unexpected();
            return this.parseFunctionStatement(node, false, !context);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._class:
            if (context) this.unexpected();
            return this.parseClass(node, true);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._if:
            return this.parseIfStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._return:
            return this.parseReturnStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._switch:
            return this.parseSwitchStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._throw:
            return this.parseThrowStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._try:
            return this.parseTryStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._const:
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._var:
            kind = kind || this.value;
            if (context && kind !== "var") this.unexpected();
            return this.parseVarStatement(node, kind);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._while:
            return this.parseWhileStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._with:
            return this.parseWithStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL:
            return this.parseBlock(true, node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi:
            return this.parseEmptyStatement(node);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._export:
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._import:
            if (this.options.ecmaVersion > 10 && starttype === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._import) {
                $6fb78ed28ed3b042$var$skipWhiteSpace.lastIndex = this.pos;
                var skip = $6fb78ed28ed3b042$var$skipWhiteSpace.exec(this.input);
                var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next);
                if (nextCh === 40 || nextCh === 46) return this.parseExpressionStatement(node, this.parseExpression());
            }
            if (!this.options.allowImportExportEverywhere) {
                if (!topLevel) this.raise(this.start, "'import' and 'export' may only appear at the top level");
                if (!this.inModule) this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'");
            }
            return starttype === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._import ? this.parseImport(node) : this.parseExport(node, exports$1);
        // If the statement does not start with a statement keyword or a
        // brace, it's an ExpressionStatement or LabeledStatement. We
        // simply start parsing an expression, and afterwards, if the
        // next token is a colon and the expression was a simple
        // Identifier node, we switch to interpreting it as a label.
        default:
            if (this.isAsyncFunction()) {
                if (context) this.unexpected();
                this.next();
                return this.parseFunctionStatement(node, true, !context);
            }
            var usingKind = this.isAwaitUsing(false) ? "await using" : this.isUsing(false) ? "using" : null;
            if (usingKind) {
                if (!this.allowUsing) this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script` or in the bare case statement");
                if (context) // Cases like `for (;;) using x = ...;`, `if (true) await using x = ...;`, etc. are not allowed.
                this.raise(this.start, "Using declaration is not allowed in single-statement positions");
                if (usingKind === "await using") {
                    if (!this.canAwait) this.raise(this.start, "Await using cannot appear outside of async function");
                    this.next();
                }
                this.next();
                this.parseVar(node, false, usingKind);
                this.semicolon();
                return this.finishNode(node, "VariableDeclaration");
            }
            var maybeName = this.value, expr = this.parseExpression();
            if (starttype === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name && expr.type === "Identifier" && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon)) return this.parseLabeledStatement(node, maybeName, expr, context);
            else return this.parseExpressionStatement(node, expr);
    }
};
$6fb78ed28ed3b042$var$pp$8.parseBreakContinueStatement = function(node, keyword) {
    var isBreak = keyword === "break";
    this.next();
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi) || this.insertSemicolon()) node.label = null;
    else if (this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name) this.unexpected();
    else {
        node.label = this.parseIdent();
        this.semicolon();
    }
    // Verify that there is an actual destination to break or
    // continue to.
    var i = 0;
    for(; i < this.labels.length; ++i){
        var lab = this.labels[i];
        if (node.label == null || lab.name === node.label.name) {
            if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
            if (node.label && isBreak) break;
        }
    }
    if (i === this.labels.length) this.raise(node.start, "Unsyntactic " + keyword);
    return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseDebuggerStatement = function(node) {
    this.next();
    this.semicolon();
    return this.finishNode(node, "DebuggerStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseDoStatement = function(node) {
    this.next();
    this.labels.push($6fb78ed28ed3b042$var$loopLabel);
    node.body = this.parseStatement("do");
    this.labels.pop();
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8._while);
    node.test = this.parseParenExpression();
    if (this.options.ecmaVersion >= 6) this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi);
    else this.semicolon();
    return this.finishNode(node, "DoWhileStatement");
};
// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.
$6fb78ed28ed3b042$var$pp$8.parseForStatement = function(node) {
    this.next();
    var awaitAt = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
    this.labels.push($6fb78ed28ed3b042$var$loopLabel);
    this.enterScope(0);
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL);
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi) {
        if (awaitAt > -1) this.unexpected(awaitAt);
        return this.parseFor(node, null);
    }
    var isLet = this.isLet();
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._var || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._const || isLet) {
        var init$1 = this.startNode(), kind = isLet ? "let" : this.value;
        this.next();
        this.parseVar(init$1, true, kind);
        this.finishNode(init$1, "VariableDeclaration");
        return this.parseForAfterInit(node, init$1, awaitAt);
    }
    var startsWithLet = this.isContextual("let"), isForOf = false;
    var usingKind = this.isUsing(true) ? "using" : this.isAwaitUsing(true) ? "await using" : null;
    if (usingKind) {
        var init$2 = this.startNode();
        this.next();
        if (usingKind === "await using") {
            if (!this.canAwait) this.raise(this.start, "Await using cannot appear outside of async function");
            this.next();
        }
        this.parseVar(init$2, true, usingKind);
        this.finishNode(init$2, "VariableDeclaration");
        return this.parseForAfterInit(node, init$2, awaitAt);
    }
    var containsEsc = this.containsEsc;
    var refDestructuringErrors = new $6fb78ed28ed3b042$var$DestructuringErrors;
    var initPos = this.start;
    var init = awaitAt > -1 ? this.parseExprSubscripts(refDestructuringErrors, "await") : this.parseExpression(true, refDestructuringErrors);
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in || (isForOf = this.options.ecmaVersion >= 6 && this.isContextual("of"))) {
        if (awaitAt > -1) {
            if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in) this.unexpected(awaitAt);
            node.await = true;
        } else if (isForOf && this.options.ecmaVersion >= 8) {
            if (init.start === initPos && !containsEsc && init.type === "Identifier" && init.name === "async") this.unexpected();
            else if (this.options.ecmaVersion >= 9) node.await = false;
        }
        if (startsWithLet && isForOf) this.raise(init.start, "The left-hand side of a for-of loop may not start with 'let'.");
        this.toAssignable(init, false, refDestructuringErrors);
        this.checkLValPattern(init);
        return this.parseForIn(node, init);
    } else this.checkExpressionErrors(refDestructuringErrors, true);
    if (awaitAt > -1) this.unexpected(awaitAt);
    return this.parseFor(node, init);
};
// Helper method to parse for loop after variable initialization
$6fb78ed28ed3b042$var$pp$8.parseForAfterInit = function(node, init, awaitAt) {
    if ((this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && init.declarations.length === 1) {
        if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in) {
            if ((init.kind === "using" || init.kind === "await using") && !init.declarations[0].init) this.raise(this.start, "Using declaration is not allowed in for-in loops");
            if (this.options.ecmaVersion >= 9 && awaitAt > -1) this.unexpected(awaitAt);
        } else if (this.options.ecmaVersion >= 9) node.await = awaitAt > -1;
        return this.parseForIn(node, init);
    }
    if (awaitAt > -1) this.unexpected(awaitAt);
    return this.parseFor(node, init);
};
$6fb78ed28ed3b042$var$pp$8.parseFunctionStatement = function(node, isAsync, declarationPosition) {
    this.next();
    return this.parseFunction(node, $6fb78ed28ed3b042$var$FUNC_STATEMENT | (declarationPosition ? 0 : $6fb78ed28ed3b042$var$FUNC_HANGING_STATEMENT), false, isAsync);
};
$6fb78ed28ed3b042$var$pp$8.parseIfStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    // allow function declarations in branches, but only in non-strict mode
    node.consequent = this.parseStatement("if");
    node.alternate = this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8._else) ? this.parseStatement("if") : null;
    return this.finishNode(node, "IfStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseReturnStatement = function(node) {
    if (!this.allowReturn) this.raise(this.start, "'return' outside of function");
    this.next();
    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi) || this.insertSemicolon()) node.argument = null;
    else {
        node.argument = this.parseExpression();
        this.semicolon();
    }
    return this.finishNode(node, "ReturnStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseSwitchStatement = function(node) {
    this.next();
    node.discriminant = this.parseParenExpression();
    node.cases = [];
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL);
    this.labels.push($6fb78ed28ed3b042$var$switchLabel);
    this.enterScope($6fb78ed28ed3b042$var$SCOPE_SWITCH);
    // Statements under must be grouped (by label) in SwitchCase
    // nodes. `cur` is used to keep the node that we are currently
    // adding statements to.
    var cur;
    for(var sawDefault = false; this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR;)if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._case || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._default) {
        var isCase = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._case;
        if (cur) this.finishNode(cur, "SwitchCase");
        node.cases.push(cur = this.startNode());
        cur.consequent = [];
        this.next();
        if (isCase) cur.test = this.parseExpression();
        else {
            if (sawDefault) this.raiseRecoverable(this.lastTokStart, "Multiple default clauses");
            sawDefault = true;
            cur.test = null;
        }
        this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon);
    } else {
        if (!cur) this.unexpected();
        cur.consequent.push(this.parseStatement(null));
    }
    this.exitScope();
    if (cur) this.finishNode(cur, "SwitchCase");
    this.next(); // Closing brace
    this.labels.pop();
    return this.finishNode(node, "SwitchStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseThrowStatement = function(node) {
    this.next();
    if ($6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start))) this.raise(this.lastTokEnd, "Illegal newline after throw");
    node.argument = this.parseExpression();
    this.semicolon();
    return this.finishNode(node, "ThrowStatement");
};
// Reused empty array added for node fields that are always empty.
var $6fb78ed28ed3b042$var$empty$1 = [];
$6fb78ed28ed3b042$var$pp$8.parseCatchClauseParam = function() {
    var param = this.parseBindingAtom();
    var simple = param.type === "Identifier";
    this.enterScope(simple ? $6fb78ed28ed3b042$var$SCOPE_SIMPLE_CATCH : 0);
    this.checkLValPattern(param, simple ? $6fb78ed28ed3b042$var$BIND_SIMPLE_CATCH : $6fb78ed28ed3b042$var$BIND_LEXICAL);
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR);
    return param;
};
$6fb78ed28ed3b042$var$pp$8.parseTryStatement = function(node) {
    this.next();
    node.block = this.parseBlock();
    node.handler = null;
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._catch) {
        var clause = this.startNode();
        this.next();
        if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL)) clause.param = this.parseCatchClauseParam();
        else {
            if (this.options.ecmaVersion < 10) this.unexpected();
            clause.param = null;
            this.enterScope(0);
        }
        clause.body = this.parseBlock(false);
        this.exitScope();
        node.handler = this.finishNode(clause, "CatchClause");
    }
    node.finalizer = this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8._finally) ? this.parseBlock() : null;
    if (!node.handler && !node.finalizer) this.raise(node.start, "Missing catch or finally clause");
    return this.finishNode(node, "TryStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseVarStatement = function(node, kind, allowMissingInitializer) {
    this.next();
    this.parseVar(node, false, kind, allowMissingInitializer);
    this.semicolon();
    return this.finishNode(node, "VariableDeclaration");
};
$6fb78ed28ed3b042$var$pp$8.parseWhileStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    this.labels.push($6fb78ed28ed3b042$var$loopLabel);
    node.body = this.parseStatement("while");
    this.labels.pop();
    return this.finishNode(node, "WhileStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseWithStatement = function(node) {
    if (this.strict) this.raise(this.start, "'with' in strict mode");
    this.next();
    node.object = this.parseParenExpression();
    node.body = this.parseStatement("with");
    return this.finishNode(node, "WithStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseEmptyStatement = function(node) {
    this.next();
    return this.finishNode(node, "EmptyStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseLabeledStatement = function(node, maybeName, expr, context) {
    for(var i$1 = 0, list = this.labels; i$1 < list.length; i$1 += 1){
        var label = list[i$1];
        if (label.name === maybeName) this.raise(expr.start, "Label '" + maybeName + "' is already declared");
    }
    var kind = this.type.isLoop ? "loop" : this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._switch ? "switch" : null;
    for(var i = this.labels.length - 1; i >= 0; i--){
        var label$1 = this.labels[i];
        if (label$1.statementStart === node.start) {
            // Update information about previous labels on this node
            label$1.statementStart = this.start;
            label$1.kind = kind;
        } else break;
    }
    this.labels.push({
        name: maybeName,
        kind: kind,
        statementStart: this.start
    });
    node.body = this.parseStatement(context ? context.indexOf("label") === -1 ? context + "label" : context : "label");
    this.labels.pop();
    node.label = expr;
    return this.finishNode(node, "LabeledStatement");
};
$6fb78ed28ed3b042$var$pp$8.parseExpressionStatement = function(node, expr) {
    node.expression = expr;
    this.semicolon();
    return this.finishNode(node, "ExpressionStatement");
};
// Parse a semicolon-enclosed block of statements, handling `"use
// strict"` declarations when `allowStrict` is true (used for
// function bodies).
$6fb78ed28ed3b042$var$pp$8.parseBlock = function(createNewLexicalScope, node, exitStrict) {
    if (createNewLexicalScope === void 0) createNewLexicalScope = true;
    if (node === void 0) node = this.startNode();
    node.body = [];
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL);
    if (createNewLexicalScope) this.enterScope(0);
    while(this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR){
        var stmt = this.parseStatement(null);
        node.body.push(stmt);
    }
    if (exitStrict) this.strict = false;
    this.next();
    if (createNewLexicalScope) this.exitScope();
    return this.finishNode(node, "BlockStatement");
};
// Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.
$6fb78ed28ed3b042$var$pp$8.parseFor = function(node, init) {
    node.init = init;
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi);
    node.test = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi ? null : this.parseExpression();
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi);
    node.update = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR ? null : this.parseExpression();
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, "ForStatement");
};
// Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.
$6fb78ed28ed3b042$var$pp$8.parseForIn = function(node, init) {
    var isForIn = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in;
    this.next();
    if (init.type === "VariableDeclaration" && init.declarations[0].init != null && (!isForIn || this.options.ecmaVersion < 8 || this.strict || init.kind !== "var" || init.declarations[0].id.type !== "Identifier")) this.raise(init.start, (isForIn ? "for-in" : "for-of") + " loop variable declaration may not have an initializer");
    node.left = init;
    node.right = isForIn ? this.parseExpression() : this.parseMaybeAssign();
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement");
};
// Parse a list of variable declarations.
$6fb78ed28ed3b042$var$pp$8.parseVar = function(node, isFor, kind, allowMissingInitializer) {
    node.declarations = [];
    node.kind = kind;
    for(;;){
        var decl = this.startNode();
        this.parseVarId(decl, kind);
        if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq)) decl.init = this.parseMaybeAssign(isFor);
        else if (!allowMissingInitializer && kind === "const" && !(this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in || this.options.ecmaVersion >= 6 && this.isContextual("of"))) this.unexpected();
        else if (!allowMissingInitializer && (kind === "using" || kind === "await using") && this.options.ecmaVersion >= 17 && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in && !this.isContextual("of")) this.raise(this.lastTokEnd, "Missing initializer in " + kind + " declaration");
        else if (!allowMissingInitializer && decl.id.type !== "Identifier" && !(isFor && (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in || this.isContextual("of")))) this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value");
        else decl.init = null;
        node.declarations.push(this.finishNode(decl, "VariableDeclarator"));
        if (!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma)) break;
    }
    return node;
};
$6fb78ed28ed3b042$var$pp$8.parseVarId = function(decl, kind) {
    decl.id = kind === "using" || kind === "await using" ? this.parseIdent() : this.parseBindingAtom();
    this.checkLValPattern(decl.id, kind === "var" ? $6fb78ed28ed3b042$var$BIND_VAR : $6fb78ed28ed3b042$var$BIND_LEXICAL, false);
};
var $6fb78ed28ed3b042$var$FUNC_STATEMENT = 1, $6fb78ed28ed3b042$var$FUNC_HANGING_STATEMENT = 2, $6fb78ed28ed3b042$var$FUNC_NULLABLE_ID = 4;
// Parse a function declaration or literal (depending on the
// `statement & FUNC_STATEMENT`).
// Remove `allowExpressionBody` for 7.0.0, as it is only called with false
$6fb78ed28ed3b042$var$pp$8.parseFunction = function(node, statement, allowExpressionBody, isAsync, forInit) {
    this.initFunction(node);
    if (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !isAsync) {
        if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star && statement & $6fb78ed28ed3b042$var$FUNC_HANGING_STATEMENT) this.unexpected();
        node.generator = this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star);
    }
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    if (statement & $6fb78ed28ed3b042$var$FUNC_STATEMENT) {
        node.id = statement & $6fb78ed28ed3b042$var$FUNC_NULLABLE_ID && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name ? null : this.parseIdent();
        if (node.id && !(statement & $6fb78ed28ed3b042$var$FUNC_HANGING_STATEMENT)) this.checkLValSimple(node.id, this.strict || node.generator || node.async ? this.treatFunctionsAsVar ? $6fb78ed28ed3b042$var$BIND_VAR : $6fb78ed28ed3b042$var$BIND_LEXICAL : $6fb78ed28ed3b042$var$BIND_FUNCTION);
    }
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope($6fb78ed28ed3b042$var$functionFlags(node.async, node.generator));
    if (!(statement & $6fb78ed28ed3b042$var$FUNC_STATEMENT)) node.id = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name ? this.parseIdent() : null;
    this.parseFunctionParams(node);
    this.parseFunctionBody(node, allowExpressionBody, false, forInit);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, statement & $6fb78ed28ed3b042$var$FUNC_STATEMENT ? "FunctionDeclaration" : "FunctionExpression");
};
$6fb78ed28ed3b042$var$pp$8.parseFunctionParams = function(node) {
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL);
    node.params = this.parseBindingList($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
};
// Parse a class declaration or literal (depending on the
// `isStatement` parameter).
$6fb78ed28ed3b042$var$pp$8.parseClass = function(node, isStatement) {
    this.next();
    // ecma-262 14.6 Class Definitions
    // A class definition is always strict mode code.
    var oldStrict = this.strict;
    this.strict = true;
    this.parseClassId(node, isStatement);
    this.parseClassSuper(node);
    var privateNameMap = this.enterClassBody();
    var classBody = this.startNode();
    var hadConstructor = false;
    classBody.body = [];
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL);
    while(this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR){
        var element = this.parseClassElement(node.superClass !== null);
        if (element) {
            classBody.body.push(element);
            if (element.type === "MethodDefinition" && element.kind === "constructor") {
                if (hadConstructor) this.raiseRecoverable(element.start, "Duplicate constructor in the same class");
                hadConstructor = true;
            } else if (element.key && element.key.type === "PrivateIdentifier" && $6fb78ed28ed3b042$var$isPrivateNameConflicted(privateNameMap, element)) this.raiseRecoverable(element.key.start, "Identifier '#" + element.key.name + "' has already been declared");
        }
    }
    this.strict = oldStrict;
    this.next();
    node.body = this.finishNode(classBody, "ClassBody");
    this.exitClassBody();
    return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression");
};
$6fb78ed28ed3b042$var$pp$8.parseClassElement = function(constructorAllowsSuper) {
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi)) return null;
    var ecmaVersion = this.options.ecmaVersion;
    var node = this.startNode();
    var keyName = "";
    var isGenerator = false;
    var isAsync = false;
    var kind = "method";
    var isStatic = false;
    if (this.eatContextual("static")) {
        // Parse static init block
        if (ecmaVersion >= 13 && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL)) {
            this.parseClassStaticBlock(node);
            return node;
        }
        if (this.isClassElementNameStart() || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star) isStatic = true;
        else keyName = "static";
    }
    node.static = isStatic;
    if (!keyName && ecmaVersion >= 8 && this.eatContextual("async")) {
        if ((this.isClassElementNameStart() || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star) && !this.canInsertSemicolon()) isAsync = true;
        else keyName = "async";
    }
    if (!keyName && (ecmaVersion >= 9 || !isAsync) && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star)) isGenerator = true;
    if (!keyName && !isAsync && !isGenerator) {
        var lastValue = this.value;
        if (this.eatContextual("get") || this.eatContextual("set")) {
            if (this.isClassElementNameStart()) kind = lastValue;
            else keyName = lastValue;
        }
    }
    // Parse element name
    if (keyName) {
        // 'async', 'get', 'set', or 'static' were not a keyword contextually.
        // The last token is any of those. Make it the element name.
        node.computed = false;
        node.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc);
        node.key.name = keyName;
        this.finishNode(node.key, "Identifier");
    } else this.parseClassElementName(node);
    // Parse element value
    if (ecmaVersion < 13 || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL || kind !== "method" || isGenerator || isAsync) {
        var isConstructor = !node.static && $6fb78ed28ed3b042$var$checkKeyName(node, "constructor");
        var allowsDirectSuper = isConstructor && constructorAllowsSuper;
        // Couldn't move this check into the 'parseClassMethod' method for backward compatibility.
        if (isConstructor && kind !== "method") this.raise(node.key.start, "Constructor can't have get/set modifier");
        node.kind = isConstructor ? "constructor" : kind;
        this.parseClassMethod(node, isGenerator, isAsync, allowsDirectSuper);
    } else this.parseClassField(node);
    return node;
};
$6fb78ed28ed3b042$var$pp$8.isClassElementNameStart = function() {
    return this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.privateId || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.num || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL || this.type.keyword;
};
$6fb78ed28ed3b042$var$pp$8.parseClassElementName = function(element) {
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.privateId) {
        if (this.value === "constructor") this.raise(this.start, "Classes can't have an element named '#constructor'");
        element.computed = false;
        element.key = this.parsePrivateIdent();
    } else this.parsePropertyName(element);
};
$6fb78ed28ed3b042$var$pp$8.parseClassMethod = function(method, isGenerator, isAsync, allowsDirectSuper) {
    // Check key and flags
    var key = method.key;
    if (method.kind === "constructor") {
        if (isGenerator) this.raise(key.start, "Constructor can't be a generator");
        if (isAsync) this.raise(key.start, "Constructor can't be an async method");
    } else if (method.static && $6fb78ed28ed3b042$var$checkKeyName(method, "prototype")) this.raise(key.start, "Classes may not have a static property named prototype");
    // Parse value
    var value = method.value = this.parseMethod(isGenerator, isAsync, allowsDirectSuper);
    // Check value
    if (method.kind === "get" && value.params.length !== 0) this.raiseRecoverable(value.start, "getter should have no params");
    if (method.kind === "set" && value.params.length !== 1) this.raiseRecoverable(value.start, "setter should have exactly one param");
    if (method.kind === "set" && value.params[0].type === "RestElement") this.raiseRecoverable(value.params[0].start, "Setter cannot use rest params");
    return this.finishNode(method, "MethodDefinition");
};
$6fb78ed28ed3b042$var$pp$8.parseClassField = function(field) {
    if ($6fb78ed28ed3b042$var$checkKeyName(field, "constructor")) this.raise(field.key.start, "Classes can't have a field named 'constructor'");
    else if (field.static && $6fb78ed28ed3b042$var$checkKeyName(field, "prototype")) this.raise(field.key.start, "Classes can't have a static field named 'prototype'");
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq)) {
        // To raise SyntaxError if 'arguments' exists in the initializer.
        this.enterScope($6fb78ed28ed3b042$var$SCOPE_CLASS_FIELD_INIT | $6fb78ed28ed3b042$var$SCOPE_SUPER);
        field.value = this.parseMaybeAssign();
        this.exitScope();
    } else field.value = null;
    this.semicolon();
    return this.finishNode(field, "PropertyDefinition");
};
$6fb78ed28ed3b042$var$pp$8.parseClassStaticBlock = function(node) {
    node.body = [];
    var oldLabels = this.labels;
    this.labels = [];
    this.enterScope($6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK | $6fb78ed28ed3b042$var$SCOPE_SUPER);
    while(this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR){
        var stmt = this.parseStatement(null);
        node.body.push(stmt);
    }
    this.next();
    this.exitScope();
    this.labels = oldLabels;
    return this.finishNode(node, "StaticBlock");
};
$6fb78ed28ed3b042$var$pp$8.parseClassId = function(node, isStatement) {
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name) {
        node.id = this.parseIdent();
        if (isStatement) this.checkLValSimple(node.id, $6fb78ed28ed3b042$var$BIND_LEXICAL, false);
    } else {
        if (isStatement === true) this.unexpected();
        node.id = null;
    }
};
$6fb78ed28ed3b042$var$pp$8.parseClassSuper = function(node) {
    node.superClass = this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8._extends) ? this.parseExprSubscripts(null, false) : null;
};
$6fb78ed28ed3b042$var$pp$8.enterClassBody = function() {
    var element = {
        declared: Object.create(null),
        used: []
    };
    this.privateNameStack.push(element);
    return element.declared;
};
$6fb78ed28ed3b042$var$pp$8.exitClassBody = function() {
    var ref = this.privateNameStack.pop();
    var declared = ref.declared;
    var used = ref.used;
    if (!this.options.checkPrivateFields) return;
    var len = this.privateNameStack.length;
    var parent = len === 0 ? null : this.privateNameStack[len - 1];
    for(var i = 0; i < used.length; ++i){
        var id = used[i];
        if (!$6fb78ed28ed3b042$var$hasOwn(declared, id.name)) {
            if (parent) parent.used.push(id);
            else this.raiseRecoverable(id.start, "Private field '#" + id.name + "' must be declared in an enclosing class");
        }
    }
};
function $6fb78ed28ed3b042$var$isPrivateNameConflicted(privateNameMap, element) {
    var name = element.key.name;
    var curr = privateNameMap[name];
    var next = "true";
    if (element.type === "MethodDefinition" && (element.kind === "get" || element.kind === "set")) next = (element.static ? "s" : "i") + element.kind;
    // `class { get #a(){}; static set #a(_){} }` is also conflict.
    if (curr === "iget" && next === "iset" || curr === "iset" && next === "iget" || curr === "sget" && next === "sset" || curr === "sset" && next === "sget") {
        privateNameMap[name] = "true";
        return false;
    } else if (!curr) {
        privateNameMap[name] = next;
        return false;
    } else return true;
}
function $6fb78ed28ed3b042$var$checkKeyName(node, name) {
    var computed = node.computed;
    var key = node.key;
    return !computed && (key.type === "Identifier" && key.name === name || key.type === "Literal" && key.value === name);
}
// Parses module export declaration.
$6fb78ed28ed3b042$var$pp$8.parseExportAllDeclaration = function(node, exports$1) {
    if (this.options.ecmaVersion >= 11) {
        if (this.eatContextual("as")) {
            node.exported = this.parseModuleExportName();
            this.checkExport(exports$1, node.exported, this.lastTokStart);
        } else node.exported = null;
    }
    this.expectContextual("from");
    if (this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string) this.unexpected();
    node.source = this.parseExprAtom();
    if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
    this.semicolon();
    return this.finishNode(node, "ExportAllDeclaration");
};
$6fb78ed28ed3b042$var$pp$8.parseExport = function(node, exports$1) {
    this.next();
    // export * from '...'
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star)) return this.parseExportAllDeclaration(node, exports$1);
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8._default)) {
        this.checkExport(exports$1, "default", this.lastTokStart);
        node.declaration = this.parseExportDefaultDeclaration();
        return this.finishNode(node, "ExportDefaultDeclaration");
    }
    // export var|const|let|function|class ...
    if (this.shouldParseExportStatement()) {
        node.declaration = this.parseExportDeclaration(node);
        if (node.declaration.type === "VariableDeclaration") this.checkVariableExport(exports$1, node.declaration.declarations);
        else this.checkExport(exports$1, node.declaration.id, node.declaration.id.start);
        node.specifiers = [];
        node.source = null;
        if (this.options.ecmaVersion >= 16) node.attributes = [];
    } else {
        node.declaration = null;
        node.specifiers = this.parseExportSpecifiers(exports$1);
        if (this.eatContextual("from")) {
            if (this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string) this.unexpected();
            node.source = this.parseExprAtom();
            if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
        } else {
            for(var i = 0, list = node.specifiers; i < list.length; i += 1){
                // check for keywords used as local names
                var spec = list[i];
                this.checkUnreserved(spec.local);
                // check if export is defined
                this.checkLocalExport(spec.local);
                if (spec.local.type === "Literal") this.raise(spec.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            node.source = null;
            if (this.options.ecmaVersion >= 16) node.attributes = [];
        }
        this.semicolon();
    }
    return this.finishNode(node, "ExportNamedDeclaration");
};
$6fb78ed28ed3b042$var$pp$8.parseExportDeclaration = function(node) {
    return this.parseStatement(null);
};
$6fb78ed28ed3b042$var$pp$8.parseExportDefaultDeclaration = function() {
    var isAsync;
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._function || (isAsync = this.isAsyncFunction())) {
        var fNode = this.startNode();
        this.next();
        if (isAsync) this.next();
        return this.parseFunction(fNode, $6fb78ed28ed3b042$var$FUNC_STATEMENT | $6fb78ed28ed3b042$var$FUNC_NULLABLE_ID, false, isAsync);
    } else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._class) {
        var cNode = this.startNode();
        return this.parseClass(cNode, "nullableID");
    } else {
        var declaration = this.parseMaybeAssign();
        this.semicolon();
        return declaration;
    }
};
$6fb78ed28ed3b042$var$pp$8.checkExport = function(exports$1, name, pos) {
    if (!exports$1) return;
    if (typeof name !== "string") name = name.type === "Identifier" ? name.name : name.value;
    if ($6fb78ed28ed3b042$var$hasOwn(exports$1, name)) this.raiseRecoverable(pos, "Duplicate export '" + name + "'");
    exports$1[name] = true;
};
$6fb78ed28ed3b042$var$pp$8.checkPatternExport = function(exports$1, pat) {
    var type = pat.type;
    if (type === "Identifier") this.checkExport(exports$1, pat, pat.start);
    else if (type === "ObjectPattern") for(var i = 0, list = pat.properties; i < list.length; i += 1){
        var prop = list[i];
        this.checkPatternExport(exports$1, prop);
    }
    else if (type === "ArrayPattern") for(var i$1 = 0, list$1 = pat.elements; i$1 < list$1.length; i$1 += 1){
        var elt = list$1[i$1];
        if (elt) this.checkPatternExport(exports$1, elt);
    }
    else if (type === "Property") this.checkPatternExport(exports$1, pat.value);
    else if (type === "AssignmentPattern") this.checkPatternExport(exports$1, pat.left);
    else if (type === "RestElement") this.checkPatternExport(exports$1, pat.argument);
};
$6fb78ed28ed3b042$var$pp$8.checkVariableExport = function(exports$1, decls) {
    if (!exports$1) return;
    for(var i = 0, list = decls; i < list.length; i += 1){
        var decl = list[i];
        this.checkPatternExport(exports$1, decl.id);
    }
};
$6fb78ed28ed3b042$var$pp$8.shouldParseExportStatement = function() {
    return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
// Parses a comma-separated list of module exports.
$6fb78ed28ed3b042$var$pp$8.parseExportSpecifier = function(exports$1) {
    var node = this.startNode();
    node.local = this.parseModuleExportName();
    node.exported = this.eatContextual("as") ? this.parseModuleExportName() : node.local;
    this.checkExport(exports$1, node.exported, node.exported.start);
    return this.finishNode(node, "ExportSpecifier");
};
$6fb78ed28ed3b042$var$pp$8.parseExportSpecifiers = function(exports$1) {
    var nodes = [], first = true;
    // export { x, y as z } [from '...']
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL);
    while(!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
            if (this.afterTrailingComma($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        nodes.push(this.parseExportSpecifier(exports$1));
    }
    return nodes;
};
// Parses import declaration.
$6fb78ed28ed3b042$var$pp$8.parseImport = function(node) {
    this.next();
    // import '...'
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string) {
        node.specifiers = $6fb78ed28ed3b042$var$empty$1;
        node.source = this.parseExprAtom();
    } else {
        node.specifiers = this.parseImportSpecifiers();
        this.expectContextual("from");
        node.source = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string ? this.parseExprAtom() : this.unexpected();
    }
    if (this.options.ecmaVersion >= 16) node.attributes = this.parseWithClause();
    this.semicolon();
    return this.finishNode(node, "ImportDeclaration");
};
// Parses a comma-separated list of module imports.
$6fb78ed28ed3b042$var$pp$8.parseImportSpecifier = function() {
    var node = this.startNode();
    node.imported = this.parseModuleExportName();
    if (this.eatContextual("as")) node.local = this.parseIdent();
    else {
        this.checkUnreserved(node.imported);
        node.local = node.imported;
    }
    this.checkLValSimple(node.local, $6fb78ed28ed3b042$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportSpecifier");
};
$6fb78ed28ed3b042$var$pp$8.parseImportDefaultSpecifier = function() {
    // import defaultObj, { x, y as z } from '...'
    var node = this.startNode();
    node.local = this.parseIdent();
    this.checkLValSimple(node.local, $6fb78ed28ed3b042$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportDefaultSpecifier");
};
$6fb78ed28ed3b042$var$pp$8.parseImportNamespaceSpecifier = function() {
    var node = this.startNode();
    this.next();
    this.expectContextual("as");
    node.local = this.parseIdent();
    this.checkLValSimple(node.local, $6fb78ed28ed3b042$var$BIND_LEXICAL);
    return this.finishNode(node, "ImportNamespaceSpecifier");
};
$6fb78ed28ed3b042$var$pp$8.parseImportSpecifiers = function() {
    var nodes = [], first = true;
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name) {
        nodes.push(this.parseImportDefaultSpecifier());
        if (!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma)) return nodes;
    }
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star) {
        nodes.push(this.parseImportNamespaceSpecifier());
        return nodes;
    }
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL);
    while(!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
            if (this.afterTrailingComma($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        nodes.push(this.parseImportSpecifier());
    }
    return nodes;
};
$6fb78ed28ed3b042$var$pp$8.parseWithClause = function() {
    var nodes = [];
    if (!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8._with)) return nodes;
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL);
    var attributeKeys = {};
    var first = true;
    while(!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
            if (this.afterTrailingComma($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        var attr = this.parseImportAttribute();
        var keyName = attr.key.type === "Identifier" ? attr.key.name : attr.key.value;
        if ($6fb78ed28ed3b042$var$hasOwn(attributeKeys, keyName)) this.raiseRecoverable(attr.key.start, "Duplicate attribute key '" + keyName + "'");
        attributeKeys[keyName] = true;
        nodes.push(attr);
    }
    return nodes;
};
$6fb78ed28ed3b042$var$pp$8.parseImportAttribute = function() {
    var node = this.startNode();
    node.key = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon);
    if (this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string) this.unexpected();
    node.value = this.parseExprAtom();
    return this.finishNode(node, "ImportAttribute");
};
$6fb78ed28ed3b042$var$pp$8.parseModuleExportName = function() {
    if (this.options.ecmaVersion >= 13 && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string) {
        var stringLiteral = this.parseLiteral(this.value);
        if ($6fb78ed28ed3b042$var$loneSurrogate.test(stringLiteral.value)) this.raise(stringLiteral.start, "An export name cannot include a lone surrogate.");
        return stringLiteral;
    }
    return this.parseIdent(true);
};
// Set `ExpressionStatement#directive` property for directive prologues.
$6fb78ed28ed3b042$var$pp$8.adaptDirectivePrologue = function(statements) {
    for(var i = 0; i < statements.length && this.isDirectiveCandidate(statements[i]); ++i)statements[i].directive = statements[i].expression.raw.slice(1, -1);
};
$6fb78ed28ed3b042$var$pp$8.isDirectiveCandidate = function(statement) {
    return this.options.ecmaVersion >= 5 && statement.type === "ExpressionStatement" && statement.expression.type === "Literal" && typeof statement.expression.value === "string" && // Reject parenthesized strings.
    (this.input[statement.start] === "\"" || this.input[statement.start] === "'");
};
var $6fb78ed28ed3b042$var$pp$7 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
// Convert existing expression atom to assignable pattern
// if possible.
$6fb78ed28ed3b042$var$pp$7.toAssignable = function(node, isBinding, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 6 && node) switch(node.type){
        case "Identifier":
            if (this.inAsync && node.name === "await") this.raise(node.start, "Cannot use 'await' as identifier inside an async function");
            break;
        case "ObjectPattern":
        case "ArrayPattern":
        case "AssignmentPattern":
        case "RestElement":
            break;
        case "ObjectExpression":
            node.type = "ObjectPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            for(var i = 0, list = node.properties; i < list.length; i += 1){
                var prop = list[i];
                this.toAssignable(prop, isBinding);
                // Early error:
                //   AssignmentRestProperty[Yield, Await] :
                //     `...` DestructuringAssignmentTarget[Yield, Await]
                //
                //   It is a Syntax Error if |DestructuringAssignmentTarget| is an |ArrayLiteral| or an |ObjectLiteral|.
                if (prop.type === "RestElement" && (prop.argument.type === "ArrayPattern" || prop.argument.type === "ObjectPattern")) this.raise(prop.argument.start, "Unexpected token");
            }
            break;
        case "Property":
            // AssignmentProperty has type === "Property"
            if (node.kind !== "init") this.raise(node.key.start, "Object pattern can't contain getter or setter");
            this.toAssignable(node.value, isBinding);
            break;
        case "ArrayExpression":
            node.type = "ArrayPattern";
            if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
            this.toAssignableList(node.elements, isBinding);
            break;
        case "SpreadElement":
            node.type = "RestElement";
            this.toAssignable(node.argument, isBinding);
            if (node.argument.type === "AssignmentPattern") this.raise(node.argument.start, "Rest elements cannot have a default value");
            break;
        case "AssignmentExpression":
            if (node.operator !== "=") this.raise(node.left.end, "Only '=' operator can be used for specifying default value.");
            node.type = "AssignmentPattern";
            delete node.operator;
            this.toAssignable(node.left, isBinding);
            break;
        case "ParenthesizedExpression":
            this.toAssignable(node.expression, isBinding, refDestructuringErrors);
            break;
        case "ChainExpression":
            this.raiseRecoverable(node.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (!isBinding) break;
        default:
            this.raise(node.start, "Assigning to rvalue");
    }
    else if (refDestructuringErrors) this.checkPatternErrors(refDestructuringErrors, true);
    return node;
};
// Convert list of expression atoms to binding list.
$6fb78ed28ed3b042$var$pp$7.toAssignableList = function(exprList, isBinding) {
    var end = exprList.length;
    for(var i = 0; i < end; i++){
        var elt = exprList[i];
        if (elt) this.toAssignable(elt, isBinding);
    }
    if (end) {
        var last = exprList[end - 1];
        if (this.options.ecmaVersion === 6 && isBinding && last && last.type === "RestElement" && last.argument.type !== "Identifier") this.unexpected(last.argument.start);
    }
    return exprList;
};
// Parses spread element.
$6fb78ed28ed3b042$var$pp$7.parseSpread = function(refDestructuringErrors) {
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeAssign(false, refDestructuringErrors);
    return this.finishNode(node, "SpreadElement");
};
$6fb78ed28ed3b042$var$pp$7.parseRestBinding = function() {
    var node = this.startNode();
    this.next();
    // RestElement inside of a function parameter must be an identifier
    if (this.options.ecmaVersion === 6 && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name) this.unexpected();
    node.argument = this.parseBindingAtom();
    return this.finishNode(node, "RestElement");
};
// Parses lvalue (assignable) atom.
$6fb78ed28ed3b042$var$pp$7.parseBindingAtom = function() {
    if (this.options.ecmaVersion >= 6) switch(this.type){
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL:
            var node = this.startNode();
            this.next();
            node.elements = this.parseBindingList($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketR, true, true);
            return this.finishNode(node, "ArrayPattern");
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL:
            return this.parseObj(true);
    }
    return this.parseIdent();
};
$6fb78ed28ed3b042$var$pp$7.parseBindingList = function(close, allowEmpty, allowTrailingComma, allowModifiers) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (first) first = false;
        else this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
        if (allowEmpty && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma) elts.push(null);
        else if (allowTrailingComma && this.afterTrailingComma(close)) break;
        else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.ellipsis) {
            var rest = this.parseRestBinding();
            this.parseBindingListItem(rest);
            elts.push(rest);
            if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
            this.expect(close);
            break;
        } else elts.push(this.parseAssignableListItem(allowModifiers));
    }
    return elts;
};
$6fb78ed28ed3b042$var$pp$7.parseAssignableListItem = function(allowModifiers) {
    var elem = this.parseMaybeDefault(this.start, this.startLoc);
    this.parseBindingListItem(elem);
    return elem;
};
$6fb78ed28ed3b042$var$pp$7.parseBindingListItem = function(param) {
    return param;
};
// Parses assignment pattern around given atom if possible.
$6fb78ed28ed3b042$var$pp$7.parseMaybeDefault = function(startPos, startLoc, left) {
    left = left || this.parseBindingAtom();
    if (this.options.ecmaVersion < 6 || !this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq)) return left;
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.right = this.parseMaybeAssign();
    return this.finishNode(node, "AssignmentPattern");
};
// The following three functions all verify that a node is an lvalue —
// something that can be bound, or assigned to. In order to do so, they perform
// a variety of checks:
//
// - Check that none of the bound/assigned-to identifiers are reserved words.
// - Record name declarations for bindings in the appropriate scope.
// - Check duplicate argument names, if checkClashes is set.
//
// If a complex binding pattern is encountered (e.g., object and array
// destructuring), the entire pattern is recursively checked.
//
// There are three versions of checkLVal*() appropriate for different
// circumstances:
//
// - checkLValSimple() shall be used if the syntactic construct supports
//   nothing other than identifiers and member expressions. Parenthesized
//   expressions are also correctly handled. This is generally appropriate for
//   constructs for which the spec says
//
//   > It is a Syntax Error if AssignmentTargetType of [the production] is not
//   > simple.
//
//   It is also appropriate for checking if an identifier is valid and not
//   defined elsewhere, like import declarations or function/class identifiers.
//
//   Examples where this is used include:
//     a += …;
//     import a from '…';
//   where a is the node to be checked.
//
// - checkLValPattern() shall be used if the syntactic construct supports
//   anything checkLValSimple() supports, as well as object and array
//   destructuring patterns. This is generally appropriate for constructs for
//   which the spec says
//
//   > It is a Syntax Error if [the production] is neither an ObjectLiteral nor
//   > an ArrayLiteral and AssignmentTargetType of [the production] is not
//   > simple.
//
//   Examples where this is used include:
//     (a = …);
//     const a = …;
//     try { … } catch (a) { … }
//   where a is the node to be checked.
//
// - checkLValInnerPattern() shall be used if the syntactic construct supports
//   anything checkLValPattern() supports, as well as default assignment
//   patterns, rest elements, and other constructs that may appear within an
//   object or array destructuring pattern.
//
//   As a special case, function parameters also use checkLValInnerPattern(),
//   as they also support defaults and rest constructs.
//
// These functions deliberately support both assignment and binding constructs,
// as the logic for both is exceedingly similar. If the node is the target of
// an assignment, then bindingType should be set to BIND_NONE. Otherwise, it
// should be set to the appropriate BIND_* constant, like BIND_VAR or
// BIND_LEXICAL.
//
// If the function is called with a non-BIND_NONE bindingType, then
// additionally a checkClashes object may be specified to allow checking for
// duplicate argument names. checkClashes is ignored if the provided construct
// is an assignment (i.e., bindingType is BIND_NONE).
$6fb78ed28ed3b042$var$pp$7.checkLValSimple = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $6fb78ed28ed3b042$var$BIND_NONE;
    var isBind = bindingType !== $6fb78ed28ed3b042$var$BIND_NONE;
    switch(expr.type){
        case "Identifier":
            if (this.strict && this.reservedWordsStrictBind.test(expr.name)) this.raiseRecoverable(expr.start, (isBind ? "Binding " : "Assigning to ") + expr.name + " in strict mode");
            if (isBind) {
                if (bindingType === $6fb78ed28ed3b042$var$BIND_LEXICAL && expr.name === "let") this.raiseRecoverable(expr.start, "let is disallowed as a lexically bound name");
                if (checkClashes) {
                    if ($6fb78ed28ed3b042$var$hasOwn(checkClashes, expr.name)) this.raiseRecoverable(expr.start, "Argument name clash");
                    checkClashes[expr.name] = true;
                }
                if (bindingType !== $6fb78ed28ed3b042$var$BIND_OUTSIDE) this.declareName(expr.name, bindingType, expr.start);
            }
            break;
        case "ChainExpression":
            this.raiseRecoverable(expr.start, "Optional chaining cannot appear in left-hand side");
            break;
        case "MemberExpression":
            if (isBind) this.raiseRecoverable(expr.start, "Binding member expression");
            break;
        case "ParenthesizedExpression":
            if (isBind) this.raiseRecoverable(expr.start, "Binding parenthesized expression");
            return this.checkLValSimple(expr.expression, bindingType, checkClashes);
        default:
            this.raise(expr.start, (isBind ? "Binding" : "Assigning to") + " rvalue");
    }
};
$6fb78ed28ed3b042$var$pp$7.checkLValPattern = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $6fb78ed28ed3b042$var$BIND_NONE;
    switch(expr.type){
        case "ObjectPattern":
            for(var i = 0, list = expr.properties; i < list.length; i += 1){
                var prop = list[i];
                this.checkLValInnerPattern(prop, bindingType, checkClashes);
            }
            break;
        case "ArrayPattern":
            for(var i$1 = 0, list$1 = expr.elements; i$1 < list$1.length; i$1 += 1){
                var elem = list$1[i$1];
                if (elem) this.checkLValInnerPattern(elem, bindingType, checkClashes);
            }
            break;
        default:
            this.checkLValSimple(expr, bindingType, checkClashes);
    }
};
$6fb78ed28ed3b042$var$pp$7.checkLValInnerPattern = function(expr, bindingType, checkClashes) {
    if (bindingType === void 0) bindingType = $6fb78ed28ed3b042$var$BIND_NONE;
    switch(expr.type){
        case "Property":
            // AssignmentProperty has type === "Property"
            this.checkLValInnerPattern(expr.value, bindingType, checkClashes);
            break;
        case "AssignmentPattern":
            this.checkLValPattern(expr.left, bindingType, checkClashes);
            break;
        case "RestElement":
            this.checkLValPattern(expr.argument, bindingType, checkClashes);
            break;
        default:
            this.checkLValPattern(expr, bindingType, checkClashes);
    }
};
// The algorithm used to determine whether a regexp can appear at a
// given point in the program is loosely based on sweet.js' approach.
// See https://github.com/mozilla/sweet.js/wiki/design
var $6fb78ed28ed3b042$export$68e7b4c4d99215d9 = function TokContext(token, isExpr, preserveSpace, override, generator) {
    this.token = token;
    this.isExpr = !!isExpr;
    this.preserveSpace = !!preserveSpace;
    this.override = override;
    this.generator = !!generator;
};
var $6fb78ed28ed3b042$export$2b5f701edfbd6f00 = {
    b_stat: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("{", false),
    b_expr: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("{", true),
    b_tmpl: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("${", false),
    p_stat: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("(", false),
    p_expr: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("(", true),
    q_tmpl: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("`", true, true, function(p) {
        return p.tryReadTemplateToken();
    }),
    f_stat: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("function", false),
    f_expr: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("function", true),
    f_expr_gen: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("function", true, false, null, true),
    f_gen: new $6fb78ed28ed3b042$export$68e7b4c4d99215d9("function", false, false, null, true)
};
var $6fb78ed28ed3b042$var$pp$6 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
$6fb78ed28ed3b042$var$pp$6.initialContext = function() {
    return [
        $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_stat
    ];
};
$6fb78ed28ed3b042$var$pp$6.curContext = function() {
    return this.context[this.context.length - 1];
};
$6fb78ed28ed3b042$var$pp$6.braceIsBlock = function(prevType) {
    var parent = this.curContext();
    if (parent === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_expr || parent === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_stat) return true;
    if (prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon && (parent === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_stat || parent === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_expr)) return !parent.isExpr;
    // The check for `tt.name && exprAllowed` detects whether we are
    // after a `yield` or `of` construct. See the `updateContext` for
    // `tt.name`.
    if (prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._return || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name && this.exprAllowed) return $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start));
    if (prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._else || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eof || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.arrow) return true;
    if (prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL) return parent === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_stat;
    if (prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._var || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._const || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name) return false;
    return !this.exprAllowed;
};
$6fb78ed28ed3b042$var$pp$6.inGeneratorContext = function() {
    for(var i = this.context.length - 1; i >= 1; i--){
        var context = this.context[i];
        if (context.token === "function") return context.generator;
    }
    return false;
};
$6fb78ed28ed3b042$var$pp$6.updateContext = function(prevType) {
    var update, type = this.type;
    if (type.keyword && prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dot) this.exprAllowed = false;
    else if (update = type.updateContext) update.call(this, prevType);
    else this.exprAllowed = type.beforeExpr;
};
// Used to handle edge cases when token context could not be inferred correctly during tokenization phase
$6fb78ed28ed3b042$var$pp$6.overrideContext = function(tokenCtx) {
    if (this.curContext() !== tokenCtx) this.context[this.context.length - 1] = tokenCtx;
};
// Token-specific context update code
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR.updateContext = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR.updateContext = function() {
    if (this.context.length === 1) {
        this.exprAllowed = true;
        return;
    }
    var out = this.context.pop();
    if (out === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_stat && this.curContext().token === "function") out = this.context.pop();
    this.exprAllowed = !out.isExpr;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL.updateContext = function(prevType) {
    this.context.push(this.braceIsBlock(prevType) ? $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_stat : $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_expr);
    this.exprAllowed = true;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dollarBraceL.updateContext = function() {
    this.context.push($6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_tmpl);
    this.exprAllowed = true;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL.updateContext = function(prevType) {
    var statementParens = prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._if || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._for || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._with || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._while;
    this.context.push(statementParens ? $6fb78ed28ed3b042$export$2b5f701edfbd6f00.p_stat : $6fb78ed28ed3b042$export$2b5f701edfbd6f00.p_expr);
    this.exprAllowed = true;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.incDec.updateContext = function() {
// tokExprAllowed stays unchanged
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8._function.updateContext = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._class.updateContext = function(prevType) {
    if (prevType.beforeExpr && prevType !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._else && !(prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi && this.curContext() !== $6fb78ed28ed3b042$export$2b5f701edfbd6f00.p_stat) && !(prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._return && $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start))) && !((prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon || prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL) && this.curContext() === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_stat)) this.context.push($6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_expr);
    else this.context.push($6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_stat);
    this.exprAllowed = false;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon.updateContext = function() {
    if (this.curContext().token === "function") this.context.pop();
    this.exprAllowed = true;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.backQuote.updateContext = function() {
    if (this.curContext() === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.q_tmpl) this.context.pop();
    else this.context.push($6fb78ed28ed3b042$export$2b5f701edfbd6f00.q_tmpl);
    this.exprAllowed = false;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star.updateContext = function(prevType) {
    if (prevType === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._function) {
        var index = this.context.length - 1;
        if (this.context[index] === $6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_expr) this.context[index] = $6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_expr_gen;
        else this.context[index] = $6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_gen;
    }
    this.exprAllowed = true;
};
$6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name.updateContext = function(prevType) {
    var allowed = false;
    if (this.options.ecmaVersion >= 6 && prevType !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dot) {
        if (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) allowed = true;
    }
    this.exprAllowed = allowed;
};
// A recursive descent parser operates by defining functions for all
// syntactic elements, and recursively calling those, each function
// advancing the input stream and returning an AST node. Precedence
// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
// instead of `(!x)[1]` is handled by the fact that the parser
// function that parses unary prefix operators is called first, and
// in turn calls the function that parses `[]` subscripts — that
// way, it'll receive the node for `x[1]` already parsed, and wraps
// *that* in the unary operator node.
//
// Acorn uses an [operator precedence parser][opp] to handle binary
// operator precedence, because it is much more compact than using
// the technique outlined above, which uses different, nesting
// functions to specify precedence, for all of the ten binary
// precedence levels that JavaScript defines.
//
// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser
var $6fb78ed28ed3b042$var$pp$5 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
// Check if property name clashes with already added.
// Object/class getters and setters are not allowed to clash —
// either with each other or with an init property — and in
// strict mode, init properties are also not allowed to be repeated.
$6fb78ed28ed3b042$var$pp$5.checkPropClash = function(prop, propHash, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 9 && prop.type === "SpreadElement") return;
    if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand)) return;
    var key = prop.key;
    var name;
    switch(key.type){
        case "Identifier":
            name = key.name;
            break;
        case "Literal":
            name = String(key.value);
            break;
        default:
            return;
    }
    var kind = prop.kind;
    if (this.options.ecmaVersion >= 6) {
        if (name === "__proto__" && kind === "init") {
            if (propHash.proto) {
                if (refDestructuringErrors) {
                    if (refDestructuringErrors.doubleProto < 0) refDestructuringErrors.doubleProto = key.start;
                } else this.raiseRecoverable(key.start, "Redefinition of __proto__ property");
            }
            propHash.proto = true;
        }
        return;
    }
    name = "$" + name;
    var other = propHash[name];
    if (other) {
        var redefinition;
        if (kind === "init") redefinition = this.strict && other.init || other.get || other.set;
        else redefinition = other.init || other[kind];
        if (redefinition) this.raiseRecoverable(key.start, "Redefinition of property");
    } else other = propHash[name] = {
        init: false,
        get: false,
        set: false
    };
    other[kind] = true;
};
// ### Expression parsing
// These nest, from the most general expression type at the top to
// 'atomic', nondivisible expression types at the bottom. Most of
// the functions will simply let the function(s) below them parse,
// and, *if* the syntactic construct they handle is present, wrap
// the AST node that the inner parser gave them in another node.
// Parse a full expression. The optional arguments are used to
// forbid the `in` operator (in for loops initalization expressions)
// and provide reference for storing '=' operator inside shorthand
// property assignment in contexts where both object expression
// and object pattern might appear (so it's possible to raise
// delayed syntax error at correct position).
$6fb78ed28ed3b042$var$pp$5.parseExpression = function(forInit, refDestructuringErrors) {
    var this$1$1 = this;
    return this.catchStackOverflow(function() {
        var startPos = this$1$1.start, startLoc = this$1$1.startLoc;
        var expr = this$1$1.parseMaybeAssign(forInit, refDestructuringErrors);
        if (this$1$1.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma) {
            var node = this$1$1.startNodeAt(startPos, startLoc);
            node.expressions = [
                expr
            ];
            while(this$1$1.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma))node.expressions.push(this$1$1.parseMaybeAssign(forInit, refDestructuringErrors));
            return this$1$1.finishNode(node, "SequenceExpression");
        }
        return expr;
    });
};
// Parse an assignment expression. This includes applications of
// operators like `+=`.
$6fb78ed28ed3b042$var$pp$5.parseMaybeAssign = function(forInit, refDestructuringErrors, afterLeftParse) {
    if (this.isContextual("yield")) {
        if (this.inGenerator) return this.parseYield(forInit);
        else this.exprAllowed = false;
    }
    var ownDestructuringErrors = false, oldParenAssign = -1, oldTrailingComma = -1, oldDoubleProto = -1;
    if (refDestructuringErrors) {
        oldParenAssign = refDestructuringErrors.parenthesizedAssign;
        oldTrailingComma = refDestructuringErrors.trailingComma;
        oldDoubleProto = refDestructuringErrors.doubleProto;
        refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = -1;
    } else {
        refDestructuringErrors = new $6fb78ed28ed3b042$var$DestructuringErrors;
        ownDestructuringErrors = true;
    }
    var startPos = this.start, startLoc = this.startLoc;
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name) {
        this.potentialArrowAt = this.start;
        this.potentialArrowInForAwait = forInit === "await";
    }
    var left = this.parseMaybeConditional(forInit, refDestructuringErrors);
    if (afterLeftParse) left = afterLeftParse.call(this, left, startPos, startLoc);
    if (this.type.isAssign) {
        var node = this.startNodeAt(startPos, startLoc);
        node.operator = this.value;
        if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq) left = this.toAssignable(left, false, refDestructuringErrors);
        if (!ownDestructuringErrors) {
            refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = -1;
            // reset these when detected inside this expression
            if (refDestructuringErrors.shorthandAssign >= left.start) refDestructuringErrors.shorthandAssign = -1;
            if (refDestructuringErrors.doubleProto >= left.start) refDestructuringErrors.doubleProto = -1;
        }
        if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq) this.checkLValPattern(left);
        else this.checkLValSimple(left);
        node.left = left;
        this.next();
        node.right = this.parseMaybeAssign(forInit);
        if (oldDoubleProto > -1) refDestructuringErrors.doubleProto = oldDoubleProto;
        return this.finishNode(node, "AssignmentExpression");
    } else if (ownDestructuringErrors) this.checkExpressionErrors(refDestructuringErrors, true);
    if (oldParenAssign > -1) refDestructuringErrors.parenthesizedAssign = oldParenAssign;
    if (oldTrailingComma > -1) refDestructuringErrors.trailingComma = oldTrailingComma;
    return left;
};
// Parse a ternary conditional (`?:`) operator.
$6fb78ed28ed3b042$var$pp$5.parseMaybeConditional = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprOps(forInit, refDestructuringErrors);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    if (!(expr.type === "ArrowFunctionExpression" && expr.start === startPos) && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.question)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.test = expr;
        node.consequent = this.parseMaybeAssign();
        this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon);
        node.alternate = this.parseMaybeAssign(forInit);
        return this.finishNode(node, "ConditionalExpression");
    }
    return expr;
};
// Start the precedence parser.
$6fb78ed28ed3b042$var$pp$5.parseExprOps = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeUnary(refDestructuringErrors, false, false, forInit);
    if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
    return expr.start === startPos && expr.type === "ArrowFunctionExpression" ? expr : this.parseExprOp(expr, startPos, startLoc, -1, forInit);
};
// Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.
$6fb78ed28ed3b042$var$pp$5.parseExprOp = function(left, leftStartPos, leftStartLoc, minPrec, forInit) {
    var prec = this.type.binop;
    if (prec != null && (!forInit || this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in)) {
        if (prec > minPrec) {
            var logical = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.logicalOR || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.logicalAND;
            var coalesce = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.coalesce;
            if (coalesce) // Handle the precedence of `tt.coalesce` as equal to the range of logical expressions.
            // In other words, `node.right` shouldn't contain logical expressions in order to check the mixed error.
            prec = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.logicalAND.binop;
            var op = this.value;
            this.next();
            var startPos = this.start, startLoc = this.startLoc;
            var right = this.parseExprOp(this.parseMaybeUnary(null, false, false, forInit), startPos, startLoc, prec, forInit);
            var node = this.buildBinary(leftStartPos, leftStartLoc, left, right, op, logical || coalesce);
            if (logical && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.coalesce || coalesce && (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.logicalOR || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.logicalAND)) this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses");
            return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, forInit);
        }
    }
    return left;
};
$6fb78ed28ed3b042$var$pp$5.buildBinary = function(startPos, startLoc, left, right, op, logical) {
    if (right.type === "PrivateIdentifier") this.raise(right.start, "Private identifier can only be left side of binary expression");
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.operator = op;
    node.right = right;
    return this.finishNode(node, logical ? "LogicalExpression" : "BinaryExpression");
};
// Parse unary operators, both prefix and postfix.
$6fb78ed28ed3b042$var$pp$5.parseMaybeUnary = function(refDestructuringErrors, sawUnary, incDec, forInit) {
    var startPos = this.start, startLoc = this.startLoc, expr;
    if (this.isContextual("await") && this.canAwait) {
        expr = this.parseAwait(forInit);
        sawUnary = true;
    } else if (this.type.prefix) {
        var node = this.startNode(), update = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.incDec;
        node.operator = this.value;
        node.prefix = true;
        this.next();
        node.argument = this.parseMaybeUnary(null, true, update, forInit);
        this.checkExpressionErrors(refDestructuringErrors, true);
        if (update) this.checkLValSimple(node.argument);
        else if (this.strict && node.operator === "delete" && $6fb78ed28ed3b042$var$isLocalVariableAccess(node.argument)) this.raiseRecoverable(node.start, "Deleting local variable in strict mode");
        else if (node.operator === "delete" && $6fb78ed28ed3b042$var$isPrivateFieldAccess(node.argument)) this.raiseRecoverable(node.start, "Private fields can not be deleted");
        else sawUnary = true;
        expr = this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
    } else if (!sawUnary && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.privateId) {
        if ((forInit || this.privateNameStack.length === 0) && this.options.checkPrivateFields) this.unexpected();
        expr = this.parsePrivateIdent();
        // only could be private fields in 'in', such as #x in obj
        if (this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._in) this.unexpected();
    } else {
        expr = this.parseExprSubscripts(refDestructuringErrors, forInit);
        if (this.checkExpressionErrors(refDestructuringErrors)) return expr;
        while(this.type.postfix && !this.canInsertSemicolon()){
            var node$1 = this.startNodeAt(startPos, startLoc);
            node$1.operator = this.value;
            node$1.prefix = false;
            node$1.argument = expr;
            this.checkLValSimple(expr);
            this.next();
            expr = this.finishNode(node$1, "UpdateExpression");
        }
    }
    if (!incDec && !(expr.type === "ArrowFunctionExpression" && expr.start === startPos) && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.starstar)) {
        if (sawUnary) this.unexpected(this.lastTokStart);
        else return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false, false, forInit), "**", false);
    } else return expr;
};
function $6fb78ed28ed3b042$var$isLocalVariableAccess(node) {
    return node.type === "Identifier" || node.type === "ParenthesizedExpression" && $6fb78ed28ed3b042$var$isLocalVariableAccess(node.expression);
}
function $6fb78ed28ed3b042$var$isPrivateFieldAccess(node) {
    return node.type === "MemberExpression" && node.property.type === "PrivateIdentifier" || node.type === "ChainExpression" && $6fb78ed28ed3b042$var$isPrivateFieldAccess(node.expression) || node.type === "ParenthesizedExpression" && $6fb78ed28ed3b042$var$isPrivateFieldAccess(node.expression);
}
// Parse call, dot, and `[]`-subscript expressions.
$6fb78ed28ed3b042$var$pp$5.parseExprSubscripts = function(refDestructuringErrors, forInit) {
    var startPos = this.start, startLoc = this.startLoc;
    var oldDoubleProto = -1, oldShorthandAssign = -1;
    if (refDestructuringErrors) {
        oldDoubleProto = refDestructuringErrors.doubleProto;
        oldShorthandAssign = refDestructuringErrors.shorthandAssign;
        refDestructuringErrors.doubleProto = refDestructuringErrors.shorthandAssign = -1;
    }
    var expr = this.parseExprAtom(refDestructuringErrors, forInit);
    if (expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")") return expr;
    var result = this.parseSubscripts(expr, startPos, startLoc, false, forInit);
    if (refDestructuringErrors) {
        if (result.end > expr.end) {
            this.checkExpressionErrors(refDestructuringErrors, true);
            if (refDestructuringErrors.parenthesizedAssign >= result.start) refDestructuringErrors.parenthesizedAssign = -1;
            if (refDestructuringErrors.parenthesizedBind >= result.start) refDestructuringErrors.parenthesizedBind = -1;
            if (refDestructuringErrors.trailingComma >= result.start) refDestructuringErrors.trailingComma = -1;
        }
        if (oldDoubleProto > -1) refDestructuringErrors.doubleProto = oldDoubleProto;
        if (oldShorthandAssign > -1) refDestructuringErrors.shorthandAssign = oldShorthandAssign;
    }
    return result;
};
$6fb78ed28ed3b042$var$pp$5.parseSubscripts = function(base, startPos, startLoc, noCalls, forInit) {
    var maybeAsyncArrow = this.options.ecmaVersion >= 8 && base.type === "Identifier" && base.name === "async" && this.lastTokEnd === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 && this.potentialArrowAt === base.start;
    var optionalChained = false;
    while(true){
        var element = this.parseSubscript(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit);
        if (element.optional) optionalChained = true;
        if (element.end === base.end || element.type === "ArrowFunctionExpression") {
            if (optionalChained) {
                var chainNode = this.startNodeAt(startPos, startLoc);
                chainNode.expression = element;
                element = this.finishNode(chainNode, "ChainExpression");
            }
            return element;
        }
        base = element;
        maybeAsyncArrow = false;
    }
};
$6fb78ed28ed3b042$var$pp$5.shouldParseAsyncArrow = function() {
    return !this.canInsertSemicolon() && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.arrow);
};
$6fb78ed28ed3b042$var$pp$5.parseSubscriptAsyncArrow = function(startPos, startLoc, exprList, forInit) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, true, forInit);
};
$6fb78ed28ed3b042$var$pp$5.parseSubscript = function(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit) {
    var optionalSupported = this.options.ecmaVersion >= 11;
    var optional = optionalSupported && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.questionDot);
    if (noCalls && optional) this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
    var computed = this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL);
    if (computed || optional && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.backQuote || this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dot)) {
        var node = this.startNodeAt(startPos, startLoc);
        node.object = base;
        if (computed) {
            node.property = this.parseExpression();
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketR);
        } else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.privateId && base.type !== "Super") node.property = this.parsePrivateIdent();
        else node.property = this.parseIdent(this.options.allowReserved !== "never");
        node.computed = !!computed;
        if (optionalSupported) node.optional = optional;
        base = this.finishNode(node, "MemberExpression");
    } else if (!noCalls && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL)) {
        var refDestructuringErrors = new $6fb78ed28ed3b042$var$DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
        this.yieldPos = 0;
        this.awaitPos = 0;
        this.awaitIdentPos = 0;
        var exprList = this.parseExprList($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR, this.options.ecmaVersion >= 8, false, refDestructuringErrors);
        if (maybeAsyncArrow && !optional && this.shouldParseAsyncArrow()) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            if (this.awaitIdentPos > 0) this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function");
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            this.awaitIdentPos = oldAwaitIdentPos;
            return this.parseSubscriptAsyncArrow(startPos, startLoc, exprList, forInit);
        }
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        this.awaitIdentPos = oldAwaitIdentPos || this.awaitIdentPos;
        var node$1 = this.startNodeAt(startPos, startLoc);
        node$1.callee = base;
        node$1.arguments = exprList;
        if (optionalSupported) node$1.optional = optional;
        base = this.finishNode(node$1, "CallExpression");
    } else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.backQuote) {
        if (optional || optionalChained) this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
        var node$2 = this.startNodeAt(startPos, startLoc);
        node$2.tag = base;
        node$2.quasi = this.parseTemplate({
            isTagged: true
        });
        base = this.finishNode(node$2, "TaggedTemplateExpression");
    }
    return base;
};
// Parse an atomic expression — either a single token that is an
// expression, an expression started by a keyword like `function` or
// `new`, or an expression wrapped in punctuation like `()`, `[]`,
// or `{}`.
$6fb78ed28ed3b042$var$pp$5.parseExprAtom = function(refDestructuringErrors, forInit, forNew) {
    // If a division operator appears in an expression position, the
    // tokenizer got confused, and we force it to read a regexp instead.
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.slash) this.readRegexp();
    var node, canBeArrow = this.potentialArrowAt === this.start;
    switch(this.type){
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._super:
            if (!this.allowSuper) this.raise(this.start, "'super' keyword outside a method");
            node = this.startNode();
            this.next();
            if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL && !this.allowDirectSuper) this.raise(node.start, "super() call outside constructor of a subclass");
            // The `super` keyword can appear at below:
            // SuperProperty:
            //     super [ Expression ]
            //     super . IdentifierName
            // SuperCall:
            //     super ( Arguments )
            if (this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dot && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL) this.unexpected();
            return this.finishNode(node, "Super");
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._this:
            node = this.startNode();
            this.next();
            return this.finishNode(node, "ThisExpression");
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name:
            var startPos = this.start, startLoc = this.startLoc, containsEsc = this.containsEsc;
            var id = this.parseIdent(false);
            if (this.options.ecmaVersion >= 8 && !containsEsc && id.name === "async" && !this.canInsertSemicolon() && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8._function)) {
                this.overrideContext($6fb78ed28ed3b042$export$2b5f701edfbd6f00.f_expr);
                return this.parseFunction(this.startNodeAt(startPos, startLoc), 0, false, true, forInit);
            }
            if (canBeArrow && !this.canInsertSemicolon()) {
                if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.arrow)) return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                    id
                ], false, forInit);
                if (this.options.ecmaVersion >= 8 && id.name === "async" && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name && !containsEsc && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc)) {
                    id = this.parseIdent(false);
                    if (this.canInsertSemicolon() || !this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.arrow)) this.unexpected();
                    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [
                        id
                    ], true, forInit);
                }
            }
            return id;
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.regexp:
            var value = this.value;
            node = this.parseLiteral(value.value);
            node.regex = {
                pattern: value.pattern,
                flags: value.flags
            };
            return node;
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.num:
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string:
            return this.parseLiteral(this.value);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._null:
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._true:
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._false:
            node = this.startNode();
            node.value = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._null ? null : this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._true;
            node.raw = this.type.keyword;
            this.next();
            return this.finishNode(node, "Literal");
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL:
            var start = this.start, expr = this.parseParenAndDistinguishExpression(canBeArrow, forInit);
            if (refDestructuringErrors) {
                if (refDestructuringErrors.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(expr)) refDestructuringErrors.parenthesizedAssign = start;
                if (refDestructuringErrors.parenthesizedBind < 0) refDestructuringErrors.parenthesizedBind = start;
            }
            return expr;
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL:
            node = this.startNode();
            this.next();
            node.elements = this.parseExprList($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketR, true, true, refDestructuringErrors);
            return this.finishNode(node, "ArrayExpression");
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL:
            this.overrideContext($6fb78ed28ed3b042$export$2b5f701edfbd6f00.b_expr);
            return this.parseObj(false, refDestructuringErrors);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._function:
            node = this.startNode();
            this.next();
            return this.parseFunction(node, 0);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._class:
            return this.parseClass(this.startNode(), false);
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._new:
            return this.parseNew();
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.backQuote:
            return this.parseTemplate();
        case $6fb78ed28ed3b042$export$b54c7ea7aabba5c8._import:
            if (this.options.ecmaVersion >= 11) return this.parseExprImport(forNew);
            else return this.unexpected();
        default:
            return this.parseExprAtomDefault();
    }
};
$6fb78ed28ed3b042$var$pp$5.parseExprAtomDefault = function() {
    this.unexpected();
};
$6fb78ed28ed3b042$var$pp$5.parseExprImport = function(forNew) {
    var node = this.startNode();
    // Consume `import` as an identifier for `import.meta`.
    // Because `this.parseIdent(true)` doesn't check escape sequences, it needs the check of `this.containsEsc`.
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword import");
    this.next();
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL && !forNew) return this.parseDynamicImport(node);
    else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dot) {
        var meta = this.startNodeAt(node.start, node.loc && node.loc.start);
        meta.name = "import";
        node.meta = this.finishNode(meta, "Identifier");
        return this.parseImportMeta(node);
    } else this.unexpected();
};
$6fb78ed28ed3b042$var$pp$5.parseDynamicImport = function(node) {
    this.next(); // skip `(`
    // Parse node.source.
    node.source = this.parseMaybeAssign();
    if (this.options.ecmaVersion >= 16) {
        if (!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR)) {
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
            if (!this.afterTrailingComma($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR)) {
                node.options = this.parseMaybeAssign();
                if (!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR)) {
                    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
                    if (!this.afterTrailingComma($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR)) this.unexpected();
                }
            } else node.options = null;
        } else node.options = null;
    } else // Verify ending.
    if (!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR)) {
        var errorPos = this.start;
        if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma) && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR)) this.raiseRecoverable(errorPos, "Trailing comma is not allowed in import()");
        else this.unexpected(errorPos);
    }
    return this.finishNode(node, "ImportExpression");
};
$6fb78ed28ed3b042$var$pp$5.parseImportMeta = function(node) {
    this.next(); // skip `.`
    var containsEsc = this.containsEsc;
    node.property = this.parseIdent(true);
    if (node.property.name !== "meta") this.raiseRecoverable(node.property.start, "The only valid meta property for import is 'import.meta'");
    if (containsEsc) this.raiseRecoverable(node.start, "'import.meta' must not contain escaped characters");
    if (this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere) this.raiseRecoverable(node.start, "Cannot use 'import.meta' outside a module");
    return this.finishNode(node, "MetaProperty");
};
$6fb78ed28ed3b042$var$pp$5.parseLiteral = function(value) {
    var node = this.startNode();
    node.value = value;
    node.raw = this.input.slice(this.start, this.end);
    if (node.raw.charCodeAt(node.raw.length - 1) === 110) node.bigint = node.value != null ? node.value.toString() : node.raw.slice(0, -1).replace(/_/g, "");
    this.next();
    return this.finishNode(node, "Literal");
};
$6fb78ed28ed3b042$var$pp$5.parseParenExpression = function() {
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL);
    var val = this.parseExpression();
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR);
    return val;
};
$6fb78ed28ed3b042$var$pp$5.shouldParseArrow = function(exprList) {
    return !this.canInsertSemicolon();
};
$6fb78ed28ed3b042$var$pp$5.parseParenAndDistinguishExpression = function(canBeArrow, forInit) {
    var startPos = this.start, startLoc = this.startLoc, val, allowTrailingComma = this.options.ecmaVersion >= 8;
    if (this.options.ecmaVersion >= 6) {
        this.next();
        var innerStartPos = this.start, innerStartLoc = this.startLoc;
        var exprList = [], first = true, lastIsComma = false;
        var refDestructuringErrors = new $6fb78ed28ed3b042$var$DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, spreadStart;
        this.yieldPos = 0;
        this.awaitPos = 0;
        // Do not save awaitIdentPos to allow checking awaits nested in parameters
        while(this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR){
            first ? first = false : this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
            if (allowTrailingComma && this.afterTrailingComma($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR, true)) {
                lastIsComma = true;
                break;
            } else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.ellipsis) {
                spreadStart = this.start;
                exprList.push(this.parseParenItem(this.parseRestBinding()));
                if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
                break;
            } else exprList.push(this.parseMaybeAssign(false, refDestructuringErrors, this.parseParenItem));
        }
        var innerEndPos = this.lastTokEnd, innerEndLoc = this.lastTokEndLoc;
        this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR);
        if (canBeArrow && this.shouldParseArrow(exprList) && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.arrow)) {
            this.checkPatternErrors(refDestructuringErrors, false);
            this.checkYieldAwaitInDefaultParams();
            this.yieldPos = oldYieldPos;
            this.awaitPos = oldAwaitPos;
            return this.parseParenArrowList(startPos, startLoc, exprList, forInit);
        }
        if (!exprList.length || lastIsComma) this.unexpected(this.lastTokStart);
        if (spreadStart) this.unexpected(spreadStart);
        this.checkExpressionErrors(refDestructuringErrors, true);
        this.yieldPos = oldYieldPos || this.yieldPos;
        this.awaitPos = oldAwaitPos || this.awaitPos;
        if (exprList.length > 1) {
            val = this.startNodeAt(innerStartPos, innerStartLoc);
            val.expressions = exprList;
            this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
        } else val = exprList[0];
    } else val = this.parseParenExpression();
    if (this.options.preserveParens) {
        var par = this.startNodeAt(startPos, startLoc);
        par.expression = val;
        return this.finishNode(par, "ParenthesizedExpression");
    } else return val;
};
$6fb78ed28ed3b042$var$pp$5.parseParenItem = function(item) {
    return item;
};
$6fb78ed28ed3b042$var$pp$5.parseParenArrowList = function(startPos, startLoc, exprList, forInit) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, false, forInit);
};
// New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.
var $6fb78ed28ed3b042$var$empty = [];
$6fb78ed28ed3b042$var$pp$5.parseNew = function() {
    if (this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword new");
    var node = this.startNode();
    this.next();
    if (this.options.ecmaVersion >= 6 && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dot) {
        var meta = this.startNodeAt(node.start, node.loc && node.loc.start);
        meta.name = "new";
        node.meta = this.finishNode(meta, "Identifier");
        this.next();
        var containsEsc = this.containsEsc;
        node.property = this.parseIdent(true);
        if (node.property.name !== "target") this.raiseRecoverable(node.property.start, "The only valid meta property for new is 'new.target'");
        if (containsEsc) this.raiseRecoverable(node.start, "'new.target' must not contain escaped characters");
        if (!this.allowNewDotTarget) this.raiseRecoverable(node.start, "'new.target' can only be used in functions and class static block");
        return this.finishNode(node, "MetaProperty");
    }
    var startPos = this.start, startLoc = this.startLoc;
    node.callee = this.parseSubscripts(this.parseExprAtom(null, false, true), startPos, startLoc, true, false);
    if (node.callee.type === "Super") this.raiseRecoverable(startPos, "Invalid use of 'super'");
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL)) node.arguments = this.parseExprList($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR, this.options.ecmaVersion >= 8, false);
    else node.arguments = $6fb78ed28ed3b042$var$empty;
    return this.finishNode(node, "NewExpression");
};
// Parse template expression.
$6fb78ed28ed3b042$var$pp$5.parseTemplateElement = function(ref) {
    var isTagged = ref.isTagged;
    var elem = this.startNode();
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.invalidTemplate) {
        if (!isTagged) this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal");
        elem.value = {
            raw: this.value.replace(/\r\n?/g, "\n"),
            cooked: null
        };
    } else elem.value = {
        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
        cooked: this.value
    };
    this.next();
    elem.tail = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.backQuote;
    return this.finishNode(elem, "TemplateElement");
};
$6fb78ed28ed3b042$var$pp$5.parseTemplate = function(ref) {
    if (ref === void 0) ref = {};
    var isTagged = ref.isTagged;
    if (isTagged === void 0) isTagged = false;
    var node = this.startNode();
    this.next();
    node.expressions = [];
    var curElt = this.parseTemplateElement({
        isTagged: isTagged
    });
    node.quasis = [
        curElt
    ];
    while(!curElt.tail){
        if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eof) this.raise(this.pos, "Unterminated template literal");
        this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dollarBraceL);
        node.expressions.push(this.parseExpression());
        this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR);
        node.quasis.push(curElt = this.parseTemplateElement({
            isTagged: isTagged
        }));
    }
    this.next();
    return this.finishNode(node, "TemplateLiteral");
};
$6fb78ed28ed3b042$var$pp$5.isAsyncProp = function(prop) {
    return !prop.computed && prop.key.type === "Identifier" && prop.key.name === "async" && (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.num || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star) && !$6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.start));
};
// Parse an object literal or binding pattern.
$6fb78ed28ed3b042$var$pp$5.parseObj = function(isPattern, refDestructuringErrors) {
    var node = this.startNode(), first = true, propHash = {};
    node.properties = [];
    this.next();
    while(!this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)){
        if (!first) {
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
            if (this.options.ecmaVersion >= 5 && this.afterTrailingComma($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR)) break;
        } else first = false;
        var prop = this.parseProperty(isPattern, refDestructuringErrors);
        if (!isPattern) this.checkPropClash(prop, propHash, refDestructuringErrors);
        node.properties.push(prop);
    }
    return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression");
};
$6fb78ed28ed3b042$var$pp$5.parseProperty = function(isPattern, refDestructuringErrors) {
    var prop = this.startNode(), isGenerator, isAsync, startPos, startLoc;
    if (this.options.ecmaVersion >= 9 && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.ellipsis)) {
        if (isPattern) {
            prop.argument = this.parseIdent(false);
            if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma) this.raiseRecoverable(this.start, "Comma is not permitted after the rest element");
            return this.finishNode(prop, "RestElement");
        }
        // Parse argument.
        prop.argument = this.parseMaybeAssign(false, refDestructuringErrors);
        // To disallow trailing comma via `this.toAssignable()`.
        if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma && refDestructuringErrors && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        // Finish
        return this.finishNode(prop, "SpreadElement");
    }
    if (this.options.ecmaVersion >= 6) {
        prop.method = false;
        prop.shorthand = false;
        if (isPattern || refDestructuringErrors) {
            startPos = this.start;
            startLoc = this.startLoc;
        }
        if (!isPattern) isGenerator = this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star);
    }
    var containsEsc = this.containsEsc;
    this.parsePropertyName(prop);
    if (!isPattern && !containsEsc && this.options.ecmaVersion >= 8 && !isGenerator && this.isAsyncProp(prop)) {
        isAsync = true;
        isGenerator = this.options.ecmaVersion >= 9 && this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star);
        this.parsePropertyName(prop);
    } else isAsync = false;
    this.parsePropertyValue(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc);
    return this.finishNode(prop, "Property");
};
$6fb78ed28ed3b042$var$pp$5.parseGetterSetter = function(prop) {
    var kind = prop.key.name;
    this.parsePropertyName(prop);
    prop.value = this.parseMethod(false);
    prop.kind = kind;
    var paramCount = prop.kind === "get" ? 0 : 1;
    if (prop.value.params.length !== paramCount) {
        var start = prop.value.start;
        if (prop.kind === "get") this.raiseRecoverable(start, "getter should have no params");
        else this.raiseRecoverable(start, "setter should have exactly one param");
    } else if (prop.kind === "set" && prop.value.params[0].type === "RestElement") this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params");
};
$6fb78ed28ed3b042$var$pp$5.parsePropertyValue = function(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc) {
    if ((isGenerator || isAsync) && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon) this.unexpected();
    if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon)) {
        prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors);
        prop.kind = "init";
    } else if (this.options.ecmaVersion >= 6 && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL) {
        if (isPattern) this.unexpected();
        prop.method = true;
        prop.value = this.parseMethod(isGenerator, isAsync);
        prop.kind = "init";
    } else if (!isPattern && !containsEsc && this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" && (prop.key.name === "get" || prop.key.name === "set") && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq) {
        if (isGenerator || isAsync) this.unexpected();
        this.parseGetterSetter(prop);
    } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
        if (isGenerator || isAsync) this.unexpected();
        this.checkUnreserved(prop.key);
        if (prop.key.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = startPos;
        if (isPattern) prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
        else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq && refDestructuringErrors) {
            if (refDestructuringErrors.shorthandAssign < 0) refDestructuringErrors.shorthandAssign = this.start;
            prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
        } else prop.value = this.copyNode(prop.key);
        prop.kind = "init";
        prop.shorthand = true;
    } else this.unexpected();
};
$6fb78ed28ed3b042$var$pp$5.parsePropertyName = function(prop) {
    if (this.options.ecmaVersion >= 6) {
        if (this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL)) {
            prop.computed = true;
            prop.key = this.parseMaybeAssign();
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketR);
            return prop.key;
        } else prop.computed = false;
    }
    return prop.key = this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.num || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
// Initialize empty function node.
$6fb78ed28ed3b042$var$pp$5.initFunction = function(node) {
    node.id = null;
    if (this.options.ecmaVersion >= 6) node.generator = node.expression = false;
    if (this.options.ecmaVersion >= 8) node.async = false;
};
// Parse object or class method.
$6fb78ed28ed3b042$var$pp$5.parseMethod = function(isGenerator, isAsync, allowDirectSuper) {
    var node = this.startNode(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.initFunction(node);
    if (this.options.ecmaVersion >= 6) node.generator = isGenerator;
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope($6fb78ed28ed3b042$var$functionFlags(isAsync, node.generator) | $6fb78ed28ed3b042$var$SCOPE_SUPER | (allowDirectSuper ? $6fb78ed28ed3b042$var$SCOPE_DIRECT_SUPER : 0));
    this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL);
    node.params = this.parseBindingList($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
    this.parseFunctionBody(node, false, true, false);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "FunctionExpression");
};
// Parse arrow function expression with given parameters.
$6fb78ed28ed3b042$var$pp$5.parseArrowExpression = function(node, params, isAsync, forInit) {
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.enterScope($6fb78ed28ed3b042$var$functionFlags(isAsync, false) | $6fb78ed28ed3b042$var$SCOPE_ARROW);
    this.initFunction(node);
    if (this.options.ecmaVersion >= 8) node.async = !!isAsync;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    node.params = this.toAssignableList(params, true);
    this.parseFunctionBody(node, true, false, forInit);
    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "ArrowFunctionExpression");
};
// Parse function body and check parameters.
$6fb78ed28ed3b042$var$pp$5.parseFunctionBody = function(node, isArrowFunction, isMethod, forInit) {
    var isExpression = isArrowFunction && this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL;
    var oldStrict = this.strict, useStrict = false;
    if (isExpression) {
        node.body = this.parseMaybeAssign(forInit);
        node.expression = true;
        this.checkParams(node, false);
    } else {
        var nonSimple = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(node.params);
        if (!oldStrict || nonSimple) {
            useStrict = this.strictDirective(this.end);
            // If this is a strict mode function, verify that argument names
            // are not repeated, and it does not try to bind the words `eval`
            // or `arguments`.
            if (useStrict && nonSimple) this.raiseRecoverable(node.start, "Illegal 'use strict' directive in function with non-simple parameter list");
        }
        // Start a new scope with regard to labels and the `inFunction`
        // flag (restore them to their old value afterwards).
        var oldLabels = this.labels;
        this.labels = [];
        if (useStrict) this.strict = true;
        // Add the params to varDeclaredNames to ensure that an error is thrown
        // if a let/const declaration in the function clashes with one of the params.
        this.checkParams(node, !oldStrict && !useStrict && !isArrowFunction && !isMethod && this.isSimpleParamList(node.params));
        // Ensure the function name isn't a forbidden identifier in strict mode, e.g. 'eval'
        if (this.strict && node.id) this.checkLValSimple(node.id, $6fb78ed28ed3b042$var$BIND_OUTSIDE);
        node.body = this.parseBlock(false, undefined, useStrict && !oldStrict);
        node.expression = false;
        this.adaptDirectivePrologue(node.body.body);
        this.labels = oldLabels;
    }
    this.exitScope();
};
$6fb78ed28ed3b042$var$pp$5.isSimpleParamList = function(params) {
    for(var i = 0, list = params; i < list.length; i += 1){
        var param = list[i];
        if (param.type !== "Identifier") return false;
    }
    return true;
};
// Checks function params for various disallowed patterns such as using "eval"
// or "arguments" and duplicate parameters.
$6fb78ed28ed3b042$var$pp$5.checkParams = function(node, allowDuplicates) {
    var nameHash = Object.create(null);
    for(var i = 0, list = node.params; i < list.length; i += 1){
        var param = list[i];
        this.checkLValInnerPattern(param, $6fb78ed28ed3b042$var$BIND_VAR, allowDuplicates ? null : nameHash);
    }
};
// Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).
$6fb78ed28ed3b042$var$pp$5.parseExprList = function(close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
    var elts = [], first = true;
    while(!this.eat(close)){
        if (!first) {
            this.expect($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
            if (allowTrailingComma && this.afterTrailingComma(close)) break;
        } else first = false;
        var elt = void 0;
        if (allowEmpty && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma) elt = null;
        else if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.ellipsis) {
            elt = this.parseSpread(refDestructuringErrors);
            if (refDestructuringErrors && this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma && refDestructuringErrors.trailingComma < 0) refDestructuringErrors.trailingComma = this.start;
        } else elt = this.parseMaybeAssign(false, refDestructuringErrors);
        elts.push(elt);
    }
    return elts;
};
$6fb78ed28ed3b042$var$pp$5.checkUnreserved = function(ref) {
    var start = ref.start;
    var end = ref.end;
    var name = ref.name;
    if (this.inGenerator && name === "yield") this.raiseRecoverable(start, "Cannot use 'yield' as identifier inside a generator");
    if (this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use 'await' as identifier inside an async function");
    if (!(this.currentThisScope().flags & $6fb78ed28ed3b042$var$SCOPE_VAR) && name === "arguments") this.raiseRecoverable(start, "Cannot use 'arguments' in class field initializer");
    if (this.inClassStaticBlock && (name === "arguments" || name === "await")) this.raise(start, "Cannot use " + name + " in class static initialization block");
    if (this.keywords.test(name)) this.raise(start, "Unexpected keyword '" + name + "'");
    if (this.options.ecmaVersion < 6 && this.input.slice(start, end).indexOf("\\") !== -1) return;
    var re = this.strict ? this.reservedWordsStrict : this.reservedWords;
    if (re.test(name)) {
        if (!this.inAsync && name === "await") this.raiseRecoverable(start, "Cannot use keyword 'await' outside an async function");
        this.raiseRecoverable(start, "The keyword '" + name + "' is reserved");
    }
};
// Parse the next token as an identifier. If `liberal` is true (used
// when parsing properties), it will also convert keywords into
// identifiers.
$6fb78ed28ed3b042$var$pp$5.parseIdent = function(liberal) {
    var node = this.parseIdentNode();
    this.next(!!liberal);
    this.finishNode(node, "Identifier");
    if (!liberal) {
        this.checkUnreserved(node);
        if (node.name === "await" && !this.awaitIdentPos) this.awaitIdentPos = node.start;
    }
    return node;
};
$6fb78ed28ed3b042$var$pp$5.parseIdentNode = function() {
    var node = this.startNode();
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name) node.name = this.value;
    else if (this.type.keyword) {
        node.name = this.type.keyword;
        // To fix https://github.com/acornjs/acorn/issues/575
        // `class` and `function` keywords push new context into this.context.
        // But there is no chance to pop the context if the keyword is consumed as an identifier such as a property name.
        // If the previous token is a dot, this does not apply because the context-managing code already ignored the keyword
        if ((node.name === "class" || node.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46)) this.context.pop();
        this.type = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name;
    } else this.unexpected();
    return node;
};
$6fb78ed28ed3b042$var$pp$5.parsePrivateIdent = function() {
    var node = this.startNode();
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.privateId) node.name = this.value;
    else this.unexpected();
    this.next();
    this.finishNode(node, "PrivateIdentifier");
    // For validating existence
    if (this.options.checkPrivateFields) {
        if (this.privateNameStack.length === 0) this.raise(node.start, "Private field '#" + node.name + "' must be declared in an enclosing class");
        else this.privateNameStack[this.privateNameStack.length - 1].used.push(node);
    }
    return node;
};
// Parses yield expression inside generator.
$6fb78ed28ed3b042$var$pp$5.parseYield = function(forInit) {
    if (!this.yieldPos) this.yieldPos = this.start;
    var node = this.startNode();
    this.next();
    if (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi || this.canInsertSemicolon() || this.type !== $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star && !this.type.startsExpr) {
        node.delegate = false;
        node.argument = null;
    } else {
        node.delegate = this.eat($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star);
        node.argument = this.parseMaybeAssign(forInit);
    }
    return this.finishNode(node, "YieldExpression");
};
$6fb78ed28ed3b042$var$pp$5.parseAwait = function(forInit) {
    if (!this.awaitPos) this.awaitPos = this.start;
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeUnary(null, true, false, forInit);
    return this.finishNode(node, "AwaitExpression");
};
var $6fb78ed28ed3b042$var$pp$4 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
// This function is used to raise exceptions on parse errors. It
// takes an offset integer (into the current `input`) to indicate
// the location of the error, attaches the position to the end
// of the error message, and then raises a `SyntaxError` with that
// message.
$6fb78ed28ed3b042$var$pp$4.raise = function(pos, message) {
    var loc = $6fb78ed28ed3b042$export$7af82191547c5ff7(this.input, pos);
    message += " (" + loc.line + ":" + loc.column + ")";
    if (this.sourceFile) message += " in " + this.sourceFile;
    var err = new SyntaxError(message);
    err.pos = pos;
    err.loc = loc;
    err.raisedAt = this.pos;
    throw err;
};
$6fb78ed28ed3b042$var$pp$4.raiseRecoverable = $6fb78ed28ed3b042$var$pp$4.raise;
$6fb78ed28ed3b042$var$pp$4.curPosition = function() {
    if (this.options.locations) return new $6fb78ed28ed3b042$export$13807d9ee5a34a42(this.curLine, this.pos - this.lineStart);
};
var $6fb78ed28ed3b042$var$pp$3 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
var $6fb78ed28ed3b042$var$Scope = function Scope(flags) {
    this.flags = flags;
    // A list of var-declared names in the current lexical scope
    this.var = [];
    // A list of lexically-declared names in the current lexical scope
    this.lexical = [];
    // A list of lexically-declared FunctionDeclaration names in the current lexical scope
    this.functions = [];
};
// The functions in this module keep track of declared variables in the current scope in order to detect duplicate variable names.
$6fb78ed28ed3b042$var$pp$3.enterScope = function(flags) {
    this.scopeStack.push(new $6fb78ed28ed3b042$var$Scope(flags));
};
$6fb78ed28ed3b042$var$pp$3.exitScope = function() {
    this.scopeStack.pop();
};
// The spec says:
// > At the top level of a function, or script, function declarations are
// > treated like var declarations rather than like lexical declarations.
$6fb78ed28ed3b042$var$pp$3.treatFunctionsAsVarInScope = function(scope) {
    return scope.flags & $6fb78ed28ed3b042$var$SCOPE_FUNCTION || !this.inModule && scope.flags & $6fb78ed28ed3b042$var$SCOPE_TOP;
};
$6fb78ed28ed3b042$var$pp$3.declareName = function(name, bindingType, pos) {
    var redeclared = false;
    if (bindingType === $6fb78ed28ed3b042$var$BIND_LEXICAL) {
        var scope = this.currentScope();
        redeclared = scope.lexical.indexOf(name) > -1 || scope.functions.indexOf(name) > -1 || scope.var.indexOf(name) > -1;
        scope.lexical.push(name);
        if (this.inModule && scope.flags & $6fb78ed28ed3b042$var$SCOPE_TOP) delete this.undefinedExports[name];
    } else if (bindingType === $6fb78ed28ed3b042$var$BIND_SIMPLE_CATCH) {
        var scope$1 = this.currentScope();
        scope$1.lexical.push(name);
    } else if (bindingType === $6fb78ed28ed3b042$var$BIND_FUNCTION) {
        var scope$2 = this.currentScope();
        if (this.treatFunctionsAsVar) redeclared = scope$2.lexical.indexOf(name) > -1;
        else redeclared = scope$2.lexical.indexOf(name) > -1 || scope$2.var.indexOf(name) > -1;
        scope$2.functions.push(name);
    } else for(var i = this.scopeStack.length - 1; i >= 0; --i){
        var scope$3 = this.scopeStack[i];
        if (scope$3.lexical.indexOf(name) > -1 && !(scope$3.flags & $6fb78ed28ed3b042$var$SCOPE_SIMPLE_CATCH && scope$3.lexical[0] === name) || !this.treatFunctionsAsVarInScope(scope$3) && scope$3.functions.indexOf(name) > -1) {
            redeclared = true;
            break;
        }
        scope$3.var.push(name);
        if (this.inModule && scope$3.flags & $6fb78ed28ed3b042$var$SCOPE_TOP) delete this.undefinedExports[name];
        if (scope$3.flags & $6fb78ed28ed3b042$var$SCOPE_VAR) break;
    }
    if (redeclared) this.raiseRecoverable(pos, "Identifier '" + name + "' has already been declared");
};
$6fb78ed28ed3b042$var$pp$3.checkLocalExport = function(id) {
    // scope.functions must be empty as Module code is always strict.
    if (this.scopeStack[0].lexical.indexOf(id.name) === -1 && this.scopeStack[0].var.indexOf(id.name) === -1) this.undefinedExports[id.name] = id;
};
$6fb78ed28ed3b042$var$pp$3.currentScope = function() {
    return this.scopeStack[this.scopeStack.length - 1];
};
$6fb78ed28ed3b042$var$pp$3.currentVarScope = function() {
    for(var i = this.scopeStack.length - 1;; i--){
        var scope = this.scopeStack[i];
        if (scope.flags & ($6fb78ed28ed3b042$var$SCOPE_VAR | $6fb78ed28ed3b042$var$SCOPE_CLASS_FIELD_INIT | $6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK)) return scope;
    }
};
// Could be useful for `this`, `new.target`, `super()`, `super.property`, and `super[property]`.
$6fb78ed28ed3b042$var$pp$3.currentThisScope = function() {
    for(var i = this.scopeStack.length - 1;; i--){
        var scope = this.scopeStack[i];
        if (scope.flags & ($6fb78ed28ed3b042$var$SCOPE_VAR | $6fb78ed28ed3b042$var$SCOPE_CLASS_FIELD_INIT | $6fb78ed28ed3b042$var$SCOPE_CLASS_STATIC_BLOCK) && !(scope.flags & $6fb78ed28ed3b042$var$SCOPE_ARROW)) return scope;
    }
};
var $6fb78ed28ed3b042$export$85c928794f8d04d4 = function Node(parser, pos, loc) {
    this.type = "";
    this.start = pos;
    this.end = 0;
    if (parser.options.locations) this.loc = new $6fb78ed28ed3b042$export$7387db7caf96fcdb(parser, loc);
    if (parser.options.directSourceFile) this.sourceFile = parser.options.directSourceFile;
    if (parser.options.ranges) this.range = [
        pos,
        0
    ];
};
// Start an AST node, attaching a start offset.
var $6fb78ed28ed3b042$var$pp$2 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
$6fb78ed28ed3b042$var$pp$2.startNode = function() {
    return new $6fb78ed28ed3b042$export$85c928794f8d04d4(this, this.start, this.startLoc);
};
$6fb78ed28ed3b042$var$pp$2.startNodeAt = function(pos, loc) {
    return new $6fb78ed28ed3b042$export$85c928794f8d04d4(this, pos, loc);
};
// Finish an AST node, adding `type` and `end` properties.
function $6fb78ed28ed3b042$var$finishNodeAt(node, type, pos, loc) {
    node.type = type;
    node.end = pos;
    if (this.options.locations) node.loc.end = loc;
    if (this.options.ranges) node.range[1] = pos;
    return node;
}
$6fb78ed28ed3b042$var$pp$2.finishNode = function(node, type) {
    return $6fb78ed28ed3b042$var$finishNodeAt.call(this, node, type, this.lastTokEnd, this.lastTokEndLoc);
};
// Finish node at given position
$6fb78ed28ed3b042$var$pp$2.finishNodeAt = function(node, type, pos, loc) {
    return $6fb78ed28ed3b042$var$finishNodeAt.call(this, node, type, pos, loc);
};
$6fb78ed28ed3b042$var$pp$2.copyNode = function(node) {
    var newNode = new $6fb78ed28ed3b042$export$85c928794f8d04d4(this, node.start, this.startLoc);
    for(var prop in node)newNode[prop] = node[prop];
    return newNode;
};
// This file was generated by "bin/generate-unicode-script-values.js". Do not modify manually!
var $6fb78ed28ed3b042$var$scriptValuesAddedInUnicode = "Berf Beria_Erfe Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sidetic Sidt Sunu Sunuwar Tai_Yo Tayo Todhri Todr Tolong_Siki Tols Tulu_Tigalari Tutg Unknown Zzzz";
// This file contains Unicode properties extracted from the ECMAScript specification.
// The lists are extracted like so:
// $$('#table-binary-unicode-properties > figure > table > tbody > tr > td:nth-child(1) code').map(el => el.innerText)
// #table-binary-unicode-properties
var $6fb78ed28ed3b042$var$ecma9BinaryProperties = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS";
var $6fb78ed28ed3b042$var$ecma10BinaryProperties = $6fb78ed28ed3b042$var$ecma9BinaryProperties + " Extended_Pictographic";
var $6fb78ed28ed3b042$var$ecma11BinaryProperties = $6fb78ed28ed3b042$var$ecma10BinaryProperties;
var $6fb78ed28ed3b042$var$ecma12BinaryProperties = $6fb78ed28ed3b042$var$ecma11BinaryProperties + " EBase EComp EMod EPres ExtPict";
var $6fb78ed28ed3b042$var$ecma13BinaryProperties = $6fb78ed28ed3b042$var$ecma12BinaryProperties;
var $6fb78ed28ed3b042$var$ecma14BinaryProperties = $6fb78ed28ed3b042$var$ecma13BinaryProperties;
var $6fb78ed28ed3b042$var$unicodeBinaryProperties = {
    9: $6fb78ed28ed3b042$var$ecma9BinaryProperties,
    10: $6fb78ed28ed3b042$var$ecma10BinaryProperties,
    11: $6fb78ed28ed3b042$var$ecma11BinaryProperties,
    12: $6fb78ed28ed3b042$var$ecma12BinaryProperties,
    13: $6fb78ed28ed3b042$var$ecma13BinaryProperties,
    14: $6fb78ed28ed3b042$var$ecma14BinaryProperties
};
// #table-binary-unicode-properties-of-strings
var $6fb78ed28ed3b042$var$ecma14BinaryPropertiesOfStrings = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji";
var $6fb78ed28ed3b042$var$unicodeBinaryPropertiesOfStrings = {
    9: "",
    10: "",
    11: "",
    12: "",
    13: "",
    14: $6fb78ed28ed3b042$var$ecma14BinaryPropertiesOfStrings
};
// #table-unicode-general-category-values
var $6fb78ed28ed3b042$var$unicodeGeneralCategoryValues = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu";
// #table-unicode-script-values
var $6fb78ed28ed3b042$var$ecma9ScriptValues = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb";
var $6fb78ed28ed3b042$var$ecma10ScriptValues = $6fb78ed28ed3b042$var$ecma9ScriptValues + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd";
var $6fb78ed28ed3b042$var$ecma11ScriptValues = $6fb78ed28ed3b042$var$ecma10ScriptValues + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho";
var $6fb78ed28ed3b042$var$ecma12ScriptValues = $6fb78ed28ed3b042$var$ecma11ScriptValues + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi";
var $6fb78ed28ed3b042$var$ecma13ScriptValues = $6fb78ed28ed3b042$var$ecma12ScriptValues + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith";
var $6fb78ed28ed3b042$var$ecma14ScriptValues = $6fb78ed28ed3b042$var$ecma13ScriptValues + " " + $6fb78ed28ed3b042$var$scriptValuesAddedInUnicode;
var $6fb78ed28ed3b042$var$unicodeScriptValues = {
    9: $6fb78ed28ed3b042$var$ecma9ScriptValues,
    10: $6fb78ed28ed3b042$var$ecma10ScriptValues,
    11: $6fb78ed28ed3b042$var$ecma11ScriptValues,
    12: $6fb78ed28ed3b042$var$ecma12ScriptValues,
    13: $6fb78ed28ed3b042$var$ecma13ScriptValues,
    14: $6fb78ed28ed3b042$var$ecma14ScriptValues
};
var $6fb78ed28ed3b042$var$data = {};
function $6fb78ed28ed3b042$var$buildUnicodeData(ecmaVersion) {
    var d = $6fb78ed28ed3b042$var$data[ecmaVersion] = {
        binary: $6fb78ed28ed3b042$var$wordsRegexp($6fb78ed28ed3b042$var$unicodeBinaryProperties[ecmaVersion] + " " + $6fb78ed28ed3b042$var$unicodeGeneralCategoryValues),
        binaryOfStrings: $6fb78ed28ed3b042$var$wordsRegexp($6fb78ed28ed3b042$var$unicodeBinaryPropertiesOfStrings[ecmaVersion]),
        nonBinary: {
            General_Category: $6fb78ed28ed3b042$var$wordsRegexp($6fb78ed28ed3b042$var$unicodeGeneralCategoryValues),
            Script: $6fb78ed28ed3b042$var$wordsRegexp($6fb78ed28ed3b042$var$unicodeScriptValues[ecmaVersion])
        }
    };
    d.nonBinary.Script_Extensions = d.nonBinary.Script;
    d.nonBinary.gc = d.nonBinary.General_Category;
    d.nonBinary.sc = d.nonBinary.Script;
    d.nonBinary.scx = d.nonBinary.Script_Extensions;
}
for(var $6fb78ed28ed3b042$var$i = 0, $6fb78ed28ed3b042$var$list = [
    9,
    10,
    11,
    12,
    13,
    14
]; $6fb78ed28ed3b042$var$i < $6fb78ed28ed3b042$var$list.length; $6fb78ed28ed3b042$var$i += 1){
    var $6fb78ed28ed3b042$var$ecmaVersion = $6fb78ed28ed3b042$var$list[$6fb78ed28ed3b042$var$i];
    $6fb78ed28ed3b042$var$buildUnicodeData($6fb78ed28ed3b042$var$ecmaVersion);
}
var $6fb78ed28ed3b042$var$pp$1 = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
// Track disjunction structure to determine whether a duplicate
// capture group name is allowed because it is in a separate branch.
var $6fb78ed28ed3b042$var$BranchID = function BranchID(parent, base) {
    // Parent disjunction branch
    this.parent = parent;
    // Identifies this set of sibling branches
    this.base = base || this;
};
$6fb78ed28ed3b042$var$BranchID.prototype.separatedFrom = function separatedFrom(alt) {
    // A branch is separate from another branch if they or any of
    // their parents are siblings in a given disjunction
    for(var self = this; self; self = self.parent)for(var other = alt; other; other = other.parent){
        if (self.base === other.base && self !== other) return true;
    }
    return false;
};
$6fb78ed28ed3b042$var$BranchID.prototype.sibling = function sibling() {
    return new $6fb78ed28ed3b042$var$BranchID(this.parent, this.base);
};
var $6fb78ed28ed3b042$var$RegExpValidationState = function RegExpValidationState(parser) {
    this.parser = parser;
    this.validFlags = "gim" + (parser.options.ecmaVersion >= 6 ? "uy" : "") + (parser.options.ecmaVersion >= 9 ? "s" : "") + (parser.options.ecmaVersion >= 13 ? "d" : "") + (parser.options.ecmaVersion >= 15 ? "v" : "");
    this.unicodeProperties = $6fb78ed28ed3b042$var$data[parser.options.ecmaVersion >= 14 ? 14 : parser.options.ecmaVersion];
    this.source = "";
    this.flags = "";
    this.start = 0;
    this.switchU = false;
    this.switchV = false;
    this.switchN = false;
    this.pos = 0;
    this.lastIntValue = 0;
    this.lastStringValue = "";
    this.lastAssertionIsQuantifiable = false;
    this.numCapturingParens = 0;
    this.maxBackReference = 0;
    this.groupNames = Object.create(null);
    this.backReferenceNames = [];
    this.branchID = null;
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.reset = function reset(start, pattern, flags) {
    var unicodeSets = flags.indexOf("v") !== -1;
    var unicode = flags.indexOf("u") !== -1;
    this.start = start | 0;
    this.source = pattern + "";
    this.flags = flags;
    if (unicodeSets && this.parser.options.ecmaVersion >= 15) {
        this.switchU = true;
        this.switchV = true;
        this.switchN = true;
    } else {
        this.switchU = unicode && this.parser.options.ecmaVersion >= 6;
        this.switchV = false;
        this.switchN = unicode && this.parser.options.ecmaVersion >= 9;
    }
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.raise = function raise(message) {
    this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + message);
};
// If u flag is given, this returns the code point at the index (it combines a surrogate pair).
// Otherwise, this returns the code unit of the index (can be a part of a surrogate pair).
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.at = function at(i, forceU) {
    if (forceU === void 0) forceU = false;
    var s = this.source;
    var l = s.length;
    if (i >= l) return -1;
    var c = s.charCodeAt(i);
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l) return c;
    var next = s.charCodeAt(i + 1);
    return next >= 0xDC00 && next <= 0xDFFF ? (c << 10) + next - 0x35FDC00 : c;
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.nextIndex = function nextIndex(i, forceU) {
    if (forceU === void 0) forceU = false;
    var s = this.source;
    var l = s.length;
    if (i >= l) return l;
    var c = s.charCodeAt(i), next;
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l || (next = s.charCodeAt(i + 1)) < 0xDC00 || next > 0xDFFF) return i + 1;
    return i + 2;
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.current = function current(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.pos, forceU);
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.lookahead = function lookahead(forceU) {
    if (forceU === void 0) forceU = false;
    return this.at(this.nextIndex(this.pos, forceU), forceU);
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.advance = function advance(forceU) {
    if (forceU === void 0) forceU = false;
    this.pos = this.nextIndex(this.pos, forceU);
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.eat = function eat(ch, forceU) {
    if (forceU === void 0) forceU = false;
    if (this.current(forceU) === ch) {
        this.advance(forceU);
        return true;
    }
    return false;
};
$6fb78ed28ed3b042$var$RegExpValidationState.prototype.eatChars = function eatChars(chs, forceU) {
    if (forceU === void 0) forceU = false;
    var pos = this.pos;
    for(var i = 0, list = chs; i < list.length; i += 1){
        var ch = list[i];
        var current = this.at(pos, forceU);
        if (current === -1 || current !== ch) return false;
        pos = this.nextIndex(pos, forceU);
    }
    this.pos = pos;
    return true;
};
/**
 * Validate the flags part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */ $6fb78ed28ed3b042$var$pp$1.validateRegExpFlags = function(state) {
    var validFlags = state.validFlags;
    var flags = state.flags;
    var u = false;
    var v = false;
    for(var i = 0; i < flags.length; i++){
        var flag = flags.charAt(i);
        if (validFlags.indexOf(flag) === -1) this.raise(state.start, "Invalid regular expression flag");
        if (flags.indexOf(flag, i + 1) > -1) this.raise(state.start, "Duplicate regular expression flag");
        if (flag === "u") u = true;
        if (flag === "v") v = true;
    }
    if (this.options.ecmaVersion >= 15 && u && v) this.raise(state.start, "Invalid regular expression flag");
};
function $6fb78ed28ed3b042$var$hasProp(obj) {
    for(var _ in obj)return true;
    return false;
}
/**
 * Validate the pattern part of a given RegExpLiteral.
 *
 * @param {RegExpValidationState} state The state to validate RegExp.
 * @returns {void}
 */ $6fb78ed28ed3b042$var$pp$1.validateRegExpPattern = function(state) {
    this.regexp_pattern(state);
    // The goal symbol for the parse is |Pattern[~U, ~N]|. If the result of
    // parsing contains a |GroupName|, reparse with the goal symbol
    // |Pattern[~U, +N]| and use this result instead. Throw a *SyntaxError*
    // exception if _P_ did not conform to the grammar, if any elements of _P_
    // were not matched by the parse, or if any Early Error conditions exist.
    if (!state.switchN && this.options.ecmaVersion >= 9 && $6fb78ed28ed3b042$var$hasProp(state.groupNames)) {
        state.switchN = true;
        this.regexp_pattern(state);
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Pattern
$6fb78ed28ed3b042$var$pp$1.regexp_pattern = function(state) {
    state.pos = 0;
    state.lastIntValue = 0;
    state.lastStringValue = "";
    state.lastAssertionIsQuantifiable = false;
    state.numCapturingParens = 0;
    state.maxBackReference = 0;
    state.groupNames = Object.create(null);
    state.backReferenceNames.length = 0;
    state.branchID = null;
    this.regexp_disjunction(state);
    if (state.pos !== state.source.length) {
        // Make the same messages as V8.
        if (state.eat(0x29 /* ) */ )) state.raise("Unmatched ')'");
        if (state.eat(0x5D /* ] */ ) || state.eat(0x7D /* } */ )) state.raise("Lone quantifier brackets");
    }
    if (state.maxBackReference > state.numCapturingParens) state.raise("Invalid escape");
    for(var i = 0, list = state.backReferenceNames; i < list.length; i += 1){
        var name = list[i];
        if (!state.groupNames[name]) state.raise("Invalid named capture referenced");
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Disjunction
$6fb78ed28ed3b042$var$pp$1.regexp_disjunction = function(state) {
    var trackDisjunction = this.options.ecmaVersion >= 16;
    if (trackDisjunction) state.branchID = new $6fb78ed28ed3b042$var$BranchID(state.branchID, null);
    this.regexp_alternative(state);
    while(state.eat(0x7C /* | */ )){
        if (trackDisjunction) state.branchID = state.branchID.sibling();
        this.regexp_alternative(state);
    }
    if (trackDisjunction) state.branchID = state.branchID.parent;
    // Make the same message as V8.
    if (this.regexp_eatQuantifier(state, true)) state.raise("Nothing to repeat");
    if (state.eat(0x7B /* { */ )) state.raise("Lone quantifier brackets");
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Alternative
$6fb78ed28ed3b042$var$pp$1.regexp_alternative = function(state) {
    while(state.pos < state.source.length && this.regexp_eatTerm(state));
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Term
$6fb78ed28ed3b042$var$pp$1.regexp_eatTerm = function(state) {
    if (this.regexp_eatAssertion(state)) {
        // Handle `QuantifiableAssertion Quantifier` alternative.
        // `state.lastAssertionIsQuantifiable` is true if the last eaten Assertion
        // is a QuantifiableAssertion.
        if (state.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(state)) // Make the same message as V8.
        {
            if (state.switchU) state.raise("Invalid quantifier");
        }
        return true;
    }
    if (state.switchU ? this.regexp_eatAtom(state) : this.regexp_eatExtendedAtom(state)) {
        this.regexp_eatQuantifier(state);
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Assertion
$6fb78ed28ed3b042$var$pp$1.regexp_eatAssertion = function(state) {
    var start = state.pos;
    state.lastAssertionIsQuantifiable = false;
    // ^, $
    if (state.eat(0x5E /* ^ */ ) || state.eat(0x24 /* $ */ )) return true;
    // \b \B
    if (state.eat(0x5C /* \ */ )) {
        if (state.eat(0x42 /* B */ ) || state.eat(0x62 /* b */ )) return true;
        state.pos = start;
    }
    // Lookahead / Lookbehind
    if (state.eat(0x28 /* ( */ ) && state.eat(0x3F /* ? */ )) {
        var lookbehind = false;
        if (this.options.ecmaVersion >= 9) lookbehind = state.eat(0x3C /* < */ );
        if (state.eat(0x3D /* = */ ) || state.eat(0x21 /* ! */ )) {
            this.regexp_disjunction(state);
            if (!state.eat(0x29 /* ) */ )) state.raise("Unterminated group");
            state.lastAssertionIsQuantifiable = !lookbehind;
            return true;
        }
    }
    state.pos = start;
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Quantifier
$6fb78ed28ed3b042$var$pp$1.regexp_eatQuantifier = function(state, noError) {
    if (noError === void 0) noError = false;
    if (this.regexp_eatQuantifierPrefix(state, noError)) {
        state.eat(0x3F /* ? */ );
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-QuantifierPrefix
$6fb78ed28ed3b042$var$pp$1.regexp_eatQuantifierPrefix = function(state, noError) {
    return state.eat(0x2A /* * */ ) || state.eat(0x2B /* + */ ) || state.eat(0x3F /* ? */ ) || this.regexp_eatBracedQuantifier(state, noError);
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatBracedQuantifier = function(state, noError) {
    var start = state.pos;
    if (state.eat(0x7B /* { */ )) {
        var min = 0, max = -1;
        if (this.regexp_eatDecimalDigits(state)) {
            min = state.lastIntValue;
            if (state.eat(0x2C /* , */ ) && this.regexp_eatDecimalDigits(state)) max = state.lastIntValue;
            if (state.eat(0x7D /* } */ )) {
                // SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-term
                if (max !== -1 && max < min && !noError) state.raise("numbers out of order in {} quantifier");
                return true;
            }
        }
        if (state.switchU && !noError) state.raise("Incomplete quantifier");
        state.pos = start;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-Atom
$6fb78ed28ed3b042$var$pp$1.regexp_eatAtom = function(state) {
    return this.regexp_eatPatternCharacters(state) || state.eat(0x2E /* . */ ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state);
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatReverseSolidusAtomEscape = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatAtomEscape(state)) return true;
        state.pos = start;
    }
    return false;
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatUncapturingGroup = function(state) {
    var start = state.pos;
    if (state.eat(0x28 /* ( */ )) {
        if (state.eat(0x3F /* ? */ )) {
            if (this.options.ecmaVersion >= 16) {
                var addModifiers = this.regexp_eatModifiers(state);
                var hasHyphen = state.eat(0x2D /* - */ );
                if (addModifiers || hasHyphen) {
                    for(var i = 0; i < addModifiers.length; i++){
                        var modifier = addModifiers.charAt(i);
                        if (addModifiers.indexOf(modifier, i + 1) > -1) state.raise("Duplicate regular expression modifiers");
                    }
                    if (hasHyphen) {
                        var removeModifiers = this.regexp_eatModifiers(state);
                        if (!addModifiers && !removeModifiers && state.current() === 0x3A /* : */ ) state.raise("Invalid regular expression modifiers");
                        for(var i$1 = 0; i$1 < removeModifiers.length; i$1++){
                            var modifier$1 = removeModifiers.charAt(i$1);
                            if (removeModifiers.indexOf(modifier$1, i$1 + 1) > -1 || addModifiers.indexOf(modifier$1) > -1) state.raise("Duplicate regular expression modifiers");
                        }
                    }
                }
            }
            if (state.eat(0x3A /* : */ )) {
                this.regexp_disjunction(state);
                if (state.eat(0x29 /* ) */ )) return true;
                state.raise("Unterminated group");
            }
        }
        state.pos = start;
    }
    return false;
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatCapturingGroup = function(state) {
    if (state.eat(0x28 /* ( */ )) {
        if (this.options.ecmaVersion >= 9) this.regexp_groupSpecifier(state);
        else if (state.current() === 0x3F /* ? */ ) state.raise("Invalid group");
        this.regexp_disjunction(state);
        if (state.eat(0x29 /* ) */ )) {
            state.numCapturingParens += 1;
            return true;
        }
        state.raise("Unterminated group");
    }
    return false;
};
// RegularExpressionModifiers ::
//   [empty]
//   RegularExpressionModifiers RegularExpressionModifier
$6fb78ed28ed3b042$var$pp$1.regexp_eatModifiers = function(state) {
    var modifiers = "";
    var ch = 0;
    while((ch = state.current()) !== -1 && $6fb78ed28ed3b042$var$isRegularExpressionModifier(ch)){
        modifiers += $6fb78ed28ed3b042$var$codePointToString(ch);
        state.advance();
    }
    return modifiers;
};
// RegularExpressionModifier :: one of
//   `i` `m` `s`
function $6fb78ed28ed3b042$var$isRegularExpressionModifier(ch) {
    return ch === 0x69 /* i */  || ch === 0x6d /* m */  || ch === 0x73 /* s */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedAtom
$6fb78ed28ed3b042$var$pp$1.regexp_eatExtendedAtom = function(state) {
    return state.eat(0x2E /* . */ ) || this.regexp_eatReverseSolidusAtomEscape(state) || this.regexp_eatCharacterClass(state) || this.regexp_eatUncapturingGroup(state) || this.regexp_eatCapturingGroup(state) || this.regexp_eatInvalidBracedQuantifier(state) || this.regexp_eatExtendedPatternCharacter(state);
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-InvalidBracedQuantifier
$6fb78ed28ed3b042$var$pp$1.regexp_eatInvalidBracedQuantifier = function(state) {
    if (this.regexp_eatBracedQuantifier(state, true)) state.raise("Nothing to repeat");
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-SyntaxCharacter
$6fb78ed28ed3b042$var$pp$1.regexp_eatSyntaxCharacter = function(state) {
    var ch = state.current();
    if ($6fb78ed28ed3b042$var$isSyntaxCharacter(ch)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
function $6fb78ed28ed3b042$var$isSyntaxCharacter(ch) {
    return ch === 0x24 /* $ */  || ch >= 0x28 /* ( */  && ch <= 0x2B /* + */  || ch === 0x2E /* . */  || ch === 0x3F /* ? */  || ch >= 0x5B /* [ */  && ch <= 0x5E /* ^ */  || ch >= 0x7B /* { */  && ch <= 0x7D /* } */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-PatternCharacter
// But eat eager.
$6fb78ed28ed3b042$var$pp$1.regexp_eatPatternCharacters = function(state) {
    var start = state.pos;
    var ch = 0;
    while((ch = state.current()) !== -1 && !$6fb78ed28ed3b042$var$isSyntaxCharacter(ch))state.advance();
    return state.pos !== start;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedPatternCharacter
$6fb78ed28ed3b042$var$pp$1.regexp_eatExtendedPatternCharacter = function(state) {
    var ch = state.current();
    if (ch !== -1 && ch !== 0x24 /* $ */  && !(ch >= 0x28 /* ( */  && ch <= 0x2B /* + */ ) && ch !== 0x2E /* . */  && ch !== 0x3F /* ? */  && ch !== 0x5B /* [ */  && ch !== 0x5E /* ^ */  && ch !== 0x7C /* | */ ) {
        state.advance();
        return true;
    }
    return false;
};
// GroupSpecifier ::
//   [empty]
//   `?` GroupName
$6fb78ed28ed3b042$var$pp$1.regexp_groupSpecifier = function(state) {
    if (state.eat(0x3F /* ? */ )) {
        if (!this.regexp_eatGroupName(state)) state.raise("Invalid group");
        var trackDisjunction = this.options.ecmaVersion >= 16;
        var known = state.groupNames[state.lastStringValue];
        if (known) {
            if (trackDisjunction) for(var i = 0, list = known; i < list.length; i += 1){
                var altID = list[i];
                if (!altID.separatedFrom(state.branchID)) state.raise("Duplicate capture group name");
            }
            else state.raise("Duplicate capture group name");
        }
        if (trackDisjunction) (known || (state.groupNames[state.lastStringValue] = [])).push(state.branchID);
        else state.groupNames[state.lastStringValue] = true;
    }
};
// GroupName ::
//   `<` RegExpIdentifierName `>`
// Note: this updates `state.lastStringValue` property with the eaten name.
$6fb78ed28ed3b042$var$pp$1.regexp_eatGroupName = function(state) {
    state.lastStringValue = "";
    if (state.eat(0x3C /* < */ )) {
        if (this.regexp_eatRegExpIdentifierName(state) && state.eat(0x3E /* > */ )) return true;
        state.raise("Invalid capture group name");
    }
    return false;
};
// RegExpIdentifierName ::
//   RegExpIdentifierStart
//   RegExpIdentifierName RegExpIdentifierPart
// Note: this updates `state.lastStringValue` property with the eaten name.
$6fb78ed28ed3b042$var$pp$1.regexp_eatRegExpIdentifierName = function(state) {
    state.lastStringValue = "";
    if (this.regexp_eatRegExpIdentifierStart(state)) {
        state.lastStringValue += $6fb78ed28ed3b042$var$codePointToString(state.lastIntValue);
        while(this.regexp_eatRegExpIdentifierPart(state))state.lastStringValue += $6fb78ed28ed3b042$var$codePointToString(state.lastIntValue);
        return true;
    }
    return false;
};
// RegExpIdentifierStart ::
//   UnicodeIDStart
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[+U]
$6fb78ed28ed3b042$var$pp$1.regexp_eatRegExpIdentifierStart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 0x5C /* \ */  && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if ($6fb78ed28ed3b042$var$isRegExpIdentifierStart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function $6fb78ed28ed3b042$var$isRegExpIdentifierStart(ch) {
    return $6fb78ed28ed3b042$export$56b48cc5d7560ffb(ch, true) || ch === 0x24 /* $ */  || ch === 0x5F /* _ */ ;
}
// RegExpIdentifierPart ::
//   UnicodeIDContinue
//   `$`
//   `_`
//   `\` RegExpUnicodeEscapeSequence[+U]
//   <ZWNJ>
//   <ZWJ>
$6fb78ed28ed3b042$var$pp$1.regexp_eatRegExpIdentifierPart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);
    if (ch === 0x5C /* \ */  && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) ch = state.lastIntValue;
    if ($6fb78ed28ed3b042$var$isRegExpIdentifierPart(ch)) {
        state.lastIntValue = ch;
        return true;
    }
    state.pos = start;
    return false;
};
function $6fb78ed28ed3b042$var$isRegExpIdentifierPart(ch) {
    return $6fb78ed28ed3b042$export$332f4d7bee38db93(ch, true) || ch === 0x24 /* $ */  || ch === 0x5F /* _ */  || ch === 0x200C /* <ZWNJ> */  || ch === 0x200D /* <ZWJ> */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-AtomEscape
$6fb78ed28ed3b042$var$pp$1.regexp_eatAtomEscape = function(state) {
    if (this.regexp_eatBackReference(state) || this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state) || state.switchN && this.regexp_eatKGroupName(state)) return true;
    if (state.switchU) {
        // Make the same message as V8.
        if (state.current() === 0x63 /* c */ ) state.raise("Invalid unicode escape");
        state.raise("Invalid escape");
    }
    return false;
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatBackReference = function(state) {
    var start = state.pos;
    if (this.regexp_eatDecimalEscape(state)) {
        var n = state.lastIntValue;
        if (state.switchU) {
            // For SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-atomescape
            if (n > state.maxBackReference) state.maxBackReference = n;
            return true;
        }
        if (n <= state.numCapturingParens) return true;
        state.pos = start;
    }
    return false;
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatKGroupName = function(state) {
    if (state.eat(0x6B /* k */ )) {
        if (this.regexp_eatGroupName(state)) {
            state.backReferenceNames.push(state.lastStringValue);
            return true;
        }
        state.raise("Invalid named reference");
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-CharacterEscape
$6fb78ed28ed3b042$var$pp$1.regexp_eatCharacterEscape = function(state) {
    return this.regexp_eatControlEscape(state) || this.regexp_eatCControlLetter(state) || this.regexp_eatZero(state) || this.regexp_eatHexEscapeSequence(state) || this.regexp_eatRegExpUnicodeEscapeSequence(state, false) || !state.switchU && this.regexp_eatLegacyOctalEscapeSequence(state) || this.regexp_eatIdentityEscape(state);
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatCControlLetter = function(state) {
    var start = state.pos;
    if (state.eat(0x63 /* c */ )) {
        if (this.regexp_eatControlLetter(state)) return true;
        state.pos = start;
    }
    return false;
};
$6fb78ed28ed3b042$var$pp$1.regexp_eatZero = function(state) {
    if (state.current() === 0x30 /* 0 */  && !$6fb78ed28ed3b042$var$isDecimalDigit(state.lookahead())) {
        state.lastIntValue = 0;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ControlEscape
$6fb78ed28ed3b042$var$pp$1.regexp_eatControlEscape = function(state) {
    var ch = state.current();
    if (ch === 0x74 /* t */ ) {
        state.lastIntValue = 0x09; /* \t */ 
        state.advance();
        return true;
    }
    if (ch === 0x6E /* n */ ) {
        state.lastIntValue = 0x0A; /* \n */ 
        state.advance();
        return true;
    }
    if (ch === 0x76 /* v */ ) {
        state.lastIntValue = 0x0B; /* \v */ 
        state.advance();
        return true;
    }
    if (ch === 0x66 /* f */ ) {
        state.lastIntValue = 0x0C; /* \f */ 
        state.advance();
        return true;
    }
    if (ch === 0x72 /* r */ ) {
        state.lastIntValue = 0x0D; /* \r */ 
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ControlLetter
$6fb78ed28ed3b042$var$pp$1.regexp_eatControlLetter = function(state) {
    var ch = state.current();
    if ($6fb78ed28ed3b042$var$isControlLetter(ch)) {
        state.lastIntValue = ch % 0x20;
        state.advance();
        return true;
    }
    return false;
};
function $6fb78ed28ed3b042$var$isControlLetter(ch) {
    return ch >= 0x41 /* A */  && ch <= 0x5A /* Z */  || ch >= 0x61 /* a */  && ch <= 0x7A /* z */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-RegExpUnicodeEscapeSequence
$6fb78ed28ed3b042$var$pp$1.regexp_eatRegExpUnicodeEscapeSequence = function(state, forceU) {
    if (forceU === void 0) forceU = false;
    var start = state.pos;
    var switchU = forceU || state.switchU;
    if (state.eat(0x75 /* u */ )) {
        if (this.regexp_eatFixedHexDigits(state, 4)) {
            var lead = state.lastIntValue;
            if (switchU && lead >= 0xD800 && lead <= 0xDBFF) {
                var leadSurrogateEnd = state.pos;
                if (state.eat(0x5C /* \ */ ) && state.eat(0x75 /* u */ ) && this.regexp_eatFixedHexDigits(state, 4)) {
                    var trail = state.lastIntValue;
                    if (trail >= 0xDC00 && trail <= 0xDFFF) {
                        state.lastIntValue = (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
                        return true;
                    }
                }
                state.pos = leadSurrogateEnd;
                state.lastIntValue = lead;
            }
            return true;
        }
        if (switchU && state.eat(0x7B /* { */ ) && this.regexp_eatHexDigits(state) && state.eat(0x7D /* } */ ) && $6fb78ed28ed3b042$var$isValidUnicode(state.lastIntValue)) return true;
        if (switchU) state.raise("Invalid unicode escape");
        state.pos = start;
    }
    return false;
};
function $6fb78ed28ed3b042$var$isValidUnicode(ch) {
    return ch >= 0 && ch <= 0x10FFFF;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-IdentityEscape
$6fb78ed28ed3b042$var$pp$1.regexp_eatIdentityEscape = function(state) {
    if (state.switchU) {
        if (this.regexp_eatSyntaxCharacter(state)) return true;
        if (state.eat(0x2F /* / */ )) {
            state.lastIntValue = 0x2F; /* / */ 
            return true;
        }
        return false;
    }
    var ch = state.current();
    if (ch !== 0x63 /* c */  && (!state.switchN || ch !== 0x6B /* k */ )) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalEscape
$6fb78ed28ed3b042$var$pp$1.regexp_eatDecimalEscape = function(state) {
    state.lastIntValue = 0;
    var ch = state.current();
    if (ch >= 0x31 /* 1 */  && ch <= 0x39 /* 9 */ ) {
        do {
            state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */ );
            state.advance();
        }while ((ch = state.current()) >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ );
        return true;
    }
    return false;
};
// Return values used by character set parsing methods, needed to
// forbid negation of sets that can match strings.
var $6fb78ed28ed3b042$var$CharSetNone = 0; // Nothing parsed
var $6fb78ed28ed3b042$var$CharSetOk = 1; // Construct parsed, cannot contain strings
var $6fb78ed28ed3b042$var$CharSetString = 2; // Construct parsed, can contain strings
// https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClassEscape
$6fb78ed28ed3b042$var$pp$1.regexp_eatCharacterClassEscape = function(state) {
    var ch = state.current();
    if ($6fb78ed28ed3b042$var$isCharacterClassEscape(ch)) {
        state.lastIntValue = -1;
        state.advance();
        return $6fb78ed28ed3b042$var$CharSetOk;
    }
    var negate = false;
    if (state.switchU && this.options.ecmaVersion >= 9 && ((negate = ch === 0x50 /* P */ ) || ch === 0x70 /* p */ )) {
        state.lastIntValue = -1;
        state.advance();
        var result;
        if (state.eat(0x7B /* { */ ) && (result = this.regexp_eatUnicodePropertyValueExpression(state)) && state.eat(0x7D /* } */ )) {
            if (negate && result === $6fb78ed28ed3b042$var$CharSetString) state.raise("Invalid property name");
            return result;
        }
        state.raise("Invalid property name");
    }
    return $6fb78ed28ed3b042$var$CharSetNone;
};
function $6fb78ed28ed3b042$var$isCharacterClassEscape(ch) {
    return ch === 0x64 /* d */  || ch === 0x44 /* D */  || ch === 0x73 /* s */  || ch === 0x53 /* S */  || ch === 0x77 /* w */  || ch === 0x57 /* W */ ;
}
// UnicodePropertyValueExpression ::
//   UnicodePropertyName `=` UnicodePropertyValue
//   LoneUnicodePropertyNameOrValue
$6fb78ed28ed3b042$var$pp$1.regexp_eatUnicodePropertyValueExpression = function(state) {
    var start = state.pos;
    // UnicodePropertyName `=` UnicodePropertyValue
    if (this.regexp_eatUnicodePropertyName(state) && state.eat(0x3D /* = */ )) {
        var name = state.lastStringValue;
        if (this.regexp_eatUnicodePropertyValue(state)) {
            var value = state.lastStringValue;
            this.regexp_validateUnicodePropertyNameAndValue(state, name, value);
            return $6fb78ed28ed3b042$var$CharSetOk;
        }
    }
    state.pos = start;
    // LoneUnicodePropertyNameOrValue
    if (this.regexp_eatLoneUnicodePropertyNameOrValue(state)) {
        var nameOrValue = state.lastStringValue;
        return this.regexp_validateUnicodePropertyNameOrValue(state, nameOrValue);
    }
    return $6fb78ed28ed3b042$var$CharSetNone;
};
$6fb78ed28ed3b042$var$pp$1.regexp_validateUnicodePropertyNameAndValue = function(state, name, value) {
    if (!$6fb78ed28ed3b042$var$hasOwn(state.unicodeProperties.nonBinary, name)) state.raise("Invalid property name");
    if (!state.unicodeProperties.nonBinary[name].test(value)) state.raise("Invalid property value");
};
$6fb78ed28ed3b042$var$pp$1.regexp_validateUnicodePropertyNameOrValue = function(state, nameOrValue) {
    if (state.unicodeProperties.binary.test(nameOrValue)) return $6fb78ed28ed3b042$var$CharSetOk;
    if (state.switchV && state.unicodeProperties.binaryOfStrings.test(nameOrValue)) return $6fb78ed28ed3b042$var$CharSetString;
    state.raise("Invalid property name");
};
// UnicodePropertyName ::
//   UnicodePropertyNameCharacters
$6fb78ed28ed3b042$var$pp$1.regexp_eatUnicodePropertyName = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while($6fb78ed28ed3b042$var$isUnicodePropertyNameCharacter(ch = state.current())){
        state.lastStringValue += $6fb78ed28ed3b042$var$codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function $6fb78ed28ed3b042$var$isUnicodePropertyNameCharacter(ch) {
    return $6fb78ed28ed3b042$var$isControlLetter(ch) || ch === 0x5F /* _ */ ;
}
// UnicodePropertyValue ::
//   UnicodePropertyValueCharacters
$6fb78ed28ed3b042$var$pp$1.regexp_eatUnicodePropertyValue = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while($6fb78ed28ed3b042$var$isUnicodePropertyValueCharacter(ch = state.current())){
        state.lastStringValue += $6fb78ed28ed3b042$var$codePointToString(ch);
        state.advance();
    }
    return state.lastStringValue !== "";
};
function $6fb78ed28ed3b042$var$isUnicodePropertyValueCharacter(ch) {
    return $6fb78ed28ed3b042$var$isUnicodePropertyNameCharacter(ch) || $6fb78ed28ed3b042$var$isDecimalDigit(ch);
}
// LoneUnicodePropertyNameOrValue ::
//   UnicodePropertyValueCharacters
$6fb78ed28ed3b042$var$pp$1.regexp_eatLoneUnicodePropertyNameOrValue = function(state) {
    return this.regexp_eatUnicodePropertyValue(state);
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClass
$6fb78ed28ed3b042$var$pp$1.regexp_eatCharacterClass = function(state) {
    if (state.eat(0x5B /* [ */ )) {
        var negate = state.eat(0x5E /* ^ */ );
        var result = this.regexp_classContents(state);
        if (!state.eat(0x5D /* ] */ )) state.raise("Unterminated character class");
        if (negate && result === $6fb78ed28ed3b042$var$CharSetString) state.raise("Negated character class may contain strings");
        return true;
    }
    return false;
};
// https://tc39.es/ecma262/#prod-ClassContents
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassRanges
$6fb78ed28ed3b042$var$pp$1.regexp_classContents = function(state) {
    if (state.current() === 0x5D /* ] */ ) return $6fb78ed28ed3b042$var$CharSetOk;
    if (state.switchV) return this.regexp_classSetExpression(state);
    this.regexp_nonEmptyClassRanges(state);
    return $6fb78ed28ed3b042$var$CharSetOk;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRanges
// https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRangesNoDash
$6fb78ed28ed3b042$var$pp$1.regexp_nonEmptyClassRanges = function(state) {
    while(this.regexp_eatClassAtom(state)){
        var left = state.lastIntValue;
        if (state.eat(0x2D /* - */ ) && this.regexp_eatClassAtom(state)) {
            var right = state.lastIntValue;
            if (state.switchU && (left === -1 || right === -1)) state.raise("Invalid character class");
            if (left !== -1 && right !== -1 && left > right) state.raise("Range out of order in character class");
        }
    }
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtom
// https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtomNoDash
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassAtom = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatClassEscape(state)) return true;
        if (state.switchU) {
            // Make the same message as V8.
            var ch$1 = state.current();
            if (ch$1 === 0x63 /* c */  || $6fb78ed28ed3b042$var$isOctalDigit(ch$1)) state.raise("Invalid class escape");
            state.raise("Invalid escape");
        }
        state.pos = start;
    }
    var ch = state.current();
    if (ch !== 0x5D /* ] */ ) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassEscape
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassEscape = function(state) {
    var start = state.pos;
    if (state.eat(0x62 /* b */ )) {
        state.lastIntValue = 0x08; /* <BS> */ 
        return true;
    }
    if (state.switchU && state.eat(0x2D /* - */ )) {
        state.lastIntValue = 0x2D; /* - */ 
        return true;
    }
    if (!state.switchU && state.eat(0x63 /* c */ )) {
        if (this.regexp_eatClassControlLetter(state)) return true;
        state.pos = start;
    }
    return this.regexp_eatCharacterClassEscape(state) || this.regexp_eatCharacterEscape(state);
};
// https://tc39.es/ecma262/#prod-ClassSetExpression
// https://tc39.es/ecma262/#prod-ClassUnion
// https://tc39.es/ecma262/#prod-ClassIntersection
// https://tc39.es/ecma262/#prod-ClassSubtraction
$6fb78ed28ed3b042$var$pp$1.regexp_classSetExpression = function(state) {
    var result = $6fb78ed28ed3b042$var$CharSetOk, subResult;
    if (this.regexp_eatClassSetRange(state)) ;
    else if (subResult = this.regexp_eatClassSetOperand(state)) {
        if (subResult === $6fb78ed28ed3b042$var$CharSetString) result = $6fb78ed28ed3b042$var$CharSetString;
        // https://tc39.es/ecma262/#prod-ClassIntersection
        var start = state.pos;
        while(state.eatChars([
            0x26,
            0x26
        ])){
            if (state.current() !== 0x26 /* & */  && (subResult = this.regexp_eatClassSetOperand(state))) {
                if (subResult !== $6fb78ed28ed3b042$var$CharSetString) result = $6fb78ed28ed3b042$var$CharSetOk;
                continue;
            }
            state.raise("Invalid character in character class");
        }
        if (start !== state.pos) return result;
        // https://tc39.es/ecma262/#prod-ClassSubtraction
        while(state.eatChars([
            0x2D,
            0x2D
        ])){
            if (this.regexp_eatClassSetOperand(state)) continue;
            state.raise("Invalid character in character class");
        }
        if (start !== state.pos) return result;
    } else state.raise("Invalid character in character class");
    // https://tc39.es/ecma262/#prod-ClassUnion
    for(;;){
        if (this.regexp_eatClassSetRange(state)) continue;
        subResult = this.regexp_eatClassSetOperand(state);
        if (!subResult) return result;
        if (subResult === $6fb78ed28ed3b042$var$CharSetString) result = $6fb78ed28ed3b042$var$CharSetString;
    }
};
// https://tc39.es/ecma262/#prod-ClassSetRange
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassSetRange = function(state) {
    var start = state.pos;
    if (this.regexp_eatClassSetCharacter(state)) {
        var left = state.lastIntValue;
        if (state.eat(0x2D /* - */ ) && this.regexp_eatClassSetCharacter(state)) {
            var right = state.lastIntValue;
            if (left !== -1 && right !== -1 && left > right) state.raise("Range out of order in character class");
            return true;
        }
        state.pos = start;
    }
    return false;
};
// https://tc39.es/ecma262/#prod-ClassSetOperand
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassSetOperand = function(state) {
    if (this.regexp_eatClassSetCharacter(state)) return $6fb78ed28ed3b042$var$CharSetOk;
    return this.regexp_eatClassStringDisjunction(state) || this.regexp_eatNestedClass(state);
};
// https://tc39.es/ecma262/#prod-NestedClass
$6fb78ed28ed3b042$var$pp$1.regexp_eatNestedClass = function(state) {
    var start = state.pos;
    if (state.eat(0x5B /* [ */ )) {
        var negate = state.eat(0x5E /* ^ */ );
        var result = this.regexp_classContents(state);
        if (state.eat(0x5D /* ] */ )) {
            if (negate && result === $6fb78ed28ed3b042$var$CharSetString) state.raise("Negated character class may contain strings");
            return result;
        }
        state.pos = start;
    }
    if (state.eat(0x5C /* \ */ )) {
        var result$1 = this.regexp_eatCharacterClassEscape(state);
        if (result$1) return result$1;
        state.pos = start;
    }
    return null;
};
// https://tc39.es/ecma262/#prod-ClassStringDisjunction
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassStringDisjunction = function(state) {
    var start = state.pos;
    if (state.eatChars([
        0x5C,
        0x71
    ])) {
        if (state.eat(0x7B /* { */ )) {
            var result = this.regexp_classStringDisjunctionContents(state);
            if (state.eat(0x7D /* } */ )) return result;
        } else // Make the same message as V8.
        state.raise("Invalid escape");
        state.pos = start;
    }
    return null;
};
// https://tc39.es/ecma262/#prod-ClassStringDisjunctionContents
$6fb78ed28ed3b042$var$pp$1.regexp_classStringDisjunctionContents = function(state) {
    var result = this.regexp_classString(state);
    while(state.eat(0x7C /* | */ ))if (this.regexp_classString(state) === $6fb78ed28ed3b042$var$CharSetString) result = $6fb78ed28ed3b042$var$CharSetString;
    return result;
};
// https://tc39.es/ecma262/#prod-ClassString
// https://tc39.es/ecma262/#prod-NonEmptyClassString
$6fb78ed28ed3b042$var$pp$1.regexp_classString = function(state) {
    var count = 0;
    while(this.regexp_eatClassSetCharacter(state))count++;
    return count === 1 ? $6fb78ed28ed3b042$var$CharSetOk : $6fb78ed28ed3b042$var$CharSetString;
};
// https://tc39.es/ecma262/#prod-ClassSetCharacter
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassSetCharacter = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */ )) {
        if (this.regexp_eatCharacterEscape(state) || this.regexp_eatClassSetReservedPunctuator(state)) return true;
        if (state.eat(0x62 /* b */ )) {
            state.lastIntValue = 0x08; /* <BS> */ 
            return true;
        }
        state.pos = start;
        return false;
    }
    var ch = state.current();
    if (ch < 0 || ch === state.lookahead() && $6fb78ed28ed3b042$var$isClassSetReservedDoublePunctuatorCharacter(ch)) return false;
    if ($6fb78ed28ed3b042$var$isClassSetSyntaxCharacter(ch)) return false;
    state.advance();
    state.lastIntValue = ch;
    return true;
};
// https://tc39.es/ecma262/#prod-ClassSetReservedDoublePunctuator
function $6fb78ed28ed3b042$var$isClassSetReservedDoublePunctuatorCharacter(ch) {
    return ch === 0x21 /* ! */  || ch >= 0x23 /* # */  && ch <= 0x26 /* & */  || ch >= 0x2A /* * */  && ch <= 0x2C /* , */  || ch === 0x2E /* . */  || ch >= 0x3A /* : */  && ch <= 0x40 /* @ */  || ch === 0x5E /* ^ */  || ch === 0x60 /* ` */  || ch === 0x7E /* ~ */ ;
}
// https://tc39.es/ecma262/#prod-ClassSetSyntaxCharacter
function $6fb78ed28ed3b042$var$isClassSetSyntaxCharacter(ch) {
    return ch === 0x28 /* ( */  || ch === 0x29 /* ) */  || ch === 0x2D /* - */  || ch === 0x2F /* / */  || ch >= 0x5B /* [ */  && ch <= 0x5D /* ] */  || ch >= 0x7B /* { */  && ch <= 0x7D /* } */ ;
}
// https://tc39.es/ecma262/#prod-ClassSetReservedPunctuator
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassSetReservedPunctuator = function(state) {
    var ch = state.current();
    if ($6fb78ed28ed3b042$var$isClassSetReservedPunctuator(ch)) {
        state.lastIntValue = ch;
        state.advance();
        return true;
    }
    return false;
};
// https://tc39.es/ecma262/#prod-ClassSetReservedPunctuator
function $6fb78ed28ed3b042$var$isClassSetReservedPunctuator(ch) {
    return ch === 0x21 /* ! */  || ch === 0x23 /* # */  || ch === 0x25 /* % */  || ch === 0x26 /* & */  || ch === 0x2C /* , */  || ch === 0x2D /* - */  || ch >= 0x3A /* : */  && ch <= 0x3E /* > */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */  || ch === 0x7E /* ~ */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassControlLetter
$6fb78ed28ed3b042$var$pp$1.regexp_eatClassControlLetter = function(state) {
    var ch = state.current();
    if ($6fb78ed28ed3b042$var$isDecimalDigit(ch) || ch === 0x5F /* _ */ ) {
        state.lastIntValue = ch % 0x20;
        state.advance();
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
$6fb78ed28ed3b042$var$pp$1.regexp_eatHexEscapeSequence = function(state) {
    var start = state.pos;
    if (state.eat(0x78 /* x */ )) {
        if (this.regexp_eatFixedHexDigits(state, 2)) return true;
        if (state.switchU) state.raise("Invalid escape");
        state.pos = start;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalDigits
$6fb78ed28ed3b042$var$pp$1.regexp_eatDecimalDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while($6fb78ed28ed3b042$var$isDecimalDigit(ch = state.current())){
        state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */ );
        state.advance();
    }
    return state.pos !== start;
};
function $6fb78ed28ed3b042$var$isDecimalDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigits
$6fb78ed28ed3b042$var$pp$1.regexp_eatHexDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while($6fb78ed28ed3b042$var$isHexDigit(ch = state.current())){
        state.lastIntValue = 16 * state.lastIntValue + $6fb78ed28ed3b042$var$hexToInt(ch);
        state.advance();
    }
    return state.pos !== start;
};
function $6fb78ed28ed3b042$var$isHexDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */  || ch >= 0x41 /* A */  && ch <= 0x46 /* F */  || ch >= 0x61 /* a */  && ch <= 0x66 /* f */ ;
}
function $6fb78ed28ed3b042$var$hexToInt(ch) {
    if (ch >= 0x41 /* A */  && ch <= 0x46 /* F */ ) return 10 + (ch - 0x41 /* A */ );
    if (ch >= 0x61 /* a */  && ch <= 0x66 /* f */ ) return 10 + (ch - 0x61 /* a */ );
    return ch - 0x30 /* 0 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-LegacyOctalEscapeSequence
// Allows only 0-377(octal) i.e. 0-255(decimal).
$6fb78ed28ed3b042$var$pp$1.regexp_eatLegacyOctalEscapeSequence = function(state) {
    if (this.regexp_eatOctalDigit(state)) {
        var n1 = state.lastIntValue;
        if (this.regexp_eatOctalDigit(state)) {
            var n2 = state.lastIntValue;
            if (n1 <= 3 && this.regexp_eatOctalDigit(state)) state.lastIntValue = n1 * 64 + n2 * 8 + state.lastIntValue;
            else state.lastIntValue = n1 * 8 + n2;
        } else state.lastIntValue = n1;
        return true;
    }
    return false;
};
// https://www.ecma-international.org/ecma-262/8.0/#prod-OctalDigit
$6fb78ed28ed3b042$var$pp$1.regexp_eatOctalDigit = function(state) {
    var ch = state.current();
    if ($6fb78ed28ed3b042$var$isOctalDigit(ch)) {
        state.lastIntValue = ch - 0x30; /* 0 */ 
        state.advance();
        return true;
    }
    state.lastIntValue = 0;
    return false;
};
function $6fb78ed28ed3b042$var$isOctalDigit(ch) {
    return ch >= 0x30 /* 0 */  && ch <= 0x37 /* 7 */ ;
}
// https://www.ecma-international.org/ecma-262/8.0/#prod-Hex4Digits
// https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigit
// And HexDigit HexDigit in https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
$6fb78ed28ed3b042$var$pp$1.regexp_eatFixedHexDigits = function(state, length) {
    var start = state.pos;
    state.lastIntValue = 0;
    for(var i = 0; i < length; ++i){
        var ch = state.current();
        if (!$6fb78ed28ed3b042$var$isHexDigit(ch)) {
            state.pos = start;
            return false;
        }
        state.lastIntValue = 16 * state.lastIntValue + $6fb78ed28ed3b042$var$hexToInt(ch);
        state.advance();
    }
    return true;
};
// Object type used to represent tokens. Note that normally, tokens
// simply exist as properties on the parser object. This is only
// used for the onToken callback and the external tokenizer.
var $6fb78ed28ed3b042$export$50792b0e93539fde = function Token(p) {
    this.type = p.type;
    this.value = p.value;
    this.start = p.start;
    this.end = p.end;
    if (p.options.locations) this.loc = new $6fb78ed28ed3b042$export$7387db7caf96fcdb(p, p.startLoc, p.endLoc);
    if (p.options.ranges) this.range = [
        p.start,
        p.end
    ];
};
// ## Tokenizer
var $6fb78ed28ed3b042$var$pp = $6fb78ed28ed3b042$export$7acfa6ed01010e37.prototype;
// Move to the next token
$6fb78ed28ed3b042$var$pp.next = function(ignoreEscapeSequenceInKeyword) {
    if (!ignoreEscapeSequenceInKeyword && this.type.keyword && this.containsEsc) this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword);
    if (this.options.onToken) this.options.onToken(new $6fb78ed28ed3b042$export$50792b0e93539fde(this));
    this.lastTokEnd = this.end;
    this.lastTokStart = this.start;
    this.lastTokEndLoc = this.endLoc;
    this.lastTokStartLoc = this.startLoc;
    this.nextToken();
};
$6fb78ed28ed3b042$var$pp.getToken = function() {
    this.next();
    return new $6fb78ed28ed3b042$export$50792b0e93539fde(this);
};
// If we're in an ES6 environment, make parsers iterable
if (typeof Symbol !== "undefined") $6fb78ed28ed3b042$var$pp[Symbol.iterator] = function() {
    var this$1$1 = this;
    return {
        next: function() {
            var token = this$1$1.getToken();
            return {
                done: token.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eof,
                value: token
            };
        }
    };
};
// Toggle strict mode. Re-reads the next number or string to please
// pedantic tests (`"use strict"; 010;` should fail).
// Read a single token, updating the parser object's token-related
// properties.
$6fb78ed28ed3b042$var$pp.nextToken = function() {
    var curContext = this.curContext();
    if (!curContext || !curContext.preserveSpace) this.skipSpace();
    this.start = this.pos;
    if (this.options.locations) this.startLoc = this.curPosition();
    if (this.pos >= this.input.length) return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eof);
    if (curContext.override) return curContext.override(this);
    else this.readToken(this.fullCharCodeAtPos());
};
$6fb78ed28ed3b042$var$pp.readToken = function(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if ($6fb78ed28ed3b042$export$56b48cc5d7560ffb(code, this.options.ecmaVersion >= 6) || code === 92 /* '\' */ ) return this.readWord();
    return this.getTokenFromCode(code);
};
$6fb78ed28ed3b042$var$pp.fullCharCodeAt = function(pos) {
    var code = this.input.charCodeAt(pos);
    if (code <= 0xd7ff || code >= 0xdc00) return code;
    var next = this.input.charCodeAt(pos + 1);
    return next <= 0xdbff || next >= 0xe000 ? code : (code << 10) + next - 0x35fdc00;
};
$6fb78ed28ed3b042$var$pp.fullCharCodeAtPos = function() {
    return this.fullCharCodeAt(this.pos);
};
$6fb78ed28ed3b042$var$pp.skipBlockComment = function() {
    var startLoc = this.options.onComment && this.curPosition();
    var start = this.pos, end = this.input.indexOf("*/", this.pos += 2);
    if (end === -1) this.raise(this.pos - 2, "Unterminated comment");
    this.pos = end + 2;
    if (this.options.locations) for(var nextBreak = void 0, pos = start; (nextBreak = $6fb78ed28ed3b042$var$nextLineBreak(this.input, pos, this.pos)) > -1;){
        ++this.curLine;
        pos = this.lineStart = nextBreak;
    }
    if (this.options.onComment) this.options.onComment(true, this.input.slice(start + 2, end), start, this.pos, startLoc, this.curPosition());
};
$6fb78ed28ed3b042$var$pp.skipLineComment = function(startSkip) {
    var start = this.pos;
    var startLoc = this.options.onComment && this.curPosition();
    var ch = this.input.charCodeAt(this.pos += startSkip);
    while(this.pos < this.input.length && !$6fb78ed28ed3b042$export$2c19a3e3b4008fff(ch))ch = this.input.charCodeAt(++this.pos);
    if (this.options.onComment) this.options.onComment(false, this.input.slice(start + startSkip, this.pos), start, this.pos, startLoc, this.curPosition());
};
// Called at the start of the parse and after every token. Skips
// whitespace and comments, and.
$6fb78ed28ed3b042$var$pp.skipSpace = function() {
    loop: while(this.pos < this.input.length){
        var ch = this.input.charCodeAt(this.pos);
        switch(ch){
            case 32:
            case 160:
                ++this.pos;
                break;
            case 13:
                if (this.input.charCodeAt(this.pos + 1) === 10) ++this.pos;
            case 10:
            case 8232:
            case 8233:
                ++this.pos;
                if (this.options.locations) {
                    ++this.curLine;
                    this.lineStart = this.pos;
                }
                break;
            case 47:
                switch(this.input.charCodeAt(this.pos + 1)){
                    case 42:
                        this.skipBlockComment();
                        break;
                    case 47:
                        this.skipLineComment(2);
                        break;
                    default:
                        break loop;
                }
                break;
            default:
                if (ch > 8 && ch < 14 || ch >= 5760 && $6fb78ed28ed3b042$export$268622f0f1cbc82b.test(String.fromCharCode(ch))) ++this.pos;
                else break loop;
        }
    }
};
// Called at the end of every token. Sets `end`, `val`, and
// maintains `context` and `exprAllowed`, and skips the space after
// the token, so that the next one's `start` will point at the
// right position.
$6fb78ed28ed3b042$var$pp.finishToken = function(type, val) {
    this.end = this.pos;
    if (this.options.locations) this.endLoc = this.curPosition();
    var prevType = this.type;
    this.type = type;
    this.value = val;
    this.updateContext(prevType);
};
// ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
//
$6fb78ed28ed3b042$var$pp.readToken_dot = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next >= 48 && next <= 57) return this.readNumber(true);
    var next2 = this.input.charCodeAt(this.pos + 2);
    if (this.options.ecmaVersion >= 6 && next === 46 && next2 === 46) {
        this.pos += 3;
        return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.ellipsis);
    } else {
        ++this.pos;
        return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dot);
    }
};
$6fb78ed28ed3b042$var$pp.readToken_slash = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (this.exprAllowed) {
        ++this.pos;
        return this.readRegexp();
    }
    if (next === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.slash, 1);
};
$6fb78ed28ed3b042$var$pp.readToken_mult_modulo_exp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    var tokentype = code === 42 ? $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.star : $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.modulo;
    // exponentiation operator ** and **=
    if (this.options.ecmaVersion >= 7 && code === 42 && next === 42) {
        ++size;
        tokentype = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.starstar;
        next = this.input.charCodeAt(this.pos + 2);
    }
    if (next === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, size + 1);
    return this.finishOp(tokentype, size);
};
$6fb78ed28ed3b042$var$pp.readToken_pipe_amp = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (this.options.ecmaVersion >= 12) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, 3);
        }
        return this.finishOp(code === 124 ? $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.logicalOR : $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.logicalAND, 2);
    }
    if (next === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp(code === 124 ? $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bitwiseOR : $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bitwiseAND, 1);
};
$6fb78ed28ed3b042$var$pp.readToken_caret = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bitwiseXOR, 1);
};
$6fb78ed28ed3b042$var$pp.readToken_plus_min = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
        if (next === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(this.input.slice(this.lastTokEnd, this.pos)))) {
            // A `-->` line comment
            this.skipLineComment(3);
            this.skipSpace();
            return this.nextToken();
        }
        return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.incDec, 2);
    }
    if (next === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, 2);
    return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.plusMin, 1);
};
$6fb78ed28ed3b042$var$pp.readToken_lt_gt = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    if (next === code) {
        size = code === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2;
        if (this.input.charCodeAt(this.pos + size) === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, size + 1);
        return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bitShift, size);
    }
    if (next === 33 && code === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45) {
        // `<!--`, an XML-style comment that should be interpreted as a line comment
        this.skipLineComment(4);
        this.skipSpace();
        return this.nextToken();
    }
    if (next === 61) size = 2;
    return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.relational, size);
};
$6fb78ed28ed3b042$var$pp.readToken_eq_excl = function(code) {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2);
    if (code === 61 && next === 62 && this.options.ecmaVersion >= 6) {
        this.pos += 2;
        return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.arrow);
    }
    return this.finishOp(code === 61 ? $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.eq : $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.prefix, 1);
};
$6fb78ed28ed3b042$var$pp.readToken_question = function() {
    var ecmaVersion = this.options.ecmaVersion;
    if (ecmaVersion >= 11) {
        var next = this.input.charCodeAt(this.pos + 1);
        if (next === 46) {
            var next2 = this.input.charCodeAt(this.pos + 2);
            if (next2 < 48 || next2 > 57) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.questionDot, 2);
        }
        if (next === 63) {
            if (ecmaVersion >= 12) {
                var next2$1 = this.input.charCodeAt(this.pos + 2);
                if (next2$1 === 61) return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.assign, 3);
            }
            return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.coalesce, 2);
        }
    }
    return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.question, 1);
};
$6fb78ed28ed3b042$var$pp.readToken_numberSign = function() {
    var ecmaVersion = this.options.ecmaVersion;
    var code = 35; // '#'
    if (ecmaVersion >= 13) {
        ++this.pos;
        code = this.fullCharCodeAtPos();
        if ($6fb78ed28ed3b042$export$56b48cc5d7560ffb(code, true) || code === 92 /* '\' */ ) return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.privateId, this.readWord1());
    }
    this.raise(this.pos, "Unexpected character '" + $6fb78ed28ed3b042$var$codePointToString(code) + "'");
};
$6fb78ed28ed3b042$var$pp.getTokenFromCode = function(code) {
    switch(code){
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case 46:
            return this.readToken_dot();
        // Punctuation tokens.
        case 40:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenL);
        case 41:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.parenR);
        case 59:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.semi);
        case 44:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.comma);
        case 91:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketL);
        case 93:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.bracketR);
        case 123:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceL);
        case 125:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.braceR);
        case 58:
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.colon);
        case 96:
            if (this.options.ecmaVersion < 6) break;
            ++this.pos;
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.backQuote);
        case 48:
            var next = this.input.charCodeAt(this.pos + 1);
            if (next === 120 || next === 88) return this.readRadixNumber(16);
             // '0x', '0X' - hex number
            if (this.options.ecmaVersion >= 6) {
                if (next === 111 || next === 79) return this.readRadixNumber(8);
                 // '0o', '0O' - octal number
                if (next === 98 || next === 66) return this.readRadixNumber(2);
                 // '0b', '0B' - binary number
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return this.readNumber(false);
        // Quotes produce strings.
        case 34:
        case 39:
            return this.readString(code);
        // Operators are parsed inline in tiny state machines. '=' (61) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case 47:
            return this.readToken_slash();
        case 37:
        case 42:
            return this.readToken_mult_modulo_exp(code);
        case 124:
        case 38:
            return this.readToken_pipe_amp(code);
        case 94:
            return this.readToken_caret();
        case 43:
        case 45:
            return this.readToken_plus_min(code);
        case 60:
        case 62:
            return this.readToken_lt_gt(code);
        case 61:
        case 33:
            return this.readToken_eq_excl(code);
        case 63:
            return this.readToken_question();
        case 126:
            return this.finishOp($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.prefix, 1);
        case 35:
            return this.readToken_numberSign();
    }
    this.raise(this.pos, "Unexpected character '" + $6fb78ed28ed3b042$var$codePointToString(code) + "'");
};
$6fb78ed28ed3b042$var$pp.finishOp = function(type, size) {
    var str = this.input.slice(this.pos, this.pos + size);
    this.pos += size;
    return this.finishToken(type, str);
};
$6fb78ed28ed3b042$var$pp.readRegexp = function() {
    var escaped, inClass, start = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(start, "Unterminated regular expression");
        var ch = this.input.charAt(this.pos);
        if ($6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6.test(ch)) this.raise(start, "Unterminated regular expression");
        if (!escaped) {
            if (ch === "[") inClass = true;
            else if (ch === "]" && inClass) inClass = false;
            else if (ch === "/" && !inClass) break;
            escaped = ch === "\\";
        } else escaped = false;
        ++this.pos;
    }
    var pattern = this.input.slice(start, this.pos);
    ++this.pos;
    var flagsStart = this.pos;
    var flags = this.readWord1();
    if (this.containsEsc) this.unexpected(flagsStart);
    // Validate pattern
    var state = this.regexpState || (this.regexpState = new $6fb78ed28ed3b042$var$RegExpValidationState(this));
    state.reset(start, pattern, flags);
    this.validateRegExpFlags(state);
    this.validateRegExpPattern(state);
    // Create Literal#value property value.
    var value = null;
    try {
        value = new RegExp(pattern, flags);
    } catch (e) {
    // ESTree requires null if it failed to instantiate RegExp object.
    // https://github.com/estree/estree/blob/a27003adf4fd7bfad44de9cef372a2eacd527b1c/es5.md#regexpliteral
    }
    return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.regexp, {
        pattern: pattern,
        flags: flags,
        value: value
    });
};
// Read an integer in the given radix. Return null if zero digits
// were read, the integer value otherwise. When `len` is given, this
// will return `null` unless the integer has exactly `len` digits.
$6fb78ed28ed3b042$var$pp.readInt = function(radix, len, maybeLegacyOctalNumericLiteral) {
    // `len` is used for character escape sequences. In that case, disallow separators.
    var allowSeparators = this.options.ecmaVersion >= 12 && len === undefined;
    // `maybeLegacyOctalNumericLiteral` is true if it doesn't have prefix (0x,0o,0b)
    // and isn't fraction part nor exponent part. In that case, if the first digit
    // is zero then disallow separators.
    var isLegacyOctalNumericLiteral = maybeLegacyOctalNumericLiteral && this.input.charCodeAt(this.pos) === 48;
    var start = this.pos, total = 0, lastCode = 0;
    for(var i = 0, e = len == null ? Infinity : len; i < e; ++i, ++this.pos){
        var code = this.input.charCodeAt(this.pos), val = void 0;
        if (allowSeparators && code === 95) {
            if (isLegacyOctalNumericLiteral) this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals");
            if (lastCode === 95) this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore");
            if (i === 0) this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits");
            lastCode = code;
            continue;
        }
        if (code >= 97) val = code - 97 + 10;
        else if (code >= 65) val = code - 65 + 10;
        else if (code >= 48 && code <= 57) val = code - 48;
        else val = Infinity;
        if (val >= radix) break;
        lastCode = code;
        total = total * radix + val;
    }
    if (allowSeparators && lastCode === 95) this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits");
    if (this.pos === start || len != null && this.pos - start !== len) return null;
    return total;
};
function $6fb78ed28ed3b042$var$stringToNumber(str, isLegacyOctalNumericLiteral) {
    if (isLegacyOctalNumericLiteral) return parseInt(str, 8);
    // `parseFloat(value)` stops parsing at the first numeric separator then returns a wrong value.
    return parseFloat(str.replace(/_/g, ""));
}
function $6fb78ed28ed3b042$var$stringToBigInt(str) {
    if (typeof BigInt !== "function") return null;
    // `BigInt(value)` throws syntax error if the string contains numeric separators.
    return BigInt(str.replace(/_/g, ""));
}
$6fb78ed28ed3b042$var$pp.readRadixNumber = function(radix) {
    var start = this.pos;
    this.pos += 2; // 0x
    var val = this.readInt(radix);
    if (val == null) this.raise(this.start + 2, "Expected number in radix " + radix);
    if (this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110) {
        val = $6fb78ed28ed3b042$var$stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
    } else if ($6fb78ed28ed3b042$export$56b48cc5d7560ffb(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.num, val);
};
// Read an integer, octal integer, or floating-point number.
$6fb78ed28ed3b042$var$pp.readNumber = function(startsWithDot) {
    var start = this.pos;
    if (!startsWithDot && this.readInt(10, undefined, true) === null) this.raise(start, "Invalid number");
    var octal = this.pos - start >= 2 && this.input.charCodeAt(start) === 48;
    if (octal && this.strict) this.raise(start, "Invalid number");
    var next = this.input.charCodeAt(this.pos);
    if (!octal && !startsWithDot && this.options.ecmaVersion >= 11 && next === 110) {
        var val$1 = $6fb78ed28ed3b042$var$stringToBigInt(this.input.slice(start, this.pos));
        ++this.pos;
        if ($6fb78ed28ed3b042$export$56b48cc5d7560ffb(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
        return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.num, val$1);
    }
    if (octal && /[89]/.test(this.input.slice(start, this.pos))) octal = false;
    if (next === 46 && !octal) {
        ++this.pos;
        this.readInt(10);
        next = this.input.charCodeAt(this.pos);
    }
    if ((next === 69 || next === 101) && !octal) {
        next = this.input.charCodeAt(++this.pos);
        if (next === 43 || next === 45) ++this.pos;
         // '+-'
        if (this.readInt(10) === null) this.raise(start, "Invalid number");
    }
    if ($6fb78ed28ed3b042$export$56b48cc5d7560ffb(this.fullCharCodeAtPos())) this.raise(this.pos, "Identifier directly after number");
    var val = $6fb78ed28ed3b042$var$stringToNumber(this.input.slice(start, this.pos), octal);
    return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.num, val);
};
// Read a string value, interpreting backslash-escapes.
$6fb78ed28ed3b042$var$pp.readCodePoint = function() {
    var ch = this.input.charCodeAt(this.pos), code;
    if (ch === 123) {
        if (this.options.ecmaVersion < 6) this.unexpected();
        var codePos = ++this.pos;
        code = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos);
        ++this.pos;
        if (code > 0x10FFFF) this.invalidStringToken(codePos, "Code point out of bounds");
    } else code = this.readHexChar(4);
    return code;
};
$6fb78ed28ed3b042$var$pp.readString = function(quote) {
    var out = "", chunkStart = ++this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated string constant");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === quote) break;
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(false);
            chunkStart = this.pos;
        } else if (ch === 0x2028 || ch === 0x2029) {
            if (this.options.ecmaVersion < 10) this.raise(this.start, "Unterminated string constant");
            ++this.pos;
            if (this.options.locations) {
                this.curLine++;
                this.lineStart = this.pos;
            }
        } else {
            if ($6fb78ed28ed3b042$export$2c19a3e3b4008fff(ch)) this.raise(this.start, "Unterminated string constant");
            ++this.pos;
        }
    }
    out += this.input.slice(chunkStart, this.pos++);
    return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.string, out);
};
// Reads template string tokens.
var $6fb78ed28ed3b042$var$INVALID_TEMPLATE_ESCAPE_ERROR = {};
$6fb78ed28ed3b042$var$pp.tryReadTemplateToken = function() {
    this.inTemplateElement = true;
    try {
        this.readTmplToken();
    } catch (err) {
        if (err === $6fb78ed28ed3b042$var$INVALID_TEMPLATE_ESCAPE_ERROR) this.readInvalidTemplateToken();
        else throw err;
    }
    this.inTemplateElement = false;
};
$6fb78ed28ed3b042$var$pp.invalidStringToken = function(position, message) {
    if (this.inTemplateElement && this.options.ecmaVersion >= 9) throw $6fb78ed28ed3b042$var$INVALID_TEMPLATE_ESCAPE_ERROR;
    else this.raise(position, message);
};
$6fb78ed28ed3b042$var$pp.readTmplToken = function() {
    var out = "", chunkStart = this.pos;
    for(;;){
        if (this.pos >= this.input.length) this.raise(this.start, "Unterminated template");
        var ch = this.input.charCodeAt(this.pos);
        if (ch === 96 || ch === 36 && this.input.charCodeAt(this.pos + 1) === 123) {
            if (this.pos === this.start && (this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.template || this.type === $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.invalidTemplate)) {
                if (ch === 36) {
                    this.pos += 2;
                    return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.dollarBraceL);
                } else {
                    ++this.pos;
                    return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.backQuote);
                }
            }
            out += this.input.slice(chunkStart, this.pos);
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.template, out);
        }
        if (ch === 92) {
            out += this.input.slice(chunkStart, this.pos);
            out += this.readEscapedChar(true);
            chunkStart = this.pos;
        } else if ($6fb78ed28ed3b042$export$2c19a3e3b4008fff(ch)) {
            out += this.input.slice(chunkStart, this.pos);
            ++this.pos;
            switch(ch){
                case 13:
                    if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
                case 10:
                    out += "\n";
                    break;
                default:
                    out += String.fromCharCode(ch);
                    break;
            }
            if (this.options.locations) {
                ++this.curLine;
                this.lineStart = this.pos;
            }
            chunkStart = this.pos;
        } else ++this.pos;
    }
};
// Reads a template token to search for the end, without validating any escape sequences
$6fb78ed28ed3b042$var$pp.readInvalidTemplateToken = function() {
    for(; this.pos < this.input.length; this.pos++)switch(this.input[this.pos]){
        case "\\":
            ++this.pos;
            break;
        case "$":
            if (this.input[this.pos + 1] !== "{") break;
        // fall through
        case "`":
            return this.finishToken($6fb78ed28ed3b042$export$b54c7ea7aabba5c8.invalidTemplate, this.input.slice(this.start, this.pos));
        case "\r":
            if (this.input[this.pos + 1] === "\n") ++this.pos;
        // fall through
        case "\n":
        case "\u2028":
        case "\u2029":
            ++this.curLine;
            this.lineStart = this.pos + 1;
            break;
    }
    this.raise(this.start, "Unterminated template");
};
// Used to read escaped characters
$6fb78ed28ed3b042$var$pp.readEscapedChar = function(inTemplate) {
    var ch = this.input.charCodeAt(++this.pos);
    ++this.pos;
    switch(ch){
        case 110:
            return "\n" // 'n' -> '\n'
            ;
        case 114:
            return "\r" // 'r' -> '\r'
            ;
        case 120:
            return String.fromCharCode(this.readHexChar(2)) // 'x'
            ;
        case 117:
            return $6fb78ed28ed3b042$var$codePointToString(this.readCodePoint()) // 'u'
            ;
        case 116:
            return "\t" // 't' -> '\t'
            ;
        case 98:
            return "\b" // 'b' -> '\b'
            ;
        case 118:
            return "\u000b" // 'v' -> '\u000b'
            ;
        case 102:
            return "\f" // 'f' -> '\f'
            ;
        case 13:
            if (this.input.charCodeAt(this.pos) === 10) ++this.pos;
             // '\r\n'
        case 10:
            if (this.options.locations) {
                this.lineStart = this.pos;
                ++this.curLine;
            }
            return "";
        case 56:
        case 57:
            if (this.strict) this.invalidStringToken(this.pos - 1, "Invalid escape sequence");
            if (inTemplate) {
                var codePos = this.pos - 1;
                this.invalidStringToken(codePos, "Invalid escape sequence in template string");
            }
        default:
            if (ch >= 48 && ch <= 55) {
                var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0];
                var octal = parseInt(octalStr, 8);
                if (octal > 255) {
                    octalStr = octalStr.slice(0, -1);
                    octal = parseInt(octalStr, 8);
                }
                this.pos += octalStr.length - 1;
                ch = this.input.charCodeAt(this.pos);
                if ((octalStr !== "0" || ch === 56 || ch === 57) && (this.strict || inTemplate)) this.invalidStringToken(this.pos - 1 - octalStr.length, inTemplate ? "Octal literal in template string" : "Octal literal in strict mode");
                return String.fromCharCode(octal);
            }
            if ($6fb78ed28ed3b042$export$2c19a3e3b4008fff(ch)) {
                // Unicode new line characters after \ get removed from output in both
                // template literals and strings
                if (this.options.locations) {
                    this.lineStart = this.pos;
                    ++this.curLine;
                }
                return "";
            }
            return String.fromCharCode(ch);
    }
};
// Used to read character escape sequences ('\x', '\u', '\U').
$6fb78ed28ed3b042$var$pp.readHexChar = function(len) {
    var codePos = this.pos;
    var n = this.readInt(16, len);
    if (n === null) this.invalidStringToken(codePos, "Bad character escape sequence");
    return n;
};
// Read an identifier, and return it as a string. Sets `this.containsEsc`
// to whether the word contained a '\u' escape.
//
// Incrementally adds only escaped chars, adding other chunks as-is
// as a micro-optimization.
$6fb78ed28ed3b042$var$pp.readWord1 = function() {
    this.containsEsc = false;
    var word = "", first = true, chunkStart = this.pos;
    var astral = this.options.ecmaVersion >= 6;
    while(this.pos < this.input.length){
        var ch = this.fullCharCodeAtPos();
        if ($6fb78ed28ed3b042$export$332f4d7bee38db93(ch, astral)) this.pos += ch <= 0xffff ? 1 : 2;
        else if (ch === 92) {
            this.containsEsc = true;
            word += this.input.slice(chunkStart, this.pos);
            var escStart = this.pos;
            if (this.input.charCodeAt(++this.pos) !== 117) this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX");
            ++this.pos;
            var esc = this.readCodePoint();
            if (!(first ? $6fb78ed28ed3b042$export$56b48cc5d7560ffb : $6fb78ed28ed3b042$export$332f4d7bee38db93)(esc, astral)) this.invalidStringToken(escStart, "Invalid Unicode escape");
            word += $6fb78ed28ed3b042$var$codePointToString(esc);
            chunkStart = this.pos;
        } else break;
        first = false;
    }
    return word + this.input.slice(chunkStart, this.pos);
};
// Read an identifier or keyword token. Will check for reserved
// words when necessary.
$6fb78ed28ed3b042$var$pp.readWord = function() {
    var word = this.readWord1();
    var type = $6fb78ed28ed3b042$export$b54c7ea7aabba5c8.name;
    if (this.keywords.test(word)) type = $6fb78ed28ed3b042$export$d53f8326294b31d8[word];
    return this.finishToken(type, word);
};
// Acorn is a tiny, fast JavaScript parser written in JavaScript.
//
// Acorn was written by Marijn Haverbeke, Ingvar Stepanyan, and
// various contributors and released under an MIT license.
//
// Git repositories for Acorn are available at
//
//     http://marijnhaverbeke.nl/git/acorn
//     https://github.com/acornjs/acorn.git
//
// Please use the [github bug tracker][ghbt] to report issues.
//
// [ghbt]: https://github.com/acornjs/acorn/issues
var $6fb78ed28ed3b042$export$83d89fbfd8236492 = "8.19.0";
$6fb78ed28ed3b042$export$7acfa6ed01010e37.acorn = {
    Parser: $6fb78ed28ed3b042$export$7acfa6ed01010e37,
    version: $6fb78ed28ed3b042$export$83d89fbfd8236492,
    defaultOptions: $6fb78ed28ed3b042$export$ba43bf67f3d48107,
    Position: $6fb78ed28ed3b042$export$13807d9ee5a34a42,
    SourceLocation: $6fb78ed28ed3b042$export$7387db7caf96fcdb,
    getLineInfo: $6fb78ed28ed3b042$export$7af82191547c5ff7,
    Node: $6fb78ed28ed3b042$export$85c928794f8d04d4,
    TokenType: $6fb78ed28ed3b042$export$f435f793048e7a0f,
    tokTypes: $6fb78ed28ed3b042$export$b54c7ea7aabba5c8,
    keywordTypes: $6fb78ed28ed3b042$export$d53f8326294b31d8,
    TokContext: $6fb78ed28ed3b042$export$68e7b4c4d99215d9,
    tokContexts: $6fb78ed28ed3b042$export$2b5f701edfbd6f00,
    isIdentifierChar: $6fb78ed28ed3b042$export$332f4d7bee38db93,
    isIdentifierStart: $6fb78ed28ed3b042$export$56b48cc5d7560ffb,
    Token: $6fb78ed28ed3b042$export$50792b0e93539fde,
    isNewLine: $6fb78ed28ed3b042$export$2c19a3e3b4008fff,
    lineBreak: $6fb78ed28ed3b042$export$a1aa2dd4ad0d3f6,
    lineBreakG: $6fb78ed28ed3b042$export$866e20207bbc41f2,
    nonASCIIwhitespace: $6fb78ed28ed3b042$export$268622f0f1cbc82b
};
// The main exported interface (under `self.acorn` when in the
// browser) is a `parse` function that takes a code string and returns
// an abstract syntax tree as specified by the [ESTree spec][estree].
//
// [estree]: https://github.com/estree/estree
function $6fb78ed28ed3b042$export$98e6a39c04603d36(input, options) {
    return $6fb78ed28ed3b042$export$7acfa6ed01010e37.parse(input, options);
}
// This function tries to parse a single expression at a given
// offset in a string. Useful for parsing mixed-language formats
// that embed JavaScript expressions.
function $6fb78ed28ed3b042$export$61f24eb03dd7ce92(input, pos, options) {
    return $6fb78ed28ed3b042$export$7acfa6ed01010e37.parseExpressionAt(input, pos, options);
}
// Acorn is organized as a tokenizer and a recursive-descent parser.
// The `tokenizer` export provides an interface to the tokenizer.
function $6fb78ed28ed3b042$export$5f8c09e3ae6f64e1(input, options) {
    return $6fb78ed28ed3b042$export$7acfa6ed01010e37.tokenizer(input, options);
}

});

parcelRegister("8GDFe", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("dXEwi"))) : import("dXEwi")).then(()=>parcelRequire('eBAXX'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("8JNLO", function(module, exports) {

$parcel$export(module.exports, "preprocessChanges", () => $65c92200c7609eaa$export$ac8fb5fb52b42414);

var $91tDV = parcelRequire("91tDV");

var $eMYgZ = parcelRequire("eMYgZ");
function $65c92200c7609eaa$var$x(a) {
    return a && typeof a == "object" && !Array.isArray(a);
}
function $65c92200c7609eaa$var$J(a, s) {
    if (!a || typeof a.getByPath != "function") return null;
    try {
        return a.getByPath(s);
    } catch  {
        return null;
    }
}
function $65c92200c7609eaa$var$N(a, s) {
    if (!Array.isArray(a) || !Array.isArray(s)) return null;
    for(let u = a.length - 1; u >= 0; u--){
        const g = a[u];
        if (!Array.isArray(g) || g.length < 3) continue;
        const [m, f, d] = g;
        if (m !== "update" && m !== "set" || !Array.isArray(f) || f.length > s.length) continue;
        let p = !0;
        for(let i = 0; i < f.length; i++)if (f[i] !== s[i]) {
            p = !1;
            break;
        }
        if (!p) continue;
        if (f.length === s.length) return d;
        let c = d;
        for(let i = f.length; i < s.length; i++){
            if (c == null) return null;
            c = c[s[i]];
        }
        if (c !== null) return c;
    }
    return null;
}
function $65c92200c7609eaa$export$ac8fb5fb52b42414(a, s = [], u = {}) {
    const g = (e)=>{
        const [n, r, t] = e || [], l = Array.isArray(r) && r[0] === "schema", h = Array.isArray(r) && r[0] === "files";
        if (n === "delete") return [
            e
        ];
        if (!(n === "update" && Array.isArray(r) && (r.length === 1 || r.length === 2 || l && r.length === 3) && $65c92200c7609eaa$var$x(t)) || h || t && t.type === "files") return [
            e
        ];
        const y = $65c92200c7609eaa$var$J(a, r);
        if (Array.isArray(r) && n === "update" && (!l && r.length === 2 || l && r.length === 3) && (y === null || typeof y > "u")) return [
            e
        ];
        const A = y || {}, j = t || {};
        if (!$65c92200c7609eaa$var$x(A) || !$65c92200c7609eaa$var$x(j)) return [
            e
        ];
        const S = (0, $91tDV.diffJson)(A, j, []);
        if (!S.length) return [
            e
        ];
        const _ = [];
        for(let b = 0; b < S.length; b++){
            const P = S[b], O = [
                ...r,
                ...P.path
            ], v = O[O.length - 1];
            P.action === "set" ? _.push([
                "update",
                O,
                P.value
            ]) : P.action === "del" && v !== "__order" && _.push([
                "delete",
                O
            ]);
        }
        return _;
    }, m = (e)=>{
        const n = [], r = new Set;
        for(let t = 0; t < e.length; t++){
            const l = g(e[t]);
            for(let h = 0; h < l.length; h++){
                const o = l[h];
                if (!(Array.isArray(o) && o[0] === "delete" && Array.isArray(o[1]) && o[1][o[1].length - 1] === "__order")) {
                    const A = JSON.stringify(o);
                    r.has(A) || (r.add(A), n.push(o));
                }
            }
        }
        return n;
    }, d = (()=>{
        try {
            const e = m(s);
            return u.append && u.append.length && e.push(...u.append), e;
        } catch  {
            return Array.isArray(s) ? s.slice() : [];
        }
    })().map((e)=>{
        if (!Array.isArray(e) || e.length < 3) return e;
        const [n, r] = e;
        if (n !== "update" && n !== "set" || !Array.isArray(r)) return e;
        const t = $65c92200c7609eaa$var$N(s, r);
        return t === null ? e : [
            n,
            r,
            t
        ];
    }), p = (0, $eMYgZ.computeOrdersForTuples)(a, d), c = new Map;
    for(let e = 0; e < s.length; e++){
        const n = s[e];
        if (!Array.isArray(n) || n.length < 3) continue;
        const [r, t, l] = n, h = Array.isArray(t) && t[0] === "files";
        if (r !== "update" || !Array.isArray(t) || t.length !== 1 && t.length !== 2 || !$65c92200c7609eaa$var$x(l) || h || l && l.type === "files") continue;
        const o = Object.keys(l).filter((k)=>k !== "__order"), y = JSON.stringify(t);
        c.set(y, {
            path: t,
            keys: o
        });
    }
    const i = [], C = new Set;
    c.forEach((e, n)=>{
        C.add(n), i.push(e);
    });
    for(let e = 0; e < p.length; e++){
        const n = p[e], r = JSON.stringify(n.path);
        C.has(r) || (C.add(r), i.push(n));
    }
    return {
        granularChanges: d,
        orders: i
    };
}

});
parcelRegister("91tDV", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $691b338967b06659$export$53b83ca8eaab0383);
$parcel$export(module.exports, "diffJson", () => $691b338967b06659$export$904c012e6be94faf);
function $691b338967b06659$export$53b83ca8eaab0383(t) {
    return t && typeof t == "object" && !Array.isArray(t);
}
function $691b338967b06659$var$c(t, e) {
    if (Object.is(t, e)) return !0;
    if (typeof t == "function" && typeof e == "function") try {
        return t.toString() === e.toString();
    } catch  {
        return !1;
    }
    if (typeof t == "function" || typeof e == "function") return !1;
    if (t instanceof Date && e instanceof Date) return t.getTime() === e.getTime();
    if (t instanceof RegExp && e instanceof RegExp) return String(t) === String(e);
    if (Array.isArray(t) && Array.isArray(e)) {
        if (t.length !== e.length) return !1;
        for(let r = 0; r < t.length; r++)if (!$691b338967b06659$var$c(t[r], e[r])) return !1;
        return !0;
    }
    if (t && e && typeof t == "object" && typeof e == "object") {
        const r = Object.keys(t), i = Object.keys(e);
        if (r.length !== i.length) return !1;
        for(let f = 0; f < r.length; f++){
            const n = r[f];
            if (!Object.hasOwn(e, n) || !$691b338967b06659$var$c(t[n], e[n])) return !1;
        }
        return !0;
    }
    return !1;
}
function $691b338967b06659$export$904c012e6be94faf(t, e, r = []) {
    const i = [], f = Array.isArray(r) ? r : [];
    for(const n in t)Object.hasOwn(t, n) && !(n in e) && i.push({
        action: "del",
        path: [
            ...f,
            n
        ]
    });
    for(const n in e)if (Object.hasOwn(e, n)) {
        const o = t?.[n], s = e[n];
        $691b338967b06659$export$53b83ca8eaab0383(o) && $691b338967b06659$export$53b83ca8eaab0383(s) ? i.push(...$691b338967b06659$export$904c012e6be94faf(o, s, [
            ...f,
            n
        ])) : $691b338967b06659$var$c(o, s) || i.push({
            action: "set",
            path: [
                ...f,
                n
            ],
            value: s
        });
    }
    return i;
}

});

parcelRegister("eMYgZ", function(module, exports) {

$parcel$export(module.exports, "computeOrdersForTuples", () => $ac444d5c273ce383$export$3bd8404e3eb669ba);
function $ac444d5c273ce383$var$N(t) {
    return t && typeof t == "object" && !Array.isArray(t);
}
function $ac444d5c273ce383$var$b(t) {
    return Array.isArray(t) ? t : typeof t == "string" ? [
        t
    ] : [];
}
function $ac444d5c273ce383$export$8e50dbb6ea289577(t = []) {
    const n = new Set, c = [], p = new Set([
        "style",
        "class",
        "text",
        "html",
        "content",
        "data",
        "attr",
        "state",
        "scope",
        "define",
        "on",
        "extend",
        "extends",
        "childExtend",
        "childExtends",
        "children",
        "component",
        "context",
        "tag",
        "key",
        "__order",
        "if"
    ]);
    for(let u = 0; u < t.length; u++){
        const f = t[u];
        if (!Array.isArray(f) || f.length < 2) continue;
        const r = $ac444d5c273ce383$var$b(f[1]);
        if (!r.length || r[0] === "schema") continue;
        const g = r.slice(0, -1);
        if (g.length) {
            const e = JSON.stringify(g);
            n.has(e) || (n.add(e), c.push(g));
        }
        const i = r[r.length - 1];
        if (p.has(i) && r.length >= 2) {
            const e = r.slice(0, -2);
            if (e.length) {
                const o = JSON.stringify(e);
                n.has(o) || (n.add(o), c.push(e));
            }
        }
        for(let e = 0; e < r.length; e++){
            const o = r[e];
            if (!p.has(o)) continue;
            const l = r.slice(0, e);
            if (!l.length) continue;
            const s = JSON.stringify(l);
            n.has(s) || (n.add(s), c.push(l));
        }
    }
    return c;
}
function $ac444d5c273ce383$export$73fcced9b0346081(t, n = []) {
    if (!t || typeof t.getByPath != "function") return [];
    const c = [], p = new Set([
        "__order"
    ]);
    for(let u = 0; u < n.length; u++){
        const f = n[u], r = (()=>{
            try {
                return t.getByPath(f);
            } catch  {
                return null;
            }
        })();
        if (!$ac444d5c273ce383$var$N(r)) continue;
        const g = Object.keys(r).filter((i)=>!p.has(i));
        c.push({
            path: f,
            keys: g
        });
    }
    return c;
}
function $ac444d5c273ce383$var$M(t) {
    return typeof t != "string" || !t.length ? "" : t.replaceAll("/////n", `
`).replaceAll("/////tilde", "`");
}
function $ac444d5c273ce383$var$B(t) {
    const n = $ac444d5c273ce383$var$M(t);
    if (!n) return null;
    const c = n.replace(/^\s*export\s+default\s*/u, "return ");
    try {
        return new Function(c)();
    } catch  {
        return null;
    }
}
function $ac444d5c273ce383$var$F(t) {
    const n = $ac444d5c273ce383$var$B(t);
    return !n || typeof n != "object" ? [] : Object.keys(n);
}
function $ac444d5c273ce383$export$3bd8404e3eb669ba(t, n = []) {
    const c = new Map;
    for(let i = 0; i < n.length; i++){
        const e = n[i];
        if (!Array.isArray(e)) continue;
        const [o, l] = e, s = $ac444d5c273ce383$var$b(l);
        if (!Array.isArray(s) || s.length < 2 || s[0] === "schema") continue;
        const d = s.slice(0, -1), x = s[s.length - 1], y = JSON.stringify(d);
        c.has(y) || c.set(y, new Set), (o === "update" || o === "set") && c.get(y).add(x);
    }
    const p = new Map;
    for(let i = 0; i < n.length; i++){
        const e = n[i];
        if (!Array.isArray(e)) continue;
        const [o, l, s] = e, d = $ac444d5c273ce383$var$b(l);
        if (o !== "update" || !Array.isArray(d) || d.length < 3 || d[0] !== "schema") continue;
        const [, x, y] = d, a = [
            x,
            y
        ], A = s && Array.isArray(s.uses) ? s.uses : null, P = s && s.code, w = (()=>{
            try {
                return t && typeof t.getByPath == "function" ? t.getByPath(a) : null;
            } catch  {
                return null;
            }
        })();
        if (!w) continue;
        const _ = new Set(Object.keys(w)), m = new Set([
            "__order"
        ]), O = $ac444d5c273ce383$var$F(P);
        let S = [];
        const K = JSON.stringify(a), E = c.get(K) || new Set, j = new Set([
            ..._,
            ...E
        ]);
        if (Array.isArray(O) && O.length && (S = O.filter((h)=>j.has(h) && !m.has(h))), Array.isArray(A) && A.length) for(let h = 0; h < A.length; h++){
            const k = A[h];
            j.has(k) && !m.has(k) && !S.includes(k) && S.push(k);
        }
        if (E.size) for (const h of E)!m.has(h) && !S.includes(h) && S.push(h);
        S.length && p.set(JSON.stringify(a), {
            path: a,
            keys: S
        });
    }
    const u = $ac444d5c273ce383$export$8e50dbb6ea289577(n), f = [], r = new Set;
    p.forEach((i)=>{
        const e = JSON.stringify(i.path);
        r.has(e) || (r.add(e), f.push(i));
    });
    const g = $ac444d5c273ce383$export$73fcced9b0346081(t, u);
    for(let i = 0; i < g.length; i++){
        const e = g[i], o = JSON.stringify(e.path);
        if (r.has(o)) continue;
        const l = c.get(o);
        if (l && l.size) {
            const s = e.keys, d = new Set(s), x = new Set([
                "style",
                "class",
                "text",
                "html",
                "content",
                "data",
                "attr",
                "state",
                "scope",
                "define",
                "on",
                "extend",
                "extends",
                "childExtend",
                "childExtends",
                "children",
                "component",
                "context",
                "tag",
                "key",
                "__order",
                "if"
            ]);
            let y = s.length;
            for(let a = 0; a < s.length; a++)if (x.has(s[a])) {
                y = a;
                break;
            }
            for (const a of l){
                if (d.has(a)) continue;
                const A = y;
                s.splice(A, 0, a), d.add(a), y++;
            }
        }
        r.add(o), f.push(e);
    }
    return f;
}

});


parcelRegister("jchVc", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("4R0nr"))) : import("4R0nr")).then(()=>parcelRequire('8bMcq'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("5ulAg", function(module, exports) {

$parcel$export(module.exports, "ProjectService", () => $3ff07f2f79b070dd$export$9616f8c54d4f56aa);

var $em51x = parcelRequire("em51x");

var $eMYgZ = parcelRequire("eMYgZ");

var $8JNLO = parcelRequire("8JNLO");
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");

var $3WN7t = parcelRequire("3WN7t");

var $hPIwr = parcelRequire("hPIwr");

var $gYAeI = parcelRequire("gYAeI");

var $h5XS2 = parcelRequire("h5XS2");
function $3ff07f2f79b070dd$var$l(y) {
    const r = y?.cause?.cause ?? y?.cause ?? null;
    return r && typeof r == "object" && !(r instanceof Error) ? r : {};
}
const $3ff07f2f79b070dd$var$$ = new Set([
    "not_public",
    "project_not_found",
    "env_not_found",
    "project_unavailable"
]);
class $3ff07f2f79b070dd$export$9616f8c54d4f56aa extends (0, $em51x.BaseService) {
    async createProject(r) {
        this._requireReady("createProject");
        try {
            const e = await this._request("/projects", {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "createProject"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to create project: ${e.message}`, {
                cause: e
            });
        }
    }
    async getProjects(r = {}) {
        this._requireReady("getProjects");
        try {
            const e = new URLSearchParams;
            Object.keys(r).forEach((o)=>{
                r[o] != null && e.append(o, r[o]);
            });
            const t = e.toString(), s = t ? await this._request(`/projects?${t}`, {
                method: "GET",
                methodName: "getProjects"
            }) : await this._request("/projects", {
                method: "GET",
                methodName: "getProjects"
            });
            if (s.success) return s;
            throw new Error(s.message);
        } catch (e) {
            throw new Error(`Failed to get projects: ${e.message}`, {
                cause: e
            });
        }
    }
    async listProjects(r = {}) {
        return await this.getProjects(r);
    }
    async listPublicProjects(r = {}) {
        try {
            const e = new URLSearchParams;
            Object.keys(r).forEach((o)=>{
                r[o] != null && e.append(o, r[o]);
            });
            const t = e.toString(), s = t ? await this._request(`/projects/public?${t}`, {
                method: "GET",
                methodName: "listPublicProjects"
            }) : await this._request("/projects/public", {
                method: "GET",
                methodName: "listPublicProjects"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (e) {
            throw new Error(`Failed to list public projects: ${e.message}`, {
                cause: e
            });
        }
    }
    async getProject(r) {
        if (this._requireReady("getProject"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/projects/${r}`, {
                method: "GET",
                methodName: "getProject"
            });
            if (e.success) {
                const t = e.data.icon ? `${this._apiUrl}/core/files/public/${e.data.icon.id}/download` : null;
                return {
                    ...e.data,
                    icon: {
                        src: t,
                        ...e.data.icon
                    }
                };
            }
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get project: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPublicProject(r) {
        if (!r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/projects/public/${r}`, {
                method: "GET",
                methodName: "getPublicProject"
            });
            if (e.success) {
                const t = e.data.icon ? `${this._apiUrl}/core/files/public/${e.data.icon.id}/download` : null;
                return {
                    ...e.data,
                    icon: {
                        src: t,
                        ...e.data.icon
                    }
                };
            }
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get public project: ${e.message}`, {
                cause: e
            });
        }
    }
    async getProjectByKey(r, e = {}) {
        this._requireReady("getProjectByKey");
        const t = (0, $hPIwr.projectKeyPath)(r), { workspaceId: s } = e, o = s ? new URLSearchParams({
            workspaceId: String(s)
        }).toString() : "";
        try {
            const a = await this._request(`/projects/key/${t}${o ? `?${o}` : ""}`, {
                method: "GET",
                methodName: "getProjectByKey"
            });
            if (a.success) {
                const n = a.data.icon ? `${this._apiUrl}/core/files/public/${a.data.icon.id}/download` : null;
                return {
                    ...a.data,
                    icon: {
                        src: n,
                        ...a.data.icon
                    }
                };
            }
            throw new Error(a.message);
        } catch (a) {
            const n = (0, $gYAeI.ambiguousKeyError)(a, r);
            throw n || new Error(`Failed to get project by key: ${a.message}`, {
                cause: a
            });
        }
    }
    async getProjectDataByKey(r, e = {}) {
        this._requireReady("getProjectDataByKey");
        const t = (0, $hPIwr.projectKeyPath)(r), { branch: s = "main", version: o = "latest", includeHistory: a = !1, workspaceId: n, headers: i } = e, c = new URLSearchParams({
            branch: s,
            version: o,
            includeHistory: a.toString(),
            ...n ? {
                workspaceId: String(n)
            } : {}
        }).toString();
        try {
            const h = await this._request(`/projects/key/${t}/data?${c}`, {
                method: "GET",
                methodName: "getProjectDataByKey",
                ...i ? {
                    headers: i
                } : {}
            });
            if (h.success) return h.data;
            throw new Error(h.message);
        } catch (h) {
            const w = (0, $gYAeI.ambiguousKeyError)(h, r);
            throw w || new Error(`Failed to get project data by key: ${h.message}`, {
                cause: h
            });
        }
    }
    async getPublicProjectDataByKey(r, { envKey: e } = {}) {
        if (!e) throw new Error("Environment key is required");
        const t = (0, $hPIwr.projectKeyPath)(r);
        try {
            const s = await this._request(`/projects/key/${t}/public/${encodeURIComponent(e)}/data`, {
                method: "GET",
                methodName: "getPublicProjectDataByKey"
            });
            return s?.success ? s.data : null;
        } catch (s) {
            const o = $3ff07f2f79b070dd$var$l(s), a = o?.error, n = (0, $gYAeI.ambiguousKeyError)(s, r);
            if (n) throw n;
            if (a === "password_required") {
                const i = new Error(o.message || "Project is password-protected");
                throw i.code = "password_required", i.visibility = o.visibility || "password-protected", i.status = 401, i;
            }
            if ($3ff07f2f79b070dd$var$$.has(a)) return null;
            throw new Error(`Failed to get public project data by key: ${s.message}`, {
                cause: s
            });
        }
    }
    async getPublicProjectVisibility(r) {
        const e = (0, $hPIwr.projectKeyPath)(r);
        try {
            return (await this._request(`/projects/key/${e}/public/visibility`, {
                method: "GET",
                methodName: "getPublicProjectVisibility"
            }))?.data?.visibility || null;
        } catch (t) {
            return $3ff07f2f79b070dd$var$l(t)?.error === "project_unavailable" || (0, $h5XS2.logger).warn("[ProjectService.getPublicProjectVisibility] probe failed:", t?.message || t), null;
        }
    }
    async unlockPublicProjectDataByKey(r, { envKey: e, password: t } = {}) {
        if (!e) throw new Error("Environment key is required");
        if (!t) throw new Error("Password is required");
        const s = (0, $hPIwr.projectKeyPath)(r);
        try {
            const o = await this._request(`/projects/key/${s}/public/${encodeURIComponent(e)}/unlock`, {
                method: "POST",
                body: JSON.stringify({
                    password: t
                }),
                methodName: "unlockPublicProjectDataByKey"
            });
            return o?.success ? o.data : null;
        } catch (o) {
            const a = (0, $gYAeI.ambiguousKeyError)(o, r);
            if (a) throw a;
            const i = $3ff07f2f79b070dd$var$l(o)?.error;
            if (i === "invalid_password" || i === "invalid_params" || i === "not_password_protected" || i === "project_unavailable") return null;
            throw new Error(`Failed to unlock public project data by key: ${o.message}`, {
                cause: o
            });
        }
    }
    async resolveAppkey(r) {
        if (!r) throw new Error("appkey is required");
        const e = await this._request(`/projects/resolve/${encodeURIComponent(r)}`, {
            method: "GET",
            methodName: "resolveAppkey"
        });
        if (e?.success && e.data) return e.data;
        if (e?.owner !== void 0 || e?.key !== void 0) return e;
        throw new Error(e?.message || "Failed to resolve appkey");
    }
    async updateProject(r, e) {
        if (this._requireReady("updateProject"), !r) throw new Error("Project ID is required");
        try {
            const t = await this._request(`/projects/${r}`, {
                method: "PATCH",
                body: JSON.stringify(e),
                methodName: "updateProject"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update project: ${t.message}`, {
                cause: t
            });
        }
    }
    async updateProjectComponents(r, e) {
        if (this._requireReady("updateProjectComponents"), !r) throw new Error("Project ID is required");
        try {
            const t = await this._request(`/projects/${r}/components`, {
                method: "PATCH",
                body: JSON.stringify({
                    components: e
                }),
                methodName: "updateProjectComponents"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update project components: ${t.message}`, {
                cause: t
            });
        }
    }
    async updateProjectSettings(r, e) {
        if (this._requireReady("updateProjectSettings"), !r) throw new Error("Project ID is required");
        try {
            const t = await this._request(`/projects/${r}/settings`, {
                method: "PATCH",
                body: JSON.stringify({
                    settings: e
                }),
                methodName: "updateProjectSettings"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update project settings: ${t.message}`, {
                cause: t
            });
        }
    }
    async updateProjectName(r, e) {
        if (this._requireReady("updateProjectName"), !r) throw new Error("Project ID is required");
        try {
            const t = await this._request(`/projects/${r}`, {
                method: "PATCH",
                body: JSON.stringify({
                    name: e
                }),
                methodName: "updateProjectName"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update project name: ${t.message}`, {
                cause: t
            });
        }
    }
    async setProjectSourceAccess(r, e) {
        if (!r) throw new Error("Project ID is required");
        if (!e) throw new Error("sourceAccess is required");
        if (!(0, $3WN7t.PROJECT_SOURCE_ACCESS).includes(e)) throw new Error(`Invalid sourceAccess: ${e}. Must be one of: ${(0, $3WN7t.PROJECT_SOURCE_ACCESS).join(", ")}`);
        return this._call("setProjectSourceAccess", `/projects/${r}`, {
            method: "PATCH",
            body: {
                sourceAccess: e
            }
        });
    }
    async setProjectAccess(r, e) {
        if (this._requireReady("setProjectAccess"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Access level is required");
        const t = [
            "account",
            "team",
            "organization",
            "public"
        ];
        if (!t.includes(e)) throw new Error(`Invalid access value: ${e}. Must be one of: ${t.join(", ")}`);
        try {
            const s = await this._request(`/projects/${r}`, {
                method: "PATCH",
                body: JSON.stringify({
                    access: e
                }),
                methodName: "setProjectAccess"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to set project access: ${s.message}`, {
                cause: s
            });
        }
    }
    async setProjectVisibility(r, e) {
        if (this._requireReady("setProjectVisibility"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Visibility is required");
        const t = [
            "public",
            "private",
            "password-protected"
        ];
        if (!t.includes(e)) throw new Error(`Invalid visibility value: ${e}. Must be one of: ${t.join(", ")}`);
        try {
            const s = await this._request(`/projects/${r}`, {
                method: "PATCH",
                body: JSON.stringify({
                    visibility: e
                }),
                methodName: "setProjectVisibility"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to set project visibility: ${s.message}`, {
                cause: s
            });
        }
    }
    async updateProjectPackage(r, e) {
        if (this._requireReady("updateProjectPackage"), !r) throw new Error("Project ID is required");
        try {
            const t = await this._request(`/projects/${r}/package`, {
                method: "PATCH",
                body: JSON.stringify({
                    package: e
                }),
                methodName: "updateProjectPackage"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update project package: ${t.message}`, {
                cause: t
            });
        }
    }
    async duplicateProject(r, e, t, s, o = {}) {
        if (this._requireReady("duplicateProject"), !r) throw new Error("Project ID is required");
        const { targetOwnerOrganization: a, fork: n, regenerateSecrets: i } = o || {};
        try {
            const c = await this._request(`/projects/${r}/duplicate`, {
                method: "POST",
                body: JSON.stringify({
                    name: e,
                    key: t,
                    targetUserId: s,
                    targetOwnerOrganization: a,
                    fork: n,
                    regenerateSecrets: i
                }),
                methodName: "duplicateProject"
            });
            if (c.success) return c.data;
            throw new Error(c.message);
        } catch (c) {
            throw new Error(`Failed to duplicate project: ${c.message}`, {
                cause: c
            });
        }
    }
    async removeProject(r) {
        if (this._requireReady("removeProject"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/projects/${r}`, {
                method: "DELETE",
                methodName: "removeProject"
            });
            if (e.success) return e;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to remove project: ${e.message}`, {
                cause: e
            });
        }
    }
    async transferProjectOwnership(r, { targetType: e, userId: t, organizationId: s }) {
        if (this._requireReady("transferProjectOwnership"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("targetType is required (user or organization)");
        const o = await this._request(`/projects/${r}/transfer-ownership`, {
            method: "POST",
            body: JSON.stringify({
                targetType: e,
                userId: t,
                organizationId: s
            }),
            methodName: "transferProjectOwnership"
        });
        if (o.success) return o.data;
        throw new Error(o.message);
    }
    async transferProjectToWorkspace(r, e) {
        if (this._requireReady("transferProjectToWorkspace"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("targetWorkspaceId is required");
        const t = await this._request(`/projects/${r}/transfer-workspace`, {
            method: "POST",
            body: JSON.stringify({
                targetWorkspaceId: e
            }),
            methodName: "transferProjectToWorkspace"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async checkProjectKeyAvailability(r) {
        if (this._requireReady("checkProjectKeyAvailability"), !r) throw new Error("Project key is required");
        try {
            const e = await this._request(`/projects/check-key/${r}`, {
                method: "GET",
                methodName: "checkProjectKeyAvailability"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to check project key availability: ${e.message}`, {
                cause: e
            });
        }
    }
    async getProjectRolePermissionsConfig(r, e = {}) {
        if (this._requireReady("getProjectRolePermissionsConfig"), !r) throw new Error("Project ID is required");
        const { headers: t } = e;
        try {
            const s = await this._request(`/projects/${r}/permissions`, {
                method: "GET",
                ...t ? {
                    headers: t
                } : {},
                methodName: "getProjectRolePermissionsConfig"
            });
            if (s && s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to get project role permissions config: ${s.message}`, {
                cause: s
            });
        }
    }
    async updateProjectRolePermissionsConfig(r, e, t = {}) {
        if (this._requireReady("updateProjectRolePermissionsConfig"), !r) throw new Error("Project ID is required");
        if (!e || typeof e != "object") throw new Error("rolePermissions object is required");
        const { headers: s } = t;
        try {
            const o = await this._request(`/projects/${r}/permissions`, {
                method: "PATCH",
                body: JSON.stringify({
                    rolePermissions: e
                }),
                ...s ? {
                    headers: s
                } : {},
                methodName: "updateProjectRolePermissionsConfig"
            });
            if (o && o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to update project role permissions config: ${o.message}`, {
                cause: o
            });
        }
    }
    async getProjectMembers(r) {
        if (this._requireReady("getProjectMembers"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/projects/${r}/members`, {
                method: "GET",
                methodName: "getProjectMembers"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get project members: ${e.message}`, {
                cause: e
            });
        }
    }
    async inviteMember(r, e, t = "guest", s = {}) {
        if (this._requireReady("inviteMember"), !r || !e || !t) throw new Error("Project ID, email, and role are required");
        const { name: o, callbackUrl: a, headers: n } = s;
        try {
            const i = {
                email: e,
                role: t
            };
            a && (i.callbackUrl = a), o && (i.name = o);
            const c = await this._request(`/projects/${r}/invite`, {
                method: "POST",
                body: JSON.stringify(i),
                ...n ? {
                    headers: n
                } : {},
                methodName: "inviteMember"
            });
            if (c.success) return c.data;
            throw new Error(c.message);
        } catch (i) {
            throw new Error(`Failed to invite member: ${i.message}`, {
                cause: i
            });
        }
    }
    async createMagicInviteLink(r, e = {}) {
        if (this._requireReady("createMagicInviteLink"), !r) throw new Error("Project ID is required");
        const { headers: t } = e;
        try {
            const s = await this._request(`/projects/${r}/invite-link`, {
                method: "POST",
                ...t ? {
                    headers: t
                } : {},
                methodName: "createMagicInviteLink"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to create magic invite link: ${s.message}`, {
                cause: s
            });
        }
    }
    async acceptInvite(r) {
        if (this._requireReady("acceptInvite"), !r) throw new Error("Invitation token is required");
        try {
            const e = await this._request("/projects/accept-invite", {
                method: "POST",
                body: JSON.stringify({
                    token: r
                }),
                methodName: "acceptInvite"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to accept invite: ${e.message}`, {
                cause: e
            });
        }
    }
    async updateMemberRole(r, e, t) {
        if (this._requireReady("updateMemberRole"), !r || !e || !t) throw new Error("Project ID, member ID, and role are required");
        try {
            const s = await this._request(`/projects/${r}/members/${e}`, {
                method: "PATCH",
                body: JSON.stringify({
                    role: t
                }),
                methodName: "updateMemberRole"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to update member role: ${s.message}`, {
                cause: s
            });
        }
    }
    async removeMember(r, e) {
        if (this._requireReady("removeMember"), !r || !e) throw new Error("Project ID and member ID are required");
        try {
            const t = await this._request(`/projects/${r}/members/${e}`, {
                method: "DELETE",
                methodName: "removeMember"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to remove member: ${t.message}`, {
                cause: t
            });
        }
    }
    async getAvailableLibraries(r = {}) {
        this._requireReady("getAvailableLibraries");
        const e = new URLSearchParams(r).toString();
        try {
            const t = await this._request(`/projects/libraries/available?${e}`, {
                method: "GET",
                methodName: "getAvailableLibraries"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to get available libraries: ${t.message}`, {
                cause: t
            });
        }
    }
    async getProjectLibraries(r) {
        if (this._requireReady("getProjectLibraries"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/projects/${r}/libraries`, {
                method: "GET",
                methodName: "getProjectLibraries"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get project libraries: ${e.message}`, {
                cause: e
            });
        }
    }
    async addProjectLibraries(r, e) {
        if (this._requireReady("addProjectLibraries"), !r || !e) throw new Error("Project ID and library IDs are required");
        try {
            const t = await this._request(`/projects/${r}/libraries`, {
                method: "POST",
                body: JSON.stringify({
                    libraryIds: e
                }),
                methodName: "addProjectLibraries"
            });
            if (t.success) return t;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to add project libraries: ${t.message}`, {
                cause: t
            });
        }
    }
    async removeProjectLibraries(r, e) {
        if (this._requireReady("removeProjectLibraries"), !r || !e) throw new Error("Project ID and library IDs are required");
        try {
            const t = await this._request(`/projects/${r}/libraries`, {
                method: "DELETE",
                body: JSON.stringify({
                    libraryIds: e
                }),
                methodName: "removeProjectLibraries"
            });
            if (t.success) return t;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to remove project libraries: ${t.message}`, {
                cause: t
            });
        }
    }
    async applyProjectChanges(r, e, t = {}) {
        if (this._requireReady("applyProjectChanges"), !r) throw new Error("Project ID is required");
        if (!Array.isArray(e)) throw new Error("Changes must be an array");
        const { message: s, branch: o = "main", type: a = "patch", headers: n, source: i, forceSharedLibrary: c } = t, h = this._context && this._context.state, { granularChanges: w, orders: g } = (0, $8JNLO.preprocessChanges)(h, e, t), p = t.orders || (g && g.length ? g : h ? (0, $eMYgZ.computeOrdersForTuples)(h, w) : []), j = (u)=>(0, $2C0hZ.deepStringifyFunctions)(u, Array.isArray(u) ? [] : {});
        try {
            const u = await this._request(`/projects/${r}/changes`, {
                method: "POST",
                body: JSON.stringify({
                    changes: j(e),
                    granularChanges: j(w),
                    message: s,
                    branch: o,
                    type: a,
                    ...p && p.length ? {
                        orders: p
                    } : {},
                    ...i && typeof i == "object" ? {
                        source: i
                    } : {},
                    ...c === !0 ? {
                        forceSharedLibrary: !0
                    } : {}
                }),
                ...n ? {
                    headers: n
                } : {},
                methodName: "applyProjectChanges"
            });
            if (u == null) return null;
            if (u.success) return u.data;
            throw new Error(u.message);
        } catch (u) {
            throw new Error(`Failed to apply project changes: ${u.message}`, {
                cause: u
            });
        }
    }
    async getProjectData(r, e = {}) {
        if (this._requireReady("getProjectData"), !r) throw new Error("Project ID is required");
        const { branch: t = "main", version: s = "latest", includeHistory: o = !1, headers: a } = e, n = new URLSearchParams({
            branch: t,
            version: s,
            includeHistory: o.toString()
        }).toString();
        try {
            const i = await this._request(`/projects/${r}/data?${n}`, {
                method: "GET",
                methodName: "getProjectData",
                ...a ? {
                    headers: a
                } : {}
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to get project data: ${i.message}`, {
                cause: i
            });
        }
    }
    async getProjectVersions(r, e = {}) {
        if (this._requireReady("getProjectVersions"), !r) throw new Error("Project ID is required");
        const { branch: t = "main", page: s = 1, limit: o = 50, fields: a, headers: n } = e, i = new URLSearchParams({
            branch: t,
            page: s.toString(),
            limit: o.toString(),
            ...a ? {
                fields: Array.isArray(a) ? a.join(",") : a
            } : {}
        }).toString();
        try {
            const c = await this._request(`/projects/${r}/versions?${i}`, {
                method: "GET",
                methodName: "getProjectVersions",
                ...n ? {
                    headers: n
                } : {}
            });
            if (c.success) return c.data;
            throw new Error(c.message);
        } catch (c) {
            throw new Error(`Failed to get project versions: ${c.message}`, {
                cause: c
            });
        }
    }
    async getProjectVersion(r, e, t = {}) {
        if (this._requireReady("getProjectVersion"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Version ID is required");
        const { headers: s } = t;
        try {
            const o = await this._request(`/projects/${r}/versions/${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "getProjectVersion",
                ...s ? {
                    headers: s
                } : {}
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to get project version: ${o.message}`, {
                cause: o
            });
        }
    }
    async getLatestProjectVersion(r, e = {}) {
        if (this._requireReady("getLatestProjectVersion"), !r) throw new Error("Project ID is required");
        const { branch: t = "main", headers: s } = e, o = new URLSearchParams({
            branch: t
        }).toString();
        try {
            const a = await this._request(`/projects/${r}/versions/latest?${o}`, {
                method: "GET",
                methodName: "getLatestProjectVersion",
                ...s ? {
                    headers: s
                } : {}
            });
            if (a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to get latest project version: ${a.message}`, {
                cause: a
            });
        }
    }
    async getProjectVersionData(r, e, t = {}) {
        if (this._requireReady("getProjectVersionData"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Version ID is required");
        const { headers: s } = t;
        try {
            const o = await this._request(`/projects/${r}/versions/${encodeURIComponent(e)}/data`, {
                method: "GET",
                methodName: "getProjectVersionData",
                ...s ? {
                    headers: s
                } : {}
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to get project version data: ${o.message}`, {
                cause: o
            });
        }
    }
    async listEnvironments(r, e = {}) {
        if (this._requireReady("listEnvironments"), !r) throw new Error("Project ID is required");
        const { headers: t, workspaceId: s } = e, o = s ? new URLSearchParams({
            workspaceId: String(s)
        }).toString() : "";
        try {
            const a = await this._request(`/projects/${r}/environments${o ? `?${o}` : ""}`, {
                method: "GET",
                ...t ? {
                    headers: t
                } : {},
                methodName: "listEnvironments"
            });
            if (a && a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to list environments: ${a.message}`, {
                cause: a
            });
        }
    }
    async upsertEnvironment(r, e, t, s = {}) {
        if (this._requireReady("upsertEnvironment"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Environment key is required");
        if (!t || typeof t != "object") throw new Error("Environment config object is required");
        const { headers: o } = s;
        try {
            const a = await this._request(`/projects/${r}/environments`, {
                method: "POST",
                body: JSON.stringify({
                    envKey: e,
                    config: t
                }),
                ...o ? {
                    headers: o
                } : {},
                methodName: "upsertEnvironment"
            });
            if (a && a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to upsert environment: ${a.message}`, {
                cause: a
            });
        }
    }
    async updateEnvironment(r, e, t, s = {}) {
        if (this._requireReady("updateEnvironment"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Environment key is required");
        if (!t || typeof t != "object") throw new Error("Environment updates object is required");
        const { headers: o } = s;
        try {
            const a = await this._request(`/projects/${r}/environments/${encodeURIComponent(e)}`, {
                method: "PATCH",
                body: JSON.stringify(t),
                ...o ? {
                    headers: o
                } : {},
                methodName: "updateEnvironment"
            });
            if (a && a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to update environment: ${a.message}`, {
                cause: a
            });
        }
    }
    async publishToEnvironment(r, e, t, s = {}) {
        if (this._requireReady("publishToEnvironment"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Environment key is required");
        if (!t || typeof t != "object") throw new Error("Publish payload is required");
        const { headers: o } = s;
        try {
            const a = await this._request(`/projects/${r}/environments/${encodeURIComponent(e)}/publish`, {
                method: "POST",
                body: JSON.stringify(t),
                ...o ? {
                    headers: o
                } : {},
                methodName: "publishToEnvironment"
            });
            if (a && a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to publish to environment: ${a.message}`, {
                cause: a
            });
        }
    }
    async deleteEnvironment(r, e, t = {}) {
        if (this._requireReady("deleteEnvironment"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Environment key is required");
        const { headers: s } = t;
        try {
            const o = await this._request(`/projects/${r}/environments/${encodeURIComponent(e)}`, {
                method: "DELETE",
                ...s ? {
                    headers: s
                } : {},
                methodName: "deleteEnvironment"
            });
            if (o && o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to delete environment: ${o.message}`, {
                cause: o
            });
        }
    }
    async promoteEnvironment(r, e, t, s = {}) {
        if (this._requireReady("promoteEnvironment"), !r) throw new Error("Project ID is required");
        if (!e || !t) throw new Error("Both fromEnvKey and toEnvKey are required");
        if (e === t) throw new Error("fromEnvKey and toEnvKey must be different");
        const { headers: o } = s;
        try {
            const a = await this._request(`/projects/${r}/pipeline/promote`, {
                method: "POST",
                body: JSON.stringify({
                    from: e,
                    to: t
                }),
                ...o ? {
                    headers: o
                } : {},
                methodName: "promoteEnvironment"
            });
            if (a && a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to promote environment: ${a.message}`, {
                cause: a
            });
        }
    }
    async restoreProjectVersion(r, e, t = {}) {
        if (this._requireReady("restoreProjectVersion"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Version is required");
        const { message: s, branch: o = "main", type: a = "patch", headers: n } = t;
        try {
            const i = await this._request(`/projects/${r}/restore`, {
                method: "POST",
                body: JSON.stringify({
                    version: e,
                    message: s,
                    branch: o,
                    type: a
                }),
                ...n ? {
                    headers: n
                } : {},
                methodName: "restoreProjectVersion"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to restore project version: ${i.message}`, {
                cause: i
            });
        }
    }
    async updateProjectItem(r, e, t, s = {}) {
        const o = [
            [
                "update",
                e,
                t
            ]
        ], a = s.message || `Updated ${Array.isArray(e) ? e.join(".") : e}`;
        return await this.applyProjectChanges(r, o, {
            ...s,
            message: a
        });
    }
    async deleteProjectItem(r, e, t = {}) {
        const s = [
            [
                "delete",
                e
            ]
        ], o = t.message || `Deleted ${Array.isArray(e) ? e.join(".") : e}`;
        return await this.applyProjectChanges(r, s, {
            ...t,
            message: o
        });
    }
    async setProjectValue(r, e, t, s = {}) {
        const o = [
            [
                "set",
                e,
                t
            ]
        ], a = s.message || `Set ${Array.isArray(e) ? e.join(".") : e}`;
        return await this.applyProjectChanges(r, o, {
            ...s,
            message: a
        });
    }
    async addProjectItems(r, e, t = {}) {
        const s = e.map((a)=>{
            const [n, i] = a, { value: c, ...h } = i;
            return [
                [
                    "update",
                    [
                        n,
                        i.key
                    ],
                    c
                ],
                [
                    "update",
                    [
                        "schema",
                        n,
                        i.key
                    ],
                    h
                ]
            ];
        }).flat(), o = t.message || `Added ${e.length} items`;
        return await this.applyProjectChanges(r, s, {
            ...t,
            message: o
        });
    }
    async getProjectItemByPath(r, e, t = {}) {
        const s = await this.getProjectData(r, t);
        if (!s?.data) return null;
        let o = s.data;
        const a = Array.isArray(e) ? e : [
            e
        ];
        for (const n of a)if (o && typeof o == "object" && n in o) o = o[n];
        else return null;
        return o;
    }
    async getFavoriteProjects() {
        this._requireReady("getFavoriteProjects");
        try {
            const r = await this._request("/users/favorites", {
                method: "GET",
                methodName: "getFavoriteProjects"
            });
            if (r.success) return (r.data || []).map((e)=>({
                    isFavorite: !0,
                    ...e,
                    ...e.icon && {
                        icon: {
                            src: `${this._apiUrl}/core/files/public/${e.icon.id}/download`,
                            ...e.icon
                        }
                    }
                }));
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to get favorite projects: ${r.message}`, {
                cause: r
            });
        }
    }
    async addFavoriteProject(r) {
        if (this._requireReady("addFavoriteProject"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/users/favorites/${r}`, {
                method: "POST",
                methodName: "addFavoriteProject"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to add favorite project: ${e.message}`, {
                cause: e
            });
        }
    }
    async removeFavoriteProject(r) {
        if (this._requireReady("removeFavoriteProject"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/users/favorites/${r}`, {
                method: "DELETE",
                methodName: "removeFavoriteProject"
            });
            if (e.success) return e.message || "Project removed from favorites";
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to remove favorite project: ${e.message}`, {
                cause: e
            });
        }
    }
    async getRecentProjects(r = {}) {
        this._requireReady("getRecentProjects");
        const { limit: e = 20, headers: t } = r, s = new URLSearchParams({
            limit: e.toString()
        }).toString();
        try {
            const o = s ? await this._request(`/users/projects/recent?${s}`, {
                method: "GET",
                ...t ? {
                    headers: t
                } : {},
                methodName: "getRecentProjects"
            }) : await this._request("/users/projects/recent", {
                method: "GET",
                ...t ? {
                    headers: t
                } : {},
                methodName: "getRecentProjects"
            });
            if (o.success) return (o.data || []).map((a)=>({
                    ...a.project,
                    ...a.project && a.project.icon && {
                        icon: {
                            src: `${this._apiUrl}/core/files/public/${a.project.icon.id}/download`,
                            ...a.project.icon
                        }
                    }
                }));
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to get recent projects: ${o.message}`, {
                cause: o
            });
        }
    }
    async getProjectComponents(r) {
        if (this._requireReady("getProjectComponents"), !r) throw new Error("projectId is required");
        const e = await this._request(`/projects/${encodeURIComponent(r)}/resources/components`, {
            method: "GET",
            methodName: "getProjectComponents"
        });
        return e?.success ? e : {
            items: []
        };
    }
    async getProjectFunctions(r) {
        if (this._requireReady("getProjectFunctions"), !r) throw new Error("projectId is required");
        const e = await this._request(`/projects/${encodeURIComponent(r)}/resources/functions`, {
            method: "GET",
            methodName: "getProjectFunctions"
        });
        return e?.success ? e : {
            items: []
        };
    }
    async getProjectPages(r) {
        if (this._requireReady("getProjectPages"), !r) throw new Error("projectId is required");
        const e = await this._request(`/projects/${encodeURIComponent(r)}/resources/pages`, {
            method: "GET",
            methodName: "getProjectPages"
        });
        return e?.success ? e : {
            items: []
        };
    }
    async getProjectComponentsByKey(r) {
        if (this._requireReady("getProjectComponentsByKey"), !r) throw new Error("projectKey is required");
        let e;
        try {
            e = await this._request(`/projects/key/${(0, $hPIwr.projectKeyPath)(r)}/resources/components`, {
                method: "GET",
                methodName: "getProjectComponentsByKey"
            });
        } catch (t) {
            throw (0, $gYAeI.ambiguousKeyError)(t, r) || t;
        }
        return e?.success ? e : {
            items: []
        };
    }
    async getProjectFunctionsByKey(r) {
        if (this._requireReady("getProjectFunctionsByKey"), !r) throw new Error("projectKey is required");
        let e;
        try {
            e = await this._request(`/projects/key/${(0, $hPIwr.projectKeyPath)(r)}/resources/functions`, {
                method: "GET",
                methodName: "getProjectFunctionsByKey"
            });
        } catch (t) {
            throw (0, $gYAeI.ambiguousKeyError)(t, r) || t;
        }
        return e?.success ? e : {
            items: []
        };
    }
    async getProjectPagesByKey(r) {
        if (this._requireReady("getProjectPagesByKey"), !r) throw new Error("projectKey is required");
        let e;
        try {
            e = await this._request(`/projects/key/${(0, $hPIwr.projectKeyPath)(r)}/resources/pages`, {
                method: "GET",
                methodName: "getProjectPagesByKey"
            });
        } catch (t) {
            throw (0, $gYAeI.ambiguousKeyError)(t, r) || t;
        }
        return e?.success ? e : {
            items: []
        };
    }
    async listProjectOwnership(r = {}) {
        this._requireReady("listProjectOwnership");
        const e = new URLSearchParams;
        Object.keys(r).forEach((o)=>{
            r[o] != null && e.append(o, String(r[o]));
        });
        const t = e.toString(), s = t ? await this._request(`/projects/ownership?${t}`, {
            method: "GET",
            methodName: "listProjectOwnership"
        }) : await this._request("/projects/ownership", {
            method: "GET",
            methodName: "listProjectOwnership"
        });
        return s?.success ? s : {
            success: !1,
            data: {
                items: [],
                total: 0
            }
        };
    }
    async assignProjectOwner(r = {}) {
        if (!r.projectId && !r.projectKey) throw new Error("projectId or projectKey is required");
        if (!r.userId && !r.email) throw new Error("userId or email is required");
        return this._call("assignProjectOwner", "/projects/ownership/assign", {
            method: "POST",
            body: r
        });
    }
    async autoAssignProjectOwners(r = {}) {
        return this._call("autoAssignProjectOwners", "/projects/ownership/auto-assign", {
            method: "POST",
            body: r
        });
    }
}

});
parcelRegister("3WN7t", function(module, exports) {

$parcel$export(module.exports, "WORKSPACE_MEMBER_ROLES", () => $2dfce4021e5f7a05$export$315dba6251724c18);
$parcel$export(module.exports, "TEAM_GRANT_ROLES", () => $2dfce4021e5f7a05$export$55fbb572687d8281);
$parcel$export(module.exports, "PROJECT_SOURCE_ACCESS", () => $2dfce4021e5f7a05$export$fe44eae457377e56);
const $2dfce4021e5f7a05$export$315dba6251724c18 = [
    "owner",
    "admin",
    "editor",
    "viewer",
    "guest"
], $2dfce4021e5f7a05$export$f14749e8f67a7bab = [
    "owner",
    "admin",
    "editor",
    "viewer",
    "guest"
], $2dfce4021e5f7a05$export$55fbb572687d8281 = [
    "admin",
    "editor",
    "guest",
    "viewer"
], $2dfce4021e5f7a05$export$fe44eae457377e56 = [
    "public",
    "org",
    "workspace",
    "restricted"
];

});

parcelRegister("hPIwr", function(module, exports) {

$parcel$export(module.exports, "projectKeyPath", () => $cfb9bc4223435b30$export$351585f89d583263);
function $cfb9bc4223435b30$export$351585f89d583263(e) {
    if (e && typeof e == "object") {
        const { owner: r, key: o } = e;
        if (!o) throw new Error("Project key is required");
        return r ? `${encodeURIComponent(r)}/${encodeURIComponent(o)}` : encodeURIComponent(o);
    }
    if (!e) throw new Error("Project key is required");
    return encodeURIComponent(String(e));
}

});


parcelRegister("kfmJN", function(module, exports) {

$parcel$export(module.exports, "PlanService", () => $ebd6d89095662a9f$export$b31c0ec5cbb6a324);

var $em51x = parcelRequire("em51x");
class $ebd6d89095662a9f$export$b31c0ec5cbb6a324 extends (0, $em51x.BaseService) {
    async getPlans() {
        try {
            const e = await this._request("/plans", {
                method: "GET",
                methodName: "getPlans"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get plans: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPlansWithPricing() {
        try {
            const e = await this._request("/plans/pricing", {
                method: "GET",
                methodName: "getPlansWithPricing"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get plans with pricing: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPlan(e) {
        if (!e) throw new Error("Plan ID is required");
        try {
            const r = await this._request(`/plans/${e}`, {
                method: "GET",
                methodName: "getPlan"
            });
            if (r.success) return r.data;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to get plan: ${r.message}`, {
                cause: r
            });
        }
    }
    async getAdminPlans() {
        this._requireReady("getAdminPlans");
        try {
            const e = await this._request("/admin/plans", {
                method: "GET",
                methodName: "getAdminPlans"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get admin plans: ${e.message}`, {
                cause: e
            });
        }
    }
    async createPlan(e) {
        if (this._requireReady("createPlan"), !e || typeof e != "object") throw new Error("Plan data is required");
        try {
            const r = await this._request("/admin/plans", {
                method: "POST",
                body: JSON.stringify(e),
                methodName: "createPlan"
            });
            if (r.success) return r.data;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to create plan: ${r.message}`, {
                cause: r
            });
        }
    }
    async updatePlan(e, r) {
        if (this._requireReady("updatePlan"), !e) throw new Error("Plan ID is required");
        if (!r || typeof r != "object") throw new Error("Plan data is required");
        try {
            const t = await this._request(`/admin/plans/${e}`, {
                method: "PATCH",
                body: JSON.stringify(r),
                methodName: "updatePlan"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update plan: ${t.message}`, {
                cause: t
            });
        }
    }
    async deletePlan(e) {
        if (this._requireReady("deletePlan"), !e) throw new Error("Plan ID is required");
        try {
            const r = await this._request(`/admin/plans/${e}`, {
                method: "DELETE",
                methodName: "deletePlan"
            });
            if (r.success) return r.data;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to delete plan: ${r.message}`, {
                cause: r
            });
        }
    }
    async initializePlans() {
        this._requireReady("initializePlans");
        try {
            const e = await this._request("/admin/plans/initialize", {
                method: "POST",
                methodName: "initializePlans"
            });
            if (e.success) return e;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to initialize plans: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPlansWithValidation() {
        try {
            const e = await this.getPlans();
            if (!Array.isArray(e)) throw new Error("Invalid response format: plans should be an array");
            return e;
        } catch (e) {
            throw new Error(`Failed to get plans with validation: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPlanWithValidation(e) {
        if (!e || typeof e != "string") throw new Error("Plan ID must be a valid string");
        try {
            const r = await this.getPlan(e);
            if (!r || typeof r != "object") throw new Error("Invalid plan data received");
            return r;
        } catch (r) {
            throw new Error(`Failed to get plan with validation: ${r.message}`, {
                cause: r
            });
        }
    }
    async createPlanWithValidation(e) {
        if (!e || typeof e != "object") throw new Error("Plan data must be a valid object");
        const r = [
            "name",
            "description"
        ];
        for (const t of r)if (!e[t]) throw new Error(`Required field '${t}' is missing`);
        if (Object.hasOwn(e, "price")) throw new Error('Field "price" is no longer supported. Use unified "pricingOptions" with "amount" instead.');
        if (e.pricingOptions != null) {
            if (!Array.isArray(e.pricingOptions) || e.pricingOptions.length === 0) throw new Error("pricingOptions must be a non-empty array when provided");
            const t = new Set([
                "month",
                "year",
                "week",
                "day",
                null
            ]);
            e.pricingOptions.forEach((n, s)=>{
                if (!n || typeof n != "object") throw new Error(`Pricing option at index ${s} must be an object`);
                const { key: i, displayName: a, amount: c, interval: o, lookupKey: l } = n;
                if (!i || typeof i != "string") throw new Error(`Pricing option at index ${s} is missing required field 'key'`);
                if (!/^[a-z0-9-]+$/u.test(i)) throw new Error(`Pricing option key '${i}' must contain only lowercase letters, numbers, and hyphens`);
                if (!a || typeof a != "string") throw new Error(`Pricing option '${i}' is missing required field 'displayName'`);
                if (typeof c != "number" || c < 0) throw new Error(`Pricing option '${i}' must have a non-negative numeric 'amount'`);
                if (o !== null && !t.has(o)) throw new Error(`Pricing option '${i}' has invalid interval '${o}'. Allowed: month, year, week, day or null`);
                if (!l || typeof l != "string") throw new Error(`Pricing option '${i}' is missing required field 'lookupKey'`);
            });
        }
        if (Object.hasOwn(e, "key") && e.key == null) throw new Error("Plan key must be a valid string");
        if (e.key && !/^[a-z0-9-]+$/u.test(e.key)) throw new Error("Plan key must contain only lowercase letters, numbers, and hyphens");
        return await this.createPlan(e);
    }
    async updatePlanWithValidation(e, r) {
        if (!e || typeof e != "string") throw new Error("Plan ID must be a valid string");
        if (!r || typeof r != "object") throw new Error("Plan data must be a valid object");
        if (Object.hasOwn(r, "price")) throw new Error('Field "price" is no longer supported. Use unified "pricingOptions" with "amount" instead.');
        if (r.pricingOptions != null) {
            if (!Array.isArray(r.pricingOptions) || r.pricingOptions.length === 0) throw new Error("pricingOptions must be a non-empty array when provided");
            const t = new Set([
                "month",
                "year",
                "week",
                "day",
                null
            ]);
            r.pricingOptions.forEach((n, s)=>{
                if (!n || typeof n != "object") throw new Error(`Pricing option at index ${s} must be an object`);
                const { key: i, displayName: a, amount: c, interval: o, lookupKey: l } = n;
                if (!i || typeof i != "string") throw new Error(`Pricing option at index ${s} is missing required field 'key'`);
                if (!/^[a-z0-9-]+$/u.test(i)) throw new Error(`Pricing option key '${i}' must contain only lowercase letters, numbers, and hyphens`);
                if (!a || typeof a != "string") throw new Error(`Pricing option '${i}' is missing required field 'displayName'`);
                if (typeof c != "number" || c < 0) throw new Error(`Pricing option '${i}' must have a non-negative numeric 'amount'`);
                if (o !== null && !t.has(o)) throw new Error(`Pricing option '${i}' has invalid interval '${o}'. Allowed: month, year, week, day or null`);
                if (!l || typeof l != "string") throw new Error(`Pricing option '${i}' is missing required field 'lookupKey'`);
            });
        }
        if (Object.hasOwn(r, "key") && r.key == null) throw new Error("Plan key must be a valid string");
        if (r.key && !/^[a-z0-9-]+$/u.test(r.key)) throw new Error("Plan key must contain only lowercase letters, numbers, and hyphens");
        return await this.updatePlan(e, r);
    }
    async getActivePlans() {
        try {
            return (await this.getPlans()).filter((r)=>r.status === "active" && r.isVisible !== !1);
        } catch (e) {
            throw new Error(`Failed to get active plans: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPlansByPriceRange(e = 0, r = 1 / 0) {
        try {
            return (await this.getPlansWithPricing()).filter((n)=>{
                const s = n?.pricing?.bestPrice?.amount ?? 0;
                return s >= e && s <= r;
            });
        } catch (t) {
            throw new Error(`Failed to get plans by price range: ${t.message}`, {
                cause: t
            });
        }
    }
    async getPlanByKey(e) {
        if (!e) throw new Error("Plan key is required");
        try {
            const t = (await this.getPlans()).find((n)=>n.key === e);
            if (!t) throw new Error(`Plan with key '${e}' not found`);
            return t;
        } catch (r) {
            throw new Error(`Failed to get plan by key: ${r.message}`, {
                cause: r
            });
        }
    }
}

});

parcelRegister("5gzYb", function(module, exports) {

$parcel$export(module.exports, "SubscriptionService", () => $3d5a593b20e1f018$export$557bff42f3c95df3);

var $em51x = parcelRequire("em51x");
class $3d5a593b20e1f018$export$557bff42f3c95df3 extends (0, $em51x.BaseService) {
    async createSubscription(r) {
        if (this._requireReady("createSubscription"), !r || typeof r != "object") throw new Error("Subscription data is required");
        const { projectId: e, workspaceId: t, planId: s, pricingKey: n = "monthly", seats: c = 1, successUrl: i, cancelUrl: a } = r;
        if (!e && !t) throw new Error("Project ID or Workspace ID is required");
        if (!s) throw new Error("Plan ID is required");
        try {
            const o = await this._request("/subscriptions", {
                method: "POST",
                body: JSON.stringify({
                    projectId: e,
                    workspaceId: t,
                    planId: s,
                    pricingKey: n,
                    seats: c,
                    successUrl: i,
                    cancelUrl: a
                }),
                methodName: "createSubscription"
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to create subscription: ${o.message}`, {
                cause: o
            });
        }
    }
    async createWorkspaceSubscriptionCheckout(r, e = {}) {
        if (this._requireReady("createWorkspaceSubscriptionCheckout"), !r) throw new Error("Workspace ID is required");
        const { planId: t, pricingKey: s = "monthly", successUrl: n, cancelUrl: c } = e;
        if (!t) throw new Error("Plan ID is required");
        try {
            const i = await this._request("/subscriptions/checkout", {
                method: "POST",
                body: JSON.stringify({
                    workspaceId: r,
                    planId: t,
                    pricingKey: s,
                    successUrl: n,
                    cancelUrl: c
                }),
                methodName: "createWorkspaceSubscriptionCheckout"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to create workspace subscription checkout: ${i.message}`, {
                cause: i
            });
        }
    }
    async getProjectStatus(r) {
        if (this._requireReady("getProjectStatus"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/subscriptions/project/${r}`, {
                method: "GET",
                methodName: "getProjectStatus"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get project subscription status: ${e.message}`, {
                cause: e
            });
        }
    }
    async getUsage(r) {
        if (this._requireReady("getUsage"), !r) throw new Error("Subscription ID is required");
        try {
            const e = await this._request(`/subscriptions/${r}/usage`, {
                method: "GET",
                methodName: "getUsage"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get subscription usage: ${e.message}`, {
                cause: e
            });
        }
    }
    async cancelSubscription(r) {
        if (this._requireReady("cancelSubscription"), !r) throw new Error("Subscription ID is required");
        try {
            const e = await this._request(`/subscriptions/${r}/cancel`, {
                method: "POST",
                methodName: "cancelSubscription"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to cancel subscription: ${e.message}`, {
                cause: e
            });
        }
    }
    async listInvoices(r, e = {}) {
        if (this._requireReady("listInvoices"), !r) throw new Error("Subscription ID is required");
        const { page: t = 1, limit: s = 20, status: n, startingAfter: c } = e;
        try {
            const i = new URLSearchParams;
            t && i.append("page", t.toString()), s && i.append("limit", s.toString()), n && i.append("status", n), c && i.append("startingAfter", c);
            const a = i.toString(), o = a ? await this._request(`/subscriptions/${r}/invoices?${a}`, {
                method: "GET",
                methodName: "listInvoices"
            }) : await this._request(`/subscriptions/${r}/invoices`, {
                method: "GET",
                methodName: "listInvoices"
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (i) {
            throw new Error(`Failed to list invoices: ${i.message}`, {
                cause: i
            });
        }
    }
    async getPortalUrl(r, e) {
        if (this._requireReady("getPortalUrl"), !r) throw new Error("Subscription ID is required");
        try {
            const t = new URLSearchParams;
            e && t.append("returnUrl", e);
            const s = t.toString(), n = s ? await this._request(`/subscriptions/${r}/portal?${s}`, {
                method: "GET",
                methodName: "getPortalUrl"
            }) : await this._request(`/subscriptions/${r}/portal`, {
                method: "GET",
                methodName: "getPortalUrl"
            });
            if (n.success) return n.data;
            throw new Error(n.message);
        } catch (t) {
            throw new Error(`Failed to get portal URL: ${t.message}`, {
                cause: t
            });
        }
    }
    async createSubscriptionWithValidation(r) {
        if (!r || typeof r != "object") throw new Error("Subscription data must be a valid object");
        if (!r.projectId && !r.workspaceId) throw new Error("Required field 'projectId' or 'workspaceId' is missing");
        if (!r.planId) throw new Error("Required field 'planId' is missing");
        if (r.seats != null && (!Number.isInteger(r.seats) || r.seats < 1)) throw new Error("Seats must be a positive integer");
        if (r.pricingKey && ![
            "monthly",
            "yearly"
        ].includes(r.pricingKey)) throw new Error('Pricing key must be either "monthly" or "yearly"');
        return await this.createSubscription(r);
    }
    async hasActiveSubscription(r) {
        try {
            return (await this.getProjectStatus(r)).hasSubscription === !0;
        } catch (e) {
            throw new Error(`Failed to check subscription status: ${e.message}`, {
                cause: e
            });
        }
    }
    async getProjectSubscription(r) {
        try {
            const e = await this.getProjectStatus(r);
            return e.hasSubscription ? e.subscription : null;
        } catch (e) {
            throw new Error(`Failed to get project subscription: ${e.message}`, {
                cause: e
            });
        }
    }
    async getProjectUsage(r) {
        try {
            const e = await this.getProjectStatus(r);
            return e.hasSubscription ? e.usage : null;
        } catch (e) {
            throw new Error(`Failed to get project usage: ${e.message}`, {
                cause: e
            });
        }
    }
    async getInvoicesWithPagination(r, e = {}) {
        try {
            const t = await this.listInvoices(r, e);
            return {
                invoices: t.data || [],
                pagination: t.pagination || {}
            };
        } catch (t) {
            throw new Error(`Failed to get invoices with pagination: ${t.message}`, {
                cause: t
            });
        }
    }
    async isSubscriptionActive(r) {
        try {
            const e = await this.getUsage(r);
            return e && e.subscription && e.subscription.status === "active";
        } catch (e) {
            throw new Error(`Failed to check subscription status: ${e.message}`, {
                cause: e
            });
        }
    }
    async getSubscriptionLimits(r) {
        try {
            return (await this.getUsage(r)).limits || {};
        } catch (e) {
            throw new Error(`Failed to get subscription limits: ${e.message}`, {
                cause: e
            });
        }
    }
    async changeSubscription(r) {
        if (this._requireReady("changeSubscription"), !r || typeof r != "object") throw new Error("Change data is required");
        const { subscriptionId: e, planId: t, pricingKey: s, seats: n = 1, projectId: c, successUrl: i, cancelUrl: a } = r;
        if (!e) throw new Error("Subscription ID is required");
        if (!s) throw new Error("Pricing key is required");
        try {
            const o = await this._request(`/subscriptions/${e}/change`, {
                method: "POST",
                body: JSON.stringify({
                    planId: t,
                    pricingKey: s,
                    seats: n,
                    projectId: c,
                    successUrl: i,
                    cancelUrl: a
                }),
                methodName: "changeSubscription"
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to change subscription: ${o.message}`, {
                cause: o
            });
        }
    }
    async downgrade(r) {
        if (this._requireReady("downgrade"), !r || typeof r != "object") throw new Error("Downgrade data is required");
        const { subscriptionId: e, reason: t } = r;
        if (!e) throw new Error("Subscription ID is required");
        try {
            const s = await this._request(`/subscriptions/${e}/downgrade`, {
                method: "POST",
                body: JSON.stringify({
                    reason: t
                }),
                methodName: "downgrade"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to downgrade subscription: ${s.message}`, {
                cause: s
            });
        }
    }
    async changeSubscriptionWithValidation(r) {
        if (!r || typeof r != "object") throw new Error("Change data must be a valid object");
        const e = [
            "subscriptionId",
            "pricingKey"
        ];
        for (const t of e)if (!r[t]) throw new Error(`Required field '${t}' is missing`);
        if (r.seats != null && (!Number.isInteger(r.seats) || r.seats < 1)) throw new Error("Seats must be a positive integer");
        if (typeof r.subscriptionId != "string") throw new Error("Subscription ID must be a valid string");
        if (r.planId && typeof r.planId != "string") throw new Error("Plan ID must be a valid string");
        return await this.changeSubscription(r);
    }
    async downgradeWithValidation(r) {
        if (!r || typeof r != "object") throw new Error("Downgrade data must be a valid object");
        if (!r.subscriptionId) throw new Error("Subscription ID is required");
        if (typeof r.subscriptionId != "string") throw new Error("Subscription ID must be a valid string");
        if (r.reason && typeof r.reason != "string") throw new Error("Reason must be a valid string");
        return await this.downgrade(r);
    }
    async getPricingOptions(r) {
        if (!r) throw new Error("subscriptionId is required");
        return this._call("getPricingOptions", `/subscriptions/${r}/pricing-options`);
    }
    async canAccessProjectFeature(r, e) {
        if (this._requireReady("canAccessProjectFeature"), !r) throw new Error("projectId is required");
        if (!e) throw new Error("featureKey is required");
        const t = await this._request(`/subscriptions/project/${r}/features/${encodeURIComponent(e)}/can-access`, {
            method: "GET",
            methodName: "canAccessProjectFeature"
        });
        return t?.success ? t.data : {
            canAccess: !1
        };
    }
    async grantProjectFeature(r, e) {
        if (!r) throw new Error("projectId is required");
        if (!e) throw new Error("featureKey is required");
        return this._call("grantProjectFeature", `/subscriptions/project/${r}/features/${encodeURIComponent(e)}/grant`, {
            method: "POST"
        });
    }
    async revokeProjectFeature(r, e) {
        if (!r) throw new Error("projectId is required");
        if (!e) throw new Error("featureKey is required");
        return this._call("revokeProjectFeature", `/subscriptions/project/${r}/features/${encodeURIComponent(e)}/revoke`, {
            method: "POST"
        });
    }
}

});

parcelRegister("coWlv", function(module, exports) {

$parcel$export(module.exports, "FileService", () => $9074fc314b8bff18$export$4adefade6695ab45);

var $em51x = parcelRequire("em51x");
class $9074fc314b8bff18$export$4adefade6695ab45 extends (0, $em51x.BaseService) {
    async uploadFile(e, t = {}) {
        if (this._requireReady("uploadFile"), !e) throw new Error("File is required for upload");
        const r = new FormData;
        r.append("file", e);
        const i = Object.hasOwn(t, "projectId") ? t.projectId : this._context.project?.id;
        i != null && i !== "" && r.append("projectId", i), t.tags && r.append("tags", JSON.stringify(t.tags)), t.visibility && r.append("visibility", t.visibility || "public"), t.metadata && r.append("metadata", JSON.stringify(t.metadata));
        try {
            const s = await this._request("/files/upload", {
                method: "POST",
                body: r,
                headers: {},
                methodName: "uploadFile"
            });
            if (!s.success) throw new Error(s.message);
            return s.data;
        } catch (s) {
            throw new Error(`File upload failed: ${s.message}`, {
                cause: s
            });
        }
    }
    async updateProjectIcon(e, t) {
        if (this._requireReady("updateProjectIcon"), !e || !t) throw new Error("Project ID and icon file are required");
        const r = new FormData;
        r.append("icon", t), r.append("projectId", e);
        try {
            const a = await this._request("/files/upload-project-icon", {
                method: "POST",
                body: r,
                headers: {},
                methodName: "updateProjectIcon"
            });
            if (a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to update project icon: ${a.message}`, {
                cause: a
            });
        }
    }
    async uploadFileWithValidation(e, t = {}) {
        if (!e) throw new Error("File is required");
        const r = t.maxSize || 10485760;
        if (e.size > r) throw new Error(`File size exceeds maximum allowed size of ${r / 1048576}MB`);
        const a = t.allowedTypes || [
            "image/*",
            "application/pdf",
            "text/*"
        ];
        if (a.length > 0 && !a.some((s)=>s.endsWith("/*") ? e.type.startsWith(s.replace("/*", "")) : e.type === s)) throw new Error(`File type '${e.type}' is not allowed. Allowed types: ${a.join(", ")}`);
        return await this.uploadFile(e, t);
    }
    async uploadImage(e, t = {}) {
        const r = {
            ...t,
            allowedTypes: [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/webp"
            ],
            maxSize: t.maxSize || 5242880
        };
        return await this.uploadFileWithValidation(e, r);
    }
    async uploadDocument(e, t = {}) {
        const r = {
            ...t,
            allowedTypes: [
                "application/pdf",
                "text/plain",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ],
            maxSize: t.maxSize || 20971520
        };
        return await this.uploadFileWithValidation(e, r);
    }
    getFileUrl(e) {
        if (!e) throw new Error("File ID is required");
        return `${this._apiUrl}/core/files/public/${e}/download`;
    }
    validateFile(e, t = {}) {
        const r = [];
        if (!e) return r.push("File is required"), r;
        const a = t.maxSize || 10485760;
        e.size > a && r.push(`File size (${(e.size / 1048576).toFixed(2)}MB) exceeds maximum allowed size of ${a / 1048576}MB`);
        const i = t.allowedTypes || [];
        return i.length > 0 && (i.some((o)=>o.endsWith("/*") ? e.type.startsWith(o.replace("/*", "")) : e.type === o) || r.push(`File type '${e.type}' is not allowed. Allowed types: ${i.join(", ")}`)), r;
    }
    createFileFormData(e, t = {}) {
        const r = new FormData;
        return r.append("file", e), Object.keys(t).length > 0 && r.append("metadata", JSON.stringify(t)), r;
    }
    async uploadMultipleFiles(e, t = {}) {
        if (!Array.isArray(e) || e.length === 0) throw new Error("Files array is required and must not be empty");
        const r = e.map((i)=>this.uploadFile(i, t));
        return (await Promise.allSettled(r)).map((i, s)=>({
                file: e[s],
                success: i.status === "fulfilled",
                data: i.status === "fulfilled" ? i.value : null,
                error: i.status === "rejected" ? i.reason.message : null
            }));
    }
    async uploadProjectFile(e, t = {}) {
        if (this._requireReady("uploadProjectFile"), !e) throw new Error("File is required for upload");
        const r = t.key || e.name;
        if (!r) throw new Error("File key is required (provide options.key or a file with a name)");
        const a = await this.uploadFile(e, {
            projectId: t.projectId,
            visibility: t.visibility || "public",
            tags: t.tags,
            metadata: t.metadata
        }), i = a._id || a.id, s = $9074fc314b8bff18$var$h(r, a), o = {
            content: {
                src: this.getFileUrl(i)
            },
            code: "",
            key: r,
            type: "file",
            format: s
        }, l = this._context?.services?.project, d = t.projectId || this._context.project?.id;
        if (l && d) {
            const c = t.branch || "main", p = [
                [
                    "update",
                    [
                        "files",
                        r
                    ],
                    o
                ]
            ];
            await l.applyProjectChanges(d, p, {
                branch: c
            });
        }
        return o;
    }
    async uploadMultipleProjectFiles(e, t = {}) {
        if (!Array.isArray(e) || e.length === 0) throw new Error("Files array is required and must not be empty");
        const r = [];
        for (const a of e)try {
            const i = await this.uploadProjectFile(a, {
                ...t,
                key: a.name || t.key
            });
            r.push({
                file: a,
                success: !0,
                data: i,
                error: null
            });
        } catch (i) {
            r.push({
                file: a,
                success: !1,
                data: null,
                error: i.message
            });
        }
        return r;
    }
    async getFile(e) {
        if (!e) throw new Error("fileId is required");
        return this._call("getFile", `/files/${e}`);
    }
    async downloadFileContent(e) {
        if (!e) throw new Error("fileId is required");
        const t = await this._call("downloadFileContent", `/files/${e}/download`, {
            raw: !0
        });
        return typeof t == "string" ? t : t && typeof t.text == "function" ? await t.text() : typeof t == "object" ? JSON.stringify(t) : String(t);
    }
    async extractFileText(e) {
        if (!e) throw new Error("fileId is required");
        return this._call("extractFileText", `/files/${e}/extract-text`);
    }
    async updateFile(e, t = {}) {
        if (!e) throw new Error("fileId is required");
        return this._call("updateFile", `/files/${e}`, {
            method: "PUT",
            body: t
        });
    }
    async deleteFile(e) {
        if (!e) throw new Error("fileId is required");
        return this._call("deleteFile", `/files/${e}`, {
            method: "DELETE"
        });
    }
    async listMyUploads({ page: e = 1, limit: t = 20, sortBy: r, sortOrder: a } = {}) {
        const i = new URLSearchParams({
            page: String(e),
            limit: String(t)
        });
        return r && i.append("sortBy", r), a && i.append("sortOrder", a), this._call("listMyUploads", `/files/my-uploads?${i.toString()}`);
    }
    async uploadMarketplaceThumbnail(e, { itemId: t, kind: r } = {}) {
        if (this._requireReady("uploadMarketplaceThumbnail"), !e) throw new Error("thumbnailFile is required");
        if (!t) throw new Error("itemId is required");
        if (!r) throw new Error("kind is required");
        const a = new FormData;
        a.append("file", e), a.append("itemId", t), a.append("kind", r);
        const i = await this._request("/marketplace/thumbnail", {
            method: "POST",
            body: a,
            headers: {},
            methodName: "uploadMarketplaceThumbnail"
        });
        if (i?.success) return i.data;
        throw new Error(i?.message || "Failed to upload marketplace thumbnail");
    }
}
function $9074fc314b8bff18$var$h(n, e) {
    if (e.extension) return e.extension.toLowerCase();
    const t = n.lastIndexOf(".");
    return t !== -1 ? n.slice(t + 1).toLowerCase() : "";
}

});

parcelRegister("hn31Z", function(module, exports) {

$parcel$export(module.exports, "PaymentService", () => $ca56ef91fc1a18b8$export$e5ffdf14a094ba8);

var $em51x = parcelRequire("em51x");

var $h5XS2 = parcelRequire("h5XS2");
class $ca56ef91fc1a18b8$export$e5ffdf14a094ba8 extends (0, $em51x.BaseService) {
    async checkout(r = {}) {
        this._requireReady("checkout");
        const { projectId: t, seats: e = 1, planId: i, pricingKey: a = "monthly", successUrl: n = `${window.location.origin}/success`, cancelUrl: o = `${window.location.origin}/pricing` } = r;
        if (!t) throw new Error("Project ID is required for checkout");
        if (!i) throw new Error("Plan ID is required for checkout");
        try {
            const s = await this._request("/payments/checkout", {
                method: "POST",
                body: JSON.stringify({
                    projectId: t,
                    seats: e,
                    planId: i,
                    pricingKey: a,
                    successUrl: n,
                    cancelUrl: o
                }),
                methodName: "checkout"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to checkout: ${s.message}`, {
                cause: s
            });
        }
    }
    async getSubscriptionStatus(r) {
        if (this._requireReady("getSubscriptionStatus"), !r) throw new Error("Project ID is required");
        try {
            const t = await this._request(`/payments/subscription/${r}`, {
                method: "GET",
                methodName: "getSubscriptionStatus"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to get subscription status: ${t.message}`, {
                cause: t
            });
        }
    }
    async checkoutWithValidation(r = {}) {
        const { projectId: t, seats: e, planId: i, successUrl: a, cancelUrl: n } = r;
        if (!t) throw new Error("Project ID is required");
        if (e && (typeof e != "number" || e < 1)) throw new Error("Seats must be a positive number");
        if (i && typeof i != "string") throw new Error("Plan ID must be a string");
        if (a && !this._isValidUrl(a)) throw new Error("Success URL must be a valid URL");
        if (n && !this._isValidUrl(n)) throw new Error("Cancel URL must be a valid URL");
        return await this.checkout(r);
    }
    async getSubscriptionStatusWithValidation(r) {
        if (!r || typeof r != "string") throw new Error("Project ID must be a valid string");
        return await this.getSubscriptionStatus(r);
    }
    async hasActiveSubscription(r) {
        try {
            return (await this.getSubscriptionStatus(r))?.active === !0;
        } catch (t) {
            return (0, $h5XS2.logger).warn("Failed to check subscription status:", t.message), !1;
        }
    }
    async getSubscriptionDetails(r) {
        try {
            const t = await this.getSubscriptionStatus(r);
            return t ? {
                hasSubscription: !0,
                active: t.active || !1,
                plan: t.plan,
                seats: t.seats,
                nextBillingDate: t.nextBillingDate,
                amount: t.amount,
                currency: t.currency,
                status: t.status
            } : {
                hasSubscription: !1,
                active: !1,
                message: "No subscription found"
            };
        } catch (t) {
            throw new Error(`Failed to get subscription details: ${t.message}`, {
                cause: t
            });
        }
    }
    async checkoutForPlan(r, t, e = {}) {
        if (!r) throw new Error("Project ID is required");
        if (!t) throw new Error("Plan ID is required");
        const i = {
            projectId: r,
            planId: t,
            ...e
        };
        return await this.checkoutWithValidation(i);
    }
    async checkoutForTeam(r, t, e = {}) {
        if (!r) throw new Error("Project ID is required");
        if (!t || t < 1) throw new Error("Seats must be a positive number");
        if (!e.planId) throw new Error('Plan ID is required \u2014 pass options.planId (a real Plan _id resolved via sdk.getPlansWithPricing(); the old "team_monthly" Stripe lookup key is not a valid planId)');
        const i = {
            projectId: r,
            seats: t,
            ...e
        };
        return await this.checkoutWithValidation(i);
    }
    validateSubscriptionStatus(r) {
        if (!r || typeof r != "object") return {
            isValid: !1,
            error: "Invalid subscription status format"
        };
        const e = [
            "active",
            "plan",
            "seats"
        ].filter((i)=>!(i in r));
        return e.length > 0 ? {
            isValid: !1,
            error: `Missing required fields: ${e.join(", ")}`
        } : {
            isValid: !0,
            error: null
        };
    }
    formatSubscriptionAmount(r, t = "USD") {
        return !r || typeof r != "number" ? "N/A" : new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: t
        }).format(r / 100);
    }
    async getSubscriptionSummary(r) {
        try {
            const t = await this.getSubscriptionDetails(r);
            return t.hasSubscription ? t.active ? {
                status: "active",
                message: `Active ${t.plan} plan with ${t.seats} seats`,
                action: "manage",
                details: t
            } : {
                status: "inactive",
                message: "Subscription is inactive",
                action: "reactivate"
            } : {
                status: "no_subscription",
                message: "No active subscription",
                action: "subscribe"
            };
        } catch (t) {
            return {
                status: "error",
                message: `Failed to get subscription: ${t.message}`,
                action: "retry"
            };
        }
    }
    _isValidUrl(r) {
        try {
            return new URL(r), true;
        } catch  {
            return !1;
        }
    }
}

});

parcelRegister("1q0WH", function(module, exports) {

$parcel$export(module.exports, "DnsService", () => $1088f3f9af008234$export$803776f646e61283);

var $em51x = parcelRequire("em51x");
const $1088f3f9af008234$var$f = new Set([
    "active",
    "failed",
    "orphaned"
]);
function $1088f3f9af008234$var$l(s) {
    const e = s?.cause?.cause ?? s?.cause ?? null;
    return e && typeof e == "object" && !(e instanceof Error) ? e : {};
}
function $1088f3f9af008234$var$n(s, e) {
    const r = $1088f3f9af008234$var$l(e), t = new Error(`${s}: ${e.message}`, {
        cause: e
    });
    return e?.status && (t.status = e.status), r?.error && (t.code = r.error), r && Object.keys(r).length && (t.body = r), r?.conflicts && (t.conflicts = r.conflicts), r?.failures && (t.failures = r.failures), r?.operations && (t.operations = r.operations), r?.warnings && (t.warnings = r.warnings), t;
}
function $1088f3f9af008234$var$c(s) {
    if (!s?.success) throw new Error(s?.message || s?.error || "Project domain request failed");
    const e = s.data;
    return e && typeof e == "object" && !Array.isArray(e) ? {
        ...e,
        ...s.warnings && !e.warnings ? {
            warnings: s.warnings
        } : {}
    } : e;
}
function $1088f3f9af008234$var$D(s, e) {
    const r = String(e || "").toLowerCase(), t = Array.isArray(s?.onboarding) ? s.onboarding : Array.isArray(s?.domains?.statuses) ? s.domains.statuses : [];
    return t.find((a)=>String(a?.hostname || "").toLowerCase() === r) || t[0] || null;
}
const $1088f3f9af008234$var$y = (s)=>new Promise((e)=>setTimeout(e, s));
class $1088f3f9af008234$export$803776f646e61283 extends (0, $em51x.BaseService) {
    async createDnsRecord(e, r = {}) {
        if (this._requireReady("createDnsRecord"), !e) throw new Error("Domain is required");
        try {
            const t = await this._request("/dns/records", {
                method: "POST",
                body: JSON.stringify({
                    domain: e,
                    ...r
                }),
                methodName: "createDnsRecord"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to create DNS record: ${t.message}`, {
                cause: t
            });
        }
    }
    async getDnsRecord(e) {
        if (this._requireReady("getDnsRecord"), !e) throw new Error("Domain is required");
        try {
            const r = await this._request(`/dns/records/${e}`, {
                method: "GET",
                methodName: "getDnsRecord"
            });
            if (r.success) return r.data;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to get DNS record: ${r.message}`, {
                cause: r
            });
        }
    }
    async getCustomHost(e) {
        if (this._requireReady("getCustomHost"), !e) throw new Error("Hostname is required");
        try {
            const r = await this._request(`/dns/custom-hosts/${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "getCustomHost"
            });
            if (r.success) return r.data;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to get custom host: ${r.message}`, {
                cause: r
            });
        }
    }
    async removeDnsRecord(e) {
        if (this._requireReady("removeDnsRecord"), !e) throw new Error("Domain is required");
        try {
            const r = await this._request(`/dns/records/${e}`, {
                method: "DELETE",
                methodName: "removeDnsRecord"
            });
            if (r.success) return r.data;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to remove DNS record: ${r.message}`, {
                cause: r
            });
        }
    }
    async addProjectCustomDomains(e, r, t = {}) {
        if (this._requireReady("addProjectCustomDomains"), !e) throw new Error("Project ID is required");
        if (!r || Array.isArray(r) && !r.length) throw new Error("customDomains is required and must be a non-empty string or array");
        const { envKey: a, headers: i } = t;
        try {
            const o = await this._request(`/projects/${e}/domains`, {
                method: "PATCH",
                body: JSON.stringify({
                    customDomains: r,
                    ...a ? {
                        envKey: a
                    } : {}
                }),
                ...i ? {
                    headers: i
                } : {},
                methodName: "addProjectCustomDomains"
            });
            return $1088f3f9af008234$var$c(o);
        } catch (o) {
            throw $1088f3f9af008234$var$n("Failed to update project custom domains", o);
        }
    }
    async addProjectCustomDomain(e, r, t = {}) {
        return await this.addProjectCustomDomains(e, r, t);
    }
    validateDomain(e) {
        return !e || typeof e != "string" ? {
            isValid: !1,
            error: "Domain must be a non-empty string"
        } : /^[a-zA-Z0-9](?:(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)?(?:\.[a-zA-Z0-9](?:(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)?)*$/u.test(e) ? /\.[a-zA-Z]{2,}$/u.test(e) ? {
            isValid: !0,
            error: null
        } : {
            isValid: !1,
            error: "Domain must have a valid top-level domain"
        } : {
            isValid: !1,
            error: "Invalid domain format"
        };
    }
    async createDnsRecordWithValidation(e, r = {}) {
        const t = this.validateDomain(e);
        if (!t.isValid) throw new Error(t.error);
        return await this.createDnsRecord(e, r);
    }
    async getDnsRecordWithValidation(e) {
        const r = this.validateDomain(e);
        if (!r.isValid) throw new Error(r.error);
        return await this.getDnsRecord(e);
    }
    async removeDnsRecordWithValidation(e) {
        const r = this.validateDomain(e);
        if (!r.isValid) throw new Error(r.error);
        return await this.removeDnsRecord(e);
    }
    async addProjectCustomDomainsWithValidation(e, r, t = {}) {
        if (!e || typeof e != "string") throw new Error("Project ID must be a valid string");
        if (!r) throw new Error("Custom domains are required");
        const a = Array.isArray(r) ? r : [
            r
        ];
        if (a.length === 0) throw new Error("At least one custom domain is required");
        for (const i of a){
            const o = this.validateDomain(i);
            if (!o.isValid) throw new Error(`Invalid domain '${i}': ${o.error}`);
        }
        return await this.addProjectCustomDomains(e, r, t);
    }
    async isDomainAvailable(e) {
        try {
            return await this.getDnsRecord(e), !1;
        } catch (r) {
            if (r?.status === 404 || /not.?found/i.test(r?.message || "")) return !0;
            throw r;
        }
    }
    async getDomainStatus(e) {
        try {
            const r = await this.getDnsRecord(e);
            return {
                exists: !0,
                active: r.active || !1,
                verified: r.verified || !1,
                record: r
            };
        } catch (r) {
            if (r?.status === 404 || /not.?found/i.test(r?.message || "")) return {
                exists: !1,
                active: !1,
                verified: !1,
                error: "Domain not found"
            };
            throw r;
        }
    }
    async verifyDomainOwnership(e) {
        try {
            const r = await this.getDnsRecord(e);
            return r.verified ? {
                verified: !0,
                needsVerification: !1
            } : {
                verified: !1,
                needsVerification: !0,
                verificationMethod: r.verificationMethod || "dns",
                verificationRecord: r.verificationRecord
            };
        } catch (r) {
            throw new Error(`Failed to verify domain ownership: ${r.message}`, {
                cause: r
            });
        }
    }
    async getProjectDomains(e) {
        if (this._requireReady("getProjectDomains"), !e) throw new Error("Project ID is required");
        try {
            const r = await this._request(`/projects/${e}/domains`, {
                method: "GET",
                methodName: "getProjectDomains"
            });
            return $1088f3f9af008234$var$c(r);
        } catch (r) {
            throw $1088f3f9af008234$var$n("Failed to get project domains", r);
        }
    }
    async removeProjectCustomDomain(e, r) {
        if (this._requireReady("removeProjectCustomDomain"), !e) throw new Error("Project ID is required");
        if (!r) throw new Error("Domain is required");
        try {
            const t = await this._request(`/projects/${e}/domains/${encodeURIComponent(r)}`, {
                method: "DELETE",
                methodName: "removeProjectCustomDomain"
            });
            return $1088f3f9af008234$var$c(t);
        } catch (t) {
            throw $1088f3f9af008234$var$n("Failed to remove project custom domain", t);
        }
    }
    async checkProjectDomain(e, r) {
        if (this._requireReady("checkProjectDomain"), !e) throw new Error("Project ID is required");
        if (!r) throw new Error("Domain is required");
        try {
            const t = await this._request(`/projects/${e}/domains/check/${encodeURIComponent(r)}`, {
                method: "GET",
                methodName: "checkProjectDomain"
            });
            return $1088f3f9af008234$var$c(t);
        } catch (t) {
            throw $1088f3f9af008234$var$n("Failed to check project domain", t);
        }
    }
    async checkProjectCustomDomain(e, r) {
        return await this.checkProjectDomain(e, r);
    }
    async getProjectCustomDomainStatus(e, r) {
        if (this._requireReady("getProjectCustomDomainStatus"), !e) throw new Error("Project ID is required");
        if (!r) throw new Error("Domain is required");
        try {
            const t = await this._request(`/projects/${e}/domains/status/${encodeURIComponent(r)}`, {
                method: "GET",
                methodName: "getProjectCustomDomainStatus"
            });
            return $1088f3f9af008234$var$c(t);
        } catch (t) {
            throw $1088f3f9af008234$var$n("Failed to get project domain status", t);
        }
    }
    async getProjectDomainInstructions(e, r) {
        if (this._requireReady("getProjectDomainInstructions"), !e) throw new Error("Project ID is required");
        if (!r) throw new Error("Domain is required");
        try {
            const t = await this._request(`/projects/${e}/domains/instructions/${encodeURIComponent(r)}`, {
                method: "GET",
                methodName: "getProjectDomainInstructions"
            });
            return $1088f3f9af008234$var$c(t);
        } catch (t) {
            throw $1088f3f9af008234$var$n("Failed to get project domain instructions", t);
        }
    }
    async getProjectCustomDomainInstructions(e, r) {
        return await this.getProjectDomainInstructions(e, r);
    }
    async startProjectCustomDomainSetup(e, r, t = {}) {
        if (this._requireReady("startProjectCustomDomainSetup"), !e) throw new Error("Project ID is required");
        if (!r) throw new Error("Domain is required");
        const a = await this.checkProjectDomain(e, r), i = await this.addProjectCustomDomains(e, r, t), o = $1088f3f9af008234$var$D(i, r);
        return {
            projectId: e,
            domain: r,
            hostname: o?.hostname || a?.hostname || r,
            env: o?.env || t.envKey || a?.env || null,
            state: o?.state || a?.state || null,
            configured: o?.configured ?? a?.configured ?? !1,
            check: a,
            add: i,
            status: o,
            instructions: o?.instructions || a?.instructions || null,
            records: o?.records || a?.records || [],
            warnings: [
                ...Array.isArray(i?.warnings) ? i.warnings : [],
                ...Array.isArray(o?.warnings) ? o.warnings : []
            ]
        };
    }
    async pollProjectCustomDomainStatus(e, r, t = {}) {
        if (this._requireReady("pollProjectCustomDomainStatus"), !e) throw new Error("Project ID is required");
        if (!r) throw new Error("Domain is required");
        const { intervalMs: a = 2e3, timeoutMs: i = 12e4, terminalStates: o = $1088f3f9af008234$var$f } = t, m = o instanceof Set ? o : new Set(o), h = Date.now() + i;
        let d = null;
        for(; Date.now() <= h;){
            if (d = await this.getProjectCustomDomainStatus(e, r), m.has(d?.state)) return d;
            await $1088f3f9af008234$var$y(a);
        }
        const u = new Error(`Timed out waiting for custom domain '${r}' to become ready`);
        throw u.code = "custom_domain_status_timeout", u.lastStatus = d, u;
    }
    formatDomain(e) {
        return e ? e.replace(/^https?:\/\//u, "").replace(/\/$/u, "") : "";
    }
    extractDomainFromUrl(e) {
        try {
            return new URL(e).hostname;
        } catch  {
            return null;
        }
    }
}

});

parcelRegister("2ylZH", function(module, exports) {

$parcel$export(module.exports, "BranchService", () => $1dbfd15553b4cf32$export$52a14e2e227d6f87);

var $em51x = parcelRequire("em51x");
class $1dbfd15553b4cf32$export$52a14e2e227d6f87 extends (0, $em51x.BaseService) {
    async listBranches(r) {
        if (this._requireReady("listBranches"), !r) throw new Error("Project ID is required");
        try {
            const e = await this._request(`/projects/${r}/branches`, {
                method: "GET",
                methodName: "listBranches"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to list branches: ${e.message}`, {
                cause: e
            });
        }
    }
    async createBranch(r, e) {
        if (this._requireReady("createBranch"), !r) throw new Error("Project ID is required");
        if (!e.name) throw new Error("Branch name is required");
        const { name: t, source: s = "main" } = e;
        try {
            const a = await this._request(`/projects/${r}/branches`, {
                method: "POST",
                body: JSON.stringify({
                    name: t,
                    source: s
                }),
                methodName: "createBranch"
            });
            if (a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to create branch: ${a.message}`, {
                cause: a
            });
        }
    }
    async deleteBranch(r, e) {
        if (this._requireReady("deleteBranch"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Branch name is required");
        if (e === "main") throw new Error("Cannot delete main branch");
        try {
            const t = await this._request(`/projects/${r}/branches/${encodeURIComponent(e)}`, {
                method: "DELETE",
                methodName: "deleteBranch"
            });
            if (t.success) return t;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to delete branch: ${t.message}`, {
                cause: t
            });
        }
    }
    async renameBranch(r, e, t) {
        if (this._requireReady("renameBranch"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Current branch name is required");
        if (!t) throw new Error("New branch name is required");
        if (e === "main") throw new Error("Cannot rename main branch");
        try {
            const s = await this._request(`/projects/${r}/branches/${encodeURIComponent(e)}/rename`, {
                method: "POST",
                body: JSON.stringify({
                    newName: t
                }),
                methodName: "renameBranch"
            });
            if (s.success) return s;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to rename branch: ${s.message}`, {
                cause: s
            });
        }
    }
    async getBranchChanges(r, e = "main", t = {}) {
        if (this._requireReady("getBranchChanges"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Branch name is required");
        const { versionId: s, versionValue: a, target: n } = t, i = new URLSearchParams;
        s && i.append("versionId", s), a && i.append("versionValue", a), n && i.append("target", n);
        const h = i.toString();
        try {
            const c = h ? await this._request(`/projects/${r}/branches/${encodeURIComponent(e)}/changes?${h}`, {
                method: "GET",
                methodName: "getBranchChanges"
            }) : await this._request(`/projects/${r}/branches/${encodeURIComponent(e)}/changes`, {
                method: "GET",
                methodName: "getBranchChanges"
            });
            if (c.success) return c.data;
            throw new Error(c.message);
        } catch (c) {
            throw new Error(`Failed to get branch changes: ${c.message}`, {
                cause: c
            });
        }
    }
    async mergeBranch(r, e, t = {}) {
        if (this._requireReady("mergeBranch"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Source branch name is required");
        const { target: s = "main", message: a, type: n = "patch", commit: i = !1, changes: h } = t, c = {
            target: s,
            type: n,
            commit: i,
            ...a && {
                message: a
            },
            ...h && {
                changes: h
            }
        };
        try {
            const o = await this._request(`/projects/${r}/branches/${encodeURIComponent(e)}/merge`, {
                method: "POST",
                body: JSON.stringify(c),
                methodName: "mergeBranch"
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw o.message.includes("conflicts") || o.message.includes("409") ? new Error(`Merge conflicts detected: ${o.message}`, {
                cause: o
            }) : new Error(`Failed to merge branch: ${o.message}`, {
                cause: o
            });
        }
    }
    async resetBranch(r, e) {
        if (this._requireReady("resetBranch"), !r) throw new Error("Project ID is required");
        if (!e) throw new Error("Branch name is required");
        try {
            const t = await this._request(`/projects/${r}/branches/${encodeURIComponent(e)}/reset`, {
                method: "POST",
                methodName: "resetBranch"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to reset branch: ${t.message}`, {
                cause: t
            });
        }
    }
    async publishVersion(r, e) {
        if (this._requireReady("publishVersion"), !r) throw new Error("Project ID is required");
        if (!e.version) throw new Error("Version is required");
        const { version: t, branch: s = "main" } = e;
        try {
            const a = await this._request(`/projects/${r}/publish`, {
                method: "POST",
                body: JSON.stringify({
                    version: t,
                    branch: s
                }),
                methodName: "publishVersion"
            });
            if (a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to publish version: ${a.message}`, {
                cause: a
            });
        }
    }
    async createBranchWithValidation(r, e, t = "main") {
        if (!e || e.trim().length === 0) throw new Error("Branch name cannot be empty");
        if (e.includes(" ")) throw new Error("Branch name cannot contain spaces");
        if (e === "main") throw new Error('Cannot create a branch named "main"');
        const s = e.trim().toLowerCase().replace(/[^a-z0-9-_]/gu, "-");
        return await this.createBranch(r, {
            name: s,
            source: t
        });
    }
    async branchExists(r, e) {
        try {
            return (await this.listBranches(r))?.data?.includes(e) || !1;
        } catch (t) {
            throw new Error(`Failed to check if branch exists: ${t.message}`, {
                cause: t
            });
        }
    }
    async previewMerge(r, e, t = "main") {
        return await this.mergeBranch(r, e, {
            target: t,
            commit: !1
        });
    }
    async commitMerge(r, e, t = {}) {
        const { target: s = "main", message: a = `Merge ${e} into ${s}`, type: n = "patch", changes: i } = t;
        return await this.mergeBranch(r, e, {
            target: s,
            message: a,
            type: n,
            commit: !0,
            changes: i
        });
    }
    async createFeatureBranch(r, e) {
        const t = `feature/${e.toLowerCase().replace(/[^a-z0-9-]/gu, "-")}`;
        return await this.createBranch(r, {
            name: t,
            source: "main"
        });
    }
    async createHotfixBranch(r, e) {
        const t = `hotfix/${e.toLowerCase().replace(/[^a-z0-9-]/gu, "-")}`;
        return await this.createBranch(r, {
            name: t,
            source: "main"
        });
    }
    async getBranchStatus(r, e) {
        try {
            const [t, s] = await Promise.all([
                this.listBranches(r),
                this.getBranchChanges(r, e).catch(()=>null)
            ]), a = t?.data?.includes(e) || !1, n = s?.data?.length > 0;
            return {
                exists: a,
                hasChanges: n,
                changeCount: s?.data?.length || 0,
                canDelete: a && e !== "main",
                canRename: a && e !== "main"
            };
        } catch (t) {
            throw new Error(`Failed to get branch status: ${t.message}`, {
                cause: t
            });
        }
    }
    async deleteBranchSafely(r, e, t = {}) {
        const { force: s = !1 } = t;
        if (!s) {
            const a = await this.getBranchStatus(r, e);
            if (!a.exists) throw new Error(`Branch '${e}' does not exist`);
            if (!a.canDelete) throw new Error(`Branch '${e}' cannot be deleted`);
            if (a.hasChanges) throw new Error(`Branch '${e}' has uncommitted changes. Use force option to delete anyway.`);
        }
        return await this.deleteBranch(r, e);
    }
    async getBranchesWithStatus(r) {
        try {
            const t = (await this.listBranches(r))?.data || [];
            return await Promise.all(t.map(async (a)=>{
                try {
                    const n = await this.getBranchStatus(r, a);
                    return {
                        name: a,
                        ...n
                    };
                } catch (n) {
                    return {
                        name: a,
                        exists: !0,
                        hasChanges: !1,
                        changeCount: 0,
                        canDelete: a !== "main",
                        canRename: a !== "main",
                        error: n.message
                    };
                }
            }));
        } catch (e) {
            throw new Error(`Failed to get branches with status: ${e.message}`, {
                cause: e
            });
        }
    }
    validateBranchName(r) {
        return !r || typeof r != "string" ? {
            isValid: !1,
            error: "Branch name must be a non-empty string"
        } : r.trim().length === 0 ? {
            isValid: !1,
            error: "Branch name cannot be empty"
        } : r.includes(" ") ? {
            isValid: !1,
            error: "Branch name cannot contain spaces"
        } : r === "main" ? {
            isValid: !1,
            error: 'Cannot use "main" as a branch name'
        } : /^[a-zA-Z0-9-_]+$/u.test(r) ? {
            isValid: !0,
            error: null
        } : {
            isValid: !1,
            error: "Branch name can only contain letters, numbers, hyphens, and underscores"
        };
    }
    sanitizeBranchName(r) {
        return r ? r.trim().toLowerCase().replace(/[^a-z0-9-_]/gu, "-").replace(/-+/gu, "-").replace(/^-|-$/gu, "") : "";
    }
}

});

parcelRegister("bt9uV", function(module, exports) {

$parcel$export(module.exports, "PullRequestService", () => $8599c52efa4d002f$export$7d8540ebe62619c8);

var $em51x = parcelRequire("em51x");
class $8599c52efa4d002f$export$7d8540ebe62619c8 extends (0, $em51x.BaseService) {
    async createPullRequest(r, t) {
        if (this._requireReady("createPullRequest"), !r) throw new Error("Project ID is required");
        if (!t.source || !t.target || !t.title) throw new Error("Source branch, target branch, and title are required");
        try {
            const e = await this._request(`/projects/${r}/pull-requests`, {
                method: "POST",
                body: JSON.stringify(t),
                methodName: "createPullRequest"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to create pull request: ${e.message}`, {
                cause: e
            });
        }
    }
    async listPullRequests(r, t = {}) {
        if (this._requireReady("listPullRequests"), !r) throw new Error("Project ID is required");
        const { status: e = "open", source: s, target: u, page: i = 1, limit: l = 20 } = t, o = new URLSearchParams({
            status: e,
            page: i.toString(),
            limit: l.toString()
        });
        s && o.append("source", s), u && o.append("target", u);
        try {
            const a = await this._request(`/projects/${r}/pull-requests?${o.toString()}`, {
                method: "GET",
                methodName: "listPullRequests"
            });
            if (a.success) return a.data;
            throw new Error(a.message);
        } catch (a) {
            throw new Error(`Failed to list pull requests: ${a.message}`, {
                cause: a
            });
        }
    }
    async getPullRequest(r, t) {
        if (this._requireReady("getPullRequest"), !r) throw new Error("Project ID is required");
        if (!t) throw new Error("Pull request ID is required");
        try {
            const e = await this._request(`/projects/${r}/pull-requests/${t}`, {
                method: "GET",
                methodName: "getPullRequest"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get pull request: ${e.message}`, {
                cause: e
            });
        }
    }
    async reviewPullRequest(r, t, e) {
        if (this._requireReady("reviewPullRequest"), !r) throw new Error("Project ID is required");
        if (!t) throw new Error("Pull request ID is required");
        const s = [
            "approved",
            "requested_changes",
            "feedback"
        ];
        if (e.status && !s.includes(e.status)) throw new Error(`Invalid review status. Must be one of: ${s.join(", ")}`);
        try {
            const u = await this._request(`/projects/${r}/pull-requests/${t}/review`, {
                method: "POST",
                body: JSON.stringify(e),
                methodName: "reviewPullRequest"
            });
            if (u.success) return u;
            throw new Error(u.message);
        } catch (u) {
            throw new Error(`Failed to review pull request: ${u.message}`, {
                cause: u
            });
        }
    }
    async addPullRequestComment(r, t, e) {
        if (this._requireReady("addPullRequestComment"), !r) throw new Error("Project ID is required");
        if (!t) throw new Error("Pull request ID is required");
        if (!e.value) throw new Error("Comment value is required");
        try {
            const s = await this._request(`/projects/${r}/pull-requests/${t}/comment`, {
                method: "POST",
                body: JSON.stringify(e),
                methodName: "addPullRequestComment"
            });
            if (s.success) return s;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to add pull request comment: ${s.message}`, {
                cause: s
            });
        }
    }
    async mergePullRequest(r, t) {
        if (this._requireReady("mergePullRequest"), !r) throw new Error("Project ID is required");
        if (!t) throw new Error("Pull request ID is required");
        try {
            const e = await this._request(`/projects/${r}/pull-requests/${t}/merge`, {
                method: "POST",
                methodName: "mergePullRequest"
            });
            if (e.success) return e;
            throw new Error(e.message);
        } catch (e) {
            throw e.message.includes("conflicts") || e.message.includes("409") ? new Error(`Pull request has merge conflicts: ${e.message}`, {
                cause: e
            }) : new Error(`Failed to merge pull request: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPullRequestDiff(r, t) {
        if (this._requireReady("getPullRequestDiff"), !r) throw new Error("Project ID is required");
        if (!t) throw new Error("Pull request ID is required");
        try {
            const e = await this._request(`/projects/${r}/pull-requests/${t}/diff`, {
                method: "GET",
                methodName: "getPullRequestDiff"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get pull request diff: ${e.message}`, {
                cause: e
            });
        }
    }
    async createPullRequestWithValidation(r, t) {
        const { source: e, target: s, title: u, description: i, changes: l } = t;
        if (e === s) throw new Error("Source and target branches cannot be the same");
        if (!u || u.trim().length === 0) throw new Error("Pull request title cannot be empty");
        if (u.length > 200) throw new Error("Pull request title cannot exceed 200 characters");
        const o = {
            source: e.trim(),
            target: s.trim(),
            title: u.trim(),
            ...i && {
                description: i.trim()
            },
            ...l && {
                changes: l
            }
        };
        return await this.createPullRequest(r, o);
    }
    async approvePullRequest(r, t, e = "") {
        const s = {
            status: "approved",
            ...e && {
                threads: [
                    {
                        comment: e,
                        type: "praise"
                    }
                ]
            }
        };
        return await this.reviewPullRequest(r, t, s);
    }
    async requestPullRequestChanges(r, t, e = []) {
        if (!e || e.length === 0) throw new Error("Must provide specific feedback when requesting changes");
        const s = {
            status: "requested_changes",
            threads: e
        };
        return await this.reviewPullRequest(r, t, s);
    }
    async getOpenPullRequests(r, t = {}) {
        return await this.listPullRequests(r, {
            ...t,
            status: "open"
        });
    }
    async getClosedPullRequests(r, t = {}) {
        return await this.listPullRequests(r, {
            ...t,
            status: "closed"
        });
    }
    async getMergedPullRequests(r, t = {}) {
        return await this.listPullRequests(r, {
            ...t,
            status: "merged"
        });
    }
    async isPullRequestMergeable(r, t) {
        try {
            return (await this.getPullRequest(r, t))?.data?.canMerge || !1;
        } catch (e) {
            throw new Error(`Failed to check pull request mergeability: ${e.message}`, {
                cause: e
            });
        }
    }
    async getPullRequestStatusSummary(r, t) {
        try {
            const s = (await this.getPullRequest(r, t))?.data;
            if (!s) throw new Error("Pull request not found");
            return {
                status: s.status,
                reviewStatus: s.reviewStatus,
                canMerge: s.canMerge,
                hasConflicts: !s.canMerge,
                reviewCount: s.reviews?.length || 0,
                approvedReviews: s.reviews?.filter((u)=>u.status === "approved").length || 0,
                changesRequested: s.reviews?.filter((u)=>u.status === "requested_changes").length || 0
            };
        } catch (e) {
            throw new Error(`Failed to get pull request status summary: ${e.message}`, {
                cause: e
            });
        }
    }
    validatePullRequestData(r) {
        const t = [];
        return (!r.source || typeof r.source != "string") && t.push("Source branch is required and must be a string"), (!r.target || typeof r.target != "string") && t.push("Target branch is required and must be a string"), r.source === r.target && t.push("Source and target branches cannot be the same"), !r.title || typeof r.title != "string" ? t.push("Title is required and must be a string") : r.title.trim().length === 0 ? t.push("Title cannot be empty") : r.title.length > 200 && t.push("Title cannot exceed 200 characters"), r.description && typeof r.description != "string" && t.push("Description must be a string"), {
            isValid: t.length === 0,
            errors: t
        };
    }
    validateReviewData(r) {
        const t = [], e = [
            "approved",
            "requested_changes",
            "feedback"
        ];
        return r.status && !e.includes(r.status) && t.push(`Invalid review status. Must be one of: ${e.join(", ")}`), r.threads && !Array.isArray(r.threads) && t.push("Threads must be an array"), r.threads && r.threads.forEach((s, u)=>{
            (!s.comment || typeof s.comment != "string") && t.push(`Thread ${u + 1}: Comment is required and must be a string`), s.type && ![
                "praise",
                "issue",
                "suggestion"
            ].includes(s.type) && t.push(`Thread ${u + 1}: Invalid thread type`);
        }), {
            isValid: t.length === 0,
            errors: t
        };
    }
    async getPullRequestStats(r, t = {}) {
        try {
            const { status: e = "open" } = t, s = await this.listPullRequests(r, {
                status: e
            }), u = {
                total: s.length,
                open: 0,
                closed: 0,
                merged: 0,
                withConflicts: 0,
                readyToMerge: 0
            };
            return s.forEach((i)=>{
                i.status === "open" && u.open++, i.status === "closed" && u.closed++, i.status === "merged" && u.merged++, i.hasConflicts && u.withConflicts++, i.canMerge && u.readyToMerge++;
            }), u;
        } catch (e) {
            throw new Error(`Failed to get pull request stats: ${e.message}`, {
                cause: e
            });
        }
    }
    async closePullRequest(r, t) {
        if (this._requireReady("closePullRequest"), !r) throw new Error("Project ID is required");
        if (!t) throw new Error("Pull request ID is required");
        try {
            const e = await this._request(`/projects/${r}/pull-requests/${t}/close`, {
                method: "POST",
                methodName: "closePullRequest"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to close pull request: ${e.message}`, {
                cause: e
            });
        }
    }
    async reopenPullRequest(r, t) {
        if (this._requireReady("reopenPullRequest"), !r) throw new Error("Project ID is required");
        if (!t) throw new Error("Pull request ID is required");
        try {
            const e = await this._request(`/projects/${r}/pull-requests/${t}/reopen`, {
                method: "POST",
                methodName: "reopenPullRequest"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to reopen pull request: ${e.message}`, {
                cause: e
            });
        }
    }
}

});

parcelRegister("45c85", function(module, exports) {

$parcel$export(module.exports, "AdminService", () => $2f9109aeb58bebb4$export$33af9b5749be502a);

var $em51x = parcelRequire("em51x");
class $2f9109aeb58bebb4$export$33af9b5749be502a extends (0, $em51x.BaseService) {
    async getAdminUsers(e = {}) {
        this._requireReady("getAdminUsers");
        const { emails: s, ids: t, query: r, status: a, team: n, page: u = 1, limit: m = 50, sort: c = {
            field: "createdAt",
            order: "desc"
        } } = e, i = new URLSearchParams;
        s && i.append("emails", s), t && i.append("ids", t), r && i.append("query", r), a && i.append("status", a), u && i.append("page", u.toString()), m && i.append("limit", m.toString()), c && c.field && (i.append("sort[field]", c.field), i.append("sort[order]", c.order || "desc")), n != null && i.append("team", n);
        const o = i.toString();
        try {
            const d = o ? await this._request(`/users/admin/users?${o}`, {
                method: "GET",
                methodName: "getAdminUsers"
            }) : await this._request("/users/admin/users", {
                method: "GET",
                methodName: "getAdminUsers"
            });
            if (d.success) return d.data;
            throw new Error(d.message);
        } catch (d) {
            throw new Error(`Failed to get admin users: ${d.message}`, {
                cause: d
            });
        }
    }
    async assignProjectsToUser(e, s = {}) {
        if (this._requireReady("assignProjectsToUser"), !e) throw new Error("User ID is required");
        const { projectIds: t, role: r = "guest" } = s, a = {
            userId: e,
            role: r
        };
        t && Array.isArray(t) && (a.projectIds = t);
        try {
            const n = await this._request("/users/assign-projects", {
                method: "POST",
                body: JSON.stringify(a),
                methodName: "assignProjectsToUser"
            });
            if (n.success) return n.data;
            throw new Error(n.message);
        } catch (n) {
            throw new Error(`Failed to assign projects to user: ${n.message}`, {
                cause: n
            });
        }
    }
    async updateUser(e, s) {
        if (this._requireReady("updateUser"), !e) throw new Error("User ID is required");
        if (!s || typeof s != "object" || Object.keys(s).length === 0) throw new Error("userData must be a non-empty object");
        try {
            const t = await this._request(`/users/${e}`, {
                method: "PATCH",
                body: JSON.stringify(s),
                methodName: "updateUser"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw t.message?.includes("Duplicate") ? new Error("Username already exists") : new Error(`Failed to update user: ${t.message}`, {
                cause: t
            });
        }
    }
    async searchAdminUsers(e, s = {}) {
        return await this.getAdminUsers({
            query: e,
            ...s
        });
    }
    async getAdminUsersByEmails(e, s = {}) {
        const t = Array.isArray(e) ? e.join(",") : e;
        return await this.getAdminUsers({
            emails: t,
            ...s
        });
    }
    async getAdminUsersByIds(e, s = {}) {
        const t = Array.isArray(e) ? e.join(",") : e;
        return await this.getAdminUsers({
            ids: t,
            ...s
        });
    }
    async assignSpecificProjectsToUser(e, s, t = "guest") {
        if (!Array.isArray(s) || s.length === 0) throw new Error("Project IDs must be a non-empty array");
        return await this.assignProjectsToUser(e, {
            projectIds: s,
            role: t
        });
    }
    async assignAllProjectsToUser(e, s = "guest") {
        return await this.assignProjectsToUser(e, {
            role: s
        });
    }
    validateUserData(e) {
        const s = [];
        return !e || typeof e != "object" ? (s.push("User data must be an object"), {
            isValid: !1,
            errors: s
        }) : (e.email && typeof e.email != "string" ? s.push("Email must be a string") : e.email && !this._isValidEmail(e.email) && s.push("Email must be a valid email address"), e.username && typeof e.username != "string" ? s.push("Username must be a string") : e.username && e.username.length < 3 && s.push("Username must be at least 3 characters long"), e.role && ![
            "admin",
            "user",
            "guest"
        ].includes(e.role) && s.push("Role must be one of: admin, user, guest"), e.status && ![
            "active",
            "inactive",
            "suspended"
        ].includes(e.status) && s.push("Status must be one of: active, inactive, suspended"), {
            isValid: s.length === 0,
            errors: s
        });
    }
    async updateUserWithValidation(e, s) {
        const t = this.validateUserData(s);
        if (!t.isValid) throw new Error(`Validation failed: ${t.errors.join(", ")}`);
        return await this.updateUser(e, s);
    }
    async getUserStats() {
        try {
            const e = await this.getAdminUsers({
                limit: 1e3
            }), s = {
                total: e.length,
                active: 0,
                inactive: 0,
                suspended: 0,
                admins: 0,
                users: 0,
                guests: 0
            };
            return e.forEach((t)=>{
                t.status === "active" && s.active++, t.status === "inactive" && s.inactive++, t.status === "suspended" && s.suspended++, t.role === "admin" && s.admins++, t.role === "user" && s.users++, t.role === "guest" && s.guests++;
            }), s;
        } catch (e) {
            throw new Error(`Failed to get user stats: ${e.message}`, {
                cause: e
            });
        }
    }
    async bulkUpdateUsers(e) {
        if (!Array.isArray(e) || e.length === 0) throw new Error("User updates must be a non-empty array");
        const s = e.map(async (r)=>{
            try {
                const a = await this.updateUser(r.userId, r.userData);
                return {
                    userId: r.userId,
                    success: !0,
                    data: a
                };
            } catch (a) {
                return {
                    userId: r.userId,
                    success: !1,
                    error: a.message
                };
            }
        }), t = await Promise.all(s);
        return {
            total: t.length,
            successful: t.filter((r)=>r.success).length,
            failed: t.filter((r)=>!r.success).length,
            results: t
        };
    }
    async getUsersByRole(e, s = {}) {
        return (await this.getAdminUsers(s)).filter((r)=>r.role === e);
    }
    async getUsersByStatus(e, s = {}) {
        return (await this.getAdminUsers(s)).filter((r)=>r.status === e);
    }
    async activateUser(e) {
        return await this.updateUser(e, {
            status: "active"
        });
    }
    async deactivateUser(e) {
        return await this.updateUser(e, {
            status: "inactive"
        });
    }
    async suspendUser(e) {
        return await this.updateUser(e, {
            status: "suspended"
        });
    }
    async promoteToAdmin(e) {
        return await this.updateUser(e, {
            role: "admin"
        });
    }
    async demoteFromAdmin(e) {
        return await this.updateUser(e, {
            role: "user"
        });
    }
    async getRateLimitStats() {
        this._requireReady("getRateLimitStats");
        try {
            const e = await this._request("/users/admin/rate-limit-stats", {
                method: "GET",
                methodName: "getRateLimitStats"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get rate limit stats: ${e.message}`, {
                cause: e
            });
        }
    }
    async getProjectKeyStats() {
        this._requireReady("getProjectKeyStats");
        const e = await this._request("/users/admin/project-key-stats", {
            method: "GET",
            methodName: "getProjectKeyStats"
        });
        if (e.success) return e.data;
        throw new Error(e.message || "Failed to get project key stats");
    }
    async getSystemStatus({ refresh: e = !1, signal: s } = {}) {
        return this._requireReady("getSystemStatus"), e ? this._request("/system/status?refresh=1", {
            method: "GET",
            methodName: "getSystemStatus",
            signal: s
        }) : this._request("/system/status", {
            method: "GET",
            methodName: "getSystemStatus",
            signal: s
        });
    }
    async getSystemUptime({ limit: e, signal: s } = {}) {
        this._requireReady("getSystemUptime");
        const t = Math.floor(Number(e));
        return Number.isFinite(t) && t > 0 ? this._request(`/system/uptime?limit=${t}`, {
            method: "GET",
            methodName: "getSystemUptime",
            signal: s
        }) : this._request("/system/uptime", {
            method: "GET",
            methodName: "getSystemUptime",
            signal: s
        });
    }
    async getAdminSubscribers({ status: e, limit: s, offset: t, signal: r } = {}) {
        this._requireReady("getAdminSubscribers");
        const a = new URLSearchParams, n = (Array.isArray(e) ? e : [
            e
        ]).filter((o)=>typeof o == "string" && o.trim()).map((o)=>o.trim());
        n.length && a.append("status", n.join(","));
        const u = Math.floor(Number(s));
        Number.isFinite(u) && u > 0 && a.append("limit", String(u));
        const m = Math.floor(Number(t));
        Number.isFinite(m) && m > 0 && a.append("offset", String(m));
        const i = a.toString() ? await this._request(`/admin/subscribers?${a.toString()}`, {
            method: "GET",
            methodName: "getAdminSubscribers",
            signal: r
        }) : await this._request("/admin/subscribers", {
            method: "GET",
            methodName: "getAdminSubscribers",
            signal: r
        });
        if (i && typeof i == "object" && "success" in i) {
            if (i.success) return i.data;
            throw new Error(i.message || "getAdminSubscribers failed");
        }
        return i;
    }
    _isValidEmail(e) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(e);
    }
}

});

parcelRegister("dmndo", function(module, exports) {

$parcel$export(module.exports, "ScreenshotService", () => $9b9f567702d359ec$export$5bdb934b2624cbb5);

var $em51x = parcelRequire("em51x");

var $hPIwr = parcelRequire("hPIwr");
class $9b9f567702d359ec$export$5bdb934b2624cbb5 extends (0, $em51x.BaseService) {
    constructor(e){
        super(e), this._debounceTimers = new Map, this._inflightRefreshes = new Map;
    }
    async createScreenshotProject(e) {
        this._requireReady("createScreenshotProject");
        try {
            const t = await this._request("/screenshots/projects", {
                method: "POST",
                body: JSON.stringify(e),
                methodName: "createScreenshotProject"
            });
            if (t.success) return t;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to create screenshot project: ${t.message}`, {
                cause: t
            });
        }
    }
    async getProjectScreenshots(e, t = {}) {
        if (this._requireReady("getProjectScreenshots"), !e) throw new Error("projectKey is required");
        const { type: r = "all", status: s, limit: n = 50, offset: a = 0 } = t, o = new URLSearchParams;
        r && o.set("type", r), s && o.set("status", s), n != null && o.set("limit", String(n)), a != null && o.set("offset", String(a));
        try {
            const c = await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}${o.toString() ? `?${o.toString()}` : ""}`, {
                method: "GET",
                methodName: "getProjectScreenshots"
            });
            if (c.success) return c;
            throw new Error(c.message);
        } catch (c) {
            throw new Error(`Failed to get project screenshots: ${c.message}`, {
                cause: c
            });
        }
    }
    async reprocessProjectScreenshots(e, t = {}) {
        if (this._requireReady("reprocessProjectScreenshots"), !e) throw new Error("projectKey is required");
        try {
            const r = await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}/reprocess`, {
                method: "POST",
                body: JSON.stringify(t),
                methodName: "reprocessProjectScreenshots"
            });
            if (r.success) return r;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to reprocess screenshots: ${r.message}`, {
                cause: r
            });
        }
    }
    async recreateProjectScreenshots(e, t = {}) {
        if (this._requireReady("recreateProjectScreenshots"), !e) throw new Error("projectKey is required");
        try {
            const r = await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}/recreate`, {
                method: "POST",
                body: JSON.stringify(t),
                methodName: "recreateProjectScreenshots"
            });
            if (r.success) return r;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to recreate screenshots: ${r.message}`, {
                cause: r
            });
        }
    }
    async refreshForEnvironment(e, t = "production", r = {}) {
        if (![
            "development",
            "staging",
            "production"
        ].includes(t)) throw new Error(`environment must be development | staging | production, got ${t}`);
        return this.recreateProjectScreenshots(e, {
            environment: t,
            force: !0,
            ...r
        });
    }
    async deleteProjectScreenshots(e) {
        if (this._requireReady("deleteProjectScreenshots"), !e) throw new Error("projectKey is required");
        try {
            const t = await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}`, {
                method: "DELETE",
                methodName: "deleteProjectScreenshots"
            });
            if (t.success) return t;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to delete project screenshots: ${t.message}`, {
                cause: t
            });
        }
    }
    async getThumbnailCandidate(e, t = {}) {
        if (this._requireReady("getThumbnailCandidate"), !e) throw new Error("projectKey is required");
        const { includeData: r = !1 } = t, s = new URLSearchParams;
        r && s.set("include_data", "true");
        try {
            const n = await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}/thumbnail/candidate${s.toString() ? `?${s.toString()}` : ""}`, {
                method: "GET",
                methodName: "getThumbnailCandidate"
            });
            if (n.success) return n;
            throw new Error(n.message);
        } catch (n) {
            throw new Error(`Failed to get thumbnail candidate: ${n.message}`, {
                cause: n
            });
        }
    }
    async updateProjectThumbnail(e, t = {}) {
        if (this._requireReady("updateProjectThumbnail"), !e) throw new Error("projectKey is required");
        try {
            const r = await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}/thumbnail`, {
                method: "POST",
                body: JSON.stringify(t),
                methodName: "updateProjectThumbnail"
            });
            if (r.success) return r;
            throw new Error(r.message);
        } catch (r) {
            throw new Error(`Failed to update project thumbnail: ${r.message}`, {
                cause: r
            });
        }
    }
    async getPageScreenshot(e, t = "json") {
        if (this._requireReady("getPageScreenshot"), !e) throw new Error("screenshotId is required");
        const r = new URLSearchParams;
        t && r.set("format", t);
        try {
            return await this._request(`/screenshots/pages/${encodeURIComponent(e)}${r.toString() ? `?${r.toString()}` : ""}`, {
                method: "GET",
                methodName: "getPageScreenshot"
            });
        } catch (s) {
            throw new Error(`Failed to get page screenshot: ${s.message}`, {
                cause: s
            });
        }
    }
    async getComponentScreenshot(e, t = "json") {
        if (this._requireReady("getComponentScreenshot"), !e) throw new Error("screenshotId is required");
        const r = new URLSearchParams;
        t && r.set("format", t);
        try {
            return await this._request(`/screenshots/components/${encodeURIComponent(e)}${r.toString() ? `?${r.toString()}` : ""}`, {
                method: "GET",
                methodName: "getComponentScreenshot"
            });
        } catch (s) {
            throw new Error(`Failed to get component screenshot: ${s.message}`, {
                cause: s
            });
        }
    }
    async getScreenshotByKey(e, t, r, s = "json") {
        if (this._requireReady("getScreenshotByKey"), !e) throw new Error("projectKey is required");
        if (!t || ![
            "component",
            "page"
        ].includes(String(t))) throw new Error("type must be 'component' or 'page'");
        if (!r) throw new Error("key is required");
        const n = s ? `?${new URLSearchParams({
            format: s
        }).toString()}` : "";
        try {
            return t === "component" ? await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}/components/${encodeURIComponent(r)}${n}`, {
                method: "GET",
                methodName: "getScreenshotByKey"
            }) : await this._request(`/screenshots/projects/${(0, $hPIwr.projectKeyPath)(e)}/pages/${encodeURIComponent(r)}${n}`, {
                method: "GET",
                methodName: "getScreenshotByKey"
            });
        } catch (a) {
            throw new Error(`Failed to get screenshot by key: ${a.message}`, {
                cause: a
            });
        }
    }
    async getQueueStatistics() {
        this._requireReady("getQueueStatistics");
        try {
            const e = await this._request("/screenshots/queue/stats", {
                method: "GET",
                methodName: "getQueueStatistics"
            });
            if (e.success) return e;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get queue statistics: ${e.message}`, {
                cause: e
            });
        }
    }
    async refreshThumbnail(e, t = {}) {
        if (this._requireReady("refreshThumbnail"), !e) throw new Error("projectKey is required");
        const { debounceMs: r = 15e3, waitAfterRecreateMs: s = 2e4, recreate: n = {
            process_pages: !0,
            process_components: !1,
            process_descriptions: !1,
            force: !1,
            priority: 5
        }, thumbnail: a = {
            strategy: "auto",
            force: !0
        } } = t;
        let o;
        if (e && typeof e == "object") {
            if (!e.key) throw new Error("refreshThumbnail: projectKey object must include a `key` property");
            o = e.owner ? `${e.owner}/${e.key}` : e.key;
        } else o = String(e);
        const c = this._inflightRefreshes.get(o);
        if (c) return c;
        const u = this._debounceTimers.get(o);
        u && clearTimeout(u);
        const m = new Promise((d)=>{
            const w = setTimeout(async ()=>{
                try {
                    await this.recreateProjectScreenshots(e, n), await new Promise((g)=>{
                        setTimeout(g, s);
                    });
                    const h = await this.updateProjectThumbnail(e, a);
                    d(h);
                } catch (h) {
                    d({
                        success: !1,
                        error: h?.message || String(h)
                    });
                } finally{
                    this._debounceTimers.delete(o), this._inflightRefreshes.delete(o);
                }
            }, r);
            this._debounceTimers.set(o, w);
        });
        return this._inflightRefreshes.set(o, m), m;
    }
}
var $9b9f567702d359ec$export$2e2bcd8739ae039 = $9b9f567702d359ec$export$5bdb934b2624cbb5;

});

parcelRegister("joPWZ", function(module, exports) {

$parcel$export(module.exports, "TrackingService", () => $e1f88e7d2cecdd71$export$118dd607fe6f53d);

var $em51x = parcelRequire("em51x");

var $gN40b = parcelRequire("gN40b");

var $h5XS2 = parcelRequire("h5XS2");
parcelRequire("lHyXG");
var $jaOyK = parcelRequire("jaOyK");
const $e1f88e7d2cecdd71$var$k = 100, $e1f88e7d2cecdd71$var$m = ()=>typeof window < "u", $e1f88e7d2cecdd71$var$d = {
    enabled: !0,
    sessionTracking: !0,
    enableTracing: !0,
    maxQueueSize: $e1f88e7d2cecdd71$var$k,
    transport: null,
    globalAttributes: {},
    user: null,
    kind: null
}, $e1f88e7d2cecdd71$var$T = /^[A-Za-z0-9][A-Za-z0-9_.:-]{0,127}$/, $e1f88e7d2cecdd71$var$j = 64, $e1f88e7d2cecdd71$var$A = (a)=>{
    if (!a || typeof a != "object" || Array.isArray(a)) return null;
    const t = [
        a.id,
        a._id,
        a.userId
    ].find((n)=>n != null && n !== ""), e = typeof t == "number" && Number.isFinite(t) ? String(t) : t;
    if (typeof e != "string" || !$e1f88e7d2cecdd71$var$T.test(e)) return null;
    const i = typeof a.plan == "string" ? a.plan.trim() : "";
    return i && i.length <= $e1f88e7d2cecdd71$var$j && !i.includes("@") ? {
        id: e,
        plan: i
    } : {
        id: e
    };
}, $e1f88e7d2cecdd71$var$h = (a)=>{
    if (!a || typeof a != "object") return {};
    try {
        return JSON.parse(JSON.stringify(a));
    } catch (t) {
        return (0, $h5XS2.logger).warn("[TrackingService] Failed to sanitize attributes:", t), {
            ...a
        };
    }
}, $e1f88e7d2cecdd71$var$q = (a)=>{
    const t = {
        current: null
    }, e = {
        current: null
    };
    return {
        api: {
            pushEvent: (i, n, r, s)=>{
                a.capture("info", String(i || ""), {
                    kind: "event",
                    domain: r || null,
                    attributes: n || {},
                    ...s && typeof s == "object" ? s : {}
                });
            },
            pushError: (i, n)=>{
                a.captureError(i, n?.context || n || {});
            },
            pushLog: (i, n)=>{
                const r = Array.isArray(i) ? i.map((s)=>typeof s == "string" ? s : JSON.stringify(s)).join(" ") : String(i || "");
                a.capture(n?.level || "info", r, n?.context || {});
            },
            pushMeasurement: (i, n)=>{
                const r = i?.values, s = typeof r == "object" && r !== null ? r.value ?? Object.values(r).find((o)=>typeof o == "number") : r;
                a.addMeasurement(i?.type || "measurement", Number(s) || 0, "ms");
            },
            setView: (i)=>{
                t.current = i || null, a.setContext("view", i || null);
            },
            setUser: (i)=>{
                const n = $e1f88e7d2cecdd71$var$A(i);
                a.identify(n ? {
                    userId: n.id,
                    traits: n.plan ? {
                        plan: n.plan
                    } : {}
                } : null);
            },
            setSession: (i, n)=>{
                e.current = i || null, a.setContext("session", i || null);
            }
        },
        destroy: ()=>a.shutdown()
    };
};
class $e1f88e7d2cecdd71$export$118dd607fe6f53d extends (0, $em51x.BaseService) {
    constructor({ context: t, options: e } = {}){
        super({
            context: t,
            options: e
        }), this._client = null, this._analyzing = null, this._queue = [], this._initialized = !1, this._enabled = $e1f88e7d2cecdd71$var$d.enabled, this._runtimeConfig = {}, this._setupPromise = null, this._trackingOptions = {
            ...$e1f88e7d2cecdd71$var$d,
            ...e?.tracking || {}
        }, this._globalAttributes = $e1f88e7d2cecdd71$var$h(this._trackingOptions.globalAttributes || {}), this._trackingOptions.globalAttributes = {
            ...this._globalAttributes
        };
    }
    async init({ context: t = {}, options: e = {} } = {}) {
        return this.updateContext(t), this._trackingOptions = {
            ...$e1f88e7d2cecdd71$var$d,
            ...this._trackingOptions,
            ...this._options?.tracking || {},
            ...e.tracking || {}
        }, this._globalAttributes = $e1f88e7d2cecdd71$var$h(this._trackingOptions.globalAttributes || {}), this._enabled = this._trackingOptions.enabled !== !1, this._enabled ? $e1f88e7d2cecdd71$var$m() ? (this._runtimeConfig = this._buildRuntimeConfig(), this._initialized ? (this._setReady(), this) : (this._setupPromise || (this._setupPromise = this._setupAnalyzingClient(this._runtimeConfig)), await this._setupPromise, this)) : (this._enabled = !1, this._setReady(), this) : (this._setReady(), this);
    }
    updateContext(t) {
        super.updateContext(t);
        const e = t?.tracking;
        e && (Object.hasOwn(e, "user") && this.setUser(e.user, {
            queue: !1
        }), Object.hasOwn(e, "globalAttributes") && this.setGlobalAttributes(e.globalAttributes));
    }
    configureTracking(t = {}) {
        return !t || typeof t != "object" ? this : (this._trackingOptions = {
            ...this._trackingOptions,
            ...t
        }, Object.hasOwn(t, "globalAttributes") && this.setGlobalAttributes(t.globalAttributes), Object.hasOwn(t, "user") && (this.setUser(t.user), this._trackingOptions.user = t.user), this);
    }
    configure(t = {}) {
        return this.configureTracking(t);
    }
    trackEvent(t, e, i = {}) {
        if (!t) throw new Error("Event name is required for trackEvent");
        const n = this._mergeAttributes(e), r = i && typeof i == "object" ? i : {}, { domain: s, queue: o, ...c } = r, u = Object.hasOwn(r, "domain") ? s : null, b = (g)=>{
            const p = g?.api;
            if (!p?.pushEvent) {
                (0, $h5XS2.logger).warn("[TrackingService] pushEvent API not available");
                return;
            }
            p.pushEvent(t, n, u, c);
        };
        Object.hasOwn(r, "queue") ? this._withClient(b, {
            queue: !!o
        }) : this._withClient(b);
    }
    trackError(t, e = {}) {
        if (!t) return;
        const i = t instanceof Error ? t : new Error(typeof t == "string" ? t : "Unknown error captured by TrackingService"), r = e && typeof e == "object" && e !== null && !("context" in e || "type" in e || "stackFrames" in e || "skipDedupe" in e || "spanContext" in e || "timestampOverwriteMs" in e || "originalError" in e) ? {
            context: e
        } : e || {}, s = this._mergeAttributes(r.context), o = {
            ...r,
            ...Object.keys(s).length > 0 ? {
                context: s
            } : {}
        }, c = Object.hasOwn(o, "queue"), { queue: u, ...b } = o, g = (p)=>{
            const _ = p?.api;
            if (!_?.pushError) {
                (0, $h5XS2.logger).warn("[TrackingService] pushError API not available");
                return;
            }
            _.pushError(i, b);
        };
        c ? this._withClient(g, {
            queue: !!u
        }) : this._withClient(g);
    }
    captureException(t, e = {}) {
        this.trackError(t, e);
    }
    logMessage(t, e = "info", i = null) {
        if (!t) return;
        const n = Array.isArray(t) ? t : [
            t
        ], r = this._mergeAttributes(i), o = {
            level: e || "info",
            ...Object.keys(r).length > 0 ? {
                context: r
            } : {}
        };
        this._withClient((c)=>{
            const u = c?.api;
            if (!u?.pushLog) {
                (0, $h5XS2.logger).warn("[TrackingService] pushLog API not available");
                return;
            }
            u.pushLog(n, o);
        });
    }
    logDebug(t, e) {
        this.logMessage(t, "debug", e);
    }
    logInfo(t, e) {
        this.logMessage(t, "info", e);
    }
    logWarning(t, e) {
        this.logMessage(t, "warn", e);
    }
    logWarn(t, e) {
        this.logWarning(t, e);
    }
    logErrorMessage(t, e) {
        this.logMessage(t, "error", e);
    }
    logError(t, e) {
        this.logErrorMessage(t, e);
    }
    addBreadcrumb(t, e) {
        if (!t) return;
        const i = {
            category: "custom",
            ...$e1f88e7d2cecdd71$var$h(e || {}),
            message: t
        };
        this.trackEvent("breadcrumb", i);
    }
    trackMeasurement(t, e, i = {}) {
        if (!t) throw new Error("Measurement type is required for trackMeasurement");
        if (e == null) throw new Error("Measurement values are required for trackMeasurement");
        const n = typeof e == "object" && !Array.isArray(e) ? $e1f88e7d2cecdd71$var$h(e) : {
            value: Number(e)
        };
        if (typeof n.value == "number" && Number.isNaN(n.value)) throw new Error("Measurement value must be a valid number");
        const r = i && typeof i == "object" ? i : {}, { attributes: s, context: o, queue: c, ...u } = r, b = Object.keys(this._globalAttributes).length > 0, g = s ? this._mergeAttributes(s) : b ? {
            ...this._globalAttributes
        } : {}, p = {
            type: t,
            values: n,
            ...g && Object.keys(g).length > 0 ? {
                attributes: g
            } : {}
        }, _ = o ? this._mergeAttributes(o) : b ? {
            ...this._globalAttributes
        } : {}, v = {
            ...u,
            ...Object.keys(_).length > 0 ? {
                context: _
            } : {}
        }, w = (O)=>{
            const y = O?.api;
            if (!y?.pushMeasurement) {
                (0, $h5XS2.logger).warn("[TrackingService] pushMeasurement API not available");
                return;
            }
            y.pushMeasurement(p, v);
        };
        Object.hasOwn(r, "queue") ? this._withClient(w, {
            queue: !!c
        }) : this._withClient(w);
    }
    trackView(t, e) {
        if (!t) throw new Error("View name is required for trackView");
        const i = $e1f88e7d2cecdd71$var$h(e || {}), n = this._mergeAttributes(i);
        this._withClient((r)=>{
            const s = r?.api;
            if (!s?.setView) {
                (0, $h5XS2.logger).warn("[TrackingService] setView API not available");
                return;
            }
            s.setView({
                name: t,
                ...n
            });
        });
    }
    setUser(t, e = {}) {
        if (t == null) {
            this.clearUser();
            return;
        }
        if (typeof t != "object") throw new Error("User must be an object");
        const i = $e1f88e7d2cecdd71$var$A(t), n = e && typeof e == "object" && Object.hasOwn(e, "queue"), r = (s)=>{
            const o = s?.api;
            if (!o?.setUser) {
                (0, $h5XS2.logger).warn("[TrackingService] setUser API not available");
                return;
            }
            o.setUser(i);
        };
        n ? this._withClient(r, {
            queue: !!e.queue
        }) : this._withClient(r);
    }
    clearUser() {
        this._withClient((t)=>{
            const e = t?.api;
            e?.setUser ? e.setUser(null) : (0, $h5XS2.logger).warn("[TrackingService] setUser API not available");
        });
    }
    setSession(t, e = {}) {
        if (t == null) {
            this.clearSession();
            return;
        }
        if (typeof t != "object") throw new Error("Session must be an object");
        const i = $e1f88e7d2cecdd71$var$h(t), n = Object.hasOwn(e, "queue"), { queue: r, ...s } = e, o = (c)=>{
            const u = c?.api;
            if (!u?.setSession) {
                (0, $h5XS2.logger).warn("[TrackingService] setSession API not available");
                return;
            }
            u.setSession(i, s);
        };
        n ? this._withClient(o, {
            queue: !!r
        }) : this._withClient(o);
    }
    clearSession() {
        this._withClient((t)=>{
            const e = t?.api;
            e?.setSession ? e.setSession(null) : (0, $h5XS2.logger).warn("[TrackingService] setSession API not available");
        });
    }
    setGlobalAttributes(t) {
        if (t == null) {
            this._globalAttributes = {}, this._trackingOptions.globalAttributes = {};
            return;
        }
        if (typeof t != "object") throw new Error("Global attributes must be an object");
        const e = $e1f88e7d2cecdd71$var$h(t);
        this._globalAttributes = e, this._trackingOptions.globalAttributes = e;
    }
    setGlobalAttribute(t, e) {
        if (!t) throw new Error("Global attribute key is required");
        const i = $e1f88e7d2cecdd71$var$h({
            [t]: e
        });
        this._globalAttributes = {
            ...this._globalAttributes,
            ...i
        }, this._trackingOptions.globalAttributes = {
            ...this._globalAttributes
        };
    }
    removeGlobalAttribute(t) {
        if (!t) throw new Error("Global attribute key is required to remove it");
        if (Object.hasOwn(this._globalAttributes, t)) {
            const e = {
                ...this._globalAttributes
            };
            delete e[t], this._globalAttributes = e, this._trackingOptions.globalAttributes = e;
        }
    }
    _mergeAttributes(t) {
        const i = t && typeof t == "object" ? $e1f88e7d2cecdd71$var$h(t) : {};
        return !this._globalAttributes || Object.keys(this._globalAttributes).length === 0 ? i : {
            ...this._globalAttributes,
            ...i
        };
    }
    flushQueue() {
        if (!this._queue.length) return;
        const t = [
            ...this._queue
        ];
        this._queue.length = 0, this._client && t.forEach((e)=>{
            try {
                e(this._client);
            } catch (i) {
                (0, $h5XS2.logger).error("[TrackingService] Failed to flush queued tracking call", i);
            }
        });
    }
    getClient(t = {}) {
        return t && t.getRawClient ? this._analyzing : this._client;
    }
    flush() {
        try {
            this._analyzing?.flush?.();
        } catch (t) {
            (0, $h5XS2.logger).warn("[TrackingService] flush failed:", t);
        }
    }
    isEnabled() {
        return this._enabled && !!this._client;
    }
    isInitialized() {
        return this._initialized;
    }
    destroy() {
        if (this._queue.length = 0, this._client?.destroy) try {
            this._client.destroy();
        } catch (t) {
            (0, $h5XS2.logger).warn("[TrackingService] Failed to destroy analyzing client cleanly", t);
        }
        $e1f88e7d2cecdd71$var$m() && window.symbols && window.symbols.tracking === this._client && delete window.symbols.tracking, this._client = null, this._analyzing = null, this._initialized = !1, this._setupPromise = null, this._setReady(!1), this._enabled = this._trackingOptions.enabled !== !1;
    }
    _buildRuntimeConfig() {
        const t = this._context?.tracking || {}, e = {
            ...$e1f88e7d2cecdd71$var$d,
            ...this._trackingOptions,
            ...t
        }, i = e.appName || t.appName || this._trackingOptions.appName || (0, $gN40b.default).grafanaAppName || "workspace", n = e.appVersion || t.appVersion || this._trackingOptions.appVersion || this._context?.appVersion || null, r = e.environment || t.environment || this._trackingOptions.environment || this._resolveEnvironmentName(), s = $e1f88e7d2cecdd71$var$h(t.globalAttributes || {}), o = $e1f88e7d2cecdd71$var$h({
            ...this._globalAttributes,
            ...s
        }), c = e.workspaceId || t.workspaceId || this._trackingOptions.workspaceId || null, u = e.kind || t.kind || this._trackingOptions.kind || null;
        return {
            appName: i,
            appVersion: n,
            environment: r,
            globalAttributes: o,
            workspaceId: c,
            kind: u === "workspace" || u === "project" ? u : null,
            sessionTracking: e.sessionTracking !== !1,
            enableTracing: e.enableTracing !== !1,
            transport: typeof e.transport == "function" ? e.transport : null,
            user: e.user,
            maxQueueSize: typeof e.maxQueueSize == "number" && e.maxQueueSize > 0 ? e.maxQueueSize : $e1f88e7d2cecdd71$var$k
        };
    }
    _resolveEnvironmentName() {
        return (0, $gN40b.default).isProduction ? "production" : (0, $gN40b.default).isStaging ? "staging" : (0, $gN40b.default).isTesting ? "testing" : (0, $gN40b.default).isDevelopment ? "development" : "production";
    }
    _resolveTransport(t) {
        if (typeof t.transport == "function") return t.transport;
        const e = (i)=>t.workspaceId ? {
                ...i,
                workspace_id: i?.workspace_id || t.workspaceId
            } : i;
        return async (i)=>{
            try {
                const n = this._context?.services?.analyzed;
                return typeof n?.ingest != "function" ? {
                    ok: !1
                } : {
                    ok: !(await n.ingest(e(i)))?.error
                };
            } catch (n) {
                return (0, $h5XS2.logger).warn("[TrackingService] transport failed:", n?.message || n), {
                    ok: !1
                };
            }
        };
    }
    async _setupAnalyzingClient(t, e = {}) {
        try {
            const i = this._resolveTransport(t), n = typeof e.createClient == "function" ? e.createClient : (0, $jaOyK.createAnalyzing);
            this._analyzing = n({
                appKey: t.appName,
                release: t.appVersion || null,
                env: t.environment,
                ...t.kind ? {
                    kind: t.kind
                } : {},
                transport: i,
                level: "info",
                sampleRate: 1,
                consoleSink: !1,
                memorySink: !0
            });
            for (const [r, s] of Object.entries(t.globalAttributes || {}))try {
                this._analyzing.setContext(r, s);
            } catch  {}
            try {
                this._analyzing.state.activate(null);
            } catch  {}
            this._client = $e1f88e7d2cecdd71$var$q(this._analyzing), t.user && this.setUser(t.user, {
                queue: !1
            }), $e1f88e7d2cecdd71$var$m() && (window.symbols ||= {}, window.symbols.tracking = this._client), this._initialized = !0, this._setReady(), this.flushQueue();
        } catch (i) {
            this._enabled = !1, this._setError(i), this._ready = !0, (0, $h5XS2.logger).error("[TrackingService] Failed to initialize analyzing client:", i);
        } finally{
            this._setupPromise = null;
        }
    }
    _withClient(t, e = {}) {
        if (!this._enabled) return null;
        if (this._client) try {
            return t(this._client);
        } catch (n) {
            return (0, $h5XS2.logger).error("[TrackingService] Tracking callback failed:", n), null;
        }
        if (e.queue === !1) return null;
        const i = this._runtimeConfig.maxQueueSize ?? this._trackingOptions.maxQueueSize ?? $e1f88e7d2cecdd71$var$k;
        return this._queue.length >= i && this._queue.shift(), this._queue.push(t), null;
    }
}

});
parcelRegister("lHyXG", function(module, exports) {

$parcel$export(module.exports, "createAnalyzing", () => (parcelRequire("jaOyK")).createAnalyzing);

var $jaOyK = parcelRequire("jaOyK");

var $3DuSb = parcelRequire("3DuSb");

var $2c3Au = parcelRequire("2c3Au");

var $52ggo = parcelRequire("52ggo");

var $l7scL = parcelRequire("l7scL");

var $j6pIZ = parcelRequire("j6pIZ");

});
parcelRegister("jaOyK", function(module, exports) {

$parcel$export(module.exports, "createAnalyzing", () => $df562b85726a23c8$export$1139d0d548409a0b);
parcelRequire("ag0Rk");
var $28jIP = parcelRequire("28jIP");
var $34R9O = parcelRequire("34R9O");
var $a7hC5 = parcelRequire("a7hC5");

var $l7scL = parcelRequire("l7scL");

var $j6pIZ = parcelRequire("j6pIZ");

var $52ggo = parcelRequire("52ggo");
const $df562b85726a23c8$var$ue = typeof window < "u" && typeof document < "u", $df562b85726a23c8$export$6fc9c8e1df1b788f = Object.freeze([
    "plan"
]), $df562b85726a23c8$var$Qe = 64, $df562b85726a23c8$export$216b222649202c37 = (t)=>{
    if (t == null) return null;
    let i, a = null;
    if (typeof t == "string" || typeof t == "number") i = t;
    else if (typeof t == "object" && !Array.isArray(t)) i = [
        t.userId,
        t.id
    ].find((S)=>S != null && S !== ""), t.traits && typeof t.traits == "object" && !Array.isArray(t.traits) && (a = t.traits);
    else return null;
    const g = typeof i == "number" && Number.isFinite(i) ? String(i) : i;
    if (!(0, $52ggo.isUserId)(g)) return null;
    const l = {};
    for (const S of $df562b85726a23c8$export$6fc9c8e1df1b788f){
        const v = a?.[S];
        if (typeof v != "string") continue;
        const m = v.trim();
        !m || m.length > $df562b85726a23c8$var$Qe || (0, $52ggo.looksLikeEmail)(m) || (l[S] = m);
    }
    return {
        userId: g,
        traits: l
    };
}, $df562b85726a23c8$export$c74098586707641 = ({ debug: t, captureOverrides: i } = {})=>t === !0 ? !0 : i && typeof i.network == "boolean" ? i.network : !1, $df562b85726a23c8$export$8c7a64e76903f385 = 200, $df562b85726a23c8$export$8317fddd6a97e121 = [
    "source",
    "medium",
    "campaign",
    "term",
    "content"
], $df562b85726a23c8$var$V = (t)=>{
    if (typeof t != "string") return null;
    const i = t.trim();
    return i ? i.length > $df562b85726a23c8$export$8c7a64e76903f385 ? i.slice(0, $df562b85726a23c8$export$8c7a64e76903f385) : i : null;
}, $df562b85726a23c8$export$540aff2593bb49a8 = ({ location: t, document: i } = {})=>{
    const a = {};
    try {
        const g = t || (typeof location < "u" ? location : null), l = i || (typeof document < "u" ? document : null), S = $df562b85726a23c8$var$V(g?.href);
        S && (a.url = S);
        const v = $df562b85726a23c8$var$V(l?.referrer);
        v && (a.referrer = v);
        const m = typeof g?.search == "string" ? g.search : "";
        if (m) {
            const s = new URLSearchParams(m), w = {};
            for (const d of $df562b85726a23c8$export$8317fddd6a97e121){
                const T = $df562b85726a23c8$var$V(s.get(`utm_${d}`));
                T && (w[d] = T);
            }
            Object.keys(w).length && (a.utm = w);
        }
    } catch  {}
    return a;
}, $df562b85726a23c8$export$2b5513f358ba834e = "smbls_vid", $df562b85726a23c8$export$8b437002c2b08d1 = "smbls_sid", $df562b85726a23c8$export$e4c4442c1ac02dc2 = 1800000, $df562b85726a23c8$var$D = ()=>typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`, $df562b85726a23c8$var$J = (t, i)=>{
    try {
        const a = t?.getItem?.(i);
        if (!a) return null;
        const g = JSON.parse(a);
        return g && typeof g == "object" ? g : null;
    } catch  {
        return null;
    }
}, $df562b85726a23c8$var$Y = (t, i, a)=>{
    try {
        return t?.setItem?.(i, JSON.stringify(a)), !0;
    } catch  {
        return !1;
    }
}, $df562b85726a23c8$var$ye = (t)=>{
    try {
        return typeof globalThis < "u" ? globalThis[t] : void 0;
    } catch  {
        return;
    }
}, $df562b85726a23c8$export$dac6f84782cc6336 = ({ localStorage: t = $df562b85726a23c8$var$ye("localStorage"), sessionStorage: i = $df562b85726a23c8$var$ye("sessionStorage"), now: a = ()=>Date.now(), sessionTimeoutMs: g = $df562b85726a23c8$export$e4c4442c1ac02dc2, visitor: l, sessionId: S } = {})=>{
    const v = typeof g == "number" && g > 0 ? g : $df562b85726a23c8$export$e4c4442c1ac02dc2, m = l !== !1;
    let s = null, w = !1;
    if (m) {
        if (l && typeof l == "object" && l.id) s = {
            id: String(l.id),
            firstSeenAt: Number(l.firstSeenAt) || a(),
            seq: Number.isInteger(l.seq) && l.seq > 0 ? l.seq : 0
        }, w = l.returning === !0 || s.seq > 0;
        else {
            const o = $df562b85726a23c8$var$J(t, $df562b85726a23c8$export$2b5513f358ba834e);
            o && typeof o.id == "string" && o.id ? (s = {
                id: o.id,
                firstSeenAt: Number(o.firstSeenAt) || a(),
                seq: Number.isInteger(o.seq) && o.seq > 0 ? o.seq : 0
            }, w = !0) : t && (s = {
                id: $df562b85726a23c8$var$D(),
                firstSeenAt: a(),
                seq: 0
            }, $df562b85726a23c8$var$Y(t, $df562b85726a23c8$export$2b5513f358ba834e, s) || (s = null));
        }
    }
    let d = null;
    const T = ()=>{
        d && i && $df562b85726a23c8$var$Y(i, $df562b85726a23c8$export$8b437002c2b08d1, d);
    }, U = ()=>{
        s && t && !(l && typeof l == "object") && $df562b85726a23c8$var$Y(t, $df562b85726a23c8$export$2b5513f358ba834e, s);
    }, C = ()=>{
        if (!s || l && typeof l == "object") return;
        const o = $df562b85726a23c8$var$J(t, $df562b85726a23c8$export$2b5513f358ba834e);
        o && o.id === s.id && Number.isInteger(o.seq) && o.seq > s.seq && (s.seq = o.seq);
    }, z = (o, f)=>{
        C();
        const L = s ? s.seq > 0 || w : !1;
        return s && (s.seq += 1), d = {
            sessionId: f || $df562b85726a23c8$var$D(),
            lastActivityAt: o,
            startedAt: o,
            seq: s ? s.seq : 1,
            returning: L
        }, U(), T(), d;
    };
    if (S) {
        const o = s ? w : !1;
        C(), d = {
            sessionId: String(S),
            lastActivityAt: a(),
            startedAt: a(),
            seq: s ? s.seq + 1 : 1,
            returning: o
        }, s && (s.seq += 1, U());
    } else {
        const o = a(), f = $df562b85726a23c8$var$J(i, $df562b85726a23c8$export$8b437002c2b08d1);
        f && typeof f.sessionId == "string" && f.sessionId && typeof f.lastActivityAt == "number" && o - f.lastActivityAt >= 0 && o - f.lastActivityAt < v ? (d = {
            sessionId: f.sessionId,
            lastActivityAt: o,
            startedAt: Number(f.startedAt) || f.lastActivityAt,
            seq: Number.isInteger(f.seq) && f.seq > 0 ? f.seq : s && s.seq || 1,
            returning: f.returning === !0
        }, T()) : z(o);
    }
    return {
        enabled: !!s,
        get sessionId () {
            return d.sessionId;
        },
        visitor () {
            return s ? {
                id: s.id,
                firstSeenAt: s.firstSeenAt,
                returning: d.returning === !0,
                seq: d.seq
            } : null;
        },
        touch (o = a()) {
            d && (d.lastActivityAt = o, T());
        },
        expired (o = a()) {
            return !d || S ? !1 : o - d.lastActivityAt >= v;
        },
        rotate (o = a(), f) {
            return z(o, f).sessionId;
        },
        _debug () {
            return {
                vid: s ? {
                    ...s
                } : null,
                session: d ? {
                    ...d
                } : null,
                existed: w
            };
        }
    };
}, $df562b85726a23c8$export$1139d0d548409a0b = (t = {})=>{
    const { endpoint: i, appKey: a, tenantKey: g, release: l, env: S, apiKey: v, sdk: m, getAuth: s, transport: w, capture: d, level: T = "info", sampleRate: U = 1, redact: C, beforeSend: z, kind: o, landing: f, visitor: L, sessionTimeoutMs: pe, storage: M, debug: ge = !1, sessionId: G, consoleSink: me = !1, memorySink: he = !0, batchMs: ke, maxBatch: Se, maxRetries: be, backoffMs: _e, queueLimit: we, mode: Ae = "authenticated", workspaceId: W, projectId: ve, projectEnv: X, domain: Ie, ingestUrl: Z } = t;
    if (!a) throw new Error("[@symbo.ls/analyzing] appKey is required");
    let E = w, H = null;
    const O = {
        url: null,
        token: null
    }, Q = (e, n)=>{
        const r = e?._context?.apiUrl;
        r && (O.url = `${r}/core/analyzed/ingest`), n && (O.token = n);
    };
    if (!E && Ae === "public") {
        const e = Z || "/v1/analytics/ingest";
        if (X === "development" && typeof console < "u") {
            if (!W) try {
                console.warn("[analyzing] no workspaceId provided; mermaid will resolve from Origin");
            } catch  {}
            if (!Z) try {
                console.warn(`[analyzing] no ingestUrl provided; defaulting to ${e}`);
            } catch  {}
        }
        E = async (n)=>{
            try {
                const r = await fetch(e, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        ...n,
                        workspace_id: W || void 0,
                        project_id: ve || void 0,
                        project_env: X || void 0,
                        domain: Ie || void 0
                    }),
                    keepalive: !0
                });
                return {
                    ok: r.ok,
                    status: r.status
                };
            } catch (r) {
                return {
                    ok: !1,
                    reason: r?.message || "fetch-failed"
                };
            }
        };
    }
    if (!E && m) {
        const e = ()=>typeof m == "function" ? m() : m, n = async (u)=>{
            const c = u?._context || {};
            if (typeof c.workspaceProjectTokenProvider == "function") try {
                const y = await c.workspaceProjectTokenProvider(), b = typeof y == "string" ? y : y?.token || y?.access_token || null;
                if (b) return b;
            } catch  {}
            if (typeof u.getAuthToken == "function") try {
                return u.getAuthToken() || null;
            } catch  {}
            return null;
        }, r = async (u, c)=>{
            try {
                const b = (u?._context || {}).apiUrl;
                if (!b) return {
                    ok: !1,
                    reason: "no-api-base"
                };
                const I = await n(u);
                if (!I) return {
                    ok: !1,
                    reason: "no-auth"
                };
                const Fe = `${String(b).replace(/\/+$/, "")}/core/analyzed/ingest`, ae = await fetch(Fe, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        ...I ? {
                            Authorization: `Bearer ${I}`
                        } : {}
                    },
                    body: JSON.stringify(c),
                    keepalive: !0
                });
                return {
                    ok: ae.ok,
                    status: ae.status
                };
            } catch (y) {
                return {
                    ok: !1,
                    reason: y?.message || "fetch-failed"
                };
            }
        };
        let k = !1, K = !1;
        const ie = new Set, j = [], F = (u)=>{
            j.push(u), j.length > 100 && j.shift();
        }, Re = async (u)=>{
            const c = e();
            if (!c) return {
                ok: !1,
                reason: "no-sdk"
            };
            const y = await n(c);
            if (!y) return {
                ok: !1,
                reason: "no-auth"
            };
            if (Q(c, y), typeof c.execute == "function") try {
                if (!(await c.execute("analyzed", "ingest", u))?.error) return {
                    ok: !0
                };
            } catch  {}
            return r(c, u);
        }, Ke = async ()=>{
            if (!j.length) return;
            const u = j.splice(0);
            for (const c of u)if ((await Re(c))?.status === 401) {
                k = !0, F(c);
                return;
            }
        };
        if ($df562b85726a23c8$var$ue) try {
            window.addEventListener("storage", (u)=>{
                u?.key === "symbols_access_token" && u.newValue && u.newValue !== u.oldValue && (k = !1, K = !1, Ke().catch(()=>{}));
            }, {
                passive: !0
            });
        } catch  {}
        E = async (u)=>{
            if (k) return F(u), {
                ok: !1,
                reason: "suspended"
            };
            const c = e();
            if (!c) return {
                ok: !1
            };
            const y = await n(c);
            if (!y) return {
                ok: !1,
                reason: "no-auth"
            };
            if (Q(c, y), typeof c.execute == "function") try {
                if (!(await c.execute("analyzed", "ingest", u))?.error) return {
                    ok: !0
                };
            } catch  {}
            const b = await r(c, u);
            if (b?.status === 401) {
                if (k = !0, !K && typeof console < "u") {
                    K = !0;
                    try {
                        console.warn("[analyzing] ingest suspended after 401; will resume on next sign-in");
                    } catch  {}
                }
                F(u);
            } else if (b && b.ok === !1 && typeof console < "u") {
                const I = String(b.status ?? b.reason ?? "unknown");
                if (!ie.has(I)) {
                    ie.add(I);
                    try {
                        console.warn(`[analyzing] ingest envelope dropped (${I}); further drops with this status are silent`);
                    } catch  {}
                }
            }
            return b;
        }, H = (u)=>{
            if (!O.url) return !1;
            const c = (()=>{
                try {
                    return JSON.stringify(u);
                } catch  {
                    return null;
                }
            })();
            if (!c) return !1;
            try {
                if (typeof navigator < "u" && typeof navigator.sendBeacon == "function") {
                    const y = typeof Blob < "u" ? new Blob([
                        c
                    ], {
                        type: "text/plain"
                    }) : c;
                    if (navigator.sendBeacon(O.url, y)) return !0;
                }
            } catch  {}
            if (typeof fetch != "function") return !1;
            try {
                return fetch(O.url, {
                    method: "POST",
                    keepalive: !0,
                    credentials: "omit",
                    mode: "cors",
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: c
                }).catch(()=>{}), !0;
            } catch  {
                return !1;
            }
        };
    }
    if (!i && !E) throw new Error('[@symbo.ls/analyzing] one of { sdk, endpoint, transport, mode: "public" } is required');
    const Te = typeof s == "function" ? s : m && !E ? ()=>$df562b85726a23c8$var$ot(m) : null, A = {
        user: null,
        traits: {},
        tags: {}
    };
    let _ = null;
    try {
        _ = $df562b85726a23c8$export$dac6f84782cc6336({
            ...M && typeof M == "object" ? M : {},
            sessionTimeoutMs: pe,
            visitor: L,
            sessionId: G
        });
    } catch  {
        _ = null;
    }
    const ee = G || _?.sessionId || $df562b85726a23c8$var$D();
    let P = null;
    const te = o === "workspace" || o === "project" ? o : null, Ee = f && typeof f == "object" && !Array.isArray(f) ? f : $df562b85726a23c8$export$540aff2593bb49a8(), qe = (e)=>{
        try {
            if (!e || typeof e != "object") return e;
            te && (e.kind = te);
            const n = e.page && typeof e.page == "object" ? e.page : {}, r = -new Date().getTimezoneOffset(), h = {
                ...n
            };
            if (Number.isFinite(r) && (h.utcOffset = r), !h.timezone) try {
                const k = Intl.DateTimeFormat().resolvedOptions().timeZone;
                k && (h.timezone = k);
            } catch  {}
            h.landing = Ee;
            try {
                const k = P || _?.visitor();
                k && (h.visitor = k);
            } catch  {}
            e.page = h;
        } catch  {}
        return e;
    }, ne = {
        type: "remote",
        url: i,
        transport: E,
        syncTransport: H,
        apiKey: v,
        appKey: a,
        tenantKey: g,
        release: l,
        env: S,
        sessionId: ee,
        sdk: {
            name: (0, $j6pIZ.SDK_NAME),
            version: (0, $j6pIZ.SDK_VERSION)
        },
        getAuth: Te,
        getContext: ()=>({
                user: A.user,
                traits: {
                    ...A.traits
                },
                tags: {
                    ...A.tags
                }
            }),
        classify: (0, $l7scL.classifyEnvelope),
        beforeSend: (e)=>{
            const n = qe(e);
            if (typeof z != "function") return n;
            try {
                return z(n);
            } catch  {
                return n;
            }
        },
        sampleRate: U,
        batchMs: ke,
        maxBatch: Se,
        maxRetries: be,
        backoffMs: _e,
        queueLimit: we
    }, $ = [
        ne
    ];
    he && $.push("memory"), me && $.push("console");
    const xe = {
        enabled: !0,
        debug: ge,
        level: T,
        appId: a,
        capture: {
            remote: !0,
            ...d || {}
        },
        sinks: $,
        redact: C,
        transformers: [
            "enrich",
            "summarize"
        ]
    }, p = (0, $34R9O.createAnalyzeState)(xe);
    let q = ee;
    const re = ()=>{
        const e = $df562b85726a23c8$var$D();
        try {
            P = _?.visitor() || null, q = p.startNewSession(e);
        } catch  {
            return q;
        } finally{
            P = null;
        }
        try {
            _?.rotate(void 0, e);
        } catch  {}
        return q;
    }, se = ()=>{
        try {
            return !_ || !_.expired() ? !1 : (re(), !0);
        } catch  {
            return !1;
        }
    }, Ne = ()=>{
        try {
            _?.touch();
        } catch  {}
    };
    if (_) {
        const e = p.emit;
        p.emit = (r)=>(se(), Ne(), e(r));
        const n = p.flush;
        p.flush = ()=>(se(), n());
    }
    p.setCapture("network", $df562b85726a23c8$export$c74098586707641({
        debug: p.config.debug === !0,
        captureOverrides: d
    })), ne.getDebug = ()=>p.config.debug === !0;
    const x = (e)=>p.emit(e), oe = (e = "info", n, r)=>{
        x((0, $a7hC5.makeEvent)("manual", e, {
            hook: "sdk.capture",
            message: n != null ? String(n) : null,
            ...r && typeof r == "object" ? {
                data: r
            } : {}
        }));
    }, ze = (e, n = "info", r)=>{
        oe(n, e, r);
    }, Oe = (e, n)=>{
        const r = e instanceof Error ? e : new Error(String(e));
        x((0, $a7hC5.makeEvent)("error", "error", {
            hook: "sdk.captureError",
            message: r.message,
            error: r,
            ...n && typeof n == "object" ? {
                data: n
            } : {}
        }));
    }, je = (e, n, r = "ms")=>{
        x((0, $a7hC5.makeEvent)("performance", "info", {
            hook: "sdk.measurement",
            name: e,
            value: typeof n == "number" ? n : Number(n),
            unit: r
        }));
    };
    let R = null;
    const Ue = (e)=>!e || typeof e != "object" ? "" : Object.keys(e).sort().map((r)=>`${r}=${String(e[r])}`).join("|"), Ce = (e)=>{
        const n = $df562b85726a23c8$export$216b222649202c37(e);
        if (!n) {
            A.user = null, A.traits = {}, R = null;
            return;
        }
        const { userId: r, traits: h } = n, k = `${r}|${Ue(h)}`;
        k !== R && (R = k, A.user = {
            id: r
        }, A.traits = {
            ...h
        }, x((0, $a7hC5.makeEvent)("identify", "info", {
            hook: "sdk.identify",
            userId: r,
            traits: h
        })));
    }, Le = (e, n)=>{
        if (e) {
            if (n === void 0) {
                delete A.traits[e];
                return;
            }
            (0, $52ggo.isPersonalKey)(e) || (0, $52ggo.looksLikeEmail)(n) || (A.traits[e] = n);
        }
    }, Be = (e, n)=>{
        e && (n === void 0 ? delete A.tags[e] : A.tags[e] = String(n));
    }, De = ()=>p.flush(), Me = ()=>p.destroy(), Pe = ()=>_ ? re() : (q = p.startNewSession(), q), $e = (e)=>p.setCapture("network", !!e);
    if ($df562b85726a23c8$var$ue && p.config.capture.errors) {
        const e = (r)=>{
            x((0, $a7hC5.makeEvent)("error", "error", {
                hook: "preboot.error",
                message: r?.message || null,
                error: r?.error || null,
                source: r?.filename || null,
                line: r?.lineno || null,
                col: r?.colno || null
            }));
        }, n = (r)=>{
            const h = r?.reason, k = h instanceof Error ? h : null;
            x((0, $a7hC5.makeEvent)("error", "error", {
                hook: "preboot.unhandledrejection",
                message: k?.message || (typeof h == "string" ? h : "Unhandled rejection"),
                error: k
            }));
        };
        window.addEventListener("error", e, {
            passive: !0
        }), window.addEventListener("unhandledrejection", n, {
            passive: !0
        }), p.__teardown.push(()=>{
            window.removeEventListener("error", e), window.removeEventListener("unhandledrejection", n);
        });
    }
    return {
        plugin: (0, $28jIP.analyzePlugin),
        analyzeConfig: p.config,
        config: p.config,
        state: p,
        capture: oe,
        captureMessage: ze,
        captureError: Oe,
        addMeasurement: je,
        identify: Ce,
        setContext: Le,
        setTag: Be,
        setNetworkCapture: $e,
        flush: De,
        shutdown: Me,
        startNewSession: Pe,
        get sessionId () {
            return q;
        },
        get visitorId () {
            try {
                const e = _?.visitor()?.id;
                return typeof e == "string" && e ? e : null;
            } catch  {
                return null;
            }
        }
    };
}, $df562b85726a23c8$var$ot = async (t)=>{
    if (!t) return null;
    try {
        return typeof t.getAccessToken == "function" ? await t.getAccessToken() : t.tokenManager && typeof t.tokenManager.getAccessToken == "function" ? await t.tokenManager.getAccessToken() : typeof t.token == "function" ? await t.token() : typeof t.token == "string" ? t.token : null;
    } catch  {
        return null;
    }
};

});
parcelRegister("ag0Rk", function(module, exports) {
$parcel$export(module.exports, "analyzePlugin", () => (parcelRequire("28jIP")).analyzePlugin);
$parcel$export(module.exports, "createAnalyzeState", () => (parcelRequire("34R9O")).createAnalyzeState);
$parcel$export(module.exports, "makeEvent", () => (parcelRequire("a7hC5")).makeEvent);
parcelRequire("24efj");

var $28jIP = parcelRequire("28jIP");

});
parcelRegister("24efj", function(module, exports) {

$parcel$export(module.exports, "analyzePlugin", () => (parcelRequire("28jIP")).analyzePlugin);
$parcel$export(module.exports, "createAnalyzeState", () => (parcelRequire("34R9O")).createAnalyzeState);
$parcel$export(module.exports, "makeEvent", () => (parcelRequire("a7hC5")).makeEvent);

var $28jIP = parcelRequire("28jIP");

var $34R9O = parcelRequire("34R9O");

var $a7hC5 = parcelRequire("a7hC5");

var $iXkfi = parcelRequire("iXkfi");

var $cl4xd = parcelRequire("cl4xd");

var $gDxCP = parcelRequire("gDxCP");

var $2NtUK = parcelRequire("2NtUK");

var $e9L43 = parcelRequire("e9L43");

var $jGKUv = parcelRequire("jGKUv");

var $7l9wz = parcelRequire("7l9wz");

});
parcelRegister("28jIP", function(module, exports) {

$parcel$export(module.exports, "analyzePlugin", () => $18dba08468ea7462$export$65b03b22c0c0d80);

var $a7hC5 = parcelRequire("a7hC5");
const $18dba08468ea7462$var$o = (t)=>t?.context?.analyze, $18dba08468ea7462$var$f = {
    init: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    create: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    render: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    beforeRemove: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    remove: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    }
}, $18dba08468ea7462$var$d = (t, { category: e, type: r, level: a })=>(u)=>{
        const c = $18dba08468ea7462$var$o(u);
        !c || !c.shouldCapture(e) || c.emit((0, $a7hC5.makeEvent)(r, a, {
            hook: t,
            element: (0, $a7hC5.summarizeElement)(u)
        }));
    }, $18dba08468ea7462$var$s = (t)=>(e, r)=>{
        const a = $18dba08468ea7462$var$o(e);
        !a || !a.shouldCapture("state") || a.emit((0, $a7hC5.makeEvent)("state", "debug", {
            hook: t,
            element: (0, $a7hC5.summarizeElement)(e),
            changedKeys: r?.changedKeys || null
        }));
    }, $18dba08468ea7462$export$65b03b22c0c0d80 = {
    name: "analyze",
    error (t, e) {
        const r = $18dba08468ea7462$var$o(t);
        if (!r || r.config.enabled === !1 || !r.shouldCapture("errors")) return;
        const a = e?.error || e?.err || (e instanceof Error ? e : null);
        r.emit((0, $a7hC5.makeEvent)("error", "error", {
            hook: e?.hook || "error",
            element: (0, $a7hC5.summarizeElement)(t),
            error: a,
            message: a?.message || (typeof e?.message == "string" ? e.message : null)
        }));
    },
    renderRouter (t) {
        const e = $18dba08468ea7462$var$o(t);
        e && (!e.shouldCapture("navigation") && !e.shouldCapture("lifecycle") || e.emit((0, $a7hC5.makeEvent)("navigation", "info", {
            hook: "renderRouter",
            route: t.context?.routerOptions?.currentRoute || null
        })));
    },
    beforeUpdate (t) {
        const e = $18dba08468ea7462$var$o(t);
        !e || !e.shouldCapture("updates") || t.__ref && (t.__ref.__analyzeUpdateStart = typeof performance < "u" ? performance.now() : Date.now());
    },
    update (t) {
        const e = $18dba08468ea7462$var$o(t);
        if (!e || !e.shouldCapture("updates")) return;
        let r = null;
        t.__ref?.__analyzeUpdateStart != null && (r = (typeof performance < "u" ? performance.now() : Date.now()) - t.__ref.__analyzeUpdateStart, t.__ref.__analyzeUpdateStart = null), e.emit((0, $a7hC5.makeEvent)("update", "debug", {
            hook: "update",
            element: (0, $a7hC5.summarizeElement)(t),
            durationMs: r
        }));
    },
    beforeStateUpdate: $18dba08468ea7462$var$s("beforeStateUpdate"),
    stateUpdate: $18dba08468ea7462$var$s("stateUpdate")
};
for (const [t, e] of Object.entries($18dba08468ea7462$var$f))$18dba08468ea7462$export$65b03b22c0c0d80[t] = $18dba08468ea7462$var$d(t, e);

});
parcelRegister("a7hC5", function(module, exports) {

$parcel$export(module.exports, "makeEvent", () => $75d83871d788851a$export$2f7b310570bee07a);
$parcel$export(module.exports, "summarizeElement", () => $75d83871d788851a$export$d997b4c8227425c);
let $75d83871d788851a$var$u = 0;
const $75d83871d788851a$var$e = ()=>`${Date.now().toString(36)}-${($75d83871d788851a$var$u++).toString(36)}`, $75d83871d788851a$export$2f7b310570bee07a = (t, r, n = {})=>({
        id: $75d83871d788851a$var$e(),
        ts: Date.now(),
        type: t,
        level: r,
        ...n
    }), $75d83871d788851a$var$a = (t)=>{
    const r = [];
    let n = t, o = 0;
    for(; n && o < 32;)n.key != null && r.unshift(String(n.key)), n = n.parent, o++;
    return r.join(" > ");
}, $75d83871d788851a$export$d997b4c8227425c = (t)=>t ? {
        key: t.key != null ? String(t.key) : null,
        name: t.__name || t.name || null,
        path: $75d83871d788851a$var$a(t),
        tag: t.tag || null,
        component: t.component || null,
        route: t.context?.routerOptions?.currentRoute || null
    } : null;

});


parcelRegister("34R9O", function(module, exports) {

$parcel$export(module.exports, "createAnalyzeState", () => $23dafac49ee72bbc$export$64b3291aa8b05fac);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");

var $iXkfi = parcelRequire("iXkfi");

var $cl4xd = parcelRequire("cl4xd");

var $2NtUK = parcelRequire("2NtUK");

var $jGKUv = parcelRequire("jGKUv");

var $7l9wz = parcelRequire("7l9wz");
const $23dafac49ee72bbc$var$h = {
    errors: !0,
    warnings: !0,
    pointer: !1,
    keyboard: !1,
    forms: !1,
    scroll: !1,
    viewport: !1,
    network: !1,
    performance: !1,
    navigation: !1,
    console: !1,
    lifecycle: !1,
    state: !1,
    updates: !1,
    replay: !1,
    telemetry: !1
}, $23dafac49ee72bbc$var$g = {
    errors: !0,
    warnings: !0,
    pointer: !0,
    keyboard: !0,
    forms: !0,
    scroll: !0,
    viewport: !0,
    navigation: !0,
    state: !0
}, $23dafac49ee72bbc$var$k = {
    errors: !0,
    warnings: !0,
    pointer: !0,
    navigation: !0,
    performance: !0,
    viewport: !0
}, $23dafac49ee72bbc$var$w = {
    errors: !0,
    warnings: !0,
    console: !0,
    network: !1,
    navigation: !0,
    performance: !0,
    viewport: !0,
    lifecycle: !1,
    state: !1,
    updates: !1
}, $23dafac49ee72bbc$var$v = (s)=>{
    const r = {
        ...$23dafac49ee72bbc$var$h,
        ...s
    };
    return r.replay && Object.assign(r, $23dafac49ee72bbc$var$g), r.telemetry && Object.assign(r, $23dafac49ee72bbc$var$k), r.remote && Object.assign(r, $23dafac49ee72bbc$var$w), Object.assign(r, s), r;
}, $23dafac49ee72bbc$var$A = 64, $23dafac49ee72bbc$var$b = ()=>{
    if (typeof (0, $fXgyh.window) > "u" || !(0, $fXgyh.window).location) return null;
    try {
        const r = new URLSearchParams((0, $fXgyh.window).location.search).get("analyze");
        return r || null;
    } catch  {
        return null;
    }
}, $23dafac49ee72bbc$export$64b3291aa8b05fac = (s = {})=>{
    const r = s === !0 ? {} : {
        ...s
    };
    r.capture = $23dafac49ee72bbc$var$v(r.capture || {});
    const i = $23dafac49ee72bbc$var$b();
    (i === "debug" || r.debug) && (r.level = "debug", r.debug = !0, r.capture = {
        ...r.capture,
        lifecycle: !0,
        state: !0,
        updates: !0,
        console: !0,
        network: !0
    }), i === "off" && (r.enabled = !1), r.level = (0, $iXkfi.normalizeLevel)(r.level || "warn"), r.cache = {
        max: 500,
        dedupeWindowMs: 1e3,
        ...r.cache || {}
    }, r.throttle = {
        pointermove: 80,
        mousemove: 80,
        scroll: 100,
        resize: 200,
        ...r.throttle || {}
    }, r.maskFormValues == null && (r.maskFormValues = !0), r.maskStrategy || (r.maskStrategy = "mask"), Array.isArray(r.sinks) || (r.sinks = [
        "console",
        "memory"
    ]), Array.isArray(r.transformers) || (r.transformers = [
        "enrich",
        "summarize"
    ]);
    const e = {
        config: r,
        context: null,
        __ready: !1,
        __paused: !1,
        __preBuffer: [],
        __teardown: [],
        __pipeline: null,
        __sinks: null,
        __memory: null,
        __initialSnapshot: null
    }, l = ()=>{
        e.__pipeline || (e.__pipeline = (0, $cl4xd.createPipeline)(e), e.__sinks = (0, $2NtUK.resolveSinks)(e));
    };
    return e.shouldCapture = (t)=>e.config.enabled === !1 ? !1 : !!e.config.capture[t], e.emit = (t)=>{
        if (t && e.config.enabled !== !1 && !e.__paused && (0, $iXkfi.meetsLevel)(t.level, e.config.level)) {
            if (!e.__ready) {
                if (t.level !== "error" && !e.config.captureDuringHydration) return;
                e.__preBuffer.length < $23dafac49ee72bbc$var$A && e.__preBuffer.push(t);
                return;
            }
            l(), $23dafac49ee72bbc$var$_(e, t);
        }
    }, e.activate = (t)=>{
        if (e.context == null && (e.context = t || null), e.__ready) return;
        e.__ready = !0;
        const n = e.__preBuffer;
        if (e.__preBuffer = [], n.length) {
            l();
            for (const o of n)$23dafac49ee72bbc$var$_(e, o);
        }
        try {
            (0, $jGKUv.attachBrowserListeners)(e);
        } catch (o) {
            console.error("[analyze] browser attach error:", o);
        }
        try {
            (0, $7l9wz.attachNetworkListeners)(e);
        } catch (o) {
            console.error("[analyze] network attach error:", o);
        }
        for (const o of e.__onActivate || [])try {
            o(e);
        } catch (a) {
            console.error("[analyze] onActivate error:", a);
        }
    }, e.pause = ()=>{
        e.__paused = !0;
    }, e.resume = ()=>{
        e.__paused = !1;
    }, e.setLevel = (t)=>{
        e.config.level = (0, $iXkfi.normalizeLevel)(t);
    }, e.setCapture = (t, n)=>{
        if (e.config.capture[t] = !!n, t === "network" && n && e.__ready) try {
            (0, $7l9wz.attachNetworkListeners)(e);
        } catch (o) {
            console.error("[analyze] network attach error:", o);
        }
    }, e.query = (t)=>e.__memory ? e.__memory.query(t) : [], e.snapshot = ()=>e.__memory ? e.__memory.snapshot() : [], e.emitNetwork = (t)=>{
        if (!e.shouldCapture("network")) return;
        const n = t?.phase, o = n === "error" ? "error" : n === "success" && t.ok === !1 ? "warn" : "info";
        e.emit({
            id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
            ts: Date.now(),
            type: "network",
            level: o,
            hook: `fetch.${n || "unknown"}`,
            ...t
        });
    }, e.flush = ()=>{
        if (e.__sinks) for (const t of e.__sinks)typeof t.flush == "function" && t.flush();
    }, e.startNewSession = (t)=>{
        const n = t || (typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`), o = Array.isArray(e.config.sinks) ? e.config.sinks : [];
        for (const a of o)a && typeof a == "object" && a.type === "remote" && (a.sessionId = n);
        if (e.__sinks) for (const a of e.__sinks)typeof a.startNewSession == "function" && a.startNewSession(n);
        return n;
    }, e.replay = ()=>({
            initialSnapshot: e.__initialSnapshot,
            events: e.snapshot()
        }), e.destroy = ()=>{
        for (const t of e.__teardown)try {
            t();
        } catch  {}
        e.__teardown = [], e.__ready = !1, e.__paused = !0;
    }, e.__onActivate = [], e.onActivate = (t)=>{
        e.__onActivate.push(t);
    }, e;
}, $23dafac49ee72bbc$var$_ = (s, r)=>{
    const i = s.__pipeline(r);
    if (i == null) return;
    const e = Array.isArray(i) ? i : [
        i
    ];
    for (const l of e){
        if (typeof s.config.onEvent == "function") try {
            s.config.onEvent(l);
        } catch  {}
        for (const t of s.__sinks)try {
            t(l);
        } catch (n) {
            console.error("[analyze] sink error:", n);
        }
    }
};

});
parcelRegister("iXkfi", function(module, exports) {

$parcel$export(module.exports, "meetsLevel", () => $dccd7113bbafd3ef$export$4363cb978945f701);
$parcel$export(module.exports, "normalizeLevel", () => $dccd7113bbafd3ef$export$c321aca3a5b2a397);
const $dccd7113bbafd3ef$export$834c2ad6e999b78f = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
    trace: 4
}, $dccd7113bbafd3ef$export$d42500118831797d = [
    "error",
    "warn",
    "info",
    "debug",
    "trace"
], $dccd7113bbafd3ef$export$4363cb978945f701 = (r, o)=>{
    const t = $dccd7113bbafd3ef$export$834c2ad6e999b78f[r], n = $dccd7113bbafd3ef$export$834c2ad6e999b78f[o];
    return t == null || n == null ? !0 : t <= n;
}, $dccd7113bbafd3ef$export$c321aca3a5b2a397 = (r)=>$dccd7113bbafd3ef$export$834c2ad6e999b78f[r] != null ? r : "warn";

});

parcelRegister("cl4xd", function(module, exports) {

$parcel$export(module.exports, "createPipeline", () => $0251779797d28dfe$export$4f1c956984599798);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");

var $gDxCP = parcelRequire("gDxCP");
const $0251779797d28dfe$export$2c4c34ec006c735a = (r)=>{
    const n = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`, e = typeof navigator < "u" ? navigator.userAgent : null, t = r.config.buildHash || null, i = r.config.appId || null;
    return (o)=>{
        if (!o) return o;
        const s = r.context?.routerOptions?.currentRoute || null, c = (0, $fXgyh.window), l = c && c.innerWidth ? {
            w: c.innerWidth,
            h: c.innerHeight
        } : null;
        return {
            ...o,
            session: n,
            app: {
                id: i,
                build: t,
                route: s
            },
            meta: {
                ua: e,
                viewport: l
            }
        };
    };
}, $0251779797d28dfe$export$1f33c5e666a5fc46 = ()=>(r)=>{
        if (!r) return r;
        if (r.element && typeof r.element == "object") {
            const n = r.element;
            (n.node || n.parent || n.__ref) && (r = {
                ...r,
                element: {
                    key: n.key != null ? String(n.key) : null,
                    name: n.__name || n.name || null,
                    tag: n.tag || null,
                    component: n.component || null
                }
            });
        }
        return r.error instanceof Error && (r = {
            ...r,
            error: {
                name: r.error.name,
                message: r.error.message,
                stack: r.error.stack
            }
        }), r;
    }, $0251779797d28dfe$export$557372cf05b38475 = (r = 1e3, n = 500)=>{
    const e = new Map;
    return (t)=>{
        if (!t) return t;
        const i = `${t.type}:${t.level}:${t.message || ""}:${t.error?.message || ""}`, o = e.get(i), s = t.ts || Date.now();
        if (o && s - o < r) return null;
        if (e.set(i, s), e.size > n) {
            const c = Math.ceil(n / 10);
            let l = 0;
            for (const a of e.keys()){
                if (l++ >= c) break;
                e.delete(a);
            }
        }
        return t;
    };
}, $0251779797d28dfe$export$5465d4b043904462 = (r)=>(n)=>{
        if (!n) return n;
        const e = r[n.type];
        return e == null || e >= 1 ? n : Math.random() > e ? null : n;
    }, $0251779797d28dfe$var$d = {
    redact: (r)=>(0, $gDxCP.createRedact)(r.config.redact || [], r.config.maskStrategy),
    enrich: (r)=>$0251779797d28dfe$export$2c4c34ec006c735a(r),
    summarize: ()=>$0251779797d28dfe$export$1f33c5e666a5fc46(),
    dedupe: (r)=>$0251779797d28dfe$export$557372cf05b38475(r.config.cache?.dedupeWindowMs || 1e3),
    sample: (r)=>$0251779797d28dfe$export$5465d4b043904462(r.config.sample || {})
}, $0251779797d28dfe$var$b = (r, n)=>{
    if (typeof r == "function") return r;
    if (typeof r == "string") {
        const e = $0251779797d28dfe$var$d[r];
        return e ? e(n) : null;
    }
    return null;
}, $0251779797d28dfe$export$4f1c956984599798 = (r)=>{
    const n = r.config, e = Array.isArray(n.transformers) ? n.transformers.slice() : [], t = e.findIndex((o)=>o === "redact");
    t >= 0 && e.splice(t, 1);
    const i = [];
    n.redact !== !1 && i.push($0251779797d28dfe$var$d.redact(r));
    for (const o of e){
        const s = $0251779797d28dfe$var$b(o, r);
        s && i.push(s);
    }
    return (o)=>{
        let s = o;
        for (const c of i){
            if (s == null) return null;
            const l = c(s);
            if (l == null) return null;
            if (Array.isArray(l)) {
                const a = i.slice(i.indexOf(c) + 1), f = [];
                for (const m of l){
                    let u = m, p = !1;
                    for (const g of a)if (u = g(u), u == null) {
                        p = !0;
                        break;
                    }
                    !p && u != null && f.push(u);
                }
                return f;
            }
            s = l;
        }
        return s;
    };
};

});
parcelRegister("gDxCP", function(module, exports) {

$parcel$export(module.exports, "SENSITIVE_NAME_RE", () => $c1ca5f1f3fdd436f$export$f6173f2add9eca7c);
$parcel$export(module.exports, "createRedact", () => $c1ca5f1f3fdd436f$export$a3cfe66c000f2134);
const $c1ca5f1f3fdd436f$export$f6173f2add9eca7c = /password|token|secret|ssn|card|cvv|pin|apikey|api_key|auth|email|otp/i, $c1ca5f1f3fdd436f$var$S = 6, $c1ca5f1f3fdd436f$var$h = (e, r)=>{
    for (const t of r)if (t instanceof RegExp) {
        if (t.test(e)) return !0;
    } else if (typeof t == "string" && e.toLowerCase().includes(t.toLowerCase())) return !0;
    return !1;
}, $c1ca5f1f3fdd436f$var$y = (e, r)=>{
    if (r !== "redact") {
        if (r === "hash") {
            let t = 0;
            const n = String(e);
            for(let o = 0; o < n.length; o++)t = (t << 5) - t + n.charCodeAt(o) | 0;
            return `#${(t >>> 0).toString(36)}`;
        }
        return "***";
    }
}, $c1ca5f1f3fdd436f$var$c = (e, r, t, n)=>{
    if (n > 6 || e == null || typeof e != "object") return e;
    if (Array.isArray(e)) return e.map((s)=>$c1ca5f1f3fdd436f$var$c(s, r, t, n + 1));
    const o = {};
    for (const s of Object.keys(e))if ($c1ca5f1f3fdd436f$var$h(s, r) || $c1ca5f1f3fdd436f$export$f6173f2add9eca7c.test(s)) {
        const i = $c1ca5f1f3fdd436f$var$y(e[s], t);
        i !== void 0 && (o[s] = i);
    } else o[s] = $c1ca5f1f3fdd436f$var$c(e[s], r, t, n + 1);
    return o;
}, $c1ca5f1f3fdd436f$export$a3cfe66c000f2134 = (e = [], r = "mask")=>{
    const t = Array.isArray(e) ? e : [
        e
    ];
    return (n)=>{
        if (!n) return n;
        const { id: o, ts: s, type: u, level: i, hook: f, error: a, message: d, durationMs: k, element: l, target: m, ...A } = n, p = $c1ca5f1f3fdd436f$var$c(A, t, r, 0);
        return {
            id: o,
            ts: s,
            type: u,
            level: i,
            hook: f,
            error: a,
            message: d,
            durationMs: k,
            element: l,
            target: m,
            ...p
        };
    };
};

});


parcelRegister("2NtUK", function(module, exports) {

$parcel$export(module.exports, "resolveSinks", () => $20975cbbfcb55d39$export$bf3a65adc5a2fd08);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");

var $e9L43 = parcelRequire("e9L43");
const $20975cbbfcb55d39$var$h = {
    error: "\x1B[31m",
    warn: "\x1B[33m",
    info: "\x1B[36m",
    debug: "\x1B[90m",
    trace: "\x1B[90m"
}, $20975cbbfcb55d39$var$g = "\x1B[0m", $20975cbbfcb55d39$var$m = typeof (0, $fXgyh.window) < "u" && typeof (0, $fXgyh.window).document < "u", $20975cbbfcb55d39$export$5c6be558c03a29e5 = (t = {})=>{
    const c = t.minLevel || null, s = console.error.bind(console), e = console.warn.bind(console), n = console.log.bind(console);
    return (o)=>{
        if (!o) return;
        const l = o.level === "error" ? s : o.level === "warn" ? e : n, r = `[analyze:${o.type}]`;
        if ($20975cbbfcb55d39$var$m) l(r, o);
        else {
            const i = $20975cbbfcb55d39$var$h[o.level] || "";
            l(`${i}${r}${$20975cbbfcb55d39$var$g}`, o);
        }
    };
}, $20975cbbfcb55d39$export$d3ccd521f897c931 = (t, c = {})=>{
    const s = c.max || t.config.cache?.max || 500, e = new Array(s);
    let n = 0, o = 0;
    const l = (r)=>{
        e[n] = r, n = (n + 1) % s, o < s && o++;
    };
    return t.__memory = {
        push: l,
        snapshot: ()=>{
            const r = new Array(o), i = (n - o + s) % s;
            for(let u = 0; u < o; u++)r[u] = e[(i + u) % s];
            return r;
        },
        query: (r = {})=>{
            const i = t.__memory.snapshot(), u = r.sinceMs ? Date.now() - r.sinceMs : 0;
            return i.filter((a)=>!(!a || r.level && a.level !== r.level || r.type && a.type !== r.type || u && a.ts < u));
        },
        clear: ()=>{
            n = 0, o = 0;
        }
    }, l;
}, $20975cbbfcb55d39$export$eec1893444946817 = (t = {})=>{
    const c = t.url, s = t.batchMs != null ? t.batchMs : 5e3, e = t.maxBatch || 50;
    if (!c) return ()=>{};
    let n = [], o = null;
    const l = ()=>{
        if (o && (clearTimeout(o), o = null), !n.length) return;
        const i = JSON.stringify({
            events: n
        });
        n = [];
        const u = $20975cbbfcb55d39$var$m ? new (0, $fXgyh.window).Blob([
            i
        ], {
            type: "application/json"
        }) : i;
        if ($20975cbbfcb55d39$var$m && navigator.sendBeacon) try {
            navigator.sendBeacon(c, u);
            return;
        } catch  {}
        typeof fetch < "u" && fetch(c, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Analyze-Beacon": "1"
            },
            body: i,
            keepalive: !0
        }).catch(()=>{});
    };
    $20975cbbfcb55d39$var$m && ((0, $fXgyh.window).addEventListener("pagehide", l, {
        passive: !0
    }), (0, $fXgyh.window).addEventListener("beforeunload", l, {
        passive: !0
    }));
    const r = (i)=>{
        i && (n.push(i), n.length >= e ? l() : o || (o = setTimeout(l, s)));
    };
    return r.flush = l, r;
}, $20975cbbfcb55d39$var$y = {
    console: $20975cbbfcb55d39$export$5c6be558c03a29e5,
    memory: $20975cbbfcb55d39$export$d3ccd521f897c931,
    beacon: $20975cbbfcb55d39$export$eec1893444946817,
    remote: (0, $e9L43.createRemoteSink)
}, $20975cbbfcb55d39$var$p = (t, c)=>c.getDebug != null || c.debug != null ? c : {
        ...c,
        getDebug: ()=>t.config.debug === !0
    }, $20975cbbfcb55d39$export$bf3a65adc5a2fd08 = (t)=>{
    const c = Array.isArray(t.config.sinks) ? t.config.sinks : [
        "console"
    ], s = [];
    for (const e of c)if (typeof e == "function") s.push(e);
    else if (typeof e == "string") {
        const n = $20975cbbfcb55d39$var$y[e];
        if (!n) continue;
        s.push(e === "memory" ? n(t, {}) : n(e === "remote" ? $20975cbbfcb55d39$var$p(t, {}) : {}));
    } else if (e && typeof e == "object" && e.type) {
        const n = $20975cbbfcb55d39$var$y[e.type];
        if (!n) continue;
        s.push(e.type === "memory" ? n(t, e) : n(e.type === "remote" ? $20975cbbfcb55d39$var$p(t, e) : e));
    }
    return s;
};

});
parcelRegister("e9L43", function(module, exports) {

$parcel$export(module.exports, "createRemoteSink", () => $a4e669fb93a4cc66$export$c833d74f1881a897);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");
const $a4e669fb93a4cc66$var$b = typeof (0, $fXgyh.window) < "u" && typeof (0, $fXgyh.window).document < "u", $a4e669fb93a4cc66$var$q = 5e3, $a4e669fb93a4cc66$var$$ = 50, $a4e669fb93a4cc66$var$j = 3, $a4e669fb93a4cc66$var$Q = 1500, $a4e669fb93a4cc66$var$V = 1e3, $a4e669fb93a4cc66$export$1672cb3a794924ab = (e)=>e ? e.level === "error" || e.type === "error" ? "bug" : e.type === "network" ? "network" : e.type === "console" ? e.level === "error" || e.level === "warn" ? "bug" : "log" : e.level === "warn" ? "bug" : e.level === "info" ? "log" : "verbose" : "verbose", $a4e669fb93a4cc66$var$G = (e)=>{
    try {
        return JSON.stringify(e);
    } catch  {
        return null;
    }
}, $a4e669fb93a4cc66$var$Y = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch  {
        return null;
    }
}, $a4e669fb93a4cc66$var$ee = (e)=>{
    if (!e) return null;
    const n = String(e);
    let t;
    return (t = n.match(/Edg\/([\d.]+)/)) ? {
        name: "Edge",
        version: t[1]
    } : (t = n.match(/OPR\/([\d.]+)/)) ? {
        name: "Opera",
        version: t[1]
    } : (t = n.match(/Firefox\/([\d.]+)/)) ? {
        name: "Firefox",
        version: t[1]
    } : /Chrome\/([\d.]+)/.test(n) && /Safari\//.test(n) ? (t = n.match(/Chrome\/([\d.]+)/), {
        name: "Chrome",
        version: t[1]
    }) : (t = n.match(/Version\/([\d.]+).*Safari/)) ? {
        name: "Safari",
        version: t[1]
    } : {
        name: null,
        version: null
    };
}, $a4e669fb93a4cc66$var$ne = ()=>{
    if (!$a4e669fb93a4cc66$var$b) return null;
    try {
        const e = (0, $fXgyh.window).document?.documentElement?.getAttribute("data-theme") || null, n = typeof (0, $fXgyh.window).matchMedia == "function" ? (0, $fXgyh.window).matchMedia("(prefers-color-scheme: dark)").matches : null;
        return {
            active: e || (n ? "dark" : n === !1 ? "light" : null),
            forced: e || null,
            prefers: n == null ? null : n ? "dark" : "light"
        };
    } catch  {
        return null;
    }
}, $a4e669fb93a4cc66$var$te = ()=>{
    if (!$a4e669fb93a4cc66$var$b) return null;
    const e = (0, $fXgyh.window).location, n = typeof navigator < "u" ? navigator : null, t = typeof screen < "u" ? screen : null;
    return {
        url: e?.href || null,
        path: e?.pathname || null,
        referrer: (0, $fXgyh.window).document?.referrer || null,
        title: (0, $fXgyh.window).document?.title || null,
        ua: n?.userAgent || null,
        browser: $a4e669fb93a4cc66$var$ee(n?.userAgent),
        language: n?.language || null,
        languages: n?.languages || null,
        timezone: $a4e669fb93a4cc66$var$Y(),
        viewport: (0, $fXgyh.window).innerWidth ? {
            w: (0, $fXgyh.window).innerWidth,
            h: (0, $fXgyh.window).innerHeight,
            dpr: (0, $fXgyh.window).devicePixelRatio || 1
        } : null,
        screen: t ? {
            w: t.width || null,
            h: t.height || null,
            availW: t.availWidth || null,
            availH: t.availHeight || null,
            colorDepth: t.colorDepth || null,
            orientation: t.orientation?.type || null
        } : null,
        theme: $a4e669fb93a4cc66$var$ne()
    };
}, $a4e669fb93a4cc66$export$c833d74f1881a897 = (e = {})=>{
    const n = e.url, t = typeof e.transport == "function" ? e.transport : null, h = typeof e.syncTransport == "function" ? e.syncTransport : null;
    if (!n && !t) return ()=>{};
    const y = e.apiKey || null, c = e.appKey || e.appId || null, C = e.tenantKey || e.tenant || null, F = e.release || null, L = e.env || null, U = e.sdk || null, O = typeof e.getAuth == "function" ? e.getAuth : null, T = typeof e.getContext == "function" ? e.getContext : null, K = typeof e.classify == "function" ? e.classify : $a4e669fb93a4cc66$export$1672cb3a794924ab, A = typeof e.beforeSend == "function" ? e.beforeSend : null, z = e.debug === !0, k = typeof e.getDebug == "function" ? e.getDebug : null, H = e.batchMs != null ? e.batchMs : $a4e669fb93a4cc66$var$q, J = e.maxBatch || $a4e669fb93a4cc66$var$$, E = e.maxRetries != null ? e.maxRetries : $a4e669fb93a4cc66$var$j, N = e.backoffMs || $a4e669fb93a4cc66$var$Q, D = e.queueLimit || $a4e669fb93a4cc66$var$V, M = e.sampleRate != null ? e.sampleRate : 1, x = ()=>typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    let m = e.sessionId || x(), i = [], v = [], g = null, w = null;
    const P = ()=>{
        g || !i.length || (g = setTimeout(f, H));
    }, I = (r)=>{
        if (w) return;
        const s = N * Math.pow(2, Math.max(0, r - 1));
        w = setTimeout(()=>{
            if (w = null, !v.length) return;
            const o = v.shift();
            B(o.envelope, o.attempt);
        }, s);
    }, W = (r, s = !1)=>{
        const o = T ? $a4e669fb93a4cc66$var$S(T) : null, a = {
            id: m,
            sentAt: Date.now()
        };
        s && (a.endedAt = Date.now());
        const u = {
            v: 1,
            session: a,
            app: {
                key: c,
                release: F,
                env: L
            },
            tenant: C,
            sdk: U,
            page: $a4e669fb93a4cc66$var$te(),
            user: o?.user || null,
            traits: o?.traits || null,
            tags: o?.tags || null,
            events: r
        };
        if ((k ? $a4e669fb93a4cc66$var$S(k) === !0 : z) && (u.app.debug = !0), A) try {
            return A(u) || null;
        } catch  {
            return u;
        }
        return u;
    }, B = async (r, s = 1)=>{
        if (r) try {
            let o = !0;
            if (t) {
                const a = await t(r);
                o = a !== !1 && a?.ok !== !1;
            } else o = await $a4e669fb93a4cc66$var$re(n, r, {
                apiKey: y,
                getAuth: O
            });
            !o && s < E && (v.push({
                envelope: r,
                attempt: s + 1
            }), I(s + 1));
        } catch  {
            s < E && (v.push({
                envelope: r,
                attempt: s + 1
            }), I(s + 1));
        }
    }, f = (r = !1, s = !1)=>{
        if (g && (clearTimeout(g), g = null), !i.length && !s) return;
        const o = i;
        i = [];
        const a = W(o, s);
        if (a) {
            if (r && $a4e669fb93a4cc66$var$b) {
                if (typeof h == "function" && $a4e669fb93a4cc66$var$S(()=>h(a))) return;
                if (navigator.sendBeacon && n) {
                    const u = $a4e669fb93a4cc66$var$G(a);
                    if (u) try {
                        navigator.sendBeacon(n, new (0, $fXgyh.window).Blob([
                            u
                        ], {
                            type: "application/json"
                        }));
                        return;
                    } catch  {}
                }
            }
            B(a);
        }
    };
    let p = !1;
    const _ = ()=>{
        p || (p = !0, f(!0, !0));
    };
    $a4e669fb93a4cc66$var$b && ((0, $fXgyh.window).addEventListener("pagehide", _, {
        passive: !0
    }), (0, $fXgyh.window).addEventListener("beforeunload", _, {
        passive: !0
    }), (0, $fXgyh.window).addEventListener("visibilitychange", ()=>{
        (0, $fXgyh.window).document.visibilityState === "hidden" && f(!0);
    }, {
        passive: !0
    }));
    const d = (r)=>{
        if (!r || M < 1 && Math.random() > M) return;
        p && (p = !1);
        const s = {
            ...r,
            log_type: K(r)
        };
        i.push(s), i.length > D && (i = i.slice(-D)), i.length >= J ? f() : P();
    }, X = (r)=>(f(!1, !0), m = r || x(), p = !1, d.sessionId = m, m);
    return d.flush = ()=>f(!1), d.endSession = _, d.startNewSession = X, d.sessionId = m, d;
}, $a4e669fb93a4cc66$var$S = (e)=>{
    try {
        return e();
    } catch  {
        return null;
    }
}, $a4e669fb93a4cc66$var$re = async (e, n, { apiKey: t, getAuth: h })=>{
    const y = {
        "Content-Type": "application/json",
        "X-Analyze-Beacon": "1"
    };
    if (t && (y["X-Analyze-Key"] = t), h) try {
        const c = await h();
        c && (y.Authorization = `Bearer ${c}`);
    } catch  {}
    try {
        return (await fetch(e, {
            method: "POST",
            headers: y,
            body: JSON.stringify(n),
            keepalive: !0,
            credentials: "omit",
            mode: "cors"
        })).ok;
    } catch  {
        return !1;
    }
};

});


parcelRegister("jGKUv", function(module, exports) {

$parcel$export(module.exports, "attachBrowserListeners", () => $e556540324e3c7fe$export$979193b008bd28b6);
parcelRequire("byww3");
var $gjNoZ = parcelRequire("gjNoZ");
var $fXgyh = parcelRequire("fXgyh");

var $a7hC5 = parcelRequire("a7hC5");

var $gDxCP = parcelRequire("gDxCP");
const $e556540324e3c7fe$var$E = typeof (0, $fXgyh.window) < "u" && typeof (0, $fXgyh.window).document < "u", $e556540324e3c7fe$var$b = new Set([
    "password",
    "hidden"
]), $e556540324e3c7fe$var$g = (e, r)=>{
    let l = 0, a = null, i = null;
    return (...t)=>{
        const n = Date.now();
        n - l >= r ? (l = n, e(...t)) : (i = t, a || (a = setTimeout(()=>{
            l = Date.now(), a = null, i && (e(...i), i = null);
        }, r - (n - l))));
    };
}, $e556540324e3c7fe$var$d = "__analyzeKeyPath", $e556540324e3c7fe$var$f = (e)=>{
    const r = e.target;
    if (!r) return {
        selector: null,
        key: null,
        path: null
    };
    if (r[$e556540324e3c7fe$var$d]) return r[$e556540324e3c7fe$var$d];
    const l = [];
    let a = r, i = 0, t = null;
    for(; a && i < 64;){
        if (a.getAttribute) {
            const o = a.getAttribute("data-key");
            o && (t == null && (t = o), l.unshift(o));
        }
        a = a.parentNode, i++;
    }
    let n;
    if (l.length) n = {
        selector: null,
        key: t,
        path: l.join(" > "),
        tag: r.tagName?.toLowerCase() || null
    };
    else {
        const o = (r.tagName || "unknown").toLowerCase(), u = r.id ? `#${r.id}` : "", m = r.className && typeof r.className == "string" ? "." + r.className.trim().split(/\s+/).slice(0, 2).join(".") : "";
        n = {
            selector: `${o}${u}${m}`,
            key: null,
            path: null
        };
    }
    try {
        r[$e556540324e3c7fe$var$d] = n;
    } catch  {}
    return n;
}, $e556540324e3c7fe$var$N = (e, r)=>{
    if (r === "mask") return "***";
    if (r !== "redact") {
        if (r === "hash") {
            let l = 0;
            const a = String(e || "");
            for(let i = 0; i < a.length; i++)l = (l << 5) - l + a.charCodeAt(i) | 0;
            return `#${(l >>> 0).toString(36)}`;
        }
        return "***";
    }
}, $e556540324e3c7fe$var$S = (e)=>!!(!e || e.tagName === "INPUT" && $e556540324e3c7fe$var$b.has(e.type) || (0, $gDxCP.SENSITIVE_NAME_RE).test(e.name || "") || (0, $gDxCP.SENSITIVE_NAME_RE).test(e.id || "") || e.dataset?.analyze === "skip"), $e556540324e3c7fe$export$979193b008bd28b6 = (e)=>{
    if (!$e556540324e3c7fe$var$E) return;
    const r = e.config.capture, l = e.config.throttle, a = e.__teardown, i = (t, n, o, u)=>{
        t.addEventListener(n, o, u), a.push(()=>t.removeEventListener(n, o, u));
    };
    if (r.errors && (i((0, $fXgyh.window), "error", (t)=>{
        e.emit((0, $a7hC5.makeEvent)("error", "error", {
            hook: "window.onerror",
            message: t.message || null,
            error: t.error || null,
            source: t.filename || null,
            line: t.lineno || null,
            col: t.colno || null
        }));
    }), i((0, $fXgyh.window), "unhandledrejection", (t)=>{
        const n = t.reason, o = n instanceof Error ? n : null;
        e.emit((0, $a7hC5.makeEvent)("error", "error", {
            hook: "unhandledrejection",
            message: o?.message || (typeof n == "string" ? n : "Unhandled promise rejection"),
            error: o
        }));
    })), r.pointer) {
        i((0, $fXgyh.window), "click", (n)=>{
            e.emit((0, $a7hC5.makeEvent)("pointer", "info", {
                hook: "click",
                target: $e556540324e3c7fe$var$f(n),
                button: n.button,
                x: n.clientX,
                y: n.clientY,
                modifiers: $e556540324e3c7fe$var$y(n)
            }));
        }, {
            passive: !0,
            capture: !0
        }), i((0, $fXgyh.window), "dblclick", (n)=>{
            e.emit((0, $a7hC5.makeEvent)("pointer", "info", {
                hook: "dblclick",
                target: $e556540324e3c7fe$var$f(n),
                x: n.clientX,
                y: n.clientY
            }));
        }, {
            passive: !0,
            capture: !0
        }), i((0, $fXgyh.window), "contextmenu", (n)=>{
            e.emit((0, $a7hC5.makeEvent)("pointer", "info", {
                hook: "contextmenu",
                target: $e556540324e3c7fe$var$f(n),
                x: n.clientX,
                y: n.clientY
            }));
        }, {
            passive: !0,
            capture: !0
        });
        const t = $e556540324e3c7fe$var$g((n)=>{
            e.emit((0, $a7hC5.makeEvent)("pointer", "trace", {
                hook: "pointermove",
                x: n.clientX,
                y: n.clientY
            }));
        }, l.pointermove);
        i((0, $fXgyh.window), "pointermove", t, {
            passive: !0
        });
    }
    if (r.keyboard && i((0, $fXgyh.window), "keydown", (t)=>{
        e.emit((0, $a7hC5.makeEvent)("keyboard", "info", {
            hook: "keydown",
            code: t.code,
            key: t.key && t.key.length === 1 ? "\xB7" : t.key,
            modifiers: $e556540324e3c7fe$var$y(t),
            target: $e556540324e3c7fe$var$f(t)
        }));
    }, {
        passive: !0,
        capture: !0
    }), r.forms) {
        const t = (n)=>{
            const o = n.target;
            if (!o || !o.tagName || ![
                "INPUT",
                "TEXTAREA",
                "SELECT"
            ].includes(o.tagName)) return;
            const m = $e556540324e3c7fe$var$S(o), v = o.dataset?.analyze === "track";
            let p = null;
            v && !m ? p = o.value : e.config.maskFormValues !== !1 && (p = $e556540324e3c7fe$var$N(o.value, e.config.maskStrategy)), e.emit((0, $a7hC5.makeEvent)("forms", "info", {
                hook: n.type,
                target: $e556540324e3c7fe$var$f(n),
                field: {
                    name: o.name || null,
                    type: o.type || o.tagName.toLowerCase()
                },
                value: p
            }));
        };
        i((0, $fXgyh.window), "input", t, {
            passive: !0,
            capture: !0
        }), i((0, $fXgyh.window), "change", t, {
            passive: !0,
            capture: !0
        }), i((0, $fXgyh.window), "submit", (n)=>{
            e.emit((0, $a7hC5.makeEvent)("forms", "info", {
                hook: "submit",
                target: $e556540324e3c7fe$var$f(n)
            }));
        }, {
            passive: !0,
            capture: !0
        });
    }
    if (r.scroll) {
        const t = $e556540324e3c7fe$var$g(()=>{
            e.emit((0, $a7hC5.makeEvent)("scroll", "trace", {
                hook: "scroll",
                x: (0, $fXgyh.window).scrollX,
                y: (0, $fXgyh.window).scrollY
            }));
        }, l.scroll);
        i((0, $fXgyh.window), "scroll", t, {
            passive: !0,
            capture: !0
        });
    }
    if (r.viewport) {
        const t = (0, $gjNoZ.debounce)(()=>{
            e.emit((0, $a7hC5.makeEvent)("viewport", "info", {
                hook: "resize",
                w: (0, $fXgyh.window).innerWidth,
                h: (0, $fXgyh.window).innerHeight,
                dpr: (0, $fXgyh.window).devicePixelRatio || 1
            }));
        }, l.resize);
        i((0, $fXgyh.window), "resize", t, {
            passive: !0
        }), i((0, $fXgyh.window), "orientationchange", ()=>{
            e.emit((0, $a7hC5.makeEvent)("viewport", "info", {
                hook: "orientationchange",
                orientation: typeof screen < "u" && screen.orientation ? screen.orientation.type : null
            }));
        }, {
            passive: !0
        }), i((0, $fXgyh.window).document, "visibilitychange", ()=>{
            e.emit((0, $a7hC5.makeEvent)("viewport", "info", {
                hook: "visibilitychange",
                hidden: (0, $fXgyh.window).document.hidden
            }));
        }, {
            passive: !0
        }), e.emit((0, $a7hC5.makeEvent)("viewport", "info", {
            hook: "initial",
            w: (0, $fXgyh.window).innerWidth,
            h: (0, $fXgyh.window).innerHeight,
            dpr: (0, $fXgyh.window).devicePixelRatio || 1
        }));
    }
    if (r.console) for (const t of [
        "log",
        "warn",
        "error",
        "debug"
    ]){
        const n = console[t];
        console[t] = function(...o) {
            try {
                e.emit((0, $a7hC5.makeEvent)("console", t === "error" ? "error" : t === "warn" ? "warn" : "debug", {
                    hook: `console.${t}`,
                    args: o.map($e556540324e3c7fe$var$k)
                }));
            } catch  {}
            return n.apply(console, o);
        }, a.push(()=>{
            console[t] = n;
        });
    }
    if (r.performance && typeof PerformanceObserver < "u") try {
        const t = new PerformanceObserver((o)=>{
            for (const u of o.getEntries())e.emit((0, $a7hC5.makeEvent)("performance", "info", {
                hook: u.entryType,
                name: u.name,
                startTime: u.startTime,
                duration: u.duration,
                value: u.value != null ? u.value : null
            }));
        }), n = [
            "largest-contentful-paint",
            "layout-shift",
            "longtask",
            "paint",
            "first-input",
            "event"
        ];
        for (const o of n)try {
            t.observe({
                type: o,
                buffered: !0
            });
        } catch  {}
        a.push(()=>t.disconnect());
    } catch  {}
}, $e556540324e3c7fe$var$y = (e)=>({
        shift: !!e.shiftKey,
        ctrl: !!e.ctrlKey,
        alt: !!e.altKey,
        meta: !!e.metaKey
    }), $e556540324e3c7fe$var$_ = (e)=>{
    const r = {
        name: e.name || "Error",
        message: typeof e.message == "string" ? e.message : String(e),
        stack: typeof e.stack == "string" ? e.stack : null
    };
    return e.cause !== void 0 && (r.cause = $e556540324e3c7fe$var$k(e.cause)), r;
}, $e556540324e3c7fe$var$k = (e)=>{
    if (e == null) return e;
    if (e instanceof Error) return $e556540324e3c7fe$var$_(e);
    if (typeof e == "object") try {
        return JSON.parse(JSON.stringify(e));
    } catch  {
        return String(e);
    }
    return e;
};

});

parcelRegister("7l9wz", function(module, exports) {

$parcel$export(module.exports, "attachNetworkListeners", () => $5581e1ea31cef193$export$4e57191faf66e249);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");

var $a7hC5 = parcelRequire("a7hC5");
const $5581e1ea31cef193$var$d = typeof (0, $fXgyh.window) < "u" && typeof (0, $fXgyh.window).document < "u", $5581e1ea31cef193$export$b72d415da8fb0c0 = (e, o)=>{
    const c = e?.analyze;
    if (!c || !c.shouldCapture("network")) return;
    const t = o.phase === "error" ? "error" : "info";
    c.emit((0, $a7hC5.makeEvent)("network", t, {
        hook: `fetch.${o.phase}`,
        source: "symbo-fetch",
        ...o
    }));
}, $5581e1ea31cef193$export$4e57191faf66e249 = (e)=>{
    if ($5581e1ea31cef193$var$d && e.config.capture.network && !e.__networkListeners) {
        if (e.__networkListeners = !0, e.__teardown.push(()=>{
            e.__networkListeners = !1;
        }), typeof (0, $fXgyh.window).fetch == "function") {
            const o = (0, $fXgyh.window).fetch.bind((0, $fXgyh.window)), c = function(t, f) {
                if (f?.headers?.["X-Analyze-Beacon"] || !e.shouldCapture("network")) return o(t, f);
                const r = typeof t == "string" ? t : t && t.url || "", p = (f?.method || typeof t == "object" && t?.method || "GET").toUpperCase(), i = typeof performance < "u" ? performance.now() : Date.now();
                return e.emit((0, $a7hC5.makeEvent)("network", "info", {
                    hook: "fetch.start",
                    source: "window.fetch",
                    url: r,
                    method: p
                })), o(t, f).then((n)=>{
                    const u = (typeof performance < "u" ? performance.now() : Date.now()) - i;
                    return e.emit((0, $a7hC5.makeEvent)("network", n.ok ? "info" : "warn", {
                        hook: "fetch.success",
                        source: "window.fetch",
                        url: r,
                        method: p,
                        status: n.status,
                        ok: n.ok,
                        durationMs: u
                    })), n;
                }).catch((n)=>{
                    const u = (typeof performance < "u" ? performance.now() : Date.now()) - i;
                    throw e.emit((0, $a7hC5.makeEvent)("network", "error", {
                        hook: "fetch.error",
                        source: "window.fetch",
                        url: r,
                        method: p,
                        error: n,
                        durationMs: u
                    })), n;
                });
            };
            (0, $fXgyh.window).fetch = c, e.__teardown.push(()=>{
                (0, $fXgyh.window).fetch = o;
            });
        }
        if (typeof (0, $fXgyh.window).XMLHttpRequest == "function") {
            const o = (0, $fXgyh.window).XMLHttpRequest, c = o.prototype.open, t = o.prototype.send;
            o.prototype.open = function(f, r) {
                return this.__analyze = {
                    method: String(f).toUpperCase(),
                    url: String(r)
                }, c.apply(this, arguments);
            }, o.prototype.send = function(f) {
                const r = this.__analyze;
                if (!r || !e.shouldCapture("network")) return t.apply(this, arguments);
                const p = typeof performance < "u" ? performance.now() : Date.now();
                e.emit((0, $a7hC5.makeEvent)("network", "info", {
                    hook: "xhr.start",
                    source: "xhr",
                    url: r.url,
                    method: r.method
                }));
                const i = ()=>{
                    const u = (typeof performance < "u" ? performance.now() : Date.now()) - p, a = this.status >= 200 && this.status < 400;
                    e.emit((0, $a7hC5.makeEvent)("network", a ? "info" : "warn", {
                        hook: "xhr.success",
                        source: "xhr",
                        url: r.url,
                        method: r.method,
                        status: this.status,
                        ok: a,
                        durationMs: u
                    }));
                }, n = ()=>{
                    const u = (typeof performance < "u" ? performance.now() : Date.now()) - p;
                    e.emit((0, $a7hC5.makeEvent)("network", "error", {
                        hook: "xhr.error",
                        source: "xhr",
                        url: r.url,
                        method: r.method,
                        status: this.status,
                        durationMs: u
                    }));
                };
                return this.addEventListener("loadend", i), this.addEventListener("error", n), t.apply(this, arguments);
            }, e.__teardown.push(()=>{
                o.prototype.open = c, o.prototype.send = t;
            });
        }
    }
};

});




parcelRegister("l7scL", function(module, exports) {

$parcel$export(module.exports, "classifyEnvelope", () => $f600214bf757d146$export$31e4ebd16ea2d22c);
const $f600214bf757d146$export$80b443b0a7b40a70 = [
    "bug",
    "network",
    "log",
    "verbose"
], $f600214bf757d146$export$31e4ebd16ea2d22c = (r)=>r ? r.level === "error" || r.type === "error" ? "bug" : r.type === "network" ? "network" : r.type === "console" ? r.level === "error" || r.level === "warn" ? "bug" : "log" : r.level === "warn" ? "bug" : r.level === "info" ? "log" : "verbose" : "verbose";

});

parcelRegister("j6pIZ", function(module, exports) {

$parcel$export(module.exports, "SDK_NAME", () => $de82883a1de91cf7$export$ca61d37259221480);
$parcel$export(module.exports, "SDK_VERSION", () => $de82883a1de91cf7$export$31499a9cd224b78c);
const $de82883a1de91cf7$export$ca61d37259221480 = "@symbo.ls/analyzing", $de82883a1de91cf7$export$31499a9cd224b78c = "3.14.0";

});

parcelRegister("52ggo", function(module, exports) {

$parcel$export(module.exports, "isPersonalKey", () => $3aa9c1370efd9e38$export$d52f78f4c38ae9a9);
$parcel$export(module.exports, "looksLikeEmail", () => $3aa9c1370efd9e38$export$735ba148aa5fbd0);
$parcel$export(module.exports, "isOpaqueId", () => $3aa9c1370efd9e38$export$e0d4c7b70ee632dc);
$parcel$export(module.exports, "isUserId", () => $3aa9c1370efd9e38$export$1da07d7bf185731c);
const $3aa9c1370efd9e38$export$50894c0252500a83 = /e-?mail|phone|mobile|address|street|zip|postcode|password|passwd|token|secret|card|iban|passport|birth|contact|customer_?name|full_?name|first_?name|last_?name|surname|user_?name|display_?name|nick_?name|^name$|^ip(_?addr)?$/i, $3aa9c1370efd9e38$export$6fab64b70e88f56d = /[^\s@]+@[^\s@]+\.[^\s@]{2,}/, $3aa9c1370efd9e38$export$d52f78f4c38ae9a9 = (t)=>typeof t == "string" && $3aa9c1370efd9e38$export$50894c0252500a83.test(t), $3aa9c1370efd9e38$export$735ba148aa5fbd0 = (t)=>typeof t == "string" && $3aa9c1370efd9e38$export$6fab64b70e88f56d.test(t), $3aa9c1370efd9e38$export$9e0669c13468e662 = /^[A-Za-z0-9][A-Za-z0-9_-]{7,63}$/, $3aa9c1370efd9e38$export$e0d4c7b70ee632dc = (t)=>typeof t == "string" && $3aa9c1370efd9e38$export$9e0669c13468e662.test(t), $3aa9c1370efd9e38$export$a299b410962516a3 = /^[A-Za-z0-9][A-Za-z0-9_.:-]{0,127}$/, $3aa9c1370efd9e38$export$1da07d7bf185731c = (t)=>typeof t == "string" && $3aa9c1370efd9e38$export$a299b410962516a3.test(t);

});


parcelRegister("3DuSb", function(module, exports) {

var $jaOyK = parcelRequire("jaOyK");

var $2c3Au = parcelRequire("2c3Au");
let $2a5cf65066b1a836$var$n = null;
const $2a5cf65066b1a836$var$c = ()=>{
    try {
        return {
            path: location.pathname + location.search,
            title: typeof document < "u" && document.title || void 0,
            referrer: typeof document < "u" && document.referrer || void 0
        };
    } catch  {
        return {};
    }
}, $2a5cf65066b1a836$export$d1756ea37d9dd993 = (t = {})=>{
    if ($2a5cf65066b1a836$var$n) return $2a5cf65066b1a836$var$n;
    if (typeof window > "u") return null;
    const e = (0, $jaOyK.createAnalyzing)({
        mode: "public",
        kind: "project",
        appKey: t.projectId || t.domain || (typeof location < "u" ? location.host : "public"),
        projectId: t.projectId || void 0,
        workspaceId: t.workspaceId || void 0,
        projectEnv: t.projectEnv || "production",
        domain: t.domain || void 0,
        ingestUrl: t.ingestUrl || "/v1/analytics/ingest",
        batchMs: typeof t.batchMs == "number" ? t.batchMs : 5e3,
        ...t.visitor === !1 || t.visitor === "false" ? {
            visitor: !1
        } : {},
        ...typeof t.sessionTimeoutMs == "number" ? {
            sessionTimeoutMs: t.sessionTimeoutMs
        } : {}
    });
    $2a5cf65066b1a836$var$n = e;
    try {
        typeof e.state?.activate == "function" && e.state.activate(null);
    } catch  {}
    try {
        e.capture("info", "page_view", $2a5cf65066b1a836$var$c());
    } catch  {}
    try {
        const i = ()=>{
            try {
                e.capture("info", "page_view", $2a5cf65066b1a836$var$c());
            } catch  {}
        }, r = (a)=>{
            const o = history[a];
            if (typeof o != "function" || o.__analyzingWrapped) return;
            const s = function(...p) {
                const d = o.apply(this, p);
                return i(), d;
            };
            s.__analyzingWrapped = !0, history[a] = s;
        };
        r("pushState"), r("replaceState"), window.addEventListener("popstate", i);
    } catch  {}
    try {
        window.addEventListener("pagehide", ()=>{
            try {
                e.flush();
            } catch  {}
        });
    } catch  {}
    try {
        (0, $2c3Au.installPageHandle)(e);
    } catch  {}
    return e;
}, $2a5cf65066b1a836$export$577cbcc2aa3f7c73 = ()=>{
    $2a5cf65066b1a836$var$n = null;
};

});
parcelRegister("2c3Au", function(module, exports) {

$parcel$export(module.exports, "installPageHandle", () => $198f7c2cf5d10393$export$bac98599eae5e950);

var $52ggo = parcelRequire("52ggo");
const $198f7c2cf5d10393$export$3fd168e7be670a9c = "SymbolsAnalytics", $198f7c2cf5d10393$export$6593eb69d2d26000 = 2, $198f7c2cf5d10393$export$e2481030cf2a3a10 = Object.freeze([
    "view_item",
    "add_to_cart",
    "begin_checkout",
    "purchase"
]), $198f7c2cf5d10393$export$18ee05d10be8cd73 = Object.freeze([
    "funnel.ask",
    "funnel.answer",
    "funnel.blueprint",
    "funnel.make_real",
    "funnel.signup",
    "funnel.signup_error",
    "funnel.workspace_ready",
    "funnel.provision_error"
]), $198f7c2cf5d10393$export$b11b5ec02d41a7ee = "funnel.alias", $198f7c2cf5d10393$export$8761a0048c2bf7a0 = Object.freeze([
    "funnel.arrived",
    "funnel.activated",
    "funnel.paid",
    "funnel.lead"
]), $198f7c2cf5d10393$export$7e6abface7fc595b = Object.freeze([
    ...$198f7c2cf5d10393$export$e2481030cf2a3a10,
    ...$198f7c2cf5d10393$export$18ee05d10be8cd73,
    $198f7c2cf5d10393$export$b11b5ec02d41a7ee
]), $198f7c2cf5d10393$export$414474ae1a85ebb5 = Object.freeze({
    maxKeys: 16,
    maxStringLength: 200,
    maxBytes: 2048,
    maxEventsPerPage: 100,
    maxQueued: 50,
    maxAliasPerPage: 1
}), $198f7c2cf5d10393$var$L = new Set($198f7c2cf5d10393$export$7e6abface7fc595b), $198f7c2cf5d10393$var$z = new Set([
    "error",
    "warn",
    "info",
    "debug",
    "trace"
]), $198f7c2cf5d10393$var$O = /^[A-Za-z][A-Za-z0-9_]{0,39}$/, $198f7c2cf5d10393$export$481d3d45ac6c6141 = (e)=>{
    if (e == null) return {};
    if (typeof e != "object" || Array.isArray(e)) return null;
    const n = {};
    let r = 0;
    for (const s of Object.keys(e)){
        if (!$198f7c2cf5d10393$var$O.test(s) || (0, $52ggo.isPersonalKey)(s)) continue;
        const t = e[s];
        let o;
        if (t === null || typeof t == "boolean") o = t;
        else if (typeof t == "number") {
            if (!Number.isFinite(t)) continue;
            o = t;
        } else if (typeof t == "string") {
            if ((0, $52ggo.looksLikeEmail)(t)) continue;
            o = t.slice(0, $198f7c2cf5d10393$export$414474ae1a85ebb5.maxStringLength);
        } else continue;
        if (r += 1, r > $198f7c2cf5d10393$export$414474ae1a85ebb5.maxKeys) return null;
        n[s] = o;
    }
    let u = 0;
    try {
        u = JSON.stringify(n).length;
    } catch  {
        return null;
    }
    return u > $198f7c2cf5d10393$export$414474ae1a85ebb5.maxBytes ? null : n;
}, $198f7c2cf5d10393$export$2ba950d90aac0f84 = (e, n)=>{
    if (!(0, $52ggo.isOpaqueId)(n) || !e || typeof e != "object" || Array.isArray(e)) return null;
    const r = e.from;
    return !(0, $52ggo.isOpaqueId)(r) || r === n ? null : {
        from: r
    };
}, $198f7c2cf5d10393$var$w = (e)=>{
    try {
        const n = e.visitorId;
        return (0, $52ggo.isOpaqueId)(n) ? n : null;
    } catch  {
        return null;
    }
}, $198f7c2cf5d10393$export$bac98599eae5e950 = (e, { win: n } = {})=>{
    const r = n || (typeof window < "u" ? window : null);
    if (!r || !e || typeof e.capture != "function") return null;
    const u = $198f7c2cf5d10393$var$w(e);
    let s = 0, t = 0;
    const o = (i, E, P)=>{
        let a = i, p = E;
        if (typeof i == "string" && $198f7c2cf5d10393$var$z.has(i) && typeof E == "string" && (a = E, p = P), typeof a != "string" || !$198f7c2cf5d10393$var$L.has(a) || s >= $198f7c2cf5d10393$export$414474ae1a85ebb5.maxEventsPerPage) return !1;
        const y = a === $198f7c2cf5d10393$export$b11b5ec02d41a7ee;
        if (y && t >= $198f7c2cf5d10393$export$414474ae1a85ebb5.maxAliasPerPage) return !1;
        const _ = y ? $198f7c2cf5d10393$export$2ba950d90aac0f84(p, u) : $198f7c2cf5d10393$export$481d3d45ac6c6141(p);
        if (!_) return !1;
        try {
            e.capture("info", a, _);
        } catch  {
            return !1;
        }
        return s += 1, y && (t += 1), !0;
    }, A = Object.freeze({
        version: $198f7c2cf5d10393$export$6593eb69d2d26000,
        events: $198f7c2cf5d10393$export$7e6abface7fc595b,
        visitorId: u,
        capture: o
    }), f = r[$198f7c2cf5d10393$export$3fd168e7be670a9c], g = f && Array.isArray(f.q) ? f.q.slice(0, $198f7c2cf5d10393$export$414474ae1a85ebb5.maxQueued) : [];
    try {
        r[$198f7c2cf5d10393$export$3fd168e7be670a9c] = A;
    } catch  {
        return null;
    }
    for (const i of g)try {
        Array.isArray(i) && o(...i);
    } catch  {}
    return A;
};

});




parcelRegister("eny6R", function(module, exports) {

$parcel$export(module.exports, "WaitlistService", () => $a77dac25db2a8887$export$7a38ec7374e07424);

var $em51x = parcelRequire("em51x");
class $a77dac25db2a8887$export$7a38ec7374e07424 extends (0, $em51x.BaseService) {
    async joinWaitlist(e = {}) {
        if (this._requireReady("joinWaitlist"), !e || typeof e != "object") throw new Error("Waitlist join payload is required");
        if (!e.email) throw new Error("Email is required");
        try {
            const t = await this._request("/waitlist", {
                method: "POST",
                body: JSON.stringify(e),
                methodName: "joinWaitlist"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to join waitlist: ${t.message}`, {
                cause: t
            });
        }
    }
    async listWaitlistEntries(e = {}) {
        this._requireReady("listWaitlistEntries");
        const { campaignKey: t, status: i, search: a, page: n, limit: o } = e || {}, r = new URLSearchParams;
        t != null && r.append("campaignKey", String(t)), i != null && r.append("status", String(i)), a != null && r.append("search", String(a)), n != null && r.append("page", String(n)), o != null && r.append("limit", String(o));
        const l = r.toString();
        try {
            const s = l ? await this._request(`/waitlist?${l}`, {
                method: "GET",
                methodName: "listWaitlistEntries"
            }) : await this._request("/waitlist", {
                method: "GET",
                methodName: "listWaitlistEntries"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to list waitlist entries: ${s.message}`, {
                cause: s
            });
        }
    }
    async updateWaitlistEntry(e, t = {}) {
        if (this._requireReady("updateWaitlistEntry"), !e) throw new Error("Waitlist entry ID is required");
        if (!t || typeof t != "object") throw new Error("Update payload is required");
        try {
            const i = await this._request(`/waitlist/${e}`, {
                method: "PATCH",
                body: JSON.stringify(t),
                methodName: "updateWaitlistEntry"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to update waitlist entry: ${i.message}`, {
                cause: i
            });
        }
    }
    async inviteWaitlistEntry(e) {
        if (this._requireReady("inviteWaitlistEntry"), !e) throw new Error("Waitlist entry ID is required");
        try {
            const t = await this._request(`/waitlist/${e}/invite`, {
                method: "POST",
                methodName: "inviteWaitlistEntry"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to invite waitlist entry: ${t.message}`, {
                cause: t
            });
        }
    }
}

});

parcelRegister("i8omg", function(module, exports) {

$parcel$export(module.exports, "OnboardingResearchService", () => $d33bde55c890a0c2$export$11abcaf926198b10);

var $em51x = parcelRequire("em51x");
const $d33bde55c890a0c2$var$a = (i)=>{
    const e = i?.cause && typeof i.cause == "object" ? i.cause : null;
    return e && !i.code && (i.code = e.code || e.error || null), i;
};
class $d33bde55c890a0c2$export$11abcaf926198b10 extends (0, $em51x.BaseService) {
    async getOnboardingConfig() {
        try {
            return await this._call("getOnboardingConfig", "/onboarding/config");
        } catch (e) {
            throw $d33bde55c890a0c2$var$a(e);
        }
    }
    async startResearch({ url: e } = {}) {
        if (!e || typeof e != "string") throw new Error("url is required");
        try {
            return await this._request("/onboarding/research", {
                method: "POST",
                body: JSON.stringify({
                    url: e
                }),
                methodName: "startResearch"
            });
        } catch (r) {
            throw $d33bde55c890a0c2$var$a(r);
        }
    }
    async getResearch(e) {
        if (!e) throw new Error("id is required");
        try {
            return await this._request(`/onboarding/research/${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "getResearch"
            });
        } catch (r) {
            throw $d33bde55c890a0c2$var$a(r);
        }
    }
    streamResearch(e, r) {
        if (!e) throw new Error("id is required");
        if (typeof r != "function") throw new Error("onEvent must be a function");
        let o = !1, n = null;
        const s = ()=>{
            o = !0, n && n();
        };
        return n = this._sseSubscribe(`/onboarding/research/${encodeURIComponent(e)}/stream`, {}, (t)=>{
            o || (r(t), (t.type === "done" || t.type === "failed") && s());
        }, {
            anonymous: !0,
            events: [
                {
                    name: "finding",
                    frame: (t)=>({
                            type: "finding",
                            finding: t
                        })
                },
                {
                    name: "done",
                    frame: (t)=>({
                            type: "done",
                            profile: t?.profile ?? null
                        })
                },
                {
                    name: "failed",
                    frame: (t)=>({
                            type: "failed",
                            code: t?.code || "failed"
                        })
                }
            ]
        }), o && n(), ()=>s();
    }
    _onboardingWorkspace(e) {
        const r = this._resolveWorkspaceId(e);
        if (!r) throw new Error("workspaceId is required");
        return encodeURIComponent(r);
    }
    async getOnboardingBuild(e) {
        const r = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/build?workspaceId=${r}`, {
                method: "GET",
                methodName: "getOnboardingBuild"
            });
        } catch (o) {
            throw $d33bde55c890a0c2$var$a(o);
        }
    }
    async retryOnboardingBuildStep(e, r) {
        if (!r) throw new Error("key is required");
        const o = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/build/${encodeURIComponent(r)}/retry?workspaceId=${o}`, {
                method: "POST",
                methodName: "retryOnboardingBuildStep"
            });
        } catch (n) {
            throw $d33bde55c890a0c2$var$a(n);
        }
    }
    async markOnboardingProfileReviewed(e) {
        const r = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/build/profile/reviewed?workspaceId=${r}`, {
                method: "POST",
                methodName: "markOnboardingProfileReviewed"
            });
        } catch (o) {
            throw $d33bde55c890a0c2$var$a(o);
        }
    }
    async deleteOnboardingResearch(e) {
        const r = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/workspace-research?workspaceId=${r}`, {
                method: "DELETE",
                methodName: "deleteOnboardingResearch"
            });
        } catch (o) {
            throw $d33bde55c890a0c2$var$a(o);
        }
    }
    async deleteOnboardingResearchLine(e, r) {
        if (!r) throw new Error("line is required");
        const o = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/workspace-research/lines/${encodeURIComponent(r)}?workspaceId=${o}`, {
                method: "DELETE",
                methodName: "deleteOnboardingResearchLine"
            });
        } catch (n) {
            throw $d33bde55c890a0c2$var$a(n);
        }
    }
    async listOnboardingPeople(e) {
        const r = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/people?workspaceId=${r}`, {
                method: "GET",
                methodName: "listOnboardingPeople"
            });
        } catch (o) {
            throw $d33bde55c890a0c2$var$a(o);
        }
    }
    async removeOnboardingPerson(e, r) {
        if (!r) throw new Error("personId is required");
        const o = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/people/${encodeURIComponent(r)}?workspaceId=${o}`, {
                method: "DELETE",
                methodName: "removeOnboardingPerson"
            });
        } catch (n) {
            throw $d33bde55c890a0c2$var$a(n);
        }
    }
    async inviteOnboardingPerson(e, r, { email: o, recipientName: n } = {}) {
        if (!r) throw new Error("personId is required");
        if (!o) throw new Error("email is required");
        const s = this._onboardingWorkspace(e);
        try {
            return await this._request(`/onboarding/people/${encodeURIComponent(r)}/invite?workspaceId=${s}`, {
                method: "POST",
                body: JSON.stringify({
                    email: o,
                    ...n ? {
                        recipientName: n
                    } : {}
                }),
                methodName: "inviteOnboardingPerson"
            });
        } catch (t) {
            throw $d33bde55c890a0c2$var$a(t);
        }
    }
}

});

parcelRegister("6Lnup", function(module, exports) {

$parcel$export(module.exports, "ImportsService", () => $4ec95a60638f188a$export$74e5c6da20a36c00);

var $em51x = parcelRequire("em51x");
const $4ec95a60638f188a$var$d = (o)=>{
    const t = o?.cause && typeof o.cause == "object" ? o.cause : null;
    return t && !o.code && (o.code = t.error || t.code || null), o;
}, $4ec95a60638f188a$var$n = (o)=>o && typeof o == "object" && "success" in o && "data" in o ? o.data : o, $4ec95a60638f188a$var$s = (o, t)=>{
    if (o == null || o === "") throw new Error(`${t} is required`);
    return encodeURIComponent(String(o));
};
class $4ec95a60638f188a$export$74e5c6da20a36c00 extends (0, $em51x.BaseService) {
    async _imports(t, r) {
        this._requireReady(t);
        try {
            return $4ec95a60638f188a$var$n(await r());
        } catch (e) {
            throw $4ec95a60638f188a$var$d(e);
        }
    }
    async listImportSources(t) {
        const r = $4ec95a60638f188a$var$s(t, "workspaceId");
        return this._imports("listImportSources", ()=>this._request(`/workspaces/${r}/imports/sources`, {
                method: "GET",
                methodName: "listImportSources"
            }));
    }
    async listImportTargets(t) {
        const r = $4ec95a60638f188a$var$s(t, "workspaceId");
        return this._imports("listImportTargets", ()=>this._request(`/workspaces/${r}/imports/targets`, {
                method: "GET",
                methodName: "listImportTargets"
            }));
    }
    async uploadImportFile(t, r) {
        const e = $4ec95a60638f188a$var$s(t, "workspaceId");
        if (!r) throw new Error("file is required");
        const i = new FormData;
        return i.append("file", r), this._imports("uploadImportFile", ()=>this._request(`/workspaces/${e}/imports/upload`, {
                method: "POST",
                body: i,
                methodName: "uploadImportFile"
            }));
    }
    async previewImport(t, r = {}) {
        const e = $4ec95a60638f188a$var$s(t, "workspaceId");
        if (!r || typeof r != "object" || !r.fileId && !r.sourceId) throw new Error("fileId or sourceId is required");
        return this._imports("previewImport", ()=>this._request(`/workspaces/${e}/imports/preview`, {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "previewImport"
            }));
    }
    async runImport(t, { previewId: r, target: e, mapping: i } = {}) {
        const p = $4ec95a60638f188a$var$s(t, "workspaceId");
        if (!r) throw new Error("previewId is required");
        if (!e || typeof e != "object") throw new Error("target is required");
        return this._imports("runImport", ()=>this._request(`/workspaces/${p}/imports/run`, {
                method: "POST",
                body: JSON.stringify({
                    previewId: r,
                    target: e,
                    mapping: i || {}
                }),
                methodName: "runImport"
            }));
    }
    async getImport(t, r) {
        const e = $4ec95a60638f188a$var$s(t, "workspaceId"), i = $4ec95a60638f188a$var$s(r, "importId");
        return this._imports("getImport", ()=>this._request(`/workspaces/${e}/imports/${i}`, {
                method: "GET",
                methodName: "getImport"
            }));
    }
    async undoImport(t, r) {
        const e = $4ec95a60638f188a$var$s(t, "workspaceId"), i = $4ec95a60638f188a$var$s(r, "importId");
        return this._imports("undoImport", ()=>this._request(`/workspaces/${e}/imports/${i}`, {
                method: "DELETE",
                methodName: "undoImport"
            }));
    }
}

});

parcelRegister("cDyZB", function(module, exports) {

$parcel$export(module.exports, "MetricsService", () => $9334455d69d865f4$export$cb2a16d841bb29e6);

var $em51x = parcelRequire("em51x");
class $9334455d69d865f4$export$cb2a16d841bb29e6 extends (0, $em51x.BaseService) {
    async getContributions(r = {}) {
        this._requireReady("getContributions");
        const { projectId: s, userId: o, from: i, to: n } = r || {}, e = new URLSearchParams;
        s != null && e.append("projectId", String(s)), o != null && e.append("userId", String(o)), i != null && e.append("from", String(i)), n != null && e.append("to", String(n));
        const a = e.toString();
        try {
            const t = a ? await this._request(`/metrics/contributions?${a}`, {
                method: "GET",
                methodName: "getContributions"
            }) : await this._request("/metrics/contributions", {
                method: "GET",
                methodName: "getContributions"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to get contribution stats: ${t.message}`, {
                cause: t
            });
        }
    }
    async getProjectUsage(r) {
        if (!r) throw new Error("projectId is required");
        return this._call("getProjectUsage", `/usage/project/${r}`);
    }
}

});

parcelRegister("bRZWw", function(module, exports) {

$parcel$export(module.exports, "IntegrationService", () => $8a44b184fb36b748$export$9f9ef90f79cbeaf4);

var $em51x = parcelRequire("em51x");
class $8a44b184fb36b748$export$9f9ef90f79cbeaf4 extends (0, $em51x.BaseService) {
    async integrationWhoami(r, t = {}) {
        if (this._requireReady("integrationWhoami"), !r) throw new Error("API key is required");
        const e = {
            "x-api-key": r,
            ...t.headers || {}
        };
        try {
            const i = await this._request("/integrations/whoami", {
                method: "GET",
                headers: e,
                methodName: "integrationWhoami"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to validate integration API key: ${i.message}`, {
                cause: i
            });
        }
    }
    async listIntegrations(r = {}) {
        this._requireReady("listIntegrations");
        const { orgId: t, projectId: e } = r || {}, i = new URLSearchParams;
        t != null && i.append("orgId", String(t)), e != null && i.append("projectId", String(e));
        const o = i.toString();
        try {
            const n = o ? await this._request(`/integrations?${o}`, {
                method: "GET",
                methodName: "listIntegrations"
            }) : await this._request("/integrations", {
                method: "GET",
                methodName: "listIntegrations"
            });
            if (n.success) return n.data;
            throw new Error(n.message);
        } catch (n) {
            throw new Error(`Failed to list integrations: ${n.message}`, {
                cause: n
            });
        }
    }
    async createIntegration(r = {}) {
        if (this._requireReady("createIntegration"), !r || typeof r != "object") throw new Error("Integration payload is required");
        if (!r.name) throw new Error("Integration name is required");
        if (!r.ownerType) throw new Error("ownerType is required");
        try {
            const t = await this._request("/integrations", {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "createIntegration"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to create integration: ${t.message}`, {
                cause: t
            });
        }
    }
    async updateIntegration(r, t = {}) {
        if (this._requireReady("updateIntegration"), !r) throw new Error("Integration ID is required");
        if (!t || typeof t != "object") throw new Error("Update payload is required");
        try {
            const e = await this._request(`/integrations/${r}`, {
                method: "PATCH",
                body: JSON.stringify(t),
                methodName: "updateIntegration"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to update integration: ${e.message}`, {
                cause: e
            });
        }
    }
    async createIntegrationApiKey(r, t = {}) {
        if (this._requireReady("createIntegrationApiKey"), !r) throw new Error("Integration ID is required");
        if (!t || typeof t != "object") throw new Error("API key payload is required");
        try {
            const e = await this._request(`/integrations/${r}/api-keys`, {
                method: "POST",
                body: JSON.stringify(t),
                methodName: "createIntegrationApiKey"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to create integration API key: ${e.message}`, {
                cause: e
            });
        }
    }
    async listIntegrationApiKeys(r) {
        if (this._requireReady("listIntegrationApiKeys"), !r) throw new Error("Integration ID is required");
        try {
            const t = await this._request(`/integrations/${r}/api-keys`, {
                method: "GET",
                methodName: "listIntegrationApiKeys"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to list integration API keys: ${t.message}`, {
                cause: t
            });
        }
    }
    async revokeIntegrationApiKey(r, t) {
        if (this._requireReady("revokeIntegrationApiKey"), !r) throw new Error("Integration ID is required");
        if (!t) throw new Error("API key ID is required");
        try {
            const e = await this._request(`/integrations/${r}/api-keys/${t}/revoke`, {
                method: "POST",
                methodName: "revokeIntegrationApiKey"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to revoke integration API key: ${e.message}`, {
                cause: e
            });
        }
    }
    async createIntegrationWebhook(r, t = {}) {
        if (this._requireReady("createIntegrationWebhook"), !r) throw new Error("Integration ID is required");
        if (!t || typeof t != "object") throw new Error("Webhook payload is required");
        try {
            const e = await this._request(`/integrations/${r}/webhooks`, {
                method: "POST",
                body: JSON.stringify(t),
                methodName: "createIntegrationWebhook"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to create integration webhook: ${e.message}`, {
                cause: e
            });
        }
    }
    async listIntegrationWebhooks(r) {
        if (this._requireReady("listIntegrationWebhooks"), !r) throw new Error("Integration ID is required");
        try {
            const t = await this._request(`/integrations/${r}/webhooks`, {
                method: "GET",
                methodName: "listIntegrationWebhooks"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to list integration webhooks: ${t.message}`, {
                cause: t
            });
        }
    }
    async updateIntegrationWebhook(r, t, e = {}) {
        if (this._requireReady("updateIntegrationWebhook"), !r) throw new Error("Integration ID is required");
        if (!t) throw new Error("Webhook ID is required");
        if (!e || typeof e != "object") throw new Error("Update payload is required");
        try {
            const i = await this._request(`/integrations/${r}/webhooks/${t}`, {
                method: "PATCH",
                body: JSON.stringify(e),
                methodName: "updateIntegrationWebhook"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to update integration webhook: ${i.message}`, {
                cause: i
            });
        }
    }
    async deleteIntegrationWebhook(r, t) {
        if (this._requireReady("deleteIntegrationWebhook"), !r) throw new Error("Integration ID is required");
        if (!t) throw new Error("Webhook ID is required");
        try {
            const e = await this._request(`/integrations/${r}/webhooks/${t}`, {
                method: "DELETE",
                methodName: "deleteIntegrationWebhook"
            });
            if (e && e.success) return e.data;
            if (e == null) return null;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to delete integration webhook: ${e.message}`, {
                cause: e
            });
        }
    }
    async listIntegrationWebhookDeliveries(r, t, e = {}) {
        if (this._requireReady("listIntegrationWebhookDeliveries"), !r) throw new Error("Integration ID is required");
        if (!t) throw new Error("Webhook ID is required");
        const { page: i, limit: o, status: n, includePayload: h } = e || {}, a = new URLSearchParams;
        i != null && a.append("page", String(i)), o != null && a.append("limit", String(o)), n != null && a.append("status", String(n)), h != null && a.append("includePayload", String(h));
        const c = a.toString();
        try {
            const s = c ? await this._request(`/integrations/${r}/webhooks/${t}/deliveries?${c}`, {
                method: "GET",
                methodName: "listIntegrationWebhookDeliveries"
            }) : await this._request(`/integrations/${r}/webhooks/${t}/deliveries`, {
                method: "GET",
                methodName: "listIntegrationWebhookDeliveries"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to list webhook deliveries: ${s.message}`, {
                cause: s
            });
        }
    }
    async replayIntegrationWebhookDelivery(r, t, e) {
        if (this._requireReady("replayIntegrationWebhookDelivery"), !r) throw new Error("Integration ID is required");
        if (!t) throw new Error("Webhook ID is required");
        if (!e) throw new Error("deliveryId is required");
        try {
            const i = await this._request(`/integrations/${r}/webhooks/${t}/replay`, {
                method: "POST",
                body: JSON.stringify({
                    deliveryId: e
                }),
                methodName: "replayIntegrationWebhookDelivery"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to replay webhook delivery: ${i.message}`, {
                cause: i
            });
        }
    }
    async listGitHubConnectors(r) {
        if (this._requireReady("listGitHubConnectors"), !r) throw new Error("Integration ID is required");
        try {
            const t = await this._request(`/integrations/${r}/connectors/github`, {
                method: "GET",
                methodName: "listGitHubConnectors"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to list GitHub connectors: ${t.message}`, {
                cause: t
            });
        }
    }
    async createGitHubConnector(r, t = {}) {
        if (this._requireReady("createGitHubConnector"), !r) throw new Error("Integration ID is required");
        if (!t || typeof t != "object") throw new Error("Connector payload is required");
        if (!t.projectId) throw new Error("projectId is required");
        if (!t.repository) throw new Error("repository is required");
        try {
            const e = await this._request(`/integrations/${r}/connectors/github`, {
                method: "POST",
                body: JSON.stringify(t),
                methodName: "createGitHubConnector"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to create GitHub connector: ${e.message}`, {
                cause: e
            });
        }
    }
    async updateGitHubConnector(r, t, e = {}) {
        if (this._requireReady("updateGitHubConnector"), !r) throw new Error("Integration ID is required");
        if (!t) throw new Error("Connector ID is required");
        if (!e || typeof e != "object") throw new Error("Update payload is required");
        try {
            const i = await this._request(`/integrations/${r}/connectors/github/${t}`, {
                method: "PATCH",
                body: JSON.stringify(e),
                methodName: "updateGitHubConnector"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to update GitHub connector: ${i.message}`, {
                cause: i
            });
        }
    }
    async deleteGitHubConnector(r, t) {
        if (this._requireReady("deleteGitHubConnector"), !r) throw new Error("Integration ID is required");
        if (!t) throw new Error("Connector ID is required");
        try {
            const e = await this._request(`/integrations/${r}/connectors/github/${t}`, {
                method: "DELETE",
                methodName: "deleteGitHubConnector"
            });
            if (e && e.success) return e.data;
            if (e == null) return null;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to delete GitHub connector: ${e.message}`, {
                cause: e
            });
        }
    }
    async getGitHubRepo({ owner: r, repo: t } = {}) {
        if (this._requireReady("getGitHubRepo"), !r) throw new Error("owner is required");
        if (!t) throw new Error("repo is required");
        const e = new URLSearchParams;
        e.append("owner", String(r)), e.append("repo", String(t));
        try {
            const i = await this._request(`/integrations/github/repo?${e.toString()}`, {
                method: "GET",
                methodName: "getGitHubRepo"
            });
            if (i.success) return i.data;
            throw new Error(i.message);
        } catch (i) {
            throw new Error(`Failed to get GitHub repo: ${i.message}`, {
                cause: i
            });
        }
    }
    async listGitHubRepos({ orgId: r } = {}) {
        if (this._requireReady("listGitHubRepos"), !r) throw new Error("orgId is required");
        const t = new URLSearchParams;
        t.append("orgId", String(r));
        try {
            const e = await this._request(`/integrations/github/repos?${t.toString()}`, {
                method: "GET",
                methodName: "listGitHubRepos"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to list GitHub repos: ${e.message}`, {
                cause: e
            });
        }
    }
    listOrgIntegrations({ orgId: r, scopeType: t, scopeId: e, includeParents: i } = {}) {
        if (!r) throw new Error("orgId is required");
        const o = new URLSearchParams;
        return o.set("orgId", String(r)), t !== void 0 && o.set("scopeType", String(t)), e !== void 0 && o.set("scopeId", String(e)), i !== void 0 && o.set("includeParents", String(i)), this._call("listOrgIntegrations", `/org-integrations?${o.toString()}`);
    }
    upsertOrgIntegration(r = {}) {
        if (!r.orgId) throw new Error("orgId is required");
        if (!r.kind) throw new Error("kind is required");
        return this._call("upsertOrgIntegration", "/org-integrations", {
            method: "POST",
            body: r
        });
    }
    deleteOrgIntegration({ orgId: r, kind: t, slug: e, scopeType: i, scopeId: o } = {}) {
        if (!r) throw new Error("orgId is required");
        if (!t) throw new Error("kind is required");
        const n = {
            orgId: r,
            kind: t
        };
        return e !== void 0 && (n.slug = e), i !== void 0 && (n.scopeType = i), o !== void 0 && (n.scopeId = o), this._call("deleteOrgIntegration", "/org-integrations", {
            method: "DELETE",
            body: n
        });
    }
    assignOrgIntegrationScope(r = {}) {
        if (!r.orgId) throw new Error("orgId is required");
        if (!r.kind) throw new Error("kind is required");
        return this._call("assignOrgIntegrationScope", "/org-integrations/assign-scope", {
            method: "POST",
            body: r
        });
    }
    reorderOrgIntegrations(r = {}) {
        if (!r.orgId) throw new Error("orgId is required");
        if (!r.kind) throw new Error("kind is required");
        return this._call("reorderOrgIntegrations", "/org-integrations/reorder", {
            method: "POST",
            body: r
        });
    }
    listOrgIntegrationKinds() {
        return this._call("listOrgIntegrationKinds", "/org-integrations/kinds");
    }
    getIntegrationsCatalog() {
        return this._call("getIntegrationsCatalog", "/integrations/catalog");
    }
    callOrgIntegrationCapability({ orgId: r, idOrSlug: t, kind: e, capability: i, args: o, workspaceId: n, slug: h, scopeType: a, scopeId: c } = {}) {
        if (!r) throw new Error("orgId is required");
        if (!i) throw new Error("capability is required");
        const s = {
            orgId: r,
            capability: i
        };
        if (o !== void 0 && (s.args = o), n !== void 0 && (s.workspaceId = n), t) return e !== void 0 && (s.kind = e), this._call("callOrgIntegrationCapability", `/org-integrations/${t}/call`, {
            method: "POST",
            body: s
        });
        if (!e) throw new Error("kind is required when idOrSlug is not provided");
        return s.kind = e, h !== void 0 && (s.slug = h), a !== void 0 && (s.scopeType = a), c !== void 0 && (s.scopeId = c), this._call("callOrgIntegrationCapability", "/org-integrations/call", {
            method: "POST",
            body: s
        });
    }
    async syncGitHubIntegration({ orgId: r, slug: t = "default", scopeType: e = "org", scopeId: i = null } = {}) {
        if (this._requireReady("syncGitHubIntegration"), !r) throw new Error("orgId is required");
        try {
            const o = await this._request("/integrations/github/sync", {
                method: "POST",
                body: JSON.stringify({
                    orgId: r,
                    slug: t,
                    scopeType: e,
                    scopeId: i
                }),
                methodName: "syncGitHubIntegration"
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to sync GitHub integration: ${o.message}`, {
                cause: o
            });
        }
    }
    listMarketplaceEntitlements(r, { status: t } = {}) {
        if (!r) throw new Error("workspaceId is required");
        const e = new URLSearchParams;
        return e.set("workspaceId", String(r)), t !== void 0 && e.set("status", String(t)), this._call("listMarketplaceEntitlements", `/marketplace/integrations/entitlements?${e.toString()}`);
    }
    checkMarketplaceEntitlement({ workspaceId: r, kind: t } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!t) throw new Error("kind is required");
        const e = new URLSearchParams;
        return e.set("workspaceId", String(r)), e.set("kind", String(t)), this._call("checkMarketplaceEntitlement", `/marketplace/integrations/entitlement-check?${e.toString()}`);
    }
    installMarketplaceIntegration(r = {}) {
        if (!r.orgId) throw new Error("orgId is required");
        if (!r.workspaceId) throw new Error("workspaceId is required");
        if (!r.kind) throw new Error("kind is required");
        return this._call("installMarketplaceIntegration", "/marketplace/integrations/install", {
            method: "POST",
            body: r
        });
    }
    uninstallMarketplaceIntegration(r = {}) {
        if (!r.orgId) throw new Error("orgId is required");
        if (!r.workspaceId) throw new Error("workspaceId is required");
        if (!r.kind) throw new Error("kind is required");
        return this._call("uninstallMarketplaceIntegration", "/marketplace/integrations/uninstall", {
            method: "POST",
            body: r
        });
    }
}

});

parcelRegister("ko4Dy", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagService", () => $ed79a55c4785d6f4$export$66565c155d0da0d4);

var $em51x = parcelRequire("em51x");
function $ed79a55c4785d6f4$var$u(n) {
    if (!n) return null;
    if (Array.isArray(n)) {
        const t = n.flatMap((a)=>String(a).split(",")).map((a)=>a.trim()).filter(Boolean);
        return t.length ? t.join(",") : null;
    }
    const r = String(n).split(",").map((e)=>e.trim()).filter(Boolean);
    return r.length ? r.join(",") : null;
}
class $ed79a55c4785d6f4$export$66565c155d0da0d4 extends (0, $em51x.BaseService) {
    async getFeatureFlags(r = {}) {
        this._requireReady("getFeatureFlags");
        const { keys: e } = r || {}, t = new URLSearchParams, a = $ed79a55c4785d6f4$var$u(e);
        a && t.append("keys", a);
        const s = t.toString();
        try {
            const o = s ? await this._request(`/feature-flags?${s}`, {
                method: "GET",
                methodName: "getFeatureFlags"
            }) : await this._request("/feature-flags", {
                method: "GET",
                methodName: "getFeatureFlags"
            });
            if (o.success) return o.data;
            throw new Error(o.message);
        } catch (o) {
            throw new Error(`Failed to get feature flags: ${o.message}`, {
                cause: o
            });
        }
    }
    async getFeatureFlag(r) {
        if (this._requireReady("getFeatureFlag"), !r) throw new Error("Feature flag key is required");
        try {
            const e = await this._request(`/feature-flags/${encodeURIComponent(String(r))}`, {
                method: "GET",
                methodName: "getFeatureFlag"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to get feature flag: ${e.message}`, {
                cause: e
            });
        }
    }
    async getAdminFeatureFlags(r = {}) {
        this._requireReady("getAdminFeatureFlags");
        const { includeArchived: e = !0 } = r || {}, t = new URLSearchParams;
        e === !1 && t.append("includeArchived", "false");
        const a = t.toString();
        try {
            const s = a ? await this._request(`/admin/feature-flags?${a}`, {
                method: "GET",
                methodName: "getAdminFeatureFlags"
            }) : await this._request("/admin/feature-flags", {
                method: "GET",
                methodName: "getAdminFeatureFlags"
            });
            if (s.success) return s.data;
            throw new Error(s.message);
        } catch (s) {
            throw new Error(`Failed to get admin feature flags: ${s.message}`, {
                cause: s
            });
        }
    }
    async createFeatureFlag(r) {
        if (this._requireReady("createFeatureFlag"), !r || typeof r != "object") throw new Error("Feature flag data is required");
        if (!r.key) throw new Error("Feature flag key is required");
        try {
            const e = await this._request("/admin/feature-flags", {
                method: "POST",
                body: JSON.stringify(r),
                methodName: "createFeatureFlag"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to create feature flag: ${e.message}`, {
                cause: e
            });
        }
    }
    async updateFeatureFlag(r, e) {
        if (this._requireReady("updateFeatureFlag"), !r) throw new Error("Feature flag id is required");
        if (!e || typeof e != "object") throw new Error("Feature flag patch is required");
        try {
            const t = await this._request(`/admin/feature-flags/${encodeURIComponent(String(r))}`, {
                method: "PATCH",
                body: JSON.stringify(e),
                methodName: "updateFeatureFlag"
            });
            if (t.success) return t.data;
            throw new Error(t.message);
        } catch (t) {
            throw new Error(`Failed to update feature flag: ${t.message}`, {
                cause: t
            });
        }
    }
    async archiveFeatureFlag(r) {
        if (this._requireReady("archiveFeatureFlag"), !r) throw new Error("Feature flag id is required");
        try {
            const e = await this._request(`/admin/feature-flags/${encodeURIComponent(String(r))}`, {
                method: "DELETE",
                methodName: "archiveFeatureFlag"
            });
            if (e.success) return e.data;
            throw new Error(e.message);
        } catch (e) {
            throw new Error(`Failed to archive feature flag: ${e.message}`, {
                cause: e
            });
        }
    }
}

});

parcelRegister("hZpeq", function(module, exports) {

$parcel$export(module.exports, "OrganizationService", () => $d18bb4a64c83f498$export$abbf95a02a0c9d38);

var $em51x = parcelRequire("em51x");

var $h5XS2 = parcelRequire("h5XS2");
class $d18bb4a64c83f498$export$abbf95a02a0c9d38 extends (0, $em51x.BaseService) {
    async createOrganization({ name: e, slug: r }) {
        if (this._requireReady("createOrganization"), !e || !r) throw new Error("name and slug are required");
        const t = await this._request("/organizations", {
            method: "POST",
            body: JSON.stringify({
                name: e,
                slug: r
            }),
            methodName: "createOrganization"
        });
        if (t.success) return this._createSubdomainRecords(r).catch((s)=>{
            (0, $h5XS2.logger).warn("Failed to create DNS records for organization:", s?.message || s);
        }), t.data;
        throw new Error(t.message);
    }
    async listOrganizations() {
        this._requireReady("listOrganizations");
        const e = await this._request("/organizations", {
            method: "GET",
            methodName: "listOrganizations"
        });
        if (e.success) return e.data;
        throw new Error(e.message);
    }
    async checkOrganizationSlug(e) {
        if (this._requireReady("checkOrganizationSlug"), !e) return null;
        try {
            const r = await this._request(`/organizations?slug=${encodeURIComponent(e)}&_check=1`, {
                method: "GET",
                methodName: "checkOrganizationSlug"
            });
            if (r?.success === !1) return null;
            const t = r?.data ?? r, s = String(e).toLowerCase(), a = (i)=>i && typeof i == "object" && String(i.slug || "").toLowerCase() === s;
            return Array.isArray(t) ? !t.some(a) : t && (t.id || t.slug) ? !a(t) : !0;
        } catch (r) {
            return r?.status === 404 ? !0 : null;
        }
    }
    async getOrganization(e) {
        if (this._requireReady("getOrganization"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}`, {
            method: "GET",
            methodName: "getOrganization"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async updateOrganization(e, r) {
        if (this._requireReady("updateOrganization"), !e) throw new Error("orgId is required");
        const t = await this._request(`/organizations/${e}`, {
            method: "PATCH",
            body: JSON.stringify(r),
            methodName: "updateOrganization"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async updateOrganizationBranding(e, r) {
        if (this._requireReady("updateOrganizationBranding"), !e) throw new Error("orgId is required");
        const t = await this._request(`/organizations/${e}/branding`, {
            method: "PATCH",
            body: JSON.stringify(r),
            methodName: "updateOrganizationBranding"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async transferOrgOwnership(e, { userId: r }) {
        if (this._requireReady("transferOrgOwnership"), !e) throw new Error("orgId is required");
        if (!r) throw new Error("userId is required");
        const t = await this._request(`/organizations/${e}/transfer-ownership`, {
            method: "POST",
            body: JSON.stringify({
                userId: r
            }),
            methodName: "transferOrgOwnership"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async deleteOrganization(e, r = {}) {
        if (this._requireReady("deleteOrganization"), !e) throw new Error("orgId is required");
        const { mode: t = "soft", dryRun: s = !1, cascade: a = !0 } = r, i = new URLSearchParams;
        t !== "soft" && i.set("mode", t), s && i.set("dryRun", "true");
        const d = i.toString(), o = d ? await this._request(`/organizations/${e}?${d}`, {
            method: "DELETE",
            methodName: "deleteOrganization"
        }) : await this._request(`/organizations/${e}`, {
            method: "DELETE",
            methodName: "deleteOrganization"
        });
        if (!o.success && o.error) return {
            ok: !1,
            deleted: !1,
            mode: t,
            dryRun: s,
            error: o.message || o.error
        };
        if (o.success === !1) throw new Error(o.message);
        const n = o.data ?? o;
        return t === "hard" && s ? {
            ok: !0,
            deleted: !1,
            mode: "hard",
            dryRun: !0,
            dryRunPlan: {
                projects: n.projects ?? [],
                usersAffected: n.members ?? n.orgMembers ?? 0,
                ...n
            }
        } : {
            ok: !0,
            deleted: !0,
            mode: t,
            dryRun: !1,
            data: n
        };
    }
    async listOrgMembers(e) {
        if (this._requireReady("listOrgMembers"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/members`, {
            method: "GET",
            methodName: "listOrgMembers"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async addOrgMember(e, { userId: r, role: t = "member" }) {
        if (this._requireReady("addOrgMember"), !e) throw new Error("orgId is required");
        if (!r) throw new Error("userId is required");
        const s = await this._request(`/organizations/${e}/members`, {
            method: "POST",
            body: JSON.stringify({
                userId: r,
                role: t
            }),
            methodName: "addOrgMember"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async updateOrgMember(e, r, { role: t }) {
        if (this._requireReady("updateOrgMember"), !e || !r) throw new Error("orgId and memberId are required");
        const s = await this._request(`/organizations/${e}/members/${r}`, {
            method: "PATCH",
            body: JSON.stringify({
                role: t
            }),
            methodName: "updateOrgMember"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async removeOrgMember(e, r) {
        if (this._requireReady("removeOrgMember"), !e || !r) throw new Error("orgId and memberId are required");
        const t = await this._request(`/organizations/${e}/members/${r}`, {
            method: "DELETE",
            methodName: "removeOrgMember"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async createTeam(e, { name: r, slug: t, parentTeam: s }) {
        if (this._requireReady("createTeam"), !e) throw new Error("orgId is required");
        if (!r) throw new Error("name is required");
        const a = await this._request(`/organizations/${e}/teams`, {
            method: "POST",
            body: JSON.stringify({
                name: r,
                slug: t,
                parentTeam: s
            }),
            methodName: "createTeam"
        });
        if (a.success) return a.data;
        throw new Error(a.message);
    }
    async listTeams(e) {
        if (this._requireReady("listTeams"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/teams`, {
            method: "GET",
            methodName: "listTeams"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async updateTeam(e, r, t) {
        if (this._requireReady("updateTeam"), !e || !r) throw new Error("orgId and teamId are required");
        const s = await this._request(`/organizations/${e}/teams/${r}`, {
            method: "PATCH",
            body: JSON.stringify(t),
            methodName: "updateTeam"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async deleteTeam(e, r) {
        if (this._requireReady("deleteTeam"), !e || !r) throw new Error("orgId and teamId are required");
        const t = await this._request(`/organizations/${e}/teams/${r}`, {
            method: "DELETE",
            methodName: "deleteTeam"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async listTeamMembers(e, r) {
        if (this._requireReady("listTeamMembers"), !e || !r) throw new Error("orgId and teamId are required");
        const t = await this._request(`/organizations/${e}/teams/${r}/members`, {
            method: "GET",
            methodName: "listTeamMembers"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async listOrgTeamMembers(e) {
        if (this._requireReady("listOrgTeamMembers"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/team-members`, {
            method: "GET",
            methodName: "listOrgTeamMembers"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async addTeamMember(e, r, { userId: t, role: s = "member" }) {
        if (this._requireReady("addTeamMember"), !e || !r) throw new Error("orgId and teamId are required");
        if (!t) throw new Error("userId is required");
        const a = await this._request(`/organizations/${e}/teams/${r}/members`, {
            method: "POST",
            body: JSON.stringify({
                userId: t,
                role: s
            }),
            methodName: "addTeamMember"
        });
        if (a.success) return a.data;
        throw new Error(a.message);
    }
    async updateTeamMember(e, r, t, s = {}) {
        if (this._requireReady("updateTeamMember"), !e || !r || !t) throw new Error("orgId, teamId and teamMemberId are required");
        const a = {};
        Object.prototype.hasOwnProperty.call(s, "teamRole") ? a.teamRole = s.teamRole : Object.prototype.hasOwnProperty.call(s, "role") && (a.teamRole = s.role), Object.prototype.hasOwnProperty.call(s, "status") && (a.status = s.status);
        const i = await this._request(`/organizations/${e}/teams/${r}/members/${t}`, {
            method: "PATCH",
            body: JSON.stringify(a),
            methodName: "updateTeamMember"
        });
        if (i.success) return i.data;
        throw new Error(i.message);
    }
    async removeTeamMember(e, r, t) {
        if (this._requireReady("removeTeamMember"), !e || !r || !t) throw new Error("orgId, teamId and teamMemberId are required");
        const s = await this._request(`/organizations/${e}/teams/${r}/members/${t}`, {
            method: "DELETE",
            methodName: "removeTeamMember"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async listAgentAssignments(e, { assigneeId: r } = {}) {
        if (this._requireReady("listAgentAssignments"), !e) throw new Error("orgId is required");
        const t = r ? await this._request(`/organizations/${e}/agent-assignments?assigneeId=${encodeURIComponent(r)}`, {
            method: "GET",
            methodName: "listAgentAssignments"
        }) : await this._request(`/organizations/${e}/agent-assignments`, {
            method: "GET",
            methodName: "listAgentAssignments"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async assignAgent(e, { agentId: r, assigneeId: t, role: s = "assignee", metadata: a = {} }) {
        if (this._requireReady("assignAgent"), !e) throw new Error("orgId is required");
        if (!r) throw new Error("agentId is required");
        if (!t) throw new Error("assigneeId is required");
        const i = await this._request(`/organizations/${e}/agent-assignments`, {
            method: "POST",
            body: JSON.stringify({
                agentId: r,
                assigneeId: t,
                role: s,
                metadata: a
            }),
            methodName: "assignAgent"
        });
        if (i.success) return i.data;
        throw new Error(i.message);
    }
    async updateAgentAssignment(e, r, t = {}) {
        if (this._requireReady("updateAgentAssignment"), !e || !r) throw new Error("orgId and assignmentId are required");
        const s = await this._request(`/organizations/${e}/agent-assignments/${r}`, {
            method: "PATCH",
            body: JSON.stringify(t),
            methodName: "updateAgentAssignment"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async unassignAgent(e, r) {
        if (this._requireReady("unassignAgent"), !e || !r) throw new Error("orgId and assignmentId are required");
        const t = await this._request(`/organizations/${e}/agent-assignments/${r}`, {
            method: "DELETE",
            methodName: "unassignAgent"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async setMemberStatus(e, r, t) {
        if (this._requireReady("setMemberStatus"), !e) throw new Error("orgId is required");
        if (!r) throw new Error("userId is required");
        if (t !== "active" && t !== "inactive") throw new Error("status must be 'active' or 'inactive'");
        const s = await this._request(`/organizations/${e}/members/${encodeURIComponent(r)}/status`, {
            method: "PATCH",
            body: JSON.stringify({
                status: t
            }),
            methodName: "setMemberStatus"
        });
        if (s.success) return s;
        throw new Error(s.message || s.error || "setMemberStatus failed");
    }
    async createOrgInvitation(e, { email: r, role: t = "member", teams: s }) {
        if (this._requireReady("createOrgInvitation"), !e) throw new Error("orgId is required");
        if (!r) throw new Error("email is required");
        const a = await this._request(`/organizations/${e}/invitations`, {
            method: "POST",
            body: JSON.stringify({
                email: r,
                role: t,
                teams: s
            }),
            methodName: "createOrgInvitation"
        });
        if (a.success) return a.data;
        throw new Error(a.message);
    }
    async createOrgInvitationLink(e, { role: r = "member" } = {}) {
        if (!e) throw new Error("orgId is required");
        return this._call("createOrgInvitationLink", `/organizations/${e}/invitations`, {
            method: "POST",
            body: {
                kind: "link",
                role: r
            }
        });
    }
    async listOrgInvitations(e) {
        if (this._requireReady("listOrgInvitations"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/invitations`, {
            method: "GET",
            methodName: "listOrgInvitations"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async revokeOrgInvitation(e, r) {
        if (this._requireReady("revokeOrgInvitation"), !e || !r) throw new Error("orgId and inviteId are required");
        const t = await this._request(`/organizations/${e}/invitations/${r}/revoke`, {
            method: "POST",
            methodName: "revokeOrgInvitation"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async acceptOrgInvitation({ token: e }) {
        if (this._requireReady("acceptOrgInvitation"), !e) throw new Error("token is required");
        const r = await this._request("/organizations/accept-invitation", {
            method: "POST",
            body: JSON.stringify({
                token: e
            }),
            methodName: "acceptOrgInvitation"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async getOrgProjectPermissions(e) {
        if (this._requireReady("getOrgProjectPermissions"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/project-permissions`, {
            method: "GET",
            methodName: "getOrgProjectPermissions"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async updateOrgProjectPermissions(e, r) {
        if (this._requireReady("updateOrgProjectPermissions"), !e) throw new Error("orgId is required");
        const t = await this._request(`/organizations/${e}/project-permissions`, {
            method: "PATCH",
            body: JSON.stringify(r),
            methodName: "updateOrgProjectPermissions"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async listTeamAccess(e, r) {
        if (this._requireReady("listTeamAccess"), !e || !r) throw new Error("orgId and teamId are required");
        const t = await this._request(`/organizations/${e}/teams/${r}/access`, {
            method: "GET",
            methodName: "listTeamAccess"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async grantTeamAccess(e, r, { projectId: t, role: s = "editor" }) {
        if (this._requireReady("grantTeamAccess"), !e || !r) throw new Error("orgId and teamId are required");
        if (!t) throw new Error("projectId is required");
        const a = await this._request(`/organizations/${e}/teams/${r}/access`, {
            method: "POST",
            body: JSON.stringify({
                projectId: t,
                role: s
            }),
            methodName: "grantTeamAccess"
        });
        if (a.success) return a.data;
        throw new Error(a.message);
    }
    async updateTeamAccess(e, r, t, { role: s }) {
        if (this._requireReady("updateTeamAccess"), !e || !r || !t) throw new Error("orgId, teamId and accessId are required");
        const a = await this._request(`/organizations/${e}/teams/${r}/access/${t}`, {
            method: "PATCH",
            body: JSON.stringify({
                role: s
            }),
            methodName: "updateTeamAccess"
        });
        if (a.success) return a.data;
        throw new Error(a.message);
    }
    async revokeTeamAccess(e, r, t) {
        if (this._requireReady("revokeTeamAccess"), !e || !r || !t) throw new Error("orgId, teamId and accessId are required");
        const s = await this._request(`/organizations/${e}/teams/${r}/access/${t}`, {
            method: "DELETE",
            methodName: "revokeTeamAccess"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async createOrgProject(e, r) {
        if (this._requireReady("createOrgProject"), !e) throw new Error("orgId is required");
        const t = await this._request(`/organizations/${e}/projects`, {
            method: "POST",
            body: JSON.stringify(r),
            methodName: "createOrgProject"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async getCreditPool(e) {
        if (this._requireReady("getCreditPool"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/credit-pool`, {
            method: "GET",
            methodName: "getCreditPool"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async updateCreditPool(e, r) {
        if (this._requireReady("updateCreditPool"), !e) throw new Error("orgId is required");
        const t = await this._request(`/organizations/${e}/credit-pool`, {
            method: "PATCH",
            body: JSON.stringify({
                pooledCredits: r
            }),
            methodName: "updateCreditPool"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async getSso(e) {
        if (this._requireReady("getSso"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/sso`, {
            method: "GET",
            methodName: "getSso"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async updateSso(e, r) {
        if (this._requireReady("updateSso"), !e) throw new Error("orgId is required");
        const t = await this._request(`/organizations/${e}/sso`, {
            method: "PATCH",
            body: JSON.stringify(r || {}),
            methodName: "updateSso"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async getScim(e) {
        if (this._requireReady("getScim"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/scim`, {
            method: "GET",
            methodName: "getScim"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async updateScim(e, { enabled: r, rotateToken: t } = {}) {
        if (this._requireReady("updateScim"), !e) throw new Error("orgId is required");
        const s = {};
        r !== void 0 && (s.enabled = r), t !== void 0 && (s.rotateToken = t);
        const a = await this._request(`/organizations/${e}/scim`, {
            method: "PATCH",
            body: JSON.stringify(s),
            methodName: "updateScim"
        });
        if (a.success) return a.data;
        throw new Error(a.message);
    }
    async listOrgCustomDomains(e) {
        if (!e) throw new Error("orgId is required");
        return this._call("listOrgCustomDomains", `/organizations/${e}/custom-domains`, {
            method: "GET"
        });
    }
    async attachOrgCustomDomain(e, { domain: r, workspaceId: t } = {}) {
        if (!e) throw new Error("orgId is required");
        if (!r) throw new Error("domain is required");
        if (!t) throw new Error("workspaceId is required");
        return this._call("attachOrgCustomDomain", `/organizations/${e}/custom-domains`, {
            method: "POST",
            body: {
                domain: r,
                workspaceId: t
            }
        });
    }
    async verifyOrgCustomDomain(e, r, { tls: t } = {}) {
        if (!e) throw new Error("orgId is required");
        if (!r) throw new Error("domain is required");
        return this._call("verifyOrgCustomDomain", `/organizations/${e}/custom-domains/${encodeURIComponent(r)}/verify`, {
            method: "POST",
            body: {
                tls: t ?? null
            }
        });
    }
    async listOrgRoles(e) {
        if (!e) throw new Error("orgId is required");
        return this._call("listOrgRoles", `/organizations/${e}/roles`);
    }
    async createOrgRole(e, r = {}) {
        if (!e) throw new Error("orgId is required");
        if (!r.key) throw new Error("role.key is required");
        if (!r.name) throw new Error("role.name is required");
        if (!r.baseTier) throw new Error("role.baseTier is required");
        return this._call("createOrgRole", `/organizations/${e}/roles`, {
            method: "POST",
            body: r
        });
    }
    async updateOrgRole(e, r, t = {}) {
        if (!e) throw new Error("orgId is required");
        if (!r) throw new Error("roleKey is required");
        if (Object.keys(t).length === 0) throw new Error("updates cannot be empty");
        return this._call("updateOrgRole", `/organizations/${e}/roles/${encodeURIComponent(r)}`, {
            method: "PATCH",
            body: t
        });
    }
    async deleteOrgRole(e, r) {
        if (!e) throw new Error("orgId is required");
        if (!r) throw new Error("roleKey is required");
        return this._call("deleteOrgRole", `/organizations/${e}/roles/${encodeURIComponent(r)}`, {
            method: "DELETE"
        });
    }
    async getMemberEffectiveRole(e, r) {
        if (!e) throw new Error("orgId is required");
        if (!r) throw new Error("memberId is required");
        return this._call("getMemberEffectiveRole", `/organizations/${e}/members/${r}/effective-role`);
    }
    async listOrgPayments(e) {
        if (this._requireReady("listOrgPayments"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/payments`, {
            method: "GET",
            methodName: "listOrgPayments"
        });
        return r?.success ? r.data : {
            payments: []
        };
    }
    async listTeamInvitations(e, r) {
        if (this._requireReady("listTeamInvitations"), !e || !r) throw new Error("orgId and teamId are required");
        const t = await this._request(`/organizations/${e}/teams/${r}/invitations`, {
            method: "GET",
            methodName: "listTeamInvitations"
        });
        return t?.success ? t.data : {
            invitations: []
        };
    }
    async createTeamInvitation(e, r, { email: t, recipientName: s } = {}) {
        if (!e || !r) throw new Error("orgId and teamId are required");
        if (!t) throw new Error("email is required");
        return this._call("createTeamInvitation", `/organizations/${e}/teams/${r}/invitations`, {
            method: "POST",
            body: {
                email: t,
                ...s ? {
                    recipientName: s
                } : {}
            }
        });
    }
    async inviteToTeam(e, r, t) {
        return this.createTeamInvitation(e, r, t);
    }
    async revokeTeamInvitation(e, r, t) {
        if (!e || !r) throw new Error("orgId and teamId are required");
        if (!t) throw new Error("inviteId is required");
        return this._call("revokeTeamInvitation", `/organizations/${e}/teams/${r}/invitations/${t}/revoke`, {
            method: "POST"
        });
    }
    async acceptTeamInvitation({ token: e } = {}) {
        if (!e) throw new Error("token is required");
        return this._call("acceptTeamInvitation", "/organizations/accept-team-invitation", {
            method: "POST",
            body: {
                token: e
            }
        });
    }
    async listTeamWorkspaceAccess(e, r) {
        if (this._requireReady("listTeamWorkspaceAccess"), !e || !r) throw new Error("orgId and teamId are required");
        const t = await this._request(`/organizations/${e}/teams/${r}/workspace-access`, {
            method: "GET",
            methodName: "listTeamWorkspaceAccess"
        });
        return t?.success ? t.data : {
            grants: []
        };
    }
    async grantTeamWorkspaceAccess(e, r, { workspaceId: t, role: s = "guest" } = {}) {
        if (!e || !r) throw new Error("orgId and teamId are required");
        if (!t) throw new Error("workspaceId is required");
        return this._call("grantTeamWorkspaceAccess", `/organizations/${e}/teams/${r}/workspace-access`, {
            method: "POST",
            body: {
                workspaceId: t,
                role: s
            }
        });
    }
    async updateTeamWorkspaceAccess(e, r, t, { role: s } = {}) {
        if (!e || !r || !t) throw new Error("orgId, teamId and accessId are required");
        if (!s) throw new Error("role is required");
        return this._call("updateTeamWorkspaceAccess", `/organizations/${e}/teams/${r}/workspace-access/${t}`, {
            method: "PATCH",
            body: {
                role: s
            }
        });
    }
    async revokeTeamWorkspaceAccess(e, r, t) {
        if (!e || !r || !t) throw new Error("orgId, teamId and accessId are required");
        return this._call("revokeTeamWorkspaceAccess", `/organizations/${e}/teams/${r}/workspace-access/${t}`, {
            method: "DELETE"
        });
    }
    async adminListOrganizations(e = {}) {
        this._requireReady("adminListOrganizations");
        const r = new URLSearchParams;
        e.status && r.append("status", e.status), e.page && r.append("page", e.page.toString()), e.limit && r.append("limit", e.limit.toString());
        const t = r.toString(), s = t ? await this._request(`/organizations/admin?${t}`, {
            method: "GET",
            methodName: "adminListOrganizations"
        }) : await this._request("/organizations/admin", {
            method: "GET",
            methodName: "adminListOrganizations"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async adminListAllTeams(e) {
        if (this._requireReady("adminListAllTeams"), !e) throw new Error("orgId is required");
        const r = await this._request(`/organizations/${e}/teams/admin/all`, {
            method: "GET",
            methodName: "adminListAllTeams"
        });
        return r?.success ? r.data : {
            teams: []
        };
    }
    async adminOverrideTeam(e, r) {
        if (!e || !r) throw new Error("orgId and teamId are required");
        return this._call("adminOverrideTeam", `/organizations/${e}/teams/${r}/admin-override`, {
            method: "POST"
        });
    }
    async ensureOrgStripeCustomer(e) {
        if (!e) throw new Error("orgId is required");
        return this._call("ensureOrgStripeCustomer", `/organizations/${e}/stripe/customer`, {
            method: "POST"
        });
    }
}

});

parcelRegister("8z4Wp", function(module, exports) {

$parcel$export(module.exports, "WorkspaceService", () => $63c56cca5ebf0795$export$5443b0efd6a98e4f);

var $em51x = parcelRequire("em51x");

var $3WN7t = parcelRequire("3WN7t");
const $63c56cca5ebf0795$var$a = (n = {})=>n.environment || n.environmentKey || n.envKey || n.env, $63c56cca5ebf0795$var$p = (n)=>`?environment=${encodeURIComponent(n)}`, $63c56cca5ebf0795$var$d = (n = {})=>{
    const { environmentKey: e, envKey: r, env: o, ...s } = n;
    return {
        ...s,
        environment: $63c56cca5ebf0795$var$a(n)
    };
};
class $63c56cca5ebf0795$export$5443b0efd6a98e4f extends (0, $em51x.BaseService) {
    async createWorkspace({ organization: e, displayName: r, slug: o }) {
        if (!e) throw new Error("organization is required");
        if (!r) throw new Error("displayName is required");
        return this._call("createWorkspace", "/workspaces", {
            method: "POST",
            body: {
                organization: e,
                displayName: r,
                slug: o
            }
        });
    }
    async listWorkspaces({ organization: e, page: r, limit: o } = {}) {
        const s = new URLSearchParams;
        e && s.set("organization", e), r && s.set("page", String(r)), o && s.set("limit", String(o));
        const t = s.toString() ? `?${s}` : "";
        return this._call("listWorkspaces", `/workspaces${t}`);
    }
    async getWorkspace(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getWorkspace", `/workspaces/${e}`);
    }
    async updateWorkspace(e, r) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("updateWorkspace", `/workspaces/${e}`, {
            method: "PATCH",
            body: r
        });
    }
    async updateWorkspaceSettings(e, r) {
        if (!e) throw new Error("workspaceId is required");
        if (!r || typeof r != "object" || Array.isArray(r)) throw new Error("partialSettings object is required");
        return this._call("updateWorkspaceSettings", `/workspaces/${e}/settings`, {
            method: "PATCH",
            body: r
        });
    }
    async deleteWorkspace(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("deleteWorkspace", `/workspaces/${e}`, {
            method: "DELETE"
        });
    }
    async listWorkspaceMembers(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("listWorkspaceMembers", `/workspaces/${e}/members`);
    }
    async addWorkspaceMember(e, { userId: r, role: o = "editor" }) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("userId is required");
        if (!(0, $3WN7t.WORKSPACE_MEMBER_ROLES).includes(o)) throw new Error(`Invalid role: ${o}. Must be one of: ${(0, $3WN7t.WORKSPACE_MEMBER_ROLES).join(", ")}`);
        return this._call("addWorkspaceMember", `/workspaces/${e}/members`, {
            method: "POST",
            body: {
                userId: r,
                role: o
            }
        });
    }
    async updateWorkspaceMemberRole(e, r, { role: o }) {
        if (!e || !r || !o) throw new Error("workspaceId, userId, role are required");
        if (!(0, $3WN7t.WORKSPACE_MEMBER_ROLES).includes(o)) throw new Error(`Invalid role: ${o}. Must be one of: ${(0, $3WN7t.WORKSPACE_MEMBER_ROLES).join(", ")}`);
        return this._call("updateWorkspaceMemberRole", `/workspaces/${e}/members/${r}`, {
            method: "PATCH",
            body: {
                role: o
            }
        });
    }
    async removeWorkspaceMember(e, r) {
        if (!e || !r) throw new Error("workspaceId and userId are required");
        return this._call("removeWorkspaceMember", `/workspaces/${e}/members/${r}`, {
            method: "DELETE"
        });
    }
    async startWorkspaceExport(e) {
        if (!e) throw new Error("Workspace ID is required");
        return this._call("startWorkspaceExport", `/workspaces/${e}/exports`, {
            method: "POST"
        });
    }
    async listWorkspaceExports(e) {
        if (!e) throw new Error("Workspace ID is required");
        return this._call("listWorkspaceExports", `/workspaces/${e}/exports`);
    }
    async getWorkspaceExport(e, r) {
        if (!e) throw new Error("Workspace ID is required");
        if (!r) throw new Error("Export ID is required");
        return this._call("getWorkspaceExport", `/workspaces/${e}/exports/${r}`);
    }
    async getWorkspaceExportDownloadUrl(e, r) {
        if (!e) throw new Error("Workspace ID is required");
        if (!r) throw new Error("Export ID is required");
        return this._call("getWorkspaceExportDownloadUrl", `/workspaces/${e}/exports/${r}/download`, {
            method: "POST"
        });
    }
    async deleteWorkspaceExport(e, r) {
        if (!e) throw new Error("Workspace ID is required");
        if (!r) throw new Error("Export ID is required");
        return this._call("deleteWorkspaceExport", `/workspaces/${e}/exports/${r}`, {
            method: "DELETE"
        });
    }
    async getWorkspaceMemberRecordScope(e, r) {
        if (!e || !r) throw new Error("workspaceId and userId are required");
        return this._call("getWorkspaceMemberRecordScope", `/workspaces/${e}/members/${r}/record-scope`);
    }
    async updateWorkspaceMemberRecordScope(e, r, o = {}) {
        if (!e || !r) throw new Error("workspaceId and userId are required");
        if (!Object.prototype.hasOwnProperty.call(o, "recordScope")) throw new Error("recordScope is required (an object of { scopeField: [values] }, or null to clear)");
        return this._call("updateWorkspaceMemberRecordScope", `/workspaces/${e}/members/${r}/record-scope`, {
            method: "PATCH",
            body: {
                recordScope: o.recordScope
            }
        });
    }
    async grantWorkspaceTeamAccess(e, { teamId: r, role: o = "guest" }) {
        if (!e || !r) throw new Error("workspaceId and teamId are required");
        if (!(0, $3WN7t.TEAM_GRANT_ROLES).includes(o)) throw new Error(`Invalid role: ${o}. Must be one of: ${(0, $3WN7t.TEAM_GRANT_ROLES).join(", ")}`);
        return this._call("grantWorkspaceTeamAccess", `/workspaces/${e}/team-access`, {
            method: "POST",
            body: {
                teamId: r,
                role: o
            }
        });
    }
    async revokeWorkspaceTeamAccess(e, r) {
        if (!e || !r) throw new Error("workspaceId and teamId are required");
        return this._call("revokeWorkspaceTeamAccess", `/workspaces/${e}/team-access/${r}`, {
            method: "DELETE"
        });
    }
    async getBilling(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getBilling", `/workspaces/${e}/billing`);
    }
    async getCreditBalance(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getCreditBalance", `/workspaces/${e}/credits/balance`);
    }
    async getCreditLedger(e, { limit: r, before: o, reason: s } = {}) {
        if (!e) throw new Error("workspaceId is required");
        const t = new URLSearchParams;
        r && t.set("limit", String(r)), o && t.set("before", String(o)), s && t.set("reason", String(s));
        const i = t.toString() ? `?${t}` : "";
        return this._call("getCreditLedger", `/workspaces/${e}/credits/ledger${i}`);
    }
    async getSignupClaimStatus(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getSignupClaimStatus", `/workspaces/${e}/credits/claim-signup`);
    }
    async claimSignupCredits(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("claimSignupCredits", `/workspaces/${e}/credits/claim-signup`, {
            method: "POST"
        });
    }
    async getWorkspaceUsage(e, { period: r, from: o, to: s, reason: t } = {}) {
        if (!e) throw new Error("workspaceId is required");
        const i = new URLSearchParams;
        r && i.set("period", String(r)), o && i.set("from", o instanceof Date ? o.toISOString() : String(o)), s && i.set("to", s instanceof Date ? s.toISOString() : String(s)), t && i.set("reason", String(t));
        const w = i.toString() ? `?${i}` : "";
        return this._call("getWorkspaceUsage", `/workspaces/${e}/usage${w}`);
    }
    async getWorkspaceUsageByActor(e, { period: r, from: o, to: s } = {}) {
        if (!e) throw new Error("workspaceId is required");
        const t = new URLSearchParams;
        r && t.set("period", String(r)), o && t.set("from", o instanceof Date ? o.toISOString() : String(o)), s && t.set("to", s instanceof Date ? s.toISOString() : String(s));
        const i = t.toString() ? `?${t}` : "";
        return this._call("getWorkspaceUsageByActor", `/workspaces/${e}/usage/by-actor${i}`);
    }
    async createCreditTopupCheckout(e, { amountCents: r, successUrl: o, cancelUrl: s, credits: t } = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (r == null && t != null) throw new Error("createCreditTopupCheckout: `credits` is no longer accepted \u2014 top-ups are freeform. Pass `amountCents` (integer cents, minimum 2000).");
        if (!Number.isInteger(Number(r))) throw new Error("createCreditTopupCheckout: `amountCents` must be an integer number of cents");
        const i = {
            amountCents: Number(r)
        };
        return o && (i.successUrl = o), s && (i.cancelUrl = s), this._call("createCreditTopupCheckout", `/workspaces/${e}/billing/topups/checkout`, {
            method: "POST",
            body: i
        });
    }
    async confirmCreditTopup(e, r) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("sessionId is required");
        return this._call("confirmCreditTopup", `/workspaces/${e}/billing/topups/confirm`, {
            method: "POST",
            body: {
                sessionId: r
            }
        });
    }
    async getAutoTopup(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getAutoTopup", `/workspaces/${e}/billing/auto-topup`);
    }
    async setupAutoTopup(e, { thresholdCredits: r, amountCents: o, monthlyLimitCents: s, consent: t, returnUrl: i } = {}) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("setupAutoTopup", `/workspaces/${e}/billing/auto-topup/setup`, {
            method: "POST",
            body: {
                thresholdCredits: r,
                amountCents: o,
                monthlyLimitCents: s,
                consent: t,
                returnUrl: i
            }
        });
    }
    async pauseAutoTopup(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("pauseAutoTopup", `/workspaces/${e}/billing/auto-topup/pause`, {
            method: "POST"
        });
    }
    async refreshAutoTopup(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("refreshAutoTopup", `/workspaces/${e}/billing/auto-topup/refresh`, {
            method: "POST"
        });
    }
    async getSpendControls(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getSpendControls", `/workspaces/${e}/spend-controls`);
    }
    async updateSpendControls(e, r) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("updateSpendControls", `/workspaces/${e}/spend-controls`, {
            method: "PATCH",
            body: r
        });
    }
    async getWorkspacePublicConfig(e, r = {}) {
        if (!e) throw new Error("workspaceId is required");
        const o = $63c56cca5ebf0795$var$a(r);
        if (!o) throw new Error("environment is required");
        return this._call("getWorkspacePublicConfig", `/workspaces/${encodeURIComponent(e)}/config/public${$63c56cca5ebf0795$var$p(o)}`);
    }
    async upsertWorkspacePublicConfig(e, r = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!$63c56cca5ebf0795$var$a(r)) throw new Error("environment is required");
        if (!r.key) throw new Error("key is required");
        if (r.value === void 0 || r.value === null) throw new Error("value is required");
        return this._call("upsertWorkspacePublicConfig", `/workspaces/${encodeURIComponent(e)}/config/public`, {
            method: "POST",
            body: $63c56cca5ebf0795$var$d(r)
        });
    }
    async deleteWorkspacePublicConfig(e, r, o = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("key is required");
        const s = $63c56cca5ebf0795$var$a(o);
        if (!s) throw new Error("environment is required");
        return this._call("deleteWorkspacePublicConfig", `/workspaces/${encodeURIComponent(e)}/config/public/${encodeURIComponent(r)}${$63c56cca5ebf0795$var$p(s)}`, {
            method: "DELETE"
        });
    }
    async listWorkspaceSecrets(e, r = {}) {
        if (!e) throw new Error("workspaceId is required");
        const o = $63c56cca5ebf0795$var$a(r);
        if (!o) throw new Error("environment is required");
        return this._call("listWorkspaceSecrets", `/workspaces/${encodeURIComponent(e)}/secrets${$63c56cca5ebf0795$var$p(o)}`);
    }
    async upsertWorkspaceSecret(e, r = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!$63c56cca5ebf0795$var$a(r)) throw new Error("environment is required");
        if (!r.key) throw new Error("key is required");
        if (r.value === void 0 || r.value === null || r.value === "") throw new Error("value is required");
        if (!Array.isArray(r.allowedConsumers) || r.allowedConsumers.length === 0) throw new Error("allowedConsumers are required");
        return this._call("upsertWorkspaceSecret", `/workspaces/${encodeURIComponent(e)}/secrets`, {
            method: "POST",
            body: $63c56cca5ebf0795$var$d(r)
        });
    }
    async deleteWorkspaceSecret(e, r, o = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("key is required");
        const s = $63c56cca5ebf0795$var$a(o);
        if (!s) throw new Error("environment is required");
        return this._call("deleteWorkspaceSecret", `/workspaces/${encodeURIComponent(e)}/secrets/${encodeURIComponent(r)}${$63c56cca5ebf0795$var$p(s)}`, {
            method: "DELETE"
        });
    }
    async getWorkspaceAppDependencies(e, r) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("appId is required");
        const o = await this._call("getWorkspaceAppDependencies", `/workspaces/${e}/apps/${encodeURIComponent(r)}/dependencies`, {
            method: "GET",
            raw: !0
        });
        return {
            resolved: o.resolved || [],
            cycles: o.cycles || []
        };
    }
    async installWorkspaceApps(e, { appId: r, alsoInstall: o } = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("appId is required");
        const s = await this._call("installWorkspaceApps", `/workspaces/${e}/apps`, {
            method: "POST",
            body: {
                appId: r,
                ...o ? {
                    alsoInstall: o
                } : {}
            },
            raw: !0
        });
        return {
            installed: s.installed || [],
            alreadyInstalled: s.alreadyInstalled || [],
            workspaceApps: s.workspaceApps || []
        };
    }
    async removeWorkspaceApp(e, r, { force: o } = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("appId is required");
        const s = o ? "?force=true" : "", t = await this._call("removeWorkspaceApp", `/workspaces/${e}/apps/${encodeURIComponent(r)}${s}`, {
            method: "DELETE",
            raw: !0
        });
        return {
            uninstalled: t.uninstalled,
            dependents: t.dependents || [],
            forced: !!t.forced
        };
    }
    async listWorkspacePresets() {
        const e = await this._call("listWorkspacePresets", "/presets");
        return Array.isArray(e?.presets) ? e.presets : [];
    }
    async applyWorkspacePreset(e, r, { include: o, exclude: s, setup: t } = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("presetKey is required");
        const i = {};
        return o !== void 0 && (i.include = o), s !== void 0 && (i.exclude = s), t !== void 0 && (i.setup = t), this._call("applyWorkspacePreset", `/workspaces/${e}/presets/${encodeURIComponent(r)}/apply`, {
            method: "POST",
            body: i
        });
    }
    async saveWorkspaceBlueprint(e, r) {
        if (!e) throw new Error("workspaceId is required");
        if (!r || typeof r != "object" || Array.isArray(r)) throw new Error("blueprint must be an object");
        return this._call("saveWorkspaceBlueprint", `/workspaces/${e}/blueprint`, {
            method: "PUT",
            body: r
        });
    }
    async getWorkspaceBlueprint(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getWorkspaceBlueprint", `/workspaces/${e}/blueprint`);
    }
    async startWorkspaceSetup(e, { retry: r, from: o } = {}) {
        if (!e) throw new Error("workspaceId is required");
        const s = {};
        return r !== void 0 && (s.retry = r), typeof o == "string" && (s.from = o), this._call("startWorkspaceSetup", `/workspaces/${e}/setup`, {
            method: "POST",
            body: s
        });
    }
    async getWorkspaceSetup(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getWorkspaceSetup", `/workspaces/${e}/setup`);
    }
    async estimateBuild(e, r) {
        if (!e) throw new Error("workspaceId is required");
        if (!r || typeof r != "object" || Array.isArray(r)) throw new Error("body must be an object");
        return this._call("estimateBuild", `/workspaces/${e}/build-estimate`, {
            method: "POST",
            body: r
        });
    }
    async getWorkspacePermissions(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("getWorkspacePermissions", `/workspaces/${e}/permissions`);
    }
    async createWorkspaceProject(e, r) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("createWorkspaceProject", `/workspaces/${e}/projects`, {
            method: "POST",
            body: r
        });
    }
    async listWorkspaceInvitations(e) {
        if (!e) throw new Error("workspaceId is required");
        return this._call("listWorkspaceInvitations", `/workspaces/${e}/invitations`);
    }
    async createWorkspaceInvitation(e, { email: r, role: o = "editor", recipientName: s, teams: t } = {}) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("email is required");
        return this._call("createWorkspaceInvitation", `/workspaces/${e}/invitations`, {
            method: "POST",
            body: {
                email: r,
                role: o,
                ...s ? {
                    recipientName: s
                } : {},
                ...Array.isArray(t) && t.length ? {
                    teams: t
                } : {}
            }
        });
    }
    async revokeWorkspaceInvitation(e, r) {
        if (!e) throw new Error("workspaceId is required");
        if (!r) throw new Error("inviteId is required");
        return this._call("revokeWorkspaceInvitation", `/workspaces/${e}/invitations/${r}/revoke`, {
            method: "POST"
        });
    }
    async acceptWorkspaceInvitation({ token: e } = {}) {
        if (!e) throw new Error("token is required");
        return this._call("acceptWorkspaceInvitation", "/workspaces/accept-invitation", {
            method: "POST",
            body: {
                token: e
            }
        });
    }
    async getInvitationPreview({ token: e } = {}) {
        if (!e) throw new Error("token is required");
        return this._call("getInvitationPreview", "/invitations/preview", {
            method: "POST",
            body: {
                token: e
            }
        });
    }
}

});

parcelRegister("gm2mj", function(module, exports) {

$parcel$export(module.exports, "BootService", () => $be8087dd232fb21d$export$c5c20439f1c8b415);

var $em51x = parcelRequire("em51x");
class $be8087dd232fb21d$export$c5c20439f1c8b415 extends (0, $em51x.BaseService) {
    async boot({ workspaceId: e, org: t, ws: n } = {}) {
        const o = [];
        e && o.push(`workspaceId=${encodeURIComponent(e)}`), t && o.push(`org=${encodeURIComponent(t)}`), n && o.push(`ws=${encodeURIComponent(n)}`);
        const s = o.length ? `?${o.join("&")}` : "";
        return this._call("boot", `/boot${s}`);
    }
}
var $be8087dd232fb21d$export$2e2bcd8739ae039 = $be8087dd232fb21d$export$c5c20439f1c8b415;

});

parcelRegister("gV6h4", function(module, exports) {

$parcel$export(module.exports, "McpConnectorService", () => $c516d6259843e991$export$294975934fe88625);

var $em51x = parcelRequire("em51x");
class $c516d6259843e991$export$294975934fe88625 extends (0, $em51x.BaseService) {
    mcpConnectorList(e = {}) {
        const o = new URLSearchParams;
        for (const [s, r] of Object.entries(e || {}))r != null && r !== "" && o.set(s, String(r));
        const t = o.toString();
        return this._call("mcpConnector.list", `/mcp-connectors${t ? `?${t}` : ""}`);
    }
    mcpConnectorGet(e) {
        if (!e) throw new Error("connectorId is required");
        return this._call("mcpConnector.get", `/mcp-connectors/${encodeURIComponent(e)}`);
    }
    mcpConnectorCreate(e = {}) {
        return this._call("mcpConnector.create", "/mcp-connectors", {
            method: "POST",
            body: e
        });
    }
    mcpConnectorUpdate(e, o = {}) {
        if (!e) throw new Error("connectorId is required");
        return this._call("mcpConnector.update", `/mcp-connectors/${encodeURIComponent(e)}`, {
            method: "PUT",
            body: o
        });
    }
    mcpConnectorDiscover(e, o = {}) {
        if (!e) throw new Error("connectorId is required");
        return this._call("mcpConnector.discover", `/mcp-connectors/${encodeURIComponent(e)}/discover`, {
            method: "POST",
            body: o
        });
    }
    mcpConnectorSetStatus(e, o = {}) {
        if (!e) throw new Error("connectorId is required");
        return this._call("mcpConnector.setStatus", `/mcp-connectors/${encodeURIComponent(e)}/status`, {
            method: "PATCH",
            body: o
        });
    }
    mcpConnectorRemove(e) {
        if (!e) throw new Error("connectorId is required");
        return this._call("mcpConnector.remove", `/mcp-connectors/${encodeURIComponent(e)}`, {
            method: "DELETE"
        });
    }
}
const $c516d6259843e991$export$fa5f97e3e48c2609 = (n)=>new $c516d6259843e991$export$294975934fe88625(n);
var $c516d6259843e991$export$2e2bcd8739ae039 = $c516d6259843e991$export$294975934fe88625;

});

parcelRegister("guDnT", function(module, exports) {

$parcel$export(module.exports, "VoiceService", () => $c01dff958e23a386$export$925655758545fa4f);

var $em51x = parcelRequire("em51x");
class $c01dff958e23a386$export$925655758545fa4f extends (0, $em51x.BaseService) {
    voiceTranscribe({ audio: t, filename: o = "clip.webm", language: e } = {}) {
        if (!t) throw new Error("audio is required");
        const r = new FormData;
        return r.append("audio", t, o), typeof e == "string" && e && r.append("language", e), this._call("voiceTranscribe", "/ai/voice/transcribe", {
            method: "POST",
            body: r
        });
    }
    async voiceTts({ text: t, voiceId: o, modelId: e, signal: r } = {}) {
        if (this._requireReady("voiceTts"), !t || typeof t != "string") throw new Error("text is required");
        const u = `${this._apiUrl}/core/ai/voice/tts`, a = {
            "Content-Type": "application/json"
        }, n = this._tokenManager?.getAccessToken?.();
        n && (a.Authorization = `Bearer ${n}`);
        const i = await fetch(u, {
            method: "POST",
            headers: a,
            body: JSON.stringify({
                text: t,
                voiceId: o,
                modelId: e
            }),
            signal: r
        });
        if (!i.ok) {
            const d = await i.json().catch(()=>null), s = new Error(d?.message || `voiceTts failed (HTTP ${i.status})`);
            throw s.status = i.status, s.code = d?.error, s;
        }
        return i;
    }
    async voiceVoices({ workspaceId: t, signal: o } = {}) {
        this._requireReady("voiceVoices");
        const e = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
        try {
            return await this._request(`/ai/voice/voices${e}`, {
                method: "GET",
                methodName: "voiceVoices",
                ...o ? {
                    signal: o
                } : {}
            });
        } catch (r) {
            throw r && !r.code && r.cause && typeof r.cause.error == "string" && (r.code = r.cause.error), r;
        }
    }
    async voiceAgentSession({ workspaceId: t, signal: o } = {}) {
        this._requireReady("voiceAgentSession");
        try {
            return await this._request("/ai/voice/agent", {
                method: "POST",
                methodName: "voiceAgentSession",
                body: JSON.stringify(t ? {
                    workspaceId: t
                } : {}),
                ...o ? {
                    signal: o
                } : {}
            });
        } catch (e) {
            throw e && !e.code && e.cause && typeof e.cause.error == "string" && (e.code = e.cause.error), e;
        }
    }
}
const $c01dff958e23a386$export$6b9f3d7c1993ba70 = (c)=>new $c01dff958e23a386$export$925655758545fa4f(c);
var $c01dff958e23a386$export$2e2bcd8739ae039 = $c01dff958e23a386$export$925655758545fa4f;

});

parcelRegister("5tLYA", function(module, exports) {

$parcel$export(module.exports, "workspaceProjectBaseUrl", () => $3fd4e048781bc0e8$export$59dd0c3383896351);
$parcel$export(module.exports, "WorkspaceProjectService", () => $3fd4e048781bc0e8$export$4461292f844a8d17);

var $em51x = parcelRequire("em51x");

var $7sTYS = parcelRequire("7sTYS");
var $3fd4e048781bc0e8$require$Buffer = $7sTYS.Buffer;
const $3fd4e048781bc0e8$var$g = "/workspace-project", $3fd4e048781bc0e8$var$y = (u)=>{
    if (!u || typeof u != "string") return null;
    const e = u.split(".");
    if (e.length !== 3) return null;
    try {
        let t = e[1].replace(/-/g, "+").replace(/_/g, "/");
        for(; t.length % 4;)t += "=";
        const s = typeof atob == "function" ? atob(t) : $3fd4e048781bc0e8$require$Buffer.from(t, "base64").toString("utf8"), o = JSON.parse(s), n = o?.app_metadata || {};
        return o?.workspace_id ?? o?.workspaceId ?? n.workspace_id ?? n.active_workspace_id ?? null;
    } catch  {
        return null;
    }
}, $3fd4e048781bc0e8$export$59dd0c3383896351 = (u)=>`${u}${$3fd4e048781bc0e8$var$g}`;
class $3fd4e048781bc0e8$export$4461292f844a8d17 extends (0, $em51x.BaseService) {
    init({ context: e }) {
        super.init({
            context: e
        }), this._workspacePrefix = $3fd4e048781bc0e8$export$59dd0c3383896351(e?.workspaceApiUrl || this._apiUrl), this._tokenProvider = e?.workspaceProjectTokenProvider || null;
    }
    async _resolveAuthHeader() {
        if (this._tokenProvider) try {
            const e = await this._tokenProvider(), t = e ? typeof e == "string" ? e : e.token || e.access_token || null : null;
            if (t) {
                const s = this._context?.activeWorkspaceId, o = $3fd4e048781bc0e8$var$y(t);
                if (!(s != null && o != null && String(o) !== String(s))) return `Bearer ${t}`;
                if (this._tokenManager) try {
                    await this._tokenManager.ensureValidToken();
                    const a = this._tokenManager.getAuthHeader();
                    if (a) return a;
                } catch  {}
                return `Bearer ${t}`;
            }
        } catch  {}
        if (this._tokenManager) try {
            return await this._tokenManager.ensureValidToken(), this._tokenManager.getAuthHeader();
        } catch  {}
        return null;
    }
    switchOrg() {
        this._invalidateTokenProviderCache();
    }
    switchWorkspace() {
        this._invalidateTokenProviderCache();
    }
    _invalidateTokenProviderCache() {
        try {
            typeof this._tokenProvider?.invalidate == "function" && this._tokenProvider.invalidate();
        } catch  {}
    }
    async _ws(e, t, { method: s = "GET", body: o, headers: n } = {}) {
        this._requireReady(e);
        const a = `${this._workspacePrefix}${t}`, c = {
            method: s,
            headers: {
                ...n || {}
            },
            methodName: e
        };
        if (o !== void 0 && (c.body = JSON.stringify(o)), c.authHeader = await this._resolveAuthHeader(), !c.authHeader) {
            const i = new Error("[workspaceProject] not authenticated \u2014 no bearer token available");
            throw i.code = "invalid_token", i.status = 401, i.local = !0, i;
        }
        return this._requestExternal(a, c);
    }
    _chatWorkspaceId(e) {
        return this._resolveWorkspaceId(e);
    }
    chat = {
        listChannels: (e)=>{
            const t = this._chatWorkspaceId(e), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._ws("chat.listChannels", `/chat/channels${s}`);
        },
        createChannel: (e)=>{
            const t = this._chatWorkspaceId(e?.workspace_id);
            return this._ws("chat.createChannel", "/chat/channels", {
                method: "POST",
                body: {
                    payload: t ? {
                        ...e,
                        workspace_id: t
                    } : e
                }
            });
        },
        updateChannel: (e, t)=>this._ws("chat.updateChannel", `/chat/channels/${encodeURIComponent(e)}`, {
                method: "PATCH",
                body: {
                    payload: t
                }
            }),
        removeChannel: (e)=>this._ws("chat.removeChannel", `/chat/channels/${encodeURIComponent(e)}`, {
                method: "DELETE"
            }),
        listMessages: (e, t)=>{
            const { bulk: s, workspaceId: o, ...n } = t && typeof t == "object" ? t : {};
            if (!e && s !== !0) throw new Error("[chat.listMessages] channelId is required \u2014 pass { bulk: true } explicitly for a workspace-wide read");
            const a = Object.entries(n).reduce((h, [l, d])=>(d != null && (h[l] = String(d)), h), {}), c = this._chatWorkspaceId(o);
            c && (a.workspaceId = String(c));
            const i = new URLSearchParams(a).toString(), r = i ? `?${i}` : "";
            return e ? this._ws("chat.listMessages", `/chat/channels/${encodeURIComponent(e)}/messages${r}`) : this._ws("chat.listAllMessages", `/chat/messages${r}`);
        },
        sendMessage: (e, t)=>this._ws("chat.sendMessage", `/chat/channels/${encodeURIComponent(e)}/messages`, {
                method: "POST",
                body: {
                    payload: t
                }
            }),
        updateMessage: (e, t)=>this._ws("chat.updateMessage", `/chat/messages/${encodeURIComponent(e)}`, {
                method: "PATCH",
                body: {
                    payload: t
                }
            }),
        removeMessage: (e)=>this._ws("chat.removeMessage", `/chat/messages/${encodeURIComponent(e)}`, {
                method: "DELETE"
            }),
        purgeMessages: ()=>this._ws("chat.purgeMessages", "/chat/messages/purge", {
                method: "POST"
            }),
        toggleReaction: (e, t, s)=>this._ws("chat.toggleReaction", `/chat/messages/${encodeURIComponent(e)}/reactions`, {
                method: "POST",
                body: {
                    emoji: t,
                    userId: s
                }
            }),
        listMembers: (e, t)=>{
            const { bulk: s, workspaceId: o } = t && typeof t == "object" ? t : {};
            if (!e && s !== !0) throw new Error("[chat.listMembers] channelId is required \u2014 pass { bulk: true } explicitly for a workspace-wide read");
            const n = this._chatWorkspaceId(o), a = n ? `?workspaceId=${encodeURIComponent(n)}` : "";
            return e ? this._ws("chat.listMembers", `/chat/channels/${encodeURIComponent(e)}/members${a}`) : this._ws("chat.listAllMembers", `/chat/members${a}`);
        },
        addMember: (e, t)=>this._ws("chat.addMember", "/chat/members", {
                method: "POST",
                body: {
                    payload: {
                        ...t,
                        channel_id: e
                    }
                }
            }),
        updateMember: (e, t, s)=>this._ws("chat.updateMember", `/chat/channels/${encodeURIComponent(e)}/members/${encodeURIComponent(t)}`, {
                method: "PATCH",
                body: {
                    payload: s
                }
            }),
        removeMember: (e, t)=>this._ws("chat.removeMember", `/chat/channels/${encodeURIComponent(e)}/members/${encodeURIComponent(t)}`, {
                method: "DELETE"
            }),
        markRead: (e, t, s)=>this._ws("chat.markRead", `/chat/channels/${encodeURIComponent(e)}/members/${encodeURIComponent(t)}/read`, {
                method: "POST",
                body: {
                    lastReadAt: s
                }
            }),
        muteChannel: (e, t, s)=>this._ws("chat.muteChannel", `/chat/channels/${encodeURIComponent(e)}/members/${encodeURIComponent(t)}/mute`, {
                method: "POST",
                body: {
                    muted: s
                }
            }),
        typing: (e, { state: t = "start", threadParentId: s } = {})=>this._ws("chat.typing", `/chat/channels/${encodeURIComponent(e)}/typing`, {
                method: "POST",
                body: s ? {
                    state: t,
                    threadParentId: s
                } : {
                    state: t
                }
            }),
        listMentions: (e, t)=>{
            const s = !!(t && typeof t == "object"), { workspaceId: o, ...n } = s ? t : {}, a = this._chatWorkspaceId(o), c = a ? `?workspaceId=${encodeURIComponent(a)}` : "";
            return this._ws("chat.listMentions", `/chat/mentions${c}`, {
                method: "POST",
                body: {
                    filter: e,
                    options: s ? n : t
                }
            });
        },
        markMentionsRead: (e, t)=>this._ws("chat.markMentionsRead", `/chat/channels/${encodeURIComponent(e)}/mentions/read`, {
                method: "POST",
                body: {
                    callerEmail: t
                }
            }),
        searchMessages: (e, t, s)=>{
            const o = this._chatWorkspaceId(s), n = o ? `?workspaceId=${encodeURIComponent(o)}` : "";
            return this._ws("chat.searchMessages", `/chat/search${n}`, {
                method: "POST",
                body: {
                    q: e,
                    callerEmail: t
                }
            });
        }
    };
    calendar = {
        listEvents: (e, t)=>{
            const s = this._chatWorkspaceId(t), o = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._ws("calendar.listEvents", `/calendar/events${o}`, {
                method: "POST",
                body: {
                    filter: e
                }
            });
        },
        getEvent: (e, t)=>{
            const s = this._chatWorkspaceId(t), o = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._ws("calendar.getEvent", `/calendar/events/${encodeURIComponent(e)}${o}`);
        },
        createEvent: (e)=>{
            const t = this._chatWorkspaceId(e?.workspace_id);
            return this._ws("calendar.createEvent", "/calendar/events", {
                method: "POST",
                body: {
                    payload: t ? {
                        ...e,
                        workspace_id: t
                    } : e
                }
            });
        },
        updateEvent: (e, t, s)=>{
            const o = this._chatWorkspaceId(s), n = o ? `?workspaceId=${encodeURIComponent(o)}` : "";
            return this._ws("calendar.updateEvent", `/calendar/events/${encodeURIComponent(e)}${n}`, {
                method: "PATCH",
                body: {
                    payload: t
                }
            });
        },
        deleteEvent: (e, t)=>{
            const s = this._chatWorkspaceId(t), o = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._ws("calendar.deleteEvent", `/calendar/events/${encodeURIComponent(e)}${o}`, {
                method: "DELETE"
            });
        },
        deleteFutureEvents: (e, t, s)=>{
            const o = this._chatWorkspaceId(s), n = o ? `?workspaceId=${encodeURIComponent(o)}` : "";
            return this._ws("calendar.deleteFutureEvents", `/calendar/events/delete-future${n}`, {
                method: "POST",
                body: {
                    seriesId: e,
                    fromDate: t
                }
            });
        },
        sync: (e)=>this._ws("calendar.sync", "/calendar/sync", {
                method: "POST",
                body: {
                    params: e
                }
            })
    };
    meet = {
        listRooms: (e)=>{
            const t = this._chatWorkspaceId(e), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._ws("meet.listRooms", `/meet/rooms${s}`);
        },
        createRoom: (e)=>{
            const t = this._chatWorkspaceId(e?.workspace_id);
            return this._ws("meet.createRoom", "/meet/rooms", {
                method: "POST",
                body: {
                    payload: t ? {
                        ...e,
                        workspace_id: t
                    } : e
                }
            });
        },
        getRoom: (e)=>this._ws("meet.getRoom", `/meet/rooms/${encodeURIComponent(e)}`),
        updateRoom: (e, t)=>this._ws("meet.updateRoom", `/meet/rooms/${encodeURIComponent(e)}`, {
                method: "PATCH",
                body: {
                    payload: t
                }
            }),
        endRoom: (e)=>this._ws("meet.endRoom", `/meet/rooms/${encodeURIComponent(e)}/end`, {
                method: "POST"
            }),
        reopenRoom: (e)=>this._ws("meet.reopenRoom", `/meet/rooms/${encodeURIComponent(e)}/reopen`, {
                method: "POST"
            }),
        listMembers: (e)=>this._ws("meet.listMembers", `/meet/rooms/${encodeURIComponent(e)}/members`),
        addMember: (e, t)=>this._ws("meet.addMember", `/meet/rooms/${encodeURIComponent(e)}/members`, {
                method: "POST",
                body: {
                    payload: t
                }
            }),
        listTranscripts: (e)=>this._ws("meet.listTranscripts", `/meet/rooms/${encodeURIComponent(e)}/transcripts`),
        listUtterances: (e)=>this._ws("meet.listUtterances", `/meet/rooms/${encodeURIComponent(e)}/utterances`),
        getTranscriptView: async (e)=>{
            const [t, s] = await Promise.all([
                this._ws("meet.listUtterances", `/meet/rooms/${encodeURIComponent(e)}/utterances`),
                this._ws("meet.listTranscripts", `/meet/rooms/${encodeURIComponent(e)}/transcripts`)
            ]), o = Array.isArray(t) ? t : t?.data || [], n = Array.isArray(s) ? s : s?.data || [];
            return {
                utterances: o,
                analysis: n[0] || null
            };
        },
        waitingRoom: ()=>this._ws("meet.waitingRoom", "/meet/waiting-room"),
        admitGuest: (e)=>this._ws("meet.admitGuest", `/meet/waiting-room/${encodeURIComponent(e)}/admit`, {
                method: "POST"
            }),
        rejectGuest: (e)=>this._ws("meet.rejectGuest", `/meet/waiting-room/${encodeURIComponent(e)}/reject`, {
                method: "POST"
            }),
        issueToken: (e)=>this._ws("meet.issueToken", "/meet/token", {
                method: "POST",
                body: {
                    params: e
                }
            }),
        mute: (e)=>this._ws("meet.mute", "/meet/mute", {
                method: "POST",
                body: {
                    params: e
                }
            }),
        getTranscriptView: (e)=>this._ws("meet.getTranscriptView", `/meet/rooms/${encodeURIComponent(e)}/transcript-view`),
        updateAnalysisAppliedItems: (e, t)=>this._ws("meet.updateAnalysisAppliedItems", `/meet/rooms/${encodeURIComponent(e)}/analysis/applied-items`, {
                method: "PATCH",
                body: {
                    applied_items: t
                }
            })
    };
    presence = {
        online: (e)=>{
            const t = this._chatWorkspaceId(e), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._ws("presence.online", `/presence/online${s}`);
        },
        heartbeat: (e)=>{
            const t = this._chatWorkspaceId(e), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._ws("presence.heartbeat", `/presence/heartbeat${s}`, {
                method: "POST"
            });
        }
    };
    notifications = {
        list: ()=>this._request("/notifications", {
                method: "GET",
                methodName: "notifications.list"
            }),
        unreadCount: ()=>this._request("/notifications/unread-count", {
                method: "GET",
                methodName: "notifications.unreadCount"
            }),
        create: (e, t)=>{
            const s = this._chatWorkspaceId(t?.workspaceId), o = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._ws("notifications.create", `/notifications${o}`, {
                method: "POST",
                body: {
                    payload: e
                }
            });
        },
        close: ({ appId: e, dedupKey: t, workspaceId: s } = {})=>{
            const o = this._chatWorkspaceId(s), n = o ? `?workspaceId=${encodeURIComponent(o)}` : "";
            return this._ws("notifications.close", `/notifications/close${n}`, {
                method: "POST",
                body: {
                    appId: e,
                    dedupKey: t
                }
            });
        },
        audience: (e)=>{
            const t = this._chatWorkspaceId(e?.workspaceId), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._ws("notifications.audience", `/notifications/audience${s}`);
        },
        markRead: (e)=>this._request(`/notifications/${encodeURIComponent(e)}/read`, {
                method: "POST",
                methodName: "notifications.markRead"
            }),
        markAllRead: ()=>this._request("/notifications/mark-all-read", {
                method: "POST",
                methodName: "notifications.markAllRead"
            })
    };
    search = (e, t)=>{
        const { workspaceId: s, ...o } = t && typeof t == "object" ? t : {}, n = this._chatWorkspaceId(s), a = n ? `?workspaceId=${encodeURIComponent(n)}` : "";
        return this._ws("search", `/search${a}`, {
            method: "POST",
            body: {
                q: e,
                ...o
            }
        });
    };
    permissions = {
        me: ()=>this._ws("permissions.me", "/permissions/me"),
        check: (e, t)=>this._ws("permissions.check", "/permissions/check", {
                method: "POST",
                body: {
                    action: e,
                    resource: t
                }
            })
    };
    system = {
        status: ()=>this._ws("system.status", "/system/status"),
        featureFlags: ()=>this._ws("system.featureFlags", "/system/feature-flags")
    };
    getPersonaSession() {
        return this._ws("getPersonaSession", "/persona");
    }
    people = {
        list: (e)=>{
            const t = this._chatWorkspaceId(e), s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return this._ws("people.list", `/people${s}`);
        },
        get: (e)=>this._ws("people.get", `/people/${encodeURIComponent(e)}`),
        me: ()=>this._ws("people.me", "/people/me")
    };
    activity = {
        listNotes: ()=>this._ws("activity.listNotes", "/activity/notes"),
        addNote: (e)=>this._ws("activity.addNote", "/activity/notes", {
                method: "POST",
                body: {
                    payload: e
                }
            }),
        scoringConfig: ()=>this._ws("activity.scoringConfig", "/activity/scoring-config"),
        updateScoringConfig: (e)=>this._ws("activity.updateScoringConfig", "/activity/scoring-config", {
                method: "PATCH",
                body: {
                    payload: e
                }
            }),
        heatmap: (e)=>this._ws("activity.heatmap", "/activity/heatmap", {
                method: "POST",
                body: {
                    filter: e
                }
            }),
        listEvents: (e)=>this._ws("activity.listEvents", "/activity/events", {
                method: "POST",
                body: {
                    filter: e
                }
            })
    };
    announcements = {
        list: ()=>this._request("/announcements", {
                method: "GET",
                methodName: "announcements.list"
            }).then((e)=>Array.isArray(e) ? e : e?.announcements ?? []),
        get: (e)=>this._request(`/announcements/${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "announcements.get"
            }).then((t)=>t?.announcement ?? t),
        create: (e)=>this._request("/announcements", {
                method: "POST",
                body: JSON.stringify({
                    payload: e
                }),
                methodName: "announcements.create"
            }).then((t)=>t?.announcement ?? t),
        update: (e, t)=>this._request(`/announcements/${encodeURIComponent(e)}`, {
                method: "PUT",
                body: JSON.stringify({
                    payload: t
                }),
                methodName: "announcements.update"
            }).then((s)=>s?.announcement ?? s),
        remove: (e)=>this._request(`/announcements/${encodeURIComponent(e)}`, {
                method: "DELETE",
                methodName: "announcements.remove"
            }),
        toggleReaction: (e, t, s)=>this._request(`/announcements/${encodeURIComponent(e)}/reactions`, {
                method: "POST",
                body: JSON.stringify({
                    emoji: t,
                    reactor: s
                }),
                methodName: "announcements.toggleReaction"
            }).then((o)=>o?.announcement ?? o)
    };
    _fileCanvasWorkspaceId(e, t) {
        const s = t && t.workspaceId || e && typeof e == "object" && e.workspaceId || this._context?.activeWorkspaceId;
        return s ? String(s) : null;
    }
    fileCanvas = {
        list: (e, t)=>{
            const s = new URLSearchParams;
            e && typeof e == "object" && "parent_id" in e && s.set("parentId", e.parent_id == null ? "root" : String(e.parent_id));
            const o = this._fileCanvasWorkspaceId(e, t);
            o && s.set("workspaceId", o);
            const n = s.toString();
            return this._request(`/file-canvas${n ? `?${n}` : ""}`, {
                method: "GET",
                methodName: "fileCanvas.list"
            }).then((a)=>Array.isArray(a) ? a : a?.data ?? []);
        },
        get: (e, t)=>{
            const s = this._fileCanvasWorkspaceId(null, t);
            return this._request(`/file-canvas/${encodeURIComponent(e)}${s ? `?workspaceId=${encodeURIComponent(s)}` : ""}`, {
                method: "GET",
                methodName: "fileCanvas.get"
            }).then((o)=>o?.data ?? o);
        },
        create: (e, t)=>{
            const s = this._fileCanvasWorkspaceId(e, t);
            return this._request(`/file-canvas${s ? `?workspaceId=${encodeURIComponent(s)}` : ""}`, {
                method: "POST",
                body: JSON.stringify(e || {}),
                methodName: "fileCanvas.create"
            }).then((o)=>o?.data ?? o);
        },
        update: (e, t, s)=>{
            const o = this._fileCanvasWorkspaceId(t, s);
            return this._request(`/file-canvas/${encodeURIComponent(e)}${o ? `?workspaceId=${encodeURIComponent(o)}` : ""}`, {
                method: "PATCH",
                body: JSON.stringify(t || {}),
                methodName: "fileCanvas.update"
            }).then((n)=>n?.data ?? n);
        },
        remove: (e, t)=>{
            const s = this._fileCanvasWorkspaceId(null, t);
            return this._request(`/file-canvas/${encodeURIComponent(e)}${s ? `?workspaceId=${encodeURIComponent(s)}` : ""}`, {
                method: "DELETE",
                methodName: "fileCanvas.remove"
            });
        }
    };
    _recordsWorkspaceId(e, t) {
        const s = t && t.workspaceId || e && typeof e == "object" && e.workspaceId || this._context?.activeWorkspaceId;
        if (!s) throw new Error("[sdk records] no workspace scope \u2014 pass { workspaceId } or set the SDK's activeWorkspaceId.");
        return encodeURIComponent(String(s));
    }
    records = {
        list: async (e, t)=>{
            const s = this._recordsWorkspaceId(e, t), o = new URLSearchParams, n = e && typeof e == "object" && e.collection ? e.collection : null;
            n && o.set("collection", String(n)), t?.limit != null && o.set("limit", String(t.limit)), t?.page != null && o.set("page", String(t.page)), t?.offset != null && o.set("offset", String(t.offset)), t?.order && o.set("order", String(t.order));
            const a = o.toString(), c = await this._request(`/workspaces/${s}/records${a ? `?${a}` : ""}`, {
                method: "GET",
                methodName: "records.list"
            }), i = c?.data ?? [];
            return c?.pagination && (i.pagination = c.pagination), i;
        },
        get: async (e, t)=>{
            const s = this._recordsWorkspaceId(null, t);
            return (await this._request(`/workspaces/${s}/records/${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "records.get"
            }))?.data ?? null;
        },
        create: async (e, t)=>{
            const s = this._recordsWorkspaceId(e, t), o = await this._request(`/workspaces/${s}/records`, {
                method: "POST",
                body: JSON.stringify(e || {}),
                methodName: "records.create"
            });
            return o?.data ?? o;
        },
        update: async (e, t, s)=>{
            const o = this._recordsWorkspaceId(t, s), n = await this._request(`/workspaces/${o}/records/${encodeURIComponent(e)}`, {
                method: "PATCH",
                body: JSON.stringify(t || {}),
                methodName: "records.update"
            });
            return n?.data ?? n;
        },
        subscribe: (e, t)=>{
            const s = e || {}, o = s.workspaceId || this._context?.activeWorkspaceId, n = this._recordsWorkspaceId(s, null), a = s.collection || s.collectionKey || "";
            let c = !1, i = 0;
            const r = (d)=>{
                if (!c) try {
                    t(d);
                } catch  {}
            }, h = ()=>{
                const d = ++i;
                this.records.list({
                    collection: a
                }, {
                    workspaceId: o
                }).then((w)=>{
                    c || d !== i || r({
                        type: "records.snapshot",
                        collection: a,
                        records: w
                    });
                }).catch(()=>{});
            }, l = this._sseSubscribe(`/workspaces/${n}/records/stream`, {
                collection: a
            }, (d)=>{
                r(d), d && d.type === "records.open" && h();
            }, {
                flatParams: !0,
                events: [
                    {
                        name: "records.open",
                        frame: (d)=>({
                                type: "records.open",
                                ...d
                            })
                    },
                    {
                        name: "records.change",
                        frame: (d)=>({
                                type: "records.change",
                                ...d
                            })
                    }
                ]
            });
            return ()=>{
                c = !0, l();
            };
        },
        remove: async (e, t)=>{
            const s = this._recordsWorkspaceId(null, t), o = await this._request(`/workspaces/${s}/records/${encodeURIComponent(e)}`, {
                method: "DELETE",
                methodName: "records.remove"
            });
            return o?.data ?? o;
        }
    };
    bookmarks = {
        enrich: async (e, t)=>{
            const s = this._recordsWorkspaceId(e, t), { workspaceId: o, ...n } = e && typeof e == "object" ? e : {}, a = await this._request(`/workspaces/${s}/bookmarks/enrich`, {
                method: "POST",
                body: JSON.stringify(n),
                methodName: "bookmarks.enrich"
            });
            return a?.data ?? a;
        }
    };
    userPreferences = {
        get: async ()=>(await this._request("/prefs/user", {
                method: "GET",
                methodName: "userPreferences.get"
            }))?.prefs ?? null,
        upsert: (e)=>this._request("/prefs/user", {
                method: "PUT",
                body: JSON.stringify({
                    payload: e
                }),
                methodName: "userPreferences.upsert"
            }).then((t)=>t?.prefs ?? t),
        patch: (e)=>this._request("/prefs/user", {
                method: "PATCH",
                body: JSON.stringify({
                    patch: e
                }),
                methodName: "userPreferences.patch"
            }).then((t)=>t?.prefs ?? t)
    };
    homeDashboardPrefs = {
        get: async (e)=>{
            const t = e?.workspaceId, s = t ? `?workspaceId=${encodeURIComponent(t)}` : "";
            return (await this._request(`/prefs/home-dashboard${s}`, {
                method: "GET",
                methodName: "homeDashboardPrefs.get"
            }))?.prefs ?? null;
        },
        upsert: (e, t)=>this._request("/prefs/home-dashboard", {
                method: "PUT",
                body: JSON.stringify({
                    payload: e,
                    ...t?.workspaceId ? {
                        workspaceId: t.workspaceId
                    } : {}
                }),
                methodName: "homeDashboardPrefs.upsert"
            }).then((s)=>s?.prefs ?? s)
    };
    workspaceDashboardDefaults = {
        get: async ()=>(await this._request("/prefs/workspace-defaults", {
                method: "GET",
                methodName: "workspaceDashboardDefaults.get"
            }))?.defaults ?? null,
        upsert: (e)=>this._request("/prefs/workspace-defaults", {
                method: "PUT",
                body: JSON.stringify({
                    payload: e
                }),
                methodName: "workspaceDashboardDefaults.upsert"
            }).then((t)=>t?.defaults ?? t)
    };
    widgetDefs = {
        list: async (e)=>{
            const t = e?.workspaceId, s = t ? `?workspaceId=${encodeURIComponent(t)}` : "", o = await this._request(`/widget-defs${s}`, {
                method: "GET",
                methodName: "widgetDefs.list"
            });
            return Array.isArray(o?.widgets) ? o.widgets : [];
        },
        create: async (e, t)=>{
            const s = await this._request("/widget-defs", {
                method: "POST",
                body: JSON.stringify({
                    widget: e,
                    ...t?.workspaceId ? {
                        workspaceId: t.workspaceId
                    } : {}
                }),
                methodName: "widgetDefs.create"
            });
            return s?.widget ?? s;
        },
        update: async (e, t, s)=>{
            const o = s?.workspaceId, n = o ? `?workspaceId=${encodeURIComponent(o)}` : "", a = await this._request(`/widget-defs/${encodeURIComponent(e)}${n}`, {
                method: "PATCH",
                body: JSON.stringify({
                    widget: t,
                    ...o ? {
                        workspaceId: o
                    } : {}
                }),
                methodName: "widgetDefs.update"
            });
            return a?.widget ?? a;
        },
        remove: async (e, t)=>{
            const s = t?.workspaceId, o = s ? `?workspaceId=${encodeURIComponent(s)}` : "";
            return this._request(`/widget-defs/${encodeURIComponent(e)}${o}`, {
                method: "DELETE",
                methodName: "widgetDefs.remove"
            });
        }
    };
    userProfiles = {
        update: (e, t)=>this._request("/user-profile", {
                method: "PATCH",
                body: JSON.stringify(t || {}),
                methodName: "userProfiles.update"
            }).then((s)=>s?.data ?? s)
    };
    _activityWorkspaceId(e, t) {
        const s = t && t.workspaceId || e && typeof e == "object" && e.workspaceId || this._context?.activeWorkspaceId;
        if (!s) throw new Error("[sdk activity] no workspace scope \u2014 pass { workspaceId } or set the SDK's activeWorkspaceId.");
        return encodeURIComponent(String(s));
    }
    standups = {
        list: (e, t)=>{
            const s = this._activityWorkspaceId(e, t), o = new URLSearchParams, n = e && typeof e == "object" && (e.author ?? e.author_email) || null;
            n && o.set("author", String(n)), e && typeof e == "object" && e.date && o.set("date", String(e.date)), t?.limit != null && o.set("limit", String(t.limit));
            const a = o.toString();
            return this._request(`/workspaces/${s}/standups${a ? `?${a}` : ""}`, {
                method: "GET",
                methodName: "standups.list"
            }).then((c)=>c?.data ?? []);
        },
        get: (e, t)=>{
            const s = this._activityWorkspaceId(null, t);
            return this._request(`/workspaces/${s}/standups/${encodeURIComponent(e)}`, {
                method: "GET",
                methodName: "standups.get"
            }).then((o)=>o?.data ?? null);
        },
        create: (e, t)=>{
            const s = this._activityWorkspaceId(e, t);
            return this._request(`/workspaces/${s}/standups`, {
                method: "POST",
                body: JSON.stringify(e || {}),
                methodName: "standups.create"
            }).then((o)=>o?.data ?? o);
        },
        update: (e, t, s)=>{
            const o = this._activityWorkspaceId(t, s);
            return this._request(`/workspaces/${o}/standups/${encodeURIComponent(e)}`, {
                method: "PATCH",
                body: JSON.stringify(t || {}),
                methodName: "standups.update"
            }).then((n)=>n?.data ?? n);
        },
        upsert: (e, t)=>{
            const s = this._activityWorkspaceId(e, t);
            return this._request(`/workspaces/${s}/standups`, {
                method: "POST",
                body: JSON.stringify(e || {}),
                methodName: "standups.upsert"
            }).then((o)=>o?.data ?? o);
        }
    };
    auditLog = {
        list: (e, t)=>{
            const s = this._activityWorkspaceId(e, t), o = t?.limit ?? (e && typeof e == "object" ? e.limit : null), n = o != null ? `?limit=${encodeURIComponent(String(o))}` : "";
            return this._request(`/workspaces/${s}/activity-log${n}`, {
                method: "GET",
                methodName: "auditLog.list"
            }).then((a)=>a?.data ?? []);
        }
    };
    i18n = {
        subscribeTranslations: (e, t)=>()=>{}
    };
    setRealtimeProvider(e) {
        this._realtimeProvider = typeof e == "function" ? e : null;
    }
    _realtimeSubscribe(e, t, s) {
        const o = this._realtimeProvider;
        if (typeof o != "function" || typeof s != "function") return ()=>{};
        try {
            const n = o({
                op: e,
                filter: t || {},
                callback: s
            });
            return typeof n == "function" ? n : ()=>{};
        } catch (n) {
            return console.warn(`[sdk.workspaceProject.realtime] provider failed for op '${e}':`, n?.message || n), ()=>{};
        }
    }
    realtime = {
        subscribeMessages: ({ channelId: e } = {}, t)=>this._realtimeSubscribe("chat.messages", {
                channelId: e
            }, t),
        subscribeChannels: (e = {}, t)=>this._realtimeSubscribe("chat.channels", e, t),
        subscribeMentions: ({ userEmail: e } = {}, t)=>this._realtimeSubscribe("chat.mentions", {
                userEmail: e
            }, t),
        subscribeNotifications: ({ userEmail: e } = {}, t)=>this._realtimeSubscribe("notifications", {
                userEmail: e
            }, t),
        subscribePresence: ({ scope: e = "workspace", userKey: t } = {}, s)=>this._realtimeSubscribe("presence", {
                scope: e,
                userKey: t
            }, s),
        subscribeMeet: ({ roomId: e, workspaceId: t, tables: s } = {}, o)=>this._realtimeSubscribe("meet", {
                roomId: e,
                workspaceId: t,
                tables: s
            }, o),
        subscribeMeetSse: ({ roomId: e, workspaceId: t, tables: s } = {}, o)=>{
            if (typeof o != "function") return ()=>{};
            const n = (r)=>{
                if (!(!r || !r.kind)) try {
                    o(r.kind, r.payload);
                } catch  {}
            }, a = (r)=>(h)=>({
                        kind: r,
                        payload: h
                    }), c = [
                {
                    name: "meet.snapshot",
                    frame: (r)=>({
                            kind: "meet.snapshot",
                            payload: r || {}
                        })
                },
                {
                    name: "meet.room.insert",
                    frame: a("room")
                },
                {
                    name: "meet.room.update",
                    frame: a("room")
                },
                {
                    name: "meet.room.delete",
                    frame: a("room")
                },
                {
                    name: "meet.waiting.insert",
                    frame: a("waiting")
                },
                {
                    name: "meet.waiting.update",
                    frame: a("waiting")
                },
                {
                    name: "meet.waiting.delete",
                    frame: a("waiting")
                },
                {
                    name: "meet.transcript.insert",
                    frame: a("transcript")
                },
                {
                    name: "meet.analysis.insert",
                    frame: a("analysis")
                },
                {
                    name: "meet.analysis.update",
                    frame: a("analysis")
                },
                {
                    name: "meet.revoked",
                    frame: ()=>{}
                }
            ], i = {};
            return e && (i.roomId = e), t && !e && (i.workspaceId = t), Array.isArray(s) && s.length ? i.tables = s.join(",") : typeof s == "string" && s && (i.tables = s), this._sseSubscribe("/meet/stream", i, n, {
                events: c,
                flatParams: !0
            });
        },
        subscribeChatSse: ({ workspaceId: e, channelIds: t, tables: s } = {}, o)=>{
            if (typeof o != "function") return ()=>{};
            const n = (m)=>{
                if (!(!m || !m.kind)) try {
                    o(m.kind, m.payload);
                } catch  {}
            }, a = Array.isArray(t) && t.length ? new Set(t.map((m)=>String(m))) : null, c = (m)=>m && (m.channel_id != null ? String(m.channel_id) : null), i = (m)=>!a || m != null && a.has(c(m)), r = (m, p, _)=>(f)=>{
                    const I = f?.[_];
                    return p !== "DELETE" && a && !i(I) || p === "DELETE" && a && !i(I) ? void 0 : {
                        kind: m,
                        payload: p === "DELETE" ? {
                            eventType: "DELETE",
                            new: null,
                            old: I
                        } : {
                            eventType: p,
                            new: I,
                            old: null
                        }
                    };
                }, h = (m)=>(p)=>{
                    const _ = r("chat.channels", m, "member")(p);
                    if (_) return _.payload._kind = "member", _;
                }, l = [
                {
                    name: "chat.snapshot",
                    frame: (m)=>({
                            kind: "chat.snapshot",
                            payload: m || {}
                        })
                },
                {
                    name: "chat.message.insert",
                    frame: r("chat.messages", "INSERT", "message")
                },
                {
                    name: "chat.message.update",
                    frame: r("chat.messages", "UPDATE", "message")
                },
                {
                    name: "chat.message.delete",
                    frame: r("chat.messages", "DELETE", "message")
                },
                {
                    name: "chat.channel.insert",
                    frame: r("chat.channels", "INSERT", "channel")
                },
                {
                    name: "chat.channel.update",
                    frame: r("chat.channels", "UPDATE", "channel")
                },
                {
                    name: "chat.channel.delete",
                    frame: r("chat.channels", "DELETE", "channel")
                },
                {
                    name: "chat.member.insert",
                    frame: h("INSERT")
                },
                {
                    name: "chat.member.update",
                    frame: h("UPDATE")
                },
                {
                    name: "chat.member.delete",
                    frame: h("DELETE")
                },
                {
                    name: "chat.mention.insert",
                    frame: r("chat.mentions", "INSERT", "mention")
                },
                {
                    name: "chat.typing",
                    frame: r("chat.typing", "TYPING", "typing")
                },
                {
                    name: "error",
                    frame: ()=>{}
                }
            ], d = {}, w = this._chatWorkspaceId(e);
            return w && (d.workspaceId = w), Array.isArray(s) && s.length ? d.tables = s.join(",") : typeof s == "string" && s && (d.tables = s), this._sseSubscribe("/chat/stream", d, n, {
                events: l,
                flatParams: !0
            });
        }
    };
    storage = {
        createSignedUrl: (e, t, s = 300)=>this._request(`/storage/${encodeURIComponent(e)}/signed-url`, {
                method: "POST",
                body: JSON.stringify({
                    path: t,
                    ttl: s
                }),
                methodName: "storage.createSignedUrl"
            }),
        upload: (e, t, s = {})=>(async ()=>{
                this._requireReady("storage.upload");
                const n = `${this._apiUrl}/core/storage/${encodeURIComponent(e)}/upload`, a = {
                    method: "POST",
                    body: t,
                    headers: {}
                }, c = await this._resolveAuthHeader();
                c && (a.headers.Authorization = c);
                const i = await fetch(n, a), r = await i.json().catch(()=>({}));
                if (!i.ok) throw new Error(r?.message || `HTTP ${i.status}`);
                return r;
            })(),
        remove: (e, t)=>this._request(`/storage/${encodeURIComponent(e)}/object`, {
                method: "DELETE",
                body: JSON.stringify({
                    path: t
                }),
                methodName: "storage.remove"
            }),
        publicUrl: (e, t)=>this._request(`/storage/${encodeURIComponent(e)}/public-url`, {
                method: "POST",
                body: JSON.stringify({
                    path: t
                }),
                methodName: "storage.publicUrl"
            }),
        download: (e, t)=>(async ()=>{
                this._requireReady("storage.download");
                const o = this._context?.activeWorkspaceId, n = o ? `?workspaceId=${encodeURIComponent(String(o))}` : "", a = `${this._apiUrl}/core/storage/${encodeURIComponent(e)}/download${n}`, c = {
                    method: "POST",
                    body: JSON.stringify({
                        path: t
                    }),
                    headers: {
                        "Content-Type": "application/json"
                    }
                }, i = await this._resolveAuthHeader();
                i && (c.headers.Authorization = i);
                const r = await fetch(a, c);
                if (!r.ok) {
                    const h = await r.json().catch(()=>({}));
                    throw new Error(h?.message || `HTTP ${r.status}`);
                }
                return r.text();
            })()
    };
    query = (e)=>this._ws("query", "/query", {
            method: "POST",
            body: e
        });
}

});

parcelRegister("3qLQL", function(module, exports) {

$parcel$export(module.exports, "AllocationRuleService", () => $27f8ead7c9c3d4d3$export$afa159c4256039cc);

var $em51x = parcelRequire("em51x");
class $27f8ead7c9c3d4d3$export$afa159c4256039cc extends (0, $em51x.BaseService) {
    async listRules(e) {
        this._requireReady("listRules");
        const r = e ? `?organizationId=${encodeURIComponent(e)}` : "", s = await this._request(`/allocation-rules${r}`, {
            method: "GET",
            methodName: "listRules"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async getRule(e) {
        if (this._requireReady("getRule"), !e) throw new Error("ruleId is required");
        const r = await this._request(`/allocation-rules/${e}`, {
            method: "GET",
            methodName: "getRule"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
    async createRule({ organizationId: e, workspaceId: r, policy: s, monthlyAllocation: a, priority: o }) {
        if (this._requireReady("createRule"), !e) throw new Error("organizationId is required");
        const t = await this._request("/allocation-rules", {
            method: "POST",
            body: JSON.stringify({
                organizationId: e,
                workspaceId: r,
                policy: s,
                monthlyAllocation: a,
                priority: o
            }),
            methodName: "createRule"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async updateRule(e, r) {
        if (this._requireReady("updateRule"), !e) throw new Error("ruleId is required");
        const s = await this._request(`/allocation-rules/${e}`, {
            method: "PATCH",
            body: JSON.stringify(r || {}),
            methodName: "updateRule"
        });
        if (s.success) return s.data;
        throw new Error(s.message);
    }
    async deleteRule(e) {
        if (this._requireReady("deleteRule"), !e) throw new Error("ruleId is required");
        const r = await this._request(`/allocation-rules/${e}`, {
            method: "DELETE",
            methodName: "deleteRule"
        });
        if (r.success) return r.data;
        throw new Error(r.message);
    }
}

});

parcelRegister("uPAry", function(module, exports) {

$parcel$export(module.exports, "SharedAssetService", () => $05cad18525f238a9$export$c32ad43c4c0f6d61);

var $em51x = parcelRequire("em51x");
class $05cad18525f238a9$export$c32ad43c4c0f6d61 extends (0, $em51x.BaseService) {
    async createAsset(s) {
        if (this._requireReady("createAsset"), !s || typeof s != "object") throw new Error("Asset body is required");
        const e = await this._request("/shared-assets", {
            method: "POST",
            body: JSON.stringify(s),
            methodName: "createAsset"
        });
        if (e.success) return e.data;
        throw new Error(e.message);
    }
    async listAssets(s = {}) {
        this._requireReady("listAssets");
        const e = new URLSearchParams;
        for (const [i, r] of Object.entries(s || {}))r != null && r !== "" && e.append(i, String(r));
        const t = e.toString(), a = t ? await this._request(`/shared-assets?${t}`, {
            method: "GET",
            methodName: "listAssets"
        }) : await this._request("/shared-assets", {
            method: "GET",
            methodName: "listAssets"
        });
        if (a.success) return a.data;
        throw new Error(a.message);
    }
    async getAsset(s) {
        if (this._requireReady("getAsset"), !s) throw new Error("id is required");
        const e = await this._request(`/shared-assets/${s}`, {
            method: "GET",
            methodName: "getAsset"
        });
        if (e.success) return e.data;
        throw new Error(e.message);
    }
    async updateAsset(s, e) {
        if (this._requireReady("updateAsset"), !s) throw new Error("id is required");
        const t = await this._request(`/shared-assets/${s}`, {
            method: "PATCH",
            body: JSON.stringify(e || {}),
            methodName: "updateAsset"
        });
        if (t.success) return t.data;
        throw new Error(t.message);
    }
    async deleteAsset(s) {
        if (this._requireReady("deleteAsset"), !s) throw new Error("id is required");
        const e = await this._request(`/shared-assets/${s}`, {
            method: "DELETE",
            methodName: "deleteAsset"
        });
        if (e.success) return e.data;
        throw new Error(e.message);
    }
}

});

parcelRegister("5hQ2H", function(module, exports) {

$parcel$export(module.exports, "CreditsService", () => $3d96e8d9511ac655$export$77f9bbaa869101e9);

var $em51x = parcelRequire("em51x");
class $3d96e8d9511ac655$export$77f9bbaa869101e9 extends (0, $em51x.BaseService) {
    async getRates() {
        return this._call("getRates", "/credits/rates");
    }
    async getProjectBalance(e) {
        if (!e) throw new Error("projectId is required");
        return this._call("getProjectBalance", `/projects/${e}/credits/balance`);
    }
    async getProjectLedger(e, { limit: r, cursor: t, reason: o } = {}) {
        if (this._requireReady("getProjectLedger"), !e) throw new Error("projectId is required");
        const s = new URLSearchParams;
        r != null && s.append("limit", String(r)), t && s.append("cursor", t), o && s.append("reason", o);
        const c = s.toString(), i = c ? await this._request(`/projects/${e}/credits/ledger?${c}`, {
            method: "GET",
            methodName: "getProjectLedger"
        }) : await this._request(`/projects/${e}/credits/ledger`, {
            method: "GET",
            methodName: "getProjectLedger"
        });
        return i?.success ? i.data : {
            items: []
        };
    }
    async getProjectSpendControls(e) {
        if (!e) throw new Error("projectId is required");
        return this._call("getProjectSpendControls", `/projects/${e}/credits/controls`);
    }
    async updateProjectSpendControls(e, r = {}) {
        if (!e) throw new Error("projectId is required");
        return this._call("updateProjectSpendControls", `/projects/${e}/credits/controls`, {
            method: "PUT",
            body: r
        });
    }
    async topupProjectCredits(e, { packs: r = 1, returnUrl: t } = {}) {
        if (!e) throw new Error("projectId is required");
        return this._call("topupProjectCredits", `/projects/${e}/credits/topup`, {
            method: "POST",
            body: {
                packs: r,
                ...t ? {
                    returnUrl: t
                } : {}
            }
        });
    }
}

});

parcelRegister("EyYmL", function(module, exports) {

$parcel$export(module.exports, "ProposedActionService", () => $079edd6166a061ba$export$66f641bf70d26ec7);

var $em51x = parcelRequire("em51x");
const $079edd6166a061ba$var$s = (n, o)=>{
    const e = new URLSearchParams(o || void 0);
    n && e.set("workspaceId", String(n));
    const t = e.toString();
    return t ? `?${t}` : "";
};
class $079edd6166a061ba$export$66f641bf70d26ec7 extends (0, $em51x.BaseService) {
    list(o = {}, e = {}) {
        const t = {};
        o.status && (t.status = o.status), o.entityType && (t.entityType = o.entityType), o.entityId && (t.entityId = o.entityId), o.actionKey && (t.actionKey = o.actionKey);
        const p = o.workspaceId || e.workspaceId;
        return this._call("proposedActions.list", `/proposed-actions${$079edd6166a061ba$var$s(p, t)}`);
    }
    get(o, { workspaceId: e } = {}) {
        return this._call("proposedActions.get", `/proposed-actions/${encodeURIComponent(o)}${$079edd6166a061ba$var$s(e)}`);
    }
    propose(o = {}, { workspaceId: e } = {}) {
        return this._call("proposedActions.propose", `/proposed-actions${$079edd6166a061ba$var$s(e)}`, {
            method: "POST",
            body: o
        });
    }
    create(o = {}, e = {}) {
        return this.propose(o, e);
    }
    approve(o, { workspaceId: e } = {}) {
        return this._call("proposedActions.approve", `/proposed-actions/${encodeURIComponent(o)}/approve${$079edd6166a061ba$var$s(e)}`, {
            method: "POST",
            body: {}
        });
    }
    reject(o, { workspaceId: e } = {}) {
        return this._call("proposedActions.reject", `/proposed-actions/${encodeURIComponent(o)}/reject${$079edd6166a061ba$var$s(e)}`, {
            method: "POST",
            body: {}
        });
    }
    setResult(o, e = {}, { workspaceId: t } = {}) {
        return this._call("proposedActions.setResult", `/proposed-actions/${encodeURIComponent(o)}/result${$079edd6166a061ba$var$s(t)}`, {
            method: "POST",
            body: e
        });
    }
}
const $079edd6166a061ba$export$a5389cb2745c6ee9 = (n)=>new $079edd6166a061ba$export$66f641bf70d26ec7(n);

});

parcelRegister("cHtb1", function(module, exports) {

$parcel$export(module.exports, "WorkflowService", () => $93f022162f427d7c$export$74cd158efb822d7b);

var $em51x = parcelRequire("em51x");
const $93f022162f427d7c$var$s = (t, o)=>{
    const e = new URLSearchParams(o || void 0);
    t && e.set("workspaceId", String(t));
    const r = e.toString();
    return r ? `?${r}` : "";
};
class $93f022162f427d7c$export$74cd158efb822d7b extends (0, $em51x.BaseService) {
    list(o = {}, e = {}) {
        const r = {};
        o.appliesTo && (r.appliesTo = o.appliesTo);
        const n = o.workspaceId || e.workspaceId;
        return this._call("workflows.list", `/workflows${$93f022162f427d7c$var$s(n, r)}`);
    }
    get(o, { workspaceId: e } = {}) {
        return this._call("workflows.get", `/workflows/${encodeURIComponent(o)}${$93f022162f427d7c$var$s(e)}`);
    }
    create(o = {}, { workspaceId: e } = {}) {
        return this._call("workflows.create", `/workflows${$93f022162f427d7c$var$s(e)}`, {
            method: "POST",
            body: o
        });
    }
    update(o, e = {}, { workspaceId: r } = {}) {
        return this._call("workflows.update", `/workflows/${encodeURIComponent(o)}${$93f022162f427d7c$var$s(r)}`, {
            method: "PATCH",
            body: e
        });
    }
    remove(o, { workspaceId: e } = {}) {
        return this._call("workflows.remove", `/workflows/${encodeURIComponent(o)}${$93f022162f427d7c$var$s(e)}`, {
            method: "DELETE"
        });
    }
}
const $93f022162f427d7c$export$6900f333cd6d6e73 = (t)=>new $93f022162f427d7c$export$74cd158efb822d7b(t);

});

parcelRegister("4SXQx", function(module, exports) {

$parcel$export(module.exports, "FieldDefService", () => $38eaa0d35d504d16$export$fbb6bcf8c73ab2dc);

var $em51x = parcelRequire("em51x");
const $38eaa0d35d504d16$var$s = (i, e)=>{
    const t = new URLSearchParams(e || void 0);
    i && t.set("workspaceId", String(i));
    const d = t.toString();
    return d ? `?${d}` : "";
};
class $38eaa0d35d504d16$export$fbb6bcf8c73ab2dc extends (0, $em51x.BaseService) {
    list(e = {}, t = {}) {
        const d = {};
        e.entityType && (d.entityType = e.entityType), (e.includeArchived || t.includeArchived) && (d.includeArchived = "true");
        const n = e.workspaceId || t.workspaceId;
        return this._call("fieldDefs.list", `/field-defs${$38eaa0d35d504d16$var$s(n, d)}`);
    }
    get(e, { workspaceId: t } = {}) {
        return this._call("fieldDefs.get", `/field-defs/${encodeURIComponent(e)}${$38eaa0d35d504d16$var$s(t)}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("fieldDefs.create", `/field-defs${$38eaa0d35d504d16$var$s(t)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: d } = {}) {
        return this._call("fieldDefs.update", `/field-defs/${encodeURIComponent(e)}${$38eaa0d35d504d16$var$s(d)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("fieldDefs.remove", `/field-defs/${encodeURIComponent(e)}${$38eaa0d35d504d16$var$s(t)}`, {
            method: "DELETE"
        });
    }
}
const $38eaa0d35d504d16$export$96e440378c80cbf7 = (i)=>new $38eaa0d35d504d16$export$fbb6bcf8c73ab2dc(i);

});

parcelRegister("eFRuB", function(module, exports) {

$parcel$export(module.exports, "RecordCollectionService", () => $aaee638b7cd5762f$export$c8a7a43086c180ed);

var $em51x = parcelRequire("em51x");
const $aaee638b7cd5762f$var$r = (t, o)=>{
    const e = new URLSearchParams(o || void 0);
    t && e.set("workspaceId", String(t));
    const c = e.toString();
    return c ? `?${c}` : "";
};
class $aaee638b7cd5762f$export$c8a7a43086c180ed extends (0, $em51x.BaseService) {
    list(o = {}, e = {}) {
        const c = {};
        (o.includeDeleted || e.includeDeleted) && (c.includeDeleted = "true");
        const l = o.workspaceId || e.workspaceId;
        return this._call("recordCollections.list", `/record-collections${$aaee638b7cd5762f$var$r(l, c)}`);
    }
    get(o, { workspaceId: e } = {}) {
        return this._call("recordCollections.get", `/record-collections/${encodeURIComponent(o)}${$aaee638b7cd5762f$var$r(e)}`);
    }
    create(o = {}, { workspaceId: e } = {}) {
        return this._call("recordCollections.create", `/record-collections${$aaee638b7cd5762f$var$r(e)}`, {
            method: "POST",
            body: o
        });
    }
    update(o, e = {}, { workspaceId: c } = {}) {
        return this._call("recordCollections.update", `/record-collections/${encodeURIComponent(o)}${$aaee638b7cd5762f$var$r(c)}`, {
            method: "PATCH",
            body: e
        });
    }
    remove(o, { workspaceId: e } = {}) {
        return this._call("recordCollections.remove", `/record-collections/${encodeURIComponent(o)}${$aaee638b7cd5762f$var$r(e)}`, {
            method: "DELETE"
        });
    }
}
const $aaee638b7cd5762f$export$e5f81c5eebedc856 = (t)=>new $aaee638b7cd5762f$export$c8a7a43086c180ed(t);

});

parcelRegister("fR4bG", function(module, exports) {

$parcel$export(module.exports, "PartyService", () => $b8af0dcb71227044$export$b86ebea21f3c7055);

var $em51x = parcelRequire("em51x");
const $b8af0dcb71227044$var$o = (r, e)=>{
    const t = new URLSearchParams(e || void 0);
    r && t.set("workspaceId", String(r));
    const s = t.toString();
    return s ? `?${s}` : "";
};
class $b8af0dcb71227044$export$b86ebea21f3c7055 extends (0, $em51x.BaseService) {
    list(e = {}, t = {}) {
        const s = {};
        e.kind && (s.kind = e.kind), e.role && (s.role = e.role), e.owner && (s.owner = e.owner), e.q && (s.q = e.q), e.taxId && (s.taxId = e.taxId), e.member && (s.member = e.member), (e.includeArchived || t.includeArchived) && (s.includeArchived = "true");
        const i = e.workspaceId || t.workspaceId;
        return this._call("parties.list", `/parties${$b8af0dcb71227044$var$o(i, s)}`);
    }
    get(e, { workspaceId: t } = {}) {
        return this._call("parties.get", `/parties/${encodeURIComponent(e)}${$b8af0dcb71227044$var$o(t)}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("parties.create", `/parties${$b8af0dcb71227044$var$o(t)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: s } = {}) {
        return this._call("parties.update", `/parties/${encodeURIComponent(e)}${$b8af0dcb71227044$var$o(s)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("parties.remove", `/parties/${encodeURIComponent(e)}${$b8af0dcb71227044$var$o(t)}`, {
            method: "DELETE"
        });
    }
    listRoles(e, { workspaceId: t } = {}) {
        return this._call("parties.listRoles", `/parties/${encodeURIComponent(e)}/roles${$b8af0dcb71227044$var$o(t)}`);
    }
    addRole(e, t = {}, { workspaceId: s } = {}) {
        return this._call("parties.addRole", `/parties/${encodeURIComponent(e)}/roles${$b8af0dcb71227044$var$o(s)}`, {
            method: "POST",
            body: t
        });
    }
    removeRole(e, t, { workspaceId: s } = {}) {
        return this._call("parties.removeRole", `/parties/${encodeURIComponent(e)}/roles/${encodeURIComponent(t)}${$b8af0dcb71227044$var$o(s)}`, {
            method: "DELETE"
        });
    }
    listRelationships(e, { workspaceId: t } = {}) {
        return this._call("parties.listRelationships", `/parties/${encodeURIComponent(e)}/relationships${$b8af0dcb71227044$var$o(t)}`);
    }
    addRelationship(e, t = {}, { workspaceId: s } = {}) {
        return this._call("parties.addRelationship", `/parties/${encodeURIComponent(e)}/relationships${$b8af0dcb71227044$var$o(s)}`, {
            method: "POST",
            body: t
        });
    }
    removeRelationship(e, { workspaceId: t } = {}) {
        return this._call("parties.removeRelationship", `/parties/relationships/${encodeURIComponent(e)}${$b8af0dcb71227044$var$o(t)}`, {
            method: "DELETE"
        });
    }
    listAllRelationships(e = {}, { workspaceId: t } = {}) {
        const s = {};
        e.kind && (s.kind = e.kind);
        const i = e.workspaceId || t;
        return this._call("parties.listAllRelationships", `/parties/relationships${$b8af0dcb71227044$var$o(i, s)}`);
    }
    setManagers(e = [], { workspaceId: t } = {}) {
        return this._call("parties.setManagers", `/parties/relationships/reports-to${$b8af0dcb71227044$var$o(t)}`, {
            method: "POST",
            body: {
                assignments: e
            }
        });
    }
}
const $b8af0dcb71227044$export$1bb41d915f1150ac = (r)=>new $b8af0dcb71227044$export$b86ebea21f3c7055(r);

});

parcelRegister("czCQ4", function(module, exports) {

$parcel$export(module.exports, "InteractionService", () => $9276e181ab8cade2$export$318a52a665410e47);

var $em51x = parcelRequire("em51x");
const $9276e181ab8cade2$var$i = (r, n)=>{
    const t = new URLSearchParams(n || void 0);
    r && t.set("workspaceId", String(r));
    const e = t.toString();
    return e ? `?${e}` : "";
}, $9276e181ab8cade2$var$u = [
    "status",
    "owner",
    "dueFrom",
    "dueTo",
    "followUpFrom",
    "followUpTo"
], $9276e181ab8cade2$var$y = [
    "limit",
    "offset",
    "page"
], $9276e181ab8cade2$var$I = (r)=>Array.isArray(r) ? r.map(String).join(",") : r instanceof Date ? r.toISOString() : String(r);
class $9276e181ab8cade2$export$318a52a665410e47 extends (0, $em51x.BaseService) {
    async list(n = {}, t = {}) {
        const e = {};
        n.partyId && (e.partyId = n.partyId), n.kind && (e.kind = n.kind), n.regardingType && (e.regardingType = n.regardingType), n.regardingId && (e.regardingId = n.regardingId), n.since && (e.since = n.since);
        for (const o of $9276e181ab8cade2$var$u)n[o] !== void 0 && n[o] !== null && n[o] !== "" && (e[o] = $9276e181ab8cade2$var$I(n[o]));
        const s = t.sort ?? n.sort;
        s && (e.sort = String(s));
        let d = !1;
        for (const o of $9276e181ab8cade2$var$y){
            const c = t[o] ?? n[o];
            c != null && c !== "" && (e[o] = String(c), d = !0);
        }
        const g = n.workspaceId || t.workspaceId;
        if (!d) return this._call("interactions.list", `/interactions${$9276e181ab8cade2$var$i(g, e)}`);
        this._requireReady("interactions.list");
        const a = await this._request(`/interactions${$9276e181ab8cade2$var$i(g, e)}`, {
            method: "GET",
            methodName: "interactions.list"
        });
        if (!a || a.success === !1) throw new Error(a?.message || "interactions.list failed");
        const m = Array.isArray(a.data) ? a.data : [];
        return a.pagination && (m.pagination = a.pagination), m;
    }
    myDay({ date: n, tz: t, workspaceId: e } = {}) {
        const s = {};
        return n && (s.date = String(n)), t && (s.tz = String(t)), this._call("interactions.myDay", `/interactions/my-day${$9276e181ab8cade2$var$i(e, s)}`);
    }
    markDone(n, t = {}, { workspaceId: e } = {}) {
        return this._call("interactions.markDone", `/interactions/${encodeURIComponent(n)}${$9276e181ab8cade2$var$i(e)}`, {
            method: "PATCH",
            body: {
                ...t,
                status: "done"
            }
        });
    }
    get(n, { workspaceId: t } = {}) {
        return this._call("interactions.get", `/interactions/${encodeURIComponent(n)}${$9276e181ab8cade2$var$i(t)}`);
    }
    create(n = {}, { workspaceId: t } = {}) {
        return this._call("interactions.create", `/interactions${$9276e181ab8cade2$var$i(t)}`, {
            method: "POST",
            body: n
        });
    }
    update(n, t = {}, { workspaceId: e } = {}) {
        return this._call("interactions.update", `/interactions/${encodeURIComponent(n)}${$9276e181ab8cade2$var$i(e)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(n, { workspaceId: t } = {}) {
        return this._call("interactions.remove", `/interactions/${encodeURIComponent(n)}${$9276e181ab8cade2$var$i(t)}`, {
            method: "DELETE"
        });
    }
}
const $9276e181ab8cade2$export$bbd74fafbccc5f92 = (r)=>new $9276e181ab8cade2$export$318a52a665410e47(r);

});

parcelRegister("3y8Ff", function(module, exports) {

$parcel$export(module.exports, "SegmentService", () => $295b449ea3630f76$export$6ac5e10e8a100d48);

var $em51x = parcelRequire("em51x");
const $295b449ea3630f76$var$n = (r, t)=>{
    const e = new URLSearchParams(t || void 0);
    r && e.set("workspaceId", String(r));
    const s = e.toString();
    return s ? `?${s}` : "";
};
class $295b449ea3630f76$export$6ac5e10e8a100d48 extends (0, $em51x.BaseService) {
    list(t = {}, e = {}) {
        const s = {};
        (t.includeDeleted || e.includeDeleted) && (s.includeDeleted = "true");
        const m = t.workspaceId || e.workspaceId;
        return this._call("segments.list", `/segments${$295b449ea3630f76$var$n(m, s)}`);
    }
    get(t, { workspaceId: e } = {}) {
        return this._call("segments.get", `/segments/${encodeURIComponent(t)}${$295b449ea3630f76$var$n(e)}`);
    }
    create(t = {}, { workspaceId: e } = {}) {
        return this._call("segments.create", `/segments${$295b449ea3630f76$var$n(e)}`, {
            method: "POST",
            body: t
        });
    }
    update(t, e = {}, { workspaceId: s } = {}) {
        return this._call("segments.update", `/segments/${encodeURIComponent(t)}${$295b449ea3630f76$var$n(s)}`, {
            method: "PATCH",
            body: e
        });
    }
    remove(t, { workspaceId: e } = {}) {
        return this._call("segments.remove", `/segments/${encodeURIComponent(t)}${$295b449ea3630f76$var$n(e)}`, {
            method: "DELETE"
        });
    }
    listMembers(t, { workspaceId: e } = {}) {
        return this._call("segments.listMembers", `/segments/${encodeURIComponent(t)}/members${$295b449ea3630f76$var$n(e)}`);
    }
}
const $295b449ea3630f76$export$d05082ff888c46ad = (r)=>new $295b449ea3630f76$export$6ac5e10e8a100d48(r);

});

parcelRegister("lEGsd", function(module, exports) {

$parcel$export(module.exports, "LeadService", () => $fc3e43e012174341$export$d1ef88524e640c87);

var $em51x = parcelRequire("em51x");

var $2Bvnl = parcelRequire("2Bvnl");
class $fc3e43e012174341$export$d1ef88524e640c87 extends (0, $em51x.BaseService) {
    async list(e = {}, t = {}) {
        this._requireReady("leads.list");
        const s = await this._request(`/leads${(0, $2Bvnl.crmQuery)(e, t)}`, {
            method: "GET",
            methodName: "leads.list"
        });
        return (0, $2Bvnl.crmRows)(s, "leads.list");
    }
    summary(e = {}, t = {}) {
        return this._call("leads.summary", `/leads/summary${(0, $2Bvnl.crmQuery)(e, t)}`);
    }
    pipelines({ workspaceId: e } = {}) {
        return this._call("leads.pipelines", `/leads/pipelines${(0, $2Bvnl.crmQuery)({
            workspaceId: e
        })}`);
    }
    get(e, { workspaceId: t } = {}) {
        return this._call("leads.get", `/leads/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: t
        })}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("leads.create", `/leads${(0, $2Bvnl.crmQuery)({
            workspaceId: t
        })}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: s } = {}) {
        return this._call("leads.update", `/leads/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`, {
            method: "PATCH",
            body: t
        });
    }
    move(e, { stage: t, pipeline: s, stageOrder: n } = {}, { workspaceId: d } = {}) {
        const a = {
            stage: t
        };
        return s !== void 0 && (a.pipeline = s), n !== void 0 && (a.stageOrder = n), this._call("leads.move", `/leads/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: d
        })}`, {
            method: "PATCH",
            body: a
        });
    }
    markLost(e, t = null, { workspaceId: s } = {}) {
        return this._call("leads.markLost", `/leads/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`, {
            method: "PATCH",
            body: {
                status: "lost",
                lossReason: t
            }
        });
    }
    reopen(e, { stage: t } = {}, { workspaceId: s } = {}) {
        return this._call("leads.reopen", `/leads/${encodeURIComponent(e)}/reopen${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`, {
            method: "POST",
            body: t ? {
                stage: t
            } : {}
        });
    }
    convert(e, t = {}, { workspaceId: s } = {}) {
        return this._call("leads.convert", `/leads/${encodeURIComponent(e)}/convert${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`, {
            method: "POST",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("leads.remove", `/leads/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: t
        })}`, {
            method: "DELETE"
        });
    }
    subscribe(e = {}, t) {
        if (typeof t != "function") throw new Error("leads.subscribe: onEvent must be a function");
        const n = (e && typeof e == "object" ? e : {}).workspaceId || this._context?.activeWorkspaceId;
        let d = !1;
        const a = (r)=>{
            if (!d) try {
                t(r);
            } catch  {}
        }, c = this._sseSubscribe("/leads/stream", {
            workspaceId: n
        }, a, {
            flatParams: !0,
            events: [
                {
                    name: "leads.open",
                    frame: (r)=>({
                            type: "leads.open",
                            ...r
                        })
                },
                {
                    name: "leads.change",
                    frame: (r)=>({
                            type: "leads.change",
                            ...r
                        })
                }
            ]
        });
        return ()=>{
            d = !0, c();
        };
    }
}
const $fc3e43e012174341$export$d82be99917388d33 = (l)=>new $fc3e43e012174341$export$d1ef88524e640c87(l);

});
parcelRegister("2Bvnl", function(module, exports) {

$parcel$export(module.exports, "crmQuery", () => $1e57600057185e42$export$46a223978b929a46);
$parcel$export(module.exports, "crmRows", () => $1e57600057185e42$export$f82c99a47a9a4a65);
const $1e57600057185e42$var$f = [
    "pipeline",
    "stage",
    "status",
    "owner",
    "party",
    "company",
    "q",
    "sourceChannel",
    "valueMin",
    "valueMax",
    "currency",
    "createdFrom",
    "createdTo",
    "expectedCloseFrom",
    "expectedCloseTo",
    "closedFrom",
    "closedTo",
    "updatedSince",
    "rotting",
    "hasNextActivity",
    "includeArchived"
], $1e57600057185e42$var$u = [
    "limit",
    "offset",
    "page",
    "sort"
], $1e57600057185e42$var$c = (e)=>Array.isArray(e) ? e.map(String).join(",") : e instanceof Date ? e.toISOString() : String(e), $1e57600057185e42$export$46a223978b929a46 = (e = {}, i = {})=>{
    const r = new URLSearchParams, n = e && typeof e == "object" ? e : {}, a = i && typeof i == "object" ? i : {};
    for (const t of $1e57600057185e42$var$f)n[t] !== void 0 && n[t] !== null && n[t] !== "" && r.set(t, $1e57600057185e42$var$c(n[t]));
    if (n.dimensions && typeof n.dimensions == "object") for (const [t, o] of Object.entries(n.dimensions))o != null && o !== "" && r.set(`dimension.${t}`, $1e57600057185e42$var$c(o));
    for (const t of $1e57600057185e42$var$u){
        const o = a[t] !== void 0 ? a[t] : n[t];
        o != null && o !== "" && r.set(t, $1e57600057185e42$var$c(o));
    }
    const s = n.workspaceId || a.workspaceId;
    s && r.set("workspaceId", String(s));
    const d = r.toString();
    return d ? `?${d}` : "";
}, $1e57600057185e42$export$f82c99a47a9a4a65 = (e, i)=>{
    if (!e || e.success === !1) throw new Error(e?.message || `${i} failed`);
    const r = Array.isArray(e.data) ? e.data : [];
    return e.pagination && (r.pagination = e.pagination), r;
};

});


parcelRegister("62BpU", function(module, exports) {

$parcel$export(module.exports, "DealService", () => $465ff4311c384329$export$e561bdb9b4153aa7);

var $em51x = parcelRequire("em51x");

var $2Bvnl = parcelRequire("2Bvnl");
class $465ff4311c384329$export$e561bdb9b4153aa7 extends (0, $em51x.BaseService) {
    async list(e = {}, s = {}) {
        this._requireReady("deals.list");
        const o = await this._request(`/deals${(0, $2Bvnl.crmQuery)(e, s)}`, {
            method: "GET",
            methodName: "deals.list"
        });
        return (0, $2Bvnl.crmRows)(o, "deals.list");
    }
    summary(e = {}, s = {}) {
        return this._call("deals.summary", `/deals/summary${(0, $2Bvnl.crmQuery)(e, s)}`);
    }
    pipelines({ workspaceId: e } = {}) {
        return this._call("deals.pipelines", `/deals/pipelines${(0, $2Bvnl.crmQuery)({
            workspaceId: e
        })}`);
    }
    get(e, { workspaceId: s } = {}) {
        return this._call("deals.get", `/deals/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`);
    }
    create(e = {}, { workspaceId: s } = {}) {
        return this._call("deals.create", `/deals${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`, {
            method: "POST",
            body: e
        });
    }
    update(e, s = {}, { workspaceId: o } = {}) {
        return this._call("deals.update", `/deals/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: o
        })}`, {
            method: "PATCH",
            body: s
        });
    }
    move(e, { stage: s, pipeline: o, stageOrder: d } = {}, { workspaceId: n } = {}) {
        const a = {
            stage: s
        };
        return o !== void 0 && (a.pipeline = o), d !== void 0 && (a.stageOrder = d), this._call("deals.move", `/deals/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: n
        })}`, {
            method: "PATCH",
            body: a
        });
    }
    markWon(e, { workspaceId: s } = {}) {
        return this._call("deals.markWon", `/deals/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`, {
            method: "PATCH",
            body: {
                status: "won"
            }
        });
    }
    markLost(e, s = null, { workspaceId: o } = {}) {
        return this._call("deals.markLost", `/deals/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: o
        })}`, {
            method: "PATCH",
            body: {
                status: "lost",
                lossReason: s
            }
        });
    }
    reopen(e, { stage: s } = {}, { workspaceId: o } = {}) {
        return this._call("deals.reopen", `/deals/${encodeURIComponent(e)}/reopen${(0, $2Bvnl.crmQuery)({
            workspaceId: o
        })}`, {
            method: "POST",
            body: s ? {
                stage: s
            } : {}
        });
    }
    remove(e, { workspaceId: s } = {}) {
        return this._call("deals.remove", `/deals/${encodeURIComponent(e)}${(0, $2Bvnl.crmQuery)({
            workspaceId: s
        })}`, {
            method: "DELETE"
        });
    }
}
const $465ff4311c384329$export$5026632a5ab3d0a8 = (l)=>new $465ff4311c384329$export$e561bdb9b4153aa7(l);

});

parcelRegister("90yaS", function(module, exports) {

$parcel$export(module.exports, "LeadSourceService", () => $68ee9f738a781d08$export$687873db9abe6bc);

var $em51x = parcelRequire("em51x");
const $68ee9f738a781d08$var$r = (a = {})=>{
    const e = new URLSearchParams;
    for (const [o, t] of Object.entries(a || {}))t == null || t === "" || e.set(o, Array.isArray(t) ? t.map(String).join(",") : t instanceof Date ? t.toISOString() : String(t));
    const s = e.toString();
    return s ? `?${s}` : "";
}, $68ee9f738a781d08$var$n = [
    "status",
    "source",
    "reason",
    "provider",
    "importRun",
    "since",
    "until"
];
class $68ee9f738a781d08$export$687873db9abe6bc extends (0, $em51x.BaseService) {
    list(e = {}, { workspaceId: s } = {}) {
        const { type: o, status: t, includeArchived: c } = e || {};
        return this._call("leadSources.list", `/lead-sources${$68ee9f738a781d08$var$r({
            type: o,
            status: t,
            includeArchived: c,
            workspaceId: s || e?.workspaceId
        })}`);
    }
    get(e, { workspaceId: s } = {}) {
        return this._call("leadSources.get", `/lead-sources/${encodeURIComponent(e)}${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`);
    }
    create(e = {}, { workspaceId: s } = {}) {
        return this._call("leadSources.create", `/lead-sources${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "POST",
            body: e
        });
    }
    update(e, s = {}, { workspaceId: o } = {}) {
        return this._call("leadSources.update", `/lead-sources/${encodeURIComponent(e)}${$68ee9f738a781d08$var$r({
            workspaceId: o
        })}`, {
            method: "PATCH",
            body: s
        });
    }
    archive(e, { workspaceId: s } = {}) {
        return this._call("leadSources.archive", `/lead-sources/${encodeURIComponent(e)}${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "DELETE"
        });
    }
    rotateSecret(e, { workspaceId: s } = {}) {
        return this._call("leadSources.rotateSecret", `/lead-sources/${encodeURIComponent(e)}/rotate-secret${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "POST",
            body: {}
        });
    }
    sendTestLead(e, s = {}, { workspaceId: o } = {}) {
        return this._call("leadSources.sendTestLead", `/lead-sources/${encodeURIComponent(e)}/test${$68ee9f738a781d08$var$r({
            workspaceId: o
        })}`, {
            method: "POST",
            body: {
                payload: s
            }
        });
    }
    getSettings({ workspaceId: e } = {}) {
        return this._call("leadSources.getSettings", `/lead-sources/settings${$68ee9f738a781d08$var$r({
            workspaceId: e
        })}`);
    }
    updateSettings(e = {}, { workspaceId: s } = {}) {
        return this._call("leadSources.updateSettings", `/lead-sources/settings${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "PATCH",
            body: e
        });
    }
    csvPresets({ workspaceId: e } = {}) {
        return this._call("leadSources.csvPresets", `/lead-sources/csv-presets${$68ee9f738a781d08$var$r({
            workspaceId: e
        })}`);
    }
    async listIssues(e = {}, s = {}) {
        this._requireReady("leadSources.listIssues");
        const o = {};
        for (const d of $68ee9f738a781d08$var$n)o[d] = e?.[d];
        const t = await this._request(`/lead-sources/issues${$68ee9f738a781d08$var$r({
            ...o,
            limit: s.limit,
            offset: s.offset,
            workspaceId: s.workspaceId || e?.workspaceId
        })}`, {
            method: "GET",
            methodName: "leadSources.listIssues"
        });
        if (!t || t.success === !1) throw new Error(t?.message || "leadSources.listIssues failed");
        const c = Array.isArray(t.data) ? t.data : [];
        return t.pagination && (c.pagination = t.pagination), c;
    }
    issuesSummary(e = {}, { workspaceId: s } = {}) {
        const o = {};
        for (const t of $68ee9f738a781d08$var$n)o[t] = e?.[t];
        return this._call("leadSources.issuesSummary", `/lead-sources/issues/summary${$68ee9f738a781d08$var$r({
            ...o,
            workspaceId: s || e?.workspaceId
        })}`);
    }
    retryIssue(e, { workspaceId: s } = {}) {
        return this._call("leadSources.retryIssue", `/lead-sources/issues/${encodeURIComponent(e)}/retry${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "POST",
            body: {}
        });
    }
    retryIssues(e = {}, { workspaceId: s } = {}) {
        return this._call("leadSources.retryIssues", `/lead-sources/issues/retry${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "POST",
            body: e
        });
    }
    getEvent(e, { workspaceId: s } = {}) {
        return this._call("leadSources.getEvent", `/lead-sources/events/${encodeURIComponent(e)}${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`);
    }
    leadTouches(e, { workspaceId: s } = {}) {
        return this._call("leadSources.leadTouches", `/lead-sources/leads/${encodeURIComponent(e)}/touches${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`);
    }
    importCsv(e = {}, { workspaceId: s } = {}) {
        return this._call("leadSources.importCsv", `/lead-sources/imports/csv${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "POST",
            body: e
        });
    }
    importBitrix24(e = {}, { workspaceId: s } = {}) {
        return this._call("leadSources.importBitrix24", `/lead-sources/imports/bitrix24${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "POST",
            body: e
        });
    }
    listImports(e = {}, { workspaceId: s } = {}) {
        return this._call("leadSources.listImports", `/lead-sources/imports${$68ee9f738a781d08$var$r({
            kind: e?.kind,
            limit: e?.limit,
            workspaceId: s || e?.workspaceId
        })}`);
    }
    getImport(e, { workspaceId: s } = {}) {
        return this._call("leadSources.getImport", `/lead-sources/imports/${encodeURIComponent(e)}${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`);
    }
    undoImport(e, { workspaceId: s } = {}) {
        return this._call("leadSources.undoImport", `/lead-sources/imports/${encodeURIComponent(e)}/undo${$68ee9f738a781d08$var$r({
            workspaceId: s
        })}`, {
            method: "POST",
            body: {}
        });
    }
    submitForm(e, s = {}) {
        return this._call("leadSources.submitForm", `/lead-sources/forms/${encodeURIComponent(e)}`, {
            method: "POST",
            body: s
        });
    }
}
const $68ee9f738a781d08$export$d06c527a32d17c58 = (a)=>new $68ee9f738a781d08$export$687873db9abe6bc(a);

});

parcelRegister("cI0b7", function(module, exports) {

$parcel$export(module.exports, "ChannelService", () => $9409bb888bfa7ccf$export$ad877c9653fa6220);

var $em51x = parcelRequire("em51x");
const $9409bb888bfa7ccf$var$t = (s = {})=>{
    const n = new URLSearchParams;
    for (const [a, c] of Object.entries(s || {}))c == null || c === "" || n.set(a, Array.isArray(c) ? c.map(String).join(",") : c instanceof Date ? c.toISOString() : String(c));
    const e = n.toString();
    return e ? `?${e}` : "";
}, $9409bb888bfa7ccf$var$i = [
    "channel",
    "status",
    "assignee",
    "unread",
    "accountId"
], $9409bb888bfa7ccf$var$h = [
    "partyId",
    "regardingType",
    "regardingId",
    "channel",
    "before"
], $9409bb888bfa7ccf$var$l = (s)=>{
    const n = Array.isArray(s?.data) ? s.data : [];
    return s?.pagination && (n.pagination = s.pagination), n;
};
class $9409bb888bfa7ccf$export$ad877c9653fa6220 extends (0, $em51x.BaseService) {
    listAccounts(n = {}, { workspaceId: e } = {}) {
        const { channel: a, status: c } = n || {};
        return this._call("channels.listAccounts", `/channels/accounts${$9409bb888bfa7ccf$var$t({
            channel: a,
            status: c,
            workspaceId: e || n?.workspaceId
        })}`);
    }
    getAccount(n, { workspaceId: e } = {}) {
        return this._call("channels.getAccount", `/channels/accounts/${encodeURIComponent(n)}${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`);
    }
    createAccount(n = {}, { workspaceId: e } = {}) {
        return this._call("channels.createAccount", `/channels/accounts${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "POST",
            body: n
        });
    }
    updateAccount(n, e = {}, { workspaceId: a } = {}) {
        return this._call("channels.updateAccount", `/channels/accounts/${encodeURIComponent(n)}${$9409bb888bfa7ccf$var$t({
            workspaceId: a
        })}`, {
            method: "PATCH",
            body: e
        });
    }
    disconnectAccount(n, { workspaceId: e } = {}) {
        return this._call("channels.disconnectAccount", `/channels/accounts/${encodeURIComponent(n)}${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "DELETE"
        });
    }
    rotateVerifyToken(n, { workspaceId: e } = {}) {
        return this._call("channels.rotateVerifyToken", `/channels/accounts/${encodeURIComponent(n)}/verify-token${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "POST",
            body: {}
        });
    }
    listTemplates(n, { workspaceId: e } = {}) {
        return this._call("channels.listTemplates", `/channels/accounts/${encodeURIComponent(n)}/templates${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`);
    }
    syncTemplates(n, { workspaceId: e } = {}) {
        return this._call("channels.syncTemplates", `/channels/accounts/${encodeURIComponent(n)}/templates/sync${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "POST",
            body: {}
        });
    }
    simulate(n, e = {}, { workspaceId: a } = {}) {
        return this._call("channels.simulate", `/channels/accounts/${encodeURIComponent(n)}/simulate${$9409bb888bfa7ccf$var$t({
            workspaceId: a
        })}`, {
            method: "POST",
            body: e
        });
    }
    getSettings({ workspaceId: n } = {}) {
        return this._call("channels.getSettings", `/channels/settings${$9409bb888bfa7ccf$var$t({
            workspaceId: n
        })}`);
    }
    updateSettings(n = {}, { workspaceId: e } = {}) {
        return this._call("channels.updateSettings", `/channels/settings${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "PATCH",
            body: n
        });
    }
    async inbox(n = {}, e = {}) {
        const a = {};
        for (const o of $9409bb888bfa7ccf$var$i)a[o] = n?.[o];
        const c = await this._call("channels.inbox", `/channels/inbox${$9409bb888bfa7ccf$var$t({
            ...a,
            limit: e.limit,
            offset: e.offset,
            workspaceId: e.workspaceId || n?.workspaceId
        })}`, {
            raw: !0
        });
        return $9409bb888bfa7ccf$var$l(c);
    }
    async timeline(n = {}, e = {}) {
        const a = {};
        for (const o of $9409bb888bfa7ccf$var$h)a[o] = n?.[o];
        const c = await this._call("channels.timeline", `/channels/timeline${$9409bb888bfa7ccf$var$t({
            ...a,
            limit: e.limit,
            workspaceId: e.workspaceId || n?.workspaceId
        })}`, {
            raw: !0
        });
        return $9409bb888bfa7ccf$var$l(c);
    }
    markRead(n, { workspaceId: e } = {}) {
        return this._call("channels.markRead", `/channels/conversations/${encodeURIComponent(n)}/read${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "POST",
            body: {}
        });
    }
    send(n = {}, { workspaceId: e } = {}) {
        return this._call("channels.send", `/channels/messages${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "POST",
            body: n
        });
    }
    startCall(n = {}, { workspaceId: e } = {}) {
        return this._call("channels.startCall", `/channels/calls${$9409bb888bfa7ccf$var$t({
            workspaceId: e
        })}`, {
            method: "POST",
            body: n
        });
    }
    logCallOutcome(n, e = {}, { workspaceId: a } = {}) {
        return this._call("channels.logCallOutcome", `/channels/calls/${encodeURIComponent(n)}${$9409bb888bfa7ccf$var$t({
            workspaceId: a
        })}`, {
            method: "PATCH",
            body: e
        });
    }
    simulateCall(n, e = {}, { workspaceId: a } = {}) {
        return this._call("channels.simulateCall", `/channels/calls/${encodeURIComponent(n)}/simulate${$9409bb888bfa7ccf$var$t({
            workspaceId: a
        })}`, {
            method: "POST",
            body: e
        });
    }
}
const $9409bb888bfa7ccf$export$6134b36416df934b = (s)=>new $9409bb888bfa7ccf$export$ad877c9653fa6220(s);

});

parcelRegister("eypFE", function(module, exports) {

$parcel$export(module.exports, "CrmService", () => $a9882754f528718e$export$5b844e4467ed798c);

var $em51x = parcelRequire("em51x");

var $2Bvnl = parcelRequire("2Bvnl");
class $a9882754f528718e$export$5b844e4467ed798c extends (0, $em51x.BaseService) {
    getSettings({ workspaceId: e } = {}) {
        return this._call("crm.getSettings", `/crm/settings${(0, $2Bvnl.crmQuery)({
            workspaceId: e
        })}`);
    }
    updateSettings(e = {}, { workspaceId: r } = {}) {
        return this._call("crm.updateSettings", `/crm/settings${(0, $2Bvnl.crmQuery)({
            workspaceId: r
        })}`, {
            method: "PATCH",
            body: e
        });
    }
    permissions({ workspaceId: e } = {}) {
        return this._call("crm.permissions", `/crm/permissions${(0, $2Bvnl.crmQuery)({
            workspaceId: e
        })}`);
    }
    migrateCrmDeals({ apply: e = !1 } = {}, { workspaceId: r } = {}) {
        return this._call("crm.migrateCrmDeals", `/crm/migrations/crm-deals${(0, $2Bvnl.crmQuery)({
            workspaceId: r
        })}`, {
            method: "POST",
            body: {
                apply: e === !0
            }
        });
    }
    homeCounts({ workspaceId: e, tz: r, horizonDays: m, bookingKind: n } = {}) {
        if (!e) return Promise.reject(new Error("crm.homeCounts: workspaceId is required \u2014 the home counts never fall back to the active workspace"));
        const i = {
            workspaceId: String(e),
            tz: r || $a9882754f528718e$var$a()
        };
        return m != null && m !== "" && (i.horizonDays = String(m)), n && (i.bookingKind = String(n)), this._call("crm.homeCounts", `/crm/home-counts?${new URLSearchParams(i)}`);
    }
}
const $a9882754f528718e$var$a = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    } catch  {
        return "UTC";
    }
}, $a9882754f528718e$export$fa9158a821e39ebc = (s)=>new $a9882754f528718e$export$5b844e4467ed798c(s);

});

parcelRegister("9BpV2", function(module, exports) {

$parcel$export(module.exports, "ProductService", () => $6fdbacb5f1d260b8$export$f4ea222e76e5ca5c);

var $em51x = parcelRequire("em51x");
const $6fdbacb5f1d260b8$var$o = (r, e)=>{
    const t = new URLSearchParams(e || void 0);
    r && t.set("workspaceId", String(r));
    const c = t.toString();
    return c ? `?${c}` : "";
};
class $6fdbacb5f1d260b8$export$f4ea222e76e5ca5c extends (0, $em51x.BaseService) {
    list(e = {}, t = {}) {
        const c = {};
        e.kind && (c.kind = e.kind), e.active !== void 0 && (c.active = String(e.active)), e.q && (c.q = e.q), (e.includeArchived || t.includeArchived) && (c.includeArchived = "true");
        const d = e.workspaceId || t.workspaceId;
        return this._call("products.list", `/products${$6fdbacb5f1d260b8$var$o(d, c)}`);
    }
    get(e, { workspaceId: t } = {}) {
        return this._call("products.get", `/products/${encodeURIComponent(e)}${$6fdbacb5f1d260b8$var$o(t)}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("products.create", `/products${$6fdbacb5f1d260b8$var$o(t)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: c } = {}) {
        return this._call("products.update", `/products/${encodeURIComponent(e)}${$6fdbacb5f1d260b8$var$o(c)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("products.remove", `/products/${encodeURIComponent(e)}${$6fdbacb5f1d260b8$var$o(t)}`, {
            method: "DELETE"
        });
    }
}
const $6fdbacb5f1d260b8$export$5b96c0293fd74684 = (r)=>new $6fdbacb5f1d260b8$export$f4ea222e76e5ca5c(r);

});

parcelRegister("6p5r3", function(module, exports) {

$parcel$export(module.exports, "PriceService", () => $013405578987dbab$export$a57a5736e95414f9);

var $em51x = parcelRequire("em51x");
const $013405578987dbab$var$i = (t, e)=>{
    const c = new URLSearchParams(e || void 0);
    t && c.set("workspaceId", String(t));
    const r = c.toString();
    return r ? `?${r}` : "";
};
class $013405578987dbab$export$a57a5736e95414f9 extends (0, $em51x.BaseService) {
    list(e = {}, c = {}) {
        const r = {};
        e.productId && (r.productId = e.productId), e.active !== void 0 && (r.active = String(e.active)), (e.includeArchived || c.includeArchived) && (r.includeArchived = "true");
        const s = e.workspaceId || c.workspaceId;
        return this._call("prices.list", `/prices${$013405578987dbab$var$i(s, r)}`);
    }
    get(e, { workspaceId: c } = {}) {
        return this._call("prices.get", `/prices/${encodeURIComponent(e)}${$013405578987dbab$var$i(c)}`);
    }
    create(e = {}, { workspaceId: c } = {}) {
        return this._call("prices.create", `/prices${$013405578987dbab$var$i(c)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, c = {}, { workspaceId: r } = {}) {
        return this._call("prices.update", `/prices/${encodeURIComponent(e)}${$013405578987dbab$var$i(r)}`, {
            method: "PATCH",
            body: c
        });
    }
    remove(e, { workspaceId: c } = {}) {
        return this._call("prices.remove", `/prices/${encodeURIComponent(e)}${$013405578987dbab$var$i(c)}`, {
            method: "DELETE"
        });
    }
}
const $013405578987dbab$export$53581d3897af2d2c = (t)=>new $013405578987dbab$export$a57a5736e95414f9(t);

});

parcelRegister("hEz4S", function(module, exports) {

$parcel$export(module.exports, "CompanyProfileService", () => $cda161c4ba87b747$export$d2404815f5329f7b);

var $em51x = parcelRequire("em51x");
const $cda161c4ba87b747$var$n = (e, r)=>{
    const o = new URLSearchParams(r || void 0);
    e && o.set("workspaceId", String(e));
    const t = o.toString();
    return t ? `?${t}` : "";
};
class $cda161c4ba87b747$export$d2404815f5329f7b extends (0, $em51x.BaseService) {
    get({ workspaceId: r } = {}) {
        return this._call("companyProfile.get", `/company-profile${$cda161c4ba87b747$var$n(r)}`);
    }
    update(r = {}, { workspaceId: o } = {}) {
        return this._call("companyProfile.update", `/company-profile${$cda161c4ba87b747$var$n(o)}`, {
            method: "PATCH",
            body: r
        });
    }
}
const $cda161c4ba87b747$export$b4dae7c4d1c73105 = (e)=>new $cda161c4ba87b747$export$d2404815f5329f7b(e);

});

parcelRegister("dXbir", function(module, exports) {

$parcel$export(module.exports, "AgreementService", () => $a2898c4d740a3c85$export$824c5129188ee5fa);

var $em51x = parcelRequire("em51x");
const $a2898c4d740a3c85$var$r = (a, e)=>{
    const t = new URLSearchParams(e || void 0);
    a && t.set("workspaceId", String(a));
    const n = t.toString();
    return n ? `?${n}` : "";
}, $a2898c4d740a3c85$var$s = (a)=>a instanceof Date ? a.toISOString() : String(a);
class $a2898c4d740a3c85$export$824c5129188ee5fa extends (0, $em51x.BaseService) {
    list(e = {}, t = {}) {
        e = e || {};
        const n = {};
        e.kind && (n.kind = e.kind), e.status && (n.status = e.status), e.partyId && (n.partyId = e.partyId), e.q && (n.q = e.q), e.createdFrom && (n.createdFrom = $a2898c4d740a3c85$var$s(e.createdFrom)), e.createdTo && (n.createdTo = $a2898c4d740a3c85$var$s(e.createdTo));
        const o = e.workspaceId || t.workspaceId;
        return this._call("agreements.list", `/agreements${$a2898c4d740a3c85$var$r(o, n)}`);
    }
    get(e, { workspaceId: t } = {}) {
        return this._call("agreements.get", `/agreements/${encodeURIComponent(e)}${$a2898c4d740a3c85$var$r(t)}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("agreements.create", `/agreements${$a2898c4d740a3c85$var$r(t)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: n } = {}) {
        return this._call("agreements.update", `/agreements/${encodeURIComponent(e)}${$a2898c4d740a3c85$var$r(n)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("agreements.remove", `/agreements/${encodeURIComponent(e)}${$a2898c4d740a3c85$var$r(t)}`, {
            method: "DELETE"
        });
    }
}
const $a2898c4d740a3c85$export$703a91939632f051 = (a)=>new $a2898c4d740a3c85$export$824c5129188ee5fa(a);

});

parcelRegister("g2Zqa", function(module, exports) {

$parcel$export(module.exports, "InvoiceService", () => $baec7a32ac5457ef$export$6c32f12fb7437c39);

var $em51x = parcelRequire("em51x");
const $baec7a32ac5457ef$var$n = (i, e)=>{
    const o = new URLSearchParams(e || void 0);
    i && o.set("workspaceId", String(i));
    const t = o.toString();
    return t ? `?${t}` : "";
};
class $baec7a32ac5457ef$export$6c32f12fb7437c39 extends (0, $em51x.BaseService) {
    list(e = {}, o = {}) {
        e = e || {};
        const t = {};
        e.direction && (t.direction = e.direction), e.status && (t.status = e.status), e.partyId && (t.partyId = e.partyId);
        const s = e.agreement || e.agreementId;
        s && (t.agreement = s), (e.overdue || o.overdue) && (t.overdue = "true");
        const c = e.workspaceId || o.workspaceId;
        return this._call("invoices.list", `/invoices${$baec7a32ac5457ef$var$n(c, t)}`);
    }
    get(e, { workspaceId: o } = {}) {
        return this._call("invoices.get", `/invoices/${encodeURIComponent(e)}${$baec7a32ac5457ef$var$n(o)}`);
    }
    create(e = {}, { workspaceId: o } = {}) {
        return this._call("invoices.create", `/invoices${$baec7a32ac5457ef$var$n(o)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, o = {}, { workspaceId: t } = {}) {
        return this._call("invoices.update", `/invoices/${encodeURIComponent(e)}${$baec7a32ac5457ef$var$n(t)}`, {
            method: "PATCH",
            body: o
        });
    }
    issue(e, { workspaceId: o } = {}) {
        return this._call("invoices.issue", `/invoices/${encodeURIComponent(e)}/issue${$baec7a32ac5457ef$var$n(o)}`, {
            method: "POST"
        });
    }
    remove(e, { workspaceId: o } = {}) {
        return this._call("invoices.remove", `/invoices/${encodeURIComponent(e)}${$baec7a32ac5457ef$var$n(o)}`, {
            method: "DELETE"
        });
    }
    void(e, o = {}, { workspaceId: t } = {}) {
        return this._call("invoices.void", `/invoices/${encodeURIComponent(e)}/void${$baec7a32ac5457ef$var$n(t)}`, {
            method: "POST",
            body: {
                reason: o?.reason ?? null
            }
        });
    }
    createCreditNote(e, o = {}, { workspaceId: t } = {}) {
        return this._call("invoices.createCreditNote", `/invoices/${encodeURIComponent(e)}/credit-notes${$baec7a32ac5457ef$var$n(t)}`, {
            method: "POST",
            body: o
        });
    }
    listCreditNotes(e, { workspaceId: o } = {}) {
        return this._call("invoices.listCreditNotes", `/invoices/${encodeURIComponent(e)}/credit-notes${$baec7a32ac5457ef$var$n(o)}`);
    }
}
const $baec7a32ac5457ef$export$8d89bbc47259f11b = (i)=>new $baec7a32ac5457ef$export$6c32f12fb7437c39(i);

});

parcelRegister("8AFid", function(module, exports) {

$parcel$export(module.exports, "TransactionService", () => $6411b765b29c86fc$export$985c8653d1398450);

var $em51x = parcelRequire("em51x");
const $6411b765b29c86fc$var$s = (a, t)=>{
    const n = new URLSearchParams(t || void 0);
    a && n.set("workspaceId", String(a));
    const e = n.toString();
    return e ? `?${e}` : "";
};
class $6411b765b29c86fc$export$985c8653d1398450 extends (0, $em51x.BaseService) {
    list(t = {}, n = {}) {
        const e = {};
        t.kind && (e.kind = t.kind), t.partyId && (e.partyId = t.partyId), t.invoiceId && (e.invoiceId = t.invoiceId);
        const o = t.workspaceId || n.workspaceId;
        return this._call("transactions.list", `/transactions${$6411b765b29c86fc$var$s(o, e)}`);
    }
    get(t, { workspaceId: n } = {}) {
        return this._call("transactions.get", `/transactions/${encodeURIComponent(t)}${$6411b765b29c86fc$var$s(n)}`);
    }
    create(t = {}, { workspaceId: n } = {}) {
        return this._call("transactions.create", `/transactions${$6411b765b29c86fc$var$s(n)}`, {
            method: "POST",
            body: t
        });
    }
    update(t, n = {}, { workspaceId: e } = {}) {
        return this._call("transactions.update", `/transactions/${encodeURIComponent(t)}${$6411b765b29c86fc$var$s(e)}`, {
            method: "PATCH",
            body: n
        });
    }
    remove(t, { workspaceId: n } = {}) {
        return this._call("transactions.remove", `/transactions/${encodeURIComponent(t)}${$6411b765b29c86fc$var$s(n)}`, {
            method: "DELETE"
        });
    }
}
const $6411b765b29c86fc$export$299e8d74e696d53c = (a)=>new $6411b765b29c86fc$export$985c8653d1398450(a);

});

parcelRegister("SoT0z", function(module, exports) {

$parcel$export(module.exports, "CommentService", () => $0a385925ab3fb688$export$f0c6d5b94cf85967);

var $em51x = parcelRequire("em51x");
const $0a385925ab3fb688$var$s = (o, e)=>{
    const t = new URLSearchParams(e || void 0);
    o && t.set("workspaceId", String(o));
    const n = t.toString();
    return n ? `?${n}` : "";
};
class $0a385925ab3fb688$export$f0c6d5b94cf85967 extends (0, $em51x.BaseService) {
    list(e = {}, t = {}) {
        const n = {};
        e.entityType != null && (n.entityType = e.entityType), e.entityId != null && (n.entityId = e.entityId);
        const m = e.workspaceId || t.workspaceId;
        return this._call("comments.list", `/comments${$0a385925ab3fb688$var$s(m, n)}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("comments.create", `/comments${$0a385925ab3fb688$var$s(t)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: n } = {}) {
        return this._call("comments.update", `/comments/${encodeURIComponent(e)}${$0a385925ab3fb688$var$s(n)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("comments.remove", `/comments/${encodeURIComponent(e)}${$0a385925ab3fb688$var$s(t)}`, {
            method: "DELETE"
        });
    }
}
const $0a385925ab3fb688$export$72c42a90d67d327e = (o)=>new $0a385925ab3fb688$export$f0c6d5b94cf85967(o);

});

parcelRegister("gbH35", function(module, exports) {

$parcel$export(module.exports, "AttachmentService", () => $bc8f110488ea6dea$export$6853f1e422640e54);

var $em51x = parcelRequire("em51x");
const $bc8f110488ea6dea$var$s = (a, t)=>{
    const e = new URLSearchParams(t || void 0);
    a && e.set("workspaceId", String(a));
    const n = e.toString();
    return n ? `?${n}` : "";
};
class $bc8f110488ea6dea$export$6853f1e422640e54 extends (0, $em51x.BaseService) {
    list(t = {}, e = {}) {
        const n = {};
        t.entityType != null && (n.entityType = t.entityType), t.entityId != null && (n.entityId = t.entityId);
        const c = t.workspaceId || e.workspaceId;
        return this._call("attachments.list", `/attachments${$bc8f110488ea6dea$var$s(c, n)}`);
    }
    create(t = {}, { workspaceId: e } = {}) {
        return this._call("attachments.create", `/attachments${$bc8f110488ea6dea$var$s(e)}`, {
            method: "POST",
            body: t
        });
    }
    remove(t, { workspaceId: e } = {}) {
        return this._call("attachments.remove", `/attachments/${encodeURIComponent(t)}${$bc8f110488ea6dea$var$s(e)}`, {
            method: "DELETE"
        });
    }
}
const $bc8f110488ea6dea$export$d1bdfa7122d4c267 = (a)=>new $bc8f110488ea6dea$export$6853f1e422640e54(a);

});

parcelRegister("ed6J1", function(module, exports) {

$parcel$export(module.exports, "WatcherService", () => $a5877f0ce8f882d6$export$11fef6f5efe51d68);

var $em51x = parcelRequire("em51x");
const $a5877f0ce8f882d6$var$c = (n, t)=>{
    const s = new URLSearchParams(t || void 0);
    n && s.set("workspaceId", String(n));
    const e = s.toString();
    return e ? `?${e}` : "";
};
class $a5877f0ce8f882d6$export$11fef6f5efe51d68 extends (0, $em51x.BaseService) {
    list(t = {}, s = {}) {
        const e = {};
        t.entityType != null && (e.entityType = t.entityType), t.entityId != null && (e.entityId = t.entityId), t.userEmail != null && (e.userEmail = t.userEmail);
        const a = t.workspaceId || s.workspaceId;
        return this._call("watchers.list", `/watchers${$a5877f0ce8f882d6$var$c(a, e)}`);
    }
    watch(t = {}, { workspaceId: s } = {}) {
        return this._call("watchers.watch", `/watchers${$a5877f0ce8f882d6$var$c(s)}`, {
            method: "POST",
            body: t
        });
    }
    unwatch(t = {}, s = {}) {
        const e = {};
        t.entityType != null && (e.entityType = t.entityType), t.entityId != null && (e.entityId = t.entityId), t.userEmail != null && (e.userEmail = t.userEmail);
        const a = t.workspaceId || s.workspaceId;
        return this._call("watchers.unwatch", `/watchers${$a5877f0ce8f882d6$var$c(a, e)}`, {
            method: "DELETE"
        });
    }
}
const $a5877f0ce8f882d6$export$c017144b7e854417 = (n)=>new $a5877f0ce8f882d6$export$11fef6f5efe51d68(n);

});

parcelRegister("5pEx7", function(module, exports) {

$parcel$export(module.exports, "ActivityEntryService", () => $3f0eba9d086cfc65$export$a96ecc84449fb414);

var $em51x = parcelRequire("em51x");
const $3f0eba9d086cfc65$var$a = (n, t)=>{
    const e = new URLSearchParams(t || void 0);
    n && e.set("workspaceId", String(n));
    const i = e.toString();
    return i ? `?${i}` : "";
};
class $3f0eba9d086cfc65$export$a96ecc84449fb414 extends (0, $em51x.BaseService) {
    list(t = {}, e = {}) {
        const i = {};
        t.entityType != null && (i.entityType = t.entityType), t.entityId != null && (i.entityId = t.entityId);
        const s = t.since ?? e.since, c = t.limit ?? e.limit;
        s != null && (i.since = s), c != null && (i.limit = c);
        const r = t.workspaceId || e.workspaceId;
        return this._call("activityEntries.list", `/activity-entries${$3f0eba9d086cfc65$var$a(r, i)}`);
    }
}
const $3f0eba9d086cfc65$export$9b42bc5ff7ef3552 = (n)=>new $3f0eba9d086cfc65$export$a96ecc84449fb414(n);

});

parcelRegister("18tk4", function(module, exports) {

$parcel$export(module.exports, "TagService", () => $0d3d48b0fc26c99e$export$537ee2fb98769370);

var $em51x = parcelRequire("em51x");
const $0d3d48b0fc26c99e$var$a = (r, e)=>{
    const t = new URLSearchParams(e || void 0);
    r && t.set("workspaceId", String(r));
    const s = t.toString();
    return s ? `?${s}` : "";
};
class $0d3d48b0fc26c99e$export$537ee2fb98769370 extends (0, $em51x.BaseService) {
    list(e = {}, t = {}) {
        const s = {};
        e.group != null && (s.group = e.group);
        const o = e.workspaceId || t.workspaceId;
        return this._call("tags.list", `/tags${$0d3d48b0fc26c99e$var$a(o, s)}`);
    }
    get(e, { workspaceId: t } = {}) {
        return this._call("tags.get", `/tags/${encodeURIComponent(e)}${$0d3d48b0fc26c99e$var$a(t)}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("tags.create", `/tags${$0d3d48b0fc26c99e$var$a(t)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: s } = {}) {
        return this._call("tags.update", `/tags/${encodeURIComponent(e)}${$0d3d48b0fc26c99e$var$a(s)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("tags.remove", `/tags/${encodeURIComponent(e)}${$0d3d48b0fc26c99e$var$a(t)}`, {
            method: "DELETE"
        });
    }
}
const $0d3d48b0fc26c99e$export$aef79b5332e30eaa = (r)=>new $0d3d48b0fc26c99e$export$537ee2fb98769370(r);

});

parcelRegister("7GVWM", function(module, exports) {

$parcel$export(module.exports, "RegistryService", () => $599967ba8dc153cf$export$9e0de942f65dac83);

var $em51x = parcelRequire("em51x");
class $599967ba8dc153cf$export$9e0de942f65dac83 extends (0, $em51x.BaseService) {
    frStatus() {
        return this._call("registry.frStatus", "/registry/fr/status");
    }
    frSearch(r, { limit: t } = {}) {
        const e = new URLSearchParams({
            q: String(r ?? "")
        });
        return t != null && e.set("limit", String(t)), this._call("registry.frSearch", `/registry/fr/search?${e.toString()}`);
    }
    frCompany(r) {
        return this._call("registry.frCompany", `/registry/fr/company/${encodeURIComponent(String(r ?? ""))}`);
    }
}

});

parcelRegister("lVGN7", function(module, exports) {

$parcel$export(module.exports, "BookingService", () => $ff701d5121d17d7f$export$2fedf75feaa5759f);

var $em51x = parcelRequire("em51x");
const $ff701d5121d17d7f$var$s = (t, o)=>{
    const n = new URLSearchParams(o || void 0);
    t && n.set("workspaceId", String(t));
    const e = n.toString();
    return e ? `?${e}` : "";
};
class $ff701d5121d17d7f$export$2fedf75feaa5759f extends (0, $em51x.BaseService) {
    list(o = {}, n = {}) {
        const e = {};
        o.status && (e.status = o.status), o.party && (e.party = o.party), o.host && (e.host = o.host), o.kind && (e.kind = o.kind), o.since && (e.since = o.since);
        const i = o.workspaceId || n.workspaceId;
        return this._call("bookings.list", `/bookings${$ff701d5121d17d7f$var$s(i, e)}`);
    }
    get(o, { workspaceId: n } = {}) {
        return this._call("bookings.get", `/bookings/${encodeURIComponent(o)}${$ff701d5121d17d7f$var$s(n)}`);
    }
    create(o = {}, { workspaceId: n } = {}) {
        return this._call("bookings.create", `/bookings${$ff701d5121d17d7f$var$s(n)}`, {
            method: "POST",
            body: o
        });
    }
    update(o, n = {}, { workspaceId: e } = {}) {
        return this._call("bookings.update", `/bookings/${encodeURIComponent(o)}${$ff701d5121d17d7f$var$s(e)}`, {
            method: "PATCH",
            body: n
        });
    }
    confirm(o, { workspaceId: n } = {}) {
        return this._call("bookings.confirm", `/bookings/${encodeURIComponent(o)}/confirm${$ff701d5121d17d7f$var$s(n)}`, {
            method: "POST"
        });
    }
    remove(o, { workspaceId: n } = {}) {
        return this._call("bookings.remove", `/bookings/${encodeURIComponent(o)}${$ff701d5121d17d7f$var$s(n)}`, {
            method: "DELETE"
        });
    }
}
const $ff701d5121d17d7f$export$996e624e894888cc = (t)=>new $ff701d5121d17d7f$export$2fedf75feaa5759f(t);

});

parcelRegister("4WnFd", function(module, exports) {

$parcel$export(module.exports, "AvailabilityRuleService", () => $398eef5a7a28c4e0$export$a0e6c5201c08faeb);

var $em51x = parcelRequire("em51x");
const $398eef5a7a28c4e0$var$a = (i, e)=>{
    const t = new URLSearchParams(e || void 0);
    i && t.set("workspaceId", String(i));
    const o = t.toString();
    return o ? `?${o}` : "";
}, $398eef5a7a28c4e0$var$p = (i, e)=>{
    const t = new Intl.DateTimeFormat("en-US", {
        timeZone: e,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23"
    }).formatToParts(i).reduce((r, { type: s, value: n })=>(s !== "literal" && (r[s] = Number(n)), r), {});
    return Date.UTC(t.year, t.month - 1, t.day, t.hour, t.minute, t.second) - i.getTime();
}, $398eef5a7a28c4e0$var$c = (i, e, t, o, r, s)=>{
    const n = Date.UTC(i, e, t, o, r);
    return new Date(n - $398eef5a7a28c4e0$var$p(new Date(n), s));
}, $398eef5a7a28c4e0$var$v = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6
}, $398eef5a7a28c4e0$var$u = (i, e)=>{
    const t = new Intl.DateTimeFormat("en-US", {
        timeZone: e,
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23"
    }).formatToParts(i).reduce((o, { type: r, value: s })=>(o[r] = s, o), {});
    return {
        dow: $398eef5a7a28c4e0$var$v[t.weekday],
        hours: Number(t.hour),
        minutes: Number(t.minute)
    };
}, $398eef5a7a28c4e0$var$b = (i)=>{
    const e = {
        timeBlocks: [],
        tz: i[0].tz
    }, t = new Date, o = t.getUTCFullYear(), r = t.getUTCMonth(), s = t.getUTCDate() - t.getUTCDay();
    for (const n of i[0].weekly){
        const [m, d] = n.from.split(":").map(Number), [f, h] = n.to.split(":").map(Number), l = s + n.dow;
        e.timeBlocks.push({
            from: $398eef5a7a28c4e0$var$c(o, r, l, m, d, e.tz),
            to: $398eef5a7a28c4e0$var$c(o, r, l, f, h, e.tz)
        });
    }
    return e;
}, $398eef5a7a28c4e0$var$g = (i, e)=>{
    let t = {};
    t.timeBlocks = [];
    for (const o of i.timeBlocks)for (const r of e.timeBlocks)o.from < r.to && o.to > r.from && t.timeBlocks.push({
        from: o.from > r.from ? o.from : r.from,
        to: o.to < r.to ? o.to : r.to
    });
    return t;
}, $398eef5a7a28c4e0$var$w = (i)=>{
    if (!i.timeBlocks || i.timeBlocks.length === 0) return [];
    const e = [];
    for (const t of i.timeBlocks){
        const o = $398eef5a7a28c4e0$var$u(t.from, i.tz), r = $398eef5a7a28c4e0$var$u(t.to, i.tz);
        e.push({
            dow: o.dow,
            from: `${o.hours}:${String(o.minutes).padStart(2, "0")}`,
            to: `${r.hours}:${String(r.minutes).padStart(2, "0")}`
        });
    }
    return e;
};
class $398eef5a7a28c4e0$export$a0e6c5201c08faeb extends (0, $em51x.BaseService) {
    list(e = {}, t = {}) {
        const o = {};
        e.user && (o.user = e.user);
        const r = e.workspaceId || t.workspaceId;
        return this._call("availabilityRules.list", `/availability-rules${$398eef5a7a28c4e0$var$a(r, o)}`);
    }
    async intersect(e, t) {
        if (!e || e.length === 0) return [];
        const o = await Promise.all(e.map((n)=>this.list({
                user: n,
                workspaceId: t
            }))), r = [];
        for (const n of o){
            if (!n || n.length === 0) return [];
            r.push($398eef5a7a28c4e0$var$b(n));
        }
        let s = r[0];
        for (const n of r.slice(1))s = $398eef5a7a28c4e0$var$g(s, n);
        return s.tz = r[0].tz, $398eef5a7a28c4e0$var$w(s);
    }
    get(e, { workspaceId: t } = {}) {
        return this._call("availabilityRules.get", `/availability-rules/${encodeURIComponent(e)}${$398eef5a7a28c4e0$var$a(t)}`);
    }
    create(e = {}, { workspaceId: t } = {}) {
        return this._call("availabilityRules.create", `/availability-rules${$398eef5a7a28c4e0$var$a(t)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, t = {}, { workspaceId: o } = {}) {
        return this._call("availabilityRules.update", `/availability-rules/${encodeURIComponent(e)}${$398eef5a7a28c4e0$var$a(o)}`, {
            method: "PATCH",
            body: t
        });
    }
    remove(e, { workspaceId: t } = {}) {
        return this._call("availabilityRules.remove", `/availability-rules/${encodeURIComponent(e)}${$398eef5a7a28c4e0$var$a(t)}`, {
            method: "DELETE"
        });
    }
}
const $398eef5a7a28c4e0$export$82c1bfa78c169c45 = (i)=>new $398eef5a7a28c4e0$export$a0e6c5201c08faeb(i);

});

parcelRegister("d3wfo", function(module, exports) {

$parcel$export(module.exports, "ConversationService", () => $981491d31a617ff7$export$4097a1a257609c41);

var $em51x = parcelRequire("em51x");
const $981491d31a617ff7$var$o = (t, e)=>{
    const s = new URLSearchParams(e || void 0);
    t && s.set("workspaceId", String(t));
    const n = s.toString();
    return n ? `?${n}` : "";
};
class $981491d31a617ff7$export$4097a1a257609c41 extends (0, $em51x.BaseService) {
    list(e = {}, s = {}) {
        const n = {};
        e.status && (n.status = e.status), e.party && (n.party = e.party), e.assignee && (n.assignee = e.assignee);
        const a = e.workspaceId || s.workspaceId;
        return this._call("conversations.list", `/conversations${$981491d31a617ff7$var$o(a, n)}`);
    }
    get(e, { workspaceId: s } = {}) {
        return this._call("conversations.get", `/conversations/${encodeURIComponent(e)}${$981491d31a617ff7$var$o(s)}`);
    }
    create(e = {}, { workspaceId: s } = {}) {
        return this._call("conversations.create", `/conversations${$981491d31a617ff7$var$o(s)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, s = {}, { workspaceId: n } = {}) {
        return this._call("conversations.update", `/conversations/${encodeURIComponent(e)}${$981491d31a617ff7$var$o(n)}`, {
            method: "PATCH",
            body: s
        });
    }
    remove(e, { workspaceId: s } = {}) {
        return this._call("conversations.remove", `/conversations/${encodeURIComponent(e)}${$981491d31a617ff7$var$o(s)}`, {
            method: "DELETE"
        });
    }
    listMessages(e, { workspaceId: s } = {}) {
        return this._call("conversations.listMessages", `/conversations/${encodeURIComponent(e)}/messages${$981491d31a617ff7$var$o(s)}`);
    }
    addMessage(e, s = {}, { workspaceId: n } = {}) {
        return this._call("conversations.addMessage", `/conversations/${encodeURIComponent(e)}/messages${$981491d31a617ff7$var$o(n)}`, {
            method: "POST",
            body: s
        });
    }
}
const $981491d31a617ff7$export$b80675961554d745 = (t)=>new $981491d31a617ff7$export$4097a1a257609c41(t);

});

parcelRegister("lQAED", function(module, exports) {

$parcel$export(module.exports, "RecurrenceService", () => $fe7ae31da128e2a9$export$837963f9ac7d0ebe);

var $em51x = parcelRequire("em51x");
const $fe7ae31da128e2a9$var$t = (n, e)=>{
    const r = new URLSearchParams(e || void 0);
    n && r.set("workspaceId", String(n));
    const c = r.toString();
    return c ? `?${c}` : "";
};
class $fe7ae31da128e2a9$export$837963f9ac7d0ebe extends (0, $em51x.BaseService) {
    list(e = {}, r = {}) {
        const c = {};
        e.enabled !== void 0 && e.enabled !== null && (c.enabled = String(e.enabled)), e.templateType && (c.templateType = e.templateType), e.templateId && (c.templateId = e.templateId);
        const s = e.workspaceId || r.workspaceId;
        return this._call("recurrences.list", `/recurrences${$fe7ae31da128e2a9$var$t(s, c)}`);
    }
    get(e, { workspaceId: r } = {}) {
        return this._call("recurrences.get", `/recurrences/${encodeURIComponent(e)}${$fe7ae31da128e2a9$var$t(r)}`);
    }
    create(e = {}, { workspaceId: r } = {}) {
        return this._call("recurrences.create", `/recurrences${$fe7ae31da128e2a9$var$t(r)}`, {
            method: "POST",
            body: e
        });
    }
    update(e, r = {}, { workspaceId: c } = {}) {
        return this._call("recurrences.update", `/recurrences/${encodeURIComponent(e)}${$fe7ae31da128e2a9$var$t(c)}`, {
            method: "PATCH",
            body: r
        });
    }
    remove(e, { workspaceId: r } = {}) {
        return this._call("recurrences.remove", `/recurrences/${encodeURIComponent(e)}${$fe7ae31da128e2a9$var$t(r)}`, {
            method: "DELETE"
        });
    }
}
const $fe7ae31da128e2a9$export$9f35caca53cb501b = (n)=>new $fe7ae31da128e2a9$export$837963f9ac7d0ebe(n);

});

parcelRegister("j6CXP", function(module, exports) {

$parcel$export(module.exports, "MailService", () => $de8ccd46f0f2100b$export$2e1dbe9af965f3b0);

var $em51x = parcelRequire("em51x");
const $de8ccd46f0f2100b$var$n = (l, t)=>{
    const e = new URLSearchParams(t || void 0);
    l && e.set("workspaceId", String(l));
    const a = e.toString();
    return a ? `?${a}` : "";
};
class $de8ccd46f0f2100b$export$2e1dbe9af965f3b0 extends (0, $em51x.BaseService) {
    getSetup({ workspaceId: t } = {}) {
        return this._call("mail.getSetup", `/mail/setup${$de8ccd46f0f2100b$var$n(t)}`);
    }
    setupNotifyAdmin({ workspaceId: t } = {}) {
        return this._call("mail.setupNotifyAdmin", `/mail/setup/notify-admin${$de8ccd46f0f2100b$var$n(t)}`, {
            method: "POST"
        });
    }
    setupLink({ workspaceId: t } = {}) {
        return this._call("mail.setupLink", `/mail/setup/link${$de8ccd46f0f2100b$var$n(t)}`, {
            method: "POST"
        });
    }
    listAccounts(t = {}, e = {}) {
        const a = t.workspaceId || e.workspaceId;
        return this._call("mail.listAccounts", `/mail/accounts${$de8ccd46f0f2100b$var$n(a)}`);
    }
    startConnect(t, { workspaceId: e } = {}) {
        return this._call("mail.startConnect", `/mail/accounts/connect/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST"
        });
    }
    getAccount(t, { workspaceId: e } = {}) {
        return this._call("mail.getAccount", `/mail/accounts/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(e)}`);
    }
    updateAccount(t, e = {}, { workspaceId: a } = {}) {
        return this._call("mail.updateAccount", `/mail/accounts/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "PATCH",
            body: e
        });
    }
    disconnectAccount(t, { workspaceId: e } = {}) {
        return this._call("mail.disconnectAccount", `/mail/accounts/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "DELETE"
        });
    }
    reconnect(t, { workspaceId: e } = {}) {
        return this._call("mail.reconnect", `/mail/accounts/${encodeURIComponent(t)}/reconnect${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST"
        });
    }
    syncNow(t, { workspaceId: e } = {}) {
        return this._call("mail.syncNow", `/mail/accounts/${encodeURIComponent(t)}/sync${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST"
        });
    }
    adminListAccounts(t = {}, e = {}) {
        const a = t.workspaceId || e.workspaceId;
        return this._call("mail.adminListAccounts", `/mail/admin/accounts${$de8ccd46f0f2100b$var$n(a)}`);
    }
    adminDisconnect(t, { workspaceId: e } = {}) {
        return this._call("mail.adminDisconnect", `/mail/admin/accounts/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "DELETE"
        });
    }
    adminAudit(t = {}, e = {}) {
        const a = {}, o = t.limit ?? e.limit;
        o !== void 0 && (a.limit = o);
        const s = t.workspaceId || e.workspaceId;
        return this._call("mail.adminAudit", `/mail/admin/audit${$de8ccd46f0f2100b$var$n(s, a)}`);
    }
    getTenant({ workspaceId: t } = {}) {
        return this._call("mail.getTenant", `/mail/tenant${$de8ccd46f0f2100b$var$n(t)}`);
    }
    tenantConsentUrl(t, { workspaceId: e } = {}) {
        return this._call("mail.tenantConsentUrl", `/mail/tenant/${encodeURIComponent(t)}/consent${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST"
        });
    }
    tenantTest(t, { workspaceId: e } = {}) {
        return this._call("mail.tenantTest", `/mail/tenant/${encodeURIComponent(t)}/test${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST"
        });
    }
    tenantProvision(t, e = {}, { workspaceId: a } = {}) {
        return this._call("mail.tenantProvision", `/mail/tenant/${encodeURIComponent(t)}/provision${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "POST",
            body: e
        });
    }
    createShared(t = {}, { workspaceId: e } = {}) {
        return this._call("mail.createShared", `/mail/shared${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST",
            body: t
        });
    }
    updateShared(t, e = {}, { workspaceId: a } = {}) {
        return this._call("mail.updateShared", `/mail/shared/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "PATCH",
            body: e
        });
    }
    listThreads(t = {}, e = {}) {
        const a = {}, o = [
            "accountId",
            "folder",
            "label",
            "unread",
            "starred",
            "attachments",
            "snoozed",
            "from",
            "q",
            "cursor",
            "limit"
        ];
        for (const i of o){
            const c = t[i] ?? e[i];
            c != null && c !== "" && (a[i] = c);
        }
        const s = t.workspaceId || e.workspaceId;
        return this._call("mail.listThreads", `/mail/threads${$de8ccd46f0f2100b$var$n(s, a)}`);
    }
    getThread(t, { workspaceId: e } = {}) {
        return this._call("mail.getThread", `/mail/threads/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(e)}`);
    }
    updateThread(t, e = {}, { workspaceId: a } = {}) {
        return this._call("mail.updateThread", `/mail/threads/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "PATCH",
            body: e
        });
    }
    batchThreads(t = {}, { workspaceId: e } = {}) {
        return this._call("mail.batchThreads", `/mail/threads/batch${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST",
            body: t
        });
    }
    rsvpThread(t, e = {}, { workspaceId: a } = {}) {
        return this._call("mail.rsvpThread", `/mail/threads/${encodeURIComponent(t)}/rsvp${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "POST",
            body: e
        });
    }
    getBody(t, { workspaceId: e } = {}) {
        return this._call("mail.getBody", `/mail/messages/${encodeURIComponent(t)}/body${$de8ccd46f0f2100b$var$n(e)}`);
    }
    async attachmentUrl(t, e, { workspaceId: a } = {}) {
        const o = await this._call("mail.attachmentUrl", `/mail/messages/${encodeURIComponent(t)}/attachments/${encodeURIComponent(e)}${$de8ccd46f0f2100b$var$n(a)}`);
        return o && typeof o == "object" && typeof o.path == "string" && this._apiUrl ? {
            ...o,
            url: `${this._apiUrl}${o.path}`
        } : o;
    }
    resolveAddress(t, { workspaceId: e } = {}) {
        const a = e ? `&workspaceId=${encodeURIComponent(e)}` : "";
        return this._call("mail.resolveAddress", `/mail/resolve?email=${encodeURIComponent(t)}${a}`);
    }
    searchThreads(t = {}, e = {}) {
        const a = {}, o = [
            "q",
            "scope",
            "accountId",
            "limit"
        ];
        for (const i of o){
            const c = t[i] ?? e[i];
            c != null && c !== "" && (a[i] = c);
        }
        const s = t.workspaceId || e.workspaceId;
        return this._call("mail.searchThreads", `/mail/search${$de8ccd46f0f2100b$var$n(s, a)}`);
    }
    saveAttachment(t, e, { workspaceId: a } = {}) {
        return this._call("mail.saveAttachment", `/mail/messages/${encodeURIComponent(t)}/attachments/${encodeURIComponent(e)}/save${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "POST",
            body: {}
        });
    }
    createDraft(t = {}, { workspaceId: e } = {}) {
        return this._call("mail.createDraft", `/mail/drafts${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST",
            body: t
        });
    }
    updateDraft(t, e = {}, { workspaceId: a } = {}) {
        return this._call("mail.updateDraft", `/mail/drafts/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "PATCH",
            body: e
        });
    }
    deleteDraft(t, { workspaceId: e } = {}) {
        return this._call("mail.deleteDraft", `/mail/drafts/${encodeURIComponent(t)}${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "DELETE"
        });
    }
    uploadDraftAttachment(t, e, { workspaceId: a, filename: o } = {}) {
        const s = new FormData;
        return o ? s.append("file", e, o) : s.append("file", e), this._call("mail.uploadDraftAttachment", `/mail/drafts/${encodeURIComponent(t)}/attachments${$de8ccd46f0f2100b$var$n(a)}`, {
            method: "POST",
            body: s
        });
    }
    send(t = {}, { workspaceId: e } = {}) {
        return this._call("mail.send", `/mail/send${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST",
            body: t
        });
    }
    listOutbox(t = {}, e = {}) {
        const a = {}, o = t.status ?? e.status, s = t.limit ?? e.limit;
        o !== void 0 && (a.status = o), s !== void 0 && (a.limit = s);
        const i = t.workspaceId || e.workspaceId;
        return this._call("mail.listOutbox", `/mail/outbox${$de8ccd46f0f2100b$var$n(i, a)}`);
    }
    cancelSend(t, { workspaceId: e } = {}) {
        return this._call("mail.cancelSend", `/mail/outbox/${encodeURIComponent(t)}/cancel${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST"
        });
    }
    crmTimeline(t = {}, e = {}) {
        const a = t || {}, o = {};
        for (const i of [
            "type",
            "id",
            "party",
            "before",
            "limit"
        ]){
            const c = a[i] ?? e[i];
            c != null && c !== "" && (o[i] = Array.isArray(c) ? c.join(",") : c);
        }
        const s = a.workspaceId || e.workspaceId;
        return this._call("mail.crmTimeline", `/mail/crm/timeline${$de8ccd46f0f2100b$var$n(s, o)}`);
    }
    crmSend(t = {}, { workspaceId: e } = {}) {
        const { workspaceId: a, ...o } = t || {};
        return this._call("mail.crmSend", `/mail/crm/send${$de8ccd46f0f2100b$var$n(e || a)}`, {
            method: "POST",
            body: o
        });
    }
    simulateInbound(t, e = {}, { workspaceId: a } = {}) {
        const { workspaceId: o, ...s } = e || {};
        return this._call("mail.simulateInbound", `/mail/accounts/${encodeURIComponent(t)}/simulate${$de8ccd46f0f2100b$var$n(a || o)}`, {
            method: "POST",
            body: s
        });
    }
    serviceDeskReply(t = {}, { workspaceId: e } = {}) {
        return this._call("mail.serviceDeskReply", `/mail/service-desk/reply${$de8ccd46f0f2100b$var$n(e)}`, {
            method: "POST",
            body: t
        });
    }
    subscribeStream({ workspaceId: t } = {}, e) {
        const a = [
            "mail.snapshot",
            "mail.thread.upsert",
            "mail.thread.delete",
            "mail.account.status",
            "mail.account.progress",
            "mail.outbox.sent",
            "mail.outbox.failed",
            "mail.unread"
        ], o = t ? {
            workspaceId: String(t)
        } : {};
        return this._sseSubscribe("/mail/stream", o, e, {
            flatParams: !0,
            events: a.map((s)=>({
                    name: s,
                    frame: (i)=>({
                            type: s,
                            ...i
                        })
                }))
        });
    }
}
const $de8ccd46f0f2100b$export$4e2f1b75a5fab12 = (l)=>new $de8ccd46f0f2100b$export$2e1dbe9af965f3b0(l);

});

parcelRegister("g3MVt", function(module, exports) {

$parcel$export(module.exports, "CanvasLayoutService", () => $bb12e0d11c2dd8bf$export$55ed4e0028d8f38d);

var $em51x = parcelRequire("em51x");

var $aDFzZ = parcelRequire("aDFzZ");

var $h5XS2 = parcelRequire("h5XS2");
class $bb12e0d11c2dd8bf$export$55ed4e0028d8f38d extends (0, $em51x.BaseService) {
    getCanvasLayout(r) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("canvasLayout.get", `/workspaces/${encodeURIComponent(r)}/canvas-layout`);
    }
    patchCanvasLayout(r, s = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("canvasLayout.patch", `/workspaces/${encodeURIComponent(r)}/canvas-layout`, {
            method: "PATCH",
            body: s
        });
    }
    subscribeWorkspaceCanvasLayout(r, s) {
        if (!r || typeof s != "function") return ()=>{};
        if (!this._tokenManager) return ()=>{};
        const o = this._tokenManager.getAccessToken?.();
        if (!o) return ()=>{};
        const a = this._apiUrl;
        if (!a) return ()=>{};
        let t;
        try {
            t = (0, $aDFzZ.io)(a, {
                path: "/user-socket",
                transports: [
                    "websocket",
                    "polling"
                ],
                auth: {
                    token: o
                },
                autoConnect: !0,
                reconnection: !0,
                reconnectionDelay: 1e3,
                reconnectionDelayMax: 1e4
            });
        } catch (e) {
            return (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceCanvasLayout] socket init failed:", e?.message || e), ()=>{};
        }
        let c = !1;
        return t.on("connect_error", (e)=>{
            e?.message && !c && (c = !0, (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceCanvasLayout] connect_error:", e.message));
        }), t.on("canvas-layout-changed", (e)=>{
            if (!(e?.workspaceId && e.workspaceId !== r)) try {
                s({
                    positions: e?.positions ?? {},
                    groups: e?.groups ?? {},
                    version: e?.version
                });
            } catch (i) {
                (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceCanvasLayout] handler threw:", i?.message || i);
            }
        }), ()=>{
            try {
                t.removeAllListeners();
            } catch  {}
            try {
                t.disconnect();
            } catch  {}
        };
    }
    subscribeWorkspaceFileCanvas(r, s) {
        if (!r || typeof s != "function") return ()=>{};
        if (!this._tokenManager) return ()=>{};
        const o = this._tokenManager.getAccessToken?.();
        if (!o) return ()=>{};
        const a = this._apiUrl;
        if (!a) return ()=>{};
        let t;
        try {
            t = (0, $aDFzZ.io)(a, {
                path: "/user-socket",
                transports: [
                    "websocket",
                    "polling"
                ],
                auth: {
                    token: o
                },
                autoConnect: !0,
                reconnection: !0,
                reconnectionDelay: 1e3,
                reconnectionDelayMax: 1e4
            });
        } catch (e) {
            return (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceFileCanvas] socket init failed:", e?.message || e), ()=>{};
        }
        let c = !1;
        return t.on("connect_error", (e)=>{
            e?.message && !c && (c = !0, (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceFileCanvas] connect_error:", e.message));
        }), t.on("file-canvas-changed", (e)=>{
            if (!(e?.workspaceId && e.workspaceId !== r)) try {
                s({
                    type: e?.type || "UPDATE",
                    rows: Array.isArray(e?.rows) ? e.rows : [],
                    ids: Array.isArray(e?.ids) ? e.ids : [],
                    patch: e?.patch || null
                });
            } catch (i) {
                (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceFileCanvas] handler threw:", i?.message || i);
            }
        }), ()=>{
            try {
                t.removeAllListeners();
            } catch  {}
            try {
                t.disconnect();
            } catch  {}
        };
    }
}

});

parcelRegister("8UO8l", function(module, exports) {

$parcel$export(module.exports, "RefsService", () => $67da71283ff64b0b$export$be84f862cfa32cd6);

var $em51x = parcelRequire("em51x");
class $67da71283ff64b0b$export$be84f862cfa32cd6 extends (0, $em51x.BaseService) {
    _workspaceScope(e) {
        return this._resolveWorkspaceId(e, {
            fallbackToStorage: !0
        });
    }
    _requireWorkspace(e, s) {
        const r = this._workspaceScope(s);
        if (!r) throw new Error(`${e} requires a workspaceId`);
        return String(r);
    }
    resolve({ ref: e, workspaceId: s } = {}) {
        if (!e) throw new Error("refs.resolve requires a ref");
        const r = this._requireWorkspace("refs.resolve", s);
        return this._call("refs.resolve", `/workspaces/${encodeURIComponent(r)}/refs/resolve?ref=${encodeURIComponent(e)}`);
    }
    relations({ ref: e, depth: s = 1, workspaceId: r } = {}) {
        if (!e) throw new Error("refs.relations requires a ref");
        const o = this._requireWorkspace("refs.relations", r), t = Number(s) > 1 ? 2 : 1;
        return this._call("refs.relations", `/workspaces/${encodeURIComponent(o)}/refs/relations?ref=${encodeURIComponent(e)}&depth=${t}`);
    }
    searchWorkspace({ query: e, q: s, surfaces: r, limit: o, workspaceId: t } = {}) {
        const i = String(e ?? s ?? "").trim(), p = this._requireWorkspace("refs.searchWorkspace", t), n = new URLSearchParams({
            q: i
        });
        return Array.isArray(r) && r.length && n.set("surfaces", r.join(",")), Number.isFinite(Number(o)) && n.set("limit", String(Math.trunc(Number(o)))), this._call("refs.searchWorkspace", `/workspaces/${encodeURIComponent(p)}/search?${n.toString()}`);
    }
}
const $67da71283ff64b0b$export$214453a654078a66 = (a)=>new $67da71283ff64b0b$export$be84f862cfa32cd6(a);
var $67da71283ff64b0b$export$2e2bcd8739ae039 = $67da71283ff64b0b$export$be84f862cfa32cd6;

});

parcelRegister("hvDlp", function(module, exports) {

$parcel$export(module.exports, "MeetService", () => $cbf3d9dbd85fd392$export$e4e2ad8dc9e7b4d9);

var $em51x = parcelRequire("em51x");
class $cbf3d9dbd85fd392$export$e4e2ad8dc9e7b4d9 extends (0, $em51x.BaseService) {
    meetGuestRequest({ roomId: e, name: t, email: r, password: o } = {}) {
        if (!e) throw new Error("roomId is required");
        return this._call("meetGuestRequest", "/meet/guest/request", {
            method: "POST",
            body: {
                roomId: e,
                name: t,
                email: r,
                password: o
            }
        });
    }
    meetGuestMeta({ roomId: e } = {}) {
        if (!e) throw new Error("roomId is required");
        return this._call("meetGuestMeta", "/meet/guest/meta", {
            method: "POST",
            body: {
                roomId: e
            }
        });
    }
    meetGuestStatus({ waitingId: e } = {}) {
        if (!e) throw new Error("waitingId is required");
        return this._call("meetGuestStatus", "/meet/guest/status", {
            method: "POST",
            body: {
                waitingId: e
            }
        });
    }
    meetGuestToken({ roomId: e, waitingId: t } = {}) {
        if (!e) throw new Error("roomId is required");
        return this._call("meetGuestToken", "/meet/guest/token", {
            method: "POST",
            body: {
                roomId: e,
                waitingId: t
            }
        });
    }
    meetMuteParticipant({ roomId: e, participantIdentity: t, trackSid: r, muted: o } = {}) {
        if (!e) throw new Error("roomId is required");
        if (!t) throw new Error("participantIdentity is required");
        if (!r) throw new Error("trackSid is required");
        if (typeof o != "boolean") throw new Error("muted must be a boolean");
        return this._call("meetMuteParticipant", "/meet/mute", {
            method: "POST",
            body: {
                roomId: e,
                participantIdentity: t,
                trackSid: r,
                muted: o
            }
        });
    }
    meetArchiveRooms({ roomIds: e, archived: t } = {}) {
        if (!Array.isArray(e)) throw new Error("roomIds must be an array");
        return this._call("meetArchiveRooms", "/meet/archive", {
            method: "POST",
            body: {
                roomIds: e,
                archived: t
            }
        });
    }
}

});

parcelRegister("3bJnZ", function(module, exports) {

$parcel$export(module.exports, "CalendarService", () => $25259ae2dfdf79ff$export$72f9f0f982e7ae3d);

var $em51x = parcelRequire("em51x");
class $25259ae2dfdf79ff$export$72f9f0f982e7ae3d extends (0, $em51x.BaseService) {
    calendarListEvents({ workspaceId: e, organization: r, window: t, includeDeleted: n, limit: i } = {}) {
        const a = new URLSearchParams;
        e && a.set("workspaceId", e), r && a.set("orgId", r), t && (t.gte || t.lte) && a.set("start_at", JSON.stringify(t)), n && a.set("includeDeleted", "true"), i != null && a.set("limit", String(i));
        const o = a.toString();
        return this._call("calendarListEvents", `/calendar/events${o ? `?${o}` : ""}`, {
            method: "GET"
        });
    }
    calendarGetEvent({ id: e, workspaceId: r } = {}) {
        if (e == null) throw new Error("id is required");
        const t = r ? `?workspaceId=${encodeURIComponent(r)}` : "";
        return this._call("calendarGetEvent", `/calendar/events/${encodeURIComponent(e)}${t}`, {
            method: "GET"
        });
    }
    calendarCreateEvent({ payload: e, organization: r, workspaceId: t } = {}) {
        if (!e || typeof e != "object") throw new Error("payload is required");
        if (!r) throw new Error("organization is required (owner/admin write gate)");
        return this._call("calendarCreateEvent", "/calendar/events", {
            method: "POST",
            body: {
                payload: e,
                organization: r,
                ...t ? {
                    workspaceId: t
                } : {}
            }
        });
    }
    calendarUpdateEvent({ id: e, payload: r, organization: t, workspaceId: n } = {}) {
        if (e == null) throw new Error("id is required");
        if (!r || typeof r != "object") throw new Error("payload is required");
        if (!t) throw new Error("organization is required (owner/admin write gate)");
        return this._call("calendarUpdateEvent", `/calendar/events/${encodeURIComponent(e)}`, {
            method: "PATCH",
            body: {
                payload: r,
                organization: t,
                ...n ? {
                    workspaceId: n
                } : {}
            }
        });
    }
    calendarDeleteEvent({ id: e, organization: r, workspaceId: t } = {}) {
        if (e == null) throw new Error("id is required");
        if (!r) throw new Error("organization is required (owner/admin write gate)");
        return this._call("calendarDeleteEvent", `/calendar/events/${encodeURIComponent(e)}`, {
            method: "DELETE",
            body: {
                organization: r,
                ...t ? {
                    workspaceId: t
                } : {}
            }
        });
    }
    calendarDeleteFutureEvents({ seriesId: e, fromDate: r, organization: t, workspaceId: n } = {}) {
        if (!e) throw new Error("seriesId is required");
        if (!r) throw new Error("fromDate is required");
        if (!t) throw new Error("organization is required (member write gate)");
        return this._call("calendarDeleteFutureEvents", "/calendar/events/delete-future", {
            method: "POST",
            body: {
                seriesId: e,
                fromDate: r,
                organization: t,
                ...n ? {
                    workspaceId: n
                } : {}
            }
        });
    }
    calendarSync({ organization: e, workspaceId: r } = {}) {
        if (!e) throw new Error("organization is required (owner/admin write gate)");
        return this._call("calendarSync", "/calendar/sync", {
            method: "POST",
            body: {
                organization: e,
                ...r ? {
                    workspaceId: r
                } : {}
            }
        });
    }
    calendarSyncStatus({ organization: e, workspaceId: r } = {}) {
        if (!e) throw new Error("organization is required");
        const t = new URLSearchParams({
            orgId: e
        });
        return r && t.set("workspaceId", r), this._call("calendarSyncStatus", `/calendar/sync?${t.toString()}`, {
            method: "GET"
        });
    }
}

});

parcelRegister("llyqc", function(module, exports) {

$parcel$export(module.exports, "BuildsService", () => $f8a64288c2f9aa59$export$c42cd9bc10fb01e3);

var $em51x = parcelRequire("em51x");

var $aDFzZ = parcelRequire("aDFzZ");

var $h5XS2 = parcelRequire("h5XS2");
const $f8a64288c2f9aa59$var$s = (m)=>{
    if (!m) throw new Error("workspaceId is required");
    return `/builds/workspaces/${encodeURIComponent(m)}`;
};
class $f8a64288c2f9aa59$export$c42cd9bc10fb01e3 extends (0, $em51x.BaseService) {
    getBuildsGitHubState(t) {
        return this._call("getBuildsGitHubState", `${$f8a64288c2f9aa59$var$s(t)}/github`);
    }
    listBuildRepos(t) {
        return this._call("listBuildRepos", `${$f8a64288c2f9aa59$var$s(t)}/repos`);
    }
    listBuildImports(t) {
        return this._call("listBuildImports", `${$f8a64288c2f9aa59$var$s(t)}/imports`);
    }
    createBuildImport(t, e = {}) {
        if (!e.repositoryFullName) throw new Error("repositoryFullName is required");
        return this._call("createBuildImport", `${$f8a64288c2f9aa59$var$s(t)}/imports`, {
            method: "POST",
            body: e
        });
    }
    updateBuildImport(t, e, r = {}) {
        if (!e) throw new Error("repoId is required");
        return this._call("updateBuildImport", `${$f8a64288c2f9aa59$var$s(t)}/imports/${encodeURIComponent(e)}`, {
            method: "PATCH",
            body: r
        });
    }
    deleteBuildImport(t, e) {
        if (!e) throw new Error("repoId is required");
        return this._call("deleteBuildImport", `${$f8a64288c2f9aa59$var$s(t)}/imports/${encodeURIComponent(e)}`, {
            method: "DELETE"
        });
    }
    triggerBuild(t, e, r = {}) {
        if (!e) throw new Error("repoId is required");
        return this._call("triggerBuild", `${$f8a64288c2f9aa59$var$s(t)}/imports/${encodeURIComponent(e)}/trigger`, {
            method: "POST",
            body: r
        });
    }
    listBuilds(t, { limit: e } = {}) {
        const r = e ? `?limit=${encodeURIComponent(e)}` : "";
        return this._call("listBuilds", `${$f8a64288c2f9aa59$var$s(t)}/builds${r}`);
    }
    getBuild(t, e) {
        if (!e) throw new Error("buildId is required");
        return this._call("getBuild", `${$f8a64288c2f9aa59$var$s(t)}/builds/${encodeURIComponent(e)}`);
    }
    getBuildLogs(t, e, { tailBytes: r } = {}) {
        if (!e) throw new Error("buildId is required");
        const n = r ? `?tailBytes=${encodeURIComponent(r)}` : "";
        return this._call("getBuildLogs", `${$f8a64288c2f9aa59$var$s(t)}/builds/${encodeURIComponent(e)}/logs${n}`);
    }
    deployBuild(t, e, r = {}) {
        if (!e) throw new Error("buildId is required");
        return this._call("deployBuild", `${$f8a64288c2f9aa59$var$s(t)}/builds/${encodeURIComponent(e)}/deploy`, {
            method: "POST",
            body: r
        });
    }
    listBuildDeployments(t) {
        return this._call("listBuildDeployments", `${$f8a64288c2f9aa59$var$s(t)}/deployments`);
    }
    rollbackDeployment(t, e) {
        if (!e) throw new Error("deploymentId is required");
        return this._call("rollbackDeployment", `${$f8a64288c2f9aa59$var$s(t)}/deployments/${encodeURIComponent(e)}/rollback`, {
            method: "POST"
        });
    }
    scaleDeployment(t, e, r = {}) {
        if (!e) throw new Error("deploymentId is required");
        return this._call("scaleDeployment", `${$f8a64288c2f9aa59$var$s(t)}/deployments/${encodeURIComponent(e)}/scale`, {
            method: "POST",
            body: r
        });
    }
    getDeploymentMetrics(t, e, { interval: r, since: n, until: u, limit: c } = {}) {
        if (!e) throw new Error("deploymentId is required");
        const i = new URLSearchParams;
        r && i.set("interval", r), n && i.set("since", n), u && i.set("until", u), c && i.set("limit", String(c));
        const a = i.toString() ? `?${i.toString()}` : "";
        return this._call("getDeploymentMetrics", `${$f8a64288c2f9aa59$var$s(t)}/deployments/${encodeURIComponent(e)}/metrics${a}`);
    }
    subscribeWorkspaceBuilds(t = {}) {
        const { onBuildStatus: e, onDeploymentStatus: r, workspaceId: n } = t || {}, u = typeof e == "function", c = typeof r == "function";
        if (!u && !c) return ()=>{};
        if (!this._tokenManager) return ()=>{};
        const i = this._tokenManager.getAccessToken?.();
        if (!i) return ()=>{};
        const a = this._apiUrl;
        if (!a) return ()=>{};
        let l;
        try {
            l = (this._ioFactory || (0, $aDFzZ.io))(a, {
                path: "/user-socket",
                transports: [
                    "websocket",
                    "polling"
                ],
                auth: {
                    token: i
                },
                autoConnect: !0,
                reconnection: !0,
                reconnectionDelay: 1e3,
                reconnectionDelayMax: 1e4
            });
        } catch (o) {
            return (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceBuilds] socket init failed:", o?.message || o), ()=>{};
        }
        let h = !1;
        l.on("connect_error", (o)=>{
            o?.message && !h && (h = !0, (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceBuilds] connect_error:", o.message));
        });
        const g = (o)=>!!(n && o?.workspaceId && o.workspaceId !== n);
        return u && l.on("build-status-changed", (o)=>{
            if (!g(o)) try {
                e(o);
            } catch (d) {
                (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceBuilds] onBuildStatus threw:", d?.message || d);
            }
        }), c && l.on("deployment-status-changed", (o)=>{
            if (!g(o)) try {
                r(o);
            } catch (d) {
                (0, $h5XS2.logger).warn("[sdk.subscribeWorkspaceBuilds] onDeploymentStatus threw:", d?.message || d);
            }
        }), ()=>{
            try {
                l.removeAllListeners();
            } catch  {}
            try {
                l.disconnect();
            } catch  {}
        };
    }
}

});

parcelRegister("8rBBj", function(module, exports) {

$parcel$export(module.exports, "StorefrontService", () => $625e03114b5202e6$export$f39a0cd4cbdafbf1);

var $em51x = parcelRequire("em51x");
const $625e03114b5202e6$var$u = (d)=>{
    const r = new URLSearchParams;
    for (const [t, o] of Object.entries(d || {}))o != null && o !== "" && r.set(t, String(o));
    const e = r.toString();
    return e ? `?${e}` : "";
};
class $625e03114b5202e6$export$f39a0cd4cbdafbf1 extends (0, $em51x.BaseService) {
    listStorefrontProducts(r, { category: e, limit: t, page: o } = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("listStorefrontProducts", `/storefront/${encodeURIComponent(r)}/products${$625e03114b5202e6$var$u({
            category: e,
            limit: t,
            page: o
        })}`);
    }
    getStorefrontProduct(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        return this._call("getStorefrontProduct", `/storefront/${encodeURIComponent(r)}/products/${encodeURIComponent(e)}`);
    }
    listStorefrontCollection(r, e, { limit: t, page: o, ...n } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("collection is required");
        return this._call("listStorefrontCollection", `/storefront/${encodeURIComponent(r)}/collections/${encodeURIComponent(e)}${$625e03114b5202e6$var$u({
            ...n,
            limit: t,
            page: o
        })}`);
    }
    listStorefrontJobs(r, { limit: e, page: t } = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("listStorefrontJobs", `/storefront/${encodeURIComponent(r)}/jobs${$625e03114b5202e6$var$u({
            limit: e,
            page: t
        })}`);
    }
    getStorefrontJob(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        return this._call("getStorefrontJob", `/storefront/${encodeURIComponent(r)}/jobs/${encodeURIComponent(e)}`);
    }
    applyToStorefrontJob(r, e, { fullName: t, email: o, phone: n, coverLetter: i, cvUrl: f } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        return this._call("applyToStorefrontJob", `/storefront/${encodeURIComponent(r)}/jobs/${encodeURIComponent(e)}/apply`, {
            method: "POST",
            body: {
                fullName: t,
                email: o,
                phone: n,
                coverLetter: i,
                cvUrl: f
            }
        });
    }
    registerStorefrontCustomer(r, { phone: e, email: t, fullName: o, password: n, birthDate: i, identificationNumber: f } = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("registerStorefrontCustomer", `/storefront/${encodeURIComponent(r)}/auth/register`, {
            method: "POST",
            body: {
                phone: e,
                email: t,
                fullName: o,
                password: n,
                birthDate: i,
                identificationNumber: f
            }
        });
    }
    loginStorefrontCustomer(r, { email: e, phone: t, identifier: o, password: n } = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("loginStorefrontCustomer", `/storefront/${encodeURIComponent(r)}/auth/login`, {
            method: "POST",
            body: {
                email: e,
                phone: t,
                identifier: o,
                password: n
            }
        });
    }
    requestStorefrontCustomerOtp(r, { phone: e, email: t, purpose: o } = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("requestStorefrontCustomerOtp", `/storefront/${encodeURIComponent(r)}/auth/request-otp`, {
            method: "POST",
            body: {
                phone: e,
                email: t,
                purpose: o
            }
        });
    }
    verifyStorefrontCustomerOtp(r, { phone: e, email: t, code: o, purpose: n } = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("verifyStorefrontCustomerOtp", `/storefront/${encodeURIComponent(r)}/auth/verify-otp`, {
            method: "POST",
            body: {
                phone: e,
                email: t,
                code: o,
                purpose: n
            }
        });
    }
    resetStorefrontCustomerPassword(r, { phone: e, email: t, code: o, newPassword: n } = {}) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("resetStorefrontCustomerPassword", `/storefront/${encodeURIComponent(r)}/auth/reset-password`, {
            method: "POST",
            body: {
                phone: e,
                email: t,
                code: o,
                newPassword: n
            }
        });
    }
    getStorefrontAuthProviders(r) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("getStorefrontAuthProviders", `/storefront/${encodeURIComponent(r)}/auth/providers`, {
            method: "GET"
        });
    }
    signInStorefrontCustomerWithOAuth(r, e, { idToken: t, accessToken: o, nonce: n, name: i } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (![
            "google",
            "apple",
            "facebook"
        ].includes(e)) throw new Error("provider must be one of: google, apple, facebook");
        return this._call("signInStorefrontCustomerWithOAuth", `/storefront/${encodeURIComponent(r)}/auth/oauth/${encodeURIComponent(e)}`, {
            method: "POST",
            body: {
                idToken: t,
                accessToken: o,
                nonce: n,
                name: i
            }
        });
    }
    setStorefrontAuthProviders(r, e = {}) {
        if (this._requireReady("setStorefrontAuthProviders"), !r) throw new Error("workspaceId is required");
        return this._call("setStorefrontAuthProviders", `/storefront/${encodeURIComponent(r)}/settings/auth-providers`, {
            method: "PUT",
            body: e
        });
    }
    getStorefrontSchema(r) {
        if (this._requireReady("getStorefrontSchema"), !r) throw new Error("workspaceId is required");
        return this._call("getStorefrontSchema", `/storefront/${encodeURIComponent(r)}/settings/schema`, {
            method: "GET"
        });
    }
    setStorefrontSchema(r, e) {
        if (this._requireReady("setStorefrontSchema"), !r) throw new Error("workspaceId is required");
        if (!e || typeof e != "object") throw new Error("schema is required");
        return this._call("setStorefrontSchema", `/storefront/${encodeURIComponent(r)}/settings/schema`, {
            method: "PUT",
            body: e
        });
    }
    getStorefrontCustomerMe(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("getStorefrontCustomerMe", `/storefront/${encodeURIComponent(r)}/auth/me`, {
            headers: {
                Authorization: `Bearer ${e}`
            }
        });
    }
    resolveStorefront(r) {
        return this._call("resolveStorefront", `/storefront/resolve${$625e03114b5202e6$var$u({
            host: r
        })}`);
    }
    listStorefrontBundles(r, { limit: e, page: t } = {}) {
        return this.listStorefrontCollection(r, "bundles", {
            limit: e,
            page: t
        });
    }
    listStorefrontCmsTypes(r, { limit: e, page: t } = {}) {
        return this.listStorefrontCollection(r, "cmsTypes", {
            limit: e,
            page: t
        });
    }
    listStorefrontCmsEntries(r, { type: e, slug: t, limit: o, page: n, omit: i, v: f } = {}) {
        return this.listStorefrontCollection(r, "cmsEntries", {
            type: e,
            slug: t,
            omit: i,
            v: f,
            limit: o,
            page: n
        });
    }
    placeStorefrontOrder(r, e = {}, { customerToken: t } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e || typeof e != "object") throw new Error("order is required");
        return this._call("placeStorefrontOrder", `/storefront/${encodeURIComponent(r)}/orders`, {
            method: "POST",
            body: e,
            headers: $625e03114b5202e6$var$s(t)
        });
    }
    getStorefrontOrderStatus(r, e, t, { customerToken: o } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        if (!t && !o) throw new Error("key or customerToken is required");
        return this._call("getStorefrontOrderStatus", `/storefront/${encodeURIComponent(r)}/orders/${encodeURIComponent(e)}/status`, {
            headers: $625e03114b5202e6$var$h(t, o)
        });
    }
    payStorefrontOrderTest(r, e, { key: t, result: o, method: n } = {}, { customerToken: i } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        if (![
            "success",
            "fail"
        ].includes(o)) throw new Error("result must be 'success' or 'fail'");
        return this._call("payStorefrontOrderTest", `/storefront/${encodeURIComponent(r)}/orders/${encodeURIComponent(e)}/pay/test`, {
            method: "POST",
            body: {
                result: o,
                method: n
            },
            headers: $625e03114b5202e6$var$h(t, i)
        });
    }
    listStorefrontOrders(r, e, { limit: t, skip: o } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("listStorefrontOrders", `/storefront/${encodeURIComponent(r)}/orders${$625e03114b5202e6$var$u({
            limit: t,
            skip: o
        })}`, {
            headers: $625e03114b5202e6$var$s(e)
        });
    }
    getStorefrontOrder(r, e, t) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        if (!t) throw new Error("customerToken is required");
        return this._call("getStorefrontOrder", `/storefront/${encodeURIComponent(r)}/orders/${encodeURIComponent(e)}`, {
            headers: $625e03114b5202e6$var$s(t)
        });
    }
    getStorefrontCart(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("getStorefrontCart", `/storefront/${encodeURIComponent(r)}/cart`, {
            headers: $625e03114b5202e6$var$s(e)
        });
    }
    replaceStorefrontCart(r, e, t) {
        if (!r) throw new Error("workspaceId is required");
        if (!Array.isArray(e)) throw new Error("items must be an array");
        if (!t) throw new Error("customerToken is required");
        return this._call("replaceStorefrontCart", `/storefront/${encodeURIComponent(r)}/cart`, {
            method: "PUT",
            body: {
                items: e
            },
            headers: $625e03114b5202e6$var$s(t)
        });
    }
    clearStorefrontCart(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("clearStorefrontCart", `/storefront/${encodeURIComponent(r)}/cart`, {
            method: "DELETE",
            headers: $625e03114b5202e6$var$s(e)
        });
    }
    listStorefrontAddresses(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("listStorefrontAddresses", `/storefront/${encodeURIComponent(r)}/account/addresses`, {
            headers: $625e03114b5202e6$var$s(e)
        });
    }
    createStorefrontAddress(r, { deliveryCityId: e, street: t, building: o, flat: n, isDefault: i } = {}, f) {
        if (!r) throw new Error("workspaceId is required");
        if (!f) throw new Error("customerToken is required");
        return this._call("createStorefrontAddress", `/storefront/${encodeURIComponent(r)}/account/addresses`, {
            method: "POST",
            body: {
                deliveryCityId: e,
                street: t,
                building: o,
                flat: n,
                isDefault: i
            },
            headers: $625e03114b5202e6$var$s(f)
        });
    }
    updateStorefrontAddress(r, e, t = {}, o) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        if (!o) throw new Error("customerToken is required");
        const { deliveryCityId: n, street: i, building: f, flat: c, isDefault: a } = t || {};
        return this._call("updateStorefrontAddress", `/storefront/${encodeURIComponent(r)}/account/addresses/${encodeURIComponent(e)}`, {
            method: "PATCH",
            body: {
                deliveryCityId: n,
                street: i,
                building: f,
                flat: c,
                isDefault: a
            },
            headers: $625e03114b5202e6$var$s(o)
        });
    }
    deleteStorefrontAddress(r, e, t) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        if (!t) throw new Error("customerToken is required");
        return this._call("deleteStorefrontAddress", `/storefront/${encodeURIComponent(r)}/account/addresses/${encodeURIComponent(e)}`, {
            method: "DELETE",
            headers: $625e03114b5202e6$var$s(t)
        });
    }
    updateStorefrontCustomerMe(r, e = {}, t) {
        if (!r) throw new Error("workspaceId is required");
        if (!t) throw new Error("customerToken is required");
        return this._call("updateStorefrontCustomerMe", `/storefront/${encodeURIComponent(r)}/auth/me`, {
            method: "PATCH",
            body: e || {},
            headers: $625e03114b5202e6$var$s(t)
        });
    }
    changeStorefrontCustomerPassword(r, { currentPassword: e, newPassword: t } = {}, o) {
        if (!r) throw new Error("workspaceId is required");
        if (!o) throw new Error("customerToken is required");
        return this._call("changeStorefrontCustomerPassword", `/storefront/${encodeURIComponent(r)}/auth/change-password`, {
            method: "POST",
            body: {
                currentPassword: e,
                newPassword: t
            },
            headers: $625e03114b5202e6$var$s(o)
        });
    }
    deleteStorefrontCustomerAccount(r, { currentPassword: e, reauth: t } = {}, o) {
        if (!r) throw new Error("workspaceId is required");
        if (!o) throw new Error("customerToken is required");
        return this._call("deleteStorefrontCustomerAccount", `/storefront/${encodeURIComponent(r)}/auth/me`, {
            method: "DELETE",
            body: {
                currentPassword: e,
                reauth: t
            },
            headers: $625e03114b5202e6$var$s(o)
        });
    }
    listStorefrontAppointments(r, e, { limit: t, skip: o } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("listStorefrontAppointments", `/storefront/${encodeURIComponent(r)}/account/appointments${$625e03114b5202e6$var$u({
            limit: t,
            skip: o
        })}`, {
            headers: $625e03114b5202e6$var$s(e)
        });
    }
    getStorefrontBalances(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("getStorefrontBalances", `/storefront/${encodeURIComponent(r)}/account/balances`, {
            headers: $625e03114b5202e6$var$s(e)
        });
    }
    listStorefrontLoyalty(r, e, { limit: t, skip: o } = {}) {
        if (!r) throw new Error("workspaceId is required");
        if (!e) throw new Error("customerToken is required");
        return this._call("listStorefrontLoyalty", `/storefront/${encodeURIComponent(r)}/account/loyalty${$625e03114b5202e6$var$u({
            limit: t,
            skip: o
        })}`, {
            headers: $625e03114b5202e6$var$s(e)
        });
    }
    subscribeStorefrontEvents(r, e) {
        if (!r) throw new Error("workspaceId is required");
        if (typeof e != "function") throw new Error("onEvent must be a function");
        return this._sseSubscribe(`/storefront/${encodeURIComponent(r)}/events`, {}, e, {
            anonymous: !0,
            events: [
                {
                    name: "records",
                    frame: (t)=>({
                            type: "records",
                            collection: t.collection,
                            at: t.at
                        })
                },
                {
                    name: "deployment",
                    frame: (t)=>({
                            type: "deployment",
                            version: t.version,
                            at: t.at
                        })
                }
            ]
        });
    }
    getStorefrontCheckout(r) {
        if (!r) throw new Error("workspaceId is required");
        return this._call("getStorefrontCheckout", `/storefront/${encodeURIComponent(r)}/checkout`);
    }
    confirmStorefrontCashPayment(r, e, { reference: t, note: o } = {}) {
        if (this._requireReady("confirmStorefrontCashPayment"), !r) throw new Error("workspaceId is required");
        if (!e) throw new Error("id is required");
        return this._call("confirmStorefrontCashPayment", `/storefront/${encodeURIComponent(r)}/orders/${encodeURIComponent(e)}/payments/confirm`, {
            method: "POST",
            body: {
                reference: t,
                note: o
            }
        });
    }
    getStorefrontCheckoutSettings(r) {
        if (this._requireReady("getStorefrontCheckoutSettings"), !r) throw new Error("workspaceId is required");
        return this._call("getStorefrontCheckoutSettings", `/storefront/${encodeURIComponent(r)}/settings/checkout`, {
            method: "GET"
        });
    }
    setStorefrontCheckoutSettings(r, e) {
        if (this._requireReady("setStorefrontCheckoutSettings"), !r) throw new Error("workspaceId is required");
        if (!e || typeof e != "object") throw new Error("settings is required");
        return this._call("setStorefrontCheckoutSettings", `/storefront/${encodeURIComponent(r)}/settings/checkout`, {
            method: "PUT",
            body: e
        });
    }
    getStorefrontPaymentSettings(r) {
        if (this._requireReady("getStorefrontPaymentSettings"), !r) throw new Error("workspaceId is required");
        return this._call("getStorefrontPaymentSettings", `/storefront/${encodeURIComponent(r)}/settings/payments`, {
            method: "GET"
        });
    }
    setStorefrontPaymentSettings(r, e) {
        if (this._requireReady("setStorefrontPaymentSettings"), !r) throw new Error("workspaceId is required");
        if (!e || typeof e != "object") throw new Error("settings is required");
        return this._call("setStorefrontPaymentSettings", `/storefront/${encodeURIComponent(r)}/settings/payments`, {
            method: "PUT",
            body: e
        });
    }
}
function $625e03114b5202e6$var$s(d) {
    return d ? {
        Authorization: `Bearer ${d}`
    } : void 0;
}
const $625e03114b5202e6$export$fb648880da28f53d = "X-Storefront-Order-Key";
function $625e03114b5202e6$var$h(d, r) {
    const e = {
        ...$625e03114b5202e6$var$s(r) || {}
    };
    return d && (e[$625e03114b5202e6$export$fb648880da28f53d] = String(d)), Object.keys(e).length ? e : void 0;
}
const $625e03114b5202e6$export$8ca249638fcb195e = (d)=>new $625e03114b5202e6$export$f39a0cd4cbdafbf1(d);

});

parcelRegister("5m933", function(module, exports) {

$parcel$export(module.exports, "PublicCollectionService", () => $3e66069dec163cb3$export$231f573f8a749489);

var $em51x = parcelRequire("em51x");
const $3e66069dec163cb3$var$r = encodeURIComponent, $3e66069dec163cb3$var$a = ({ q: c, where: e, sort: t, limit: i, page: l } = {})=>{
    const n = new URLSearchParams;
    if (c != null && c !== "" && n.set("q", String(c)), e && typeof e == "object") for (const [u, d] of Object.entries(e)){
        if (d == null) continue;
        const b = u.startsWith("data.") ? u : `data.${u}`;
        n.set(`where[${b}]`, String(d));
    }
    t && n.set("sort", Array.isArray(t) ? t.join(",") : String(t)), i != null && i !== "" && n.set("limit", String(i)), l != null && l !== "" && n.set("page", String(l));
    const s = n.toString();
    return s ? `?${s}` : "";
}, $3e66069dec163cb3$var$o = (c, e)=>{
    if (c == null || c === "") throw new Error(`${e} is required`);
};
class $3e66069dec163cb3$export$231f573f8a749489 extends (0, $em51x.BaseService) {
    listPublicRecords(e, t, i = {}) {
        return $3e66069dec163cb3$var$o(e, "scope"), $3e66069dec163cb3$var$o(t, "key"), this._call("listPublicRecords", `/public/${$3e66069dec163cb3$var$r(e)}/collections/${$3e66069dec163cb3$var$r(t)}${$3e66069dec163cb3$var$a(i)}`);
    }
    getPublicRecord(e, t, i) {
        return $3e66069dec163cb3$var$o(e, "scope"), $3e66069dec163cb3$var$o(t, "key"), $3e66069dec163cb3$var$o(i, "idOrSlug"), this._call("getPublicRecord", `/public/${$3e66069dec163cb3$var$r(e)}/collections/${$3e66069dec163cb3$var$r(t)}/${$3e66069dec163cb3$var$r(i)}`);
    }
    submitPublicRecord(e, t, i, { captchaToken: l, honeypot: n } = {}) {
        if ($3e66069dec163cb3$var$o(e, "scope"), $3e66069dec163cb3$var$o(t, "key"), !i || typeof i != "object" || Array.isArray(i)) throw new Error("data must be an object");
        const s = {
            data: i
        };
        return l && (s.captchaToken = l), n && n.field && (s[n.field] = n.value ?? ""), this._call("submitPublicRecord", `/public/${$3e66069dec163cb3$var$r(e)}/collections/${$3e66069dec163cb3$var$r(t)}/submissions`, {
            method: "POST",
            body: s
        });
    }
    votePublicRecord(e, t, i) {
        return $3e66069dec163cb3$var$o(e, "scope"), $3e66069dec163cb3$var$o(t, "key"), $3e66069dec163cb3$var$o(i, "id"), this._call("votePublicRecord", `/public/${$3e66069dec163cb3$var$r(e)}/collections/${$3e66069dec163cb3$var$r(t)}/${$3e66069dec163cb3$var$r(i)}/vote`, {
            method: "POST",
            body: {}
        });
    }
}
const $3e66069dec163cb3$export$337b3540ce6caa75 = (c)=>new $3e66069dec163cb3$export$231f573f8a749489(c);

});

parcelRegister("4Ccat", function(module, exports) {

$parcel$export(module.exports, "PERSONA_TARGET_ROLES", () => $35c42652ba0d5c26$export$3634ca3755b43aff);
$parcel$export(module.exports, "PersonaService", () => $35c42652ba0d5c26$export$5894c225fad48926);

var $em51x = parcelRequire("em51x");

var $6v49f = parcelRequire("6v49f");

var $h5XS2 = parcelRequire("h5XS2");

var $7sTYS = parcelRequire("7sTYS");
var $35c42652ba0d5c26$require$Buffer = $7sTYS.Buffer;
const $35c42652ba0d5c26$export$3634ca3755b43aff = Object.freeze([
    "admin",
    "editor",
    "viewer",
    "guest"
]), $35c42652ba0d5c26$var$d = [
    "userId",
    "user",
    "memberId",
    "email",
    "sub"
], $35c42652ba0d5c26$var$h = new Set([
    404,
    409,
    410
]);
class $35c42652ba0d5c26$export$5894c225fad48926 extends (0, $em51x.BaseService) {
    async startPersona(e = {}) {
        if (e === null || typeof e != "object" || Array.isArray(e)) throw new Error("startPersona requires an argument object: startPersona({ role })");
        const r = $35c42652ba0d5c26$var$d.filter((c)=>c in e);
        if (e.type === "user" || r.length) throw new Error(`persona is role simulation only \u2014 it can never name a user. No user-identifying argument is accepted (got: ${[
            ...e.type === "user" ? [
                'type: "user"'
            ] : [],
            ...r
        ].join(", ")}). Pass { role } with one of: ` + $35c42652ba0d5c26$export$3634ca3755b43aff.join(", "));
        if ("type" in e || "id" in e) throw new Error(`the { type, id } persona shape was removed with the per-person scope cut \u2014 pass { role: '<role>' } (one of: ${$35c42652ba0d5c26$export$3634ca3755b43aff.join(", ")})`);
        const { role: n } = e;
        if (typeof n != "string" || !n) throw new Error("startPersona requires a role \u2014 one of: " + $35c42652ba0d5c26$export$3634ca3755b43aff.join(", "));
        if (n === "owner") throw new Error("'owner' is structurally excluded as a persona target \u2014 it is the baseline an owner already has, not a lens to switch into");
        if (!$35c42652ba0d5c26$export$3634ca3755b43aff.includes(n)) throw new Error(`invalid persona role '${n}' \u2014 must be one of: ${$35c42652ba0d5c26$export$3634ca3755b43aff.join(", ")}`);
        const s = this._decodePersonaClaim(), o = await this._call("startPersona", "/persona/start", {
            method: "POST",
            body: {
                role: n
            }
        });
        this._installPersonaOverlay(o);
        const l = o?.persona || this._decodePersonaClaim();
        return (0, $6v49f.rootBus).emit("sdk.personaChanged", {
            previous: s,
            persona: l
        }), o;
    }
    async endPersona() {
        const e = {
            ok: !1,
            wasActive: !1,
            endedRemotely: !1,
            restored: !1,
            persona: null
        };
        let r = null;
        try {
            if (r = this._decodePersonaClaim(), !r) return e.ok = !0, e;
            e.wasActive = !0;
            let n = null;
            try {
                n = await this._call("endPersona", "/persona/end", {
                    method: "POST",
                    body: {}
                }), e.endedRemotely = !0;
            } catch (o) {
                $35c42652ba0d5c26$var$h.has(o?.status) ? e.endedRemotely = !0 : (0, $h5XS2.logger).warn("[persona] endPersona server call failed \u2014 recovering locally:", o?.message || o);
            }
            if (typeof this._tokenManager?.clearPersonaToken == "function") this._tokenManager.clearPersonaToken(), e.restored = !0;
            else if (this._adoptTokens(n)) e.restored = !0;
            else if (this._tokenManager?.hasRefreshToken?.()) try {
                await this._tokenManager.refreshTokens(), e.restored = !0;
            } catch (o) {
                (0, $h5XS2.logger).warn("[persona] token refresh during endPersona failed:", o?.message || o);
            }
            const s = this._decodePersonaClaim();
            e.ok = !s, e.persona = s, e.ok || (e.error = "persona still active on the current token \u2014 server unreachable and token not refreshable; retry endPersona()");
        } catch (n) {
            e.error = n?.message || String(n), (0, $h5XS2.logger).warn("[persona] endPersona failed unexpectedly:", e.error);
        }
        return e.ok && e.wasActive && (0, $6v49f.rootBus).emit("sdk.personaChanged", {
            previous: r,
            persona: null
        }), e;
    }
    async getPersona() {
        return this._decodePersonaClaim();
    }
    switchWorkspace() {
        if (this._decodePersonaClaim()) return this.endPersona();
    }
    switchOrg() {
        if (this._decodePersonaClaim()) return this.endPersona();
    }
    _adoptTokens(e) {
        const r = e?.accessToken || e?.tokens?.accessToken || null;
        if (!r || !this._tokenManager) return !1;
        const n = e?.refreshToken || e?.tokens?.refreshToken || null, s = e?.expiresIn ?? e?.tokens?.accessTokenExp?.expiresIn;
        return this._tokenManager.setTokens({
            access_token: r,
            refresh_token: n,
            ...s != null ? {
                expires_in: s
            } : {},
            token_type: "Bearer"
        }), !0;
    }
    _installPersonaOverlay(e) {
        const r = e?.accessToken || e?.tokens?.accessToken || null;
        return !r || !this._tokenManager ? !1 : typeof this._tokenManager.setPersonaToken == "function" ? this._tokenManager.setPersonaToken(r) : ((0, $h5XS2.logger).warn("[persona] TokenManager has no overlay support \u2014 falling back to cross-tab token adoption"), this._adoptTokens(e));
    }
    _decodeAccessTokenClaims() {
        const e = this._tokenManager?.getAccessToken?.();
        if (!e || typeof e != "string") return null;
        const r = e.split(".");
        if (r.length !== 3) return null;
        try {
            let n = r[1].replace(/-/g, "+").replace(/_/g, "/");
            for(; n.length % 4;)n += "=";
            const s = typeof atob == "function" ? atob(n) : $35c42652ba0d5c26$require$Buffer.from(n, "base64").toString("utf8");
            return JSON.parse(s);
        } catch  {
            return null;
        }
    }
    _decodePersonaClaim() {
        const r = this._decodeAccessTokenClaims()?.persona;
        return !r || typeof r != "object" ? null : {
            role: typeof r.role == "string" ? r.role : null,
            sid: r.sid ?? null,
            startedAt: r.startedAt ?? null
        };
    }
}

});


parcelRegister("huLI0", function(module, exports) {

$parcel$export(module.exports, "SERVICE_METHODS", () => $cbca3ef9a96d793c$export$53938b3fcad004);
const $cbca3ef9a96d793c$export$53938b3fcad004 = {
    hasPermission: "auth",
    hasGlobalPermission: "auth",
    connect: "collab",
    disconnect: "collab",
    isConnected: "collab",
    updateData: "collab",
    addItem: "collab",
    addMultipleItems: "collab",
    updateItem: "collab",
    deleteItem: "collab",
    undo: "collab",
    redo: "collab",
    checkpoint: "collab",
    sendCursor: "collab",
    sendPresence: "collab",
    toggleLive: "collab",
    getStoredAuthState: "auth",
    getAuthToken: "auth",
    getSignupPolicy: "auth",
    register: "auth",
    login: "auth",
    startDemo: "auth",
    enterDemo: "auth",
    claimDemoAccount: "auth",
    cloneDemoWorkspace: "auth",
    logout: "auth",
    refreshToken: "auth",
    googleAuth: "auth",
    googleAuthCallback: "auth",
    githubAuth: "auth",
    exchangeNativeAuthToken: "auth",
    requestPasswordReset: "auth",
    confirmPasswordReset: "auth",
    confirmRegistration: "auth",
    previewRegisterConfirmation: "auth",
    setInitialPassword: "auth",
    getSignInSessionInfo: "auth",
    activateSignInSession: "auth",
    requestPasswordChange: "auth",
    confirmPasswordChange: "auth",
    getMe: "auth",
    updateMe: "auth",
    checkUsernameAvailable: "auth",
    getPermissions: "auth",
    getSession: "auth",
    onAuthStateChange: "auth",
    getTokenDebugInfo: "auth",
    getMyProjectRoleByKey: "auth",
    getProjectRoleWithFallback: "auth",
    getProjectRoleByKeyWithFallback: "auth",
    getMyOrgNotifications: "auth",
    getMyFreebusy: "auth",
    getMyProjects: "auth",
    getMyTeams: "auth",
    getMyOrgMemberships: "auth",
    getOrgMemberRoles: "auth",
    setActiveOrganization: "auth",
    setActiveWorkspace: "auth",
    subscribeUserEvents: "auth",
    subscribePresence: "auth",
    resendVerification: "auth",
    verifyEmail: "auth",
    getUserProfile: "auth",
    updateUserProfile: "auth",
    updateUserHrProfile: "auth",
    getUserProjects: "auth",
    getUser: "auth",
    getUserByEmail: "auth",
    getUserByUsername: "auth",
    listAgents: "auth",
    createAgent: "auth",
    getAgent: "auth",
    updateAgent: "auth",
    getAgentToolCatalog: "auth",
    createProject: "project",
    getProjects: "project",
    getProject: "project",
    getProjectByKey: "project",
    getProjectDataByKey: "project",
    getPublicProjectDataByKey: "project",
    getPublicProjectVisibility: "project",
    unlockPublicProjectDataByKey: "project",
    getPublicProject: "project",
    listPublicProjects: "project",
    listProjects: "project",
    updateProject: "project",
    updateProjectComponents: "project",
    updateProjectSettings: "project",
    updateProjectName: "project",
    updateProjectPackage: "project",
    duplicateProject: "project",
    removeProject: "project",
    transferProjectOwnership: "project",
    checkProjectKeyAvailability: "project",
    getProjectRolePermissionsConfig: "project",
    updateProjectRolePermissionsConfig: "project",
    listEnvironments: "project",
    upsertEnvironment: "project",
    updateEnvironment: "project",
    publishToEnvironment: "project",
    deleteEnvironment: "project",
    promoteEnvironment: "project",
    getProjectMembers: "project",
    inviteMember: "project",
    acceptInvite: "project",
    createMagicInviteLink: "project",
    updateMemberRole: "project",
    removeMember: "project",
    getAvailableLibraries: "project",
    getProjectLibraries: "project",
    addProjectLibraries: "project",
    removeProjectLibraries: "project",
    applyProjectChanges: "project",
    getProjectData: "project",
    getProjectVersions: "project",
    getProjectVersion: "project",
    getLatestProjectVersion: "project",
    getProjectVersionData: "project",
    restoreProjectVersion: "project",
    updateProjectItem: "project",
    deleteProjectItem: "project",
    setProjectValue: "project",
    addProjectItems: "project",
    getProjectItemByPath: "project",
    setProjectAccess: "project",
    setProjectVisibility: "project",
    getFavoriteProjects: "project",
    addFavoriteProject: "project",
    removeFavoriteProject: "project",
    getRecentProjects: "project",
    getPlans: "plan",
    getPlan: "plan",
    getAdminPlans: "plan",
    createPlan: "plan",
    updatePlan: "plan",
    deletePlan: "plan",
    initializePlans: "plan",
    getPlansWithValidation: "plan",
    getPlanWithValidation: "plan",
    createPlanWithValidation: "plan",
    updatePlanWithValidation: "plan",
    getActivePlans: "plan",
    getPlansByPriceRange: "plan",
    getPlanByKey: "plan",
    getPlansWithPricing: "plan",
    createSubscription: "subscription",
    createWorkspaceSubscriptionCheckout: "subscription",
    getProjectStatus: "subscription",
    getUsage: "subscription",
    cancelSubscription: "subscription",
    listInvoices: "subscription",
    getPortalUrl: "subscription",
    createSubscriptionWithValidation: "subscription",
    hasActiveSubscription: "subscription",
    getProjectSubscription: "subscription",
    getProjectUsage: "subscription",
    getInvoicesWithPagination: "subscription",
    isSubscriptionActive: "subscription",
    getSubscriptionLimits: "subscription",
    changeSubscription: "subscription",
    downgrade: "subscription",
    changeSubscriptionWithValidation: "subscription",
    downgradeWithValidation: "subscription",
    uploadFile: "file",
    updateProjectIcon: "file",
    uploadFileWithValidation: "file",
    uploadImage: "file",
    uploadDocument: "file",
    getFileUrl: "file",
    downloadFileContent: "file",
    extractFileText: "file",
    validateFile: "file",
    createFileFormData: "file",
    uploadMultipleFiles: "file",
    checkout: "payment",
    getSubscriptionStatus: "payment",
    checkoutWithValidation: "payment",
    getSubscriptionStatusWithValidation: "payment",
    getSubscriptionDetails: "payment",
    checkoutForPlan: "payment",
    checkoutForTeam: "payment",
    validateSubscriptionStatus: "payment",
    formatSubscriptionAmount: "payment",
    getSubscriptionSummary: "payment",
    createDnsRecord: "dns",
    getDnsRecord: "dns",
    removeDnsRecord: "dns",
    getCustomHost: "dns",
    addProjectCustomDomains: "dns",
    addProjectCustomDomain: "dns",
    validateDomain: "dns",
    createDnsRecordWithValidation: "dns",
    getDnsRecordWithValidation: "dns",
    removeDnsRecordWithValidation: "dns",
    addProjectCustomDomainsWithValidation: "dns",
    isDomainAvailable: "dns",
    getDomainStatus: "dns",
    verifyDomainOwnership: "dns",
    getProjectDomains: "dns",
    removeProjectCustomDomain: "dns",
    formatDomain: "dns",
    extractDomainFromUrl: "dns",
    listBranches: "branch",
    createBranch: "branch",
    deleteBranch: "branch",
    renameBranch: "branch",
    getBranchChanges: "branch",
    mergeBranch: "branch",
    resetBranch: "branch",
    publishVersion: "branch",
    createBranchWithValidation: "branch",
    branchExists: "branch",
    previewMerge: "branch",
    commitMerge: "branch",
    createFeatureBranch: "branch",
    createHotfixBranch: "branch",
    getBranchStatus: "branch",
    deleteBranchSafely: "branch",
    getBranchesWithStatus: "branch",
    validateBranchName: "branch",
    sanitizeBranchName: "branch",
    createPullRequest: "pullRequest",
    listPullRequests: "pullRequest",
    getPullRequest: "pullRequest",
    reviewPullRequest: "pullRequest",
    addPullRequestComment: "pullRequest",
    mergePullRequest: "pullRequest",
    getPullRequestDiff: "pullRequest",
    createPullRequestWithValidation: "pullRequest",
    approvePullRequest: "pullRequest",
    requestPullRequestChanges: "pullRequest",
    getOpenPullRequests: "pullRequest",
    getClosedPullRequests: "pullRequest",
    getMergedPullRequests: "pullRequest",
    isPullRequestMergeable: "pullRequest",
    getPullRequestStatusSummary: "pullRequest",
    validatePullRequestData: "pullRequest",
    validateReviewData: "pullRequest",
    getPullRequestStats: "pullRequest",
    closePullRequest: "pullRequest",
    reopenPullRequest: "pullRequest",
    getAdminUsers: "admin",
    assignProjectsToUser: "admin",
    updateUser: "admin",
    searchAdminUsers: "admin",
    getAdminUsersByEmails: "admin",
    getAdminUsersByIds: "admin",
    assignSpecificProjectsToUser: "admin",
    assignAllProjectsToUser: "admin",
    validateUserData: "admin",
    updateUserWithValidation: "admin",
    getUserStats: "admin",
    bulkUpdateUsers: "admin",
    getUsersByRole: "admin",
    getUsersByStatus: "admin",
    activateUser: "admin",
    deactivateUser: "admin",
    suspendUser: "admin",
    promoteToAdmin: "admin",
    demoteFromAdmin: "admin",
    getSystemStatus: "admin",
    getSystemUptime: "admin",
    getAdminSubscribers: "admin",
    createScreenshotProject: "screenshot",
    getProjectScreenshots: "screenshot",
    reprocessProjectScreenshots: "screenshot",
    recreateProjectScreenshots: "screenshot",
    deleteProjectScreenshots: "screenshot",
    getThumbnailCandidate: "screenshot",
    updateProjectThumbnail: "screenshot",
    getPageScreenshot: "screenshot",
    getComponentScreenshot: "screenshot",
    getScreenshotByKey: "screenshot",
    getQueueStatistics: "screenshot",
    refreshThumbnail: "screenshot",
    configureTracking: "tracking",
    trackEvent: "tracking",
    trackError: "tracking",
    captureException: "tracking",
    logMessage: "tracking",
    logDebug: "tracking",
    logInfo: "tracking",
    logWarning: "tracking",
    logWarn: "tracking",
    logErrorMessage: "tracking",
    logError: "tracking",
    addBreadcrumb: "tracking",
    trackMeasurement: "tracking",
    trackView: "tracking",
    setUser: "tracking",
    clearUser: "tracking",
    setSession: "tracking",
    clearSession: "tracking",
    setGlobalAttributes: "tracking",
    setGlobalAttribute: "tracking",
    removeGlobalAttribute: "tracking",
    flushQueue: "tracking",
    getClient: "tracking",
    isEnabled: "tracking",
    isInitialized: "tracking",
    joinWaitlist: "waitlist",
    getOnboardingConfig: "onboardingResearch",
    startResearch: "onboardingResearch",
    getResearch: "onboardingResearch",
    streamResearch: "onboardingResearch",
    getOnboardingBuild: "onboardingResearch",
    retryOnboardingBuildStep: "onboardingResearch",
    deleteOnboardingResearch: "onboardingResearch",
    markOnboardingProfileReviewed: "onboardingResearch",
    deleteOnboardingResearchLine: "onboardingResearch",
    listOnboardingPeople: "onboardingResearch",
    removeOnboardingPerson: "onboardingResearch",
    listImportSources: "imports",
    listImportTargets: "imports",
    uploadImportFile: "imports",
    previewImport: "imports",
    runImport: "imports",
    getImport: "imports",
    undoImport: "imports",
    inviteOnboardingPerson: "onboardingResearch",
    listWaitlistEntries: "waitlist",
    updateWaitlistEntry: "waitlist",
    inviteWaitlistEntry: "waitlist",
    getContributions: "metrics",
    integrationWhoami: "integration",
    listIntegrations: "integration",
    createIntegration: "integration",
    updateIntegration: "integration",
    createIntegrationApiKey: "integration",
    listIntegrationApiKeys: "integration",
    revokeIntegrationApiKey: "integration",
    createIntegrationWebhook: "integration",
    listIntegrationWebhooks: "integration",
    updateIntegrationWebhook: "integration",
    deleteIntegrationWebhook: "integration",
    listIntegrationWebhookDeliveries: "integration",
    replayIntegrationWebhookDelivery: "integration",
    listGitHubConnectors: "integration",
    createGitHubConnector: "integration",
    updateGitHubConnector: "integration",
    deleteGitHubConnector: "integration",
    getGitHubRepo: "integration",
    listGitHubRepos: "integration",
    syncGitHubIntegration: "integration",
    listOrgIntegrations: "integration",
    upsertOrgIntegration: "integration",
    deleteOrgIntegration: "integration",
    assignOrgIntegrationScope: "integration",
    reorderOrgIntegrations: "integration",
    listOrgIntegrationKinds: "integration",
    getIntegrationsCatalog: "integration",
    callOrgIntegrationCapability: "integration",
    listMarketplaceEntitlements: "integration",
    checkMarketplaceEntitlement: "integration",
    installMarketplaceIntegration: "integration",
    uninstallMarketplaceIntegration: "integration",
    getFeatureFlags: "featureFlag",
    getFeatureFlag: "featureFlag",
    getAdminFeatureFlags: "featureFlag",
    createFeatureFlag: "featureFlag",
    updateFeatureFlag: "featureFlag",
    archiveFeatureFlag: "featureFlag",
    createOrganization: "organization",
    listOrganizations: "organization",
    checkOrganizationSlug: "organization",
    getOrganization: "organization",
    updateOrganization: "organization",
    updateOrganizationBranding: "organization",
    transferOrgOwnership: "organization",
    deleteOrganization: "organization",
    listOrgMembers: "organization",
    addOrgMember: "organization",
    updateOrgMember: "organization",
    removeOrgMember: "organization",
    createTeam: "organization",
    listTeams: "organization",
    updateTeam: "organization",
    deleteTeam: "organization",
    listTeamMembers: "organization",
    listOrgTeamMembers: "organization",
    addTeamMember: "organization",
    updateTeamMember: "organization",
    removeTeamMember: "organization",
    listAgentAssignments: "organization",
    assignAgent: "organization",
    updateAgentAssignment: "organization",
    unassignAgent: "organization",
    setMemberStatus: "organization",
    createOrgInvitation: "organization",
    createOrgInvitationLink: "organization",
    listOrgInvitations: "organization",
    revokeOrgInvitation: "organization",
    acceptOrgInvitation: "organization",
    listTeamInvitations: "organization",
    createTeamInvitation: "organization",
    inviteToTeam: "organization",
    revokeTeamInvitation: "organization",
    acceptTeamInvitation: "organization",
    getOrgProjectPermissions: "organization",
    updateOrgProjectPermissions: "organization",
    listTeamAccess: "organization",
    grantTeamAccess: "organization",
    updateTeamAccess: "organization",
    revokeTeamAccess: "organization",
    createOrgProject: "organization",
    adminListOrganizations: "organization",
    getCreditPool: "organization",
    updateCreditPool: "organization",
    getSso: "organization",
    updateSso: "organization",
    getScim: "organization",
    updateScim: "organization",
    listOrgCustomDomains: "organization",
    attachOrgCustomDomain: "organization",
    verifyOrgCustomDomain: "organization",
    boot: "boot",
    mcpConnectorList: "mcpConnector",
    mcpConnectorGet: "mcpConnector",
    mcpConnectorCreate: "mcpConnector",
    mcpConnectorUpdate: "mcpConnector",
    mcpConnectorDiscover: "mcpConnector",
    mcpConnectorSetStatus: "mcpConnector",
    mcpConnectorRemove: "mcpConnector",
    voiceTranscribe: "voice",
    voiceTts: "voice",
    voiceVoices: "voice",
    voiceAgentSession: "voice",
    createWorkspace: "workspace",
    listWorkspaces: "workspace",
    getWorkspace: "workspace",
    updateWorkspace: "workspace",
    updateWorkspaceSettings: "workspace",
    deleteWorkspace: "workspace",
    startWorkspaceExport: "workspace",
    listWorkspaceExports: "workspace",
    getWorkspaceExport: "workspace",
    getWorkspaceExportDownloadUrl: "workspace",
    deleteWorkspaceExport: "workspace",
    listWorkspaceMembers: "workspace",
    addWorkspaceMember: "workspace",
    updateWorkspaceMemberRole: "workspace",
    removeWorkspaceMember: "workspace",
    getWorkspaceMemberRecordScope: "workspace",
    updateWorkspaceMemberRecordScope: "workspace",
    grantWorkspaceTeamAccess: "workspace",
    revokeWorkspaceTeamAccess: "workspace",
    getBilling: "workspace",
    getCreditBalance: "workspace",
    getCreditLedger: "workspace",
    getSignupClaimStatus: "workspace",
    claimSignupCredits: "workspace",
    getWorkspaceUsage: "workspace",
    getWorkspaceUsageByActor: "workspace",
    createCreditTopupCheckout: "workspace",
    confirmCreditTopup: "workspace",
    getAutoTopup: "workspace",
    setupAutoTopup: "workspace",
    pauseAutoTopup: "workspace",
    refreshAutoTopup: "workspace",
    getSpendControls: "workspace",
    updateSpendControls: "workspace",
    getWorkspaceAppDependencies: "workspace",
    installWorkspaceApps: "workspace",
    removeWorkspaceApp: "workspace",
    listWorkspacePresets: "workspace",
    applyWorkspacePreset: "workspace",
    saveWorkspaceBlueprint: "workspace",
    getWorkspaceBlueprint: "workspace",
    startWorkspaceSetup: "workspace",
    getWorkspaceSetup: "workspace",
    estimateBuild: "workspace",
    getWorkspacePublicConfig: "workspace",
    upsertWorkspacePublicConfig: "workspace",
    deleteWorkspacePublicConfig: "workspace",
    listWorkspaceSecrets: "workspace",
    upsertWorkspaceSecret: "workspace",
    deleteWorkspaceSecret: "workspace",
    getRates: "credits",
    getProjectBalance: "credits",
    getProjectLedger: "credits",
    getProjectSpendControls: "credits",
    updateProjectSpendControls: "credits",
    topupProjectCredits: "credits",
    getPricingOptions: "subscription",
    canAccessProjectFeature: "subscription",
    grantProjectFeature: "subscription",
    revokeProjectFeature: "subscription",
    configure: "tracking",
    flush: "tracking",
    getWorkspacePermissions: "workspace",
    createWorkspaceProject: "workspace",
    listWorkspaceInvitations: "workspace",
    createWorkspaceInvitation: "workspace",
    revokeWorkspaceInvitation: "workspace",
    acceptWorkspaceInvitation: "workspace",
    getInvitationPreview: "workspace",
    setProjectSourceAccess: "project",
    transferProjectToWorkspace: "project",
    getRateLimitStats: "admin",
    listRules: "allocationRule",
    getRule: "allocationRule",
    createRule: "allocationRule",
    updateRule: "allocationRule",
    deleteRule: "allocationRule",
    createAsset: "sharedAsset",
    listAssets: "sharedAsset",
    getAsset: "sharedAsset",
    updateAsset: "sharedAsset",
    deleteAsset: "sharedAsset",
    getCanvasLayout: "canvasLayout",
    patchCanvasLayout: "canvasLayout",
    subscribeWorkspaceCanvasLayout: "canvasLayout",
    subscribeWorkspaceFileCanvas: "canvasLayout",
    meetGuestMeta: "meet",
    meetGuestRequest: "meet",
    meetGuestStatus: "meet",
    meetGuestToken: "meet",
    meetMuteParticipant: "meet",
    meetArchiveRooms: "meet",
    calendarListEvents: "calendar",
    calendarGetEvent: "calendar",
    calendarCreateEvent: "calendar",
    calendarUpdateEvent: "calendar",
    calendarDeleteEvent: "calendar",
    calendarDeleteFutureEvents: "calendar",
    calendarSync: "calendar",
    calendarSyncStatus: "calendar",
    getBuildsGitHubState: "builds",
    listBuildRepos: "builds",
    listBuildImports: "builds",
    createBuildImport: "builds",
    updateBuildImport: "builds",
    deleteBuildImport: "builds",
    triggerBuild: "builds",
    listBuilds: "builds",
    getBuild: "builds",
    getBuildLogs: "builds",
    deployBuild: "builds",
    listBuildDeployments: "builds",
    rollbackDeployment: "builds",
    scaleDeployment: "builds",
    getDeploymentMetrics: "builds",
    subscribeWorkspaceBuilds: "builds",
    checkProjectDomain: "dns",
    checkProjectCustomDomain: "dns",
    getProjectCustomDomainStatus: "dns",
    getProjectDomainInstructions: "dns",
    getProjectCustomDomainInstructions: "dns",
    startProjectCustomDomainSetup: "dns",
    pollProjectCustomDomainStatus: "dns",
    createShareLink: "shareLinks",
    listShareLinks: "shareLinks",
    revokeShareLink: "shareLinks",
    getSharedResource: "shareLinks",
    getSharedResourceContentUrl: "shareLinks",
    shareUrl: "shareLinks",
    listStorefrontProducts: "storefront",
    getStorefrontProduct: "storefront",
    listStorefrontCollection: "storefront",
    listStorefrontJobs: "storefront",
    getStorefrontJob: "storefront",
    applyToStorefrontJob: "storefront",
    listPublicRecords: "publicRecords",
    getPublicRecord: "publicRecords",
    submitPublicRecord: "publicRecords",
    votePublicRecord: "publicRecords",
    startPersona: "persona",
    endPersona: "persona",
    getPersona: "persona",
    getPersonaSession: "workspaceProject",
    registerStorefrontCustomer: "storefront",
    loginStorefrontCustomer: "storefront",
    requestStorefrontCustomerOtp: "storefront",
    verifyStorefrontCustomerOtp: "storefront",
    resetStorefrontCustomerPassword: "storefront",
    getStorefrontCustomerMe: "storefront",
    getStorefrontAuthProviders: "storefront",
    signInStorefrontCustomerWithOAuth: "storefront",
    setStorefrontAuthProviders: "storefront",
    getStorefrontSchema: "storefront",
    setStorefrontSchema: "storefront",
    resolveStorefront: "storefront",
    listStorefrontBundles: "storefront",
    listStorefrontCmsTypes: "storefront",
    listStorefrontCmsEntries: "storefront",
    placeStorefrontOrder: "storefront",
    getStorefrontOrderStatus: "storefront",
    payStorefrontOrderTest: "storefront",
    listStorefrontOrders: "storefront",
    getStorefrontOrder: "storefront",
    getStorefrontCart: "storefront",
    replaceStorefrontCart: "storefront",
    clearStorefrontCart: "storefront",
    listStorefrontAddresses: "storefront",
    createStorefrontAddress: "storefront",
    updateStorefrontAddress: "storefront",
    deleteStorefrontAddress: "storefront",
    updateStorefrontCustomerMe: "storefront",
    changeStorefrontCustomerPassword: "storefront",
    deleteStorefrontCustomerAccount: "storefront",
    listStorefrontAppointments: "storefront",
    getStorefrontBalances: "storefront",
    listStorefrontLoyalty: "storefront",
    subscribeStorefrontEvents: "storefront",
    getStorefrontCheckout: "storefront",
    confirmStorefrontCashPayment: "storefront",
    getStorefrontCheckoutSettings: "storefront",
    setStorefrontCheckoutSettings: "storefront",
    getStorefrontPaymentSettings: "storefront",
    setStorefrontPaymentSettings: "storefront",
    frSearch: "registry",
    frCompany: "registry",
    frStatus: "registry"
};

});

parcelRegister("eatmv", function(module, exports) {

$parcel$export(module.exports, "registerEntity", () => $a508c689470f9212$export$8afc2bf1b919cbde);
$parcel$export(module.exports, "createEntityDispatcher", () => $a508c689470f9212$export$18d13f57a667a03d);

var $4QZMS = parcelRequire("4QZMS");

var $g0NMY = parcelRequire("g0NMY");
const $a508c689470f9212$var$W = [
    "filter",
    "params",
    "options",
    "single",
    "limit",
    "offset",
    "order"
], $a508c689470f9212$var$t = {
    filterOptions: (e)=>{
        const s = e && typeof e == "object" && !Array.isArray(e) ? e : {}, o = {};
        for(const c in s)$a508c689470f9212$var$W.includes(c) || (o[c] = s[c]);
        return [
            s.filter ?? s.params ?? (Object.keys(o).length ? o : void 0),
            {
                single: s.single,
                limit: s.limit,
                offset: s.offset,
                order: s.order,
                ...s.workspaceId !== void 0 ? {
                    workspaceId: s.workspaceId
                } : {},
                ...s.options || {}
            }
        ];
    },
    id: (e)=>[
            e?.id ?? e?.number ?? e
        ],
    payload: (e)=>[
            e?.payload ?? e?.data ?? e
        ],
    idPayload: (e)=>[
            e?.id ?? e?.number,
            e?.payload ?? e?.data ?? (()=>{
                const { id: s, number: o, ...i } = e || {};
                return i;
            })()
        ]
}, $a508c689470f9212$var$P = (e)=>{
    const s = e && typeof e == "object" && !Array.isArray(e) ? e : {};
    if (s.filter && typeof s.filter == "object") return [
        s.filter
    ];
    if (s.params && typeof s.params == "object") return [
        s.params
    ];
    const { filter: o, params: i, options: c, ...u } = s;
    return [
        u
    ];
}, $a508c689470f9212$var$A = (e)=>[
        e && typeof e == "object" && !Array.isArray(e) ? e.workspaceId ?? e.id : e
    ], $a508c689470f9212$var$n = {
    list: $a508c689470f9212$var$t.filterOptions,
    get: $a508c689470f9212$var$t.id,
    create: $a508c689470f9212$var$t.payload,
    update: $a508c689470f9212$var$t.idPayload,
    remove: $a508c689470f9212$var$t.id
}, $a508c689470f9212$var$d = (e)=>e && typeof e == "object" && e.workspaceId !== void 0 ? [
        {
            workspaceId: e.workspaceId
        }
    ] : [], $a508c689470f9212$var$a = (e, s)=>{
    if (!e || typeof e != "object" || Array.isArray(e)) return e;
    const o = {};
    for(const i in e)i !== "workspaceId" && !(s && s.includes(i)) && (o[i] = e[i]);
    return o;
}, $a508c689470f9212$var$r = {
    id: (e)=>[
            e?.id ?? e?.number ?? e,
            ...$a508c689470f9212$var$d(e)
        ],
    payload: (e)=>[
            e?.payload ?? e?.data ?? $a508c689470f9212$var$a(e),
            ...$a508c689470f9212$var$d(e)
        ],
    idPayload: (e)=>[
            e?.id ?? e?.number,
            e?.payload ?? e?.data ?? $a508c689470f9212$var$a(e, [
                "id",
                "number"
            ]),
            ...$a508c689470f9212$var$d(e)
        ]
}, $a508c689470f9212$var$p = {
    list: $a508c689470f9212$var$t.filterOptions,
    get: $a508c689470f9212$var$r.id,
    create: $a508c689470f9212$var$r.payload,
    update: $a508c689470f9212$var$r.idPayload,
    remove: $a508c689470f9212$var$r.id
}, $a508c689470f9212$var$k = (e)=>({
        workspaceId: e?.workspaceId
    }), $a508c689470f9212$var$C = {
    ...$a508c689470f9212$var$p,
    summary: $a508c689470f9212$var$t.filterOptions,
    pipelines: (e)=>[
            $a508c689470f9212$var$k(e)
        ],
    move: (e)=>[
            e?.id,
            {
                stage: e?.stage,
                pipeline: e?.pipeline,
                stageOrder: e?.stageOrder
            },
            $a508c689470f9212$var$k(e)
        ],
    markWon: (e)=>[
            e?.id,
            $a508c689470f9212$var$k(e)
        ],
    markLost: (e)=>[
            e?.id,
            e?.lossReason ?? null,
            $a508c689470f9212$var$k(e)
        ],
    reopen: (e)=>[
            e?.id,
            {
                stage: e?.stage
            },
            $a508c689470f9212$var$k(e)
        ],
    convert: (e)=>[
            e?.id,
            $a508c689470f9212$var$a(e, [
                "id"
            ]),
            $a508c689470f9212$var$k(e)
        ]
}, $a508c689470f9212$var$D = (e, s)=>e?.payload ?? $a508c689470f9212$var$a(e, s), $a508c689470f9212$var$L = {
    list: $a508c689470f9212$var$t.filterOptions,
    get: $a508c689470f9212$var$r.id,
    create: (e)=>[
            $a508c689470f9212$var$D(e),
            ...$a508c689470f9212$var$d(e)
        ],
    update: (e)=>[
            e?.id ?? e?.number,
            $a508c689470f9212$var$D(e, [
                "id",
                "number"
            ]),
            ...$a508c689470f9212$var$d(e)
        ],
    remove: $a508c689470f9212$var$r.id,
    subscribe: (e)=>[
            e || {}
        ]
}, $a508c689470f9212$var$U = {
    enrich: (e)=>[
            e?.payload ?? e?.data ?? $a508c689470f9212$var$a(e),
            ...$a508c689470f9212$var$d(e)
        ]
}, $a508c689470f9212$var$T = (e)=>e?.payload ?? e?.data ?? (()=>{
        const { partyId: s, id: o, workspaceId: i, ...c } = e || {};
        return c;
    })(), $a508c689470f9212$var$K = (e)=>e?.payload ?? e?.data ?? (()=>{
        const { conversationId: s, id: o, ...i } = e || {};
        return i;
    })(), $a508c689470f9212$var$v = (e)=>[
        e?.filter ?? e?.params ?? e,
        {
            workspaceId: e?.workspaceId,
            since: e?.since,
            limit: e?.limit,
            ...e?.options || {}
        }
    ], $a508c689470f9212$var$f = (e)=>[
        {
            workspaceId: e?.workspaceId ?? e?.params?.workspaceId ?? e?.filter?.workspaceId
        }
    ], $a508c689470f9212$var$h = (e)=>e?.workspaceId ?? e?.params?.workspaceId ?? e?.filter?.workspaceId, $a508c689470f9212$var$I = {
    "i18n.translations": {
        service: "workspaceProject",
        methods: {
            subscribe: "i18n.subscribeTranslations"
        },
        argMap: {
            subscribe: (e)=>[
                    {
                        lang: e?.lang ?? e?.filter?.lang,
                        namespace: e?.namespace ?? e?.filter?.namespace
                    }
                ]
        }
    },
    "auth.session": {
        service: "auth",
        methods: {
            list: "getSession",
            subscribe: "onAuthStateChange"
        }
    },
    "auth.me": {
        service: "auth",
        methods: {
            list: "getMe",
            get: "getMe",
            update: "updateMe"
        }
    },
    "auth.permissions": {
        service: "auth",
        methods: {
            list: "getPermissions"
        }
    },
    "users.members": {
        service: "auth",
        methods: {
            list: "listMembers"
        },
        argMap: {
            list: (e)=>e?.workspaceId || e?.orgSlug ? [
                    {
                        workspaceId: e?.workspaceId,
                        orgSlug: e?.orgSlug
                    }
                ] : [
                    void 0
                ]
        }
    },
    organization: {
        service: "organization",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        }
    },
    organizations: {
        service: "organization",
        methods: {
            delete: "deleteOrganization"
        },
        argMap: {
            delete: (e)=>[
                    e?.id ?? e?.orgId,
                    {
                        mode: e?.mode,
                        dryRun: e?.dryRun,
                        cascade: e?.cascade
                    }
                ]
        }
    },
    "organization.members": {
        service: "organization",
        methods: {
            list: "listMembers",
            create: "inviteMember",
            remove: "removeMember"
        }
    },
    "organization.roles": {
        service: "organization",
        methods: {
            list: "listRoles"
        }
    },
    workspace: {
        service: "workspace",
        methods: {
            list: "listWorkspaces",
            get: "getWorkspace",
            create: "createWorkspace",
            update: "updateWorkspace",
            remove: "deleteWorkspace"
        }
    },
    "workspace.members": {
        service: "workspace",
        methods: {
            list: "listWorkspaceMembers",
            create: "addWorkspaceMember"
        }
    },
    "workspace.members.recordScope": {
        service: "workspace",
        methods: {
            get: "getWorkspaceMemberRecordScope",
            list: "getWorkspaceMemberRecordScope",
            update: "updateWorkspaceMemberRecordScope"
        },
        argMap: {
            get: (e)=>[
                    e?.workspaceId,
                    e?.userId
                ],
            list: (e)=>[
                    e?.workspaceId,
                    e?.userId
                ],
            update: (e)=>[
                    e?.workspaceId,
                    e?.userId,
                    e?.payload ?? e?.data ?? (()=>{
                        const { workspaceId: s, userId: o, ...i } = e || {};
                        return i;
                    })()
                ]
        }
    },
    "workspace.blueprint": {
        service: "workspace",
        methods: {
            get: "getWorkspaceBlueprint",
            list: "getWorkspaceBlueprint",
            update: "saveWorkspaceBlueprint"
        },
        argMap: {
            get: (e)=>[
                    $a508c689470f9212$var$h(e)
                ],
            list: (e)=>[
                    $a508c689470f9212$var$h(e)
                ],
            update: (e)=>[
                    $a508c689470f9212$var$h(e),
                    e?.blueprint ?? e?.payload
                ]
        }
    },
    "workspace.setup": {
        service: "workspace",
        methods: {
            get: "getWorkspaceSetup",
            list: "getWorkspaceSetup",
            create: "startWorkspaceSetup"
        },
        argMap: {
            get: (e)=>[
                    $a508c689470f9212$var$h(e)
                ],
            list: (e)=>[
                    $a508c689470f9212$var$h(e)
                ],
            create: (e)=>[
                    $a508c689470f9212$var$h(e),
                    {
                        ...e?.retry !== void 0 ? {
                            retry: e.retry
                        } : {},
                        ...e?.from !== void 0 ? {
                            from: e.from
                        } : {}
                    }
                ]
        }
    },
    "workspace.settings": {
        service: "workspace",
        methods: {
            update: "updateWorkspaceSettings"
        },
        argMap: {
            update: (e)=>[
                    e?.workspaceId ?? e?.id,
                    e?.payload ?? (()=>{
                        const { workspaceId: s, id: o, ...i } = e || {};
                        return i;
                    })()
                ]
        }
    },
    tickets: {
        service: "tickets",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            assign: "assign",
            epicCounts: "epicCounts",
            columnCounts: "columnCounts"
        },
        argMap: {
            ...$a508c689470f9212$var$n,
            assign: (e)=>[
                    e?.id ?? e?.number,
                    e?.assignee ?? e?.email
                ],
            epicCounts: ()=>[],
            columnCounts: (e)=>e?.filter ? [
                    e.filter,
                    {
                        groupBy: e.groupBy
                    }
                ] : [
                    e ?? {}
                ]
        }
    },
    "tickets.columns": {
        service: "tickets",
        methods: {
            list: "columns.list",
            update: "columns.update"
        },
        argMap: {
            list: ()=>[],
            update: $a508c689470f9212$var$t.idPayload
        }
    },
    "tickets.comments": {
        service: "tickets",
        methods: {
            list: "comments.list",
            create: "comments.create",
            update: "comments.update",
            remove: "comments.remove"
        },
        argMap: {
            ...$a508c689470f9212$var$n,
            list: (e)=>{
                const s = e && typeof e == "object" && !Array.isArray(e) ? e : {}, o = s.filter ?? s.params, i = s.ticketId ?? s.id ?? (o && typeof o == "object" ? o.ticketId ?? o.id : o) ?? (s === e ? void 0 : e), c = {};
                for (const u of [
                    "limit",
                    "skip",
                    "sortBy",
                    "sortDir",
                    "includeCount"
                ])s[u] !== void 0 && (c[u] = s[u]);
                return [
                    i,
                    {
                        ...c,
                        ...s.options || {}
                    }
                ];
            }
        }
    },
    "tickets.release": {
        service: "tickets",
        methods: {
            list: "release.list",
            listForStaging: "release.listForStaging",
            listForProd: "release.listForProd",
            create: "release.create",
            promoteToStaging: "release.promoteToStaging"
        },
        argMap: {
            list: (e)=>[
                    e || {}
                ],
            listForStaging: (e)=>[
                    e || {}
                ],
            listForProd: (e)=>[
                    e || {}
                ],
            create: (e)=>[
                    e || {}
                ],
            promoteToStaging: (e)=>[
                    e || {}
                ]
        }
    },
    "tickets.cycle": {
        service: "tickets",
        methods: {
            list: "cycle.list",
            get: "cycle.get",
            create: "cycle.create",
            update: "cycle.update",
            activate: "cycle.activate",
            archive: "cycle.archive",
            listTickets: "cycle.listTickets",
            addTicket: "cycle.addTicket",
            removeTicket: "cycle.removeTicket"
        },
        argMap: {
            list: (e)=>[
                    e || {}
                ],
            get: (e)=>[
                    e?.cycleId ?? e?.id ?? e,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            create: (e)=>[
                    e?.payload ?? e,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            update: (e)=>[
                    e?.cycleId ?? e?.id,
                    e?.payload ?? e,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            activate: (e)=>[
                    e?.cycleId ?? e?.id ?? e,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            archive: (e)=>[
                    e?.cycleId ?? e?.id ?? e,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            listTickets: (e)=>[
                    e?.cycleId ?? e?.id ?? e,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            addTicket: (e)=>[
                    e?.cycleId ?? e?.id,
                    e?.ticketId,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            removeTicket: (e)=>[
                    e?.cycleId ?? e?.id,
                    e?.ticketId,
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    resourceLinks: {
        service: "resourceLinks",
        methods: {
            list: "list",
            create: "create",
            remove: "remove",
            removeByPair: "removeByPair"
        },
        argMap: {
            list: (e)=>[
                    e?.filter ?? e ?? {}
                ],
            create: (e)=>[
                    e?.payload ?? e
                ],
            remove: $a508c689470f9212$var$t.id,
            removeByPair: (e)=>[
                    e?.payload ?? e
                ]
        }
    },
    proposedActions: {
        service: "proposedActions",
        methods: {
            list: "list",
            get: "get",
            create: "propose",
            approve: "approve",
            reject: "reject",
            result: "setResult"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions,
            get: $a508c689470f9212$var$t.id,
            create: $a508c689470f9212$var$t.payload,
            approve: $a508c689470f9212$var$t.id,
            reject: $a508c689470f9212$var$t.id,
            result: $a508c689470f9212$var$t.idPayload
        }
    },
    workflows: {
        service: "workflows",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$n
    },
    fieldDefs: {
        service: "fieldDefs",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$n
    },
    publicRecords: {
        service: "publicRecords",
        methods: {
            list: "listPublicRecords",
            get: "getPublicRecord",
            create: "submitPublicRecord",
            submit: "submitPublicRecord",
            vote: "votePublicRecord"
        },
        argMap: {
            list: (e)=>[
                    e?.scope ?? e?.workspaceId,
                    e?.key ?? e?.collection,
                    {
                        q: e?.q,
                        where: e?.where,
                        sort: e?.sort,
                        limit: e?.limit,
                        page: e?.page
                    }
                ],
            get: (e)=>[
                    e?.scope ?? e?.workspaceId,
                    e?.key ?? e?.collection,
                    e?.idOrSlug ?? e?.slug ?? e?.id
                ],
            create: (e)=>[
                    e?.scope ?? e?.workspaceId,
                    e?.key ?? e?.collection,
                    e?.data ?? e?.payload,
                    {
                        captchaToken: e?.captchaToken,
                        honeypot: e?.honeypot
                    }
                ],
            submit: (e)=>[
                    e?.scope ?? e?.workspaceId,
                    e?.key ?? e?.collection,
                    e?.data ?? e?.payload,
                    {
                        captchaToken: e?.captchaToken,
                        honeypot: e?.honeypot
                    }
                ],
            vote: (e)=>[
                    e?.scope ?? e?.workspaceId,
                    e?.key ?? e?.collection,
                    e?.id
                ]
        }
    },
    publicRecord: {
        service: "publicRecords",
        methods: {
            list: "getPublicRecord",
            get: "getPublicRecord"
        },
        argMap: {
            list: (e)=>[
                    e?.scope ?? e?.workspaceId,
                    e?.key ?? e?.collection,
                    e?.idOrSlug ?? e?.slug ?? e?.id
                ],
            get: (e)=>[
                    e?.scope ?? e?.workspaceId,
                    e?.key ?? e?.collection,
                    e?.idOrSlug ?? e?.slug ?? e?.id
                ]
        }
    },
    recordCollections: {
        service: "recordCollections",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$n
    },
    parties: {
        service: "parties",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            listRoles: "listRoles",
            addRole: "addRole",
            removeRole: "removeRole",
            listRelationships: "listRelationships",
            addRelationship: "addRelationship",
            removeRelationship: "removeRelationship"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            listRoles: (e)=>[
                    e?.partyId ?? e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            addRole: (e)=>[
                    e?.partyId ?? e?.id,
                    $a508c689470f9212$var$T(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            removeRole: (e)=>[
                    e?.partyId ?? e?.id,
                    e?.role,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            listRelationships: (e)=>[
                    e?.partyId ?? e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            addRelationship: (e)=>[
                    e?.partyId ?? e?.id,
                    $a508c689470f9212$var$T(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            removeRelationship: (e)=>[
                    e?.relId ?? e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    interactions: {
        service: "interactions",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            myDay: "myDay",
            markDone: "markDone"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            myDay: (e)=>[
                    {
                        date: e?.date,
                        tz: e?.tz,
                        workspaceId: e?.workspaceId
                    }
                ],
            markDone: (e)=>[
                    e?.id,
                    $a508c689470f9212$var$a(e, [
                        "id"
                    ]),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    leads: {
        service: "leads",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            summary: "summary",
            pipelines: "pipelines",
            move: "move",
            markLost: "markLost",
            reopen: "reopen",
            convert: "convert",
            subscribe: "subscribe"
        },
        argMap: {
            ...$a508c689470f9212$var$C,
            subscribe: (e)=>[
                    e || {}
                ]
        }
    },
    "crm.homeCounts": {
        service: "crm",
        methods: {
            get: "homeCounts"
        },
        argMap: {
            get: (e)=>[
                    {
                        workspaceId: e?.workspaceId,
                        tz: e?.tz,
                        horizonDays: e?.horizonDays,
                        bookingKind: e?.bookingKind
                    }
                ]
        }
    },
    "crm.permissions": {
        service: "crm",
        methods: {
            list: "permissions"
        },
        argMap: {
            list: (e)=>[
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "crm.settings": {
        service: "crm",
        methods: {
            get: "getSettings",
            update: "updateSettings"
        },
        argMap: {
            get: (e)=>[
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            update: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    deals: {
        service: "deals",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            summary: "summary",
            pipelines: "pipelines",
            move: "move",
            markWon: "markWon",
            markLost: "markLost",
            reopen: "reopen"
        },
        argMap: $a508c689470f9212$var$C
    },
    segments: {
        service: "segments",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            members: "listMembers"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            members: $a508c689470f9212$var$t.id
        }
    },
    leadSources: {
        service: "leadSources",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "archive",
            archive: "archive",
            rotateSecret: "rotateSecret",
            sendTestLead: "sendTestLead"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            archive: $a508c689470f9212$var$r.id,
            rotateSecret: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            sendTestLead: (e)=>[
                    e?.id,
                    e?.payload ?? {},
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "leadSources.issues": {
        service: "leadSources",
        methods: {
            list: "listIssues",
            get: "getEvent",
            summary: "issuesSummary",
            retry: "retryIssue",
            retryMany: "retryIssues"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions,
            get: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            summary: $a508c689470f9212$var$t.filterOptions,
            retry: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            retryMany: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "leadSources.settings": {
        service: "leadSources",
        methods: {
            get: "getSettings",
            update: "updateSettings"
        },
        argMap: {
            get: (e)=>[
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            update: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "leadSources.imports": {
        service: "leadSources",
        methods: {
            list: "listImports",
            get: "getImport",
            undo: "undoImport",
            csv: "importCsv",
            bitrix24: "importBitrix24"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions,
            get: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            undo: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            csv: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            bitrix24: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "channels.accounts": {
        service: "channels",
        methods: {
            list: "listAccounts",
            get: "getAccount",
            create: "createAccount",
            update: "updateAccount",
            remove: "disconnectAccount",
            disconnect: "disconnectAccount",
            rotateVerifyToken: "rotateVerifyToken",
            templates: "listTemplates",
            syncTemplates: "syncTemplates",
            simulate: "simulate"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            disconnect: $a508c689470f9212$var$r.id,
            rotateVerifyToken: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            templates: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            syncTemplates: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            simulate: (e)=>[
                    e?.id ?? e?.accountId,
                    e?.payload ?? $a508c689470f9212$var$a(e, [
                        "id",
                        "accountId"
                    ]),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "channels.settings": {
        service: "channels",
        methods: {
            get: "getSettings",
            update: "updateSettings"
        },
        argMap: {
            get: (e)=>[
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            update: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "channels.inbox": {
        service: "channels",
        methods: {
            list: "inbox"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions
        }
    },
    "channels.timeline": {
        service: "channels",
        methods: {
            list: "timeline"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions
        }
    },
    "channels.messages": {
        service: "channels",
        methods: {
            send: "send",
            create: "send"
        },
        argMap: {
            send: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            create: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "channels.calls": {
        service: "channels",
        methods: {
            start: "startCall",
            create: "startCall",
            outcome: "logCallOutcome",
            update: "logCallOutcome",
            simulate: "simulateCall"
        },
        argMap: {
            start: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            create: (e)=>[
                    e?.payload ?? $a508c689470f9212$var$a(e),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            outcome: (e)=>[
                    e?.id,
                    e?.payload ?? $a508c689470f9212$var$a(e, [
                        "id"
                    ]),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            update: (e)=>[
                    e?.id,
                    e?.payload ?? $a508c689470f9212$var$a(e, [
                        "id"
                    ]),
                    {
                        workspaceId: e?.workspaceId
                    }
                ],
            simulate: (e)=>[
                    e?.id,
                    e?.payload ?? $a508c689470f9212$var$a(e, [
                        "id"
                    ]),
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    "channels.conversations": {
        service: "channels",
        methods: {
            read: "markRead"
        },
        argMap: {
            read: (e)=>[
                    e?.id,
                    {
                        workspaceId: e?.workspaceId
                    }
                ]
        }
    },
    products: {
        service: "products",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$p
    },
    prices: {
        service: "prices",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$p
    },
    agreements: {
        service: "agreements",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$p
    },
    invoices: {
        service: "invoices",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            issue: "issue",
            void: "void",
            createCreditNote: "createCreditNote",
            listCreditNotes: "listCreditNotes"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            issue: $a508c689470f9212$var$r.id,
            void: $a508c689470f9212$var$r.idPayload,
            createCreditNote: $a508c689470f9212$var$r.idPayload,
            listCreditNotes: $a508c689470f9212$var$r.id
        }
    },
    transactions: {
        service: "transactions",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$p
    },
    companyProfile: {
        service: "companyProfile",
        methods: {
            get: "get",
            update: "update"
        },
        argMap: {
            get: (e)=>$a508c689470f9212$var$d(e),
            update: $a508c689470f9212$var$r.payload
        }
    },
    comments: {
        service: "comments",
        methods: {
            list: "list",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: {
            list: $a508c689470f9212$var$v,
            create: $a508c689470f9212$var$t.payload,
            update: $a508c689470f9212$var$t.idPayload,
            remove: $a508c689470f9212$var$t.id
        }
    },
    refs: {
        service: "refs",
        methods: {
            resolve: "resolve",
            relations: "relations"
        }
    },
    search: {
        service: "refs",
        methods: {
            workspace: "searchWorkspace"
        }
    },
    attachments: {
        service: "attachments",
        methods: {
            list: "list",
            create: "create",
            remove: "remove"
        },
        argMap: {
            list: $a508c689470f9212$var$v,
            create: $a508c689470f9212$var$t.payload,
            remove: $a508c689470f9212$var$t.id
        }
    },
    watchers: {
        service: "watchers",
        methods: {
            list: "list",
            watch: "watch",
            unwatch: "unwatch"
        },
        argMap: {
            list: $a508c689470f9212$var$v,
            watch: (e)=>[
                    e?.payload ?? e?.data ?? e,
                    {
                        workspaceId: e?.workspaceId ?? e?.options?.workspaceId
                    }
                ],
            unwatch: $a508c689470f9212$var$v
        }
    },
    activityEntries: {
        service: "activityEntries",
        methods: {
            list: "list"
        },
        argMap: {
            list: $a508c689470f9212$var$v
        }
    },
    tags: {
        service: "tags",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: {
            ...$a508c689470f9212$var$n,
            list: $a508c689470f9212$var$v
        }
    },
    bookings: {
        service: "bookings",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            confirm: "confirm"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            confirm: $a508c689470f9212$var$t.id
        }
    },
    availabilityRules: {
        service: "availabilityRules",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$p
    },
    conversations: {
        service: "conversations",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            messages: "listMessages",
            addMessage: "addMessage"
        },
        argMap: {
            ...$a508c689470f9212$var$p,
            messages: (e)=>[
                    e?.conversationId ?? e?.id
                ],
            addMessage: (e)=>[
                    e?.conversationId ?? e?.id,
                    $a508c689470f9212$var$K(e)
                ]
        }
    },
    recurrences: {
        service: "recurrences",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        },
        argMap: $a508c689470f9212$var$p
    },
    docs: {
        service: "docs",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove",
            tree: "tree",
            folders: "folders"
        },
        argMap: {
            ...$a508c689470f9212$var$n,
            tree: $a508c689470f9212$var$t.id,
            folders: ()=>[]
        }
    },
    "mail.setup": {
        service: "mail",
        methods: {
            get: "getSetup",
            link: "setupLink",
            notifyAdmin: "setupNotifyAdmin"
        },
        argMap: {
            get: $a508c689470f9212$var$f,
            link: $a508c689470f9212$var$f,
            notifyAdmin: $a508c689470f9212$var$f
        }
    },
    "mail.accounts": {
        service: "mail",
        methods: {
            list: "listAccounts",
            get: "getAccount",
            update: "updateAccount",
            remove: "disconnectAccount",
            connect: "startConnect",
            reconnect: "reconnect",
            sync: "syncNow",
            simulate: "simulateInbound"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions,
            get: $a508c689470f9212$var$r.id,
            update: $a508c689470f9212$var$r.idPayload,
            remove: $a508c689470f9212$var$r.id,
            connect: (e)=>[
                    e?.provider ?? (typeof e == "string" ? e : void 0),
                    ...$a508c689470f9212$var$d(e)
                ],
            reconnect: $a508c689470f9212$var$r.id,
            sync: $a508c689470f9212$var$r.id,
            simulate: $a508c689470f9212$var$r.idPayload
        }
    },
    "mail.crm": {
        service: "mail",
        methods: {
            timeline: "crmTimeline",
            send: "crmSend"
        },
        argMap: {
            timeline: $a508c689470f9212$var$t.filterOptions,
            send: $a508c689470f9212$var$r.payload
        }
    },
    "mail.drafts": {
        service: "mail",
        methods: {
            create: "createDraft",
            update: "updateDraft",
            remove: "deleteDraft",
            attach: "uploadDraftAttachment"
        },
        argMap: {
            create: $a508c689470f9212$var$r.payload,
            update: $a508c689470f9212$var$r.idPayload,
            remove: $a508c689470f9212$var$r.id,
            attach: (e)=>[
                    e?.id,
                    e?.file,
                    ...$a508c689470f9212$var$d(e)
                ]
        }
    },
    "mail.outbox": {
        service: "mail",
        methods: {
            list: "listOutbox",
            send: "send",
            cancel: "cancelSend"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions,
            send: $a508c689470f9212$var$r.payload,
            cancel: $a508c689470f9212$var$r.id
        }
    },
    "mail.threads": {
        service: "mail",
        methods: {
            list: "listThreads",
            get: "getThread",
            update: "updateThread",
            batch: "batchThreads",
            rsvp: "rsvpThread",
            search: "searchThreads"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions,
            get: $a508c689470f9212$var$r.id,
            update: $a508c689470f9212$var$r.idPayload,
            batch: $a508c689470f9212$var$r.payload,
            rsvp: $a508c689470f9212$var$r.idPayload,
            search: $a508c689470f9212$var$t.filterOptions
        }
    },
    "mail.messages": {
        service: "mail",
        methods: {
            body: "getBody",
            attachment: "attachmentUrl",
            saveAttachment: "saveAttachment",
            resolve: "resolveAddress"
        },
        argMap: {
            body: $a508c689470f9212$var$r.id,
            attachment: (e)=>[
                    e?.id,
                    e?.aid ?? e?.attachmentId,
                    ...$a508c689470f9212$var$d(e)
                ],
            saveAttachment: (e)=>[
                    e?.id,
                    e?.aid ?? e?.attachmentId,
                    ...$a508c689470f9212$var$d(e)
                ],
            resolve: (e)=>[
                    e?.email,
                    ...$a508c689470f9212$var$d(e)
                ]
        }
    },
    "mail.admin": {
        service: "mail",
        methods: {
            list: "adminListAccounts",
            remove: "adminDisconnect",
            audit: "adminAudit"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions,
            remove: $a508c689470f9212$var$r.id,
            audit: $a508c689470f9212$var$t.filterOptions
        }
    },
    "mail.tenant": {
        service: "mail",
        methods: {
            get: "getTenant",
            consent: "tenantConsentUrl",
            test: "tenantTest",
            provision: "tenantProvision"
        },
        argMap: {
            get: $a508c689470f9212$var$f,
            consent: (e)=>[
                    e?.provider ?? (typeof e == "string" ? e : void 0),
                    ...$a508c689470f9212$var$d(e)
                ],
            test: (e)=>[
                    e?.provider ?? (typeof e == "string" ? e : void 0),
                    ...$a508c689470f9212$var$d(e)
                ],
            provision: (e)=>[
                    e?.provider ?? (typeof e == "string" ? e : void 0),
                    {
                        ...e?.dryRun !== void 0 ? {
                            dryRun: e.dryRun
                        } : {}
                    },
                    ...$a508c689470f9212$var$d(e)
                ]
        }
    },
    "mail.shared": {
        service: "mail",
        methods: {
            create: "createShared",
            update: "updateShared"
        },
        argMap: {
            create: $a508c689470f9212$var$r.payload,
            update: $a508c689470f9212$var$r.idPayload
        }
    },
    "mail.serviceDesk": {
        service: "mail",
        methods: {
            reply: "serviceDeskReply"
        },
        argMap: {
            reply: $a508c689470f9212$var$r.payload
        }
    },
    "aiChat.threads": {
        service: "aiChat",
        methods: {
            list: "threads.list",
            get: "threads.get",
            create: "threads.create",
            remove: "threads.remove"
        },
        argMap: {
            list: (e)=>[
                    {
                        includeArchived: e?.includeArchived ?? e?.filter?.includeArchived ?? !1,
                        orgId: e?.orgId ?? e?.filter?.orgId,
                        workspaceId: e?.workspaceId ?? e?.filter?.workspaceId
                    }
                ],
            get: (e)=>[
                    e?.id ?? e?.number ?? e,
                    {
                        orgId: e?.orgId,
                        workspaceId: e?.workspaceId
                    }
                ],
            create: (e)=>[
                    e?.payload ?? e?.data ?? e,
                    {
                        orgId: e?.orgId,
                        workspaceId: e?.workspaceId
                    }
                ],
            remove: $a508c689470f9212$var$t.id
        }
    },
    "aiChat.messages": {
        service: "aiChat",
        methods: {
            list: "messages.list"
        },
        argMap: {
            list: (e)=>[
                    e?.threadId ?? e?.id ?? e?.filter?.threadId,
                    {
                        limit: e?.limit ?? e?.options?.limit,
                        beforeId: e?.beforeId ?? e?.options?.beforeId,
                        orgId: e?.orgId ?? e?.options?.orgId,
                        workspaceId: e?.workspaceId ?? e?.options?.workspaceId
                    }
                ]
        }
    },
    "aiChat.completion": {
        service: "aiChat",
        methods: {
            rpc: "completion"
        },
        argMap: {
            rpc: $a508c689470f9212$var$t.payload
        }
    },
    "aiChat.meetAnalyze": {
        service: "aiChat",
        methods: {
            rpc: "meetAnalyze"
        },
        argMap: {
            rpc: $a508c689470f9212$var$t.payload
        }
    },
    analyzed: {
        service: "analyzed",
        methods: {
            ingest: "ingest",
            ingestPublic: "ingestPublic",
            listSessions: "listSessions",
            getSession: "getSession",
            listEvents: "listEvents",
            listUsers: "listUsers",
            listBugs: "listBugs",
            now: "now",
            weekly: "weekly",
            demographics: "demographics",
            changes: "changes",
            activeUsers: "activeUsers",
            totals: "totals",
            pages: "pages",
            referrers: "referrers",
            campaigns: "campaigns",
            daily: "daily",
            funnel: "funnel"
        },
        argMap: {
            ingest: (e)=>[
                    e
                ],
            ingestPublic: (e)=>[
                    e?.envelope ?? e,
                    e?.signature
                ],
            listSessions: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            getSession: $a508c689470f9212$var$r.id,
            listEvents: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            listUsers: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            listBugs: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            now: (e)=>[
                    e?.filter ?? e ?? {}
                ],
            weekly: (e)=>[
                    e?.filter ?? e ?? {}
                ],
            demographics: (e)=>[
                    e?.filter ?? e ?? {}
                ],
            changes: (e)=>[
                    e?.filter ?? e ?? {}
                ],
            activeUsers: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            totals: (e)=>[
                    e?.filter ?? e ?? {}
                ],
            pages: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            referrers: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            campaigns: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? {}
                ],
            daily: (e)=>[
                    e?.filter ?? e ?? {}
                ],
            funnel: (e)=>[
                    e?.filter ?? e ?? {}
                ]
        }
    },
    growth: {
        service: "growth",
        methods: {
            funnel: "funnel",
            accounts: "accounts",
            activation: "activation"
        },
        argMap: {
            funnel: $a508c689470f9212$var$P,
            accounts: $a508c689470f9212$var$t.filterOptions,
            activation: $a508c689470f9212$var$A
        }
    },
    "growth.funnel": {
        service: "growth",
        methods: {
            list: "funnel",
            get: "funnel"
        },
        argMap: {
            list: $a508c689470f9212$var$P,
            get: $a508c689470f9212$var$P
        }
    },
    "growth.accounts": {
        service: "growth",
        methods: {
            list: "accounts"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions
        }
    },
    "growth.activation": {
        service: "growth",
        methods: {
            get: "activation"
        },
        argMap: {
            get: $a508c689470f9212$var$A
        }
    },
    "docs.documents": {
        service: "docs",
        methods: {
            list: "documents.list",
            get: "documents.get",
            create: "documents.create",
            update: "documents.update"
        },
        argMap: $a508c689470f9212$var$n
    },
    "docs.kbArticles": {
        service: "docs",
        methods: {
            list: "kbArticles.list",
            get: "kbArticles.get",
            create: "kbArticles.create",
            update: "kbArticles.update",
            children: "kbArticles.children"
        },
        argMap: {
            ...$a508c689470f9212$var$n,
            children: $a508c689470f9212$var$t.id
        }
    },
    "docs.notes": {
        service: "docs",
        methods: {
            list: "notes.list",
            get: "notes.get",
            create: "notes.create",
            update: "notes.update"
        },
        argMap: $a508c689470f9212$var$n
    },
    "docs.userDocs": {
        service: "docs",
        methods: {
            list: "userDocs.list",
            get: "userDocs.get",
            create: "userDocs.create",
            update: "userDocs.update"
        },
        argMap: $a508c689470f9212$var$n
    },
    "workspaceProject.chat": {
        service: "workspaceProject",
        methods: {
            list: "chat.listChannels",
            create: "chat.createChannel",
            update: "chat.updateChannel",
            remove: "chat.removeChannel",
            typing: "chat.typing"
        },
        argMap: {
            list: (e)=>[
                    e?.workspaceId
                ],
            create: $a508c689470f9212$var$t.payload,
            update: $a508c689470f9212$var$t.idPayload,
            remove: $a508c689470f9212$var$t.id,
            typing: (e)=>[
                    e?.channelId,
                    {
                        state: e?.state,
                        threadParentId: e?.threadParentId
                    }
                ]
        }
    },
    "workspaceProject.chat.members": {
        service: "workspaceProject",
        methods: {
            list: "chat.listMembers",
            create: "chat.addMember",
            update: "chat.updateMember",
            remove: "chat.removeMember",
            markRead: "chat.markRead",
            mute: "chat.muteChannel"
        },
        argMap: {
            list: (e)=>{
                const s = e?.channelId ?? e?.filter?.channelId;
                return [
                    s,
                    {
                        bulk: !s,
                        workspaceId: e?.workspaceId
                    }
                ];
            },
            create: (e)=>[
                    e?.channelId,
                    e?.payload ?? {
                        user_id: e?.userId,
                        role: e?.role
                    }
                ],
            update: (e)=>[
                    e?.channelId,
                    e?.userId,
                    e?.payload ?? e?.data ?? e
                ],
            remove: (e)=>[
                    e?.channelId,
                    e?.userId
                ],
            markRead: (e)=>[
                    e?.channelId,
                    e?.userId,
                    e?.lastReadAt ?? new Date().toISOString()
                ],
            mute: (e)=>[
                    e?.channelId,
                    e?.userId,
                    e?.muted
                ]
        }
    },
    "workspaceProject.chat.messages": {
        service: "workspaceProject",
        methods: {
            list: "chat.listMessages",
            create: "chat.sendMessage",
            update: "chat.updateMessage",
            remove: "chat.removeMessage",
            react: "chat.toggleReaction",
            purge: "chat.purgeMessages"
        },
        argMap: {
            list: (e)=>{
                const s = e?.channelId ?? e?.filter?.channelId ?? e?.params?.channelId;
                return [
                    s,
                    {
                        single: e?.single,
                        limit: e?.limit,
                        offset: e?.offset,
                        order: e?.order,
                        ...e?.options || {},
                        bulk: !s,
                        workspaceId: e?.workspaceId ?? e?.options?.workspaceId
                    }
                ];
            },
            create: (e)=>[
                    e?.channelId ?? e?.filter?.channelId,
                    e?.payload ?? e?.data ?? (()=>{
                        const { channelId: s, filter: o, options: i, ...c } = e || {};
                        return c;
                    })()
                ],
            update: (e)=>[
                    e?.messageId ?? e?.id,
                    e?.payload ?? e?.data ?? e
                ],
            remove: (e)=>[
                    e?.messageId ?? e?.id
                ],
            react: (e)=>[
                    e?.messageId ?? e?.id,
                    e?.emoji,
                    e?.userId
                ],
            purge: ()=>[]
        }
    },
    "workspaceProject.chat.mentions": {
        service: "workspaceProject",
        methods: {
            list: "chat.listMentions",
            markRead: "chat.markMentionsRead"
        },
        argMap: {
            list: (e)=>[
                    e?.filter ?? e?.params,
                    {
                        single: e?.single,
                        limit: e?.limit,
                        offset: e?.offset,
                        order: e?.order,
                        ...e?.options || {},
                        workspaceId: e?.workspaceId ?? e?.options?.workspaceId
                    }
                ],
            markRead: (e)=>[
                    e?.channelId,
                    e?.callerEmail ?? e?.userId ?? e?.email
                ]
        }
    },
    "workspaceProject.chat.search": {
        service: "workspaceProject",
        methods: {
            rpc: "chat.searchMessages"
        },
        argMap: {
            rpc: (e)=>[
                    e?.q ?? e?.query,
                    e?.callerEmail ?? e?.userId ?? e?.email,
                    e?.workspaceId
                ]
        }
    },
    "workspaceProject.calendar": {
        service: "workspaceProject",
        methods: {
            list: "calendar.listEvents",
            get: "calendar.getEvent",
            create: "calendar.createEvent",
            update: "calendar.updateEvent",
            remove: "calendar.deleteEvent",
            deleteFuture: "calendar.deleteFutureEvents"
        },
        argMap: {
            list: (e)=>[
                    e?.filter ?? e?.params
                ],
            get: $a508c689470f9212$var$t.id,
            create: $a508c689470f9212$var$t.payload,
            update: $a508c689470f9212$var$t.idPayload,
            remove: $a508c689470f9212$var$t.id,
            deleteFuture: (e)=>[
                    e?.seriesId,
                    e?.fromDate,
                    e?.workspaceId
                ]
        }
    },
    "workspaceProject.notifications": {
        service: "workspaceProject",
        methods: {
            list: "notifications.list",
            get: "notifications.unreadCount",
            create: "notifications.create",
            update: "notifications.markRead",
            markAllRead: "notifications.markAllRead",
            close: "notifications.close"
        },
        argMap: {
            list: ()=>[],
            get: ()=>[],
            create: $a508c689470f9212$var$r.payload,
            update: $a508c689470f9212$var$t.id,
            markAllRead: ()=>[],
            close: $a508c689470f9212$var$t.payload
        }
    },
    "workspaceProject.audience": {
        service: "workspaceProject",
        methods: {
            list: "notifications.audience"
        },
        argMap: {
            list: (e)=>$a508c689470f9212$var$d(e)
        }
    },
    "workspaceProject.presence": {
        service: "workspaceProject",
        methods: {
            list: "presence.online",
            update: "presence.heartbeat"
        },
        argMap: {
            list: ()=>[],
            update: $a508c689470f9212$var$t.payload
        }
    },
    "workspaceProject.people": {
        service: "workspaceProject",
        methods: {
            list: "people.list",
            get: "people.get",
            me: "people.me"
        },
        argMap: {
            list: ()=>[],
            get: $a508c689470f9212$var$t.id,
            me: ()=>[]
        }
    },
    "workspaceProject.permissions": {
        service: "workspaceProject",
        methods: {
            list: "permissions.me",
            rpc: "permissions.check"
        },
        argMap: {
            list: ()=>[],
            rpc: (e)=>[
                    e?.action,
                    e?.resource
                ]
        }
    },
    "workspaceProject.search": {
        service: "workspaceProject",
        methods: {
            rpc: "search"
        },
        argMap: {
            rpc: (e)=>[
                    e?.q ?? e?.query,
                    e?.options ?? e
                ]
        }
    },
    "workspaceProject.activity": {
        service: "workspaceProject",
        methods: {
            list: "activity.listNotes",
            create: "activity.addNote",
            scoringConfig: "activity.scoringConfig",
            updateScoringConfig: "activity.updateScoringConfig",
            heatmap: "activity.heatmap",
            listEvents: "activity.listEvents"
        },
        argMap: {
            list: ()=>[],
            create: $a508c689470f9212$var$t.payload,
            scoringConfig: ()=>[],
            updateScoringConfig: $a508c689470f9212$var$t.payload,
            heatmap: (e)=>[
                    e?.filter ?? e?.params ?? e
                ],
            listEvents: (e)=>[
                    e?.filter ?? e?.params ?? e
                ]
        }
    },
    "workspaceProject.activity.scoringConfig": {
        service: "workspaceProject",
        methods: {
            list: "activity.scoringConfig",
            update: "activity.updateScoringConfig"
        },
        argMap: {
            list: ()=>[],
            update: $a508c689470f9212$var$t.payload
        }
    },
    "workspaceProject.standups": {
        service: "workspaceProject",
        methods: {
            list: "standups.list",
            get: "standups.get",
            create: "standups.create",
            update: "standups.update",
            upsert: "standups.upsert"
        },
        argMap: {
            list: (e)=>[
                    e?.filter ?? e?.params,
                    {
                        order: e?.order,
                        limit: e?.limit,
                        ...e?.options || {}
                    }
                ],
            get: $a508c689470f9212$var$t.id,
            create: $a508c689470f9212$var$t.payload,
            update: $a508c689470f9212$var$t.idPayload,
            upsert: $a508c689470f9212$var$t.payload
        }
    },
    "workspaceProject.system": {
        service: "workspaceProject",
        methods: {
            status: "system.status",
            featureFlags: "system.featureFlags"
        },
        argMap: {
            status: ()=>[],
            featureFlags: ()=>[]
        }
    },
    "admin.subscribers": {
        service: "admin",
        methods: {
            list: "getAdminSubscribers"
        },
        argMap: {
            list: (e)=>[
                    {
                        status: e?.status ?? e?.filter?.status,
                        limit: e?.limit ?? e?.options?.limit,
                        offset: e?.offset ?? e?.options?.offset,
                        signal: e?.signal
                    }
                ]
        }
    },
    "workspaceProject.auditLog": {
        service: "workspaceProject",
        methods: {
            list: "auditLog.list"
        },
        argMap: {
            list: $a508c689470f9212$var$t.filterOptions
        }
    },
    "workspaceProject.analyzed": {
        service: "analyzed",
        methods: {
            ingest: "ingest"
        },
        argMap: {
            ingest: (e)=>[
                    e
                ]
        }
    },
    "workspaceProject.analyzedSessions": {
        service: "analyzed",
        methods: {
            list: "listSessions",
            get: "getSession"
        },
        argMap: {
            list: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? e ?? {}
                ],
            get: $a508c689470f9212$var$t.id
        }
    },
    "workspaceProject.analyzedEvents": {
        service: "analyzed",
        methods: {
            list: "listEvents"
        },
        argMap: {
            list: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? e ?? {}
                ]
        }
    },
    "workspaceProject.analyzedUserSummaries": {
        service: "analyzed",
        methods: {
            list: "listUsers"
        },
        argMap: {
            list: (e)=>[
                    e?.filter ?? {},
                    e?.options ?? e ?? {}
                ]
        }
    },
    "workspaceProject.analyzedBugs": {
        service: "analyzed",
        methods: {
            list: "listBugs"
        },
        argMap: {
            list: (e)=>[
                    {
                        projectId: e?.appKey ?? e?.filter?.appKey ?? e?.params?.appKey,
                        since: e?.since ?? e?.filter?.since ?? e?.params?.since
                    },
                    {
                        limit: e?.limit ?? e?.filter?.limit ?? e?.params?.limit ?? 200,
                        offset: e?.offset ?? e?.filter?.offset ?? e?.params?.offset ?? 0
                    }
                ]
        }
    },
    "workspaceProject.announcements": {
        service: "workspaceProject",
        methods: {
            list: "announcements.list",
            get: "announcements.get",
            create: "announcements.create",
            update: "announcements.update",
            remove: "announcements.remove",
            react: "announcements.toggleReaction"
        },
        argMap: {
            ...$a508c689470f9212$var$n,
            react: (e)=>[
                    e?.id ?? e?.number,
                    e?.emoji,
                    e?.reactor
                ]
        }
    },
    "workspaceProject.fileCanvas": {
        service: "workspaceProject",
        methods: {
            list: "fileCanvas.list",
            get: "fileCanvas.get",
            create: "fileCanvas.create",
            update: "fileCanvas.update",
            remove: "fileCanvas.remove"
        },
        argMap: $a508c689470f9212$var$p
    },
    "workspaceProject.records": {
        service: "workspaceProject",
        methods: {
            list: "records.list",
            get: "records.get",
            create: "records.create",
            update: "records.update",
            remove: "records.remove",
            subscribe: "records.subscribe"
        },
        argMap: $a508c689470f9212$var$L
    },
    "workspaceProject.bookmarks": {
        service: "workspaceProject",
        methods: {
            enrich: "bookmarks.enrich"
        },
        argMap: $a508c689470f9212$var$U
    },
    "workspaceProject.userPreferences": {
        service: "workspaceProject",
        methods: {
            get: "userPreferences.get",
            update: "userPreferences.upsert",
            patch: "userPreferences.patch"
        },
        argMap: {
            get: ()=>[],
            update: $a508c689470f9212$var$t.payload,
            patch: (e)=>[
                    e?.patch ?? e?.payload ?? e?.data ?? e
                ]
        }
    },
    "workspaceProject.homeDashboardPrefs": {
        service: "workspaceProject",
        methods: {
            get: "homeDashboardPrefs.get",
            update: "homeDashboardPrefs.upsert"
        },
        argMap: {
            get: (e)=>e?.workspaceId != null ? [
                    {
                        workspaceId: e.workspaceId
                    }
                ] : [],
            update: (e)=>[
                    e?.payload ?? e?.data ?? e,
                    ...e?.workspaceId != null ? [
                        {
                            workspaceId: e.workspaceId
                        }
                    ] : []
                ]
        }
    },
    "workspaceProject.workspaceDashboardDefaults": {
        service: "workspaceProject",
        methods: {
            get: "workspaceDashboardDefaults.get",
            update: "workspaceDashboardDefaults.upsert"
        },
        argMap: {
            get: ()=>[],
            update: $a508c689470f9212$var$t.payload
        }
    },
    "ai.boards": (0, $4QZMS.AI_BOARDS_ENTITY_ROUTE),
    assistants: (0, $g0NMY.ASSISTANTS_ENTITY_ROUTE),
    "workspaceProject.widgetDefs": {
        service: "workspaceProject",
        methods: {
            list: "widgetDefs.list",
            create: "widgetDefs.create",
            update: "widgetDefs.update",
            remove: "widgetDefs.remove"
        },
        argMap: {
            list: (e)=>e?.workspaceId != null ? [
                    {
                        workspaceId: e.workspaceId
                    }
                ] : [],
            create: (e)=>[
                    e?.widget ?? e?.payload ?? e?.data ?? e,
                    ...e?.workspaceId != null ? [
                        {
                            workspaceId: e.workspaceId
                        }
                    ] : []
                ],
            update: (e)=>[
                    e?.id,
                    e?.widget ?? e?.payload ?? e?.data ?? {},
                    ...e?.workspaceId != null ? [
                        {
                            workspaceId: e.workspaceId
                        }
                    ] : []
                ],
            remove: (e)=>[
                    e?.id,
                    ...e?.workspaceId != null ? [
                        {
                            workspaceId: e.workspaceId
                        }
                    ] : []
                ]
        }
    },
    "workspaceProject.userProfiles": {
        service: "workspaceProject",
        methods: {
            list: "userProfiles.list",
            get: "userProfiles.get",
            update: "userProfiles.update"
        },
        argMap: {
            list: ()=>[],
            get: $a508c689470f9212$var$t.id,
            update: $a508c689470f9212$var$t.idPayload
        }
    },
    "workspaceProject.meet.rooms": {
        service: "workspaceProject",
        methods: {
            list: "meet.listRooms",
            get: "meet.getRoom",
            create: "meet.createRoom",
            update: "meet.updateRoom",
            end: "meet.endRoom",
            reopen: "meet.reopenRoom"
        },
        argMap: {
            list: ()=>[],
            get: $a508c689470f9212$var$t.id,
            create: $a508c689470f9212$var$t.payload,
            update: $a508c689470f9212$var$t.idPayload,
            end: $a508c689470f9212$var$t.id,
            reopen: $a508c689470f9212$var$t.id
        }
    },
    "workspaceProject.meet.transcripts": {
        service: "workspaceProject",
        methods: {
            list: "meet.listTranscripts"
        },
        argMap: {
            list: (e)=>[
                    e?.roomId ?? e?.filter?.room_id ?? e
                ]
        }
    },
    "workspaceProject.meet.members": {
        service: "workspaceProject",
        methods: {
            list: "meet.listMembers",
            create: "meet.addMember"
        },
        argMap: {
            list: (e)=>[
                    e?.roomId ?? e?.filter?.room_id ?? e
                ],
            create: (e)=>[
                    e?.roomId ?? e?.filter?.room_id,
                    e?.payload ?? e?.data ?? (()=>{
                        const { roomId: s, filter: o, options: i, ...c } = e || {};
                        return c;
                    })()
                ]
        }
    },
    "workspaceProject.meet.utterances": {
        service: "workspaceProject",
        methods: {
            list: "meet.listUtterances"
        },
        argMap: {
            list: (e)=>[
                    e?.roomId ?? e?.filter?.room_id ?? e
                ]
        }
    },
    "workspaceProject.meet.transcriptView": {
        service: "workspaceProject",
        methods: {
            rpc: "meet.getTranscriptView"
        },
        argMap: {
            rpc: (e)=>[
                    e?.roomId ?? e?.p_room_id ?? e?.params?.p_room_id ?? e?.filter?.room_id ?? e
                ]
        }
    },
    "workspaceProject.meet.analysisAppliedItems": {
        service: "workspaceProject",
        methods: {
            update: "meet.updateAnalysisAppliedItems"
        },
        argMap: {
            update: (e)=>[
                    e?.roomId ?? e?.id ?? e?.filter?.room_id,
                    e?.applied_items ?? e?.appliedItems ?? e?.payload ?? e?.data
                ]
        }
    },
    "workspaceProject.meet.waitingRoom": {
        service: "workspaceProject",
        methods: {
            list: "meet.waitingRoom",
            admit: "meet.admitGuest",
            reject: "meet.rejectGuest"
        },
        argMap: {
            list: ()=>[],
            admit: $a508c689470f9212$var$t.id,
            reject: $a508c689470f9212$var$t.id
        }
    },
    "workspaceProject.meet.token": {
        service: "workspaceProject",
        methods: {
            rpc: "meet.issueToken"
        },
        argMap: {
            rpc: $a508c689470f9212$var$t.payload
        }
    },
    "workspaceProject.meet.mute": {
        service: "workspaceProject",
        methods: {
            mute: "meet.mute"
        },
        argMap: {
            mute: $a508c689470f9212$var$t.payload
        }
    },
    "workspaceProject.realtime.messages": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeMessages"
        },
        argMap: {
            subscribe: (e)=>[
                    {
                        channelId: e?.channelId ?? e?.filter?.channelId
                    }
                ]
        }
    },
    "workspaceProject.realtime.channels": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeChannels"
        },
        argMap: {
            subscribe: (e)=>[
                    e?.filter ?? e ?? {}
                ]
        }
    },
    "workspaceProject.realtime.mentions": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeMentions"
        },
        argMap: {
            subscribe: (e)=>[
                    {
                        userEmail: e?.userEmail ?? e?.filter?.userEmail
                    }
                ]
        }
    },
    "workspaceProject.realtime.notifications": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeNotifications"
        },
        argMap: {
            subscribe: (e)=>[
                    {
                        userEmail: e?.userEmail ?? e?.filter?.userEmail
                    }
                ]
        }
    },
    "workspaceProject.realtime.presence": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribePresence"
        },
        argMap: {
            subscribe: (e)=>[
                    {
                        scope: e?.scope ?? "workspace"
                    }
                ]
        }
    },
    "workspaceProject.realtime.meet": {
        service: "workspaceProject",
        methods: {
            subscribe: "realtime.subscribeMeet"
        },
        argMap: {
            subscribe: (e)=>[
                    {
                        roomId: e?.roomId ?? e?.filter?.roomId,
                        workspaceId: e?.workspaceId ?? e?.filter?.workspaceId,
                        tables: e?.tables ?? e?.filter?.tables
                    }
                ]
        }
    },
    "workspaceProject.storage": {
        service: "workspaceProject",
        methods: {
            signedUrl: "storage.createSignedUrl",
            upload: "storage.upload",
            remove: "storage.remove",
            publicUrl: "storage.publicUrl",
            download: "storage.download"
        },
        argMap: {
            signedUrl: (e)=>[
                    e?.bucket,
                    e?.path,
                    e?.ttl ?? 300
                ],
            upload: (e)=>[
                    e?.bucket,
                    e?.formData ?? e?.payload,
                    e?.options ?? {}
                ],
            remove: (e)=>[
                    e?.bucket,
                    e?.path
                ],
            publicUrl: (e)=>[
                    e?.bucket,
                    e?.path
                ],
            download: (e)=>[
                    e?.bucket,
                    e?.path
                ]
        }
    },
    "workspaceProject.query": {
        service: "workspaceProject",
        methods: {
            rpc: "query"
        },
        argMap: {
            rpc: $a508c689470f9212$var$t.payload
        }
    },
    canvasLayout: {
        service: "canvasLayout",
        methods: {
            get: "getCanvasLayout",
            patch: "patchCanvasLayout",
            subscribe: "subscribeWorkspaceCanvasLayout"
        },
        argMap: {
            get: (e)=>[
                    e?.workspaceId ?? e?.id ?? e
                ],
            patch: (e)=>[
                    e?.workspaceId ?? e?.id,
                    e?.payload ?? (()=>{
                        const { workspaceId: s, id: o, ...i } = e || {};
                        return i;
                    })()
                ],
            subscribe: (e)=>[
                    e?.workspaceId ?? e?.id ?? e
                ]
        }
    },
    project: {
        service: "project",
        methods: {
            list: "listProjects",
            get: "getProject",
            create: "createProject",
            update: "updateProject",
            remove: "removeProject"
        }
    },
    "project.versions": {
        service: "project",
        methods: {
            list: "getProjectVersions",
            get: "getProjectVersion",
            rpc: "restoreProjectVersion"
        },
        argMap: {
            list: (e)=>[
                    e?.projectId ?? e?.params?.projectId ?? e?.filter?.projectId,
                    {
                        branch: e?.branch ?? e?.params?.branch,
                        page: e?.page ?? e?.params?.page,
                        limit: e?.limit ?? e?.params?.limit,
                        fields: e?.fields ?? e?.params?.fields
                    }
                ],
            get: (e)=>[
                    e?.projectId ?? e?.params?.projectId,
                    e?.versionId ?? e?.id ?? e?.params?.versionId
                ],
            rpc: (e)=>[
                    e?.projectId ?? e?.params?.projectId,
                    e?.version ?? e?.versionId ?? e?.params?.version,
                    {
                        message: e?.message ?? e?.params?.message,
                        branch: e?.branch ?? e?.params?.branch,
                        type: e?.type ?? e?.params?.type
                    }
                ]
        }
    },
    "project.branch": {
        service: "branch",
        methods: {
            list: "listBranches",
            get: "getBranch",
            create: "createBranch",
            remove: "deleteBranch"
        }
    },
    "project.pullRequest": {
        service: "pullRequest",
        methods: {
            list: "list",
            get: "get",
            create: "create",
            update: "update",
            remove: "remove"
        }
    },
    "project.collab": {
        service: "collab",
        methods: {
            subscribe: "subscribe"
        }
    },
    "marketplace.listings": {
        service: "marketplace",
        methods: {
            list: "list",
            get: "get"
        }
    },
    file: {
        service: "file",
        methods: {
            list: "list",
            get: "get",
            create: "upload",
            remove: "remove"
        }
    },
    screenshot: {
        service: "screenshot",
        methods: {
            get: "getScreenshotByKey"
        }
    },
    "builds.github": {
        service: "builds",
        methods: {
            state: "getBuildsGitHubState",
            get: "getBuildsGitHubState"
        },
        argMap: {
            state: (e)=>[
                    $a508c689470f9212$var$l(e)
                ],
            get: (e)=>[
                    $a508c689470f9212$var$l(e)
                ]
        }
    },
    "builds.repos": {
        service: "builds",
        methods: {
            list: "listBuildRepos"
        },
        argMap: {
            list: (e)=>[
                    $a508c689470f9212$var$l(e)
                ]
        }
    },
    "builds.imports": {
        service: "builds",
        methods: {
            list: "listBuildImports",
            create: "createBuildImport",
            update: "updateBuildImport",
            remove: "deleteBuildImport"
        },
        argMap: {
            list: (e)=>[
                    $a508c689470f9212$var$l(e)
                ],
            create: (e)=>[
                    $a508c689470f9212$var$l(e),
                    e?.payload ?? e?.data
                ],
            update: (e)=>[
                    $a508c689470f9212$var$l(e),
                    $a508c689470f9212$var$O(e),
                    e?.payload ?? e?.data ?? {}
                ],
            remove: (e)=>[
                    $a508c689470f9212$var$l(e),
                    $a508c689470f9212$var$O(e)
                ]
        }
    },
    "builds.builds": {
        service: "builds",
        methods: {
            list: "listBuilds",
            get: "getBuild",
            create: "triggerBuild",
            logs: "getBuildLogs",
            subscribe: "subscribeWorkspaceBuilds"
        },
        argMap: {
            list: (e)=>[
                    $a508c689470f9212$var$l(e),
                    {
                        limit: e?.limit
                    }
                ],
            get: (e)=>[
                    $a508c689470f9212$var$l(e),
                    e?.id ?? e?.buildId ?? e?.params?.id
                ],
            create: (e)=>[
                    $a508c689470f9212$var$l(e),
                    e?.repoId ?? e?.params?.repoId,
                    e?.payload ?? {}
                ],
            logs: (e)=>[
                    $a508c689470f9212$var$l(e),
                    $a508c689470f9212$var$N(e),
                    {
                        tailBytes: e?.tailBytes ?? e?.params?.tailBytes
                    }
                ],
            subscribe: (e)=>[
                    e
                ]
        }
    },
    "builds.deployments": {
        service: "builds",
        methods: {
            list: "listBuildDeployments",
            create: "deployBuild",
            rollback: "rollbackDeployment",
            scale: "scaleDeployment",
            metrics: "getDeploymentMetrics",
            subscribe: "subscribeWorkspaceBuilds"
        },
        argMap: {
            list: (e)=>[
                    $a508c689470f9212$var$l(e)
                ],
            create: (e)=>[
                    $a508c689470f9212$var$l(e),
                    e?.buildId ?? e?.params?.buildId,
                    e?.payload ?? {}
                ],
            rollback: (e)=>[
                    $a508c689470f9212$var$l(e),
                    $a508c689470f9212$var$j(e)
                ],
            scale: (e)=>[
                    $a508c689470f9212$var$l(e),
                    $a508c689470f9212$var$j(e),
                    e?.payload ?? e?.data ?? {}
                ],
            metrics: (e)=>[
                    $a508c689470f9212$var$l(e),
                    $a508c689470f9212$var$j(e),
                    {
                        interval: e?.interval ?? e?.params?.interval,
                        since: e?.since ?? e?.params?.since,
                        until: e?.until ?? e?.params?.until,
                        limit: e?.limit ?? e?.params?.limit
                    }
                ],
            subscribe: (e)=>[
                    e
                ]
        }
    },
    projectDomains: {
        service: "dns",
        methods: {
            list: "getProjectDomains",
            add: "addProjectCustomDomains",
            create: "addProjectCustomDomains",
            setup: "startProjectCustomDomainSetup",
            poll: "pollProjectCustomDomainStatus",
            remove: "removeProjectCustomDomain",
            check: "checkProjectDomain",
            status: "getProjectCustomDomainStatus",
            instructions: "getProjectDomainInstructions"
        },
        argMap: {
            list: (e)=>[
                    $a508c689470f9212$var$m(e)
                ],
            add: (e)=>[
                    $a508c689470f9212$var$m(e),
                    e?.customDomains ?? e?.domains ?? e?.hostname,
                    e?.options ?? (e?.envKey ? {
                        envKey: e.envKey
                    } : {})
                ],
            create: (e)=>[
                    $a508c689470f9212$var$m(e),
                    e?.customDomains ?? e?.domains ?? e?.hostname,
                    e?.options ?? (e?.envKey ? {
                        envKey: e.envKey
                    } : {})
                ],
            setup: (e)=>[
                    $a508c689470f9212$var$m(e),
                    $a508c689470f9212$var$w(e),
                    e?.options ?? (e?.envKey ? {
                        envKey: e.envKey
                    } : {})
                ],
            poll: (e)=>[
                    $a508c689470f9212$var$m(e),
                    $a508c689470f9212$var$w(e),
                    e?.options ?? {}
                ],
            remove: (e)=>[
                    $a508c689470f9212$var$m(e),
                    $a508c689470f9212$var$w(e)
                ],
            check: (e)=>[
                    $a508c689470f9212$var$m(e),
                    $a508c689470f9212$var$w(e)
                ],
            status: (e)=>[
                    $a508c689470f9212$var$m(e),
                    $a508c689470f9212$var$w(e)
                ],
            instructions: (e)=>[
                    $a508c689470f9212$var$m(e),
                    $a508c689470f9212$var$w(e)
                ]
        }
    },
    orgIntegration: {
        service: "integration",
        methods: {
            list: "listOrgIntegrations",
            upsert: "upsertOrgIntegration",
            remove: "deleteOrgIntegration",
            assignScope: "assignOrgIntegrationScope",
            reorder: "reorderOrgIntegrations",
            kinds: "listOrgIntegrationKinds",
            call: "callOrgIntegrationCapability"
        },
        argMap: {
            list: (e)=>[
                    $a508c689470f9212$var$x(e)
                ],
            upsert: $a508c689470f9212$var$t.payload,
            remove: $a508c689470f9212$var$t.payload,
            assignScope: $a508c689470f9212$var$t.payload,
            reorder: $a508c689470f9212$var$t.payload,
            kinds: ()=>[],
            call: $a508c689470f9212$var$t.payload
        }
    },
    "marketplace.integrations": {
        service: "integration",
        methods: {
            list: "listMarketplaceEntitlements",
            get: "checkMarketplaceEntitlement",
            create: "installMarketplaceIntegration",
            remove: "uninstallMarketplaceIntegration"
        },
        argMap: {
            list: (e)=>{
                const s = $a508c689470f9212$var$E(e);
                return [
                    s.workspaceId,
                    {
                        status: s.status
                    }
                ];
            },
            get: (e)=>[
                    $a508c689470f9212$var$E(e)
                ],
            create: $a508c689470f9212$var$t.payload,
            remove: $a508c689470f9212$var$t.payload
        }
    }
}, $a508c689470f9212$var$l = (e)=>e?.workspaceId ?? e?.params?.workspaceId ?? e?.filter?.workspaceId ?? (typeof e == "string" ? e : void 0), $a508c689470f9212$var$O = (e)=>e?.repoId ?? e?.params?.repoId ?? e?.id ?? e?.params?.id, $a508c689470f9212$var$N = (e)=>e?.buildId ?? e?.params?.buildId ?? e?.id ?? e?.params?.id, $a508c689470f9212$var$j = (e)=>e?.deploymentId ?? e?.params?.deploymentId ?? e?.id ?? e?.params?.id, $a508c689470f9212$var$m = (e)=>e?.projectId ?? e?.params?.projectId ?? e?.filter?.projectId ?? (typeof e == "string" ? e : void 0), $a508c689470f9212$var$w = (e)=>e?.domain ?? e?.hostname ?? e?.params?.domain ?? e?.params?.hostname, $a508c689470f9212$var$x = (e)=>({
        orgId: e?.orgId ?? e?.params?.orgId ?? e?.filter?.orgId,
        scopeType: e?.scopeType ?? e?.params?.scopeType ?? e?.filter?.scopeType,
        scopeId: e?.scopeId ?? e?.params?.scopeId ?? e?.filter?.scopeId,
        includeParents: e?.includeParents ?? e?.params?.includeParents ?? e?.filter?.includeParents
    }), $a508c689470f9212$var$E = (e)=>({
        workspaceId: e?.workspaceId ?? e?.params?.workspaceId ?? e?.filter?.workspaceId,
        kind: e?.kind ?? e?.params?.kind ?? e?.filter?.kind,
        status: e?.status ?? e?.params?.status ?? e?.filter?.status
    }), $a508c689470f9212$var$F = (e, s)=>!e || !s ? null : s.split(".").reduce((o, i)=>o?.[i], e), $a508c689470f9212$export$8afc2bf1b919cbde = (e, s)=>{
    if (typeof e != "string") throw new Error("[registerEntity] path must be a string");
    if (!s?.service || !s?.methods) throw new Error("[registerEntity] route must have { service, methods }");
    $a508c689470f9212$var$I[e] = s;
}, $a508c689470f9212$export$7d7255c09dd853ea = ()=>Object.keys($a508c689470f9212$var$I), $a508c689470f9212$export$18d13f57a667a03d = (e)=>{
    const s = (o, i, c, u)=>{
        const g = $a508c689470f9212$var$I[o];
        if (!g) throw new Error(`[sdk.execute] Unknown entity: '${o}'. Known: ${Object.keys($a508c689470f9212$var$I).join(", ")}`);
        const b = g.methods[i];
        if (!b) throw new Error(`[sdk.execute] Entity '${o}' does not support op '${i}'. Supported ops: ${Object.keys(g.methods).join(", ")}`);
        let y;
        try {
            y = e.getService(g.service);
        } catch (B) {
            throw new Error(`[sdk.execute] Service '${g.service}' for entity '${o}' is not available: ${B.message}`);
        }
        const M = $a508c689470f9212$var$F(y, b);
        if (typeof M != "function") throw new Error(`[sdk.execute] Method '${b}' not found on service '${g.service}' (entity '${o}', op '${i}')`);
        const S = g.argMap?.[i], R = typeof S == "function" ? S(c) : [
            c
        ];
        return i === "subscribe" && typeof u == "function" ? M.call(y, ...R, u) : M.call(y, ...R);
    };
    return s.listEntities = $a508c689470f9212$export$7d7255c09dd853ea, s.getRoute = (o)=>$a508c689470f9212$var$I[o] || null, s;
};
var $a508c689470f9212$export$2e2bcd8739ae039 = $a508c689470f9212$export$18d13f57a667a03d;

});

parcelRegister("41Z4i", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TOKEN_KEYS", () => $2ef6a05489fe2921$export$e8c8aeb3e952a983);
$parcel$export(module.exports, "createCrossAppAuth", () => $2ef6a05489fe2921$export$d1ee6aa85d937b48);

var $dNwK1 = parcelRequire("dNwK1");
const $2ef6a05489fe2921$export$e8c8aeb3e952a983 = [
    "symbols_access_token",
    "symbols_expires_at",
    "symbols_expires_in",
    "symbols_bridge_access_token",
    "symbols_bridge_expires_at"
];
function $2ef6a05489fe2921$export$d1ee6aa85d937b48({ tokenKeys: u = $2ef6a05489fe2921$export$e8c8aeb3e952a983, sessionCookieName: p = "smbls_session", resolvePeerOrigin: f = null, bridgeIframePath: g = "/_session-bridge" } = {}) {
    function a() {
        if (typeof localStorage > "u") return null;
        const e = {};
        let o = !1;
        for (const s of u){
            const t = localStorage.getItem(s);
            t != null && (e[s] = t, o = !0);
        }
        return o ? e : null;
    }
    function h(e) {
        if (!e) return !1;
        const o = Number(e.symbols_expires_at || e.symbols_bridge_expires_at || 0);
        return o ? o > Date.now() : !0;
    }
    function k() {
        return a();
    }
    function w() {
        return i(), !1;
    }
    function S() {
        i();
    }
    function i() {
        (0, $dNwK1.writeCookie)(p, null, 0);
    }
    function x() {
        return new Promise((e)=>{
            if (typeof window > "u" || typeof document > "u") {
                e(!1);
                return;
            }
            const o = a();
            if (h(o)) {
                e(!1);
                return;
            }
            if (typeof f != "function") {
                e(!1);
                return;
            }
            const s = f();
            if (!s) {
                e(!1);
                return;
            }
            if (window.location.origin === s) {
                e(!1);
                return;
            }
            const t = document.createElement("iframe");
            t.style.cssText = "position:absolute;width:0;height:0;border:0;visibility:hidden", t.src = `${s}${g}`;
            let d = !1;
            const c = (n)=>{
                if (!d) {
                    d = !0, window.removeEventListener("message", _);
                    try {
                        t.remove();
                    } catch  {}
                    e(n);
                }
            }, _ = (n)=>{
                if (n.origin !== s || n.source !== t.contentWindow) return;
                const m = n.data?.type;
                if (m === "symbols-session-ready") {
                    try {
                        t.contentWindow?.postMessage({
                            type: "symbols-session-request"
                        }, s);
                    } catch  {}
                    return;
                }
                if (m !== "symbols-session-response") return;
                if (!n.data.ok) {
                    c(!1);
                    return;
                }
                const r = n.data.sdkTokens || {};
                let l = !1;
                const C = [
                    "symbols_access_token",
                    "symbols_expires_at",
                    "symbols_bridge_access_token",
                    "symbols_bridge_expires_at"
                ];
                for (const y of C){
                    const b = r[y];
                    b != null && (localStorage.setItem(y, String(b)), l = !0);
                }
                !r.symbols_access_token && r.symbols_bridge_access_token && (localStorage.setItem("symbols_access_token", String(r.symbols_bridge_access_token)), r.symbols_bridge_expires_at && localStorage.setItem("symbols_expires_at", String(r.symbols_bridge_expires_at)), l = !0), c(l);
            };
            window.addEventListener("message", _), t.addEventListener("load", ()=>{
                try {
                    t.contentWindow?.postMessage({
                        type: "symbols-session-request"
                    }, s);
                } catch  {}
            }), document.body.appendChild(t), setTimeout(()=>c(!1), 4e3);
        });
    }
    function A() {
        typeof window > "u" || i();
    }
    function E() {}
    return {
        TOKEN_KEYS: u,
        collectLocalSession: a,
        collectSdkTokens: k,
        hydrateAuthFromCookie: w,
        hydrateAuthFromIframeBridge: x,
        persistAuthToCookie: S,
        clearAuthCookie: i,
        installAuthSync: A,
        uninstallAuthSync: E
    };
}

});
parcelRegister("dNwK1", function(module, exports) {

$parcel$export(module.exports, "parentDomain", () => $a0b93fb23e49fbe6$export$3b1f1e712ed06a51);
$parcel$export(module.exports, "readCookie", () => $a0b93fb23e49fbe6$export$bead674655ff515d);
$parcel$export(module.exports, "writeCookie", () => $a0b93fb23e49fbe6$export$a673831a9bd037e1);
function $a0b93fb23e49fbe6$export$3b1f1e712ed06a51(n = typeof window < "u" ? window.location.hostname : "") {
    return n ? n === "localhost" || n.endsWith(".localhost") ? ".localhost" : n.endsWith(".symbols.app") ? ".symbols.app" : null : null;
}
function $a0b93fb23e49fbe6$export$bead674655ff515d(n) {
    if (typeof document > "u") return null;
    const o = n + "=";
    for (const e of document.cookie.split(";")){
        const t = e.trim();
        if (t.startsWith(o)) try {
            return decodeURIComponent(t.slice(o.length));
        } catch  {
            return null;
        }
    }
    return null;
}
function $a0b93fb23e49fbe6$export$a673831a9bd037e1(n, o, e) {
    if (typeof document > "u") return;
    const t = $a0b93fb23e49fbe6$export$3b1f1e712ed06a51(window.location.hostname), r = o == null ? "" : encodeURIComponent(String(o)), c = o == null ? 0 : e, i = [
        `${n}=${r}`,
        "path=/",
        `max-age=${c}`,
        "SameSite=Lax"
    ];
    t && i.push(`domain=${t}`), window.location.protocol === "https:" && i.push("Secure"), document.cookie = i.join("; ");
}

});


parcelRegister("5SFNa", function(module, exports) {

$parcel$export(module.exports, "readTierLock", () => $448269e5a3fce1d9$export$8c49de3ee51caa4c);
$parcel$export(module.exports, "isTierLocked", () => $448269e5a3fce1d9$export$81bb0d91d901a4cc);
const $448269e5a3fce1d9$var$r = new Set([
    "capability_locked",
    "environment_locked",
    "branch_mode_locked",
    "tier_locked"
]), $448269e5a3fce1d9$export$8c49de3ee51caa4c = (e)=>{
    if (!e) return null;
    const l = (e.cause && typeof e.cause == "object" ? e.cause : null) || null, n = l?.error || null;
    return !(e.status === 402) && !(n && $448269e5a3fce1d9$var$r.has(n)) ? null : {
        error: n || "tier_locked",
        capability: l?.capability ?? null,
        envKey: l?.envKey ?? null,
        tier: l?.tier ?? null,
        requiredTier: l?.requiredTier ?? null,
        requiredTierName: l?.requiredTierName ?? null,
        message: l?.message || e.message || "This feature needs a higher plan."
    };
}, $448269e5a3fce1d9$export$81bb0d91d901a4cc = (e)=>$448269e5a3fce1d9$export$8c49de3ee51caa4c(e) !== null;
var $448269e5a3fce1d9$export$2e2bcd8739ae039 = $448269e5a3fce1d9$export$8c49de3ee51caa4c;

});


parcelRegister("b1lQC", function(module, exports) {

$parcel$export(module.exports, "hydrateAuthFromIframeBridge", () => $8060bc3374cc3190$export$45cb7059e7c59007);
$parcel$export(module.exports, "clearAuthCookie", () => $8060bc3374cc3190$export$5d31187a0cdf795a);
$parcel$export(module.exports, "collectSdkTokens", () => $8060bc3374cc3190$export$2caf675105ee535);
// Cross-app auth sync (canvas ↔ workspace) — the SDK-token cookie/iframe
// handoff. Lets a user signed in on one Symbols origin (canvas) skip signin
// on a peer origin (workspace / marketplace / preview) by forwarding the SDK
// tokens held in localStorage. Consumed by `shared/functions/sdk.js`
// (hydrateAuthFromCookie + installAuthSync) and the `/_session-bridge` pages
// (collectSdkTokens).
// `@symbo.ls/sdk-supabase-bridge` was DELETED with the Supabase plane
// (2026-07-27) and this implementation ported verbatim into the SDK
// (sdk/src/crossAppAuth.js, exported both from the main entry and the
// `./cross-app-auth` subpath). The old specifier kept resolving ONLY because a
// stale copy was still hoisted into the repo-root node_modules — on a clean
// install it is absent, Parcel fails to resolve it, and the workspace shell
// does not boot at all. This import has been corrected twice (ed3dfd87,
// 2cfc3cc6) and reverted twice; see crossAppAuth.regression.test.js, which
// fails if the dead specifier ever comes back.
// NB: the MAIN entry, not the `./cross-app-auth` subpath the SDK also exports.
// Parcel's default resolver does not honour `exports` subpath maps — it tries to
// load a literal `./cross-app-auth` file and fails the build
// ("Cannot load file './cross-app-auth' from module '@symbo.ls/sdk'"). The main
// entry re-exports createCrossAppAuth (sdk/src/index.js), and prefs.js already
// imports from it the same way.
parcelRequire("S1wNg");
var $41Z4i = parcelRequire("41Z4i");

var $3xVCk = parcelRequire("3xVCk");
// ── Cross-app auth (canvas ↔ workspace cookie + iframe sync) ─────────
// Peer resolution lives in ./functions/sessionBridgePeerOrigin.js — the
// access-only re-ask (./functions/sessionBridgeReacquire.js) frames the same
// peer, so one resolver serves both.
const $8060bc3374cc3190$var$_crossApp = (0, $41Z4i.createCrossAppAuth)({
    resolvePeerOrigin: (0, $3xVCk.sessionBridgePeerOrigin)
});
const $8060bc3374cc3190$export$a299b57594f93420 = (...a)=>$8060bc3374cc3190$var$_crossApp.hydrateAuthFromCookie(...a);
const $8060bc3374cc3190$export$45cb7059e7c59007 = (...a)=>$8060bc3374cc3190$var$_crossApp.hydrateAuthFromIframeBridge(...a);
const $8060bc3374cc3190$export$d5d56450a6fb624 = (...a)=>$8060bc3374cc3190$var$_crossApp.persistAuthToCookie(...a);
const $8060bc3374cc3190$export$5d31187a0cdf795a = (...a)=>$8060bc3374cc3190$var$_crossApp.clearAuthCookie(...a);
const $8060bc3374cc3190$export$6c3ff1d8842f6efd = (...a)=>$8060bc3374cc3190$var$_crossApp.installAuthSync(...a);
const $8060bc3374cc3190$export$332974f1fffb359a = [
    'symbols_access_token',
    'symbols_expires_at',
    'symbols_expires_in',
    'symbols_bridge_access_token',
    'symbols_bridge_expires_at'
];
const $8060bc3374cc3190$export$2caf675105ee535 = ()=>{
    if (typeof localStorage === 'undefined') return null;
    const keys = [
        'symbols_access_token',
        'symbols_expires_at',
        'symbols_expires_in',
        'symbols_bridge_access_token',
        'symbols_bridge_expires_at'
    ];
    const out = {};
    let hasAny = false;
    for (const k of keys){
        const v = localStorage.getItem(k);
        if (v != null) {
            out[k] = v;
            hasAny = true;
        }
    }
    return hasAny ? out : null;
};

});
parcelRegister("3xVCk", function(module, exports) {

$parcel$export(module.exports, "sessionBridgePeerOrigin", () => $295125b7c0495d0b$export$e534ef2940c651a9);
$parcel$export(module.exports, "isSessionBridgeBorrower", () => $295125b7c0495d0b$export$53e9e9dd0e28c84d);
// The origin whose `/_session-bridge` this page frames to borrow a session:
// the workspace shell for a canvas page, the canvas for a shell page, null
// for every other host. Moved out of crossAppAuth.js unchanged so the
// access-only re-ask (sessionBridgeReacquire.js) frames the same peer as the
// cold-boot handoff.
//
// Cookies with domain=.localhost are silently dropped by Chrome, so in dev the
// iframe bridge is the only cross-host path; on *.symbols.app the peer is the
// same-channel shell/canvas host (see sessionBridgePeers.js for the matching
// answer-side allow-list).

var $grPR9 = parcelRequire("grPR9");
const $295125b7c0495d0b$export$e534ef2940c651a9 = ()=>{
    if (typeof window === 'undefined') return null;
    const host = window.location.hostname;
    const isCanvas = host.startsWith('canvas.');
    // (The `system-governance-intranet.` / `governance-intranet.` clauses are
    // gone, review D5: no such app is served, and the bridge allow-list
    // (sessionBridgePeers.js) never answered them.)
    const isWorkspace = host.startsWith('workspace.') || // `us-at.symbols.app` is the retired workspace origin — full removal was
    // decided 2026-08-18. It still resolves today, so this clause must stay:
    // dropping it early breaks the cross-app auth bridge for anyone still on
    // that host. Once the host stops answering, this branch is dead code and
    // can go.
    host === 'us-at.symbols.app';
    if (host.endsWith('.localhost') || host === 'localhost') {
        // Scheme + port MUST come from the live location, not be hardcoded. The
        // portless proxy serves the whole *.localhost:1355 family over HTTPS, so a
        // hardcoded `http://` produced a DIFFERENT origin than the running page —
        // the iframe bridge then pointed at an origin the browser blocks as mixed
        // content and the handoff silently never completed.
        const scheme = window.location.protocol === 'https:' ? 'https:' : 'http:';
        const port = window.location.port ? `:${window.location.port}` : '';
        if (isCanvas) return `${scheme}//workspace.localhost${port}`;
        if (isWorkspace) return `${scheme}//canvas.localhost${port}`;
        return null;
    }
    // Channel-mapped peer origin for prod-style hosts. The standalone canvas
    // hosts (`edit.symbols.app`, `canvas.<tier>.symbols.app`) are deleted
    // (2026-10-23/24, sessionBridgePeers.js), so on *.symbols.app the borrower
    // is the comm host below; the canvas clauses only still match the local
    // canvas dev server (`canvas.localhost`, handled above).
    // The comm host (`<tier>.comm.symbols.app`, commHost.js) borrows from the
    // workspace shell of its own tier — the `comm` label (or the legacy `com`)
    // → `my` — the moment it has no login of its own, so a person signed in on
    // my.symbols.app opens comm.symbols.app signed in. Its own sign-in marks the
    // session 'own' like the shell's, so it is NOT an isSessionBridgeBorrower
    // below (that flag means "never logs in itself").
    const commTwin = /^((?:[a-z0-9-]+\.)*)comm?\.symbols\.app$/.exec(String(host || '').toLowerCase());
    if (commTwin) return `https://${commTwin[1]}my.symbols.app`;
    if (host.endsWith('.symbols.app')) {
        if (isCanvas) return (0, $grPR9.workspaceOrigin)();
        if (isWorkspace) return (0, $grPR9.canvasOrigin)();
        return null;
    }
    return null;
};
const $295125b7c0495d0b$export$53e9e9dd0e28c84d = ()=>{
    if (typeof window === 'undefined' || !window.location) return false;
    const host = String(window.location.hostname || '');
    return host.startsWith('canvas.');
};

});
parcelRegister("grPR9", function(module, exports) {

$parcel$export(module.exports, "currentChannelFromHost", () => $bf9764849a4d349e$export$b63baea4f0f7eb4e);
$parcel$export(module.exports, "canvasOrigin", () => $bf9764849a4d349e$export$37bc00fba23a1100);
$parcel$export(module.exports, "canvasUrl", () => $bf9764849a4d349e$export$8cde1d63b9dbd29e);
$parcel$export(module.exports, "workspaceOrigin", () => $bf9764849a4d349e$export$1709c826e52a7691);
$parcel$export(module.exports, "workspaceUrl", () => $bf9764849a4d349e$export$327b3a5168bd3166);
$parcel$export(module.exports, "isInsideWorkspaceShell", () => $bf9764849a4d349e$export$8a89765f67b61db7);
// Resolve canvas (editor) + workspace (intranet shell) origins for the
// CURRENT channel — single source of truth lives in
// `server/packages/channels/channels.json` via `@symbo.ls/channels`.
// Handles every shape the user can land on:
//
//   shell host        — `<tier>.my.symbols.app`              (channels.shell)
//   preview host      — `<tier>.preview.symbols.app`         (channels.preview)
//   project preview   — `<owner>--<key>.<tier>.preview.symbols.app`
//                       (suffix-match — same tier as bare preview)
//   localhost variants — *.localhost / localhost             (`local` channel)
//
// The standalone canvas hosts (`edit.symbols.app`, `canvas.<tier>.symbols.app`)
// are deleted (2026-10-23/24): the editor IS the shell. Use these instead of
// hardcoding `https://my.symbols.app/…` anywhere a surface needs to deep-link
// into the matching tier's editor or workspace shell.
//
// FA204 / frank trap — every export below used to share a bank of
// module-scope helpers (_hostnameOf/_channelOf/_isLocalHost/_localOrigin/
// _canvasOriginForChannel) plus bare sibling-export calls (canvasUrl ->
// canvasOrigin, workspaceUrl -> workspaceOrigin). Unresolvable once each
// export is individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers). The `@symbo.ls/channels`
// imports (channelShellUrl/channelPreviewUrl/channelNames) are NOT part of
// this trap — cross-file ESM imports resolve fine via frank's globalScope
// fallback; only same-file module-scope locals and bare sibling reads break.
// Each export below now carries its own self-contained inline copy of
// exactly the local helpers it calls.

var $hmkNw = parcelRequire("hmkNw");
const $bf9764849a4d349e$export$b63baea4f0f7eb4e = ()=>{
    function _hostnameOf(url) {
        if (!url) return null;
        try {
            return new URL(url).hostname;
        } catch  {
            return null;
        }
    }
    function _channelOf(host) {
        if (!host) return null;
        const tiers = [];
        for (const name of (0, $hmkNw.channelNames))for (const url of [
            (0, $hmkNw.shellUrl)(name),
            (0, $hmkNw.previewUrl)(name)
        ]){
            const h = _hostnameOf(url);
            if (h) tiers.push({
                name: name,
                h: h
            });
        }
        tiers.sort((a, b)=>b.h.length - a.h.length);
        // Two channels can serve ONE host: `demo` and `production` share the prod
        // preview host (and `demo-dev`/`development` the dev one). First-in-
        // registry-order named `demo` for every prod preview page, so its shell
        // links went to demo.symbols.app. The registry's own collision rule
        // (`channelByApiUrl` — a real plane outranks its demo twin) breaks the tie.
        const pick = (names)=>names.find((n)=>(0, $hmkNw.channelByApiUrl)((0, $hmkNw.resolveChannel)(n).api) === n) || names[0];
        const exact = tiers.filter(({ h: h })=>host === h);
        if (exact.length) return pick(exact.map(({ name: name })=>name));
        const suffix = tiers.filter(({ h: h })=>host.endsWith('.' + h));
        if (suffix.length) {
            const best = suffix[0].h.length;
            return pick(suffix.filter(({ h: h })=>h.length === best).map(({ name: name })=>name));
        }
        return null;
    }
    function _isLocalHost(host) {
        return !!host && (host === 'localhost' || host.endsWith('.localhost'));
    }
    if (typeof window === 'undefined') return null;
    const host = window.location.hostname;
    if (_isLocalHost(host)) return 'local';
    return _channelOf(host);
};
const $bf9764849a4d349e$export$37bc00fba23a1100 = ()=>{
    function _hostnameOf(url) {
        if (!url) return null;
        try {
            return new URL(url).hostname;
        } catch  {
            return null;
        }
    }
    function _channelOf(host) {
        if (!host) return null;
        const tiers = [];
        for (const name of (0, $hmkNw.channelNames))for (const url of [
            (0, $hmkNw.shellUrl)(name),
            (0, $hmkNw.previewUrl)(name)
        ]){
            const h = _hostnameOf(url);
            if (h) tiers.push({
                name: name,
                h: h
            });
        }
        tiers.sort((a, b)=>b.h.length - a.h.length);
        // Two channels can serve ONE host: `demo` and `production` share the prod
        // preview host (and `demo-dev`/`development` the dev one). First-in-
        // registry-order named `demo` for every prod preview page, so its shell
        // links went to demo.symbols.app. The registry's own collision rule
        // (`channelByApiUrl` — a real plane outranks its demo twin) breaks the tie.
        const pick = (names)=>names.find((n)=>(0, $hmkNw.channelByApiUrl)((0, $hmkNw.resolveChannel)(n).api) === n) || names[0];
        const exact = tiers.filter(({ h: h })=>host === h);
        if (exact.length) return pick(exact.map(({ name: name })=>name));
        const suffix = tiers.filter(({ h: h })=>host.endsWith('.' + h));
        if (suffix.length) {
            const best = suffix[0].h.length;
            return pick(suffix.filter(({ h: h })=>h.length === best).map(({ name: name })=>name));
        }
        return null;
    }
    function _isLocalHost(host) {
        return !!host && (host === 'localhost' || host.endsWith('.localhost'));
    }
    function _localOrigin(hostname) {
        if (typeof window === 'undefined') return `http://${hostname}:1355`;
        const port = window.location.port ? `:${window.location.port}` : '';
        return `${window.location.protocol}//${hostname}${port}`;
    }
    if (typeof window === 'undefined') return 'https://my.symbols.app';
    const host = window.location.hostname;
    if (_isLocalHost(host)) {
        if (host === 'workspace.localhost' || host === 'my.localhost') return _localOrigin(host);
        return _localOrigin('workspace.localhost');
    }
    for (const name of (0, $hmkNw.channelNames)){
        if (host === _hostnameOf((0, $hmkNw.shellUrl)(name))) return `${window.location.protocol}//${host}`;
    }
    const channel = _channelOf(host);
    const shell = channel ? (0, $hmkNw.shellUrl)(channel) : null;
    return shell || 'https://my.symbols.app';
};
const $bf9764849a4d349e$export$8cde1d63b9dbd29e = (path = '/')=>{
    // FA204 / frank trap — self-contained inline copy of canvasOrigin (= the
    // channel's workspace shell), see the file header. Kept identical.
    function _canvasOrigin() {
        function _hostnameOf(url) {
            if (!url) return null;
            try {
                return new URL(url).hostname;
            } catch  {
                return null;
            }
        }
        function _channelOf(host) {
            if (!host) return null;
            const tiers = [];
            for (const name of (0, $hmkNw.channelNames))for (const url of [
                (0, $hmkNw.shellUrl)(name),
                (0, $hmkNw.previewUrl)(name)
            ]){
                const h = _hostnameOf(url);
                if (h) tiers.push({
                    name: name,
                    h: h
                });
            }
            tiers.sort((a, b)=>b.h.length - a.h.length);
            // Two channels can serve ONE host: `demo` and `production` share the prod
            // preview host (and `demo-dev`/`development` the dev one). First-in-
            // registry-order named `demo` for every prod preview page, so its shell
            // links went to demo.symbols.app. The registry's own collision rule
            // (`channelByApiUrl` — a real plane outranks its demo twin) breaks the tie.
            const pick = (names)=>names.find((n)=>(0, $hmkNw.channelByApiUrl)((0, $hmkNw.resolveChannel)(n).api) === n) || names[0];
            const exact = tiers.filter(({ h: h })=>host === h);
            if (exact.length) return pick(exact.map(({ name: name })=>name));
            const suffix = tiers.filter(({ h: h })=>host.endsWith('.' + h));
            if (suffix.length) {
                const best = suffix[0].h.length;
                return pick(suffix.filter(({ h: h })=>h.length === best).map(({ name: name })=>name));
            }
            return null;
        }
        function _isLocalHost(host) {
            return !!host && (host === 'localhost' || host.endsWith('.localhost'));
        }
        function _localOrigin(hostname) {
            if (typeof window === 'undefined') return `http://${hostname}:1355`;
            const port = window.location.port ? `:${window.location.port}` : '';
            return `${window.location.protocol}//${hostname}${port}`;
        }
        if (typeof window === 'undefined') return 'https://my.symbols.app';
        const host = window.location.hostname;
        if (_isLocalHost(host)) {
            if (host === 'workspace.localhost' || host === 'my.localhost') return _localOrigin(host);
            return _localOrigin('workspace.localhost');
        }
        for (const name of (0, $hmkNw.channelNames)){
            if (host === _hostnameOf((0, $hmkNw.shellUrl)(name))) return `${window.location.protocol}//${host}`;
        }
        const channel = _channelOf(host);
        const shell = channel ? (0, $hmkNw.shellUrl)(channel) : null;
        return shell || 'https://my.symbols.app';
    }
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${_canvasOrigin()}${p}`;
};
const $bf9764849a4d349e$export$1709c826e52a7691 = ()=>{
    function _hostnameOf(url) {
        if (!url) return null;
        try {
            return new URL(url).hostname;
        } catch  {
            return null;
        }
    }
    function _channelOf(host) {
        if (!host) return null;
        const tiers = [];
        for (const name of (0, $hmkNw.channelNames))for (const url of [
            (0, $hmkNw.shellUrl)(name),
            (0, $hmkNw.previewUrl)(name)
        ]){
            const h = _hostnameOf(url);
            if (h) tiers.push({
                name: name,
                h: h
            });
        }
        tiers.sort((a, b)=>b.h.length - a.h.length);
        // Two channels can serve ONE host: `demo` and `production` share the prod
        // preview host (and `demo-dev`/`development` the dev one). First-in-
        // registry-order named `demo` for every prod preview page, so its shell
        // links went to demo.symbols.app. The registry's own collision rule
        // (`channelByApiUrl` — a real plane outranks its demo twin) breaks the tie.
        const pick = (names)=>names.find((n)=>(0, $hmkNw.channelByApiUrl)((0, $hmkNw.resolveChannel)(n).api) === n) || names[0];
        const exact = tiers.filter(({ h: h })=>host === h);
        if (exact.length) return pick(exact.map(({ name: name })=>name));
        const suffix = tiers.filter(({ h: h })=>host.endsWith('.' + h));
        if (suffix.length) {
            const best = suffix[0].h.length;
            return pick(suffix.filter(({ h: h })=>h.length === best).map(({ name: name })=>name));
        }
        return null;
    }
    function _isLocalHost(host) {
        return !!host && (host === 'localhost' || host.endsWith('.localhost'));
    }
    function _localOrigin(hostname) {
        if (typeof window === 'undefined') return `http://${hostname}:1355`;
        const port = window.location.port ? `:${window.location.port}` : '';
        return `${window.location.protocol}//${hostname}${port}`;
    }
    if (typeof window === 'undefined') return 'https://my.symbols.app';
    const host = window.location.hostname;
    if (_isLocalHost(host)) {
        // The local dev shell actually runs on `workspace.localhost`.
        // `my.localhost` is only the channels registry's NOMINAL local shell host
        // and normally has no app registered against it, so returning it hardcoded
        // sent every deep-link into the shell — including the post-create redirect
        // after "New project" — to a portless "No app registered for my.localhost"
        // 404. `isInsideWorkspaceShell` below already treats BOTH names as the
        // shell, which is what made the mismatch invisible.
        if (host === 'workspace.localhost' || host === 'my.localhost') return _localOrigin(host);
        return _localOrigin('workspace.localhost');
    }
    // Already on the shell host — keep it (preserves protocol + port).
    for (const name of (0, $hmkNw.channelNames)){
        if (host === _hostnameOf((0, $hmkNw.shellUrl)(name))) return `${window.location.protocol}//${host}`;
    }
    const channel = _channelOf(host);
    const shell = channel ? (0, $hmkNw.shellUrl)(channel) : null;
    return shell || 'https://my.symbols.app';
};
const $bf9764849a4d349e$export$327b3a5168bd3166 = (path = '/')=>{
    // FA204 / frank trap — self-contained inline copy of workspaceOrigin, see
    // the file header. Kept identical to the export above.
    function _workspaceOrigin() {
        function _hostnameOf(url) {
            if (!url) return null;
            try {
                return new URL(url).hostname;
            } catch  {
                return null;
            }
        }
        function _channelOf(host) {
            if (!host) return null;
            const tiers = [];
            for (const name of (0, $hmkNw.channelNames))for (const url of [
                (0, $hmkNw.shellUrl)(name),
                (0, $hmkNw.previewUrl)(name)
            ]){
                const h = _hostnameOf(url);
                if (h) tiers.push({
                    name: name,
                    h: h
                });
            }
            tiers.sort((a, b)=>b.h.length - a.h.length);
            // Two channels can serve ONE host: `demo` and `production` share the prod
            // preview host (and `demo-dev`/`development` the dev one). First-in-
            // registry-order named `demo` for every prod preview page, so its shell
            // links went to demo.symbols.app. The registry's own collision rule
            // (`channelByApiUrl` — a real plane outranks its demo twin) breaks the tie.
            const pick = (names)=>names.find((n)=>(0, $hmkNw.channelByApiUrl)((0, $hmkNw.resolveChannel)(n).api) === n) || names[0];
            const exact = tiers.filter(({ h: h })=>host === h);
            if (exact.length) return pick(exact.map(({ name: name })=>name));
            const suffix = tiers.filter(({ h: h })=>host.endsWith('.' + h));
            if (suffix.length) {
                const best = suffix[0].h.length;
                return pick(suffix.filter(({ h: h })=>h.length === best).map(({ name: name })=>name));
            }
            return null;
        }
        function _isLocalHost(host) {
            return !!host && (host === 'localhost' || host.endsWith('.localhost'));
        }
        function _localOrigin(hostname) {
            if (typeof window === 'undefined') return `http://${hostname}:1355`;
            const port = window.location.port ? `:${window.location.port}` : '';
            return `${window.location.protocol}//${hostname}${port}`;
        }
        if (typeof window === 'undefined') return 'https://my.symbols.app';
        const host = window.location.hostname;
        if (_isLocalHost(host)) {
            if (host === 'workspace.localhost' || host === 'my.localhost') return _localOrigin(host);
            return _localOrigin('workspace.localhost');
        }
        for (const name of (0, $hmkNw.channelNames)){
            if (host === _hostnameOf((0, $hmkNw.shellUrl)(name))) return `${window.location.protocol}//${host}`;
        }
        const channel = _channelOf(host);
        const shell = channel ? (0, $hmkNw.shellUrl)(channel) : null;
        return shell || 'https://my.symbols.app';
    }
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${_workspaceOrigin()}${p}`;
};
const $bf9764849a4d349e$export$8a89765f67b61db7 = ()=>{
    function _hostnameOf(url) {
        if (!url) return null;
        try {
            return new URL(url).hostname;
        } catch  {
            return null;
        }
    }
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    if (host === 'workspace.localhost' || host === 'my.localhost') return true;
    for (const name of (0, $hmkNw.channelNames)){
        if (host === _hostnameOf((0, $hmkNw.shellUrl)(name))) return true;
    }
    return false;
};

});



parcelRegister("kkyxm", function(module, exports) {

$parcel$export(module.exports, "reacquireBridgeSession", () => $ecd0773ed15adeaf$export$6971a140a94fa1ca);
// Ask the peer origin's `/_session-bridge` for its ACCESS token and adopt it
// as this origin's access-only session. Resolves `{ access_token, expires_at }`
// (expires_at in epoch ms, or null) or null.
//
// The bridge hands over the access token only (sessionBridgeTokens.js). The
// origin that owns the login keeps its refresh token and is the only one that
// refreshes; a peer origin re-asks here instead:
//   - at cold boot, when it has no fresh session (`ifStale: true`) — an origin
//     that holds its OWN refresh token never borrows here: it refreshes itself;
//   - when its access token runs out (the SDK session reacquirer —
//     TokenManager.setSessionReacquirer, wired in sdkClient.js — or the
//     renewal timer in sessionBridgeRenewal.js for an SDK without it);
//   - after the server REJECTED its token, once, before /login (bootResolve).
//     There `rejectedToken` is the token the server just refused: a reply with
//     that same token is no session, whatever its local expiry says.
//
// Adoption writes the access token + expiry and DROPS any refresh token this
// origin held — a session borrowed from a peer must never be refreshed here
// (a copied single-use refresh token is the sign-out this fixes). Stale
// `symbols_bridge_*` mirrors and `symbols_expires_in` go with it.
//
// Never sends anything but `{ type: 'symbols-session-request' }`, and only to
// the exact peer origin; replies from any other origin are ignored.
//
// FA204 / frank trap — helpers stay inline in the export; the peer resolver
// is a cross-file import.

var $3xVCk = parcelRequire("3xVCk");
const $ecd0773ed15adeaf$export$6971a140a94fa1ca = ({ ifStale: ifStale = false, rejectedToken: rejectedToken = null, timeoutMs: timeoutMs = 4000, bridgePath: bridgePath = '/_session-bridge', onNoSession: // Called ONLY when the peer answers an explicit ok:false ("no session
// here") — never on a timeout, an error or an unusable reply, which all
// resolve null too. sdkClient restores a refresh token as this origin's own
// login on this verdict alone (review D1, live on canvas.dev 2026-10-11).
onNoSession = null } = {})=>new Promise((resolve)=>{
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            resolve(null);
            return;
        }
        let storage = null;
        try {
            storage = window.localStorage;
        } catch  {
            storage = null;
        }
        if (!storage) {
            resolve(null);
            return;
        }
        if (ifStale) {
            if (storage.getItem('symbols_refresh_token')) {
                resolve(null);
                return;
            }
            const access = storage.getItem('symbols_access_token');
            const exp = Number(storage.getItem('symbols_expires_at'));
            if (access && (!(exp > 0) || exp > Date.now())) {
                resolve(null);
                return;
            }
        }
        const origin = (0, $3xVCk.sessionBridgePeerOrigin)();
        if (!origin || origin === window.location.origin) {
            resolve(null);
            return;
        }
        const iframe = document.createElement('iframe');
        iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
        iframe.src = `${origin}${bridgePath}`;
        let settled = false;
        let timer = null;
        const ask = ()=>{
            try {
                iframe.contentWindow?.postMessage({
                    type: 'symbols-session-request'
                }, origin);
            } catch  {
            /* frame gone — the timeout settles */ }
        };
        const done = (value)=>{
            if (settled) return;
            settled = true;
            if (timer) clearTimeout(timer);
            window.removeEventListener('message', onMessage);
            try {
                iframe.remove();
            } catch  {
            /* already detached */ }
            resolve(value);
        };
        const adopt = (tokens)=>{
            const access = tokens?.symbols_access_token || tokens?.symbols_bridge_access_token;
            const rawExp = Number(tokens?.symbols_expires_at || tokens?.symbols_bridge_expires_at);
            const expiresAt = rawExp > 0 ? rawExp : null;
            if (!access || typeof access !== 'string') return null;
            if (expiresAt && expiresAt <= Date.now()) return null;
            if (rejectedToken && access === rejectedToken) return null;
            try {
                storage.setItem('symbols_access_token', access);
                if (expiresAt) storage.setItem('symbols_expires_at', String(expiresAt));
                else storage.removeItem('symbols_expires_at');
                for (const k of [
                    'symbols_refresh_token',
                    'symbols_expires_in',
                    'symbols_bridge_access_token',
                    'symbols_bridge_expires_at'
                ])storage.removeItem(k);
                // Marks this origin's session as ADOPTED from the bridge. Only such a
                // session gets the SDK reacquirer and the boot gate's one re-ask
                // (review M2): an origin that owns its login never borrows.
                storage.setItem('symbols_session_source', 'bridge');
            } catch  {
                return null;
            }
            return {
                access_token: access,
                expires_at: expiresAt
            };
        };
        // Only THIS request's bridge iframe may answer: the exact peer origin AND
        // the iframe's own window. Any other window of the peer origin (an
        // opener, a popup, user code on that origin) could otherwise post a
        // forged response mid-ask and make this origin adopt its token
        // (review M1, 2026-10-09).
        const onMessage = (ev)=>{
            if (ev.origin !== origin || ev.source !== iframe.contentWindow) return;
            const type = ev.data?.type;
            if (type === 'symbols-session-ready') {
                ask();
                return;
            }
            if (type !== 'symbols-session-response') return;
            if (ev.data?.ok) {
                done(adopt(ev.data.sdkTokens));
                return;
            }
            if (typeof onNoSession === 'function') try {
                onNoSession();
            } catch  {
            /* the caller's verdict hook must not keep the ask open */ }
            done(null);
        };
        window.addEventListener('message', onMessage);
        iframe.addEventListener('load', ask);
        timer = setTimeout(()=>done(null), timeoutMs);
        try {
            document.body.appendChild(iframe);
        } catch  {
            done(null);
        }
    });

});

parcelRegister("5Wuyg", function(module, exports) {

$parcel$export(module.exports, "installBridgeSessionRenewal", () => $453a11760a75f01e$export$ad258748e869e3b8);
// Keep an ACCESS-ONLY session alive on an SDK that has no session reacquirer.
//
// The bridge hands a peer origin the access token only (sessionBridgeTokens.js).
// The SDK hook that makes the peer re-ask on expiry —
// TokenManager.setSessionReacquirer, SDK branch
// fix/token-manager-session-reacquirer — ships with the next SDK release. An
// SDK without it CLEARS an expired session that has no refresh token
// (TokenManager.ensureValidToken), which would sign the peer out once per
// access-token lifetime: the very symptom this fix removes.
//
// So, on such an SDK only, this re-asks the bridge `leadMs` before the access
// token expires (the TokenManager treats a token as expired 60 s early, so the
// lead is larger than that; the owner's bridge rotates its own token when less
// than 5 min remain, so the answer is a fresh token) and hands the new token to
// the TokenManager through
// its public `setTokens` — the call magic-callback.js already makes. It
// re-schedules after every renewal, retries every `retryMs` while the old token
// still lives, and re-checks when the tab becomes visible again (timers in a
// hidden tab are throttled).
//
// It does nothing when:
//   - the SDK has the reacquirer hook (the SDK owns the re-ask then);
//   - the session owns a refresh token (the owner refreshes itself);
//   - there is no session at all.
//
// Returns `{ stop, renewNow }`, or null when nothing was installed.
//
// FA204 / frank trap — helpers stay inline in the export.

var $kkyxm = parcelRequire("kkyxm");
const $453a11760a75f01e$export$ad258748e869e3b8 = (sdk, opts = {})=>{
    const tm = sdk?._tokenManager;
    if (!tm || typeof tm.setTokens !== 'function' || typeof tm.getTokenStatus !== 'function') return null;
    if (typeof tm.setSessionReacquirer === 'function') return null;
    const leadMs = opts.leadMs ?? 120000;
    const retryMs = opts.retryMs ?? 30000;
    const reacquire = opts.reacquire || (()=>(0, $kkyxm.reacquireBridgeSession)());
    let timer = null;
    let stopped = false;
    let inFlight = null;
    const isPeerSession = ()=>tm.hasTokens() && !tm.hasRefreshToken();
    const expiresAt = ()=>tm.getTokenStatus()?.expiresAt || null;
    const clear = ()=>{
        if (timer) clearTimeout(timer);
        timer = null;
    };
    const schedule = (delay)=>{
        clear();
        if (stopped || !isPeerSession()) return;
        const exp = expiresAt();
        if (!exp) return;
        const wait = delay ?? Math.max(0, exp - leadMs - Date.now());
        timer = setTimeout(()=>{
            timer = null;
            renewNow();
        }, wait);
    };
    const renewNow = ()=>{
        if (inFlight) return inFlight;
        inFlight = (async ()=>{
            if (stopped || !isPeerSession()) return false;
            let got = null;
            try {
                got = await reacquire();
            } catch  {
                got = null;
            }
            if (stopped) return false;
            if (got?.access_token && isPeerSession()) {
                const expiresIn = got.expires_at ? Math.max(1, Math.floor((got.expires_at - Date.now()) / 1000)) : undefined;
                tm.setTokens({
                    access_token: got.access_token,
                    expires_in: expiresIn,
                    token_type: 'Bearer'
                });
                // The owner may hand back a token that is no newer (it had not
                // rotated yet): retry later instead of re-asking at delay 0.
                const exp = expiresAt();
                if (exp && exp - Date.now() <= leadMs) {
                    if (exp - Date.now() > retryMs) schedule(retryMs);
                } else schedule();
                return true;
            }
            const exp = expiresAt();
            if (exp && exp - Date.now() > retryMs) schedule(retryMs);
            return false;
        })().finally(()=>{
            inFlight = null;
        });
        return inFlight;
    };
    const onVisible = ()=>{
        if (typeof document !== 'undefined' && document.visibilityState === 'visible') schedule();
    };
    try {
        document.addEventListener('visibilitychange', onVisible);
    } catch  {
    /* no document (SSR) */ }
    schedule();
    return {
        stop: ()=>{
            stopped = true;
            clear();
            try {
                document.removeEventListener('visibilitychange', onVisible);
            } catch  {
            /* no document */ }
        },
        renewNow: renewNow
    };
};

});

parcelRegister("29wU0", function(module, exports) {

$parcel$export(module.exports, "workspaceApiBase", () => $1915f1bc922bc90a$export$703338d600e57242);
$parcel$export(module.exports, "deploymentChannel", () => $1915f1bc922bc90a$export$ea389a3d21bc440f);
// Single source of truth for the workspace API base URL.
//
// Wraps `@symbo.ls/channels` — the canonical platform-wide channel
// registry — so every consumer that hits `/workspace/*` (SDK init in
// sdk.js, coreHeaders.js, the
// workspace-project SDK adapter in envs.js) resolves to the same URL
// derived from a single channel name. Channels (`local`, `next`,
// `staging`, `upcoming`, `production`, ...) are defined in
// `server/packages/channels/channels.json`.
//
// Hostname → channel autodetection is computed by walking the channel
// registry's shell hostnames at runtime — there's no per-host map in
// this file. If a new channel adds a `shell` URL to channels.json,
// this resolver auto-recognises it.
//
// Local dev: the `local` channel's shell is `http://my.localhost:1355`,
// so reaching the workspace via that host (the canonical portless URL)
// autodetects the `local` channel and points at `http://localhost:8080`.
// Hitting raw `localhost:<parcel-port>` falls through to the registry's
// `defaultChannel`. Either case is overridable per-tab with
// `localStorage.symbols_api_channel = '<channel>'`.
//
// Precedence (first non-null wins):
//   1. `?channel=<known-channel>` on local hosts — per-navigation override.
//   2. `SYMBOLS_API_CHANNEL` build-time env pin — local hosts only; the dev
//      launcher (scripts/start.js) defaults it to `development`, so plain
//      `bun start` talks to dev.api. `SYMBOLS_API_CHANNEL=local bun start`
//      opts into the local server.
//   3. `window.__SYMBOLS_ENV.WORKSPACE_API_URL`  — explicit URL (LOCAL hosts only),
//      escape hatch for ngrok / mirrors / staging proxies.
//   4. `window.__SYMBOLS_ENV.NODE_ENV`          — channel name override.
//   5. `localStorage.symbols_workspace_api`     — explicit URL (LOCAL hosts only).
//   6. `localStorage.symbols_api_channel`       — channel name (LOCAL hosts only).
//   7. Hostname autodetect (channel registry walk).
//   8. `apiUrl()` from `@symbo.ls/channels`     — registry's own
//      resolution (NODE_ENV → defaultChannel).
//
// URL override — LOCAL DEV HOSTS ONLY (localhost / *.localhost):
//   ?apiUrl=http://localhost:8080  → use a local API for this page load
// It is never persisted, never accepts a remote API, and is ignored on every
// other host: a link must never choose where the bearer token goes (P0,
// 2026-10-08 — `?apiUrl=` used to be honoured and persisted on every host but
// my.symbols.app). Any override an older build persisted is cleared off a
// local host.

var $hmkNw = parcelRequire("hmkNw");
function $1915f1bc922bc90a$export$703338d600e57242() {
    if (typeof window === 'undefined') return (0, $hmkNw.apiUrl)();
    // Build-time NODE_ENV — Parcel inlines `process.env.NODE_ENV` as a
    // literal string at build time when it's accessed directly (no
    // `typeof process` guard, no destructuring). The `try`/`catch` is only
    // there for the rare bundler that doesn't do the substitution — at
    // runtime in the browser `process` is undefined and the access would
    // throw. This is the authoritative env for hostname-less surfaces like
    // raw `localhost`.
    let BUILD_ENV = null;
    try {
        BUILD_ENV = "development";
    } catch (_) {
    /* no process — leave null */ }
    // Build-time channel pin — the dev launcher (scripts/start.js) exports
    // SYMBOLS_API_CHANNEL (`development` by default, so the team's plain
    // `bun start` talks to dev.api; `SYMBOLS_API_CHANNEL=local bun start`
    // opts into the local server). Parcel inlines it as a literal exactly
    // like NODE_ENV above. The pin lives as long as that dev-server process
    // — every tab and reload of the run keeps it, a restart without the
    // variable drops it — which is why it is exempt from the stale-pin
    // guard below: unlike a localStorage / __SYMBOLS_ENV remote pin it
    // cannot outlive the intent that set it (persisted remote pins could,
    // and that was the dev.api "Failed to fetch" bug). Consulted on LOCAL
    // hosts only, so a deployed artifact accidentally built with the
    // variable set keeps resolving by hostname.
    let BUILD_CHANNEL = null;
    try {
        BUILD_CHANNEL = null;
    } catch (_) {
    /* no process — leave null */ }
    const hostnameOf = (url)=>{
        if (!url) return null;
        try {
            return new URL(url).hostname;
        } catch  {
            return null;
        }
    };
    // Local-dev origins: `localhost` and every `*.localhost` portless sub-app
    // host (my.localhost, workspace.localhost, canvas.localhost,
    // api.localhost, …). On such an origin the `*.localhost → local`
    // autodetect is authoritative; a stale REMOTE pin (an old `?apiUrl=`
    // capture, or symbols_workspace_api / symbols_api_channel left pointing
    // at a non-local tier) must NOT strand the single SDK instance on an
    // unreachable API — that is the dev.api "Failed to fetch" bug. A pin
    // naming a LOCAL host (localhost:8080, the api.localhost:1355 h2 alias)
    // is still honored.
    const isLocalHostname = (host)=>host === 'localhost' || typeof host === 'string' && host.endsWith('.localhost');
    const isLocalUrl = (url)=>{
        const h = hostnameOf(url);
        return h ? isLocalHostname(h) : false;
    };
    // Autodetect channel from current hostname by walking the channel
    // registry. Three-pass:
    //   1. Exact hostname match against each channel's shell URL hostname
    //      (covers `dev.my.symbols.app`, `next.my.symbols.app`, etc.).
    //   2. Suffix match against each channel's shell + preview hostname.
    //      Covers wildcard project previews like
    //      `<owner>--<key>.dev.preview.symbols.app` and any other
    //      sub-subdomain that lives under a registered channel host —
    //      without this, project previews fall through to defaultChannel
    //      = production and call `next.api.symbols.app` instead of the
    //      tier-matching API.
    //   3. If still no match, parse the leading subdomain label and check
    //      if it's a known channel name (covers canvas/workspace shell
    //      variants like `dev.canvas.symbols.app` that aren't in
    //      channels.json's `shell` field).
    //
    // `dev` is aliased to `development` because that's what the channel is
    // named in the registry — the only label-renaming compromise; every
    // other channel uses the same name in hostname and registry.
    const hostToChannel = (host)=>{
        if (!host) return null;
        // PR-preview surfaces (`<id>.pr.my.symbols.app`, `<id>.pr.api.symbols.app`)
        // are ephemeral and not registry channels; without this they suffix-match
        // the production shell host `my.symbols.app` (Pass 2 below) and wrongly call
        // the prod API. Point them at the development tier (dev.api.symbols.app).
        if (/\.pr\.[a-z]+\.symbols\.app$/i.test(host)) return 'development';
        // The comm host (`comm.symbols.app`, `<tier>.comm.symbols.app` — commHost.js)
        // serves the SAME bucket as the workspace host of its tier, so it talks to
        // that tier's API: read it as its `my` twin and let the walk below match.
        // Bare `comm.symbols.app` matched nothing and failed closed. The label rule
        // is restated here (FA204 — this function is self-contained).
        const commTwin = /^((?:[a-z0-9-]+\.)*)comm?\.symbols\.app$/i.exec(host);
        if (commTwin) host = `${commTwin[1]}my.symbols.app`;
        // The portless dev proxy serves EVERY `*.localhost` sub-app host on :1355
        // (my.localhost, workspace.localhost, canvas.localhost, preview.localhost, …) —
        // all local dev, all api → http://localhost:8080. Only `my.localhost` matched
        // the shell-host walk below (it IS the local channel's shell); the sibling
        // sub-app hosts fell through to the build's NODE_ENV / defaultChannel and hit
        // the wrong (dev/prod) API — Failed-to-fetch when that tier isn't reachable.
        // Route any local-dev host (bare `localhost` on a direct Parcel port, e.g.
        // `:4506`, OR any `*.localhost` portless sub-app host) to the local channel.
        //
        // Bug fixed 2026-08-15: this used to be `host.endsWith('.localhost')`,
        // which is false for bare `localhost` (`'localhost'.endsWith('.localhost')
        // === false` — no leading label). A bare `http://localhost:4506` tab fell
        // through every pass below and landed on the BUILD_ENV / defaultChannel
        // fallback (`dev.api.symbols.app`), while `:1355` (which routes through
        // `my.localhost`) correctly resolved to `local`. Measured: `:1355` sent 14
        // calls to `localhost:8080` and 0 to `dev.api`; `:4506` sent 0 to
        // `localhost:8080` (all silently went remote instead). This is what
        // produced a convincing FAKE auth bug — a `:4506` tab redirected to
        // `/login` (its SDK was pointed at a server it was never signed into)
        // while a `:1355` tab of the same session stayed signed in.
        //
        // `isLocalHostname` (above) already covered bare `localhost` correctly —
        // it just wasn't consulted here, only for gating whether a STORED pin is
        // honored (the `onLocal`/`ok()` guard below). Reusing it here is the fix:
        // the two local-host definitions in this file can never drift apart again.
        if (isLocalHostname(host) && (0, $hmkNw.isKnownChannel)('local')) return 'local';
        // Build a longest-host-first list of (channel, host) tuples covering
        // both shell + preview surfaces, so specific hosts beat generic ones
        // when both could match.
        const tiers = [];
        for (const name of (0, $hmkNw.channelNames))for (const url of [
            (0, $hmkNw.shellUrl)(name),
            (0, $hmkNw.previewUrl)(name)
        ]){
            const h = hostnameOf(url);
            if (h) tiers.push({
                name: name,
                h: h
            });
        }
        tiers.sort((a, b)=>b.h.length - a.h.length);
        // Pass 1: exact match (e.g. `dev.my.symbols.app`).
        for (const { name: name, h: h } of tiers){
            if (host === h) return name;
        }
        // Pass 2: suffix match (`*.dev.preview.symbols.app` → development).
        // Anchored at a label boundary so `evil-dev.preview.symbols.app`
        // doesn't accidentally claim the dev channel.
        for (const { name: name, h: h } of tiers){
            if (host.endsWith('.' + h)) return name;
        }
        // Pass 3: prefix label. `<env>.<*>.symbols.app` — the leading label
        // is the channel name (or `dev` aliased to `development`).
        const labels = host.split('.');
        if (labels.length < 4) return null // bare apex like `my.symbols.app`
        ;
        const prefix = labels[0];
        if (prefix === 'dev') return 'development';
        if ((0, $hmkNw.isKnownChannel)(prefix)) return prefix;
        return null;
    };
    const queryParam = (name)=>{
        try {
            return new URLSearchParams(window.location.search).get(name);
        } catch (_) {
            return null;
        }
    };
    // Apply a `?apiUrl=...` query-param override into localStorage so the
    // rest of the precedence chain (and every subsequent page load) honors
    // it. Designed for testing how a server PR-preview deploy
    // (e.g. https://332.pr.api.symbols.app — see server/workers/pr-preview)
    // affects the live UI without rebuilding the frontend.
    //
    // Behavior:
    //   ?apiUrl=https://332.pr.api.symbols.app  → store + use
    //   ?apiUrl=clear  (or  ?apiUrl=  blank)    → remove the override
    // Non-prod hosts only — prod is hard-locked.
    //
    // Idempotent: only applies once per page load (URL param is the trigger,
    // after which the localStorage key carries the override across navs).
    // SECURITY (P0, 2026-10-08): a URL never chooses the API the SDK sends the
    // bearer token to. `?apiUrl=` used to be honoured AND persisted on every
    // host but my.symbols.app — `https://<white-label>/?apiUrl=https://evil`
    // pointed the stored token at the attacker. Now it counts only on a LOCAL dev
    // host, only for a LOCAL API, only for this page load (never persisted), and
    // any override an older build persisted is ignored and CLEARED off a local
    // host (workspaceApiBase.noUrlOverride.test.js).
    const onLocalHost = isLocalHostname(window.location.hostname);
    if (!onLocalHost) try {
        window.localStorage.removeItem('symbols_workspace_api');
        window.localStorage.removeItem('symbols_api_channel');
    } catch (_) {
    /* sandboxed storage — nothing persisted to clear */ }
    const queryApiUrl = ()=>{
        if (!onLocalHost) return null;
        const raw = queryParam('apiUrl');
        if (raw == null) return null;
        try {
            const u = new URL(raw.trim());
            if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
            return isLocalHostname(u.hostname) ? u.origin : null;
        } catch (_) {
            return null;
        }
    };
    const localQueryChannel = ()=>{
        if (!isLocalHostname(window.location.hostname)) return null;
        const channel = queryParam('channel');
        return channel && (0, $hmkNw.isKnownChannel)(channel) ? channel : null;
    };
    // A local dev host may name a LOCAL API in the URL, for this load only.
    const queryUrl = queryApiUrl();
    if (queryUrl) return queryUrl;
    // A channel named in the current URL is an intentional, per-navigation
    // choice, not a stale persisted pin. Honor it on local shells so developers
    // can use a remote API when the local server is not running. Stored remote
    // channels remain subject to the local-host guard below.
    const queryChannel = localQueryChannel();
    if (queryChannel) return (0, $hmkNw.apiUrl)(queryChannel);
    // Build-time SYMBOLS_API_CHANNEL pin (see the BUILD_CHANNEL note above).
    // After the query param — a channel named in the URL is a deliberate
    // per-navigation choice and must beat the process-wide default. `dev`
    // aliases to `development`, mirroring hostToChannel's label rule.
    if (BUILD_CHANNEL && isLocalHostname(window.location.hostname)) {
        const pinned = BUILD_CHANNEL === 'dev' ? 'development' : BUILD_CHANNEL;
        if ((0, $hmkNw.isKnownChannel)(pinned)) return (0, $hmkNw.apiUrl)(pinned);
    }
    // On a local-dev origin (localhost / *.localhost) the hostname autodetect
    // MUST win over a stale REMOTE pin: an old `?apiUrl=` capture or a
    // symbols_workspace_api / symbols_api_channel left on a non-local tier would
    // otherwise freeze the single SDK instance on an unreachable API
    // (dev.api "Failed to fetch"), silently overriding the `*.localhost → local`
    // rule below. `ok(url)` returns the url only when it's allowed on this origin
    // (any host off-local; only local hosts on-local), else null → fall through
    // to the next resolver. A LOCAL pin (api.localhost h2 alias, localhost:8080)
    // is still honored.
    const onLocal = isLocalHostname(window.location.hostname);
    const ok = (url)=>!onLocal || isLocalUrl(url) ? url : null;
    // Explicit URL override (highest precedence — direct URL beats channel).
    // a page-injected URL override is a LOCAL dev escape hatch only
    const runtimeUrl = window.__SYMBOLS_ENV?.WORKSPACE_API_URL;
    if (onLocal && runtimeUrl && ok(runtimeUrl)) return runtimeUrl;
    // Channel name override at runtime.
    const runtimeChannel = window.__SYMBOLS_ENV?.NODE_ENV;
    if (runtimeChannel) {
        const u = (0, $hmkNw.apiUrl)(runtimeChannel);
        if (ok(u)) return u;
    }
    // localStorage — explicit URL flag survives reloads.
    try {
        // read on a local dev host only (cleared above anywhere else)
        const lsUrl = onLocal ? window.localStorage.getItem('symbols_workspace_api') : null;
        if (lsUrl && ok(lsUrl)) return lsUrl;
        const lsChannel = onLocal ? window.localStorage.getItem('symbols_api_channel') : null;
        if (lsChannel) {
            const u = (0, $hmkNw.apiUrl)(lsChannel);
            if (ok(u)) return u;
        }
    } catch (_) {
    /* sandbox contexts may throw */ }
    // Hostname autodetect — walks the channel registry.
    const matched = hostToChannel(window.location.hostname);
    if (matched) return (0, $hmkNw.apiUrl)(matched);
    // WHITELABEL-CHANNEL-DEFAULT-1 (tickets/opus.md) — the served channel
    // stamp, for hosts the registry cannot name: WHITE-LABEL CUSTOM DOMAINS.
    //
    // A custom domain is not in channels.json and never will be — customer #2
    // must cost ZERO deploys, which is the same principle that rules out an
    // env-list CORS entry and a per-customer OAuth console entry. So the walk
    // above misses and, before this, execution fell straight to the BUILD_ENV
    // literal below. Measured 2026-08-19: app.bellforge.eu therefore talked to
    // dev.api while its org, workspace and verified customDomains row all live
    // on STAGING (Nika ruled it stays there) — the lookup returned `data: null`
    // and the whole white-label chain failed closed for a third independent
    // reason.
    //
    // ⚠️ WHY THE STAMP IS THE ONLY HONEST SOURCE: the SAME artifact is deployed
    // to dev.my AND staging.my, so "which plane am I" is genuinely NOT knowable
    // from the bundle — only from where it was served. `deploy-workspace.sh`
    // uploads a separate copy per target and a custom domain is served BY that
    // target's backend (app.bellforge.eu → my-staging → the staging bucket), so
    // the stamp is inherited by every custom domain on that backend, forever,
    // with no per-customer config.
    //
    // ⚠️ AND WHY IT IS READ *HERE*, not first (Nika, 2026-08-19: "do not change
    // anything for symbols"): every platform host matches `hostToChannel` and
    // has already returned above, so this line is unreachable for
    // my.symbols.app / canvas / preview / marketplace. Reading the meta at
    // higher precedence would put a deploy-time artifact in front of a resolver
    // every Symbols surface depends on, for no gain — the two agree on those
    // hosts by construction. Until the deploy half stamps it, this is a no-op
    // and behaviour is byte-identical to today.
    // THE ONE INJECTED-IDENTITY ACCESSOR. A deployment names its plane in one
    // of two injected values, never in the bundle:
    //   • a parcel deploy stamps `<meta name="symbols-channel">` (above);
    //   • the mermaid runtime (the PUBLISHED shell, *.symbo.ls) writes
    //     `window.__SYMBOLS_CHANNEL__` before the runtime evaluates
    //     (@symbo.ls/mermaid deployIdentity.js).
    // An unknown name counts as none.
    const injectedChannel = ()=>{
        try {
            if (typeof document !== 'undefined' && document.querySelector) {
                const el = document.querySelector('meta[name="symbols-channel"]');
                const v = el && el.getAttribute('content');
                const channel = typeof v === 'string' ? v.trim() : '';
                if (channel && (0, $hmkNw.isKnownChannel)(channel)) return channel;
            }
        } catch (_) {
        /* no DOM — try the runtime injection */ }
        const injected = window.__SYMBOLS_CHANNEL__;
        return typeof injected === 'string' && (0, $hmkNw.isKnownChannel)(injected) ? injected : null;
    };
    const stamped = injectedChannel();
    if (stamped) return (0, $hmkNw.apiUrl)(stamped);
    // Build-time NODE_ENV fallback — LOCAL HOSTS ONLY. The @symbo.ls/channels
    // dist's own `currentChannel()` is gated by a `typeof process` check that
    // fails in browsers, so plain `localhost` (no shell-host match) used the
    // build-time NODE_ENV literal Parcel substituted into our code. Off a local
    // host the value is not an identity: mermaid's process shim reads
    // `NODE_ENV: 'production'` on EVERY worker, dev included, so a published
    // dev shell resolved the production API from it.
    if (onLocal && BUILD_ENV && (0, $hmkNw.isKnownChannel)(BUILD_ENV)) return (0, $hmkNw.apiUrl)(BUILD_ENV);
    // FAIL CLOSED. No host rule and no injected identity: there is no honest
    // answer, and the registry default is production. '' makes getSDK serve
    // its null client (no backend reached) instead of talking to the wrong
    // plane (workspaceApiBase.failClosed.test.js).
    return '';
}
function $1915f1bc922bc90a$export$ea389a3d21bc440f() {
    try {
        if (typeof document !== 'undefined' && document && document.querySelector) {
            const el = document.querySelector('meta[name="symbols-channel"]');
            const v = el && el.getAttribute('content');
            const channel = typeof v === 'string' ? v.trim() : '';
            if (channel && (0, $hmkNw.isKnownChannel)(channel)) return channel;
        }
    } catch (_) {
    /* no DOM — try the runtime injection */ }
    const injected = typeof window !== 'undefined' ? window.__SYMBOLS_CHANNEL__ : undefined;
    return typeof injected === 'string' && (0, $hmkNw.isKnownChannel)(injected) ? injected : null;
}

});

parcelRegister("jhJrJ", function(module, exports) {

$parcel$export(module.exports, "getActiveWorkspacePointer", () => $e0a2db86f658089b$export$26183deedebc9b7c);
$parcel$export(module.exports, "setActiveWorkspacePointer", () => $e0a2db86f658089b$export$9e7d0cb1f77cd44c);
$parcel$export(module.exports, "clearActiveWorkspacePointer", () => $e0a2db86f658089b$export$d23d89e055924401);
$parcel$export(module.exports, "findWorkspaceInOrg", () => $e0a2db86f658089b$export$d4c6ee70e43624bb);
$parcel$export(module.exports, "workspaceUrlHandle", () => $e0a2db86f658089b$export$f79f41f88c9df5e2);
$parcel$export(module.exports, "resolveActiveWorkspace", () => $e0a2db86f658089b$export$8382b2317a0f0332);
// activeWorkspacePointer.js — the ONE owner of the client "active workspace"
// pointer (MULTI_WORKSPACE_TABS.md §6e/§6h/§5c-B). Converges the 4 read + 3 write
// sites that hand-rolled the `localStorage.activeWorkspace`-wins precedence
// (bootShell, auth.js, switchers) onto a single accessor, killing the drift the
// design flagged, and switches the storage backing per the rollout flag:
//
//   MWT OFF (default) → shared `localStorage.activeWorkspace` — every tab reads
//     the same value. Byte-identical to today.
//   MWT ON            → PER-TAB `sessionStorage.activeWorkspace`, seeded from
//     localStorage for a fresh tab, and at boot overridden by the tab's URL
//     (`/w/<org-slug>`, resolved via `resolveActiveWorkspace`). localStorage is
//     kept as the "last default" seed so new tabs open where you last were.
//
// The SDK is scoped separately (boot calls `sdk.updateContext({activeWorkspaceId})`
// — client-only, per-tab; services thread it as the Phase-0 `?workspaceId=` param).
// This module owns ONLY the client mirror + the resolution precedence.
//
// Pure-ish module, direct ESM import (workspacePrefix.js / guestRoutes.js pattern).

var $fDBlu = parcelRequire("fDBlu");

var $9juhh = parcelRequire("9juhh");
const $e0a2db86f658089b$export$26183deedebc9b7c = ()=>{
    const KEY = 'activeWorkspace';
    const local = ()=>{
        try {
            return globalThis.localStorage || null;
        } catch  {
            return null;
        }
    };
    const session = ()=>{
        try {
            return globalThis.sessionStorage || null;
        } catch  {
            return null;
        }
    };
    if (!(0, $fDBlu.isMwtEnabled)()) return local()?.getItem(KEY) || null;
    const ss = session();
    const own = ss?.getItem(KEY);
    if (own) return own;
    // Fresh tab: seed from the shared localStorage default, then own it per-tab so
    // subsequent reads are stable even if another tab later moves the seed.
    const seed = local()?.getItem(KEY) || null;
    if (seed && ss) try {
        ss.setItem(KEY, seed);
    } catch  {}
    return seed;
};
const $e0a2db86f658089b$export$9e7d0cb1f77cd44c = (id)=>{
    const KEY = 'activeWorkspace';
    const local = ()=>{
        try {
            return globalThis.localStorage || null;
        } catch  {
            return null;
        }
    };
    const session = ()=>{
        try {
            return globalThis.sessionStorage || null;
        } catch  {
            return null;
        }
    };
    if (!id) return;
    const v = String(id);
    if (!(0, $fDBlu.isMwtEnabled)()) {
        try {
            local()?.setItem(KEY, v);
        } catch  {}
        return;
    }
    try {
        session()?.setItem(KEY, v);
    } catch  {}
};
const $e0a2db86f658089b$export$d23d89e055924401 = ()=>{
    const KEY = 'activeWorkspace';
    const local = ()=>{
        try {
            return globalThis.localStorage || null;
        } catch  {
            return null;
        }
    };
    const session = ()=>{
        try {
            return globalThis.sessionStorage || null;
        } catch  {
            return null;
        }
    };
    try {
        local()?.removeItem(KEY);
    } catch  {}
    try {
        session()?.removeItem(KEY);
    } catch  {}
};
// org id → its HQ workspace id, from a workspaces list. HQ convention is
// `type:'shared'` (`'hq'` reserved), mirroring AppOrgSwitcher._homeWorkspace.
const $e0a2db86f658089b$var$_hqWorkspaceId = (orgId, workspaces)=>{
    if (!Array.isArray(workspaces)) return null;
    const oid = String(orgId);
    const mine = workspaces.filter((w)=>w && String(w.org_id ?? w.organization ?? '') === oid);
    const hq = mine.find((w)=>w.type === 'hq') || mine.find((w)=>w.type === 'shared') || mine[0];
    return hq ? String(hq.id ?? hq._id ?? '') || null : null;
};
// Find one workspace INSIDE an org by its URL handle. Scoping to the org is
// what makes slugs safe here — Workspace.slug is unique per org, not globally.
// Order mirrors how readable each handle is: `slug` (human, optional on the
// model), then `key` (`ws_<nanoid>`, always present and globally unique — the
// fallback for slug-less workspaces), then the raw id so a pasted id resolves.
const $e0a2db86f658089b$var$_findInOrg = (orgId, workspaces, wanted)=>{
    if (!Array.isArray(workspaces) || !wanted) return null;
    const oid = String(orgId);
    const want = String(wanted).toLowerCase();
    const mine = workspaces.filter((w)=>w && String(w.org_id ?? w.organization ?? '') === oid);
    const eq = (v)=>String(v ?? '').toLowerCase() === want;
    const hit = mine.find((w)=>w.slug && eq(w.slug)) || mine.find((w)=>w.key && eq(w.key)) || mine.find((w)=>eq(w.id ?? w._id));
    return hit ? String(hit.id ?? hit._id ?? '') || null : null;
};
const $e0a2db86f658089b$export$d4c6ee70e43624bb = $e0a2db86f658089b$var$_findInOrg;
const $e0a2db86f658089b$export$f79f41f88c9df5e2 = (ws)=>{
    if (!ws) return null;
    return String(ws.slug || ws.key || ws.id || ws._id || '') || null;
};
const $e0a2db86f658089b$export$8382b2317a0f0332 = ({ url: url, search: search, orgs: orgs, workspaces: workspaces, orgWorkspaces: orgWorkspaces, claim: claim } = {})=>{
    const path = ()=>{
        try {
            return globalThis.location?.pathname || '';
        } catch  {
            return '';
        }
    };
    const searchStr = ()=>{
        try {
            return globalThis.location?.search || '';
        } catch  {
            return '';
        }
    };
    const findInOrg = (orgId, wsList, wanted)=>{
        if (!Array.isArray(wsList) || !wanted) return null;
        const oid = String(orgId);
        const want = String(wanted).toLowerCase();
        const mine = wsList.filter((w)=>w && String(w.org_id ?? w.organization ?? '') === oid);
        const eq = (v)=>String(v ?? '').toLowerCase() === want;
        const hit = mine.find((w)=>w.slug && eq(w.slug)) || mine.find((w)=>w.key && eq(w.key)) || mine.find((w)=>eq(w.id ?? w._id));
        return hit ? String(hit.id ?? hit._id ?? '') || null : null;
    };
    const hqWorkspaceId = (orgId, wsList)=>{
        if (!Array.isArray(wsList)) return null;
        const oid = String(orgId);
        const mine = wsList.filter((w)=>w && String(w.org_id ?? w.organization ?? '') === oid);
        const hq = mine.find((w)=>w.type === 'hq') || mine.find((w)=>w.type === 'shared') || mine[0];
        return hq ? String(hq.id ?? hq._id ?? '') || null : null;
    };
    const activeWorkspacePointer = ()=>{
        const KEY = 'activeWorkspace';
        const local = ()=>{
            try {
                return globalThis.localStorage || null;
            } catch  {
                return null;
            }
        };
        const session = ()=>{
            try {
                return globalThis.sessionStorage || null;
            } catch  {
                return null;
            }
        };
        if (!(0, $fDBlu.isMwtEnabled)()) return local()?.getItem(KEY) || null;
        const ss = session();
        const own = ss?.getItem(KEY);
        if (own) return own;
        const seed = local()?.getItem(KEY) || null;
        if (seed && ss) try {
            ss.setItem(KEY, seed);
        } catch  {}
        return seed;
    };
    if ((0, $fDBlu.isMwtEnabled)()) {
        const slug = (0, $9juhh.getWorkspacePrefixSlug)(url || path());
        if (slug && Array.isArray(orgs)) {
            const org = orgs.find((o)=>o && o.slug === slug);
            if (org) {
                const fromMap = orgWorkspaces && orgWorkspaces[org.id];
                const list = Array.isArray(fromMap) ? fromMap : workspaces;
                // Scheme A: `/w/<org>/<ws-handle>/…` — segment 2 names WHICH workspace
                // when it matches one of this org's workspaces (data-driven, checked
                // against the org's own list right here — no dependence on the shell's
                // handle resolver, which may not be registered at boot). An
                // unrecognized segment is a route on the HQ — exactly the legacy
                // reading, so `/w/icca/documents` stays the documents page unless the
                // org really has a workspace with that handle.
                const { seg2: seg2 } = (0, $9juhh.getWorkspaceRawSegments)(url || path());
                if (seg2) {
                    const pathPick = findInOrg(org.id, list, seg2) || findInOrg(org.id, workspaces, seg2);
                    if (pathPick) return {
                        workspaceId: pathPick,
                        orgId: String(org.id),
                        orgSlug: slug,
                        source: 'url-path-ws'
                    };
                    // `default` that no workspace of the org claims names the org's MAIN
                    // workspace — the server's meaning (workspaceSlug.js: the HQ slug
                    // convention) — never the tab's last-used one (Nika 2026-10-18). Same
                    // HQ rule as the bare-org fallback below. Mirrored in the warm boot
                    // snapshot's scope match (workspace bootSnapshot.js).
                    if (String(seg2).toLowerCase() === 'default') {
                        const hqId = hqWorkspaceId(org.id, list) || hqWorkspaceId(org.id, workspaces);
                        if (hqId) return {
                            workspaceId: hqId,
                            orgId: String(org.id),
                            orgSlug: slug,
                            source: 'url-default'
                        };
                    }
                }
                // Legacy `?ws=` — parsed forever so old links keep resolving; the
                // canonicalizer (syncWorkspaceUrl) rewrites it to path form on the
                // first state sync. Matched on slug first (what the address bar
                // carries), id second (paste-an-id still works).
                const wanted = (0, $9juhh.getWorkspaceQueryParam)(search != null ? search : searchStr());
                if (wanted) {
                    const pick = findInOrg(org.id, list, wanted) || findInOrg(org.id, workspaces, wanted);
                    if (pick) return {
                        workspaceId: pick,
                        orgId: String(org.id),
                        orgSlug: slug,
                        source: 'url-ws'
                    };
                }
                // No `?ws=` — the URL names the org only, so it cannot say WHICH of its
                // workspaces. Before falling back to HQ, honour the tab's own pointer
                // when it points INSIDE this org: it is strictly more specific than the
                // org, and it is what the user last chose. Skipping this is why a reload
                // of a two-workspace org always bounced back to the HQ workspace even
                // though the tab clearly knew which one it had been in. A pointer into a
                // DIFFERENT org is correctly ignored — the URL wins on the org.
                const ptrInOrg = findInOrg(org.id, list, activeWorkspacePointer());
                if (ptrInOrg) return {
                    workspaceId: ptrInOrg,
                    orgId: String(org.id),
                    orgSlug: slug,
                    source: 'url-pointer'
                };
                const wsId = hqWorkspaceId(org.id, list) || hqWorkspaceId(org.id, workspaces);
                if (wsId) return {
                    workspaceId: wsId,
                    orgId: String(org.id),
                    orgSlug: slug,
                    source: 'url'
                };
                // P0 tenant isolation (tickets/fable.md 2026-08-14 — "/w/natali/…/notes
                // RENDERS BELLFORGE"): the URL names a MEMBER org, but none of its
                // workspaces are resolvable yet (cross-org cold deep-link before the
                // target org's list loads). This used to FALL THROUGH to the tab
                // pointer — a workspace in a DIFFERENT org — so the whole boot scoped
                // to the pointer's tenant while the address bar named this one: the
                // exact cross-tenant render Nika reported. The URL is the source of
                // truth for scope; the pointer is an accelerator that must never win
                // over a URL-named member org. Return the org pinned with the
                // workspace deliberately unresolved — bootShell skips the
                // workspace-keyed seeds/pointer write for a null workspaceId, scopes
                // the org fetch to THIS org, and the auth tick's listWorkspaces
                // fallback resolves the workspace within one boot. A pointer into a
                // NON-member/unknown slug still falls through below (this session
                // cannot scope to an org it cannot see; reconcileMwtOrgFromUrl owns
                // the honest URL rescope for that case).
                return {
                    workspaceId: null,
                    orgId: String(org.id),
                    orgSlug: slug,
                    source: 'url-org-unresolved'
                };
            }
        }
    }
    const ptr = activeWorkspacePointer();
    if (ptr) return {
        workspaceId: ptr,
        orgId: null,
        orgSlug: null,
        source: 'pointer'
    };
    if (claim) return {
        workspaceId: String(claim),
        orgId: null,
        orgSlug: null,
        source: 'claim'
    };
    return {
        workspaceId: null,
        orgId: null,
        orgSlug: null,
        source: 'none'
    };
};

});
parcelRegister("fDBlu", function(module, exports) {

$parcel$export(module.exports, "isMwtEnabled", () => $b6277795148540ea$export$7f8ddfbdde821984);
$parcel$export(module.exports, "_resetMwtFlagCache", () => $b6277795148540ea$export$ec4dcb07f0f6e887);
// Multi-workspace-tabs rollout flag (MULTI_WORKSPACE_TABS.md Phase 5).
//
// ON by default since 2696043c (2026-07-21, "MWT default-ON (re-enabled) —
// boot-race guard fix now in place"). Corrected 2026-08-08 during the
// tickets/workspace.md P1 tenant-isolation audit — this header previously
// still described the EARLIER default-OFF revert (cccc347b, 2026-07-19),
// which is stale relative to the code below (`!== 'off'`, not `=== 'on'`).
// Do not re-derive the default from this comment alone; read `isMwtEnabled`.
//
// IMPORTANT for anyone auditing pointer/isolation bugs: because the OFF
// default briefly shipped (cccc347b, 2026-07-19 → 2696043c, 2026-07-21) and
// `localStorage.mwt` has no expiry, any browser that picked up
// `localStorage.mwt='off'` during that window (or via an explicit `?mwt=0`)
// stays pinned to the OLD shared-pointer behavior FOREVER, silently, even
// though the code has defaulted back to ON since 2026-07-21. Check
// `localStorage.getItem('mwt')` in the affected browser before assuming the
// pointer read is the shared one — it depends on that browser's history, not
// just what shipped to `main`.
//
// When ON (default) → per-tab workspace scoping: sessionStorage pointer,
// `/w/<org-slug>` URL prefix, and cross-tab/cross-device convergence gated
// per-tab. Opt OUT persistently with `localStorage.setItem('mwt', 'off')`, or
// transiently for one load/tab with `?mwt=0`. When off, the shell behaves
// EXACTLY as before MWT existed: shared `localStorage.activeWorkspace`
// pointer, no URL prefix, active convergence handlers.
//
// The `?mwt` query param wins over localStorage and is NOT persisted, so a single
// tab can force-enable (`?mwt=1`) or force-disable (`?mwt=0`) independently of the
// rest of the browser — which is how the two-tab isolation matrix is exercised.
//
// Pure module, direct ESM import (guestRoutes.js / workspacePrefix.js
// pattern) — AND barrelled via `functions/index.js` (`export *
// from './mwtFlag.js'`, line ~450); the "never registered" half of this
// comment went stale at some point after that landed.
//
// `_cached` sentinel is `null`, not `undefined` — frank's FA201 auto-fix
// wraps this module-scope mutable state in a `Smut` container that
// round-trips through JSON at `to-json` time, and `JSON.stringify` drops
// `undefined`-valued keys entirely, so the emitted Smut container never had
// a `_cached` key to write through (`frank to-json`: `unresolvable-
// identifier` on both `functions.isMwtEnabled` and its globalScope-lifted
// duplicate). `null` survives JSON round-tripping; same semantics
// everywhere `_cached` is read as "unset".
//
// FA204 / frank trap (a SEPARATE, more fundamental issue than the FA201 fix
// above addresses) — `_cached` is genuinely shared mutable state between TWO
// exports (isMwtEnabled + the test-only _resetMwtFlagCache), with no
// `el`/`root` argument anywhere in this file to hoist it onto
// (project_frank_drops_module_local_helpers). Re-homed onto
// `globalThis.__mwtFlagCache` (lazily created) — the same
// always-reachable-global escape hatch pointerCapability.js's
// `window.__pointerCapabilityState` uses. `globalThis` (not `window`) since
// this must also work in the SSR/Node test environment
// _resetMwtFlagCache is called from.
const $b6277795148540ea$export$7f8ddfbdde821984 = ()=>{
    const cache = globalThis.__mwtFlagCache ??= {
        value: null
    };
    if (cache.value !== null) return cache.value;
    let on = false;
    try {
        if (typeof window !== 'undefined' && window.location) {
            const q = new URLSearchParams(window.location.search || '').get('mwt');
            if (q === '1' || q === 'on') on = true;
            else if (q === '0' || q === 'off') on = false;
            else {
                // FILES-XWS-CALL-BLEED-1 — expiry for the stale opt-out described in
                // this file's header. `localStorage` has no TTL, so a browser that
                // picked up `mwt='off'` during the 2026-07-19 -> 2026-07-21 default-OFF
                // window stayed pinned to the shared-pointer behavior forever: with MWT
                // off `resolveActiveWorkspace` ignores the URL, so `/w/<org>/<ws>/…`
                // renders whatever workspace the pointer last held. That reads as
                // cross-workspace bleed to the person looking at the address bar.
                //
                // One-shot generation purge. A store with no `mwtOptOutGen` marker
                // predates this migration, so its `off` cannot be told apart from the
                // landmine — drop it once and stamp the store. Every opt-out made after
                // the migration carries the marker and is never touched, so the
                // documented `localStorage.setItem('mwt', 'off')` affordance keeps
                // working. Bump the marker value only for a new deliberate migration.
                const store = globalThis.localStorage;
                if (store && store.getItem('mwtOptOutGen') !== '1') {
                    if (store.getItem('mwt') === 'off') store.removeItem('mwt');
                    store.setItem('mwtOptOutGen', '1');
                }
                on = store?.getItem('mwt') !== 'off';
            }
        }
    } catch  {
        on = false;
    }
    cache.value = on;
    return on;
};
const $b6277795148540ea$export$ec4dcb07f0f6e887 = ()=>{
    const cache = globalThis.__mwtFlagCache ??= {
        value: null
    };
    cache.value = null;
};

});

parcelRegister("9juhh", function(module, exports) {

$parcel$export(module.exports, "registerWorkspaceHandleResolver", () => $6c7d5fec39c2e374$export$f0b5b7b1032c86c9);
$parcel$export(module.exports, "parseWorkspacePath", () => $6c7d5fec39c2e374$export$6c453bf4a1590ef2);
$parcel$export(module.exports, "getWorkspacePathHandle", () => $6c7d5fec39c2e374$export$f38819fdd9e0701c);
$parcel$export(module.exports, "getWorkspaceRawSegments", () => $6c7d5fec39c2e374$export$94148ee21fa4cfc4);
$parcel$export(module.exports, "stripWorkspacePrefix", () => $6c7d5fec39c2e374$export$9221bcd07e78b6b9);
$parcel$export(module.exports, "routePathCandidates", () => $6c7d5fec39c2e374$export$3fab56b963d25f0f);
$parcel$export(module.exports, "canonicalRoutePath", () => $6c7d5fec39c2e374$export$39fe38d87db118f9);
$parcel$export(module.exports, "getWorkspacePrefixSlug", () => $6c7d5fec39c2e374$export$15e98674ca341ad7);
$parcel$export(module.exports, "hasWorkspacePrefix", () => $6c7d5fec39c2e374$export$b00fbb664057e473);
$parcel$export(module.exports, "withWorkspacePrefix", () => $6c7d5fec39c2e374$export$e92083c0dafa98b);
$parcel$export(module.exports, "withWorkspacePath", () => $6c7d5fec39c2e374$export$ffa80e85c89ae931);
$parcel$export(module.exports, "getWorkspaceQueryParam", () => $6c7d5fec39c2e374$export$86f43de096d0570b);
$parcel$export(module.exports, "withWorkspaceQuery", () => $6c7d5fec39c2e374$export$7b4e5f73a9a69c5d);
// Multi-workspace-tabs: intranet route paths gain an optional leading
// `/w/<org-slug>` prefix (MULTI_WORKSPACE_TABS.md §6a/§6g) so a browser tab can
// pin itself to one workspace. Only the workspaceProject intranet route set is
// prefixed — canvas (`/<owner>/<project>`, `/studio/*`), marketplace and preview
// are NEVER prefixed (§6b). `w` is RESERVED (added to app.js `_CANVAS_RESERVED`),
// so `/w/<x>` is UNAMBIGUOUSLY a workspace prefix, never a `<owner>/<key>` pair.
//
// AMENDED 2026-08-06 (per Nika "for canvas projects
// /w/<org>/<workspace>/p/<project>"): the canvas PROJECT page now has a
// workspace-scoped form — `/w/<org>/p/<key>` (HQ) and `/w/<org>/<ws>/p/<key>`
// — where the reserved `p` segment marks "the next segment is a project key".
// The residual route after org/ws parsing is `/p/<key>` (parse + compose live
// in ./projectUrls.js). Bare `/<owner>/<key>` stays valid forever (external
// links, cross-org projects). Other canvas surfaces (`/studio/*`) remain
// unprefixed.
//
// These are pure path-string helpers (guestRoutes.js pattern) — they take the
// path as an argument (Rule 64: reads are fine; navigation still goes through
// el.router) so callers pass either `window.location.pathname` or the
// router's `root.currentPath`.
//
// CORRECTION 2026-08-12 — this file's header USED to claim these are "NOT via
// el.call and NOT registered in functions/index.js", but functions/index.js
// DOES barrel `export * from './workspacePrefix.js'`, and
// `stripWorkspacePrefix` genuinely IS called via `el.call('stripWorkspacePrefix',
// …)` from tickets/Main.js + Sidebar.js — real, live registry usage, not just
// direct import. FA204 / frank trap applies: an exported function reading a
// module-scope const, OR a bare SIBLING export, is unresolvable once this
// file's exports are individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers; readerVoice.js precedent,
// workspace 8732aa07). Every export below is now self-contained, WITHOUT
// exception. The handle resolver — genuinely mutable cross-cutting state, SET
// once at boot by `registerWorkspaceHandleResolver` and READ by every parse
// call, with no `el`/`root` argument anywhere in this file's signatures to
// hoist state onto (unlike AppNavbar's `el.context` or navbarTabMenu's
// `root.__navbarSaveQueue`) — lives on `globalThis.__workspacePrefixState`,
// per the pointerCapability.js template. It used to be a module-scope `let`
// (`_wsHandleResolver`), a documented deliberate exception, until frank's
// emission gate started refusing it: see the Scheme A block below for the
// measurement. In practice this only affects the NOT-YET-SHIPPED two-segment
// `/w/<org>/<ws>/…` scheme (Phase 3); today, with zero live `/w/` URLs, every
// call falls through the one-segment/no-prefix branches, which never touch
// the resolver at all.
//
// CRITICAL PROPERTY — `stripWorkspacePrefix` is a NO-OP for every path that does
// NOT start with `/w/<slug>`. Until Phase 3 emits prefixed URLs, no path does,
// so wrapping a classifier in it is byte-identical today. That's why Phase 1
// (route-classifier hardening) ships safely on its own, ahead of the URL change.
// ── Scheme A (2026-07-30 per Nika): the workspace lives IN THE PATH ─────────
// `/w/<org>/<ws-handle>/<route…>`; the HQ keeps the concise `/w/<org>/<route…>`
// form. The ambiguity that originally forced the `?ws=` query param
// (`/w/icca/documents` — workspace or route?) is resolved DATA-DRIVEN: segment
// 2 reads as a workspace IFF the session knows a workspace of that org by that
// handle. The shell registers the resolver at boot
// (registerWorkspaceHandleResolver); before it is set — or when it says no —
// segment 2 reads as a route on the HQ, which is exactly the legacy
// interpretation, and the boot canonicalizer re-stamps once claims land.
// Server-side, new slugs are minted against a reserved blacklist mirroring the
// static route names, so fresh collisions cannot be created.
//
// The handle resolver is genuinely mutable cross-cutting state: set once here
// by `registerWorkspaceHandleResolver` and read by every parse call below,
// with no `el`/`root` argument in any of this file's signatures to hoist it
// onto instead. It USED to be a module-scope `let` (`_wsHandleResolver`), the
// ONE documented exception to this file's self-contained-export rule.
//
// FA201 / frank trap (WS-SHARED-MODULE-LET-BLOCKS-EVERY-PUSH-1) — that
// exception broke the publish path for EVERY project that inlines this
// package. frank hoists each export into the emitted `globalScope` and revives
// it with a bare indirect eval, where nothing module-level is in scope, so the
// three readers below each emitted a guaranteed ReferenceError on
// `_wsHandleResolver`. frank's emission gate refuses that (`PUBLISH BLOCKED —
// [unresolvable-identifier]`), which is why every push of a shared-inlining
// project needed `--no-verify-serialization`.
//
// Re-homed onto `globalThis.__workspacePrefixState`, per the
// pointerCapability.js template — the same always-reachable-global escape
// hatch that file's `window.__pointerCapabilityState` uses. `globalThis`
// rather than `window` because it is defined in every runtime this package is
// loaded in (browser, bun test, node), and in a browser it IS `window`, so the
// shell writes and the readers read one object. The lazy create is INLINED at
// each site on purpose: a shared module-scope getter would just relocate the
// same bare-sibling-call hazard this fix removes.
const $6c7d5fec39c2e374$export$f0b5b7b1032c86c9 = (fn)=>{
    if (!globalThis.__workspacePrefixState) globalThis.__workspacePrefixState = {
        handleResolver: null
    };
    globalThis.__workspacePrefixState.handleResolver = typeof fn === 'function' ? fn : null;
};
const $6c7d5fec39c2e374$export$6c453bf4a1590ef2 = (pathname)=>{
    // Org slug per MODEL: required, globally-unique, [a-z0-9-]{1,48}. The
    // lookahead admits `?`/`#` too so a composed path+query (`/w/acme?x=1`,
    // planMwtNav's inputs) parses the same as a bare pathname.
    const WORKSPACE_PREFIX_RE = /^\/w\/[a-z0-9-]{1,48}(?=[/?#]|$)/;
    const WORKSPACE_SLUG_RE = /^\/w\/([a-z0-9-]{1,48})(?=[/?#]|$)/;
    // Segment 2 — WHICH workspace. Handles are workspace slugs OR keys
    // (`ws_jfTumkSWof`) or raw ids, hence the wider charset than org slugs.
    const WORKSPACE_TWO_SEG_RE = /^\/w\/([a-z0-9-]{1,48})\/([A-Za-z0-9_-]{1,64})(?=[/?#]|$)/;
    // Segment-2 names that can NEVER be a workspace handle — static route
    // markers under `/w/<org>/…`, gated here so not even a lying/stale
    // resolver can claim them. `p` is the canvas-project marker
    // (`/w/<org>/p/<key>` — the HQ form puts it in segment 2). Mirrored
    // server-side in RESERVED_WORKSPACE_SLUGS (server
    // src/core/utils/workspaceSlug.js) so no workspace can mint the slug.
    const RESERVED_WS_SEG2 = new Set([
        'p'
    ]);
    const isWsHandle = (orgSlug, seg)=>{
        if (!seg || RESERVED_WS_SEG2.has(seg)) return false;
        const resolver = globalThis.__workspacePrefixState?.handleResolver;
        if (!resolver) return false;
        try {
            return !!resolver(orgSlug, seg);
        } catch  {
            return false;
        }
    };
    const restToRoute = (rest)=>{
        if (rest === '') return '/';
        // A prefix followed directly by query/hash (`/w/acme?x=1`) strips to
        // `?x=1` — normalize to a rooted route so classifiers always see a path.
        return rest.startsWith('?') || rest.startsWith('#') ? '/' + rest : rest;
    };
    // `default` is NEVER a route. It is the HQ slug convention (server
    // workspaceSlug.js: 'Default' → slug 'default', left unreserved because it is
    // unambiguous as segment 2), so `/w/<org>/default/…` links reach orgs whose
    // default workspace carries another slug (`hq`) or none (key only). Where a
    // route would start it is dropped — never read as the `/default` route
    // ("Not found"): at segment 2 when no workspace of the org claims it (the
    // org's default landing, exactly the bare `/w/<org>`), and right after a
    // handle, where only a double stamp (`/w/<org>/<handle>/default`) puts it.
    const dropDefault = (rest)=>/^\/default(?=[/?#]|$)/i.test(rest) ? rest.slice(8) : rest;
    if (typeof pathname !== 'string' || !pathname) return {
        orgSlug: null,
        wsHandle: null,
        route: pathname || '/'
    };
    const two = pathname.match(WORKSPACE_TWO_SEG_RE);
    if (two && isWsHandle(two[1], two[2])) return {
        orgSlug: two[1],
        wsHandle: two[2],
        route: restToRoute(dropDefault(pathname.slice(two[0].length)))
    };
    const one = pathname.match(WORKSPACE_SLUG_RE);
    if (one) return {
        orgSlug: one[1],
        wsHandle: null,
        route: restToRoute(dropDefault(pathname.replace(WORKSPACE_PREFIX_RE, '')))
    };
    return {
        orgSlug: null,
        wsHandle: null,
        route: pathname
    };
};
const $6c7d5fec39c2e374$export$f38819fdd9e0701c = (pathname)=>{
    const WORKSPACE_TWO_SEG_RE = /^\/w\/([a-z0-9-]{1,48})\/([A-Za-z0-9_-]{1,64})(?=[/?#]|$)/;
    const RESERVED_WS_SEG2 = new Set([
        'p'
    ]);
    const isWsHandle = (orgSlug, seg)=>{
        if (!seg || RESERVED_WS_SEG2.has(seg)) return false;
        const resolver = globalThis.__workspacePrefixState?.handleResolver;
        if (!resolver) return false;
        try {
            return !!resolver(orgSlug, seg);
        } catch  {
            return false;
        }
    };
    if (typeof pathname !== 'string' || !pathname) return null;
    const two = pathname.match(WORKSPACE_TWO_SEG_RE);
    return two && isWsHandle(two[1], two[2]) ? two[2] : null;
};
const $6c7d5fec39c2e374$export$94148ee21fa4cfc4 = (pathname)=>{
    const WORKSPACE_SLUG_RE = /^\/w\/([a-z0-9-]{1,48})(?=[/?#]|$)/;
    const WORKSPACE_TWO_SEG_RE = /^\/w\/([a-z0-9-]{1,48})\/([A-Za-z0-9_-]{1,64})(?=[/?#]|$)/;
    if (typeof pathname !== 'string' || !pathname) return {
        orgSlug: null,
        seg2: null
    };
    const two = pathname.match(WORKSPACE_TWO_SEG_RE);
    if (two) return {
        orgSlug: two[1],
        seg2: two[2]
    };
    const one = pathname.match(WORKSPACE_SLUG_RE);
    return {
        orgSlug: one ? one[1] : null,
        seg2: null
    };
};
const $6c7d5fec39c2e374$export$9221bcd07e78b6b9 = (pathname)=>{
    const WORKSPACE_PREFIX_RE = /^\/w\/[a-z0-9-]{1,48}(?=[/?#]|$)/;
    const WORKSPACE_SLUG_RE = /^\/w\/([a-z0-9-]{1,48})(?=[/?#]|$)/;
    const WORKSPACE_TWO_SEG_RE = /^\/w\/([a-z0-9-]{1,48})\/([A-Za-z0-9_-]{1,64})(?=[/?#]|$)/;
    const RESERVED_WS_SEG2 = new Set([
        'p'
    ]);
    const isWsHandle = (orgSlug, seg)=>{
        if (!seg || RESERVED_WS_SEG2.has(seg)) return false;
        const resolver = globalThis.__workspacePrefixState?.handleResolver;
        if (!resolver) return false;
        try {
            return !!resolver(orgSlug, seg);
        } catch  {
            return false;
        }
    };
    const restToRoute = (rest)=>{
        if (rest === '') return '/';
        return rest.startsWith('?') || rest.startsWith('#') ? '/' + rest : rest;
    };
    // `default` is never a route — see parseWorkspacePath's dropDefault.
    const dropDefault = (rest)=>/^\/default(?=[/?#]|$)/i.test(rest) ? rest.slice(8) : rest;
    if (typeof pathname !== 'string' || !pathname) return pathname;
    const two = pathname.match(WORKSPACE_TWO_SEG_RE);
    if (two && isWsHandle(two[1], two[2])) return restToRoute(dropDefault(pathname.slice(two[0].length)));
    const one = pathname.match(WORKSPACE_SLUG_RE);
    if (one) return restToRoute(dropDefault(pathname.replace(WORKSPACE_PREFIX_RE, '')));
    return pathname;
};
const $6c7d5fec39c2e374$export$3fab56b963d25f0f = (pathname)=>{
    const ORG_RE = /^\/w\/[a-z0-9-]{1,48}(?=[/?#]|$)/;
    const TWO_SEG_RE = /^\/w\/[a-z0-9-]{1,48}\/[A-Za-z0-9_-]{1,64}(?=[/?#]|$)/;
    const path = typeof pathname === 'string' && pathname ? pathname : '/';
    const out = [
        path
    ];
    const push = (rest)=>{
        const next = rest === '' ? '/' : rest;
        if (out.indexOf(next) === -1) out.push(next);
    };
    const org = path.match(ORG_RE);
    if (!org) return out;
    push(path.slice(org[0].length));
    const two = path.match(TWO_SEG_RE);
    if (two) push(path.slice(two[0].length));
    return out;
};
const $6c7d5fec39c2e374$export$39fe38d87db118f9 = (pathname)=>{
    // Legacy → canonical route-prefix aliases. The tickets feature renamed its
    // USER-FACING route to /tasks (2026-08-06 per Nika "instead of /tickets it
    // will be /tasks") while the old /tickets* URLs stay registered as inbound
    // aliases in the shell route map — so active-state matchers (AppNavbar,
    // HeaderTabs) normalize a live path through canonicalRoutePath before
    // comparing against an item's canonical route. Longest prefix first. The
    // DATA plane (sdk.tickets.*, root.tickets) keeps its internal names.
    const LEGACY_ROUTE_ALIASES = [
        // Requests/Resolutions moved OUT of the tickets sidebar to their own
        // top-level surface before the rename — their legacy forms canonicalize
        // there, not under /tasks (a /tasks/requests route does not exist).
        [
            '/tickets/requests/audit',
            '/resolutions/audit'
        ],
        [
            '/tickets/requests',
            '/resolutions/requests'
        ],
        [
            '/tickets/resolutions',
            '/resolutions'
        ],
        [
            '/tickets-page',
            '/tasks-page'
        ],
        [
            '/tickets',
            '/tasks'
        ],
        [
            '/ticket',
            '/task'
        ],
        // Documents renamed to Notes (2026-08-06 per Nika). The old three-way
        // section split collapsed: /documents/notes IS the main list now, and
        // /documents/kb joins the canonical /notes/knowledge-base form.
        [
            '/documents/knowledge-base',
            '/notes/knowledge-base'
        ],
        [
            '/documents/kb',
            '/notes/knowledge-base'
        ],
        [
            '/documents/notes',
            '/notes'
        ],
        [
            '/documents/editor',
            '/notes/editor'
        ],
        [
            '/documents',
            '/notes'
        ],
        [
            '/docs',
            '/notes'
        ]
    ];
    const p = typeof pathname === 'string' ? pathname : '';
    const hit = LEGACY_ROUTE_ALIASES.find(([from])=>p === from || p.startsWith(from + '/'));
    return hit ? hit[1] + p.slice(hit[0].length) : p;
};
const $6c7d5fec39c2e374$export$15e98674ca341ad7 = (pathname)=>{
    const WORKSPACE_SLUG_RE = /^\/w\/([a-z0-9-]{1,48})(?=[/?#]|$)/;
    if (typeof pathname !== 'string') return null;
    const m = pathname.match(WORKSPACE_SLUG_RE);
    return m ? m[1] : null;
};
const $6c7d5fec39c2e374$export$b00fbb664057e473 = (pathname)=>{
    const WORKSPACE_SLUG_RE = /^\/w\/([a-z0-9-]{1,48})(?=[/?#]|$)/;
    if (typeof pathname !== 'string') return false;
    return WORKSPACE_SLUG_RE.test(pathname);
};
const $6c7d5fec39c2e374$export$e92083c0dafa98b = (slug, pathname = '/')=>{
    const base = typeof pathname === 'string' && pathname ? pathname : '/';
    if (!slug) return base;
    const rest = base === '/' ? '' : base.startsWith('/') ? base : `/${base}`;
    return `/w/${slug}${rest}`;
};
const $6c7d5fec39c2e374$export$ffa80e85c89ae931 = (orgSlug, wsHandle, pathname = '/')=>{
    const base = typeof pathname === 'string' && pathname ? pathname : '/';
    if (!orgSlug) return base;
    const rest = base === '/' ? '' : (base.startsWith('/') ? base : `/${base}`).replace(/^\/(?=[?#])/, '');
    return wsHandle ? `/w/${orgSlug}/${wsHandle}${rest}` : `/w/${orgSlug}${rest}`;
};
const $6c7d5fec39c2e374$export$86f43de096d0570b = (search)=>{
    const WORKSPACE_QUERY_KEY = 'ws';
    if (typeof search !== 'string' || !search) return null;
    const qAt = search.indexOf('?');
    const qs = qAt === -1 ? search : search.slice(qAt + 1);
    try {
        const v = new URLSearchParams(qs.split('#')[0]).get(WORKSPACE_QUERY_KEY);
        return v ? String(v).trim() || null : null;
    } catch  {
        return null;
    }
};
const $6c7d5fec39c2e374$export$7b4e5f73a9a69c5d = (url, slug)=>{
    const WORKSPACE_QUERY_KEY = 'ws';
    const raw = typeof url === 'string' && url ? url : '/';
    const hashAt = raw.indexOf('#');
    const hash = hashAt === -1 ? '' : raw.slice(hashAt);
    const noHash = hashAt === -1 ? raw : raw.slice(0, hashAt);
    const qAt = noHash.indexOf('?');
    const path = qAt === -1 ? noHash : noHash.slice(0, qAt);
    const params = new URLSearchParams(qAt === -1 ? '' : noHash.slice(qAt));
    if (slug) params.set(WORKSPACE_QUERY_KEY, String(slug));
    else params.delete(WORKSPACE_QUERY_KEY);
    const q = params.toString();
    return path + (q ? '?' + q : '') + hash;
};

});




parcelRegister("eVQcI", function(module, exports) {

$parcel$export(module.exports, "ownerSlug", () => $adeee2313452366d$export$7e6296f657b1fe2c);
$parcel$export(module.exports, "ownerMatches", () => $adeee2313452366d$export$911588fa76f0350d);
$parcel$export(module.exports, "projectKey", () => $adeee2313452366d$export$a59753e5f25e6cbe);
$parcel$export(module.exports, "SCREENSHOT_CDN_READY", () => $adeee2313452366d$export$11eb1e4fea2455f6);
$parcel$export(module.exports, "isLegacyScreenshotUrl", () => $adeee2313452366d$export$5253f4b68e546e6c);
$parcel$export(module.exports, "sanitizeStoredThumbnail", () => $adeee2313452366d$export$b9083e9b1fc536a1);
$parcel$export(module.exports, "projectScreenshotUrl", () => $adeee2313452366d$export$b946faae724d34ec);
$parcel$export(module.exports, "groupByOwner", () => $adeee2313452366d$export$90a2d8a00e64886);

var $hmkNw = parcelRequire("hmkNw");
const $adeee2313452366d$export$7e6296f657b1fe2c = (project)=>{
    const o = project?.owner;
    if (!o) return project?.ownerUsername || '';
    if (typeof o === 'string') return o;
    return o.slug || o.username || '';
};
const $adeee2313452366d$export$911588fa76f0350d = (project, slug)=>{
    // FA204 / frank trap — self-contained inline copy of ownerSlug, see the
    // file header.
    const _ownerSlug = (project)=>{
        const o = project?.owner;
        if (!o) return project?.ownerUsername || '';
        if (typeof o === 'string') return o;
        return o.slug || o.username || '';
    };
    return _ownerSlug(project) === slug;
};
const $adeee2313452366d$export$a59753e5f25e6cbe = (project)=>(project?.key || '').split('.')[0];
const $adeee2313452366d$export$11eb1e4fea2455f6 = true;
const $adeee2313452366d$export$5253f4b68e546e6c = (url)=>{
    if (typeof url !== 'string' || !url) return false;
    return /^https?:\/\/screenshots\.symbo\.ls\//i.test(url);
};
const $adeee2313452366d$export$b9083e9b1fc536a1 = (url)=>{
    // FA204 / frank trap — self-contained inline copy of isLegacyScreenshotUrl,
    // see the file header.
    const _isLegacyScreenshotUrl = (url)=>{
        if (typeof url !== 'string' || !url) return false;
        return /^https?:\/\/screenshots\.symbo\.ls\//i.test(url);
    };
    return _isLegacyScreenshotUrl(url) ? null : url || null;
};
const $adeee2313452366d$export$b946faae724d34ec = (project, { page: page = 'root', env: env = 'production' } = {})=>{
    // FA204 / frank trap — self-contained inline copies, see the file header.
    const SCREENSHOT_CDN_READY = true;
    const _ownerSlug = (project)=>{
        const o = project?.owner;
        if (!o) return project?.ownerUsername || '';
        if (typeof o === 'string') return o;
        return o.slug || o.username || '';
    };
    const _projectKey = (project)=>(project?.key || '').split('.')[0];
    // Mongo ObjectId pattern — 24 hex chars. Projects whose owner or key is
    // a raw ObjectId have not been migrated to human-readable slugs yet and
    // will not have a CDN screenshot. Returning null lets the tile fall back
    // to the letter-placeholder gradient, eliminating the 404 noise (#2185).
    const _isObjectId = (s)=>/^[a-f0-9]{24}$/i.test(String(s || ''));
    // Owner slugs to skip the CDN fetch for (framework/demo entries with no
    // captured screenshots — avoids 404 noise, #2314). Emptied 2026-06-09 per
    // Nika: the `system` org's projects now have captured screenshots on the
    // CDN (verified system/landing/root.webp → 200), so they load when
    // available and only fall back to the gradient for a project that
    // genuinely has none.
    const _SKIP_CDN_OWNERS = new Set();
    if (!SCREENSHOT_CDN_READY) return null;
    const owner = _ownerSlug(project);
    const key = _projectKey(project);
    if (_isObjectId(owner) || _isObjectId(key)) return null;
    if (_SKIP_CDN_OWNERS.has(String(owner || '').toLowerCase())) return null;
    return (0, $hmkNw.screenshotCdnUrl)({
        owner: owner,
        key: key,
        page: page,
        env: env
    });
};
const $adeee2313452366d$export$90a2d8a00e64886 = (projects)=>{
    // FA204 / frank trap — self-contained inline copy of ownerSlug, see the
    // file header.
    const _ownerSlug = (project)=>{
        const o = project?.owner;
        if (!o) return project?.ownerUsername || '';
        if (typeof o === 'string') return o;
        return o.slug || o.username || '';
    };
    const map = new Map();
    for (const p of projects){
        const slug = _ownerSlug(p) || 'unknown';
        if (!map.has(slug)) map.set(slug, []);
        map.get(slug).push(p);
    }
    return [
        ...map.entries()
    ].map(([owner, items])=>({
            owner: owner,
            items: items
        }));
};

});


parcelRegister("l82Az", function(module, exports) {

$parcel$export(module.exports, "MemberProfile", () => $f61c5a6dacc263dc$export$70752ed3eb71b053);
$parcel$export(module.exports, "MemberProfileA11yRow", () => $f61c5a6dacc263dc$export$ec0c9d788be664cb);
$parcel$export(module.exports, "MemberProfileA11yChip", () => $f61c5a6dacc263dc$export$6c1453e44d8b037f);
$parcel$export(module.exports, "MemberProfileDocRow", () => $f61c5a6dacc263dc$export$76702a5ccaf727aa);
$parcel$export(module.exports, "MemberProfileCheckItem", () => $f61c5a6dacc263dc$export$5e443b08c7b93dd6);
$parcel$export(module.exports, "ProfileGrantCard", () => $f61c5a6dacc263dc$export$a73d92b4aa3052ce);
// MemberProfile — canonical account-screen component, consumed by
// workspace-shell's /my + /profile + /settings pages AND canvas's
// /settings (shared/pages/profile.js). Reads from findMe(s) which
// resolves to the viewed person (via ?u= query or current user).
// Sections: Hero, Details, Equity, Documents, Checklist.
//
// Config via parent element props:
//   editable  — whether fields are editable (boolean fn or static)
//   showPrivate — whether equity/docs/checklist are visible
//
// Every prop factory below calls `findMe(s)` directly — a former
// `const _me = findMe` alias used to sit between them, and while it
// resolved fine for THIS file's own render pass, frank's serializer could
// not chase the alias back to the real `findMe` export when re-extracting
// any of these nested prop factories as a standalone unit (dozens of
// `unresolvable-identifier` findings on `_me`, all latent ReferenceErrors,
// none of them tripped in the app only because nothing here had exercised
// the affected re-extraction path yet). Removed the alias, called `findMe`
// everywhere `_me` used to be. See tickets/fable.md "decompose
// workspace-shell's 507 defects by owning package".
//
// Moved from workspace/components/MemberProfile.js into `shared`
// (2026-08-15) per Nika's ruling on tickets/opus.md ("extract MemberProfile
// into packages/shared … so canvas and the shell both consume ONE
// implementation" — NOT the twelve-fix shared/** grant from the same day).
// findMe/canAdmin/canSuperadmin/canEditProfile/canAccessPrivate/
// isSuperAdmin/getSDK/patchPeopleList/signoutAndRedirect/teams.* all now
// resolve from sibling files in THIS package instead of workspace's —
// see peopleUtils.js, memberProfileAccess.js, sdk.js, signout.js, teams.js.

var $76fm2 = parcelRequire("76fm2");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $e0RDd = parcelRequire("e0RDd");

var $kg2OA = parcelRequire("kg2OA");
// Was workspace/functions/featureFlags.js USE_PROFILES_OVERLAY — a static
// `true` (not a runtime toggle), inlined here rather than dragging the rest
// of that flag catalog (workspace-only, unrelated to MemberProfile) into
// this package. Keep in sync with the workspace copy if it ever flips.
const $f61c5a6dacc263dc$var$USE_PROFILES_OVERLAY = true;
// Map user_profiles column name → profiles column name. Columns absent
// from the map are user_profiles-only (financial) and are not mirrored.
// `department` and `group_name` used to live here; removed with §I10 —
// team membership is now Mongo-backed via `functions/teams.js`.
const $f61c5a6dacc263dc$var$_HR_TO_PROFILES = {
    name: 'display_name',
    position: 'title',
    github: 'github',
    location: 'location',
    timezone: 'timezone',
    weekly_hours: 'weekly_target_hours',
    working_hours_start: 'working_hours_start',
    working_hours_end: 'working_hours_end'
};
// Translate a user_profiles patch to a profiles patch. Returns null if
// no HR fields touched (e.g., pure financial edits) — skip the mirror.
const $f61c5a6dacc263dc$var$_toProfilesPatch = (patch)=>{
    const out = {};
    for (const [k, v] of Object.entries(patch)){
        const mapped = $f61c5a6dacc263dc$var$_HR_TO_PROFILES[k];
        if (!mapped) continue;
        // profiles.weekly_target_hours is numeric; coerce.
        if (mapped === 'weekly_target_hours') {
            const n = Number(String(v ?? '').replace(/[^0-9.]/g, ''));
            out[mapped] = Number.isFinite(n) ? n : null;
        } else out[mapped] = v;
    }
    return Object.keys(out).length ? out : null;
};
const $f61c5a6dacc263dc$var$_numberFmt = new Intl.NumberFormat('en-US');
const $f61c5a6dacc263dc$var$_fmt = (n)=>n == null ? "\u2014" : $f61c5a6dacc263dc$var$_numberFmt.format(n);
const $f61c5a6dacc263dc$var$_timezoneOptions = ()=>{
    try {
        const list = typeof Intl !== 'undefined' && Intl.supportedValuesOf ? Intl.supportedValuesOf('timeZone') : null;
        if (list && list.length) return list;
    } catch  {}
    return [
        'UTC',
        'Europe/London',
        'Europe/Paris',
        'Europe/Berlin',
        'Europe/Moscow',
        'Asia/Tbilisi',
        'Asia/Dubai',
        'Asia/Kolkata',
        'Asia/Shanghai',
        'Asia/Tokyo',
        'Australia/Sydney',
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Los_Angeles',
        'America/Sao_Paulo'
    ];
};
const $f61c5a6dacc263dc$var$_countryOptions = [
    'Georgia',
    'United States',
    'United Kingdom',
    'Germany',
    'France',
    'Spain',
    'Netherlands',
    'Sweden',
    'Norway',
    'Denmark',
    'Poland',
    'Ukraine',
    'Turkey',
    'UAE',
    'India',
    'China',
    'Japan',
    'Australia',
    'Brazil',
    'Canada',
    'Mexico',
    'Argentina',
    'Ireland',
    'Portugal',
    'Italy',
    'Greece',
    'Czech Republic',
    'Hungary',
    'Romania',
    'Bulgaria',
    'Estonia',
    'Latvia',
    'Lithuania'
].sort((a, b)=>a.localeCompare(b));
// Legacy `location` field is a "City, CC" string. Extract country for the
// Country select; everything before the last comma becomes City.
const $f61c5a6dacc263dc$var$_countryCodes = {
    GE: 'Georgia',
    US: 'United States',
    UK: 'United Kingdom',
    GB: 'United Kingdom',
    DE: 'Germany',
    FR: 'France',
    ES: 'Spain',
    NL: 'Netherlands',
    SE: 'Sweden',
    NO: 'Norway',
    DK: 'Denmark',
    PL: 'Poland',
    UA: 'Ukraine',
    TR: 'Turkey',
    AE: 'UAE',
    IN: 'India',
    CN: 'China',
    JP: 'Japan',
    AU: 'Australia',
    BR: 'Brazil',
    CA: 'Canada',
    MX: 'Mexico',
    AR: 'Argentina',
    IE: 'Ireland',
    PT: 'Portugal',
    IT: 'Italy',
    GR: 'Greece',
    CZ: 'Czech Republic',
    HU: 'Hungary',
    RO: 'Romania',
    BG: 'Bulgaria',
    EE: 'Estonia',
    LV: 'Latvia',
    LT: 'Lithuania'
};
const $f61c5a6dacc263dc$var$_countryOf = (person)=>{
    if (person?.country) return person.country;
    const loc = person?.location || '';
    const parts = loc.split(',').map((s)=>s.trim()).filter(Boolean);
    const tail = parts[parts.length - 1] || '';
    if ($f61c5a6dacc263dc$var$_countryCodes[tail.toUpperCase()]) return $f61c5a6dacc263dc$var$_countryCodes[tail.toUpperCase()];
    if ($f61c5a6dacc263dc$var$_countryOptions.includes(tail)) return tail;
    return '';
};
const $f61c5a6dacc263dc$var$_cityOf = (person)=>{
    if (person?.city) return person.city;
    const loc = person?.location || '';
    const parts = loc.split(',').map((s)=>s.trim()).filter(Boolean);
    if (parts.length >= 2) return parts.slice(0, -1).join(', ');
    return '';
};
const $f61c5a6dacc263dc$var$_tenure = (start)=>{
    if (!start) return "\u2014";
    const ms = Date.now() - new Date(start).getTime();
    const totalMonths = Math.floor(ms / 2630016000);
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    if (years === 0) return `${months} month${months !== 1 ? 's' : ''}`;
    if (months === 0) return `${years} year${years !== 1 ? 's' : ''}`;
    return `${years} year${years !== 1 ? 's' : ''} and ${months} month${months !== 1 ? 's' : ''}`;
};
// Debounced Supabase write — per-field timers prevent cross-field cancellation
const $f61c5a6dacc263dc$var$_patchTimers = {};
// Pending patches indexed by field — populated by _patchUser, consumed by _flushPendingPatches.
const $f61c5a6dacc263dc$var$_pendingUserPatches = {};
const $f61c5a6dacc263dc$var$IDENTITY_FIELDS = new Set([
    'name',
    'avatar',
    'timezone',
    'email'
]);
/**
 * Splits outgoing patches into Identity and HR segments,
 * and routes them to their respective API endpoints based
 * on whether the user is editing their own profile or
 * acting as an admin editing someone else's.
 */ const $f61c5a6dacc263dc$var$_writeUserPatch = async (person, patch, isSelf, root)=>{
    const sdk = (0, $1NxyO.getSDK)();
    const identityPatch = {};
    const hrPatch = {};
    let teamPatch = undefined;
    for (const [k, v] of Object.entries(patch)){
        if (k === 'team') teamPatch = v;
        else if ($f61c5a6dacc263dc$var$IDENTITY_FIELDS.has(k)) identityPatch[k] = v;
        else hrPatch[k] = v;
    }
    if (teamPatch !== undefined && root) {
        const orgId = root?.jwtClaims?.workspace_org_id || (root?.jwtClaims?.orgs || [])[0]?.id;
        if (orgId) {
            const current = (0, $kg2OA.personTeams)(person, root).filter((t)=>!t.isSystem)[0];
            if (current && current.orgId === orgId) await (0, $kg2OA.removeMemberFromTeam)(root, {
                orgId: orgId,
                teamId: current.id,
                userId: person.userId,
                email: person.email
            });
            if (teamPatch) {
                const target = (0, $kg2OA.teamsInOrg)(orgId, root).find((t)=>t.name === teamPatch);
                if (target) await (0, $kg2OA.addMemberToTeam)(root, {
                    orgId: orgId,
                    teamId: target.id,
                    userId: person.userId,
                    email: person.email
                });
            }
        }
    }
    // Identity Routing
    if (Object.keys(identityPatch).length > 0) {
        if (isSelf) await sdk.updateUserProfile(identityPatch);
        else await sdk.updateUser(person.userId, identityPatch);
    }
    // HR Routing
    if (Object.keys(hrPatch).length > 0) await sdk.updateUserHrProfile(person.userId, hrPatch);
    // Write to public.profiles when overlay flag is on
    // Update once DB migration to MongoDB is complete
    // legacy Supabase DB is no longer being used
    if ($f61c5a6dacc263dc$var$USE_PROFILES_OVERLAY && person.email) {
        const mapped = $f61c5a6dacc263dc$var$_toProfilesPatch(patch);
        if (mapped) try {
            await sdk.updateUserHrProfile(person.userId, {
                email: person.email,
                ...mapped,
                updated_at: new Date().toISOString()
            });
        } catch (error) {
            console.warn('[MemberProfile] profiles mirror failed', error?.message);
        }
    }
};
const $f61c5a6dacc263dc$var$_patchUser = (el, s, patch)=>{
    const person = (0, $76fm2.findMe)(s);
    if (!person?.userId) return;
    // Check if user is editing their profile
    const isSelf = !!(person.email && s.root?.currentUserEmail === person.email || person.userId && s.root?.currentUserId === person.userId);
    // Sync both directories so stale values don't resurface after navigate. Closes #2218.
    s.root.update({
        people: (0, $76fm2.patchPeopleList)(s.root.people, person.userId, patch),
        peopleAll: (0, $76fm2.patchPeopleList)(s.root.peopleAll, person.userId, patch)
    });
    const field = Object.keys(patch)[0];
    const prevValue = person[field];
    // Stage the patch so _flushPendingPatches can flush it synchronously.
    $f61c5a6dacc263dc$var$_pendingUserPatches[field] = {
        person: person,
        patch: patch,
        isSelf: isSelf,
        root: s.root,
        prevValue: prevValue
    };
    clearTimeout($f61c5a6dacc263dc$var$_patchTimers[field]);
    if (!s.root?._profileEditing) $f61c5a6dacc263dc$var$_patchTimers[field] = setTimeout(async ()=>{
        delete $f61c5a6dacc263dc$var$_pendingUserPatches[field];
        try {
            await $f61c5a6dacc263dc$var$_writeUserPatch(person, patch, isSelf, s.root);
        } catch (e) {
            console.warn('patch failed', e);
            const msg = e.message || String(e);
            if (msg.includes('permission') && el) el.call('openNotification', {
                title: el.call('polyglot', 'account.member.permissionDenied.title'),
                message: el.call('polyglot', 'account.member.permissionDenied.message'),
                type: 'error'
            });
            const revertPatch = {
                [field]: prevValue !== undefined ? prevValue : undefined
            };
            s.root.update({
                people: (0, $76fm2.patchPeopleList)(s.root.people, person.userId, revertPatch),
                peopleAll: (0, $76fm2.patchPeopleList)(s.root.peopleAll, person.userId, revertPatch)
            });
        }
    }, 400);
};
// Flush all pending debounced patches immediately (cancel timers, write now).
const $f61c5a6dacc263dc$var$_flushPendingPatches = async (el)=>{
    const entries = Object.entries($f61c5a6dacc263dc$var$_pendingUserPatches);
    if (!entries.length) return;
    // Cancel all pending debounce timers.
    for (const field of Object.keys($f61c5a6dacc263dc$var$_pendingUserPatches)){
        clearTimeout($f61c5a6dacc263dc$var$_patchTimers[field]);
        delete $f61c5a6dacc263dc$var$_patchTimers[field];
    }
    // Fire all writes concurrently. Each entry is { person, patch, isSelf, root }.
    await Promise.all(entries.map(async ([field, { person: person, patch: patch, isSelf: isSelf, root: root, prevValue: prevValue }])=>{
        delete $f61c5a6dacc263dc$var$_pendingUserPatches[field];
        try {
            await $f61c5a6dacc263dc$var$_writeUserPatch(person, patch, isSelf, root);
        } catch (e) {
            console.warn('[flushPendingPatches] patch failed', e);
            const msg = e.message || String(e);
            if (msg.includes('permission') && el) el.call('openNotification', {
                title: el.call('polyglot', 'account.member.permissionDenied.title'),
                message: el.call('polyglot', 'account.member.permissionDenied.message'),
                type: 'error'
            });
            const revertPatch = {
                [field]: prevValue !== undefined ? prevValue : undefined
            };
            root.update({
                people: (0, $76fm2.patchPeopleList)(root.people, person.userId, revertPatch),
                peopleAll: (0, $76fm2.patchPeopleList)(root.peopleAll, person.userId, revertPatch)
            });
        }
    }));
};
// The read side of a row. A value factory answers the text or an empty
// marker ('' / '—'); an empty value reads "Not set" in the placeholder ink,
// never a bare dash. `valueFn` rides `scope` (a factory parameter read from a
// nested closure does not survive frank serialization — see EditView below).
//
// A row may hand a FIXED text instead (a `{{ }}` template: Security's "Coming
// soon"). It has no value to read and renders as given. Calling it as a
// function emptied both Security rows and threw in the console (live,
// 2026-10-29; memberProfileReadValue.test.js).
const $f61c5a6dacc263dc$var$_isEmptyValue = (v)=>v == null || v === '' || v === "\u2014" || v === '-';
const $f61c5a6dacc263dc$var$_VALUE_TEXT = {
    tag: 'span',
    fontSize: 'A',
    fontWeight: '500',
    textAlign: 'right',
    overflowWrap: 'anywhere',
    minWidth: '0'
};
const $f61c5a6dacc263dc$var$_readValue = (valueFn)=>typeof valueFn !== 'function' ? {
        ...$f61c5a6dacc263dc$var$_VALUE_TEXT,
        color: 'title',
        text: valueFn
    } : {
        ...$f61c5a6dacc263dc$var$_VALUE_TEXT,
        scope: {
            valueFn: valueFn
        },
        color: (el, s)=>$f61c5a6dacc263dc$var$_isEmptyValue(el.scope.valueFn(el, s)) ? 'placeholder' : 'title',
        text: (el, s)=>{
            const v = el.scope.valueFn(el, s);
            return $f61c5a6dacc263dc$var$_isEmptyValue(v) ? el.call('polyglot', 'account.member.notSet') : v;
        }
    };
// Row builder — label/value with optional inline editing.
//
// A definition row: the caption label and its value share a line and the
// line WRAPS when the value is long (a Georgian label, an address), so the
// value drops under its label instead of squeezing it. No hover wash: a
// read row is not a control. Rows sit apart by their own block inset
// (`Z`, was `B`: 66 px per row measured live, 2026-10-28), no stroke.
const $f61c5a6dacc263dc$var$_row = (label, valueFn, opts = {})=>({
        flow: 'x',
        flexWrap: 'wrap',
        align: 'baseline space-between',
        gap: 'X B',
        padding: 'Z 0',
        minWidth: '0',
        hide: opts.hide || null,
        // A row with a hint is a SETTINGS row (Security's Two-factor): its label
        // column takes the room and the value stays on the right, the contract of
        // the password row's label. With no basis the long hint pushed "Coming
        // soon" under itself, to the left (live, 2026-10-29).
        RowLabel: opts.hint ? {
            flow: 'y',
            gap: 'Y',
            flex: '1 1 var(--spacing-E)',
            minWidth: '0',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: label
            },
            Hint: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: opts.hint
            }
        } : {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: label
        },
        // Editable rows render two views side-by-side: a static span shown when
        // not in edit mode, and an input/select shown when editing.
        RowValue: opts.editable ? {
            flow: 'x',
            align: 'center right',
            minWidth: '0',
            ReadView: {
                ...$f61c5a6dacc263dc$var$_readValue(valueFn),
                hide: (el, s)=>!!s.root?._profileEditing && el.call('canEditProfile', (0, $76fm2.findMe)(s))
            },
            EditView: opts.combobox ? {
                extends: 'AppCombobox',
                scope: {
                    valueFn: valueFn,
                    opts: opts,
                    pick (box, value) {
                        const rowOpts = box.scope.opts;
                        if (rowOpts.field) $f61c5a6dacc263dc$var$_patchUser(box, box.state, {
                            [rowOpts.field]: value || null
                        });
                        box.state.update({
                            open: false,
                            query: ''
                        });
                    }
                },
                hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', (0, $76fm2.findMe)(s)),
                width: 'F',
                placeholder: opts.placeholder || '',
                options: (el, s)=>{
                    const list = typeof el.scope.opts.options === 'function' ? el.scope.opts.options() : el.scope.opts.options;
                    return [
                        {
                            value: '',
                            label: el.call('polyglot', 'account.member.select.none')
                        },
                        ...list.map((v)=>({
                                value: v,
                                label: v
                            }))
                    ];
                },
                current: (el, s)=>{
                    const v = el.scope.valueFn(el, s);
                    return v === "\u2014" ? '' : v || '';
                }
            } : opts.options ? {
                // `valueFn` is a factory PARAMETER (a different function per
                // `_row(...)` caller — Country/Timezone below) read from a
                // nested closure (`value`/`onCreate` bodies) rather than being
                // the top-level prop value itself — that's exactly the shape
                // frank's serializer cannot survive (closures don't travel
                // with the emitted function string). Declared here via
                // `scope:` instead so it rides with the element and is read
                // via `el.scope.valueFn` — the framework's own documented fix
                // for this class (`tickets/fable.md` "decompose workspace-
                // shell's 507 defects", `unresolvable-scope-read` on
                // `components.MemberProfile...EditView.{value,onCreate}`).
                //
                // `opts` rides the same way, for the SAME reason — `children`/
                // `onChange` below close over the `_row(...)` factory
                // parameter directly. The gate previously read this as clean
                // (`scope-read-name-collision` false green: an unrelated
                // module's own `opts` key happened to be present in the
                // emitted globalScope, so `__scope.opts` resolved to THAT
                // object instead of throwing) — both Options selects rendered
                // an unrelated widget spec's fields, silently, at any
                // frank-served runtime. Fixed at the source (smbls
                // `20749e2ce`, the gate's false-green fix), not papered over.
                scope: {
                    valueFn: valueFn,
                    opts: opts
                },
                hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', (0, $76fm2.findMe)(s)),
                tag: 'select',
                fontSize: 'A',
                fontWeight: '700',
                color: opts.accent || 'title',
                // The kit's FIELD surface (see the Team select below).
                theme: 'field',
                round: 'radiusControl',
                minHeight: 'controlH',
                padding: '0 A',
                cursor: 'pointer',
                width: 'F',
                // focus: THE global ring only (brand reset.js, §8.2) — the old
                // `:focus` border-swap to blue was a second focus style (F1).
                value: (el, s)=>{
                    const v = el.scope.valueFn(el, s);
                    return v === "\u2014" ? '' : v || '';
                },
                // The `onCreate` that wrote `el.node.value` by hand is GONE. It
                // duplicated the controlled `value:` above, it is a forbidden
                // direct node write, and it only ever ran once — smbls
                // re-asserts a controlled value after every option (re)mount
                // (element/src/create.js syncSelectValue), which is strictly
                // more correct when a `options()` factory resolves late.
                //
                // FA808 / Rule 10 + the same missing-`value` defect as the two
                // notification selects: the inline childExtends declared only
                // `tag` and `text`, so every <option> reported its TEXT as its
                // value. Picking "— none —" therefore stored the literal string
                // '— none —' into the profile field instead of null, and the
                // controlled `value: ''` matched no option at all, so the
                // control rendered BLANK for anyone with no value set.
                // LanguageOption declares `value` (see the DigestSelect note for
                // why that component and not a new one).
                childExtends: 'LanguageOption',
                childrenAs: 'state',
                children: (el, s)=>{
                    const rowOpts = el.scope.opts;
                    const list = typeof rowOpts.options === 'function' ? rowOpts.options() : rowOpts.options;
                    return [
                        {
                            value: '',
                            text: el.call('polyglot', 'account.member.select.none')
                        },
                        ...list.map((v)=>({
                                value: v,
                                text: v
                            }))
                    ];
                },
                onChange: (e, el, s)=>{
                    const rowOpts = el.scope.opts;
                    if (rowOpts.field) $f61c5a6dacc263dc$var$_patchUser(el, s, {
                        [rowOpts.field]: e.target.value || null
                    });
                }
            } : {
                // Same closure-capture fix as the Options branch above —
                // `onInput` closes over the `_row(...)` factory parameter.
                scope: {
                    opts: opts
                },
                hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', (0, $76fm2.findMe)(s)),
                tag: 'input',
                type: opts.type || 'text',
                fontSize: 'A',
                fontWeight: '700',
                color: opts.accent || 'title',
                // The kit's FIELD surface (see the Team select below).
                theme: 'field',
                round: 'radiusControl',
                textAlign: 'right',
                minHeight: 'controlH',
                padding: '0 A',
                width: 'F',
                placeholder: opts.placeholder || '',
                // focus: THE global ring only (brand reset.js, §8.2) — the old
                // `:focus` border-swap to blue was a second focus style (F1).
                value: opts.editValueFn || valueFn,
                onInput: (e, el, s)=>{
                    const rowOpts = el.scope.opts;
                    if (!rowOpts.field) return;
                    const parsed = rowOpts.parse ? rowOpts.parse(e.target.value) : e.target.value;
                    $f61c5a6dacc263dc$var$_patchUser(el, s, {
                        [rowOpts.field]: parsed
                    });
                }
            }
        } : $f61c5a6dacc263dc$var$_readValue(valueFn)
    });
// Card wrapper shorthand — the brand's in-page card (the CommonCard /
// AdminCard surface): the solid `card` theme, `radiusCard`, no stroke.
// It was `radiusSheet` + the `overlay` wash, the overlay-sheet radius on an
// in-page card. One inset for every card on the page (UI symmetry); a phone
// or a narrow slot takes the smaller step, so the 390 px posture keeps 262 px
// of row instead of 212 px (C on both sides measured live, 2026-10-28).
// The measure cap rides the stacks now: a stack is never wider than its
// share of the row, so a label never sits a screen away from its value.
const $f61c5a6dacc263dc$var$_card = (content)=>({
        flow: 'y',
        gap: 'A',
        padding: 'B',
        round: 'radiusCard',
        theme: 'card',
        minWidth: '0',
        '@mobileL': {
            padding: 'A'
        },
        '@appMobile': {
            padding: 'A'
        },
        ...content
    });
// ── Exported component ──
// Server role enums -> bundle keys. See the note at the Role row below.
const $f61c5a6dacc263dc$var$ROLE_KEYS = {
    owner: 'account.member.role.owner',
    'co-owner': 'account.member.role.coOwner',
    superadmin: 'account.member.role.superadmin',
    admin: 'account.member.role.admin',
    manager: 'account.member.role.manager',
    member: 'account.member.role.member',
    editor: 'account.member.role.editor',
    viewer: 'account.member.role.viewer',
    guest: 'account.member.role.guest'
};
// The person's workspace role code: root.roles.byUser (CU-10 §90), the
// legacy `roles` array, then the server's default.
const $f61c5a6dacc263dc$var$_roleOf = (root, person)=>{
    const byUser = root && root.roles && root.roles.byUser || {};
    return person && person.userId && byUser[person.userId] || person?.roles?.[0] || 'member';
};
// An EXPLICIT map, never `'account.member.role.' + role` — a key built by
// concatenation is invisible to grep, to the parity test and to every
// extraction tool (docs/I18N-CONVENTION.md §1.3). A role the server invents
// later passes through polyglot unchanged rather than rendering a raw key.
const $f61c5a6dacc263dc$var$_roleLabelKey = (role)=>$f61c5a6dacc263dc$var$ROLE_KEYS[role] || role || '';
// Access state worth a chip: read-only (inactive) or deactivated (left).
// Active is the normal state and shows no chip.
const $f61c5a6dacc263dc$var$_accessKey = (person)=>{
    const status = person && person.status;
    if (status === 'left') return 'account.member.access.left';
    if (status === 'inactive') return 'account.member.access.inactive';
    return '';
};
// "Position · Team" — the hero's second line. Either half may be missing.
const $f61c5a6dacc263dc$var$_heroRoleLine = (person, root)=>{
    if (!person) return '';
    // The Team row's own reading: the roster's `team` when the row carries one,
    // else the first real team membership.
    const team = person.team !== undefined ? person.team : person.userId || person.email ? (0, $kg2OA.primaryTeamName)(person, root) : null;
    return [
        person.position,
        team
    ].filter((v)=>v && v !== '-').join(" \xb7 ");
};
const $f61c5a6dacc263dc$export$70752ed3eb71b053 = {
    // The page fills its slot (2026-09-03, Nika "content layout adapt to
    // layout - make it full width"): a wrapping row of full-width bands and
    // two-stack bands. The hero and the settings heading take a whole line;
    // each stack pair (ProfileMain + ProfileSide, SettingsMain + SettingsSide)
    // shares a line while the CONTAINER holds H + G + the gap, and stacks
    // one under the other below that — a phone, a narrow pane, the assistant
    // rail open. No viewport query: the flex basis reads the real slot.
    flow: 'x',
    flexWrap: 'wrap',
    // Each stack is as tall as its own cards (`stretch` would pad the
    // shorter stack out to the taller one and draw nothing in it).
    alignItems: 'flex-start',
    gap: 'A',
    width: '100%',
    minWidth: '0',
    ProfileHero: $f61c5a6dacc263dc$var$_card({
        attr: {
            'data-content-section': 'Profile'
        },
        // The identity plate heads the page on its own line. It WRAPS: the
        // avatar, the text and the actions share a line while they fit, and the
        // actions drop under the text on a phone — they sat at x 445..741 in a
        // 390 px window before, outside the screen (live 2026-10-28).
        flex: '1 1 100%',
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        gap: 'B',
        HeroAvatar: {
            align: 'center center',
            // The identity plate of the redesign (DESIGN_SPEC §9 Settings/Account):
            // the fixed `avatarXl` circle (72px — never em, it must not scale with
            // the card's type) on the neutral widget plate, title ink at 500. The
            // `overlayStrong` plate it replaces composited to the window ground in
            // dark — the initials floated with no plate at all (live 2026-09-26).
            boxSize: 'avatarXl',
            minWidth: 'avatarXl',
            round: 'radiusPill',
            color: 'title',
            fontSize: 'C',
            fontWeight: '500',
            // user_profiles table stores the avatar as `avatar` (text). The legacy
            // `avatarUrl` field never existed in the DB — collapse both so Google
            // OAuth avatars (s.avatar = googleusercontent URL) render as images
            // instead of leaking as raw text. Fixes #2245, #2233, #2247.
            background: (el, s)=>{
                const url = (0, $76fm2.findMe)(s).avatarUrl || (0, $76fm2.findMe)(s).avatar;
                return url && /^(https?:|\/)/i.test(url) ? 'transparent' : 'widgetPlate';
            },
            backgroundImage: (el, s)=>{
                const url = (0, $76fm2.findMe)(s).avatarUrl || (0, $76fm2.findMe)(s).avatar;
                return url && /^(https?:|\/)/i.test(url) ? `url(${JSON.stringify(url)})` : 'none';
            },
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            cursor: (el, s)=>el.call('canEditProfile', (0, $76fm2.findMe)(s)) ? 'pointer' : 'default',
            overflow: 'hidden',
            // The reveal keys off THIS element's hover: ChangeOverlay carries
            // pointer-events:none (clicks fall through to the onClick below), so
            // its own :hover can never match — the old overlay-side ':hover' was
            // dead CSS and the "Change" prompt never appeared over photos.
            ':hover .avatar-change-overlay': {
                opacity: '1'
            },
            // Never render the avatar value as text — it's a URL string for Google
            // OAuth users. Show initials only when there is no displayable image.
            text: (el, s)=>{
                const url = (0, $76fm2.findMe)(s).avatarUrl || (0, $76fm2.findMe)(s).avatar;
                if (url && /^(https?:|\/)/i.test(url)) return '';
                // Initials fallback when no image is available — by GRAPHEME and
                // letters only (a UTF-16 `p[0]` split a surrogate pair and kept
                // symbols), two letters, one for a Han / Kana / Hangul name, and
                // never re-cased for Georgian (toUpperCase turns Mkhedruli into
                // Mtavruli capitals).
                const name = (0, $76fm2.findMe)(s).name || (0, $76fm2.findMe)(s).email || '';
                const letters = (w)=>Array.from(String(w)).filter((c)=>/\p{L}/u.test(c));
                const up = (c)=>/[\u10D0-\u10FF]/.test(c) ? c : c.toUpperCase();
                const parts = String(name).trim().split(/\s+/).filter((w)=>letters(w).length);
                const first = parts[0] ? letters(parts[0])[0] : '';
                if (/[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}]/u.test(first)) return first;
                if (parts.length >= 2) return up(first) + up(letters(parts[1])[0]);
                return letters(name).slice(0, 2).map(up).join('');
            },
            onClick: (e, el, s)=>{
                if (!el.call('canEditProfile', (0, $76fm2.findMe)(s))) return;
                const input = el.AvatarUpload?.node;
                if (input) input.click();
            },
            ChangeOverlay: {
                // Hidden when user cannot edit. HOVER-ONLY in BOTH states
                // (2026-09-02 per Nika "fix settings ui"): the old always-on prompt
                // for avatar-less users painted the black.5 scrim + "Upload photo"
                // permanently OVER the initials — two text layers stacked into an
                // illegible blob on the very first screen of Settings. The initials
                // now stay clean; the scrim appears on hover, in both the
                // no-avatar ("Upload photo") and has-avatar ("Change") states —
                // the cursor:pointer on HeroAvatar still advertises the action.
                // The scrim itself stays FIXED black.5/white: it overlays the
                // user's arbitrary uploaded photo (same scrim-over-imagery
                // contract as a lightbox badge).
                hide: (el, s)=>!el.call('canEditProfile', (0, $76fm2.findMe)(s)),
                class: 'avatar-change-overlay',
                position: 'absolute',
                inset: '0',
                align: 'center center',
                background: 'black.5',
                color: 'white',
                fontSize: 'Z',
                fontWeight: '700',
                opacity: '0',
                transition: 'opacity A defaultBezier',
                pointerEvents: 'none',
                text: (el, s)=>{
                    const url = (0, $76fm2.findMe)(s).avatarUrl || (0, $76fm2.findMe)(s).avatar;
                    return el.call('polyglot', url && /^(https?:|\/)/i.test(url) ? 'account.member.avatar.change' : 'account.member.avatar.upload');
                }
            },
            AvatarUpload: {
                tag: 'input',
                type: 'file',
                accept: 'image/png,image/jpeg,image/webp,image/gif,image/svg+xml',
                display: 'none',
                onChange: async (e, el, s)=>{
                    const file = e.target.files?.[0];
                    if (!file) return;
                    try {
                        if (typeof el.sdk?.uploadFile !== 'function') {
                            el.call('openNotification', {
                                type: 'error',
                                title: el.call('polyglot', 'account.member.uploadUnavailable.title'),
                                message: el.call('polyglot', 'account.member.uploadUnavailable.message')
                            });
                            return;
                        }
                        const res = await el.sdk.uploadFile(file);
                        // FileController.formatFileResponse returns { src, urls: { absolute: { publicDownload } } }.
                        // Also handle legacy shapes { url } / { data.url } / { publicUrl } from other environments.
                        const url = res?.src || res?.urls?.absolute?.publicDownload || res?.url || res?.data?.url || res?.publicUrl || (typeof res === 'string' ? res : null);
                        if (!url) throw new Error('Upload returned no URL');
                        $f61c5a6dacc263dc$var$_patchUser(el, s, {
                            avatar: url
                        });
                        // Optimistically reflect it locally so the image updates instantly without a refresh
                        const myEmail = s.root.currentUserEmail;
                        s.root.update({
                            people: (s.root.people || []).map((p)=>p.email === myEmail ? {
                                    ...p,
                                    avatar: url
                                } : p)
                        });
                    } catch (err) {
                        console.warn('[MemberProfile] avatar upload failed', err);
                        el.call('openNotification', {
                            type: 'error',
                            title: el.call('polyglot', 'account.member.upload.failed'),
                            message: err?.message || String(err)
                        });
                    } finally{
                        // Reset so picking the same file twice still fires onChange.
                        if (e.target) e.target.value = '';
                    }
                }
            }
        },
        HeroInfo: {
            flow: 'y',
            gap: 'Y',
            // The text column grows into the free space and may shrink below its
            // longest word: a long name or address wraps inside the card instead
            // of pushing the actions out of it (hero scrollWidth 694 px in a
            // 296 px card at 390, live 2026-10-28).
            flex: '1 1 var(--spacing-G)',
            minWidth: '0',
            HeroName: {
                tag: 'h2',
                fontSize: 'C',
                fontWeight: '700',
                color: 'title',
                letterSpacing: '-0.02em',
                overflowWrap: 'anywhere',
                // Hide until the person record has loaded — avoids the "Unknown"
                // flash that occurs when findMe(s) returns {} before people hydrates.
                hide: (el, s)=>!(0, $76fm2.findMe)(s).name,
                text: (el, s)=>(0, $76fm2.findMe)(s).name || ''
            },
            // Position and primary team on one line: what the person does and
            // where. Either half may be missing; the line hides when both are.
            HeroPosition: {
                tag: 'span',
                fontSize: 'A',
                color: 'paragraph',
                overflowWrap: 'anywhere',
                hide: (el, s)=>!$f61c5a6dacc263dc$var$_heroRoleLine((0, $76fm2.findMe)(s), s.root),
                text: (el, s)=>$f61c5a6dacc263dc$var$_heroRoleLine((0, $76fm2.findMe)(s), s.root)
            },
            HeroMeta: {
                flow: 'x',
                flexWrap: 'wrap',
                align: 'center',
                gap: 'Y Z1',
                padding: 'X 0 0',
                // The workspace role, for every viewer: the People page already
                // shows it on each card. A neutral chip, never a hue (no status).
                HeroRole: {
                    extends: 'AppStatusChip',
                    hide: (el, s)=>!(0, $76fm2.findMe)(s).userId,
                    label: (el, s)=>$f61c5a6dacc263dc$var$_roleLabelKey($f61c5a6dacc263dc$var$_roleOf(s.root, (0, $76fm2.findMe)(s)))
                },
                // Access state, only when it is not the normal one: read-only is a
                // warning, deactivated (left) is a danger. Active shows nothing.
                HeroAccess: {
                    extends: 'AppStatusChip',
                    hide: (el, s)=>!$f61c5a6dacc263dc$var$_accessKey((0, $76fm2.findMe)(s)),
                    status: (el, s)=>(0, $76fm2.findMe)(s).status === 'left' ? 'danger' : 'warning',
                    label: (el, s)=>$f61c5a6dacc263dc$var$_accessKey((0, $76fm2.findMe)(s))
                },
                HeroEmail: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    overflowWrap: 'anywhere',
                    minWidth: '0',
                    // The signed-in email is the fallback for the OWN profile only; it
                    // is read up front so the signal is tracked on every run (FA515).
                    text: (el, s)=>{
                        const ownEmail = s.root.currentUserEmail;
                        return (0, $76fm2.findMe)(s).email || (el.call('isSelf', s) ? ownEmail : '') || '';
                    }
                }
            }
        },
        // The actions share the hero line while they fit and drop under the
        // text on a narrow card. The shared capsule kit owns their geometry and
        // states (Rule 68: no padding, height or type at the call site): the ink
        // capsule for the one primary action, the tonal capsule beside it, the
        // text capsule for Cancel.
        HeroActions: {
            // Show when the current user can edit the profile (self / admin)
            // OR when viewing someone else's profile (to show the Message button).
            hide: (el, s)=>{
                const canEdit = el.call('canEditProfile', (0, $76fm2.findMe)(s));
                const isSelfView = el.call('isSelf', s);
                return !canEdit && isSelfView;
            },
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Z',
            align: 'center',
            MessageBtn: {
                extends: 'AppCapsuleBtnPrimary',
                // Only show when viewing someone else's profile.
                hide: (el, s)=>el.call('isSelf', s),
                text: (el)=>el.call('polyglot', 'account.member.action.message'),
                onClick: (e, el, s)=>{
                    const email = (0, $76fm2.findMe)(s).email;
                    if (!email) return;
                    const root = s.root;
                    root.update({
                        _pendingDmEmail: email
                    });
                    const rootEl = el.getRoot();
                    el.router('/chat', rootEl);
                }
            },
            EditBtn: {
                extends: 'AppCapsuleBtnToolbar',
                // The fields it opens live on the profile, never on /settings.
                hide: (el, s)=>{
                    const editing = !!s.root?._profileEditing;
                    const view = el.call('memberProfileView', s);
                    return editing || view === 'settings' || !el.call('canEditProfile', (0, $76fm2.findMe)(s));
                },
                text: (el)=>el.call('polyglot', 'account.member.action.edit'),
                onClick: (e, el, s)=>s.root.update({
                        _profileEditing: true,
                        _profileBackup: JSON.stringify((0, $76fm2.findMe)(s))
                    })
            },
            // The switch between the two views of your own page (stage 3,
            // memberProfileAccess.js memberProfileView): the profile offers your
            // settings, the settings offer your profile. It opens the way the
            // avatar menu opens Settings (accountMenu.js openAccountPage): inside a
            // pane, that pane. Hidden while an edit is open (Cancel and Save own
            // the row then), and where the host serves no such route (canvas
            // serves /settings only). Every signal is read up front (FA515).
            SettingsBtn: {
                extends: 'AppCapsuleBtnToolbar',
                hide: (el, s)=>{
                    const editing = !!s.root?._profileEditing;
                    const view = el.call('memberProfileView', s);
                    const pages = el.context && el.context.pages || {};
                    return editing || view === 'settings' || !el.call('isSelf', s) || !pages['/settings'];
                },
                text: (el)=>el.call('polyglot', 'account.member.action.settings'),
                onClick: (e, el)=>el.call('openAccountPage', '/settings')
            },
            ViewProfileBtn: {
                extends: 'AppCapsuleBtnToolbar',
                hide: (el, s)=>{
                    const view = el.call('memberProfileView', s);
                    const pages = el.context && el.context.pages || {};
                    return view !== 'settings' || !pages['/profile'];
                },
                text: (el)=>el.call('polyglot', 'account.member.action.viewProfile'),
                onClick: (e, el)=>el.call('openAccountPage', '/profile')
            },
            CancelBtn: {
                extends: 'AppCapsuleBtnGhost',
                hide: (el, s)=>!s.root?._profileEditing,
                text: (el)=>el.call('polyglot', 'account.member.action.cancel'),
                onClick: (e, el, s)=>{
                    if (s.root._profileBackup) {
                        const original = JSON.parse(s.root._profileBackup);
                        s.root.update({
                            people: (s.root.people || []).map((p)=>p.userId === original.userId ? original : p),
                            peopleAll: (s.root.peopleAll || []).map((p)=>p.userId === original.userId ? original : p)
                        });
                    }
                    for (const field of Object.keys($f61c5a6dacc263dc$var$_pendingUserPatches)){
                        clearTimeout($f61c5a6dacc263dc$var$_patchTimers[field]);
                        delete $f61c5a6dacc263dc$var$_patchTimers[field];
                        delete $f61c5a6dacc263dc$var$_pendingUserPatches[field];
                    }
                    s.root.update({
                        _profileEditing: false
                    });
                }
            },
            SaveBtn: {
                extends: 'AppCapsuleBtnPrimary',
                hide: (el, s)=>!s.root?._profileEditing,
                // Busy = the real disabled attribute (the kit's `field-disabled`
                // step), never a faded opacity; the label stack keeps the width of
                // the longer label so the capsule does not resize (Rule 66).
                disabled: (el, s)=>!!s.root?._profileSaving,
                'aria-busy': (el, s)=>!!s.root?._profileSaving,
                AppLabelStack: {
                    labels: [
                        'account.member.team.save',
                        'account.member.team.saving'
                    ],
                    shown: (el, s)=>s.root?._profileSaving ? 1 : 0
                },
                onClick: async (e, el, s)=>{
                    if (s.root?._profileSaving) return;
                    s.root.update({
                        _profileSaving: true
                    });
                    try {
                        await $f61c5a6dacc263dc$var$_flushPendingPatches(el);
                    } finally{
                        s.root.update({
                            _profileSaving: false,
                            _profileEditing: false
                        });
                    }
                }
            }
        }
    }),
    // ── The profile: two stacks, not one auto-fit grid ──
    // The 2026-09-03 auto-fit grid paired unrelated cards in one row, so the
    // shorter card left a hole as tall as the difference (live 2026-10-28,
    // 1920 window: Details 912 px beside Documents 254 px = a 658 px hole).
    // Two flex stacks share the row instead: the wide one holds the reading
    // cards, the narrow one the private side cards. Each stack is as tall as
    // its own cards. The row wraps on the CONTAINER width (H + G + gap), so a
    // narrow slot or a phone gets one stack under the other with no media
    // query, and the wide stack never stretches a row past its measure.
    ProfileMain: {
        // The profile view only — /settings shows the settings stacks below.
        hide: (el, s)=>el.call('memberProfileView', s) === 'settings',
        flow: 'y',
        gap: 'A',
        flex: '2 1 var(--spacing-H)',
        minWidth: '0',
        ProfileDetails: $f61c5a6dacc263dc$var$_card({
            attr: {
                'data-content-section': 'Details'
            },
            DetailsTitle: {
                extends: 'AppMicroLabel',
                text: '{{ account.profile.sections.details | polyglot }}'
            },
            FullName: $f61c5a6dacc263dc$var$_row('{{ account.member.field.fullName | polyglot }}', (el, s)=>(0, $76fm2.findMe)(s).name || "\u2014", {
                editable: true,
                field: 'name',
                placeholder: (el)=>el.call('polyglot', 'account.member.placeholder.name')
            }),
            Position: $f61c5a6dacc263dc$var$_row('{{ account.member.field.position | polyglot }}', (el, s)=>(0, $76fm2.findMe)(s).position || "\u2014", {
                editable: true,
                field: 'position',
                placeholder: (el)=>el.call('polyglot', 'account.member.placeholder.position'),
                editValueFn: (el, s)=>(0, $76fm2.findMe)(s).position || ''
            }),
            // Team picker — reads from `root.teamsByEmail` (Mongo-sourced via
            // `functions/teams.js`). Writes go through SDK (add/remove Team
            // members). No user_profiles text fallback — legacy columns dropped.
            Team: {
                // The `_row()` shape, inline — this row has a bespoke team picker.
                flow: 'x',
                flexWrap: 'wrap',
                align: 'baseline space-between',
                gap: 'X B',
                padding: 'Z 0',
                minWidth: '0',
                RowLabel: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: '{{ account.member.field.team | polyglot }}'
                },
                RowValue: {
                    flow: 'x',
                    align: 'center right',
                    gap: 'Z',
                    minWidth: '0',
                    ReadView: {
                        ...$f61c5a6dacc263dc$var$_readValue((el, s)=>{
                            const me = (0, $76fm2.findMe)(s);
                            if (me.team !== undefined) return me.team || '';
                            return (0, $kg2OA.primaryTeamName)(me, s.root) || '';
                        }),
                        hide: (el, s)=>!!s.root?._profileEditing && el.call('canEditProfile', (0, $76fm2.findMe)(s))
                    },
                    EditSelect: {
                        hide: (el, s)=>!s.root?._profileEditing || !el.call('canEditProfile', (0, $76fm2.findMe)(s)),
                        tag: 'select',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        // The kit's FIELD surface (its own fill + hover/focus steps, no
                        // hairline edge — the borderless law); was `dialog` + a hairline.
                        theme: 'field',
                        round: 'radiusControl',
                        minHeight: 'controlH',
                        padding: '0 A',
                        cursor: 'pointer',
                        minWidth: 'F',
                        value: (el, s)=>{
                            const me = (0, $76fm2.findMe)(s);
                            if (me.team !== undefined) return me.team || '';
                            return (0, $kg2OA.primaryTeamName)(me, s.root) || '';
                        },
                        // FA808 / Rule 10 — the inline `childExtends: {…}` object cannot be
                        // carried by frank's serializer, so the published build rendered an
                        // option-less select. This one already declared `value`, so unlike
                        // its neighbours it stored the right code; the shape is otherwise
                        // identical to LanguageOption, which is why that component is reused
                        // here too (see the DigestSelect note).
                        childExtends: 'LanguageOption',
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const orgId = s.root?.jwtClaims?.workspace_org_id || (s.root?.jwtClaims?.orgs || [])[0]?.id;
                            const list = (0, $kg2OA.teamsInOrg)(orgId, s.root);
                            return [
                                {
                                    value: '',
                                    text: el.call('polyglot', 'account.member.select.none')
                                },
                                ...list.map((t)=>({
                                        value: t.name,
                                        text: t.name
                                    })),
                                {
                                    value: '__create__',
                                    text: el.call('polyglot', 'account.member.team.create')
                                }
                            ];
                        },
                        onChange: async (e, el, s)=>{
                            const me = (0, $76fm2.findMe)(s);
                            if (!me?.userId || !me?.email) return;
                            const root = s.root;
                            const orgId = root?.jwtClaims?.workspace_org_id || (root?.jwtClaims?.orgs || [])[0]?.id;
                            if (!orgId) return;
                            let value = e.target.value;
                            if (value === '__create__') {
                                const name = typeof window !== 'undefined' ? window.prompt(el.call('polyglot', 'account.member.team.newPrompt')) : null;
                                const currentName = me.team !== undefined ? me.team : (0, $kg2OA.primaryTeamName)(me, root);
                                if (!name) {
                                    if (el.node) el.node.value = currentName || '';
                                    return;
                                }
                                try {
                                    const team = await (0, $kg2OA.createTeam)(root, {
                                        orgId: orgId,
                                        name: name.trim()
                                    });
                                    value = team.name;
                                } catch (err) {
                                    console.warn('Team creation failed', err);
                                    if (el.node) el.node.value = currentName || '';
                                    return;
                                }
                            }
                            $f61c5a6dacc263dc$var$_patchUser(el, s, {
                                team: value
                            });
                            if (el.node) {
                                el.node.value = value || '';
                                typeof window !== 'undefined' && window.requestAnimationFrame(()=>{
                                    if (el.node) el.node.value = value || '';
                                });
                            }
                        }
                    }
                }
            },
            Country: $f61c5a6dacc263dc$var$_row('{{ account.member.field.country | polyglot }}', (el, s)=>$f61c5a6dacc263dc$var$_countryOf((0, $76fm2.findMe)(s)) || "\u2014", {
                editable: true,
                field: 'country',
                combobox: true,
                placeholder: (el)=>el.call('polyglot', 'account.member.field.country'),
                options: $f61c5a6dacc263dc$var$_countryOptions
            }),
            City: $f61c5a6dacc263dc$var$_row('{{ account.member.field.city | polyglot }}', (el, s)=>$f61c5a6dacc263dc$var$_cityOf((0, $76fm2.findMe)(s)) || "\u2014", {
                editable: true,
                field: 'city',
                placeholder: (el)=>el.call('polyglot', 'account.member.placeholder.city'),
                editValueFn: (el, s)=>$f61c5a6dacc263dc$var$_cityOf((0, $76fm2.findMe)(s)) || ''
            }),
            Timezone: $f61c5a6dacc263dc$var$_row('{{ account.member.field.timezone | polyglot }}', (el, s)=>(0, $76fm2.findMe)(s).timezone || "\u2014", {
                editable: true,
                field: 'timezone',
                combobox: true,
                placeholder: (el)=>el.call('polyglot', 'account.member.field.timezone'),
                options: $f61c5a6dacc263dc$var$_timezoneOptions
            }),
            GitHub: $f61c5a6dacc263dc$var$_row('{{ account.member.field.github | polyglot }}', (el, s)=>(0, $76fm2.findMe)(s).github || el.call('isSelf', s) && s.root?.user?.profile?.github || "\u2014", {
                editable: true,
                field: 'github',
                placeholder: (el)=>el.call('polyglot', 'account.member.placeholder.github'),
                editValueFn: (el, s)=>(0, $76fm2.findMe)(s).github || el.call('isSelf', s) && s.root?.user?.profile?.github || ''
            }),
            // Account-plane row (INVITE-ONBOARDING-USERNAME-NOT-ORG-1): the platform
            // username lives on the USER record (sdk.updateMe), not the roster doc
            // `_patchUser` writes — hand-rolled instead of `opts.field` so the save
            // routes to the right plane. Self-edit only; saves on change (blur/
            // Enter), never per keystroke — a half-typed handle must not land.
            Username: {
                flow: 'x',
                flexWrap: 'wrap',
                align: 'baseline space-between',
                gap: 'X B',
                padding: 'Z 0',
                minWidth: '0',
                RowLabel: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: '{{ account.member.field.username | polyglot }}'
                },
                RowValue: {
                    flow: 'x',
                    align: 'center right',
                    minWidth: '0',
                    ReadView: {
                        // The signed-in user's own handle is the fallback for the OWN
                        // profile only. On another member's profile it printed the
                        // VIEWER's username (qa.employee read `nikoloza`, live
                        // 2026-10-28): the viewed person's record has no username field.
                        ...$f61c5a6dacc263dc$var$_readValue((el, s)=>(0, $76fm2.findMe)(s).username || (el.call('isSelf', s) ? s.root?.currentUserUsername : '') || ''),
                        hide: (el, s)=>!!s.root?._profileEditing && (0, $76fm2.findMe)(s)?.email === s.root?.currentUserEmail
                    },
                    EditView: {
                        hide: (el, s)=>!s.root?._profileEditing || (0, $76fm2.findMe)(s)?.email !== s.root?.currentUserEmail,
                        tag: 'input',
                        type: 'text',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        // The kit's FIELD surface (its own fill + hover/focus steps, no
                        // hairline edge — the borderless law); was `dialog` + a hairline.
                        theme: 'field',
                        round: 'radiusControl',
                        textAlign: 'right',
                        minHeight: 'controlH',
                        padding: '0 A',
                        width: 'F',
                        placeholder: (el)=>el.call('polyglot', 'account.member.placeholder.github'),
                        maxlength: 39,
                        value: (el, s)=>(0, $76fm2.findMe)(s).username || s.root?.currentUserUsername || '',
                        onChange: async (e, el, s)=>{
                            const next = String(e.target?.value || '').trim().toLowerCase();
                            const current = s.root?.currentUserUsername || '';
                            if (!next || next === current) return;
                            try {
                                await el.sdk.updateMe({
                                    username: next
                                });
                                s.root?.update({
                                    currentUserUsername: next
                                });
                            } catch (err) {
                                console.warn('[MemberProfile] username update failed:', err?.message || err);
                                if (el.node) el.node.value = current;
                            }
                        }
                    }
                }
            },
            Tenure: $f61c5a6dacc263dc$var$_row('{{ account.member.field.tenure | polyglot }}', (el, s)=>$f61c5a6dacc263dc$var$_tenure((0, $76fm2.findMe)(s).startDate)),
            Role: $f61c5a6dacc263dc$var$_row('{{ account.member.field.role | polyglot }}', (el, s)=>{
                // CU-10 §90: roles no longer on person. Look up from root.roles.byUser.
                const me = (0, $76fm2.findMe)(s);
                const userId = me?.userId;
                const byUser = s.root?.roles?.byUser || {};
                const role = userId && byUser[userId] || me?.roles?.[0] || 'member';
                // An EXPLICIT map, never `'account.member.role.' + role` — a key built
                // by concatenation is invisible to grep, to the parity test and to
                // every extraction tool (docs/I18N-CONVENTION.md §1.3). A role the
                // server invents later falls through polyglot unchanged rather than
                // rendering a raw key.
                return el.call('polyglot', $f61c5a6dacc263dc$var$ROLE_KEYS[role] || role);
            }, {
                hide: (el)=>!el.call('isSuperAdmin')
            })
        }),
        ProfileAvailability: {
            ...$f61c5a6dacc263dc$var$_card({}),
            attr: {
                'data-content-section': 'Availability'
            },
            // THE CARD'S OWN LOADING MARK (stage 3): the account id whose
            // availability has come back. The card said "No availability set" and
            // painted an empty grid until its data arrived, then switched to the
            // real schedule (live 2026-10-28). Until the mark matches the viewed
            // person, the summary is a skeleton line, the grid is busy and inert,
            // and Reset / Select all wait: a click there saved a grid built from
            // nothing over the stored one. A name the root never owns, so a read
            // never falls through to a root key.
            state: {
                _availFor: ''
            },
            scope: {
                // Loading: the viewed person has an account id and this card's load
                // for that id has not come back yet. The children read it through
                // their inherited scope.
                availLoading (s) {
                    const id = (0, $76fm2.findMe)(s).userId;
                    return !!id && s._availFor !== id;
                }
            },
            // Everyone on the team, the owner included — one rule with the
            // section rails (memberProfileAccess.js showsAvailability).
            hide: (el, s)=>!el.call('showsAvailability', (0, $76fm2.findMe)(s), s.root),
            // Pull the viewed person's server-side AvailabilityRule into root.people
            // so the grid + summary show persisted data (registered via the calendar
            // eager slice folded into the shell context). Once per person; the mark
            // lands when THAT load settles, found or not (a host without the
            // calendar slice answers undefined, which settles at once). The card
            // may show someone else by then: only the person it asked for counts.
            onRender: (el, s)=>{
                const person = (0, $76fm2.findMe)(s);
                const id = person && person.userId;
                if (!id || el._hydrated === id) return;
                el._hydrated = id;
                const done = ()=>{
                    if (el._hydrated === id && el.state) el.state.update({
                        _availFor: id
                    });
                };
                Promise.resolve(el.call('hydratePersonAvailability', s.root, person)).then(done, done);
            },
            AvailHeader: {
                flow: 'x',
                // WRAPS: at 390 px the two buttons squeezed the title to one letter
                // per line (212 x 287 px, live 2026-10-28). The buttons drop under
                // the title when the line is short.
                flexWrap: 'wrap',
                gap: 'Z A',
                align: 'center space-between',
                // Section heads are the mono micro-label (DESIGN_SPEC §5.7).
                AvailTitle: {
                    extends: 'AppMicroLabel',
                    text: '{{ account.member.availability.title | polyglot }}'
                },
                AvailActions: {
                    flow: 'x',
                    gap: 'A',
                    AvailReset: {
                        // The tonal capsule of the kit, compact in a card head (Rule 68:
                        // the kit owns the height and inset).
                        extends: 'AppCapsuleBtnToolbar',
                        compact: true,
                        disabled: (el, s)=>el.scope.availLoading(s),
                        text: (el)=>el.call('polyglot', 'account.member.availability.reset'),
                        hide: (el, s)=>{
                            if (!s.root?.currentUserEmail) return true;
                            return !(el.call('isSelf', s) || el.call('canAdmin', s));
                        },
                        onClick: (e, el, s)=>{
                            const root = s.root || el.state?.root;
                            const user = el.call('findMe', s);
                            if (!user) return;
                            const emptyGrid = Array.from({
                                length: 7
                            }, ()=>Array.from({
                                    length: 24
                                }, ()=>false));
                            const next = (root.people || []).map((p)=>p.email === user.email ? {
                                    ...p,
                                    availabilityGrid: emptyGrid
                                } : p);
                            root.update({
                                people: next
                            });
                            el.call('saveAvailabilityGrid', root, user, emptyGrid);
                        }
                    },
                    AvailSelectAll: {
                        // The tonal capsule of the kit, compact in a card head (Rule 68:
                        // the kit owns the height and inset).
                        extends: 'AppCapsuleBtnToolbar',
                        compact: true,
                        disabled: (el, s)=>el.scope.availLoading(s),
                        text: (el)=>el.call('polyglot', 'account.member.availability.selectAll'),
                        hide: (el, s)=>{
                            if (!s.root?.currentUserEmail) return true;
                            return !(el.call('isSelf', s) || el.call('canAdmin', s));
                        },
                        onClick: (e, el, s)=>{
                            const root = s.root || el.state?.root;
                            const user = el.call('findMe', s);
                            if (!user) return;
                            // Flip all cells in grid to on
                            const fullGrid = Array.from({
                                length: 7
                            }, ()=>Array.from({
                                    length: 24
                                }, ()=>true));
                            const next = (root.people || []).map((p)=>p.email === user.email ? {
                                    ...p,
                                    availabilityGrid: fullGrid
                                } : p);
                            root.update({
                                people: next
                            });
                            el.call('saveAvailabilityGrid', root, user, fullGrid);
                        }
                    }
                }
            },
            // Schedule-derived, tz-honest one-liner — the read-only availability view
            // when looking at another member ("Available now · until 18:00 · …").
            AvailSummary: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'paragraph',
                hide: (el, s)=>el.scope.availLoading(s),
                text: (el, s)=>el.call('availabilitySummaryText', (0, $76fm2.findMe)(s))
            },
            // The summary's place while the data is on its way: one skeleton line
            // of the summary's own height, so the swap moves nothing (Rule 66),
            // read out as loading. The bare key reuses the shared SkeletonRow.
            SkeletonRow: {
                width: '60%',
                height: 'A2',
                role: 'status',
                aria: {
                    label: (el)=>el.call('polyglot', 'common.state.loading')
                },
                hide: (el, s)=>!el.scope.availLoading(s)
            },
            // Busy and inert until the data arrives: no pointer, no keyboard, and
            // the cells lose their hue (an all-red grid read as "never available").
            ProfileAvailabilityGrid: {
                aria: {
                    busy: (el, s)=>el.scope.availLoading(s) ? 'true' : null
                },
                inert: (el, s)=>el.scope.availLoading(s) ? '' : null,
                '&[aria-busy="true"]': {
                    filter: 'grayscale(1)',
                    animation: 'pulse 1.5s ease-in-out infinite',
                    '@media (prefers-reduced-motion: reduce)': {
                        animation: 'none'
                    }
                }
            }
        }
    },
    ProfileSide: {
        flow: 'y',
        gap: 'A',
        flex: '1 1 var(--spacing-G)',
        minWidth: '0',
        // Empty stack = no column: every side card is private (self or a holder
        // of profile.private.read) or the superadmin access card on someone
        // else's profile. A hidden stack lets the main stack take the row.
        // The profile view only, like its partner stack.
        hide: (el, s)=>{
            const settings = el.call('memberProfileView', s) === 'settings';
            return settings || !el.call('canAccessPrivate', (0, $76fm2.findMe)(s)) && (el.call('isSelf', s) || !el.call('canSuperadmin', s));
        },
        ProfileChecklist: {
            ...$f61c5a6dacc263dc$var$_card({}),
            attr: {
                'data-content-section': 'Checklist'
            },
            hide: (el, s)=>!el.call('canAccessPrivate', (0, $76fm2.findMe)(s)),
            CheckHead: {
                flow: 'y',
                gap: 'Z',
                // The label reads in neutral ink (orange as small-text ink measured
                // 2.4:1 on the light stage); the hue stays on the status dots.
                CheckEyebrow: {
                    extends: 'AppMicroLabel',
                    text: '{{ account.profile.sections.checklist | polyglot }}'
                }
            },
            CheckList: {
                flow: 'y',
                gap: 'Y',
                childExtends: 'MemberProfileCheckItem',
                childrenAs: 'state',
                children: (el, s)=>{
                    const p = (0, $76fm2.findMe)(s);
                    // This is the general account checklist. Employment documents,
                    // equity and developer accounts are not universal requirements;
                    // actual documents and equity already have their own sections.
                    return [
                        {
                            label: 'account.member.checklist.location',
                            done: !!(p.location && p.timezone)
                        },
                        {
                            label: 'account.member.checklist.availability',
                            done: !!p.workingDays
                        }
                    ];
                }
            }
        },
        ProfileDocuments: {
            ...$f61c5a6dacc263dc$var$_card({}),
            attr: {
                'data-content-section': 'Documents'
            },
            hide: (el, s)=>!el.call('canAccessPrivate', (0, $76fm2.findMe)(s)),
            DocHead: {
                flow: 'y',
                gap: 'Z',
                DocEyebrow: {
                    extends: 'AppMicroLabel',
                    text: '{{ account.member.documents.title | polyglot }}'
                }
            },
            // The OWN documents only. `docs.userDocs.list` is scoped to the CALLER
            // on the server, and `root.userDocs` holds the caller's documents too,
            // so on another member's profile both printed the VIEWER's signed
            // documents under that member's name. Until the server can list a
            // named member's documents for a `profile.private.read` holder, another
            // member's card shows the empty state instead of the wrong person's
            // files.
            DocList: {
                flow: 'y',
                gap: 'X',
                childExtends: 'MemberProfileDocRow',
                childrenAs: 'state',
                children: (el, s)=>(el.call('isSelf', s) ? s.root?.userDocs || [] : []).map((d)=>({
                            id: d.id,
                            title: d.title,
                            size: d.file_size ? Math.round(d.file_size / 1024) : null,
                            signedAt: d.signed_at || '',
                            storagePath: d.storage_path
                        }))
            },
            // The empty state — a sentence in caption ink, not a fake document row.
            DocEmpty: {
                tag: 'p',
                hide: (el, s)=>el.call('isSelf', s) && (s.root?.userDocs || []).length > 0,
                fontSize: 'Z2',
                color: 'caption',
                text: (el)=>el.call('polyglot', 'account.member.documents.empty')
            }
        }
    },
    // ── Settings: the owner's own preferences, on their own page ──
    // /settings (stage 3, memberProfileAccess.js memberProfileView): same
    // two-stack shape as the profile above, and the page's own title names it,
    // so no heading sits inside. The view is the owner's only (another
    // member's page is always the profile). The cards are assigned below
    // (MemberProfile.SettingsMain.X = …); the shared page mounts the Mail card
    // at the end of SettingsMain.
    SettingsMain: {
        hide: (el, s)=>el.call('memberProfileView', s) !== 'settings',
        flow: 'y',
        gap: 'A',
        flex: '2 1 var(--spacing-H)',
        minWidth: '0'
    },
    SettingsSide: {
        hide: (el, s)=>el.call('memberProfileView', s) !== 'settings',
        flow: 'y',
        gap: 'A',
        flex: '1 1 var(--spacing-G)',
        minWidth: '0'
    }
};
const $f61c5a6dacc263dc$var$_selfCard = (content)=>({
        ...$f61c5a6dacc263dc$var$_card(content),
        hide: (el)=>!el.call('isSelf')
    });
// THE one write funnel for this page's preferences (digest, mentions,
// birthday reminders, notification sound).
//
// It also REPAIRS legacy rows for the two enum keys. Until the notification
// selects declared a real `value` on their options, an <option> reported its
// TEXT as its value, so `e.target.value` was the capitalised LABEL and this
// function persisted 'Daily' / 'Realtime' instead of 'daily' / 'realtime'.
// (smbls documents the same trap at element/src/create.js — "the browser fell
// back to the option's TEXT as its value".)
//
// Every legal code is exactly the lowercase of its own label, because the
// labels were GENERATED from the codes by `v.charAt(0).toUpperCase() +
// v.slice(1)`. So `toLowerCase()` is the exact inverse of the bug, not a
// guess. Normalising the MERGED object — not only the patch — means any write
// through this funnel repairs both keys at once: a person who never touches
// the digest select still converges the moment they flip the birthday toggle.
// The read side (the selects' `scope.current`) is tolerant meanwhile, so a
// legacy row shows the right option immediately, before any write happens.
//
// Safe by construction: nothing outside this file compares these values.
// PrefsService round-trips the whole object through a Mongo `Mixed` subdoc
// (server core/models/UserPreference.js) and no digest/notification consumer
// reads them, so lowercasing is idempotent on correct rows and repairs broken
// ones.
const $f61c5a6dacc263dc$var$_savePrefs = async (root, patch)=>{
    if (!root?.currentUserId) return;
    const prefs = {
        ...root.userPrefs || {},
        ...patch,
        user_id: root.currentUserId
    };
    for (const key of [
        'email_digest',
        'mention_notifications'
    ])if (typeof prefs[key] === 'string') prefs[key] = prefs[key].toLowerCase();
    root.update({
        userPrefs: prefs
    });
    try {
        await (0, $1NxyO.getSDK)().execute('workspaceProject.userPreferences', 'update', {
            payload: prefs
        });
    } catch (e) {
        console.warn('prefs save failed', e);
    }
};
// ── Accessibility (self only) ──
//
// The same four choices the public site offers (company/packages/landing —
// its panel is the reference), on the surface a signed-in person actually
// reaches (2026-09-04 per Nika "add same accessibility options as we have in
// landing also in workspace settings").
//
// PER PERSON, on this device, exactly like the theme — not a workspace-wide
// admin default. (The interface LANGUAGE is the opposite: since 2026-09-10 it
// is the workspace's own setting, and this page carries no control for it.) An admin forcing reduced motion or high
// contrast on everyone would be the opposite of an accessibility feature; the
// choice belongs to the person who needs it. `_selfCard` gates it the same
// way, because this page also renders OTHER people's profiles.
//
// Every row writes through ONE function, `setA11yPref`
// (shared/functions/a11yPrefs.js), which validates the key, persists the whole
// set and updates root state; the shell mirrors the result onto <html> and its
// injected sheet carries the rules. So this card is chrome only — nothing here
// knows what "high contrast" does, which is what keeps the site and the app
// from drifting apart.
//
// Labels take the FUNCTION form, like every other card on this page: a
// `{{ key | polyglot }}` template renders EMPTY under canvas, which registers
// no `context.polyglot` (see LanguageSelectField.js's note).
$f61c5a6dacc263dc$export$70752ed3eb71b053.SettingsMain.ProfileAccessibility = $f61c5a6dacc263dc$var$_selfCard({
    attr: {
        'data-content-section': 'Accessibility'
    },
    gap: 'B',
    AccessibilityTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: (el)=>el.call('polyglot', 'account.member.a11y.title')
    },
    AccessibilityHint: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        text: (el)=>el.call('polyglot', 'account.member.a11y.hint')
    },
    AccessibilityRows: {
        flow: 'y',
        // TYPE SCALE — three chips, not a switch: it is one choice among three,
        // and a person needs to see which step they are on. `aria-pressed` on
        // each, so a screen reader announces the state rather than the glyph.
        FontScale: {
            extends: 'MemberProfileA11yRow',
            RowLabel: {
                LabelText: {
                    text: (el)=>el.call('polyglot', 'account.member.a11y.fontSize')
                },
                Hint: {
                    text: (el)=>el.call('polyglot', 'account.member.a11y.fontSizeHint')
                }
            },
            Control: {
                flow: 'x',
                gap: 'Y',
                flexShrink: '0',
                // The row recipe's own `Control.SwitchInput` is inherited here and has
                // to be retired explicitly: this row is three chips, not a switch.
                // Without the tombstone it rendered a FOURTH control — and, because
                // `childExtends` applies to every child of Control, the leftover
                // switch was ALSO extended into a chip, so it painted an empty
                // `aria-pressed="true"` button beside the three real ones (measured
                // live 2026-09-04: 4 buttons, 4 switches, one with no label).
                SwitchInput: null,
                childExtends: 'MemberProfileA11yChip',
                // Each chip NAMES its own step. All three carried the row's name
                // ("Text size") over the same visible "A", so a screen reader heard one
                // sentence three times and only `aria-pressed` differed.
                Smaller: {
                    scope: {
                        pref: 'sm',
                        labelKey: 'account.member.a11y.fontSizeSmall'
                    },
                    text: 'A',
                    fontSize: 'Z1'
                },
                Normal: {
                    scope: {
                        pref: 'md',
                        labelKey: 'account.member.a11y.fontSizeNormal'
                    },
                    text: 'A',
                    fontSize: 'A'
                },
                Larger: {
                    scope: {
                        pref: 'lg',
                        labelKey: 'account.member.a11y.fontSizeLarge'
                    },
                    text: 'A',
                    fontSize: 'B'
                }
            }
        },
        Contrast: {
            extends: 'MemberProfileA11yRow',
            scope: {
                key: 'a11yContrast',
                labelKey: 'account.member.a11y.contrast',
                hintKey: 'account.member.a11y.contrastHint'
            },
            Control: {
                SwitchInput: {}
            }
        },
        Motion: {
            extends: 'MemberProfileA11yRow',
            scope: {
                key: 'a11yMotion',
                labelKey: 'account.member.a11y.motion',
                hintKey: 'account.member.a11y.motionHint'
            },
            Control: {
                SwitchInput: {}
            }
        },
        Links: {
            extends: 'MemberProfileA11yRow',
            scope: {
                key: 'a11yLinks',
                labelKey: 'account.member.a11y.links',
                hintKey: 'account.member.a11y.linksHint'
            },
            Control: {
                SwitchInput: {}
            }
        },
        // SINGLE-KEY SHORTCUTS — the off switch WCAG 2.1.4 asks for
        // (HOME_AMBIENT_SKIN_SPEC §5, DESIGN-WL-SHELL-KEYBOARD-MOTION-1): keys
        // like `/`, `?`, `J`, `G then H` run commands when focus is not in a
        // field; a speech or switch user can turn them off, and the chords
        // (⌘K and the like) stay. ON by default.
        //
        // Unlike the four rows above (device-local, `setA11yPref`) this is the
        // person's ACCOUNT preference — `user_preferences.shortcutsSingleKeys`
        // (root.userPrefs), which the shortcut registry reads — so it follows
        // them to every device. The write spreads the current row, because the
        // record's `update` REPLACES it (themeMode.js / navbarTabMenu.js carry
        // the same contract); the Reset row below leaves it alone (it resets
        // this device's four).
        SingleKeys: {
            extends: 'MemberProfileA11yRow',
            scope: {
                key: 'shortcutsSingleKeys',
                labelKey: 'account.member.a11y.singleKeys',
                hintKey: 'account.member.a11y.singleKeysHint',
                singleKeysOn (root) {
                    const prefs = root && root.userPrefs;
                    return !(prefs && typeof prefs === 'object' && prefs.shortcutsSingleKeys === false);
                },
                async saveSingleKeys (el, root, on) {
                    if (!root || typeof root.update !== 'function') return;
                    const prev = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : {};
                    const next = {
                        ...prev,
                        shortcutsSingleKeys: !!on
                    };
                    root.update({
                        userPrefs: next
                    }, {
                        preventFetch: true
                    });
                    const sdk = el && el.sdk;
                    if (!sdk || typeof sdk.execute !== 'function') return;
                    try {
                        await sdk.execute('workspaceProject.userPreferences', 'update', {
                            payload: next
                        });
                    } catch (err) {
                        // Roll the switch back: the record did not take it.
                        root.update({
                            userPrefs: prev
                        }, {
                            preventFetch: true
                        });
                        console.warn('[MemberProfile] shortcutsSingleKeys save failed', err);
                    }
                }
            },
            Control: {
                SwitchInput: {
                    onCheck: (el, s)=>el.parent.parent.scope.singleKeysOn(s.root),
                    onClick: (e, el, s)=>{
                        const row = el.parent.parent;
                        return row.scope.saveSingleKeys(el, s.root, !row.scope.singleKeysOn(s.root));
                    }
                }
            }
        }
    },
    // Stays mounted and only hides (Rule 66), so the row cannot flicker in and
    // out of the card's flow as the last preference returns to its default.
    ResetRow: {
        flow: 'x',
        align: 'center left',
        paddingTop: 'B',
        hide: (el, s)=>el.call('a11yPrefsAreDefault', s.root),
        ResetBtn: {
            tag: 'button',
            type: 'button',
            padding: 'Y A',
            minHeight: 'controlHCompact',
            '@coarse': {
                minHeight: 'controlH'
            },
            round: 'radiusControl',
            borderWidth: '0',
            background: 'overlayStrong',
            color: 'title',
            fontSize: 'Z1',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'A defaultBezier filter',
            ':hover': {
                filter: 'brightness(0.96)'
            },
            text: (el)=>el.call('polyglot', 'account.member.a11y.reset'),
            onClick: (e, el, s)=>el.call('resetA11yPrefs', s.root)
        }
    }
});
const $f61c5a6dacc263dc$export$ec0c9d788be664cb = {
    scope: {
        key: '',
        labelKey: '',
        hintKey: ''
    },
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    padding: 'B 0',
    RowLabel: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        LabelText: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el)=>el.scope.labelKey ? el.call('polyglot', el.scope.labelKey) : ''
        },
        Hint: {
            tag: 'span',
            fontSize: 'Z2',
            lineHeight: '1.4',
            color: 'caption',
            text: (el)=>el.scope.hintKey ? el.call('polyglot', el.scope.hintKey) : ''
        }
    },
    Control: {
        flow: 'x',
        align: 'center right',
        flexShrink: '0',
        SwitchInput: {
            attr: {
                'aria-label': (el)=>el.scope.labelKey ? el.call('polyglot', el.scope.labelKey) : null
            },
            onCheck: (el, s)=>!!s.root[el.parent.parent.scope.key],
            onClick: (e, el, s)=>{
                const key = el.parent.parent.scope.key;
                el.call('setA11yPref', s.root, key, !s.root[key]);
            }
        }
    }
};
const $f61c5a6dacc263dc$export$6c1453e44d8b037f = {
    tag: 'button',
    type: 'button',
    scope: {
        pref: 'md',
        labelKey: 'account.member.a11y.fontSize'
    },
    attr: {
        'aria-pressed': (el, s)=>s.root.a11yFontScale === el.scope.pref ? 'true' : 'false'
    },
    aria: {
        label: (el)=>el.call('polyglot', el.scope.labelKey)
    },
    boxSize: 'C C',
    '@coarse': {
        minWidth: 'controlH',
        minHeight: 'controlH'
    },
    flow: 'x',
    align: 'center center',
    round: 'radiusControl',
    borderWidth: '0',
    cursor: 'pointer',
    fontWeight: '700',
    lineHeight: '1',
    // The house selected pair: the ink capsule when active, the control surface
    // at rest — the same ramp the marketplace filter chips use.
    background: (el, s)=>s.root.a11yFontScale === el.scope.pref ? 'highlight' : 'overlayStrong',
    color: (el, s)=>s.root.a11yFontScale === el.scope.pref ? 'highlight-reversed' : 'title',
    transition: 'A defaultBezier filter',
    ':hover': {
        filter: 'brightness(0.96)'
    },
    onClick: (e, el, s)=>el.call('setA11yPref', s.root, 'a11yFontScale', el.scope.pref)
};
// ── Assistant (self only) — the default ANSWER MODE ──
// ASSISTANT_BOARD_MODE_SPEC §1 (WS-W2-ASSISTANT-PAGE-MODE-DOCK-1): where the
// assistant's answers go — Page (a generated board on the home), Sidebar,
// Minimized. The SAME choice the assistant's settings panel carries (one
// writer, the shell's `setAssistantAnswersMode`: persisted per user, the last
// mode remembered), here where a person looks for their defaults. Hidden
// wherever the shell's writer is absent (another app mounting this page).
// Page is a PLACEMENT (the main thread, the default — Nika's pick 6 A): it
// needs no board service, so the card shows whether or not the generated-
// board service answers. The row wraps: the choice drops
// under its label on a narrow card rather than pushing out of it.
$f61c5a6dacc263dc$export$70752ed3eb71b053.SettingsMain.ProfileAssistant = {
    ...$f61c5a6dacc263dc$var$_card({
        attr: {
            'data-content-section': 'Assistant'
        },
        gap: 'B',
        AssistantTitle: {
            tag: 'h2',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: (el)=>el.call('polyglot', 'account.member.assistant.title')
        },
        AnswersRow: {
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center space-between',
            gap: 'A',
            padding: 'B 0',
            RowLabel: {
                flow: 'y',
                gap: 'Y',
                flex: '1 1 auto',
                minWidth: '0',
                LabelText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el)=>el.call('polyglot', 'account.member.assistant.answers')
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Z2',
                    lineHeight: '1.4',
                    color: 'caption',
                    overflowWrap: 'anywhere',
                    text: (el)=>el.call('polyglot', 'account.member.assistant.answersHint')
                }
            },
            AppSegmented: {
                variant: 'choice',
                compact: true,
                ariaLabel: (el)=>el.call('polyglot', 'account.member.assistant.answers'),
                current: (el, s)=>{
                    const dock = s.root && s.root.assistantDock;
                    return dock === 'main' ? 'page' : dock === 'minimized' ? 'minimized' : 'sidebar';
                },
                select: 'setAssistantAnswersMode',
                childrenAs: 'state',
                children: ()=>[
                        {
                            key: 'page',
                            text: 'ai.answers.page',
                            value: 'page'
                        },
                        {
                            key: 'sidebar',
                            text: 'ai.answers.sidebar',
                            value: 'sidebar'
                        },
                        {
                            key: 'minimized',
                            text: 'ai.answers.minimized',
                            value: 'minimized'
                        }
                    ]
            }
        }
    }),
    subscribeTo: [
        'assistantDock'
    ],
    hide: (el)=>!el.call('isSelf') || typeof (el.context && el.context.functions && el.context.functions.setAssistantAnswersMode) !== 'function'
};
// ── Security (self only) ──
$f61c5a6dacc263dc$export$70752ed3eb71b053.SettingsSide.ProfileSecurity = $f61c5a6dacc263dc$var$_selfCard({
    attr: {
        'data-content-section': 'Security'
    },
    gap: 'B',
    SecurityTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: '{{ account.member.security.title | polyglot }}'
    },
    SecurityRows: {
        flow: 'y',
        PwdRow: {
            // The label and its hint take their own line and the field sits under
            // them (stage 3): beside the field the hint wrapped to three lines in
            // the side stack on a 1920 px window.
            flow: 'y',
            gap: 'Z',
            padding: 'B 0',
            RowLabel: {
                flow: 'y',
                gap: 'Y',
                minWidth: '0',
                LabelText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: '{{ account.member.security.password | polyglot }}'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: '{{ account.member.security.passwordHint | polyglot }}'
                }
            },
            // The field takes the line and the FIELD gives way on a phone: field
            // and button kept 301 px in a 262 px card (live 390 px frame,
            // 2026-10-29; memberProfileNarrowRows.test.js). The button keeps its
            // width. Where the field would be shorter than F beside it, the button
            // wraps under the field: the field kept 99 px at 390 px and 128 px in
            // the 1440 px side stack (live 2026-10-29).
            PwdAction: {
                flow: 'x',
                flexWrap: 'wrap',
                gap: 'Z',
                align: 'center',
                minWidth: '0',
                PwdInput: {
                    tag: 'input',
                    type: 'password',
                    placeholder: (el)=>el.call('polyglot', 'account.member.placeholder.newPassword'),
                    fontSize: 'Z2',
                    theme: 'field',
                    minHeight: 'controlH',
                    padding: '0 A',
                    round: 'radiusControl',
                    color: 'title',
                    flex: '1 1 var(--spacing-F)',
                    minWidth: '0'
                },
                // The kit's ink capsule (Rule 68: the kit owns its height, inset and
                // states — it was a hand-made capsule with a hover and no pressed
                // step). The label stack keeps the width of the longest of its three
                // words, so "Updated" never resizes it (Rule 66).
                PwdBtn: {
                    extends: 'AppCapsuleBtnPrimary',
                    flexShrink: '0',
                    AppLabelStack: {
                        labels: [
                            'account.member.security.update',
                            'account.member.security.updated',
                            'account.member.security.updateFailed'
                        ],
                        shown: (el, s)=>s._pwdStatus === 'account.member.security.updated' ? 1 : s._pwdStatus === 'account.member.security.updateFailed' ? 2 : 0
                    },
                    onClick: async (e, el, s)=>{
                        const input = el.parent.PwdInput?.node;
                        const pw = input?.value;
                        if (!pw || pw.length < 6) return;
                        try {
                            // TODO[password-update]: SDK updateMe currently routes profile
                            // edits — confirm server-side handles password rotation via this
                            // path; if a dedicated flow is required, replace with that call.
                            await el.sdk.updateMe({
                                password: pw
                            });
                            input.value = '';
                            el.state.update({
                                _pwdStatus: 'account.member.security.updated'
                            });
                            setTimeout(()=>el.state.update({
                                    _pwdStatus: null
                                }), 2000);
                        } catch (err) {
                            el.state.update({
                                _pwdStatus: 'account.member.security.updateFailed'
                            });
                            setTimeout(()=>el.state.update({
                                    _pwdStatus: null
                                }), 2000);
                        }
                    }
                }
            }
        },
        TwoFa: $f61c5a6dacc263dc$var$_row('{{ account.member.security.twoFa | polyglot }}', '{{ common.state.coming_soon | polyglot }}', {
            hint: '{{ account.member.security.twoFaHint | polyglot }}'
        }),
        BackupCodes: $f61c5a6dacc263dc$var$_row('{{ account.member.security.backupCodes | polyglot }}', '{{ common.state.coming_soon | polyglot }}', {})
    }
});
// ── Notifications (self only) ──
$f61c5a6dacc263dc$export$70752ed3eb71b053.SettingsMain.ProfileNotifications = $f61c5a6dacc263dc$var$_selfCard({
    attr: {
        'data-content-section': 'Notifications'
    },
    gap: 'B',
    NotifTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: '{{ account.member.notifications.title | polyglot }}'
    },
    NotifRows: {
        flow: 'y',
        EmailDigest: {
            flow: 'x',
            align: 'center space-between',
            padding: 'B 0',
            RowLabel: {
                flow: 'y',
                gap: 'Y',
                LabelText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: '{{ account.member.notifications.digest | polyglot }}'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: '{{ account.member.notifications.digestHint | polyglot }}'
                }
            },
            // The stored preference is a lowercase CODE ('off' | 'daily' |
            // 'weekly'); the label is derived from it, never stored.
            //
            // This row used to declare `childExtends: { tag: 'option', text }` with
            // `selected: v === cur` on each item. `childrenAs: 'state'` makes each
            // item the child's STATE, and the inline childExtends declared only
            // `tag` and `text` — so neither `value` nor `selected` ever reached the
            // DOM, and BOTH halves of the control were wrong: the select always
            // showed the first option, and `e.target.value` returned the option's
            // TEXT ('Daily'), which `_savePrefs` persisted as the preference.
            //
            // `value:` (controlled) is the form that survives, not `<option
            // selected>`: a native <select> ignores declarative selectedness when
            // its options arrive through `childrenAs`, and smbls re-asserts a
            // controlled `value` after every option (re)mount
            // (element/src/create.js syncSelectValue). `selected:` on the items is
            // gone — with a controlled value syncSelectValue never consults
            // defaultSelected at all, so it was dead weight that read as working.
            DigestSelect: {
                tag: 'select',
                theme: 'field',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusControl',
                color: 'title',
                fontSize: 'Z2',
                cursor: 'pointer',
                // The visible RowLabel is not associated with this control by
                // `for`/`id`, so a screen reader would otherwise announce an unnamed
                // combo box. Same fix as InterfaceLanguageSelect two cards up.
                'aria-label': (el)=>el.call('polyglot', 'account.member.notifications.digestAria'),
                // FA204 — the code list travels ON the element, so no serialized
                // handler reads a bare module-scope binding (this file has been bitten
                // by exactly that: see the `scope-read-name-collision` note on the
                // profile Options select above).
                //
                // `current` is the LEGACY-TOLERANT read. Rows written before this fix
                // hold the label ('Off' / 'Daily' / 'Weekly'); lowercasing maps each
                // one back to its own code, because the labels were generated FROM
                // the codes. A value that is not a known code at all falls back to
                // the default rather than leaving the control blank — `node.value =
                // <no matching option>` sets selectedIndex to -1 and shows nothing.
                scope: {
                    CODES: [
                        'off',
                        'daily',
                        'weekly'
                    ],
                    DEFAULT: 'daily',
                    current (stored) {
                        const code = String(stored == null ? '' : stored).toLowerCase();
                        return this.CODES.indexOf(code) === -1 ? this.DEFAULT : code;
                    }
                },
                // FA808 / Rule 10 — a NAMED component, never an inline
                // `childExtends: {…}` object: frank's serializer cannot carry the
                // inline form, so the published build renders an option-less select.
                // LanguageOption (components/LanguageSelectField.js) is the platform's
                // `{ value, text }` <option> and holds no language-specific logic, so
                // Rule 63 says reuse it rather than mint a fourth near-identical
                // option component beside AppOption and IntegrationScopeOption. Its
                // NAME is the only thing domain-specific about it; that should
                // collapse to a neutral one when LanguageSelectField.js is next open.
                childExtends: 'LanguageOption',
                childrenAs: 'state',
                children: (el)=>el.scope.CODES.map((v)=>({
                            value: v,
                            text: v.charAt(0).toUpperCase() + v.slice(1)
                        })),
                // FA515 — `s.root.userPrefs` is read UNCONDITIONALLY so the signal is
                // tracked. `userPrefs` boots as null and lands later from
                // loadPrivateData; a `s.root?.userPrefs` guard short-circuits on that
                // first run, never subscribes, and the control then freezes on the
                // default forever.
                value: (el, s)=>el.scope.current(s.root.userPrefs?.email_digest),
                onChange: (e, el, s)=>$f61c5a6dacc263dc$var$_savePrefs(s.root, {
                        email_digest: e.target.value
                    })
            }
        },
        Mentions: {
            flow: 'x',
            align: 'center space-between',
            padding: 'B 0',
            RowLabel: {
                flow: 'y',
                gap: 'Y',
                LabelText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: '{{ account.member.notifications.mentions | polyglot }}'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: '{{ account.member.notifications.mentionsHint | polyglot }}'
                }
            },
            // Identical shape and identical defect to DigestSelect above — see the
            // full note there. Codes: 'off' | 'realtime' | 'daily'.
            //
            // The label expression here used to special-case `v === 'realtime' ?
            // 'Realtime' : capitalise(v)`. That ternary was a no-op — capitalising
            // 'realtime' already yields 'Realtime' — so it is gone; one rule now
            // produces every label, which is also what makes `toLowerCase()` an
            // exact inverse for the legacy rows.
            MentionSelect: {
                tag: 'select',
                theme: 'field',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusControl',
                color: 'title',
                fontSize: 'Z2',
                cursor: 'pointer',
                'aria-label': (el)=>el.call('polyglot', 'account.member.notifications.mentionsAria'),
                scope: {
                    CODES: [
                        'off',
                        'realtime',
                        'daily'
                    ],
                    DEFAULT: 'realtime',
                    current (stored) {
                        const code = String(stored == null ? '' : stored).toLowerCase();
                        return this.CODES.indexOf(code) === -1 ? this.DEFAULT : code;
                    }
                },
                childExtends: 'LanguageOption',
                childrenAs: 'state',
                children: (el)=>el.scope.CODES.map((v)=>({
                            value: v,
                            text: v.charAt(0).toUpperCase() + v.slice(1)
                        })),
                value: (el, s)=>el.scope.current(s.root.userPrefs?.mention_notifications),
                onChange: (e, el, s)=>$f61c5a6dacc263dc$var$_savePrefs(s.root, {
                        mention_notifications: e.target.value
                    })
            }
        },
        Birthdays: {
            flow: 'x',
            align: 'center space-between',
            padding: 'B 0',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ account.member.notifications.birthdays | polyglot }}'
            },
            BirthdayToggle: {
                tag: 'button',
                minHeight: 'controlHCompact',
                padding: '0 Z',
                round: 'radiusPill',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '700',
                // §4.3 selection wash + title ink — the old white-on-green state chip
                // measured 2.81:1 (needs 4.5; AA walk 2026-08-08). Hue never marks
                // selection; the On/Off label carries the state.
                background: (el, s)=>s.root?.userPrefs?.birthday_reminders !== false ? 'selected' : 'overlay',
                color: (el, s)=>s.root?.userPrefs?.birthday_reminders !== false ? 'title' : 'caption',
                text: (el, s)=>el.call('polyglot', s.root?.userPrefs?.birthday_reminders !== false ? 'account.member.toggle.on' : 'account.member.toggle.off'),
                onClick: (e, el, s)=>{
                    const cur = s.root?.userPrefs?.birthday_reminders !== false;
                    $f61c5a6dacc263dc$var$_savePrefs(s.root, {
                        birthday_reminders: !cur
                    });
                }
            }
        },
        // Gates the chime openNotification's `sound: true` toasts play
        // (shared/functions/notifySound.js reads this same key). Default ON,
        // same idiom as Birthdays above — the terminal row now, so no bottom
        // border.
        NotifSound: {
            flow: 'x',
            align: 'center space-between',
            padding: 'B 0',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ account.member.notifications.sound | polyglot }}'
            },
            NotifSoundToggle: {
                tag: 'button',
                minHeight: 'controlHCompact',
                padding: '0 Z',
                round: 'radiusPill',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '700',
                // §4.3 selection wash + title ink (same AA fix as BirthdayToggle).
                background: (el, s)=>s.root?.userPrefs?.notification_sound !== false ? 'selected' : 'overlay',
                color: (el, s)=>s.root?.userPrefs?.notification_sound !== false ? 'title' : 'caption',
                text: (el, s)=>el.call('polyglot', s.root?.userPrefs?.notification_sound !== false ? 'account.member.toggle.on' : 'account.member.toggle.off'),
                onClick: (e, el, s)=>{
                    const cur = s.root?.userPrefs?.notification_sound !== false;
                    $f61c5a6dacc263dc$var$_savePrefs(s.root, {
                        notification_sound: !cur
                    });
                }
            }
        }
    }
});
// ── Sessions (self only) ──
$f61c5a6dacc263dc$export$70752ed3eb71b053.SettingsSide.ProfileSessions = $f61c5a6dacc263dc$var$_selfCard({
    attr: {
        'data-content-section': 'Sessions'
    },
    gap: 'A',
    SessTitle: {
        tag: 'h2',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: '{{ account.member.session.title | polyglot }}'
    },
    SessionInfo: {
        flow: 'y',
        gap: 'Z',
        padding: 'Z 0',
        Browser: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z 0',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ account.member.session.browser | polyglot }}'
            },
            RowValue: {
                tag: 'span',
                fontSize: 'A',
                color: 'paragraph',
                text: (el)=>{
                    if (typeof navigator === 'undefined') return "\u2014";
                    const ua = navigator.userAgent;
                    if (ua.includes('Chrome')) return 'Chrome';
                    if (ua.includes('Firefox')) return 'Firefox';
                    if (ua.includes('Safari')) return 'Safari';
                    return 'Unknown';
                }
            }
        },
        Platform: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z 0',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ account.member.session.platform | polyglot }}'
            },
            RowValue: {
                tag: 'span',
                fontSize: 'A',
                color: 'paragraph',
                text: (el)=>{
                    if (typeof navigator === 'undefined') return "\u2014";
                    const p = navigator.platform || '';
                    if (p.includes('Mac')) return 'macOS';
                    if (p.includes('Win')) return 'Windows';
                    if (p.includes('Linux')) return 'Linux';
                    return p || 'Unknown';
                }
            }
        },
        SignedIn: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z 0',
            RowLabel: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ account.member.session.status | polyglot }}'
            },
            // Status hue as a DOT + neutral ink (wave-1 RoleDot grammar) — green as
            // small-text ink measured 2.48:1 on the light stage (needs 4.5).
            RowValue: {
                tag: 'span',
                flow: 'x',
                align: 'center',
                gap: 'Y',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                StatusDot: {
                    tag: 'span',
                    width: 'Y',
                    height: 'Y',
                    round: '50%',
                    flex: '0 0 auto',
                    background: 'green'
                },
                StatusText: {
                    tag: 'span',
                    text: '{{ account.member.session.activeNow | polyglot }}'
                }
            }
        }
    }
});
// ── Danger zone (self only) ──
$f61c5a6dacc263dc$export$70752ed3eb71b053.SettingsSide.ProfileDanger = {
    ...$f61c5a6dacc263dc$var$_card({}),
    attr: {
        'data-content-section': 'Danger zone'
    },
    hide: (el)=>!el.call('isSelf'),
    // ONE BUTTON COLUMN (current-2a, 2026-09-26: "one shared width for the
    // three buttons = the widest label of the three in the active language,
    // armed labels included, so the right edge stays even; keep 44px"). The
    // card is a two-track grid — the labels, then an `auto` track the three
    // buttons share. Each button's own width is its widest label (the label
    // stack below), the `auto` track is the widest of the three, and every
    // button stretches to it. The rows are `display: contents`, so their label
    // and button land in the card's tracks while each row keeps its own state.
    // (`_card` makes the card a flex column; the grid replaces that.)
    flow: null,
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    alignItems: 'center',
    columnGap: 'A',
    rowGap: 'B',
    // A phone has no room for two tracks: one column, the buttons full width
    // (equal by construction), each under its own label.
    '@mobileL': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        rowGap: 'Z'
    },
    // KEPT — the ONE card in this file with a visible edge: a semantic danger
    // accent (not the row/card separation habit `_card` used to carry). §4.2
    // danger role via `redInk` (adaptive [#B93A24, red]) — brand red as ink
    // measured 2.82:1 on the light stage (title needs 3.0, the buttons 4.5;
    // AA walk 2026-08-08). redInk holds ≥5.0:1 light / ≥5.7:1 dark.
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'redInk',
    DangerTitle: {
        tag: 'h2',
        gridColumn: '1 / -1',
        fontSize: 'B',
        fontWeight: '700',
        color: 'redInk',
        text: '{{ account.member.danger.title | polyglot }}'
    },
    DangerHint: {
        tag: 'p',
        gridColumn: '1 / -1',
        fontSize: 'Z2',
        color: 'caption',
        text: '{{ account.member.danger.hint | polyglot }}'
    },
    // THE ROWS. Each ARMS on the first click and acts on the second, and each
    // OWNS its armed flag: with no `state` of their own the rows shared one
    // `_confirming` on an ancestor, so arming Sign out armed Deactivate too (the
    // defect /admin/danger fixed on 2026-09-24). The second half of a
    // double-click is NOT a confirm (a click with `detail > 1` is dropped):
    // arming and acting are two gestures. Keyboard activation (`detail` 0)
    // still works. The control is the kit's destructive capsule (the
    // `dangerInk` pair on a wash of that ink); armed deepens the wash through a
    // flat `dataArmed` hook and a static selector — not a reactive `background`
    // (that paints inline, over :hover / :active) and not a solid red slab
    // (DESIGN_LANGUAGE §4.2: danger is ink on a tint).
    //
    // THE LABEL STACK (Rule 66): every label a button can show sits in ONE grid
    // cell — the kit's `AppLabelStack` (D2 e0c4487f7, which replaced the three
    // stacks this card built by hand) — and only the `shown` one is visible,
    // so each capsule is as wide as its LONGEST label in the active language
    // from the first paint and arming never resizes it. A fixed `minWidth`
    // could not do this: "Confirm deactivation?" measures 202 px in English and
    // 294 px in Georgian (TBC Contractica Medium at Z2, + the capsule's inset).
    // A label under `visibility: hidden` is out of the accessible name. The
    // stack sizes each button; the card's shared `auto` track (above) makes
    // the three one width.
    SignOutRow: {
        state: {
            _confirming: false
        },
        // The row's own box goes (the card's grid places its label and button);
        // its state stays. No row hover wash: a row is not a control.
        display: 'contents',
        RowLabel: {
            flow: 'y',
            gap: 'Y',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ account.member.danger.signOut | polyglot }}'
            },
            Hint: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: '{{ account.member.danger.signOutHint | polyglot }}'
            }
        },
        SignOutBtn: {
            extends: 'AppCapsuleBtnDanger',
            // Fills the shared button track (the widest label of the three).
            justifySelf: 'stretch',
            flexShrink: '0',
            dataArmed: (el, s)=>!!s._confirming,
            '&[data-armed]': {
                background: 'color-mix(in srgb, currentColor 20%, var(--color-tintBase))'
            },
            AppLabelStack: {
                labels: [
                    'account.member.danger.signOutBtn',
                    'account.member.danger.signOutConfirm'
                ],
                shown: (el, s)=>s._confirming ? 1 : 0
            },
            onClick: async (e, el, s)=>{
                if (e.detail > 1) return;
                if (!s._confirming) {
                    el.state.update({
                        _confirming: true
                    });
                    setTimeout(()=>el.state.update({
                            _confirming: false
                        }), 3000);
                    return;
                }
                await (0, $e0RDd.signoutAndRedirect)({
                    sdk: el.sdk
                });
            }
        }
    },
    DeactivateRow: {
        state: {
            _confirming: false
        },
        display: 'contents',
        RowLabel: {
            flow: 'y',
            gap: 'Y',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ account.member.danger.deactivate | polyglot }}'
            },
            Hint: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: '{{ account.member.danger.deactivateHint | polyglot }}'
            }
        },
        DeactivateBtn: {
            extends: 'AppCapsuleBtnDanger',
            // Fills the shared button track (the widest label of the three).
            justifySelf: 'stretch',
            flexShrink: '0',
            dataArmed: (el, s)=>!!s._confirming,
            '&[data-armed]': {
                background: 'color-mix(in srgb, currentColor 20%, var(--color-tintBase))'
            },
            AppLabelStack: {
                labels: [
                    'account.member.danger.deactivateBtn',
                    'account.member.danger.deactivateConfirm'
                ],
                shown: (el, s)=>s._confirming ? 1 : 0
            },
            onClick: async (e, el, s)=>{
                if (e.detail > 1) return;
                if (!s._confirming) {
                    el.state.update({
                        _confirming: true
                    });
                    setTimeout(()=>el.state.update({
                            _confirming: false
                        }), 3000);
                    return;
                }
                try {
                    await el.sdk.execute('workspaceProject.userProfiles', 'update', {
                        id: s.root.currentUserId,
                        payload: {
                            status: 'left'
                        }
                    });
                    await (0, $e0RDd.signoutAndRedirect)({
                        sdk: el.sdk
                    });
                } catch (err) {
                    console.warn('deactivate failed', err);
                }
            }
        }
    },
    // DELETE ORGANIZATION — moved here from the workspace switcher (Q10 A, Nika
    // 2026-09-26: a destructive org action does not belong in the menu people
    // open to switch). Same gate as the switcher row it replaces: the OWNER of
    // the active org (the server's DELETE /organizations/:id is owner-only
    // too). Same confirm step: arm, then act; the arm lapses after 4 s.
    // Never a PERSONAL org: it goes with its account (MODEL.md invariant 1),
    // and the server answers 400 `personal_org_undeletable` (2026-10-28). The
    // row checked the role only before, so the owner of a personal org was
    // offered the delete.
    DeleteOrgRow: {
        state: {
            _confirming: false,
            _busy: false
        },
        scope: {
            // The org this row deletes: the SETTLED active org — `root.org`, the
            // /auth/me OrgMember row — matched in the membership list for its
            // role. Stricter than the switcher's display resolver ON PURPOSE: no
            // `orgs[0]` fallback, and nothing while a switch is in flight
            // (`_pendingActiveOrgId`) — a destructive action never guesses its
            // target.
            //
            // A PERSONAL org is no target. The type is read the way the shell
            // reads it elsewhere (inviteRoles.js, workspaceRename.js): the
            // membership row, and the active org row with the same id. Either one
            // saying `personal` is enough, and the name never decides.
            targetOrg (root) {
                if (!root || root._pendingActiveOrgId) return null;
                const org = root.org;
                const id = org && (org.id || org._id);
                if (!id) return null;
                const list = Array.isArray(root.orgs) ? root.orgs : [];
                const row = list.find((o)=>o && o.id === id) || null;
                if (!row || row.type === 'personal' || org.type === 'personal') return null;
                return row;
            },
            // What a refused delete says. The SDK throws the server's English
            // message with the JSON body on `cause` (BaseService._request), or
            // resolves `{ ok: false, error }` for a refusal it reads off a 2xx
            // body. A personal org reads in plain words, in the page language.
            failureText (el, err) {
                const body = err && err.cause || err || {};
                if (body.error === 'personal_org_undeletable') return el.call('polyglot', 'account.member.danger.personalOrgUndeletable');
                return err && (err.message || err.error) || String(err);
            }
        },
        hide: (el, s)=>{
            const org = el.scope.targetOrg(s.root);
            return !(org && org.role === 'owner');
        },
        display: 'contents',
        RowLabel: {
            flow: 'y',
            gap: 'Y',
            minWidth: '0',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el)=>el.call('polyglot', 'shell.orgSwitcher.deleteOrg')
            },
            // The TARGET, by name: the row never offers to delete "this
            // organization" without saying which one.
            OrgName: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>{
                    const org = el.scope.targetOrg(s.root);
                    return org && org.name || '';
                }
            }
        },
        DeleteOrgBtn: {
            extends: 'AppCapsuleBtnDanger',
            // Fills the shared button track (the widest label of the three).
            justifySelf: 'stretch',
            // Its own store for the disarm timer; `targetOrg` still resolves up the
            // scope chain from the row.
            scope: {
                disarm: null
            },
            flexShrink: '0',
            dataArmed: (el, s)=>!!s._confirming,
            '&[data-armed]': {
                background: 'color-mix(in srgb, currentColor 20%, var(--color-tintBase))'
            },
            disabled: (el, s)=>!!s._busy,
            AppLabelStack: {
                labels: [
                    'common.action.delete',
                    'shell.orgSwitcher.deleteConfirm',
                    'shell.orgSwitcher.deleting'
                ],
                shown: (el, s)=>s._busy ? 2 : s._confirming ? 1 : 0
            },
            onClick: async (e, el, s)=>{
                if (e.detail > 1) return;
                if (s._busy) return;
                if (!s._confirming) {
                    el.state.update({
                        _confirming: true
                    });
                    clearTimeout(el.scope.disarm);
                    el.scope.disarm = setTimeout(()=>el.state.update({
                            _confirming: false
                        }), 4000);
                    return;
                }
                clearTimeout(el.scope.disarm);
                const org = el.scope.targetOrg(s.root);
                if (!org || org.role !== 'owner') {
                    el.state.update({
                        _confirming: false
                    });
                    return;
                }
                el.state.update({
                    _confirming: false,
                    _busy: true
                });
                const fail = (err)=>{
                    console.warn('[MemberProfile] deleteOrganization failed', err?.message || err?.error || err);
                    el.state.update({
                        _busy: false
                    });
                    el.call('openNotification', {
                        title: el.call('polyglot', 'shell.orgSwitcher.deleteFailed'),
                        message: el.scope.failureText(el, err),
                        type: 'error'
                    });
                };
                let res;
                try {
                    res = await el.sdk.deleteOrganization(org.id);
                } catch (err) {
                    fail(err);
                    return;
                }
                // A refusal the SDK RESOLVES keeps the org: before this check it
                // left the membership list as if it were deleted.
                if (res && res.ok === false) {
                    fail(res);
                    return;
                }
                // As the switcher row did (#2276): the org leaves the membership
                // list, and the auth tick re-resolves the active org. This row then
                // hides with it.
                const nextOrgs = (s.root.orgs || []).filter((o)=>o.id !== org.id);
                s.root.update({
                    orgs: nextOrgs,
                    _pendingActiveOrgId: null
                });
                el.state.update({
                    _busy: false
                });
            },
            onRemove: (el)=>clearTimeout(el.scope && el.scope.disarm)
        }
    }
};
// ── Member access (superadmin, viewing OTHER members) ──
// Per-member read-only toggle. status 'inactive' = read-only workspace access:
// the member can view everything but the auth middleware 403s their writes, and
// they're filtered out of active rosters/calendars/channels. Sets the canonical
// Mongo User.status via sdk.setMemberStatus(orgId, …) → the org-admin-gated
// PATCH /organizations/:orgId/members/:userId/status route. Gated on
// canSuperadmin (mirrors the server's org-management role gate) and !isSelf.
$f61c5a6dacc263dc$export$70752ed3eb71b053.ProfileSide.ProfileAccess = {
    ...$f61c5a6dacc263dc$var$_card({}),
    attr: {
        'data-content-section': 'Member access'
    },
    hide: (el, s)=>el.call('isSelf', s) || !el.call('canSuperadmin', s),
    AccessTitle: {
        extends: 'AppMicroLabel',
        text: (el)=>el.call('polyglot', 'account.member.access.title')
    },
    AccessHint: {
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        text: (el)=>el.call('polyglot', 'account.member.access.hint')
    },
    // State on the left, the one action on the right; the action drops under
    // the state on a narrow card. The state reads in title ink — the hue
    // (`blue` ink, `blue.1` / `green.1` plates) carried no status meaning and
    // the plates failed the brand's no-raw-hue rule (live 2026-10-28).
    AccessRow: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center space-between',
        gap: 'Z A',
        RowLabel: {
            flow: 'y',
            gap: 'Y',
            flex: '1 1 var(--spacing-F)',
            minWidth: '0',
            LabelText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '500',
                color: 'title',
                text: (el, s)=>{
                    const st = (0, $76fm2.findMe)(s)?.status;
                    return el.call('polyglot', st === 'inactive' ? 'account.member.access.inactive' : st === 'left' ? 'account.member.access.left' : 'account.member.access.active');
                }
            },
            Hint: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>el.call('polyglot', (0, $76fm2.findMe)(s)?.status === 'inactive' ? 'account.member.access.readOnlyHint' : 'account.member.access.fullHint')
            }
        },
        AccessBtn: {
            extends: 'AppCapsuleBtnToolbar',
            // Busy = the real disabled attribute; the stack keeps the capsule as
            // wide as its longest label in the active language (Rule 66).
            disabled: (el, s)=>!!s._accessBusy,
            'aria-busy': (el, s)=>!!s._accessBusy,
            AppLabelStack: {
                labels: [
                    'account.member.access.setReadOnly',
                    'account.member.access.restore',
                    'account.member.access.saving'
                ],
                shown: (el, s)=>s._accessBusy ? 2 : (0, $76fm2.findMe)(s)?.status === 'inactive' ? 1 : 0
            },
            onClick: async (e, el, s)=>{
                const person = (0, $76fm2.findMe)(s);
                if (!person?.userId || s._accessBusy) return;
                const orgId = s.root?.org?.id || el.sdk?._context?.activeOrgId;
                if (!orgId) {
                    console.warn('[MemberProfile] setMemberStatus: no active org id');
                    return;
                }
                const next = person.status === 'inactive' ? 'active' : 'inactive';
                el.state.update({
                    _accessBusy: true
                });
                try {
                    await el.sdk.setMemberStatus(orgId, person.userId, next);
                    s.root.update({
                        people: (0, $76fm2.patchPeopleList)(s.root.people, person.userId, {
                            status: next
                        }),
                        peopleAll: (0, $76fm2.patchPeopleList)(s.root.peopleAll, person.userId, {
                            status: next
                        })
                    });
                } catch (err) {
                    console.warn('[MemberProfile] setMemberStatus failed', err?.message || err);
                } finally{
                    el.state.update({
                        _accessBusy: false
                    });
                }
            }
        }
    }
};
const $f61c5a6dacc263dc$export$76702a5ccaf727aa = {
    // A native button: Enter, Space and the focus ring come with the tag.
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center',
    gap: 'Z1',
    width: '100%',
    padding: 'Z1 Z',
    round: 'radiusControl',
    border: 'none',
    background: 'transparent',
    color: 'title',
    textAlign: 'left',
    cursor: 'pointer',
    disabled: (el, s)=>!s.storagePath,
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    ':disabled': {
        cursor: 'default',
        background: 'transparent'
    },
    // migrated 2026-04-27 to SDK route workspaceProject.storage.signedUrl
    // (replaces sb().storage.from('contracts').createSignedUrl(path, 300)).
    onClick: async (e, el, s)=>{
        if (!s.storagePath) return;
        try {
            const result = await el.sdk.execute('workspaceProject.storage', 'signedUrl', {
                bucket: 'contracts',
                path: s.storagePath,
                ttl: 300
            });
            const url = result?.url || result?.signedUrl;
            if (url) window.open(url, '_blank');
            else console.warn('[MemberProfile] signed URL response missing url field', result);
        } catch (err) {
            console.warn('[MemberProfile] signed url failed', err?.message || err);
        }
    },
    Icon: {
        name: 'document',
        boxSize: 'A',
        flexShrink: '0',
        color: 'caption',
        ariaHidden: 'true'
    },
    DocInfo: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        DocTitle: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '500',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s.title
        },
        DocMeta: {
            tag: 'span',
            hide: (el, s)=>s.size == null && !s.signedAt,
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>[
                    s.size != null ? el.call('polyglot', 'account.member.documents.sizeKb').replace('{size}', s.size) : '',
                    s.signedAt ? el.call('polyglot', 'account.member.documents.signedOn').replace('{date}', s.signedAt) : ''
                ].filter(Boolean).join(" \xb7 ")
        }
    },
    DocAction: {
        tag: 'span',
        hide: (el, s)=>!s.storagePath,
        fontSize: 'Z2',
        fontWeight: '500',
        // §4.4 accent ink (AA on both stages; brand blue is 3.2:1 on light).
        color: 'accentInk',
        text: (el)=>el.call('polyglot', 'account.member.documents.open')
    }
};
const $f61c5a6dacc263dc$export$5e443b08c7b93dd6 = {
    flow: 'x',
    // The mark sits on the label's FIRST line: the body wraps on a phone.
    align: 'flex-start',
    gap: 'Z1',
    padding: 'Y 0',
    // The done mark is the house check glyph in ink (it was a green text ✓ and
    // a ○); a pending row keeps the glyph's box so every label starts on one
    // line (Rule 66).
    CheckIcon: {
        extends: 'Icon',
        name: 'check',
        boxSize: 'A',
        flexShrink: '0',
        // Centres the A box on the label's first line (a 1.5 line, a 1 em box).
        marginTop: 'X',
        color: 'title',
        visibility: (el, s)=>s.done ? 'visible' : 'hidden',
        ariaHidden: 'true'
    },
    // The label and its status share a line while it holds both; on a phone
    // the status drops under the label, aligned with its text. Beside the
    // status the label kept its longest Georgian word and pushed the status
    // 51 px past the card edge, and with only `minWidth: 0` it wrapped to five
    // lines in 105 px (live 390 px frame, 2026-10-29;
    // memberProfileNarrowRows.test.js).
    CheckBody: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center space-between',
        gap: 'Y Z1',
        flex: '1',
        minWidth: '0',
        CheckLabel: {
            tag: 'span',
            fontSize: 'A',
            flex: '1 1 var(--spacing-F)',
            minWidth: '0',
            overflowWrap: 'anywhere',
            color: (el, s)=>s.done ? 'title' : 'caption',
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        // Status hue as a DOT + neutral ink (wave-1 RoleDot grammar) — orange as
        // small-text ink measured 2.4:1 ×8 on the light stage (needs 4.5).
        CheckStatus: {
            tag: 'span',
            flow: 'x',
            align: 'center',
            gap: 'Y',
            flexShrink: '0',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            StatusDot: {
                tag: 'span',
                width: 'Y',
                height: 'Y',
                round: '50%',
                flex: '0 0 auto',
                background: (el, s)=>s.done ? 'green' : 'orange'
            },
            StatusText: {
                tag: 'span',
                text: (el, s)=>el.call('polyglot', s.done ? 'account.member.checklist.done' : 'account.member.checklist.pending')
            }
        }
    }
};
const $f61c5a6dacc263dc$export$a73d92b4aa3052ce = {};

});
parcelRegister("e0RDd", function(module, exports) {

$parcel$export(module.exports, "signoutAndRedirect", () => $a33aaadff39813a9$export$c6f8d3a5ab54e94);
// Canonical signout — called from every "Sign out" surface in the
// workspace (AppHeader, IntranetAppHeader, NoOrgOverlay, MemberProfile).
// Centralizes the steps that have to happen in the right order to
// avoid the redirect-loop class of bugs:
//
//   1. await sdk.logout — server-side teardown of the refresh token +
//      TokenManager.clearTokens (which only wipes the SDK's symbols_*
//      keys). Errors swallowed so a network blip doesn't strand the
//      user in a half-signed-out state. The SDK fires SIGNED_OUT to
//      subscribers AFTER clearTokens regardless of network outcome.
//
//   2. invalidateUserDataCache — drops the previous user's cached
//      profile / orgs / projects so the next signed-in render doesn't
//      flash this user's data.
//
//   3. queryClient?.clear — @symbo.ls/fetch's response cache, optional
//      because some callers (early-boot signout via storage event)
//      don't have a queryClient handle. Skipped silently when absent.
//
//   4. purgeAuthStorage — wipes BOTH `sb-<ref>-auth-token` (legacy
//      federation remnants) and `symbols_*` (SDK) namespaces, plus the
//      sdk_only retry flag. WORKSPACE-SIGNOUT-REDIRECT-LOOP: without
//      this, hasSessionToken still returns true on the next page load
//      because stale tokens are intact → redirectIfUnauthed bounces the
//      signed-out user back into the shell. Visible as a flash loop.
//
//   5. localStorage.setItem('logout', Date.now()) — cross-tab signal.
//      wireGlobalListeners listens for `e.key === 'logout'` storage
//      events and triggers the canonical logout switcher in any OTHER
//      tab still signed in for this user. Required so a sign-out in
//      Tab A doesn't leave Tab B mid-session with a stale Supabase
//      auto-refresh writing fresh sb-* tokens back into localStorage.
//      Cleared from the source tab via removeItem so we don't replay
//      our own signal if we re-sign-in later in the same tab.
//
//   6. window.location.href — hard reload (not history.replaceState)
//      so workspace/index.js's redirectIfUnauthed re-evaluates with a
//      fully empty localStorage. SPA-nav leaves the app mounted with
//      auth subscribers and refresh timers still running, which races
//      the just-wiped tokens.

var $fnRiS = parcelRequire("fnRiS");

var $lUr30 = parcelRequire("lUr30");
const $a33aaadff39813a9$export$c6f8d3a5ab54e94 = async ({ sdk: sdk, queryClient: queryClient = null, redirectTo: redirectTo = '/login' } = {})=>{
    try {
        await sdk?.logout?.();
    } catch (_) {
    /* network/token-clear failure — still nav */ }
    try {
        (0, $lUr30.invalidateUserDataCache)();
    } catch (_) {}
    try {
        queryClient?.clear?.();
    } catch (_) {}
    try {
        (0, $fnRiS.purgeAuthStorage)();
    } catch (_) {}
    try {
        if (typeof window !== 'undefined') {
            window.localStorage.setItem('logout', String(Date.now()));
            window.localStorage.removeItem('logout');
        }
    } catch (_) {}
    if (typeof window !== 'undefined') window.location.href = redirectTo;
};

});
parcelRegister("fnRiS", function(module, exports) {

$parcel$export(module.exports, "purgeAuthStorage", () => $b33259fa0beeb9d3$export$8ff00aae78f5a1be);
/**
 * purgeAuthStorage — single source of truth for clearing stored auth
 * credentials. Used by two distinct logout paths:
 *
 *   1. bootShell._forceLogoutAndReauth (pre-mount): runs BEFORE the SPA
 *      mounts, so queryClient / state aren't constructed yet.
 *   2. switchers/logout.js (post-mount): runs from a mounted shell with
 *      state + queryClient available.
 *
 * Both paths must purge the same keys to avoid one logout shape leaving
 * residue the other would pick up on the next boot.
 *
 * Keys purged:
 *   - localStorage `sb-*`           — legacy auth-js session keys (pre-retirement residue)
 *                                     (one per Supabase project ref).
 *   - localStorage `symbols_*`      — SDK access/refresh/bridge tokens.
 *   - localStorage `activeWorkspace` — the canonical chosen-workspace pointer.
 *     Cleared so a fresh sign-in (or a different user on the same browser)
 *     doesn't inherit the previous session's workspace selection (which boot
 *     prefers over the JWT claim — see _resolveAuthSnapshot in bootShell.js).
 *   - sessionStorage `__symbols_sdk_only_fed_attempted` — the per-tab
 *     flag that prevents bootShell's federation-retry loop. Cleared so
 *     a fresh sign-in isn't pre-blocked.
 *
 * Best-effort: each storage access is try/wrapped so a quota / disabled-
 * storage error in one doesn't prevent the rest from running.
 */ 
var $jhJrJ = parcelRequire("jhJrJ");
function $b33259fa0beeb9d3$export$8ff00aae78f5a1be() {
    const SDK_ONLY_RETRY_KEY = '__symbols_sdk_only_fed_attempted';
    if (typeof window === 'undefined') return;
    try {
        const purge = Object.keys(window.localStorage).filter((k)=>k.startsWith('sb-') || k.startsWith('symbols_'));
        for (const k of purge)window.localStorage.removeItem(k);
        (0, $jhJrJ.clearActiveWorkspacePointer)();
    } catch (_) {}
    try {
        window.sessionStorage.removeItem(SDK_ONLY_RETRY_KEY);
    } catch (_) {}
}

});


parcelRegister("kg2OA", function(module, exports) {

$parcel$export(module.exports, "__setTeamsSdkForTests", () => $03ce50749ecc6c4d$export$32ce66465c0b0991);
$parcel$export(module.exports, "loadAllTeams", () => $03ce50749ecc6c4d$export$3cdd454e9fc60cd4);
$parcel$export(module.exports, "loadTeamMembers", () => $03ce50749ecc6c4d$export$4d61445feb376f64);
$parcel$export(module.exports, "loadAllTeamMembers", () => $03ce50749ecc6c4d$export$b4a7ad46ab9380e0);
$parcel$export(module.exports, "personTeams", () => $03ce50749ecc6c4d$export$14c8ce83a4142100);
$parcel$export(module.exports, "primaryTeamName", () => $03ce50749ecc6c4d$export$7a146fa902c3b991);
$parcel$export(module.exports, "addMemberToTeam", () => $03ce50749ecc6c4d$export$1799d229e79f350b);
$parcel$export(module.exports, "setTeamMemberStatus", () => $03ce50749ecc6c4d$export$6ba76b827c3d421d);
$parcel$export(module.exports, "removeMemberFromTeam", () => $03ce50749ecc6c4d$export$8c1358525ec9cee6);
$parcel$export(module.exports, "createTeam", () => $03ce50749ecc6c4d$export$dadd67f86cf9b534);
$parcel$export(module.exports, "createTeamWithMembers", () => $03ce50749ecc6c4d$export$e6735781ccf8b28a);
$parcel$export(module.exports, "updateTeamPermissions", () => $03ce50749ecc6c4d$export$d6d54ebf00abd93b);
$parcel$export(module.exports, "updateTeamCategory", () => $03ce50749ecc6c4d$export$90d341c4b8ffe31d);
$parcel$export(module.exports, "inviteToTeam", () => $03ce50749ecc6c4d$export$69073f265828e8b9);
$parcel$export(module.exports, "inviteToWorkspace", () => $03ce50749ecc6c4d$export$97b65d9df0cb20a1);
$parcel$export(module.exports, "teamsInOrg", () => $03ce50749ecc6c4d$export$6d550913e15f5dd8);
$parcel$export(module.exports, "isActiveOrgMember", () => $03ce50749ecc6c4d$export$19e5c3d8b2f178);
// Teams directory — sourced from Mongo via the Symbols SDK, not from
// Supabase. The `user_profiles.department` / `user_profiles.group_name`
// text columns on governance are legacy; team membership is now
// canonical in Mongo's `Team` + `TeamMember`.
//
// Load once per session into root state:
//   root.teams         Array of { id, name, slug, parentTeam, orgId }
//   root.teamsByEmail  { [lowercase email]: Array<{ id, name, role }> }
//
// Consumers (peopleGroups, PersonCard, MemberProfile, _person mapper)
// read from root.teamsByEmail instead of person.department / .group.
//
// Moved from workspace/functions/teams.js (2026-08-15, MemberProfile
// extraction — tickets/opus.md) so MemberProfile can live in `shared` and
// stay reachable from every host (workspace, canvas). Self-contained
// already (its only dependency was the shared SDK singleton) — no other
// behavior change. workspace/functions/teams.js now re-exports this file
// so its other consumers (peopleGroups.js, PersonCard.js,
// loadPrivateData.js) are unaffected.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
// SDK list-response unwrap — the server returns either `{items}`,
// `{data:{items}}`, `{data:[...]}`, or a bare array depending on the
// endpoint + version. Normalize to a plain array.
const $03ce50749ecc6c4d$var$_unwrapList = (r)=>r?.items || r?.data?.items || r?.data || (Array.isArray(r) ? r : []);
// Stable non-PII join key off a roster row. The server now stamps a
// top-level `userId` on every row for all viewers (memberProjection.js);
// fall back to the populated `user._id` for older payloads. This is the key
// a non-mgmt viewer's membership resolves on — their rows carry no email
// (tickets/fable.md P0 regression).
const $03ce50749ecc6c4d$var$_memberUserId = (m)=>{
    const raw = m?.userId != null ? m.userId : m?.user?._id != null ? m.user._id : m?.user?.id;
    return raw != null ? String(raw) : '';
};
// Every id-space a person can be joined on: the canonical Mongo userId AND
// the Supabase UUID alias when the server sends one. The people roster keys
// identity as `supabaseUserId || _id`, so a federated peer's people-row id
// is their Supabase UUID while their team-row userId is the Mongo _id —
// index the membership under BOTH so a consumer holding EITHER id resolves
// it (tickets/fable.md P0 regression). Deduped; empty when neither exists.
const $03ce50749ecc6c4d$var$_memberIdKeys = (m)=>{
    const keys = [];
    const uid = $03ce50749ecc6c4d$var$_memberUserId(m);
    if (uid) keys.push(uid);
    const sb = m?.supabaseUserId != null ? String(m.supabaseUserId) : '';
    if (sb && sb !== uid) keys.push(sb);
    return keys;
};
// Use the shared SDK instance (pointed at the same channel as the rest of
// the workspace — `localhost:8080` in localNext, `next.api.symbols.app`
// in next, etc.). The previous hack here built its own SDK and copied
// the federation bridge token into `symbols_access_token`, which broke
// `/core/*` calls in localNext mode (bridge token is signed by prod, the
// local server uses a different secret). The shared SDK already carries
// the locally-minted token via TokenManager — no per-module override.
const $03ce50749ecc6c4d$var$_getSdk = ()=>{
    // Test seam — same shape as workspaceProjects.js's `__setModuleSdkFnForTests`
    // family. `getSDK()` is a process-wide singleton behind a cache keyed on the
    // resolved channel URL, so a unit test cannot substitute it without writing
    // globals that leak into every LATER file of the same bun process (one bun
    // process runs a whole package). An explicit, named seam that the test
    // clears in its own teardown is the honest alternative.
    // FA201: the handle lives on globalThis, never a module-scope `let`.
    const injected = globalThis.__teamsSdkForTests;
    if (typeof injected === 'function') return injected();
    if (typeof window === 'undefined') return null;
    return (0, $1NxyO.getSDK)();
};
const $03ce50749ecc6c4d$export$32ce66465c0b0991 = (fn)=>{
    globalThis.__teamsSdkForTests = typeof fn === 'function' ? fn : null;
};
// In-flight dedup + short-TTL cache for loadAllTeams (2026-06-08 perf).
// loadAllTeams fans out 2 requests PER ORG across every org the user
// belongs to (listOrgMembers + listTeams). On /studio it was fired ~3×
// concurrently — loadPrivateData (sign-in), onWorkspaceChange
// (org-resolve), and the page's own data load — with no dedup, so a
// 6-org user issued ~36 simultaneous /core/organizations/:id/{teams,
// members} requests that saturated the server (~4s each) and chat /
// member surfaces waited 5–9s. The guard collapses concurrent callers
// onto ONE fan-out and serves a fresh result to callers arriving within
// the TTL, cutting ~36 → 12 requests. Keyed by the sorted org-id set so
// an org switch (different claims) misses the cache and reloads; the
// switch also wipes the relevant root state in onWorkspaceChange.
// FA201 / frank trap (WS-SHARED-MODULE-LET-BLOCKS-EVERY-PUSH-1) — the two
// handles used to be module-scope `let`s (`_allTeamsInflight`,
// `_allTeamsCache`) read by the EXPORTED `loadAllTeams`. frank hoists that
// export into the emitted `globalScope` and revives it with a bare indirect
// eval, where nothing module-level is in scope, so each read emitted a
// guaranteed ReferenceError and frank's emission gate refused the whole
// publish (`PUBLISH BLOCKED — [unresolvable-identifier]`) for any project that
// inlines this package AND uses this export. Re-homed onto
// `globalThis.__allTeamsState`, per the pointerCapability.js template; the
// lazy create is INLINED at the one read site, because a shared module-scope
// getter would just relocate the same bare-sibling-call hazard.
//
// The tenant keying is UNCHANGED: the sorted org-id set still lives INSIDE
// each value (`{ key, … }`) and is still compared before reuse, so this is
// the same TENANT-KEYED shape the module-state census classified — only its
// home moved.
const $03ce50749ecc6c4d$var$_ALL_TEAMS_TTL_MS = 5000;
const $03ce50749ecc6c4d$export$3cdd454e9fc60cd4 = async (root, opts)=>{
    // SCOPE. By default this loads the ACTIVE (scoped) organisation ONLY — see
    // the ACTIVE-ORG-ONLY note in _loadAllTeamsUncached. `{ allOrgs: true }` is
    // the opt-in fan-out across every org in the claim set, for a surface that
    // genuinely shows more than one org at a time. The cache key carries the
    // scope so the two answers can never be served for each other.
    const allOrgs = !!(opts && opts.allOrgs);
    const orgIds = (root?.jwtClaims?.orgs || []).map((o)=>o?.id).filter(Boolean).sort();
    const key = orgIds.length ? (allOrgs ? 'all:' : 'active:') + orgIds.join(',') : '';
    if (!globalThis.__allTeamsState) globalThis.__allTeamsState = {
        inflight: null,
        cache: null,
        denied: null
    };
    const state = globalThis.__allTeamsState;
    // Fresh-enough cached result → reuse (collapses re-fires within the
    // page-settle window). Empty key (no orgs yet) is never cached.
    if (key && state.cache && state.cache.key === key && Date.now() - state.cache.ts < $03ce50749ecc6c4d$var$_ALL_TEAMS_TTL_MS) return state.cache.result;
    // A fan-out for this exact org set is already running → await it
    // instead of starting a second identical burst.
    if (key && state.inflight && state.inflight.key === key) return state.inflight.promise;
    const promise = $03ce50749ecc6c4d$var$_loadAllTeamsUncached(root, allOrgs);
    if (key) state.inflight = {
        key: key,
        promise: promise
    };
    try {
        const result = await promise;
        if (key) state.cache = {
            key: key,
            result: result,
            ts: Date.now()
        };
        return result;
    } finally{
        if (state.inflight && state.inflight.promise === promise) state.inflight = null;
    }
};
const $03ce50749ecc6c4d$var$_loadAllTeamsUncached = async (root, allOrgs)=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) return {
        teams: [],
        teamsByEmail: {},
        teamsByUserId: {},
        orgMembersByOrgId: {}
    };
    // Fetch members for EVERY org the user belongs to. Filtering by
    // type (`'team'` only) used to skip the Symbols System home org on
    // some accounts — when the active workspace lives under such an
    // org, /people then renders empty.
    const orgs = root?.jwtClaims?.orgs || [];
    const teams = [];
    const teamsByEmail = {};
    const orgMembersByOrgId = {};
    // Parallel across orgs — 2 calls per org (listOrgMembers + listTeams)
    // and N orgs gives 2N concurrent requests. Well under the 180 req/min
    // free-tier cap for any realistic N. The earlier serial loop predates
    // the deferred `loadTeamMembers` and was guarding against an N×teams
    // burst that no longer fires from here.
    //
    // PERF-3: within each org, listOrgMembers and listTeams are independent
    // API calls — fire them in parallel via Promise.all. For a user in K
    // orgs this halves the per-org wall-clock from 2 serial RTTs to 1
    // concurrent RTT. No order dependency between the two calls: the member
    // map only feeds orgMembersByOrgId (not consumed by teams list), and
    // the teams list only feeds the `teams` accumulator.
    // Per-org fetch — members + teams accumulated into the shared maps.
    const processOrg = async (org)=>{
        const orgId = org.id;
        if (!orgId) return;
        // AN ORG THAT ALREADY REFUSED US IS NEVER ASKED AGAIN THIS SESSION.
        // `/core/auth/me` can list an org whose own read answers 403
        // ("Organization membership required") — a stale claim, Mongo ↔ JWT
        // staleness. The catches below already swallow it into "no teams", but a
        // swallowed 403 is still a REQUEST: the browser logs `Failed to load
        // resource: 403` in the console on its own, and no JS can suppress that.
        // The only fix is not to ask twice. Measured on the Vault white-label host
        // 2026-09-09: two 403s on EVERY page load, for the workspace Owner.
        if (!globalThis.__allTeamsState) globalThis.__allTeamsState = {
            inflight: null,
            cache: null,
            denied: null
        };
        const _denied = globalThis.__allTeamsState.denied;
        if (_denied && _denied[orgId]) return;
        // A 403 on either call means the org is not readable by this session at
        // all — record it once, for both calls, and for every later pass.
        const _markDenied = (err)=>{
            const msg = err && err.message || '';
            const status = err && (err.status || err.statusCode);
            if (status !== 403 && !/Organization membership required/i.test(msg)) return;
            if (!globalThis.__allTeamsState.denied) globalThis.__allTeamsState.denied = {};
            globalThis.__allTeamsState.denied[orgId] = true;
        };
        // Store orgMembers as a plain lookup object ({email: true}) not a
        // Set because smbls's root.update() path JSON-clones state and Sets
        // don't survive — entries become empty {}. Plain objects round-trip.
        const [oRes, teamsRes] = await Promise.all([
            sdk.listOrgMembers(orgId).catch((err)=>{
                // "Organization membership required" is the SDK's response when
                // the JWT lists an org the user is no longer a member of (Mongo
                // ↔ Supabase JWT staleness — see tickets/sdk.md SDK-WORKSPACE-TEAMS-1).
                // The missing key downgrades the UI to "show full cross-tenant
                // list" via filterToActiveOrg. Demote this to debug to stop
                // spamming console on every page load.
                _markDenied(err);
                const msg = err?.message || '';
                if (!/Organization membership required/i.test(msg)) console.warn('[teams] listOrgMembers failed for', orgId, err);
                return null;
            }),
            sdk.listTeams(orgId).catch((err)=>{
                _markDenied(err);
                const msg = err?.message || '';
                if (!/Organization membership required/i.test(msg)) console.warn('[teams] listTeams failed for', orgId, err);
                return null;
            })
        ]);
        if (oRes !== null) {
            const oMembers = $03ce50749ecc6c4d$var$_unwrapList(oRes);
            const map = {};
            for (const m of oMembers){
                const email = (m?.user?.email || m?.email || '').toLowerCase();
                if (email) map[email] = true;
            }
            orgMembersByOrgId[orgId] = map;
        }
        if (teamsRes === null) return;
        const list = $03ce50749ecc6c4d$var$_unwrapList(teamsRes);
        // Per-team member fetching is intentionally deferred — each
        // listTeamMembers is a separate API call and with many teams
        // bursts past the free-tier cap (180 req/min). loadTeamMembers()
        // is called lazily when the user opens a team detail view.
        for (const t of list)teams.push({
            id: t._id || t.id,
            name: t.name,
            slug: t.slug,
            parentTeam: t.parentTeam || null,
            category: t.category || 'active',
            isSystem: !!t.isSystem,
            permissions: t.permissions || [],
            orgId: orgId,
            orgName: org.name
        });
    };
    // ACTIVE-ORG-FIRST (2026-06-08 per Nika "optimize general loading /
    // double-check how we handle requests"): fetch the ACTIVE org alone
    // first and commit its slice to root immediately, THEN background the
    // rest. The old `Promise.all(orgs.map(...))` fired all 2N requests (12
    // for a 6-org user) in a single burst that pegged the API and starved
    // the critical-path calls queued behind it (the dashboard's
    // loadOrgMembers, loadProjects) — that pile-up was the main reason
    // /studio members + projects loaded slowly. Active-first cuts the
    // opening burst to 2 requests, so the active-org views paint right away
    // and the freed capacity lets the rest of the page through. Falls back
    // to the all-at-once path when the active org isn't in the claim set.
    const activeOrgId = root?.jwtClaims?.workspace_org_id;
    const active = activeOrgId && orgs.find((o)=>o.id && o.id === activeOrgId);
    if (active) {
        await processOrg(active);
        try {
            root.update({
                teams: [
                    ...teams
                ],
                orgMembersByOrgId: {
                    ...orgMembersByOrgId
                }
            });
        } catch (_) {}
        // ── ACTIVE-ORG-ONLY (2026-09-09, A2-04) ──────────────────────────────
        // Boot stops here. Every consumer of `root.teams` /
        // `root.orgMembersByOrgId` keys on the ACTIVE org — /admin/teams filters
        // to `jwtClaims.workspace_org_id`, filterToActiveOrg and
        // PersonDetailModal both index by the active org id — so the other orgs'
        // rows were fetched and never read. On a white-label host that is the
        // whole point: the custom domain scopes the session to ONE organisation.
        //
        // The cost of fetching them anyway was not only latency. Nika's account
        // lists 13 orgs and one of them answers 403 on its own read, so EVERY
        // page load put two 403s in the console of a customer-facing build, for
        // the workspace Owner (measured on vault.pr, 2026-09-09).
        //
        // A cross-org surface asks for the rest explicitly, with
        // `{ allOrgs: true }`, when the user opens it — never on the boot path.
        if (!allOrgs) return {
            teams: teams,
            teamsByEmail: teamsByEmail,
            teamsByUserId: {},
            orgMembersByOrgId: orgMembersByOrgId
        };
    }
    // No active org in the claim set (or an explicit cross-org caller): the
    // original fan-out. Without this a session that cannot resolve its own
    // active org would get an EMPTY directory instead of a slow one.
    await Promise.all(orgs.filter((o)=>o !== active).map(processOrg));
    return {
        teams: teams,
        teamsByEmail: teamsByEmail,
        teamsByUserId: {},
        orgMembersByOrgId: orgMembersByOrgId
    };
};
const $03ce50749ecc6c4d$export$4d61445feb376f64 = async (root, team)=>{
    if (!team?.id) return;
    // Skip if already loaded this session.
    if (root?.teamMembersLoaded?.[team.id]) return;
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) return;
    try {
        const mRes = await sdk.listTeamMembers(team.orgId, team.id);
        const members = $03ce50749ecc6c4d$var$_unwrapList(mRes);
        // Merge new entries into the existing maps without touching entries from
        // other teams (different teamId). Both indexes are written: teamsByUserId
        // (the stable non-PII key that rides EVERY row) is primary; teamsByEmail
        // is kept for consumers that only hold an email and for mgmt / optimistic
        // writes — but a non-mgmt viewer's rows carry NO email, so only the id
        // index resolves for them (tickets/fable.md P0 regression).
        const next = {
            ...root?.teamsByEmail || {}
        };
        const nextById = {
            ...root?.teamsByUserId || {}
        };
        for (const m of members){
            const email = (m?.user?.email || m?.email || '').toLowerCase();
            const userId = $03ce50749ecc6c4d$var$_memberUserId(m);
            const idKeys = $03ce50749ecc6c4d$var$_memberIdKeys(m);
            if (!email && !idKeys.length) continue;
            const entry = {
                id: team.id,
                name: team.name,
                slug: team.slug,
                category: team.category,
                orgId: team.orgId,
                // Permission-group flag (server SystemTeamsSeeder): Admin /
                // Manager / Members / HR / … are seeded per org as permission
                // carriers wearing the Team model. Surfaces that mean "real
                // team" (people grouping, teams rail) filter these out.
                isSystem: !!team.isSystem,
                // Person identity off the populated TeamMember.user — lets the
                // /team-members team filter render members who aren't in the
                // people roster (no user_profiles row yet) as ghost cards.
                userName: m?.user?.name || '',
                userAvatar: m?.user?.avatar || null,
                userId: userId || null,
                role: m?.role || 'member',
                // §unified-perms PR #1 — per-member overlay. Default 'active'
                // matches the TeamMember schema default; the server stamps
                // 'passive' explicitly when an admin elevates a member without
                // changing the team's category.
                status: m?.status || 'active'
            };
            // Avoid duplicate entries for this team on re-open. Index under every
            // id-space (Mongo + Supabase) so either kind of consumer id resolves.
            if (email) next[email] = [
                ...(next[email] || []).filter((e)=>e.id !== team.id),
                entry
            ];
            for (const k of idKeys)nextById[k] = [
                ...(nextById[k] || []).filter((e)=>e.id !== team.id),
                entry
            ];
        }
        root.update({
            teamsByEmail: next,
            teamsByUserId: nextById,
            teamMembersLoaded: {
                ...root?.teamMembersLoaded || {},
                [team.id]: true
            }
        });
    } catch (err) {
        console.warn('[teams] loadTeamMembers failed for', team.id, err);
    }
};
const $03ce50749ecc6c4d$export$b4a7ad46ab9380e0 = async (root)=>{
    const teams = root?.teams || [];
    if (!teams.length) return;
    const orgId = root?.jwtClaims?.workspace_org_id;
    const orgTeams = orgId ? teams.filter((t)=>String(t.orgId) === String(orgId)) : teams;
    if (!orgTeams.length) return;
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (sdk && typeof sdk.listOrgTeamMembers === 'function' && orgId) try {
        const { members: members = [] } = await sdk.listOrgTeamMembers(orgId) || {};
        const teamById = {};
        for (const t of orgTeams)teamById[String(t.id)] = t;
        const next = {
            ...root?.teamsByEmail || {}
        };
        const nextById = {
            ...root?.teamsByUserId || {}
        };
        const loaded = {
            ...root?.teamMembersLoaded || {}
        };
        for (const m of members){
            const team = teamById[String(m?.team)];
            if (!team) continue;
            const email = (m?.user?.email || m?.email || '').toLowerCase();
            const userId = $03ce50749ecc6c4d$var$_memberUserId(m);
            const idKeys = $03ce50749ecc6c4d$var$_memberIdKeys(m);
            // A non-mgmt viewer's rows carry a userId but NO email — index them
            // by id so their memberships still resolve (fable.md P0 regression).
            if (!email && !idKeys.length) continue;
            const entry = {
                id: team.id,
                name: team.name,
                slug: team.slug,
                category: team.category,
                orgId: team.orgId,
                isSystem: !!team.isSystem,
                userName: m?.user?.name || '',
                userAvatar: m?.user?.avatar || null,
                userId: userId || null,
                role: m?.role || 'member',
                status: m?.status || 'active'
            };
            if (email) next[email] = [
                ...(next[email] || []).filter((e)=>e.id !== team.id),
                entry
            ];
            for (const k of idKeys)nextById[k] = [
                ...(nextById[k] || []).filter((e)=>e.id !== team.id),
                entry
            ];
        }
        for (const t of orgTeams)loaded[t.id] = true;
        root.update({
            teamsByEmail: next,
            teamsByUserId: nextById,
            teamMembersLoaded: loaded
        });
        return;
    } catch (err) {
        console.warn("[teams] listOrgTeamMembers failed \u2014 falling back to per-team:", err?.message);
    }
    await Promise.all(orgTeams.map((t)=>$03ce50749ecc6c4d$export$4d61445feb376f64(root, t)));
};
const $03ce50749ecc6c4d$export$14c8ce83a4142100 = (personOrEmail, root)=>{
    // Accept a person-like `{ userId, email }` OR a bare email string (legacy
    // callers). `userId` is the PRIMARY join key — the server stamps it on
    // EVERY roster row for every viewer (memberProjection.js), whereas a
    // non-mgmt viewer's rows carry NO email, so teamsByEmail is empty for them
    // and only the userId index resolves (tickets/fable.md P0 regression).
    // Email is the fallback for legacy callers and mgmt-viewer rows.
    const p = typeof personOrEmail === 'string' ? {
        email: personOrEmail
    } : personOrEmail || {};
    const uid = p.userId != null ? String(p.userId) : '';
    const key = String(p.email || '').toLowerCase();
    const byId = uid && root?.teamsByUserId?.[uid] || null;
    const byEmail = key && root?.teamsByEmail?.[key] || null;
    const raw = byId && byId.length ? byId : byEmail || byId || [];
    const orgId = root?.jwtClaims?.workspace_org_id;
    const scoped = orgId ? raw.filter((t)=>String(t?.orgId) === String(orgId)) : raw;
    const seen = new Set();
    const out = [];
    for (const t of scoped){
        const k = String(t?.id || t?.name || '');
        if (!k || seen.has(k)) continue;
        seen.add(k);
        out.push(t);
    }
    return out;
};
const $03ce50749ecc6c4d$export$7a146fa902c3b991 = (personOrEmail, root)=>{
    const real = $03ce50749ecc6c4d$export$14c8ce83a4142100(personOrEmail, root).filter((t)=>!t.isSystem);
    return real.length ? real[0].name : null;
};
// ── Write helpers ─────────────────────────────────────────────────
// Thin wrappers around SDK methods. Optimistically update
// root.teamsByEmail on success so the UI reflects the change before
// the next `loadAllTeams()` refresh.
// Generic optimistic indexer — appends one team entry under an arbitrary
// key (a lowercased email for teamsByEmail, a userId for teamsByUserId).
// No-op when the key is empty (e.g. a non-mgmt caller has no peer email).
const $03ce50749ecc6c4d$var$_addTeamEntry = (map, key, team, role = 'member')=>{
    if (!key) return map || {};
    // Mirror the shape loadAllTeamMembers writes — category + status feed
    // PersonDetailModal's effective-perms calc and the category-coloring
    // on TeamPersonNode. Omitting them made every optimistic add visibly
    // revert to "unknown" until the next refresh.
    const entry = {
        id: team.id,
        name: team.name,
        slug: team.slug,
        orgId: team.orgId,
        role: role,
        category: team.category || null,
        status: team.category === 'passive' ? 'passive' : 'active'
    };
    const base = map || {};
    return {
        ...base,
        [key]: [
            ...base[key] || [],
            entry
        ]
    };
};
const $03ce50749ecc6c4d$var$_removeTeamEntry = (map, key, teamId)=>{
    if (!key) return map || {};
    const next = {
        ...map || {}
    };
    next[key] = (next[key] || []).filter((t)=>t.id !== teamId);
    if (!next[key].length) delete next[key];
    return next;
};
const $03ce50749ecc6c4d$export$1799d229e79f350b = async (root, { orgId: orgId, teamId: teamId, userId: userId, email: email, role: role = 'member' })=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    await sdk.addTeamMember(orgId, teamId, {
        userId: userId,
        role: role
    });
    const team = (root?.teams || []).find((t)=>t.id === teamId) || {
        id: teamId,
        name: '',
        slug: '',
        orgId: orgId
    };
    // Write BOTH indexes optimistically — teamsByUserId (the stable non-PII key
    // that resolves for every viewer) and teamsByEmail (mgmt / legacy callers).
    root.update({
        teamsByEmail: $03ce50749ecc6c4d$var$_addTeamEntry(root.teamsByEmail || {}, String(email || '').toLowerCase(), team, role),
        teamsByUserId: $03ce50749ecc6c4d$var$_addTeamEntry(root.teamsByUserId || {}, userId != null ? String(userId) : '', team, role)
    });
};
const $03ce50749ecc6c4d$export$6ba76b827c3d421d = async (root, { orgId: orgId, teamId: teamId, userId: userId, email: email, status: status })=>{
    if (![
        'active',
        'passive'
    ].includes(status)) throw new Error('status must be active | passive');
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const mRes = await sdk.listTeamMembers(orgId, teamId);
    const members = $03ce50749ecc6c4d$var$_unwrapList(mRes);
    const row = members.find((m)=>m?.user?.id === userId || m?.user?._id === userId || m?.userId === userId || String(m?.user?.email || '').toLowerCase() === String(email || '').toLowerCase());
    const memberId = row?.id || row?._id;
    if (!memberId) throw new Error('Team member not found');
    await sdk.updateTeamMember(orgId, teamId, memberId, {
        status: status
    });
    // Optimistic merge: rewrite this team's row for this person in BOTH
    // indexes (userId resolves for every viewer, email for mgmt / legacy).
    const patchList = (list)=>(list || []).map((e)=>e.id === teamId ? {
                ...e,
                status: status
            } : e);
    const key = String(email || '').toLowerCase();
    const uid = userId != null ? String(userId) : '';
    const upd = {};
    if (key) {
        const prev = root?.teamsByEmail || {};
        upd.teamsByEmail = {
            ...prev,
            [key]: patchList(prev[key])
        };
    }
    if (uid) {
        const prevById = root?.teamsByUserId || {};
        upd.teamsByUserId = {
            ...prevById,
            [uid]: patchList(prevById[uid])
        };
    }
    if (Object.keys(upd).length) root.update(upd);
};
const $03ce50749ecc6c4d$export$8c1358525ec9cee6 = async (root, { orgId: orgId, teamId: teamId, userId: userId, email: email })=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const mRes = await sdk.listTeamMembers(orgId, teamId);
    const members = $03ce50749ecc6c4d$var$_unwrapList(mRes);
    const row = members.find((m)=>m?.user?.id === userId || m?.user?._id === userId || m?.userId === userId);
    const memberId = row?.id || row?._id;
    if (memberId) await sdk.removeTeamMember(orgId, teamId, memberId);
    // Drop the entry from BOTH indexes so the optimistic removal reflects for
    // every viewer tier (email-index for mgmt, userId-index for everyone).
    root.update({
        teamsByEmail: $03ce50749ecc6c4d$var$_removeTeamEntry(root.teamsByEmail || {}, String(email || '').toLowerCase(), teamId),
        teamsByUserId: $03ce50749ecc6c4d$var$_removeTeamEntry(root.teamsByUserId || {}, userId != null ? String(userId) : '', teamId)
    });
};
const $03ce50749ecc6c4d$export$dadd67f86cf9b534 = async (root, { orgId: orgId, name: name })=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const slug = String(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const res = await sdk.createTeam(orgId, {
        name: name,
        slug: slug
    });
    const created = res?.data || res;
    const team = {
        id: created._id || created.id,
        name: created.name,
        slug: created.slug,
        parentTeam: created.parentTeam || null,
        category: created.category || 'active',
        isSystem: !!created.isSystem,
        permissions: created.permissions || [],
        orgId: orgId,
        orgName: (root?.jwtClaims?.orgs || []).find((o)=>o.id === orgId)?.name || ''
    };
    root.update({
        teams: [
            ...root?.teams || [],
            team
        ]
    });
    return team;
};
const $03ce50749ecc6c4d$export$e6735781ccf8b28a = async (root, { orgId: orgId, name: name, members: members = [] })=>{
    const team = await $03ce50749ecc6c4d$export$dadd67f86cf9b534(root, {
        orgId: orgId,
        name: name
    });
    if (!team?.id) throw new Error('createTeam returned no id');
    if (members.length === 0) return {
        team: team,
        errors: []
    };
    const errors = [];
    await Promise.all(members.map(async (m)=>{
        try {
            await $03ce50749ecc6c4d$export$1799d229e79f350b(root, {
                orgId: orgId,
                teamId: team.id,
                userId: m.userId,
                email: m.email
            });
        } catch (err) {
            errors.push({
                email: m.email,
                error: err?.message || String(err)
            });
        }
    }));
    return {
        team: team,
        errors: errors
    };
};
const $03ce50749ecc6c4d$export$d6d54ebf00abd93b = async (root, { orgId: orgId, teamId: teamId, permissions: permissions })=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const res = await sdk.updateTeam(orgId, teamId, {
        permissions: permissions
    });
    const updated = res?.data || res;
    const nextTeams = (root?.teams || []).map((t)=>t.id === teamId ? {
            ...t,
            permissions: updated?.permissions || permissions
        } : t);
    root.update({
        teams: nextTeams
    });
    return updated;
};
const $03ce50749ecc6c4d$export$90d341c4b8ffe31d = async (root, { orgId: orgId, teamId: teamId, category: category, resetToTemplate: resetToTemplate = false })=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    const res = await sdk.updateTeam(orgId, teamId, {
        category: category,
        resetToTemplate: resetToTemplate
    });
    const updated = res?.data || res;
    const nextTeams = (root?.teams || []).map((t)=>t.id === teamId ? {
            ...t,
            category: updated?.category || category,
            permissions: updated?.permissions || t.permissions,
            appliedTemplate: updated?.appliedTemplate ?? null
        } : t);
    root.update({
        teams: nextTeams
    });
    return updated;
};
const $03ce50749ecc6c4d$export$69073f265828e8b9 = async (root, { orgId: orgId, teamId: teamId, email: email })=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    if (!email) throw new Error('email required');
    return sdk.inviteToTeam(orgId, teamId, {
        email: email
    });
};
const $03ce50749ecc6c4d$export$97b65d9df0cb20a1 = async (root, { workspaceId: workspaceId, email: email, role: role, teams: teams })=>{
    const sdk = await $03ce50749ecc6c4d$var$_getSdk();
    if (!sdk) throw new Error('SDK not available');
    if (!workspaceId) throw new Error('workspaceId required');
    if (!email) throw new Error('email required');
    return sdk.createWorkspaceInvitation(workspaceId, {
        email: email,
        role: role || 'editor',
        ...Array.isArray(teams) && teams.length ? {
            teams: teams
        } : {}
    });
};
const $03ce50749ecc6c4d$export$6d550913e15f5dd8 = (orgId, root)=>(root?.teams || []).filter((t)=>t.orgId === orgId);
const $03ce50749ecc6c4d$export$19e5c3d8b2f178 = (email, root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return false;
    const set = root?.orgMembersByOrgId?.[orgId];
    if (!set) return false;
    return !!set[String(email || '').toLowerCase()];
};

});


parcelRegister("19uAL", function(module, exports) {

$parcel$export(module.exports, "ProfileAvailabilityCell", () => $0d6e5ca58e0d351a$export$5bc2dfb247a1ef80);
$parcel$export(module.exports, "ProfileAvailabilityGrid", () => $0d6e5ca58e0d351a$export$9c49f3715ff4d771);
// Standalone availability grid for the profile page.
// Uses event delegation on the grid container for click handling
// since DOMQL lifecycle hooks don't fire on deeply nested childExtends cells.
//
// Moved from workspace/components/ProfileAvailabilityGrid.js (2026-08-15,
// MemberProfile extraction — tickets/opus.md) so it stays reachable from
// every host MemberProfile renders in (workspace, canvas) — MemberProfile
// bare-keys this component (`ProfileAvailabilityGrid: {}`), and DOMQL's
// key-based auto-extend needs it resolvable from wherever MemberProfile
// itself resolves from.
//
// canAdmin/canEditProfile here are this package's memberProfileAccess.js
// (not workspace's roleHelpers.js) — these two helpers are called from
// plain JS closures (_currentUserIsAdmin/_canEditAvailability), not DOMQL
// prop factories, so there's no `el` to route through el.call the way
// MemberProfile.js does for the same functions. The only behavior this
// trades away is roleHelpers.js's local team-permission UNION fallback
// (same documented, already-shipped tradeoff as appAccess.js's
// isOwnerOrAdmin/canApp) — a UI-only cursor/click-affordance gate; the
// server independently enforces the real write authorization.

var $76fm2 = parcelRequire("76fm2");

var $9qRgv = parcelRequire("9qRgv");
// KEYS, not day names — the render site (DayLabel below) resolves them.
// Duplicated under `account.*` rather than read from `calendar.day.*`: a
// surface never reaches into another namespace's keys, and the account path
// does not load the calendar bundle (docs/I18N-CONVENTION.md §5).
const $0d6e5ca58e0d351a$var$DAYS = [
    'account.availability.day.mon',
    'account.availability.day.tue',
    'account.availability.day.wed',
    'account.availability.day.thu',
    'account.availability.day.fri',
    'account.availability.day.sat',
    'account.availability.day.sun'
];
const $0d6e5ca58e0d351a$var$_hhmmToMin = (s)=>{
    if (!s) return 0;
    const [h, m] = s.split(':').map(Number);
    return h * 60 + m;
};
const $0d6e5ca58e0d351a$var$_isAvailableDefault = (user, hour)=>{
    const wh = user?.workingHours;
    if (!wh) return false;
    const minute = hour * 60;
    const start = $0d6e5ca58e0d351a$var$_hhmmToMin(wh.start);
    const end = $0d6e5ca58e0d351a$var$_hhmmToMin(wh.end);
    return start < end ? minute >= start && minute < end : minute >= start || minute < end;
};
const $0d6e5ca58e0d351a$var$_isAvailableAt = (user, day, hour)=>{
    if (!user) return false;
    const grid = user.availabilityGrid;
    if (grid && grid[day] && typeof grid[day][hour] === 'boolean') return grid[day][hour];
    return $0d6e5ca58e0d351a$var$_isAvailableDefault(user, hour);
};
// Every prop factory below calls `findMe` directly — a former
// `const _me = findMe` alias sat here, which resolved fine for this file's
// own render pass but couldn't be chased back to the real `findMe` export
// when frank re-extracted any of these nested prop factories as a
// standalone unit (`unresolvable-identifier` on `_me`, same class as
// MemberProfile.js — see tickets/fable.md "decompose workspace-shell's
// 507 defects by owning package").
// CU-10 §90: roles/isAdmin removed from person object. Use canAdmin() which
// unions JWT perm check (admin.pages.read) with legacy role fallback.
const $0d6e5ca58e0d351a$var$_currentUserIsAdmin = (root)=>{
    if (!root) return false;
    // canAdmin uses Phase E JWT claim as primary path; falls back to userIsAdmin
    // which reads root.roles.byUser (populated from server member-roles endpoint).
    return (0, $9qRgv.canAdmin)({
        root: root
    });
};
// A member sets their OWN availability from their profile; admins can still
// edit anyone's. canEditProfile = self OR profile.edit_others OR superadmin.
const $0d6e5ca58e0d351a$var$_canEditAvailability = (state)=>{
    const root = state?.root;
    if (!root) return false;
    return (0, $9qRgv.canEditProfile)({
        root: root
    }, (0, $76fm2.findMe)(state)) || $0d6e5ca58e0d351a$var$_currentUserIsAdmin(root);
};
const $0d6e5ca58e0d351a$export$5bc2dfb247a1ef80 = {
    tag: 'button',
    border: 'none',
    padding: '0',
    height: 'A',
    minHeight: 'A',
    background: (el, s)=>{
        const u = (0, $76fm2.findMe)(el.state);
        return $0d6e5ca58e0d351a$var$_isAvailableAt(u, s.day, s.h) ? 'green' : 'red.15';
    },
    cursor: (el)=>$0d6e5ca58e0d351a$var$_canEditAvailability(el.state) ? 'pointer' : 'not-allowed',
    // Cell fill IS the data (green/red-tint) — a neutral 'hover' wash would
    // mute the signal, and it's too subtle to read per-cell in a 168-cell
    // grid. Hued-surface exception (§4.3): brightness step, not opacity.
    ':hover': {
        filter: 'brightness(1.12)'
    }
};
const $0d6e5ca58e0d351a$export$9c49f3715ff4d771 = {
    display: 'grid',
    gridTemplateColumns: 'auto repeat(24, minmax(32px, 1fr))',
    gridTemplateRows: 'auto repeat(7, auto)',
    gap: '1px',
    background: 'line',
    padding: '1px',
    round: 'radiusControl',
    overflowX: 'auto',
    overflowY: 'hidden',
    userSelect: 'none',
    // Tooltip binding
    attr: {
        title: (el, s)=>{
            const u = (0, $76fm2.findMe)(s);
            if (!s.root?.currentUserEmail || !u) return el.call('polyglot', 'account.member.availability.readOnly');
            if (s.root.currentUserEmail === u.email) return el.call('polyglot', 'account.member.availability.toggle');
            if ($0d6e5ca58e0d351a$var$_currentUserIsAdmin(s.root)) return el.call('polyglot', 'account.member.availability.toggleAdmin');
            return el.call('polyglot', 'account.member.availability.readOnly');
        }
    },
    // Event delegation: ONE declared click handler on the grid container.
    // FA503: was `el.node.addEventListener('click', …)` armed from `onCreate`
    // with no removal — every re-mount of the profile added another listener to
    // the same node, and the shift-range anchor lived in a closure that only
    // the listener could reach. Declared, DOMQL registers it once and removes it
    // in dispose(); the anchor rides the element itself.
    onClick: (e, el, s)=>{
        const btn = e.target.closest('button');
        if (!btn) return;
        const root = s.root || el.state?.root;
        // Self OR admin — a member sets their OWN availability on their profile.
        if (!$0d6e5ca58e0d351a$var$_canEditAvailability(el.state)) return;
        // Find day/hour from the button's data attributes
        const day = parseInt(btn.dataset.day);
        const hour = parseInt(btn.dataset.hour);
        if (isNaN(day) || isNaN(hour)) return;
        const user = (0, $76fm2.findMe)(el.state);
        if (!user) return;
        const grid = user.availabilityGrid ? user.availabilityGrid.map((row)=>row.slice()) : Array.from({
            length: 7
        }, ()=>Array.from({
                length: 24
            }, (_, h)=>$0d6e5ca58e0d351a$var$_isAvailableDefault(user, h)));
        const cellsToUpdate = [];
        const lastClicked = el._availLastClicked || null;
        if (e.shiftKey && lastClicked !== null) {
            const lastIndex = lastClicked.day * 24 + lastClicked.hour;
            const currentIndex = day * 24 + hour;
            const minIndex = Math.min(lastIndex, currentIndex);
            const maxIndex = Math.max(lastIndex, currentIndex);
            for(let ii = minIndex; ii <= maxIndex; ii++){
                const d = Math.floor(ii / 24);
                const h = ii % 24;
                grid[d][h] = lastClicked.targetState;
                cellsToUpdate.push({
                    d: d,
                    h: h,
                    state: lastClicked.targetState
                });
            }
        } else {
            const targetState = !grid[day][hour];
            grid[day][hour] = targetState;
            cellsToUpdate.push({
                d: day,
                h: hour,
                state: targetState
            });
            el._availLastClicked = {
                day: day,
                hour: hour,
                targetState: targetState
            };
        }
        const next = (root.people || []).map((p)=>p.email === user.email ? {
                ...p,
                availabilityGrid: grid
            } : p);
        root.update({
            people: next
        });
        el.call('saveAvailabilityGrid', root, user, grid);
        cellsToUpdate.forEach(({ d: d, h: h, state: state })=>{
            const targetBtn = el.node.querySelector(`button[data-day="${d}"][data-hour="${h}"]`);
            if (targetBtn) targetBtn.style.background = state ? 'var(--color-green)' : 'color-mix(in srgb, var(--color-red) 15%, transparent)';
        });
    },
    Corner: {
        background: 'modal',
        padding: 'Y'
    },
    HourHeaders: {
        display: 'contents',
        childExtends: {
            tag: 'span',
            background: 'modal',
            fontSize: 'Y2',
            color: 'caption',
            fontFamily: 'monospace',
            textAlign: 'center',
            padding: 'Y 0',
            text: (el, s)=>String(s.h).padStart(2, '0')
        },
        childrenAs: 'state',
        children: ()=>Array.from({
                length: 24
            }, (_, h)=>({
                    h: h
                }))
    },
    DayRows: {
        display: 'contents',
        childExtends: {
            display: 'contents',
            Label: {
                tag: 'span',
                background: 'modal',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '700',
                padding: 'Y Z',
                align: 'center right',
                // KEY-IN-STATE contract: `DAYS` carries the keys, this site resolves
                // them, so the strip re-renders on a language switch.
                text: (el, s)=>el.call('polyglot', s.label || '')
            },
            Cells: {
                display: 'contents',
                childExtends: {
                    tag: 'button',
                    border: 'none',
                    padding: '0',
                    height: 'A',
                    minHeight: 'A',
                    background: (el, s)=>{
                        const u = (0, $76fm2.findMe)(el.state);
                        return $0d6e5ca58e0d351a$var$_isAvailableAt(u, s.day, s.h) ? 'green' : 'red.15';
                    },
                    cursor: (el)=>$0d6e5ca58e0d351a$var$_canEditAvailability(el.state) ? 'pointer' : 'not-allowed',
                    // Hued-surface exception (§4.3) — see ProfileAvailabilityCell above.
                    ':hover': {
                        filter: 'brightness(1.12)'
                    },
                    // Store day/hour as data attributes for the delegated click handler
                    attr: {
                        'data-day': (el, s)=>s.day,
                        'data-hour': (el, s)=>s.h
                    }
                },
                childrenAs: 'state',
                children: (el, s)=>Array.from({
                        length: 24
                    }, (_, h)=>({
                            day: s.day,
                            h: h
                        }))
            }
        },
        childrenAs: 'state',
        children: ()=>$0d6e5ca58e0d351a$var$DAYS.map((label, day)=>({
                    day: day,
                    label: label
                }))
    }
};

});
parcelRegister("9qRgv", function(module, exports) {

$parcel$export(module.exports, "hasPermission", () => $6ddfdc2472f9489e$export$b325ec6732b039cf);
$parcel$export(module.exports, "canAdmin", () => $6ddfdc2472f9489e$export$ef34a013d83db0f0);
$parcel$export(module.exports, "canSuperadmin", () => $6ddfdc2472f9489e$export$98ebe541db8507e7);
$parcel$export(module.exports, "isSuperAdmin", () => $6ddfdc2472f9489e$export$35299ffa64889538);
$parcel$export(module.exports, "canAccessPrivate", () => $6ddfdc2472f9489e$export$fb0f0a656c460aeb);
$parcel$export(module.exports, "canEditProfile", () => $6ddfdc2472f9489e$export$c43c98c9a9584587);
$parcel$export(module.exports, "showsAvailability", () => $6ddfdc2472f9489e$export$236bba9f6e30c9d5);
$parcel$export(module.exports, "memberProfileView", () => $6ddfdc2472f9489e$export$d438573b07c40132);
$parcel$export(module.exports, "memberProfileSections", () => $6ddfdc2472f9489e$export$892e126179668f5c);
$parcel$export(module.exports, "showsMailSettings", () => $6ddfdc2472f9489e$export$d2ca4299f40dc998);
// Member-profile permission checks — canAdmin / canSuperadmin / isSuperAdmin /
// canAccessPrivate / canEditProfile — and the page's view rules (the two
// views, their section rail, the Mail card gate; foot of the file). Ported from workspace/functions/
// roleHelpers.js (2026-08-15, MemberProfile extraction — tickets/opus.md,
// Nika's "extract MemberProfile into shared" ruling) so MemberProfile can
// live here and stay reachable from every host (workspace, canvas).
//
// Lives in SHARED (not workspace) for the exact reason appAccess.js's
// `isOwnerOrAdmin` does (same folder, same file header) — shared is
// consumed by every host and must not depend on the workspace package.
// This REPLICATES the claim-based legs of roleHelpers.js `hasPermission` /
// `canAdmin` / `canSuperadmin` / `canAccessPrivate` / `canEditProfile` /
// `isSuperAdmin` (root.jwtClaims / root.org.role / root.org.permissions —
// same primitives, no cross-package import) plus the legacy
// `root.roles.byUser` dual-read fallback via `findPerson` (already in this
// package, peopleUtils.js). The ONE branch intentionally NOT replicated is
// claimResolver.js's local team-permission UNION fallback (needs
// workspace's PERMISSION_KEYS / CATEGORY_PERMISSION_TEMPLATES catalog, a
// workspace-only import this file can't take) — same skip appAccess.js
// already made, same reasoning: `org.permissions` / `org.intranetPermissions`
// is populated by the same `/auth/me` call every claims-reading gate here
// already depends on, so the fallback gap is the same cold-load window
// every other claim gate tolerates.
//
// ONE OWNER PER NAME: these six names are registered by shared only. The shell
// registers its own resolvers prefixed (shellHasPermission, shellCanAdmin, …,
// workspace/functions/roleHelpers.js); each export below hands the call to the
// shell's when the calling element's bag has it, so the shell keeps its
// team-permission union and a catalog merge never picks between two
// definitions of one name.
//
// Every export below is a regular `function` (never an arrow) so
// `el.call('canAdmin', …)` / `el.call('isSuperAdmin')`'s `this` binding
// (smbls element/src/methods.js `method.call(this, ...)`) survives —
// same convention roleHelpers.js documents at its own header.

var $76fm2 = parcelRequire("76fm2");
// Permission-array resolution — mirrors appAccess.js `canApp`'s
// `permissionsFromRoot`, itself mirroring the PREFERRED (server-enriched)
// branches of workspace/functions/claimResolver.js `resolveClaims`.
const $6ddfdc2472f9489e$var$_permissionsFromRoot = (root)=>{
    const org = root?.org;
    if (org && Array.isArray(org.permissions)) return org.permissions;
    if (org && Array.isArray(org.intranetPermissions)) return org.intranetPermissions;
    return root?.jwtClaims?.permissions || [];
};
// Owner bypass — mirrors roleHelpers.js `hasPermission`'s `_claims(r).is_owner`
// leg, sourced the same way appAccess.js `isOwnerOrAdmin` sources it.
const $6ddfdc2472f9489e$var$_isOwner = (root)=>{
    const claims = root?.jwtClaims || {};
    if (claims.is_owner === true) return true;
    return !!(root?.org && root.org.isOwner === true);
};
function $6ddfdc2472f9489e$export$b325ec6732b039cf(root, perm) {
    // Inside the shell, the shell's resolver answers (it adds the team-permission
    // union this file cannot import); one owner per name, see the file header.
    const _host = this && this.context && this.context.functions && this.context.functions.shellHasPermission;
    if (typeof _host === 'function') return _host.apply(this, arguments);
    const r = root != null ? root : this && this.state && this.state.root;
    if (!r) return false;
    if ($6ddfdc2472f9489e$var$_isOwner(r)) return true;
    return $6ddfdc2472f9489e$var$_permissionsFromRoot(r).includes(perm);
}
const $6ddfdc2472f9489e$var$_currentPerson = (root)=>root ? (0, $76fm2.findPerson)(root, root.currentUserEmail) : null;
// Legacy `root.roles.byUser` lookup — the dual-read fallback leg every
// gate below keeps for accounts without JWT-carried permissions yet.
const $6ddfdc2472f9489e$var$_legacyHasRole = (person, root, role)=>{
    if (!person) return false;
    if (Array.isArray(person.roles) && person.roles.length > 0) return person.roles.includes(role);
    if (!root || !person.userId) return false;
    return (root.roles?.byUser || {})[person.userId] === role;
};
const $6ddfdc2472f9489e$var$_legacyIsAdmin = (person, root)=>$6ddfdc2472f9489e$var$_legacyHasRole(person, root, 'superadmin') || $6ddfdc2472f9489e$var$_legacyHasRole(person, root, 'admin');
const $6ddfdc2472f9489e$var$_legacyIsSuperadmin = (person, root)=>$6ddfdc2472f9489e$var$_legacyHasRole(person, root, 'superadmin');
function $6ddfdc2472f9489e$export$ef34a013d83db0f0(s) {
    // Inside the shell, the shell's resolver answers (it adds the team-permission
    // union this file cannot import); one owner per name, see the file header.
    const _host = this && this.context && this.context.functions && this.context.functions.shellCanAdmin;
    if (typeof _host === 'function') return _host.apply(this, arguments);
    const root = s?.root || this && this.state && this.state.root;
    return $6ddfdc2472f9489e$export$b325ec6732b039cf(root, 'admin.pages.read') || $6ddfdc2472f9489e$var$_legacyIsAdmin($6ddfdc2472f9489e$var$_currentPerson(root), root);
}
function $6ddfdc2472f9489e$export$98ebe541db8507e7(s) {
    // Inside the shell, the shell's resolver answers (it adds the team-permission
    // union this file cannot import); one owner per name, see the file header.
    const _host = this && this.context && this.context.functions && this.context.functions.shellCanSuperadmin;
    if (typeof _host === 'function') return _host.apply(this, arguments);
    const root = s?.root || this && this.state && this.state.root;
    return $6ddfdc2472f9489e$export$b325ec6732b039cf(root, 'admin.danger.access') || $6ddfdc2472f9489e$var$_legacyIsSuperadmin($6ddfdc2472f9489e$var$_currentPerson(root), root);
}
function $6ddfdc2472f9489e$export$35299ffa64889538(s) {
    // Inside the shell, the shell's resolver answers (it adds the team-permission
    // union this file cannot import); one owner per name, see the file header.
    const _host = this && this.context && this.context.functions && this.context.functions.shellIsSuperAdmin;
    if (typeof _host === 'function') return _host.apply(this, arguments);
    const root = s && s.root || this && this.state && this.state.root;
    if (!root) return false;
    const claims = root.jwtClaims || {};
    if (claims.symbols_role === 'admin' || claims.symbolsRole === 'admin') return true;
    return $6ddfdc2472f9489e$var$_legacyIsSuperadmin($6ddfdc2472f9489e$var$_currentPerson(root), root);
}
function $6ddfdc2472f9489e$export$fb0f0a656c460aeb(sOrPerson, maybePerson) {
    // Inside the shell, the shell's resolver answers (it adds the team-permission
    // union this file cannot import); one owner per name, see the file header.
    const _host = this && this.context && this.context.functions && this.context.functions.shellCanAccessPrivate;
    if (typeof _host === 'function') return _host.apply(this, arguments);
    let root, person;
    if (maybePerson !== undefined) {
        root = sOrPerson?.root || this && this.state && this.state.root;
        person = maybePerson;
    } else {
        root = this && this.state && this.state.root;
        person = sOrPerson;
    }
    if (!root) return true;
    const isSelfUser = !person?.email || person.email === root.currentUserEmail;
    if (isSelfUser) return true;
    if ($6ddfdc2472f9489e$export$b325ec6732b039cf(root, 'profile.private.read')) return true;
    return $6ddfdc2472f9489e$var$_legacyIsSuperadmin($6ddfdc2472f9489e$var$_currentPerson(root), root);
}
function $6ddfdc2472f9489e$export$c43c98c9a9584587(sOrPerson, maybePerson) {
    // Inside the shell, the shell's resolver answers (it adds the team-permission
    // union this file cannot import); one owner per name, see the file header.
    const _host = this && this.context && this.context.functions && this.context.functions.shellCanEditProfile;
    if (typeof _host === 'function') return _host.apply(this, arguments);
    let root, person;
    if (maybePerson !== undefined) {
        root = sOrPerson?.root || this && this.state && this.state.root;
        person = maybePerson;
    } else {
        root = this && this.state && this.state.root;
        person = sOrPerson;
    }
    if (!root) return false;
    const isSelfUser = !person?.email || person.email === root.currentUserEmail;
    if (isSelfUser) return true;
    if ($6ddfdc2472f9489e$export$b325ec6732b039cf(root, 'profile.edit_others')) return true;
    return $6ddfdc2472f9489e$var$_legacyIsSuperadmin($6ddfdc2472f9489e$var$_currentPerson(root), root);
}
function $6ddfdc2472f9489e$export$236bba9f6e30c9d5(person, maybeRoot) {
    if (!person || !person.email) return false;
    if (person.status === 'left') return false;
    const outside = [
        'guest',
        'viewer'
    ];
    const legacy = Array.isArray(person.roles) && person.roles.length > 0 ? person.roles : null;
    if (legacy) return !legacy.every((r)=>outside.includes(r));
    const root = maybeRoot || this && this.state && this.state.root || {};
    const byUser = root.roles && root.roles.byUser || {};
    const role = person.userId && byUser[person.userId] || 'member';
    return !outside.includes(role);
}
function $6ddfdc2472f9489e$export$d438573b07c40132(state) {
    const el = this;
    const ask = (name, ...args)=>el && typeof el.call === 'function' ? el.call(name, ...args) : undefined;
    const root = state && state.root || el && el.state && el.state.root || null;
    const live = root && typeof root.currentPath === 'string' ? root.currentPath : '';
    let route = null;
    let node = el;
    let hops = 0;
    while(node && hops < 100){
        const pane = node._slotPaneKey;
        if (pane) {
            if (typeof node._slotHref === 'string') route = node._slotHref;
            else if (root && typeof root[pane] === 'string' && root[pane]) route = root[pane];
            if (route != null) break;
        }
        if (node.parent === node) break;
        node = node.parent;
        hops++;
    }
    let path = String(route == null ? live : route).split('?')[0].split('#')[0];
    const stripped = ask('stripWorkspacePrefix', path);
    if (typeof stripped === 'string') path = stripped;
    path = path.replace(/\/+$/, '') || '/';
    if (path !== '/settings' && path !== '/account') return 'profile';
    return ask('isSelf', state) === false ? 'profile' : 'settings';
}
function $6ddfdc2472f9489e$export$892e126179668f5c(state) {
    const el = this;
    const root = state && state.root || el && el.state && el.state.root || null;
    const row = (sectionKey, key)=>({
            sectionKey: sectionKey,
            label: el.call('polyglot', key)
        });
    const list = [
        row('Profile', 'account.profile.sections.profile')
    ];
    if (el.call('memberProfileView', state) === 'settings') {
        list.push(row('Accessibility', 'account.profile.sections.accessibility'));
        // The Assistant card shows wherever the shell's writer is present.
        const fns = el.context && el.context.functions;
        if (fns && typeof fns.setAssistantAnswersMode === 'function') list.push(row('Assistant', 'account.profile.sections.assistant'));
        list.push(row('Notifications', 'account.profile.sections.notifications'));
        if (el.call('showsMailSettings', state)) list.push(row('Mail', 'account.profile.sections.mail'));
        list.push(row('Security', 'account.profile.sections.security'), row('Sessions', 'account.profile.sections.sessions'), row('Danger zone', 'account.profile.sections.danger_zone'));
        return list;
    }
    const person = el.call('findMe', state) || {};
    list.push(row('Details', 'account.profile.sections.details'));
    if (el.call('showsAvailability', person, root)) list.push(row('Availability', 'account.profile.sections.availability'));
    if (el.call('canAccessPrivate', person)) list.push(row('Checklist', 'account.profile.sections.checklist'), row('Documents', 'account.profile.sections.documents'));
    if (!el.call('isSelf', state) && el.call('canSuperadmin', state)) list.push(row('Member access', 'account.profile.sections.access'));
    return list;
}
function $6ddfdc2472f9489e$export$d2ca4299f40dc998(state) {
    const el = this;
    const comps = el && el.context && el.context.components;
    if (!comps || !comps.MailAccountSettingsCard) return false;
    if (!el.call('isSelf', state)) return false;
    const root = state && state.root || el.state && el.state.root || null;
    return !!el.call('navItemVisible', root, '/mail');
}

});


parcelRegister("i41vD", function(module, exports) {

$parcel$export(module.exports, "applyMarkdownToElement", () => $d269c56c0dbb3e45$export$1daceb1e81e67587);
$parcel$export(module.exports, "markdownToChildren", () => $d269c56c0dbb3e45$export$a1da4c6d15571a03);
$parcel$export(module.exports, "highlightMarkdownRefs", () => $d269c56c0dbb3e45$export$298e632b10b81801);
$parcel$export(module.exports, "MarkdownPreview", () => $d269c56c0dbb3e45$export$e52fbcfb1760e90c);
// Single unified markdown previewer for the workspace.
//
// Workspace-project pages (tickets, docs, knowledge-base) own their page-level
// H1/H2 chrome, so user-supplied markdown must never claim those heading slots.
// When `demoteHeadings` is true (default): h1→H4, h2→H5, h3-h6→H6.
// When false: native H1-H6 are used (useful for stand-alone surfaces where the
// markdown IS the primary content).
//
// Props:
//   markdown       — the markdown source string (or an (el, s) factory)
//   text           — DEPRECATED alias for `markdown`; see the component below
//   withMentions   — default false; when true applies @mention / #channel highlighting
//   demoteHeadings — default true; h1→H4, h2→H5, h3-h6→H6
//
// Internal rendering delegates to transformMarkdown from symbolize-markdown.
// Caches on el._lastMd to skip unchanged updates.
//
// Chat-specific highlights (##ticket, @@event, +reference) are always applied
// when the body contains the respective patterns — they only fire when the regex
// matches so they are safe for non-chat surfaces (tickets, docs).

var $3Rzdu = parcelRequire("3Rzdu");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
// ⚠ DOCUMENTED FRANK EXCEPTION (2026-08-14) — this one import is the entire
// source of this package's 14 remaining `frank to-json`
// `unresolvable-identifier` findings, and none of them can be fixed here.
// `@symbo.ls/symbolize-markdown` is on frank's `BUNDLE_INLINE_PACKAGES`
// allowlist (smbls/plugins/frank/toJSON.js) — deliberately, because stubbing
// it made a module-load-time `transformMarkdown(...)` serialize as `""` and
// blanked 96% of the docs page — so frank inlines its PUBLISHED, MINIFIED
// dist and lifts its internals into globalScope as single-letter entries
// (`globalScope.F/C/B/M/S/E/g2` — the markdown block splitter, node
// dispatcher, heading/paragraph/table builders and inline-span mapper). Their
// free variables (`q u x j v r m k`) are sibling minified declarations inside
// that same dist — all eight verified present in
// node_modules/@symbo.ls/symbolize-markdown/dist/esm/index.js — which the
// lift does not carry across. Nothing in this package's source can change
// that; it is a frank-vs-minified-dist interaction. Do not "fix" it by
// dropping the import.
// FA204/FA207 / frank trap — `applyMarkdownToElement` is genuinely called via
// `el.call('applyMarkdownToElement', …)` from tickets/TicketDetailModal.js
// (its own comment explains why: a raw cross-package import gets stubbed by
// frank's EXTERNAL_PACKAGES at serialization time, so it reaches this
// function through the runtime-merged context instead — the SAME merged
// context that also makes a bare module-scope/sibling-export read
// unresolvable once this file's exports are individually frank.toJSON'd;
// project_frank_drops_module_local_helpers, the readerVoice.js precedent).
// Both `applyMarkdownToElement` and `markdownToChildren` below are therefore
// fully self-contained — every table/regex/helper they need is a LOCAL
// declaration inside their own body, duplicated rather than shared with
// MarkdownPreview's own (separately duplicated) `scope` methods, since a
// plain arrow export has no `this`/`el.scope` of its own to route through.
//
// `highlightMentions` / `highlightChannels` go through `el.call` for the same
// reason and are NOT imported. They live in `@symbo-ls/workspace-chat`, which
// is not even a declared dependency of this package — the old raw
// `import … from '@symbo-ls/workspace-chat/functions/highlightMentions.js'`
// resolved only through outer-monorepo hoisting (a phantom dependency), and it
// also pointed the shared layer at a feature package that sits ABOVE it. At
// serialization time esbuild turned it into a namespace object frank cannot
// lift, so both reads emitted as `__scope.import_highlightMentions.<name>`
// with nothing backing them: a TypeError on the first @mention in any
// frank-served chat/ticket body (`frank to-json`:
// `scope-read-name-collision`/`import_highlightMentions`, 4 findings). Chat
// barrels both functions (`packages/chat/functions/index.js:13`), so the
// merged runtime context carries them wherever chat is linked; a host that
// does NOT link chat now simply renders the markdown without mention
// highlighting instead of throwing.
// ── Core render helper — also used by the back-compat shim ─────────────────
// Exposed as a named export so renderMarkdown.js can delegate to it without
// importing the DOMQL component (avoids circular deps). Consumers calling the
// function path (el.call / imperative) always use this helper directly.
//
// Options:
//   withMentions   — boolean (default false)
//   demoteHeadings — boolean (default true)
//   people         — array of person objects for @mention resolution
//   channels       — array of channel objects for #channel resolution
//   components     — optional custom components map (overrides the demote/native map)
// A reference badge is an icon glyph plus PLAIN TEXT, and the text half is
// server data: a ticket title, an event title, a reference type. Building it
// as an HTML string put that data through `innerHTML`, so a title carrying
// markup ran in the bubble of every reader who saw the message. The glyph is
// a constant from CARD_ICONS; the data goes in a TEXT NODE, where markup is
// characters and nothing else. Module-level on purpose: frank lifts a plain
// module-level function whole, and the serialized methods below call it.
const $d269c56c0dbb3e45$var$paintRefBadge = (span, icon, text)=>{
    const glyph = span.ownerDocument.createElement('span');
    glyph.textContent = icon;
    span.replaceChildren(glyph, span.ownerDocument.createTextNode(text));
};
const $d269c56c0dbb3e45$export$1daceb1e81e67587 = (el, body, emptyNode, options = {})=>{
    const DEMOTE_COMPONENTS = {
        em: 'Em',
        h1: 'H4',
        h2: 'H5',
        h3: 'H6',
        h4: 'H6',
        h5: 'H6',
        h6: 'H6',
        hr: 'Hr',
        li: 'LI',
        ol: 'OL',
        ul: 'UL',
        del: 'Del',
        img: 'Img',
        pre: 'Pre',
        code: 'InlineCode',
        link: 'Link',
        strong: 'Strong',
        codeBlock: 'CodeBlock',
        paragraph: 'P',
        blockquote: 'Blockquote'
    };
    const NATIVE_COMPONENTS = {
        em: 'Em',
        h1: 'H1',
        h2: 'H2',
        h3: 'H3',
        h4: 'H4',
        h5: 'H5',
        h6: 'H6',
        hr: 'Hr',
        li: 'LI',
        ol: 'OL',
        ul: 'UL',
        del: 'Del',
        img: 'Img',
        pre: 'Pre',
        code: 'InlineCode',
        link: 'Link',
        strong: 'Strong',
        codeBlock: 'CodeBlock',
        paragraph: 'P',
        blockquote: 'Blockquote'
    };
    // Reference-card chrome (mirrors renderMarkdown.js's own duplicate copy).
    const CARD_BASE = 'display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:6px;font-size:13px;font-weight:700;cursor:pointer;vertical-align:middle;text-decoration:none;';
    const CARD_STYLES = {
        ticket: CARD_BASE + 'color:var(--color-orange,#f59e0b);background:rgba(245,158,11,0.1);',
        event: CARD_BASE + 'color:var(--color-blue,#6366f1);background:rgba(99,102,241,0.1);',
        reference: CARD_BASE + 'color:var(--color-green,#22c55e);background:rgba(34,197,94,0.1);'
    };
    const CARD_ICONS = {
        ticket: "\u25A0",
        event: "\u25CB",
        reference: "\u25C6"
    };
    const replaceTextNodes = (targetEl, regex, makeSpan)=>{
        if (!targetEl || !targetEl.node) return [];
        const walker = document.createTreeWalker(targetEl.node, NodeFilter.SHOW_TEXT);
        const replacements = [];
        let textNode;
        while(textNode = walker.nextNode()){
            regex.lastIndex = 0;
            if (!regex.test(textNode.textContent)) continue;
            replacements.push(textNode);
        }
        const spans = [];
        for (const node of replacements){
            if (!node.parentNode) continue;
            const frag = document.createDocumentFragment();
            let last = 0;
            regex.lastIndex = 0;
            let match;
            while((match = regex.exec(node.textContent)) !== null){
                if (match.index > last) frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)));
                const span = makeSpan(match);
                spans.push(span);
                frag.appendChild(span);
                last = match.index + match[0].length;
            }
            if (last < node.textContent.length) frag.appendChild(document.createTextNode(node.textContent.slice(last)));
            node.parentNode.replaceChild(frag, node);
        }
        return spans;
    };
    // Anchored at start-of-string OR a whitespace boundary so `1##5` (inline
    // math, version strings, etc.) doesn't trigger a ticket badge.
    const TICKET_RE = /(?<=^|\s)##(\d+)/g;
    const highlightTickets = (targetEl)=>{
        const spans = replaceTextNodes(targetEl, TICKET_RE, (match)=>{
            const num = parseInt(match[1], 10);
            const span = document.createElement('span');
            span.style.cssText = CARD_STYLES.ticket;
            span.setAttribute('data-ref-ticket', String(num));
            $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.ticket, ` #${num}`);
            return span;
        });
        if (!spans.length) return;
        const numbers = spans.map((s)=>parseInt(s.getAttribute('data-ref-ticket'), 10));
        // Phase 4: sdk.tickets.list (Mongo-backed main server)
        // getService is Proxy-deferred — resolve the service first, then call list.
        Promise.resolve((0, $1NxyO.getSDK)().getService('tickets')).then((svc)=>svc.list({
                deleted: false,
                number_in: [
                    ...new Set(numbers)
                ]
            }, {
                columns: 'id,number,title,state,columnKey'
            })).then((res)=>{
            const data = Array.isArray(res) ? res : res?.data || res?.rows || [];
            const map = {};
            for (const t of data || [])map[t.number] = t;
            for (const span of spans){
                const num = parseInt(span.getAttribute('data-ref-ticket'), 10);
                const ticket = map[num];
                if (ticket) $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.ticket, ` #${num} \xb7 ${(ticket.title || '').slice(0, 40)}`);
            }
        }).catch(()=>{});
    };
    // Drop space from the capture class so `@@my-event with more text` only
    // matches `my-event`, not `my-event with more text`.
    const EVENT_RE = /(?<=^|\s)@@([a-zA-Z0-9._-]+)/g;
    const highlightEvents = (targetEl)=>{
        const spans = replaceTextNodes(targetEl, EVENT_RE, (match)=>{
            const title = match[1].trim();
            const span = document.createElement('span');
            span.style.cssText = CARD_STYLES.event;
            span.setAttribute('data-ref-event', title);
            $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.event, ` ${title}`);
            return span;
        });
        if (!spans.length) return;
        const titles = [
            ...new Set(spans.map((s)=>s.getAttribute('data-ref-event')))
        ];
        // migrated 2026-04-27 to SDK route workspaceProject.calendar/list
        (0, $1NxyO.getSDK)().execute('workspaceProject.calendar', 'list', {
            filter: {
                title_in: titles
            }
        }).then((res)=>{
            const data = Array.isArray(res) ? res : res?.data || res?.events || res?.rows || [];
            const map = {};
            for (const ev of data || [])if (ev?.title) map[ev.title.toLowerCase()] = ev;
            for (const span of spans){
                const title = span.getAttribute('data-ref-event');
                const ev = map[title.toLowerCase()];
                if (ev && ev.date) $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.event, ` ${title} \xb7 ${ev.date}`);
            }
        }).catch(()=>{});
    };
    const REF_RE = /(?<=^|\s)\+([a-zA-Z0-9._-]+)/g;
    const highlightReferences = (targetEl)=>{
        const spans = replaceTextNodes(targetEl, REF_RE, (match)=>{
            const title = match[1].trim();
            const span = document.createElement('span');
            span.style.cssText = CARD_STYLES.reference;
            span.setAttribute('data-ref-doc', title);
            $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.reference, ` ${title}`);
            return span;
        });
        if (!spans.length) return;
        const titles = [
            ...new Set(spans.map((s)=>s.getAttribute('data-ref-doc')))
        ];
        // Migrated 2026-05-19: workspaceProject.documents.notes/.kb → sdk.docs.notes/.kbArticles (Mongo).
        Promise.all([
            (0, $1NxyO.getSDK)().execute('docs.notes', 'list', {
                filter: {
                    title_in: titles
                }
            }),
            (0, $1NxyO.getSDK)().execute('docs.kbArticles', 'list', {
                filter: {
                    title_in: titles
                }
            })
        ]).then(([notesRes, kbRes])=>{
            const notesData = Array.isArray(notesRes) ? notesRes : notesRes?.data || notesRes?.notes || notesRes?.rows || [];
            const kbData = Array.isArray(kbRes) ? kbRes : kbRes?.data || kbRes?.articles || kbRes?.rows || [];
            const map = {};
            for (const n of notesData || [])if (n?.title) map[n.title.toLowerCase()] = 'Note';
            for (const a of kbData || [])if (a?.title) map[a.title.toLowerCase()] = 'KB';
            for (const span of spans){
                const title = span.getAttribute('data-ref-doc');
                const type = map[title.toLowerCase()];
                if (type) $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.reference, ` ${title} \xb7 ${type}`);
            }
        }).catch(()=>{});
    };
    const { withMentions: withMentions = false, demoteHeadings: demoteHeadings = true, people: people, channels: channels, components: customComponents } = options;
    if (!el || typeof el.set !== 'function') return;
    if (el._lastMd === body) return;
    el._lastMd = body;
    if (!body) {
        el.set(emptyNode || {
            tag: 'span',
            text: ''
        });
        return;
    }
    const components = customComponents || (demoteHeadings ? DEMOTE_COMPONENTS : NATIVE_COMPONENTS);
    // A node that renders child nodes says `text: null`: a library's bare-key
    // component may carry demo text (see markdownToChildren below). On dev
    // system/hq every ticket paragraph that started with bold text read
    // "It was the last day for our tribe, the year ends" first.
    const ownTextOnly = (node)=>{
        if (!node || typeof node !== 'object' || Array.isArray(node)) return node;
        const out = {
            ...node
        };
        let hasKids = false;
        for (const k of Object.keys(out)){
            const v = out[k];
            if (/^[A-Z]/.test(k) && v && typeof v === 'object' && !Array.isArray(v)) {
                hasKids = true;
                out[k] = ownTextOnly(v);
            }
        }
        if (Array.isArray(out.children) && out.children.length) {
            hasKids = true;
            out.children = out.children.map(ownTextOnly);
        }
        if (hasKids && out.text === undefined) out.text = null;
        return out;
    };
    try {
        el.set(ownTextOnly((0, $3Rzdu.transformMarkdown)(body, {
            components: components
        })));
    } catch (_) {
        el.set({
            tag: 'span',
            text: body
        });
    }
    requestAnimationFrame(()=>{
        // Run longer-prefix patterns FIRST (## before #, @@ before @).
        TICKET_RE.lastIndex = 0;
        if (TICKET_RE.test(body)) highlightTickets(el);
        EVENT_RE.lastIndex = 0;
        if (EVENT_RE.test(body)) highlightEvents(el);
        REF_RE.lastIndex = 0;
        if (REF_RE.test(body)) highlightReferences(el);
        if (withMentions) {
            const MENTION_RE = /(?<=^|\s)@([a-zA-Z0-9._-]+)/g;
            MENTION_RE.lastIndex = 0;
            if (MENTION_RE.test(body)) el.call('highlightMentions', el, people);
            const CHANNEL_RE = /(?<=^|\s)#([a-zA-Z0-9._-]+)/g;
            CHANNEL_RE.lastIndex = 0;
            if (CHANNEL_RE.test(body)) el.call('highlightChannels', el, channels);
        }
    });
};
const $d269c56c0dbb3e45$export$a1da4c6d15571a03 = (body, options = {})=>{
    const DEMOTE_COMPONENTS = {
        em: 'Em',
        h1: 'H4',
        h2: 'H5',
        h3: 'H6',
        h4: 'H6',
        h5: 'H6',
        h6: 'H6',
        hr: 'Hr',
        li: 'LI',
        ol: 'OL',
        ul: 'UL',
        del: 'Del',
        img: 'Img',
        pre: 'Pre',
        code: 'InlineCode',
        link: 'Link',
        strong: 'Strong',
        codeBlock: 'CodeBlock',
        paragraph: 'P',
        blockquote: 'Blockquote'
    };
    const NATIVE_COMPONENTS = {
        em: 'Em',
        h1: 'H1',
        h2: 'H2',
        h3: 'H3',
        h4: 'H4',
        h5: 'H5',
        h6: 'H6',
        hr: 'Hr',
        li: 'LI',
        ol: 'OL',
        ul: 'UL',
        del: 'Del',
        img: 'Img',
        pre: 'Pre',
        code: 'InlineCode',
        link: 'Link',
        strong: 'Strong',
        codeBlock: 'CodeBlock',
        paragraph: 'P',
        blockquote: 'Blockquote'
    };
    if (!body) return [];
    const { demoteHeadings: demoteHeadings = true, components: customComponents } = options;
    const components = customComponents || (demoteHeadings ? DEMOTE_COMPONENTS : NATIVE_COMPONENTS);
    // A node that renders child nodes has no text of its own, and says so. The
    // component keys above are BARE keys, so they resolve through the linked
    // libraries too, and a library's component may carry demo text: in
    // system/default `P`, `Caption` and `H1`–`H6` read "It was the last day for
    // our tribe, the year ends", `Link` reads "Link", `Strong` "Strong text".
    // A paragraph whose words all sit in child nodes (`**Subject**` alone, or
    // span + strong + span) has no `text`, so it showed that sentence before
    // its own words (dev, system/hq chat, 2026-10-28). `text: null` cancels an
    // inherited text — the rule renderAssistantMarkdown already applies.
    const ownTextOnly = (node)=>{
        if (!node || typeof node !== 'object' || Array.isArray(node)) return node;
        const out = {
            ...node
        };
        let hasKids = false;
        for (const k of Object.keys(out)){
            const v = out[k];
            if (/^[A-Z]/.test(k) && v && typeof v === 'object' && !Array.isArray(v)) {
                hasKids = true;
                out[k] = ownTextOnly(v);
            }
        }
        if (Array.isArray(out.children) && out.children.length) {
            hasKids = true;
            out.children = out.children.map(ownTextOnly);
        }
        if (hasKids && out.text === undefined) out.text = null;
        return out;
    };
    try {
        const spec = (0, $3Rzdu.transformMarkdown)(body, {
            components: components
        });
        if (!spec || typeof spec !== 'object') return [
            {
                tag: 'span',
                text: body
            }
        ];
        // transformMarkdown returns either a single node ({tag|extends|text|children})
        // or a keyed object of top-level nodes — normalize both to a children array.
        if ('extends' in spec || 'tag' in spec || 'text' in spec || 'children' in spec) return [
            ownTextOnly(spec)
        ];
        return Object.keys(spec).filter((k)=>!k.startsWith('__')).map((k)=>spec[k]).filter((v)=>v && typeof v === 'object').map(ownTextOnly);
    } catch (_) {
        return [
            {
                tag: 'pre',
                whiteSpace: 'pre-wrap',
                text: body
            }
        ];
    }
};
const $d269c56c0dbb3e45$export$298e632b10b81801 = (el, body)=>{
    if (!el || !el.node || !body) return;
    const CARD_BASE = 'display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:6px;font-size:13px;font-weight:700;cursor:pointer;vertical-align:middle;text-decoration:none;';
    const CARD_STYLES = {
        ticket: CARD_BASE + 'color:var(--color-orange,#f59e0b);background:rgba(245,158,11,0.1);',
        event: CARD_BASE + 'color:var(--color-blue,#6366f1);background:rgba(99,102,241,0.1);',
        reference: CARD_BASE + 'color:var(--color-green,#22c55e);background:rgba(34,197,94,0.1);'
    };
    const CARD_ICONS = {
        ticket: "\u25A0",
        event: "\u25CB",
        reference: "\u25C6"
    };
    const replaceTextNodes = (targetEl, regex, makeSpan)=>{
        if (!targetEl || !targetEl.node) return [];
        const walker = document.createTreeWalker(targetEl.node, NodeFilter.SHOW_TEXT);
        const replacements = [];
        let textNode;
        while(textNode = walker.nextNode()){
            regex.lastIndex = 0;
            if (!regex.test(textNode.textContent)) continue;
            replacements.push(textNode);
        }
        const spans = [];
        for (const node of replacements){
            if (!node.parentNode) continue;
            const frag = document.createDocumentFragment();
            let last = 0;
            regex.lastIndex = 0;
            let match;
            while((match = regex.exec(node.textContent)) !== null){
                if (match.index > last) frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)));
                const span = makeSpan(match);
                spans.push(span);
                frag.appendChild(span);
                last = match.index + match[0].length;
            }
            if (last < node.textContent.length) frag.appendChild(document.createTextNode(node.textContent.slice(last)));
            node.parentNode.replaceChild(frag, node);
        }
        return spans;
    };
    // Anchored at start-of-string OR a whitespace boundary so `1##5` (inline
    // math, version strings, etc.) doesn't trigger a ticket badge.
    const TICKET_RE = /(?<=^|\s)##(\d+)/g;
    const highlightTickets = (targetEl)=>{
        const spans = replaceTextNodes(targetEl, TICKET_RE, (match)=>{
            const num = parseInt(match[1], 10);
            const span = document.createElement('span');
            span.style.cssText = CARD_STYLES.ticket;
            span.setAttribute('data-ref-ticket', String(num));
            $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.ticket, ` #${num}`);
            return span;
        });
        if (!spans.length) return;
        const numbers = spans.map((s)=>parseInt(s.getAttribute('data-ref-ticket'), 10));
        // getService is Proxy-deferred — resolve the service first, then call list.
        Promise.resolve((0, $1NxyO.getSDK)().getService('tickets')).then((svc)=>svc.list({
                deleted: false,
                number_in: [
                    ...new Set(numbers)
                ]
            }, {
                columns: 'id,number,title,state,columnKey'
            })).then((res)=>{
            const data = Array.isArray(res) ? res : res?.data || res?.rows || [];
            const map = {};
            for (const t of data || [])map[t.number] = t;
            for (const span of spans){
                if (!span.isConnected) continue;
                const num = parseInt(span.getAttribute('data-ref-ticket'), 10);
                const ticket = map[num];
                if (ticket) $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.ticket, ` #${num} \xb7 ${(ticket.title || '').slice(0, 40)}`);
            }
        }).catch(()=>{});
    };
    // Drop space from the capture class so `@@my-event with more text` only
    // matches `my-event`, not `my-event with more text`.
    const EVENT_RE = /(?<=^|\s)@@([a-zA-Z0-9._-]+)/g;
    const highlightEvents = (targetEl)=>{
        const spans = replaceTextNodes(targetEl, EVENT_RE, (match)=>{
            const title = match[1].trim();
            const span = document.createElement('span');
            span.style.cssText = CARD_STYLES.event;
            span.setAttribute('data-ref-event', title);
            $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.event, ` ${title}`);
            return span;
        });
        if (!spans.length) return;
        const titles = [
            ...new Set(spans.map((s)=>s.getAttribute('data-ref-event')))
        ];
        (0, $1NxyO.getSDK)().execute('workspaceProject.calendar', 'list', {
            filter: {
                title_in: titles
            }
        }).then((res)=>{
            const data = Array.isArray(res) ? res : res?.data || res?.events || res?.rows || [];
            const map = {};
            for (const ev of data || [])if (ev?.title) map[ev.title.toLowerCase()] = ev;
            for (const span of spans){
                if (!span.isConnected) continue;
                const title = span.getAttribute('data-ref-event');
                const ev = map[title.toLowerCase()];
                if (ev && ev.date) $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.event, ` ${title} \xb7 ${ev.date}`);
            }
        }).catch(()=>{});
    };
    const REF_RE = /(?<=^|\s)\+([a-zA-Z0-9._-]+)/g;
    const highlightReferences = (targetEl)=>{
        const spans = replaceTextNodes(targetEl, REF_RE, (match)=>{
            const title = match[1].trim();
            const span = document.createElement('span');
            span.style.cssText = CARD_STYLES.reference;
            span.setAttribute('data-ref-doc', title);
            $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.reference, ` ${title}`);
            return span;
        });
        if (!spans.length) return;
        const titles = [
            ...new Set(spans.map((s)=>s.getAttribute('data-ref-doc')))
        ];
        Promise.all([
            (0, $1NxyO.getSDK)().execute('docs.notes', 'list', {
                filter: {
                    title_in: titles
                }
            }),
            (0, $1NxyO.getSDK)().execute('docs.kbArticles', 'list', {
                filter: {
                    title_in: titles
                }
            })
        ]).then(([notesRes, kbRes])=>{
            const notesData = Array.isArray(notesRes) ? notesRes : notesRes?.data || notesRes?.notes || notesRes?.rows || [];
            const kbData = Array.isArray(kbRes) ? kbRes : kbRes?.data || kbRes?.articles || kbRes?.rows || [];
            const map = {};
            for (const n of notesData || [])if (n?.title) map[n.title.toLowerCase()] = 'Note';
            for (const a of kbData || [])if (a?.title) map[a.title.toLowerCase()] = 'KB';
            for (const span of spans){
                if (!span.isConnected) continue;
                const title = span.getAttribute('data-ref-doc');
                const type = map[title.toLowerCase()];
                if (type) $d269c56c0dbb3e45$var$paintRefBadge(span, CARD_ICONS.reference, ` ${title} \xb7 ${type}`);
            }
        }).catch(()=>{});
    };
    // Longer-prefix patterns FIRST (## before #, @@ before @) — the mention and
    // channel passes that run after this one match the single-char prefixes.
    TICKET_RE.lastIndex = 0;
    if (TICKET_RE.test(body)) highlightTickets(el);
    EVENT_RE.lastIndex = 0;
    if (EVENT_RE.test(body)) highlightEvents(el);
    REF_RE.lastIndex = 0;
    if (REF_RE.test(body)) highlightReferences(el);
};
const $d269c56c0dbb3e45$export$e52fbcfb1760e90c = {
    // FA204 / frank trap — the render logic used to be a bare module-scope
    // `_render` (assigned directly to onCreate/onUpdate) that called the
    // exported `applyMarkdownToElement` — a free-variable reference that
    // silently reads as undefined once this component is frank.toJSON'd for
    // platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). `applyMarkdownToElement` /
    // `markdownToChildren` above are now FULLY SELF-CONTAINED exports (see
    // their own header comment) rather than shared with these `scope`
    // methods — `applyMarkdownToElement` is genuinely reached via
    // `el.call('applyMarkdownToElement', …)` from tickets/TicketDetailModal.js
    // (a DIFFERENT top-level export can't route through THIS component's
    // scope anyway), so both halves independently duplicate the same
    // render pipeline (regexes, card styles/icons, the three
    // reference-highlighters). This half is called via
    // `el.scope.<name>`/`this.<name>`, so MarkdownPreview's own
    // onCreate/onUpdate resolve post-frank without touching the exported
    // utility's call graph.
    scope: {
        DEMOTE_COMPONENTS: {
            em: 'Em',
            h1: 'H4',
            h2: 'H5',
            h3: 'H6',
            h4: 'H6',
            h5: 'H6',
            h6: 'H6',
            hr: 'Hr',
            li: 'LI',
            ol: 'OL',
            ul: 'UL',
            del: 'Del',
            img: 'Img',
            pre: 'Pre',
            code: 'InlineCode',
            link: 'Link',
            strong: 'Strong',
            codeBlock: 'CodeBlock',
            paragraph: 'P',
            blockquote: 'Blockquote'
        },
        NATIVE_COMPONENTS: {
            em: 'Em',
            h1: 'H1',
            h2: 'H2',
            h3: 'H3',
            h4: 'H4',
            h5: 'H5',
            h6: 'H6',
            hr: 'Hr',
            li: 'LI',
            ol: 'OL',
            ul: 'UL',
            del: 'Del',
            img: 'Img',
            pre: 'Pre',
            code: 'InlineCode',
            link: 'Link',
            strong: 'Strong',
            codeBlock: 'CodeBlock',
            paragraph: 'P',
            blockquote: 'Blockquote'
        },
        CARD_STYLES: {
            ticket: 'display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:6px;font-size:13px;font-weight:700;cursor:pointer;vertical-align:middle;text-decoration:none;color:var(--color-orange,#f59e0b);background:rgba(245,158,11,0.1);',
            event: 'display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:6px;font-size:13px;font-weight:700;cursor:pointer;vertical-align:middle;text-decoration:none;color:var(--color-blue,#6366f1);background:rgba(99,102,241,0.1);',
            reference: 'display:inline-flex;align-items:center;gap:6px;padding:3px 8px;border-radius:6px;font-size:13px;font-weight:700;cursor:pointer;vertical-align:middle;text-decoration:none;color:var(--color-green,#22c55e);background:rgba(34,197,94,0.1);'
        },
        CARD_ICONS: {
            ticket: "\u25A0",
            event: "\u25CB",
            reference: "\u25C6"
        },
        // Anchored at start-of-string OR a whitespace boundary so `1##5` (inline
        // math, version strings, etc.) doesn't trigger a ticket badge. The
        // negative-lookahead `(?!\s)` after the trigger prevents `## foo` (with
        // space after the trigger) from greedy-matching the rest of a sentence
        // into a single badge — empirically that produced labels like
        // "send flow verified end-to-end" out of "+ send flow verified ...".
        TICKET_RE: /(?<=^|\s)##(\d+)/g,
        // Drop space from the capture class so `@@my-event with more text` only
        // matches `my-event`, not `my-event with more text`. The composer's
        // autocomplete inserts the title's slug (alphanumeric + dot/underscore/
        // dash), so multi-word titles aren't broken by this; free-form typing
        // gracefully stops at the first space.
        EVENT_RE: /(?<=^|\s)@@([a-zA-Z0-9._-]+)/g,
        REF_RE: /(?<=^|\s)\+([a-zA-Z0-9._-]+)/g,
        replaceTextNodes (el, regex, makeSpan) {
            if (!el || !el.node) return [];
            const walker = document.createTreeWalker(el.node, NodeFilter.SHOW_TEXT);
            const replacements = [];
            let textNode;
            while(textNode = walker.nextNode()){
                regex.lastIndex = 0;
                if (!regex.test(textNode.textContent)) continue;
                replacements.push(textNode);
            }
            const spans = [];
            for (const node of replacements){
                if (!node.parentNode) continue;
                const frag = document.createDocumentFragment();
                let last = 0;
                regex.lastIndex = 0;
                let match;
                while((match = regex.exec(node.textContent)) !== null){
                    if (match.index > last) frag.appendChild(document.createTextNode(node.textContent.slice(last, match.index)));
                    const span = makeSpan(match);
                    spans.push(span);
                    frag.appendChild(span);
                    last = match.index + match[0].length;
                }
                if (last < node.textContent.length) frag.appendChild(document.createTextNode(node.textContent.slice(last)));
                node.parentNode.replaceChild(frag, node);
            }
            return spans;
        },
        highlightTickets (el) {
            const spans = this.replaceTextNodes(el, this.TICKET_RE, (match)=>{
                const num = parseInt(match[1], 10);
                const span = document.createElement('span');
                span.style.cssText = this.CARD_STYLES.ticket;
                span.setAttribute('data-ref-ticket', String(num));
                $d269c56c0dbb3e45$var$paintRefBadge(span, this.CARD_ICONS.ticket, ` #${num}`);
                return span;
            });
            if (!spans.length) return;
            const numbers = spans.map((s)=>parseInt(s.getAttribute('data-ref-ticket'), 10));
            // Phase 4: sdk.tickets.list (Mongo-backed main server)
            // getService is Proxy-deferred — resolve the service first, then call list.
            Promise.resolve((0, $1NxyO.getSDK)().getService('tickets')).then((svc)=>svc.list({
                    deleted: false,
                    number_in: [
                        ...new Set(numbers)
                    ]
                }, {
                    columns: 'id,number,title,state,columnKey'
                })).then((res)=>{
                const data = Array.isArray(res) ? res : res?.data || res?.rows || [];
                const map = {};
                for (const t of data || [])map[t.number] = t;
                for (const span of spans){
                    const num = parseInt(span.getAttribute('data-ref-ticket'), 10);
                    const ticket = map[num];
                    if (ticket) $d269c56c0dbb3e45$var$paintRefBadge(span, this.CARD_ICONS.ticket, ` #${num} \xb7 ${(ticket.title || '').slice(0, 40)}`);
                }
            }).catch(()=>{});
        },
        highlightEvents (el) {
            const spans = this.replaceTextNodes(el, this.EVENT_RE, (match)=>{
                const title = match[1].trim();
                const span = document.createElement('span');
                span.style.cssText = this.CARD_STYLES.event;
                span.setAttribute('data-ref-event', title);
                $d269c56c0dbb3e45$var$paintRefBadge(span, this.CARD_ICONS.event, ` ${title}`);
                return span;
            });
            if (!spans.length) return;
            const titles = [
                ...new Set(spans.map((s)=>s.getAttribute('data-ref-event')))
            ];
            // migrated 2026-04-27 to SDK route workspaceProject.calendar/list
            (0, $1NxyO.getSDK)().execute('workspaceProject.calendar', 'list', {
                filter: {
                    title_in: titles
                }
            }).then((res)=>{
                const data = Array.isArray(res) ? res : res?.data || res?.events || res?.rows || [];
                const map = {};
                for (const ev of data || [])if (ev?.title) map[ev.title.toLowerCase()] = ev;
                for (const span of spans){
                    const title = span.getAttribute('data-ref-event');
                    const ev = map[title.toLowerCase()];
                    if (ev && ev.date) $d269c56c0dbb3e45$var$paintRefBadge(span, this.CARD_ICONS.event, ` ${title} \xb7 ${ev.date}`);
                }
            }).catch(()=>{});
        },
        highlightReferences (el) {
            const spans = this.replaceTextNodes(el, this.REF_RE, (match)=>{
                const title = match[1].trim();
                const span = document.createElement('span');
                span.style.cssText = this.CARD_STYLES.reference;
                span.setAttribute('data-ref-doc', title);
                $d269c56c0dbb3e45$var$paintRefBadge(span, this.CARD_ICONS.reference, ` ${title}`);
                return span;
            });
            if (!spans.length) return;
            const titles = [
                ...new Set(spans.map((s)=>s.getAttribute('data-ref-doc')))
            ];
            // Migrated 2026-05-19: workspaceProject.documents.notes/.kb → sdk.docs.notes/.kbArticles (Mongo).
            // sdk.docs.*.list() returns {data, count} — unwrap the data array.
            Promise.all([
                (0, $1NxyO.getSDK)().execute('docs.notes', 'list', {
                    filter: {
                        title_in: titles
                    }
                }),
                (0, $1NxyO.getSDK)().execute('docs.kbArticles', 'list', {
                    filter: {
                        title_in: titles
                    }
                })
            ]).then(([notesRes, kbRes])=>{
                const notesData = Array.isArray(notesRes) ? notesRes : notesRes?.data || notesRes?.notes || notesRes?.rows || [];
                const kbData = Array.isArray(kbRes) ? kbRes : kbRes?.data || kbRes?.articles || kbRes?.rows || [];
                const map = {};
                for (const n of notesData || [])if (n?.title) map[n.title.toLowerCase()] = 'Note';
                for (const a of kbData || [])if (a?.title) map[a.title.toLowerCase()] = 'KB';
                for (const span of spans){
                    const title = span.getAttribute('data-ref-doc');
                    const type = map[title.toLowerCase()];
                    if (type) $d269c56c0dbb3e45$var$paintRefBadge(span, this.CARD_ICONS.reference, ` ${title} \xb7 ${type}`);
                }
            }).catch(()=>{});
        },
        // el.markdown is the resolved markdown source (v3.14 flat prop access) —
        // already a string when the consumer passed a factory, because a lowercase
        // custom prop is auto-invoked on read. The typeof guard covers a host that
        // assigns the prop after create, where no getter wraps it.
        // withMentions / demoteHeadings are booleans set by the consumer.
        render (el, s) {
            const src = el.markdown;
            const body = typeof src === 'function' ? src(el, s) || '' : src == null ? '' : String(src);
            const withMentions = !!el.withMentions;
            const demoteHeadings = el.demoteHeadings !== false;
            const people = s && s.root && s.root.people;
            const channels = s && s.root && s.root.channels;
            if (!el || typeof el.set !== 'function') return;
            if (el._lastMd === body) return;
            el._lastMd = body;
            if (!body) {
                el.set({
                    tag: 'span',
                    text: ''
                });
                return;
            }
            const components = demoteHeadings ? this.DEMOTE_COMPONENTS : this.NATIVE_COMPONENTS;
            // A node that renders child nodes says `text: null`, so a library's
            // demo text never shows (see markdownToChildren above).
            const ownTextOnly = (node)=>{
                if (!node || typeof node !== 'object' || Array.isArray(node)) return node;
                const out = {
                    ...node
                };
                let hasKids = false;
                for (const k of Object.keys(out)){
                    const v = out[k];
                    if (/^[A-Z]/.test(k) && v && typeof v === 'object' && !Array.isArray(v)) {
                        hasKids = true;
                        out[k] = ownTextOnly(v);
                    }
                }
                if (Array.isArray(out.children) && out.children.length) {
                    hasKids = true;
                    out.children = out.children.map(ownTextOnly);
                }
                if (hasKids && out.text === undefined) out.text = null;
                return out;
            };
            try {
                el.set(ownTextOnly((0, $3Rzdu.transformMarkdown)(body, {
                    components: components
                })));
            } catch (_) {
                el.set({
                    tag: 'span',
                    text: body
                });
            }
            requestAnimationFrame(()=>{
                // Run longer-prefix patterns FIRST (## before #, @@ before @).
                this.TICKET_RE.lastIndex = 0;
                if (this.TICKET_RE.test(body)) this.highlightTickets(el);
                this.EVENT_RE.lastIndex = 0;
                if (this.EVENT_RE.test(body)) this.highlightEvents(el);
                this.REF_RE.lastIndex = 0;
                if (this.REF_RE.test(body)) this.highlightReferences(el);
                if (withMentions) {
                    const MENTION_RE = /(?<=^|\s)@([a-zA-Z0-9._-]+)/g;
                    MENTION_RE.lastIndex = 0;
                    if (MENTION_RE.test(body)) el.call('highlightMentions', el, people);
                    const CHANNEL_RE = /(?<=^|\s)#([a-zA-Z0-9._-]+)/g;
                    CHANNEL_RE.lastIndex = 0;
                    if (CHANNEL_RE.test(body)) el.call('highlightChannels', el, channels);
                }
            });
        }
    },
    tag: 'div',
    // The deprecated `text` alias is moved onto `markdown` HERE — onInit runs
    // before the node exists (core.js create(), triggerLifecycle('Init') precedes
    // cacheNode), so the framework never paints the raw source and never
    // registers a text effect for it. That keeps every ALREADY PUBLISHED
    // consumer correct without a republish — the stock system/cms-app editor
    // Preview passes `text`.
    onInit: (el, s)=>{
        if (el.text == null) return;
        if (el.markdown == null) el.markdown = el.text;
        el.text = null;
    },
    // A FACTORY SOURCE FOLLOWS STATE FROM HERE, with nothing asked of the call
    // site. The framework reads every `stateDeps` selector inside its OWN
    // effect, so reading `el.markdown` invokes the consumer's factory and
    // subscribes to whatever root-state signals that factory touches; a changed
    // snapshot then fires `onStateUpdate`. This is what keeps the stock
    // system/cms-app editor Preview live as the draft is typed — it passes a
    // function on the deprecated `text` alias and declares no subscription of
    // its own. A static source yields a constant selector and never fires.
    stateDeps: [
        (el, s)=>el.markdown
    ],
    onStateUpdate: (el, s)=>el.scope.render(el, s),
    onCreate: (el, s)=>el.scope.render(el, s),
    onUpdate: (el, s)=>el.scope.render(el, s)
};

});
parcelRegister("3Rzdu", function(module, exports) {

$parcel$export(module.exports, "defaultComponents", () => $2d01a397d92dfb87$export$71abc632aa29e6fe);
$parcel$export(module.exports, "transformMarkdown", () => $2d01a397d92dfb87$export$be0664469ff86e63);
parcelRequire("dOb0Y");
var $2LJ4A = parcelRequire("2LJ4A");
var $dUjEB = parcelRequire("dUjEB");
const $2d01a397d92dfb87$export$71abc632aa29e6fe = {
    h1: "H1",
    h2: "H2",
    h3: "H3",
    h4: "H4",
    h5: "H5",
    h6: "H6",
    paragraph: "P",
    pre: "Pre",
    code: "InlineCode",
    codeBlock: "CodePreviewWithTitle",
    blockquote: "Blockquote",
    ul: "UL",
    ol: "OL",
    li: "LI",
    hr: "Hr",
    table: "Table",
    thead: "Thead",
    tbody: "Tbody",
    tr: "Tr",
    th: "Th",
    td: "Td",
    span: "Span",
    strong: "Strong",
    em: "Em",
    del: "Del",
    link: "Link",
    img: "Img",
    input: "Input"
};
let $2d01a397d92dfb87$var$A = $2d01a397d92dfb87$export$71abc632aa29e6fe;
function $2d01a397d92dfb87$var$a(t) {
    return $2d01a397d92dfb87$var$A[t] || $2d01a397d92dfb87$export$71abc632aa29e6fe[t];
}
function $2d01a397d92dfb87$export$be0664469ff86e63(t, e = {}) {
    $2d01a397d92dfb87$var$A = e.components ? {
        ...$2d01a397d92dfb87$export$71abc632aa29e6fe,
        ...e.components
    } : $2d01a397d92dfb87$export$71abc632aa29e6fe;
    const { content: s, meta: n } = $2d01a397d92dfb87$var$X(t), i = $2d01a397d92dfb87$var$S(s);
    if (!i.some((h)=>h.type === "symbols_block") && !n) {
        const h = $2d01a397d92dfb87$var$M(i);
        return (0, $dUjEB.toSymbols)(h);
    }
    const o = {};
    n && (o.__meta = n);
    const u = {};
    function f(h, p) {
        o[h] !== void 0 && (u[h] = (u[h] || 0) + 1, h = `${h}_${u[h]}`), o[h] = p;
    }
    let c = 0;
    for (const h of i){
        if (h.type === "symbols_block") {
            o[`__raw_${c++}`] = h.content.trim();
            continue;
        }
        const p = $2d01a397d92dfb87$var$q(h);
        p && f(p.type, (0, $dUjEB.toSymbols)([
            p
        ]));
    }
    const d = Object.keys(o);
    return d.length === 1 && !d[0].startsWith("__") ? o[d[0]] : o;
}
function $2d01a397d92dfb87$var$X(t) {
    const e = t.trimStart();
    if (!e.startsWith("---")) return {
        content: t,
        meta: null
    };
    const s = e.indexOf(`
---`, 3);
    if (s === -1) return {
        content: t,
        meta: null
    };
    const n = e.substring(3, s).trim(), i = e.substring(s + 4).trimStart(), r = [];
    for (const u of n.split(`
`)){
        const f = u.trim().match(/^import\s*\{([^}]+)\}\s*from\s*['"]([^'"]+)['"]$/);
        if (f) {
            const c = f[1].split(",").map((d)=>d.trim()).filter(Boolean);
            r.push({
                names: c,
                from: f[2]
            });
        }
    }
    const o = r.length ? {
        imports: r
    } : null;
    return {
        content: i,
        meta: o
    };
}
function $2d01a397d92dfb87$var$C(t) {
    return t.trim().replace(/^\|/, "").replace(/(?<!\\)\|$/, "").split(/(?<!\\)\|/).map((e)=>e.trim());
}
function $2d01a397d92dfb87$var$k(t) {
    const e = $2d01a397d92dfb87$var$C(t);
    return e.length > 0 && e.every((s)=>/^:?-+:?$/.test(s));
}
function $2d01a397d92dfb87$var$L(t, e) {
    const s = t[e].trim();
    if (!s.includes("|") || e + 1 >= t.length) return !1;
    const n = t[e + 1].trim();
    if (!$2d01a397d92dfb87$var$k(n)) return !1;
    const i = $2d01a397d92dfb87$var$C(s);
    return $2d01a397d92dfb87$var$C(n).length !== i.length ? !1 : i.length > 1 || s.startsWith("|");
}
function $2d01a397d92dfb87$var$G(t) {
    const e = t.trim();
    return !e || !e.includes("|") ? !1 : !/^#{1,6}\s/.test(e) && !e.startsWith("```") && !e.startsWith(">");
}
function $2d01a397d92dfb87$var$S(t) {
    const e = t.split(`
`), s = [];
    let n = 0;
    for(; n < e.length;){
        const r = e[n].trim();
        if (!r) {
            n++;
            continue;
        }
        if (r.startsWith("```")) {
            const c = r.slice(3).trim() || null, d = [];
            for(n++; n < e.length && !e[n].trim().startsWith("```");)d.push(e[n]), n++;
            n++, s.push({
                type: "code_block",
                lang: c,
                content: d.join(`
`)
            });
            continue;
        }
        if (r === "{{") {
            const c = [];
            for(n++; n < e.length && e[n].trim() !== "}}";)c.push(e[n]), n++;
            n++, s.push({
                type: "symbols_block",
                content: c.join(`
`)
            });
            continue;
        }
        const o = r.match(/^(#{1,6})\s+(.+)$/);
        if (o) {
            s.push({
                type: "heading",
                level: o[1].length,
                content: o[2].replace(/\s+#+\s*$/, "")
            }), n++;
            continue;
        }
        if (/^([-*_])\1{2,}\s*$/.test(r)) {
            s.push({
                type: "hr"
            }), n++;
            continue;
        }
        if ($2d01a397d92dfb87$var$L(e, n)) {
            const c = [];
            for(; n < e.length && $2d01a397d92dfb87$var$G(e[n]);)c.push(e[n].trim()), n++;
            s.push({
                type: "table",
                lines: c
            });
            continue;
        }
        if (r.startsWith(">")) {
            const c = [];
            for(; n < e.length;){
                const h = e[n].trim();
                if (h.startsWith(">")) c.push(h.replace(/^>\s?/, ""));
                else if (h === "") {
                    if (n + 1 < e.length && e[n + 1].trim().startsWith(">")) c.push("");
                    else break;
                } else break;
                n++;
            }
            s.push({
                type: "blockquote",
                content: c.join(`
`)
            });
            continue;
        }
        const u = r.match(/^([-*+]|\d+\.)\s/);
        if (u) {
            const c = [], d = /^\d+\./.test(u[1]);
            for(; n < e.length;){
                const p = e[n].trim();
                if (!p) {
                    if (n + 1 < e.length && (e[n + 1].trim().match(/^([-*+]|\d+\.)\s/) || e[n + 1].startsWith("  "))) {
                        n++;
                        continue;
                    }
                    break;
                }
                const $ = p.match(/^([-*+]|\d+\.)\s(.*)$/);
                if ($) {
                    const y = $[2].match(/^\[([ xX])\]\s(.*)$/);
                    for(y ? c.push({
                        text: y[2],
                        checked: y[1] !== " ",
                        children: []
                    }) : c.push({
                        text: $[2],
                        children: []
                    }), n++; n < e.length;){
                        const b = e[n];
                        if (b.trim() === "") break;
                        if (b.startsWith("  ") || b.startsWith("	")) {
                            const _ = b.replace(/^(?:  |\t)/, "").trim();
                            if (_.startsWith("```")) {
                                const K = _.slice(3).trim() || null, W = [];
                                for(n++; n < e.length;){
                                    const F = e[n], B = F.startsWith("  ") || F.startsWith("	") ? F.replace(/^(?:  |\t)/, "") : F;
                                    if (B.trim().startsWith("```")) {
                                        n++;
                                        break;
                                    }
                                    W.push(B), n++;
                                }
                                const I = c[c.length - 1];
                                I.codeBlocks || (I.codeBlocks = []), I.codeBlocks.push({
                                    lang: K,
                                    content: W.join(`
`)
                                });
                                continue;
                            }
                            const w = _.match(/^([-*+]|\d+\.)\s(.*)$/);
                            w ? c[c.length - 1].children.push(w[2]) : c[c.length - 1].text += " " + _, n++;
                        } else {
                            if (b.trim().match(/^([-*+]|\d+\.)\s/)) break;
                            break;
                        }
                    }
                } else break;
            }
            s.push({
                type: "list",
                ordered: d,
                items: c
            });
            continue;
        }
        const f = [];
        for(; n < e.length;){
            const c = e[n].trim();
            if (!c || /^#{1,6}\s/.test(c) || c.startsWith("```") || c.startsWith(">") || c.match(/^([-*_])\1{2,}\s*$/) || c.match(/^([-*+]|\d+\.)\s/) || $2d01a397d92dfb87$var$L(e, n) || c === "{{") break;
            f.push(c), n++;
        }
        f.length ? s.push({
            type: "paragraph",
            content: f.join(" ")
        }) : (s.push({
            type: "paragraph",
            content: r
        }), n++);
    }
    return s;
}
function $2d01a397d92dfb87$var$M(t) {
    return t.map($2d01a397d92dfb87$var$q).filter(Boolean);
}
function $2d01a397d92dfb87$var$q(t) {
    switch(t.type){
        case "heading":
            return $2d01a397d92dfb87$var$J(t);
        case "paragraph":
            return $2d01a397d92dfb87$var$Q(t);
        case "code_block":
            return $2d01a397d92dfb87$var$H(t);
        case "blockquote":
            return $2d01a397d92dfb87$var$V(t);
        case "list":
            return $2d01a397d92dfb87$var$Y(t);
        case "hr":
            return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("hr"), {
                tag: "hr"
            });
        case "table":
            return $2d01a397d92dfb87$var$tt(t);
        default:
            return null;
    }
}
function $2d01a397d92dfb87$var$J(t) {
    const e = $2d01a397d92dfb87$var$a(`h${t.level}`), s = $2d01a397d92dfb87$var$m(t.content);
    return s.length === 1 && typeof s[0] == "string" ? (0, $2LJ4A.createIRNode)(e, {
        tag: `h${t.level}`,
        text: s[0]
    }) : (0, $2LJ4A.createIRNode)(e, {
        tag: `h${t.level}`,
        children: $2d01a397d92dfb87$var$g(s)
    });
}
function $2d01a397d92dfb87$var$Q(t) {
    const e = $2d01a397d92dfb87$var$m(t.content);
    return e.length === 1 && typeof e[0] == "string" ? (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("paragraph"), {
        tag: "p",
        text: e[0]
    }) : (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("paragraph"), {
        tag: "p",
        children: $2d01a397d92dfb87$var$g(e)
    });
}
function $2d01a397d92dfb87$var$H(t) {
    const e = (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("codeBlock"), {
        tag: "code",
        text: t.content
    }), s = {};
    return t.lang && (s["data-language"] = t.lang), (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("pre"), {
        tag: "pre",
        props: Object.keys(s).length ? s : void 0,
        children: [
            e
        ]
    });
}
function $2d01a397d92dfb87$var$V(t) {
    const e = $2d01a397d92dfb87$var$S(t.content), s = $2d01a397d92dfb87$var$M(e);
    return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("blockquote"), {
        tag: "blockquote",
        children: s.length ? s : void 0,
        text: s.length ? void 0 : t.content
    });
}
function $2d01a397d92dfb87$var$Y(t) {
    const e = t.ordered ? "ol" : "ul", s = t.ordered ? $2d01a397d92dfb87$var$a("ol") : $2d01a397d92dfb87$var$a("ul"), n = $2d01a397d92dfb87$var$a("li"), i = t.items.map((r)=>{
        const o = $2d01a397d92dfb87$var$m(r.text), u = {
            type: n,
            tag: "li"
        };
        if (r.checked !== void 0) {
            const f = (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("input"), {
                tag: "input",
                props: {
                    type: "checkbox",
                    checked: r.checked,
                    disabled: !0
                }
            }), c = $2d01a397d92dfb87$var$g(o);
            u.children = [
                f,
                ...c
            ];
        } else o.length === 1 && typeof o[0] == "string" ? u.text = o[0] : u.children = $2d01a397d92dfb87$var$g(o);
        if (r.children && r.children.length) {
            const f = r.children.map((d)=>{
                const h = $2d01a397d92dfb87$var$m(d);
                return h.length === 1 && typeof h[0] == "string" ? {
                    type: n,
                    tag: "li",
                    text: h[0]
                } : {
                    type: n,
                    tag: "li",
                    children: $2d01a397d92dfb87$var$g(h)
                };
            }), c = (0, $2LJ4A.createIRNode)(s, {
                tag: e,
                children: f.map((d)=>(0, $2LJ4A.createIRNode)(d.type, d))
            });
            u.children || (u.children = []), u.children.push(c);
        }
        if (r.codeBlocks && r.codeBlocks.length) {
            u.children || (u.children = u.text != null ? [
                (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("span"), {
                    tag: "span",
                    text: u.text
                })
            ] : [], u.text = void 0);
            for (const f of r.codeBlocks)u.children.push($2d01a397d92dfb87$var$H({
                lang: f.lang,
                content: f.content
            }));
        }
        return (0, $2LJ4A.createIRNode)(n, {
            tag: "li",
            text: u.text,
            children: u.children
        });
    });
    return (0, $2LJ4A.createIRNode)(s, {
        tag: e,
        children: i
    });
}
function $2d01a397d92dfb87$var$tt(t) {
    const e = t.lines.filter((f)=>!$2d01a397d92dfb87$var$k(f)).map($2d01a397d92dfb87$var$C);
    if (!e.length) return null;
    const s = e[0], n = e.slice(1), i = s.map((f)=>{
        const c = $2d01a397d92dfb87$var$m(f);
        return c.length === 1 && typeof c[0] == "string" ? (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("th"), {
            tag: "th",
            text: c[0]
        }) : (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("th"), {
            tag: "th",
            children: $2d01a397d92dfb87$var$g(c)
        });
    }), r = (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("thead"), {
        tag: "thead",
        children: [
            (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("tr"), {
                tag: "tr",
                children: i
            })
        ]
    }), o = n.map((f)=>{
        const c = f.map((d)=>{
            const h = $2d01a397d92dfb87$var$m(d);
            return h.length === 1 && typeof h[0] == "string" ? (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("td"), {
                tag: "td",
                text: h[0]
            }) : (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("td"), {
                tag: "td",
                children: $2d01a397d92dfb87$var$g(h)
            });
        });
        return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("tr"), {
            tag: "tr",
            children: c
        });
    }), u = (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("tbody"), {
        tag: "tbody",
        children: o
    });
    return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("table"), {
        tag: "table",
        children: [
            r,
            u
        ]
    });
}
function $2d01a397d92dfb87$var$nt(t) {
    const e = t.indexOf(",");
    if (e === -1) return 0;
    const s = t.substring(e + 1);
    return /;base64/i.test(t.substring(0, e)) ? Math.floor(s.length * 3 / 4) : s.length;
}
function $2d01a397d92dfb87$var$et(t) {
    return t < 1024 ? `${t} B` : t < 1048576 ? `${Math.round(t / 1024)} KB` : `${(t / 1048576).toFixed(1)} MB`;
}
const $2d01a397d92dfb87$var$j = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~", $2d01a397d92dfb87$var$z = 64976, $2d01a397d92dfb87$var$O = "\uFFFE", $2d01a397d92dfb87$var$st = /\uFFFE([\uFDD0-\uFDEF\uFFFE])|[\uFDD0-\uFDEF]/g;
function $2d01a397d92dfb87$var$E(t) {
    return t >= "\uFDD0" && t <= "\uFDEF" || t === $2d01a397d92dfb87$var$O ? $2d01a397d92dfb87$var$O + t : t;
}
function $2d01a397d92dfb87$var$it(t) {
    let e = "";
    for(let s = 0; s < t.length; s++){
        const n = t[s];
        if (n === "`") {
            const o = t.indexOf("`", s + 1);
            if (o !== -1) {
                for(let u = s; u <= o; u++)e += $2d01a397d92dfb87$var$E(t[u]);
                s = o;
                continue;
            }
        }
        const i = n === "<" ? $2d01a397d92dfb87$var$P(t, s) : null;
        if (i) {
            for(let o = s; o < s + i.length; o++)e += $2d01a397d92dfb87$var$E(t[o]);
            s += i.length - 1;
            continue;
        }
        const r = n === "\\" && s + 1 < t.length ? $2d01a397d92dfb87$var$j.indexOf(t[s + 1]) : -1;
        if (r !== -1) {
            e += String.fromCharCode($2d01a397d92dfb87$var$z + r), s++;
            continue;
        }
        e += $2d01a397d92dfb87$var$E(n);
    }
    return e;
}
function $2d01a397d92dfb87$var$N(t) {
    return t.replace($2d01a397d92dfb87$var$st, (e, s)=>s !== void 0 ? s : $2d01a397d92dfb87$var$j[e.charCodeAt(0) - $2d01a397d92dfb87$var$z]);
}
function $2d01a397d92dfb87$var$rt(t) {
    if (typeof t == "string") return $2d01a397d92dfb87$var$N(t);
    const e = {
        ...t
    };
    for (const s of Object.keys(e))typeof e[s] == "string" && (e[s] = $2d01a397d92dfb87$var$N(e[s]));
    return e;
}
const $2d01a397d92dfb87$var$ct = /^[A-Za-z][A-Za-z0-9+.-]{1,31}:/, $2d01a397d92dfb87$var$ot = /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
function $2d01a397d92dfb87$var$Z(t) {
    return t.length > 1 && t[0] === "<" && t[t.length - 1] === ">" ? t.slice(1, -1) : t;
}
function $2d01a397d92dfb87$var$P(t, e) {
    if (t[e] !== "<") return null;
    const s = t.indexOf(">", e + 1);
    if (s === -1) return null;
    const n = t.substring(e + 1, s);
    return $2d01a397d92dfb87$var$ct.test(n) && ![
        ...n
    ].some((i)=>i <= " " || i === "<" || i === "\x7F") ? {
        length: s + 1 - e,
        text: n,
        href: n
    } : $2d01a397d92dfb87$var$ot.test(n) ? {
        length: s + 1 - e,
        text: n,
        href: `mailto:${n}`
    } : null;
}
const $2d01a397d92dfb87$var$lt = /^[\t\n\f\r\p{Zs}]$/u, $2d01a397d92dfb87$var$ut = /^[\p{P}\p{S}]$/u;
function $2d01a397d92dfb87$var$x(t, e) {
    if (e < 0 || e >= t.length) return "space";
    const s = t[e];
    if (s >= "\uFDD0" && s <= "\uFDEF") {
        let r = 0;
        for(; e - 1 - r >= 0 && t[e - 1 - r] === $2d01a397d92dfb87$var$O;)r++;
        return r % 2 === 0 ? "punct" : "other";
    }
    let n = s;
    const i = t.charCodeAt(e);
    if (i >= 55296 && i <= 56319) {
        const r = t.charCodeAt(e + 1);
        r >= 56320 && r <= 57343 && (n = t.slice(e, e + 2));
    } else if (i >= 56320 && i <= 57343) {
        const r = t.charCodeAt(e - 1);
        r >= 55296 && r <= 56319 && (n = t.slice(e - 1, e + 1));
    }
    return $2d01a397d92dfb87$var$lt.test(n) ? "space" : $2d01a397d92dfb87$var$ut.test(n) ? "punct" : "other";
}
function $2d01a397d92dfb87$var$U(t, e) {
    let s = e;
    for(; s > 0 && t[s - 1] === "_";)s--;
    let n = e;
    for(; n + 1 < t.length && t[n + 1] === "_";)n++;
    const i = $2d01a397d92dfb87$var$x(t, s - 1), r = $2d01a397d92dfb87$var$x(t, n + 1), o = r !== "space" && (r !== "punct" || i !== "other"), u = i !== "space" && (i !== "punct" || r !== "other");
    return {
        open: o && (!u || i === "punct"),
        close: u && (!o || r === "punct")
    };
}
function $2d01a397d92dfb87$var$D(t, e, s) {
    let n = t.indexOf(e, s);
    if (e[0] !== "_") return n;
    for(; n !== -1 && !$2d01a397d92dfb87$var$U(t, n).close;)n = t.indexOf(e, n + 1);
    return n;
}
function $2d01a397d92dfb87$var$m(t) {
    return t.includes("\\") ? $2d01a397d92dfb87$var$v($2d01a397d92dfb87$var$it(t)).map($2d01a397d92dfb87$var$rt) : $2d01a397d92dfb87$var$v(t);
}
function $2d01a397d92dfb87$var$v(t) {
    const e = [];
    let s = "", n = 0;
    for(; n < t.length;){
        if (t[n] === "!" && t[n + 1] === "[") {
            const i = t.indexOf("]", n + 2);
            if (i !== -1 && t[i + 1] === "(") {
                const r = t.indexOf(")", i + 2);
                if (r !== -1) {
                    s && (e.push(s), s = ""), e.push({
                        type: "img",
                        alt: t.substring(n + 2, i),
                        src: $2d01a397d92dfb87$var$Z(t.substring(i + 2, r))
                    }), n = r + 1;
                    continue;
                }
            }
        }
        if (t[n] === "[") {
            const i = t.indexOf("]", n + 1);
            if (i !== -1 && t[i + 1] === "(") {
                const r = t.indexOf(")", i + 2);
                if (r !== -1) {
                    s && (e.push(s), s = ""), e.push({
                        type: "link",
                        text: t.substring(n + 1, i),
                        href: $2d01a397d92dfb87$var$Z(t.substring(i + 2, r))
                    }), n = r + 1;
                    continue;
                }
            }
        }
        if (t[n] === "<") {
            const i = $2d01a397d92dfb87$var$P(t, n);
            if (i) {
                s && (e.push(s), s = ""), e.push({
                    type: "link",
                    text: i.text,
                    href: i.href
                }), n += i.length;
                continue;
            }
        }
        if (t[n] === "`") {
            const i = t.indexOf("`", n + 1);
            if (i !== -1) {
                s && (e.push(s), s = ""), e.push({
                    type: "code",
                    text: t.substring(n + 1, i)
                }), n = i + 1;
                continue;
            }
        }
        if (t.startsWith("data:", n)) {
            const i = /^data:[\w.+-]+\/[\w.+-]+(?:;[\w.+-]+=?[\w.+-]*)*,[^\s)"'<>]*/.exec(t.substring(n));
            if (i) {
                const r = i[0];
                s && (e.push(s), s = "");
                const o = r.substring(5, r.indexOf(";") === -1 ? r.indexOf(",") : Math.min(r.indexOf(";"), r.indexOf(",")));
                o.startsWith("image/") ? e.push({
                    type: "img",
                    alt: o,
                    src: r
                }) : e.push({
                    type: "dataChip",
                    mime: o,
                    bytes: $2d01a397d92dfb87$var$nt(r)
                }), n += r.length;
                continue;
            }
        }
        if (t[n] === "~" && t[n + 1] === "~") {
            const i = t.indexOf("~~", n + 2);
            if (i !== -1) {
                s && (e.push(s), s = ""), e.push({
                    type: "strikethrough",
                    text: t.substring(n + 2, i)
                }), n = i + 2;
                continue;
            }
        }
        if (t[n] === "_" && !$2d01a397d92dfb87$var$U(t, n).open) {
            s += t[n], n++;
            continue;
        }
        if (t[n] === "*" && t[n + 1] === "*" && t[n + 2] === "*" || t[n] === "_" && t[n + 1] === "_" && t[n + 2] === "_") {
            const i = t.substring(n, n + 3), r = $2d01a397d92dfb87$var$D(t, i, n + 3);
            if (r !== -1) {
                s && (e.push(s), s = ""), e.push({
                    type: "boldItalic",
                    text: t.substring(n + 3, r)
                }), n = r + 3;
                continue;
            }
        }
        if (t[n] === "*" && t[n + 1] === "*" || t[n] === "_" && t[n + 1] === "_") {
            const i = t.substring(n, n + 2), r = $2d01a397d92dfb87$var$D(t, i, n + 2);
            if (r !== -1) {
                s && (e.push(s), s = ""), e.push({
                    type: "bold",
                    text: t.substring(n + 2, r)
                }), n = r + 2;
                continue;
            }
        }
        if (t[n] === "*" && t[n + 1] !== "*") {
            const i = t.indexOf("*", n + 1);
            if (i !== -1 && i > n + 1) {
                s && (e.push(s), s = ""), e.push({
                    type: "italic",
                    text: t.substring(n + 1, i)
                }), n = i + 1;
                continue;
            }
        }
        if (t[n] === "_" && t[n + 1] !== "_") {
            const i = $2d01a397d92dfb87$var$D(t, "_", n + 1);
            if (i !== -1 && i > n + 1) {
                s && (e.push(s), s = ""), e.push({
                    type: "italic",
                    text: t.substring(n + 1, i)
                }), n = i + 1;
                continue;
            }
        }
        s += t[n], n++;
    }
    return s && e.push(s), e;
}
function $2d01a397d92dfb87$var$g(t) {
    return t.map((e)=>{
        if (typeof e == "string") return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("span"), {
            tag: "span",
            text: e
        });
        switch(e.type){
            case "bold":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("strong"), {
                    tag: "strong",
                    text: e.text
                });
            case "boldItalic":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("strong"), {
                    tag: "strong",
                    children: [
                        (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("em"), {
                            tag: "em",
                            text: e.text
                        })
                    ]
                });
            case "dataChip":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("code"), {
                    tag: "code",
                    text: `${e.mime} \xB7 ${$2d01a397d92dfb87$var$et(e.bytes)}`,
                    props: {
                        "data-embed": "data-uri"
                    }
                });
            case "italic":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("em"), {
                    tag: "em",
                    text: e.text
                });
            case "strikethrough":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("del"), {
                    tag: "del",
                    text: e.text
                });
            case "code":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("code"), {
                    tag: "code",
                    text: e.text
                });
            case "link":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("link"), {
                    tag: "a",
                    text: e.text,
                    props: {
                        href: e.href
                    }
                });
            case "img":
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("img"), {
                    tag: "img",
                    props: {
                        src: e.src,
                        alt: e.alt
                    }
                });
            default:
                return (0, $2LJ4A.createIRNode)($2d01a397d92dfb87$var$a("span"), {
                    tag: "span",
                    text: String(e)
                });
        }
    });
}

});
parcelRegister("dOb0Y", function(module, exports) {

$parcel$export(module.exports, "createIRNode", () => (parcelRequire("2LJ4A")).createIRNode);
$parcel$export(module.exports, "toSymbols", () => (parcelRequire("dUjEB")).toSymbols);

var $2LJ4A = parcelRequire("2LJ4A");

var $dUjEB = parcelRequire("dUjEB");

var $iNUaC = parcelRequire("iNUaC");

});
parcelRegister("2LJ4A", function(module, exports) {

$parcel$export(module.exports, "createIRNode", () => $2042ef1dee9b934a$export$cc2911221c4d056f);
function $2042ef1dee9b934a$export$cc2911221c4d056f(c, e = {}) {
    const l = {
        type: c
    };
    return e.tag && (l.tag = e.tag), e.props && Object.keys(e.props).length && (l.props = e.props), e.text && (l.text = e.text), e.style && Object.keys(e.style).length && (l.style = e.style), e.classes && e.classes.length && (l.classes = e.classes), e.events && Object.keys(e.events).length && (l.events = e.events), e.children && e.children.length && (l.children = e.children), l;
}

});

parcelRegister("dUjEB", function(module, exports) {

$parcel$export(module.exports, "toSymbols", () => $a1ffc0316be645af$export$96506f577486e763);

var $iNUaC = parcelRequire("iNUaC");
function $a1ffc0316be645af$var$g(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
}
const $a1ffc0316be645af$var$p = {
    display: "display",
    "flex-direction": "flow",
    "align-items": "align",
    "justify-content": "align",
    gap: "gap",
    padding: "padding",
    "padding-top": "paddingTop",
    "padding-bottom": "paddingBottom",
    "padding-left": "paddingLeft",
    "padding-right": "paddingRight",
    margin: "margin",
    "margin-top": "marginTop",
    "margin-bottom": "marginBottom",
    "margin-left": "marginLeft",
    "margin-right": "marginRight",
    width: "width",
    height: "height",
    "min-width": "minWidth",
    "min-height": "minHeight",
    "max-width": "maxWidth",
    "max-height": "maxHeight",
    "font-size": "fontSize",
    "font-weight": "fontWeight",
    "line-height": "lineHeight",
    "letter-spacing": "letterSpacing",
    "text-align": "textAlign",
    "text-decoration": "textDecoration",
    "text-transform": "textTransform",
    color: "color",
    "background-color": "background",
    background: "background",
    "border-radius": "round",
    border: "border",
    "box-shadow": "boxShadow",
    opacity: "opacity",
    overflow: "overflow",
    position: "position",
    top: "top",
    bottom: "bottom",
    left: "left",
    right: "right",
    "z-index": "zIndex",
    cursor: "cursor",
    transition: "transition",
    transform: "transform"
}, $a1ffc0316be645af$var$h = {
    480: "@mobileL",
    768: "@tabletS",
    1024: "@screenS",
    1280: "@screenM",
    1440: "@screenL"
};
function $a1ffc0316be645af$export$56b4cbf46bcbeec1(t) {
    const i = {};
    for (const [n, e] of Object.entries(t)){
        if (n.startsWith("--")) {
            i[n] = e;
            continue;
        }
        const o = n.replace(/([A-Z])/g, "-$1").toLowerCase(), a = $a1ffc0316be645af$var$p[o] || (0, $iNUaC.toCamelCase)(o);
        if (o === "align-items" || o === "justify-content") {
            i.align ? i.align = `${i.align} ${e}` : i.align = e;
            continue;
        }
        if (o === "display" && e === "flex") {
            i.flow = "column";
            continue;
        }
        if (o === "display" && e === "grid") {
            i.display = "grid";
            continue;
        }
        if (o === "flex-direction") {
            i.flow = e;
            continue;
        }
        if ([
            "padding",
            "paddingTop",
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "margin",
            "marginTop",
            "marginBottom",
            "marginLeft",
            "marginRight",
            "gap"
        ].includes(a)) {
            i[a] = (0, $iNUaC.pxToSpacingToken)(e);
            continue;
        }
        i[a] = e;
    }
    return i;
}
function $a1ffc0316be645af$export$96506f577486e763(t) {
    if (!t || !t.length) return {};
    if (t.length === 1) return $a1ffc0316be645af$var$r(t[0]);
    const i = {};
    for(let n = 0; n < t.length; n++){
        const e = t[n];
        let o = $a1ffc0316be645af$var$g(e.type || `child${n}`);
        i[o] !== void 0 && (o = `${o}_${n}`), i[o] = $a1ffc0316be645af$var$r(e);
    }
    return i;
}
const $a1ffc0316be645af$var$s = new Set([
    "em",
    "i",
    "del",
    "s",
    "strike",
    "mark",
    "kbd",
    "var",
    "samp",
    "cite",
    "sub",
    "sup",
    "small",
    "abbr",
    "dfn",
    "q",
    "time",
    "span",
    "div"
]);
function $a1ffc0316be645af$var$r(t) {
    const i = {};
    if (t.type && !(t.tag && $a1ffc0316be645af$var$s.has(t.tag)) && !$a1ffc0316be645af$var$s.has(t.type) && (i.extends = t.type), t.tag && (i.tag = t.tag), t.text && (i.text = t.text), t.style && Object.keys(t.style).length && Object.assign(i, $a1ffc0316be645af$export$56b4cbf46bcbeec1(t.style)), t.props) for (const [n, e] of Object.entries(t.props))n === "className" || n === "class" || (i[n] = e);
    if (t.events && Object.assign(i, t.events), t.children && t.children.length) for(let n = 0; n < t.children.length; n++){
        const e = t.children[n], o = $a1ffc0316be645af$var$g(e.type || `child${n}`), a = i[o] !== void 0 ? `${o}_${n}` : o;
        i[a] = $a1ffc0316be645af$var$r(e);
    }
    return i;
}

});
parcelRegister("iNUaC", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", () => $db085fdd2ae63c42$export$86f54f62aa7a7514);
$parcel$export(module.exports, "pxToSpacingToken", () => $db085fdd2ae63c42$export$fb0bbfa60c752983);
function $db085fdd2ae63c42$export$6fb43ff9addf7357(t) {
    return t.replace(/[^a-zA-Z0-9]+(.)/g, (e, n)=>n.toUpperCase()).replace(/^./, (e)=>e.toUpperCase());
}
function $db085fdd2ae63c42$export$86f54f62aa7a7514(t) {
    return t.replace(/-([a-z])/g, (e, n)=>n.toUpperCase());
}
const $db085fdd2ae63c42$var$r = {
    0: "-",
    2: "W2",
    4: "W1",
    6: "X2",
    8: "X1",
    10: "Z2",
    12: "Z1",
    14: "Y2",
    16: "A",
    18: "A1",
    20: "A2",
    22: "B1",
    26: "B",
    30: "B2",
    34: "C1",
    42: "C",
    50: "C2",
    58: "D1",
    68: "D",
    84: "D2",
    110: "E",
    142: "F",
    184: "G",
    240: "H"
};
function $db085fdd2ae63c42$export$fb0bbfa60c752983(t) {
    const e = typeof t == "string" ? parseInt(t, 10) : t;
    if (isNaN(e)) return t;
    if ($db085fdd2ae63c42$var$r[e] !== void 0) return $db085fdd2ae63c42$var$r[e];
    for (const [n, a] of Object.entries($db085fdd2ae63c42$var$r))if (Math.abs(e - Number(n)) <= 2) return a;
    return `${e}px`;
}
const $db085fdd2ae63c42$var$o = {
    0: 0,
    2: "W2",
    4: "W1",
    6: "X2",
    8: "X1",
    10: "Z2",
    12: "Z1",
    16: "A",
    9999: "100%"
};
function $db085fdd2ae63c42$export$efad67f9c03d3708(t) {
    const e = typeof t == "string" ? parseInt(t, 10) : t;
    return isNaN(e) ? t : e >= 9999 || t === "50%" || t === "100%" ? "100%" : $db085fdd2ae63c42$var$o[e] !== void 0 ? $db085fdd2ae63c42$var$o[e] : `${e}px`;
}
const $db085fdd2ae63c42$var$i = {
    div: null,
    span: null,
    p: "P",
    h1: "H1",
    h2: "H2",
    h3: "H3",
    h4: "H4",
    h5: "H5",
    h6: "H6",
    button: "Button",
    a: "Link",
    img: "Img",
    nav: "Nav",
    header: "Header",
    main: "Main",
    section: "Section",
    article: "Article",
    aside: "Aside",
    footer: "Footer",
    input: "Input",
    select: "Select",
    textarea: "Textarea",
    form: "Form",
    label: "Label",
    video: "Video",
    iframe: "Iframe",
    ul: "UL",
    ol: "OL",
    li: "LI"
};
function $db085fdd2ae63c42$export$f27b9a4be72f580f(t) {
    const e = t.toLowerCase();
    return e in $db085fdd2ae63c42$var$i ? $db085fdd2ae63c42$var$i[e] : $db085fdd2ae63c42$export$6fb43ff9addf7357(e);
}
function $db085fdd2ae63c42$export$daa248218ce067a5(t) {
    return t.flatMap((e)=>e.trim().split(/\s+/)).filter(Boolean);
}

});





parcelRegister("3JSwc", function(module, exports) {

$parcel$export(module.exports, "MenuPanel", () => $2b8fdd42d88d0e3f$export$fa689aab22c97aaa);
$parcel$export(module.exports, "MenuPanelItem", () => $2b8fdd42d88d0e3f$export$f74b0153d97b37f0);
// MenuPanel / MenuPanelItem — THE house dropdown recipe (extracted from the
// /files context menu per Nika: "reuse this contextmenu style, shape and item
// styles to all other dropdowns").
//
// Panel: the `dialog` overlay surface + the `overlay` elevation token
// (DESIGN_LANGUAGE.md §2 — menus are overlay-level chrome; 2026-06-10 per
// Nika "remove that overlayStrong background from contextmenu and use
// default styles"); radiusCard shell, Y padding.
// Item:  borderless button row — Y/Z1 padding, radiusControl, title text,
//        the house `hover` wash (same pairing as the brand DropdownItem).
//
// Consumers extend these and add their own positioning/children. NOTE: no
// `transition` on backgrounds here — the runtime re-applies background per
// tick on some rows, perpetually restarting CSS transitions (see the ticket
// in tickets/smbls.md), which makes hover styles appear dead.
const $2b8fdd42d88d0e3f$export$fa689aab22c97aaa = {
    flow: 'y',
    gap: '0',
    minWidth: 'E1',
    maxWidth: '100%',
    maxHeight: '60dvh',
    overflow: 'auto',
    // Don't chain the panel's edge-bounce to the surface behind it (iPad program
    // P2 — overscroll-contain on inner scrollers; guideline MUST for overlays).
    overscrollBehavior: 'contain',
    padding: 'Y',
    round: 'radiusCard',
    theme: 'dialog',
    shadow: 'overlay',
    borderWidth: '0',
    boxSizing: 'border-box',
    '@mobileL': {
        minWidth: '0',
        maxWidth: 'calc(100dvw - var(--spacing-B))'
    },
    role: 'menu',
    // THE MENU KEYBOARD MODEL on every house menu (functions/menuKeyboard.js;
    // found missing by crm-w1 on a module popover, 2026-09-26): ArrowUp /
    // ArrowDown wrap through the rows, Home / End reach the ends. Rows are
    // <button>s, so Enter / Space activate natively; Escape belongs to the host
    // (the dropdown layer closes on it and returns focus to the trigger;
    // ContextDropdown and the other self-hosted menus keep their own handler,
    // which replaces this one). The panel is a programmatic focus target only.
    tabindex: '-1',
    onKeydown: (e, el)=>el.call('menuArrowNav', e, el.node),
    // Focus lands INSIDE a menu the dropdown layer hosts
    // (`openDropdown({ content: { extends: 'MenuPanel', … } })` — every module
    // popover): the layer mounts the panel only while it is open, so its render
    // IS the open edge. Keyed on the host, never on mount alone — a MenuPanel
    // that sits on a page (a catalog specimen, a sidebar list) must not pull the
    // page's focus into itself.
    onRender: (el)=>{
        if (typeof el.lookup !== 'function' || !el.lookup('DropdownRoot')) return;
        el.call('armMenuFocus', el, {
            when: (node)=>el.call('menuNodeVisible', node)
        });
    },
    // A focus CONTAINER, not a control: the brand reset draws the focus ring as
    // a box-shadow on every [tabindex]:focus-visible, which REPLACED the panel's
    // elevation with a bare ring whenever the panel itself held focus. The
    // panel keeps its `overlay` elevation; the focused row carries the ring.
    ':focus-visible': {
        boxShadow: 'var(--shadow-overlay)'
    }
};
const $2b8fdd42d88d0e3f$export$f74b0153d97b37f0 = {
    // The glyph plate's state rules (hover, keyboard focus invert it); they
    // match nothing on a row without a plate. The checked row's inversion is
    // below, beside `aria-checked`.
    extends: 'GlyphPlateHolder',
    tag: 'button',
    type: 'button',
    width: '100%',
    display: 'flex',
    flow: 'x',
    align: 'center left',
    padding: 'Y Z1',
    round: 'radiusControl',
    fontSize: 'Z1',
    textAlign: 'left',
    // THE TEXT LAW (overflow law §3b.4 + .8): a row's label wraps inside the
    // panel — a long email, URL or Georgian compound never widens the menu past
    // the viewport or spills out of the row (it was `nowrap`).
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    cursor: 'pointer',
    borderWidth: '0',
    background: 'transparent',
    color: 'title',
    role: (el)=>el.checked === undefined ? 'menuitem' : 'menuitemcheckbox',
    ariaChecked: (el)=>el.checked === undefined ? null : el.checked ? 'true' : 'false',
    // The state hooks below are FLAT `dataX` props (→ `data-x`), never a
    // `data: {}` block: a call-site `data` object REPLACES the component's
    // whole `data` on this runtime (FW-ELEMENT-DEFINITION-DATA-REPLACES-
    // EXTENDS-DATA-1), which silently dropped `data-danger` from a row that
    // also carried its own `data`. A flat key is only replaced by the same key.
    dataDanger: (el)=>!!el.danger,
    // iPad/touch: 44pt min row height (Apple HIG). The Y/Z1 padding alone yields
    // ~31px rows — too small to tap reliably. Coarse-pointer only (no-op on
    // desktop). Fixed-px token on purpose: the old `minHeight: 'C'` resolved
    // through the em chain at this row's Z1 font-size to ~40px, not 44.
    '@coarse': {
        minHeight: 'controlH'
    },
    '@mobileL': {
        minHeight: 'controlH'
    },
    touchAction: 'manipulation',
    // Hover: the house `hover` wash token (adaptive pair — DESIGN_LANGUAGE.md
    // §4.3; byte-identical to the old raw 0.07/0.05 pair). Must stay a FLAT
    // prop: a `:hover` block containing ONLY `@dark`/`@light` sub-blocks emits
    // NOTHING through css-in-props — the rows rendered with zero hover rules
    // until a flat prop made the rule materialize. (2026-06-15 per Nika "those
    // items in dropdown do not have hover".)
    ':hover': {
        background: 'hover'
    },
    // Keyboard focus: THE house ring (DESIGN_LANGUAGE §8.2 — one ring,
    // globally), drawn INWARD via the `focusRingInset` shadow token because
    // this panel is `overflow: auto` and an outer spread would be clipped at
    // its edge. The row is a real <button>, so brand reset.js paints the outer
    // ring by selector; this class rule (higher specificity) swaps it for the
    // inset variant — same colours, same 1px gap + 2px ring.
    ':focus-visible': {
        shadow: 'focusRingInset'
    },
    // Press: one step deeper than hover, same adaptive family (§4.3) — a
    // click reads as contact, not just a lingering hover.
    ':active': {
        background: 'selected'
    },
    '&[data-danger]': {
        color: 'dangerInk'
    },
    // Hover and press take the brand ERROR FILL pair, never a tint of the row's
    // own ink: on the `raised` ground a menu takes inside a dialog (gray5), a
    // light danger ink tinting the ground lightened it under the text (hover
    // 3.62:1, press 3.30:1 measured). The fill pair holds 5.4:1 on raised,
    // 5.1:1 on the dialog, 6.4:1 in light (__tests__/dangerRowOnRaised.test.js).
    '&[data-danger]:hover': {
        background: 'errorFillBg',
        color: 'errorFillInk'
    },
    '&[data-danger]:active': {
        background: 'errorFillBg',
        color: 'errorFillInk'
    },
    // The keycaps lift on the highlighted row — two rules, so the keyboard one
    // is not wrapped in the engine's `@media (hover: hover)` guard with the
    // pointer one.
    '&:hover [data-keycap]': {
        background: 'raised',
        color: 'title',
        boxShadow: 'var(--shadow-float)'
    },
    '&:focus-visible [data-keycap]': {
        background: 'raised',
        color: 'title',
        boxShadow: 'var(--shadow-float)'
    },
    // Not rendered at all when the row names no glyph: a mounted Icon with no
    // `name` resolves its KEY as the icon name and warns `Unknown icon name
    // "Icon"` on every plain row (measured by lane W2). A row that should
    // gain a glyph later declares it up front and toggles it with `hide:`.
    // `hide:` stays beside `if:` as the fallback for a runtime whose `if:` is
    // inert (published element builds before 3.14.788 — ContextDropdown's
    // Icon slot carries the same pair).
    Icon: {
        if: (el)=>!!el.name,
        hide: (el)=>!el.name,
        order: '-1',
        flexShrink: '0',
        marginRight: 'Y1',
        color: 'currentColor'
    },
    // THE GLYPH PLATE (dropdowns spec §4 menu row): a row that names `glyph`
    // (a LINE glyph, e.g. 'lnAssistant', or a PIXEL one at its 16 px, e.g. 'pxFly') leads with the glyph language's plate
    // instead of a bare Icon — 24 px (`glyphPlateXs`, the navbar tab's plate),
    // the hairline ring at rest, inverted with the row (GlyphPlateHolder +
    // the checked rule below). Same spacing contract as the Icon slot (order
    // -1, no shrink, Y1 to the label). No `glyph`, no node.
    // (__tests__/menuPanelItemPlate.test.js)
    //
    // The glyph travels ONE hop at a time: the row's `glyph` onto the Plate's
    // own `glyph` prop, the Plate's onto its Icon. The Icon built-in calls its
    // `name` factory RAW on every run of its render effect, so the old
    // two-parent read (`el.parent.parent.glyph`) threw `Cannot read properties
    // of null (reading 'glyph')` once the Plate's link to its row was gone
    // while the Icon's effect still ran (prod console since c24d97aa8). A
    // custom prop on the Plate is wrapped by the framework into a getter before
    // the Plate's children exist; the getter returns undefined on a throw, so
    // the Icon's read can never throw.
    // (__tests__/menuPanelItemPlateGlyphRead.test.js)
    Plate: {
        if: (el)=>!!el.parent.glyph,
        hide: (el)=>!el.parent.glyph,
        extends: 'AppGlyphPlate',
        glyph: (el)=>el.parent.glyph,
        ariaHidden: 'true',
        order: '-1',
        flexShrink: '0',
        marginRight: 'Y1',
        boxSize: 'glyphPlateXs',
        minWidth: 'glyphPlateXs',
        Icon: {
            name: (el)=>el.parent.glyph,
            boxSize: 'iconSm'
        }
    },
    '&[aria-checked="true"] [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    // Takes no box on a row without keycaps.
    Shortcut: {
        hide: (el)=>!(el.children || Object.keys(el).some((k)=>k.charCodeAt(0) >= 65 && k.charCodeAt(0) <= 90)),
        display: 'flex',
        flow: 'x',
        gap: 'W',
        flexShrink: '0',
        marginLeft: 'auto',
        paddingLeft: 'A',
        ariaHidden: 'true'
    },
    Icon_check: {
        name: 'checkmark',
        hide: (el)=>el.parent.checked === undefined,
        visibility: (el)=>el.parent.checked ? 'visible' : 'hidden',
        flexShrink: '0',
        marginLeft: 'auto',
        paddingLeft: 'Z',
        boxSizing: 'content-box',
        ariaHidden: 'true',
        color: 'currentColor'
    }
};

});

parcelRegister("agmHi", function(module, exports) {

$parcel$export(module.exports, "ContextDropdownItem", () => $778d013293f17d2e$export$335516d6a9398ddb);
$parcel$export(module.exports, "ContextDropdown", () => $778d013293f17d2e$export$f16218d5ce5ca2e1);
// ContextDropdown — the house right-click context menu, promoted from the
// /files context menu so every surface reuses its EXACT shape + styles
// (MenuPanel / MenuPanelItem). One instance is mounted globally in the app
// shell; only one menu is open at a time.
//
// Driven by `root.contextDropdown`:
//   { open, x, y, items?, itemsFn?, actionFn, openKey?, ...ctx }
//   - x / y       : viewport coords of the cursor (or the anchor button).
//   - items       : a static [{ label, action, danger?, disabled?, caption?,
//                   color?, ... }] array (simple menus — e.g. chat
//                   channel/DM/group rows).
//   - itemsFn     : a registered fn name; `el.call(itemsFn, root)` returns the
//                   array. Use this when the rows are derived from state and
//                   can change WITHOUT reopening — e.g. the files multi-step
//                   "Move to folder…" picker.
//   - actionFn    : a registered fn name; on a row click the menu calls
//                   `el.call(actionFn, action, item)`. The handler OWNS the
//                   dispatch AND the close: terminal actions clear
//                   `root.contextDropdown`; step actions re-set it (stay open).
//   - openKey     : the `key` of whichever row's SUBMENU is currently open
//                   (see below) — owned entirely by this component, never
//                   set by an opener.
//   - ...ctx      : any extra the openers/handlers need (nodeId, channelId…).
//
// ── Row states — the same three flags on every row shape, static `items`
// and `itemsFn` alike ───────────────────────────────────────────────────
//   - danger: true       the destructive row: MenuPanelItem's `dangerInk` + that
//                        ink's own hover/press washes (the legacy `color: 'red'`
//                        means the same). It was the raw brand `red`.
//   - disabled: true     the row is INERT but stays ON SCREEN and stays
//                        REACHABLE. `aria-disabled="true"`, no hover/press
//                        ground, no `actionFn` dispatch from click / Enter /
//                        Space, and no submenu opened by hover, click or
//                        ArrowRight. Ink drops to the house `inactive` token —
//                        NOT an opacity fade, which would push the row under
//                        the house 4.5:1 floor and dim its icon with it.
//                        Deliberately NOT the native `disabled` ATTRIBUTE:
//                        `.focus()` is a no-op on a disabled <button>, so the
//                        row would fall out of `menuLevelNav`'s arrow cycle
//                        and strand it. WAI-ARIA APG keeps a disabled menu
//                        item focusable and inert instead, which is what this
//                        does. `disabled` BEATS `danger` — a row that cannot
//                        fire must not advertise a destructive one.
//   - caption: '<key>'   a SECOND line under the label, `caption` ink at `Y`,
//                        resolved through polyglot exactly like `label` (a
//                        plain string passes through untouched). Absent →
//                        nothing renders and the row keeps its one-line
//                        height. The line lives INSIDE the row, so it joins
//                        the row's accessible name from content the same way
//                        `label` already does — no `aria-describedby` id
//                        plumbing, which no menu in this house has ever used.
//                        Pairs with `disabled` to say WHY a row is inert
//                        ("Collapse" / "Nothing to fold") instead of folding
//                        the reason into the label and dispatching a no-op.
//   - checked: bool      a current-value row: a `menuitemcheckbox` with
//                        aria-checked and the house check glyph at the far end
//                        (its box is kept when unchecked, so labels align). A
//                        row whose `action` is `{ multi, field, value }` (the
//                        tickets people pickers) derives it LIVE from
//                        root[field]. Absent → a plain `menuitem`, no box.
//   - shortcut: ['⌘','C'] trailing AppKeycap caps (a string is one cap) — ONLY
//                        for a shortcut that is wired; pair it with
//                        `ariaKeyshortcuts: 'Meta+C'` so AT hears it. The caps
//                        lift on the highlighted row (MenuPanelItem's rule).
//
// The transparent full-viewport backdrop closes the menu on any outside click
// or right-click. Position is viewport-clamped so it never overflows.
//
// Nested rows (2nd level): give any row a `children: [{ key, action, label,
// … }, …]` array (same shape as a top-level row) and it renders as a
// disclosure row (chevron, no `action` of its own) that reveals a flyout
// submenu of those rows — hover (120ms open / 250ms close intent, matching
// @symbo.ls/dropdown's DropdownTrigger), click, and keyboard (ArrowRight /
// Enter opens + focuses the first row, ArrowLeft / Escape closes + returns
// focus to the parent row) all drive the SAME `openKey` so the three
// modalities can never disagree. The flyout is `position: fixed` and
// positioned via the dropdown plugin's own `computePosition` (viewport-edge
// flip, right→left) — that also means it is never clipped by MenuPanel's
// `overflow: auto`, with no need to reach in and override an ancestor's
// overflow. Only one level of nesting ships today (this is what the project
// canvas "New" row needs); a deeper level is a mechanical repeat of the same
// recipe since `Submenu` rows are themselves `ContextDropdownItem`s.
// Reuse the dropdown plugin's own viewport-edge-flip math for the submenu
// flyout instead of hand-rolling a second one — same package
// shared/functions/index.js already imports for openDropdown/closeDropdown.

var $f39o3 = parcelRequire("f39o3");
const $778d013293f17d2e$export$335516d6a9398ddb = {
    // FA204 / frank trap — every helper below lives in `scope`, not module
    // scope: a bare module-scope const/function silently reads as undefined
    // once this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Called via
    // `el.scope.<name>(...)` from any descendant factory/handler. Regular
    // method syntax (not arrows) throughout — `el.scope.foo()` binds `this`
    // to `el.scope`, so a sibling helper calling another does it via
    // `this.<name>(...)` (object-literal properties can't see each other as
    // bare identifiers otherwise). `menuLevelNav` is ALSO needed by the
    // sibling `ContextDropdown` export below (its top-level Menu.onKeydown) —
    // `el.scope` only resolves within the tree of the specific top-level
    // export it's defined on, so it's duplicated there rather than shared.
    scope: {
        // ── nested rows (2nd level) ──────────────────────────────────────────
        //
        // A row is a "parent" row when its data carries a non-empty `children`
        // array (same shape as top-level rows). `openKey` — the currently-open
        // parent row's `key`, or falsy for none — lives on `root.contextDropdown`
        // itself, a SIBLING of `open`/`x`/`y`/…, NOT on the row's own data: every
        // itemsFn rebuilds its rows fresh on each contextDropdown change, so
        // anything stored on the row objects would be wiped the instant openKey
        // changes. Keeping it on the shared parent object survives that rebuild
        // and self-resets for free — every existing opener already replaces the
        // WHOLE `contextDropdown` object on open (never merges), so a
        // freshly-opened menu never inherits a stale openKey from a previous
        // session.
        hasSub (s) {
            return !!(s && Array.isArray(s.children) && s.children.length);
        },
        // A row's checked state: `undefined` = not a checkable row (a plain
        // menuitem, no check box); true / false = a menuitemcheckbox. A
        // multi-select row (`action: { multi, field, value }`) derives it LIVE
        // from the bound root filter field (row state snapshots go stale in
        // v3.14 childrenAs); any other row reads its own `checked`.
        checkedOf (s) {
            const a = s && s.action;
            if (a && a.multi && a.field) {
                const picked = [].concat(s.root && s.root[a.field] || []).filter(Boolean);
                return a.value ? picked.includes(a.value) : !picked.length;
            }
            return s && s.checked !== undefined ? !!s.checked : undefined;
        },
        // The row's keycaps: `shortcut: ['⌘', 'C']` or a one-cap string.
        keysOf (s) {
            const k = s && s.shortcut;
            if (Array.isArray(k)) return k.filter((c)=>c != null && c !== '').map(String);
            return k ? [
                String(k)
            ] : [];
        },
        // Arrow-key navigation WITHIN one menu level (the top Menu or a
        // Submenu) — same keys/wrap-around math as CanvasNavbar's CreateMenu
        // keyboard model, generalized to whichever container the key bubbled
        // through. `:scope >` scopes to the container's OWN direct rows so a
        // nested Submenu's items never fold into a containing Menu's up/down
        // cycle (and vice-versa); stopPropagation once a key is actually
        // handled so an ancestor level can't ALSO react to the same keystroke.
        menuLevelNav (e, containerNode) {
            if (!containerNode) return;
            const items = Array.from(containerNode.querySelectorAll(':scope > [role="menuitem"], :scope > [role="menuitemcheckbox"]'));
            if (!items.length) return;
            const idx = items.indexOf(document.activeElement);
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                // idx < 0 (nothing in this level focused yet) lands on the first row —
                // NOT `(idx + 1) % length` with idx = -1, which would land on the
                // second-to-last row instead of a sane starting point.
                items[idx < 0 ? 0 : (idx + 1) % items.length].focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                items[idx < 0 ? items.length - 1 : (idx - 1 + items.length) % items.length].focus();
            } else if (e.key === 'Home') {
                e.preventDefault();
                e.stopPropagation();
                items[0].focus();
            } else if (e.key === 'End') {
                e.preventDefault();
                e.stopPropagation();
                items[items.length - 1].focus();
            }
        },
        // Open/close a row's submenu — the SINGLE place that writes `openKey`,
        // used by hover, click AND keyboard alike so all three trigger
        // modalities agree on one source of truth (no CSS-hover-vs-JS-state
        // fights, no `!important` cascade tie-breaks). `opts.focusFirst` is
        // keyboard-open ONLY (ArrowRight / Enter): a passing mouse hover — or
        // even a click, which already parks native focus on the row itself —
        // must never silently steal keyboard focus into the flyout.
        openSubmenu (el, s, opts) {
            const dd = s && s.root && s.root.contextDropdown;
            if (!dd) return;
            s.root.update({
                contextDropdown: {
                    ...dd,
                    openKey: s.key
                }
            }, {
                preventFetch: true
            });
            if (typeof window === 'undefined' || !opts || !opts.focusFirst) return;
            // The submenu's rows don't exist in the DOM until this state commits
            // and the (previously display:none) panel paints — poll a few
            // bounded ticks rather than assume one microtask is enough (same
            // reasoning as subSettle below).
            let tries = 0;
            const focusFirst = ()=>{
                const first = el.Submenu && el.Submenu.node && el.Submenu.node.querySelector('[role="menuitem"], [role="menuitemcheckbox"]');
                if (first) first.focus();
                else if (++tries < 6) window.setTimeout(focusFirst, 30);
            };
            window.setTimeout(focusFirst, 0);
        },
        closeSubmenu (el, s, opts) {
            const dd = s && s.root && s.root.contextDropdown;
            if (!dd) return;
            s.root.update({
                contextDropdown: {
                    ...dd,
                    openKey: null
                }
            }, {
                preventFetch: true
            });
            if (opts && opts.refocus && el && el.node && el.node.focus) el.node.focus();
        },
        // Position an open submenu against its OWNER ROW using the SAME
        // viewport-flip math the top-level dropdown plugin panels use
        // (@symbo.ls/dropdown's computePosition: 'right-start', flips to
        // 'left-start' when the right side would clip). `position: fixed` — not
        // `absolute` — so the panel is positioned against the viewport rather
        // than MenuPanel's own `overflow: auto` box; fixed-position descendants
        // aren't clipped by an ancestor's overflow at all, so there's no need
        // to reach in and flip MenuPanel's overflow to visible the way
        // CascadeMenu's flyout does.
        subPos (el, s) {
            const rowNode = el && el.parent && el.parent.node;
            if (typeof window === 'undefined' || !rowNode) return {
                left: 0,
                top: 0
            };
            const r = rowNode.getBoundingClientRect();
            const anchor = {
                left: r.left,
                top: r.top,
                right: r.right,
                bottom: r.bottom,
                width: r.width,
                height: r.height
            };
            const size = {
                width: el._subSize && el._subSize.w || 240,
                height: el._subSize && el._subSize.h || Math.round(window.innerHeight * 0.6)
            };
            return (0, $f39o3.computePosition)(anchor, size, 'right-start');
        },
        // Re-measure the submenu's REAL rendered size and re-apply the computed
        // position — mirrors ddSettle on the ContextDropdown export below
        // (onRender fires before the rows lay out, measuring 0×0; a short
        // bounded poll catches the real size once painted). Only runs while
        // THIS row's submenu is the open one.
        subSettle (el) {
            if (typeof window === 'undefined' || !el || !el.parent) return;
            el.__subSettleGen = (el.__subSettleGen || 0) + 1;
            const gen = el.__subSettleGen;
            let ticks = 0;
            const tick = ()=>{
                if (gen !== el.__subSettleGen) return;
                const dd = el.state?.root?.contextDropdown;
                const ownerKey = el.state?.key;
                if (!dd || dd.openKey !== ownerKey || !el.node) return;
                const w = el.node.offsetWidth;
                const h = el.node.offsetHeight;
                if (w > 0 && h > 0) el._subSize = {
                    w: w,
                    h: h
                };
                const pos = this.subPos(el, el.state);
                el.node.style.left = pos.left + 'px';
                el.node.style.top = pos.top + 'px';
                if (++ticks < 24) window.setTimeout(tick, 50);
            };
            tick();
        }
    },
    // Same row chrome as the /files context-menu item (MenuPanelItem already
    // carries the house hover styles). ⚠ 'MenuPanelItem', the ROW — not
    // 'MenuPanel', the panel: the dd72ccfd frank-trap sweep accidentally
    // rewrote this to the panel and every context-menu row lost its hover
    // wash + gained panel chrome (Nika 2026-08-12, "fix ui of context menus
    // (hover states etc)").
    extends: 'MenuPanelItem',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    // THE ROW STATES ride MenuPanelItem's recipe (white-label redesign
    // 2026-09-26, DESIGN_SPEC §5.9): the row keeps the recipe's static `title`
    // ink, and each state is an ATTRIBUTE the recipe's static rules key on —
    // never an inline colour factory (a factory-valued `color` is written
    // inline and outranks every class rule, so the recipe's danger ink could
    // never land):
    //   - `data-danger` (danger, or the legacy `color: 'red'`) → `dangerInk` +
    //     the ink's own hover/press washes from MenuPanelItem. It was the raw
    //     brand `red`, ~2.4:1 as text on the light panel.
    //   - `aria-disabled="true"` → the house `inactive` ink, a not-allowed
    //     cursor and no hover/press ground. The ink/cursor rule outranks the
    //     recipe's flat classes; the ground rules TIE the recipe's doubled-class
    //     `:hover`/`:active` on specificity and win by order — a row mints its
    //     merged keys in order, MenuPanelItem's first, and nothing else mints
    //     these three rules (contextDropdownRecipe.test.js pins the order).
    //     `disabled` is checked FIRST — an inert row must not advertise a
    //     destructive action it cannot perform (see the row-state contract at
    //     the top of this file).
    // EVERY factory below reads through `s?.` — the v3.14 children machinery
    // instantiates the childExtends TEMPLATE once with NO state bound (an
    // empty-items open does exactly that), and ONE throw inside the children
    // effect kills the subscription for good: every context menu in the app
    // then opens EMPTY until reload (2026-08-06 per Nika "context menu on
    // dashboard got broke - no items in it" — `s.divider` on undefined threw
    // here). Framework ticket in tickets/smbls.md covers the template-eval +
    // dead-effect root cause; the guards are the component's own contract.
    dataDanger: (el, s)=>!s?.disabled && !!(s?.danger || s?.color === 'red'),
    ariaDisabled: (el, s)=>s?.disabled ? 'true' : null,
    // The house `inactive` ink, not an `opacity` fade. An alpha fade multiplies
    // through to the row's Icon/check/Chevron as well and lands the label under
    // the house 4.5:1 floor; `inactive` is a measured adaptive pair
    // (gray6 / gray10) that clears it on both themes. `not-allowed` is the
    // affordance the `field` theme's `:disabled` block and AiMenu's AiOptionRow
    // already use for an inert control.
    '&[aria-disabled="true"]': {
        color: 'inactive',
        cursor: 'not-allowed'
    },
    '&[aria-disabled="true"]:hover': {
        background: 'transparent'
    },
    '&[aria-disabled="true"]:active': {
        background: 'transparent'
    },
    // A `{ divider: true }` row renders as a non-interactive separator line
    // (the tickets people pickers use it to split humans from agents —
    // 2026-08-06 per Nika "in filter drdopwon make line and list agents
    // below humans"). role 'separator' keeps it out of the arrow-key cycle
    // (menuLevelNav queries [role="menuitem"] only) and out of the
    // accessibility action list; every visual part of the row collapses via
    // the divider gates below.
    // A row with a checked state (`checked`, or a multi-select action) is a
    // menuitemcheckbox — the arrow cycle and focus-first query both roles.
    role: (el, s)=>{
        if (s?.divider) return 'separator';
        return el.scope.checkedOf(s) === undefined ? 'menuitem' : 'menuitemcheckbox';
    },
    ariaChecked: (el, s)=>{
        if (s?.divider) return null;
        const c = el.scope.checkedOf(s);
        return c === undefined ? null : c ? 'true' : 'false';
    },
    ariaKeyshortcuts: (el, s)=>s?.ariaKeyshortcuts || null,
    // A row with `children` is a disclosure row (opens a Submenu, no action of
    // its own) — rendered as a <div>, NOT a <button>: its flyout holds MORE
    // buttons, and button-in-button is invalid HTML (the browser silently
    // drops the nested ones). Leaf (action) rows stay <button>s, unchanged
    // from before this existed — MenuPanelItem's own `tag`/`type` already
    // default to 'button', so every existing flat-menu consumer (files, chat,
    // tickets, home, …) renders exactly as it did prior to this.
    tag: (el, s)=>el.scope.hasSub(s) || s?.divider ? 'div' : 'button',
    type: (el, s)=>el.scope.hasSub(s) || s?.divider ? null : 'button',
    tabindex: (el, s)=>el.scope.hasSub(s) ? '0' : null,
    // Conditional class, NOT null-returning prop factories: a factory that
    // returns null for the common case would still override the
    // MenuPanelItem base padding/hover on every NORMAL row. The class only
    // exists on divider rows.
    isDivider: (el, s)=>!!s?.divider,
    '.isDivider': {
        pointerEvents: 'none',
        minHeight: '0',
        height: '1px',
        padding: '0',
        margin: 'Y -Z',
        background: 'line'
    },
    ariaHaspopup: (el, s)=>el.scope.hasSub(s) ? 'true' : null,
    ariaExpanded: (el, s)=>{
        if (!el.scope.hasSub(s)) return null;
        const dd = s.root && s.root.contextDropdown;
        return dd && dd.openKey === s.key ? 'true' : 'false';
    },
    // Optional leading avatar (people pickers) or icon. ADDITIVE: rows that
    // pass neither render label-only, identical to before — the label just
    // moved from the button's `text` into a Label child span so an avatar can
    // sit beside it.
    Avatar: {
        extends: 'Avatar',
        // `if:` first: a row with no avatar mounts NO Avatar element at all, so
        // no CSS pass can ever show one (2026-10-27 per Nika "dropdown has bug in
        // list list items show avatar sometimes" — the Home · Ask · Create menu).
        // The Icon slot below already ships this gate; `if:` is live since
        // element 3.14.788. A row's `avatar` is fixed for the life of the row
        // (the items feed rebuilds the list), so the gate never shifts layout.
        if: (el, s)=>!!s?.avatar,
        // `hide:` (registered CSS prop) stays as the fallback for a runtime whose
        // `if:` is inert (element builds before 3.14.788): there every plain row
        // (home Refresh/Customize, …) rendered a stray empty-src initials avatar
        // (2026-07-25 per Nika "remove that avatar from / page contextmenu").
        hide: (el, s)=>!s?.avatar,
        // AND an explicit display factory: published element builds up to
        // 3.14.779 carry FW-HIDE-UNAPPLIED-1 (a hide factory true from its
        // first run is clobbered by the explicit-display pass — fixed in smbls
        // 7031e3d60, unpublished while npm is billing-locked), which re-showed
        // this avatar (2026-08-18 per Nika, "persists"). The explicit display
        // IS the pass that wins on every runtime, old and fixed. This slot has
        // now been broken by two different framework regressions — keep both
        // gates.
        display: (el, s)=>s?.avatar ? null : 'none',
        width: 'A',
        height: 'A',
        minWidth: 'A',
        // No `|| ''` — an empty `src` is a REAL request for the document URL
        // (4 failed requests per mount on the served catalog, 2026-09-20).
        // smbls removes the attribute when a factory answers undefined, which
        // is the honest "this row has no avatar" state; the two gates above
        // still hide the box. See __tests__/emptyImageSrcShared.test.js.
        src: (el, s)=>s?.avatar || undefined
    },
    // Optional leading glyph. `if:` — NOT `hide:` alone — because a HIDDEN Icon
    // is still a MOUNTED Icon, and the built-in resolves its name from
    // `el.name || el.icon || el.key` (default-config Icon/index.js
    // `getIconName`): a row that names no glyph answered `undefined` from the
    // factory, fell through to the KEY, and warned
    // `[Icon] Unknown icon name "Icon" at <…ContextDropdown.Menu.0.Icon>` on
    // EVERY page while painting the `noIcon` placeholder behind
    // `display: none`. `if:` is the house recipe for exactly this slot —
    // AiMenu's AiOptionRow ships `Icon: { if: (el, s) => !!s.icon, … }`.
    // No layout shift (the RULES caution on `if:`-gated chrome): a row's
    // `icon` is fixed for the life of that row — the items feed rebuilds the
    // whole list, it never grows a glyph under a mounted row.
    // The Avatar slot above carries the same three gates. Here the gate is
    // additive — `hide:` stays
    // as the fallback for a runtime whose `if:` is inert (published element
    // builds before 3.14.788), so an old runtime still hides the box exactly
    // as it does today.
    Icon: {
        extends: 'Icon',
        if: (el, s)=>!!s?.icon && !s?.avatar,
        hide: (el, s)=>!!s?.avatar || !s?.icon,
        icon: (el, s)=>s?.icon,
        boxSize: 'A',
        minWidth: 'A',
        // The row's own `gap` spaces the glyph from the label, as it always did.
        // MenuPanelItem's glyph slot (merged in underneath) adds a `Y1` margin
        // for rows WITHOUT a gap — here it would double the space, so the
        // inherited declaration is removed (null = the tombstone).
        marginRight: null
    },
    // Label, plus the optional `caption` second line. The Body/Label/Sub column
    // is the SAME recipe AiMenu's AiOptionRow and AiPickerRow already ship for a
    // menu row with secondary text — one house shape for it, not a second one.
    // `Body` takes the `flex: '1'` the Label used to carry, so Check/Chevron
    // still get pushed to the row's trailing edge and a long label wraps
    // inside the row (`minWidth: '0'` lets the column shrink under its content).
    Body: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        // ONLY tightened when there is a second line to tighten. The panel/theme
        // line-height a one-line row inherits today is what sets its height, and
        // the contract is that a caption-less row keeps EXACTLY the height it has
        // now — so the common case returns null (no rule, inherit) rather than a
        // value that would silently re-scale every existing context menu.
        lineHeight: (el, s)=>s?.caption ? '1.3' : null,
        // THE TEXT LAW (overflow law §3b.8): the row's primary text WRAPS — it
        // is never cut to an ellipsis (it was nowrap + hidden + ellipsis).
        Label: {
            tag: 'span',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            text: (el, s)=>el.call('polyglot', s?.label || '')
        },
        // `Sub`, NOT `Caption`: `Caption` is a REGISTERED built-in atom
        // (@symbo.ls/default-config Atoms/Text.js — `{ tag: 'caption' }`), so a
        // bare `Caption:` key auto-extends it and emits a real HTML <caption>
        // outside any table — the exact collision MarketplaceFeedPost hit and
        // renamed away from (e0c2ee3b). `Sub` is the key AiMenu / AiPickerRow /
        // AiSettingsPanel already use for this slot and collides with nothing.
        //
        // Both gates, same reasoning as the Avatar slot above: `hide:` alone was
        // clobbered by FW-HIDE-UNAPPLIED-1 on published builds up to 3.14.779,
        // and a stray empty line here would add row height to EVERY caption-less
        // row — precisely what the contract forbids.
        Sub: {
            tag: 'span',
            hide: (el, s)=>!s?.caption,
            display: (el, s)=>s?.caption ? null : 'none',
            fontSize: 'Y',
            lineHeight: '1.4',
            // Stays `caption` ink even on a disabled row: the reason is the one
            // thing the user still needs to read, and `caption` is the token named
            // for exactly this role.
            color: 'caption',
            // Secondary meta: the one text the law lets ellipsize — with its full
            // text in `title`, so the cut part stays readable on hover.
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            title: (el, s)=>el.call('polyglot', s?.caption || '') || null,
            text: (el, s)=>el.call('polyglot', s?.caption || '')
        }
    },
    // MenuPanelItem's trailing slots, fed from the row DATA (they merge in
    // underneath this definition, so their DOM place is BEFORE Avatar/Body —
    // `order` puts them after the label, where the recipe draws them).
    //
    // Keycaps — `shortcut: ['⌘', 'C']`. The recipe's lift rule raises them on
    // the highlighted row.
    Shortcut: {
        order: '1',
        hide: (el, s)=>!el.scope.keysOf(s).length,
        childExtends: 'AppKeycap',
        children: (el, s)=>el.scope.keysOf(s).map((text)=>({
                    text: text
                }))
    },
    // The check — the house glyph at the far end, in the row's own ink (so an
    // inert row's check follows it into `inactive`). A checkable row keeps the
    // glyph's BOX when unchecked, so labels stay aligned down the menu; a
    // plain row has no box. Multi-select rows derive it live (checkedOf).
    Icon_check: {
        order: '1',
        hide: (el, s)=>el.scope.checkedOf(s) === undefined,
        visibility: (el, s)=>el.scope.checkedOf(s) ? 'visible' : 'hidden'
    },
    // Disclosure affordance — only a `children` row shows it. Pushed to the
    // row's far edge (same `margin: 0 0 0 auto` idiom the legacy canvas
    // dropdown used for its own trailing icon).
    Chevron: {
        extends: 'Icon',
        order: '2',
        hide: (el, s)=>!el.scope.hasSub(s),
        icon: 'chevronRight',
        boxSize: 'Z1',
        color: (el, s)=>s?.disabled ? 'inactive' : 'caption',
        margin: '0 0 0 auto',
        ariaHidden: 'true'
    },
    // The flyout — only rendered/positioned for a `children` row. Recurses
    // through the SAME ContextDropdownItem for its own rows, so a future
    // deeper level is a mechanical repeat of this recipe.
    Submenu: {
        extends: 'MenuPanel',
        position: 'fixed',
        zIndex: '20',
        width: 'max-content',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        display: (el, s)=>{
            if (!el.scope.hasSub(s)) return 'none';
            const dd = s.root && s.root.contextDropdown;
            return dd && dd.openKey === s.key ? 'flex' : 'none';
        },
        style: {
            left: (el, s)=>el.scope.subPos(el, s).left + 'px',
            top: (el, s)=>el.scope.subPos(el, s).top + 'px'
        },
        subscribeTo: [
            'contextDropdown'
        ],
        onRender: (el)=>el.scope.subSettle(el),
        onUpdate: (el)=>el.scope.subSettle(el),
        onKeydown: (e, el)=>el.scope.menuLevelNav(e, el.node),
        // Bridge the hover gap between the row and its flyout — entering EITHER
        // cancels the other's pending close-intent timer (same shared-timer
        // idiom AppNavbar's More menu uses between its button and panel).
        onMouseenter: (e, el)=>{
            const rowEl = el.parent;
            if (rowEl && rowEl._closeTimer) {
                clearTimeout(rowEl._closeTimer);
                rowEl._closeTimer = null;
            }
        },
        onMouseleave: (e, el, s)=>{
            const rowEl = el.parent;
            if (!rowEl) return;
            rowEl._closeTimer = window.setTimeout(()=>{
                const dd = s.root && s.root.contextDropdown;
                if (dd && dd.openKey === s.key) el.scope.closeSubmenu(rowEl, s);
            }, 250);
        },
        childExtends: 'ContextDropdownItem',
        childrenAs: 'state',
        children: (el, s)=>(s?.children || []).filter((it)=>it && typeof it === 'object')
    },
    onMouseenter: (e, el, s)=>{
        const dd = s.root && s.root.contextDropdown;
        // Hovering any row closes a DIFFERENT row's open submenu right away —
        // only one flyout is ever open at once (matches native menu behaviour).
        // A row INSIDE a flyout is not a different row: it is the open flyout's
        // own content. Without this guard the pointer closed the flyout the
        // moment it entered one of its rows, so no flyout row could ever be
        // clicked with a mouse (measured on dev 2026-09-26: the avatar menu's
        // Theme › Light never applied — mousedown on the row, the flyout gone
        // before mouseup).
        const inFlyout = !!(el.parent && el.parent.key === 'Submenu');
        if (dd && dd.openKey && dd.openKey !== s.key && !inFlyout) {
            if (el._closeTimer) {
                clearTimeout(el._closeTimer);
                el._closeTimer = null;
            }
            s.root.update({
                contextDropdown: {
                    ...dd,
                    openKey: null
                }
            }, {
                preventFetch: true
            });
        }
        // Closing a DIFFERENT row's flyout above is menu-wide behaviour and still
        // applies when the pointer lands on an inert row; opening this row's OWN
        // flyout does not.
        if (s?.disabled || !el.scope.hasSub(s)) return;
        if (el._closeTimer) {
            clearTimeout(el._closeTimer);
            el._closeTimer = null;
        }
        if (el._hoverTimer) clearTimeout(el._hoverTimer);
        // Same 120ms hover-intent delay as the house DropdownTrigger
        // (@symbo.ls/dropdown) — a deliberate pause, not a flinch, before a
        // passing hover opens a flyout.
        el._hoverTimer = window.setTimeout(()=>el.scope.openSubmenu(el, s), 120);
    },
    onMouseleave: (e, el, s)=>{
        if (!el.scope.hasSub(s)) return;
        if (el._hoverTimer) {
            clearTimeout(el._hoverTimer);
            el._hoverTimer = null;
        }
        // Same 250ms close-intent delay as DropdownTrigger — lets the pointer
        // transit the gap into the flyout without it slamming shut.
        el._closeTimer = window.setTimeout(()=>{
            const dd = s.root && s.root.contextDropdown;
            if (dd && dd.openKey === s.key) el.scope.closeSubmenu(el, s);
        }, 250);
    },
    onKeydown: (e, el, s)=>{
        const root = s.root;
        if (!root || !root.contextDropdown) return;
        const hasSub = el.scope.hasSub(s);
        // Inert, but still in the arrow cycle: swallow the ACTIVATION keys only
        // (Enter / Space open nothing and dispatch nothing; preventDefault also
        // stops the <button>'s native keydown->click, so onClick is never even
        // reached) and let every NAVIGATION key — Arrow up/down, Home, End,
        // Escape — bubble to the level container untouched, so the row stays
        // reachable per WAI-ARIA APG instead of trapping or skipping the walk.
        if (s?.disabled) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'ArrowRight') {
                e.preventDefault();
                e.stopPropagation();
            }
            return;
        }
        if ((e.key === 'ArrowRight' || e.key === 'Enter') && hasSub && e.target === el.node) {
            e.preventDefault();
            e.stopPropagation();
            el.scope.openSubmenu(el, s, {
                focusFirst: true
            });
            return;
        }
        if (e.key === 'ArrowLeft' || e.key === 'Escape') {
            if (hasSub && root.contextDropdown.openKey === s.key) {
                e.preventDefault();
                e.stopPropagation();
                el.scope.closeSubmenu(el, s, {
                    refocus: true
                });
            }
        }
    },
    onClick: (e, el, s)=>{
        // Inert: no submenu toggle, no `actionFn` dispatch, and the menu stays
        // open. stopPropagation is load-bearing, not defensive — a row inside a
        // Submenu is a DOM descendant of its parent row, so an unstopped click
        // would bubble into that parent's own onClick and toggle the flyout shut
        // under the user.
        if (s?.disabled) {
            e.stopPropagation();
            return;
        }
        if (el.scope.hasSub(s)) {
            e.stopPropagation();
            const dd = s.root && s.root.contextDropdown;
            if (!dd) return;
            if (dd.openKey === s.key) el.scope.closeSubmenu(el, s);
            else el.scope.openSubmenu(el, s);
            return;
        }
        const dd = s.root && s.root.contextDropdown;
        if (dd && dd.actionFn) el.call(dd.actionFn, s.action, s);
    }
};
const $778d013293f17d2e$export$f16218d5ce5ca2e1 = {
    // FA204 / frank trap (see ContextDropdownItem above for the full
    // explanation) — `menuLevelNav` is duplicated here rather than shared:
    // `el.scope` only resolves within the tree of the specific top-level
    // export it's defined on, not across sibling top-level exports in this
    // file.
    scope: {
        // Clamp a context-menu (x, y) into the viewport. The height defaults to
        // MenuPanel's 60vh maxHeight cap — the TALLEST the menu can ever be —
        // until onRender measures the real size onto `el._ddSize`. Using the
        // worst-case cap (not a small guess) means even the first, unmeasured
        // paint of a long list can't run off the bottom edge; once measured,
        // short menus hug the cursor.
        ddMenuPos (el, dd) {
            const pad = 8;
            const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
            const vh = typeof window !== 'undefined' ? window.innerHeight : 800;
            const w = el && el._ddSize && el._ddSize.w || el?.node?.offsetWidth || 220;
            const h = el && el._ddSize && el._ddSize.h || Math.round(vh * 0.6);
            // An anchor at the screen's bottom or right edge (the account menu of a
            // navbar placed at the bottom or on a rail — shared accountMenu.js) names
            // the menu's FAR edge: `fromRight` — x is its right edge, `fromBottom` —
            // y is its bottom edge, so it opens leftward / upward off the anchor.
            const x = dd.fromRight ? (dd.x || 0) - w : dd.x || 0;
            const y = dd.fromBottom ? (dd.y || 0) - h : dd.y || 0;
            return {
                left: Math.max(pad, Math.min(x, vw - w - pad)),
                top: Math.max(pad, Math.min(y, vh - h - pad))
            };
        },
        // Measure the menu's REAL rendered size and re-clamp — repeatedly, on a
        // short BOUNDED timer. Why a setTimeout chain and not onRender / rAF /
        // ResizeObserver: onRender runs before the rows lay out (measures 0×0)
        // and doesn't reliably re-fire per open, while rAF + ResizeObserver are
        // frame-driven and Chrome throttles frames in backgrounded/automated
        // tabs — the same reason the home Gridstack init polls on a plain timer
        // (see workspace pages/main.js). Symptom fixed here: right-click near
        // the BOTTOM of / — with no measured size the clamp assumed the 60vh
        // worst-case cap and parked the short menu ~40vh above the cursor, and
        // nothing ever corrected it. Each tick measures (zero-guarded: a hidden
        // node's 0×0 never clobbers a real measurement), caches onto
        // `el._ddSize` — which the reactive style factory reads too, so both
        // writers agree — and re-writes the clamped position. Stops when the
        // menu closes, a newer open supersedes it (gen token), or after ~1.2s
        // (late-loading avatar rows still get caught).
        ddSettle (el) {
            if (typeof window === 'undefined' || !el) return;
            el.__ddSettleGen = (el.__ddSettleGen || 0) + 1;
            const gen = el.__ddSettleGen;
            let ticks = 0;
            const tick = ()=>{
                if (gen !== el.__ddSettleGen) return;
                const dd = el.state?.root?.contextDropdown;
                if (!dd || !dd.open || !el.node) return;
                const w = el.node.offsetWidth;
                const h = el.node.offsetHeight;
                if (w > 0 && h > 0) el._ddSize = {
                    w: w,
                    h: h
                };
                const p = this.ddMenuPos(el, dd);
                el.node.style.left = p.left + 'px';
                el.node.style.top = p.top + 'px';
                if (++ticks < 24) window.setTimeout(tick, 50);
            };
            tick();
        },
        // Arrow-key navigation WITHIN one menu level (the top Menu or a
        // Submenu) — same keys/wrap-around math as CanvasNavbar's CreateMenu
        // keyboard model, generalized to whichever container the key bubbled
        // through. `:scope >` scopes to the container's OWN direct rows so a
        // nested Submenu's items never fold into a containing Menu's up/down
        // cycle (and vice-versa); stopPropagation once a key is actually
        // handled so an ancestor level can't ALSO react to the same keystroke.
        menuLevelNav (e, containerNode) {
            if (!containerNode) return;
            const items = Array.from(containerNode.querySelectorAll(':scope > [role="menuitem"], :scope > [role="menuitemcheckbox"]'));
            if (!items.length) return;
            const idx = items.indexOf(document.activeElement);
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                items[idx < 0 ? 0 : (idx + 1) % items.length].focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                items[idx < 0 ? items.length - 1 : (idx - 1 + items.length) % items.length].focus();
            } else if (e.key === 'Home') {
                e.preventDefault();
                e.stopPropagation();
                items[0].focus();
            } else if (e.key === 'End') {
                e.preventDefault();
                e.stopPropagation();
                items[items.length - 1].focus();
            }
        },
        // Escape-close — and every arrow-key move — only works once the
        // delegated keydown walk can reach a handler ON or inside Menu:
        // DOMQL's delegated events walk the ANCESTOR CHAIN of `event.target`,
        // starting at `event.target` itself (smbls/packages/element/src/
        // delegate.js installDelegatedEvent: `let target = event.target; while
        // (target !== rootNode) { check; target = target.parentNode }`), and
        // opening the menu never moved focus into it anywhere — so "open menu
        // -> press Escape immediately" left `event.target` wherever focus
        // already was (often `document.body`), never a descendant of (or
        // equal to) Menu's node, and the walk never reached this handler at
        // all (tickets/fable.md, 2026-08-14 diagnosis: every consumer shared
        // the gap — chat's channel rows and the tickets people pickers had
        // each grown their own local, per-opener workaround for exactly this,
        // see channelActions.js `ensureChatContextMenuEscClose` and
        // Sidebar.js `_focusContextMenuFirstItem`). Moving focus onto the
        // first row here — once, centrally — makes both of those redundant.
        // Also the MORE COMPLETE fix, not just an Escape patch: menuLevelNav's
        // own `idx = items.indexOf(document.activeElement)` already assumed a
        // row could hold focus.
        //
        // Mirrors the open/close focus-lifecycle idiom this same package
        // already ships for AppDialog (functions/appDialogSync.js +
        // appDialogFocusPanel.js) and Modal.js's own `syncUrl` — same
        // `el._wasOpen` / `el._returnFocusTo` names, same edge-detect-once
        // shape, same "a detached node's `.focus()` is a silent no-op, no
        // extra liveness check needed" reasoning. Edge-detected so it fires
        // EXACTLY ONCE per false->true (or true->false) transition:
        // `subscribeTo: ['contextDropdown']` reruns Menu's onUpdate on EVERY
        // contextDropdown mutation, including a submenu's `openKey` toggling
        // and an itemsFn recompute (e.g. a bound filter field) — neither may
        // yank focus back to the top level away from wherever the user
        // actually is. Every close path (Escape here, Backdrop click/
        // right-click, a terminal row action) converges on `contextDropdown:
        // null`, so the true->false edge is the one place that needs to
        // restore focus, regardless of which path fired.
        //
        // Bounded poll, NOT requestAnimationFrame — same reasoning as
        // ddSettle above (already rejected here: Chrome throttles frames in
        // backgrounded/automated tabs). `offsetWidth`/`offsetHeight > 0` is
        // the same "really rendered now, not still display:none behind the
        // parent's `hide:` gate" signal ddSettle already uses; the row query
        // reuses menuLevelNav's own `:scope >` idiom so a nested Submenu's
        // rows (two levels down, NOT a direct child of Menu) can never be
        // mistaken for the top level's first row.
        focusMenuOnOpen (el) {
            if (typeof window === 'undefined' || !el) return;
            const dd = el.state?.root?.contextDropdown;
            const isOpen = !!(dd && dd.open);
            if (isOpen === el._wasOpen) return;
            el._wasOpen = isOpen;
            if (!isOpen) {
                if (el._returnFocusTo && el._returnFocusTo.focus) el._returnFocusTo.focus();
                el._returnFocusTo = null;
                return;
            }
            el._returnFocusTo = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
            el.__focusGen = (el.__focusGen || 0) + 1;
            const gen = el.__focusGen;
            let ticks = 0;
            const tick = ()=>{
                if (gen !== el.__focusGen || !el.node) return;
                if (el.node.offsetWidth > 0 && el.node.offsetHeight > 0) {
                    const firstRow = el.node.querySelector(':scope > [role="menuitem"], :scope > [role="menuitemcheckbox"]');
                    if (firstRow && firstRow.focus) firstRow.focus();
                    else if (el.node.focus) el.node.focus();
                    return;
                }
                if (++ticks < 10) window.setTimeout(tick, 20);
            };
            tick();
        }
    },
    position: 'fixed',
    inset: '0',
    // zIndex is dynamic: an opener on an even-higher surface can pass
    // `contextDropdown.z` to lift the menu above it. The DEFAULT sits above the
    // shell's DropdownRoot layer (10010 — see app.js) and below ModalRoot
    // (10500): a context menu is the most transient surface on screen and must
    // never render underneath an open dropdown panel — the old 1400 default put
    // the right-click menu BEHIND the header-search results panel (2026-08-01
    // per Nika) and behind the messenger overlay (1900) for drawer person rows.
    // Per-key `style` so it re-applies reactively in v3.14 (a flat zIndex freezes
    // at mount).
    style: {
        zIndex: (el, s)=>s.root && s.root.contextDropdown && s.root.contextDropdown.z || '10100'
    },
    hide: (el, s)=>!(s.root && s.root.contextDropdown && s.root.contextDropdown.open),
    // Transparent backdrop — clicking (or right-clicking) anywhere off the menu
    // closes it. Sibling of the Menu, so item clicks don't hit it.
    Backdrop: {
        position: 'absolute',
        inset: '0',
        onPointerdown: (e, el, s)=>s.root.update({
                contextDropdown: null
            }, {
                preventFetch: true
            }),
        onContextmenu: (e, el, s)=>{
            e.preventDefault();
            s.root.update({
                contextDropdown: null
            }, {
                preventFetch: true
            });
        }
    },
    Menu: {
        extends: 'MenuPanel',
        position: 'absolute',
        // Programmatic focus target only — kept OUT of normal Tab order (the
        // standard ARIA menu-container idiom, same as AppDialog's Panel /
        // brand's ModalWindow). Lets `focusMenuOnOpen` fall back to focusing
        // the container itself when there's no row yet (an empty-items open,
        // or the poll below firing before a row exists), so Escape-close is
        // reachable via the delegated walk (see focusMenuOnOpen's comment)
        // even in that edge case.
        tabindex: '-1',
        // Viewport clamp shared by the reactive style factory AND the settle poll
        // so they never disagree (whoever writes inline `left`/`top` last would
        // otherwise win — that fight let the menu overflow). Until a real size is
        // measured, the height falls back to MenuPanel's 60vh cap (the tallest the
        // menu can ever be) — NOT a small guess — so even on the very first paint a
        // long list (e.g. the 50-row people picker) is clamped fully on-screen
        // instead of running off the bottom. ddSettle then measures the ACTUAL
        // rendered size onto `el._ddSize` and re-clamps, so short menus hug the
        // cursor. (2026-06-15 per Nika "dropdown items should never go out of
        // viewport"; settle poll 2026-07-03 per Nika "context menu on / does not
        // align at the bottom".)
        style: {
            left: (el, s)=>el.scope.ddMenuPos(el, s.root && s.root.contextDropdown || {}).left + 'px',
            top: (el, s)=>el.scope.ddMenuPos(el, s.root && s.root.contextDropdown || {}).top + 'px'
        },
        // Re-run the settle poll on mount AND on every contextDropdown change —
        // onRender alone runs before the rows lay out (measures 0×0, so the 60vh
        // worst-case clamp stuck: clicked near the bottom of /, the short menu sat
        // ~40vh above the cursor) and does not reliably re-fire per open in v3.14.
        // subscribeTo + onUpdate is the established re-arm pattern (CanvasPageSlot,
        // GridContainer).
        subscribeTo: [
            'contextDropdown'
        ],
        onRender: (el)=>{
            el.scope.ddSettle(el);
            el.scope.focusMenuOnOpen(el);
        },
        onUpdate: (el)=>{
            el.scope.ddSettle(el);
            el.scope.focusMenuOnOpen(el);
        },
        // Arrow/Home/End move within the top level; Escape closes the WHOLE
        // menu. A row that owns an open submenu handles (and stops) its OWN
        // Escape/ArrowLeft first (see ContextDropdownItem.onKeydown) — this only
        // ever runs once nothing nested intercepted it, i.e. the true top level.
        onKeydown: (e, el, s)=>{
            el.scope.menuLevelNav(e, el.node);
            if (e.key === 'Escape') {
                e.preventDefault();
                s.root && s.root.update({
                    contextDropdown: null
                }, {
                    preventFetch: true
                });
            }
        },
        childExtends: 'ContextDropdownItem',
        childrenAs: 'state',
        children: (el, s)=>{
            const dd = s.root && s.root.contextDropdown;
            if (!dd) return [];
            const list = dd.itemsFn ? el.call(dd.itemsFn, s.root) || [] : dd.items || [];
            // Falsy holes (an itemsFn's `cond && {…}` conditional rows) must never
            // reach the reconciler — a stateless row runs every factory against
            // undefined, and one throw here kills this children effect for good.
            return (Array.isArray(list) ? list : []).filter((it)=>it && typeof it === 'object');
        }
    }
};

});
parcelRegister("f39o3", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $af4e6ae20db0595c$export$48a53dcb22e581d0);
$parcel$export(module.exports, "fadeInTransform", () => $af4e6ae20db0595c$export$a70b3e3f26af624b);
const $af4e6ae20db0595c$var$x = 8, $af4e6ae20db0595c$var$u = (t, D, o)=>({
        bottom: o - t.bottom,
        top: t.top,
        right: D - t.right,
        left: t.left
    }), $af4e6ae20db0595c$var$P = (t, D, o, n)=>{
    const a = $af4e6ae20db0595c$var$u(t, o, n), e = (i)=>a[i] >= D.height + 8;
    return e("bottom") ? "bottom" : e("top") ? "top" : a.bottom >= a.top ? "bottom" : "top";
}, $af4e6ae20db0595c$var$G = (t, D, o, n, a)=>{
    const e = $af4e6ae20db0595c$var$u(D, n, a), i = t === "top" || t === "bottom" ? o.height + 8 : o.width + 8;
    if (e[t] >= i) return t;
    const s = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
    }[t];
    return s && e[s] >= i || s && e[s] > e[t] ? s : t;
}, $af4e6ae20db0595c$var$b = 40, $af4e6ae20db0595c$var$_ = (t, D, o)=>{
    let n;
    return t === "bottom" ? n = o - D.bottom - 16 : t === "top" ? n = D.top - 16 : n = o - 16, Math.max(40, Math.floor(n));
}, $af4e6ae20db0595c$var$r = (t, D, o)=>Math.max(D, Math.min(o, t)), $af4e6ae20db0595c$export$48a53dcb22e581d0 = (t, D, o = "auto")=>{
    if (!t) {
        const m = typeof window < "u" ? window.innerHeight : 768;
        return {
            left: 0,
            top: 0,
            side: "bottom",
            align: "start",
            maxHeight: $af4e6ae20db0595c$var$_("center", null, m)
        };
    }
    const n = typeof window < "u" ? window.innerWidth : 1024, a = typeof window < "u" ? window.innerHeight : 768, e = {
        width: Math.max(120, D?.width || 0),
        height: Math.max(40, D?.height || 0)
    };
    if (o === "center") {
        const m = $af4e6ae20db0595c$var$_("center", t, a), I = Math.min(e.height, m), w = $af4e6ae20db0595c$var$r((n - e.width) / 2, 8, Math.max(8, n - e.width - 8)), A = $af4e6ae20db0595c$var$r((a - I) / 2, 8, Math.max(8, a - I - 8));
        return {
            left: w,
            top: A,
            side: "center",
            align: "center",
            maxHeight: m
        };
    }
    let i, s;
    if (o === "auto") i = $af4e6ae20db0595c$var$P(t, e, n, a), s = "start";
    else {
        const m = o.split("-");
        i = m[0], s = m[1] || "start", i = $af4e6ae20db0595c$var$G(i, t, e, n, a);
    }
    const p = $af4e6ae20db0595c$var$_(i, t, a), f = Math.min(e.height, p);
    let l, h;
    i === "bottom" || i === "top" ? (s === "start" ? l = t.left : s === "end" ? l = t.right - e.width : l = t.left + (t.width - e.width) / 2, h = i === "bottom" ? t.bottom + 8 : t.top - f - 8) : (s === "start" ? h = t.top : s === "end" ? h = t.bottom - f : h = t.top + (t.height - f) / 2, l = i === "right" ? t.right + 8 : t.left - e.width - 8);
    const g = Math.max(8, n - e.width - 8), N = Math.max(8, a - f - 8);
    return l = $af4e6ae20db0595c$var$r(l, 8, g), h = $af4e6ae20db0595c$var$r(h, 8, N), {
        left: l,
        top: h,
        side: i,
        align: s,
        maxHeight: p
    };
}, $af4e6ae20db0595c$export$a70b3e3f26af624b = (t)=>{
    switch(t){
        case "bottom":
            return "translateY(-6px)";
        case "top":
            return "translateY(6px)";
        case "left":
            return "translateX(6px)";
        case "right":
            return "translateX(-6px)";
        case "center":
            return "translateY(0px)";
        default:
            return "translateY(-6px)";
    }
};

});


parcelRegister("iJo40", function(module, exports) {

$parcel$export(module.exports, "PersonaPicker", () => $da2f187c7f1e9f0f$export$64cda144539ad5ee);
$parcel$export(module.exports, "PersonaPill", () => $da2f187c7f1e9f0f$export$d909d76ac64199ab);

var $51O3G = parcelRequire("51O3G");
'use strict';
const $da2f187c7f1e9f0f$export$64cda144539ad5ee = {
    extends: 'MenuPanel',
    position: 'absolute',
    bottom: '100%',
    left: '0',
    marginBottom: 'Z',
    // minWidth inherits MenuPanel's own 'E1' — 3 short rows don't need a
    // bespoke width.
    zIndex: '1',
    role: 'menu',
    ariaLabel: (el)=>el.call('polyglot', 'members.persona.viewAs'),
    hide: (el, s)=>!(s.root && s.root._personaPickerOpen),
    subscribeTo: [
        '_personaPickerOpen'
    ],
    // Escape closes + returns focus to the trigger — standard disclosure
    // pattern, same idiom ContextDropdownItem uses for its own submenu.
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Escape') return;
        e.preventDefault();
        e.stopPropagation();
        s.root.update({
            _personaPickerOpen: false
        });
        const trigger = el.parent && el.parent.RoleToggle;
        if (trigger && trigger.node && typeof trigger.node.focus === 'function') trigger.node.focus();
    },
    // Focus the first row on the CLOSED→OPEN edge only (never steal focus on
    // every re-render) — same false→true edge-detection idiom as app.js's
    // `_prevAssistantOpen`, scoped to this element instance instead of a
    // module-level mutable (Rule 33).
    scope: {
        focusFirstOnOpen (el, s) {
            const isOpen = !!(s.root && s.root._personaPickerOpen);
            if (isOpen && !el._personaPickerWasOpen && el.node) {
                const first = el.node.querySelector('[role="menuitem"]');
                if (first) first.focus();
            }
            el._personaPickerWasOpen = isOpen;
        }
    },
    onRender: (el, s)=>el.scope.focusFirstOnOpen(el, s),
    onUpdate: (el, s)=>el.scope.focusFirstOnOpen(el, s),
    Label: {
        tag: 'p',
        padding: 'Y Z1',
        margin: '0',
        fontSize: 'Y',
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: '.04em',
        color: 'caption',
        text: '{{ members.persona.viewAs | polyglot }}'
    },
    // Data rows (role/label pairs), not DOMQL prop objects — `childrenAs:
    // 'state'` so each row's own data lands on its child `s` alongside the
    // normal state plumbing (s.root, s.key, ...), exactly like ContextDropdown's
    // `Menu.children` + `ContextDropdownItem`.
    children: (el, s)=>(0, $51O3G.PERSONA_ROLE_CATALOG),
    childrenAs: 'state',
    childExtends: 'MenuPanelItem',
    childProps: {
        role: 'menuitem',
        text: (el, s)=>el.call('polyglot', 'members.persona.viewAsRole').replace('{role}', el.call('polyglot', s && s.label || '')),
        onClick: (e, el, s)=>{
            const root = s && s.root;
            if (!root) return;
            root.update({
                _personaPickerOpen: false
            });
            el.call('startPersonaRole', s.role);
        }
    }
};
const $da2f187c7f1e9f0f$export$d909d76ac64199ab = {
    tag: 'div',
    // Critical — see decision #1 above. No box of its own; every visible
    // child is `position:'fixed'`, so this wrapper never enters the shell
    // grid's `1fr` content row.
    display: 'contents',
    subscribeTo: [
        '_personaSession'
    ],
    hide: (el, s)=>!(0, $51O3G.personaActive)(s.root),
    // BOOT-FROM-TRUTH (tickets/opus.md PERSONA-3: "reload must restore AS
    // persona, not silently drop back to admin"). One oracle call at mount:
    // `refreshPersonaSession` asks the SERVER what the presented token's
    // persona state is (GET /persona, the persona-LENIENT worker route) and
    // makes `_personaSession` agree — a reloaded tab re-renders the pill from
    // server truth even though DOMQL state was lost with the page, and a
    // stale claim (ended remotely / expired) is shed instead of trapping the
    // admin behind a banner the server no longer honors. Fire-and-forget:
    // the function never rejects, fails SAFE (state untouched) on transport
    // errors, and no-ops on a pre-oracle @symbo.ls/sdk.
    onRender: (el)=>{
        // A no-op when the boot already asked (loadPrivateData, priv:start).
        el.call('refreshPersonaSession', {
            mount: true
        });
    },
    // Invisible click-outside catcher for the picker — same purely-functional
    // idiom as ContextDropdown's own Backdrop (no background/visual styling,
    // `position:'fixed'` so it covers the WHOLE viewport, not just this
    // wrapper's own subtree). zIndex sits one below the bar so the bar's own
    // buttons always win the hit-test.
    PickerBackdrop: {
        // FA515 — `s.root && s.root.X` short-circuits, so a run where `s.root`
        // hasn't resolved yet never touches `.X` and the tracker never learns
        // this factory depends on it. Explicit `hideDeps` forces the re-run.
        hide: (el, s)=>!(s.root && s.root._personaPickerOpen),
        hideDeps: [
            '_personaPickerOpen'
        ],
        position: 'fixed',
        inset: '0',
        // One below the bar (see the card's TOP-LAYER PROMOTION note).
        zIndex: '10399',
        onPointerdown: (e, el, s)=>s.root.update({
                _personaPickerOpen: false
            })
    },
    // The bar itself. Named to match its base per the auto-extend convention
    // (same as DemoClaimBanner's own `CanvasHelpCard:` child key — no
    // `extends:` needed, the key IS the extend).
    CanvasHelpCard: {
        position: 'fixed',
        right: 'auto',
        left: 'A',
        bottom: 'A',
        // TOP-LAYER PROMOTION (PERSONA-3: "a persona with fewer permissions must
        // not be able to hide its own exit button" — including via a blocking
        // overlay it cannot dismiss). The shell's documented ladder
        // (CreditBlocker.js): DropdownRoot 10010 → context menu 10100 →
        // CreditBlocker 10300 → ModalRoot 10500 → AiBridge/Voice 10600. The
        // pill's old 1500 sat UNDER the whole blocking band — a workspace
        // hitting the credit wall mid-persona stranded the admin with the exit
        // painted beneath the gate. 10400 clears every persistent blocker while
        // staying below ModalRoot: modals are chrome the admin opened and can
        // always dismiss, so painting over their backdrop would be noise, not
        // safety. NB nothing in this app uses the NATIVE top layer
        // (dialog.showModal / popover) today — if that ever changes, this must
        // move to popover='manual' promotion, because no z-index beats the top
        // layer.
        zIndex: '10400',
        flow: 'x',
        align: 'center',
        gap: 'Z1',
        padding: 'Z A',
        boxShadow: 'none',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        '@mobileL': {
            display: 'flex',
            left: 'Z',
            right: 'Z',
            // Live-verified defect (Chrome MCP / puppeteer, both themes, PERSONA-6
            // taste pass 2026-08-13): a flush `bottom: 'Z'` here put the pill
            // directly ON TOP of the AI composer bar at phone widths — both are
            // `position:'fixed'` and bottom-docked, so the exit affordance visibly
            // covered "Whats up?" instead of sitting above it. Same
            // `--slot-bottom` (+`--chip-row` for the phone suggestion-chip band)
            // clearance already wired app-wide for exactly this class of
            // bottom-docked overlay — `CanvasScaffold.js:212` and
            // `tickets/pages/board.js:960` use the identical
            // `calc(var(--slot-bottom) + var(--chip-row))` expression to dock
            // above the SAME composer. Reused verbatim rather than re-deriving a
            // second measurement. NB `DemoClaimBanner.js` (the pill shape this
            // component's own header cites as its precedent) still has the
            // pre-existing flush-`bottom:'Z'` version of this bug — flagged
            // separately, not fixed here (out of this ticket's scope).
            bottom: 'calc(var(--slot-bottom) + var(--chip-row))',
            maxWidth: 'none'
        },
        // Not a help tip — no decorative swipe animation here.
        Lottie: null,
        Icon: {
            // "ROLE LENS" (opus.md PERSONA-1's own phrase) — `eye` is the direct
            // visual match.
            icon: 'eye',
            boxSize: 'Z2',
            minWidth: 'Z2',
            color: 'caption',
            ariaHidden: 'true'
        },
        RoleToggle: {
            tag: 'button',
            type: 'button',
            flow: 'x',
            align: 'center',
            gap: 'X',
            padding: '0',
            background: 'transparent',
            borderWidth: '0',
            cursor: 'pointer',
            color: 'title',
            fontSize: 'Z2',
            fontWeight: '700',
            whiteSpace: 'nowrap',
            ariaHaspopup: 'true',
            // FA515 — same short-circuit trap as PickerBackdrop.hide above; every
            // conditional `s.root && s.root.X` read below gets an explicit `Deps`.
            ariaExpanded: (el, s)=>s.root && s.root._personaPickerOpen ? 'true' : 'false',
            ariaExpandedDeps: [
                '_personaPickerOpen'
            ],
            Label: {
                tag: 'span',
                // The SHIPPED SDK contract is `{ role }` (sdk 26402c58, wrapper
                // 5b917d25) — this read previously spoke the retired `{ type, id }`
                // draft shape, so a real session labeled itself "a different
                // persona". Tolerate the legacy shape defensively (personaRoleLabel
                // already falls back for unknown roles — same fail-open stance as
                // personaActive).
                text: (el, s)=>{
                    const sess = s.root && s.root._personaSession;
                    const role = sess && (sess.role || (sess.type === 'role' ? sess.id : null));
                    // The role LABEL comes from PERSONA_ROLE_CATALOG, which already
                    // carries bundle keys; `personaRoleLabel` is the English fallback
                    // for an enum value the catalog has no row for (editor/member).
                    const row = (0, $51O3G.PERSONA_ROLE_CATALOG).find((r)=>r.role === role);
                    return el.call('polyglot', 'members.persona.viewAsRole').replace('{role}', el.call('polyglot', row && row.label || (0, $51O3G.personaRoleLabel)(role)));
                },
                textDeps: [
                    '_personaSession'
                ]
            },
            Chevron: {
                icon: (el, s)=>s.root && s.root._personaPickerOpen ? 'chevronDown' : 'chevronUp',
                iconDeps: [
                    '_personaPickerOpen'
                ],
                boxSize: 'Y',
                color: 'caption',
                ariaHidden: 'true'
            },
            onClick: (e, el, s)=>{
                s.root.update({
                    _personaPickerOpen: !(s.root && s.root._personaPickerOpen)
                });
            }
        },
        ExitBtn: {
            tag: 'button',
            type: 'button',
            minHeight: 'controlH',
            minWidth: 'F',
            padding: '0 Z1',
            round: 'radiusPill',
            theme: 'tertiary',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: '160ms ease background',
            ':hover': {
                background: 'hover'
            },
            // Token-driven fill/ink step, never opacity — decision #5 +
            // DESIGN_LANGUAGE §8.5 rule 6 + the shipped `dd83fc31` precedent.
            ':disabled': {
                background: 'overlay',
                color: 'caption',
                cursor: 'not-allowed'
            },
            // FA515 — same short-circuit trap; explicit Deps on both conditional
            // reads below.
            disabled: (el, s)=>!!(s.root && s.root._personaExiting),
            disabledDeps: [
                '_personaExiting'
            ],
            // "Exiting…" swap stays inside the button's own reserved geometry
            // (DESIGN_LANGUAGE §8.4 mechanism 4) — minWidth floors it so the swap
            // never visibly resizes the pill.
            text: (el, s)=>el.call('polyglot', s.root && s.root._personaExiting ? 'members.persona.exiting' : 'members.persona.exit'),
            textDeps: [
                '_personaExiting'
            ],
            onClick: async (e, el, s)=>{
                if (s.root && s.root._personaExiting) return;
                s.root.update({
                    _personaExiting: true,
                    _personaPickerOpen: false
                });
                const ok = await el.call('endPersonaSession');
                if (!ok) // EXIT RECONCILIATION (PERSONA-3). ok:false means the end call
                // could not confirm the session died — but "could not confirm"
                // covers the write landing and the RESPONSE being lost. Ask the
                // oracle: it classifies the presented claim through the server's
                // own resolver and sheds blob + state here if the session is in
                // fact dead; if it is genuinely still live (or the oracle is
                // unreachable too) state stays put and the pill keeps telling the
                // truth. A SUCCESSFUL end needs no oracle round trip — the shed
                // in endPersonaSession already matches acknowledged server state.
                await el.call('refreshPersonaSession');
                s.root.update({
                    _personaExiting: false
                });
                if (!ok && s.root && s.root._personaSession) console.warn("[PersonaPill] exit failed \u2014 persona session may still be active server-side");
            }
        },
        PersonaPicker: {}
    }
} // ── Mount ────────────────────────────────────────────────────────────────
 // Bare key `PersonaPill: {}` at a shell root, as a SIBLING of routed
 // `content` — never inside AppHeader or any nav chrome (decision #4: a role
 // whose chrome fails to render must not take the exit with it). Today wired
 // at `workspace/packages/workspace/app.js` only (the concrete "every route"
 // the ticket's acceptance criteria means). Other shell roots (canvas
 // app.js, marketplace app.js, ...) can pick it up with the same one-line
 // addition once persona is confirmed to apply there too — the component
 // itself needs no per-app change, it already no-ops with no active persona.
;

});
parcelRegister("51O3G", function(module, exports) {

$parcel$export(module.exports, "PERSONA_ROLE_CATALOG", () => $3a93e04b7fcf794e$export$1b067fc9de1fc65c);
$parcel$export(module.exports, "personaRoleLabel", () => $3a93e04b7fcf794e$export$c7620ba2785b8e64);
$parcel$export(module.exports, "personaSessionRole", () => $3a93e04b7fcf794e$export$619ecd0b9eed5d03);
$parcel$export(module.exports, "personaActive", () => $3a93e04b7fcf794e$export$5afa8234bbf8487d);
$parcel$export(module.exports, "personaDisabledProps", () => $3a93e04b7fcf794e$export$a8f8c802f5c7d595);
$parcel$export(module.exports, "startPersonaRole", () => $3a93e04b7fcf794e$export$ba6c5da1e386c5de);
$parcel$export(module.exports, "endPersonaSession", () => $3a93e04b7fcf794e$export$24d466718def75e0);
$parcel$export(module.exports, "refreshPersonaSession", () => $3a93e04b7fcf794e$export$f54a3acf24ad3f8a);

var $9UTQi = parcelRequire("9UTQi");
'use strict';
const $3a93e04b7fcf794e$export$1b067fc9de1fc65c = [
    {
        role: 'admin',
        label: 'members.persona.role.admin'
    },
    // "sign it as [team member]" (Nika, 2026-08-11, RESIDUALS ANSWERED) —
    // never a tenant's own job title (e.g. bellforge's "Searcher").
    {
        role: 'viewer',
        label: 'members.persona.role.teamMember'
    },
    {
        role: 'guest',
        label: 'members.persona.role.guest'
    }
];
function $3a93e04b7fcf794e$export$c7620ba2785b8e64(role) {
    const labels = {
        admin: 'Admin',
        editor: 'Manager',
        viewer: 'Team member',
        member: 'Team member',
        guest: 'Guest'
    };
    return labels[role] || 'a different persona';
}
function $3a93e04b7fcf794e$export$619ecd0b9eed5d03(session) {
    if (!session || typeof session !== 'object') return null;
    if (typeof session.role === 'string' && session.role) return session.role;
    if (session.type === 'role' && typeof session.id === 'string' && session.id) return session.id;
    return null;
}
function $3a93e04b7fcf794e$export$5afa8234bbf8487d(root) {
    return !!(root && root._personaSession);
}
function $3a93e04b7fcf794e$export$a8f8c802f5c7d595(root, minRole) {
    const session = root && root._personaSession;
    if (!session) return {
        disabled: false,
        title: null
    };
    // Self-contained copies — FA204/frank trap: frank.toJSON serializes each
    // functions-file export independently, so a bare reference to a
    // module-local binding (PERSONA_ROLE_RANK) or a sibling exported function
    // (personaRoleLabel) reads as undefined once this file is served to a
    // consuming app (project_frank_drops_module_local_helpers — same class as
    // every other fix in this sweep; workspaceModuleRef.js's
    // applyCollectionsSync duplicates its own `defaultOps` literal rather than
    // reading the exported WS_APP_RECORD_OPS bare for the identical reason).
    // Keep both literals in sync with PERSONA_ROLE_RANK/PERSONA_ROLE_CATALOG
    // above by hand.
    const roleRank = {
        admin: 4,
        editor: 3,
        viewer: 2,
        member: 2,
        guest: 1
    };
    const roleLabel = (role)=>({
            admin: 'Admin',
            editor: 'Manager',
            viewer: 'Team member',
            member: 'Team member',
            guest: 'Guest'
        })[role] || 'a different persona';
    // Both session shapes (inline copy of personaSessionRole — same FA204
    // discipline): server-truth `{ role }` first, legacy `{ type:'role', id }`
    // tolerated; anything else (incl. the forbidden `{ type:'user' }`) → null
    // → rank 0 → fail CLOSED.
    const sessionRole = typeof session.role === 'string' && session.role ? session.role : session.type === 'role' && typeof session.id === 'string' && session.id ? session.id : null;
    const activeRank = sessionRole ? roleRank[sessionRole] ?? 0 : 0;
    const minRank = roleRank[minRole] ?? 0;
    if (activeRank >= minRank) return {
        disabled: false,
        title: null
    };
    const label = sessionRole ? roleLabel(sessionRole) : 'this persona';
    return {
        disabled: true,
        title: `Not available to ${label}`
    };
}
async function $3a93e04b7fcf794e$export$ba6c5da1e386c5de(role) {
    const el = this;
    if (!el || !el.sdk || typeof el.sdk.startPersona !== 'function') {
        console.warn('[persona] sdk.startPersona is not available (pre-PERSONA-4 @symbo.ls/sdk)');
        return false;
    }
    try {
        // Role-only shape — the shipped contract (server 886a9b27 + sdk
        // 26402c58) made the draft's `{ type, id }` axis structurally
        // unrepresentable (its only other value was the forbidden per-person
        // one), so the SDK takes `{ role }` and refuses anything user-shaped.
        // NB `role` must be a REAL workspace tier (sdk PERSONA_TARGET_ROLES:
        // admin/editor/viewer/guest — owner excluded). The picker owns mapping
        // its UI labels ("[team member]") onto that enum — PERSONA-6 territory;
        // the catalog above is labels, not wire values.
        const data = await el.sdk.startPersona({
            role: role
        });
        const persona = data && typeof data === 'object' ? data.persona : null;
        // PER-TAB PERSISTENCE (Nika, 2026-08-14: persona isolation is per-tab).
        // The SDK now installs the token as a sessionStorage OVERLAY instead of
        // overwriting `symbols_access_token`, so the admin's other tabs stay
        // admin. This writes the matching session blob — the same per-tab
        // storage — so a reload of THIS tab keeps showing the lens and its exit
        // affordance, instead of rendering as the admin against persona-narrowed
        // data. The blob deliberately carries no more than the server sent.
        if (persona && data && typeof data.accessToken === 'string') (0, $9UTQi.writePersonaSession)({
            token: data.accessToken,
            sid: persona.sid,
            role: persona.role || role,
            startedAt: persona.startedAt,
            expiresAt: persona.expiresAt,
            workspaceId: persona.workspaceId,
            actorWorkspaceRole: persona.actorWorkspaceRole
        });
        const state = el.state ? el.state : null;
        const root = state && state.root ? state.root : state;
        if (root && typeof root.update === 'function') root.update({
            _personaSession: {
                role: persona && persona.role || role,
                sid: persona && persona.sid || null,
                startedAt: persona && persona.startedAt || null,
                actorWorkspaceRole: persona && persona.actorWorkspaceRole || null
            }
        });
        return true;
    } catch (err) {
        console.warn('[persona] startPersona failed:', err && err.message || err);
        return false;
    }
}
async function $3a93e04b7fcf794e$export$24d466718def75e0() {
    const el = this;
    const state = el && el.state ? el.state : null;
    const root = state && state.root ? state.root : state;
    const shedLocal = ()=>{
        (0, $9UTQi.clearPersonaSession)();
        if (root && typeof root.update === 'function') root.update({
            _personaSession: null,
            _personaPickerOpen: false
        });
    };
    if (!el || !el.sdk || typeof el.sdk.endPersona !== 'function') {
        console.warn("[persona] sdk.endPersona is not available (pre-PERSONA-4 @symbo.ls/sdk) \u2014 shedding the persona locally; the server row expires on its own");
        shedLocal();
        return true;
    }
    try {
        // sdk.endPersona NEVER rejects — it resolves { ok, wasActive, ... }
        // and reports ok:false only when the persona is genuinely still in
        // force (unreachable server AND unrefreshable token), so the exit
        // affordance can stay visible instead of lying. Surface that as this
        // wrapper's boolean.
        const result = await el.sdk.endPersona();
        const ok = !result || result.ok !== false;
        if (ok) shedLocal();
        return ok;
    } catch (err) {
        console.warn('[persona] endPersona failed:', err && err.message || err);
        return false;
    }
}
async function $3a93e04b7fcf794e$export$f54a3acf24ad3f8a(opts) {
    const el = this;
    const mode = opts && typeof opts === 'object' ? opts : {};
    const holder = globalThis.__personaRefresh = globalThis.__personaRefresh || {
        pending: null,
        bootStarted: false
    };
    if (mode.mount && holder.bootStarted) return holder.pending || true;
    if (holder.pending) return holder.pending;
    if (mode.boot) holder.bootStarted = true;
    holder.pending = (async ()=>{
        if (!el || !el.sdk || typeof el.sdk.getPersonaSession !== 'function') // Pre-oracle @symbo.ls/sdk — nothing to reconcile against; the pill
        // keeps rendering from local state (fail open toward showing the exit).
        return false;
        const state = el.state ? el.state : null;
        const root = state && state.root ? state.root : state;
        if (!root || typeof root.update !== 'function') return false;
        try {
            const res = await el.sdk.getPersonaSession();
            const truth = res && typeof res === 'object' && 'active' in res ? res : res && res.data;
            if (!truth || typeof truth !== 'object') return false;
            if (truth.active === true && typeof truth.role === 'string') {
                root.update({
                    _personaSession: {
                        role: truth.role,
                        sid: truth.sid || null,
                        startedAt: truth.startedAt || null,
                        actorWorkspaceRole: truth.actorWorkspaceRole || null
                    }
                });
                return true;
            }
            if (truth.active === false) {
                if (truth.stale) {
                    console.warn('[persona] server no longer honors this persona session (' + (truth.reason || 'unknown') + ") \u2014 recovering to the base session");
                    (0, $9UTQi.clearPersonaSession)();
                }
                if (root._personaSession) root.update({
                    _personaSession: null,
                    _personaPickerOpen: false
                });
                return true;
            }
            return false;
        } catch (err) {
            console.warn("[persona] getPersonaSession failed \u2014 keeping current persona state:", err && err.message || err);
            return false;
        }
    })().finally(()=>{
        holder.pending = null;
    });
    return holder.pending;
}

});
parcelRegister("9UTQi", function(module, exports) {

$parcel$export(module.exports, "PERSONA_SESSION_STORAGE_KEY", () => $7384a926905a9d7b$export$12b74048b343ef95);
$parcel$export(module.exports, "readPersonaSession", () => $7384a926905a9d7b$export$2c82d39646365728);
$parcel$export(module.exports, "writePersonaSession", () => $7384a926905a9d7b$export$555a836218aa7886);
$parcel$export(module.exports, "clearPersonaSession", () => $7384a926905a9d7b$export$8af16b618a713186);
$parcel$export(module.exports, "personaSessionExpired", () => $7384a926905a9d7b$export$37b0fd1768d76d22);
$parcel$export(module.exports, "readPersonaWorkspaceToken", () => $7384a926905a9d7b$export$fec7fada316e9015);
$parcel$export(module.exports, "personaStateFromSession", () => $7384a926905a9d7b$export$e00db09ea3d0548d);

var $jhJrJ = parcelRequire("jhJrJ");
'use strict';
const $7384a926905a9d7b$export$12b74048b343ef95 = 'symbols_persona_session';
function $7384a926905a9d7b$export$2c82d39646365728() {
    const KEY = 'symbols_persona_session';
    const storage = ()=>{
        try {
            return typeof globalThis.sessionStorage !== 'undefined' ? globalThis.sessionStorage : null;
        } catch  {
            return null;
        }
    };
    const validShape = (s)=>!!s && typeof s === 'object' && typeof s.token === 'string' && s.token.length > 0 && typeof s.sid === 'string' && s.sid.length > 0 && [
            'admin',
            'editor',
            'viewer',
            'guest'
        ].includes(s.role) && Number.isFinite(s.startedAt) && Number.isFinite(s.expiresAt) && typeof s.workspaceId === 'string' && s.workspaceId.length > 0;
    const store = storage();
    if (!store) return null;
    let raw = null;
    try {
        raw = store.getItem(KEY);
    } catch  {
        return null;
    }
    if (!raw) return null;
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch  {
        parsed = null;
    }
    if (!validShape(parsed)) {
        // Corrupt blob — degrade to the honest base session, loudly.
        try {
            store.removeItem(KEY);
        } catch  {
        /* locked storage — nothing else to do */ }
        console.warn("[persona] malformed stored session cleared \u2014 back to the base session");
        return null;
    }
    return parsed;
}
function $7384a926905a9d7b$export$555a836218aa7886(envelope) {
    const KEY = 'symbols_persona_session';
    const storage = ()=>{
        try {
            return typeof globalThis.sessionStorage !== 'undefined' ? globalThis.sessionStorage : null;
        } catch  {
            return null;
        }
    };
    const src = envelope && typeof envelope === 'object' ? envelope : null;
    const session = src ? {
        token: typeof src.token === 'string' ? src.token : null,
        sid: typeof src.sid === 'string' ? src.sid : null,
        role: src.role,
        startedAt: Number(src.startedAt),
        expiresAt: Number(src.expiresAt),
        workspaceId: typeof src.workspaceId === 'string' ? src.workspaceId : null,
        actorWorkspaceRole: typeof src.actorWorkspaceRole === 'string' ? src.actorWorkspaceRole : null
    } : null;
    const valid = !!session && !!session.token && !!session.sid && [
        'admin',
        'editor',
        'viewer',
        'guest'
    ].includes(session.role) && Number.isFinite(session.startedAt) && Number.isFinite(session.expiresAt) && !!session.workspaceId;
    if (!valid) {
        console.warn('[persona] refusing to store a malformed persona session envelope');
        return false;
    }
    const store = storage();
    if (!store) return false;
    try {
        store.setItem(KEY, JSON.stringify(session));
        return true;
    } catch  {
        return false;
    }
}
function $7384a926905a9d7b$export$8af16b618a713186() {
    const KEY = 'symbols_persona_session';
    try {
        if (typeof globalThis.sessionStorage !== 'undefined') globalThis.sessionStorage.removeItem(KEY);
    } catch  {
    /* locked storage */ }
}
function $7384a926905a9d7b$export$37b0fd1768d76d22(session, nowMs) {
    if (!session || !Number.isFinite(session.expiresAt)) return false;
    const now = Number.isFinite(nowMs) ? nowMs : Date.now();
    return session.expiresAt <= now;
}
function $7384a926905a9d7b$export$fec7fada316e9015() {
    const KEY = 'symbols_persona_session';
    const storage = ()=>{
        try {
            return typeof globalThis.sessionStorage !== 'undefined' ? globalThis.sessionStorage : null;
        } catch  {
            return null;
        }
    };
    const store = storage();
    if (!store) return null;
    let parsed = null;
    try {
        const raw = store.getItem(KEY);
        parsed = raw ? JSON.parse(raw) : null;
    } catch  {
        parsed = null;
    }
    if (!parsed || typeof parsed.token !== 'string' || !parsed.token) return null;
    let pointer = null;
    try {
        pointer = (0, $jhJrJ.getActiveWorkspacePointer)() || null;
    } catch  {
        pointer = null;
    }
    if (pointer && typeof parsed.workspaceId === 'string' && parsed.workspaceId && String(pointer) !== String(parsed.workspaceId)) {
        try {
            store.removeItem(KEY);
        } catch  {
        /* locked storage */ }
        console.warn("[persona] persona session was bound to a different workspace \u2014 cleared (base session restored)");
        return null;
    }
    return parsed.token;
}
function $7384a926905a9d7b$export$e00db09ea3d0548d(session) {
    if (!session || typeof session !== 'object') return null;
    return {
        role: session.role,
        sid: session.sid,
        startedAt: session.startedAt,
        expiresAt: session.expiresAt,
        workspaceId: session.workspaceId,
        actorWorkspaceRole: session.actorWorkspaceRole || null
    };
}

});



parcelRegister("8G5VK", function(module, exports) {

$parcel$export(module.exports, "UploadProgress", () => $6516d8a0d04cfc2b$export$98a3886347b629fb);
const $6516d8a0d04cfc2b$export$98a3886347b629fb = {
    flow: 'x',
    theme: 'field',
    padding: 'Z1 Z1+V Z1 Z1',
    round: 'A2',
    position: 'relative',
    align: 'center flex-start',
    gap: 'Z',
    '@mobileS': {
        fontSize: 'Z2'
    },
    Icon: {
        theme: 'bordered',
        icon: 'copy',
        boxSizing: 'content-box',
        padding: 'Y2',
        fontSize: 'C',
        round: 'radiusControl'
    },
    XBtn: {
        position: 'absolute',
        top: 'Y',
        right: 'Y1',
        padding: 'Y',
        $isSafari: {
            top: '0',
            right: 'Y'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'X',
        flex: '1',
        H6: {
            text: 'Image.jpg',
            alignSelf: 'flex-start',
            fontWeight: '700'
        },
        ProgressLineValue: {
            ProgressLine: {},
            UnitValue: {}
        }
    }
};

});

parcelRegister("dngBU", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $9bca4ed8497849ca$export$fddf379e22a74b00);
$parcel$export(module.exports, "EmptyStateTiles", () => $9bca4ed8497849ca$export$74f3e823f12d9978);
$parcel$export(module.exports, "EmptyStateImages", () => $9bca4ed8497849ca$export$94b8f93c2313f297);
$parcel$export(module.exports, "EmptyStateLoading", () => $9bca4ed8497849ca$export$6af6f9887e137fe8);
// Generic empty-state component for list / grid / dashboard views.
// Drop into any container with `extends: 'EmptyState'` and override
// the `icon`, `title`, `hint`, `action` props as needed.
//
// Pattern:
//   MyEmptyState: {
//     extends: 'EmptyState',
//     icon: 'people',
//     title: 'No team members yet',
//     hint: 'Invite teammates to start collaborating.',
//     action: { text: 'Invite member', onClick: (e, el, s) => ... }
//   }
//
// TRANSLATION — read docs/I18N-CONVENTION.md §1.2 before changing this.
// `title` is a global HTML attribute, so a `{{ … | polyglot }}` template put
// on it is resolved to '' by the static attribute pass and written back over
// the prop, and a FUNCTION value is dropped by the child's text effect. There
// is no working rewrite form — only a RENAME. So this component now reads
// `heading` / `hintText` FIRST and keeps `title` / `hint` as the back-compat
// fallback (canvas and workspace still pass those). Both paths are resolved
// through polyglot at the render site, so a call site may pass EITHER a bundle
// key ('canvas.empty.noPages') or a plain string; polyglot returns a non-key
// verbatim. New call sites: pass a KEY on `heading` / `hintText`.
// THE ERROR VARIANT (white-label redesign 2026-09-26, DESIGN_SPEC §5.8, L60):
// a page that could not load its data is a calm poster, never a red banner —
//
//   EmptyState: {
//     variant: 'error',
//     heading: 'crm.error.contacts',          // "Couldn't load contacts"
//     hintText: 'common.error.retryHint',     // "Check your connection…"
//     details: (el, s) => s.root.crmError,    // the raw message, folded away
//     action: { text: 'common.action.try_again', onClick: … }
//   }
//
// The alert glyph in `dangerInk` on the neutral plate; the one action is
// TONAL (the `layer` wash), not the ink primary — retrying is a recovery,
// not a call to action; the technical message sits behind a native "Details"
// disclosure in the `Code` face, so it is reachable and never the headline.
// The error poster is announced (role=alert). Capability refusals are not
// errors and never reach this (the view is gated instead).
const $9bca4ed8497849ca$export$fddf379e22a74b00 = {
    flow: 'y',
    align: 'center center',
    gap: 'A',
    padding: 'C A',
    width: '100%',
    textAlign: 'center',
    // Default props — consumers override.
    variant: 'empty',
    details: null,
    role: (el)=>el.variant === 'error' ? 'alert' : null,
    icon: null,
    heading: '',
    headingTail: '',
    hintText: '',
    title: '',
    hint: '',
    action: null,
    visual: null,
    // THE VISUAL SLOT (brief §4.8 item 3, P08 / P15 / P16, 2026-09-24): an
    // optional picture ABOVE the heading — an image stack or a tile preview
    // (EmptyStateImages / EmptyStateTiles below), or any definition. It takes
    // the icon's place: a poster shows one picture.
    Visual: {
        if: (el)=>!!el.parent?.visual,
        flow: 'y',
        align: 'center center',
        // A definition rendered as-is: `childrenAs: 'element'`. A `content` factory
        // returning the same object mounted an EMPTY element (measured).
        childrenAs: 'element',
        children: (el)=>el.parent?.visual ? [
                el.parent.visual
            ] : []
    },
    // Decorative icon — falls back to nothing if no icon prop (the error
    // variant falls back to the alert glyph).
    IconWrap: {
        if: (el)=>!!(el.parent?.icon || el.parent?.variant === 'error') && !el.parent?.visual,
        flow: 'y',
        align: 'center center',
        width: 'C',
        height: 'C',
        // A circle from the shape token (was the raw '50%'), on the neutral
        // PLATE: `overlay` is a 5% wash of the ground's own family and read
        // 1.00:1 on a common-box card (brand TabSet); `widgetPlate` steps on the
        // sheet, the card and the document (brief §4.8, 2026-09-24).
        round: 'radiusPill',
        background: 'widgetPlate',
        color: (el)=>el.parent?.variant === 'error' ? 'dangerInk' : 'caption',
        Icon: {
            icon: (el)=>el.parent.parent.icon || (el.parent.parent.variant === 'error' ? 'exclMark' : null),
            boxSize: 'A1'
        }
    },
    Title: {
        tag: 'h3',
        fontSize: 'A1',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el)=>el.call('polyglot', el.parent.heading || el.parent.title || ''),
        // THE TWO-TONE HEADING (brief §4.8 item 2, P16 / P35 / P45): an optional
        // quiet second half in the SAME heading. `inactive` in light; `caption`
        // in dark, because a poster may sit on the bare dark stage, where
        // `inactive` reads 3.33:1 and `caption` 6.07:1 (brief G6).
        Tail: {
            tag: 'span',
            if: (el)=>!!el.parent?.parent?.headingTail,
            color: 'inactive',
            '@dark': {
                color: 'caption'
            },
            text: (el)=>' ' + el.call('polyglot', el.parent.parent.headingTail || '')
        }
    },
    Hint: {
        if: (el)=>!!(el.parent?.hintText || el.parent?.hint),
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        margin: '0',
        maxWidth: 'J',
        text: (el)=>el.call('polyglot', el.parent.hintText || el.parent.hint || '')
    },
    // The raw message of a failure, folded away (error variant only).
    ErrorDetails: {
        tag: 'details',
        hide: (el)=>!(el.parent?.variant === 'error' && el.parent?.details),
        maxWidth: 'J',
        width: '100%',
        textAlign: 'left',
        ErrorSummary: {
            tag: 'summary',
            cursor: 'pointer',
            fontSize: 'Z1',
            color: 'caption',
            textAlign: 'center',
            ':hover': {
                color: 'title'
            },
            text: (el)=>el.call('polyglot', 'common.action.details')
        },
        ErrorText: {
            tag: 'pre',
            margin: 'Z 0 0',
            padding: 'Z A',
            round: 'radiusControl',
            theme: 'layer',
            fontFamily: 'Code',
            fontSize: 'Y',
            color: 'caption',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            text: (el)=>{
                const d = el.parent.parent.details;
                return String((typeof d === 'function' ? d(el.parent.parent, el.state) : d) || '');
            }
        }
    },
    ActionBtn: {
        if: (el)=>!!el.parent?.action,
        tag: 'button',
        type: 'button',
        // The one primary action of the poster moment — solid-ink capsule on the
        // control scale (DESIGN_LANGUAGE.md §6.2; primary actions are ink, never
        // hue fills — §1). The `primary` theme carries the hover/focus/active
        // state steps (Rule 65). The error variant's retry is TONAL.
        theme: 'primary',
        // flat hook: FW-ELEMENT-DEFINITION-DATA-REPLACES-EXTENDS-DATA-1
        dataVariant: (el)=>el.parent?.variant || 'empty',
        '&[data-variant="error"]': {
            theme: 'layer',
            color: 'title'
        },
        '&[data-variant="error"]:hover': {
            background: 'selected'
        },
        minHeight: 'controlH',
        padding: '0 A',
        round: 'radiusPill',
        fontSize: 'Z2',
        fontWeight: '500',
        border: 'none',
        cursor: 'pointer',
        marginTop: 'V',
        text: (el)=>el.call('polyglot', el.parent?.action?.text || ''),
        onClick: (e, el, s)=>{
            const action = el.parent?.action;
            if (typeof action?.onClick === 'function') action.onClick(e, el, s);
        }
    }
};
const $9bca4ed8497849ca$export$74f3e823f12d9978 = {
    flow: 'x',
    gap: 'Y',
    count: 3,
    childrenAs: 'props',
    children: (el)=>Array.from({
            length: el.count || 3
        }, (_, i)=>({
                key: `tile-${i}`
            })),
    childProps: {
        boxSize: 'C',
        round: 'radiusControl',
        background: 'widgetPlate'
    }
};
const $9bca4ed8497849ca$export$94b8f93c2313f297 = {
    display: 'grid',
    images: [],
    childExtends: 'Img',
    children: (el)=>(el.images || []).slice(0, 3).map((src, i)=>({
                key: `img-${i}`,
                src: src,
                layer: i
            })),
    childProps: {
        gridArea: '1 / 1',
        boxSize: 'D',
        round: 'radiusCard',
        objectFit: 'cover',
        alt: '',
        transform: (el)=>`translateX(calc(var(--spacing-Z) * ${el.layer - 1}))`
    }
};
const $9bca4ed8497849ca$export$6af6f9887e137fe8 = {
    flow: 'y',
    align: 'center center',
    gap: 'A',
    padding: 'C A',
    width: '100%',
    ariaBusy: 'true',
    // Each part is the shared Skeleton family by its own key.
    SkeletonCircle: {
        width: 'C',
        height: 'C',
        round: 'radiusPill'
    },
    // the title's A1 line box
    SkeletonRow: {
        fontSize: 'A1',
        height: 'auto',
        width: 'F2',
        text: '\u00a0'
    },
    // Two hint lines are two line boxes with NO gap between them — a gap made
    // the block 1.53px taller than a two-line hint, and the action sat 1.64px
    // low until the swap (measured live on dev, 2026-09-24). The bars get
    // their separation from a visual-only scale, which moves no layout.
    HintLines: {
        flow: 'y',
        align: 'center center',
        gap: '0',
        width: '100%',
        maxWidth: 'J',
        childProps: {
            fontSize: 'Z2',
            height: 'auto',
            text: '\u00a0',
            transform: 'scaleY(0.7)'
        },
        SkeletonRow_1: {
            width: '100%'
        },
        SkeletonRow_2: {
            width: '70%'
        }
    },
    // the action's capsule
    Skeleton: {
        minHeight: 'controlH',
        width: 'E1',
        round: 'radiusPill',
        marginTop: 'V'
    }
};

});

parcelRegister("ee5Fb", function(module, exports) {

$parcel$export(module.exports, "SwitchInput", () => $a5b6c4168faaf282$export$f8fd43a15610a9c6);
// Generic iOS-style switch — the house replacement for native
// `type: 'checkbox'` inputs (admin pages migrated 2026-07-25 per Nika
// "check all buttons, ui … fix the whole admin area"). Value-driven and
// registry-agnostic; FlagSwitch (components/FlagRow.js) extends this
// with the /admin/flags registry semantics.
//
// CONTRACT: consumers override `onCheck: (el, s) => bool` — deliberately
// `on`-prefixed: v3.14 evaluates ordinary function props ONCE at create
// and freezes the RESULT (el.isChecked became a boolean and every CSS
// factory calling it threw, dropping the whole style layer — verified
// live on /admin/activity-scoring 2026-07-25). `on*` props are the
// framework's handler class: they stay FUNCTIONS on the element, so the
// reactive CSS factories below can dispatch through them per repaint.
// aria-checked rides the attr bag — a top-level quoted dash-key prop
// does not survive `extends` inheritance, attr entries do.
//
// Geometry: track C×(A1 + 2·X) ≈ 44×28 with a ~20px knob — the compact
// Apple ratio. The knob parks left/right via a justify flip; the
// animated cue is the track fill and the knob ink (no ring: the OFF track is
// a visible plate of its own).
const $a5b6c4168faaf282$export$f8fd43a15610a9c6 = {
    tag: 'button',
    type: 'button',
    role: 'switch',
    onCheck: ()=>false,
    attr: {
        'aria-checked': (el, s)=>el.onCheck && el.onCheck(el, s) ? 'true' : 'false'
    },
    cursor: 'pointer',
    border: 'none',
    width: 'C',
    minWidth: 'C',
    padding: 'X',
    round: 'radiusPill',
    flow: 'x',
    flexShrink: '0',
    align: (el, s)=>el.onCheck && el.onCheck(el, s) ? 'center right' : 'center left',
    // MONOCHROME, CSS-DRIVEN STATE (admin audit 2026-09-24; DESIGN_LANGUAGE
    // §8.1-8.2). Every state is a CLASS rule keyed on the switch's own
    // `aria-checked` attribute or `:disabled`. There is no inline fill and no
    // inline box-shadow, so the reset's :focus-visible ring shows (an inline
    // box-shadow hid it on 56 switches), and no reactive :hover makes the
    // framework emit !important.
    //
    // The knob paints `currentColor`, so each state sets the switch's
    // `color` for the knob and the `background` for the track:
    //   OFF      track `title.14` (the house tonal step: 1.37 light, 1.46 dark
    //            on the sheet), knob `caption`; hover `title.22`, pressed `title.3`
    //   ON       the ink itself: track `title`, knob `title-reversed` (18.2);
    //            hover `title.8`, pressed `title.7`. The selection wash
    //            (`selected`) cannot mark ON: in light it is one alpha step
    //            from a visible OFF plate.
    //   DISABLED the OFF plate whatever the value, knob `inactive` (sheet /
    //            card: 5.38 / 4.79 light, 4.42 / 3.57 dark; the `disabled`
    //            ink read 2.87 on the dark card) — the knob's side still shows
    //            the value; never opacity (DESIGN_LANGUAGE §8.1).
    // Every step clears Rule 65's 0.02 luminance step in both themes, and the
    // knob clears 3:1 on every step, on the sheet and on a card. Like every
    // choice control, a switch sits on a card or sheet: on the bare dark stage
    // the pressed OFF knob reads 2.78.
    // ORDER MATTERS: the engine doubles the class of a bare `:hover` rule, so
    // it ties with the ON and DISABLED pointer rules; the later rule wins,
    // so the ON block stays after the rest states and DISABLED stays last.
    color: 'caption',
    background: 'title.14',
    transition: 'Z defaultBezier background, Z defaultBezier color',
    ':hover': {
        background: 'title.22'
    },
    ':active': {
        background: 'title.3'
    },
    '&[aria-checked="true"]': {
        color: 'title-reversed',
        background: 'title',
        ':hover': {
            background: 'title.8'
        },
        ':active': {
            background: 'title.7'
        }
    },
    ':disabled': {
        color: 'inactive',
        background: 'title.14',
        cursor: 'not-allowed',
        ':hover': {
            background: 'title.14'
        },
        ':active': {
            background: 'title.14'
        }
    },
    Knob: {
        boxSize: 'A1 A1',
        round: '100%',
        // The switch's ink for its state (see the block above): `caption` OFF,
        // `title-reversed` ON, `inactive` while disabled.
        background: 'currentColor',
        transition: 'Z defaultBezier background',
        flexShrink: '0',
        pointerEvents: 'none'
    }
};

});

parcelRegister("8MiLp", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $66415c7eb689a6b4$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonRow", () => $66415c7eb689a6b4$export$8bbcb87f63697989);
$parcel$export(module.exports, "SkeletonCircle", () => $66415c7eb689a6b4$export$7d2444dbb58007d7);
$parcel$export(module.exports, "SkeletonCard", () => $66415c7eb689a6b4$export$5956eb8f2ff4afde);
// Generic skeleton placeholder. Use while async data is loading so the
// page reserves its final layout instead of flashing "Loading…" text.
//
// Usage:
//   ListLoading: {
//     extends: 'Skeleton',
//     width: '100%', height: 'A',  // override size to match final content
//     round: 'Y'
//   }
//
//   Plus the SkeletonRow / SkeletonCircle helpers for common shapes.
//
// Animation: a gentle opacity pulse via brand's `pulse` keyframe
// (company/packages/brand/designSystem/animation.js). That keyframe did not
// actually exist until 2026-08-08 — this file had named it since it was
// written, and an unknown animation-name is silently inert in CSS, so every
// skeleton in the product was a flat static block and the reduced-motion
// branch below had no motion to suppress. Both are live now.
const $66415c7eb689a6b4$export$8f31e4c4a37b8e9c = {
    display: 'block',
    width: '100%',
    // §9 zero-shift law: a skeleton must mirror the geometry of the real
    // content it stands in for. `V` (~1.5px) measured invisible in the live
    // app (DESIGN-LOCKS-RED-1 browser check) — no real line of text is
    // 1.5px tall. `Z` sits in this design system's line-height range.
    height: 'Z',
    round: 'radiusPill',
    // `overlay` is an ink-matching-background wash (gray14/gray2 — the SAME
    // base gray a dark-theme modal panel already is), so a skeleton inside a
    // Modal composited to zero visible contrast (measured live, DESIGN-LOCKS-
    // RED-1 browser check: fill and panel both rgb(20,20,22)). `selected`
    // washes the OPPOSITE tone (black/white alpha, like `hover`), so it reads
    // against either theme's panel regardless of the panel's own shade.
    background: 'selected',
    // shimmer animation — gentle 1.5s loop
    animation: 'pulse 1.5s ease-in-out infinite',
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        opacity: '0.6'
    }
};
const $66415c7eb689a6b4$export$8bbcb87f63697989 = {
    extends: 'Skeleton',
    height: 'Z'
};
const $66415c7eb689a6b4$export$7d2444dbb58007d7 = {
    extends: 'Skeleton',
    width: 'B',
    height: 'B',
    // the shape token (was the raw '50%'): a pill on a square box is a circle
    round: 'radiusPill'
};
const $66415c7eb689a6b4$export$5956eb8f2ff4afde = {
    flow: 'y',
    gap: 'V',
    padding: 'A',
    round: 'radiusCard',
    // The SURFACE of the card it stands for, too (Rule 66): the brand `card`
    // theme, the raised surface one step off a sheet — 1.13:1 light, 1.19:1
    // dark, and its `selected` rows step on it. It was `overlay`, a 5% wash
    // of the ground's own family: 1.01:1 on the sheet in light and 1.00:1 in
    // dark, so the card vanished and only its rows showed (filed by admin fix
    // lane B, 2026-09-24, which had to force `theme: 'card'` on the page).
    theme: 'card',
    Title: {
        extends: 'SkeletonRow',
        width: '60%',
        height: 'Z2'
    },
    Line_1: {
        extends: 'SkeletonRow',
        width: '100%'
    },
    Line_2: {
        extends: 'SkeletonRow',
        width: '80%'
    }
};

});

parcelRegister("lXaM8", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $ffb7776a566695a7$export$b08b517936747730);
// Spinner — the busy indicator (DESIGN_LANGUAGE.md §9). The language had NO
// spinner primitive at all; 40 surfaces flashed ad-hoc "Loading…" strings
// instead. Two legal uses only:
//   1. inside a control while its action is in flight (label swaps to this,
//      inside a minWidth floor so the control never resizes — Rule 66)
//   2. a true indeterminate full-surface operation (canvas stage)
// Content-shaped loads use Skeleton, never this.
//
// Ring draws in `line` with a `currentColor` head, so it inherits whatever
// ink its surface carries (correct on both themes and on hued surfaces).
// Sized via the fixed-px icon tokens; `size` prop picks the token.
const $ffb7776a566695a7$export$b08b517936747730 = {
    display: 'inline-block',
    boxSize: 'iconMd',
    flexShrink: '0',
    round: '50%',
    borderWidth: 'hairline2',
    borderStyle: 'solid',
    borderColor: 'line',
    borderTopColor: 'currentColor',
    animation: 'rotate 0.8s linear infinite',
    role: 'status',
    // FUNCTION form: it switches on every engine (a template on an attribute
    // needs element ≥ 3.14.788, I18N-CONVENTION §1.1), and the literal read
    // `Loading` to a Georgian screen reader on every busy surface (live walk
    // 2026-09-22).
    'aria-label': (el)=>el.call('polyglot', 'common.state.loading')
};

});

parcelRegister("ZviK2", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $0b8dfa671105f8e0$export$c17561cb55d4db30);
// ProgressBar — the determinate progress primitive (DESIGN_LANGUAGE.md §9).
// Pass `value` as 0..1. Track is the `overlay` wash; fill is ink (`title`),
// pill-rounded. The width transition is the language's one sanctioned
// layout animation — a determinate indicator must resize to mean anything.
//
//   Uploading: { extends: 'ProgressBar', value: (el, s) => s.uploadProgress }
//
// `warnAt` / `dangerAt` (0..1, optional) — a limit-style consumer (a
// balance approaching its cap) should "change character as it approaches
// the limit" (DESIGN_LANGUAGE §4.2 status roles), not stay ink until a
// bare 100%. When set, the fill steps ink → `yellow` → `red` as `value`
// crosses each threshold. Unset by default so every existing consumer
// (plain upload/determinate progress) keeps its current plain-ink fill —
// additive only, per the D5 change-set convention.
//
//   CreditsUsed: { extends: 'ProgressBar', value: 0.92, warnAt: 0.7, dangerAt: 0.9 }
const $0b8dfa671105f8e0$export$c17561cb55d4db30 = {
    width: '100%',
    height: 'X',
    round: 'radiusPill',
    background: 'overlay',
    overflow: 'hidden',
    value: 0,
    warnAt: null,
    dangerAt: null,
    role: 'progressbar',
    'aria-valuemin': '0',
    'aria-valuemax': '100',
    'aria-valuenow': (el)=>String(Math.round(Math.min(1, Math.max(0, el.value || 0)) * 100)),
    Fill: {
        height: '100%',
        round: 'radiusPill',
        background: (el)=>{
            const parent = el.parent;
            const v = Math.min(1, Math.max(0, parent?.value || 0));
            if (parent?.dangerAt != null && v >= parent.dangerAt) return 'red';
            if (parent?.warnAt != null && v >= parent.warnAt) return 'yellow';
            return 'title';
        },
        transition: 'width B defaultBezier, background A defaultBezier',
        width: (el)=>`${Math.min(100, Math.max(0, (el.parent?.value || 0) * 100))}%`
    }
};

});

parcelRegister("crhkn", function(module, exports) {

$parcel$export(module.exports, "PageBarTitle", () => $90e5728c81719ce1$export$b71d8ec2f21a953);
$parcel$export(module.exports, "PageBarMeta", () => $90e5728c81719ce1$export$3a47d6f50bd1ee6e);
$parcel$export(module.exports, "PageBarBtn", () => $90e5728c81719ce1$export$74d5289a5bf0ab41);
$parcel$export(module.exports, "PageBar", () => $90e5728c81719ce1$export$aa2f1e927b091bd6);
// PageBar — the in-page title-bar archetype (DESIGN_LANGUAGE.md §7.2).
// ONE chassis for every page/pane header in the product; per-app headers
// (DocsHeader, CalHeader, TicketsHeader, AnalyticsHeader, ChatPaneHeader…)
// become configurations of this, not components. The contract comes from
// the 2026-08-06 chat pane-header convergence, generalized:
//
// - geometry: padding 'Z A', minHeight 'D', root gap 'A', side-group gap 'Z1'
// - BORDERLESS: no hairline underline — headers separate by whitespace and
//   fill contrast (§2.5); the PageHeader hairline is retired with migration
// - title = PageBarTitle ('A' / 700, ellipsis) · meta = PageBarMeta ('Y2'
//   caption, ellipsis) · icon actions = PageBarBtn (fixed B1 box, quiet
//   until the house `hover` wash)
//
// Slots: fill `Left` (back affordance + title + meta), `Center` (tabs /
// segmented nav — absent by default), `Right` (actions rail). Self-contained
// on purpose: unlike ChatPaneHeader (which extends the workspace shell's
// PageHeader and therefore only resolves in-shell), PageBar carries its own
// chassis so standalone apps (marketplace, preview) get the same bar.
const $90e5728c81719ce1$export$b71d8ec2f21a953 = {
    tag: 'h2',
    margin: '0',
    fontSize: 'A',
    fontWeight: '700',
    color: 'title',
    minWidth: '0',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
const $90e5728c81719ce1$export$3a47d6f50bd1ee6e = {
    tag: 'span',
    fontSize: 'Y2',
    color: 'caption',
    minWidth: '0',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
const $90e5728c81719ce1$export$74d5289a5bf0ab41 = {
    extends: 'IconButton',
    boxSize: 'B1',
    alignSelf: 'center',
    flexShrink: '0',
    round: 'radiusPill',
    background: 'transparent',
    color: 'caption',
    ':hover': {
        background: 'hover',
        color: 'title'
    }
};
const $90e5728c81719ce1$export$aa2f1e927b091bd6 = {
    tag: 'header',
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    minHeight: 'D',
    padding: 'Z A',
    width: '100%',
    boxSizing: 'border-box',
    Left: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        minWidth: '0',
        flex: '1'
    },
    Right: {
        flow: 'x',
        align: 'center right',
        gap: 'Z1',
        flexShrink: '0'
    }
};

});

parcelRegister("4VxOT", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $3966b837fc86b0bf$export$c1ed4f415b9e7023);
// Generic error / access-denied state for pages that fail to load or
// gate the user. Distinct from EmptyState (which is "no data yet") —
// this is for "something is wrong" or "you don't have permission."
//
// Usage:
//   PageBody: {
//     ErrorState: {
//       kind: 'forbidden',          // 'forbidden' | 'notFound' | 'serverError' | 'offline'
//       heading: 'admin.pages.noAccess.heading',
//       hintText: 'admin.pages.noAccess.hint',
//       action: { text: 'common.action.back', onClick: ... }
//     }
//   }
//
// `kind` selects the icon + default copy; `heading` / `hintText` / `action`
// override individual fields.
//
// TRANSLATION — docs/I18N-CONVENTION.md §1.2. `title` is a global HTML
// attribute, so neither rewrite form works on it when a child reads it as
// CONTENT: a `{{ … | polyglot }}` template resolves to '' in the static
// attribute pass and is written back over the prop, and a function value is
// dropped by the child's text effect. The fix is a RENAME, so `heading` /
// `hintText` are the props to pass now; `title` / `hint` stay as the
// back-compat fallback for the canvas and workspace call sites. Every path is
// resolved through polyglot at the render site, so a call site may pass a
// bundle KEY or a plain string — polyglot returns a non-key verbatim.
const $3966b837fc86b0bf$export$c1ed4f415b9e7023 = {
    // FA204 / frank trap — kindDefaults + resolve used to be bare module-scope
    // const/function read from inside the Icon/Title/Hint `text`/`icon`
    // factories; they read as undefined once this component is frank.toJSON'd
    // for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called via
    // `el.scope.resolve` (which reads its sibling `el.scope.kindDefaults` via
    // `this.kindDefaults` — object-literal properties can't see each other as
    // bare identifiers).
    scope: {
        kindDefaults: {
            forbidden: {
                icon: 'lock',
                heading: 'shell.errorState.forbidden.heading',
                hintText: 'shell.errorState.forbidden.hint'
            },
            notFound: {
                icon: 'search',
                heading: 'shell.errorState.notFound.heading',
                hintText: 'shell.errorState.notFound.hint'
            },
            serverError: {
                icon: 'warning',
                heading: 'shell.errorState.serverError.heading',
                hintText: 'shell.errorState.serverError.hint'
            },
            offline: {
                icon: 'network',
                heading: 'shell.errorState.offline.heading',
                hintText: 'shell.errorState.offline.hint'
            },
            generic: {
                icon: 'warning',
                heading: 'shell.errorState.generic.heading',
                hintText: 'shell.errorState.generic.hint'
            }
        },
        // `key` is the CANONICAL prop name ('icon' | 'heading' | 'hintText'). The
        // legacy alias is checked first on the element so an un-migrated call site
        // still wins over the default, exactly as it did before the rename.
        resolve (el, key) {
            const defaults = this.kindDefaults[el.kind || 'generic'] || this.kindDefaults.generic;
            const legacy = {
                heading: 'title',
                hintText: 'hint'
            }[key];
            if (el[key] != null) return el[key];
            if (legacy && el[legacy] != null) return el[legacy];
            return defaults[key];
        }
    },
    flow: 'y',
    align: 'center center',
    gap: 'A',
    padding: 'C A',
    width: '100%',
    textAlign: 'center',
    // Live region so screen readers announce the error when the page
    // swaps in. role=alert for high priority.
    // Flat attributes (FA105) — `attr: {}` is never needed for a prop the
    // framework already promotes.
    role: 'alert',
    'aria-live': 'assertive',
    // Default props — consumers override.
    kind: 'generic',
    heading: null,
    hintText: null,
    title: null,
    hint: null,
    action: null,
    IconWrap: {
        flow: 'y',
        align: 'center center',
        width: 'C',
        height: 'C',
        round: '50%',
        background: 'overlay',
        color: 'red',
        Icon: {
            icon: (el)=>el.scope.resolve(el.parent.parent, 'icon'),
            boxSize: 'A1'
        }
    },
    Title: {
        tag: 'h2',
        fontSize: 'A2',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el)=>el.call('polyglot', el.scope.resolve(el.parent, 'heading'))
    },
    Hint: {
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        margin: '0',
        maxWidth: 'J',
        text: (el)=>el.call('polyglot', el.scope.resolve(el.parent, 'hintText'))
    },
    ActionBtn: {
        if: (el)=>!!el.parent?.action,
        tag: 'button',
        type: 'button',
        minHeight: 'controlH',
        padding: '0 A',
        round: 'radiusPill',
        // A fixed brand-hue plate (no `theme:`), so the ink is fixed too — and it is
        // the brand `fillInk` (near-black), not white. White on a raw brand hue read
        // under the 4.5:1 floor in BOTH themes (blue 3.62, red 3.21, green 2.81);
        // near-black reads 5.66 / 6.39 / 7.28. Nika's decision 2026-09-21
        // (treatment 3, design-direction.md §6).
        background: 'blue',
        color: 'fillInk',
        fontSize: 'Z2',
        fontWeight: '700',
        border: 'none',
        cursor: 'pointer',
        marginTop: 'V',
        text: (el)=>el.call('polyglot', el.parent?.action?.text || ''),
        onClick: (e, el, s)=>{
            const action = el.parent?.action;
            if (typeof action?.onClick === 'function') action.onClick(e, el, s);
        }
    }
};

});

parcelRegister("8VqFn", function(module, exports) {

$parcel$export(module.exports, "AiMenuPanel", () => $67f854fc56b2f40c$export$1b51bfd36a0133c3);
$parcel$export(module.exports, "AiMenuHeading", () => $67f854fc56b2f40c$export$f23b41ff45655cf3);
$parcel$export(module.exports, "AiOptionRow", () => $67f854fc56b2f40c$export$dbee8fccf4fd6757);
// AiMenu — THE one dropdown/menu system for the two Symbols AI surfaces
// (the canvas prompt composer's ModelBtn/ParamsBtn dropdowns and the
// assistant drawer's Sessions / model / settings / mention panels), extracted
// 2026-08-12 per Nika "improve and redesign all dropdowns in
// CanvasPromptTextarea and AISidebar — make design exceptionally good".
//
// Three registered pieces, one language:
//
//   • AiMenuPanel   — the panel surface + motion. `canvas-card-glass` (the
//     house dropdown surface — shared/functions openDropdown defaults every
//     plugin panel to it, so inline panels MUST match), radiusCard,
//     borderless (the glass theme paints a 1px hairline; fill contrast is
//     the separation device — design-direction.md §8), padding Z, minWidth
//     G, 60vh cap with internal scroll. NO shadow prop: the glass theme
//     carries the single budget shadow itself (brand shadow budget = 1).
//     Motion is the brand `Dropdown` recipe — hidden base (opacity 0 /
//     visibility hidden / a Y lift) + a `.isOpen` conditional block tweened
//     by `A defaultBezier` (~150ms). CONSUMERS declare the `isOpen`
//     predicate + their own positioning; the recipe re-fires reliably since
//     smbls bf7d72268 (registerConditionalEffects). `visibility` keeps the
//     closed panel out of the tab order and rides transitionProperty so it
//     holds until the fade-out ends. prefers-reduced-motion is enforced
//     globally by the brand reset — never re-implemented here.
//
//   • AiMenuHeading — the section caption: Y2 / 700 / caption ink /
//     uppercase / .08em, inset to the option rows' Z1 text edge (the
//     AiSettingsPanel sectionHeader pattern, now THE one heading).
//
//   • AiOptionRow   — the option row: MenuPanelItem metrics (Y/Z1 padding,
//     radiusControl, borderless, 44pt coarse-pointer floor) + leading icon
//     slot + Label/Sub body + right-aligned meta + trailing check. Selected
//     = the house `selected` wash + `title` ink — monochrome, never a hue
//     fill. Disabled rows stay real click targets (dim wash + `title`
//     tooltip + blocked onClick) and Sub keeps its one-line slot so a
//     demoted row never grows and shifts its neighbours.
//
// Per-row state contract (childrenAs: 'state'):
//   { key, label, sub, active?, disabled?, icon?, meta? }
// `onClick` comes from the consumer (AiModelSwitcherRow persists the model
// mode; AiSettingsPanel's sections dispatch their own choose* helpers).
//
// NO `transition` on the reactive background anywhere in this file — the
// runtime re-applies reactive backgrounds per tick, perpetually restarting
// the transition, which makes hover appear dead (MenuPanel.js note +
// tickets/smbls.md).
const $67f854fc56b2f40c$export$1b51bfd36a0133c3 = {
    flow: 'y',
    minWidth: 'G',
    maxWidth: '90vw',
    maxHeight: '60dvh',
    overflow: 'auto',
    // Don't chain the panel's edge-bounce to the surface behind it.
    overscrollBehavior: 'contain',
    padding: 'Z',
    round: 'radiusCard',
    theme: 'canvas-card-glass',
    // The glass theme paints a 1px border; menus separate by fill contrast
    // alone. Longhand borderWidth (not `border: 'none'`) — the theme emits
    // longhands, so only a longhand zero wins (CanvasPromptTextarea note).
    borderWidth: '0',
    // Menus are overlay-level chrome (MenuPanel, the house recipe, carries
    // the same token). Needed because the glass theme's OWN light-half
    // shadow (`black.01`) computes to `none` live (measured 2026-08-13 —
    // ticketed, brand is read-only), so a light-theme panel over an empty
    // white ground had NO separation at all. One box-shadow value renders
    // either way — the elevation budget stays 1.
    shadow: 'overlay',
    boxSizing: 'border-box',
    textAlign: 'left',
    // Hidden base — the consumer's `isOpen` predicate flips the block below.
    // The lift reads `var(--spacing-Y)` (~6.5px): `transform` is a raw
    // passthrough in css-in-props, so a bare token inside translate3d() would
    // reach the browser verbatim and be dropped as invalid.
    opacity: '0',
    visibility: 'hidden',
    transform: 'translate3d(0, calc(-1 * var(--spacing-Y)), 0)',
    transition: 'A defaultBezier',
    transitionProperty: 'opacity, transform, visibility',
    '.isOpen': {
        opacity: '1',
        visibility: 'visible',
        transform: 'translate3d(0, 0, 0)'
    },
    '@mobileL': {
        minWidth: '0',
        maxWidth: 'calc(100dvw - var(--spacing-B))'
    }
};
const $67f854fc56b2f40c$export$f23b41ff45655cf3 = {
    extends: 'AppMicroLabel',
    display: 'block',
    lineHeight: '1',
    // Align to the option rows' text edge. Spacing tokens are em-relative:
    // the rows inset Z1 at their Z1 font, so the caption's own inset is the
    // nearest on-scale step at ITS font (the exact px does not exist on the em
    // scale without a raw value).
    paddingLeft: 'Z2'
};
const $67f854fc56b2f40c$export$dbee8fccf4fd6757 = {
    tag: 'button',
    type: 'button',
    // Keyboard/AT contract (2026-09-02) — `menuitem` is the marker every menu
    // panel in this system walks with `menuArrowNav`
    // (shared/functions/menuKeyboard.js), the SAME marker ContextDropdown's own
    // rows carry. Deliberately NO `tabindex: -1` roving here: this exact row is
    // also mounted inside the AI SETTINGS panel, a large drawer/dropdown body
    // where Tab is the primary way through the sections — taking the rows out
    // of the tab order there would trade one keyboard gap for a worse one. The
    // arrow cycle is therefore ADDITIVE to native tabbing, and a native
    // <button> already activates on Enter AND Space with no extra handler.
    role: 'menuitem',
    ariaDisabled: (el, s)=>s?.disabled ? 'true' : null,
    width: '100%',
    flow: 'x',
    align: 'center',
    gap: 'A',
    // MenuPanelItem metrics, restated (not extended) so the disabled-aware
    // reactive `:hover` below is the row's ONLY hover rule — a base-class
    // static hover would race it on disabled rows.
    padding: 'Y Z1',
    round: 'radiusControl',
    fontSize: 'Z1',
    textAlign: 'left',
    borderWidth: '0',
    color: 'title',
    whiteSpace: 'normal',
    // 44pt touch floor on coarse pointers (Apple HIG) — same as MenuPanelItem.
    '@coarse': {
        minHeight: 'controlH'
    },
    // A disabled row carries no opacity (DESIGN_SPEC §8.1: an inert control
    // steps its INK to `inactive`, it never fades) — the label below does.
    cursor: (el, s)=>s.disabled ? 'not-allowed' : 'pointer',
    // A disabled row's reason stays reachable via the native tooltip.
    title: (el, s)=>s.disabled ? s.sub : '',
    background: (el, s)=>s.active ? 'selected' : 'transparent',
    ':hover': {
        background: (el, s)=>s.disabled ? 'transparent' : 'hover'
    },
    // Leading icon — renders only when the row's state names a glyph.
    // (Key-based auto-extend: `Icon` extends the Icon built-in — FA806.)
    Icon: {
        if: (el, s)=>!!s.icon,
        name: (el, s)=>s.icon,
        boxSize: 'A',
        color: (el, s)=>s.disabled ? 'inactive' : 'title',
        flexShrink: '0'
    },
    Body: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        lineHeight: '1.3',
        // Every row feed in this house carries a polyglot KEY in `label`/`sub`
        // (AUTH_ROWS, VOICE_ROWS, the pin rows, the scope segments). `translate`
        // returns its input unchanged when a key does not resolve, so a model
        // name or any tenant string still passes through untouched. Resolving
        // HERE — at the one shared row — is what keeps every AI menu from
        // printing raw dotted keys on screen.
        // Labels are 500 (the weight law); an inert row's label steps to
        // `inactive`.
        Label: {
            tag: 'span',
            fontWeight: '500',
            color: (el, s)=>s.disabled ? 'inactive' : 'title',
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        Sub: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            lineHeight: '1.4',
            text: (el, s)=>el.call('polyglot', s.sub || '')
        }
    },
    // Right-aligned meta (kbd hint / sub-label) — renders only when provided.
    Meta: {
        if: (el, s)=>!!s.meta,
        tag: 'span',
        fontSize: 'Y',
        color: 'caption',
        flexShrink: '0',
        text: (el, s)=>el.call('polyglot', s.meta || '')
    },
    // Trailing checkmark — the active row's second cue beside the wash.
    // (`Icon_1` auto-extends the Icon built-in; the `_1` suffix is ignored
    // for extend resolution — FA806.)
    Icon_1: {
        name: 'checkmark',
        boxSize: 'Z',
        color: 'title',
        flexShrink: '0',
        hide: (el, s)=>!s.active
    }
};

});

parcelRegister("grZn4", function(module, exports) {

$parcel$export(module.exports, "AiPickerRow", () => $bf9ec60089b260f3$export$dce918ef229a8b9);

var $kANrO = parcelRequire("kANrO");
const $bf9ec60089b260f3$export$dce918ef229a8b9 = {
    extends: 'MenuPanelItem',
    flow: 'x',
    gap: 'A',
    // A touch more vertical room than the one-line MenuPanelItem so the
    // label + sub two-liner breathes; horizontal padding matches the house row.
    padding: 'X2 Z',
    // MenuPanelItem is nowrap (single-line menu items); the sub-line here can
    // wrap on a narrow panel, so allow normal wrapping.
    whiteSpace: 'normal',
    // Active row — the HOUSE selected wash. Same base grays as the `overlay`
    // design-system token (dark `gray14` / light `gray2`), a step stronger in
    // alpha than the inherited MenuPanelItem :hover — i.e. the CanvasViewNav
    // active level (~10% wash), NOT `overlayStrong` (near-opaque, too heavy for
    // a row). Driven by a reactive `isActive` predicate → toggles the
    // `.isActive` class, the reliably-reactive path (plain style factories
    // freeze at mount). The trailing green check stays as a secondary,
    // belt-and-suspenders cue.
    isActive: (el, s)=>!!s.active,
    // The active row already stays visibly selected on hover WITHOUT a compound
    // `.isActive:hover`: a case block applies its flat props as INLINE styles, and
    // `@light` sub-blocks compile to `[data-theme="light"] &` with `!important` —
    // both outrank MenuPanelItem's plain `:hover` class rule. An extra nested
    // `':hover'` here was therefore unreachable in both themes, and its own
    // `@light` child compiled to the non-matching selector `._cls:hover @light`
    // (the `[data-theme]` transform only applies at the first nesting level), so
    // it emitted invalid CSS for nothing. Dropped.
    '.isActive': {
        background: 'gray14.1',
        '@light': {
            background: 'gray2.06'
        }
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        const ai = (0, $kANrO.getAiService)();
        if (!ai) return;
        try {
            if (s.authMode) ai.setAuthMode(s.key);
            else ai.setMode(s.key);
            // Bump a tick so the picker's children: factories re-evaluate and the
            // active wash/check move to the newly-active row. Without this the
            // dropdown stays on its initial render until closed and reopened.
            const root = el.state?.root;
            if (root?.update) {
                const next = (root._aiModePickerTick || 0) + 1;
                root.update({
                    _aiModePickerTick: next
                });
            }
        } catch (err) {
            console.warn('[AiPickerRow] mode change failed:', err?.message || err);
        }
    },
    // Leading brand Icon — the per-option visual anchor. Muted (`caption`) by
    // default, brightening to `title` on the active row via its own `.isActive`
    // block (mirrors CanvasViewNav's active child icon). `color` drives the
    // glyph fill through the Icon's `currentColor`.
    // `if:` — this slot had NO gate at all, so an option that names no glyph
    // painted a VISIBLE `noIcon` placeholder and warned
    // `[Icon] Unknown icon name "Icon"` (the built-in falls through to the
    // element KEY when `name`/`icon` answers undefined). Every feed shipping
    // today carries an icon, so nothing changes on screen now; the gate is what
    // keeps the next feed honest. Same recipe as AiMenu's AiOptionRow and
    // ContextDropdownItem.
    Icon: {
        if: (el, s)=>!!s?.icon,
        name: (el, s)=>s.icon,
        boxSize: 'Z1',
        color: 'caption',
        flexShrink: '0',
        isActive: (el, s)=>!!s.active,
        '.isActive': {
            color: 'title'
        }
    },
    Body: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        // Pin a tight line-height — the panel/theme otherwise inherits a loose
        // ~27px line-height that made every row tall and label/sub float apart.
        lineHeight: '1.3',
        Label: {
            tag: 'span',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        Sub: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            lineHeight: '1.4',
            text: (el, s)=>el.call('polyglot', s.sub || '')
        }
    },
    // Trailing checkmark — a second `Icon` instance via key-based auto-extend
    // (the `_1` suffix is ignored for extend resolution, so no `extends: 'Icon'`
    // needed). Declared AFTER Body, which takes flex:1 and pushes it to the
    // right edge, so every label stays left-aligned regardless of active state;
    // the glyph shows only on the active row.
    Icon_1: {
        name: 'checkmark',
        boxSize: 'Z',
        color: 'green',
        flexShrink: '0',
        hide: (el, s)=>!s.active
    }
};

});
parcelRegister("kANrO", function(module, exports) {

$parcel$export(module.exports, "resolveAiService", () => $efdd86b9c5236e41$export$d66d3dd2a43771ef);
$parcel$export(module.exports, "getAiService", () => $efdd86b9c5236e41$export$63bdf8076b3bf880);
$parcel$export(module.exports, "_clearAiServiceCache", () => $efdd86b9c5236e41$export$28dcdfa48261263d);
// Module-level cache for the SDK's AiService instance.
//
// The SDK exposes services through getService(name) which is wrapped in
// an async init-await Proxy (see ../governanceBridge.js → sdk.js
// wrapWithInitAwait), so synchronous DOMQL factories (the ParamsBtn
// picker, AppAssistant message rendering, ticket AI surfaces) can't
// touch it directly.
//
// Storing the resolved instance on root state breaks too: smbls' deep
// state clone strips the class prototype, leaving plain own properties
// behind — `_aiSvc.getMode()` then throws "not a function". A module
// singleton bypasses both problems: callers grab the live class
// instance synchronously through `getAiService()` once it's been
// resolved at shell boot.
//
// Boot path (workspace/app.js shellApp.onCreate):
//   import { resolveAiService } from '@symbo-ls/workspace-shared/functions/aiService.js'
//   resolveAiService(el.sdk)
//
// Consumer path (anywhere):
//   import { getAiService } from '…/aiService.js'
//   const ai = getAiService()
//   if (ai) ai.dispatch(...)
//
// `bumpTick(root)` exists so picker UIs can nudge a state-level signal
// after changing mode — DOMQL factories that read sdk.ai.getMode() can
// then re-evaluate. Without a state-side hook the dropdown would render
// stale until reopened.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
function $efdd86b9c5236e41$export$d66d3dd2a43771ef(sdk) {
    const state = globalThis.__aiServiceState = globalThis.__aiServiceState || {
        aiSvc: null,
        resolvePromise: null
    };
    if (state.aiSvc) return Promise.resolve(state.aiSvc);
    if (state.resolvePromise) return state.resolvePromise;
    const real = sdk || (0, $1NxyO.getSDK)();
    if (!real) return Promise.reject(new Error('[aiService] no SDK'));
    state.resolvePromise = Promise.resolve(real.getService('ai')).then((svc)=>{
        state.aiSvc = svc;
        return svc;
    }).catch((err)=>{
        state.resolvePromise = null;
        throw err;
    });
    return state.resolvePromise;
}
function $efdd86b9c5236e41$export$63bdf8076b3bf880() {
    return globalThis.__aiServiceState ? globalThis.__aiServiceState.aiSvc : null;
}
function $efdd86b9c5236e41$export$28dcdfa48261263d() {
    globalThis.__aiServiceState = {
        aiSvc: null,
        resolvePromise: null
    };
}

});


parcelRegister("3erwy", function(module, exports) {

$parcel$export(module.exports, "AiActionConfirmCard", () => $25a8079d3ae9b0eb$export$6b8824bcd53b700f);
$parcel$export(module.exports, "AiActionRow", () => $25a8079d3ae9b0eb$export$958d80f02fbe95bb);

var $kANrO = parcelRequire("kANrO");
const $25a8079d3ae9b0eb$export$6b8824bcd53b700f = {
    hide: (el, s)=>!s.root?._aiActionProposals?.length,
    // Open/closed through the kit's AppDialog lifecycle (DESIGN_SPEC §6.6): the
    // same reactive side effect AppDialog runs from its `isOpen` — focus moves
    // in when proposals arrive (the first control, Reject: the safe one) and
    // goes back to the opener when they clear. `dataOpen` is the reader that
    // keeps the effect running.
    isOpen: (el, s)=>{
        const open = !!s.root?._aiActionProposals?.length;
        el.call('appDialogSync', open);
        return open;
    },
    dataOpen: (el)=>!!el.isOpen,
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    // The Modal.js layer (DESIGN_SPEC §6.8: PageSlot 1300 < DropdownRoot 1500 <
    // Modal 2000): a confirmation the composer raises must cover the open
    // window and the header. At z 95 it opened UNDER a PageSlot window and left
    // the header undimmed (live on dev 2026-09-26).
    zIndex: '2000',
    // THE blocking veil (DESIGN_SPEC §6.3): the `backdrop` theme — the scrim
    // fill and its 8px blur — fading in each time the card opens (a `hide:`
    // flip restarts the keyframe). It was the scrim + a raw `blur(6px)`.
    theme: 'backdrop',
    animationName: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'both',
    align: 'center center',
    padding: 'overlayGutter',
    // The phone sheet touches the bottom edge.
    '@mobileL': {
        padding: '0',
        alignItems: 'flex-end'
    },
    onClick: (e, el, s)=>{
        // Backdrop click dismisses (same as Reject). Inner Card stops
        // propagation so its own clicks don't bubble here.
        if (e.target === el.node) s.root?.update?.({
            _aiActionProposals: null,
            _aiActionError: null
        });
    },
    // Escape = Reject, and it stops here (the top-most overlay only).
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        s.root?.update?.({
            _aiActionProposals: null,
            _aiActionError: null
        });
    },
    // The centre sheet (§6.1) at `overlayMd`, capped by the veil's inset box,
    // rising on the spring; the phone gets the bottom sheet. The chassis
    // (`document` + `radiusSheet` + `overlay`) is the elevated-alert family's
    // signature — kept (notificationFamilyChrome.test.js).
    Card: {
        position: 'relative',
        boxSizing: 'border-box',
        width: 'overlayMd',
        maxWidth: '100%',
        maxHeight: '100%',
        background: 'document',
        round: 'radiusSheet',
        shadow: 'overlay',
        overflow: 'hidden',
        flow: 'y',
        animationName: 'modalIn',
        animationDuration: 'D',
        animationTimingFunction: 'springBezier',
        animationFillMode: 'both',
        '@mobileL': {
            width: '100%',
            maxHeight: '92%',
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
            animationName: 'fadeInUpShort'
        },
        role: 'dialog',
        ariaModal: 'true',
        ariaLabelledby: 'aiActionConfirmTitle',
        tabindex: '-1',
        onKeydown: (e, el)=>el.call('appDialogTrapTab', e),
        onClick: (e)=>e.stopPropagation(),
        Header: {
            flow: 'y',
            gap: 'V',
            padding: 'A B',
            // Was a `borderBottom` divider (the border habit) — Header/Body/Footer
            // already read as distinct zones via padding + typographic hierarchy
            // (bold H3 title vs. the row list vs. the button row), matching the
            // UserProfile precedent in this same sweep (design-direction.md §8).
            Title: {
                tag: 'h3',
                id: 'aiActionConfirmTitle',
                margin: '0',
                fontSize: 'B',
                fontWeight: '700',
                color: 'title',
                text: '{{ ai.confirm.title | polyglot }}'
            },
            Sub: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>{
                    const n = s.root?._aiActionProposals?.length || 0;
                    return n === 1 ? 'Review the proposed change and confirm to apply.' : `Review the ${n} proposed changes and confirm to apply.`;
                }
            }
        },
        // Per-action row list. childrenAs:'state' so each row gets the
        // ProposedAction shape as its state. The row reads s.kind + s.summary
        // to render.
        Body: {
            flow: 'y',
            gap: 'V',
            padding: 'A B',
            maxHeight: '50dvh',
            overflow: 'auto',
            childExtends: 'AiActionRow',
            childrenAs: 'state',
            children: (el, s)=>s.root?._aiActionProposals || []
        },
        // Error banner — shown when executeActions throws. The proposals
        // stay rendered so the user can retry the same set.
        ErrorBanner: {
            hide: (el, s)=>!s.root?._aiActionError,
            role: 'alert',
            padding: 'V A',
            background: 'red.1',
            // The AA-safe danger pair — the raw brand `red` reads under 4.5:1 as
            // text on its own tint.
            color: 'dangerInk',
            fontSize: 'Z2',
            text: (el, s)=>`Couldn't apply: ${s.root?._aiActionError || ''}`
        },
        Footer: {
            flow: 'x',
            gap: 'A',
            padding: 'A B',
            align: 'center flex-end',
            // Was a `borderTop` divider — see the Header comment above.
            // The kit footer (DESIGN_SPEC §6.9): Reject = the ghost capsule, Confirm
            // = the ink primary with the house floor ("Confirm" → "Applying…").
            // Was a hand-built ghost and a raw `blue` plate.
            RejectBtn: {
                extends: 'AppCapsuleBtnGhost',
                disabled: (el, s)=>!!s.root?._aiActionRunning,
                text: '{{ ai.confirm.reject | polyglot }}',
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    s.root?.update?.({
                        _aiActionProposals: null,
                        _aiActionError: null
                    });
                }
            },
            ConfirmBtn: {
                extends: 'AppCapsuleBtnPrimary',
                minWidth: 'E',
                disabled: (el, s)=>!!s.root?._aiActionRunning,
                text: (el, s)=>s.root?._aiActionRunning ? "Applying\u2026" : 'Confirm',
                onClick: async (e, el, s)=>{
                    e.preventDefault();
                    const root = s.root;
                    const actions = root?._aiActionProposals;
                    if (!Array.isArray(actions) || !actions.length) return;
                    const ai = (0, $kANrO.getAiService)();
                    if (!ai) {
                        root?.update?.({
                            _aiActionError: 'AI service not ready'
                        });
                        return;
                    }
                    root?.update?.({
                        _aiActionRunning: true,
                        _aiActionError: null
                    });
                    try {
                        const results = await ai.executeActions(actions);
                        const failed = results.find((r)=>r?.error);
                        if (failed) {
                            root?.update?.({
                                _aiActionRunning: false,
                                _aiActionError: failed.error?.message || String(failed.error)
                            });
                            return;
                        }
                        root?.update?.({
                            _aiActionRunning: false,
                            _aiActionProposals: null,
                            _aiActionResults: results,
                            _aiActionError: null
                        });
                    } catch (err) {
                        root?.update?.({
                            _aiActionRunning: false,
                            _aiActionError: err?.message || String(err)
                        });
                    }
                }
            }
        }
    }
};
const $25a8079d3ae9b0eb$export$958d80f02fbe95bb = {
    // FA204 / frank trap — the kind→{icon,color,label} lookup + its resolver
    // live in `scope`, not module scope: a bare module-scope const/function
    // silently reads as undefined once the component is frank.toJSON'd for
    // platform delivery (workspace d6ea1142, project_frank_drops_module_local_helpers).
    scope: {
        kindMeta: (kind)=>{
            const KIND_META = {
                'ticket.create': {
                    icon: 'check',
                    color: 'orange',
                    label: 'ai.confirm.kind.ticketCreate'
                },
                'ticket.update': {
                    icon: 'check',
                    color: 'orange',
                    label: 'ai.confirm.kind.ticketUpdate'
                },
                'ticket.move': {
                    icon: 'arrowRight',
                    color: 'orange',
                    label: 'ai.confirm.kind.ticketMove'
                },
                'event.create': {
                    icon: 'date outline',
                    color: 'blue',
                    label: 'ai.confirm.kind.eventCreate'
                },
                'note.create': {
                    icon: 'document',
                    color: 'green',
                    label: 'ai.confirm.kind.noteCreate'
                },
                'doc.create': {
                    icon: 'document',
                    color: 'cerulean',
                    label: 'ai.confirm.kind.docCreate'
                },
                'kb.create': {
                    icon: 'document',
                    color: 'cerulean',
                    label: 'ai.confirm.kind.kbCreate'
                }
            };
            return KIND_META[kind] || {
                icon: 'star',
                color: 'gray',
                label: kind || 'Action'
            };
        }
    },
    // Straight on the sheet (DESIGN_SPEC §6.2) — no `overlay` box per row.
    flow: 'x',
    gap: 'A',
    align: 'center',
    padding: 'V 0',
    IconTile: {
        width: 'C',
        height: 'C',
        minWidth: 'C',
        round: 'radiusControl',
        align: 'center center',
        background: (el, s)=>el.scope.kindMeta(s.kind).color + '.2',
        color: (el, s)=>el.scope.kindMeta(s.kind).color,
        Icon: {
            icon: (el, s)=>el.scope.kindMeta(s.kind).icon,
            boxSize: 'A'
        }
    },
    Body: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Summary: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.summary || el.call('polyglot', el.scope.kindMeta(s.kind).label)
        },
        Kind: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', el.scope.kindMeta(s.kind).label)
        }
    }
};

});

parcelRegister("i3LgR", function(module, exports) {

$parcel$export(module.exports, "AiModePicker", () => $d25d2cd370ea2b8c$export$f945866d8b92e186);
$parcel$export(module.exports, "AiModePickerBody", () => $d25d2cd370ea2b8c$export$cbb9785a67237326);

var $kANrO = parcelRequire("kANrO");
// AiModePicker — shell-mounted dropdown that lets the user pick the AI provider
// (Symbols Cloud / Org providers / Local agent) and the authorization mode (Ask
// permissions / Auto).
//
// Lives at the shell root (not inside CanvasPromptTextarea's ParamsBtn) so the
// picker's `position: fixed` lands in true viewport coordinates — anchoring
// inside the prompt textarea breaks because that parent has
// `transform: translateX(-50%)` which captures fixed-positioned descendants as
// its containing block.
//
// State contract:
//   _aiModePickerOpen   : boolean — visibility
//   _aiModePickerAnchor : { right, bottom } in px from the viewport's
//                         right/bottom edges, captured by ParamsBtn's onClick
//                         from el.node.getBoundingClientRect.
//   _aiModePickerTick   : integer — bumped by AiPickerRow.onClick so the
//                         children: factories re-evaluate and the active
//                         wash/check move immediately.
//   _aiSvcReady         : boolean — true once sdk.ai resolves at boot; picker
//                         children: factories gate on it.
//
// AiModePicker and AiModePickerBody share ONE set of section builders below
// (providerSection / authSection) so the two never drift — the option data,
// icons, headers and row wiring live in a single place.
// Uppercase caption header. Pins a single tight line (`lineHeight: '1'` + a
// small X2 bottom margin) — the span otherwise inherits the panel's loose
// typography (a ~59px box + 25px margin) which opened a big empty gap under
// each header. Returns a FRESH object per call so the two exports never share
// (and mutate) one node.
// The caption is the kit's mono micro-label (every section head in the
// redesign).
const $d25d2cd370ea2b8c$var$sectionHeader = (key)=>({
        extends: 'AppMicroLabel',
        display: 'block',
        lineHeight: '1',
        margin: '0 0 X2 0',
        // The caption arrives as a polyglot KEY. `translate` returns its input
        // unchanged when a key does not resolve, so a plain caption still renders.
        text: (el)=>el.call('polyglot', key)
    });
// FA204 / frank trap — PROVIDER_OPTIONS/AUTH_OPTIONS + the two children
// factories used to be bare module-scope consts/functions; they silently
// read as undefined once a component is frank.toJSON'd for platform delivery
// (workspace d6ea1142, project_frank_drops_module_local_helpers). Each is now
// duplicated into BOTH AiModePicker's and AiModePickerBody's own `scope`
// block below (el.scope only resolves within the specific top-level export's
// tree, not across sibling exports in this file) and called via
// `el.scope.<name>`. `providerSection`/`authSection` still run at module-load
// time to build the static section objects — safe, since their OUTPUT here is
// only the inline wrapper below (which reads nothing but `el`).
const $d25d2cd370ea2b8c$var$providerSection = ()=>({
        flow: 'y',
        gap: 'V',
        SectionHeader: $d25d2cd370ea2b8c$var$sectionHeader('ai.settings.provider'),
        Options: {
            flow: 'y',
            gap: 'V',
            children: (el, s)=>el.scope.providerChildren(el, s),
            childExtends: 'AiPickerRow',
            childrenAs: 'state'
        }
    });
const $d25d2cd370ea2b8c$var$authSection = ()=>({
        flow: 'y',
        gap: 'V',
        SectionHeader: $d25d2cd370ea2b8c$var$sectionHeader('ai.settings.authorization'),
        Options: {
            flow: 'y',
            gap: 'V',
            children: (el, s)=>el.scope.authChildren(el, s),
            childExtends: 'AiPickerRow',
            childrenAs: 'state'
        }
    });
const $d25d2cd370ea2b8c$export$f945866d8b92e186 = {
    scope: {
        // Each option carries a `icon` (a real brand-icon-set glyph — verified
        // present: cloud / key / terminal / lock / play) rendered as
        // AiPickerRow's leading anchor.
        PROVIDER_OPTIONS: [
            {
                key: 'simone',
                label: 'ai.mode.providerCloud.label',
                sub: 'ai.mode.providerCloud.sub',
                icon: 'cloud'
            },
            {
                key: 'providers',
                label: 'ai.mode.providerOrg.label',
                sub: 'ai.mode.providerOrg.sub',
                icon: 'key'
            },
            {
                key: 'local',
                label: 'ai.mode.providerLocal.label',
                sub: 'ai.mode.providerLocal.sub',
                icon: 'terminal'
            }
        ],
        AUTH_OPTIONS: [
            {
                key: 'ask',
                label: 'ai.mode.permAsk.label',
                sub: 'ai.mode.permAsk.sub',
                icon: 'lock',
                authMode: true
            },
            {
                key: 'auto',
                label: 'ai.mode.permAuto.label',
                sub: 'ai.mode.permAuto.sub',
                icon: 'play',
                authMode: true
            }
        ],
        providerChildren (el, s) {
            s.root?._aiModePickerTick;
            s.root?._aiSvcReady;
            const ai = (0, $kANrO.getAiService)();
            if (!ai) return [];
            const current = ai.getMode?.() || 'simone';
            return this.PROVIDER_OPTIONS.map((m)=>({
                    ...m,
                    active: m.key === current
                }));
        },
        authChildren (el, s) {
            s.root?._aiModePickerTick;
            s.root?._aiSvcReady;
            const ai = (0, $kANrO.getAiService)();
            if (!ai) return [];
            const current = ai.getAuthMode?.() || 'ask';
            return this.AUTH_OPTIONS.map((m)=>({
                    ...m,
                    active: m.key === current
                }));
        }
    },
    hide: (el, s)=>!s.root?._aiModePickerOpen,
    tag: 'div',
    position: 'fixed',
    bottom: (el, s)=>{
        const a = s.root?._aiModePickerAnchor;
        return a && typeof a.bottom === 'number' ? a.bottom + 'px' : '80px';
    },
    right: (el, s)=>{
        const a = s.root?._aiModePickerAnchor;
        return a && typeof a.right === 'number' ? a.right + 'px' : '24px';
    },
    // The popover recipe (DESIGN_SPEC §6.1): the `G` floor (the AiMenuPanel
    // width; it was a raw 320px), the 70vh cap with its own scroll, the card
    // radius, the in-app `dialog` surface on the overlay elevation.
    minWidth: 'G',
    maxWidth: '90vw',
    maxHeight: '70dvh',
    overflow: 'auto',
    padding: 'Z',
    round: 'radiusCard',
    theme: 'dialog',
    // Borderless — a surface theme may paint a 1px border via its longhand,
    // which DOMQL composes AFTER `border: 'none'` (the theme's longhand wins).
    // Explicit `borderWidth: 0` + the shorthand both so neither slot can apply.
    border: 'none',
    borderWidth: '0',
    shadow: 'overlay',
    zIndex: '200',
    flow: 'y',
    gap: 'V',
    textAlign: 'left',
    // Inner-click guard so the document mousedown listener below doesn't close
    // the picker on its own clicks.
    onClick: (e)=>e.stopPropagation(),
    // Outside-press closes. FA503: declared, so DOMQL registers it once and
    // removes it in dispose() — no `el._docClickGuard` mirror field.
    onDocumentMousedown: {
        capture: true,
        handler: (ev, el)=>{
            const node = el?.node;
            if (!node) return;
            if (node.contains(ev.target)) return;
            // Also keep open if the click landed on the anchor button so ParamsBtn's
            // own onClick gets a chance to toggle (otherwise we close → open in one
            // click and the picker flickers shut).
            const anchor = document.querySelector('[data-key="ParamsBtn"]');
            if (anchor && anchor.contains(ev.target)) return;
            const root = el.state?.root;
            if (root?._aiModePickerOpen) root.update({
                _aiModePickerOpen: false
            });
        }
    },
    ProviderSection: $d25d2cd370ea2b8c$var$providerSection(),
    AuthSection: $d25d2cd370ea2b8c$var$authSection()
};
const $d25d2cd370ea2b8c$export$cbb9785a67237326 = {
    // Duplicated from AiModePicker's scope — see the frank-trap note above
    // `providerSection`. el.scope only resolves within THIS export's own tree.
    scope: {
        PROVIDER_OPTIONS: [
            {
                key: 'simone',
                label: 'ai.mode.providerCloud.label',
                sub: 'ai.mode.providerCloud.sub',
                icon: 'cloud'
            },
            {
                key: 'providers',
                label: 'ai.mode.providerOrg.label',
                sub: 'ai.mode.providerOrg.sub',
                icon: 'key'
            },
            {
                key: 'local',
                label: 'ai.mode.providerLocal.label',
                sub: 'ai.mode.providerLocal.sub',
                icon: 'terminal'
            }
        ],
        AUTH_OPTIONS: [
            {
                key: 'ask',
                label: 'ai.mode.permAsk.label',
                sub: 'ai.mode.permAsk.sub',
                icon: 'lock',
                authMode: true
            },
            {
                key: 'auto',
                label: 'ai.mode.permAuto.label',
                sub: 'ai.mode.permAuto.sub',
                icon: 'play',
                authMode: true
            }
        ],
        providerChildren (el, s) {
            s.root?._aiModePickerTick;
            s.root?._aiSvcReady;
            const ai = (0, $kANrO.getAiService)();
            if (!ai) return [];
            const current = ai.getMode?.() || 'simone';
            return this.PROVIDER_OPTIONS.map((m)=>({
                    ...m,
                    active: m.key === current
                }));
        },
        authChildren (el, s) {
            s.root?._aiModePickerTick;
            s.root?._aiSvcReady;
            const ai = (0, $kANrO.getAiService)();
            if (!ai) return [];
            const current = ai.getAuthMode?.() || 'ask';
            return this.AUTH_OPTIONS.map((m)=>({
                    ...m,
                    active: m.key === current
                }));
        }
    },
    tag: 'div',
    // The AiMenuPanel floor (was a raw 320px).
    minWidth: 'G',
    // Cap at 90vw so long provider labels can't push the dropdown panel wider
    // than the viewport on iPad / Split View (mirrors AiModePicker's 90vw cap).
    maxWidth: '90vw',
    flow: 'y',
    gap: 'V',
    textAlign: 'left',
    ProviderSection: $d25d2cd370ea2b8c$var$providerSection(),
    AuthSection: $d25d2cd370ea2b8c$var$authSection()
};

});

parcelRegister("6P0et", function(module, exports) {

$parcel$export(module.exports, "AiModelSwitcherTrigger", () => $4f77afa56630afdf$export$ce41aa7bbf8661b4);
$parcel$export(module.exports, "AiModelSwitcherBody", () => $4f77afa56630afdf$export$62e48a08cdddabfb);
$parcel$export(module.exports, "AiModelSwitcherRow", () => $4f77afa56630afdf$export$c9a8f66a9fa44dc3);
$parcel$export(module.exports, "AiModelSwitcher", () => $4f77afa56630afdf$export$c31a4d27b8899a6f);
// AiModelSwitcher — THE single quick model-mode switcher, shared by the
// assistant chat header (_simone/Chat.js) and the canvas prompt bar
// (workspace/app.js ModelBtn) so the two can never drift (2026-08-12 per
// Nika "canvasPromptTextarea and ai assistant should be using same model
// switcher and settings buttons").
//
// Four exports, one implementation:
//   • AiModelSwitcherTrigger — the "✦ ⌄" button (the model in its aria-label
//     and in the open menu — no name on the button, 2026-09-29). Its DEFAULT onClick
//     drives the SELF-ANCHORED composite below (root._modelMenuOpen) so the
//     switcher works on surfaces without the @symbo.ls/dropdown plugin
//     (standalone simone :1235, chrome-connect, ext-ui). Hosts that have
//     the plugin (the workspace shell composer) override onClick with
//     openDropdown + AiModelSwitcherBody instead.
//   • AiModelSwitcherBody — the menu body (heading + option rows). No
//     positioning / outside-click guard of its own — the host (the
//     composite's Picker or the dropdown plugin panel) owns those. The
//     same split AiSettingsPanel already uses for the settings body.
//   • AiModelSwitcherRow — one registered option row (label + sub + check),
//     fed per-row state by the body's Options collection.
//   • AiModelSwitcher — the composite trigger + anchored picker with the
//     house Dropdown motion recipe. What Chat.js mounts in its header.
//
// Selection writes root.modelMode + the localStorage key sdk.ai.getModelMode
// reads (`symbols_ai_model_mode`) so the NEXT send carries body.modelMode —
// the same contract AiSettingsPanel's provider section implements (that
// panel stays the deep, scope-aware surface; this is the one-tap switch).

var $2d1Zl = parcelRequire("2d1Zl");

var $3CWNx = parcelRequire("3CWNx");
const $4f77afa56630afdf$export$ce41aa7bbf8661b4 = {
    // FA204 / frank trap — the label map lives in scope: a bare module-scope
    // const read from a serialized prop factory reads as undefined once this
    // component is frank.toJSON'd for platform delivery.
    scope: {
        // ArrowDown/ArrowUp on the CLOSED trigger opens the menu — the standard
        // menu-button contract. Enter/Space need no handler: this is a real
        // <button>, so both already fire the onClick that opens it.
        openByKey (e, el, s) {
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return false;
            e.preventDefault();
            e.stopPropagation();
            if (s.root._modelMenuOpen) return true;
            s.root.update({
                _modelMenuOpen: true
            });
            try {
                el.call('fetchAiProviderDiagnostics');
            } catch (_) {}
            return true;
        },
        // The model's name, the way its own menu rows name it: the ONE catalog
        // (functions/aiModelCatalog.js, held as a scope VALUE — FA204), its label
        // through polyglot — a bundle key translates (Auto / Research / Cheap:
        // "ავტომატური" in a ka UI), a product name stays Latin (polyglot echoes
        // it; I18N glossary rule 4). An unknown mode reads as Auto.
        MODEL_ROWS: (0, $2d1Zl.AI_MODEL_ROWS),
        modelName (el, mode) {
            const rows = this.MODEL_ROWS;
            const row = rows.find((r)=>r.key === mode) || rows.find((r)=>r.key === 'auto');
            return el.call('polyglot', row.label);
        }
    },
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'X',
    align: 'center center',
    padding: 'Y2 Y',
    // THE ROW'S SQUARE on every width: the icon-button law's control size
    // (`controlHCompact`, the token the composer row's own button floor uses) —
    // measured on dev 37211a590 at 1440 the button was 35.3 × 33.3 px beside
    // the row's 36 px icon buttons. Border-box: the padding sits INSIDE the
    // floor, never on top of it (a content-box floor grew the phone send to
    // 56 px, 40e9d2445).
    minWidth: 'controlHCompact',
    minHeight: 'controlHCompact',
    boxSizing: 'border-box',
    round: 'radiusControl',
    theme: 'tertiary',
    color: 'title',
    fontWeight: '400',
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    whiteSpace: 'nowrap',
    // House trigger states: hover wash at rest, `selected` while its menu is
    // open (the BoardMenu MenuTrigger recipe). isOpen only flips on the
    // self-anchored composite (root._modelMenuOpen) — the shell composer host
    // overrides onClick with openDropdown and never writes the flag, so the
    // block is simply inert there.
    ':hover': {
        background: 'hover'
    },
    isOpen: (el, s)=>!!s.root._modelMenuOpen,
    '.isOpen': {
        background: 'selected'
    },
    // THE COMPACT FORM — "✦" + caret in every language and on every width
    // (current-2a's decision, 2026-09-29, Nika's "no cut text"): measured on
    // dev a9783341a at 1440, the English composer row beside the Dashboard chip
    // overflowed for every model but Auto (Cheap +8 … OpenRouter +45 px) and its
    // shrink cut the chip's word to "…"; "✦ ავტომატური" never fitted. About a
    // 36 px square; the model name lives in the accessible name below and in the
    // open menu. A host that re-states a label-era inline padding (the
    // composer's ModelBtn: 'Y Z2') still gets the square on phones:
    '@mobileL': {
        paddingInline: 'Y'
    },
    // The name carries the model ("Switch AI model: Auto") — the button shows
    // no name on any width, so the accessible name is where the model is read.
    'aria-label': (el, s)=>el.call('polyglot', 'ai.settings.switchModel') + ': ' + el.scope.modelName(el, s && s.root && s.root.modelMode || 'auto'),
    'aria-haspopup': 'menu',
    // Tracks the SELF-ANCHORED composite's own flag — the one host whose open
    // state this component owns. The shell composer's ModelBtn hands the panel
    // to the @symbo.ls/dropdown plugin, which owns (and announces) its own
    // panel lifecycle; that mount pins this to 'false' rather than reporting a
    // flag it never writes.
    ariaExpanded: (el, s)=>s.root._modelMenuOpen ? 'true' : 'false',
    onKeydown: (e, el, s)=>el.scope.openByKey(e, el, s),
    // The model button's one visible mark (the name is in the aria-label).
    Glyph: {
        tag: 'span',
        text: "\u2726"
    },
    // Caret glyph — key-based auto-extend (`Icon` extends the Icon built-in).
    // Flips while the composite's menu is open; static transition on
    // transform only (never on a reactive background — MenuPanel.js note).
    Icon: {
        name: 'arrow angle down',
        boxSize: 'Z',
        opacity: '.6',
        transition: 'A defaultBezier',
        transitionProperty: 'transform',
        isOpen: (el, s)=>!!s.root._modelMenuOpen,
        '.isOpen': {
            transform: 'rotate(180deg)'
        }
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const opening = !s.root._modelMenuOpen;
        s.root.update({
            _modelMenuOpen: opening
        });
        // Refresh live per-provider diagnostics on OPEN only — cheap +
        // best-effort (see fetchAiProviderDiagnostics), never on toggle-close.
        if (opening) try {
            el.call('fetchAiProviderDiagnostics');
        } catch (_) {}
    }
};
const $4f77afa56630afdf$export$62e48a08cdddabfb = {
    // FA204 / frank trap — rows + diagnostics gating live in scope (see the
    // Trigger note). The catalog + demotion are the SHARED
    // functions/aiModelCatalog.js exports, assigned here as scope VALUES and
    // reached via `this.…` (el.scope.modelRows() binds `this` to el.scope) —
    // never as bare imported identifiers from inside a scope method, which a
    // frank `to-json` lift would drop (`unresolvable-identifier`). The
    // workspace-pin picker (AiSettingsPanel PinSection) consumes the SAME two
    // values, so the two menus can never drift.
    scope: {
        MODEL_ROWS: (0, $2d1Zl.AI_MODEL_ROWS),
        catalogRows: (0, $2d1Zl.aiModelCatalogRows),
        // THE house keyboard model (functions/menuKeyboard.js), held as scope
        // VALUES so every reach from a serialized factory is `this.…`/
        // `el.scope.…` — the same FA204-safe shape catalogRows above uses.
        navRows: (0, $3CWNx.menuArrowNav),
        focusOnOpen: (0, $3CWNx.menuFocusOnOpen),
        nodeVisible: (0, $3CWNx.menuNodeVisible),
        focusBack: (0, $3CWNx.restoreMenuFocus),
        // Is this body's menu open RIGHT NOW? It renders in two hosts with two
        // different lifecycles and one predicate has to cover both:
        //   • the self-anchored composite (Chat header) keeps the panel mounted
        //     and hides it with `visibility: hidden` — `root._modelMenuOpen` is
        //     the truth, and offsetWidth is useless (a hidden panel keeps its
        //     layout box);
        //   • the shell composer hands the body to the @symbo.ls/dropdown plugin,
        //     which MOUNTS it only while open and never touches that flag — so
        //     "am I actually painted?" is the only available signal there.
        menuIsOpen (el, s) {
            if (s && s.root && s.root._modelMenuOpen) return true;
            return this.nodeVisible(el && el.node);
        },
        // Arm the focus lifecycle. Edge-detected inside menuFocusOnOpen, so this
        // may be called from onRender AND every onUpdate without re-yanking focus
        // back to the first row while the user is three rows down.
        armFocus (el, s) {
            this.focusOnOpen(el, this.menuIsOpen(el, s), {
                when: (node)=>this.nodeVisible(node)
            });
        },
        // Escape closes whichever host owns this body and hands focus back to the
        // trigger. Both close paths run unconditionally: the composite reads the
        // flag, the plugin host answers `closeDropdown`, and neither call harms
        // the other host (the flag is already false there; `closeDropdown` is a
        // best-effort el.call — portable consumers may not register it at all).
        closeMenu (el, s) {
            if (s && s.root && s.root._modelMenuOpen) s.root.update({
                _modelMenuOpen: false
            });
            try {
                el.call('closeDropdown', 'aiModel');
            } catch (_) {}
            this.focusBack(el);
        },
        modelRows (el, s) {
            const current = s.root.modelMode || 'auto';
            // Live per-provider diagnostics (GET /core/ai/providers, fetched when
            // the menu opens — see the Trigger/ModelBtn onClick). Absent until the
            // first successful fetch, so every row defaults to enabled — the menu
            // degrades to plain labels, never to a broken/empty one. Which row is
            // ACTIVE is this menu's own question — the per-user root.modelMode.
            //
            // ONLY WHAT THIS SERVER CAN RUN (WS-AI-MODEL-SWITCHER-SHOWS-SIX-
            // DISABLED-PROVIDERS-1, QA on dev 2026-09-26: six of eight rows read
            // "Disabled on this server"). A provider the server cannot run is not a
            // choice, so its row is left out and one muted line (OffNote below)
            // says how many are off. 'auto' is never demoted and leads the list.
            // The member's CURRENT choice stays even when it went off, with the
            // live reason as its line — the menu never hides why a pick is not
            // answering.
            const rows = this.catalogRows(this.MODEL_ROWS, s.root.aiProviderDiagnostics);
            return rows.filter((m)=>!m.disabled || m.key === current).map((m)=>({
                    ...m,
                    active: m.key === current
                }));
        },
        // How many rows the list above leaves out (off on this server, and not
        // the member's current choice) — the OffNote's count; 0 hides it.
        offCount (el, s) {
            const current = s.root.modelMode || 'auto';
            const rows = this.catalogRows(this.MODEL_ROWS, s.root.aiProviderDiagnostics);
            return rows.filter((m)=>m.disabled && m.key !== current).length;
        }
    },
    flow: 'y',
    gap: 'Y',
    textAlign: 'left',
    // ── keyboard (2026-09-02) ───────────────────────────────────────────────
    // One `role="menu"` over BOTH groups: `menuArrowNav` collects
    // `[role="menuitem"]` in DOM order from this node down, so ArrowDown walks
    // Model rows → Provider row and wraps, with no per-group wiring. The rows
    // are native <button>s (AiOptionRow), so Enter/Space already activate.
    // `tabindex: -1` makes the panel itself a programmatic focus target only —
    // never a tab stop — so `focusFirstMenuRow` can park focus here when the
    // catalog is momentarily empty and Escape still reaches this handler
    // through DOMQL's ancestor-walking keydown delegate.
    role: 'menu',
    tabindex: '-1',
    ariaLabel: (el)=>el.call('polyglot', 'ai.modelSwitcher.ariaLabel'),
    subscribeTo: [
        '_modelMenuOpen'
    ],
    onRender: (el, s)=>el.scope.armFocus(el, s),
    onUpdate: (el, s)=>el.scope.armFocus(el, s),
    // Plugin-hosted panels are UNMOUNTED on close (outside click, row pick, the
    // plugin's own Escape) — there is no true→false edge left to observe, so
    // the focus return happens here instead.
    onRemove: (el)=>el.scope.focusBack(el),
    onKeydown: (e, el, s)=>{
        if (el.scope.navRows(e, el.node)) return;
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            el.scope.closeMenu(el, s);
            return;
        }
        // Tab leaves the menu — close it on the way out (native menu behaviour),
        // WITHOUT preventDefault so the browser still moves focus onward. Drop
        // the stored return target FIRST: the close edge would otherwise pull
        // focus back to the trigger and fight the Tab the user just pressed.
        if (e.key === 'Tab') {
            el._menuReturnFocusTo = null;
            if (s.root && s.root._modelMenuOpen) s.root.update({
                _modelMenuOpen: false
            });
        }
    },
    // Unique key — `SectionHeader` is a built-in component; a plain key
    // renders just our label. Extends THE shared menu caption (AiMenu.js) so
    // this heading and the AiSettingsPanel section headers are one treatment.
    PvHeading: {
        extends: 'AiMenuHeading',
        text: '{{ ai.modelSwitcher.model | polyglot }}'
    },
    Options: {
        flow: 'y',
        gap: 'V',
        children: (el, s)=>el.scope.modelRows(el, s),
        childrenAs: 'state',
        childExtends: 'AiModelSwitcherRow'
    },
    // One muted line when the server has some providers off — the count of
    // the rows the list leaves out, never a row per provider. Aligned to the
    // option rows' text edge like the section captions; not a menu item, so
    // the arrow keys walk past it.
    OffNote: {
        tag: 'p',
        margin: '0',
        paddingLeft: 'Z2',
        fontSize: 'Y',
        lineHeight: '1.4',
        color: 'inactive',
        hide: (el, s)=>!el.scope.offCount(el, s),
        text: (el, s)=>el.call('polyglot', 'ai.modelSwitcher.someOff').replace('{count}', el.scope.offCount(el, s))
    },
    // ── Provider ────────────────────────────────────────────────────────────
    // Moved here from AiSettingsPanel's ProviderSection (2026-09-02 per Nika
    // "move AI provider section to model switcher both in AI prompt and
    // sidebar") — this body renders in BOTH surfaces, so one declaration
    // covers them. The one provider the model rows cannot express is the
    // machine-local simone-bridge target; its row logic is inlined (not a
    // cross-file scope reach — frank `to-json` lifts drop same-file sibling
    // helpers, let alone another component's scope). Selecting it toggles
    // targetMode exactly like the settings panel's chooseLocal did, opening
    // the AiBridgeModal shell overlay on the way in. Because this menu now
    // owns the ONLY exit from local mode, the two mount-site gates that hid
    // the switcher in local mode are dropped in the same change (Chat.js
    // header, app.js ModelBtn) — hiding it again would trap local mode.
    ProviderHeading: {
        extends: 'AiMenuHeading',
        text: '{{ ai.modelSwitcher.provider | polyglot }}'
    },
    LocalRow: {
        extends: 'AiOptionRow',
        cursor: 'pointer',
        opacity: '1',
        title: '',
        background: (el, s)=>(s.root.targetMode || 'general') === 'local' ? 'selected' : 'transparent',
        ':hover': {
            background: 'hover'
        },
        // The row base reads per-row state for these slots; this named child's
        // `s` is the menu state, so pin them off deterministically.
        // (Icon = leading glyph slot, Icon_1 = trailing check — AiOptionRow.)
        Icon: {
            if: ()=>false
        },
        Meta: {
            if: ()=>false
        },
        Body: {
            Label: {
                text: '{{ ai.settings.localAgent | polyglot }}'
            },
            // Sub SWAPS its text while local instead of gaining a second line, so
            // the row never grows and shifts its neighbours (the house rule every
            // AiOptionRow follows).
            Sub: {
                tag: 'div',
                text: (el, s)=>el.call('polyglot', (s.root.targetMode || 'general') === 'local' ? 'ai.settings.localAgentSubActive' : 'ai.settings.localAgentSub')
            }
        },
        Icon_1: {
            hide: (el, s)=>(s.root.targetMode || 'general') !== 'local'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const root = el.state && el.state.root;
            if (!root || !root.update) return;
            const leaving = (s.root.targetMode || 'general') === 'local';
            const next = leaving ? 'workspace' : 'local';
            root.update({
                targetMode: next,
                _aiBridgeSetupOpen: !leaving,
                _modelMenuOpen: false
            });
            try {
                el.call('onTargetModeChange', next);
            } catch (_) {}
            try {
                el.call('closeDropdown', 'aiModel');
            } catch (_) {}
        }
    }
};
const $4f77afa56630afdf$export$c9a8f66a9fa44dc3 = {
    extends: 'AiOptionRow',
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        // A disabled row is a real click target (so its reason is reachable
        // via title/hover), just not a selectable one.
        if (s.disabled) return;
        const root = el.state && el.state.root;
        if (root && root.update) root.update({
            modelMode: s.key,
            _modelMenuOpen: false
        });
        // Persist to the key sdk.ai.getModelMode reads so the next send
        // carries body.modelMode. The el.call hops are best-effort — the
        // shell registers setModelMode + closeDropdown; portable consumers
        // (standalone simone / extension panels) may have neither.
        try {
            if (typeof window !== 'undefined') window.localStorage.setItem('symbols_ai_model_mode', s.key);
        } catch (_) {}
        try {
            el.call('setModelMode', s.key);
        } catch (_) {}
        try {
            el.call('closeDropdown', 'aiModel');
        } catch (_) {}
    }
};
const $4f77afa56630afdf$export$c31a4d27b8899a6f = {
    position: 'relative',
    flow: 'x',
    gap: 'X',
    align: 'center',
    // Key-based auto-extend — the key IS the registered trigger component.
    AiModelSwitcherTrigger: {},
    Picker: {
        extends: 'AiMenuPanel',
        isOpen: (el, s)=>!!s.root._modelMenuOpen,
        tag: 'div',
        position: 'absolute',
        top: '110%',
        right: '0',
        zIndex: '200',
        onClick: (e)=>e.stopPropagation(),
        // Outside-press closes. FA503: declared, so DOMQL registers it once and
        // removes it in dispose() — no `el._docClickGuard` mirror field.
        onDocumentMousedown: {
            capture: true,
            handler: (ev, el)=>{
                const node = el && el.node;
                if (!node || node.contains(ev.target)) return;
                const root = el.state && el.state.root;
                if (root && root._modelMenuOpen) root.update({
                    _modelMenuOpen: false
                });
            }
        },
        AiModelSwitcherBody: {}
    }
};

});
parcelRegister("2d1Zl", function(module, exports) {

$parcel$export(module.exports, "AI_MODEL_ROWS", () => $19be5687dd76ab80$export$4e9ed1b400d78ead);
$parcel$export(module.exports, "aiModelCatalogRows", () => $19be5687dd76ab80$export$492b79f3937fe7bf);
// aiModelCatalog — the ONE model-mode catalog + live-diagnostics demotion,
// shared by the header model dropdown (AiModelSwitcherBody) and the
// workspace-pin picker (AiSettingsPanel PinSection) so the two can never
// drift. Extracted 2026-08-31 (AI-SETTINGS-WORKSPACE-PROVIDER-PIN-NO-UI-
// WRITER-1): the pin surface needed the same rows, and a second copy is the
// exact drift the models-list removal deleted.
//
// Both consumers assign these exports ONTO their component `scope` as VALUES
// (`MODEL_ROWS: AI_MODEL_ROWS`, `catalogRows: aiModelCatalogRows`) and call
// them via `this.…` — never as bare identifiers from inside scope methods —
// because a frank `to-json` lift drops top-of-file import bindings
// (`unresolvable-identifier`, see AiSettingsPanel's chooseAuth note). Both
// functions are self-contained for the same reason: no free variables.
const $19be5687dd76ab80$export$4e9ed1b400d78ead = [
    {
        key: 'auto',
        label: 'ai.model.auto',
        sub: 'ai.model.auto.sub'
    },
    // Product names stay Latin (docs/I18N-GLOSSARY.md rule 4) — only the
    // description line is a bundle key.
    {
        key: 'simone',
        label: 'Simone',
        sub: 'ai.model.simone.sub'
    },
    {
        key: 'anthropic',
        label: 'Anthropic',
        sub: 'ai.model.anthropic.sub'
    },
    {
        key: 'openai',
        label: 'OpenAI',
        sub: 'ai.model.openai.sub'
    },
    {
        key: 'gemini',
        label: 'Gemini',
        sub: 'ai.model.gemini.sub'
    },
    {
        key: 'openrouter',
        label: 'OpenRouter',
        sub: 'ai.model.openrouter.sub'
    },
    {
        key: 'research',
        label: 'ai.model.research',
        sub: 'ai.model.research.sub'
    },
    {
        key: 'cheap',
        label: 'ai.model.cheap',
        sub: 'ai.model.cheap.sub'
    }
];
const $19be5687dd76ab80$export$492b79f3937fe7bf = (rows, diagnostics)=>{
    const byProvider = new Map((diagnostics && diagnostics.providers ? diagnostics.providers : []).map((p)=>[
            p.provider,
            p
        ]));
    return rows.map((m)=>{
        const diag = m.key === 'auto' ? null : byProvider.get(m.key);
        const disabled = Boolean(diag && diag.usable === false);
        return {
            ...m,
            disabled: disabled,
            sub: disabled && diag.reason ? diag.reason : m.sub
        };
    });
};

});

parcelRegister("3CWNx", function(module, exports) {

$parcel$export(module.exports, "menuRowNodes", () => $2a4287c7b6f9137c$export$832bc14d089318db);
$parcel$export(module.exports, "menuArrowNav", () => $2a4287c7b6f9137c$export$7c4e7bdea171e1a3);
$parcel$export(module.exports, "menuActivateRow", () => $2a4287c7b6f9137c$export$58e757a2546a227b);
$parcel$export(module.exports, "focusFirstMenuRow", () => $2a4287c7b6f9137c$export$d859301eb7c867a7);
$parcel$export(module.exports, "armMenuFocus", () => $2a4287c7b6f9137c$export$199869d2fb591d8e);
$parcel$export(module.exports, "armNamedMenuFocus", () => $2a4287c7b6f9137c$export$e82f43c0eb44b40c);
$parcel$export(module.exports, "menuNodeVisible", () => $2a4287c7b6f9137c$export$a081e84bb6aa2d34);
$parcel$export(module.exports, "releaseMenuFocus", () => $2a4287c7b6f9137c$export$88db1feded4126c2);
$parcel$export(module.exports, "restoreMenuFocus", () => $2a4287c7b6f9137c$export$e979bf9fa05b110a);
$parcel$export(module.exports, "menuFocusOnOpen", () => $2a4287c7b6f9137c$export$8b3f96414e37c6f4);
// menuKeyboard — THE one keyboard model for every AI + chat dropdown
// (2026-09-02 per Nika "add keyboard navigation when ai chatbot dropdowns
// open + fix it for chat too").
//
// The house already had this behaviour in exactly ONE place: the shared
// right-click menu (components/ContextDropdown.js — `menuLevelNav` +
// `focusMenuOnOpen`) plus the per-opener focus nudge
// (workspace/functions/homeContextMenu.js `focusHomeContextMenu`). Every
// OTHER menu (the AI model switcher, the AI settings sections, the composer
// '+' attach menu, the assistant Sessions history) was pointer-only. This
// module is that same proven model, lifted out of one component's `scope` so
// four packages can share ONE implementation instead of growing four
// slightly-different copies.
//
// Why plain exported functions and not a component: `el.scope` only resolves
// inside the tree of the ONE top-level export it is declared on, which is why
// ContextDropdown already had to duplicate `menuLevelNav` between its two
// exports. Consumers here assign these functions as scope VALUES
// (`scope: { menuNav: menuArrowNav }` → `el.scope.menuNav(...)`), the same
// FA204-safe reach AiModelSwitcherBody already uses for the model catalog —
// a bare module-scope identifier read from inside a serialized factory reads
// as undefined after frank.toJSON (project_frank_drops_module_local_helpers).
//
// The contract every consumer implements:
//   • the panel carries `role="menu"` + `tabindex="-1"`,
//   • every actionable row carries `role="menuitem"`,
//   • the panel's `onKeydown` runs `menuArrowNav` first, then handles
//     Escape (close + `restoreMenuFocus`),
//   • the panel arms `menuFocusOnOpen` from `onRender`/`onUpdate` so DOM
//     focus actually lands inside the menu. That last step is not optional:
//     DOMQL's keydown delegate walks the ANCESTOR chain of `event.target`
//     (smbls/packages/element/src/delegate.js `installDelegatedEvent`), so a
//     menu that never receives focus never receives a keystroke either —
//     the exact root cause diagnosed three separate times before this
//     (workspace 99c1097a tickets pickers, a986e7ee chat, homeContextMenu.js).
// Rows a keyboard may land on. `[role="menuitem"]` is the house marker
// (ContextDropdown's own query); the option/radio/checkbox roles are accepted
// so a listbox-shaped picker can reuse the same walker.
const $2a4287c7b6f9137c$var$ROW_SELECTOR = '[role="menuitem"],[role="menuitemradio"],[role="menuitemcheckbox"],[role="option"]';
const $2a4287c7b6f9137c$export$832bc14d089318db = (containerNode, selector)=>{
    if (!containerNode || typeof containerNode.querySelectorAll !== 'function') return [];
    const rows = Array.from(containerNode.querySelectorAll(selector || $2a4287c7b6f9137c$var$ROW_SELECTOR));
    return rows.filter((n)=>{
        if (!n) return false;
        if (n.hidden === true) return false;
        if (typeof n.hasAttribute === 'function' && n.hasAttribute('disabled')) return false;
        if (typeof n.getAttribute !== 'function') return true;
        if (n.getAttribute('aria-disabled') === 'true') return false;
        if (n.getAttribute('aria-hidden') === 'true') return false;
        return true;
    });
};
const $2a4287c7b6f9137c$export$7c4e7bdea171e1a3 = (e, containerNode, opts)=>{
    if (!e || !e.key) return false;
    const o = opts || {};
    const rows = $2a4287c7b6f9137c$export$832bc14d089318db(containerNode, o.selector);
    if (!rows.length) return false;
    const doc = typeof document !== 'undefined' ? document : null;
    const active = o.activeElement || doc && doc.activeElement || null;
    const idx = rows.indexOf(active);
    const nextKey = o.orientation === 'x' ? 'ArrowRight' : 'ArrowDown';
    const prevKey = o.orientation === 'x' ? 'ArrowLeft' : 'ArrowUp';
    let target = -1;
    if (e.key === nextKey) target = idx < 0 ? 0 : (idx + 1) % rows.length;
    else if (e.key === prevKey) target = idx < 0 ? rows.length - 1 : (idx - 1 + rows.length) % rows.length;
    else if (e.key === 'Home') target = 0;
    else if (e.key === 'End') target = rows.length - 1;
    else return false;
    if (typeof e.preventDefault === 'function') e.preventDefault();
    // Stop once handled so an ancestor menu level can never react to the same
    // keystroke (ContextDropdown's own rule).
    if (typeof e.stopPropagation === 'function') e.stopPropagation();
    const node = rows[target];
    if (node && typeof node.focus === 'function') node.focus();
    return true;
};
const $2a4287c7b6f9137c$export$58e757a2546a227b = (e, containerNode)=>{
    if (!e || e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return false;
    const row = e.target;
    if (!row || typeof row.click !== 'function') return false;
    if (containerNode && typeof containerNode.contains === 'function' && !containerNode.contains(row)) return false;
    if (typeof row.getAttribute === 'function' && !row.getAttribute('role')) return false;
    if (typeof e.preventDefault === 'function') e.preventDefault();
    if (typeof e.stopPropagation === 'function') e.stopPropagation();
    row.click();
    return true;
};
// Focus the first row of a just-opened menu, on a BOUNDED poll.
//
// A poll, not one microtask and not requestAnimationFrame: the panel does not
// exist (plugin-hosted) or has not left `visibility: hidden` (self-anchored)
// until the open state commits and paints, and Chrome throttles frames in
// backgrounded/automated tabs — the same reasoning ContextDropdown's ddSettle
// and homeContextMenu's focusHomeContextMenu already record.
//
// `getNode` may be a node or a function returning one (the node can appear
// mid-poll). `opts.when` gates each tick — consumers pass a visibility test so
// an always-mounted-but-hidden panel never steals focus.
// One scheduler for the polls below. `window.setTimeout` is the browser path;
// the bare `setTimeout` fallback exists because this package's own test DOM
// shim (__tests__/testDomShim.js) installs an INERT `window` carrying only
// `document` — a hard `window.setTimeout(...)` would throw there and take
// down suites that merely touch a component wired to these helpers.
const $2a4287c7b6f9137c$var$_schedule = (fn, ms)=>{
    if (typeof window !== 'undefined' && typeof window.setTimeout === 'function') return window.setTimeout(fn, ms);
    if (typeof setTimeout === 'function') return setTimeout(fn, ms);
    return null;
};
const $2a4287c7b6f9137c$export$d859301eb7c867a7 = (getNode, opts)=>{
    if (typeof window === 'undefined') return;
    const o = opts || {};
    const tries = o.tries || 10;
    const every = o.every || 30;
    let n = 0;
    const tick = ()=>{
        if (typeof o.cancelled === 'function' && o.cancelled()) return;
        const node = typeof getNode === 'function' ? getNode() : getNode;
        const ready = node && (typeof o.when !== 'function' || o.when(node));
        if (ready) {
            const doc = typeof document !== 'undefined' ? document : null;
            const rows = $2a4287c7b6f9137c$export$832bc14d089318db(node, o.selector);
            const first = o.last ? rows[rows.length - 1] : rows[0];
            // CONFIRM the focus landed, don't assume it (measured live 2026-09-02
            // on the composer '+' menu): `.focus()` on a node that is not attached
            // or not painted yet is a SILENT no-op, and the first poll tick can
            // easily run in that window — the menu then opened correctly, carried
            // its rows, and still had focus parked outside it. Keep polling until
            // the browser agrees, instead of declaring victory on the call.
            if (first && typeof first.focus === 'function') {
                first.focus();
                if (!doc || doc.activeElement === first) return;
            }
            // Painted with no rows at all (an empty menu) — park focus on the
            // panel itself so Escape is still reachable through the delegate walk.
            if (rows.length === 0 && typeof node.focus === 'function') {
                node.focus();
                if (!doc || doc.activeElement === node) return;
            }
        }
        if (++n < tries) $2a4287c7b6f9137c$var$_schedule(tick, every);
    };
    $2a4287c7b6f9137c$var$_schedule(tick, 0);
};
// One generation counter per panel. Every arm bumps it and captures the new
// value; a poll whose captured value is stale cancels itself on its next
// tick. That is what stops a menu opened-then-closed inside the poll window
// from pulling focus back into a panel the user has already left.
const $2a4287c7b6f9137c$var$_bumpMenuFocusGen = (el)=>{
    el.__menuFocusGen = (el.__menuFocusGen || 0) + 1;
    return el.__menuFocusGen;
};
const $2a4287c7b6f9137c$export$199869d2fb591d8e = (el, opts)=>{
    if (!el || typeof window === 'undefined') return;
    const doc = typeof document !== 'undefined' ? document : null;
    const active = doc && doc.activeElement;
    el._menuReturnFocusTo = active && active !== doc.body ? active : null;
    const gen = $2a4287c7b6f9137c$var$_bumpMenuFocusGen(el);
    $2a4287c7b6f9137c$export$d859301eb7c867a7(()=>el.node, {
        ...opts || {},
        cancelled: ()=>gen !== el.__menuFocusGen
    });
};
const $2a4287c7b6f9137c$export$e82f43c0eb44b40c = (el, key, opts)=>{
    const panel = el && typeof el.lookup === 'function' ? el.lookup(key) : null;
    if (!panel) return false;
    $2a4287c7b6f9137c$export$199869d2fb591d8e(panel, {
        ...opts || {},
        when: (node)=>$2a4287c7b6f9137c$export$a081e84bb6aa2d34(node)
    });
    return true;
};
const $2a4287c7b6f9137c$export$88db1feded4126c2 = (el)=>{
    if (!el) return;
    el._menuReturnFocusTo = null;
    $2a4287c7b6f9137c$var$_bumpMenuFocusGen(el);
};
const $2a4287c7b6f9137c$export$e979bf9fa05b110a = (el)=>{
    if (!el) return false;
    const back = el._menuReturnFocusTo;
    el._menuReturnFocusTo = null;
    // Same cancel as releaseMenuFocus: a still-running arm poll would otherwise
    // pull focus off the trigger we just restored it to.
    $2a4287c7b6f9137c$var$_bumpMenuFocusGen(el);
    if (back && typeof back.focus === 'function') {
        back.focus();
        return true;
    }
    return false;
};
const $2a4287c7b6f9137c$export$8b3f96414e37c6f4 = (el, isOpen, opts)=>{
    if (!el || typeof window === 'undefined') return;
    const open = !!isOpen;
    if (open === el._menuWasOpen) return;
    el._menuWasOpen = open;
    if (!open) {
        $2a4287c7b6f9137c$export$e979bf9fa05b110a(el);
        return;
    }
    $2a4287c7b6f9137c$export$199869d2fb591d8e(el, opts);
};
const $2a4287c7b6f9137c$export$a081e84bb6aa2d34 = (node)=>{
    if (!node || typeof window === 'undefined') return false;
    // A node still detached from the document is never "on screen", and
    // getComputedStyle returns an EMPTY declaration for it (every property
    // reads ''), which would otherwise pass all three checks below.
    if (node.isConnected === false) return false;
    if (typeof window.getComputedStyle !== 'function') return true;
    const st = window.getComputedStyle(node);
    if (!st) return true;
    if (st.visibility === 'hidden' || st.display === 'none' || st.opacity === '0') return false;
    // An ANCESTOR's `display: none` does NOT show up in this node's own
    // computed style — it still reports `display: flex` — but it collapses the
    // box to 0×0 and makes every descendant unfocusable. Measured live
    // 2026-09-02: the composer '+' menu on a route where the whole composer is
    // hidden reported itself visible, and `.focus()` was silently refused.
    // Both signals are needed: a `visibility: hidden` panel keeps its box (so
    // size alone would pass it), a display-none ancestor keeps the computed
    // style (so style alone would pass it).
    if (typeof node.offsetWidth === 'number' && !node.offsetWidth && !node.offsetHeight) return false;
    return true;
};

});


parcelRegister("422PO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProviderSection", () => $2ef98c3dc247e0fc$export$8bd0874e5ae6c9c4);
$parcel$export(module.exports, "AiSettingsPanel", () => $2ef98c3dc247e0fc$export$3d3165a033703da9);
$parcel$export(module.exports, "default", () => $2ef98c3dc247e0fc$export$2e2bcd8739ae039);
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $2d1Zl = parcelRequire("2d1Zl");

var $3CWNx = parcelRequire("3CWNx");
// AiSettingsPanel — the SINGLE AI-settings body shared by BOTH assistant
// surfaces so they can never drift:
//   • the canvas prompt bar's ParamsBtn dropdown (workspace/app.js →
//     openDropdown({ content: { extends: 'AiSettingsPanel' } }))
//   • the sidebar assistant's SettingsDrawer sheet (_simone/SettingsDrawer.js)
//
// The panel does NOT choose the MODEL. The model DROPDOWN (AiModelSwitcher —
// the assistant header pill and the canvas composer's ModelBtn) is the single
// model chooser (2026-08-31, Nika: "remove models list in sidebar ai settings,
// we already have dropdown for it"). The provider list that used to live here
// rendered the SAME eight rows as that dropdown and wrote the SAME
// `root.modelMode` + `symbols_ai_model_mode` key — one chooser duplicated on
// one surface. It is deleted; what stays is every control the dropdown does
// NOT carry, each wired to the state that actually routes a turn:
//   • local agent  → targetMode 'local' (the simone-bridge WebSocket round-trip
//                    in simoneAiTransport); toggled via the onTargetModeChange
//                    host hook so the bridge socket opens/closes. The row is a
//                    TOGGLE because the model dropdown HIDES itself in local
//                    mode (Chat.js Actions, app.js ModelBtn) — this row is the
//                    only way back to a cloud provider, a job the deleted
//                    provider list used to do.
//   • authorization→ sdk.ai.getAuthMode/setAuthMode.
//   • SCOPE        → 'me' (per-user localStorage, the above) vs 'workspace'
//                    (an admin pins settings for every member via
//                    settings.aiProvider).
//   • workspace pin→ PinSection (workspace scope only): ONE row + an
//                    on-demand picker writing aiProvider.mode 'provider' +
//                    modelMode — the only shape server
//                    resolveWorkspaceModelMode honours for a model
//                    (AI-SETTINGS-WORKSPACE-PROVIDER-PIN-NO-UI-WRITER-1: the
//                    deleted list was the pin's only writer; this row
//                    restores it WITHOUT a standing list — the catalog
//                    mounts only while the picker is open, and it is the
//                    dropdown's own shared catalog, never a second copy).
//
// State keys written here (declared with safe defaults in workspace/state-app.js):
//   _aiScope ('me'|'workspace'), targetMode, _aiBridgeSetupOpen, _aiPanelTick
//   (nudge signal for reactive re-eval), _aiPinMenuOpen (the pin picker's
//   gate). `modelMode` is READ nowhere in this file any more and written
//   only by the model dropdown. One key lives on the panel's OWN store, never
//   the root: `pinError` (a refused workspace write — see the body's `state`).
// Section header — THE shared menu caption (AiMenu.js AiMenuHeading — the
// pattern this file originated), so AI-settings sections, the model menu and
// the assistant Sessions menu all read as one treatment. Called immediately
// (not read from inside a serialized factory closure) so it's not a frank
// trap — the returned plain object is what lands in the tree, not this
// function reference.
const $2ef98c3dc247e0fc$var$sectionHeader = (key)=>({
        extends: 'AiMenuHeading',
        // The caption arrives as a polyglot KEY. `translate` returns its input
        // unchanged when a key does not resolve, so a plain caption still renders.
        text: (el)=>el.call('polyglot', key)
    });
// One option row — THE shared AiOptionRow (AiMenu.js): MenuPanelItem metrics
// (Y/Z1 padding, radiusControl), the house active pattern (`selected` wash +
// `title` ink), disabled rows that stay real click targets with a fixed
// one-line Sub slot (a demoted row never grows and shifts its neighbours —
// Nika: status must never shift layout). `childrenAs: 'state'` feeds each row
// { key, label, sub, active, disabled }; onClick is provided per section.
// Called immediately (same reasoning as sectionHeader above) — not a trap.
const $2ef98c3dc247e0fc$var$optionRow = (onClick)=>({
        extends: 'AiOptionRow',
        onClick: onClick
    });
// ── Answers: Page · Sidebar · Minimized (ASSISTANT_BOARD_MODE_SPEC §1) ────
// WHERE the assistant's answers go — THE one segmented choice, shown on both
// hosts of this panel (the composer's settings menu and the sidebar's
// settings sheet) because both render this body. The kit segmented control
// at VALUE strength (the ink thumb, compact). The value is the user's own
// (never workspace-scoped), so it sits above "Applies to". The writer is the
// shell's `setAssistantAnswersMode` (workspace functions/assistantDock.js):
// persisted per user; Sidebar returns to the last side.
//
// Hidden only where the shell's writer is absent (another app mounting this
// panel). Page is a PLACEMENT (the main thread, the default — Nika's pick
// 6 A): it needs no board service, so the choice shows whether or not the
// generated-board service answers (only the Dashboard MODE needs it).
const $2ef98c3dc247e0fc$var$AnswersSection = {
    hide: (el)=>typeof (el.context && el.context.functions && el.context.functions.setAssistantAnswersMode) !== 'function',
    subscribeTo: [
        'assistantDock'
    ],
    flow: 'y',
    gap: 'Y',
    SectionHeader: $2ef98c3dc247e0fc$var$sectionHeader('ai.answers.label'),
    AppSegmented: {
        variant: 'choice',
        compact: true,
        ariaLabel: (el)=>el.call('polyglot', 'ai.answers.label'),
        current: (el, s)=>{
            const dock = s.root && s.root.assistantDock;
            return dock === 'main' ? 'page' : dock === 'minimized' ? 'minimized' : 'sidebar';
        },
        select: 'setAssistantAnswersMode',
        childrenAs: 'state',
        children: ()=>[
                {
                    key: 'page',
                    text: 'ai.answers.page',
                    value: 'page'
                },
                {
                    key: 'sidebar',
                    text: 'ai.answers.sidebar',
                    value: 'sidebar'
                },
                {
                    key: 'minimized',
                    text: 'ai.answers.minimized',
                    value: 'minimized'
                }
            ]
    },
    Note: {
        tag: 'span',
        fontSize: 'Y',
        color: 'caption',
        lineHeight: '1.4',
        text: (el)=>el.call('polyglot', 'ai.answers.note')
    }
};
// ── Scope segmented control (Just me / Whole workspace) ──────────────────
const $2ef98c3dc247e0fc$var$ScopeSection = {
    hide: (el, s)=>!(s.root.workspace || s.root.workspaceEmbed),
    flow: 'y',
    gap: 'Y',
    SectionHeader: $2ef98c3dc247e0fc$var$sectionHeader('ai.settings.appliesTo'),
    Seg: {
        flow: 'x',
        gap: 'W',
        padding: 'W',
        round: 'radiusPill',
        background: 'overlay',
        // A segmented control is a radio group, so the keys are LEFT/RIGHT, not
        // up/down (`orientation: 'x'`), and the walk is over the segment buttons
        // themselves rather than the `[role="menuitem"]` default — these are
        // radios, not menu items. Home/End jump to the ends.
        role: 'radiogroup',
        ariaLabel: (el)=>el.call('polyglot', 'ai.settings.appliesTo'),
        onKeydown: (e, el)=>el.scope.navRows(e, el.node, {
                orientation: 'x',
                selector: 'button'
            }),
        children: (el, s)=>{
            s.root._aiPanelTick;
            const cur = s.root._aiScope || 'me';
            const admin = el.scope.isWorkspaceAdmin(s);
            return [
                {
                    key: 'me',
                    label: 'ai.settings.scope.me',
                    enabled: true
                },
                {
                    key: 'workspace',
                    label: 'ai.settings.scope.workspace',
                    enabled: admin
                }
            ].map((o)=>({
                    ...o,
                    active: o.key === cur
                }));
        },
        childrenAs: 'state',
        childExtends: {
            tag: 'button',
            type: 'button',
            role: 'radio',
            ariaChecked: (el, s)=>s.active ? 'true' : 'false',
            // Not an admin → not selectable. `aria-disabled` (never the `disabled`
            // attribute) keeps the row a real target whose `title` reason stays
            // readable, and `menuRowNodes` skips it, so the arrow cycle never
            // stops on a segment the click path would refuse anyway.
            ariaDisabled: (el, s)=>s.enabled ? null : 'true',
            flex: '1',
            minHeight: 'controlHCompact',
            padding: '0 Z',
            round: 'radiusPill',
            border: 'none',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            fontWeight: '700',
            fontSize: 'Z',
            cursor: (el, s)=>s.enabled ? 'pointer' : 'not-allowed',
            opacity: (el, s)=>s.enabled ? '1' : '.4',
            color: (el, s)=>s.active ? 'title' : 'caption',
            // House active wash; no transition on the reactive background (it
            // re-applies per tick and would restart the animation forever).
            background: (el, s)=>s.active ? 'selected' : 'transparent',
            text: (el, s)=>el.call('polyglot', s.label || ''),
            title: (el, s)=>s.enabled ? '' : el.call('polyglot', 'ai.settings.scopeAdminOnly'),
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                if (!s.enabled) return;
                const root = el.state && el.state.root;
                if (root && root.update) root.update({
                    _aiScope: s.key
                });
                el.scope.bumpTick(root);
            }
        }
    },
    Note: {
        tag: 'span',
        fontSize: 'Y',
        color: 'caption',
        lineHeight: '1.4',
        margin: 'X2 0 0 0',
        text: (el, s)=>el.call('polyglot', el.scope.scopeIsWorkspace(s) ? 'ai.settings.scopeNote.workspace' : 'ai.settings.scopeNote.me')
    }
};
// ── Workspace model pin (workspace scope only) ───────────────────────────
// The admin control the deleted provider list used to carry: settings
// .aiProvider mode 'provider' + modelMode — the ONE shape server
// resolveWorkspaceModelMode honours ahead of every member's own dropdown
// choice (AI-SETTINGS-WORKSPACE-PROVIDER-PIN-NO-UI-WRITER-1). ONE row; the
// catalog appears only in an on-demand picker (never a standing list —
// Nika's removal), and it is the model dropdown's own shared catalog
// (functions/aiModelCatalog.js), demoted by the same live diagnostics.
const $2ef98c3dc247e0fc$var$PinSection = {
    hide: (el, s)=>!el.scope.scopeIsWorkspace(s),
    flow: 'y',
    gap: 'Y',
    position: 'relative',
    SectionHeader: $2ef98c3dc247e0fc$var$sectionHeader('ai.settings.workspaceModel'),
    PinRow: {
        extends: 'AiOptionRow',
        cursor: 'pointer',
        opacity: '1',
        title: '',
        background: (el, s)=>s.root._aiPinMenuOpen ? 'selected' : 'transparent',
        ':hover': {
            background: 'hover'
        },
        // Menu-button contract: this row OPENS a picker, so it announces the
        // popup and its state, and ArrowDown/ArrowUp open it (Enter/Space
        // already do — AiOptionRow is a native <button>).
        ariaHaspopup: 'menu',
        ariaExpanded: (el, s)=>s.root._aiPinMenuOpen ? 'true' : 'false',
        onKeydown: (e, el, s)=>{
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
            e.preventDefault();
            e.stopPropagation();
            if (!s.root._aiPinMenuOpen) el.scope.togglePinMenu(el, s);
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            el.scope.togglePinMenu(el, s);
        },
        // Same named-child anatomy pins as LocalRow (the row base reads per-row
        // state; this named child's `s` is the whole panel state).
        Icon: {
            if: ()=>false
        },
        Meta: {
            if: ()=>false
        },
        Body: {
            Label: {
                text: '{{ ai.settings.pinnedModel | polyglot }}'
            },
            // Sub swaps its one line (pinned label vs. Off vs. a refused save) —
            // the row never grows and shifts its neighbours, the house rule every
            // AiOptionRow follows. A refused save reads in the AA-safe danger ink
            // and is announced: a polite live region, because the focus is back on
            // this row when the refusal lands.
            Sub: {
                tag: 'div',
                ariaLive: 'polite',
                color: (el, s)=>el.scope.pinFailed(el, s) ? 'dangerInk' : 'caption',
                text: (el, s)=>el.scope.pinSubCopy(el, s)
            }
        },
        Icon_1: {
            hide: (el, s)=>!el.scope.pinnedModelMode(el, s)
        }
    },
    // The picker — MOUNT-gated (`if:`), so the catalog exists only while open
    // and the panel never carries a standing model list (the intent
    // aiSettingsPanelNoModelsList.test.js locks; this gate is what keeps the
    // pin surface inside it). Anchored panel = the AiModelSwitcher composite
    // recipe (AiMenuPanel base + a document-level outside-click guard).
    Picker: {
        extends: 'AiMenuPanel',
        if: (el, s)=>!!s.root._aiPinMenuOpen,
        isOpen: (el, s)=>!!s.root._aiPinMenuOpen,
        tag: 'div',
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        zIndex: '200',
        // A real menu (2026-09-02): focus enters on open, arrows cycle the model
        // rows, Escape closes and hands focus back to PinRow. `if:`-gated, so the
        // node exists only while open — the open edge is the mount itself, and
        // the close edge is the unmount, which is why the focus return rides
        // onRemove rather than a true→false state edge.
        role: 'menu',
        tabindex: '-1',
        ariaLabel: (el)=>el.call('polyglot', 'ai.settings.pinModel'),
        onRender: (el, s)=>el.scope.focusOnOpen(el, !!s.root._aiPinMenuOpen, {
                when: (node)=>el.scope.nodeVisible(node)
            }),
        onKeydown: (e, el, s)=>{
            if (el.scope.navRows(e, el.node)) return;
            if (e.key !== 'Escape') return;
            // Stop here so the PANEL's Escape (which closes the whole settings
            // body) never fires in the same keystroke: one Escape closes one level.
            e.preventDefault();
            e.stopPropagation();
            if (s.root && s.root._aiPinMenuOpen) s.root.update({
                _aiPinMenuOpen: false
            });
            el.scope.focusBack(el);
        },
        onClick: (e)=>e.stopPropagation(),
        // Outside-press closes. FA503: declared, so DOMQL registers it once and
        // removes it in dispose() — no `el._docClickGuard` mirror field.
        onDocumentMousedown: {
            capture: true,
            handler: (ev, el)=>{
                // Guard against the SECTION (row + picker), not the picker node
                // alone: a mousedown on the PinRow would otherwise close the menu
                // here and the row's click would immediately reopen it — the toggle
                // could then never close (the AiModelSwitcher trigger has that
                // artifact; this section does not inherit it).
                const node = el && el.node;
                const host = node && node.parentNode || node;
                if (!host || host.contains(ev.target)) return;
                const root = el.state && el.state.root;
                if (root && root._aiPinMenuOpen) root.update({
                    _aiPinMenuOpen: false
                });
            }
        },
        onRemove: (el)=>{
            // The picker unmounts on close (`if:` gate) — that unmount IS the close
            // edge, so the focus return to PinRow rides it.
            el.scope.focusBack(el);
        },
        PvHeading: {
            extends: 'AiMenuHeading',
            text: '{{ ai.settings.pinModel | polyglot }}'
        },
        Options: {
            flow: 'y',
            gap: 'V',
            children: (el, s)=>el.scope.pinRows(el, s),
            childrenAs: 'state',
            childExtends: $2ef98c3dc247e0fc$var$optionRow((e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                // A demoted row stays a real click target (its reason is readable),
                // just not a selectable one — the model dropdown's own contract.
                if (s.disabled) return;
                el.scope.choosePin(el, s, s.key);
            })
        }
    }
};
const $2ef98c3dc247e0fc$export$8bd0874e5ae6c9c4 = {
    hide: (el, s)=>el.scope.scopeIsWorkspace(s),
    flow: 'y',
    gap: 'Y',
    SectionHeader: $2ef98c3dc247e0fc$var$sectionHeader('ai.settings.provider'),
    // THE shared AiOptionRow — a named child (not a childrenAs:'state' row), so
    // the state-reading factories are overridden with the local predicates and
    // copy.
    LocalRow: {
        extends: 'AiOptionRow',
        cursor: 'pointer',
        opacity: '1',
        title: '',
        background: (el, s)=>el.scope.isLocal(s) ? 'selected' : 'transparent',
        ':hover': {
            background: 'hover'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            el.scope.chooseLocal(el, s);
        },
        // The row base reads per-row state for these slots; this named child's
        // `s` is the whole panel state, so pin them off deterministically.
        // (Icon = leading glyph slot, Icon_1 = trailing check — AiOptionRow.)
        Icon: {
            if: ()=>false
        },
        Meta: {
            if: ()=>false
        },
        Body: {
            Label: {
                text: '{{ ai.settings.localAgent | polyglot }}'
            },
            // Sub SWAPS its text while local instead of gaining a second line, so
            // the row never grows and shifts its neighbours (the house rule every
            // AiOptionRow follows). The swapped copy is what makes the toggle
            // discoverable: the header model dropdown is hidden in local mode, so
            // the user must know this row is also the way out.
            Sub: {
                tag: 'div',
                text: (el, s)=>el.call('polyglot', el.scope.isLocal(s) ? 'ai.settings.localAgentSubActive' : 'ai.settings.localAgentSub')
            }
        },
        Icon_1: {
            hide: (el, s)=>!el.scope.isLocal(s)
        }
    }
};
// The local-bridge SETUP lives in AiBridgeModal (a shell-root overlay opened by
// chooseLocal via root._aiBridgeSetupOpen) — NOT inline here, so selecting the
// local agent never grows/shifts the dropdown.
// ── Authorization (real ask/auto) ────────────────────────────────────────
const $2ef98c3dc247e0fc$var$AuthSection = {
    flow: 'y',
    gap: 'Y',
    SectionHeader: $2ef98c3dc247e0fc$var$sectionHeader('ai.settings.authorization'),
    Options: {
        flow: 'y',
        gap: 'V',
        // Arrows cycle within THIS section only (the walk is scoped to this
        // node), so Authorization and Voice never fold into one another's cycle.
        // The rows are AiOptionRow <button>s carrying role="menuitem", so
        // Enter/Space already activate them.
        role: 'group',
        ariaLabel: (el)=>el.call('polyglot', 'ai.settings.authorization'),
        onKeydown: (e, el)=>el.scope.navRows(e, el.node),
        children: (el, s)=>{
            s.root._aiPanelTick;
            const ai = el.call('getAiService');
            const pin = el.scope.scopeIsWorkspace(s) ? el.scope.workspacePin(el, s) : null;
            const cur = pin && pin.authMode ? pin.authMode : ai && ai.getAuthMode && ai.getAuthMode() || 'ask';
            return el.scope.AUTH_ROWS.map((r)=>({
                    ...r,
                    active: r.key === cur
                }));
        },
        childrenAs: 'state',
        childExtends: $2ef98c3dc247e0fc$var$optionRow((e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            el.scope.chooseAuth(el, s, s.key);
        })
    }
};
// Voice — whether Simone SPEAKS its replies (ElevenLabs TTS through the
// existing /core/ai/voice/tts chain; speakReply.js owns playback). Same row
// mechanics as AuthSection; current value lives in localStorage via
// speakRepliesEnabled/setSpeakReplies (default OFF — S3, tickets/sonnet.md,
// 2026-08-16: a fresh profile must not speak until the user opts in).
const $2ef98c3dc247e0fc$var$VoiceSection = {
    flow: 'y',
    gap: 'Y',
    SectionHeader: $2ef98c3dc247e0fc$var$sectionHeader('ai.settings.voiceGroup'),
    Options: {
        flow: 'y',
        gap: 'V',
        role: 'group',
        ariaLabel: (el)=>el.call('polyglot', 'ai.settings.voiceGroup'),
        onKeydown: (e, el)=>el.scope.navRows(e, el.node),
        children: (el, s)=>{
            s.root._aiPanelTick;
            let on = false;
            try {
                on = !!el.call('speakRepliesEnabled');
            } catch (_) {}
            const cur = on ? 'on' : 'off';
            return el.scope.VOICE_ROWS.map((r)=>({
                    ...r,
                    active: r.key === cur
                }));
        },
        childrenAs: 'state',
        childExtends: $2ef98c3dc247e0fc$var$optionRow((e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            el.scope.chooseVoice(el, s, s.key);
        })
    }
};
// ── AI reliability (AI-210 "give the turn telemetry a reader") ───────────
// Quiet, READ-ONLY 14-day tool-turn success readout — the settings-panel
// half of AI-210 (the admin/usage dashboard half already shipped: see
// workspace/packages/workspace/pages/admin/usage.js Section_AiTurnStats).
// A ONE-LINE stat (title ink) + a caption-ink detail line, matching
// AiOptionRow's Label/Sub body shape — a settings panel, not a dashboard,
// so no per-day breakdown here.
//
// Genuinely LOCAL to this panel instance: unlike every section above (whose
// state keys are cross-cutting, app-root-owned settings — see the file
// header), this is ephemeral per-mount telemetry that must never land on
// the shared root store both panel hosts read/write through `s.root.X`.
// The explicit `state: {}` below (vs. every section above, which declares
// no `state:` and so inherits the parent's store BY REFERENCE — see
// @symbo.ls/state src/create.js `applyInitialState`) makes a genuinely
// separate store branch: `el.update` in onInit writes ONLY here. `s.root`
// reads from inside this branch still resolve to the real app root (the
// store's `root` getter climbs past local branches to the topmost store —
// @symbo.ls/state src/methods.js), so nothing above is affected.
const $2ef98c3dc247e0fc$var$ReliabilitySection = {
    flow: 'y',
    gap: 'Y',
    state: {},
    SectionHeader: $2ef98c3dc247e0fc$var$sectionHeader('ai.settings.reliabilityGroup'),
    // Best-effort, fire-and-forget — it never blocks panel open. A missing SDK
    // method or a failed call both just leave `aiReliability` unset; Row's `if:`
    // then never activates — the same optional-call contract every other row in
    // this panel follows.
    onInit: (el)=>{
        el.scope.loadAiReliability(el);
    },
    Row: {
        // Lazy activation: absent at first render, created the moment
        // loadAiReliability's `.then()` populates `aiReliability` — v3.14's
        // `if:` effect re-runs the full creation path on a false→true flip
        // (@symbo.ls/element src/create.js registerIfEffect "First-time
        // activation"), so this resurrects correctly once the async call
        // resolves; it does not need `hide:` + `subscribeTo`. Never reads a
        // MISSING key as "empty" — the empty-state copy is a POPULATED value
        // (formatAiReliability returns it for a genuine `rows: []`), so this
        // stays un-activated only pre-load or when the SDK lacks the method.
        if: (el, s)=>!!s.aiReliability,
        tag: 'div',
        flow: 'y',
        gap: 'V',
        padding: 'Y Z1',
        Label: {
            tag: 'span',
            fontWeight: '700',
            color: 'title',
            fontSize: 'Z1',
            lineHeight: '1.3',
            text: (el, s)=>s.aiReliability.label
        },
        Sub: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            lineHeight: '1.4',
            text: (el, s)=>s.aiReliability.sub
        }
    }
};
const $2ef98c3dc247e0fc$export$3d3165a033703da9 = {
    // FA204 / frank trap — every helper below used to be a bare module-scope
    // const/function read from inside nested factories (`children`, `onClick`,
    // `background`, …). Those read as undefined once this component was
    // frank.toJSON'd for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called via
    // `el.scope.<name>`; helpers that call SIBLING scope helpers use regular
    // function syntax + `this.<name>(...)` (el.scope.foo() binds `this` to
    // el.scope — object-literal properties can't see each other as bare
    // identifiers otherwise).
    scope: {
        // NO standing provider/model catalog renders here any more — the model
        // dropdown owns model choice (AiModelSwitcherBody, the single chooser).
        // The workspace-pin picker REUSES that dropdown's shared catalog
        // (functions/aiModelCatalog.js, assigned below as scope VALUES) behind an
        // on-demand `if:` gate — a different QUESTION (the workspace pin, never
        // root.modelMode), the same rows. Do not reintroduce a copy.
        PIN_CATALOG: (0, $2d1Zl.AI_MODEL_ROWS),
        catalogRows: (0, $2d1Zl.aiModelCatalogRows),
        // ── keyboard (2026-09-02) ─────────────────────────────────────────────
        // THE shared menu keyboard model (functions/menuKeyboard.js), assigned as
        // scope VALUES exactly like the catalog above — a scope method that
        // called them by their bare imported names would read as undefined after
        // a frank to-json lift.
        //
        // What this panel takes and what it deliberately does NOT:
        //   • Escape closes the panel from anywhere inside it, on BOTH hosts.
        //   • Arrows cycle WITHIN one section (Authorization, Voice, the pinned-
        //     model picker) and left/right across the "Applies to" segments.
        //   • The pinned-model picker is a real menu: focus enters on open,
        //     returns to its row on close.
        //   • Rows stay in the NATIVE tab order (no roving tabindex). This body
        //     is also a drawer sheet with headings, a read-only reliability
        //     readout and several independent groups — Tab is the primary way
        //     through it, and a menu-style roving model would remove far more
        //     than it adds. The arrow cycle is additive.
        navRows: (0, $3CWNx.menuArrowNav),
        focusOnOpen: (0, $3CWNx.menuFocusOnOpen),
        nodeVisible: (0, $3CWNx.menuNodeVisible),
        focusBack: (0, $3CWNx.restoreMenuFocus),
        // Close the panel on Escape, whichever host mounts it. The chat surface
        // renders it inside SettingsDrawer behind `root.showSettings`; the shell
        // composer hands it to the @symbo.ls/dropdown plugin under the 'aiParams'
        // id (AiSettingsButton). Both are attempted, and neither harms the other:
        // the flag is already false on the shell, and `closeDropdown` is a
        // best-effort el.call that portable consumers may not register at all.
        closePanel (el, s) {
            if (s && s.root && s.root.showSettings) s.root.update({
                showSettings: false
            });
            try {
                el.call('closeDropdown', 'aiParams');
            } catch (_) {}
            this.focusBack(el);
        },
        AUTH_ROWS: [
            {
                key: 'ask',
                label: 'ai.settings.authAsk.label',
                sub: 'ai.settings.authAsk.sub'
            },
            {
                key: 'auto',
                label: 'ai.settings.authAuto.label',
                sub: 'ai.settings.authAuto.sub'
            }
        ],
        VOICE_ROWS: [
            {
                key: 'on',
                label: 'ai.settings.voiceOn.label',
                sub: 'ai.settings.voiceOn.sub'
            },
            {
                key: 'off',
                label: 'ai.settings.voiceOff.label',
                sub: 'ai.settings.voiceOff.sub'
            }
        ],
        chooseVoice (el, s, key) {
            el.call('setSpeakReplies', key === 'on');
            // Priming inside THIS click blesses the audio element for autoplay, so
            // the very next reply can speak without another gesture.
            if (key === 'on') try {
                el.call('primeSpeakAudio');
            } catch (_) {}
            this.bumpTick(s.root);
        },
        isLocal (s) {
            return (s.root.targetMode || 'general') === 'local';
        },
        scopeIsWorkspace (s) {
            return s.root._aiScope === 'workspace';
        },
        // The member's role on THIS workspace as the SERVER resolved it: the held
        // record's `access.role` (getWorkspace's `callerAccess` — the read is
        // gated on the same resolution `updateWorkspaceSettings` runs before it
        // writes a pin). Never the org role (an org admin named `editor` on a
        // workspace is an editor there, and the server refuses the write) and
        // never the record's own `role` (list rows stamp a 'member' stand-in).
        // The shell's `callerWorkspaceRole` reads this same field, but not every
        // host of this shared panel registers it (the workspace-ui catalog, the
        // extensions), so the panel reads the one field itself — the same record
        // `resolveWsId` takes the write's target from. null = the answer has not
        // landed yet (the boot merges it into the held record in the background).
        workspaceRole (s) {
            const ws = s && s.root && s.root.workspace;
            const role = ws && ws.access && ws.access.role;
            return typeof role === 'string' && role ? role : null;
        },
        // True only when that answer is owner/admin. Any other role is false, and
        // so is no answer yet: the panel WAITS — the Workspace segment stays
        // disabled, and the pin and authorization writes send nothing.
        isWorkspaceAdmin (s) {
            const role = this.workspaceRole(s);
            return role === 'owner' || role === 'admin';
        },
        // The workspace's pinned provider (settings.aiProvider), if any.
        // TWO sources, in precedence order, and both are needed:
        //   1. root.workspaceSettings.aiProvider — the WRITE MIRROR
        //      persistWorkspacePin maintains: the newest value this session, ahead
        //      of the not-yet-refetched record right after a write.
        //   2. root.workspace.settings.aiProvider — the CANONICAL server record
        //      (workspaceSettings.js is THE accessor; direct-read fallback kept
        //      for hosts without the registered function). Reading ONLY the
        //      mirror was a measured defect (2026-08-31, live): a fresh boot
        //      showed a pinned workspace as "Off", and a post-reload unpin merge
        //      built from {} and dropped the pinned modelMode/authMode siblings.
        // DECISION-site note (spec §5): while the record is still pre-arrival
        // both sources are empty and this reads "no pin" for a moment — the safe
        // action for both meanings, and writes are admin-gated anyway.
        workspacePin (el, s) {
            const mirror = s.root.workspaceSettings && s.root.workspaceSettings.aiProvider;
            if (mirror) return mirror;
            let bag = null;
            try {
                bag = el && el.call ? el.call('workspaceSettings') : null;
            } catch (_) {
                bag = null;
            }
            const settings = bag && bag.ready ? bag.settings : s.root.workspace && s.root.workspace.settings || null;
            return settings && settings.aiProvider || null;
        },
        // The pin, normalized: the modelMode ONLY when the shape is the one the
        // server honours (mode 'provider' — resolveWorkspaceModelMode); null for
        // 'cloud'/'bridge'/absent, so no other shape ever reads as pinned.
        pinnedModelMode (el, s) {
            const pin = this.workspacePin(el, s);
            return pin && pin.mode === 'provider' && pin.modelMode ? pin.modelMode : null;
        },
        pinLabel (mode) {
            const row = this.PIN_CATALOG.find((r)=>r.key === mode);
            return row && row.label || mode;
        },
        pinSubCopy (el, s) {
            s.root._aiPanelTick;
            if (this.pinFailed(el, s)) return el.call('polyglot', 'ai.settings.pin.saveFailed');
            const pinned = this.pinnedModelMode(el, s);
            return pinned ? el.call('polyglot', 'ai.settings.pin.activeSuffix').replace('{model}', el.call('polyglot', this.pinLabel(pinned))) : el.call('polyglot', 'ai.settings.pin.off');
        },
        // The picker rows: the dropdown's own shared catalog + live demotion,
        // prefixed with the unpin row. ACTIVE follows the WORKSPACE PIN — a
        // different question from the dropdown's per-user root.modelMode.
        pinRows (el, s) {
            s.root._aiPanelTick;
            const pinned = this.pinnedModelMode(el, s);
            const rows = this.catalogRows(this.PIN_CATALOG, s.root.aiProviderDiagnostics);
            return [
                {
                    key: 'nopin',
                    label: 'ai.settings.pinNone.label',
                    sub: 'ai.settings.pinNone.sub',
                    active: !pinned
                },
                ...rows.map((r)=>({
                        ...r,
                        active: r.key === pinned
                    }))
            ];
        },
        togglePinMenu (el, s) {
            const root = el.state && el.state.root;
            if (!root || !root.update) return;
            const opening = !root._aiPinMenuOpen;
            root.update({
                _aiPinMenuOpen: opening
            });
            // Refresh the live per-provider diagnostics on OPEN only — the same
            // best-effort contract the model dropdown's trigger follows.
            if (opening) try {
                el.call('fetchAiProviderDiagnostics');
            } catch (_) {}
            this.bumpTick(root);
        },
        // Admin-only. 'nopin' → mode 'cloud' (the server's "no pin" — the
        // resolver falls through to each member's own request); a model key →
        // mode 'provider' + that modelMode. persistWorkspacePin's merge keeps
        // the pinned authMode either way.
        choosePin (el, s, key) {
            if (!this.isWorkspaceAdmin(s)) return;
            const root = el.state && el.state.root;
            if (key === 'nopin') this.persistWorkspacePin(el, s, {
                mode: 'cloud'
            });
            else this.persistWorkspacePin(el, s, {
                mode: 'provider',
                modelMode: key
            });
            if (root && root.update) root.update({
                _aiPinMenuOpen: false
            });
            this.bumpTick(root);
        },
        // The SDK does NOT live on the state root (root.sdk is undefined) and
        // el.sdk isn't reliably present on a nested shared-library component, so
        // fall back to the getSDK() singleton — the SAME cached, auth-hydrated
        // instance aiService resolves through. This is what makes the admin
        // workspace-pin write actually fire.
        resolveSdk (el) {
            const fromEl = el && el.state && el.state.root && el.state.root.sdk || el && el.sdk;
            if (fromEl) return fromEl;
            try {
                return (0, $1NxyO.getSDK)();
            } catch (_) {
                return null;
            }
        },
        resolveWsId (el) {
            return this.resolveWsIdFrom(el.state && el.state.root, this.resolveSdk(el));
        },
        // The active workspace's id: the held record first, then the SDK's
        // context. Split from resolveWsId so a write's late answer can ask it
        // again from the root it captured (the row that started the write may
        // be gone by then). Not the packages' `wsIdOf`: that reads the record
        // only, and a shared component imports no package function.
        resolveWsIdFrom (root, sdk) {
            return root && root.workspace && (root.workspace._id || root.workspace.id) || sdk && sdk._context && sdk._context.activeWorkspaceId || null;
        },
        bumpTick (root) {
            if (root && root.update) root.update({
                _aiPanelTick: (root._aiPanelTick || 0) + 1
            });
        },
        // Admin-only: write settings.aiProvider so the SERVER applies this
        // provider to every member's turns. Merge-safe single-key PATCH; mirrors
        // into root.workspaceSettings so the UI reflects it immediately.
        //
        // A REFUSED write (a 403, a failed request, a `{ success: false }`
        // answer — onboarding.js's language save reads the same shape) puts the
        // mirror's pin back to its value before the write and notes the refusal
        // for the pin row (`pinError` on the panel's own store). The mirror never
        // keeps a pin the server did not save: the row, the picker and the
        // transport's authMode all read it. Root, SDK and the panel store are
        // captured NOW — the picker row that started the write unmounts when the
        // picker closes, long before a slow answer lands.
        persistWorkspacePin (el, s, aiProvider) {
            const root = el.state && el.state.root;
            const sdk = this.resolveSdk(el);
            const wsId = this.resolveWsId(el);
            if (!sdk || !sdk.updateWorkspaceSettings || !wsId) return;
            const merged = {
                ...this.workspacePin(el, s) || {},
                ...aiProvider
            };
            const before = this.mirrorPin(root);
            const panel = this.panelStore(s);
            if (panel && panel.pinError) panel.update({
                pinError: null
            });
            if (root && root.update) root.update({
                workspaceSettings: {
                    ...root.workspaceSettings || {},
                    aiProvider: merged
                }
            });
            // The executor runs at once, so the request still leaves inside this
            // click, and a synchronous throw takes the same refusal path.
            new Promise((resolve)=>resolve(sdk.updateWorkspaceSettings(wsId, {
                    aiProvider: merged
                }))).then((res)=>{
                if (res && res.success === false) throw new Error(res.message || '');
            }).catch((err)=>{
                console.warn('[AiSettingsPanel] workspace pin write failed:', err && err.message || err);
                if (!this.undoWorkspacePin(root, sdk, wsId, merged, before)) return;
                if (panel && panel.update) panel.update({
                    pinError: wsId
                });
            });
        },
        // Puts the mirror's pin back after a refused write — only while the
        // refused value is still what the mirror shows, and only on the workspace
        // the write was for. A newer write (its own answer decides) or a
        // workspace switch (the mirror belongs to the other workspace now) is
        // left alone, and then nothing is noted either. Values, not identity: the
        // store wraps every written object in a proxy of its own. Answers
        // whether it put the pin back.
        undoWorkspacePin (root, sdk, wsId, merged, before) {
            if (!root || !root.update) return false;
            if (String(this.resolveWsIdFrom(root, sdk)) !== String(wsId)) return false;
            const bag = root.workspaceSettings;
            if (!this.samePin(bag && bag.aiProvider, merged)) return false;
            root.update({
                workspaceSettings: {
                    ...bag,
                    aiProvider: before
                }
            });
            this.bumpTick(root);
            return true;
        },
        // A plain copy of the mirror's pin (null when the mirror holds none) —
        // the value a refused write puts back. null lets workspacePin fall
        // through to the canonical record again.
        mirrorPin (root) {
            const pin = root && root.workspaceSettings && root.workspaceSettings.aiProvider;
            return pin ? {
                ...pin
            } : null;
        },
        // Same keys, same values — the aiProvider shape is flat.
        samePin (a, b) {
            if (!a || !b) return false;
            const keys = Object.keys(b);
            return Object.keys(a).length === keys.length && keys.every((k)=>a[k] === b[k]);
        },
        // The panel's OWN store (the body's `state: { pinError }`). The pin row
        // holds it as its state; a picker or authorization ROW holds its item as
        // state, and the panel's store is that row store's parent. Never the app
        // root: a refused write is this panel's note, not shell state.
        panelStore (s) {
            if (s && 'pinError' in s) return s;
            const parent = s && s.parent;
            return parent && 'pinError' in parent ? parent : null;
        },
        // True while this panel's last workspace write stands refused, on the
        // workspace it was for (another workspace's row reads normally).
        pinFailed (el, s) {
            const failed = s && s.pinError;
            return !!failed && String(failed) === String(this.resolveWsId(el));
        },
        // The Local-agent row is a TOGGLE, and the ONLY exit from local mode: the
        // model dropdown hides itself while local (Chat.js Actions `if:`, app.js
        // ModelBtn `hide:`), and the provider list that used to carry the exit is
        // deleted. ON → select the local target and open the connect setup as a
        // shell-root modal overlay (AiBridgeModal), NOT inline, so the dropdown
        // never grows/shifts. OFF → back to the cloud target, keeping whatever
        // modelMode the dropdown last stored, and close the connect modal.
        chooseLocal (el, s) {
            const root = el.state && el.state.root;
            if (!root || !root.update) return;
            // Inlined `isLocal(s)`'s body: this helper is one line, and an inlined
            // predicate survives a frank `to-json` lift into `globalScope` (which
            // does not carry same-file sibling helpers along —
            // `unresolvable-identifier`, the trap chooseProvider documented before
            // it was deleted).
            const leaving = (s.root.targetMode || 'general') === 'local';
            const next = leaving ? 'workspace' : 'local';
            root.update({
                targetMode: next,
                _aiBridgeSetupOpen: !leaving
            });
            try {
                el.call('onTargetModeChange', next);
            } catch (_) {}
            this.bumpTick(root);
        },
        chooseAuth (el, s, key) {
            const root = el.state && el.state.root;
            // `el.call('getAiService')`, not the bare imported function —
            // chooseAuth is referenced from multiple element sites in this file,
            // so frank `to-json` auto-lifts it into `globalScope`, and the lift's
            // text extraction drops the top-of-file import binding
            // (`unresolvable-identifier`, same class as getSDK.js's `SDK` import —
            // see tickets/smbls.md). `el.call` resolves through the live functions
            // registry at runtime instead of a static free-var reference, so it
            // survives the lift untouched. `getAiService` is already barrelled
            // (functions/index.js `export * from './aiService.js'`).
            const ai = el.call('getAiService');
            try {
                if (ai) ai.setAuthMode(key);
            } catch (_) {}
            if (this.scopeIsWorkspace(s) && this.isWorkspaceAdmin(s)) {
                const pin = this.workspacePin(el, s) || {};
                this.persistWorkspacePin(el, s, {
                    mode: pin.mode || 'cloud',
                    modelMode: pin.modelMode || 'auto',
                    authMode: key
                });
            }
            this.bumpTick(root);
        },
        // AI-210 — one source of truth for both the SDK call param and the
        // display copy below, so the two never drift.
        AI_RELIABILITY_DAYS: 14,
        // Best-effort load for ReliabilitySection.Row. `turnStats` lives on the
        // AI SERVICE (shipped sdk e7b88ec: AiService.turnStats, `GET
        // .../ai-turn-stats`). The SDK keeps services in a Map — there is NO
        // `sdk.ai` property (live-verified 2026-08-16: `sdk.ai` undefined on the
        // running page while the resolved service had `turnStats`; a property
        // feature-detect silently gated this row off on a working stack). Reach
        // it the way every other row in THIS panel does — the app-cached
        // resolved instance via `el.call('getAiService')` (see the Options rows
        // above), falling back to the async `sdk.getService('ai')` for a host
        // that has not resolved it yet. Writes onto the CALLER's own local state
        // (`el.update`, never `root.update`) — see the comment on
        // ReliabilitySection's `state: {}` for why this data must stay off the
        // shared root store.
        loadAiReliability (el) {
            // BOOT WINDOW: this panel is an always-mounted, hide-gated body, so
            // onInit runs at shell boot — before the SDK singleton exists and
            // before the AI service has resolved. A one-shot "is it there now?"
            // check silently no-ops for the whole session (live-verified
            // 2026-08-16: header rendered, row never appeared; re-invoking the
            // loader post-boot rendered it). So resolve through the app's own
            // `resolveAiService` promise — it settles once `sdk.getService('ai')`
            // completes, however long boot takes — with the sync-cached instance
            // as the fast path and `sdk.getService('ai')` as the fallback for a
            // host without that registered function.
            let cached = null;
            try {
                cached = el.call('getAiService');
            } catch (_) {
                cached = null;
            }
            let svcPromise;
            if (cached && typeof cached.turnStats === 'function') svcPromise = Promise.resolve(cached);
            else try {
                svcPromise = Promise.resolve(el.call('resolveAiService'));
            } catch (_) {
                const sdk = this.resolveSdk(el);
                svcPromise = sdk && typeof sdk.getService === 'function' ? Promise.resolve(sdk.getService('ai')) : Promise.resolve(sdk && sdk.ai);
            }
            svcPromise.then((ai)=>{
                if (!ai || typeof ai.turnStats !== 'function') return null;
                return ai.turnStats({
                    workspaceId: this.resolveWsId(el),
                    days: this.AI_RELIABILITY_DAYS
                });
            }).then((resp)=>{
                if (resp == null) return;
                // Defensive unwrap — mirrors usage.js's `_unwrapTurnStats`
                // (`r.data || r`): tolerate either an envelope-wrapped or a flat
                // resolved shape rather than assuming one.
                const data = resp && resp.data || resp || {};
                const rows = Array.isArray(data.rows) ? data.rows : [];
                // STATE write, not `el.update`: `el.update({ aiReliability: {…} })`
                // routes a lowercase key with an object value through the
                // element-patch path (a child/prop write), so the value never
                // reached this section's local store and `Row.if` never flipped —
                // live-verified 2026-08-16 (`state.update` mounted the row;
                // `el.update` left the store empty). The section's own
                // `state: {}` branch is what makes this write local.
                if (el.state && typeof el.state.update === 'function') el.state.update({
                    aiReliability: this.formatAiReliability(el, rows)
                });
            }).catch((err)=>{
                console.warn('[AiSettingsPanel] turnStats fetch failed:', err && err.message || err);
            });
        },
        // Formatter — aggregates the day-window's rows into the row's two
        // display lines, in the active language (`el` reads polyglot). `rows` is
        // asserted to always be an array (never undefined): loadAiReliability
        // only reaches here on a SUCCESSFUL response, so an empty array is the
        // genuine "nothing recorded yet" case (AiService.turnStats's own asserted
        // contract), never a stand-in for a failed fetch. The element comes
        // FIRST, as the loader passes it (dev 2026-10-30: the signature kept only
        // `rows` after the i18n extraction, so `rows` was the element and every
        // open logged "turnStats fetch failed: … reduce is not a function").
        formatAiReliability (el, rows) {
            const totals = rows.reduce((acc, r)=>({
                    toolTurns: acc.toolTurns + (Number(r.toolTurns) || 0),
                    okToolTurns: acc.okToolTurns + (Number(r.okToolTurns) || 0),
                    textLeakTurns: acc.textLeakTurns + (Number(r.textLeakTurns) || 0)
                }), {
                toolTurns: 0,
                okToolTurns: 0,
                textLeakTurns: 0
            });
            if (totals.toolTurns === 0) return {
                label: el.call('polyglot', 'ai.settings.reliability.empty'),
                sub: el.call('polyglot', 'ai.settings.reliability.window').replace('{days}', String(this.AI_RELIABILITY_DAYS))
            };
            const pct = Math.round(totals.okToolTurns / totals.toolTurns * 100);
            const sub = totals.textLeakTurns > 0 ? el.call('polyglot', totals.textLeakTurns === 1 ? 'ai.settings.reliability.leak' : 'ai.settings.reliability.leaks').replace('{count}', String(totals.textLeakTurns)) : el.call('polyglot', 'ai.settings.reliability.noLeaks');
            return {
                label: el.call('polyglot', 'ai.settings.reliability.label').replace('{pct}', String(pct)).replace('{ok}', String(totals.okToolTurns)).replace('{total}', String(totals.toolTurns)).replace('{days}', String(this.AI_RELIABILITY_DAYS)),
                sub: sub
            };
        }
    },
    tag: 'div',
    // The panel's OWN store (`state: {}` + `s.update`, the ReliabilitySection
    // precedent above): `pinError` holds the workspace id of a refused
    // workspace write, read by the pin row. Local on purpose: each host (the
    // composer dropdown, the sidebar sheet) shows the note where the click
    // happened, and an undeclared ROOT key would be shell state nobody owns.
    // The sections declare no `state:`, so they hold this store by reference;
    // every `s.root.X` read still reaches the app root (the store's `root`
    // getter climbs past local branches).
    state: {
        pinError: null
    },
    // Escape closes the panel from ANY row inside it (2026-09-02). It sits on
    // the body, not on each section, because DOMQL's keydown delegate walks the
    // ancestor chain of `event.target` — one handler here catches every
    // descendant, and a section that stops its own key (the pin picker's own
    // Escape) simply never lets it reach here.
    role: 'group',
    ariaLabel: (el)=>el.call('polyglot', 'ai.settings.panelLabel'),
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Escape') return;
        e.preventDefault();
        el.scope.closePanel(el, s);
    },
    // Spacing token (~the old 320px) — hosts that must shrink below it (the
    // in-sidebar SettingsDrawer sheet) override minWidth: '0' at the mount.
    minWidth: 'G',
    maxWidth: '90vw',
    flow: 'y',
    gap: 'A',
    textAlign: 'left',
    AnswersSection: // No diagnostics fetch here any more: the per-provider diagnostics rendered
    // ONLY the deleted provider rows. The data path itself is untouched — the
    // model dropdown still refreshes it on its own open (AiModelSwitcherTrigger
    // onClick and the shell composer's ModelBtn onClick both call
    // `fetchAiProviderDiagnostics`), which is where the reason badges render.
    $2ef98c3dc247e0fc$var$AnswersSection,
    ScopeSection: $2ef98c3dc247e0fc$var$ScopeSection,
    PinSection: $2ef98c3dc247e0fc$var$PinSection,
    AuthSection: // ProviderSection is unmounted (2026-09-02 per Nika "move AI provider
    // section to model switcher both in AI prompt and sidebar") — the Local
    // agent row now lives in AiModelSwitcherBody, which both surfaces render.
    // The const stays declared below for hosts that still mount it by key.
    $2ef98c3dc247e0fc$var$AuthSection,
    VoiceSection: $2ef98c3dc247e0fc$var$VoiceSection,
    ReliabilitySection: $2ef98c3dc247e0fc$var$ReliabilitySection
};
var $2ef98c3dc247e0fc$export$2e2bcd8739ae039 = $2ef98c3dc247e0fc$export$3d3165a033703da9;

});

parcelRegister("6kXqC", function(module, exports) {

$parcel$export(module.exports, "AiSettingsButton", () => $49d2b591a24841bd$export$72aa8d31319df0c4);
// AiSettingsButton — THE single AI-settings trigger, shared by the assistant
// chat header (_simone/Chat.js — the composer row carries none since
// 2026-09-26) and the canvas prompt bar's ParamsBtn (workspace/app.js) — one
// glyph, one label, one behaviour
// (2026-08-12 per Nika "canvasPromptTextarea and ai assistant should be
// using same model switcher and settings buttons"). The PANEL was already
// shared (AiSettingsPanel — both surfaces mount the same body); this
// unifies the BUTTON that opens it.
//
// Context-aware open — one component, the right surface either side:
//   • inside a Chat surface (an ancestor carries `chatScope` — the same
//     walk as Chat.js chatScopeOf) it toggles root.showSettings, which
//     Chat's own Settings slot (SettingsDrawer → AiSettingsPanel) renders
//     over the assistant. Works on every Chat consumer, including the
//     plugin-less ones (standalone simone, chrome-connect, ext-ui).
//   • outside (the shell composer) it opens the @symbo.ls/dropdown panel
//     with the SAME AiSettingsPanel body anchored to the button — the
//     house openDropdown pattern.
const $49d2b591a24841bd$export$72aa8d31319df0c4 = {
    // Geometry + states come from the assistant chrome's one icon-button
    // primitive (36px pill, iconMd glyph, inactive→title ink, hover wash), so
    // this button is the same control in the drawer header, the composer bar
    // and the home composer's params slot. Only the icon and the behaviour
    // live here.
    extends: 'AssistantIconButton',
    // FA204 / frank trap — helpers live in scope, not module scope (they read
    // as undefined once this component is frank.toJSON'd for delivery).
    scope: {
        inChatSurface (el) {
            let n = el;
            while(n){
                if (n.chatScope) return true;
                n = n.parent;
            }
            return false;
        },
        toggleChatSettings (s) {
            if (s.root && s.root.update) s.root.update({
                showSettings: !s.root.showSettings
            });
        }
    },
    icon: 'preferences',
    title: (el)=>el.call('polyglot', 'ai.settings.panelLabel'),
    'aria-haspopup': 'menu',
    // Chat surface: pointer = onMousedown (survives the chrome re-render
    // dead-click window, worst under PageSlot churn); keyboard = detail-0
    // click. Guarded so one gesture can't double-toggle showSettings
    // (open-then-close = "AI settings doesn't open").
    onMousedown: (e, el, s)=>{
        if (e.button !== 0) return;
        if (!el.scope.inChatSurface(el)) return;
        el.scope.toggleChatSettings(s);
    },
    onClick: (e, el, s)=>{
        if (el.scope.inChatSurface(el)) {
            if (e.detail !== 0) return;
            el.scope.toggleChatSettings(s);
            return;
        }
        // Shell surface — the dropdown plugin owns positioning, outside-click
        // and ESC dismiss. The dropdown Panel is deliberately padding:0 (the
        // content owns its chrome — DropdownRoot.js), so the caller supplies
        // the panel's own padding here (the SettingsDrawer sheet pads via its
        // Sheet instead — same body, two hosts). Geometry matches THE AI menu
        // system (AiMenu.js AiMenuPanel): minWidth G / radiusCard / 60vh cap —
        // the same values the ModelBtn dropdown and the inline assistant panels
        // carry, so every AI menu is one shape.
        e.preventDefault();
        e.stopPropagation();
        el.call('openDropdown', {
            id: 'aiParams',
            anchorEl: el,
            placement: 'top-end',
            minWidth: 'G',
            maxHeight: '60dvh',
            round: 'radiusCard',
            // Shell paint opt-in — AiSettingsPanel's body paints no card of its
            // own (its rows carry their own pills); the plugin Panel is
            // chromeless by default (FW-DROPDOWN-PANEL-STALE-SHELL-PAINT-1).
            theme: 'canvas-card-glass',
            shadow: 'overlay',
            content: {
                extends: 'AiSettingsPanel',
                padding: 'Z'
            }
        });
    }
};

});

parcelRegister("kvJNN", function(module, exports) {

$parcel$export(module.exports, "AssistantIconButton", () => $eeea3b40410451ee$export$1614bb24898c0c64);
// AssistantIconButton — THE icon button of the assistant's chrome: the
// header actions (settings, dock, minimize, close) and the composer bar
// (upload, voice, settings). One primitive, one geometry, one set of states
// (Rule 65 / Rule 68 — the scale belongs here, never to a call site).
//
// Before this (2026-09-10 per Nika "fix ui and alignment in ai assistant —
// make design way more beautiful"): the header buttons were NavbarButtons at
// `padding: 'Y2'` (35px, 17px glyphs), the composer's were the same base at
// `padding: 'Y'` (27px, 15px glyphs), and the send button was a 38px circle
// — three sizes, three centre lines, in one panel.
//
// Brand grammar (brand-language, chrome register): a `controlHCompact` (36px)
// circle on `radiusPill`, the glyph at `iconMd` (20px), quiet `inactive` ink
// that steps to `title` on approach, the house `hover` wash (a fill step,
// never opacity), `selected` when pressed. Monochrome — hue never marks a
// chrome button. The tap-slop pseudo for touch is inherited from NavbarButton.
const $eeea3b40410451ee$export$1614bb24898c0c64 = {
    extends: [
        'NavbarButton',
        'AppControl'
    ],
    compact: true,
    boxSize: 'controlHCompact',
    minWidth: 'controlHCompact',
    boxSizing: 'border-box',
    padding: '0',
    round: 'radiusPill',
    align: 'center center',
    flexShrink: '0',
    theme: 'transparent',
    border: 'none',
    color: 'inactive',
    cursor: 'pointer',
    transition: 'A defaultBezier',
    transitionProperty: 'background-color, color',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    ':active': {
        background: 'selected',
        color: 'title'
    },
    Icon: {
        boxSize: 'iconMd',
        display: 'block',
        flexShrink: '0'
    }
};

});

parcelRegister("5Kt5i", function(module, exports) {

$parcel$export(module.exports, "AssistantSendButton", () => $42f7cf3037323736$export$c40df58f254a7656);
// AssistantSendButton — the composer's send control. Same circle as its
// sibling icon buttons (`controlHCompact`, so the whole composer bar sits on
// ONE centre line), two honest states declared on the primitive (Rule 65):
//
//   resting  — a quiet disc of the field's own ink (Rule 67's `color-mix` on
//              currentColor) with `inactive` ink: the button is present but
//              there is nothing to send yet. Measured live 2026-09-10: the
//              `overlayStrong` token painted rgba(20,20,22,.98) on the dark
//              field — a near-black disc on near-black, invisible.
//   ready    — `theme: 'primary'`, the brand's SOLID-INK action (white on the
//              dark shell, black on the light one). A hue fill never marks a
//              primary action in the chrome register.
//
// The mount site decides WHEN it is ready (`isReady`) and what happens on
// click; it never restates the geometry.
const $42f7cf3037323736$export$c40df58f254a7656 = {
    extends: 'NavbarButton',
    boxSize: 'controlHCompact',
    minWidth: 'controlHCompact',
    boxSizing: 'border-box',
    padding: '0',
    round: 'radiusPill',
    align: 'center center',
    flexShrink: '0',
    border: 'none',
    style: {
        background: 'color-mix(in srgb, currentColor 12%, transparent)'
    },
    color: 'inactive',
    cursor: 'default',
    transition: 'A defaultBezier',
    transitionProperty: 'background-color, color, transform',
    '.isReady': {
        theme: 'primary',
        cursor: 'pointer',
        ':hover': {
            transform: 'translateY(-1px)'
        },
        ':active': {
            transform: 'translateY(0)'
        }
    },
    Icon: {
        boxSize: 'iconMd',
        display: 'block',
        flexShrink: '0',
        color: 'inherit'
    }
};

});

parcelRegister("angsT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AiBridgeModal", () => $78d8d2fc32c29a41$export$fb129214da820adf);
$parcel$export(module.exports, "default", () => $78d8d2fc32c29a41$export$2e2bcd8739ae039);
// AiBridgeModal — the "connect your local AI" setup, as a shell-root MODAL
// OVERLAY rather than an inline card inside the AI-settings dropdown.
//
// Why a root-mounted modal and not inline: AiSettingsPanel renders inside the
// @symbo.ls/dropdown Panel, which uses `transform` + `overflow: auto`. A
// `position: fixed` child there is clipped/mis-positioned by that transformed
// ancestor, and growing the panel inline shifts the whole dropdown. Mounting
// this once at the shell root (beside ModalRoot/DropdownRoot in app.js) and
// gating it on `root._aiBridgeSetupOpen` gives a clean centered overlay with
// zero dropdown layout shift. Both AI-settings surfaces (canvas ParamsBtn
// dropdown + sidebar SettingsDrawer) just flip the flag.
//
// Reads bridge state off root (bridgeStatus / bridgeUrl / agent) and drives the
// local simone-bridge via the registered `configureBridge` function — same
// plumbing the old inline card used.
const $78d8d2fc32c29a41$export$fb129214da820adf = {
    // FA204 / frank trap — isLocal used to be a bare module-scope const read
    // from inside `if` (a serialized factory); it reads as undefined once this
    // component is frank.toJSON'd for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called via
    // `el.scope.isLocal`.
    scope: {
        isLocal: (s)=>(s.root.targetMode || 'general') === 'local',
        // THE close path — the veil, Escape and Done all run it. The `if:` gate
        // unmounts this element WITHOUT a lifecycle hook on this runtime
        // (measured: an if-flip fires only onInit, never onRemove), so focus goes
        // back to the opener here, through the kit's AppDialog lifecycle function
        // bound to the modal root.
        close (el, s) {
            s.root.update({
                _aiBridgeSetupOpen: false
            });
            const modal = typeof el.lookup === 'function' && el.lookup('AiBridgeModal') || el;
            if (modal && typeof modal.call === 'function') modal.call('appDialogSync', false);
        }
    },
    if: (el, s)=>!!s.root._aiBridgeSetupOpen && el.scope.isLocal(s),
    // A typed URL is a DRAFT in this modal's own state until the user connects.
    // The input used to write `root.bridgeUrl` on every keystroke — a shared
    // key the status line, the bridge and the catalog specimen all read (the
    // specimen caught it, 2026-09-24). Connect hands the draft to
    // `configureBridge`, which writes the root key itself. A draft the user
    // never connects is dropped with the modal.
    state: {
        draftUrl: '',
        draftTouched: false
    },
    tag: 'div',
    position: 'fixed',
    inset: '0',
    zIndex: '10600',
    // THE blocking veil (DESIGN_SPEC §6.3): the `backdrop` theme — the scrim
    // fill AND its blur — fading in as the modal mounts. It was the bare
    // `scrim` fill, no blur.
    theme: 'backdrop',
    animationName: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'both',
    align: 'center center',
    padding: 'overlayGutter',
    // The phone sheet touches the bottom edge.
    '@mobileL': {
        padding: '0',
        alignItems: 'flex-end'
    },
    onClick: (e, el, s)=>el.scope.close(el, s),
    // Escape closes the top-most overlay only: it stops here.
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        el.scope.close(el, s);
    },
    // Focus moves in on open (the kit's AppDialog lifecycle: the first field,
    // a frame later). Only a REAL open — a catalog specimen that mounts this
    // with `if: true` must not steal the page's focus.
    onInit: (el, s)=>{
        if (s.root && s.root._aiBridgeSetupOpen) el.call('appDialogSync', true);
    },
    // The centre sheet (§6.1): opaque `dialog`, `radiusSheet`, the `overlay`
    // elevation, `overlayMd` wide (was a raw 460px on the `modal` surface),
    // rising on the spring; the phone gets the bottom sheet.
    Sheet: {
        onClick: (e)=>e.stopPropagation(),
        role: 'dialog',
        ariaModal: 'true',
        ariaLabelledby: 'aiBridgeTitle',
        tabindex: '-1',
        onKeydown: (e, el)=>el.call('appDialogTrapTab', e),
        flow: 'y',
        gap: 'A',
        boxSizing: 'border-box',
        width: 'overlayMd',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'auto',
        padding: 'B',
        theme: 'dialog',
        round: 'radiusSheet',
        shadow: 'overlay',
        animationName: 'modalIn',
        animationDuration: 'D',
        animationTimingFunction: 'springBezier',
        animationFillMode: 'both',
        '@mobileL': {
            width: '100%',
            maxHeight: '92%',
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
            animationName: 'fadeInUpShort'
        },
        Header: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            Title: {
                tag: 'h3',
                id: 'aiBridgeTitle',
                text: '{{ ai.bridge.title | polyglot }}',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                margin: '0',
                flex: '1'
            },
            // The dismiss — the kit's tonal capsule in its compact step (was a
            // hand-built button on the `tertiary` theme).
            Close: {
                extends: 'AppCapsuleBtnToolbar',
                compact: true,
                text: '{{ ai.bridge.done | polyglot }}',
                onClick: (e, el, s)=>el.scope.close(el, s)
            }
        },
        Status: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            Dot: {
                boxSize: 'X',
                round: '50%',
                flexShrink: '0',
                // The status hue as its semantic pair (Rule 69) — the raw brand hues
                // fall under 3:1 as a mark on the light sheet.
                background: (el, s)=>{
                    const st = s.root.bridgeStatus;
                    if (st === 'open') return 'successInk';
                    if (st === 'connecting') return 'accentInk';
                    return 'dangerInk';
                }
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const st = s.root.bridgeStatus;
                    if (st === 'open') return 'Connected' + (s.root.agent ? " \xb7 " + s.root.agent : '');
                    if (st === 'connecting') return "Connecting\u2026";
                    return 'Not connected';
                }
            }
        },
        Steps: {
            tag: 'ol',
            margin: '0',
            padding: '0 0 0 A',
            color: 'caption',
            fontSize: 'Y',
            lineHeight: '1.6',
            Step1: {
                tag: 'li',
                text: '{{ ai.bridge.step1 | polyglot }}'
            },
            Step2: {
                tag: 'li',
                text: (el, s)=>'It listens for the workspace on ' + ((s.draftTouched ? s.draftUrl : s.root.bridgeUrl) || 'ws://localhost:8765') + '.'
            },
            Step3: {
                tag: 'li',
                text: '{{ ai.bridge.step3 | polyglot }}'
            }
        },
        // The shared field kit (components/AppField.js): AppField owns the
        // caption, AppInput the control surface; this field keeps the behaviour
        // only. `label` is a FUNCTION prop — the kit also names the control with
        // it, and an attribute never resolves a template.
        AppField: {
            label: (el)=>el.call('polyglot', 'ai.bridge.urlLabel'),
            AppInput: {
                type: 'text',
                placeholder: 'ws://localhost:8765',
                // the draft once the user types, else the saved URL; all three are
                // read on every run, so each one is tracked (FA515)
                value: (el, s)=>{
                    const saved = s.root.bridgeUrl;
                    const draft = s.draftUrl;
                    return (s.draftTouched ? draft : saved) || '';
                },
                onInput: (e, el, s)=>s.update({
                        draftUrl: e.target.value,
                        draftTouched: true
                    }, {
                        preventFetch: true
                    })
            }
        },
        Actions: {
            flow: 'x',
            gap: 'Z',
            align: 'center flex-end',
            // The one action — the kit's ink primary (was a hand-built button on
            // the `documentInverted` theme).
            Connect: {
                extends: 'AppCapsuleBtnPrimary',
                text: (el, s)=>s.root.bridgeStatus === 'open' ? 'Reconnect' : 'Connect',
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    try {
                        const url = (s.draftTouched ? s.draftUrl : s.root.bridgeUrl) || 'ws://localhost:8765';
                        el.call('configureBridge', url);
                    } catch (_) {}
                }
            }
        }
    }
};
var $78d8d2fc32c29a41$export$2e2bcd8739ae039 = $78d8d2fc32c29a41$export$fb129214da820adf;

});

parcelRegister("4bDXo", function(module, exports) {

$parcel$export(module.exports, "Chat", () => (parcelRequire("cYg7K")).Chat);
$parcel$export(module.exports, "chatScopeOf", () => (parcelRequire("cYg7K")).chatScopeOf);
$parcel$export(module.exports, "ck", () => (parcelRequire("cYg7K")).ck);
$parcel$export(module.exports, "ChatMessage", () => (parcelRequire("hLz4a")).ChatMessage);
$parcel$export(module.exports, "ChatCard", () => (parcelRequire("e6RpB")).ChatCard);
$parcel$export(module.exports, "ChatSourceChip", () => (parcelRequire("kYbJX")).ChatSourceChip);
$parcel$export(module.exports, "ChatConfidenceFactor", () => (parcelRequire("e6Lsf")).ChatConfidenceFactor);
$parcel$export(module.exports, "ChatMarkdown", () => (parcelRequire("18vPj")).ChatMarkdown);
$parcel$export(module.exports, "collapseCodeFences", () => (parcelRequire("18vPj")).collapseCodeFences);
$parcel$export(module.exports, "ToolCallCard", () => (parcelRequire("1yK8J")).ToolCallCard);
$parcel$export(module.exports, "ChatToolRow", () => (parcelRequire("kHf3q")).ChatToolRow);
$parcel$export(module.exports, "ChatToolStepLabel", () => (parcelRequire("kHf3q")).ChatToolStepLabel);
$parcel$export(module.exports, "ChatToolStep", () => (parcelRequire("8JqaR")).ChatToolStep);
$parcel$export(module.exports, "SimoneReasoningPill", () => (parcelRequire("k4ef8")).SimoneReasoningPill);
$parcel$export(module.exports, "AiBubbleStack", () => (parcelRequire("7aO1X")).AiBubbleStack);
$parcel$export(module.exports, "AiCaptionBubble", () => (parcelRequire("7aO1X")).AiCaptionBubble);
$parcel$export(module.exports, "AiAsk", () => (parcelRequire("ewdVg")).AiAsk);
$parcel$export(module.exports, "SimoneSuggestions", () => (parcelRequire("hNbPv")).SimoneSuggestions);
$parcel$export(module.exports, "AssistantStarter", () => (parcelRequire("3uNNz")).AssistantStarter);
$parcel$export(module.exports, "AssistantStarterList", () => (parcelRequire("3uNNz")).AssistantStarterList);
$parcel$export(module.exports, "ToolTerminal", () => (parcelRequire("4zGmN")).ToolTerminal);
$parcel$export(module.exports, "SessionMenu", () => (parcelRequire("aOHSJ")).SessionMenu);
$parcel$export(module.exports, "ConnectionBadge", () => (parcelRequire("7jzAZ")).ConnectionBadge);
$parcel$export(module.exports, "SettingsDrawer", () => (parcelRequire("6gOkc")).SettingsDrawer);
$parcel$export(module.exports, "detectAgentMention", () => (parcelRequire("fC1oY")).detectAgentMention);
$parcel$export(module.exports, "spliceAt", () => (parcelRequire("fC1oY")).spliceAt);
$parcel$export(module.exports, "agentInsertText", () => (parcelRequire("fC1oY")).agentInsertText);
$parcel$export(module.exports, "agentRoster", () => (parcelRequire("fC1oY")).agentRoster);
$parcel$export(module.exports, "agentsFromMongo", () => (parcelRequire("fC1oY")).agentsFromMongo);
$parcel$export(module.exports, "filterAgentsForMention", () => (parcelRequire("fC1oY")).filterAgentsForMention);
// Re-export the simone chat components for use as the workspace AI
// drawer. Single source of truth: extensions/packages/simone owns
// the Chat / ChatMessage / ChatMarkdown / SessionMenu / TargetPicker /
// PickedContextChip / ConnectionBadge components; this file just
// surfaces them inside workspace's shared component registry so
// app.js can mount them by bare-key auto-extend.
//
// The simone surface reads state keys we DON'T own:
//   bridgeStatus, bridgeUrl, agent, chatInput, chatMessages,
//   chatTyping, picking, pickedElements, showSettings,
//   currentAssistantId, sessions, activeSessionId, target,
//   targetSelected, targetOptions, targetDraft*, cliAuth,
//   cloudWorkspaces, recentPairings, currentOrigin
// These are declared in workspace/state-app.js with workspace-safe
// defaults (bridgeStatus: 'open' so the composer is enabled even
// though we don't have a real bridge — sdk.ai is our transport).
//
// The simone surface dispatches via window.__simoneSendOverBridge.
// workspace installs an adapter at shell boot (functions/simoneAiTransport)
// that wires that handle through sdk.ai.dispatch so the user's picker
// selection (simone/providers/local) is honored.
// VENDORED from extensions/packages/simone/symbols/components/ into
// ./_simone/. simone is `private: true` (never published), so the bare
// `@symbo-ls/simone/...` import resolved only via the local monorepo
// symlink — it broke the CI `smbls build` (workspace checks out alone),
// which fast-failed every dev.my deploy. In-tree relative imports keep
// esbuild's symlink-preserving resolver on the workspace tree AND build
// in CI. Re-sync ./_simone/ from simone source if those components change.

var $cYg7K = parcelRequire("cYg7K");

var $hLz4a = parcelRequire("hLz4a");

var $e6RpB = parcelRequire("e6RpB");

var $kYbJX = parcelRequire("kYbJX");

var $e6Lsf = parcelRequire("e6Lsf");

var $18vPj = parcelRequire("18vPj");

var $1yK8J = parcelRequire("1yK8J");

var $kHf3q = parcelRequire("kHf3q");

var $8JqaR = parcelRequire("8JqaR");

var $k4ef8 = parcelRequire("k4ef8");

var $7aO1X = parcelRequire("7aO1X");

var $ewdVg = parcelRequire("ewdVg");

var $hNbPv = parcelRequire("hNbPv");

var $3uNNz = parcelRequire("3uNNz");

var $4zGmN = parcelRequire("4zGmN");

var $aOHSJ = parcelRequire("aOHSJ");

var $7jzAZ = parcelRequire("7jzAZ");

var $6gOkc = parcelRequire("6gOkc");

var $fC1oY = parcelRequire("fC1oY");

});
parcelRegister("cYg7K", function(module, exports) {

$parcel$export(module.exports, "chatScopeOf", () => chatScopeOf);
$parcel$export(module.exports, "ck", () => ck);
$parcel$export(module.exports, "Chat", () => Chat);
// THE house keyboard model for menus (arrow cycle, focus-in-on-open,
// focus-back-on-close) — ../../functions/menuKeyboard.js. Held as scope
// VALUES below, never read as bare identifiers from inside a factory: a
// frank.toJSON lift drops those (the FA204 trap this whole file is organised
// around).

var $3CWNx = parcelRequire("3CWNx");

var $m13h3 = parcelRequire("m13h3");

var $5e5Ez = parcelRequire("5e5Ez");
const chatScopeOf = (el)=>{
    let n = el;
    while(n){
        if (n.chatScope) return n.chatScope;
        n = n.parent;
    }
    return 'general';
};
const ck = (el, base)=>{
    let n = el;
    let scope = 'general';
    while(n){
        if (n.chatScope) {
            scope = n.chatScope;
            break;
        }
        n = n.parent;
    }
    return scope === 'addapp' ? '_ax_' + base : scope === 'dashboard' ? '_db_' + base : base;
};
const Chat = {
    // FA204 / frank trap — every helper below (ensureAgentRoster,
    // detectAgentMention, mentionAgents, agentInsertText, resizeComposerTextarea,
    // voiceHostingChat, refreshMentionPicker, pickMentionAgent, send,
    // isComposerSendDisabled, plus DUPLICATE copies of chatScopeOf/ck) used to be
    // bare module-scope const/function read from inside this component's own
    // factories/handlers (onCreate, Header.*, Messages.*, ComposerWrap.*); they
    // read as undefined once this component is frank.toJSON'd for platform
    // delivery. Moved into `scope`, called via `el.scope.<name>` from factories
    // and `this.<name>` between sibling scope methods (object-literal properties
    // can't see each other as bare identifiers). `chatScopeOf`/`ck` ALSO stay
    // exported at module scope (dual-mode, same idiom as AppOrgSwitcher's
    // `__orgSwitcherInternals`) because assistantSimone.js re-exports them bare
    // (`export { chatScopeOf, ck } from './_simone/Chat.js'`) for the published
    // component surface — the scope copies here are what this component's own
    // tree actually calls.
    scope: {
        // ── menu keyboard model (Sessions history dropdown) ──────────────────
        // THE shared implementation (functions/menuKeyboard.js) — the same three
        // helpers the AI model switcher and the composer '+' menu use, so every
        // menu in the assistant answers the same keys.
        navRows: (0, $3CWNx.menuArrowNav),
        focusBack: (0, $3CWNx.restoreMenuFocus),
        nodeVisible: (0, $3CWNx.menuNodeVisible),
        // Plain scope VALUE, and the `when` gate is passed at the CALL SITE: a
        // scope METHOD that called the imported `menuFocusOnOpen` by its bare
        // name would read as undefined after a frank to-json lift
        // (`unresolvable-identifier` — the same trap AiModelSwitcherBody's
        // catalogRows note records). The panel stays MOUNTED and hides with
        // `visibility: hidden` (the AiMenuPanel motion recipe), and a
        // visibility-hidden node cannot take focus — so the open poll must wait
        // for the paint instead of firing once and missing.
        focusOnOpen: (0, $3CWNx.menuFocusOnOpen),
        // Plain scope VALUE (see focusOnOpen): the workspace/org name the empty
        // state's Hint and Sub address. Self-contained in its own module, so the
        // lift keeps it whole.
        scopeName: (0, $m13h3.assistantScopeName),
        // The empty state's status line: while this workspace's own starter set
        // is being written, the line that says so; '' otherwise (the list head
        // then shows its micro-label). Reads `root.lang` so a language switch
        // re-runs the factories that call it. Self-contained apart from the
        // `scopeName` VALUE above, reached through `el.scope` like a factory.
        startersStatus (el, s) {
            const root = s && s.root;
            root && root.lang;
            const name = el.scope.scopeName(root);
            if (!name || !root || !root._aiStartersPending) return '';
            return el.call('polyglot', 'ai.chat.subGenerating').replace('{workspace}', name);
        },
        // ── @-agent mention (composer autocomplete) ──────────────────────────
        // Typing `@name` in the composer opens an agent picker; picking one
        // directs the thread to that agent (root _targetAgentId/_targetAgentName
        // — the existing persona-swap plumbing). Tested spec: ./mention.js (kept
        // in sync).
        // Resolve this Chat instance's scope by walking up for `chatScope` — the
        // same idiom as `ck` below (kept independent so a caller that only needs
        // the scope string doesn't need the base-key logic).
        chatScopeOf (el) {
            let n = el;
            while(n){
                if (n.chatScope) return n.chatScope;
                n = n.parent;
            }
            return 'general';
        },
        // Self-contained (does NOT call the sibling `chatScopeOf` method): frank
        // serializes component prop functions and rewrites their free vars to
        // __scope.X, but it does NOT recursively rewrite free vars inside hoisted
        // HELPER bodies, so a helper calling another helper across that boundary
        // used to throw at runtime in frank/brender consumers. Inlining the scope
        // walk keeps `ck` self-contained regardless. (See tickets/smbls.md: frank
        // should rewrite hoisted helper bodies too.)
        ck (el, base) {
            let n = el;
            let scope = 'general';
            while(n){
                if (n.chatScope) {
                    scope = n.chatScope;
                    break;
                }
                n = n.parent;
            }
            return scope === 'addapp' ? '_ax_' + base : scope === 'dashboard' ? '_db_' + base : base;
        },
        // Detect an @-mention token in `value` at `caret`. Returns
        // {query,start,end}|null.
        detectAgentMention (value, caret) {
            if (caret == null || !value) return null;
            const upto = value.slice(0, caret);
            const at = upto.lastIndexOf('@');
            if (at < 0) return null;
            if (at > 0 && !/\s/.test(value[at - 1])) return null;
            const after = upto.slice(at + 1);
            if (!/^[a-zA-Z0-9._\- ]*$/.test(after)) return null;
            return {
                query: after,
                start: at,
                end: caret
            };
        },
        agentDisplayName: // An agent's name in the active interface language (core-wl's rule,
        // workspace 075f2e7e5: the record's metadata.nameI18n for the language,
        // else its own name) — the shared helper held as a scope VALUE and reached
        // through `this.` (FA204: a bare imported identifier would not survive a
        // frank lift).
        $5e5Ez.agentDisplayName,
        agentLabel (a, lang) {
            return this.agentDisplayName({
                name: a && a.name || '',
                metadata: {
                    nameI18n: a && a.nameI18n
                }
            }, lang);
        },
        // Addressable agents on root (from _agents + people, deduped), filtered by
        // query — the record name, the name shown in `lang`, or the handle.
        mentionAgents (root, query, lang) {
            const seen = new Set();
            const roster = [];
            for (const a of [
                ...root && root._agents || [],
                ...root && root.people || []
            ]){
                if (!a || !a.userId || !(a.kind === 'agent' || a.isAgent)) continue;
                const key = String(a.userId);
                if (seen.has(key)) continue;
                seen.add(key);
                roster.push(a);
            }
            const q = String(query || '').trim().toLowerCase();
            const matched = q ? roster.filter((a)=>{
                const name = String(a.name || '').toLowerCase();
                const shown = String(this.agentLabel(a, lang) || '').toLowerCase();
                const handle = String((a.email || '').split('@')[0] || '').toLowerCase();
                return name.includes(q) || shown.includes(q) || handle.includes(q);
            }) : roster;
            return matched.slice(0, 8);
        },
        // The @handle to insert for a picked agent.
        agentInsertText (agent) {
            if (!agent) return '';
            const handle = (agent.email || '').split('@')[0] || agent.name;
            return handle ? `@${handle} ` : '';
        },
        // Recompute the composer's @-mention picker from the live textarea + draft.
        // Writes root._simoneAgentPicker (or clears it).
        refreshMentionPicker (el, s) {
            // Ensure the roster is (being) loaded — covers the case where the
            // composer mounted before the SDK attached to the root element. Idempotent.
            this.ensureAgentRoster(el, s);
            const node = el.node;
            const value = node && node.value || s.draft || '';
            const caret = node && node.selectionStart != null ? node.selectionStart : value.length;
            const trig = this.detectAgentMention(value, caret);
            const options = trig ? this.mentionAgents(s.root, trig.query, el.call('getActiveLang')) : [];
            if (!trig || !options.length) {
                if (s.root._simoneAgentPicker) s.root.update({
                    _simoneAgentPicker: null
                });
                return null;
            }
            const picker = {
                query: trig.query,
                start: trig.start,
                end: trig.end,
                options: options,
                activeIndex: 0
            };
            s.root.update({
                _simoneAgentPicker: picker
            });
            return picker;
        },
        // THIS composer's draft state (PromptTextarea's own state bag) from any
        // element inside the composer band — the picker's rows live beside the
        // composer box, not inside it. null outside a composer.
        mentionDraftState (el) {
            const wrap = el && typeof el.lookup === 'function' ? el.lookup('ComposerWrap') : null;
            const box = wrap && typeof wrap.lookdown === 'function' ? wrap.lookdown('PromptTextarea') : null;
            return box && box.state || null;
        },
        // Commit a picked agent: splice `@handle` into the draft, direct the thread
        // to the agent, close the picker. `s` is the PromptTextarea state (carries draft).
        pickMentionAgent (el, s, agent) {
            const picker = s.root._simoneAgentPicker;
            if (!picker || !agent) return;
            const insert = this.agentInsertText(agent);
            const draft = s.draft || '';
            s.update({
                draft: draft.slice(0, picker.start) + insert + draft.slice(picker.end)
            });
            s.root.update({
                _simoneAgentPicker: null,
                _targetAgentId: agent.userId,
                // the name the user saw in the picker (the active language)
                _targetAgentName: this.agentLabel(agent, el.call('getActiveLang')) || agent.name
            });
        },
        // Best-effort hydrate of the agent roster for the @-mention picker — the
        // general drawer doesn't mount team-and-agents (which normally fills
        // root._agents). Idempotent via root._agentsLoaded (the SAME guard
        // team-and-agents uses, so they never double-load). Transforms the SDK's
        // Mongo agents to the picker shape inline (tested equivalent:
        // agentsFromMongo in ./mention.js).
        //
        // FALSE-ZERO-1 surface 4: this used to write `_agents` ONLY when the
        // resolved list was non-empty, and swallow the failure path into a bare
        // `root._agentsLoaded = false` reset — so `root._agents === undefined`
        // meant BOTH "this workspace genuinely has zero agents" AND "the load
        // failed", and every consumer ("Your agents" widget, tickets
        // assignables) rendered that ambiguity as a confident "0". Fixed at the
        // producer: ALWAYS write `_agents` on success (`[]` included — a real,
        // verified zero must still render as zero), and record a failure into
        // the declared `_agentsError` key instead of swallowing it, so a failed
        // load stays distinguishable from a genuine empty roster.
        ensureAgentRoster (el, s) {
            const root = s && s.root;
            if (!root || root._agentsLoaded) return;
            // The SDK lives on the ROOT element (el.sdk isn't set on the composer).
            const rootEl = el && el.getRoot && el.getRoot();
            const sdk = rootEl && rootEl.sdk || el && el.sdk;
            const orgId = root.jwtClaims && root.jwtClaims.workspace_org_id;
            if (!sdk || typeof sdk.listAgents !== 'function' || !orgId) return;
            root._agentsLoaded = true;
            Promise.resolve(sdk.listAgents(orgId)).then((raw)=>{
                const list = Array.isArray(raw) ? raw : raw && raw.data || [];
                const agents = list.map((u)=>({
                        id: String(u.username || u.id || u._id || '').toLowerCase(),
                        name: u.name || u.username || 'Agent',
                        kind: 'agent',
                        avatar: u.avatar || null,
                        userId: u.id || u._id || null,
                        email: u.email || null,
                        // the per-language names of a server-seeded agent (agentLabel)
                        nameI18n: u.metadata && u.metadata.nameI18n || null
                    })).filter((a)=>a.userId);
                // Always write — [] is a real, verified zero, not a dropped read.
                root.update({
                    _agents: agents,
                    _agentsError: null
                });
            }).catch((err)=>{
                root._agentsLoaded = false;
                root.update({
                    _agentsError: err && err.message || 'Failed to load agents'
                });
            });
        },
        // T18 — is THIS chat composer the live voice host? True while voice is open
        // and root.voiceHost names the chat composer (the VoiceBtn writes it before
        // voicePttPress — full contract in shared/components/VoiceStrip.js; the
        // voiceMinimized axis is deliberately ignored while a composer hosts).
        voiceHostingChat (s) {
            return !!(s && s.root && s.root.voiceOpen && s.root.voiceHost === 'chat');
        },
        isComposerSendDisabled (el, s) {
            return !s.root || s.root.bridgeStatus !== 'open' || !((s.draft || '') + '').trim();
        },
        resizeComposerTextarea (node) {
            if (!node) return;
            const hasText = !!node.value;
            node.style.whiteSpace = hasText ? 'pre-wrap' : 'nowrap';
            node.style.height = 'auto';
            if (!hasText) {
                node.style.overflowY = 'hidden';
                return;
            }
            const maxHeight = window.innerHeight * 0.35;
            node.style.height = Math.min(node.scrollHeight, maxHeight) + 'px';
            node.style.overflowY = node.scrollHeight > maxHeight ? 'auto' : 'hidden';
        },
        // Read the PromptTextarea draft from state, hand it to the active transport
        // via `sendPrompt` (carrying this Chat's scope so /add-app dispatches
        // project-scoped), then clear the draft + collapse the auto-grown field.
        // Shared by the Textarea Enter handler and the floating send Button; both
        // inherit PromptTextarea.state, so `s` is that state and `s.update` writes
        // back. No-ops while the bridge is closed.
        // `s.images` is this composer's own attachment bag — UploadBtn below writes
        // into it, and it is the SAME state object the draft lives on. It rides the
        // send as sendPrompt's third argument (workspace/functions/_simone/
        // sendPrompt.js), which normalizes + caps it into the envelope's
        // `attachments`. Cleared with the draft: the turn owns them now.
        send (el, s) {
            const text = ((s.draft || '') + '').trim();
            const images = Array.isArray(s.images) ? s.images : [];
            if (!text || s.root.bridgeStatus !== 'open') return;
            const scope = this.chatScopeOf(el);
            // THE ASK ROUTER (workspace functions/assistantAskRoute.js
            // assistantAskHandoff): an ask that clearly wants another surface — a
            // page, an app, slides, a website, the tour — goes there; every other
            // ask stays in this chat. Only the general chat routes, and never an ask
            // with images (they ride this chat's own send).
            const fns = el.context && el.context.functions;
            const routed = scope === 'general' && !images.length && !!fns && typeof fns.assistantAskHandoff === 'function' && !!el.call('assistantAskHandoff', text, {
                from: 'sidebar'
            });
            if (!routed) el.call('sendPrompt', text, scope, images);
            s.update({
                draft: '',
                images: []
            });
            // setAttribute('value','') only resets the default-value attr — reset the
            // live node and collapse the height the onInput auto-grow left behind.
            const ta = el.node?.tagName === 'TEXTAREA' ? el.node : el.parent?.Textarea?.node;
            if (ta) {
                ta.value = '';
                this.resizeComposerTextarea(ta);
            }
        }
    },
    flow: 'y',
    width: '100%',
    height: '100%',
    // In the workspace drawer (root.workspaceEmbed) the chat is a docked
    // SHEET: `common-box`, the surface of the AppDialog panel, so cards and the
    // `card` tooltip step above it — 1.13:1 light, 1.19:1 dark. It painted the
    // page GROUND, `document`, which in light IS the card fill: a tooltip over
    // the drawer read 1.00:1, separated only by its shadow (tooltips lane,
    // 2026-09-24). Standalone (the extension panels) the chat IS the page, so
    // it keeps the ground.
    theme: (el, s)=>s.root && s.root.workspaceEmbed ? 'common-box' : 'document',
    // Anchors the Settings layer (Chat.Settings → SettingsDrawer, absolute
    // inset 0) to the assistant surface itself — in the docked workspace drawer
    // the settings sheet renders over the sidebar, attached to its trigger,
    // instead of floating viewport-centered over the page content.
    position: 'relative',
    // 'general' (drawer + bottom composer, workspace-scoped) | 'addapp' (the
    // /add-app builder, project-scoped per extension). Set by the host mount;
    // namespaces this Chat's per-context state via el.scope.ck() (see top of file).
    chatScope: 'general',
    // On mount, pull the member's server conversation history so PREVIOUS chats
    // load. The workspace never wired this — hydrateServerSessions only ran after a
    // turn (refreshSessionsAfterTurn), so prior conversations never appeared on
    // open. Runs on the live Chat element (has the SDK); hydrate scopes the SDK to
    // the active workspace itself, so it's timing-safe.
    // …then restore the thread that was OPEN before the page went away
    // (SIMONE-INFLIGHT-TURN-NO-PERSISTENCE-1). activeSessionId/chatMessages are
    // in-memory root state, so every reload — F5, a parcel HMR refresh, a crash,
    // the AppOrgSwitcher org-switch fallback — used to reset the panel to an empty
    // chat even though the server still held the conversation, and a turn that was
    // mid-approval vanished without a trace. `restoreActiveThread` re-reads the
    // remembered thread from the server (never a browser copy of the transcript)
    // and, when the reload killed a live turn, adds one honest notice row. Chained
    // after hydrate so the thread list and the open thread agree; the host that
    // has no such function (standalone simone) just no-ops.
    onCreate: (el)=>{
        const scope = el.scope.chatScopeOf(el);
        try {
            const hydrated = el.call('hydrateServerSessions', scope);
            const restore = ()=>{
                try {
                    el.call('restoreActiveThread', scope);
                } catch (_) {
                /* no restore fn (standalone) → panel opens empty, as before */ }
            };
            if (hydrated && typeof hydrated.then === 'function') hydrated.then(restore, restore);
            else restore();
        } catch (_) {
        /* local / no SDK → keep local sessions */ }
    },
    // Borderless header. Title (left, flexShrink 0) | spacer | Actions (right,
    // flexShrink 0). Target switching lives in the SettingsDrawer (the header's
    // SettingsBtn — the composer row carries none since 2026-09-26), not in a
    // header pill.
    Header: {
        tag: 'header',
        position: 'relative',
        flow: 'x',
        align: 'center',
        // Compact bar (2026-09-02 per Nika "make sidebar header more compact"):
        // one token step down on every gauge — gap A→Z, padding Z A→Y Z — the
        // same treatment the PageSlot header compaction took. The controls keep
        // their own hit areas; only the bar's outer air shrinks.
        gap: 'Z',
        padding: 'Y Z',
        // A COLOUR name in a THEME slot emits NOTHING — the mirror of the
        // `background: '<theme-name>'` miss. `overlay` is a colour token
        // (designSystem/color.js), not a theme, and `getMediaTheme` on an unknown
        // name returns undefined, so this element rendered with ZERO classes:
        // measured 2026-09-22 against the real pipeline, not a wrong fill — no
        // fill. Reported as "overlays without bg" (Nika, my.symbols.app); the
        // shell mounts this Chat wholesale inside AssistantDrawer. `background:`
        // is the slot that resolves the token, to `var(--color-overlay)`.
        background: 'overlay',
        flexShrink: '0',
        Title: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            flexShrink: '0',
            // Logo. ext-ui overrides onClick to deep-link the active session into
            // symbols.app; standalone / workspace leave it inert.
            Icon: {
                icon: 'logov2',
                boxSize: 'A1',
                color: 'title'
            },
            // Sessions history dropdown — AppOrgSwitcher-style Trigger + Menu,
            // anchored to the left cluster. Replaces the old toggle button + the
            // separate top-level SessionMenu slot.
            Sessions: {
                position: 'relative',
                flow: 'x',
                align: 'center',
                Trigger: {
                    tag: 'button',
                    type: 'button',
                    flow: 'x',
                    gap: 'Z',
                    align: 'center',
                    padding: 'Y2 Z2',
                    round: 'radiusControl',
                    theme: 'tertiary',
                    color: 'title',
                    fontWeight: '500',
                    cursor: 'pointer',
                    border: 'none',
                    background: 'transparent',
                    // House trigger states — hover wash at rest, `selected` while the
                    // menu is open (the BoardMenu MenuTrigger / AiModelSwitcherTrigger
                    // recipe), so every AI menu trigger reads identically.
                    ':hover': {
                        background: 'hover'
                    },
                    isOpen: (el, s)=>!!s.root.showSessionMenu,
                    '.isOpen': {
                        background: 'selected'
                    },
                    // Menu-button ARIA + keyboard contract (2026-09-02). ArrowDown /
                    // ArrowUp open the history menu; Enter and Space need no branch,
                    // because this is a real <button> and both already fire onClick.
                    ariaHaspopup: 'menu',
                    ariaExpanded: (el, s)=>s.root.showSessionMenu ? 'true' : 'false',
                    ariaLabel: (el)=>el.call('polyglot', 'ai.chat.history'),
                    onKeydown: (e, el, s)=>{
                        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
                        e.preventDefault();
                        e.stopPropagation();
                        if (!s.root.showSessionMenu) s.root.update({
                            showSessionMenu: true
                        });
                    },
                    // The current thread's name. It was cut in JS to 24 characters
                    // plus a literal "…" — a cut no language or width could undo, and
                    // the name was then nowhere in full. Now the whole name is the
                    // text, one line bounded by the `F` measure, and the full name is
                    // the `title` (the overflow law, HOME_AMBIENT_SKIN_SPEC §3b rule 8:
                    // one-line text keeps its ellipsis only with the whole text there).
                    Label: {
                        tag: 'span',
                        maxWidth: 'F',
                        minWidth: '0',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        title: (el, s)=>{
                            const cur = (s.root.sessions || {})[s.root.activeSessionId];
                            return cur && cur.title || el.call('polyglot', 'ai.chat.newChat');
                        },
                        text: (el, s)=>{
                            const cur = (s.root.sessions || {})[s.root.activeSessionId];
                            return cur && cur.title || el.call('polyglot', 'ai.chat.newChat');
                        }
                    },
                    // Caret flips while open — static transition on transform only
                    // (never on a reactive background — MenuPanel.js note).
                    Caret: {
                        extends: 'Icon',
                        name: 'arrow angle down',
                        boxSize: 'Z',
                        opacity: '.6',
                        transition: 'A defaultBezier',
                        transitionProperty: 'transform',
                        isOpen: (el, s)=>!!s.root.showSessionMenu,
                        '.isOpen': {
                            transform: 'rotate(180deg)'
                        }
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        s.root.update({
                            showSessionMenu: !s.root.showSessionMenu
                        });
                    }
                },
                Menu: {
                    // THE shared AiMenuPanel (AiMenu.js): glass surface, radiusCard,
                    // borderless, 60vh scroll cap AND the house open/close motion
                    // (hidden base + `.isOpen` conditional block, `A defaultBezier`)
                    // all come from the base — only the anchor positioning and the
                    // isOpen predicate live here, so this panel, the model picker and
                    // the composer dropdowns are one shape by construction.
                    extends: 'AiMenuPanel',
                    isOpen: (el, s)=>!!s.root.showSessionMenu,
                    position: 'absolute',
                    top: '110%',
                    left: '0',
                    zIndex: '200',
                    // Keyboard (2026-09-02): one `role="menu"` over the whole panel, so
                    // the arrow cycle runs "New chat" → every session row and wraps —
                    // `menuArrowNav` collects `[role="menuitem"]` in DOM order, and the
                    // New-chat button carries that role too. Rows are native <button>s,
                    // so Enter/Space already activate them. `tabindex: -1` makes the
                    // panel a programmatic focus target only (never a tab stop), which
                    // is what lets Escape reach this handler when the session list is
                    // empty: DOMQL's keydown delegate walks the ancestor chain of
                    // `event.target`, so a menu nothing inside it ever focused would
                    // never receive the keystroke at all.
                    role: 'menu',
                    tabindex: '-1',
                    ariaLabel: (el)=>el.call('polyglot', 'ai.chat.history'),
                    subscribeTo: [
                        'showSessionMenu'
                    ],
                    onClick: (e)=>e.stopPropagation(),
                    onKeydown: (e, el, s)=>{
                        if (el.scope.navRows(e, el.node)) return;
                        if (e.key === 'Escape') {
                            e.preventDefault();
                            e.stopPropagation();
                            if (s.root && s.root.update) s.root.update({
                                showSessionMenu: false
                            });
                            el.scope.focusBack(el);
                            return;
                        }
                        // Tab leaves the menu: close on the way out, but drop the stored
                        // return target first so the close edge does not pull focus back
                        // to the trigger and fight the Tab.
                        if (e.key === 'Tab') {
                            el._menuReturnFocusTo = null;
                            if (s.root && s.root.showSessionMenu) s.root.update({
                                showSessionMenu: false
                            });
                        }
                    },
                    // iPad: the thread-row context menu (Star / Remove) is unreachable by
                    // touch — arm the shared long-press shim at the menu root; the
                    // synthetic contextmenu bubbles from the touched row, so one arm
                    // covers every session row. Idempotent per node.
                    // The focus arm rides the SAME hook (edge-detected inside
                    // menuFocusOnOpen, so an unrelated re-render never re-yanks focus).
                    onRender: (el, s)=>{
                        el.call('armLongPress');
                        el.scope.focusOnOpen(el, !!s.root.showSessionMenu, {
                            when: (node)=>el.scope.nodeVisible(node)
                        });
                    },
                    onUpdate: (el, s)=>el.scope.focusOnOpen(el, !!s.root.showSessionMenu, {
                            when: (node)=>el.scope.nodeVisible(node)
                        }),
                    // Outside-press closes the session menu. FA503: the framework owns
                    // this document listener — one registration per element, removed in
                    // dispose(), and no `el._docClickGuard` field to keep the two hooks
                    // in step.
                    onDocumentMousedown: {
                        capture: true,
                        handler: (ev, el)=>{
                            const node = el && el.node;
                            if (!node || node.contains(ev.target)) return;
                            const root = el.state && el.state.root;
                            if (root && root.showSessionMenu) root.update({
                                showSessionMenu: false
                            });
                        }
                    },
                    HeaderRow: {
                        flow: 'x',
                        align: 'center space-between',
                        // Horizontal 0 — the heading self-insets to the rows' Z1 text
                        // edge (AiMenuHeading paddingLeft) and the NewBtn's right edge
                        // aligns with the option rows' right edge.
                        padding: 'Y 0',
                        gap: 'Y',
                        // THE shared menu caption (AiMenu.js) — one heading treatment
                        // across the Sessions menu, model menu and AI settings sections.
                        Label: {
                            extends: 'AiMenuHeading',
                            text: '{{ ai.chat.historyHeading | polyglot }}'
                        },
                        NewBtn: {
                            tag: 'button',
                            type: 'button',
                            // First stop in the panel's arrow cycle — `menuArrowNav` walks
                            // `[role="menuitem"]` in DOM order, and "New chat" is the first
                            // actionable control in this panel.
                            role: 'menuitem',
                            flow: 'x',
                            gap: 'X',
                            align: 'center',
                            padding: 'Y2 Z',
                            round: 'radiusControl',
                            theme: 'tertiary',
                            border: 'none',
                            cursor: 'pointer',
                            color: 'title',
                            fontSize: 'Z1',
                            ':hover': {
                                background: 'hover'
                            },
                            // Z, not Y — at Y (~6.5px) the plus glyph rendered as a bare
                            // dot next to the label (verified live 2026-08-13).
                            Plus: {
                                extends: 'Icon',
                                name: 'plus',
                                boxSize: 'Z'
                            },
                            Lbl: {
                                tag: 'span',
                                text: '{{ ai.chat.newChat | polyglot }}'
                            },
                            onClick: (e, el, s)=>{
                                e.stopPropagation();
                                try {
                                    el.call('newSession', el.scope.chatScopeOf(el));
                                } catch (_) {}
                                if (s.root && s.root.update) s.root.update({
                                    showSessionMenu: false
                                });
                            }
                        }
                    },
                    List: {
                        flow: 'y',
                        gap: 'V',
                        children: (el, s)=>{
                            const sess = s.root.sessions || {};
                            return Object.keys(sess).filter((id)=>id && id !== 'null' && id !== 'undefined' && sess[id] && typeof sess[id] === 'object').map((id)=>sess[id])// Starred (pinned) threads float to the top, then most-recent.
                            .sort((a, b)=>{
                                const ap = a.pinned ? 1 : 0;
                                const bp = b.pinned ? 1 : 0;
                                if (ap !== bp) return bp - ap;
                                return (b.ts || 0) - (a.ts || 0);
                            });
                        },
                        childrenAs: 'state',
                        // Session row — the system's row metrics (AiMenu.js AiOptionRow:
                        // Y/Z1 padding, radiusControl, 44pt coarse floor) with the
                        // session-specific anatomy (star / title / time / ⋮). Active =
                        // the house `selected` wash + `title` ink — same recipe as the
                        // model + settings option rows. No `transition` on the reactive
                        // background (MenuPanel.js note).
                        childExtends: {
                            tag: 'button',
                            type: 'button',
                            // Arrow-cycle marker (the panel's own role="menu" walks these);
                            // `aria-current` names the thread that is already open, the
                            // same fact the `selected` wash carries visually.
                            role: 'menuitem',
                            ariaCurrent: (el, s)=>s.id === s.root.activeSessionId ? 'true' : null,
                            flow: 'x',
                            align: 'center space-between',
                            width: '100%',
                            gap: 'Z',
                            padding: 'Y Z1',
                            round: 'radiusControl',
                            fontSize: 'Z1',
                            border: 'none',
                            cursor: 'pointer',
                            textAlign: 'left',
                            '@coarse': {
                                minHeight: 'controlH'
                            },
                            background: (el, s)=>s.id === s.root.activeSessionId ? 'selected' : 'transparent',
                            color: (el, s)=>s.id === s.root.activeSessionId ? 'title' : 'caption',
                            fontWeight: (el, s)=>s.id === s.root.activeSessionId ? '700' : '500',
                            ':hover': {
                                background: 'hover'
                            },
                            // Right-click opens the thread context menu (Star / Remove) at the
                            // cursor — the same shell ContextDropdown the /files menu uses.
                            onContextmenu: (e, el, s)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                if (s.root && s.root.update) s.root.update({
                                    contextDropdown: {
                                        open: true,
                                        x: e.clientX,
                                        y: e.clientY,
                                        // lift above the assistant drawer (z-index 10000)
                                        z: '20050',
                                        sessionId: s.id,
                                        itemsFn: 'sessionContextItems',
                                        actionFn: 'sessionContextAction'
                                    }
                                });
                            },
                            // ★ marks a starred (pinned) thread; pinned rows also sort to top.
                            // (key-based auto-extend: `Icon` extends the Icon built-in.)
                            Icon: {
                                if: (el, s)=>!!s.pinned,
                                name: 'star',
                                boxSize: 'Z',
                                color: 'orange',
                                flexShrink: '0'
                            },
                            // The thread's name — primary text, never cut (overflow law
                            // §3b rule 8): it wraps; the time keeps its place.
                            Title: {
                                text: (el, s)=>s.title || el.call('polyglot', 'ai.chat.newChat'),
                                overflowWrap: 'anywhere',
                                flex: '1 1 auto',
                                minWidth: '0'
                            },
                            Time: {
                                text: (el, s)=>{
                                    if (!s.ts) return '';
                                    const d = new Date(s.ts);
                                    return el.call('localizedDate', d, {
                                        hour: 'numeric',
                                        minute: '2-digit'
                                    });
                                },
                                color: 'caption',
                                flexShrink: '0'
                            },
                            // ⋮ opens the same Star / Remove context menu, anchored to the
                            // button (replaces the old inline × delete). `Icon_1` auto-extends
                            // the Icon built-in (the `_1` suffix is ignored for resolution).
                            Icon_1: {
                                name: 'three dots vertical',
                                boxSize: 'Z',
                                color: 'caption',
                                cursor: 'pointer',
                                flexShrink: '0',
                                ':hover': {
                                    color: 'title'
                                },
                                onClick: (e, el, s)=>{
                                    e.stopPropagation();
                                    const r = el.node && el.node.getBoundingClientRect && el.node.getBoundingClientRect() || {
                                        right: 0,
                                        bottom: 0
                                    };
                                    if (s.root && s.root.update) s.root.update({
                                        contextDropdown: {
                                            open: true,
                                            x: Math.round((r.right || 0) - 150),
                                            y: Math.round((r.bottom || 0) + 4),
                                            // lift above the assistant drawer (z-index 10000)
                                            z: '20050',
                                            sessionId: s.id,
                                            itemsFn: 'sessionContextItems',
                                            actionFn: 'sessionContextAction'
                                        }
                                    });
                                }
                            },
                            onClick: (e, el, s)=>{
                                e.stopPropagation();
                                try {
                                    el.call('switchSession', s.id, el.scope.chatScopeOf(el));
                                } catch (_) {}
                                if (s.root && s.root.update) s.root.update({
                                    showSessionMenu: false
                                });
                            }
                        },
                        Empty: {
                            if: (el, s)=>!Object.keys(s.root.sessions || {}).filter((id)=>id && id !== 'null' && id !== 'undefined').length,
                            padding: 'Z A',
                            text: '{{ ai.chat.noPrevious | polyglot }}',
                            color: 'caption',
                            textAlign: 'center'
                        }
                    }
                }
            }
        },
        // Center spacer — Title pins left, Actions pin right. The old center
        // TargetSwitcher pill was removed (target switching lives in the
        // settings panel — header SettingsBtn → SettingsDrawer TargetSection).
        PvHeaderSpacer: {
            flex: '1'
        },
        // Right: Avatar (signed in) + AI ProviderDropdown.
        Actions: {
            flow: 'x',
            gap: 'X',
            align: 'center',
            flexShrink: '0',
            // THE AI-settings entry of the assistant — the shared AiSettingsButton
            // (one implementation with the canvas prompt's ParamsBtn, 2026-08-12
            // per Nika). In a Chat surface it opens the SettingsDrawer → shared
            // AiSettingsPanel. Since 2026-09-26 it is the ONLY one: the composer
            // row carries none (Nika: "remove AI settings button from ai sidebar
            // textarea").
            SettingsBtn: {
                extends: 'AiSettingsButton'
            },
            Me: {
                extends: 'Avatar',
                avatarType: 'initials',
                boxSize: 'B',
                cursor: 'pointer',
                // Hidden in the workspace embed — the shell chrome already shows the
                // signed-in avatar; repeating it inside the drawer is noise.
                hide: (el, s)=>!s.root.authUser || !!s.root.workspaceEmbed,
                // Never `''` — an empty `src` is a REAL request for the document URL,
                // and this avatar is mounted (then hidden) in every host with no
                // signed-in user, the preview assistant included. With no user it
                // asks for nothing. A signed-in user with NO photo gets the house
                // initials image: the framework Avatar paints its own initials ONLY
                // from `onError`, so an <img> with no `src` would show the browser's
                // broken-image glyph. See shared/__tests__/emptyImageSrcShared.test.js.
                src: (el, s)=>{
                    const u = s.root.authUser;
                    if (!u) return undefined;
                    return u.avatar || u.avatarUrl || el.call('avatarUrl', u.name || u.email) || undefined;
                },
                alt: (el, s)=>s.root.authUser && (s.root.authUser.name || s.root.authUser.email) || '',
                ':hover': {
                    filter: 'brightness(1.15)'
                }
            },
            // Local mode: the simone-bridge agent (Claude/Codex) ignores modelMode,
            // so swap the model picker for a live connection badge — a status dot +
            // the active agent name (or connecting… / disconnected). ConnectionBadge
            // reads s.root.bridgeStatus + s.root.agent.
            ConnectionBadge: {
                if: (el, s)=>(s.root.targetMode || 'general') === 'local'
            },
            // Model-mode picker — THE shared AiModelSwitcher (one implementation
            // with the canvas prompt bar's ModelBtn; see
            // shared/components/AiModelSwitcher.js). Forces a provider mode on the
            // /agent/conversation request body (default 'auto'), mirroring the
            // server AgentModelModes enum; selection persists to localStorage
            // `symbols_ai_model_mode` (the key sdk.ai.getModelMode reads) so the
            // next send carries body.modelMode. Shown in local mode too
            // (2026-09-02): the switcher body now carries the Provider group with
            // the Local-agent row — it is the one exit from local mode, so hiding
            // it here would trap the user there (the old local-mode `if:` gate
            // predates the move).
            AiModelSwitcher: {}
        }
    },
    // AIUX-SCROLL root cause: the previous onUpdate gated the re-scroll behind
    // a hand-picked content "signature" (`list.length` + the last message's
    // text/resultText length). A turn that only grew a tool-activity card
    // (Stack.Activity → ChatToolRow, or a Stack.Cards row) never touched
    // text/resultText, so the signature stayed identical, onUpdate bailed
    // before ever re-measuring scroll position, and the view stayed pinned
    // wherever it was — reading as a stalled turn (reproduced 3× on the "✓
    // Reading projects 0.3s" tool row). Rebuilt on the SAME ResizeObserver
    // recipe `chat/components/MessageList.js` (ChatMessageList) already uses
    // for its scroll container: it is KEYING-AGNOSTIC — it fires on ANY height
    // change to the message stack regardless of *why* it grew, so it can't
    // miss a growth path the way a hand-picked signature always will. Children
    // moved to a measurable `Inner` stack (mirrors that file's `List` child)
    // since ResizeObserver needs a content box to watch, not the scroll
    // container's own (fixed) box.
    //
    // A TRANSCRIPT, NOT A LANDMARK (DESIGN-SHARED-CHAT-MESSAGES-MAIN-LANDMARK-1):
    // the shell owns the page's one `main`, and this list mounts in the
    // assistant drawer, the /add-app builder and the home's Build tab. As a
    // `<main>` it put a chat forward as the page's main region — the only one
    // on the phone Build tab, a second one with the drawer open over /add-app.
    // It is a plain block with the role a message stream takes: a polite `log`,
    // named in the active language. `aria-busy` holds while THIS thread's turn
    // is in flight, so a screen reader announces the finished answer instead of
    // every streamed chunk. Pinned by __tests__/chatMessagesLog.test.js.
    Messages: {
        role: 'log',
        ariaLive: 'polite',
        ariaLabel: (el)=>el.call('polyglot', 'ai.chat.messagesLabel'),
        ariaBusy: (el, s)=>s.root && s.root[el.scope.ck(el, 'chatTyping')] ? 'true' : null,
        flex: '1 1 0',
        minHeight: '0',
        padding: 'A',
        overflow: 'auto',
        // Drawer-inner scroller: edge-bounce must not chain to the page behind
        // the assistant drawer (also correct on the full-page simone surface).
        overscrollBehavior: 'contain',
        // Scroll to bottom on first paint — onMounted fires after the node is
        // attached + laid out (unlike onCreate, where the subtree is still
        // detached and scrollHeight reads 0).
        onMounted: (el)=>{
            const container = el.node;
            if (!container) return;
            el._pinned = true;
            container.style.scrollBehavior = 'auto';
            container.scrollTop = container.scrollHeight;
            container.style.scrollBehavior = '';
        },
        // "Pinned to bottom" tracking + content-height auto-scroll.
        //
        // A first cut of this fix re-derived "is the user near the bottom" by
        // measuring scrollHeight/scrollTop/clientHeight INSIDE the ResizeObserver
        // callback, i.e. AFTER the content had already grown. That works for a
        // small streaming delta (a few px), but breaks for one big jump — e.g. a
        // full non-streaming answer landing at once, or a burst of tool-activity
        // rows arriving together: the post-growth distance-from-bottom is huge
        // (the growth amount itself), so the check reads "user scrolled away"
        // even when they were exactly pinned to the bottom the instant before.
        // Verified live: injecting 40 messages in one state update while
        // scrollTop was 0 (trivially "at bottom" — the two-message thread fit
        // the container) left distanceFromBottom at 5330px post-growth and the
        // view never moved.
        //
        // Fixed by tracking pinned-state from actual user scroll events instead
        // of re-deriving it from post-resize geometry: `el._pinned` reflects
        // whether the container's scroll position was near the bottom the LAST
        // TIME the user (or our own auto-scroll) moved it — independent of how
        // large the next content jump is. The ResizeObserver only reads that
        // flag; it never recomputes "near bottom" from the grown state.
        // FA503: the pinned-tracker is a DECLARED node handler ('scroll' does not
        // bubble, so DOMQL binds it straight to this container's node and drops it
        // in dispose()) — it no longer has to ride `el._scrollHandler` just so
        // `onRemove` can find it again.
        onScroll: (ev, el)=>{
            const container = el.node;
            if (!container) return;
            el._pinned = container.scrollHeight - container.scrollTop - container.clientHeight < 120;
        },
        onCreate: (el)=>{
            if (!el || !el.node) return;
            const container = el.node;
            if (el._pinned === undefined) el._pinned = true;
            const inner = container.querySelector('[data-key="Inner"]') || container.firstElementChild;
            if (typeof ResizeObserver === 'undefined' || !inner) return;
            el._roBottom = new ResizeObserver(()=>{
                if (!container.isConnected || !el._pinned) return;
                // rAF lets the browser finish the current paint before moving
                // scrollTop — without it the new content sometimes lands half-clipped.
                requestAnimationFrame(()=>{
                    if (!container.isConnected) return;
                    container.style.scrollBehavior = 'auto';
                    container.scrollTop = container.scrollHeight;
                    container.style.scrollBehavior = '';
                });
            });
            el._roBottom.observe(inner);
        },
        onRemove: (el)=>{
            if (el?._roBottom) {
                try {
                    el._roBottom.disconnect();
                } catch (_) {}
                el._roBottom = null;
            }
        },
        // Sending a message is a deliberate user action — always bring it into
        // view AND re-pin to the bottom, even if the user had scrolled far up
        // reading history (the pinned-tracking above deliberately does NOT
        // force-scroll an unpinned reader for a background update). Tracks the
        // chatMessages length; a growth whose newest row is the user's OWN
        // message bypasses the pinned check.
        onUpdate: (el, s)=>{
            if (!el || !el.node) return;
            const list = s.root[el.scope.ck(el, 'chatMessages')] || [];
            const prevLen = el._prevLen;
            el._prevLen = list.length;
            if (prevLen === undefined || list.length <= prevLen) return;
            const last = list[list.length - 1];
            if (!last || last.role !== 'user') return;
            el._pinned = true;
            const container = el.node;
            requestAnimationFrame(()=>{
                if (!container.isConnected) return;
                container.style.scrollBehavior = 'auto';
                container.scrollTop = container.scrollHeight;
                container.style.scrollBehavior = '';
            });
        },
        Inner: {
            flow: 'y',
            gap: 'A',
            childExtends: 'ChatMessage',
            // Tag each message that continues a same-author run with `_grouped`, so
            // ChatMessage drops the repeated avatar + Author/Time header and pulls
            // the row up tight (consecutive Claude replies read as one stacked
            // block). Only continuation rows get a fresh object; the first of each
            // group keeps its identity to minimise re-render churn during streaming.
            children: (el, s)=>{
                const list = s.root[el.scope.ck(el, 'chatMessages')] || [];
                let prevRole = null;
                return list.map((m, i)=>{
                    const grouped = m.role === prevRole;
                    prevRole = m.role;
                    // `_last` marks the newest message so its follow-up Suggestions row
                    // (ChatMessage) reads at full strength — older completed rows keep
                    // their CTAs, stepped back (2026-08-12 per Nika "always followup
                    // with beautiful buttons as call to actions from each message").
                    // Stamp BOTH the last row (true) and the row before it (false):
                    // childrenAs:'state' updates MERGE, so the previous holder must be
                    // overwritten explicitly or its stale `_last: true` survives — while
                    // untouched older rows keep their identity (the streaming-churn
                    // concern above).
                    const nearLast = i >= list.length - 2;
                    if (!grouped && !nearLast) return m;
                    return {
                        ...m,
                        ...grouped ? {
                            _grouped: true
                        } : {},
                        ...nearLast ? {
                            _last: i === list.length - 1
                        } : {}
                    };
                });
            },
            childrenAs: 'state'
        }
    },
    Empty: {
        if: (el, s)=>!(s.root[el.scope.ck(el, 'chatMessages')] || []).length,
        position: 'absolute',
        inset: 'D 0 G 0',
        flow: 'y',
        // Top-justified, not vertically centred (design consult 2026-09-10): the
        // built rows and the generated rows differ in height, and a centred
        // column would move the Hint and the Sub when the generated set lands.
        // Justified to the top, the list grows in one direction only (Rule 66).
        align: 'center flex-start',
        gap: 'Z',
        padding: '0 C',
        // Six two-line rows can outgrow the box this slot reserves above the
        // composer on a short viewport; they scroll inside it rather than show
        // through the composer's overlay wash.
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        // Container stays click-through so it never blocks the composer behind it;
        // the Starters list re-enables pointer events on itself for the rows.
        pointerEvents: 'none',
        // First use of the assistant in a workspace. The workspace drawer is
        // if-latched on `assistantOpen`, so this slot is CREATED at the first
        // open — the moment the workspace package makes sure THIS workspace has
        // its generated starter set (workspace/functions/assistantStarters.js:
        // cache first, one model call only when the set is stale, cached in the
        // member's preferences row). Deferred a microtask so the state writes it
        // makes never land inside this element's own creation pass. Hosts without
        // the function (standalone simone, ext-ui) no-op.
        onCreate: (el, s)=>{
            const root = s.root;
            queueMicrotask(()=>{
                try {
                    el.call('ensureWorkspaceStarters', root);
                } catch (_) {}
            });
        },
        // The assistant's mark, above the greeting — a solid-ink tile (the
        // brand's poster moment inside the chrome: one focal point, no hue), so
        // the empty state reads as a welcome rather than a list that starts at
        // the top edge.
        Mark: {
            // a div, never the key's <mark> (the user agent paints it yellow)
            tag: 'div',
            boxSize: 'avatarMd',
            minWidth: 'avatarMd',
            round: 'radiusCard',
            align: 'center center',
            theme: 'primary',
            flexShrink: '0',
            marginBottom: 'Y',
            Icon: {
                name: 'logov2',
                boxSize: 'iconLg'
            }
        },
        Hint: {
            // "Ask anything about <workspace>" (2026-09-10 per Nika). The name is
            // the ONE resolver held in scope as `scopeName` (functions/
            // assistantScopeName.js): an org's default workspace ("Default") is
            // addressed by its org's name. The generic Symbols line survives only
            // where no workspace resolves (standalone simone, pre-boot). `root.lang`
            // is read so a language switch re-runs this factory — el.call('polyglot')
            // captures its value at evaluation time, unlike the template form.
            text: (el, s)=>{
                s.root && s.root.lang;
                const name = el.scope.scopeName(s.root);
                return name ? el.call('polyglot', 'ai.chat.hintWorkspace').replace('{workspace}', name) : el.call('polyglot', 'ai.chat.hint');
            },
            color: 'title',
            fontSize: 'B',
            fontWeight: '700',
            textAlign: 'center'
        },
        // THE LIST'S HEAD — one slot above the starters with two faces (Nika
        // 2026-09-26, "make first recommendations buttons in the middle and make
        // better design to it"): the micro-label that names the list ("Try
        // asking") at rest, the status line while this workspace's own set is
        // being written ("Looking at what <workspace> is working on…"). Both
        // live in ONE grid cell and only the current one is visible, so the
        // capsules below never move when one face replaces the other (Rule 66).
        // It replaces the old sentence under the greeting ("Not sure where to
        // start? Try one of these:"), which the label now says in two words.
        Sub: {
            tag: 'div',
            display: 'grid',
            justifyItems: 'center',
            marginTop: 'Z',
            // Both faces re-run on the keys they read (a language switch, the
            // generated set starting or landing, a workspace switch) — declared, so
            // a first run that short-circuits never leaves them untracked (FA515).
            childProps: {
                gridArea: '1 / 1',
                subscribeTo: [
                    'lang',
                    '_aiStartersPending',
                    'workspace',
                    'org'
                ]
            },
            StartersLabel: {
                extends: 'AppMicroLabel',
                text: (el, s)=>{
                    s.root && s.root.lang;
                    return el.call('polyglot', 'ai.chat.startersLabel');
                },
                visibility: (el, s)=>el.scope.startersStatus(el, s) ? 'hidden' : 'visible'
            },
            StartersStatus: {
                tag: 'span',
                color: 'caption',
                fontSize: 'Z1',
                textAlign: 'center',
                maxWidth: 'I',
                text: (el, s)=>el.scope.startersStatus(el, s),
                visibility: (el, s)=>el.scope.startersStatus(el, s) ? 'visible' : 'hidden'
            }
        },
        // Starter prompts — click to ask the AI. Each sends straight through the
        // active transport via el.call('sendPrompt', …) — identical to typing the
        // prompt and pressing Enter in the composer (bridge in standalone simone,
        // sdk.ai in the workspace drawer).
        //
        // PER WORKSPACE, never a brochure (2026-09-10 per Nika "make those options
        // smart and more beautiful per workspace — not static or generic —
        // generated on workspace use"). The rows come from the workspace
        // package's `workspaceStarters(root)`: this workspace's GENERATED set when
        // it has a fresh one, else a set BUILT from the apps the workspace
        // actually shows — each row carrying that app's glyph and name
        // (AssistantStarter). A host with no such function (standalone simone)
        // gets the two generic staples.
        //
        // CENTRED CAPSULES OF ONE WIDTH (Nika 2026-09-26, "make first
        // recommendations buttons in the middle and make better design to it").
        // One grid track, `minmax(0, max-content)`: as wide as the longest
        // starter in the active language, never wider than the panel, centred;
        // every capsule stretches to it, so the column reads as one even stack
        // in English and in Georgian (a long prompt wraps inside its capsule
        // instead of widening one of them). The kit's even-width construction:
        // one shared track — the same one the Danger zone's buttons share.
        // THE centred starter list (AssistantStarter.js AssistantStarterList —
        // one track as wide as the longest starter, the compact capsule: six fit
        // the empty state on a short viewport; at 44px the sixth sat under the
        // fold of a 757px window, live on dev 2c2b6d978). The Page view's empty
        // workspace mounts the same list. The rows are this host's own.
        Starters: {
            extends: 'AssistantStarterList',
            marginTop: 'Y',
            pointerEvents: 'auto',
            children: (el, s)=>{
                const root = s.root || {};
                // Every input the workspace builder reads, touched here so the list
                // follows a workspace switch, the apps landing, a language switch and
                // the generated set arriving in the preferences row.
                root.lang, root.workspace, root.org, root.workspaceApps, root.workspaceSettings, root.workspaceProject, root.userPrefs, root.assistantOpen, root._aiStartersPending;
                let rows = null;
                try {
                    rows = el.call('workspaceStarters', root);
                } catch (_) {
                    rows = null;
                }
                if (Array.isArray(rows) && rows.length) {
                    // A stale or missing generated set re-arms generation. Idempotent:
                    // a fresh cache, an in-flight call and a recent failure all return
                    // at once, and the state writes it makes are deferred past this
                    // render (queueMicrotask) so an effect never updates mid-effect.
                    queueMicrotask(()=>{
                        try {
                            el.call('ensureWorkspaceStarters', root);
                        } catch (_) {}
                    });
                    return rows;
                }
                return [
                    {
                        key: 'generic-help',
                        text: el.call('polyglot', 'ai.chat.starter.help'),
                        icon: 'magicstar'
                    },
                    {
                        key: 'generic-symbols',
                        text: el.call('polyglot', 'ai.chat.starter.symbols'),
                        icon: 'magicstar'
                    }
                ];
            }
        }
    },
    // Multi-agent panel — the delegated/chained sub-agents working on the current
    // turn (live, from the SDK onProcessActive agent.started/completed events),
    // PLUS the retained history of prior runs (runHistory) so past parallel/chained
    // runs stay reviewable after their turn ends. The transport moves each finished
    // batch from activeProcesses → runHistory (capped 30) instead of dropping it.
    // Sits above the composer; present while there are live OR past runs
    // (scope-aware via ck). Live runs tint blue (running) / green (done) / red
    // (error); past runs are already done/error so they read green/red. Reuses the
    // overlay-card + status-tint look; Pv* keys avoid built-in auto-extend
    // collisions; reactive text/color/background only (padding/round stay static).
    ActiveProcesses: {
        if: (el, s)=>(s.root[el.scope.ck(el, 'activeProcesses')] || []).length > 0 || (s.root[el.scope.ck(el, 'runHistory')] || []).length > 0,
        flow: 'y',
        gap: 'Z',
        margin: '- A Z',
        padding: 'Z1',
        round: 'B',
        // `overlay` is a COLOUR token, never a theme — see Header above. In the
        // theme slot it emitted no class at all, so this card had no plate.
        background: 'overlay',
        flexShrink: '0',
        PvHead: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            PvLabel: {
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                text: (el, s)=>{
                    const running = (s.root[el.scope.ck(el, 'activeProcesses')] || []).some((p)=>p.status === 'running');
                    return running ? 'Agents working' : 'Recent agent runs';
                }
            },
            PvCount: {
                marginLeft: 'auto',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    const active = s.root[el.scope.ck(el, 'activeProcesses')] || [];
                    const history = s.root[el.scope.ck(el, 'runHistory')] || [];
                    const running = active.filter((p)=>p.status === 'running').length;
                    return running ? `${running} running` : `${active.length + history.length} runs`;
                }
            },
            // Dismiss the whole panel — clears the retained history and any finished
            // (non-running) current batch. Hidden mid-turn (never yank a live run) and
            // when there's nothing to clear.
            PvClear: {
                tag: 'button',
                type: 'button',
                marginLeft: 'Y',
                padding: '0',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Y2',
                color: 'caption',
                ':hover': {
                    color: 'title'
                },
                text: '{{ ai.chat.clear | polyglot }}',
                hide: (el, s)=>{
                    const active = s.root[el.scope.ck(el, 'activeProcesses')] || [];
                    const history = s.root[el.scope.ck(el, 'runHistory')] || [];
                    const running = active.some((p)=>p.status === 'running');
                    return running || !active.length && !history.length;
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    s.root.update({
                        [el.scope.ck(el, 'activeProcesses')]: [],
                        [el.scope.ck(el, 'runHistory')]: []
                    });
                }
            }
        },
        PvRows: {
            flow: 'y',
            gap: 'Y',
            childrenAs: 'state',
            // Live runs first (current turn), then the retained history (capped 6) so
            // the panel reads "working now → earlier". Past rows carry _past for a
            // subtle dim; ids never overlap (history is only populated once a batch has
            // left activeProcesses).
            children: (el, s)=>{
                const active = s.root[el.scope.ck(el, 'activeProcesses')] || [];
                const history = (s.root[el.scope.ck(el, 'runHistory')] || []).slice(0, 6);
                return [
                    ...active,
                    ...history.map((h)=>({
                            ...h,
                            _past: true
                        }))
                ];
            },
            childExtends: {
                flow: 'x',
                gap: 'Z',
                align: 'center left',
                padding: 'Y Z',
                round: 'X2',
                opacity: (el, s)=>s._past ? '0.6' : '1',
                background: (el, s)=>s.status === 'error' ? 'red.15' : s.status === 'done' ? 'green.15' : 'blue.15',
                PvInfo: {
                    flow: 'y',
                    flex: '1 1 0',
                    minWidth: '0',
                    PvName: {
                        fontSize: 'Z1',
                        fontWeight: '700',
                        color: 'title',
                        text: (el, s)=>s.agentName || s.seedSlug || 'Agent'
                    },
                    PvTask: {
                        fontSize: 'Y2',
                        color: 'caption',
                        overflow: 'hidden',
                        text: (el, s)=>s.status === 'error' ? s.error || 'failed' : s.task || s.result || ''
                    }
                },
                PvStatus: {
                    marginLeft: 'auto',
                    flexShrink: '0',
                    fontSize: 'Y2',
                    color: (el, s)=>s.status === 'error' ? 'red' : s.status === 'done' ? 'green' : 'blue',
                    text: (el, s)=>s.status === 'error' ? 'error' : s.status === 'done' ? "\u2713 done" : "running\u2026"
                }
            }
        }
    },
    // Composer — brand `PromptTextarea` with its marketing Flex/Button stripped
    // and a chat toolbar (Pick/Inspect/Upload/Settings) + circular send pinned
    // inside it. The draft lives on PromptTextarea.state (`draft`); Textarea +
    // CircleButton inherit it, so `_send` reads/clears via state. Disabled until
    // the bridge connects. Pick shows everywhere except the workspace embed
    // (`hidePickTool`); Inspect $0 only shows when `inspectorTools` is set.
    ComposerWrap: {
        tag: 'form',
        padding: 'A',
        paddingBottom: 'max(env(safe-area-inset-bottom), A)',
        borderTop: 'none',
        // `overlay` is a COLOUR token, never a theme — see Header above. In the
        // theme slot it emitted no class at all, so the composer band had no plate.
        background: 'overlay',
        flexShrink: '0',
        flow: 'x',
        align: 'center center',
        // Anchors the "→ Talking to <agent>" chip above the composer.
        position: 'relative',
        // Correspondent chip. It says WHO this panel is talking to, in two cases:
        //   1. the thread BELONGS to an agent (entered from its card —
        //      root._threadAgentName). Clicking it leaves that correspondent and
        //      resumes the general assistant's own thread.
        //   2. an @-mention or an in-thread agent chip has aimed only the NEXT
        //      message at an agent (root._targetAgentName). Clicking it clears
        //      that aim and the thread stays where it is.
        // Case 1 is what makes the panel say which thread it resumed
        // (AI-TALK-TO-AGENT-REUSES-OPEN-THREAD-1 acceptance).
        TargetAgentChip: {
            tag: 'button',
            type: 'button',
            // Bare <button>, so it inherits no TooltipTrigger — a plain `title`
            // here rendered the NATIVE browser tooltip right beside the house
            // ones on the toolbar below. Trigger + tooltipText directly instead;
            // ariaLabel carries what the ✕ means for screen readers.
            extends: 'TooltipTrigger',
            tooltipText: (el, s)=>s.root._threadAgentName ? 'Leave this agent and go back to the general assistant' : 'Stop directing this thread to the agent',
            tooltipPlacement: 'top',
            aria: {
                label: (el, s)=>s.root._threadAgentName ? 'Leave this agent and go back to the general assistant' : 'Stop directing this thread to the agent'
            },
            hide: (el, s)=>!(s.root._threadAgentName || s.root._targetAgentName),
            position: 'absolute',
            bottom: 'calc(100% + Z)',
            left: 'A',
            zIndex: '25',
            flow: 'x',
            align: 'center center',
            gap: 'Y',
            padding: 'Z Z1',
            round: 'F',
            borderWidth: '0',
            cursor: 'pointer',
            background: 'overlayStrong',
            color: 'title',
            fontSize: 'Y2',
            Label: {
                tag: 'span',
                text: (el, s)=>"\u2192 " + (s.root._threadAgentName || s.root._targetAgentName || '')
            },
            X: {
                tag: 'span',
                text: "\u2715",
                color: 'caption',
                marginLeft: 'Y'
            },
            onClick: (e, el, s)=>{
                // In an agent's OWN thread the chip is that thread's identity, so
                // leaving is a thread move, not a flag clear — go back to the general
                // assistant's thread, which is resumed the same way.
                if (s.root._threadAgentId) {
                    el.call('openAgentThread', null, el.scope.chatScopeOf(el));
                    return;
                }
                s.root.update({
                    _targetAgentId: null,
                    _targetAgentName: null
                });
            }
        },
        // @-mention agent picker — floats above the COMPOSER BAND. It is a child
        // of ComposerWrap, never of PromptTextarea: the brand PromptTextarea box
        // is `overflow: hidden`, so a panel that floats ABOVE it was clipped away —
        // present in the DOM, invisible, and a click at its place hit the message
        // list (design-d2's live finding, 2026-09-29). Rows use childrenAs:'state'
        // (per-row data via state — no closure capture, FA205); a pick reaches
        // THIS composer's draft state through the tree (`mentionDraftState`).
        // Shown only while root._simoneAgentPicker has options.
        SimoneMentionDropdown: {
            // Declared (FA515): the voice check below short-circuits, so the picker
            // key is read only on some runs — the dependency is stated, not implied.
            hideDeps: [
                '_simoneAgentPicker'
            ],
            // Draft-coupled — hides with the textarea while voice hosts (T18).
            hide: (el, s)=>el.scope.voiceHostingChat(s) || !(s.root._simoneAgentPicker && s.root._simoneAgentPicker.options && s.root._simoneAgentPicker.options.length),
            // Aligned with the composer box inside the band's `A` inset, floating
            // just above the band's top edge.
            position: 'absolute',
            left: 'A',
            right: 'A',
            bottom: 'calc(100% - Y)',
            zIndex: '30',
            flow: 'y',
            gap: 'V',
            // THE AI menu surface (AiMenu.js AiMenuPanel values, restated —
            // this panel is display-gated by the typeahead `hide` above, so it
            // takes the brand entrance keyframe instead of the .isOpen
            // transition: `fadeInUpShort` replays on every reveal (the
            // VoiceStrip precedent for display-gated swaps) and close stays
            // instant — a keystroke-driven picker must never lag the caret.
            // Borderless: the old hairline ring was the banned separation
            // stroke (design-direction.md §8) — the glass theme's own single
            // shadow is the separation.
            padding: 'Z',
            theme: 'canvas-card-glass',
            round: 'radiusCard',
            borderWidth: '0',
            // Overlay elevation token (the AiMenuPanel note): the glass theme's
            // light-half shadow computes to none, and THIS panel floats over the
            // often-empty white chat area — without it the picker was literally
            // white-on-white invisible in light (measured 2026-08-13).
            shadow: 'overlay',
            animation: 'fadeInUpShort',
            animationDuration: 'A',
            maxHeight: '40dvh',
            overflow: 'auto',
            overscrollBehavior: 'contain',
            // The row stays an INLINE shape on purpose: this Chat is reused verbatim
            // by hosts that register only `Chat` (standalone simone, the chrome
            // panel, the ext-ui inspector), where a named row component would not
            // resolve.
            childExtends: {
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center flex-start',
                gap: 'Y',
                width: '100%',
                padding: 'Y Z1',
                round: 'radiusControl',
                borderWidth: '0',
                cursor: 'pointer',
                textAlign: 'left',
                // Active row wears the house active wash; __i is the row's picker index.
                // Active row wears the house active wash (the accepted overlay value).
                // Hover unifies with keyboard nav by moving activeIndex, so a single
                // highlight mechanism serves both (no static rgba :hover).
                background: (el, s)=>(s.root._simoneAgentPicker && s.root._simoneAgentPicker.activeIndex) === s.__i ? 'selected' : 'transparent',
                onMouseenter: (e, el, s)=>{
                    const p = s.root._simoneAgentPicker;
                    if (p && p.activeIndex !== s.__i) s.root.update({
                        _simoneAgentPicker: {
                            ...p,
                            activeIndex: s.__i
                        }
                    });
                },
                // onMousedown (not onClick) + preventDefault so the pick fires before
                // the textarea blur, keeping focus + the caret in the input. `s` is the
                // row's agent state; the draft state is THIS composer's PromptTextarea
                // state, found through the tree.
                onMousedown: (e, el, s)=>{
                    e.preventDefault();
                    const draft = el.scope.mentionDraftState(el);
                    if (draft) el.scope.pickMentionAgent(el, draft, s);
                },
                Avatar: {
                    extends: 'Avatar',
                    avatarType: 'initials',
                    boxSize: 'C C',
                    flexShrink: '0',
                    round: '50%',
                    src: (el, s)=>s.avatar || el.call('avatarUrl', s.name || s.email || '?')
                },
                Meta: {
                    flow: 'y',
                    minWidth: '0',
                    Name: {
                        color: 'title',
                        fontSize: 'Z1',
                        fontWeight: '500',
                        text: (el, s)=>el.scope.agentLabel(s, el.call('getActiveLang')) || 'Agent'
                    },
                    Handle: {
                        color: 'caption',
                        fontSize: 'Y2',
                        text: (el, s)=>'@' + ((s.email || '').split('@')[0] || String(s.name || '').toLowerCase())
                    }
                }
            },
            childrenAs: 'state',
            children: (el, s)=>(s.root._simoneAgentPicker && s.root._simoneAgentPicker.options || []).map((agent, i)=>({
                        ...agent,
                        __i: i,
                        key: String(agent.userId)
                    }))
        },
        PromptTextarea: {
            width: '100%',
            boxSize: 'auto 100%',
            minHeight: '0',
            height: 'auto',
            maxHeight: '35dvh',
            // Column flex so the awareness bar can sit ABOVE the textarea: brand's
            // PromptTextarea is a block whose `Textarea` key merges first, so the
            // bar (a new key) lands after it in source order — under the textarea,
            // inside the bottom-anchored composer control row (ComposerBar), clipped by
            // this card's overflow:hidden (AI-CONTEXT-AWARENESS-O1-1 live pass,
            // 2026-08-21). `order: -1` on the bar is the declarative fix; the
            // Textarea's own autosize/height rules are untouched.
            flow: 'y',
            // A docked panel's corners (radiusSheet), not the brand hero capsule's
            // `B` — a two-row composer on a capsule radius read as a pill.
            round: 'radiusSheet',
            // Brand's PromptTextarea pins a FIXED height per breakpoint (`boxSize:
            // 'E2 I'` at @tabletM, 'E2 100%' / 'F1 100%' below) — those media rules
            // outrank the flat `height: auto` above, so at ≤tabletM widths the card
            // stayed E2 tall, the bar + textarea overflowed it and overflow:hidden
            // clipped the textarea (live at 1000px, 2026-08-21). The chat composer
            // is content-sized at every width.
            '@tabletM': {
                boxSize: 'auto 100%'
            },
            '@tabletS': {
                boxSize: 'auto 100%'
            },
            '@mobileL': {
                boxSize: 'auto 100%'
            },
            outline: 'none',
            boxShadow: 'none',
            borderColor: 'transparent',
            // The BAR is the visual field (the textarea inside it suppresses its
            // own ring below), so THE house ring lands here on :focus-within —
            // `focusRing` shadow token, DESIGN_LANGUAGE §8.2. This used to kill the
            // ring outright (`boxShadow: 'none'`), leaving Simone's composer the
            // one form element with NO keyboard focus state (F1, Nika 2026-08-16).
            ':focus-within': {
                outline: 'none',
                shadow: 'focusRing',
                borderColor: 'transparent'
            },
            // position:relative anchors this box's own absolute parts. (The
            // @-mention picker floats from ComposerWrap, OUTSIDE this box — its
            // overflow is hidden and would clip it.)
            position: 'relative',
            // `images` MUST be declared here, not left to appear on first upload.
            // UploadBtn below walks up the tree until it finds a state whose
            // `images` IS AN ARRAY — with the key undeclared, that walk ran past
            // this composer all the way to the root and wrote the picture onto the
            // ROOT state, where `send` (which reads THIS state) could only see it by
            // accident of state inheritance, and two live composers would share one
            // bag. Declaring it stops the walk here, which is what makes the
            // attachment belong to this composer.
            state: {
                draft: '',
                images: []
            },
            // ── Ref-drop target (spec §4.1) ──────────────────────────────────────
            // The drawer composer accepts an entity drag exactly like the chat
            // Composer does (packages/chat/components/Composer.js) — same declared
            // attribute, same three handlers, same dragRef.js wire contract reached
            // through el.call so no package imports another (FA001).
            //
            // WHERE IT DIFFERS FROM CHAT: chat splices a markdown LINK into the
            // message body, because a chat message has nowhere else to put a ref.
            // The assistant does: a dropped ref becomes a STRUCTURED attachment
            // (`el.call('attachAiRef', ref)` → root.aiAttached), so it reaches the
            // model as data the server keeps and the orchestrator registers as a
            // retrieval candidate — not as text in the prompt. AiContextBar above
            // renders the chip and owns the remove.
            //
            // `data-ref-drop` is what the POINTER-drag sources hit-test on pointerup
            // (the tickets board — dragRef.js dispatchRefDrop delivers through this
            // very onDrop via a synthetic DragEvent). Declaring it is the whole
            // opt-in; there is no second registration.
            'data-ref-drop': 'assistant',
            // The drop affordance is an INSTANCE flag + an imperative el.update()
            // patch, never root state: root.update() silently drops any key the
            // shell's state schema does not declare, and a hover ring is not state
            // worth declaring. Same technique the chat Composer uses. The wash is
            // the house `selected` step — the composer already owns a focus ring
            // (:focus-within shadow above) and a second ring would be two rings.
            _dragOverOn: {
                background: 'selected'
            },
            _dragOverOff: {
                background: 'none'
            },
            onDragover: (e, el)=>{
                if (!el.call('hasDragRef', e)) return;
                // MUST preventDefault, or the browser shows the "can't drop here"
                // cursor for our custom MIME. getData() is blocked during dragover
                // (DataTransfer protected mode), so hasDragRef tests `.types` only.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
                if (el._dragOver) return;
                el._dragOver = true;
                el.update(el._dragOverOn);
            },
            onDragleave: (e, el)=>{
                // dragleave also fires when the pointer crosses onto a DESCENDANT
                // (the textarea, the toolbar, a chip) — only clear once it has really
                // left this element's box. relatedTarget is null when the drag leaves
                // the window, and the guard then falls through and clears correctly.
                if (el.node && e.relatedTarget && el.node.contains(e.relatedTarget)) return;
                if (!el._dragOver) return;
                el._dragOver = false;
                el.update(el._dragOverOff);
            },
            onDrop: (e, el)=>{
                if (el._dragOver) {
                    el._dragOver = false;
                    el.update(el._dragOverOff);
                }
                const ref = el.call('readDragRef', e);
                if (!ref) return;
                e.preventDefault();
                try {
                    // drag-ref `kind` === EntityRef `type` (spec §2) — attachAiRef
                    // accepts either spelling, so the payload goes through untouched.
                    el.call('attachAiRef', ref);
                } catch (_) {
                // Unregistered on this surface (standalone simone, the chrome
                // panel) — the drop is a no-op instead of a throw out of a handler.
                }
            },
            // Brand PromptTextarea ships an upload/chevron Flex + a marketing
            // "Create a feature" Button — neither belongs in the chat composer.
            // O1 (opus.md): the ONE awareness rendering, INSIDE PromptTextarea so its
            // inherited state is this composer's own draft bag (images live here) —
            // that is the `composerState` the resolver takes as its second argument.
            // Replaces the top-level PickedContextChip mount: picked elements are the
            // "attached" tier now, next to the focus tier (open record, canvas
            // selection) — one grammar, and the `sent` truth on every chip.
            AiContextBar: {
                order: '-1',
                flexShrink: '0',
                padding: 'Z1 A2 0'
            },
            Flex: {
                if: ()=>false
            },
            Button: {
                if: ()=>false
            },
            Textarea: {
                // Hidden (not unmounted) while the voice strip hosts this composer
                // (T18) — reactive `hide` on a mounted-open child.
                hide: (el, s)=>el.scope.voiceHostingChat(s),
                rows: '1',
                resize: 'none',
                border: 'none',
                fontSize: 'inherit',
                // A typed draft in the title ink: the field's inherited text ink
                // (rgba(0,0,0,.65)) read like its placeholder (rgb(85,85,93)). The
                // placeholder keeps its own rule.
                color: 'title',
                minWidth: '100%',
                width: '100%',
                minHeight: '1.5em',
                height: 'auto',
                maxHeight: '35dvh',
                overflow: 'hidden',
                overflowX: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                // Tokens only. The old raw right inset and the C bottom inset reserved
                // room for ABSOLUTELY placed buttons; the controls now sit in a flow
                // row below (ComposerBar), so the text keeps the field's own inset.
                padding: 'A2 A2 Y A2',
                outline: 'none',
                boxShadow: 'none',
                ':focus': {
                    outline: 'none',
                    boxShadow: 'none'
                },
                ':focus-visible': {
                    outline: 'none',
                    boxShadow: 'none'
                },
                // AIUX-CHROME item 2 (tickets/sonnet.md, live-verified 2026-08-13) —
                // the static "…or reference $0…" hint is a Chrome-DevTools-style
                // convention (Inspect $0 — the InspectZeroBtn tooltip below) that
                // only means anything to the chrome-extension inspector surface
                // (`root.inspectorTools`); every other consumer (workspace drawer,
                // dashboard, standalone) showed it too, reading as a stray price/bug
                // token to new users who have no "$0" feature visible at all. Only
                // surface the hint where it's actually true.
                // Through the bundle (it was an English literal in every workspace
                // language — the i18n gate reads only `prop: 'literal'`, so a literal
                // inside a factory slipped past it).
                placeholder: (el, s)=>el.call('polyglot', s.root && s.root.inspectorTools ? 'ai.chat.placeholderInspector' : 'ai.chat.placeholder'),
                value: (el, s)=>s.draft || '',
                disabled: (el, s)=>s.root.bridgeStatus !== 'open',
                onCreate: (el, s)=>{
                    el.scope.resizeComposerTextarea(el.node);
                    // Hydrate the @-mention agent roster (best-effort, idempotent).
                    el.scope.ensureAgentRoster(el, s);
                    if (typeof ResizeObserver === 'undefined') return;
                    el._composerResizeObserver = new ResizeObserver(()=>el.scope.resizeComposerTextarea(el.node));
                    el._composerResizeObserver.observe(el.node);
                },
                onRemove: (el)=>{
                    el._composerResizeObserver?.disconnect?.();
                },
                onUpdate: (el)=>{
                    el.scope.resizeComposerTextarea(el.node);
                },
                onInput: (e, el, s)=>{
                    s.update({
                        draft: e.target.value
                    });
                    el.scope.resizeComposerTextarea(el.node);
                    el.scope.refreshMentionPicker(el, s);
                },
                // Enter sends (chat convention); Shift+Enter inserts a newline. When the
                // @-mention picker is open it captures Arrow/Enter/Tab/Escape first.
                onKeydown: (e, el, s)=>{
                    const picker = s.root._simoneAgentPicker;
                    if (picker && picker.options && picker.options.length) {
                        const n = picker.options.length;
                        if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            s.root.update({
                                _simoneAgentPicker: {
                                    ...picker,
                                    activeIndex: (picker.activeIndex + 1) % n
                                }
                            });
                            return;
                        }
                        if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            s.root.update({
                                _simoneAgentPicker: {
                                    ...picker,
                                    activeIndex: (picker.activeIndex - 1 + n) % n
                                }
                            });
                            return;
                        }
                        if (e.key === 'Enter' || e.key === 'Tab') {
                            e.preventDefault();
                            el.scope.pickMentionAgent(el, s, picker.options[picker.activeIndex] || picker.options[0]);
                            return;
                        }
                        if (e.key === 'Escape') {
                            e.preventDefault();
                            s.root.update({
                                _simoneAgentPicker: null
                            });
                            return;
                        }
                    }
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        el.scope.send(el, s);
                    }
                }
            },
            // Composer toolbar — NavbarButton icon buttons pinned bottom-left.
            // Pick (cursor selection) + Upload + Settings show everywhere except
            // where a host hides Pick (`hidePickTool` — workspace embed); Inspect $0
            // is inspector-only (chrome extension).
            // The composer's control row — IN FLOW under the text, never absolute.
            // Left: upload / voice / settings; right: send. One centre line, one
            // compact scale (AssistantIconButton + AssistantSendButton), so nothing
            // needs a hand-tuned inset and the text keeps its own padding.
            ComposerBar: {
                hide: (el, s)=>el.scope.voiceHostingChat(s),
                flow: 'x',
                align: 'center space-between',
                gap: 'Z',
                padding: '0 Z Z Z',
                flexShrink: '0',
                PromptButtons: {
                    flow: 'x',
                    align: 'center start',
                    gap: 'X',
                    flexShrink: '0',
                    // Every control here is the assistant chrome's one icon button —
                    // the primitive owns the scale and the states (Rules 65 + 68).
                    childExtends: 'AssistantIconButton',
                    PickBtn: {
                        if: ()=>false,
                        icon: 'sf cursor',
                        // Surface-specific intent: in the chrome extension the picked DOM
                        // node is the thing the agent should UPDATE; in the workspace embed
                        // (and standalone) picking just POINTS the AI at an item as context.
                        title: (el, s)=>{
                            if (s.root && s.root.picking) return "Picking\u2026 (Esc to cancel)";
                            if (typeof window !== 'undefined' && typeof window.__ccSendToPage === 'function') return 'Pick the element to update on the inspected page';
                            return s.root && s.root.workspaceEmbed ? 'Point the AI at an item on this page' : 'Point the AI at an element on this page';
                        },
                        background: (el, s)=>s.root && s.root.picking ? 'primary' : undefined,
                        onClick: (e, el)=>{
                            try {
                                el.call('togglePick');
                            } catch (_) {}
                        }
                    },
                    InspectZeroBtn: {
                        if: (el, s)=>!!(s.root && s.root.inspectorTools),
                        icon: 'sf inspect',
                        title: (el, s)=>typeof window !== 'undefined' && window.__ccSurfaceMode === 'side-panel' ? 'Capture the currently-focused element on the active tab' : 'Inspect $0 from the Elements panel',
                        onClick: (e, el)=>{
                            try {
                                el.call('inspectSelected');
                            } catch (_) {}
                        }
                    },
                    UploadBtn: {
                        tag: 'label',
                        icon: 'sf upload',
                        title: (el)=>el.call('polyglot', 'ai.chat.uploadImage'),
                        position: 'relative',
                        cursor: 'pointer',
                        Input: {
                            tag: 'input',
                            type: 'file',
                            accept: 'image/*',
                            position: 'absolute',
                            inset: '0',
                            opacity: '0',
                            cursor: 'pointer',
                            onChange: (e, el)=>{
                                const file = e.target.files && e.target.files[0];
                                if (!file || !file.type.startsWith('image/')) return;
                                let promptEl = el.parent;
                                while(promptEl && promptEl.parent && !(promptEl.state && Array.isArray(promptEl.state.images)))promptEl = promptEl.parent;
                                const st = promptEl && promptEl.state;
                                const nodeRef = el.node;
                                const reader = new FileReader();
                                reader.onloadend = ()=>{
                                    // The SAME entry shape the canvas composer stores
                                    // ({ key, name, mime, size, dataUrl }) — a bare data-URL
                                    // string used to be pushed here, which left the awareness chip
                                    // with no file name and no `key` to remove it by. `key` is the
                                    // handle removePromptAttachment deletes on.
                                    const entry = {
                                        key: `img-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
                                        name: file.name || 'image',
                                        mime: file.type || '',
                                        size: file.size || 0,
                                        dataUrl: reader.result
                                    };
                                    if (st && st.update) st.update({
                                        images: [
                                            ...st.images || [],
                                            entry
                                        ]
                                    });
                                    if (nodeRef) nodeRef.value = '';
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                    },
                    // Voice input — talk to the assistant hands-free. Click toggles the
                    // shared VoiceOverlay in talk mode (replies are read aloud), holding
                    // (≥280ms) is push-to-talk. Renders only where a VoiceOverlay host is
                    // mounted (voiceHostReady — chrome-connect/ext-ui surfaces never show
                    // it). Own `scope` isolates the PTT hold timer.
                    VoiceBtn: {
                        scope: {},
                        display: null,
                        show: (el, s)=>!!(s.root && s.root.voiceHostReady),
                        icon: (el, s)=>s.root && s.root.voiceOpen ? 'mic' : 'micOutline',
                        title: (el)=>el.call('polyglot', 'ai.chat.voiceTooltip'),
                        isActive: (el, s)=>!!(s.root && s.root.voiceOpen),
                        '.isActive': {
                            background: 'overlayStrong',
                            color: 'title'
                        },
                        onPointerdown: (e, el, s)=>{
                            if (e.button !== 0) return;
                            // Capture on the BUTTON, not `e.target` — see the twin handler in
                            // canvas/components/CanvasPromptTextarea.js for the full rationale:
                            // `e.target` is usually the inner icon, `icon` is reactive and
                            // swaps the moment `voiceOpen` flips (i.e. as a hold begins), and
                            // capture dies with the node it was taken on — dropping the
                            // `pointerup` that ends the hold.
                            const capture = el.node || e.target;
                            if (capture && capture.setPointerCapture && e.pointerId !== undefined) try {
                                capture.setPointerCapture(e.pointerId);
                            } catch (_) {}
                            // Announce this composer as the voice host BEFORE the engine
                            // opens — root.voiceHost contract (shared/components/
                            // VoiceStrip.js): the in-place strip renders here instead of the
                            // full-screen overlay. UI-only root write → preventFetch.
                            if (s.root && s.root.update) s.root.update({
                                voiceHost: 'chat'
                            }, {
                                preventFetch: true
                            });
                            el.call('voicePttPress', {
                                mode: 'talk',
                                scope: el.scope.chatScopeOf(el)
                            });
                        },
                        onPointerup: (e, el)=>{
                            if (e.button !== 0) return;
                            el.call('voicePttRelease', {
                                mode: 'talk',
                                scope: el.scope.chatScopeOf(el)
                            });
                        },
                        onPointercancel: (e, el)=>el.call('voicePttCancel')
                    }
                },
                SendButton: {
                    extends: 'AssistantSendButton',
                    aria: {
                        label: (el)=>el.call('polyglot', 'ai.chat.sendMessage')
                    },
                    title: (el)=>el.call('polyglot', 'ai.chat.sendMessage'),
                    isReadyDeps: [
                        'draft',
                        (el, s)=>s.root && s.root.bridgeStatus
                    ],
                    isReady: (el, s)=>!el.scope.isComposerSendDisabled(el, s),
                    // The glyph is the send arrow in every state. A turn in flight swaps
                    // it for the house busy indicator (shared LoadingSpinner, its use #1:
                    // inside a control while its action runs) — the sprite has no
                    // `loading` glyph, so that name painted `#noIcon`, a hatched square
                    // (measured live on dev, 2026-10-18).
                    icon: 'arrowUp',
                    Icon: {
                        hideDeps: [
                            (el, s)=>s.root && s.root[el.scope.ck(el, 'chatTyping')]
                        ],
                        hide: (el, s)=>!!(s.root && s.root[el.scope.ck(el, 'chatTyping')])
                    },
                    LoadingSpinner: {
                        hideDeps: [
                            (el, s)=>s.root && s.root[el.scope.ck(el, 'chatTyping')]
                        ],
                        hide: (el, s)=>!(s.root && s.root[el.scope.ck(el, 'chatTyping')])
                    },
                    opacity: (el, s)=>s.root && s.root[el.scope.ck(el, 'chatTyping')] ? '.5' : '1',
                    pointerEvents: (el, s)=>s.root && (s.root[el.scope.ck(el, 'chatTyping')] || el.scope.isComposerSendDisabled(el, s)) ? 'none' : 'auto',
                    disabled: (el, s)=>el.scope.isComposerSendDisabled(el, s),
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        el.scope.send(el, s);
                    }
                }
            },
            // T18 — the in-place voice surface. Replaces the text trio (Textarea +
            // ComposerBar, hidden above/below) inside the same
            // ComposerWrap form shell while this composer hosts voice. Visibility
            // lives on the strip's own reactive `display:` predicate
            // (VoiceStrip.js).
            VoiceStrip: {
                hostKey: 'chat',
                // This box clips its overflow (the brand prompt box): the call's
                // words stay in the strip's row, not as bubbles above it.
                floatWords: false
            }
        },
        // Stop the native <form> submit from reloading the panel.
        onSubmit: (e)=>{
            e.preventDefault();
        }
    },
    // Settings overlay — mounted ON Chat (not the host page) so every consumer
    // (standalone simone, chrome-connect panel, ext-ui, workspace drawer) gets
    // the same settings surface from the SettingsBtn without wiring anything.
    Settings: {
        if: (el, s)=>!!s.root.showSettings,
        extends: 'SettingsDrawer'
    }
} // el.node.scrollTop / ResizeObserver in Messages.onMounted/onCreate/onUpdate
 // are a known DOMQL escape hatch — scroll-to-bottom on new content has no
 // canonical DOMQL prop yet. Same recipe as `chat/components/MessageList.js`
 // (ChatMessageList.onMounted/onCreate) — see AIUX-SCROLL (tickets/sonnet.md).
;

});
parcelRegister("m13h3", function(module, exports) {

$parcel$export(module.exports, "isGenericWorkspaceName", () => $0422df0e6113a6f3$export$43a031be91c380e4);
$parcel$export(module.exports, "assistantScopeName", () => $0422df0e6113a6f3$export$5da7f3fd96672f63);
// assistantScopeName(root) — the name the assistant's empty state addresses:
// "Ask anything about <this>" (2026-09-10 per Nika "instead of 'ask anything
// about symbols' say 'ask anything about {workspace}'"). ONE resolver, shared
// by the drawer hint (shared Chat.js) and the workspace starter builder
// (workspace/functions/assistantStarters.js), so both name the same thing.
//
// The workspace's own display name wins. An org's DEFAULT workspace is the
// exception: it is literally named "Default" (slug `default` — every org
// starts with one, e.g. /w/gita/default, live 2026-09-10), and "Ask anything
// about Default" names nothing a reader recognises. There, the ORGANISATION's
// name is the identity the member knows the space by — it is what the header
// switcher prints — so the hint uses it. '' when neither resolves (standalone
// simone, pre-boot), and the caller falls back to the generic Symbols line.
//
// Self-contained on purpose: it is held as a scope VALUE by the shared Chat
// component, which is frank.toJSON'd for platform delivery — a helper that
// called a sibling export by its bare name would read as undefined there
// (the FA204 trap Chat.js is organised around). The name precedence is the
// same one `workspaceDisplayName` (./activeWorkspaceRecord.js) states:
// `displayName` FIRST, the frozen legacy `name` second.
// The names an org's starter workspace ships with — inlined in BOTH functions
// below (not a shared module constant): each is registered on
// `context.functions` and frank-lifted on its own, where a module-scope
// binding or a sibling call reads as undefined (FA203/FA204).
const $0422df0e6113a6f3$export$43a031be91c380e4 = (name)=>{
    const n = String(name == null ? '' : name).trim().toLowerCase();
    return !n || [
        'default',
        'workspace',
        'main',
        'untitled'
    ].indexOf(n) !== -1;
};
const $0422df0e6113a6f3$export$5da7f3fd96672f63 = (root)=>{
    if (!root || typeof root !== 'object') return '';
    const ws = root.workspace;
    const wsName = String(ws && (ws.displayName || ws.name) || '').trim();
    const generic = [
        'default',
        'workspace',
        'main',
        'untitled'
    ].indexOf(wsName.toLowerCase()) !== -1;
    if (wsName && !generic) return wsName;
    const org = root.org;
    const orgName = String(org && (org.name || org.displayName) || '').trim();
    return orgName;
};

});

parcelRegister("5e5Ez", function(module, exports) {

$parcel$export(module.exports, "agentDisplayName", () => $3ce2a52ca1ca246a$export$420f302e27a2c0d1);
'use strict';
const $3ce2a52ca1ca246a$export$420f302e27a2c0d1 = (agent, lang)=>{
    if (!agent || typeof agent !== 'object') return '';
    const translated = lang ? agent.metadata?.nameI18n?.[lang] : null;
    if (typeof translated === 'string' && translated.trim()) return translated;
    return agent.name || '';
};

});


parcelRegister("hLz4a", function(module, exports) {

$parcel$export(module.exports, "ChatMessage", () => $cef206db2df1af69$export$423c13fd52bec8ad);

var $9GdJK = parcelRequire("9GdJK");
const $cef206db2df1af69$export$423c13fd52bec8ad = {
    // FA204 / frank trap — initial/themeForRole used to be bare module-scope
    // const read from inside Avatar.theme/Avatar.text (serialized factories);
    // they read as undefined once this component is frank.toJSON'd for
    // platform delivery. Moved into `scope`, called via `el.scope.<name>`.
    scope: {
        initial (name) {
            return (name || '?')[0].toUpperCase();
        },
        themeForRole (role) {
            return role === 'user' ? 'primary' : role === 'system' ? 'warning' : role === 'tool' ? 'info' : 'success';
        },
        // AIUX-CHROME item 4 (tickets/sonnet.md, live-verified 2026-08-13) — on a
        // synthesized failure answer (failWorkspaceLoop; ChatMessage's own
        // `onInit`/`onUpdate` comment above documents the shape), the server puts
        // its RAW diagnostic straight into the message's own `text` — proven live:
        // "The Symbols Service (managed AI) is currently unavailable — Symbols
        // Service produced no output — empty SSE stream from
        // https://symbols-service-production.up.railway.app/api/chat (no deltas,
        // no tool calls, no error frame)…", `metadata.errorCode:
        // 'AI_PROVIDER_UNAVAILABLE'`. That string (stream internals, a raw
        // backend URL) is developer copy, never user copy. Only `errorCode` is a
        // safe, structured signal — never echo `metadata.errorMessage` /
        // `s.text` for a non-credits error. Credits-exhaustion codes keep their
        // OWN dedicated banner + copy (notifyCreditsExhaustedFromMessage) — this
        // returns null for those so the caller falls back to the normal text.
        //
        // `memberText: true` (an unkept-promise turn, `errorCode:
        // 'TURN_ENDED_ON_PROMISE'`) marks text the server wrote FOR the member:
        // the model's own words plus a stop line in the member's language. That
        // row shows its text as written (null → the caller renders `s.text`);
        // an empty text still gets the generic line below, so no row is blank.
        humanErrorText (metadata, tools, text) {
            if (metadata && metadata.memberText === true && String(text || '').trim()) return null;
            const code = String(metadata && metadata.errorCode || '');
            if ([
                'INSUFFICIENT_CREDITS',
                'SPEND_CAP_EXCEEDED',
                'ALLOCATION_EXCEEDED'
            ].includes(code)) return null;
            // A turn can fail AFTER its tools already ran: the write landed and only
            // the summarizing model call came back empty. Reporting that as "the AI
            // service is unavailable" tells the user nothing happened when in fact
            // something did — measured 2026-08-14, three of eight `create_note` turns
            // created the document and still rendered a bare failure, with the row's
            // own `tools[]` carrying "Done: create_note completed successfully"
            // right next to the denial. Lead with what completed.
            const done = (tools || []).filter((t)=>t && t.status === 'done');
            const failed = (tools || []).filter((t)=>t && t.status === 'error');
            // AI-301 — when the row knows WHAT got made (t.created, stamped by the
            // transport), name the actual item; the humanized tool name is the
            // fallback for tools without a structured outcome.
            const nameTools = (list)=>list.map((t)=>t.created && (t.created.title || t.created.name) ? `\u{201C}${String(t.created.title || t.created.name)}\u{201D}` : String(t.tool || '').replace(/_/g, ' ')).join(', ');
            // A failed tool (status 'error', set by the transport on ok:false) is the
            // failure itself. Name it. Never blame the summary for it.
            if (failed.length) {
                if (done.length) return `${nameTools(failed)} failed, so this answer stopped. ${nameTools(done)} finished and is saved. ` + 'Ask me to continue when you are ready.';
                return `${nameTools(failed)} failed. Try again, or switch models if it keeps happening.`;
            }
            if (done.length) return `I finished ${done.length === 1 ? 'this action' : 'these actions'} \u{2014} ${nameTools(done)} \u{2014} but ` + "couldn't write the summary afterwards. That work is saved; nothing needs redoing. " + 'Ask me to continue when you are ready.';
            if (code === 'AI_PROVIDER_UNAVAILABLE') return 'The AI service is temporarily unavailable. Try again in a moment, or switch models.';
            return 'Something went wrong answering that. Try again, or switch models if it keeps happening.';
        },
        // Is this row a non-credits synthesized-error answer with a retry/switch
        // affordance worth showing? (credits errors get their own CTA via the
        // notification banner, not an inline retry.)
        isRetryableError (s) {
            if (!s || s.role !== 'assistant' || s.streaming) return false;
            const metadata = s.metadata;
            if (!metadata || metadata.kind !== 'error') return false;
            const code = String(metadata.errorCode || '');
            if ([
                'INSUFFICIENT_CREDITS',
                'SPEND_CAP_EXCEEDED',
                'ALLOCATION_EXCEEDED'
            ].includes(code)) return false;
            // NEVER offer retry once a tool has already run in this turn. The server
            // marks provider emptiness `retryable: true`, but a retry re-runs the
            // whole turn — and the tools that already succeeded run a SECOND time.
            // Measured 2026-08-14: one turn silently created the same document twice.
            // Continuing is safe; retrying is not.
            if ((s.tools || []).some((t)=>t && t.status === 'done')) return false;
            return metadata.retryable !== false;
        },
        // AI-304 (tickets/ai.md) — the failed-AFTER-tools case Retry deliberately
        // abandons: work landed, only the summarizing turn died, and the user had
        // no one-click way forward. Continue sends a resume prompt through the
        // normal send path; the conversation's persisted tool results give the
        // model its state, and duplicate-safety is AI-202's server-side
        // idempotency replay (an identical re-issued write returns the ORIGINAL
        // result instead of a second row). Credits errors stay excluded — their
        // banner owns the CTA.
        isContinuableError (s) {
            if (!s || s.role !== 'assistant' || s.streaming) return false;
            const metadata = s.metadata;
            if (!metadata || metadata.kind !== 'error') return false;
            const code = String(metadata.errorCode || '');
            if ([
                'INSUFFICIENT_CREDITS',
                'SPEND_CAP_EXCEEDED',
                'ALLOCATION_EXCEEDED'
            ].includes(code)) return false;
            return (s.tools || []).some((t)=>t && t.status === 'done');
        },
        // AI-302 (tickets/ai.md) — the render-time gate: tool-call protocol text
        // must never render as the answer, in EVERY ChatMessage host. The
        // workspace app already guards at its state layer (simoneAiTransport +
        // sessions._toChatMessages, functions/_simone/protocolText.js — the
        // canonical, tested copy); docs/preview mount this component with their
        // own transports and get THIS last line of defense. Deliberately a
        // compact INLINE twin of that helper — scope methods must be
        // self-contained for frank/brender serialization, so an import cannot
        // express it; keep the two in step when either changes. Conservative by
        // the same rules: fenced code and JSON-bearing prose are never flagged;
        // whole-text call shapes, wire markers, and the measured truncated
        // fragment are. Returns the neutral notice, or null for a clean text.
        protocolLeakNotice (text) {
            const t = String(text || '').trim();
            if (!t || t.startsWith('```')) return null;
            const NOTICE = "This reply contained internal tool instructions instead of an answer \u2014 the raw output was kept for diagnosis. Ask again if anything is missing.";
            if (t.startsWith('{') && t.endsWith('}')) {
                try {
                    const p = JSON.parse(t);
                    if (p && typeof p === 'object' && !Array.isArray(p)) {
                        const bag = p.tool_call && typeof p.tool_call === 'object' ? p.tool_call : p;
                        const isCall = typeof bag.name === 'string' && bag.name.trim() && (p.tool_call !== undefined || Object.prototype.hasOwnProperty.call(bag, 'arguments') || Object.prototype.hasOwnProperty.call(bag, 'args'));
                        if (isCall) return NOTICE;
                    }
                } catch (_) {
                /* unparseable — fall through to the fragment rules */ }
                if (/^\{\s*"tool_call"\s*:/.test(t)) return NOTICE;
            }
            if (/^\[Tool call\]/.test(t) || /^RTLU to=functions\./.test(t)) return NOTICE;
            const fragment = /^"[A-Za-z_][\w-]*"\s*:/.test(t) && /[}\]]\s*$/.test(t) && t.length <= 400 && !/[.!?]\s+[A-Z]/.test(t);
            return fragment ? NOTICE : null;
        },
        // ── GROUNDING (spec §4.2–4.3) ────────────────────────────────────────
        // Scope methods, not module-scope consts: the factories below are
        // serialized by frank.toJSON and a bare module read is `undefined` there
        // (the FA204 trap this whole file is organised around). Each method is
        // self-contained for the same reason — no method calls a sibling.
        // Band → semantic INK token.
        //
        // The band is resolved from whatever the server sent: `band` is the
        // authority when present, and a result that carried only a `score` still
        // resolves off the spec §4.3 thresholds (High ≥ .80 · Moderate ≥ .55 ·
        // Low ≥ .30 · Insufficient < .30), so the pill can never read "Unscored"
        // for an answer that WAS scored. `confBandKey` below repeats the ladder
        // rather than calling this one — sibling scope methods are reachable, but
        // each returns a different thing and neither is the other's helper.
        //
        // These four tokens are the adaptive light-dark pairs
        // from the design system (shared/designSystem/color.js) — a raw hue would
        // fail contrast on one of the two stages (Rule 67). An unscored row takes
        // `caption`, the house muted ink: quiet, but never invisible.
        confTone (confidence) {
            let band = '';
            if (confidence && typeof confidence === 'object') {
                const named = String(confidence.band || '').toLowerCase();
                if ([
                    'high',
                    'moderate',
                    'low',
                    'insufficient'
                ].includes(named)) band = named;
                else {
                    const score = typeof confidence.score === 'number' ? confidence.score : null;
                    if (score != null) band = score >= 0.8 ? 'high' : score >= 0.55 ? 'moderate' : score >= 0.3 ? 'low' : 'insufficient';
                }
            }
            const TONES = {
                high: 'successInk',
                moderate: 'accentInk',
                low: 'warningInk',
                insufficient: 'dangerInk'
            };
            return TONES[band] || 'caption';
        },
        // '0–1' → '72%'. Returns '' when there is no number, so the pill shows the
        // band label alone rather than a bare '%'.
        confPercent (confidence) {
            const score = confidence && typeof confidence === 'object' && typeof confidence.score === 'number' ? confidence.score : null;
            if (score == null) return '';
            return Math.round(Math.max(0, Math.min(1, score)) * 100) + '%';
        },
        // The six weighted factors, in the spec's own order, as breakdown rows.
        // ALWAYS six — a factor the server omitted renders an empty bar rather
        // than vanishing, so the shape of the score stays readable and two
        // answers stay comparable.
        confRows (confidence) {
            const b = confidence && typeof confidence === 'object' && confidence.breakdown || {};
            // The polyglot key rides on the ROW as a LITERAL. Building it at the
            // render site (`'ai.confidence.factor.' + s.factor`) is banned: a key
            // assembled at runtime is invisible to grep, to the en/ka parity test
            // and to the extraction tooling (docs/I18N-CONVENTION.md §1.3, enforced
            // by i18nSharedExtraction's "no key is built by concatenation").
            const FACTORS = [
                [
                    'precedent',
                    'ai.confidence.factor.precedent'
                ],
                [
                    'coverage',
                    'ai.confidence.factor.coverage'
                ],
                [
                    'authority',
                    'ai.confidence.factor.authority'
                ],
                [
                    'freshness',
                    'ai.confidence.factor.freshness'
                ],
                [
                    'consistency',
                    'ai.confidence.factor.consistency'
                ],
                [
                    'self',
                    'ai.confidence.factor.self'
                ]
            ];
            return FACTORS.map(([k, labelKey])=>{
                const raw = typeof b[k] === 'number' ? b[k] : null;
                return {
                    key: 'cf-' + k,
                    factor: k,
                    labelKey: labelKey,
                    value: raw,
                    pct: raw == null ? 0 : Math.round(Math.max(0, Math.min(1, raw)) * 100)
                };
            });
        },
        // Band → its polyglot key, as LITERALS for the same reason as confRows
        // above. Returns '' for an unscored answer; the render site then reaches
        // for the 'unscored' key by its own literal.
        confBandKey (confidence) {
            let band = '';
            if (confidence && typeof confidence === 'object') {
                const named = String(confidence.band || '').toLowerCase();
                if ([
                    'high',
                    'moderate',
                    'low',
                    'insufficient'
                ].includes(named)) band = named;
                else {
                    const score = typeof confidence.score === 'number' ? confidence.score : null;
                    if (score != null) band = score >= 0.8 ? 'high' : score >= 0.55 ? 'moderate' : score >= 0.3 ? 'low' : 'insufficient';
                }
            }
            const BAND_KEYS = {
                high: 'ai.confidence.band.high',
                moderate: 'ai.confidence.band.moderate',
                low: 'ai.confidence.band.low',
                insufficient: 'ai.confidence.band.insufficient'
            };
            return BAND_KEYS[band] || '';
        },
        // ── THE ADVICE LEVEL (vault spec 06 §7) ─────────────────────────────
        // The server's level bag, read for the pill. Only a workspace that grades
        // its answers (`settings.gradientCeiling` on the server) sends one; every
        // other row carries `level: null` and this returns null, so the block
        // never renders there. NO POSITION, NO PILL: the drawer never guesses a
        // level. A refused answer is named Out of scope, never shown as a low
        // number. Keys ride as LITERALS, for the reason confRows gives.
        levelView (level) {
            if (!level || typeof level !== 'object') return null;
            const num = (v)=>{
                if (v === null || v === undefined || v === '') return null;
                const n = Number(v);
                return Number.isInteger(n) && n >= 0 && n <= 10 ? n : null;
            };
            const refused = level.refused === true;
            const emitted = num(level.emitted);
            if (!refused && emitted === null) return null;
            const BANDS = [
                [
                    3,
                    'ai.level.band.legalNote'
                ],
                [
                    6,
                    'ai.level.band.legalRecommendation'
                ],
                [
                    7,
                    'ai.level.band.legalDecision'
                ],
                [
                    8,
                    'ai.level.band.commercialNote'
                ],
                [
                    9,
                    'ai.level.band.commercialRecommendation'
                ],
                [
                    10,
                    'ai.level.band.commercialDecision'
                ]
            ];
            const band = refused ? null : BANDS.find(([top])=>emitted <= top);
            const ceilings = (Array.isArray(level.ceilings) ? level.ceilings : []).map((c, i)=>({
                    key: 'lc-' + i,
                    text: String(typeof c === 'string' ? c : c && (c.reason || c.text || c.condition) || '').trim()
                })).filter((c)=>c.text);
            const r = level.retreat && typeof level.retreat === 'object' ? level.retreat : null;
            return {
                refused: refused,
                labelKey: refused ? 'ai.level.outOfScope' : band[1],
                value: refused ? '' : String(emitted),
                requested: num(level.requested),
                emitted: emitted,
                ceilings: ceilings,
                retreat: r ? String(r.condition || r.reason || '').trim() : ''
            };
        },
        // ── A QUESTION UNDER ITS STEP (Nika 2026-10-28: "fix positioning") ──
        // A question card (choice / confirm) that names a step's call id
        // (`_callId`) is drawn under that step (ChatToolStep); every other card
        // stays in Cards. One rule for both, so a card is drawn exactly once.
        // `_step` tells the card a step row sits above it (a closed card leaves
        // the reason to that row); `_pickOnRow`, that the row names its answer
        // (the card's folded line then keeps the question and Change).
        stepAsks (cards, id, row) {
            if (id == null || !Array.isArray(cards)) return [];
            const onRow = this.rowNamesPick(row);
            return cards.filter((c)=>!!c && (c.type === 'choice' || c.type === 'confirm') && c._callId != null && String(c._callId) === String(id)).map((c, i)=>({
                    key: 'ask-' + String(c._cardId || i),
                    ...c,
                    _step: true,
                    _pickOnRow: onRow
                }));
        },
        // THE ANSWER IS SAID ONCE (coordinator W3a, 2026-10-29: "You chose
        // “Blue”" on the row, and "Blue" again on the card's folded line under
        // it). The row names the answer when its question is done and its
        // `answer` (the transport's stamp, a reload's restore) fits the row
        // whole: 48 characters, the row's own limit (ChatToolRow). A longer
        // answer reads "You answered" there and its card keeps the words; an
        // Edit has no `answer` (its card says what should change). Only a
        // question's row names an answer (the tools ChatToolRow's label reads).
        rowNamesPick (row) {
            const answer = row && typeof row.answer === 'string' ? row.answer.trim() : '';
            const tool = String(row && row.tool || '').replace(/^module_fn_/, '');
            const asks = [
                'ask_user',
                'askUser',
                'confirm_with_user',
                'confirmWithUser'
            ].includes(tool);
            return asks && row.status === 'done' && answer !== '' && answer.length <= 48;
        },
        // A step's row with the questions it asked (`_asks`). The drawn row is
        // the thread's row: an answered question's row names the pick ("You
        // chose “Yes”", ChatToolRow) from the `answer` the transport stamps and a
        // reload restores. It used to drop that `answer` whenever an answered
        // card sat under the step, so live every answered question read "You
        // answered" (F3 live, W11 dev 2026-10-29: confirm "Yes", ask "Blue").
        stepRow (t, cards) {
            return {
                key: t.id,
                ...t,
                _asks: this.stepAsks(cards, t && t.id, t)
            };
        },
        looseCards (s) {
            const cards = Array.isArray(s && s.cards) ? s.cards : [];
            const tools = Array.isArray(s && s.tools) ? s.tools : [];
            if (!cards.length) return [];
            const steps = new Set(tools.map((t)=>t && t.id != null ? String(t.id) : ''));
            return cards.filter((c)=>!(c && s.role === 'assistant' && (c.type === 'choice' || c.type === 'confirm') && c._callId != null && steps.has(String(c._callId))));
        }
    },
    // Hide assistant rows that have no text and aren't streaming — otherwise
    // the Meta line (Author + Time) renders as a ghost row. A row that carries
    // cards or an agentic tool timeline is content too.
    if: (el, s)=>s.role !== 'assistant' || !!s.text || !!s.streaming || !!(s.cards && s.cards.length) || !!(s.tools && s.tools.length),
    // Credits-exhausted UX (tickets/opus.md) — the metadata-key check the
    // ticket calls for: `s.metadata` carries `{ kind:'error', errorCode, … }`
    // when this row is failWorkspaceLoop's synthesized answer (live turn: SDK
    // AiService → simoneAiTransport's onDone patch; reload: sessions.js
    // _toChatMessages). notifyCreditsExhaustedFromMessage (workspace/functions/
    // creditGuard.js) does the actual role-aware notification/banner work —
    // this is only the wiring, kept intentionally dumb and defensive: docs/
    // preview mount ChatMessage too and don't register that function, so a
    // missing-function throw must never break the row.
    //
    // Both onInit (a HISTORY-loaded row already carries metadata at creation —
    // onUpdate never fires for it) and onUpdate (a LIVE row's metadata lands
    // in a later patch, after the row already exists and is mid-stream) are
    // wired to the same call — notifyCreditsExhaustedFromMessage dedupes by
    // message id itself, so calling it from both is idempotent.
    onInit: (el, s)=>{
        if (s.role === 'assistant' && s.metadata && s.metadata.kind === 'error') try {
            el.call('notifyCreditsExhaustedFromMessage', el, s);
        } catch (_) {
        /* function not registered on this app (docs/preview) — no-op */ }
    },
    onUpdate: (el, s)=>{
        if (s.role === 'assistant' && s.metadata && s.metadata.kind === 'error') try {
            el.call('notifyCreditsExhaustedFromMessage', el, s);
        } catch (_) {
        /* function not registered on this app (docs/preview) — no-op */ }
    },
    flow: 'x',
    gap: 'Z',
    width: '100%',
    align: 'flex-start',
    flexDirection: (el, s)=>s.role === 'user' ? 'row-reverse' : 'row',
    // Entrance — each new row rises in softly (one-shot: CSS animations run at
    // node creation only, and rows are keyed keep-alive, so streaming patches
    // never re-trigger it). Brand keyframe, ~iOS timing.
    animationName: 'fadeInUpShort',
    animationDuration: '340ms',
    animationTimingFunction: 'cubic-bezier(0.32, 0.72, 0, 1)',
    // Consecutive same-author rows (s._grouped, set in Chat.js → Messages
    // children) stack tightly: pull the row up against the list's 'A' gap.
    // Done via a static modifier — a reactive `marginTop: (el,s)=>…` token is a
    // spacing prop with a function value, which this bundle's DOMQL drops.
    isGrouped: (el, s)=>!!s._grouped,
    '.isGrouped': {
        marginTop: 'calc(var(--spacing-A) * -0.55)'
    },
    Avatar: {
        // No avatar for assistant rows (full-width stacked block) nor for
        // continuation rows of a same-author group. User avatar lives in Meta so
        // it aligns with the "You" + timestamp line.
        if: (el, s)=>s.role !== 'assistant' && s.role !== 'user' && !s._grouped,
        width: 'B',
        height: 'B',
        borderRadius: '50%',
        align: 'center center',
        flexShrink: '0',
        fontSize: 'Z1',
        fontWeight: '700',
        theme: (el, s)=>el.scope.themeForRole(s.role),
        text: (el, s)=>el.scope.initial(s.role === 'user' ? el.call('polyglot', 'ai.chat.you') : s.role === 'system' ? '!' : s.role === 'tool' ? 'T' : 'C')
    },
    Stack: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        flex: '1 1 auto',
        // Assistant has no avatar gutter → take the full row width.
        maxWidth: (el, s)=>s.role === 'assistant' || s.role === 'user' ? '100%' : 'calc(100% - 36px)',
        align: (el, s)=>s.role === 'user' ? 'flex-end stretch' : 'flex-start stretch',
        Meta: {
            // Skip the repeated Author/Time header on grouped continuation rows.
            if: (el, s)=>!s._grouped,
            flow: 'x',
            gap: 'Y',
            align: 'center',
            flexDirection: (el, s)=>s.role === 'user' ? 'row-reverse' : 'row',
            alignSelf: (el, s)=>s.role === 'user' ? 'flex-end' : undefined,
            isAssistantMeta: (el, s)=>s.role === 'assistant',
            '.isAssistantMeta': {
                paddingLeft: 'A'
            },
            UserAvatar: {
                extends: 'Avatar',
                if: (el, s)=>s.role === 'user',
                avatarType: 'initials',
                boxSize: 'B',
                flexShrink: '0',
                src: (el, s)=>{
                    const u = s.root && s.root.authUser;
                    return u && (u.avatar || u.avatarUrl) || el.call('avatarUrlFor', s.root?.currentUserEmail);
                },
                alt: (el, s)=>{
                    const u = s.root && s.root.authUser;
                    s.root?.lang;
                    return u && (u.name || u.email) || el.call('polyglot', 'ai.chat.you');
                }
            },
            Author: {
                // The author is a property of THE MESSAGE, never of the thread's live
                // routing target. `s.agentName` is stamped at write time (the
                // simoneAiTransport placeholder) and restored from the persisted
                // metadata on a history reload (sessions._toChatMessages), so it is
                // the only agent identity this factory may read. Assistant rows with
                // no agent carry the product AI title, not "Claude".
                // AI-TALK-TO-AGENT-REUSES-OPEN-THREAD-1: a `root._targetAgentName`
                // fallback here re-labelled every EARLIER reply the moment the user
                // pressed "Talk to QA". Measured on production 2026-08-30 06:43 — a
                // reply the general assistant wrote redrew its author as `QA`, same
                // id, same timestamp, same body, so the transcript then claimed an
                // author that never wrote it.
                text: (el, s)=>{
                    s.root?.lang;
                    return s.role === 'user' ? el.call('polyglot', 'ai.chat.you') : s.role === 'system' ? el.call('polyglot', 'ai.chat.system') : s.role === 'tool' ? s.toolName || el.call('polyglot', 'ai.chat.tool') : s.agentName || el.call('polyglot', 'ai.chat.assistant');
                },
                fontSize: 'Z1',
                fontWeight: '700',
                color: 'title'
            },
            Time: {
                if: (el, s)=>!!s.ts,
                text: (el, s)=>{
                    const d = new Date(s.ts);
                    return el.call('localizedDate', d, {
                        hour: 'numeric',
                        minute: '2-digit'
                    });
                },
                fontSize: 'Z1',
                color: 'caption'
            }
        },
        // Live agentic timeline — the tools this assistant message ran while
        // answering (structured tool.activity frames upserted by the transport;
        // history turns get theirs folded in by sessions._toChatMessages). Rendered
        // ABOVE the answer text, in run order, each row expandable to its exact
        // input/result. Stable keys (tool call id) keep rows from remounting as
        // the array is re-patched during streaming. PERMANENTLY mounted (no `if`) —
        // an if-gated container only mounts when the first tool arrives and gets
        // APPENDED after the answer bubble, putting the steps BELOW the answer;
        // an empty children list renders zero-height, so the always-on container
        // costs nothing and keeps its chronological slot.
        Activity: {
            flow: 'y',
            width: '100%',
            minWidth: '0',
            // ON THE ANSWER'S TEXT EDGE: this inset plus the row's own `Z`
            // (ChatToolRow Head) is the answer block's `A` (Md) — Y + Z = A on the
            // golden scale. `Z` here put the status glyph 4px right of the text.
            paddingLeft: 'Y',
            // A step with the question it asked under it (ChatToolStep, Nika
            // 2026-10-28 "fix positioning"): each row carries the question cards
            // that name its call (`_asks`, always present — a key absent at first
            // render is never tracked), and leaves an answer its card shows to
            // that card (scope.stepRow).
            childExtends: 'ChatToolStep',
            childrenAs: 'state',
            // `s.tools` is read FIRST and unconditionally: behind the role check,
            // an assistant row whose `tools` key was absent at first render never
            // tracked the dependency (short-circuit + absent-key read), so the
            // factory never re-fired and the live timeline stayed empty. The
            // transport also seeds tools:[] on the placeholder — both halves are
            // deliberate (see simoneAiTransport placeholder note). `s.cards` the
            // same way: a question card lands after its step.
            children: (el, s)=>{
                const tools = s.tools || [];
                const cards = s.cards || [];
                if (s.role !== 'assistant') return [];
                return tools.map((t)=>el.scope.stepRow(t, cards));
            }
        },
        ToolBubble: {
            if: (el, s)=>s.role === 'tool',
            extends: 'ToolCallCard'
        },
        Bubble: {
            if: (el, s)=>s.role !== 'tool',
            alignSelf: (el, s)=>s.role === 'user' ? 'flex-end' : 'flex-start',
            maxWidth: (el, s)=>s.role === 'assistant' ? '100%' : '85%',
            borderRadius: 'B B Y B',
            // Padding MUST be a static token value. A reactive
            // `padding: (el,s) => …'Z A'` is a spacing prop with a function value,
            // which this bundle's DOMQL drops entirely — that's why every bubble
            // rendered with padding:0 ("bubbles lost padding"). Base = the
            // user/system padded bubble; the flush full-width assistant variant
            // lives in the static `.isAssistant` modifier so its tokens resolve.
            padding: 'Z A',
            isAssistant: (el, s)=>s.role === 'assistant',
            isUser: (el, s)=>s.role === 'user',
            // Live-answer feel: while THIS message is the one actively streaming
            // (s.streaming, flipped false server-side when the turn ends — see
            // simoneAiTransport.js `_patchAssistantMessage(..., { streaming: false })`)
            // its tail fades in via a masked gradient on the bottom edge (~last
            // fifth of the block). The mask is recomputed by the browser on every
            // layout pass as the text grows, so newly arriving lines materialize
            // softly with NO per-delta JS or re-render loop. History rows (and the
            // other party's messages) never carry `streaming`, so they never
            // re-trigger this — only the live answer breathes.
            isStreaming: (el, s)=>s.role === 'assistant' && !!s.streaming && !!s.text,
            '.isAssistant': {
                padding: 'Y2 0'
            },
            '.isUser': {
                borderRadius: 'B B Y B'
            },
            // Standard maskImage only — Chrome unprefixed since 120; a webkit* camel
            // key would be silently dropped by css-in-props (not a registered prop).
            '.isStreaming': {
                maskImage: 'linear-gradient(to top, rgba(0,0,0,0.4) 0%, rgba(0,0,0,1) 20%)'
            },
            // borderRadius: 'B',
            fontSize: 'A',
            lineHeight: '1.5',
            wordBreak: 'normal',
            overflowWrap: 'anywhere',
            // Assistant = flush/transparent. User (sent) = a solid accent bubble that
            // reads in dark mode — the old 'primary' theme rendered a WHITE bubble in
            // dark mode (white blob + near-black text). System = warning.
            theme: (el, s)=>s.role === 'system' ? 'warning' : 'transparent',
            background: (el, s)=>s.role === 'user' ? 'blue' : undefined,
            color: (el, s)=>s.role === 'user' ? 'fillInk' : undefined,
            // Assistant text → rendered as MARKDOWN (bold, lists, code, links,
            // headings) via a `children:` factory (markdownToChildren). NOT
            // el.set/ChatMarkdown: el.set inside this reactive state-driven message
            // list re-fires the parent and wipes the subtree in v3.14 (see marketplace
            // MarketplaceDetailMarkdownBody) — that's why answers came back INVISIBLE.
            // A children spec diff-renders cleanly.
            Md: {
                if: (el, s)=>s.role === 'assistant' && !!s.text,
                flow: 'y',
                gap: 'Z',
                minWidth: '0',
                paddingLeft: 'A',
                '> ul': {
                    listStylePosition: 'inside',
                    paddingLeft: '0',
                    margin: '0'
                },
                '> ol': {
                    listStylePosition: 'inside',
                    paddingLeft: '0',
                    margin: '0'
                },
                // ── Markdown element polish (2026-07-25 per Nika "improve md
                // converting into domql looking better / clickable links / fully
                // interactive") — design-token styling for every element the
                // symbolize transpiler emits, so an assistant answer reads as
                // designed UI rather than raw browser defaults. Descendant rules
                // (not per-node props) so BOTH renderer paths — symbolize and the
                // brender-safe inline fallback — pick them up identically.
                '& table': {
                    display: 'block',
                    width: '100%',
                    overflowX: 'auto',
                    borderCollapse: 'collapse',
                    margin: 'Y 0 Z',
                    fontSize: 'Z1'
                },
                '& th': {
                    textAlign: 'left',
                    padding: 'Y Z1 Y 0',
                    borderBottom: '1px solid var(--color-line)',
                    color: 'var(--color-title)',
                    fontWeight: '700',
                    whiteSpace: 'nowrap'
                },
                '& td': {
                    padding: 'Y Z1 Y 0',
                    borderBottom: '1px solid var(--color-line)',
                    color: 'var(--color-paragraph)',
                    verticalAlign: 'top'
                },
                '& tbody tr:last-child td': {
                    borderBottom: 'none'
                },
                '& a': {
                    color: 'var(--color-blue)',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px',
                    cursor: 'pointer',
                    transition: 'A opacity defaultBezier'
                },
                '& a:hover': {
                    opacity: '.8'
                },
                '& pre': {
                    background: 'var(--color-line)',
                    padding: 'Z A',
                    borderRadius: 'var(--spacing-Z)',
                    overflowX: 'auto',
                    fontSize: 'Z1',
                    lineHeight: '1.5',
                    margin: 'Y 0'
                },
                '& code': {
                    background: 'var(--color-line)',
                    padding: 'V Y',
                    borderRadius: 'var(--spacing-Y)',
                    fontSize: '.92em'
                },
                '& pre code': {
                    background: 'transparent',
                    padding: '0'
                },
                '& blockquote': {
                    borderLeft: '2px solid var(--color-line)',
                    paddingLeft: 'A',
                    color: 'var(--color-caption)',
                    margin: 'Y 0'
                },
                '& hr': {
                    border: 'none',
                    borderTop: '1px solid var(--color-line)',
                    margin: 'A 0'
                },
                '& li': {
                    margin: '0 0 var(--spacing-Y2)'
                },
                '& p': {
                    margin: '0'
                },
                // ── Streaming render (2026-08-01, per Nika "streaming animation,
                // texts flickering, replacing loading") ─────────────────────────
                // STABLE NAMED children instead of a per-delta `children` factory:
                // the old factory returned a FRESH [text, caret] array on every SSE
                // delta, so DOMQL re-created both nodes each chunk — the caret's
                // blink animation restarted (reads as flicker) and the text node
                // remounted instead of mutating. Named children reconcile by key:
                // `StreamText`'s `text` factory re-evaluates in place (a plain
                // textContent write), the caret ELEMENT persists across the whole
                // turn, and the thinking Dots below hide in the same state pass the
                // first token lands — loading is REPLACED by the stream, no gap.
                Stream: {
                    if: (el, s)=>s.role === 'assistant' && !!s.streaming,
                    whiteSpace: 'pre-wrap',
                    // Soft entrance for the first tokens (brand `fadeIn` keyframes) —
                    // plays once when the stream block mounts, not per delta.
                    animationName: 'fadeIn',
                    animationDuration: '180ms',
                    animationTimingFunction: 'ease-out',
                    StreamText: {
                        tag: 'span',
                        whiteSpace: 'pre-wrap',
                        text: (el, s)=>s.text || ''
                    },
                    StreamCaret: {
                        tag: 'span',
                        display: 'inline-block',
                        width: '0.5em',
                        height: '1.05em',
                        marginLeft: 'V',
                        verticalAlign: 'text-bottom',
                        background: 'title',
                        animationName: 'blinking',
                        animationDuration: '800ms',
                        animationIterationCount: 'infinite'
                    }
                },
                // ── Final render — markdown parsed ONCE when the turn ends ──────
                // (parsing the full GROWING markdown per delta is O(n²) over a turn,
                // and half-finished markdown — mid-token `**`, unclosed fences —
                // renders as artifacts). The `if:` swap from Stream to Rendered is
                // the single intentional repaint of the turn; the fadeIn makes it a
                // designed settle instead of a flash. `>` heading rules ride here
                // because the markdown tree's top level is now one child deeper.
                Rendered: {
                    if: (el, s)=>s.role === 'assistant' && !s.streaming && !!s.text,
                    flow: 'y',
                    gap: 'Z',
                    minWidth: '0',
                    animationName: 'fadeIn',
                    animationDuration: '180ms',
                    animationTimingFunction: 'ease-out',
                    '> h1': {
                        fontSize: 'B',
                        lineHeight: '1.25',
                        margin: 'A 0 Z'
                    },
                    '> h2': {
                        fontSize: 'B',
                        lineHeight: '1.25',
                        margin: 'A 0 Z'
                    },
                    '> h3': {
                        fontSize: 'A1',
                        lineHeight: '1.3',
                        margin: 'Z 0 Y'
                    },
                    '> h4': {
                        fontSize: 'A1',
                        lineHeight: '1.3',
                        margin: 'Z 0 Y'
                    },
                    '> h5': {
                        fontSize: 'A',
                        lineHeight: '1.35',
                        margin: 'Y 0 V'
                    },
                    '> h6': {
                        fontSize: 'A',
                        lineHeight: '1.35',
                        margin: 'Y 0 V'
                    },
                    // Markdown → children via the SHARED, registered
                    // `renderAssistantMarkdown` (symbolize-markdown). el.call is a
                    // runtime string lookup, so it survives frank serialization on the
                    // brender (docs.symbols.app) — a bare module-ref to
                    // markdownToChildren / a components map inside this serialized
                    // factory throws there (frank doesn't rewrite free vars in hoisted
                    // helpers — see tickets/smbls.md). docs, preview and workspace all
                    // share one renderer.
                    //
                    // AIUX-CHROME item 4 — a synthesized-error row's `s.text` is the
                    // server's raw diagnostic (see `el.scope.humanErrorText` above);
                    // swap it for human copy before it ever reaches the renderer. Only
                    // credits-exhaustion codes are exempt (humanErrorText returns null
                    // for those, so they keep their own server text + banner), and so is
                    // a `memberText` row (its text is written for the member).
                    children: (el, s)=>{
                        const human = s.metadata && s.metadata.kind === 'error' ? el.scope.humanErrorText(s.metadata, s.tools, s.text) : null;
                        // AI-302 — the render-time protocol gate (el.scope
                        // .protocolLeakNotice): tool-call wire text never renders as the
                        // answer in ANY host. Checked on the text that would actually
                        // render; a human error override is already safe copy.
                        const leak = human ? null : el.scope.protocolLeakNotice(s.text);
                        return el.call('renderAssistantMarkdown', human || leak || s.text || '');
                    }
                }
            },
            // User / system messages render as plain text, preserving newlines.
            Plain: {
                if: (el, s)=>s.role !== 'assistant',
                whiteSpace: 'pre-wrap',
                text: (el, s)=>s.text || ''
            },
            // Streaming placeholder before the first delta lands — a quiet
            // "Thinking…" status line ("Working…" while a tool row is live above it),
            // with the pulsing dots carrying the motion.
            Dots: {
                if: (el, s)=>s.role === 'assistant' && !s.text && !!s.streaming,
                flow: 'x',
                gap: 'Y',
                align: 'center',
                padding: 'Y 0 Y A',
                PvThinkingLabel: {
                    tag: 'span',
                    fontSize: 'Z1',
                    color: 'caption',
                    fontWeight: '500',
                    animationName: 'blinking',
                    animationDuration: '1600ms',
                    animationTimingFunction: 'ease-in-out',
                    animationIterationCount: 'infinite',
                    text: (el, s)=>{
                        s.root?.lang;
                        const tools = s.tools || [];
                        // A step that waits for the person's OK is not "Thinking" — the
                        // same words as the island's head (one label, ai.chat.needsOk).
                        if (tools.some((t)=>t && t.status === 'approval')) return el.call('polyglot', 'ai.chat.needsOk');
                        return tools.some((t)=>t && t.status === 'running') ? el.call('polyglot', 'ai.chat.working') : el.call('polyglot', 'ai.chat.thinking');
                    }
                },
                // AI-305 (tickets/ai.md) — a LONG run must show motion beyond the
                // caret: count the completed tool rows live. Reads the same `s.tools`
                // the timeline above renders, so the number can never disagree with
                // the visible rows (the acceptance: counter === done rows). Empty
                // while nothing has completed — the label alone carries the idle
                // state, no "0 actions" noise. Steady (no blink): completed work is
                // a fact, not an in-flight signal.
                PvDoneCount: {
                    tag: 'span',
                    fontSize: 'Z1',
                    color: 'caption',
                    opacity: '.75',
                    hide: (el, s)=>!(s.tools || []).some((t)=>t && t.status === 'done'),
                    text: (el, s)=>{
                        s.root?.lang;
                        const n = (s.tools || []).filter((t)=>t && t.status === 'done').length;
                        if (!n) return '';
                        return el.call('polyglot', n === 1 ? 'ai.chat.actionDone' : 'ai.chat.actionsDone').replace('{count}', String(n));
                    }
                },
                PvDots: {
                    flow: 'x',
                    gap: 'X',
                    align: 'center',
                    childExtends: {
                        boxSize: 'X2',
                        round: '50%',
                        background: 'caption',
                        flexShrink: '0',
                        animationName: 'blinking',
                        animationDuration: '1100ms',
                        animationTimingFunction: 'ease-in-out',
                        animationIterationCount: 'infinite'
                    },
                    PvDot_1: {},
                    PvDot_2: {
                        animationDelay: '180ms'
                    },
                    PvDot_3: {
                        animationDelay: '360ms'
                    }
                }
            },
            // S1 (NIKA BATCH 2026-08-16) — token count + elapsed time for the
            // whole run, not just the pre-first-token wait (unlike Dots above,
            // which hides once `s.text` starts filling in). `Dots`/`Stream`/`Md`/
            // `Rendered` are siblings directly under `Bubble`, EACH gated by its
            // own `if:` — there's no shared wrapper to inherit a gate from
            // (verified via a live import + object-path walk, not assumed from
            // the visual indentation, which is inconsistent in this file).
            // `hide:`, never `if:`, so the interval-driven ticking node isn't
            // destroyed and recreated every time `s.streaming` flips. Both cells
            // reserve worst-case width — `9 → 10 → 100` must never reflow the
            // row, the ticket's own words for "worse than no counter".
            PvUsage: {
                tag: 'span',
                hide: (el, s)=>s.role !== 'assistant' || !s.streaming,
                flow: 'x',
                gap: 'V',
                align: 'center',
                padding: 'V 0 0 A',
                fontSize: 'Z1',
                color: 'caption',
                opacity: '.6',
                PvElapsed: {
                    tag: 'span',
                    display: 'inline-block',
                    minWidth: 'C',
                    // Left in its reserved cell: the line starts on the answer's text
                    // edge (right-aligned, "0s" began 22px in), and the reserved width
                    // still keeps 9 → 10 → 100 from reflowing the row.
                    textAlign: 'left',
                    fontVariantNumeric: 'tabular-nums',
                    whiteSpace: 'nowrap',
                    // `_tick` has no meaning of its own — simoneAiTransport.js's
                    // elapsed-timer interval touches it once a second purely to give
                    // this factory a state key to react to on pure wall-clock
                    // passage (no delta, no tool event fires otherwise).
                    text: (el, s)=>{
                        s._tick;
                        const secs = Math.max(0, Math.floor((Date.now() - (s.ts || Date.now())) / 1000));
                        return `${secs}s`;
                    }
                },
                PvUsageDot: {
                    tag: 'span',
                    text: "\xb7"
                },
                PvTokens: {
                    tag: 'span',
                    display: 'inline-block',
                    minWidth: 'C',
                    textAlign: 'right',
                    fontVariantNumeric: 'tabular-nums',
                    whiteSpace: 'nowrap',
                    // While streaming: a rough, explicitly-labeled ESTIMATE from the
                    // growing text (~4 chars/token, a common rough heuristic — never
                    // presented as exact). Once `s.usage` lands (onDone), the row
                    // shows the server's real, authoritative count instead — the
                    // "settles at a final value" half of the acceptance.
                    text: (el, s)=>{
                        if (s.usage && typeof s.usage.completionTokens === 'number') {
                            const total = (s.usage.promptTokens || 0) + s.usage.completionTokens;
                            return `${total} tokens`;
                        }
                        const estimate = Math.round((s.text || '').length / 4);
                        return estimate ? `~${estimate} tokens` : '';
                    }
                }
            }
        },
        // Picked-element refs the user attached when they sent this message.
        // Rendered as small chips BELOW the user bubble so they stay visible
        // when the message list auto-scrolls to the bottom.
        // O1 (opus.md): the picked-elements echo on a sent user message renders
        // with the ONE chip (read-only: no removeVia), same grammar as the composer's
        // AiContextBar — the fourth near-copy of this row is gone.
        PickedAttached: {
            if: (el, s)=>s.role === 'user' && !!(s.picked && s.picked.length),
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Z',
            alignSelf: 'flex-end',
            justifyContent: 'flex-end',
            maxWidth: '85%',
            childExtends: 'AiContextChip',
            childrenAs: 'state',
            children: (el, s)=>(s.picked || []).map((p, i)=>{
                    const kp = Array.isArray(p.keyPath) ? p.keyPath : [];
                    // An inspected region (the composer's Inspect & ask) went with the
                    // ask as structured facts — its chip says so (pageContext.js's
                    // composer chip reads the same way).
                    const region = !!(p.inspect && typeof p.inspect === 'object');
                    return {
                        key: 'picked-' + (p.pickedAt != null ? p.pickedAt : i),
                        id: 'picked:' + i,
                        kind: region ? 'region' : 'element',
                        title: kp.length ? kp.join(" \u203A ") : p.key || (p.tagPath || []).slice(-2).join(' > ') || p.tag || '(element)',
                        icon: region ? 'lnInspect' : 'cursor',
                        source: 'picked',
                        sent: region ? 'structured' : 'text-only',
                        removeVia: null,
                        tier: 'attached'
                    };
                })
        },
        // ── SOURCES (spec §4.2) ─────────────────────────────────────────────
        // The entities this answer actually cited, as chips under the reply.
        // Each entry is `{ ref, type, id, title, use, verified }` — the server's
        // persisted shape; `use` is the model's own one-line reason ("warranty
        // cap, cl. 9"), and `verified: false` marks a ref the turn's retrieval
        // never actually read (it is KEPT, not hidden — a claimed source the
        // tools did not open is information, and silently dropping it would make
        // an unverified answer look identical to a grounded one).
        //
        // The chip is composed INLINE rather than reusing AiContextChip: that
        // component's click is bound to the alterable-reference mute toggle and
        // its title factory renders the mute sentence, so a navigating chip with
        // a `use` caption would be fighting it. Same call the Suggestions row
        // below makes — an inline `childExtends`, not a fifth exported near-copy.
        Sources: {
            if: (el, s)=>s.role === 'assistant' && !s.streaming && Array.isArray(s.sources) && s.sources.length > 0,
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Y',
            width: '100%',
            minWidth: '0',
            marginTop: 'Z',
            paddingLeft: 'A',
            childrenAs: 'state',
            // A source may arrive as the bare string form or as the full row; both
            // normalize to a state bag the chip reads. `key` keeps rows stable
            // across the onDone patch that fills them in.
            children: (el, s)=>(s.sources || []).filter(Boolean).map((x, i)=>typeof x === 'string' ? {
                        key: 'src-' + i,
                        ref: x
                    } : {
                        key: 'src-' + i,
                        ...x
                    }),
            childExtends: 'ChatSourceChip'
        },
        // ── ADVICE LEVEL (vault spec 06 §7) ─────────────────────────────────
        // Only on a settled assistant row whose level bag took a position — a
        // workspace that does not grade its answers never renders this block.
        // It sits above Confidence, in the order the VaultOS answer sheet uses.
        // The pill takes the confidence pill's plate and metrics so the two read
        // as one family, but no tone: the level is not a second confidence. A
        // click discloses the requested and emitted levels, every ceiling that
        // applied and the retreat (06 §7). Expansion rides `root._aiLevelOpen`
        // keyed by message id — the confidence pill's own shape.
        Level: {
            if: (el, s)=>s.role === 'assistant' && !s.streaming && !!el.scope.levelView(s.level),
            flow: 'y',
            gap: 'Y',
            width: '100%',
            minWidth: '0',
            marginTop: 'Y',
            paddingLeft: 'A',
            color: 'caption',
            Pill: {
                tag: 'button',
                type: 'button',
                alignSelf: 'flex-start',
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                padding: 'X Z',
                round: 'radiusPill',
                background: 'overlay',
                borderWidth: '0',
                cursor: 'pointer',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'title',
                transition: 'B defaultBezier background',
                ':hover': {
                    background: 'hover'
                },
                aria: {
                    expanded: (el, s)=>!!(s.root && s.root._aiLevelOpen && s.root._aiLevelOpen[s.id]),
                    label: (el)=>el.call('polyglot', 'ai.level.toggle')
                },
                Label: {
                    tag: 'span',
                    text: (el, s)=>{
                        const v = el.scope.levelView(s.level);
                        return v ? el.call('polyglot', v.labelKey) : '';
                    }
                },
                Value: {
                    tag: 'span',
                    if: (el, s)=>!!(el.scope.levelView(s.level) || {}).value,
                    text: (el, s)=>(el.scope.levelView(s.level) || {}).value || '',
                    color: 'caption',
                    fontWeight: '400'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const root = s.root;
                    if (!root || !root.update) return;
                    const open = {
                        ...root._aiLevelOpen || {}
                    };
                    open[s.id] = !open[s.id];
                    // preventFetch — disclosure chrome, not a data read.
                    root.update({
                        _aiLevelOpen: open
                    }, {
                        preventFetch: true
                    });
                }
            },
            // `hide:` not `if:` — the Breakdown note below says why. The root key
            // is read behind a guard, so it is declared as a dependency (FA515).
            Detail: {
                hide: (el, s)=>!(s.root && s.root._aiLevelOpen && s.root._aiLevelOpen[s.id]),
                hideDeps: [
                    (el, s)=>s.root && s.root._aiLevelOpen
                ],
                flow: 'y',
                gap: 'X',
                width: '100%',
                minWidth: '0',
                padding: 'Z A2',
                round: 'radiusControl',
                background: 'overlay',
                Levels: {
                    tag: 'span',
                    fontSize: 'X',
                    color: 'caption',
                    text: (el, s)=>{
                        const v = el.scope.levelView(s.level);
                        if (!v) return '';
                        const asked = v.requested === null ? '' : el.call('polyglot', 'ai.level.requested') + ' ' + v.requested;
                        const given = v.emitted === null ? '' : el.call('polyglot', 'ai.level.emitted') + ' ' + v.emitted;
                        return [
                            asked,
                            given
                        ].filter(Boolean).join(" \xb7 ");
                    }
                },
                Ceilings: {
                    if: (el, s)=>((el.scope.levelView(s.level) || {}).ceilings || []).length > 0,
                    flow: 'y',
                    gap: 'X',
                    width: '100%',
                    minWidth: '0',
                    CeilingsTitle: {
                        tag: 'span',
                        fontSize: 'X',
                        fontWeight: '700',
                        color: 'caption',
                        text: (el)=>el.call('polyglot', 'ai.level.ceilingsTitle')
                    },
                    // Each ceiling is the sentence the server phrased — never re-worded.
                    CeilingsRows: {
                        flow: 'y',
                        gap: 'X',
                        children: (el, s)=>((el.scope.levelView(s.level) || {}).ceilings || []).map((c)=>({
                                    key: c.key,
                                    tag: 'span',
                                    fontSize: 'X',
                                    color: 'caption',
                                    text: c.text
                                }))
                    }
                },
                // A retreat is announced, never silently applied (02 §6).
                Retreat: {
                    tag: 'p',
                    if: (el, s)=>!!(el.scope.levelView(s.level) || {}).retreat,
                    margin: '0',
                    fontSize: 'X',
                    color: 'caption',
                    text: (el, s)=>el.call('polyglot', 'ai.level.retreat') + ': ' + (el.scope.levelView(s.level) || {}).retreat
                }
            }
        },
        // ── CONFIDENCE (spec §4.3) ──────────────────────────────────────────
        // On a SCORED assistant row in a workspace that grounds its answers (the
        // gate on `if:` below). Before server c9b2ea74 every answer carried the
        // pill and an unscored one read the muted "Unscored" — the server now
        // scores only where grounding is on, so "Unscored" everywhere else said
        // nothing true; a row with no verdict shows no pill. The muted label
        // stays for a verdict whose band cannot be read.
        //
        // The pill is the whole affordance; clicking it discloses the six
        // weighted factors, the caps that were applied and the one-line reason.
        // Expansion rides `root._aiConfidenceOpen` keyed by message id — the same
        // shape ChatToolRow uses for its own rows, so a reload or a thread switch
        // starts every row collapsed and two rows never share one flag.
        Confidence: {
            // The label shows only where the workspace grounds its answers — server
            // settings.ai.grounding, or a workspace that runs the advice gradient
            // (settings.gradientCeiling). The server writes a verdict only there
            // (server c9b2ea74, 2026-09-28), so a row without a SCORE shows NO pill
            // (never "Unscored"), and the workspace check also hides the verdicts
            // older rows carry from before that change. (core-wl's patch, with the
            // score read through confBandKey — an empty verdict `{}` is no score.)
            if: (el, s)=>{
                if (s.role !== 'assistant' || s.streaming) return false;
                if (!el.scope.confBandKey(s.confidence)) return false;
                // A capabilities answer (describe_capabilities / the composer's "What
                // can you do here?") is the workspace's own catalogue of what is
                // installed — deterministic, nothing to ground — and the verdict the
                // turn carries is about missing sources, not about it. Measured on
                // dev 2026-10-05: "Insufficient 0%" under the Tokens catalogue card.
                if ((Array.isArray(s.cards) ? s.cards : []).some((c)=>c && c.type === 'capabilities')) return false;
                const ws = s.root && s.root.workspace;
                const settings = ws && ws.settings || {};
                return settings.ai && settings.ai.grounding === true || settings.gradientCeiling !== undefined && settings.gradientCeiling !== null;
            },
            flow: 'y',
            gap: 'Y',
            width: '100%',
            minWidth: '0',
            marginTop: 'Y',
            paddingLeft: 'A',
            // The tone is declared ONCE, here, and both readings inherit it through
            // `currentColor`: the pill's label + dot, and the breakdown's bar fills.
            // Everything else in the block sets `caption` explicitly, so the tint
            // never leaks into body copy.
            color: (el, s)=>el.scope.confTone(s.confidence),
            Pill: {
                tag: 'button',
                type: 'button',
                alignSelf: 'flex-start',
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                padding: 'X Z',
                round: 'radiusPill',
                background: 'overlay',
                borderWidth: '0',
                cursor: 'pointer',
                fontSize: 'Y2',
                fontWeight: '700',
                // No `color` of its own: it inherits the container's tone above, and
                // the plate stays the neutral house wash so no hue FILL enters the
                // chrome register (design-direction §6/§8).
                transition: 'B defaultBezier background',
                ':hover': {
                    background: 'hover'
                },
                // A finger's target: the pill is 28px tall (measured on dev DFI) —
                // the 44pt floor (_touchTarget.js).
                '@coarse': {
                    position: 'relative',
                    ...(0, $9GdJK.touchFloor)
                },
                aria: {
                    expanded: (el, s)=>!!(s.root && s.root._aiConfidenceOpen && s.root._aiConfidenceOpen[s.id]),
                    label: (el)=>el.call('polyglot', 'ai.confidence.toggle')
                },
                Dot: {
                    boxSize: 'Y',
                    round: '50%',
                    background: 'currentColor',
                    flexShrink: '0'
                },
                Label: {
                    tag: 'span',
                    text: (el, s)=>{
                        const key = el.scope.confBandKey(s.confidence);
                        if (!key) return el.call('polyglot', 'ai.confidence.unscored');
                        // The server may send its OWN band label (spec §4.3 `bandLabel`);
                        // it wins, because it is the phrasing the score was computed with.
                        const stated = s.confidence && s.confidence.bandLabel;
                        return stated ? String(stated) : el.call('polyglot', key);
                    }
                },
                Score: {
                    tag: 'span',
                    if: (el, s)=>!!el.scope.confPercent(s.confidence),
                    text: (el, s)=>el.scope.confPercent(s.confidence),
                    color: 'caption',
                    fontWeight: '400'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const root = s.root;
                    if (!root || !root.update) return;
                    const open = {
                        ...root._aiConfidenceOpen || {}
                    };
                    open[s.id] = !open[s.id];
                    // preventFetch — this is disclosure chrome, not a data read (the
                    // same call ChatToolRow's row toggle makes).
                    root.update({
                        _aiConfidenceOpen: open
                    }, {
                        preventFetch: true
                    });
                }
            },
            // The breakdown. `hide:` not `if:` — an if-gated child REMOUNTS on every
            // flip and lands appended at the container's end (the trap ChatToolRow's
            // PvStatus note records); a hidden child keeps its slot.
            Breakdown: {
                hide: (el, s)=>!(s.root && s.root._aiConfidenceOpen && s.root._aiConfidenceOpen[s.id]),
                flow: 'y',
                gap: 'Y',
                width: '100%',
                minWidth: '0',
                padding: 'Z A2',
                round: 'radiusControl',
                background: 'overlay',
                // The six factors, as compact bars. Rows share one fontSize so their
                // labels and figures sit on one baseline (Rule 34).
                Factors: {
                    flow: 'y',
                    gap: 'Y',
                    width: '100%',
                    minWidth: '0',
                    childrenAs: 'state',
                    // `Factors` declares no state of its own, so `s` IS the message
                    // state it inherits — no `s.parent` hop (that would reach the
                    // Breakdown element's state, which is the same object anyway and
                    // reads as if a hop were needed).
                    children: (el, s)=>el.scope.confRows(s.confidence),
                    childExtends: 'ChatConfidenceFactor'
                },
                // The caps that clamped the score (spec §4.3: no sources → ≤ .29, one
                // source → ≤ .54, …). Each is a plain sentence the server already
                // phrased — never re-worded here.
                Caps: {
                    if: (el, s)=>Array.isArray(s.confidence?.caps) && s.confidence.caps.length > 0,
                    flow: 'y',
                    gap: 'X',
                    width: '100%',
                    minWidth: '0',
                    marginTop: 'Y',
                    CapsTitle: {
                        tag: 'span',
                        text: '{{ ai.confidence.capsTitle | polyglot }}',
                        fontSize: 'X',
                        fontWeight: '700',
                        color: 'caption'
                    },
                    // Plain children (element objects), not childrenAs+childExtends: a
                    // cap is one static sentence with no interaction and no reactive
                    // prop of its own, so a registered child component would be a name
                    // with nothing behind it (FA808 is about SHAPES worth naming).
                    CapsRows: {
                        flow: 'y',
                        gap: 'X',
                        children: (el, s)=>(s.confidence && s.confidence.caps || []).map((c, i)=>({
                                    key: 'cap-' + i,
                                    tag: 'span',
                                    fontSize: 'X',
                                    color: 'caption',
                                    text: typeof c === 'string' ? c : String(c && (c.text || c.reason) || '')
                                }))
                    }
                },
                // The one-line why. Last, because it reads as the summary of the rows
                // above it.
                Reason: {
                    tag: 'p',
                    if: (el, s)=>!!s.confidence?.reason,
                    margin: '0',
                    marginTop: 'Y',
                    fontSize: 'X',
                    color: 'caption',
                    text: (el, s)=>String(s.confidence.reason)
                },
                // No score at all — say so inside the disclosure too, so an opened
                // "Unscored" pill is not an empty box.
                NoScore: {
                    tag: 'p',
                    if: (el, s)=>!el.scope.confBandKey(s.confidence),
                    margin: '0',
                    fontSize: 'X',
                    color: 'caption',
                    text: '{{ ai.confidence.noScore | polyglot }}'
                }
            }
        },
        // The message's cards — all but a question its own step holds
        // (ChatToolStep). ON THE ANSWER'S TEXT EDGE, the Md block's `A` (Nika
        // 2026-10-28 "fix positioning"): the card box started on the message's
        // own edge, A (16–17px) left of the text above it in every host —
        // measured on dev at 1920 / 1280, in the drawer and at 390.
        Cards: {
            if: (el, s)=>el.scope.looseCards(s).length > 0,
            flow: 'y',
            gap: 'Z',
            width: '100%',
            minWidth: '0',
            marginTop: 'Y',
            paddingLeft: 'A',
            childExtends: 'ChatCard',
            childrenAs: 'state',
            children: (el, s)=>el.scope.looseCards(s)
        },
        // AI follow-up suggestions — the assistant's next-step CTAs, attached to
        // this reply (server-validated `metadata.suggestions`, grounded in the
        // workspace's apps + capabilities). Rendered on EVERY completed assistant
        // message that carries them (2026-08-12 per Nika "always followup with
        // beautiful buttons as call to actions from each message"), never while
        // the reply is still streaming; the newest row (`_last`, stamped in
        // Chat.js's Messages children map) reads at full strength while older
        // rows step back and wake on approach. Tapping one SENDS its prompt
        // immediately as the user's next message through the normal send path —
        // same-scope sendPrompt, so the drawer / dashboard / add-app instance
        // each route to their own thread and the AI continues automatically.
        // Solid `layer` capsules — fill-contrast, borderless (design-direction
        // §8), house `hover` wash + lift on approach (chrome register:
        // monochrome interaction, no hue fills). Distinct from ask_user choice
        // buttons (a required mid-task answer): these are OPTIONAL follow-ups.
        Suggestions: {
            if: (el, s)=>s.role === 'assistant' && !s.streaming && Array.isArray(s.suggestions) && s.suggestions.length > 0,
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Y',
            width: '100%',
            minWidth: '0',
            marginTop: 'Z',
            paddingLeft: 'A',
            // History rows keep their CTAs reachable but stepped back (static
            // opacity step — zero layout shift; the chips stay fully interactive
            // and carry their own hover feedback).
            opacity: (el, s)=>s._last ? '1' : '.7',
            transition: 'B opacity defaultBezier',
            animationName: 'fadeInUpShort',
            animationDuration: '420ms',
            animationTimingFunction: 'cubic-bezier(0.32, 0.72, 0, 1)',
            childrenAs: 'state',
            children: (el, s)=>(s.suggestions || []).map((x, i)=>({
                        key: 'sg-' + i,
                        ...x
                    })),
            childExtends: {
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                padding: 'Y Z1',
                minHeight: 'controlHCompact',
                round: 'radiusPill',
                // A finger's target: a 36px chip takes the house tap slop (_touchTarget.js).
                '@coarse': {
                    position: 'relative',
                    ...(0, $9GdJK.touchSlop)
                },
                // Solid elevated chip (the Starters' exact surface) — fill-contrast
                // separation, no hairline ring (design-direction §8); 'overlay' is a
                // 5% wash that reads as bare text on the document ground.
                theme: 'layer',
                color: 'title',
                fontSize: 'Z1',
                fontWeight: '500',
                cursor: 'pointer',
                border: 'none',
                maxWidth: '100%',
                minWidth: '0',
                textAlign: 'left',
                transition: 'B defaultBezier',
                transitionProperty: 'background-color, color, transform',
                // Hover = the house fill step + a small lift (chrome register:
                // monochrome interaction — hue never marks hover; the wash rides on
                // top of the layer chip).
                ':hover': {
                    background: 'hover',
                    transform: 'translateY(-1px)'
                },
                ':active': {
                    transform: 'translateY(0)'
                },
                // Nudge the arrow toward the action on hover — the chip reads as
                // "continue with this".
                ':hover > svg': {
                    transform: 'translateX(2px)'
                },
                // The follow-up's own words — the chip's primary text: it wraps
                // inside the capsule instead of being cut (the overflow law, §3b
                // rule 8; the chip already caps at the message's width).
                Label: {
                    tag: 'span',
                    text: (el, s)=>s.label,
                    minWidth: '0',
                    overflowWrap: 'anywhere'
                },
                // No explicit `color` — the glyph rides the button ink via
                // currentColor, so it flips to white with the hover fill.
                Icon: {
                    name: 'arrowRight',
                    fontSize: 'Z1',
                    flexShrink: '0',
                    transition: 'B transform defaultBezier'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    const prompt = s.prompt || s.label;
                    if (!prompt) return;
                    // Resolve this Chat instance's scope by walking up for `chatScope`
                    // — inlined (no helper import) so the walk survives frank
                    // serialization, same idiom as Chat.js `ck`.
                    let scope = 'general';
                    let n = el;
                    while(n){
                        if (n.chatScope) {
                            scope = n.chatScope;
                            break;
                        }
                        n = n.parent;
                    }
                    try {
                        // THE ASK ROUTER (workspace functions/assistantAskRoute.js
                        // assistantAskHandoff): a chip that clearly asks for another
                        // surface — a page, an app, slides, a website, the tour — goes
                        // there; every other chip continues this thread. Only the general
                        // thread routes (the builder's own chat never does).
                        const fns = el.context && el.context.functions;
                        if (scope === 'general' && fns && typeof fns.assistantAskHandoff === 'function' && el.call('assistantAskHandoff', prompt, {
                            from: 'chip'
                        })) return;
                        el.call('sendPrompt', prompt, scope);
                    } catch (_) {
                    /* transport not ready — chip is a no-op rather than a throw */ }
                }
            }
        },
        // AIUX-CHROME item 4 (tickets/sonnet.md) — "Rewrite [error copy] to
        // human copy + a retry / switch-model affordance." A synthesized-error
        // row (el.scope.isRetryableError — non-credits `metadata.kind:'error'`,
        // `retryable !== false`) gets a Retry button (re-sends the immediately
        // preceding user prompt through the normal send path — same mechanism
        // Suggestions above uses) and a Switch model button (opens the shared
        // model-switcher dropdown via the same `root._modelMenuOpen` flag
        // AiModelSwitcherTrigger uses — shared/components/AiModelSwitcher.js).
        // Credits-exhaustion errors are excluded — those already get a dedicated
        // banner + admin CTA (notifyCreditsExhaustedFromMessage) where a bare
        // "Retry" would just fail again.
        ErrorActions: {
            // AI-304 — the row shows for BOTH synthesized-error affordance sets:
            // retryable (no tool ran — Retry re-sends the prompt) and continuable
            // (a tool already completed — Continue resumes; Retry stays hidden so
            // the completed write is never re-run by reflex).
            if: (el, s)=>el.scope.isRetryableError(s) || el.scope.isContinuableError(s),
            flow: 'x',
            gap: 'Y',
            width: '100%',
            marginTop: 'Z',
            paddingLeft: 'A',
            // AI-304 — one-click resume for a failed-after-tools turn. Sends the
            // member's Continue word with a resume flag through the same sendPrompt
            // path the sibling buttons use; the conversation's persisted tool results give the model
            // its state, and AI-202's server-side idempotency replay makes an
            // accidentally re-issued identical write return the ORIGINAL result
            // instead of a duplicate row. Same chip anatomy as RetryBtn (house
            // layer pill).
            ContinueBtn: {
                hide: (el, s)=>!el.scope.isContinuableError(s),
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                padding: 'Y Z1',
                minHeight: 'controlHCompact',
                round: 'radiusPill',
                theme: 'layer',
                color: 'title',
                fontSize: 'Z1',
                fontWeight: '500',
                cursor: 'pointer',
                border: 'none',
                transition: 'B defaultBezier',
                transitionProperty: 'background-color, color, transform',
                ':hover': {
                    background: 'hover',
                    transform: 'translateY(-1px)'
                },
                ':active': {
                    transform: 'translateY(0)'
                },
                Icon: {
                    name: 'arrowRight',
                    fontSize: 'Z1',
                    flexShrink: '0'
                },
                Label: {
                    tag: 'span',
                    text: '{{ common.action.continue | polyglot }}'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    // Resolve this Chat instance's scope — inlined (frank-safe), same
                    // idiom as the sibling buttons.
                    let scope = 'general';
                    let n = el;
                    while(n){
                        if (n.chatScope) {
                            scope = n.chatScope;
                            break;
                        }
                        n = n.parent;
                    }
                    // The member's bubble says the chip's own word, in the member's
                    // language (persona round 4, elena: the model's resume instruction
                    // showed under "You"). The resume itself rides `opts.resume` →
                    // `context.resume`; the server tells the model to pick up without
                    // redoing the saved actions.
                    try {
                        el.call('sendPrompt', el.call('polyglot', 'common.action.continue'), scope, null, null, {
                            resume: true
                        });
                    } catch (_) {
                    /* transport not ready — chip is a no-op rather than a throw */ }
                }
            },
            RetryBtn: {
                hide: (el, s)=>el.scope.isContinuableError(s),
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                padding: 'Y Z1',
                minHeight: 'controlHCompact',
                round: 'radiusPill',
                theme: 'layer',
                color: 'title',
                fontSize: 'Z1',
                fontWeight: '500',
                cursor: 'pointer',
                border: 'none',
                transition: 'B defaultBezier',
                transitionProperty: 'background-color, color, transform',
                ':hover': {
                    background: 'hover',
                    transform: 'translateY(-1px)'
                },
                ':active': {
                    transform: 'translateY(0)'
                },
                Icon: {
                    name: 'refresh',
                    fontSize: 'Z1',
                    flexShrink: '0'
                },
                Label: {
                    tag: 'span',
                    text: '{{ common.action.try_again | polyglot }}'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    // Resolve this Chat instance's scope — inlined (frank-safe), same
                    // idiom as the Suggestions button above.
                    let scope = 'general';
                    let n = el;
                    while(n){
                        if (n.chatScope) {
                            scope = n.chatScope;
                            break;
                        }
                        n = n.parent;
                    }
                    const base = scope === 'addapp' ? '_ax_chatMessages' : scope === 'dashboard' ? '_db_chatMessages' : 'chatMessages';
                    const list = s.root && s.root[base] || [];
                    const idx = list.findIndex((m)=>m && m.id === s.id);
                    let prompt = null;
                    for(let i = (idx < 0 ? list.length : idx) - 1; i >= 0; i--)if (list[i] && list[i].role === 'user' && list[i].text) {
                        prompt = list[i].text;
                        break;
                    }
                    if (!prompt) return;
                    try {
                        el.call('sendPrompt', prompt, scope);
                    } catch (_) {
                    /* transport not ready — button is a no-op rather than a throw */ }
                }
            },
            SwitchModelBtn: {
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center center',
                gap: 'Y',
                padding: 'Y Z1',
                minHeight: 'controlHCompact',
                round: 'radiusPill',
                theme: 'transparent',
                color: 'caption',
                fontSize: 'Z1',
                fontWeight: '500',
                cursor: 'pointer',
                border: 'none',
                transition: 'B defaultBezier',
                transitionProperty: 'background-color, color, transform',
                ':hover': {
                    background: 'hover',
                    color: 'title'
                },
                // "✦" matches AiModelSwitcherTrigger's own glyph (shared/components/
                // AiModelSwitcher.js) — no separate icon asset needed for this text
                // affordance.
                Label: {
                    tag: 'span',
                    text: '{{ ai.chat.switchModel | polyglot }}'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    if (s.root && s.root.update) s.root.update({
                        _modelMenuOpen: true
                    });
                }
            }
        }
    }
};

});
parcelRegister("9GdJK", function(module, exports) {

$parcel$export(module.exports, "touchRow", () => $70c2b12dd69501c3$export$6064cd292fd22ed7);
$parcel$export(module.exports, "touchSlop", () => $70c2b12dd69501c3$export$85d67b6298f0efe3);
$parcel$export(module.exports, "touchFloor", () => $70c2b12dd69501c3$export$336918908cc9c417);
// THE TOUCH TARGET — the 44pt hit area every control owes a finger
// (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1; Apple HIG: 44 x 44 pt; the brand
// `controlH` sizes token). Three shapes, all spread INSIDE a `'@coarse'` block
// so a mouse never sees them. Two are an `:after` pseudo, so the control's own
// box, padding and layout never change (Rule 66) — only its hit area; the
// third (`touchRow`, below) draws the control itself at the floor.
//
//   touchSlop   — the house tap slop: `inset: tapSlop` grows the control by
//                 6px a side (the brand IconButton / NavbarButton recipe).
//                 Enough for a control of 32px and up: a 36px compact capsule
//                 answers a 48px square.
//   touchFloor  — the 44pt FLOOR for the controls that stay small on a
//                 touch screen: the hit area is the control's own box, never
//                 under `controlH` on either axis, centred on it. A 25px
//                 header button (the 14px iPad-portrait root), the 28px send
//                 button, an 18px swatch: each answers a 44px square. Measured
//                 on dev DFI 2026-10-05 with a touch device simulated — the
//                 send button took 25 x 25 at 834px and the canvas-background
//                 swatch 19 x 19 at 375px.
//
// The pseudo is absolutely positioned, so the control must be a containing
// block: a STATIC control adds `position: 'relative'` beside the spread (a
// control that is already positioned must not — a `'@coarse'` position would
// beat its own). A control that clips (`overflow: hidden`) clips its hit area
// too; it opens up under `'@coarse'` (its own round still clips its fill).
//
//   '@coarse': { position: 'relative', ...touchFloor }
//
// A pseudo reaches past the control's box, so it meets its NEIGHBOUR when the
// two sit closer than the reach: the later one in the tree wins the overlap.
// Measured on dev 19a2e0adb (Finances, 393 / 834, a finger 21px from the
// centre): an icon-only compact capsule (33 or 22px wide) handed its right edge
// to the capsule 9-10px away. Two answers, by where the control sits:
//
//   touchRow    — a control AMONG its neighbours, flush or a hair apart (a
//                 segment, a tab, a list row, a chip in a group that wraps):
//                 it DRAWS `controlH` on both axes under `'@coarse'` and its
//                 own box is its hit area — no pseudo, so it neither takes a
//                 neighbour's edge nor gets cut by the scroll strip it sits in.
//                 '@coarse': { ...touchRow }
//   a pseudo floor on a box of at least `controlHCompact` (36px, the brand
//                 IconButton) — a small control in a toolbar: the floor then
//                 reaches only 4px past the box, so two controls 8px apart
//                 keep their own edges (AppCapsuleBtn's compact rule).
const $70c2b12dd69501c3$export$6064cd292fd22ed7 = {
    minHeight: 'controlH',
    minWidth: 'controlH'
};
const $70c2b12dd69501c3$export$85d67b6298f0efe3 = {
    ':after': {
        content: '""',
        position: 'absolute',
        inset: 'tapSlop'
    }
};
const $70c2b12dd69501c3$export$336918908cc9c417 = {
    ':after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '100%',
        height: '100%',
        minWidth: 'controlH',
        minHeight: 'controlH',
        transform: 'translate(-50%, -50%)'
    }
};

});


parcelRegister("e6RpB", function(module, exports) {

$parcel$export(module.exports, "ChatCard", () => $a45b0eb78d8f53fb$export$e109d98223f8e741);
// ChatCard — interactive cards rendered INSIDE an assistant message.
//
// The simone assistant is a dynamic surface, not a text box: it can attach a
// `cards` array to its message (via the render_cards / ask_user client tools)
// and ChatMessage renders each card through this dispatcher. We compose platform
// PRIMITIVES (CommonCard, Avatar, AgentAvatar, Img) into chat-native cards with
// their own onClick — the heavy page cards (TicketsCard, PersonCard) read
// page-root state the chat root doesn't have, so we don't mount them directly.
//
// Each card object becomes the dispatcher's `s` (childrenAs:'state' from
// ChatMessage.Cards). Card shapes:
//   { type:'tickets',    items:[{ id,title,state,priority,number,assignee }] }
//   { type:'people',     items:[{ name,email,kind:'agent'|'human',role }] }
//   { type:'thumbnails', items:[{ url,caption,href }] }
//   { type:'choice',     prompt, options:[{label,value,primary}], _cardId, _callId,
//                        _resolved, _chosen, _chosenLabel, _superseded, _closedBy,
//                        _written }
//   { type:'confirm',    prompt, confirmLabel, cancelLabel, _cardId, _callId,
//                        _resolved, _chosen, _chosenLabel, _superseded, _closedBy,
//                        _edit }
// A question card (choice / confirm) carries the call id of the step that
// asked (`_callId`): ChatMessage draws it under that step (ChatToolStep).
// ── One ticket → a clickable compact card; opens the ticket on /tickets. ──
const $a45b0eb78d8f53fb$var$TICKET_CARD = {
    tag: 'button',
    type: 'button',
    extends: 'CommonCard',
    theme: (el, s)=>el.scope.surface(s),
    width: '100%',
    textAlign: 'left',
    border: '0',
    cursor: 'pointer',
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    // A CLICKABLE CARD lifts on the `float` shadow under the pointer — the
    // house interactive-card cue (ItemPreview, IntegrationCategoryCard). The
    // card is the brand `card` surface now (CommonCard), and the `hover`
    // wash it used REPLACED that fill: in light it stepped 0.008 luminance
    // off the card at rest, no visible change.
    transition: 'Z defaultBezier box-shadow',
    ':hover': {
        shadow: 'float'
    },
    onClick: (e, el, s)=>{
        // Open the detail modal ONLY with a full ticket resolved from the live list
        // (we're on /tickets) — the same safe path the dashboard task widgets use.
        // The heavy TicketsDetailModal HANGS the renderer when seeded with only the
        // card's partial data (it reads fields/relations the card doesn't carry), so
        // when the ticket isn't loaded on this page navigate to the board instead —
        // a normal page load, not a synchronous rebuild — rather than opening the
        // modal with a stub.
        try {
            const root = el.scope.rootOf(el);
            const full = root && Array.isArray(root.tickets) ? root.tickets.find((t)=>String(t.id) === String(s.id)) : null;
            if (full) el.call('openTicketDetailModal', full);
            else el.call('openAppPage', '/tasks');
        } catch (_) {}
    },
    PvDot: {
        boxSize: 'Y',
        round: '50%',
        flexShrink: '0',
        background: (el, s)=>el.scope.stateColor(s.state)
    },
    PvBody: {
        flow: 'y',
        gap: 'V',
        flex: '1 1 0',
        minWidth: '0',
        // The ticket's TITLE — primary text, never cut (the overflow law,
        // HOME_AMBIENT_SKIN_SPEC §3b rule 8): it wraps inside the card.
        PvTitle: {
            text: (el, s)=>s.title || el.call('polyglot', 'ai.chatCard.ticketFallback'),
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            overflowWrap: 'anywhere'
        },
        PvMeta: {
            flow: 'x',
            gap: 'Y',
            align: 'center left',
            PvNum: {
                text: (el, s)=>s.number != null && s.number !== '' ? '#' + s.number : '',
                fontSize: 'Z',
                color: 'caption'
            },
            PvState: {
                text: (el, s)=>String(s.state || '').replace(/_/g, ' '),
                fontSize: 'Z',
                color: 'caption'
            },
            PvPriority: {
                if: (el, s)=>!!s.priority,
                text: (el, s)=>"\xb7 " + s.priority,
                fontSize: 'Z',
                color: 'caption'
            }
        }
    },
    Avatar: {
        if: (el, s)=>!!s.assignee,
        avatarType: 'initials',
        boxSize: 'C C',
        flexShrink: '0',
        src: (el, s)=>el.call('avatarUrl', s.assignee)
    }
};
// ── One person / agent → an avatar chip; agents get the robot AgentAvatar.
// Clicking an AGENT chip directs the user's next message at that agent (sets
// _targetAgentId, which the transport forwards so the server resolves that
// agent's persona). Pass the agent's id on the card item to enable this. ──
const $a45b0eb78d8f53fb$var$PERSON_CHIP = {
    extends: 'CommonCard',
    theme: (el, s)=>el.scope.surface(s),
    // A div (CommonCard's default tag). `tag:` is fixed at element creation — a
    // function value doesn't apply and left the chip unrendered. onClick works on a
    // div; agent chips target the agent, human chips are inert.
    cursor: (el, s)=>s.kind === 'agent' ? 'pointer' : 'default',
    // Only an AGENT chip is clickable, so only it lifts (the `float` cue of a
    // clickable card); a human chip stays still. The `overlay` wash it used
    // replaced the card fill (0.011 luminance darker than the card in dark).
    transition: 'Z defaultBezier box-shadow',
    ':hover': {
        shadow: (el, s)=>s.kind === 'agent' ? 'float' : undefined
    },
    attr: {
        role: (el, s)=>s.kind === 'agent' ? 'button' : null,
        tabindex: (el, s)=>s.kind === 'agent' ? '0' : null,
        'aria-label': (el, s)=>s.kind === 'agent' ? 'Message ' + (s.name || s.title || 'agent') : null
    },
    onClick: (e, el, s)=>{
        if (s.kind !== 'agent') return;
        try {
            const root = el.scope.rootOf(el);
            if (root && root.update) root.update({
                _targetAgentId: s.id || null,
                _targetAgentName: s.name || null
            });
        } catch (_) {}
    },
    onKeydown: (e, el, s)=>{
        if (s.kind !== 'agent') return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            try {
                const root = el.scope.rootOf(el);
                if (root && root.update) root.update({
                    _targetAgentId: s.id || null,
                    _targetAgentName: s.name || null
                });
            } catch (_) {}
        }
    },
    flow: 'x',
    gap: 'Y',
    align: 'center left',
    padding: 'V Z',
    PersonAvatar: {
        extends: 'Avatar',
        if: (el, s)=>s.kind !== 'agent',
        avatarType: 'initials',
        boxSize: 'C C',
        flexShrink: '0',
        src: (el, s)=>el.call('avatarUrl', s.name || s.email || '?')
    },
    BotAvatar: {
        extends: 'AgentAvatar',
        if: (el, s)=>s.kind === 'agent',
        boxSize: 'C C',
        flexShrink: '0'
    },
    PvWho: {
        flow: 'y',
        gap: 'V',
        minWidth: '0',
        // A person's NAME — primary text: it wraps (it was one unclipped line
        // that ran out of the card on a long name or an email).
        PvName: {
            text: (el, s)=>s.name || s.email || el.call('polyglot', 'ai.chatCard.memberFallback'),
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            overflowWrap: 'anywhere'
        },
        PvRole: {
            if: (el, s)=>!!(s.role || s.kind === 'agent'),
            text: (el, s)=>s.role || (s.kind === 'agent' ? el.call('polyglot', 'ai.chatCard.agentRole') : ''),
            fontSize: 'Z',
            color: 'caption'
        }
    }
};
// ── One thumbnail (optionally a link). Static `tag: 'a'` (an anchor with no
// href is an inert inline element, which is fine) — a function `tag:` doesn't
// apply at creation. ──
const $a45b0eb78d8f53fb$var$THUMB = {
    tag: 'a',
    href: (el, s)=>s.href || null,
    // Static — `target` on an href-less anchor is inert (same reasoning as `tag`).
    target: '_blank',
    flow: 'y',
    gap: 'V',
    width: 'F',
    textDecoration: 'none',
    PvImgWrap: {
        width: '100%',
        height: 'E',
        round: 'Z',
        overflow: 'hidden',
        background: 'overlay',
        Img: {
            extends: 'Img',
            src: (el, s)=>s.url,
            objectFit: 'cover',
            width: '100%',
            height: '100%'
        }
    },
    // Secondary meta: one line, the whole caption on hover (rule 8).
    PvCap: {
        if: (el, s)=>!!s.caption,
        text: (el, s)=>s.caption,
        title: (el, s)=>s.caption,
        fontSize: 'Z',
        color: 'caption',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
};
// ── One insurance policy → a compact clickable card; opens /policies. ──
// Visual language mirrors TICKET_CARD: CommonCard shell, flow x, same gap/
// align/hover token. Initials badge via el.call('policyInitials'), premium
// via el.call('formatPolicyMoney'), status pill themed via el.call('policyStatus').
const $a45b0eb78d8f53fb$var$POLICY_CARD = {
    tag: 'button',
    type: 'button',
    extends: 'CommonCard',
    theme: (el, s)=>el.scope.surface(s),
    width: '100%',
    textAlign: 'left',
    border: '0',
    cursor: 'pointer',
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    // A CLICKABLE CARD lifts on the `float` shadow under the pointer — the
    // house interactive-card cue (ItemPreview, IntegrationCategoryCard). The
    // card is the brand `card` surface now (CommonCard), and the `hover`
    // wash it used REPLACED that fill: in light it stepped 0.008 luminance
    // off the card at rest, no visible change.
    transition: 'Z defaultBezier box-shadow',
    ':hover': {
        shadow: 'float'
    },
    onClick: (e, el)=>{
        try {
            el.call('openAppPage', '/policies');
        } catch (_) {}
    },
    // Initials disc — NOT keyed `Avatar`: that auto-extends the Avatar built-in,
    // whose `src` expects an image URL (initials text just renders the "Avatar"
    // placeholder). Plain themed disc, matching the /policies table row.
    Initials: {
        flow: 'y',
        align: 'center center',
        width: 'C',
        height: 'C',
        flexShrink: '0',
        round: '50%',
        theme: 'tertiary',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>el.call('policyInitials', s.insured)
    },
    PvBody: {
        flow: 'y',
        gap: 'V',
        flex: '1 1 0',
        minWidth: '0',
        // The policy's identifier and product are one-line meta with their
        // whole text on hover; the insured person's NAME is primary and wraps
        // (the overflow law, §3b rule 8).
        PvNumber: {
            text: (el, s)=>'#' + s.number,
            title: (el, s)=>'#' + s.number,
            fontSize: 'Z1',
            fontWeight: '700',
            fontFamily: 'monospace',
            color: 'title',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        PvInsured: {
            text: (el, s)=>s.insured || '',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            overflowWrap: 'anywhere'
        },
        PvProduct: {
            text: (el, s)=>s.product || '',
            title: (el, s)=>s.product || null,
            fontSize: 'Z',
            color: 'caption',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    PvRight: {
        flow: 'y',
        gap: 'V',
        align: 'flex-end',
        flexShrink: '0',
        PvPremium: {
            text: (el, s)=>el.call('formatPolicyMoney', s.premium, s.currency),
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title'
        },
        PvStatus: {
            padding: 'V Z',
            round: 'Y',
            fontSize: 'Y2',
            fontWeight: '700',
            // Theme drives the pill colour (success=green, warning=orange, alert=red).
            theme: (el, s)=>el.call('policyStatus', s).theme,
            text: (el, s)=>el.call('polyglot', el.call('policyStatus', s).label)
        }
    }
};
// ── One answer of a question card (choice / confirm). A press answers: on a
// live card resolveChatCard resumes the waiting tool; on an answered card
// reopened by Change, changeChatCardAnswer sends the new answer as the
// person's next message (scope.askPick). The card shows these only while it
// is open, so an answer is never inert or dimmed.
//
// THE HOUSE CAPSULE at the compact size (Nika 2026-10-28: "improve design, ui
// and UX of confirmation card"): AppCapsuleBtn owns the geometry — 36px
// (`controlHCompact`), the 44pt floor on a coarse pointer, the press, the
// focus ring, a label that wraps. It was a hand-rolled button: a `blue` fill
// for the primary answer (hue never fills a chrome action), the `Z` letter
// radius, weight 700, an opacity hover and no touch floor. The primary answer
// is the ink capsule (`theme: 'primary'`, its own hover and press steps);
// the others are the tonal `layer` capsule with the `selected` step — the
// AppCapsuleBtnPrimary / AppCapsuleBtnToolbar roles, as exclusive classes: a
// childrenAs:'state' list takes ONE `childExtends`, and two roles must never
// meet on one element (the tonal hover would paint over the ink capsule's
// own). While Change has an answered card open, its CURRENT answer is the
// chosen segment of a choice control — the brand inversion (`highlight` fill,
// `highlight-reversed` ink), `aria-pressed` — so the person sees what they
// are changing.
const $a45b0eb78d8f53fb$var$CHOICE_BTN = {
    extends: 'AppCapsuleBtn',
    compact: true,
    border: 'none',
    isPrimary: (el, s)=>!!s.primary && !s.chosen,
    isTonal: (el, s)=>!s.primary && !s.chosen,
    isChosen: (el, s)=>!!s.chosen,
    '.isPrimary': {
        theme: 'primary'
    },
    '.isTonal': {
        theme: 'layer',
        color: 'title',
        ':hover': {
            background: 'selected'
        },
        ':active': {
            background: 'selected'
        }
    },
    '.isChosen': {
        background: 'highlight',
        color: 'highlight-reversed'
    },
    aria: {
        pressed: (el, s)=>s.chosen ? 'true' : null
    },
    text: (el, s)=>s.label,
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.scope.askPick(el, s.value, s.label);
    }
};
const $a45b0eb78d8f53fb$export$e109d98223f8e741 = {
    // FA204 / frank trap — STATE_COLOR/stateColor/rootOf/choiceOptions used to
    // be bare module-scope const/function read from inside TICKET_CARD.onClick,
    // TICKET_CARD.PvDot.background, PERSON_CHIP.onClick/onKeydown, and
    // PvCardChoice.PvOptions.children (all serialized factories nested under
    // this file's single top-level export); they read as undefined once this
    // component is frank.toJSON'd for platform delivery. Moved into `scope`,
    // called via `el.scope.<name>`. TICKET_CARD/PERSON_CHIP/THUMB/POLICY_CARD/
    // CHOICE_BTN themselves stay module-scope plain object literals — they're
    // referenced directly as `childExtends: X` values (not read from inside a
    // nested function), so frank inlines their structure at build time; only
    // the FUNCTIONS nested inside them get toString'd, which is why those
    // functions (not the containing objects) needed the el.scope rewrite.
    scope: {
        // The surface of a chat card follows the chat's posture (Chat.js
        // `theme`). In the workspace drawer the chat is a `common-box` SHEET, so
        // a card on it is the brand `card` (CommonCard): 1.19:1 dark / 1.13:1
        // light. Standalone (the extension panels) the chat IS the page, the
        // `document` ground — gray15 in light, the `card` fill itself (1.00:1)
        // — so a card there is the raised surface of a ground, `common-box`
        // (brand law: a card sits inside a sheet; on the stage the raised
        // surface is common-box): 1.13:1 light.
        surface (s) {
            return s.root && s.root.workspaceEmbed ? 'card' : 'common-box';
        },
        // Ticket state → a design-system colour for the status dot.
        STATE_COLOR: {
            not_started: 'gray',
            backlog: 'gray',
            todo: 'gray',
            unsynced: 'gray',
            started: 'blue',
            in_progress: 'blue',
            'in-progress': 'blue',
            in_review: 'orange',
            review: 'orange',
            ready_to_test: 'orange',
            ready_for_staging: 'orange',
            blocked: 'red',
            done: 'green',
            completed: 'green',
            closed: 'green',
            merged: 'green'
        },
        stateColor (st) {
            return this.STATE_COLOR[String(st || '').toLowerCase().replace(/[\s-]+/g, '_')] || 'gray';
        },
        // Resolve the chat root's state.root from any card element. Cards render
        // under ChatMessage's childrenAs:'state' subtree; el.state.root is the
        // fast path, el.getRoot() the fallback.
        rootOf (el) {
            return el && el.state && el.state.root || el && el.getRoot && el.getRoot() && el.getRoot().state && el.getRoot().state.root || null;
        },
        // THE QUESTION TAKES THE KEYBOARD (round 1b, ledger BLD-18). Has THIS
        // question (a choice / confirm card, by its id) taken focus before? The
        // marker lives on the chat's root state, so a re-render that mounts the
        // same card again never moves focus a second time.
        askFocused (s) {
            const root = s && s.root;
            return !!(root && s._cardId && root.__chatAskFocused === s._cardId);
        },
        // May a live question take focus now? Only an unanswered card that has not
        // had it yet, and never from a person who is typing (a field that holds
        // text keeps the keyboard) or from another open layer (a dialog, a modal
        // sheet). Read when the card is created, before its node exists.
        askTakesFocus (el, s) {
            if (!s || s._resolved || !s._cardId || this.askFocused(s)) return false;
            const doc = typeof document === 'undefined' ? null : document;
            if (!doc) return false;
            const active = doc.activeElement;
            if (!active || active === doc.body || active === doc.documentElement) return true;
            const tag = String(active.tagName || '').toUpperCase();
            const field = tag === 'TEXTAREA' || tag === 'INPUT' || active.isContentEditable === true;
            const held = field ? active.value != null ? active.value : active.textContent : '';
            if (String(held || '').trim() !== '') return false;
            if (typeof active.closest === 'function' && active.closest('dialog[open], [aria-modal="true"]')) return false;
            return true;
        },
        // The answers of a choice / confirm card, one row each (CHOICE_BTN), by
        // the ONE rule every surface that asks reads (functions/askCardOptions —
        // AiAsk on the island and the call reads it too): a confirm card answers
        // Confirm (the primary) or Cancel, in the tool's own words when it gave
        // them; while Change has an answered card open, its current answer is
        // the one filled capsule (no second, primary fill beside it).
        choiceOptions (s, el) {
            s.root?.lang;
            const rows = el.call('askCardOptions', s);
            return (Array.isArray(rows) ? rows : []).map((o)=>({
                    ...o,
                    key: 'answer-' + o.at
                }));
        },
        // ── A QUESTION CARD'S FACES (Nika 2026-10-28: "colalpese after answer,
        // fix positioning and make it able to also edit"). What the card shows
        // and which field is open live on the chat's root, by card id —
        // `_aiAskCompose` (declared in the shell's state): a card row is patched
        // with `state.replace` on every message update, so a key of its own would
        // not survive. `{ field: 'own' | 'edit' | null, change: boolean }`, UI
        // state only (never persisted, gone on a workspace switch).
        askMode (s) {
            const id = s && s._cardId;
            const root = s && s.root;
            const all = root && root._aiAskCompose;
            const mode = all && id ? all[id] : null;
            return mode && typeof mode === 'object' ? mode : null;
        },
        // 'open' — the question and its answers (live, or reopened by Change);
        // 'answered' — one line: the question short, the answer, Change;
        // 'closed' — a new message closed it (the transport's supersede), or its
        // turn ended without the answer (`_closedBy`): one muted line, the
        // question it closed, nothing to change.
        askFace (s) {
            const mode = this.askMode(s);
            if (s._superseded) return 'closed';
            if (s._resolved && !(mode && mode.change)) return 'answered';
            return 'open';
        },
        // The field open on an open card: 'own' (Write my own) or 'edit' (a
        // confirm card's Edit), else null.
        askField (s) {
            const mode = this.askMode(s);
            if (this.askFace(s) !== 'open' || !mode) return null;
            return mode.field === 'own' || mode.field === 'edit' ? mode.field : null;
        },
        // An answered card that Change reopened.
        askChanging (s) {
            const mode = this.askMode(s);
            return !!(s._resolved && !s._superseded && mode && mode.change);
        },
        // The answer on the folded line: the pick's label, the person's own
        // words, or what a confirm card's Edit asked to change.
        askAnswerText (el, s) {
            s.root?.lang;
            const said = s._chosenLabel != null ? String(s._chosenLabel).trim() : '';
            if (s._edit) return String(el.call('polyglot', 'ai.chatCard.ask.editAnswer') || '').replace('{words}', ()=>said);
            if (said) return said;
            if (s.type === 'confirm' && s._chosen === 'confirm') return s.confirmLabel || el.call('polyglot', 'ai.chatCard.confirm');
            if (s.type === 'confirm' && s._chosen === 'cancel') return s.cancelLabel || el.call('polyglot', 'ai.chatCard.cancel');
            return s._chosen != null ? String(s._chosen) : '';
        },
        // Why a closed card closed, in the page language (`_closedBy`, set by the
        // transport's _endWaitingCards): the person stopped the reply, or the
        // turn failed or ended first; else a new message closed it (supersede).
        askWhyText (el, s) {
            s.root?.lang;
            const key = s._closedBy === 'stop' ? 'ai.chatCard.ask.closedStop' : s._closedBy === 'end' ? 'ai.chatCard.ask.closedEnd' : 'ai.tool.superseded';
            return String(el.call('polyglot', key) || '');
        },
        // Write a card's mode (null clears it) — in memory only.
        askSetMode (s, mode) {
            const root = s && s.root;
            const id = s && s._cardId;
            if (!root || typeof root.update !== 'function' || !id) return;
            const all = {
                ...root._aiAskCompose || {}
            };
            if (mode) all[id] = mode;
            else delete all[id];
            root.update({
                _aiAskCompose: all
            }, {
                preventFetch: true
            });
        },
        // The question card around any of its controls.
        askCard (el) {
            if (!el) return null;
            if (el.key === 'PvCardChoice') return el;
            return typeof el.lookup === 'function' ? el.lookup('PvCardChoice') : null;
        },
        // The card's controls, by role: 'card' (the card itself), 'field' (its
        // input), 'writeOwn' (Write my own / Edit), 'change' (Change).
        askTarget (card, name) {
            if (!card) return null;
            if (name === 'card') return card;
            if (name === 'field') return card.PvCompose && card.PvCompose.AppInputCompact || null;
            if (name === 'writeOwn') return card.PvAnswers && card.PvAnswers.AppCapsuleBtnGhost || null;
            if (name === 'change') return card.PvFolded && card.PvFolded.AppCapsuleBtnGhost || null;
            return null;
        },
        // Focus a control of the card once the update shows it: `hide` applies
        // in the update's microtask, so a focus in the same tick lands on a
        // hidden node. Two microtasks later is still inside the press, so a
        // phone keyboard opens for a field.
        askFocus (card, name) {
            if (!card) return;
            const run = ()=>{
                const target = this.askTarget(card, name);
                const node = target && target.node;
                if (node && typeof node.focus === 'function') node.focus();
            };
            queueMicrotask(()=>queueMicrotask(run));
        },
        // The field's words live with the card's mode (`text`), bound to the
        // input's `value`: a mode that closes takes them with it, so a closed
        // field is empty — its words were never sent, and a hidden field that
        // holds text reads as unsaved work to the shell (hasUnsavedInput asks
        // "Discard changes?" for it). Only an open field shows them: a question
        // closed under an open field (its turn stopped or ended, or another
        // surface answered it) keeps its mode, never its words.
        askText (s) {
            const mode = this.askMode(s);
            const open = this.askField(s);
            return open && mode && typeof mode.text === 'string' ? mode.text : '';
        },
        askSetText (s, text) {
            const mode = this.askMode(s);
            if (!mode || !mode.field) return;
            this.askSetMode(s, {
                ...mode,
                text: String(text == null ? '' : text)
            });
        },
        // A press on an answer: answers the live question, or changes the answer
        // of an answered one (the AI reads the new answer as the person's next
        // message). The card folds to its answer line; focus goes to its Change.
        askPick (el, value, label) {
            const card = this.askCard(el);
            const s = card && card.state;
            if (!s || !s._cardId || s._superseded) return;
            const changing = this.askChanging(s);
            if (s._resolved && !changing) return;
            if (this.askMode(s)) this.askSetMode(s, null);
            // the answer it already has: nothing to tell the AI
            const same = changing && !s._written && !s._edit && s._chosen != null && String(s._chosen) === String(value);
            if (same) return this.askFocus(card, 'change');
            try {
                if (changing) el.call('changeChatCardAnswer', s._cardId, value, label);
                else el.call('resolveChatCard', s._cardId, value, label);
            } catch (_) {}
            this.askFocus(card, 'change');
        },
        // Send the field: the person's own words as the answer (Write my own),
        // or what should change (Edit — never a yes: the transport answers the
        // tool `confirmed: false` with the words). An empty field sends nothing.
        askSubmit (el) {
            const card = this.askCard(el);
            const s = card && card.state;
            const field = this.askTarget(card, 'field');
            const node = field && field.node;
            const kind = s ? this.askField(s) : null;
            if (!s || !s._cardId || !kind) return;
            // the words on screen (the last keystroke may not have reached the
            // mode yet), else the mode's
            const typed = node && typeof node.value === 'string' ? node.value : this.askText(s);
            const text = String(typed || '').trim();
            if (!text) {
                this.askFocus(card, 'field');
                return;
            }
            const changing = this.askChanging(s);
            if (s._resolved && !changing) return;
            const extra = kind === 'edit' ? {
                edit: true,
                text: text
            } : {
                written: true,
                text: text
            };
            const value = kind === 'edit' ? 'edit' : text;
            this.askSetMode(s, null);
            try {
                if (changing) el.call('changeChatCardAnswer', s._cardId, value, text, extra);
                else el.call('resolveChatCard', s._cardId, value, text, extra);
            } catch (_) {}
            this.askFocus(card, 'change');
        },
        // Write my own / Edit: the field opens under the answers, empty, with
        // focus.
        askOpenField (el, kind) {
            const card = this.askCard(el);
            const s = card && card.state;
            if (!s || this.askFace(s) !== 'open') return;
            this.askSetMode(s, {
                field: kind,
                change: this.askChanging(s),
                text: ''
            });
            this.askFocus(card, 'field');
        },
        // The field's close (and Escape): back to the answers, its words
        // dropped, focus on the control that opened it.
        askCloseField (el) {
            const card = this.askCard(el);
            const s = card && card.state;
            if (!s) return;
            const changing = this.askChanging(s);
            this.askSetMode(s, changing ? {
                field: null,
                change: true
            } : null);
            this.askFocus(card, 'writeOwn');
        },
        // Change: an answered card opens again, its answers and its field.
        askChange (el) {
            const card = this.askCard(el);
            const s = card && card.state;
            if (!s || this.askFace(s) !== 'answered') return;
            this.askSetMode(s, {
                field: null,
                change: true
            });
            this.askFocus(card, 'card');
        },
        // Keep the answer (and Escape while changing): the card folds again.
        askKeep (el) {
            const card = this.askCard(el);
            const s = card && card.state;
            if (!s) return;
            this.askSetMode(s, null);
            this.askFocus(card, 'change');
        }
    },
    width: '100%',
    // Tickets — a clickable compact card per ticket.
    PvCardTickets: {
        if: (el, s)=>s.type === 'tickets',
        flow: 'y',
        gap: 'Y',
        childExtends: $a45b0eb78d8f53fb$var$TICKET_CARD,
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    },
    // People & agents — avatar chips (robot for agents, initials for humans).
    PvCardPeople: {
        if: (el, s)=>s.type === 'people',
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        childExtends: $a45b0eb78d8f53fb$var$PERSON_CHIP,
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    },
    // Thumbnails.
    PvCardThumbs: {
        if: (el, s)=>s.type === 'thumbnails',
        flow: 'x',
        gap: 'Z',
        flexWrap: 'wrap',
        childExtends: $a45b0eb78d8f53fb$var$THUMB,
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    },
    // Policies — a compact clickable card per insurance policy; opens /policies.
    PvCardPolicies: {
        if: (el, s)=>s.type === 'policies',
        flow: 'y',
        gap: 'Y',
        childExtends: $a45b0eb78d8f53fb$var$POLICY_CARD,
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    },
    // Choice / confirm — interactive buttons that resume the AI turn on click.
    //
    // THE QUESTION TAKES THE KEYBOARD (round 1b, ledger BLD-18 — sam, keyboard
    // only: focus stayed in the composer and the answer chips were 13–14 Tab
    // stops away). The card is a group named by its prompt; a live, unanswered
    // card takes focus ONCE when it appears (scope.askTakesFocus: never from a
    // person who is typing, never from another open layer), so the next Tab is
    // the first answer and the focus says the question. A card that takes focus
    // leaves the chat's polite log (Chat.js Messages is `role: 'log'`) — the
    // focus already said it, so the question is said once; a card that does not
    // is read by the log as before. `tabindex: -1`: focusable by this move, never
    // a Tab stop of its own. A restored card (sessions.js) is always answered or
    // closed, so an unanswered card IS a live ask.
    //
    // THREE FACES (Nika 2026-10-28: "colalpese after answer, fix positioning and
    // make it able to also edit"; scope.askFace):
    //   open      the question and its answers, then Write my own (a choice
    //             card) or Edit (a confirm card), which opens a field under the
    //             answers: Enter sends, Escape or its close goes back.
    //   answered  ONE LINE — the question short and quiet, the answer, and
    //             Change, which opens the card again: a new pick or new words
    //             go to the AI as the person's next message.
    //   closed    a new message closed it, or its turn ended without the
    //             answer (a stop, a failure): one muted line — the question it
    //             closed — nothing to change.
    // Both folded faces are ONE line (PvFolded). An answered card kept both
    // answer buttons (an inert one at 0.4 opacity) and added a raw green "✓ Red"
    // under them. The folded faces take the `.isFolded` inset (a static class:
    // a reactive padding is dropped).
    PvCardChoice: {
        if: (el, s)=>s.type === 'choice' || s.type === 'confirm',
        extends: 'CommonCard',
        theme: (el, s)=>el.scope.surface(s),
        flow: 'y',
        gap: 'Z',
        role: 'group',
        tabindex: '-1',
        aria: {
            labelledby: (el, s)=>s.prompt && s._cardId ? 'chat-ask-' + s._cardId : null,
            live: (el, s)=>el.__askFocus || el.scope.askFocused(s) ? 'off' : null
        },
        // The house focus ring (the `focusRing` shadow), as on every focusable card.
        ':focus-visible': {
            shadow: 'focusRing'
        },
        isFolded: (el, s)=>el.scope.askFace(s) !== 'open',
        '.isFolded': {
            padding: 'Y Y Y Z1'
        },
        // Decided BEFORE the node exists, so the card is created out of the log
        // when it is going to take focus (the log never reads it first).
        onInit: (el, s)=>{
            el.__askFocus = el.scope.askTakesFocus(el, s);
        },
        onMounted: (el, s)=>{
            if (!el.__askFocus) return;
            const node = el.node;
            if (!node || typeof node.focus !== 'function') return;
            const root = s && s.root;
            if (root && s._cardId) root.__chatAskFocused = s._cardId;
            node.focus();
        },
        // Escape while Change has the card open keeps the answer. The field
        // takes its own Escape first (PvCompose); preventDefault keeps the
        // shell's Escape (it closes the drawer) out of it.
        onKeydown: (e, el, s)=>{
            if (e.key !== 'Escape' || !el.scope.askChanging(s)) return;
            e.preventDefault();
            e.stopPropagation();
            el.scope.askKeep(el);
        },
        PvPrompt: {
            hide: (el, s)=>!s.prompt || el.scope.askFace(s) !== 'open',
            id: (el, s)=>s._cardId ? 'chat-ask-' + s._cardId : null,
            text: (el, s)=>s.prompt,
            fontSize: 'Z1',
            fontWeight: '500',
            color: 'title',
            overflowWrap: 'anywhere'
        },
        // The answers in one wrapping row: the picks, then Write my own / Edit
        // (AppCapsuleBtnGhost); while Change has the card open, a close at the
        // row's end (CloseButton) keeps the answer.
        PvAnswers: {
            hide: (el, s)=>el.scope.askFace(s) !== 'open',
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center flex-start',
            gap: 'Y',
            minWidth: '0',
            // The picks sit in the row itself (no box of their own), so they wrap
            // with Write my own as one row.
            PvOptions: {
                display: 'contents',
                childExtends: $a45b0eb78d8f53fb$var$CHOICE_BTN,
                childrenAs: 'state',
                children: (el, s)=>el.scope.choiceOptions(s, el)
            },
            // Write my own (a choice card) / Edit (a confirm card): opens the field.
            AppCapsuleBtnGhost: {
                compact: true,
                hide: (el, s)=>!!el.scope.askField(s),
                Icon: {
                    name: 'edit',
                    fontSize: 'Z2',
                    flexShrink: '0'
                },
                // Function text beside the Icon: a `{{ }}` label is rewritten by the
                // language switch through textContent, which drops the Icon.
                Label: {
                    tag: 'span',
                    text: (el, s)=>{
                        s.root?.lang;
                        return el.call('polyglot', s.type === 'confirm' ? 'common.action.edit' : 'ai.chatCard.ask.writeOwn');
                    }
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    el.scope.askOpenField(el, s.type === 'confirm' ? 'edit' : 'own');
                }
            },
            // Keep my answer, while Change has the card open. CloseButton carries a
            // scope of its own (its localized name), so its factories reach the
            // card's helpers through the row.
            CloseButton: {
                hide: (el, s)=>!el.parent.scope.askChanging(s),
                marginLeft: 'auto',
                'aria-label': (el, s)=>{
                    s.root?.lang;
                    return el.call('polyglot', 'ai.chatCard.ask.keepAnswer');
                },
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.parent.scope.askKeep(el);
                }
            }
        },
        // The field: the person's own words (Write my own) or what should change
        // (a confirm card's Edit). Enter or Send sends; Escape and the close go
        // back.
        PvCompose: {
            hide: (el, s)=>!el.scope.askField(s),
            flow: 'x',
            align: 'center',
            gap: 'Y',
            width: '100%',
            minWidth: '0',
            // AppInput carries a scope of its own (the field kit), so its factories
            // reach the card's helpers through the row. Its words are bound to the
            // card's mode (scope.askText): a mode that closes empties it.
            AppInputCompact: {
                flex: '1 1 0',
                enterkeyhint: 'send',
                autocomplete: 'off',
                value: (el, s)=>el.parent.scope.askText(s),
                onInput: (e, el, s)=>el.parent.scope.askSetText(s, el.node.value),
                placeholder: (el, s)=>{
                    s.root?.lang;
                    return el.call('polyglot', el.parent.scope.askField(s) === 'edit' ? 'ai.chatCard.ask.editPlaceholder' : 'ai.chatCard.ask.ownPlaceholder');
                },
                ariaLabel: (el, s)=>{
                    s.root?.lang;
                    return el.call('polyglot', el.parent.scope.askField(s) === 'edit' ? 'ai.chatCard.ask.editPlaceholder' : 'ai.chatCard.ask.ownPlaceholder');
                },
                onKeydown: (e, el)=>{
                    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
                        e.preventDefault();
                        el.parent.scope.askSubmit(el);
                    } else if (e.key === 'Escape') {
                        e.preventDefault();
                        e.stopPropagation();
                        el.parent.scope.askCloseField(el);
                    }
                }
            },
            AppCapsuleBtnPrimary: {
                compact: true,
                text: '{{ common.action.send | polyglot }}',
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.scope.askSubmit(el);
                }
            },
            CloseButton: {
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.parent.scope.askCloseField(el);
                }
            }
        },
        // FOLDED → ONE LINE, the question short and quiet first (its whole text
        // on hover).
        //   answered  then the answer (primary text: it wraps, never cut) and
        //             Change (AppCapsuleBtnGhost). Under its step the row
        //             already names the answer ("You chose “Blue”",
        //             `_pickOnRow`: ChatMessage.scope.rowNamesPick), so the line
        //             keeps the question and Change; a card with no row that
        //             names it (in Cards, an Edit, words too long for the row)
        //             keeps the answer here (coordinator W3a: said once);
        //   closed    a new message closed it (the transport's supersede): no
        //             answer, nothing to change. Under its step the row already
        //             says why ("Unanswered question · Skipped — you sent a new
        //             message"), so the line names the question it closed; a card
        //             with no step row above it (in Cards: `_step` unset) also
        //             says why, in the row's own words (PvWhy). A card its turn
        //             left (`_closedBy`: a stop, a failed or ended turn) always
        //             says why, and its row reads only "Unanswered question" (no
        //             tag: the card says why — ChatToolRow SkippedTag).
        // Only the question gives way (it shortens). The answer never shrinks:
        // where the line is too narrow (390 px, measured 2026-10-28: "Red" broke
        // into "Re" / "d"), the line wraps — the answer, then Change, go under.
        PvFolded: {
            hide: (el, s)=>el.scope.askFace(s) === 'open',
            flow: 'x',
            align: 'center',
            flexWrap: 'wrap',
            gap: 'Z',
            width: '100%',
            minWidth: '0',
            animationName: 'fadeIn',
            animationDuration: 'B',
            animationTimingFunction: 'defaultBezier',
            PvAsked: {
                tag: 'span',
                hide: (el, s)=>!s.prompt,
                text: (el, s)=>s.prompt,
                title: (el, s)=>s.prompt || null,
                flex: '0 1 auto',
                minWidth: '0',
                fontSize: 'Z',
                color: 'caption',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            PvAnswer: {
                tag: 'span',
                // Read before the branch, so the factory tracks it from the first
                // render (FA515).
                hide: (el, s)=>{
                    const step = !!s._step;
                    const onRow = !!s._pickOnRow;
                    return step && onRow || el.scope.askFace(s) !== 'answered';
                },
                text: (el, s)=>el.scope.askAnswerText(el, s),
                flex: '0 0 auto',
                maxWidth: '100%',
                fontSize: 'Z1',
                fontWeight: '500',
                color: 'title',
                overflowWrap: 'anywhere'
            },
            PvWhy: {
                tag: 'span',
                hide: (el, s)=>el.scope.askFace(s) !== 'closed' || !!s._step && !!s.prompt && !s._closedBy,
                text: (el, s)=>el.scope.askWhyText(el, s),
                flex: '0 0 auto',
                maxWidth: '100%',
                fontSize: 'Z',
                color: 'caption'
            },
            AppCapsuleBtnGhost: {
                hide: (el, s)=>el.scope.askFace(s) !== 'answered',
                compact: true,
                marginLeft: 'auto',
                Icon: {
                    name: 'edit',
                    fontSize: 'Z2',
                    flexShrink: '0'
                },
                Label: {
                    tag: 'span',
                    text: '{{ ai.chatCard.ask.change | polyglot }}'
                },
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.scope.askChange(el);
                }
            }
        }
    },
    // AI action approval — the assistant proposes a change to a workspace project's
    // books and waits. Approve runs it; Reject drops it. The buttons show only while
    // THIS card is the live pending action (root._aiAction.id === s.id); once handled
    // it collapses to a ✓. approveAiAction/rejectAiAction are NOT static
    // registrations: workspaceProjects.js injects moduleActions.js's trio into
    // ctx.functions whenever manifest-v2 module actions are in scope (takeover
    // activation, and the merged installed-apps caps pass), and its teardown
    // clears root._aiAction (hiding these buttons, synchronously) BEFORE the
    // names unregister — so a rendered control always resolves. Contract pinned
    // by workspace/__tests__/chatCardModuleActionContract.test.js.
    //
    // DECIDED → ONE LINE (Nika 2026-10-28: "colalpese after answer"): once this
    // card is not the live park, it folds like an answered question card — the
    // proposal short and quiet (its whole text on hover), what the run did, and
    // Open when the run names its page. Static `.isFolded` classes: a reactive
    // padding or flow is dropped. As on the question line, only the proposal
    // gives way: a narrow line wraps the outcome under it (390 px: "✓ Added 4
    // widgets to “Q3 sales”" stood in a 97 px column, three lines tall).
    PvCardAiAction: {
        if: (el, s)=>s.type === 'aiAction',
        extends: 'CommonCard',
        theme: (el, s)=>el.scope.surface(s),
        flow: 'y',
        gap: 'Z',
        subscribeTo: [
            '_aiAction'
        ],
        isFolded: (el, s)=>!(s.root && s.root._aiAction && s.root._aiAction.id === s.id),
        '.isFolded': {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            padding: 'Y Y Y Z1'
        },
        PvAiSummary: {
            text: (el, s)=>s.summary || el.call('polyglot', 'ai.chatCard.applyChange'),
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            isFolded: (el, s)=>!(s.root && s.root._aiAction && s.root._aiAction.id === s.id),
            title: (el, s)=>s.root && s.root._aiAction && s.root._aiAction.id === s.id ? null : s.summary || el.call('polyglot', 'ai.chatCard.applyChange'),
            '.isFolded': {
                flex: '0 1 auto',
                minWidth: '0',
                fontSize: 'Z',
                fontWeight: '400',
                color: 'caption',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        },
        PvAiActions: {
            hide: (el, s)=>!(s.root && s.root._aiAction && s.root._aiAction.id === s.id),
            flow: 'x',
            gap: 'Y',
            flexWrap: 'wrap',
            // §1/§6.2 primary action = ink capsule (adaptive highlight pair — AA by
            // construction). The old solid-green fill measured 2.8:1 with white ink.
            PvApprove: {
                tag: 'button',
                type: 'button',
                padding: 'V A',
                round: 'radiusPill',
                border: 'none',
                cursor: 'pointer',
                background: 'highlight',
                color: 'highlight-reversed',
                fontSize: 'Z2',
                fontWeight: '700',
                whiteSpace: 'nowrap',
                transition: 'filter 140ms defaultBezier',
                ':hover': {
                    filter: 'brightness(1.12)'
                },
                text: '{{ ai.chatCard.approve | polyglot }}',
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.call('approveAiAction');
                }
            },
            PvReject: {
                tag: 'button',
                type: 'button',
                padding: 'V A',
                round: 'radiusPill',
                border: 'none',
                cursor: 'pointer',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z2',
                fontWeight: '700',
                whiteSpace: 'nowrap',
                transition: 'background 140ms defaultBezier',
                ':hover': {
                    background: 'hover'
                },
                text: '{{ ai.confirm.reject | polyglot }}',
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.call('rejectAiAction');
                }
            }
        },
        // What the run did, from the card's own `outcome` (moduleActions.js
        // cardOutcomePatch — APPROVAL-CARD-SHOWS-HANDLED-AFTER-A-REFUSAL-1):
        //   { state: 'handled', text }    → ✓ <the app's words>
        //   { state: 'notApplied', text } → ✗ Not applied: <the app's reason>
        //   { state: 'rejected' }         → Rejected
        // A handled card without words (written before the field existed) keeps
        // the plain ✓ Handled. Measured on dev 2026-10-05 (Storm Tokens): a
        // REFUSED action's card said "✓ Handled" under the app's own refusal.
        // ONE LINE (APPROVAL-OUTCOME-PRINTED-TWICE-1, decided 2026-10-05): the
        // card is the only place the outcome shows — moduleActions.js no longer
        // adds a "✓ <words>" chat line under it, so the card says the words.
        PvAiHandled: {
            hide: (el, s)=>!!(s.root && s.root._aiAction && s.root._aiAction.id === s.id),
            text: (el, s)=>{
                const o = s.outcome && typeof s.outcome === 'object' ? s.outcome : null;
                if (o && o.state === 'rejected') return el.call('polyglot', 'ai.chatCard.rejected');
                if (o && o.state === 'notApplied') {
                    const label = el.call('polyglot', 'ai.chatCard.notApplied');
                    const why = typeof o.text === 'string' ? o.text.trim().slice(0, 240) : '';
                    return why ? `${label}: ${why}` : label;
                }
                const did = o && o.state === 'handled' && typeof o.text === 'string' ? o.text.trim().slice(0, 240) : '';
                return did ? `\u{2713} ${did}` : el.call('polyglot', 'ai.chatCard.handled');
            },
            // The outcome is the folded line's answer: primary text, it wraps.
            flex: '0 0 auto',
            maxWidth: '100%',
            fontSize: 'Z1',
            fontWeight: '500',
            overflowWrap: 'anywhere',
            // Ink that CARRIES MEANING takes the brand's theme-paired inks (raw
            // green / red read 2.15:1 / 2.45:1 as small text on a light ground —
            // brand designSystem/color.js), never a raw hue.
            color: (el, s)=>{
                const state = s.outcome && s.outcome.state;
                if (state === 'notApplied') return 'dangerInk';
                if (state === 'rejected') return 'caption';
                return 'successInk';
            }
        },
        // OPEN WHERE IT LANDED (BESSI dev 2026-10-28): an approved write that names
        // its page — `outcome.open`, which moduleActions.js _runOutcome keeps only
        // as a same-origin path — opens it in a SPLIT pane, so the thread moves
        // beside the page instead of giving way to it.
        // Shown only on a handled card, so always on the folded line: its end.
        AppCapsuleBtnGhost: {
            compact: true,
            marginLeft: 'auto',
            hide: (el, s)=>!(s.outcome && s.outcome.state === 'handled' && typeof s.outcome.open === 'string'),
            Label: {
                tag: 'span',
                text: '{{ common.action.open | polyglot }}'
            },
            Icon: {
                name: 'arrowRight',
                fontSize: 'Z2',
                flexShrink: '0'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                if (s.outcome && typeof s.outcome.open === 'string') el.call('openAppPage', s.outcome.open, {
                    split: true
                });
            }
        }
    },
    // INLINE GENERATIVE BLOCKS (AI_ASSISTANT_SPEC v1 §3) — an answer VIEW
    // (render_answer_ui), a RECORDS block, a generated BOARD, an installed app's
    // WIDGET or VIEW (embed_widget / embed_view), an app's own FORM from a
    // proposal (embed_form), WEB SOURCES (web_search / fetch_url) — drawn by
    // the workspace shell's own
    // AssistantThreadBlock on this card's surface. Only a host that registers
    // that component renders them; a host without it (the docs, the preview,
    // the extension panels) reads them through the fallback below instead of an
    // empty card.
    PvCardBlock: {
        if: (el, s)=>[
                'view',
                'records',
                'board',
                'widget',
                'form',
                'sources',
                'capabilities'
            ].includes(s.type) && !!(el.context && el.context.components && el.context.components.AssistantThreadBlock),
        extends: 'AssistantThreadBlock',
        theme: (el, s)=>el.scope.surface(s)
    },
    // Fallback — a card whose `type` no branch above claims. The dispatcher used
    // to be silent-empty here (a zero-height div): the model invented a type or
    // sent a malformed card, the tool reported ✓, and nothing appeared — the
    // worst failure mode because nobody sees it. Render the best generic reading
    // of the payload instead (item labels, or the card's own text), and warn so
    // the unknown type is discoverable in the console.
    PvCardFallback: {
        if: (el, s)=>![
                'tickets',
                'people',
                'thumbnails',
                'policies',
                'choice',
                'confirm',
                'aiAction'
            ].includes(s.type) && !([
                'view',
                'records',
                'board',
                'widget',
                'form',
                'sources',
                'capabilities'
            ].includes(s.type) && !!(el.context && el.context.components && el.context.components.AssistantThreadBlock)),
        extends: 'CommonCard',
        theme: (el, s)=>el.scope.surface(s),
        flow: 'y',
        gap: 'Y',
        onCreate: (el, s)=>{
            console.warn("[ChatCard] unknown card type \u2014 rendering generic fallback:", s.type, s);
        },
        PvFallbackRows: {
            flow: 'y',
            gap: 'X',
            childrenAs: 'state',
            children: (el, s)=>{
                const items = Array.isArray(s.items) ? s.items : [];
                if (items.length) return items.slice(0, 12).map((item, i)=>({
                        key: `fb-${i}`,
                        label: item && (item.title || item.name || item.label || item.caption || item.text) || (typeof item === 'string' ? item : JSON.stringify(item).slice(0, 80)),
                        sub: item && (item.state || item.role || item.email || item.status) || ''
                    }));
                const own = s.text || s.title || s.summary || s.prompt;
                return own ? [
                    {
                        key: 'fb-0',
                        label: String(own),
                        sub: ''
                    }
                ] : [];
            },
            childExtends: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                minWidth: '0',
                // The action's own words — primary text: it wraps (rule 8).
                PvFbLabel: {
                    tag: 'span',
                    fontSize: 'Z1',
                    color: 'title',
                    flex: '1 1 auto',
                    minWidth: '0',
                    overflowWrap: 'anywhere',
                    text: (el, s)=>s.label
                },
                PvFbSub: {
                    if: (el, s)=>!!s.sub,
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    flexShrink: '0',
                    text: (el, s)=>s.sub
                }
            }
        },
        PvFallbackNote: {
            text: (el, s)=>`unsupported card type \u{201C}${s.type || 'none'}\u{201D}`,
            fontSize: 'Y2',
            color: 'caption',
            opacity: '.6'
        }
    }
};

});

parcelRegister("kYbJX", function(module, exports) {

$parcel$export(module.exports, "ChatSourceChip", () => $03f08e86afd0043a$export$a333a5e66be5d3e5);
// ChatSourceChip — ONE cited source under an assistant answer (VaultOS v2
// design §4.2). Rendered by ChatMessage's `Sources` row via
// `childExtends: 'ChatSourceChip'`, one chip per entry of the assistant
// message's `sources` array.
//
// Row shape (the server's persisted `metadata.sources[]`):
//   { ref, type, id, title, use, verified }
// `ref` is the `ref:<type>:<id>` string form; `use` is the model's own
// one-line reason for citing it ("warranty cap, cl. 9"); `verified: false`
// marks a ref the turn's retrieval never actually opened. An unverified ref
// is KEPT and marked, never hidden: a claimed source the tools did not read
// is information, and dropping it would make an ungrounded answer look
// identical to a grounded one.
//
// It is a SEPARATE component, not an inline `childExtends: {}`, so a consumer
// can override the chip (FA808) and so the whole entity-ref grammar stays in
// one place. It deliberately does NOT extend AiContextChip: that component's
// click is bound to the alterable-reference mute toggle and its title factory
// renders the mute sentence, so a navigating chip with a `use` caption would
// be fighting it rather than reusing it.
//
// ── WHERE A CHIP GOES, AND WHAT IT DOES WHEN IT CANNOT GO (design §3.4/§3.5)
//
// A `record` opens on a MODULE page, resolved through the record-route
// registry the installed modules declare (shared/functions/entityRef.js
// `entityRefHref`). A module route must be opened with the shell's own opener,
// `openAppPage` — a raw `el.router('/vault-rooms?item=…')` is a HARD
// navigation to a blank page on the branded host (measured 2026-09-09). Every
// SHELL route (doc/mail/ticket/file/event/channel) keeps `el.router`, which is
// what it has always used and what the shell serves directly.
//
// And a chip whose ref this workspace cannot open is never dead-silent: it
// keeps its place, prints its KIND when the producer sent no title, says why
// in words, and hides the affordance by DISABLING the button rather than
// swallowing a click. A citation the reader cannot follow is still
// information; a control that does nothing is a lie.
//
// FA204 / frank trap — no module-scope const is read from any factory below;
// every entity-ref helper is reached with `el.call`, a runtime string lookup
// that survives frank.toJSON. The three derivations every factory needs live
// in `scope:` for the same reason (`el.scope.X` is the form frank rewrites to).
const $03f08e86afd0043a$export$a333a5e66be5d3e5 = {
    tag: 'button',
    type: 'button',
    scope: {
        // The chip may carry the string form, the flattened row, or both.
        raw (el, s) {
            return s.ref || {
                type: s.type,
                id: s.id,
                meta: s.meta
            };
        },
        refType (el, s) {
            try {
                const parsed = el.call('parseEntityRef', el.scope.raw(el, s));
                return parsed && parsed.type || '';
            } catch (_) {
                return '';
            }
        },
        // The destination, or null when nothing in this workspace opens it.
        href (el, s) {
            try {
                return el.call('entityRefHref', el.scope.raw(el, s), el.getRootState());
            } catch (_) {
                return null;
            }
        },
        // A canvas node is NOT unreadable — it has no route by design and is
        // re-focused on the open board instead (spec §4.6).
        isUnreadable (el, s) {
            return el.scope.refType(el, s) !== 'canvas' && !el.scope.href(el, s);
        },
        // WHAT the chip prints: the producer's own title, else the KIND. Never an
        // id — the Longbow board's "Mail thread f82cc8" is what an id-as-title
        // looks like to a reader (proposal §0 fact 4). `s.title` is tenant content
        // and passes through `translate()` unchanged, so one call serves both.
        label (el, s) {
            return s.title ? String(s.title) : el.call('polyglot', el.call('entityRefKindKey', el.scope.raw(el, s)));
        },
        // The label wrapped in the sentence that says what clicking does — or why
        // nothing will. The key carries a {name} hole so a translation orders the
        // two parts its own way.
        sentence (el, s) {
            const key = el.scope.isUnreadable(el, s) ? 'ai.sources.unreadableTitle' : 'ai.sources.open';
            return el.call('polyglot', key).replace('{name}', el.scope.label(el, s));
        }
    },
    flow: 'x',
    align: 'center start',
    gap: 'Y',
    padding: 'Y Z',
    round: 'radiusPill',
    // Borderless, fill-contrast separation (design-direction §8): the
    // house `overlay` wash, the house `hover` step on approach. No ring,
    // no shadow — the shadow budget belongs to the drawer, not to a chip.
    background: 'overlay',
    borderWidth: '0',
    color: 'title',
    fontSize: 'Y2',
    // An unopenable chip is not a control: no pointer, no hover step, out of
    // the tab order, `aria-disabled` for the reader. The BOX is unchanged, so
    // nothing beside it moves (Rule 66) — only the affordance goes.
    cursor: (el, s)=>el.scope.isUnreadable(el, s) ? 'default' : 'pointer',
    disabled: (el, s)=>el.scope.isUnreadable(el, s) ? true : null,
    maxWidth: '100%',
    minWidth: '0',
    textAlign: 'left',
    transition: 'B defaultBezier background',
    // Focus is NOT declared here: the global brand ring owns it
    // (DESIGN_LANGUAGE §8.2 — an `outline:` shorthand carrying a token letter
    // does not resolve, and that dead-ring class killed 20+ focus rings twice).
    ':hover': (el, s)=>el.scope.isUnreadable(el, s) ? {} : {
            background: 'hover'
        },
    // An unverified ref steps back to muted ink — the label stays fully
    // legible, the status is unmistakable, no strike-through noise (the
    // same grammar AiContextChip uses for a dropped item).
    isUnverified: (el, s)=>s.verified === false,
    // D-2 (2026-09-24): this text can sit on a washed dark row, where `inactive`
    // reads 4.29:1 on `hover` and 3.33:1 on `selected` — both under 4.5 — so the
    // quiet ink here is `caption`. (The chip washes `hover` on hover.)
    '.isUnverified': {
        color: 'caption'
    },
    // The name the reader hears, and the sentence around it. `{name}` is the
    // same label the chip prints — the ref's own title, else its KIND — so the
    // accessible name and the visible one can never disagree. An unopenable
    // chip must NOT be announced as "Open …".
    aria: {
        label: (el, s)=>el.scope.sentence(el, s),
        disabled: (el, s)=>el.scope.isUnreadable(el, s) ? 'true' : null
    },
    // A tooltip where it carries new information: on an unopenable chip the
    // sentence is the only place the reason appears for a pointer user; on an
    // openable one the chip's ONE line may be cut (a long document name, the
    // "why"), so the tooltip is the whole of it — the overflow law's condition
    // for an ellipsis (§3b rule 8).
    title: (el, s)=>{
        if (el.scope.isUnreadable(el, s)) return el.scope.sentence(el, s);
        const use = s.use ? " \xb7 " + String(s.use) : '';
        return el.scope.label(el, s) + use;
    },
    Icon: {
        name: (el, s)=>el.call('entityRefIcon', s.ref || s),
        boxSize: 'iconSm',
        flexShrink: '0',
        color: 'currentColor'
    },
    Label: {
        tag: 'span',
        text: (el, s)=>el.scope.label(el, s),
        fontWeight: '500',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: '0'
    },
    // WHY the source was cited. Quiet caption ink, same size as the label
    // so the row shares one baseline (Rule 34 — aligned siblings share
    // fontSize; both inherit the chip's own 'Y2').
    Use: {
        tag: 'span',
        if: (el, s)=>!!s.use,
        text: (el, s)=>"\xb7 " + String(s.use),
        color: 'caption',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: '0'
    },
    Unverified: {
        tag: 'span',
        if: (el, s)=>s.verified === false,
        text: '{{ ai.sources.unverified | polyglot }}',
        fontSize: 'X',
        color: 'caption',
        whiteSpace: 'nowrap',
        flexShrink: '0'
    },
    // §3.5 — one quiet line saying WHY nothing opens. The chip stays; only the
    // promise goes. The condition is fixed for the life of the chip (a ref does
    // not become readable mid-render), so this is not chrome that appears under
    // the pointer — no Rule 66 exposure.
    Unreadable: {
        tag: 'span',
        if: (el, s)=>el.scope.isUnreadable(el, s),
        text: '{{ ai.sources.unreadable | polyglot }}',
        fontSize: 'X',
        color: 'caption',
        whiteSpace: 'nowrap',
        flexShrink: '0'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        const raw = el.scope.raw(el, s);
        const type = el.scope.refType(el, s);
        // A canvas node has no route of its own — it lives INSIDE an open
        // board, so the right act is to re-focus it there. `focusCanvasEntity`
        // is registered by the canvas surface only; everywhere else the try
        // fails and the chip is a no-op rather than a navigation to nowhere.
        if (type === 'canvas') {
            try {
                el.call('focusCanvasEntity', el.call('formatEntityRef', raw));
            } catch (_) {
            /* not on a canvas surface — no-op */ }
            return;
        }
        const href = el.scope.href(el, s);
        // No installed module claims this collection, and the producer supplied
        // no `meta.href`. The chip already SAYS so and its button is disabled —
        // this branch only catches a click that arrived some other way (keyboard
        // on an older bundle, a synthetic event).
        if (!href) return;
        // A MODULE route must go through the shell's own opener: a plain
        // `el.router('/vault-rooms?item=…')` is a hard navigation to a blank page
        // on the branded host (measured 2026-09-09). `openAppPage` lands it in the
        // PageSlot exactly like a navbar tab, and `preferSlot` says so explicitly
        // rather than letting the opener re-derive it from boot-racy settings.
        // Every SHELL route keeps `el.router`, which is what serves them today.
        //
        // `record` is the one type whose home is a module page. If the opener is
        // not registered on this host (docs/preview), fall through to the router
        // rather than swallowing the click — degraded beats dead.
        if (type === 'record') try {
            el.call('openAppPage', href, {
                preferSlot: true
            });
            return;
        } catch (_) {
        /* no shell opener on this host — fall through to the router */ }
        try {
            el.router(href, el.getRoot());
        } catch (_) {
        /* no router on this host (docs/preview) — no-op */ }
    }
};

});

parcelRegister("e6Lsf", function(module, exports) {

$parcel$export(module.exports, "ChatConfidenceFactor", () => $a4566fb34502696b$export$ad14fc8207344e2c);
// ChatConfidenceFactor — ONE weighted factor of an answer's confidence score
// (VaultOS v2 design §4.3). Rendered by ChatMessage's `Confidence.Breakdown`
// via `childExtends: 'ChatConfidenceFactor'`, six times, in the spec's order:
// precedent · coverage · authority · freshness · consistency · self.
//
// Row state (built by ChatMessage's `confRows` scope method):
//   { key, factor, labelKey, value, pct }
// `labelKey` is the polyglot key as a LITERAL, minted upstream. Building it
// here from `factor` would be a runtime-assembled key — invisible to grep, to
// the en/ka parity test and to extraction (docs/I18N-CONVENTION.md §1.3).
// `value === null` means the server sent no number for that factor — the row
// then prints an em dash and an empty bar. That is NOT the same as zero, and
// the two must never render alike: an omitted factor says "not measured", a
// zero says "measured, and it failed".
//
// The bar is two flat fills and nothing else — no gridline, no axis, no
// outline (design-direction §8/§11). The fill takes `currentColor`, which the
// Confidence container sets to the band's semantic ink, so the bars and the
// pill above them are one reading rather than two colour decisions.
//
// FA204 / frank trap — no module-scope const is read from any factory here;
// the label goes through `el.call('polyglot', …)`, a runtime string lookup
// that survives frank.toJSON.
const $a4566fb34502696b$export$ad14fc8207344e2c = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    // One fontSize for the whole row: spacing tokens are em-based, so the
    // label, the bar and the figure only line up when they share it (Rule 34).
    fontSize: 'X',
    FactorName: {
        tag: 'span',
        text: (el, s)=>el.call('polyglot', s.labelKey || ''),
        color: 'caption',
        flexShrink: '0',
        // A FLOOR, not a fixed width: a hard `width` at this font size clips the
        // longest label ("Self-reported") on a narrow drawer.
        minWidth: 'D',
        whiteSpace: 'nowrap'
    },
    Track: {
        flex: '1 1 0',
        minWidth: '0',
        height: 'Y',
        round: 'radiusPill',
        background: 'selected',
        overflow: 'hidden',
        Fill: {
            height: '100%',
            round: 'radiusPill',
            background: 'currentColor',
            width: (el, s)=>s.pct + '%',
            transition: 'C defaultBezier width'
        }
    },
    FactorValue: {
        tag: 'span',
        text: (el, s)=>s.value == null ? "\u2014" : s.pct + '%',
        color: 'caption',
        flexShrink: '0',
        minWidth: 'B',
        textAlign: 'right'
    }
};

});

parcelRegister("18vPj", function(module, exports) {

$parcel$export(module.exports, "collapseCodeFences", () => collapseCodeFences);
$parcel$export(module.exports, "ChatMarkdown", () => ChatMarkdown);
// Render an assistant message's markdown into DOMQL nodes via the symbolize
// markdown transpiler — the same transpiler workspace/chat uses.
//
// Static import: resolves cleanly in BOTH real build paths — the parcel dev
// server that serves :1235 and the chrome-connect esbuild panel bundle (which
// bundles symbolize-markdown's prebuilt dist). (Parcel's *production*
// `parcel build` has an unrelated, pre-existing scope-hoisting defect, but
// that's not how simone ships — it runs via the dev server + the esbuild
// panel, neither of which scope-hoists.)
//
// el.set() is the canonical DOMQL escape hatch for swapping a subtree
// (workspace/chat's MarkdownPreview does the same). _lastMd caches the source
// so streaming re-renders that don't change the text are skipped.

var $3Rzdu = parcelRequire("3Rzdu");
const collapseCodeFences = (tree)=>{
    if (!tree || typeof tree !== 'object' || Array.isArray(tree)) return tree;
    const out = {};
    for (const key of Object.keys(tree)){
        const node = tree[key];
        const isPre = node && typeof node === 'object' && (node.tag === 'pre' || node.extends === 'Pre');
        if (!isPre) {
            out[key] = node;
            continue;
        }
        const codeText = node.CodeBlock && node.CodeBlock.text || '';
        const lines = String(codeText).split('\n').length;
        if (lines <= 3 && codeText.length <= 160) {
            out[key] = node;
            continue;
        }
        const lang = String(node['data-language'] || '').trim();
        out['CodeToggle_' + key] = {
            tag: 'details',
            width: '100%',
            minWidth: '0',
            round: 'radiusControl',
            overflow: 'hidden',
            margin: 'Y 0',
            Summary: {
                tag: 'summary',
                padding: 'Y Z',
                fontSize: 'Z2',
                fontFamily: 'monospace',
                color: 'caption',
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'B defaultBezier color',
                ':hover': {
                    color: 'title'
                },
                text: (el)=>`${lang || 'code'} \xb7 ` + el.call('polyglot', lines === 1 ? 'ai.chat.codeLine' : 'ai.chat.codeLines').replace('{count}', lines)
            },
            [key]: node
        };
    }
    return out;
};
const ChatMarkdown = {
    // FA204 / frank trap — COMPONENTS/render (+ a duplicated collapseCodeFences)
    // used to be bare module-scope const/function read from inside onCreate/
    // onUpdate (serialized factories); they read as undefined once this
    // component is frank.toJSON'd for platform delivery. Moved into `scope`,
    // called via `el.scope.<name>`. `collapseCodeFences` ALSO stays exported at
    // module scope (dual-mode, same idiom as AppOrgSwitcher's
    // `__orgSwitcherInternals`) because ChatMarkdown.test.js imports it bare for
    // offline Node coverage — the scope copy is what the live tree actually
    // calls.
    scope: {
        // Chat-bubble code mapping — same convention as renderAssistantMarkdown
        // and MarkdownPreview. Never leave these on the transpiler defaults:
        // default fenced/inline code maps to the full CodePreviewWithTitle chrome
        // (title + copy + framework switcher), which is wrong inside an
        // assistant bubble — this was the "AI-generated code renders the Code
        // preview" bug.
        COMPONENTS: {
            code: 'InlineCode',
            codeBlock: 'CodeBlock'
        },
        collapseCodeFences (tree) {
            if (!tree || typeof tree !== 'object' || Array.isArray(tree)) return tree;
            const out = {};
            for (const key of Object.keys(tree)){
                const node = tree[key];
                const isPre = node && typeof node === 'object' && (node.tag === 'pre' || node.extends === 'Pre');
                if (!isPre) {
                    out[key] = node;
                    continue;
                }
                const codeText = node.CodeBlock && node.CodeBlock.text || '';
                const lines = String(codeText).split('\n').length;
                if (lines <= 3 && codeText.length <= 160) {
                    out[key] = node;
                    continue;
                }
                const lang = String(node['data-language'] || '').trim();
                out['CodeToggle_' + key] = {
                    tag: 'details',
                    width: '100%',
                    minWidth: '0',
                    round: 'radiusControl',
                    overflow: 'hidden',
                    margin: 'Y 0',
                    Summary: {
                        tag: 'summary',
                        padding: 'Y Z',
                        fontSize: 'Z2',
                        fontFamily: 'monospace',
                        color: 'caption',
                        cursor: 'pointer',
                        userSelect: 'none',
                        transition: 'B defaultBezier color',
                        ':hover': {
                            color: 'title'
                        },
                        text: (el)=>`${lang || 'code'} \xb7 ` + el.call('polyglot', lines === 1 ? 'ai.chat.codeLine' : 'ai.chat.codeLines').replace('{count}', lines)
                    },
                    [key]: node
                };
            }
            return out;
        },
        render (el, s) {
            // Read the markdown source from state — s.text is the canonical
            // message string. el.text can hold the unresolved prop factory, which
            // would feed a function (not a string) into transformMarkdown.
            const body = s && typeof s.text === 'string' ? s.text : typeof el.text === 'string' ? el.text : '';
            if (el._lastMd === body) return;
            el._lastMd = body;
            if (!body) {
                el.set({
                    tag: 'span',
                    text: ''
                });
                return;
            }
            try {
                el.set(this.collapseCodeFences((0, $3Rzdu.transformMarkdown)(body, {
                    components: this.COMPONENTS
                })));
            } catch (_) {
                el.set({
                    tag: 'span',
                    text: body
                });
            }
        }
    },
    tag: 'div',
    flow: 'y',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    onCreate: (el, s)=>el.scope.render(el, s),
    onUpdate: (el, s)=>el.scope.render(el, s)
};

});

parcelRegister("1yK8J", function(module, exports) {

$parcel$export(module.exports, "ToolCallCard", () => $122cc1cf049182ba$export$215fefa8c8ab133a);
// Tool-call row for `role:'tool'` messages (the local-bridge transport pushes
// these) — same visual language as the ChatToolRow timeline: a quiet
// collapsed row (status glyph + tool name + duration-less hint), expandable to
// terminal-styled input/output blocks. Expansion rides root._aiToolOpen keyed
// by the message id, like the timeline rows, so it survives list re-patches.
// I/O renders through ToolTerminal (self-contained — resolves in the
// chrome-connect panel bundle where workspace/shared components don't).
const $122cc1cf049182ba$export$215fefa8c8ab133a = {
    flow: 'y',
    width: '100%',
    minWidth: '0',
    Head: {
        tag: 'button',
        type: 'button',
        flow: 'x',
        gap: 'Z',
        align: 'center',
        width: '100%',
        minWidth: '0',
        padding: 'Y Z',
        round: 'Z',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'B defaultBezier background',
        ':hover': {
            background: 'hover'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const root = s.root;
            if (!root || !root.update) return;
            const open = {
                ...root._aiToolOpen || {}
            };
            open[s.id] = !open[s.id];
            root.update({
                _aiToolOpen: open
            }, {
                preventFetch: true
            });
        },
        // Status glyph — a PERMANENT container so the glyph keeps its slot at the
        // row start; the variants inside are hide-gated (an `if`-gated child
        // REMOUNTS when status flips and lands appended at the row's end).
        // Key-based auto-extend: Icon / Icon_1 (the `_N` suffix is ignored).
        PvStatus: {
            boxSize: 'Z',
            flexShrink: '0',
            flow: 'x',
            align: 'center center',
            PvRunDot: {
                hide: (el, s)=>s.status !== 'pending',
                boxSize: 'Y',
                round: '50%',
                background: 'blue',
                flexShrink: '0',
                animationName: 'blinking',
                animationDuration: '1100ms',
                animationTimingFunction: 'ease-in-out',
                animationIterationCount: 'infinite'
            },
            Icon: {
                hide: (el, s)=>s.status === 'pending' || s.status === 'error',
                name: 'checkmark',
                boxSize: 'Z',
                color: 'green',
                flexShrink: '0'
            },
            Icon_1: {
                hide: (el, s)=>s.status !== 'error',
                name: 'x',
                boxSize: 'Z',
                color: 'red',
                flexShrink: '0'
            }
        },
        Name: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '500',
            flexShrink: '0',
            color: (el, s)=>s.status === 'pending' ? 'title' : 'caption',
            text: (el, s)=>{
                const name = String(s.toolName || 'tool').replace(/[_-]+/g, ' ').trim();
                return name ? name[0].toUpperCase() + name.slice(1) : 'Tool';
            }
        },
        // Secondary meta: one line; the tooltip carries the arguments (capped)
        // — the overflow law's condition for an ellipsis (§3b rule 8). The card
        // itself expands to the full payload.
        Hint: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            opacity: '.65',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '1 1 auto',
            minWidth: '0',
            title: (el, s)=>{
                const args = String(s.argsText || '').replace(/\s+/g, ' ').trim();
                if (!args) return null;
                return args.length > 400 ? args.slice(0, 400) + "\u2026" : args;
            },
            text: (el, s)=>{
                const args = String(s.argsText || '').replace(/\s+/g, ' ').trim();
                return args.length > 60 ? `${args.slice(0, 60)}\u{2026}` : args;
            }
        },
        Icon_2: {
            name: 'arrow angle down',
            boxSize: 'Z',
            color: 'caption',
            opacity: '.6',
            flexShrink: '0',
            transition: 'B defaultBezier transform',
            isOpen: (el, s)=>!!(s.root && s.root._aiToolOpen && s.root._aiToolOpen[s.id]),
            '.isOpen': {
                transform: 'rotate(180deg)'
            }
        }
    },
    Detail: {
        hide: (el, s)=>!(s.root && s.root._aiToolOpen && s.root._aiToolOpen[s.id]),
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        padding: 'X Z Y B',
        ToolTerminal: {
            if: (el, s)=>!!s.argsText,
            label: 'ai.tool.input',
            value: (el, s)=>s.argsText
        },
        ToolTerminal_1: {
            if: (el, s)=>!!s.resultText,
            label: 'ai.tool.output',
            value: (el, s)=>s.resultText
        }
    }
};

});

parcelRegister("kHf3q", function(module, exports) {

$parcel$export(module.exports, "ChatToolRow", () => $f11380488d2f54f0$export$a9cfa4e7ab21c288);
$parcel$export(module.exports, "ChatToolStepLabel", () => $f11380488d2f54f0$export$b49b012922d10877);

var $9GdJK = parcelRequire("9GdJK");
const $f11380488d2f54f0$export$a9cfa4e7ab21c288 = {
    // THE ARGUMENT NAMES, ONCE (dev.my 2026-10-31, CHECK 8d: a Georgian
    // session's collapsed row read "title: Undo gone" while its open details
    // said "სათაური"). The collapsed hint (Head.Hint) and the open details
    // (ToolArgsList) name an argument with the SAME words, from this one
    // helper: the map, the snake / kebab → camel read and the humanized
    // fallback. A `scope` method, not a module-scope helper: the factories
    // that call it are serialized by frank, where a module read is undefined
    // (the FA204 trap); the method is self-contained for the same reason, and
    // a host without polyglot (docs, preview) reads the humanized name.
    scope: {
        toolArgName (el, key, tool) {
            const bare = String(tool || '').replace(/^module_fn_/, '');
            // THE ARGUMENT NAMES IN WORDS (dev 2026-10-30: a Georgian session's
            // step read "Ticket" — the tool's own key, in English; the Tasks
            // app's word is "task"). The common keys of the AI tools, after the
            // Tasks and Calendar AI forms' own field words; snake / kebab keys
            // read as camel (start_time → startTime). Every key a literal for the
            // i18n gate. A task's `body` IS its description (the server takes
            // `description` as its alias).
            const words = {
                ticket: 'ai.toolArg.task',
                ticketId: 'ai.toolArg.task',
                task: 'ai.toolArg.task',
                taskId: 'ai.toolArg.task',
                title: 'ai.toolArg.title',
                name: 'ai.toolArg.name',
                description: 'ai.toolArg.description',
                body: /_ticket$/.test(bare) ? 'ai.toolArg.description' : 'ai.toolArg.text',
                text: 'ai.toolArg.text',
                content: 'ai.toolArg.text',
                message: 'ai.toolArg.message',
                status: 'ai.toolArg.status',
                priority: 'ai.toolArg.priority',
                assignee: 'ai.toolArg.assignee',
                dueDate: 'ai.toolArg.dueDate',
                due: 'ai.toolArg.dueDate',
                type: 'ai.toolArg.type',
                issueType: 'ai.toolArg.type',
                column: 'ai.toolArg.column',
                event: 'ai.toolArg.event',
                eventId: 'ai.toolArg.event',
                date: 'ai.toolArg.date',
                start: 'ai.toolArg.start',
                startTime: 'ai.toolArg.start',
                end: 'ai.toolArg.end',
                endTime: 'ai.toolArg.end',
                timezone: 'ai.toolArg.timeZone',
                timeZone: 'ai.toolArg.timeZone',
                invitees: 'ai.toolArg.invitees',
                project: 'ai.toolArg.project',
                projectId: 'ai.toolArg.project',
                page: 'ai.toolArg.page',
                note: 'ai.toolArg.note',
                noteId: 'ai.toolArg.note',
                folder: 'ai.toolArg.folder',
                file: 'ai.toolArg.file',
                channel: 'ai.toolArg.channel',
                email: 'ai.toolArg.email',
                role: 'ai.toolArg.role',
                query: 'ai.toolArg.search',
                q: 'ai.toolArg.search',
                search: 'ai.toolArg.search',
                newName: 'ai.toolArg.newName',
                newTitle: 'ai.toolArg.newTitle',
                agent: 'ai.toolArg.agent',
                agentId: 'ai.toolArg.agent',
                theme: 'ai.toolArg.theme',
                summary: 'ai.toolArg.summary'
            };
            const camel = String(key).replace(/[_-]+([a-zA-Z0-9])/g, (m, c)=>c.toUpperCase());
            const wordKey = Object.prototype.hasOwnProperty.call(words, camel) ? words[camel] : '';
            let said = '';
            if (wordKey) try {
                said = el.call('polyglot', wordKey);
            } catch (_) {
                said = '';
            }
            if (typeof said === 'string' && said && said !== wordKey) return said;
            // A name the vocabulary does not hold reads humanized ("viewId" →
            // "View id"), as before.
            const plain = String(key).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ').trim().toLowerCase();
            return plain ? plain.charAt(0).toUpperCase() + plain.slice(1) : String(key);
        }
    },
    flow: 'y',
    width: '100%',
    minWidth: '0',
    // Entrance — each tool step slides in from the left as it starts, giving
    // the live reasoning timeline a visible cadence (one-shot at node creation;
    // status patches on the same keyed row never re-trigger it).
    animationName: 'fadeInLeft',
    animationDuration: '300ms',
    animationTimingFunction: 'cubic-bezier(0.32, 0.72, 0, 1)',
    Head: {
        tag: 'button',
        type: 'button',
        flow: 'x',
        // The row WRAPS: where a narrow chat column (the app builder's, ~300px)
        // cannot hold the step's words beside Run / Run all / Skip, the controls
        // go to their own line under the words — never squeezing the label to one
        // letter per line (round 1b, ledger BLD-5: nino's and giorgi's Georgian
        // titles printed one letter per line beside the approval controls).
        flexWrap: 'wrap',
        gap: 'Z',
        align: 'center',
        width: '100%',
        minWidth: '0',
        padding: 'Y Z',
        // Clickable row header — same radius family as the Run/Skip/Open
        // controls below (`radiusControl`) rather than the spacing-letter
        // sequence: `Z` sits BELOW `A` in the shared letter alphabet
        // (`… W < X < Y < Z < A < B < C …`), so it does not even read as "small
        // A" — DESIGN_LANGUAGE.md §3's `old-letter-radius` lock retires this
        // whole letter-radius family in favor of the shape token table.
        round: 'radiusControl',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'B defaultBezier background',
        ':hover': {
            background: 'hover'
        },
        // A press steps the fill past the hover's: the brand's pressed wash
        // (`selected`), never opacity (Rule 65; the brand Interaction table). The
        // wash controls below take the same step.
        ':active': {
            background: 'selected'
        },
        // A finger's target: the 35px row takes the house tap slop (_touchTarget.js)
        // — UNDER its own controls. The slop is an absolute `:after`, painted over
        // the row's in-flow children, so every tap on Run / Run all / Open / Undo
        // hit this button and only toggled the details; Skip answered because it
        // overflowed past the row (round 1b, ledger BLD-5: giorgi's four taps on a
        // tablet). Its own stacking context with the pseudo at -1 (the
        // HomeTopSummary wash's recipe) keeps the 6px past the edge and hands every
        // tap on a control to the control.
        '@coarse': {
            position: 'relative',
            isolation: 'isolate',
            ':after': {
                ...(0, $9GdJK.touchSlop)[':after'],
                zIndex: '-1'
            }
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const root = s.root;
            if (!root || !root.update) return;
            const open = {
                ...root._aiToolOpen || {}
            };
            open[s.id] = !open[s.id];
            root.update({
                _aiToolOpen: open
            }, {
                preventFetch: true
            });
        },
        // Status glyph — a PERMANENT container so the glyph keeps its slot at the
        // row start: a status flip swaps the glyph inside the fixed box, and
        // nothing beside it moves. The variants inside are hide-gated: each stays
        // mounted, and a flip only toggles its `display`. (An `if:`-gated child
        // would not land at the row's end either: smbls inserts it at its
        // declared place, insertIfElementAtDeclaredOrder in element/src/core.js.)
        // Key-based auto-extend: Icon / Icon_1 (the `_N` suffix is ignored).
        PvStatus: {
            boxSize: 'Z',
            flexShrink: '0',
            flow: 'x',
            align: 'center center',
            PvRunDot: {
                hide: (el, s)=>s.status !== 'running',
                boxSize: 'Y',
                round: '50%',
                background: 'blue',
                flexShrink: '0',
                animationName: 'blinking',
                animationDuration: '1100ms',
                animationTimingFunction: 'ease-in-out',
                animationIterationCount: 'infinite'
            },
            // Awaiting the user's Run / Skip — the authorization gate paused this
            // call (simoneAiTransport runClientToolWithAuth). Amber, same pulse.
            PvAskDot: {
                hide: (el, s)=>s.status !== 'approval',
                boxSize: 'Y',
                round: '50%',
                background: 'orange',
                flexShrink: '0',
                animationName: 'blinking',
                animationDuration: '1100ms',
                animationTimingFunction: 'ease-in-out',
                animationIterationCount: 'infinite'
            },
            Icon: {
                hide: (el, s)=>s.status !== 'done',
                name: 'checkmark',
                boxSize: 'Z',
                color: 'green',
                flexShrink: '0'
            },
            Icon_1: {
                hide: (el, s)=>s.status !== 'error',
                name: 'x',
                boxSize: 'Z',
                color: 'red',
                flexShrink: '0'
            },
            // Denied — the user skipped it. Quiet, not red: declining an action the
            // gate asked about is a normal outcome, not a failure.
            Icon_2: {
                hide: (el, s)=>s.status !== 'denied',
                name: 'x',
                boxSize: 'Z',
                color: 'caption',
                opacity: '.6',
                flexShrink: '0'
            }
        },
        Label: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '500',
            flexShrink: '0',
            // The server label is PRIMARY text (HOME_AMBIENT_SKIN_SPEC §3b rule 8):
            // up to 80 characters that wrap and are cut nowhere, at 390 too. It
            // takes the free width the hidden hint leaves (the duration and the
            // chevron keep the row's end, like every other row) and shrinks below
            // its text width to wrap instead of pushing the row; 1.5 is the house
            // body leading for Georgian descenders on a second line.
            // A FLOOR for the words (the spacing scale's `G`): below it the row wraps
            // the controls onto the next line instead of shrinking the label further
            // (BLD-5). Never wider than the line less the status glyph and its gap
            // (`B` here: the glyph and the gap are `Z` each in the row's own font,
            // the label is a step smaller), so the words keep the glyph's line and a
            // column narrower than the floor never overflows. The basis is the same
            // floor: a basis of the full text would start a line of its own.
            isLabelled: (el, s)=>typeof s.label === 'string' && s.label.trim() !== '',
            '.isLabelled': {
                flex: '1 1 min(var(--spacing-G), calc(100% - var(--spacing-B)))',
                minWidth: 'min(var(--spacing-G), calc(100% - var(--spacing-B)))',
                overflowWrap: 'anywhere',
                lineHeight: '1.5'
            },
            color: (el, s)=>s.status === 'running' || s.status === 'approval' || s.status === 'done' && s.created ? 'title' : 'caption',
            opacity: (el, s)=>s.status === 'denied' ? '.55' : s.status === 'running' ? '.9' : '1',
            text: (el, s)=>{
                // The server's words are the row — already in the turn's language —
                // except for a DONE write that names what it made (the created phrase
                // below). Read before any branch, so the factory tracks the key from
                // the first render.
                const label = typeof s.label === 'string' ? s.label.trim() : '';
                const status = s.status;
                const answer = typeof s.answer === 'string' ? s.answer.trim() : '';
                // Verb-phrase label per tool — inline (self-contained) so it survives
                // frank serialization in brender hosts. Every phrase is a language key
                // (persona round 3, B8: a step with no server label printed English
                // words — "Building an extension" — on a Georgian page), read in the
                // active language with its `{hole}`s filled. The server sends a label
                // on every frame now, so this is the fallback for an older server or
                // a saved turn.
                const t = (key, fill)=>{
                    let raw = '';
                    try {
                        raw = el.call('polyglot', key);
                    } catch (_) {
                        raw = '';
                    }
                    let str = typeof raw === 'string' && raw && raw !== key ? raw : '';
                    if (str && fill) for (const hole of Object.keys(fill))str = str.split(hole).join(fill[hole]);
                    return str;
                };
                const tool = String(s.tool || 'tool');
                // Module fns arrive as module_fn_<app><Verb…> from the server frame —
                // strip the transport prefix so the label map and the humanizer see
                // the real fn name (the raw form rendered as "Module fn excalidraw
                // clear").
                const bare = tool.replace(/^module_fn_/, '');
                const a = s.args || {};
                const q = (v, n = 48)=>{
                    const str = String(v == null ? '' : v).trim();
                    return str.length > n ? `${str.slice(0, n)}\u{2026}` : str;
                };
                // AI-301 (tickets/ai.md) — a COMPLETED write names what it made, not
                // what it was doing: "Created note “Q3 plan”" beats "Creating a note".
                // It wins over the server's label too: that label is the step in
                // progress ("Creating the task “…”"), and a done task row kept it
                // (wave 2, dev 2026-10-28). The phrase is in the active language (B8).
                // The structured outcome rides s.created — stamped live by the
                // transport from the client tool's own return value, restored on
                // reload by sessions._toChatMessages. The kind is a word of the
                // active language too (an unknown kind reads "item").
                const c = s.created;
                if (status === 'done' && c && typeof c === 'object') {
                    const kindKey = {
                        note: 'ai.toolKind.note',
                        document: 'ai.toolKind.document',
                        ticket: 'ai.toolKind.ticket',
                        channel: 'ai.toolKind.channel',
                        folder: 'ai.toolKind.folder',
                        project: 'ai.toolKind.project',
                        agent: 'ai.toolKind.agent',
                        event: 'ai.toolKind.event'
                    }[String(c.kind || '')] || 'ai.toolKind.item';
                    const kind = t(kindKey) || String(c.kind || 'item');
                    const title = q(c.title);
                    const made = title ? t('ai.toolStep.createdNamed', {
                        '{kind}': kind,
                        '{title}': title
                    }) : t('ai.toolStep.created', {
                        '{kind}': kind
                    });
                    if (made) return made;
                }
                // AN ANSWERED QUESTION SAYS WHAT WAS CHOSEN (W7 live, 2026-10-28: an
                // ask_user answered "No, cancel" still read "Waiting for your choice").
                // The server's ask_user label is the WAIT. Once the person picks, the
                // row names the pick (`answer` — the transport stamps it, a reload
                // restores it from the saved result); a question a new message closed
                // reads as unanswered. A failed one keeps the server's words.
                // A confirmation (confirm_with_user) asks on the same in-chat card and
                // gets the same `answer` stamp (F3, dev 2026-10-28: its row still read
                // "Waiting for your confirmation" after the answer).
                // A question its turn left (`denied`: a stop, a failed or ended turn —
                // the transport's _endWaitingCards; a reload of its not-run result)
                // reads as unanswered too, from the key: the label the transport wrote
                // then is in the language of that moment.
                // The answer is said ONCE (coordinator W3a): the row names it only
                // whole, up to 48 characters, and the card under the row then drops
                // it from its folded line (ChatMessage.scope.rowNamesPick, the same
                // limit). A longer answer — the person's own words — reads "You
                // answered" here, and its card shows the words.
                if (bare === 'ask_user' || bare === 'askUser' || bare === 'confirm_with_user' || bare === 'confirmWithUser') {
                    const said = status === 'done' ? answer && answer.length <= 48 ? t('ai.toolStep.chose', {
                        '{choice}': answer
                    }) : t('ai.toolStep.answered') : status === 'superseded' || status === 'denied' ? t('ai.toolStep.askUnanswered') : '';
                    if (said) return said;
                }
                if (label) return label;
                // [key, holes] per tool — each hole named as written in the bundle
                // ('{query}'); a phrase with a hole only when the argument is there.
                const keys = {
                    open_search: a.query ? [
                        'ai.toolStep.searchFor',
                        {
                            '{query}': q(a.query)
                        }
                    ] : [
                        'ai.toolStep.search'
                    ],
                    navigate_to_app: a.route ? [
                        'ai.toolStep.openRoute',
                        {
                            '{route}': q(a.route)
                        }
                    ] : [
                        'ai.toolStep.navigate'
                    ],
                    open_page_in_split: a.route ? [
                        'ai.toolStep.openBeside',
                        {
                            '{route}': q(a.route)
                        }
                    ] : [
                        'ai.toolStep.closeSplit'
                    ],
                    render_answer_ui: a.title ? [
                        'ai.toolStep.drawAnswerNamed',
                        {
                            '{title}': q(a.title)
                        }
                    ] : [
                        'ai.toolStep.drawAnswer'
                    ],
                    select_page_item: a.type ? [
                        'ai.toolStep.openType',
                        {
                            '{type}': q(a.type)
                        }
                    ] : [
                        'ai.toolStep.openItem'
                    ],
                    set_theme: a.theme ? [
                        'ai.toolStep.switchThemeTo',
                        {
                            '{theme}': q(a.theme)
                        }
                    ] : [
                        'ai.toolStep.switchTheme'
                    ],
                    confirm_with_user: [
                        'ai.toolStep.confirm'
                    ],
                    ask_user: [
                        'ai.toolStep.choose'
                    ],
                    close_modals: [
                        'ai.toolStep.closeDialogs'
                    ],
                    render_cards: [
                        'ai.toolStep.showCards'
                    ],
                    list_projects: [
                        'ai.toolStep.readProjects'
                    ],
                    list_workspace_records: a.collection ? [
                        'ai.toolStep.readRecords',
                        {
                            '{collection}': q(a.collection)
                        }
                    ] : [
                        'ai.toolStep.listCollections'
                    ],
                    list_deployments: [
                        'ai.toolStep.checkDeployments'
                    ],
                    list_builds: a.buildId ? [
                        'ai.toolStep.readBuildLog'
                    ] : [
                        'ai.toolStep.readBuilds'
                    ],
                    list_project_environments: [
                        'ai.toolStep.readEnvironments'
                    ],
                    get_project: [
                        'ai.toolStep.readProject'
                    ],
                    create_project: a.name ? [
                        'ai.toolStep.createProjectNamed',
                        {
                            '{name}': q(a.name)
                        }
                    ] : [
                        'ai.toolStep.createProject'
                    ],
                    update_project: [
                        'ai.toolStep.updateProject'
                    ],
                    commit_project_changes: [
                        'ai.toolStep.commitChanges'
                    ],
                    create_extension: a.name ? [
                        'ai.toolStep.buildExtensionNamed',
                        {
                            '{name}': q(a.name)
                        }
                    ] : [
                        'ai.toolStep.buildExtension'
                    ],
                    create_app: [
                        'ai.toolStep.createApp'
                    ],
                    update_app: [
                        'ai.toolStep.updateApp'
                    ],
                    list_members: [
                        'ai.toolStep.readMembers'
                    ],
                    invite_member: a.email ? [
                        'ai.toolStep.inviteEmail',
                        {
                            '{email}': q(a.email)
                        }
                    ] : [
                        'ai.toolStep.inviteMember'
                    ],
                    list_invitations: [
                        'ai.toolStep.readInvitations'
                    ],
                    cancel_invitation: [
                        'ai.toolStep.cancelInvitation'
                    ],
                    update_member_role: [
                        'ai.toolStep.updateRole'
                    ],
                    remove_member: [
                        'ai.toolStep.removeMember'
                    ],
                    rename_workspace: [
                        'ai.toolStep.renameWorkspace'
                    ],
                    list_agents: [
                        'ai.toolStep.readAgents'
                    ],
                    create_agent: a.name ? [
                        'ai.toolStep.createAgentNamed',
                        {
                            '{name}': q(a.name)
                        }
                    ] : [
                        'ai.toolStep.createAgent'
                    ],
                    update_agent: [
                        'ai.toolStep.updateAgent'
                    ],
                    delegate_tasks: [
                        'ai.toolStep.delegate'
                    ],
                    chain_agents: [
                        'ai.toolStep.chainAgents'
                    ],
                    create_ticket: a.title ? [
                        'ai.toolStep.createTicketNamed',
                        {
                            '{title}': q(a.title)
                        }
                    ] : [
                        'ai.toolStep.createTicket'
                    ],
                    update_ticket: [
                        'ai.toolStep.updateTicket'
                    ],
                    assign_ticket: a.email ? [
                        'ai.toolStep.assignTo',
                        {
                            '{email}': q(a.email)
                        }
                    ] : [
                        'ai.toolStep.clearAssignee'
                    ],
                    move_ticket: [
                        'ai.toolStep.moveTicket'
                    ],
                    delete_ticket: [
                        'ai.toolStep.deleteTicket'
                    ],
                    propose_action: a.summary ? [
                        'ai.toolStep.proposeSummary',
                        {
                            '{summary}': q(a.summary)
                        }
                    ] : [
                        'ai.toolStep.propose'
                    ],
                    // An installed app's own action (the server name and the el.call
                    // name): the act, never its key — "actionKey: bsDraftOrder" (dev
                    // 2026-10-28). The approval card under the row names the change.
                    propose_app_action: [
                        'ai.toolStep.propose'
                    ],
                    proposeModuleAction: [
                        'ai.toolStep.propose'
                    ],
                    create_folder: [
                        'ai.toolStep.createFolder'
                    ],
                    create_note: a.title ? [
                        'ai.toolStep.createNoteNamed',
                        {
                            '{title}': q(a.title)
                        }
                    ] : [
                        'ai.toolStep.createNote'
                    ],
                    create_channel: [
                        'ai.toolStep.createChannel'
                    ],
                    send_message: [
                        'ai.toolStep.sendMessage'
                    ],
                    // Module apps (both the server snake name and the el.call camel name
                    // — frames carry one, dispatch data the other).
                    excalidraw_get_scene: [
                        'ai.toolStep.readDrawing'
                    ],
                    excalidrawGetScene: [
                        'ai.toolStep.readDrawing'
                    ],
                    excalidraw_add_elements: [
                        'ai.toolStep.addDrawing'
                    ],
                    excalidrawAddElements: [
                        'ai.toolStep.addDrawing'
                    ],
                    excalidraw_update_elements: [
                        'ai.toolStep.editDrawing'
                    ],
                    excalidrawUpdateElements: [
                        'ai.toolStep.editDrawing'
                    ],
                    excalidraw_delete_elements: [
                        'ai.toolStep.eraseDrawing'
                    ],
                    excalidrawDeleteElements: [
                        'ai.toolStep.eraseDrawing'
                    ],
                    excalidraw_clear: [
                        'ai.toolStep.clearDrawing'
                    ],
                    excalidrawClear: [
                        'ai.toolStep.clearDrawing'
                    ]
                };
                const hit = Object.prototype.hasOwnProperty.call(keys, bare) ? keys[bare] : null;
                const said = hit ? t(hit[0], hit[1]) : '';
                if (said) return said;
                // A tool with no phrase of its own: the plain step words of the
                // active language. Only a host with no language bundle at all falls
                // to the tool's own name — humanized, snake and camel (module fns
                // arrive camelCased: excalidrawAddElements).
                const generic = t('ai.toolStep.generic');
                if (generic) return generic;
                const words = bare.replace(/[_-]+/g, ' ').replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase().trim();
                return words ? words[0].toUpperCase() + words.slice(1) : 'Tool';
            }
        },
        // Compact args hint after the label — first couple of arg values, clipped.
        // Secondary meta: the one line may be cut, so the tooltip carries the
        // arguments whole (capped — a payload can be a whole document) — the
        // overflow law's condition for an ellipsis (§3b rule 8). Only on a row
        // WITHOUT a server label: a labelled row says the step in words, and its
        // exact arguments stay in the expanded terminal.
        // In the person's words (dev.my 2026-10-31, CHECK 8d: a Georgian row read
        // "შეიქმნა: შენიშვნა „Undo gone“" and beside it "title: Undo gone"): each
        // argument is named as the open details name it (scope.toolArgName — one
        // map), and a value the step's words already show is not said twice.
        Hint: {
            hide: (el, s)=>typeof s.label === 'string' && s.label.trim() !== '',
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            opacity: '.65',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '1 1 auto',
            minWidth: '0',
            title: (el, s)=>{
                const a = s.args;
                if (!a || typeof a !== 'object') return null;
                let str = '';
                try {
                    str = JSON.stringify(a);
                } catch (_) {
                    return null;
                }
                if (!str || str === '{}' || str === '[]') return null;
                return str.length > 400 ? str.slice(0, 400) + "\u2026" : str;
            },
            text: (el, s)=>{
                const a = s.args;
                const tool = s.tool;
                if (!a || typeof a !== 'object') return '';
                // Positional args (module fns): the whole payload is an array, or a
                // named bag whose only key is the positional `args` array — the
                // key-walk below yields nothing for those, so preview them directly.
                const preview = (v)=>{
                    const str = JSON.stringify(v);
                    return str && str.length > 56 ? `${str.slice(0, 56)}\u{2026}` : str || '';
                };
                if (Array.isArray(a)) return preview(a);
                if (Array.isArray(a.args)) {
                    const inner = Array.isArray(a.args[0]) ? a.args[0] : a.args;
                    if (!inner.length) return '';
                    // the count in the active language (B8 — never an English "items")
                    const key = inner.length === 1 ? 'ai.toolStep.oneItem' : 'ai.tool.items';
                    let raw = '';
                    try {
                        raw = el.call('polyglot', key);
                    } catch (_) {
                        raw = '';
                    }
                    const word = typeof raw === 'string' && raw && raw !== key ? raw : '';
                    return word ? word.replace('{count}', String(inner.length)) : String(inner.length);
                }
                // Never an id (dev 2026-10-29: "access: private · projectId: 6aa332f5…"):
                // a database id or a uuid is a code name, not the person's words — the
                // tooltip and the expanded terminal keep the whole arguments.
                const isId = (str)=>/^[0-9a-f]{24}$/i.test(str) || /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(str);
                // SAID ONCE (the CHECK 8d row): a value the step's words show — the
                // item a done step made ("შეიქმნა: შენიშვნა „Undo gone“"), a phrase's
                // own value ("Searching “q3 plan”") — is not said twice; the rest of
                // the arguments stay. The words come from the Label's own factory
                // (the one ChatToolStepLabel reuses), read through the element tree:
                // the hint never disagrees with the step it sits beside, and this
                // factory stays self-contained for frank.
                const step = el.parent && el.parent.Label;
                const stepWords = (row)=>{
                    let said = '';
                    try {
                        said = step && typeof step.text === 'function' ? step.text(step, row) : '';
                    } catch (_) {
                        said = '';
                    }
                    return typeof said === 'string' ? said : '';
                };
                // Whole: both edges next to a non-letter or the words' own ends (a
                // value the hint cuts, by its start alone).
                const holds = (words, part, cut)=>{
                    for(let at = words.indexOf(part); at >= 0; at = words.indexOf(part, at + 1)){
                        if (/[\p{L}\p{N}]/u.test(words.charAt(at - 1))) continue;
                        if (!cut && /[\p{L}\p{N}]/u.test(words.charAt(at + part.length))) continue;
                        return true;
                    }
                    return false;
                };
                // The step's words for the row with one value taken out of its data
                // (the arguments, the item it made): words that still hold the value
                // hold it as a word of the phrase or of a longer value ("Updating a
                // task" beside a type "task"), so that argument is not said yet.
                const drop = (o, str)=>{
                    if (!o || typeof o !== 'object' || Array.isArray(o)) return o;
                    const kept = {};
                    for (const k of Object.keys(o)){
                        const v = o[k];
                        if (v == null || typeof v === 'object' || String(v).trim() !== str) kept[k] = v;
                    }
                    return kept;
                };
                const words = stepWords(s);
                const parts = [];
                for (const key of Object.keys(a)){
                    const v = a[key];
                    if (v == null || typeof v === 'object') continue;
                    const str = String(v).trim();
                    if (!str || isId(str)) continue;
                    // the part of the value this hint shows: its first 40 characters
                    const part = str.slice(0, 40);
                    const cut = part.length < str.length;
                    if (holds(words, part, cut)) {
                        const rest = {
                            ...s,
                            args: drop(a, str),
                            created: drop(s.created, str)
                        };
                        if (!holds(stepWords(rest), part, cut)) continue;
                    }
                    parts.push(`${el.scope.toolArgName(el, key, tool)}: ${cut ? `${part}\u{2026}` : str}`);
                    if (parts.length >= 2) break;
                }
                return parts.join(" \xb7 ");
            }
        },
        // AI-301 — the created item as a LIVE LINK on its own row: one click opens
        // the note/document/ticket/channel via the house deep-open path
        // (selectPageItem — the same el.call the select_page_item tool uses;
        // off-page fetch + navigation included). Only kinds with a canonical open
        // path get the affordance; the kind→type map is INLINE (self-contained)
        // so it survives frank serialization in brender hosts. Guarded — docs/
        // preview mount this row without the workspace function barrel, where the
        // call is unavailable and the button no-ops instead of throwing.
        OpenCreated: {
            // AI-306 — an undone item has nothing to open; the pair of affordances
            // collapses to the quiet "undone" tag below.
            // FA515: the hide reads s.root._aiUndone only after its other tests
            // pass. Each of those tests reads a state key today, so the factory
            // runs again (and subscribes) when one changes; the declaration keeps
            // the subscription from resting on that — a later test that reads no
            // signal (an el.call, a plain field) would drop it.
            hideDeps: [
                '_aiUndone'
            ],
            hide: (el, s)=>s.status !== 'done' || !s.created || ![
                    'note',
                    'document',
                    'ticket',
                    'channel',
                    'event'
                ].includes(String(s.created.kind || '')) || !!(s.root && s.root._aiUndone && s.created.id && s.root._aiUndone[String(s.created.id)]),
            tag: 'button',
            type: 'button',
            flow: 'x',
            align: 'center',
            gap: 'X',
            flexShrink: '0',
            padding: 'X Z',
            round: 'radiusPill',
            border: 'none',
            background: 'transparent',
            // Semantic ink pair (`['blueDeep', 'blueBright']`, DESIGN_SYSTEM.md
            // "raw-hue-ink" lock / symbols-mcp Rule 69), not the raw `blue` hue —
            // this is text ink, so it needs a light/dark pair, not a single fixed
            // value tuned to one ground.
            color: 'accentInk',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'B defaultBezier background',
            ':hover': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            },
            // A finger's target of its own (touchRow — a control among neighbours),
            // like Run / Skip below.
            '@coarse': {
                minHeight: 'controlH',
                minWidth: 'controlH'
            },
            Label: {
                tag: 'span',
                text: '{{ common.action.open | polyglot }}'
            },
            Icon: {
                name: 'arrowRight',
                fontSize: 'Z2',
                flexShrink: '0'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const c = s.created;
                if (!c || !c.id) return;
                const type = {
                    note: 'note',
                    document: 'document',
                    ticket: 'ticket',
                    channel: 'channel',
                    event: 'event'
                }[String(c.kind || '')];
                if (!type) return;
                try {
                    el.call('selectPageItem', type, String(c.id));
                } catch (_) {
                /* host without the workspace fn barrel — affordance no-ops */ }
            }
        },
        // AI-306 (tickets/ai.md) — one-click Undo for an AI write, beside the
        // Open pill on the row that made it. Session-scoped: the latch lives on
        // root state (`_aiUndone`, keyed by created id), so it survives the
        // per-delta message churn but not a reload — matching the ticket's
        // scope. The delete paths are the EXISTING registered ops
        // (aiDeleteNote resolves notes AND documents by id; aiDeleteTicket) —
        // no new deletion capability, the same guarded el.call idiom as every
        // sibling. Channels are deliberately excluded: no aiDeleteChannel op
        // exists, and Undo must never gain destructive reach the AI itself
        // does not have. Guarded — hosts without the workspace fn barrel no-op.
        UndoCreated: {
            // read behind a conditional — declared so the factory re-fires (FA515;
            // see OpenCreated)
            hideDeps: [
                '_aiUndone'
            ],
            hide: (el, s)=>s.status !== 'done' || !s.created || ![
                    'note',
                    'document',
                    'ticket',
                    'event'
                ].includes(String(s.created.kind || '')) || !!(s.root && s.root._aiUndone && s.created.id && s.root._aiUndone[String(s.created.id)]),
            tag: 'button',
            type: 'button',
            flexShrink: '0',
            padding: 'X Z',
            round: 'radiusPill',
            border: 'none',
            background: 'transparent',
            color: 'caption',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'B defaultBezier background, color',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            ':active': {
                background: 'selected',
                color: 'title'
            },
            '@coarse': {
                minHeight: 'controlH',
                minWidth: 'controlH'
            },
            // After a failed Undo the same button offers the retry (UndoFailure
            // below says why).
            Label: {
                tag: 'span',
                // read behind a conditional — declared so the factory re-fires (FA515)
                hideDeps: [
                    '_aiUndoError'
                ],
                hide: (el, s)=>!!(s.created && s.root && s.root._aiUndoError && s.root._aiUndoError[s.created.id]),
                text: '{{ ai.tool.undo | polyglot }}'
            },
            RetryLabel: {
                tag: 'span',
                hideDeps: [
                    '_aiUndoError'
                ],
                hide: (el, s)=>!(s.created && s.root && s.root._aiUndoError && s.root._aiUndoError[s.created.id]),
                text: '{{ ai.tool.undoRetry | polyglot }}'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const c = s.created;
                if (!c || !c.id) return;
                const kind = String(c.kind || '');
                if (![
                    'note',
                    'document',
                    'ticket',
                    'event'
                ].includes(kind)) return;
                // One delete at a time: a second click while it runs sends nothing.
                if (el._undoBusy) return;
                const id = String(c.id);
                const root = s.root;
                // A failed Undo stays on the row (`_aiUndoError`, keyed by the created
                // id, the `_aiUndone` latch's twin) until a retry works. It keeps the
                // CAUSE CODE aiUndoCreated classified, never the raw error: the row
                // says the cause in the active language (UndoFailure below).
                const noteFailure = (cause)=>{
                    if (!root || !root.update) return;
                    const was = root._aiUndoError || {};
                    if (cause === null && !(id in was)) return;
                    const next = {
                        ...was
                    };
                    if (cause === null) delete next[id];
                    else next[id] = {
                        cause: String(cause || '')
                    };
                    root.update({
                        _aiUndoError: next
                    }, {
                        preventFetch: true
                    });
                };
                let pending;
                try {
                    // aiUndoCreated deletes BY ID (no page-state name-resolve — the
                    // arrays are empty off their routes, and a name-resolve failure
                    // here once looked like success). The latch is EVIDENCE-based:
                    // only an explicit ok result marks the row undone.
                    pending = el.call('aiUndoCreated', kind, id);
                } catch (_) {
                    return;
                /* host without the workspace fn barrel — affordance no-ops */ }
                // A host without the op answers undefined: nothing ran, nothing to say.
                if (pending === undefined) return;
                el._undoBusy = true;
                Promise.resolve(pending).then((res)=>{
                    if (!res || res.ok === false) return noteFailure(res && res.cause || '');
                    noteFailure(null);
                    if (!root || !root.update) return;
                    root.update({
                        _aiUndone: {
                            ...root._aiUndone || {},
                            [id]: true
                        }
                    }, {
                        preventFetch: true
                    });
                }, (err)=>{
                    // The raw error is for the console; the row says the fallback.
                    console.warn('[ChatToolRow] Undo failed:', err);
                    noteFailure('');
                }).then(()=>{
                    el._undoBusy = false;
                });
            }
        },
        // Quiet outcome tag once undone — same slot/voice as SkippedTag below.
        UndoneTag: {
            // read behind a conditional — declared so the factory re-fires (FA515;
            // see OpenCreated)
            hideDeps: [
                '_aiUndone'
            ],
            hide: (el, s)=>!(s.status === 'done' && s.created && s.created.id && s.root && s.root._aiUndone && s.root._aiUndone[String(s.created.id)]),
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            opacity: '.6',
            flexShrink: '0',
            fontStyle: 'italic',
            text: '{{ ai.tool.undone | polyglot }}'
        },
        // A step a new message closed while it waited on Run / Skip (the
        // transport's supersedeParkedAiToolApprovals; history: reason
        // `new_message`). Not the person's "skipped": they wrote instead. "Run it
        // now" asks the AI again as their follow-up (aiToolRunNow) — the server
        // already closed the call, so nothing runs in place. Once per row. A
        // question's card under its step leaves this reason to the row (ChatCard
        // PvWhy), so a question row keeps the tag (see SkippedTag).
        SupersededTag: {
            hide: (el, s)=>s.status !== 'superseded',
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            opacity: '.6',
            flexShrink: '1',
            fontStyle: 'italic',
            text: '{{ ai.tool.superseded | polyglot }}'
        },
        // A question (ask_user) or a confirmation (confirm_with_user) is answered,
        // never run: its superseded row has no "Run it now" — the step would read
        // "Waiting for your choice". The names are inline (self-contained).
        RunNow: {
            hide: (el, s)=>s.status !== 'superseded' || !!s.rerun || [
                    'ask_user',
                    'askUser',
                    'confirm_with_user',
                    'confirmWithUser'
                ].includes(String(s.tool || '')),
            tag: 'button',
            type: 'button',
            flexShrink: '0',
            padding: 'X Z',
            round: 'radiusPill',
            border: 'none',
            background: 'transparent',
            color: 'accentInk',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'B defaultBezier background',
            ':hover': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            },
            '@coarse': {
                minHeight: 'controlH',
                minWidth: 'controlH'
            },
            text: '{{ ai.tool.runNow | polyglot }}',
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                try {
                    el.call('aiToolRunNow', s.id);
                } catch (_) {
                /* host without the workspace fn barrel — affordance no-ops */ }
            }
        },
        // Run / Skip — the authorization ask, inline on the row it concerns.
        // Buttons settle the transport's suspended Promise via
        // el.call('resolveAiToolApproval'); stopPropagation so answering never
        // also toggles the row. Guarded — in hosts without the workspace function
        // barrel (chrome-connect panel) the call is simply unavailable and the
        // buttons no-op instead of throwing into the click handler.
        Approve: {
            hide: (el, s)=>s.status !== 'approval',
            tag: 'button',
            type: 'button',
            text: '{{ ai.tool.run | polyglot }}',
            flexShrink: '0',
            padding: 'Y2 Z1',
            round: 'radiusControl',
            border: 'none',
            // Run is the row's primary action: the brand's solid ink (a primary
            // action is never a hue fill), with the theme's own hover, focus and
            // press steps in both themes. No fill, ink or hover is declared here:
            // a declared prop outvotes the `theme:` compound (smbls f6757537d).
            theme: 'primary',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'B defaultBezier background',
            // Each control answers a finger at the 44pt floor itself (touchRow: a
            // control among neighbours draws the floor, no pseudo to take a
            // neighbour's edge) — on a tablet these three sat under the row's slop
            // and never received a tap (BLD-5).
            '@coarse': {
                minHeight: 'controlH',
                minWidth: 'controlH'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                try {
                    el.call('resolveAiToolApproval', s.id, true);
                } catch (_) {}
            }
        },
        // AI-307 (tickets/ai.md) — "Approve all for this run": a 16-step run must
        // not mean 16 Run clicks, and Auto as the only alternative is too broad.
        // One click grants THE CURRENT TURN only — the transport keys the grant
        // to the live assistant id (approveAllAiToolsForTurn), so it expires with
        // the turn and never persists. The fn also approves this very card's
        // parked ask, so the click that grants the run unblocks it too. Guarded —
        // hosts without the workspace fn barrel no-op.
        ApproveAll: {
            hide: (el, s)=>s.status !== 'approval',
            tag: 'button',
            type: 'button',
            text: '{{ ai.tool.runAll | polyglot }}',
            flexShrink: '0',
            padding: 'Y2 Z1',
            round: 'radiusControl',
            border: 'none',
            background: 'transparent',
            color: 'caption',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'B defaultBezier background, color',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            ':active': {
                background: 'selected',
                color: 'title'
            },
            title: (el)=>el.call('polyglot', 'ai.tool.runAllTooltip'),
            '@coarse': {
                minHeight: 'controlH',
                minWidth: 'controlH'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                try {
                    el.call('approveAllAiToolsForTurn');
                } catch (_) {}
            }
        },
        Deny: {
            hide: (el, s)=>s.status !== 'approval',
            tag: 'button',
            type: 'button',
            text: '{{ ai.tool.skip | polyglot }}',
            flexShrink: '0',
            padding: 'Y2 Z1',
            round: 'radiusControl',
            border: 'none',
            background: 'transparent',
            color: 'caption',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            transition: 'B defaultBezier background',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            ':active': {
                background: 'selected',
                color: 'title'
            },
            '@coarse': {
                minHeight: 'controlH',
                minWidth: 'controlH'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                try {
                    el.call('resolveAiToolApproval', s.id, false);
                } catch (_) {}
            }
        },
        // Quiet outcome tag for a skipped step — same slot the duration uses.
        // A row says why it closed ONCE: a question its turn left (a stop, a
        // failed or ended turn) has a card under it that says why (ChatCard
        // PvWhy, `_closedBy`), so the row drops the tag — nobody pressed Skip. A
        // row with no such card (a step skipped on Run / Skip) keeps it. The
        // same rule keeps SupersededTag above: a card a new message closed
        // leaves the reason to its row. `_asks` is read first, so the factory
        // tracks it from the first run.
        SkippedTag: {
            hide: (el, s)=>{
                const asks = Array.isArray(s._asks) ? s._asks : [];
                return s.status !== 'denied' || asks.some((c)=>!!c && !!c._closedBy);
            },
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            opacity: '.6',
            flexShrink: '0',
            fontStyle: 'italic',
            text: '{{ ai.tool.skipped | polyglot }}'
        },
        Took: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            opacity: '.6',
            flexShrink: '0',
            text: (el, s)=>{
                if (!s.doneTs || !s.ts) return '';
                const secs = Math.max(0, s.doneTs - s.ts) / 1000;
                return secs >= 0.1 ? `${secs.toFixed(1)}s` : '';
            }
        },
        Icon_2: {
            name: 'arrow angle down',
            boxSize: 'Z',
            color: 'caption',
            opacity: '.6',
            flexShrink: '0',
            transition: 'B defaultBezier transform',
            isOpen: (el, s)=>!!(s.root && s.root._aiToolOpen && s.root._aiToolOpen[s.id]),
            '.isOpen': {
                transform: 'rotate(180deg)'
            }
        }
    },
    // WHY a step failed — the client tool's own reason (simoneAiTransport stamps
    // `failure` via toolFailure), or a server tool's refusal sentence. Keepz DEV
    // 2026-10-15: two refused render_answer_ui draws showed a bare ✗ and read as
    // an unexplained flake. Collapsed-row text, under the head; the red glyph
    // already says "failed", so the reason itself stays in the caption voice.
    // `hide`, not `if`: the line stays mounted, and a status flip only toggles
    // its `display`. (An `if:`-gated child would keep its place as well: smbls
    // inserts it at its declared place, not at the row's end; see PvStatus.)
    Failure: {
        hide: (el, s)=>s.status !== 'error' || !(typeof s.failure === 'string' && s.failure.trim() !== ''),
        tag: 'p',
        margin: '0',
        padding: 'X Z 0 B',
        fontSize: 'Z1',
        lineHeight: '1.4',
        color: 'caption',
        overflowWrap: 'anywhere',
        text: (el, s)=>typeof s.failure === 'string' ? s.failure : ''
    },
    // WHY an Undo did not work, in the active language: aiUndoCreated's `cause`
    // code → one of the ai.tool.undoWhy.* words (an unknown or missing code reads
    // the plain fallback). Never the raw error: wave 2 (dev 2026-10-28) showed an
    // English SDK message on a Georgian page. Visible until a retry works; the
    // Undo button reads "Try again" meanwhile.
    UndoFailure: {
        hideDeps: [
            '_aiUndoError'
        ],
        hide: (el, s)=>!(s.created && s.root && s.root._aiUndoError && s.root._aiUndoError[s.created.id]),
        tag: 'p',
        margin: '0',
        padding: 'X Z 0 B',
        fontSize: 'Z1',
        lineHeight: '1.4',
        color: 'caption',
        overflowWrap: 'anywhere',
        UndoSaid: {
            tag: 'span',
            text: '{{ ai.tool.undoFailed | polyglot }}'
        },
        UndoWhy: {
            tag: 'span',
            // read behind a conditional — declared so the factory re-fires (FA515)
            textDeps: [
                '_aiUndoError'
            ],
            text: (el, s)=>{
                const e = s.created && s.root && s.root._aiUndoError && s.root._aiUndoError[s.created.id];
                if (!e) return '';
                // cause code → key, inline (self-contained); literal keys only
                const keys = {
                    gone: 'ai.tool.undoWhy.gone',
                    denied: 'ai.tool.undoWhy.denied',
                    unavailable: 'ai.tool.undoWhy.unavailable',
                    network: 'ai.tool.undoWhy.network'
                };
                const cause = String(e.cause || '');
                const key = Object.prototype.hasOwnProperty.call(keys, cause) ? keys[cause] : 'ai.tool.undoWhy.failed';
                let said = '';
                try {
                    said = el.call('polyglot', key);
                } catch (_) {
                    said = '';
                }
                return typeof said === 'string' && said ? ` ${said}` : '';
            }
        }
    },
    // Reasoning note — the model's narration before this step (what it streamed
    // between the previous tool and this one), snapped out of the answer bubble
    // by the transport. Always visible under the row header (not gated behind
    // the expand), quiet, italic — the "why" for the step.
    // Only on a step that RUNS (F3, dev 2026-10-29 W12c): those words are written
    // before the call, and a delete_ticket row read "I've deleted the task …"
    // while it waited for Run / Skip and after Skip. A step that waits, was
    // skipped or was closed by a new message shows its label alone; the note
    // comes in with Run, in the same change that takes Run / Skip away. A step
    // that never ran (`notRun`: its approval ran out, or its turn failed while
    // it waited) is a failed row with "did not run" under it, and no note.
    Note: {
        // Rule 66: the note is the model's words, not chrome. It comes in with
        // the person's own Run (the same change takes Run / Skip away) and leaves
        // when the answer takes its words (the transport clears the last step's
        // note). A kept box would leave a blank band under every step that shows
        // no note: one that waits, was skipped or closed, or has no note at all.
        // frank-allow FA813: the model's words come and go with the step's own change
        if: (el, s)=>!!s.note && !s.notRun && ![
                'approval',
                'denied',
                'superseded'
            ].includes(s.status),
        tag: 'p',
        margin: '0',
        padding: 'X Z Y2 B',
        fontSize: 'Z1',
        lineHeight: '1.4',
        fontStyle: 'italic',
        color: 'caption',
        whiteSpace: 'pre-wrap',
        text: (el, s)=>s.note
    },
    // AI-CREATED WIDGET PREVIEW (tickets/opus.md "Per-workspace AI-CREATED
    // widgets"): a pending create_widget/update_widget renders the widget ITSELF
    // above Run / Skip — approving something you can SEE is a materially better
    // consent surface than approving a JSON diff, and the rendering primitive
    // already exists (the same WidgetRenderer that will draw it on the board, so
    // the preview cannot drift from the real thing).
    //
    // ADDITIVE + GATED: `if:` is false for every other tool and for every phase
    // that is not `approval`, so no existing row in any consumer changes shape.
    // `WidgetRenderer` is a workspace-shell component; in a host that does not
    // register it the bare key simply mounts nothing (the preview is absent, the
    // Run / Skip row is unaffected) — this row deliberately carries no import.
    // Values render as placeholders: a pending widget has no id yet, so the
    // renderer's own fetch guard no-ops and the preview shows STRUCTURE, which is
    // exactly what is being approved.
    WidgetPreview: {
        // Rule 66: the widget being approved, not chrome. It shows only while a
        // widget step waits on Run / Skip, and leaves with the same change that
        // takes Run / Skip away. A kept box would put a WidgetRenderer in every
        // tool row (four more elements, its state factory, two capability gates
        // of two el.call each, an onRender / onUpdate pair that calls
        // loadAiWidgetData) and a blank plate under each one.
        // frank-allow FA813: the widget being approved, only while its step waits on Run / Skip
        if: (el, s)=>{
            if (s.status !== 'approval') return false;
            const tool = String(s.tool || '');
            if (!/widget/i.test(tool)) return false;
            const a = s.args;
            const bag = Array.isArray(a) ? a[a.length - 1] : a && a.widget ? a.widget : a;
            return !!(bag && bag.body && Array.isArray(bag.body.blocks) && bag.body.blocks.length);
        },
        flow: 'y',
        gap: 'Y',
        margin: '0 Z Y B',
        padding: 'Z',
        // Preview plate — same radius family as a card/tile (`radiusCard`), not
        // the retired spacing-letter radius (see the Head button's `round`
        // comment above for why `Z` is not "small A" here).
        round: 'radiusCard',
        background: 'overlay',
        Caption: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: '{{ ai.tool.widgetHint | polyglot }}'
        },
        WidgetRenderer: {
            state: (el, s)=>{
                const a = s.args;
                const bag = Array.isArray(a) ? a[a.length - 1] : a && a.widget ? a.widget : a;
                const def = bag || {};
                return {
                    // Deliberately id-LESS: `loadAiWidgetData` returns early without an
                    // id, so an unapproved widget never issues a data read. The preview
                    // is the STRUCTURE that is being approved — blocks, labels, layout —
                    // with placeholder values.
                    id: null,
                    title: def.title || 'Widget',
                    icon: def.icon || 'star',
                    hue: def.hue || null,
                    body: def.body || {
                        blocks: []
                    },
                    dataRecipe: def.dataRecipe || null,
                    // The preview draws structure only — it never resolves the recipe
                    // (no id → the renderer's fetch guard returns early), so this stamp
                    // cannot be a way to see data. The REAL capability check happens
                    // server-side on create and on every read.
                    viewerCapability: {
                        allowed: true,
                        reason: null
                    }
                };
            }
        }
    },
    Detail: {
        // read behind a conditional — declared so the factory re-fires (FA515;
        // see Head.OpenCreated)
        hideDeps: [
            '_aiToolOpen'
        ],
        hide: (el, s)=>!(s.root && s.root._aiToolOpen && s.root._aiToolOpen[s.id]),
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        padding: 'X Z Y B',
        // The call's ARGUMENTS as label / value rows, never raw JSON (live on dev
        // 2026-10-02: `"params": "<object:who,range>"` in a terminal). A name in
        // the person's words, in the active language (`ai.toolArg.*`; a name the
        // vocabulary does not hold reads humanized: "viewId" → "View id"); a text
        // as written; the server's previews (`<object:k1,k2>`, `<array:N>`) and a
        // real nested value readable — the keys as a list, an array as its count.
        // Flat, borderless: the overlay plate the terminal header uses.
        // A list with no row to show (every value empty, or an id) has no block.
        ToolArgs: {
            // Rule 66: the call's arguments, not chrome, inside the details the
            // person opened. The block changes only when the arguments do (they
            // normally come with the call's first frame); a kept box would show an
            // empty Input block.
            // frank-allow FA813: the details' own content, set by the call's arguments
            if: (el, s)=>{
                const a = s.args && typeof s.args === 'object' ? s.args : null;
                if (!a) return false;
                // The rows' own rule (ToolArgsList below): a row needs a value, and
                // a database id or a uuid is no value a person reads.
                const isId = (str)=>/^[0-9a-f]{24}$/i.test(str) || /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(str);
                return Object.keys(a).some((k)=>{
                    const v = a[k];
                    if (v == null) return false;
                    if (Array.isArray(v)) return true;
                    if (typeof v === 'object') return Object.keys(v).length > 0;
                    const str = String(v).trim();
                    const obj = /^<object:(.*)>$/.exec(str);
                    if (obj) return obj[1].split(',').some(Boolean);
                    return str !== '' && !isId(str);
                });
            },
            flow: 'y',
            width: '100%',
            minWidth: '0',
            round: 'radiusControl',
            overflow: 'hidden',
            background: 'overlay',
            ToolArgsLabel: {
                padding: 'Y2 Z',
                color: 'caption',
                fontSize: 'Z2',
                fontWeight: '700',
                text: (el)=>el.call('polyglot', 'ai.tool.input')
            },
            ToolArgsList: {
                tag: 'dl',
                margin: '0',
                padding: '0 Z Z',
                flow: 'y',
                gap: 'Y',
                minWidth: '0',
                children: (el, s)=>{
                    const args = s && s.args && typeof s.args === 'object' ? s.args : {};
                    const tool = s && s.tool;
                    // THE ARGUMENT NAMES IN WORDS (dev 2026-10-30: a Georgian session's
                    // step read "Ticket" — the tool's own key, in English): each name
                    // in the person's words, in the active language — the row's one
                    // map (scope.toolArgName), the one the collapsed hint reads too.
                    // Never an id: rows show human labels, never a database id or a
                    // uuid (the collapsed Hint keeps the same rule).
                    const isId = (str)=>/^[0-9a-f]{24}$/i.test(str) || /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(str);
                    const items = (n)=>String(el.call('polyglot', 'ai.tool.items')).replace('{count}', String(n));
                    const value = (v)=>{
                        if (v == null) return '';
                        if (Array.isArray(v)) return items(v.length);
                        if (typeof v === 'object') return Object.keys(v).join(', ');
                        const str = String(v);
                        if (isId(str.trim())) return '';
                        const obj = /^<object:(.*)>$/.exec(str);
                        if (obj) return obj[1].split(',').filter(Boolean).join(', ');
                        const arr = /^<array:(\d+)>$/.exec(str);
                        if (arr) return items(arr[1]);
                        return str.length > 200 ? str.slice(0, 200) + "\u2026" : str;
                    };
                    // An argument with no value (or only an id) has no row; the name is
                    // the quiet line (caption ink, a step below) over its value (title
                    // ink).
                    return Object.keys(args).map((k)=>[
                            k,
                            value(args[k])
                        ]).filter(([, v])=>String(v).trim() !== '').map(([k, v], i)=>({
                            key: 'arg' + i,
                            flow: 'y',
                            gap: 'X',
                            minWidth: '0',
                            ToolArgName: {
                                tag: 'dt',
                                color: 'caption',
                                fontSize: 'Y2',
                                text: el.scope.toolArgName(el, k, tool)
                            },
                            ToolArgValue: {
                                tag: 'dd',
                                margin: '0',
                                color: 'title',
                                fontSize: 'Z',
                                overflowWrap: 'anywhere',
                                text: v
                            }
                        }));
                }
            }
        },
        ToolTerminal_1: {
            // Rule 66: the step's result, not chrome. It comes when the step ends,
            // as the last block of the details the person opened; its height is not
            // known before, so no box can be kept for it (a kept box would show an
            // empty terminal).
            // frank-allow FA813: the result comes with the step's end, last in the details
            if: (el, s)=>!!s.summary,
            label: 'ai.tool.result',
            value: (el, s)=>s.summary || ''
        }
    }
};
const $f11380488d2f54f0$export$b49b012922d10877 = {
    tag: 'span',
    minWidth: '0',
    overflowWrap: 'anywhere',
    text: $f11380488d2f54f0$export$a9cfa4e7ab21c288.Head.Label.text,
    title: $f11380488d2f54f0$export$a9cfa4e7ab21c288.Head.Label.text,
    isOneLine: (el)=>!!el.oneLine,
    '.isOneLine': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
};

});

parcelRegister("8JqaR", function(module, exports) {

$parcel$export(module.exports, "ChatToolStep", () => $65b6d453191fe8b5$export$45255532890a76a7);
// ChatToolStep — one step of the assistant's live timeline
// (ChatMessage.Activity): the step's own row (ChatToolRow) and, under it, the
// question that step asked.
//
// THE QUESTION SITS UNDER THE STEP THAT ASKED (Nika 2026-10-28: "fix
// positioning"). A question card (ask_user / confirm_with_user, ChatCard
// PvCardChoice) carries the call id of its step (`_callId`: the transport's
// _askOnCard live, sessions.js _askCardFromHistory on a reload), and
// ChatMessage.Activity hands each step the cards that name it (`_asks`). The
// card was drawn in ChatMessage.Cards: after the answer bubble, 35–37px under
// its step while the turn waited, with the reply's text pushed between the
// two once it came, and the two cards of a turn that asked twice both under
// its last step (the first 182px from its own) — measured on dev 2026-10-28.
//
// On the answer's text edge: the timeline's inset (Activity `Y`) plus this
// slot's `Z` is the answer block's `A` — the edge the step's status glyph and
// the answer text share.
const $65b6d453191fe8b5$export$45255532890a76a7 = {
    extends: 'ChatToolRow',
    StepAsks: {
        hide: (el, s)=>!(Array.isArray(s._asks) && s._asks.length),
        flow: 'y',
        gap: 'Z',
        width: '100%',
        minWidth: '0',
        padding: 'X 0 Y Z',
        childExtends: 'ChatCard',
        childrenAs: 'state',
        children: (el, s)=>Array.isArray(s._asks) ? s._asks : []
    }
};

});

parcelRegister("k4ef8", function(module, exports) {

$parcel$export(module.exports, "SimoneReasoningPill", () => $03c5261be9202f06$export$5782bea47b61fa4);

var $4SiPM = parcelRequire("4SiPM");
const $03c5261be9202f06$export$5782bea47b61fa4 = {
    // FA204 / frank trap — liveMsg/runningTool/agents/runningAgents/isLive/
    // voiceCase/headLabel/voiceRowCount/threadMsgs/routePath used to be bare
    // module-scope const read from inside `hide`, `isChatPreview`, `isVoice`,
    // `onFrame` and the head/thread/activity factories (all serialized) — they
    // read as undefined once this component is frank.toJSON'd for platform
    // delivery. Moved into `scope`, called via
    // `el.scope.<name>` from factories and `this.<name>` between sibling scope
    // methods (object-literal properties can't see each other as bare
    // identifiers). `_routePath` is also HALF of the cross-file collision that
    // was blocking `smbls push` — Suggestions.js declared its own bare
    // module-scope `_routePath`, and esbuild's dedup-rename
    // (`_routePath`/`_routePath2`) made frank's verifier refuse the whole
    // publish. Scoping both resolves the collision (scope keys are per-
    // component, never bundled by name). The 2026-10-28 additions (approvalTool,
    // choiceCard, askWaits, stepTool, island, answerId, canMoveToMain,
    // answerDismiss, answerMove, statusText) follow the same law.
    scope: {
        // The live general assistant message (or null). Scans from the END — the
        // live message is the just-appended tail, and the transport re-sets
        // chatMessages on every delta, so a front `.find()` was an
        // O(thread-length) scan per tick across all the pill's factories.
        liveMsg (root) {
            if (!root || !root.currentAssistantId) return null;
            const msgs = root.chatMessages || [];
            for(let i = msgs.length - 1; i >= 0; i--){
                if (msgs[i] && msgs[i].id === root.currentAssistantId) return msgs[i];
            }
            return null;
        },
        // The last running tool of the live message (the current step), or null.
        runningTool (root) {
            const msg = this.liveMsg(root);
            if (!msg) return null;
            const running = (msg.tools || []).filter((t)=>t && t.status === 'running');
            return running.length ? running[running.length - 1] : null;
        },
        // The step that waits for the person's OK, or null — the newest tool row
        // in the `approval` status among the assistant messages after the
        // person's last line. Read from the thread, not from the live id: a late
        // ask is anchored to the newest assistant message after the turn's id
        // cleared (simoneAiTransport._patchToolActivity), and it still holds the
        // server's loop. Mirrors AiAsk.scope.approvalTool, which renders the ask
        // itself.
        approvalTool (root) {
            const msgs = root && Array.isArray(root.chatMessages) ? root.chatMessages : [];
            for(let i = msgs.length - 1; i >= 0; i--){
                const m = msgs[i];
                if (!m) continue;
                if (m.role === 'user') return null;
                const tools = m.role === 'assistant' && Array.isArray(m.tools) ? m.tools : [];
                for(let j = tools.length - 1; j >= 0; j--){
                    if (tools[j] && tools[j].status === 'approval') return tools[j];
                }
            }
            return null;
        },
        // The question that waits for the person's pick, or null — an ask_user
        // card (simoneAiTransport askUser: a confirm or a choice) nobody answered,
        // on an assistant message after the person's last line (a new line
        // closes it). The transport turns the typing off while it waits, so the
        // turn reads as done. Mirrors AiAsk.scope.choiceCard, which renders the
        // question itself.
        choiceCard (root) {
            const msgs = root && Array.isArray(root.chatMessages) ? root.chatMessages : [];
            for(let i = msgs.length - 1; i >= 0; i--){
                const m = msgs[i];
                if (!m) continue;
                if (m.role === 'user') return null;
                const cards = m.role === 'assistant' && Array.isArray(m.cards) ? m.cards : [];
                for(let j = cards.length - 1; j >= 0; j--){
                    const c = cards[j];
                    const asks = !!c && (c.type === 'choice' || c.type === 'confirm');
                    if (asks && c._cardId && !c._resolved) return c;
                }
            }
            return null;
        },
        // An ask waits on the person: a step for the OK, or a question for a pick.
        askWaits (root) {
            const tool = this.approvalTool(root);
            const card = this.choiceCard(root);
            return !!(tool || card);
        },
        // The step the head names after "Working:" — the running tool, unless the
        // delegated agents are the step or an ask waits (a question's own row
        // runs while it waits).
        stepTool (root) {
            if (this.askWaits(root) || this.runningAgents(root) > 0) return null;
            return this.runningTool(root);
        },
        // The delegated/chained sub-agents of the current turn (general scope).
        agents (root) {
            return root && root.activeProcesses || [];
        },
        runningAgents (root) {
            return this.agents(root).filter((p)=>p && p.status === 'running').length;
        },
        // Live = the main turn is streaming OR at least one sub-agent is still running.
        isLive (root) {
            return !!(root && (root.chatTyping || this.runningAgents(root) > 0));
        },
        // Voice island case — the minimized voice session owns the body. `voiceHost`
        // (a composer strip is hosting, T18) hands the surface to the composer.
        voiceCase (root) {
            return !!(root && root.voiceOpen && root.voiceMinimized && !root.voiceHost);
        },
        // Head label: an ask that waits outranks everything (the turn is stopped
        // on the person) — "Needs your OK" for a step, "Waiting for your choice"
        // for a question (the ask_user row's words) — then the agent count while
        // delegating, else Working (a tool is running) vs Thinking (pure
        // reasoning) — same rule and same words as ChatMessage.Dots.
        headLabel (root, el) {
            root?.lang;
            if (this.approvalTool(root)) return el.call('polyglot', 'ai.chat.needsOk');
            if (this.choiceCard(root)) return el.call('polyglot', 'ai.toolStep.choose');
            const running = this.runningAgents(root);
            if (running) {
                const label = running === 1 ? el.call('polyglot', 'ai.pill.agentWorking') : el.call('polyglot', 'ai.pill.agentsWorking');
                return label.replace('{count}', String(running));
            }
            return this.runningTool(root) ? el.call('polyglot', 'ai.chat.working') : el.call('polyglot', 'ai.chat.thinking');
        },
        // Does the voice thread have anything in it? Mirrors VoiceLog's own source
        // precedence (voiceTurns, then the assistant thread) — a COUNT only; the
        // rendering lives in the shared component. Drives the island's width so
        // the gauge follows content instead of being pinned wide around an empty
        // log.
        voiceRowCount (root) {
            const live = root && root.voiceTurns || [];
            if (live.length) return live.filter((t)=>t && String(t.text || '').trim()).length;
            const msgs = root && root[(root.voiceChatKey || '') + 'chatMessages'] || [];
            return msgs.filter((m)=>m && (m.role === 'user' || m.role === 'assistant') && String(m.text || '').trim()).length;
        },
        // The island's THREAD rows — the assistant conversation as a running log,
        // normalised into the shared VoiceLog row shape. This replaces the old
        // two-message RecentChat preview that was hidden the moment anything
        // started streaming: the conversation used to VANISH and be swapped for a
        // status line, then come back, which is the churn Nika reported
        // (2026-08-02, "ai assistant text islands in the background should be
        // consistant, logging in one small minimized thread so you can keep
        // track. do not show hide different ui"). Now it simply keeps growing —
        // the live reply is already in chatMessages with its text extending per
        // delta, so it streams in place inside the thread.
        //
        // 2026-10-28: the rows ride the bubbles ABOVE the bar now (AiBubbleStack,
        // which shows the newest two and fades the one before), so three are
        // enough. A streaming reply keeps its NEWEST words when it is cut — the
        // bubble shows the tail of a reply while it streams.
        threadMsgs (root) {
            const msgs = root && root.chatMessages || [];
            const out = [];
            for(let i = msgs.length - 1; i >= 0 && out.length < 3; i--){
                const m = msgs[i];
                if (!m || m.role !== 'user' && m.role !== 'assistant') continue;
                const t = typeof m.text === 'string' ? m.text.trim() : '';
                if (!t) continue;
                const streaming = !!m.streaming;
                out.unshift({
                    id: m.id || 'm' + i,
                    role: m.role === 'user' ? 'user' : 'agent',
                    text: t.length <= 420 ? t : streaming ? "\u2026" + t.slice(-420) : t.slice(0, 420) + "\u2026",
                    streaming: streaming
                });
            }
            return out;
        },
        // ——— the answer that landed while the island is the thread's handle ———
        // The island element: the answer baseline lives on it (onInit), and a
        // child's factory reaches it through the element tree.
        island (el) {
            if (!el) return null;
            if (el.__aiIsland) return el;
            return typeof el.lookup === 'function' ? el.lookup((p)=>!!(p && p.__aiIsland)) : null;
        },
        // The answer the head offers ("Answer ready"), or null. The shell owns the
        // rule (workspace functions/assistantAnswerPopover.js): an answer that
        // landed after the island mounted, while the island is the handle, not
        // dismissed. A host without it (the standalone canvas) has no answer
        // state.
        answerId (el, root) {
            const fns = el && el.context && el.context.functions;
            if (!fns || typeof fns.assistantAnswerPopoverFor !== 'function') return null;
            const isl = this.island(el);
            return el.call('assistantAnswerPopoverFor', root, isl ? isl.__answerBaseline : undefined) || null;
        },
        canMoveToMain (el, root) {
            const fns = el && el.context && el.context.functions;
            if (!fns || typeof fns.assistantThreadCanMoveToMain !== 'function') return false;
            return !!el.call('assistantThreadCanMoveToMain', root);
        },
        answerDismiss (el) {
            const fns = el && el.context && el.context.functions;
            if (fns && typeof fns.assistantAnswerPopoverDismiss === 'function') el.call('assistantAnswerPopoverDismiss');
        },
        // Open in main / Open in sidebar — the shell's two moves (each dismisses
        // the answer). The slot handle retires with either: the thread has a real
        // surface now, so the island must not come back when it closes.
        answerMove (el, s, where) {
            const root = s && s.root;
            if (!root || typeof root.update !== 'function') return;
            const fns = el.context && el.context.functions || {};
            const name = where === 'main' ? 'assistantAnswerToMain' : 'assistantAnswerToSidebar';
            if (typeof fns[name] === 'function') el.call(name);
            if (root._assistantPillHandle) root.update({
                _assistantPillHandle: false
            });
        },
        // The head's status words: the ask, the live turn, the landed answer, or
        // the idle handle's name. A live turn names its running step after a
        // colon (the step itself is the HeadStep span beside these words). A
        // question that waits is never "Answer ready": its turn is not done.
        statusText (el, root) {
            if (this.askWaits(root)) return this.headLabel(root, el);
            if (this.isLive(root)) return this.headLabel(root, el) + (this.stepTool(root) ? ':' : "\u2026");
            if (this.answerId(el, root)) return el.call('polyglot', 'ai.pill.answerReady');
            return el.call('polyglot', 'ai.pill.idle');
        },
        // Route WITHOUT the multi-workspace-tabs `/w/<slug>` prefix — the hide's
        // route list compares bare app routes, and on a prefixed tab
        // (`/w/acme/add-app`) the raw path never matches. Inline mirror of
        // workspacePrefix.js stripWorkspacePrefix.
        routePath (root) {
            const p = root && root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
            const stripped = String(p).replace(/^\/w\/[a-z0-9-]{1,48}(?=\/|$)/, '');
            return stripped === '' ? '/' : stripped;
        }
    },
    // Show when something needs the small surface. Voice case first — it bypasses
    // the aiAssistant flag and the route hides (see header). Assistant cases keep
    // the original logic verbatim: the FULL drawer isn't visible AND there's
    // either live activity, the persistent minimized handle, or the slot handle —
    // or, since 2026-10-28, a step that waits for the person's OK.
    // The keys the gate reads only behind a branch are declared, so every run
    // subscribes to them whichever branch returns first (FA515).
    hideDeps: [
        (el, s)=>s.root && s.root.voiceHost,
        (el, s)=>s.root && s.root.voiceMinimized,
        (el, s)=>s.root && s.root.meetView,
        (el, s)=>s.root && s.root.assistantDock,
        (el, s)=>s.root && s.root._assistantPillHandle
    ],
    hide: (el, s)=>{
        const r = s.root;
        if (!r) return true;
        if (el.scope.voiceCase(r)) return false;
        // Voice in the FOREGROUND elsewhere — the full overlay or a composer strip
        // (`voiceHost` alone keeps the strip visible: it ignores the minimized
        // axis) — every assistant case yields. The strip already streams the same
        // thread this pill would preview (command turns mirror into voiceTurns),
        // so a live pill or the minimized-drawer handle beside it is the same
        // conversation on screen twice (2026-08-06 per Nika "when voice is open,
        // no point to have chat - they are morphing into each other"). Restores
        // itself the moment voice minimizes (the voice case above takes the
        // island) or closes (normal assistant logic resumes).
        if (r.voiceOpen && (r.voiceHost || !r.voiceMinimized)) return true;
        // /flags gate: assistant off removes the pill everywhere.
        if (!(0, $4SiPM.featureEnabled)(r, 'aiAssistant')) return true;
        // On routes where the global composer is hidden — they own their bottom UI
        // (/chat, /add-app) or the pill would overlap call controls (an active /meet
        // call, /meet-guest) — the pill, which anchors just above that composer, must
        // hide too; otherwise it floats over the page's own bottom UI at a stale
        // --slot-bottom (the composer's ResizeObserver freezes while it's hidden).
        // Mirrors CanvasPromptTextarea.hide's route list; reading currentPath also
        // makes the pill re-evaluate on a pure route change (it reads no other route
        // signal). Routes absent on the standalone extension simply never match.
        const path = el.scope.routePath(r);
        if (path === '/add-app' || path === '/chat' || path === '/meet-guest') return true;
        if (path === '/meet' && r.meetView === 'call') return true;
        if (r.assistantOpen && r.assistantDock !== 'minimized') return true;
        if (r._homeThreadOpen) return true;
        const minimizedHandle = r.assistantOpen && r.assistantDock === 'minimized';
        // Third handle case: the shell DELIBERATELY kept the drawer closed for this
        // turn because a page sheet is open in the PageSlot and the drawer would
        // cover it (homeAiSend sets _assistantPillHandle). The pill is then the
        // turn's ONLY surface, so it must outlive the turn exactly like the
        // minimized handle does — otherwise the send looks silently dropped: the
        // composer clears, the pill shows while streaming, and then everything
        // (message + answer) disappears with no thread entry and no error.
        const slotHandle = !r.assistantOpen && !!r._assistantPillHandle;
        // An ask waits on the person — a step for the OK, a question for a pick —
        // and the thread is off screen (the two checks above): the island is the
        // ask's only surface, so it shows even with no handle and no live turn —
        // the transport stops "typing" while an ask waits (simoneAiTransport
        // onWaiting, askUser), which used to hide it.
        if (el.scope.askWaits(r)) return false;
        return !el.scope.isLive(r) && !minimizedHandle && !slotHandle;
    },
    // Thread footprint — whenever the thread has anything in it, idle handle OR
    // mid-turn, the island matches the global composer it docks above: the same
    // `H` width token as CanvasPromptTextarea (and the same full-width @mobileL
    // treatment), so it reads as part of the composer stack. Pinning the gauge
    // across BOTH states is what stops the island resizing every time a turn
    // starts and ends — `width: max-content` around a growing reply would jump
    // the footprint on every delta, which reads as a different panel rather than
    // the same one filling up. A conditional class, NOT a reactive `width`
    // factory — reactive layout props don't re-apply on a state change in v3.14
    // (same mechanism as the composer's `.isLarge`).
    // Width follows the THREAD, in either mode. Measured on the deployed build
    // the voice posture was pinned at 494px with the log hidden and two of seven
    // controls hidden — half the island was empty space, which is why it read as
    // a panel rather than a compact handle. Now it is content-sized until there
    // is actually a transcript to hold, then it takes the composer gauge.
    // An ask that waits takes the gauge too: its bubble spans the bar's width.
    isChatPreview: (el, s)=>el.scope.voiceCase(s.root) ? el.scope.voiceRowCount(s.root) > 0 : el.scope.threadMsgs(s.root).length > 0 || el.scope.askWaits(s.root),
    '.isChatPreview': {
        width: 'H',
        '@mobileL': {
            left: 'A',
            right: 'A',
            width: 'auto',
            maxWidth: 'calc(100dvw - var(--spacing-B))',
            transform: 'none'
        }
    },
    // THE COMPOSER'S GAUGE — whenever the island docks above the composer as one
    // stack (the call bar, or a thread preview), the shell sizes it to the
    // composer's LIVE width: workspace app.js publishes the resting pill's width
    // as --prompt-w and its injected stylesheet reads this attribute (wider than
    // a phone; a phone keeps the island's own left/right inset). The pill grows
    // past `H` with its context chip, so an `H` island sat 10px in on each side.
    // A data attribute, not the class blocks below: those are hashed and paint
    // their width inline, so only a shell rule keyed on a stable attribute can
    // override it.
    data: {
        gauge: (el, s)=>el.scope.voiceCase(s.root) || el.scope.threadMsgs(s.root).length > 0 || el.scope.askWaits(s.root) ? 'composer' : null
    },
    // Voice posture — THE CALL BAR (2026-10-22, the call redesign): the call's
    // row (orb · status and clock · controls) at the composer's own `H` gauge
    // from the first frame, so the bar never jumps wide when the first line
    // lands (the controls now share the head row, so the bar is never a wide,
    // mostly empty card either). Equal padding on every side; no pointer
    // affordance on the shell itself (the controls are the hit targets).
    isVoice: (el, s)=>el.scope.voiceCase(s.root),
    '.isVoice': {
        width: 'H',
        cursor: 'default',
        gap: 'Z',
        padding: 'Z',
        '@mobileL': {
            left: 'A',
            right: 'A',
            width: 'auto',
            maxWidth: 'calc(100dvw - var(--spacing-B))',
            transform: 'none'
        }
    },
    position: 'fixed',
    // Above the PageSlot (z 1300) so the small view stays visible when a page sheet
    // is open; below modals. This also holds for the voice case — the island stays
    // at 1350 (NOT the overlay's 10600): minimized voice is ambient, it must not
    // outrank dialogs. The BOTTOM offset is set in app.js's injected shell CSS
    // (`[data-key="SimoneReasoningPill"]{bottom:var(--slot-bottom)}`) — a raw
    // `var(--…)` on `bottom` compiles to an EMPTY DOMQL atomic rule (see
    // calc-width-empty-atomic-rule), so shell-var positioning MUST go through the
    // stylesheet, exactly like the PageSlot's own --slot-bottom. --slot-bottom =
    // --prompt-clear (composer clearance, live via RO) + --nav-gap, so the pill's
    // bottom edge sits the same nav-gap above the composer as the PageSlot's does.
    // (The standalone canvas mount sets `bottom: 'D'` at the mount site instead.)
    zIndex: '1350',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'max-content',
    maxWidth: '92vw',
    flow: 'y',
    gap: 'Z',
    padding: 'Z Z1',
    theme: 'canvas-card-glass',
    // Same surface treatment as the EXPANDED composer (2026-08-02 per Nika
    // "voice ui should be similar to expanded chattextarea ui — no border,
    // similar rounds"): the island is the assistant/voice surface changing
    // posture, not a foreign card stacked on the page. The border is zeroed and
    // elevation comes from the theme, exactly as CanvasPromptTextarea does it.
    //
    // The RADIUS deliberately does NOT copy the composer's token (2026-08-02 per
    // Nika "round is too big for voice island"). Matching `round: 'B'` literally
    // was the first attempt and it looked wrong, because a corner radius is
    // absolute while these two boxes differ ~3x in height. With the brand
    // spacing scale (base 17, ratio 1.618) B is ~27.5 and A is ~17: on the
    // expanded composer — `width: 'H'`, many lines tall — 27.5 is a modest card
    // corner, but on this island (one control row inside `padding: 'Z Z1'`,
    // ~48 tall) 27.5 exceeds half the height, so it collapses into a full
    // capsule and reads as a different species of surface. `A` keeps a soft
    // card corner at BOTH island heights — the compact idle handle and the
    // taller transcript posture — which is what "match the composer" means
    // perceptually. Note this is NOT the em-basis trap (Rule 34): both mount as
    // siblings at the app root (workspace/app.js SimoneReasoningPill + Canvas-
    // PromptTextarea) with no fontSize of their own, so the token resolves to
    // identical pixels on each — the difference is purely box geometry.
    round: 'A',
    // canvas-card-glass paints a 1px border via the brand theme; this chrome
    // reads cleaner without it. Longhand `borderWidth: 0` — the theme's
    // longhand `borderWidth: 1px` lands after a shorthand when DOMQL composes
    // the cascade, so `border: none` is a no-op (the trap the composer and the
    // mode tabs both document).
    borderWidth: '0',
    // No explicit boxShadow: the theme already carries the elevation pair
    // (inset sheen + `0 4px 32px`), which is the exact elevation the expanded
    // composer floats on. The previous hard-coded rgba both double-darkened
    // this surface relative to the composer and violated tokens-only.
    cursor: 'pointer',
    textAlign: 'left',
    // Morph discipline: opacity + padding tween between postures (both inert —
    // nothing drives them per-frame); `bottom` must stay OUT of the list (driven
    // by the live --prompt-clear var — `all` made it never settle), and width
    // swaps max-content↔H which no transition can tween — the posture keyframes
    // on the body groups carry that swap visually instead.
    transition: 'B opacity defaultBezier, B padding defaultBezier',
    // The call chrome's 60 fps half — the orb's ring and the clock — runs off
    // the shared driver (functions/voiceSession.js voiceCallFrame), only while
    // the island IS the call (it reads the analyser off the VoiceOverlay, the
    // session host, and caches its refs on this element).
    onFrame: (el, s)=>{
        const root = s && s.root || s;
        // FA210: the frame loop can tick before this element's scope exists
        // (early frames / bypass mounts).
        if (!root || !el.scope || !el.scope.voiceCase(root)) return;
        el.call('voiceCallFrame');
    },
    // ——— the landed answer (the retired AssistantAnswerPopover's rules) ———
    // The newest answer at mount is the BASELINE: a restored thread never says
    // "Answer ready", only an answer that lands after. Kept on the element
    // (children reach it through scope.island). Guarded: the standalone canvas
    // has no answer state.
    onInit: (el, s)=>{
        el.__aiIsland = true;
        const fns = el.context && el.context.functions;
        if (fns && typeof fns.assistantLatestAnswerId === 'function') el.__answerBaseline = el.call('assistantLatestAnswerId', s && s.root);
    },
    // Esc dismisses it — a row of the shell keyboard registry, live only while
    // the answer shows.
    onMounted: (el)=>{
        const fns = el.context && el.context.functions;
        if (fns && typeof fns.assistantAnswerPopoverShortcuts === 'function') el.call('assistantAnswerPopoverShortcuts', el);
    },
    onBeforeRemove: (el)=>{
        if (typeof el.__popoverShortcutsOff === 'function') el.__popoverShortcutsOff();
    },
    // A press outside the island dismisses it (a read-only listener).
    onDocumentPointerdown: (e, el, s)=>{
        if (!el.scope || typeof el.scope.answerId !== 'function') return;
        if (!el.scope.answerId(el, s && s.root)) return;
        const node = el.node;
        if (node && e && e.target && typeof node.contains === 'function' && node.contains(e.target)) return;
        el.scope.answerDismiss(el);
    },
    // ——— assistant cases' whole-surface affordance ———
    // Full-area button (valid: the root is a div) shown only while an assistant
    // case owns the island. Native focus/keyboard for free; the voice case hides
    // it so the voice controls receive their own clicks.
    ExpandHit: {
        tag: 'button',
        type: 'button',
        display: null,
        show: (el, s)=>!el.scope.voiceCase(s.root),
        position: 'absolute',
        inset: '0',
        zIndex: '1',
        background: 'transparent',
        borderWidth: '0',
        padding: '0',
        cursor: 'pointer',
        title: (el)=>el.call('polyglot', 'ai.pill.open'),
        aria: {
            label: (el)=>el.call('polyglot', 'ai.pill.open')
        },
        // Tapping the pill expands back to the full drawer. If the assistant was
        // minimized, restore it to a visible dock (right) so the drawer actually
        // shows; otherwise just open at the current dock.
        onClick: (e, el, s)=>{
            // Expanding retires the slot handle — the drawer itself now carries the
            // thread, so the pill must not re-appear if the user later closes it.
            // Written only when the flag is actually set: hosts that don't declare it
            // (preview / standalone) must not take an undeclared-root-key write.
            const patch = {
                assistantOpen: true
            };
            if (s.root._assistantPillHandle) patch._assistantPillHandle = false;
            if (s.root.assistantDock === 'minimized') patch.assistantDock = 'right';
            s.root.update(patch);
            // The drawer shows the answer now: "Answer ready" is read.
            el.scope.answerDismiss(el);
        }
    },
    // THE CONSTANT CHROME. One head row for every state the island can be in —
    // idle handle, live turn, an ask, a landed answer, and voice. It is never
    // hidden and never swapped; only its leading indicator, its words and its
    // trailing buttons change. There used to be TWO heads (this one plus a
    // separate VoiceHead) that hid each other, so entering voice read as one
    // panel being replaced by another instead of the same object transforming
    // (2026-08-02 per Nika "in terms of voice and text, island should be
    // transforming").
    //
    // AT THE CONTROL HEIGHT, ALWAYS (2026-10-28): the row is `controlHCompact`
    // tall whether or not a 36px button is on show in it, so the bar is the
    // same height idle, live, asking, answered and in a call.
    Head: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        width: '100%',
        minWidth: '0',
        minHeight: 'controlHCompact',
        Lead: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Y',
            minWidth: '0',
            flex: '1 1 auto',
            // Star and orb are the two faces of the same slot — one leaves as the
            // other arrives, so the row's geometry never changes.
            // Plain `fadeIn`, not the `fadeInUpShort` the old swapped-in voice blocks
            // used: these two occupy the SAME slot, so a rise would read as arriving
            // from elsewhere. Cross-fading in place is what makes it one indicator
            // changing rather than two indicators trading places. 150ms is the brand
            // base — quick and physical, opacity only.
            // The star blinks while the assistant works (a turn streams or agents
            // run); an ask that waits is the person's move, so it stands still.
            Icon: {
                display: null,
                show: (el, s)=>!el.scope.voiceCase(s.root),
                name: 'magicstar',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0',
                animationName: 'fadeIn',
                animationDuration: '150ms',
                isWorking: (el, s)=>el.scope.isLive(s.root) && !el.scope.askWaits(s.root),
                '.isWorking': {
                    animationName: 'blinking',
                    animationDuration: '1.6s',
                    animationIterationCount: 'infinite'
                }
            },
            // The CALL's face of the same slot (2026-10-22, the call redesign): the
            // shared orb at the control height, its ring driven by the island's
            // frame loop (voiceCallFrame). Replaced a 13-bar wave that read as a
            // dashed rule at rest.
            VoiceOrb: {
                display: null,
                show: (el, s)=>el.scope.voiceCase(s.root),
                animationName: 'fadeIn',
                animationDuration: '150ms'
            },
            // The call's status — the shared word + clock (localized; this slot
            // used to print hard-coded English in every language).
            VoiceCallStatus: {
                display: null,
                show: (el, s)=>el.scope.voiceCase(s.root),
                flex: '1 1 auto',
                animationName: 'fadeIn',
                animationDuration: '150ms'
            },
            // The status words: Thinking… · Working: · 2 agents working… · Needs
            // your OK · Answer ready · Assistant. One line; the tooltip is the whole
            // of it (the overflow law, §3b rule 8).
            Label: {
                tag: 'span',
                display: null,
                show: (el, s)=>!el.scope.voiceCase(s.root),
                flexShrink: '0',
                maxWidth: '100%',
                minWidth: '0',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 'Z1',
                fontWeight: '500',
                color: 'title',
                text: (el, s)=>el.scope.statusText(el, s.root),
                title: (el, s)=>el.scope.statusText(el, s.root)
            },
            // The running step, in the tool row's own words ("Searching
            // “transactions”") — named in the row instead of a second row under
            // it. Cut to one line here; the drawer's timeline holds the rest.
            HeadStep: {
                tag: 'span',
                flow: 'x',
                hide: (el, s)=>el.scope.voiceCase(s.root) || !el.scope.stepTool(s.root),
                flex: '0 1 auto',
                minWidth: '0',
                fontSize: 'Z1',
                color: 'paragraph',
                childExtends: 'ChatToolStepLabel',
                childrenAs: 'state',
                children: (el, s)=>{
                    const tool = el.scope.stepTool(s.root);
                    return tool ? [
                        {
                            ...tool,
                            key: 'step-' + tool.id
                        }
                    ] : [];
                },
                childProps: {
                    oneLine: true
                }
            }
        },
        // VOICE-TALK-ONLY-SIMONE-1 part 2 (Nika: "remove command and talk
        // switcher - just keep talk"): the island's VoiceModeTabs trailing slot
        // is unmounted — Talk is the only user-facing mode now (voiceSession
        // voiceStart talk-default; the composer's hold-to-command gesture is the
        // one remaining one-shot path).
        // The call's controls ride the head row's trailing edge (the Fly call
        // bar's anatomy): the SHARED set the composer strip carries too, each
        // button deriving its own visibility from state — here Mute, Expand and
        // End call (Type shows only while a composer hosts).
        VoiceControls: {
            display: null,
            show: (el, s)=>el.scope.voiceCase(s.root),
            animationName: 'fadeIn',
            animationDuration: '150ms'
        },
        // "Answer ready"'s two moves, in the row (they were a second capsule
        // stacked over this one). Icon buttons on the assistant chrome's own
        // primitive; their names are their tooltips. Above ExpandHit (z 2 vs 1).
        AssistantIconButton_main: {
            hide: (el, s)=>el.scope.voiceCase(s.root) || !el.scope.answerId(el, s.root) || !el.scope.canMoveToMain(el, s.root),
            icon: 'lnGrid',
            title: (el)=>el.call('polyglot', 'ai.pill.openInMain'),
            position: 'relative',
            zIndex: '2',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.scope.answerMove(el, s, 'main');
            }
        },
        AssistantIconButton_side: {
            hide: (el, s)=>el.scope.voiceCase(s.root) || !el.scope.answerId(el, s.root),
            icon: 'sidebarRightFill',
            title: (el)=>el.call('polyglot', 'ai.pill.openInSidebar'),
            position: 'relative',
            zIndex: '2',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.scope.answerMove(el, s, 'side');
            }
        },
        // Trailing dismiss (2026-09-02 per Nika: "it should be possible to
        // close/minimize ExpandHit"). The idle handle used to be permanent — the
        // only affordance was ExpandHit, so a pill you did not want could only be
        // resolved by opening the drawer and closing THAT. This X retires both
        // handle cases in one gesture, and the landed answer with them. It sits
        // ABOVE ExpandHit (zIndex 2 vs 1) so the X wins its own clicks; hidden
        // while a turn is live or an ask waits, because the pill is the turn's
        // only surface then and the hide gate would keep it on screen regardless.
        // Voice has its own close in VoiceControls.
        AssistantIconButton_close: {
            hide: (el, s)=>el.scope.voiceCase(s.root) || el.scope.isLive(s.root) || el.scope.askWaits(s.root),
            icon: 'crossmark',
            title: (el)=>el.call('polyglot', 'ai.pill.dismiss'),
            aria: {
                label: (el)=>el.call('polyglot', 'ai.pill.dismissLabel')
            },
            position: 'relative',
            zIndex: '2',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.scope.answerDismiss(el);
                // Retire every handle that keeps the pill mounted: the minimized-dock
                // handle (assistantOpen + dock 'minimized') and the slot handle. Only
                // declared keys are written (undeclared-root-key rule — hosts without
                // the pill-handle flag never take that write).
                const patch = {
                    assistantOpen: false
                };
                if (s.root._assistantPillHandle) patch._assistantPillHandle = false;
                s.root.update(patch);
            }
        }
    },
    // ——— above the bar: the words as bubbles, and the ask ———
    // The shared stack (AiBubbleStack, the composer's call strip mounts the same
    // one). The island hands it the assistant conversation in the text posture;
    // in a call it reads the call's own turns. It replaced the in-row thread
    // (VoiceLog + the live partial + CurrentStep + Agents), which grew the bar
    // with every line.
    AiBubbleStack: {
        turnsSource: (el, s)=>el.scope.voiceCase(s.root) ? null : el.scope.threadMsgs(s.root)
    }
};

});
parcelRegister("4SiPM", function(module, exports) {

$parcel$export(module.exports, "FEATURE_FLAGS_STORAGE_KEY", () => $38cad0a2e187d0d2$export$c42f2e95b8f0b11f);
$parcel$export(module.exports, "loadFeatureFlagOverrides", () => $38cad0a2e187d0d2$export$809eca0c7ea8663b);
$parcel$export(module.exports, "cacheFeatureFlagOverrides", () => $38cad0a2e187d0d2$export$8ebe978553489957);
$parcel$export(module.exports, "featureFlagDef", () => $38cad0a2e187d0d2$export$a67e2bd71a597aae);
$parcel$export(module.exports, "featureFlagOverrides", () => $38cad0a2e187d0d2$export$ecfb94020c5c52ff);
$parcel$export(module.exports, "featureEnabled", () => $38cad0a2e187d0d2$export$2e95bbd1facb2569);
$parcel$export(module.exports, "featureFlagForRoute", () => $38cad0a2e187d0d2$export$ea927577f76a1c3c);
$parcel$export(module.exports, "navItemVisible", () => $38cad0a2e187d0d2$export$f1855d02ec2af90b);
$parcel$export(module.exports, "FEATURE_FLAG_GROUPS", () => (parcelRequire("lXSq3")).FEATURE_FLAG_GROUPS);
$parcel$export(module.exports, "FEATURE_SUBFLAGS", () => (parcelRequire("lXSq3")).FEATURE_SUBFLAGS);
$parcel$export(module.exports, "FEATURE_FLAGS", () => (parcelRequire("lXSq3")).FEATURE_FLAGS);
$parcel$export(module.exports, "FLAG_INDEX", () => (parcelRequire("lXSq3")).FLAG_INDEX);
$parcel$export(module.exports, "ROUTE_FLAGS", () => (parcelRequire("lXSq3")).ROUTE_FLAGS);
$parcel$export(module.exports, "RAW_FEATURE_FLAGS", () => (parcelRequire("lXSq3")).RAW_FEATURE_FLAGS);
// Runtime feature-flag REGISTRY + read helpers — shared so navigation
// components (AppNavbar, CanvasViewNav, launcher) can gate items via
// featureEnabled(root, key). WRITE/persist lives in the workspace shell
// (@symbo-ls/workspace-shell/functions/featureFlags.js): flags are saved
// per-workspace in Mongo (workspace.settings.featureFlags via
// sdk.updateWorkspaceSettings) so they survive reloads, follow the
// workspace across devices, and stay inspectable by admins on the
// workspace document. Resolution order here (all reactive):
//   1. root.workspace.settings.featureFlags — server truth (Mongo)
//   2. root._featureFlags — live mirror (pre-load hydration + optimistic
//      toggle echo)
//   3. localStorage cache — last-known copy bridging the pre-auth boot
// (2026-07-25 per Nika: /flags + sub-features, per-workspace Mongo
// persistence, gates on all navigation items.)
//
// FA204 / frank trap — every helper/table this file's exports used to
// reference bare (either module-scope locals or same-file sibling
// exports) is unresolvable once each export is individually
// frank.toJSON'd for platform delivery (project_frank_drops_module_local_
// helpers). The ~700-line flag/sub-flag/route tables now live in
// ./featureFlagsData.js and are IMPORTED here — a cross-file import
// resolves fine via frank's globalScope fallback, so this is the fix for
// the data tables without a 6-way duplication of hand-authored content.
// The remaining (cheap) helpers each carry their own self-contained inline
// copy. `_cachedOverrides` is genuine cross-call state (module-memoized,
// invalidated by cacheFeatureFlagOverrides) with no el/root argument to
// hoist it onto — re-homed onto `globalThis.__featureFlagsOverridesCache`,
// the pointerCapability.js/mwtFlag.js template.

var $9juhh = parcelRequire("9juhh");

var $5LAZU = parcelRequire("5LAZU");

var $c7KfS = parcelRequire("c7KfS");

var $flGcp = parcelRequire("flGcp");

var $lXSq3 = parcelRequire("lXSq3");
const $38cad0a2e187d0d2$export$c42f2e95b8f0b11f = 'symbols_feature_flags';
const $38cad0a2e187d0d2$export$809eca0c7ea8663b = ()=>{
    const FEATURE_FLAGS_STORAGE_KEY = 'symbols_feature_flags';
    const state = globalThis.__featureFlagsOverridesCache = globalThis.__featureFlagsOverridesCache || {
        cached: null
    };
    if (state.cached) return state.cached;
    if (typeof window === 'undefined' || !window.localStorage) return {};
    try {
        const raw = window.localStorage.getItem(FEATURE_FLAGS_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        state.cached = parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_) {
        state.cached = {};
    }
    return state.cached;
};
const $38cad0a2e187d0d2$export$8ebe978553489957 = (flags)=>{
    const FEATURE_FLAGS_STORAGE_KEY = 'symbols_feature_flags';
    const state = globalThis.__featureFlagsOverridesCache = globalThis.__featureFlagsOverridesCache || {
        cached: null
    };
    state.cached = flags && typeof flags === 'object' ? flags : {};
    try {
        window.localStorage.setItem(FEATURE_FLAGS_STORAGE_KEY, JSON.stringify(state.cached));
    } catch (_) {
    /* private mode — in-memory cache still applies this session */ }
};
const $38cad0a2e187d0d2$export$a67e2bd71a597aae = (key)=>(0, $lXSq3.FLAG_INDEX)[key];
const $38cad0a2e187d0d2$export$ecfb94020c5c52ff = (root)=>{
    // FA204 / frank trap — self-contained inline copy of
    // loadFeatureFlagOverrides, see the file header.
    const _loadFeatureFlagOverrides = ()=>{
        const FEATURE_FLAGS_STORAGE_KEY = 'symbols_feature_flags';
        const state = globalThis.__featureFlagsOverridesCache = globalThis.__featureFlagsOverridesCache || {
            cached: null
        };
        if (state.cached) return state.cached;
        if (typeof window === 'undefined' || !window.localStorage) return {};
        try {
            const raw = window.localStorage.getItem(FEATURE_FLAGS_STORAGE_KEY);
            const parsed = raw ? JSON.parse(raw) : null;
            state.cached = parsed && typeof parsed === 'object' ? parsed : {};
        } catch (_) {
            state.cached = {};
        }
        return state.cached;
    };
    // DECISION site (spec §5) — deliberately NOT gated on `ready`, and this one
    // is the clearest case for not gating: the chain below already degrades to
    // the persisted localStorage cache, which exists precisely so the
    // pre-arrival window resolves to this user's LAST KNOWN flag set rather
    // than to bare defaults. Blocking on `ready` would throw that cache away
    // and make the unloaded window strictly worse, not safer. Reading through
    // the accessor still matters: it stops a list-shaped record from
    // contributing a phantom `featureFlags` key it never had.
    const { settings: settings } = (0, $5LAZU.workspaceSettings)(root);
    const mirror = root && root._featureFlags;
    return settings?.featureFlags || mirror || _loadFeatureFlagOverrides();
};
const $38cad0a2e187d0d2$export$2e95bbd1facb2569 = (root, key)=>{
    // FA204 / frank trap — self-contained inline copy of featureFlagOverrides,
    // see the file header. `featureEnabled` recurses on itself for
    // `def.parentKey` — that's a self-reference, not a sibling-export read,
    // so it's left as-is (matches dragRef.js's `setDragRef` self-recursion
    // precedent).
    const _featureFlagOverrides = (root)=>{
        const _loadFeatureFlagOverrides = ()=>{
            const FEATURE_FLAGS_STORAGE_KEY = 'symbols_feature_flags';
            const state = globalThis.__featureFlagsOverridesCache = globalThis.__featureFlagsOverridesCache || {
                cached: null
            };
            if (state.cached) return state.cached;
            if (typeof window === 'undefined' || !window.localStorage) return {};
            try {
                const raw = window.localStorage.getItem(FEATURE_FLAGS_STORAGE_KEY);
                const parsed = raw ? JSON.parse(raw) : null;
                state.cached = parsed && typeof parsed === 'object' ? parsed : {};
            } catch (_) {
                state.cached = {};
            }
            return state.cached;
        };
        const { settings: settings } = (0, $5LAZU.workspaceSettings)(root);
        const mirror = root && root._featureFlags;
        return settings?.featureFlags || mirror || _loadFeatureFlagOverrides();
    };
    const def = (0, $lXSq3.FLAG_INDEX)[key];
    if (!def) return true;
    if (def.core) return true;
    if (def.parentKey && !$38cad0a2e187d0d2$export$2e95bbd1facb2569(root, def.parentKey)) return false;
    const v = _featureFlagOverrides(root)[key];
    return typeof v === 'boolean' ? v : def.defaultOn !== false;
};
const $38cad0a2e187d0d2$export$ea927577f76a1c3c = (path)=>{
    const p = (0, $9juhh.stripWorkspacePrefix)(String(path || '').split('?')[0]);
    if (!p) return null;
    const hit = (0, $lXSq3.ROUTE_FLAGS).find(([base])=>p === base || p.indexOf(base + '/') === 0);
    return hit ? hit[1] : null;
};
const $38cad0a2e187d0d2$export$f1855d02ec2af90b = (root, item)=>{
    // NAVBAR-REMOVE-PERSIST-1 — a `{ path, dismissed: true }` row is a
    // persistence TOMBSTONE (moduleConsole.js mcRemoveListItem), not a real
    // destination: it exists only so workspaceConfigs.js's _appendNavbar dedup
    // ('seen' by path) never re-adds an app/module-contributed navbar entry
    // the admin explicitly removed. It must never render.
    if (item && item.dismissed) return false;
    // FA204 / frank trap — self-contained inline copies of
    // featureFlagForRoute/featureEnabled/_passesAppAccess, see the file
    // header. `_passesAppAccess` was module-local (used only here) — layered
    // ON TOP of feature flags (see appAccess.js): feature flags are a
    // product on/off switch; app-access is a per-team admin-configurable ACL
    // (the Apps matrix on /admin/teams), only enforced while
    // workspace.settings.appAccessControl.enforced is on. Routes outside the
    // 12-app vocabulary (studio/infra/agents/marketplace/team-members/…)
    // have no app-access key and stay visible; owners/admins always bypass
    // (see canApp).
    const _featureFlagForRoute = (path)=>{
        const p = (0, $9juhh.stripWorkspacePrefix)(String(path || '').split('?')[0]);
        if (!p) return null;
        const hit = (0, $lXSq3.ROUTE_FLAGS).find(([base])=>p === base || p.indexOf(base + '/') === 0);
        return hit ? hit[1] : null;
    };
    const _featureEnabled = (root, key)=>{
        const _featureFlagOverrides = (root)=>{
            const _loadFeatureFlagOverrides = ()=>{
                const FEATURE_FLAGS_STORAGE_KEY = 'symbols_feature_flags';
                const state = globalThis.__featureFlagsOverridesCache = globalThis.__featureFlagsOverridesCache || {
                    cached: null
                };
                if (state.cached) return state.cached;
                if (typeof window === 'undefined' || !window.localStorage) return {};
                try {
                    const raw = window.localStorage.getItem(FEATURE_FLAGS_STORAGE_KEY);
                    const parsed = raw ? JSON.parse(raw) : null;
                    state.cached = parsed && typeof parsed === 'object' ? parsed : {};
                } catch (_) {
                    state.cached = {};
                }
                return state.cached;
            };
            const { settings: settings } = (0, $5LAZU.workspaceSettings)(root);
            const mirror = root && root._featureFlags;
            return settings?.featureFlags || mirror || _loadFeatureFlagOverrides();
        };
        const def = (0, $lXSq3.FLAG_INDEX)[key];
        if (!def) return true;
        if (def.core) return true;
        if (def.parentKey && !_featureEnabled(root, def.parentKey)) return false;
        const v = _featureFlagOverrides(root)[key];
        return typeof v === 'boolean' ? v : def.defaultOn !== false;
    };
    const _passesAppAccess = (root, route)=>{
        const appKey = (0, $c7KfS.appKeyForRoute)(route);
        return !appKey || (0, $c7KfS.canApp)(root, appKey, 'read');
    };
    if (!item) return true;
    // THE COMM PROFILE (commHost.js): a comm host (comm.symbols.app) lists only
    // the routes it serves — every other destination lives on the workspace
    // host. Ahead of `flag: false`: an item that opts out of gating still names
    // a route this host does not serve.
    const _commRoute = typeof item === 'string' ? item : !item.divider && (item.route || item.path || item.href);
    if (_commRoute && (0, $flGcp.isCommHost)() && !(0, $flGcp.isCommRoute)(_commRoute)) return false;
    if (typeof item === 'string') {
        const flag = _featureFlagForRoute(item);
        if (flag && !_featureEnabled(root, flag)) return false;
        return _passesAppAccess(root, item);
    }
    if (item.divider) return true;
    if (item.flag === false) return true;
    const route = item.route || item.path || item.href;
    const flag = item.flag || _featureFlagForRoute(route);
    if (flag && !_featureEnabled(root, flag)) return false;
    return _passesAppAccess(root, route);
};

});
parcelRegister("5LAZU", function(module, exports) {

$parcel$export(module.exports, "workspaceSettings", () => $432e0a7583586c89$export$9930657b564c586a);
$parcel$export(module.exports, "workspaceSettingsReady", () => $432e0a7583586c89$export$df084bc666812f34);
$parcel$export(module.exports, "workspaceSettingsPending", () => $432e0a7583586c89$export$ed156d11a4a23fa8);
$parcel$export(module.exports, "workspaceSettingsForWrite", () => $432e0a7583586c89$export$79bee8c02f25646f);
// workspaceSettings.js — THE one accessor for `root.workspace.settings`
// (tickets/spec-workspace-record-shape.md §5, 2026-08-08).
//
// WHY THIS EXISTS. `root.workspace` is populated from two incompatible shapes
// (see activeWorkspaceRecord.js for the full history): a FULL server record,
// which carries the `settings` bag — `navbar`, `workspaceApps`,
// `home_default_panels`, `featureFlags`, `appAccessControl`, `voice`, `ai`,
// `companyInfo`, `workspaceModule` — and a LIST/claims entry, which never
// does. §4 made the downgrade impossible; it did NOT make the *pre-arrival*
// window visible. Thirty-five direct `workspace.settings.*` reads each did
//
//     const list = root?.workspace?.settings?.workspaceApps    // → undefined
//
// and then fell through to a default. `undefined` there has TWO meanings that
// the optional-chain collapses into one:
//
//   (a) the workspace is loaded and legitimately has no override — the
//       default IS the answer; and
//   (b) the workspace record has not arrived yet — the default is a LIE, and
//       rendering it paints a configured workspace as an unconfigured one.
//
// THE RULE (spec §5): a not-yet-loaded workspace must never render as a
// legitimately-configured one. So every read goes through here and gets the
// disambiguating bit back with the data:
//
//     const { settings, ready, pending } = workspaceSettings(root)
//
//   ready === true   → `settings` is authoritative (possibly `{}`, which
//                      means "loaded, no overrides" — a real answer).
//   ready === false  → `settings` is null. NOT "no overrides". Unknown.
//
// READINESS IS A TRI-STATE, and collapsing it to a boolean is a trap worth
// naming, because it is how a "correct" render gate turns into a permanently
// blank surface:
//
//   ready              the record is here. Render it.
//   pending            an id is known and completion is genuinely in flight
//                      (§4c scheduled the fetch). Render the indeterminate
//                      state — NOT the default.
//   !ready && !pending either no workspace is selected at all, or completion
//                      definitively FAILED (`_completionUnreachable`, stamped
//                      by activeWorkspaceRecord.js when the follow-up fetch
//                      comes back empty). Nothing more is coming, so the
//                      default IS the best available answer and rendering it
//                      is honest, not a substitution.
//
// Without that third state a render gate written as `if (!ready) return []`
// blanks the navbar FOREVER for any user whose getWorkspace 403s — trading a
// transient wrong-navbar bug for a permanent no-navbar one.
//
// HOW TO USE THE BIT. Two call-site classes, and they behave differently on
// purpose:
//
//   DECISION sites — read a setting to take a branch where "absent" and
//     "unknown" lead to the same safe action (is this flag on? is enforcement
//     enabled? is there a voice agent configured?). These may ignore `ready`,
//     but must say so in a comment: the default they fall to has to be the
//     right answer for BOTH meanings, and that is a claim worth writing down.
//
//   RENDER sites — paint configuration into the UI (the navbar, an
//     enforcement toggle, an "Added to workspace" label, a configured agent
//     id). These MUST branch on `ready` and render a loading/indeterminate
//     state instead of the default. This is the same principle the
//     app-dependency spec states for missing dependencies: a missing value
//     must be visually distinct from an empty one, never silently
//     substituted.
//
//   WRITE-BASE sites — read the bag only to build the next one
//     (`{ ...ws.settings, voice: next }`). These must NOT write while
//     `ready` is false: a merge over a null base both materializes a fake
//     `settings` bag on a shape that has none (making the record LOOK full)
//     and can drop sibling keys the writer never saw. `workspaceSettingsForWrite`
//     below is the guarded form.
//
// This accessor is deliberately NOT a fetch. It reports what is held right
// now. Convergence — "an id is known, so the full record WILL arrive" — is
// activeWorkspaceRecord.js's job (§4c), and the late-arrival re-render is
// §6's (see notifyActiveWorkspaceFull / the applyWorkspaceConfig converge in
// workspace/functions/loadPrivateData.js).

var $9IIym = parcelRequire("9IIym");
function $432e0a7583586c89$export$9930657b564c586a(input) {
    const rootOf = (i, self)=>{
        if (i && typeof i === 'object') {
            if (i.root && typeof i.root === 'object') return i.root;
            if ('workspace' in i || typeof i.update === 'function') return i;
        }
        if (self && self.state) return self.state.root || self.state;
        return null;
    };
    const root = rootOf(input, this);
    const ws = root && root.workspace || null;
    // Readiness is the PROVENANCE stamp, never "settings is non-empty" — a
    // workspace may legitimately carry no overrides at all, and inferring
    // not-loaded from an empty bag is exactly the conflation this file exists
    // to end (spec §4d).
    const ready = (0, $9IIym.isFullWorkspaceRecord)(ws);
    const id = ws ? String(ws.id || ws._id || '') || null : null;
    return {
        // `{}` when ready-with-no-overrides; `null` when not ready. Callers that
        // optional-chain (`settings?.navbar`) get `undefined` either way — which
        // is why the ones that RENDER must read `ready`, not just `settings`.
        settings: ready ? ws.settings || {} : null,
        ready: ready,
        // See the tri-state note at the top of this file. `_completionUnreachable`
        // is the terminal stamp activeWorkspaceRecord.js writes when the §4c
        // follow-up fetch cannot produce a full record.
        pending: !ready && !!id && !ws._completionUnreachable,
        workspace: ws,
        id: id
    };
}
function $432e0a7583586c89$export$df084bc666812f34(input) {
    const rootOf = (i, self)=>{
        if (i && typeof i === 'object') {
            if (i.root && typeof i.root === 'object') return i.root;
            if ('workspace' in i || typeof i.update === 'function') return i;
        }
        if (self && self.state) return self.state.root || self.state;
        return null;
    };
    return (0, $9IIym.isFullWorkspaceRecord)(rootOf(input, this)?.workspace);
}
function $432e0a7583586c89$export$ed156d11a4a23fa8(input) {
    const rootOf = (i, self)=>{
        if (i && typeof i === 'object') {
            if (i.root && typeof i.root === 'object') return i.root;
            if ('workspace' in i || typeof i.update === 'function') return i;
        }
        if (self && self.state) return self.state.root || self.state;
        return null;
    };
    const root = rootOf(input, this);
    const ws = root && root.workspace || null;
    const ready = (0, $9IIym.isFullWorkspaceRecord)(ws);
    const id = ws ? String(ws.id || ws._id || '') || null : null;
    return !ready && !!id && !ws?._completionUnreachable;
}
function $432e0a7583586c89$export$79bee8c02f25646f(input) {
    const rootOf = (i, self)=>{
        if (i && typeof i === 'object') {
            if (i.root && typeof i.root === 'object') return i.root;
            if ('workspace' in i || typeof i.update === 'function') return i;
        }
        if (self && self.state) return self.state.root || self.state;
        return null;
    };
    const root = rootOf(input, this);
    const ws = root && root.workspace || null;
    const ready = (0, $9IIym.isFullWorkspaceRecord)(ws);
    return ready ? ws.settings || {} : null;
}

});
parcelRegister("9IIym", function(module, exports) {

$parcel$export(module.exports, "normalizeWorkspaceRecord", () => $713ac87778012d84$export$b3226f2f27aeccd2);
$parcel$export(module.exports, "stampWorkspaceShape", () => $713ac87778012d84$export$b323ccd8ef0173f9);
$parcel$export(module.exports, "isFullWorkspaceRecord", () => $713ac87778012d84$export$c3a87c3f11063da5);
$parcel$export(module.exports, "stampWorkspaceListShape", () => $713ac87778012d84$export$e8c62d7f13cdb005);
$parcel$export(module.exports, "workspaceDisplayName", () => $713ac87778012d84$export$77904262cebf60e);
$parcel$export(module.exports, "fetchFullWorkspaceRecord", () => $713ac87778012d84$export$edfcf08ea1069b3d);
$parcel$export(module.exports, "onActiveWorkspaceFull", () => $713ac87778012d84$export$4b71ed33d18fc64);
$parcel$export(module.exports, "_notifyActiveWorkspaceFull", () => $713ac87778012d84$export$a8cfcfd754112fe);
$parcel$export(module.exports, "onWorkspaceIdentityCorrected", () => $713ac87778012d84$export$26e292a95e2caf0);
$parcel$export(module.exports, "notifyWorkspaceIdentityCorrected", () => $713ac87778012d84$export$5c9430af94b8abb6);
$parcel$export(module.exports, "setActiveWorkspaceRecord", () => $713ac87778012d84$export$b773161fd5b731d0);
// activeWorkspaceRecord.js — the ONE owner of what may land in `root.workspace`
// (tickets/spec-workspace-record-shape.md, 2026-08-08).
//
// THE DEFECT this closes: `root.workspace` was populated from two incompatible
// shapes and the code freely substituted one for the other —
//
//   sdk.getWorkspace(id) / the /core/boot `workspace` section  → FULL record
//     (`_id`, `organization`, `displayName`, `settings`, …) — `settings`
//     carries `navbar`, `workspaceApps`, `home_default_panels`, `featureFlags`,
//     `appAccessControl`.
//   claims.workspaces / listWorkspaces rows                    → LIST entry
//     (`id`, `name`, `slug`, `type`, `org_id`, `role`) — no `settings`, ever.
//
// When a list entry landed in `root.workspace`, every `workspace.settings.*`
// read silently resolved to `undefined` and fell back to framework defaults —
// the workspace still showed the right NAME, so it looked loaded. Measured
// live on dev.my.symbols.app: a cold `/add-app` load raced auth.js's claims
// tick against bootShell's full-record fetch and lost, painting the default
// navbar over a fully-configured workspace. It is a RACE, not a route bug —
// any route can lose it on any auth tick.
//
// THE RULE: `root.workspace` holds a COMPLETE workspace record, or it holds
// nothing. A list/claims-shaped entry is never assigned to it directly — it
// goes through `setActiveWorkspaceRecord`, which enforces monotonic shape
// (a list entry can never DOWNGRADE a full record already held for the same
// id) and guarantees the full record gets fetched once any id is known, on
// ANY resolution path — not just the two branches bootShell used to gate on
// `activeWorkspaceId` being present at BOOT time.
//
// Provenance stamp: every workspace record/row gets a non-destructive
// `_shape: 'full' | 'list'` marker — same precedent as the workspace-switch
// isolation invariants' provenance stamps (see MEMORY
// project_workspace_switch_isolation_invariants.md). `root.workspaceReady`
// mirrors "is `root.workspace` currently `_shape:'full'`" so consumers can
// gate rendering on it explicitly instead of inferring readiness from
// `settings` being non-empty (a workspace can legitimately have NO settings
// overrides — that must not read as "not loaded").

var $gGHbJ = parcelRequire("gGHbJ");
const $713ac87778012d84$export$b3226f2f27aeccd2 = (ws)=>{
    if (!ws || typeof ws !== 'object') return ws;
    if (!ws.id && ws._id) ws.id = String(ws._id);
    if (!ws.name && ws.displayName) ws.name = ws.displayName;
    if (!ws.org_id && ws.organization) ws.org_id = String(ws.organization);
    return ws;
};
const $713ac87778012d84$export$b323ccd8ef0173f9 = (ws, shape, { clone: clone = true } = {})=>{
    if (!ws || typeof ws !== 'object') return ws;
    const out = clone ? {
        ...ws
    } : ws;
    out._shape = shape;
    return out;
};
const $713ac87778012d84$export$c3a87c3f11063da5 = (ws)=>!!ws && ws._shape === 'full';
const $713ac87778012d84$export$e8c62d7f13cdb005 = (rows)=>(Array.isArray(rows) ? rows : []).map((w)=>w && typeof w === 'object' ? {
            ...w,
            _shape: w._shape || 'list'
        } : w);
const $713ac87778012d84$export$77904262cebf60e = (ws)=>ws && (ws.displayName || ws.name) || '';
const $713ac87778012d84$export$edfcf08ea1069b3d = async (sdk, id, { getWorkspaceCached: getWorkspaceCached } = {})=>{
    if (!sdk || !id) return null;
    try {
        let raw;
        if (typeof getWorkspaceCached === 'function') raw = await getWorkspaceCached(sdk, id);
        else if (typeof sdk.getWorkspace === 'function') {
            const res = await sdk.getWorkspace(id);
            raw = res?.data || res || null;
        } else return null;
        if (!raw || !(raw._id || raw.id)) return null;
        // FA204 / frank trap — self-contained inline copies of
        // normalizeWorkspaceRecord/stampWorkspaceShape (a bare sibling-export
        // call is exactly as unresolvable post-frank-serialization as a
        // module-local read; the two named exports stay live for their many
        // real external consumers — bootShell.js/loadPrivateData.js/auth.js/
        // switchWorkspace.js/this file's own test suite).
        const ws = {
            ...raw
        };
        if (!ws.id && ws._id) ws.id = String(ws._id);
        if (!ws.name && ws.displayName) ws.name = ws.displayName;
        if (!ws.org_id && ws.organization) ws.org_id = String(ws.organization);
        ws._shape = 'full';
        return ws;
    } catch (err) {
        console.warn('[activeWorkspaceRecord] fetchFullWorkspaceRecord failed:', err?.message || err);
        return null;
    }
};
const $713ac87778012d84$export$4b71ed33d18fc64 = (fn)=>{
    if (!globalThis.__activeWorkspaceRecordListeners) globalThis.__activeWorkspaceRecordListeners = new Set();
    const listeners = globalThis.__activeWorkspaceRecordListeners;
    if (typeof fn !== 'function') return ()=>{};
    listeners.add(fn);
    return ()=>listeners.delete(fn);
};
const $713ac87778012d84$export$a8cfcfd754112fe = (root, ws)=>{
    const listeners = globalThis.__activeWorkspaceRecordListeners;
    if (!listeners) return;
    for (const fn of listeners)try {
        fn(root, ws);
    } catch (err) {
        console.warn('[activeWorkspaceRecord] full-record listener failed:', err?.message || err);
    }
};
const $713ac87778012d84$export$26e292a95e2caf0 = (fn)=>{
    if (!globalThis.__workspaceIdentityCorrectedListeners) globalThis.__workspaceIdentityCorrectedListeners = new Set();
    const listeners = globalThis.__workspaceIdentityCorrectedListeners;
    if (typeof fn !== 'function') return ()=>{};
    listeners.add(fn);
    return ()=>listeners.delete(fn);
};
const $713ac87778012d84$export$5c9430af94b8abb6 = (root, ws)=>{
    const listeners = globalThis.__workspaceIdentityCorrectedListeners;
    if (!listeners) return;
    for (const fn of listeners)try {
        fn(root, ws);
    } catch (err) {
        console.warn('[activeWorkspaceRecord] identity-correction listener failed:', err?.message || err);
    }
};
const $713ac87778012d84$export$b773161fd5b731d0 = (root, next, opts = {})=>{
    // FA204 / frank trap — self-contained inline copies of
    // _notifyActiveWorkspaceFull (reading the same
    // globalThis.__activeWorkspaceRecordListeners set the exported version
    // reads)/fetchFullWorkspaceRecord (a bare sibling-export call is exactly
    // as unresolvable post-frank-serialization as a module-local read; the
    // named export stays live for its own test suite) and
    // _markCompletionUnreachable (was a bare module-local helper, now local
    // to this export, its sole caller). `_pendingFullFetches` is genuine
    // cross-call dedup state (must survive BETWEEN separate top-level calls
    // to this function, not just within one call) — re-homed onto
    // `globalThis.__activeWorkspaceRecordPendingFetches`.
    const notifyActiveWorkspaceFull = (r, ws)=>{
        const listeners = globalThis.__activeWorkspaceRecordListeners;
        if (!listeners) return;
        for (const fn of listeners)try {
            fn(r, ws);
        } catch (err) {
            console.warn('[activeWorkspaceRecord] full-record listener failed:', err?.message || err);
        }
    };
    const fetchFullRecord = async (sdk, id, { getWorkspaceCached: getWorkspaceCached } = {})=>{
        if (!sdk || !id) return null;
        try {
            let raw;
            if (typeof getWorkspaceCached === 'function') raw = await getWorkspaceCached(sdk, id);
            else if (typeof sdk.getWorkspace === 'function') {
                const res = await sdk.getWorkspace(id);
                raw = res?.data || res || null;
            } else return null;
            if (!raw || !(raw._id || raw.id)) return null;
            const ws = {
                ...raw
            };
            if (!ws.id && ws._id) ws.id = String(ws._id);
            if (!ws.name && ws.displayName) ws.name = ws.displayName;
            if (!ws.org_id && ws.organization) ws.org_id = String(ws.organization);
            ws._shape = 'full';
            return ws;
        } catch (err) {
            console.warn('[activeWorkspaceRecord] fetchFullWorkspaceRecord failed:', err?.message || err);
            return null;
        }
    };
    // Terminal marker for "this record will never become full". Written onto
    // the held record itself (not a sibling root key) so it travels with the
    // record and is automatically void the moment a different workspace is
    // adopted — exactly like `_shape`. Idempotent, and never applied to a
    // record that has meanwhile become full or moved to another id.
    const markCompletionUnreachable = (r, id)=>{
        const cur = r && r.workspace;
        if (!cur || cur._shape === 'full' || cur._completionUnreachable) return;
        if (String(cur.id || cur._id || '') !== String(id)) return;
        if ((0, $gGHbJ.isLoudDevRuntime)()) console.warn(`[activeWorkspaceRecord] workspace ${id} could not be completed to a full record`);
        r.update({
            workspace: {
                ...cur,
                _completionUnreachable: true
            }
        });
    };
    if (!globalThis.__activeWorkspaceRecordPendingFetches) globalThis.__activeWorkspaceRecordPendingFetches = new Set();
    const pendingFullFetches = globalThis.__activeWorkspaceRecordPendingFetches;
    if (!root) return false;
    const reason = opts.reason || 'unknown';
    if (!next) {
        // Explicit clear — sign-out / no active workspace. Always allowed; there
        // is nothing to protect a clear from.
        root.update({
            workspace: null,
            workspaceReady: false
        });
        return true;
    }
    const shape = next._shape === 'full' ? 'full' : 'list';
    const nextId = String(next.id || next._id || '');
    const current = root.workspace;
    const currentShape = current ? current._shape === 'full' ? 'full' : 'list' : null;
    const currentId = current ? String(current.id || current._id || '') : '';
    if (shape === 'list' && currentShape === 'full' && currentId && currentId === nextId) {
        if ((0, $gGHbJ.isLoudDevRuntime)()) console.warn(`[activeWorkspaceRecord] rejected list-shape downgrade of full workspace ${nextId} (reason: ${reason})`);
        return false;
    }
    // A full-record refresh can change language without changing identity.
    // Capture the pair before update: reactive stores may merge the new record
    // into the held object. Missing policy and explicit 'default' are equivalent.
    const languageChanged = (current?.settings?.language || '') !== (next.settings?.language || '') || (current?.settings?.languagePolicy || 'default') !== (next.settings?.languagePolicy || 'default');
    root.update({
        workspace: next,
        workspaceReady: shape === 'full'
    });
    // §6 — announce the UPGRADE, not every write. A transition is
    // (nothing | list) → full, or a full record for a DIFFERENT id than the one
    // previously held. A changed language/policy pair also needs convergence:
    // the shell's language listener otherwise never sees an admin's update to
    // the active workspace. Identical pairs stay silent so repeated full-record
    // fetches cannot put the activation chain on a hot path.
    if (shape === 'full' && (!(currentShape === 'full' && currentId === nextId) || languageChanged)) notifyActiveWorkspaceFull(root, next);
    // §4c — guaranteed completion on ANY resolution path, not just the two
    // bootShell branches gated on `activeWorkspaceId` being present at boot.
    // Whenever what ends up held is list-shaped, converge to the full record.
    if (shape === 'list' && nextId) {
        if (!opts.sdk) // Nobody is going to complete this one — the caller handed no sdk, so
        // there is no fetch to wait for. Say so TERMINALLY (see
        // `_completionUnreachable` below): a render site that gates on "still
        // loading" must be able to tell "wait for it" from "this is all there
        // is", or a caller that never schedules a fetch leaves that gate hung
        // forever and the surface renders its indeterminate state permanently.
        markCompletionUnreachable(root, nextId);
        else if (!pendingFullFetches.has(nextId)) {
            pendingFullFetches.add(nextId);
            Promise.resolve(fetchFullRecord(opts.sdk, nextId, {
                getWorkspaceCached: opts.getWorkspaceCached
            })).then((full)=>{
                // Staleness guard: only apply if the tab is still scoped to the SAME
                // workspace id this fetch was for — a switch that happened while the
                // fetch was in flight must not have its new scope stomped by a late
                // answer for the OLD id.
                const cur = root.workspace;
                const curId = cur ? String(cur.id || cur._id || '') : '';
                if (curId !== nextId) return;
                if (full) {
                    $713ac87778012d84$export$b773161fd5b731d0(root, full, {
                        reason: `${reason}:full-fetch-followup`
                    });
                    return;
                }
                // The fetch ran and came back with nothing (network failure, 403,
                // an sdk without getWorkspace). Dropping that on the floor is the
                // silent-catch this whole spec exists to end: readiness would sit
                // false forever with no way for a consumer to distinguish it from
                // "any moment now".
                markCompletionUnreachable(root, nextId);
            }).finally(()=>pendingFullFetches.delete(nextId));
        }
    }
    return true;
};

});
parcelRegister("gGHbJ", function(module, exports) {

$parcel$export(module.exports, "isLoudDevRuntime", () => $c26211db95bcca6d$export$3452e66ea0c4d82f);
// isLoudDevRuntime.js — local copy of the pure, zero-dependency helper from
// `smbls/packages/utils/env.js` (added in 62baffcc7, first published as
// `@symbo.ls/utils@3.14.691`).
//
// Why a local copy instead of bumping `@symbo.ls/utils`: the reported
// `SyntaxError: Export named 'isLoudDevRuntime' not found` was real (the
// floor at bun.lock time, 3.14.663, predates the symbol), but raising the
// floor to pull it in caused second-order breakage — see the revert commit
// "Revert \"fix(deps): declare the @symbo.ls/utils floor where
// isLoudDevRuntime is used\"" for the measured before/after test tallies.
// This function has zero dependencies (only reads `process.env` /
// `location.hostname`), so vendoring it locally closes the SyntaxError
// without touching the dependency graph at all. Once the lock's
// `@symbo.ls/utils` floor naturally advances past 3.14.691, this file and
// its three call sites can be repointed back to the package export.
//
// FRAMEWORK-6: shared gate for dev-only loud-failure diagnostics.
//
// Why a hybrid gate instead of `process.env.NODE_ENV !== 'production'` alone:
// the dist build (`esbuild --minify`, default platform=browser) auto-defines
// `process.env.NODE_ENV` to `"production"` and dead-code-eliminates any
// branch gated on it. Consumers resolve `dist/esm`, not `src`, so a
// NODE_ENV-only gate can never fire in a real dev browser session.
//
// Why not hostname alone: node/test consumers (vitest, bun test, SSR) resolve
// source, where NODE_ENV is live and `location` may not exist.
//
// So:
//  - build-time leg — `process.env.NODE_ENV` — live for source/test
//    consumers; folds to `false` at dist build time.
//  - runtime leg — `location.hostname` is `localhost`, `127.0.0.1`, or any
//    `*.localhost` — survives the dist build, so dev servers
//    (`workspace.localhost:1355` etc.) still get loud failures.
//
// A visitor on a production domain (`my.symbols.app`, `*.symbo.ls`, custom
// domains) matches neither leg and never sees console noise from this.
//
// @param {object} [overrides] test-only injection: `{ env, hostname }`
// @returns {boolean}
const $c26211db95bcca6d$export$3452e66ea0c4d82f = (overrides)=>{
    const env = overrides && 'env' in overrides ? overrides.env : undefined;
    if (env && env !== 'production') return true;
    const hostname = overrides && 'hostname' in overrides ? overrides.hostname : typeof location !== 'undefined' ? location.hostname : undefined;
    if (typeof hostname === 'string' && hostname) return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost');
    return false;
};

});



parcelRegister("c7KfS", function(module, exports) {

$parcel$export(module.exports, "isOwnerOrAdmin", () => $8d3a04c57a85a543$export$d3171c70de634e66);
$parcel$export(module.exports, "canApp", () => $8d3a04c57a85a543$export$9ad88462d918dd0f);
$parcel$export(module.exports, "appKeyForRoute", () => $8d3a04c57a85a543$export$5dc6fdf96168690f);
// canApp — per-team app-access CRUD gate. Layered ON TOP of feature
// flags (featureFlags.js, same folder — a product on/off switch): this
// is an admin-configurable ACL, gating whether a signed-in member's
// TEAM grants a given `app.<key>.<verb>` permission. Off by default —
// every workspace ships with `workspace.settings.appAccessControl`
// unset, so canApp is a no-op bypass until an admin opts in from the
// Apps matrix on /admin/teams (workspace/pages/admin/teams.js
// _enforceRow, writes via workspace/functions/featureFlags.js
// setAppAccessEnforced). The 12-app × 4-verb `app.<key>.<verb>`
// vocabulary itself lives in workspace/functions/permissions.js
// (APP_ACCESS_APPS / APP_ACCESS_VERBS, mirroring
// server/src/core/constants/permissions.js @554832fb) — this file only
// builds/reads the permission strings, it does not own the catalog.
//
// Lives in SHARED (not workspace) because navItemVisible (featureFlags.js,
// same folder) needs it, and shared is consumed by every host (workspace,
// canvas, marketplace, preview) — it must not depend on the workspace
// package. That's also why the owner/admin bypass below REPLICATES the
// claim-based legs of workspace/functions/roleHelpers.js `hasPermission`
// (owner bypass) and `currentUserIsAdmin` (owner/admin claim signals,
// roleHelpers.js:26-99) instead of importing them — same primitives
// (root.jwtClaims.is_owner / org_role / workspace_role / symbols_role,
// root.org.role), read directly off `root` so this file stays free of
// cross-package imports. The one leg intentionally NOT replicated is
// currentUserIsAdmin's legacy `root.people` / `roles.byUser` fallback —
// that needs `findPerson` from workspace-shared/functions/peopleUtils.js
// and is a dual-read-migration leg for pre-JWT-permission data; every
// account new enough to have `appAccessControl` also has claim-based
// owner/admin signals, so skipping it costs nothing here.

var $9juhh = parcelRequire("9juhh");

var $5LAZU = parcelRequire("5LAZU");
const $8d3a04c57a85a543$export$d3171c70de634e66 = (root)=>{
    const isOwnerLikeRole = (r)=>r === 'owner' || r === 'admin';
    const claims = root?.jwtClaims || {};
    if (claims.is_owner === true) return true;
    if (isOwnerLikeRole(claims.org_role)) return true;
    if (isOwnerLikeRole(claims.workspace_role)) return true;
    if (claims.symbols_role === 'admin' || claims.symbolsRole === 'admin') return true;
    if (isOwnerLikeRole(root?.org?.role)) return true;
    return false;
};
const $8d3a04c57a85a543$export$9ad88462d918dd0f = (root, appKey, verb = 'read')=>{
    // DECISION site (spec §5) — deliberately does NOT gate on `ready`, and the
    // reason has to be written down because the default here is PERMISSIVE.
    // "enforcement is off" and "we don't know yet whether enforcement is on"
    // both resolve to `true` (allow). That is the correct direction: this gate
    // hides navigation, so failing closed would blank a member's whole app list
    // for the pre-arrival window and then pop it back in — strictly worse than
    // briefly showing an app that a later tick removes, and it can never leak
    // DATA (the server enforces access independently; this only decides what is
    // offered in the UI).
    const isOwnerLikeRole = (r)=>r === 'owner' || r === 'admin';
    const ownerOrAdmin = (r)=>{
        const claims = r?.jwtClaims || {};
        if (claims.is_owner === true) return true;
        if (isOwnerLikeRole(claims.org_role)) return true;
        if (isOwnerLikeRole(claims.workspace_role)) return true;
        if (claims.symbols_role === 'admin' || claims.symbolsRole === 'admin') return true;
        if (isOwnerLikeRole(r?.org?.role)) return true;
        return false;
    };
    const permissionsFromRoot = (r)=>{
        const org = r?.org;
        if (org && Array.isArray(org.permissions)) return org.permissions;
        if (org && Array.isArray(org.intranetPermissions)) return org.intranetPermissions;
        return r?.jwtClaims?.permissions || [];
    };
    const { settings: settings } = (0, $5LAZU.workspaceSettings)(root);
    if (!settings?.appAccessControl?.enforced) return true;
    if (ownerOrAdmin(root)) return true;
    return permissionsFromRoot(root).includes(`app.${appKey}.${verb}`);
};
const $8d3a04c57a85a543$export$5dc6fdf96168690f = (path)=>{
    // Route prefix → app-access key. Deliberately independent from
    // featureFlags.js's ROUTE_FLAGS (route → FEATURE flag key): the two
    // vocabularies mostly overlap by naming coincidence (calendar / chat /
    // meet / documents / files / analytics / data / announcements / company
    // all share their route prefix as both a flag key AND an app-access
    // key) but diverge on Tickets (feature-flag key `tasks`, app-access key
    // `tickets`) and Reminders (no ROUTE_FLAGS entry yet). Keeping this
    // table independent also means it never collides with concurrent edits
    // to ROUTE_FLAGS.
    //
    // '/reminders' is a best-effort route guess — APP_ACCESS_APPS already
    // carries a `reminders` app key (server@554832fb) ahead of its own
    // top-level route/page landing; update this entry if that route ships
    // under a different path.
    const APP_ROUTES = [
        [
            '/calendar',
            'calendar'
        ],
        [
            '/chat',
            'chat'
        ],
        [
            '/meet',
            'meet'
        ],
        // /notes is the canonical route (documents→notes rename 2026-08-06); the
        // app-access key stays the internal 'documents'. '/documents' = legacy alias.
        [
            '/notes',
            'documents'
        ],
        [
            '/documents',
            'documents'
        ],
        [
            '/files',
            'files'
        ],
        // /tasks is the canonical route (tickets→tasks rename 2026-08-06); the
        // ACL app key stays the internal 'tickets'. /tickets* = inbound aliases.
        [
            '/tasks-page',
            'tickets'
        ],
        [
            '/tasks',
            'tickets'
        ],
        [
            '/task',
            'tickets'
        ],
        [
            '/tickets-page',
            'tickets'
        ],
        [
            '/tickets',
            'tickets'
        ],
        [
            '/ticket',
            'tickets'
        ],
        [
            '/reminders',
            'reminders'
        ],
        [
            '/resolutions',
            'resolutions'
        ],
        [
            '/workspace-analytics',
            'analytics'
        ],
        [
            '/analytics',
            'analytics'
        ],
        [
            '/logs',
            'analytics'
        ],
        [
            '/data',
            'data'
        ],
        [
            '/announcements',
            'announcements'
        ],
        [
            '/company',
            'company'
        ]
    ];
    const p = (0, $9juhh.stripWorkspacePrefix)(String(path || '').split('?')[0]);
    if (!p) return null;
    const hit = APP_ROUTES.find(([base])=>p === base || p.indexOf(base + '/') === 0);
    return hit ? hit[1] : null;
};

});

parcelRegister("flGcp", function(module, exports) {

$parcel$export(module.exports, "isCommHostname", () => $b2c98d100a0a255a$export$40db34631ce91ec8);
$parcel$export(module.exports, "myHostForComm", () => $b2c98d100a0a255a$export$64a787605cecddf5);
$parcel$export(module.exports, "commHostForMy", () => $b2c98d100a0a255a$export$3ffabd51f89b2967);
$parcel$export(module.exports, "isCommHost", () => $b2c98d100a0a255a$export$b5bffc57ba3ed93e);
$parcel$export(module.exports, "isCommRoute", () => $b2c98d100a0a255a$export$2ed7ba7f11caf0f);
$parcel$export(module.exports, "commHome", () => $b2c98d100a0a255a$export$16958c53223e7916);
$parcel$export(module.exports, "commAssistantMode", () => $b2c98d100a0a255a$export$f847d3f176892fb8);
$parcel$export(module.exports, "workspaceHostUrl", () => $b2c98d100a0a255a$export$867bebf939eaf612);
$parcel$export(module.exports, "reloadCommHome", () => $b2c98d100a0a255a$export$12dee32dc4b4862d);
$parcel$export(module.exports, "openOnWorkspaceHost", () => $b2c98d100a0a255a$export$4f9bd80f70a068bc);
// The communication host — `comm.symbols.app` (prod) and
// `<tier>.comm.symbols.app` (`dev.comm.symbols.app`, …). It serves the SAME
// shell build from the SAME bucket as the workspace host of its tier
// (`my.symbols.app`, `dev.my.symbols.app`), so it is always the current build.
// Only the profile differs: chat, calls, inbox, calendar, mail, reminders,
// people, agents, the AI composer and Fly (commProfileData.js). Contract:
// workspace docs/COMM_HOST.md.
//
// The pairing is ONE label rule, no channel list: the `comm` label right
// before `symbols.app` ↔ the `my` label. `comm.symbols.app` ↔ `my.symbols.app`,
// `dev.comm.symbols.app` ↔ `dev.my.symbols.app`.
//
// THE LEGACY `com` LABEL (Nika 2026-10-24: "change domain to com.symbols to
// comm.symbols"): `com.symbols.app` was the comm host's first name. Every
// test here still accepts it (`comm?`), so a build reaching a tier works on
// both names in any order; each tier's old host then redirects to the new
// one at the edge (docs/COMM_HOST.md). The pairing writes `comm` only.
//
// FA204 / frank trap — every export is self-contained (the label rule is
// restated where it is used); the lists come from commProfileData.js, a
// cross-file import, which resolves through frank's globalScope fallback.
//
// Local simulation (no DNS): `?comm=1` (one visit) or
// `localStorage.symbols_force_comm='1'` — the demoHost.js convention. A
// simulated comm host has no workspace host to send other routes to, so they
// land on the comm home instead (commRouteGuard).

var $ez5lb = parcelRequire("ez5lb");

var $9juhh = parcelRequire("9juhh");
const $b2c98d100a0a255a$export$40db34631ce91ec8 = (hostname)=>{
    const h = typeof hostname === 'string' ? hostname.split(':')[0].trim().toLowerCase() : '';
    return /(^|\.)comm?\.symbols\.app$/.test(h);
};
const $b2c98d100a0a255a$export$64a787605cecddf5 = (hostname)=>{
    const h = typeof hostname === 'string' ? hostname.split(':')[0].trim().toLowerCase() : '';
    const m = /^((?:[a-z0-9-]+\.)*)comm?\.symbols\.app$/.exec(h);
    return m ? `${m[1]}my.symbols.app` : null;
};
const $b2c98d100a0a255a$export$3ffabd51f89b2967 = (hostname)=>{
    const h = typeof hostname === 'string' ? hostname.split(':')[0].trim().toLowerCase() : '';
    const m = /^((?:[a-z0-9-]+\.)*)my\.symbols\.app$/.exec(h);
    return m ? `${m[1]}comm.symbols.app` : null;
};
const $b2c98d100a0a255a$export$b5bffc57ba3ed93e = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        const host = String(window.location && window.location.hostname || '').toLowerCase();
        if (/(^|\.)comm?\.symbols\.app$/.test(host)) return true;
        if (window.localStorage.getItem('symbols_force_comm') === '1') return true;
        if ((window.location.search || '').includes('comm=1')) return true;
    } catch (_) {
    // Sandboxed storage / location — the workspace profile.
    }
    return false;
};
const $b2c98d100a0a255a$export$2ed7ba7f11caf0f = (pathname)=>{
    const p = (0, $9juhh.stripWorkspacePrefix)(String(pathname || '').split(/[?#]/)[0]) || '/';
    if (p === '/') return false;
    return (0, $ez5lb.commRoutes)().some((base)=>p === base || p.indexOf(base + '/') === 0);
};
const $b2c98d100a0a255a$export$16958c53223e7916 = ()=>(0, $ez5lb.commHomePath)();
const $b2c98d100a0a255a$export$f847d3f176892fb8 = (mode)=>{
    let comm = false;
    try {
        const host = String(window.location && window.location.hostname || '').toLowerCase();
        comm = /(^|\.)comm?\.symbols\.app$/.test(host) || window.localStorage.getItem('symbols_force_comm') === '1' || (window.location.search || '').includes('comm=1');
    } catch (_) {
        comm = false;
    }
    if (!comm) return mode;
    return (0, $ez5lb.commAssistantModes)().includes(mode) ? mode : 'assistant';
};
const $b2c98d100a0a255a$export$867bebf939eaf612 = (path)=>{
    if (typeof window === 'undefined' || !window.location) return null;
    const host = String(window.location.hostname || '').toLowerCase();
    const m = /^((?:[a-z0-9-]+\.)*)comm?\.symbols\.app$/.exec(host);
    if (!m) return null;
    const p = typeof path === 'string' && path.startsWith('/') ? path : '/';
    return `https://${m[1]}my.symbols.app${p}`;
};
const $b2c98d100a0a255a$export$12dee32dc4b4862d = (el)=>{
    const win = el && el.context && el.context.window || (typeof window !== 'undefined' ? window : null);
    if (!win || !win.location || typeof win.location.assign !== 'function') return false;
    try {
        win.location.assign((0, $ez5lb.commHomePath)());
        return true;
    } catch (_) {
        return false;
    }
};
const $b2c98d100a0a255a$export$4f9bd80f70a068bc = (el, path)=>{
    const win = el && el.context && el.context.window || (typeof window !== 'undefined' ? window : null);
    if (!win || !win.location || typeof win.location.assign !== 'function') return false;
    const host = String(win.location.hostname || '').toLowerCase();
    const m = /^((?:[a-z0-9-]+\.)*)comm?\.symbols\.app$/.exec(host);
    if (!m) return false;
    const p = typeof path === 'string' && path.startsWith('/') ? path : '/';
    try {
        win.location.assign(`https://${m[1]}my.symbols.app${p}`);
        return true;
    } catch (_) {
        return false;
    }
};

});
parcelRegister("ez5lb", function(module, exports) {

$parcel$export(module.exports, "commRoutes", () => $a9a87a1cd78576c7$export$5f37b37e411a5cc4);
$parcel$export(module.exports, "commHomePath", () => $a9a87a1cd78576c7$export$ea22ecd7473dd337);
$parcel$export(module.exports, "commNavTabs", () => $a9a87a1cd78576c7$export$1f0b7058ba3d6ea1);
$parcel$export(module.exports, "commAssistantModes", () => $a9a87a1cd78576c7$export$fcbc9eb45df402b5);
// The comm profile's ONE list — what `comm.symbols.app` (the communication
// host, workspace docs/COMM_HOST.md) serves. Every reader (the router guard,
// the nav filter, the header tabs) takes it from here; nothing restates it.
//
// Functions, not array consts: a module-level array is hoisted into the
// platform's globalScope and comes back as a keyed object in a consumer's
// fetched copy (`.map`/`.some` then throw). A function survives the round trip.
// The base paths a comm host serves. A path matches its base or any deeper
// sub-route (`/chat` covers `/chat/<channel>`). Everything else opens on the
// workspace host (my.symbols.app).
const $a9a87a1cd78576c7$export$5f37b37e411a5cc4 = ()=>[
        // The communication apps (Nika 2026-10-23)
        '/chat',
        '/meet',
        '/meet-guest',
        '/inbox',
        '/calendar',
        '/mail',
        '/reminders',
        '/people',
        '/team-members',
        '/team-and-agents',
        '/profile',
        '/u',
        '/user',
        '/agents',
        '/my-agents',
        // The person's own settings
        '/settings',
        '/account',
        // Sign-in, invites and the session bridge — a comm host signs in on its own
        '/login',
        '/signin',
        '/signup',
        '/signup-confirmation',
        '/reset-password',
        '/auth',
        '/github-auth-callback',
        '/sign-in-session',
        '/_session-bridge',
        '/accept-invite',
        '/accept-org-invite',
        '/accept-team-invite',
        '/accept-workspace-invite',
        '/waitlist-invite',
        '/waitlist',
        '/404'
    ];
const $a9a87a1cd78576c7$export$ea22ecd7473dd337 = ()=>'/chat';
const $a9a87a1cd78576c7$export$1f0b7058ba3d6ea1 = ()=>[
        {
            key: 'chat',
            label: 'shell.app.chat',
            path: '/chat'
        },
        {
            key: 'meet',
            label: 'shell.app.meet',
            path: '/meet'
        },
        {
            key: 'inbox',
            label: 'shell.app.inbox',
            path: '/inbox'
        },
        {
            key: 'calendar',
            label: 'shell.app.calendar',
            path: '/calendar'
        },
        {
            key: 'mail',
            label: 'shell.app.mail',
            path: '/mail'
        },
        {
            key: 'reminders',
            label: 'shell.app.reminders',
            path: '/reminders'
        },
        {
            key: 'people',
            label: 'shell.app.people',
            path: '/team-members'
        },
        {
            key: 'agents',
            label: 'shell.app.agents',
            path: '/agents'
        }
    ];
const $a9a87a1cd78576c7$export$fcbc9eb45df402b5 = ()=>[
        'assistant',
        'tools',
        'fly'
    ];

});


parcelRegister("lXSq3", function(module, exports) {

$parcel$export(module.exports, "FEATURE_FLAG_GROUPS", () => $ffd9522da8939bdf$export$96f17309eafe32fc);
$parcel$export(module.exports, "RAW_FEATURE_FLAGS", () => $ffd9522da8939bdf$export$9fdfd1d8755a4e44);
$parcel$export(module.exports, "FEATURE_SUBFLAGS", () => $ffd9522da8939bdf$export$f5f3ea3c7409aaa3);
$parcel$export(module.exports, "FEATURE_FLAGS", () => $ffd9522da8939bdf$export$1e3fa289c11cc7);
$parcel$export(module.exports, "FLAG_INDEX", () => $ffd9522da8939bdf$export$598cb7508de11bf8);
$parcel$export(module.exports, "ROUTE_FLAGS", () => $ffd9522da8939bdf$export$7ddb87109dcd28a1);
// Pure data tables for the runtime feature-flag registry — split out of
// featureFlags.js so every reader in that file becomes a cross-file IMPORT
// instead of a same-file sibling-export read.
//
// FA204 / frank trap (project_frank_drops_module_local_helpers): a
// same-file sibling-export/module-local read is unresolvable once the
// reading function is individually frank.toJSON'd for platform delivery;
// a cross-file ESM import resolves fine via frank's globalScope prototype-
// chain fallback (independently proven in this codebase — see the
// `__scope` construction recovered from the served platform payload:
// `const s = el?.scope; const g = el?.context?.globalScope; ... return s ??
// g ?? {}`). These tables are ~700 lines of hand-authored flag metadata —
// duplicating them per consuming function (the usual per-export inline-copy
// recipe) would be correct but turn every future flag edit into a 6+-way
// find-and-replace. Moving them here once, imported everywhere they're
// read, gets the same frank-safety with none of that maintenance cost.
//
// Nothing in this file is itself a DOMQL-registered function — it's pure
// data plus one pure derivation (`FEATURE_FLAGS`) and one pure index build
// (`FLAG_INDEX`), both computed ONCE at module-evaluation time (not inside
// an exported function body), so neither is subject to the trap at all.
// ─── User-facing runtime feature flags (the /flags page) ────────────────
//
// Unlike the migration constants above (module-level, flipped at build
// time by an engineer), these are RUNTIME toggles: the registry of every
// user-visible product feature, rendered at /flags where users switch
// features on/off. Core "basics" are locked always-on.
//
// Persistence v1 is per-device: overrides live in localStorage and are
// mirrored onto root state as `_featureFlags` so reactive `hide:`/CSS
// factories re-run on toggle. Server-side prefs sync (the
// homeDashboardPrefs `/core/prefs` route family) is the planned
// follow-up — keep the shape { [key]: boolean } so the same object can
// ride a prefs payload unchanged.
//
// Consumers gate surfaces with `featureEnabled(s.root, 'chat')` — core
// flags always return true, unknown keys default to ON (a missing
// registry entry must never dark-launch-hide a live feature).
// (2026-07-25 per Nika "build /flags page for all the feature flags that
// users can turn on and off … basics always on".)
const $ffd9522da8939bdf$export$96f17309eafe32fc = [
    {
        key: 'basics',
        label: 'flags.group.basics.label',
        description: 'flags.group.basics.descr'
    },
    {
        key: 'views',
        label: 'flags.group.views.label',
        description: 'flags.group.views.descr'
    },
    {
        key: 'modules',
        label: 'flags.group.modules.label',
        description: 'flags.group.modules.descr'
    },
    {
        key: 'ai',
        label: 'flags.group.ai.label',
        description: 'flags.group.ai.descr'
    },
    {
        key: 'apps',
        label: 'flags.group.apps.label',
        description: 'flags.group.apps.descr'
    }
];
const $ffd9522da8939bdf$export$9fdfd1d8755a4e44 = [
    // ── Basics — core: locked ON, the switch renders as an "Always on" pill.
    {
        key: 'shell',
        group: 'basics',
        core: true,
        label: 'flags.shell.label',
        description: 'flags.shell.descr'
    },
    {
        key: 'home',
        group: 'basics',
        core: true,
        label: 'flags.home.label',
        description: 'flags.home.descr'
    },
    {
        key: 'search',
        group: 'basics',
        core: true,
        label: 'flags.search.label',
        description: 'flags.search.descr'
    },
    {
        key: 'people',
        group: 'basics',
        core: true,
        label: 'flags.people.label',
        description: 'flags.people.descr'
    },
    {
        key: 'profile',
        group: 'basics',
        core: true,
        label: 'flags.profile.label',
        description: 'flags.profile.descr'
    },
    {
        key: 'notifications',
        group: 'basics',
        core: true,
        label: 'flags.notifications.label',
        description: 'flags.notifications.descr'
    },
    {
        key: 'theme',
        group: 'basics',
        core: true,
        label: 'flags.theme.label',
        description: 'flags.theme.descr'
    },
    {
        key: 'multiWorkspace',
        group: 'basics',
        core: true,
        label: 'flags.multiWorkspace.label',
        description: 'flags.multiWorkspace.descr'
    },
    // ── Canvas views
    {
        key: 'studio',
        group: 'views',
        label: 'flags.studio.label',
        description: 'flags.studio.descr'
    },
    {
        key: 'infra',
        group: 'views',
        label: 'flags.infra.label',
        description: 'flags.infra.descr'
    },
    {
        key: 'tasks',
        group: 'views',
        label: 'flags.tasks.label',
        description: 'flags.tasks.descr'
    },
    {
        key: 'agents',
        group: 'views',
        label: 'flags.agents.label',
        description: 'flags.agents.descr'
    },
    // ── Workspace modules
    {
        key: 'calendar',
        group: 'modules',
        label: 'flags.calendar.label',
        description: 'flags.calendar.descr'
    },
    {
        key: 'reminders',
        group: 'modules',
        label: 'flags.reminders.label',
        description: 'flags.reminders.descr'
    },
    // History — the built-in timeline of the workspace activity log. On by
    // default like the other built-in modules; gates the navbar rows, the
    // launcher tile and the /history route through ROUTE_FLAGS below.
    {
        key: 'history',
        group: 'modules',
        label: 'flags.history.label',
        description: 'flags.history.descr'
    },
    {
        key: 'chat',
        group: 'modules',
        label: 'flags.chat.label',
        description: 'flags.chat.descr'
    },
    // Dark by default — the FIRST flag in this registry with
    // `defaultOn: false`. `featureEnabled` reads `def.defaultOn !== false`, so
    // Mail stays off (header button, navbar entries and the /mail route all
    // hidden) until an admin turns it on at /flags. Every other module ships
    // on, so omitting the key would have shipped Mail live to every workspace.
    {
        key: 'mail',
        group: 'modules',
        defaultOn: false,
        label: 'flags.mail.label',
        description: 'flags.mail.descr'
    },
    {
        key: 'meet',
        group: 'modules',
        label: 'flags.meet.label',
        description: 'flags.meet.descr'
    },
    {
        key: 'documents',
        group: 'modules',
        label: 'flags.documents.label',
        description: 'flags.documents.descr'
    },
    {
        key: 'files',
        group: 'modules',
        label: 'flags.files.label',
        description: 'flags.files.descr'
    },
    {
        key: 'resolutions',
        group: 'modules',
        label: 'flags.resolutions.label',
        description: 'flags.resolutions.descr'
    },
    {
        key: 'analytics',
        group: 'modules',
        label: 'flags.analytics.label',
        description: 'flags.analytics.descr'
    },
    {
        key: 'data',
        group: 'modules',
        label: 'flags.data.label',
        description: 'flags.data.descr'
    },
    {
        key: 'announcements',
        group: 'modules',
        label: 'flags.announcements.label',
        description: 'flags.announcements.descr'
    },
    {
        key: 'company',
        group: 'modules',
        label: 'flags.company.label',
        description: 'flags.company.descr'
    },
    // ── AI & collaboration
    {
        key: 'aiAssistant',
        group: 'ai',
        label: 'flags.aiAssistant.label',
        description: 'flags.aiAssistant.descr'
    },
    {
        key: 'realtime',
        group: 'ai',
        label: 'flags.realtime.label',
        description: 'flags.realtime.descr'
    },
    {
        key: 'splitView',
        group: 'ai',
        label: 'flags.splitView.label',
        description: 'flags.splitView.descr'
    },
    // ── Marketplace & apps
    {
        key: 'marketplace',
        group: 'apps',
        label: 'flags.marketplace.label',
        description: 'flags.marketplace.descr'
    },
    {
        key: 'communityFeed',
        group: 'apps',
        label: 'flags.communityFeed.label',
        description: 'flags.communityFeed.descr'
    },
    {
        key: 'promptGallery',
        group: 'apps',
        label: 'flags.promptGallery.label',
        description: 'flags.promptGallery.descr'
    },
    {
        key: 'workspaceApps',
        group: 'apps',
        label: 'flags.workspaceApps.label',
        description: 'flags.workspaceApps.descr'
    },
    {
        key: 'customApps',
        group: 'apps',
        label: 'flags.customApps.label',
        description: 'flags.customApps.descr'
    },
    // AI-written apps run in an opaque sandbox frame instead of the shell
    // (ISOLATED-RUNTIME-PLAN §8, workspace functions/generatedAppSandbox.js).
    // OFF by default until the 2026-10-10 review; a TOP-LEVEL flag on purpose:
    // a security switch must not turn off with an unrelated parent.
    {
        key: 'appsSandbox',
        group: 'apps',
        defaultOn: false,
        label: 'flags.appsSandbox.label',
        description: 'flags.appsSandbox.descr'
    }
];
const $ffd9522da8939bdf$export$f5f3ea3c7409aaa3 = {
    shell: [
        {
            key: 'keyboardShortcuts',
            label: 'flags.shellKeyboardShortcuts.label',
            description: 'flags.shellKeyboardShortcuts.descr'
        },
        {
            key: 'moduleTabs',
            label: 'flags.shellModuleTabs.label',
            description: 'flags.shellModuleTabs.descr'
        },
        {
            key: 'contextMenus',
            label: 'flags.shellContextMenus.label',
            description: 'flags.shellContextMenus.descr'
        }
    ],
    home: [
        {
            key: 'widgets',
            label: 'flags.homeWidgets.label',
            description: 'flags.homeWidgets.descr'
        },
        {
            key: 'appIcons',
            label: 'flags.homeAppIcons.label',
            description: 'flags.homeAppIcons.descr'
        },
        {
            key: 'agentsWidget',
            label: 'flags.homeAgentsWidget.label',
            description: 'flags.homeAgentsWidget.descr'
        },
        {
            key: 'analyticsWidget',
            label: 'flags.homeAnalyticsWidget.label',
            description: 'flags.homeAnalyticsWidget.descr'
        },
        {
            key: 'eventsWidget',
            label: 'flags.homeEventsWidget.label',
            description: 'flags.homeEventsWidget.descr'
        },
        {
            key: 'chatRail',
            label: 'flags.homeChatRail.label',
            description: 'flags.homeChatRail.descr'
        }
    ],
    search: [
        {
            key: 'commandSearch',
            label: 'flags.searchCommandSearch.label',
            description: 'flags.searchCommandSearch.descr'
        },
        {
            key: 'appsLauncher',
            label: 'flags.searchAppsLauncher.label',
            description: 'flags.searchAppsLauncher.descr'
        },
        {
            key: 'headerMorph',
            label: 'flags.searchHeaderMorph.label',
            description: 'flags.searchHeaderMorph.descr'
        }
    ],
    people: [
        {
            key: 'memberProfiles',
            label: 'flags.peopleMemberProfiles.label',
            description: 'flags.peopleMemberProfiles.descr'
        },
        {
            key: 'roleManagement',
            label: 'flags.peopleRoleManagement.label',
            description: 'flags.peopleRoleManagement.descr'
        },
        {
            key: 'invites',
            label: 'flags.peopleInvites.label',
            description: 'flags.peopleInvites.descr'
        }
    ],
    notifications: [
        {
            key: 'feed',
            label: 'flags.notificationsFeed.label',
            description: 'flags.notificationsFeed.descr'
        },
        {
            key: 'unreadBadges',
            label: 'flags.notificationsUnreadBadges.label',
            description: 'flags.notificationsUnreadBadges.descr'
        }
    ],
    theme: [
        {
            key: 'systemSync',
            label: 'flags.themeSystemSync.label',
            description: 'flags.themeSystemSync.descr'
        },
        {
            key: 'workspaceSkins',
            label: 'flags.themeWorkspaceSkins.label',
            description: 'flags.themeWorkspaceSkins.descr'
        }
    ],
    multiWorkspace: [
        {
            key: 'workspaceUrls',
            label: 'flags.multiWorkspaceWorkspaceUrls.label',
            description: 'flags.multiWorkspaceWorkspaceUrls.descr'
        },
        {
            key: 'orgSwitcher',
            label: 'flags.multiWorkspaceOrgSwitcher.label',
            description: 'flags.multiWorkspaceOrgSwitcher.descr'
        }
    ],
    studio: [
        {
            key: 'studiosBoards',
            label: 'flags.studioStudiosBoards.label',
            description: 'flags.studioStudiosBoards.descr'
        },
        {
            key: 'projectThumbnails',
            label: 'flags.studioProjectThumbnails.label',
            description: 'flags.studioProjectThumbnails.descr'
        },
        {
            key: 'canvasSidebars',
            label: 'flags.studioCanvasSidebars.label',
            description: 'flags.studioCanvasSidebars.descr'
        },
        {
            key: 'projectCreation',
            label: 'flags.studioProjectCreation.label',
            description: 'flags.studioProjectCreation.descr'
        }
    ],
    infra: [
        {
            key: 'statusPage',
            label: 'flags.infraStatusPage.label',
            description: 'flags.infraStatusPage.descr'
        },
        {
            key: 'servicesList',
            label: 'flags.infraServicesList.label',
            description: 'flags.infraServicesList.descr'
        },
        {
            key: 'environments',
            label: 'flags.infraEnvironments.label',
            description: 'flags.infraEnvironments.descr'
        }
    ],
    tasks: [
        {
            key: 'myView',
            label: 'flags.tasksMyView.label',
            description: 'flags.tasksMyView.descr'
        },
        {
            key: 'standups',
            label: 'flags.tasksStandups.label',
            description: 'flags.tasksStandups.descr'
        },
        {
            key: 'feed',
            label: 'flags.tasksFeed.label',
            description: 'flags.tasksFeed.descr'
        },
        {
            key: 'features',
            label: 'flags.tasksFeatures.label',
            description: 'flags.tasksFeatures.descr'
        },
        {
            key: 'planning',
            label: 'flags.tasksPlanning.label',
            description: 'flags.tasksPlanning.descr'
        },
        {
            key: 'typeFilters',
            label: 'flags.tasksTypeFilters.label',
            description: 'flags.tasksTypeFilters.descr'
        },
        {
            key: 'generalTriage',
            label: 'flags.tasksGeneralTriage.label',
            description: 'flags.tasksGeneralTriage.descr'
        },
        {
            key: 'githubSync',
            label: 'flags.tasksGithubSync.label',
            description: 'flags.tasksGithubSync.descr'
        },
        {
            key: 'teamAgentLenses',
            label: 'flags.tasksTeamAgentLenses.label',
            description: 'flags.tasksTeamAgentLenses.descr'
        }
    ],
    agents: [
        {
            key: 'myAgents',
            label: 'flags.agentsMyAgents.label',
            description: 'flags.agentsMyAgents.descr'
        },
        {
            key: 'assignments',
            label: 'flags.agentsAssignments.label',
            description: 'flags.agentsAssignments.descr'
        },
        {
            key: 'permissions',
            label: 'flags.agentsPermissions.label',
            description: 'flags.agentsPermissions.descr'
        },
        {
            key: 'tools',
            label: 'flags.agentsTools.label',
            description: 'flags.agentsTools.descr'
        }
    ],
    calendar: [
        {
            key: 'miniCalendar',
            label: 'flags.calendarMiniCalendar.label',
            description: 'flags.calendarMiniCalendar.descr'
        },
        {
            key: 'monthWeekViews',
            label: 'flags.calendarMonthWeekViews.label',
            description: 'flags.calendarMonthWeekViews.descr'
        },
        {
            key: 'teamView',
            label: 'flags.calendarTeamView.label',
            description: 'flags.calendarTeamView.descr'
        },
        {
            key: 'availability',
            label: 'flags.calendarAvailability.label',
            description: 'flags.calendarAvailability.descr'
        },
        {
            key: 'bookings',
            label: 'flags.calendarBookings.label',
            description: 'flags.calendarBookings.descr'
        },
        {
            key: 'reminders',
            label: 'flags.calendarReminders.label',
            description: 'flags.calendarReminders.descr'
        },
        {
            key: 'linkedResources',
            label: 'flags.calendarLinkedResources.label',
            description: 'flags.calendarLinkedResources.descr'
        }
    ],
    chat: [
        {
            key: 'channels',
            label: 'flags.chatChannels.label',
            description: 'flags.chatChannels.descr'
        },
        {
            key: 'directMessages',
            label: 'flags.chatDirectMessages.label',
            description: 'flags.chatDirectMessages.descr'
        },
        {
            key: 'threads',
            label: 'flags.chatThreads.label',
            description: 'flags.chatThreads.descr'
        },
        {
            key: 'messengerOverlay',
            label: 'flags.chatMessengerOverlay.label',
            description: 'flags.chatMessengerOverlay.descr'
        },
        {
            key: 'chatDrawer',
            label: 'flags.chatChatDrawer.label',
            description: 'flags.chatChatDrawer.descr'
        }
    ],
    meet: [
        {
            key: 'transcripts',
            label: 'flags.meetTranscripts.label',
            description: 'flags.meetTranscripts.descr'
        },
        {
            key: 'liveCaptions',
            label: 'flags.meetLiveCaptions.label',
            description: 'flags.meetLiveCaptions.descr'
        },
        {
            key: 'rooms',
            label: 'flags.meetRooms.label',
            description: 'flags.meetRooms.descr'
        },
        {
            key: 'guestLinks',
            label: 'flags.meetGuestLinks.label',
            description: 'flags.meetGuestLinks.descr'
        }
    ],
    documents: [
        {
            key: 'knowledgeBase',
            label: 'flags.documentsKnowledgeBase.label',
            description: 'flags.documentsKnowledgeBase.descr'
        },
        {
            key: 'notes',
            label: 'flags.documentsNotes.label',
            description: 'flags.documentsNotes.descr'
        },
        {
            key: 'editor',
            label: 'flags.documentsEditor.label',
            description: 'flags.documentsEditor.descr'
        },
        {
            key: 'collabEditing',
            label: 'flags.documentsCollabEditing.label',
            description: 'flags.documentsCollabEditing.descr'
        },
        {
            key: 'exportTools',
            label: 'flags.documentsExportTools.label',
            description: 'flags.documentsExportTools.descr'
        }
    ],
    files: [
        {
            key: 'folders',
            label: 'flags.filesFolders.label',
            description: 'flags.filesFolders.descr'
        },
        {
            key: 'desktopGrid',
            label: 'flags.filesDesktopGrid.label',
            description: 'flags.filesDesktopGrid.descr'
        }
    ],
    resolutions: [
        {
            key: 'requests',
            label: 'flags.resolutionsRequests.label',
            description: 'flags.resolutionsRequests.descr'
        },
        {
            key: 'improvements',
            label: 'flags.resolutionsImprovements.label',
            description: 'flags.resolutionsImprovements.descr'
        },
        {
            key: 'editRequests',
            label: 'flags.resolutionsEditRequests.label',
            description: 'flags.resolutionsEditRequests.descr'
        },
        {
            key: 'audit',
            label: 'flags.resolutionsAudit.label',
            description: 'flags.resolutionsAudit.descr'
        }
    ],
    analytics: [
        {
            key: 'projectAnalytics',
            label: 'flags.analyticsProjectAnalytics.label',
            description: 'flags.analyticsProjectAnalytics.descr'
        },
        {
            key: 'workspaceUsage',
            label: 'flags.analyticsWorkspaceUsage.label',
            description: 'flags.analyticsWorkspaceUsage.descr'
        },
        {
            key: 'liveMap',
            label: 'flags.analyticsLiveMap.label',
            description: 'flags.analyticsLiveMap.descr'
        },
        {
            key: 'logs',
            label: 'flags.analyticsLogs.label',
            description: 'flags.analyticsLogs.descr'
        },
        {
            key: 'bugsFeed',
            label: 'flags.analyticsBugsFeed.label',
            description: 'flags.analyticsBugsFeed.descr'
        },
        {
            key: 'sessionsExplorer',
            label: 'flags.analyticsSessionsExplorer.label',
            description: 'flags.analyticsSessionsExplorer.descr'
        }
    ],
    data: [
        {
            key: 'users',
            label: 'flags.dataUsers.label',
            description: 'flags.dataUsers.descr'
        },
        {
            key: 'organizations',
            label: 'flags.dataOrganizations.label',
            description: 'flags.dataOrganizations.descr'
        },
        {
            key: 'projects',
            label: 'flags.dataProjects.label',
            description: 'flags.dataProjects.descr'
        },
        {
            key: 'plans',
            label: 'flags.dataPlans.label',
            description: 'flags.dataPlans.descr'
        },
        {
            key: 'teams',
            label: 'flags.dataTeams.label',
            description: 'flags.dataTeams.descr'
        },
        {
            key: 'externalSources',
            label: 'flags.dataExternalSources.label',
            description: 'flags.dataExternalSources.descr'
        }
    ],
    announcements: [
        {
            key: 'polls',
            label: 'flags.announcementsPolls.label',
            description: 'flags.announcementsPolls.descr'
        },
        {
            key: 'tagFilters',
            label: 'flags.announcementsTagFilters.label',
            description: 'flags.announcementsTagFilters.descr'
        }
    ],
    company: [
        {
            key: 'profileEditing',
            label: 'flags.companyProfileEditing.label',
            description: 'flags.companyProfileEditing.descr'
        }
    ],
    aiAssistant: [
        {
            key: 'composer',
            label: 'flags.aiAssistantComposer.label',
            description: 'flags.aiAssistantComposer.descr'
        },
        {
            key: 'answerViews',
            label: 'flags.aiAssistantAnswerViews.label',
            description: 'flags.aiAssistantAnswerViews.descr'
        },
        {
            key: 'buildApps',
            label: 'flags.aiAssistantBuildApps.label',
            description: 'flags.aiAssistantBuildApps.descr'
        },
        {
            key: 'pageAwareness',
            label: 'flags.aiAssistantPageAwareness.label',
            description: 'flags.aiAssistantPageAwareness.descr'
        },
        {
            key: 'reasoningTimeline',
            label: 'flags.aiAssistantReasoningTimeline.label',
            description: 'flags.aiAssistantReasoningTimeline.descr'
        },
        {
            key: 'suggestionChips',
            label: 'flags.aiAssistantSuggestionChips.label',
            description: 'flags.aiAssistantSuggestionChips.descr'
        },
        {
            key: 'moduleAi',
            label: 'flags.aiAssistantModuleAi.label',
            description: 'flags.aiAssistantModuleAi.descr'
        }
    ],
    realtime: [
        {
            key: 'presence',
            label: 'flags.realtimePresence.label',
            description: 'flags.realtimePresence.descr'
        },
        {
            key: 'onlineDock',
            label: 'flags.realtimeOnlineDock.label',
            description: 'flags.realtimeOnlineDock.descr'
        },
        {
            key: 'collabSessions',
            label: 'flags.realtimeCollabSessions.label',
            description: 'flags.realtimeCollabSessions.descr'
        }
    ],
    splitView: [
        {
            key: 'appWindows',
            label: 'flags.splitViewAppWindows.label',
            description: 'flags.splitViewAppWindows.descr'
        },
        {
            key: 'splitPane',
            label: 'flags.splitViewSplitPane.label',
            description: 'flags.splitViewSplitPane.descr'
        },
        {
            key: 'fullscreenMode',
            label: 'flags.splitViewFullscreenMode.label',
            description: 'flags.splitViewFullscreenMode.descr'
        },
        {
            key: 'pageRestore',
            label: 'flags.splitViewPageRestore.label',
            description: 'flags.splitViewPageRestore.descr'
        }
    ],
    marketplace: [
        {
            key: 'featured',
            label: 'flags.marketplaceFeatured.label',
            description: 'flags.marketplaceFeatured.descr'
        },
        {
            key: 'detailGallery',
            label: 'flags.marketplaceDetailGallery.label',
            description: 'flags.marketplaceDetailGallery.descr'
        },
        {
            key: 'livePreviews',
            label: 'flags.marketplaceLivePreviews.label',
            description: 'flags.marketplaceLivePreviews.descr'
        }
    ],
    communityFeed: [
        {
            key: 'comments',
            label: 'flags.communityFeedComments.label',
            description: 'flags.communityFeedComments.descr'
        },
        {
            key: 'follows',
            label: 'flags.communityFeedFollows.label',
            description: 'flags.communityFeedFollows.descr'
        },
        {
            key: 'shareComposer',
            label: 'flags.communityFeedShareComposer.label',
            description: 'flags.communityFeedShareComposer.descr'
        }
    ],
    promptGallery: [
        {
            key: 'copyActions',
            label: 'flags.promptGalleryCopyActions.label',
            description: 'flags.promptGalleryCopyActions.descr'
        }
    ],
    workspaceApps: [
        {
            key: 'crm',
            label: 'flags.workspaceAppsCrm.label',
            description: 'flags.workspaceAppsCrm.descr'
        },
        {
            key: 'hr',
            label: 'flags.workspaceAppsHr.label',
            description: 'flags.workspaceAppsHr.descr'
        },
        {
            key: 'commerce',
            label: 'flags.workspaceAppsCommerce.label',
            description: 'flags.workspaceAppsCommerce.descr'
        },
        {
            key: 'scheduling',
            label: 'flags.workspaceAppsScheduling.label',
            description: 'flags.workspaceAppsScheduling.descr'
        },
        {
            key: 'cms',
            label: 'flags.workspaceAppsCms.label',
            description: 'flags.workspaceAppsCms.descr'
        },
        {
            key: 'financials',
            label: 'flags.workspaceAppsFinancials.label',
            description: 'flags.workspaceAppsFinancials.descr'
        }
    ],
    customApps: [
        {
            key: 'aiBuilt',
            label: 'flags.customAppsAiBuilt.label',
            description: 'flags.customAppsAiBuilt.descr'
        },
        {
            key: 'sharing',
            label: 'flags.customAppsSharing.label',
            description: 'flags.customAppsSharing.descr'
        }
    ]
};
const $ffd9522da8939bdf$export$1e3fa289c11cc7 = $ffd9522da8939bdf$export$9fdfd1d8755a4e44.map((f)=>$ffd9522da8939bdf$export$f5f3ea3c7409aaa3[f.key] ? {
        ...f,
        subs: $ffd9522da8939bdf$export$f5f3ea3c7409aaa3[f.key]
    } : f);
// Flat lookup over parents AND dotted sub-keys (`tasks.standups`), built
// once at module-init time — sub entries carry `parentKey` so featureEnabled
// can gate through the parent. Also pure module-init-time code, not a
// function body.
function $ffd9522da8939bdf$var$buildFlagIndex() {
    const map = {};
    $ffd9522da8939bdf$export$1e3fa289c11cc7.forEach((f)=>{
        map[f.key] = f;
        (f.subs || []).forEach((sub)=>{
            map[`${f.key}.${sub.key}`] = {
                ...sub,
                key: `${f.key}.${sub.key}`,
                parentKey: f.key
            };
        });
    });
    return map;
}
const $ffd9522da8939bdf$export$598cb7508de11bf8 = $ffd9522da8939bdf$var$buildFlagIndex();
const $ffd9522da8939bdf$export$7ddb87109dcd28a1 = [
    [
        '/studio',
        'studio'
    ],
    [
        '/canvas',
        'studio'
    ],
    // The Workspace apps view of the Apps hub (docs/APP_SPLIT.md) — the same
    // product surface as /studio, so the same flag.
    [
        '/apps',
        'studio'
    ],
    [
        '/infra',
        'infra'
    ],
    // /tasks is the canonical route (tickets→tasks rename 2026-08-06 per
    // Nika); the /tickets* forms stay as inbound legacy aliases.
    [
        '/tasks-page',
        'tasks'
    ],
    [
        '/tasks',
        'tasks'
    ],
    [
        '/task',
        'tasks'
    ],
    [
        '/tickets-page',
        'tasks'
    ],
    [
        '/tickets',
        'tasks'
    ],
    [
        '/ticket',
        'tasks'
    ],
    [
        '/team-and-agents',
        'agents'
    ],
    [
        '/my-agents',
        'agents'
    ],
    [
        '/agents',
        'agents'
    ],
    [
        '/calendar',
        'calendar'
    ],
    [
        '/reminders',
        'reminders'
    ],
    [
        '/history',
        'history'
    ],
    [
        '/chat',
        'chat'
    ],
    [
        '/mail',
        'mail'
    ],
    [
        '/meet',
        'meet'
    ],
    // /notes is the canonical route (documents→notes rename 2026-08-06); the
    // flag key stays the internal 'documents'. '/documents' = legacy alias.
    [
        '/notes',
        'documents'
    ],
    [
        '/documents',
        'documents'
    ],
    [
        '/files',
        'files'
    ],
    [
        '/resolutions',
        'resolutions'
    ],
    [
        '/workspace-analytics',
        'analytics'
    ],
    [
        '/analytics',
        'analytics'
    ],
    [
        '/logs',
        'analytics'
    ],
    [
        '/data',
        'data'
    ],
    [
        '/announcements',
        'announcements'
    ],
    [
        '/company',
        'company'
    ],
    [
        '/marketplace/prompt-gallery',
        'promptGallery'
    ],
    [
        '/marketplace/feed',
        'communityFeed'
    ],
    [
        '/marketplace',
        'marketplace'
    ],
    [
        '/feed',
        'communityFeed'
    ],
    [
        '/add-app',
        'customApps'
    ],
    // Installed workspace-app routes (system catalog apps).
    [
        '/crm',
        'workspaceApps.crm'
    ],
    [
        '/contacts',
        'workspaceApps.crm'
    ],
    [
        '/hr',
        'workspaceApps.hr'
    ],
    [
        '/commerce',
        'workspaceApps.commerce'
    ],
    [
        '/scheduling',
        'workspaceApps.scheduling'
    ],
    [
        '/cms',
        'workspaceApps.cms'
    ],
    [
        '/financials',
        'workspaceApps.financials'
    ]
];

});



parcelRegister("7aO1X", function(module, exports) {

$parcel$export(module.exports, "AiBubbleStack", () => $53904698b4b0af2e$export$aba822b56910ef89);
$parcel$export(module.exports, "AiCaptionBubble", () => $53904698b4b0af2e$export$81d6414c6ec04653);
// AiBubbleStack — THE WORDS ABOVE A BAR, AS BUBBLES (Nika 2026-10-28: "in
// minimized mode, captions should be like bubble and should not resize ai
// navbar" / "when AI asks for confirmation, in minimized mode its not
// visible").
//
// A bar — the minimized assistant island (SimoneReasoningPill) or a composer
// that hosts a voice call (VoiceStrip) — is ONE row at the control height.
// What was said floats ABOVE it in this absolutely positioned column, so the
// bar never grows: the same height with no turn, one turn or ten, and while a
// reply streams. The column takes no layout space and no pointer of its own;
// only the bubbles do.
//
//   • BubbleCaptions — the newest two lines (each an AiCaptionBubble, below),
//     oldest first, so the newest sits nearest the bar: the person's line on
//     the right (one line), the
//     assistant's on the left (three lines; while it streams, its newest
//     words). The line before them fades out as a new one arrives. A press
//     opens the conversation: the thread for a text exchange, the call screen
//     for a call.
//   • AiAsk — what waits on the person while the thread is not on screen: a
//     step for the OK (the step, what it will write, Run · Skip · Run all on
//     the row's own settle) or a question for a pick (its prompt, one button
//     per option on the card's own writer), and a polite live region that
//     names it (_simone/AiAsk.js — the ONE ask; the full-screen call mounts it
//     too). It sits nearest the bar, so it never moves while the captions
//     above it change.
//
// Rows: a host may pass `turnsSource` (the island hands in its thread rows in
// the text posture — the VoiceLog contract); without it the call's own turns
// are read: `voiceTurns`, then the live partial as the person's streaming line.
//
// Every factory is self-contained and every helper lives in `scope` (FA204 —
// frank serializes each factory on its own).
const $53904698b4b0af2e$export$aba822b56910ef89 = {
    scope: {
        // The call's lines: the engine-agnostic turns (an `action` kind is a
        // command result), then what the engine hears right now.
        voiceRows (root) {
            const r = root || {};
            const turns = Array.isArray(r.voiceTurns) ? r.voiceTurns : [];
            const out = [];
            for(let i = 0; i < turns.length; i++){
                const t = turns[i];
                const text = t && typeof t.text === 'string' ? t.text.trim() : '';
                if (!text) continue;
                out.push({
                    id: String(t.id || 'vt' + i),
                    role: t.kind === 'action' ? 'action' : t.role === 'user' ? 'user' : 'agent',
                    text: text,
                    streaming: !!t.streaming
                });
            }
            const heard = typeof r.voiceInterim === 'string' ? r.voiceInterim.trim() : '';
            if (heard) out.push({
                id: 'voice-interim',
                role: 'user',
                text: heard,
                streaming: true
            });
            return out;
        },
        // The bubbles on show: the newest two lines plus the one before them,
        // marked `older` — it fades out where it stands instead of vanishing when
        // a new line pushes it off. `stack` is the AiBubbleStack element (it
        // carries the host's `turnsSource`).
        captions (stack, s) {
            const src = stack && stack.turnsSource;
            const own = typeof src === 'function' ? src(stack, s) : src;
            const thread = Array.isArray(own);
            const rows = thread ? own : this.voiceRows(s && s.root);
            const tail = rows.slice(-3);
            return tail.map((row, i)=>({
                    key: 'cap-' + String(row.id || i),
                    id: String(row.id || i),
                    role: row.role === 'user' ? 'user' : row.role === 'action' ? 'action' : 'agent',
                    text: String(row.text || ''),
                    streaming: !!row.streaming,
                    source: thread ? 'thread' : 'voice',
                    older: tail.length === 3 && i === 0
                }));
        }
    },
    // Above the bar's top edge, as wide as the bar, never in its flow. Above the
    // island's full-surface hit area and its trailing buttons (z 1 and 2).
    position: 'absolute',
    left: '0',
    right: '0',
    bottom: '100%',
    zIndex: '3',
    flow: 'y',
    align: 'stretch flex-end',
    gap: 'Y',
    paddingBottom: 'Z',
    pointerEvents: 'none',
    textAlign: 'left',
    BubbleCaptions: {
        flow: 'y',
        align: 'flex-start flex-end',
        gap: 'Y',
        minWidth: '0',
        childrenAs: 'state',
        children: (el, s)=>el.scope.captions(el.parent, s),
        childExtends: 'AiCaptionBubble'
    },
    // The ask, nearest the bar: the shared component (its card and its live
    // region sit in this column's flow — its wrapper is `display: contents`).
    AiAsk: {}
};
const $53904698b4b0af2e$export$81d6414c6ec04653 = {
    scope: {
        // One bubble's words: whitespace folded and the loudest markdown marks
        // dropped (a caption is a line, not a document). The assistant's line
        // carries the ellipsis while it streams; the person's live partial keeps
        // its newest words.
        captionText (row) {
            const text = String(row && row.text || '').replace(/\*\*|__|`/g, '').replace(/(^|\s)#{1,6}\s/g, '$1').replace(/\s+/g, ' ').trim();
            if (!row || !row.streaming) return text;
            if (row.role === 'user') return text.length > 64 ? "\u2026" + text.slice(-63) : text;
            return text + "\u2026";
        },
        // A press on a line opens the conversation it belongs to. A call → the
        // call screen (voiceExpand). The thread → the drawer, exactly as a press
        // on the bar itself does: a minimized dock moves to the right edge for
        // the session (never the saved placement — "Open in main" is the head's
        // own explicit move), the slot handle retires, and a landed answer is
        // read. Every shell move is guarded (the standalone canvas has none).
        openCaption (el, s) {
            const root = s && s.root;
            if (!root || typeof root.update !== 'function') return;
            const fns = el.context && el.context.functions || {};
            if (s.source === 'voice') {
                if (typeof fns.voiceExpand === 'function') el.call('voiceExpand');
                return;
            }
            const patch = {
                assistantOpen: true
            };
            if (root._assistantPillHandle) patch._assistantPillHandle = false;
            if (root.assistantDock === 'minimized') patch.assistantDock = 'right';
            root.update(patch);
            if (typeof fns.assistantAnswerPopoverDismiss === 'function') el.call('assistantAnswerPopoverDismiss');
        }
    },
    tag: 'button',
    type: 'button',
    display: 'block',
    minWidth: '0',
    maxWidth: (el, s)=>s.role === 'user' ? '80%' : '100%',
    alignSelf: (el, s)=>s.role === 'user' ? 'flex-end' : 'flex-start',
    padding: 'Y Z1',
    theme: 'dialog',
    shadow: 'float',
    round: 'radiusCard',
    borderWidth: '0',
    textAlign: 'left',
    fontSize: 'Z1',
    lineHeight: '1.45',
    color: (el, s)=>s.role === 'user' ? 'paragraph' : 'title',
    cursor: 'pointer',
    pointerEvents: 'auto',
    // The house enter for a new line; the line that is pushed off fades where
    // it stands (opacity, never a jump) and leaves the tab order. A line that
    // mounts already pushed off never enters at all.
    animationName: 'fadeInUpShort',
    animationDuration: 'B',
    transition: 'B opacity defaultBezier, A background-color defaultBezier',
    // A fill step that stays OPAQUE over the page: the ink mixed into the
    // sheet's own ground (`tintBase` is the dialog fill in both schemes).
    ':hover': {
        background: 'color-mix(in srgb, currentColor 6%, var(--color-tintBase))'
    },
    ':active': {
        background: 'color-mix(in srgb, currentColor 10%, var(--color-tintBase))'
    },
    isOlder: (el, s)=>!!s.older,
    '.isOlder': {
        opacity: '0',
        pointerEvents: 'none',
        animationName: 'none'
    },
    tabindex: (el, s)=>s.older ? '-1' : '0',
    aria: {
        hidden: (el, s)=>s.older ? 'true' : null
    },
    // The overflow law: a clamped line carries its whole text in the title.
    title: (el, s)=>el.scope.captionText({
            text: s.text
        }),
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.scope.openCaption(el, s);
    },
    BubbleWords: {
        tag: 'span',
        display: 'block',
        overflowWrap: 'anywhere',
        lineClamp: (el, s)=>s.role === 'user' ? 1 : 3,
        text: (el, s)=>el.scope.captionText(s),
        // While the assistant streams, the box shows its NEWEST three lines: a
        // bottom-aligned column clips its overflow at the top.
        isTail: (el, s)=>!!s.streaming && s.role !== 'user',
        '.isTail': {
            lineClamp: 'none',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            maxHeight: '3lh',
            overflow: 'hidden'
        }
    }
};

});

parcelRegister("ewdVg", function(module, exports) {

$parcel$export(module.exports, "AiAsk", () => $a91eda94da3be59d$export$e296e01cea6e93d3);
// AiAsk — WHAT WAITS ON THE PERSON, wherever the thread is not on screen
// (Nika 2026-10-28: "when AI asks for confirmation, in minimized mode its not
// visible" — the same class in the voice call: "the ask must show in the call
// (Run · Skip)" — and the coordinator's W7 live finding the same day: an
// ask_user question was invisible in the minimized island, which read
// "Answer ready" while the question waited).
//
// Two kinds of ask stop a turn on the person, and the thread asks both in
// place:
//   • an APPROVAL — the client gate parks a write the AI wants to make
//     (simoneAiTransport.runClientToolWithAuth): its tool row turns
//     `status: 'approval'`, and the row's own Run · Skip · Run all answer it;
//   • a QUESTION — ask_user hangs a confirm/choice card on the message
//     (simoneAiTransport askUser), and the thread's ChatCard buttons answer it
//     through resolveChatCard(cardId, value, label).
// This asks everywhere else — ONE component, mounted where a surface hides
// the thread:
//   • above the minimized island and a composer's call strip (AiBubbleStack
//     mounts it nearest the bar);
//   • on the full-screen voice call (VoiceOverlay's column): the island and
//     the strip are hidden while the call screen is up, and the live agent
//     keeps it up for its whole ask, so nothing else would show the ask.
//
//   • AskCard — a group named by the ask's words: "Needs your OK" or
//     "Waiting for your choice", the thread's own. An approval: the step in
//     the tool row's own words, one line of what it will write, and Run ·
//     Skip · Run all on the SAME settle path as the row's own buttons
//     (resolveAiToolApproval / approveAllAiToolsForTurn). A question: its
//     prompt and one button per option — the card's own labels and values, by
//     the ONE rule the thread card reads (functions/askCardOptions) — then
//     the card's two other paths (coordinator F2, 2026-10-28): Write my own
//     (a choice) or Edit (a confirm) opens a field, where Enter or Send
//     answers in the person's own words and Escape goes back. All on the
//     SAME writer as the card's (resolveChatCard, with the card's own
//     `extra`). Off while the thread is on screen (it asks there) — never
//     under the call screen, which covers the thread.
//   • AskAnnounce — a polite live region, always in the tree, that says
//     "Needs your OK: <step>" or "Waiting for your choice: <question>" when an
//     ask appears. Nothing here takes focus on its own (the thread's
//     question does); the field takes it when the person opens it.
//
// The wrapper is `display: contents`: the card and the region sit in the
// host's own flow (the stack's column, the call's column) as if they were its
// children, so an empty ask adds no box and no gap.
//
// Every factory is self-contained and every helper lives in `scope` (FA204 —
// frank serializes each factory on its own). Each helper reads its root keys
// up front, before any branch (FA515: a short-circuit drops a subscription).
const $a91eda94da3be59d$export$e296e01cea6e93d3 = {
    scope: {
        // The thread the ask reads first: the VOICE thread while a call is open
        // (`voiceChatKey`, the prefix VoiceLog reads — a call can run in the
        // add-app or the dashboard thread), else the general one.
        threadKey (root) {
            const r = root || {};
            const open = r.voiceOpen;
            const key = r.voiceChatKey;
            return open && typeof key === 'string' ? key : '';
        },
        // What waits on the person in one thread, or null — the newest ask among
        // the assistant messages after the person's last line (a new line closes
        // both kinds: simoneAiTransport.supersedeParkedAiToolApprovals):
        // { kind: 'approval', tool } — a step parked for the OK — or
        // { kind: 'choice', card } — a question's card nobody answered yet.
        // Read from the thread, not from the live id: a late ask lands on the
        // newest assistant message after the turn's id cleared
        // (simoneAiTransport._patchToolActivity), and it still holds the server's
        // loop. Mirrors SimoneReasoningPill.scope.approvalTool / choiceCard (the
        // island's head) and VoiceOverlay.scope.heldAsk (the voice says it).
        waitingIn (msgs) {
            const list = Array.isArray(msgs) ? msgs : [];
            for(let i = list.length - 1; i >= 0; i--){
                const m = list[i];
                if (!m) continue;
                if (m.role === 'user') return null;
                if (m.role !== 'assistant') continue;
                const tools = Array.isArray(m.tools) ? m.tools : [];
                for(let j = tools.length - 1; j >= 0; j--){
                    if (tools[j] && tools[j].status === 'approval') return {
                        kind: 'approval',
                        tool: tools[j]
                    };
                }
                const cards = Array.isArray(m.cards) ? m.cards : [];
                for(let j = cards.length - 1; j >= 0; j--){
                    const c = cards[j];
                    const asks = !!c && (c.type === 'choice' || c.type === 'confirm');
                    if (asks && c._cardId && !c._resolved) return {
                        kind: 'choice',
                        card: c
                    };
                }
            }
            return null;
        },
        // The ask: in the call's thread first, then the general one.
        pending (root) {
            const r = root || {};
            const k = this.threadKey(r);
            const own = this.waitingIn(r[k + 'chatMessages']);
            const general = k ? this.waitingIn(r.chatMessages) : null;
            return own || general;
        },
        approvalTool (root) {
            const ask = this.pending(root);
            return ask && ask.kind === 'approval' ? ask.tool : null;
        },
        choiceCard (root) {
            const ask = this.pending(root);
            return ask && ask.kind === 'choice' ? ask.card : null;
        },
        // The thread is on screen — the drawer docked open, or the main thread —
        // and it already asks there. Never while the full-screen call is up: the
        // call covers the thread.
        threadOnScreen (root) {
            const r = root || {};
            const open = r.voiceOpen;
            const minimized = r.voiceMinimized;
            const host = r.voiceHost;
            const drawer = r.assistantOpen;
            const dock = r.assistantDock;
            const home = r._homeThreadOpen;
            if (open && !minimized && !host) return false;
            return !!(drawer && dock !== 'minimized' || home);
        },
        askShown (root) {
            const ask = this.pending(root);
            const covered = this.threadOnScreen(root);
            return !!ask && !covered;
        },
        // The ask's words — the thread's own: "Needs your OK" for a step
        // (ChatMessage, the island's head), "Waiting for your choice" for a
        // question (the ask_user tool row).
        askWord (el, root) {
            root && root.lang;
            const card = this.choiceCard(root);
            return el.call('polyglot', card ? 'ai.toolStep.choose' : 'ai.chat.needsOk');
        },
        // The question in its own words (the card's prompt), or ''.
        promptOf (root) {
            const card = this.choiceCard(root);
            return card && typeof card.prompt === 'string' ? card.prompt.trim() : '';
        },
        // What the live region says first: the ask's words, and a colon when the
        // step or the question follows them.
        announceHead (el, root) {
            const shown = this.askShown(root);
            const tool = this.approvalTool(root);
            const prompt = this.promptOf(root);
            if (!shown) return '';
            const word = this.askWord(el, root);
            return tool || prompt ? word + ': ' : word;
        },
        // One line of what the step will write: the first line of its body, else
        // its title. Positional arguments (an app verb) give their first text.
        preview (tool) {
            const a = tool && tool.args;
            if (!a || typeof a !== 'object') return '';
            const first = (v)=>{
                if (typeof v !== 'string') return '';
                const line = v.split('\n').map((x)=>x.replace(/^[\s#>*-]+/, '').trim()).find(Boolean);
                return line ? line.length > 160 ? line.slice(0, 159) + "\u2026" : line : '';
            };
            const list = Array.isArray(a) ? a : Array.isArray(a.args) ? a.args : null;
            if (list) {
                for (const v of list){
                    const line = first(v);
                    if (line) return line;
                }
                return '';
            }
            const keys = [
                'content',
                'body',
                'text',
                'description',
                'message',
                'prompt'
            ];
            const names = [
                'title',
                'name',
                'summary',
                'query',
                'subject'
            ];
            for (const k of keys.concat(names)){
                const line = first(a[k]);
                if (line) return line;
            }
            return '';
        },
        // The step's glyph: a document for what writes a page, a check for a
        // ticket, the assistant's star for anything else.
        glyph (tool) {
            const name = String(tool && tool.tool || '').replace(/^module_fn_/, '');
            if (/note|doc|folder|page/i.test(name)) return 'document';
            if (/ticket/i.test(name)) return 'check';
            return 'magicstar';
        },
        // The ask's glyph: a question mark for a question, the step's own for an
        // approval.
        askGlyph (root) {
            const card = this.choiceCard(root);
            const tool = this.approvalTool(root);
            return card ? 'questionMark' : this.glyph(tool);
        },
        // The question's buttons, by the ONE rule the thread's card reads
        // (functions/askCardOptions, through el.call): a confirm card is its two
        // labels — the card's own, else Confirm / Cancel — the first one primary;
        // a choice card is its options in their order, each answering with its
        // value (else its label). Each row carries the card's id for the writer.
        askOptions (el, root) {
            root && root.lang;
            const card = this.choiceCard(root);
            if (!card) return [];
            const rows = el.call('askCardOptions', card);
            return (Array.isArray(rows) ? rows : []).map((o)=>({
                    ...o,
                    cardId: card._cardId
                }));
        },
        // Run / Skip — the row's own settle. Guarded: a host without the shell's
        // function barrel (the standalone canvas) has no ask to answer.
        settle (el, s, approved) {
            const tool = this.approvalTool(s && s.root);
            const fns = el.context && el.context.functions || {};
            if (!tool || typeof fns.resolveAiToolApproval !== 'function') return;
            el.call('resolveAiToolApproval', tool.id, !!approved);
            this.askAnswered(el, s.root);
        },
        // Run all — this turn only (the transport keys the grant to the turn).
        approveAll (el) {
            const fns = el.context && el.context.functions || {};
            if (typeof fns.approveAllAiToolsForTurn !== 'function') return;
            el.call('approveAllAiToolsForTurn');
            this.askAnswered(el, el.state && el.state.root);
        },
        // AFTER AN ANSWER, FOCUS STAYS ON THE SURFACE (coordinator W3c,
        // 2026-10-29): the ask hides once it is answered, and the control that
        // had focus goes with it — focus fell to the page's body. It goes to the
        // text input of the same surface: the composer the island docks above
        // (or the one whose call strip holds the ask) — the shell's own path,
        // voiceFocusComposer, found by key. The full-screen call has no text
        // input: there it goes to the call's Minimize, where the call screen puts
        // focus when it opens (VoiceOverlay.scope.syncFocus). The call is told
        // by the posture threadOnScreen reads, never by `lookup`: that also
        // returns a root's child of the same key, from anywhere in the tree.
        // A composer that HOSTS the call shows no text input either: its strip
        // stands in the field's place (VoiceStrip.js), so focus goes to the
        // strip's Type — VoiceControls' KeyboardBtn, "give me the text input
        // back" (coordinator decision, 2026-10-29). The posture says a strip is
        // up; `lookup` from the ask finds the strip it floats over. A phone's
        // strip has no Type (the call hands itself to the island there after
        // its first line), so the composer path stays.
        askAnswered (el, root) {
            const r = root || {};
            const open = r.voiceOpen;
            const minimized = r.voiceMinimized;
            const host = r.voiceHost;
            if (open && !minimized && !host) {
                const shell = typeof el.getRoot === 'function' ? el.getRoot() : null;
                const call = shell && shell.lookdown ? shell.lookdown('VoiceOverlay') : null;
                const back = call && call.lookdown ? call.lookdown('CallMinimize') : null;
                queueMicrotask(()=>{
                    const node = back && back.node;
                    if (node && node.isConnected && typeof node.focus === 'function') node.focus();
                });
                return;
            }
            if (open && host && r._isPhoneViewport !== true) {
                const strip = typeof el.lookup === 'function' ? el.lookup('VoiceStrip') : null;
                const type = strip && strip.lookdown ? strip.lookdown('KeyboardBtn') : null;
                if (type) {
                    queueMicrotask(()=>{
                        const node = type.node;
                        if (node && node.isConnected && typeof node.focus === 'function') node.focus();
                    });
                    return;
                }
            }
            const fns = el.context && el.context.functions || {};
            if (typeof fns.voiceFocusComposer === 'function') el.call('voiceFocusComposer');
        },
        // A question's answer — the card's own writer, as the thread's ChatCard
        // buttons call it: the card's id, the option's value and its label (the
        // transport resumes the suspended turn with them). Guarded like settle.
        // A pick closes an open field first: its words were never sent, and a
        // hidden field that holds words reads as unsaved work to the shell
        // (ChatCard.scope.askPick does the same).
        choose (el, s) {
            const root = s && s.root;
            const fns = el.context && el.context.functions || {};
            if (!s || !s.cardId || typeof fns.resolveChatCard !== 'function') return;
            if (this.askMode(root)) this.askSetMode(root, null);
            el.call('resolveChatCard', s.cardId, s.value, s.label);
            this.askAnswered(el, root);
        },
        // ── WRITE MY OWN / EDIT (coordinator F2, 2026-10-28: on the call screen
        // and the island a typed message closed the question instead of
        // answering it). The thread card's two other paths (ChatCard PvAnswers /
        // PvCompose), in its words and on its writer. The open field lives where
        // the card keeps its own: the root's `_aiAskCompose`, by card id
        // (`{ field: 'own' | 'edit', change: false, text }`, UI state only), so
        // the drawer and this ask share ONE open field per question.
        askMode (root) {
            const all = root && root._aiAskCompose;
            const card = this.choiceCard(root);
            const id = card && card._cardId;
            const mode = all && id ? all[id] : null;
            return mode && typeof mode === 'object' ? mode : null;
        },
        // The field open on the ask: 'own' (Write my own) or 'edit' (a confirm
        // card's Edit), else null.
        askField (root) {
            const mode = this.askMode(root);
            const field = mode && mode.field;
            return field === 'own' || field === 'edit' ? field : null;
        },
        // The field's words, bound to its `value`, while the field is open: a
        // mode that closes takes them with it, and a question that closes (its
        // turn stopped or ended, or the drawer answered it) is no longer read,
        // so a closed field is empty — no unsaved work left behind.
        askText (root) {
            const mode = this.askMode(root);
            const open = this.askField(root);
            return open && mode && typeof mode.text === 'string' ? mode.text : '';
        },
        // Write the question's mode (null clears it) — in memory only, a new
        // object each time (ChatCard.scope.askSetMode).
        askSetMode (root, mode) {
            const card = this.choiceCard(root);
            const id = card && card._cardId;
            if (!root || typeof root.update !== 'function' || !id) return;
            const all = {
                ...root._aiAskCompose || {}
            };
            if (mode) all[id] = mode;
            else delete all[id];
            root.update({
                _aiAskCompose: all
            }, {
                preventFetch: true
            });
        },
        askSetText (root, text) {
            const mode = this.askMode(root);
            if (!mode || !mode.field) return;
            this.askSetMode(root, {
                ...mode,
                text: String(text == null ? '' : text)
            });
        },
        // The ask's card around any of its controls, and its controls by role:
        // 'field' (the input), 'writeOwn' (Write my own / Edit).
        askCardOf (el) {
            if (!el) return null;
            if (el.key === 'AskCard') return el;
            return typeof el.lookup === 'function' ? el.lookup('AskCard') : null;
        },
        askTarget (card, name) {
            if (!card) return null;
            if (name === 'field') return card.AskCompose && card.AskCompose.AppInputCompact || null;
            if (name === 'writeOwn') return card.AskOptions && card.AskOptions.AppCapsuleBtnGhost_own || null;
            return null;
        },
        // Focus a control once the update shows it: `hide` applies in the
        // update's microtask, so a focus in the same tick lands on a hidden node;
        // two microtasks later is still inside the press, so a phone keyboard
        // opens for the field (ChatCard.scope.askFocus).
        askFocus (el, name) {
            const card = this.askCardOf(el);
            if (!card) return;
            const run = ()=>{
                const target = this.askTarget(card, name);
                const node = target && target.node;
                if (node && typeof node.focus === 'function') node.focus();
            };
            queueMicrotask(()=>queueMicrotask(run));
        },
        // Write my own (a choice) / Edit (a confirm): the field opens under the
        // answers, empty, with focus.
        askOpenField (el, root) {
            const card = this.choiceCard(root);
            if (!card) return;
            const field = card.type === 'confirm' ? 'edit' : 'own';
            this.askSetMode(root, {
                field: field,
                change: false,
                text: ''
            });
            this.askFocus(el, 'field');
        },
        // The field's close (and Escape): back to the answers, its words
        // dropped, focus on the control that opened it.
        askCloseField (el, root) {
            this.askSetMode(root, null);
            this.askFocus(el, 'writeOwn');
        },
        // Send the field — the card's own writer with the card's own `extra`:
        // the person's words as the answer (Write my own), or what should change
        // (Edit: never a yes — the transport answers the tool `confirmed: false`
        // with the words). An empty field sends nothing and keeps the keyboard.
        // Guarded like choose.
        askSubmit (el, root) {
            const card = this.choiceCard(root);
            const kind = this.askField(root);
            const field = this.askTarget(this.askCardOf(el), 'field');
            const node = field && field.node;
            const fns = el.context && el.context.functions || {};
            if (!card || !card._cardId || !kind || typeof fns.resolveChatCard !== 'function') return;
            // the words on screen (the last keystroke may not have reached the
            // mode yet), else the mode's
            const typed = node && typeof node.value === 'string' ? node.value : this.askText(root);
            const text = String(typed || '').trim();
            if (!text) {
                this.askFocus(el, 'field');
                return;
            }
            const extra = kind === 'edit' ? {
                edit: true,
                text: text
            } : {
                written: true,
                text: text
            };
            this.askSetMode(root, null);
            el.call('resolveChatCard', card._cardId, kind === 'edit' ? 'edit' : text, text, extra);
            this.askAnswered(el, root);
        }
    },
    display: 'contents',
    AskCard: {
        hide: (el, s)=>!el.scope.askShown(s.root),
        role: 'group',
        aria: {
            label: (el, s)=>el.scope.askWord(el, s.root)
        },
        // The host's full column width: the stack stretches its rows, the call's
        // column centres its own.
        alignSelf: 'stretch',
        flow: 'y',
        gap: 'Z',
        padding: 'Z1',
        theme: 'dialog',
        shadow: 'float',
        round: 'radiusCard',
        borderWidth: '0',
        textAlign: 'left',
        pointerEvents: 'auto',
        animationName: 'fadeInUpShort',
        animationDuration: 'B',
        AskHead: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Y',
            minWidth: '0',
            Icon: {
                name: (el, s)=>el.scope.askGlyph(s.root),
                boxSize: 'A',
                color: 'title',
                flexShrink: '0'
            },
            // An approval: the step in the tool row's own words — primary text, so
            // it wraps.
            AskStep: {
                hide: (el, s)=>!el.scope.approvalTool(s.root),
                flex: '1 1 auto',
                minWidth: '0',
                fontSize: 'Z1',
                fontWeight: '500',
                lineHeight: '1.45',
                color: 'title',
                childExtends: 'ChatToolStepLabel',
                childrenAs: 'state',
                children: (el, s)=>{
                    const tool = el.scope.approvalTool(s.root);
                    return tool ? [
                        {
                            ...tool,
                            key: 'ask-' + tool.id
                        }
                    ] : [];
                }
            },
            // A question: its prompt, whole — primary text, so it wraps. A card
            // with no prompt names itself by the ask's words.
            AskPrompt: {
                tag: 'span',
                hide: (el, s)=>!el.scope.choiceCard(s.root),
                flex: '1 1 auto',
                minWidth: '0',
                fontSize: 'Z1',
                fontWeight: '500',
                lineHeight: '1.45',
                color: 'title',
                text: (el, s)=>el.scope.promptOf(s.root) || el.scope.askWord(el, s.root)
            }
        },
        AskPreview: {
            tag: 'span',
            hide: (el, s)=>!el.scope.preview(el.scope.approvalTool(s.root)),
            minWidth: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: 'Z1',
            color: 'paragraph',
            text: (el, s)=>el.scope.preview(el.scope.approvalTool(s.root)),
            title: (el, s)=>el.scope.preview(el.scope.approvalTool(s.root))
        },
        AskActions: {
            hide: (el, s)=>!el.scope.approvalTool(s.root),
            flow: 'x',
            align: 'center flex-start',
            gap: 'Y',
            flexWrap: 'wrap',
            AppCapsuleBtnPrimary_run: {
                compact: true,
                text: '{{ ai.tool.run | polyglot }}',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.scope.settle(el, s, true);
                }
            },
            AppCapsuleBtnGhost_skip: {
                compact: true,
                text: '{{ ai.tool.skip | polyglot }}',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.scope.settle(el, s, false);
                }
            },
            AppCapsuleBtnGhost_all: {
                compact: true,
                text: '{{ ai.tool.runAll | polyglot }}',
                title: (el)=>el.call('polyglot', 'ai.tool.runAllTooltip'),
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.scope.approveAll(el);
                }
            }
        },
        // A question's answers in one wrapping row, as the thread card lays them
        // out (ChatCard PvAnswers): its options, then Write my own / Edit.
        AskOptions: {
            hide: (el, s)=>!el.scope.choiceCard(s.root),
            flow: 'x',
            align: 'center flex-start',
            gap: 'Y',
            flexWrap: 'wrap',
            // One capsule per option in the card's order: the ink capsule for a
            // primary option (a confirm's yes), the quiet one for the rest — the
            // pair Run · Skip use. They sit in the row itself (no box of their
            // own), so they wrap with Write my own as one row. Each row's own state
            // is its option; each branch names its capsule as a literal (FA807).
            AskPicks: {
                display: 'contents',
                children: (el, s)=>el.scope.askOptions(el, s.root).map((o)=>o.primary ? {
                            key: 'opt-' + o.cardId + '-' + o.at,
                            extends: 'AppCapsuleBtnPrimary',
                            state: o
                        } : {
                            key: 'opt-' + o.cardId + '-' + o.at,
                            extends: 'AppCapsuleBtnGhost',
                            state: o
                        }),
                childProps: {
                    compact: true,
                    text: (el, s)=>s.label,
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        el.scope.choose(el, s);
                    }
                }
            },
            // Write my own (a choice card) / Edit (a confirm card): opens the
            // field, and gives way while it is open. Function text beside the
            // Icon: a `{{ }}` label is rewritten by the language switch through
            // textContent, which drops the Icon (ChatCard's own note).
            AppCapsuleBtnGhost_own: {
                compact: true,
                hide: (el, s)=>!!el.scope.askField(s.root),
                Icon: {
                    name: 'edit',
                    fontSize: 'Z2',
                    flexShrink: '0'
                },
                Label: {
                    tag: 'span',
                    text: (el, s)=>{
                        s.root?.lang;
                        const card = el.scope.choiceCard(s.root);
                        return el.call('polyglot', card && card.type === 'confirm' ? 'common.action.edit' : 'ai.chatCard.ask.writeOwn');
                    }
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    el.scope.askOpenField(el, s.root);
                }
            }
        },
        // The field: the person's own words (Write my own) or what should change
        // (Edit). Enter or Send sends; Escape and the close go back. Escape stays
        // in the field: past it, on the full-screen call the window's Escape
        // steps the call down to the island (VoiceOverlay.onWindowKeydown), and
        // in the shell it closes what the page has open.
        AskCompose: {
            hide: (el, s)=>!el.scope.askField(s.root),
            flow: 'x',
            align: 'center',
            gap: 'Y',
            width: '100%',
            minWidth: '0',
            // AppInput carries a scope of its own (the field kit), so its factories
            // reach the ask's helpers through the row. Its words are bound to the
            // question's mode (scope.askText): a mode that closes empties it.
            AppInputCompact: {
                flex: '1 1 0',
                enterkeyhint: 'send',
                autocomplete: 'off',
                value: (el, s)=>el.parent.scope.askText(s.root),
                onInput: (e, el, s)=>el.parent.scope.askSetText(s.root, el.node.value),
                placeholder: (el, s)=>{
                    s.root?.lang;
                    return el.call('polyglot', el.parent.scope.askField(s.root) === 'edit' ? 'ai.chatCard.ask.editPlaceholder' : 'ai.chatCard.ask.ownPlaceholder');
                },
                ariaLabel: (el, s)=>{
                    s.root?.lang;
                    return el.call('polyglot', el.parent.scope.askField(s.root) === 'edit' ? 'ai.chatCard.ask.editPlaceholder' : 'ai.chatCard.ask.ownPlaceholder');
                },
                onKeydown: (e, el, s)=>{
                    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
                        e.preventDefault();
                        el.parent.scope.askSubmit(el, s.root);
                    } else if (e.key === 'Escape') {
                        e.preventDefault();
                        e.stopPropagation();
                        el.parent.scope.askCloseField(el, s.root);
                    }
                }
            },
            AppCapsuleBtnPrimary: {
                compact: true,
                text: '{{ common.action.send | polyglot }}',
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    el.scope.askSubmit(el, s.root);
                }
            },
            // CloseButton carries a scope of its own (its localized name).
            CloseButton: {
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    el.parent.scope.askCloseField(el, s.root);
                }
            }
        }
    },
    // Visually hidden, never display:none — a live region must stay in the
    // accessibility tree to announce: the sr-only clip box (PageSrTitle's
    // idiom) on the brand's one-pixel size token.
    AskAnnounce: {
        tag: 'span',
        role: 'status',
        aria: {
            live: 'polite'
        },
        position: 'absolute',
        width: 'hairline',
        height: 'hairline',
        padding: '0',
        border: '0',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        AskAnnounceWord: {
            tag: 'span',
            text: (el, s)=>el.scope.announceHead(el, s.root)
        },
        AskAnnounceStep: {
            tag: 'span',
            childExtends: 'ChatToolStepLabel',
            childrenAs: 'state',
            children: (el, s)=>{
                const shown = el.scope.askShown(s.root);
                const tool = el.scope.approvalTool(s.root);
                return shown && tool ? [
                    {
                        ...tool,
                        key: 'say-' + tool.id
                    }
                ] : [];
            }
        },
        AskAnnounceQuestion: {
            tag: 'span',
            text: (el, s)=>{
                const shown = el.scope.askShown(s.root);
                const prompt = el.scope.promptOf(s.root);
                return shown ? prompt : '';
            }
        }
    }
};

});

parcelRegister("hNbPv", function(module, exports) {

$parcel$export(module.exports, "SimoneSuggestions", () => $cf403065634314da$export$e66f8ddbf67d07f3);

var $4SiPM = parcelRequire("4SiPM");
const $cf403065634314da$export$e66f8ddbf67d07f3 = {
    // FA204 / frank trap — helpers live in `scope`, reached via `el.scope.*`.
    scope: {
        // Route WITHOUT the multi-workspace-tabs `/w/<slug>` prefix — the hide
        // compares bare app routes. Inline mirror of workspacePrefix.js
        // stripWorkspacePrefix (same helper as ReasoningPill's).
        routePath (root) {
            const p = root && root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
            const stripped = String(p).replace(/^\/w\/[a-z0-9-]{1,48}(?=\/|$)/, '');
            return stripped === '' ? '/' : stripped;
        },
        // The shell's panel model is registered on this host.
        hasModel (el) {
            const fns = el && el.context && el.context.functions;
            return !!(fns && typeof fns.aiPanelSuggestions === 'function');
        },
        groups (el, s) {
            if (!this.hasModel(el)) return [];
            try {
                const out = el.call('aiPanelSuggestions', s && s.root);
                return Array.isArray(out) ? out : [];
            } catch (_) {
                return [];
            }
        },
        actions (el, s) {
            if (!this.hasModel(el)) return [];
            try {
                const out = el.call('aiPanelActions', s && s.root);
                return Array.isArray(out) ? out : [];
            } catch (_) {
                return [];
            }
        },
        // The chosen context's key — a row key carries it, so a context switch
        // re-mounts the rows instead of patching them in place.
        scopeKey (el, s) {
            try {
                return String(el.call('aiScopeChosenKey', s && s.root) || '');
            } catch (_) {
                return '';
            }
        },
        // A change signature of a group's rows (djb2 → base36), not a hash for
        // anything but telling two row lists apart.
        sig (rows) {
            const t = (rows || []).map((r)=>r && r.text || '').join('|');
            let h = 5381;
            for(let i = 0; i < t.length; i++)h = (h << 5) + h + t.charCodeAt(i) | 0;
            return (h >>> 0).toString(36);
        }
    },
    // Declared subscriptions (FA515): every discriminator the hide / paint /
    // row factories read behind a short-circuit.
    subscribeTo: [
        'currentPath',
        'chatTyping',
        'activeProcesses',
        'assistantOpen',
        '_homeThreadOpen',
        'meetView',
        '_promptFocused',
        '_dropdownLayer',
        '_promptMenuOpen',
        '_aiPanel',
        '_aiInspect',
        '_aiAskContext',
        '_aiRefMutedFor',
        '_canvasSlot',
        'workspace',
        'workspaceApps',
        'workspaceProject',
        'assistantMode',
        'chatMessages',
        'sessions',
        'lang',
        'selectedTicket',
        'selectedEvent',
        'showEventDetail',
        'selectedDocument',
        'profileEmail',
        'selectedPerson',
        '_selectedAgent',
        '_selectedTeamMember',
        '_createAgentOpen',
        '_createMemberOpen',
        'selectedAnnouncement',
        'editorDoc',
        'data'
    ],
    hide: (el, s)=>{
        // /flags gate: assistant off removes the panel everywhere.
        if (!(0, $4SiPM.featureEnabled)(s.root, 'aiAssistant')) return true;
        const r = s.root;
        if (!r) return true;
        if (!el.scope.hasModel(el)) return true;
        // The composer's own route-hide: never over a page's own bottom UI.
        const path = el.scope.routePath(r);
        if (path === '/add-app' || path === '/chat' || path === '/meet-guest') return true;
        if (path === '/meet' && r.meetView === 'call') return true;
        // A streaming turn: the reasoning pill owns the strip (reading
        // activeProcesses also TOUCHES the signal, so the panel returns after).
        if (r.chatTyping || (r.activeProcesses || []).some((p)=>p && p.status === 'running')) return true;
        // The thread, the drawer or a Fly page (the workspace's fly canvas,
        // functions/assistantFly.js — its next asks are on the page) holds the
        // answer: step aside — unless asked for.
        const fns = el.context && el.context.functions;
        const fly = fns && typeof fns.assistantFlyShown === 'function' ? !!el.call('assistantFlyShown', r) : false;
        if ((r.assistantOpen || r._homeThreadOpen || fly) && r._aiPanel !== 'open') return true;
        return false;
    },
    role: 'dialog',
    ariaModal: 'false',
    ariaLabel: (el)=>el.call('polyglot', 'ai.panel.label'),
    // ── THE PANEL — one glass surface at composer width; sections by rhythm.
    flow: 'y',
    gap: 'Z1',
    width: '100%',
    minWidth: '0',
    boxSizing: 'border-box',
    fontSize: 'Z1',
    theme: 'search-glass',
    borderWidth: '0',
    round: 'radiusCard',
    padding: 'Z',
    shadow: 'overlay',
    maxHeight: '70dvh',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    // DESIGN_SPEC 6.5: under reduced transparency the glass is the opaque
    // `dialog` surface, no blur.
    '@reduceTransparency': {
        theme: 'dialog',
        backdropFilter: 'none'
    },
    // A phone: the sheet — its radius, a taller cap, its own scroll.
    '@mobileL': {
        round: 'radiusSheet',
        maxHeight: '62dvh',
        padding: 'Z'
    },
    // PAINTS while focused, under no menu, not put away, not inspecting —
    // opacity + visibility + a 6 px rise, never display, so the motion can run;
    // no pointer while hidden. Inline in each factory (no scope helper), so a
    // reader may call them with any element.
    opacity: (el, s)=>s.root?._promptFocused && !s.root._dropdownLayer && !s.root._promptMenuOpen && s.root._aiPanel !== 'dismissed' && !s.root._aiInspect ? '1' : '0',
    visibility: (el, s)=>s.root?._promptFocused && !s.root._dropdownLayer && !s.root._promptMenuOpen && s.root._aiPanel !== 'dismissed' && !s.root._aiInspect ? 'visible' : 'hidden',
    pointerEvents: (el, s)=>s.root?._promptFocused && !s.root._dropdownLayer && !s.root._promptMenuOpen && s.root._aiPanel !== 'dismissed' && !s.root._aiInspect ? 'auto' : 'none',
    transform: (el, s)=>s.root?._promptFocused && !s.root._dropdownLayer && !s.root._promptMenuOpen && s.root._aiPanel !== 'dismissed' && !s.root._aiInspect ? 'none' : 'translateY(6px)',
    // Under a menu, put away or inspecting the panel goes AT ONCE (the next
    // layer is the surface now); otherwise the house enter / one-step-faster exit.
    transition: (el, s)=>s.root?._promptFocused && (s.root._dropdownLayer || s.root._promptMenuOpen || s.root._aiPanel === 'dismissed' || s.root._aiInspect) ? 'none' : s.root?._promptFocused ? 'opacity B defaultBezier, transform B defaultBezier, visibility 0s' : 'opacity A defaultBezier, transform A defaultBezier, visibility 0s A',
    // THE FOCUS MIRROR'S OTHER HALF (dropdowns spec §8): focus arriving here
    // keeps `_promptFocused` up (and cancels the field's pending clear); focus
    // leaving for anything but this panel or the field starts the same clear.
    // Host = PromptBand's parent, the composer card that holds the field's
    // `_blurT`.
    onFocusin: (e, el, s)=>{
        const host = el.parent && el.parent.parent;
        if (host && host._blurT) {
            clearTimeout(host._blurT);
            host._blurT = null;
        }
        if (s.root && !s.root._promptFocused) s.root.update({
            _promptFocused: true
        });
    },
    onFocusout: (e, el, s)=>{
        const host = el.parent && el.parent.parent;
        const next = e && e.relatedTarget;
        if (!host || next && el.node && el.node.contains(next)) return;
        if (next && host.Textarea && next === host.Textarea.node) return;
        if (host._blurT) clearTimeout(host._blurT);
        host._blurT = setTimeout(()=>{
            host._blurT = null;
            if (s.root && s.root._promptFocused) s.root.update({
                _promptFocused: false
            });
        }, 250);
    },
    // ONE Escape puts the panel away and hands focus back to the field (one
    // Escape = one layer: it closes nothing else). ↑ ↓ Home End walk the
    // suggestion rows; the chips, the verbs and the mode segments keep their
    // own arrows.
    onKeydown: (e, el, s)=>{
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            const host = el.parent && el.parent.parent;
            const ta = host && host.Textarea && host.Textarea.node;
            if (ta && typeof ta.focus === 'function') ta.focus();
            if (s && s.root && typeof s.root.update === 'function') s.root.update({
                _aiPanel: 'dismissed'
            }, {
                preventFetch: true
            });
            return;
        }
        const menu = el.PanelMenu && el.PanelMenu.node;
        if (!menu || !e.target || typeof menu.contains !== 'function' || !menu.contains(e.target)) return;
        el.call('menuArrowNav', e, menu, {
            selector: '[role="menuitem"]'
        });
    },
    // ── CONTEXT — what the ask is about.
    PanelContext: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        AiPanelLabel: {
            text: (el)=>el.call('polyglot', 'ai.scope.label')
        },
        AiScopeSwitch: {}
    },
    // ── THE THREE VERBS — one symmetric row: three equal tracks.
    PanelActions: {
        role: 'group',
        ariaLabel: (el)=>el.call('polyglot', 'ai.panel.actions'),
        if: (el, s)=>el.parent.scope.actions(el.parent, s).length > 0,
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: 'Y',
        minWidth: '0',
        childExtends: 'AiPanelAction',
        childrenAs: 'state',
        children: (el, s)=>// the element key is prefixed (never a bare word a tag or a prop could
            // own); the verb itself rides as `verb` — the one the click runs
            el.parent.scope.actions(el.parent, s).map((a)=>({
                    ...a,
                    verb: a.key,
                    key: 'verb-' + a.key
                })),
        // ← → between the verbs (the row is one Tab stop per verb; the arrows are
        // a convenience, the menu's own walker on the horizontal axis).
        onKeydown: (e, el)=>el.call('menuArrowNav', e, el.node, {
                selector: 'button',
                orientation: 'x'
            })
    },
    // ── THE CONTEXT'S ASKS — a menu of grouped rows (the house menu row).
    // Hidden while the member is typing: the starters are for an empty field;
    // the context and the verbs stay.
    PanelMenu: {
        role: 'menu',
        tabindex: '-1',
        ariaLabel: (el)=>el.call('polyglot', 'ai.panel.suggestions'),
        hide: (el, s)=>!!String(s && s.draft || '').trim(),
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        childExtends: 'AiPanelGroup',
        childrenAs: 'state',
        // A group's key carries the context and its rows' words, so a change
        // re-mounts the group instead of patching rows in place.
        children: (el, s)=>{
            const panel = el.parent;
            const scopeKey = panel.scope.scopeKey(panel, s);
            return panel.scope.groups(panel, s).map((g)=>({
                    key: g.key + ':' + scopeKey + ':' + panel.scope.sig(g.rows),
                    label: g.label,
                    rows: g.rows || []
                }));
        }
    },
    // ── THE MODE — what the AI makes; the current one named with what it does.
    PanelMode: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        AiPanelLabel: {
            text: (el)=>el.call('polyglot', 'ai.assistantMode.label')
        },
        AiModeSwitch: {}
    }
};

});

parcelRegister("3uNNz", function(module, exports) {

$parcel$export(module.exports, "AssistantStarter", () => $28bacd648eb19976$export$c172458fb91d3f97);
$parcel$export(module.exports, "AssistantStarterList", () => $28bacd648eb19976$export$927036f5d1eed887);
// AssistantStarter — ONE recommendation the assistant offers before the first
// message, in BOTH places it offers them (Nika 2026-09-26: one centred
// component): the empty chat's stack (Chat.js Empty.Starters) and the chip
// row of the AI island above the collapsed composer (Suggestions.js Actions,
// `compact`).
//
// Row state (childrenAs:'state' — produced by the workspace package's
// `workspaceStarters(root)` / `buildSuggestions(root)`, or Chat.js's own
// generic fallback):
//   { key, text, prompt?, icon?, caption?, localAction?, generic? }
//   text        — what the capsule shows AND, when `prompt` is absent, what it
//                 sends (the island's rows name it `label`; both are read)
//   prompt      — the fuller ask that actually goes to the AI
//   icon        — sprite name of the app the prompt concerns ('magicstar' when
//                 the prompt is about the workspace as a whole)
//   caption     — the app's name (the glyph already shows which app; the
//                 capsule carries one line of words, so the name is not
//                 painted)
//   localAction — a registered function to run instead of sending (module
//                 manifests declare these for their own starters)
//   generic     — an always-offered staple: one ink step quieter than the
//                 surface's own offers (the island's hierarchy)
//
// THE KIT'S TONAL CAPSULE (Nika 2026-09-26, "make first recommendations
// buttons in the middle and make better design to it"): AppCapsuleBtnToolbar
// — the resting `layer` wash (fill contrast, no stroke), the `selected` step
// under the pointer and on press, the house press scale, a controlH tap
// target on the pill radius, the kit's `:disabled`. The app's glyph leads in
// the quiet `caption` ink (hue never marks a starter), the prompt follows,
// the pair centred. Chat.js centres the capsules and gives them ONE width (a
// shared grid track); a long prompt wraps inside its capsule, centred, rather
// than widening it. It was a launcher row: a glyph tile, a caption line and a
// trailing arrow on a full-width card. Focus ring: the brand reset's global
// :focus-visible — never re-implemented here.
const $28bacd648eb19976$export$c172458fb91d3f97 = {
    extends: 'AppCapsuleBtnToolbar',
    gap: 'Y',
    padding: 'Y A',
    whiteSpace: 'normal',
    textAlign: 'center',
    lineHeight: '1.35',
    minWidth: '0',
    color: (el, s)=>s && s.generic ? 'paragraph' : 'title',
    // THE GLYPH PLATE (dropdowns spec §4, §7.2 A5): the app's glyph on a borderless round plate in the quiet
    // ink; the capsule's hover and keyboard focus INVERT it (the one state logic, §5). The generic spark is the
    // line assistant glyph (`magicstar` rows keep working — they map to it).
    Plate: {
        dataGlyphPlate: true,
        ariaHidden: 'true',
        display: 'flex',
        align: 'center center',
        flexShrink: '0',
        boxSize: 'glyphPlateXs',
        round: 'radiusPill',
        color: 'caption',
        transition: 'background-color A defaultBezier, color A defaultBezier',
        Icon: {
            name: (el, s)=>s.icon && s.icon !== 'magicstar' ? s.icon : 'lnAssistant',
            boxSize: 'iconSm'
        }
    },
    '&:hover [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed'
    },
    '&:focus-visible [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed'
    },
    StarterLabel: {
        tag: 'span',
        minWidth: '0',
        text: (el, s)=>s.text || s.label
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        // Resolve this Chat instance's scope by walking up for `chatScope` —
        // inlined (no helper import) so the walk survives frank serialization,
        // the same idiom as Chat.js `ck` and ChatMessage's Suggestions row.
        let scope = 'general';
        let n = el;
        while(n){
            if (n.chatScope) {
                scope = n.chatScope;
                break;
            }
            n = n.parent;
        }
        // THE ASK ROUTER (workspace functions/assistantAskRoute.js
        // assistantAskHandoff): a starter that clearly asks for another surface —
        // a page, an app, slides, a website, the tour — goes there, before the
        // assistant opens. Every other starter is this chat's. Only the general
        // chat routes; a starter with its own action runs that.
        const ask = s.prompt || s.text || s.label;
        const fns = el.context && el.context.functions;
        if (!s.localAction && scope === 'general' && ask && fns && typeof fns.assistantAskHandoff === 'function' && el.call('assistantAskHandoff', ask, {
            from: 'starter'
        })) return;
        // From the island above the collapsed composer the answer lands in the
        // assistant, so it opens first (a no-op inside the open drawer).
        if (s.root && typeof s.root.update === 'function' && !s.root.assistantOpen) s.root.update({
            assistantOpen: true
        });
        try {
            if (s.localAction) el.call(s.localAction);
            else el.call('sendPrompt', s.prompt || s.text || s.label, scope);
        } catch (_) {}
    }
};
const $28bacd648eb19976$export$927036f5d1eed887 = {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, max-content)',
    justifyContent: 'center',
    rowGap: 'Y',
    width: '100%',
    maxWidth: 'H',
    childProps: {
        compact: true
    },
    childrenAs: 'state',
    childExtends: 'AssistantStarter'
};

});

parcelRegister("4zGmN", function(module, exports) {

$parcel$export(module.exports, "ToolTerminal", () => $354b4b6eb88be57b$export$943bde22cda603ff);
// Terminal-styled block for tool-call I/O (args + result).
//
// Named ToolTerminal — NOT Terminal — on purpose: workspace/shared already
// ships a single-line `Terminal` command-bar, and that library is linked in
// the standalone (:1235) build. Defining `Terminal` here would shadow it and
// break every consumer that expects the canonical one (Rule 63: no duplicate
// names across tiers). This component is also fully self-contained so it
// renders in the chrome-connect panel, which only links the brand library.
//
// Consumer passes `label` (header text, or a bundle KEY — resolved through
// polyglot when the host registers it; a host without polyglot shows it as
// given) and `value` (body text) on the element that `extends:
// 'ToolTerminal'`; the children read them off el.parent.
const $354b4b6eb88be57b$export$943bde22cda603ff = {
    flow: 'y',
    width: '100%',
    round: 'Y',
    overflow: 'hidden',
    border: 'hairline solid line',
    // The terminal's header: one line, the whole label on hover (the overflow
    // law, §3b rule 8).
    Label: {
        text: (el, s)=>{
            const raw = el.parent && el.parent.label || 'terminal';
            const fns = el.context && el.context.functions;
            if (!fns || typeof fns.polyglot !== 'function') return raw;
            try {
                const t = el.call('polyglot', raw);
                return t ? String(t) : raw;
            } catch (_) {
                return raw;
            }
        },
        title: (el, s)=>{
            const raw = el.parent && el.parent.label || null;
            const fns = el.context && el.context.functions;
            if (!raw || !fns || typeof fns.polyglot !== 'function') return raw;
            try {
                const t = el.call('polyglot', raw);
                return t ? String(t) : raw;
            } catch (_) {
                return raw;
            }
        },
        padding: 'Y2 Z',
        // `overlay` is a COLOUR token, never a theme (designSystem/color.js). In
        // the theme slot `getMediaTheme` returned undefined and this label emitted
        // ZERO classes — no plate behind the terminal header. `background:` is the
        // slot that resolves it, to `var(--color-overlay)`.
        background: 'overlay',
        color: 'caption',
        fontSize: 'Z2',
        fontWeight: '700',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    Body: {
        tag: 'pre',
        margin: '0',
        padding: 'Z',
        overflow: 'auto',
        maxHeight: 'H',
        theme: 'document',
        color: 'foreground',
        fontFamily: 'monospace',
        fontSize: 'Z2',
        lineHeight: '1.45',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        text: (el, s)=>{
            let v = el.parent && el.parent.value;
            if (typeof v === 'function') try {
                v = v(el.parent, s);
            } catch (_) {
                v = '';
            }
            return v == null ? '' : String(v);
        }
    }
};

});

parcelRegister("aOHSJ", function(module, exports) {

$parcel$export(module.exports, "SessionMenu", () => $7e009ce05e7787bc$export$6366b7097bfd87f1);
// Session selector — a small dropdown anchored to the header's session
// button. Lists sessions newest-first, highlights the active one, lets the
// user switch / delete / start a new chat.
//
// LEGACY TOP-LEVEL SLOT, kept for the published component surface
// (assistantSimone.js re-export): the canonical Chat header now inlines its
// own Sessions menu (Chat.js Header.Title.Sessions). Restyled 2026-08-12 onto
// THE AI menu system (AiMenu.js) so a host that still mounts this slot gets
// the same panel/row/heading language as every other AI dropdown: the
// AiMenuPanel glass surface + motion (isOpen tracks the same
// root.showSessionMenu flag hosts already gate on), AiMenuHeading caption,
// AiOptionRow metrics on the rows with the house `selected` wash for the
// active session.
// THE house keyboard model for menus (../../functions/menuKeyboard.js) —
// held as scope VALUES on the export below, never read as bare identifiers
// from inside a factory (FA204: a frank to-json lift drops those).

var $3CWNx = parcelRequire("3CWNx");
const $7e009ce05e7787bc$var$Row = {
    tag: 'button',
    type: 'button',
    // Arrow-cycle marker + "this is the open thread" (the same fact the
    // `selected` wash carries visually).
    role: 'menuitem',
    ariaCurrent: (el, s)=>s.id === s.root.activeSessionId ? 'true' : null,
    flow: 'x',
    gap: 'Z',
    align: 'center space-between',
    width: '100%',
    padding: 'Y Z1',
    round: 'radiusControl',
    theme: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z1',
    textAlign: 'left',
    '@coarse': {
        minHeight: 'controlH'
    },
    // Active = the house `selected` wash + `title` ink (one recipe with the
    // option rows). No `transition` on the reactive background — the runtime
    // re-applies it per tick and would restart the tween forever
    // (MenuPanel.js note).
    background: (el, s)=>s.id === s.root.activeSessionId ? 'selected' : 'transparent',
    ':hover': {
        background: 'hover'
    },
    // The thread's name — primary text, never cut (the overflow law,
    // HOME_AMBIENT_SKIN_SPEC §3b rule 8): it wraps, a long word breaks
    // anywhere, and the time keeps its place beside it.
    Title: {
        text: (el, s)=>s.title || el.call('polyglot', 'ai.chat.newChat'),
        color: (el, s)=>s.id === s.root.activeSessionId ? 'title' : 'caption',
        fontWeight: (el, s)=>s.id === s.root.activeSessionId ? '700' : '500',
        overflowWrap: 'anywhere',
        flex: '1 1 auto',
        minWidth: '0'
    },
    Time: {
        text: (el, s)=>{
            if (!s.ts) return '';
            const d = new Date(s.ts);
            return el.call('localizedDate', d, {
                hour: 'numeric',
                minute: '2-digit'
            });
        },
        color: 'caption',
        flexShrink: '0',
        fontSize: 'Y'
    },
    Delete: {
        tag: 'span',
        text: "\xd7",
        color: 'caption',
        flexShrink: '0',
        padding: 'Y2 Y',
        round: 'radiusControl',
        role: 'button',
        tabindex: '0',
        'aria-label': (el)=>el.call('polyglot', 'ai.sessions.delete'),
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('deleteSession', s.id);
        },
        onKeydown: (e, el, s)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                el.call('deleteSession', s.id);
            }
        }
    },
    onClick: (e, el, s)=>el.call('switchSession', s.id)
};
const $7e009ce05e7787bc$export$6366b7097bfd87f1 = {
    // THE shared AiMenuPanel: glass surface, radiusCard, borderless, 60vh
    // scroll cap, house open/close motion. Hosts historically mount this slot
    // gated on root.showSessionMenu — the isOpen predicate reads the same
    // flag, so an always-mounted host animates open/closed and an if:-gated
    // host simply renders open.
    extends: 'AiMenuPanel',
    // Same keyboard contract as the canonical header menu (Chat.js Sessions):
    // one role="menu" over the whole panel, arrows cycle "+ New" and every
    // session row, Enter/Space activate natively (<button> rows), Escape
    // closes and hands focus back to whatever opened the menu. Hosts gate this
    // slot on `root.showSessionMenu`, so that flag is also the focus edge.
    scope: {
        navRows: (0, $3CWNx.menuArrowNav),
        focusOnOpen: (0, $3CWNx.menuFocusOnOpen),
        nodeVisible: (0, $3CWNx.menuNodeVisible),
        focusBack: (0, $3CWNx.restoreMenuFocus)
    },
    role: 'menu',
    tabindex: '-1',
    ariaLabel: (el)=>el.call('polyglot', 'ai.sessions.title'),
    subscribeTo: [
        'showSessionMenu'
    ],
    onRender: (el, s)=>el.scope.focusOnOpen(el, !!s.root.showSessionMenu, {
            when: (node)=>el.scope.nodeVisible(node)
        }),
    onUpdate: (el, s)=>el.scope.focusOnOpen(el, !!s.root.showSessionMenu, {
            when: (node)=>el.scope.nodeVisible(node)
        }),
    onKeydown: (e, el, s)=>{
        if (el.scope.navRows(e, el.node)) return;
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            if (s.root && s.root.update) s.root.update({
                showSessionMenu: false
            });
            el.scope.focusBack(el);
            return;
        }
        if (e.key === 'Tab') {
            el._menuReturnFocusTo = null;
            if (s.root && s.root.showSessionMenu) s.root.update({
                showSessionMenu: false
            });
        }
    },
    isOpen: (el, s)=>!!s.root.showSessionMenu,
    position: 'fixed',
    top: 'C1',
    right: 'A',
    zIndex: '20',
    gap: 'V',
    Header: {
        flow: 'x',
        gap: 'Y',
        align: 'center space-between',
        // Horizontal 0 — the heading self-insets to the rows' Z1 text edge
        // (AiMenuHeading paddingLeft) and the button's right edge aligns with
        // the rows' right edge.
        padding: 'Y 0',
        Label: {
            extends: 'AiMenuHeading',
            text: '{{ ai.sessions.title | polyglot }}'
        },
        NewBtn: {
            tag: 'button',
            type: 'button',
            // First stop in the panel's arrow cycle (DOM order).
            role: 'menuitem',
            text: '{{ ai.sessions.new | polyglot }}',
            padding: 'Y2 Z',
            round: 'radiusControl',
            theme: 'tertiary',
            border: 'none',
            cursor: 'pointer',
            color: 'title',
            fontSize: 'Z1',
            fontWeight: '700',
            ':hover': {
                background: 'hover'
            },
            onClick: (e, el, s)=>el.call('newSession')
        }
    },
    List: {
        flow: 'y',
        gap: 'V',
        childExtends: $7e009ce05e7787bc$var$Row,
        children: (el, s)=>{
            const sess = s.root.sessions || {};
            return Object.values(sess).sort((a, b)=>(b.ts || 0) - (a.ts || 0));
        },
        childrenAs: 'state',
        Empty: {
            if: (el, s)=>!Object.keys(s.root.sessions || {}).length,
            padding: 'Y Z1',
            text: '{{ ai.sessions.empty | polyglot }}',
            color: 'caption',
            fontSize: 'Z1'
        }
    }
};

});

parcelRegister("7jzAZ", function(module, exports) {

$parcel$export(module.exports, "ConnectionBadge", () => $5535eb47317bd3c4$export$b39c0c03e25f00e8);
const $5535eb47317bd3c4$export$b39c0c03e25f00e8 = {
    // FA204 / frank trap — themeFor/agentLabel/stateLabel used to be bare
    // module-scope const read from inside Dot.theme/Label.text/Label.theme
    // (serialized factories); they read as undefined once this component is
    // frank.toJSON'd for platform delivery. Moved into `scope`, called via
    // `el.scope.<name>`.
    scope: {
        // Maps the bridge's agent identifier (sent in `bridge_ready` as
        // `adapter.name`) to a presentable label. Unknown identifiers fall back
        // to the raw value so future adapters surface without a code change.
        agentLabel (agent) {
            if (!agent) return null;
            if (agent === 'claude' || agent === 'claude-code') return 'Claude';
            if (agent === 'codex') return 'Codex';
            return String(agent);
        },
        // Connection-state fallback for when the bridge hasn't told us which AI
        // is active yet (still connecting, closed, errored).
        stateLabel (status) {
            if (status === 'connecting') return "connecting\u2026";
            if (status === 'closed') return 'disconnected';
            if (status === 'error') return 'error';
            return status || 'unknown';
        },
        themeFor (status) {
            if (status === 'open') return 'success';
            if (status === 'connecting') return 'warning';
            if (status === 'error') return 'error';
            return 'transparent';
        }
    },
    flow: 'x',
    gap: 'Y',
    align: 'center',
    Dot: {
        width: 'Y',
        height: 'Y',
        borderRadius: '50%',
        theme: (el, s)=>el.scope.themeFor(s.root.bridgeStatus)
    },
    // Show the active AI agent (Claude / Codex / …) when the bridge has
    // reported one — otherwise fall back to the connection-state label so
    // the badge still communicates that something's wrong.
    Label: {
        text: (el, s)=>el.scope.agentLabel(s.root.agent) || el.scope.stateLabel(s.root.bridgeStatus),
        fontSize: 'Z1',
        theme: (el, s)=>el.scope.themeFor(s.root.bridgeStatus)
    }
};

});

parcelRegister("6gOkc", function(module, exports) {

$parcel$export(module.exports, "SettingsDrawer", () => $490b46231390202e$export$c4647fec8211a5a);
// Settings layer — mounted on Chat itself (Chat.Settings), opened by the
// header SettingsBtn + the composer SettingsBtn (`preferences` glyph — the
// same params affordance as the workspace prompt's ParamsBtn). It hosts ONE
// body, the shared `AiSettingsPanel` (workspace/packages/shared/components/
// AiSettingsPanel.js), which is the SAME body the canvas prompt bar's
// ParamsBtn dropdown renders — so the two assistant surfaces are identical
// by construction. AiSettingsPanel owns everything that used to be split
// across this drawer's TargetSection, AiModePickerBody and BridgeField: the
// per-me / whole-workspace scope, the real provider picker (modelMode), the
// local simone-bridge setup, and the authorization mode.
//
// POSITIONING — an IN-SURFACE layer, not a viewport modal. `absolute` +
// Chat root's `position: relative` anchor the scrim + sheet to the assistant
// surface itself: in the workspace drawer the sheet slides over the sidebar
// content right under the header SettingsBtn (previously `fixed; inset: 0`
// centered it mid-viewport, visually detached from its trigger); in the
// full-surface hosts (standalone simone, chrome-connect, ext-ui) Chat fills
// the page so the geometry is unchanged. Contained by construction: the
// sheet can never overflow the viewport edge, and on phones (drawer =
// full-width overlay) it becomes a full-width sheet automatically.
const $490b46231390202e$export$c4647fec8211a5a = {
    position: 'absolute',
    inset: '0',
    background: 'scrim',
    align: 'flex-start center',
    padding: 'A',
    // Above the in-chat layers (Sessions menu 200, composer chips 25) within
    // the assistant surface's stacking context.
    zIndex: '300',
    // The layer is `if:`-created (Chat.Settings), so a brand entrance keyframe
    // plays on every open — opacity-only: this is a sheet, not a dropdown, and
    // a tall surface travelling would overshoot the motion budget.
    animation: 'fadeIn',
    animationDuration: 'A',
    onClick: (e, el, s)=>{
        // Scrim click closes; Sheet stops propagation below.
        s.root.update({
            showSettings: false
        });
    },
    Sheet: {
        flow: 'y',
        gap: 'A',
        width: '100%',
        // Token cap for wide hosts (full-page simone); inside the drawer the
        // width: 100% minus the scrim padding governs. The old F2 cap was
        // NARROWER than the panel's own min width — permanent overflow.
        maxWidth: 'G1',
        maxHeight: '100%',
        overflow: 'auto',
        // Don't chain this layer's edge-bounce to the surface behind (iPad P2).
        overscrollBehavior: 'contain',
        padding: 'A',
        // THE AI menu surface (AiMenu.js system) at sheet geometry: the same
        // glass every AI dropdown wears, radiusSheet (docked-sheet class, brand
        // geometry) and NO added shadow — the glass theme carries the single
        // budget shadow. Borderless via longhand (the theme emits longhands).
        theme: 'canvas-card-glass',
        round: 'radiusSheet',
        borderWidth: '0',
        onClick: (e)=>e.stopPropagation(),
        Header: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            Title: {
                tag: 'h2',
                text: '{{ ai.settings.panelLabel | polyglot }}',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                margin: '0',
                flex: '1'
            },
            Close: {
                tag: 'button',
                type: 'button',
                text: '{{ ai.bridge.done | polyglot }}',
                padding: 'Y Z1',
                round: 'radiusControl',
                border: 'none',
                theme: 'tertiary',
                color: 'title',
                cursor: 'pointer',
                fontWeight: '700',
                fontSize: 'Z1',
                ':hover': {
                    background: 'hover'
                },
                onClick: (e, el, s)=>s.root.update({
                        showSettings: false
                    })
            }
        },
        // The single shared body — provider (real modelMode), local simone-bridge
        // setup, authorization, and the per-me / whole-workspace scope toggle.
        // minWidth 0 so the panel's dropdown-host min width can never force the
        // sheet wider than a narrow (320px-min) drawer.
        AiSettingsPanel: {
            minWidth: '0',
            maxWidth: '100%'
        }
    }
};

});

parcelRegister("fC1oY", function(module, exports) {

$parcel$export(module.exports, "detectAgentMention", () => $b5db7e004362ea4e$export$8be01f330f0c4a50);
$parcel$export(module.exports, "spliceAt", () => $b5db7e004362ea4e$export$f54d8193886cf23a);
$parcel$export(module.exports, "agentInsertText", () => $b5db7e004362ea4e$export$1608d62e16ed9acf);
$parcel$export(module.exports, "agentRoster", () => $b5db7e004362ea4e$export$2c0a5f7b93ed2b72);
$parcel$export(module.exports, "agentsFromMongo", () => $b5db7e004362ea4e$export$cf1b8634505f348b);
$parcel$export(module.exports, "filterAgentsForMention", () => $b5db7e004362ea4e$export$8ef15c775af9140b);
// @-agent mention helpers for the Simone composer. The composer is a native
// <textarea> (unlike the /chat app's contenteditable), so these are textarea-
// safe: caret = node.selectionStart, insert = a value splice. Kept small +
// dependency-free (shared can't import from the chat package).
// Detect an @-mention trigger in `value` at `caret`. Returns { query, start, end }
// or null. The `@` must be at start-of-value or preceded by whitespace, and only
// mention-ish chars may follow (letters/digits/._- and spaces for names).

var $5e5Ez = parcelRequire("5e5Ez");
const $b5db7e004362ea4e$export$8be01f330f0c4a50 = (value, caret)=>{
    if (caret == null || !value) return null;
    const upto = value.slice(0, caret);
    const at = upto.lastIndexOf('@');
    if (at < 0) return null;
    if (at > 0 && !/\s/.test(value[at - 1])) return null;
    const after = upto.slice(at + 1);
    if (!/^[a-zA-Z0-9._\- ]*$/.test(after)) return null;
    return {
        query: after,
        start: at,
        end: caret
    };
};
const $b5db7e004362ea4e$export$f54d8193886cf23a = (value, start, end, insert)=>({
        value: String(value).slice(0, start) + insert + String(value).slice(end),
        caret: start + insert.length
    });
const $b5db7e004362ea4e$export$1608d62e16ed9acf = (agent)=>{
    if (!agent) return '';
    const handle = (agent.email || '').split('@')[0] || agent.name;
    return handle ? `@${handle} ` : '';
};
// Is a roster entry an addressable agent (has a userId to target)?
const $b5db7e004362ea4e$var$isAgentEntry = (a)=>!!(a && a.userId && (a.kind === 'agent' || a.isAgent));
const $b5db7e004362ea4e$export$2c0a5f7b93ed2b72 = (root)=>{
    const out = [];
    const seen = new Set();
    for (const a of [
        ...root && root._agents || [],
        ...root && root.people || []
    ]){
        if (!$b5db7e004362ea4e$var$isAgentEntry(a)) continue;
        const key = String(a.userId);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(a);
    }
    return out;
};
const $b5db7e004362ea4e$export$cf1b8634505f348b = (list)=>(Array.isArray(list) ? list : []).map((u)=>({
            id: String(u.username || u.id || u._id || '').toLowerCase(),
            name: u.name || u.username || 'Agent',
            kind: 'agent',
            avatar: u.avatar || null,
            userId: u.id || u._id || null,
            email: u.email || null,
            // the record's per-language names (server-seeded agents), shown by
            // agentMentionLabel in the active interface language
            nameI18n: u.metadata && u.metadata.nameI18n || null
        })).filter((a)=>a.userId);
const $b5db7e004362ea4e$export$5ee25eec605f3bd7 = (a, lang)=>(0, $5e5Ez.agentDisplayName)({
        name: a && a.name || '',
        metadata: {
            nameI18n: a && a.nameI18n
        }
    }, lang);
const $b5db7e004362ea4e$export$a37a887b70fd623c = (raw)=>{
    const list = Array.isArray(raw) ? raw : raw && raw.data || [];
    // Always present, [] included — a real, verified zero must still render
    // as zero, distinguishable from "never loaded" (null) and "failed"
    // (_agentsError set).
    return {
        _agents: $b5db7e004362ea4e$export$cf1b8634505f348b(list),
        _agentsError: null
    };
};
const $b5db7e004362ea4e$export$583e14b563729e09 = (err)=>({
        _agentsError: err && err.message || 'Failed to load agents'
    });
const $b5db7e004362ea4e$export$8ef15c775af9140b = (root, query, limit = 8, lang)=>{
    const roster = $b5db7e004362ea4e$export$2c0a5f7b93ed2b72(root);
    const q = String(query || '').trim().toLowerCase();
    const matched = q ? roster.filter((a)=>{
        const name = String(a.name || '').toLowerCase();
        const shown = String($b5db7e004362ea4e$export$5ee25eec605f3bd7(a, lang) || '').toLowerCase();
        const handle = String((a.email || '').split('@')[0] || '').toLowerCase();
        return name.includes(q) || shown.includes(q) || handle.includes(q);
    }) : roster;
    return matched.slice(0, limit);
};

});


parcelRegister("90sUK", function(module, exports) {

$parcel$export(module.exports, "IntegrationScopeListItem", () => $68ea8ae7fe4086e3$export$850c47653bc5ed82);
$parcel$export(module.exports, "IntegrationScopePicker", () => $68ea8ae7fe4086e3$export$dadb819fbe33454e);
$parcel$export(module.exports, "IntegrationScopeOption", () => $68ea8ae7fe4086e3$export$43697b580c0086f5);
$parcel$export(module.exports, "IntegrationScopeModeBtn", () => $68ea8ae7fe4086e3$export$b4f033e55d74aa71);
$parcel$export(module.exports, "resolveScope", () => $68ea8ae7fe4086e3$export$37a93f4c48de2a8d);
$parcel$export(module.exports, "IntegrationScopeBadge", () => $68ea8ae7fe4086e3$export$eece0a3f8635d741);
// Shared scope picker for admin → integrations forms.
//
// Writes `{scopeType, scopeId}` into the caller's draft state (via
// `draftKey` — the name of the root state slot the page already uses,
// e.g. `_newSupabaseDraft` for the Supabase page). The caller then
// forwards those two fields to `saveIntegration({...draft, scopeType,
// scopeId})`.
//
// Scope modes:
//   - Org — whole organization. scopeId is null. Default for infra kinds
//     (github, google_workspace, npm).
//   - Workspace — a specific workspace in the org. scopeId = workspaceId.
//     Sources from root.workspaces (flat list) → root.jwtClaims.workspaces
//     (fallback). Filtered in real-time by a search input (§I12).
//   - Project — a specific project. scopeId = projectId. Sources from
//     root.projects (canvas-loaded flat list) → root._scopeProjectsByOrg
//     (governance lazy-fetch). Both sources normalised to { id, key, name }.
//
// Usage in a page:
//
//   IntegrationScopePicker: {
//     draftKey: '_newSupabaseDraft',     // required
//     defaultScopeType: 'project'        // from kind.default_scope
//   }
// SDK-only transport (integrations remediation #6) — this file's raw
// `fetch` against /projects (plus its hand-rolled channel base + localStorage
// token read) was one of the three raw-fetch leaves blocking the
// response-envelope normalisation. `sdk.getProjects` speaks the same
// contract (owner + limit) through the TokenManager.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $68ea8ae7fe4086e3$export$850c47653bc5ed82 = {
    tag: 'button',
    type: 'button',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: 'Z',
    align: 'center left',
    width: '100%',
    padding: 'V Z1',
    border: 'none',
    // A picked row is the house SELECTED state (DESIGN_LANGUAGE §8.1: the
    // `selected` wash + `title` + 700; lists keep the wash, hue never marks a
    // state — admin audit 2026-09-24). It was a blue tint and blue ink through
    // inline factories, and the static :hover had to beat that inline fill, so
    // the framework emitted !important. Now a class rule keyed on the row's own
    // aria-pressed; the rule order keeps the picked row's wash under the pointer.
    ariaPressed: (el, s)=>s._selected ? 'true' : 'false',
    background: 'transparent',
    color: 'title',
    cursor: 'pointer',
    fontSize: 'Z2',
    textAlign: 'left',
    ':hover': {
        background: 'hover'
    },
    '&[aria-pressed="true"]': {
        background: 'selected',
        fontWeight: '700',
        ':hover': {
            background: 'selected'
        }
    },
    Label: {
        tag: 'span',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s._label || ''
    },
    Check: {
        tag: 'span',
        fontSize: 'Y1',
        color: 'title',
        hide: (el, s)=>!s._selected,
        text: "\u2713"
    },
    // Generic click handler: reads _draftKey, _scopeType, _value from state.
    // Workspace list sets _scopeType:'workspace', project list sets 'project'.
    onClick: (e, el, s)=>{
        const dk = s._draftKey;
        if (!dk) return;
        const type = s._scopeType || 'project';
        const clearKey = type === 'workspace' ? '_scopeWsQuery' : '_scopeProjQuery';
        s.root.update({
            [dk]: {
                ...s.root?.[dk] || {},
                scopeType: type,
                scopeId: s._value || null,
                _scopeManualMode: false
            },
            [clearKey]: ''
        });
    }
};
const $68ea8ae7fe4086e3$export$dadb819fbe33454e = {
    // FA204 / frank trap — every helper below lives in `scope`, not module
    // scope: a bare module-scope const/function silently reads as undefined
    // once this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Called via
    // `el.scope.<name>(...)` from any descendant factory/handler. Regular
    // method syntax (not arrows) throughout — `el.scope.foo()` binds `this`
    // to `el.scope`, so a sibling helper calling another does it via
    // `this.<name>(...)` (object-literal properties can't see each other as
    // bare identifiers otherwise). `isActiveMode` (used only by the sibling
    // `IntegrationScopeModeBtn` export below) stays in THAT export's own
    // scope — `el.scope` doesn't cross top-level export boundaries.
    scope: {
        // Resolve the workspace list from the two possible root sources.
        // Priority: root.workspaces (flat array) → jwtClaims.workspaces.
        getWorkspaces (root) {
            const orgId = root?.jwtClaims?.workspace_org_id;
            const list = Array.isArray(root?.workspaces) ? root.workspaces : root?.jwtClaims?.workspaces || [];
            return orgId ? list.filter((w)=>!w.org_id || w.org_id === orgId) : list;
        },
        // Resolve the project list from the two possible root sources.
        // Priority: root.projects (canvas-loaded flat array) →
        //           root._scopeProjectsByOrg[orgId] (governance lazy-fetch).
        getProjects (root) {
            const orgId = root?.jwtClaims?.workspace_org_id;
            // Canvas context: root.projects is the full flat project list.
            if (Array.isArray(root?.projects) && root.projects.length) return root.projects.map((p)=>({
                    id: p.id || p._id || p.key,
                    key: p.key || p.slug,
                    name: p.name || p.displayName || p.key
                }));
            // Governance context: per-org API cache.
            if (orgId) {
                const cache = (root?._scopeProjectsByOrg || {})[orgId];
                if (Array.isArray(cache)) return cache;
            }
            return [];
        },
        // Case-insensitive substring filter. Checks `name` and `key` (key may be
        // absent for workspace items — that's fine, the OR short-circuits).
        filterItems (items, q) {
            if (!q) return items;
            const lq = q.toLowerCase();
            return items.filter((it)=>(it.name || it.label || '').toLowerCase().includes(lq) || (it.key || '').toLowerCase().includes(lq));
        },
        // ── Lazy project-load (governance context) ───────────────────────────
        async ensureProjectsLoaded (root, { force: force = false } = {}) {
            if (typeof window === 'undefined') return;
            const orgId = root?.jwtClaims?.workspace_org_id;
            if (!orgId) {
                this.startWatcher(root);
                return;
            }
            const cache = root._scopeProjectsByOrg || {};
            if (!force && Array.isArray(cache[orgId])) return;
            if (root._scopeProjectsInFlight?.[orgId]) return;
            root._scopeProjectsInFlight = {
                ...root._scopeProjectsInFlight || {},
                [orgId]: true
            };
            const clearFlight = ()=>{
                const flight = {
                    ...root._scopeProjectsInFlight || {}
                };
                delete flight[orgId];
                root._scopeProjectsInFlight = flight;
            };
            const orgs = root?.jwtClaims?.orgs || [];
            const org = orgs.find((o)=>(o.id || o._id) === orgId);
            const slug = org?.slug || org?.username;
            if (!slug) {
                clearFlight();
                this.startWatcher(root);
                return;
            }
            let items = [];
            let errorMsg = null;
            try {
                // The SDK's TokenManager owns auth (no localStorage read here) and the
                // channel resolver owns the base URL — a signed-out caller surfaces as a
                // rejected call, handled by the catch below just like any transport
                // failure.
                const res = await (0, $1NxyO.getSDK)().getProjects({
                    owner: slug,
                    limit: 100
                });
                // Tolerate every envelope the route has historically returned
                // ({data}, {items}, or a bare array) — the same shapes the raw reader
                // accepted, so normalising the server envelope later can't break this.
                const rows = Array.isArray(res) ? res : res?.data || res?.items || [];
                items = rows.map((p)=>({
                        id: p.id || p._id,
                        name: p.name || p.displayName || p.key,
                        key: p.key || p.slug
                    }));
            } catch (err) {
                const status = err?.status || err?.statusCode;
                errorMsg = status === 429 ? 'apps.scope.error.rateLimited' : err?.message || 'apps.scope.error.fetchFailed';
            } finally{
                root.update({
                    _scopeProjectsByOrg: {
                        ...root._scopeProjectsByOrg || {},
                        [orgId]: items
                    },
                    _scopeProjectsError: {
                        ...root._scopeProjectsError || {},
                        [orgId]: errorMsg
                    }
                });
                clearFlight();
            }
        },
        startWatcher (root) {
            if (typeof window === 'undefined') return;
            if (root._scopeProjectsWatcher) return;
            const started = Date.now();
            root._scopeProjectsWatcher = setInterval(()=>{
                const orgId = root?.jwtClaims?.workspace_org_id;
                const orgs = root?.jwtClaims?.orgs || [];
                const hasSlug = orgs.some((o)=>(o.id || o._id) === orgId && (o.slug || o.username));
                if (orgId && hasSlug) {
                    this.stopWatcher(root);
                    this.ensureProjectsLoaded(root);
                } else if (Date.now() - started > 30000) {
                    this.stopWatcher(root);
                    if (orgId) root.update({
                        _scopeProjectsByOrg: {
                            ...root._scopeProjectsByOrg || {},
                            [orgId]: []
                        },
                        _scopeProjectsError: {
                            ...root._scopeProjectsError || {},
                            [orgId]: 'apps.scope.error.sessionNotLoaded'
                        }
                    });
                }
            }, 1000);
        },
        stopWatcher (root) {
            if (root?._scopeProjectsWatcher) {
                clearInterval(root._scopeProjectsWatcher);
                root._scopeProjectsWatcher = null;
            }
        }
    },
    flow: 'y',
    gap: 'V',
    onDestroy: (el, s)=>el.scope.stopWatcher(s?.root),
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: '{{ apps.scope.title | polyglot }}'
    },
    Hint: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0 0 V 0',
        text: '{{ apps.scope.hint | polyglot }}'
    },
    Modes: {
        flow: 'x',
        gap: 'Z',
        childExtends: 'IntegrationScopeModeBtn',
        childrenAs: 'state',
        children: (el, s)=>{
            const draftKey = el?.parent?.draftKey || s.draftKey;
            return [
                'org',
                'workspace',
                'project'
            ].map((type)=>({
                    type: type,
                    label: type === 'org' ? 'apps.scope.mode.org' : type === 'workspace' ? 'apps.scope.mode.workspace' : 'apps.scope.mode.project',
                    draftKey: draftKey
                }));
        }
    },
    // ── Workspace search-dropdown (§I12) ──────────────────────────────
    WorkspaceDropdown: {
        hide: (el, s)=>{
            const draft = s.root?.[s.draftKey] || {};
            return (draft.scopeType || s.defaultScopeType || 'org') !== 'workspace';
        },
        marginTop: 'V',
        flow: 'y',
        gap: 'V',
        // Selected-value badge — shows the chosen workspace name above the list.
        SelectedBadge: {
            tag: 'span',
            padding: 'V Z',
            round: 'radiusPill',
            fontSize: 'Y1',
            fontWeight: '700',
            // the neutral plate (was a blue tint painted as a raw rgba literal)
            background: 'widgetPlate',
            color: 'title',
            hide: (el, s)=>{
                const dk = s.draftKey;
                return !dk || !(s.root?.[dk] || {}).scopeId;
            },
            text: (el, s)=>{
                const dk = s.draftKey;
                if (!dk) return '';
                const scopeId = (s.root?.[dk] || {}).scopeId;
                if (!scopeId) return '';
                const ws = el.scope.getWorkspaces(s.root);
                const found = ws.find((w)=>(w.id || w.workspace_id || w._id) === scopeId);
                return el.call('polyglot', 'apps.scope.selected').replace('{name}', found ? found.name || found.id : String(scopeId).slice(0, 10) + "\u2026");
            }
        },
        SearchInput: {
            tag: 'input',
            type: 'text',
            width: '100%',
            theme: 'field',
            minHeight: 'controlH',
            round: 'radiusControl',
            color: 'title',
            fontSize: 'Z2',
            padding: '0 A',
            placeholder: (el)=>el.call('polyglot', 'apps.scope.searchWorkspaces'),
            value: (el, s)=>s.root?._scopeWsQuery || '',
            onInput: (e, el, s)=>s.root.update({
                    _scopeWsQuery: e.target.value
                })
        },
        List: {
            flow: 'y',
            maxHeight: 'E',
            overflowY: 'auto',
            round: 'radiusControl',
            // Fill-contrast dropdown (was a `line` border — border-habit sweep,
            // design-direction.md §8) — the list's own `document` fill already
            // separates it from the page.
            background: 'document',
            childExtends: 'IntegrationScopeListItem',
            childrenAs: 'state',
            children: (el, s)=>{
                const dk = s.draftKey;
                const q = s.root?._scopeWsQuery || '';
                const curId = dk ? (s.root?.[dk] || {}).scopeId || '' : '';
                const ws = el.scope.getWorkspaces(s.root).map((w)=>({
                        id: w.id || w.workspace_id || w._id,
                        name: w.name || w.id || w.workspace_id
                    }));
                const filtered = el.scope.filterItems(ws, q);
                return filtered.map((it)=>({
                        _value: it.id,
                        _label: it.name,
                        _selected: it.id === curId,
                        _draftKey: dk,
                        _scopeType: 'workspace'
                    }));
            },
            Empty: {
                tag: 'span',
                padding: 'V Z1',
                fontSize: 'Z2',
                color: 'caption',
                fontStyle: 'italic',
                hide: (el, s)=>{
                    const dk = s.draftKey;
                    const q = s.root?._scopeWsQuery || '';
                    const ws = el.scope.getWorkspaces(s.root);
                    return el.scope.filterItems(ws, q).length > 0;
                },
                text: (el, s)=>{
                    const q = s.root?._scopeWsQuery || '';
                    const total = el.scope.getWorkspaces(s.root).length;
                    if (!total) return el.call('polyglot', 'apps.scope.ws.emptyOrg');
                    return q ? el.call('polyglot', 'apps.scope.noMatches').replace('{query}', q) : el.call('polyglot', 'apps.scope.ws.empty');
                }
            }
        }
    },
    // ── Project search-dropdown (§I12) ────────────────────────────────
    ProjectDropdown: {
        hide: (el, s)=>{
            const draft = s.root?.[s.draftKey] || {};
            return (draft.scopeType || s.defaultScopeType || 'org') !== 'project';
        },
        marginTop: 'V',
        flow: 'y',
        gap: 'V',
        // Trigger API fetch if root.projects is empty (governance context).
        onRender: (el, s)=>{
            const draft = s.root?.[s.draftKey] || {};
            const active = (draft.scopeType || s.parent?.defaultScopeType || 'org') === 'project';
            if (active && !(Array.isArray(s.root?.projects) && s.root.projects.length)) el.scope.ensureProjectsLoaded(s.root);
        },
        // Selected-value badge.
        SelectedBadge: {
            tag: 'span',
            padding: 'V Z',
            round: 'radiusPill',
            fontSize: 'Y1',
            fontWeight: '700',
            // the neutral plate (was a blue tint painted as a raw rgba literal)
            background: 'widgetPlate',
            color: 'title',
            hide: (el, s)=>{
                const dk = s.draftKey;
                return !dk || !(s.root?.[dk] || {}).scopeId;
            },
            text: (el, s)=>{
                const dk = s.draftKey;
                if (!dk) return '';
                const scopeId = (s.root?.[dk] || {}).scopeId;
                if (!scopeId) return '';
                const projects = el.scope.getProjects(s.root);
                const found = projects.find((p)=>(p.id || p.key) === scopeId);
                return el.call('polyglot', 'apps.scope.selected').replace('{name}', found ? found.name || found.key : String(scopeId).slice(0, 10) + "\u2026");
            }
        },
        // Loading / error hints.
        LoadingHint: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            fontStyle: 'italic',
            hide: (el, s)=>{
                if (Array.isArray(s.root?.projects) && s.root.projects.length) return true;
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                return orgId && Array.isArray((s.root?._scopeProjectsByOrg || {})[orgId]);
            },
            text: '{{ apps.scope.loadingProjects | polyglot }}'
        },
        ErrorHint: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'red',
            hide: (el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                return !orgId || !(s.root?._scopeProjectsError || {})[orgId];
            },
            text: (el, s)=>{
                const orgId = s.root?.jwtClaims?.workspace_org_id;
                const err = orgId ? (s.root?._scopeProjectsError || {})[orgId] : null;
                // `err` is either a bundle KEY written by `ensureProjectsLoaded` /
                // `startWatcher` (neither has an element) or a raw server message.
                // polyglot resolves the first and passes the second through.
                return err ? el.call('polyglot', 'apps.scope.proj.loadFailed').replace('{error}', el.call('polyglot', err)) : '';
            }
        },
        SearchInput: {
            tag: 'input',
            type: 'text',
            width: '100%',
            theme: 'field',
            minHeight: 'controlH',
            round: 'radiusControl',
            color: 'title',
            fontSize: 'Z2',
            padding: '0 A',
            placeholder: (el)=>el.call('polyglot', 'apps.scope.searchProjects'),
            value: (el, s)=>s.root?._scopeProjQuery || '',
            onInput: (e, el, s)=>s.root.update({
                    _scopeProjQuery: e.target.value
                })
        },
        List: {
            flow: 'y',
            maxHeight: 'E',
            overflowY: 'auto',
            round: 'radiusControl',
            // Fill-contrast dropdown (was a `line` border — border-habit sweep,
            // design-direction.md §8) — the list's own `document` fill already
            // separates it from the page.
            background: 'document',
            childExtends: 'IntegrationScopeListItem',
            childrenAs: 'state',
            children: (el, s)=>{
                const dk = s.draftKey;
                const q = s.root?._scopeProjQuery || '';
                const curId = dk ? (s.root?.[dk] || {}).scopeId || '' : '';
                const projects = el.scope.getProjects(s.root);
                const filtered = el.scope.filterItems(projects, q);
                return filtered.map((p)=>({
                        _value: p.id || p.key,
                        _label: p.name || p.key || p.id,
                        _selected: (p.id || p.key) === curId,
                        _draftKey: dk,
                        _scopeType: 'project'
                    }));
            },
            Empty: {
                tag: 'span',
                padding: 'V Z1',
                fontSize: 'Z2',
                color: 'caption',
                fontStyle: 'italic',
                hide: (el, s)=>{
                    const q = s.root?._scopeProjQuery || '';
                    const projects = el.scope.getProjects(s.root);
                    // Hide empty message while loading.
                    if (!(Array.isArray(s.root?.projects) && s.root.projects.length) && !Array.isArray((s.root?._scopeProjectsByOrg || {})[s.root?.jwtClaims?.workspace_org_id])) return true;
                    return el.scope.filterItems(projects, q).length > 0;
                },
                text: (el, s)=>{
                    const q = s.root?._scopeProjQuery || '';
                    const total = el.scope.getProjects(s.root).length;
                    if (!total) return el.call('polyglot', 'apps.scope.proj.emptyOrg');
                    return q ? el.call('polyglot', 'apps.scope.noMatches').replace('{query}', q) : el.call('polyglot', 'apps.scope.proj.empty');
                }
            }
        },
        // Toggle between list and manual-ID entry.
        ManualEntryToggle: {
            tag: 'button',
            type: 'button',
            padding: 'V Z',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y1',
            color: 'caption',
            textDecoration: 'underline',
            textAlign: 'left',
            text: (el, s)=>{
                const dk = s.draftKey;
                return el.call('polyglot', (s.root?.[dk] || {})._scopeManualMode ? 'apps.scope.proj.backToList' : 'apps.scope.proj.manualEntry');
            },
            onClick: (e, el, s)=>{
                const dk = s.draftKey;
                if (!dk) return;
                const current = s.root?.[dk] || {};
                s.root.update({
                    [dk]: {
                        ...current,
                        _scopeManualMode: !current._scopeManualMode
                    }
                });
            }
        },
        ManualEntryRow: {
            hide: (el, s)=>{
                const dk = s.draftKey;
                return !dk || !(s.root?.[dk] || {})._scopeManualMode;
            },
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'label',
                fontSize: 'Y1',
                color: 'caption',
                text: '{{ apps.scope.projectId | polyglot }}'
            },
            Input: {
                tag: 'input',
                type: 'text',
                width: '100%',
                theme: 'field',
                minHeight: 'controlH',
                round: 'radiusControl',
                color: 'title',
                fontSize: 'Z2',
                padding: '0 A',
                placeholder: 'e.g. prj_abc123',
                value: (el, s)=>(s.root?.[s.draftKey] || {}).scopeId || '',
                onInput: (e, el, s)=>{
                    const dk = s.draftKey;
                    if (!dk) return;
                    s.root.update({
                        [dk]: {
                            ...s.root?.[dk] || {},
                            scopeType: 'project',
                            scopeId: e.target.value || null,
                            _scopeManualMode: true
                        }
                    });
                }
            }
        }
    }
};
const $68ea8ae7fe4086e3$export$43697b580c0086f5 = {
    tag: 'option',
    // `label` is a KEY-IN-STATE carrier: workspace/pages/admin/module.js feeds
    // `admin.module.tier.trusted` / `.sandboxed` / `admin.module.version.latest`
    // here, and used to ship those raw dotted keys straight into the <option>.
    // A version string (`label: val`) is not a key and passes through unchanged.
    text: (el, s)=>el.call('polyglot', s.label || ''),
    onCreate: (el, s)=>{
        if (el.node) el.node.value = s.value == null ? '' : s.value;
    },
    onUpdate: (el, s)=>{
        if (el.node) el.node.value = s.value == null ? '' : s.value;
    }
};
const $68ea8ae7fe4086e3$export$b4f033e55d74aa71 = {
    // FA204 / frank trap (see IntegrationScopePicker above) — isActiveMode
    // used to be a bare module-scope const shared with IntegrationScopePicker's
    // helpers; scoped here instead since `el.scope` doesn't cross top-level
    // export boundaries and this is the only export that reads it.
    scope: {
        // Shared by background/color/hover factories below (hoisted while fixing
        // the border-habit site so the hover addition doesn't triplicate the same
        // active check a third time).
        isActiveMode (s) {
            const parent = s.parent || {};
            const draft = s.root?.[s.draftKey] || {};
            return (draft.scopeType || parent.defaultScopeType || 'org') === s.type;
        }
    },
    tag: 'button',
    type: 'button',
    minHeight: 'controlHCompact',
    padding: '0 Z',
    round: 'radiusPill',
    fontSize: 'Z',
    fontWeight: '700',
    cursor: 'pointer',
    // A CHOICE control (Nika 2026-09-23, D-1; admin audit 2026-09-24): the
    // chosen mode is the inversion — `highlight` + `highlight-reversed` — and
    // says so with aria-pressed. The idle modes are the house tonal chip
    // (`title` at 14 / 22 / 30%). It was a blue fill through inline factories,
    // including a reactive :hover the framework could only apply with
    // !important (54 declarations on /admin/integrations/github). Every state
    // is a class rule now; the chosen block comes last so it keeps its fill
    // under the pointer.
    ariaPressed: (el, s)=>el.scope.isActiveMode(s) ? 'true' : 'false',
    color: 'title',
    background: 'title.14',
    ':hover': {
        background: 'title.22'
    },
    ':active': {
        background: 'title.3'
    },
    '&[aria-pressed="true"]': {
        background: 'highlight',
        color: 'highlight-reversed',
        ':hover': {
            background: 'highlight'
        },
        ':active': {
            background: 'highlight'
        }
    },
    // KEY-IN-STATE contract. The three mode labels above still ship English:
    // their keys belong in `apps.json`, which this lane does not own.
    text: (el, s)=>el.call('polyglot', s.label || ''),
    onClick: (e, el, s)=>{
        s.root.update({
            [s.draftKey]: {
                ...s.root?.[s.draftKey] || {},
                scopeType: s.type,
                scopeId: s.type === 'org' ? null : (s.root?.[s.draftKey] || {}).scopeId || null
            },
            // Clear search queries on mode switch.
            _scopeWsQuery: '',
            _scopeProjQuery: ''
        });
    }
};
const $68ea8ae7fe4086e3$export$37a93f4c48de2a8d = (draft, defaultScopeType = 'org')=>{
    const scopeType = draft?.scopeType || defaultScopeType;
    if (scopeType === 'org') return {
        scopeType: 'org',
        scopeId: null
    };
    return {
        scopeType: scopeType,
        scopeId: draft?.scopeId || null
    };
};
const $68ea8ae7fe4086e3$export$eece0a3f8635d741 = {
    tag: 'span',
    padding: 'V Z',
    round: 'radiusPill',
    fontSize: 'Y1',
    fontWeight: '700',
    // the neutral plate: `overlayStrong` is a sheet wash, not a plate — it read
    // about 1:1 on a card
    background: 'widgetPlate',
    color: 'caption',
    text: (el, s)=>{
        const t = (k)=>el.call('polyglot', k);
        if (!s.scope_type || s.scope_type === 'org') return t('apps.scope.mode.org');
        const label = t(s.scope_type === 'workspace' ? 'apps.scope.mode.workspace' : 'apps.scope.mode.project');
        const short = s.scope_id ? `: ${String(s.scope_id).slice(0, 6)}\u{2026}` : '';
        return `${label}${short}`;
    }
};

});

parcelRegister("heR8J", function(module, exports) {

$parcel$export(module.exports, "GenericIntNewForm", () => $c8ccf6eb8814f118$export$66bd1d1d68b298dc);
$parcel$export(module.exports, "GenericIntConfigField", () => $c8ccf6eb8814f118$export$2fe77bdc79972d76);
$parcel$export(module.exports, "GenericIntInstanceCard", () => $c8ccf6eb8814f118$export$310e84e07e2f1fd);
// Host contract: route matches `/admin/integrations/<kind>` (or sets
// `root._genericIntKindOverride`); `root._integrationHub` populated by
// `loadIntegrationCatalogue`; `root._genericIntFormOpen` toggles the form.

var $2hTF2 = parcelRequire("2hTF2");

var $cAekN = parcelRequire("cAekN");
const $c8ccf6eb8814f118$export$66bd1d1d68b298dc = {
    // FA204 / frank trap — every helper below lives in `scope`, not module
    // scope: a bare module-scope const/function silently reads as undefined
    // once this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Called via
    // `el.scope.<name>(...)` from any descendant factory/handler. Regular
    // method syntax (not arrows) throughout — `el.scope.foo()` binds `this`
    // to `el.scope`, so a sibling helper calling another does it via
    // `this.<name>(...)` (object-literal properties can't see each other as
    // bare identifiers otherwise). `kindRow`/`kindFromRoot`/`toast`/`DRAFT_KEY`
    // are ALSO needed by the sibling `GenericIntInstanceCard`/
    // `GenericIntConfigField` exports below — `el.scope` only resolves within
    // the tree of the specific top-level export it's defined on, so they're
    // duplicated there rather than shared.
    scope: {
        DRAFT_KEY: '_genericIntDraft',
        kindFromRoot (root) {
            const override = root?._genericIntKindOverride;
            if (typeof override === 'string' && override) return override;
            const m = String(root?.currentPath || '').match(/^\/admin\/integrations\/([^?#/]+)/);
            return m ? m[1] : null;
        },
        kindRow (root) {
            const kind = this.kindFromRoot(root);
            if (!kind) return null;
            return (root?._integrationHub?.kinds || []).find((k)=>k.kind === kind) || null;
        },
        // ui_flow hint column (migration 0074) — tells the form which variant
        // UX to render. Today the column is populated only for registrar rows
        // (backfill) but no registrar rows exist in `integration_kinds` yet,
        // so every form instance evaluates to 'credential'. Wiring lives
        // here so MARKETPLACE's future `MarketplaceRegistrarDomainPicker` +
        // the OAuth2 connect button can drop in without touching save/delete
        // logic. See NEEDED_FOR_MARKETPLACE.md § REQUEST tick-3.
        uiFlow (root) {
            const kr = this.kindRow(root);
            return kr?.ui_flow || 'credential';
        },
        // Toast helper — openNotification depends on editor-app internals and
        // throws when GlobalNotification isn't fully wired (e.g. on the workspace app).
        // Swallowing the throw keeps the save/delete flow intact even if the
        // toast infrastructure is missing; fall back to console for diagnostics.
        toast (el, payload) {
            try {
                el.call('openNotification', payload);
            } catch (err) {
                console.warn('[integration]', payload.title, payload.message || '', err);
            }
        },
        async saveNew (el, s) {
            const orgId = s.root?.jwtClaims?.workspace_org_id;
            if (!orgId) {
                this.toast(el, {
                    title: el.call('polyglot', 'apps.integration.noWorkspace'),
                    type: 'error'
                });
                return;
            }
            const kind = this.kindFromRoot(s.root);
            const kindRow = this.kindRow(s.root);
            const draft = s.root?.[this.DRAFT_KEY] || {};
            const fields = kindRow?.config_schema?.fields || [];
            for (const f of fields)if (f.required && !draft[f.key]) {
                this.toast(el, {
                    title: el.call('polyglot', 'apps.integration.missingField.title'),
                    message: el.call('polyglot', 'apps.integration.missingField.message').replace('{field}', el.call('polyglot', f.label)),
                    type: 'error'
                });
                return;
            }
            const config = {};
            for (const f of fields)if (draft[f.key] != null && draft[f.key] !== '') config[f.key] = draft[f.key];
            const displayName = draft.displayName || config.display_name || kind;
            const slug = kindRow?.allows_multiple ? (0, $cAekN.slugify)(draft.slug || draft.displayName || kind) : 'default';
            const { scopeType: scopeType, scopeId: scopeId } = el.call('resolveScope', draft, kindRow?.default_scope || 'org');
            if ((scopeType === 'workspace' || scopeType === 'project') && !scopeId) {
                this.toast(el, {
                    title: el.call('polyglot', 'apps.integration.scopeRequired.title'),
                    message: el.call('polyglot', 'apps.integration.scopeRequired.message').replace('{scope}', scopeType),
                    type: 'error'
                });
                return;
            }
            const { ok: ok, body: body } = await (0, $2hTF2.saveIntegration)({
                orgId: orgId,
                kind: kind,
                slug: slug,
                displayName: displayName,
                config: config,
                secret: draft.secret || undefined,
                scopeType: scopeType,
                scopeId: scopeId,
                enabled: true
            });
            if (ok) {
                s.root.update({
                    [this.DRAFT_KEY]: null,
                    _genericIntFormOpen: false
                });
                // Reload the catalogue so the new instance appears in the list.
                // Host page can bolt on a `loadCatalogue` function; try el.call so
                // the form doesn't hard-couple to a specific loader name.
                try {
                    await el.call('reloadIntegrationHub');
                } catch  {}
                this.toast(el, {
                    title: el.call('polyglot', 'apps.integration.connected').replace('{name}', displayName),
                    type: 'success'
                });
            } else this.toast(el, {
                title: el.call('polyglot', 'apps.integration.connectFailed'),
                message: body?.error || el.call('polyglot', 'apps.integration.unknownError'),
                type: 'error'
            });
        }
    },
    hide: (el, s)=>!s.root?._genericIntFormOpen,
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'radiusControl',
    // Fill-contrast card (was a `line` border — border-habit sweep,
    // design-direction.md §8) — the form's own `overlay` fill already
    // separates it from its container.
    background: 'overlay',
    FormTitle: {
        tag: 'h3',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        // `{kind}` is the integration-kind record's own display name (server
        // content), interpolated into a translated frame rather than concatenated.
        text: (el, s)=>{
            const kr = el.scope.kindRow(s.root);
            return kr?.label ? el.call('polyglot', 'apps.integration.connectKind').replace('{kind}', kr.label) : el.call('polyglot', 'apps.integration.connect');
        }
    },
    DisplayName: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>!el.scope.kindRow(s.root)?.allows_multiple,
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: '{{ apps.integration.displayName | polyglot }}'
        },
        Input: {
            tag: 'input',
            type: 'text',
            width: '100%',
            theme: 'field',
            minHeight: 'controlH',
            round: 'radiusControl',
            color: 'title',
            fontSize: 'Z2',
            padding: '0 A',
            placeholder: (el, s)=>el.scope.kindRow(s.root)?.label || el.call('polyglot', 'apps.integration.displayNamePlaceholder'),
            value: (el, s)=>s.root?.[el.scope.DRAFT_KEY]?.displayName || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    [el.scope.DRAFT_KEY]: {
                        ...s.root?.[el.scope.DRAFT_KEY] || {},
                        displayName: e.target.value
                    }
                });
            }
        }
    },
    ConfigFields: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'GenericIntConfigField',
        childrenAs: 'state',
        children: (el, s)=>{
            const fields = el.scope.kindRow(s.root)?.config_schema?.fields || [];
            return fields.filter((f)=>f.key !== 'display_name');
        }
    },
    IntegrationScopePicker: {
        // Plain literal, not a factory — must match `scope.DRAFT_KEY` above
        // (kept in sync manually; both are the same '_genericIntDraft' data
        // constant, duplicated because this is a direct prop assignment
        // evaluated at declaration time, not inside a re-eval'd factory).
        draftKey: '_genericIntDraft',
        defaultScopeType: (el, s)=>el.scope.kindRow(s.root)?.default_scope || 'org'
    },
    SecretField: {
        flow: 'y',
        gap: 'V',
        // Hide when:
        //   - no kind row yet,
        //   - auth_model='none' (no credential needed),
        //   - ui_flow='oauth2' (user connects via provider dialog, not a typed secret),
        //   - ui_flow='webhook' (URL is the credential, collected in ConfigFields).
        // Registrar + credential flows keep the field visible.
        hide: (el, s)=>{
            const kr = el.scope.kindRow(s.root);
            if (!kr || kr.auth_model === 'none') return true;
            const flow = el.scope.uiFlow(s.root);
            return flow === 'oauth2' || flow === 'webhook';
        },
        Label: {
            tag: 'label',
            fontSize: 'Y2',
            color: 'caption',
            fontWeight: '700',
            text: (el, s)=>el.scope.kindRow(s.root)?.secret_label || el.call('polyglot', 'apps.integration.secretLabel')
        },
        Hint: {
            tag: 'p',
            fontSize: 'Y1',
            color: 'caption',
            margin: '0 0 V 0',
            hide: (el, s)=>!el.scope.kindRow(s.root)?.secret_hint,
            text: (el, s)=>el.scope.kindRow(s.root)?.secret_hint || ''
        },
        Input: {
            tag: 'input',
            type: 'password',
            width: '100%',
            theme: 'field',
            minHeight: 'controlH',
            round: 'radiusControl',
            color: 'title',
            fontSize: 'Z2',
            padding: '0 A',
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
            value: (el, s)=>s.root?.[el.scope.DRAFT_KEY]?.secret || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    [el.scope.DRAFT_KEY]: {
                        ...s.root?.[el.scope.DRAFT_KEY] || {},
                        secret: e.target.value
                    }
                });
            }
        }
    },
    // OAuth2 flow replaces the secret field — user connects via provider
    // dialog instead of typing a key. `startOAuthFlow` is a registered
    // function in `workspace/packages/workspace/functions/` (INTEGRATIONS
    // scope). Today it's a stub; wired fully when DOMAIN's Cloudflare
    // registrar / other OAuth2 kinds land. MARKETPLACE tick 4 spec.
    MarketplaceOAuthConnectButton: {
        if: (el, s)=>el.scope.uiFlow(s.root) === 'oauth2'
    },
    // Registrar flow adds a domain management card AFTER the secret
    // field — user enters API key first, then uses the picker to search /
    // register domains via `sdk-bridge.callCapability`. v0 is a hint
    // card; MARKETPLACE replaces with search+results UI once DOMAIN's
    // first provider handler (porkbun.ts — shipped 2026-04-24) is wired
    // into `integration-call`'s dispatch table. MARKETPLACE tick 4 spec.
    MarketplaceRegistrarDomainPicker: {
        if: (el, s)=>el.scope.uiFlow(s.root) === 'registrar'
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Z',
        CancelBtn: {
            tag: 'button',
            type: 'button',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            // Ghost fill (was transparent + `line` outline — the outlined-button
            // habit, border-habit sweep). Rest = overlay, hover = the house hover
            // wash.
            background: 'overlay',
            color: 'title',
            ':hover': {
                background: 'hover'
            },
            fontSize: 'Z2',
            cursor: 'pointer',
            text: '{{ common.action.cancel | polyglot }}',
            onClick: (e, el, s)=>{
                s.root.update({
                    _genericIntFormOpen: false,
                    [el.scope.DRAFT_KEY]: null
                });
            }
        },
        SaveBtn: {
            tag: 'button',
            type: 'button',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            // Reviewed (fixed-colour sweep): kept — fixed brand-accent CTA
            // (mirrors CancelBtn's sibling, which correctly uses adaptive `title`
            // on `overlay`; this button's own backing never adapts).
            background: 'blue',
            color: 'fillInk',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            text: (el, s)=>el.call('polyglot', s.root?._genericIntSaving ? 'apps.integration.connecting' : 'apps.integration.connect'),
            onClick: async (e, el, s)=>{
                s.root.update({
                    _genericIntSaving: true
                });
                await el.scope.saveNew(el, s);
                s.root.update({
                    _genericIntSaving: false
                });
            }
        }
    }
};
const $c8ccf6eb8814f118$export$2fe77bdc79972d76 = {
    // FA204 / frank trap (see GenericIntNewForm above) — DRAFT_KEY duplicated
    // here since `el.scope` doesn't cross top-level export boundaries.
    scope: {
        DRAFT_KEY: '_genericIntDraft'
    },
    flow: 'y',
    gap: 'V',
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>{
            const req = s.required ? ' *' : '';
            return (s.label || s.key || '') + req;
        }
    },
    Input: {
        tag: 'input',
        type: 'text',
        width: '100%',
        padding: 'Z',
        round: 'radiusControl',
        // Was a hand-rolled `background: 'document'` + `line` border — a real
        // bug found while sweeping (border-habit, design-direction.md §8): its
        // siblings in this same file (SecretField.Input, DisplayName.Input) both
        // correctly use the branded `field` theme, which already carries its own
        // state-managed border (§2.5 exception #4). This one had reinvented a
        // plain box instead of reusing it.
        theme: 'field',
        color: 'title',
        fontSize: 'Z2',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>s.root?.[el.scope.DRAFT_KEY]?.[s.key] || '',
        onInput: (e, el, s)=>{
            s.root.update({
                [el.scope.DRAFT_KEY]: {
                    ...s.root?.[el.scope.DRAFT_KEY] || {},
                    [s.key]: e.target.value
                }
            });
        }
    }
};
const $c8ccf6eb8814f118$export$310e84e07e2f1fd = {
    // FA204 / frank trap (see GenericIntNewForm above) — kindFromRoot/kindRow/
    // toast duplicated here since `el.scope` doesn't cross top-level export
    // boundaries.
    scope: {
        kindFromRoot (root) {
            const override = root?._genericIntKindOverride;
            if (typeof override === 'string' && override) return override;
            const m = String(root?.currentPath || '').match(/^\/admin\/integrations\/([^?#/]+)/);
            return m ? m[1] : null;
        },
        kindRow (root) {
            const kind = this.kindFromRoot(root);
            if (!kind) return null;
            return (root?._integrationHub?.kinds || []).find((k)=>k.kind === kind) || null;
        },
        // Toast helper — openNotification depends on editor-app internals and
        // throws when GlobalNotification isn't fully wired (e.g. on the workspace app).
        // Swallowing the throw keeps the save/delete flow intact even if the
        // toast infrastructure is missing; fall back to console for diagnostics.
        toast (el, payload) {
            try {
                el.call('openNotification', payload);
            } catch (err) {
                console.warn('[integration]', payload.title, payload.message || '', err);
            }
        },
        async deleteInstance (el, s, slug, scopeType, scopeId) {
            const orgId = s.root?.jwtClaims?.workspace_org_id;
            if (!orgId) return;
            const kind = this.kindFromRoot(s.root);
            const { ok: ok, body: body } = await (0, $2hTF2.deleteIntegration)({
                orgId: orgId,
                kind: kind,
                slug: slug,
                scopeType: scopeType,
                scopeId: scopeId
            });
            if (ok) {
                try {
                    await el.call('reloadIntegrationHub');
                } catch  {}
                this.toast(el, {
                    title: el.call('polyglot', 'apps.integration.disconnected'),
                    type: 'success'
                });
            } else this.toast(el, {
                title: el.call('polyglot', 'apps.integration.removeFailed'),
                message: body?.error || el.call('polyglot', 'apps.integration.serverError'),
                type: 'error'
            });
        },
        // ── §I12 Instance reorder helpers ───────────────────────────────────
        //
        // HTML5 drag-and-drop reorder for GenericIntInstanceCard lists.
        // We store the drag source slug on root._genericIntDragSlug so the
        // dragover / drop handlers can read it regardless of which nested
        // element fires the event.
        //
        // On drop we:
        //   1. Reorder root._integrationHub.integrations in-memory (instant UI).
        //   2. Derive the new slug order for the affected (kind, scope) subset.
        //   3. Call reorderIntegrations() to persist positions server-side.
        instancesForKindScope (root) {
            const kind = this.kindFromRoot(root);
            if (!kind) return [];
            return (root?._integrationHub?.integrations || []).filter((i)=>i.kind === kind);
        },
        reorderInHub (root, kind, fromSlug, toSlug) {
            if (fromSlug === toSlug) return;
            const all = root?._integrationHub?.integrations || [];
            const kindItems = all.filter((i)=>i.kind === kind);
            const others = all.filter((i)=>i.kind !== kind);
            const fromIdx = kindItems.findIndex((i)=>i.slug === fromSlug);
            const toIdx = kindItems.findIndex((i)=>i.slug === toSlug);
            if (fromIdx < 0 || toIdx < 0) return;
            const reordered = [
                ...kindItems
            ];
            const [moved] = reordered.splice(fromIdx, 1);
            reordered.splice(toIdx, 0, moved);
            root.update({
                _integrationHub: {
                    ...root._integrationHub,
                    integrations: [
                        ...others,
                        ...reordered
                    ]
                },
                _genericIntDragSlug: null,
                _genericIntDragOverSlug: null
            });
        },
        async persistReorder (el, s) {
            const orgId = s.root?.jwtClaims?.workspace_org_id;
            if (!orgId) return;
            const kind = this.kindFromRoot(s.root);
            if (!kind) return;
            const items = this.instancesForKindScope(s.root);
            if (items.length < 2) return;
            const kindRow = this.kindRow(s.root);
            const scopeType = items[0]?.scope_type || kindRow?.default_scope || 'org';
            const scopeId = items[0]?.scope_id || null;
            const slugs = items.map((i)=>i.slug);
            const { ok: ok, body: body } = await (0, $2hTF2.reorderIntegrations)({
                orgId: orgId,
                kind: kind,
                slugs: slugs,
                scopeType: scopeType,
                scopeId: scopeId
            });
            if (!ok) this.toast(el, {
                title: el.call('polyglot', 'apps.integration.reorderFailed'),
                message: body?.error || el.call('polyglot', 'apps.integration.unknownError'),
                type: 'error'
            });
        }
    },
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'radiusControl',
    // Fill-contrast card (was a `line` border, redundant on top of this same
    // `overlay` fill — border-habit sweep, design-direction.md §8). The
    // functional drag-over indicator moves from a border-color swap to a fill
    // swap for the same reason (states use fill, not stroke, §4.3/§8.1) —
    // it stays a hue (not `selected`) because it signals a drop TARGET, a
    // distinct transient affordance, not a selection.
    background: (el, s)=>s.root?._genericIntDragOverSlug === s.slug ? 'blue.1' : 'overlay',
    opacity: (el, s)=>s.root?._genericIntDragSlug === s.slug ? '0.4' : '1',
    // §I12 — drag-and-drop reorder
    draggable: 'true',
    onDragStart: (e, el, s)=>{
        s.root.update({
            _genericIntDragSlug: s.slug
        });
        e.dataTransfer.effectAllowed = 'move';
    },
    onDragOver: (e, el, s)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        const dragSlug = s.root?._genericIntDragSlug;
        if (dragSlug && dragSlug !== s.slug) s.root.update({
            _genericIntDragOverSlug: s.slug
        });
    },
    onDragLeave: (e, el, s)=>{
        if (s.root?._genericIntDragOverSlug === s.slug) s.root.update({
            _genericIntDragOverSlug: null
        });
    },
    onDrop: async (e, el, s)=>{
        e.preventDefault();
        const fromSlug = s.root?._genericIntDragSlug;
        const toSlug = s.slug;
        if (!fromSlug || fromSlug === toSlug) {
            s.root.update({
                _genericIntDragSlug: null,
                _genericIntDragOverSlug: null
            });
            return;
        }
        const kind = el.scope.kindFromRoot(s.root);
        el.scope.reorderInHub(s.root, kind, fromSlug, toSlug);
        await el.scope.persistReorder(el, s);
    },
    onDragEnd: (e, el, s)=>{
        s.root.update({
            _genericIntDragSlug: null,
            _genericIntDragOverSlug: null
        });
    },
    Header: {
        flow: 'x',
        align: 'center space-between',
        Left: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            DragHandle: {
                tag: 'span',
                text: "\u283F",
                color: 'caption',
                fontSize: 'A',
                cursor: 'grab',
                // Prevent text selection during drag
                userSelect: 'none'
            },
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.display_name || s.slug || ''
            },
            IntegrationScopeBadge: {}
        },
        Right: {
            flow: 'x',
            gap: 'Z',
            align: 'center',
            StatusPill: {
                padding: 'V Z',
                round: 'radiusPill',
                fontSize: 'Y1',
                fontWeight: '700',
                background: (el, s)=>s.enabled ? 'green' : 'overlayStrong',
                color: (el, s)=>s.enabled ? 'fillInk' : 'caption',
                text: (el, s)=>el.call('polyglot', s.enabled ? 'apps.integration.status.live' : 'apps.integration.status.disabled')
            },
            TestBtn: {
                tag: 'button',
                type: 'button',
                hide: (el, s)=>{
                    const caps = el.scope.kindRow(s.root)?.capabilities || [];
                    return caps.length === 0 || !s.enabled;
                },
                minHeight: 'controlHCompact',
                padding: '0 Z',
                round: 'radiusPill',
                // Ghost fill (was transparent + `line` outline — the outlined-button
                // habit, border-habit sweep). Rest = overlay, hover = the house
                // hover wash.
                background: 'overlay',
                color: 'title',
                ':hover': {
                    background: 'hover'
                },
                fontSize: 'Z',
                cursor: 'pointer',
                disabled: (el, s)=>!!s.root?._genericIntTesting?.[s.slug],
                text: (el, s)=>el.call('polyglot', s.root?._genericIntTesting?.[s.slug] ? 'apps.integration.testing' : 'apps.integration.test'),
                onClick: async (e, el, s)=>{
                    const orgId = s.root?.jwtClaims?.workspace_org_id;
                    if (!orgId) return;
                    const caps = el.scope.kindRow(s.root)?.capabilities || [];
                    if (!caps.length) return;
                    s.root.update({
                        _genericIntTesting: {
                            ...s.root?._genericIntTesting || {},
                            [s.slug]: true
                        }
                    });
                    const res = await (0, $2hTF2.callCapability)({
                        orgId: orgId,
                        kind: el.scope.kindFromRoot(s.root),
                        slug: s.slug
                    }, caps[0], {});
                    s.root.update({
                        _genericIntTesting: {
                            ...s.root?._genericIntTesting || {},
                            [s.slug]: false
                        }
                    });
                    el.scope.toast(el, res?.error ? {
                        title: el.call('polyglot', 'apps.integration.testFailed'),
                        message: res.error,
                        type: 'error'
                    } : {
                        title: el.call('polyglot', 'apps.integration.testPassed'),
                        type: 'success'
                    });
                }
            },
            RemoveBtn: {
                tag: 'button',
                type: 'button',
                minHeight: 'controlHCompact',
                padding: '0 Z',
                round: 'radiusPill',
                // Ghost fill (was transparent + `line` outline — the outlined-button
                // habit, border-habit sweep). Rest = overlay, hover = the danger
                // tint (§8.1 state matrix: danger → red ink, hover red.1).
                background: 'overlay',
                color: 'red',
                ':hover': {
                    background: 'red.1'
                },
                fontSize: 'Z',
                cursor: 'pointer',
                text: '{{ common.action.remove | polyglot }}',
                onClick: async (e, el, s)=>{
                    await el.scope.deleteInstance(el, s, s.slug, s.scope_type, s.scope_id);
                }
            }
        }
    },
    ConfigPreview: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const cfg = s.config;
            return !cfg || Object.keys(cfg).length === 0;
        },
        children: (el, s)=>{
            const cfg = s.config || {};
            return Object.entries(cfg).filter(([k])=>!k.includes('secret') && !k.includes('key') && !k.includes('token')).slice(0, 4).map(([k, v])=>({
                    key: k,
                    value: String(v)
                }));
        },
        childrenAs: 'state',
        childExtends: {
            flow: 'x',
            gap: 'Z',
            fontSize: 'Y2',
            Key: {
                color: 'caption',
                text: (el, s)=>s.key || '',
                minWidth: '120px'
            },
            Value: {
                color: 'title',
                text: (el, s)=>s.value || "\u2014",
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }
    }
};

});
parcelRegister("2hTF2", function(module, exports) {

$parcel$export(module.exports, "listOrgIntegrations", () => $1aa8586cb3812b40$export$ff50ba736d55c110);
$parcel$export(module.exports, "saveIntegration", () => $1aa8586cb3812b40$export$6b400a7c808bfba0);
$parcel$export(module.exports, "deleteIntegration", () => $1aa8586cb3812b40$export$ba41385ae01ee131);
$parcel$export(module.exports, "addIntegrationFromMarketplace", () => $1aa8586cb3812b40$export$1cf78abcf6d94c6d);
$parcel$export(module.exports, "assignIntegrationScope", () => $1aa8586cb3812b40$export$e0a7ede0704bb4eb);
$parcel$export(module.exports, "reorderIntegrations", () => $1aa8586cb3812b40$export$cd37fb6f2cf1af92);
$parcel$export(module.exports, "loadIntegrationCatalogue", () => $1aa8586cb3812b40$export$1587fb5beefd14b4);
$parcel$export(module.exports, "loadIntegrationUnits", () => $1aa8586cb3812b40$export$53f09f566140490d);
$parcel$export(module.exports, "listScopedIntegrations", () => $1aa8586cb3812b40$export$a3fb1fedb05eb6b9);
$parcel$export(module.exports, "loadOrgIntegrations", () => $1aa8586cb3812b40$export$68742fc05db98ed0);
$parcel$export(module.exports, "loadWorkspaceIntegrations", () => $1aa8586cb3812b40$export$32940dd3fd7222d6);
$parcel$export(module.exports, "loadProjectIntegrations", () => $1aa8586cb3812b40$export$bb68030dbea98deb);
$parcel$export(module.exports, "listIntegrationKinds", () => $1aa8586cb3812b40$export$670cac04aa7a321c);
$parcel$export(module.exports, "findIntegrationsByCapability", () => $1aa8586cb3812b40$export$861c105576c0b303);
$parcel$export(module.exports, "callCapability", () => $1aa8586cb3812b40$export$415cb9dbfbcf662e);
$parcel$export(module.exports, "listMarketplaceEntitlements", () => $1aa8586cb3812b40$export$616979c1cd47585a);
$parcel$export(module.exports, "checkMarketplaceEntitlement", () => $1aa8586cb3812b40$export$e4bd44fdc2b0ac47);
$parcel$export(module.exports, "installMarketplaceIntegration", () => $1aa8586cb3812b40$export$515d3ec9e43ab49e);
$parcel$export(module.exports, "uninstallMarketplaceIntegration", () => $1aa8586cb3812b40$export$6e85b9fa02462ac7);
// Client-side entry point for external integration operations.
//
// Org-owned integrations (kind='github',
// 'google_workspace', 'npm', etc.) live in the Symbols server's
// Mongo-backed `OrgIntegration` collection. Their secrets stay server-side
// (Vault / GSM) and never reach the browser — every op round-trips through
// the server's `/org-integrations/*` REST routes with the caller's SDK
// bearer token.
//
// Every op routes through the typed @symbo.ls/sdk IntegrationService (see
// `_viaSDK` below) — the SDK owns the base URL, the Mongo bearer token, and
// the route paths. Success returns the bare server payload
// (`{ ok, ... }` / `{ items: [...] }` / `{ kinds: [...] }`); failure returns
// `{ error: string, status? }` (the SDK throws, `_viaSDK` translates).
//
// The server re-checks org membership from the token: 401 on an
// unauthenticated caller, 403 on a non-member, 404 on a missing integration.
//
// Routes used here:
//   GET  /org-integrations?orgId=&scopeType=&scopeId=&kind=&includeParents=
//                                       — list org / scope integrations
//   GET  /org-integrations/kinds        — integration_kinds catalogue
//   POST /org-integrations              — upsert an integration instance
//   DEL  /org-integrations              — delete an instance (exact scope)
//   POST /org-integrations/assign-scope — move a row between scopes
//   POST /org-integrations/reorder      — persist drag-and-drop order
//   POST /org-integrations/call         — capability dispatcher (per-kind)
//   /marketplace/integrations/*         — paid-path entitlement + install
//
// The Mongo server returns canonical camelCase rows; consumers were written
// against the legacy snake_case shape, so rows/kinds are normalized at this
// boundary (see `_normalizeRow` / `_normalizeKind`).

var $cAekN = parcelRequire("cAekN");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
// SDK-only transport (workspace rule: never raw fetch from project code).
// Every op routes through the typed @symbo.ls/sdk IntegrationService methods,
// which own the base URL, the Mongo bearer token, and the
// /org-integrations|/marketplace routing — no hand-rolled fetch/URL/token here.
//
// `_viaSDK` bridges the two error conventions: the SDK THROWS on failure, but
// this module's callers expect a return-based `{ error, status? }`. On success
// the SDK's `_call` returns the bare server payload (`{ items }` / `{ kinds }` /
// `{ ok, ... }`) — identical to what the old fetch returned, so every
// downstream reader (_readList*, _fold, marketplace UI) is unchanged.
const $1aa8586cb3812b40$var$_viaSDK = async (run)=>{
    try {
        return await run((0, $1NxyO.getSDK)());
    } catch (err) {
        return {
            error: err?.message || 'request failed',
            status: err?.statusCode || err?.status
        };
    }
};
// The Mongo-backed Node server returns canonical camelCase rows; the
// Wire rows are snake_case. Consumers (loadIntegrationUnits / _fold,
// marketplace catalog, admin hub) were written against the snake_case shape,
// so normalize the Mongo rows at the SDK boundary instead of forking every
// downstream call site.
//
// `pick(snake, camel)` uses presence (`in`) rather than `??` so an explicit
// `null` value on the snake-case key (e.g. `scope_id: null` for org-scoped
// rows) is preserved instead of falling through to the camel-case sibling.
const $1aa8586cb3812b40$var$_pick = (obj, snake, camel)=>snake in obj ? obj[snake] : obj[camel];
const $1aa8586cb3812b40$var$_normalizeRow = (row)=>row && {
        ...row,
        display_name: $1aa8586cb3812b40$var$_pick(row, 'display_name', 'displayName'),
        scope_type: $1aa8586cb3812b40$var$_pick(row, 'scope_type', 'scopeType'),
        scope_id: $1aa8586cb3812b40$var$_pick(row, 'scope_id', 'scopeId'),
        has_secret: $1aa8586cb3812b40$var$_pick(row, 'has_secret', 'hasSecret'),
        updated_at: $1aa8586cb3812b40$var$_pick(row, 'updated_at', 'updatedAt')
    };
const $1aa8586cb3812b40$var$_normalizeKind = (kind)=>kind && {
        ...kind,
        auth_model: $1aa8586cb3812b40$var$_pick(kind, 'auth_model', 'authModel'),
        default_scope: $1aa8586cb3812b40$var$_pick(kind, 'default_scope', 'defaultScope'),
        allows_multiple: $1aa8586cb3812b40$var$_pick(kind, 'allows_multiple', 'allowsMultiple'),
        config_schema: $1aa8586cb3812b40$var$_pick(kind, 'config_schema', 'configSchema'),
        secret_label: $1aa8586cb3812b40$var$_pick(kind, 'secret_label', 'secretLabel'),
        secret_hint: $1aa8586cb3812b40$var$_pick(kind, 'secret_hint', 'secretHint'),
        sort_order: $1aa8586cb3812b40$var$_pick(kind, 'sort_order', 'sortOrder'),
        // CU-INT §180 — marketplace paid path. Surfaces pricing so the UI can
        // render "Free" vs "Paid" badges + use kind.pricing.stripePriceId when
        // wiring its own Checkout buttons. Null/absent on free kinds.
        pricing: kind.pricing ?? null
    };
// Mongo list endpoints return `{ items: [...] }`; legacy paths
// returned `{ integrations: [...] }`. Read either shape so the SDK is
// resilient to either side of the cutover.
const $1aa8586cb3812b40$var$_readListItems = (resp)=>resp?.items || resp?.integrations || [];
const $1aa8586cb3812b40$var$_readListIntegrations = (resp)=>$1aa8586cb3812b40$var$_readListItems(resp).map($1aa8586cb3812b40$var$_normalizeRow);
const $1aa8586cb3812b40$var$_readListKinds = (resp)=>(resp?.kinds || []).map($1aa8586cb3812b40$var$_normalizeKind);
const $1aa8586cb3812b40$export$ff50ba736d55c110 = (orgId)=>$1aa8586cb3812b40$var$_viaSDK(async (sdk)=>{
        const r = await sdk.listOrgIntegrations({
            orgId: orgId
        });
        return {
            ok: true,
            result: $1aa8586cb3812b40$var$_readListIntegrations(r)
        };
    });
const $1aa8586cb3812b40$export$6b400a7c808bfba0 = (args)=>$1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.upsertOrgIntegration(args));
const $1aa8586cb3812b40$export$ba41385ae01ee131 = (args)=>$1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.deleteOrgIntegration(args));
const $1aa8586cb3812b40$export$1cf78abcf6d94c6d = (args)=>{
    if (!args?.kind) return Promise.resolve({
        ok: false,
        body: {
            error: 'kind required'
        }
    });
    const scopeType = args.scopeType || 'org';
    return $1aa8586cb3812b40$export$6b400a7c808bfba0({
        orgId: args.orgId,
        kind: args.kind,
        slug: (0, $cAekN.slugify)(args.displayName || args.config?.display_name || args.kind),
        displayName: args.displayName || args.kind,
        config: args.config || {},
        secret: args.secret,
        scopeType: scopeType,
        scopeId: scopeType === 'org' ? null : args.scopeId || null,
        enabled: true
    });
};
const $1aa8586cb3812b40$export$e0a7ede0704bb4eb = (args)=>$1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.assignOrgIntegrationScope(args));
const $1aa8586cb3812b40$export$cd37fb6f2cf1af92 = (args)=>$1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.reorderOrgIntegrations(args));
const $1aa8586cb3812b40$export$1587fb5beefd14b4 = async (orgId)=>{
    const [kindsRes, integrationsRes] = await Promise.all([
        $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.listOrgIntegrationKinds()),
        orgId ? $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.listOrgIntegrations({
                orgId: orgId
            })) : Promise.resolve({
            items: []
        })
    ]);
    return {
        kinds: $1aa8586cb3812b40$var$_readListKinds(kindsRes),
        integrations: $1aa8586cb3812b40$var$_readListIntegrations(integrationsRes)
    };
};
// ---------- scope-aware unified reader ----------
//
// The "integration units" shape. One entry per configured kind at the
// requested scope (with parent-scope inheritance by default). Built on the
// `/org-integrations` list route (scopeType / scopeId / includeParents
// params) which handles the inheritance query server-side.
//
// Shape returned:
//   [{
//     kind, label, category, icon, description,
//     auth_model, default_scope, capabilities, allows_multiple,
//     instances: [
//       { slug, display_name, scope_type, scope_id, config, enabled, has_secret, updated_at }
//     ],
//     count
//   }, …]
//
// Scope descriptor:
//   { type: 'org' | 'workspace' | 'project', orgId, id?, includeParents? }
//
// `id` is required for workspace/project scope. `includeParents` defaults
// to true — a project view merges project + workspace + org rows so
// child contexts inherit org-wide infra (github, google_workspace, etc).
const $1aa8586cb3812b40$var$_fold = (kinds, integrations)=>{
    const byKind = {};
    for (const k of kinds || [])byKind[k.kind] = {
        kind: k.kind,
        label: k.label,
        category: k.category,
        icon: k.icon,
        description: k.description,
        auth_model: k.auth_model,
        default_scope: k.default_scope,
        capabilities: k.capabilities || [],
        allows_multiple: k.allows_multiple,
        instances: [],
        count: 0
    };
    for (const i of integrations || []){
        const unit = byKind[i.kind];
        if (!unit) continue;
        unit.instances.push({
            slug: i.slug,
            display_name: i.display_name,
            scope_type: i.scope_type,
            scope_id: i.scope_id,
            config: i.config,
            enabled: i.enabled,
            has_secret: i.has_secret,
            updated_at: i.updated_at
        });
        unit.count += 1;
    }
    return Object.values(byKind).sort((a, b)=>a.category.localeCompare(b.category));
};
const $1aa8586cb3812b40$export$53f09f566140490d = async (scope = {})=>{
    // `type` null is no type — the org default (a destructuring default fires
    // for undefined only; null reached the SDK as scopeType="null" → 400).
    const { orgId: orgId, id: id = null, includeParents: includeParents = true } = scope;
    const type = scope.type ?? 'org';
    if (!orgId) return [];
    if ((type === 'workspace' || type === 'project') && !id) throw new Error(`loadIntegrationUnits: scope.id required for type="${type}"`);
    const [kindsRes, rowsRes] = await Promise.all([
        $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.listOrgIntegrationKinds()),
        $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.listOrgIntegrations({
                orgId: orgId,
                scopeType: type,
                scopeId: id || undefined,
                includeParents: includeParents
            }))
    ]);
    return $1aa8586cb3812b40$var$_fold($1aa8586cb3812b40$var$_readListKinds(kindsRes), $1aa8586cb3812b40$var$_readListIntegrations(rowsRes));
};
const $1aa8586cb3812b40$export$a3fb1fedb05eb6b9 = async (scope = {})=>{
    // `type` null is no type — the org default (a destructuring default fires
    // for undefined only; null reached the SDK as scopeType="null" → 400).
    const { orgId: orgId, id: id = null, includeParents: includeParents = true } = scope;
    const type = scope.type ?? 'org';
    if (!orgId) return [];
    if ((type === 'workspace' || type === 'project') && !id) throw new Error(`listScopedIntegrations: scope.id required for type="${type}"`);
    const rowsRes = await $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.listOrgIntegrations({
            orgId: orgId,
            scopeType: type,
            scopeId: id || undefined,
            includeParents: includeParents
        }));
    return $1aa8586cb3812b40$var$_readListIntegrations(rowsRes);
};
const $1aa8586cb3812b40$export$68742fc05db98ed0 = (orgId, opts = {})=>$1aa8586cb3812b40$export$53f09f566140490d({
        type: 'org',
        orgId: orgId,
        ...opts
    });
const $1aa8586cb3812b40$export$32940dd3fd7222d6 = (orgId, workspaceId, opts = {})=>$1aa8586cb3812b40$export$53f09f566140490d({
        type: 'workspace',
        orgId: orgId,
        id: workspaceId,
        ...opts
    });
const $1aa8586cb3812b40$export$bb68030dbea98deb = (orgId, projectId, opts = {})=>$1aa8586cb3812b40$export$53f09f566140490d({
        type: 'project',
        orgId: orgId,
        id: projectId,
        ...opts
    });
const $1aa8586cb3812b40$export$670cac04aa7a321c = async ()=>{
    const res = await $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.listOrgIntegrationKinds());
    return $1aa8586cb3812b40$var$_readListKinds(res);
};
const $1aa8586cb3812b40$export$861c105576c0b303 = async (capability, scope)=>{
    const units = await $1aa8586cb3812b40$export$53f09f566140490d(scope);
    return units.filter((u)=>(u.capabilities || []).includes(capability));
};
const $1aa8586cb3812b40$export$415cb9dbfbcf662e = async (ref, capability, args = {})=>$1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.callOrgIntegrationCapability({
            orgId: ref.orgId,
            kind: ref.kind,
            slug: ref.slug || 'default',
            scopeType: ref.scopeType || 'org',
            scopeId: ref.scopeId ?? null,
            workspaceId: ref.workspaceId,
            capability: capability,
            args: args
        }));
const $1aa8586cb3812b40$export$616979c1cd47585a = async ({ workspaceId: workspaceId, status: status } = {})=>{
    if (!workspaceId) return {
        error: 'workspaceId required'
    };
    return $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.listMarketplaceEntitlements(workspaceId, {
            status: status
        }));
};
const $1aa8586cb3812b40$export$e4bd44fdc2b0ac47 = async ({ workspaceId: workspaceId, kind: kind } = {})=>{
    if (!workspaceId || !kind) return {
        error: 'workspaceId + kind required'
    };
    return $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.checkMarketplaceEntitlement({
            workspaceId: workspaceId,
            kind: kind
        }));
};
const $1aa8586cb3812b40$export$515d3ec9e43ab49e = async (args = {})=>{
    if (!args.orgId || !args.workspaceId || !args.kind) return {
        error: 'orgId, workspaceId, kind required'
    };
    return $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.installMarketplaceIntegration(args));
};
const $1aa8586cb3812b40$export$6e85b9fa02462ac7 = async (args = {})=>{
    if (!args.orgId || !args.workspaceId || !args.kind) return {
        error: 'orgId, workspaceId, kind required'
    };
    return $1aa8586cb3812b40$var$_viaSDK((sdk)=>sdk.uninstallMarketplaceIntegration(args));
};
const $1aa8586cb3812b40$export$a1916ca775e5fc01 = {
    normalizeRow: $1aa8586cb3812b40$var$_normalizeRow,
    normalizeKind: $1aa8586cb3812b40$var$_normalizeKind,
    readListItems: $1aa8586cb3812b40$var$_readListItems,
    readListIntegrations: $1aa8586cb3812b40$var$_readListIntegrations,
    readListKinds: $1aa8586cb3812b40$var$_readListKinds
};

});
parcelRegister("cAekN", function(module, exports) {

$parcel$export(module.exports, "slugify", () => $9293f75b19b2a7a2$export$c383cdd2a518017a);
// Lowercase, hyphen-joined, alphanumeric-only slug. Defaults to 40 chars
// max with a random fallback so callers always get a non-empty result.
const $9293f75b19b2a7a2$export$c383cdd2a518017a = (s, { maxLen: maxLen = 40, fallbackPrefix: fallbackPrefix = 'slot' } = {})=>{
    const out = String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, maxLen);
    if (out) return out;
    return `${fallbackPrefix}-${Math.random().toString(36).slice(2, 6)}`;
};

});



parcelRegister("7udiq", function(module, exports) {

$parcel$export(module.exports, "MarketplaceRegistrarDomainPicker", () => $5735a61c242f6fcb$export$602f2ba5227d76a0);
// v1 functional domain picker — upgraded from v0 hint-card per
// MARKETPLACE tick-7 REQUEST. Renders only when IntegrationConfigureForm
// detects `_uiFlow === 'registrar'` (guard in the form's slot).
//
// UI:
//   - SearchRow: input + button → calls `domain.search` capability.
//   - ResultsList: maps `searchResults` → MarketplaceRegistrarSearchResult rows.
//   - OwnedDomains: list from `domain.list` capability, fired on mount.
//
// State is local to this component's subtree (not root) — smbls v3.14
// `state: {}` scopes state inheritance so two pickers on the same page
// don't share searchResults / ownedDomains.
//
// Wiring:
//   - `callCapabilityAndSet(inflightKey, resultKey, errorKey, capability, args, state)`
//     is a helper in `workspace/packages/marketplace/functions/index.js`
//     (shipped by MARKETPLACE per tick-7). Stubs throw until wired; same
//     pattern as `startOAuthFlow`.
//   - The search + register flow hits `integration-call` edge fn (v13+)
//     with `kind = <registrar kind>` + `capability ∈ ['domain.search',
//     'domain.register', 'domain.list']` → routed via
//     `integration_kinds.registrar_provider` to the right module in
//     `_shared/registrars/` (today: porkbun.ts).
const $5735a61c242f6fcb$export$602f2ba5227d76a0 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    borderRadius: 'Z',
    // Fill-contrast panel (was `border: 'hairline solid line'` — border-habit
    // sweep, design-direction.md §8) — the panel's own `layer` wash already
    // separates it from its container.
    background: 'layer',
    marginTop: 'Z',
    state: {
        searchQuery: '',
        searching: false,
        searchResults: null,
        searchError: null,
        ownedDomains: null,
        registering: false,
        registerResult: null,
        registerError: null
    },
    // Fire `domain.list` on mount to populate the "Your domains" section.
    // Only runs when there's an API key configured (i.e. the integration
    // has been saved at least once) — the form state's `apiKey` field
    // signals that.
    onCreate: (el, s)=>{
        if (s?.apiKey) el.call('callCapabilityAndSet', 'listing', 'ownedDomains', 'listError', 'domain.list', {}, s);
    },
    Title: {
        tag: 'h5',
        text: '{{ publish.domains.management | polyglot }}',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'title',
        margin: '0'
    },
    Hint: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y',
        color: 'caption',
        // Hidden once an API key is configured.
        hide: (el, s)=>!!s?.apiKey,
        text: '{{ publish.domains.needApiKey | polyglot }}'
    },
    SearchRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        hide: (el, s)=>!s?.apiKey,
        SearchInput: {
            extends: 'Input',
            flex: '1',
            minHeight: 'controlH',
            round: 'radiusControl',
            fontSize: 'Z2',
            padding: '0 A',
            placeholder: 'example.com',
            value: (el, s)=>s.searchQuery || '',
            onInput: (e, el, s)=>s.update({
                    searchQuery: e.target.value
                })
        },
        SearchBtn: {
            extends: 'Button',
            theme: 'primary',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            fontWeight: '700',
            disabled: (el, s)=>!s.searchQuery || !!s.searching,
            text: (el, s)=>el.call('polyglot', s.searching ? 'publish.domains.searching' : 'common.action.search'),
            onClick: (e, el, s)=>el.call('callCapabilityAndSet', 'searching', 'searchResults', 'searchError', 'domain.search', {
                    query: s.searchQuery
                }, s)
        }
    },
    SearchError: {
        hide: (el, s)=>!s?.searchError,
        tag: 'p',
        fontSize: 'Y',
        color: 'danger',
        margin: '0',
        text: (el, s)=>s.searchError || ''
    },
    ResultsList: {
        flow: 'y',
        gap: 'X',
        hide: (el, s)=>!(Array.isArray(s?.searchResults) && s.searchResults.length),
        childExtends: 'MarketplaceRegistrarSearchResult',
        children: (el, s)=>s.searchResults || []
    },
    EmptyResults: {
        hide: (el, s)=>!(Array.isArray(s?.searchResults) && s.searchResults.length === 0),
        tag: 'p',
        fontSize: 'Y',
        color: 'caption',
        margin: '0',
        text: '{{ publish.domains.noResults | polyglot }}'
    },
    OwnedDomainsSection: {
        flow: 'y',
        gap: 'X',
        marginTop: 'Z',
        hide: (el, s)=>!(Array.isArray(s?.ownedDomains) && s.ownedDomains.length),
        OwnedTitle: {
            tag: 'h6',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'title',
            margin: '0',
            text: '{{ publish.domains.yours | polyglot }}'
        },
        OwnedList: {
            flow: 'y',
            gap: 'X',
            // Same mini-row component used for search results — it handles
            // the domain name + (hidden) price + (hidden) register button
            // gracefully. Here the rows surface expiration info via a simple
            // text mapping before the row.
            children: (el, s)=>(s.ownedDomains || []).map((d)=>({
                        flow: 'x',
                        align: 'center space-between',
                        gap: 'Z',
                        padding: 'Y Z',
                        borderRadius: 'Y',
                        // Fill-contrast row (was `border: 'hairline solid line'` —
                        // border-habit sweep, design-direction.md §8), same treatment as
                        // MarketplaceRegistrarSearchResult's row.
                        background: 'document',
                        Domain: {
                            tag: 'span',
                            flex: '1',
                            fontSize: 'Z2',
                            fontWeight: '500',
                            color: 'title',
                            text: d.domain || ''
                        },
                        ExpiresAt: {
                            tag: 'span',
                            fontSize: 'Y2',
                            color: 'caption',
                            text: (el)=>d.expiresAt ? el.call('polyglot', 'publish.domains.renews').replace('{date}', String(d.expiresAt).slice(0, 10)) : ''
                        }
                    }))
        }
    }
};

});

parcelRegister("eoJr3", function(module, exports) {

$parcel$export(module.exports, "MarketplaceRegistrarSearchResult", () => $a7b68d12b5c16f37$export$ddee2f9abef6784);
// Single row in MarketplaceRegistrarDomainPicker's ResultsList.
// One child per `searchResults[]` entry. Shape:
//   { domain: 'example.com', available: true, priceUsd?: 12, currencyCode?: 'USD' }
//
// Available domains show price + [Register] button; taken domains show
// "taken" muted text. Per MARKETPLACE tick-7 spec; INTEGRATIONS scaffolds.
const $a7b68d12b5c16f37$export$ddee2f9abef6784 = {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    padding: 'Y Z',
    borderRadius: 'Y',
    // Fill-contrast row (was `border: 'hairline solid line'` — border-habit
    // sweep, design-direction.md §8) — the row's own `document` fill already
    // separates it from the picker's `layer`-washed container.
    background: 'document',
    Status: {
        tag: 'span',
        fontSize: 'A',
        text: (el)=>el.parent.available ? "\u2713" : "\u2717",
        color: (el)=>el.parent.available ? 'green' : 'caption'
    },
    Domain: {
        tag: 'span',
        flex: '1',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'title',
        text: (el)=>el.parent.domain || ''
    },
    Price: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        hide: (el)=>!el.parent.available,
        text: (el)=>{
            const p = el.parent.priceUsd;
            if (p == null) return '';
            const cur = el.parent.currencyCode || 'USD';
            return cur === 'USD' ? `$${p}/yr` : `${p} ${cur}/yr`;
        }
    },
    TakenLabel: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        hide: (el)=>el.parent.available,
        text: '{{ publish.domains.taken | polyglot }}'
    },
    RegisterBtn: {
        extends: 'Button',
        hide: (el)=>!el.parent.available,
        // Register action — routes through the same capability layer.
        // `callCapabilityAndSet` is shipped by MARKETPLACE in
        // `marketplace/functions/index.js` (helper signature takes state
        // as the last arg — MARKETPLACE tick-9 fix).
        onClick: (e, el, s)=>el.call('callCapabilityAndSet', 'registering', 'registerResult', 'registerError', 'domain.register', {
                domain: el.parent.domain
            }, s),
        text: '{{ publish.domains.register | polyglot }}'
    }
};

});

parcelRegister("1oTHf", function(module, exports) {

$parcel$export(module.exports, "MarketplaceOAuthConnectButton", () => $10533c822a029449$export$16ac55d5a884edc9);
// v0 OAuth Connect button — scaffolded by INTEGRATIONS per
// MARKETPLACE tick-4 REQUEST. Replaces `SecretField` when the kind's
// `ui_flow === 'oauth2'` (already hidden by that guard). Button click
// calls the registered `startOAuthFlow(kind, {scopeType, scopeId, slug})`
// function which opens the provider's OAuth URL + handles the
// callback → Vault persistence. Today `startOAuthFlow` is a stub that
// throws a clear "not wired" error; DOMAIN's first OAuth2 provider
// (Cloudflare registrar) triggers the full implementation.
const $10533c822a029449$export$16ac55d5a884edc9 = {
    extends: 'Button',
    theme: 'primary',
    marginTop: 'Z',
    minHeight: 'controlH',
    padding: '0 A',
    round: 'radiusPill',
    fontSize: 'Z2',
    fontWeight: '700',
    text: (el, s)=>`Connect with ${s?.kindLabel || s?.kind || 'provider'}`,
    disabled: (el, s)=>!!s?.oauthInFlight,
    onClick: (e, el, s)=>el.call('startOAuthFlow', s?.kind, {
            scopeType: s?.scopeType,
            scopeId: s?.scopeId,
            slug: s?.slug
        })
};

});

parcelRegister("aFEwk", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $7c4d2a3e921400fc$export$519437715052e656);
$parcel$export(module.exports, "Modal", () => $7c4d2a3e921400fc$export$2b77a92f1a5ad772);
// Explicit delta on brand's `ModalFooter` (reuse-brand consolidation,
// 2026-08-09) rather than a from-scratch redeclaration under the same key.
// Note for the next reader: every real sharedLibraries.js in this monorepo
// loads brand BEFORE shared (`[brand, shared, ...]`), and the shared-library
// merge is first-wins (smbls/packages/utils/sharedLibraries.js
// `mergeOneLibrary`: a key is copied only when the target doesn't already
// have it) — so brand's `ModalFooter` (margin: '0 -X', order: 2, align:
// 'center space-between') already wins this exact-name collision in every
// shipped context, and this file's own definition was dead weight. Live-
// verified on the workspace-ui catalog (`/shared`, ModalFooter cell): the
// rendered spec carries `align-items:center; justify-content:space-between`
// with no padding-top rule — brand's shape, not this one. `extends` makes
// that relationship explicit instead of accidental, and keeps the intended
// top-padding delta ready in case this ever renders without brand loaded.
const $7c4d2a3e921400fc$export$519437715052e656 = {
    extends: 'ModalFooter',
    padding: 'A1 0 0 0'
};
const $7c4d2a3e921400fc$export$2b77a92f1a5ad772 = {
    // FA204 / frank trap — syncUrl/manageFocus/maybeDismiss used to be bare
    // module-scope const/function/imperative-side-effect; they read as
    // undefined once this component is frank.toJSON'd for platform delivery —
    // platform delivery reconstructs the component from its serialized props,
    // it does not execute arbitrary top-level module code (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Fixed by keeping
    // every method in `scope` (per-instance-subtree, `el.scope.X` — see
    // create.js's scope prototype chain: own → parent.scope → … → root.scope)
    // so descendants (`Window`) reach the same methods as the Modal root.
    //
    // Escape dismissal — FA409/FA503 fix (2026-08-15): this used to be a
    // single document-level `addEventListener` bound once via
    // `window.__modalEscBound`, coordinating across every Modal instance
    // through an `el.context` "topModalEl" pointer. `window.__modalEscBound`
    // is a global-object state leak (FA409) and the raw `addEventListener`
    // bypasses the framework's own event lifecycle (FA503). Replaced with the
    // pattern `AppDialog.js` already proves live (Escape bubbling from
    // whichever descendant holds focus up to a plain `onKeydown` on the
    // dialog root): `ModalWindow` already ships `tabindex: '-1'`
    // (`company/packages/brand/components/ModalWindow.js`), so `manageFocus`
    // below moves focus onto `Window` when the modal opens (and restores it
    // to the previously-focused element on close) — that's all `onKeydown`
    // needs to receive the bubbled keydown. No cross-instance coordination is
    // needed any more: each Modal instance owns its own Escape handling, so
    // there is nothing left for a "topModalEl" pointer to arbitrate.
    scope: {
        // `display` is reactive — it re-evaluates whenever `root[stateKey]`
        // changes. We piggy-back on that to detect open/close transitions and
        // sync the URL: snapshot `location.href` on open, restore it on close.
        // Any page-level hash sync (e.g. calendar.js's `_writeHash` poll)
        // converges on the same result — if the modal's state is null again,
        // that page's hash writer won't re-add a modal marker, so the restore
        // sticks.
        syncUrl (el, isOpen) {
            if (typeof window === 'undefined') return;
            if (isOpen === el._wasOpen) return;
            const wasOpen = el._wasOpen;
            el._wasOpen = isOpen;
            if (isOpen) el._urlBeforeOpen = window.location.href;
            else {
                // MOUNT is not a CLOSE: the first reactive evaluation runs with
                // `_wasOpen === undefined` and isOpen false — running the close path
                // then STRIPPED the urlParam (`?ticket=…`) off every cold-loaded
                // deep link before the modal's URL-restore could read it
                // (2026-07-25, board ?ticket links died on reload). Only a real
                // open→close transition may touch the URL.
                if (wasOpen !== true) return;
                // A modal that OWNS a URL param (declares `urlParam: '<key>'`)
                // deep-links into itself — e.g. `?ticket=<id>` (2026-06-08 per Nika
                // "open ?ticket=… and close → remove from url"). For those, STRIP
                // that param on close instead of restoring the pre-open URL: a
                // deep-linked open started WITH the param, so restoring it would
                // re-add `?ticket=` on every close (and undo the modal's own
                // _clearTicketUrl). This runs for EVERY close path — backdrop, X,
                // Escape — because they all null the stateKey, which re-fires the
                // `isOpen` reactive that calls this. Modals without `urlParam` keep
                // the original snapshot/restore behavior unchanged.
                if (typeof el.urlParam === 'string' && el.urlParam) try {
                    const u = new URL(window.location.href);
                    if (u.searchParams.has(el.urlParam)) {
                        u.searchParams.delete(el.urlParam);
                        window.history.replaceState(null, '', u.toString());
                    }
                } catch (_) {}
                else if (el._urlBeforeOpen && el._urlBeforeOpen !== window.location.href) window.history.replaceState(null, '', el._urlBeforeOpen);
                el._urlBeforeOpen = null;
            }
        },
        // Moves focus onto `Window` when the modal opens (it already carries
        // `tabindex: '-1'` via brand's `ModalWindow`, so it's programmatically
        // focusable without adding anything to the tab order) and restores focus
        // to whatever was focused before the modal opened. This is what lets
        // the plain `onKeydown` below catch Escape: the key only bubbles up to
        // an ancestor's `onKeydown` from whichever element currently holds
        // focus, so without this the Modal's own `onKeydown` would never fire
        // for a mouse-only open. Deferred a frame (matches
        // `appDialogFocusPanel.js`) so the `display`/`visibility` flip has
        // already landed in the DOM before `.focus()` runs.
        manageFocus (el, isOpen) {
            if (typeof document === 'undefined') return;
            if (isOpen === el._focusWasOpen) return;
            el._focusWasOpen = isOpen;
            if (isOpen) {
                el._returnFocusTo = document.activeElement;
                const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (fn)=>fn();
                raf(()=>{
                    const win = el.lookdown && el.lookdown('Window');
                    if (win && win.node && typeof win.node.focus === 'function') win.node.focus();
                });
            } else {
                if (el._returnFocusTo && el._returnFocusTo.focus) el._returnFocusTo.focus();
                el._returnFocusTo = null;
            }
        },
        // The shared close action — nulls `stateKey` (+ any `extraClose` merge)
        // on root state. Used by both the backdrop dismiss guard below and the
        // `onKeydown` Escape handler, so there is exactly one place that decides
        // how a Modal instance closes itself.
        close (el, s) {
            const root = s?.root;
            const sk = typeof el.stateKey === 'string' ? el.stateKey : null;
            if (!sk || !root?.update) return;
            const extra = el.extraClose && typeof el.extraClose === 'object' && !Array.isArray(el.extraClose) ? el.extraClose : null;
            root.update(extra ? {
                [sk]: null,
                ...extra
            } : {
                [sk]: null
            });
        },
        // Only direct backdrop clicks dismiss — Window's onClick below
        // stopPropagations everything inside the modal, so a click that
        // reaches here is on the backdrop layer itself.
        // THE DIALOG'S ACCESSIBLE NAME (DESIGN-WL-SHARED-MODAL-DIALOG-HAS-NO-
        // ACCESSIBLE-NAME-1). The brand ModalWindow is role=dialog + aria-modal,
        // but it never said WHICH dialog: a screen reader announced "dialog" with
        // no name. The Window now points aria-labelledby at its own heading (the
        // ModalHeader's h2, given a stable id below); a Modal with no visible
        // heading passes `ariaLabel` (on the Modal or on its Window). Never both
        // unset — a dev build warns and names the consumer.
        //
        // The Modal root is the element that holds the Window; its key names the
        // heading id (`CreateAgentModal` → `CreateAgentModalTitle`), and a
        // consumer may pin its own with `titleId`.
        modalRootOf (el) {
            let m = el;
            while(m && !m.Window && m.parent)m = m.parent;
            return m && m.Window ? m : null;
        },
        modalTitleId (el) {
            const m = this.modalRootOf(el);
            if (!m) return null;
            return m.titleId || String(m.key || 'modal').replace(/[^A-Za-z0-9_-]/g, '') + 'Title';
        },
        // A heading counts when the ModalHeader keeps its Hgroup > H and gives it
        // text (a string, a template, or a factory). Read off the definition, so
        // it answers before the children exist.
        modalHasHeading (win) {
            const h = win && win.ModalHeader && win.ModalHeader.Hgroup && win.ModalHeader.Hgroup.H;
            if (!h) return false;
            const t = h.text;
            return typeof t === 'function' || typeof t === 'string' && t.trim() !== '';
        },
        // `ariaLabel` from the Modal root (the Window's own flat `ariaLabel`, when a
        // consumer sets one, replaces the Window's factory at merge and wins).
        modalRootLabel (el) {
            const m = this.modalRootOf(el);
            const v = m && m.ariaLabel;
            const out = typeof v === 'function' ? v(m, m.state) : v;
            return out == null || out === '' ? null : out;
        },
        modalWarnUnnamed (win) {
            return;
        },
        maybeDismiss (e, el, s) {
            if (e.target !== el.node) return;
            el.scope.close(el, s);
        },
        // Is this Modal the phone bottom sheet? Yes unless its root says
        // `phoneSheet: false` — read through the root, so the root, the Window
        // and the grabber answer the same question (see `dataPhoneSheet` below).
        isPhoneSheet (el) {
            const m = this.modalRootOf(el);
            return !!m && m.phoneSheet !== false;
        }
    },
    // Escape dismissal — declarative, bubbles from whichever descendant holds
    // focus (moved onto `Window` by `manageFocus` above) up to this root. No
    // document-level listener, no global/window flag, no cross-instance
    // coordination — each Modal instance owns its own Escape handling.
    onKeydown: (e, el, s)=>{
        if (e.key === 'Escape') el.scope.close(el, s);
    },
    isOpen: (el, s)=>{
        const open = !!s.root?.[el.stateKey];
        el.scope.syncUrl(el, open);
        el.scope.manageFocus(el, open);
        return open;
    },
    // ALWAYS MOUNTED (white-label redesign 2026-09-26, DESIGN_SPEC §6.10): the
    // root used to flip `display: none` on close, so the EXIT snapped — no
    // transition can run out of `display: none`. Now the open state is the
    // `data-open` attribute — a FLAT `dataOpen` factory, never a `data: {}`
    // block a consumer's own `data` would replace (FW-ELEMENT-DEFINITION-DATA-
    // REPLACES-EXTENDS-DATA-1) — (reading `el.isOpen` here keeps syncUrl/manageFocus
    // firing) and every state is a STATIC selector rule: closed = transparent,
    // hidden and click-through, with the visibility held for the exit (`C`);
    // open = the veil fades in over `C` while the window rises on the spring.
    // The veil is the one blocking `backdrop` theme (scrim + blur) — it was the
    // bare `scrim` fill + a 4px blur.
    dataOpen: (el)=>!!el.isOpen,
    display: 'flex',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity B defaultBezier, visibility 0s linear C',
    '&[data-open]': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    position: 'fixed',
    inset: '0',
    zIndex: '2000',
    align: 'center center',
    theme: 'backdrop',
    padding: 'A',
    // THE PHONE SHEET (brand overlay law: "on a phone every blocking overlay
    // becomes the bottom sheet (top corners, grabber)" — the sheet the shared
    // AppDialog and the windows ModalLayer draw). `phoneSheet` is on by default;
    // `phoneSheet: false` keeps a Modal that is NOT a blocking overlay — a
    // dedicated page that reuses a modal as its renderer, an inline catalog
    // preview — on the inset phone frame it always had. The answer is published
    // as `data-phone-sheet` on the root, the Window and the grabber (FLAT
    // factories, the `dataOpen` rule above), and every phone-sheet rule is
    // keyed on it. Above `mobileL` nothing here applies: desktop is unchanged.
    dataPhoneSheet: (el)=>el.scope.isPhoneSheet(el),
    // The frame half: the sheet meets the screen's edges, so the veil drops its
    // gutter. An opted-out Modal keeps the `Z` gutter.
    '@mobileL': {
        padding: 'Z',
        '&[data-phone-sheet]': {
            padding: '0'
        }
    },
    // Backdrop dismiss — listen on BOTH click and mousedown so the dismiss
    // fires reliably even when something between (a fade-out transition
    // mid-flight, or a child element's stopPropagation race) would
    // otherwise swallow the click. The mousedown handler covers the case
    // where DOMQL's click handler isn't getting the e.target it expects;
    // mousedown is fired before any other handler can rebind.
    //
    // `e.target === el.node` filters to the actual backdrop layer — clicks
    // inside the Window have e.target === the inner element, so they fall
    // through this guard and the Window's content gets the click.
    onClick: (e, el, s)=>el.scope.maybeDismiss(e, el, s),
    onMousedown: (e, el, s)=>el.scope.maybeDismiss(e, el, s),
    Window: {
        extends: 'ModalWindow',
        // Stop bubbling so clicks inside the Window don't reach the
        // backdrop dismiss handler above. ModalWindow doesn't ship a default
        // onClick — without this guard the dismiss check (`e.target ===
        // el.node`) is the only thing keeping window-internal clicks from
        // closing the modal, and Chrome's event re-targeting under
        // transforms or shadow DOM can break that check in subtle ways.
        onClick: (e)=>e.stopPropagation(),
        onMousedown: (e)=>e.stopPropagation(),
        // Tab / Shift+Tab stay inside the window — the AppDialog trap. Without it
        // Tab walked out to the page behind (ws-w2, CreateAgentModal) and the
        // root's Escape handler, which only hears keys from inside the modal,
        // went deaf. Focus moves in on open and back on close (manageFocus).
        onKeydown: (e, el)=>el.call('appDialogTrapTab', e),
        boxSizing: 'border-box',
        // The centre-sheet motion (§6.4): rise 2.5% from 0.97 on the spring, leave
        // one step faster on the house curve. The pose is a custom property so
        // the phone pose below and the open rule never fight over `transform`.
        '--modal-from': 'translate3d(0, 2.5%, 0) scale(0.97)',
        transform: 'var(--modal-from)',
        transition: 'transform C defaultBezier',
        dataOpen: (el)=>!!el.parent.isOpen,
        '&[data-open]': {
            transform: 'none',
            transition: 'transform D springBezier'
        },
        // manageFocus moves focus onto the Window; the brand reset's
        // [tabindex]:focus-visible ring (a box-shadow) must not replace its
        // elevation after a keyboard open — same rule as the AppDialog panel.
        ':focus-visible': {
            boxShadow: 'var(--shadow-overlay)'
        },
        // The overflow law's sheet frame: every floating overlay sits
        // `overlayGutter` in from the viewport on each side (it was one em-based
        // `A` in total — a different inset from every AppDialog sheet).
        dataPhoneSheet: (el)=>el.scope.isPhoneSheet(el),
        '@mobileL': {
            width: '100%',
            maxWidth: 'calc(100dvw - 2 * overlayGutter)',
            maxHeight: 'calc(100dvh - 2 * overlayGutter)',
            padding: 'A',
            // Sheet presentation on mobile (DESIGN_LANGUAGE.md §7.5).
            round: 'radiusSheet',
            // the phone pose: the sheet rises from below
            '--modal-from': 'translate3d(0, 6.5%, 0)',
            // THE PHONE SHEET — the window half (the frame half is the root's own
            // `@mobileL` block): full width on the bottom edge, top corners only,
            // at most 92% of the screen so the veil above stays a dismiss target.
            // The same rule as the AppDialog phone panel:
            //   - `minWidth: '100%'` outranks any width or max-width, a consumer's
            //     own included, without a specificity fight;
            //   - `alignSelf` seats it on the bottom edge whatever the root's
            //     `align`;
            //   - the top corners through `round` itself, not the corner longhands
            //     (MobileRailSheet's form): it takes the same reactive-collision
            //     `!important` as the `round` above, so a consumer's reactive
            //     `round` (the ticket detail's) cannot keep the bottom corners;
            //   - THE HOME INDICATOR: a transparent bottom border the size of the
            //     safe-area inset — the surface paints under it, so the sheet meets
            //     the edge while the content ends above the system's swipe zone;
            //   - `position: 'relative'` makes the window the grabber's containing
            //     block (the brand ModalWindow sets it too);
            //   - THE GRABBER'S ZONE: the top inset goes back to `B` — the window's
            //     own desktop inset, the AppDialog head's phone inset and the
            //     windows sheet's — so the grabber at `Y` keeps clear of the first
            //     line (the phone `A` left it 5px). The sides keep the phone `A`.
            // The motion is the phone pose above: up 6.5% on the `D` spring, down on
            // `C` — the brand's `modalInUp` / `modalOutDown`, held as transitions
            // because this root is always mounted, so the exit still plays.
            '&[data-phone-sheet]': {
                position: 'relative',
                minWidth: '100%',
                maxHeight: '92%',
                alignSelf: 'flex-end',
                round: 'radiusSheet radiusSheet 0 0',
                borderBottomWidth: 'env(safe-area-inset-bottom)',
                borderBottomStyle: 'solid',
                borderBottomColor: 'transparent',
                paddingTop: 'B',
                transformOrigin: 'bottom center'
            }
        },
        // The phone sheet's grabber — decoration (the sheet closes by Escape, the
        // veil and Close), so aria-hidden and click-through. Absolute, so it takes
        // no flex gap and moves no content. Absent above `mobileL` and on an
        // opted-out Modal. The AppDialog grabber's tokens, so the sheets match.
        SheetGrabber: {
            ariaHidden: 'true',
            display: 'none',
            position: 'absolute',
            top: 'Y',
            left: '50%',
            width: 'grabberW',
            height: 'grabberH',
            round: 'radiusPill',
            background: 'line',
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            dataPhoneSheet: (el)=>el.scope.isPhoneSheet(el),
            '@mobileL': {
                '&[data-phone-sheet]': {
                    display: 'block'
                }
            }
        },
        // The name: the heading when there is one, else the consumer's label.
        ariaLabelledby: (el)=>el.scope.modalHasHeading(el) ? el.scope.modalTitleId(el) : null,
        ariaLabel: (el)=>el.scope.modalRootLabel(el),
        onRender: (el)=>el.scope.modalWarnUnnamed(el),
        ModalHeader: {
            Hgroup: {
                H: {
                    id: (el)=>el.scope.modalTitleId(el)
                }
            },
            // THE CLOSE BUTTON'S TOUCH AREA STAYS INSIDE THE WINDOW
            // (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1; the Finances lane's shell check).
            // The brand header pulls its Icons group into the window's padding
            // (`margin: -Y2 -Z1 - auto`), and on a coarse pointer the brand
            // IconButton grows a 6px tap slop (`:after`, inset tapSlop) around the
            // close button. On a phone the window's padding is `A`, so the slop
            // passed the window's edge and the window — a scroller — scrolled
            // sideways by 2px: measured on dev 501167cd5 with touch rules,
            // CreateAgentModal's Window scrollWidth 371 / clientWidth 369 at 393
            // (353/351 at 375, 418/416 at 440), the close button's right edge 3.8px
            // from the window's; with every `:after` off, 369/369. On a coarse
            // pointer the group pulls in by `Y` instead, so the slop ends inside the
            // padding; a mouse keeps the brand's alignment.
            Icons: {
                '@coarse': {
                    marginRight: '-Y'
                }
            }
        }
    }
};

});

parcelRegister("9Ht0m", function(module, exports) {

$parcel$export(module.exports, "AppDialog", () => $70fea0f95a4917c0$export$176734c854c40f53);
$parcel$export(module.exports, "AppDialogTitle", () => $70fea0f95a4917c0$export$86c54013fd2710e5);
$parcel$export(module.exports, "AppDialogHint", () => $70fea0f95a4917c0$export$f37bc114ad9611de);
$parcel$export(module.exports, "AppDialogHead", () => $70fea0f95a4917c0$export$5348b9bc79e4ba31);
$parcel$export(module.exports, "AppDialogBody", () => $70fea0f95a4917c0$export$25de408dbb9d59f5);
$parcel$export(module.exports, "AppDialogFoot", () => $70fea0f95a4917c0$export$2d46f9fa90bbe51b);
$parcel$export(module.exports, "AppDialogFooter", () => $70fea0f95a4917c0$export$e8da57899240059c);
// Shared modal/drawer overlay primitive — the canonical replacement for the
// hand-copied `<AppAbbrev>Overlay` + inline `theme: 'dialog'` Panel pattern
// forked across catalog/cms/commerce/crm/financials/helmet/hr/jobs/polyglot/
// scheduling/warehouse (see tickets/workspace.md "a11y: the catalog
// drawer/select/row pattern is duplicated..."). Every one of those forks was
// missing `role="dialog"`, an accessible name, and focus move-in/restore —
// this primitive owns all three plus keyboard dismissal, once, so a fix here
// reaches every consumer instead of recurring per app.
//
// Relationship to `@symbo.ls/windows` (ModalRoot/openModal/CustomTemplate,
// re-exported a few lines below in this same index): that plugin is the
// canonical IMPERATIVE, stack-based dialog host mounted once at the
// workspace SHELL root (`packages/workspace/app.js` → `ModalRoot: {}`) — the
// right tool for shell-level/cross-cutting modals (event/profile/booking)
// that call `el.call('openModal', {...})`. The 11 forked apps here are
// separately-published "workspace module" projects (own `symbols.json`,
// own manifest, injected into the shell's context at install time) whose
// existing modals are DECLARATIVE — a plain `hide: (el,s) => !s.root.flag`
// gate — not stack entries. Rewriting ~100 files across 11 independent
// projects onto the imperative stack API (state-carrier restructuring,
// `content:` closures, onConfirm/onClose rewiring) is a legitimately
// larger, separate migration; a design-meta follow-up ticket recommending
// it as the eventual destination was filed alongside this one. AppDialog
// gives every one of those files the SAME validated a11y contract
// (role, aria-modal, Tab-trap, focus-restore, Escape) TODAY via a
// mechanical, zero-state-model-change migration (swap the app's own
// `<AppAbbrev>Overlay` base for `AppDialog`) — not a competing dialog
// system, a narrower one scoped to exactly this consumption shape.
//
// ── v2: the floating overlay chassis (white-label redesign, 2026-09-26) ────
// DESIGN_SPEC §6 · IMPLEMENTATION_PLAN §2.2. One primitive, two presentations
// on a tablet or desktop, one on a phone:
//
//   AppDialog: {
//     stateKey: 'crmDealCreate',     // any root key; truthy = open (unchanged)
//     extraClose: { … },             // merged into the close write (unchanged)
//     presentation: 'center',        // 'center' (default) | 'side'
//                                    // legacy `anchor: 'right'` === 'side'
//     panelSize: 'md',               // 'sm' | 'md' | 'lg' | 'xl' → sizes
//                                    // overlaySm/Md/Lg/Xl (default: center md,
//                                    // side lg). NOT `size` — that name is a
//                                    // css-in-props shorthand (inline-size +
//                                    // block-size) and would paint on the root.
//     initialFocus: 'field',         // 'field' | 'panel' (default: center →
//                                    // field, side → panel)
//     dirty: (el, s) => boolean,     // true → a backdrop click is inert; Esc,
//                                    // Close and Cancel still close
//     closeCall: 'fnName',           // optional: a host-driven dialog names the
//                                    // function that closes it (called with the
//                                    // dialog element) instead of nulling
//                                    // stateKey — every close path uses it
//     Panel: {
//       AppDialogHead: { eyebrow, heading, titleId, subtitle },
//       AppDialogBody: { … },        // the ONLY scroll container
//       AppDialogFoot: { … }         // actions — never scrolls away
//     }
//   }
//
// A consumer WITHOUT `AppDialogBody` keeps the one scrolling Panel it always
// had (legacy mode: `B` inset, `A` gap, `overflow: auto`) — the ~160 existing
// call sites keep working while they migrate, and gain the float, the veil,
// the motion and the phone sheet for free.
//
// GEOMETRY. The root fills its frame (`absolute`, `inset: 0` — a workspace
// module mounts inside a transformed app window, which is the containing
// block of any `fixed` descendant; a `fixed` overlay would land at that
// container's scroll offset) and insets its panel by `overlayGutter`. A
// centre sheet sits in the middle; a side panel floats at the right edge,
// full height, all four corners rounded — nothing docks (P2). On a phone
// (`@mobileL`) every presentation becomes the bottom sheet: full width, the
// bottom edge, top corners only, a grabber. Alignment is flex on the root —
// the panel's `transform` is reserved for motion.
//
// MOTION (§6.4). Opacity and transform only; the veil fades, its blur never
// animates. Enter: `D` on `springBezier` (the PageSlot curve Nika approved);
// exit: `C` on `defaultBezier`. Centre rises 2.5% from 0.97, a side panel
// slides 4% from 0.98, the phone sheet rises 6.5%. The brand reset lands the
// final state at once under prefers-reduced-motion.
//
// HOW THE STATES REACH THE CSS. The root is ALWAYS mounted — `hide:` writes
// `display: none`, which kills both transitions. Open/closed and the
// presentation are published as DATA ATTRIBUTES (`data-open`,
// `data-presentation`) by reactive FLAT `dataOpen` / `dataPresentation`
// factories — never a `data: {}` block, which a consumer's own `data` object
// replaces wholesale on this runtime (FW-ELEMENT-DEFINITION-DATA-REPLACES-
// EXTENDS-DATA-1: the dialog would never open) — and every state rule is
// a STATIC selector block keyed on them (`'&[data-open]'`). Not factories:
// a factory-valued CSS prop is written INLINE, and an inline value outranks
// every `@mobileL` rule, so the phone sheet could never take over. Not `.isX`
// blocks: those apply at create only on this runtime. The phone pose rides a
// custom property (`--app-dialog-from`) so the open rule's `transform: none`
// and the phone rule never fight over one property. The framework's cascade
// tiers put these compound rules after the flat classes and the `@mobileL`
// rules after both, so the order holds whichever element minted a rule first.
//
// Closed = `inert` + `visibility: hidden` + `pointer-events: none` on the
// root, the visibility after the exit (a `C` delay on its transition; none
// on open): not focusable, out of the accessibility tree, and click-through.
// The root clips in both states, so a parked panel adds no scroll size.
//
// Dismissal: Esc (bubbles from the focused descendant to the root, which
// stops it there — only the top-most overlay closes), a backdrop click
// (inert while `dirty`), the head's Close, a footer Cancel — all four through
// the dialog's own `scope.closeNearest` (below). Tab is trapped in the Panel (appDialogTrapTab —
// NOT `inert`, which would silence the backdrop's own dismiss handlers);
// focus moves in on open (appDialogFocusPanel, honouring `initialFocus`) and
// returns to the opener on close (appDialogSync).
const $70fea0f95a4917c0$export$176734c854c40f53 = {
    // THE close path, carried by the dialog itself (frank-safe `scope`, the
    // Modal.js pattern): every descendant reaches it as `el.scope.closeNearest`
    // through the scope chain, so Esc, the veil, the head's Close and a footer
    // Cancel close the dialog in ANY function registry — a standalone module's
    // own sharedLibraries.js registers only the four 2026-08 functions.
    // `appDialogCloseNearest` (functions/) is the registered entry for code
    // outside these handlers, and delegates here.
    //
    //   from   the element that asked (the root, the veil, any Panel descendant)
    //   opts   { fromBackdrop: true } for the veil — inert while `dirty`
    //
    // Walks up to the nearest dialog root (the element that owns a Backdrop
    // and a Panel). A host-driven dialog names its own close function in
    // `closeCall`; everything else nulls `stateKey` (+ `extraClose`) on the
    // root state. Returns true when a close was requested.
    scope: {
        closeNearest (from, opts) {
            let dialog = from;
            while(dialog && !(dialog.Backdrop && dialog.Panel))dialog = dialog.parent;
            if (!dialog) return false;
            if (opts && opts.fromBackdrop && dialog.dirty) return false;
            if (typeof dialog.closeCall === 'string' && dialog.closeCall) {
                dialog.call(dialog.closeCall, dialog);
                return true;
            }
            const key = dialog.stateKey;
            const root = dialog.state && dialog.state.root;
            if (!key || !root || typeof root.update !== 'function') return false;
            const extra = dialog.extraClose && typeof dialog.extraClose === 'object' && !Array.isArray(dialog.extraClose) ? dialog.extraClose : null;
            root.update(extra ? {
                [key]: null,
                ...extra
            } : {
                [key]: null
            });
            return true;
        }
    },
    // '' = not chosen: a legacy `anchor: 'right'` then means 'side', anything
    // else 'center'. An explicit presentation always wins over `anchor`.
    presentation: '',
    panelSize: '',
    initialFocus: '',
    dirty: false,
    isOpen: (el, s)=>{
        const open = !!s.root?.[el.stateKey];
        el.call('appDialogSync', open);
        return open;
    },
    // The two state hooks every rule below keys on. Reading `el.isOpen` here is
    // also what keeps `appDialogSync` (focus in / focus back) firing on every
    // open and close — `isOpen`'s side effect only runs when an effect reads it.
    dataOpen: (el)=>!!el.isOpen,
    dataPresentation: (el)=>el.presentation === 'side' || !el.presentation && el.anchor === 'right' ? 'side' : 'center',
    // Nothing in a closed dialog is focusable or read. `visibility: hidden`
    // (below) hides the closed root, but a descendant that sets its own
    // `visibility: visible` (an inline error whose draft outlives the dialog)
    // would still take focus and be read (BESSI QA 2026-10-28). The attribute
    // leaves in the update that opens the dialog; focus moves in one frame
    // later (appDialogSync).
    inert: (el)=>el.isOpen ? null : '',
    position: 'absolute',
    // THE FRAME. `--app-dialog-inset` is the band the shell leaves free on a
    // full-page mount (below its floating header, the sheet's own margins);
    // unset = 0, the frame itself (a PageSlot pane, a module standalone). A
    // full-page mount is a scroller with no position, so the root resolves
    // against the viewport and an `inset: 0` put the side sheet under the
    // header (persona audit 2026-10-25: Bookmarks, Translations editors).
    inset: 'var(--app-dialog-inset, 0)',
    zIndex: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: 'overlayGutter',
    visibility: 'hidden',
    pointerEvents: 'none',
    // The dialog adds no scroll size, closed or open. A closed panel keeps its
    // parked transform (`--app-dialog-from`, below) and an opening one starts
    // from it: both reach past this frame, and the scroller around it took a
    // sideways scroll from them (BESSI QA 2026-10-28, 5px on dev
    // kestrel-assist /production — the route's `content`, then the document).
    // `clip`, not `hidden`: the root stays no scroll container. The open
    // panel's shadow ends at the frame edge, where the veil ends too.
    overflow: 'clip',
    transition: 'visibility 0s linear C',
    '&[data-presentation="side"]': {
        alignItems: 'stretch',
        justifyContent: 'flex-end'
    },
    '&[data-open]': {
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'visibility 0s linear 0s'
    },
    // The phone sheet touches the frame: no gutter.
    '@mobileL': {
        padding: '0'
    },
    // Escape closes from anywhere inside the dialog — keydown bubbles from
    // whichever descendant holds focus up to this root — and STOPS here, so an
    // enclosing surface (a PageSlot window, a dialog underneath) is untouched.
    onKeydown: (e, el)=>{
        if (e.key !== 'Escape') return;
        e.stopPropagation();
        el.scope.closeNearest(el);
    },
    Backdrop: {
        position: 'absolute',
        inset: '0',
        theme: 'backdrop',
        opacity: '0',
        transition: 'opacity B defaultBezier',
        dataOpen: (el)=>!!el.parent.isOpen,
        '&[data-open]': {
            opacity: '1',
            transition: 'opacity C defaultBezier'
        },
        onClick: (e, el)=>el.scope.closeNearest(el, {
                fromBackdrop: true
            })
    },
    Panel: {
        position: 'relative',
        display: 'flex',
        flow: 'y',
        boxSizing: 'border-box',
        minWidth: '0',
        minHeight: '0',
        // The size token of the presentation; a consumer's own static `width`
        // replaces this whole prop at merge and keeps winning.
        width: (el)=>{
            const p = el.parent || {};
            const side = p.presentation === 'side' || !p.presentation && p.anchor === 'right';
            const size = p.panelSize || (side ? 'lg' : 'md');
            return ({
                sm: 'overlaySm',
                md: 'overlayMd',
                lg: 'overlayLg',
                xl: 'overlayXl'
            })[size] || 'overlayMd';
        },
        maxWidth: '100%',
        maxHeight: '100%',
        // The sheet: opaque `dialog` (white / gray3) on the `overlay` elevation,
        // `radiusSheet` on all four corners in both presentations. Body copy keeps
        // the `paragraph` ink every consumer was written against.
        theme: 'dialog',
        color: 'paragraph',
        round: 'radiusSheet',
        shadow: 'overlay',
        // LEGACY vs ANATOMY. With the three anatomy slots the panel itself is a
        // non-scrolling column and AppDialogBody scrolls; without them the panel
        // is the one scroller it always was.
        padding: (el)=>el.AppDialogBody ? '0' : 'B',
        gap: (el)=>el.AppDialogBody ? '0' : 'A',
        overflow: (el)=>el.AppDialogBody ? 'hidden' : 'auto',
        overscrollBehavior: 'contain',
        // Motion: the closed pose is a custom property per presentation (and per
        // viewport, below); the open rule resets transform to none.
        '--app-dialog-from': 'translate3d(0, 2.5%, 0) scale(0.97)',
        transform: 'var(--app-dialog-from)',
        transformOrigin: 'center',
        opacity: '0',
        transition: 'opacity C defaultBezier, transform C defaultBezier',
        dataOpen: (el)=>!!el.parent.isOpen,
        dataPresentation: (el)=>{
            const p = el.parent;
            return p.presentation === 'side' || !p.presentation && p.anchor === 'right' ? 'side' : 'center';
        },
        '&[data-presentation="side"]': {
            '--app-dialog-from': 'translate3d(4%, 0, 0) scale(0.98)',
            transformOrigin: 'right center'
        },
        '&[data-open]': {
            opacity: '1',
            transform: 'none',
            transition: 'opacity D springBezier, transform D springBezier'
        },
        // THE PHONE SHEET. `minWidth: 100%` outranks any width (a consumer's own
        // included) without a specificity fight; `alignSelf` pins it to the
        // bottom whatever the root's alignment; the bottom corners square off.
        '@mobileL': {
            minWidth: '100%',
            maxHeight: '92%',
            alignSelf: 'flex-end',
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
            // THE HOME INDICATOR (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1). The sheet
            // meets the screen's bottom edge, and on an iPhone without a home
            // button the last 34pt of it are the system's swipe zone: the foot's
            // Cancel / Save sat in it (an `A` inset, ~16px, from the edge). A
            // TRANSPARENT bottom border the size of the inset: the sheet's own
            // surface paints under it (background-clip is the border box), so the
            // sheet still reaches the edge, while the content — the padding box,
            // and in a legacy panel the scrollport — ends above the zone. One rule
            // for the anatomy and the legacy panel alike; 0 wherever the device
            // reports no inset (viewport-fit=cover is set in index.html).
            borderBottomWidth: 'env(safe-area-inset-bottom)',
            borderBottomStyle: 'solid',
            borderBottomColor: 'transparent',
            '&[data-presentation]': {
                '--app-dialog-from': 'translate3d(0, 6.5%, 0)',
                transformOrigin: 'bottom center'
            }
        },
        // Dialog semantics — role/aria-modal always on. The accessible name is
        // the head's title when an AppDialogHead is present; a consumer that
        // points `ariaLabelledby` at its own title id replaces this.
        role: 'dialog',
        ariaModal: 'true',
        tabindex: '-1',
        // The panel takes focus itself (`initialFocus: 'panel'`, every side
        // panel by default). The brand reset's [tabindex]:focus-visible ring is a
        // box-shadow and would REPLACE the sheet's elevation after a keyboard
        // open (found by crm-w1 on the contact panel) — the sheet keeps it.
        ':focus-visible': {
            boxShadow: 'var(--shadow-overlay)'
        },
        ariaLabelledby: (el)=>el.AppDialogHead && el.AppDialogHead.titleId || null,
        ariaDescribedby: (el)=>{
            const head = el.AppDialogHead;
            return head && head.titleId && head.subtitle ? head.titleId + 'Hint' : null;
        },
        onKeydown: (e, el)=>el.call('appDialogTrapTab', e),
        // The phone sheet's grabber — decoration (the sheet closes by Esc, the
        // backdrop and Close; a swipe is a later addition). Absent on wider
        // screens. `line` ink: a `layer` wash (4%) reads 1.08:1 on the white
        // sheet, the hairline tone reads.
        SheetGrabber: {
            ariaHidden: 'true',
            display: 'none',
            position: 'absolute',
            top: 'Y',
            left: '50%',
            width: 'grabberW',
            height: 'grabberH',
            round: 'radiusPill',
            background: 'line',
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            '@mobileL': {
                display: 'block'
            }
        }
    }
};
const $70fea0f95a4917c0$export$86c54013fd2710e5 = {
    tag: 'h2',
    margin: '0',
    fontSize: 'B',
    fontWeight: '700',
    color: 'title'
};
const $70fea0f95a4917c0$export$f37bc114ad9611de = {
    tag: 'p',
    margin: '0',
    fontSize: 'Z1',
    color: 'inactive'
};
const $70fea0f95a4917c0$export$5348b9bc79e4ba31 = {
    extends: 'ModalHeader',
    eyebrow: '',
    heading: '',
    titleId: '',
    subtitle: '',
    flexShrink: '0',
    padding: 'B B A',
    '@mobileL': {
        padding: 'B A A'
    },
    // The brand header's own H (an h6) and P are replaced, not restyled: the
    // three texts are the house parts by name.
    Hgroup: {
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        H: null,
        P: null,
        AppMicroLabel: {
            order: '-1',
            hide: (el)=>!el.parent.parent.eyebrow,
            text: (el)=>el.call('polyglot', el.parent.parent.eyebrow || '')
        },
        AppDialogTitle: {
            lineHeight: '1.25',
            id: (el)=>el.parent.parent.titleId || null,
            text: (el)=>el.call('polyglot', el.parent.parent.heading || '')
        },
        AppDialogHint: {
            lineHeight: '1.5',
            id: (el)=>{
                const head = el.parent.parent;
                return head.titleId && head.subtitle ? head.titleId + 'Hint' : null;
            },
            hide: (el)=>!el.parent.parent.subtitle,
            text: (el)=>el.call('polyglot', el.parent.parent.subtitle || '')
        }
    },
    // THE CLOSE BUTTON'S TOUCH AREA STAYS INSIDE THE PANEL
    // (DESIGN-APPDIALOG-CLOSE-SLOP-PASSES-PANEL-EDGE-1 — the same defect class
    // Modal.js already carries for ModalWindow: ModalHeader's Icons group pulls
    // in by Z1, and on a coarse pointer the brand IconButton's 6px tap slop
    // (`:after`, inset tapSlop) then passes the head's own `A` right padding by
    // 2px at every phone width (measured dev `7e8916816668c`: 377of375, 395of393,
    // 442of440). Pulling the group in by `Y` instead on `@coarse` keeps the slop
    // inside the padding; a mouse keeps ModalHeader's own Z1 alignment.
    Icons: {
        '@coarse': {
            marginRight: '-Y'
        },
        Close: {
            onClick: (e, el)=>{
                e.stopPropagation();
                if (el.scope && el.scope.closeNearest) el.scope.closeNearest(el);
            }
        }
    }
};
const $70fea0f95a4917c0$export$25de408dbb9d59f5 = {
    flow: 'y',
    gap: 'A',
    flex: '1 1 auto',
    minHeight: '0',
    overflow: 'auto',
    overscrollBehavior: 'contain',
    padding: '0 B B',
    '@mobileL': {
        padding: '0 A A'
    }
};
const $70fea0f95a4917c0$export$2d46f9fa90bbe51b = {
    display: 'flex',
    // ONE `flex-flow: row wrap` declaration — a separate `flexWrap` would be a
    // second atomic class racing the `flow` shorthand's implied `nowrap`.
    flow: 'x wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 'Z',
    flexShrink: '0',
    padding: '0 B B',
    '@mobileL': {
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: 'minmax(0, 1fr)',
        padding: '0 A A',
        '&:has(> :nth-child(3))': {
            gridAutoFlow: 'row'
        }
    }
};
const $70fea0f95a4917c0$export$e8da57899240059c = {
    extends: 'AppDialogFoot',
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(0, 1fr)',
    justifyContent: 'stretch',
    // Each label WRAPS inside its equal column (the overflow law's text rule):
    // the brand Button atom is `nowrap`, so a Georgian "Cancel" in half of a
    // 390 px sheet spilled past its capsule.
    //
    // THE PHONE PAIR: the brand capsules own their geometry (Rule 68). Brand
    // company 6eea987 puts CancelButton and CheckButton on the house capsule
    // scale (padding `0 A`); in half of a 390 px sheet that leaves about 127 px
    // of label room, so the pair needs no phone override here. (A compact
    // override lived here for the pre-6eea987 brand, whose `Z1 D1` Cancel left
    // a ~4 px content box; it was removed before any dev build carried it.)
    childProps: {
        minWidth: '0',
        minHeight: 'controlH',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere'
    },
    CancelButton: {
        tag: 'button',
        type: 'button',
        text: '{{ common.action.cancel | polyglot }}',
        onClick: (e, el)=>{
            if (el.scope && el.scope.closeNearest) el.scope.closeNearest(el);
        }
    },
    CheckButton: {
        Icon: null,
        type: 'button',
        text: '{{ common.action.confirm | polyglot }}'
    }
};

});

parcelRegister("5ytgv", function(module, exports) {

$parcel$export(module.exports, "AppMicroLabel", () => $40b6d43012238deb$export$9d65f5f508e9a7d);
// The MICRO-LABEL — the small mono uppercase caption that labels DATA: a
// sheet's section header ("ROLES"), a KPI's name, a stage lane ("LEAD"), a
// dialog's eyebrow ("PIPELINE"), a page's app name ("CRM"). DESIGN_SPEC §5.7,
// P6 (references r044 r090 r091): the `Code` face, `Y`, weight 500, tracked
// `.06em`, uppercase, the quiet `inactive` ink (6.5:1 on `gray15`, 5.4:1 on a
// dark `gray3` sheet).
//
//   AppMicroLabel: { text: '{{ crm.section.roles | polyglot }}' }
//
// A label, never a control: buttons, tabs, navigation and titles do not use
// the mono face.
//
// Uppercase is CSS, never JS: `text-transform` leaves Georgian Mkhedruli
// alone (CSS Text 3), where `toUpperCase()` would turn it into Mtavruli
// capitals (__tests__/georgianEyebrowsStayMkhedruli.test.js).
//
// It sits on sheets and pages. On a WASHED dark row (hover / selected)
// `inactive` drops to 3.3:1 — a label inside a washed row takes
// `color: 'caption'` at the call site.
const $40b6d43012238deb$export$9d65f5f508e9a7d = {
    tag: 'span',
    fontFamily: 'Code',
    fontSize: 'Y',
    fontWeight: '500',
    lineHeight: '1.4',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    // THE TEXT LAW (overflow law §3b.8): a long eyebrow (Georgian runs long)
    // wraps inside its head instead of running past a sheet's radius clip (it
    // was `nowrap`).
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    color: 'inactive'
};

});

parcelRegister("8UxUv", function(module, exports) {

$parcel$export(module.exports, "AppKeycap", () => $67cddb94471e0ce8$export$15b5b595382e4ab1);
// The KEYCAP — one key of a keyboard shortcut, shown beside the command it
// runs: ⌘ K on the search pill, ⌘ E on a menu row (DESIGN_SPEC §5.9,
// references r004 r072). A `<kbd>`: the `Code` face at `Y` in `caption` ink,
// on the resting `layer` wash, a small rounded square at least `iconMd`
// (20px) on each side so a one-glyph key never collapses into a sliver.
//
//   Shortcut: {
//     flow: 'x', gap: 'W',
//     AppKeycap: { text: '⌘' },
//     AppKeycap_1: { text: 'K' }
//   }
//
// Render a keycap ONLY where the shortcut is wired — a keycap for a key that
// does nothing is a lie. On a menu's highlighted row the caps lift to the
// sheet (`dialog` + `float`); that rule belongs to the row (MenuPanelItem),
// which knows it is highlighted. A shortcut row names its keys to assistive
// technology with `aria-keyshortcuts` on the command itself; the caps stay
// visual. The corner is the house control radius (em-based: ~9px at the
// keycap's own `Y` type) — the design-language lock allows semantic radii
// only.
const $67cddb94471e0ce8$export$15b5b595382e4ab1 = {
    tag: 'kbd',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    minWidth: 'iconMd',
    height: 'iconMd',
    padding: '0 X',
    round: 'radiusControl',
    theme: 'layer',
    fontFamily: 'Code',
    fontSize: 'Y',
    fontWeight: '500',
    lineHeight: '1',
    color: 'caption',
    whiteSpace: 'nowrap',
    // The hook MenuPanelItem's lift rule keys on — flat, so a call-site `data`
    // object cannot replace it (FW-ELEMENT-DEFINITION-DATA-REPLACES-EXTENDS-DATA-1).
    dataKeycap: true
};

});

parcelRegister("8wp52", function(module, exports) {

$parcel$export(module.exports, "AppCombobox", () => $6344c447fc55c4ad$export$302138a4afaa0726);
// AppCombobox — a SEARCHABLE single choice for a LARGE option set (a contact
// among 301, a product among thousands). DESIGN_SPEC §5.4, L65: a native
// <select> with hundreds of rows is not acceptable UX, and the built-in
// `SearchDropdown` (system/default) fails the combobox pattern — measured
// from its source 2026-09-26: its trigger is a click-only <div> with no
// tabindex (the keyboard never reaches it), no combobox / listbox / option
// roles, no aria-expanded / aria-activedescendant, and hard-coded English.
//
//   AppCombobox: {
//     ariaLabel: (el) => el.call('polyglot', 'crm.deal.contact'),
//     placeholder: 'crm.deal.contactPlaceholder',   // a bundle key or a string
//     options: (el, s) => s.root.crmContacts.map((c) => ({
//       value: c.id, label: c.name, hint: c.email     // hint: optional
//     })),
//     current: (el, s) => s.root.crmDealDraft?.contactId,
//     select: 'crmDealSetContact'                   // el.call(select, value)
//   }
//
// The WAI-ARIA combobox (1.2, list autocomplete): the input is the combobox —
// it keeps focus the whole time; ↓ / ↑ move the active option (announced by
// aria-activedescendant), Enter picks it, Esc closes (a second Esc leaves the
// field alone), Tab closes without picking. Typing filters by label and hint,
// case- and accent-insensitively; the list shows the first `limit` matches
// and says how many more there are.
//
// THE LIST OPENS IN FLOW, under the field — a disclosure, not a floating
// popover — so no scroll container can clip it: a combobox mostly lives in a
// dialog body, which IS a scroll container (the floating form waits on the
// framework popover host, IMPLEMENTATION_PLAN §8 F2). Closed, it takes no
// box. Rows are the house list row (radiusControl, the `hover` wash, the
// `selected` wash on the active row, the check on the current value).
//
// Its own UI state (query / open / active) is LOCAL; the chosen value lives
// wherever `current` reads it and changes only through `select`.
const $6344c447fc55c4ad$export$302138a4afaa0726 = {
    options: [],
    current: null,
    select: '',
    placeholder: '',
    limit: 50,
    // The combobox's private helpers travel WITH it (frank-safe: `scope`, not
    // module-level functions); every descendant reaches them as `el.scope.X`.
    scope: {
        norm (v) {
            return String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        },
        id (box, part) {
            const path = typeof box.getPath === 'function' && box.getPath() || [
                box.key
            ];
            return 'cbx-' + path.join('-').replace(/[^\w-]/g, '') + '-' + part;
        },
        matches (box, s) {
            const all = (Array.isArray(box.options) ? box.options : []).filter(Boolean);
            const q = this.norm(s && s.query);
            const hits = q ? all.filter((o)=>this.norm(o.label).includes(q) || this.norm(o.hint).includes(q)) : all;
            const shown = hits.slice(0, box.limit || 50);
            const more = hits.length - shown.length;
            const statusKey = !hits.length ? 'common.state.noMatches' : more > 0 ? 'common.hint.keepTyping' : '';
            return {
                shown: shown,
                more: more,
                statusKey: statusKey
            };
        },
        active (box, s) {
            const n = this.matches(box, s).shown.length;
            return n ? Math.max(0, Math.min(s && s.active || 0, n - 1)) : -1;
        },
        label (box) {
            const c = box.current;
            const hit = (Array.isArray(box.options) ? box.options : []).find((o)=>o && o.value === c);
            return hit ? String(hit.label) : '';
        },
        open (box) {
            const s = box.state;
            const shown = this.matches(box, {
                query: ''
            }).shown;
            const at = shown.findIndex((o)=>o.value === box.current);
            s.update({
                open: true,
                query: '',
                active: at === -1 ? 0 : at
            });
        },
        pick (box, value) {
            if (typeof box.select === 'string' && box.select) box.call(box.select, value);
            box.state.update({
                open: false,
                query: ''
            });
        },
        reveal (box, index) {
            const list = box.ComboList && box.ComboList.node;
            const opt = box.ComboList && box.ComboList.getChildren()[index];
            if (!list || !opt || !opt.node) return;
            const top = opt.node.offsetTop;
            const bottom = top + opt.node.offsetHeight;
            if (top < list.scrollTop) list.scrollTo({
                top: top
            });
            else if (bottom > list.scrollTop + list.clientHeight) list.scrollTo({
                top: bottom - list.clientHeight
            });
        },
        key (box, e) {
            const s = box.state;
            const shown = this.matches(box, s).shown;
            const n = shown.length;
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                if (!s.open) return this.open(box);
                if (!n) return;
                const next = (this.active(box, s) + (e.key === 'ArrowDown' ? 1 : -1) + n) % n;
                s.update({
                    active: next
                });
                this.reveal(box, next);
            } else if (e.key === 'Enter') {
                if (!s.open || !n) return;
                e.preventDefault();
                this.pick(box, shown[this.active(box, s)].value);
            } else if (e.key === 'Escape') {
                // The first Esc closes the list and stops there; with the list closed
                // it bubbles on (an enclosing dialog closes).
                if (!s.open) return;
                e.preventDefault();
                e.stopPropagation();
                s.update({
                    open: false,
                    query: ''
                });
            } else if (e.key === 'Tab') {
                if (s.open) s.update({
                    open: false,
                    query: ''
                });
            }
        }
    },
    state: {
        query: '',
        open: false,
        active: 0
    },
    flow: 'y',
    gap: '0',
    width: '100%',
    minWidth: '0',
    // The field: the kit's input group (one surface, one edge, one ring).
    // `ComboList` / `ComboStatus` are distinctive on purpose — `Field`,
    // `Search`, `Group` are system/default components, and a bare key
    // auto-extends its namesake.
    AppInputGroup: {
        gap: 'Y',
        AppInputBare: {
            type: 'text',
            role: 'combobox',
            autocomplete: 'off',
            spellcheck: 'false',
            ariaAutocomplete: 'list',
            ariaExpanded: (el, s)=>s.open ? 'true' : 'false',
            ariaControls: (el)=>el.scope.id(el.parent.parent, 'list'),
            ariaActivedescendant: (el, s)=>{
                const at = s.open ? el.scope.active(el.parent.parent, s) : -1;
                return at === -1 ? null : el.scope.id(el.parent.parent, 'opt-' + at);
            },
            // the accessible name: the AppField label around the combobox, else
            // its own `ariaLabel`
            ariaLabel: (el)=>{
                const box = el.parent.parent;
                const field = box.parent;
                const own = field && field.label;
                if (own) return typeof own === 'function' ? own(field, field.state) : own;
                const v = box.ariaLabel;
                return (typeof v === 'function' ? v(box, box.state) : v) || null;
            },
            placeholder: (el)=>{
                const box = el.parent.parent;
                const v = typeof box.placeholder === 'function' ? box.placeholder(box, box.state) : box.placeholder;
                return v ? el.call('polyglot', v) : null;
            },
            // Open: what is being typed. Closed: the chosen option's label.
            value: (el, s)=>s.open ? s.query : el.scope.label(el.parent.parent),
            onFocus: (e, el)=>el.scope.open(el.parent.parent),
            onInput: (e, el, s)=>s.update({
                    query: e.target.value,
                    open: true,
                    active: 0
                }),
            onBlur: (e, el, s)=>s.update({
                    open: false,
                    query: ''
                }),
            onKeydown: (e, el)=>el.scope.key(el.parent.parent, e)
        },
        // the disclosure glyph — decoration; the field itself is the control
        Icon: {
            name: 'chevronDown',
            flexShrink: '0',
            color: 'caption',
            pointerEvents: 'none',
            ariaHidden: 'true',
            transition: 'transform A defaultBezier',
            transform: (el, s)=>s.open ? 'rotate(180deg)' : 'none'
        }
    },
    ComboList: {
        role: 'listbox',
        id: (el)=>el.scope.id(el.parent, 'list'),
        hide: (el, s)=>!s.open,
        flow: 'y',
        gap: '0',
        marginTop: 'X',
        maxHeight: 'G',
        overflow: 'auto',
        overscrollBehavior: 'contain',
        padding: 'Y',
        round: 'radiusCard',
        theme: 'layer',
        // A press inside the list must not blur the input first (that would
        // close the list before the click lands).
        onMousedown: (e)=>e.preventDefault(),
        childrenAs: 'state',
        children: (el, s)=>{
            // A closed control keeps its listbox target, but no hidden option tree.
            // Query once for the list. Each row uses its snapshot's count for the
            // active highlight instead of scanning the full option set again.
            if (!s.open) return [];
            const shown = el.scope.matches(el.parent, s).shown;
            return shown.map((o, i)=>({
                    key: 'o-' + o.value,
                    value: o.value,
                    label: String(o.label),
                    hint: o.hint ? String(o.hint) : '',
                    index: i,
                    optionCount: shown.length
                }));
        },
        childProps: {
            tag: 'div',
            role: 'option',
            id: (el, s)=>el.scope.id(el.parent.parent, 'opt-' + s.index),
            ariaSelected: (el, s)=>el.parent.parent.current === s.value ? 'true' : 'false',
            // flat hook: FW-ELEMENT-DEFINITION-DATA-REPLACES-EXTENDS-DATA-1
            dataActive: (el, s)=>s.index === Math.max(0, Math.min(el.parent.state.active || 0, s.optionCount - 1)),
            display: 'flex',
            flow: 'x',
            align: 'center',
            gap: 'Z',
            padding: 'Y Z1',
            round: 'radiusControl',
            cursor: 'pointer',
            color: 'title',
            fontSize: 'Z1',
            ':hover': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            },
            '&[data-active]': {
                background: 'selected'
            },
            onClick: (e, el, s)=>el.scope.pick(el.parent.parent, s.value),
            // THE TEXT LAW (overflow law §3b.8): the option's primary text WRAPS,
            // never an ellipsis; the hint is secondary meta — it may ellipsize, and
            // then carries its full text in `title`.
            OptionLabel: {
                tag: 'span',
                flex: '1 1 auto',
                minWidth: '0',
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                text: (el, s)=>s.label
            },
            OptionHint: {
                tag: 'span',
                flexShrink: '1',
                minWidth: '0',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 'Z',
                color: 'caption',
                hide: (el, s)=>!s.hint,
                title: (el, s)=>s.hint || null,
                text: (el, s)=>s.hint
            },
            Icon: {
                name: 'checkmark',
                flexShrink: '0',
                ariaHidden: 'true',
                visibility: (el, s)=>el.parent.parent.parent.current === s.value ? 'visible' : 'hidden'
            }
        }
    },
    // "No matches" / "12 more — keep typing": one quiet line under the rows.
    // A live region is announced only if it EXISTS before its text changes, so
    // it stays mounted (never hidden) and is simply empty — no box — when there
    // is nothing to say.
    ComboStatus: {
        tag: 'span',
        role: 'status',
        padding: '0 Z1',
        fontSize: 'Z',
        color: 'caption',
        marginTop: (el, s)=>s.open && el.scope.matches(el.parent, s).statusKey ? 'X' : '0',
        text: (el, s)=>{
            const m = s.open ? el.scope.matches(el.parent, s) : null;
            if (!m || !m.statusKey) return '';
            return el.call('polyglot', m.statusKey).replace('{count}', String(m.more));
        }
    }
};

});

parcelRegister("fa8nh", function(module, exports) {

$parcel$export(module.exports, "PartyPicker", () => $b09e492bb1a298b6$export$4ec871f73ce2727c);
// PartyPicker — THE client picker of the app family (APP-FAMILY-CONTRACT
// §3.1, gap G-D). Orders, Invoices and Production pick a client with this one
// component — and add one, with `allowCreate` — in a workspace with or
// without CRM. It IS the shared AppCombobox (the WAI-ARIA combobox: roles,
// ↓ ↑ Enter Esc Tab, the in-flow list, the status line) over the workspace's
// own Parties, plus an in-flow quick add.
//
//   PartyPicker: {
//     kind: 'company',                 // 'company' | 'person' | 'any' (default)
//     partyRole: 'customer',           // a party the quick add creates gets this role
//     current: (el, s) => s.root.ordForm.party,   // the chosen Party id
//     select: 'ordFormPickParty',      // el.call(select, { id, name, kind, taxId })
//     door: 'ordData',                 // optional — el.call(door, 'parties', op, args)
//     allowCreate: true,
//     ariaLabel: (el) => el.call('polyglot', 'ordTxFieldClient')   // optional
//   }
//
// THE NAMES. The contract's `role` and `value` are taken in DOMQL — `role` is
// the box's ARIA role, `value` an input's value — so they are `partyRole` and
// `current` here (`current` is what AppCombobox and AppSegmented already call
// the chosen value). `placeholder` and `addLabel` (the "New client" row and
// the form's title) are bundle keys or plain strings.
//
// DATA. The first open reads the directory ONCE (`parties.list`, staff left
// out with `member: 'exclude'`, `kind` unless 'any'); typing filters it at
// once — name, legal name, email, tax id and registration number (the exact
// id ranks first; spaces, dashes, dots, slashes and case do not count: the
// server's normalizeIdentityValue rule), phone (any separators, with or
// without the country code) — and asks the server too (`q`, 2+ characters,
// debounced, the newest query wins), so a row the server matches and the
// loaded rows lack still shows. The role is NOT a list filter: CRM creates
// contacts without role rows, and a role filter would hide them. Requests go
// through `door` when the app has one (the door pins the workspace), else
// straight to the L1 SDK pinned to `s.root.workspace` — never unpinned: with
// no workspace yet the read fails, says so, and the next open tries again.
// The chosen party shows its name before any open (one `parties.get`).
//
// THE QUICK ADD (`allowCreate`). The last option, "New client" (↑ from the
// first row reaches it), opens a form under the field with the typed text as
// the name: { kind, name, legalName, taxId, email, phone }. The duplicate
// rule — a tax id another party has is REFUSED: nothing is created, that
// party is returned through `select` and the status line names it. Archived
// rows count: the check asks the server for the exact id (`taxId`,
// `includeArchived`); SDK 3.14.822 drops `taxId`, so today the answer is the
// whole directory and the exact match runs here. A similar name WARNS once:
// "Use …" or "Add anyway". Keyboard: Enter in a field adds, Esc closes the
// form (and stops there, so a dialog around it stays), the focus goes to the
// name on open and back to the field — list closed — after.
//
// THE ROW WASHES are the shell's CSS variables, not the token names: an
// installed app renders under its own config, which has no `hover` /
// `selected` (the AppSegmented cause, __tests__/appSegmentedStateTokens.test.js),
// and the keyboard's active row must show there too.
//
// Helpers live in `scope` (frank-safe, any function registry). Per-instance
// timers and sequence numbers sit on the box's own scope object, written as
// `box.scope.X` — a child's `el.scope` only reads through to it.
const $b09e492bb1a298b6$export$4ec871f73ce2727c = {
    extends: 'AppCombobox',
    kind: 'any',
    partyRole: '',
    current: null,
    select: '',
    door: '',
    allowCreate: false,
    placeholder: 'common.party.placeholder',
    addLabel: 'common.party.addNew',
    ariaLabel: (el)=>el.call('polyglot', 'common.party.label'),
    searchDelay: 250,
    limit: 50,
    // Every key the picker reads is held here: a key a state lacks reads
    // through to the ROOT state.
    state: {
        query: '',
        open: false,
        active: 0,
        parties: [],
        loaded: false,
        loading: false,
        loadError: false,
        hits: [],
        hitsFor: '',
        searching: false,
        pickedId: '',
        pickedName: '',
        pickedKind: '',
        pickedTaxId: '',
        note: '',
        noteName: '',
        adding: false,
        addKind: 'company',
        addName: '',
        addLegalName: '',
        addTaxId: '',
        addEmail: '',
        addPhone: '',
        addBusy: false,
        addError: '',
        addNameError: false,
        addSimilarId: '',
        addSimilarName: ''
    },
    scope: {
        partyAddValue: '__add__',
        // ── the filter (pure) ────────────────────────────────────────────────
        partyText (v) {
            return String(v == null ? '' : v).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
        },
        // The server's identity key: spaces, dashes, dots and slashes do not
        // count, case does not count; '' when empty or longer than 64.
        partyTaxKey (v) {
            const k = String(v == null ? '' : v).replace(/[\s\-./]+/g, '').toUpperCase();
            return k.length && k.length <= 64 ? k : '';
        },
        // Digits only; a leading 00 is the international prefix.
        partyDigits (v) {
            const d = String(v == null ? '' : v).replace(/\D/g, '');
            return d.indexOf('00') === 0 ? d.slice(2) : d;
        },
        // Digits and phone separators only, 6 to 20 digits (the server's rule).
        partyPhoneShaped (v) {
            const t = String(v == null ? '' : v).trim();
            if (!/^\+?[\d\s\-().]+$/.test(t)) return false;
            const n = t.replace(/\D/g, '').length;
            return n >= 6 && n <= 20;
        },
        partyArr (v) {
            return Array.isArray(v) ? v : [];
        },
        // The search keys of a row, computed once per row.
        partyKeys (r) {
            return {
                name: this.partyText(r.name),
                legal: this.partyText(r.legalName),
                tax: this.partyTaxKey(r.taxId),
                reg: this.partyTaxKey(r.regNo),
                emails: this.partyArr(r.emails).map((e)=>this.partyText(e)),
                phones: this.partyArr(r.phones).map((p)=>this.partyDigits(p))
            };
        },
        // A server row (the Party DTO) → the compact row the picker keeps.
        partyRow (p) {
            if (!p || typeof p !== 'object') return null;
            const rawId = p.id != null ? p.id : p._id;
            if (rawId == null || rawId === '') return null;
            const str = (v)=>v == null ? '' : String(v).trim();
            const values = (list, first)=>{
                const out = [];
                const push = (v)=>{
                    const t = str(v && typeof v === 'object' ? v.value : v);
                    if (t && out.indexOf(t) === -1) out.push(t);
                };
                push(first);
                for (const v of Array.isArray(list) ? list : [])push(v);
                return out;
            };
            const id = String(rawId);
            const person = [
                str(p.firstName),
                str(p.lastName)
            ].filter(Boolean).join(' ');
            const row = {
                id: id,
                name: str(p.name) || person || str(p.legalName) || id,
                kind: p.kind === 'person' || p.kind === 'company' ? p.kind : '',
                taxId: str(p.taxId),
                regNo: str(p.regNo),
                legalName: str(p.legalName),
                emails: values(p.emails, p.primaryEmail || p.email),
                phones: values(p.phones, p.phoneE164 || p.phone),
                member: p.user != null && p.user !== '',
                archived: !!p.archivedAt,
                gone: !!p.deleted || p.mergedInto != null && p.mergedInto !== ''
            };
            row.find = this.partyKeys(row);
            return row;
        },
        // A list answer (an array or { data: [] }) → compact rows.
        partyRows (res) {
            const list = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
            const out = [];
            for (const p of list){
                const r = this.partyRow(p);
                if (r) out.push(r);
            }
            return out;
        },
        // A one-row answer (the row or { data: row }).
        partyOne (res) {
            return res && typeof res === 'object' && res.data && typeof res.data === 'object' ? res.data : res;
        },
        partyKindOf (box) {
            const k = String(box && box.kind || '').toLowerCase();
            return k === 'company' || k === 'person' ? k : 'any';
        },
        // Listed: a client — never staff (a member's party), never archived or
        // merged away — of the asked kind.
        partyListable (r, kind) {
            if (!r || r.member || r.archived || r.gone) return false;
            return kind === 'company' || kind === 'person' ? r.kind === kind : true;
        },
        // A match → its rank (0 is best); -1: no match. The exact tax id (or
        // registration number) first; the name — a prefix, a word start, a
        // contains — with the legal name under each; then a tax-id fragment,
        // an email, a phone.
        partyRank (r, query) {
            const q = this.partyText(query);
            if (!q) return 0;
            const f = r.find || this.partyKeys(r);
            const qTax = this.partyTaxKey(query);
            if (qTax && (qTax === f.tax || qTax === f.reg)) return 0;
            if (f.name.indexOf(q) === 0) return 1;
            if (f.legal && f.legal.indexOf(q) === 0) return 2;
            const wordStart = (t)=>t.split(/[^\p{L}\p{N}@.]+/u).some((w)=>w && w.indexOf(q) === 0);
            if (wordStart(f.name) || f.legal && wordStart(f.legal)) return 3;
            if (f.name.indexOf(q) >= 0 || f.legal && f.legal.indexOf(q) >= 0) return 4;
            if (qTax.length >= 3 && (f.tax && f.tax.indexOf(qTax) >= 0 || f.reg && f.reg.indexOf(qTax) >= 0)) return 5;
            if (f.emails.some((e)=>e.indexOf(q) >= 0)) return 6;
            if (this.partyPhoneShaped(query)) {
                const qd = this.partyDigits(query);
                if (f.phones.some((d)=>d.length >= 6 && (d.indexOf(qd) >= 0 || qd.indexOf(d) >= 0))) return 7;
            }
            return -1;
        },
        // The listed rows that match, best first, then by name.
        partyFilter (rows, query, kind) {
            const k = kind === 'company' || kind === 'person' ? kind : 'any';
            const ranked = [];
            for (const r of this.partyArr(rows)){
                if (!this.partyListable(r, k)) continue;
                const rank = this.partyRank(r, query);
                if (rank >= 0) ranked.push({
                    r: r,
                    rank: rank
                });
            }
            ranked.sort((a, b)=>a.rank - b.rank || a.r.name.localeCompare(b.r.name));
            return ranked.map((x)=>x.r);
        },
        // The quick add's duplicate rule → { exact, similar }. `exact`: a party
        // with the same tax id — archived ones count (the add is refused).
        // `similar`: a live party whose name or legal name is the same, or holds
        // the other (4+ letters; shorter names compare whole) — warned once.
        // Staff and merged rows are never the existing client.
        partyDuplicate (draft, rows) {
            const d = draft || {};
            const list = this.partyArr(rows).filter((r)=>r && !r.member && !r.gone);
            const tax = this.partyTaxKey(d.taxId);
            const exact = tax ? list.find((r)=>this.partyTaxKey(r.taxId) === tax) || null : null;
            const name = this.partyText(d.name);
            let similar = null;
            if (name) {
                const near = (t)=>t.length >= 4 && (t.indexOf(name) >= 0 || name.indexOf(t) >= 0);
                similar = list.find((r)=>{
                    if (r.archived) return false;
                    const own = this.partyText(r.name);
                    const legal = this.partyText(r.legalName);
                    if (own === name || legal && legal === name) return true;
                    if (name.length < 4) return false;
                    return near(own) || !!legal && near(legal);
                }) || null;
            }
            return {
                exact: exact,
                similar: similar
            };
        },
        // What `select` receives: exactly { id, name, kind, taxId }.
        partySummary (r) {
            if (!r) return null;
            return {
                id: r.id,
                name: r.name,
                kind: r.kind || null,
                taxId: r.taxId || null
            };
        },
        // The row's secondary line: what tells two similar clients apart.
        partyHint (r) {
            const parts = [];
            if (r.legalName && this.partyText(r.legalName) !== this.partyText(r.name)) parts.push(r.legalName);
            if (r.taxId) parts.push(r.taxId);
            const contact = this.partyArr(r.emails)[0] || this.partyArr(r.phones)[0];
            if (contact) parts.push(contact);
            return parts.join(" \xb7 ");
        },
        // A bundle string with its {name} filled (a function replacement: a
        // name with `$&` in it stays as typed).
        partyCopy (box, key, name) {
            const text = String(box.call('polyglot', key) || '');
            return text.replace(/\{name\}/g, ()=>String(name == null ? '' : name));
        },
        // ── the combobox, specialised ──────────────────────────────────────
        partyCurrent (box) {
            const c = box.current;
            return c == null ? '' : String(c);
        },
        partyPicked (st) {
            return this.partyRow({
                id: st.pickedId,
                name: st.pickedName,
                kind: st.pickedKind,
                taxId: st.pickedTaxId
            });
        },
        partyFind (box, id) {
            const want = id == null ? '' : String(id);
            if (!want) return null;
            const s = box.state;
            for (const r of this.partyArr(s.parties))if (r && r.id === want) return r;
            for (const r of this.partyArr(s.hits))if (r && r.id === want) return r;
            return s.pickedId === want ? this.partyPicked(s) : null;
        },
        partyMatches (box, s, query) {
            const st = s || {};
            const q = String(query == null ? '' : query).trim();
            const kind = this.partyKindOf(box);
            const pool = this.partyArr(st.parties).slice();
            if (st.pickedId && !pool.some((r)=>r && r.id === st.pickedId)) pool.push(this.partyPicked(st));
            const local = this.partyFilter(pool, q, kind);
            const seen = {};
            for (const r of local)seen[r.id] = true;
            // what the server matched for THIS query and the loaded rows lack
            const extra = q && st.hitsFor === q ? this.partyArr(st.hits).filter((r)=>r && !seen[r.id] && this.partyListable(r, kind)) : [];
            const all = local.concat(extra);
            const cap = Number(box.limit) || 50;
            const shown = all.slice(0, cap).map((r)=>({
                    value: r.id,
                    label: r.name,
                    hint: this.partyHint(r),
                    isAdd: false
                }));
            const more = all.length - shown.length;
            let statusKey = '';
            if (!all.length) statusKey = st.loadError ? 'common.party.loadFailed' : st.loading || q && st.searching ? 'common.party.searching' : 'common.state.noMatches';
            else if (more > 0) statusKey = 'common.hint.keepTyping';
            if (box.allowCreate) shown.push({
                value: this.partyAddValue,
                label: String(box.call('polyglot', box.addLabel || 'common.party.addNew')),
                hint: q,
                isAdd: true
            });
            return {
                shown: shown,
                more: more,
                statusKey: statusKey
            };
        },
        matches (box, s) {
            return this.partyMatches(box, s, s && s.query);
        },
        label (box) {
            const r = this.partyFind(box, this.partyCurrent(box));
            return r ? r.name : '';
        },
        open (box) {
            const s = box.state;
            this.partyLoad(box);
            const shown = this.partyMatches(box, s, '').shown;
            const at = shown.findIndex((o)=>o.value === this.partyCurrent(box));
            s.update({
                open: true,
                query: '',
                active: at === -1 ? 0 : at,
                note: '',
                noteName: ''
            });
        },
        pick (box, value) {
            const s = box.state;
            if (value === this.partyAddValue) return this.partyAddOpen(box, s.query);
            const r = this.partyFind(box, value);
            s.update({
                open: false,
                query: ''
            });
            if (r) this.partyChoose(box, r, '');
        },
        // Choose a party: remember it (its name shows before the directory
        // loads) and hand its summary to `select`. `note`: a status line naming it.
        partyChoose (box, r, note) {
            const sum = this.partySummary(r);
            box.state.update({
                pickedId: sum.id,
                pickedName: sum.name,
                pickedKind: sum.kind || '',
                pickedTaxId: sum.taxId || '',
                note: note || '',
                noteName: note ? sum.name : '',
                adding: false
            });
            if (typeof box.select === 'string' && box.select) box.call(box.select, sum);
            return sum;
        },
        // The status line: the list's status while open; a note after.
        partyStatus (box, s) {
            if (s.open) {
                const m = this.matches(box, s);
                return m.statusKey ? String(box.call('polyglot', m.statusKey)).replace('{count}', String(m.more)) : '';
            }
            return s.note ? this.partyCopy(box, s.note, s.noteName) : '';
        },
        // ── data ────────────────────────────────────────────────────────────
        // One call. Through the app's door when it has one; else the L1 SDK,
        // pinned to this tab's workspace — never unpinned (the server would
        // answer for the caller's other workspace).
        partyCall (box, op, args) {
            const door = typeof box.door === 'string' ? box.door : '';
            if (door) return box.call(door, 'parties', op, args || {});
            const sdk = box.sdk || box.context && box.context.sdk;
            if (!sdk || typeof sdk.execute !== 'function') throw new Error('sdk_unavailable');
            const root = box.state && box.state.root;
            const ws = root && root.workspace;
            const wsId = ws && (ws.id || ws._id);
            if (!wsId) throw new Error('workspace_not_ready');
            return sdk.execute('parties', op, {
                ...args || {},
                workspaceId: String(wsId)
            });
        },
        // The directory, once; a failed read is tried again on the next open.
        partyLoad (box) {
            const s = box.state;
            const sc = box.scope;
            if (s.loaded || s.loading) return sc.partyLoading || Promise.resolve();
            const kind = this.partyKindOf(box);
            const filter = {
                member: 'exclude'
            };
            if (kind !== 'any') filter.kind = kind;
            s.update({
                loading: true,
                loadError: false
            });
            const run = Promise.resolve().then(()=>this.partyCall(box, 'list', {
                    filter: filter
                })).then((res)=>{
                if (sc.partyGone) return;
                s.update({
                    parties: this.partyRows(res),
                    loaded: true,
                    loading: false
                });
                // opened before the rows came: the chosen one becomes active
                if (s.open && !String(s.query || '').trim()) {
                    const cur = this.partyCurrent(box);
                    const at = this.partyMatches(box, s, '').shown.findIndex((o)=>o.value === cur);
                    if (at > 0) s.update({
                        active: at
                    });
                }
            }, ()=>{
                if (!sc.partyGone) s.update({
                    loading: false,
                    loadError: true
                });
            });
            sc.partyLoading = run;
            return run;
        },
        partySearchSoon (box) {
            const sc = box.scope;
            clearTimeout(sc.partyTimer);
            this.partyLoad(box);
            const q = String(box.state.query || '').trim();
            if (q.length < 2) return;
            const wait = Number(box.searchDelay);
            sc.partyTimer = setTimeout(()=>this.partySearch(box, q), wait >= 0 ? wait : 250);
        },
        // The server's matches for `q`; an answer older than the newest search
        // is dropped.
        partySearch (box, q) {
            const sc = box.scope;
            const s = box.state;
            if (sc.partyGone) return Promise.resolve();
            const seq = (sc.partySeq || 0) + 1;
            sc.partySeq = seq;
            const kind = this.partyKindOf(box);
            const filter = {
                q: q,
                member: 'exclude'
            };
            if (kind !== 'any') filter.kind = kind;
            s.update({
                searching: true
            });
            return Promise.resolve().then(()=>this.partyCall(box, 'list', {
                    filter: filter
                })).then((res)=>this.partyRows(res), ()=>null).then((rows)=>{
                if (sc.partyGone || sc.partySeq !== seq) return;
                s.update(rows ? {
                    hits: rows,
                    hitsFor: q,
                    searching: false
                } : {
                    searching: false
                });
            });
        },
        // The chosen party's name before any open: one get by id.
        partyResolve (box) {
            const sc = box.scope;
            const id = this.partyCurrent(box);
            if (!id || sc.partyResolving === id || this.partyFind(box, id)) return;
            sc.partyResolving = id;
            Promise.resolve().then(()=>this.partyCall(box, 'get', {
                    id: id
                })).then((res)=>this.partyRow(this.partyOne(res)), ()=>null).then((r)=>{
                if (sc.partyResolving === id) sc.partyResolving = '';
                if (sc.partyGone || !r || this.partyCurrent(box) !== id) return;
                box.state.update({
                    pickedId: r.id,
                    pickedName: r.name,
                    pickedKind: r.kind,
                    pickedTaxId: r.taxId
                });
            });
        },
        // ── the quick add ───────────────────────────────────────────────────
        partyAddOpen (box, name) {
            const kind = this.partyKindOf(box);
            box.state.update({
                open: false,
                query: '',
                note: '',
                noteName: '',
                adding: true,
                addKind: kind === 'person' ? 'person' : 'company',
                addName: String(name || '').trim(),
                addLegalName: '',
                addTaxId: '',
                addEmail: '',
                addPhone: '',
                addBusy: false,
                addError: '',
                addNameError: false,
                addSimilarId: '',
                addSimilarName: ''
            });
            this.partyFocusField(box, 'name');
        },
        partyAddClose (box) {
            box.state.update({
                adding: false,
                addBusy: false,
                addError: '',
                addNameError: false,
                addSimilarId: '',
                addSimilarName: ''
            });
            this.partyFocusInput(box);
        },
        // One field of the draft; an edit clears the last check's answer.
        partyAddSet (box, key, value) {
            const patch = {
                addError: '',
                addSimilarId: '',
                addSimilarName: ''
            };
            patch[key] = String(value == null ? '' : value);
            if (key === 'addName') patch.addNameError = false;
            box.state.update(patch);
        },
        // Enter in a field adds (a button keeps its own Enter); Esc closes the
        // form and stops there.
        partyAddKey (box, e) {
            if (!e || e.isComposing) return;
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                this.partyAddClose(box);
                return;
            }
            if (e.key !== 'Enter') return;
            const tag = e.target && e.target.tagName ? String(e.target.tagName).toUpperCase() : '';
            if (tag !== 'INPUT') return;
            e.preventDefault();
            this.partyAddRun(box, false);
        },
        // Add: a name is required; the same tax id is refused (the existing
        // party is returned); a similar name warns once (`force` = "Add
        // anyway"); then create, give the role, choose it.
        async partyAddRun (box, force) {
            const s = box.state;
            const sc = box.scope;
            if (s.addBusy) return null;
            const name = String(s.addName || '').trim();
            if (!name) {
                s.update({
                    addNameError: true,
                    addSimilarId: '',
                    addSimilarName: ''
                });
                this.partyFocusField(box, 'name');
                return null;
            }
            const fixed = this.partyKindOf(box);
            const kind = fixed !== 'any' ? fixed : s.addKind === 'person' ? 'person' : 'company';
            const tax = String(s.addTaxId || '').trim();
            const taxKey = this.partyTaxKey(tax);
            s.update({
                addBusy: true,
                addError: '',
                addNameError: false
            });
            await this.partyLoad(box);
            if (sc.partyGone) return null;
            const rows = this.partyArr(s.parties);
            if (taxKey) {
                let exact = this.partyDuplicate({
                    taxId: taxKey
                }, rows).exact;
                if (!exact) {
                    let answer = null;
                    try {
                        const res = await this.partyCall(box, 'list', {
                            filter: {
                                taxId: taxKey,
                                includeArchived: true
                            }
                        });
                        answer = this.partyRows(res);
                    } catch (err) {
                        answer = null;
                    }
                    if (sc.partyGone) return null;
                    // the check could not run: never create blind
                    if (!answer) {
                        s.update({
                            addBusy: false,
                            addError: 'common.party.addFailed'
                        });
                        return null;
                    }
                    exact = this.partyDuplicate({
                        taxId: taxKey
                    }, answer).exact;
                }
                if (exact) {
                    s.update({
                        addBusy: false,
                        addSimilarId: '',
                        addSimilarName: ''
                    });
                    const sum = this.partyChoose(box, exact, 'common.party.idExists');
                    this.partyFocusInput(box);
                    return sum;
                }
            }
            if (force !== true) {
                const similar = this.partyDuplicate({
                    name: name
                }, rows).similar;
                if (similar) {
                    s.update({
                        addBusy: false,
                        addSimilarId: similar.id,
                        addSimilarName: similar.name
                    });
                    return null;
                }
            }
            const payload = {
                kind: kind,
                name: name
            };
            const legal = String(s.addLegalName || '').trim();
            const email = String(s.addEmail || '').trim();
            const phone = String(s.addPhone || '').trim();
            if (kind === 'company' && legal) payload.legalName = legal;
            if (tax) payload.taxId = tax;
            if (email) payload.emails = [
                {
                    value: email,
                    primary: true
                }
            ];
            if (phone) payload.phones = [
                {
                    value: phone,
                    primary: true
                }
            ];
            let row = null;
            try {
                row = this.partyRow(this.partyOne(await this.partyCall(box, 'create', {
                    payload: payload
                })));
            } catch (err) {
                row = null;
            }
            if (sc.partyGone) return null;
            if (!row) {
                s.update({
                    addBusy: false,
                    addError: 'common.party.addFailed'
                });
                return null;
            }
            const role = String(box.partyRole || '').trim();
            // the party exists either way; its role is best effort
            if (role) await Promise.resolve().then(()=>this.partyCall(box, 'addRole', {
                    partyId: row.id,
                    role: role
                })).catch(()=>null);
            if (sc.partyGone) return null;
            s.update({
                parties: [
                    row
                ].concat(this.partyArr(s.parties).filter((r)=>r && r.id !== row.id)),
                addBusy: false
            });
            const sum = this.partyChoose(box, row, '');
            this.partyFocusInput(box);
            return sum;
        },
        // "Use …" on the similar-name warning.
        partyUseSimilar (box) {
            const s = box.state;
            const r = this.partyFind(box, s.addSimilarId);
            s.update({
                adding: false,
                addSimilarId: '',
                addSimilarName: ''
            });
            if (r) this.partyChoose(box, r, '');
            this.partyFocusInput(box);
        },
        // Focus a quick-add field once the form is in the DOM.
        partyFocusField (box, name) {
            const go = ()=>{
                const field = box.PartyAdd && box.PartyAdd['AppField_' + name];
                const input = field && field.AppInput;
                if (input && input.node && typeof input.node.focus === 'function') input.node.focus();
            };
            const st = box.state;
            if (st && typeof st.$settled === 'function') st.$settled().then(go);
            else go();
        },
        // Back to the picker's field WITHOUT opening the list (its focus opens it).
        partyFocusInput (box) {
            const input = box.AppInputGroup && box.AppInputGroup.AppInputBare;
            if (!input || !input.node || typeof input.node.focus !== 'function') return;
            box.scope.partyQuiet = true;
            try {
                input.node.focus();
            } finally{
                box.scope.partyQuiet = false;
            }
        }
    },
    // The chosen party's name: on mount, and whenever `current` changes.
    stateDeps: [
        (el)=>el.scope.partyCurrent(el)
    ],
    onStateUpdate: (el)=>el.scope.partyResolve(el),
    onRender: (el)=>el.scope.partyResolve(el),
    onBeforeRemove: (el)=>{
        el.scope.partyGone = true;
        clearTimeout(el.scope.partyTimer);
    },
    AppInputGroup: {
        AppInputBare: {
            onFocus: (e, el)=>{
                if (el.scope.partyQuiet) return;
                el.scope.open(el.parent.parent);
            },
            onInput: (e, el, s)=>{
                s.update({
                    query: e.target.value,
                    open: true,
                    active: 0,
                    note: '',
                    noteName: ''
                });
                el.scope.partySearchSoon(el.parent.parent);
            }
        }
    },
    ComboList: {
        children: (el, s)=>{
            if (!s.open) return [];
            const shown = el.scope.matches(el.parent, s).shown;
            return shown.map((o, i)=>({
                    key: 'o-' + o.value,
                    value: o.value,
                    label: String(o.label),
                    hint: o.hint ? String(o.hint) : '',
                    isAdd: !!o.isAdd,
                    index: i,
                    optionCount: shown.length
                }));
        },
        childProps: {
            ':hover': {
                background: 'var(--color-hover)'
            },
            ':active': {
                background: 'var(--color-selected)'
            },
            '&[data-active]': {
                background: 'var(--color-selected)'
            },
            // the "New client" row leads with a plus
            Icon_add: {
                name: 'plus',
                order: '-1',
                flexShrink: '0',
                ariaHidden: 'true',
                hide: (el, s)=>!s.isAdd
            }
        }
    },
    ComboStatus: {
        marginTop: (el, s)=>el.scope.partyStatus(el.parent, s) ? 'X' : '0',
        text: (el, s)=>el.scope.partyStatus(el.parent, s)
    },
    // The quick add: in flow under the field (a dialog body is a scroll
    // container; an in-flow form is never clipped), on the neutral plate.
    PartyAdd: {
        role: 'group',
        ariaLabelledby: (el)=>el.scope.id(el.parent, 'add-title'),
        hide: (el, s)=>!s.adding,
        flow: 'y',
        gap: 'Z1',
        marginTop: 'Z',
        padding: 'A',
        round: 'radiusCard',
        background: 'widgetPlate',
        minWidth: '0',
        onKeydown: (e, el)=>el.parent.scope.partyAddKey(el.parent, e),
        // the form's title: the kit caption, by its bare key
        AppFieldLabel: {
            id: (el)=>el.scope.id(el.parent.parent, 'add-title'),
            text: (el)=>el.call('polyglot', el.parent.parent.addLabel || 'common.party.addNew')
        },
        // Company · Person — only when the picker takes either kind.
        AppFieldSegmented: {
            hide: (el)=>el.scope.partyKindOf(el.parent.parent) !== 'any',
            label: (el)=>el.call('polyglot', 'common.party.kind'),
            options: [
                {
                    value: 'company',
                    label: 'common.party.kindCompany'
                },
                {
                    value: 'person',
                    label: 'common.party.kindPerson'
                }
            ],
            stateKey: 'addKind'
        },
        AppField_name: {
            label: (el)=>el.call('polyglot', 'common.party.name'),
            reserveError: true,
            AppInput: {
                maxlength: '160',
                autocomplete: 'off',
                ariaRequired: 'true',
                ariaInvalid: (el, s)=>s.addNameError ? 'true' : null,
                class: {
                    hasError: (el, s)=>!!s.addNameError
                },
                value: (el, s)=>s.addName || '',
                onInput: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddSet(box, 'addName', e.target.value);
                }
            },
            FieldError: {
                text: (el, s)=>s.addNameError ? el.call('polyglot', 'common.party.nameRequired') : '',
                visibility: (el, s)=>s.addNameError ? 'visible' : 'hidden'
            }
        },
        AppField_legal: {
            hide: (el, s)=>s.addKind !== 'company',
            label: (el)=>el.call('polyglot', 'common.party.legalName'),
            AppInput: {
                maxlength: '200',
                autocomplete: 'off',
                value: (el, s)=>s.addLegalName || '',
                onInput: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddSet(box, 'addLegalName', e.target.value);
                }
            }
        },
        // A company's tax ID; a person's personal ID — the same `taxId` field.
        AppField_tax: {
            label: (el, s)=>el.call('polyglot', s.addKind === 'person' ? 'common.party.personalId' : 'common.party.taxId'),
            AppInput: {
                maxlength: '64',
                autocomplete: 'off',
                spellcheck: 'false',
                value: (el, s)=>s.addTaxId || '',
                onInput: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddSet(box, 'addTaxId', e.target.value);
                }
            }
        },
        AppField_email: {
            label: (el)=>el.call('polyglot', 'common.party.email'),
            AppInput: {
                type: 'email',
                inputmode: 'email',
                maxlength: '200',
                autocomplete: 'off',
                spellcheck: 'false',
                value: (el, s)=>s.addEmail || '',
                onInput: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddSet(box, 'addEmail', e.target.value);
                }
            }
        },
        AppField_phone: {
            label: (el)=>el.call('polyglot', 'common.party.phone'),
            AppInput: {
                type: 'tel',
                inputmode: 'tel',
                maxlength: '40',
                autocomplete: 'off',
                value: (el, s)=>s.addPhone || '',
                onInput: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddSet(box, 'addPhone', e.target.value);
                }
            }
        },
        // A similar name: warned once — use that client, or add anyway.
        PartyAddSimilar: {
            hide: (el, s)=>!s.addSimilarId,
            flow: 'x',
            align: 'center flex-start',
            flexWrap: 'wrap',
            gap: 'Z',
            Icon: {
                name: 'warning',
                color: 'warningInk',
                flexShrink: '0',
                ariaHidden: 'true'
            },
            PartyAddSimilarText: {
                tag: 'span',
                role: 'alert',
                flex: '1 1 auto',
                minWidth: '0',
                fontSize: 'Z1',
                color: 'title',
                overflowWrap: 'anywhere',
                text: (el, s)=>{
                    const box = el.parent.parent.parent;
                    return s.addSimilarId ? box.scope.partyCopy(box, 'common.party.similarName', s.addSimilarName) : '';
                }
            },
            AppCapsuleBtnToolbar: {
                compact: true,
                text: (el, s)=>{
                    const box = el.parent.parent.parent;
                    return s.addSimilarId ? box.scope.partyCopy(box, 'common.party.useExisting', s.addSimilarName) : '';
                },
                onClick: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyUseSimilar(box);
                }
            },
            AppCapsuleBtnGhost: {
                compact: true,
                disabled: (el, s)=>!!s.addBusy,
                text: (el)=>el.call('polyglot', 'common.party.addAnyway'),
                onClick: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddRun(box, true);
                }
            }
        },
        PartyAddError: {
            tag: 'span',
            role: 'alert',
            fontSize: 'Z1',
            fontWeight: '500',
            color: 'dangerInk',
            overflowWrap: 'anywhere',
            hide: (el, s)=>!s.addError,
            text: (el, s)=>s.addError ? el.call('polyglot', s.addError) : ''
        },
        PartyAddFoot: {
            flow: 'x',
            align: 'center flex-end',
            flexWrap: 'wrap',
            gap: 'Z',
            AppCapsuleBtnGhost: {
                compact: true,
                text: (el)=>el.call('polyglot', 'common.action.cancel'),
                onClick: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddClose(box);
                }
            },
            AppCapsuleBtnPrimary: {
                compact: true,
                disabled: (el, s)=>!!s.addBusy,
                text: (el)=>el.call('polyglot', 'common.action.add'),
                onClick: (e, el)=>{
                    const box = el.parent.parent.parent;
                    box.scope.partyAddRun(box, false);
                }
            }
        }
    }
};

});

parcelRegister("5uQ8N", function(module, exports) {

$parcel$export(module.exports, "AppField", () => $400833355e1927be$export$2148905522a1cdb9);
$parcel$export(module.exports, "AppFieldLabel", () => $400833355e1927be$export$76216bab7cce0dd1);
$parcel$export(module.exports, "AppFieldHint", () => $400833355e1927be$export$3c08c9f113d025d9);
$parcel$export(module.exports, "AppFieldError", () => $400833355e1927be$export$cc4034d5a94730b3);
$parcel$export(module.exports, "AppInput", () => $400833355e1927be$export$109c16966aba5275);
$parcel$export(module.exports, "AppSelect", () => $400833355e1927be$export$1c68b36cdd5016bf);
$parcel$export(module.exports, "AppTextarea", () => $400833355e1927be$export$931e1c8c2a8572d9);
$parcel$export(module.exports, "AppInputCompact", () => $400833355e1927be$export$52d71544f3f02e20);
$parcel$export(module.exports, "AppSelectCompact", () => $400833355e1927be$export$a417281465d215fd);
$parcel$export(module.exports, "AppInputGroup", () => $400833355e1927be$export$486ac38af8c35794);
$parcel$export(module.exports, "AppInputBare", () => $400833355e1927be$export$1ec472a2265e10b);
$parcel$export(module.exports, "AppInputPrefix", () => $400833355e1927be$export$2d1554afacccefbb);
$parcel$export(module.exports, "AppInputWithIcon", () => $400833355e1927be$export$b91e10c2e1851f08);
$parcel$export(module.exports, "AppFieldPrefix", () => $400833355e1927be$export$d50d650407971840);
$parcel$export(module.exports, "AppOption", () => $400833355e1927be$export$611746b3d807f6e7);
$parcel$export(module.exports, "AppFieldInput", () => $400833355e1927be$export$60fb8f17137399b6);
$parcel$export(module.exports, "AppFieldSelect", () => $400833355e1927be$export$e8d30ac866e3b878);
$parcel$export(module.exports, "AppCapsuleBtn", () => $400833355e1927be$export$1bf1b8ed4f9c20a);
$parcel$export(module.exports, "AppCapsuleBtnToolbar", () => $400833355e1927be$export$5d89943ec710669);
$parcel$export(module.exports, "AppCapsuleBtnPrimary", () => $400833355e1927be$export$19fd668685d7c8a8);
$parcel$export(module.exports, "AppCapsuleBtnGhost", () => $400833355e1927be$export$f10afacc1637b3c1);
$parcel$export(module.exports, "AppCapsuleBtnDanger", () => $400833355e1927be$export$40d0e6890b3f3fc8);
$parcel$export(module.exports, "AppLabelStack", () => $400833355e1927be$export$c4759c9d18b2cff5);
$parcel$export(module.exports, "AppFieldTextarea", () => $400833355e1927be$export$c5d92638aed1047f);
$parcel$export(module.exports, "AppFieldSearch", () => $400833355e1927be$export$af9caed268fbf8b1);

var $9GdJK = parcelRequire("9GdJK");
// The shared field kit — ONE field language for every workspace form (a
// modal, a sheet, a settings panel). Canonical replacement for the per-app
// `<AppAbbrev>Input`/`<AppAbbrev>Select` forks (ComSelect, SchSelect,
// CrmSelect, HrSelect, WhInput, BiSelect, JobSelect, HmInput, FinInput,
// CmsInput — see tickets/workspace.md's a11y ticket) and for the raw
// `tag: 'input'` blocks the modals carried with their own look each.
//
// THE RECIPE (Nika 2026-09-24, "improve fields ui/ux in modals, just like
// we have in aihouse" — the AI House admin sheets are the reference):
//   label    a small uppercase caption above the control — `Y1` (12.7px
//            at the 17px base, the AI House size; `Z3` is not a step of the
//            brand type scale and fell back to `Z`), 500, `.06em`, caption
//            ink (the weight law: labels are 500)
//   control  `controlH` tall, `radiusControl`, `Z2` type, `- Z2` inset
//            (DESIGN_LANGUAGE §6.2, the "Input / select / textarea" row),
//            on the brand `field` fill with a hairline `line` edge — the one
//            stroke the borderless law keeps (§2.5.4) — that steps to
//            `inactive` under the pointer; the quiet `placeholder` ink; the
//            global focus ring and nothing else; the `field-disabled` pair
//   notes    two optional lines under the control: a hint in caption ink
//            and an inline error in danger ink whose box can be reserved
//            (Rule 66: field validation → inline, box reserved)
//   select   a native <select> that KEEPS THE BROWSER'S OWN CARET (decided
//            2026-09-24, the AI House AhSelect precedent): no
//            `appearance: none`, no drawn chevron. The native control brings
//            the OS picker, type-ahead, the arrow keys and the accessible
//            name; its caret sits inside the `- Z2` inset, needs no reserved
//            box and follows the page's colour scheme (measured on AhSelect,
//            2026-09-20). A drawn chevron costs an Icon overlay, a reserved
//            inset per control size and a second pointer target that must
//            opt out of clicks — three more parts for the same signal.
//
// The family (this file unless named):
//   AppField                     the <label> wrapper: caption, hint, error
//   AppFieldLabel                the caption itself — Y1 / 500 / uppercase /
//                                .06em, caption ink; AppField's FieldLabel
//                                extends it, and a caption with no control
//                                of its own extends it by name
//   AppFieldHint / AppFieldError the two note lines under a control
//   AppInput / AppSelect /       the controls — controlH, Z2
//     AppTextarea
//   AppInputCompact /            the dense-row controls — controlHCompact, Z
//     AppSelectCompact           (a drawer row, a table's inline editor)
//   AppInputGroup                ONE field surface around a bare input
//                                (AppInputBare) and a fixed adornment:
//     AppInputPrefix             a fixed text before the input — a host
//                                before a slug, a sign before an amount
//     AppInputWithIcon           a leading glyph — a search field's magnifier
//   AppFieldPrefix               AppField + AppInputPrefix
//   The choice fields — a short option set is a choice control, never a
//   native select (their own files):
//     AppSegmented /             one line of segments, the brand TabSet
//       AppFieldSegmented        (AppFieldSegmented.js)
//     AppChoiceChip /            a wrapping row of choice chips, for a narrow
//       AppChoiceChips /         column (AppFieldChips.js)
//       AppFieldChips
//     AppColorChip /             colour options — a dot that IS the value
//       AppColorChips /          (AppFieldColors.js)
//       AppFieldColors
//
// Usage:
//
//   AppField: {
//     label: 'Person',                    // or (el) => el.call('polyglot', 'key')
//     hint: 'Shown on the invoice',       // optional, under the control
//     reserveError: true,                 // keep the error line's box even when empty
//     AppSelect: { value: ..., onChange: ..., children: [...] },
//     FieldError: { text: (el, s) => s.root.formErrors.person || '' }
//   }
//
// The two note lines are declared here, before the consumer's control key
// merges in, so flex `order` places them under the control. A reactive error
// is the consumer's own `FieldError.text` factory (a function-valued `error`
// prop would be evaluated once at create and frozen — v3.14); the control
// takes the danger edge through `class: { hasError: (el, s) => … }`.
//
// `ariaLabel` reads the SAME `label` string AppField's own FieldLabel renders
// visually, off `el.parent` — the cascade validated in catalog's
// CatalogInput/CatalogField fix. A control used outside an AppField (a bare
// filter/picker) keeps the name its call site gives it (`aria: { label }`):
// a function prop that returned undefined REMOVED a call-site `aria-label`
// (measured by the tickets migration, 2026-09-24), so `fieldName` below
// falls back to the control's own. It is a module-level helper, not a
// registered function: a harness that mounts the kit with a minimal
// function registry must still get the name.
// The accessible name of a kit control: the field's `label` when the control
// sits in an AppField, else the control's own `aria.label`; never undefined
// for a control that has a name of its own. `host` is the element whose
// PARENT may be the field: the control itself, or — for the bare input inside
// a kit group (AppInputPrefix, AppInputWithIcon) — the group.
//
// FRANK: the helper is NOT read as a free variable — an arrow `ariaLabel` has
// no element `this`, so a published app read frank's lifted `fieldName` off
// `{}` and threw (frank-audit, crm-w1's run). It sits on each control's own
// `scope` (spread in at module evaluation, so frank serializes the function
// itself) and is read as `el.scope.fieldName`
// (__tests__/fieldKitNameSurvivesFrank.test.js).
const $400833355e1927be$var$FIELD_NAME_SCOPE = {
    fieldName (el, host) {
        const h = host || el;
        const field = h && h.parent;
        const own = field && field.label;
        if (own) return typeof own === 'function' ? own(field, field.state) : own;
        const bag = el && el.aria && el.aria.label;
        if (bag) return typeof bag === 'function' ? bag(el, el.state) : bag;
        return undefined;
    }
};
// FIELD-KIT DIRTY (perf/shell-keepalive, Nika 2026-10-10 "Yes, the field
// kit"). A user's input marks the kit control unsaved, so every shell form
// declares its unsaved work with no per-page code: the control carries
// `dirty` — the declaration the shell's `hasUnsavedInput` reads (the PageSlot
// keep-alive cap and the split-pane replace ask "Discard changes?" for it).
//   • marked   by the USER only: `beforeinput` on a text control (typing,
//              paste, delete — never a programmatic write) and `input` on a
//              select. The value the control showed before that first edit is
//              its LOADED value;
//   • cleared  when the value returns to the loaded one (computed on read,
//              through the kit's own change path), and when the page's save
//              succeeds: the shell's `markPageSaved` (el.call) takes every
//              kit control in the page as saved — a failed save does not call
//              it, so the controls stay unsaved.
// Per-control state lives on the control element (`__kitBase`,
// `__kitTouched`); the helpers sit on the control's own `scope` like
// FIELD_NAME_SCOPE (frank: no free variable — fieldKitNameSurvivesFrank).
const $400833355e1927be$var$FIELD_DIRTY_SCOPE = {
    kitValue (el) {
        const node = el && el.node;
        if (!node) return '';
        const v = node.value;
        return v === undefined || v === null ? '' : String(v);
    },
    kitEdit (el) {
        if (!el || !el.node) return;
        if (el.__kitBase === undefined) el.__kitBase = el.scope.kitValue(el);
        el.__kitTouched = true;
    },
    kitDirty (el) {
        if (!el || !el.__kitTouched || el.__kitBase === undefined) return false;
        return el.scope.kitValue(el) !== el.__kitBase;
    },
    kitSaved (el) {
        if (!el) return;
        el.__kitBase = el.scope.kitValue(el);
        el.__kitTouched = false;
    }
};
const $400833355e1927be$export$2148905522a1cdb9 = {
    // A <label>, so a click on the caption focuses the control (the brand
    // field was one; a div lost that, measured by the calendar migration).
    // The control's accessible NAME still comes from its own aria-label —
    // the label's text content would have carried the hint and the error too.
    tag: 'label',
    flow: 'y',
    gap: 'Y',
    label: '',
    hint: '',
    error: '',
    reserveError: false,
    FieldLabel: {
        extends: 'AppFieldLabel',
        text: (el)=>el.parent && el.parent.label || ''
    },
    FieldHint: {
        extends: 'AppFieldHint',
        order: '2'
    },
    FieldError: {
        extends: 'AppFieldError',
        order: '3'
    }
};
const $400833355e1927be$export$76216bab7cce0dd1 = {
    tag: 'span',
    fontSize: 'Y1',
    fontWeight: '500',
    color: 'caption',
    textTransform: 'uppercase',
    letterSpacing: '0.06em'
};
const $400833355e1927be$export$3c08c9f113d025d9 = {
    tag: 'span',
    fontSize: 'Y1',
    color: 'caption',
    text: (el)=>el.parent && el.parent.hint || '',
    hide: (el)=>!(el.parent && el.parent.hint)
};
const $400833355e1927be$export$cc4034d5a94730b3 = {
    tag: 'span',
    role: 'alert',
    fontSize: 'Y1',
    fontWeight: '500',
    color: 'dangerInk',
    minHeight: 'Z1',
    text: (el)=>el.parent && el.parent.error || '',
    hide: (el)=>!(el.parent && (el.parent.reserveError || el.parent.error)),
    visibility: (el)=>el.parent && el.parent.error ? 'visible' : 'hidden'
};
const $400833355e1927be$export$109c16966aba5275 = {
    tag: 'input',
    theme: 'field',
    minHeight: 'controlH',
    minWidth: '0',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: '- Z2',
    round: 'radiusControl',
    fontSize: 'Z2',
    // iOS FOCUS ZOOM (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): a focused field under
    // 16px zooms the page in iOS Safari. `Z2` is ~15.4px at a phone's root and
    // ~12.9px at the iPad-portrait one (the compact `Z` 12.8 / 11.2px, measured
    // on dev DFI): on a touch screen the field text takes `fieldTextTouch`.
    '@coarse': {
        fontSize: 'fieldTextTouch'
    },
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    outline: 'none',
    transition: 'A defaultBezier',
    transitionProperty: 'background-color, border-color',
    scope: {
        ...$400833355e1927be$var$FIELD_NAME_SCOPE,
        ...$400833355e1927be$var$FIELD_DIRTY_SCOPE
    },
    ariaLabel: (el)=>el.scope.fieldName(el),
    // unsaved work (FIELD-KIT DIRTY above)
    dirty: (el)=>el.scope.kitDirty(el),
    onBeforeinput: (e, el)=>el.scope.kitEdit(el),
    '&:not(.hasError):hover': {
        borderColor: 'inactive'
    },
    ':disabled': {
        theme: 'field-disabled',
        cursor: 'not-allowed'
    },
    '&.hasError': {
        borderColor: 'dangerInk'
    }
};
const $400833355e1927be$export$1c68b36cdd5016bf = {
    tag: 'select',
    theme: 'field',
    minHeight: 'controlH',
    minWidth: '0',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: '- Z2',
    round: 'radiusControl',
    fontSize: 'Z2',
    // iOS FOCUS ZOOM (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): a focused field under
    // 16px zooms the page in iOS Safari. `Z2` is ~15.4px at a phone's root and
    // ~12.9px at the iPad-portrait one (the compact `Z` 12.8 / 11.2px, measured
    // on dev DFI): on a touch screen the field text takes `fieldTextTouch`.
    '@coarse': {
        fontSize: 'fieldTextTouch'
    },
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    outline: 'none',
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    transition: 'A defaultBezier',
    transitionProperty: 'background-color, border-color',
    scope: {
        ...$400833355e1927be$var$FIELD_NAME_SCOPE,
        ...$400833355e1927be$var$FIELD_DIRTY_SCOPE
    },
    ariaLabel: (el)=>el.scope.fieldName(el),
    // unsaved work (FIELD-KIT DIRTY above): a select has no `beforeinput`; its
    // loaded value is taken at focus, before the user's pick lands
    dirty: (el)=>el.scope.kitDirty(el),
    onFocus: (e, el)=>{
        if (el.__kitBase === undefined) el.__kitBase = el.scope.kitValue(el);
    },
    onInput: (e, el)=>el.scope.kitEdit(el),
    '&:not(.hasError):hover': {
        borderColor: 'inactive'
    },
    // The browser paints a disabled <select> at opacity 0.7 (measured live on
    // dev, 2026-09-24): that dimmed the field-disabled pair to a see-through
    // control. The disabled law is the token step alone, so opacity stays 1.
    ':disabled': {
        theme: 'field-disabled',
        opacity: '1',
        cursor: 'not-allowed'
    },
    '&.hasError': {
        borderColor: 'dangerInk'
    }
};
const $400833355e1927be$export$931e1c8c2a8572d9 = {
    tag: 'textarea',
    theme: 'field',
    minHeight: 'controlH',
    minWidth: '0',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: 'Z Z2',
    round: 'radiusControl',
    fontSize: 'Z2',
    // iOS FOCUS ZOOM (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): a focused field under
    // 16px zooms the page in iOS Safari. `Z2` is ~15.4px at a phone's root and
    // ~12.9px at the iPad-portrait one (the compact `Z` 12.8 / 11.2px, measured
    // on dev DFI): on a touch screen the field text takes `fieldTextTouch`.
    '@coarse': {
        fontSize: 'fieldTextTouch'
    },
    lineHeight: '1.4',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    outline: 'none',
    resize: 'vertical',
    transition: 'A defaultBezier',
    transitionProperty: 'background-color, border-color',
    scope: {
        ...$400833355e1927be$var$FIELD_NAME_SCOPE,
        ...$400833355e1927be$var$FIELD_DIRTY_SCOPE
    },
    ariaLabel: (el)=>el.scope.fieldName(el),
    // unsaved work (FIELD-KIT DIRTY above)
    dirty: (el)=>el.scope.kitDirty(el),
    onBeforeinput: (e, el)=>el.scope.kitEdit(el),
    '&:not(.hasError):hover': {
        borderColor: 'inactive'
    },
    ':disabled': {
        theme: 'field-disabled',
        cursor: 'not-allowed'
    },
    '&.hasError': {
        borderColor: 'dangerInk'
    }
};
const $400833355e1927be$export$52d71544f3f02e20 = {
    extends: 'AppInput',
    minHeight: 'controlHCompact',
    padding: '- Z',
    fontSize: 'Z'
};
const $400833355e1927be$export$a417281465d215fd = {
    extends: 'AppSelect',
    minHeight: 'controlHCompact',
    padding: '- Z',
    fontSize: 'Z'
};
const $400833355e1927be$export$486ac38af8c35794 = {
    tag: 'div',
    flow: 'x',
    align: 'center',
    gap: 'Z',
    theme: 'field',
    minHeight: 'controlH',
    minWidth: '0',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    padding: '- Z2',
    round: 'radiusControl',
    fontSize: 'Z2',
    // The group's bare input inherits this size: the touch floor is the group's
    // (see AppInput — DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1).
    '@coarse': {
        fontSize: 'fieldTextTouch'
    },
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    cursor: 'text',
    transition: 'A defaultBezier',
    transitionProperty: 'background-color, border-color',
    '&:not(.hasError):hover': {
        borderColor: 'inactive'
    },
    ':has(> input:focus-visible)': {
        shadow: 'focusRing'
    },
    ':has(> input:disabled)': {
        theme: 'field-disabled',
        cursor: 'not-allowed'
    },
    '&.hasError': {
        borderColor: 'dangerInk'
    },
    onMousedown: (e, el)=>{
        if (e.target !== el.node) return;
        const input = el.AppInputBare && el.AppInputBare.node;
        if (!input || typeof input.focus !== 'function') return;
        e.preventDefault();
        input.focus();
    }
};
const $400833355e1927be$export$1ec472a2265e10b = {
    tag: 'input',
    flex: '1',
    minWidth: '0',
    alignSelf: 'stretch',
    padding: '0',
    border: 'none',
    background: 'transparent',
    outline: 'none',
    textOverflow: 'ellipsis',
    scope: {
        ...$400833355e1927be$var$FIELD_NAME_SCOPE,
        ...$400833355e1927be$var$FIELD_DIRTY_SCOPE
    },
    ariaLabel: (el)=>el.scope.fieldName(el, el.parent),
    // unsaved work (FIELD-KIT DIRTY above)
    dirty: (el)=>el.scope.kitDirty(el),
    onBeforeinput: (e, el)=>el.scope.kitEdit(el),
    ':focus-visible': {
        shadow: 'none'
    },
    ':disabled': {
        cursor: 'not-allowed'
    }
};
const $400833355e1927be$export$2d1554afacccefbb = {
    extends: 'AppInputGroup',
    gap: '0',
    prefixText: '',
    Prefix: {
        tag: 'span',
        flexShrink: '0',
        whiteSpace: 'nowrap',
        color: 'caption',
        pointerEvents: 'none',
        text: (el)=>el.parent && el.parent.prefixText || ''
    },
    AppInputBare: {}
};
const $400833355e1927be$export$b91e10c2e1851f08 = {
    extends: 'AppInputGroup',
    icon: 'search',
    Icon: {
        name: (el)=>el.parent && el.parent.icon || 'search',
        flexShrink: '0',
        color: 'caption',
        pointerEvents: 'none',
        'aria-hidden': 'true'
    },
    AppInputBare: {}
};
const $400833355e1927be$export$d50d650407971840 = {
    extends: 'AppField',
    prefixText: '',
    AppInputPrefix: {
        prefixText: (el)=>el.parent && el.parent.prefixText
    }
};
const $400833355e1927be$export$611746b3d807f6e7 = {
    tag: 'option'
};
const $400833355e1927be$export$60fb8f17137399b6 = {
    extends: 'AppInput'
};
const $400833355e1927be$export$e8d30ac866e3b878 = {
    extends: 'AppSelect'
};
const $400833355e1927be$export$1bf1b8ed4f9c20a = {
    extends: 'AppControl',
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'X',
    minHeight: 'controlH',
    // A block inset of Z: a one-line label (22.5 px at Z2) plus 2 × Z stays
    // under controlH, so a one-line capsule keeps its height; a label that
    // WRAPS (the text law below) keeps that inset instead of touching the
    // capsule's edges — measured on dev bad4186b3, CRM "new contact" at 390:
    // the Georgian primary wrapped to two lines in a 45 px capsule, 0 px above
    // and below them.
    padding: 'Z A',
    round: 'radiusPill',
    cursor: 'pointer',
    // THE TEXT LAW (overflow law §3b.8, DESIGN-WL-D2-KIT-OVERFLOW-LAW-1): a
    // label that meets a narrower container WRAPS inside the capsule — it was
    // `nowrap`, so a Georgian label spilled past its capsule in a 390 px
    // equal-grid foot. `break-word` (not `anywhere`) keeps the capsule's
    // min-content at its longest word, so it never folds into a tower: a
    // two-word label is at most two lines. AppLabelStack stays width-exact.
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    textAlign: 'center',
    fontSize: 'Z2',
    fontWeight: '500',
    transition: 'background-color A defaultBezier, transform Z defaultBezier',
    compact: false,
    // A flat hook — a call-site `data` object replaces a `data: {}` block
    // (FW-ELEMENT-DEFINITION-DATA-REPLACES-EXTENDS-DATA-1).
    dataCompact: (el)=>!!el.compact,
    // THE COMPACT SIZE CARRIES ITS OWN TOUCH FLOOR, IN THIS BLOCK
    // (DESIGN-CAPSULEBTN-COARSE-FLOOR-NESTED-WRONG-1). The `'@coarse'` floor
    // used to sit in the `'@coarse'` block below, as an inner
    // `'&[data-compact]'`. It emits the same rule text either way — but not in
    // the same PLACE. Both rules are specificity (0,2,0): one class plus one
    // attribute, and a media block adds none. At equal specificity the cascade
    // falls back to SHEET ORDER, and the engine mints one compound class per
    // style BLOCK, once, where the first element that ever needs it mounts — so
    // the order of two blocks is decided by two unrelated elements' mounts,
    // while inside ONE block the flat body is always emitted immediately before
    // its own nested media rule. Split across two blocks the floor therefore
    // won on some pages and lost on others: measured on dev 7e8916816
    // (Validators, Finances, Tokens at 375-834) every compact capsule kept
    // `min-height: 36px` on a coarse pointer, so a finger 21px above or below
    // the centre missed it and the two vertical probes landed on the parent
    // Bar. Declared HERE the pair is atomic and no mount order can separate
    // them. Same reason AppControl states `controlHCompact` and its floor in
    // one block, and the shape NavbarRailControl and AppHeader already use.
    // The emitted cascade is resolved in __tests__/capsuleCoarseFloor.test.js —
    // a definition read cannot see sheet order.
    '&[data-compact]': {
        minHeight: 'controlHCompact',
        padding: 'Y Z2',
        fontSize: 'Z',
        '@coarse': {
            minHeight: 'controlH',
            minWidth: 'controlH'
        }
    },
    // A touch control occupies its full 44px box. No invisible hit area can
    // overlap a neighboring action or be clipped by a toolbar's scroll port.
    '@coarse': {
        position: 'relative',
        ...(0, $9GdJK.touchRow)
    },
    ':active': {
        transform: 'scale(0.97)'
    },
    ':disabled': {
        theme: 'field-disabled',
        cursor: 'not-allowed',
        transform: 'none'
    }
};
const $400833355e1927be$export$5d89943ec710669 = {
    extends: 'AppCapsuleBtn',
    theme: 'layer',
    color: 'title',
    ':hover': {
        background: 'selected'
    },
    ':active': {
        background: 'selected'
    }
};
const $400833355e1927be$export$19fd668685d7c8a8 = {
    extends: 'AppCapsuleBtn',
    theme: 'primary',
    border: 'none'
};
const $400833355e1927be$export$f10afacc1637b3c1 = {
    extends: 'AppCapsuleBtn',
    border: 'none',
    background: 'transparent',
    color: 'title',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    }
};
const $400833355e1927be$export$40d0e6890b3f3fc8 = {
    extends: 'AppCapsuleBtn',
    border: 'none',
    color: 'dangerInk',
    background: 'color-mix(in srgb, currentColor 12%, var(--color-tintBase))',
    ':hover': {
        background: 'color-mix(in srgb, currentColor 18%, var(--color-tintBase))'
    },
    ':active': {
        background: 'color-mix(in srgb, currentColor 20%, var(--color-tintBase))'
    }
};
const $400833355e1927be$export$c4759c9d18b2cff5 = {
    tag: 'span',
    display: 'inline-grid',
    labels: [],
    shown: 0,
    children: (el)=>(Array.isArray(el.labels) ? el.labels : []).map((label, index)=>({
                key: 'label' + index,
                label: label,
                index: index
            })),
    childProps: {
        tag: 'span',
        gridArea: '1 / 1',
        justifySelf: 'center',
        whiteSpace: 'nowrap',
        text: (el)=>el.call('polyglot', el.label || ''),
        visibility: (el, s)=>{
            const stack = el.parent || {};
            const v = typeof stack.shown === 'function' ? stack.shown(stack, s) : stack.shown;
            return el.index === (Number(v) || 0) ? 'visible' : 'hidden';
        }
    }
};
const $400833355e1927be$export$c5d92638aed1047f = {
    extends: 'AppTextarea'
};
const $400833355e1927be$export$af9caed268fbf8b1 = {
    extends: 'AppInputWithIcon',
    icon: 'search',
    shortcut: '',
    // Exactly the compact class height, like the 36 px buttons and selects in
    // the same row. The Clear is the kit's 36 px square (the icon-button law),
    // so with `minHeight` alone the hairline border grew the field to 38 px;
    // the fixed height lets the square overlap the hairline instead, unclipped.
    // A call site that needs the 44 px field sets `minHeight: 'controlH'`.
    // The compact TYPE too: `Z`, the AppInputCompact / AppSelectCompact size
    // beside it in the same row (it read `Z1`, so the search text stood one
    // step larger than the selects' — 15.2 against 14.1 px at 1920 on dev
    // kestrel-assist /production, 2026-10-28).
    height: 'controlHCompact',
    minHeight: 'controlHCompact',
    padding: '- X - Z',
    gap: 'Y',
    fontSize: 'Z',
    round: 'radiusPill',
    role: 'search',
    AppInputBare: {
        type: 'search',
        autocomplete: 'off',
        placeholder: (el)=>{
            const v = el.parent && el.parent.placeholder;
            return typeof v === 'function' ? v(el.parent, el.parent.state) : v || null;
        },
        value: (el)=>{
            const v = el.parent && el.parent.value;
            return (typeof v === 'function' ? v(el.parent, el.parent.state) : v) || '';
        },
        ariaKeyshortcuts: (el)=>{
            const k = el.parent && el.parent.shortcut;
            return k ? String(k).trim().split(/[\s+]+/).join('+') : null;
        },
        '::-webkit-search-cancel-button': {
            display: 'none'
        }
    },
    Shortcut: {
        flow: 'x',
        gap: 'W',
        flexShrink: '0',
        ariaHidden: 'true',
        pointerEvents: 'none',
        hide: (el)=>{
            const p = el.parent || {};
            const v = typeof p.value === 'function' ? p.value(p, p.state) : p.value;
            return !p.shortcut || !!v;
        },
        childExtends: 'AppKeycap',
        children: (el)=>String(el.parent && el.parent.shortcut || '').trim().split(/[\s+]+/).filter(Boolean).map((k, i)=>({
                    key: `k${i}`,
                    text: k
                }))
    },
    // the clear button — the kit's icon-only square (CompactIconButton: the
    // icon-button law, DESIGN-WL-ICON-BUTTONS-SQUARE-1; the brand IconButton's
    // coarse-pointer tap slop comes with it). It was an `iconLg` box — a square,
    // but off the control scale the law names; a 36 px control fills the
    // compact field over its hairline, and sits inside a 44 px one.
    IconButton: {
        extends: 'CompactIconButton',
        type: 'button',
        theme: 'transparent',
        color: 'caption',
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        ariaLabel: (el)=>el.call('polyglot', 'common.action.clear'),
        Icon: {
            name: 'x',
            boxSize: 'iconSm'
        },
        // Takes no box while the keycaps hold the end of an empty field.
        hide: (el)=>{
            const p = el.parent || {};
            const v = typeof p.value === 'function' ? p.value(p, p.state) : p.value;
            return !!p.shortcut && !v;
        },
        // Reserved: hidden (not removed) while there is nothing to clear, or
        // nothing to clear it with.
        visibility: (el)=>{
            const p = el.parent || {};
            const v = typeof p.value === 'function' ? p.value(p, p.state) : p.value;
            return v && typeof p.onClear === 'function' ? 'visible' : 'hidden';
        },
        tabindex: (el)=>{
            const p = el.parent || {};
            const v = typeof p.value === 'function' ? p.value(p, p.state) : p.value;
            return v && typeof p.onClear === 'function' ? '0' : '-1';
        },
        onClick: (e, el, s)=>{
            const group = el.parent;
            if (group && typeof group.onClear === 'function') group.onClear(e, group, s);
        }
    }
};

});

parcelRegister("4hXc3", function(module, exports) {

$parcel$export(module.exports, "AppToolbar", () => $31f6aa84c43d6f9d$export$dd7a6aec2803cf20);
$parcel$export(module.exports, "AppToolbarMore", () => $31f6aa84c43d6f9d$export$4260d7d4f8f99c0);
// AppToolbar — the overflow law's toolbar (Nika 2026-09-26: "you should also
// fix modals, dropdowns, widgets cutting ui and buttons and texts in
// overflow"; HOME_AMBIENT_SKIN_SPEC §3b.5; DESIGN-WL-D2-KIT-OVERFLOW-LAW-1).
//
// A row of controls that never cuts one at its edge:
//   - it WRAPS by default: a control that does not fit starts the next line
//     (one `flex-flow: row wrap` declaration);
//   - on a phone, a control marked `collapse: true` folds away and the ONE
//     square ••• (AppToolbarMore, the kit's CompactIconButton) takes its place,
//     opening the same actions as MenuPanel rows.
//
//   AppToolbar: {
//     Search: { extends: 'AppFieldSearch', … },
//     Export: { extends: 'AppCapsuleBtnToolbar', text: '…', collapse: true },
//     Archive: { extends: 'AppCapsuleBtnToolbar', text: '…', collapse: true },
//     AppToolbarMore: {
//       items: (el, s) => [
//         { key: 'export', text: 'crm.action.export', icon: 'download', onClick: … },
//         { key: 'archive', text: 'crm.action.archive', icon: 'archive', onClick: … }
//       ]
//     }
//   }
//
// The show / hide rules live on the TOOLBAR (`& > [data-…]` class rules), never
// as a `display` on the child: a declared display is written inline and would
// outrank the phone rule (FW-ELEMENT-DECLARED-DISPLAY-WRITTEN-INLINE-BEATS-
// MEDIA-RULES-1).
const $31f6aa84c43d6f9d$export$dd7a6aec2803cf20 = {
    role: 'toolbar',
    display: 'flex',
    flow: 'x wrap',
    align: 'center flex-start',
    gap: 'Z',
    minWidth: '0',
    maxWidth: '100%',
    childProps: {
        dataCollapse: (el)=>!!el.collapse
    },
    '& > [data-toolbar-more]': {
        display: 'none'
    },
    '@mobileL': {
        '& > [data-collapse]': {
            display: 'none'
        },
        '& > [data-toolbar-more]': {
            display: 'inline-flex'
        }
    }
};
const $31f6aa84c43d6f9d$export$4260d7d4f8f99c0 = {
    extends: 'CompactIconButton',
    icon: 'moreHorizontal',
    dataToolbarMore: true,
    ariaHaspopup: 'menu',
    ariaLabel: (el)=>el.call('polyglot', 'common.action.moreActions'),
    title: (el)=>el.call('polyglot', 'common.action.moreActions'),
    items: [],
    onClick: (e, el, s)=>{
        if (e && e.stopPropagation) e.stopPropagation();
        const list = typeof el.items === 'function' ? el.items(el, s) : el.items;
        // The row's handler reads its action off the ROW (a flat `action` prop),
        // never a variable captured from this map — a captured one would not
        // survive serialization (frank FA205).
        const rows = (Array.isArray(list) ? list : []).map((item, index)=>({
                key: item.key || 'item' + index,
                text: el.call('polyglot', item.text || ''),
                // a MenuPanelItem row paints its glyph from the Icon child's `name`
                // (a row-level `icon` never reached it)
                ...item.icon ? {
                    Icon: {
                        name: item.icon
                    }
                } : {},
                danger: item.danger,
                action: item.onClick,
                onClick: (ev, row, rs)=>{
                    row.call('closeDropdown', 'appToolbarMore');
                    if (typeof row.action === 'function') row.action(ev, row, rs);
                }
            }));
        el.call('openDropdown', {
            anchorEl: el,
            id: 'appToolbarMore',
            placement: 'bottom-end',
            round: 'radiusCard',
            content: {
                extends: 'MenuPanel',
                childExtends: 'MenuPanelItem',
                children: rows
            }
        });
    }
};

});

parcelRegister("eHVf7", function(module, exports) {

$parcel$export(module.exports, "AppChoiceGroup", () => $ab517c1a8f326e12$export$2f144de701d61474);
// The CHOICE contract every short-option control shares (brief §4.4) — one
// definition, no look of its own. AppSegmented (the brand TabSet track) and
// AppColorChips (dot + label chips) both extend it:
//
//   options   [{ value, label }] — label: a bundle key or a plain string
//   stateKey  the key of the nearest state that holds the value; a click
//             writes it (the house state contract, like AppPagination)
//
// Each option is a toggle button in a labelled group (role=group,
// aria-pressed). A call site with its own wiring overrides the options'
// isActive / ariaPressed / onClick through childProps.
const $ab517c1a8f326e12$export$2f144de701d61474 = {
    role: 'group',
    children: (el, s)=>{
        const opts = typeof el.options === 'function' ? el.options(el, s) : el.options;
        return (opts || []).map((o)=>({
                key: `opt-${o.value}`,
                optionValue: o.value,
                optionLabel: o.label
            }));
    },
    childProps: {
        isActive: (el, s)=>{
            const key = el.parent?.stateKey;
            return !!key && s?.[key] === el.optionValue;
        },
        ariaPressed: (el, s)=>{
            const key = el.parent?.stateKey;
            return key && s?.[key] === el.optionValue ? 'true' : 'false';
        },
        onClick: (e, el, s)=>{
            const key = el.parent?.stateKey;
            if (key) s.update({
                [key]: el.optionValue
            });
        }
    }
};

});

parcelRegister("hBOPV", function(module, exports) {

$parcel$export(module.exports, "AppSegmented", () => $cd1d536d3d9c2942$export$ffbffec285753c9f);
$parcel$export(module.exports, "AppSegmentedItem", () => $cd1d536d3d9c2942$export$652cb3c8bf5bd28c);
$parcel$export(module.exports, "AppFieldSegmented", () => $cd1d536d3d9c2942$export$f302ab3d78df382e);
// A SHORT option set (5 or fewer) is a choice control, not a native select —
// brief §4.4 (P19, P42, P48, P64), 2026-09-24. Rebuilt 2026-09-26 as THE
// segmented control of the white-label redesign (DESIGN_SPEC §5.2): one
// capsule track (the `segmentTrack` theme — the brand's neutral plate
// `widgetPlate` in light, `layer`'s value in dark; 2026-09-30, see the track
// below), borderless segments, and the chosen segment in one of two
// strengths —
//
//   variant 'view'    a raised thumb (`raised` fill + the `float` elevation)
//                     for switching VIEWS: Contacts · Pipeline · Follow-ups.
//                     role=tablist / tab, aria-selected. Compact (36px).
//   variant 'choice'  the ink thumb (`highlight` / `highlight-reversed`, the
//                     D-1 inversion) for picking a VALUE: Person · Company.
//                     role=radiogroup / radio, aria-checked. 44px in a form;
//                     `compact: true` for a toolbar. The default.
//
// On a touch screen every segment draws 44px, either variant (the 44pt rule,
// AppSegmentedItem below); the sizes above are the pointer's.
//
// Selection is monochrome in three strengths (P5): rows take the `selected`
// wash, views the raised thumb, value choices the ink thumb. Hue never marks
// selection.
//
// TWO CONTRACTS, one look.
//
// THE ROW CONTRACT (new — frank-safe by construction: rows are plain data and
// the handler is a function NAME, so no row factory captures a loop variable):
//
//   AppSegmented: {
//     variant: 'view',
//     ariaLabel: '{{ crm.views | polyglot }}',
//     current: (el, s) => s.root.crmView || 'contacts', // reactive value
//     select: 'crmSetView',                             // el.call(select, value)
//     childrenAs: 'state',
//     children: () => [
//       { key: 'contacts', text: 'crm.view.contacts', value: 'contacts' }, …
//     ]
//   }
//
// `current`, not `value` (an HTML attribute name); `text` is a bundle key or a
// plain string (polyglot returns a non-key verbatim). Arrow keys move the
// choice and the focus (roving tabindex: only the chosen segment is in the Tab
// order), Home/End jump to the ends. On a narrow pane the track scrolls
// sideways — it never clips.
//
// THE OPTIONS CONTRACT (2026-09-24, unchanged for its call sites): `options`
// [{ value, label }] + `stateKey` — AppChoiceGroup's toggle semantics
// (role=group, aria-pressed). A call site with its own wiring overrides the
// segments' `isActive` / `ariaPressed` / `onClick` through `childProps`.
//
// HOW THE STATE REACHES THE CSS: every segment publishes `data-active` and
// `data-variant`, and the thumb is a STATIC selector rule keyed on them — not
// a `.isActive` block (create-only on this runtime) and not a factory (inline,
// and it cannot carry the dark/light theme pair).
//
// AppFieldSegmented is the FIELD variant: the AppField label above the
// control, the control named by the same label.
// THE TRACK IS AN AppScrollRow (overflow law §3b.5,
// DESIGN-WL-D2-KIT-OVERFLOW-LAW-1; crm-w1 measured the CRM view tabs cut at
// the screen edge at 390 px): a track wider than its room scrolls sideways
// with no scrollbar, fades ONLY the edge that hides a segment, and keeps the
// chosen segment whole — the kit's one edge-fade row (components/
// AppScrollRow.js), spread here because the track already extends
// AppChoiceGroup. It owns no state (the options contract reads the NEAREST
// state).

var $gSI3w = parcelRequire("gSI3w");

var $9GdJK = parcelRequire("9GdJK");
const $cd1d536d3d9c2942$export$ffbffec285753c9f = {
    extends: 'AppChoiceGroup',
    variant: '',
    compact: false,
    role: (el)=>el.select ? el.variant === 'view' ? 'tablist' : 'radiogroup' : 'group',
    display: 'flex',
    flow: 'x',
    alignItems: 'stretch',
    width: 'fit-content',
    maxWidth: '100%',
    minHeight: (el)=>el.compact || el.variant === 'view' ? 'controlHCompact' : 'controlH',
    boxSizing: 'border-box',
    padding: 'X',
    round: 'radiusPill',
    // THE TRACK (2026-09-30; Nika via "unreal crm": "the CRM submenu buttons
    // lose their background on other Windows devices"). Windows follows the
    // LIGHT scheme by default, where the old `layer` track read 1.08:1 on every
    // ground and the white view thumb 1.08-1.22:1 on it. `segmentTrack`
    // (shared designSystem/theme.js): light = the brand's neutral plate
    // `widgetPlate` (1.15:1 on every ground, the thumb 1.15-1.30:1); dark =
    // `layer`'s value, unchanged (widgetPlate's dark half equals the dark thumb
    // on a dark sheet, 1.08:1). __tests__/segmentedTrackContrast.test.js.
    theme: 'segmentTrack',
    // the edge-fade row: min-width 0 (a flex item's default is its content),
    // sideways scroll with no scrollbar, the fade, its scope and its hooks
    ...(0, $gSI3w.AppScrollRow),
    scrollSnapType: 'x proximity',
    childExtends: 'AppSegmentedItem',
    childProps: {
        // Both contracts in one place; `childProps` overrides AppChoiceGroup's
        // option-only versions of the first three.
        isActive: (el, s)=>{
            const seg = el.parent || {};
            if (seg.select) return seg.current === (s && s.value);
            const key = seg.stateKey;
            return !!key && s?.[key] === el.optionValue;
        },
        ariaPressed: (el)=>el.parent && el.parent.select ? null : el.isActive ? 'true' : 'false',
        onClick: (e, el, s)=>{
            const seg = el.parent || {};
            if (seg.select) return el.call(seg.select, s && s.value);
            const key = seg.stateKey;
            if (key) s.update({
                [key]: el.optionValue
            });
        }
    }
};
const $cd1d536d3d9c2942$export$652cb3c8bf5bd28c = {
    extends: 'AppControl',
    compact: true,
    tag: 'button',
    type: 'button',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0',
    // A segment is a control: the house compact height (Nika 2026-09-26 12:2x,
    // "Keep the rule: segments use the 36 px compact height" — the admin
    // control law flagged the old `minHeight: '0'` on every AppSegmented tab).
    // The track's X inset around a 36 px segment makes the track 44 px.
    minHeight: 'controlHCompact',
    // ON A TOUCH SCREEN a segment DRAWS the 44pt floor on both axes
    // (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1; _touchTarget.js `touchRow`) — the
    // pointer keeps the 36px rule above. Segments sit flush in a track that
    // scrolls, so a pseudo hit area would take a neighbour's edge (a short
    // label like "7D" is under 44 wide) and be cut by the track; the segment's
    // own box is its hit area instead. Measured on dev DFI 2026-10-05 with a
    // touch device simulated: the home board's Next up switcher's segments
    // 36px tall, and the Validators lane had to draw its own segments at 44
    // (ValSeg). The track keeps its X inset, so it grows to 44 + 2 X around
    // them.
    '@coarse': {
        ...(0, $9GdJK.touchRow)
    },
    padding: '0 A',
    round: 'radiusPill',
    borderWidth: '0',
    background: 'transparent',
    fontSize: 'Z',
    fontWeight: '500',
    lineHeight: '1',
    color: 'caption',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    scrollSnapAlign: 'start',
    transition: 'background-color A defaultBezier, color A defaultBezier',
    text: (el, s)=>el.call('polyglot', (el.optionValue !== undefined ? el.optionLabel : s && s.text) ?? ''),
    // The row contract's semantics; the options contract keeps the toggle
    // (aria-pressed from the track's childProps) and native Tab order.
    role: (el)=>{
        const seg = el.parent || {};
        if (!seg.select) return null;
        return seg.variant === 'view' ? 'tab' : 'radio';
    },
    ariaSelected: (el)=>{
        const seg = el.parent || {};
        return seg.select && seg.variant === 'view' ? el.isActive ? 'true' : 'false' : null;
    },
    ariaChecked: (el)=>{
        const seg = el.parent || {};
        return seg.select && seg.variant !== 'view' ? el.isActive ? 'true' : 'false' : null;
    },
    tabindex: (el)=>el.parent && el.parent.select ? el.isActive ? '0' : '-1' : null,
    // Flat `dataX` hooks, never a `data: {}` block a call-site `data` object
    // would replace (FW-ELEMENT-DEFINITION-DATA-REPLACES-EXTENDS-DATA-1).
    dataActive: (el)=>!!el.isActive,
    dataVariant: (el)=>el.parent && el.parent.variant === 'view' ? 'view' : 'choice',
    // The raised thumb: the `raised` fill (white; `gray5` in dark, where the
    // sheet colour would read SUNKEN on a track washed lighter than the sheet)
    // and the `float` elevation. The shadow is the token's CSS variable, not
    // the `shadow:` prop — a [light, dark] shadow pair nested in a selector
    // block compiles to an invalid `selector @media …` rule; the variable flips
    // with the scheme by itself.
    //
    // EVERY STATE COLOUR IS THE BRAND TOKEN'S CSS VARIABLE, for the same reason
    // and one more (2026-10-25, Nika: "Yes, this fix only"; the CRM's contact
    // type and filters on dev). An installed app renders its pages under its OWN
    // isolated config — its tokens plus default-config, `useVariable: false`
    // (workspace functions/workspaceProjects.js, the module design system).
    // That config has no `highlight`, `highlight-reversed`, `raised`, `hover`
    // or `selected`, so the token names went out as raw words:
    // `background: highlight` (a CSS system colour) under an invalid
    // `color: highlight-reversed` — the caption ink stayed, and the chosen
    // segment's label vanished into the fill. The variables are the shell's
    // own (the brand emits them on the document in both schemes), so they
    // resolve the same in the shell and inside every app: the ink thumb is
    // black on white / white on black (21:1), the view thumb the title ink on
    // `raised` — __tests__/appSegmentedStateTokens.test.js.
    '&[data-active][data-variant="view"]': {
        background: 'var(--color-raised)',
        color: 'var(--color-title)',
        boxShadow: 'var(--shadow-float)'
    },
    '&[data-active][data-variant="choice"]': {
        background: 'var(--color-highlight)',
        color: 'var(--color-highlight-reversed)'
    },
    '&:not([data-active]):hover': {
        background: 'var(--color-hover)',
        color: 'var(--color-title)'
    },
    '&:not([data-active]):active': {
        background: 'var(--color-selected)'
    },
    // WINDOWS CONTRAST (forced colours; the shared `forcedColors` media): the
    // browser repaints every fill with a system colour and drops every
    // box-shadow, so both thumbs (a fill, a fill + elevation) and the focus
    // ring (a shadow) vanish. System-colour outlines carry them instead — the
    // only colours that mode keeps; there is no design-system token for them.
    // Longhands: the `outline` shorthand reads its words as spacing tokens.
    // Widths on the size token `hairline2` (2px — the kit holds no raw px).
    '@forcedColors': {
        '&[data-active]': {
            outlineWidth: 'hairline2',
            outlineStyle: 'solid',
            outlineColor: 'Highlight',
            outlineOffset: '0'
        },
        '&:focus-visible': {
            outlineWidth: 'hairline2',
            outlineStyle: 'solid',
            outlineColor: 'CanvasText',
            outlineOffset: 'hairline2'
        }
    },
    // Roving focus: ← → (and ↑ ↓) move to the neighbour, Home / End to the
    // ends; the move IS the choice (automatic activation), and focus follows.
    // The segment that BECOMES the choice (a click, the keyboard, or a value
    // changed from outside) is brought into view in its track. `stateDeps` +
    // `onStateUpdate` is the framework's declarative effect: it fires only when
    // `isActive` actually flips, never on the first render.
    stateDeps: [
        (el)=>!!el.isActive
    ],
    onStateUpdate: (el, s, ctx, change)=>{
        const seg = el.parent;
        if (!change || !change.next || !change.next[0] || !seg || !seg.scope) return;
        if (typeof seg.scope.edgeFadeBecameCurrent === 'function') seg.scope.edgeFadeBecameCurrent(seg, el.node);
    },
    onKeydown: (e, el)=>{
        const seg = el.parent;
        if (!seg || !seg.select) return;
        const items = typeof seg.getChildren === 'function' ? seg.getChildren() : [];
        const at = items.indexOf(el);
        if (at === -1) return;
        const step = {
            ArrowRight: 1,
            ArrowDown: 1,
            ArrowLeft: -1,
            ArrowUp: -1
        }[e.key];
        let next = null;
        if (step) next = items[(at + step + items.length) % items.length];
        else if (e.key === 'Home') next = items[0];
        else if (e.key === 'End') next = items[items.length - 1];
        if (!next || next === el) return;
        e.preventDefault();
        el.call(seg.select, next.state && next.state.value);
        if (next.node && next.node.focus) next.node.focus();
    }
};
const $cd1d536d3d9c2942$export$f302ab3d78df382e = {
    extends: 'AppField',
    // A choice group is not a <label>: a label's click would activate its
    // first button (buttons are labelable) and pick a segment by accident.
    tag: 'div',
    AppSegmented: {
        ariaLabel: (el)=>el.call('polyglot', el.parent?.label || ''),
        options: (el)=>el.parent?.options,
        stateKey: (el)=>el.parent?.stateKey
    }
};

});
parcelRegister("gSI3w", function(module, exports) {

$parcel$export(module.exports, "AppScrollRow", () => $c4a3dd09810d930d$export$5e4505c6895e5cf0);
// AppScrollRow — a row that scrolls sideways and FADES only an edge that hides
// content (overflow law §3b.5, DESIGN-WL-D2-KIT-OVERFLOW-LAW-1). ONE kit piece
// for every scrolling row, so the fade cannot drift between copies:
// AppSegmented's track, the header's two tab strips (Tabs, MobileTabs), the
// composer's recent-board chips.
//
//   • THE AXIS IS THE ONE THAT HIDES CONTENT, never a fixed one
//     (`edgeFadeAxis`): sideways by default, down the column for a consumer
//     that turns the row on its end — the header's tab strip on a left or
//     right rail (`data-nav-rail`: `flexDirection: column`, `overflowY:
//     auto`). Every edge the kit reads — the flags, the mask and the reveal —
//     follows that axis. It used to read `scrollWidth` / `scrollLeft` only,
//     so a COLUMN raised no flag, painted no fade and never revealed the
//     current child: measured live at 1194 x 834 (iPad 11 landscape, dev
//     /w/dfli/dfi), the rail's 298px lane hid 64px of its 362px of tabs with
//     no hint, and opening one of them showed no active tab at all
//     (DESIGN-SHELL-RAIL-TRAILING-CLUSTER-COVERS-TABS-1). The flags name the
//     axis they describe (`data-fade-axis="y"`, absent sideways), and the
//     column's mask rules carry one attribute more than the row's, so no
//     class-insertion order ever decides which gradient paints.
//   • No scrollbar chrome; it shrinks inside a flex parent (min-width 0) and
//     its overscroll never chains to the page, on either axis.
//   • THE FADE: `data-fade-start` / `data-fade-end` + a `C`-band mask. A mask
//     paints nothing new — it only scales the alpha of what is there — and a
//     side with nothing beyond it paints no fade at all.
//   • THE FLAGS come from the FIRST and LAST visible child against the row's
//     visible box, never from the raw scroll offset: a row with its own
//     padding rests scrolled by that padding once scroll-snap aligns its first
//     child (3.68 px on CRM at 390 px, dev bad4186b3) and hides nothing —
//     the offset rule faded the start over the chosen first segment. They are
//     written through the element's own update (attr) only when one flips,
//     never on the node and never into a state: a row may sit where the
//     NEAREST state belongs to someone else (AppSegmented inside a form's
//     options contract), so the row owns none.
//   • THE GEOMETRY comes from an IntersectionObserver on the row's own
//     children (root = the row): the browser computes it inside its frame,
//     so the row reads NO box during render or update — the
//     getBoundingClientRect reads it did on every onContentUpdate were forced
//     layouts (~320 ms over six calls per staging boot, 2026-10-10). Each
//     child keeps its last entry and the row's scrollLeft when it arrived.
//   • THE CUT RULE (as before): a side is cut when MORE than 1 px of the
//     child lies past that edge of the row's box (the entry's own box against
//     the entry's root box). The thresholds (0, 0.99, 1) only pace delivery.
//     A display:none child reports a zero box and takes no part.
//   • RE-OBSERVED (a fresh entry per child, next frame) on mount, on every
//     resize (its own ResizeObserver) and when its children change
//     (onContentUpdate: a chip, a tab, a view added without resizing the
//     row). ON SCROLL the row re-reads the stored entries moved by the scroll
//     since they arrived (arithmetic, no box read): a child wider than the
//     row (HomeAppStrip's one dock) crosses no threshold while it scrolls, so
//     the observer alone would never report it. Both observers go in
//     onRemove.
//   • TIMING: the observer reports after the browser paints a frame. A row
//     that overflows on mount paints its first frame without fades (and an
//     unrevealed current child); the flags arrive with the observer's first
//     callback. A hidden tab runs no frame, so its rows wait for the first
//     visible frame.
//   • THE CURRENT CHILD (aria-current, or aria-selected / aria-checked /
//     aria-pressed = "true" — a tab, a radio, a toggle chip) stays whole: on
//     mount, resize or a content change a current child the row cuts moves
//     to the row's middle (from its observer entry, flags in the same
//     callback); a child that
//     BECOMES current calls `el.parent.scope.edgeFadeBecameCurrent(el.parent,
//     el.node)`. A child already in full view is never moved, so the row
//     never fights a user who scrolled it. A row vetoes reveals (a drag in
//     progress) by declaring its own `scope.edgeFadeCanReveal(el)`.
//
// USE — layout (display / flow / gap / align / padding) is the consumer's:
//   Chips: { extends: 'AppScrollRow', flow: 'x', gap: 'Z', children: … }
// or spread `...AppScrollRow` into a definition that extends something else
// (AppSegmented), merging `scope` when it declares its own.
const $c4a3dd09810d930d$export$5e4505c6895e5cf0 = {
    minWidth: '0',
    overflowX: 'auto',
    overflowY: 'hidden',
    overscrollBehaviorX: 'contain',
    // A consumer that turns the row on its end scrolls the OTHER axis, and its
    // overscroll must not chain to the page either (the rail's tab column).
    overscrollBehaviorY: 'contain',
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': {
        display: 'none'
    },
    '&[data-fade-start]': {
        maskImage: 'linear-gradient(to right, transparent, black var(--spacing-C))'
    },
    '&[data-fade-end]': {
        maskImage: 'linear-gradient(to right, black calc(100% - var(--spacing-C)), transparent)'
    },
    '&[data-fade-start][data-fade-end]': {
        maskImage: 'linear-gradient(to right, transparent, black var(--spacing-C), black calc(100% - var(--spacing-C)), transparent)'
    },
    // THE COLUMN'S OWN BAND (the axis note above): one attribute more than the
    // matching row rule, so the column always wins where it applies and no
    // insertion order is ever load-bearing.
    '&[data-fade-axis="y"][data-fade-start]': {
        maskImage: 'linear-gradient(to bottom, transparent, black var(--spacing-C))'
    },
    '&[data-fade-axis="y"][data-fade-end]': {
        maskImage: 'linear-gradient(to bottom, black calc(100% - var(--spacing-C)), transparent)'
    },
    '&[data-fade-axis="y"][data-fade-start][data-fade-end]': {
        maskImage: 'linear-gradient(to bottom, transparent, black var(--spacing-C), black calc(100% - var(--spacing-C)), transparent)'
    },
    scope: {
        // The children that take room — a display:none child reports a zero box
        // to the observer. A child with no entry yet (just added) counts.
        edgeFadeChildren (el) {
            const n = el && el.node;
            if (!n) return [];
            const seen = el._edgeFadeSeen;
            return Array.from(n.children || []).filter((c)=>{
                if (!c) return false;
                const s = seen && seen.get(c);
                const r = s && s.entry && s.entry.boundingClientRect;
                if (!r) return true;
                return r.width > 0 || r.height > 0;
            });
        },
        // WHICH AXIS SCROLLS — the one that hides content, so the row needs no
        // flag of its own and a consumer that flips it (the rail's column) needs
        // no second kit piece. Sideways unless the other axis hides more: a row
        // declares `overflowY: hidden` and a column `overflowX: hidden`, so only
        // one of the two is ever non-zero in practice.
        edgeFadeAxis (el) {
            const n = el && el.node;
            if (!n) return 'x';
            const down = (n.scrollHeight || 0) - (n.clientHeight || 0);
            const across = (n.scrollWidth || 0) - (n.clientWidth || 0);
            return down > 1 && down > across ? 'y' : 'x';
        },
        // How much this axis hides, and where it rests now.
        edgeFadeHidden (el, axis) {
            const n = el && el.node;
            if (!n) return 0;
            return axis === 'y' ? (n.scrollHeight || 0) - (n.clientHeight || 0) : (n.scrollWidth || 0) - (n.clientWidth || 0);
        },
        edgeFadeAt (el, axis) {
            const n = el && el.node;
            if (!n) return 0;
            return (axis || this.edgeFadeAxis(el)) === 'y' ? n.scrollTop || 0 : n.scrollLeft || 0;
        },
        // How far a child lies past each edge of the row's box, from its stored
        // entry moved by the scroll since it arrived (`now` = the row's own
        // offset on `axis`). Null when the entry carries no boxes.
        edgeFadeOverhang (seen, now = 0, axis = 'x') {
            const e = seen && seen.entry;
            const r = e && e.boundingClientRect;
            const root = e && e.rootBounds;
            if (!r || !root) return null;
            const shift = (now || 0) - (seen.at || 0);
            if (axis === 'y') return {
                start: root.top - (r.top - shift),
                end: r.bottom - shift - root.bottom
            };
            return {
                start: root.left - (r.left - shift),
                end: r.right - shift - root.right
            };
        },
        // Is this child cut on that side? More than 1 px of it past that edge
        // (sub-pixel slack for a fractional layout). Takes an entry, or a stored
        // { entry, at } with the row's own offset now.
        edgeFadeCut (entry, side, now = 0, axis = 'x') {
            if (!entry) return false;
            const seen = entry.entry ? entry : {
                entry: entry,
                at: now
            };
            const o = this.edgeFadeOverhang(seen, now, axis);
            if (!o) return seen.entry.intersectionRatio < 0.99;
            return o[side] > 1;
        },
        // Which edges hide a child, from the stored entries of the first and the
        // last child that take room, moved by the scroll since they arrived.
        edgeFadeSync (el) {
            const n = el && el.node;
            if (!n || typeof el.update !== 'function') return;
            let start = false;
            let end = false;
            const axis = this.edgeFadeAxis(el);
            const seen = el._edgeFadeSeen;
            if (seen && this.edgeFadeHidden(el, axis) > 1) {
                const kids = this.edgeFadeChildren(el).filter((c)=>seen.has(c));
                if (kids.length) {
                    const now = this.edgeFadeAt(el, axis);
                    start = this.edgeFadeCut(seen.get(kids[0]), 'start', now, axis);
                    end = this.edgeFadeCut(seen.get(kids[kids.length - 1]), 'end', now, axis);
                }
            }
            if (!!el._fadeStart === start && !!el._fadeEnd === end && el._fadeAxis === axis) return;
            el._fadeStart = start;
            el._fadeEnd = end;
            el._fadeAxis = axis;
            el.update({
                attr: {
                    'data-fade-start': start ? '' : null,
                    'data-fade-end': end ? '' : null,
                    'data-fade-axis': axis === 'y' ? 'y' : null
                }
            });
        },
        // A row may veto reveals (a drag reads child positions under the pointer).
        edgeFadeCanReveal () {
            return true;
        },
        // The current child, as the DOM states it.
        edgeFadeCurrent (el) {
            return this.edgeFadeChildren(el).find((c)=>{
                const cur = c.getAttribute && c.getAttribute('aria-current');
                return cur && cur !== 'false' || c.getAttribute && c.getAttribute('aria-selected') === 'true' || c.getAttribute && c.getAttribute('aria-checked') === 'true' || c.getAttribute && c.getAttribute('aria-pressed') === 'true';
            }) || null;
        },
        // Bring one child node to the row's middle — only if the row cuts it.
        // Reads the child's stored entry, never its box. On a column the middle
        // is the lane's own, down the axis that scrolls.
        edgeFadeReveal (el, node) {
            const n = el && el.node;
            const s = node && el._edgeFadeSeen && el._edgeFadeSeen.get(node);
            if (!n || !s || !this.edgeFadeCanReveal(el)) return;
            const r = s.entry.boundingClientRect;
            const box = s.entry.rootBounds;
            const axis = this.edgeFadeAxis(el);
            const near = axis === 'y' ? 'top' : 'left';
            const size = axis === 'y' ? 'height' : 'width';
            if (!r || !box || !box[size] || !(r.width > 0 || r.height > 0)) return;
            const from = this.edgeFadeAt(el, axis);
            const o = this.edgeFadeOverhang(s, from, axis);
            if (!o || o.start <= 1 && o.end <= 1) return;
            const hidden = this.edgeFadeHidden(el, axis);
            if (hidden <= 1 || typeof n.scrollTo !== 'function') return;
            const shift = from - (s.at || 0);
            const target = from + (r[near] - shift + r[size] / 2 - (box[near] + box[size] / 2));
            const to = Math.max(0, Math.min(hidden, target));
            if (Math.abs(to - from) < 0.5) return;
            n.scrollTo(axis === 'y' ? {
                top: to
            } : {
                left: to
            });
        },
        // The observer's callback: store each child's entry with the row's own
        // offset now, reveal a pending current child, then read the flags —
        // in the same callback, the entries moved by the reveal's scroll.
        edgeFadeSeen (el, entries) {
            const n = el && el.node;
            if (!n) return;
            const seen = el._edgeFadeSeen || (el._edgeFadeSeen = new Map());
            const at = this.edgeFadeAt(el);
            for (const e of entries || [])if (e && e.target) seen.set(e.target, {
                entry: e,
                at: at
            });
            for (const c of Array.from(seen.keys()))if (c.parentNode !== n) seen.delete(c);
            const want = el._edgeFadeWant;
            if (want) {
                const node = want === true ? this.edgeFadeCurrent(el) : want;
                if (!node || node.parentNode !== n || seen.has(node)) {
                    el._edgeFadeWant = null;
                    if (node && seen.has(node)) this.edgeFadeReveal(el, node);
                }
            }
            this.edgeFadeSync(el);
        },
        // A scroll: the stored entries, moved by it, give the flags. A child
        // wider than the row crosses no threshold, so no entry would come.
        edgeFadeScrolled (el) {
            if (el && el._edgeFadeSeen) this.edgeFadeSync(el);
        },
        // Watch every child afresh: the observer queues one entry per child for
        // its next frame. No box is read here.
        edgeFadeObserve (el) {
            const n = el && el.node;
            const io = el && el._edgeFadeIo;
            if (!n || !io) return;
            io.disconnect();
            for (const c of Array.from(n.children || []))if (c) io.observe(c);
        },
        // A child just became current (a click, the keyboard, a route, a value
        // set from outside): show it whole on the observer's next frame, with
        // the flags.
        edgeFadeBecameCurrent (el, node) {
            if (!el) return;
            el._edgeFadeWant = node || true;
            this.edgeFadeObserve(el);
        },
        // The row changed shape: reveal the current child first (it moves the
        // scroll), then read the flags against the settled position.
        edgeFadeChanged (el) {
            if (!el) return;
            el._edgeFadeWant = true;
            this.edgeFadeObserve(el);
        },
        edgeFadeArm (el) {
            const n = el && el.node;
            if (!n) return;
            if (!el._edgeFadeIo && typeof IntersectionObserver !== 'undefined') el._edgeFadeIo = new IntersectionObserver((entries)=>{
                if (el._edgeFadeIo) this.edgeFadeSeen(el, entries);
            }, {
                root: n,
                threshold: [
                    0,
                    0.99,
                    1
                ]
            });
            if (!el._edgeFadeRo && typeof ResizeObserver !== 'undefined') {
                el._edgeFadeRo = new ResizeObserver(()=>this.edgeFadeChanged(el));
                el._edgeFadeRo.observe(n);
            }
            this.edgeFadeChanged(el);
        },
        edgeFadeDisarm (el) {
            if (el._edgeFadeIo) el._edgeFadeIo.disconnect();
            if (el._edgeFadeRo) el._edgeFadeRo.disconnect();
            el._edgeFadeIo = null;
            el._edgeFadeRo = null;
            el._edgeFadeSeen = null;
            el._edgeFadeWant = null;
        }
    },
    onScroll: (e, el)=>el.scope.edgeFadeScrolled(el),
    onMounted: (el)=>el.scope.edgeFadeArm(el),
    onContentUpdate: (el)=>el.scope.edgeFadeChanged(el),
    onRemove: (el)=>el.scope.edgeFadeDisarm(el)
};

});


parcelRegister("f8wM8", function(module, exports) {

$parcel$export(module.exports, "AssistantModeChip", () => $b05106e40368c8a1$export$d3d1b0c112a71e4d);

var $9GdJK = parcelRequire("9GdJK");
const $b05106e40368c8a1$export$d3d1b0c112a71e4d = {
    tag: 'button',
    type: 'button',
    // FA204 / frank: every helper lives in scope (a module-scope read from a
    // serialized prop factory reads as undefined once this is frank.toJSON'd).
    scope: {
        // Each mode names its polyglot key LITERALLY (the i18n gate forbids a key
        // built by concatenation — a built key is invisible to the extraction).
        // `icon` is the glyph painted today — five DIFFERENT shapes, because on
        // phones the chip shows the glyph alone (a spark, a layout, a stack, the
        // code brackets, play); `glyph` is the design lane's line glyph for the
        // mode (dropdowns spec §3.3, `ln*`), which replaces `icon` once that icon
        // set is in the sprite.
        modeChipModes () {
            // A comm host (workspace docs/COMM_HOST.md) offers its own modes only —
            // commProfileData.js commAssistantModes(), restated (scope methods are
            // serialized alone).
            let comm = false;
            try {
                const host = String(window.location && window.location.hostname || '').toLowerCase();
                comm = /(^|\.)comm?\.symbols\.app$/.test(host) || window.localStorage.getItem('symbols_force_comm') === '1' || (window.location.search || '').includes('comm=1');
            } catch (_) {
                comm = false;
            }
            const all = [
                {
                    mode: 'assistant',
                    key: 'ai.assistantMode.assistant',
                    icon: 'magicstarOutline',
                    glyph: 'lnAssistant'
                },
                {
                    mode: 'dashboard',
                    key: 'ai.assistantMode.dashboard',
                    icon: 'layoutOutline',
                    glyph: 'lnDashboard'
                },
                {
                    mode: 'tools',
                    key: 'ai.assistantMode.tools',
                    icon: 'layers',
                    glyph: 'lnTools'
                },
                {
                    mode: 'apps',
                    key: 'ai.assistantMode.apps',
                    icon: 'code',
                    glyph: 'lnApps'
                },
                {
                    mode: 'presentation',
                    key: 'ai.assistantMode.presentation',
                    icon: 'play',
                    glyph: 'lnPresentation'
                },
                // Fly (Nika 2026-10-17): every ask composes a page — the wing of the
                // Fly mark: the swoosh as PIXEL art (designSystem/icons.js pxFly — Nika
                // 2026-10-18, "choose z_current but pixelated"); it shows only at 16 px.
                {
                    mode: 'fly',
                    key: 'ai.assistantMode.fly',
                    icon: 'send',
                    glyph: 'pxFly'
                }
            ];
            return comm ? all.filter((x)=>[
                    'assistant',
                    'tools',
                    'fly'
                ].includes(x.mode)) : all;
        },
        modeChipKey (mode) {
            const m = this.modeChipModes().find((x)=>x.mode === mode);
            return m ? m.key : 'ai.assistantMode.assistant';
        },
        // the mode's own glyph — the one its menu row paints: the design lane's LINE glyph (dropdowns spec
        // §7.3 B1; the workspace glyph set has been in the sprite since 217ecd70a) — except Fly, whose mark is
        // the PIXEL swoosh everywhere it shows (Nika 2026-10-18 "choose z_current but pixelated": pxFly)
        modeChipIcon (mode) {
            const m = this.modeChipModes().find((x)=>x.mode === mode);
            return m ? m.glyph : 'lnAssistant';
        },
        // WHAT THE CHIP NAMES — its word, glyph and name: { key, glyph }. The
        // stored mode, except while a thread holds the screen: then the VIEW there
        // (plan rule 2.1-1 "labels read the view"; item 4 = A, the concierge for
        // Nika 2026-10-28: "one rule everywhere") — "Chat". The main thread's view
        // is read from the one reader the thread head, the placeholder and the Ask
        // menu read (workspace assistantAskRoute.js assistantEffectiveView; Apps
        // mode's thread is Build, which the stored Apps already names). A mount
        // that IS a thread surface says so with the flat `threadSurface` (the
        // sidebar drawer's head: shown only with its thread, and an ask typed
        // there stays in that chat) — Chat by the same rule, Apps keeps its name.
        // The stored mode stays — nothing is written, the menu still checks it —
        // and the chip names it again once the thread closes. A host without the
        // readers (canvas standalone) names the stored mode.
        modeChipShown (el, root) {
            const mode = this.modeChipCurrent(root);
            const chat = {
                key: 'workspace.homeView.chat',
                glyph: 'lnChat'
            };
            if (el && el.threadSurface && mode !== 'apps') return chat;
            const fns = el && el.context && el.context.functions;
            const thread = !!fns && typeof fns.assistantMainThreadOpen === 'function' && typeof fns.assistantEffectiveView === 'function' && !!el.call('assistantMainThreadOpen', root);
            if (thread && el.call('assistantEffectiveView', root) === 'chat') return chat;
            return {
                key: this.modeChipKey(mode),
                glyph: this.modeChipIcon(mode)
            };
        },
        modeChipCurrent (root) {
            const m = root && root.assistantMode;
            return this.modeChipModes().some((x)=>x.mode === m) ? m : 'assistant';
        },
        modeChipOffered (el, s) {
            const fns = el && el.context && el.context.functions;
            return !!fns && typeof fns.setAssistantMode === 'function';
        },
        // The merged form is on: the mount asked for it (`withContext`, read off
        // the CHIP element) and the shell's context readers + writer exist.
        modeChipContextOn (chip) {
            if (!chip || !chip.withContext) return false;
            const fns = chip.context && chip.context.functions;
            return !!fns && typeof fns.aiScopeOptions === 'function' && typeof fns.aiScopeCurrent === 'function' && typeof fns.setAiScope === 'function';
        },
        // The chosen (or default) context row, or null where the form is off.
        modeChipContextRow (chip, s) {
            if (!this.modeChipContextOn(chip)) return null;
            try {
                return chip.call('aiScopeCurrent', s && s.root) || null;
            } catch (_) {
                return null;
            }
        },
        // The menu's context rows: every option, the chosen one checked. A row
        // reads its option key off ITSELF (`scopeKey`), never a captured variable
        // (frank FA205). Its key is prefixed: a data key that names an HTML tag
        // becomes that tag.
        modeChipContextRows (chip, s) {
            const root = s && s.root;
            let options = [];
            try {
                options = chip.call('aiScopeOptions', root) || [];
            } catch (_) {
                options = [];
            }
            const current = this.modeChipContextRow(chip, s);
            const chosen = current ? current.key : null;
            return options.map((o)=>({
                    key: 'ctx-' + o.key,
                    scopeKey: o.key,
                    glyph: o.glyph || 'lnApps',
                    text: o.label || o.short || '',
                    checked: o.key === chosen,
                    onClick: (ev, row)=>{
                        row.call('closeDropdown', 'assistantMode');
                        row.call('setAiScope', row.scopeKey);
                    }
                }));
        },
        // One labelled group of the merged menu: role="group" named by its
        // caption; the caption itself is aria-hidden (the group's name already
        // says it) and is a span, so the menu keyboard never lands on it.
        modeChipGroup (label, rows) {
            return {
                role: 'group',
                ariaLabel: label,
                flow: 'y',
                gap: '0',
                minWidth: '0',
                AiPanelLabel: {
                    ariaHidden: 'true',
                    text: label,
                    padding: 'Y Z1 X'
                },
                GroupRows: {
                    flow: 'y',
                    gap: '0',
                    minWidth: '0',
                    childExtends: 'MenuPanelItem',
                    children: rows
                }
            };
        },
        // aria-expanded follows the dropdown plugin's own layer: its onOpen once
        // the layer is up, its onClose on every close — a row, Escape, an outside
        // press, or another dropdown replacing this one. Written through the
        // element's own update as `attr` (AppScrollRow's path): the flat
        // `ariaExpanded` is applied once at create, and an update of the flat key
        // does not re-apply it (measured on the real smbls create()).
        modeChipExpanded (el, open) {
            if (!el || !el.node) return;
            el.update({
                attr: {
                    'aria-expanded': open ? 'true' : 'false'
                }
            });
        },
        modeChipOpen (el, s) {
            const current = this.modeChipCurrent(s && s.root);
            // A row's handler reads its mode off the ROW (a flat `mode` prop), never
            // a variable captured from this map — a captured one would not survive
            // serialization (frank FA205).
            const rows = this.modeChipModes().map((m)=>({
                    key: m.mode,
                    mode: m.mode,
                    // the mode's glyph (LINE; Fly's is its pixel mark) — MenuPanelItem's own Plate slot (c24d97aa8) draws it with the house row's
                    // spacing and inversion; the row carries no plate, spacing or state rule of its own (Nika: "fix ai mode
                    // chooser dropdown gaps in dropdown list items" — the label touched a row-level plate, 0 px)
                    glyph: m.glyph,
                    text: el.call('polyglot', m.key),
                    checked: m.mode === current,
                    onClick: (ev, row)=>{
                        row.call('closeDropdown', 'assistantMode');
                        row.call('setAssistantMode', row.mode);
                    }
                }));
            // the body paints nothing: MenuPanel's opaque `dialog` surface and its elevation are dropped (the
            // SearchAppsMenu recipe); its keyboard model, role and focus arming stay
            const body = {
                extends: 'MenuPanel',
                theme: null,
                background: 'transparent',
                backdropFilter: 'none',
                shadow: 'none',
                ':focus-visible': {
                    boxShadow: 'none'
                },
                // DESIGN_SPEC 6.5: reduced transparency = the opaque `dialog` surface (the body covers the Panel)
                '@reduceTransparency': {
                    theme: 'dialog'
                }
            };
            // THE MERGED MENU (withContext): the Context group first, then the Mode group; else the flat mode menu.
            const content = this.modeChipContextOn(el) ? {
                ...body,
                ariaLabel: el.call('polyglot', 'ai.assistantMode.menuWithContext'),
                ContextGroup: this.modeChipGroup(el.call('polyglot', 'ai.scope.label'), this.modeChipContextRows(el, s)),
                ModeGroup: this.modeChipGroup(el.call('polyglot', 'ai.assistantMode.label'), rows)
            } : {
                ...body,
                ariaLabel: el.call('polyglot', 'ai.assistantMode.label'),
                childExtends: 'MenuPanelItem',
                children: rows
            };
            el.call('openDropdown', {
                anchorEl: el,
                id: 'assistantMode',
                placement: 'top-start',
                round: 'radiusCard',
                // THE GLASS ON THE LAYER (dropdowns spec §7.3 B2, the 9d0573e22 lesson): the plugin Panel carries the
                // one popover glass and the elevation — its own backdrop-filter reaches the page; a glass on the body
                // inside it would not. No `background` here: a surface override beats the theme's fill.
                theme: 'search-glass',
                shadow: 'overlay',
                onOpen: ()=>el.scope.modeChipExpanded(el, true),
                onClose: ()=>el.scope.modeChipExpanded(el, false),
                content: content
            });
        }
    },
    // the stored mode, and the keys the main thread's reader reads
    // (workspace assistantMainThread.js assistantMainThreadOpen)
    subscribeTo: [
        'assistantMode',
        '_homeThreadOpen',
        'assistantDock',
        'currentPath',
        '_mainThreadPath'
    ],
    hide: (el, s)=>!el.scope.modeChipOffered(el, s),
    flow: 'x',
    align: 'center',
    gap: 'X',
    flexShrink: '0',
    // the inverted glyph plate leads (dropdowns spec §4 capsule: inline padding `Y Z2 Y Y`)
    padding: 'Y Z2 Y Y',
    // the phone form is a glyph + caret: the inline padding drops to the block
    // one (Y), so it takes ~40 px where the word takes 101-141 px (en / ka)
    '@mobileL': {
        paddingInline: 'Y'
    },
    // the small pill's compact form: the same glyph + caret geometry — unless the
    // merged form names the context there (the pill has no second trigger now)
    class: {
        isCompact: (el, s)=>!!(s && s.size === 'small') && !el.scope.modeChipContextRow(el, s)
    },
    '&.isCompact': {
        paddingInline: 'Y'
    },
    round: 'radiusControl',
    border: 'none',
    background: 'transparent',
    color: 'title',
    fontWeight: '400',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    },
    // the open menu (dropdowns spec §7.3 B3): the `selected` wash while aria-expanded
    '&[aria-expanded="true"]': {
        background: 'selected'
    },
    // A finger's target: the composer's mode prefix measured 47-50 x 35-36 on
    // dev DFI with a touch device simulated — the 44pt floor (_touchTarget.js).
    '@coarse': {
        position: 'relative',
        ...(0, $9GdJK.touchFloor)
    },
    ariaHaspopup: 'menu',
    ariaExpanded: 'false',
    ariaLabel: (el, s)=>{
        const sc = el.scope;
        const mode = el.call('polyglot', sc.modeChipShown(el, s && s.root).key);
        const row = sc.modeChipContextRow(el, s);
        if (!row) return el.call('polyglot', 'ai.assistantMode.label') + ': ' + mode;
        return el.call('polyglot', 'ai.assistantMode.labelWithContext').replace('{mode}', ()=>mode).replace('{context}', ()=>row.label || row.short || '');
    },
    // The phone form's glyph (the Icon built-in): hidden by default, shown on
    // the mobileL band only. Glyph and caret never shrink — even where a mount
    // makes the chip elastic (the canvas composer truncates the Label first,
    // 40e9d2445), the menu sign stays whole.
    Icon: {
        name: (el, s)=>el.parent.scope.modeChipShown(el.parent, s && s.root).glyph,
        // THE INVERTED GLYPH PLATE (dropdowns spec §4 "the mode chip", §7.3 B3): this glyph child IS the plate —
        // `glyphPlateXs`, round, `highlight` fill, `title-reversed` ink, the glyph inset to exactly `iconSm` (a
        // pixel glyph shows whole cells only at 16 px) — and it shows
        // on every width: plate + word + caret on desktop, plate + caret on phones and in the small pill (the word
        // hides there, the name keeps it). Glyph and caret never shrink — even where a mount makes the chip elastic
        // (the canvas composer truncates the Label first, 40e9d2445), the menu sign stays whole.
        flexShrink: '0',
        boxSizing: 'border-box',
        boxSize: 'glyphPlateXs',
        // The glyph is exactly `iconSm` inside the plate — the inset is computed
        // from the two tokens, never the em-based `X` (3.6–4.0 px by font size): a
        // PIXEL glyph (pxFly) shows whole cells only at 16 px.
        padding: 'calc((var(--size-glyphPlateXs) - var(--size-iconSm)) / 2)',
        round: 'radiusPill',
        background: 'highlight',
        color: 'title-reversed',
        // the small pill's compact marker stays on the glyph (the pill slot reads it); it styles nothing here now
        class: {
            isCompact: (el, s)=>!!(s && s.size === 'small')
        }
    },
    // The word: the mode's — or, in the merged form, the CONTEXT's short name,
    // capped at D2 (the measured row budget, composerToolRowGeometry) with an
    // ellipsis and its full name in the title (the overflow law's secondary
    // meta). The mode word is never capped: the chip stays rigid for it.
    Label: {
        tag: 'span',
        text: (el, s)=>{
            const sc = el.parent.scope;
            const row = sc.modeChipContextRow(el.parent, s);
            if (row) return row.short || row.label || '';
            return el.call('polyglot', sc.modeChipShown(el.parent, s && s.root).key);
        },
        title: (el, s)=>{
            const row = el.parent.scope.modeChipContextRow(el.parent, s);
            return row && row.label || null;
        },
        whiteSpace: 'nowrap',
        '@mobileL': {
            display: 'none'
        },
        class: {
            isCompact: (el, s)=>!!(s && s.size === 'small') && !el.parent.scope.modeChipContextRow(el.parent, s),
            hasContext: (el, s)=>!!el.parent.scope.modeChipContextRow(el.parent, s)
        },
        '&.isCompact': {
            display: 'none'
        },
        '&.hasContext': {
            maxWidth: 'D2',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    Caret: {
        extends: 'Icon',
        name: 'arrow angle down',
        flexShrink: '0',
        boxSize: 'Z',
        opacity: '.6'
    },
    onKeydown: (e, el, s)=>{
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        e.stopPropagation();
        el.scope.modeChipOpen(el, s);
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        el.scope.modeChipOpen(el, s);
    }
};

});

parcelRegister("ajIJv", function(module, exports) {

$parcel$export(module.exports, "AiScopeSwitch", () => $782e60c9705f324a$export$35a18c84bf4a3e8a);
$parcel$export(module.exports, "AiScopeChip", () => $782e60c9705f324a$export$d658238771243022);
// AiScopeSwitch / AiScopeChip — THE CONTEXT of an AI ask, chosen in the
// composer's focus panel (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1).
//
// One radio group: the open record, the page, the app, the workspace, then the
// other installed apps — most specific first (the shell's context model,
// workspace functions/aiScope.js, through `el.call`). Each choice is a chip:
// the context's line glyph and its short name; the chosen one is the D-1
// inversion (`highlight` fill, `highlight-reversed` ink) the kit's choice
// chips wear (AppChoiceChip), every other one the tonal capsule of its own ink
// (14 / 22 / 30 % on rest / hover / press — Rule 67, a tint of currentColor
// follows the theme). The row WRAPS (overflow law §3b.5: nothing is cut at
// the edge; a long Georgian app name takes a second line, never an ellipsis).
//
// THE KEYBOARD (the radio group pattern): one Tab stop — the chosen chip
// (roving tabindex); ← → ↑ ↓ move the choice and the focus, Home / End reach
// the ends. The move IS the choice (automatic activation), like the kit's
// segmented control (AppSegmentedItem). A chip's name says its kind: "Page:
// Validators · Overview".
//
// The host passes nothing: the rows, the chosen key and the writer are the
// shell's (`aiScopeOptions`, `aiScopeChosenKey`, `setAiScope`). A host
// without them renders no switch.
const $782e60c9705f324a$export$35a18c84bf4a3e8a = {
    role: 'radiogroup',
    ariaLabel: (el)=>el.call('polyglot', 'ai.scope.label'),
    hide: (el)=>!(el.context && el.context.functions && el.context.functions.aiScopeOptions),
    flow: 'x',
    flexWrap: 'wrap',
    align: 'center start',
    gap: 'Y',
    minWidth: '0',
    childExtends: 'AiScopeChip',
    childrenAs: 'state',
    children: (el, s)=>{
        const fns = el.context && el.context.functions;
        if (!fns || typeof fns.aiScopeOptions !== 'function') return [];
        let rows = [];
        try {
            rows = el.call('aiScopeOptions', s.root) || [];
        } catch (_) {
            rows = [];
        }
        return rows.map((r)=>({
                key: 'scope-' + r.key,
                value: r.key,
                text: r.short || r.label,
                label: r.label,
                kind: r.kind,
                other: !!r.other,
                glyph: r.glyph
            }));
    }
};
const $782e60c9705f324a$export$d658238771243022 = {
    tag: 'button',
    type: 'button',
    role: 'radio',
    flow: 'x',
    align: 'center',
    gap: 'X',
    flexShrink: '0',
    maxWidth: '100%',
    minHeight: 'controlHCompact',
    boxSizing: 'border-box',
    padding: '0 Z1 0 Y',
    round: 'radiusPill',
    borderWidth: '0',
    cursor: 'pointer',
    fontSize: 'Z',
    fontWeight: '500',
    lineHeight: '1.2',
    textAlign: 'left',
    color: 'title',
    background: 'color-mix(in srgb, currentColor 14%, transparent)',
    transition: 'background-color A defaultBezier, color A defaultBezier',
    ':hover': {
        background: 'color-mix(in srgb, currentColor 22%, transparent)'
    },
    ':active': {
        background: 'color-mix(in srgb, currentColor 30%, transparent)'
    },
    '@coarse': {
        minHeight: 'controlH'
    },
    scope: {
        // The chosen key, read through the shell's one reader.
        chosen (el, s) {
            try {
                return el.call('aiScopeChosenKey', s && s.root);
            } catch (_) {
                return null;
            }
        },
        // A chip's spoken name: its kind, then its full name ("Page: Validators ·
        // Overview") — the colon form, so a translation never declines the name.
        spoken (el, s) {
            const kinds = {
                record: 'ai.scope.kind.record',
                page: 'ai.scope.kind.page',
                app: 'ai.scope.kind.app',
                workspace: 'ai.scope.kind.workspace'
            };
            const kind = el.call('polyglot', kinds[s && s.kind] || kinds.app);
            return kind + ': ' + (s && (s.label || s.text) || '');
        },
        // Move the choice to a sibling chip and its focus with it.
        move (el, to) {
            const host = el.parent;
            const items = host && typeof host.getChildren === 'function' ? host.getChildren() : [];
            if (!items.length) return;
            const at = items.indexOf(el);
            const i = to === 'first' ? 0 : to === 'last' ? items.length - 1 : (at + to + items.length) % items.length;
            const next = items[i];
            if (!next || next === el) return;
            el.call('setAiScope', next.state && next.state.value);
            if (next.node && typeof next.node.focus === 'function') next.node.focus();
        }
    },
    isActive: (el, s)=>el.scope.chosen(el, s) === (s && s.value),
    ariaChecked: (el, s)=>el.scope.chosen(el, s) === (s && s.value) ? 'true' : 'false',
    tabindex: (el, s)=>el.scope.chosen(el, s) === (s && s.value) ? '0' : '-1',
    ariaLabel: (el, s)=>el.scope.spoken(el, s),
    title: (el, s)=>s && s.label || null,
    dataActive: (el, s)=>el.scope.chosen(el, s) === (s && s.value),
    '&[data-active]': {
        background: 'highlight',
        color: 'highlight-reversed'
    },
    '&[data-active]:hover': {
        background: 'highlight',
        color: 'highlight-reversed'
    },
    // WINDOWS CONTRAST: forced colours drop the fills — the chosen chip keeps a
    // system outline (the kit segment's rule).
    '@forcedColors': {
        '&[data-active]': {
            outlineWidth: 'hairline2',
            outlineStyle: 'solid',
            outlineColor: 'Highlight',
            outlineOffset: '0'
        }
    },
    // The context's line glyph — never shrinks, the name does (it wraps).
    Icon: {
        name: (el, s)=>s && s.glyph || 'lnApps',
        boxSize: 'iconSm',
        flexShrink: '0',
        ariaHidden: 'true'
    },
    Label: {
        tag: 'span',
        minWidth: '0',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.text || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('setAiScope', s && s.value);
    },
    onKeydown: (e, el)=>{
        const step = {
            ArrowRight: 1,
            ArrowDown: 1,
            ArrowLeft: -1,
            ArrowUp: -1
        }[e.key];
        const to = step || (e.key === 'Home' ? 'first' : e.key === 'End' ? 'last' : null);
        if (!to) return;
        e.preventDefault();
        e.stopPropagation();
        el.scope.move(el, to);
    }
};

});

parcelRegister("iToPu", function(module, exports) {

$parcel$export(module.exports, "AiModeSwitch", () => $dc109fb02311c9c5$export$ec85505c91d5418a);
$parcel$export(module.exports, "AiModeOption", () => $dc109fb02311c9c5$export$1819426258b7bcfc);
// AiModeSwitch — WHAT the AI makes, chosen in the composer's focus panel
// (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1: "MODES made clear: name +
// one-line description, current one obvious").
//
// The six modes as the kit's segmented control (AppSegmented, the `choice`
// strength — the chosen segment is the ink thumb), each segment the mode's own
// glyph (LINE; Fly's is its pixel mark, pxFly) — the one the composer's mode chip wears, so the panel teaches
// the chip — and beside the track ONE line naming the current mode and what
// it does ("Dashboard — Builds a board of widgets"). Every segment carries its
// name (aria-label) and its own line (the tooltip). The track writes through
// the shell's ONE writer (`setAssistantMode`), exactly like the chip's menu;
// without that writer it renders nothing.
//
// The mode list mirrors AssistantModeChip.scope.modeChipModes (the chip keeps
// its own frank-safe copy; aiModeSwitch.test.js holds the two equal).
const $dc109fb02311c9c5$export$ec85505c91d5418a = {
    flow: 'x',
    flexWrap: 'wrap',
    align: 'center start',
    gap: 'Y Z',
    minWidth: '0',
    hide: (el)=>!(el.context && el.context.functions && typeof el.context.functions.setAssistantMode === 'function'),
    scope: {
        modes () {
            // A comm host (workspace docs/COMM_HOST.md) offers its own modes only —
            // commProfileData.js commAssistantModes(), restated (scope methods are
            // serialized alone).
            let comm = false;
            try {
                const host = String(window.location && window.location.hostname || '').toLowerCase();
                comm = /(^|\.)comm?\.symbols\.app$/.test(host) || window.localStorage.getItem('symbols_force_comm') === '1' || (window.location.search || '').includes('comm=1');
            } catch (_) {
                comm = false;
            }
            const all = [
                {
                    mode: 'assistant',
                    key: 'ai.assistantMode.assistant',
                    desc: 'ai.assistantMode.desc.assistant',
                    glyph: 'lnAssistant'
                },
                {
                    mode: 'dashboard',
                    key: 'ai.assistantMode.dashboard',
                    desc: 'ai.assistantMode.desc.dashboard',
                    glyph: 'lnDashboard'
                },
                {
                    mode: 'tools',
                    key: 'ai.assistantMode.tools',
                    desc: 'ai.assistantMode.desc.tools',
                    glyph: 'lnTools'
                },
                {
                    mode: 'apps',
                    key: 'ai.assistantMode.apps',
                    desc: 'ai.assistantMode.desc.apps',
                    glyph: 'lnApps'
                },
                {
                    mode: 'presentation',
                    key: 'ai.assistantMode.presentation',
                    desc: 'ai.assistantMode.desc.presentation',
                    glyph: 'lnPresentation'
                },
                {
                    mode: 'fly',
                    key: 'ai.assistantMode.fly',
                    desc: 'ai.assistantMode.desc.fly',
                    glyph: 'pxFly'
                }
            ];
            return comm ? all.filter((x)=>[
                    'assistant',
                    'tools',
                    'fly'
                ].includes(x.mode)) : all;
        },
        current (root) {
            const m = root && root.assistantMode;
            return this.modes().some((x)=>x.mode === m) ? m : 'assistant';
        },
        line (el, mode) {
            const m = this.modes().find((x)=>x.mode === mode) || this.modes()[0];
            return el.call('polyglot', m.key) + " \u2014 " + el.call('polyglot', m.desc);
        }
    },
    AppSegmented: {
        variant: 'choice',
        compact: true,
        ariaLabel: (el)=>el.call('polyglot', 'ai.assistantMode.label'),
        current: (el, s)=>el.parent.scope.current(s && s.root),
        select: 'setAssistantMode',
        childExtends: 'AiModeOption',
        childrenAs: 'state',
        children: (el)=>el.parent.scope.modes().map((m)=>({
                    key: 'mode-' + m.mode,
                    value: m.mode,
                    text: '',
                    glyph: m.glyph,
                    name: m.key,
                    desc: m.desc
                }))
    },
    // The current mode, named, with what it does — one quiet line that wraps
    // under the track when the panel is narrow (a phone, a long Georgian line).
    ModeLine: {
        tag: 'span',
        minWidth: '0',
        flex: '1 1 12em',
        fontSize: 'Z',
        color: 'caption',
        lineHeight: '1.35',
        overflowWrap: 'anywhere',
        text: (el, s)=>el.parent.scope.line(el, el.parent.scope.current(s && s.root))
    }
};
const $dc109fb02311c9c5$export$1819426258b7bcfc = {
    extends: 'AppSegmentedItem',
    padding: '0 Z',
    ariaLabel: (el, s)=>el.call('polyglot', s && s.name || ''),
    title: (el, s)=>el.call('polyglot', s && s.name || '') + " \u2014 " + el.call('polyglot', s && s.desc || ''),
    Icon: {
        name: (el, s)=>s && s.glyph || 'lnAssistant',
        boxSize: 'iconSm',
        ariaHidden: 'true'
    }
};

});

parcelRegister("duAq3", function(module, exports) {

$parcel$export(module.exports, "AiPanelLabel", () => $9d2a53cfee6cc161$export$2ee90bd2ff018b1c);
$parcel$export(module.exports, "AiPanelAction", () => $9d2a53cfee6cc161$export$677b93fc454840ca);
$parcel$export(module.exports, "AiPanelGroup", () => $9d2a53cfee6cc161$export$ca309a9c7efee56b);
$parcel$export(module.exports, "AiPanelRow", () => $9d2a53cfee6cc161$export$a29acfdf08e6732b);
// The PARTS of the composer's focus panel (DESIGN-COMPOSER-FOCUS-POPOVER-
// CONTEXT-INSPECT-1; the panel is _simone/Suggestions.js):
//
//   AiPanelLabel   a section's name — the quiet eyebrow ("Context",
//                  "Suggested for Overview", "Recent", "Mode")
//   AiPanelAction  one of the three first-class verbs (Inspect & ask,
//                  Summarize, Build a board): the kit's tonal capsule in its
//                  compact size, the verb's line glyph on the house plate
//   AiPanelGroup   a group of suggestion rows (role=group, named by its label)
//   AiPanelRow     one suggestion: THE house menu row (MenuPanelItem — its
//                  glyph plate slot, hover / focus / press, the inset focus
//                  ring) in the menu the panel's rows form; the generic
//                  staple reads one ink step quieter
//
// Every row and verb sends through the shell (`aiPanelSend`, `aiPanelRun` —
// workspace functions/aiPanel.js); nothing here builds a prompt.
const $9d2a53cfee6cc161$export$2ee90bd2ff018b1c = {
    tag: 'span',
    display: 'block',
    fontSize: 'Z',
    fontWeight: '500',
    lineHeight: '1.3',
    color: 'caption',
    padding: '0 X',
    overflowWrap: 'anywhere'
};
const $9d2a53cfee6cc161$export$677b93fc454840ca = {
    extends: 'AppCapsuleBtnToolbar',
    compact: true,
    // The three share one track each (the panel's grid): a verb fills its
    // column, so the trio reads as one symmetric row in every language; a long
    // Georgian verb wraps inside its capsule (the kit's text law).
    width: '100%',
    minWidth: '0',
    gap: 'Y',
    // The verb's glyph on the plate; the capsule's hover and keyboard focus
    // invert it (the one state logic of a glyph plate).
    '&:hover [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed'
    },
    '&:focus-visible [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed'
    },
    ariaLabel: (el, s)=>s && s.label || null,
    title: (el, s)=>s && s.hint || null,
    // PHONES: three tiles — the glyph over the word, so each word keeps the
    // whole track (beside its glyph, "Summarize" broke as "Summariz / e" at 390
    // on dev 2026-10-04).
    '@mobileL': {
        flexDirection: 'column',
        gap: 'X',
        paddingBlock: 'Z',
        round: 'radiusCard',
        textAlign: 'center'
    },
    Plate: {
        dataGlyphPlate: true,
        ariaHidden: 'true',
        display: 'flex',
        align: 'center center',
        flexShrink: '0',
        boxSize: 'glyphPlateXs',
        round: 'radiusPill',
        color: 'caption',
        transition: 'background-color A defaultBezier, color A defaultBezier',
        Icon: {
            name: (el, s)=>s && s.glyph || 'lnAssistant',
            boxSize: 'iconSm'
        }
    },
    ActionLabel: {
        tag: 'span',
        minWidth: '0',
        text: (el, s)=>s && s.label || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        el.call('aiPanelRun', s && (s.verb || s.key));
    }
};
const $9d2a53cfee6cc161$export$ca309a9c7efee56b = {
    role: 'group',
    ariaLabel: (el, s)=>s && s.label || null,
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    // The group's name for the eye; the group's own aria-label names it for
    // assistive technology, so this copy is hidden from it.
    AiPanelLabel: {
        ariaHidden: 'true',
        text: (el, s)=>s && s.label || ''
    },
    GroupRows: {
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        childExtends: 'AiPanelRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const rows = s && s.rows;
            const list = rows && typeof rows.parse === 'function' ? rows.parse() : rows;
            return Array.isArray(list) ? list : [];
        }
    }
};
const $9d2a53cfee6cc161$export$a29acfdf08e6732b = {
    extends: 'MenuPanelItem',
    // MenuPanelItem draws its Plate from the row's `glyph` (a line glyph name).
    glyph: (el, s)=>s && s.glyph || null,
    text: (el, s)=>s && s.text || '',
    title: (el, s)=>s && s.prompt && s.prompt !== s.text ? s.prompt : null,
    color: (el, s)=>s && s.generic ? 'paragraph' : 'title',
    lineHeight: '1.35',
    // the house row's text law, restated where the panel's names live: a long
    // ask or a Georgian compound wraps inside the row, never widens the panel
    overflowWrap: 'anywhere',
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        const row = s && typeof s.parse === 'function' ? s.parse() : s;
        el.call('aiPanelSend', row);
    }
};

});

parcelRegister("hPOOF", function(module, exports) {

$parcel$export(module.exports, "AppColorChip", () => $cfbe9e1fa7d546f8$export$7fc909edff463ae4);
$parcel$export(module.exports, "AppColorChips", () => $cfbe9e1fa7d546f8$export$4859cbcb4b7f6df9);
$parcel$export(module.exports, "AppFieldColors", () => $cfbe9e1fa7d546f8$export$faed2c60229e78f0);
// Colour options — brief §4.4 item 3 (P42), 2026-09-24: tonal chips, each a
// DOT that IS the value (the colour token itself) and a LABEL that stays ink.
// A colour pick is a CHOICE control, so the chosen chip is the D-1 inversion
// (`highlight` fill + `highlight-reversed` ink); its dot keeps the colour.
//
// The tonal fill mixes the chip's OWN ink (Rule 67: a tint of currentColor
// follows the ink per scheme): 14% at rest, 22% on hover, 30% pressed. Each
// step clears Rule 65's 0.02 luminance floor on the white and on the dark
// card (computed in __tests__/appFieldColors.test.js).
//
// Contract: the shared AppChoiceGroup's — `options` [{ value, label }] where
// `value` is a brand colour token ('blue', 'green', …), and `stateKey`, the
// state key a click writes. The label is a bundle key or a plain string.
const $cfbe9e1fa7d546f8$export$7fc909edff463ae4 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center',
    gap: 'Y',
    minHeight: 'controlHCompact',
    padding: '0 Z1',
    round: 'radiusPill',
    borderWidth: '0',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    color: 'title',
    background: 'color-mix(in srgb, currentColor 14%, transparent)',
    ':hover': {
        background: 'color-mix(in srgb, currentColor 22%, transparent)'
    },
    ':active': {
        background: 'color-mix(in srgb, currentColor 30%, transparent)'
    },
    '.isActive': {
        background: 'highlight',
        color: 'highlight-reversed'
    },
    '@coarse': {
        minHeight: 'controlH'
    },
    Dot: {
        tag: 'span',
        'aria-hidden': true,
        boxSize: 'Z',
        flexShrink: '0',
        round: 'radiusPill',
        background: (el)=>el.parent?.optionValue
    },
    Label: {
        tag: 'span',
        text: (el)=>el.call('polyglot', el.parent?.optionLabel ?? '')
    }
};
const $cfbe9e1fa7d546f8$export$4859cbcb4b7f6df9 = {
    extends: 'AppChoiceGroup',
    childExtends: 'AppColorChip',
    flow: 'x',
    flexWrap: 'wrap',
    gap: 'Y'
};
const $cfbe9e1fa7d546f8$export$faed2c60229e78f0 = {
    extends: 'AppField',
    // A choice group is not a <label> — see AppFieldSegmented.
    tag: 'div',
    AppColorChips: {
        ariaLabel: (el)=>el.call('polyglot', el.parent?.label || ''),
        options: (el)=>el.parent?.options,
        stateKey: (el)=>el.parent?.stateKey
    }
};

});

parcelRegister("jexpo", function(module, exports) {

$parcel$export(module.exports, "AppChoiceChip", () => $e0093d5cf93f9f1d$export$4943f750927ada79);
$parcel$export(module.exports, "AppChoiceChips", () => $e0093d5cf93f9f1d$export$763f179d45fa51bf);
$parcel$export(module.exports, "AppFieldChips", () => $e0093d5cf93f9f1d$export$7ba994780110a648);
// A SHORT option set in a NARROW column is a row of choice chips that WRAPS —
// the shell twin of the AI House chip rows (AhChipChoice). Nika 2026-09-24,
// "choice fields: where a select holds few options, use AppFieldSegmented /
// chips".
//
// AppSegmented is the brand TabSet: ONE line (`width: fit-content`), each
// segment at `Z2` type with a `B1` inset on both sides of its label. Four
// ticket types need over 400px that way in English, and more in Georgian;
// the ticket sidebar column is about 238px. A column that narrow takes these
// chips instead: every option is its own capsule, the row wraps, and every
// option stays one tap away in any language.
//
// Nothing here is a new look:
//   AppChoiceChip   the kit's tonal choice chip — AppColorChip without its
//                   dot (a text option carries no colour value): the tonal
//                   fill of its own ink (14 / 22 / 30%), the capsule,
//                   `controlHCompact`, and the chosen chip as the D-1
//                   inversion (`highlight` fill + `highlight-reversed` ink)
//   AppChoiceChips  AppColorChips with those chips: the shared choice
//                   contract (AppChoiceGroup — `options`, `stateKey`,
//                   role=group, aria-pressed) on a wrapping row
// A call site with its own state wiring overrides the chips' `isActive` /
// `ariaPressed` / `onClick` through `childProps`, as with AppSegmented.
//
// AppFieldChips is the FIELD variant: the AppField caption above the row, and
// the group named by the same label. Like AppFieldSegmented it is a `div`: a
// <label> would press its first chip when the caption is clicked.
const $e0093d5cf93f9f1d$export$4943f750927ada79 = {
    extends: 'AppColorChip',
    Dot: null
};
const $e0093d5cf93f9f1d$export$763f179d45fa51bf = {
    extends: 'AppColorChips',
    childExtends: 'AppChoiceChip'
};
const $e0093d5cf93f9f1d$export$7ba994780110a648 = {
    extends: 'AppField',
    tag: 'div',
    AppChoiceChips: {
        ariaLabel: (el)=>el.call('polyglot', el.parent?.label || ''),
        options: (el)=>el.parent?.options,
        stateKey: (el)=>el.parent?.stateKey
    }
};

});

parcelRegister("XQdJz", function(module, exports) {

$parcel$export(module.exports, "AppPageEyebrow", () => $0b3e04b5bf8f8770$export$fbda63144a01702);
// Shared page-header "eyebrow" chip — the canonical replacement for the
// byte-identical inline `Eyebrow: {...}` block forked across cap-table/cms/
// catalog/polyglot/helmet (workspace/DESIGN_LANGUAGE.md §8.5 rule 3: "hue
// carries in the wash; ink stays neutral"). Measured 2026-08-08, light theme,
// hue ink over hue.15 wash over the page ground (rgb(241,241,243)):
//   green  → 2.20:1  FAIL  (cap-table, helmet)
//   blue   → 2.70:1  FAIL  (cms)
//   orange → 2.12:1  FAIL  (polyglot)
//   purple → 4.70:1  pass  (catalog)
// Four of five forks failed WCAG AA (3:1 large-text floor) by painting the
// brand hue as TEXT on a translucent wash of the SAME hue — the wash
// composites toward near-white on light grounds regardless of which hue it
// is, so the "passing" purple copy was luck, not a safe pattern. Do NOT
// revert this back to a hue-coloured `color` — put the hue back in the wash
// and it fails again.
//
// This component owns ONLY the invariant geometry + the neutral ink. It
// deliberately does NOT own the hue: a factory-resolved `color` token is a
// known trap in this codebase (see MEMORY.md
// project_static_color_token_table_drop — static `color` is resolved once
// against the token table, so per-instance hue would need an (el, s)
// function anyway). Keeping `background` a plain per-consumer prop sidesteps
// that trap entirely and keeps the hue where §8.5 says it belongs: in the
// wash, supplied by each app.
//
// Usage:
//   AppPageEyebrow: { background: 'green.15', text: 'Cap table' }
const $0b3e04b5bf8f8770$export$fbda63144a01702 = {
    tag: 'span',
    fontSize: 'Y2',
    fontWeight: '500',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: 'title',
    padding: 'V Z',
    round: 'radiusPill'
};

});

parcelRegister("lUIcz", function(module, exports) {

$parcel$export(module.exports, "DraftSwitcher", () => $ff411d77797e421b$export$b3771b6a97874e3d);
const $ff411d77797e421b$export$b3771b6a97874e3d = {
    Input: {
        checked: ({ state: state })=>state.draft
    },
    SwitchField: {},
    Caption: {
        padding: '0',
        opacity: '.65',
        color: 'inactive',
        text: '{{ common.state.draft | polyglot }}'
    },
    extends: 'SwitchFieldWithCaption',
    onChange: (ev, el, s)=>{
        s.update({
            draft: !s.draft
        });
    }
};

});

parcelRegister("65E03", function(module, exports) {

$parcel$export(module.exports, "IconNavbar", () => $46f23cdf3d39d39b$export$9dc0b64fb0451d70);
// IconNavbar — shared chrome for floating canvas navbars.
//
// Wraps `Navbar` with the standard "floating island" treatment used across
// the editor: common-card theme, C1 round, V Z padding, A gap, no text
// selection. Consumers (AppNavbar, Zoombar, CvModesBar, WorkspaceViews,
// AppHeader, etc.) extend this and only override position/content.
//
// Why a thin wrapper over Navbar:
//   - Navbar in @symbo-ls/brand carries layout primitives (flex row,
//     sticky-on-default, etc.). IconNavbar pins the theme + spacing + round
//     so every floating bar reads as one component family.
//   - One place to retune the look (theme, padding, round) for all bars.
//
// Position overrides — IconNavbar deliberately does NOT pin `position` so
// callers can choose `sticky`, `absolute`, or default. Same for top/left/
// right/bottom: callers anchor wherever they need.
const $46f23cdf3d39d39b$export$9dc0b64fb0451d70 = {
    extends: 'Navbar',
    // `navbar` theme from @symbo-ls/brand (theme.js:371) supplies both color
    // and an opaque blurred background — same palette every floating bar
    // (AppHeader, AppNavbar, Zoombar, CvModesBar) shares. NO `background`
    // override here so the theme's bg actually shows; consumers that want a
    // transparent chrome can set `background: 'transparent'` themselves.
    theme: 'navbar',
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'V Z',
    round: 'radiusPill',
    userSelect: 'none'
};

});

parcelRegister("fyymM", function(module, exports) {

$parcel$export(module.exports, "CANVAS_BG_PRESETS_BY_THEME", () => CANVAS_BG_PRESETS_BY_THEME);
$parcel$export(module.exports, "canvasBackgroundPresetsForTheme", () => canvasBackgroundPresetsForTheme);
$parcel$export(module.exports, "Zoombar", () => Zoombar);
// Canvas background picker — the Zoombar's color dot opens a dropdown
// (presets + native custom input) and writes the picked color to a
// document-level CSS var `--canvas-bg`. Every canvas Stage references it
// via `style: { background: 'var(--canvas-bg, <page default>)' }`
// (project canvas embed/Canvas.js, /studio studios.js root, /tickets
// board.js Stage, /team-and-agents Stage), so one pick recolors whichever
// canvas is active — the old path only poked the project canvas via
// `gs.canvasElement.setNodeStyles`. The CSS-var route is imperative on a
// stable node (documentElement), sidestepping v3.14's frozen reactive
// background factories on mounted stages. Clearing the var restores each
// page's own default. Persistence: the pre-existing per-theme cookie
// `canvas_${theme}_background`, restored in the dot's onInit and whenever
// the shell changes theme so light picks do not leak into dark mode.

var $jlzPZ = parcelRequire("jlzPZ");

var $aFPBz = parcelRequire("aFPBz");

var $9GdJK = parcelRequire("9GdJK");
const CANVAS_BG_PRESETS_BY_THEME = {
    light: [
        {
            label: 'editor.canvasBg.paper',
            value: '#f2f3f5'
        },
        {
            label: 'editor.canvasBg.white',
            value: '#fafafb'
        },
        {
            label: 'editor.canvasBg.mist',
            value: '#e7eaf0'
        },
        {
            label: 'editor.canvasBg.coolGray',
            value: '#dfe3ea'
        },
        {
            label: 'editor.canvasBg.softBlue',
            value: '#eaf2ff'
        },
        {
            label: 'editor.canvasBg.sage',
            value: '#e9f4ee'
        },
        {
            label: 'editor.canvasBg.sand',
            value: '#f4efe6'
        },
        {
            label: 'editor.canvasBg.lavender',
            value: '#f0edfb'
        }
    ],
    dark: [
        {
            label: 'editor.canvasBg.graphite',
            value: '#161616'
        },
        {
            label: 'editor.canvasBg.nearBlack',
            value: '#0a0a0a'
        },
        {
            label: 'editor.canvasBg.darkGray',
            value: '#2e2e34'
        },
        {
            label: 'editor.canvasBg.slate',
            value: '#232a36'
        },
        {
            label: 'editor.canvasBg.deepBlue',
            value: '#10203a'
        },
        {
            label: 'editor.canvasBg.deepGreen',
            value: '#0f241a'
        },
        {
            label: 'editor.canvasBg.warmDark',
            value: '#262019'
        },
        {
            label: 'editor.canvasBg.lightBg',
            value: '#f2f3f5'
        }
    ]
};
const canvasBackgroundPresetsForTheme = (theme)=>CANVAS_BG_PRESETS_BY_THEME[(0, $jlzPZ.resolveCanvasBackgroundTheme)(theme)];
const Zoombar = {
    // FA204 / frank trap — DOT_DEFAULTS used to be a bare module-scope const
    // read from inside `onInit`/`onClick` (serialized factories); it silently
    // read as undefined once this component is frank.toJSON'd for platform
    // delivery (workspace d6ea1142, project_frank_drops_module_local_helpers).
    // Moved into `scope`, called via `el.scope.DOT_DEFAULTS`.
    // CANVAS_BG_PRESETS_BY_THEME/canvasBackgroundPresetsForTheme above stay
    // module-scope EXPORTS (canvas/__tests__/theme.test.js and
    // workspace-ui/functions/workspaceUiManifest.js import them directly as
    // plain JS) — canvasBackgroundPresetsForTheme is duplicated below as a
    // scope method (referencing the same exported table at build time, so no
    // data is retyped) so the in-file `onClick` call site also resolves
    // post-frank.
    scope: {
        DOT_DEFAULTS: {
            dark: '#A3ADB6',
            light: '#bac1c9'
        },
        CANVAS_BG_PRESETS_BY_THEME: CANVAS_BG_PRESETS_BY_THEME,
        canvasBackgroundPresetsForTheme (theme) {
            return this.CANVAS_BG_PRESETS_BY_THEME[(0, $jlzPZ.resolveCanvasBackgroundTheme)(theme)];
        }
    },
    // if: (el, s) => el.getUserSettings('allowZoombar'),
    extends: 'IconNavbar',
    // Touch declutter: on a coarse pointer (iPad) the bar loosens up so the
    // remaining controls (background · settings · docs) get comfortable spacing
    // once the mouse-only zoom stepper + keyboard-shortcuts button drop out.
    '@coarse': {
        gap: 'Y1'
    },
    ZoomInNavbar: {
        // Mouse-only: the -/100%/+ stepper (and its % readout) is redundant with
        // pinch-zoom on touch, so hide it under a coarse pointer to declutter.
        '@coarse': {
            display: 'none'
        }
    },
    Box: {
        tag: 'button',
        type: 'button',
        title: (el)=>el.call('polyglot', 'editor.canvasBg.title'),
        'aria-label': (el)=>el.call('polyglot', 'editor.canvasBg.title'),
        width: 'A1',
        height: 'A1',
        aspectRatio: '1 / 1',
        round: '100%',
        overflow: 'hidden',
        flexShrink: '0',
        cursor: 'pointer',
        border: '0',
        padding: '0',
        background: '#A3ADB6',
        // A finger's target: the swatch is A1 (18-19px measured on dev DFI with a
        // touch device simulated, phones and iPads) — the 44pt floor
        // (_touchTarget.js). It clips nothing of its own (its fill is its own
        // round), so it stops clipping the hit area under a coarse pointer.
        '@coarse': {
            position: 'relative',
            overflow: 'visible',
            ...(0, $9GdJK.touchFloor)
        },
        onInit: (el, s)=>{
            const doc = el.context?.document || document;
            const globalTheme = (0, $jlzPZ.resolveCanvasBackgroundTheme)((0, $aFPBz.safeCall)(el, 'getGlobalTheme'), doc);
            const colorFromCookie = (0, $jlzPZ.syncCanvasBackgroundForTheme)(globalTheme, doc, (name)=>(0, $aFPBz.safeCall)(el, 'getCookie', name));
            const initValue = colorFromCookie || el.scope.DOT_DEFAULTS[globalTheme || 'dark'];
            el.setNodeStyles({
                background: initValue
            });
            el.value = initValue;
            // Singleton document-level watcher: re-syncs the per-theme cookie
            // var on every data-theme flip (user OR OS-driven 'auto'), so a
            // light pick never leaks into dark mode. Zoombar mounts once at
            // the shell root, so this runs once per document.
            (0, $jlzPZ.watchCanvasBackgroundTheme)(doc);
        },
        onClick: (ev, el, s)=>{
            ev.stopPropagation();
            const box = el;
            const doc = el.context?.document || document;
            const globalTheme = (0, $jlzPZ.resolveCanvasBackgroundTheme)((0, $aFPBz.safeCall)(el, 'getGlobalTheme'), doc);
            const cookieKey = `canvas_${globalTheme}_background`;
            const presets = el.scope.canvasBackgroundPresetsForTheme(globalTheme);
            const apply = (value)=>{
                box.setNodeStyles({
                    background: value
                });
                box.value = value;
                (0, $jlzPZ.setCanvasBackgroundVar)(doc, value);
                (0, $aFPBz.safeCall)(box, 'setCookie', cookieKey, value);
            };
            const reset = ()=>{
                const fallback = el.scope.DOT_DEFAULTS[globalTheme || 'dark'];
                box.setNodeStyles({
                    background: fallback
                });
                box.value = fallback;
                (0, $jlzPZ.clearCanvasBackgroundVar)(doc);
                (0, $aFPBz.safeCall)(box, 'removeCookie', cookieKey);
            };
            // Dropdown portal content — built here in the opener so `box` /
            // `apply` are captured in scope (the portal doesn't inherit page
            // state) and rows carry explicit `tag`s (childExtends tag doesn't
            // apply inside portal content).
            const content = {
                flow: 'y',
                gap: 'Z',
                padding: 'Z1',
                PickerTitle: {
                    tag: 'span',
                    text: '{{ editor.canvasBg.title | polyglot }}',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'caption',
                    letterSpacing: '.04em',
                    textTransform: 'uppercase'
                },
                PickerSwatches: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, auto)',
                    gap: 'Y',
                    ...presets.reduce((acc, preset, i)=>{
                        acc['PickerSwatch_' + i] = {
                            tag: 'button',
                            type: 'button',
                            title: (el)=>el.call('polyglot', preset.label),
                            'aria-label': (el)=>el.call('polyglot', preset.label),
                            width: 'A1',
                            aspectRatio: '1 / 1',
                            round: '100%',
                            padding: '0',
                            cursor: 'pointer',
                            flexShrink: '0',
                            background: preset.value,
                            border: 'hairline solid',
                            borderColor: 'line',
                            onClick: (e, it)=>{
                                e.stopPropagation();
                                apply(preset.value);
                                it.call('closeDropdown', 'canvasBgPicker');
                            }
                        };
                        return acc;
                    }, {})
                },
                PickerCustomRow: {
                    flow: 'x',
                    align: 'center space-between',
                    gap: 'Z',
                    PickerCustomLabel: {
                        tag: 'span',
                        text: '{{ editor.canvasBg.custom | polyglot }}',
                        fontSize: 'Z1',
                        color: 'paragraph'
                    },
                    PickerCustomInput: {
                        tag: 'input',
                        type: 'color',
                        // The visible "Custom" label beside it is a sibling span, not a
                        // <label for>, so the control itself carried no accessible name.
                        'aria-label': (it)=>it.call('polyglot', 'editor.canvasBg.custom'),
                        width: 'B',
                        height: 'A1',
                        padding: '0',
                        border: '0',
                        round: 'Y',
                        cursor: 'pointer',
                        background: 'transparent',
                        // Content is rebuilt on every open, so the current pick is
                        // known at build time — set it as the input's value prop.
                        value: /^#[0-9a-fA-F]{6}$/.test(box.value || '') ? box.value : '#161616',
                        // Applies live while the user drags the native picker.
                        onInput: (e, it)=>apply(it.node.value)
                    }
                },
                PickerResetRow: {
                    tag: 'button',
                    type: 'button',
                    text: '{{ editor.canvasBg.reset | polyglot }}',
                    fontSize: 'Z1',
                    color: 'paragraph',
                    textAlign: 'left',
                    padding: 'Y Z',
                    round: 'radiusControl',
                    border: '0',
                    cursor: 'pointer',
                    background: 'transparent',
                    ':hover': {
                        background: 'hover',
                        color: 'title'
                    },
                    onClick: (e, it)=>{
                        e.stopPropagation();
                        reset();
                        it.call('closeDropdown', 'canvasBgPicker');
                    }
                }
            };
            el.call('openDropdown', {
                id: 'canvasBgPicker',
                anchorEl: el,
                placement: 'top-end',
                // Explicit shell paint — this picker's rows render directly on the
                // dropdown shell (no own card). The plugin Panel is chromeless by
                // default since FW-DROPDOWN-PANEL-STALE-SHELL-PAINT-1; opt back in.
                theme: 'canvas-card-glass',
                shadow: 'overlay',
                content: content
            });
        }
    },
    NavbarButtonSet: {
        padding: '0',
        Settings: {
            icon: 'sf settings',
            onClick: (ev, el)=>{
                el.call('openRouterModal', '/settings', {
                    key: '/settings'
                });
            },
            title: (el)=>el.call('polyglot', 'editor.zoombar.settings')
        },
        Keyboard: {
            title: (el)=>el.call('polyglot', 'editor.zoombar.shortcutsTooltip'),
            'aria-label': (el)=>el.call('polyglot', 'editor.zoombar.shortcuts'),
            icon: 'sf keyboard',
            // Keyboard shortcuts need a keyboard — don't render on a coarse pointer
            // (iPad). `if` excludes at mount, so desktop (fine) is completely
            // untouched and we avoid fighting NavbarButton's inline display with a
            // @coarse display:none (which loses to it).
            if: (el)=>!el.call('isCoarsePointer'),
            onClick: (ev, el)=>el.call('openKeyboardShortcuts')
        },
        Question: {
            title: (el)=>el.call('polyglot', 'editor.zoombar.docs'),
            icon: 'sf question',
            onClick: (ev, el, s)=>{
                // canvas's v1→v2 bridge (Rule 63 fix — this used to be the SAME name
                // as the real shared setWindow primitive and shadowed it shell-wide;
                // see canvas/methods/index.js). In v2 this opens the shortcuts
                // overlay instead of the (nonexistent in v2) onboarding explorer
                // window.
                el.call('bridgeSetWindow', 'explorer', 'onboarding');
            }
        }
    }
};

});
parcelRegister("jlzPZ", function(module, exports) {

$parcel$export(module.exports, "CANVAS_BG_VAR", () => $e15bc70fdabf3ee2$export$50e2d333c0d43e07);
$parcel$export(module.exports, "STAGE_BG_VAR", () => $e15bc70fdabf3ee2$export$493d9a4ccb08d68b);
$parcel$export(module.exports, "STAGE_BACKGROUND", () => $e15bc70fdabf3ee2$export$cf72b3733061787b);
$parcel$export(module.exports, "CANVAS_SURFACE_BACKGROUND", () => $e15bc70fdabf3ee2$export$4492312be7022110);
$parcel$export(module.exports, "CANVAS_SURFACE_BG_VAR", () => $e15bc70fdabf3ee2$export$19918cd3e337f01a);
$parcel$export(module.exports, "CANVAS_SURFACE_DEFAULTS", () => $e15bc70fdabf3ee2$export$2bb69b4452d039e8);
$parcel$export(module.exports, "CANVAS_DOTS_DARK", () => $e15bc70fdabf3ee2$export$372524d3705bc6f3);
$parcel$export(module.exports, "CANVAS_DOTS_LIGHT", () => $e15bc70fdabf3ee2$export$b805c43e09903cdf);
$parcel$export(module.exports, "CANVAS_DOT_RADIUS_VAR", () => $e15bc70fdabf3ee2$export$9d1521d61f3ea079);
$parcel$export(module.exports, "CANVAS_DOT_BASE_SPACING", () => $e15bc70fdabf3ee2$export$b12958530debc5b5);
$parcel$export(module.exports, "CANVAS_DOT_FOLD_PERIOD", () => $e15bc70fdabf3ee2$export$ee1c1b7cd0ffd850);
$parcel$export(module.exports, "CANVAS_DOT_INK_DIVISOR", () => $e15bc70fdabf3ee2$export$8fa98ae6fbd2ed6e);
$parcel$export(module.exports, "CANVAS_DOT_VISIBILITY_FLOOR", () => $e15bc70fdabf3ee2$export$a94ffdf48db72562);
$parcel$export(module.exports, "canvasDotMetrics", () => $e15bc70fdabf3ee2$export$d83e807ef41eceed);
$parcel$export(module.exports, "applyCanvasDotMetrics", () => $e15bc70fdabf3ee2$export$b08f64093881110e);
$parcel$export(module.exports, "resolveCanvasBackgroundTheme", () => $e15bc70fdabf3ee2$export$16c9f9af99c55e95);
$parcel$export(module.exports, "canvasBackgroundCookieName", () => $e15bc70fdabf3ee2$export$fb6b4b3824307680);
$parcel$export(module.exports, "readCanvasBackgroundCookie", () => $e15bc70fdabf3ee2$export$19c1aa432c02f690);
$parcel$export(module.exports, "setCanvasBackgroundVar", () => $e15bc70fdabf3ee2$export$b1ff612f36ba4903);
$parcel$export(module.exports, "clearCanvasBackgroundVar", () => $e15bc70fdabf3ee2$export$1174439b297d98b6);
$parcel$export(module.exports, "syncCanvasBackgroundForTheme", () => $e15bc70fdabf3ee2$export$dab076f1587c6c37);
$parcel$export(module.exports, "watchCanvasBackgroundTheme", () => $e15bc70fdabf3ee2$export$915a8cb94e456c54);
// Canvas surface + dots theming contract.
//
// Static theming is PURE CSS: pages declare `'@dark' / '@light'` blocks
// (compiled by the framework into `[data-theme="…"]`-scoped rules, see
// element/create.js theme-block handling), so surfaces, dots, and fades follow
// `data-theme` with zero JS. The ONLY imperative pieces here are for true user
// state that CSS cannot derive — the per-theme canvas-background cookie the
// Zoombar picker writes, which rides the document-level `--canvas-bg` var.
//
// TWO RULES (both verified live, both break silently):
// 1. Never write a THEMED value (a resolved colour) as an INLINE style on a
//    node — inline beats the `[data-theme]` class rules and freezes the
//    element on one theme. Inline is reserved for the theme-agnostic
//    `background: var(--canvas-bg, var(--stage-bg, var(--color-stage)))`
//    chain — a var() string re-resolves on every theme flip.
// 2. Props inside `'@dark' / '@light'` blocks must be FLAT — a nested
//    `style: {…}` compiles to a bogus `[data-theme] .cls style`
//    child-element selector instead of declarations on the class.
const $e15bc70fdabf3ee2$export$50e2d333c0d43e07 = '--canvas-bg';
const $e15bc70fdabf3ee2$export$493d9a4ccb08d68b = '--stage-bg';
const $e15bc70fdabf3ee2$export$cf72b3733061787b = 'var(--stage-bg, var(--color-stage))';
const $e15bc70fdabf3ee2$export$4492312be7022110 = 'var(--canvas-bg, var(--stage-bg, var(--color-stage)))';
const $e15bc70fdabf3ee2$export$19918cd3e337f01a = '--canvas-surface-bg';
const $e15bc70fdabf3ee2$export$2bb69b4452d039e8 = {
    light: 'var(--color-milk)',
    dark: '#0a0a0a'
};
const $e15bc70fdabf3ee2$export$372524d3705bc6f3 = 'radial-gradient(circle, rgba(215,215,238,0.35) var(--canvas-dot-r, 0.3px), transparent var(--canvas-dot-r, 0.3px))';
const $e15bc70fdabf3ee2$export$b805c43e09903cdf = 'radial-gradient(circle, rgba(215,215,238,0.35) var(--canvas-dot-r, 0.3px), transparent var(--canvas-dot-r, 0.3px))';
const $e15bc70fdabf3ee2$export$9d1521d61f3ea079 = '--canvas-dot-r';
const $e15bc70fdabf3ee2$export$b12958530debc5b5 = 12;
const $e15bc70fdabf3ee2$export$ee1c1b7cd0ffd850 = 3;
const $e15bc70fdabf3ee2$export$8fa98ae6fbd2ed6e = 40;
const $e15bc70fdabf3ee2$export$a94ffdf48db72562 = 1;
const $e15bc70fdabf3ee2$export$d83e807ef41eceed = (scale, base = 12, period = 3, inkDivisor = $e15bc70fdabf3ee2$export$8fa98ae6fbd2ed6e)=>{
    const s = Number.isFinite(scale) && scale > 0 ? scale : 1;
    const p = Number.isFinite(period) && period > 1 ? period : 3;
    const octave = Math.pow(p, Math.floor(Math.log(s) / Math.log(p)));
    const folded = Number.isFinite(octave) && octave > 0 ? base * (s / octave) : base;
    const spacing = Number.isFinite(folded) && folded > 0 ? folded : base;
    // FA204 / frank trap — inlined literal (was a bare CANVAS_DOT_INK_DIVISOR
    // read), same reasoning as the base/period literals inlined above (see
    // this function's own header comment on frank's positional-default
    // resolver gap). Keep in sync with CANVAS_DOT_INK_DIVISOR above.
    const div = Number.isFinite(inkDivisor) && inkDivisor > 0 ? inkDivisor : 40;
    return {
        spacing: spacing,
        radius: spacing / div
    };
};
const $e15bc70fdabf3ee2$export$b08f64093881110e = (node, scale, offsetX = 0, offsetY = 0, base, opts = {})=>{
    if (!node || !node.style) return null;
    // FA204 / frank trap — self-contained inline copy of canvasDotMetrics (a
    // bare sibling-export read is exactly as unresolvable post-frank as a
    // module-local read); the export above stays live for genuine external
    // consumers.
    const dotMetrics = (scale0, base0 = 12, period = 3, inkDivisor)=>{
        const s = Number.isFinite(scale0) && scale0 > 0 ? scale0 : 1;
        const p = Number.isFinite(period) && period > 1 ? period : 3;
        const octave = Math.pow(p, Math.floor(Math.log(s) / Math.log(p)));
        const folded = Number.isFinite(octave) && octave > 0 ? base0 * (s / octave) : base0;
        const spacing0 = Number.isFinite(folded) && folded > 0 ? folded : base0;
        const div = Number.isFinite(inkDivisor) && inkDivisor > 0 ? inkDivisor : 40;
        return {
            spacing: spacing0,
            radius: spacing0 / div
        };
    };
    const { spacing: spacing, radius: rawRadius } = dotMetrics(scale, base, opts.period, opts.inkDivisor);
    // Opt-in rendering-visibility floor (see CANVAS_DOT_VISIBILITY_FLOOR above)
    // — deliberately NOT applied by default, so every existing caller (and
    // canvasDotMetrics.test.js's locked unclamped values) stays byte-identical.
    // Only raises the radius; never lowers a healthy one.
    const radius = Number.isFinite(opts.minRadius) && opts.minRadius > 0 ? Math.max(rawRadius, opts.minRadius) : rawRadius;
    const px = (offsetX % spacing + spacing) % spacing;
    const py = (offsetY % spacing + spacing) % spacing;
    node.style.backgroundSize = `${spacing}px ${spacing}px`;
    node.style.backgroundPosition = `${px}px ${py}px`;
    // FA204 / frank trap — inlined literal (was a bare CANVAS_DOT_RADIUS_VAR
    // read); the export above stays live for genuine external consumers.
    node.style.setProperty('--canvas-dot-r', `${radius}px`);
    return {
        spacing: spacing,
        radius: radius
    };
};
const $e15bc70fdabf3ee2$export$16c9f9af99c55e95 = (theme, doc = globalThis.document)=>{
    const key = String(theme || '').replace(/^@/, '');
    if (key === 'light' || key === 'dark') return key;
    const attr = doc?.documentElement?.getAttribute?.('data-theme');
    if (attr === 'light' || attr === 'dark') return attr;
    try {
        const media = globalThis.matchMedia?.('(prefers-color-scheme: dark)');
        if (media) return media.matches ? 'dark' : 'light';
        return 'dark';
    } catch (_) {
        return 'dark';
    }
};
const $e15bc70fdabf3ee2$export$fb6b4b3824307680 = (theme, doc = globalThis.document)=>{
    const resolveTheme = (t, d)=>{
        const key = String(t || '').replace(/^@/, '');
        if (key === 'light' || key === 'dark') return key;
        const attr = d?.documentElement?.getAttribute?.('data-theme');
        if (attr === 'light' || attr === 'dark') return attr;
        try {
            const media = globalThis.matchMedia?.('(prefers-color-scheme: dark)');
            if (media) return media.matches ? 'dark' : 'light';
            return 'dark';
        } catch (_) {
            return 'dark';
        }
    };
    return `canvas_${resolveTheme(theme, doc)}_background`;
};
const $e15bc70fdabf3ee2$export$19c1aa432c02f690 = (theme, doc = globalThis.document, readCookie = null)=>{
    const resolveTheme = (t, d)=>{
        const key = String(t || '').replace(/^@/, '');
        if (key === 'light' || key === 'dark') return key;
        const attr = d?.documentElement?.getAttribute?.('data-theme');
        if (attr === 'light' || attr === 'dark') return attr;
        try {
            const media = globalThis.matchMedia?.('(prefers-color-scheme: dark)');
            if (media) return media.matches ? 'dark' : 'light';
            return 'dark';
        } catch (_) {
            return 'dark';
        }
    };
    const cookieName = (t, d)=>`canvas_${resolveTheme(t, d)}_background`;
    const readCookieValue = (name, d)=>{
        const cookie = d?.cookie || '';
        for (const part of String(cookie).split(';')){
            const trimmed = part.trim();
            if (!trimmed) continue;
            const eq = trimmed.indexOf('=');
            try {
                const rawName = eq < 0 ? trimmed : trimmed.slice(0, eq);
                if (decodeURIComponent(rawName) !== name) continue;
                return decodeURIComponent(eq < 0 ? '' : trimmed.slice(eq + 1));
            } catch (err) {
                // Malformed percent-encoding in an unrelated cookie must not break
                // theme sync.
                console.warn('[canvasBackground] skipping malformed cookie:', err);
            }
        }
        return null;
    };
    const name = cookieName(theme, doc);
    return typeof readCookie === 'function' ? readCookie(name) || null : readCookieValue(name, doc);
};
const $e15bc70fdabf3ee2$export$b1ff612f36ba4903 = (doc = globalThis.document, value)=>{
    doc?.documentElement?.style?.setProperty?.('--canvas-bg', value);
};
const $e15bc70fdabf3ee2$export$1174439b297d98b6 = (doc = globalThis.document)=>{
    doc?.documentElement?.style?.removeProperty?.('--canvas-bg');
};
const $e15bc70fdabf3ee2$export$dab076f1587c6c37 = (theme, doc = globalThis.document, readCookie = null)=>{
    const resolveTheme = (t, d)=>{
        const key = String(t || '').replace(/^@/, '');
        if (key === 'light' || key === 'dark') return key;
        const attr = d?.documentElement?.getAttribute?.('data-theme');
        if (attr === 'light' || attr === 'dark') return attr;
        try {
            const media = globalThis.matchMedia?.('(prefers-color-scheme: dark)');
            if (media) return media.matches ? 'dark' : 'light';
            return 'dark';
        } catch (_) {
            return 'dark';
        }
    };
    const cookieName = (t, d)=>`canvas_${resolveTheme(t, d)}_background`;
    const readCookieValue = (name, d)=>{
        const cookie = d?.cookie || '';
        for (const part of String(cookie).split(';')){
            const trimmed = part.trim();
            if (!trimmed) continue;
            const eq = trimmed.indexOf('=');
            try {
                const rawName = eq < 0 ? trimmed : trimmed.slice(0, eq);
                if (decodeURIComponent(rawName) !== name) continue;
                return decodeURIComponent(eq < 0 ? '' : trimmed.slice(eq + 1));
            } catch (err) {
                console.warn('[canvasBackground] skipping malformed cookie:', err);
            }
        }
        return null;
    };
    const readCanvasBgCookie = (t, d, rc)=>{
        const name = cookieName(t, d);
        return typeof rc === 'function' ? rc(name) || null : readCookieValue(name, d);
    };
    const value = readCanvasBgCookie(theme, doc, readCookie);
    if (value) doc?.documentElement?.style?.setProperty?.('--canvas-bg', value);
    else doc?.documentElement?.style?.removeProperty?.('--canvas-bg');
    return value || null;
};
const $e15bc70fdabf3ee2$export$915a8cb94e456c54 = (doc = globalThis.document, readCookie = null)=>{
    const root = doc?.documentElement;
    if (!root) return null;
    if (doc.__canvasBgThemeWatcher) return doc.__canvasBgThemeWatcher;
    const Observer = doc.defaultView?.MutationObserver || globalThis.MutationObserver;
    if (!Observer) return null;
    const syncForTheme = (t, d, rc)=>{
        const resolveTheme = (tt, dd)=>{
            const key = String(tt || '').replace(/^@/, '');
            if (key === 'light' || key === 'dark') return key;
            const attr = dd?.documentElement?.getAttribute?.('data-theme');
            if (attr === 'light' || attr === 'dark') return attr;
            try {
                const media = globalThis.matchMedia?.('(prefers-color-scheme: dark)');
                if (media) return media.matches ? 'dark' : 'light';
                return 'dark';
            } catch (_) {
                return 'dark';
            }
        };
        const cookieName = (tt, dd)=>`canvas_${resolveTheme(tt, dd)}_background`;
        const readCookieValue = (name, dd)=>{
            const cookie = dd?.cookie || '';
            for (const part of String(cookie).split(';')){
                const trimmed = part.trim();
                if (!trimmed) continue;
                const eq = trimmed.indexOf('=');
                try {
                    const rawName = eq < 0 ? trimmed : trimmed.slice(0, eq);
                    if (decodeURIComponent(rawName) !== name) continue;
                    return decodeURIComponent(eq < 0 ? '' : trimmed.slice(eq + 1));
                } catch (err) {
                    console.warn('[canvasBackground] skipping malformed cookie:', err);
                }
            }
            return null;
        };
        const name = cookieName(t, d);
        const value = typeof rc === 'function' ? rc(name) || null : readCookieValue(name, d);
        if (value) d?.documentElement?.style?.setProperty?.('--canvas-bg', value);
        else d?.documentElement?.style?.removeProperty?.('--canvas-bg');
        return value || null;
    };
    const observer = new Observer(()=>{
        syncForTheme(root.getAttribute('data-theme'), doc, readCookie);
    });
    observer.observe(root, {
        attributes: true,
        attributeFilter: [
            'data-theme'
        ]
    });
    doc.__canvasBgThemeWatcher = observer;
    return observer;
};

});

parcelRegister("aFPBz", function(module, exports) {

$parcel$export(module.exports, "safeCall", () => $7c55c35e10a900f2$export$175e60bb96229ece);
// safeCall — invoke a registered function via el.call without throwing
// when the function isn't registered in the current context.
//
// `el.call(name)` THROWS on an unknown function. That's the right default
// for app code, but PORTABLE shared components (e.g. the Zoombar, mounted
// in the shell AND every canvas sub-app) legitimately can't assume every
// host registers every helper they'd like to use — getGlobalTheme /
// getCookie / setCookie / removeCookie exist in the shell context but not
// in the canvas (scratch) context, for instance. Rather than register the
// full helper set into every possible host (fragile — each new host must
// remember), such components resolve optional helpers defensively: call
// if present, fall back gracefully if not.
//
// Returns the function's result, or undefined when it isn't registered
// (or throws). Use ONLY for genuinely-optional helpers — app code that
// depends on a function being present should call it directly so a real
// missing-registration bug surfaces loudly.
const $7c55c35e10a900f2$export$175e60bb96229ece = (el, fn, ...args)=>{
    try {
        return el?.call?.(fn, ...args);
    } catch (_) {
        return undefined;
    }
};

});


parcelRegister("huryk", function(module, exports) {

$parcel$export(module.exports, "ResizeOverlay", () => $cbba9c608acb3c90$export$4a957ab72f2178d);
const $cbba9c608acb3c90$export$4a957ab72f2178d = {
    if: (el, s)=>!el.getUserSettings('optimizedMode'),
    '--handler-offset': '-0.25em',
    childProps: {
        position: 'absolute',
        round: '100%',
        width: 'Y1',
        height: 'Y1',
        background: '#2485F0',
        boxShadow: '#fff 0 0 0 1.5px, #000c 0 1px 4px'
    },
    children: [
        {
            right: '--handler-offset',
            bottom: '--handler-offset'
        },
        {
            left: '--handler-offset',
            bottom: '--handler-offset'
        },
        {
            right: '--handler-offset',
            top: '--handler-offset'
        },
        {
            left: '--handler-offset',
            top: '--handler-offset'
        }
    ]
};

});

parcelRegister("ivtZq", function(module, exports) {

$parcel$export(module.exports, "IconGridTypes", () => $d792629a95f3e619$export$891988792261bc03);
const $d792629a95f3e619$export$891988792261bc03 = {
    extends: 'Group',
    Title: {
        text: '{{ editor.icons.type | polyglot }}'
    },
    Flex: {
        flow: 'y',
        gap: 'Y2',
        margin: '- -X2',
        round: 'radiusControl',
        childProps: {
            align: 'center space-between',
            padding: 'X1',
            round: 'X',
            cursor: 'pointer',
            color: 'paragraph',
            transition: 'B1 defaultBezier',
            transitionProperty: 'color, background',
            ':hover': {
                color: 'title',
                background: `linear-gradient(0deg,
          rgba(255,255,255,0.06) 0%,
          rgba(255,255,255,0.07) 100%
        )`
            },
            ':hover svg': {
                color: 'title'
            },
            IconText: {
                icon: 'info',
                text: '{{ text }}',
                fontSize: 'Z',
                align: 'center space-between',
                gap: 'Y2',
                Icon: {
                    transition: 'B1 defaultBezier color',
                    // eslint-disable-next-line no-restricted-syntax -- icon glyph color, not the text (see `text:` sibling)
                    color: 'inactive',
                    icon: '{{ icon }}',
                    padding: 'W2',
                    round: 'radiusControl',
                    fontSize: 'D',
                    background: `linear-gradient(0deg,
            rgba(255,255,255,0.06) 0%,
            rgba(255,255,255,0.07) 100%
          )`
                }
            },
            Icon: {
                name: 'checkmark',
                fontSize: 'Z',
                opacity: '0'
            }
        },
        childrenAs: 'state',
        children: ()=>[
                {
                    icon: 'icons',
                    text: '{{ editor.icons.filled | polyglot }}'
                },
                {
                    icon: 'iconsOutline',
                    text: '{{ editor.icons.outline | polyglot }}'
                },
                {
                    icon: 'iconsColored',
                    text: '{{ editor.icons.multicolor | polyglot }}'
                }
            ]
    }
};

});

parcelRegister("9BuYc", function(module, exports) {

$parcel$export(module.exports, "CanvasPanel", () => $6fdf97b9d12adbc4$export$e7af55c592e53ae4);
const $6fdf97b9d12adbc4$export$e7af55c592e53ae4 = {
    useGlassmorphism: (el)=>el.getUserSettings('useGlassmorphism'),
    '.useGlassmorphism': {
        theme: 'canvas-card-glass'
    },
    '!useGlassmorphism': {
        theme: 'canvas-card'
    },
    useAnimations: (el)=>el.getUserSettings('useAnimations'),
    '.useAnimations': {
        transition: 'C defaultBezier'
    },
    // Card-outline over live canvas content (design-direction.md §8). Both
    // themes above already carry an opaque/glass fill; DESIGN_LANGUAGE §2.4
    // says explicitly of `canvas-card-glass` that "shadows move to `float`" —
    // applied to both branches for one consistent floating-panel treatment
    // (canvas-card also KEEPS the glass-family shadow rather than reverting to
    // a stroke, since a stroke does no separation work floating content can't
    // already get from elevation).
    shadow: 'float'
};

});

parcelRegister("6g7r0", function(module, exports) {

$parcel$export(module.exports, "GridChooser", () => $48ea0113b496f883$export$692e5e7e251a6bb5);
const $48ea0113b496f883$export$692e5e7e251a6bb5 = {
    extends: 'Group',
    width: '100%',
    Title: {
        text: '{{ editor.grid.options | polyglot }}'
    },
    Grid: {
        margin: '- -X2',
        templateColumns: 'repeat(12, 1fr)',
        templateRows: 'repeat(3, 1fr)',
        gap: 'X2',
        round: 'radiusControl',
        overflow: 'hidden',
        childProps: {
            opacity: '0.35',
            theme: 'space',
            minHeight: 'B1',
            round: 'X1',
            isActive: (el, s)=>{
                const key = parseInt(el.key);
                const { gridOptions: gridOptions } = s.settings;
                const h = Math.floor(key / 12) + 1;
                const w = key % 12 + 1;
                return gridOptions?.w >= w && gridOptions?.h >= h;
            },
            '.isActive': {
                opacity: '.85'
            },
            '!isActive': {
                ':hover': {
                    opacity: '.45'
                }
            },
            onClick: (ev, el, s)=>{
                const key = parseInt(el.key);
                const h = Math.floor(key / 12) + 1;
                const w = key % 12 + 1;
                s.update({
                    settings: {
                        gridOptions: {
                            w: w,
                            h: h
                        }
                    }
                });
            }
        },
        children: ()=>new Array(60).fill({})
    }
};

});

parcelRegister("8RJFW", function(module, exports) {

$parcel$export(module.exports, "DragHandler", () => $6746b430af762926$export$d23484e29a0c570);
const $6746b430af762926$export$d23484e29a0c570 = {
    extends: 'Icon',
    if: (el, s)=>!el.getUserSettings('optimizedMode'),
    position: 'absolute',
    left: '50%',
    bottom: '-1.5em',
    transform: 'translate3d(-50%, 0, 1px)',
    // `name`, not `icon` — a bare `extends: 'Icon'` leaf reads its glyph off
    // `name` (see AppHeader.js LogoIcon's comment for the same footgun); the
    // stray `icon` prop here drew a permanently empty box everywhere this
    // component is used, catalog included.
    name: 'dragOutline',
    // eslint-disable-next-line no-restricted-syntax -- decorative drag-handle icon, not text
    color: 'inactive'
};

});

parcelRegister("gFO4G", function(module, exports) {

$parcel$export(module.exports, "DsNavbar", () => $c2375172fa6b5b61$export$ce2e060fe36ca634);
const $c2375172fa6b5b61$export$ce2e060fe36ca634 = {
    extends: 'Navbar',
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    transform: 'translate3d(0, -50%, 0)',
    left: '--canvas-gutter',
    flow: 'y',
    padding: 'U1 U1',
    round: 'radiusPill',
    gap: 'X',
    theme: 'canvas-card-glass',
    NavbarButtonSet: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'radiusPill',
            isActive: (el)=>el.getWindow('explorer') === el.key,
            onClick: (ev, el)=>el.call('handleDsNavbarClick')
        },
        children: [
            {
                key: 'components',
                title: (el)=>el.call('polyglot', 'editor.quickAdd.component2'),
                Icon: {
                    name: 'grid'
                }
            },
            {
                key: 'pages',
                title: (el)=>el.call('polyglot', 'editor.command.category.pages'),
                Icon: {
                    name: 'pages outline'
                }
            },
            {
                key: 'functions',
                title: (el)=>el.call('polyglot', 'editor.panel.functions'),
                Icon: {
                    name: 'fn outline'
                }
            },
            {
                key: 'files',
                title: (el)=>el.call('polyglot', 'shell.app.files'),
                Icon: {
                    name: 'folder outline'
                }
            },
            {
                key: 'dependencies',
                title: (el)=>el.call('polyglot', 'editor.panel.dependencies'),
                Icon: {
                    name: 'npm outline'
                }
            }
        ],
        childrenAs: 'props'
    },
    Line: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_ds: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'radiusPill',
            isActive: (el)=>el.getWindow('explorer') === el.key,
            onClick: (ev, el)=>el.call('handleDsNavbarClick')
        },
        children: [
            {
                key: 'color',
                title: (el)=>el.call('polyglot', 'editor.panel.colors'),
                Icon: {
                    name: 'color outline colored'
                }
            },
            {
                key: 'typography',
                title: (el)=>el.call('polyglot', 'editor.panel.typography'),
                Icon: {
                    name: 'typography outline colored'
                },
                opacity: '.7'
            },
            {
                key: 'spacing',
                title: (el)=>el.call('polyglot', 'editor.panel.spacing'),
                Icon: {
                    name: 'space outline colored'
                },
                opacity: '.7'
            },
            {
                key: 'icons',
                title: (el)=>el.call('polyglot', 'editor.panel.icons'),
                Icon: {
                    name: 'icons outline colored'
                }
            },
            {
                key: 'shape',
                title: (el)=>el.call('polyglot', 'editor.panel.shapes'),
                Icon: {
                    name: 'shape outline colored'
                }
            },
            {
                key: 'media',
                title: (el)=>el.call('polyglot', 'editor.panel.responsive'),
                Icon: {
                    name: 'device mobile half fill'
                },
                opacity: '.7'
            },
            {
                key: 'cases',
                title: (el)=>el.call('polyglot', 'editor.panel.cases'),
                Icon: {
                    name: 'boolean outline'
                }
            }
        ],
        childrenAs: 'props'
    },
    Line_2: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_meta: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        Expand: {
            title: (el)=>el.call('polyglot', 'shell.voice.expand'),
            icon: 'arrowAngleRight',
            onClick: (ev, el)=>{
                el.toggleWindow('explorer');
            }
        }
    },
    NavbarTooltip: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        top: '0',
        left: '110%',
        tooltipPosition: 'right',
        shapeDirection: 'left'
    }
};

});

parcelRegister("4vbFx", function(module, exports) {

$parcel$export(module.exports, "DeviceButtonSet", () => $34731be4f9d62ad6$export$1772333bb1fb502e);
const $34731be4f9d62ad6$export$1772333bb1fb502e = {
    // FA204 / frank trap — DEVICE_LABELS used to be a bare module-scope const
    // read from inside `childProps` (a serialized factory); it read as
    // undefined once this component was frank.toJSON'd for platform delivery
    // (workspace d6ea1142, project_frank_drops_module_local_helpers). Kept in
    // `scope` so `el.scope.DEVICE_LABELS` resolves post-serialization too —
    // note `el.scope.previewSize` below is a SEPARATE, pre-existing use of the
    // same bag as ad-hoc runtime instance state (not a frank concern), so this
    // is additive, not a new pattern.
    scope: {
        DEVICE_LABELS: {
            custom: 'Custom size',
            mobileXS: 'Mobile preview',
            tabletS: 'Tablet portrait preview',
            tabletL: 'Tablet landscape preview',
            screenM: 'Small screen preview',
            screenL: 'Large screen preview',
            resizable: 'Resizable preview',
            canvas: 'Canvas view'
        }
    },
    extends: 'NavbarButtonSet',
    gap: 'A',
    childProps: (el, state)=>{
        const isActive = el.scope.previewSize === state.key;
        const isThreeDots = state.icon === 'threeDotsVertical' && 'threeDotsVertical';
        const isResize = state.icon === 'dimensionsAlt' && (isActive ? state.icon + ' colored outline' : state.icon);
        return {
            isActive: isActive,
            isThreeDots: isThreeDots,
            theme: null,
            background: 'transparent.0',
            color: 'inactive',
            aria: {
                label: el.scope.DEVICE_LABELS[state.key] || state.key
            },
            icon: isResize || isThreeDots || isActive ? state.icon : state.icon + ' outline',
            '.isThreeDots': {
                order: -15
            },
            // Adaptive (was fixed 'gray4'/'gray10') — the house hover wash + full-
            // ink brighten, matching the weaker-than-`.isActive` step this set
            // already uses (isActive below is the stronger `secondary-highlight`
            // filled theme).
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            '.isActive': {
                opacity: 1,
                theme: 'secondary-highlight'
            },
            onClick: (ev, el, s, ctx)=>{
                const previewSize = s.key !== el.scope.previewSize ? s.key : 'unset';
                el.scope.previewSize = previewSize;
                el.parent.update();
                ctx.utils.setCookie('previewSize', previewSize);
                el.syncCanvas();
            }
        };
    },
    childrenAs: 'state',
    children: ()=>[
            {
                key: 'custom',
                icon: 'threeDotsVertical'
            },
            {
                key: 'mobileXS',
                icon: 'deviceMobile'
            },
            {
                key: 'tabletS',
                icon: 'deviceTabletPortrait'
            },
            {
                key: 'tabletL',
                icon: 'deviceTabletLandscape'
            },
            {
                key: 'screenM',
                icon: 'deviceSmallScreen'
            },
            {
                key: 'screenL',
                icon: 'deviceBigScreen'
            },
            {
                key: 'resizable',
                icon: 'dimensionsAlt'
            },
            {
                key: 'canvas',
                icon: 'columns'
            }
        ]
};

});

parcelRegister("4ot0c", function(module, exports) {

$parcel$export(module.exports, "ResponsiveSwitching", () => $332fe686cf78e61c$export$8dd390149ba5442e);
const $332fe686cf78e61c$export$8dd390149ba5442e = {
    extends: 'NavbarButtonSet',
    gap: 'A',
    scope: {
        previewSize: null
    },
    childrenAs: 'state',
    children: ()=>[
            {
                key: 'screenL',
                icon: 'deviceBigScreen'
            },
            {
                key: 'screenM',
                icon: 'deviceSmallScreen'
            },
            {
                key: 'tabletL',
                icon: 'deviceTabletLandscape'
            },
            {
                key: 'tabletS',
                icon: 'deviceTabletPortrait'
            },
            {
                key: 'mobileXS',
                icon: 'deviceMobile'
            },
            {
                key: 'canvas',
                icon: 'columns'
            },
            {
                key: 'custom',
                icon: 'layout'
            },
            {
                key: 'resizable',
                icon: 'dimensionsAlt'
            }
        ],
    childProps: {
        isActive: (el, s)=>el.parent.scope?.previewSize === s.key,
        icon: (el, s)=>{
            const active = el.parent.scope?.previewSize === s.key;
            return active ? s.icon : s.icon + ' outline';
        },
        title: (el, s)=>s.key,
        '.isActive': {
            theme: 'navbarButton-active'
        },
        '!isActive': {
            theme: 'navbarButton'
        },
        onClick: (ev, el, s)=>{
            const parent = el.parent;
            const scope = parent.scope;
            if (!scope) return;
            const newSize = scope.previewSize !== s.key ? s.key : null;
            // Reactive scope write — fires signals on parent.scope.previewSize
            // so all sibling icon factories re-evaluate their `isActive` /
            // theme bindings automatically (smbls FRAMEWORK-SCOPE-REACTIVE-1).
            scope.previewSize = newSize;
            // The icon-sprite swap is imperative DOM (no DOMQL binding for
            // xlink:href on individual children), so we still need a sibling
            // walk for THAT specific render — but no longer need `child.update()`
            // afterwards; the reactive theme/.isActive bindings cover the rest.
            for (const key of parent.__ref.__children){
                const child = parent[key];
                if (!child?.Icon?.node) continue;
                const isActive = child.state.key === newSize;
                const iconBase = child.state.icon;
                const outlineId = iconBase + 'Outline';
                const hasOutline = !!document.getElementById(outlineId);
                const spriteId = isActive ? iconBase : hasOutline ? outlineId : iconBase;
                const useEl = child.Icon.node.querySelector('use');
                if (useEl) useEl.setAttribute('xlink:href', '#' + spriteId);
            }
            if (el.syncCanvas) el.syncCanvas({
                previewSize: newSize
            });
        }
    }
};

});

parcelRegister("4jWBv", function(module, exports) {

$parcel$export(module.exports, "CanvasVerticalNavbar", () => $32566548aeb3177e$export$e0e7130af7b19cb6);
const $32566548aeb3177e$export$e0e7130af7b19cb6 = {
    extends: 'Navbar',
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    transform: 'translate3d(0, -50%, 0)',
    left: '--canvas-gutter',
    flow: 'y',
    padding: 'U1 U1',
    round: 'radiusPill',
    gap: 'X',
    theme: 'canvas-card-glass',
    NavbarButtonSet: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        childProps: {
            padding: 'Y2',
            round: 'radiusPill',
            isActive: (el)=>el.call('getFilesSidebar') && el.call('getSidebarContent') === el.section,
            onClick: (ev, el)=>{
                const activeContent = el.section;
                el.setWindow('explorer', activeContent);
                window.setTimeout(()=>{
                    el.call('setSidebarContent', activeContent);
                }, 35);
            }
        },
        children: [
            {
                icon: 'content',
                title: (el)=>el.call('polyglot', 'editor.panel.artboards'),
                section: 'ARTBOARD_TYPES'
            },
            {
                icon: 'fnOutline',
                title: (el)=>el.call('polyglot', 'editor.panel.functions'),
                section: 'FUNCTION_TYPES'
            },
            {
                icon: 'copywritingOutline',
                title: (el)=>el.call('polyglot', 'editor.panel.state'),
                section: 'STATE_TYPES'
            },
            {
                icon: 'tree',
                title: (el)=>el.call('polyglot', 'editor.ds.title'),
                section: 'DESIGN_SYSTEM_TYPES'
            },
            {
                icon: 'folderOutline',
                title: (el)=>el.call('polyglot', 'editor.panel.assets'),
                section: 'ASSETS_TYPES'
            },
            {
                icon: 'fuse',
                title: (el)=>el.call('polyglot', 'editor.panel.integrations'),
                section: 'INTEGRATIONS_TYPES'
            },
            {
                icon: 'tutorial outline',
                title: (el)=>el.call('polyglot', 'editor.textNavbar.learn'),
                section: 'TUTORIALS'
            }
        ],
        childrenAs: 'props'
    },
    Line: {
        margin: 'Y1 0',
        width: 'fill-available'
    },
    NavbarButtonSet_meta: {
        padding: '0',
        gap: 'Z',
        flow: 'y',
        Expand: {
            title: (el)=>el.call('polyglot', 'editor.position.expand'),
            icon: 'arrowAngleRight',
            onClick: (ev, el)=>{
                el.toggleWindow('explorer');
            }
        }
    },
    NavbarTooltip: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        top: '0',
        left: '110%',
        tooltipPosition: 'right',
        shapeDirection: 'left'
    }
};

});

parcelRegister("2Y3ZC", function(module, exports) {

$parcel$export(module.exports, "ActiveContentSwitcher", () => $229448494a8816cd$export$f36f9c766a52306c);
const $229448494a8816cd$export$f36f9c766a52306c = {
    extends: [
        'Grid',
        'Navbar'
    ],
    round: 'radiusPill',
    fontSize: 'Z1',
    templateColumns: 'repeat(7, 1fr)',
    align: 'center center',
    children: [
        {
            icon: 'magicstar',
            title: (el)=>el.call('polyglot', 'editor.panel.aiAssistant'),
            section: 'AI'
        },
        {
            icon: 'content',
            title: (el)=>el.call('polyglot', 'editor.panel.artboards'),
            section: 'ARTBOARD_TYPES'
        },
        {
            icon: 'fnOutline',
            title: (el)=>el.call('polyglot', 'editor.panel.functions'),
            section: 'FUNCTION_TYPES'
        },
        {
            icon: 'tree',
            title: (el)=>el.call('polyglot', 'editor.ds.title'),
            section: 'DESIGN_SYSTEM_TYPES'
        },
        {
            icon: 'copywritingOutline',
            title: (el)=>el.call('polyglot', 'editor.panel.state'),
            section: 'STATE_TYPES'
        },
        {
            icon: 'folderOutline',
            title: (el)=>el.call('polyglot', 'editor.panel.assets'),
            section: 'ASSETS_TYPES'
        },
        {
            icon: 'fuse',
            title: (el)=>el.call('polyglot', 'editor.panel.integrations'),
            section: 'INTEGRATIONS_TYPES'
        }
    ],
    childProps: {
        textAlign: 'center',
        onClick: (ev, el, s)=>{
            const activeContent = el.section;
            el.call('setSidebarContent', activeContent);
        }
    },
    childExtends: {
        extends: [
            'NavbarButton',
            'NavbarTooltipParent'
        ],
        state: null,
        width: '100%',
        aspectRatio: 'unset',
        padding: 'Z -',
        // Reviewed (fixed-colour sweep): the literals below are NOT base-level —
        // each is already the return value of its own '@dark'/'@light' factory,
        // so this active-tab pill is a deliberate dark chip in BOTH schemes
        // (gray3 dark / gray4 light background, gray15 text either way), not an
        // unscoped fixed literal. Left as-is.
        '@dark': (el, s)=>el.section === s.activeContent ? {
                color: 'gray15',
                background: 'gray3'
            } : undefined,
        '@light': (el, s)=>el.section === s.activeContent ? {
                color: 'gray15',
                background: 'gray4'
            } : undefined,
        theme: (el, s)=>el.section !== s.activeContent ? 'transparent' : undefined,
        ':hover': (el, s)=>el.section !== s.activeContent ? {
                '@dark': {
                    color: 'gray15',
                    background: 'gray2'
                },
                '@light': {
                    color: 'gray15',
                    background: 'gray4'
                }
            } : undefined
    },
    NavbarTooltip: {
        ignoreChildExtends: true,
        ignoreChildProps: true
    }
};

});

parcelRegister("2NZLH", function(module, exports) {

$parcel$export(module.exports, "Feedback", () => $20b0124aa4c46a7d$export$175e500a48a60fd2);
// Feedback — one row of a feedback board: a vote toggle with its count, then
// the post's heading and one meta line. The component ships NO content of its
// own. Every word and number comes from the row's props:
//
//   heading — the post's heading. No heading → nothing renders.
//   meta    — one line under the heading (author, age, comment count),
//             composed and translated by the consumer. Empty → no line.
//   upvotes — the vote count, a number. Not a number → no vote toggle.
//   voted   — true when the person's own vote is already on.
//
//   Feedback: { heading: (el, s) => s.post.title, upvotes: (el, s) => s.post.votes }
//   Board: { childExtends: 'Feedback', children: (el, s) => s.posts }  // each item → props
//
// Props, not state: a prop never falls back to the root state's key of the
// same name, and the row adds no state scope of its own, so an element that
// only SHARES the key `Feedback` (a generated app's message, a toast) keeps
// its own state and shows only its own content. The vote toggle keeps its
// one flag on its own state; a consumer that saves votes sets
// `Button: { onClick }`. Its accessible name is the count until a consumer
// sets `Button: { aria: { label } }` — the catalogs hold no "upvote" term.
//
// Why: the component carried a whole demo post ("Flexbox in Editor", "by
// kiaynwang", "3 hours ago", "49 comments"). A child key named `Feedback`
// extends this component, so a generated app showed a stranger's post on a
// person's screen (R2-M1, persona round 2).
// __tests__/feedbackShipsNoContent.test.js guards it.
const $20b0124aa4c46a7d$export$175e500a48a60fd2 = {
    flow: 'x',
    gap: 'A2',
    align: 'flex-start',
    Button: {
        color: 'paragraph',
        flow: 'column',
        gap: 'Z',
        padding: '0',
        background: 'transparent',
        border: '0',
        fontSize: 'A',
        cursor: 'pointer',
        margin: '-W - -',
        state: {
            flipped: false
        },
        hide: (el)=>!el.parent.heading || typeof el.parent.upvotes !== 'number',
        text: (el, s)=>{
            const row = el.parent;
            if (typeof row.upvotes !== 'number') return '';
            const step = row.voted ? -1 : 1;
            return String(row.upvotes + (s.flipped ? step : 0));
        },
        aria: {
            pressed: (el, s)=>Boolean(el.parent.voted) !== Boolean(s.flipped) ? 'true' : 'false'
        },
        Icon: {
            name: 'arrowAngleUp',
            // eslint-disable-next-line no-restricted-syntax -- icon glyph color, not text
            color: 'inactive'
        },
        // The glyph follows aria-pressed, so what a person sees and what a screen
        // reader hears cannot disagree. Hover takes the next ink up: `placeholder`
        // (the old hover) is the same pair as `inactive`, so it changed nothing.
        '[aria-pressed="true"] svg': {
            color: 'orange'
        },
        '[aria-pressed="false"]:hover svg': {
            color: 'paragraph'
        },
        onClick: (ev, el, s)=>{
            s.update({
                flipped: !s.flipped
            });
        }
    },
    Hgroup: {
        hide: (el)=>!el.parent.heading,
        H: {
            tag: 'h6',
            fontWeight: '700',
            text: (el)=>el.parent.parent.heading
        },
        P: {
            hide: (el)=>!el.parent.parent.meta,
            text: (el)=>el.parent.parent.meta
        }
    }
};

});

parcelRegister("9Oc4t", function(module, exports) {

$parcel$export(module.exports, "NavbarTooltipParent", () => $724225a7bad1d323$export$61d215aafe79203c);
const $724225a7bad1d323$export$61d215aafe79203c = {
    onUpdate: (el, s)=>{
        const active = window.location.pathname.includes(s.href);
        if (active) el.call('setNavbarTooltipPosition');
    },
    onMouseenter: (ev, el, s)=>{
        if (!s.hover) {
            s.hover = true;
            el.call('setNavbarTooltipPosition', {
                visible: true
            });
        }
    },
    onMouseleave: (ev, el, s)=>{
        if (s.hover) {
            s.hover = false;
            const Tooltip = el.lookup('NavbarTooltip');
            if (Tooltip) Tooltip.update({
                opacity: '0',
                visibility: 'hidden'
            });
        }
    }
};

});

parcelRegister("57Nb9", function(module, exports) {

$parcel$export(module.exports, "ResponsiveOverlay", () => $3bb3c11b3ad0c653$export$b80c1f5e9d0f0b13);
const $3bb3c11b3ad0c653$export$b80c1f5e9d0f0b13 = {
    Link: {
        extends: 'SquareButton',
        theme: 'quaternary',
        color: 'title',
        icon: 'logov2',
        href: 'https://symbols.app',
        'aria-label': (el)=>el.call('polyglot', 'shell.overlay.brandHome')
    },
    IconText: {
        icon: 'deviceTabletLandscapeHalf fill',
        lineHeight: '1.4',
        gap: 'Z',
        text: '{{ editor.overlay.smallView | polyglot }}',
        '@mobileM': {
            flow: 'column',
            textAlign: 'center'
        }
    },
    // The one action — the kit's ink primary (the kit owns the scale: it was
    // the brand Button with a hand-set padding, Rule 68).
    Button: {
        extends: 'AppCapsuleBtnPrimary',
        // Playwright smoke harness binds via this exact string —
        // qa-automation/pages/signin.page.ts (and homepage.page.ts) openAnyway.
        'data-testid': 'ResponsiveOverlay.Button',
        text: '{{ editor.overlay.openAnyway | polyglot }}',
        onClick: (ev, el)=>el.parent.remove()
    },
    flow: 'column',
    if: (el)=>{
        const isTesting = location.host.includes('localhost');
        const isCanvas = location.pathname.includes('srcdoc');
        const isEmbed = el.isEmbed();
        if (isEmbed || isCanvas || isTesting) return false;
        return true;
    },
    display: 'none',
    align: 'center space-between',
    position: 'fixed',
    inset: '0 0 0 0',
    boxSize: '100%',
    padding: 'C',
    zIndex: '999999',
    gap: 'A',
    '@tabletL': {
        display: 'flex'
    },
    // The page ground and its ink, in both schemes (DESIGN_SPEC S16: tokens) —
    // it was a raw `black.9` / `gray15.95` pair under a 3px blur. The notice
    // covers the whole screen, so the ground is opaque and needs no blur.
    theme: 'document'
};

});

parcelRegister("334b0", function(module, exports) {

$parcel$export(module.exports, "CodePreviewWithTitle", () => $2384e4482a565c80$export$193ccbdefee80ca0);
// The public code-preview component (title + copy/framework buttons +
// Prism-highlighted body). Renamed from `Code` — the bare `Code` name
// collided with `code`/`Code` keys produced from markdown and AI-generated
// content, which auto-extended this component's chrome by key. Bare `code`
// keys now render as plain elements.
const $2384e4482a565c80$export$193ccbdefee80ca0 = {
    extends: 'CodeWithTitleAndButtons',
    flow: 'y',
    minWidth: 'H',
    maxWidth: '50%',
    '@tabletS': {
        width: 'max-content',
        widthRange: 'auto'
    }
};

});

parcelRegister("946QX", function(module, exports) {

$parcel$export(module.exports, "CodeWithTitleAndButtons", () => $6999cda64f8a12f5$export$1c5966595d851711);
// Self-contained since the Code → CodePreviewWithTitle rename: the old
// title-only intermediate (previously exported as CodePreviewWithTitle) is
// folded in here so the CodePreviewWithTitle name is free for the public
// head component. Rendering is byte-identical to the old
// Group → title-layer → buttons-layer chain.
const $6999cda64f8a12f5$export$1c5966595d851711 = {
    extends: 'Group',
    tag: 'pre',
    margin: '0',
    minWidth: 'F3',
    maxWidth: '50%',
    align: 'stretch',
    '@tabletS': {
        maxWidth: 'none'
    },
    Title: {
        order: null,
        tag: 'h5',
        text: '{{ learn.codeExample.title | polyglot }}',
        fontFamily: 'smbls',
        color: 'caption',
        fontSize: 'Z',
        fontWeight: '500',
        whiteSpace: 'nowrap'
    },
    CodePreview: {
        margin: '0 -Y1',
        round: 'A+X',
        padding: 'A A1 D1',
        '&': {
            minWidth: '100%',
            width: 'auto'
        }
    },
    Buttons: {
        align: 'center space-between',
        margin: '-C+X1 -W 0',
        gap: 'X2',
        transition: 'B opacity',
        '&': {
            minWidth: '100%',
            width: 'auto'
        },
        childExtends: [
            'WiderButton'
        ],
        childProps: {
            round: 'radiusControl',
            fontSize: 'A',
            transition: 'A',
            transitionProperty: 'background, color, border',
            theme: 'secondary-highlight',
            zIndex: 10
        },
        CopyButton: {
            extends: [
                'WiderButton',
                'CopyButton'
            ],
            margin: '0 auto 0 0',
            icon: 'copy outline',
            value: (el)=>{
                const val = el.call('getCodePreviewValue', el.parent.value || '//');
                return val;
            }
        },
        Link: {
            href: '/dashboard#{{ title }}',
            ariaLabel: (el)=>el.call('polyglot', 'learn.codeExample.openInDashboard'),
            Icon: {
                name: 'url'
            }
        },
        FrameworkSwitcher: {
            padding: 'Z B Z Z2',
            fontSize: 'A',
            fontFamily: 'smbls',
            Icon: {
                name: (el)=>{
                    const fw = el.getRootState?.()?.framework;
                    return (fw === 'domql' ? 'symbols' : fw) || 'symbols';
                }
            },
            Icon_arrow: {
                position: 'absolute',
                opacity: 0.5,
                fontSize: 'Z',
                right: 'Z1',
                icon: 'arrowAngleMirroringVertical'
            }
        }
    }
};

});

parcelRegister("17dNB", function(module, exports) {

$parcel$export(module.exports, "CodePreview", () => $0d0126181c1caa95$export$92c0a26c2d112021);

const $0d0126181c1caa95$export$92c0a26c2d112021 = {
    flex: 1,
    minWidth: 'G',
    maxHeight: '100%',
    overflow: 'auto',
    display: 'block',
    whiteSpace: 'pre-wrap',
    lineHeight: 1.8,
    fontSize: '0.765em',
    fontFamily: 'Code',
    round: 'A1',
    height: 'max-content',
    transition: 'B padding',
    padding: 'A_default A1_default',
    theme: 'common-card',
    value: '// demo code',
    // Dark tokens sit on `gray2.65` over the WORKSPACE stage, and a workspace
    // may paint a lighter stage (natali: gray5). Every hue clears 4.5:1 on the
    // card over the default stage AND over gray5; `keyword` was the one that
    // did not (3.73 on the gray5 card, measured live 2026-09-22).
    '& .token': {
        '&.keyword': {
            color: '#6592b9'
        },
        '&.string': {
            color: '#c8749c'
        },
        '&.punctuation': {
            color: '#A3A3A8'
        },
        '&.function': {
            color: '#c7c981'
        },
        '&.property': {
            color: '#87b6cb'
        },
        '&.string-property': {
            color: '#C584C0'
        },
        '&.operator': {
            color: '#74b6d4'
        },
        '&.boolean': {
            color: '#589BD6'
        },
        '&.number': {
            color: '#B5CFA8'
        },
        '&.comment': {
            color: '#6A9A55'
        },
        '&.constant': {
            color: '#fff'
        }
    },
    // The light palette: the same hues as the dark one, each darkened until it
    // clears 4.5:1 on BOTH light grounds a preview sits on (white — the light
    // `common-card` ground — and the gray15 stage). It used to reuse the dark
    // palette's own hexes for number / operator / boolean / comment, which read
    // 1.69–3.30 on white (measured live on the UI kit, 2026-09-22;
    // shared/__tests__/codePreviewSyntaxContrast.test.js recomputes every value).
    '@light': {
        '& .token': {
            '&.keyword': {
                color: '#126ebd'
            },
            '&.string': {
                color: '#cd2072'
            },
            '&.punctuation': {
                color: '#6a6a89'
            },
            '&.function': {
                color: '#7a6c00'
            },
            '&.property': {
                color: '#2b7393'
            },
            '&.string-property': {
                color: '#b633ac'
            },
            '&.operator': {
                color: '#2e7393'
            },
            '&.boolean': {
                color: '#2a70ad'
            },
            '&.number': {
                color: '#527540'
            },
            '&.comment': {
                color: '#517641'
            },
            '&.constant': {
                color: 'black'
            }
        }
    },
    onUpdate: (el, s)=>{
        el.onRender(el, s);
    },
    onRender: async (el, s)=>{
        const prismjs = await (parcelRequire("7vPAX"));
        // LIVENESS GATE — see getCodePreviewValue.js. The page can change while
        // prismjs loads, and smbls `dispose()` nulls `element.node` and
        // `element.parent`. Everything below this line reads the tree:
        // `getRootState`, `el.call` and `el.update`. The test is the dispose
        // signature, NOT `node.isConnected` — a child's onRender legitimately
        // runs before the root is attached.
        if (!el.node || !el.parent) return;
        const Prism = prismjs?.default || prismjs;
        const globalState = el.getRootState();
        const code = await el.call('getCodePreviewValue');
        if (!code || !Prism) return;
        await el.update({
            html: Prism.highlight(code, Prism.languages.javascript, globalState?.language)
        }, {
            preventListeners: true,
            preventUpdateListener: true
        });
    }
};

});
parcelRegister("7vPAX", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("7qvlX"))) : import("7qvlX")).then(()=>parcelRequire('eYBTA'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("g3ftr", function(module, exports) {

$parcel$export(module.exports, "PageTemplate", () => $baf8edea3da978f7$export$1773bf8c632ebee7);
const $baf8edea3da978f7$export$1773bf8c632ebee7 = {
    tag: 'main',
    flow: 'column',
    width: '100%',
    margin: '- auto',
    maxWidth: 'K_default',
    padding: 'D2 E B1',
    flex: 1,
    '@screenS': {
        padding: 'C1 C B1'
    },
    '@tabletS': {
        padding: 'C1 B'
    }
};

});

parcelRegister("6T65T", function(module, exports) {

$parcel$export(module.exports, "DesignSystem", () => $503c9b4e065a1995$export$76bc5a0bcb063c6b);
const $503c9b4e065a1995$export$76bc5a0bcb063c6b = {
    Grid: {
        childExtends: {
            theme: 'common-card-interactive',
            padding: 'Z2 Y2 Z2 Z2',
            align: 'center space-between',
            flex: '1',
            round: 'radiusCard',
            gap: 'B2',
            width: '100%',
            href: '{{ href }}',
            '@tabletL': {
                maxWidth: 'none'
            },
            ':nth-child(2)': {
                '> div > p': {
                    maxWidth: 'E3'
                }
            },
            WiderButton: {
                icon: (el, s)=>s.icon,
                padding: 'Y2',
                background: (el, s)=>s.background,
                theme: (el, s)=>s.theme
            },
            Hgroup: {
                gap: 'X2',
                H: {
                    text: (el, s)=>el.call('polyglot', s.title || ''),
                    fontSize: 'A',
                    fontWeight: '500'
                },
                P: {
                    text: (el, s)=>el.call('polyglot', s.p || ''),
                    fontSize: 'Z',
                    maxWidth: (el, s)=>s.maxWidth,
                    '@tabletL': {
                        maxWidth: 'E3+A1'
                    }
                }
            }
        },
        children: ()=>[
                {
                    title: 'editor.panel.colors',
                    href: '/docs/color',
                    p: 'editor.dsCard.colors',
                    icon: 'color',
                    theme: 'theme',
                    maxWidth: 'E'
                },
                {
                    title: 'editor.panel.typography',
                    href: '/docs/typography',
                    p: 'editor.dsCard.typography',
                    icon: 'typography',
                    theme: 'typography',
                    maxWidth: 'E'
                },
                {
                    title: 'editor.panel.spacing',
                    href: '/docs/space',
                    p: 'editor.dsCard.spacing',
                    maxWidth: 'E2',
                    icon: 'space',
                    theme: 'space'
                },
                {
                    title: 'editor.panel.shapes',
                    href: '/docs/shapes',
                    p: 'editor.dsCard.shapes',
                    icon: 'shape',
                    theme: 'shape'
                },
                {
                    title: 'editor.panel.icons',
                    href: '/docs/icons',
                    p: 'editor.dsCard.icons',
                    icon: 'icons',
                    theme: 'icons'
                },
                {
                    title: 'editor.panel.breakpoints',
                    href: '/docs/media',
                    p: 'editor.dsCard.breakpoints',
                    icon: 'deviceMobileOutline'
                },
                {
                    title: 'editor.panel.sequence',
                    href: '/docs/sequence',
                    p: 'editor.dsCard.sequence',
                    icon: 'stateColored'
                },
                {
                    title: 'editor.panel.timing',
                    href: '/docs/timing',
                    p: 'editor.dsCard.timing',
                    icon: 'clock'
                }
            ]
    }
};

});

parcelRegister("3ywb8", function(module, exports) {

$parcel$export(module.exports, "Terminal", () => $296d8215b57fba36$export$8dd80f06eb58bfe1);
const $296d8215b57fba36$export$8dd80f06eb58bfe1 = {
    tag: 'code',
    Icon: {
        icon: 'terminal',
        '@dark': {
            color: 'gray7'
        },
        '@light': {
            color: 'gray8'
        }
    },
    Command: {
        overflow: 'hidden',
        flex: 1,
        padding: '0',
        textOverflow: 'ellipsis',
        margin: '0 auto 0 0'
    },
    Copy: {
        extends: [
            'WiderButton',
            'CopyButton'
        ],
        icon: 'copyOutline',
        background: 'transparent.0',
        theme: 'secondary-highlight',
        value: (el)=>el.call('getCodePreviewValue', el.parent.value)
    },
    flow: 'x',
    align: 'center space-between',
    padding: 'W X W A',
    minWidth: 'G',
    minHeight: 'B2',
    round: 'radiusControl',
    fontFamily: 'Code',
    gap: 'X2',
    whiteSpace: 'nowrap',
    theme: 'common-card'
};

});

parcelRegister("6dIo9", function(module, exports) {

$parcel$export(module.exports, "Page", () => $4876639937c5057a$export$6955bcca4cd3539f);
const $4876639937c5057a$export$6955bcca4cd3539f = {
    tag: 'main',
    extends: 'PageTemplate',
    width: '100%',
    maxWidth: 'K_default',
    margin: '- auto'
};

});

parcelRegister("1bajT", function(module, exports) {

$parcel$export(module.exports, "Command", () => $0dbed2d88554467f$export$cc7e12c76513e857);


const $0dbed2d88554467f$export$cc7e12c76513e857 = {
    padding: '0 C2 0 0',
    fontSize: '0.765em',
    fontFamily: 'Code',
    '@dark': {
        '& .token': {
            '&.function': {
                color: '#DBDDAA'
            }
        }
    },
    '@light': {
        '& .token': {
            '&.function': {
                color: '#a59300'
            }
        }
    },
    onUpdate: (el, s)=>{
        el.onRender(el, s);
    },
    onRender: async (el, s)=>{
        const prismjs = await (parcelRequire("7vPAX"));
        // LIVENESS GATE — see getCodePreviewValue.js. Two awaits, so two gates:
        // the bash grammar below is a second load window the page can change
        // across. The test is the dispose signature, NOT `node.isConnected` —
        // a child's onRender legitimately runs before the root is attached.
        if (!el.node || !el.parent) return;
        const Prism = prismjs?.default || prismjs;
        if (!Prism.languages.bash) {
            try {
                await (parcelRequire("jplC7"));
            } catch (e) {
                await window.require('prismjs@1.30.0/components/prism-bash.min.js');
            }
            if (!el.node || !el.parent) return;
        }
        const code = el.call('getCodePreviewValue');
        if (!code || !Prism) return;
        el.update({
            html: Prism.highlight(code, Prism.languages.bash, 'bash')
        }, {
            preventListeners: true
        });
    }
};

});
parcelRegister("jplC7", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("fhLTf"))) : import("fhLTf")).then(()=>parcelRequire('lQvx2'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("lEzlR", function(module, exports) {

$parcel$export(module.exports, "TerminalWithTitle", () => $fc38c178c7d9be4b$export$257fce7f278657d7);
const $fc38c178c7d9be4b$export$257fce7f278657d7 = {
    extends: 'Group',
    Title: {
        tag: 'title'
    },
    Terminal: {}
};

});

parcelRegister("8MK2B", function(module, exports) {

$parcel$export(module.exports, "DesignSystemOptions", () => $6656852f38a3d995$export$d7f7350a8dbd4c82);
const $6656852f38a3d995$export$d7f7350a8dbd4c82 = {
    extends: 'SettingsSection',
    state: 'designSystem',
    Title: {
        text: '{{ editor.ds.settingsTitle | polyglot }}',
        QuestionMarkTooltip: {
            onClick: (ev, el, s)=>{
                s.update({
                    useReset: true,
                    useVariable: true,
                    useDocumentTheme: true,
                    useFontImport: true,
                    useIconSprite: true,
                    useSvgSprite: true,
                    useDefaultConfig: true,
                    verbose: false
                }, {
                    preventShModalUpdate: true
                });
            }
        }
    },
    Grid: {
        childExtends: {
            extends: 'OptionToggle',
            onChange: async (ev, el, s)=>{
                const { key: key } = el;
                const val = s[key];
                await el.updateDesignSystem(null, key, !val, {
                    message: `Set ${key} design system settings to ${!val}`
                });
                el.call('setCookie', key, !val);
            },
            Input: {
                checked: (el)=>el.getDesignSystem()[el.parent.key]
            }
        },
        children: [
            {
                key: 'useReset',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Reset CSS browser defaults and matching Symbols Design System'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.normalize | polyglot }}'
                }
            },
            {
                key: 'useVariable',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Apply CSS values as variables'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.cssVars | polyglot }}'
                }
            },
            {
                key: 'useDocumentTheme',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Apply global @dark @light, and other themes to the document'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.globalThemes | polyglot }}'
                }
            },
            {
                key: 'useFontImport',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Import fonts via @font-face from Symbols cdn'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.importFonts | polyglot }}'
                }
            },
            {
                key: 'useIconSprite',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Bundle icons as SVG sprites'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.spriteIcons | polyglot }}'
                }
            },
            {
                key: 'useSvgSprite',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Bundle SVGs as SVG sprites'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.spriteSvg | polyglot }}'
                }
            },
            {
                key: 'useDefaultConfig',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Use default config as fallback for components'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.defaultConfig | polyglot }}'
                }
            },
            {
                key: 'verbose',
                QuestionMarkTooltip: {
                    TooltipHidden: {
                        shapeDirection: 'top',
                        tip: 'Design System verbose mode in console'
                    }
                },
                Caption: {
                    text: '{{ editor.ds.verbose | polyglot }}'
                }
            },
            {
                extends: 'SelectDropdownWithTitle',
                ignoreChildExtends: true,
                // Row-separator-as-chrome (design-direction.md §8 / DESIGN_LANGUAGE
                // §2.5) — was a top border split across '@dark'/'@light' with raw
                // `--color-line-dark`/`--color-line-light` custom-property names (not
                // even wrapped in a token). The row's own `padding: 'B1 - -'` top
                // padding already separates it from the toggle grid above.
                padding: 'B1 - -',
                Title: {
                    opacity: '.65',
                    // Was `inactive` — same fix as SwitchFieldWithCaption.Caption
                    // (company/packages/brand): composited with this row's `.65`
                    // opacity it measured 2.98:1 light / 3.49:1 dark (needs 4.5; AA
                    // walk 2026-08-09, LMC-4). `caption` holds >=4.6 light / >=5.7
                    // dark at the same opacity.
                    color: 'caption',
                    text: '{{ settings.platform.defaultTheme | polyglot }}'
                },
                SelectDropdown: {
                    Value: {
                        Text: {
                            text: (el)=>el.call('toDescriptionCase', el.getDesignSystem('globalTheme')) || 'Auto'
                        }
                    },
                    Dropdown: {
                        top: '121%',
                        options: [
                            {
                                key: 'auto',
                                labelKey: 'settings.platform.theme.auto'
                            },
                            {
                                key: 'dark',
                                labelKey: 'settings.platform.theme.dark'
                            },
                            {
                                key: 'light',
                                labelKey: 'settings.platform.theme.light'
                            },
                            {
                                key: 'custom',
                                labelKey: 'editor.canvasBg.custom'
                            }
                        ],
                        onChoose: async (ev, el, s, ctx, calleeElement)=>{
                            const globalTheme = calleeElement.state.key;
                            undefined.sdk.updateData([
                                [
                                    'update',
                                    [
                                        'designSystem',
                                        'globaltheme'
                                    ],
                                    globalTheme
                                ]
                            ], {
                                message: `Updating globalTheme to ${globalTheme}`
                            });
                            el.getRootState().update({
                                globalTheme: globalTheme
                            });
                            el.call('setCookie', 'globalTheme', el.getDesignSystem('globalTheme'));
                        },
                        DropdownHeader: {
                            text: '{{ settings.platform.globalTheme | polyglot }}'
                        },
                        ListInDropdown: {
                            childExtends: {
                                extends: 'KeyValueColumnFields',
                                isActive: (el, s)=>el.getDesignSystem('globalTheme') === s.key,
                                // NO `text:` here. KeyValueColumnFields already renders the
                                // option label in its own `Text` slot (`s.text || s.value ||
                                // s.key`), and this row HAS children, so a `text:` on the row
                                // adds a SECOND text node beside them: every global theme read
                                // "dark ✓ dark". The row is a chassis with slots, not a leaf.
                                // (Same defect and same fix as LanguageSelectField.js.)
                                fontWeight: '400',
                                // The options carry polyglot KEYS (labelKey): a '{{ … | polyglot }}'
                                // string read out of row state is data to the template resolver since
                                // smbls 3c416df0c, and this Text slot painted raw 'Auto / Dark / Light'.
                                Text: {
                                    text: (el, s)=>el.call('polyglot', s.labelKey)
                                }
                            }
                        }
                    }
                }
            }
        ],
        childrenAs: 'props'
    }
};

});

parcelRegister("25iav", function(module, exports) {

$parcel$export(module.exports, "InstallTabs", () => $184a244b1592017e$export$1dcef869b609755b);
const $184a244b1592017e$export$1dcef869b609755b = {
    flow: 'x',
    align: 'end',
    gap: 'B1',
    margin: 'C1 - -',
    childProps: {
        isActive: (el, s)=>s.installTab === el.key,
        theme: 'transparent',
        // Was a persistent 3px bottom border on the active tab, painted with a
        // raw CSS var (`--document-dark-background`) instead of a token —
        // underline-as-chrome, banned by design-direction.md §8 / DESIGN_LANGUAGE
        // §2.5 stroke policy. Mirrors brand TabsLink.js's identical fix: drop the
        // border, let the active state read from ink alone (color + weight
        // below). Padding rebalanced from the old bottom-heavy '0 0 A' (shaped to
        // clear the border) to symmetric 'Z1 A' now that there is nothing to
        // clear.
        round: '0',
        padding: 'Z1 A',
        align: 'end',
        transition: 'A, defaultBezier',
        transitionProperty: 'color, font-weight',
        // Real tab semantics for assistive tech (brief §"Real semantics") —
        // the active tab was conveyed only visually via .isActive. `role` is a
        // flat first-class prop (audit_component FA105 — brand TabsLink.js
        // still wraps it in `attr:`, a pre-existing defect out of scope here
        // since brand/ is read-only); `aria-selected` stays in `attr` since a
        // hyphenated aria-* key has no flat form.
        role: 'tab',
        attr: {
            'aria-selected': (el, s)=>String(!!el.call('exec', el.isActive, el))
        },
        ':hover': {
            color: 'title'
        },
        '.isActive': {
            color: 'title',
            // 'bold' silently renders as 700 in this face (no 600) — spelled out
            // as the real token per the {400,500,700} weight law (DESIGN_LANGUAGE
            // §5.2).
            fontWeight: '700'
        },
        onClick: (ev, el, s)=>{
            s.update({
                installTab: el.key
            });
            el.call('setCookie', 'installTab', el.key);
        }
    },
    childExtends: 'Button',
    Development: {
        text: '{{ publish.envs.development | polyglot }}'
    },
    Domain: {
        extends: 'SubscribeButton',
        Text: {
            order: '-1',
            text: '{{ learn.install.domain | polyglot }}'
        }
    },
    Live: {
        text: '{{ editor.import.liveWebsite | polyglot }}'
    }
};

});

parcelRegister("9LcDL", function(module, exports) {

$parcel$export(module.exports, "SettingsSection", () => $71b24ef0a6f81d3a$export$d239b03507a9e5cc);
const $71b24ef0a6f81d3a$export$d239b03507a9e5cc = {
    extends: 'Group',
    Title: {
        flow: 'x',
        width: '100%',
        margin: 'A - -',
        align: 'center space-between',
        text: '{{ settings.section.platform | polyglot }}',
        QuestionMarkTooltip: {
            margin: '0',
            TooltipHidden: {
                minWidth: 'none',
                padding: 'Z A',
                shapeDirection: 'top',
                description: (el)=>el.call('polyglot', 'settings.section.resetTooltip')
            },
            Icon: {
                fontSize: 'A2',
                opacity: '.65',
                name: 'refresh'
            }
        }
    },
    Grid: {
        margin: 'A -',
        templateColumns: 'repeat(4, 1fr)',
        gap: 'B1 C3',
        '@tabletM': {
            columns: 'repeat(3, 1fr)'
        },
        '@tabletS': {
            columns: 'repeat(2, 1fr)'
        },
        '@mobileL': {
            columns: 'repeat(1, 1fr)'
        },
        childExtends: 'OptionToggle'
    }
};

});

parcelRegister("PepXP", function(module, exports) {

$parcel$export(module.exports, "InstallFooter", () => $099ff29ada0fab9e$export$f58493c6a6fcb573);
const $099ff29ada0fab9e$export$f58493c6a6fcb573 = {
    flow: 'x',
    align: 'center',
    gap: 'X2',
    opacity: '.35',
    Icon: {
        name: 'question mark fill'
    },
    Paragraph: {
        margin: '0',
        childrenAs: 'props',
        children: [
            {
                text: '{{ learn.install.footer | polyglot }}',
                padding: '0 V1'
            },
            {
                extends: 'DocsLink',
                href: '/docs/intro',
                text: '{{ learn.install.docsPage | polyglot }}'
            }
        ]
    }
};

});

parcelRegister("dI7M1", function(module, exports) {

$parcel$export(module.exports, "InstallCdn", () => $9fb56a1c6d4024b6$export$3c91bc0ff0f60103);
// Install snippet's CDN URL resolves through `workspaceApiBase()` so the
// tier matches whatever surface the user is viewing — `dev.api.symbols.app`
// for dev users, `staging.api...` for staging, prod for prod. Previously
// hardcoded `https://api.symbols.app/cdn/...` which sent dev/staging
// users to a stale prod build.

var $29wU0 = parcelRequire("29wU0");
const $9fb56a1c6d4024b6$export$3c91bc0ff0f60103 = {
    P: {
        color: 'inactive',
        margin: '0',
        text: '{{ learn.install.addScript | polyglot }}'
    },
    CodePreviewWithTitle: {
        margin: 'Z1 0 0',
        value: (el)=>`<script src="${(0, $29wU0.workspaceApiBase)()}/cdn/${el.getAppKey() && el.getAppKey().split('.')[0]}"></script>`,
        Title: null,
        Buttons: {
            FrameworkSwitcher: null
        }
    }
};

});

parcelRegister("9dwcZ", function(module, exports) {

$parcel$export(module.exports, "InstallLiveExt", () => $6b5e4fe5d737cb79$export$5093e061083d8cea);
// Live-extension snippet URL resolves through `workspaceApiBase()` so
// the tier matches whatever surface the user is viewing. Previously
// hardcoded `https://api.symbols.app/live/...` (always prod).

var $29wU0 = parcelRequire("29wU0");
const $6b5e4fe5d737cb79$export$5093e061083d8cea = {
    gap: '0',
    P: {
        color: 'inactive',
        margin: '0',
        text: '{{ learn.install.addScript | polyglot }}'
    },
    CodePreviewWithTitle: {
        margin: 'Z1 0 0',
        value: (el)=>`<script src="${(0, $29wU0.workspaceApiBase)()}/live/${el.getAppKey() && el.getAppKey().split('.')[0]}"></script>`,
        Title: null,
        Buttons: {
            FrameworkSwitcher: null
        }
    }
};

});

parcelRegister("3Unag", function(module, exports) {

$parcel$export(module.exports, "InstallDomain", () => $2d88920cc7907993$export$2f1bc08691d5966);
const $2d88920cc7907993$export$2f1bc08691d5966 = {
    flow: 'y',
    gap: 'C1',
    P: {
        color: 'inactive',
        margin: '0',
        Text: {
            text: '{{ publish.dns.step1 | polyglot }}'
        },
        LabeledHighlight: {
            text: (el)=>el.getRootState().domain
        }
    },
    ARecord: {
        P: {
            color: 'inactive',
            margin: '0 - Z2',
            text: '{{ publish.dns.step2 | polyglot }}'
        },
        Terminal: {
            width: 'fit-content',
            Icon: {},
            value: '104.18.10.164'
        },
        Terminal2: {
            extends: 'Terminal',
            value: '104.18.11.164'
        }
    },
    TxtRecord: {
        P: {
            color: 'inactive',
            margin: '0 - Z2',
            text: '{{ publish.dns.step3 | polyglot }}'
        },
        CodePreviewWithTitle: {
            margin: 'Z1 0 0',
            Title: null,
            value: '// txt_record',
            Buttons: {
                Link: null,
                FrameworkSwitcher: null
            }
        }
    }
};

});

parcelRegister("i7Cwa", function(module, exports) {

$parcel$export(module.exports, "ChromeExt", () => $d316c2447a7eadf1$export$d634877323dc1dda);
const $d316c2447a7eadf1$export$d634877323dc1dda = {
    P: {
        color: 'inactive',
        margin: '0 0 X2',
        text: '{{ learn.install.chromeExt | polyglot }}'
    },
    Link: {
        target: '_blank',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'transparent',
        display: 'inline-block',
        href: '#',
        transition: 'opacity A defaultBezier, border A defaultBezier',
        round: 'radiusControl',
        opacity: '.9',
        ':hover': {
            opacity: '1',
            borderColor: 'inactive.25'
        },
        Img: {
            display: 'block',
            height: 'C1',
            src: 'chrome-ext.png'
        }
    }
};

});

parcelRegister("anekH", function(module, exports) {

$parcel$export(module.exports, "InstallSymbolsJson", () => $78d72b8eade06d01$export$1262c65904bd4136);
const $78d72b8eade06d01$export$1262c65904bd4136 = {
    P: {
        color: 'inactive',
        margin: '0 - Z2',
        childProps: {
            display: 'inline'
        },
        children: [
            '2. Create ',
            {
                Labeled: {
                    text: 'symbols.json'
                }
            },
            ' file in your project:'
        ]
    },
    CodePreviewWithTitle: {
        margin: 'Z1 0 0',
        Title: null,
        value: (el)=>{
            const rootState = el.getRootState?.();
            const framework = rootState?.framework === 'domql' ? 'symbols' : rootState?.framework || 'symbols';
            return `{
  "key": "${el.getAppKey?.() || 'my-app'}",
  "framework": "${framework}",
  "packageManager": "${rootState?.pkgManager || 'npm'}"
}`;
        }
    }
};

});

parcelRegister("iSjpO", function(module, exports) {

$parcel$export(module.exports, "InstallHero", () => $dbdc549c8835c07a$export$b019d98b16ad2c30);
const $dbdc549c8835c07a$export$b019d98b16ad2c30 = {
    flow: 'column',
    theme: 'headerCaptions',
    gap: 'C1',
    padding: 'D3+Z D3 0',
    margin: '-D3+Z -D3 0',
    minWidth: '100%',
    Hgroup: {
        H: {
            text: '{{ learn.install.title | polyglot }}'
        },
        P: {
            text: '{{ learn.install.subtitle | polyglot }}'
        }
    },
    'Iframe.youtube': {
        widthRange: 'G 50%',
        src: 'https://www.youtube.com/embed/QIdimVDuSEU?si=-1m28wkdUypmrI0w',
        border: '0',
        round: 'X2',
        margin: '-A -X2 -D3',
        aspectRatio: '16 / 9',
        minHeight: '0',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
        allowfullscreen: true,
        onBeforeUpdate: ()=>false
    }
};

});

parcelRegister("jz85T", function(module, exports) {

$parcel$export(module.exports, "UsersTable", () => $e3e7908214fee801$export$23b8bf72cfd1bee4);
const $e3e7908214fee801$export$23b8bf72cfd1bee4 = {
    onRender: async (el, s)=>{
        const projectMembers = await el.call('getProjectMembers');
        return s.set(projectMembers);
    },
    state: {},
    Flex_Title: {
        flow: 'x',
        align: 'center space-between',
        margin: '- - B2',
        gap: 'C1',
        Span: {
            text: '{{ members.usersTable.title | polyglot }}'
        },
        DocsLink: {
            hide: (el)=>!el.hasProjectPermission('projectSettings'),
            flow: 'x',
            align: 'center',
            gap: 'X2',
            Icon: {
                name: 'plus'
            },
            text: '{{ members.usersTable.invite | polyglot }}',
            theme: 'transparent',
            onClick: async (ev, el)=>{
                await el.call('openRouterModal', '/settings', {
                    key: '/invite'
                });
            }
        }
    },
    Flex_members: {
        flow: 'y',
        childExtends: 'Grid',
        childProps: {
            align: 'center center',
            columns: '2.2em 1fr 3fr 1fr 1.8rem',
            padding: 'Z1 0',
            gap: 'C1',
            Avatar: {
                boxSize: 'B',
                key: (el, s)=>s.name
            },
            Name: {
                margin: '- - - -C',
                Text: {
                    tag: 'span',
                    text: '{{ name }}'
                },
                Strong: {
                    hide: (el, s)=>!s.username,
                    text: ' ({{ username }})'
                }
            },
            Email: {
                text: '{{ email }}'
            },
            Role: {
                role: '{{ role }}'
            },
            IconButton_Remove: {
                hide: (el, s)=>!el.hasProjectPermission('iam') || s.role === 'owner',
                icon: 'trash',
                aria: {
                    label: (el)=>el.call('polyglot', 'members.table.removeMember')
                },
                onClick: async (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    const res = window.confirm('Do you really want to remove the User from this Project?');
                    if (res) try {
                        const rs = el.getRootState();
                        await el.sdk.removeMember(rs.projectId, s.id);
                        el.parent.remove();
                    } catch (err) {
                        console.error(err);
                    }
                }
            }
        },
        children: (el, s)=>s.parse(),
        childrenAs: 'state'
    }
};

});

parcelRegister("bgri5", function(module, exports) {

$parcel$export(module.exports, "RoleSelect", () => $83365bb1ca041447$export$f783f1f51c5374cf);
const $83365bb1ca041447$export$f783f1f51c5374cf = {
    extends: 'SelectField',
    // THE FIELD LAW (admin audit 2026-09-24, /admin/teams invite row): a field
    // is a `controlH` control. The root read min-height auto (44px only by the
    // inner select's own floor); the floor is declared here, so it holds
    // whatever the inner select does.
    minHeight: 'controlH',
    padding: '0',
    round: 'radiusPill',
    Select: {
        // No hard-coded name or id: the brand SelectField gives each select its
        // own id (3.14.796); the literal 'user' repeated on every instance.
        onChange: async (ev, el, s)=>{
            ev.preventDefault();
            ev.stopImmediatePropagation();
            const res = window.confirm('Do you really want to change the User Role for this Project?');
            if (res) try {
                const rs = el.getRootState();
                await el.sdk.updateMemberRole(rs.projectId, s.id, ev.target.value);
            } catch (err) {
                console.error(err);
            }
            else ev.target.value = s.role;
        },
        childrenAs: 'props',
        children: ()=>[
                {
                    value: 'owner',
                    text: '{{ members.role.owner | polyglot }}'
                },
                {
                    value: 'admin',
                    text: '{{ members.role.admin | polyglot }}'
                },
                {
                    value: 'editor',
                    text: '{{ members.role.editor | polyglot }}'
                },
                {
                    value: 'guest',
                    text: '{{ members.role.guest | polyglot }}'
                }
            ],
        childProps: {
            tag: 'option',
            attr: {
                disabled: (el, s)=>!el.hasProjectPermission('iam'),
                selected: (el, s)=>{
                    const userRole = s.role || -1;
                    const optionValue = el.value;
                    return userRole === optionValue;
                }
            }
        }
    }
};

});

parcelRegister("cVgHD", function(module, exports) {

$parcel$export(module.exports, "SettingsTabs", () => $9687c3b847cf6a84$export$230d78a31b14e415);
const $9687c3b847cf6a84$export$230d78a31b14e415 = {
    extends: 'TabsLinkSwitcher',
    children: (el)=>[
            el.isAdmin() && {
                href: '/project-account',
                text: el.getRootState('projectName')
            },
            el.isOwner() && {
                href: '/pricing',
                text: '{{ settings.tabs.billing | polyglot }}'
            },
            el.isEditMode() && {
                href: '/project-data',
                text: '{{ settings.tabs.data | polyglot }}'
            },
            {
                href: '/install',
                text: '{{ settings.tabs.install | polyglot }}'
            },
            el.isEditMode() && {
                href: '/project-versions',
                text: '{{ settings.tabs.versions | polyglot }}'
            },
            el.isAdmin() && {
                href: '/connect',
                text: '{{ settings.tabs.connect | polyglot }}'
            },
            el.isAdmin() && {
                href: '/shared-libs',
                text: '{{ settings.tabs.sharedLibraries | polyglot }}'
            },
            {
                href: '/settings',
                text: '{{ settings.tabs.settings | polyglot }}'
            }
        ].filter((v)=>v),
    childrenAs: 'props',
    childProps: {
        isActive: (el, s)=>s.key === el.href,
        borderStyle: 'solid',
        fontWeight: '400',
        padding: 'Z B1',
        '!isActive': {
            fontWeight: '400'
        },
        onClick: (ev, el, s)=>{
            // el.call(
            //   'openModal',
            //   '/settings',
            //   {
            //     key: el.props.href
            //   },
            //   { forced: true }
            // )
            s.update({
                key: el.href
            });
        }
    }
};

});

parcelRegister("6l5up", function(module, exports) {

$parcel$export(module.exports, "DashboardTabs", () => $49d8f6572da34e6d$export$90de4fc8eb5809e1);
const $49d8f6572da34e6d$export$90de4fc8eb5809e1 = {
    extends: 'Grid',
    templateColumns: '3fr 7fr',
    gap: 'A',
    // Adaptive (was fixed 'white') — inherited default ink for the Hgroup
    // heading/paragraph, which render on the normal adaptive document surface.
    color: 'title',
    align: 'space-between',
    round: 'radiusCard',
    minHeight: 'G1',
    '@screenM': {
        templateColumns: '2.7fr 7fr'
    },
    '@screenS': {
        templateColumns: '1fr'
    },
    Info: {
        flow: 'column',
        flex: 1,
        align: 'flex-start space-between',
        padding: '0',
        gap: 'E',
        '@screenS': {
            flow: 'row',
            padding: '- - Y -'
        },
        Hgroup: {
            width: '100%',
            padding: 'Z X2',
            H: {
                tag: 'h4',
                lineHeight: 1.2,
                margin: '0 0 X',
                fontWeight: '700',
                text: '{{ editor.dashboard.title | polyglot }}'
            },
            P: {
                maxWidth: 'G1',
                text: '{{ editor.dashboard.intro | polyglot }}'
            }
        },
        ContinueButton: {
            minWidth: 'auto',
            opacity: '1',
            margin: '0',
            gap: 'X2',
            text: '{{ editor.dashboard.gettingStarted | polyglot }}',
            href: '/init/personalize',
            transitionProperty: 'background, transform, color, background',
            theme: 'secondary',
            '@screenS': {
                alignSelf: 'flex-end'
            }
        }
    },
    Flex: {
        margin: '- - - -Z2',
        gap: 'A',
        flex: 3,
        '@screenS': {
            gap: 'A1'
        },
        '@tabletS': {
            display: 'grid',
            columns: 'repeat(3, 1fr)'
        },
        childExtends: 'ItemHighlightAlt',
        childrenAs: 'state',
        // `state` here is DOMQL's `childrenAs:'state'` wrapping for each ITEM
        // in the returned array (see smbls/packages/element/src/create.js
        // `childrenAs === 'state'`) — it has nothing to do with resolving free
        // variables inside this factory itself. This factory's own body needs
        // `el.getRootState().package` (the pattern every other package-gated
        // surface in this package uses — ProjectSection.js, YouAreConnected.js),
        // not a bare `state` — the bare read left every tile's `available`/
        // `icon`/`href` throwing `ReferenceError: state is not defined` on every
        // render (found via the tickets/fable.md CI guard, workspace-scope check
        // — packages/workspace/dist bundle, 2026-08-08).
        children: (el)=>{
            const pkg = el.getRootState().package;
            return [
                {
                    available: pkg > 1,
                    icon: pkg > 1 ? 'copywriting' : 'arrowUpRight',
                    title: 'Content',
                    href: pkg > 1 ? '/state' : '/pricing',
                    p: 'State and content database'
                },
                {
                    available: pkg > 1,
                    icon: pkg > 1 ? 'pages' : 'arrowUpRight',
                    title: 'Pages',
                    href: pkg > 1 ? '/pages' : '/pricing',
                    p: 'Pages, routes and flow of the app'
                },
                {
                    icon: 'menu outline',
                    title: 'Components',
                    href: '/components',
                    p: 'Symbols User Interface library'
                },
                {
                    icon: 'tree outline',
                    title: 'Design System',
                    href: '/design-system',
                    p: 'Design System of your brand'
                },
                {
                    available: pkg > 1,
                    icon: 'fn outline',
                    title: 'Functions',
                    href: pkg > 1 ? 'fn outline' : 'arrowUpRight',
                    p: 'Browser and data functions'
                }
            ];
        }
    }
};

});

parcelRegister("l2dag", function(module, exports) {

$parcel$export(module.exports, "IntegrationsList", () => $f503ff0fa124c8ec$export$859afb2d25dd0c2e);
const $f503ff0fa124c8ec$export$859afb2d25dd0c2e = {
    extends: 'Grid',
    height: '100%',
    width: '100%',
    padding: 'Z2 A',
    overflow: 'auto',
    overflowY: 'auto',
    templateColumns: 'repeat(4, 1fr)',
    templateRows: 'repeat(12, 1fr)',
    childrenAs: 'state',
    children: [
        {
            poster: 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iy6P.qskNVuU/v0/1200x-1.png',
            title: 'Google Maps'
        },
        {
            poster: 'https://plausible.io/docs/img/numbers-not-adding-up.png',
            title: 'Plausible Analytics'
        },
        {
            poster: 'https://images.ctfassets.net/xny2w179f4ki/79Ufvhs5lHbhgaamd7E5SO/dbce5c98feff7e3e2411155f29d668ef/Screen_Shot_2021-12-01_at_12.29_1.png',
            title: 'Intercom'
        },
        {
            poster: 'https://assets.cdn.prod.twilio.com/original_images/whats-new-in-capturing-video-feature.png',
            title: 'Twillio Video'
        },
        {
            poster: 'https://community.fabric.microsoft.com/t5/image/serverpage/image-id/109469i0FAB4D2BF0FEEBA6?v=v2',
            title: 'Twitter Feed'
        },
        {
            poster: 'https://searchengineland.com/wp-content/seloads/2011/03/facebook-like-buttons.jpg',
            title: 'Facebook Like button'
        },
        {
            poster: 'https://cdn.pixabay.com/photo/2020/03/19/13/58/youtube-4947559_1280.jpg',
            title: 'Youtube Video'
        },
        {
            poster: 'https://i.ytimg.com/vi/NooR1uqCgtg/mqdefault.jpg',
            title: 'Figma Preview'
        },
        {
            poster: 'https://res.cloudinary.com/practicaldev/image/fetch/s--CRJTTGM8--/c_imagga_scale,f_auto,fl_progressive,h_900,q_auto,w_1600/https://dev-to-uploads.s3.amazonaws.com/i/g595slgphyi9lkqz2u18.png',
            title: 'Mardown preview'
        },
        {
            poster: 'https://vimeo-blog-images.storage.googleapis.com/2022/03/Blog_-Video-Editing-on-Tiktok-and-best-Tiktok-editing-apps.png',
            title: 'Tiktok Video'
        }
    ],
    gap: 'C1',
    childExtends: 'IntegrationItem'
};

});

parcelRegister("QWd3l", function(module, exports) {

$parcel$export(module.exports, "InstallSync", () => $09f202a4dbf69052$export$7e42685671ebc8d);
const $09f202a4dbf69052$export$7e42685671ebc8d = {
    P: {
        color: 'inactive',
        margin: '0',
        text: '{{ learn.install.syncStep | polyglot }}'
    },
    Terminal: {
        width: 'fit-content',
        margin: 'A 0 Z -Y',
        value: (el)=>{
            const pkg = el.getRootState?.()?.pkgManager;
            return pkg === 'npm' ? 'npm i @symbo.ls/cli -g' : pkg === 'yarn' ? 'yarn add smbls global' : pkg === 'pnpm' ? 'pnpm add smbls global' : 'npm i @symbo.ls/cli -g';
        }
    },
    Flex: {
        gap: 'C1',
        TerminalWithTitle_fetch: {
            margin: 'A - -',
            Title: {
                text: '{{ learn.install.oneTimeFetch | polyglot }}'
            },
            Terminal: {
                margin: '0 0 0 -Y',
                value: 'smbls fetch'
            }
        },
        TerminalWithTitle_sync: {
            margin: 'A - -',
            Title: {
                text: '{{ learn.install.listenChanges | polyglot }}'
            },
            Terminal: {
                margin: '0 0 0 -Y',
                value: 'smbls sync'
            }
        }
    }
};

});

parcelRegister("9Y2Gx", function(module, exports) {

$parcel$export(module.exports, "ServerPreview", () => $741bccdf21ee3e9e$export$e1a41130dda87857);
const $741bccdf21ee3e9e$export$e1a41130dda87857 = {
    flow: 'column',
    align: 'center space-between',
    gap: 'B',
    round: 'radiusControl',
    padding: 'Z2 A1',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    theme: 'common-card-outline',
    SectionHeader: {
        margin: '0',
        padding: '0',
        title: (el)=>el.call('polyglot', 'publish.envs.development')
    }
};

});

parcelRegister("lacrQ", function(module, exports) {

$parcel$export(module.exports, "IntegrationItem", () => $f684301675b75b91$export$28ffd0d8a8abd470);
const $f684301675b75b91$export$28ffd0d8a8abd470 = {
    extends: [
        'Flex',
        'Link'
    ],
    position: 'relative',
    href: '/playground',
    fontWeight: 'bold',
    overflow: 'hidden',
    flexDirection: 'column',
    width: '100%',
    height: 'F2',
    padding: '0 Z 0 A2',
    round: 'radiusControl',
    // Border habit removed (design-direction.md §8) — the poster image IS the
    // tile's own fill, and IntegrationsList's `gap: 'C1'` grid already gives
    // every tile generous whitespace separation; no stroke needed.
    background: ({ state: state })=>`url(${state.poster}) center center no-repeat`,
    backgroundSize: 'cover',
    ':after, :before': {
        content: '""',
        position: 'absolute',
        inset: '0 0 0 0',
        transition: 'B defaultBezier',
        transitionProperty: 'opacity',
        background: 'shadow-overlay',
        zIndex: 1
    },
    Title: {
        // Reviewed (fixed-colour sweep): kept — this label floats over an
        // arbitrary poster image (`background: url(state.poster)` above), so its
        // backing plate (`gray1.65`) must stay a fixed dark scrim regardless of
        // app theme; the paired text stays fixed to match (case 1: badge over
        // arbitrary imagery).
        color: 'gray8',
        fontWeight: 400,
        position: 'absolute',
        inset: 'auto 0 0 0',
        padding: 'Z A Z2',
        background: 'gray1.65',
        boxShadow: '0 0 35px gray1',
        zIndex: 2,
        text: '{{ title }}'
    }
};

});

parcelRegister("dKynU", function(module, exports) {

$parcel$export(module.exports, "SettingsFooter", () => $a02a3e4fee38991b$export$263308e70c82876f);
const $a02a3e4fee38991b$export$263308e70c82876f = {
    ContinueButton: {
        show: (el)=>!el.getUserSettings('autoSaveSettings'),
        hide: (el)=>el.getUserSettings('autoSaveSettings'),
        text: '{{ settings.footer.update | polyglot }}',
        onClick: async (ev, el)=>{
            await el.call('closeRouterModal');
            const Canvas = el.getCanvas();
            Canvas.Iframe.update();
            el.getEditorPanels()?.update();
            el.call('openNotification', {
                title: el.call('polyglot', 'settings.footer.saved.title'),
                message: el.call('polyglot', 'settings.footer.saved.message'),
                type: 'success'
            });
        }
    },
    CheckboxField: {
        margin: '- auto - -',
        checked: (el)=>el.getUserSettings('autoSaveSettings'),
        onChange: (ev, el)=>{
            el.setUserSettings('autoSaveSettings', Boolean(ev.target.checked));
            el.parent.update();
        },
        Icon: {},
        Span: {
            text: '{{ settings.footer.autoUpdate | polyglot }}'
        }
    },
    Flex: {
        gap: 'B2',
        // 6 text-link buttons in one unwrapped row is wider than any narrow
        // host (a settings drawer, a catalog cell) — reflow onto multiple
        // lines instead of forcing the footer wider than its container.
        wrap: 'wrap',
        childExtends: [
            'IconText',
            'DocsLink'
        ],
        // SIZE-1 item 4 remainder (tickets/sonnet.md, WAVE-G, 2026-08-14/15):
        // neither `IconText` (framework built-in) nor brand's `DocsLink` sets
        // any padding/minHeight, so all 6 rows measured 17px tall — exactly
        // text-glyph height, under the touch/click comfortable floor. One
        // `childProps` entry covers all 6 uniformly rather than repeating the
        // fix per child. Same two-tier token family the chat-lane pass used for
        // the identical "small inline click target" shape this same sweep
        // (workspace a986e7ee, ChatSidebarMore): `iconLg` (24px) unconditional,
        // `controlH` (44px, Apple HIG) added under `'@coarse'` for touch.
        childProps: {
            padding: 'V W',
            minHeight: 'iconLg',
            '@coarse': {
                minHeight: 'controlH'
            }
        },
        ConvertToDomql3: {
            color: 'inactive',
            text: '{{ settings.footer.convertDomql3 | polyglot }}',
            onClick: async (ev, el)=>{
                await el.convertToDomql3();
            }
        },
        RestoreTypes: {
            color: 'inactive',
            text: '{{ settings.footer.restoreTypes | polyglot }}',
            onClick: async (ev, el)=>{
                await el.restoreMissingTypes();
            }
        },
        RestoreComponents: {
            color: 'inactive',
            text: '{{ settings.footer.restoreComponents | polyglot }}',
            onClick: async (ev, el)=>{
                await el.restoreMissingComponents();
            }
        },
        ResetSettings: {
            color: 'inactive',
            text: '{{ settings.footer.resetSettings | polyglot }}',
            onClick: (ev, el)=>{
                el.setAllUserSettings({
                    optimizedMode: false,
                    thumbnailPreview: false,
                    allowInitialSelection: false,
                    openOnDblClick: true,
                    showGrid: true,
                    allowTabs: true,
                    allowZoombar: true,
                    allowAutoPosition: true,
                    allowTabPreview: true,
                    useAnimations: true
                }, {
                    message: 'Reset settings'
                });
            }
        },
        ClearCookies: {
            color: 'inactive',
            text: '{{ settings.footer.cleanCookies | polyglot }}',
            onClick: (ev, el)=>{
                el.call('removeCookie', 'topNavbarActive');
                el.call('removeCookie', 'bottomNavbarActive');
                el.call('removeCookie', 'globalTheme');
                el.call('removeCookie', 'sceneTheme');
                el.call('removeCookie', 'globalTheme');
                el.call('removeCookie', 'framework');
                el.call('removeCookie', 'pkgManager');
                el.call('removeCookie', 'language');
                el.call('removeCookie', 'activeProject');
                el.call('removeCookie', 'installTab');
                el.call('removeCookie', 'isSidebarSticky');
                el.call('removeCookie', 'componentShowFilter');
                el.call('removeCookie', 'navbarPlacement');
                el.call('removeCookie', 'presentMode');
                el.call('removeCookie', 'showErrorBanner');
                el.call('removeCookie', 'thumbnailPreview');
                el.call('removeCookie', 'optimizedMode');
                el.call('removeCookie', 'showGrid');
                el.call('removeCookie', 'explorerAutoscroll');
                el.call('removeCookie', 'debuggingMode');
                el.call('removeCookie', 'allowCanvasReplaceRouter');
                el.call('removeCookie', 'useDomql3');
                el.call('removeCookie', 'useGlassmorphism');
                el.call('removeCookie', 'allowAutoPosition');
                el.call('removeCookie', 'allowInitialSelection');
                el.call('removeCookie', 'openOnDblClick');
                el.call('removeCookie', 'allowTabs');
                el.call('removeCookie', 'showReferences');
                el.call('removeCookie', 'allowTeamCursors');
                el.call('removeCookie', 'allowFilesidebarPreview');
                el.call('removeCookie', 'allowTabPreview');
                el.call('removeCookie', 'useAnimations');
                el.call('removeCookie', 'allowZoombar');
                el.call('removeCookie', 'previewSize');
                el.call('removeCookie', 'zoomLevel');
                el.call('removeCookie', 'userId');
                el.call('removeCookie', 'name');
                el.call('removeCookie', 'email');
                el.call('openNotification', {
                    title: el.call('polyglot', 'settings.footer.cookiesCleared.title'),
                    message: el.call('polyglot', 'settings.footer.cookiesCleared.message'),
                    type: 'success'
                });
            }
        },
        ClearCache: {
            color: 'inactive',
            text: '{{ settings.footer.cleanCache | polyglot }}',
            fontWeight: 400,
            onClick: async (ev, el)=>{
                await el.clearCache();
            }
        }
    },
    flow: 'x',
    gap: 'B2',
    margin: 'A2 -X2 B2',
    align: 'center space-between',
    // Three top-level groups (ContinueButton / CheckboxField / the link Flex)
    // side by side with no wrap policy forced this row wider than its
    // container whenever the link group above already needed a second line.
    wrap: 'wrap'
};

});

parcelRegister("6FHpI", function(module, exports) {

$parcel$export(module.exports, "ProjectSection", () => $0140e83fe22c6635$export$df6d31f85b3648aa);
const $0140e83fe22c6635$export$df6d31f85b3648aa = {
    extends: 'Grid',
    childExtends: 'ProjectInfo',
    templateColumns: (el)=>el.getRootState().package > 1 ? '5fr 2fr' : '1fr',
    gap: 'A',
    align: 'stretch flex-start',
    Stats: {
        Title: {
            text: '{{ editor.project.company | polyglot }}'
        },
        ItemPreview: {
            gap: 'B',
            align: 'flex-start space-between',
            Strong: {
                margin: 'W - -',
                text: '{{ title }}'
            },
            Grid: {
                templateColumns: '2fr 1fr 1fr 1fr',
                width: '100%',
                childExtends: {
                    extends: 'Hgroup',
                    margin: '0',
                    H: {
                        tag: 'strong',
                        text: '{{ title }}'
                    },
                    P: {
                        text: (el, s)=>el.call('polyglot', s.p || '')
                    }
                },
                children: (el)=>[
                        {
                            title: el.call('polyglot', el.getRootState().package > 1 ? 'editor.project.premium' : 'editor.project.starter'),
                            p: 'editor.project.packageLabel'
                        },
                        {
                            title: `1.${el.getRootState().version}`,
                            p: 'editor.addDependency.version'
                        },
                        {
                            title: el.getRootState().versionscount,
                            p: 'editor.project.publishes'
                        },
                        {
                            title: el.call('formatDate', el.getRootState().createdAt),
                            p: 'editor.project.userSince'
                        }
                    ],
                childrenAs: 'state'
            }
        }
    },
    Team: {
        Title: {
            text: '{{ shell.app.team | polyglot }}'
        },
        ItemPreview: {
            AvatarBundle: {
                extends: 'AvatarBundle',
                fontSize: 'Y2',
                options: (el, s)=>{
                    const projectUsers = el.getRootProjectsUsers();
                    const filtered = el.call('isArray', projectUsers) ? projectUsers.filter((v)=>(v.role || 0) > -1) : projectUsers;
                    return filtered?.filter((v)=>!v.email?.endsWith('@symbo')).map((v)=>({
                            key: v.name,
                            title: v.name
                        }));
                },
                childProps: {
                    ':not(:last-child)': {
                        margin: '0 -Z 0 0'
                    }
                }
            },
            SectionHeader_last_connected: {
                margin: '0',
                title: (el)=>{
                    const projectUsers = el.getRootProjectsUsers();
                    const usersCount = projectUsers?.filter((v)=>(v.role || 0) > -1).length;
                    return `${usersCount} members`;
                },
                p: (el)=>{
                    const projectUsers = el.getRootProjectsUsers();
                    const usersCount = projectUsers?.filter((v)=>(v.role || 0) > -1).length;
                    const left = 5 - usersCount < 0 ? 0 : usersCount;
                    return el.call('polyglot', 'editor.project.inviteLeft').replace('{count}', left);
                }
            }
        }
    }
};

});

parcelRegister("2i7tj", function(module, exports) {

$parcel$export(module.exports, "ProjectInfo", () => $1ab30eefe80d5e1a$export$a1c9a67310a2d004);
const $1ab30eefe80d5e1a$export$a1c9a67310a2d004 = {
    extends: 'Group',
    tag: 'section',
    gap: 'Z',
    Title: {
        text: '{{ editor.connection.connected | polyglot }}',
        width: '100%'
    },
    ItemPreview: {
        flex: 1,
        templateColumns: 'repeat(12, 1fr)',
        autoFlow: 'dense',
        autoColumns: 'auto',
        autoRows: 'auto',
        justifyItems: 'stretch',
        position: 'relative',
        transition: 'C defaultBezier max-height'
    }
};

});

parcelRegister("9lJSC", function(module, exports) {

$parcel$export(module.exports, "SignupForm", () => $6ce9aa04e8c57784$export$cc15cfe224a6a69b);
const $6ce9aa04e8c57784$export$cc15cfe224a6a69b = {
    flow: 'column',
    gap: 'A',
    flex: '1',
    '@mobileL': {
        minWidth: '100%'
    },
    childExtends: 'InputField',
    childProps: {
        width: '100%',
        '@mobileL': {
            maxWidth: '100%'
        },
        Title: {
            tag: 'span'
        },
        Input: {
            width: '100%',
            theme: 'field',
            background: 'hover',
            minHeight: 'controlH',
            round: 'radiusControl',
            fontSize: 'Z2',
            padding: '0 A',
            onInput: (ev, el, s)=>{
                s.update({
                    [el.parent.key.toLowerCase()]: el.node.value
                });
            }
        }
    },
    Email: {
        Title: {
            text: '{{ auth.signup.email | polyglot }}',
            padding: '- - 0'
        },
        Input: {
            autofocus: true,
            autocomplete: 'email',
            name: 'email',
            ariaLabel: (el)=>el.call('polyglot', 'auth.signup.email'),
            autocapitalize: 'none',
            spellcheck: false,
            required: true,
            type: 'email',
            value: (el, s)=>s.email || '',
            // A white-label host never shows the platform's own address as the
            // example (it named symbo.ls on a tenant's signup).
            placeholder: (el, s)=>el.call('polyglot', s && s.root && s.root.whitelabelBrand ? 'auth.whitelabel.emailPlaceholder' : 'auth.signup.emailPlaceholder'),
            disabled: (el, s)=>!!s.hasToken
        }
    },
    Name: {
        Title: {
            text: '{{ auth.signup.name | polyglot }}',
            padding: '- - 0'
        },
        Input: {
            autocomplete: 'name',
            name: 'name',
            ariaLabel: (el)=>el.call('polyglot', 'auth.signup.name'),
            required: true,
            value: (el, s)=>s.name || '',
            placeholder: (el)=>el.call('polyglot', 'auth.signup.namePlaceholder'),
            type: 'text'
        }
    },
    Password: {
        Title: {
            text: '{{ auth.signup.password | polyglot }}',
            padding: '- - 0'
        },
        Input: {
            autocomplete: 'new-password',
            name: 'password',
            ariaLabel: (el)=>el.call('polyglot', 'auth.signup.password'),
            value: (el, s)=>s.password || '',
            placeholder: (el)=>el.call('polyglot', 'auth.signup.password'),
            required: true,
            type: 'password',
            onInput: (ev, el, s)=>{
                // Typing again withdraws a refusal the page printed for the old
                // password (`passwordRefused` is the sign-up page's own key — written
                // only when it is set, so a host that never declared it is left alone).
                s.update(s.passwordRefused ? {
                    password: el.node.value,
                    passwordRefused: false
                } : {
                    password: el.node.value
                });
            }
        }
    },
    ModalFooter: {
        // A div, not the label `childExtends: 'InputField'` makes of it: a label
        // forwards a click on ANY text beside its button to that button, so the
        // links and lines a page puts under the button (the sign-up page's "Sign
        // in" and legal links) would submit the form when pressed.
        tag: 'div',
        // White-label host: flush with the fields (the brand footer's '0 -X'
        // bleed is a modal affordance; on the branded card it set the button
        // off the field edges).
        isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
        '.isBranded': {
            margin: '0',
            padding: 'Z 0 0'
        },
        padding: 'B1 - - -',
        CheckButton: {
            // White-label host: the tenant accent (inert on the platform).
            extends: [
                'WhitelabelAccent',
                'CheckButton'
            ],
            text: (el, s)=>el.call('polyglot', s.loading ? 'auth.signup.creating' : 'auth.signup.submit'),
            disabled: (el, s)=>!!s.loading,
            opacity: (el, s)=>s.loading ? '.7' : '1',
            cursor: (el, s)=>s.loading ? 'wait' : 'pointer',
            pointerEvents: (el, s)=>s.loading ? 'none' : 'auto',
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2',
            fontWeight: '700',
            type: 'submit',
            icon: null
        },
        Title: null,
        Input: null
    }
};

});

parcelRegister("1zLpu", function(module, exports) {

$parcel$export(module.exports, "SignupLink", () => $125dd5fbddfc96ea$export$f912c6ea1b2b0dfb);
// SignupLink — a quiet text link under the sign-up button: "Sign in" for an
// existing account, the privacy policy, the terms. The caption ink, UNDERLINED
// (a link is never colour alone, persona elena at 150% zoom), the title ink on
// hover and press. The house focus ring comes from the brand reset
// (`a:focus-visible`), and on a touch screen the hit area is the 44pt floor —
// the sign-in page's own text link carries the same one.
//
//   SignupLink_privacy: { href: …, text: … }   // the key's prefix names this component
//
// Rule 65: every state is declared here, on the primitive, never at a call site.
//
// THE TOUCH FLOOR is `touchFloor` of components/_touchTarget.js (read it for the
// why: an `:after` hit area at least `controlH` square, centred on the link, so
// the link's own box and the layout never change). It is written out here because
// frank-audit FA001 forbids a sibling import in a component file; the two are
// pinned equal by __tests__/signupPageAudit.test.js, so they cannot drift.
const $125dd5fbddfc96ea$export$f912c6ea1b2b0dfb = {
    extends: 'Link',
    color: 'caption',
    fontWeight: '400',
    textDecoration: 'underline',
    ':hover': {
        color: 'title'
    },
    ':active': {
        color: 'title'
    },
    '@coarse': {
        position: 'relative',
        ':after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100%',
            height: '100%',
            minWidth: 'controlH',
            minHeight: 'controlH',
            transform: 'translate(-50%, -50%)'
        }
    }
};

});

parcelRegister("5b7A3", function(module, exports) {

$parcel$export(module.exports, "LoginForm", () => $3c53dc24d9f8b486$export$1f58f750f20f344b);

var $9GdJK = parcelRequire("9GdJK");
const $3c53dc24d9f8b486$export$1f58f750f20f344b = {
    flow: 'column',
    height: '100%',
    gap: 'C1',
    '@tabletS': {
        height: 'unset',
        align: 'stretch flex-start',
        width: '100%'
    },
    '@mobileL': {
        height: 'unset',
        align: 'stretch flex-start',
        width: '100%'
    },
    Flex: {
        gap: 'Z',
        flow: 'column',
        width: '100%',
        maxWidth: '100%',
        childProps: {
            width: '100%',
            '@tabletS': {
                maxWidth: '100%',
                align: 'stretch',
                width: '100%'
            },
            '@mobileL': {
                maxWidth: '100%',
                align: 'stretch',
                width: '100%'
            }
        },
        Title: null,
        Input: null,
        Identifier: {
            flow: 'column',
            align: 'stretch flex-start',
            gap: 'Y',
            width: '100%',
            '@mobileL': {
                width: '100%'
            },
            Title: {
                tag: 'span',
                text: '{{ auth.login.emailOrUsername | polyglot }}',
                padding: '0',
                width: '100%',
                minWidth: '0',
                lineHeight: '1.25',
                '@mobileL': {
                    padding: '0',
                    width: '100%',
                    minWidth: '0',
                    lineHeight: '1.25'
                }
            },
            Input: {
                // Mirror every keystroke into LoginWindow state via onInput.
                // We do NOT bind `value: (el, s) => s.identifier` — that
                // factory re-rendered the input on every state change and
                // raced with native typing, intermittently clearing the field.
                // Mirroring out via onInput keeps state in sync for the submit
                // handler to read, without ever writing input.value back from
                // state (so the browser owns the live input).
                // Playwright smoke harness binds via this exact string —
                // qa-automation/pages/signin.page.ts emailInput.
                'data-testid': 'content.LoginWindow.Flex.Identifier.Input',
                minHeight: 'controlH',
                width: '100%',
                theme: 'field',
                background: 'hover',
                type: 'text',
                name: 'username',
                ariaLabel: (el)=>el.call('polyglot', 'auth.login.emailOrUsername'),
                required: true,
                autocapitalize: 'none',
                spellcheck: false,
                autocomplete: 'username',
                placeholder: (el)=>el.call('polyglot', 'auth.login.emailOrUsernamePlaceholder'),
                round: 'radiusControl',
                fontSize: 'Z2',
                padding: '0 A',
                '@tabletS': {
                    flex: '1 1 auto',
                    minWidth: '0',
                    width: '100%'
                },
                '@mobileL': {
                    flex: '1 1 auto',
                    minWidth: '0',
                    width: '100%'
                },
                onInput: (ev, el, s)=>{
                    s.update({
                        identifier: el.node.value
                    });
                }
            }
        },
        Password: {
            flow: 'column',
            align: 'stretch flex-start',
            gap: 'Y',
            width: '100%',
            '@mobileL': {
                width: '100%'
            },
            Title: {
                tag: 'span',
                text: '{{ auth.login.password | polyglot }}',
                padding: '0',
                width: '100%',
                minWidth: '0',
                lineHeight: '1.25',
                '@mobileL': {
                    padding: '0',
                    width: '100%',
                    minWidth: '0',
                    lineHeight: '1.25'
                }
            },
            Input: {
                // Same one-way mirror as Identifier — see note above. The
                // password mirror is doubly important: Chrome's password
                // manager clears the field at form submission time as a
                // privacy measure, so reading `input.value` inside the
                // submit handler returns '' even though the user typed.
                // Reading from `s.password` (captured at typing time) is
                // the only reliable path.
                // Playwright smoke harness binds via this exact string —
                // qa-automation/pages/signin.page.ts passwordInput.
                'data-testid': 'content.LoginWindow.Flex.Password.Input',
                minHeight: 'controlH',
                width: '100%',
                theme: 'field',
                background: 'hover',
                autocomplete: 'current-password',
                name: 'password',
                ariaLabel: (el)=>el.call('polyglot', 'auth.login.password'),
                required: true,
                placeholder: (el)=>el.call('polyglot', 'auth.login.password'),
                type: 'password',
                round: 'radiusControl',
                fontSize: 'Z2',
                padding: '0 A',
                '@tabletS': {
                    flex: '1 1 auto',
                    minWidth: '0',
                    width: '100%'
                },
                '@mobileL': {
                    flex: '1 1 auto',
                    minWidth: '0',
                    width: '100%'
                },
                onInput: (ev, el, s)=>{
                    s.update({
                        password: el.node.value
                    });
                }
            }
        }
    },
    ModalFooter: {
        display: 'flex',
        flow: 'row',
        width: '100%',
        maxWidth: 'unset',
        align: 'center space-between',
        gap: 'Z',
        '@tabletS': {
            childProps: {
                width: '100%'
            }
        },
        '@mobileL': {
            flow: 'column',
            gap: 'Z',
            childProps: {
                width: '100%'
            }
        },
        CheckButton: {
            // Playwright smoke harness binds via this exact string —
            // qa-automation/pages/signin.page.ts submitButton.
            'data-testid': 'content.LoginWindow.Flex.ModalFooter.CheckButton',
            // Static label: the LoadingGifSection overlay (in LoginWindow) is the
            // loading affordance. A loading-conditional label ('Sign in' →
            // 'Signing in…') widened this fit-content button, and since LoginWindow
            // is boxSize:auto the whole card grew on submit (the layout shift).
            text: '{{ auth.login.submit | polyglot }}',
            disabled: (el, s)=>!!s.loading,
            opacity: (el, s)=>s.loading ? '.7' : '1',
            cursor: (el, s)=>s.loading ? 'wait' : 'pointer',
            pointerEvents: (el, s)=>s.loading ? 'none' : 'auto',
            type: 'submit',
            Icon: null,
            width: 'fit-content',
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2',
            fontWeight: '700',
            '@tabletS': {
                width: '100%',
                maxWidth: '100%'
            },
            '@mobileL': {
                width: '100%',
                maxWidth: '100%'
            }
        },
        Title: null,
        Input: null,
        DocsLink: {
            margin: '- - - auto',
            fontSize: 'Z2',
            fontWeight: '400',
            color: 'caption',
            href: '/reset-password',
            text: '{{ auth.login.forgot | polyglot }}',
            display: 'flex',
            align: 'center center',
            // A finger's target: the link is 20-23px tall (WebKit, iPhone / iPad
            // emulation of dev /signin, DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1) — the
            // 44pt floor (_touchTarget.js).
            '@coarse': {
                position: 'relative',
                ...(0, $9GdJK.touchFloor)
            }
        }
    }
};

});

parcelRegister("QpQpJ", function(module, exports) {

$parcel$export(module.exports, "ItemPreview", () => $09d8e799c9cea38c$export$5f817064d72b5431);
const $09d8e799c9cea38c$export$5f817064d72b5431 = {
    extends: [
        'Flex',
        'Link'
    ],
    flow: 'column',
    align: 'space-between flex-start',
    gap: 'C2',
    round: 'radiusControl',
    padding: 'A1 A1',
    whiteSpace: 'nowrap',
    href: (el)=>{
        const key = el.getAppKey();
        return key ? '/account/' + key.split('.')[0] : null;
    },
    transition: 'A defaultBezier',
    transitionProperty: 'background, box-shadow',
    // `common-card-outline-interactive` is retired (DESIGN_LANGUAGE §2.4 —
    // alias `card`; -interactive variants replaced by the §4.3 washes) and
    // carried a raw '2px' outline on top. Card outlines are banned
    // (design-direction.md §8) — an opaque `card` fill plus a lift on hover
    // (§2.3 `float`) is the prescribed interactive-card treatment, same as
    // tickets/Cards.js.
    theme: 'card',
    ':hover': {
        shadow: 'float'
    },
    fontWeight: '400'
};

});

parcelRegister("53EEE", function(module, exports) {

$parcel$export(module.exports, "WaitlistForm", () => $3aecc4b51b9a3d7d$export$c214714ed8e35309);
const $3aecc4b51b9a3d7d$export$c214714ed8e35309 = {
    flow: 'column',
    gap: 'B1',
    flex: '1',
    childProps: {
        value: (el, s)=>s[el.key.toLowerCase()],
        fontSize: 'A2',
        padding: 'Z1 A2',
        width: '100%',
        maxWidth: 'G',
        onChange: (ev, el, s)=>{
            s.update({
                [el.key.toLowerCase()]: el.node.value
            });
        }
    },
    childExtends: 'Input',
    Name: {
        placeholder: (el)=>el.call('polyglot', 'auth.waitlist.namePlaceholder'),
        required: true
    },
    Email: {
        placeholder: (el)=>el.call('polyglot', 'auth.waitlist.emailPlaceholder'),
        required: true,
        type: 'email'
    }
};

});

parcelRegister("boLZC", function(module, exports) {

$parcel$export(module.exports, "RequestAccessButtons", () => $84c729f74c1749e8$export$cb65862e7b9e8f70);
const $84c729f74c1749e8$export$cb65862e7b9e8f70 = {
    flow: 'y',
    align: 'start start',
    // Fill-contrast column divider (was a left-edge `line` border — border-
    // habit sweep, design-direction.md §8) separating this OAuth column from
    // the email/password form beside it in LoginWindow's two-column Flex.
    background: 'overlay',
    margin: '0',
    '@media (max-width: 500px)': {
        // Stacked single-column layout on mobile — no sibling column to
        // separate from, so no fill either (matches the original border's
        // desktop-only intent).
        background: 'transparent',
        padding: 'A 0 0',
        align: 'center flex-start'
    },
    childProps: {
        width: '100%'
    },
    Hgroup: {
        H: {
            tag: 'strong',
            text: '{{ members.requestAccess.title | polyglot }}'
        },
        P: {
            text: '{{ members.requestAccess.body | polyglot }}'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A2',
        '@media (max-width: 500px)': {
            gap: 'Z'
        },
        Link: {
            extends: [
                'Link',
                'Button'
            ],
            icon: 'email',
            Icon: {
                order: '-1'
            },
            margin: '0 0 0 -X',
            theme: 'quaternary',
            // Adaptive (was fixed 'white') — `theme: 'quaternary'` already supplies
            // its own paired text color; the fixed override defeated it and went
            // invisible against quaternary's near-white light-mode background.
            color: 'title',
            fontWeight: '500',
            text: '{{ members.requestAccess.continueEmail | polyglot }}',
            href: '/signin',
            gap: 'Z',
            '@tabletS': {
                align: 'center center',
                fontSize: 'Z1',
                margin: '0',
                maxWidth: '100%',
                padding: 'Z1 A',
                width: '100%'
            },
            '@media (max-width: 500px)': {
                align: 'center center',
                maxWidth: '100%',
                textAlign: 'center',
                border: 'none'
            },
            '@mobileM': {
                fontSize: 'Y'
            }
        }
    }
};

});

parcelRegister("722a7", function(module, exports) {

$parcel$export(module.exports, "InviteForm", () => $51ea65ab15330009$export$b8c329f2c3642723);
const $51ea65ab15330009$export$b8c329f2c3642723 = {
    flow: 'column',
    gap: 'B1',
    flex: '1',
    childProps: {
        Input: {
            margin: '- -Z'
        }
    },
    'InputField.name': {
        Title: {
            text: '{{ members.inviteForm.fullName | polyglot }}'
        },
        Input: {
            value: '{{ name }}',
            required: true,
            placeholder: 'Mike',
            onInput: (ev, el, s)=>{
                const [, key] = el.parent.key.split('.');
                s.update({
                    [key]: el.node.value
                });
            }
        }
    },
    'InputField.email': {
        Title: {
            text: '{{ members.inviteForm.emailOfMember | polyglot }}'
        },
        Input: {
            value: '{{ email }}',
            required: true,
            placeholder: 'mike@me.com',
            pattern: '^[^s@]+@[^s@]+.[^s@]{2,}$',
            type: 'email',
            onInput: (ev, el, s)=>{
                const [, key] = el.parent.key.split('.');
                s.update({
                    [key]: el.node.value
                });
            }
        }
    },
    Flex: {
        extends: 'GroupField',
        Title: {
            text: '{{ members.inviteForm.roleOfMember | polyglot }}'
        },
        'SelectRoleField.role': {
            margin: '- -Z',
            Select: {
                value: '{{ role }}',
                required: true,
                onChange: (ev, el, s)=>{
                    const [, key] = el.parent.key.split('.');
                    s.update({
                        [key]: el.node.value
                    });
                },
                onRender: (el, s)=>{
                    const [, key] = el.parent.key.split('.');
                    s.update({
                        [key]: 'guest'
                    });
                }
            }
        },
        Input: {
            display: 'none'
        }
    }
};

});

parcelRegister("9cXQa", function(module, exports) {

$parcel$export(module.exports, "LoginWindow", () => $6b43a7142b6a2848$export$e2c4df1c67a59cff);
// LoginWindow — modal-style auth chrome reused across signin / signup /
// reset-password pages. Hosts the email/password form (LoginForm /
// SignupForm / ResetEmailForm via slot replacement) plus the Google +
// GitHub OAuth buttons.
//
// OAuth path: routes through the SYMBOLS SDK (MongoDB-backed), same as
// the email/password path — `el.sdk.googleAuth(idToken)` and
// `el.sdk.githubAuth(code)`. Identical to the legacy editor behavior.
// We do NOT route through Supabase here; the federated Supabase
// session is minted later as a fan-out from the SDK login on
// email/password (see signin.js _fanOutBridgeLogin), and OAuth users
// pick up Supabase via their first authenticated workspace request
// hitting the bridge — not via the OAuth handshake itself.
//
// Google: Google Identity Services One Tap embedded inline. The
// gsi/client script is loaded by index.html so `window.google` is
// available; `onInit` initializes with the env client id and `onClick`
// triggers the One Tap prompt. Google calls back into our credential
// handler with an ID token, which we hand to `el.sdk.googleAuth`.
//
// GitHub: classic OAuth redirect. Click → store invite token in
// localStorage (since the OAuth round-trip strips arbitrary query
// params) → top-level navigate to GitHub. The provider redirects back
// to `/github-auth-callback?code=…` which calls `el.sdk.githubAuth`
// to mint the Symbols SDK session.
//
// Native shell (Tauri WKWebView, isNativeShell()): NO Google path can work
// embedded — FedCM/One Tap is unavailable in WKWebView, the shell drops the
// code-client's `window.open` popup, and Google policy rejects OAuth from
// embedded webviews outright ("disallowed_useragent"). So in-shell we skip
// ALL GIS wiring and instead run OAuth in the SYSTEM browser with a
// `symbols://auth-callback` deep link back (tickets/ipad.md): onRender
// arms the deep-link entry paths + feature-detects the server exchange
// route (ensureNativeGoogleAuth → s.nativeAuthReady), and onClick hands
// the redirect-flow URL to the system browser (launchNativeGoogleAuth).
// When the server predates the flow (probe 404s) the shipped guard stays:
// button disabled with the reason rendered inline (P_nativeShellNotice) —
// email/password + magic-link remain the fallback path. Every shell branch
// is gated on isNativeShell(); the web path is untouched when it returns
// false.

var $klqGv = parcelRequire("klqGv");

var $e2Fqo = parcelRequire("e2Fqo");
const $6b43a7142b6a2848$export$e2c4df1c67a59cff = {
    extends: 'ModalWindow',
    // FA204 / frank trap — `completeGoogleLogin` used to be a bare module-scope
    // async function read from inside two `onClick`/callback closures (a
    // serialized factory). It read as undefined once this component was
    // frank.toJSON'd for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called via
    // `el.scope.completeGoogleLogin(...)`.
    scope: {
        // Shared post-credential flow for BOTH Google paths (One Tap id-token and
        // the explicit OAuth code-client): hydrate the SDK session, then route to
        // the post-OAuth `next`.
        async completeGoogleLogin (el, s, loginResult) {
            await el.call('initializeUserSession', {
                loginData: loginResult
            });
            let next = (0, $klqGv.consumeOAuthNext)(new URL(window.location.href).searchParams.get('next'));
            // SIGNUP-INTENT — a paid plan picked on symbols.app/built-with opens its
            // checkout once, unless the sign-in already had a destination.
            if (next === '/') next = el.call('takeSignupCheckoutNext') || next;
            s.update({
                loading: false
            });
            el.router(next, el.getRoot());
        }
    },
    tag: 'form',
    ariaBusy: (el, s)=>!!s.loading,
    // ModalWindow declares `state: {}` (empty) which gives LoginWindow its
    // own isolated state. Initialize `loading` here so reactive bindings
    // (LoadingGifSection overlay + CheckButton opacity/text/cursor in
    // LoginForm/SignupForm/ResetEmailForm/ResetPasswordsForm) register the
    // dep at first render — without `loading: false` here, DOMQL's signal
    // tracker may skip the dep on undefined reads and never re-render when
    // onSubmit later sets `s.update({ loading: true })`.
    // `nativeAuthReady` — native shell only: flips true once
    // ensureNativeGoogleAuth's probe confirms the server carries the
    // deep-link exchange route; initialized here so the Google button's
    // reactive disabled/cursor/opacity factories register the dep.
    state: {
        loading: false,
        identifier: '',
        password: '',
        nativeAuthReady: false
    },
    // AUTH-WIPE-1 (c) — the VISIBLE STOP for the dev-infra case (Nika's third
    // condition). bootShell routes a signature-class 401 on the LOCAL channel
    // into its soft path: auth storage is KEPT and nothing is purged, but the
    // user still lands here, which is indistinguishable from an ordinary
    // sign-out. Without this notice they retype credentials that were never the
    // problem. `?authInfra=dev_signature` is set ONLY on the local channel, so
    // every other host reaches this component unchanged.
    onRender: (el, s)=>{
        if (typeof window === 'undefined') return;
        // Idempotency guard — onRender can fire twice in dev under HMR
        // (same guard as pages/auth/callback.js).
        if (s.authInfraNoticeShown) return;
        const url = new URL(window.location.href);
        if (url.searchParams.get('authInfra') !== 'dev_signature') return;
        s.update({
            authInfraNoticeShown: true
        });
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.login.devApi.title'),
            message: el.call('polyglot', 'auth.login.devApi.message'),
            type: 'error'
        });
    },
    // Bypass HTML5 native validation. The signin/signup/reset-password
    // pages all run their own field validation inside `onSubmit` and
    // surface errors via `openNotification` — letting the browser's
    // native `:invalid` interception block the submit event silently is
    // a footgun (it never reaches onSubmit, so users see nothing happen
    // when they click Sign in). Setting `novalidate` here means the
    // submit event ALWAYS fires; pages own validation end-to-end.
    novalidate: true,
    overflow: 'visible',
    position: 'relative',
    transform: 'none',
    top: 'auto',
    left: 'auto',
    flow: 'column',
    // flex-start (not space-between): with minHeight pinning the box,
    // space-between stretched the slack into a large gap between the
    // header and the form sections (2026-06-06 per Nika).
    align: 'flex-start flex-start',
    height: 'auto',
    width: 'I1',
    maxWidth: '100%',
    margin: 'auto',
    padding: 'B B2 C1',
    round: 'radiusCard',
    theme: 'common-box',
    color: 'title',
    // Border + blue glow removed 2026-06-06 per Nika ("remove
    // LoadingGifSection border and outline") — the loading overlay sits
    // inside this window, so the ring/glow read as chrome around the
    // loading gif. minHeight pins the box so the content swap during
    // sign-in doesn't resize the window.
    border: 'none',
    boxShadow: 'none',
    minHeight: 'H',
    '@mobileM': {
        padding: 'A A B',
        minHeight: 'auto',
        width: '100%',
        maxWidth: '100%'
    },
    LoadingGifSection: {
        background: 'scrim',
        position: 'absolute',
        inset: '0',
        fullSize: true,
        transition: 'B defaultBezier',
        transitionProperty: 'opacity, visibility',
        pointerEvents: (el, s)=>s.loading ? 'auto' : 'none',
        opacity: (el, s)=>s.loading ? 1 : 0,
        visibility: (el, s)=>s.loading ? 'visible' : 'hidden'
    },
    ModalHeader: {
        width: '100%',
        margin: '0',
        Hgroup: {
            H: {
                tag: 'h1',
                fontSize: 'D',
                text: '{{ auth.login.heading | polyglot }}'
            },
            P: null
        },
        Icons: {
            // SECURITY/UX (platform#2278): the full-page /login, /signin, /signup,
            // /reset-password surfaces have NOTHING to close to — the old X did
            // `el.router('/')`, which (combined with the missing SPA auth guard, now
            // fixed in workspace/app.js) let an unauthenticated visitor walk into the
            // dashboard. There's no valid "close" on a full-page auth screen, so the
            // X is hidden by default. ONLY a modal consumer (LoginWindow rendered
            // inside an overlay, e.g. MarketplaceSigninModal) re-enables it via an
            // `Icons.Close.if`/`onClick` override that dismisses the overlay.
            Close: {
                // The brand ModalHeader's Close can't be hidden from here — neither
                // `if` nor `hide` merges through `extends: 'ModalWindow'` onto it. The
                // X is hidden on the full-page auth screens by a route-scoped CSS rule
                // in workspace/app.js (`html[data-shell-route="auth"] … Close`). What
                // DOES merge is `onClick`, so make it a safe no-op — defense in depth:
                // even if the X ever renders on a page it must NEVER navigate into the
                // app (that was the #2278 bypass — the old override did `router('/')`).
                onClick: (ev)=>{
                    ev?.preventDefault?.();
                    ev?.stopPropagation?.();
                }
            }
        }
    },
    Flex: {
        align: 'stretch space-between',
        width: '100%',
        padding: 'B C1',
        flow: 'x',
        gap: 'C2',
        childProps: {
            flex: '1 1 0',
            minWidth: '0'
        },
        '@tabletS': {
            flow: 'column',
            gap: 'B',
            padding: 'B 0 0'
        },
        '@mobileL': {
            flow: 'column',
            wrap: 'nowrap',
            padding: 'A 0 B',
            gap: 'A',
            width: '100%',
            maxWidth: '100%'
        },
        // Keep keyboard order aligned with the visible form-first layout.
        LoginForm: null,
        SignupForm: null,
        ResetEmailForm: null,
        ResetPasswordsForm: null,
        RequestAccessButtons: {
            // Force the OAuth column to the right of the email/password form
            // even though it's declared first in this component. Pages slot
            // their LoginForm/SignupForm/etc. into Flex with default order 0,
            // and `order: 2` here pushes RequestAccessButtons after them
            // without making LoginWindow aware of which form key the page used.
            order: 2,
            height: '100%',
            padding: '0',
            background: 'transparent',
            gap: 'A2',
            Hgroup: {
                margin: '0 0 A',
                '@mobileL': {
                    margin: '0 0 Z'
                },
                H: {
                    tag: 'h2',
                    fontSize: 'A',
                    text: '{{ auth.login.alternativeHeading | polyglot }}'
                },
                P: {
                    color: 'inactive',
                    fontSize: 'Z2',
                    text: '{{ auth.login.alternativeBody | polyglot }}'
                }
            },
            '@tabletS': {
                margin: '0',
                align: 'stretch flex-start'
            },
            '@mobileL': {
                margin: '0',
                padding: 'A 0 0',
                gap: 'A',
                border: 'none',
                borderWidth: '0',
                borderStyle: 'none',
                borderColor: 'transparent'
            },
            Flex: {
                GoogleSignInButton: {
                    extends: [
                        'Link',
                        'Button'
                    ],
                    // type='button' — `Button` renders a native <button>, and a <button>
                    // with no explicit type defaults to type=submit. Without this the
                    // OAuth buttons are implicit form-submit buttons; the first one in
                    // DOM order (Google) captured Enter and ran its onClick (which
                    // preventDefaults), so pressing Enter in the email/password form
                    // appeared to do nothing. type='button' leaves the Sign-in
                    // CheckButton as the only submit button, so Enter submits the form.
                    type: 'button',
                    // Native shell: disabled only while the system-browser flow is
                    // unconfirmed (server probe pending or 404 — s.nativeAuthReady
                    // false), with the reason rendered right below
                    // (P_nativeShellNotice) — never a silent no-op. Each factory
                    // falls through to the exact web value when isNativeShell() is
                    // false.
                    disabled: (el, s)=>!!s.loading || el.call('isNativeShell') && !s.nativeAuthReady,
                    margin: '0 0 0 -X',
                    theme: 'quaternary',
                    fontWeight: '500',
                    gap: 'Z',
                    cursor: (el, s)=>s.loading || el.call('isNativeShell') && !s.nativeAuthReady ? 'not-allowed' : 'pointer',
                    opacity: (el, s)=>s.loading || el.call('isNativeShell') && !s.nativeAuthReady ? 0.6 : 1,
                    pointerEvents: (el, s)=>s.loading ? 'none' : 'auto',
                    icon: 'googleLogoNormal',
                    // CSS order flips the Icon flex child in front of the text node
                    // so the brand glyph reads left of the label without reversing
                    // the whole row (row-reverse would also flip Hgroup hierarchy).
                    Icon: {
                        order: '-1'
                    },
                    text: '{{ auth.login.google | polyglot }}',
                    '@tabletS': {
                        align: 'center center',
                        fontSize: 'Z1',
                        margin: '0',
                        maxWidth: '100%',
                        padding: 'Z1 A',
                        width: '100%'
                    },
                    '@mobileL': {
                        padding: 'Z1 -',
                        align: 'center center',
                        maxWidth: '100%',
                        textAlign: 'center',
                        border: 'none'
                    },
                    '@mobileM': {
                        fontSize: 'Y'
                    },
                    // One-time GIS init. The gsi/client script is NOT loaded by
                    // index.html — we lazy-inject it only on auth pages so the
                    // editor's main bundle stays Google-free. `onRender` may
                    // fire multiple times in dev under HMR; the `_gsiInited`
                    // guard + script-tag de-dup make it idempotent.
                    onRender: (el, s)=>{
                        if (typeof window === 'undefined') return;
                        // Native shell: skip ALL GIS wiring (script inject + One Tap
                        // init + code client) — none of it can succeed in the embedded
                        // webview (see header note). Instead arm the deep-link entry
                        // paths (?xt boot param / 'symbols:auth-callback' event) and
                        // feature-detect the server exchange route; the probe verdict
                        // lands in s.nativeAuthReady and enables the button.
                        if (el.call('isNativeShell')) {
                            el.call('ensureNativeGoogleAuth');
                            return;
                        }
                        if (window._gsiInited) return;
                        const _GSI_SRC = 'https://accounts.google.com/gsi/client';
                        if (!document.querySelector(`script[src="${_GSI_SRC}"]`)) {
                            const tag = document.createElement('script');
                            tag.src = _GSI_SRC;
                            tag.async = true;
                            tag.defer = true;
                            document.head.appendChild(tag);
                        }
                        const tryInit = ()=>{
                            if (!window.google?.accounts?.id) return false;
                            const clientId = el.sdk?.environment?.googleClientId;
                            if (!clientId) {
                                console.warn("[LoginWindow] no googleClientId in sdk.environment \u2014 Google button will fail");
                                return true // give up retrying; nothing to init
                                ;
                            }
                            window.google.accounts.id.initialize({
                                client_id: clientId,
                                // WORKSPACE-AUTH-GSI-FEDCM-DEPRECATION: Google is making
                                // FedCM the mandatory backend for One Tap. Opt into the
                                // FedCM-driven prompt UI so we use the browser-native
                                // chooser instead of Google's legacy iframe. Once this
                                // is on, `PromptMomentNotification.isNotDisplayed()` /
                                // `isSkippedMoment()` / `isDismissedMoment()` (and their
                                // get*Reason siblings) all stop returning meaningful
                                // values — we must not call them, or the GSI logger
                                // re-emits the deprecation warning. The prompt() call
                                // below was rewritten to drop those status checks.
                                use_fedcm_for_prompt: true,
                                callback: async (response)=>{
                                    if (!response?.credential) {
                                        s.update({
                                            loading: false
                                        });
                                        return;
                                    }
                                    const inviteToken = (0, $e2Fqo.readInviteToken)('google');
                                    try {
                                        const loginResult = await el.sdk.googleAuth(response.credential, inviteToken);
                                        // A sign-in on this origin: its refresh token is its own (review D1).
                                        el.call('markOwnSession');
                                        await el.scope.completeGoogleLogin(el, s, loginResult);
                                    } catch (err) {
                                        console.error('[LoginWindow] googleAuth failed:', err);
                                        (0, $e2Fqo.clearInviteToken)('google');
                                        s.update({
                                            loading: false
                                        });
                                        el.call('openNotification', {
                                            title: el.call('polyglot', 'auth.login.googleFailed'),
                                            message: err?.message || el.call('polyglot', 'auth.login.tryAgain'),
                                            type: 'error'
                                        });
                                    }
                                },
                                auto_select: false,
                                cancel_on_tap_outside: true
                            });
                            // Explicit OAuth code flow — the reliable path for the button.
                            // One Tap above only authenticates users ALREADY signed into
                            // Google in this browser; otherwise FedCM aborts ("Not signed
                            // in with the identity provider") with no recovery. initCodeClient
                            // opens Google's account chooser + consent in a popup and works
                            // regardless of session/FedCM state. The code is exchanged
                            // server-side via /core/auth/google/callback (redirect_uri
                            // 'postmessage' for the popup ux_mode).
                            if (window.google.accounts.oauth2?.initCodeClient) window._gsiCodeClient = window.google.accounts.oauth2.initCodeClient({
                                client_id: clientId,
                                scope: 'openid email profile',
                                ux_mode: 'popup',
                                callback: async (resp)=>{
                                    if (!resp?.code) {
                                        s.update({
                                            loading: false
                                        });
                                        return;
                                    }
                                    const inviteToken = (0, $e2Fqo.readInviteToken)('google');
                                    try {
                                        const loginResult = await el.sdk.googleAuthCallback(resp.code, 'postmessage', inviteToken);
                                        // A sign-in on this origin: its refresh token is its own (review D1).
                                        el.call('markOwnSession');
                                        await el.scope.completeGoogleLogin(el, s, loginResult);
                                    } catch (err) {
                                        console.error('[LoginWindow] googleAuthCallback failed:', err);
                                        (0, $e2Fqo.clearInviteToken)('google');
                                        s.update({
                                            loading: false
                                        });
                                        el.call('openNotification', {
                                            title: el.call('polyglot', 'auth.login.googleFailed'),
                                            message: err?.message || el.call('polyglot', 'auth.login.tryAgain'),
                                            type: 'error'
                                        });
                                    }
                                }
                            });
                            window._gsiInited = true;
                            return true;
                        };
                        if (!tryInit()) {
                            // gsi/client still loading — retry briefly
                            const t = setInterval(()=>{
                                if (tryInit()) clearInterval(t);
                            }, 200);
                            setTimeout(()=>clearInterval(t), 5000);
                        }
                    },
                    onClick: (ev, el, s)=>{
                        ev?.preventDefault?.();
                        // Native shell: run OAuth in the SYSTEM browser (Safari) with
                        // the symbols:// deep link back. Gated on the server probe —
                        // when the exchange route isn't deployed the button stays
                        // disabled, and this branch keeps the reason as a
                        // defense-in-depth notification (in case a webview ever drops
                        // the disabled attr), never a silent no-op.
                        if (el.call('isNativeShell')) {
                            if (!s.nativeAuthReady) {
                                el.call('openNotification', {
                                    title: el.call('polyglot', 'auth.login.googleNotInApp.title'),
                                    message: el.call('polyglot', 'auth.login.googleNotInApp.message'),
                                    type: 'warning'
                                });
                                return;
                            }
                            // Persist invite token + post-OAuth next across the Safari
                            // round-trip (same stashes as the web path below).
                            (0, $e2Fqo.stashInviteToken)('google');
                            (0, $klqGv.stashOAuthNext)();
                            s.update({
                                loading: true
                            });
                            el.call('launchNativeGoogleAuth');
                            // No cancel signal if the user abandons Safari — cap the
                            // spinner like the web popup path (the deep-link completion
                            // owns `loading` from the moment it fires).
                            setTimeout(()=>{
                                if (s.loading) s.update({
                                    loading: false
                                });
                            }, 60000);
                            return;
                        }
                        if (!window.google?.accounts?.id) {
                            el.call('openNotification', {
                                title: el.call('polyglot', 'auth.login.googleUnavailable.title'),
                                message: el.call('polyglot', 'auth.login.googleUnavailable.message'),
                                type: 'error'
                            });
                            return;
                        }
                        // Persist invite token (?token=…) + post-OAuth next so they
                        // survive the prompt round-trip even when the credential
                        // callback fires from a different invocation.
                        (0, $e2Fqo.stashInviteToken)('google');
                        (0, $klqGv.stashOAuthNext)();
                        s.update({
                            loading: true
                        });
                        try {
                            // Explicit OAuth popup (Google account chooser + consent) —
                            // works for every user regardless of whether they're already
                            // signed into Google or whether FedCM is available. This is the
                            // reliable replacement for the One Tap `prompt()`, which aborted
                            // ("Not signed in with the identity provider") for anyone without
                            // an active Google session. The code-client callback resets
                            // `loading` on success; if the user closes the popup we get no
                            // signal, so cap the spinner with a 30s safety timeout.
                            if (window._gsiCodeClient) window._gsiCodeClient.requestCode();
                            else // Code client not ready yet (gsi/client still loading) — fall
                            // back to One Tap so the click isn't a no-op.
                            window.google.accounts.id.prompt(()=>{});
                            setTimeout(()=>{
                                if (s.loading) s.update({
                                    loading: false
                                });
                            }, 30000);
                        } catch (err) {
                            console.error('[LoginWindow] One Tap prompt failed:', err);
                            s.update({
                                loading: false
                            });
                            el.call('openNotification', {
                                title: el.call('polyglot', 'auth.login.googleSignInFailed'),
                                message: err?.message || el.call('polyglot', 'auth.login.tryAgain'),
                                type: 'error'
                            });
                        }
                    }
                },
                // Native shell only: the visible reason the Google button above is
                // disabled — inline text, not a title tooltip (hover doesn't exist
                // on touch). Hidden reactively once the system-browser flow is
                // confirmed (s.nativeAuthReady) — the guard survives only as the
                // fallback for servers that predate the exchange route.
                // `_`-suffix key auto-extends the built-in P.
                P_nativeShellNotice: {
                    if: (el)=>el.call('isNativeShell'),
                    display: (el, s)=>s.nativeAuthReady ? 'none' : 'block',
                    text: '{{ auth.login.googleNativeHint | polyglot }}',
                    color: 'caption',
                    fontSize: 'Y',
                    margin: '0',
                    maxWidth: '100%'
                },
                GithubSignInButton: {
                    // Hide Github on preview embeds — the OAuth callback hops the
                    // top frame and breaks the embedded preview UX.
                    if: (el)=>{
                        const env = el.sdk?.environment;
                        return !env?.isPreview;
                    },
                    extends: [
                        'Link',
                        'Button'
                    ],
                    // type='button' — `Button` renders a native <button>, and a <button>
                    // with no explicit type defaults to type=submit. Without this the
                    // OAuth buttons are implicit form-submit buttons; the first one in
                    // DOM order (Google) captured Enter and ran its onClick (which
                    // preventDefaults), so pressing Enter in the email/password form
                    // appeared to do nothing. type='button' leaves the Sign-in
                    // CheckButton as the only submit button, so Enter submits the form.
                    type: 'button',
                    disabled: (el, s)=>!!s.loading,
                    margin: '0 0 0 -X',
                    theme: 'quaternary',
                    fontWeight: '500',
                    gap: 'Z',
                    cursor: (el, s)=>s.loading ? 'not-allowed' : 'pointer',
                    opacity: (el, s)=>s.loading ? 0.6 : 1,
                    pointerEvents: (el, s)=>s.loading ? 'none' : 'auto',
                    icon: 'github',
                    Icon: {
                        order: '-1'
                    },
                    text: '{{ auth.login.github | polyglot }}',
                    '@tabletS': {
                        align: 'center center',
                        fontSize: 'Z1',
                        margin: '0',
                        maxWidth: '100%',
                        padding: 'Z1 A',
                        width: '100%'
                    },
                    '@mobileL': {
                        padding: 'Z1 -',
                        align: 'center center',
                        maxWidth: '100%',
                        textAlign: 'center',
                        border: 'none'
                    },
                    '@mobileM': {
                        fontSize: 'Y'
                    },
                    onClick: (ev, el, s)=>{
                        ev?.preventDefault?.();
                        const env = el.sdk?.environment;
                        if (!env?.githubClientId) {
                            el.call('openNotification', {
                                title: el.call('polyglot', 'auth.login.githubUnavailable.title'),
                                message: el.call('polyglot', 'auth.login.githubUnavailable.message'),
                                type: 'error'
                            });
                            return;
                        }
                        s.update({
                            loading: true
                        });
                        try {
                            (0, $e2Fqo.stashInviteToken)('github');
                            (0, $klqGv.stashOAuthNext)();
                            const redirectUri = `${window.location.origin}/github-auth-callback`;
                            const scope = 'user:email';
                            window.location.href = `https://github.com/login/oauth/authorize` + `?client_id=${encodeURIComponent(env.githubClientId)}` + `&redirect_uri=${encodeURIComponent(redirectUri)}` + `&scope=${encodeURIComponent(scope)}`;
                        } catch (err) {
                            console.error('[LoginWindow] GitHub redirect failed:', err);
                            (0, $e2Fqo.clearInviteToken)('github');
                            s.update({
                                loading: false
                            });
                            el.call('openNotification', {
                                title: el.call('polyglot', 'auth.login.githubStartFailed'),
                                message: err?.message || el.call('polyglot', 'auth.login.tryAgain'),
                                type: 'error'
                            });
                        }
                    }
                },
                Link: null
            }
        }
    }
};

});
parcelRegister("klqGv", function(module, exports) {

$parcel$export(module.exports, "stashOAuthNext", () => $ecfa77d16da585e8$export$20a97d37181f82a4);
$parcel$export(module.exports, "consumeOAuthNext", () => $ecfa77d16da585e8$export$edcca3e68c0fcb40);
// Post-OAuth `next` URL persistence.
//
// OAuth providers (Google One Tap, GitHub redirect, magic-link) strip
// arbitrary query params on the round-trip back. To preserve a `?next=`
// parameter from the original sign-in entry across the provider hop,
// we stash it in localStorage on the way out and consume it on the
// callback page. Used from signin/signup/reset-password (entry side)
// and callback/magic-callback (callback side).
//
// FA204/FA207 / frank trap — `KEY` (module-scope) and `_safePath` (a sibling
// export read bare by consumeOAuthNext) are both unresolvable once this
// file's exports are individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers; readerVoice.js precedent).
// Both are inlined self-contained in each consumer.
const $ecfa77d16da585e8$export$20a97d37181f82a4 = ()=>{
    const KEY = 'post_oauth_next';
    if (typeof window === 'undefined') return;
    try {
        const next = new URL(window.location.href).searchParams.get('next');
        if (!next) return;
        // Never store an API-base override param (`apiUrl`, `channel`): they name
        // the API the bearer token goes to (postOAuthNext.overrideParams.test.js).
        const OVERRIDE_PARAMS = [
            'apiUrl',
            'channel'
        ];
        let stored = next;
        try {
            const u = new URL(next, window.location.origin);
            if (u.origin === window.location.origin) {
                for (const k of OVERRIDE_PARAMS)u.searchParams.delete(k);
                stored = u.pathname + u.search + u.hash;
            }
        } catch (_) {
        /* unparseable — consume clamps it to '/' */ }
        window.localStorage.setItem(KEY, stored);
    } catch (_) {
    /* URL parse can throw on file:// — non-fatal */ }
};
const $ecfa77d16da585e8$export$edcca3e68c0fcb40 = (urlSearchParamsNext = null)=>{
    const KEY = 'post_oauth_next';
    // Clamp a `?next` redirect target to a SAFE same-origin path. The
    // callback page feeds the consumed value straight into
    // `window.location.replace`, so an attacker-supplied absolute
    // (`https://evil.com`) or protocol-relative (`//evil.com`, `/\evil.com` —
    // browsers normalize `\` → `/`) value would be an open redirect
    // (phishing). Resolve against the current origin via the URL parser and
    // keep only same-origin requests, returning just the path; anything
    // cross-origin or unparseable falls back to `/`.
    const safePath = (next)=>{
        if (!next || typeof next !== 'string') return '/';
        if (typeof window === 'undefined') return next[0] === '/' && next[1] !== '/' && !next.includes('\\') ? next : '/';
        try {
            const url = new URL(next, window.location.origin);
            if (url.origin !== window.location.origin) return '/';
            // never hand back an API-base override param (`apiUrl`, `channel`)
            for (const k of [
                'apiUrl',
                'channel'
            ])url.searchParams.delete(k);
            return url.pathname + url.search + url.hash;
        } catch (_) {
            return '/';
        }
    };
    if (urlSearchParamsNext) return safePath(urlSearchParamsNext);
    if (typeof window === 'undefined') return '/';
    try {
        const stashed = window.localStorage.getItem(KEY);
        if (stashed) {
            window.localStorage.removeItem(KEY);
            return safePath(stashed);
        }
    } catch (_) {}
    return '/';
};

});

parcelRegister("e2Fqo", function(module, exports) {

$parcel$export(module.exports, "stashInviteToken", () => $a39162a955af4bb9$export$759212efe7a9d62b);
$parcel$export(module.exports, "readInviteToken", () => $a39162a955af4bb9$export$ab0465c45f59a258);
$parcel$export(module.exports, "takeInviteToken", () => $a39162a955af4bb9$export$4007ae1c29cd8ed1);
$parcel$export(module.exports, "inviteTokenClaims", () => $a39162a955af4bb9$export$4db28865a557667f);
$parcel$export(module.exports, "inviteTokenFromNext", () => $a39162a955af4bb9$export$89cf592a7507104b);
$parcel$export(module.exports, "clearInviteToken", () => $a39162a955af4bb9$export$40194dd3ce120050);
// Invite-token persistence across OAuth round-trips.
//
// The OAuth handshake (Google One Tap, GitHub authorize redirect) strips
// arbitrary `?token=<inviteToken>` query params on the way to / back from
// the provider. We stash the invite token in localStorage under a
// per-provider key on the way out, then read+clear it on the callback
// page so the SDK's googleAuth/githubAuth handlers can consume it.
//
// FA204 / frank trap — `_key` used to be a bare module-scope helper, read
// from inside each exported function's own body: unresolvable once this
// file's exports are individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers). Inlined as a local in each.
// Read the invite token from the current URL's `?token=` param and
// stash under the provider's key. No-op when the URL has no token.
const $a39162a955af4bb9$export$759212efe7a9d62b = (provider)=>{
    const key = (p)=>`${p}_auth_invite_token`;
    if (typeof window === 'undefined' || !provider) return null;
    try {
        const token = new URL(window.location.href).searchParams.get('token');
        if (token) window.localStorage.setItem(key(provider), token);
        return token || null;
    } catch (_) {
        return null;
    }
};
const $a39162a955af4bb9$export$ab0465c45f59a258 = (provider)=>{
    const key = (p)=>`${p}_auth_invite_token`;
    if (typeof window === 'undefined' || !provider) return null;
    try {
        const token = window.localStorage.getItem(key(provider));
        if (token) window.localStorage.removeItem(key(provider));
        return token;
    } catch (_) {
        return null;
    }
};
const $a39162a955af4bb9$export$4007ae1c29cd8ed1 = ()=>{
    if (typeof window === 'undefined') return null;
    let parked = null;
    try {
        // The boot getter deletes itself on read; a plain value is dropped here.
        parked = window.__symbolsInviteToken || null;
        if ('__symbolsInviteToken' in window) delete window.__symbolsInviteToken;
    } catch (_) {
        parked = null;
    }
    let fromUrl = null;
    try {
        const url = new URL(window.location.href);
        const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
        fromUrl = url.searchParams.get('token') || hash.get('token') || null;
        if (fromUrl) {
            url.searchParams.delete('token');
            hash.delete('token');
            const rest = hash.toString();
            const history = window.history;
            if (history && typeof history.replaceState === 'function') history.replaceState(history.state, '', url.pathname + url.search + (rest ? '#' + rest : ''));
        }
    } catch (_) {
    /* a malformed address: nothing to take out */ }
    return fromUrl || parked;
};
const $a39162a955af4bb9$export$4db28865a557667f = (token)=>{
    if (!token || typeof token !== 'string') return null;
    try {
        const part = token.split('.')[1];
        if (!part) return null;
        const b64 = part.replace(/-/g, '+').replace(/_/g, '/');
        const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - b64.length % 4);
        const binary = atob(b64 + pad);
        // atob yields one char per byte; the payload is UTF-8 (an address may
        // carry a non-ASCII part).
        const json = decodeURIComponent(Array.from(binary, (c)=>'%' + c.charCodeAt(0).toString(16).padStart(2, '0')).join(''));
        const p = JSON.parse(json);
        if (!p || typeof p !== 'object') return null;
        return {
            type: typeof p.type === 'string' ? p.type : null,
            email: typeof p.email === 'string' && p.email ? p.email : null,
            organizationId: p.organizationId ? String(p.organizationId) : null,
            kind: typeof p.kind === 'string' ? p.kind : null,
            role: typeof p.role === 'string' ? p.role : null
        };
    } catch (_) {
        return null;
    }
};
const $a39162a955af4bb9$export$89cf592a7507104b = (search)=>{
    try {
        const q = typeof search === 'string' ? search : typeof window !== 'undefined' && window.location ? window.location.search : '';
        const next = new URLSearchParams(q || '').get('next');
        if (!next || next.charAt(0) !== '/' || next.charAt(1) === '/') return null;
        const url = new URL(next, 'https://local.invalid');
        if (url.origin !== 'https://local.invalid') return null;
        const path = url.pathname.replace(/\/+$/, '');
        const acceptPaths = [
            '/accept-invite',
            '/accept-org-invite',
            '/accept-team-invite',
            '/accept-workspace-invite'
        ];
        if (acceptPaths.indexOf(path) === -1) return null;
        const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
        return hash.get('token') || url.searchParams.get('token') || null;
    } catch (_) {
        return null;
    }
};
const $a39162a955af4bb9$export$40194dd3ce120050 = (provider)=>{
    const key = (p)=>`${p}_auth_invite_token`;
    if (typeof window === 'undefined' || !provider) return;
    try {
        window.localStorage.removeItem(key(provider));
    } catch (_) {}
};

});


parcelRegister("3QmN9", function(module, exports) {

$parcel$export(module.exports, "YouAreConnected", () => $2cc7e86a608df03b$export$435025809c0ec1d9);
const $2cc7e86a608df03b$export$435025809c0ec1d9 = {
    if: (el)=>el.getRootState().package > 0,
    width: '100%',
    attr: {
        id: 'connect'
    },
    SectionTitle: {
        text: '{{ editor.connection.title | polyglot }}'
    },
    Grid: {
        width: '100%',
        flex: 1,
        templateColumns: 'repeat(4, 1fr)',
        position: 'relative',
        transition: 'C defaultBezier max-height',
        gap: 'A',
        ServerPreview_test: {
            gap: 'C1',
            SectionHeader: {
                title: (el)=>el.call('polyglot', 'settings.governance.env.development')
            },
            Flex: {
                gap: 'A',
                flow: 'y',
                ConnectionLabel_dev: {
                    isActive: (el)=>el.getAppKey(),
                    Circle: {},
                    Link: {
                        target: '_blank',
                        fontWeight: '400',
                        href: (el)=>`https://${el.getAppKey()}/`,
                        ':hover': {
                            textDecoration: 'underline'
                        },
                        '@dark': {
                            color: 'white'
                        },
                        '@light': {
                            color: 'black'
                        },
                        text: (el)=>el.getAppKey()
                    },
                    SquareButton_force: {
                        show: (el, s)=>s.active,
                        icon: 'reload outline',
                        aria: {
                            label: (el)=>el.call('polyglot', 'editor.connection.refresh')
                        },
                        background: 'transparent',
                        theme: 'common-card-outline-interactive',
                        isActive: false,
                        fontSize: 'Z',
                        '--spacing-ratio': 1.2,
                        borderWidth: 'hairline',
                        borderStyle: 'solid',
                        onClick: async (event, el)=>{
                            el.update({
                                Icon: {
                                    name: 'checkmark outline'
                                }
                            });
                            const t = setTimeout(()=>{
                                el.update({
                                    Icon: {
                                        name: 'reload outline'
                                    }
                                });
                                clearTimeout(t);
                            }, 1000);
                            await el.call('addSmblsSubdomains', el.getAppKey());
                        }
                    },
                    text: null
                },
                ConnectionLabel_local: {
                    isActive: (el, s)=>el.getRootState('clients').localhost,
                    Circle: {},
                    text: 'localhost'
                }
            }
        },
        ServerPreview_cli: {
            SectionHeader: {
                title: (el)=>el.call('polyglot', 'editor.connection.cli')
            },
            ConnectionLabel: {
                isActive: (el, s)=>el.getRootState('clients').cli
            }
        },
        ServerPreview_ci: {
            SectionHeader: {
                title: (el)=>el.call('polyglot', 'editor.connection.ci')
            },
            ConnectionLabel: {}
        },
        ServerPreview_prod: {
            flex: 1,
            state: 'RELEASE',
            SectionHeader: {
                title: (el)=>el.call('polyglot', 'settings.governance.env.production')
            },
            ConnectionLabel_published: {
                isActive: (el)=>el.getRootState('createdAt'),
                Circle: {},
                text: (el, s)=>el.call('polyglot', s.isActive ? 'editor.connection.published' : 'editor.connection.unpublished'),
                Link: {
                    color: 'highlight',
                    target: '_blank',
                    fontWeight: '400',
                    hide: (el)=>!el.getRootState('domain'),
                    href: (el)=>el.getRootState('domain'),
                    text: (el)=>el.getRootState('domain') && new URL(el.getRootState('domain')).host,
                    ':hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            SectionHeader_last_connected: {
                margin: '0',
                heading: null,
                Article: {
                    P: {
                        order: '-1',
                        text: '{{ editor.connection.lastPublish | polyglot }}'
                    },
                    Title: {
                        color: 'title',
                        text: (el)=>el.getRootState('updatedAt') && new Date(el.getRootState('updatedAt')).toLocaleString()
                    }
                }
            }
        }
    },
    Flex: {
        minWidth: '100%',
        align: 'center space-between',
        gridColumnStart: 'span 3',
        color: 'title',
        padding: 'B1 X - -',
        staging: {
            noChanges: {
                if: ()=>false,
                text: '{{ editor.connection.noStaged | polyglot }}'
            },
            publish: {
                if: ()=>true,
                ContinueButton_publish: {
                    scrollToTop: false,
                    href: (el)=>el.getCanvasPathname() + '/publish',
                    margin: '0',
                    // Adaptive (was fixed 'white') — ContinueButton's own base already
                    // sets `color: 'title'`; this override defeated it and went
                    // invisible in light mode.
                    color: 'title',
                    text: '{{ publish.action.publish | polyglot }}'
                },
                Button_reset: {
                    onClick: async (ev, el)=>{
                        ev.preventDefault();
                        await el.call('openRouterModal', '/reset');
                    },
                    margin: '- - - B1',
                    fontWeight: '400',
                    scrollToTop: false,
                    background: 'transparent',
                    theme: 'common-card-outline-interactive',
                    text: '{{ common.action.reset | polyglot }}'
                }
            }
        },
        version: {
            // CAT-3: unguarded — a root state with no `version` key (a bare
            // catalog mount, or any pre-boot race) rendered the literal
            // "Version 1.undefined".
            text: (el)=>`Version 1.${el.getRootState().version ?? '?'}`
        }
    }
};

});

parcelRegister("42HIn", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordsForm", () => $2f194228a670a714$export$6d623bb7624668db);
const $2f194228a670a714$export$6d623bb7624668db = {
    flow: 'column',
    gap: 'B1',
    flex: '1',
    childExtends: 'InputField',
    childProps: {
        width: '100%',
        maxWidth: 'G+B',
        Title: {
            tag: 'span'
        },
        Input: {
            width: '100%',
            theme: 'field',
            background: 'hover',
            minHeight: 'controlH',
            round: 'radiusControl',
            fontSize: 'Z2',
            padding: '0 A'
        }
    },
    Password: {
        Title: {
            text: '{{ auth.resetPassword.newLabel | polyglot }}'
        },
        Input: {
            // One-way mirror only — see ResetEmailForm.Email.Input for why
            // `value: (el, s) => s.password` is intentionally absent.
            type: 'password',
            name: 'new-password',
            required: true,
            ariaLabel: (el)=>el.call('polyglot', 'auth.resetPassword.newLabel'),
            autocomplete: 'new-password',
            placeholder: (el)=>el.call('polyglot', 'auth.resetPassword.placeholder'),
            onInput: (ev, el, s)=>{
                s.update({
                    passwordTouched: true,
                    password: el.node.value
                });
            }
        },
        Label_1: {
            show: (el, st)=>st.passwordTouched === true && !st.password,
            color: 'red',
            text: '{{ auth.resetPassword.required | polyglot }}'
        }
    },
    RepeatPassword: {
        Title: {
            text: '{{ auth.resetPassword.repeatLabel | polyglot }}'
        },
        Input: {
            // One-way mirror only — see ResetEmailForm.Email.Input for why
            // `value: (el, s) => s.repeatPassword` is intentionally absent.
            type: 'password',
            name: 'repeat-password',
            required: true,
            ariaLabel: (el)=>el.call('polyglot', 'auth.resetPassword.repeatLabel'),
            autocomplete: 'new-password',
            placeholder: (el)=>el.call('polyglot', 'auth.resetPassword.placeholder'),
            onInput: (ev, el, s)=>{
                s.update({
                    repeatPasswordTouched: true,
                    repeatPassword: el.node.value
                });
            }
        },
        Label_2: {
            show: (el, st)=>st.repeatPasswordTouched === true && !st.repeatPassword,
            color: 'red',
            text: '{{ auth.resetPassword.repeatRequired | polyglot }}'
        },
        Label_3: {
            show: (el, st)=>st.passwordTouched === true && st.repeatPasswordTouched === true && st.password !== st.repeatPassword,
            color: 'red',
            text: '{{ auth.resetPassword.mismatch | polyglot }}'
        }
    },
    ModalFooter: {
        // White-label host: flush with the fields (the brand footer's '0 -X'
        // bleed is a modal affordance; on the branded card it set the button
        // off the field edges).
        isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
        '.isBranded': {
            margin: '0',
            padding: 'Z 0 0'
        },
        display: 'flex',
        flow: 'row',
        width: '100%',
        maxWidth: 'unset',
        align: 'center space-between',
        gap: 'Z',
        '@mobileL': {
            flow: 'column',
            gap: 'A2',
            childProps: {
                width: '100%'
            }
        },
        CheckButton: {
            // White-label host: the tenant accent (inert on the platform).
            extends: [
                'WhitelabelAccent',
                'CheckButton'
            ],
            text: (el, s)=>el.call('polyglot', s.loading ? 'auth.resetPassword.updating' : 'auth.resetPassword.submit'),
            disabled: (el, s)=>!!s.loading,
            opacity: (el, s)=>s.loading ? '.7' : '1',
            cursor: (el, s)=>s.loading ? 'wait' : 'pointer',
            pointerEvents: (el, s)=>s.loading ? 'none' : 'auto',
            type: 'submit',
            Icon: null,
            width: 'fit-content',
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2',
            fontWeight: '700',
            '@mobileL': {
                width: '100%',
                maxWidth: '100%'
            }
        },
        Title: null,
        Input: null
    }
};

});

parcelRegister("2w1Rh", function(module, exports) {

$parcel$export(module.exports, "ResetEmailForm", () => $1d5002f6e74b2f25$export$1c367202ee4dfef3);
const $1d5002f6e74b2f25$export$1c367202ee4dfef3 = {
    if: (el, s)=>!s.token,
    flow: 'column',
    gap: 'A',
    flex: '1',
    height: '100%',
    '@mobileL': {
        align: 'center unset',
        height: 'unset'
    },
    childExtends: 'InputField',
    childProps: {
        width: '100%',
        Title: {
            tag: 'span'
        },
        Input: {
            width: '100%',
            theme: 'field',
            background: 'hover',
            minHeight: 'controlH',
            round: 'radiusControl',
            fontSize: 'Z2',
            padding: '0 A'
        }
    },
    Email: {
        Title: {
            text: '{{ auth.resetEmail.label | polyglot }}'
        },
        Input: {
            // One-way mirror only — DO NOT bind `value: (el, s) => s.email`.
            // That factory re-renders the input on every state change and
            // races with native typing, intermittently clearing the field
            // mid-keystroke. The submit handler reads state with a DOM
            // fallback (see reset-password.js _submitRequestReset) so this
            // input owns its own live value; state stays in sync via
            // onInput for the gating UI (Label/touched).
            autocomplete: 'username',
            name: 'email',
            type: 'email',
            ariaLabel: (el)=>el.call('polyglot', 'auth.resetEmail.label'),
            required: true,
            autocapitalize: 'none',
            spellcheck: false,
            // A white-label host never shows the platform's own address as the
            // example (it named symbo.ls on a tenant's signup).
            placeholder: (el, s)=>el.call('polyglot', s && s.root && s.root.whitelabelBrand ? 'auth.whitelabel.emailPlaceholder' : 'auth.resetEmail.placeholder'),
            onInput: (ev, el, s)=>{
                s.update({
                    touched: true,
                    email: el.node.value
                });
            }
        },
        Label: {
            show: (el, st)=>st.touched === true && !st.email,
            color: 'red',
            text: '{{ auth.resetEmail.required | polyglot }}'
        }
    },
    ModalFooter: {
        // White-label host: flush with the fields (the brand footer's '0 -X'
        // bleed is a modal affordance; on the branded card it set the button
        // off the field edges).
        isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
        '.isBranded': {
            margin: '0',
            padding: 'Z 0 0'
        },
        ignoreChildExtends: true,
        Title: null,
        Input: null,
        display: 'flex',
        flow: 'row',
        width: '100%',
        maxWidth: 'unset',
        align: 'center space-between',
        gap: 'Z',
        padding: 'B1 0 0',
        '@mobileL': {
            flow: 'column',
            gap: 'A2',
            childProps: {
                width: '100%'
            }
        },
        CheckButton: {
            // White-label host: the tenant accent (inert on the platform).
            extends: [
                'WhitelabelAccent',
                'CheckButton'
            ],
            text: (el, s)=>el.call('polyglot', s.loading ? 'auth.resetEmail.sending' : 'auth.resetEmail.submit'),
            disabled: (el, s)=>!!s.loading,
            opacity: (el, s)=>s.loading ? '.7' : '1',
            cursor: (el, s)=>s.loading ? 'wait' : 'pointer',
            pointerEvents: (el, s)=>s.loading ? 'none' : 'auto',
            type: 'submit',
            Icon: null,
            width: '100%',
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2',
            fontWeight: '700',
            '@mobileL': {
                width: '100%',
                maxWidth: '100%'
            }
        }
    }
};

});

parcelRegister("YUaO6", function(module, exports) {

$parcel$export(module.exports, "EmailConfirmationSuccess", () => $0b712d8f87174fd9$export$740e4872145c79e6);
const $0b712d8f87174fd9$export$740e4872145c79e6 = {
    extends: 'Flex',
    flow: 'y',
    align: 'center center',
    gap: 'B',
    Icon: {
        name: 'checkmark circle',
        color: 'green',
        size: 'A'
    },
    H3: {
        text: '{{ auth.emailConfirmed.title | polyglot }}',
        margin: '0'
    },
    P: {
        text: '{{ auth.emailConfirmed.body | polyglot }}',
        textAlign: 'center',
        color: 'paragraph',
        maxWidth: 'G'
    },
    SigninButton: {
        extends: [
            'Button',
            'ClickableItem'
        ],
        text: '{{ auth.emailConfirmed.action | polyglot }}',
        margin: 'B 0 0',
        width: '100%',
        onClick: (_, el)=>{
            el.router('/signin', el.getRoot());
        }
    }
};

});

parcelRegister("5rbnd", function(module, exports) {

$parcel$export(module.exports, "UsersTableCopy", () => $3f584be09e24c414$export$bbbb5ab329022dcf);
const $3f584be09e24c414$export$bbbb5ab329022dcf = {
    H6: {
        text: '{{ members.usersTable.heading | polyglot }}',
        margin: '- - A'
    },
    Flex: {
        flow: 'y',
        childExtends: 'Grid',
        childProps: {
            align: 'center center',
            columns: '2.2em 1fr 3fr 1fr',
            padding: 'Z1 0',
            gap: 'C1',
            Avatar: {
                boxSize: 'B',
                key: (el, s)=>s.name
            },
            Name: {
                margin: '- - - -C',
                Text: {
                    tag: 'span',
                    text: '{{ name }}'
                },
                Strong: {
                    hide: (el, s)=>!s.username,
                    text: ' ({{ username }})'
                }
            },
            Email: {
                text: '{{ email }}'
            },
            Role: {}
        },
        children: (el)=>el.getRootProjectsUsers(),
        childrenAs: 'state'
    }
};

});

parcelRegister("dvkXw", function(module, exports) {

$parcel$export(module.exports, "EmailConfirmationError", () => $9d4e6da7f97f1104$export$3ea6b5c03372ccee);
const $9d4e6da7f97f1104$export$3ea6b5c03372ccee = {
    extends: 'Flex',
    flow: 'y',
    align: 'center center',
    gap: 'B',
    Icon: {
        name: 'exclMark',
        size: 'A',
        color: 'red'
    },
    H3: {
        text: '{{ auth.emailConfirmFailed.title | polyglot }}',
        margin: '0'
    },
    P: {
        text: (el, s)=>s.error || el.call('polyglot', 'auth.emailConfirmFailed.body'),
        textAlign: 'center',
        color: 'paragraph',
        maxWidth: 'G'
    },
    TryAgainButton: {
        extends: [
            'Button',
            'ClickableItem'
        ],
        text: '{{ common.action.try_again | polyglot }}',
        margin: 'B 0 0',
        width: '100%',
        onClick: async (_, el, s)=>{
            s.update({
                loading: true
            });
            await el.call('confirmEmail');
        }
    }
};

});

parcelRegister("68SJI", function(module, exports) {

$parcel$export(module.exports, "EmailConfirmationTaken", () => $478df2ea067308c5$export$f6869e7788a08cec);
// The /signup-confirmation answer to the server's 409 "Email taken": a
// pending email (demo claim) that another account took before the link was
// clicked. The server burns the token, so there is no retry — one way forward.
// Painted by the signup-confirmation page when `confirmEmail` sets
// `emailTaken`.
const $478df2ea067308c5$export$f6869e7788a08cec = {
    flow: 'y',
    align: 'center center',
    gap: 'B',
    role: 'alert',
    Icon: {
        name: 'exclMark',
        size: 'A',
        color: 'dangerInk'
    },
    H3: {
        text: '{{ auth.emailTaken.title | polyglot }}',
        margin: '0'
    },
    P: {
        text: '{{ auth.emailTaken.body | polyglot }}',
        textAlign: 'center',
        color: 'paragraph',
        maxWidth: 'G'
    },
    // Same control as the sibling panels' sign-in button (EmailConfirmationSuccess).
    SigninButton: {
        extends: [
            'Button',
            'ClickableItem'
        ],
        text: '{{ auth.emailConfirmed.action | polyglot }}',
        margin: 'B 0 0',
        width: '100%',
        onClick: (_, el)=>{
            el.router('/signin', el.getRoot());
        }
    }
};

});

parcelRegister("bniHL", function(module, exports) {

$parcel$export(module.exports, "ConfirmSetPassword", () => $84805a14dae64431$export$fa0f22ed205ea1f1);
// The /signup-confirmation step after a confirm whose first-proof cleanup
// dropped the password set before the proof (server core/auth-takeover-paths
// review r3 D4; Nika: "Ask for a password on confirm"). The person is signed
// in already (the confirm answer's fresh session is stored); this step lets
// them set a password with the single-use `setPasswordToken`, or Skip.
// Painted by the signup-confirmation page while `s.setPasswordToken` is set.
// Same field shape as ResetPasswordsForm; same button control as the sibling
// confirmation panels.
const $84805a14dae64431$export$fa0f22ed205ea1f1 = {
    flow: 'y',
    align: 'center center',
    gap: 'B',
    width: '100%',
    H3: {
        text: '{{ auth.setPassword.title | polyglot }}',
        margin: '0'
    },
    P: {
        text: '{{ auth.setPassword.body | polyglot }}',
        textAlign: 'center',
        color: 'paragraph',
        maxWidth: 'G'
    },
    NewPassword: {
        extends: 'InputField',
        width: '100%',
        Title: {
            tag: 'span',
            text: '{{ auth.setPassword.label | polyglot }}'
        },
        Input: {
            width: '100%',
            theme: 'field',
            background: 'hover',
            minHeight: 'controlH',
            round: 'radiusControl',
            fontSize: 'Z2',
            padding: '0 A',
            type: 'password',
            name: 'new-password',
            autocomplete: 'new-password',
            ariaLabel: (el)=>el.call('polyglot', 'auth.setPassword.label'),
            placeholder: (el)=>el.call('polyglot', 'auth.setPassword.placeholder'),
            onInput: (ev, el, s)=>{
                s.update({
                    newPassword: el.node.value,
                    setPasswordError: null
                });
            }
        }
    },
    ErrorNote: {
        tag: 'p',
        role: 'alert',
        margin: '0',
        color: 'dangerInk',
        fontSize: 'Z2',
        // Box reserved; only visibility changes (no layout shift).
        visibility: (el, s)=>s.setPasswordError ? 'visible' : 'hidden',
        text: '{{ auth.setPassword.error | polyglot }}'
    },
    SaveButton: {
        extends: [
            'Button',
            'ClickableItem'
        ],
        text: '{{ auth.setPassword.save | polyglot }}',
        width: '100%',
        disabled: (el, s)=>!s.newPassword || !!s.savingPassword,
        onClick: async (_, el, s)=>{
            await el.call('completeConfirmSignIn', s.newPassword || '');
        }
    },
    SkipButton: {
        extends: [
            'Button',
            'ClickableItem'
        ],
        theme: 'transparent',
        text: '{{ auth.setPassword.skip | polyglot }}',
        width: '100%',
        disabled: (el, s)=>!!s.savingPassword,
        onClick: async (_, el)=>{
            await el.call('completeConfirmSignIn');
        }
    }
};

});

parcelRegister("bNJ8P", function(module, exports) {

$parcel$export(module.exports, "TutorialsPanel", () => $897749794450038d$export$2a1dc0901352403f);
const $897749794450038d$export$2a1dc0901352403f = {
    CaptionTitle: {
        Text: {
            text: '{{ learn.docs.title | polyglot }}'
        }
    },
    DocsSidebar: {
        top: 'auto',
        padding: '0',
        fontSize: 'Z2',
        gap: 'A2',
        childProps: {
            position: 'relative',
            padding: '- 0',
            NumbCaption: {
                Numb: null,
                SquareButton: {
                    padding: 'X'
                }
            }
        }
    },
    flow: 'y',
    gap: 'A'
};

});

parcelRegister("1x6Ci", function(module, exports) {

$parcel$export(module.exports, "GovernanceFields", () => $11de016c315e9095$export$7dca2081066c7a55);
const $11de016c315e9095$export$7dca2081066c7a55 = {
    if: (el)=>el.getRootState('email').endsWith('@symbols.app'),
    flow: 'x',
    gap: 'C',
    childProps: {
        gap: 'Y',
        Icon: {
            color: 'placeholder'
        }
    },
    margin: '- B2 - auto',
    childExtends: [
        'IconText',
        'DropdownParentFocus'
    ],
    Env: {
        icon: 'fuse',
        Icon_arrow: {
            // eslint-disable-next-line no-restricted-syntax -- dropdown chevron glyph, not text
            color: 'inactive',
            name: 'arrow angle down'
        },
        Dropdown: {
            hide: (el)=>!el.getAppKey(),
            top: 'B',
            left: '0',
            align: 'start',
            ListInDropdown: {
                childExtends: [
                    'Link'
                ],
                onClick: (ev)=>ev.stopPropagation(),
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'radiusPill',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                children: ()=>[
                        {
                            href: `https://dev.symbols.app${window.location.pathname}`,
                            target: '_blank',
                            text: '{{ settings.governance.env.development | polyglot }}'
                        },
                        {
                            href: `https://staging.symbols.app${window.location.pathname}`,
                            target: '_blank',
                            text: '{{ settings.governance.env.staging | polyglot }}'
                        },
                        {
                            href: `https://symbols.app${window.location.pathname}`,
                            target: '_blank',
                            text: '{{ settings.governance.env.production | polyglot }}'
                        }
                    ]
            }
        },
        text: (el)=>el.getRootState('evn')
    },
    PlatformVersion: {
        icon: 'state',
        text: 'v',
        onRender: async (el)=>{
            // getPlatformVersion() legitimately resolves undefined right now (see
            // its own comment in shared/methods/root.js — the version import is
            // disabled pending a separate bundler decision). Concatenating that
            // straight into the label rendered the literal "vundefined" on every
            // app that mounts GovernanceFields, catalog or not. Guard so the
            // honest "no version resolved yet" state is an empty suffix, not a
            // stringified `undefined`.
            const version = await el.getPlatformVersion();
            el.update({
                text: version ? `v${version}` : 'v'
            });
        },
        Icon_arrow: {
            // eslint-disable-next-line no-restricted-syntax -- dropdown chevron glyph, not text
            color: 'inactive',
            name: 'arrow angle down'
        },
        Dropdown: {
            hide: (el)=>!el.getAppKey(),
            top: 'B',
            left: '0',
            align: 'start',
            ListInDropdown: {
                childExtends: [
                    'Link'
                ],
                onClick: (ev)=>ev.stopPropagation(),
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'radiusPill',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                children: ()=>[
                        {
                            href: (el)=>'https://github.com/symbo-ls/platform/commits/' + `v${el.getPlatformVersion()}`,
                            target: '_blank',
                            text: '{{ settings.governance.link.commit | polyglot }}'
                        },
                        {
                            href: (el)=>({
                                    production: `https://github.com/symbo-ls/platform/actions?query=branch%3Av${el.getPlatformVersion()}+event%3Aworkflow_dispatch`,
                                    staging: `https://github.com/symbo-ls/platform/actions?query=branch%3Av${el.getPlatformVersion()}+event%3Arelease`,
                                    development: `https://github.com/symbo-ls/platform/actions`
                                })[el.getRootState('env')],
                            target: '_blank',
                            text: '{{ settings.governance.link.workflow | polyglot }}'
                        },
                        {
                            href: (el)=>'https://github.com/symbo-ls/platform/tree/refs/tags/' + `v${el.getPlatformVersion()}`,
                            target: '_blank',
                            text: '{{ settings.governance.link.code | polyglot }}'
                        },
                        {
                            target: '_blank',
                            text: '{{ settings.governance.link.releaseNotes | polyglot }}',
                            href: (el)=>'https://github.com/symbo-ls/platform/releases' + `?after=v${el.getPlatformVersion()}`
                        }
                    ]
            }
        }
    }
};

});

parcelRegister("fsZBt", function(module, exports) {

$parcel$export(module.exports, "EditorTools", () => $b42941b11e1f5582$export$3489fe258094d6f6);
const $b42941b11e1f5582$export$3489fe258094d6f6 = {
    TextNavbarButtonDropdown: {
        tag: 'div',
        Icon: null,
        ignoreChildProps: true,
        ignoreChildExtends: true,
        isActive: null,
        margin: '- U - -',
        '!isActive': {
            ':hover': null,
            ':active': null
        },
        Button: {
            round: 'radiusPill',
            padding: 'Y Y1',
            ariaHaspopup: 'true',
            title: (el)=>el.call('polyglot', 'editor.tools.editOptions'),
            icon: (el)=>{
                const preffered = (el.getCanvasScope?.() || el.scope || {}).preferredEditor;
                const map = {
                    editor: 'sf pencil',
                    code: 'code',
                    sidebar: 'sidebarLeft'
                };
                return map[preffered] || map['editor'];
            },
            // Icon's box comes from width/height (boxSize), never fontSize — left
            // unset this rode the same ambient font-size cascade as every other
            // EditorTools button. Pin it to match the row explicitly.
            Icon: {
                boxSize: 'A A'
            },
            text: null,
            lineHeight: 0.9,
            align: 'end',
            onClick: (ev, el)=>{
                ev.stopPropagation();
                el.call('openDropdown', {
                    id: 'editInNavbar',
                    anchorEl: el,
                    placement: 'bottom-end',
                    content: {
                        extends: 'EditInNavbarMenu'
                    }
                });
            },
            // Brand DropdownArrow (extends Icon) only sets `fontSize: 'Y1'` — same
            // footgun: Icon ignores fontSize for sizing. And boxSize rides the
            // SPACING scale, where 'Y1' is ~4px — the chevron rendered as a speck
            // (2026-08-08 per Nika "icons sizes"). Z1 (~one step under the 12px
            // row icon) reads as the accessory glyph it is while staying visible.
            DropdownArrow: {
                margin: '- - - Y',
                boxSize: 'Z1 Z1'
            }
        },
        // @symbo.ls/dropdown (2026-06-09, task #2) — the IconButton opens the
        // EditInNavbarMenu body via the shared DropdownRoot, replacing the legacy
        // DropdownParentFocus (which stayed visible when inactive). The plugin owns
        // open/close + outside-click/ESC dismiss.
        IconButton: null
    },
    ShareBtn: {
        hide: true,
        icon: 'share outline',
        title: (el)=>el.call('polyglot', 'common.action.share'),
        isActive: (el)=>el.getWindow('componentEditor') === 'share',
        onClick: (ev, el)=>{
            if (el.getWindow('componentEditor') === 'share') el.closeWindow('componentEditor');
            else el.setWindow('componentEditor', 'share');
            el.parent.update();
        }
    },
    extends: 'NavbarButtonSet',
    gap: 'W',
    childProps: {
        '.isDisabled': {
            opacity: '.35',
            pointerEvents: 'none'
        }
    }
};

});

parcelRegister("wve4y", function(module, exports) {

$parcel$export(module.exports, "ChooseCanvas", () => $061b361a28d90d9f$export$9771f47b4c9d5e03);
const $061b361a28d90d9f$export$9771f47b4c9d5e03 = {
    CaptionTitle: {
        extends: [
            'Flex',
            'CaptionTitle'
        ],
        align: 'center',
        padding: 'X - - A',
        Text: {
            text: '{{ editor.chooseCanvas.select | polyglot }}',
            margin: '- C - -'
        },
        IconButton: {
            onClick: (ev, el)=>el.call('openRouterModal', '/add-canvas'),
            theme: 'tertiary',
            icon: 'plus',
            ariaLabel: (el)=>el.call('polyglot', 'editor.chooseCanvas.addCanvas'),
            margin: '- - - auto'
        },
        'IconButton.question': {
            theme: 'tertiary',
            icon: 'sf question',
            ariaLabel: (el)=>el.call('polyglot', 'editor.editNavbar.openDocs'),
            onClick: (ev, el)=>el.setWindow('docs', '/canvas-pages')
        }
    },
    Flex: {
        flow: 'y',
        gap: 'W2',
        margin: 'X2 - -',
        childProps: (el, s)=>({
                align: 'center',
                gap: 'Y',
                round: 'radiusPill',
                padding: 'Z A',
                isActive: s.value === el.call('getActiveCanvasPage'),
                theme: s.value === el.call('getActiveCanvasPage') ? 'field' : 'transparent',
                ':hover': {
                    theme: 'field'
                },
                '!isActive': {
                    color: 'inactive',
                    fontWeight: '400'
                },
                '.isActive': {
                    theme: 'field',
                    fontWeight: '500',
                    color: 'title'
                },
                Icon: {
                    hide: (el, s)=>!s._id,
                    order: -1,
                    name: 'url',
                    color: 'blue.35'
                },
                Text: {
                    text: '{{ value }}'
                },
                SharedLibSuffix: {
                    hide: (el, s)=>!s._id,
                    margin: '- - - -X2',
                    opacity: '.35',
                    text: '.symbo.ls'
                },
                Icon_arrow: {
                    hide: (el, s)=>!s._id,
                    margin: '- - - auto',
                    name: 'arrowUpRight',
                    color: 'disabled'
                },
                onClick: async (ev, el, s)=>{
                    if (s._id) // Same-origin canvas route — navigate in-app via the SPA router
                    // instead of spawning a new tab (sibling branches below already
                    // route in-shell via openCanvasPage / openRouterModal).
                    return el.router(`/nikoloza/${s.value}`, el.getRoot());
                    if (el.getWindow('explorerMinimized')) el.expandWindow('explorer');
                    else if (s.value === 'Add new') await el.call('openRouterModal', '/add-canvas');
                    else await el.call('openCanvasPage', s.value);
                }
            }),
        childExtends: {
            onContextmenu: (ev, el)=>{
                const data = el.scope;
                if (!data) return;
                window.requestAnimationFrame(()=>{
                    el.activateContext(ev, el);
                });
            }
        },
        childrenAs: 'state',
        children: async (el, s)=>{
            // `canvas` is absent in any host that never opened one (UI-kit
            // catalog, preview frame, a fresh shell). The optional hop belongs
            // BEFORE the dot: `canvas.pages || {}` still throws on `canvas`.
            const { canvas: canvas } = el.getRootState() || {};
            // `el.call` answers undefined for a name this host never registered
            // (framework contract, smbls element methods.js) — and a children
            // factory MUST answer an array, or the reconciler takes the whole
            // dropdown down with an unhandled rejection.
            const rows = el.call('joinArrays', [
                {
                    title: (el)=>el.call('polyglot', 'editor.chooseCanvas.default')
                },
                ...Object.values(canvas?.pages || {})
            ], s.sharedLibs || []) || [];
            return rows.map((v)=>({
                    value: v.title,
                    ...v
                }));
        },
        onRender: (el, s)=>{
            if (el.isEmbed()) return;
            window.requestAnimationFrame(async ()=>{
            // const mySharedLibs = await el.call('getMySharedLibraries')
            // const sharedLibs = mySharedLibs.map(lib => ({
            //   title: lib.key.split('.symbo.ls')[0],
            //   _id: lib.id,
            //   key: lib.key,
            //   name: lib.name,
            //   ...lib
            // }))
            // s.replace({
            //   sharedLibs
            // })
            });
        }
    }
};

});

parcelRegister("k4OXE", function(module, exports) {

$parcel$export(module.exports, "EditNavbar", () => $e9dbb62e830f6851$export$a260e8a59d12e5e);
const $e9dbb62e830f6851$export$a260e8a59d12e5e = {
    NavbarButtonSet_title: {
        padding: '0',
        Text: {
            ignoreChildExtends: true,
            text: '{{ key }}'
        },
        CopyButton: {
            title: (el)=>el.call('polyglot', 'editor.editNavbar.copyTitle'),
            value: (el, s)=>s.key
        }
    },
    EditorTools: {
        hide: true,
        margin: '- auto - C3',
        // eslint-disable-next-line no-restricted-syntax -- icon toolbar default color, not text
        color: 'inactive',
        fontSize: 'Z1'
    },
    EditorPositionNavbar: {
        margin: '- - - auto'
    },
    NavbarButtonSet_meta: {
        Que: {
            title: (el)=>el.call('polyglot', 'editor.command.docs.description'),
            icon: 'questionMark',
            isActive: false,
            onClick: (ev, el)=>{
                el.setWindow('docs', '/properties');
            }
        },
        Close: {
            title: (el)=>el.call('polyglot', 'common.action.close'),
            icon: 'crossmark',
            isActive: false,
            margin: '- - - X',
            onClick: (ev, el)=>{
                el.closeWindow('componentEditor');
            }
        }
    },
    extends: 'Navbar',
    position: 'sticky',
    top: '0',
    width: '100%',
    padding: 'W X W Z2',
    fontSize: '1rem'
};

});

parcelRegister("bRZM1", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarSection", () => $8a448fe4f779002f$export$656c39b7eabb5ebb);
const $8a448fe4f779002f$export$656c39b7eabb5ebb = {
    FilesSectionTitle: null,
    FilesSidebarTitle: {},
    FileSidebarAddNewItem: {
        Label: {
            hasItems: (el, s)=>el.call('hasItems', s.type)
        },
        show: (el, s)=>{
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            if (!isVisible) return false;
            if (s.adding) return true;
            const hasSchema = el.getSchema(s.type);
            const fileSidebarContent = el.lookup('Overflow')?.state?.fileSidebarContent;
            const isLocalLib = !fileSidebarContent || fileSidebarContent === 'Local';
            return Boolean(isLocalLib && hasSchema && Object.keys(hasSchema).length === 0 && el.isEditMode());
        },
        ignoreChildExtends: true
    },
    FilesSectionList: null,
    FilesSidebarList: {
        hide: (el, s)=>{
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            return !isVisible;
        }
    },
    extends: 'FilesSection',
    hide: (el, s)=>s.noResults === true,
    onDblclick: (ev, el, s)=>{
        el.call('setCookie', `sidebar_${s.type}`, !s.isHidden);
        s.update();
    }
};

});

parcelRegister("6q2m8", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarTitle", () => $4ac6ff9e5fec7c91$export$1243751800bf9a6d);
const $4ac6ff9e5fec7c91$export$1243751800bf9a6d = {
    IconButton_arrow: {},
    Span: {},
    'NavbarButton.add': {
        transition: 'A defaultBezier opacity',
        color: 'disabled',
        title: (el)=>el.call('polyglot', 'editor.sidebar.addNew'),
        icon: 'plus',
        fontSize: 'Z2',
        allowedAddNewDropdown: [
            'components',
            'pages',
            'functions',
            'methods',
            'snippets',
            'typography',
            'state'
        ],
        allowedAddNewPanel: [
            'semantic_color',
            'color',
            'theme',
            'media',
            'icons',
            'media',
            'spacing'
        ],
        allowedAddModal: [
            'font',
            'font_family',
            'templates',
            'cases',
            'dependencies',
            'files'
        ],
        hide: (el, s)=>{
            const activeFileSidebar = el.call('getActiveDynamicIslandCategory');
            return !el.hasProjectPermission('editMode') || activeFileSidebar !== 'Local' || !el.allowedAddNewDropdown.includes(s.type) && !el.allowedAddNewPanel.includes(s.type) && !el.allowedAddModal.includes(s.type);
        },
        margin: '- - - auto',
        onClick: async (ev, el, s)=>{
            ev.stopPropagation();
            ev.preventDefault();
            el.call('setCookie', `sidebar_${s.type}`, true);
            if (el.allowedAddNewDropdown.includes(s.type)) {
                s.toggle('adding');
                // LOOKUP-SHAPE-1: this five-deep chain used to deref unguarded
                // INSIDE a setTimeout — a miss at any link threw into nothing (no
                // error surface, no user feedback), so the focus just silently
                // never happened. Guarded link-by-link; a miss now no-ops instead
                // of throwing into the timer.
                return setTimeout(()=>{
                    const list = el.lookup('FilesSidebarList');
                    const addNewItem = list?.parent?.lookdown('FileSidebarAddNewItem');
                    const input = addNewItem?.Label?.Input;
                    input?.node?.focus();
                }, 100);
            }
            if (el.allowedAddNewPanel.includes(s.type)) return el.call('setFloatingPanel', {
                type: el.call('getSingular', s.type),
                key: '',
                value: null
            });
            await el.call('openModal', `/add-${el.getSingular(s.type.replace(/_/gu, '-'))}`);
        }
    },
    'NavbarButton.sort': {
        transition: 'A defaultBezier opacity',
        color: 'disabled',
        title: (el)=>el.call('polyglot', 'editor.sidebar.sortAz'),
        icon: (el, s)=>{
            const value = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true';
            return value ? 'textLineHeight' : 'language';
        },
        fontSize: 'Z2',
        hide: (el, s)=>{
            return ![
                'components',
                'pages',
                'files',
                'state',
                'functions',
                'methods'
            ].includes(s.type);
        },
        onClick: async (ev, el, s)=>{
            ev.stopPropagation();
            ev.preventDefault();
            const value = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true';
            el.call('setCookie', `sidebar_${s.type}_sort`, !value);
            s.update();
        }
    },
    'NavbarButton.question': {},
    extends: [
        'FilesSectionTitle'
    ]
};

});

parcelRegister("kmFWr", function(module, exports) {

$parcel$export(module.exports, "FileSidebarSearch", () => $ed3665774a621dbb$export$77e94eb672d063ca);
const $ed3665774a621dbb$export$77e94eb672d063ca = {
    extends: 'CanvasSearch',
    position: 'relative',
    zIndex: 'none',
    theme: 'field',
    round: 'radiusPill',
    Form: {
        Icon: {
            top: 'Z1',
            name: 'search outline',
            position: 'absolute',
            left: 'Z2'
        },
        Input: {
            theme: 'field',
            round: 'radiusPill',
            padding: 'Z B2 Z B2+X2',
            placeholder: (el)=>el.call('polyglot', 'common.action.filter')
        }
    },
    NavbarButton: {
        opacity: '0',
        position: 'absolute',
        top: 'X',
        right: 'X',
        theme: 'transparent',
        // eslint-disable-next-line no-restricted-syntax -- icon-only clear button (aria-labelled), not text
        color: 'inactive',
        icon: 'crossmark',
        ariaLabel: (el)=>el.call('polyglot', 'editor.sidebar.clearSearch'),
        fontSize: 'Z2',
        ':hover': {
            opacity: '1',
            color: 'title'
        },
        onClick: (ev, el)=>{
            const { node: node } = el.parent.Form.Input;
            if (node.value) {
                // LOOKUP-SHAPE-1: threw inline on a miss — guarded so the input
                // still clears/refocuses even when the sidebar isn't mounted.
                el.lookup('CanvasProjectSidebar')?.state?.update({
                    search: ''
                });
                node.value = '';
                setTimeout(()=>{
                    node.focus();
                }, 100);
            }
        }
    }
};

});

parcelRegister("cG84U", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarList", () => $93afac69c1520139$export$80a850316348ac68);
const $93afac69c1520139$export$80a850316348ac68 = {
    extends: 'FilesSectionList',
    childExtends: 'FilesSidebarListItem',
    children: async (el, s)=>{
        const FilesSidebar = el.getFilesSidebar();
        const sorted = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true';
        const list = await el.call('listSidebar', s.type, {
            search: FilesSidebar?.state?.search,
            activeFileSidebar: FilesSidebar?.state?.activeFileSidebar,
            sortIf: sorted && [
                'components',
                'pages',
                'files',
                'state',
                'functions',
                'methods'
            ].includes(s.type),
            sort: (a, b)=>{
                return a.key?.toLowerCase() < b.key?.toLowerCase() ? -1 : 1;
            }
        });
        // Drop the layer-visibility entries of artboards that no longer exist.
        // `showLayersSchema` is ONE flat map keyed by item key and shared by the
        // pages and the components sections, while `list` is only what THIS
        // section renders — `listSidebar` filters pages/components to the current
        // canvas page and to the search string — so the stale test runs against
        // the artboard DATA over every artboard type, never against one section's
        // rendered list: the old `!list.find(...)` test deleted every other
        // section's entries and every entry off the current page on each render
        // (WS-FILES-SAVE-LAYERS-VISIBILITY-STATE-MISSING-1). The per-type
        // containers, not `getItem`: its cross-type fallback throws on a missing
        // container and counts a same-named non-artboard item as an owner.
        const showLayersSchema = el.scope.showLayersSchema;
        if (list.length > 0 && showLayersSchema !== undefined && el.call('hasArtboard', s.type)) {
            const artboardTypes = el.call('getTypes', 'ARTBOARD_TYPES');
            const owned = (key)=>artboardTypes.some((type)=>el.getData(type)?.[key] || el.getSchema(type)?.[key]);
            let pruned = false;
            Object.keys(showLayersSchema).forEach((key)=>{
                if (owned(key)) return;
                delete showLayersSchema[key];
                pruned = true;
            });
            if (pruned) el.syncCanvas({
                showLayersSchema: showLayersSchema
            });
        }
        return list;
    },
    onMouseleave: (ev, el)=>{
        if (!el.getUserSettings('allowFilesidebarPreview')) return;
        el.call('setScenePosition', null, {
            visible: false
        });
    },
    // Delegated right-click handler — some sections (#2061) override
    // `childExtends` to a custom row component (IconTemplateRow,
    // ColorTemplateRow, …) and rely on the v3.14 auto-extend chain to pull
    // in `FilesSidebarListItem.onContextmenu`. When the chain breaks (e.g.
    // a custom row stops chaining FilesSidebarListItem, or `childrenAs`
    // strips lifecycle hooks from the synthesized child def), the row's
    // own `onContextmenu` is silently absent and right-click is a no-op.
    // This handler resolves the right-clicked child from the DOM, locates
    // the matching DOMQL element, and forwards to the same
    // `activateContext(ev, child)` flow that `FilesSidebarListItem` runs —
    // guarantees a working context menu for every section regardless of
    // its child extends chain.
    onContextmenu: (ev, el)=>{
        if (!ev?.target?.closest) return;
        const root = el.node;
        if (!root) return;
        let cursor = ev.target;
        let row = null;
        while(cursor && cursor !== root){
            if (cursor.parentNode === root) {
                row = cursor;
                break;
            }
            cursor = cursor.parentNode;
        }
        if (!row) return;
        // Find the matching DOMQL child by node identity. Children are keyed
        // off the rendered item state (s.key) so we walk the parent's
        // resolved children rather than rely on a DOM-side data attribute.
        const ref = el.__ref;
        if (!ref?.__children) return;
        let child = null;
        for (const k of ref.__children){
            const cand = el[k];
            if (cand?.node === row) {
                child = cand;
                break;
            }
        }
        if (!child || child.state?.editing) return;
        const key = child.state?.key;
        if (key && key !== el.getHoveredKey?.()) el.activateHovered?.(key);
        const t = setTimeout(()=>{
            el.activateContext(ev, child);
            clearTimeout(t);
        }, 0);
    },
    align: 'stretch',
    flow: 'column',
    fontSize: 'Z2',
    gap: 'X1'
};

});

parcelRegister("buRKN", function(module, exports) {

$parcel$export(module.exports, "FileSidebarAddNewItem", () => $85ec317350ee4ad5$export$77fc6e2f9af9d2ef);
const $85ec317350ee4ad5$export$77fc6e2f9af9d2ef = {
    if: (el)=>el.isEditMode(),
    Label: {
        flow: 'x',
        margin: '- X2 X2 0',
        fontSize: 'Z2',
        align: 'center center',
        hasItems: true,
        // Reviewed (border-habit sweep, design-direction.md §8): KEPT — this
        // underline is the field-affordance exception (§2.5 #4), not decorative
        // chrome. Input below is deliberately `theme: 'transparent'` with
        // `outline: '0'` at every state (rest/:focus/:focus-visible) — this
        // bottom rule is the ONLY visual signal that the row is an editable text
        // field; removing it would leave the "add new" row with no field
        // affordance at all.
        '.hasItems': {
            borderWidth: '0 0 1px',
            borderColor: 'line-highlight',
            borderStyle: 'solid',
            ':focus-within': {
                borderColor: 'dim'
            }
        },
        templateAreas: `"plus input icons"
        "error error error"`,
        templateColumns: '0.1fr 1fr 0.1fr',
        Icon: {
            gridArea: 'plus',
            // eslint-disable-next-line no-restricted-syntax -- plus-icon glyph, not text
            color: 'inactive',
            name: 'plus'
        },
        Input: {
            gridArea: 'input',
            padding: 'X2 -',
            width: '100%',
            round: '0',
            theme: 'transparent',
            // A typed value takes the brand value ink; the transparent theme's own
            // ink is a 65% alpha, one tone with the placeholder hint in light.
            color: 'title',
            outline: '0',
            name: 'sidebar-new-item',
            attr: {
                required: true,
                placeholder: (el, s)=>s.type === 'pages' ? '/add-new-page' : s.type === 'components' ? 'ComponentName' : s.type === 'functions' ? 'newFunction' : s.type === 'methods' ? 'newMethod' : s.type === 'state' ? 'state_collection' : s.type === 'secrets' ? 'new_secret' : s.type === 'dependencies' ? '@npm/dependency' : ''
            },
            '::placeholder': {
                color: 'placeholder'
            },
            ':focus-visible': {
                outline: '0'
            },
            ':focus': {
                outline: '0',
                borderColor: 'caption'
            },
            onInput: (ev, el, s)=>{
                let cleanedValue;
                const { node: node } = el;
                const { value: value } = node;
                let start = node.selectionStart;
                let end = node.selectionEnd;
                const isPage = s.type === 'pages';
                const isComponent = s.type === 'components';
                const isFunction = s.type === 'functions' || s.type === 'snippets' || s.type === 'methods';
                const isState = s.type === 'state';
                if (isPage) {
                    // Filter out invalid characters
                    const allowedCharacters = /[^a-zA-Z0-9/-]/gu;
                    cleanedValue = value.replace(allowedCharacters, '').toLowerCase();
                    if (!cleanedValue.startsWith('/')) {
                        cleanedValue = `/${cleanedValue}`;
                        start++;
                        end++;
                    }
                // Prevent typing invalid characters
                } else if (isComponent) {
                    const allowedCharacters = /[^a-zA-Z0-9_.]/g;
                    cleanedValue = value.replace(allowedCharacters, '');
                    cleanedValue = cleanedValue.split(/[_.]/u).filter(Boolean).map((v)=>v.charAt(0).toUpperCase() + v.slice(1)).join('');
                } else if (isFunction || isState) {
                    const allowedCharacters = /[^a-zA-Z0-9_]/g;
                    cleanedValue = value.replace(allowedCharacters, '');
                } else cleanedValue = value;
                if (value !== cleanedValue) {
                    el.node.value = cleanedValue;
                    node.setSelectionRange(start, end);
                }
                s.key = cleanedValue;
            }
        },
        Flex: {
            gap: 'X2',
            gridArea: 'icons',
            class: 'icons',
            opacity: 0,
            childExtends: 'IconButton',
            childProps: {
                padding: 'Y',
                fontSize: 'Z',
                theme: 'transparent',
                ':hover': {
                    theme: 'quaternary'
                }
            },
            Save: {
                type: 'submit',
                icon: 'checkmark',
                ariaLabel: (el)=>el.call('polyglot', 'common.action.save')
            },
            Close: {
                icon: 'crossmark',
                ariaLabel: (el)=>el.call('polyglot', 'common.action.cancel'),
                onClick: (ev, el, s)=>{
                    s.update({
                        key: null,
                        adding: null
                    });
                }
            }
        },
        Err: {
            hide: (el, s)=>!s.err,
            gridArea: 'error',
            position: 'absolute',
            top: '101%',
            left: '0',
            right: '0',
            theme: 'navbar',
            text: (el, s)=>s.err
        },
        ':hover .icons, :focus-within .icons': {
            opacity: 1
        }
    },
    extends: [
        'Form',
        'Grid'
    ],
    onSubmit: async (ev, el, s)=>{
        ev.preventDefault();
        const { key: key } = s;
        const type = el.getSingular(s.type) || s.parent.type;
        if (el.getSchemaItem(key, type)) {
            el.call('openNotification', {
                title: el.call('polyglot', 'editor.addComponent.exists.title').replace('{kind}', type),
                message: el.call('polyglot', 'editor.addComponent.exists.message').replace('{key}', key).replace('{kind}', type),
                type: 'error'
            });
            return;
        }
        try {
            await el.call('createItem', type, key);
            el.Label.Input.node.value = '';
        } catch (err) {
            if (!err) {
                el.node.reset();
                return s.update({
                    key: null,
                    err: null,
                    adding: false
                });
            }
            s.update({
                err: err
            });
        }
        s.update({
            key: null,
            adding: null
        });
    }
};

});

parcelRegister("cSSYh", function(module, exports) {

$parcel$export(module.exports, "TutorialsRow", () => $96152b56d68cc417$export$9fdc988a22400602);
const $96152b56d68cc417$export$9fdc988a22400602 = {
    extends: 'Group',
    background: 'highlight-reversed',
    padding: 'A1 B1',
    margin: '- -B1',
    round: 'A2',
    gap: 'A2',
    hide: (el, s)=>s.hideTutorials,
    ':hover .hide': {
        opacity: 1
    },
    // The "Hide" control rests at opacity: 0 and the rule above is its only
    // reveal — and since smbls e3333d298 every `:hover` rule is wrapped in
    // `@media (hover: hover)`, that reveal never runs on touch. Without this a
    // phone user can never dismiss the Getting Started row.
    '@coarse': {
        '.hide': {
            opacity: 1
        }
    },
    Title: {
        flow: 'x',
        align: 'center space-between',
        text: '{{ learn.gettingStarted.title | polyglot }}',
        IconText: {
            class: 'hide',
            opacity: '0',
            text: '{{ learn.gettingStarted.hide | polyglot }}',
            icon: 'eyeClosed',
            gap: 'Y1',
            transition: 'A defaultBezier opacity',
            cursor: 'pointer',
            ':hover': {
                textDecoration: 'underline'
            },
            onClick: (ev, el, s)=>{
                el.call('setCookie', 'hideTutorialsDashboard', 'true', 365);
                s.toggle('hideTutorials', {
                    preventUpdate: [
                        'ChooseProject'
                    ]
                });
            }
        }
    },
    Scrollable: {
        paddingInline: '0',
        margin: '- -B',
        padding: '- - - B',
        maxWidth: 'auto',
        width: 'auto',
        gap: 'C',
        ':before, &:after': {
            content: '""',
            widthRange: '1px'
        },
        childExtends: 'TutorialsRowItem',
        childrenAs: 'state',
        children: [
            {
                text: 'learn.videoRow.gettingStarted',
                youtubeId: 'jYU0soXY-To',
                duration: '14:31'
            },
            {
                text: 'learn.videoRow.symbolsLibrary',
                youtubeId: '1Vut-DOrfvg',
                duration: '1:50'
            },
            {
                text: 'learn.videoRow.whatIsSymbols',
                youtubeId: 'P_jjCTzS0-w',
                duration: '1:15'
            },
            {
                text: 'learn.videoRow.navigation',
                youtubeId: 'rugrjZ6WrDM',
                duration: '4:25'
            },
            {
                text: 'learn.videoRow.components',
                youtubeId: 'ScXOBnJ6ZIU',
                duration: '2:31'
            },
            {
                text: 'learn.videoRow.pages',
                youtubeId: '-qWxYRR15DM',
                duration: '0:56'
            },
            {
                text: 'learn.videoRow.calculator',
                youtubeId: 'dPZCwGEysdI',
                duration: '5:23'
            },
            {
                text: 'learn.videoRow.codeEditor',
                youtubeId: 'W2sEhoLA0Dc',
                duration: '0:23'
            },
            {
                text: 'learn.videoRow.files',
                youtubeId: 'P9D8A0258Ro',
                duration: '1:58'
            },
            {
                text: 'learn.videoRow.colors',
                youtubeId: 'i4JuUp39n50',
                duration: '2:02'
            },
            {
                text: 'learn.videoRow.spacing',
                youtubeId: 'xFgl6jG2yrw',
                duration: '2:35'
            },
            {
                text: 'learn.videoRow.icons',
                youtubeId: 'rPfSew0RGZc',
                duration: '2:19'
            }
        ]
    },
    Scrollbar: {
        extends: 'Scrollbar.scrollable'
    }
};

});

parcelRegister("3Ztwo", function(module, exports) {

$parcel$export(module.exports, "CanvasProjectSidebar", () => $2e7df7f0eb30ce86$export$32473c318172225f);
const $2e7df7f0eb30ce86$export$32473c318172225f = {
    data: {},
    state: {
        activeFileSidebar: 'Local',
        activeContent: 'ARTBOARD_TYPES'
    },
    flow: 'y',
    minHeight: 'F1',
    height: 'max-content',
    onInit: (el, s, ctx, opts)=>{
        const activeContent = el.getWindow('explorer');
        if (!el.call('isString', activeContent)) return;
        if (activeContent.includes(':')) {
            s.activeContent = activeContent.split(':')[1];
            return;
        }
        const activeContentCookie = el.call('getCookie', el.getAppKey() + '_activeContent');
        if (activeContentCookie) s.activeContent = activeContentCookie;
    },
    // iPad: native contextmenu never fires on long-press / Apple Pencil. One arm
    // at the sidebar root covers every section list + row (FilesSidebarListItem's
    // per-row menu + FilesSidebarList's delegated fallback) via the bubbling
    // synthetic contextmenu. Idempotent per node; no-op on fine pointers.
    onRender: (el)=>el.call('armLongPress'),
    ':hover': {
        '& header > a:first-child': {
            opacity: 1
        }
    },
    ExplorerSwitcher: {
        padding: 'V',
        margin: 'W2 -W1 A1'
    },
    Overflow: {
        flow: 'y',
        gap: 'B2',
        overflow: 'hidden auto',
        flex: 1,
        lazyLoad: true,
        round: 'radiusCard',
        '::-moz-scrollbar': {
            hide: true
        },
        '::-webkit-scrollbar': {
            hide: true
        },
        SectionsList: {
            flow: 'y',
            gap: 'A2',
            padding: '- Y1',
            childProps: {
                ':first-child .hr': {
                    hide: true
                }
            },
            childrenAs: 'element',
            children: (el, s)=>{
                const activeType = el.parent.activeType || el.getWindow('explorer');
                const activeContent = s.activeContent;
                if (!activeType) return [];
                const types = el.call('getActiveSidebarTypes', activeContent);
                return types.reduce((initial, type)=>{
                    if (// !s.search || //&&
                    // el.call('isString', activeType) &&
                    // activeType !== type) ||
                    !el.call('checkFeatureByPackage', type)) return initial;
                    switch(type){
                        case 'docs':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            Text: {
                                                text: '{{ editor.sidebar.learningCentre | polyglot }}'
                                            }
                                        }
                                    },
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        FileSidebarAddNewItem: null,
                                        childExtends: 'FilesSidebarListItem',
                                        // childExtends: 'CaseTemplate',
                                        childProps: {
                                            isActive: false,
                                            isCurrent: false,
                                            onClick: (ev, el, s)=>{
                                                console.log('open docs');
                                            }
                                        },
                                        childrenAs: 'props'
                                    }
                                }
                            ];
                        case 'color':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'ColorTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'gradient':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'ColorTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'semantic_color':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'SemanticColorTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'global_theme':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'GlobalThemeTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'theme':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            Text: {
                                                text: '{{ editor.sidebar.themes | polyglot }}'
                                            }
                                        }
                                    },
                                    FilesSidebarList: {
                                        columns: 'repeat(3, 1fr)',
                                        childProps: {
                                            minWidth: 'none',
                                            round: 'radiusPill'
                                        },
                                        childExtends: {
                                            extends: [
                                                'ThemeTemplateRow',
                                                'FilesSidebarListItem'
                                            ]
                                        }
                                    }
                                }
                            ];
                        case 'typography':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: {
                                        border: 'none!important',
                                        onSubmit: (ev, submitEl)=>{
                                            ev.preventDefault();
                                            submitEl.call('createTypography');
                                            submitEl.Label.Input.node.value = '';
                                            return s.update({
                                                key: null,
                                                err: null,
                                                adding: false
                                            });
                                        },
                                        Label: {
                                            Icon: {},
                                            Input: {
                                                onInput: null
                                            }
                                        }
                                    },
                                    FilesSidebarList: {
                                        gap: 'Z1',
                                        childExtends: [
                                            'TypographyTemplate',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'font':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'FontItemRow',
                                            'FilesSidebarListItem'
                                        ],
                                        childProps: {
                                            onClick: async (ev, el, s)=>{
                                                ev.preventDefault();
                                                if (el.lookup('Overflow')?.state.activeFileSidebar === 'Local') await el.call('openRouterModal', '/edit-font', {
                                                    key: s.key
                                                });
                                            }
                                        }
                                    }
                                }
                            ];
                        case 'font_family':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            text: '{{ editor.sidebar.fontFamilies | polyglot }}',
                                            Text: null
                                        }
                                    },
                                    FilesSidebarList: {
                                        childExtends: [
                                            'FontFamilyObject',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'type_templates':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {
                                        Span: {
                                            text: '{{ editor.sidebar.textStyles | polyglot }}',
                                            Text: null
                                        }
                                    },
                                    FilesSidebarList: {
                                        childExtends: [
                                            'TextStylesTemplate',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'spacing':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    gap: '0',
                                    state: {
                                        type: 'spacing'
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: {
                                        border: 'none!important',
                                        onSubmit: (ev, submitEl)=>{
                                            ev.preventDefault();
                                            submitEl.call('createSpacing');
                                            return s.update({
                                                key: null,
                                                err: null,
                                                adding: false
                                            });
                                        }
                                    },
                                    FilesSidebarList: {
                                        // display: 'flex',
                                        // flexDirection: 'column',
                                        gap: '0',
                                        // margin: '-',
                                        Default: {
                                            state: el.filterKeys(el.getDesignSystem('spacing'))
                                        },
                                        childExtends: [
                                            'SpacingTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'icons':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        // columns: 'repeat(7, 1fr)',
                                        // gap: 'W',
                                        // margin: '- -Y',
                                        // style: {
                                        //   svg: {
                                        //     // width: '100%',
                                        //     // height: '100%',
                                        //     display: 'inline-block'
                                        //     // fill: 'currentColor',
                                        //     // '*': {
                                        //     //   fill: 'currentColor'
                                        //     // }
                                        //   }
                                        // },
                                        FileSidebarAddNewItem: null,
                                        childExtends: 'IconTemplateRow'
                                    }
                                }
                            ];
                        case 'shape':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: null,
                                    FilesSidebarGrid: {
                                    }
                                }
                            ];
                        case 'cases':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    // FilesSidebarList: null,
                                    FilesSidebarList: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 'A',
                                        FileSidebarAddNewItem: null,
                                        childExtends: [
                                            'CaseTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'media':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FilesSidebarList: {
                                        childExtends: [
                                            'MediaTemplateRow',
                                            'FilesSidebarListItem'
                                        ]
                                    }
                                }
                            ];
                        case 'files':
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    },
                                    FilesSidebarTitle: {},
                                    FileSidebarAddNewItem: null,
                                    FilesSidebarList: {
                                        childProps: {
                                            flow: 'row'
                                        }
                                    }
                                }
                            ];
                        default:
                            return [
                                ...initial,
                                {
                                    extends: 'FilesSidebarSection',
                                    state: {
                                        type: type
                                    }
                                }
                            ];
                    }
                }, []);
            },
            onBeforeUpdate: (_, el, s, ctx, opts)=>Boolean(el.getWindow('explorer')) && !opts.layerClick
        }
    }
};

});

parcelRegister("16SWn", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarListItem", () => $0cf0f80a8fdac461$export$15a8054233279549);
const $0cf0f80a8fdac461$export$15a8054233279549 = {
    Span: {},
    Text: {},
    EditCode: {},
    ContextMenu: {
        extends: 'NavbarButton',
        hide: (el, s)=>!el.hasProjectPermission('editMode') || s.editing || !el.call('hasArtboard', s.type),
        class: 'layer-controls',
        icon: 'threeDots',
        ariaLabel: (el)=>el.call('polyglot', 'editor.layerNavbar.options'),
        padding: 'Y',
        margin: '-W',
        onClick: (ev, el)=>{
            ev.preventDefault();
            ev.stopPropagation();
            el.activateContext(ev);
        }
    },
    Rename: {
        extends: 'FileSidebarAddNewItem',
        show: (el, s)=>Boolean(s.editing),
        flex: 1,
        Label: {
            margin: '0 0 0 -1.4em',
            padding: '0 0 0 1.4em',
            Icon: null,
            Input: {
                flex: 1,
                value: (el, s)=>s.key,
                name: 'new-key',
                onInput: ()=>{}
            },
            Flex: {
                Save: {
                    type: 'submit'
                },
                Close: {
                    onClick: (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                        s.update({
                            editing: false
                        });
                    }
                }
            },
            Err: {
                whiteSpace: 'pre-line',
                padding: 'X Y',
                theme: 'modal',
                round: 'X',
                fontSize: 'Y2',
                position: 'static'
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const capitalizeType = el.call('capitalize', s.type);
            await el.call(`rename${capitalizeType}`, 'new-key', async (newKey)=>{
                // el.call('removeItemFromSidebar', s.type, s.key)
                // el.getCanvasCollection().update()
                el.node.reset();
                s.update({
                    editing: false,
                    key: newKey
                });
            });
        }
    },
    extends: 'FileItem',
    onBeforeUpdate: (_, el, s)=>{
        if (el.call('getCookie', `sidebar_${s.type}`) === 'false') return false;
        if (s.editing) return;
        const { node: node } = el;
        const scroll = el.getUserSettings('explorerAutoscroll') && s.key && s.key === el.getSelectedKey();
        if (!scroll) return;
        if (el.getRootData().sidebarClick) {
            el.getRootData().sidebarClick = false;
            return;
        }
        const t = setTimeout(()=>{
            if (!node || !node.scrollIntoView) return;
            node.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'center'
            });
            el.getRootData().sidebarClick = false;
            clearTimeout(t);
        }, 65);
    },
    onMouseenter: (ev, el, s)=>{
        if (!el.call('hasArtboard', s.type) || s.editing) return;
        ev.stopPropagation();
        const data = el.scope;
        if (data.inContext) return;
        const Collection = el.getCanvasCollection();
        const componentFound = Collection?.lookdown((el)=>el.state?.key === s.key);
        if (data.Collection && componentFound) el.activateHovered(componentFound);
        const allowOnChosen = el.getChosenKey() && el.getChosenKey() !== s.key;
        const allowSettings = el.getUserSettings('allowFilesidebarPreview');
        if (allowOnChosen && allowSettings) {
            const t = setTimeout(()=>{
                el.call('setScenePosition', s.key, {
                    visible: true
                });
                clearTimeout(t);
            }, 0);
        }
    },
    onMouseleave: (ev, el, s)=>{
        if (!el.call('hasArtboard', s.type) || s.editing) return;
        const data = el.scope;
        if (data.inContext) return;
        if (el.getHoveredKey() === s.key) el.activateHovered(null);
        ev.stopPropagation();
    },
    onClick: async (ev, el, s)=>{
        ev.stopPropagation();
        if (s.editing) return;
        if (el.data.dblclicking) {
            el.data.dblclicking = false;
            return;
        }
        const data = el.scope;
        el.getRootData().sidebarClick = true;
        if (s.type === 'dependencies') await el.call('openRouterModal', '/edit-dependency', {
            key: s.key
        });
        else if (s.type === 'secrets') await el.call('openRouterModal', '/edit-secret', {
            key: s.key
        });
        else if (s.type === 'files') await el.call('openRouterModal', '/edit-file', {
            key: s.key
        });
        else if ([
            'functions',
            'snippets',
            'methods'
        ].includes(s.type)) await el.call('activateFunction', s.key);
        else if (s.type === 'state') await el.call('activateState', s.key);
        else {
            // el.activateSelected(data.hovered)
            if (data.activeFunction || data.activeState) el.openWindow('editorPanels');
            // if (el.getRootState('isCmdPressed') && data.chosen) el.activateChosen(data.hovered, el, s)
            const component = el.getHovered() || el;
            const { state: state } = component;
            if (!el.call('inOnCurrentCanvasPage', component?.state?.type || state?.type, component?.state?.key || state?.key)) el.call('openCanvasPage', el.call('findKeyInOtherCanvasPages', state?.key) || 'Default');
            const t = setTimeout(()=>{
                if (data.chosen || state?.key === el.getSelectedKey()) // el.activateChosen(component?.state?.key)
                el.state.update({
                    showLayers: !el.state.showLayers
                });
                else {
                    el.activateSelected(state?.key);
                    el.zoomToNode(data.selected);
                }
                clearTimeout(t);
            }, 15);
        }
    },
    onDblclick: (ev, el, s)=>{
        if (s.editing) return;
        el.data.dblclicking = true;
        ev.stopPropagation();
        const hovered = el.getHoveredKey();
        if (el.call('hasArtboard', s.type)) el.activateChosen(hovered, el, s);
        el.activateSelected(hovered, el, s);
        el.call('clearFollowing');
        // Open the nested structure recursively using shared function
        el.call('expandAllLayersForParentComponent', el, s);
    },
    onContextmenu: (ev, el, s)=>{
        if (s.editing) return;
        if (s.key !== el.getHoveredKey()) el.activateHovered(s.key);
        const t = setTimeout(()=>{
            el.activateContext(ev, el);
            clearTimeout(t);
        }, 0);
    },
    onInit: (el, s)=>{
        if ([
            'pages',
            'components'
        ].includes(s.type)) {
            const showLayersSchema = el.call('getShowLayersSchema');
            const path = el.call('getLayerPath') || [];
            path.push('showLayers');
            const showLayers = el.call('getInObjectByPath', showLayersSchema, path) || false;
            s.update({
                showLayers: showLayers
            }, {
                preventStateUpdateListener: true
            });
        }
    },
    // ——— the layer-visibility watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-SIBLINGS-1) ———
    //
    // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the framework
    // registers it ONLY when a sibling `stateDeps` ARRAY exists, and no legacy
    // `stateUpdate` event is emitted. This block shipped with NO `stateDeps`
    // and the legacy `(changes, el, s)` signature, so expanding or collapsing
    // a layer was NEVER persisted — `onInit` read the saved schema back, so
    // every tree came back at the last state that some OTHER writer had saved.
    //
    // One self-contained dep (FA204): this row's own `showLayers` flag. The
    // effect never runs on the initial pass, so the `onInit` seed (which reads
    // the persisted value) can never write itself straight back.
    stateDeps: [
        (el, s)=>(s || {}).showLayers
    ],
    // v3.14 signature: `(el, state, context, { prev, next })`.
    onStateUpdate: (el, s, ctx, { next: next })=>{
        if (![
            'pages',
            'components'
        ].includes(s.type)) return;
        const path = el.call('getLayerPath') || [];
        path.push('showLayers');
        el.call('saveLayersVisibilityState', path, next[0]);
    }
};

});

parcelRegister("5D1TR", function(module, exports) {

$parcel$export(module.exports, "TutorialsRowItem", () => $010ebe37e97fc8a0$export$5cf11d85a75cc0fb);
const $010ebe37e97fc8a0$export$5cf11d85a75cc0fb = {
    flow: 'y',
    state: {
        text: 'learn.videoRow.gettingStarted',
        youtubeId: 'jYU0soXY-To',
        duration: '14:31'
    },
    padding: '0',
    gap: 'Y1',
    widthRange: 'F2',
    round: '0',
    overflow: 'visible',
    ':after': null,
    cursor: 'pointer',
    opacity: '0.8',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .playButton': {
            opacity: '1'
        }
    },
    onClick: (ev, el, s)=>{
        el.call('openModalVideo', `https://www.youtube.com/embed/${s.youtubeId}?controls=1&amp;autoplay=1`);
    },
    Img: null,
    Box: {
        position: 'relative',
        Img: {
            round: 'radiusCard',
            position: 'relative',
            width: '100%',
            src: 'https://img.youtube.com/vi/{{ youtubeId }}/hqdefault.jpg'
        },
        Circle: {
            flow: 'x',
            class: 'playButton',
            opacity: '0',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transition: 'A defaultBezier all',
            transform: 'translate(-50%, -50%)',
            padding: 'Z',
            round: 'radiusPill',
            // Reviewed (fixed-colour sweep): kept — this play-button scrim floats
            // over the YouTube thumbnail (arbitrary imagery), so it must stay a
            // fixed dark scrim in both themes (case 1).
            background: 'black.35',
            Icon: {
                fontSize: 'C',
                name: 'play'
            }
        }
    },
    H3: null,
    Span: {
        text: (el, s)=>el.call('polyglot', s.text || ''),
        color: 'title'
    },
    Time: {
        margin: '-Z - -',
        text: '{{ duration }}',
        fontWeight: '200',
        color: 'placeholder',
        fontSize: 'Z1'
    }
};

});

parcelRegister("9CdwW", function(module, exports) {

$parcel$export(module.exports, "DashboardSidebar", () => $7002287d6df2b5cb$export$af924ad9495a7d0a);
const $7002287d6df2b5cb$export$af924ad9495a7d0a = {
    flow: 'y',
    gap: 'C1',
    IconText: {
        order: '-1',
        fontWeight: '700',
        text: '{{ editor.dashboard.gettingStarted | polyglot }}',
        icon: 'arrow angle down',
        gap: 'Y1',
        align: 'start',
        hide: (el, s)=>!s.hideTutorials,
        cursor: 'pointer',
        ':hover': {
            textDecoration: 'underline'
        },
        Icon: {
            order: 2
        },
        onClick: (ev, el, s)=>{
            el.call('setCookie', 'hideTutorialsDashboard', 'false', 365);
            s.toggle('hideTutorials', {
                preventUpdate: [
                    'ChooseProject'
                ]
            });
        }
    },
    Title: null,
    Filter: {
        flow: 'y',
        align: 'start',
        gap: 'A',
        position: 'sticky',
        top: 'D1',
        childExtends: {
            extends: [
                'Button'
            ],
            theme: (el, s)=>s.projectsFilter === el.key ? 'secondary' : 'tertiary',
            padding: 'Z1 A2',
            onClick: async (ev, el, s)=>{
                s.update({
                    projectsFilter: el.key
                });
                el.call('setCookie', 'projectsFilter', el.key);
                el.sdk.rootBus.emit('projects:filter', el.key);
            }
        },
        All: {
            text: '{{ editor.dashboard.filter.all | polyglot }}'
        },
        Favorites: {
            text: '{{ editor.dashboard.filter.favorites | polyglot }}'
        },
        Recents: {
            text: '{{ editor.dashboard.filter.recents | polyglot }}'
        },
        New: {
            extends: [
                'Button'
            ],
            ignoreChildExtends: true,
            theme: null,
            fontWeight: '700',
            text: '{{ editor.dashboard.newProject | polyglot }}',
            isActive: false,
            margin: 'C1 - -',
            background: 'title',
            color: 'title-reversed',
            ':hover': {
                opacity: '0.85'
            },
            onClick: async (ev, el, s)=>{
                await el.call('openRouterModal', '/settings', {
                    key: '/onboarding'
                });
            }
        }
    }
};

});

parcelRegister("aoTCe", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarGrid", () => $79274961545a67fb$export$a17cdbd1e02b554e);
const $79274961545a67fb$export$a17cdbd1e02b554e = {
    extends: 'Grid',
    hide: (el, s)=>s.hide === true,
    fontSize: 'Z2',
    childrenAs: 'state',
    columns: 'repeat(8, 1fr)',
    margin: '- 0',
    gap: 'Z1',
    children: async (el, s)=>{
        const activeFileSidebar = s.parent.activeFileSidebar;
        return await el.call('listSidebar', s.type, {
            search: el.lookup('Overflow')?.state.search,
            activeFileSidebar: activeFileSidebar
        });
    }
};

});

parcelRegister("39Kwr", function(module, exports) {

$parcel$export(module.exports, "NavbarTheming", () => $24c64cb5d3679053$export$b2e5091528fe62b7);
const $24c64cb5d3679053$export$b2e5091528fe62b7 = {
    extends: 'NavbarButtonSet',
    childProps: {
        theme: 'sepia',
        background: 'transparent.0',
        isActive: (el)=>el.getRootState('globalTheme') === el.key,
        '!isActive': {
            opacity: '0.65'
        },
        '.isActive': {
            opacity: '1'
        },
        onClick: (ev, el)=>{
            const key = el.key;
            el.getRootState().update({
                globalTheme: key,
                sceneTheme: key
            });
            el.call('setCookie', 'sceneTheme', key);
            el.call('setCookie', 'globalTheme', key);
        }
    },
    children: [
        {
            key: 'light',
            ariaLabel: (el)=>el.call('polyglot', 'editor.theming.lightTheme'),
            icon: (el)=>el.getRootState('sceneTheme') === el.key.toLowerCase() ? 'sun' : 'sun outline'
        },
        {
            key: 'dark',
            ariaLabel: (el)=>el.call('polyglot', 'editor.theming.darkTheme'),
            icon: (el)=>el.getRootState('sceneTheme') === el.key.toLowerCase() ? 'moon' : 'moon outline'
        }
    ]
};

});

parcelRegister("btldR", function(module, exports) {

$parcel$export(module.exports, "GlobalNotification", () => $85a2dd7f75227c78$export$3b37f25902107e4);
// GlobalNotification — toast container. Renders one Notification child
// per entry in `root.state.notifications`. Animation + hover-pause +
// timed dismissal are all driven from shared/methods/notification.js
// — this component is purely declarative.
//
// State shape per entry:
//   {
//     id: string         // unique, generated by openNotification
//     type?: 'success' | 'error' | 'info' | 'warning'
//     title?: string
//     message?: string
//     href?: string      // optional click-through target
//     notifType?: string // source NOTIFICATION type ('ticket', 'calendar_invite',
//                        // …) — distinct from the visual `type` above; rides in
//                        // from subscribeNotifications so the click can route
//                        // to the entity's feature modal
//     metadata?: object  // source notification metadata (ticketObjectId,
//                        // eventId, …) — same origin + purpose as notifType
//     icon?: string      // overrides the leading IconText.Icon name
//     action?: { call: string, args?: any[] } // run on click in the context
//                        // of the element that raised the toast (a module's
//                        // own functions included; methods/notification.js)
//     actionLabel?: string // a polyglot key: the toast grows an inline
//                        // action capsule (Undo, View…) and `action` runs
//                        // from THAT capsule only — a body click then just
//                        // dismisses, so a stray click never fires an Undo
//     _exiting?: boolean // flipped to true ~300ms before removal so the
//                        // child plays a fade-out before unmounting
//   }
//
// Interactions:
//   click toast    → href routing (if any) → action.call (if any) →
//                     el.call('closeNotification', s) — manual dismiss
//   click X icon   → el.call('closeNotification', s) — same
//   mouseover      → el.call('pauseNotification', s.id)  — hold timer
//   mouseout       → el.call('resumeNotification', s.id) — resume timer
//
// Exit animation: the animation props read `s._exiting`. When the timer
// (or manual close) flips this flag in state, the child re-renders with the
// exit keyframes instead of the entry ones. After ~300ms the notification is
// filtered out of the array and the child unmounts.
//
// THE LOOK (white-label redesign 2026-09-26, DESIGN_SPEC §5.8; r084): every
// toast is the neutral `dialog` capsule on the `float` elevation — a pill for
// one line, `radiusCard` when a message makes it two — with the TYPE carried
// by a small leading plate: the type's ink glyph on a wash of that ink
// (success / danger / warning / accent; the title ink when untyped). It was a
// full hue fill per type. Placement: bottom-centre on `--slot-bottom`, the
// composer-top line the PageSlot already uses, so a toast never covers the
// composer (Q9 A); outside the shell it falls back to `C1`. Motion: in on
// `fadeInUpShort` (6.5%) over `C` on `springBezier`, out on `modalOutDown`
// over `B` — well inside the removal delay (EXIT_MS, methods/notification.js).
const $85a2dd7f75227c78$export$3b37f25902107e4 = {
    // FA204 / frank trap — TYPE_ICON used to be a bare module-scope const read
    // from inside the IconText.Icon `name` factory; it reads as undefined once
    // this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Moved into `scope`,
    // read via `el.scope.TYPE_ICON`.
    scope: {
        // Per-type default for the leading IconText.Icon when the caller doesn't
        // pass an explicit `icon`. Every name must resolve in a registry the
        // shell actually merges — brand designSystem/icons.js ('exclMark',
        // 'checkmark', 'info') or the shell app's own icons ('warning'). 'alert
        // circle' resolved NOWHERE and painted the hatched noIcon placeholder
        // (WS-CREDIT-TOAST-ICON-CONTRAST-1); resolvability is now pinned by
        // __tests__/globalNotificationErrorToast.test.js.
        TYPE_ICON: {
            success: 'checkmark circle',
            error: 'exclMark',
            warning: 'warning',
            info: 'info outline'
        }
    },
    childExtends: 'Notification',
    // Live region — the persistent container carries role=status + aria-live so
    // toasts are announced to screen readers as their text injects. 'polite' since
    // toasts are non-critical; the region must live on the stable container (not the
    // transient child) so it exists before content appears.
    role: 'status',
    ariaLive: 'polite',
    ariaAtomic: false,
    flow: 'y',
    gap: 'Y1',
    position: 'fixed',
    // Absolute top of the stack — toasts must always render above EVERY other
    // surface (modals 2000, dropdowns/mentions ~1300–2050, ResponsiveOverlay
    // 999999, the brand MainLoader 9990099, the Messenger chat list 9990000,
    // and even DashboardNavbar 9999999). One above the highest known layer so a
    // notification is never occluded by any chrome.
    zIndex: 10000000,
    // Above the shell call panel when one shows: the panel publishes its height
    // + gap as `--call-clear` (unset = 0). On phones the panel spans the width
    // on the same line, so a toast covered its Accept / Decline row.
    // (__tests__/toastClearsCallPanel.test.js)
    bottom: 'calc(var(--slot-bottom, var(--spacing-C1)) + var(--call-clear, 0%))',
    left: '50%',
    transform: 'translateX(-50%)',
    // Container itself shouldn't intercept pointer events when empty —
    // each toast re-enables pointer events on itself.
    pointerEvents: 'none',
    childrenAs: 'state',
    children: (el, s)=>s.notifications || [],
    childProps: (el, s)=>({
            theme: 'dialog',
            color: 'title',
            minWidth: 'F3',
            maxWidth: 'G2',
            // No right room reserved for the close X any more: it is IN FLOW at the
            // end of the line (below), so neither the text nor the action capsule
            // can ever sit under its 44px target.
            padding: 'Z 0 Z Z',
            gap: 'Z',
            align: 'center flex-start',
            round: (el, _s)=>_s.message ? 'radiusCard' : 'radiusPill',
            shadow: 'float',
            overflow: 'hidden',
            pointerEvents: 'auto',
            cursor: (el, _s)=>_s.href ? 'pointer' : 'default',
            // Reactive motion: enter on mount, exit when `_exiting` flips — the
            // longhands, so each half carries its own duration and curve.
            animationName: (el, _s)=>_s._exiting ? 'modalOutDown' : 'fadeInUpShort',
            animationDuration: (el, _s)=>_s._exiting ? 'B' : 'C',
            animationTimingFunction: (el, _s)=>_s._exiting ? 'defaultBezier' : 'springBezier',
            animationFillMode: 'both',
            onMouseover: (ev, el, _s)=>{
                el.call('pauseNotification', _s.id);
            },
            onMouseout: (ev, el, _s)=>{
                el.call('resumeNotification', _s.id);
            },
            onClick: (ev, el, _s)=>{
                // Don't dismiss when the click bubbled up from the X icon —
                // the icon's own onClick already called closeNotification and
                // stopped propagation, so this branch only fires for body clicks.
                // Feature-modal first: a ticket/event toast opens its detail modal in
                // place; everything else keeps the shared slot-vs-navigate decision
                // (openNotificationTarget.js owns the mapping — shared with
                // NotificationRow). `notifType`/`metadata` ride in from
                // subscribeNotifications; toasts without them resolve off href alone.
                // The toast's own href, else the one its type implies (a channel message
                // or missed call → the sender's CRM contact, or the CRM inbox) — the
                // same rule as the bell row (functions/notificationHrefOf.js).
                const href = el.call('notificationHrefOf', {
                    href: _s.href,
                    type: _s.notifType,
                    metadata: _s.metadata
                });
                if (href) el.call('openNotificationTarget', {
                    href: href,
                    type: _s.notifType,
                    metadata: _s.metadata
                }, el);
                // action runs AFTER href routing, BEFORE dismiss — e.g. a chat-message
                // toast's { call: 'openChatFromToast', args: [channelId] } (chat's
                // subscribeRealtime.js) opens the Messenger drawer to that channel.
                // With an `actionLabel` the action belongs to its capsule, not the body.
                // The action runs in the context of the element that RAISED the toast
                // (a module's own functions included) — runNotificationAction.
                if (_s.action?.call && !_s.actionLabel) el.call('runNotificationAction', _s);
                el.call('closeNotification', {
                    id: _s.id
                });
            },
            // The plate clips for its radius only (overflow law §3b.1): a long word
            // in the title or the message (a URL, an email) wraps instead of running
            // under the clip.
            Hgroup: {
                minWidth: '0',
                overflowWrap: 'anywhere',
                // fills the line, so the capsule and the X sit at its end
                flex: '1',
                H: {
                    color: 'title',
                    tag: 'strong',
                    fontWeight: '500',
                    text: (el, _s)=>_s.title || ''
                },
                P: {
                    color: 'caption',
                    text: (el, _s)=>_s.message || '',
                    // Don't reserve space when there's no message line.
                    hide: (el, _s)=>!_s.message
                }
            },
            // THE TYPE PLATE — the Notification's own IconText, as a 20px circle:
            // the type's ink glyph on a 14% wash of that ink. Explicit `s.icon` wins
            // the glyph; the ink follows the type (untyped = the title ink).
            IconText: {
                flexShrink: '0',
                boxSize: 'iconMd',
                round: 'radiusPill',
                align: 'center center',
                color: (el, _s)=>({
                        success: 'successInk',
                        error: 'dangerInk',
                        warning: 'warningInk',
                        info: 'accentInk'
                    })[_s.type] || 'title',
                background: 'color-mix(in srgb, currentColor 14%, var(--color-tintBase))',
                Icon: {
                    name: (el, _s)=>_s.icon || el.scope.TYPE_ICON[_s.type] || 'info outline',
                    boxSize: 'iconXs',
                    color: 'currentColor'
                },
                Text: null
            },
            // The inline action (white-label redesign 2026-09-26: the App Store's
            // install toast routes here, Undo included) — the kit's compact ghost
            // capsule at the end of the line, before the close X.
            NotificationAction: {
                extends: 'AppCapsuleBtnGhost',
                compact: true,
                order: '1',
                hide: (el, _s)=>!_s.actionLabel,
                flexShrink: '0',
                marginLeft: 'auto',
                // the 36px capsule overlaps the toast's block padding a little, so an
                // action toast keeps the one-line pill's height
                marginTop: '-Y',
                marginBottom: '-Y',
                text: (el, _s)=>el.call('polyglot', _s.actionLabel || ''),
                onClick: (ev, el, _s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (_s.action?.call) el.call('runNotificationAction', _s);
                    el.parent.call('closeNotification', {
                        id: _s.id
                    });
                }
            },
            Icon: null,
            Button: {
                type: 'button',
                ariaLabel: (el)=>el.call('polyglot', 'common.action.close'),
                // IN FLOW, last on the line (it was absolute top-right, over the
                // line's own end — the Undo capsule landed under its target). The
                // negative block margin (= the toast's own block padding) lets the
                // 44px target span the toast's height without growing a one-line
                // pill past that 44px floor.
                order: '2',
                flexShrink: '0',
                margin: '-Z 0',
                minWidth: 'controlH',
                minHeight: 'controlH',
                padding: 'Z',
                boxSizing: 'border-box',
                theme: 'transparent',
                background: 'transparent',
                color: 'caption',
                cursor: 'pointer',
                ':hover': {
                    color: 'title'
                },
                Icon: {
                    name: 'crossmark',
                    color: 'currentColor'
                },
                onClick: (ev, el, _s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    el.parent.call('closeNotification', {
                        id: _s.id
                    });
                }
            }
        })
};

});

parcelRegister("aWjer", function(module, exports) {

$parcel$export(module.exports, "SelectedArticlesPanel", () => $7f6e3d392780a69f$export$a169f90ca89f802b);
const $7f6e3d392780a69f$export$a169f90ca89f802b = {
    flow: 'y',
    hide: (el, s)=>s.activeContent !== 'TUTORIALS',
    flexDirection: 'column',
    align: 'start start',
    round: 'A1',
    padding: 'Z2 Z2',
    position: 'relative',
    fontSize: 'Z1',
    childProps: {
        flex: '0 0 auto',
        width: '100%',
        minHeight: 'auto'
    },
    Flex: {
        flexDirection: 'column',
        H1: {
            fontSize: 'B2',
            padding: '- - Z -',
            color: 'title',
            fontWeight: '500',
            text: (el)=>{
                const { name: name, username: username } = el.getRootState();
                return el.call('polyglot', 'learn.intro.greeting').replace('{name}', username || name || '');
            }
        },
        P: {
            color: 'paragraph',
            text: '{{ learn.articles.intro | polyglot }}'
        },
        Flex: {
            flow: 'y',
            // Gap replaces the per-row top divider (was `line` — border-habit
            // sweep, design-direction.md §8; §2.5 house rule: row separators
            // inside rounded cards stay banned — gap + hover tint instead).
            gap: 'X2',
            childProps: {
                padding: 'Z1 W',
                width: '100%',
                maxWidth: 'H1',
                round: 'radiusControl',
                transition: 'A defaultBezier padding',
                color: 'title',
                ':hover': {
                    background: 'hover'
                },
                onClick: (ev, el)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    el.setWindow('docs', el.href.split('/docs')[1]);
                }
            },
            children: [
                {
                    href: '/docs/intro',
                    text: '{{ learn.articles.intro2 | polyglot }}'
                },
                {
                    href: '/docs/components',
                    text: '{{ learn.articles.firstComponents | polyglot }}'
                },
                {
                    href: '/docs/pages',
                    text: '{{ learn.articles.routing | polyglot }}'
                },
                {
                    href: '/docs/how-to-code',
                    text: '{{ learn.articles.howToCode | polyglot }}'
                },
                {
                    href: '/docs/design-system',
                    text: '{{ learn.articles.dsReference | polyglot }}'
                },
                {
                    href: '/docs/element',
                    text: '{{ learn.articles.elementApi | polyglot }}'
                },
                {
                    href: '/docs/properties',
                    text: '{{ learn.articles.customProps | polyglot }}'
                },
                {
                    text: '{{ learn.articles.publishing | polyglot }}'
                },
                {
                    text: '{{ learn.articles.importExport | polyglot }}'
                },
                {
                    text: '{{ learn.articles.versioning | polyglot }}'
                },
                {
                    text: '{{ learn.articles.branching | polyglot }}'
                },
                {
                    href: '/docs/functions',
                    text: '{{ learn.articles.functions | polyglot }}'
                },
                {
                    href: '/docs/dependencies',
                    text: '{{ editor.panel.dependencies | polyglot }}'
                }
            ]
        }
    }
};

});

parcelRegister("a1063", function(module, exports) {

$parcel$export(module.exports, "SelectRoleField", () => $74aa128c4f6ea2de$export$e9a93c2a595c51f8);
const $74aa128c4f6ea2de$export$e9a93c2a595c51f8 = {
    extends: 'SelectField',
    Select: {
        name: 'role',
        id: 'role',
        childrenAs: 'props',
        children: ()=>[
                {
                    value: 'guest',
                    text: '{{ members.role.guest | polyglot }}'
                },
                {
                    value: 'editor',
                    text: '{{ members.role.editor | polyglot }}'
                },
                {
                    value: 'admin',
                    text: '{{ members.role.admin | polyglot }}'
                }
            ],
        childProps: {
            tag: 'option',
            attr: {
                selected: (el, s)=>{
                    const userRole = s.role || -1;
                    const optionValue = el.value;
                    return userRole === optionValue;
                }
            }
        }
    }
};

});

parcelRegister("2jzBU", function(module, exports) {

$parcel$export(module.exports, "SidebarSignupOverlay", () => $1af8fa9b2df03cd5$export$4350b8e18189a32a);
const $1af8fa9b2df03cd5$export$4350b8e18189a32a = {
    extends: 'SidebarPricingOverlay',
    SimpleOverlay: {
        background: 'electricBlue'
    },
    Notification: {
        onClick: (f, el, st)=>{
            el.call('openRouterModal', '/settings', {
                key: '/signup'
            });
        },
        Hgroup: {
            H: {
                text: '{{ editor.overlay.unlockEditing | polyglot }}'
            },
            P: {
                text: '{{ editor.overlay.unlockEditingDescr | polyglot }}'
            }
        }
    }
};

});

parcelRegister("kRjfO", function(module, exports) {

$parcel$export(module.exports, "ActiveCanvasUsers", () => $f2f7b1534129ca15$export$a9ad618203b48d82);
const $f2f7b1534129ca15$export$a9ad618203b48d82 = {
    flow: 'x',
    state: {
        clients: {},
        users: []
    },
    alignSelf: 'center',
    fontSize: 'X',
    children: (el, s)=>s.users,
    childExtends: 'Avatar',
    childProps: {
        avatarType: 'initials',
        opacity: 0.35,
        transition: 'B defaultBezier',
        transitionProperty: 'opacity, outline',
        data: {},
        ':hover': {
            opacity: 1
        },
        ':not(:last-child)': {
            margin: '0 -Z 0 0'
        },
        '.isActive': {
            zIndex: 2,
            opacity: 1,
            outline: '2px solid orange'
        },
        '.isFollowingYou': {
            zIndex: 2,
            opacity: 1,
            outline: '2px solid blue'
        },
        onClick: (ev, el)=>{
            const { userId: userId } = el;
            el.call('setFollowingUser', userId);
            el.parent.update();
        },
        onDblclick: (ev, el)=>{
            const { userId: userId } = el;
            el.call('askToFollow', userId);
        }
    },
    ':empty': {
        hide: true
    },
    onInit: async (el, st)=>{
        const areClientsEqual = (prev = {}, next = {})=>{
            const prevKeys = Object.keys(prev);
            const nextKeys = Object.keys(next);
            if (prevKeys.length !== nextKeys.length) return false;
            return prevKeys.every((key)=>{
                const p = prev[key] || {};
                const n = next[key] || {};
                // Fallback: use map key as _id if field missing
                const pId = p._id || key;
                const nId = n._id || key;
                // Only compare properties that affect visual rendering
                return pId === nId && p.username === n.username && p.avatar === n.avatar && p.userId === n.userId && p.followingUser === n.followingUser;
            });
        };
        el.sdk.rootBus.on('clients:updated', (data)=>{
            if (!data) return;
            const prevClients = st.clients || {};
            if (areClientsEqual(prevClients, data)) return; // nothing important changed
            // Save new clients map; the stateDeps watcher derives the `users`
            // list from it. MERGE, never `replace` — a signal-store `replace`
            // DELETES every key absent from its argument (signal/store.js
            // storeReplace), so `replace({ clients })` also dropped `users` and
            // emptied the avatar strip on every presence message.
            st.update({
                clients: data
            });
        });
    },
    // ——— the presence watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-SIBLINGS-1) ———
    //
    // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the framework
    // registers it ONLY when a sibling `stateDeps` ARRAY exists, and no legacy
    // `stateUpdate` event is emitted. This block shipped with NO `stateDeps`
    // and the legacy `(changes, el)` signature, so the derived `users` list
    // was NEVER rebuilt — the `clients:updated` bus payload landed in state
    // and the avatar strip stayed on whatever it mounted with.
    //
    // Deps (each self-contained — FA204):
    //   • `clients` — the map the bus handler in `onInit` replaces.
    //   • root `followingUser` / `userId` — the two flags the derived rows
    //     carry (`isActive`, `isFollowingYou`); a follow change must repaint
    //     the outlines without a manual `el.parent.update()`.
    // NOT a dep: `users` — the handler WRITES it; watching it would re-enter.
    stateDeps: [
        (el, s)=>(s || {}).clients,
        (el, s)=>(s && (s.root || s) || {}).followingUser,
        (el, s)=>(s && (s.root || s) || {}).userId
    ],
    // v3.14 signature: `(el, state, context, { prev, next })`.
    onStateUpdate: (el, s)=>{
        const clients = s && s.clients || {};
        // Read the two follow flags off the SAME root the deps above select,
        // not via `getRootState()` — that helper resolves through a root-state
        // registry the effect has no guarantee about, and the effect must see
        // exactly the values it subscribed to.
        const { followingUser: followingUser, userId: userId } = s && (s.root || s) || {};
        const activeUsers = Object.keys(clients).slice(0, 5).map((id)=>({
                href: clients[id].route,
                userId: id,
                key: clients[id].username,
                title: clients[id].username,
                src: clients[id].avatar,
                isActive: followingUser === clients[id].userId,
                isFollowingYou: userId === clients[id]?.followingUser
            })).filter((u)=>u.title !== 'root').filter((v, i, a)=>a.findIndex((t)=>t.userId === v.userId) === i);
        // MERGE the derived list — `replace` would delete `clients` (the key
        // this very effect watches) and immediately re-enter with an empty
        // map. `users` is deliberately NOT a dep, so this write starts no loop
        // (the legacy `preventStateUpdateListener` option is gone with the
        // legacy listener it named).
        el.state.update({
            users: activeUsers
        });
    }
};

});

parcelRegister("3KoGt", function(module, exports) {

$parcel$export(module.exports, "CanvasConnectionBar", () => $2ba8d0b76e4ae85b$export$c42f475087089848);
// A small connection-status bar: who else is active on the canvas
// (ActiveCanvasUsers) + the connection status navbar (ConnectionNavbar).
// Renamed from `CanvasConnection` 2026-07-27 — that bare name collided with
// the real SVG edge renderer at packages/canvas/components/CanvasConnection.js
// (the 88-line `<g>`/HitArea/Visible bezier-edge component used by
// /team-and-agents' `childExtends: 'CanvasConnection'`). canvas's own eager
// component barrel wins that name in every context canvas is linked
// (workspace shell, canvas's own standalone build), so this flex-strip
// component only ever rendered in scopes that link `shared` WITHOUT canvas
// (marketplace/preview/demo/gazer) — and nothing in those packages actually
// referenced it by name. See tickets/workspace.md (CanvasConnection
// duplicate-name collision).
const $2ba8d0b76e4ae85b$export$c42f475087089848 = {
    flow: 'x',
    ActiveCanvasUsers: {},
    ConnectionNavbar: {},
    gap: 'Z2'
};

});

parcelRegister("fgj8P", function(module, exports) {

$parcel$export(module.exports, "ConnectionNavbar", () => $b1c732b846853e1e$export$3e15a33dfc6fe18c);
const $b1c732b846853e1e$export$3e15a33dfc6fe18c = {
    flow: 'x',
    align: 'center space-between',
    padding: '0',
    round: 'radiusPill',
    gap: 'A',
    theme: 'canvas-card-glass',
    ':hover .avatar': {
        opacity: 0
    },
    ConnectionLabel: {
        gap: 'Y1',
        margin: '- - - A+V',
        lineHeight: 1,
        onClick: (ev, el)=>{
            el.call('openInNewTab');
        },
        ':hover': {
            textDecoration: 'underline'
        },
        Circle: {
            boxSize: 'Y1',
            isActive: true,
            position: 'relative',
            isLoading: false,
            animationIterationCount: 'infinite',
            '.isLoading': {
                animation: 'blinking',
                animationDuration: 'G2'
            },
            '!isLoading': {
                animation: null
            },
            onRender: (el, s)=>{
                // The checkpoint bus is an ENHANCEMENT, not a precondition. A host
                // that boots without an SDK (UI-kit catalog, preview frame, spec
                // host) still names the connection and still paints the dot; only
                // the auto-save blink is missing. Same guard shape as
                // packages/workspace/analyzing.js's own rootBus subscriptions.
                if (!el.sdk?.rootBus?.on) return;
                const handler = ({ origin: origin })=>{
                    if (origin === 'auto') {
                        el.update({
                            isLoading: true
                        });
                        setTimeout(()=>el.update({
                                isLoading: false
                            }), 1000);
                    }
                };
                el.sdk.rootBus.on('checkpoint:done', handler);
            }
        },
        Text: {
            maxWidth: '100%',
            text: (el)=>el.getAppKey(),
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            padding: '- - .1em'
        },
        CopyButton: null
    },
    NavbarButtonSet: {
        padding: '0 X',
        gap: 'Y',
        VersionsButton: {
            hide: (el)=>!el.hasProjectPermission('editMode'),
            icon: 'version outline',
            title: (el)=>el.call('polyglot', 'editor.connection.publishingVersions'),
            scrollToTop: false,
            onClick: (ev, el)=>{
                el.getRootState().toggle('isVersionsOpen', {
                    preventUpdate: true
                });
                el.getVersionsAside()?.update();
            }
        },
        Pub: {
            hide: (el)=>!el.hasProjectPermission('editMode'),
            icon: 'upload outline',
            title: (el)=>el.call('polyglot', 'editor.connection.publishingVersions'),
            scrollToTop: false,
            onClick: async (ev, el)=>{
                await el.call('openRouterModal', '/publish');
            }
        },
        SettingsButton: {
            extends: 'Link',
            title: (el)=>el.call('polyglot', 'editor.zoombar.settings'),
            color: 'paragraph',
            icon: 'settings outline',
            isActive: (el)=>el.getWindow('modal') === 'Settings',
            scrollToTop: false,
            onClick: async (ev, el)=>{
                await el.call('openRouterModal', '/settings', {
                    key: '/settings'
                });
            }
        },
        childProps: {
            padding: 'Y1'
        }
    }
};

});

parcelRegister("eL04l", function(module, exports) {

$parcel$export(module.exports, "SaveCheckpointControl", () => $abe5822bed314bdc$export$edd299a88e898c3d);
const $abe5822bed314bdc$export$edd299a88e898c3d = {
    flow: 'x',
    position: 'relative',
    width: '100px',
    height: '30px',
    fontSize: 'X',
    align: 'center',
    pointerEvents: 'auto',
    onInit: (el, s)=>{
        // The checkpoint bus is an ENHANCEMENT, not a precondition — see the
        // identical guard in ConnectionNavbar.js. Without an SDK the control
        // still mounts and the commit button still renders; only the AUTO-save
        // status message is missing.
        if (!el.sdk?.rootBus?.on) return;
        const handler = ({ origin: origin })=>{
            if (origin === 'auto') {
                s.status = 'autoSaved';
                setTimeout(()=>s.update({
                        status: null
                    }), 1500);
            }
        };
        el.sdk.rootBus.on('checkpoint:done', handler);
    },
    state: {
        status: null
    },
    CommitBtn: {
        extends: 'Button',
        hide: true,
        show: (el, st)=>st.status === null,
        icon: 'cloud',
        text: '{{ editor.checkpoint.commit | polyglot }}',
        width: '100%',
        onClick: async (ev, el, st)=>{
            try {
                st.update({
                    status: 'saving'
                });
                await el.sdk.checkpoint();
                st.update({
                    status: 'manualSaved'
                });
                setTimeout(()=>st.update({
                        status: null
                    }), 2500);
            } catch (err) {
                console.error(err);
                st.update({
                    status: null
                });
            }
        }
    },
    ManualSavedStatusMessage: {
        if: (el, st)=>st.status === 'manualSaved',
        tag: 'Span',
        text: '{{ editor.checkpoint.saved | polyglot }}',
        color: 'green',
        textAlign: 'center',
        width: '100%'
    },
    AutoSavedStatusMessage: {
        if: (el, st)=>st.status === 'autoSaved',
        tag: 'Span',
        text: '{{ publish.tools.autosaved | polyglot }}',
        color: 'green',
        textAlign: 'center',
        width: '100%'
    },
    SavingStatusMessage: {
        if: (el, st)=>st.status === 'saving',
        tag: 'Span',
        text: '{{ common.state.saving | polyglot }}',
        color: 'inactive',
        textAlign: 'center',
        width: '100%'
    }
};

});

parcelRegister("4j3T6", function(module, exports) {

$parcel$export(module.exports, "SelectedNavbar", () => $322bf3c8bda0b569$export$6cd19c0078491cd3);
const $322bf3c8bda0b569$export$6cd19c0078491cd3 = {
    // FA204 / frank trap — isDsKey/dsLabel/navTitle used to be bare
    // module-scope const read from inside `onDblclick`/`text` factories; they
    // read as undefined once this component is frank.toJSON'd for platform
    // delivery (workspace d6ea1142, project_frank_drops_module_local_helpers).
    // Moved into `scope`; navTitle calls its siblings via `this.<name>`
    // (object-literal properties can't see each other as bare identifiers).
    scope: {
        // Built-in design-system canvas frames are keyed `__ds/<route>` (canvas/
        // functions/canvas/state.js). They're read-only reference views, so the
        // navbar shows a friendly label and skips rename. (2026-06-17.)
        isDsKey (k) {
            return typeof k === 'string' && k.indexOf('__ds/') === 0;
        },
        // `el` is threaded through because `el.scope.navTitle(...)` binds `this`
        // to the SCOPE object, not the element — polyglot needs the element.
        dsLabel (el, k) {
            return el.call('polyglot', 'editor.selectedNavbar.dsTitle').replace('{route}', k.slice(5).replace(/^\w/, (c)=>c.toUpperCase()));
        },
        navTitle (el, k) {
            return this.isDsKey(k) ? this.dsLabel(el, k) : k;
        }
    },
    // if: (el) => el.getUserSettings('allowTitleOnArtboard'),
    state: {
        type: 'components',
        value: {},
        isEditMode: false
    },
    extends: 'EditNavbar',
    minWidth: 'G1',
    position: 'absolute',
    bottom: '100%',
    margin: 'Z -',
    left: '50%',
    transition: 'X opacity defaultBezier',
    padding: '0 W 0 Z2',
    round: 'radiusCard',
    top: 'auto',
    pointerEvents: 'auto',
    theme: 'common-box',
    // Card-outline on a floating island over live canvas content
    // (design-direction.md §8) — the prescribed separation for a floating
    // toolbar is elevation (DESIGN_LANGUAGE §2.3 `float`), not a stroke; same
    // fix as MainCanvasNavbar.js / SelectedLayerNavbar.js.
    shadow: 'float',
    width: 'calc(100% + Y1 * 2)',
    maxWidth: 'calc(100% + Y1 * 2)',
    fontSize: 'Z1',
    isEditing: (el, s)=>s.isEditMode,
    transform: 'translate3d(-50%, 0, 1px)',
    '.isEditing': {
        theme: 'field'
    },
    '!isEditing': {
        theme: 'navbar'
    },
    onBeforeUpdate: (_, el, s, ctx, opts)=>{
        s.isEditMode = Boolean(opts.force);
        const selected = el.getSelectedKey();
        if (!selected) return;
        s.key = selected;
        s.type = selected.startsWith('/') ? 'pages' : 'components';
    },
    EditorPositionNavbar: null,
    NavbarButtonSet_meta: null,
    NavbarButtonSet_title: {
        maxWidth: '40%',
        hide: (el, s)=>s.isEditMode,
        onDblclick: (ev, el, s)=>{
            // Built-in design-system frames can't be renamed — skip edit mode.
            if (el.scope.isDsKey(el.getSelectedKey())) return;
            // v2 boards: the rename pipeline behind this form (renameLegacy —
            // shared/functions/rename.js) is the v1 Form/schema flow and does not
            // rename v2 project pages; entering edit mode would offer a form whose
            // Save can't work. Skip until a v2 rename lands (tickets/workspace.md).
            if (el.call('isCanvasV2')) return;
            s.update({
                isEditMode: true
            }, {
                force: true
            });
        },
        Text: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1.7',
            ignoreChildExtends: true,
            text: (el)=>el.scope.navTitle(el, el.getSelectedKey())
        },
        CopyButton: {
            // Brand CopyButton (extends IconButton) only sets `fontSize: 'Z'` —
            // Icon ignores fontSize for its own box, so that alone doesn't pin a
            // size. boxSize rides the SPACING scale (not the fontSize scale): 'Z'
            // rendered a 7px glyph beside the row's 12px icons — too small to read
            // as a control (2026-08-08 per Nika "icons sizes"). Z2 keeps it one
            // step under the row, clearly secondary but legible.
            Icon: {
                boxSize: 'Z2 Z2'
            },
            value: (el, s)=>el.getSelectedKey()
        }
    },
    EditorTools: {
        margin: '- - - auto',
        hide: (el, s)=>s.isEditMode,
        gap: 'U',
        paddingInlineEnd: '0',
        // Icon's rendered box comes from width/height (boxSize), NEVER
        // fontSize — every button below used to leave it unset and silently
        // ride SquareButton's ambient inherited font-size, which is how this
        // row could drift out of proportion with itself. Pin one explicit
        // boxSize across the row instead (tickets/design "selected navbar
        // icon misproportions").
        PreviewBtn: {
            icon: 'sf play',
            title: (el)=>el.call('polyglot', 'editor.selectedNavbar.preview'),
            Icon: {
                boxSize: 'A A'
            },
            onClick: (ev, el, s)=>{
                // s.key seeds in onBeforeUpdate, which may not have run before the
                // first click — fall back to the live selection.
                el.activateChosen(s.key || el.getSelectedKey());
                el.call('clearFollowing');
            }
        },
        ContextBtn: {
            icon: 'three dots vertical',
            title: (el)=>el.call('polyglot', 'editor.layerNavbar.options'),
            Icon: {
                boxSize: 'A A'
            },
            onClick: (ev, el, s)=>{
                el.activateContext(ev, s.key);
            },
            order: 3
        },
        childExtends: 'NavbarButton',
        Refresh: {
            icon: 'reload outline',
            title: (el)=>el.call('polyglot', 'common.action.refresh'),
            Icon: {
                boxSize: 'A A'
            },
            onClick: (ev, el)=>{
                const key = el.getSelectedKey();
                const item = el.getItem?.(key);
                el.call('refreshComponentOnCanvas', key, item);
            }
        },
        InNewTab: {
            icon: 'arrow up right',
            title: (el)=>el.call('polyglot', 'members.sharingNavbar.newTab'),
            Icon: {
                boxSize: 'A A'
            },
            onClick: (ev, el)=>{
                const url = el.call('generatePreviewUrl');
                window.open(url, 'Symbols preview');
            }
        },
        TextNavbarButtonDropdown: {}
    },
    FileSidebarAddNewItem: {
        hide: (el, s)=>!s.isEditMode,
        flex: 1,
        padding: '- Y1 - -',
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const capitalizeType = el.call('capitalize', s.type);
            await el.call(`rename${capitalizeType}`, 'new-key', async (newKey)=>{
                el.node.reset();
                s.update({
                    isEditMode: false,
                    key: newKey
                });
            });
        },
        Label: {
            border: 'none',
            '.hasItems': null,
            margin: '0',
            Icon: null,
            Input: {
                autofocus: true,
                padding: '0',
                value: (el, s)=>{
                    return el.getSelectedKey();
                },
                onInput: ()=>{},
                attr: {
                    required: true,
                    placeholder: (el, s)=>el.call('polyglot', s.type === 'pages' ? 'editor.selectedNavbar.pathPlaceholder' : 'editor.selectedNavbar.componentPlaceholder')
                }
            },
            Flex: {
                childExtends: 'NavbarButton',
                Save: {
                    padding: 'Y2',
                    fontSize: 'A'
                },
                Close: {
                    order: 2,
                    padding: 'Y2',
                    fontSize: 'A',
                    onClick: (ev, el, s)=>{
                        s.parent.update({
                            isEditMode: false
                        });
                    }
                }
            }
        }
    }
};

});

parcelRegister("1GKsk", function(module, exports) {

$parcel$export(module.exports, "SidebarPricingOverlay", () => $13adbfdc338a06f2$export$ce5cf17922a9e345);
const $13adbfdc338a06f2$export$ce5cf17922a9e345 = {
    if: (el)=>el.isAuthorised() && el.getRootState('tier') === 'starter',
    SimpleOverlay: {
        background: 'gradient-colorful-active',
        height: 'F',
        opacity: '.9',
        zIndex: 11,
        inset: 'auto 0 0 0',
        // flat, so the atomic engine writes BOTH mask spellings (an inline style block never gets the twin)
        maskImage: 'url(data:image/jpeg;base64,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)',
        maskSize: '100% 100%'
    },
    Notification: {
        extends: [
            'Notification',
            'Link'
        ],
        onClick: (f, el, st)=>{
            el.call('openRouterModal', '/settings', {
                key: '/pricing'
            });
        },
        align: 'start start',
        zIndex: 12,
        margin: 'auto X Z',
        theme: null,
        color: 'caption',
        // The page ground as a token (was the raw custom-property reference).
        background: 'document',
        padding: 'Z2 A Z',
        fontWeight: 400,
        position: 'relative',
        gap: 'Y2',
        transition: 'B2 background defaultBezier',
        ':hover': {
            background: 'blue.15'
        },
        IconText: {
            hide: true
        },
        Hgroup: {
            H: {
                tag: 'strong',
                text: '{{ editor.overlay.unlockAll | polyglot }}'
            },
            P: {
                color: 'caption',
                text: '{{ editor.overlay.unlockAllDescr | polyglot }}'
            }
        }
    }
};

});

parcelRegister("kBwpZ", function(module, exports) {

$parcel$export(module.exports, "Tests", () => $f00068efbaccfd26$export$3253960704044f84);
const $f00068efbaccfd26$export$3253960704044f84 = {
    children: [
        'one',
        'two'
    ],
    childProps: {
        onClick: (ev, el, s)=>{
            s.update({
                act: el.text
            });
        },
        '.isAct': {
            color: 'red',
            textDecoration: 'underline'
        }
    }
};

});

parcelRegister("gLrcS", function(module, exports) {

$parcel$export(module.exports, "ExplorerSwitcher", () => $c34623cd1e48a927$export$a2171b94d0ca9189);
const $c34623cd1e48a927$export$a2171b94d0ca9189 = {
    extends: [
        'Grid',
        'Navbar'
    ],
    round: 'radiusPill',
    fontSize: 'Z',
    templateColumns: 'repeat(11, 1fr)',
    align: 'center center',
    onRender: (el)=>el.update(),
    childProps: {
        textAlign: 'center',
        isActive: (el, s)=>el.key === s.activeContent,
        onClick: (ev, el, s)=>{
            const activeContent = el.key;
            // el.call('setSidebarContent', activeContent)
            el.setWindow('explorer', 'explorer:' + activeContent);
        },
        theme: null
    },
    theme: null,
    children: [
        {
            icon: 'sf components',
            title: (el)=>el.call('polyglot', 'editor.panel.artboards'),
            key: 'ARTBOARD_TYPES'
        },
        {
            icon: 'fnOutline',
            title: (el)=>el.call('polyglot', 'editor.panel.functions'),
            key: 'FUNCTION_TYPES'
        },
        {
            icon: 'sf document',
            title: (el)=>el.call('polyglot', 'editor.panel.state'),
            key: 'STATE_TYPES'
        },
        {
            icon: 'sf assets',
            title: (el)=>el.call('polyglot', 'editor.panel.assets'),
            key: 'ASSETS_TYPES'
        },
        {
            icon: 'sf pallete',
            title: (el)=>el.call('polyglot', 'editor.panel.colors'),
            key: 'COLOR_TYPES'
        },
        {
            icon: 'sf responsive',
            title: (el)=>el.call('polyglot', 'editor.panel.responsive'),
            key: 'RESPONSIVE_TYPES'
        },
        {
            icon: 'fontFace',
            title: (el)=>el.call('polyglot', 'editor.panel.typography'),
            key: 'TYPOGRAPHY_TYPES'
        },
        {
            icon: 'spaceOutlineColored',
            title: (el)=>el.call('polyglot', 'editor.panel.spacing'),
            key: 'SPACING_TYPES'
        },
        {
            icon: 'iconsOutlineColored',
            title: (el)=>el.call('polyglot', 'editor.panel.icons'),
            key: 'ICON_TYPES'
        },
        {
            icon: 'animationsAlt',
            title: (el)=>el.call('polyglot', 'editor.panel.animation'),
            key: 'TRANSITION_TYPES'
        },
        {
            icon: 'fuse',
            title: (el)=>el.call('polyglot', 'editor.panel.integrations'),
            key: 'INTEGRATIONS_TYPES'
        }
    ],
    gap: 'V',
    childExtends: {
        extends: [
            'NavbarButton',
            'NavbarTooltipParent'
        ],
        state: null,
        round: 'radiusPill',
        padding: 'Z -',
        width: 'initial',
        aspectRatio: 'unset'
    },
    NavbarTooltip: {
        ignoreChildExtends: true,
        ignoreChildProps: true
    }
};

});

parcelRegister("1PgFA", function(module, exports) {

$parcel$export(module.exports, "MainCanvasNavbar", () => $15477c24fe16c583$export$775593b21f1bf9b7);
const $15477c24fe16c583$export$775593b21f1bf9b7 = {
    MainNav: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        LogoDropdown: {},
        TextNavbar: {}
    },
    ModesInNavbar: {
        margin: '- -Z'
    },
    CanvasPagesDropdown: {
        margin: '- -Z'
    },
    CanvasSearch: {
        flex: 1
    },
    History: {
        extends: 'NavbarButtonSet',
        gap: 'X2',
        margin: '- -Z - -Y2',
        Undo: {
            title: (el)=>el.call('polyglot', 'editor.ext.undo'),
            icon: 'undo',
            onClick: (ev, el, s)=>{
                el.sdk.undo();
            }
        },
        Redo: {
            title: (el)=>el.call('polyglot', 'editor.ext.redo'),
            icon: 'redo',
            onClick: (ev, el, s)=>{
                el.sdk.redo();
            }
        },
        History: {
            title: (el)=>el.call('polyglot', 'editor.ext.history'),
            icon: 'sf history',
            onClick: (ev, el, s)=>{
                el.getRootState().toggle('isVersionsOpen', {
                    preventUpdate: true
                });
                el.getVersionsAside()?.update();
            }
        }
    },
    EnvsNavbar: {},
    PublishNavbar: {},
    MembersNavbar: {
        margin: '- -Z2 - -'
    },
    SharingNavbar: {},
    extends: 'Navbar',
    gap: 'A2',
    round: 'radiusPill',
    padding: 'V Z',
    userSelect: 'none',
    theme: 'common-box',
    // Card-outline-as-chrome on top of an already-filled surface
    // (design-direction.md §8). This is a floating pill toolbar over live
    // canvas content (§7.8 Toolbar island presentation) — the prescribed
    // separation for that is elevation, not a stroke (DESIGN_LANGUAGE §2.3).
    shadow: 'float'
};

});

parcelRegister("KNCM2", function(module, exports) {

$parcel$export(module.exports, "TextNavbar", () => $08caca5c772e0008$export$6b8c7dc3a3321139);
const $08caca5c772e0008$export$6b8c7dc3a3321139 = {
    Insert: {
        extends: 'TextNavbarButtonDropdown',
        key: 'insert:library',
        Button: {
            icon: 'sf plus',
            text: null
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.QuickAdd': {}
                }
            }
        }
    },
    Assistant: {
        extends: 'TextNavbarButtonDropdown',
        key: 'chat',
        Button: {
            text: '{{ editor.textNavbar.assistant | polyglot }}'
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.AssistantMenu': {}
                }
            }
        }
    },
    Files: {
        extends: 'TextNavbarButtonDropdown',
        key: 'explorer',
        Button: {
            text: '{{ shell.app.files | polyglot }}'
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.MoreFilesMenu': {}
                }
            }
        }
    },
    Learn: {
        extends: 'TextNavbarButtonDropdown',
        key: 'learn',
        Button: {
            text: '{{ editor.textNavbar.learn | polyglot }}'
        },
        IconButton: {
            DropdownParentFocus: {
                Dropdown: {
                    'Dropdown.MoreLearnMenu': {}
                }
            }
        }
    },
    flow: 'x',
    onFrame: (el, s)=>{
        const explorer = el.getWindow('explorer');
        el.variables({
            explorer: explorer
        }).changed((changes, prev)=>{
            el.update();
        });
    }
};

});

parcelRegister("kFWwG", function(module, exports) {

$parcel$export(module.exports, "SearchBar", () => $f0d509095b4a9443$export$79d13b60110f33be);
const $f0d509095b4a9443$export$79d13b60110f33be = {
    extends: [
        'DropdownParentFocus'
    ],
    position: 'relative',
    theme: 'quinary',
    round: 'radiusPill',
    // `minWidth` on a letter token is a HARD floor: the component can never
    // shrink below it, so it overflows any container narrower than that — a
    // catalog cell, a narrow split pane. The intent is a PREFERRED width,
    // which is `width` + `maxWidth: '100%'`: same size when there's room,
    // shrinks instead of overflowing when there isn't (see brand DropdownField
    // for the canonical version of this fix).
    width: 'D3',
    maxWidth: '100%',
    margin: '-V - - -',
    tag: 'search',
    state: {
        recents: []
    },
    Input_trigger: null,
    Form: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        onSubmit: (ev)=>ev.preventDefault(),
        Icon: {
            fontSize: 'Z1',
            margin: '- -B2 - A',
            name: 'search'
        },
        Input: {
            round: '0',
            placeholder: (el)=>el.call('polyglot', 'shell.searchBar.placeholder'),
            padding: 'Y1 B2 Y1 C',
            theme: 'transparent',
            // A typed value takes the brand value ink; the transparent theme's own
            // ink is a 65% alpha, one tone with the placeholder hint in light.
            color: 'title',
            outline: 'none',
            appearance: 'none',
            // Native <input> has its own intrinsic min-content floor that
            // `flex: 1` alone doesn't override — same class as the root's
            // minWidth fix above, just living on the child this time.
            minWidth: '0',
            ':focus-visible': {
                outline: 'none'
            },
            '::-webkit-search-cancel-button': {
                display: 'none'
            },
            '::placeholder': {
                color: 'placeholder'
            },
            onInput: (ev, el, s)=>{
                s.update({
                    searchTerm: el.node.value
                });
            },
            flex: 1
        }
    },
    Dropdown: {
        top: '105%',
        width: '100%',
        left: '0',
        // Wrapper first, menu body LAST — the §7.7 MenuPanel surface must win the
        // merge over the brand Dropdown's legacy common-box chrome.
        extends: [
            'Dropdown',
            'CanvasSearchDropdown'
        ]
    }
};

});

parcelRegister("dziRv", function(module, exports) {

$parcel$export(module.exports, "CanvasSearch", () => $9e0d2cda2d240372$export$15f38bcfd79a2b77);
const $9e0d2cda2d240372$export$15f38bcfd79a2b77 = {
    extends: [
        'SearchBar'
    ],
    tag: 'search',
    state: {
        recents: []
    },
    onInit: (el, s)=>{
        const projectKey = el.getAppKey();
        const recentKey = projectKey + '_recentSearches';
        const recentsValue = window.localStorage.getItem(recentKey);
        let recents = JSON.parse(recentsValue || '[]');
        if (!recents.length) {
            const components = el.getSchema('components') || el.call('getData', 'components') || {};
            recents = Object.values(components).map((v)=>({
                    key: v.key,
                    type: v.type,
                    title: v.title
                }));
        }
        s.recents = recents.slice(0, 15);
    }
};

});

parcelRegister("pku4a", function(module, exports) {

$parcel$export(module.exports, "ZoomInNavbar", () => $04c2399909fb8086$export$b5f4da73219db3d9);
const $04c2399909fb8086$export$b5f4da73219db3d9 = {
    // FA204 / frank trap — getGS/getIframeWindow used to be bare module-scope
    // functions read from inside `onFrame`/`onClick`/`onDblclick` factories;
    // they read as undefined once this component is frank.toJSON'd for
    // platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called
    // via `el.scope.<name>`.
    scope: {
        getGS: ()=>window.__canvasGlobalScope,
        getIframeWindow: ()=>{
            const iframe = document.getElementById('canvas-iframe');
            return iframe?.contentWindow || window;
        },
        // ZOOMBAR-PRESET-DROPDOWN-DEAD-1 — the presets behind the arrow
        // (central decision, option A: 50/75/100/150/200% + fit). `fit` has no
        // scale of its own: it routes to the canvas's existing fit helper
        // (`fitToSelection` — fits the selection, or everything when nothing is
        // selected; the same helper ⌘1 and the `/fit` command use). Only the v2
        // project canvas registers that helper's data (the `__v2` panzoom shim),
        // so the Fit row is enabled per-frame below only on that surface — the
        // studios / tickets / infra / team boards mirror a real panzoom instance
        // and keep their own module-private fit, so Fit would be a silent no-op
        // there (a fake affordance — the very thing this ticket exists to
        // remove). Lives in `scope`, not module scope (FA204 frank trap).
        ZOOM_PRESETS: [
            {
                key: 'p50',
                label: '50%',
                scale: 0.5
            },
            {
                key: 'p75',
                label: '75%',
                scale: 0.75
            },
            {
                key: 'p100',
                label: '100%',
                scale: 1
            },
            {
                key: 'p150',
                label: '150%',
                scale: 1.5
            },
            {
                key: 'p200',
                label: '200%',
                scale: 2
            },
            {
                key: 'fit',
                label: 'editor.zoombar.fitToContent',
                fit: true
            }
        ],
        // `this` is the scope bag (el.scope.<name>() binds it). Returns true
        // when a zoom was issued, false when panzoom is not ready — the rows are
        // disabled then anyway, this is the same defense-in-depth the +/-
        // buttons carry.
        applyZoomPreset (el, preset) {
            const gs = this.getGS();
            if (!gs?.panzoomInstance || !preset) return false;
            if (preset.fit) {
                // A canvas registered through registerCanvasPanzoom (a module canvas page) brings its own fit on the instance.
                if (typeof gs.panzoomInstance.__fit === 'function') {
                    gs.panzoomInstance.__fit();
                    return true;
                }
                if (!gs.panzoomInstance.__v2) return false;
                el.call('fitToSelection');
                return true;
            }
            const win = this.getIframeWindow();
            const { x: x, y: y } = gs.positions || {
                x: 0,
                y: 0
            };
            gs.panzoomInstance.smoothZoomAbs(x + win.innerWidth / 2, y + win.innerHeight / 2, preset.scale);
            return true;
        }
    },
    // INVISIBLE-OVERLAY-EATS-CLICKS-1 #3: before this, the buttons stayed
    // enabled-looking through the ~20s the global scope takes to register on
    // a fresh boot, and each onClick silently `return`ed with zero feedback
    // (a dead app is indistinguishable from a slow one).
    //
    // ⚠️ FIRST ATTEMPT used a reactive `state.panzoomReady` + `disabled: (el,
    // s) => !s.panzoomReady` on the buttons — live-verified BROKEN (real
    // click, not synthetic dispatch: `el.update({panzoomReady:true})` fired
    // correctly from onFrame, but the child buttons' `disabled:` factory
    // never re-evaluated — both buttons stayed permanently `disabled=""`,
    // including once panzoom was genuinely ready. Reactive-prop dependency
    // tracking does not pick this one up; do not reintroduce it without
    // re-verifying live first.
    //
    // Fixed the SAME way the file already handles the % label two lines
    // down, for the same reason that comment gives (a reactive re-render
    // here has already caused a real regression once): grab the real button
    // DOM nodes from the SAME already-running per-frame loop and set
    // `.disabled`/`.title` as plain DOM property writes, which are governed
    // by the HTML spec, not this component's own reactivity. Only touched on
    // an actual readiness transition, both directions — a route switch
    // between canvas surfaces can tear one panzoom instance down before the
    // next registers, and Zoombar is one shell-root mount serving every
    // surface, so re-arming on the way down is what makes the SECOND
    // surface's boot correct too, not just the first. The % label eager-syncs
    // the moment readiness flips instead of waiting for the next scale
    // change (the bonus defect: a scale that changed via wheel-zoom, which
    // is NOT gated by these buttons, while the buttons were still dead left
    // the label frozen at its mount-time default, e.g. "100%" at a real
    // 52.5%).
    flow: 'x',
    onFrame: (el)=>{
        const pz = el.scope.getGS()?.panzoomInstance;
        const ready = !!pz;
        if (ready !== el._lastPanzoomReady) {
            el._lastPanzoomReady = ready;
            const outNode = el.node && el.node.querySelector(':scope > [data-key="NavbarButton_out"]');
            const inNode = el.node && el.node.querySelector(':scope > [data-key="NavbarButton_in"]');
            const presetsNode = el.node && el.node.querySelector(':scope > [data-key="NavbarButton_presets"]');
            const title = ready ? '' : el.call('polyglot', 'editor.zoombar.loading');
            // The cursor is deliberately NOT written here.
            // WS-ZOOMBAR-DISABLED-LOOKS-ENABLED-1 had to set `node.style.cursor`
            // imperatively, because FocusableComponent shipped `cursor: pointer`
            // inside its `style: {}` escape hatch — an INLINE declaration that beats
            // any `:disabled` stylesheet rule regardless of specificity. smbls
            // fc681ac1d moved that cursor onto the atomic engine (flat
            // `cursor: 'pointer'` plus `':disabled': { cursor: 'not-allowed' }`), so
            // the `:disabled` block each button declares below now wins on its own
            // and the imperative write became dead code
            // (WS-ZOOMINNAVBAR-IMPERATIVE-CURSOR-WORKAROUND-IS-DEAD-CODE-1).
            // Published in @symbo.ls/default-config 3.14.782; this repo resolves
            // 3.14.783. Never restore the write on a DOWNGRADE below 3.14.782 — fix
            // the dep. `packages/workspace/__tests__/zoombarCursorRidesTheAtom.test.js`
            // goes red on exactly that.
            if (outNode) {
                outNode.disabled = !ready;
                outNode.title = title || 'Zoom out';
            }
            if (inNode) {
                inNode.disabled = !ready;
                inNode.title = title || 'Zoom in';
            }
            if (presetsNode) {
                presetsNode.disabled = !ready;
                presetsNode.title = title || 'Zoom presets';
            }
        }
        // Fit row readiness is a SECOND transition: it follows which surface
        // owns the panzoom (see scope.ZOOM_PRESETS), not just whether one exists.
        const fitReady = !!(pz && (pz.__v2 || typeof pz.__fit === 'function'));
        if (fitReady !== el._lastFitReady) {
            el._lastFitReady = fitReady;
            const fitNode = el.node && el.node.querySelector('[data-key="MenuPanelItem_fit"]');
            if (fitNode) {
                fitNode.disabled = !fitReady;
                fitNode.title = fitReady ? '' : el.call('polyglot', 'editor.zoombar.fitUnavailable');
            }
        }
        const scale = pz ? pz.getTransform().scale : 0.35;
        const text = parseInt(scale * 100) + '%';
        // Update the percent label by targeting the Box's OWN node via data-key.
        // `el.Box.node` resolved to ZoomInNavbar's node in v3.14, so the previous
        // `el.Box.node.innerText = text` wiped the zoom +/- buttons + dropdown
        // arrow on every frame — collapsing the whole control to a bare "NN%"
        // (the broken layout). Setting `textContent` on the child node updates
        // only the label and leaves the buttons intact.
        const boxNode = el.node && el.node.querySelector(':scope > [data-key="Box"]');
        if (boxNode && boxNode.textContent !== text) boxNode.textContent = text;
    },
    align: 'center',
    NavbarButton_out: {
        // Static defaults matching onFrame's own not-ready branch — real state
        // corrected imperatively above the instant readiness is known, same
        // pattern as the % label's own '100%' static default just below.
        disabled: true,
        title: (el)=>el.call('polyglot', 'editor.zoombar.loading'),
        icon: 'sf zoom out',
        // WS-ZOOMBAR-DISABLED-LOOKS-ENABLED-1 — native :disabled tracks the
        // plain `.disabled` DOM writes in onFrame above for free. Canonical
        // disabled treatment (brand-language skill): dimmed ink + opacity +
        // non-pointer cursor, never color-only — same shape as CheckButton /
        // AppField / PersonaPill's ExitBtn.
        ':disabled': {
            color: 'disabled',
            opacity: '.55',
            cursor: 'not-allowed'
        },
        // `:not(:disabled)` added — plain `:not(:hover)` tied on specificity
        // with the `:disabled` block above (both class+1-pseudo) and, being
        // later in source order, won the `color` property while disabled.
        // Mutually excluding `:disabled` here makes the two states disjoint
        // instead of racing: the idle transparent-theme treatment is an
        // enabled-state affordance anyway.
        ':not(:hover):not(:disabled)': {
            theme: 'transparent'
        },
        onClick: (ev, el)=>{
            const gs = el.scope.getGS();
            // Defense in depth — a compliant browser never fires onClick on a
            // disabled control, but the guard costs nothing and this is exactly
            // the class of "handler returns early" the ticket exists to catch.
            if (!gs?.panzoomInstance) return;
            const win = el.scope.getIframeWindow();
            const { x: x, y: y } = gs.positions;
            gs.panzoomInstance.smoothZoom(x + win.innerWidth / 2, y + win.innerHeight / 2, 0.75);
        }
    },
    Box: {
        width: '7ch',
        textAlign: 'center',
        padding: '- Z',
        fontSize: 'Z2',
        color: 'paragraph',
        text: '100%',
        userSelect: 'none',
        onDblclick: (ev, el)=>{
            const gs = el.scope.getGS();
            if (!gs?.panzoomInstance) return;
            const win = el.scope.getIframeWindow();
            const { x: x, y: y } = gs.positions;
            gs.panzoomInstance.smoothZoomAbs(x + win.innerWidth / 2, y + win.innerHeight / 2, 1);
        }
    },
    NavbarButton_in: {
        disabled: true,
        title: (el)=>el.call('polyglot', 'editor.zoombar.loading'),
        icon: 'sf zoom in',
        ':disabled': {
            color: 'disabled',
            opacity: '.55',
            cursor: 'not-allowed'
        },
        ':not(:hover):not(:disabled)': {
            theme: 'transparent'
        },
        onClick: (ev, el)=>{
            const gs = el.scope.getGS();
            if (!gs?.panzoomInstance) return;
            const win = el.scope.getIframeWindow();
            const { x: x, y: y } = gs.positions;
            gs.panzoomInstance.smoothZoom(x + win.innerWidth / 2, y + win.innerHeight / 2, 1.25);
        }
    },
    // ZOOMBAR-PRESET-DROPDOWN-DEAD-1 — the arrow used to be a bare
    // `DropdownArrow: { margin: '- - - X2' }` here: an Icon with no sibling
    // Dropdown, no onClick, not a button — a fake affordance. It is now the
    // third NavbarButton of the stepper (same circle, same transparent idle,
    // same disabled-until-ready mechanism as +/- above) carrying the house
    // DropdownParentFocus idiom the sibling navbars use (EnvsNavbar,
    // ModesInNavbar, CanvasPagesDropdown): focus-within opens the child
    // Dropdown, blur / outside click / a row click closes it, Escape below.
    //
    // INLINE, NOT THE openDropdown PORTAL, ON PURPOSE: the shell's DropdownRoot
    // (10010) sits under CreditBlocker's gate (10300) by design ("a leftover
    // open menu must not float over the gate"), while this whole bar sits
    // above it (10310 — pan/zoom is a pure read, parent ticket). A child
    // Dropdown shares the bar's stacking context, so the menu is reachable
    // through the gate exactly like the buttons, with no ladder change.
    NavbarButton_presets: {
        // Explicit, not key-derived: a literal `extends` REPLACES the key's
        // implicit NavbarButton (live-verified: `extends: 'DropdownParentFocus'`
        // alone rendered a bare 12px <div>), so both are listed — same shape as
        // ModesInNavbar's `extends: ['CanvasButton', …, 'DropdownParentFocus']`.
        extends: [
            'NavbarButton',
            'DropdownParentFocus'
        ],
        disabled: true,
        title: (el)=>el.call('polyglot', 'editor.zoombar.presets'),
        aria: {
            haspopup: 'menu'
        },
        ':disabled': {
            color: 'disabled',
            opacity: '.55',
            cursor: 'not-allowed'
        },
        ':not(:hover):not(:disabled)': {
            theme: 'transparent'
        },
        // Escape closes: DropdownParentFocus only closes on blur. The focused
        // node (the trigger or a row) is ev.target — blur() is the one write
        // the DOM contract allows on a node.
        onKeydown: (ev)=>{
            if (ev.key !== 'Escape') return;
            ev.stopPropagation();
            if (ev.target && typeof ev.target.blur === 'function') ev.target.blur();
        },
        // The idiom's own trigger toggles by comparing `activeElement` AT CLICK
        // time — but Chrome has already moved focus onto this checkbox on
        // mousedown, so a first real click opened and closed the menu in one
        // gesture (live-verified on this node: activeElement === body right after
        // the click). Decide on mousedown instead: already focused means open →
        // keep focus from re-landing and blur (close); otherwise the default
        // focus move opens it. The click itself is then a no-op.
        Input_trigger: {
            onMousedown: (ev, el)=>{
                if (!el.node || !el.node.matches(':focus')) return;
                ev.preventDefault();
                el.node.blur();
            },
            onClick: ()=>{}
        },
        DropdownArrow: {},
        // Opens UPWARD and right-aligned: the bar is docked bottom-right.
        Dropdown: {
            bottom: '115%',
            top: 'auto',
            right: '0',
            left: 'auto',
            round: 'radiusCard',
            // The brand Dropdown is the positioned/animated shell; the visible
            // surface is the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7),
            // same nesting as ModesInNavbar's Dropdown.MoreModesMenu.
            MenuPanel: {
                role: 'menu',
                // The menu lives INSIDE the <button> (Button base: 700) — rows are
                // body weight, not button weight (brand weight law: 400 body).
                fontWeight: '400',
                ariaLabel: (el)=>el.call('polyglot', 'editor.zoombar.presets'),
                MenuPanelItem_p50: {
                    role: 'menuitem',
                    text: '50%',
                    onClick: (ev, el)=>{
                        el.scope.applyZoomPreset(el, el.scope.ZOOM_PRESETS[0]);
                        el.node?.blur?.();
                    }
                },
                MenuPanelItem_p75: {
                    role: 'menuitem',
                    text: '75%',
                    onClick: (ev, el)=>{
                        el.scope.applyZoomPreset(el, el.scope.ZOOM_PRESETS[1]);
                        el.node?.blur?.();
                    }
                },
                MenuPanelItem_p100: {
                    role: 'menuitem',
                    text: '100%',
                    onClick: (ev, el)=>{
                        el.scope.applyZoomPreset(el, el.scope.ZOOM_PRESETS[2]);
                        el.node?.blur?.();
                    }
                },
                MenuPanelItem_p150: {
                    role: 'menuitem',
                    text: '150%',
                    onClick: (ev, el)=>{
                        el.scope.applyZoomPreset(el, el.scope.ZOOM_PRESETS[3]);
                        el.node?.blur?.();
                    }
                },
                MenuPanelItem_p200: {
                    role: 'menuitem',
                    text: '200%',
                    onClick: (ev, el)=>{
                        el.scope.applyZoomPreset(el, el.scope.ZOOM_PRESETS[4]);
                        el.node?.blur?.();
                    }
                },
                MenuPanelItem_fit: {
                    role: 'menuitem',
                    text: '{{ editor.zoombar.fitToContent | polyglot }}',
                    // Static default, corrected per-frame (see onFrame's fit transition).
                    disabled: true,
                    title: (el)=>el.call('polyglot', 'editor.zoombar.fitUnavailable'),
                    // WS-ZOOMBAR-DISABLED-LOOKS-ENABLED-1 — MenuPanelItem's base sets
                    // cursor: 'pointer' unconditionally with no :disabled step.
                    ':disabled': {
                        color: 'disabled',
                        opacity: '.55',
                        cursor: 'not-allowed'
                    },
                    onClick: (ev, el)=>{
                        el.scope.applyZoomPreset(el, el.scope.ZOOM_PRESETS[5]);
                        el.node?.blur?.();
                    }
                }
            }
        }
    }
};

});

parcelRegister("83ZB1", function(module, exports) {

$parcel$export(module.exports, "ModesInNavbar", () => $5dee6240ff19028a$export$ba77faaf886999b4);
const $5dee6240ff19028a$export$ba77faaf886999b4 = {
    Default: {
        isActive: (el, s)=>el.isCanvasMode('defaultMode'),
        title: (el)=>el.call('polyglot', 'editor.mode.default'),
        icon: 'sf cursor',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('defaultMode');
        }
    },
    Inspect: {
        isActive: (el, s)=>el.isCanvasMode('inspectMode'),
        title: (el)=>el.call('polyglot', 'editor.mode.inspect'),
        icon: 'sf inspect',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('inspectMode');
        }
    },
    Pan: {
        isActive: (el, s)=>el.isCanvasMode('panningMode'),
        title: (el)=>el.call('polyglot', 'editor.mode.pan'),
        icon: 'sf move',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('panningMode');
        }
    },
    Viewing: {
        isActive: (el, s)=>el.isCanvasMode('isViewing'),
        title: (el)=>el.call('polyglot', 'editor.mode.view'),
        icon: 'sf eye',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('isViewing');
        },
        hide: true
    },
    Comment: {
        isActive: (el, s)=>el.isCanvasMode('isCommenting'),
        title: (el)=>el.call('polyglot', 'editor.mode.comment'),
        icon: 'sf comment',
        '!isActive': {
            ':not(:hover)': {
                theme: 'transparent'
            }
        },
        onClick: (ev, el, s)=>{
            el.setCanvasMode('isCommenting');
        },
        hide: true
    },
    CanvasButton: {
        ignoreChildProps: true,
        ignoreChildExtends: true,
        lineHeight: 1,
        padding: 'X',
        round: 'X',
        margin: '- - - -W',
        ariaLabel: (el)=>el.call('polyglot', 'editor.mode.more'),
        onClick: async (ev, el)=>{
            ev.stopPropagation();
        },
        DropdownArrow: {},
        extends: [
            'CanvasButton',
            'Flex',
            'DropdownParentFocus'
        ],
        Dropdown: {
            top: 'C3',
            left: '-D1',
            'Dropdown.MoreModesMenu': {}
        }
    },
    extends: 'NavbarButtonSet',
    gap: 'W2',
    onFrame: (el, s)=>{
        const canvasMode = el.getCanvasMode();
        el.variables({
            canvasMode: canvasMode
        }).changed((_)=>{
            el.update();
        });
    },
    align: 'center',
    onRender: (el)=>el.update()
};

});

parcelRegister("eWL94", function(module, exports) {

$parcel$export(module.exports, "CanvasSearchDropdown", () => $ae1b0d884b0964f5$export$b8abeb8be44361a4);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7,
// bespoke-menus wave): MenuPanel shell; the CanvasSearchItem pill rows are
// compound result rows (type icon + key + per-type action buttons), not
// menu-command rows, so they keep their own chassis — same call as the
// EnvItem/DomainItem cards in Dropdown.Envs. Deleted with the re-chassis: the
// hand-rolled `padding: 'Z1 A'` shell (MenuPanel pads Y) and the list's
// `margin: '- -Z2'` pull (it compensated that padding; under the Y body it
// would overflow by Z2 − Y and clip).
//
// Both consumers (SearchBar, ComponentAddressBar) merge this body INTO the
// brand Dropdown wrapper — `extends: ['Dropdown', 'CanvasSearchDropdown']`,
// menu body LAST so the MenuPanel surface (dialog theme, radiusCard, overlay
// elevation) wins over the wrapper's legacy common-box chrome while the
// wrapper keeps contributing positioning, flip logic and visibility. The
// wrapper's bolted-on @dark/@light boxShadow pair is nulled here: §7.7 puts
// menus on the `overlay` elevation token, and the pair's case-block
// !important would otherwise beat the token in both schemes.

const $ae1b0d884b0964f5$export$b8abeb8be44361a4 = {
    extends: 'MenuPanel',
    gap: 'A',
    minWidth: 'H',
    scope: {},
    '@dark': {
        boxShadow: null
    },
    '@light': {
        boxShadow: null
    },
    CaptionTitle: {
        // Align the caption with the house Z1 label inset.
        padding: '- Z1',
        Text: {
            text: (el, s)=>el.call('polyglot', s.searchTerm ? 'editor.canvasSearch.results' : 'editor.canvasSearch.recent')
        }
    },
    Items: {
        // Z gap between the radiusPill result rows — the dense result list keeps
        // its pill rhythm (rows own their inset), so no gap-0 command-list here.
        gap: 'Z',
        flow: 'y',
        onInit: async (el, s)=>{
            const fuse = await (parcelRequire("dp7yT"));
            // LIVENESS GATE — the page can change while that import is pending, and
            // an `onInit` that resumes into a removed element reads null. smbls
            // `dispose()` nulls BOTH `element.node` and `element.parent`
            // (packages/element/src/dispose.js), so the read of
            // `el.parent.typesToIndex` below threw
            // `Cannot read properties of null (reading 'typesToIndex')` on the
            // served catalog every time pagination replaced the grid mid-import.
            // An ordinary user reproduces it by navigating during the same window.
            //
            // The test is the DISPOSE SIGNATURE, deliberately not
            // `node.isConnected`. The framework learned that lesson first: the
            // onFrame loop in smbls packages/element/src/create.js used to return
            // early on `!node.isConnected` and killed itself, because during an
            // initial top-down mount a child completes before the ROOT is attached
            // to the document. Its comment states the rule this line follows — the
            // element is dead only when it was disposed. `__tests__/
            // asyncLifecycleLiveness.test.js` keeps a control on the mid-mount case
            // so nobody trades this back for an isConnected check.
            if (!el.node || !el.parent) return;
            const Fuse = fuse.default;
            const fuseOptions = {
                isCaseSensitive: false,
                shouldSort: true,
                findAllMatches: true,
                includeScore: true,
                threshold: 0.3,
                keys: [
                    'key',
                    'title',
                    'code'
                ]
            };
            // Arrow form, not `function mapBucketToItems () {}` — FA207: frank
            // re-emits each handler as standalone source, and a nested function
            // DECLARATION inside it does not survive that rewrite.
            const mapBucketToItems = (bucketObj, type)=>{
                if (!bucketObj) return [];
                return Object.values(bucketObj).map((item)=>({
                        key: item.key,
                        title: item.title || '',
                        code: item.code || '',
                        type: type
                    })).filter((v)=>v.key);
            };
            const typesArr = el.parent.typesToIndex || [
                'components',
                'pages',
                'functions',
                'state',
                'files'
            ];
            const searchItems = typesArr.flatMap((bucket)=>mapBucketToItems(el.getSchema?.(bucket), bucket));
            el.scope.fuse = new Fuse(searchItems, fuseOptions);
        },
        children: (el, s)=>{
            if (!s.searchTerm) return s.recents;
            const fuse = el.scope.fuse;
            // The index is built by an ASYNC onInit, so a keystroke can land before
            // it exists — and now also on the removal path above, which leaves the
            // slot empty on purpose. Answer the recents rather than throw.
            if (!fuse) return s.recents || [];
            // Arrow form — FA207, same reason as mapBucketToItems above.
            const searchAll = (query)=>fuse.search(query).map((r)=>({
                        key: r.item.key,
                        title: r.item.title,
                        code: r.item.code,
                        type: r.item.type,
                        score: r.score
                    }));
            const result = searchAll(s.searchTerm);
            return result;
        },
        childrenAs: 'state',
        childExtends: 'CanvasSearchItem'
    }
};

});
parcelRegister("dp7yT", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hISor"))) : import("hISor")).then(()=>parcelRequire('gYTwq'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("3xzmz", function(module, exports) {

$parcel$export(module.exports, "ThemesInNavbar", () => $293fe28461e925e9$export$b868767c26e65391);
const $293fe28461e925e9$export$b868767c26e65391 = {
    Dark: {
        title: (el)=>el.call('polyglot', 'editor.theming.darkMode'),
        isActive: (el)=>el.getRootState('sceneTheme') === 'dark',
        theme: 'sepia',
        icon: (el, s)=>el.getRootState('sceneTheme') === 'dark' ? 'moon' : 'moon outline',
        onClick: (ev, el, s)=>{
            const key = 'dark';
            el.getRootState().update({
                globalTheme: key,
                sceneTheme: key
            });
            el.getRoot().call('router', window.location.pathname);
            el.getRoot().call('setCookie', 'sceneTheme', key);
            el.getRoot().call('setCookie', 'globalTheme', key);
        }
    },
    Light: {
        title: (el)=>el.call('polyglot', 'editor.theming.lightMode'),
        isActive: (el)=>el.getRootState('sceneTheme') === 'light',
        theme: 'sepia',
        icon: (el, s)=>el.getRootState('sceneTheme') === 'light' ? 'sun' : 'sun outline',
        onClick: (ev, el, s)=>{
            const key = 'light';
            el.getRootState().update({
                globalTheme: key,
                sceneTheme: key
            });
            el.getRoot().call('router', window.location.pathname);
            el.getRoot().call('setCookie', 'sceneTheme', key);
            el.getRoot().call('setCookie', 'globalTheme', key);
        }
    },
    extends: 'NavbarButtonSet',
    gap: 'W2'
};

});

parcelRegister("jibsX", function(module, exports) {

$parcel$export(module.exports, "CanvasSearchItem", () => $e0b897aef948a3e4$export$1057bd021b8a4b43);
const $e0b897aef948a3e4$export$1057bd021b8a4b43 = {
    Icon: {
        color: 'currentColor',
        margin: '- Y1 - -',
        fontWeight: '100',
        name: (el, s)=>({
                components: 'sfComponents',
                pages: 'sfPage',
                functions: 'fnOutline',
                state: 'sfDocument',
                files: 'sfAssets'
            })[s.type],
        opacity: '1',
        fontSize: 'A1'
    },
    Text: {
        text: '{{ key }}',
        margin: '- C - -',
        fontSize: 'A1'
    },
    Flex_Buttons: {
        gap: 'Y1',
        margin: '- - - auto',
        childExtends: [
            'CanvasButton',
            'IconButton'
        ],
        childProps: {
            padding: 'Y'
        },
        Target: {
            if: (el, s)=>el.call('hasType', 'ARTBOARD_TYPES', s.type),
            icon: 'target',
            ariaLabel: (el)=>el.call('polyglot', 'editor.canvasSearch.locateOnCanvas'),
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                el.call('openArtboardItem', s.type, s.key);
            }
        },
        Open: {
            if: (el, s)=>el.call('hasType', 'ARTBOARD_TYPES', s.type),
            icon: 'arrow up right',
            ariaLabel: (el)=>el.call('polyglot', 'common.action.open'),
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                el.call('activateChosen', s.key, s.type);
            }
        },
        OpenCode: {
            if: (el, s)=>el.call('hasType', 'FUNCTION_TYPES', s.type) || el.call('hasType', 'STATE_TYPES', s.type),
            icon: 'code',
            ariaLabel: (el)=>el.call('polyglot', 'editor.canvasSearch.openCode'),
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                el.call('activateFunction', s.key);
            }
        },
        TargetFile: {
            if: (el, s)=>el.call('hasType', 'ASSETS_TYPES', s.type),
            icon: 'target',
            ariaLabel: (el)=>el.call('polyglot', 'editor.canvasSearch.locateInFiles'),
            onClick: async (ev, el, s)=>{
                ev.stopPropagation();
                await el.call('setSidebarContent', 'files');
            }
        }
    },
    extends: [
        'KeyValueColumnFields'
    ],
    round: 'radiusPill',
    align: 'center',
    padding: 'X Z X A',
    onClick: (ev, el, s)=>{
        el.call('openItem', s.type, s.key);
        const projectKey = el.getAppKey();
        const recentsKey = projectKey + '_recentSearches';
        const recents = s.parent.recents.filter((r)=>r.key !== s.key);
        recents.unshift(s.parse());
        s.parent.recents = recents;
        const recentsValue = JSON.stringify(s.parent.recents);
        window.localStorage.setItem(recentsKey, recentsValue);
    },
    ':hover': {
        '& svg': {
            opacity: 1
        }
    }
};

});

parcelRegister("dXJxf", function(module, exports) {

$parcel$export(module.exports, "InsertPanel", () => $a2a41b695b2e5bb4$export$344c3c4996334393);
const $a2a41b695b2e5bb4$export$344c3c4996334393 = {
    flow: 'y',
    fontSize: 'Z2',
    padding: 'A+Z Z2',
    gap: 'C',
    overflow: 'hidden auto',
    QuickAddPanel: {},
    Line: {
        margin: '-A -A -Z'
    },
    ImportInInsert: {},
    Line_2: {
        margin: '- -A'
    },
    LibraryFromInsert: {},
    Line_3: {
        margin: '- -A'
    },
    DataSourcesInInsert: {},
    Line_4: {
        margin: '- -A'
    },
    IntegrationsInInsert: {}
};

});

parcelRegister("cSZ5I", function(module, exports) {

$parcel$export(module.exports, "QuickAddPanel", () => $9619ea98faaef1d3$export$130c02e5d9ffc2f1);
const $9619ea98faaef1d3$export$130c02e5d9ffc2f1 = {
    flow: 'y',
    state: {
        type: 'components'
    },
    tag: 'form',
    gap: 'Z',
    onSubmit: (ev, el, s)=>{
        ev.preventDefault();
        el.call('createItem', s.type, s.key);
    },
    CaptionTitle: {
        Text: {
            text: '{{ editor.quickAdd.title | polyglot }}'
        }
    },
    Flex: {
        gap: 'X',
        margin: '- - - -Z+W',
        Select_action: {
            background: 'none',
            color: 'currentColor',
            padding: 'X Y2',
            width: 'D3',
            onChange: (ev, el, s, ctx)=>{
                const value = ev.target.value;
                if (value) s.update({
                    action: value
                });
            },
            children: [
                {
                    text: '{{ common.action.create | polyglot }}',
                    value: 'create'
                },
                {
                    text: '{{ editor.quickAdd.reuse | polyglot }}',
                    value: 'reuse'
                },
                {
                    text: '{{ common.action.duplicate | polyglot }}',
                    value: 'duplicate'
                }
            ],
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>el.node.value === s.action
                }
            }
        },
        Select_type: {
            background: 'none',
            color: 'currentColor',
            padding: 'X Y2',
            width: 'E+A',
            onChange: (ev, el, s, ctx)=>{
                const value = ev.target.value;
                if (value) s.update({
                    type: value
                });
            },
            children: [
                {
                    text: '{{ editor.quickAdd.component | polyglot }}',
                    value: 'components'
                },
                {
                    text: '{{ editor.quickAdd.page | polyglot }}',
                    value: 'pages'
                },
                {
                    text: '{{ editor.addFunction.name | polyglot }}',
                    value: 'functions'
                },
                {
                    text: '{{ editor.quickAdd.method | polyglot }}',
                    value: 'methods'
                },
                {
                    text: '{{ editor.panel.state | polyglot }}',
                    value: 'state'
                },
                {
                    text: '{{ editor.quickAdd.dependency | polyglot }}',
                    value: 'dependencies'
                }
            ],
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>el.node.value === s.action
                }
            }
        },
        FileSidebarAddNewItem: {
            Label: {
                border: 'none',
                '.hasItems': null,
                margin: '0',
                Icon: null,
                Input: {
                    padding: 'Z',
                    required: true,
                    // FLAT prop, not `attr: {}` (FA105): an attribute needs the FUNCTION
                    // form to switch language, and `{example}` is the identifier SHAPE
                    // the field accepts — never translated (glossary rule 5).
                    placeholder: (el, s)=>el.call('polyglot', 'editor.quickAdd.typePlaceholder').replace('{example}', el.scope.EXAMPLE_BY_TYPE[s.type] || ''),
                    scope: {
                        EXAMPLE_BY_TYPE: {
                            pages: '/page-path',
                            components: 'ComponentName',
                            functions: 'functionName',
                            methods: 'methodName',
                            state: 'state_name',
                            secrets: 'secret_name',
                            dependencies: '@dep/name'
                        }
                    }
                },
                Flex: {
                    margin: '- - - auto',
                    Save: {
                        extends: 'NavbarButton'
                    },
                    Close: null
                }
            },
            flex: 1
        }
    }
};

});

parcelRegister("lMynu", function(module, exports) {

$parcel$export(module.exports, "EnvItem", () => $fdb8bf604af9e05b$export$a7c8212cbbf10083);
const $fdb8bf604af9e05b$export$a7c8212cbbf10083 = {
    Circle: {
        margin: 'X - -',
        round: 'radiusCard',
        boxSize: 'Z',
        isActive: (el)=>el.isActive || el.parent.isActive,
        '.isActive': {
            background: 'green'
        },
        '!isActive': {
            background: 'shadow'
        }
    },
    Hgroup: {
        flow: 'y',
        margin: '- B - -',
        gap: 'X',
        H: {
            color: 'title',
            tag: 'span',
            overflow: 'hidden',
            whiteSpace: 'wrap',
            textOverflow: 'anywhere',
            text: '{{ publish.envs.production | polyglot }}'
        },
        P: {
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            overflow: 'hidden',
            overflowWrap: 'anywhere',
            whiteSpace: 'wrap',
            textOverflow: 'anywhere',
            lineBreak: 'anywhere',
            text: (el)=>`${el.getAppKey()}`
        }
    },
    Buttons: {
        hide: (el)=>el.getRootState('tier') === 'starter',
        margin: '-X -X - auto',
        EnvActive: {
            icon: 'checkmark',
            color: 'green'
        },
        childExtends: 'IconButton',
        childProps: {
            theme: 'transparent',
            padding: 'Y'
        }
    },
    Upgrade: {
        extends: 'Link',
        hide: (el)=>el.getRootState('tier') !== 'starter',
        color: 'blue',
        text: '{{ publish.action.upgrade | polyglot }}',
        margin: '- - - auto',
        alignSelf: 'start',
        whiteSpace: 'nowrap',
        fontSize: 'Z2',
        lineHeight: 1,
        ':hover': {
            textDecoration: 'underline'
        },
        onClick: (f, el, st)=>{
            el.call('openRouterModal', '/settings', {
                key: '/pricing'
            });
        }
    },
    flow: 'x',
    gap: 'Z',
    round: 'radiusControl',
    padding: 'Z Z2 Y'
};

});

parcelRegister("brgv2", function(module, exports) {

$parcel$export(module.exports, "DomainItem", () => $853f03d0f473dda5$export$1acf300af2c00da);
// A card row in Dropdown.Envs' Domains group. The whole card is the control:
// it hands off to the Infra canvas's connect-domain modal, pre-scoped to the
// project this canvas is editing (shared/functions/openProjectDomainFlow.js).
// Was a dead end — the arrow button had no handler and nothing else did.
// Rows override `onClick` to pick the modal step ('link' | 'new').
const $853f03d0f473dda5$export$1acf300af2c00da = {
    extends: [
        'Flex'
    ],
    gap: 'Z',
    padding: 'Z Z2 Y',
    round: 'radiusControl',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el)=>{
        e.preventDefault();
        el.call('openProjectDomainFlow', {
            step: 'link'
        });
    },
    Icon: {
        margin: 'V2 - -',
        name: 'network',
        fontSize: 'A1'
    },
    Hgroup: {
        flow: 'y',
        margin: '- B - -',
        gap: 'X',
        H: {
            color: 'title',
            tag: 'span',
            text: '{{ publish.domains.custom | polyglot }}'
        },
        P: {
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            overflow: 'hidden',
            overflowWrap: 'anywhere',
            whiteSpace: 'wrap',
            textOverflow: 'anywhere',
            lineBreak: 'anywhere',
            text: '{{ publish.domains.customHint | polyglot }}'
        }
    },
    Buttons: {
        hide: (el)=>el.getRootState('tier') === 'starter',
        margin: '-X -X - auto',
        childExtends: 'IconButton',
        childProps: {
            theme: 'transparent',
            padding: 'Y'
        },
        EnvOpen: {
            icon: 'arrow up right',
            color: 'title',
            // Accessible name for the icon-only button (IconButton mirrors `title`
            // onto aria-label); its click bubbles to the card's handler above.
            title: (el)=>el.call('polyglot', 'publish.domains.custom')
        }
    },
    Upgrade: {
        extends: 'Link',
        color: 'blue',
        text: '{{ publish.action.upgrade | polyglot }}',
        margin: '- - - auto',
        alignSelf: 'start',
        whiteSpace: 'nowrap',
        fontSize: 'Z2',
        lineHeight: 1,
        ':hover': {
            textDecoration: 'underline'
        },
        onClick: (f, el, st)=>{
            // Stop the bubble — the card's own handler would open pricing a
            // second time for the starter tier.
            f.stopPropagation();
            el.call('openRouterModal', '/settings', {
                key: '/pricing'
            });
        },
        hide: (el)=>el.getRootState('tier') !== 'starter'
    }
};

});

parcelRegister("jj2PM", function(module, exports) {

$parcel$export(module.exports, "DropdownButton", () => $e0e1fd73632c1298$export$181f40ec41159e56);
const $e0e1fd73632c1298$export$181f40ec41159e56 = {
    extends: [
        'CanvasButton',
        'Flex'
    ],
    round: 'radiusPill',
    align: 'center',
    alignSelf: 'center',
    margin: '- -X2 - -',
    '!isActive': {
        ':hover': {
            '@dark': {
                backgroundColor: 'gray4.5'
            },
            '@light': {
                backgroundColor: 'gray13.5'
            }
        },
        ':active': {
            '@dark': {
                backgroundColor: 'gray4.5'
            },
            '@light': {
                backgroundColor: 'gray13.5'
            }
        }
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        padding: 'Y Y2 Y Z',
        round: 'C1 0 0 C1',
        lineHeight: 0.9,
        align: 'center',
        gap: 'Y',
        icon: 'play oval',
        text: '{{ editor.selectedNavbar.preview | polyglot }}',
        aspectRatio: 'none'
    },
    IconButton: {
        extends: [
            'CanvasButton',
            'IconButton'
        ],
        round: '0 C1 C1 0',
        theme: 'transparent',
        lineHeight: 1,
        padding: 'Y2 Y2 Y2 Y',
        margin: '- - - -X',
        icon: null,
        ariaLabel: (el)=>el.call('polyglot', 'editor.dropdown.moreOptions'),
        DropdownArrow: {}
    }
};

});

parcelRegister("2Wt9r", function(module, exports) {

$parcel$export(module.exports, "InviteDropdown", () => $22479c5e51bf9382$export$eefca90c663865f2);
// Invite panel — the dialog the header's invite button opens (and the canvas
// MembersNavbar mounts inline): invite a person by email at a role, copy the
// link of the invitation just sent, and see the first members.
//
// Redesigned 2026-10-08 (Nika: "fix/redesign ui of invite user dropdown from
// top navbar"). Measured on dev before the change: a magic-link row that
// opened the CUSTOM-DOMAIN flow when clicked (it inherited DomainItem's
// onClick), a copy button that minted a second invitation, an email field
// narrower than its role select, form controls hung past the panel edge by a
// bleed, member rows printing slugs over three lines, an empty right side on
// every read-only row, a bottom fade that dimmed the last row and "All
// members" from the moment the panel opened, `role="menu"` with no menu
// items, and focus parked on the panel instead of the email field.
//
// THE SHAPE (top to bottom, gap not lines — DESIGN_LANGUAGE §7.7):
//   Title             the dialog's name, also its accessible name
//   the invite form   email (AppField) · role select · copy · send
//                     (InviteFormInDropdown — hidden when the caller may not
//                     invite here)
//   MagicLinkInInvite "Share by magic link": role select · "Copy magic link"
//                     (secondary — send stays the one primary), a status line,
//                     the org's active links with Revoke (INVITE-MAGIC-LINK-1,
//                     2026-10-09; org context only, same who-may-invite rule)
//   NoInviteNote      the one-line reason when the form is hidden
//   MembersInInvite   the first members, their roles, "All members"
//
// It is a DIALOG, not a menu: it holds a form. It keeps the house MenuPanel
// surface (the dialog ground, the overlay elevation, the card radius, the
// height cap) and swaps the menu semantics: `role="dialog"` with a name, and
// focus lands on the email field when the dropdown layer hosts it. Escape
// belongs to the layer (it closes and returns focus to the trigger). MenuPanel
// keeps its arrow-key handler; it only moves between `menuitem` rows and this
// panel has none, so the arrow keys stay the fields' own.
//
// THE RULES live in ONE function: `invitePolicy` (shared/functions/
// inviteRoles.js) — may this caller invite, at which roles, whose role may
// they change. Nothing here restates a role table.
const $22479c5e51bf9382$export$eefca90c663865f2 = {
    extends: 'MenuPanel',
    role: 'dialog',
    ariaLabel: (el)=>el.call('polyglot', 'members.inviteDropdown.title'),
    // The dropdown OWNS the invite-form model: a NON-EMPTY store that declares
    // every key the form writes. An empty `state: {}` is ignored at runtime and
    // the form's writes then land on the ROOT state (2026-08-06: a `set` on
    // that chain wiped the whole session). Every write below is `update` with
    // explicit values — never `set`.
    //   email / role       the form's two fields (role '' = the policy default)
    //   status             'idle' | 'sending'
    //   error              a polyglot KEY for the email field's inline error
    //   failure            the send's error text (already user-facing)
    //   sentEmail/sentUrl  the invitation just created, and its accept link
    //   sentNoEmail        the server created it but the email did not go out
    //   copied             the link of that invitation is on the clipboard
    state: {
        email: '',
        role: '',
        status: 'idle',
        error: '',
        failure: '',
        sentEmail: '',
        sentUrl: '',
        sentNoEmail: false,
        copied: false
    },
    width: 'G2',
    padding: 'A',
    gap: 'A',
    textAlign: 'start',
    onClick: null,
    // Focus INTO the dialog, onto its first field: the email input, or — for a
    // caller with no invite form — the first link. Only when the dropdown layer
    // hosts the panel (its render IS the open edge); the inline MembersNavbar
    // mount sits on a page and must not pull the page's focus.
    onRender: (el)=>{
        if (typeof el.lookup !== 'function' || !el.lookup('DropdownRoot')) return;
        el.call('armMenuFocus', el, {
            selector: 'input[type="email"], a[href]',
            when: (node)=>el.call('menuNodeVisible', node)
        });
    },
    Title: {
        tag: 'h2',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'title',
        text: '{{ members.inviteDropdown.title | polyglot }}'
    },
    InviteFormInDropdown: {},
    MagicLinkInInvite: {},
    // 3(b): a caller the form is hidden from learns why, in one line.
    NoInviteNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z1',
        color: 'caption',
        hide: (el, s)=>!el.call('invitePolicy', s).reason,
        text: (el, s)=>{
            const reason = el.call('invitePolicy', s).reason;
            if (!reason) return '';
            return el.call('polyglot', reason === 'personalOrg' ? 'members.inviteDropdown.personalOrg' : 'members.inviteDropdown.noPermission');
        }
    },
    MembersInInvite: {}
};

});

parcelRegister("7keBB", function(module, exports) {

$parcel$export(module.exports, "ImportInInsert", () => $5555bb01a691680c$export$62438493c234200e);
const $5555bb01a691680c$export$62438493c234200e = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: '{{ editor.insert.import | polyglot }}'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'DomainItem',
        childrenAs: 'state',
        childProps: {
            Hgroup: {
                H: {
                    text: (el, s)=>el.call('polyglot', s.title || '')
                },
                P: {
                    text: (el, s)=>el.call('polyglot', s.descr || '')
                }
            },
            Icon: {
                name: '{{ icon }}'
            },
            Button: {
                margin: '-Y -Z2 - auto',
                text: '{{ publish.sync.connect | polyglot }}',
                icon: 'plus oval',
                gap: 'Y1',
                Icon: {
                    order: 2,
                    color: 'blue'
                },
                extends: [
                    'CanvasButton',
                    'Button'
                ],
                padding: 'Y2 Z2',
                fontSize: 'Z2',
                onClick: (ev, el, s)=>s.onAdd?.(el, s)
            },
            align: 'start',
            Upgrade: null
        },
        children: [
            {
                icon: 'globe',
                title: 'editor.import.liveWebsite',
                descr: 'editor.import.liveWebsiteDescr'
            },
            {
                icon: 'figma',
                title: 'Figma',
                descr: 'publish.sync.figma.descr'
            },
            {
                icon: 'terminal',
                title: 'editor.import.localFiles',
                descr: 'editor.import.localFilesDescr'
            }
        ]
    }
};

});

parcelRegister("cM2BL", function(module, exports) {

$parcel$export(module.exports, "DataSourcesInInsert", () => $94cbfda9048586e2$export$53a14e1679f3c215);
const $94cbfda9048586e2$export$53a14e1679f3c215 = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: '{{ editor.insert.dataSources | polyglot }}'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'IntegrationsItem',
        childrenAs: 'state',
        childProps: {
            Button: {
                text: '{{ common.action.add | polyglot }}'
            }
        },
        children: [
            {
                icon: 'plus',
                title: 'editor.canvasBg.custom',
                descr: 'editor.insert.customDataSourceDescr',
                onConnect: (el, s)=>{},
                onAdd: (el, s)=>{
                    el.setWindow('docs', '/fetch');
                }
            }
        ]
    }
};

});

parcelRegister("cdWPR", function(module, exports) {

$parcel$export(module.exports, "IntegrationsInInsert", () => $8e64566d004badf0$export$2da129bd3ddef0e0);
const $8e64566d004badf0$export$2da129bd3ddef0e0 = {
    flow: 'y',
    gap: 'A',
    position: 'relative',
    CaptionTitle: {
        Text: {
            text: '{{ apps.integrations.title | polyglot }}'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'IntegrationsItem',
        childrenAs: 'state',
        children: ()=>[
                {
                    icon: 'github',
                    title: 'Github',
                    descr: 'apps.integration.github.descr'
                },
                {
                    icon: 'slack',
                    title: 'Slack',
                    descr: 'apps.integration.slack.descr'
                },
                {
                    icon: 'intercom',
                    title: 'Intercom',
                    descr: 'apps.integration.intercom.descr'
                },
                {
                    // Amplitude has no simple-icons entry (checked, not in the
                    // catalog) — kept on its nearest REGISTERED category glyph rather
                    // than an unvetted/hand-traced mark, per tickets/fable.md
                    // "commission ~12 real brand-mark SVGs": a deliberate, documented
                    // fallback beats a silently-wrong or unlicensed asset. Still owed.
                    icon: 'analytics',
                    title: 'Amplitude',
                    descr: 'apps.integration.amplitude.descr'
                },
                {
                    icon: 'googleAnalytics',
                    title: 'Google Analytics',
                    descr: 'apps.integration.googleAnalytics.descr'
                },
                {
                    icon: 'stripe',
                    title: 'Stripe',
                    descr: 'apps.integration.stripe.descr'
                },
                {
                    icon: 'auth0',
                    title: 'Auth0',
                    descr: 'apps.integration.auth0.descr'
                },
                {
                    icon: 'googleSheets',
                    title: 'Google Sheets',
                    descr: 'apps.integration.googleSheets.descr'
                },
                {
                    icon: 'instagram',
                    title: 'Instagram feed',
                    descr: 'apps.integration.instagram.descr'
                },
                {
                    icon: 'npm',
                    title: 'NPM',
                    descr: 'apps.integration.npm.descr'
                },
                {
                    icon: 'firebase',
                    title: 'Firebase',
                    descr: 'apps.integration.firebase.descr'
                }
            ].slice(0, 5)
    },
    InsertSectionShadow: {}
};

});

parcelRegister("crzYn", function(module, exports) {

$parcel$export(module.exports, "AssetsFromInsert", () => $90f3e91fabe9d367$export$4f64d3e5927276dc);
const $90f3e91fabe9d367$export$4f64d3e5927276dc = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        Text: {
            text: '{{ editor.panel.assets | polyglot }}'
        }
    }
};

});

parcelRegister("bxRll", function(module, exports) {

$parcel$export(module.exports, "LibraryFromInsert", () => $867c27a6f148e111$export$7c58b3dde488193e);
const $867c27a6f148e111$export$7c58b3dde488193e = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        align: 'center',
        Text: {
            text: '{{ editor.insert.fromLibrary | polyglot }}'
        },
        SearchButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'search',
            ariaLabel: (el)=>el.call('polyglot', 'editor.insert.searchLibrary'),
            margin: '- auto - A'
        },
        ExpandButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'expand',
            ariaLabel: (el)=>el.call('polyglot', 'editor.insert.expandLibrary'),
            onClick: (ev, el)=>{
                el.setWindow('explorer', 'insert:library');
            }
        },
        width: '100%'
    }
};

});

parcelRegister("hQgn2", function(module, exports) {

$parcel$export(module.exports, "IconsFromInsert", () => $cfd3fddd1792ea98$export$d854251a925c666a);
const $cfd3fddd1792ea98$export$d854251a925c666a = {
    flow: 'y',
    gap: 'Z',
    position: 'relative',
    CaptionTitle: {
        width: '100%',
        Text: {
            text: '{{ editor.panel.icons | polyglot }}'
        },
        SearchButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'search',
            ariaLabel: (el)=>el.call('polyglot', 'editor.insert.searchIcons'),
            margin: '- auto - A'
        },
        ExpandButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            icon: 'expand',
            ariaLabel: (el)=>el.call('polyglot', 'editor.insert.expandIcons'),
            onClick: (ev, el)=>{
                el.setWindow('explorer', 'insert:icons');
            }
        },
        align: 'center'
    },
    IconsGroup: {
        limit: 96,
        childProps: {
            padding: 'auto',
            Icon: {
                fontSize: 'A'
            }
        }
    },
    InsertSectionShadow: {}
};

});

parcelRegister("gwsNu", function(module, exports) {

$parcel$export(module.exports, "FontsFromInsert", () => $c075f902bd1eafa6$export$7509b04aaab822ed);
const $c075f902bd1eafa6$export$7509b04aaab822ed = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        Text: {
            text: '{{ editor.panel.fonts | polyglot }}'
        }
    }
};

});

parcelRegister("k8tyG", function(module, exports) {

$parcel$export(module.exports, "IconsGroup", () => $ea8b7bae4402139b$export$201ed751e2092582);
const $ea8b7bae4402139b$export$201ed751e2092582 = {
    extends: 'Grid',
    lazyLoad: true,
    columns: 'repeat(12, 1fr)',
    gap: 'X',
    margin: '- -X2',
    limit: 60,
    data: async (el, s, ctx)=>{
        // ⚠ This raw `fetch` breaks the SDK-only rule (workspace/CLAUDE.md) and
        // Rule 47. This lane only stops the crash — where the icon asset read
        // BELONGS is a separate decision (it is a design-system icon set, not
        // component data). Until that lands, a failed read must degrade to an
        // empty grid, never to an unhandled rejection.
        if (!el?.call) return [];
        let defIcons;
        try {
            const res = await fetch('https://assets.symbo.ls/icons/def_icons.json');
            defIcons = await res.json();
        } catch (err) {
            el.warn?.('IconsGroup: the icon library did not load', err);
            return [];
        }
        const data = el.call('arraizeIconsCategory', defIcons);
        // `deepClone` resolves through context.utils, which a host is free not
        // to register; `el.call` then answers undefined by framework contract.
        return el.call('deepClone', data) || data || [];
    },
    childExtends: 'IconTemplate',
    childrenAs: 'state',
    children: async (el, s)=>{
        const limit = el.limit;
        const resolved = s.data || el.data ? await el.call('exec', el.data) : [];
        // `exec(param, element)` answers undefined for a function param when no
        // element is forwarded (smbls utils/object.js), and an icon read that
        // never arrived answers undefined too. Children must always be an array.
        const data = Array.isArray(resolved) ? resolved : [];
        if (limit) return data.slice(0, limit);
        return data;
    }
};

});

parcelRegister("l6dib", function(module, exports) {

$parcel$export(module.exports, "IconTemplateWithTooltip", () => $f5c47813cdceb040$export$d7a7c0b85237e33d);
const $f5c47813cdceb040$export$d7a7c0b85237e33d = {
    extends: [
        'ClickableItem',
        'Link',
        'IconText',
        'TooltipParent'
    ],
    round: 'X',
    scrollToTop: false,
    aspectRatio: '1 / 1',
    align: 'center center',
    href: (el, s)=>window.location.pathname + '/edit-icon/' + s.key,
    aria: {
        label: (el, s)=>s.key
    },
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity, border-radius',
    theme: null,
    padding: 'A2',
    '& @container (min-width: 50px)': {
        border: '10px solid blue',
        color: 'red !important',
        style: {
            color: 'red !important'
        }
    },
    ':hover': {
        theme: 'secondary',
        transform: 'scale(1.015)',
        '> svg': {
            fontSize: 'E'
        }
    },
    onClick: (event, element, state, ctx)=>{
        element.call('copyStringToClipboard', state.key);
    },
    Icon: {
        transition: 'A defaultBezier font-size',
        fontSize: 'D2',
        src: (el, s)=>s.value
    },
    TooltipHidden: {
        flow: 'x',
        align: 'center',
        shapeDirection: 'top',
        padding: 'X Y1',
        top: '103%',
        pointerEvents: 'auto',
        whiteSpace: 'nowrap',
        minWidth: '0',
        gap: 'X2',
        name: 'copy outline',
        title: (el, s)=>s.key,
        onClick: (event, el, state)=>{
            event.stopImmediatePropagation();
            event.preventDefault();
            el.update({
                Icon: {
                    name: 'checkmark outline'
                }
            });
            const t = setTimeout(()=>{
                el.update({
                    Icon: {
                        name: 'copy outline'
                    }
                });
                clearTimeout(t);
            }, 1000);
            el.call('copyStringToClipboard', state.key);
        },
        P: null,
        Icon: {
            // eslint-disable-next-line no-restricted-syntax -- copy-icon glyph, not text
            color: 'inactive',
            name: 'copy outline'
        }
    }
};

});

parcelRegister("a3joQ", function(module, exports) {

$parcel$export(module.exports, "IconsPanelWidget", () => $75193b920685be7f$export$30a3b116a1c1069c);
const $75193b920685be7f$export$30a3b116a1c1069c = {
    extends: '/icons',
    width: '100%',
    SectionHeader: null,
    Flex: {
        childProps: {
            Grid: {
                columns: 'repeat(6, 1fr)',
                fontSize: '',
                childProps: {
                    aspectRatio: '1 / 1',
                    Icon: {
                        fontSize: 'B'
                    },
                    ':hover': {
                        '> svg': {
                            fontSize: 'B'
                        }
                    }
                }
            }
        }
    },
    AddButton: {
        padding: 'Y2',
        order: 3,
        scrollToTop: false,
        ariaLabel: (el)=>el.call('polyglot', 'editor.icons.add'),
        href: ()=>window.location.pathname + '/add-icon'
    }
};

});

parcelRegister("5u9fY", function(module, exports) {

$parcel$export(module.exports, "IconTemplate", () => $3fe6ef492b50fa59$export$a306f48a7cb235d4);
const $3fe6ef492b50fa59$export$a306f48a7cb235d4 = {
    extends: [
        'Flex',
        'CanvasButton'
    ],
    round: 'X',
    aspectRatio: '1 / 1',
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity, border-radius',
    padding: 'A2',
    align: 'center center',
    aria: {
        label: (el, s)=>s.key
    },
    '& @container (min-width: 10px)': {
        border: '10px solid blue',
        color: 'red !important',
        style: {
            color: 'red !important'
        }
    },
    Icon: {
        transition: 'A defaultBezier font-size',
        fontSize: 'D2',
        src: (el, s)=>s.value
    }
};

});

parcelRegister("ab4lJ", function(module, exports) {

$parcel$export(module.exports, "IntegrationsItem", () => $768e4e2cd645cbf6$export$bc7349c2edf96a12);
const $768e4e2cd645cbf6$export$bc7349c2edf96a12 = {
    extends: 'DomainItem',
    align: 'start',
    state: {
        icon: 'plus',
        title: 'apps.integration.custom.title',
        descr: 'apps.integration.custom.descr'
    },
    Icon: {
        name: '{{ icon }}'
    },
    Hgroup: {
        H: {
            text: (el, s)=>el.call('polyglot', s.title || '')
        },
        P: {
            text: (el, s)=>el.call('polyglot', s.descr || '')
        }
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        margin: '-Y -Z2 - auto',
        icon: 'plus oval',
        text: '{{ publish.sync.connect | polyglot }}',
        gap: 'Y1',
        padding: 'Y2 Z2',
        fontSize: 'Z2',
        Icon: {
            order: 2,
            color: 'blue'
        },
        onClick: (ev, el, s)=>s.onAdd?.(el, s)
    },
    Upgrade: null
};

});

parcelRegister("1NRNm", function(module, exports) {

$parcel$export(module.exports, "IconsGroupWithCaption", () => $150418a98c1e77fd$export$5cfc63c7ff8809ab);
const $150418a98c1e77fd$export$5cfc63c7ff8809ab = {
    width: '100%',
    P: {
        margin: '0 - Z2',
        text: '{{ title }}',
        userSelect: 'none',
        color: 'inactive',
        fontSize: 'Y',
        textTransform: 'uppercase'
    },
    IconsGroup: {
        if: (el, s)=>Object.keys(s.data).length
    }
};

});

parcelRegister("lQ7tY", function(module, exports) {

$parcel$export(module.exports, "InsertSectionShadow", () => $fe64422e009ee024$export$8e13aef1de89d1fa);
const $fe64422e009ee024$export$8e13aef1de89d1fa = {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    height: 'E3',
    // ZERO-SIZE-SHIPPED-1 #2: an EMPTY box with `height` still compresses to
    // 0px the moment an instance participates in flex flow (the InviteDropdown
    // override flips `position` to sticky inside a height-capped overflow:auto
    // flex column — default flex-shrink:1 + min-content 0 ate the whole box;
    // qa measured "correct gradient, computed height 0"). Inert for this base's
    // own absolute positioning (flex properties are ignored for abs children),
    // load-bearing for every in-flow reuse.
    flex: '0 0 auto',
    background: 'linear-gradient(0deg, var(--theme-common-box-dark-background) 5%, transparent 100%)',
    pointerEvents: 'none'
};

});

parcelRegister("5emKl", function(module, exports) {

$parcel$export(module.exports, "LibraryNavbar", () => $3cefe786bb0ee366$export$91e08e50e237eb41);
const $3cefe786bb0ee366$export$91e08e50e237eb41 = {
    flow: 'x',
    align: 'center space-between',
    padding: 'Y2',
    top: '0',
    margin: '- -X2',
    border: '0',
    position: 'sticky',
    theme: 'common-box',
    zIndex: 2,
    gap: 'X',
    CanvasSearch: {
        round: 'radiusPill',
        fontSize: 'A1',
        flex: 1,
        Form: {
            Icon: {},
            Input: {
                paddingBlock: 'Z',
                placeholder: (el)=>el.call('polyglot', 'editor.library.searchPlaceholder'),
                onInput: (ev, el, s)=>{
                    s.update({
                        search: el.node.value
                    });
                }
            }
        }
    },
    NavbarButtonSet: {
        gap: 'X2',
        margin: '- - - A2',
        padding: '0',
        Docs: {
            isActive: false,
            title: (el)=>el.call('polyglot', 'editor.library.howItWorks'),
            icon: 'question mark',
            onClick: (ev, el)=>{
                el.setWindow('docs', '/components');
            }
        }
    }
};

});

parcelRegister("ifSTk", function(module, exports) {

$parcel$export(module.exports, "InsertPanelIcons", () => $d4a434fcc3dbb04c$export$eb2cbcd06e53f6cf);
const $d4a434fcc3dbb04c$export$eb2cbcd06e53f6cf = {
    flow: 'y',
    width: '100%',
    gap: 'C',
    overflowY: 'auto',
    LibraryNavbar: {},
    Flex: {
        flow: 'y',
        gap: 'B',
        IconsGroup: {
            limit: 1000,
            childProps: {
                padding: 'auto',
                Icon: {
                    fontSize: 'A'
                }
            }
        },
        padding: 'A'
    }
};

});

parcelRegister("aKMQu", function(module, exports) {

$parcel$export(module.exports, "TutorialsInLearn", () => $7d4416f5e81d94f2$export$152c5f6f7ab62400);
const $7d4416f5e81d94f2$export$152c5f6f7ab62400 = {
    flow: 'y',
    state: {
        limit: 5
    },
    tag: 'form',
    align: 'start',
    gap: 'A',
    position: 'relative',
    onSubmit: (ev, el, s)=>{
        ev.preventDefault();
        el.call('createItem', s.type, s.key);
    },
    CaptionTitle: {
        Text: {
            text: '{{ learn.tutorials.title | polyglot }}'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        margin: '- - - -X',
        childExtends: 'TutorialItemInLearn',
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    title: 'learn.video.gettingStarted.title',
                    descr: 'learn.video.gettingStarted.descr',
                    youtubeId: 'jYU0soXY-To',
                    duration: '14:31'
                },
                {
                    title: 'learn.video.symbolsLibrary.title',
                    descr: 'learn.video.symbolsLibrary.descr',
                    youtubeId: '1Vut-DOrfvg',
                    duration: '1:50'
                },
                {
                    title: 'learn.video.whatIsSymbols.title',
                    descr: 'learn.video.whatIsSymbols.descr',
                    youtubeId: 'P_jjCTzS0-w',
                    duration: '1:15'
                },
                {
                    title: 'learn.video.navigation.title',
                    descr: 'learn.video.navigation.descr',
                    youtubeId: 'rugrjZ6WrDM',
                    duration: '4:25'
                },
                {
                    title: 'learn.video.calculator.title',
                    descr: 'learn.video.calculator.descr',
                    youtubeId: 'dPZCwGEysdI',
                    duration: '5:23'
                },
                {
                    title: 'learn.video.components.title',
                    descr: 'learn.video.components.descr',
                    youtubeId: 'ScXOBnJ6ZIU',
                    duration: '2:31'
                },
                {
                    title: 'learn.video.pages.title',
                    descr: 'learn.video.pages.descr',
                    youtubeId: '-qWxYRR15DM',
                    duration: '0:56'
                },
                {
                    title: 'learn.video.codeEditor.title',
                    descr: 'learn.video.codeEditor.descr',
                    youtubeId: 'W2sEhoLA0Dc',
                    duration: '0:23'
                },
                {
                    title: 'learn.video.files.title',
                    descr: 'learn.video.files.descr',
                    youtubeId: 'P9D8A0258Ro',
                    duration: '1:58'
                },
                {
                    title: 'learn.video.colors.title',
                    descr: 'learn.video.colors.descr',
                    youtubeId: 'i4JuUp39n50',
                    duration: '2:02'
                },
                {
                    title: 'learn.video.spacing.title',
                    descr: 'learn.video.spacing.descr',
                    youtubeId: 'xFgl6jG2yrw',
                    duration: '2:35'
                },
                {
                    title: 'learn.video.icons.title',
                    descr: 'learn.video.icons.descr',
                    youtubeId: 'rPfSew0RGZc',
                    duration: '2:19'
                }
            ].slice(0, s.limit || 30)
    },
    InsertSectionShadow: {
        left: '-C1',
        right: '-C1',
        bottom: 'C1'
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        zIndex: 2,
        margin: '- - - -Y2',
        icon: (el, s)=>'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
        text: (el, s)=>el.call('polyglot', s.limit === 5 ? 'learn.video.more' : 'learn.video.less'),
        gap: 'Y1',
        padding: 'Y2 Z2',
        color: 'caption',
        fontSize: 'Z2',
        Icon: {
            order: 2
        },
        onClick: (ev, el, s)=>{
            s.update({
                limit: s.limit === 5 ? 30 : 5
            });
        }
    }
};

});

parcelRegister("jgejL", function(module, exports) {

$parcel$export(module.exports, "Lottie", () => $e05a9e2e2e09a09d$export$eeef939529b18d03);
// A Bridge host (COMPONENTS.md → Bridge): lottie-web draws inside this node,
// DOMQL owns the node itself.
//
// lottie-web keeps every animation it loads, with its frame loop, until the
// animation's own `destroy()`. This component loaded in `onRender` and dropped
// the handle, so nothing ever stopped one (shared item 24, 2026-11-01): a
// removal (a page swap, a removed parent) left it running, an element that
// went before `lottie-web` loaded still got one, and each `if:` re-show fired
// `onRender` again (a second SVG and a second loop in the same node). The
// bridge mounts once per connected node, keeps its animation through an `if:`
// hide, and destroys it exactly once per started mount, a late mount included.

const $e05a9e2e2e09a09d$export$eeef939529b18d03 = {
    extends: 'Bridge',
    src: 'resize.json',
    boxSize: '3.2em',
    onBridgeMount: async (node, el)=>{
        const lottie = await (parcelRequire("ceBKe"));
        const player = lottie.default || lottie;
        let src = el.call('exec', el.src, el);
        if (!src) return;
        if (el.call('isString', src) && src.includes('{{')) src = el.call('replaceLiteralsWithObjectFields', src);
        return player.loadAnimation({
            container: node,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `https://assets.symbo.ls/lottie/${src}`
        });
    },
    onBridgeDestroy: (animation)=>animation && animation.destroy()
};

});
parcelRegister("ceBKe", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("5PUA1"))) : import("5PUA1")).then(()=>parcelRequire('8KMYG'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("79ery", function(module, exports) {

$parcel$export(module.exports, "InsertPanelLibrary", () => $534493da3cce35cb$export$5683a14ff3cb666a);
const $534493da3cce35cb$export$5683a14ff3cb666a = {
    flow: 'y',
    overflow: 'hidden auto',
    gap: 'Z2',
    fontSize: 'Z1',
    width: '100%',
    overflowY: 'auto',
    onEventComplete: async (el, s)=>{
        const elData = el.data;
        el.scope.__cache = {};
        s.replace({
            loading: true
        }, {
            preventListeners: true
        });
        // The libraries THIS project links, each as an `owner/key` ref (the
        // project's own `useLibraries` record). A bare key can name several
        // owners' projects — the server answers it 409 `ambiguous_key` — so the
        // panel never sends one. It used to fetch the hardcoded legacy key
        // 'default.symbo.ls': on dev that key named nikoloza/default AND
        // system/default (2026-10-24).
        const libraries = await el.call('insertPanelLibraryRefs');
        const base = libraries.length ? libraries[0].ref : null;
        const active = s.activeLibrary || base;
        if (!active) {
            s.replace({
                loading: false
            }, {
                preventListeners: true
            });
            return;
        }
        let data;
        if (elData[active]) data = elData[active];
        else {
            data = await el.call('fetchInsertPanelLibrary', active);
            elData[active] = data;
        }
        if (!data) {
            s.replace({
                loading: false
            }, {
                preventListeners: true
            });
            return;
        }
        const exclList = [
            'members',
            'usedByProjects',
            'environments',
            'project',
            'versions'
        ];
        const exclOpts = {
            exclude: [
                'canvas',
                'schema',
                ...exclList
            ]
        };
        const dataExclOpts = {
            exclude: exclList
        };
        const projData = el.call('deepClone', el.getData(), exclOpts);
        data = el.call('deepClone', data, dataExclOpts);
        // Another library merges over the project's first linked one, as the
        // hardcoded default did.
        if (active !== base && elData[base]) {
            const defData = el.call('deepClone', elData[base], exclOpts);
            data = el.call('deepMerge', data, defData);
        }
        // USER-CODE-ORIGIN review N4: the library project stays AS STORED
        // (strings) — the shell never revives member-authored project code.
        // Usage
        const componentsCache = Object.values(data.components || {});
        el.scope.libraryComponentsCache = componentsCache;
        window.setTimeout(()=>{
            el.scope.__cache = el.call('deepMerge', projData, data);
            s.replace({
                loading: false
            }, {
                preventListeners: true
            });
        }, 350);
    },
    scope: {
        __cache: {}
    },
    state: {
        // An `owner/key` ref; null = the project's first linked library.
        activeLibrary: null
    },
    data: {},
    LibraryNavbar: {},
    // DELETED: the `Nav` library-switcher row.
    //
    // Its `children` factory was `el.call('getSnippet', 'TEMPLATES_DATA',
    // 'array')`, and that call has never returned anything. `getSnippet` was
    // `packages/docs/functions/getSnippet.js` and went out with the whole docs
    // package in workspace 23a019f68 ("docs out, QuickEditor on canvas", April
    // 2026); nothing has registered the name since, and `el.call` on an
    // unregistered name THROWS rather than answering undefined. `TEMPLATES_DATA`
    // was never a snippet in this repository either — the docs package shipped
    // DOCS_SITEMAP and TUTORIALS and nothing else — so even before that deletion
    // the call hit getSnippet's own "snippet was not found" path. The row has
    // rendered zero library tabs at every commit, in every host, while costing a
    // minHeight-'D' bar of empty chrome and one lifecycle error per mount
    // (measured on the served UI-kit catalog, 2026-09-20).
    //
    // Registering the name instead would mean inventing the library list in
    // code, which is exactly what "never hardcode content" forbids. The real
    // source exists now: `el.call('insertPanelLibraryRefs')` answers the
    // project's linked libraries as `{ ref: 'owner/key', name }` rows. A
    // switcher sets `activeLibrary` to a row's `ref` — never a bare key (the
    // deleted row stored `projectPath.split('/')[1] + '.symbo.ls'`, which drops
    // the owner).
    P: {
        align: 'center',
        textAlign: 'center',
        margin: '-A auto C',
        color: 'placeholder',
        maxWidth: 'F1',
        flow: 'y',
        Lottie: {
            src: 'swipe-right.json',
            fontSize: 'B1',
            margin: '- - -X2'
        },
        Text: {
            text: '{{ editor.insert.dragHint | polyglot }}'
        }
    },
    LoadingGif: {
        hide: (el, s)=>!s.loading
    },
    LibraryRows: {
        padding: 'Z',
        childrenAs: 'state',
        children: (el, s)=>{
            if (!el.scope.__cache.canvas) return;
            const canvasPages = el.scope.__cache.canvas.pages;
            const data = el.scope.__cache.schema.components;
            function unifyComponents(obj) {
                const allComponents = [];
                // Iterate through each key in the object
                for(const key in obj)if (obj[key].components && Array.isArray(obj[key].components)) allComponents.push(...obj[key].components);
                return allComponents;
            }
            const allDefined = unifyComponents(canvasPages);
            const filteredFromOtherPages = Object.keys(data).filter((item)=>!allDefined.includes(item));
            const arr = [
                {
                    title: (el)=>el.call('polyglot', 'editor.chooseCanvas.default'),
                    components: filteredFromOtherPages
                }
            ];
            const pages = s.CACHE.canvas.pages;
            const exclPages = [
                'Archive',
                'Working'
            ];
            const pagesArr = Object.keys(pages).filter((item)=>!exclPages.includes(item));
            return arr.concat(pagesArr.map((v)=>pages[v]));
        },
        childProps: {
            CaptionTitle: {
                Text: {
                    text: '{{ title }}'
                }
            },
            Grid: {
                padding: '0',
                gap: 'A',
                margin: 'Z2 -Y -',
                templateColumns: 'repeat(4, 1fr)',
                childExtends: 'ComponentThumbnailIframe',
                childrenAs: 'state',
                children: (el, s)=>{
                    // const components = el.call('getProjectSchema', s.data)
                    const components = s.components.map((v)=>{
                        const data = el.scope.__cache;
                        const schemaItem = data.schema.components[v];
                        const dataItem = data.components[v];
                        return schemaItem && dataItem && {
                            ...schemaItem,
                            value: dataItem
                        };
                    });
                    return components.filter((v)=>v);
                }
            },
            Line: {
                margin: 'B1 -Z1'
            }
        },
        hide: (el, s)=>s.loading
    }
};

});

parcelRegister("jUFla", function(module, exports) {

$parcel$export(module.exports, "BoxSizeItem", () => $e7f350a0a188afad$export$31374a5cb71755e3);
const $e7f350a0a188afad$export$31374a5cb71755e3 = {
    Icon: {
        icon: 'gap',
        color: 'inactive',
        boxSize: 'A1 A1'
    },
    SizeUnits: {
        flow: 'column-reverse',
        LetterValue: {
            // Was fixed 'white' — this row renders on BoxSizeRow's adaptive
            // `document-background`, so a fixed literal went invisible in light.
            color: 'title',
            fontSize: 'A1',
            padding: 'X2 X2 0 X2'
        },
        NumberValue: {
            color: 'inactive',
            fontSize: 'Y',
            padding: 'X X2 X2 X2'
        }
    },
    Span: {
        title: 'paragraph',
        text: '{{ editor.boxSize.min | polyglot }}',
        fontSize: 'Y',
        alignSelf: 'flex-end',
        margin: '- - -Y -'
    },
    flow: 'x',
    padding: 'Z Y1',
    gap: 'C',
    margin: '-1px'
};

});

parcelRegister("4lnWj", function(module, exports) {

$parcel$export(module.exports, "TutorialItemInLearn", () => $329bb17b7892d888$export$f0a956bb7c98bff8);
const $329bb17b7892d888$export$f0a956bb7c98bff8 = {
    flow: 'x',
    state: {
        title: 'learn.video.gettingStarted.title',
        descr: 'learn.video.gettingStarted.descr',
        youtubeId: 'jYU0soXY-To',
        duration: '14:31'
    },
    align: 'stretch',
    padding: '0',
    gap: 'A',
    round: '0',
    overflow: 'visible',
    cursor: 'pointer',
    opacity: '0.8',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .playButton': {
            opacity: '1'
        }
    },
    onClick: (ev, el, s)=>{
        el.call('openModalVideo', `https://www.youtube.com/embed/${s.youtubeId}?controls=1&amp;autoplay=1`);
    },
    Box: {
        position: 'relative',
        width: 'D3',
        Img: {
            display: 'block',
            round: 'radiusControl',
            position: 'relative',
            width: '100%',
            src: 'https://img.youtube.com/vi/{{ youtubeId }}/hqdefault.jpg'
        },
        Circle: {
            flow: 'x',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'title',
            Icon: {
                fontSize: 'D',
                name: 'play oval fill'
            }
        }
    },
    Flex: {
        flow: 'y',
        gap: 'W2',
        Strong: {
            text: (el, s)=>el.call('polyglot', s.title || '')
        },
        Span: {
            whiteSpace: 'nowrap',
            fontWeight: '200',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: (el, s)=>el.call('polyglot', s.descr || '')
        },
        Time: {
            margin: 'auto - -',
            text: '{{ duration }}',
            fontWeight: '200'
        }
    }
};

});

parcelRegister("aA8Qp", function(module, exports) {

$parcel$export(module.exports, "DynamicIsland", () => $7b4420770f97ce66$export$67d0f66cae6d7a87);
const $7b4420770f97ce66$export$67d0f66cae6d7a87 = {
    state: {
        recents: [],
        recentsIndex: 0,
        default: 'explorer',
        panelMap: {
            onboarding: 'IntroPanel',
            chat: 'AISidebarPanel',
            explorer: 'CanvasProjectSidebar',
            'insert:icons': 'InsertPanelIcons',
            'insert:integrations': 'IntegrationsPanel',
            'insert:library': 'InsertPanelLibrary',
            insert: 'InsertPanel',
            learn: 'LearnPanel'
        }
    },
    DynamicNavbar: {},
    content: (el, s)=>{
        const activeWindow = el.getWindow('explorer');
        if (!el.call('isString', activeWindow)) return Boolean(activeWindow) ? {
            extends: s.panelMap[s.default]
        } : {};
        // First try exact match
        if (s.panelMap[activeWindow]) return {
            extends: s.panelMap[activeWindow]
        };
        // Then try prefix match
        for(const key in s.panelMap){
            if (activeWindow.startsWith(key)) return {
                extends: s.panelMap[key]
            };
        }
        return {};
    },
    PromptAI: {
        margin: 'auto - -',
        order: 2,
        hide: true
    },
    flow: 'y',
    gap: '0',
    width: 'G1+B1',
    position: 'absolute',
    overflow: 'hidden',
    top: 'B2+X',
    padding: '0 --canvas-double-gutter',
    left: '--canvas-gutter',
    bottom: '--canvas-gutter',
    round: 'radiusControl',
    fontSize: 'Z2',
    minWidth: 'G2',
    maxWidth: '50vw',
    minHeight: 'I',
    resize: 'auto',
    // Border habit removed — `theme: 'common-box'` already supplies its own
    // opaque fill (design-direction.md §8).
    theme: 'common-box',
    useAnimations: true,
    '.useAnimations': {
        transition: 'A1 defaultBezier',
        transitionProperty: 'transform, visibility, opacity, width'
    },
    isActive: (el)=>Boolean(el.getWindow('explorer')),
    '.isActive': {
        transform: 'none',
        opacity: 1,
        visibility: 'visible'
    },
    '!isActive': {
        transform: 'translate3d(0, 1.2em, 1px)',
        opacity: 0,
        visibility: 'hidden'
    },
    ':hover .close': {
        opacity: 1
    },
    // `:hover` rules are `@media (hover: hover)`-gated since smbls e3333d298, so
    // on touch the hover reveal never runs and the island's close control stays
    // stuck at its rest opacity: 0. Always reachable on coarse pointers.
    '@coarse': {
        '.close': {
            opacity: 1
        }
    },
    isInsertActive: (el)=>el.getWindow('explorer') === 'insert',
    '.isInsertActive': {
        width: 'H'
    },
    isIconsActive: (el)=>el.getWindow('explorer') === 'insert:icons',
    '.isIconsActive': {
        width: 'H'
    },
    isLibraryActive: (el)=>el.getWindow('explorer') === 'insert:library',
    '.isLibraryActive': {
        width: 'I'
    },
    onBeforeUpdate: (_, el, s, ctx, opts)=>{
        if (opts.skipRecentsIndexing) return;
        const recents = s.recents || [];
        const recent = recents[0];
        const activeWindow = el.getWindow('explorer');
        if (activeWindow && activeWindow !== recent) recents.unshift(activeWindow);
        s.recents = recents;
        s.recentsIndex = 0;
    // else s.recents = recents
    },
    onRender: (el)=>Boolean(el.getWindow('explorer')) && el.update()
};

});

parcelRegister("688r3", function(module, exports) {

$parcel$export(module.exports, "BoxSizeRow", () => $476a088021327be9$export$e9f8f3e6c705c1c);
const $476a088021327be9$export$e9f8f3e6c705c1c = {
    Flex: {
        zIndex: 2,
        backgroundColor: 'document-background',
        border: 'hairline solid gray3',
        round: 'radiusControl',
        margin: '-1px',
        childProps: {
            ':first-child': {
                border: '.7px dashed gray3',
                round: 'radiusControl'
            }
        },
        childExtends: 'BoxSizeItem',
        children: [
            {
                SizeUnits: {
                    LetterValue: {},
                    NumberValue: {}
                }
            },
            {
                Icon: {
                    opacity: '0'
                },
                SizeUnits: {
                    LetterValue: {},
                    NumberValue: {}
                },
                Span: {
                    opacity: '0'
                }
            }
        ]
    },
    BoxSizeItem: {
        border: '.7px dashed gray3',
        round: 'radiusControl',
        margin: '-1px 0 -1px -B',
        padding: 'Z Y1 Z B',
        Icon: {
            opacity: '0'
        },
        SizeUnits: {
            LetterValue: {
                value: (el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    return s[key] && s[key] !== 'none' ? el.call('getLetterValueFromState', 0, key) : '';
                },
                onInput: (ev, el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    el.call('updateLetterStateValue', 0, key);
                }
            },
            NumberValue: {
                value: (el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    return s[key] && s[key] !== 'none' ? el.call('getNumberValueFromState', 0, key) : 'none';
                },
                onInput: (ev, el, s)=>{
                    const type = s.type;
                    const key = `max${type}`;
                    el.call('updateNumberStateValue', 0, key);
                }
            }
        },
        Span: {
            text: '{{ editor.boxSize.max | polyglot }}'
        }
    },
    flow: 'x'
};

});

parcelRegister("gTzw7", function(module, exports) {

$parcel$export(module.exports, "LearnPanel", () => $c4cd555deb3f25f9$export$bcddf6d1dc10e1b4);
const $c4cd555deb3f25f9$export$bcddf6d1dc10e1b4 = {
    flow: 'y',
    fontSize: 'Z2',
    padding: 'A+Z Z2',
    gap: 'C',
    overflow: 'hidden auto',
    ExamplesInLearn: {},
    Line_1: {
        margin: '- -A'
    },
    TutorialsInLearn: {},
    Line_2: {
        margin: '- -A'
    },
    TutorialsPanel: {},
    Line_3: {
        margin: '- -A'
    },
    LibrariesInLearn: {}
};

});

parcelRegister("dmw3V", function(module, exports) {

$parcel$export(module.exports, "BoxSize", () => $9ba633525863e7f7$export$89a73b2d97ef42d6);
const $9ba633525863e7f7$export$89a73b2d97ef42d6 = {
    Flex: {
        gap: 'B',
        flow: 'y',
        childExtends: 'BoxSizeRow',
        children: [
            {
                type: 'Width'
            },
            {
                type: 'Height'
            }
        ],
        childrenAs: 'state'
    }
};

});

parcelRegister("2c3u4", function(module, exports) {

$parcel$export(module.exports, "BoxModelSubGrid", () => $198f6797f2b40899$export$2ffab48cb1b042f8);
const $198f6797f2b40899$export$2ffab48cb1b042f8 = {
    border: '.25)',
    extends: 'Grid',
    columns: '4.375em auto 4.375em',
    rows: '4.375em auto 4.375em',
    round: 'radiusCard',
    templateAreas: `"x1 t x2"
    "l content r"
    "x3 b x4"`,
    position: 'relative',
    childrenAs: 'props',
    children: [
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            extends: 'Icon',
            position: 'absolute',
            top: 'Y1',
            left: 'Y1',
            icon: 'paddingColored',
            fontSize: 'A',
            color: '#8B935C'
        },
        {
            extends: 'Icon',
            icon: 'marginColored',
            position: 'absolute',
            top: '-Z1',
            left: '-Z1',
            fontSize: 'A',
            color: 'yellow'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 't',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'r',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelMiddle',
            gridArea: 'content'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'b',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'l',
            SizeUnits: {
                LetterValue: {
                    color: '#8F9959'
                },
                NumberValue: {}
            }
        }
    ]
};

});

parcelRegister("8HO8k", function(module, exports) {

$parcel$export(module.exports, "BoxModelAside", () => $65693a50d386dbb3$export$a3774f6ebc625341);
const $65693a50d386dbb3$export$a3774f6ebc625341 = {
    SizeUnits: {},
    flow: 'x',
    align: 'center center',
    height: '100%'
};

});

parcelRegister("4LS6x", function(module, exports) {

$parcel$export(module.exports, "BoxModelMiddle", () => $3795853d2e092688$export$21daaad90663c234);
const $3795853d2e092688$export$21daaad90663c234 = {
    border: 'solid yellow.15',
    Flex_lineHeight: {
        position: 'absolute',
        alignSelf: 'flex-start',
        borderLeft: '.4)',
        padding: '- - - Y2',
        height: '70%',
        align: 'center center',
        Icon: {
            icon: 'textLineHeight',
            color: '#3A5A7F'
        }
    },
    SizeUnits: {
        LetterValue: null,
        NumberValue: {
            text: '140%',
            color: '#3A5A7F',
            '::after': '%',
            onInput: (ev, el, s)=>{
                el.call('updateNumberStateValue', 0, 'lineHeight');
            },
            value: (el, s)=>el.call('getNumberValueFromState', 0, 'lineHeight')
        }
    },
    flow: 'column',
    align: 'center center',
    position: 'relative',
    height: 'C1',
    borderWidth: '.8px',
    padding: '- - - Y',
    round: 'Y2',
    minWidth: 'E3'
};

});

parcelRegister("6f0SR", function(module, exports) {

$parcel$export(module.exports, "BorderRadiusBox", () => $48b4d448bc1f719e$export$4fea2869a78c52a9);
const $48b4d448bc1f719e$export$4fea2869a78c52a9 = {
    borderWidth: '.5px',
    round: (_, s)=>`${s.borderStartStartRadius} ${s.borderStartEndRadius} ${s.borderEndEndRadius} ${s.borderEndStartRadius}`,
    borderColor: 'yellow.25',
    borderStyle: 'solid',
    height: '100%',
    onClick: (ev, el, s)=>{
        const getCornerInputs = ()=>{
            const inputs = [
                ...document.querySelectorAll('input[key="NumberValue"]')
            ];
            return inputs.map((input)=>{
                const rect = input.getBoundingClientRect();
                return {
                    el: input,
                    value: input.value,
                    x: rect.left + rect.width / 2,
                    y: rect.top + rect.height / 2
                };
            });
        };
        const corners = getCornerInputs();
        let closest = null;
        let minDist = Infinity;
        for (const c of corners){
            const dx = ev.clientX - c.x;
            const dy = ev.clientY - c.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < minDist) {
                minDist = dist;
                closest = c;
            }
        }
        if (closest) closest.el.select();
    },
    flow: 'x'
};

});

parcelRegister("a0VaR", function(module, exports) {

$parcel$export(module.exports, "BorderRadius", () => $74a6410eb5ccc391$export$41808410d1eaf88a);
const $74a6410eb5ccc391$export$41808410d1eaf88a = {
    extends: 'Grid',
    border: '.25 solid gray6',
    borderWidth: '.5px',
    columns: '4.375em auto 4.375em',
    rows: '5em auto 5em',
    templateAreas: `"bss content bse"
    ". content ."
    "bes content bee"`,
    textAlign: 'center',
    childrenAs: 'props',
    childProps: {
        cursor: 'pointer',
        position: 'relative'
    },
    children: [
        {
            gridArea: 'bss',
            alignContent: 'flex-start',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        },
        {
            BorderRadiusBox: {},
            gridArea: 'content',
            gridRow: '1 3'
        },
        {
            gridArea: 'bse',
            alignContent: 'flex-start',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        },
        {
            gridArea: 'bes',
            alignContent: 'flex-end',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        },
        {
            gridArea: 'bee',
            alignContent: 'flex-end',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B',
                    attr: {}
                },
                NumberValue: {
                    attr: {}
                }
            }
        }
    ]
};

});

parcelRegister("3Jt47", function(module, exports) {

$parcel$export(module.exports, "BoxModel", () => $2b7c1ed61857d7d2$export$d245e7471253a18f);
const $2b7c1ed61857d7d2$export$d245e7471253a18f = {
    extends: 'Grid',
    // Adaptive (was fixed 'gray6') — inherited by the aside NumberValue
    // readouts, which sit on the page's normal adaptive surface, unlike the
    // padding/margin swatch icons in BoxModelSubGrid (those stay raw hex on
    // purpose, matching color.js's own fixed design-system legend swatches).
    color: 'inactive',
    fontSize: 'Z',
    border: 'solid yellow.25',
    borderWidth: '.5px',
    position: 'relative',
    round: 'A2',
    overflow: 'hidden',
    columns: '4.375em auto 4.375em',
    rows: '4.375em auto 4.375em',
    templateAreas: `"x1 t x2"
    "l content r"
    "x3 b x4"`,
    align: 'center center',
    textAlign: 'center',
    childProps: {
        cursor: 'pointer',
        position: 'relative'
    },
    childrenAs: 'props',
    children: [
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            boxSize: '100%'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 't',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'r',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelSubGrid',
            gridArea: 'content'
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'b',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        },
        {
            extends: 'BoxModelAside',
            gridArea: 'l',
            SizeUnits: {
                LetterValue: {
                    color: '#85684B'
                },
                NumberValue: {}
            }
        }
    ]
};

});

parcelRegister("5DHHM", function(module, exports) {

$parcel$export(module.exports, "LibraryItemInLearn", () => $41b27f36c308f82a$export$74fefb16c05d779b);
// One library row of the Learn panel. LibrariesInLearn hands each row its item
// as state (`childrenAs: 'state'`); the row ships no data of its own. It used
// to default to a demo row — a real person's project path, a resource count, a
// poster — and that row showed on ANY element keyed `LibraryItemInLearn`, a
// generated app's included (R2-M1 sweep). The keys are declared empty so a
// bare row never reads the root state's `title`, and a row without a title
// stays hidden.
const $41b27f36c308f82a$export$74fefb16c05d779b = {
    extends: [
        'Link',
        'Flex'
    ],
    state: {
        title: '',
        amount: null,
        poster: '',
        projectPath: ''
    },
    hide: (el, s)=>!s.title,
    align: 'stretch',
    padding: '0',
    gap: 'A',
    round: '0',
    overflow: 'visible',
    cursor: 'pointer',
    opacity: '0.8',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .playButton': {
            opacity: '1'
        }
    },
    href: 'https://symbols.app/{{ projectPath }}',
    target: '_blank',
    Box: {
        position: 'relative',
        width: 'E3',
        Img: {
            display: 'block',
            round: 'radiusControl',
            position: 'relative',
            width: '100%',
            src: '{{ poster }}'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'W2',
        Strong: {
            text: '{{ title }}'
        },
        Span: {
            whiteSpace: 'nowrap',
            fontWeight: '200',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: '{{ projectPath }}'
        },
        Span_2: {
            if: (el, s)=>!!s.amount,
            margin: 'auto - -',
            fontWeight: '100',
            fontSize: 'Z2',
            text: (el, s)=>el.call('polyglot', 'learn.libraries.resources').replace('{amount}', s.amount),
            color: 'paragraph'
        }
    }
};

});

parcelRegister("gz3Jr", function(module, exports) {

$parcel$export(module.exports, "LibrariesInLearn", () => $c0f2cf4d7a45cc7f$export$351f0a051f9760f2);
// Poster URLs resolve through `workspaceApiBase()` so dev / staging /
// prod surfaces all see the file from the tier they're actually browsing
// — previously hardcoded `https://api.symbols.app/...` sent dev users
// to a frozen prod build that may not even host these files anymore.

var $29wU0 = parcelRequire("29wU0");
const $c0f2cf4d7a45cc7f$export$351f0a051f9760f2 = {
    // FA204 / frank trap — publicFile used to be a bare module-scope const read
    // from inside the `children` factory; it reads as undefined once this
    // component is frank.toJSON'd for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called via
    // `el.scope.publicFile`.
    scope: {
        publicFile: (id)=>`${(0, $29wU0.workspaceApiBase)()}/core/files/public/${id}/download`
    },
    flow: 'y',
    state: {
        limit: 5
    },
    tag: 'form',
    align: 'start',
    gap: 'A',
    position: 'relative',
    onSubmit: (ev, el, s)=>{
        ev.preventDefault();
        el.call('createItem', s.type, s.key);
    },
    CaptionTitle: {
        Text: {
            text: '{{ learn.libraries.title | polyglot }}'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        margin: '- - - -X',
        childExtends: 'LibraryItemInLearn',
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    poster: el.scope.publicFile('68b667ce424350c909ec03f9'),
                    projectPath: 'nikoloza/default',
                    amount: 206,
                    title: 'Default'
                },
                {
                    poster: el.scope.publicFile('68b667c8424350c909ec03d4'),
                    projectPath: 'nikoloza/ecommerce',
                    amount: 271,
                    title: 'Ecommerce'
                },
                {
                    poster: el.scope.publicFile('68b667ac424350c909ec034e'),
                    projectPath: 'nikoloza/forms',
                    amount: 248,
                    title: 'Forms'
                },
                {
                    poster: el.scope.publicFile('68b667c2424350c909ec03a6'),
                    projectPath: 'nikoloza/ai',
                    amount: 213,
                    title: 'AI'
                },
                {
                    poster: el.scope.publicFile('68b667d6424350c909ec0421'),
                    projectPath: 'nikoloza/web3',
                    amount: 85,
                    title: 'Web3'
                },
                {
                    poster: el.scope.publicFile('68b667db424350c909ec044f'),
                    projectPath: 'nikoloza/content-and-marketing',
                    amount: 275,
                    title: 'Content & Marketing'
                },
                {
                    poster: el.scope.publicFile('68b66c9b424350c909ec1f66'),
                    projectPath: 'nikoloza/docs',
                    amount: 598,
                    title: 'Docs'
                },
                {
                    poster: el.scope.publicFile('68b671ef424350c909ec5342'),
                    projectPath: 'nikoloza/charts',
                    amount: 0,
                    title: 'Charts'
                },
                {
                    poster: el.scope.publicFile('68b66bfb424350c909ec1eb4'),
                    projectPath: 'nikoloza/ui',
                    amount: 0,
                    title: 'No-code'
                },
                {
                    poster: el.scope.publicFile('68b672ad424350c909ec544b'),
                    projectPath: 'nikoloza/cms',
                    amount: 0,
                    title: 'CMS'
                },
                {
                    poster: el.scope.publicFile('68b66c19424350c909ec1f0c'),
                    projectPath: 'nikoloza/code',
                    amount: 0,
                    title: 'Code'
                },
                {
                    poster: el.scope.publicFile('68b63fae424350c909ea336e'),
                    projectPath: 'nikoloza/miscellaneous',
                    amount: 0,
                    title: 'Miscellaneous'
                }
            ].slice(0, s.limit || 30)
    },
    InsertSectionShadow: {
        left: '-C1',
        right: '-C1',
        bottom: 'C'
    },
    Button: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        zIndex: 2,
        margin: '- - - -Y2',
        icon: (el, s)=>'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
        text: (el, s)=>el.call('polyglot', s.limit === 5 ? 'learn.libraries.more' : 'learn.libraries.less'),
        gap: 'Y1',
        padding: 'Y2 Z2',
        color: 'caption',
        fontSize: 'Z2',
        Icon: {
            order: 2
        },
        onClick: (ev, el, s)=>{
            s.update({
                limit: s.limit === 5 ? 30 : 5
            });
        }
    }
};

});

parcelRegister("h1XLQ", function(module, exports) {

$parcel$export(module.exports, "OnboardingPanel", () => $c660e4da79a93f2d$export$a49e45749effe8da);
const $c660e4da79a93f2d$export$a49e45749effe8da = {
    flow: 'y',
    gap: 'Z1',
    CaptionTitle: {
        Text: {
            text: '{{ learn.checklist.title | polyglot }}'
        }
    },
    Flex: {
        flow: 'y',
        gap: 'Z2',
        childExtends: [
            'Flex',
            {}
        ],
        childProps: {
            fontWeight: '400',
            isActive: false,
            isCurrent: false,
            gap: 'Z',
            align: 'center',
            ':hover': {
                textDecoration: 'underline'
            },
            Circle: {
                order: '-1',
                boxSize: 'A',
                // Was a bare `--color-line` custom-property name with no var()
                // wrapper — an invalid border shorthand value that rendered with no
                // colour. Fixed to the real token.
                border: 'hairline solid line',
                Icon: {
                    name: 'checkmark'
                }
            },
            Text: {
                '.isDone': {
                    fontWeight: '200',
                    color: 'paragraph',
                    textDecoration: 'line-through'
                }
            }
        },
        childrenAs: 'props',
        children: ()=>[
                {
                    Text: {
                        text: '{{ learn.checklist.createComponent | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getSchema('components') || {}).length > 0,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/add-component');
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.reuseComponent | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getSchema('components') || {}).length > 1,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        const componentFound = Object.values(el.getSchema('components'))[0];
                        if (!componentFound?.key) return el.call('openNotification', {
                            title: el.call('polyglot', 'learn.checklist.noComponent.title'),
                            message: el.call('polyglot', 'learn.checklist.noComponent.message'),
                            type: 'transparentPattern'
                        });
                        await el.call('openRouterModal', '/add-component', {
                            key: componentFound.key + 'Reused',
                            title: (componentFound.title || componentFound.key) + ' Reused',
                            type: 'components',
                            value: {
                                [componentFound.key]: {}
                            },
                            code: `export default {\n  // Reusable component:\n  ${componentFound.key}: {\n    // Overwrite properties... \n  },\n}`,
                            advanced: true
                        });
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.createPage | polyglot }}'
                    },
                    isDone: (el)=>(el.getSchema('pages') || {})['/'],
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/add-page', {
                            title: 'Main page',
                            key: '/',
                            type: 'pages',
                            value: {
                                '/': {
                                    H1: {
                                        text: 'Hello Symbols'
                                    }
                                }
                            },
                            code: `export default {\n  '/': {\n    H1: { text: 'Hello Symbols' } \n  },\n}`,
                            advanced: true
                        });
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.openPage | polyglot }}'
                    },
                    isDone: (el)=>el.call('getCookie', el.getAppKey() + '_projectRemotePageWasViewed'),
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        const pageFound = Object.values(el.getSchema('pages'))[0];
                        if (!pageFound?.key) return el.call('openNotification', {
                            title: el.call('polyglot', 'learn.checklist.noPage.title'),
                            message: el.call('polyglot', 'learn.checklist.noPage.message'),
                            type: 'transparentPattern'
                        });
                        const url = `https://${el.getAppKey()}/${pageFound.key}`;
                        window.open(url, 'Symbols preview');
                        el.call('setCookie', el.getAppKey() + '_projectRemotePageWasViewed', true);
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.importLibrary | polyglot }}'
                    },
                    // add flag to confirm component was added,
                    isDone: (el)=>Object.keys(el.getSchema('components')).length > 1,
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        el.setWindow('explorer', 'insert:library');
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.uploadLogo | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getData('files')).length > 0,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/add-file');
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.addColor | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getData('designSystem').color || {}).length > 2,
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        el.call('activeAddingFloatingPanel', ev, 'color');
                    }
                },
                // {
                //   Text: {
                //     text: 'Setup a global theme'
                //   },
                //   isDone: el =>
                //     Boolean(
                //       el.getData('designSystem').theme?.document[
                //         '@' + el.call('getSystemGlobalTheme')
                //       ]
                //     ),
                //   onClick: (ev, el) => {
                //     ev.stopPropagation()
                //     el.call('activeAddingFloatingPanel', ev, 'global_theme')
                //   }
                // }
                {
                    Text: {
                        text: '{{ learn.checklist.publish | polyglot }}'
                    },
                    isDone: (el)=>el.call('getCookie', el.getAppKey() + '_projectWasPublished'),
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/publish');
                    }
                }
            ]
    }
};

});

parcelRegister("aTPXf", function(module, exports) {

$parcel$export(module.exports, "ActionNotification", () => $7ef75785062610a1$export$66de11dc13751ad0);
$parcel$export(module.exports, "ActionNotificationButtons", () => $7ef75785062610a1$export$1b363515a2bb1540);
// ActionNotification — the ACTION tier of the CTA-notification set (Nika
// 2026-09-02: "notifications should have CTA buttons that navigate to
// related field … create new component based on TutorialNotification, add
// buttons at the right — like Confirm/Goto and Cancel as vertical set —
// add this component in workspace-ui and reuse in Bellforge").
//
// FAMILY NOTE (notificationFamilyChrome.test.js, DESIGN_LANGUAGE.md §7.6):
// the chassis is the coachmark family's ("based on TutorialNotification" —
// canvas-card-glass + radiusControl, elevation carried by the theme), but
// dismissal is PER EVENT — the two buttons — never a cookie, so this card
// joins NEITHER locked family list. It is the third tier: a transient
// notification that asks for one decision and shows where the event went.
//
// CONTRACT. Content from state: { title, descr?, confirmText?, cancelText? }.
// Each of those four is KEY-IN-STATE (docs/I18N-CONVENTION.md): the state field
// may carry a bundle KEY or a plain server-supplied string, and every render
// site resolves it through polyglot — which returns a non-key verbatim, so a
// shell notification row's raw title still renders unchanged.
// Behaviour from mount-site props on the CARD:
//   onConfirmAction(ev, card, s) — absent → openNotificationTarget(s, card),
//     so a shell notification row ({ href, notifType, metadata }) drops in
//     unchanged and the Confirm button goes exactly where clicking the row's
//     toast would have gone.
//   onCancelAction(ev, card, s)  — absent → dismiss only.
// Both buttons remove the card afterwards (actionCard marks the removal
// root, the rootSlide idiom).
const $7ef75785062610a1$export$66de11dc13751ad0 = {
    extends: 'Navbar',
    theme: 'canvas-card-glass',
    round: 'radiusControl',
    overflow: 'hidden',
    padding: '0',
    flow: 'x',
    align: 'stretch',
    gap: '0',
    width: '100%',
    maxWidth: 'H2',
    actionCard: true,
    state: {
        title: 'shell.actionNotification.done',
        descr: '',
        confirmText: 'shell.actionNotification.goTo',
        cancelText: 'common.action.cancel'
    },
    Hgroup: {
        flex: 1,
        margin: 'auto',
        padding: 'Z1 A Z1 B',
        gap: 'Y1',
        lineHeight: 1.4,
        minWidth: '0',
        H: {
            tag: 'strong',
            text: (el, s)=>el.call('polyglot', s.title || '')
        },
        P: {
            if: (el, s)=>!!s.descr,
            text: (el, s)=>el.call('polyglot', s.descr || '')
        }
    },
    ActionNotificationButtons: {}
};
const $7ef75785062610a1$export$1b363515a2bb1540 = {
    childExtends: [
        'CanvasButton',
        'Button'
    ],
    flow: 'y',
    align: 'stretch',
    fontSize: 'Z2',
    // gap, never inter-button dividers (§2.5 — row separators inside rounded
    // cards stay banned).
    gap: 'X2',
    flex: 'none',
    childProps: {
        round: '0',
        flex: 1,
        padding: 'Y A',
        gap: 'X2',
        align: 'center start'
    },
    children: [
        {
            icon: 'checkmark',
            text: (el, s)=>el.call('polyglot', s.confirmText || 'shell.actionNotification.goTo'),
            onClick: (ev, el, s)=>{
                const card = el.lookup((x)=>x.actionCard);
                if (card && typeof card.onConfirmAction === 'function') card.onConfirmAction(ev, card, s);
                else // The default: route to the notification's own target — feature
                // modal or slot, the ONE click-through decision the toast uses.
                try {
                    el.call('openNotificationTarget', s, card || el);
                } catch (_) {
                /* target-less state — the dismiss below still resolves the card */ }
                if (card && card.remove) card.remove();
            }
        },
        {
            icon: 'x',
            text: (el, s)=>el.call('polyglot', s.cancelText || 'common.action.cancel'),
            onClick: (ev, el, s)=>{
                const card = el.lookup((x)=>x.actionCard);
                if (card && typeof card.onCancelAction === 'function') card.onCancelAction(ev, card, s);
                if (card && card.remove) card.remove();
            }
        }
    ]
};

});

parcelRegister("guX97", function(module, exports) {

$parcel$export(module.exports, "TutorialNotification", () => $c02d53db612d9cb5$export$e106eb5586d3fe2c);
// TutorialNotification — the chassis of the COACHMARK family, one of the two
// CTA notification families DESIGN_LANGUAGE.md §7.6 defines. Coachmark chrome
// is `theme: 'canvas-card-glass'` + `round: 'radiusControl'`, elevation `float`
// carried by the theme (never a `shadow:` key here), and cookie dismissal.
//
// It is NOT the adoption target for the whole app. The elevated-alert family —
// CallInvitationBanner, CreditBlocker, AiActionConfirmCard, on
// `background:'document'` + `radiusSheet` + `shadow:'overlay'` with durable
// dismissal — stays separate on purpose. Nika decided that on 2026-08-29
// (CALLINVITATION-CONSOLIDATE-1, answer B): two families, each internally
// consistent, one per urgency tier. Giving this chassis an eyebrow slot, a
// header dismiss-X and an elevated-surface variant so those three could adopt
// it is the scope increase that decision declined — do not add them, and do
// not migrate those three here.
//
// `packages/shared/__tests__/notificationFamilyChrome.test.js` locks both
// signatures; move a member between families there and in §7.6, in the same
// commit, or not at all.
const $c02d53db612d9cb5$export$e106eb5586d3fe2c = {
    extends: 'Navbar',
    theme: 'canvas-card-glass',
    padding: '0',
    overflow: 'hidden',
    align: 'stretch',
    transition: 'all, defaultBezier, B2',
    round: 'radiusControl',
    gap: 'A',
    flow: 'y',
    width: '100%',
    maxWidth: 'H2',
    rootSlide: true,
    useCookie: true,
    // Same cookie-dismiss contract as TutorialGifNotification (family
    // consistency — this card is the adoption target for canvas COACHMARK
    // notifications and must behave like every other dismissible card in
    // the family, not just look like one). Cookie dismissal is per-browser,
    // which is exactly why the elevated-alert family may never inherit it:
    // an urgent card dismissed on the laptop would return on the phone.
    if: (el, s)=>{
        const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true';
        return el.useCookie ? !preventByCookie : true;
    },
    state: {
        title: 'learn.coach.canvas.title',
        descr: 'learn.coach.canvasAlt.descr',
        icon: 'resize.json'
    },
    Lottie: {
        minWidth: '3.2em',
        src: '{{ icon }}',
        fontSize: 'C2'
    },
    Hgroup: {
        flex: 1,
        margin: 'auto',
        padding: 'Z B A',
        gap: 'Y1',
        lineHeight: 1.4,
        width: '100%',
        H: {
            tag: 'strong',
            text: (el, s)=>el.call('polyglot', s.title || '')
        },
        P: {
            text: (el, s)=>el.call('polyglot', s.descr || '')
        }
    },
    // Adopts the shared bottom action bar every other sibling uses (was a
    // bespoke absolute-positioned, icon-only right rail with no `onClick` on
    // either button — non-functional, and structurally too narrow to ever
    // hold a text-labeled 1-N CTA set). TutorialNotificationButtons already
    // supports N actions via its `children` array (see
    // TutorialGifNotificationSlider.js and gazer's OnboardingOverlay.js for
    // 2- and 3-button overrides) — this is the general contract callers
    // adopt: override `TutorialNotificationButtons.children` with
    // `{ icon, text, onClick, hide? }` objects.
    //
    // `order: '1'`: base keys merge BEFORE consumer keys, so a consumer's own
    // content key (Lead/Message) would otherwise land AFTER this action row —
    // in every horizontal pill the CTAs rendered LEFT of the message (measured
    // live on /infra, UI-TUTORIAL-NOTIFICATION-FAMILY-1). The action row is
    // the family's bottom/trailing bar by contract, so it pins itself last.
    TutorialNotificationButtons: {
        order: '1'
    }
};

});

parcelRegister("b8HiZ", function(module, exports) {

$parcel$export(module.exports, "TutorialNotificationStack", () => $81c2089e3d7f5b2b$export$a33d0eabf7df3757);
const $81c2089e3d7f5b2b$export$a33d0eabf7df3757 = {
    flow: 'y',
    childExtends: 'TutorialNotification',
    position: 'relative',
    gap: 'X',
    width: 'H2',
    childrenAs: 'state',
    // Per-child dismissal now comes from TutorialNotification's own
    // `useCookie`/`if:` (inherited via childExtends — the same mechanism
    // TutorialGifsNotificationStack already relies on), so this no longer
    // hand-rolls its own cookie pre-filter. `if:false` never creates the DOM
    // node (smbls/packages/element/src/create.js), so a dismissed card
    // leaves no `:nth-child()` gap — behavior is identical, one fewer
    // bespoke path to keep in sync.
    children: [
        {
            key: 'explainCanvas',
            title: 'learn.coach.canvas.title',
            descr: 'learn.coach.canvas.descr',
            icon: 'resize.json',
            docsArticle: '/canvas-and-editor'
        },
        {
            key: 'explainRealtime',
            title: 'learn.coach.realtime.title',
            descr: 'learn.coach.realtime.descr',
            icon: 'realtime-move.json',
            docsArticle: '/publish'
        },
        {
            key: 'explainEditingAndNav',
            title: 'learn.coach.edit.title',
            descr: 'learn.coach.edit.descr',
            icon: 'double-click.json',
            docsArticle: '/building-in-symbols'
        }
    ],
    childProps: {
        ':nth-child(1)': {
            zIndex: 3,
            position: 'relative'
        },
        ':nth-child(2)': {
            pointerEvents: 'none',
            zIndex: 2,
            opacity: 0.9,
            position: 'absolute',
            transform: 'translate3d(0, -0.7em, 0) scale(0.95)'
        },
        ':nth-child(3)': {
            pointerEvents: 'none',
            zIndex: 1,
            opacity: 0.7,
            position: 'absolute',
            transform: 'translate3d(0, -1.2em, 0) scale(0.9)'
        }
    }
};

});

parcelRegister("jDN2N", function(module, exports) {

$parcel$export(module.exports, "IntroPanel", () => $e4c7b3fa294dcf55$export$b9367e9c9a2468a2);
const $e4c7b3fa294dcf55$export$b9367e9c9a2468a2 = {
    flow: 'y',
    fontSize: 'Z1',
    padding: 'A2 A A2',
    gap: 'C',
    overflow: 'hidden auto',
    Hgroup: {
        H: {
            fontSize: 'B2',
            margin: '0',
            color: 'title',
            fontWeight: '500',
            text: (el)=>{
                const { name: name, username: username } = el.getRootState();
                return el.call('polyglot', 'learn.intro.greeting').replace('{name}', username || name || '');
            }
        },
        P: {
            margin: '0',
            fontSize: 'Z2',
            color: 'paragraph',
            text: '{{ learn.intro.welcome | polyglot }}'
        }
    },
    DragParagraph: {
        fontSize: 'Z1',
        margin: 'Z auto A'
    },
    DragComponentsTutorial: {},
    Line: {
        margin: '0'
    },
    MovingOn: {
        P: {
            color: 'paragraph',
            text: '{{ learn.intro.continue | polyglot }}'
        },
        Flex: {
            flow: 'y',
            gap: 'X2',
            childExtends: 'Flex',
            childProps: {
                align: 'center',
                gap: 'Z',
                padding: 'Z2 W',
                width: '100%',
                round: 'radiusControl',
                transition: 'A defaultBezier background',
                color: 'title',
                // Row-separator-as-chrome (design-direction.md §8 / DESIGN_LANGUAGE
                // §2.5 — "no row hairlines… use gap + hover tint"). Replaced the top
                // divider with the parent Flex's `gap` and a real hover fill (§8.1)
                // instead of text-only underline.
                ':hover': {
                    background: 'hover',
                    textDecoration: 'underline'
                },
                Icon: {
                    order: '-2',
                    name: 'arrow up right'
                }
            },
            children: [
                {
                    Text: {
                        text: '{{ learn.intro.myContent | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.chatAi | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.moreTutorials | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.moreExamples | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.libraryComponents | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.myCode | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.documentation | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.howToExport | polyglot }}'
                    }
                },
                {
                    Text: {
                        text: '{{ learn.intro.support | polyglot }}'
                    }
                }
            ]
        }
    },
    Dismiss: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        alignSelf: 'start',
        fontSize: 'Z',
        gap: 'X2',
        opacity: '.65',
        margin: '- - - -A',
        padding: 'Z A',
        icon: 'x circle fill',
        text: '{{ learn.intro.dismiss | polyglot }}',
        onClick: (ev, el)=>{
            el.call('setCookie', 'tutorialMarked_intro', true);
            el.closeWindow('explorer');
        }
    }
};

});

parcelRegister("4i8Bg", function(module, exports) {

$parcel$export(module.exports, "ExampleItemInLearn", () => $31ff83a2314f7d1b$export$ea36d12a85b634f2);
const $31ff83a2314f7d1b$export$ea36d12a85b634f2 = {
    extends: 'LibraryItemInLearn',
    href: null,
    onClick: (ev, el)=>{
        el.setWindow('docs', '/examples');
    },
    state: {
        poster: 'example_clock.png',
        descr: 'learn.example.counter.descr',
        title: 'learn.example.counter.title'
    },
    Box: {
        position: 'relative',
        width: 'E',
        // Fill-contrast frame (was a `line`-bordered outline — border-habit
        // sweep, design-direction.md §8) around the poster thumbnail.
        background: 'overlay',
        round: 'radiusControl',
        Img: {
            display: 'block',
            round: 'radiusControl',
            position: 'relative',
            width: '100%',
            src: '{{ poster }}'
        }
    },
    Flex: {
        Strong: {},
        Span: {
            text: (el, s)=>el.call('polyglot', s.descr || '')
        },
        Span_2: null
    }
};

});

parcelRegister("QxmOO", function(module, exports) {

$parcel$export(module.exports, "ExamplesInLearn", () => $09debd716f698da6$export$91018bcd516f5ecb);
const $09debd716f698da6$export$91018bcd516f5ecb = {
    state: {
        limit: 5
    },
    tag: 'form',
    CaptionTitle: {
        width: '100%',
        align: 'center',
        Text: {
            text: '{{ learn.examples.title | polyglot }}'
        },
        ExpandButton: {
            extends: [
                'CanvasButton',
                'IconButton'
            ],
            margin: '- - - auto',
            icon: 'expand',
            aria: {
                label: (el)=>el.call('polyglot', 'learn.examples.open')
            },
            onClick: (ev, el)=>{
                el.setWindow('docs', '/examples');
            }
        }
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        margin: '- - - -X',
        childExtends: 'ExampleItemInLearn',
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    poster: 'example_counter.png',
                    descr: 'learn.example.counter.descr',
                    title: 'learn.example.counter.title'
                },
                {
                    poster: 'example_conditional.png',
                    descr: 'learn.example.conditional.descr',
                    title: 'learn.example.conditional.title'
                },
                {
                    poster: 'example_toggling-state.png',
                    descr: 'learn.example.toggling.descr',
                    title: 'learn.example.toggling.title'
                },
                {
                    poster: 'example_fetch.png',
                    descr: 'learn.example.fetch.descr',
                    title: 'learn.example.fetch.title'
                },
                {
                    poster: 'example_form-input.png',
                    descr: 'learn.example.formInput.descr',
                    title: 'learn.example.formInput.title'
                },
                {
                    poster: 'example_clock.png',
                    descr: 'learn.example.clock.descr',
                    title: 'learn.example.clock.title'
                },
                {
                    poster: 'example_tabs.png',
                    descr: 'learn.example.tabs.descr',
                    title: 'learn.example.tabs.title'
                },
                {
                    poster: 'example_accordion.png',
                    descr: 'learn.example.accordion.descr',
                    title: 'learn.example.accordion.title'
                },
                {
                    poster: 'example_progress.png',
                    descr: 'learn.example.progress.descr',
                    title: 'learn.example.progress.title'
                },
                {
                    poster: 'example_dynamic.png',
                    descr: 'learn.example.dynamicList.descr',
                    title: 'learn.example.dynamicList.title'
                }
            ].slice(0, s.limit || 30)
    },
    InsertSectionShadow: {
        left: '-C1',
        right: '-C1',
        bottom: 'C'
    },
    Flex_buttons: {
        childExtends: [
            'CanvasButton',
            'Button'
        ],
        margin: '- - - -Y2',
        zIndex: 2,
        Button: {
            icon: (el, s)=>'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
            text: (el, s)=>el.call('polyglot', s.limit === 5 ? 'learn.examples.more' : 'learn.examples.less'),
            gap: 'Y1',
            padding: 'Y2 Z2',
            color: 'caption',
            fontSize: 'Z2',
            Icon: {
                order: 2
            },
            onClick: (ev, el, s)=>{
                s.update({
                    limit: s.limit === 5 ? 30 : 5
                });
            }
        }
    },
    flow: 'y',
    align: 'start',
    gap: 'A',
    position: 'relative'
};

});

parcelRegister("7vocS", function(module, exports) {

$parcel$export(module.exports, "ExtensionCanvasNavbar", () => $576e349d061d935a$export$22941971b7e98993);
const $576e349d061d935a$export$22941971b7e98993 = {
    extends: 'Navbar',
    gap: 'A2',
    round: 'radiusPill',
    padding: 'V Z',
    userSelect: 'none',
    theme: 'common-box',
    LogoDropdown: {},
    Inspects: {
        extends: 'NavbarButtonSet',
        gap: 'X2',
        Inspect: {
            title: (el)=>el.call('polyglot', 'editor.ext.inspect'),
            icon: 'sf inspect',
            onClick: (ev, el, s)=>{
                if (window.chrome && window.chrome.runtime) {
                    const extId = window.prompt('What is your extension id?', // 'ohaibdehbmoofjegbepabbkaljahdhac',
                    'lfjlkobjhaemapiegmoceekipkjgapae');
                    window.chrome.runtime.sendMessage(extId, {
                        type: 'toggle_platform_mode'
                    }, (response)=>{
                        console.log('%creceived response', 'color: skyBlue', response);
                        if ('domql' in response) {
                            console.log('%cdomql received', 'color: green');
                            s.update({
                                value: response.domql
                            });
                        }
                    });
                } else console.error('chrome extension not installed');
            }
        },
        AddToCanvasButton: {
            '!value': {
                opacity: 0.35,
                pointerEvents: 'none'
            },
            extends: 'DropdownButton',
            ignoreChildExtends: true,
            ignoreChildProps: true,
            Button: {
                icon: 'plus oval',
                fontWeight: 400,
                text: '{{ editor.ext.addToCanvas | polyglot }}',
                aspectRatio: 'none',
                onClick: async (ev, el, s)=>{
                    await el.closeModal();
                    const t = setTimeout(()=>{
                        el.call('openRouterModal', '/add-component', {
                            key: 'ParsedComponent',
                            title: '',
                            type: 'components',
                            value: s.value,
                            advanced: true
                        });
                        clearTimeout(t);
                    }, 500);
                }
            },
            IconButton: {}
        },
        Edit: {
            disabled: true,
            opacity: 0.35,
            pointerEvents: 'none',
            title: (el)=>el.call('polyglot', 'editor.ext.edit'),
            icon: 'sf pencil',
            onClick: (ev, el, s)=>{}
        },
        Replace: {
            disabled: true,
            opacity: 0.35,
            title: (el)=>el.call('polyglot', 'editor.ext.replace'),
            icon: 'sf replace',
            onClick: (ev, el, s)=>{},
            pointerEvents: 'none'
        }
    },
    UrlAddressBar: {
        flex: 1
    },
    History: {
        extends: 'NavbarButtonSet',
        gap: 'X2',
        Undo: {
            title: (el)=>el.call('polyglot', 'editor.ext.undo'),
            icon: 'undo',
            onClick: (ev, el, s)=>{
                el.sdk.undo();
            }
        },
        Redo: {
            title: (el)=>el.call('polyglot', 'editor.ext.redo'),
            icon: 'redo',
            onClick: (ev, el, s)=>{
                el.sdk.redo();
            }
        },
        History: {
            title: (el)=>el.call('polyglot', 'editor.ext.history'),
            icon: 'sf history',
            onClick: (ev, el, s)=>{
                el.getRootState().toggle('isVersionsOpen', {
                    preventUpdate: true
                });
                el.getVersionsAside()?.update();
            }
        }
    },
    Meta: {
        extends: 'NavbarButtonSet',
        gap: 'W2',
        InNewTab: {
            icon: 'sf arrow up right',
            title: (el)=>el.call('polyglot', 'members.sharingNavbar.newTab'),
            onClick: 'openInNewTab'
        },
        Share: {
            title: (el)=>el.call('polyglot', 'members.sharingNavbar.share'),
            icon: 'sf share',
            onClick: (ev, el, s)=>{},
            Dropdown: {
                left: 'auto',
                right: '-A',
                ShareDropdown: {}
            },
            extends: [
                'CanvasButton',
                'IconButton',
                'DropdownParentFocus'
            ]
        }
    },
    Closing: {
        extends: 'NavbarButtonSet',
        gap: 'W2',
        InNewTab: {
            icon: 'question mark',
            title: (el)=>el.call('polyglot', 'editor.ext.help')
        },
        Quetion: {
            title: (el)=>el.call('polyglot', 'common.action.close'),
            icon: 'crossmark',
            onClick: (ev, el, s)=>el.closeModal()
        }
    }
};

});

parcelRegister("w3B2S", function(module, exports) {

$parcel$export(module.exports, "UrlAddressBar", () => $0605c777036153b4$export$25e6a8f722a492d1);
const $0605c777036153b4$export$25e6a8f722a492d1 = {
    tag: 'search',
    Form: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        margin: '0',
        attr: {
            novalidate: true
        },
        onSubmit: (ev, el, s)=>{
            ev.preventDefault();
            const inputNode = el.Input.node;
            let val = inputNode.value.trim();
            if (!val) {
                inputNode.setCustomValidity('This field is required.');
                inputNode.reportValidity();
                return;
            }
            let finalUrl = val;
            let isValid = false;
            // --- 1. Try to parse as-is (preserves user's http:// or https://) ---
            try {
                const u = new URL(finalUrl);
                if (u.protocol !== 'http:' && u.protocol !== 'https:') throw new Error('Unsupported protocol');
                finalUrl = u.href;
                isValid = true;
            } catch (e) {
                // --- 2. Strip any malformed protocol and rebuild with https:// ---
                // Remove all variations: https://, http://, https:, http:, //, ///
                const cleanDomain = finalUrl.replace(/^(?:https?:?\/+)+/i, '');
                finalUrl = `https://${cleanDomain}`;
                // --- 3. Validate the fixed URL ---
                try {
                    const u = new URL(finalUrl);
                    // Ensure we have a valid hostname
                    if (!u.hostname || !u.hostname.includes('.') && u.hostname !== 'localhost') throw new Error('Invalid hostname');
                    isValid = true;
                    finalUrl = u.href;
                } catch (e2) {
                    inputNode.setCustomValidity('Please enter a valid domain (e.g., google.com)');
                    inputNode.reportValidity();
                    return;
                }
            }
            // --- 4. Submit if valid ---
            if (isValid) {
                inputNode.setCustomValidity('');
                inputNode.value = finalUrl;
                console.log(finalUrl);
                s.update({
                    url: finalUrl
                });
            }
        },
        Icon: {
            fontSize: 'Z1',
            margin: '- -B2 - A',
            name: 'network'
        },
        Input: {
            flex: 1,
            autofocus: 'autofocus',
            round: '0',
            placeholder: (el)=>el.call('polyglot', 'editor.ext.urlPlaceholder'),
            padding: 'Y1 B2 Y1 B2',
            theme: 'transparent',
            // A typed value takes the brand value ink; the transparent theme's own
            // ink is a 65% alpha, one tone with the placeholder hint in light.
            color: 'title',
            outline: 'none',
            name: 'url',
            required: true,
            type: 'text',
            disabled: (el)=>{
                const t = el.call('sameOriginTop');
                return !Boolean(t && t.chrome && t.chrome.runtime);
            },
            appearance: 'none',
            ':focus-visible': {
                outline: 'none'
            },
            '::-webkit-search-cancel-button': {
                display: 'none'
            },
            '::placeholder': {
                color: 'placeholder'
            },
            onInput: (ev, el, s)=>{
                el.node.setCustomValidity('');
                s.quietUpdate({
                    urlPlaceholder: el.node.value
                });
            },
            onBlur: (ev, el, s)=>{
                let v = el.node.value.trim();
                if (v && !/^https?:\/\//i.test(v)) {
                    const clean = v.replace(/^(?:https?:?\/+)+/i, '');
                    if (clean) {
                        el.node.value = `https://${clean}`;
                        s.quietUpdate({
                            urlPlaceholder: el.node.value
                        });
                    }
                }
            }
        }
    },
    VisitedPages: {
        extends: 'Dropdown',
        width: '100%',
        left: '0'
    },
    extends: 'DropdownParentFocus',
    position: 'relative',
    theme: 'quinary',
    round: 'radiusPill',
    minWidth: 'D3',
    margin: '-V - - -'
};

});

parcelRegister("gGzRt", function(module, exports) {

$parcel$export(module.exports, "LogoDropdown", () => $c25c62ee20ccf9c0$export$bf41e5b326b68de1);
const $c25c62ee20ccf9c0$export$bf41e5b326b68de1 = {
    Logo: {
        pointerEvents: 'none',
        position: 'relative',
        top: 'auto',
        left: 'auto',
        style: {
            color: 'currentColor'
        },
        Dropdown: null
    },
    Dropdown: null,
    DropdownArrow: {
        margin: '- W2 - -'
    },
    Dropdown_2: {
        left: '-Z',
        'Dropdown.Logo': {}
    },
    extends: [
        'CanvasButton',
        'DropdownParentFocus'
    ],
    ariaLabel: (el)=>el.call('polyglot', 'editor.logoMenu.ariaLabel'),
    flow: 'x',
    round: 'radiusPill',
    align: 'center',
    padding: 'W'
};

});

parcelRegister("8gvzB", function(module, exports) {

$parcel$export(module.exports, "InstallExt", () => $60484f1ff61283d8$export$ded4bf9c71b08005);
const $60484f1ff61283d8$export$ded4bf9c71b08005 = {
    extends: 'ModalWindow',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'shadow',
    ModalHeader: null,
    IconButton: null,
    Flex: {
        align: 'start',
        gap: 'Z2',
        whiteSpace: 'nowrap',
        Img: {
            src: 'chrome-ext-icon.png',
            width: 'C',
            margin: '-W - - -'
        },
        Hgroup: {
            H: {
                tag: 'strong',
                text: '{{ learn.install.extTitle | polyglot }}'
            },
            P: {
                text: '{{ learn.install.extDescr | polyglot }}'
            },
            gap: 'X'
        }
    },
    Flex_Buttons: {
        align: 'start',
        gap: 'Z',
        childExtends: 'Button',
        margin: '- - - -X',
        Install: {
            extends: [
                'Link',
                'Button'
            ],
            href: '/docs/chrome-extension',
            target: '_blank',
            text: '{{ learn.install.install | polyglot }}',
            theme: 'primary',
            icon: 'arrow up right',
            gap: 'X2',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            fontWeight: '700',
            Icon: {
                order: 2
            },
            onClick: ()=>{}
        },
        Cancel: {
            text: '{{ common.action.cancel | polyglot }}',
            // `line` border removed (border-habit sweep, design-direction.md §8)
            // — `theme: 'tertiary'` ("the quiet/text control theme", DESIGN_LANGUAGE
            // §2.4) already supplies a complete, transparent-at-rest state language
            // (rest/hover/active); the manual outline on top was the outlined-
            // button habit, working against the theme's own quiet intent.
            theme: 'tertiary',
            gap: 'X2',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            onClick: (ev, el)=>el.closeModal()
        }
    }
};

});

parcelRegister("SMppT", function(module, exports) {

$parcel$export(module.exports, "DashboardNavbar", () => $0a4a9844ced51c3d$export$33004ad7afb7afec);
const $0a4a9844ced51c3d$export$33004ad7afb7afec = {
    LogoDropdown: {},
    HeaderBreadcrumb: {
        fontSize: 'A',
        margin: '- -A - -',
        Button_username: null,
        Button_project: null
    },
    AddNewButton: {
        extends: [
            'CanvasButton',
            'Button'
        ],
        icon: 'plus',
        padding: 'Z Z2',
        gap: 'X2',
        text: '{{ editor.dashboard.newProject | polyglot }}',
        aspectRatio: 'none',
        Icon: {
            color: 'blue'
        },
        onClick: async (ev, el)=>{
            await el.call('openRouterModal', '/settings', {
                key: '/onboarding'
            });
        }
    },
    DocsSearchHeader: {
        margin: '- auto'
    },
    ThemesInNavbar: {
        margin: '- A2 - -'
    },
    Avatar: {
        fontSize: 'X',
        onClick: async (ev, el)=>{
            await el.call('openRouterModal', '/settings', {
                key: '/personal-account'
            });
        }
    },
    extends: 'Navbar',
    gap: 'A2',
    round: 'radiusPill',
    padding: 'W Z2',
    fontSize: 'Z1',
    userSelect: 'none',
    theme: 'common-box',
    position: 'sticky',
    top: 'X',
    left: 'X',
    right: 'X',
    zIndex: 9999999
};

});

parcelRegister("2aOwz", function(module, exports) {

$parcel$export(module.exports, "CanvasPagesDropdown", () => $1953b504c20b5ca8$export$d89c380e41f2aa5d);
const $1953b504c20b5ca8$export$d89c380e41f2aa5d = {
    extends: [
        'CanvasButton',
        'DropdownParentFocus',
        'Button'
    ],
    Text: {
        lineHeight: 0.9,
        width: 'D',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el)=>el.call('getActiveCanvasPage') || el.call('polyglot', 'editor.chooseCanvas.default'),
        onMouseover: (ev, el, s)=>{
            if (!s.hover) {
                s.hover = true;
                el.call('setNavbarTooltipPosition', {
                    visible: true
                });
            }
        },
        onMouseleave: (ev, el, s)=>{
            if (s.hover) {
                s.hover = false;
                const Tooltip = el.lookup('NavbarTooltip');
                if (Tooltip) Tooltip.update({
                    opacity: '0',
                    visibility: 'hidden'
                });
            }
        },
        title: (el)=>el.call('polyglot', 'editor.chooseCanvas.selected')
    },
    Dropdown: {
        left: '0',
        ChooseCanvas: {
            padding: 'X'
        }
    },
    DropdownArrow: {},
    padding: 'Y2 Y2 Y2 Z2',
    align: 'center',
    gap: 'Y',
    aspectRatio: 'none'
};

});

parcelRegister("12H5K", function(module, exports) {

$parcel$export(module.exports, "EnvsNavbar", () => $0c2767706a4bad3d$export$3fbb5972befe2441);
const $0c2767706a4bad3d$export$3fbb5972befe2441 = {
    extends: [
        'CanvasButton',
        'DropdownParentFocus',
        'Button'
    ],
    padding: 'Y1 Y2 Y1 Z2',
    align: 'center',
    gap: 'Y1',
    margin: '- -Y1',
    lineHeight: 1,
    ConnectionLabel: {
        Circle: {
            boxSize: 'Y1',
            isActive: true,
            position: 'relative',
            isLoading: false,
            animationIterationCount: 'infinite',
            '.isLoading': {
                animation: 'blinking',
                animationDuration: 'G2'
            },
            '!isLoading': {
                animation: null
            },
            onRender: (el, s)=>{
                // The checkpoint bus is an ENHANCEMENT, not a precondition — see the
                // identical guard in ConnectionNavbar.js. Without an SDK the env
                // label still renders; only the auto-save blink is missing.
                if (!el.sdk?.rootBus?.on) return;
                const handler = ({ origin: origin })=>{
                    if (origin === 'auto') {
                        el.update({
                            isLoading: true
                        });
                        setTimeout(()=>el.update({
                                isLoading: false
                            }), 1000);
                    }
                };
                el.sdk.rootBus.on('checkpoint:done', handler);
            }
        },
        Text: {
            maxWidth: '100%',
            text: (el)=>'development',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            padding: '- - .1em'
        },
        CopyButton: null,
        onMouseover: (ev, el, s)=>{
            if (!s.hover) {
                s.hover = true;
                el.call('setNavbarTooltipPosition', {
                    visible: true
                });
            }
        },
        onMouseleave: (ev, el, s)=>{
            if (s.hover) {
                s.hover = false;
                const Tooltip = el.lookup('NavbarTooltip');
                if (Tooltip) Tooltip.update({
                    opacity: '0',
                    visibility: 'hidden'
                });
            }
        },
        title: (el)=>el.call('polyglot', 'publish.envs.title')
    },
    DropdownArrow: {},
    Dropdown: {
        left: '0',
        onClick: ()=>{},
        'Dropdown.Envs': {}
    }
};

});

parcelRegister("1cwKO", function(module, exports) {

$parcel$export(module.exports, "SharingNavbar", () => $0e0051b3c304efbd$export$84db5d08a1872df);
const $0e0051b3c304efbd$export$84db5d08a1872df = {
    extends: 'NavbarButtonSet',
    gap: 'W2',
    PreviewButton: {
        extends: 'DropdownButton',
        ignoreChildExtends: true,
        ignoreChildProps: true,
        Button: {
            icon: 'play oval',
            text: null,
            aspectRatio: 'none',
            onClick: (ev, el)=>{
                el.openModal('/browser-preview');
            },
            Icon: {
                color: 'blue'
            }
        },
        IconButton: {
            DropdownParentFocus: {
                position: 'absolute',
                Dropdown: {
                    left: '-D2',
                    onClick: ()=>{},
                    PreviewModesMenu: {}
                },
                inset: '0'
            }
        }
    },
    InNewTab: {
        icon: 'sf arrow up right',
        title: (el)=>el.call('polyglot', 'members.sharingNavbar.newTab'),
        onClick: 'openInNewTab'
    },
    Share: {
        title: (el)=>el.call('polyglot', 'members.sharingNavbar.share'),
        icon: 'sf share',
        Dropdown: {
            left: 'auto',
            right: '-A',
            onClick: (ev, el, s)=>{},
            'Dropdown.Share': {}
        },
        extends: [
            'CanvasButton',
            'IconButton',
            'DropdownParentFocus'
        ]
    }
};

});

parcelRegister("iJu6a", function(module, exports) {

$parcel$export(module.exports, "ActiveSyncInPublish", () => $da33c6eb31806311$export$b22bb9c2f6852300);
// A sync panel mock-up: no product surface mounts it and no record feeds it.
// Its status lines were invented ("Last version 1.2.1", "Synced 6 mins ago",
// "6 updates") and read as real activity wherever the component showed — they
// are gone (R2-M1 sweep). Real status needs a data contract first.
const $da33c6eb31806311$export$b22bb9c2f6852300 = {
    flow: 'y',
    gap: 'A',
    margin: '- -Z2',
    Website: {
        extends: 'DomainItem',
        Icon: {
            name: 'globe'
        },
        Hgroup: {
            H: {
                text: '{{ publish.sync.website.title | polyglot }}'
            },
            P: null
        },
        Upgrade: null,
        align: 'start'
    },
    Figma: {
        extends: 'DomainItem',
        Icon: {
            name: 'figma'
        },
        Hgroup: {
            H: {
                text: 'Figma'
            },
            P: null
        },
        Upgrade: null,
        Sync: {
            extends: [
                'CanvasButton',
                'Button'
            ],
            padding: 'Y2 Z2',
            margin: '-Y1 -Z2 - -',
            fontSize: 'Z2',
            text: '{{ publish.action.sync | polyglot }}',
            icon: 'syncOvalFill',
            gap: 'Y1',
            Icon: {
                order: 2,
                color: 'blue'
            }
        },
        align: 'start'
    },
    Autosync: {
        extends: 'DomainItem',
        Icon: null,
        Hgroup: {
            H: {
                text: '{{ publish.sync.autosync | polyglot }}'
            },
            P: {
                text: '{{ publish.sync.autosyncHint | polyglot }}'
            }
        },
        Upgrade: null,
        Toggle: {
            margin: '- - - auto'
        },
        align: 'start'
    }
};

});

parcelRegister("dk3YI", function(module, exports) {

$parcel$export(module.exports, "SyncSuggestionsInPublish", () => $9b303a9f9c258abc$export$c682921053737a09);
const $9b303a9f9c258abc$export$c682921053737a09 = {
    flow: 'y',
    gap: 'A',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    childProps: {
        Icon: {
            name: '{{ icon }}'
        },
        Hgroup: {
            H: {
                text: (el, s)=>el.call('polyglot', s.title || '')
            },
            P: {
                text: (el, s)=>el.call('polyglot', s.descr || '')
            }
        },
        Upgrade: null,
        Button: {
            extends: [
                'CanvasButton',
                'Button'
            ],
            padding: 'Y2 Z2',
            margin: '-Y -Z2 - auto',
            text: '{{ publish.sync.connect | polyglot }}',
            icon: 'plus oval',
            gap: 'Y1',
            Icon: {
                order: 2,
                color: 'blue'
            },
            fontSize: 'Z2'
        },
        align: 'start'
    },
    children: [
        {
            icon: 'globe',
            title: 'publish.sync.website.title',
            descr: 'publish.sync.website.descr'
        },
        {
            icon: 'figma',
            title: 'Figma',
            descr: 'publish.sync.figma.descr'
        },
        {
            icon: 'wordpress',
            title: 'Wordpress',
            descr: 'publish.sync.wordpress.descr'
        },
        {
            icon: 'github',
            title: 'Github',
            descr: 'publish.sync.github.descr'
        }
    ],
    childrenAs: 'state'
};

});

parcelRegister("8iu1V", function(module, exports) {

$parcel$export(module.exports, "ExportsInPublish", () => $60a74c817a8e194e$export$15ccd15a29c1f632);
const $60a74c817a8e194e$export$15ccd15a29c1f632 = {
    flow: 'y',
    gap: 'A',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    childrenAs: 'state',
    childProps: {
        align: 'start',
        Icon: {
            name: '{{ icon }}'
        },
        Hgroup: {
            H: {
                text: (el, s)=>el.call('polyglot', s.title || '')
            },
            P: {
                text: (el, s)=>el.call('polyglot', s.descr || '')
            }
        },
        Upgrade: {
            if: (el)=>el.isFree()
        },
        Select: {
            padding: 'X Y2',
            margin: '-W Y2 - auto',
            background: 'none',
            color: 'currentColor',
            onChange: (ev, el, s, ctx)=>{
                const value = ev.target.value;
                if (value) s.update({
                    action: value
                });
            },
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>el.node.value === s.action
                }
            },
            if: (el)=>!el.isFree(),
            children: [
                {
                    text: 'CLI'
                },
                {
                    text: 'Zip'
                }
            ]
        },
        IconButton: {
            if: (el)=>!el.isFree(),
            extends: [
                'CanvasButton',
                'Button'
            ],
            padding: 'Y2',
            margin: '-Y -Y2',
            icon: 'downloadOutline',
            aria: {
                label: (el)=>el.call('polyglot', 'publish.exports.download')
            },
            gap: 'Y1',
            Icon: {
                order: 2,
                color: 'blue'
            }
        }
    },
    children: [
        {
            icon: 'terminal',
            title: 'publish.exports.local.title',
            descr: 'publish.exports.local.descr'
        },
        {
            icon: 'html',
            title: 'HTML',
            descr: 'publish.exports.html.descr'
        },
        {
            icon: 'jquery',
            title: 'jQuery',
            descr: 'publish.exports.jquery.descr'
        },
        {
            icon: 'react',
            title: 'React',
            descr: 'publish.exports.react.descr'
        },
        {
            icon: 'sf assets',
            title: 'Webp',
            descr: 'publish.exports.webp.descr'
        },
        {
            icon: 'icons',
            title: 'SVG',
            descr: 'publish.exports.svg.descr'
        }
    ]
};

});

parcelRegister("4MOhO", function(module, exports) {

$parcel$export(module.exports, "PublishTools", () => $37c2a6e87378efcd$export$97d4718db6c825d4);
const $37c2a6e87378efcd$export$97d4718db6c825d4 = {
    flow: 'y',
    gap: 'A',
    margin: '- -Z2',
    childExtends: 'DomainItem',
    Custom: {
        Hgroup: {
            H: {
                text: 'Version 2.0.0'
            },
            P: {
                text: '{{ publish.tools.updateMajor | polyglot }}'
            }
        }
    },
    Lookup: {
        Icon: {
            name: 'sf search'
        },
        Hgroup: {
            H: {
                text: 'Version 1.2.0'
            },
            P: {
                text: '{{ publish.tools.updateMinor | polyglot }}'
            }
        }
    },
    Current: {
        Icon: null,
        Hgroup: {
            H: {
                text: (el)=>'Version ' + el.getRootState('version'),
                IconButton: {
                    extends: [
                        'CanvasButton',
                        'IconButton'
                    ],
                    theme: null,
                    padding: 'Y',
                    margin: '- - -Z X',
                    icon: 'search oval dotted',
                    aria: {
                        label: (el)=>el.call('polyglot', 'publish.tools.showVersions')
                    },
                    onClick: (ev, el, s)=>{
                        el.getRootState().toggle('isVersionsOpen', {
                            preventUpdate: true
                        });
                        el.getVersionsAside()?.update();
                    }
                }
            },
            P: {
                text: '{{ publish.tools.autosaved | polyglot }}'
            }
        },
        Upgrade: null,
        Span: {
            margin: '- - - auto',
            text: '{{ publish.tools.latest | polyglot }}'
        }
    }
};

});

parcelRegister("7tIhN", function(module, exports) {

$parcel$export(module.exports, "InlineSelect", () => $571d981c95deed64$export$4f2db7fec6b223fd);
// InlineSelect — the house "quiet" native <select> for a control that sits
// INLINE in a row (the invite email row, the member rows, sharing
// permissions, the preview env picker): no field fill at rest, the row's
// own ink, sized to its longest option, and a fixed compact control height
// so no flex row can ever stretch it.
//
// UI-INVITE-MODAL-CONTROL-SIZE-1 (measured live on prod, 2026-09-07,
// lang=ka): the invite email row's role select painted 186×64. The recipe
// it carried at the call site (`padding: 'X Y2'`, `background: 'none'`,
// `color: 'currentColor'`, `width: 'auto'`, `flexShrink: '0'`) stated no
// height of its own, so the absolute overlay it sat in (`align-items:
// stretch`) grew it to the 62px send button beside it, and its label landed
// 13px under the input's text line. Rule 68: the control scale belongs to
// the primitive, never to the call site — and this was the FOURTH
// byte-identical copy of the recipe (MembersInInvite, InviteFormInDropdown,
// SharingPermissions, PreviewCanvasNavbar), which is where Rule 61 says it
// gets extracted. Host facts stay at the call site as MARGIN, never as
// padding: right-alignment (`margin-left: auto`) and the `-Y2` optical pull
// that lands the chevron on the host's scrollport edge.
const $571d981c95deed64$export$4f2db7fec6b223fd = {
    extends: 'Select',
    // Quiet at rest: the row's ink, no field fill. The `field` theme the
    // Select atom carries still paints its hover/focus washes (Rule 65 — a
    // control acknowledges the pointer), which is why `theme` is NOT nulled.
    background: 'none',
    color: 'currentColor',
    // Brand control scale (§6.2): pinned fontSize, fixed-px height — the ONE
    // compact variant — and an em horizontal inset. `minHeight` alone leaves a
    // flex host's `align-items: stretch` free to grow the box; `alignSelf:
    // center` closes that door in every host.
    fontSize: 'Z2',
    minHeight: 'controlHCompact',
    padding: '0 Y2',
    round: 'radiusControl',
    alignSelf: 'center',
    // A control NEVER clips its own label (design-system call 2026-08-19,
    // fable.md "invite role select: the label clips at 87px"): intrinsic
    // width, no flex squeeze — the vocabulary is the vocabulary, in every
    // locale ("ადმინისტრატორი" is 186px at this size).
    width: 'auto',
    flexShrink: '0',
    cursor: 'pointer'
};

});

parcelRegister("6pGEl", function(module, exports) {

$parcel$export(module.exports, "CompactIconButton", () => $4ab629364cb0e7a1$export$16eb4a68c3e8809);
// CompactIconButton — the 36px icon-only control (brand compact scale,
// `controlHCompact`) for an action that sits INSIDE another control's row:
// a pill field's send action, a row's copy action.
//
// UI-INVITE-MODAL-CONTROL-SIZE-1 (measured live on prod, 2026-09-07): the
// invite row's send button and the magic-link copy button painted 62px and
// 60px circles inside a 49px input. Both extended two Button descendants at
// once (`['CanvasButton', 'IconButton']`, `['CanvasButton', 'CopyButton']`)
// and came out with the Button atom's 44px `controlH` floor — SquareButton's
// `minHeight: 'auto'` reset never reached them through that stack — and
// then a `Y2` call-site padding on a content-box grew the box further. Only
// three buttons on the whole page carried the 44px floor: those two and the
// (intended) 44px AllMembersBtn. Rule 68: a control's geometry is stated
// ONCE, on its primitive — this one pins width, height, padding, box model
// AND min-height itself, and every consumer extends exactly this one name
// (a single `extends` string, never a pair).
//
// Theme is the consumer's: `primary` for the ONE primary action of a row
// (solid ink, never a hue fill — brand law), the inherited `tertiary` for a
// quiet action. Icon: `icon: '<name>'` at the call site, as on every
// IconText descendant.
//
// THE ICON-BUTTON LAW, staged (Nika 2026-09-26: "all icon buttons should have
// 1/1 aspect ratio"; DESIGN-WL-ICON-BUTTONS-SQUARE-1). Brand IconButton carries
// the law from company 5abaf75 (design-d1): an icon-only button is a square —
// controlHCompact, aspect-ratio 1 / 1, padding 0, flex-shrink 0, border-box,
// the glyph centred. Until that brand is published and pinned, THIS is the
// kit's square: every kit icon-only control extends it, so dev shows the law
// now. Its geometry is locked to brand's `.isIconOnly` values
// (__tests__/iconButtonSquare.test.js) — the two cannot drift, and once the
// pinned brand carries the law the declarations here restate it, never fight
// it.
const $4ab629364cb0e7a1$export$16eb4a68c3e8809 = {
    extends: [
        'IconButton',
        'AppControl'
    ],
    compact: true,
    boxSize: 'controlHCompact',
    minHeight: 'controlHCompact',
    aspectRatio: '1 / 1',
    boxSizing: 'border-box',
    padding: '0',
    round: 'radiusPill',
    flexShrink: '0',
    align: 'center center',
    cursor: 'pointer',
    Icon: {
        boxSize: 'iconSm',
        display: 'block',
        flexShrink: '0'
    }
};

});

parcelRegister("j2DKy", function(module, exports) {

$parcel$export(module.exports, "MembersInInvite", () => $ddcd09bca147f6d5$export$be96fae5728bbc55);
// Members section of the invite panel: the first five members of the current
// context (the org, or the project inside the canvas), each with a name, an
// email and a role, plus "All members" → /team-and-agents.
//
// It loads its OWN list when it mounts (it used to wait for the header
// button to preload it onto the root before the panel could open, so the
// panel showed nothing until a network round trip ended). Three states, each
// in its own box: loading (three skeleton rows), error (a line and a retry),
// ready (the rows; "Only you so far" when nobody else is there yet).
//
// A row's role is EITHER a select (when this caller may change it, to the
// roles the server accepts — `invitePolicy().editRolesFor`) OR a static,
// translated label. A row never shows an empty right side.
const $ddcd09bca147f6d5$export$be96fae5728bbc55 = {
    // FA204 — every helper the handlers read travels on `scope`.
    scope: {
        MAX_VISIBLE: 5,
        // Context-adaptive source: project members inside a project, the active
        // org's members (sdk.listOrgMembers) everywhere else. `key` is a data key
        // with a prefix, so it can never read as an HTML tag name.
        async load (host, s) {
            const st = s && typeof s.update === 'function' ? s : host.state;
            const root = st && st.root || host.getRootState() || {};
            const projectId = root.projectId;
            const orgId = root.jwtClaims && root.jwtClaims.workspace_org_id;
            // The first load starts in 'loading' already (the declared state) — no
            // write while the panel is still being created; a retry sets it here.
            if (st.membersStatus !== 'loading') st.update({
                membersStatus: 'loading'
            });
            try {
                let raw = [];
                if (projectId) raw = await host.call('getProjectMembers') || [];
                else if (orgId) raw = await host.sdk.listOrgMembers(orgId) || [];
                const members = raw.map((v)=>{
                    const u = v && v.user || v || {};
                    const eff = v && v.effectiveRole || {};
                    const id = String(v && (v._id || v.id) || u._id || u.id || u.email || '');
                    return {
                        key: 'member_' + id,
                        // The membership row id the PATCH routes key on — not the user id.
                        memberId: v && (v._id || v.id) || '',
                        name: u.name || '',
                        username: u.username || '',
                        email: u.email || '',
                        avatar: u.avatar || '',
                        role: eff.key || v && v.role || u.role || '',
                        roleName: eff.name || '',
                        tier: eff.baseTier || v && v.role || u.role || ''
                    };
                });
                st.update({
                    members: members,
                    membersStatus: 'ready'
                });
            } catch (err) {
                console.warn('[MembersInInvite] load failed:', err && err.message ? err.message : err);
                st.update({
                    members: [],
                    membersStatus: 'error'
                });
            }
        },
        // The translated name of a role, or the custom role's own name.
        roleText (el, s) {
            const key = el.call('invitePolicy', s).labelKey(s.role);
            return key ? el.call('polyglot', key) : s.roleName || s.role || '';
        }
    },
    state: {
        members: [],
        membersStatus: 'loading'
    },
    flow: 'y',
    gap: 'Y',
    onInit: (el, s)=>{
        el.scope.load(el, s);
    },
    CaptionTitle: {
        Text: {
            text: (el, s)=>s.membersStatus === 'ready' ? el.call('polyglot', 'members.invite.membersCount').replace('{count}', String((s.members || []).length)) : el.call('polyglot', 'members.invite.members')
        }
    },
    Loading: {
        flow: 'y',
        ariaBusy: 'true',
        hide: (el, s)=>s.membersStatus !== 'loading',
        children: [
            {},
            {},
            {}
        ],
        childProps: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            padding: 'Y 0',
            SkeletonCircle: {
                boxSize: 'B',
                flexShrink: '0'
            },
            SkeletonRow: {
                width: '50%'
            }
        }
    },
    LoadError: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        hide: (el, s)=>s.membersStatus !== 'error',
        Message: {
            tag: 'span',
            role: 'alert',
            fontSize: 'Z1',
            color: 'caption',
            text: (el, s)=>s.membersStatus === 'error' ? el.call('polyglot', 'members.invite.loadFailed') : ''
        },
        AppCapsuleBtnGhost: {
            compact: true,
            text: '{{ members.invite.retry | polyglot }}',
            onClick: (ev, el, s)=>{
                ev.preventDefault();
                const host = el.lookup('MembersInInvite');
                if (host) host.scope.load(host, host.state);
            }
        }
    },
    List: {
        flow: 'y',
        hide: (el, s)=>s.membersStatus !== 'ready',
        children: (el, s)=>(s.members || []).slice(0, el.lookup('MembersInInvite').scope.MAX_VISIBLE),
        childrenAs: 'state',
        childProps: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            padding: 'Y 0',
            minWidth: '0',
            // The person's own picture, else their initials. (A `key` factory here
            // never ran — the framework Avatar seeds from the element key, so every
            // row painted the same "Avatar" face.) The name is in the row's text,
            // so the image is decorative.
            Avatar: {
                boxSize: 'B',
                flexShrink: '0',
                src: (el, s)=>s.avatar || el.call('avatarUrl', s.name || s.username || s.email),
                alt: ''
            },
            Who: {
                flow: 'y',
                flex: '1',
                minWidth: '0',
                MemberName: {
                    tag: 'span',
                    fontSize: 'Z1',
                    color: 'title',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.name || s.username || s.email
                },
                MemberEmail: {
                    tag: 'span',
                    fontSize: 'Y1',
                    color: 'caption',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    hide: (el, s)=>!s.email || s.email === (s.name || s.username),
                    text: (el, s)=>s.email
                }
            },
            // The editable role — only where the server accepts a change from
            // this caller (invitePolicy). Org: PATCH /organizations/:orgId/
            // members/:id. Project: PATCH /projects/:projectId/members/:id.
            InlineSelect: {
                hide: (el, s)=>!el.call('invitePolicy', s).editRolesFor(s).length,
                aria: {
                    label: (el)=>el.call('polyglot', 'members.inviteForm.roleOfMember')
                },
                value: (el, s)=>s.role,
                onChange: async (ev, el, s)=>{
                    const value = ev.target.value;
                    const prev = s.role;
                    if (!value || value === prev) return;
                    const root = s && s.root || el.getRootState() || {};
                    const policy = el.call('invitePolicy', s);
                    const t = (k)=>el.call('polyglot', k);
                    // Optimistic: the select already shows the new role; the model
                    // follows it now and goes back on a refusal (the select's `value`
                    // reads the model, so the revert repaints it).
                    s.update({
                        role: value
                    });
                    try {
                        if (policy.context === 'project') await el.sdk.updateMemberRole(root.projectId, s.memberId, value);
                        else {
                            const orgId = root.jwtClaims && root.jwtClaims.workspace_org_id;
                            await el.sdk.updateOrgMember(orgId, s.memberId, {
                                role: value
                            });
                        }
                        s.update({
                            tier: value
                        });
                        const roleKey = policy.labelKey(value);
                        el.call('openNotification', {
                            title: t('members.roleUpdated.title'),
                            message: t('members.roleUpdated.message').replace('{name}', s.name || s.username || t('members.roleUpdated.fallbackName')).replace('{role}', roleKey ? t(roleKey) : value),
                            type: 'success'
                        });
                    } catch (err) {
                        s.update({
                            role: prev
                        });
                        el.call('openNotification', {
                            title: t('members.role.changeFailed'),
                            message: `${err && err.message ? err.message : err}`,
                            type: 'error'
                        });
                        console.warn('[MembersInInvite] role change failed:', err);
                    }
                },
                childrenAs: 'props',
                childProps: {
                    tag: 'option',
                    text: (el)=>el.call('polyglot', el.labelKey),
                    attr: {
                        selected: (el, s)=>el.value === s.role ? '' : null
                    }
                },
                children: (el, s)=>el.call('invitePolicy', s).editRolesFor(s)
            },
            // The role as text, for every row this caller may not change.
            RoleText: {
                tag: 'span',
                flexShrink: '0',
                fontSize: 'Z1',
                color: 'caption',
                hide: (el, s)=>!!el.call('invitePolicy', s).editRolesFor(s).length || !el.lookup('MembersInInvite').scope.roleText(el, s),
                text: (el, s)=>el.lookup('MembersInInvite').scope.roleText(el, s)
            }
        }
    },
    OnlyYou: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z1',
        color: 'caption',
        hide: (el, s)=>{
            // Read before any early return, so the signal is always tracked.
            const me = String(s.root.currentUserEmail || '').toLowerCase();
            if (s.membersStatus !== 'ready') return true;
            return !(s.members || []).every((m)=>me && String(m.email || '').toLowerCase() === me);
        },
        text: '{{ members.invite.onlyYou | polyglot }}'
    },
    // The full roster ("All members") — /team-and-agents owns member
    // management. A link, not a button (it navigates); it closes the panel
    // first. Bare `Link` key (FA806): the framework Link is the `<a>`.
    Link: {
        href: '/team-and-agents',
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        // The row's wash reaches Z into the panel's A padding, so its text lines
        // up with the member rows above it and the wash stays inside the panel.
        margin: '- -Z',
        padding: 'Y Z',
        round: 'radiusControl',
        fontSize: 'Z1',
        fontWeight: '500',
        color: 'title',
        textDecoration: 'none',
        cursor: 'pointer',
        ':hover': {
            background: 'hover'
        },
        ':active': {
            background: 'selected'
        },
        ':focus-visible': {
            shadow: 'focusRingInset'
        },
        Text: {
            text: '{{ members.invite.allMembers | polyglot }}'
        },
        Icon: {
            name: 'arrowAngleRight',
            boxSize: 'iconSm',
            flexShrink: '0'
        },
        onClick: (ev, el)=>{
            ev.preventDefault();
            ev.stopPropagation();
            el.call('closeDropdown', 'appInvite');
            el.router('/team-and-agents', el.getRoot());
        }
    }
};

});

parcelRegister("d4P6G", function(module, exports) {

$parcel$export(module.exports, "InviteFormInDropdown", () => $98534ad5284a2a17$export$8a8ae801343d178d);
// The invite form inside the invite panel (InviteDropdown owns its state).
//
//   Email      AppField + AppInput — a labelled field at the panel's full
//              width, an inline error under it in a reserved box
//   Actions    role select (AppSelect, the rest of the row) · copy-link icon
//              (its box reserved, shown once an invitation has a link) ·
//              "Send invite" (the ink capsule; "Sending…" while busy, same
//              width — AppLabelStack)
//   Note       one status line: the result of the last send, in a reserved
//              box (role="status", so it is announced)
//
// ONE SEND = ONE INVITATION. The copy-link icon copies the `inviteUrl` the
// SAME createOrgInvitation call returned; it never creates a second
// invitation (the old magic-link button did, and also sent a second email).
// A project invite returns no link, so the icon stays hidden there.
//
// The context decides the call, never the fields: inside a project
// (root.projectId) the form sends a PROJECT invite, at the role the select
// shows — its default included (before, an untouched select left `role`
// empty and the submit fell through to an ORG invitation). Outside a project
// it sends an org invitation. The roles offered and the default come from
// `invitePolicy` (shared/functions/inviteRoles.js), which mirrors the server.
const $98534ad5284a2a17$export$8a8ae801343d178d = {
    tag: 'form',
    flow: 'y',
    gap: 'Z',
    // Validation is ours (inline, in the field's reserved error line), not the
    // browser's bubble.
    noValidate: true,
    hide: (el, s)=>!el.call('invitePolicy', s).mayInvite,
    onSubmit: async (ev, el, s)=>{
        ev.preventDefault();
        if (!s || s.status === 'sending') return;
        const policy = el.call('invitePolicy', s);
        if (!policy.mayInvite) return;
        const email = String(s.email || '').trim();
        // The server's own email shape (ProjectMemberController.inviteMember).
        const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!email) {
            s.update({
                error: 'members.inviteForm.needEmail.message'
            });
            return;
        }
        if (!EMAIL_RE.test(email)) {
            s.update({
                error: 'members.inviteForm.invalidEmail'
            });
            return;
        }
        const allowed = policy.inviteRoles.map((r)=>r.value);
        const role = allowed.includes(s.role) ? s.role : policy.defaultRole;
        const root = s.root || el.getRootState() || {};
        s.update({
            status: 'sending',
            error: '',
            failure: '',
            sentEmail: '',
            sentUrl: '',
            sentNoEmail: false,
            copied: false
        });
        try {
            let url = '';
            let emailSent = true;
            if (policy.context === 'project') await el.sdk.inviteMember(root.projectId, email, role);
            else {
                const orgId = root.jwtClaims && root.jwtClaims.workspace_org_id;
                const invite = await el.sdk.createOrgInvitation(orgId, {
                    email: email,
                    role: role
                });
                url = invite && invite.inviteUrl || '';
                emailSent = !(invite && invite.emailSent === false);
            }
            s.update({
                status: 'idle',
                email: '',
                sentEmail: email,
                sentUrl: url,
                sentNoEmail: !emailSent
            });
            // Ready for the next address.
            const input = el.AppField && el.AppField.AppInput;
            if (input && input.node && typeof input.node.focus === 'function') input.node.focus();
        } catch (err) {
            console.warn('[InviteFormInDropdown] invite failed:', err);
            const failed = el.call('polyglot', 'members.invite.failed');
            s.update({
                status: 'idle',
                failure: el.call('userFacingErrorMessage', err, {
                    networkMessage: el.call('polyglot', 'members.invite.offline'),
                    fallback: (e)=>{
                        const msg = String(e && e.message || '').trim();
                        return msg ? failed + ': ' + msg : failed;
                    }
                })
            });
        }
    },
    AppField: {
        label: (el)=>el.call('polyglot', 'members.inviteForm.emailLabel'),
        reserveError: true,
        AppInput: {
            type: 'email',
            name: 'email',
            autocomplete: 'email',
            inputmode: 'email',
            spellcheck: false,
            placeholder: (el)=>el.call('polyglot', 'members.inviteForm.placeholder'),
            value: (el, s)=>s.email || '',
            ariaInvalid: (el, s)=>s.error ? 'true' : null,
            class: {
                hasError: (el, s)=>!!s.error
            },
            // Every keystroke, the empty string included: a cleared field must
            // clear the model too (it used to keep the last non-empty address).
            onInput: (ev, el, s)=>{
                s.update({
                    email: ev.target.value,
                    error: ''
                });
            }
        },
        FieldError: {
            text: (el, s)=>s.error ? el.call('polyglot', s.error) : '',
            visibility: (el, s)=>s.error ? 'visible' : 'hidden'
        }
    },
    // One line where it fits; on a narrow panel (a phone, a long Georgian role
    // name) the buttons wrap under the select instead of the select clipping
    // its label — a control never clips its own label (design call
    // 2026-08-19: "ადმინისტრატორი" is 186px at this size).
    Actions: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        gap: 'Z',
        AppSelect: {
            name: 'role',
            // At least its longest option, growing into the free space; never
            // squeezed below its label.
            flex: '1 0 auto',
            width: 'auto',
            aria: {
                label: (el)=>el.call('polyglot', 'members.inviteForm.roleOfMember')
            },
            value: (el, s)=>{
                const p = el.call('invitePolicy', s);
                return p.inviteRoles.some((r)=>r.value === s.role) ? s.role : p.defaultRole;
            },
            onChange: (ev, el, s)=>{
                s.update({
                    role: ev.target.value
                });
            },
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                // `invitePolicy` hands over polyglot KEYS: a '{{ … | polyglot }}'
                // string a factory returns is data and would render raw.
                text: (el)=>el.call('polyglot', el.labelKey),
                attr: {
                    selected: (el, s)=>{
                        const p = el.call('invitePolicy', s);
                        const current = p.inviteRoles.some((r)=>r.value === s.role) ? s.role : p.defaultRole;
                        return el.value === current ? '' : null;
                    }
                }
            },
            children: (el, s)=>el.call('invitePolicy', s).inviteRoles
        },
        // The link of the invitation just sent. Its box is always there (Rule
        // 66 — nothing moves when it appears); hidden, it is out of the tab
        // order and the accessibility tree.
        CompactIconButton: {
            // Pushes itself and the send button to the row's end — on the select's
            // line, or on their own line when the row wraps.
            marginLeft: 'auto',
            icon: 'copy outline',
            aria: {
                label: (el)=>el.call('polyglot', 'members.inviteDropdown.copyLink'),
                hidden: (el, s)=>s.sentUrl ? null : 'true'
            },
            title: (el)=>el.call('polyglot', 'members.inviteDropdown.copyLink'),
            visibility: (el, s)=>s.sentUrl ? 'visible' : 'hidden',
            tabindex: (el, s)=>s.sentUrl ? null : '-1',
            onClick: (ev, el, s)=>{
                ev.preventDefault();
                if (!s.sentUrl) return;
                el.call('copyStringToClipboard', s.sentUrl);
                s.update({
                    copied: true
                });
            }
        },
        AppCapsuleBtnPrimary: {
            type: 'submit',
            flexShrink: '0',
            disabled: (el, s)=>s.status === 'sending',
            ariaBusy: (el, s)=>s.status === 'sending' ? 'true' : null,
            AppLabelStack: {
                labels: [
                    'members.inviteForm.send',
                    'members.inviteForm.sending'
                ],
                shown: (el, s)=>s.status === 'sending' ? 1 : 0
            }
        }
    },
    Note: {
        tag: 'p',
        role: 'status',
        margin: '0',
        minHeight: 'Z1',
        fontSize: 'Y1',
        color: (el, s)=>s.failure ? 'dangerInk' : 'caption',
        text: (el, s)=>{
            if (s.failure) return s.failure;
            if (s.copied) return el.call('polyglot', 'members.inviteDropdown.linkCopied.title');
            if (!s.sentEmail) return '';
            const key = s.sentNoEmail ? 'members.inviteDropdown.sentNoEmail' : 'members.inviteSent.person';
            return el.call('polyglot', key).replace('{who}', s.sentEmail).replace('{email}', s.sentEmail);
        }
    }
};

});

parcelRegister("6oYAR", function(module, exports) {

$parcel$export(module.exports, "MagicLinkInInvite", () => $4a93fc963b10720a$export$26696031d9f35790);
// "Share by magic link" — the invite panel's second way in, under the email
// form (INVITE-MAGIC-LINK-1). Nika 2026-10-09: "also add share by magic link in
// invite dropdown. sharing magic link should go to them same invite flow as it
// works from email".
//
// A magic link is an ORG invitation bound to no email: the first person who
// opens it and accepts joins at the chosen role, once (the server claims it
// atomically), through the same accept page an emailed invitation lands on.
// Who may make one is exactly who may invite by email: `invitePolicy` here,
// the same route gate and role ceiling on the server. A link grants at most
// `maintainer` (the policy's `linkRoles`; the server answers 400
// `link_role_too_high` above it), and an org keeps at most 25 open links: the
// server answers 409 `too_many_open_links`, and the status line under the
// button says "Revoke an open link first." (the panel keeps no count of its
// own).
//
// THE SHAPE (only when `magicLinkOffered` — functions/inviteRoles.js — says
// so: an org context, a caller who may invite, a link role, and an SDK with
// `createOrgInvitationLink`):
//   CaptionTitle_link  "Share by magic link"
//   LinkActions   role select (AppSelect) · "Copy magic link"
//                 (AppCapsuleBtnToolbar — the secondary role; "Send invite"
//                 stays the panel's ONE primary). One click = ONE link, copied.
//   LinkStatusRow one status line (role="status"): the hint before, the
//                 result after, and a quiet "Revoke" for the link just made in
//                 a reserved box. Hidden sizers hold the hint and the result in
//                 the same grid cell, so the line keeps the height of its
//                 longest message and nothing under it moves (Rule 66).
//   ActiveLinks   the org's open links: role · ends {date} · Revoke.
//
// NO RE-COPY. The signed link is a bearer credential: the server returns it
// once (the create response), never stores it and never lists it. It goes
// straight to the clipboard and is never kept in state or logged. The list
// shows only a role and an end date.
//
// THE DATES ARE THE SERVER'S. "Ends {date}" is a row's `expiresAt`; the day
// count in the hint is the span the server gave the org's newest open
// invitation (expiresAt − createdAt). No client constant: with no open
// invitation yet, the hint says only that the link works once.
//
// FA204 — every helper the handlers read travels on `scope`, and each name
// carries the `magicLink` prefix: `el.scope` is one bag per app (the member
// list keeps its own `load` there).
const $4a93fc963b10720a$export$26696031d9f35790 = {
    scope: {
        magicLinkOrgId (s) {
            const root = s && s.root || {};
            return root.jwtClaims && root.jwtClaims.workspace_org_id || null;
        },
        // The role the select shows: the chosen one while the policy offers it
        // for a link, else the policy default (`member`, which every caller who
        // may make a link may grant).
        magicLinkRole (el, s) {
            const p = el.call('invitePolicy', s);
            const roles = p.linkRoles;
            if (roles.some((r)=>r.value === s.role)) return s.role;
            if (roles.some((r)=>r.value === p.defaultRole)) return p.defaultRole;
            return roles.length ? roles[0].value : null;
        },
        // The translated name of a role.
        magicLinkRoleText (el, s, role) {
            const key = el.call('invitePolicy', s).labelKey(role);
            return key ? el.call('polyglot', key) : role || '';
        },
        // A server timestamp as a short date in the session language.
        magicLinkDate (el, value) {
            return value ? el.call('localizedDate', value, {
                month: 'short',
                day: 'numeric'
            }) : '';
        },
        // The hint line, for the role the select shows.
        magicLinkHint (el, s) {
            const sc = el.lookup('MagicLinkInInvite').scope;
            const role = sc.magicLinkRoleText(el, s, sc.magicLinkRole(el, s));
            const days = Number(s.ttlDays) || 0;
            const key = days === 1 ? 'members.inviteDropdown.magicLink.hintOneDay' : days > 1 ? 'members.inviteDropdown.magicLink.hintDays' : 'members.inviteDropdown.magicLink.hint';
            return el.call('polyglot', key).replace('{role}', role).replace('{days}', String(days));
        },
        // The result line for the link just made — or, before there is one, the
        // same sentence for the role the select shows (it sizes the line).
        magicLinkCreatedText (el, s) {
            const sc = el.lookup('MagicLinkInInvite').scope;
            const role = sc.magicLinkRoleText(el, s, s.createdRole || sc.magicLinkRole(el, s));
            return el.call('polyglot', 'members.inviteDropdown.magicLink.created').replace('{role}', role).replace('{date}', sc.magicLinkDate(el, s.createdEndsAt));
        },
        // Plain copies of the open-link rows (state rows carry methods).
        magicLinkRows (s) {
            return (s.links || []).map((l)=>({
                    key: l.key,
                    inviteId: l.inviteId,
                    role: l.role,
                    endsAt: l.endsAt,
                    busy: false
                }));
        },
        // The org's OPEN links: pending, unexpired, kind 'link'. The list route
        // returns every pending invitation of the org (email ones too) and never
        // a link URL. Its newest row also gives the hint its day count.
        async magicLinkLoad (host, s) {
            const orgId = host.scope.magicLinkOrgId(s);
            if (!orgId) return;
            if (s.linksStatus !== 'loading') s.update({
                linksStatus: 'loading'
            });
            try {
                const rows = await host.sdk.listOrgInvitations(orgId) || [];
                const now = Date.now();
                const dated = rows.find((r)=>r && r.createdAt && r.expiresAt);
                const span = dated ? Date.parse(dated.expiresAt) - Date.parse(dated.createdAt) : 0;
                const links = rows.filter((r)=>r && r.kind === 'link' && r.status === 'pending' && Date.parse(r.expiresAt) > now).map((r)=>{
                    const id = String(r._id || r.id || '');
                    return {
                        // A data key that can never read as an HTML tag name.
                        key: 'magicLink_' + id,
                        inviteId: id,
                        role: r.role || '',
                        endsAt: r.expiresAt,
                        busy: false
                    };
                });
                s.update({
                    links: links,
                    linksStatus: 'ready',
                    ttlDays: span > 0 ? Math.round(span / 86400000) : 0
                });
            } catch (err) {
                console.warn('[MagicLinkInInvite] load failed:', err && err.message ? err.message : err);
                s.update({
                    links: [],
                    linksStatus: 'error'
                });
            }
        },
        // ONE click = ONE link: create it at the select's role and copy it.
        // NOT async on purpose: the clipboard write must START inside the click
        // (copyTextWhenReady), before the first await — Safari ends the user
        // gesture there and would copy nothing.
        magicLinkCreate (host, s) {
            if (s.status === 'creating') return null;
            if (!host.call('magicLinkOffered', s)) return null;
            const role = host.scope.magicLinkRole(host, s);
            const orgId = host.scope.magicLinkOrgId(s);
            const failed = host.call('polyglot', 'members.inviteDropdown.magicLink.failed');
            s.update({
                status: 'creating',
                failure: '',
                createdId: '',
                createdRole: '',
                createdEndsAt: '',
                createdCopied: false,
                revokedCreated: false
            });
            const request = Promise.resolve().then(()=>host.sdk.createOrgInvitationLink(orgId, {
                    role: role
                }));
            const copied = host.call('copyTextWhenReady', request.then((link)=>link && link.inviteUrl || ''));
            return Promise.all([
                request,
                copied
            ]).then(([link, ok])=>{
                const id = String(link && (link._id || link.id) || '');
                if (!id || !link.inviteUrl) throw new Error(failed);
                const endsAt = link.expiresAt || '';
                const span = link.createdAt && link.expiresAt ? Date.parse(link.expiresAt) - Date.parse(link.createdAt) : 0;
                s.update({
                    status: 'idle',
                    createdId: id,
                    createdRole: link.role || role,
                    createdEndsAt: endsAt,
                    createdCopied: ok === true,
                    ttlDays: span > 0 ? Math.round(span / 86400000) : s.ttlDays,
                    linksStatus: 'ready',
                    links: [
                        {
                            key: 'magicLink_' + id,
                            inviteId: id,
                            role: link.role || role,
                            endsAt: endsAt,
                            busy: false
                        },
                        ...host.scope.magicLinkRows(s).filter((l)=>l.inviteId !== id)
                    ]
                });
            }).catch((err)=>{
                console.warn('[MagicLinkInInvite] create failed:', err && err.message ? err.message : err);
                // The org's open-link cap (409): say what to do, in the session
                // language — the server's code, never its English message.
                const code = err && err.cause && err.cause.error;
                s.update({
                    status: 'idle',
                    failure: code === 'too_many_open_links' ? host.call('polyglot', 'members.inviteDropdown.magicLink.tooMany') : host.call('userFacingErrorMessage', err, {
                        networkMessage: host.call('polyglot', 'members.invite.offline'),
                        fallback: (e)=>{
                            const msg = String(e && e.message || '').trim();
                            return msg && msg !== failed ? failed + ': ' + msg : failed;
                        }
                    })
                });
            });
        },
        // Revoke one open link — from its list row (`row` is that row's state)
        // or from the status line (the link just made).
        async magicLinkRevoke (host, s, inviteId, row) {
            if (!inviteId) return;
            const fromLine = !row;
            if (row && row.busy) return;
            if (fromLine && s.revokingCreated) return;
            const orgId = host.scope.magicLinkOrgId(s);
            const isCreated = s.createdId === inviteId;
            const failed = host.call('polyglot', 'members.inviteDropdown.magicLink.revokeFailed');
            if (row) row.update({
                busy: true
            });
            s.update({
                failure: '',
                revokingCreated: fromLine
            });
            try {
                await host.sdk.revokeOrgInvitation(orgId, inviteId);
                const patch = {
                    revokingCreated: false,
                    links: host.scope.magicLinkRows(s).filter((l)=>l.inviteId !== inviteId)
                };
                if (isCreated) Object.assign(patch, {
                    createdId: '',
                    createdRole: '',
                    createdEndsAt: '',
                    revokedCreated: true
                });
                s.update(patch);
            } catch (err) {
                console.warn('[MagicLinkInInvite] revoke failed:', err && err.message ? err.message : err);
                if (row) row.update({
                    busy: false
                });
                s.update({
                    revokingCreated: false,
                    failure: host.call('userFacingErrorMessage', err, {
                        networkMessage: host.call('polyglot', 'members.invite.offline'),
                        fallback: (e)=>{
                            const msg = String(e && e.message || '').trim();
                            return msg ? failed + ': ' + msg : failed;
                        }
                    })
                });
            }
        }
    },
    // The section owns its model (a NON-EMPTY store that declares every key it
    // writes; writes are `update`, never `set`).
    //   role             the select ('' = the policy default)
    //   status           'idle' | 'creating'
    //   failure          a failed create / revoke, user-facing
    //   createdId/Role/EndsAt   the link just made (never its URL)
    //   createdCopied    the clipboard took it (false: say so — never claim a copy)
    //   revokingCreated  the status line's Revoke is busy
    //   revokedCreated   the link just made was revoked
    //   links            the org's open links: { key, inviteId, role, endsAt, busy }
    //   linksStatus      'idle' | 'loading' | 'ready' | 'error'
    //   ttlDays          the server's link lifetime, in days (0 = not known yet)
    state: {
        role: '',
        status: 'idle',
        failure: '',
        createdId: '',
        createdRole: '',
        createdEndsAt: '',
        createdCopied: false,
        revokingCreated: false,
        revokedCreated: false,
        links: [],
        linksStatus: 'idle',
        ttlDays: 0
    },
    flow: 'y',
    gap: 'Z',
    hide: (el, s)=>!el.call('magicLinkOffered', s),
    onInit: (el, s)=>{
        if (el.call('magicLinkOffered', s)) el.scope.magicLinkLoad(el, s);
    },
    CaptionTitle_link: {
        Text: {
            text: (el)=>el.call('polyglot', 'members.inviteDropdown.magicLink.title')
        }
    },
    // One line where it fits; on a narrow panel the button wraps under the
    // select instead of the select clipping its label (same law as the email
    // form's row).
    LinkActions: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        gap: 'Z',
        AppSelect: {
            name: 'magicLinkRole',
            flex: '1 0 auto',
            width: 'auto',
            aria: {
                label: (el)=>el.call('polyglot', 'members.inviteForm.roleOfMember')
            },
            value: (el, s)=>el.lookup('MagicLinkInInvite').scope.magicLinkRole(el, s),
            onChange: (ev, el, s)=>{
                s.update({
                    role: ev.target.value
                });
            },
            childrenAs: 'props',
            childProps: {
                tag: 'option',
                // `invitePolicy` hands over polyglot KEYS.
                text: (el)=>el.call('polyglot', el.labelKey),
                attr: {
                    selected: (el, s)=>el.value === el.lookup('MagicLinkInInvite').scope.magicLinkRole(el, s) ? '' : null
                }
            },
            // Only the roles a link may grant (at most maintainer).
            children: (el, s)=>el.call('invitePolicy', s).linkRoles
        },
        // Secondary, label-stable while busy.
        AppCapsuleBtnToolbar: {
            flexShrink: '0',
            disabled: (el, s)=>s.status === 'creating',
            ariaBusy: (el, s)=>s.status === 'creating' ? 'true' : null,
            AppLabelStack: {
                labels: [
                    'members.inviteDropdown.magicLink.copy',
                    'members.inviteDropdown.magicLink.creating'
                ],
                shown: (el, s)=>s.status === 'creating' ? 1 : 0
            },
            onClick: (ev, el, s)=>{
                ev.preventDefault();
                const host = el.lookup('MagicLinkInInvite');
                if (host) host.scope.magicLinkCreate(host, s);
            }
        }
    },
    LinkStatusRow: {
        flow: 'x',
        align: 'start',
        gap: 'Z',
        LinkStatus: {
            flex: '1',
            minWidth: '0',
            display: 'grid',
            // The ONE live line: the current message.
            LinkStatusText: {
                tag: 'p',
                role: 'status',
                gridArea: '1 / 1',
                margin: '0',
                fontSize: 'Y1',
                color: (el, s)=>s.failure ? 'dangerInk' : 'caption',
                text: (el, s)=>{
                    const sc = el.lookup('MagicLinkInInvite').scope;
                    if (s.failure) return s.failure;
                    if (s.createdId) return s.createdCopied ? sc.magicLinkCreatedText(el, s) : el.call('polyglot', 'members.inviteDropdown.magicLink.notCopied');
                    if (s.revokedCreated) return el.call('polyglot', 'members.inviteDropdown.magicLink.revoked');
                    return sc.magicLinkHint(el, s);
                }
            },
            // Sizers: never seen, never announced — they only hold the line at the
            // height of its longest message.
            LinkHintSizer: {
                tag: 'span',
                gridArea: '1 / 1',
                fontSize: 'Y1',
                visibility: 'hidden',
                aria: {
                    hidden: 'true'
                },
                text: (el, s)=>el.lookup('MagicLinkInInvite').scope.magicLinkHint(el, s)
            },
            LinkResultSizer: {
                tag: 'span',
                gridArea: '1 / 1',
                fontSize: 'Y1',
                visibility: 'hidden',
                aria: {
                    hidden: 'true'
                },
                text: (el, s)=>el.lookup('MagicLinkInInvite').scope.magicLinkCreatedText(el, s)
            }
        },
        // The quiet "Revoke" for the link just made. Its box is always there;
        // hidden, it is out of the tab order and the accessibility tree.
        AppCapsuleBtnGhost: {
            compact: true,
            flexShrink: '0',
            visibility: (el, s)=>s.createdId ? 'visible' : 'hidden',
            tabindex: (el, s)=>s.createdId ? null : '-1',
            aria: {
                hidden: (el, s)=>s.createdId ? null : 'true'
            },
            disabled: (el, s)=>!!s.revokingCreated,
            ariaBusy: (el, s)=>s.revokingCreated ? 'true' : null,
            AppLabelStack: {
                labels: [
                    'members.inviteDropdown.magicLink.revoke',
                    'members.inviteDropdown.magicLink.revoking'
                ],
                shown: (el, s)=>s.revokingCreated ? 1 : 0
            },
            onClick: (ev, el, s)=>{
                ev.preventDefault();
                const host = el.lookup('MagicLinkInInvite');
                if (host && s.createdId) host.scope.magicLinkRevoke(host, s, s.createdId, null);
            }
        }
    },
    ActiveLinks: {
        flow: 'y',
        gap: 'Y',
        hide: (el, s)=>s.linksStatus !== 'error' && !(s.links || []).length,
        CaptionTitle_active: {
            Text: {
                text: (el)=>el.call('polyglot', 'members.inviteDropdown.magicLink.active')
            }
        },
        LinkLoadError: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            hide: (el, s)=>s.linksStatus !== 'error',
            LinkLoadMessage: {
                tag: 'span',
                role: 'alert',
                fontSize: 'Z1',
                color: 'caption',
                text: (el, s)=>s.linksStatus === 'error' ? el.call('polyglot', 'members.inviteDropdown.magicLink.loadFailed') : ''
            },
            AppCapsuleBtnGhost: {
                compact: true,
                text: (el)=>el.call('polyglot', 'members.invite.retry'),
                onClick: (ev, el)=>{
                    ev.preventDefault();
                    const host = el.lookup('MagicLinkInInvite');
                    if (host) host.scope.magicLinkLoad(host, host.state);
                }
            }
        },
        LinkList: {
            tag: 'ul',
            flow: 'y',
            margin: '0',
            padding: '0',
            listStyle: 'none',
            hide: (el, s)=>s.linksStatus === 'error',
            children: (el, s)=>s.links || [],
            childrenAs: 'state',
            childProps: {
                tag: 'li',
                flow: 'x',
                align: 'center',
                gap: 'Z',
                padding: 'Y 0',
                minWidth: '0',
                LinkWhen: {
                    tag: 'span',
                    flex: '1',
                    minWidth: '0',
                    fontSize: 'Z1',
                    color: 'title',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>{
                        const sc = el.lookup('MagicLinkInInvite').scope;
                        return el.call('polyglot', 'members.inviteDropdown.magicLink.row').replace('{role}', sc.magicLinkRoleText(el, s, s.role)).replace('{date}', sc.magicLinkDate(el, s.endsAt));
                    }
                },
                AppCapsuleBtnGhost: {
                    compact: true,
                    flexShrink: '0',
                    disabled: (el, s)=>!!s.busy,
                    ariaBusy: (el, s)=>s.busy ? 'true' : null,
                    aria: {
                        label: (el, s)=>{
                            const sc = el.lookup('MagicLinkInInvite').scope;
                            return el.call('polyglot', 'members.inviteDropdown.magicLink.revokeLabel').replace('{role}', sc.magicLinkRoleText(el, s, s.role)).replace('{date}', sc.magicLinkDate(el, s.endsAt));
                        }
                    },
                    AppLabelStack: {
                        labels: [
                            'members.inviteDropdown.magicLink.revoke',
                            'members.inviteDropdown.magicLink.revoking'
                        ],
                        shown: (el, s)=>s.busy ? 1 : 0
                    },
                    onClick: (ev, el, s)=>{
                        ev.preventDefault();
                        const host = el.lookup('MagicLinkInInvite');
                        if (host) host.scope.magicLinkRevoke(host, host.state, s.inviteId, s);
                    }
                }
            }
        }
    }
};

});

parcelRegister("jPMVK", function(module, exports) {

$parcel$export(module.exports, "SharingPermissions", () => $e708bc4bac64cce9$export$7e5858cf954c329c);
const $e708bc4bac64cce9$export$7e5858cf954c329c = {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
        Text: {
            text: '{{ members.sharing.title | polyglot }}'
        }
    },
    Flex: {
        gap: 'A',
        flow: 'y',
        margin: '- -Z2',
        childExtends: 'DomainItem',
        childProps: {
            align: 'start',
            Icon: null,
            Upgrade: null,
            Hgroup: {},
            Select: {
                padding: 'X Y2',
                margin: '-W -Y2 - auto',
                background: 'none',
                color: 'currentColor',
                width: 'D3+Z2',
                onChange: (ev, el, s, ctx)=>{
                    const value = ev.target.value;
                    if (value) s.update({
                        action: value
                    });
                },
                childrenAs: 'props',
                childProps: {
                    tag: 'option',
                    attr: {
                        selected: (el, s)=>el.node.value === s.action
                    }
                }
            }
        },
        Guests: {
            Hgroup: {
                H: {
                    text: '{{ members.sharing.previewVisibility | polyglot }}'
                },
                P: {
                    text: '{{ members.sharing.previewHint | polyglot }}'
                }
            },
            Select: {
                children: [
                    {
                        text: '{{ members.sharing.public | polyglot }}'
                    },
                    {
                        text: '{{ members.sharing.passwordProtected | polyglot }}'
                    },
                    {
                        text: '{{ members.sharing.private | polyglot }}'
                    }
                ]
            }
        },
        Editors: {
            Hgroup: {
                H: {
                    text: '{{ members.sharing.canvasAccess | polyglot }}'
                },
                P: {
                    text: '{{ members.sharing.canvasHint | polyglot }}'
                }
            },
            Select: {
                children: [
                    {
                        text: '{{ members.sharing.public | polyglot }}'
                    },
                    {
                        text: '{{ members.sharing.unlisted | polyglot }}'
                    },
                    {
                        text: '{{ members.sharing.private | polyglot }}'
                    }
                ]
            }
        }
    }
};

});

parcelRegister("aTuB1", function(module, exports) {

$parcel$export(module.exports, "MembersNavbar", () => $7ee6c635525fd216$export$5ebc161896d8e9c7);
const $7ee6c635525fd216$export$5ebc161896d8e9c7 = {
    flow: 'x',
    align: 'center',
    ActiveCanvasUsers: {},
    Invite: {
        // Outlined-button-on-top-of-a-themed-fill (design-direction.md §8 ban
        // list) — `theme: 'secondary'` below already fills and separates the
        // button; the stroke was redundant chrome.
        extends: [
            'IconButton',
            'DropdownParentFocus'
        ],
        margin: '- - - -Z',
        round: 'radiusPill',
        Icon: {
            fontSize: 'Z'
        },
        padding: 'Y+U',
        title: (el)=>el.call('polyglot', 'members.navbar.invite'),
        icon: 'plus',
        theme: 'secondary',
        Dropdown: {
            left: '-F1',
            onClick: ()=>{},
            InviteDropdown: {}
        }
    }
};

});

parcelRegister("e0CcM", function(module, exports) {

$parcel$export(module.exports, "PublishNavbar", () => $a32eb381e51e4ba2$export$ce0dc92c408ef861);
const $a32eb381e51e4ba2$export$ce0dc92c408ef861 = {
    hide: (el)=>!el.hasProjectPermission('editMode'),
    state: {
        modes: {
            publish: {
                icon: 'sf upload',
                text: '{{ publish.action.publish | polyglot }}',
                callback: async (el)=>{
                    await el.call('openRouterModal', '/publish');
                }
            },
            sync: {
                icon: 'syncOvalFill',
                text: '{{ publish.action.sync | polyglot }}',
                callback: async (el)=>{
                    await el.call('openRouterModal', '/publish');
                }
            },
            export: {
                icon: 'sf download',
                text: '{{ publish.action.export | polyglot }}',
                callback: async (el)=>{
                    await el.call('openRouterModal', '/publish');
                }
            }
        },
        activeOutput: 'publish'
    },
    Button: {
        icon: (el, s)=>s.modes[s.activeOutput].icon,
        text: null,
        title: (el)=>el.call('polyglot', 'publish.action.publish'),
        aspectRatio: 'none',
        onClick: async (ev, el, s)=>{
            await s.modes[s.activeOutput].callback(el);
        }
    },
    IconButton: {
        DropdownParentFocus: {
            position: 'absolute',
            Dropdown: {
                left: '-F',
                onClick: ()=>{},
                'Dropdown.Publish': {}
            },
            inset: '0'
        }
    },
    extends: 'DropdownButton'
};

});

parcelRegister("2PsF8", function(module, exports) {

$parcel$export(module.exports, "MoreInsertMenu", () => $20f693f7f14998c7$export$6ff4b60376c1373a);
// Migrated onto the house menu recipe (DESIGN_LANGUAGE.md §7.7, bespoke-menus
// wave). This is an embedded GROUP — Dropdown.QuickAdd mounts it between its
// own MenuPanel groups — so the shell stays a plain flow block (the panel
// chrome belongs to the embedding menu) and only the rows re-chassis onto
// MenuPanelItem. Deleted with the re-chassis: the `margin: '- -Z2'` list pull
// (it compensated the old hand-rolled `padding: 'A A1'`-era bodies — MenuPanel
// pads Y and MenuPanelItem rows run full-width, so the pull would overflow the
// panel by Z2 − Y and clip; QuickAdd's consumption-site neutralization of
// exactly that pull is deleted in the same wave), the `':hover': { '& svg': …
// }` opacity armor + per-row Icon color/opacity/weight games (they fought the
// retired KeyValueColumnFields/DropdownItem chassis), the hand-rolled row
// chrome (padding/fontSize/round/weight — MenuPanelItem owns the row recipe)
// and the caption's `color: 'propValue'` tint (captions in the embedding panel
// are plain CaptionTitle — one voice per menu).
const $20f693f7f14998c7$export$6ff4b60376c1373a = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        // Align the caption with MenuPanelItem's Z1 label inset (house idiom).
        padding: '- Z1',
        Text: {
            text: '{{ editor.insert.from | polyglot }}'
        }
    },
    Items: {
        flow: 'y',
        gap: '0',
        childExtends: 'MenuPanelItem',
        childProps: {
            Icon: {
                order: '-1',
                margin: '- Y1 - -'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: '{{ editor.import.liveWebsite | polyglot }}',
                    Icon: {
                        name: 'globe'
                    },
                    onClick: (ev, el)=>{
                        el.openModal('/browser-extension');
                    }
                },
                {
                    text: '{{ editor.import.localFiles | polyglot }}',
                    Icon: {
                        name: 'terminal'
                    },
                    onClick: (ev, el)=>{
                        el.openModal('/settings', {
                            key: '/install'
                        });
                    }
                }
            ]
    }
};

});

parcelRegister("8tbjz", function(module, exports) {

$parcel$export(module.exports, "PreviewCanvasNavbar", () => $62a9ceff287cb04d$export$95ef4f367d901261);
const $62a9ceff287cb04d$export$95ef4f367d901261 = {
    extends: 'Navbar',
    gap: 'A2',
    round: 'radiusPill',
    padding: 'V Z',
    userSelect: 'none',
    theme: 'common-box',
    LogoDropdown: {},
    ComponentAddressBar: {
        flex: 1
    },
    Select: {
        padding: 'X Y2',
        margin: '-W -Y2 - auto',
        background: 'none',
        color: 'currentColor',
        width: 'D3',
        onChange: (ev, el, s, ctx)=>{
            const value = ev.target.value;
            if (value) s.update({
                env: value
            });
        },
        childrenAs: 'props',
        childProps: {
            tag: 'option',
            attr: {
                selected: (el, s)=>el.node.value === s.action
            }
        },
        children: [
            {
                text: '{{ publish.envs.production | polyglot }}'
            },
            {
                text: '{{ publish.envs.development | polyglot }}'
            },
            {
                text: '{{ publish.envs.staging | polyglot }}'
            }
        ]
    },
    Meta: {
        extends: 'NavbarButtonSet',
        gap: 'W2',
        InNewTab: {
            icon: 'sf arrow up right',
            title: (el)=>el.call('polyglot', 'members.sharingNavbar.newTab'),
            onClick: (ev, el, s)=>{
                window.open(s.url);
            },
            '!url': {
                opacity: '.35',
                pointerEvents: 'none'
            }
        },
        Share: {
            title: (el)=>el.call('polyglot', 'common.action.share'),
            icon: 'sf share',
            onClick: (ev, el, s)=>{},
            Dropdown: {
                left: 'auto',
                right: '-A',
                ShareDropdown: {}
            },
            '!url': {
                opacity: '.35',
                pointerEvents: 'none'
            },
            extends: [
                'CanvasButton',
                'IconButton',
                'DropdownParentFocus'
            ]
        },
        Close: {
            title: (el)=>el.call('polyglot', 'common.action.close'),
            icon: 'crossmark',
            onClick: (ev, el, s)=>el.closeModal()
        }
    }
};

});

parcelRegister("hxjuK", function(module, exports) {

$parcel$export(module.exports, "ComponentAddressBar", () => $cc44a409f449d03e$export$a39e9b059c0203e0);
const $cc44a409f449d03e$export$a39e9b059c0203e0 = {
    extends: [
        'DropdownParentFocus'
    ],
    tag: 'search',
    position: 'relative',
    theme: 'quinary',
    round: 'radiusPill',
    minWidth: 'D3',
    margin: '-V - - -',
    Form: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        margin: '0',
        attr: {
            novalidate: true
        },
        onSubmit: (ev, el, s)=>{
            ev.preventDefault();
        },
        Icon: {
            fontSize: 'Z1',
            margin: '- -B2 - A',
            name: 'search'
        },
        Input: {
            autofocus: 'autofocus',
            flex: 1,
            round: '0',
            placeholder: (el)=>el.call('polyglot', 'editor.addressBar.searchPlaceholder'),
            padding: 'Y1 B2 Y1 B2',
            theme: 'transparent',
            // A typed value takes the brand value ink; the transparent theme's own
            // ink is a 65% alpha, one tone with the placeholder hint in light.
            color: 'title',
            outline: 'none',
            name: 'url',
            required: true,
            type: 'text',
            appearance: 'none',
            ':focus-visible': {
                outline: 'none'
            },
            '::-webkit-search-cancel-button': {
                display: 'none'
            },
            '::placeholder': {
                color: 'placeholder'
            },
            onInput: (ev, el, s)=>{
                s.update({
                    searchTerm: el.node.value
                });
            }
        }
    },
    CanvasSearchDropdown: {
        Items: {
            childProps: {
                Flex_Buttons: null,
                onClick: (ev, el, s)=>{
                    const key = s.key;
                    const type = s.type;
                    s.parent.update({
                        type: type,
                        key: key
                    });
                }
            }
        },
        // Wrapper first, menu body LAST — the §7.7 MenuPanel surface must win the
        // merge over the brand Dropdown's legacy common-box chrome. (The list slot
        // re-keyed ListInDropdown → Items with the §7.7 re-chassis.)
        extends: [
            'Dropdown',
            'CanvasSearchDropdown'
        ],
        width: '100%',
        left: '0',
        typesToIndex: [
            'components',
            'pages'
        ]
    }
};

});

parcelRegister("hb5Di", function(module, exports) {

$parcel$export(module.exports, "DynamicNavbar", () => $c817d54d61d4c7a2$export$938ef846a8a29382);
const $c817d54d61d4c7a2$export$938ef846a8a29382 = {
    extends: 'Navbar',
    position: 'sticky',
    top: '0',
    fontSize: 'Y2',
    margin: '- -Y1',
    padding: 'X2 0 0',
    theme: null,
    NavbarButtonSet: {
        width: '100%',
        childProps: {
            padding: 'Y'
        },
        Back: {
            icon: 'arrow angle left',
            ariaLabel: (el)=>el.call('polyglot', 'common.action.back'),
            hasBack: (el, s)=>{
                return s.recentsIndex < s.recents.length - 1;
            },
            '!hasBack': {
                opacity: '0.35',
                pointerEvents: 'none'
            },
            onClick: (ev, el, s)=>{
                const recents = s.recents;
                s.recentsIndex++;
                const prev = recents?.[s.recentsIndex];
                if (prev) el.setWindow('explorer', prev, {
                    skipRecentsIndexing: true
                });
            }
        },
        Forward: {
            icon: 'arrow angle right',
            ariaLabel: (el)=>el.call('polyglot', 'common.action.forward'),
            hasForward: (el, s)=>{
                return s.recentsIndex > 0;
            },
            '!hasForward': {
                opacity: '0.35',
                pointerEvents: 'none'
            },
            onClick: (ev, el, s)=>{
                const recents = s.recents;
                s.recentsIndex--;
                const next = recents?.[s.recentsIndex];
                if (next) el.setWindow('explorer', next, {
                    skipRecentsIndexing: true
                });
            }
        },
        Close: {
            margin: '- - - auto',
            icon: 'crossmark',
            ariaLabel: (el)=>el.call('polyglot', 'common.action.close'),
            onClick: (ev, el)=>el.closeWindow('explorer')
        }
    }
};

});

parcelRegister("lckKv", function(module, exports) {

$parcel$export(module.exports, "TextNavbarButton", () => $f6ead049ae039cf3$export$741fb40eab8e7c74);
const $f6ead049ae039cf3$export$741fb40eab8e7c74 = {
    padding: 'Y1 Z2',
    fontWeight: '400',
    lineHeight: 0.9,
    isActive: (el)=>{
        const explorer = el.getWindow('explorer');
        return explorer?.startsWith?.(el.parent.key || el.key);
    },
    onClick: (ev, el)=>{
        const active = el.parent.key || el.key;
        const explorer = el.getWindow('explorer');
        const isSelected = active === explorer;
        const hasSelected = explorer?.startsWith?.(active);
        const val = isSelected ? null : active;
        el.setWindow('explorer', val);
    },
    text: '{{ shell.app.files | polyglot }}',
    key: 'explorer',
    extends: [
        'CanvasButton',
        'Button'
    ]
};

});

parcelRegister("iWna3", function(module, exports) {

$parcel$export(module.exports, "MicroNavbar", () => $dc9f9c1cc79a0891$export$bbced15ff3692903);
const $dc9f9c1cc79a0891$export$bbced15ff3692903 = {
    fontSize: 'Y1',
    background: 'none',
    backdropFilter: 'none'
};

});

parcelRegister("fiE2A", function(module, exports) {

$parcel$export(module.exports, "TextNavbarButtonDropdown", () => $b23798b73380427c$export$d6cfbf32f5d6e745);
// Split trigger chip (label button + arrow button) for the TextNavbar menus —
// the menu BODIES it opens (Dropdown.QuickAdd / .AssistantMenu /
// .MoreFilesMenu / .MoreLearnMenu) are already on the MenuPanel chassis; this
// file owns only the trigger chrome. Bespoke-menus wave (§7.7/§4.3): the
// active chip's raw gray5/gray11 + white/black pairs move onto the house
// `selected` wash + `title` ink, and the inner Dropdown's `theme:
// 'common-box'` re-assert is dropped (it restated the brand Dropdown default).
const $b23798b73380427c$export$d6cfbf32f5d6e745 = {
    extends: 'DropdownButton',
    key: 'insert',
    isActive: (el)=>{
        const explorer = el.getWindow('explorer');
        return explorer?.startsWith?.(el.key);
    },
    // `@dark`/`@light` inside a case block compile to `[data-theme="…"] &` rules
    // carrying `!important` (framework contract) — the only delivery strong
    // enough to beat the CanvasButton base chrome, so the active chip paints in
    // both themes. The VALUES are the §4.3 washes: `selected`/`title` are
    // adaptive pairs, so both scheme blocks carry the same tokens — the blocks
    // exist purely for the !important transform.
    //
    // A nested `':hover'` used to sit here with `@dark`/`@light` children. It was
    // unreachable twice over: the `[data-theme]` transform only applies at the
    // FIRST nesting level, so those children compiled to the non-matching
    // selectors `._cls:hover @dark` / `._cls:hover @light`; and even in the
    // canonical `'@dark': { ':hover': {} }` order the base rule's `!important`
    // beats a plain hover rule. Dropped rather than left emitting invalid CSS.
    '.isActive': {
        '@dark': {
            color: 'title',
            backgroundColor: 'selected'
        },
        '@light': {
            color: 'title',
            backgroundColor: 'selected'
        }
    },
    Button: {
        extends: 'TextNavbarButton',
        text: '{{ editor.insert.title | polyglot }}',
        icon: null,
        isActive: null,
        padding: 'Y2 Y1 Y2 Z2'
    },
    IconButton: {
        padding: 'Z Y2 Z Y',
        DropdownParentFocus: {
            inset: '0',
            position: 'absolute',
            Dropdown: {
                left: '-D2',
                onClick: ()=>{}
            }
        }
    }
};

});

parcelRegister("30LIk", function(module, exports) {

$parcel$export(module.exports, "PreviewModesMenu", () => $23166232a3cf453c$export$79df570625663578);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7,
// bespoke-menus wave): MenuPanel shell + MenuPanelItem rows. Deleted with the
// re-chassis: the hand-rolled `theme: 'navbar'` + `padding: 'Y1 Z2'` shell
// chrome (MenuPanel owns the dialog surface + Y padding — the navbar glass was
// the pre-§7.7 recipe), the `margin: '- -Z2'` list pull (it compensated that
// padding; under the MenuPanel Y body it would overflow by Z2 − Y and clip
// against the Dropdown wrapper's overflow), the `':hover': { '& svg': … }`
// opacity armor + per-row Icon color/opacity/weight games (they fought the
// retired KeyValueColumnFields/DropdownItem chassis) and the hand-rolled row
// chrome (MenuPanelItem owns the row recipe).
const $23166232a3cf453c$export$79df570625663578 = {
    extends: 'MenuPanel',
    gap: 'A',
    Items: {
        flow: 'y',
        gap: '0',
        childExtends: 'MenuPanelItem',
        childProps: {
            Icon: {
                order: '-1',
                margin: '- Y1 - -'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: '{{ editor.previewModes.newTab | polyglot }}',
                    Icon: {
                        name: 'arrow up right'
                    },
                    onClick: 'openInNewTab'
                },
                {
                    text: '{{ editor.previewModes.localRender | polyglot }}',
                    Icon: {
                        name: 'playOvalDotted'
                    },
                    onClick: (ev, el, s)=>{
                        el.openModal('/browser-preview');
                    }
                },
                {
                    text: '{{ editor.previewModes.remotePreview | polyglot }}',
                    Icon: {
                        name: 'network'
                    },
                    onClick: (ev, el, s)=>{
                        el.openModal('/browser-preview');
                    }
                }
            ]
    }
};

});

parcelRegister("kMzF2", function(module, exports) {

$parcel$export(module.exports, "TutorialGifsNotificationStack", () => $f213f3d588fa228c$export$c0a4ae70da3eb869);
const $f213f3d588fa228c$export$c0a4ae70da3eb869 = {
    flow: 'y',
    childExtends: 'TutorialGifNotification',
    position: 'relative',
    gap: 'X',
    width: 'H2',
    childrenAs: 'state',
    children: [
        {
            key: 'explainCanvas',
            title: 'learn.coach.zoom.title',
            descr: 'learn.coach.canvas.descr',
            src: 'intro.gif',
            docsArticle: '/canvas-and-editor'
        },
        {
            key: 'explainRealtime',
            title: 'learn.coach.realtime.title',
            descr: 'learn.coach.realtime.descr',
            src: 'realtime.gif',
            docsArticle: '/publish'
        },
        {
            key: 'explainEditingAndNav',
            title: 'learn.coach.edit.title',
            descr: 'learn.coach.edit.descr',
            icon: 'double-click.json',
            src: 'editor.gif',
            docsArticle: '/building-in-symbols',
            callback: (el, s)=>{
                el.setWindow('explorer', 'onboarding');
            }
        }
    ],
    childProps: {
        ':nth-child(3)': {
            pointerEvents: 'none',
            zIndex: 1,
            opacity: 0.7,
            position: 'absolute',
            transform: 'translate3d(0, -1.2em, 0) scale(0.9)'
        },
        ':nth-child(2)': {
            pointerEvents: 'none',
            zIndex: 2,
            opacity: 0.9,
            position: 'absolute',
            transform: 'translate3d(0, -0.7em, 0) scale(0.95)'
        },
        ':nth-child(1)': {
            position: 'relative',
            zIndex: 3
        }
    }
};

});

parcelRegister("fC6iK", function(module, exports) {

$parcel$export(module.exports, "TutorialGifNotification", () => $b5df4af88ee6b8e4$export$c570c7295be03d26);
const $b5df4af88ee6b8e4$export$c570c7295be03d26 = {
    extends: 'Navbar',
    theme: 'canvas-card-glass',
    padding: '0',
    overflow: 'hidden',
    align: 'stretch',
    transition: 'all, defaultBezier, B2',
    round: 'radiusControl',
    gap: 'A',
    flow: 'y',
    width: '100%',
    maxWidth: 'H2',
    rootSlide: true,
    useCookie: true,
    if: (el, s)=>{
        const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true';
        return el.useCookie ? !preventByCookie : true;
    },
    state: {
        title: 'learn.coach.zoom.title',
        descr: 'learn.coach.canvas.descr',
        src: 'intro.gif'
    },
    Img: {
        minWidth: '3.2em',
        src: '{{ src }}',
        fontSize: 'C2'
    },
    Hgroup: {
        flex: 1,
        margin: 'auto',
        padding: 'Z B A',
        gap: 'Y1',
        lineHeight: 1.4,
        width: '100%',
        H: {
            tag: 'strong',
            text: (el, s)=>el.call('polyglot', s.title || '')
        },
        P: {
            text: (el, s)=>el.call('polyglot', s.descr || '')
        }
    },
    TutorialNotificationButtons: {}
};

});

parcelRegister("bBBHp", function(module, exports) {

$parcel$export(module.exports, "DragParagraph", () => $873064aa6af62380$export$ce3c911421d2fb76);
const $873064aa6af62380$export$ce3c911421d2fb76 = {
    align: 'center',
    textAlign: 'center',
    margin: '- auto',
    color: 'placeholder',
    maxWidth: 'F1',
    flow: 'y',
    Lottie: {
        src: 'swipe-right.json',
        fontSize: 'B1',
        margin: '- - -X2'
    },
    Text: {
        text: '{{ editor.insert.dragHint | polyglot }}'
    }
};

});

parcelRegister("ij1Fw", function(module, exports) {

$parcel$export(module.exports, "DragComponentsTutorial", () => $d53b4bb2be1bf1d4$export$67274c180e682c4);
const $d53b4bb2be1bf1d4$export$67274c180e682c4 = {
    scope: {
        __scope: {
            pages: {
                '/': {
                    align: 'center',
                    boxSize: '100%',
                    width: 'G+F',
                    Window: {
                        margin: 'auto',
                        round: 'radiusControl',
                        border: 'hairline solid gray',
                        HelloWorld: {},
                        Hr: {
                            borderColor: 'gray',
                            margin: '0'
                        },
                        ConfirmButtons: {}
                    }
                }
            },
            components: {
                ConfirmButtons: {
                    flow: 'x',
                    align: 'stretch space-around',
                    childProps: {
                        flex: 1,
                        textAlign: 'center',
                        padding: 'Z2',
                        ':hover': {
                            background: 'gray.35'
                        }
                    },
                    Link: {
                        extends: [
                            'Link',
                            'IconText'
                        ],
                        text: 'About me',
                        theme: 'transparent',
                        gap: 'X2',
                        icon: 'check',
                        Icon: {
                            color: 'green'
                        }
                    },
                    Link_contact: {
                        text: 'Contact',
                        href: '#contact'
                    }
                },
                HelloWorld: {
                    padding: 'B',
                    Flex: {
                        gap: 'A',
                        H4: {
                            text: "\uD83C\uDF00",
                            order: '-1'
                        },
                        Hgroup: {
                            H: {
                                text: 'Hello World'
                            },
                            P: {
                                text: 'This is example paragraph page that shows you how cool is Symbols'
                            }
                        }
                    }
                }
            }
        }
    },
    flow: 'y',
    childProps: {
        margin: '- - B',
        P: {
            margin: '0 0 X2'
        },
        ComponentThumbnailIframe: {
            margin: '- -Y1',
            height: 'F1',
            background: 'shadow',
            round: 'radiusCard'
        }
    },
    children: [
        {
            P: {
                text: '{{ learn.drag.step1 | polyglot }}'
            },
            ComponentThumbnailIframe: {
                state: {
                    key: 'HelloWorld',
                    title: 'Hello World',
                    type: 'components',
                    settings: {
                        gridOptions: {}
                    },
                    code: `export default {
  padding: 'B',

  Flex: {
  gap: 'A',

  H4: {
    text: '\u{1F300}',
    order: -1
  },
  Hgroup: {
    H: {
      text: 'Hello World',
    },
    P: {
      text: 'This is example paragraph page that shows you how cool is Symbols',
    },
  }
  }
}`,
                    uses: [
                        'Flex',
                        'H4',
                        'Hgroup',
                        'H',
                        'P'
                    ],
                    error: null,
                    value: {
                        padding: 'B',
                        Flex: {
                            gap: 'A',
                            H4: {
                                text: "\uD83C\uDF00",
                                order: '-1'
                            },
                            Hgroup: {
                                H: {
                                    text: 'Hello World'
                                },
                                P: {
                                    text: 'This is example paragraph page that shows you how cool is Symbols'
                                }
                            }
                        }
                    }
                }
            }
        },
        {
            P: {
                text: '{{ learn.drag.step2 | polyglot }}'
            },
            ComponentThumbnailIframe: {
                state: {
                    key: 'ConfirmButtons',
                    title: 'Confirm Buttons',
                    type: 'components',
                    settings: {
                        gridOptions: {}
                    },
                    code: `export default {
  flow: 'x',
  align: 'stretch space-around',

  childProps: {
  flex: 1,
  textAlign: 'center',
  padding: 'Z2',
  ':hover': {
    background: 'gray.35',
  }
  },

  Link: {
  extends: ['Link', 'IconText'],
  text: 'About me',
  theme: 'transparent',
  gap: 'X2',
  icon: 'check',
  Icon: {
    color: 'green'
  }
  },

  Link_contact: {
  text: 'Contact',
  href: '#contact'
  },
}`,
                    uses: [
                        'Flex',
                        'Link',
                        'IconText',
                        'Icon'
                    ],
                    value: {
                        flow: 'x',
                        align: 'stretch space-around',
                        childProps: {
                            flex: 1,
                            textAlign: 'center',
                            padding: 'Z2',
                            ':hover': {
                                background: 'gray.35'
                            }
                        },
                        Link: {
                            extends: [
                                'Link',
                                'IconText'
                            ],
                            text: 'About me',
                            theme: 'transparent',
                            gap: 'X2',
                            icon: 'check',
                            Icon: {
                                color: 'green'
                            }
                        },
                        Link_contact: {
                            text: 'Contact',
                            href: '#contact'
                        }
                    }
                }
            }
        },
        {
            P: {
                text: '{{ learn.drag.step3 | polyglot }}'
            },
            ComponentThumbnailIframe: {
                state: {
                    key: '/',
                    type: 'pages',
                    settings: {
                        gridOptions: {}
                    },
                    code: `export default {
  flow: 'x',
  align: 'center',
  boxSize: '100%',
  width: 'G+F',

  Window: {
  margin: 'auto',
  round: 'radiusControl',
  border: 'hairline solid gray',

  HelloWorld: {},

  Hr: {
    borderColor: 'gray',
    margin: '0'
  },

  ConfirmButtons: {}
  }
}`,
                    uses: [
                        'Flex',
                        'Window',
                        'HelloWorld',
                        'Hr',
                        'ConfirmButtons'
                    ],
                    value: {
                        flow: 'x',
                        align: 'center',
                        boxSize: '100%',
                        width: 'G+F',
                        Window: {
                            margin: 'auto',
                            round: 'radiusControl',
                            border: 'hairline solid gray',
                            HelloWorld: {},
                            Hr: {
                                borderColor: 'gray',
                                margin: '0'
                            },
                            ConfirmButtons: {}
                        }
                    }
                }
            }
        }
    ]
};

});

parcelRegister("bKKAQ", function(module, exports) {

$parcel$export(module.exports, "resolveCanvasV2CodeTarget", () => resolveCanvasV2CodeTarget);
$parcel$export(module.exports, "isCanvasV2EditorContext", () => isCanvasV2EditorContext);
$parcel$export(module.exports, "getCanvasV2CodeEditor", () => getCanvasV2CodeEditor);
$parcel$export(module.exports, "openCanvasV2CodeEditor", () => openCanvasV2CodeEditor);
$parcel$export(module.exports, "EditInNavbarMenu", () => EditInNavbarMenu);
// EditInNavbarMenu — "Edit in…" menu (Open in Editor / Edit in Code / Open in
// Sidebar) from the selected-component navbar. Migrated 2026-06-09 (task #2)
// from the legacy DropdownParentFocus (which stayed visible when inactive) to
// @symbo.ls/dropdown: EditorTools' IconButton opens this body via
// el.call('openDropdown', { content: { extends: 'EditInNavbarMenu' } }); the
// plugin owns placement + outside-click/ESC dismiss, which fixes the
// visible-when-inactive bug. Each row dismisses via closeDropdown.
//
// Portal note: the item handlers call canvas-element methods (setCanvasScope /
// getWindow / setWindow). getCanvas() resolves via getRootData('Canvas') first
// (global), so those work even though @symbo.ls/dropdown renders this body in a
// workspace-level portal outside the canvas subtree.
//
// The four functions below stay exported at module scope for
// EditInNavbarMenu.test.js's offline Node coverage (it imports and calls
// them directly with a mock `el`) — they're ALSO duplicated into
// EditInNavbarMenu's own `scope` below for use inside its serialized
// factories (el.scope only resolves within that component's own tree, and a
// bare module-scope reference reads as undefined once frank.toJSON's the
// component for platform delivery — workspace d6ea1142,
// project_frank_drops_module_local_helpers). `MENU_ID` has no external
// consumer, so it moves into `scope` outright rather than staying duplicated.
const resolveCanvasV2CodeTarget = (el)=>{
    const canvasElement = el.call('getCanvas');
    const canvasRoot = canvasElement?.state?.root;
    const project = canvasRoot?.data || el.getRootState('data');
    const canvas = canvasRoot?.canvas || el.call('getCanvasV2');
    const selected = el.call('getSelected');
    const selectedState = selected?.state?.parse?.() || {};
    const key = canvas?.selection?.primary || el.call('getSelectedKey') || selectedState.key;
    const selectedType = selectedState.type || selectedState._cvType;
    const type = selectedType && project?.[selectedType]?.[key] ? selectedType : Object.hasOwn(project?.components || {}, key) ? 'components' : Object.hasOwn(project?.pages || {}, key) ? 'pages' : null;
    return {
        key: key,
        type: type,
        value: type ? project?.[type]?.[key] : null,
        selectedState: selectedState
    };
};
const isCanvasV2EditorContext = (el)=>{
    const canvasElement = el.call('getCanvas');
    const canvas = canvasElement?.state?.root?.canvas || el.call('getCanvasV2');
    return Boolean(canvas?.selection && Array.isArray(canvas.selection.ids));
};
const getCanvasV2CodeEditor = (el)=>{
    const canvasElement = el.call('getCanvas');
    return canvasElement?.parent?.CanvasEditor?.CanvasV2CodeEditor || el.getRoot()?.lookdown?.('CanvasV2CodeEditor') || null;
};
const openCanvasV2CodeEditor = (el)=>{
    const { type, key, value, selectedState } = resolveCanvasV2CodeTarget(el);
    const codeEditor = getCanvasV2CodeEditor(el);
    if (!type || !key || value == null || !codeEditor) return false;
    // Do not use setCanvasScope() here. It calls the legacy syncCanvas() path,
    // which activates the full-screen Chosen scene and leaves v2 interactions
    // blocked after the panel closes.
    const scope = el.getCanvasScope();
    if (scope) {
        scope.editorActive = false;
        scope.preferredEditor = 'code';
    }
    codeEditor.data.itemType = type;
    codeEditor.data.itemKey = key;
    codeEditor.setNodeStyles({
        display: 'flex'
    });
    codeEditor.state.set({
        ...selectedState,
        type: type,
        key: key,
        code: null,
        value: el.call('deepClone', value)
    }, {
        forceMonacoUpdate: true
    });
    return true;
};
const EditInNavbarMenu = {
    // FA204 / frank trap — see the header comment above the module-scope
    // exports for the full rationale. openCanvasV2CodeEditor calls its
    // siblings via `this.<name>` (object-literal properties can't see each
    // other as bare identifiers — only `el.scope.<name>()` binds `this` to
    // the scope bag).
    scope: {
        MENU_ID: 'editInNavbar',
        resolveCanvasV2CodeTarget (el) {
            const canvasElement = el.call('getCanvas');
            const canvasRoot = canvasElement?.state?.root;
            const project = canvasRoot?.data || el.getRootState('data');
            const canvas = canvasRoot?.canvas || el.call('getCanvasV2');
            const selected = el.call('getSelected');
            const selectedState = selected?.state?.parse?.() || {};
            const key = canvas?.selection?.primary || el.call('getSelectedKey') || selectedState.key;
            const selectedType = selectedState.type || selectedState._cvType;
            const type = selectedType && project?.[selectedType]?.[key] ? selectedType : Object.hasOwn(project?.components || {}, key) ? 'components' : Object.hasOwn(project?.pages || {}, key) ? 'pages' : null;
            return {
                key: key,
                type: type,
                value: type ? project?.[type]?.[key] : null,
                selectedState: selectedState
            };
        },
        isCanvasV2EditorContext (el) {
            const canvasElement = el.call('getCanvas');
            const canvas = canvasElement?.state?.root?.canvas || el.call('getCanvasV2');
            return Boolean(canvas?.selection && Array.isArray(canvas.selection.ids));
        },
        getCanvasV2CodeEditor (el) {
            const canvasElement = el.call('getCanvas');
            return canvasElement?.parent?.CanvasEditor?.CanvasV2CodeEditor || el.getRoot()?.lookdown?.('CanvasV2CodeEditor') || null;
        },
        openCanvasV2CodeEditor (el) {
            const { type, key, value, selectedState } = this.resolveCanvasV2CodeTarget(el);
            const codeEditor = this.getCanvasV2CodeEditor(el);
            if (!type || !key || value == null || !codeEditor) return false;
            // Do not use setCanvasScope() here. It calls the legacy syncCanvas()
            // path, which activates the full-screen Chosen scene and leaves v2
            // interactions blocked after the panel closes.
            const scope = el.getCanvasScope();
            if (scope) {
                scope.editorActive = false;
                scope.preferredEditor = 'code';
            }
            codeEditor.data.itemType = type;
            codeEditor.data.itemKey = key;
            codeEditor.setNodeStyles({
                display: 'flex'
            });
            codeEditor.state.set({
                ...selectedState,
                type: type,
                key: key,
                code: null,
                value: el.call('deepClone', value)
            }, {
                forceMonacoUpdate: true
            });
            return true;
        }
    },
    // Body-only menu for the shared DropdownRoot — no position / outside-click
    // here; the plugin owns placement + dismiss. Keeps its own navbar glass card.
    minWidth: '210px',
    flow: 'y',
    gap: '0',
    padding: 'Y Z1',
    round: 'radiusControl',
    theme: 'navbar',
    role: 'menu',
    ariaLabel: (el)=>el.call('polyglot', 'editor.editIn.label'),
    shadow: 'overlay',
    ListInDropdown: {
        margin: '- -Z2',
        gap: '0',
        childProps: {
            ':hover': {
                '& svg': {
                    opacity: 1
                },
                // House dropdown hover wash — the brand DropdownItem's own hover is the
                // near-invisible gray6.05, so override it with the `hover` token to
                // match every other menu (DESIGN_LANGUAGE.md §4.3).
                background: 'hover'
            },
            padding: 'Z Z2',
            fontSize: 'A',
            fontWeight: '400',
            round: 'radiusControl',
            Text: null,
            color: 'title',
            Icon: {
                color: 'currentColor',
                opacity: '1',
                order: '-1',
                margin: '- Y1 - -',
                fontWeight: '100'
            }
        },
        childrenAs: 'props',
        // On a v2 board only the rows whose actions actually EXIST there are
        // offered. "Open in Editor" activates the legacy full-screen Chosen scene
        // (setCanvasScope editorActive — the very flow the openCanvasV2CodeEditor
        // comment above warns leaves v2 interactions blocked) and "Open in
        // Sidebar" opens the v1 file-explorer window that v2 chrome never mounts
        // — both dead-or-harmful clicks on v2 (2026-08-08 per Nika "icons
        // clicking and functionality"). v1 surfaces keep all three rows.
        children: (el)=>{
            const v2 = el.scope.isCanvasV2EditorContext(el);
            const rows = [
                {
                    v1Only: true,
                    text: '{{ editor.editIn.openEditor | polyglot }}',
                    Icon: {
                        name: 'playOvalDotted'
                    },
                    onClick: (ev, el, s)=>{
                        el.call('closeDropdown', el.scope.MENU_ID);
                        el.setCanvasScope({
                            editorActive: true,
                            preferredEditor: 'editor'
                        });
                        el.call('openEditor');
                    }
                },
                {
                    text: '{{ editor.editIn.editCode | polyglot }}',
                    Icon: {
                        name: 'code'
                    },
                    onClick: (ev, el, s)=>{
                        el.call('closeDropdown', el.scope.MENU_ID);
                        // Canvas v2 is the default. A portal-local isCanvasV2() lookup can
                        // be false even while this toolbar belongs to a v2 artboard, so only
                        // enter the legacy Chosen flow when legacy mode was explicitly set.
                        if (el.getCanvasScope()?.canvasV2 !== false) {
                            el.scope.openCanvasV2CodeEditor(el);
                            return;
                        }
                        if (el.getWindow('componentEditor') === 'code') el.closeWindow('componentEditor');
                        else el.setWindow('componentEditor', 'code');
                        el.setCanvasScope({
                            preferredEditor: 'code'
                        });
                    }
                },
                {
                    v1Only: true,
                    text: '{{ editor.editIn.openSidebar | polyglot }}',
                    Icon: {
                        name: 'sidebarLeftFill'
                    },
                    onClick: async (ev, el, s)=>{
                        el.call('closeDropdown', el.scope.MENU_ID);
                        if (el.getWindow('explorer') !== 'explorer') await el.setWindow('explorer', 'explorer');
                        setTimeout(()=>{
                            const itemFound = el.call('findFileSidebarItem', s.type, s.key);
                            itemFound?.state?.update({
                                showLayers: true
                            });
                        }, 350);
                        el.setCanvasScope({
                            preferredEditor: 'sidebar'
                        });
                    }
                }
            ];
            return (v2 ? rows.filter((r)=>!r.v1Only) : rows).map(({ v1Only, ...row })=>row);
        }
    }
};

});

parcelRegister("f6Vk1", function(module, exports) {

$parcel$export(module.exports, "IntegrationsPanel", () => $b003e17cc5522f76$export$9ce8cb617ed70d0f);
const $b003e17cc5522f76$export$9ce8cb617ed70d0f = {
    flow: 'y',
    fontSize: 'Z2',
    padding: 'A+Z Z2',
    gap: 'C',
    overflow: 'hidden auto',
    ImportInInsert: {},
    Line_3: {
        margin: '- -A'
    },
    DataSourcesInInsert: {},
    Line_4: {
        margin: '- -A'
    },
    IntegrationsInInsert: {}
};

});

parcelRegister("55PRG", function(module, exports) {

$parcel$export(module.exports, "ProjectCodeSidebar", () => $3b55a6a754cdfc1d$export$c8a86ba5661b8e21);
const $3b55a6a754cdfc1d$export$c8a86ba5661b8e21 = {
    extends: 'DocsSidebar',
    childExtends: {
        state: {
            show: true
        }
    },
    position: 'relative',
    top: '0',
    gap: 'B2',
    childProps: {
        NumbCaption: {
            position: 'sticky',
            top: '0',
            theme: 'common-box',
            padding: 'W -',
            href: null,
            Numb: null,
            CaptionTitle: {
                ':hover': {
                    textDecoration: 'underline'
                },
                Text: {
                    text: (el, s)=>el.call('polyglot', s.title || '')
                },
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    el.lookup('Overflow').state.update({
                        type: s.key,
                        key: null
                    }, {
                        forceMonacoUpdate: true
                    });
                }
            },
            Text: null,
            SquareButton: {
                extends: [
                    'CanvasButton',
                    'SquareButton'
                ],
                margin: '-Y1 -',
                padding: 'X',
                round: 'X',
                icon: (el, s)=>s.show ? 'arrow angle up' : 'arrow angle down',
                ariaLabel: (el, s)=>el.call('polyglot', s.show ? 'editor.sidebar.collapseSection' : 'editor.sidebar.expandSection'),
                hide: (el, s)=>!s.sub_links?.length,
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    s.toggle('show');
                }
            }
        },
        NavLinks: {
            margin: 'Z - -',
            // Indent-guide border removed (border-habit sweep, design-direction.md
            // §8) — the existing left padding already reads as the nesting cue;
            // this isn't a dense-data-table hairline (§2.5's one surviving-stroke
            // exception for row/column rules).
            padding: '- - - Z2',
            hide: (el, s)=>!s.show || !s.sub_links?.length,
            childProps: {
                NumbCaption: {
                    Numb: null,
                    href: null,
                    ':hover': {
                        color: 'title'
                    },
                    // Reads the selection from the SAME place onClick below writes it —
                    // the `Overflow` ancestor's state `{ type, key }`. The previous form
                    // passed a 2-arg `(el, s)` predicate to `el.lookup`, which invokes it
                    // with ONE argument (element/src/methods.js), so `s` was undefined and
                    // `s.selectedKey` threw on the first ancestor; `selectedKey` was also
                    // written nowhere in the repo, so it could never have matched anyway.
                    isActive: (el, s)=>{
                        const selection = el.lookup('Overflow')?.state;
                        if (!selection) return false;
                        return s.parent.key === selection.type && s.key === selection.key;
                    },
                    onClick: (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                        el.lookup('Overflow').state.update({
                            type: s.parent.key,
                            key: s.key
                        }, {
                            forceMonacoUpdate: true
                        });
                    }
                }
            }
        }
    },
    children: (el)=>{
        const arrayize = (obj = {})=>Object.keys(obj).map((key)=>({
                    title: key,
                    key: key
                }));
        const rootData = [
            {
                title: '~',
                sub_links: [
                    {
                        title: 'index.html',
                        key: 'index.html'
                    },
                    {
                        title: 'app.js',
                        key: 'app.js'
                    },
                    {
                        title: 'package.json',
                        key: 'package.json'
                    },
                    {
                        title: 'sitemap.xml',
                        key: 'sitemap.xml'
                    }
                ]
            },
            {
                title: 'editor.quickAdd.component2',
                key: 'components',
                sub_links: arrayize(el.getData('components')).slice(0, 10)
            },
            {
                title: 'editor.command.category.pages',
                key: 'pages',
                sub_links: arrayize(el.getData('pages')).slice(0, 10)
            },
            {
                title: 'editor.panel.state',
                key: 'state',
                sub_links: arrayize(el.getData('state')).slice(0, 10)
            },
            {
                title: 'editor.panel.functions',
                key: 'functions',
                sub_links: arrayize(el.getData('functions')).slice(0, 10)
            },
            {
                title: 'editor.sidebar.methods',
                key: 'methods',
                sub_links: arrayize(el.getData('methods'))
            },
            {
                title: 'editor.sidebar.snippets',
                key: 'snippets',
                sub_links: arrayize(el.getData('snippers'))
            },
            {
                title: 'shell.app.files',
                key: 'files',
                sub_links: arrayize(el.getData('files'))
            },
            {
                title: 'editor.ds.title',
                key: 'designSystem',
                sub_links: arrayize(el.getData('designSystem'))
            },
            {
                title: 'editor.panel.dependencies',
                key: 'dependencies'
            },
            {
                title: 'editor.panel.integrations',
                key: 'integrations'
            },
            {
                title: 'shell.pageTitle.canvas',
                key: 'canvas'
            },
            {
                title: 'editor.zoombar.settings',
                key: 'settings'
            },
            {
                title: 'editor.sidebar.secrets',
                key: 'secrets'
            }
        ];
        return rootData;
    }
};

});

parcelRegister("lRKvL", function(module, exports) {

$parcel$export(module.exports, "ProjectCodeData", () => $feb2a06393e606ac$export$b8b6f2080b29843a);
const $feb2a06393e606ac$export$b8b6f2080b29843a = {
    Header: {
        text: (el, s)=>(s.key || s.type || '') + ' data'
    },
    CodePreviewWidget: {
        Monaco: {
            fileTab: {
                code: (el, s)=>{
                    const { type: type, key: key } = s;
                    if (!type) return `// select category or file`;
                    const typeFactory = el.getData(type);
                    const code = el.stringifyCode(key ? typeFactory[key] : typeFactory);
                    return code;
                },
                filename: 'data.js',
                fileTabKey: 'data'
            },
            onCodeEditCallback: async (editor, _, el, s)=>{
                const code = editor.getValue();
                // USER-CODE-ORIGIN review N5: PARSE the buffer (shared methods/code.js
                // parseStringCode — an acorn AST walk, no eval). The buffer starts from code a
                // co-editor stored; evalStringCodeUnsafe ran it on this origin with the
                // editor's session. Function fields stay their source text, the stored form —
                // only the opaque user-code frame revives it.
                await el.call('parseStringCode', code, {
                    onError: (err)=>{
                        s.update({
                            err: err
                        });
                    }
                });
            }
        }
    }
};

});

parcelRegister("9c7Zr", function(module, exports) {

$parcel$export(module.exports, "ProjectCodeSchema", () => $6b1b6eb498e99d44$export$42ea835fe08928c0);
const $6b1b6eb498e99d44$export$42ea835fe08928c0 = {
    Header: {
        text: (el, s)=>(s.key || s.type || '') + ' schema'
    },
    CodePreviewWidget: {
        Monaco: {
            fileTab: {
                code: (el, s)=>{
                    const { type: type, key: key } = s;
                    if (!type) return `// select category or file`;
                    const typeFactory = el.getSchema(type);
                    const code = el.stringifyCode(key ? typeFactory[key] : typeFactory);
                    return code;
                },
                filename: 'schema.js',
                fileTabKey: 'schema'
            },
            onCodeEditCallback: async (editor, _, el, s)=>{
                const code = editor.getValue();
                // USER-CODE-ORIGIN review N5: PARSE the buffer (shared methods/code.js
                // parseStringCode — an acorn AST walk, no eval). The buffer starts from code a
                // co-editor stored; evalStringCodeUnsafe ran it on this origin with the
                // editor's session. Function fields stay their source text, the stored form —
                // only the opaque user-code frame revives it.
                await el.call('parseStringCode', code, {
                    onError: (err)=>{
                        s.update({
                            err: err
                        });
                    }
                });
            }
        }
    },
    // Fill-contrast column separation from the sibling ProjectCodeData pane
    // (was a left-edge `line` divider — border-habit sweep, design-direction.md
    // §8).
    background: 'overlay'
};

});

parcelRegister("8UsF1", function(module, exports) {

$parcel$export(module.exports, "EditorPositionNavbar", () => $67c9c91f620bc80a$export$27783dfab36f84ee);
const $67c9c91f620bc80a$export$27783dfab36f84ee = {
    Expand: {
        title: (el)=>el.call('polyglot', 'editor.position.expand'),
        icon: (el)=>'arrowCompact' + (el.getUserSettings('editorPanelsAtRight') ? 'Left' : 'Right'),
        margin: '- - - auto',
        hide: (el)=>{
            const EditorPanels = el.getEditorPanels();
            return EditorPanels?.isExpanded;
        },
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            EditorPanels?.update({
                isExpanded: true
            });
        }
    },
    Minimize: {
        title: (el)=>el.call('polyglot', 'editor.position.minimize'),
        icon: (el)=>'arrowCompact' + (el.getUserSettings('editorPanelsAtRight') ? 'Right' : 'Left'),
        margin: '- - - auto',
        hide: (el)=>{
            const EditorPanels = el.getEditorPanels();
            return !EditorPanels?.isExpanded;
        },
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            EditorPanels?.update({
                isExpanded: false
            });
        }
    },
    Left: {
        title: (el)=>el.call('polyglot', 'editor.position.alignLeft'),
        icon: 'boxFilledLeft',
        hide: (el)=>!el.getUserSettings('editorPanelsAtRight'),
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            el.call('setUserSettings', 'editorPanelsAtRight', false);
            EditorPanels?.update();
        }
    },
    Right: {
        title: (el)=>el.call('polyglot', 'editor.position.alignRight'),
        icon: 'boxFilledRight',
        hide: (el)=>el.getUserSettings('editorPanelsAtRight'),
        onClick: (ev, el)=>{
            const EditorPanels = el.getEditorPanels();
            el.call('setUserSettings', 'editorPanelsAtRight', true);
            EditorPanels?.update();
        }
    },
    extends: 'NavbarButtonSet'
};

});

parcelRegister("78wxz", function(module, exports) {

$parcel$export(module.exports, "FnEditNavbar", () => $5322859dd2671f75$export$47399a3499160834);
const $5322859dd2671f75$export$47399a3499160834 = {
    IconText: {
        icon: 'fn outline',
        gap: 'X',
        padding: 'X Z1',
        text: '{{ key }}',
        Icon: {
            // eslint-disable-next-line no-restricted-syntax -- icon glyph color, not the text (see `text:` sibling)
            color: 'inactive'
        }
    },
    EditorPositionNavbar: {
        margin: '- - - auto'
    },
    NavbarButtonSet: {
        NavbarButton_docs: {
            isActive: false,
            theme: 'transparent',
            icon: 'question mark',
            ariaLabel: (el)=>el.call('polyglot', 'editor.editNavbar.openDocs'),
            // eslint-disable-next-line no-restricted-syntax -- icon-only button (aria-labelled), not visible text
            color: 'inactive',
            onClick: (ev, el)=>{
                el.setWindow('docs', '/functions');
            }
        },
        NavbarButton_close: {
            icon: 'crossmark',
            ariaLabel: (el)=>el.call('polyglot', 'common.action.close'),
            isActive: false,
            onClick: (ev, el)=>{
                el.activateFunction(null);
            }
        }
    },
    extends: [
        'MicroNavbar',
        'Navbar'
    ],
    width: '100%',
    padding: 'W1 X X1'
};

});

parcelRegister("96PlG", function(module, exports) {

$parcel$export(module.exports, "StateEditNavbar", () => $6a1c8167fbd9bb13$export$41f9d39ae13d00c6);
const $6a1c8167fbd9bb13$export$41f9d39ae13d00c6 = {
    IconText: {
        icon: 'state outline',
        text: '{{ key }}'
    },
    NavbarButtonSet: {
        NavbarButton_docs: {
            onClick: (ev, el)=>{
                el.setWindow('docs', '/state');
            }
        },
        NavbarButton_close: {
            onClick: (ev, el)=>{
                el.activateState(null);
            }
        }
    },
    extends: 'FnEditNavbar'
};

});

parcelRegister("1c57g", function(module, exports) {

$parcel$export(module.exports, "TutorialPillsNotification", () => $0deae1681d848a78$export$31da7ad61e653136);
const $0deae1681d848a78$export$31da7ad61e653136 = {
    if: true,
    state: {
        // KEY-IN-STATE — `TutorialGifNotification` resolves both through
        // `el.call('polyglot', …)` at its own render site.
        descr: 'learn.tutorial.symbolsCodeExplained.descr',
        src: 'code-preview.gif',
        title: 'learn.tutorial.symbolsCodeExplained.title',
        key: 'symbolsCodeExplained',
        docsArticle: '/building-in-symbols'
    },
    Img: {},
    Hgroup: {},
    TutorialNotificationButtons: null,
    extends: 'TutorialGifNotification',
    theme: null,
    overflow: null
};

});

parcelRegister("9mR49", function(module, exports) {

$parcel$export(module.exports, "TutorialNotificationButtons", () => $6d1f54ee09f861df$export$50b88355fa57f0ba);
const $6d1f54ee09f861df$export$50b88355fa57f0ba = {
    childExtends: [
        'CanvasButton',
        'Button'
    ],
    align: 'center center',
    flow: 'x',
    fontSize: 'Z2',
    // Top divider removed (border-habit sweep, design-direction.md §8) — the
    // parent card (TutorialNotification / TutorialGifNotificationSlider, both
    // `theme: 'canvas-card-glass'`) already supplies the surface fill this bar
    // sits on, same precedent as AiActionConfirmCard's Header/Footer.
    height: '100%',
    // Root gap replaces the inter-button divider (was a `:not(:last-child)`
    // `line-highlight` border — §2.5 house rule: "row separators inside
    // rounded cards stay banned — gap + hover tint instead").
    gap: 'X2',
    childProps: {
        round: '0',
        padding: 'A',
        flex: 1,
        gap: 'X2'
    },
    children: [
        {
            icon: 'sf question oval',
            text: '{{ common.action.learn_more | polyglot }}',
            onClick: (ev, el, s)=>{
                el.setWindow('docs', s.docsArticle);
            }
        },
        {
            icon: 'checkmark',
            text: '{{ common.action.okay | polyglot }}',
            onClick: (ev, el, s)=>{
                if (s.callback) el.call('exec', s.callback);
                el.lookup((el)=>el.rootSlide).remove();
                const markKey = 'tutorialMarked_' + s.key;
                el.call('setCookie', markKey, true);
            }
        }
    ]
};

});

parcelRegister("9iHy6", function(module, exports) {

$parcel$export(module.exports, "TutorialGifNotificationSlider", () => $6c57936e61a05389$export$3b4554570b19461f);
const $6c57936e61a05389$export$3b4554570b19461f = {
    // Was missing `extends: 'Navbar'` (unlike TutorialNotification /
    // TutorialGifNotification) — a real gap, not intentional: this card had
    // no `round:` at all and rendered square corners while every other card
    // in the family is `radiusControl`. Explicit `align`/`padding` below
    // override Navbar's row/inset defaults so nothing is silently inherited.
    extends: 'Navbar',
    theme: 'canvas-card-glass',
    padding: '0',
    overflow: 'hidden',
    align: 'stretch',
    round: 'radiusControl',
    useCookie: true,
    if: (el, s)=>{
        const preventByCookie = el.call('getCookie', 'tutorialMarked_' + s.key) === 'true';
        return el.useCookie ? !preventByCookie : true;
    },
    state: {
        slides: [
            {
                title: 'learn.coach.canvas.title',
                descr: 'learn.coach.canvas.descr',
                src: 'intro.gif',
                docsArticle: '/canvas-and-editor'
            },
            {
                title: 'learn.coach.realtime.title',
                descr: 'learn.coach.realtime.descr',
                src: 'realtime.gif',
                docsArticle: '/publish'
            },
            {
                title: 'learn.coach.edit.title',
                descr: 'learn.coach.edit.descr',
                src: 'editor.gif',
                docsArticle: '/building-in-symbols'
            }
        ],
        activeIndex: 0,
        key: 'codeTour'
    },
    Flex: {
        childExtends: 'TutorialPillsNotification',
        childrenAs: 'state',
        children: (el, s)=>s.slides,
        childProps: {
            widthRange: '100%'
        },
        transition: 'C1 defaultBezier transform',
        onBeforeUpdate: (_, el, s)=>{
            el.set({
                transform: `translate3d(-${s.activeIndex * 100}%, 0, 1px)`
            });
        }
    },
    NavigationDots: {},
    TutorialNotificationButtons: {
        children: ()=>[
                {
                    hide: (el, s)=>s.activeIndex === 0,
                    icon: 'arrow left',
                    text: '{{ learn.coach.previous | polyglot }}',
                    onClick: (ev, el, s)=>{
                        s.apply((_)=>s.activeIndex--);
                    }
                },
                {
                    icon: 'sf question oval',
                    text: '{{ common.action.learn_more | polyglot }}',
                    onClick: (ev, el, s)=>{
                        const activeItem = s.slides[s.activeIndex];
                        el.setWindow('docs', activeItem.docsArticle);
                    }
                },
                {
                    flow: 'row-reverse',
                    isLast: (el, s)=>el.key == s.activeIndex,
                    icon: (el)=>el.isLast ? 'checkmark' : 'arrow right',
                    text: (el)=>el.call('polyglot', el.isLast ? 'learn.gifSlider.okay' : 'learn.gifSlider.next'),
                    onClick: (ev, el, s)=>{
                        const activeItem = s.slides[s.activeIndex];
                        if (activeItem.callback) el.call('exec', activeItem.callback);
                        const isLast = el.isLast;
                        if (!isLast) {
                            s.apply((_)=>s.activeIndex++);
                            return;
                        }
                        el.lookup((el)=>el.rootSlider).remove();
                        el.call('setCookie', 'tutorialMarked_' + s.key, true);
                    }
                }
            ]
    },
    flow: 'y',
    position: 'relative',
    gap: 'X',
    width: 'H2',
    rootSlider: true
};

});

parcelRegister("7GjaV", function(module, exports) {

$parcel$export(module.exports, "NavigationDots", () => $597b547336f48a04$export$6659d58bd83a4f69);
const $597b547336f48a04$export$6659d58bd83a4f69 = {
    tag: 'nav',
    flow: 'x',
    gap: 'A2',
    margin: 'A -',
    padding: 'A',
    align: 'center center',
    onRender: (el)=>el.update(),
    childProps: {
        boxSize: 'Z',
        theme: 'dialog',
        round: '100%',
        cursor: 'pointer',
        isActive: (el, s)=>parseInt(el.key) === s.activeIndex,
        text: '',
        '.isActive': {
            theme: 'primary'
        },
        ':active': {
            theme: 'primary'
        }
    },
    children: (el, s)=>s.slides
};

});

parcelRegister("8n8J3", function(module, exports) {

$parcel$export(module.exports, "DangerZoneSection", () => $61873d747526636d$export$d31dc21e4a9b38a7);
const $61873d747526636d$export$d31dc21e4a9b38a7 = {
    hide: (el)=>!el.hasProjectPermission('iam'),
    CardContent: {
        flow: 'y',
        align: 'start',
        gap: 'C1',
        Hgrpup: {
            H: {
                color: 'title',
                fontSize: '1.5rem',
                fontWeight: 'bold',
                text: '{{ editor.dangerZone.title | polyglot }}'
            },
            P: {
                margin: '0',
                text: '{{ editor.dangerZone.hint | polyglot }}'
            }
        },
        ContinueButton: {
            text: '{{ editor.dangerZone.action | polyglot }}',
            theme: null,
            // Outlined button (design-direction.md §8 ban list), and the '2px' was
            // a raw width on top of that. This is a destructive action, so the fix
            // is the semantic danger tint (DESIGN_LANGUAGE §4.2: status fills are
            // tints, `red.1` fill + `red` ink), not a stroke.
            round: 'radiusPill',
            cursor: 'pointer',
            background: 'red.1',
            color: 'red',
            ':hover': {
                background: 'red.15'
            },
            onClick: async (ev, el, st)=>{
                // Double confirmation is not recommended because it can be frustrating for users.
                if (!window.confirm(`Are you sure you want to delete this project? This action cannot be undone.`)) return;
                if (!window.confirm(`Please confirm once more that you want to permanently delete "${st.projectName}".`)) return;
                const { projectId: projectId } = st;
                try {
                    await el.sdk.removeProject(projectId) // removeProject does not return anything
                    ;
                    el.call('openNotification', {
                        title: el.call('polyglot', 'editor.dangerZone.deleted.title'),
                        message: el.call('polyglot', 'editor.dangerZone.deleted.message'),
                        type: 'success'
                    });
                    setTimeout(()=>{
                        // SPA-nav to /dashboard after project removal. If the router
                        // ever fails to apply the new route, fall back to a full
                        // navigation so the user isn't stranded on the now-deleted
                        // project's settings page.
                        try {
                            el.router('/', el.getRoot());
                        } catch (_) {
                            if (typeof window !== 'undefined') window.location.href = '/';
                        }
                    }, 1000);
                } catch (error) {
                    el.call('openNotification', {
                        title: el.call('polyglot', 'editor.dangerZone.failed.title'),
                        message: el.call('polyglot', 'editor.dangerZone.failed.message').replace('{error}', error.message || el.call('polyglot', 'editor.dangerZone.failedFallback')),
                        type: 'error'
                    });
                }
            }
        }
    },
    flow: 'y',
    width: '100%',
    maxWidth: 'I2',
    gap: 'B1',
    align: 'flex-start',
    position: 'relative',
    margin: 'C1 0'
};

});

parcelRegister("8PTMd", function(module, exports) {

$parcel$export(module.exports, "MembersTable", () => $66ee5a3b5b4a959e$export$779b75330d069eb);
const $66ee5a3b5b4a959e$export$779b75330d069eb = {
    state: {
        memberRoleBeingEdited: null,
        successMessage: null,
        errorMessage: null,
        projectMembers: [],
        toUpdate: null
    },
    // The header row. Its key names the component it is, Grid (FA806).
    Grid: {
        columns: '2.2em 1fr 2fr 1fr 1fr',
        padding: 'A1',
        // Dense data table (§2.5 exception #3) — sticky header underline kept,
        // fixed to a real token: was a bare `--color-line` custom-property name
        // with no var() wrapper, an invalid border-bottom shorthand value.
        borderBottom: 'hairline solid line',
        fontWeight: 'bold',
        // The tonal header plate (brief §4.5 item 1, 2026-09-24). 'background-alt'
        // exists in no brand, workspace or framework file: the fill was a silent
        // no-op. `widgetPlate` is the plate AppTableHead uses.
        background: 'widgetPlate',
        AvatarHeader: {
            text: ''
        },
        NameHeader: {
            text: '{{ members.table.name | polyglot }}'
        },
        EmailHeader: {
            text: '{{ members.table.email | polyglot }}'
        },
        RoleHeader: {
            // Names every row's role select (aria-labelledby, below) — one id per
            // table, from the header's own key path.
            id: (el)=>'members-role-' + el.getPath().join('-').replace(/[^A-Za-z0-9_-]/g, ''),
            text: '{{ members.table.role | polyglot }}'
        },
        ActionsHeader: {
            show: (el)=>el.isAdmin(),
            text: '{{ members.table.actions | polyglot }}'
        }
    },
    TableBody: {
        childProps: {
            Avatar: {
                boxSize: 'B',
                text: '{{name}}'
            },
            NameCell: {
                // Per-row id: the second half of the row's role-select name.
                id: (el)=>'members-name-' + el.getPath().join('-').replace(/[^A-Za-z0-9_-]/g, ''),
                text: '{{name}}'
            },
            EmailCell: {
                text: '{{email}}'
            },
            RoleCell: {
                HiddenElement: {
                    show: false,
                    tag: 'div',
                    display: 'none',
                    text: ''
                },
                SelectField: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited === s.id,
                    // The brand SelectField owns the field's shape and padding: a
                    // rounded rect at `radiusControl`, not a capsule (DESIGN_LANGUAGE
                    // §6.2), and no padding on the root. This call site restated
                    // `padding: '0'` and overrode the shape to a `radiusPill` capsule.
                    position: 'relative',
                    Select: {
                        // Named "Role, <member>" by the column header and this row's name
                        // cell — no new copy. It had no name at all, and the literal id and
                        // name 'user' on every row's select (the brand SelectField now
                        // gives each its own id, 3.14.796).
                        // Each id is the element's OWN `id` prop, run the way DOMQL runs it
                        // (`exec`) — never read off the node, which can still hold the
                        // unevaluated prop while this runs (measured: the name came out as
                        // the id functions' source text).
                        ariaLabelledby: (el)=>{
                            const row = el.parent.parent.parent;
                            const table = row.parent.parent;
                            const header = table.Grid && table.Grid.RoleHeader;
                            const idOf = (x)=>x && x.id ? el.call('exec', x.id, x) : null;
                            return [
                                idOf(header),
                                idOf(row.NameCell)
                            ].filter(Boolean).join(' ') || null;
                        },
                        onChange: (ev, el, s)=>{
                            ev.preventDefault();
                            ev.stopImmediatePropagation();
                            s.parent.update({
                                toUpdate: {
                                    id: s.id,
                                    newRole: ev.target.value
                                }
                            });
                        },
                        childrenAs: 'props',
                        children: ()=>[
                                {
                                    value: 'owner',
                                    text: '{{ members.role.owner | polyglot }}'
                                },
                                {
                                    value: 'admin',
                                    text: '{{ members.role.admin | polyglot }}'
                                },
                                {
                                    value: 'editor',
                                    text: '{{ members.role.editor | polyglot }}'
                                },
                                {
                                    value: 'guest',
                                    text: '{{ members.role.guest | polyglot }}'
                                }
                            ],
                        childProps: {
                            tag: 'option',
                            disabled: (el)=>!el.isAdmin(),
                            // `selected` stays in `attr`: there it replaces the brand
                            // SelectField's own `attr.selected` factory. A flat `selected`
                            // would leave that factory running beside this one.
                            attr: {
                                selected: (el, s)=>s.role === el.value
                            }
                        }
                    }
                },
                CurrentRole: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited !== s.id,
                    text: '{{role}}'
                }
            },
            ActionsCell: {
                flow: 'x',
                childExtends: 'IconButton',
                show: (el)=>el.isAdmin(),
                gap: 'A1',
                EditButton: {
                    show: (el, s)=>el.isAdmin(),
                    background: 'transparent',
                    color: 'inactive',
                    // Adaptive ink-surface pair (was fixed 'gray4'/'white') — a solid
                    // hover fill flips polarity with theme, same fix as NativeSelect.
                    ':hover': {
                        background: 'highlight',
                        color: 'highlight-reversed'
                    },
                    icon: 'edit',
                    aria: {
                        label: (el)=>el.call('polyglot', 'members.table.editRole')
                    },
                    onClick: (ev, el, s)=>{
                        s.parent.update({
                            memberRoleBeingEdited: s.id,
                            toUpdate: null
                        });
                    }
                },
                ConfirmUpdateRoleButton: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited === s.id,
                    background: 'transparent',
                    color: 'inactive',
                    icon: 'check',
                    aria: {
                        label: (el)=>el.call('polyglot', 'members.table.confirmRole')
                    },
                    // Adaptive ink-surface pair — see EditButton above.
                    ':hover': {
                        background: 'highlight',
                        color: 'highlight-reversed'
                    },
                    onClick: async (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopImmediatePropagation();
                        if (!s.parent.toUpdate) return;
                        try {
                            const { id: memberId, newRole: newRole } = s.parent.toUpdate;
                            if (newRole) {
                                // Call API to update member role
                                await el.sdk.updateMemberRole(s.root.projectId, memberId, newRole);
                                s.parent.update({
                                    memberRoleBeingEdited: null,
                                    toUpdate: null,
                                    successMessage: 'Member role updated successfully!'
                                });
                                // Refresh the table after a short delay
                                setTimeout(async ()=>{
                                    const result = await el.sdk.getProjectMembers(s.root.projectId);
                                    s.parent.replace({
                                        projectMembers: result.map((r)=>({
                                                ...r,
                                                id: r.user.id,
                                                email: r.user.email,
                                                name: r.user.name || r.user.email,
                                                role: r.role
                                            })) || []
                                    });
                                }, 500);
                            }
                        } catch (error) {
                            s.parent.update({
                                errorMessage: `Error: ${error.message || 'Failed to update member role'}`,
                                memberRoleBeingEdited: null,
                                toUpdate: null
                            });
                        }
                    }
                },
                CrossmarkButton: {
                    show: (el, s)=>s.parent.memberRoleBeingEdited === s.id,
                    background: 'transparent',
                    color: 'inactive',
                    // Adaptive ink-surface pair — see EditButton above.
                    ':hover': {
                        background: 'highlight',
                        color: 'highlight-reversed'
                    },
                    icon: 'crossmark',
                    aria: {
                        label: (el)=>el.call('polyglot', 'common.action.cancel')
                    },
                    onClick: (ev, el, s)=>{
                        s.parent.update({
                            memberRoleBeingEdited: null,
                            toUpdate: null
                        });
                    }
                },
                TrashButton: {
                    // FA515: `show` reads s.root.projectRole only on a non-owner row (the
                    // `&&` returns first on an owner row), so that read was never tracked
                    // there. The declared selector reads it on every run.
                    showDeps: [
                        (el, s)=>s.root && s.root.projectRole
                    ],
                    show: (el, s)=>s.role !== 'owner' && [
                            'owner',
                            'admin'
                        ].includes(s.root.projectRole),
                    background: 'transparent',
                    color: 'inactive',
                    // Adaptive ink-surface pair — see EditButton above.
                    ':hover': {
                        background: 'highlight',
                        color: 'highlight-reversed'
                    },
                    icon: 'trash',
                    aria: {
                        label: (el)=>el.call('polyglot', 'members.table.removeMember')
                    },
                    onClick: async (ev, el, s)=>{
                        const memberId = s.id;
                        ev.preventDefault();
                        ev.stopImmediatePropagation();
                        const memberName = s.name;
                        const res = window.confirm(`Do you really want to remove ${memberName} from this project?`);
                        if (res) try {
                            await el.sdk.removeMember(el.getRootState('projectId'), memberId);
                            s.parent.update({
                                successMessage: `${memberName} has been removed from the project.`
                            });
                        } catch (err) {
                            s.parent.update({
                                errorMessage: `Error: ${err.message || 'Failed to remove member'}`
                            });
                        }
                    }
                }
            },
            columns: '2.2em 1fr 2fr 1fr 1fr',
            width: '100%',
            align: 'center center',
            padding: 'A1',
            // Row separator inside the same dense table (§2.5 exception #3) — was a
            // raw '1px' width against `var(--color-border-light)`, a custom
            // property that is never defined anywhere in the design system, so the
            // border rendered with no colour at all. Fixed to the real `line`
            // token; hover fixed to the `hover` interaction wash (§4.3) — its
            // `var(--color-background-hover)` was equally undefined.
            borderBottom: 'hairline solid line',
            ':hover': {
                background: 'hover'
            }
        },
        flow: 'y',
        width: '100%',
        childExtends: 'Grid',
        childrenAs: 'state',
        children: (el, s)=>s.projectMembers
    },
    EmptyMessage: {
        show: (el, s)=>!s.projectMembers || s.projectMembers.length === 0,
        text: '{{ members.table.empty | polyglot }}',
        padding: 'B1',
        textAlign: 'center',
        opacity: '0.7'
    },
    flow: 'y',
    width: '100%',
    margin: 'B1 0',
    overflow: 'hidden',
    onRender: async (el, s)=>{
        // No SDK in this host (UI-kit catalog, preview frame, spec host) → the
        // table keeps its declared empty state and EmptyMessage shows. The
        // member load is a data enhancement, not a precondition for rendering.
        if (!el.sdk?.getProjectMembers) return;
        const result = await el.sdk.getProjectMembers(el.getRootState('projectId'));
        s.update({
            projectMembers: (result || []).map((r)=>{
                const user = r.user || {};
                return {
                    ...r,
                    id: r.id,
                    email: user.email,
                    name: user.name || user.email,
                    role: r.role
                };
            })
        });
    },
    // ——— the toast watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-SIBLINGS-1) ———
    //
    // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the framework
    // registers it ONLY when a sibling `stateDeps` ARRAY exists, and no legacy
    // `stateUpdate` event is emitted anywhere. This block shipped with NO
    // `stateDeps` and the legacy `(changes, el)` signature, so it never ran:
    // a role update and a member removal both wrote `successMessage` /
    // `errorMessage` and NO notification ever opened.
    //
    // Each selector is self-contained (FA204 — a `stateDeps` entry is
    // serialized on its own by frank.toJSON, so a shared module-scope helper
    // would read as `undefined` on the platform payload). Both keys live on
    // THIS component's own state, written by the row buttons above.
    stateDeps: [
        (el, s)=>(s || {}).successMessage,
        (el, s)=>(s || {}).errorMessage
    ],
    // v3.14 signature: `(el, state, context, { prev, next })`. The effect only
    // runs when a selector value actually changed, so an unchanged message is
    // never re-toasted; a truthiness guard drops the write back to `null`.
    onStateUpdate: (el, s, ctx, { prev: prev, next: next })=>{
        const [successMessage, errorMessage] = next;
        if (successMessage && successMessage !== prev[0]) el.call('openNotification', {
            title: el.call('polyglot', 'members.notify.success.title'),
            message: successMessage,
            type: 'success'
        });
        if (errorMessage && errorMessage !== prev[1]) el.call('openNotification', {
            title: el.call('polyglot', 'members.notify.error.title'),
            message: errorMessage,
            type: 'error'
        });
    }
};

});

parcelRegister("bvG9T", function(module, exports) {

$parcel$export(module.exports, "Dropdown.MoreLearnMenu", () => $86134acbe97c0a76$export$5887f5bebe1cc0b8);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): MenuPanel shell + MenuPanelItem rows. The `margin: '- -Z2'` list
// pulls compensated the old hand-rolled `padding: 'Z1 A'` body (gone —
// MenuPanel pads Y, rows run full-width), and the `':hover': { '& svg': … }`
// opacity armor fought the retired KeyValueColumnFields/DropdownItem svg
// games (MenuPanelItem has none). The second list is icon-less, so it needs
// no Icon config at all — the old `Icon: null` only existed to suppress
// KeyValueColumnFields' baked-in checkmark.
const $86134acbe97c0a76$export$5887f5bebe1cc0b8 = {
    extends: 'MenuPanel',
    gap: 'A',
    Items: {
        flow: 'y',
        gap: '0',
        childExtends: 'MenuPanelItem',
        childProps: {
            Icon: {
                order: '-1',
                margin: '- Y1 - -'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: '{{ learn.menu.onboarding | polyglot }}',
                    Icon: {
                        name: 'intOutline'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('explorer', 'onboarding');
                        el.parent.update();
                    }
                },
                {
                    text: '{{ learn.examples.title | polyglot }}',
                    Icon: {
                        name: 'ratingFrame'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('docs', '/examples');
                    }
                },
                {
                    text: '{{ learn.menu.properties | polyglot }}',
                    Icon: {
                        name: 'ratingFrame'
                    },
                    onClick: (ev, el)=>{
                        el.setWindow('docs', '/props');
                    }
                }
            ]
    },
    GeneralNav: {
        CaptionTitle: {
            margin: 'X - X2',
            // Align the caption with MenuPanelItem's Z1 label inset.
            padding: '- Z1',
            Text: {
                text: '{{ shell.app.more | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: '{{ learn.intro.symbols | polyglot }}',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/intro');
                        }
                    },
                    {
                        text: '{{ editor.command.docs.description | polyglot }}',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/developers');
                        }
                    },
                    {
                        text: '{{ learn.menu.contribution | polyglot }}',
                        onClick: (ev, el)=>{
                            el.setWindow('docs', '/symbols-developer');
                        }
                    }
                ]
        }
    }
};

});

parcelRegister("41uEo", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Envs", () => $2edf07fc37f96f5c$export$df2fb887d44a420a);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). The rows here are EnvItem / DomainItem cards (title + description +
// trailing action), not menu-command rows, so they keep their own chassis —
// only the shell re-homes. Deleted with the re-chassis: the `margin:
// '- -Z2'` pulls on every group (they compensated the old hand-rolled
// `padding: 'Z1 A'` body; MenuPanel pads Y and the rows' own Z2 padding
// provides the hover-box inset, so a -Z2 pull would overflow the panel by
// Z2 − Y and clip), and the two `Line` dividers — the C gap + the group
// captions separate the sections (§7.7 default: gap, not hairlines).
const $2edf07fc37f96f5c$export$df2fb887d44a420a = {
    extends: 'MenuPanel',
    gap: 'C',
    textAlign: 'start',
    width: 'G1',
    Envs: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            // Align the caption with the EnvItem/DomainItem rows' Z2 content inset.
            padding: '- Z2',
            Text: {
                text: '{{ publish.envs.title | polyglot }}'
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            childExtends: 'EnvItem',
            Prod: {
                Hgroup: {
                    H: {
                        text: '{{ publish.envs.production | polyglot }}'
                    },
                    P: {
                        text: '{{ publish.envs.productionHint | polyglot }}'
                    }
                }
            },
            Test: {
                Hgroup: {
                    H: {
                        text: '{{ publish.envs.test | polyglot }}'
                    },
                    P: {
                        text: '{{ publish.envs.testHint | polyglot }}'
                    }
                }
            },
            Dev: {
                extends: [
                    'CanvasButton',
                    'EnvItem'
                ],
                isActive: true,
                Circle: {
                    isActive: true
                },
                Hgroup: {
                    H: {
                        text: '{{ publish.envs.development | polyglot }}'
                    },
                    P: {
                        text: '{{ publish.envs.developmentHint | polyglot }}'
                    }
                },
                Buttons: {
                    hide: false
                },
                Upgrade: null
            }
        }
    },
    EnvItem_Local: {
        Hgroup: {
            H: {
                text: '{{ publish.envs.local | polyglot }}'
            },
            P: {
                text: (el)=>`localhost:1234`
            }
        },
        Upgrade: null,
        Connect: {
            extends: 'Link',
            color: 'title',
            text: '{{ publish.sync.connect | polyglot }}',
            margin: '- - - auto',
            alignSelf: 'start',
            whiteSpace: 'nowrap',
            fontSize: 'Z2',
            lineHeight: 1,
            ':hover': {
                textDecoration: 'underline'
            },
            onClick: (f, el, st)=>{
                el.call('openRouterModal', '/settings', {
                    key: '/connect'
                });
            }
        }
    },
    Domains: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            padding: '- Z2',
            Text: {
                text: '{{ publish.domains.title | polyglot }}'
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            childExtends: 'DomainItem',
            Custom: {
                Hgroup: {
                    H: {
                        text: '{{ publish.domains.custom | polyglot }}'
                    },
                    P: {
                        text: '{{ publish.domains.customHint | polyglot }}'
                    }
                }
            },
            Lookup: {
                Hgroup: {
                    H: {
                        text: '{{ publish.domains.find | polyglot }}'
                    },
                    P: {
                        text: '{{ publish.domains.findHint | polyglot }}'
                    }
                },
                Upgrade: null,
                Icon: {
                    name: 'sf search'
                },
                // The modal's "New domain" step — registration through Symbols is
                // still "coming soon" there, with a one-click path back to linking.
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.call('openProjectDomainFlow', {
                        step: 'new'
                    });
                }
            }
        }
    }
};

});

parcelRegister("i2jlE", function(module, exports) {

$parcel$export(module.exports, "Dropdown.QuickAdd", () => $d2176c06a1348087$export$b4fc0047ec2eaaa6);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): MenuPanel shell + MenuPanelItem rows for the two command lists. The
// QuickAddPanel block embeds a form (selects + FileSidebarAddNewItem), so it
// keeps its own structure — only the shell and the item rows re-chassis.
// Deleted with the re-chassis: the `margin: '- -Z2'` list pulls (they
// compensated the old hand-rolled `padding: 'A A1'` body; MenuPanel pads Y
// and MenuPanelItem rows run full-width, so a -Z2 pull would overflow the
// panel by Z2 − Y and clip), the `':hover': { '& svg': … }` opacity armor
// (fought the retired KeyValueColumnFields/DropdownItem svg games), and the
// three `Line` dividers — sparse command groups with captions, so the body
// gap separates them (§7.7 default: gap, not hairlines).
const $d2176c06a1348087$export$b4fc0047ec2eaaa6 = {
    extends: 'MenuPanel',
    state: {},
    width: 'G+C',
    gap: 'A',
    textAlign: 'start',
    QuickAddMenu: {
        CaptionTitle: {
            margin: '- - Z',
            // Align the caption with MenuPanelItem's Z1 label inset.
            padding: '- Z1',
            Text: {
                text: '{{ editor.quickAdd.addBlank | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childProps: {
                gap: 'X',
                Icon: {
                    order: '-1',
                    margin: '0'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: '{{ editor.quickAdd.component | polyglot }}',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            const key = el.call('findNewName', 'components', 'NewComponent', {
                                autoRename: true
                            });
                            el.call('createItem', 'components', key);
                        }
                    },
                    {
                        text: '{{ editor.quickAdd.page | polyglot }}',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            const key = el.call('findNewName', 'pages', '/new-page', {
                                autoRename: true
                            });
                            el.call('createItem', 'pages', key);
                        }
                    },
                    {
                        text: '{{ editor.quickAdd.file | polyglot }}',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el, s)=>{
                            el.call('openRouterModal', '/add-file');
                        }
                    }
                ]
        }
    },
    // MoreInsertMenu re-chassised onto MenuPanelItem rows in the bespoke-menus
    // wave — the -Z2 pull (and this site's neutralization of it) is gone.
    MoreInsertMenu: {},
    QuickAddPanel: {
        CaptionTitle: {
            margin: '- - Y2',
            padding: '- Z1',
            Text: {
                text: '{{ editor.quickAdd.applyAction | polyglot }}'
            }
        },
        Flex: {
            flow: 'y',
            gap: 'Z2',
            childProps: {
                width: '100%'
            },
            Select_action: {
                width: '100%'
            },
            Select_type: {
                width: '100%'
            },
            FileSidebarAddNewItem: {
                order: 2,
                margin: '-X W -',
                Label: {
                    Flex: {
                        margin: '- -W - -',
                        order: 2,
                        opacity: 1,
                        Save: {
                            extends: 'NavbarButton'
                        },
                        Close: null
                    }
                }
            }
        }
    },
    ComingSoonMenu: {
        CaptionTitle_soon: {
            padding: '- Z1',
            Text: {
                text: '{{ common.state.coming_soon | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childProps: {
                Icon: {
                    order: '-1',
                    margin: '- Y1 - -'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: '{{ shell.app.marketplace | polyglot }}',
                        Icon: {
                            name: 'plus'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert');
                        }
                    },
                    {
                        text: '{{ editor.panel.integrations | polyglot }}',
                        Icon: {
                            name: 'fuse'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:integrations');
                        }
                    },
                    {
                        text: 'Figma',
                        Icon: {
                            name: 'figma'
                        },
                        Sup: {
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '{{ editor.logoMenu.soon | polyglot }}'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:figma');
                        }
                    },
                    {
                        text: '{{ editor.panel.icons | polyglot }}',
                        Icon: {
                            name: 'icons'
                        },
                        Sup: {
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '{{ editor.logoMenu.soon | polyglot }}'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:icons');
                        }
                    },
                    {
                        text: '{{ editor.panel.fonts | polyglot }}',
                        Icon: {
                            name: 'fontFace'
                        },
                        Sup: {
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '{{ editor.logoMenu.soon | polyglot }}'
                        },
                        onClick: (ev, el)=>{
                            el.setWindow('explorer', 'insert:fonts');
                        }
                    }
                ]
        }
    }
};

});

parcelRegister("dhQbH", function(module, exports) {

$parcel$export(module.exports, "Dropdown.MoreFilesMenu", () => $9ac5584916c4cabe$export$37ee3f34f795b121);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). The legacy `margin: '- -Z2'` list pull compensated the old
// hand-rolled `padding: 'Z1 A'` body — MenuPanel pads Y and MenuPanelItem
// rows run full-width, so the pull (which would now overflow the panel by
// Z2 − Y and clip against the wrapper's overflow) is deleted. The per-row
// `':hover': { '& svg': ... }` opacity armor fought the retired
// KeyValueColumnFields/DropdownItem svg games and is gone with them.
const $9ac5584916c4cabe$export$37ee3f34f795b121 = {
    extends: 'MenuPanel',
    Items: {
        flow: 'y',
        gap: '0',
        childExtends: 'MenuPanelItem',
        childProps: {
            isActive: (el, s)=>el.key === s.activeContent,
            // Active row = the house `selected` wash + medium emphasis (§4.3) —
            // replaces DropdownItem's old gray6.15/white active pair. The nested
            // ':hover' pins the selected fill so hovering the active row does not
            // drop it back to the plain `hover` wash (DropdownItem did the same).
            '.isActive': {
                fontWeight: '500',
                background: 'selected',
                ':hover': {
                    background: 'selected'
                }
            },
            onClick: (ev, el, s)=>{
                const activeContent = el.key;
                el.setWindow('explorer', 'explorer:' + activeContent);
            // el.setWindow('explorer', 'explorer', {
            //   forcedValue: activeContent
            // })
            // el.call('setSidebarContent', activeContent)
            },
            Icon: {
                order: '-1',
                margin: '- Y1 - -'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    key: 'ARTBOARD_TYPES',
                    text: '{{ editor.panel.artboards | polyglot }}',
                    Icon: {
                        name: 'sf components'
                    }
                },
                {
                    key: 'FUNCTION_TYPES',
                    text: '{{ editor.panel.functions | polyglot }}',
                    Icon: {
                        name: 'fnOutline'
                    }
                },
                {
                    key: 'STATE_TYPES',
                    text: '{{ editor.panel.state | polyglot }}',
                    Icon: {
                        name: 'sfDocument'
                    }
                },
                {
                    key: 'ASSETS_TYPES',
                    text: '{{ editor.panel.assets | polyglot }}',
                    Icon: {
                        name: 'sfAssets'
                    }
                },
                {
                    key: 'COLOR_TYPES',
                    text: '{{ editor.panel.colors | polyglot }}',
                    Icon: {
                        name: 'sfPallete'
                    }
                },
                {
                    key: 'RESPONSIVE_TYPES',
                    text: '{{ editor.panel.responsive | polyglot }}',
                    Icon: {
                        name: 'sfResponsive'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '{{ editor.logoMenu.soon | polyglot }}'
                    }
                },
                {
                    key: 'TYPOGRAPHY_TYPES',
                    text: '{{ editor.panel.typography | polyglot }}',
                    Icon: {
                        name: 'fontFace'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '{{ editor.logoMenu.soon | polyglot }}'
                    }
                },
                {
                    key: 'SPACING_TYPES',
                    text: '{{ editor.panel.spacing | polyglot }}',
                    Icon: {
                        name: 'spaceOutlineColored'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '{{ editor.logoMenu.soon | polyglot }}'
                    }
                },
                {
                    key: 'ICON_TYPES',
                    text: '{{ editor.panel.icons | polyglot }}',
                    Icon: {
                        name: 'iconsOutlineColored'
                    }
                },
                {
                    key: 'TRANSITION_TYPES',
                    text: '{{ editor.panel.animations | polyglot }}',
                    Icon: {
                        name: 'animationsAlt'
                    },
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '{{ editor.logoMenu.soon | polyglot }}'
                    }
                },
                {
                    key: 'INTEGRATIONS_TYPES',
                    text: '{{ editor.panel.integrations | polyglot }}',
                    Icon: {
                        name: 'fuse'
                    }
                }
            ]
    }
};

});

parcelRegister("eCwCc", function(module, exports) {

$parcel$export(module.exports, "Dropdown.AssistantMenu", () => $aa4de9f74af90c84$export$59ab8e072d21d642);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): panel = MenuPanel (dialog surface + overlay shadow + radiusCard + Y
// padding), rows = MenuPanelItem (Y/Z1 padding, radiusControl, the `hover`
// wash, @coarse tap height). The legacy ListInDropdown recipe is gone with
// its armor: the `margin: '- -Z2'` pull existed to claw rows back across the
// old hand-rolled `padding: 'Z1 A'` body — MenuPanelItem rows are full-width
// inside MenuPanel's own Y padding, so nothing needs pulling out — and the
// per-row `':hover': { '& svg': ... }` opacity block only fought the old
// KeyValueColumnFields/DropdownItem svg-opacity games, which MenuPanelItem
// does not have.
const $aa4de9f74af90c84$export$59ab8e072d21d642 = {
    extends: 'MenuPanel',
    gap: 'A',
    CaptionTitle: {
        // Align the caption with MenuPanelItem's Z1 label inset (same idiom as
        // MarketplaceFilters' MenuLabel).
        padding: '- Z1',
        Text: {
            text: '{{ ai.menu.title | polyglot }}'
        }
    },
    Items: {
        flow: 'y',
        gap: '0',
        childExtends: 'MenuPanelItem',
        childProps: {
            // Flat `text` renders before child elements — flex order puts the icon
            // back in front (same recipe as EditInNavbarMenu).
            Icon: {
                order: '-1',
                margin: '- Y1 - -'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: '{{ ai.menu.playground | polyglot }}',
                    Icon: {
                        name: 'wave'
                    },
                    onClick: (ev, el)=>{
                        el.call('openRouterModal', '/ai-playground');
                    }
                }
            ]
    }
};

});

parcelRegister("5dp4c", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Logo", () => $3cc19c6427a00c54$export$7013d6ee10d6e04a);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): MenuPanel shell + MenuPanelItem rows across all four nav groups.
// Deleted with the re-chassis: the four `margin: '- -Z2'` list pulls (they
// compensated the old hand-rolled `padding: 'Z1 A'` body — MenuPanel pads Y
// and MenuPanelItem rows run full-width, so a -Z2 pull would overflow the
// panel by Z2 − Y and clip), the per-row `':hover': { '& svg': … }` opacity
// armor plus the `background/border/cursor` resets (all fought the retired
// KeyValueColumnFields/DropdownItem chassis — MenuPanelItem is already a
// borderless transparent button row with the house `hover` wash). Rows that
// are links keep their own `extends` + textDecoration guards untouched.
const $3cc19c6427a00c54$export$7013d6ee10d6e04a = {
    extends: 'MenuPanel',
    gap: 'A',
    CaptionTitle: {
        // Align captions (and the identity header below) with MenuPanelItem's
        // Z1 label inset — same idiom as MarketplaceFilters' MenuLabel.
        padding: '- Z1',
        Text: {
            text: '{{ editor.logoMenu.activeProject | polyglot }}'
        },
        if: (el)=>el.isCanvas()
    },
    Flex: {
        if: (el)=>el.isCanvas(),
        gap: 'Z',
        padding: '- Z1',
        Avatar: {
            props: (el)=>({
                    avatarType: 'initials',
                    boxSize: 'B+X1',
                    src: el.call('getProjectIcon') || `https://avatars.symbo.ls/${el.avatarType || 'initials'}/svg?seed=${el.key || 'no-avatar'}`,
                    round: 'radiusControl'
                })
        },
        Hgroup: {
            flow: 'y',
            margin: '- Z - -',
            gap: 'W',
            H: {
                color: 'title',
                tag: 'span',
                overflow: 'hidden',
                whiteSpace: 'wrap',
                textOverflow: 'anywhere',
                text: (el)=>el.getRootState('projectName')
            },
            P: {
                margin: '0',
                fontWeight: '400',
                color: 'paragraph',
                overflow: 'hidden',
                overflowWrap: 'anywhere',
                whiteSpace: 'wrap',
                textOverflow: 'anywhere',
                lineBreak: 'anywhere',
                text: (el)=>`${el.getRootState('workingProjectOwner')}/${el.getRootState('workingProjectKey')}`
            }
        },
        Upgrade: {
            if: (el)=>el.isAuthorised() && el.getRootState('tier') === 'starter',
            extends: 'Link',
            color: 'blue',
            text: '{{ editor.logoMenu.freePlan | polyglot }}',
            margin: '- - - auto',
            alignSelf: 'start',
            whiteSpace: 'nowrap',
            fontSize: 'Z2',
            lineHeight: 1,
            ':hover': {
                textDecoration: 'underline'
            },
            onClick: (f, el, st)=>{
                el.call('openRouterModal', '/settings', {
                    key: '/pricing'
                });
            }
        }
    },
    ProjectNav: {
        if: (el)=>!el.isDashboard(),
        CaptionTitle: {
            margin: 'Z - X',
            padding: '- Z1',
            Text: {
                text: '{{ editor.logoMenu.project | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childProps: {
                Icon: {
                    order: '-1',
                    margin: '- Y1 - -'
                }
            },
            childrenAs: 'props',
            children: [
                {
                    Icon: {
                        name: 'upgrade'
                    },
                    text: '{{ editor.logoMenu.upgradeTeam | polyglot }}',
                    Sup: {
                        color: 'disabled',
                        margin: '-Z - - X2',
                        fontSize: 'Y',
                        text: '{{ editor.logoMenu.soon | polyglot }}'
                    }
                },
                {
                    Icon: {
                        name: 'billing'
                    },
                    text: '{{ settings.tabs.billing | polyglot }}'
                },
                {
                    Icon: {
                        name: 'sf settings fill'
                    },
                    text: '{{ editor.logoMenu.projectSettings | polyglot }}'
                }
            ]
        }
    },
    DashboardNav: {
        CaptionTitle: {
            margin: 'X -',
            padding: '- Z1',
            Text: {
                text: '{{ editor.dashboard.title | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childProps: {
                Icon: {
                    order: '-1',
                    margin: '- Y1 - -'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        Icon: {
                            name: 'plus oval'
                        },
                        text: '{{ editor.dashboard.newProject | polyglot }}',
                        onClick: async (ev, el)=>{
                            await el.call('openRouterModal', '/settings', {
                                key: '/onboarding'
                            });
                        }
                    },
                    {
                        Icon: {
                            name: 'arrows diagonal'
                        },
                        extends: [
                            'Link',
                            'Button'
                        ],
                        text: '{{ editor.logoMenu.switchProject | polyglot }}',
                        // /studio is the project picker (the /dashboard route is retired)
                        href: '/studio'
                    },
                    {
                        Icon: {
                            name: 'back'
                        },
                        extends: [
                            'Link',
                            'Button'
                        ],
                        text: '{{ editor.logoMenu.backToWorkspace | polyglot }}',
                        href: '/'
                    }
                ]
        }
    },
    UserNav: {
        CaptionTitle: {
            margin: 'Z - X',
            padding: '- Z1',
            Text: {
                text: '{{ editor.logoMenu.user | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childProps: {
                Icon: {
                    order: '-1',
                    margin: '- Y1 - -'
                }
            },
            childrenAs: 'props',
            children: [
                {
                    Icon: {
                        name: 'user'
                    },
                    text: '{{ shell.accountMenu.profile | polyglot }}',
                    onClick: async (ev, el)=>{
                        await el.call('openRouterModal', '/settings', {
                            key: '/personal-account'
                        });
                    }
                },
                {
                    extends: [
                        'Link',
                        'Button'
                    ],
                    Icon: {
                        name: 'logout'
                    },
                    text: '{{ shell.accountMenu.signOut | polyglot }}',
                    href: '/logout'
                }
            ]
        }
    },
    GeneralNav: {
        CaptionTitle: {
            margin: 'Z - -',
            padding: '- Z1',
            Text: {
                text: '{{ editor.logoMenu.general | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childProps: {
                Icon: {
                    order: '-1',
                    margin: '- Y1 - -'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        extends: 'DocsLink',
                        href: '/developers',
                        text: '{{ editor.logoMenu.whatsNew | polyglot }}',
                        ':hover': {
                            textDecoration: 'none'
                        },
                        Icon: {
                            name: 'news'
                        }
                    },
                    {
                        extends: 'DocsLink',
                        href: '/developers',
                        text: '{{ editor.logoMenu.about | polyglot }}',
                        ':hover': {
                            textDecoration: 'none'
                        },
                        Icon: {
                            name: 'sf info'
                        }
                    },
                    {
                        extends: 'DocsLink',
                        href: '/docs/resources',
                        text: '{{ editor.logoMenu.support | polyglot }}',
                        ':hover': {
                            textDecoration: 'none'
                        },
                        Icon: {
                            name: 'support'
                        }
                    }
                ]
        }
    }
};

});

parcelRegister("gktT6", function(module, exports) {

$parcel$export(module.exports, "Dropdown.MoreModesMenu", () => $be35b2ab9524c9d0$export$663119686d13f15d);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): MenuPanel shell + MenuPanelItem rows. Deleted with the re-chassis:
// the `margin: '- -Z2'` list pulls (compensated the old hand-rolled
// `padding: 'Z1 A'` body — MenuPanel pads Y and rows run full-width), the
// `':hover': { '& svg': … }` opacity armor (fought the retired
// KeyValueColumnFields/DropdownItem svg games), and the `Line` divider —
// this is a sparse command menu, not dense data, so the body gap + the
// "More canvas modes" caption separate the two groups (§7.7 default).
const $be35b2ab9524c9d0$export$663119686d13f15d = {
    extends: 'MenuPanel',
    gap: 'A',
    Items: {
        flow: 'y',
        gap: '0',
        childExtends: 'MenuPanelItem',
        childProps: {
            // Active row = the house `selected` wash + medium emphasis (§4.3),
            // replacing DropdownItem's old gray6.15/white active pair; the nested
            // ':hover' keeps the selected fill under the pointer.
            '.isActive': {
                fontWeight: '500',
                background: 'selected',
                ':hover': {
                    background: 'selected'
                }
            },
            Icon: {
                order: '-1',
                margin: '- Y1 - -'
            }
        },
        childrenAs: 'props',
        children: (el)=>[
                {
                    text: '{{ editor.theming.lightMode | polyglot }}',
                    isActive: (el)=>el.getRootState('sceneTheme') === 'light',
                    Icon: {
                        theme: 'sepia',
                        name: (el, s)=>el.getRootState('sceneTheme') === 'light' ? 'sun' : 'sun outline'
                    },
                    onClick: (ev, el, s)=>{
                        const key = 'light';
                        el.getRootState().update({
                            globalTheme: key,
                            sceneTheme: key
                        });
                        el.getRoot().call('router', window.location.pathname);
                        el.getRoot().call('setCookie', 'sceneTheme', key);
                        el.getRoot().call('setCookie', 'globalTheme', key);
                    }
                },
                {
                    text: '{{ editor.theming.darkMode | polyglot }}',
                    isActive: (el)=>el.getRootState('sceneTheme') === 'dark',
                    Icon: {
                        theme: 'sepia',
                        name: (el, s)=>el.getRootState('sceneTheme') === 'dark' ? 'moon' : 'moon outline'
                    },
                    onClick: (ev, el, s)=>{
                        const key = 'dark';
                        el.getRootState().update({
                            globalTheme: key,
                            sceneTheme: key
                        });
                        el.getRoot().call('router', window.location.pathname);
                        el.getRoot().call('setCookie', 'sceneTheme', key);
                        el.getRoot().call('setCookie', 'globalTheme', key);
                    }
                }
            ]
    },
    More: {
        CaptionTitle: {
            margin: 'X - Y2',
            // Align the caption with MenuPanelItem's Z1 label inset.
            padding: '- Z1',
            Text: {
                text: '{{ editor.mode.moreCanvas | polyglot }}'
            }
        },
        Items: {
            flow: 'y',
            gap: '0',
            childExtends: 'MenuPanelItem',
            childProps: {
                Icon: {
                    order: '-1',
                    margin: '- Y1 - -'
                }
            },
            childrenAs: 'props',
            children: (el)=>[
                    {
                        text: '{{ editor.mode.code | polyglot }}',
                        Icon: {
                            name: 'code'
                        },
                        onClick: (ev, el)=>{
                            el.call('openRouterModal', '/project-code', {
                                animationProps: {
                                    animation: 'fadeIn'
                                }
                            });
                        }
                    },
                    {
                        text: '{{ editor.mode.preview | polyglot }}',
                        Icon: {
                            name: 'sf eye'
                        },
                        Sup: {
                            color: 'disabled',
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '{{ editor.logoMenu.soon | polyglot }}'
                        }
                    },
                    {
                        text: '{{ editor.mode.comments | polyglot }}',
                        Icon: {
                            name: 'chat'
                        },
                        Sup: {
                            color: 'disabled',
                            margin: '-Z - - X2',
                            fontSize: 'Y',
                            text: '{{ editor.logoMenu.soon | polyglot }}'
                        }
                    }
                ]
        }
    }
};

});

parcelRegister("4mfko", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Share", () => $32c51b529b014c30$export$de07b2de30aa5e59);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). This menu embeds form controls (env select, selection-share toggle)
// and DomainItem link cards, so those keep their structure — only the shell
// re-homes. Deleted with the re-chassis: the `margin: '- -Z2'` pulls on
// DomainItem_Env and the link list (they compensated the old hand-rolled
// `padding: 'Z1 A'` body; MenuPanel pads Y and the DomainItem rows' own Z2
// padding provides the inset, so a -Z2 pull would overflow the panel by
// Z2 − Y and clip), and the `Line` divider — the C gap plus the two group
// captions separate Share from Access Permissions (§7.7 default).
const $32c51b529b014c30$export$de07b2de30aa5e59 = {
    extends: 'MenuPanel',
    state: {},
    width: 'G1',
    gap: 'C',
    textAlign: 'start',
    ShareSection: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            // Align the caption with the DomainItem rows' Z2 content inset.
            padding: '- Z2',
            Text: {
                text: '{{ members.share.title | polyglot }}'
            }
        },
        DomainItem_Env: {
            Upgrade: null,
            Icon: null,
            Hgroup: {
                H: {
                    text: '{{ members.share.environment | polyglot }}'
                },
                P: {
                    text: '{{ members.share.environmentHint | polyglot }}'
                }
            },
            Select: {
                padding: 'X Y2',
                margin: '-W -Y2 - auto',
                background: 'none',
                color: 'currentColor',
                width: 'D3',
                onChange: (ev, el, s, ctx)=>{
                    const value = ev.target.value;
                    if (value) s.update({
                        env: value
                    });
                },
                childrenAs: 'props',
                childProps: {
                    tag: 'option',
                    attr: {
                        selected: (el, s)=>el.node.value === s.action
                    }
                },
                children: [
                    {
                        text: '{{ members.share.env.current | polyglot }}'
                    },
                    {
                        text: '{{ members.share.env.development | polyglot }}'
                    },
                    {
                        text: '{{ members.share.env.staging | polyglot }}'
                    },
                    {
                        text: '{{ members.share.env.production | polyglot }}'
                    }
                ]
            },
            align: 'start'
        },
        Label: {
            flow: 'x',
            align: 'start',
            gap: 'A',
            // Same Z2 inset as the DomainItem rows around it (their content sits
            // at their own Z2 padding; this row has none of its own).
            padding: '- Z2',
            Hgroup: {
                H: {
                    tag: 'p',
                    text: '{{ members.share.selection | polyglot }}'
                },
                P: {
                    fontSize: 'Y2',
                    color: 'paragraph',
                    text: '{{ members.share.selectionHint | polyglot }}'
                },
                gap: 'X'
            },
            Toggle: {
                margin: '- - - auto',
                fontSize: 'Y2',
                Input: {
                    onChange: (ev, el, s)=>s.update({
                            isSelcetedActive: el.node.checked
                        })
                }
            }
        },
        Flex: {
            gap: 'A',
            flow: 'y',
            childExtends: 'DomainItem',
            childProps: {
                onInit: (el, s)=>{
                    s.path = el.getCanvasPathname();
                },
                onBeforeUpdate: (_, el, s)=>{
                    const isSelected = s.parent.isSelcetedActive ? el.getSelectedKey() : '';
                    if (isSelected) s.selected = isSelected.startsWith('/') ? isSelected : '?selected=' + el.getSelectedKey();
                    else s.selected = '';
                    if (s.parent.env) {
                        const prefix = (isSelected ? '&' : '?') + 'env=';
                        s.env = ({
                            Current: prefix + 'dev',
                            Development: '',
                            Staging: prefix + 'staging',
                            Production: prefix + 'production'
                        })[s.parent.env];
                    }
                },
                Icon: null,
                Hgroup: {
                    H: {
                        text: (el, s)=>el.call('polyglot', s.title || '')
                    },
                    P: {
                        text: (el)=>'{{ domain }}{{ path }}{{ selected }}{{ env }}'
                    }
                },
                Upgrade: null,
                Copy: {
                    extends: [
                        'CanvasButton',
                        'IconButton'
                    ],
                    padding: 'Y2',
                    margin: '-Y - - auto',
                    icon: 'copy outline',
                    aria: {
                        label: (el)=>el.call('polyglot', 'members.share.copyUrl')
                    },
                    value: '{{ env }}{{ domain }}{{ path }}{{ selection }}',
                    Icon: {
                        order: 2,
                        color: 'blue'
                    }
                },
                Open: {
                    extends: [
                        'CanvasButton',
                        'Link',
                        'IconButton'
                    ],
                    padding: 'Y2',
                    margin: '-Y -Y2 -',
                    icon: 'arrow up right',
                    aria: {
                        label: (el)=>el.call('polyglot', 'members.share.openNewTab')
                    },
                    href: 'https://{{ domain }}{{ path }}{{ selection }}',
                    target: '_blank'
                }
            },
            childrenAs: 'state',
            children: [
                {
                    title: 'members.share.previewLink',
                    domain: 'preview.symbo.ls'
                },
                {
                    title: 'members.share.canvasLink',
                    domain: 'symbols.app'
                }
            ]
        }
    },
    SharingPermissions: {
        // SharingPermissions is a shared read-only file still on the legacy
        // recipe: its inner Flex pulls out by -Z2 to compensate a body padding
        // this panel no longer has — neutralize the pull at this consumption
        // site; the shared file migrates with the bespoke-menus wave.
        Flex: {
            margin: '0'
        }
    }
};

});

parcelRegister("5V8G0", function(module, exports) {

$parcel$export(module.exports, "Dropdown.Publish", () => $44f9019416e1d85f$export$cb51629418732a88);
// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). This is the accordion menu (Publish / Sync / Export headers that
// disclose tool sections), not a command list, so the CaptionTitle headers
// and the embedded tool sections keep their structure — only the shell
// re-homes. Deleted with the re-chassis:
// - the headers' `margin: '- -A2'` bleed: it stretched each header row
//   across the old hand-rolled `padding: 'Z1 A'` body; under MenuPanel's Y
//   padding a -A2 pull would overflow the panel and clip against the brand
//   Dropdown wrapper's overflow, so headers are now full-width rows inset Y
//   (canonical MenuPanel geometry, hover box included).
// - the two `Line` dividers (with their `ignoreChildProps` escapes) — the C
//   gap between the three captioned groups separates them (§7.7 default).
// The tool sections (PublishTools / SyncSuggestionsInPublish /
// ExportsInPublish) are shared read-only files still carrying their own
// legacy `margin: '- -Z2'` body-padding pull — neutralized per instance
// below at this consumption site; the shared files migrate with the
// bespoke-menus wave.
const $44f9019416e1d85f$export$cb51629418732a88 = {
    extends: 'MenuPanel',
    childExtends: 'Flex',
    width: 'G3',
    gap: 'C',
    textAlign: 'start',
    childProps: {
        flow: 'y',
        gap: 'A',
        CaptionTitle: {
            extends: [
                'CaptionTitle',
                'CanvasButton'
            ],
            padding: 'A A2',
            round: 'radiusControl',
            Text: {},
            Icon: {
                margin: '- - - auto',
                icon: (el, s)=>s.activeOutput === el.parent.parent.key ? 'arrow angle up' : 'arrow angle down'
            },
            onClick: (ev, el, s)=>s.update({
                    activeOutput: el.parent.key
                })
        },
        Section: {
            show: (el, s)=>s.activeOutput === el.parent.key
        }
    },
    Publish: {
        key: 'publish',
        CaptionTitle: {
            Text: {
                text: '{{ publish.action.publish | polyglot }}'
            }
        },
        Section: {
            extends: 'PublishTools',
            margin: '0'
        }
    },
    Sync: {
        key: 'sync',
        CaptionTitle: {
            Text: {
                text: '{{ publish.action.sync | polyglot }}'
            }
        },
        Section: {
            extends: 'SyncSuggestionsInPublish',
            margin: '0'
        }
    },
    Export: {
        key: 'export',
        CaptionTitle: {
            Text: {
                text: '{{ publish.action.export | polyglot }}'
            }
        },
        Section: {
            extends: 'ExportsInPublish',
            margin: '0'
        }
    }
};

});

parcelRegister("evNXA", function(module, exports) {

$parcel$export(module.exports, "SelectedLayerNavbar", () => $a90ab6f69d8b0b76$export$de7c879de145bf13);
const $a90ab6f69d8b0b76$export$de7c879de145bf13 = {
    if: (el)=>true,
    state: {
        value: {}
    },
    EditorTools: {
        padding: '0',
        margin: '0',
        hide: (el, s)=>s.isEditMode,
        gap: 'U',
        childExtends: 'NavbarButton',
        AddBtn: {
            order: '-1',
            icon: 'plus',
            title: (el)=>el.call('polyglot', 'editor.layerNavbar.addChildren'),
            onClick: (ev, el, s)=>{}
        },
        Remove: {
            icon: 'trash',
            title: (el)=>el.call('polyglot', 'common.action.remove')
        },
        TextNavbarButtonDropdown: {},
        ContextBtn: {
            icon: 'three dots vertical',
            title: (el)=>el.call('polyglot', 'editor.layerNavbar.options'),
            onClick: (ev, el, s)=>{
                el.activateContext(ev, s.key);
            },
            order: 3
        }
    },
    EditorPositionNavbar: null,
    NavbarButtonSet_title: null,
    NavbarButtonSet_meta: null,
    extends: 'EditNavbar',
    fontSize: 'Y2',
    position: 'absolute',
    bottom: '100%',
    margin: 'Z -',
    left: '50%',
    width: 'auto',
    transition: 'X opacity defaultBezier',
    padding: '0 X',
    round: 'radiusControl',
    top: 'auto',
    pointerEvents: 'auto',
    theme: 'common-box',
    // Card-outline on a floating island over live canvas content
    // (design-direction.md §8) — the prescribed separation for a floating
    // toolbar is elevation (DESIGN_LANGUAGE §2.3 `float`), not a stroke; same
    // fix as MainCanvasNavbar.js.
    shadow: 'float',
    transform: 'translate3d(-50%, 0, 1px)'
};

});

parcelRegister("3LvzD", function(module, exports) {

$parcel$export(module.exports, "getQuickEditorLayerRows", () => $2bde40c359690fca$export$9016000aa352e793);
$parcel$export(module.exports, "QuickEditor", () => $2bde40c359690fca$export$cf3f49582cb93bb8);
const $2bde40c359690fca$var$isLayer = (key, value)=>/^[A-Z]/.test(key) && value && typeof value === 'object' && !Array.isArray(value);
const $2bde40c359690fca$export$9016000aa352e793 = (value, type, ownerKey)=>{
    const rows = value && type && ownerKey ? [
        {
            key: '$root',
            label: 'editor.quick.root',
            depth: 0,
            hasChildren: false,
            isRoot: true,
            ownerType: type,
            ownerKey: ownerKey,
            path: [],
            textValue: value.text,
            colorValue: value.color,
            backgroundValue: value.background,
            paddingValue: value.padding,
            fontSizeValue: value.fontSize,
            flowValue: value.flow
        }
    ] : [];
    const collect = (obj, depth, path = [])=>{
        for (const key of Object.keys(obj || {}).filter((key)=>$2bde40c359690fca$var$isLayer(key, obj[key]))){
            const layer = obj[key];
            const layerPath = [
                ...path,
                key
            ];
            const hasChildren = Object.keys(layer).some((childKey)=>$2bde40c359690fca$var$isLayer(childKey, layer[childKey]));
            rows.push({
                key: layerPath.join('.'),
                label: key,
                depth: depth,
                hasChildren: hasChildren,
                ownerType: type,
                ownerKey: ownerKey,
                path: layerPath,
                textValue: layer.text,
                colorValue: layer.color,
                backgroundValue: layer.background,
                paddingValue: layer.padding,
                fontSizeValue: layer.fontSize,
                flowValue: layer.flow
            });
            if (hasChildren) collect(layer, depth + 1, layerPath);
        }
    };
    collect(value, 0);
    return rows;
};
const $2bde40c359690fca$export$cf3f49582cb93bb8 = {
    // FA204 / frank trap — every drag/inspector helper below lives in `scope`,
    // not module scope: a bare module-scope const/function silently reads as
    // undefined once this component is frank.toJSON'd for platform delivery
    // (workspace d6ea1142, project_frank_drops_module_local_helpers). Called
    // via `el.scope.<name>(...)` from any descendant factory/handler (`scope:`
    // merges onto every instance in this tree). Regular `function`/method
    // syntax throughout (not arrows) — `el.scope.foo()` binds `this` to
    // `el.scope`, so sibling helpers call each other via `this.<name>(...)`
    // instead of a bare identifier (object-literal properties can't see each
    // other as free variables). `isLayer`/`getQuickEditorLayerRows` are
    // duplicated here (module-scope originals stay for quickEditor.test.js's
    // offline import) — `Content.children` below reads whichever is
    // available, matching AppOrgSwitcher's `hide` dual-mode precedent.
    scope: {
        isLayer (key, value) {
            return /^[A-Z]/.test(key) && value && typeof value === 'object' && !Array.isArray(value);
        },
        getQuickEditorLayerRows (value, type, ownerKey) {
            const rows = value && type && ownerKey ? [
                {
                    key: '$root',
                    label: 'editor.quick.root',
                    depth: 0,
                    hasChildren: false,
                    isRoot: true,
                    ownerType: type,
                    ownerKey: ownerKey,
                    path: [],
                    textValue: value.text,
                    colorValue: value.color,
                    backgroundValue: value.background,
                    paddingValue: value.padding,
                    fontSizeValue: value.fontSize,
                    flowValue: value.flow
                }
            ] : [];
            const collect = (obj, depth, path = [])=>{
                for (const key of Object.keys(obj || {}).filter((key)=>this.isLayer(key, obj[key]))){
                    const layer = obj[key];
                    const layerPath = [
                        ...path,
                        key
                    ];
                    const hasChildren = Object.keys(layer).some((childKey)=>this.isLayer(childKey, layer[childKey]));
                    rows.push({
                        key: layerPath.join('.'),
                        label: key,
                        depth: depth,
                        hasChildren: hasChildren,
                        ownerType: type,
                        ownerKey: ownerKey,
                        path: layerPath,
                        textValue: layer.text,
                        colorValue: layer.color,
                        backgroundValue: layer.background,
                        paddingValue: layer.padding,
                        fontSizeValue: layer.fontSize,
                        flowValue: layer.flow
                    });
                    if (hasChildren) collect(layer, depth + 1, layerPath);
                }
            };
            collect(value, 0);
            return rows;
        },
        samePath (a = [], b = []) {
            return a.length === b.length && a.every((segment, index)=>segment === b[index]);
        },
        sameParentPath (a = [], b = []) {
            return this.samePath(a.slice(0, -1), b.slice(0, -1));
        },
        // Reviewed (border-habit sweep, design-direction.md §8): these three raw
        // style objects are OUT of the declarative border-habit class, kept as-is.
        // They're applied via `Object.assign(node.style, …)` to plain native DOM
        // nodes obtained from a live pointer-drag gesture (rowFromNode / cloneNode
        // below) — nodes DOMQL's token-resolving css-in-props layer never touches —
        // so `var(--color-line)` is the correct escape hatch here, not a bug: a
        // bare `'line'` string written straight to `.style` would be an invalid CSS
        // value. Functionally these are also a state affordance (dashed = "this is
        // being moved", solid = "this is the drop target"), the same family as the
        // sanctioned dashed state-ring, not decorative chrome.
        DRAG_SOURCE_STYLE: {
            background: 'var(--color-overlay)',
            opacity: '1',
            outlineColor: 'var(--color-line)',
            outlineStyle: 'dashed',
            outlineWidth: 'var(--spacing-X)',
            boxShadow: 'none',
            transform: 'none',
            zIndex: '1'
        },
        DROP_TARGET_STYLE: {
            background: 'var(--color-overlayStrong)',
            outlineColor: 'var(--color-line)',
            outlineStyle: 'solid',
            outlineWidth: 'var(--spacing-X)'
        },
        RESET_DRAG_STYLE: {
            background: '',
            opacity: '',
            outlineColor: '',
            outlineStyle: '',
            outlineWidth: '',
            boxShadow: '',
            transform: '',
            zIndex: ''
        },
        pathKey (path = []) {
            return path.join('');
        },
        layerRowKey (path = []) {
            return path.length ? encodeURIComponent(this.pathKey(path)) : '$root';
        },
        pathFromLayerRowKey (key) {
            return key && key !== '$root' ? decodeURIComponent(key).split('') : [];
        },
        restoreSourceRowContent (quickEditor) {
            for (const item of quickEditor?.data?.dragSourceHiddenNodes || [])if (item.node) item.node.style.visibility = item.visibility;
            if (quickEditor?.data) quickEditor.data.dragSourceHiddenNodes = null;
        },
        hideSourceRowContent (quickEditor, row) {
            this.restoreSourceRowContent(quickEditor);
            if (!row?.node) return;
            quickEditor.data.dragSourceHiddenNodes = [
                ...row.node.children
            ].map((node)=>{
                const visibility = node.style.visibility;
                node.style.visibility = 'hidden';
                return {
                    node: node,
                    visibility: visibility
                };
            });
        },
        restoreDragNodePosition (quickEditor) {
            const node = quickEditor?.data?.dragNode?.node;
            const parent = quickEditor?.data?.dragOriginalParent;
            const nextSibling = quickEditor?.data?.dragOriginalNextSibling;
            if (node && parent && node.parentNode !== parent) parent.insertBefore(node, nextSibling?.parentNode === parent ? nextSibling : null);
            else if (node && parent && nextSibling?.parentNode === parent && node.nextSibling !== nextSibling) parent.insertBefore(node, nextSibling);
        },
        removeDragGhost (quickEditor) {
            quickEditor?.data?.dragGhost?.remove?.();
            if (quickEditor?.data) {
                quickEditor.data.dragGhost = null;
                quickEditor.data.dragGhostOffset = null;
            }
        },
        moveDragGhost (quickEditor, event) {
            const ghost = quickEditor?.data?.dragGhost;
            const offset = quickEditor?.data?.dragGhostOffset;
            if (!ghost || !offset) return;
            ghost.style.transform = `translate3d(${event.clientX - offset.x}px, ${event.clientY - offset.y}px, 0)`;
        },
        createDragGhost (quickEditor, row, event) {
            if (typeof document === 'undefined' || !row?.node) return;
            this.removeDragGhost(quickEditor);
            const rect = row.node.getBoundingClientRect();
            const ghost = row.node.cloneNode(true);
            // Reviewed (border-habit sweep): same raw-DOM-write exception as
            // DRAG_SOURCE_STYLE/DROP_TARGET_STYLE above — this floating ghost clone is
            // also transient chrome over unpredictable live canvas content (the
            // canvas-glass exception's same reasoning), not a static declarative
            // surface, and `cloneNode`'d elements are outside css-in-props' reach too.
            Object.assign(ghost.style, {
                position: 'fixed',
                top: '0',
                left: '0',
                width: `${rect.width}px`,
                height: `${rect.height}px`,
                pointerEvents: 'none',
                boxSizing: 'border-box',
                zIndex: '2147483647',
                background: 'var(--color-overlayStrong)',
                borderColor: 'var(--color-line)',
                borderStyle: 'solid',
                borderWidth: 'var(--spacing-X)',
                borderRadius: 'var(--spacing-Z)',
                opacity: '0.92',
                willChange: 'transform'
            });
            quickEditor.data.dragGhost = ghost;
            quickEditor.data.dragGhostOffset = {
                x: event.clientX - rect.left,
                y: event.clientY - rect.top
            };
            document.body.appendChild(ghost);
            this.moveDragGhost(quickEditor, event);
        },
        resetDragNodes (quickEditor) {
            this.restoreSourceRowContent(quickEditor);
            quickEditor?.data?.dragNode?.setNodeStyles?.(this.RESET_DRAG_STYLE);
            quickEditor?.data?.dropNode?.setNodeStyles?.(this.RESET_DRAG_STYLE);
            this.removeDragGhost(quickEditor);
        },
        rowElement (el) {
            return el.parent || el;
        },
        rowFromNode (quickEditor, node) {
            const rowKey = node?.getAttribute?.('data-qe-layer-path');
            if (!rowKey) return null;
            const existing = quickEditor?.data?.layerRows?.[rowKey];
            if (existing?.el?.node === node) return existing;
            return {
                el: {
                    node: node,
                    setNodeStyles: (styles)=>Object.assign(node.style, styles)
                },
                type: node.getAttribute('data-qe-owner-type'),
                key: node.getAttribute('data-qe-owner-key'),
                path: this.pathFromLayerRowKey(rowKey),
                isRoot: node.getAttribute('data-qe-root') === '1'
            };
        },
        getRowUnderPointer (quickEditor, event) {
            const dragLayer = quickEditor?.data?.dragLayer;
            if (!dragLayer) return null;
            const nodes = Array.from(quickEditor?.Content?.node?.querySelectorAll?.('[data-qe-layer-path]') || []);
            const rows = nodes.map((node)=>this.rowFromNode(quickEditor, node)).filter((row)=>row?.el?.node && !row.isRoot && row.type === dragLayer.type && row.key === dragLayer.key && !this.samePath(row.path, dragLayer.path)).map((row)=>({
                    row: row,
                    rect: row.el.node.getBoundingClientRect()
                })).filter(({ rect: rect })=>rect.width || rect.height);
            if (!rows.length) return null;
            const pointerY = event.clientY;
            return rows.find(({ rect: rect })=>pointerY >= rect.top && pointerY <= rect.bottom)?.row || rows.reduce((closest, current)=>{
                const currentDistance = Math.abs(pointerY - (current.rect.top + current.rect.height / 2));
                return currentDistance < closest.distance ? {
                    row: current.row,
                    distance: currentDistance
                } : closest;
            }, {
                row: null,
                distance: Infinity
            }).row;
        },
        moveDragPlaceholder (quickEditor, row, position) {
            const dragNode = quickEditor?.data?.dragNode?.node;
            const targetNode = row?.el?.node;
            if (!dragNode || !targetNode || dragNode === targetNode || dragNode.parentNode !== targetNode.parentNode) return;
            if (position === 'after') targetNode.after(dragNode);
            else targetNode.before(dragNode);
        },
        getDropPosition (row, event) {
            const rect = row?.el?.node?.getBoundingClientRect?.();
            if (!rect) return 'before';
            return event.clientY > rect.top + rect.height / 2 ? 'after' : 'before';
        },
        setDropLayerFromRow (quickEditor, row, event) {
            const dragLayer = quickEditor?.data?.dragLayer;
            if (!dragLayer || !row || row.isRoot) return false;
            if (dragLayer.key !== row.key || dragLayer.type !== row.type || this.pathKey(dragLayer.path) === this.pathKey(row.path)) {
                quickEditor.data.dropLayer = null;
                quickEditor.data.dropNode?.setNodeStyles?.(this.RESET_DRAG_STYLE);
                quickEditor.data.dropNode = null;
                return false;
            }
            if (quickEditor.data.dropNode !== row.el) {
                quickEditor.data.dropNode?.setNodeStyles?.(this.RESET_DRAG_STYLE);
                quickEditor.data.dropNode = row.el;
            }
            quickEditor.data.dropLayer = {
                type: row.type,
                key: row.key,
                path: [
                    ...row.path
                ],
                position: event ? this.getDropPosition(row, event) : 'before'
            };
            this.moveDragPlaceholder(quickEditor, row, quickEditor.data.dropLayer.position);
            row.el?.setNodeStyles?.(this.DROP_TARGET_STYLE);
            return true;
        },
        updateDropLayerFromPointer (event, quickEditor) {
            return this.setDropLayerFromRow(quickEditor, this.getRowUnderPointer(quickEditor, event), event);
        },
        getDraggedSiblingOrder (quickEditor) {
            const dragLayer = quickEditor?.data?.dragLayer;
            const parentNode = quickEditor?.data?.dragNode?.node?.parentNode;
            if (!dragLayer || !parentNode) return null;
            const rows = Array.from(parentNode.children).map((node)=>node.getAttribute?.('data-qe-layer-path')).map((key, index)=>key ? this.rowFromNode(quickEditor, parentNode.children[index]) : null).filter((row)=>row?.path?.length && row.type === dragLayer.type && row.key === dragLayer.key && this.sameParentPath(row.path, dragLayer.path));
            return rows.length ? rows.map((row)=>[
                    ...row.path
                ]) : null;
        },
        setDropLayer (event, el, s) {
            const quickEditor = el.call('getQuickEditor');
            if (!quickEditor?.data?.dragLayer || s.isRoot) return false;
            event.preventDefault?.();
            event.stopPropagation?.();
            this.setDropLayerFromRow(quickEditor, {
                el: el,
                type: s.ownerType,
                key: s.ownerKey,
                path: [
                    ...s.path
                ],
                isRoot: !!s.isRoot
            }, event);
            return false;
        },
        closeLayerInspector (el) {
            const quickEditor = el.call('getQuickEditor');
            if (!quickEditor?.data) return;
            quickEditor.data.activeLayer = null;
            quickEditor.setCanvasScope({
                activeLayer: null
            });
            quickEditor.LayerInspector?.setNodeStyles({
                display: 'none'
            });
            const fields = quickEditor.LayerInspector?.Fields;
            for (const field of [
                'Text',
                'Color',
                'Background',
                'Padding',
                'FontSize',
                'Flow'
            ]){
                const input = fields?.[field]?.Input?.node;
                if (input) input.value = '';
            }
        },
        async finishLayerPointerDrag (event, el) {
            const quickEditor = el.call('getQuickEditor');
            const dragLayer = quickEditor?.data?.dragLayer;
            if (!quickEditor?.data) return;
            this.updateDropLayerFromPointer(event, quickEditor);
            const dropLayer = quickEditor.data.dropLayer;
            quickEditor.data.dragCleanup?.();
            quickEditor.data.dragCleanup = null;
            this.resetDragNodes(quickEditor);
            let saved = false;
            if (dragLayer?.path?.length && dropLayer?.path?.length && dragLayer.type === dropLayer.type && dragLayer.key === dropLayer.key && !this.samePath(dragLayer.path, dropLayer.path)) saved = await el.call('reorderQuickEditorLayer', dropLayer.path, dropLayer.position, this.sameParentPath(dragLayer.path, dropLayer.path) ? this.getDraggedSiblingOrder(quickEditor) : null);
            if (!saved) this.restoreDragNodePosition(quickEditor);
            quickEditor.data.dragLayer = null;
            quickEditor.data.dropLayer = null;
            quickEditor.data.dragNode = null;
            quickEditor.data.dropNode = null;
            quickEditor.data.dragOriginalParent = null;
            quickEditor.data.dragOriginalNextSibling = null;
        },
        startLayerPointerDrag (event, el, s) {
            if (s.isRoot || event.button !== 0) return;
            const quickEditor = el.call('getQuickEditor');
            if (!quickEditor) return;
            event.stopPropagation?.();
            event.preventDefault?.();
            const row = this.rowElement(el);
            this.resetDragNodes(quickEditor);
            quickEditor.data.dragLayer = {
                type: s.ownerType,
                key: s.ownerKey,
                path: [
                    ...s.path
                ]
            };
            quickEditor.data.dropLayer = null;
            quickEditor.data.dragNode = row;
            quickEditor.data.dropNode = null;
            quickEditor.data.dragOriginalParent = row.node?.parentNode || null;
            quickEditor.data.dragOriginalNextSibling = row.node?.nextSibling || null;
            this.createDragGhost(quickEditor, row, event);
            row.setNodeStyles?.(this.DRAG_SOURCE_STYLE);
            this.hideSourceRowContent(quickEditor, row);
            if (typeof document !== 'undefined') {
                const onPointerMove = (moveEvent)=>{
                    this.moveDragGhost(quickEditor, moveEvent);
                    this.updateDropLayerFromPointer(moveEvent, quickEditor);
                };
                const onPointerUp = (upEvent)=>{
                    document.removeEventListener('pointermove', onPointerMove, true);
                    this.updateDropLayerFromPointer(upEvent, quickEditor);
                    this.finishLayerPointerDrag(upEvent, row);
                };
                quickEditor.data.dragCleanup = ()=>{
                    document.removeEventListener('pointermove', onPointerMove, true);
                };
                document.addEventListener('pointermove', onPointerMove, true);
                document.addEventListener('pointerup', onPointerUp, {
                    once: true,
                    capture: true
                });
            }
        }
    },
    state: {
        recents: [],
        recentsIndex: 0,
        showLayers: true
    },
    data: {
        prevSelected: null,
        activeLayer: null,
        needsRefresh: false,
        pendingDelete: null,
        dragLayer: null,
        dropLayer: null,
        dragCleanup: null,
        dragGhost: null,
        dragGhostOffset: null,
        dragSourceHiddenNodes: null,
        dragOriginalParent: null,
        dragOriginalNextSibling: null,
        layerRows: null
    },
    Header: {
        flow: 'x',
        align: 'center start',
        padding: 'Y Y1',
        gap: 'Z',
        width: '100%',
        Text: {
            tag: 'span',
            fontSize: 'Z2',
            maxWidth: '65%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        QuickEditorNavbar: {
            margin: '- - - auto'
        }
    },
    Content: {
        tag: 'div',
        class: 'layers',
        fontSize: 'A1',
        overflow: 'hidden auto',
        maxHeight: 'max(120px, min(42dvh, calc(100dvh - 300px)))',
        padding: '0 Y1 Y1',
        childrenAs: 'state',
        children: (el)=>{
            const selected = el.getSelectedKey();
            const project = el.getRootState('data');
            const type = Object.hasOwn(project?.components || {}, selected) ? 'components' : Object.hasOwn(project?.pages || {}, selected) ? 'pages' : null;
            const value = type ? project[type][selected] : {};
            // Dual-mode read (AppOrgSwitcher `hide` precedent): the live/frank-
            // served tree always has `el.scope`, so it takes the scoped copy; the
            // module-scope `getQuickEditorLayerRows` fallback only fires when this
            // factory is called directly with a fake `el` (quickEditor.test.js
            // `QuickEditor.Content.children({...})`, no `.scope`).
            return el.scope?.getQuickEditorLayerRows ? el.scope.getQuickEditorLayerRows(value, type, selected) : $2bde40c359690fca$export$9016000aa352e793(value, type, selected);
        },
        childProps: {
            position: 'relative',
            flow: 'x',
            align: 'center',
            width: '100%',
            paddingLeft: (el, s)=>`${6 + s.depth * 12}px`,
            round: 'radiusControl',
            role: 'treeitem',
            draggable: false,
            userSelect: 'none',
            attr: {
                'data-qe-layer-path': (el, s)=>el.scope.layerRowKey(s.path),
                'data-qe-owner-key': (el, s)=>s.ownerKey || '',
                'data-qe-owner-type': (el, s)=>s.ownerType || '',
                'data-qe-root': (el, s)=>s.isRoot ? '1' : '0'
            },
            onRender: (el, s)=>{
                const quickEditor = el.call('getQuickEditor');
                if (!quickEditor?.data) return;
                if (!quickEditor.data.layerRows) quickEditor.data.layerRows = {};
                quickEditor.data.layerRows[el.scope.layerRowKey(s.path)] = {
                    el: el,
                    type: s.ownerType,
                    key: s.ownerKey,
                    path: [
                        ...s.path
                    ],
                    isRoot: !!s.isRoot
                };
            },
            opacity: (el, s)=>{
                const dragLayer = el.call('getQuickEditor')?.data?.dragLayer;
                return dragLayer?.key === s.ownerKey && dragLayer?.path?.join('.') === s.path?.join('.') ? '0.45' : '1';
            },
            // Real bug found while sweeping (adjacent to the border-habit class,
            // design-direction.md §8/§4.3): this row was using the `line` stroke
            // token as a STATE FILL for both the drop-target indicator and hover —
            // `line` (`gray13`/`gray5`) is a strong, opaque rule colour, not a
            // wash, so on light theme this rendered as a heavy flat-gray block
            // instead of a subtle tint. Corrected to the canonical state tokens
            // (§8.1): `selected` for "this row is the active drop target",
            // `hover` for pointer hover.
            background: (el, s)=>{
                const dropLayer = el.call('getQuickEditor')?.data?.dropLayer;
                return dropLayer?.key === s.ownerKey && dropLayer?.path?.join('.') === s.path?.join('.') ? 'selected' : 'transparent';
            },
            ':hover': {
                background: 'hover'
            },
            onPointerEnter: (event, el, s)=>el.scope.setDropLayer(event, el, s),
            DragHandle: {
                tag: 'button',
                type: 'button',
                display: (el, s)=>s.isRoot ? 'none' : 'inline-flex',
                align: 'center center',
                flex: '0 0 auto',
                boxSize: 'A A',
                margin: '- X - -',
                padding: '0',
                border: '0',
                background: 'transparent',
                color: 'caption',
                opacity: '0.72',
                cursor: 'grab',
                title: (el)=>el.call('polyglot', 'editor.quick.dragToReorder'),
                aria: {
                    label: (el, s)=>el.call('polyglot', 'editor.quick.dragLayer').replace('{layer}', el.call('polyglot', s.label || ''))
                },
                text: "\u283F",
                lineHeight: '1',
                fontSize: 'Z1',
                onPointerDown: (event, el, s)=>el.scope.startLayerPointerDrag(event, el, s),
                ':hover': {
                    color: 'title',
                    opacity: '1'
                },
                ':active': {
                    cursor: 'grabbing'
                }
            },
            Layer: {
                tag: 'button',
                type: 'button',
                flex: '1',
                padding: 'Y Z',
                border: '0',
                background: 'transparent',
                color: 'paragraph',
                textAlign: 'left',
                cursor: 'pointer',
                text: (el, s)=>`${s.isRoot ? "\u25C9" : s.hasChildren ? "\u25B8" : "\xb7"} ${el.call('polyglot', s.label || '')}`,
                draggable: false,
                onClick: (event, el, s)=>{
                    const quickEditor = el.call('getQuickEditor');
                    if (!quickEditor) return;
                    quickEditor.data.activeLayer = {
                        type: s.ownerType,
                        key: s.ownerKey,
                        path: s.path
                    };
                    quickEditor.setCanvasScope({
                        activeLayer: s.path
                    });
                    const inspector = quickEditor.LayerInspector;
                    inspector?.setNodeStyles({
                        display: 'flex'
                    });
                    if (inspector?.Header?.Title?.node) inspector.Header.Title.node.textContent = s.label;
                    const fields = inspector?.Fields;
                    const values = {
                        Text: s.textValue,
                        Color: s.colorValue,
                        Background: s.backgroundValue,
                        Padding: s.paddingValue,
                        FontSize: s.fontSizeValue,
                        Flow: s.flowValue
                    };
                    for (const [field, value] of Object.entries(values)){
                        const input = fields?.[field]?.Input?.node;
                        if (input) input.value = value || '';
                    }
                }
            },
            Delete: {
                extends: 'IconButton',
                icon: 'crossmark',
                title: (el, s)=>el.call('polyglot', 'editor.quick.deleteLayer').replace('{layer}', el.call('polyglot', s.label || '')),
                aria: {
                    label: (el, s)=>el.call('polyglot', 'editor.quick.deleteLayer').replace('{layer}', el.call('polyglot', s.label || ''))
                },
                margin: '- Y - -',
                opacity: '0.6',
                display: (el, s)=>s.isRoot ? 'none' : 'inline-flex',
                onClick: (event, el, s)=>{
                    event.stopPropagation();
                    const quickEditor = el.call('getQuickEditor');
                    const popup = quickEditor?.DeleteConfirm;
                    if (!quickEditor || !popup) return;
                    quickEditor.data.pendingDelete = {
                        type: s.ownerType,
                        key: s.ownerKey,
                        path: [
                            ...s.path
                        ],
                        label: s.label
                    };
                    if (popup.Text?.node) popup.Text.node.textContent = el.call('polyglot', 'editor.quickEditor.deleteConfirm').replace('{name}', s.label || '');
                    const editorRect = quickEditor.node?.getBoundingClientRect?.();
                    const buttonRect = el.node?.getBoundingClientRect?.();
                    const top = editorRect && buttonRect ? Math.min(buttonRect.bottom - editorRect.top, editorRect.height - 120) : 0;
                    popup.setNodeStyles({
                        display: 'flex',
                        top: `${Math.max(0, top)}px`
                    });
                }
            }
        }
    },
    DeleteConfirm: {
        display: 'none',
        position: 'absolute',
        right: 'Y',
        zIndex: '2',
        flow: 'y',
        gap: 'Y',
        width: 'G',
        padding: 'Z',
        round: 'radiusControl',
        // Fill-contrast popup (was a `line` border — border-habit sweep,
        // design-direction.md §8) — `theme: 'common-box'`'s own opaque fill +
        // the `overlay` elevation shadow already separate it from the canvas.
        theme: 'common-box',
        shadow: 'overlay',
        Text: {
            tag: 'span',
            text: '{{ editor.quick.deleteConfirm | polyglot }}'
        },
        Actions: {
            flow: 'x',
            gap: 'Y',
            align: 'center end',
            Cancel: {
                extends: 'Button',
                text: '{{ common.action.cancel | polyglot }}',
                theme: 'secondary',
                padding: 'Y Z',
                onClick: (event, el)=>{
                    event.stopPropagation();
                    const quickEditor = el.call('getQuickEditor');
                    if (quickEditor?.data) quickEditor.data.pendingDelete = null;
                    quickEditor?.DeleteConfirm?.setNodeStyles({
                        display: 'none'
                    });
                }
            },
            Confirm: {
                extends: 'Button',
                text: '{{ common.action.delete | polyglot }}',
                theme: 'secondary',
                color: 'red',
                padding: 'Y Z',
                onClick: async (event, el)=>{
                    event.stopPropagation();
                    const quickEditor = el.call('getQuickEditor');
                    const target = quickEditor?.data?.pendingDelete;
                    if (!target) return;
                    quickEditor.data.pendingDelete = null;
                    quickEditor.DeleteConfirm?.setNodeStyles({
                        display: 'none'
                    });
                    await el.call('deleteQuickEditorLayer', target.type, target.key, target.path);
                }
            }
        }
    },
    AddControls: {
        flow: 'y',
        gap: 'Y',
        padding: 'Z Y1 Y1',
        // Top divider removed (border-habit sweep, design-direction.md §8) —
        // this panel's own `theme: 'common-box'` fill (declared at the QuickEditor
        // root) already separates every section; padding carries the rest.
        Label: {
            tag: 'span',
            text: '{{ editor.quick.addElement | polyglot }}',
            color: 'caption',
            fontSize: 'Y2'
        },
        Buttons: {
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Y',
            childProps: {
                extends: 'Button',
                theme: 'secondary',
                padding: 'Y Z'
            },
            Container: {
                text: '{{ editor.quick.el.container | polyglot }}',
                onClick: (ev, el)=>el.call('addQuickEditorLayer', 'container')
            },
            Heading: {
                text: '{{ editor.quick.el.heading | polyglot }}',
                onClick: (ev, el)=>el.call('addQuickEditorLayer', 'heading')
            },
            Text: {
                text: '{{ editor.quick.el.text | polyglot }}',
                onClick: (ev, el)=>el.call('addQuickEditorLayer', 'text')
            },
            Button: {
                text: '{{ editor.quick.el.button | polyglot }}',
                onClick: (ev, el)=>el.call('addQuickEditorLayer', 'button')
            }
        }
    },
    LayerInspector: {
        display: 'none',
        flow: 'y',
        gap: 'Z',
        padding: 'Z Y1 Y1',
        overflow: 'hidden auto',
        maxHeight: 'max(160px, calc(100dvh - 460px))',
        // Top divider removed (border-habit sweep, design-direction.md §8) —
        // same reasoning as AddControls above.
        Header: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            Title: {
                tag: 'span',
                text: '{{ editor.quick.properties | polyglot }}',
                fontWeight: '700',
                flex: '1'
            },
            Collapse: {
                extends: 'IconButton',
                icon: 'arrow angle down',
                title: (el)=>el.call('polyglot', 'editor.quick.hideProperties'),
                aria: {
                    label: (el)=>el.call('polyglot', 'editor.quick.hideProperties')
                },
                margin: '- - - auto',
                opacity: '0.72',
                onClick: (event, el)=>{
                    event.preventDefault();
                    event.stopPropagation();
                    el.scope.closeLayerInspector(el);
                },
                // Same `line`-as-state-fill bug as Content.childProps above —
                // corrected to the canonical `hover` token.
                ':hover': {
                    opacity: '1',
                    background: 'hover'
                }
            }
        },
        Fields: {
            flow: 'y',
            gap: 'Y',
            childProps: {
                flow: 'y',
                gap: 'X',
                Label: {
                    tag: 'label',
                    color: 'caption',
                    fontSize: 'Y2'
                },
                Input: {
                    tag: 'input',
                    width: '100%',
                    padding: 'Y Z',
                    round: 'radiusControl',
                    // Real bug found while sweeping (border-habit, design-direction.md
                    // §8): `background: 'field'` is not a colour token (`field` is
                    // only a THEME name, in company/packages/brand/designSystem/
                    // theme.js — the sole such use in this package) so it never
                    // resolved, and the hand-rolled `line` border was standing in for
                    // the branded field's own border. `theme: 'field'` is the real
                    // component (§2.5 exception #4 — field keeps its own border,
                    // matching IntegrationConfigureForm's SecretField.Input/
                    // DisplayName.Input in this same sweep).
                    theme: 'field',
                    color: 'title'
                }
            },
            Text: {
                Label: {
                    text: '{{ editor.quick.field.text | polyglot }}'
                },
                Input: {
                    placeholder: (el)=>el.call('polyglot', 'editor.quick.field.textPlaceholder'),
                    onChange: (ev, el)=>el.call('updateQuickEditorLayer', 'text', ev.target.value)
                }
            },
            Color: {
                Label: {
                    text: '{{ editor.quick.field.color | polyglot }}'
                },
                Input: {
                    placeholder: "title, blue, #fff\u2026",
                    onChange: (ev, el)=>el.call('updateQuickEditorLayer', 'color', ev.target.value)
                }
            },
            Background: {
                Label: {
                    text: '{{ editor.quick.field.background | polyglot }}'
                },
                Input: {
                    placeholder: "document, gray3\u2026",
                    onChange: (ev, el)=>el.call('updateQuickEditorLayer', 'background', ev.target.value)
                }
            },
            Padding: {
                Label: {
                    text: '{{ editor.quick.field.padding | polyglot }}'
                },
                Input: {
                    placeholder: "Z, A, Y Z\u2026",
                    onChange: (ev, el)=>el.call('updateQuickEditorLayer', 'padding', ev.target.value)
                }
            },
            FontSize: {
                Label: {
                    text: '{{ editor.quick.field.fontSize | polyglot }}'
                },
                Input: {
                    placeholder: "Z1, A, B\u2026",
                    onChange: (ev, el)=>el.call('updateQuickEditorLayer', 'fontSize', ev.target.value)
                }
            },
            Flow: {
                Label: {
                    text: '{{ editor.quick.field.flow | polyglot }}'
                },
                Input: {
                    placeholder: "x, y, x wrap\u2026",
                    onChange: (ev, el)=>el.call('updateQuickEditorLayer', 'flow', ev.target.value)
                }
            }
        }
    },
    PromptAI: {
        margin: 'auto - -',
        order: 2,
        hide: true
    },
    flow: 'y',
    gap: '0',
    position: 'absolute',
    top: 'C+X2',
    padding: '0',
    left: '--canvas-gutter',
    round: 'radiusControl',
    // Fill-contrast panel (was a `line` border — border-habit sweep,
    // design-direction.md §8) — `theme: 'common-box'` already supplies its own
    // opaque fill, same precedent as DynamicIsland (this floats over the
    // canvas the same way).
    theme: 'common-box',
    minWidth: 'H',
    width: 'H',
    maxHeight: 'calc(100dvh - 96px)',
    overflow: 'hidden',
    overscrollBehavior: 'contain',
    fontSize: 'Y2',
    opacity: '0',
    onRender: (el)=>{
        el.node.style.opacity = '0';
        el.node.style.pointerEvents = 'none';
        const resetInspector = ()=>{
            el.data.activeLayer = null;
            el.setCanvasScope({
                activeLayer: null
            });
            const inspector = el.LayerInspector;
            inspector?.setNodeStyles({
                display: 'none'
            });
            const fields = inspector?.Fields;
            for (const field of [
                'Text',
                'Color',
                'Background',
                'Padding',
                'FontSize',
                'Flow'
            ]){
                const input = fields?.[field]?.Input?.node;
                if (input) input.value = '';
            }
        };
        setInterval(()=>{
            if (!el.node) return;
            const selected = el.getSelectedKey();
            const editorActive = el.getCanvasScope('editorActive');
            if (!selected || editorActive === false) {
                if (!selected && editorActive !== false) el.setCanvasScope({
                    editorActive: false
                });
                if (el.node.style.opacity !== '0') {
                    el.node.style.opacity = '0';
                    el.node.style.pointerEvents = 'none';
                }
                if (el.data.prevSelected) el.data.prevSelected = null;
                if (el.data.activeLayer) resetInspector();
                return;
            }
            if (el.node.style.opacity === '0') {
                el.node.style.opacity = '1';
                el.node.style.pointerEvents = '';
            }
            const selectedChanged = selected !== el.data.prevSelected;
            if (selectedChanged) {
                const selectedEl = el.getSelected();
                if (selectedEl?.state?.parse) {
                    resetInspector();
                    const textEl = el.Header?.Text;
                    if (textEl?.node) textEl.node.textContent = selected;
                    el.data.prevSelected = selected;
                }
            }
            el.data.needsRefresh = false;
        }, 100);
    }
};

});

parcelRegister("iMFJ7", function(module, exports) {

$parcel$export(module.exports, "FileItem", () => $dacd13bd3bcd7344$export$a964e6adf466d4a6);
const $dacd13bd3bcd7344$export$a964e6adf466d4a6 = {
    data: {},
    Span: {
        order: '-1',
        class: 'dot',
        boxSize: '1.618ch',
        text: "\u30FB",
        color: 'placeholder',
        position: 'relative',
        textDecoration: 'none',
        hasError: (el, s)=>{
            if (!el.call('hasArtboard', s.type)) return false;
            const item = el.call('getItem', s.key);
            return Boolean(item?.state?.error);
        },
        '.hasError': {
            color: 'red'
        },
        Icon: {
            left: 0,
            top: 0,
            position: 'absolute',
            color: 'placeholder',
            name: (el, s)=>`arrow angle ${s.showLayers ? 'down' : 'right'}`,
            visibility: 'hidden',
            opacity: 0,
            transition: 'A defaultBezier',
            transitionProperty: 'opacity, transform',
            hasLayers: (el, s)=>Boolean(el.call('hasArtboard', s.type)),
            '!hasLayers': {
                pointerEvents: 'none'
            },
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                ev.preventDefault();
                if (!el.call('hasArtboard', s.type)) return;
                // Check for Ctrl+Click or Cmd+Click (Mac)
                const isCtrlOrCmdClick = ev && (ev.ctrlKey || ev.metaKey);
                if (isCtrlOrCmdClick) // Expand all nested layers recursively
                el.call('expandAllLayersForParentComponent', el, s);
                else // Normal click - just toggle
                s.update({
                    showLayers: !s.showLayers
                });
            }
        }
    },
    Text: {
        class: 'text',
        show: (el, s)=>!s.editing,
        text: '{{ key }}',
        maxWidth: '65%',
        overflow: 'hidden',
        padding: '.1em - .1em',
        position: 'relative',
        textOverflow: 'ellipsis'
    },
    EditCode: {
        extends: 'NavbarButton',
        if: (el)=>el.isEditMode(),
        hide: (el, s)=>s.editing || !el.call('hasArtboard', s.type),
        class: 'layer-controls',
        padding: 'Y',
        margin: '-W -Y -W auto',
        icon: 'code',
        ariaLabel: (el)=>el.call('polyglot', 'editor.sidebar.editCode'),
        onClick: (ev, el, s)=>{
            ev.preventDefault();
            ev.stopPropagation();
            el.setWindow('componentEditor', 'code');
            el.activateSelected(s.key);
        }
    },
    Rename: {
        extends: 'FileSidebarAddNewItem',
        show: (el, s)=>Boolean(s.editing),
        flex: 1,
        Label: {
            margin: '0 0 0 -1.4em',
            padding: '0 0 0 1.4em',
            Icon: null,
            Input: {
                flex: 1,
                value: (el, s)=>s.key,
                name: 'new-key',
                onInput: ()=>{}
            },
            Flex: {
                Save: {
                    type: 'submit'
                },
                Close: {
                    onClick: (ev, el, s)=>{
                        ev.preventDefault();
                        ev.stopPropagation();
                        s.update({
                            editing: false
                        });
                    }
                }
            },
            Err: {
                whiteSpace: 'pre-line',
                padding: 'X Y',
                theme: 'modal',
                round: 'X',
                fontSize: 'Y2',
                position: 'static'
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            el.node.reset();
            s.update({
                editing: false,
                key: newKey
            });
        }
    },
    content: (el, s)=>{
        if (!s.value) return;
        if (!s.showLayers || !el.call('hasArtboard', s.type)) return {
            hide: true
        };
        return {
            extends: 'Layers',
            minWidth: '100%',
            margin: '-Z2 - - -B',
            flex: 1,
            onClick: (ev)=>ev.stopPropagation()
        };
    },
    extends: 'Button',
    position: 'relative',
    padding: 'Y Y1',
    zIndex: '1',
    theme: 'transparent',
    isActive: (el, s)=>s.showLayers,
    isCurrent: (el, s)=>s.key === el.getSelectedKey(),
    width: '100%',
    align: 'center start',
    flow: 'x wrap',
    userSelect: 'none',
    gap: 'Z',
    round: 'radiusControl',
    draggable: (el, s)=>!s.showLayers && el.call('hasArtboard', s.type),
    dragstart: {
        transform: 'scale(0.97)',
        opacity: '0',
        isDragging: true
    },
    onDragstart: (ev, el, s)=>{
        if (s.showLayers || !el.call('hasArtboard', s.type)) return;
        ev.stopPropagation();
        if (ev.dataTransfer) {
            ev.dataTransfer.setData('text/component-key', s.key);
            ev.dataTransfer.effectAllowed = 'move';
        }
        if (!el.parent.data) el.parent.data = {};
        el.update(el.dragstart);
        el.parent.data.fromIndex = el.key;
        el.parent.data.state = s.parent;
    },
    onDragover: (ev, el, s)=>{
        if (s.showLayers || !el.call('hasArtboard', s.type)) return;
        ev.stopPropagation();
        ev.preventDefault();
        if (!el.parent.data) return;
        return false;
    },
    drop: {
        opacity: '1',
        transform: 'none'
    },
    onDrop: (ev, el, s)=>{
        if (s.showLayers || !el.call('hasArtboard', s.type)) return;
        if (!el.parent.data) return;
        el.call('reorderComponents', ev);
    },
    dragend: {
        opacity: '1',
        transform: 'none',
        isDragging: false
    },
    onDragend: (e, el, s)=>{
        el.update(el.dragend);
    },
    ':hover .dot': {
        color: 'transparent',
        '& svg': {
            opacity: 1,
            visibility: 'visible'
        }
    },
    ':hover .layer-controls': {
        opacity: 1
    },
    // The `.dot` swap above is the ONLY way to reach the expand/collapse arrow:
    // the arrow ships `visibility: hidden` + `opacity: 0` at rest and the bullet
    // is only dimmed out by the hover rule. Since smbls e3333d298 wraps every
    // `:hover` rule in `@media (hover: hover)`, that swap never runs on touch, so
    // a phone/tablet could never expand a component's layers. Mirror it for
    // coarse pointers; fine pointers keep the reveal-on-hover behaviour.
    // (`.layer-controls` needs no mirror — those buttons carry no hidden rest
    // state, so the rule above is a no-op in both pointer modes.)
    '@coarse': {
        '.dot': {
            color: 'transparent',
            '& svg': {
                opacity: 1,
                visibility: 'visible'
            }
        }
    },
    ':after': {
        content: '""',
        borderStyle: 'solid',
        borderColor: 'dim',
        borderWidth: '0 0 0 0',
        position: 'absolute',
        inset: '-W auto -W -Z'
    },
    '.isActive': {
        theme: 'layer',
        '& .dot': {
            color: 'transparent',
            '& svg': {
                opacity: 1,
                visibility: 'visible'
            }
        },
        '.isCurrent': {
            theme: 'field'
        },
        '& .layer-controls': {
            opacity: 1
        }
    },
    '!isActive': {
        color: 'caption',
        fontWeight: 400,
        opacity: '.85',
        '.isCurrent': {
            theme: 'field'
        },
        '& .layer-controls': {
            opacity: 0
        }
    },
    sidebarItem: true
};

});

parcelRegister("4oHg5", function(module, exports) {

$parcel$export(module.exports, "QuickEditorNavbar", () => $333af58df8f7f1aa$export$ebb8fd26c6d9e82);
const $333af58df8f7f1aa$export$ebb8fd26c6d9e82 = {
    Back: {
        icon: 'arrow angle left',
        ariaLabel: (el)=>el.call('polyglot', 'common.action.back'),
        hasBack: (el, s)=>{
            return s.recentsIndex < s.recents.length - 1;
        },
        '!hasBack': {
            opacity: '0.35',
            pointerEvents: 'none'
        },
        onClick: (ev, el, s)=>{
            const recents = s.recents;
            s.recentsIndex++;
            const prev = recents?.[s.recentsIndex];
            if (prev) el.setWindow('explorer', prev, {
                skipRecentsIndexing: true
            });
        }
    },
    Forward: {
        icon: 'arrow angle right',
        ariaLabel: (el)=>el.call('polyglot', 'common.action.forward'),
        hasForward: (el, s)=>{
            return s.recentsIndex > 0;
        },
        '!hasForward': {
            opacity: '0.35',
            pointerEvents: 'none'
        },
        onClick: (ev, el, s)=>{
            const recents = s.recents;
            s.recentsIndex--;
            const next = recents?.[s.recentsIndex];
            if (next) el.setWindow('explorer', next, {
                skipRecentsIndexing: true
            });
        }
    },
    Close: {
        icon: 'crossmark',
        ariaLabel: (el)=>el.call('polyglot', 'common.action.close'),
        onClick: (ev, el)=>{
            el.getCanvasScope().editorActive = false;
        }
    },
    extends: 'NavbarButtonSet',
    padding: '0',
    childProps: {
        padding: 'Y'
    },
    gap: 'W',
    fontSize: 'Z2'
};

});

parcelRegister("bSKEi", function(module, exports) {

$parcel$export(module.exports, "FilesSectionTitle", () => $8a68ec586eca043f$export$72f1c110d94c44ca);
const $8a68ec586eca043f$export$72f1c110d94c44ca = {
    tag: 'header',
    IconButton_arrow: {
        isVisible: (el, s)=>el.call('getCookie', `sidebar_${s.type}`) !== 'false',
        transition: 'A defaultBezier opacity',
        margin: '- -Y - -A1',
        // eslint-disable-next-line no-restricted-syntax -- expand/collapse chevron icon, not text
        color: 'inactive',
        fontSize: 'Z2',
        // margin: '- - - auto',
        background: 'transparent',
        theme: null,
        opacity: (el, s)=>el.call('getCookie', `sidebar_${s.type}`) !== 'false' ? 0 : 1,
        icon: (el, s)=>`arrow angle ${el.call('getCookie', `sidebar_${s.type}`) !== 'false' ? 'down' : 'right'}`,
        aria: {
            label: (el, s)=>el.call('getCookie', `sidebar_${s.type}`) !== 'false' ? 'Collapse section' : 'Expand section'
        },
        onClick: (ev, el, s)=>{
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            el.call('setCookie', `sidebar_${s.type}`, !isVisible);
            s.update();
        }
    },
    Span: {
        extends: [
            'CaptionTitle',
            'Flex'
        ],
        margin: 'W auto - -',
        ':hover': {
            color: 'paragraph'
        },
        Text: {
            text: (el, s)=>s.type?.replace('_', ' ')
        },
        onClick: (ev, el, s)=>{
            const isVisible = el.call('getCookie', `sidebar_${s.type}`) !== 'false';
            el.call('setCookie', `sidebar_${s.type}`, !isVisible);
            s.update();
        }
    },
    'NavbarButton.question': {
        transition: 'A defaultBezier opacity',
        color: 'disabled',
        icon: 'question mark',
        title: (el)=>el.call('polyglot', 'editor.zoombar.docs'),
        fontSize: 'Z2',
        onClick: (ev, el, s)=>{
            ev.preventDefault();
            ev.stopPropagation();
            el.setWindow('docs', '/' + s.type);
        }
    },
    extends: 'Navbar',
    top: 0,
    zIndex: 2,
    position: 'sticky',
    minWidth: '100%',
    userSelect: 'none',
    theme: 'common-box',
    align: 'center',
    margin: '- -Y1',
    padding: '- Y1',
    fontSize: 'Z2'
};

});

parcelRegister("9JGG7", function(module, exports) {

$parcel$export(module.exports, "FilesSection", () => $71696c11d62a441a$export$fcea42f222a3cf63);
const $71696c11d62a441a$export$fcea42f222a3cf63 = {
    FilesSectionTitle: {},
    FilesSectionList: {
        margin: '- -Y'
    },
    flow: 'column',
    padding: '- - X2',
    gap: 'X2',
    ':hover': {
        '& header > button, & header > a': {
            opacity: 1
        }
    }
};

});

parcelRegister("g5HV1", function(module, exports) {

$parcel$export(module.exports, "FilesSectionList", () => $bb6f2e4f8da96fe0$export$cc9acfeac802bc55);
const $bb6f2e4f8da96fe0$export$cc9acfeac802bc55 = {
    flow: 'column',
    childExtends: 'FileItem',
    fontSize: 'Z2',
    align: 'stretch',
    gap: 'X1',
    childrenAs: 'state',
    children: [
        {
            type: 'components',
            key: 'Logo',
            value: {
                Img: {}
            }
        },
        {
            type: 'components',
            key: 'Header',
            value: {
                Logo: {}
            }
        }
    ]
};

});

parcelRegister("826jW", function(module, exports) {

$parcel$export(module.exports, "commandDefs", () => $5d9369cda3cc078a$export$987a47818e82961);
$parcel$export(module.exports, "commands", () => $5d9369cda3cc078a$export$2ccc4f72dd956183);
$parcel$export(module.exports, "CommandBar", () => $5d9369cda3cc078a$export$afe2359305e787af);
const $5d9369cda3cc078a$export$987a47818e82961 = [
    {
        name: 'zoom',
        description: 'editor.command.zoom.description',
        args: [
            '25',
            '50',
            '75',
            '100',
            '150',
            '200'
        ]
    },
    {
        name: 'mode',
        description: 'editor.command.mode.description',
        args: [
            'default',
            'inspect',
            'panning',
            'interact'
        ]
    },
    {
        name: 'editor',
        description: 'editor.command.editor.description',
        args: null
    },
    {
        name: 'settings',
        description: 'editor.command.settings.description',
        args: null
    },
    {
        name: 'go',
        description: 'editor.command.go.description',
        args: [
            'dashboard',
            'canvas',
            'settings'
        ]
    },
    {
        name: 'open',
        description: 'editor.command.open.description',
        args: 'dynamic'
    },
    {
        name: 'select',
        description: 'editor.command.select.description',
        args: 'dynamic'
    },
    {
        name: 'search',
        description: 'editor.command.search.description',
        args: null
    },
    {
        name: 'docs',
        description: 'editor.command.docs.description',
        args: null
    },
    {
        name: 'versions',
        description: 'editor.command.versions.description',
        args: null
    },
    {
        name: 'theme',
        description: 'editor.command.theme.description',
        args: [
            'dark',
            'light'
        ]
    },
    // Canvas v2 commands.
    {
        name: 'auto-layout',
        description: 'editor.command.autoLayout.description',
        args: null
    },
    {
        name: 'fit',
        description: 'editor.command.fit.description',
        args: null
    },
    {
        name: 'reset',
        description: 'editor.command.reset.description',
        args: null
    },
    {
        name: 'undo',
        description: 'editor.command.undo.description',
        args: null
    },
    {
        name: 'redo',
        description: 'editor.command.redo.description',
        args: null
    },
    {
        name: 'duplicate',
        description: 'editor.command.duplicate.description',
        args: null
    },
    {
        name: 'delete',
        description: 'editor.command.delete.description',
        args: null
    },
    {
        name: 'group',
        description: 'editor.command.group.description',
        args: null
    },
    {
        name: 'ungroup',
        description: 'editor.command.ungroup.description',
        args: null
    },
    {
        name: 'snap',
        description: 'editor.command.snap.description',
        args: [
            'on',
            'off',
            'grid',
            'items',
            'guides'
        ]
    },
    {
        name: 'grid-step',
        description: 'editor.command.gridStep.description',
        args: 'dynamic'
    },
    {
        name: 'frame-mode',
        description: 'editor.command.frameMode.description',
        args: [
            'on',
            'off'
        ]
    },
    {
        name: 'guides',
        description: 'editor.command.guides.description',
        args: [
            'clear'
        ]
    },
    {
        name: 'shortcuts',
        description: 'editor.command.shortcuts.description',
        args: null
    },
    {
        name: 'help',
        description: 'editor.command.help.description',
        args: null
    },
    {
        name: 'align',
        description: 'editor.command.align.description',
        args: [
            'left',
            'right',
            'top',
            'bottom',
            'center',
            'middle'
        ]
    },
    {
        name: 'distribute',
        description: 'editor.command.distribute.description',
        args: [
            'horizontal',
            'vertical'
        ]
    }
];
const $5d9369cda3cc078a$export$2ccc4f72dd956183 = {
    zoom (el, args) {
        const value = parseFloat(args[0]);
        if (!value || value <= 0) return el.call('polyglot', 'editor.command.usage.zoom');
        const gs = el.scope.getGS();
        if (!gs?.panzoomInstance) return el.call('polyglot', 'editor.command.result.noCanvasInstance');
        const win = el.scope.getIframeWindow();
        const { x: x, y: y } = gs.positions;
        gs.panzoomInstance.smoothZoomAbs(x + win.innerWidth / 2, y + win.innerHeight / 2, value / 100);
        return el.call('polyglot', 'editor.command.result.zoomSet').replace('{value}', value);
    },
    mode (el, args) {
        const modes = [
            'defaultMode',
            'inspectMode',
            'panningMode',
            'interactMode'
        ];
        const arg = (args[0] || '').toLowerCase();
        if (!arg) return el.call('polyglot', 'editor.command.usage.mode');
        // Accept short names ('interact' → 'interactMode'); existing chrome
        // speaks v1-style flags which methods/index.js bridges to v2.
        const resolved = modes.find((m)=>m.toLowerCase().startsWith(arg));
        if (!resolved) return el.call('polyglot', 'editor.command.result.unknownMode');
        el.setCanvasMode(resolved);
        return el.call('polyglot', 'editor.command.result.modeSwitched').replace('{mode}', resolved.replace('Mode', ''));
    },
    editor (el) {
        const cs = el.getCanvasScope();
        cs.editorActive = !cs.editorActive;
        return el.call('polyglot', cs.editorActive ? 'editor.command.result.editorOpened' : 'editor.command.result.editorClosed');
    },
    settings (el) {
        el.call('openRouterModal', '/settings', {
            key: '/settings'
        });
        return el.call('polyglot', 'editor.command.result.settingsOpened');
    },
    versions (el) {
        // Registered by the canvas project (functions/versionHistory.js); on
        // surfaces without it el.call resolves to undefined and this is a no-op.
        el.call('toggleVersionHistory');
        return el.call('polyglot', 'editor.command.result.versionHistory');
    },
    go (el, args) {
        const path = args[0];
        if (!path) return el.call('polyglot', 'editor.command.usage.go');
        el.router(path, el.getRoot());
        return el.call('polyglot', 'editor.command.result.navigated').replace('{path}', path);
    },
    open (el, args) {
        const key = args[0];
        if (!key) return el.call('polyglot', 'editor.command.usage.open');
        // canvas's v1→v2 bridge (Rule 63 fix — was named the same as the real
        // shared setWindow primitive and shadowed it shell-wide; see
        // canvas/methods/index.js). Selects + fits the artboard in v2.
        el.call('bridgeSetWindow', 'explorer', key);
        return el.call('polyglot', 'editor.command.result.opened').replace('{key}', key);
    },
    select (el, args) {
        const key = args[0];
        if (!key) return el.call('polyglot', 'editor.command.usage.select');
        const rs = el.getRootState();
        const data = rs?.data;
        const type = data?.pages?.[key] ? 'pages' : 'components';
        el.call('openArtboardItem', type, key);
        return el.call('polyglot', 'editor.command.result.selected').replace('{key}', key);
    },
    search (el, args) {
        const query = args.join(' ');
        if (!query) return el.call('polyglot', 'editor.command.usage.search');
        // canvas's v1→v2 bridge — see the /open comment above. No-op in v2 today
        // (the bridge explicitly skips `search:`-prefixed args).
        el.call('bridgeSetWindow', 'explorer', 'search:' + query);
        return el.call('polyglot', 'editor.command.result.searching').replace('{query}', query);
    },
    docs (el) {
        // canvas's v1→v2 bridge — see the /open comment above.
        el.call('bridgeSetWindow', 'explorer', 'onboarding');
        return el.call('polyglot', 'editor.command.result.docsOpened');
    },
    theme (el, args) {
        const target = args[0];
        if (target && target !== 'dark' && target !== 'light') return el.call('polyglot', 'editor.command.usage.theme');
        el.call('toggleTheme', target || undefined);
        return el.call('polyglot', 'editor.command.result.themeToggled');
    },
    // ── Canvas v2 commands ────────────────────────────────────────────
    'auto-layout': (el)=>{
        el.call('autoLayout');
        return el.call('polyglot', 'editor.command.result.autoLaidOut');
    },
    fit: (el)=>{
        el.call('fitToSelection');
        return el.call('polyglot', 'editor.command.result.fitToSelection');
    },
    reset: (el)=>{
        el.call('resetCanvasView');
        return el.call('polyglot', 'editor.command.result.viewReset');
    },
    undo: (el)=>{
        el.call('undo');
        return el.call('polyglot', 'editor.command.result.undone');
    },
    redo: (el)=>{
        el.call('redo');
        return el.call('polyglot', 'editor.command.result.redone');
    },
    duplicate: (el)=>{
        el.call('duplicateSelection');
        return el.call('polyglot', 'editor.command.result.duplicated');
    },
    delete: (el)=>{
        el.call('deleteSelection');
        return el.call('polyglot', 'editor.command.result.deleted');
    },
    group: (el)=>{
        el.call('group');
        return el.call('polyglot', 'editor.command.result.grouped');
    },
    ungroup: (el)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return el.call('polyglot', 'editor.command.result.noCanvas');
        const ids = v2.selection.ids;
        Object.entries(v2.groups || {}).filter(([, g])=>g.children.some((c)=>ids.includes(c))).forEach(([gid])=>el.call('ungroup', gid));
        return el.call('polyglot', 'editor.command.result.ungrouped');
    },
    snap: (el, args)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return el.call('polyglot', 'editor.command.result.noCanvas');
        const a = (args[0] || '').toLowerCase();
        if (a === 'on') {
            el.call('patchSnap', {
                enabled: true
            });
            return el.call('polyglot', 'editor.command.result.snapOn');
        }
        if (a === 'off') {
            el.call('patchSnap', {
                enabled: false
            });
            return el.call('polyglot', 'editor.command.result.snapOff');
        }
        if (a === 'grid') {
            el.call('patchSnap', {
                toGrid: !v2.snap.toGrid
            });
            return el.call('polyglot', !v2.snap.toGrid ? 'editor.command.result.gridSnapOn' : 'editor.command.result.gridSnapOff');
        }
        if (a === 'items') {
            el.call('patchSnap', {
                toItems: !v2.snap.toItems
            });
            return el.call('polyglot', !v2.snap.toItems ? 'editor.command.result.itemSnapOn' : 'editor.command.result.itemSnapOff');
        }
        if (a === 'guides') {
            el.call('patchSnap', {
                toGuides: !v2.snap.toGuides
            });
            return el.call('polyglot', !v2.snap.toGuides ? 'editor.command.result.guideSnapOn' : 'editor.command.result.guideSnapOff');
        }
        return el.call('polyglot', 'editor.command.usage.snap');
    },
    'grid-step': (el, args)=>{
        const n = Math.max(4, Math.min(500, Number(args[0]) || 0));
        if (!n) return el.call('polyglot', 'editor.command.usage.gridStep');
        el.call('patchSnap', {
            gridStep: n
        });
        return el.call('polyglot', 'editor.command.result.gridStep').replace('{n}', n);
    },
    guides: (el, args)=>{
        if (args[0] === 'clear') {
            el.call('patchCanvas', {
                guides: {
                    horizontal: [],
                    vertical: []
                }
            });
            return el.call('polyglot', 'editor.command.result.guidesCleared');
        }
        return el.call('polyglot', 'editor.command.usage.guides');
    },
    shortcuts: (el)=>{
        el.call('openKeyboardShortcuts');
        return el.call('polyglot', 'editor.command.result.shortcutsOverlay');
    },
    help: (el)=>{
        el.call('openKeyboardShortcuts');
        return el.call('polyglot', 'editor.command.result.shortcutsOverlay');
    },
    align: (el, args)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return el.call('polyglot', 'editor.command.result.noCanvas');
        const ids = v2.selection.ids;
        if (ids.length < 2) return el.call('polyglot', 'editor.command.result.needTwo');
        const dir = (args[0] || '').toLowerCase();
        const items = v2.items;
        const rects = ids.map((id)=>items[id]).filter(Boolean);
        const nodeMap = el.scope.buildCanvasItemNodeMap();
        let target;
        // The result key is chosen IN the branch, never assembled from `dir`
        // (docs/I18N-CONVENTION.md §1.3 — a concatenated key is invisible to the
        // parity gate and to grep).
        let resultKey;
        if (dir === 'left') {
            const minX = Math.min(...rects.map((r)=>r.x));
            target = ()=>({
                    x: minX
                });
            resultKey = 'editor.command.result.alignedLeft';
        } else if (dir === 'right') {
            const maxRight = Math.max(...rects.map((r)=>r.x + r.w));
            target = (r)=>({
                    x: maxRight - r.w
                });
            resultKey = 'editor.command.result.alignedRight';
        } else if (dir === 'top') {
            const minY = Math.min(...rects.map((r)=>r.y));
            target = ()=>({
                    y: minY
                });
            resultKey = 'editor.command.result.alignedTop';
        } else if (dir === 'bottom') {
            const maxBottom = Math.max(...rects.map((r)=>r.y + r.h));
            target = (r)=>({
                    y: maxBottom - r.h
                });
            resultKey = 'editor.command.result.alignedBottom';
        } else if (dir === 'center') {
            const cx = (Math.min(...rects.map((r)=>r.x)) + Math.max(...rects.map((r)=>r.x + r.w))) / 2;
            target = (r)=>({
                    x: cx - r.w / 2
                });
            resultKey = 'editor.command.result.alignedCenter';
        } else if (dir === 'middle') {
            const cy = (Math.min(...rects.map((r)=>r.y)) + Math.max(...rects.map((r)=>r.y + r.h))) / 2;
            target = (r)=>({
                    y: cy - r.h / 2
                });
            resultKey = 'editor.command.result.alignedMiddle';
        } else return el.call('polyglot', 'editor.command.usage.align');
        ids.forEach((id)=>{
            const r = items[id];
            if (!r) return;
            const patch = target(r);
            el.call('patchCanvasItem', id, patch);
            el.scope.applyItemNodePatch(nodeMap.get(id), patch);
        });
        el.call('refreshCanvasChrome');
        el.call('pushHistory');
        el.call('persistCanvasLayout');
        return el.call('polyglot', resultKey);
    },
    distribute: (el, args)=>{
        const v2 = el.call('getCanvasV2');
        if (!v2) return el.call('polyglot', 'editor.command.result.noCanvas');
        const ids = v2.selection.ids;
        if (ids.length < 3) return el.call('polyglot', 'editor.command.result.needThree');
        const axisArg = (args[0] || '').toLowerCase();
        const axis = axisArg.startsWith('h') ? 'h' : axisArg.startsWith('v') ? 'v' : null;
        if (!axis) return el.call('polyglot', 'editor.command.usage.distribute');
        const items = v2.items;
        const sorted = [
            ...ids
        ].filter((id)=>items[id]).sort((a, b)=>axis === 'h' ? items[a].x - items[b].x : items[a].y - items[b].y);
        const first = items[sorted[0]];
        const last = items[sorted[sorted.length - 1]];
        const nodeMap = el.scope.buildCanvasItemNodeMap();
        const axisKey = axis === 'h' ? 'x' : 'y';
        const sizeKey = axis === 'h' ? 'w' : 'h';
        const total = last[axisKey] + last[sizeKey] - first[axisKey];
        const sum = sorted.reduce((acc, id)=>acc + items[id][sizeKey], 0);
        const gap = (total - sum) / (sorted.length - 1);
        let cursor = first[axisKey];
        sorted.forEach((id)=>{
            const r = items[id];
            const patch = {
                [axisKey]: cursor
            };
            el.call('patchCanvasItem', id, patch);
            el.scope.applyItemNodePatch(nodeMap.get(id), patch);
            cursor += r[sizeKey] + gap;
        });
        el.call('refreshCanvasChrome');
        el.call('pushHistory');
        el.call('persistCanvasLayout');
        return el.call('polyglot', axis === 'h' ? 'editor.command.result.distributedH' : 'editor.command.result.distributedV');
    }
};
const $5d9369cda3cc078a$export$afe2359305e787af = {
    extends: 'Navbar',
    // FA204 / frank trap — every helper below lives in `scope`, not module
    // scope: a bare module-scope const/function silently reads as undefined
    // once this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Called via
    // `el.scope.<name>(...)` (or `bar.scope.<name>(...)` — `bar` is always
    // the same live CommandBar element, just named for readability at each
    // call site) from any descendant factory/handler — including from
    // `commands` above, which is a SEPARATE top-level export (kept for
    // CommandPalette.js's cross-file `import { commandDefs, commands }`) but
    // always receives the real CommandBar element as its first arg, so
    // `el.scope` still resolves there too. Plain functions throughout
    // (never `this.<name>`) — every helper already takes `bar`/`el` as an
    // argument, so routing every cross-helper call through that argument's
    // `.scope` sidesteps the object-literal-siblings-can't-see-each-other
    // problem entirely (no method `this`-binding to keep straight across the
    // nested `commands` nesting below).
    scope: {
        commandDefs: // Mirror the top-level `commandDefs`/`commands` exports (declared above
        // this component) so this component's OWN internal helpers below never
        // depend on a bare same-file identifier post-serialization — only the
        // reference is duplicated, not the data (same object, same array).
        $5d9369cda3cc078a$export$987a47818e82961,
        commands: $5d9369cda3cc078a$export$2ccc4f72dd956183,
        getGS () {
            return window.__canvasGlobalScope;
        },
        getIframeWindow () {
            const iframe = document.getElementById('canvas-iframe');
            return iframe?.contentWindow || window;
        },
        // One DOM query per invocation — avoids N selector scans inside the
        // forEach loop below. patchCanvasItem is a non-reactive in-place
        // mutation, so we still need the imperative style write for immediate
        // visual feedback.
        buildCanvasItemNodeMap () {
            const map = new Map();
            document.querySelectorAll('[data-canvas-item]').forEach((n)=>{
                map.set(n.getAttribute('data-canvas-item'), n);
            });
            return map;
        },
        applyItemNodePatch (node, patch) {
            if (!node) return;
            if (patch.x !== undefined) node.style.left = patch.x + 'px';
            if (patch.y !== undefined) node.style.top = patch.y + 'px';
        },
        runCommand (bar, input) {
            const value = (typeof input === 'string' ? input : bar.Input.node.value).trim();
            if (!value || !value.startsWith('/')) return;
            const parts = value.slice(1).split(/\s+/);
            const cmd = parts[0].toLowerCase();
            const args = parts.slice(1);
            const handler = bar.scope.commands[cmd];
            const result = handler ? handler(bar, args) : bar.call('polyglot', 'editor.command.result.unknown').replace('{cmd}', cmd);
            bar.Input.node.value = '';
            bar.scope.hideDropdown(bar);
            bar.Input.node.blur();
            if (bar.data.feedbackTimer) clearTimeout(bar.data.feedbackTimer);
            if (bar.ResultToast?.node) {
                bar.ResultToast.node.textContent = result;
                bar.ResultToast.node.style.opacity = '1';
                bar.data.feedbackTimer = setTimeout(()=>{
                    if (bar.ResultToast?.node) bar.ResultToast.node.style.opacity = '0';
                }, 3000);
            }
        },
        getDynamicArgs (bar, cmd) {
            const items = [];
            try {
                const rs = bar.getRootState();
                const data = rs?.data;
                if (!data) return items;
                const categories = [
                    {
                        key: 'pages',
                        label: 'editor.command.category.pages'
                    },
                    {
                        key: 'components',
                        label: 'editor.command.category.components'
                    },
                    {
                        key: 'functions',
                        label: 'editor.command.category.functions'
                    }
                ];
                for (const cat of categories){
                    const obj = data[cat.key];
                    if (!obj || typeof obj !== 'object') continue;
                    const keys = Object.keys(obj);
                    if (!keys.length) continue;
                    items.push({
                        label: cat.label,
                        type: 'header'
                    });
                    for (const k of keys)items.push({
                        label: k,
                        description: cat.key.slice(0, -1),
                        type: 'arg',
                        fullValue: '/' + cmd + ' ' + k
                    });
                }
            } catch (e) {
            /* rootState may not be available */ }
            return items;
        },
        getFilteredItems (bar, value) {
            const raw = value || '';
            const trimmed = raw.trim();
            if (!trimmed || !trimmed.startsWith('/')) return bar.scope.commandDefs.map((c)=>({
                    label: '/' + c.name,
                    description: bar.call('polyglot', c.description),
                    type: 'command'
                }));
            const parts = trimmed.slice(1).split(/\s+/);
            const cmd = parts[0].toLowerCase();
            const hasSpace = raw.includes(' ');
            if (hasSpace) {
                const def = bar.scope.commandDefs.find((c)=>c.name === cmd);
                if (!def) return [];
                if (def.args === 'dynamic') {
                    const all = bar.scope.getDynamicArgs(bar, cmd);
                    const argFilter = (parts[1] || '').toLowerCase();
                    if (!argFilter) return all;
                    return all.filter((a)=>a.type === 'header' ? false : a.label.toLowerCase().includes(argFilter));
                }
                if (!def.args) return [
                    {
                        label: '/' + cmd,
                        description: bar.call('polyglot', 'editor.command.runPrefix').replace('{command}', bar.call('polyglot', def.description).toLowerCase()),
                        type: 'run',
                        fullValue: '/' + cmd
                    }
                ];
                const argFilter = (parts[1] || '').toLowerCase();
                return def.args.filter((a)=>!argFilter || a.startsWith(argFilter)).map((a)=>({
                        label: a,
                        description: '',
                        type: 'arg',
                        fullValue: '/' + cmd + ' ' + a
                    }));
            }
            return bar.scope.commandDefs.filter((c)=>c.name.startsWith(cmd)).map((c)=>({
                    label: '/' + c.name,
                    description: bar.call('polyglot', c.description),
                    type: 'command'
                }));
        },
        renderDropdown (bar, items, activeIndex) {
            const dropdown = bar.CmdDropdown?.node;
            if (!dropdown) return;
            dropdown.textContent = '';
            if (!items.length) {
                dropdown.style.opacity = '0';
                dropdown.style.visibility = 'hidden';
                return;
            }
            let selectableIndex = 0;
            items.forEach((item)=>{
                if (item.type === 'header') {
                    const header = document.createElement('div');
                    header.style.cssText = "padding:4px 8px 2px;font-size:0.8em;opacity:0.35;text-transform:uppercase;letter-spacing:0.05em;pointer-events:none;user-select:none;";
                    header.textContent = item.label;
                    dropdown.appendChild(header);
                    return;
                }
                const idx = selectableIndex++;
                const row = document.createElement('div');
                row.style.cssText = "display:flex;align-items:center;justify-content:space-between;padding:4px 8px;cursor:pointer;border-radius:4px;gap:8px;" + (idx === activeIndex ? 'background:var(--color-selected);' : '');
                row.dataset.index = idx;
                row.dataset.itemIndex = items.indexOf(item);
                const left = document.createElement('span');
                left.style.cssText = 'font-weight:500;white-space:nowrap;';
                left.textContent = item.label;
                row.appendChild(left);
                if (item.description) {
                    const right = document.createElement('span');
                    right.style.cssText = 'opacity:0.4;font-size:0.9em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
                    right.textContent = item.description;
                    row.appendChild(right);
                }
                dropdown.appendChild(row);
            });
        },
        getSelectableItems (items) {
            return items.filter((i)=>i.type !== 'header');
        },
        updateDropdown (bar) {
            const value = bar.Input?.node?.value || '';
            const items = bar.scope.getFilteredItems(bar, value);
            bar.data.filteredItems = items;
            bar.data.selectableItems = bar.scope.getSelectableItems(items);
            bar.data.activeIndex = -1;
            bar.scope.renderDropdown(bar, items, -1);
        },
        showDropdown (bar) {
            bar.scope.updateDropdown(bar);
            const dropdown = bar.CmdDropdown?.node;
            if (dropdown) {
                dropdown.style.opacity = '1';
                dropdown.style.visibility = 'visible';
                dropdown.style.pointerEvents = 'auto';
            }
            bar.data.isOpen = true;
        },
        hideDropdown (bar) {
            const dropdown = bar.CmdDropdown?.node;
            if (dropdown) {
                dropdown.style.opacity = '0';
                dropdown.style.visibility = 'hidden';
                dropdown.style.pointerEvents = 'none';
            }
            bar.data.activeIndex = -1;
            bar.data.isOpen = false;
        }
    },
    position: 'relative',
    gap: '0',
    // A capsule, like every field-shaped control of the shell.
    round: 'radiusPill',
    userSelect: 'none',
    cursor: 'text',
    minWidth: 'G+C',
    padding: '0',
    data: {
        feedbackTimer: null,
        filteredItems: [],
        selectableItems: [],
        activeIndex: -1,
        isOpen: false
    },
    // FA503 / Rule 64. Both of this bar's listeners used to be armed
    // imperatively from `onRender` behind an `__cmdBarInit` latch:
    //   • the row-click delegation duplicated the declarative `onClick` below
    //     on the SAME node (two listeners, one element);
    //   • the outside-click `document.addEventListener('mousedown', …)` had NO
    //     removal at all — its own comment ("the listener outlives the
    //     element") described the leak instead of fixing it. Every route change
    //     that unmounted the bar left one more live document listener.
    // Both are now declared props: DOMQL registers each exactly once and drops
    // them in dispose().
    // Root click keeps the pre-fix ORDER: focus/open first (what the old
    // declarative `onClick` did), then the row delegation the imperative
    // listener added after it.
    onClick: (e, el)=>{
        el.Input.node.focus();
        if (!el.data.isOpen) el.scope.showDropdown(el);
        const row = e.target.closest('[data-index]');
        if (!row) return;
        e.stopPropagation();
        const itemIdx = parseInt(row.dataset.itemIndex);
        const item = el.data.filteredItems[itemIdx];
        if (!item) return;
        if (item.type === 'run' || item.type === 'arg') el.scope.runCommand(el, item.fullValue);
        else {
            el.Input.node.value = item.label + ' ';
            el.scope.showDropdown(el);
            el.Input.node.focus();
        }
    },
    onDocumentMousedown: (e, el)=>{
        if (!el.node) return;
        if (!el.node.contains(e.target)) {
            el.scope.hideDropdown(el);
            el.Input?.node?.blur?.();
        }
    },
    Icon: {
        name: 'chevronRight',
        width: 'A',
        height: 'A',
        margin: '- -B - -',
        opacity: '.35',
        flexShrink: '0',
        marginLeft: 'Z',
        pointerEvents: 'none'
    },
    Input: {
        tag: 'input',
        type: 'text',
        placeholder: (el)=>el.call('polyglot', 'editor.command.placeholder'),
        theme: null,
        border: '0',
        outline: 'none',
        background: 'transparent',
        color: 'currentColor',
        fontFamily: 'inherit',
        width: '100%',
        padding: 'Z Z Z B2',
        flexGrow: '1',
        '::placeholder': {
            color: 'currentColor',
            opacity: '.25'
        },
        onInput: (e, el)=>{
            const bar = el.parent;
            bar.scope.updateDropdown(bar);
        },
        onKeyDown: (e, el)=>{
            const bar = el.parent;
            const selectable = bar.data.selectableItems || [];
            let idx = bar.data.activeIndex;
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!bar.data.isOpen) {
                    bar.scope.showDropdown(bar);
                    return;
                }
                idx = idx < selectable.length - 1 ? idx + 1 : 0;
                bar.data.activeIndex = idx;
                bar.scope.renderDropdown(bar, bar.data.filteredItems, idx);
                return;
            }
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (!bar.data.isOpen) {
                    bar.scope.showDropdown(bar);
                    return;
                }
                idx = idx > 0 ? idx - 1 : selectable.length - 1;
                bar.data.activeIndex = idx;
                bar.scope.renderDropdown(bar, bar.data.filteredItems, idx);
                return;
            }
            if (e.key === 'Tab') {
                e.preventDefault();
                const item = selectable[idx >= 0 ? idx : 0];
                if (!item) return;
                el.node.value = item.type === 'arg' ? item.fullValue : item.label + ' ';
                bar.scope.updateDropdown(bar);
                return;
            }
            if (e.key === 'Enter') {
                e.preventDefault();
                if (idx >= 0 && selectable[idx]) {
                    const item = selectable[idx];
                    if (item.type === 'run') bar.scope.runCommand(bar, item.fullValue);
                    else if (item.type === 'arg') bar.scope.runCommand(bar, item.fullValue);
                    else {
                        el.node.value = item.label + ' ';
                        bar.data.activeIndex = -1;
                        bar.scope.showDropdown(bar);
                    }
                    return;
                }
                if (!el.node.value.trim()) return;
                bar.scope.runCommand(bar, el.node.value);
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                if (el.node.value) {
                    el.node.value = '';
                    bar.scope.updateDropdown(bar);
                } else {
                    bar.scope.hideDropdown(bar);
                    el.node.blur();
                }
            }
        }
    },
    CmdDropdown: {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        marginTop: 'Y',
        flow: 'y',
        gap: 'W',
        padding: 'Z',
        // The popover recipe (DESIGN_SPEC §6.1): the shell glass, the card
        // radius, the overlay elevation (ring + layers once brand ships them).
        round: 'radiusCard',
        theme: 'canvas-card-glass',
        shadow: 'overlay',
        fontSize: 'Z2',
        // Adaptive (was fixed 'white') — canvas-card-glass already supplies its
        // own paired text color; the fixed override went invisible against the
        // theme's near-white light-mode glass background.
        color: 'title',
        opacity: '0',
        visibility: 'hidden',
        pointerEvents: 'none',
        transition: 'A opacity defaultBezier',
        zIndex: '1000',
        maxHeight: 'H',
        overflow: 'hidden auto',
        scrollBehavior: 'smooth'
    },
    // The result toast. Its key is not a component name: a key named like a
    // registered component extends it, and `Feedback` pulled the shared
    // Feedback row (a vote toggle and a heading group) into this span.
    ResultToast: {
        tag: 'span',
        position: 'absolute',
        top: '100%',
        left: '0',
        marginTop: 'Y',
        fontSize: 'Z2',
        // Adaptive (was fixed 'white') — same fix as CmdDropdown above.
        color: 'title',
        theme: 'canvas-card-glass',
        // A result toast: the capsule on the float elevation.
        padding: 'Y Z',
        round: 'radiusPill',
        shadow: 'float',
        opacity: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 'I',
        transition: 'B opacity defaultBezier',
        pointerEvents: 'none',
        zIndex: '1001'
    }
};

});

parcelRegister("l12sZ", function(module, exports) {

$parcel$export(module.exports, "CommandPalette", () => $f4cb9ace63250fd4$export$d5c1975cbb44d2a4);
// CommandPalette — single input that's both a slash-command palette
// and a project search. Typing `/` shows commands; anything else is
// fuzzy-searched against project schema. Replaces SearchBar on
// canvas/workspace pages.
//
// Dropdown item shape:
//   { kind: 'cmd', name, description, args, snippet }
//   { kind: 'item', type, key, score }
//
// Global shortcut: Cmd/Ctrl+K focuses the input.

var $826jW = parcelRequire("826jW");
const $f4cb9ace63250fd4$export$d5c1975cbb44d2a4 = {
    // FA204 / frank trap — every helper below used to be a bare module-scope
    // function read from inside `onFocus`/`onInput`/`onBlur`/`onKeydown`/
    // `onClick` (serialized factories); they silently read as undefined once
    // this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Moved into `scope`,
    // called via `el.scope.<name>`; siblings call each other via `this.<name>`
    // (el.scope.foo() binds `this` to el.scope — object-literal properties
    // can't see each other as bare identifiers otherwise). `commandDefs`/
    // `commands` stay a cross-file import (untouched — out of scope for this
    // ticket, governed by the separate el.call() convention).
    scope: {
        MAX_DROPDOWN: 20,
        // `commandDefs[].description` is a bundle KEY (CommandBar.js) — resolve it
        // HERE, at produce time, because renderDropdown writes the value straight
        // into innerHTML and has no reactive effect to re-run. `el` is threaded in
        // for the same reason: polyglot is an element-bound call.
        filterCommands (el, query) {
            const q = query.trim().toLowerCase();
            const tag = (c)=>({
                    kind: 'cmd',
                    name: c.name,
                    description: el.call('polyglot', c.description || ''),
                    args: c.args
                });
            if (!q) return (0, $826jW.commandDefs).slice(0, this.MAX_DROPDOWN).map(tag);
            return (0, $826jW.commandDefs).map(tag).filter((c)=>c.name.toLowerCase().includes(q) || c.description?.toLowerCase().includes(q)).slice(0, this.MAX_DROPDOWN);
        },
        fuzzySearchItems (el, query) {
            const q = query.trim().toLowerCase();
            if (!q) return [];
            const data = el.getRootState?.()?.data || el.state?.root?.data;
            if (!data) return [];
            const out = [];
            const scan = (obj, type)=>{
                if (!obj) return;
                for (const key of Object.keys(obj)){
                    if (key.toLowerCase().includes(q)) out.push({
                        kind: 'item',
                        type: type,
                        key: key
                    });
                    if (out.length >= this.MAX_DROPDOWN) return;
                }
            };
            scan(data.pages, 'pages');
            scan(data.components, 'components');
            scan(data.functions, 'functions');
            return out.slice(0, this.MAX_DROPDOWN);
        },
        runCommand (el, input) {
            const value = input.trim();
            if (!value.startsWith('/')) return null;
            const [name, ...args] = value.slice(1).split(/\s+/);
            const handler = (0, $826jW.commands)[name.toLowerCase()];
            const t = (k)=>el.call('polyglot', k);
            if (!handler) return t('shell.commandPalette.unknown').replace('{name}', name);
            try {
                return handler(el, args) || t('shell.commandPalette.ran').replace('{name}', name);
            } catch (e) {
                return t('shell.commandPalette.error').replace('{error}', e.message || e);
            }
        },
        highlightIndex (palette, delta) {
            const items = palette.Dropdown?.node?.querySelectorAll('[data-cp-item]');
            if (!items?.length) return;
            const cur = Array.from(items).findIndex((i)=>i.hasAttribute('data-cp-active'));
            items.forEach((i)=>i.removeAttribute('data-cp-active'));
            const next = ((cur < 0 ? -1 : cur) + delta + items.length) % items.length;
            const target = items[Math.max(0, next)];
            target?.setAttribute('data-cp-active', '1');
            target?.style?.setProperty?.('background', 'var(--color-selected)');
            Array.from(items).forEach((i, idx)=>{
                if (idx !== next) i.style?.setProperty?.('background', '');
            });
        },
        executeHighlighted (palette, el) {
            const active = palette.Dropdown?.node?.querySelector('[data-cp-item][data-cp-active]') || palette.Dropdown?.node?.querySelector('[data-cp-item]');
            if (!active) return null;
            const kind = active.getAttribute('data-cp-kind');
            const name = active.getAttribute('data-cp-name');
            if (kind === 'cmd') {
                palette.Input.node.value = '/' + name + ' ';
                palette.Input.node.focus();
                this.updateDropdown(palette, el);
                return null;
            }
            if (kind === 'item') {
                const key = active.getAttribute('data-cp-key');
                const type = active.getAttribute('data-cp-type');
                el.call('openArtboardItem', type, key);
                palette.Input.node.value = '';
                palette.Input.node.blur();
                this.hideDropdown(palette);
                return null;
            }
            return null;
        },
        hideDropdown (palette) {
            palette.Dropdown?.update?.({
                style: {
                    display: 'none'
                }
            });
        },
        showDropdown (palette) {
            palette.Dropdown?.update?.({
                style: {
                    display: 'block'
                }
            });
        },
        renderDropdown (palette, rows) {
            const node = palette.Dropdown?.node;
            if (!node) return;
            node.innerHTML = '';
            if (!rows.length) {
                this.hideDropdown(palette);
                return;
            }
            this.showDropdown(palette);
            for (const row of rows){
                const div = node.ownerDocument.createElement('div');
                div.setAttribute('data-cp-item', '1');
                div.setAttribute('data-cp-kind', row.kind);
                div.style.padding = '8px 12px';
                div.style.cursor = 'pointer';
                div.style.display = 'flex';
                div.style.justifyContent = 'space-between';
                div.style.gap = '12px';
                div.style.borderRadius = '4px';
                div.onmouseenter = ()=>{
                    div.style.background = 'var(--color-hover)';
                };
                div.onmouseleave = ()=>{
                    div.style.background = '';
                };
                if (row.kind === 'cmd') {
                    div.setAttribute('data-cp-name', row.name);
                    div.innerHTML = `<span><span style="font-family:monospace;color:#8ab4f8">/${row.name}</span>` + (Array.isArray(row.args) ? ` <span style="opacity:.55;font-size:11px">[${row.args.join('|')}]</span>` : '') + `</span><span style="opacity:.65;font-size:12px">${row.description || ''}</span>`;
                } else {
                    div.setAttribute('data-cp-name', row.key);
                    div.setAttribute('data-cp-kind', 'item');
                    div.setAttribute('data-cp-type', row.type);
                    div.setAttribute('data-cp-key', row.key);
                    div.innerHTML = `<span>${row.key}</span><span style="opacity:.55;font-size:11px">${row.type}</span>`;
                }
                node.appendChild(div);
            }
        },
        updateDropdown (palette, el) {
            const value = palette.Input?.node?.value || '';
            if (value.startsWith('/')) {
                const rows = this.filterCommands(el, value.slice(1));
                this.renderDropdown(palette, rows);
                return;
            }
            if (value.trim()) {
                const rows = this.fuzzySearchItems(el, value);
                this.renderDropdown(palette, rows);
                return;
            }
            // Empty + focused: show top commands.
            this.renderDropdown(palette, this.filterCommands(el, ''));
        },
        setFeedback (palette, msg) {
            const fb = palette.ResultToast;
            if (!fb?.update) return;
            fb.update({
                text: msg,
                style: {
                    display: msg ? 'block' : 'none'
                }
            });
            if (msg) {
                clearTimeout(palette.__feedbackTimer);
                palette.__feedbackTimer = setTimeout(()=>{
                    fb.update({
                        style: {
                            display: 'none'
                        }
                    });
                }, 2500);
            }
        }
    },
    tag: 'div',
    position: 'relative',
    width: '100%',
    // The `overlayLg` width token (it was the same 560 as a raw px).
    maxWidth: 'overlayLg',
    fontSize: 'Y',
    // Cmd/Ctrl+K to focus from anywhere. FA503 / Rule 64: the framework owns
    // the document-level listener — registered once when this element gets its
    // node, inert while the element is detached, and removed in dispose(). The
    // previous shape armed it from `onInit` and parked the un-binder on
    // `el.__cpUnbind`, which NOTHING ever called: every mount of this palette
    // left a live keydown listener on the document behind it.
    onDocumentKeydown: (ev, el)=>{
        if (!el.node) return;
        if (!(ev.metaKey || ev.ctrlKey) || ev.key?.toLowerCase() !== 'k') return;
        ev.preventDefault();
        el.Input?.node?.focus();
        el.Input?.node?.select?.();
    },
    Input: {
        tag: 'input',
        type: 'text',
        placeholder: (el)=>el.call('polyglot', 'shell.commandPalette.placeholder'),
        width: '100%',
        padding: 'W B',
        round: 'radiusControl',
        // The kit's `field` surface — its OWN ground and ink in both schemes, so
        // the field no longer depends on a host it cannot see (it was a fixed
        // `black.25` wash + `white` ink: 2.05:1 on a light host, measured
        // 2026-09-20). The hairline edge is the field's one kept stroke.
        theme: 'field',
        border: 'hairline solid line',
        fontSize: 'Y',
        style: {
            outline: 'none'
        },
        attr: {
            'aria-label': (el)=>el.call('polyglot', 'shell.commandPalette.inputAria')
        },
        onFocus: (ev, el)=>el.scope.updateDropdown(el.parent, el.parent),
        onInput: (ev, el)=>el.scope.updateDropdown(el.parent, el.parent),
        onBlur: (ev, el)=>{
            // Delay so click on dropdown item can fire first.
            setTimeout(()=>el.scope.hideDropdown(el.parent), 150);
        },
        onKeydown: (ev, el)=>{
            const palette = el.parent;
            if (ev.key === 'Escape') {
                el.node.value = '';
                el.node.blur();
                el.scope.hideDropdown(palette);
                return;
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                el.scope.highlightIndex(palette, 1);
                return;
            }
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                el.scope.highlightIndex(palette, -1);
                return;
            }
            if (ev.key === 'Enter') {
                ev.preventDefault();
                // Execute highlighted item, or command from input value.
                const result = el.scope.executeHighlighted(palette, palette);
                if (result === null && palette.Input.node.value.startsWith('/')) {
                    const msg = el.scope.runCommand(palette, palette.Input.node.value);
                    if (msg) el.scope.setFeedback(palette, msg);
                    palette.Input.node.value = '';
                    el.scope.hideDropdown(palette);
                }
            }
        }
    },
    Dropdown: {
        tag: 'div',
        position: 'absolute',
        top: 'calc(100% + 6px)',
        left: '0',
        right: '0',
        maxHeight: '60dvh',
        overflow: 'auto',
        // The popover recipe (DESIGN_SPEC §6.1): the opaque in-app `dialog`
        // surface, the card radius, the `overlay` elevation (its ring included) —
        // it was a fixed dark hex with white ink and a white hairline, dark in
        // both schemes.
        theme: 'dialog',
        round: 'radiusCard',
        padding: 'W',
        fontSize: 'Y',
        shadow: 'overlay',
        style: {
            display: 'none',
            zIndex: '100'
        },
        onPointerDown: (ev)=>ev.preventDefault(),
        onClick: (ev, el)=>{
            const item = ev.target.closest?.('[data-cp-item]');
            if (!item) return;
            const kind = item.getAttribute('data-cp-kind');
            if (kind === 'cmd') {
                const name = item.getAttribute('data-cp-name');
                el.parent.Input.node.value = '/' + name + ' ';
                el.parent.Input.node.focus();
                el.scope.updateDropdown(el.parent, el.parent);
            } else if (kind === 'item') {
                const key = item.getAttribute('data-cp-key');
                const type = item.getAttribute('data-cp-type');
                el.parent.call('openArtboardItem', type, key);
                el.parent.Input.node.value = '';
                el.scope.hideDropdown(el.parent);
            }
        }
    },
    // The result toast. Its key is not a component name: a key named like a
    // registered component extends it, and `Feedback` pulled the shared
    // Feedback row (a vote toggle and a heading group) into this toast.
    ResultToast: {
        tag: 'div',
        position: 'absolute',
        top: 'calc(100% + 6px)',
        left: '0',
        padding: 'W A',
        // The ink capsule (`primary`, its own adaptive ground + ink) — it was a
        // raw translucent blue under white ink.
        theme: 'primary',
        round: 'radiusPill',
        fontSize: 'Y',
        style: {
            display: 'none',
            zIndex: '99'
        }
    }
};

});

parcelRegister("9UgmD", function(module, exports) {

$parcel$export(module.exports, "DROPDOWN_APPS", () => $73660997378aa2dd$export$452d4cca16549844);
$parcel$export(module.exports, "WORKSPACE_PATHS", () => $73660997378aa2dd$export$63b6349671d6f15d);
$parcel$export(module.exports, "INTRANET_PATHS", () => $73660997378aa2dd$export$107518de889b631d);
$parcel$export(module.exports, "AppNavbarDropdownItem", () => $73660997378aa2dd$export$9227cc93a6a67e50);
$parcel$export(module.exports, "AppNavbarMoreMenu", () => $73660997378aa2dd$export$508394f03a0d3981);
$parcel$export(module.exports, "AppNavbarButton", () => $73660997378aa2dd$export$9fa14be9f2b7bdf0);
$parcel$export(module.exports, "AppNavbar", () => $73660997378aa2dd$export$cb80bf6b197ce0ea);
// The four canvas views (Frontend · Infra · Tasks · Agents) — single source of
// truth lives in CanvasViewNav.js (the left-rail switcher). The More dropdown
// mirrors them as a VIEWS section below, mapping `path` → the dropdown's `route`
// item shape rather than re-typing the routes here.

var $cEFVO = parcelRequire("cEFVO");

var $9juhh = parcelRequire("9juhh");

var $4SiPM = parcelRequire("4SiPM");

var $dot7l = parcelRequire("dot7l");
const $73660997378aa2dd$export$452d4cca16549844 = [
    {
        key: 'home',
        icon: 'logov2',
        route: '/',
        label: 'shell.app.workspace'
    },
    {
        key: 'my',
        icon: 'user',
        route: '/my',
        label: 'shell.app.myProfile'
    },
    {
        key: 'announcements',
        icon: 'bell',
        route: '/announcements',
        label: 'shell.app.announcements'
    },
    {
        key: 'div-1',
        divider: true
    },
    {
        key: 'studio',
        icon: 'layers',
        route: '/studio',
        label: 'shell.app.studio'
    },
    {
        key: 'infra',
        icon: 'server',
        route: '/infra',
        label: 'shell.app.infra'
    },
    {
        key: 'marketplace',
        icon: 'blocks',
        route: '/marketplace',
        label: 'shell.app.marketplace'
    },
    {
        key: 'teamandagents',
        icon: 'people',
        route: '/team-and-agents',
        label: 'shell.app.teamAndAgents'
    },
    {
        key: 'agents',
        icon: 'star',
        route: '/agents',
        label: 'shell.app.agents'
    },
    // `/people` is the flat directory — kept in the dropdown so users
    // searching for the old surface still find it. `/team-and-agents` is
    // the structural lens that owns the navbar slot now.
    {
        key: 'people',
        icon: 'user',
        route: '/team-members',
        label: 'shell.app.teamMembers'
    },
    {
        key: 'tickets',
        icon: 'check',
        route: '/tasks',
        label: 'shell.app.tasks'
    },
    {
        key: 'documents',
        icon: 'document',
        route: '/notes',
        label: 'shell.app.notes'
    },
    {
        key: 'files',
        icon: 'folder',
        route: '/files',
        label: 'shell.app.files'
    },
    {
        key: 'analytics',
        icon: 'analytics',
        route: '/analytics',
        label: 'shell.app.analytics'
    },
    {
        key: 'data',
        icon: 'database',
        route: '/data/projects',
        label: 'shell.app.data'
    },
    {
        key: 'div-2',
        divider: true
    },
    {
        key: 'calendar',
        icon: 'date outline',
        route: '/calendar',
        label: 'shell.app.calendar'
    },
    {
        key: 'reminders',
        icon: 'clockOutline',
        route: '/reminders',
        label: 'shell.app.reminders'
    },
    // History — the built-in timeline of the workspace activity log.
    {
        key: 'history',
        icon: 'sfHistory',
        route: '/history',
        label: 'shell.app.history'
    },
    {
        key: 'chat',
        icon: 'chat',
        route: '/chat',
        label: 'shell.app.chat'
    },
    // Mail rides the same `navItemVisible` gate as every row here, so the
    // dark-by-default `mail` flag keeps it out of the menu until it is on.
    {
        key: 'mail',
        icon: 'email',
        route: '/mail',
        label: 'shell.app.mail'
    },
    {
        key: 'meet',
        icon: 'video',
        route: '/meet',
        label: 'shell.app.meet'
    },
    {
        key: 'company',
        icon: 'info',
        route: '/company',
        label: 'shell.app.company'
    },
    {
        key: 'div-3',
        divider: true
    },
    {
        key: 'addapps',
        icon: 'plus',
        route: '/add-app',
        label: 'shell.app.addApp'
    },
    {
        key: 'div-4',
        divider: true
    },
    // VIEWS — mapped from CanvasViewNav's VIEW_NAV so the routes stay
    // single-sourced. `path` → the dropdown's `route` item shape; key prefixed
    // `view-` so it can't collide with the app keys above.
    ...(0, $cEFVO.VIEW_NAV).map((v)=>({
            key: `view-${v.key}`,
            icon: v.icon,
            route: v.path,
            label: v.label
        }))
];
const $73660997378aa2dd$export$63b6349671d6f15d = [
    '/',
    '/team-members',
    '/people',
    '/my',
    '/announcements',
    '/company',
    '/profile'
];
const $73660997378aa2dd$export$107518de889b631d = $73660997378aa2dd$export$63b6349671d6f15d;
const $73660997378aa2dd$export$9227cc93a6a67e50 = {
    // FA204 / frank trap — helpers live in `scope`, not module scope (a bare
    // module-scope OR sibling-exported read silently reads as undefined once
    // the component is frank.toJSON'd for platform delivery — workspace
    // d6ea1142, project_frank_drops_module_local_helpers). `hrefFor`/
    // `resolveStudioPath` are duplicated verbatim in AppNavbarButton's own
    // scope below (a helper used by multiple components in one file gets
    // duplicated into each). `cancelMoreClose`/`moreState` coordinate with
    // AppNavbarButton's More-dropdown timer/open-flag through `el.context` —
    // the one thing genuinely SHARED across components that live in
    // different subtrees (this row renders inside the dropdown portal, not as
    // a descendant of AppNavbarButton) — see the fuller comment on
    // AppNavbarButton.scope.moreState below.
    scope: {
        resolveStudioPath (s) {
            const root = s?.root;
            const pendingId = root?._pendingActiveOrgId;
            if (pendingId) {
                const pendingOrg = (root?.jwtClaims?.orgs || []).find((o)=>o.id === pendingId);
                if (pendingOrg?.slug) return `/studio/${pendingOrg.slug}`;
            }
            const orgSlug = root?.org?.slug;
            if (orgSlug) return `/studio/${orgSlug}`;
            // No active org: the personal studio — unless that org is the empty
            // background one beside a team (functions/visibleOrgs.js, POB round
            // 5); then the team's studio.
            const orgs = root?.jwtClaims?.orgs || [];
            const shown = (0, $dot7l.visibleOrgs)(orgs);
            const personalOrg = shown.find((o)=>o?.type === 'personal');
            if (personalOrg?.slug) return `/studio/${personalOrg.slug}`;
            if (shown !== orgs && shown[0]?.slug) return `/studio/${shown[0].slug}`;
            return '/studio';
        },
        hrefFor (el, s) {
            if (s?.key === 'studio') return this.resolveStudioPath(s);
            if (!s || !Object.prototype.hasOwnProperty.call(s, 'route')) return undefined;
            return s.route || undefined;
        },
        btnLabel (s) {
            return s?.label || (s?.key ? s.key.charAt(0).toUpperCase() + s.key.slice(1) : '');
        },
        moreState (el) {
            const ctx = el.context;
            if (!ctx.__appNavbarMore) ctx.__appNavbarMore = {
                timer: null,
                open: false
            };
            return ctx.__appNavbarMore;
        },
        cancelMoreClose (el) {
            const st = this.moreState(el);
            if (st.timer) {
                clearTimeout(st.timer);
                st.timer = null;
            }
        }
    },
    extends: 'Link',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    color: 'title',
    width: '100%',
    textDecoration: 'none',
    // Row chrome = the house MenuPanelItem recipe (kept inline because this
    // already extends Link): Y/Z1 padding, Z round, tokenized hover.
    padding: 'Y Z1',
    round: 'Z',
    border: 'none',
    ':hover': {
        background: 'hover'
    },
    href: (el, s)=>el.scope.hrefFor(el, s),
    // Set both `title` (native tooltip + status bar) and `aria-label`
    // (screen readers) directly on `attr`. Top-level `aria: { label }`
    // does NOT promote to the `aria-label` attribute in v3.14 — verified
    // against live DOM.
    attr: {
        title: (el, s)=>el.call('polyglot', el.scope.btnLabel(s)),
        'aria-label': (el, s)=>el.call('polyglot', el.scope.btnLabel(s))
    },
    onClick: (e, el, s)=>{
        el.scope.cancelMoreClose(el);
        el.call('closeDropdown', 'appNavbarMore');
        e.preventDefault();
        const route = el.scope.hrefFor(el, s);
        if (!route) return;
        // Non-canvas apps + workspace-module pages (marketplace, announcements,
        // documents, calendar, chat, …) open INSIDE the shell PageSlot; canvas
        // surfaces (studio/agents/team-and-agents/tickets/files/views) stay
        // full-page. openAppPage owns that decision — the same idiom the header
        // tabs + apps launcher use. Forward the event so cmd/ctrl-click still arms
        // split view. Guard for hosts where openAppPage isn't registered.
        try {
            // preferSlot: navbar link → non-canvas routes open in the shell PageSlot
            // (module tabs included); canvas routes stay full-page (isCanvasRoute
            // wins). split carries the cmd/ctrl second-pane gesture.
            el.call('openAppPage', route, {
                preferSlot: true,
                split: e.metaKey || e.ctrlKey
            });
            return;
        } catch (_) {}
        el.router(route, el.getRoot());
    },
    Icon: {
        name: '{{icon}}',
        boxSize: 'A A'
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        text: (el, s)=>el.call('polyglot', s.label || '')
    }
};
const $73660997378aa2dd$export$508394f03a0d3981 = {
    // FA204 / frank trap — see the header comment on AppNavbarDropdownItem's
    // scope above for the full rationale. `menuSections` (was `_MENU_SECTIONS`)
    // is a plain computed VALUE, not a function body, so it bakes to a literal
    // array at serialization time exactly like ActivityChart's `total` —
    // still homed in scope (not left at module scope) since it's private to
    // this menu, not meant for cross-file consumption the way DROPDOWN_APPS
    // is. `cancelMoreClose`/`moreState` are duplicated verbatim from
    // AppNavbarButton/AppNavbarDropdownItem's own scopes — all three read/write
    // the SAME `el.context.__appNavbarMore` bag, so the shared open/close
    // coordination survives even though this menu, the trigger button, and
    // the dropdown-portaled row all sit in different DOM subtrees (`el.scope`
    // ancestor-inheritance would NOT connect them; `el.context` is the one
    // reference every element in the app shares regardless of mount position).
    scope: {
        menuSections: $73660997378aa2dd$export$452d4cca16549844.reduce((acc, item)=>{
            if (item.divider) acc.push([]);
            else acc[acc.length - 1].push(item);
            return acc;
        }, [
            []
        ]),
        moreState (el) {
            const ctx = el.context;
            if (!ctx.__appNavbarMore) ctx.__appNavbarMore = {
                timer: null,
                open: false
            };
            return ctx.__appNavbarMore;
        },
        cancelMoreClose (el) {
            const st = this.moreState(el);
            if (st.timer) {
                clearTimeout(st.timer);
                st.timer = null;
            }
        },
        scheduleMoreClose (el) {
            this.cancelMoreClose(el);
            const st = this.moreState(el);
            st.timer = setTimeout(()=>{
                st.timer = null;
                el.call('closeDropdown', 'appNavbarMore');
            }, 200);
        }
    },
    extends: 'MenuPanel',
    tag: 'div',
    minWidth: 'G',
    textAlign: 'left',
    onMouseenter: (ev, el)=>el.scope.cancelMoreClose(el),
    onMouseleave: (ev, el)=>el.scope.scheduleMoreClose(el),
    Section_1: {
        flow: 'y',
        childExtends: 'AppNavbarDropdownItem',
        childrenAs: 'state',
        subscribeTo: [
            '_featureFlags',
            'workspace'
        ],
        children: (el, s)=>el.scope.menuSections[0].filter((it)=>(0, $4SiPM.navItemVisible)(s.root, it))
    },
    Divider_1: {
        height: '1px',
        background: 'line',
        margin: 'Z 0'
    },
    Section_2: {
        flow: 'y',
        childExtends: 'AppNavbarDropdownItem',
        childrenAs: 'state',
        subscribeTo: [
            '_featureFlags',
            'workspace'
        ],
        children: (el, s)=>el.scope.menuSections[1].filter((it)=>(0, $4SiPM.navItemVisible)(s.root, it))
    },
    Divider_2: {
        height: '1px',
        background: 'line',
        margin: 'Z 0'
    },
    Section_3: {
        flow: 'y',
        childExtends: 'AppNavbarDropdownItem',
        childrenAs: 'state',
        subscribeTo: [
            '_featureFlags',
            'workspace'
        ],
        children: (el, s)=>el.scope.menuSections[2].filter((it)=>(0, $4SiPM.navItemVisible)(s.root, it))
    },
    Divider_3: {
        height: '1px',
        background: 'line',
        margin: 'Z 0'
    },
    Section_4: {
        flow: 'y',
        childExtends: 'AppNavbarDropdownItem',
        childrenAs: 'state',
        subscribeTo: [
            '_featureFlags',
            'workspace'
        ],
        children: (el, s)=>el.scope.menuSections[3].filter((it)=>(0, $4SiPM.navItemVisible)(s.root, it))
    },
    Divider_4: {
        height: '1px',
        background: 'line',
        margin: 'Z 0'
    },
    // VIEWS — the four canvas lenses (Frontend · Infra · Tasks · Agents),
    // mapped from VIEW_NAV into DROPDOWN_APPS above. Same AppNavbarDropdownItem
    // row + static Divider convention as every other section.
    Section_5: {
        flow: 'y',
        childExtends: 'AppNavbarDropdownItem',
        childrenAs: 'state',
        subscribeTo: [
            '_featureFlags',
            'workspace'
        ],
        children: (el, s)=>el.scope.menuSections[4].filter((it)=>(0, $4SiPM.navItemVisible)(s.root, it))
    }
};
const $73660997378aa2dd$export$9fa14be9f2b7bdf0 = {
    // FA204 / frank trap — see AppNavbarDropdownItem's scope comment above for
    // the full rationale. `isActive`/`hrefFor`/`btnLabel`/`resolveStudioPath`/
    // `unreadFor` are pure and duplicated here rather than shared with
    // AppNavbarDropdownItem's copies (object-literal scope properties can't
    // reference each other across DIFFERENT top-level components — only
    // within the SAME scope object via `this`). `isActive` carries its OWN
    // literal copy of the workspace-home path list instead of reading the
    // exported `WORKSPACE_PATHS` above — a bare in-file read of a sibling
    // export is exactly as unresolvable post-frank.toJSON as a module-local
    // const (see the readerVoice.js precedent — `readerStop`/
    // `readerBoundaryFor` were both EXPORTED and still broken bare).
    // `moreState`/`cancelMoreClose`/`openMoreDropdown`/`scheduleMoreClose`
    // read/write `el.context.__appNavbarMore` — the one reference every
    // element in the app shares regardless of subtree, which is what lets
    // this button's hover/click state coordinate with AppNavbarMoreMenu (a
    // dropdown-portaled sibling, not a DOM descendant) and
    // AppNavbarDropdownItem (same portal) without a shared module closure.
    scope: {
        isActive (s) {
            if (!s || !Object.prototype.hasOwnProperty.call(s, 'route')) return false;
            const slot = s.root?._canvasSlot;
            const path = (0, $9juhh.canonicalRoutePath)(slot ? String(slot).split('?')[0] : (0, $9juhh.stripWorkspacePrefix)(s.root?.currentPath || '/'));
            const workspacePaths = [
                '/',
                '/team-members',
                '/people',
                '/my',
                '/announcements',
                '/company',
                '/profile'
            ];
            return s.route === '/' ? workspacePaths.includes(path) : path.startsWith(s.route);
        },
        resolveStudioPath (s) {
            const root = s?.root;
            const pendingId = root?._pendingActiveOrgId;
            if (pendingId) {
                const pendingOrg = (root?.jwtClaims?.orgs || []).find((o)=>o.id === pendingId);
                if (pendingOrg?.slug) return `/studio/${pendingOrg.slug}`;
            }
            const orgSlug = root?.org?.slug;
            if (orgSlug) return `/studio/${orgSlug}`;
            // No active org: the personal studio — unless that org is the empty
            // background one beside a team (functions/visibleOrgs.js, POB round
            // 5); then the team's studio.
            const orgs = root?.jwtClaims?.orgs || [];
            const shown = (0, $dot7l.visibleOrgs)(orgs);
            const personalOrg = shown.find((o)=>o?.type === 'personal');
            if (personalOrg?.slug) return `/studio/${personalOrg.slug}`;
            if (shown !== orgs && shown[0]?.slug) return `/studio/${shown[0].slug}`;
            return '/studio';
        },
        hrefFor (el, s) {
            if (s?.key === 'studio') return this.resolveStudioPath(s);
            if (!s || !Object.prototype.hasOwnProperty.call(s, 'route')) return undefined;
            return s.route || undefined;
        },
        btnLabel (s) {
            return s?.label || (s?.key ? s.key.charAt(0).toUpperCase() + s.key.slice(1) : '');
        },
        unreadFor (s) {
            return Number(s?.root?.navUnreadCounts?.[s?.key] || 0);
        },
        moreState (el) {
            const ctx = el.context;
            if (!ctx.__appNavbarMore) ctx.__appNavbarMore = {
                timer: null,
                open: false
            };
            return ctx.__appNavbarMore;
        },
        cancelMoreClose (el) {
            const st = this.moreState(el);
            if (st.timer) {
                clearTimeout(st.timer);
                st.timer = null;
            }
        },
        openMoreDropdown (el) {
            this.cancelMoreClose(el);
            const st = this.moreState(el);
            if (st.open) return;
            el.call('openDropdown', {
                anchorEl: el,
                id: 'appNavbarMore',
                placement: 'bottom-end',
                // ORGSWITCHER-PANEL-SURFACE-1 sweep: the body (AppNavbarMoreMenu)
                // extends MenuPanel and carries `radiusCard`, so the plugin shell
                // takes the same radius and never shows its own corners behind the
                // card. Width stays where it belongs — on the body's `minWidth: 'G'`.
                round: 'radiusCard',
                content: {
                    extends: 'AppNavbarMoreMenu'
                },
                onOpen: ()=>{
                    st.open = true;
                },
                onClose: ()=>{
                    st.open = false;
                }
            });
        },
        scheduleMoreClose (el) {
            this.cancelMoreClose(el);
            const st = this.moreState(el);
            st.timer = setTimeout(()=>{
                st.timer = null;
                el.call('closeDropdown', 'appNavbarMore');
            }, 200);
        }
    },
    // Multi-extends: NavbarButton supplies the icon-rendering chain
    // (IconText → Icon child resolved from `icon: '{{ icon }}'`) plus
    // hover tooltip wiring; Link supplies tag: 'a' + attr.href so the
    // button renders as a real anchor with native middle-click + status
    // bar URL. Custom onClick below overrides Link's routerOnClick.
    extends: [
        'NavbarButton',
        'Link'
    ],
    borderWidth: '0',
    round: '100%',
    position: 'relative',
    cursor: 'pointer',
    textDecoration: 'none',
    // Active state is driven by reactive factories instead of `isActive` +
    // `.isActive` because smbls v3.14 only wires reactive effects for
    // function props that are in the CSS_PROPS_REGISTRY. `isActive` is a
    // custom boolean, so `applyConditionals` runs the check ONCE at
    // creation and freezes it. `background` and `color` ARE in the CSS
    // registry, so their factories re-run whenever `root.currentPath`
    // updates via `locationchange`.
    //
    // Theme-aware tokens: the `selected` wash (active) for the resolved
    // active background. Hover bg uses explicit `@light`/`@dark` blocks below
    // because the `overlay` token (`gray14.05` light / `gray2.05` dark) is
    // designed for translucent modal-style overlays — on the navbar's
    // light `gray15.95` background it rendered as a near-invisible muddy
    // gray patch that read as "broken" rather than "hovered" (#2206).
    //
    // The hover values mirror the brand `navbarButton` theme's own
    // `:hover` recipe (`gray13.95` light / `gray4.9` dark) so the
    // affordance matches every other navbar button surface in the system
    // — we can't just rely on the inherited theme because this component
    // sets `background` as a reactive factory (needed for the active-
    // state factory to re-evaluate on route change), and a factory at the
    // base level overrides the theme's base bg, which in turn means the
    // theme's `:hover` block alone wouldn't supply a hover bg either.
    // Setting `:hover` here with `@light`/`@dark` keeps both states
    // theme-aware end-to-end without fighting the factory.
    //
    // Color contrast — both active and inactive icons use `title`. The
    // active/inactive distinction is carried by `background` (`selected`
    // vs transparent), not by fading the icon glyph itself. Previously
    // inactive icons used `caption` (gray3 light / gray13 dark) which is a
    // secondary-text token; on the navbar's `gray15.95` light bg the glyphs
    // fell to ~3.4:1 contrast through the SVG sprite stroke, well below
    // the 7:1 we want for top-level chrome. `title` (gray1 light / gray15
    // dark) keeps the icons crisp in either theme without fighting the
    // brand `navbarButton` theme's own @light/@dark color rules.
    background: (el, s)=>el.scope.isActive(s) ? 'selected' : 'transparent',
    color: 'title',
    ':hover': {
        color: 'title',
        '@light': {
            background: 'gray13.95'
        },
        '@dark': {
            background: 'gray4.9'
        }
    },
    href: (el, s)=>el.scope.hrefFor(el, s),
    // Custom navbar tooltip uses setNavbarTooltipPosition (onMouseover);
    // we still want the native title + aria-label for accessibility +
    // middle-click status bar. el.text is empty (icon-only) — top-level
    // `aria: { label }` does NOT promote to `aria-label` in v3.14, so
    // both must live on `attr`.
    attr: {
        title: (el, s)=>el.call('polyglot', el.scope.btnLabel(s)),
        'aria-label': (el, s)=>el.call('polyglot', el.scope.btnLabel(s))
    },
    icon: '{{ icon }}',
    // SIZE-1 item 3 (tickets/sonnet.md, WAVE-G, 2026-08-14/15): every icon in
    // this row — including the Logo instance, MainNavbar.js's first child —
    // measured 22×22, just under the 24px comfortable-minimum floor. Every
    // MainNavbar icon shares this one component (no per-instance override
    // exists anywhere in MainNavbar.js), so raising the floor here fixes the
    // whole row uniformly instead of making the Logo alone a mismatched size
    // against its siblings. Literal `width`/`height` (NOT the `boxSize`
    // shorthand other Icon overrides in this file use) — the framework's own
    // base Icon component sets literal `width`/`height` directly, and mixing
    // a shorthand with its own longhand on one element is order-undefined in
    // the atomic css-in-props engine (the exact bug class already found +
    // fixed on the /reminders CheckIcon this same sweep, workspace 45a50437).
    // Same keys as the base → DOMQL's child-overrides-parent extends
    // precedence resolves it unambiguously.
    Icon: {
        width: 'iconLg',
        height: 'iconLg'
    },
    // The More button opens its dropdown on HOVER. Open fires immediately
    // on mouseenter; close is debounced 200ms on mouseleave so the cursor
    // can travel from the trigger down into the dropdown without it
    // snapping shut mid-traverse. The dropdown panel itself mirrors the
    // same enter/leave handlers (in AppHeader.js) so once the cursor is
    // over the panel the timer is canceled and re-armed on exit.
    onMouseenter: (ev, el, s)=>{
        if (s.key === 'more') el.scope.openMoreDropdown(el);
    },
    // Brand's onMouseleave calls Tooltip.update() which can't override
    // the inline styles setNavbarTooltipPosition sets; trigger the
    // slide-out animation directly instead.
    onMouseleave: (ev, el, s)=>{
        if (s.hover) {
            s.hover = false;
            el.call('setNavbarTooltipPosition', {
                visible: false
            });
        }
        if (s.key === 'more') el.scope.scheduleMoreClose(el);
    },
    onClick: (e, el, s)=>{
        // Hover already handles open/close for the More button; click still
        // toggles as an accessibility fallback (keyboard + touch users).
        // DropdownRoot's outside-click closer deliberately ignores clicks on
        // the anchor, so the toggle here is the only click path for More.
        if (s.key === 'more') {
            e.preventDefault();
            if (el.scope.moreState(el).open) {
                el.scope.cancelMoreClose(el);
                el.call('closeDropdown', 'appNavbarMore');
            } else el.scope.openMoreDropdown(el);
            return;
        }
        e.preventDefault();
        const route = el.scope.hrefFor(el, s);
        if (!route) return;
        // Non-canvas navbar links open INSIDE the shell PageSlot; canvas surfaces
        // (studio/tickets/team-and-agents/agents/files/views) stay full-page.
        // openAppPage owns that decision — the SAME idiom the More dropdown items,
        // header tabs and apps launcher already use, so the icon row no longer
        // diverges by hard-navigating every link. Forward the event so cmd/ctrl-
        // click still arms split view. Guard for hosts where openAppPage isn't
        // registered (non-shell mounts of this navbar) → plain routing.
        try {
            el.call('openAppPage', route, {
                preferSlot: true,
                split: e.metaKey || e.ctrlKey
            });
            return;
        } catch (_) {}
        el.router(route, el.getRoot());
    },
    UnreadBadge: {
        hide: (el, s)=>el.scope.unreadFor(s) === 0,
        position: 'absolute',
        top: '0',
        right: '0',
        width: 'Y',
        height: 'Y',
        round: '50%',
        background: 'red',
        pointerEvents: 'none'
    }
};
const $73660997378aa2dd$export$cb80bf6b197ce0ea = {
    // FA204 / frank trap — see AppNavbarDropdownItem's scope comment above for
    // the full rationale. `apps` (was module-scope `APPS`) and the page-title
    // resolver (was module-scope `pageTitleFor`/`_NAVBAR_TITLES`/
    // `_NAVBAR_PREFIX`) are private to this component, so they move into its
    // own scope rather than staying at module scope.
    scope: {
        apps: [
            {
                key: 'logo',
                icon: 'logov2',
                route: '/',
                label: 'shell.app.workspace'
            },
            {
                key: 'studio',
                icon: 'layers',
                route: '/studio',
                label: 'shell.app.studio'
            },
            {
                key: 'infra',
                icon: 'server',
                route: '/infra',
                label: 'shell.app.infra'
            },
            // `blocks` reads as a stacked-lego glyph — Marketplace is the
            // "browse + install apps" surface, distinct from the AddApps creator
            // page which uses the bare `plus` icon below.
            {
                key: 'marketplace',
                icon: 'blocks',
                route: '/marketplace',
                label: 'shell.app.marketplace'
            },
            {
                key: 'people',
                icon: 'people',
                route: '/team-members',
                label: 'shell.app.teamMembers'
            },
            // Tickets→Tasks rename (2026-08-06 per Nika) — internal key stays
            // 'tickets' (prefs/flag identity), the route + label are the
            // canonical user-facing form.
            {
                key: 'tickets',
                icon: 'check',
                route: '/tasks',
                label: 'shell.app.tasks'
            },
            {
                key: 'documents',
                icon: 'document',
                route: '/notes',
                label: 'shell.app.notes'
            },
            {
                key: 'files',
                icon: 'folder',
                route: '/files',
                label: 'shell.app.files'
            },
            {
                key: 'analytics',
                icon: 'analytics',
                route: '/analytics',
                label: 'shell.app.analytics'
            },
            {
                key: 'calendar',
                icon: 'date outline',
                route: '/calendar',
                label: 'shell.app.calendar'
            },
            {
                key: 'reminders',
                icon: 'clockOutline',
                route: '/reminders',
                label: 'shell.app.reminders'
            },
            // History — the built-in timeline of the workspace activity log.
            {
                key: 'history',
                icon: 'sfHistory',
                route: '/history',
                label: 'shell.app.history'
            },
            // "Team chat" (not just "Chat") differentiates from the header's
            // Messenger button ("Direct messages") — workspace-bug #2184. Glyph
            // stays `chat` (multi-dot speech-bubble = group chat); Messenger uses
            // `sfMessage` (single bubble = 1:1 DM).
            {
                key: 'chat',
                icon: 'chat',
                route: '/chat',
                label: 'shell.app.chat'
            },
            // Mail — hidden until the `mail` flag is on; the row list below is
            // filtered by navItemVisible, which resolves '/mail' → the flag.
            {
                key: 'mail',
                icon: 'email',
                route: '/mail',
                label: 'shell.app.mail'
            },
            {
                key: 'meet',
                icon: 'video',
                route: '/meet',
                label: 'shell.app.meet'
            },
            {
                key: 'company',
                icon: 'info',
                route: '/company',
                label: 'shell.app.company'
            },
            {
                key: 'addapps',
                icon: 'plus',
                route: '/add-app',
                label: 'shell.app.addApp'
            },
            {
                key: 'more',
                icon: 'arrowAngleDown',
                label: 'shell.app.more'
            }
        ],
        // Small page-title resolver — matches AppHeader's pageTitle() so the
        // label stays consistent now that PageTitle is rendered here instead.
        NAVBAR_TITLES: {
            '/calendar': 'shell.app.calendar',
            '/reminders': 'shell.app.reminders',
            '/history': 'shell.app.history',
            '/inbox': 'shell.pageTitle.inbox',
            '/chat': 'shell.app.chat',
            '/mail': 'shell.app.mail',
            // Canonical /tasks keys + legacy /tickets aliases (tickets→tasks
            // rename 2026-08-06) — the alias URLs stay reachable, so both key
            // sets label.
            '/tasks': 'shell.pageTitle.myView',
            '/tasks/my': 'shell.pageTitle.myView',
            '/tasks/general': 'shell.pageTitle.general',
            '/tasks/feed': 'shell.pageTitle.feed',
            '/tasks/canvas': 'shell.pageTitle.canvas',
            '/tasks/stories': 'shell.pageTitle.stories',
            '/tasks/epics': 'shell.pageTitle.epics',
            '/tasks/board': 'shell.pageTitle.board',
            '/tasks/standups': 'shell.pageTitle.standups',
            '/tickets': 'shell.pageTitle.myView',
            '/tickets/my': 'shell.pageTitle.myView',
            '/tickets/general': 'shell.pageTitle.general',
            '/tickets/feed': 'shell.pageTitle.feed',
            '/tickets/canvas': 'shell.pageTitle.canvas',
            '/tickets/stories': 'shell.pageTitle.stories',
            '/tickets/epics': 'shell.pageTitle.epics',
            '/tickets/board': 'shell.pageTitle.board',
            '/tickets/standups': 'shell.pageTitle.standups',
            '/meet': 'shell.app.meet',
            '/system-status': 'shell.pageTitle.systemStatus',
            '/admin/system': 'shell.pageTitle.systemStatus',
            '/team-members': 'shell.app.teamMembers',
            '/people': 'shell.app.teamMembers'
        },
        NAVBAR_PREFIX: [
            [
                '/tickets/requests',
                'shell.pageTitle.requests'
            ],
            [
                '/tickets/resolutions',
                'shell.pageTitle.resolutions'
            ],
            [
                '/tasks',
                'shell.app.tasks'
            ],
            [
                '/task/',
                'shell.app.tasks'
            ],
            [
                '/tickets',
                'shell.app.tasks'
            ],
            [
                '/meet/',
                'shell.pageTitle.call'
            ],
            [
                '/notes/',
                'shell.app.notes'
            ],
            [
                '/notes',
                'shell.app.notes'
            ],
            // Legacy alias — documents→notes rename (2026-08-06 per Nika);
            // '/documents' stays reachable so a stale deep link still titles
            // correctly.
            [
                '/documents/',
                'shell.app.notes'
            ],
            [
                '/documents',
                'shell.app.notes'
            ],
            [
                '/studio',
                'shell.app.studio'
            ],
            [
                '/infra',
                'shell.app.infra'
            ],
            [
                '/admin',
                'shell.pageTitle.admin'
            ]
        ],
        pageTitleFor (path) {
            if (!path) return 'shell.pageTitle.canvas';
            if (this.NAVBAR_TITLES[path]) return this.NAVBAR_TITLES[path];
            if (path.startsWith('/meet/') && path.endsWith('/transcript')) return 'shell.pageTitle.transcript';
            for (const [prefix, label] of this.NAVBAR_PREFIX){
                if (path.startsWith(prefix)) return label;
            }
            return 'shell.pageTitle.canvas';
        }
    },
    extends: 'IconNavbar',
    align: 'center space-around',
    gap: 'Z+V',
    hide: ()=>/^\/(login|signin|signup|reset-password|forgot-password|verify-email|signup-confirmation)/.test(window.location.pathname),
    // PageTitle ("Canvas" / "Marketplace" / etc.) renders to the right of
    // the icon row. The workspace switcher does NOT live here — it lives
    // in MainNavbar (`shared/components/MainNavbar.js:44`). The shell
    // suppresses AppNavbar via `AppNavbar: null` in `AppHeader.js:131`
    // and mounts MainNavbar in its place, so any slot declared here is
    // dead code at runtime. The previous `AppWorkspaceSwitcher: {}` slot
    // would never have rendered anyway because AppNavbar uses
    // `childrenAs: 'state' + children: apps` which silently overrides
    // named siblings.
    PageTitle: {
        tag: 'span',
        text: (el, s)=>{
            const path = s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
            return el.call('polyglot', el.scope.pageTitleFor(path));
        },
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        padding: '0 Z'
    },
    childExtends: 'AppNavbarButton',
    childrenAs: 'state',
    // Feature-flag gate: items whose route maps to a flag (navItemVisible /
    // ROUTE_FLAGS) drop out when that feature is off at /flags. Unmapped
    // items (logo, System Status, More) always render.
    subscribeTo: [
        '_featureFlags',
        'workspace'
    ],
    children: (el, s)=>el.scope.apps.filter((a)=>(0, $4SiPM.navItemVisible)(s.root, a))
};

});
parcelRegister("cEFVO", function(module, exports) {

$parcel$export(module.exports, "VIEW_NAV", () => VIEW_NAV);
$parcel$export(module.exports, "isViewNavRoute", () => isViewNavRoute);
$parcel$export(module.exports, "CanvasViewNavRow", () => CanvasViewNavRow);
$parcel$export(module.exports, "CanvasViewNavGroup", () => CanvasViewNavGroup);
$parcel$export(module.exports, "CanvasViewRail", () => CanvasViewRail);
$parcel$export(module.exports, "CanvasViewMenu", () => CanvasViewMenu);
$parcel$export(module.exports, "CanvasControlsSheet", () => CanvasControlsSheet);
// Left-rail view switcher — Frontend (/studio), Infra (/infra), Agents
// (/team-and-agents). Replaces the header "Infra" tab; shown on BOTH /studio and
// /infra so you can switch between them from either side. Lives in shared so the
// canvas + infra packages can both mount it. (2026-06-18 per Nika "add a sidebar
// section … Frontend / Infra / Agents … switched from the left sidebar … on both".)
// Exported so the AppNavbar More dropdown can mirror the same four canvas
// views (single source of truth — the navbar VIEWS section maps these into its
// own item shape rather than re-typing the routes).

var $9juhh = parcelRequire("9juhh");

var $4SiPM = parcelRequire("4SiPM");
const VIEW_NAV = [
    {
        key: 'workspaceApps',
        label: 'shell.viewNav.workspaceApps',
        icon: 'grid',
        path: '/apps'
    },
    {
        key: 'websites',
        label: 'shell.viewNav.websites',
        icon: 'globe',
        path: '/studio'
    },
    {
        key: 'infra',
        label: 'shell.viewNav.infra',
        icon: 'server',
        path: '/infra'
    },
    {
        key: 'agents',
        label: 'shell.viewNav.agents',
        icon: 'people',
        path: '/agents'
    }
];
// Current route, query-stripped. The `/w/<org-slug>` prefix is stripped so the
// intranet view routes (/infra, /tickets, /agents, …) still resolve under
// multi-workspace tabs (§6d) — no-op until Phase 3 emits the prefix.
// Kept at module scope — still used by `isViewNavRoute` below, which is a
// plain exported function (not a DOMQL prop), so it's never itself
// frank-serialized and this closure resolves fine for its own callers.
const _canvasViewNavRoutePath = (s, el)=>(0, $9juhh.stripWorkspacePrefix)((s.root?.[el?.call?.('slotPaneKeyForStrict', el)] || s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '') || '').split('?')[0]);
// Every route the switcher CONTAINS — the VIEW_NAV paths plus their aliases:
// /canvas mounts the same dashboard surface as /studio (canvas/pages/index.js),
// the agents canvas answers on three routes. (/tickets routes left with the
// Tasks entry — the switcher no longer renders on the tickets board.)
const VIEW_ROUTES = [
    ...VIEW_NAV.map((d)=>d.path),
    '/canvas',
    '/team-and-agents',
    '/my-agents'
];
const isViewNavRoute = (s, el)=>{
    const p = _canvasViewNavRoutePath(s, el);
    return VIEW_ROUTES.some((base)=>p === base || p.indexOf(base + '/') === 0);
};
const CanvasViewNavRow = {
    extends: 'AppSidebarRow',
    // FA204 / frank trap — currentView (+ its routePath dependency) used to be
    // bare module-scope functions read from inside `isActive`/`onClick`
    // factories; they read as undefined once this component is frank.toJSON'd
    // for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into this component's
    // own scope, called via `el.scope.currentView` — duplicated (not shared)
    // in CanvasViewNavGroup below since `el.scope` only resolves within the
    // tree of the SPECIFIC top-level export it's defined on.
    scope: {
        routePath (s, el) {
            const paneKey = this.canvasViewPaneKey || el?.call?.('slotPaneKeyForStrict', el);
            return (0, $9juhh.stripWorkspacePrefix)((s.root?.[paneKey] || s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '') || '').split('?')[0]);
        },
        // Which view the current route belongs to (drives the active row). Each
        // view is its own page, so this is resolved fresh on mount — switching
        // navigates.
        currentView (s, el) {
            const p = this.routePath(s, el);
            if (p.indexOf('/infra') === 0) return 'infra';
            if (p.indexOf('/agents') === 0 || p.indexOf('/team-and-agents') === 0 || p.indexOf('/my-agents') === 0) return 'agents';
            // The app split's two views (VIEW_NAV): /apps is Workspace apps; the
            // board (/studio, /canvas) is Websites.
            if (p === '/apps' || p.indexOf('/apps/') === 0) return 'workspaceApps';
            return 'websites' // /studio (+ default)
            ;
        }
    },
    isActive: (el, s)=>el.scope.currentView(s, el) === s.key,
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('closeDropdown', 'canvasViews');
        if (el.scope.currentView(s, el) === s.key && !e.metaKey && !e.ctrlKey) return;
        // Use the shell's one navigation policy: tenancy, pane intent and pins.
        if (typeof el.context?.functions?.openAppPage === 'function') {
            el.call('openAppPage', s.path, {
                preferSlot: true,
                split: e.metaKey || e.ctrlKey
            });
            return;
        }
        el.router(s.path, el.getRoot());
    }
};
const CanvasViewNavGroup = {
    // The shared group (its eyebrow law, and it resolves in the standalone
    // canvas app, which never loads the tickets package).
    extends: 'AppSidebarGroup',
    // FA204 / frank trap — duplicate of CanvasViewNavRow's scope above (el.scope
    // doesn't cross top-level export boundaries), plus VIEW_NAV/viewNavChildren
    // which only this export's `children` factory needs. VIEW_NAV itself stays
    // exported at module scope too (AppNavbar's More dropdown imports it
    // cross-file — a separate, deliberately out-of-scope concern for this fix).
    scope: {
        // MUST equal the exported VIEW_NAV above (CanvasViewNav.test.js holds the
        // two equal) — this copy is what the rail renders; the app split changed
        // only the export and the rail kept "Apps · Infra · Agents" on dev
        // (check 5, 2026-10-21).
        VIEW_NAV: [
            {
                key: 'workspaceApps',
                label: 'shell.viewNav.workspaceApps',
                icon: 'grid',
                path: '/apps'
            },
            {
                key: 'websites',
                label: 'shell.viewNav.websites',
                icon: 'globe',
                path: '/studio'
            },
            {
                key: 'infra',
                label: 'shell.viewNav.infra',
                icon: 'server',
                path: '/infra'
            },
            {
                key: 'agents',
                label: 'shell.viewNav.agents',
                icon: 'people',
                path: '/agents'
            }
        ],
        routePath (s, el) {
            const paneKey = this.canvasViewPaneKey || el?.call?.('slotPaneKeyForStrict', el);
            return (0, $9juhh.stripWorkspacePrefix)((s.root?.[paneKey] || s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '') || '').split('?')[0]);
        },
        currentView (s, el) {
            const p = this.routePath(s, el);
            if (p.indexOf('/infra') === 0) return 'infra';
            if (p.indexOf('/agents') === 0 || p.indexOf('/team-and-agents') === 0 || p.indexOf('/my-agents') === 0) return 'agents';
            // The app split's two views (VIEW_NAV): /apps is Workspace apps; the
            // board (/studio, /canvas) is Websites.
            if (p === '/apps' || p.indexOf('/apps/') === 0) return 'workspaceApps';
            return 'websites' // /studio (+ default)
            ;
        },
        // Feature-flag gate: a view toggled off at /flags drops out of the
        // switcher (navItemVisible maps each path to its flag — studio/infra/
        // tasks/agents).
        viewNavChildren (el, s) {
            return this.VIEW_NAV.filter((d)=>(0, $4SiPM.navItemVisible)(s.root, d)).map((d)=>({
                    ...d,
                    _v: this.currentView(s, el)
                }));
        }
    },
    label: 'shell.viewNav.groupLabel',
    // No bottom margin — the VIEWS nav is the only content of its card, so the
    // inherited TicketsSidebarGroup marginBottom just left dead space at the card
    // foot. (2026-06-19 per Nika "remove margin bottom from ViewSwitcher > ViewNav".)
    marginBottom: '0',
    gap: 'Y',
    Header: {
        padding: '0 Z1'
    },
    AppCapsuleBtnToolbar: {
        gap: 'Z1',
        width: '100%',
        justifyContent: 'flex-start',
        minWidth: '0',
        theme: 'transparent',
        padding: 'Y Z1',
        round: 'radiusControl',
        subscribeTo: [
            'currentPath',
            '_canvasSlot',
            '_canvasSlotSecond',
            '_featureFlags',
            'workspace'
        ],
        'aria-haspopup': 'menu',
        'aria-label': (el)=>el.call('polyglot', 'shell.viewNav.switchView'),
        Icon: {
            name: (el, s)=>el.scope.VIEW_NAV.find((v)=>v.key === el.scope.currentView(s, el))?.icon || 'layers'
        },
        Text: {
            flex: '1',
            textAlign: 'left',
            text: (el, s)=>el.call('polyglot', el.scope.VIEW_NAV.find((v)=>v.key === el.scope.currentView(s, el))?.label || 'shell.app.studio')
        },
        Icon_1: {
            name: 'chevronDown',
            boxSize: 'iconSm'
        },
        onClick: (e, el)=>{
            e.preventDefault();
            e.stopPropagation();
            el.call('openDropdown', {
                id: 'canvasViews',
                anchorEl: el,
                placement: 'bottom-start',
                content: {
                    extends: 'CanvasViewMenu',
                    scope: {
                        canvasViewPaneKey: el.call('slotPaneKeyForStrict', el)
                    }
                }
            });
        }
    },
    List: {
        hide: true,
        flow: 'y',
        gap: 'V',
        subscribeTo: [
            'currentPath',
            '_canvasSlot',
            '_canvasSlotSecond',
            '_featureFlags',
            'workspace'
        ],
        childExtends: 'CanvasViewNavRow',
        children: (el, s)=>el.scope.viewNavChildren(el, s),
        childrenAs: 'state'
    }
};
const CanvasViewRail = {
    // A fixed COLUMN of glass cards (not a single card) so /agents can mount its
    // AGENTS filter card below the VIEWS card as a separate sibling. The card
    // chrome moved from the rail onto ViewsCard. (2026-06-19 per Nika "split the
    // /agents sidebar into 2 different cards".) Each card is the sidebar card
    // (AppSidebar.js AppSidebarCard, Nika 2026-10-30 "A: navbar glass").
    position: 'fixed',
    // Clear of a drawer the assistant docks on the left (the shell's
    // `--assistant-inset-left`, zero when nothing is docked there or outside
    // the shell — the token-only zero fallback the page rails use).
    left: 'calc(var(--assistant-inset-left, calc(var(--spacing-A) * 0)) + var(--spacing-X2))',
    // --shell-top (registered @property in app.js, so it resolves to the SAME px
    // here as on the app content pad / PageSlot / every other canvas rail) — was
    // a stale hardcoded 'D1' that left this rail ~16px lower than the shared
    // inset. Bare custom-property name so scratch wraps it in var() once (a
    // 'var(...)'/calc value compiles to an empty atomic rule). No bottom anchor:
    // the rail keeps its natural height so the canvas below the cards stays
    // pannable — a full-height container would eat those pointer events.
    // (2026-07-03 per Nika "same layout and positioning" across /studio /infra
    // /tickets /agents.)
    top: '--shell-top',
    width: 'G1',
    minWidth: 'G1',
    maxWidth: 'G1',
    zIndex: '1200',
    flow: 'y',
    gap: 'Z',
    fontSize: 'Z',
    pointerEvents: 'auto',
    childExtends: 'AppSidebarCard',
    ViewsCard: {
        flexShrink: '0',
        ViewNav: {
            extends: 'CanvasViewNavGroup'
        }
    }
};
const CanvasViewMenu = {
    extends: [
        'MenuPanel',
        'CanvasViewNavGroup'
    ],
    // The portal keeps the pane that opened it, so its labels and navigation
    // follow that pane rather than the background canvas.
    onCreate: (el)=>{
        if (el.scope.canvasViewPaneKey) el._slotPaneKey = el.scope.canvasViewPaneKey;
    },
    Header: null,
    AppCapsuleBtnToolbar: null,
    minWidth: 'G1',
    padding: 'Z',
    List: {
        hide: false,
        childProps: {
            role: 'menuitemradio',
            'aria-checked': (el, s)=>String(el.scope.currentView(s, el) === s.key)
        }
    }
};
const CanvasControlsSheet = {
    extends: 'MobileRailSheet',
    stateKey: '_canvasRailOpen',
    railLabel: (el)=>el.call('polyglot', 'shell.phoneNav.pageMenu'),
    Card: {
        Content: {
            flow: 'y',
            gap: 'A',
            CanvasViewNavGroup: {}
        }
    }
};

});

parcelRegister("dot7l", function(module, exports) {

$parcel$export(module.exports, "visibleOrgs", () => $9c041a65bfff871b$export$8776df1f7f82fe1f);
// visibleOrgs — THE ONE RULE for which of the person's orgs a list OFFERS.
//
// Every account owns one personal org (server rule, Nika 2026-10-25: "the
// personal org stays in the background"). POB persona round 5: a person who
// signed up as a team saw two orgs — the team and an extra "My workspace"
// (the personal org, made empty with the default name). Nika 2026-10-31
// (STATUS r122 option 1): the server marks each personal-org row of /auth/me
// `organizations[]` with `hasContent` (true when that org holds any project,
// app or workspace content), and the client hides an empty one.
//
// Hidden = a row with ALL of:
//   - `type === 'personal'` and `role === 'owner'` — the person's OWN personal
//     org. Someone else's personal org reached through a workspace grant
//     (role 'contributor') is a real place they were invited to; it stays.
//   - `hasContent === false` — the server says it is empty. A row WITHOUT the
//     field (a server that predates it) keeps the old behaviour: shown. Only
//     a real boolean `false` hides.
//   - the list also holds a row that is not personal (a team org, or a legacy
//     claims row without `type`). A solo account keeps its only org, so a
//     non-empty list never comes back empty.
//   - not named in `opts.keep` (ids or slugs) — the org the person is IN, the
//     one an in-tab switch is moving to, or the one the URL names. Hiding is
//     for lists and pickers only; a deep link to the personal org must still
//     resolve and show where the person is.
//
// Callers: the org switcher's `rawOrgs` reads (components/AppOrgSwitcher.js),
// the Studio link fallback (components/AppNavbar.js), the shell's bare `/w`
// hub (workspace pages/workspaceHub.js, through el.call).
//
// Pure: reads only its arguments (`this` is the calling element under
// el.call and is not read). Returns the SAME array when nothing is hidden.
function $9c041a65bfff871b$export$8776df1f7f82fe1f(orgs, opts) {
    const list = Array.isArray(orgs) ? orgs : [];
    if (!list.length) return list;
    const keep = new Set((opts && Array.isArray(opts.keep) ? opts.keep : []).filter((v)=>v !== null && v !== undefined && v !== '').map(String));
    const hasTeam = list.some((o)=>!!o && o.type !== 'personal');
    if (!hasTeam) return list;
    const kept = (o)=>keep.has(String(o.id || o._id || '')) || !!o.slug && keep.has(String(o.slug));
    const hidden = (o)=>!!o && o.type === 'personal' && o.role === 'owner' && o.hasContent === false && !kept(o);
    if (!list.some(hidden)) return list;
    return list.filter((o)=>!hidden(o));
}

});


parcelRegister("f2VIv", function(module, exports) {

$parcel$export(module.exports, "MainNavbar", () => $af43d04333d63133$export$345e818074809db);

var $4SiPM = parcelRequire("4SiPM");
// MainNavbar — icon-only navbar with the org/workspace switchers folded in.
//
// Same chrome as AppNavbar (IconNavbar / `navbar` theme), but uses explicit
// named children instead of childrenAs:'state' + children:APPS so additional
// named-key siblings (AppWorkspaceSwitcher, WorkspaceSwitcher, Vr, future
// breadcrumb pieces) can render alongside the icon row. childrenAs:'state'
// silently overrides named children in DOMQL — explicit keys avoid that.
const $af43d04333d63133$var$appBtn = (state)=>({
        extends: 'AppNavbarButton',
        state: state
    });
const $af43d04333d63133$export$345e818074809db = {
    extends: 'IconNavbar',
    // Drop the IconNavbar chrome so MainNavbar reads as part of one
    // continuous header row rather than a chip-shaped island. AppHeader
    // already supplies the outer flex container. Width: 100% lets the
    // contents span the full row so SecondApps can pin to the right via
    // `marginLeft: auto`.
    background: 'transparent',
    backdropFilter: 'none',
    padding: '0',
    round: '0',
    width: '100%',
    flex: '1 1 0',
    minWidth: '0',
    align: 'center',
    gap: 'Z+V',
    // Read the path from reactive root state, NOT `window.location` —
    // the router updates `state.root.currentPath` via History API, but
    // `window.location.pathname` reads are not reactive deps for DOMQL.
    // Using window.location meant `hide` evaluated once at first paint
    // (on /login → true → hidden) and the navbar stayed hidden post-
    // login until a full page reload because the route change didn't
    // invalidate this binding. Reading from `s.root.currentPath` tracks
    // the SPA route change reactively; window.location is the fallback
    // for the very first paint before the router seeds currentPath.
    hide: (el, s)=>{
        const path = s && s.root && s.root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
        return /^\/(login|signin|signup|reset-password|forgot-password|verify-email|signup-confirmation)/.test(path);
    },
    Logo: $af43d04333d63133$var$appBtn({
        key: 'logo',
        icon: 'logov2',
        route: '/',
        label: 'shell.app.workspace'
    }),
    // Org switcher, sitting immediately after the Logo. The workspace-level
    // switcher lives on the studio canvas itself (see WsSwitcher inside
    // WorkspaceViews in canvas/pages/studios.js) — having both here meant the
    // same control showed up twice on /studio routes. The canvas one stays
    // because it sits adjacent to the workspace title and reads as
    // workspace-scoped chrome, while the navbar is for global app navigation.
    AppOrgSwitcher: {},
    // Vertical separator between switchers and the first app group. Bare-key
    // auto-extends brand's `Vr` (VerticalLine). `_1`/`_2` suffix lets DOMQL
    // mount two instances of the same component without key collision; both
    // still auto-extend `Vr` because the resolver strips everything after `_`.
    // Brand `Vr` ships with `theme:'line'` + 1px width but no height, so the
    // `alignSelf: stretch` keeps it visible in a flex row with no content of
    // its own. Margin override trims the brand's `0 D` default to a tighter Z.
    Vr_1: {
        alignSelf: 'stretch',
        margin: '0 Z'
    },
    FirstApps: {
        extends: 'Flex',
        flow: 'x',
        align: 'center',
        gap: 'Z+V',
        Studio: $af43d04333d63133$var$appBtn({
            key: 'studio',
            icon: 'layers',
            route: '/studio',
            label: 'shell.app.studio'
        }),
        // `blocks` (stacked lego pieces) reads as "installed apps" — clearer
        // than the previous generic `grid`/`plus` glyphs.
        Marketplace: $af43d04333d63133$var$appBtn({
            key: 'marketplace',
            icon: 'blocks',
            route: '/marketplace',
            label: 'shell.app.marketplace'
        }),
        // /team-and-agents replaces /people in the navbar — gives the
        // hierarchy view top billing while keeping the flat People directory
        // available from the More dropdown. `people` glyph reads as team /
        // org-chart equally well.
        TeamAndAgents: $af43d04333d63133$var$appBtn({
            key: 'teamandagents',
            icon: 'people',
            route: '/team-and-agents',
            label: 'shell.app.teamAndAgents'
        }),
        Tickets: $af43d04333d63133$var$appBtn({
            key: 'tickets',
            icon: 'check',
            route: '/tasks',
            label: 'shell.app.tasks'
        }),
        Documents: $af43d04333d63133$var$appBtn({
            key: 'documents',
            icon: 'document',
            route: '/notes',
            label: 'shell.app.notes'
        }),
        // /analytics is the project / site visitor dashboard (the main
        // analytics surface). Workspace usage, world-map demographics and the
        // logs surface live under /workspace-analytics (+ /workspace-analytics/
        // logs); the AnalyticsNavbar tab strip links across them. Old /logs URL
        // still redirects (see pages/logs-redirect.js).
        Analytics: $af43d04333d63133$var$appBtn({
            key: 'analytics',
            icon: 'analytics',
            route: '/analytics',
            label: 'shell.app.analytics'
        })
    },
    // The global search pill. Definition + dropdown wiring now live in the
    // standalone `HeaderSearch` component (shared/components/HeaderSearch.js);
    // the bare key auto-extends it. MainNavbar only sets the middle-slot
    // layout (stretch to fill the row); the flat AppHeader pins it to a fixed
    // centered pill instead.
    HeaderSearch: {
        flex: '1 1 0',
        minWidth: '0',
        maxWidth: 'none',
        margin: '0 A'
    },
    // SecondApps (chrome group) — pinned to the right edge via
    // `marginLeft: auto`. Vr_2 follows AFTER the group so the vertical
    // rule sits on the RIGHT side of group 2 (between the chrome apps
    // and the AppHeader's UserActions cluster).
    SecondApps: {
        extends: 'Flex',
        flow: 'x',
        align: 'center',
        gap: 'Z+V',
        marginLeft: 'auto',
        Calendar: $af43d04333d63133$var$appBtn({
            key: 'calendar',
            icon: 'date outline',
            route: '/calendar',
            label: 'shell.app.calendar'
        }),
        // "Team chat" (not just "Chat") differentiates from the header's
        // Messenger button ("Direct messages") — workspace-bug #2184. Glyph
        // stays `chat` (multi-dot speech-bubble = group chat); Messenger uses
        // `sfMessage` (single bubble = 1:1 DM).
        Chat: $af43d04333d63133$var$appBtn({
            key: 'chat',
            icon: 'chat',
            route: '/chat',
            label: 'shell.app.chat'
        }),
        // Mail (/mail). MainNavbar names its children explicitly instead of
        // filtering a list through navItemVisible the way AppNavbar does, so the
        // feature gate has to ride on the entry itself — an ungated Mail button
        // would render for every workspace while the `mail` flag is still off.
        // `subscribeTo` re-runs this `hide` when the flag flips at /flags (a
        // root-state read inside a factory does not auto-subscribe).
        Mail: {
            ...$af43d04333d63133$var$appBtn({
                key: 'mail',
                icon: 'email',
                route: '/mail',
                label: 'shell.app.mail'
            }),
            subscribeTo: [
                '_featureFlags',
                'workspace'
            ],
            hide: (el, s)=>!(0, $4SiPM.navItemVisible)(s && s.root, '/mail')
        },
        // Meet opens the new-call modal in place (MeetNewRoomModal, shell-mounted)
        // instead of routing to /meet. Seeds newRoomDraft like the /meet page does.
        Meet: {
            ...$af43d04333d63133$var$appBtn({
                key: 'meet',
                icon: 'video',
                label: 'shell.app.meet'
            }),
            onClick: (e, el)=>{
                if (e && e.preventDefault) e.preventDefault();
                if (e && e.stopPropagation) e.stopPropagation();
                el.call('openNewRoomModal', {
                    name: '',
                    kind: 'room',
                    transcribeEnabled: true,
                    isPrivate: false
                });
            }
        },
        // Company removed from the main row — still accessible via the
        // More dropdown (DROPDOWN_APPS in AppNavbar.js). Keeps the chrome
        // group tight; Company is an infrequent destination.
        // `+` opens the AddApps creator page (prompt-driven page builder
        // backed by the freestyler logic + SDK AI service). Marketplace's
        // browse surface is now in FirstApps with the `blocks` glyph.
        AddApp: $af43d04333d63133$var$appBtn({
            key: 'addapps',
            icon: 'plus',
            route: '/add-app',
            label: 'shell.app.addApp'
        }),
        More: $af43d04333d63133$var$appBtn({
            key: 'more',
            icon: 'arrowAngleDown',
            label: 'shell.app.more'
        })
    },
    // Vertical separator on the RIGHT side of SecondApps — visually
    // closes the navbar's content row and divides the in-app chrome
    // (left + middle + right groups) from the AppHeader's external
    // UserActions cluster (Messenger / Notifications / Profile / etc.).
    Vr_2: {
        alignSelf: 'stretch',
        margin: '0 Z'
    }
};

});

parcelRegister("dffuU", function(module, exports) {

$parcel$export(module.exports, "HeaderSearch", () => $9a48b2902c9da65c$export$cc8ef7a459258dee);
// HeaderSearch — the global "Search across everything…" pill.
//
// Extracted from MainNavbar (2026-06-08 per Nika "unwrap AppHeader to one
// flex navbar"): both the flat AppHeader and the icon-row MainNavbar (the
// canvas + analytics headers) now reference this ONE definition by key
// instead of duplicating the search / apps-dropdown wiring. Each consumer
// sets its OWN layout — MainNavbar stretches it (`flex: 1`), AppHeader pins
// it to a fixed centered pill (`width: H3`) — while the shared chrome and
// behaviour live here.
//
// Wiring: `el.call('globalSearch', value)` populates `root.navSearchResults`
// + `root._navSearchGrouped`; the Dropdown.ResultGroups slot renders them
// via `NavSearchResultGroup`. The apps launcher (`openSearchAppsDropdown`)
// opens on an empty-input focus and is registered by the WORKSPACE
// functions package — guarded so shells without it keep a plain input.
const $9a48b2902c9da65c$export$cc8ef7a459258dee = {
    // FA204 / frank trap — openSearchSurface/chevronOpen used to be bare
    // module-scope functions read from inside `onMousedown`/`onClick`/`onFocus`
    // factories; they read as undefined once this component is frank.toJSON'd
    // for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`;
    // chevronOpen calls its sibling via `this.openSearchSurface` (object-
    // literal properties can't see each other as bare identifiers — only
    // `el.scope.<name>()` binds `this` to the scope bag).
    scope: {
        // ONE open policy for every trigger (chevron click + input focus): text
        // in the field re-runs the query (globalSearch owns _navSearchOpen), and
        // the workspace apps launcher opens either way — with text it lists the
        // results itself (9A, the one search dropdown). Open-only and
        // idempotent — ensureSearchLauncher opens only when the launcher is not
        // already the open layer — so the two triggers can never toggle each
        // other net-closed. The functions are registered by the WORKSPACE
        // package; shells without them keep a plain input.
        // `el` is always the search INPUT (every caller passes it: the input's own
        // onFocus, chevronOpen's resolved `input`, the Cmd+K handler). `anchor` is
        // the PILL — the panel is positioned and width-measured off it. The two are
        // passed separately on purpose: `restoreEl` is the a11y focus-restore
        // target the dropdown plugin re-focuses on close, and that must be the
        // input the user is typing in, never the pill (A2-08 — see
        // workspace/functions/searchApps.js openSearchAppsDropdown).
        openSearchSurface (el, anchor) {
            const q = (el?.node?.value || '').trim();
            try {
                // THE ONE SEARCH DROPDOWN (9A — DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1):
                // the launcher opens for text too — with text it shows the results
                // itself (workspace SearchAppsMenu). The query re-runs as before.
                if (q) el.call('globalSearch', q);
                el.call('ensureSearchLauncher', {
                    anchorEl: anchor || el,
                    restoreEl: el
                });
            } catch (err) {
                console.warn('[HeaderSearch] search open unavailable:', err);
            }
        },
        // Chevron trigger body — focus the input (a no-op when already focused,
        // so no spurious focus event) and run the shared open policy.
        chevronOpen (e, el) {
            e.preventDefault();
            e.stopPropagation();
            const input = el.parent?.Form?.Input;
            if (input?.node?.focus) input.node.focus();
            this.openSearchSurface(input || el, el.parent || el);
        },
        // The keys the ⌘K hint names on THIS device. The binding
        // (onDocumentKeydown) takes either modifier on every platform; the
        // hint names the one printed on the keyboard in front of the user.
        shortcutKeys () {
            const nav = typeof navigator === 'undefined' ? null : navigator;
            const platform = String(nav && (nav.userAgentData && nav.userAgentData.platform || nav.platform || nav.userAgent) || '');
            return [
                /mac|iphone|ipad|ipod/i.test(platform) ? "\u2318" : 'Ctrl',
                'K'
            ];
        }
    },
    extends: 'SearchBar',
    round: 'radiusPill',
    position: 'relative',
    // ON THE ROW CENTRE LINE. SearchBar carries an optical `margin:
    // '-V - - -'` — a NEGATIVE TOP margin (0.0902em, 1.63px at this pill's
    // font size) — and this pill is absolutely centred by its consumer
    // (`top: 50%` + translate), so that nudge lifted it off the centre line:
    // measured live at 1920px, the search read y2 while the leading bar, the
    // tab strip and the trailing bar all read y5. A real value, never null —
    // a null CSS prop deletes the inherited declaration instead of setting
    // one. MainNavbar already passes its own `margin: '0 A'` at the mount, so
    // the icon-row variant is unaffected.
    margin: '0',
    // The PILL is not a tab stop — its input is (A2-08 companion). SearchBar
    // extends the legacy `DropdownParentFocus`, whose `tabindex: '0'` exists so
    // a CSS-only `:focus-within` panel can be reached by keyboard. HeaderSearch
    // never ships that reveal (its results panel is state-gated and its launcher
    // is a @symbo.ls/dropdown layer), so the attribute bought nothing and cost
    // two real defects:
    //   • a DUPLICATE tab stop — Tab landed on the `<search>` wrapper, then on
    //     the input inside it, for one control;
    //   • a focus TRAP — closeDropdown re-focuses the closing layer's
    //     `restoreEl`, and a focusable wrapper accepted that focus. Tabbing out
    //     of the field fired the launcher's own blur-close 200ms later, which
    //     threw focus back onto the pill: measured live, Tab could never leave
    //     the search field (Input → ClearSearchMorph → HomeBtn → back to the
    //     pill, forever).
    // Without the attribute the wrapper is unfocusable, so the plugin's restore
    // is a no-op on it and the trap cannot form. `:focus-within` is unaffected —
    // it matches on a DESCENDANT holding focus and never needed the tabindex.
    tabindex: null,
    // SEARCH-1 (2026-08-14, per Nika review — Slack/Linear/Notion/GitHub all
    // bind Cmd+K): global keyboard shortcut so search opens from anywhere, not
    // just by clicking the pill. Bound once per mounted instance (guarded —
    // AppHeader + MainNavbar can each carry their own HeaderSearch, and only
    // the visible one's input receives focus in practice) and torn down on
    // unmount so a hidden/removed navbar variant never leaves a dangling
    // document-level listener. Focusing the input re-uses the SAME open policy
    // every other trigger (chevron, click) already funnels through — this
    // never invents a second "how search opens" path.
    // FA503: declared, so the registration IS the "bound once per mounted
    // instance" guarantee the note above describes — DOMQL registers this
    // document listener once when the element takes its node and removes it in
    // dispose(). The `__hsKbBound` / `__hsKbUnbind` pair of fields, and the
    // `onDestroy` hook that existed only to run the un-binder, are gone.
    onDocumentKeydown: (ev, el, s)=>{
        if (!(ev.metaKey || ev.ctrlKey) || ev.key?.toLowerCase() !== 'k') return;
        ev.preventDefault();
        const input = el.Form?.Input;
        if (!input?.node) return;
        // THE SHORTCUT REVEALS THE PILL. In the flat AppHeader this pill is the
        // search MORPH — opacity 0 and no pointer events until `_headerSearchOpen`
        // — and ⌘K used to focus that invisible input and open the launcher
        // under it, so typed text went into a field nobody could see (live on
        // dev 0ffad3a40, 2026-09-26). This is the open SearchBtn performs, with
        // whatever held focus before the shortcut as the return target when the
        // search closes. Where no morph reads the flag (MainNavbar's always-
        // visible pill) it only says "search is open".
        const root = s && s.root;
        if (root && !root._headerSearchOpen) {
            // Focus goes back where it was when the search closes — or, when
            // nothing held it (the page body), to the control that owns the pill
            // (the host names it: AppHeader's SearchBtn). Without a return target
            // Escape left focus on the hidden input and the launcher it keeps open
            // (live on dev 2c2b6d978).
            const prev = typeof document === 'undefined' ? null : document.activeElement;
            const held = prev && prev !== document.body && !(el.node && el.node.contains(prev));
            const back = held ? prev : el.scope.searchReturnTarget ? el.scope.searchReturnTarget(el) : null;
            if (back) root.__headerSearchReturnFocusTo = back;
            root.update({
                _headerSearchOpen: true
            });
        }
        input.node.focus();
        input.node.select?.();
        el.scope.openSearchSurface(input, el);
    },
    // Right-edge chevron — a REAL trigger for the same open the input focus
    // performs. It cannot stay decorative (pointerEvents:none pass-through):
    // an already-focused input re-fires no focus event, so after any dismissal
    // that keeps focus the pass-through click opened nothing. onMousedown
    // preventDefault keeps the press from blurring the input, so the 200ms
    // blur-close timer never races the open.
    ArrowDown: {
        extends: 'Icon',
        name: 'arrowAngleDown',
        position: 'absolute',
        right: 'A',
        top: '50%',
        transform: 'translateY(-50%)',
        color: 'caption',
        boxSize: 'A',
        cursor: 'pointer',
        role: 'button',
        'aria-label': (el)=>el.call('polyglot', 'shell.headerSearch.openDropdown'),
        // Mousedown-first like the HeaderTabs triggers (re-render node swaps eat
        // click events; preventDefault also keeps the press from blurring the
        // input, so the 200ms blur-close never races the open). onClick remains
        // as the keyboard/assistive path — both are idempotent.
        onMousedown: (e, el)=>{
            if (e.button === 0) el.scope.chevronOpen(e, el);
        },
        onClick: (e, el)=>el.scope.chevronOpen(e, el)
    },
    Form: {
        // SearchBar sizes this glyph with `fontSize: 'Z1'` and no box. Icon's box
        // comes from width/height, and the spacing scale is em-relative, so the
        // glyph tracked whatever font-size this slot inherited — measured 15.54px
        // against the header row's other controls. Overridden HERE rather than in
        // SearchBar: that component is generic and every other search bar renders
        // correctly on its own font-size.
        // The launcher's PIXEL search glyph (dropdowns spec 2026-09-30, Nika's pick): whole cells at iconSm.
        Icon: {
            name: 'pxSearch',
            boxSize: 'iconSm'
        },
        Input: {
            // THE CONTROL SCALE OF THIS VARIANT — one step down the spacing
            // sequence from SearchBar's `Y1`, horizontal insets unchanged (`B2`
            // clears the chevron, `C` clears the glyph).
            //
            // The pill is as tall as this input (line box + 2 × vertical padding)
            // and the spacing sequence is em-relative, so at the header's
            // `fontSize: '1.0625rem'` (18.0625px) `Y1` resolved to 8.528px a side
            // and the search rendered 41px against the 38px row every other
            // header bar shares. `Y` resolves to 6.900px, which lands the input at
            // 37.80px inside the pill's `HEADER_ISLAND_MIN_HEIGHT` box (38.42px) —
            // the islands' own gauge. The type size is deliberately NOT part of
            // the cure: it stays the shell's search/prompt context.
            //
            // Declared HERE, on the variant, rather than at AppHeader's mount:
            // Rule 68 bans a call-site padding override and prescribes exactly
            // this — a named variant with its own control scale. SearchBar keeps
            // `Y1` for every other search bar in the product.
            // See __tests__/headerSearchRowHeight.test.js.
            padding: 'Y B2 Y C',
            round: 'radiusPill',
            border: 'none',
            borderWidth: '0',
            borderStyle: 'none',
            theme: 'transparent',
            outline: 'none',
            appearance: 'none',
            boxShadow: 'none',
            placeholder: (el)=>el.call('polyglot', 'shell.headerSearch.placeholder'),
            // The command names its shortcut to assistive technology (the
            // keycaps beside it stay visual): onDocumentKeydown takes either
            // modifier on every platform.
            ariaKeyshortcuts: 'Meta+K Control+K',
            value: (el, s)=>s.root?.navSearchQuery || '',
            // Focus always opens SOMETHING (the old empty-only guard dead-ended on
            // stale text a dismissal left in the uncontrolled input): the launcher
            // opens, and text re-runs the search so its results come back (9A: the
            // launcher lists them). Anchor on the pill (two parents up: Input →
            // Form → HeaderSearch) so the panel aligns + sizes to the FULL search
            // width.
            onFocus: (e, el)=>{
                // A close restores focus HERE (this input is the layer's a11y restore
                // target — A2-08), so a focus arriving right after a dismissal is the
                // close's own doing, not the user's. Re-opening on it made Escape,
                // outside-click and tile picks look inert. Deliberate focus (a click
                // into the field, Cmd+K, the chevron) arrives outside that window.
                try {
                    if (el.call('searchAppsJustDismissed')) return;
                } catch (_) {}
                el.scope.openSearchSurface(el, el.parent?.parent || el);
            },
            // Close on blur — debounced so a tile mousedown in the shell-root panel
            // (which blurs the input) still lands its click before the close; the
            // panel's own mouseenter cancels the timer while the cursor is inside.
            onBlur: (e, el)=>{
                try {
                    el.call('scheduleSearchAppsClose');
                } catch (err) {
                    console.warn('[HeaderSearch] scheduleSearchAppsClose unavailable:', err);
                }
                // The results panel is state-gated (the :focus-within reveal never
                // ships — see the Dropdown block below), so blur must close it too,
                // with the same grace period so an in-panel click still lands first.
                const pill = el.parent?.parent;
                setTimeout(()=>{
                    if (pill?.node && pill.node.contains(document.activeElement)) return;
                    // 9A — the launcher is the search's ONE dropdown (it hosts the
                    // results), so focus INSIDE it (a tile, a result row) is focus
                    // inside the search, exactly as scheduleSearchAppsClose (workspace
                    // searchApps.js) counts it. A primary press on a tile moves focus
                    // there; ending the search here closed the launcher 200 ms into a
                    // slow press or a tile drag (DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1).
                    const active = document.activeElement;
                    if (active && typeof active.closest === 'function' && active.closest('[data-smbls-dropdown="panel"]') && typeof el?.context?.functions?.searchLauncherIsOpen === 'function' && el.call('searchLauncherIsOpen')) return;
                    // A result row's "Pin to navbar" context menu (NavSearchResultItem.
                    // onContextmenu, workspace/components/NavSearchDropdown.js — opened
                    // with `fromNavSearch: true`) blurs this input BY DESIGN: the house
                    // ContextDropdown is a single global portal mounted OUTSIDE this
                    // pill's subtree, so it can never satisfy the `contains` check
                    // above the way an in-panel click does. Respect it the same way
                    // scheduleSearchAppsClose (searchApps.js) respects a still-focused
                    // input — skip the close while it's up — and resume the instant it
                    // closes: Escape / outside click / the Pin action itself all null
                    // out `contextDropdown` (see ContextDropdown.js), so there is
                    // nothing here to separately track or clean up.
                    const dd = el.state?.root?.contextDropdown;
                    if (dd && dd.open && dd.fromNavSearch) return;
                    if (typeof el?.context?.functions?.closeNavSearch === 'function') el.call('closeNavSearch');
                }, 200);
            },
            // A2-08 — until 9A the first keystroke closed the apps launcher. Pre
            // FW-DROPDOWN-CLOSE-RESTORES-FOCUS-UNCONDITIONALLY-1, @symbo.ls/dropdown's
            // closeDropdown re-focused the closing layer's `restoreEl`
            // UNCONDITIONALLY; that target is set at OPEN time (onFocus, above, and
            // the ensureSearchLauncher call here) and must be THIS input — when it
            // defaulted to the anchor pill, the close moved focus onto the pill's
            // own focusable `<search>` element and every keystroke after the first was
            // dropped, so the field kept only 'w' of 'warranty'. closeDropdown now
            // restores only when the close would otherwise lose focus, but this
            // input is still passed as `restoreEl` explicitly for the other close
            // paths (Escape, outside-click) that DO need to land here rather than
            // on the pill.
            onInput: (e, el)=>{
                el.call('globalSearch', e.target.value);
                // The launcher STAYS OPEN while typing (9A): it is the one search
                // dropdown, and with text it lists the results in place of the tiles.
                // `ensureSearchLauncher` opens it only when it is not already the open
                // layer (a dismissal closed it) — never a re-mount per keystroke.
                try {
                    el.call('ensureSearchLauncher', {
                        anchorEl: el.parent?.parent || el,
                        restoreEl: el
                    });
                } catch (err) {
                    console.warn('[HeaderSearch] search launcher (input) unavailable:', err);
                }
            },
            onKeydown: (e, el)=>{
                // SEARCH-1 (2026-08-14): Down/Up move the keyboard selection through
                // the grouped results; Enter opens whatever's highlighted (or the
                // top hit if nothing's been arrow-key-selected yet). All three
                // preventDefault so the caret never moves / the form never submits.
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    el.call('moveNavSearchSelection', 1);
                    return;
                }
                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    el.call('moveNavSearchSelection', -1);
                    return;
                }
                if (e.key === 'Enter') {
                    e.preventDefault();
                    el.call('activateNavSearchSelection');
                    return;
                }
                if (e.key !== 'Escape') return;
                // Nothing to close: the morph is already down (focus came back to the
                // hidden field after a dialog closed — live on dev 2ffb10c23,
                // 2026-10-01). Leave the key for the layer below. `false`, not falsy:
                // where the morph flag is never used (MainNavbar's icon row) the field
                // still closes its own search.
                if (el?.state?.root?._headerSearchOpen === false) return;
                // The close SPENDS the key: one Escape, one layer — a lower document
                // layer (home customize mode under the open search) must not act on
                // the press that closed the search (fw-wl, dev e004fe4ec, 2026-09-30).
                if (typeof e.preventDefault === 'function') e.preventDefault();
                if (typeof el?.context?.functions?.closeNavSearch === 'function') el.call('closeNavSearch');
                // Collapse the AppHeader search morph back to the tab bar (no-op
                // where _headerSearchOpen isn't used, e.g. MainNavbar's icon row).
                try {
                    el.state?.root?.update?.({
                        _headerSearchOpen: false
                    });
                } catch (err) {
                    console.warn('[HeaderSearch] failed to clear _headerSearchOpen:', err);
                }
                // Clear the uncontrolled input too — closeNavSearch only resets state,
                // and residual text used to dead-end the next focus-open.
                if (el.node) el.node.value = '';
                el.node?.blur?.();
            }
        },
        // THE ⌘K HINT (DESIGN_SPEC §5.4 and the search launcher row: "⌘K keycap
        // in the pill", ref r072) — the kit's AppKeycap, one cap per key, shown
        // because the shortcut is wired (onDocumentKeydown above). It floats over
        // the Input's end, a `Y` step before the end control — here the chevron
        // (right A, box A); the AppHeader morph restates `right` for its Close X —
        // so the Input keeps the pill's FULL width and the global focus ring
        // outlines the whole pill. (An in-flow version shrank the Input and the
        // ring cut through the K cap — live on dev 2c2b6d978.) The caps show only
        // while the field is empty, so typed text never meets them, and the short
        // placeholder ends far before them; gone on a phone, which has no
        // shortcut keys.
        Shortcut: {
            position: 'absolute',
            right: 'calc(A + A + Y)',
            top: '50%',
            transform: 'translateY(-50%)',
            flow: 'x',
            align: 'center',
            gap: 'W',
            ariaHidden: 'true',
            pointerEvents: 'none',
            subscribeTo: [
                'navSearchQuery'
            ],
            visibility: (el, s)=>(s.root?.navSearchQuery || '').trim() ? 'hidden' : 'visible',
            childExtends: 'AppKeycap',
            children: (el)=>el.scope.shortcutKeys().map((text, i)=>({
                        key: 'k' + i,
                        text: text
                    })),
            '@mobileL': {
                display: 'none'
            }
        }
    },
    // Grouped-results renderer. SearchBar extends DropdownParentFocus which
    // CSS-shows the dropdown on `:focus-within` — so gate on `_navSearchOpen`
    // (set true by globalSearch on a non-empty query; cleared by closeNavSearch
    // / Escape) so the panel only appears once a real search is in flight.
    Dropdown: {
        // Element-level subscription so the hide flip is guaranteed to re-render
        // when globalSearch/closeNavSearch write the flag (the factory alone isn't
        // re-run reliably without it — same pattern as AppHeader's morph gate).
        // `_searchResultsInLauncher` (9A — the ONE search dropdown): a shell whose
        // launcher hosts the typed results itself declares it (the workspace
        // shell, state-app.js), and this panel then never shows — one dropdown,
        // never two. A shell that does not declare it keeps this panel as before.
        subscribeTo: [
            '_navSearchOpen'
        ],
        hide: (el, s)=>!s.root?._navSearchOpen || !!s.root?._searchResultsInLauncher,
        // `_navSearchOpen` (via hide) is the ONE visibility gate. The base
        // Dropdown ships opacity:0/visibility:hidden expecting the
        // DropdownParentFocus ':focus-within' reveal — dead CSS until
        // smbls@5b479eb85 (see the DONE ticket in tickets/smbls.md), and even
        // fixed it is the wrong gate for a QUERY-driven panel (focus ≠ has
        // results). Assert the visible state statically; presence is
        // state-driven above. The inherited ':focus-within' block still reaches
        // the pill — pseudo blocks DEEP-MERGE across extends (measured on the
        // served element 2026-09-24: z-index 1000 + this reveal, one rule) — and
        // its reveal is inert here because this panel is already visible and
        // state-gated. AppHeader adds no focus paint of its own: focus is the
        // global ring on the input.
        opacity: '1',
        visibility: 'visible',
        transform: 'translate3d(0,0,0)',
        // Neutralize the CANVAS-project schema search chrome this Dropdown
        // otherwise inherits from `SearchBar.Dropdown`'s `extends: [..,
        // 'CanvasSearchDropdown']` (a "Recent searches" / "Search results"
        // caption + a Fuse.js list over `s.recents`/`s.searchTerm` — state this
        // GLOBAL cross-entity search never populates). Left un-overridden, that
        // inherited block is exactly the SEARCH-1 "static 'Recent searches'
        // header over blank space, indistinguishable from mid-fetch" bug: it
        // renders unconditionally, in a context whose data it can never have.
        // ResultGroups/Loading/NoResults below are this search's real,
        // purpose-built states. `if:` (unmount), not `hide:` (display:none) —
        // Items.onInit dynamic-imports fuse.js and scans the canvas project
        // schema; that work must never run at all in a context with no project
        // schema to scan, not just render invisibly.
        CaptionTitle: {
            if: ()=>false
        },
        Items: {
            if: ()=>false
        },
        // Loading indicator (SEARCH-1): shown for the exact window
        // `_navSearchLoading` covers — from the keystroke that fired this query
        // until ITS OWN results land (superseded in-flight calls never flip it,
        // see globalSearch.js) — so this can never show "done" while a fetch for
        // the CURRENT query is still outstanding.
        Loading: {
            subscribeTo: [
                '_navSearchLoading'
            ],
            hide: (el, s)=>!s.root?._navSearchLoading,
            padding: 'Y1 A',
            fontSize: 'Z2',
            color: 'caption',
            text: '{{ shell.headerSearch.loading | polyglot }}'
        },
        // Explicit "no results" state (SEARCH-1) — previously a genuine
        // zero-result query showed nothing at all (just the inherited "Recent
        // searches" header above), indistinguishable from a fetch still in
        // flight. Only renders once loading has settled AND the query is
        // non-empty AND nothing matched.
        NoResults: {
            subscribeTo: [
                '_navSearchLoading',
                '_navSearchGrouped',
                'navSearchQuery'
            ],
            hide: (el, s)=>!!s.root?._navSearchLoading || !(s.root?.navSearchQuery || '').trim() || !!s.root?._navSearchGrouped?.length,
            padding: 'Y1 A',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', 'shell.headerSearch.noResults').replace('{query}', (s.root?.navSearchQuery || '').trim())
        },
        ResultGroups: {
            flow: 'y',
            subscribeTo: [
                '_navSearchGrouped',
                '_navSearchLoading'
            ],
            if: (el, s)=>!!s.root?._navSearchGrouped?.length,
            // Stale-results fix: dim (never hide — hiding would flash the panel
            // empty on every keystroke) the previous query's rows the instant a
            // new query starts fetching, so they read as "not current" rather
            // than masquerading as the fresh answer for however long the debounce
            // + network round trip takes.
            opacity: (el, s)=>s.root?._navSearchLoading ? '0.45' : '1',
            transition: 'opacity A defaultBezier',
            children: (el, s)=>s.root?._navSearchGrouped || [],
            childExtends: 'NavSearchResultGroup',
            childrenAs: 'state'
        }
    }
};

});

parcelRegister("bFPdt", function(module, exports) {

$parcel$export(module.exports, "HEADER_TABS", () => $87fb408de3723a10$export$fecb30a89294345a);
$parcel$export(module.exports, "SearchBtn", () => $87fb408de3723a10$export$776257d538414960);
$parcel$export(module.exports, "HeaderHomeBtn", () => $87fb408de3723a10$export$ad96d13a150b1c22);
$parcel$export(module.exports, "HeaderTabs", () => $87fb408de3723a10$export$a9189e2899bc0044);
$parcel$export(module.exports, "NavTabsDivider", () => $87fb408de3723a10$export$8f3c49acf59ce2d9);
$parcel$export(module.exports, "HeaderTab", () => $87fb408de3723a10$export$a78c308504aeea8c);
$parcel$export(module.exports, "MobileTab", () => $87fb408de3723a10$export$6b9fc898833d8359);
// HeaderTabs — segmented canvas-nav that replaces the centered HeaderSearch
// (2026-06-09 per Nika). Desktop/tablet layout:
//
//   [home] [search]  Studio · Files · Tasks · Agents  [arrow-down]
//
// • The home icon routes to the dashboard ('/') — an icon (2026-06-19 per Nika),
//   replacing the prior "Dashboard" text tab.
// • Text tabs switch the canvas view (route nav — the shell swaps the page;
//   the keep-alive cross-fade/background morph is layered on in a later pass).
// • The active text tab wears a lighter frosted rounded pill.
// • The search icon morphs `HeaderSearch` in (sets root._headerSearchOpen;
//   AppHeader swaps the pill for the search and the search's Escape clears it).
// • The arrow-down opens the apps launcher and, pressed again, closes it
//   (`toggleSearchAppsDropdown`).
//
// Mounted centered+absolute by AppHeader, mirroring the HeaderSearch pill it
// supersedes, so the left/right glass islands stay put.
//
// @mobileL (≤768px, the "one deck" merge — see AppHeader.js): this whole
// center zone collapses to ONE scrollable LABEL strip (MobileTabs/MobileTab,
// below) — Home folds in as its leading entry, Search relocates to the
// trailing zone (HeaderRight, AppHeader.js), Arrow hides outright (Search's
// focused input already opens the same apps dropdown). See MobileTabs' own
// comment for the full reasoning.
// Canvas tabs. `path` is the route the tab switches to.

var $gSI3w = parcelRequire("gSI3w");

var $9GdJK = parcelRequire("9GdJK");

var $9juhh = parcelRequire("9juhh");

var $4SiPM = parcelRequire("4SiPM");

var $5LAZU = parcelRequire("5LAZU");

var $flGcp = parcelRequire("flGcp");

var $ez5lb = parcelRequire("ez5lb");

var $AxJRF = parcelRequire("AxJRF");
const $87fb408de3723a10$export$fecb30a89294345a = [
    {
        key: 'studio',
        label: 'shell.app.studio',
        path: '/studio'
    },
    {
        key: 'files',
        label: 'shell.app.files',
        path: '/files'
    },
    // Tickets→Tasks rename (2026-08-06 per Nika) — key stays 'tickets'
    // (internal identity); path + label are the canonical user-facing form.
    {
        key: 'tickets',
        label: 'shell.app.tasks',
        path: '/tasks'
    },
    {
        key: 'team',
        label: 'shell.app.team',
        path: '/team-and-agents'
    }
];
// THE TWO TAB STRIPS ARE AppScrollRows (components/AppScrollRow.js — the
// kit's one edge-fade row, shared with AppSegmented and the composer's chips):
// a strip wider than its room scrolls sideways with no scrollbar and FADES
// only the edge that hides a tab, so a tab the strip cuts fades into the edge
// ("fade away with shadow whats not fitting", Nika 2026-08-07) instead of
// reading as a cropped glyph; a cut CURRENT tab is brought to the middle.
//
// The band is `C` (2.618em, ~36px at the strip's 13.9px). The fade used to be
// `V` on both edges at all times — 0.09em, 1.25px measured live — which is a
// hard crop, not a fade: with the assistant drawer docked (1440px, a 15-tab
// workspace) the strip was 307px wide and the fourth tab showed 21px of 121,
// one glyph at full ink — "Contacts" read as "(" (DESIGN-WL-W2-SHELL-OVERLAYS-1,
// 2026-09-26). An edge with nothing beyond it paints no fade at all, so the
// first tab of a strip at rest keeps its full ink.
//
// The strips' one addition: never scroll during reorder mode or a pin drag
// over the strip — both read tab positions under the pointer.
const $87fb408de3723a10$var$STRIP_ROW = {
    ...(0, $gSI3w.AppScrollRow),
    scope: {
        ...(0, $gSI3w.AppScrollRow).scope,
        edgeFadeCanReveal (el) {
            const root = el && el.state && el.state.root;
            return !(root && (root._navbarReorder || root._navbarDragOverPath));
        }
    }
};
const $87fb408de3723a10$export$776257d538414960 = {
    // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
    extends: 'NavbarRailControl',
    scope: {
        // Shared open paths for SearchBtn/ArrowBtn — each is wired to BOTH
        // onMousedown (pointer path: fires on the original target, immune to
        // the re-render node swaps that eat click events) and onClick (keyboard
        // path). ArrowBtn's two are idempotent (same-value state writes dedupe,
        // and openDropdown replaces its same-id layer); SearchBtn's toggle acts
        // once per press instead (its onMousedown note, below).
        //
        // A11Y-1 (2026-08-15): used to focus the input itself via
        // `setTimeout(80) + document.querySelector('[data-key="HeaderSearch"]
        // input')` — DOMQL never stamps a `data-key` attribute on the rendered
        // node, so the query always returned null, silently. `activeElement`
        // stayed BODY after every open, which also meant a real Escape press
        // could never reach HeaderSearch's Input.onKeydown handler (it's bound
        // to that specific element, not delegated) — one root cause explained
        // both "never focuses" AND "Escape doesn't collapse the morph" without
        // that Escape handler itself being broken. Fixed at the actual reveal
        // site instead: AppHeader.js's HeaderSearch already owns
        // `subscribeTo: ['_headerSearchOpen']` + onCreate/onUpdate, so it can
        // focus its OWN Input via the real DOMQL child reference
        // (`el.Form.Input.node`) once it's actually laid out — same
        // edge-detected-open/bounded-poll/return-focus idiom ContextDropdown.js's
        // `focusMenuOnOpen` already ships (a plain rAF/setTimeout-on-open is the
        // one that's fragile: the morph is still `opacity:0` / mid-transition at
        // that instant, and Chrome throttles rAF in backgrounded/automated tabs).
        //
        // This trigger's own job is just to remember WHERE to return focus on
        // dismiss — SearchBtn specifically, not "whatever was focused before"
        // (this handler calls `e.preventDefault()`, so the mousedown path never
        // gives this button default browser focus to fall back on).
        openHeaderSearchMorph (e, el, s) {
            e.preventDefault();
            e.stopPropagation();
            if (el?.node) s.root.__headerSearchReturnFocusTo = el.node;
            s.root.update({
                _headerSearchOpen: true
            });
            this.focusHeaderSearchInput(el);
        },
        // THE BUTTON TOGGLES (N2, Nika 2026-10-27: "fix navbar search button
        // click … for both left and top navbar modes"). On a rail the open pill
        // sits at the top of the screen and this button stays in the column
        // beside it, so its second press was a dead press: the open path above
        // is open-only. A press while the search is open now closes it, and the
        // morph's close edge (AppHeader focusSearchOnOpen) hands focus back to
        // this button. On a top bar the open pill covers the strip and this
        // button with it: the X, Escape and an outside press close it there.
        toggleHeaderSearchMorph (e, el, s) {
            if (!s?.root?._headerSearchOpen) return this.openHeaderSearchMorph(e, el, s);
            e.preventDefault();
            e.stopPropagation();
            el.call('closeHeaderSearch', {
                returnFocusTo: el?.node || null
            });
        },
        // iOS Safari raises the keyboard only for a focus made INSIDE the tap's
        // own handler (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1). AppHeader's
        // HeaderSearch focuses its input from a polled timer (focusSearchOnOpen),
        // which WebKit on a phone treats as script focus: no keyboard, and the
        // open pill stayed under the header islands (measured on dev DFI at
        // 375 / 393: the org name and the avatar drawn over "Search across
        // everything…"). The input is always mounted (the morph keeps it in the
        // DOM at opacity 0), so this gesture focuses it at once; the poll then
        // finds it focused. The header is the nearest ancestor that owns the pill.
        focusHeaderSearchInput (el) {
            let header = el && el.parent;
            while(header && !header.HeaderSearch)header = header.parent;
            const input = header?.HeaderSearch?.Form?.Input?.node;
            if (input && typeof input.focus === 'function') input.focus({
                preventScroll: true
            });
        }
    },
    tag: 'button',
    type: 'button',
    // A finger's target — the 44pt FLOOR (_touchTarget.js), not the 6px slop:
    // at the 14px iPad-portrait root this button is 25px, and 25 + 12 left a
    // 37px target (measured on dev DFI, 834px, touch simulated). These tabs
    // are bespoke buttons, so they state it themselves (2026-08-01, replaces
    // the injected selector block in workspace app.js).
    '@coarse': {
        position: 'relative',
        ...(0, $9GdJK.touchRow)
    },
    width: 'B1',
    height: 'B1',
    minWidth: 'B1',
    round: '50%',
    align: 'center center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: 'caption',
    transition: '140ms defaultBezier background, 140ms defaultBezier color',
    'aria-label': (el)=>el.call('polyglot', 'shell.headerSearch.placeholder'),
    title: (el)=>el.call('polyglot', 'common.action.search'),
    // The button opens and closes the search (toggleHeaderSearchMorph), so it
    // says which: the state rides `aria-expanded`, re-read on every flip of the
    // flag it reports.
    'aria-expanded': (el, s)=>s.root?._headerSearchOpen ? 'true' : 'false',
    subscribeTo: [
        '_headerSearchOpen'
    ],
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    ':active': {
        background: 'hover',
        color: 'title'
    },
    // N1 navigation (dropdowns spec 2026-09-30 §12): the LINE glyph set
    Icon: {
        extends: 'Icon',
        name: 'lnSearch',
        boxSize: 'iconSm'
    },
    // Act on MOUSEDOWN: re-renders (boot hydration, workspace updates) can
    // swap the button node between mousedown and mouseup, and a swapped
    // target kills the click event entirely — the "search sometimes doesn't
    // open" dead-click window. mousedown fires on the original target before
    // any swap. onClick stays the keyboard and assistive path.
    //
    // ONE TOGGLE PER PRESS. A press fires mousedown, then its click; while the
    // two only opened, the second was a no-op, and a toggle would undo the
    // first. So the mousedown notes its `detail` (`el.__searchPressDetail`) and
    // the click of the SAME press is spent. A pointer click carries a count
    // (`detail` ≥ 1); a keyboard click carries 0 and no mousedown before it;
    // an assistive click in Chrome sends mousedown and click, both 0. So a
    // click is the press's own when it has a count, or when its mousedown had
    // none — and a mousedown whose click a node swap ate never spends a later
    // keyboard click (count 1 against 0).
    onMousedown: (e, el, s)=>{
        if (e.button !== 0) return;
        el.__searchPressDetail = e.detail || 0;
        el.scope.toggleHeaderSearchMorph(e, el, s);
    },
    onClick: (e, el, s)=>{
        const pressed = el.__searchPressDetail;
        el.__searchPressDetail = null;
        if (pressed != null && (e.detail > 0 || pressed === 0)) {
            e.preventDefault();
            return;
        }
        el.scope.toggleHeaderSearchMorph(e, el, s);
    }
};
const $87fb408de3723a10$export$ad96d13a150b1c22 = {
    // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
    extends: 'NavbarRailControl',
    NavLabel: {
        text: '{{ shell.app.home | polyglot }}'
    },
    tag: 'button',
    type: 'button',
    // A finger's target — the 44pt FLOOR (_touchTarget.js), not the 6px slop:
    // at the 14px iPad-portrait root this button is 25px, and 25 + 12 left a
    // 37px target (measured on dev DFI, 834px, touch simulated). These tabs
    // are bespoke buttons, so they state it themselves (2026-08-01, replaces
    // the injected selector block in workspace app.js).
    '@coarse': {
        position: 'relative',
        ...(0, $9GdJK.touchRow)
    },
    width: 'B1',
    height: 'B1',
    minWidth: 'B1',
    round: '50%',
    align: 'center center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: 'caption',
    transition: '140ms defaultBezier background, 140ms defaultBezier color',
    'aria-label': (el)=>el.call('polyglot', 'shell.headerTabs.dashboardAriaLabel'),
    title: (el)=>el.call('polyglot', 'shell.headerTabs.dashboard'),
    attr: {
        'data-tab-path': '/'
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    '@mobileL': {
        display: 'none'
    },
    Icon: {
        extends: 'Icon',
        name: 'lnHome',
        boxSize: 'iconSm'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        el.router('/', el.getRoot());
    }
};
const $87fb408de3723a10$export$a9189e2899bc0044 = {
    scope: {
        // Active-tab wash lives on HeaderTab itself now, as the `selected`
        // design-system token on a reactive `background` factory (see HeaderTab
        // below). It used to be this imperative `var(--color-selected)` string
        // because the pill was painted by hand; the token form is what survives a
        // collection re-render (WS-NAV-ACTIVE-TAB-DOES-NOT-TRACK-ROUTE-1). The
        // VALUE is unchanged — `selected` IS `var(--color-selected)`
        // (DESIGN_LANGUAGE.md §4.3), the same wash the files/tickets sidebars, the
        // org-switcher rows and the /studio actives paint (2026-08-06).
        matchesPath (tabPath, p) {
            if (!tabPath) return false;
            if (tabPath === '/') return p === '/';
            // Normalize BOTH sides through the legacy-alias map (tickets→tasks
            // rename 2026-08-06): a stored workspace navbar may still carry path
            // '/tickets' while the live URL is the canonical /tasks (or vice versa
            // on an old deep link) — either combination must still light the tab.
            const tab = (0, $9juhh.canonicalRoutePath)(tabPath);
            const path = (0, $9juhh.canonicalRoutePath)(p);
            return path === tab || path.startsWith(tab + '/');
        },
        // The route the active pill matches against — the PageSlot route
        // (`?page=`) when an app-window/module page is open, else the top-level
        // pathname.
        navMatchPath (root) {
            if (typeof window === 'undefined') return '/';
            // An open PageSlot sheet IS the foreground surface, so it decides the
            // active tab. The LIVE `_canvasSlot` is authoritative and must be
            // checked BEFORE the URL: `?page=` is only written while the
            // underlying route is home — `_writeSlotUrl` actively DELETES the
            // param on any other route — so a sheet opened over /studio or a
            // canvas project left the URL pointing at the route underneath it,
            // and that route's tab stayed lit while the user was looking at
            // something else entirely.
            const slot = root && root._canvasSlot;
            if (slot) return String(slot).split('?')[0];
            // Strip any `/w/<org-slug>` prefix so tab matching works under
            // multi-workspace tabs; `?page=` is an unprefixed internal key.
            let p = (0, $9juhh.stripWorkspacePrefix)(window.location.pathname);
            try {
                const page = new URLSearchParams(window.location.search).get('page');
                // The param carries the FULL slot route, query included, since a
                // module record deep link puts its own params in it (A1-06). The tab
                // match is a PATH comparison, so strip them here exactly as the slot
                // branch above already does — otherwise a shared room link matches no
                // tab at all and the strip goes dark.
                if (page) p = String(page).split('?')[0].split('#')[0];
            } catch (_) {}
            return p;
        },
        // Route → ONE root key. The active pill itself is DECLARATIVE (HeaderTab's
        // `background`/`color`/`aria-current` factories below); this publishes the
        // resolved route so those factories re-run on a navigation that touches no
        // other subscribed key. Called from the mount seed and from the two
        // `onWindow…` props — one body, three call sites, no closure to unbind.
        syncNavActivePath (el, s) {
            const root = s && s.root || el.state?.root;
            if (!root) return;
            const p = this.navMatchPath(root);
            if (root._navActivePath !== p) root.update({
                _navActivePath: p
            }, {
                preventFetch: true
            });
        },
        // Effective assistant-dock squeeze — mirrors app.js's OWN derivation of
        // the <html data-assistant-dock> attribute exactly.
        assistantSqueezed (root) {
            if (!root?.assistantOpen) return false;
            const dock = root.assistantDock === 'left' || root.assistantDock === 'minimized' ? root.assistantDock : 'right';
            return dock === 'left' || dock === 'right';
        },
        // Squeezed-header degradation (assistant docked narrows HeaderTabs'
        // island clamp): drop padding a step first, then let INACTIVE tabs'
        // minWidth floor collapse further so they ellipsize harder while the
        // ACTIVE tab keeps its full readable floor.
        applyTabSqueeze (node, root, active) {
            const squeezed = this.assistantSqueezed(root);
            node.style.padding = squeezed ? 'var(--spacing-Y) var(--spacing-Z2)' : '';
            node.style.minWidth = squeezed && !active ? '2.2em' : '';
        },
        // The tab arrangement is per-workspace: a workspace can override it via
        // root.workspaceSettings.navbar (set by applyWorkspaceConfig on
        // activation — e.g. GreenIG → Claims/Users/Calendar). Before
        // applyWorkspaceConfig lands on boot, read the same navbar from the
        // active workspace RECORD so the correct bar paints on the first render
        // (no default flash). Falls back to the house default
        // (Studio/Tasks/Files/Team). Each entry is { key, label, path, icon? }.
        // Length-guarded — a null OR empty saved navbar means "no
        // personalization", never "render zero tabs".
        //
        // Shared by BOTH tab renderings — the desktop text strip (Tabs) and the
        // @mobileL icon strip (MobileTabs) — so a workspace's personalization /
        // feature-flag gates / user prefs can never drift between the two.
        visibleNavTabs (root, el) {
            // A legacy custom pin's label: the built-in route's launcher KEY, from
            // the workspace's own tile list (searchApps.js launcherTitleKeyFor),
            // when this shell carries it.
            const pinOpts = el && typeof el.call === 'function' && el.context?.functions?.launcherTitleKeyFor ? {
                labelKeyFor: (p)=>el.call('launcherTitleKeyFor', p)
            } : undefined;
            // Gated on `pending`, NOT on `!ready`: `pending` is false once
            // completion is known to be impossible, so a user whose getWorkspace
            // fails gets the house default back instead of a permanently empty
            // navbar. See workspaceSettings.js's tri-state note.
            // THE COMM PROFILE (functions/commHost.js): a comm host shows its own
            // fixed tabs — the workspace's configured navbar names apps it does
            // not serve. Fixed, so no wait on the workspace record either. The
            // person's own pins merge in after the base list, so the result is
            // filtered again — a pinned /files lives on the workspace host.
            if ((0, $flGcp.isCommHost)()) return (0, $AxJRF.applyNavbarTabPrefs)(root, (0, $ez5lb.commNavTabs)().filter((it)=>(0, $4SiPM.navItemVisible)(root, it)), pinOpts).filter((it)=>(0, $4SiPM.navItemVisible)(root, it));
            if ((0, $5LAZU.workspaceSettings)(root).pending) return [];
            const lc = (v)=>v == null ? '' : String(v).toLowerCase();
            // Earliest authoritative navbar for the FIRST paint after a reload —
            // read through THE accessor, never `root.workspace.settings` directly.
            const navFromActiveWorkspaceRecord = ()=>{
                const { settings: settings, ready: ready } = (0, $5LAZU.workspaceSettings)(root);
                if (!ready) return null;
                const ws = root?.workspace;
                const nav = settings?.navbar;
                if (!Array.isArray(nav) || !nav.length) return null;
                const orgId = lc(root?.org?.id || root?.org?._id);
                const wsOrg = lc(ws.organization || ws.organizationId || ws.org);
                if (!orgId || !wsOrg || orgId !== wsOrg) return null;
                return nav;
            };
            const saved = root?.workspaceSettings?.navbar;
            const configNav = Array.isArray(saved) && saved.length ? saved : navFromActiveWorkspaceRecord();
            if (configNav) {
                if (!(0, $4SiPM.featureEnabled)(root, 'shell.moduleTabs')) return [];
                return (0, $AxJRF.applyNavbarTabPrefs)(root, configNav.filter((it)=>(0, $4SiPM.navItemVisible)(root, it)), pinOpts);
            }
            // Literal copy of HEADER_TABS (see the file-header FA204 comment) —
            // the canonical export stays untouched for its cross-file importers;
            // an in-file bare read of it here would be exactly as unresolvable
            // post-frank.toJSON as a module-local const.
            const headerTabs = [
                {
                    key: 'studio',
                    label: 'shell.app.studio',
                    path: '/studio'
                },
                {
                    key: 'files',
                    label: 'shell.app.files',
                    path: '/files'
                },
                {
                    key: 'tickets',
                    label: 'shell.app.tasks',
                    path: '/tasks'
                },
                {
                    key: 'team',
                    label: 'shell.app.team',
                    path: '/team-and-agents'
                }
            ];
            return (0, $AxJRF.applyNavbarTabPrefs)(root, headerTabs.filter((it)=>(0, $4SiPM.navItemVisible)(root, it)), pinOpts);
        },
        // Current on-screen tab arrangement, from the DOM (the Tabs collection's
        // render order IS the arrangement the user sees).
        visibleTabPaths (tabsNode) {
            return Array.from(tabsNode?.querySelectorAll?.('[data-tab-path]') || []).map((n)=>n.getAttribute('data-tab-path')).filter(Boolean);
        },
        // Which side of the hovered tab `e` should land on — before (left half)
        // or after (right half) of its own bounding box.
        dragAfter (e, el) {
            const rect = el.node?.getBoundingClientRect?.();
            return rect ? e.clientX > rect.left + rect.width / 2 : false;
        },
        // A drag carrying the house entity-ref MIME (a search-dropdown app tile
        // — SearchAppsMenu.SearchAppTile stamps `kind: 'page'` + `meta.navPin`)
        // — the strip accepts it OUTSIDE reorder mode as a PIN drop.
        isRefDrag (el, e) {
            try {
                return !el.state?.root?._navbarReorder && !!el.call('hasDragRef', e);
            } catch (_) {
                return false;
            }
        },
        // Commit a ref drop as a custom pin AT the drop position: ensure the
        // pinnedCustom row exists (skip when the path is already a visible tab
        // — then this is just a reorder), then persist the on-screen
        // arrangement with the path spliced in at the pointer's before/after
        // slot.
        async dropRefPin (e, el, s, targetPath, tabsNodeOverride) {
            let ref = null;
            try {
                ref = el.call('readDragRef', e);
            } catch (_) {}
            const path = String(ref?.href || '').split(/[?#]/)[0];
            if (!path) return;
            const root = s.root;
            const tabsNode = tabsNodeOverride || el.parent?.node || el.node;
            const visible = this.visibleTabPaths(tabsNode);
            try {
                if (!visible.includes(path) && !(0, $AxJRF.navbarTabPrefs)(root).pinnedCustom.some((c)=>c && c.path === path)) await (0, $AxJRF.toggleCustomNavbarPin)(root, {
                    path: path,
                    label: ref.title || path
                });
                const paths = visible.filter((p)=>p !== path);
                const at = targetPath ? paths.indexOf(targetPath) : -1;
                if (at === -1) paths.push(path);
                else paths.splice(this.dragAfter(e, el) ? at + 1 : at, 0, path);
                el.call('saveNavbarTabOrder', paths);
            } catch (err) {
                console.warn('[HeaderTabs] ref pin failed:', err?.message || err);
            }
        },
        // A second press closes the launcher this chevron opened (the shell's
        // toggleSearchAppsDropdown, functions/searchApps.js): the plugin leaves a
        // press inside the anchor to the trigger, so an open-only press kept the
        // panel up (live on dev 286b17bdf, 2026-10-29: the rail chevron pressed
        // twice, the 480px launcher still up). A launcher another control opened
        // is replaced, as before.
        toggleAppsLauncher (e, el) {
            e.preventDefault();
            e.stopPropagation();
            // Anchor the apps panel to the whole tab-bar pill (el.parent) so it
            // sizes to the bar width, not the narrow arrow button (which left it
            // a thin sliver). On a left or right rail the pill is the tall tab
            // column, so the panel opens beside the rail at the chevron instead
            // (functions/navbarLayout.js navbarMenuAnchor): under the column it had
            // no room and flipped above it, 244px tall over the rail's head
            // (measured on dev 579269d80).
            try {
                // The chevron's tooltip must not sit over the launcher it opens (the
                // bell's contract): close one already on screen; `tooltipText` on
                // ArrowBtn answers nothing while the launcher is up.
                el.call('closeTooltip', el.tooltipId || el.key);
                el.call('toggleSearchAppsDropdown', el.call('navbarMenuAnchor', 'bottom-center', el.parent || el));
            } catch (err) {
                console.warn('[HeaderTabs] toggleSearchAppsDropdown unavailable:', err);
            }
        },
        // Is the apps launcher (the `searchApps` dropdown layer) up? Read from the
        // shell's one DropdownRoot, as searchApps.js itself reads it — the layer
        // sets no root key of its own.
        appsLauncherOpen (el) {
            const layer = el?.getRoot?.()?.DropdownRoot?.state?.layer;
            return !!layer && layer.id === 'searchApps';
        }
    },
    // Primary navigation landmark — these tabs switch routes (Studio/Infra/…),
    // so expose the bar as the page's primary navigation for assistive tech.
    role: 'navigation',
    'aria-label': (el)=>el.call('polyglot', 'shell.headerTabs.primaryNav'),
    // Centered absolute pill — same anchor as the HeaderSearch it replaces so
    // the left/right header islands don't shift.
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    // Clamp against the measured islands (AppHeader publishes --hdr-left-w /
    // --hdr-right-w from a ResizeObserver): dead-centering is the design
    // contract, but the pill must never slide under the left/right islands
    // when the header narrows — small screens, the docked assistant (the
    // shell CSS shrinks the header by --assistant-width), or a workspace
    // navbar carrying many module tabs (2026-07-27 per Nika "navbar looks
    // jammed … add margin on middle section so it does not stick"). The
    // symmetric 2×max() keeps true centering with an --spacing-A clearance
    // on both sides; the tabs inside ellipsize once the clamp binds (see
    // Tabs / HeaderTab minWidth: 0 + textOverflow below).
    maxWidth: 'calc(100% - 2 * (max(var(--hdr-left-w), var(--hdr-right-w)) + var(--spacing-A)))',
    flow: 'x',
    align: 'center center',
    // Gap between the icons / tabs — a touch more breathing room (V → X) so the
    // home + search icons aren't cramped against each other (2026-06-14 per Nika
    // "increase gap between icons a little bit").
    gap: 'X',
    // 2026-06-10 per Nika: slightly tighter horizontal (A → Z2); the tabs
    // inside gained vertical padding instead.
    padding: 'V Z2',
    round: 'radiusPill',
    // The header's pill: the skins' `pill` theme (AppHeader.js HeaderLeft note)
    // — the navbar glass in the solid skin, the card glass in the ambient one.
    theme: 'pill',
    borderWidth: '0',
    zIndex: '5',
    transition: '180ms defaultBezier opacity, 180ms defaultBezier transform',
    // tabletMOnly (not tabletM): this block's gap/padding disagree with
    // '@mobileL' below on the SAME properties. A bare max-width tabletM
    // (≤1280px) still matches at 390px, and the atomic CSS engine's global
    // class-insertion order — not which block is logically narrower — decides
    // the winner (live-verified on this exact component; see AppHeader.js's
    // '@tabletSOnly' comment for the full mechanism and
    // designSystem/media.js's tabletSOnly/tabletMOnly tokens). tabletMOnly
    // (1280–769px) never overlaps '@mobileL' (≤768px), so it can never win a
    // tie it shouldn't.
    '@tabletMOnly': {
        gap: '0',
        padding: 'W2 Z'
    },
    '@mobileL': {
        gap: 'Z',
        padding: 'V Z'
    },
    // Right-click on the pill BACKGROUND (not a tab): reset-only menu. This is
    // the escape hatch once every tab has been removed — with zero tabs there
    // is nothing left to right-click for "Reset navbar items". No-op while the
    // navbar is uncustomized (an empty menu must never open).
    onContextmenu: (e, el, s)=>{
        const prefs = (0, $AxJRF.navbarTabPrefs)(s.root);
        // Mirror navbarTabMenuItems' own `customized` union EXACTLY (incl.
        // pinnedCustom) — a stricter gate here made the strip menu dead for
        // users whose only customization is a custom-pinned search result.
        if (!prefs.hidden.length && !prefs.pinned.length && !prefs.order.length && !prefs.pinnedCustom.length) return;
        e.preventDefault();
        e.stopPropagation();
        s.root.update({
            contextDropdown: {
                open: true,
                x: e.clientX,
                y: e.clientY,
                itemsFn: 'navbarTabMenuItems',
                actionFn: 'navbarTabMenuAction',
                navTab: null
            }
        }, {
            preventFetch: true
        });
    },
    // FA503 / Rule 64 — the four listeners this strip needs are DECLARED, so
    // DOMQL registers each exactly once when the element takes its node and
    // removes all four in dispose(). The pre-fix shape armed them from
    // `onCreate` behind an `_escBound` latch and mirrored every handler onto
    // `el._escHandler` / `el._reorderOutsideHandler` / `el._syncActive` purely
    // so `onRemove` could take them off again — four listeners, three fields
    // and two hooks of bookkeeping for what the props below state directly.
    // Escape closes the search morph back to the tabs — unless a surface on
    // top already handled this Escape (a launcher tile's or a result row's
    // menu, a dialog: they preventDefault the key they spend). Top overlay
    // first: the search stays for the next Escape
    // (DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1, measured live on dev a9783341a:
    // one Escape on a tile's menu closed the menu, the launcher and the search).
    // A close SPENDS the key (preventDefault): one Escape, one layer — the press
    // that closed the search (and its launcher) used to reach a lower document
    // layer too, e.g. home customize mode under an open search (fw-wl's live
    // Escape checks on dev e004fe4ec, 2026-09-30).
    //
    // TOP LAYER FIRST: a dialog or a dropdown ABOVE the search (the search's own
    // launcher included) owns this Escape — the ONE reader (shared
    // functions/shellOverlayOpen.js) names it, and the search stays for the
    // next press. Its window-level listener runs AFTER this document one, so
    // without the check the search under an open dialog closed first (live on
    // dev 2ffb10c23, 2026-10-01). The main thread sits BELOW the search.
    onDocumentKeydown: (ev, el, s)=>{
        if (ev.key !== 'Escape' || ev.defaultPrevented) return;
        const layer = typeof el?.call === 'function' && typeof el?.context?.functions?.shellOverlayOpen === 'function' ? el.call('shellOverlayOpen') : null;
        if ([
            'modalRoot',
            'dropdown',
            'phoneNav',
            'mobileRail'
        ].includes(layer)) return;
        if (s.root?._navbarReorder) {
            s.root.update({
                _navbarReorder: false
            }, {
                preventFetch: true
            });
            if (typeof ev.preventDefault === 'function') ev.preventDefault();
            return;
        }
        if (s.root?._headerSearchOpen) {
            s.root.update({
                _headerSearchOpen: false
            });
            if (typeof ev.preventDefault === 'function') ev.preventDefault();
        }
    },
    // Any press OUTSIDE the tab bar exits reorder mode — the natural "done"
    // gesture (mirrors the dropdown plugin's outside-close contract).
    onDocumentPointerdown: {
        capture: true,
        handler: (ev, el, s)=>{
            if (!s.root?._navbarReorder) return;
            if (el.node && ev.target && el.node.contains(ev.target)) return;
            s.root.update({
                _navbarReorder: false
            }, {
                preventFetch: true
            });
        }
    },
    onWindowPopstate: (ev, el, s)=>el.scope.syncNavActivePath(el, s),
    onWindowLocationchange: (ev, el, s)=>el.scope.syncNavActivePath(el, s),
    onCreate: (el, s)=>{
        if (typeof document === 'undefined') return;
        // Route → ONE root key. The active pill itself is DECLARATIVE (HeaderTab's
        // `background`/`color`/`aria-current` factories below); this handler only
        // publishes the resolved route so those factories re-run on a navigation
        // that touches no other subscribed key. history.pushState is patched by the
        // shell to emit `locationchange`, so el.router() reaches this too.
        //
        // WS-NAV-ACTIVE-TAB-DOES-NOT-TRACK-ROUTE-1 — the pill USED to be painted
        // imperatively here (and from each tab's create/update hook) by matching
        // `n.getAttribute('data-tab-path')`. Measured live on vault.pr (staging
        // shell 8b492dec2): when the Tabs collection re-renders with a DIFFERENT
        // list — the module tabs (`/vault-*`) inject a beat after boot and push
        // `/tasks`/`/files` down the strip — DOMQL re-applies every prop on the
        // REUSED child nodes (the `data-tab-path` attr factory re-emits) but fires
        // NO create/update hook on them, so neither imperative writer ran again and
        // the inline wash stayed pinned to the node INDEX that was active before
        // the swap. A `?page=/vault-rooms` deep link therefore lit "Tasks" until
        // the first in-app navigation re-ran this handler. Props re-apply on that
        // swap; hooks do not — so the active state has to BE a prop.
        // Seed the key once at mount; `onWindowPopstate` / `onWindowLocationchange`
        // above carry every later navigation.
        setTimeout(()=>el.scope.syncNavActivePath(el, s), 0);
    },
    // ── Home icon — routes to the dashboard ('/') (2026-06-19 per Nika, restored) ──
    // Hidden at @mobileL: the merged deck folds Home into MobileTabs as its
    // leading (always-first, never scrolled-past-since-it-starts-at-rest) entry
    // instead — see MobileTabs.children below. Desktop/tablet keep this
    // standalone icon unchanged.
    HomeBtn: {
        extends: 'HeaderHomeBtn',
        hide: (el, s)=>!!(el.call('navbarLayoutRead', s.root) || {}).rail
    },
    // ── Search icon — morphs HeaderSearch in. Bare-key auto-extend from the
    // top-level SearchBtn export below (2026-08-02) — a SECOND mount lives in
    // HeaderRight (AppHeader.js), visible ONLY at @mobileL, so search can sit
    // in the trailing zone beside the avatar there (brief: "Trailing zone:
    // search + avatar") while this desktop/tablet position stays put. Hidden
    // here at @mobileL so the two never show at once. ──
    SearchBtn: {
        hide: (el, s)=>!!(el.call('navbarLayoutRead', s.root) || {}).rail,
        '@mobileL': {
            display: 'none'
        }
    },
    // The app icons stand apart from the strip's own (Home, Search · the
    // launcher): a hairline on each side of them (NavTabsDivider).
    NavTabsDivider_start: {},
    // ── Canvas tabs ──
    Tabs: {
        // The edge-fade row (STRIP_ROW above): min-width 0, sideways scroll with
        // no scrollbar, overscroll contained, the fade, the current tab kept
        // whole — its own keys below win where they differ.
        ...$87fb408de3723a10$var$STRIP_ROW,
        flow: 'x',
        align: 'center',
        gap: 'V',
        // THE ICON ROW (the look's `navbarIcons`, on by default): the app icons breathe — the gap between their plates
        // is the left island's own between its icons (Nika 2026-10-23: "add more spacing in between").
        class: {
            iconRow: (el, s)=>!!(el.call('homeLookRead', s && s.root) || {}).navbarIcons
        },
        '&.iconRow': {
            gap: 'Z'
        },
        // ON A RAIL (functions/navbarLayout.js; AppHeader's root note — the rail
        // is an attribute and its rules select on it, never `isX` cases): the
        // tabs stack and scroll down the column instead of across — no side fade:
        // a column never overflows sideways, so the row's own observer sets no
        // fade attribute (AppScrollRow) and no mask rule is needed here; wide
        // (expanded), each tab row runs the rail's width.
        'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s && s.root) || {}).railMode,
        '&[data-nav-rail]': {
            flexDirection: 'column',
            flex: '0 1 auto',
            minHeight: '0',
            overflowX: 'hidden',
            overflowY: 'auto',
            gap: 'Z'
        },
        '&[data-nav-rail="wide"]': {
            alignItems: 'stretch'
        },
        // The flexible member of the pill — the icon buttons keep their fixed
        // B1 footprint, this collection absorbs the root maxWidth clamp. Tabs
        // keep their NATURAL width (no per-item "…" — 2026-08-07 per Nika
        // "instead of ... on each item, just show them and fade away with
        // shadow whats not fitting"): when the clamp binds, the STRIP overflows
        // and scrolls on every pointer kind, with the cut-off edge FADED — a
        // scrolled-off label reads as "more this way", never as a cropped
        // layout. The row owns no state: a scroll never writes the root state,
        // and the tabs below keep reading `s.root` for everything they share
        // with the shell.
        flexShrink: '1',
        '@tabletS': {
            gap: '0'
        },
        '@mobileL': {
            display: 'none'
        },
        // Strip-level ref-drop acceptance: a tile dropped on empty strip space
        // (not on a tab — those handle their own positioned drop and stop
        // propagation) pins at the END. dragleave clears the insertion
        // indicator for aborted external drags — the tile's own dragend can't
        // reach this component's state.
        onDragover: (e, el, s)=>{
            if (!el.scope.isRefDrag(el, e)) return;
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
        },
        onDrop: (e, el, s)=>{
            if (!el.scope.isRefDrag(el, e)) return;
            e.preventDefault();
            s.root.update({
                _navbarDragOverPath: null,
                _navbarDragOverAfter: false
            }, {
                preventFetch: true
            });
            el.scope.dropRefPin(e, el, s, null, el.node);
        },
        onDragleave: (e, el, s)=>{
            if (el.node && e.relatedTarget && el.node.contains(e.relatedTarget)) return;
            if (s.root?._navbarDragOverPath) s.root.update({
                _navbarDragOverPath: null,
                _navbarDragOverAfter: false
            }, {
                preventFetch: true
            });
        },
        // List logic lives in scope.visibleNavTabs — shared verbatim with
        // MobileTabs' icon strip below.
        children: (el, s)=>el.scope.visibleNavTabs(s.root, el),
        childExtends: 'HeaderTab',
        childrenAs: 'state',
        subscribeTo: [
            '_featureFlags',
            'workspace',
            'workspaceReady',
            'workspaceSettings',
            'userPrefs'
        ]
    },
    // ── Mobile LABEL strip — @mobileL "one deck" merge (2026-08-02 per Nika
    // "make navbars on mobile smarter, more compact … native-like"; revised
    // same day after live-probe findings). Same list _visibleNavTabs feeds
    // Tabs above; visible where Tabs hides, so every configured destination is
    // one tap away instead of folded behind the apps-launcher chevron
    // ("nothing disappears"). TEXT, not icons: a first pass rendered icons,
    // but on a real (module-heavy) workspace every config-driven nav row
    // shares the SAME generic fallback glyph — 13 identical grey squares,
    // strictly worse than the desktop text tabs this replaces. Config-driven
    // `workspaceSettings.navbar` rows carry no icon metadata and HEADER_TABS'
    // 4 built-in defaults are the exception, not the norm for a real customer
    // workspace, so a labels-only strip is the one treatment that's always
    // legible — it reuses the SAME label strings Tabs already renders, no new
    // metadata needed, and a scrolling text-tab strip is the standard native
    // pattern on both iOS and Android for exactly this.
    //
    // Owns the WHOLE center zone now: HomeBtn/SearchBtn/ArrowBtn all step
    // aside at this breakpoint (their own '@mobileL' overrides) instead of
    // competing with this flex:1 strip for HeaderTabs' width — three fixed
    // B1 buttons + their gaps were eating ~55% of the available 212px, down to
    // an 80px scroll window (live-measured on a 13-item workspace). Home
    // folds in as the ALWAYS-FIRST synthetic entry below (never scrolled past
    // at rest, since the strip starts at scrollLeft 0); Search relocates to
    // the trailing zone beside the avatar (the brief's own "Trailing zone:
    // search + avatar" — also returns real width, since HeaderTabs' flex:1
    // shrinks by whatever HeaderRight grows, only worthwhile if it lands
    // Search somewhere useful, which trailing is); Arrow (apps launcher) is
    // hidden outright — HeaderSearch's Input already opens the SAME apps
    // dropdown on focus/hover (HeaderSearch.js `onFocus`/`onInput` →
    // `openSearchAppsDropdown`), and SearchBtn's own tap already focuses that
    // input (`_openHeaderSearchMorph`), so the full catalog stays one
    // (different) tap away without spending 29px on a second entry point.
    MobileTabs: {
        // The same edge-fade row as Tabs (it shipped the same 1.25px `V` crop);
        // inert while this strip is display:none.
        ...$87fb408de3723a10$var$STRIP_ROW,
        display: 'none',
        '@mobileL': {
            display: 'flex',
            flex: '1 1 0%',
            minWidth: '0',
            flow: 'x',
            align: 'center',
            gap: 'V',
            overflowX: 'auto',
            overflowY: 'hidden',
            overscrollBehaviorX: 'contain',
            scrollSnapType: 'x proximity',
            // Hidden-scrollbar pair (InstallableRail idiom, mirrors Tabs' own
            // '@coarse' block above) — the strip swipes like a native tab bar, no
            // scrollbar chrome inside the deck.
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': {
                display: 'none'
            }
        },
        childExtends: 'MobileTab',
        childrenAs: 'state',
        // Home prepended — a fixed system anchor, not part of the user's
        // configurable navbar, so it always leads (mirrors HomeBtn's own fixed
        // leading position on desktop) rather than being subject to
        // applyNavbarTabPrefs' pin/hide/reorder.
        children: (el, s)=>[
                {
                    key: 'home',
                    label: 'shell.app.home',
                    path: '/'
                },
                ...el.scope.visibleNavTabs(s.root, el)
            ],
        subscribeTo: [
            '_featureFlags',
            'workspace',
            'workspaceReady',
            'workspaceSettings',
            'userPrefs'
        ]
    },
    NavTabsDivider_end: {},
    // ── Arrow-down — apps launcher dropdown. Hidden at @mobileL — see the
    // MobileTabs comment above for why the launcher stays reachable (via
    // Search) without this spending width in the merged deck. ──
    ArrowBtn: {
        // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
        extends: 'NavbarRailControl',
        NavLabel: {
            text: '{{ shell.headerTabs.openApps | polyglot }}'
        },
        tag: 'button',
        type: 'button',
        // A finger's target — the 44pt FLOOR (_touchTarget.js), not the 6px slop:
        // at the 14px iPad-portrait root this button is 25px, and 25 + 12 left a
        // 37px target (measured on dev DFI, 834px, touch simulated). These tabs
        // are bespoke buttons, so they state it themselves (2026-08-01, replaces
        // the injected selector block in workspace app.js).
        '@coarse': {
            position: 'relative',
            ...(0, $9GdJK.touchRow)
        },
        width: 'B1',
        height: 'B1',
        minWidth: 'B1',
        round: '50%',
        align: 'center center',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: 'caption',
        transition: '140ms defaultBezier background, 140ms defaultBezier color',
        'aria-label': (el)=>el.call('polyglot', 'shell.headerTabs.openApps'),
        'aria-haspopup': 'menu',
        // Whether the menu it opens is up (the popup trigger's second half): the
        // open layer's root mirror (`_dropdownLayer`, functions/index.js
        // openDropdown: set by the layer's open hook, cleared by its close hook).
        // Read off the plugin's layer it stayed "false" while the launcher was up
        // (live on dev 286b17bdf, 2026-10-29): the layer reaches only the
        // DropdownRoot's own children, and the root mirror reaches this button.
        ariaExpanded: (el, s)=>s.root?._dropdownLayer === 'searchApps' ? 'true' : 'false',
        title: (el)=>el.call('polyglot', 'shell.headerTabs.apps'),
        // Read at SHOW time: nothing to show while the launcher is up, so "Apps"
        // never paints over the panel it just opened (live on dev 0ffad3a40,
        // 1440 x 813: the tooltip sat on the launcher's top-right corner;
        // DESIGN_SPEC §5.9 Tooltip — it hides when its trigger opens a popover).
        tooltipText: (el)=>el.scope.appsLauncherOpen(el) || (el.call('navbarLayoutRead', el.state.root) || {}).expanded ? '' : el.call('polyglot', 'shell.headerTabs.apps'),
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        '@mobileL': {
            display: 'none'
        },
        // A comm host has no launcher: its apps are the tabs, and the rest lives
        // on the workspace host (WorkspaceBtn below).
        hide: (el)=>el.call('isCommHost'),
        Icon: {
            extends: 'Icon',
            name: 'lnCaret',
            boxSize: 'iconSm'
        },
        // Same mousedown-first contract as SearchBtn (dead-click window) — and
        // running in the bubble phase means the dropdown plugin's capture-phase
        // outside-mousedown close always resolves BEFORE this open: deterministic
        // close-then-open instead of the old race.
        onMousedown: (e, el)=>{
            if (e.button === 0) el.scope.toggleAppsLauncher(e, el);
        },
        // ONE toggle per press: a pointer press toggles on its mousedown, so the
        // click after it only swallows the event; a click with no press before
        // it (Enter or Space on the focused button, detail 0) toggles itself.
        onClick: (e, el)=>{
            if (e.detail > 0) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            el.scope.toggleAppsLauncher(e, el);
        }
    },
    // ── Open workspace — a comm host only (functions/commHost.js), where it
    // takes the launcher's place: the whole workspace, on the workspace host
    // of the same tier. Shown on a real comm host only — a simulated one
    // (`?comm=1`) has no workspace host to open. ──
    WorkspaceBtn: {
        extends: 'NavbarRailControl',
        tag: 'button',
        type: 'button',
        '@coarse': {
            position: 'relative',
            ...(0, $9GdJK.touchRow)
        },
        width: 'B1',
        height: 'B1',
        minWidth: 'B1',
        round: '50%',
        align: 'center center',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: 'caption',
        transition: '140ms defaultBezier background, 140ms defaultBezier color',
        'aria-label': (el)=>el.call('polyglot', 'shell.headerTabs.openWorkspace'),
        title: (el)=>el.call('polyglot', 'shell.headerTabs.openWorkspace'),
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        '@mobileL': {
            display: 'none'
        },
        hide: (el)=>!el.call('isCommHost') || !el.call('workspaceHostUrl', '/'),
        Icon: {
            extends: 'Icon',
            name: 'lnApps',
            boxSize: 'iconSm'
        },
        onClick: (e, el)=>{
            e.preventDefault();
            e.stopPropagation();
            el.call('openOnWorkspaceHost', el, '/');
        }
    }
};
const $87fb408de3723a10$export$8f3c49acf59ce2d9 = {
    aria: {
        hidden: 'true'
    },
    flexShrink: '0',
    width: '1px',
    height: 'A',
    marginInline: 'Z',
    background: 'line',
    // Bar separators follow the icon preference; rails suppress them below.
    hide: (el, s)=>!((el.call('homeLookRead', s && s.root) || {}).navbarIcons || (el.call('navbarLayoutRead', s && s.root) || {}).rail) || !(el.parent && el.parent.scope && typeof el.parent.scope.visibleNavTabs === 'function' ? el.parent.scope.visibleNavTabs(s && s.root, el.parent).length : 0),
    // Rails use a continuous gap between controls instead of separators.
    'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s && s.root) || {}).railMode,
    '&[data-nav-rail]': {
        display: 'none'
    },
    subscribeTo: [
        'userPrefs',
        'workspace',
        'workspaceReady',
        'workspaceSettings',
        '_featureFlags'
    ],
    '@mobileL': {
        display: 'none'
    }
};
const $87fb408de3723a10$export$a78c308504aeea8c = {
    // the one state logic of the glyph plate (hover / keyboard focus / current invert it, current shows the dot);
    // the house tooltip carries the tab's name while the tab is an icon (`title` below)
    extends: [
        'NavbarRailControl',
        'GlyphPlateHolder'
    ],
    scope: {
        matchesPath (tabPath, p) {
            if (!tabPath) return false;
            if (tabPath === '/') return p === '/';
            const tab = (0, $9juhh.canonicalRoutePath)(tabPath);
            const path = (0, $9juhh.canonicalRoutePath)(p);
            return path === tab || path.startsWith(tab + '/');
        },
        navMatchPath (root) {
            if (typeof window === 'undefined') return '/';
            const slot = root && root._canvasSlot;
            if (slot) return String(slot).split('?')[0];
            let p = (0, $9juhh.stripWorkspacePrefix)(window.location.pathname);
            try {
                const page = new URLSearchParams(window.location.search).get('page');
                // The param carries the FULL slot route, query included, since a
                // module record deep link puts its own params in it (A1-06). The tab
                // match is a PATH comparison, so strip them here exactly as the slot
                // branch above already does — otherwise a shared room link matches no
                // tab at all and the strip goes dark.
                if (page) p = String(page).split('?')[0].split('#')[0];
            } catch (_) {}
            return p;
        },
        assistantSqueezed (root) {
            if (!root?.assistantOpen) return false;
            const dock = root.assistantDock === 'left' || root.assistantDock === 'minimized' ? root.assistantDock : 'right';
            return dock === 'left' || dock === 'right';
        },
        applyTabSqueeze (node, root, active, icon) {
            // An icon tab is already its smallest: the squeeze would only bend the circle.
            const squeezed = !icon && this.assistantSqueezed(root);
            node.style.padding = squeezed ? 'var(--spacing-Y) var(--spacing-Z2)' : '';
            node.style.minWidth = squeezed && !active ? '2.2em' : '';
        },
        // Route-match only, no styling opinion — read by this tab's declarative
        // background/color/aria-current factories AND by the squeeze sync below,
        // so the two can never disagree about what counts as "active".
        //
        // The route comes from THIS element's own state (`s.path`), never from
        // `node.getAttribute('data-tab-path')`: a collection re-render swaps the
        // state on a REUSED node, and any matcher that reads the DOM attribute
        // instead of the state is one render behind
        // (WS-NAV-ACTIVE-TAB-DOES-NOT-TRACK-ROUTE-1 — see HeaderTabs.onCreate).
        //
        // The LONGEST matching tab of the strip wins (NAVBAR-ACTIVE-LONGEST-
        // MATCH-1): an app's nested page — /validators/networks — lit BOTH
        // "Validators" (/validators, a prefix match) and "Networks". `el` gives
        // the strip's own list (the row's visibleNavTabs — exactly what it
        // renders); without it the plain prefix match stands.
        tabActive (s, el) {
            const p = this.navMatchPath(s && s.root);
            if (!this.matchesPath(s && s.path, p)) return false;
            const row = el && el.parent;
            const list = row && row.scope && typeof row.scope.visibleNavTabs === 'function' ? row.scope.visibleNavTabs(s.root, row) : null;
            if (!Array.isArray(list)) return true;
            const mine = (0, $9juhh.canonicalRoutePath)(s.path);
            return !list.some((t)=>{
                const other = t && t.path ? (0, $9juhh.canonicalRoutePath)(t.path) : '';
                return other.length > mine.length && this.matchesPath(t.path, p);
            });
        },
        // Squeeze-only self-heal. The active WASH is declarative (below); the
        // assistant-dock squeeze stays imperative because it writes `padding` /
        // `minWidth`, which this component also sets inside '@tabletM' /
        // '@tabletS' media blocks — a base-level factory for those two would race
        // the media rules on emission order (FW-ATOMIC-CSS-MEDIA-RULE-LOSES-TO-
        // BASE-BY-EMISSION-ORDER-1). An inline write outranks both, which is
        // exactly what the squeeze wants.
        applyTabActive (el) {
            const node = el.node;
            if (!node) return;
            const root = el.getRoot?.()?.state;
            const icon = !!(el.call('homeLookRead', el.state && el.state.root) || {}).navbarIcons;
            this.applyTabSqueeze(node, root, this.tabActive(el.state, el), icon);
        },
        // ── Long-press → reorder mode ──
        LP_MS: 450,
        LP_TRAVEL: 6,
        lpStart (e, el, s) {
            if (e.button !== 0 || s.placeholder || !s.path) return;
            if (s.root?._navbarReorder) return; // already in the mode — gestures are drags
            el._lpFired = false;
            el._lpMoved = false;
            el._lpX = e.clientX;
            el._lpY = e.clientY;
            try {
                el.node?.setPointerCapture?.(e.pointerId);
            } catch (_) {
            /* capture is best-effort */ }
            el._lpTimer = setTimeout(()=>{
                el._lpTimer = null;
                el._lpFired = true;
                try {
                    el.node?.releasePointerCapture?.(e.pointerId);
                } catch (_) {}
                s.root.update({
                    _navbarReorder: true
                }, {
                    preventFetch: true
                });
            }, this.LP_MS);
        },
        lpCancel (el) {
            if (el._lpTimer) {
                clearTimeout(el._lpTimer);
                el._lpTimer = null;
            }
        },
        lpMove (e, el) {
            if (!el._lpTimer && !el._lpFired) return;
            const dx = Math.abs(e.clientX - (el._lpX || 0));
            const dy = Math.abs(e.clientY - (el._lpY || 0));
            if (dx > this.LP_TRAVEL || dy > this.LP_TRAVEL) {
                el._lpMoved = true;
                this.lpCancel(el);
            }
        },
        lpEnd (e, el, s) {
            const held = el._lpFired;
            this.lpCancel(el);
            try {
                el.node?.releasePointerCapture?.(e.pointerId);
            } catch (_) {}
            if (held || el._lpMoved) {
                el._lpFired = false;
                el._lpMoved = false;
                return;
            }
            this.openTab(e, el, s);
        },
        // Open a navbar tab's route.
        openTab (e, el, s) {
            if (s.placeholder || !s.path) return;
            if (s.root?._navbarReorder) return;
            e.preventDefault();
            if (s.path === '/') {
                el.router('/', el.getRoot());
                return;
            }
            try {
                el.call('openAppPage', s.path, {
                    preferSlot: true,
                    split: e.metaKey || e.ctrlKey
                });
                return;
            } catch (_) {}
            el.router(s.path, el.getRoot());
        },
        // Current on-screen tab arrangement, from the DOM.
        visibleTabPaths (tabsNode) {
            return Array.from(tabsNode?.querySelectorAll?.('[data-tab-path]') || []).map((n)=>n.getAttribute('data-tab-path')).filter(Boolean);
        },
        dragAfter (e, el) {
            const rect = el.node?.getBoundingClientRect?.();
            return rect ? e.clientX > rect.left + rect.width / 2 : false;
        },
        isRefDrag (el, e) {
            try {
                return !el.state?.root?._navbarReorder && !!el.call('hasDragRef', e);
            } catch (_) {
                return false;
            }
        },
        // Commit a ref drop as a custom pin AT the drop position — duplicated
        // verbatim from HeaderTabs' own scope (this component's onDrop needs
        // the SAME logic when the drop target is a specific tab rather than
        // empty strip space).
        async dropRefPin (e, el, s, targetPath, tabsNodeOverride) {
            let ref = null;
            try {
                ref = el.call('readDragRef', e);
            } catch (_) {}
            const path = String(ref?.href || '').split(/[?#]/)[0];
            if (!path) return;
            const root = s.root;
            const tabsNode = tabsNodeOverride || el.parent?.node || el.node;
            const visible = this.visibleTabPaths(tabsNode);
            try {
                if (!visible.includes(path) && !(0, $AxJRF.navbarTabPrefs)(root).pinnedCustom.some((c)=>c && c.path === path)) await (0, $AxJRF.toggleCustomNavbarPin)(root, {
                    path: path,
                    label: ref.title || path
                });
                const paths = visible.filter((p)=>p !== path);
                const at = targetPath ? paths.indexOf(targetPath) : -1;
                if (at === -1) paths.push(path);
                else paths.splice(this.dragAfter(e, el) ? at + 1 : at, 0, path);
                el.call('saveNavbarTabOrder', paths);
            } catch (err) {
                console.warn('[HeaderTabs] ref pin failed:', err?.message || err);
            }
        },
        // Live dragover tracking for the insertion-bar indicator.
        dragOver (e, el, s) {
            if (this.isRefDrag(el, e)) {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'copy';
                const after = this.dragAfter(e, el);
                if (s.root._navbarDragOverPath !== s.path || s.root._navbarDragOverAfter !== after) s.root.update({
                    _navbarDragOverPath: s.path,
                    _navbarDragOverAfter: after
                }, {
                    preventFetch: true
                });
                return;
            }
            if (!s.root?._navbarReorder) return;
            e.preventDefault();
            e.dataTransfer.dropEffect = 'move';
            if (!s.path || s.path === s.root._navbarDragPath) return;
            const after = this.dragAfter(e, el);
            if (s.root._navbarDragOverPath === s.path && s.root._navbarDragOverAfter === after) return;
            s.root.update({
                _navbarDragOverPath: s.path,
                _navbarDragOverAfter: after
            }, {
                preventFetch: true
            });
        },
        // Drop a dragged tab beside the drop target, persist the full new
        // arrangement.
        dropTab (e, el, s) {
            if (this.isRefDrag(el, e)) {
                e.preventDefault();
                e.stopPropagation();
                s.root.update({
                    _navbarDragPath: null,
                    _navbarDragOverPath: null,
                    _navbarDragOverAfter: false
                }, {
                    preventFetch: true
                });
                this.dropRefPin(e, el, s, s.path);
                return;
            }
            if (!s.root?._navbarReorder) return;
            e.preventDefault();
            e.stopPropagation();
            s.root.update({
                _navbarDragPath: null,
                _navbarDragOverPath: null,
                _navbarDragOverAfter: false
            }, {
                preventFetch: true
            });
            const dragged = e.dataTransfer?.getData('text/nav-tab');
            const target = s.path;
            if (!dragged || !target || dragged === target) return;
            const paths = this.visibleTabPaths(el.parent?.node).filter((p)=>p !== dragged);
            const at = paths.indexOf(target);
            if (at === -1) return;
            const after = this.dragAfter(e, el);
            paths.splice(after ? at + 1 : at, 0, dragged);
            try {
                el.call('saveNavbarTabOrder', paths);
            } catch (err) {
                console.warn('[HeaderTabs] order save failed:', err?.message || err);
            }
        }
    },
    tag: 'button',
    type: 'button',
    // Positioning context for InsertBar (drag insertion indicator, below) —
    // relative with no offsets doesn't affect normal flex-item layout.
    position: 'relative',
    // The physical 44px row stays inside the scroll strip's clip box and
    // leaves every neighboring tab its own touch target.
    '@coarse': {
        position: 'relative',
        ...(0, $9GdJK.touchRow)
    },
    // Each tab exposes its route via data-tab-path — read by the reorder
    // drag/drop code and by tests, NOT by the active matcher (which reads the
    // element's own state — see scope.tabActive).
    attr: {
        'data-tab-path': (el, s)=>s.path
    },
    // The primary navigation landmark's children expose the CURRENT destination
    // — aria-current is what tells assistive tech which one that is. Same form
    // MobileTab below already carries.
    'aria-current': (el, s)=>el.scope.tabActive(s, el) ? 'page' : 'false',
    // Opening/closing a sheet over a NON-home route rewrites no URL, so neither
    // popstate nor locationchange fires — subscribing to the slot key is what
    // re-runs the active factories when the foreground surface changes without a
    // navigation. `_navActivePath` is the route HeaderTabs.onCreate publishes on
    // popstate/locationchange — the trigger for a plain el.router() navigation,
    // which touches no other key here. `_navbarReorder` re-fires the reactive
    // draggable/outline factories when the mode flips.
    subscribeTo: [
        '_canvasSlot',
        '_navActivePath',
        '_navbarReorder',
        '_navbarDragPath',
        '_navbarDragOverPath',
        '_navbarDragOverAfter',
        'assistantOpen',
        'assistantDock'
    ],
    onCreate: (el)=>{
        el.scope.applyTabActive(el);
        el._wasActive = el.scope.tabActive(el.state, el);
    },
    // The current destination is never left cut by the strip: the update in
    // which this tab BECOMES active (a navigation) brings it to the strip's
    // middle if the strip cuts it — the row's scope.edgeFadeBecameCurrent. An
    // update that keeps it active (the squeeze, a drag) scrolls nothing.
    onUpdate: (el)=>{
        el.scope.applyTabActive(el);
        const active = el.scope.tabActive(el.state, el);
        if (active && !el._wasActive) el.parent?.scope?.edgeFadeBecameCurrent?.(el.parent, el.node);
        el._wasActive = active;
    },
    // Reorder-mode affordances: dashed outline + grab cursor + native drag.
    // STRING values — a boolean true renders `draggable=""`, which HTML treats
    // as invalid → 'auto' → buttons stay non-draggable; only the literal
    // 'true' enables native drags.
    draggable: (el, s)=>s.root?._navbarReorder ? 'true' : 'false',
    outline: (el, s)=>s.root?._navbarReorder ? '1px dashed' : 'none',
    outlineColor: 'caption',
    outlineOffset: '-1px',
    // Lift on the tab actually being dragged — the native ghost image shows it
    // tracking the pointer; this marks the SOURCE node as picked up. Subtle
    // scale + shadow + fade, tokens only (mirrors AdminModuleNavbarRow's drag
    // lift in pages/admin/module.js).
    transform: (el, s)=>s.root?._navbarDragPath === s.path ? 'scale(1.04)' : 'scale(1)',
    boxShadow: (el, s)=>s.root?._navbarDragPath === s.path ? 'shadow.5 0 W Y' : 'none',
    opacity: (el, s)=>s.root?._navbarDragPath === s.path ? '0.9' : '1',
    // Icons OFF: yesterday's text tab, padding `Y A1`. Icons ON (the default, Nika 2026-10-23): the tab IS the 24 px
    // glyph plate (`glyphPlateXs`) with `X` all round, so the round plate sits evenly in a round tab; the plate's own
    // states (GlyphPlateHolder) say hover, focus and current, so the tab paints no wash of its own.
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'Y',
    padding: 'Y A1',
    '&.withGlyph': {
        width: 'controlHCompact',
        height: 'controlHCompact',
        padding: '0',
        justifyContent: 'center',
        '@coarse': {
            width: 'controlH',
            height: 'controlH'
        },
        ':hover': {
            background: 'transparent'
        }
    },
    round: 'radiusPill',
    // Active wash — DECLARATIVE, so it re-runs whenever DOMQL re-applies props
    // (a collection state swap included, which is the one case no lifecycle hook
    // covers — WS-NAV-ACTIVE-TAB-DOES-NOT-TRACK-ROUTE-1). `selected` is the
    // design-system token the sidebar active item and the org-switcher rows use,
    // so every active nav surface reads identically (2026-06-18 per Nika "navbar
    // active item bg color should be same as sidebar active item bg color").
    // TOKENS, not a raw `var(--color-selected)`: a token emits an atomic class,
    // a raw value emits an inline style — and an inline base background outranks
    // the ':hover' wash below (the gotcha MobileTab's own factory documents).
    // An icon tab leaves "current" to its plate (inverted, with the dot).
    background: (el, s)=>{
        const washed = !(el.call('homeLookRead', s && s.root) || {}).navbarIcons;
        return el.scope.tabActive(s, el) && washed ? 'selected' : 'transparent';
    },
    border: 'none',
    // grab while reorder mode is armed, grabbing on the one tab actually being
    // dragged, plain pointer otherwise.
    cursor: (el, s)=>{
        if (!s.root?._navbarReorder) return 'pointer';
        return s.root._navbarDragPath === s.path ? 'grabbing' : 'grab';
    },
    color: (el, s)=>el.scope.tabActive(s, el) ? 'title' : 'caption',
    // Tabs render at NATURAL width — no shrink, no per-item "…" (2026-08-07
    // per Nika; supersedes the 2026-08-01 readable-floor ellipsis recipe).
    // When the strip's clamp binds, the Tabs CONTAINER scrolls horizontally
    // with a fade mask on the cut-off edge — a full label always reads fully,
    // excess tabs fade out at the strip edge instead of every tab degrading.
    flexShrink: '0',
    // Matched to the org switcher (item 4 per Nika). 'A' renders per
    // font-context (~15px here, ~12.5px in HeaderRight), so pin a scope-
    // independent rem on both so the top-navbar text is one size.
    fontSize: '0.9rem',
    '@tabletM': {
        fontSize: '0.78rem',
        padding: 'Y Z2'
    },
    // Keep all configured labels readable while the centered island is clamped
    // on tablet. Mobile hides the text-tab collection entirely.
    '@tabletS': {
        // The tablet lane is bounded by two live-measured islands. Use a denser
        // label recipe throughout that lane so names stay readable instead of
        // falling into ellipsis near its narrow end.
        fontSize: '0.72rem',
        padding: 'Y Z'
    },
    fontWeight: '700',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    transition: '140ms defaultBezier background, 140ms defaultBezier color, A defaultBezier transform, A defaultBezier box-shadow, A defaultBezier opacity',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // N1 NAVIGATION (dropdowns spec 2026-09-30 §12): the tab's line glyph is the shared `NavTabGlyph` (24 px,
    // round, ringless in the dense bar); the one state logic comes from `GlyphPlateHolder` in this tab's extends
    // (shared/components/AppGlyphPlate.js). OPTIONAL, default OFF (Nika 2026-10-02: "on navbar make icons optional
    // from personalize default to off"): the person's look `navbarIcons` (workspace functions/homeLook.js) shows
    // it; off = display none, so no gap is left behind.
    Glyph: {
        extends: 'NavTabGlyph',
        // `hide` (display: none), reactive to the switch; a hidden flex item takes no gap. A navbar RAIL
        // (functions/navbarLayout.js) always shows the glyph: a rail is as narrow as one plate.
        hide: (el, s)=>!((el.call('homeLookRead', s && s.root) || {}).navbarIcons || (el.call('navbarLayoutRead', s && s.root) || {}).rail)
    },
    class: {
        withGlyph: (el, s)=>!!((el.call('homeLookRead', s && s.root) || {}).navbarIcons || (el.call('navbarLayoutRead', s && s.root) || {}).rail)
    },
    // A WIDE RAIL (Nika 2026-10-24: "left and right sidebars can be toggle expandable") names each tab beside
    // its glyph — a row the rail's width (HeaderTabs.Tabs), the name in the label weight.
    NavLabel: {
        tag: 'span',
        hide: (el, s)=>!(el.call('navbarLayoutRead', s && s.root) || {}).expanded,
        text: (el, s)=>el.call('storeItemText', {
                key: s.appKey,
                name: s.label
            }, 'name'),
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: '500'
    },
    // A rail's tab always wears the glyph (`withGlyph` above), and `&.withGlyph`
    // writes `padding` at the attribute rule's own specificity: the wide row
    // compounds both, so it wins whatever order the sheet holds them in.
    'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s && s.root) || {}).railMode,
    // The plate keeps its hover/current treatment, while its 16px glyph and
    // following label share the same columns as the rail's plain action icons.
    '&[data-nav-rail="wide"] > [data-key="Glyph"]': {
        marginInline: 'calc((var(--size-iconSm) - var(--size-glyphPlateXs)) / 2)'
    },
    '&.withGlyph[data-nav-rail="wide"]': {
        width: '100%',
        justifyContent: 'flex-start',
        gap: 'Z',
        padding: 'Y Z',
        minHeight: 'controlHCompact',
        round: 'radiusControl',
        boxSizing: 'border-box',
        '@coarse': {
            minHeight: 'controlH'
        }
    },
    // ONE NAME FOR ONE APP. Three kinds of row reach this single call, and the
    // ORDER inside `storeItemText` (shared/functions/storeItemText.js) is what
    // lets them share it without a branch here:
    //   • an INSTALLED APP's tab carries `appKey`, the app's own store key
    //     (workspaceConfigs.js `_appRowsWithKey`), so the label resolves to the
    //     name the App Store shows for that same record — this tab used to print
    //     the app manifest's English literal instead, so a Georgian workspace
    //     read "Warehouse" where the store said "ინვენტარი";
    //   • a SHIPPED house tab (`shell.app.studio`) has no `appKey`, so the
    //     resolver falls to its last source, which is `polyglot` — byte-identical
    //     to the plain `el.call('polyglot', s.label)` this replaced;
    //   • a TENANT's own label ("Ops", a Georgian phrase) resolves nothing at any
    //     source and comes back verbatim, because `translate()` returns its input
    //     for a key nobody ships. That property is what makes key-in-data safe
    //     and is pinned in workspace/__tests__/navbarLabelI18n.test.js.
    //
    // ICONS (Nika 2026-10-23: "try changing text navbar items with icons, with beautiful floating tooltip on hover"):
    // the same name, off the tab — the house tooltip shows it on hover and keyboard focus (TitleTooltipTrigger: the
    // shell's one floating TooltipRoot, never the native title) and it is the tab's accessible name. A text tab
    // carries its name on its face, so it wants no tooltip.
    // A RAIL's tab is a glyph too (Glyph above): its name goes to the tooltip — or, on a wide rail, to its
    // face (NavLabel), so no tooltip there.
    text: (el, s)=>(el.call('homeLookRead', s && s.root) || {}).navbarIcons || (el.call('navbarLayoutRead', s && s.root) || {}).rail ? '' : el.call('storeItemText', {
            key: s.appKey,
            name: s.label
        }, 'name'),
    title: (el, s)=>{
        const nav = el.call('navbarLayoutRead', s && s.root) || {};
        return ((el.call('homeLookRead', s && s.root) || {}).navbarIcons || nav.rail) && !nav.expanded ? el.call('storeItemText', {
            key: s.appKey,
            name: s.label
        }, 'name') : null;
    },
    'aria-label': (el, s)=>(el.call('homeLookRead', s && s.root) || {}).navbarIcons || (el.call('navbarLayoutRead', s && s.root) || {}).rail ? el.call('storeItemText', {
            key: s.appKey,
            name: s.label
        }, 'name') : null,
    // Every navbar tab — built-in app-window routes (Studio/Tasks/Files/Team) AND
    // installed workspace-module tabs (e.g. Contacts '/crm', CMS '/cms', GreenIG
    // Claims, AI House Users/Listings) — opens its NON-CANVAS route INSIDE the
    // shell PageSlot (root._canvasSlot), never a hard top-level navigation; canvas
    // tabs stay full-page (openAppPage's isCanvasRoute wins). cmd/ctrl+click opens
    // the tab in the SECOND pane (iPad split view).
    //
    // Pointer choreography (see the long-press block above _openTab): pointerdown
    // arms the 450ms reorder long-press with pointer CAPTURE — the capture keeps
    // the up event on this node across reactive re-renders, the same dead-click
    // window the old navigate-on-mousedown dodged — a short press navigates on
    // pointerup, a hold enters reorder mode instead. onClick covers KEYBOARD
    // activation only (detail === 0; a pointer click already navigated on up).
    onPointerdown: (e, el, s)=>el.scope.lpStart(e, el, s),
    onPointermove: (e, el)=>el.scope.lpMove(e, el),
    onPointerup: (e, el, s)=>el.scope.lpEnd(e, el, s),
    onPointercancel: (e, el)=>el.scope.lpCancel(el),
    onClick: (e, el, s)=>{
        if (e.detail === 0) el.scope.openTab(e, el, s);
    },
    // Reorder-mode drag-and-drop (`draggable` flips on with the mode above).
    onDragstart: (e, el, s)=>{
        if (!s.root?._navbarReorder || !s.path) {
            e.preventDefault();
            return;
        }
        e.dataTransfer.setData('text/nav-tab', s.path);
        e.dataTransfer.effectAllowed = 'move';
        s.root.update({
            _navbarDragPath: s.path,
            _navbarDragOverPath: null,
            _navbarDragOverAfter: false
        }, {
            preventFetch: true
        });
    },
    onDragover: (e, el, s)=>el.scope.dragOver(e, el, s),
    onDrop: (e, el, s)=>el.scope.dropTab(e, el, s),
    // Native drag ALWAYS fires dragend on the source — dropped on a valid
    // target, dropped outside one, or cancelled (Escape mid-drag) — so this is
    // the one handler guaranteed to run and clear the lift/indicator even when
    // no `drop` event fires at all (a cancelled drag used to leave the tab
    // permanently lifted).
    onDragend: (e, el, s)=>{
        if (!s.root?._navbarDragPath && !s.root?._navbarDragOverPath) return;
        s.root.update({
            _navbarDragPath: null,
            _navbarDragOverPath: null,
            _navbarDragOverAfter: false
        }, {
            preventFetch: true
        });
    },
    // Right-click → the house ContextDropdown with this tab's actions (Pin /
    // Open in side view / Remove — 2026-07-27 per Nika). Rows + dispatch live
    // in shared/functions/navbarTabMenu.js; `navTab` rides the dropdown state
    // so the registered itemsFn/actionFn know which tab was targeted.
    // stopPropagation keeps the pill-background reset menu (HeaderTabs root)
    // from double-firing.
    onContextmenu: (e, el, s)=>{
        if (s.placeholder || !s.path) return;
        e.preventDefault();
        e.stopPropagation();
        s.root.update({
            contextDropdown: {
                open: true,
                x: e.clientX,
                y: e.clientY,
                itemsFn: 'navbarTabMenuItems',
                actionFn: 'navbarTabMenuAction',
                navTab: {
                    key: s.key,
                    label: s.label,
                    path: s.path
                }
            }
        }, {
            preventFetch: true
        });
    },
    // Insertion indicator — a thin accent bar rendered on whichever tab is the
    // CURRENT native dragover target, before/after per _dragAfter (the exact
    // geometry _dropTab lands with, so the bar never points at a spot the drop
    // won't honor). pointerEvents: 'none' so it can never intercept the very
    // dragover it's reacting to — events keep hitting this button underneath,
    // uninterrupted.
    InsertBar: {
        tag: 'span',
        'aria-hidden': 'true',
        position: 'absolute',
        top: 'W',
        bottom: 'W',
        width: 'hairline2',
        round: 'V',
        background: 'highlight',
        pointerEvents: 'none',
        zIndex: '1',
        hide: (el, s)=>!s.root?._navbarReorder || !s.root._navbarDragOverPath || s.root._navbarDragOverPath !== s.path || s.path === s.root._navbarDragPath,
        left: (el, s)=>s.root?._navbarDragOverAfter ? 'auto' : '-W',
        right: (el, s)=>s.root?._navbarDragOverAfter ? '-W' : 'auto'
    }
};
const $87fb408de3723a10$export$6b9fc898833d8359 = {
    // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
    extends: [
        'AppControl',
        'NavbarTooltipTrigger',
        'GlyphPlateHolder'
    ],
    compact: true,
    scope: {
        matchesPath (tabPath, p) {
            if (!tabPath) return false;
            if (tabPath === '/') return p === '/';
            const tab = (0, $9juhh.canonicalRoutePath)(tabPath);
            const path = (0, $9juhh.canonicalRoutePath)(p);
            return path === tab || path.startsWith(tab + '/');
        },
        navMatchPath (root) {
            if (typeof window === 'undefined') return '/';
            const slot = root && root._canvasSlot;
            if (slot) return String(slot).split('?')[0];
            let p = (0, $9juhh.stripWorkspacePrefix)(window.location.pathname);
            try {
                const page = new URLSearchParams(window.location.search).get('page');
                // The param carries the FULL slot route, query included, since a
                // module record deep link puts its own params in it (A1-06). The tab
                // match is a PATH comparison, so strip them here exactly as the slot
                // branch above already does — otherwise a shared room link matches no
                // tab at all and the strip goes dark.
                if (page) p = String(page).split('?')[0].split('#')[0];
            } catch (_) {}
            return p;
        },
        // Route-match only, no styling opinion — shared by MobileTab's
        // declarative reactive props and its imperative sync below, so the two
        // can never disagree about what counts as "active".
        mobileTabActive (path, root) {
            return this.matchesPath(path, this.navMatchPath(root));
        },
        // State-derived form — the one the imperative sync below uses, so a
        // collection state swap on a reused node can never leave it matching the
        // PREVIOUS tab's route (WS-NAV-ACTIVE-TAB-DOES-NOT-TRACK-ROUTE-1).
        // The LONGEST matching tab of the strip wins — the same rule as
        // HeaderTab.tabActive (NAVBAR-ACTIVE-LONGEST-MATCH-1), over the strip's
        // own list (the row's visibleNavTabs).
        tabActive (s, el) {
            const p = this.navMatchPath(s && s.root);
            if (!this.mobileTabActive(s && s.path, s && s.root)) return false;
            const row = el && el.parent;
            const list = row && row.scope && typeof row.scope.visibleNavTabs === 'function' ? row.scope.visibleNavTabs(s.root, row) : null;
            if (!Array.isArray(list)) return true;
            const mine = (0, $9juhh.canonicalRoutePath)(s.path);
            return !list.some((t)=>{
                const other = t && t.path ? (0, $9juhh.canonicalRoutePath)(t.path) : '';
                return other.length > mine.length && this.matchesPath(t.path, p);
            });
        },
        // Open a navbar tab's route — duplicated verbatim from HeaderTab's own
        // scope.
        openTab (e, el, s) {
            if (s.placeholder || !s.path) return;
            if (s.root?._navbarReorder) return;
            e.preventDefault();
            if (s.path === '/') {
                el.router('/', el.getRoot());
                return;
            }
            try {
                el.call('openAppPage', s.path, {
                    preferSlot: true,
                    split: e.metaKey || e.ctrlKey
                });
                return;
            } catch (_) {}
            el.router(s.path, el.getRoot());
        }
    },
    tag: 'button',
    type: 'button',
    flexShrink: '0',
    position: 'relative',
    scrollSnapAlign: 'center',
    // Give the text pill a physical touch row inside its scroll strip.
    '@coarse': {
        position: 'relative',
        ...(0, $9GdJK.touchRow)
    },
    height: 'B1',
    round: 'radiusPill',
    border: 'none',
    cursor: 'pointer',
    // Tight but legible — a denser recipe than HeaderTab's own base (this
    // strip's whole purpose is fitting more than one destination in view at
    // once).
    //
    // TOKENS, not rem (2026-09-04 per Nika "on mobile version, navbars and text
    // are too small"). This was `fontSize: '0.72rem'`, matched to HeaderTab's
    // '@tabletS' step for cross-lane consistency — but "scope-independent" is
    // only half true: rem is independent of the ELEMENT's font context and
    // still rides the ROOT, and this shell's root is itself responsive. It
    // computes 13px in a 390px viewport (16px at 1196px), so this strip painted
    // at 9.36px in a 19px-tall row — the smallest text in the product, on the
    // one surface that is pure navigation. `Z` holds 12.04px there, and
    // `controlHCompact` (36px, designSystem/sizes.js) gives the row a real
    // touch height instead of 19px; both are absolute where it matters and
    // neither tracks a root that shrinks on phones.
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'Y',
    // icons OFF (the default): yesterday's 'V Z'; icons ON: the plate leads close to the start
    padding: 'V Z',
    '&.withGlyph': {
        padding: 'V Z V W'
    },
    fontSize: 'Z',
    minHeight: 'controlHCompact',
    fontWeight: '700',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    attr: {
        'data-tab-path': (el, s)=>s.path
    },
    // Same one resolver as HeaderTab.text above (see its note for why all three
    // kinds of row share it) — the FUNCTION form, as every HTML-attribute prop
    // must take (docs/I18N-CONVENTION.md §1).
    'aria-label': (el, s)=>el.call('storeItemText', {
            key: s.appKey,
            name: s.label
        }, 'name'),
    title: (el, s)=>el.call('storeItemText', {
            key: s.appKey,
            name: s.label
        }, 'name'),
    // Primary navigation landmark's children expose the CURRENT destination —
    // aria-current is what tells assistive tech which one that is.
    'aria-current': (el, s)=>el.scope.tabActive(s, el) ? 'page' : 'false',
    // `_navActivePath` — the route HeaderTabs.onCreate publishes on
    // popstate/locationchange; the trigger that re-runs these factories on a
    // navigation that touches no other subscribed key.
    subscribeTo: [
        '_canvasSlot',
        '_navActivePath'
    ],
    // The same reveal as HeaderTab: the update in which this tab becomes the
    // current destination brings it into full view.
    onCreate: (el)=>{
        el._wasActive = el.scope.tabActive(el.state, el);
    },
    onUpdate: (el)=>{
        const active = el.scope.tabActive(el.state, el);
        if (active && !el._wasActive) el.parent?.scope?.edgeFadeBecameCurrent?.(el.parent, el.node);
        el._wasActive = active;
    },
    // Declarative, and the ONLY writer of the wash (background/color are
    // CSS_PROPS_REGISTRY properties, so a direct factory — not a `.isX` class —
    // re-runs on a subscribed change AND on the prop re-apply a collection
    // re-render performs). The imperative create/update self-heal that used to
    // sit beside this is gone: no lifecycle hook fires when a reused child node
    // takes a DIFFERENT tab's state, so the inline styles it wrote survived as
    // the WRONG tab's highlight (WS-NAV-ACTIVE-TAB-DOES-NOT-TRACK-ROUTE-1).
    // TOKEN values, not `var(--color-selected)`: a token emits an atomic class
    // that re-emits on every prop pass, where a raw value emits an inline style
    // that outranks the ':hover' class wash below.
    background: (el, s)=>el.scope.tabActive(s, el) ? 'selected' : 'transparent',
    color: (el, s)=>el.scope.tabActive(s, el) ? 'title' : 'caption',
    transition: '140ms defaultBezier background, 140ms defaultBezier color',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // N1 NAVIGATION (dropdowns spec 2026-09-30 §12): the tab's line glyph is the shared `NavTabGlyph` (24 px,
    // round, ringless in the dense bar); the one state logic comes from `GlyphPlateHolder` in this tab's extends
    // (shared/components/AppGlyphPlate.js). OPTIONAL, default OFF (Nika 2026-10-02: "on navbar make icons optional
    // from personalize default to off"): the person's look `navbarIcons` (workspace functions/homeLook.js) shows
    // it; off = display none, so no gap is left behind.
    Glyph: {
        extends: 'NavTabGlyph',
        // `hide` (display: none), reactive to the switch; a hidden flex item takes no gap
        hide: (el, s)=>!(el.call('homeLookRead', s && s.root) || {}).navbarIcons
    },
    class: {
        withGlyph: (el, s)=>!!(el.call('homeLookRead', s && s.root) || {}).navbarIcons
    },
    // pointerup (not mousedown/click alone) — survives a reactive re-render
    // swap the way HeaderTab's long-press-aware handlers do; no reorder mode
    // to arbitrate against here, so this is the only handler this needs.
    // onClick's detail===0 gate covers keyboard activation only (a pointer tap
    // already navigated on pointerup).
    onPointerup: (e, el, s)=>{
        if (e.button === 0) el.scope.openTab(e, el, s);
    },
    onClick: (e, el, s)=>{
        if (e.detail === 0) el.scope.openTab(e, el, s);
    },
    // The mobile strip renders the SAME rows as HeaderTab, so it resolves them
    // the same way — a tab that reads "ინვენტარი" on desktop and "Warehouse" on
    // a phone is the same drift with a smaller viewport.
    text: (el, s)=>el.call('storeItemText', {
            key: s.appKey,
            name: s.label
        }, 'name')
};

});
parcelRegister("AxJRF", function(module, exports) {

$parcel$export(module.exports, "navbarTabPrefs", () => $06dd88b87fb7098d$export$dcb5e0890f1b5d07);
$parcel$export(module.exports, "applyNavbarTabPrefs", () => $06dd88b87fb7098d$export$c82f60b9e151558a);
$parcel$export(module.exports, "saveNavbarTabOrder", () => $06dd88b87fb7098d$export$3a5181ad2d6dc0aa);
$parcel$export(module.exports, "navbarTabMenuItems", () => $06dd88b87fb7098d$export$e91e6566504ee9c3);
$parcel$export(module.exports, "navbarTabMenuAction", () => $06dd88b87fb7098d$export$798642b448195d4a);
$parcel$export(module.exports, "toggleCustomNavbarPin", () => $06dd88b87fb7098d$export$49c56ff4242348e7);
// Top-navbar tab context menu — right-clicking a HeaderTabs tab opens the
// shared house ContextDropdown (`root.contextDropdown`) with Pin / Open in
// side view / Remove, per Nika (2026-07-27 "add context menu to navbar items,
// where you can remove, pin and open in sideview"). Mirror of
// accountMenuItems / accountMenuAction — same registered itemsFn/actionFn
// contract, same MenuPanel styling for free.
//
// Persistence: per-user × per-workspace, on the SAME flat userPrefs row the
// boot already awaits pre-reveal (loadPrivateData `_prefsChain` →
// root.userPrefs), under `navbar_tabs: { [workspaceId]: { hidden: [paths],
// pinned: [paths] } }`. The tab's `path` is the identity — every navbar entry
// carries one (HEADER_TABS and workspaceSettings.navbar rows alike), unlike
// `key` which saved module navbars may omit. Writes mirror MemberProfile's
// prefs save: optimistic root.update, then the full merged bag through
// `workspaceProject.userPreferences · update` (server upserts the row).
//
// `pinnedCustom` (2026-08-02 per Nika "add in searchdropdown items pin to
// navbar in context menu") — CUSTOM pins: a foreign `{ path, label }` (a
// global-search result, workspace/functions/navSearchResultMenu.js) that
// isn't part of HEADER_TABS / workspaceSettings.navbar at all. Unlike
// `pinned` (a reorder-to-front hint for a row that already exists in the
// base list), a custom pin IS the row's only reason to exist in the
// navbar — applyNavbarTabPrefs synthesizes it its own `{ key, label, path }`
// entry (see below); unpinning removes the row outright, not just its rank.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $06dd88b87fb7098d$export$dcb5e0890f1b5d07 = (root)=>{
    const wsKey = (r)=>{
        const id = r?.workspace?.id || r?.workspace?._id || r?.jwtClaims?.active_workspace_id;
        return id ? String(id) : null;
    };
    const empty = {
        hidden: [],
        pinned: [],
        order: [],
        pinnedCustom: []
    };
    const bag = (root?.userPrefs?.navbar_tabs || {})[wsKey(root)];
    return {
        hidden: Array.isArray(bag?.hidden) ? bag.hidden : empty.hidden,
        pinned: Array.isArray(bag?.pinned) ? bag.pinned : empty.pinned,
        // Explicit drag arrangement (long-press → reorder, 2026-07-30 per Nika).
        // A full path list; when present it is the arrangement AUTHORITY.
        order: Array.isArray(bag?.order) ? bag.order : empty.order,
        // Custom (foreign) pins — see the header comment above.
        pinnedCustom: Array.isArray(bag?.pinnedCustom) ? bag.pinnedCustom : empty.pinnedCustom
    };
};
const $06dd88b87fb7098d$export$d19af10b1a65d568 = async (root, { attempts: attempts = 15, delayMs: delayMs = 200 } = {})=>{
    const wsKey = (r)=>{
        const id = r?.workspace?.id || r?.workspace?._id || r?.jwtClaims?.active_workspace_id;
        return id ? String(id) : null;
    };
    for(let i = 0; i < attempts; i++){
        const key = wsKey(root);
        if (key) return key;
        await new Promise((r)=>setTimeout(r, delayMs));
    }
    return null;
};
const $06dd88b87fb7098d$export$c82f60b9e151558a = (root, list, opts)=>{
    // Inlined navbarTabPrefs (self-contained — a plain arrow with no `this`,
    // so a bare sibling-export call is exactly as unresolvable post-frank as
    // a module-local read; see the file-header FA204/FA207 comment).
    const wsKey = (r)=>{
        const id = r?.workspace?.id || r?.workspace?._id || r?.jwtClaims?.active_workspace_id;
        return id ? String(id) : null;
    };
    const empty = {
        hidden: [],
        pinned: [],
        order: [],
        pinnedCustom: []
    };
    const bag = (root?.userPrefs?.navbar_tabs || {})[wsKey(root)];
    const prefs = {
        hidden: Array.isArray(bag?.hidden) ? bag.hidden : empty.hidden,
        pinned: Array.isArray(bag?.pinned) ? bag.pinned : empty.pinned,
        order: Array.isArray(bag?.order) ? bag.order : empty.order,
        pinnedCustom: Array.isArray(bag?.pinnedCustom) ? bag.pinnedCustom : empty.pinnedCustom
    };
    const base = Array.isArray(list) ? list : [];
    const basePaths = new Set(base.map((t)=>t && t.path));
    // A custom pin's stored `label` is a one-shot copy of the search-result /
    // drag-ref title AT PIN TIME — English when the shell ran in English then,
    // and stale the day the module renames the page (measured 2026-09-23: the
    // aihouse Feedback page, pinned as "Feedback", stayed English on a Georgian
    // workspace while its base tabs translated). The name the workspace
    // DECLARES for that route is live: the resolved navbar/launcher, then the
    // module's own configDefaults, then each additive app (the same order
    // pageContext.js's moduleRouteTitle reads). A declared label is a bundle
    // key or a literal, and the tab's own `polyglot` call resolves either, so
    // it replaces the copy at render time; the copy stays the fallback for a
    // route nothing declares. A pin that carries a query or hash is a RECORD
    // pin (one person, one document) whose stored name is the record's own,
    // so the declared name of its bare route must never rename it. Inlined,
    // like `wsKey`: this file's exports cannot reach one another after frank
    // (see the header).
    const declaredLabel = (r, path)=>{
        const p = String(path || '');
        if (!p || p !== p.split('#')[0].split('?')[0]) return '';
        const lists = [];
        const ws = r?.workspaceSettings;
        if (ws && typeof ws === 'object') lists.push(ws.navbar, ws.apps);
        const cd = r?.workspaceProject?.configDefaults;
        if (cd && typeof cd === 'object') lists.push(cd.navbar, cd.apps);
        if (Array.isArray(r?.workspaceApps)) {
            for (const app of r.workspaceApps)if (app && typeof app === 'object') lists.push(app.navbar, app.apps);
        }
        for (const l of lists){
            if (!Array.isArray(l)) continue;
            for (const item of l){
                if (!item || typeof item !== 'object') continue;
                const route = String(item.path || item.route || item.href || '');
                if (route.split('#')[0].split('?')[0] !== p) continue;
                const label = String(item.label || item.title || item.name || '');
                if (label) return label;
            }
        }
        return '';
    };
    const custom = prefs.pinnedCustom.filter((c)=>c && c.path && !basePaths.has(c.path)).map((c)=>({
            key: `custom:${c.path}`,
            // A stored KEY first (pins made since keys were stored), then the name
            // the workspace declares, then the built-in route's launcher key (a
            // legacy text pin — never for a RECORD pin with a query or hash), and
            // the stored text last, for a foreign path nothing declares.
            label: c.labelKey || declaredLabel(root, c.path) || (opts && typeof opts.labelKeyFor === 'function' && String(c.path) === String(c.path).split('#')[0].split('?')[0] ? opts.labelKeyFor(c.path) || '' : '') || c.label || c.path,
            path: c.path,
            custom: true
        }));
    if (!base.length && !custom.length) return list;
    const combined = custom.length ? [
        ...base,
        ...custom
    ] : base;
    const hidden = new Set(prefs.hidden);
    const kept = hidden.size ? combined.filter((t)=>t && !hidden.has(t.path)) : combined.slice();
    if (prefs.order.length) {
        const rank = new Map(prefs.order.map((path, i)=>[
                path,
                i
            ]));
        return kept.sort((a, b)=>(rank.has(a.path) ? rank.get(a.path) : Infinity) - (rank.has(b.path) ? rank.get(b.path) : Infinity));
    }
    if (!prefs.pinned.length && !custom.length) return kept;
    const rank = new Map(prefs.pinned.map((path, i)=>[
            path,
            i
        ]));
    return kept.sort((a, b)=>(rank.has(a.path) ? rank.get(a.path) : Infinity) - (rank.has(b.path) ? rank.get(b.path) : Infinity));
};
const $06dd88b87fb7098d$export$3a5181ad2d6dc0aa = async function(orderPaths) {
    const root = this?.state?.root || this?.state;
    if (!root || !Array.isArray(orderPaths) || !orderPaths.length) return;
    const prefs = this.call('navbarTabPrefs', root);
    await saveNavbarTabPrefsLocal(root, {
        ...prefs,
        order: orderPaths.filter(Boolean)
    });
    async function saveNavbarTabPrefsLocal(r, next) {
        const wsKey = (x)=>{
            const id = x?.workspace?.id || x?.workspace?._id || x?.jwtClaims?.active_workspace_id;
            return id ? String(id) : null;
        };
        let resolvedKey = null;
        for(let i = 0; i < 15; i++){
            resolvedKey = wsKey(r);
            if (resolvedKey) break;
            await new Promise((res)=>setTimeout(res, 200));
        }
        if (!resolvedKey) {
            console.warn("[navbarTabMenu] prefs save refused \u2014 workspace not resolved yet");
            return;
        }
        const prefsPatch = {
            ...r.userPrefs || {},
            navbar_tabs: {
                ...r.userPrefs?.navbar_tabs || {},
                [resolvedKey]: next
            }
        };
        r.update({
            userPrefs: prefsPatch
        }, {
            preventFetch: true
        });
        if (!r.__navbarSaveQueue) r.__navbarSaveQueue = new Map();
        const queue = r.__navbarSaveQueue;
        const prior = queue.get(resolvedKey) || Promise.resolve();
        const task = prior.catch(()=>{}).then(()=>(0, $1NxyO.getSDK)().execute('workspaceProject.userPreferences', 'update', {
                payload: prefsPatch
            }));
        queue.set(resolvedKey, task);
        try {
            await task;
        } catch (e) {
            console.warn('[navbarTabMenu] prefs save failed', e);
        }
    }
};
const $06dd88b87fb7098d$export$e91e6566504ee9c3 = function(root) {
    const cm = root && root.contextDropdown;
    if (!cm || !cm.open) return [];
    // Inlined navbarTabPrefs (self-contained — the test-mocked `this.call`
    // for this export only stubs the route classifiers below, not the prefs
    // registry entry, so a `this.call('navbarTabPrefs', …)` indirection would
    // silently break that existing, narrower mock contract).
    const prefs = (()=>{
        const wsKey = (r)=>{
            const id = r?.workspace?.id || r?.workspace?._id || r?.jwtClaims?.active_workspace_id;
            return id ? String(id) : null;
        };
        const empty = {
            hidden: [],
            pinned: [],
            order: [],
            pinnedCustom: []
        };
        const bag = (root?.userPrefs?.navbar_tabs || {})[wsKey(root)];
        return {
            hidden: Array.isArray(bag?.hidden) ? bag.hidden : empty.hidden,
            pinned: Array.isArray(bag?.pinned) ? bag.pinned : empty.pinned,
            order: Array.isArray(bag?.order) ? bag.order : empty.order,
            pinnedCustom: Array.isArray(bag?.pinnedCustom) ? bag.pinnedCustom : empty.pinnedCustom
        };
    })();
    const customized = prefs.hidden.length > 0 || prefs.pinned.length > 0 || prefs.order.length > 0 || prefs.pinnedCustom.length > 0;
    const t = cm.navTab;
    const items = [];
    if (t && t.path) {
        const pinned = prefs.pinned.includes(t.path);
        items.push({
            key: 'pin',
            action: 'pin',
            label: pinned ? 'Unpin' : 'Pin'
        });
        // "Open in side view" only where a split can actually happen (2026-07-27
        // per Nika, both halves): the route must be SLOT-capable — canvas /
        // full-page routes (/studio, admin, data settings) always open as the
        // full page, openAppPage's isCanvasRoute/isFullPageRoute gate wins before
        // any slot logic, so the exact same registered classifiers decide here —
        // AND a PageSlot primary must already be open to split beside
        // (root._canvasSlot; without one openAppPage falls back to a plain open,
        // so the row would lie). Same-route split is a no-op re-focus — hidden
        // too. try/catch mirrors accountMenuItems: the classifiers are absent
        // outside the workspace shell, where these routes don't exist anyway.
        let fullPage = false;
        try {
            fullPage = !!(this.call('isCanvasRoute', t.path) || this.call('isFullPageRoute', t.path));
        } catch (_) {
            fullPage = false;
        }
        const slotOpen = !!root._canvasSlot && root._canvasSlot !== t.path;
        if (!fullPage && slotOpen) items.push({
            key: 'sideview',
            action: 'sideview',
            label: 'shell.navbarTabMenu.sideView'
        });
        items.push({
            key: 'remove',
            action: 'remove',
            label: 'shell.navbarTabMenu.remove',
            danger: true
        });
    }
    if (customized) items.push({
        key: 'reset',
        action: 'reset',
        label: 'shell.navbarTabMenu.reset'
    });
    return items;
};
const $06dd88b87fb7098d$export$798642b448195d4a = async function(action) {
    const root = this.state.root;
    const t = root.contextDropdown?.navTab || null;
    const prefs = this.call('navbarTabPrefs', root);
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    if (action === 'sideview' && t?.path) {
        // Second-pane open (iPad-style split). openAppPage falls back to a plain
        // primary open when nothing is on screen to split against; el.router is
        // the last resort where openAppPage isn't registered (no-backend shells).
        try {
            this.call('openAppPage', t.path, {
                preferSlot: true,
                split: true
            });
        } catch (_) {
            this.router(t.path, this.getRoot());
        }
        return;
    }
    if (action === 'pin' && t?.path) {
        const pinned = prefs.pinned.includes(t.path) ? prefs.pinned.filter((p)=>p !== t.path) : [
            ...prefs.pinned,
            t.path
        ];
        await saveNavbarTabPrefsLocal(root, {
            ...prefs,
            pinned: pinned
        });
        return;
    }
    if (action === 'remove' && t?.path) {
        await saveNavbarTabPrefsLocal(root, {
            // Spread the existing bag first — this write only means to touch
            // hidden/pinned/order below; a bare `{ hidden, pinned, order }`
            // literal here would silently drop `pinnedCustom` (update REPLACES
            // the per-workspace bag, it doesn't deep-merge — see
            // saveNavbarTabPrefsLocal above), erasing every search-pinned tab the
            // instant an unrelated tab was removed.
            ...prefs,
            hidden: prefs.hidden.includes(t.path) ? prefs.hidden : [
                ...prefs.hidden,
                t.path
            ],
            // A removed tab can't stay pinned — reset would otherwise resurrect it
            // at the front instead of its natural spot. Same for the drag order.
            pinned: prefs.pinned.filter((p)=>p !== t.path),
            order: prefs.order.filter((p)=>p !== t.path),
            // A removed CUSTOM tab (synthesized from a search-result pin) has no
            // "natural spot" to fall back to — it only ever existed because it was
            // pinned, so removing it must drop the pinnedCustom row outright too,
            // the same way `toggleCustomNavbarPin` unpins it.
            pinnedCustom: prefs.pinnedCustom.filter((c)=>c.path !== t.path)
        });
        return;
    }
    if (action === 'reset') await saveNavbarTabPrefsLocal(root, {
        hidden: [],
        pinned: [],
        order: [],
        pinnedCustom: []
    });
    // Self-contained save routine — duplicated verbatim from
    // saveNavbarTabOrder's own copy; see the FA204 comment above _saveQueue's
    // (now removed) module-scope declaration for why it can't be shared.
    async function saveNavbarTabPrefsLocal(r, next) {
        const wsKey = (x)=>{
            const id = x?.workspace?.id || x?.workspace?._id || x?.jwtClaims?.active_workspace_id;
            return id ? String(id) : null;
        };
        let resolvedKey = null;
        for(let i = 0; i < 15; i++){
            resolvedKey = wsKey(r);
            if (resolvedKey) break;
            await new Promise((res)=>setTimeout(res, 200));
        }
        if (!resolvedKey) {
            console.warn("[navbarTabMenu] prefs save refused \u2014 workspace not resolved yet");
            return;
        }
        const prefsPatch = {
            ...r.userPrefs || {},
            navbar_tabs: {
                ...r.userPrefs?.navbar_tabs || {},
                [resolvedKey]: next
            }
        };
        r.update({
            userPrefs: prefsPatch
        }, {
            preventFetch: true
        });
        if (!r.__navbarSaveQueue) r.__navbarSaveQueue = new Map();
        const queue = r.__navbarSaveQueue;
        const prior = queue.get(resolvedKey) || Promise.resolve();
        const task = prior.catch(()=>{}).then(()=>(0, $1NxyO.getSDK)().execute('workspaceProject.userPreferences', 'update', {
                payload: prefsPatch
            }));
        queue.set(resolvedKey, task);
        try {
            await task;
        } catch (e) {
            console.warn('[navbarTabMenu] prefs save failed', e);
        }
    }
};
const $06dd88b87fb7098d$export$49c56ff4242348e7 = async (root, entry)=>{
    if (!root || !entry || !entry.path) return;
    const wsKeyRead = (r)=>{
        const id = r?.workspace?.id || r?.workspace?._id || r?.jwtClaims?.active_workspace_id;
        return id ? String(id) : null;
    };
    const empty = {
        hidden: [],
        pinned: [],
        order: [],
        pinnedCustom: []
    };
    const bag = (root?.userPrefs?.navbar_tabs || {})[wsKeyRead(root)];
    const prefs = {
        hidden: Array.isArray(bag?.hidden) ? bag.hidden : empty.hidden,
        pinned: Array.isArray(bag?.pinned) ? bag.pinned : empty.pinned,
        order: Array.isArray(bag?.order) ? bag.order : empty.order,
        pinnedCustom: Array.isArray(bag?.pinnedCustom) ? bag.pinnedCustom : empty.pinnedCustom
    };
    const exists = prefs.pinnedCustom.some((c)=>c.path === entry.path);
    const pinnedCustom = exists ? prefs.pinnedCustom.filter((c)=>c.path !== entry.path) : [
        ...prefs.pinnedCustom,
        (()=>{
            // Store the row's KEY when it has one (an explicit `labelKey`, or a
            // `label` that IS a key, e.g. a launcher tile's title): the tab then
            // re-resolves on every language switch. The text stays as the
            // fallback name.
            const label = entry.label || entry.path;
            const keyShaped = (v)=>typeof v === 'string' && /^[a-z][A-Za-z0-9_-]*(\.[A-Za-z0-9_-]+)+$/.test(v);
            const labelKey = entry.labelKey || (keyShaped(entry.label) ? entry.label : '');
            return labelKey ? {
                path: entry.path,
                label: label,
                labelKey: labelKey
            } : {
                path: entry.path,
                label: label
            };
        })()
    ];
    const next = {
        ...prefs,
        pinnedCustom: pinnedCustom
    };
    let resolvedKey = null;
    for(let i = 0; i < 15; i++){
        resolvedKey = wsKeyRead(root);
        if (resolvedKey) break;
        await new Promise((res)=>setTimeout(res, 200));
    }
    if (!resolvedKey) {
        console.warn("[navbarTabMenu] prefs save refused \u2014 workspace not resolved yet");
        return;
    }
    const prefsPatch = {
        ...root.userPrefs || {},
        navbar_tabs: {
            ...root.userPrefs?.navbar_tabs || {},
            [resolvedKey]: next
        }
    };
    root.update({
        userPrefs: prefsPatch
    }, {
        preventFetch: true
    });
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    const prior = queue.get(resolvedKey) || Promise.resolve();
    const task = prior.catch(()=>{}).then(()=>(0, $1NxyO.getSDK)().execute('workspaceProject.userPreferences', 'update', {
            payload: prefsPatch
        }));
    queue.set(resolvedKey, task);
    try {
        await task;
    } catch (e) {
        console.warn('[navbarTabMenu] prefs save failed', e);
    }
};

});


parcelRegister("4YSoS", function(module, exports) {

$parcel$export(module.exports, "clearWorkspaceSwitchFallback", () => $3a06f6cac03e440f$export$b0a763c3ca50cce0);
$parcel$export(module.exports, "__orgSwitcherInternals", () => $3a06f6cac03e440f$export$7e3d2814bbd6118a);
$parcel$export(module.exports, "AppOrgSwitcher", () => $3a06f6cac03e440f$export$1ed475ce30132290);
$parcel$export(module.exports, "AppOrgSwitcherMenu", () => $3a06f6cac03e440f$export$5ffa5a00df2bb29d);
$parcel$export(module.exports, "AppOrgSwitcherItem", () => $3a06f6cac03e440f$export$49a29de5aebddbba);
$parcel$export(module.exports, "AppWsGroup", () => $3a06f6cac03e440f$export$29a7f897916538a4);
$parcel$export(module.exports, "AppWsItem", () => $3a06f6cac03e440f$export$37a8c9383d275203);
$parcel$export(module.exports, "AppOrgSwitchOverlay", () => $3a06f6cac03e440f$export$1c630aede5a7912c);
// Org switcher. The intranet is an org-level product (MODEL.md inv 15):
// each team-org has one "home" workspace (`type:'shared'`, aka the HQ
// workspace) that backs chat, tickets, docs, meet, KB, etc. Workspaces
// exist for billing boundaries in the editor — not for collab scoping.
//
// This component lets the user pick which org's intranet to view — now a
// 2-level slider (orgs → that org's workspaces; the switch commits when a
// workspace is picked). See AppOrgSwitcherMenu + AppWsGroup / AppWsItem +
// _slideOrgSwitcher below.
// Activation goes through `el.sdk.switchWorkspace(homeWsId)` — the SDK
// owns the federation/refresh round-trip; the frontend never reaches
// directly into sdk-bridge. RLS picks up the new active_workspace_id
// from the refreshed JWT and re-scopes every tenant-table query.
//
// Renders whenever the user belongs to at least one team org. A "+ Create
// organization" footer button flips `root._createOrgModalOpen = true`,
// which opens `AppCreateOrgModal` (root-mounted sibling component, see
// `workspace/components/AppCreateOrgModal.js`). This used to be a Link to
// `canvasUrl('/organizations/new')` — but `canvas.<tier>.symbols.app` is
// an NXDOMAIN host and there is no `/organizations/new` route on canvas
// either, so the link landed on Chrome's "Site can't be reached" page
// (bug #2186). Keeping the create flow in-shell also avoids losing the
// user's current workspace context.
//
// Previously named `AppWorkspaceSwitcher` and lived under
// `workspace/components/`. Renamed + relocated to `shared/components/`
// so any submodule (canvas / chat / tickets / …) can mount it via bare-
// key reference without depending on the workspace shell directly.

var $jhJrJ = parcelRequire("jhJrJ");

var $dot7l = parcelRequire("dot7l");

var $1gOQB = parcelRequire("1gOQB");

var $grPR9 = parcelRequire("grPR9");

var $29wU0 = parcelRequire("29wU0");

var $hmkNw = parcelRequire("hmkNw");

var $cQy7L = parcelRequire("cQy7L");

var $9GdJK = parcelRequire("9GdJK");

var $9juhh = parcelRequire("9juhh");
// Gate-A capstone (Mongo-only since 2026-07-31): the org/workspace IDENTITY
// reads below source from Mongo state on root (root.orgs / root.orgWorkspaces /
// root.org / the active-workspace pointer), never the retired governance JWT's
// app_metadata (root.jwtClaims). Was flag-gated behind `__USE_MONGO_CLAIMS__`
// during the Gate A cutover (2026-07-03); collapsed after the server stopped
// minting `app_metadata` claims on 2026-07-28, which made the flag's OFF
// (jwtClaims + localStorage fallback) branch permanently dead.
// The active org's Mongo id — root.org is the active-org OrgMember row populated
// by subscribeAuthSession / the eager /auth/me scope fetch (bootShell). This is
// the Mongo equivalent of the governance JWT's `workspace_org_id` claim. Used by
// the ON path of every `workspace_org_id` read so the active-org id no longer
// depends on the (stale-prone) governance claim.
const $3a06f6cac03e440f$var$_mongoActiveOrgId = (root)=>{
    const org = root && root.org;
    return org && (org.id || org._id) || '';
};
const $3a06f6cac03e440f$export$b0a763c3ca50cce0 = ()=>{
    if (!globalThis.__wsSwitchFallbackState) globalThis.__wsSwitchFallbackState = {
        timer: null
    };
    const state = globalThis.__wsSwitchFallbackState;
    if (state.timer) {
        clearTimeout(state.timer);
        state.timer = null;
    }
};
// Loader-state pair. `_wsSwitching` drives the AppOrgSwitchOverlay
// (a reactive guard — see _isLoaderActive in workspace/app.js, NOT
// applyLoader, which would also flip `root.loading` and trip studios.js's
// "loading nodes" indicator). `_pendingActiveOrgId` is the optimistic pick
// _activeOrgModuleInternal reads until the next /auth/me payload lands. Both flags are
// raised pre-switch and cleared on every exit path (success, error, 400 ms
// non-federated tick) so they always travel together.
// `_startSwitching` no longer toggles `_wsMenuOpen` — the dropdown
// plugin owns visibility, and callers explicitly dispatch
// `closeDropdown('appOrgSwitcher')` after firing this. Keeps the state
// transition atomic: pending id + loader label flip together.
// The MainLoader is shown directly (without touching `root.loading`) so
// studios.js's "loading nodes" indicator is unaffected — `root.loading`
// stays unchanged. `_isLoaderActive` in app.js already gates MainLoader
// display on `_wsSwitching`; the explicit update here triggers the
// `scaleOutIn` spiral so the switch shows the full boot-loader experience.
const $3a06f6cac03e440f$var$_startSwitching = (root, label, orgId)=>{
    if (!root) return;
    root.update({
        _pendingActiveOrgId: orgId,
        _wsSwitching: label || 'workspace'
    });
    // Show the boot-screen MainLoader spiral directly — same as app boot.
    // Guard for SSR / environments where MainLoader hasn't mounted yet.
    if (root.MainLoader && root.MainLoader.update) root.MainLoader.update({
        animation: 'scaleOutIn',
        animationDelay: '0'
    });
};
const $3a06f6cac03e440f$var$_endSwitching = (root, extra)=>{
    if (!root) return;
    root.update({
        _wsSwitching: null,
        _pendingActiveOrgId: null,
        ...extra || {}
    });
    // Hide the MainLoader that _startSwitching raised. Clearing `_wsSwitching`
    // already removes it reactively (display:'none' via _isLoaderActive in
    // app.js), but firing scaleInOut here ensures the retract animation plays
    // on the synchronous exit paths (same-org non-federated success + all error
    // paths) exactly as it does on the async onWorkspaceChange completion path.
    if (root.MainLoader && root.MainLoader.update) root.MainLoader.update({
        animation: 'scaleInOut',
        animationDelay: 'F'
    });
};
// The user's full org membership, BEFORE the _invalidOrgs permissions filter.
// Mongo only — root.orgs (populated by subscribeAuthSession from /auth/me) is
// the canonical org list; the retired governance JWT's app_metadata.orgs
// narrowed to team-only orgs and is no longer read.
//
// The list the switcher OFFERS: a team member's own EMPTY personal org
// (/auth/me `hasContent: false`, the background org every account owns) is
// left out (POB round 5, Nika 2026-10-31 — functions/visibleOrgs.js). The org
// the person is IN, or an in-tab switch is moving to, is never left out.
const $3a06f6cac03e440f$var$_rawOrgs = (root)=>{
    // Mongo only — root.orgs is the canonical org list (/auth/me).
    const fromState = Array.isArray(root?.orgs) ? root.orgs : null;
    return (0, $dot7l.visibleOrgs)(fromState || [], {
        keep: [
            root?.org?.id,
            root?.org?._id,
            root?.org?.slug,
            root?._pendingActiveOrgId
        ]
    });
};
// The membership list from /auth/me is ONE PAGE (20 rows on an account with
// hundreds of orgs), and the active org can sit outside it. root.org is the
// resolved active-org row (id / slug / name / role), so it leads the list when
// the page does not carry it. Without this the Trigger read a bare
// "Organization" and the list showed no active row (nikoloza/local, 475 orgs,
// 2026-09-24 per Nika "there is no active organization (in top right) fix it").
const $3a06f6cac03e440f$var$_withActiveOrg = (root, raw)=>{
    const active = root?.org;
    const id = active && (active.id || active._id);
    if (!id || !(active.name || active.displayName)) return raw;
    if (raw.some((o)=>o.id === id)) return raw;
    return [
        {
            ...active,
            id: id,
            name: active.name || active.displayName
        },
        ...raw
    ];
};
const $3a06f6cac03e440f$var$_orgs = (root)=>{
    const raw = $3a06f6cac03e440f$var$_withActiveOrg(root, $3a06f6cac03e440f$var$_rawOrgs(root));
    if (!raw.length) return [];
    // Filter out orgs the server rejected with 403 earlier this session
    // (see _commitOrgSwitch's catch). Reading root._invalidOrgs makes this
    // factory reactive — DOMQL re-renders the org list when a failed switch
    // flushes a stale id into the set.
    const invalid = root?._invalidOrgs;
    if (Array.isArray(invalid) && invalid.length) {
        const skip = new Set(invalid);
        const filtered = raw.filter((o)=>!skip.has(o.id));
        // Ticket 6a34260c — never let the permissions filter EMPTY the list: if
        // every org the user has is currently flagged invalid (e.g. a transient
        // 403 storm, or a single-org user who hit a permissions error switching to
        // their only org), returning [] would collapse the whole switcher via the
        // `hide` gate and strand the user with no way to switch back. Fall back to
        // the raw list so the selector stays usable; the flagged orgs simply
        // re-surface (a retry is better than a vanished control).
        return filtered.length ? filtered : raw;
    }
    return raw;
};
const $3a06f6cac03e440f$var$_workspaces = (root)=>{
    // Mongo only — flatten root.orgWorkspaces (the per-org lists fetched via
    // sdk.execute('workspace','list',{organization}), already normalized to
    // id/name/org_id). Used by _orgWorkspaces' fallback + _activeOrgModuleInternal's
    // workspace→org lookup; both also consult root.orgWorkspaces directly, so
    // this stays self-consistent.
    const byOrg = root && root.orgWorkspaces;
    if (!byOrg || typeof byOrg !== 'object') return [];
    const out = [];
    for (const k of Object.keys(byOrg)){
        const list = byOrg[k];
        if (Array.isArray(list)) out.push(...list);
    }
    return out;
};
// Workspaces for one org. Prefers the per-org list fetched via
// sdk.execute('workspace','list',{organization}) and seeded into
// root.orgWorkspaces by the Trigger BEFORE the dropdown opens — those items'
// `organization` field is in the SAME id-space as root.orgs[].id. Falls back
// to filtering the flattened root.orgWorkspaces (_workspaces) only when the
// per-org fetch hasn't run or failed for that org.
const $3a06f6cac03e440f$var$_orgWorkspaces = (orgId, root)=>{
    const fetched = root && root.orgWorkspaces && root.orgWorkspaces[orgId];
    const base = Array.isArray(fetched) ? fetched : $3a06f6cac03e440f$var$_workspaces(root).filter((w)=>(w.org_id || w.organization) === orgId);
    // Remove workspaces a switch has proven unswitchable this session (a
    // broken/orphaned federation, or one the user can't actually reach) so the
    // dropdown stops offering a row that only ever errors with "Couldn't switch".
    // Mirrors the org-level `_invalidOrgs` filter in `_orgs`. Reading
    // root._invalidWorkspaces makes this factory reactive — the L2 list re-renders
    // when a failed switch flushes an id into the set.
    const invalid = root?._invalidWorkspaces;
    if (Array.isArray(invalid) && invalid.length) {
        const skip = new Set(invalid);
        const filtered = base.filter((w)=>!skip.has(w.id || w.workspace_id || w._id));
        // Never let the filter EMPTY an org's list (same safeguard as _orgs): if every
        // workspace is flagged, show the raw list so the user isn't stranded with no
        // way in — a retry beats a vanished org.
        return filtered.length ? filtered : base;
    }
    return base;
};
// The JWT's `active_workspace_id` claim can go stale — it isn't always re-minted
// in lock-step with a workspace switch (it can point at a workspace from another
// org entirely). Prefer the TAB'S OWN resolved workspace (root.workspace.id —
// matches loadPrivateData.js / pages/main.js's TAB-TRUTH-FIRST precedence)
// first, then the SDK's persisted active workspace
// (localStorage.activeWorkspace, its documented cross-tab contract — see
// workspace/wireGlobalListeners.js + sdk switchWorkspace) as a fallback for
// before root.workspace has landed. Keeps the active-workspace checkmark
// honest for THIS tab, not whichever tab last wrote the shared pointer
// (tickets/workspace.md P1 tenant-isolation audit, 2026-08-08 — with MWT
// off, a sibling tab's switch previously could flip which workspace this
// tab's switcher showed as "active").
const $3a06f6cac03e440f$var$_activeWsId = (root)=>{
    if (root?.workspace?.id) return String(root.workspace.id);
    try {
        // No window gate: getActiveWorkspacePointer reads globalThis.sessionStorage /
        // globalThis.localStorage (per-tab MWT pointer) and null-safes both — the old
        // `window.localStorage` guard checked a storage the pointer never reads.
        const ls = (0, $jhJrJ.getActiveWorkspacePointer)();
        if (ls) return ls;
    } catch (err) {
        console.warn('[AppOrgSwitcher] read activeWorkspace failed:', err?.message || err);
    }
    // Mongo-native only — localStorage.activeWorkspace IS the Mongo-native
    // active-workspace pointer (written by sdk.switchWorkspace / PATCH
    // /auth/me/active-org; bootShell fetches root.workspace from it). No
    // fallback to the retired governance JWT's stale-prone active_workspace_id.
    return '';
};
// Find the home workspace for an org. Preference order:
//   1. type === 'shared' (server convention for team/HQ workspaces)
//   2. type === 'hq' (reserved if/when server adds it)
//   3. first workspace in that org by claim order
const $3a06f6cac03e440f$var$_homeWorkspace = (org, root)=>{
    const wss = $3a06f6cac03e440f$var$_orgWorkspaces(org.id, root);
    return wss.find((w)=>w.type === 'hq') || wss.find((w)=>w.type === 'shared') || wss[0] || null;
};
// Returns the org the UI should treat as active. Resolution order:
//   1. `_pendingActiveOrgId` — optimistic pick set THIS tick by the user
//      while `PATCH /auth/me/active-org` is in flight.
//   2. `root.org.id` — the resolved active-org OrgMember row, populated by
//      `subscribeAuthSession` from `/auth/me` (`user.activeOrganization`).
//      Survives reloads (it's in Mongo) and is replicated across every
//      device via the socket.io `active-org-changed` event.
//   3. First org in the membership list — last-resort default for fresh users.
const $3a06f6cac03e440f$var$_activeOrgModuleInternal = (root)=>{
    const orgs = $3a06f6cac03e440f$var$_orgs(root);
    const claimOrgId = $3a06f6cac03e440f$var$_mongoActiveOrgId(root);
    if (!orgs.length) {
        // Ticket 6a34260c — the org list can be transiently empty after a
        // permissions error / claims re-mint. Keep the Trigger meaningful by
        // synthesizing a minimal active-org record from the surviving server
        // context (Mongo `org` state, then the active-org claim) so the switcher
        // still shows WHERE the user is instead of a bare "Organization".
        const stateOrg = root?.org;
        if (stateOrg && (stateOrg.id || stateOrg._id)) return {
            id: stateOrg.id || stateOrg._id,
            name: stateOrg.name || stateOrg.displayName
        };
        if (claimOrgId) return {
            id: claimOrgId,
            name: root?.org?.name || ''
        };
        return null;
    }
    const pendingId = root?._pendingActiveOrgId;
    if (pendingId) {
        const pending = orgs.find((o)=>o.id === pendingId);
        if (pending) return pending;
    }
    if (claimOrgId) {
        const fromClaim = orgs.find((o)=>o.id === claimOrgId);
        if (fromClaim) return fromClaim;
    }
    const activeId = $3a06f6cac03e440f$var$_activeWsId(root);
    const w = $3a06f6cac03e440f$var$_workspaces(root).find((x)=>(x.id || x.workspace_id || x._id) === activeId);
    if (!w) return orgs[0] || null;
    return orgs.find((o)=>o.id === (w.org_id || w.organization)) || null;
};
// ORG-URL-1: decides whether `_commitOrgSwitch`'s early, OPTIMISTIC `/w/…`
// URL rewrite should fire. That rewrite races the shell's atomic
// `sdk.orgSwitched` listener (workspace/app.js `_handleOrgSwitched` ->
// `syncWorkspaceUrl(..., {rewriteOrg:true})`), which resolves the full
// target path from SETTLED post-switch state (org + the resolved workspace +
// its workspace list). The optimistic version strips the path's second
// segment by checking it against the CURRENT (pre-switch, OLD) org's
// workspace list via `stripWorkspacePrefix` — a segment the resolver doesn't
// recognize (e.g. a raw `ws_<id>` handle) is left glued onto the rest of the
// path, and `withWorkspacePrefix(org.slug, rest)` then glues the NEW org
// slug onto that stale leftover: `/w/system/ws_OXN_VBk3Vx` (org updated,
// workspace id still the OLD org's). `_commitOrgSwitch` is only ever called
// with a known `homeWorkspaceId` (AppWsItem.onClick, the sole call site), so
// the optimistic rewrite is skipped whenever one is present — the atomic
// listener owns the URL for that case and is independently correct.
const $3a06f6cac03e440f$var$_allowOptimisticUrlRewrite = (pathname, homeWorkspaceId)=>!homeWorkspaceId && (0, $9juhh.hasWorkspacePrefix)(pathname);
const $3a06f6cac03e440f$export$7e3d2814bbd6118a = {
    rawOrgs: $3a06f6cac03e440f$var$_rawOrgs,
    orgs: $3a06f6cac03e440f$var$_orgs,
    workspaces: $3a06f6cac03e440f$var$_workspaces,
    orgWorkspaces: $3a06f6cac03e440f$var$_orgWorkspaces,
    activeWsId: $3a06f6cac03e440f$var$_activeWsId,
    activeOrg: $3a06f6cac03e440f$var$_activeOrgModuleInternal,
    mongoActiveOrgId: $3a06f6cac03e440f$var$_mongoActiveOrgId,
    allowOptimisticUrlRewrite: $3a06f6cac03e440f$var$_allowOptimisticUrlRewrite,
    // the switch commit itself: the deadline tests (AppOrgSwitcher.test.js)
    // and the CLI mode's workspace picker (see the header above)
    commitOrgSwitch: (...a)=>$3a06f6cac03e440f$var$_commitOrgSwitch(...a)
};
const $3a06f6cac03e440f$export$1ed475ce30132290 = {
    // FA204 / frank trap — every helper below lives in `scope`, not module
    // scope: a bare module-scope OR sibling-exported read silently reads as
    // undefined once the component is frank.toJSON'd for platform delivery
    // (workspace d6ea1142, project_frank_drops_module_local_helpers). The
    // identity-read cluster (`rawOrgs`/`orgs`/`workspaces`/`activeWsId`/
    // `activeOrg`/`mongoActiveOrgId`) is DUPLICATED here rather than shared
    // with the module-scope originals those functions still exist at module
    // scope too, ONLY because `__orgSwitcherInternals` (below) exports them
    // BARE for `AppOrgSwitcher.test.js`'s offline Node coverage, and
    // `AppOrgSwitcher.hide` itself is called directly with `el: null` by that
    // same test — so `hide` keeps a dual-mode read (`el?.scope?.rawOrgs` in
    // the live tree, falling back to the module-scope `_rawOrgs` when `el` is
    // null). Every OTHER factory below is scope-only.
    scope: {
        mongoActiveOrgId (root) {
            const org = root && root.org;
            return org && (org.id || org._id) || '';
        },
        rawOrgs (root) {
            // the switcher's list: functions/visibleOrgs.js (see `_rawOrgs`)
            const fromState = Array.isArray(root?.orgs) ? root.orgs : null;
            return (0, $dot7l.visibleOrgs)(fromState || [], {
                keep: [
                    root?.org?.id,
                    root?.org?._id,
                    root?.org?.slug,
                    root?._pendingActiveOrgId
                ]
            });
        },
        // Scope copy of _withActiveOrg (FA204: a scope method never reads module
        // scope): the active org leads the page when the page does not carry it.
        withActiveOrg (root, raw) {
            const active = root?.org;
            const id = active && (active.id || active._id);
            if (!id || !(active.name || active.displayName)) return raw;
            if (raw.some((o)=>o.id === id)) return raw;
            return [
                {
                    ...active,
                    id: id,
                    name: active.name || active.displayName
                },
                ...raw
            ];
        },
        orgs (root) {
            const raw = this.withActiveOrg(root, this.rawOrgs(root));
            if (!raw.length) return [];
            const invalid = root?._invalidOrgs;
            if (Array.isArray(invalid) && invalid.length) {
                const skip = new Set(invalid);
                const filtered = raw.filter((o)=>!skip.has(o.id));
                return filtered.length ? filtered : raw;
            }
            return raw;
        },
        workspaces (root) {
            const byOrg = root && root.orgWorkspaces;
            if (!byOrg || typeof byOrg !== 'object') return [];
            const out = [];
            for (const k of Object.keys(byOrg)){
                const list = byOrg[k];
                if (Array.isArray(list)) out.push(...list);
            }
            return out;
        },
        activeWsId (root) {
            if (root?.workspace?.id) return String(root.workspace.id);
            try {
                const ls = (0, $jhJrJ.getActiveWorkspacePointer)();
                if (ls) return ls;
            } catch (err) {
                console.warn('[AppOrgSwitcher] read activeWorkspace failed:', err?.message || err);
            }
            return '';
        },
        activeOrg (root) {
            const orgs = this.orgs(root);
            const claimOrgId = this.mongoActiveOrgId(root);
            if (!orgs.length) {
                const stateOrg = root?.org;
                if (stateOrg && (stateOrg.id || stateOrg._id)) return {
                    id: stateOrg.id || stateOrg._id,
                    name: stateOrg.name || stateOrg.displayName
                };
                if (claimOrgId) return {
                    id: claimOrgId,
                    name: root?.org?.name || ''
                };
                return null;
            }
            const pendingId = root?._pendingActiveOrgId;
            if (pendingId) {
                const pending = orgs.find((o)=>o.id === pendingId);
                if (pending) return pending;
            }
            if (claimOrgId) {
                const fromClaim = orgs.find((o)=>o.id === claimOrgId);
                if (fromClaim) return fromClaim;
            }
            const activeId = this.activeWsId(root);
            const w = this.workspaces(root).find((x)=>(x.id || x.workspace_id || x._id) === activeId);
            if (!w) return orgs[0] || null;
            return orgs.find((o)=>o.id === (w.org_id || w.organization)) || null;
        },
        // Every-org workspace prefetch state — private to this component (the
        // Trigger + onCreate poll are the only callers), so it's a plain scope
        // data property rather than a cross-component `el.context` bag (unlike
        // AppNavbar's more-dropdown coordination, nothing outside AppOrgSwitcher
        // needs to see this).
        orgWsInFlight: new Set(),
        // Fetch orgs' workspaces via the SDK and seed root.orgWorkspaces. Each
        // item's `organization` field is in the SAME id-space as root.orgs[].id
        // (unlike the JWT claim's workspace.org_id), so the switcher's L2 lists
        // become correct. NON-BLOCKING + per-org single-flight: callers never
        // await it, so opening the menu is always instant; a per-org failure is
        // skipped (that org keeps the claim fallback).
        //
        // SCOPE discipline (boot F6 — tickets/workspace.md BOOT-RESHUFFLE root
        // cause 6): this must NEVER fan out to every org at boot. The old
        // mount-time prefetch fired one `GET /core/workspaces?organization=<id>`
        // per org — 13 simultaneous calls for a 13-org user, saturating the
        // browser's 6-connection HTTP/1.1 pool at the exact moment boot data
        // loads (measured 1.7-3.3s per call, 9-12s total boot data). So: mount
        // warms ONLY the active org (one call, off the critical path); the FULL
        // fan-out runs when the menu actually opens (Trigger.onClick), which is
        // also when the data is actually needed — and re-runs on each open so
        // newly-created workspaces show up. `onlyOrgs` narrows the fetch to a
        // subset; omitted = all orgs (the menu-open refresh). The in-flight set
        // is per-org so a pending active-org warm never blocks the menu-open
        // fan-out from covering the other orgs.
        // `displayName` FIRST. The legacy `name` field is frozen at "Default" on
        // older workspace records, so reading it first hid every rename — 8 of 23
        // workspaces printed "Default" here on 2026-09-04 while their real name sat
        // in `displayName`. THE rule, and the measurement, live on
        // `workspaceDisplayName` in functions/activeWorkspaceRecord.js. This is a
        // scope copy for the same frank reason as the identity-read cluster above:
        // a scope method has no `el`, so it cannot reach the barrel through
        // `el.call`. Keep the two in step.
        wsDisplayName (w) {
            return w && (w.displayName || w.name) || '';
        },
        prefetchOrgWorkspaces (root, sdk, onlyOrgs) {
            if (!root || !sdk || !sdk.execute) return;
            const wanted = Array.isArray(onlyOrgs) && onlyOrgs.length ? onlyOrgs : this.orgs(root);
            const inFlight = this.orgWsInFlight;
            const orgs = wanted.filter((org)=>org && org.id && !inFlight.has(org.id));
            if (!orgs.length) return;
            for (const org of orgs)inFlight.add(org.id);
            const done = ()=>{
                for (const org of orgs)inFlight.delete(org.id);
            };
            Promise.all(orgs.map((org)=>sdk.execute('workspace', 'list', {
                    organization: org.id
                }).then((r)=>r && r.items || []).catch(()=>null))).then((lists)=>{
                const orgWorkspaces = {
                    ...root.orgWorkspaces || {}
                };
                orgs.forEach((org, i)=>{
                    // Normalize the SDK Workspace shape (_id / displayName /
                    // organization) to the fields the rows + switch read (id / name /
                    // org_id) so AppWsItem renders names + the active check/switch
                    // use the right id.
                    if (Array.isArray(lists[i])) orgWorkspaces[org.id] = lists[i].map((w)=>({
                            ...w,
                            id: w.id || w._id,
                            name: this.wsDisplayName(w),
                            org_id: w.org_id || w.organization || org.id
                        }));
                });
                root.update({
                    orgWorkspaces: orgWorkspaces
                });
                done();
            }, (err)=>{
                console.warn('[AppOrgSwitcher] workspace prefetch failed:', err && err.message || err);
                done();
            });
        },
        // Open the org-switcher menu INSTANTLY. THIS is where the every-org
        // workspace prefetch runs (boot F6 — mount only warms the active org;
        // see onCreate): fired in the BACKGROUND (never awaited) so a slow SDK
        // call can't delay or block the menu from opening, and re-fired on each
        // open so newly-created workspaces show up. The active org's list is
        // already warm, and the claim fallback covers a drill that beats the
        // fetch.
        // ORGSWITCHER-PANEL-SURFACE-1 (2026-09-02 per Nika: "fix why orgswitcher
        // has its own background — remove stale bg and rely on original dropdown
        // background — it also has empty space at the right").
        //
        // BOTH symptoms were one defect: this call used to pin the plugin Panel to
        // a RAW `minWidth: '320px'` while the body (AppOrgSwitcherMenu) sizes
        // itself with the em-based `width: 'G'` token — 305px at the header's 17px
        // font. A raw px shell can never track an em body, so the Panel stood 15px
        // wider than the card inside it and the Panel's OWN surface (the dropdown
        // plugin paints `theme` + `round` + `shadow` on its shell) showed as a
        // darker strip down the RIGHT edge — the "stale background", and the
        // "empty space", in one measurement.
        //
        // The fix is to declare NO width here at all: the body owns its width
        // (content width with a token minimum), so the Panel shrink-wraps to it and
        // exactly ONE surface — the house MenuPanel card every other dropdown in
        // the product shows — is visible. `round` is handed through so the shell's
        // corners match the body's `radiusCard` instead of peeking past them at
        // the four corners (same call shape AiSettingsButton documents for the AI
        // menus: geometry declared in TOKENS, panel and body agreeing).
        // Beside a navbar RAIL, not under it: the switcher sits at the foot of a
        // left or right rail, so its menus open towards the page from the rail's
        // outer edge, the menu's foot on the trigger's — every navbar menu's one
        // anchor (functions/navbarLayout.js navbarMenuAnchor). At the top and the
        // bottom the trigger anchors as ever.
        openOrgSwitcherMenu (e, el, s) {
            this.prefetchOrgWorkspaces(s && s.root, el.sdk);
            el.call('openDropdown', {
                ...el.call('navbarMenuAnchor', 'bottom-start'),
                id: (0, $cQy7L.ORG_SWITCHER_DROPDOWN_ID),
                round: 'radiusCard',
                content: {
                    extends: 'AppOrgSwitcherMenu'
                }
            });
        },
        openInviteDropdown (e, el, s) {
            // Opens AT ONCE, in the click (the same call shape as
            // openOrgSwitcherMenu above). The invite panel loads its own member
            // list and shows a loading state while it does (MembersInInvite) — it
            // used to wait here for a listOrgMembers round trip with no feedback,
            // then anchor from a rect snapshotted before the wait.
            el.call('openDropdown', {
                ...el.call('navbarMenuAnchor', 'bottom-end'),
                id: 'appInvite',
                // The body (InviteDropdown) extends MenuPanel and carries
                // `radiusCard`, so the plugin shell takes that radius too and never
                // shows its own corners behind the card.
                round: 'radiusCard',
                content: {
                    extends: 'InviteDropdown'
                }
            });
        }
    },
    // Render whenever the user has ANY org context — the raw membership list, an
    // active-org claim, or a resolved active org. Ticket 6a34260c: gating on the
    // _invalidOrgs-FILTERED `_orgs` meant a permissions error (a 403 that flagged
    // the user's only/all orgs, or a re-mint that briefly emptied root.orgs) made
    // the whole selector VANISH, stranding the user. Gate on the unfiltered
    // context instead so the control survives transient errors; `_orgs`'s own
    // fallback keeps the dropdown list populated.
    hide: (el, s)=>{
        const rawOrgs = el?.scope?.rawOrgs ? (r)=>el.scope.rawOrgs(r) : $3a06f6cac03e440f$var$_rawOrgs;
        const root = s.root;
        if (rawOrgs(root).length) return false;
        if (root?.org && (root.org.id || root.org._id)) return false;
        return true;
    },
    position: 'relative',
    flow: 'x',
    align: 'center left',
    // Warm ONLY the active org's workspace list shortly after mount (deferred
    // 800ms so it stays off the critical boot path), retrying until orgs load.
    // The full every-org prefetch moved to menu-open (Trigger.onClick) — boot F6:
    // firing one list call PER ORG here stampeded 13 simultaneous
    // `GET /core/workspaces` on a 13-org account and saturated the 6-connection
    // HTTP/1.1 pool right as boot data loaded. One call keeps the most likely
    // drill target (the org you're in) instant; other orgs load on open, and the
    // claim fallback covers a click-before-fetch.
    onCreate: (el, s)=>{
        const root = s && s.root;
        if (!root || typeof setTimeout === 'undefined') return;
        let tries = 0;
        const poll = ()=>{
            // A warm boot mounts from the cached snapshot: wait for bootShell's
            // reconcile (it clears _bootFromCache and delivers the boot's list as
            // root.workspaces) before deciding whether a read is needed.
            if (root._bootFromCache) {
                if (++tries < 30) setTimeout(poll, 500);
                return;
            }
            if (el.scope.orgs(root).length && el.sdk && el.sdk.execute) {
                const active = el.scope.activeOrg(root);
                // The boot already answered the active org's list: bootShell seeds
                // root.orgWorkspaces[<active org>] (cold path) and root.workspaces
                // (both paths). Re-reading it here was a second
                // GET /core/workspaces?organization= for rows the root already held.
                // The menu-open refresh (openOrgSwitcherMenu) still re-reads on open.
                const seeded = active && root.orgWorkspaces && root.orgWorkspaces[active.id];
                const fromBoot = active && Array.isArray(root.workspaces) ? root.workspaces.filter((w)=>w && String(w.org_id || w.organization || '') === String(active.id)) : [];
                if (!active || !active.id || Array.isArray(seeded)) return;
                if (fromBoot.length) {
                    root.update({
                        orgWorkspaces: {
                            ...root.orgWorkspaces || {},
                            [active.id]: fromBoot
                        }
                    });
                    return;
                }
                el.scope.prefetchOrgWorkspaces(root, el.sdk, [
                    active
                ]);
            } else if (++tries < 30) setTimeout(poll, 500);
        };
        setTimeout(poll, 800);
    },
    // Trigger styled to match HeaderBreadcrumb's `Button_page` / `Button_project`
    // (company/brand/components/HeaderBreadcrumb.js) so the org switcher reads as
    // a peer of the breadcrumb dropdowns elsewhere in the product chrome.
    //
    // Migrated 2026-06-03 from a bespoke `_wsMenuOpen` toggle + sibling
    // `Menu` panel to the centralized @symbo.ls/dropdown plugin. The
    // panel body lives in `AppOrgSwitcherMenu` (below) which the plugin
    // renders inside its single shell-mounted DropdownRoot. Plugin owns
    // positioning (auto-flip), outside-click dismiss, ESC. `_wsMenuOpen`
    // is kept as a state carrier because AppOrgSwitcherItem.onClick still
    // writes it on activation (closes the dropdown by setting it to
    // false — see the `closeDropdown` call dispatched there).
    Trigger: {
        extends: [
            'Button',
            'AppControl'
        ],
        compact: true,
        theme: 'tertiary',
        gap: 'Z',
        flow: 'row-reverse',
        padding: 'Y2 Z2',
        // Header-island chrome runs on the COMPACT control scale — the brand
        // Button's capsule minHeight (controlH 44px) stretched HeaderRight to
        // 47px against its siblings' 38px island gauge (2026-08-08 per Nika
        // "top right avatar navbar somehow got thicker").
        minHeight: 'controlHCompact',
        // Use a physical touch row so the switcher and invite button keep
        // separate hit areas even in a compact header.
        '@coarse': {
            ...(0, $9GdJK.touchRow),
            ':after': {
                display: 'none'
            }
        },
        icon: 'arrow angle down',
        color: 'title',
        fontWeight: '400',
        // No explicit font-size (2026-06-08 per Nika "remove AppOrgSwitcher
        // Label fontsize") — the label inherits the surrounding header's font.
        cursor: 'pointer',
        'aria-label': (el)=>el.call('polyglot', 'shell.orgSwitcher.switchAria'),
        'aria-haspopup': 'menu',
        // Absolute gauge, not the em-relative `A`. The Trigger deliberately sets
        // no font-size (see the note above), so an em-sized icon inherits whatever
        // the surrounding header happens to be and lands off the row's gauge —
        // measured 13.25px here against HeaderTabs' 14.16px for the identical
        // `boxSize: 'A'`. `iconSm` is a fixed 16px, so every header control agrees.
        Icon: {
            boxSize: 'iconSm',
            minWidth: 'iconSm'
        },
        // Pointer = onMousedown (fires on the original target before a chrome
        // re-render can swap the node — the dead-click window, worst with a
        // PageSlot's load churn); keyboard = detail-0 click. The guard stops one
        // gesture double-firing the open (a same-id re-open remounts the panel).
        onMousedown: (e, el, s)=>{
            if (e.button !== 0) return;
            el.scope.openOrgSwitcherMenu(e, el, s);
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if (e.detail !== 0) return;
            el.scope.openOrgSwitcherMenu(e, el, s);
        },
        Label: {
            tag: 'span',
            text: (el, s)=>el.scope.activeOrg(s.root)?.name || el.call('polyglot', 'shell.orgSwitcher.orgLabel')
        }
    },
    // Invite icon next to the switcher — opens the shared InviteDropdown
    // (new-member form + magic link + members + roles) anchored to the icon
    // (2026-06-09 per Nika "add invite icon next to orgswitcher which uses
    // Invite dropdown").
    InviteBtn: {
        // AN ICON BUTTON IS A SQUARE (Nika 2026-09-26: "all icon buttons should
        // have 1/1 aspect ratio"; DESIGN-WL-ICON-BUTTONS-SQUARE-1). It extended
        // brand `Button` with `Y2` padding around a 16px glyph under a 36px
        // floor — a 29x36 control (measured, A2-14; crm-w1 read it 30x36 on dev
        // 2c2b6d978). Now the kit's icon-only square, CompactIconButton: the
        // brand icon law restated at the call site until the brand publish
        // lands — controlHCompact on both axes, aspect 1 / 1, padding 0,
        // flex-shrink 0, border-box. The house tooltip, fed by `title`
        // (TitleTooltipTrigger keeps the native one off).
        extends: [
            'CompactIconButton',
            'NavbarTooltipTrigger'
        ],
        icon: 'userPlus',
        theme: 'tertiary',
        color: 'title',
        // The visible control occupies the complete touch target.
        '@coarse': {
            ...(0, $9GdJK.touchRow),
            ':after': {
                display: 'none'
            }
        },
        'aria-label': (el)=>el.call('polyglot', 'shell.orgSwitcher.invite'),
        // The invite panel is a dialog (it holds a form), not a menu.
        'aria-haspopup': 'dialog',
        title: (el)=>el.call('polyglot', 'shell.orgSwitcher.invite'),
        // Single brand `userPlus` glyph (user + corner plus) — replaced the
        // composed UserIcon + PlusBadge overlay (2026-06-10 per Nika). Named by
        // `icon` above (IconButton's Icon renders only when the button names
        // one); sized here.
        Icon: {
            boxSize: 'iconSm',
            minWidth: 'iconSm'
        },
        // Same pointer/keyboard split as the Trigger above — see that comment.
        onMousedown: (e, el, s)=>{
            if (e.button !== 0) return;
            el.scope.openInviteDropdown(e, el, s);
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if (e.detail !== 0) return;
            el.scope.openInviteDropdown(e, el, s);
        }
    }
};
const $3a06f6cac03e440f$export$5ffa5a00df2bb29d = {
    // FA204 / frank trap — see AppOrgSwitcher.scope's header comment above for
    // the full rationale. `orgs`/`activeOrg` (+ their dependency chain) are
    // duplicated verbatim (object-literal scope properties can't reference
    // each other across different top-level components); `slideOrgSwitcher`
    // is pure DOM manipulation with no shared state, duplicated the same way
    // into AppOrgSwitcherItem's scope below.
    scope: {
        mongoActiveOrgId (root) {
            const org = root && root.org;
            return org && (org.id || org._id) || '';
        },
        rawOrgs (root) {
            // the switcher's list: functions/visibleOrgs.js (see `_rawOrgs`)
            const fromState = Array.isArray(root?.orgs) ? root.orgs : null;
            return (0, $dot7l.visibleOrgs)(fromState || [], {
                keep: [
                    root?.org?.id,
                    root?.org?._id,
                    root?.org?.slug,
                    root?._pendingActiveOrgId
                ]
            });
        },
        orgs (root) {
            const raw = this.rawOrgs(root);
            if (!raw.length) return [];
            const invalid = root?._invalidOrgs;
            if (Array.isArray(invalid) && invalid.length) {
                const skip = new Set(invalid);
                const filtered = raw.filter((o)=>!skip.has(o.id));
                return filtered.length ? filtered : raw;
            }
            return raw;
        },
        workspaces (root) {
            const byOrg = root && root.orgWorkspaces;
            if (!byOrg || typeof byOrg !== 'object') return [];
            const out = [];
            for (const k of Object.keys(byOrg)){
                const list = byOrg[k];
                if (Array.isArray(list)) out.push(...list);
            }
            return out;
        },
        activeWsId (root) {
            if (root?.workspace?.id) return String(root.workspace.id);
            try {
                const ls = (0, $jhJrJ.getActiveWorkspacePointer)();
                if (ls) return ls;
            } catch (err) {
                console.warn('[AppOrgSwitcherMenu] read activeWorkspace failed:', err?.message || err);
            }
            return '';
        },
        activeOrg (root) {
            const orgs = this.orgs(root);
            const claimOrgId = this.mongoActiveOrgId(root);
            if (!orgs.length) {
                const stateOrg = root?.org;
                if (stateOrg && (stateOrg.id || stateOrg._id)) return {
                    id: stateOrg.id || stateOrg._id,
                    name: stateOrg.name || stateOrg.displayName
                };
                if (claimOrgId) return {
                    id: claimOrgId,
                    name: root?.org?.name || ''
                };
                return null;
            }
            const pendingId = root?._pendingActiveOrgId;
            if (pendingId) {
                const pending = orgs.find((o)=>o.id === pendingId);
                if (pending) return pending;
            }
            if (claimOrgId) {
                const fromClaim = orgs.find((o)=>o.id === claimOrgId);
                if (fromClaim) return fromClaim;
            }
            const activeId = this.activeWsId(root);
            const w = this.workspaces(root).find((x)=>(x.id || x.workspace_id || x._id) === activeId);
            if (!w) return orgs[0] || null;
            return orgs.find((o)=>o.id === (w.org_id || w.organization)) || null;
        },
        // The org list under the filter: a case- and accent-insensitive match on
        // the name. An empty query is the whole list.
        matchingOrgs (root, query) {
            const orgs = this.orgs(root);
            const fold = (v)=>String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            const q = fold(query).trim();
            if (!q) return orgs;
            return orgs.filter((o)=>fold(o.name || o.displayName).includes(q));
        },
        // The menu's height is pinned to L1's (see onInit); a filtered list
        // changes L1, so re-pin it after the list has rendered.
        remeasureL1 (el) {
            const run = ()=>this.slideOrgSwitcher(el && el.node, 0);
            if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
            else run();
        },
        // Imperative because the dropdown panel doesn't re-render content on
        // state change and v3.14 freezes reactive transform/height. `fromNode`
        // is any node inside the menu; level 1 = workspaces slid in, 0 = back
        // to orgs.
        slideOrgSwitcher (fromNode, level, orgId, orgName) {
            if (!fromNode || typeof fromNode.closest !== 'function') return;
            const menu = fromNode.closest('[role="menu"]');
            if (!menu) return;
            const slider = menu.querySelector('[data-org-slider]');
            // The level on the menu: the menu's static rules take the layer that
            // is off stage out of paint and out of the Tab order after the slide.
            menu.setAttribute('data-org-level', level === 1 ? '1' : '0');
            if (level === 1) {
                menu.querySelectorAll('[data-ws-group]').forEach((g)=>{
                    g.style.display = g.getAttribute('data-ws-group') === orgId ? '' : 'none';
                });
                const title = menu.querySelector('[data-org-l2-title]');
                if (title && orgName) title.textContent = orgName;
                if (slider) slider.style.transform = 'translateX(-100%)';
                const l2 = menu.querySelector('[data-org-l2]');
                if (l2) menu.style.height = l2.scrollHeight + 'px';
            } else {
                if (slider) slider.style.transform = 'translateX(0)';
                const l1 = menu.querySelector('[data-org-l1]');
                if (l1) menu.style.height = l1.scrollHeight + 'px';
            }
        }
    },
    // House MenuPanel chrome — the body RELAYS on the one house dropdown
    // surface and paints none of its own (Nika 2026-09-02, pinned by
    // dropdownPanelSurfaceRelay.test.js); the slide mechanics need their own box
    // model — no padding (the L1/L2 layers pad themselves), hidden overflow,
    // free height.
    extends: 'MenuPanel',
    tag: 'div',
    minWidth: 'min(G, calc(100dvw - var(--spacing-B)))',
    width: 'max-content',
    maxWidth: 'calc(100dvw - var(--spacing-B))',
    // The menu's OWN state: the org filter (it used to land on the dropdown
    // layer's state, which every other dropdown body shares). Declared, so the
    // updates are never dropped.
    state: {
        orgQuery: ''
    },
    textAlign: 'left',
    padding: '0',
    maxHeight: 'none',
    overflow: 'hidden',
    position: 'relative',
    // 2-level slide: orgs → that org's workspaces, committing on a workspace
    // pick (2026-06-09 per Nika). The dropdown panel doesn't re-render its
    // content on state change and v3.14 freezes reactive transform/height, so
    // the slide + height are driven imperatively on the nodes via data-* hooks
    // (see _slideOrgSwitcher) by AppOrgSwitcherItem (drill) and the L2 back row.
    // Motion on the overlay spring (DESIGN_SPEC §9: `C springBezier`; it was a
    // raw 280ms curve of its own).
    transition: 'height C springBezier',
    // ONE LAYER ON STAGE (the overflow law, HOME_AMBIENT_SKIN_SPEC §3b rule 1:
    // the hidden overflow above clips the SLIDE, never a control). The layer
    // the slide moved off stage was still painted beyond the clip and still in
    // the Tab order — Tab from the last org reached an invisible Back button.
    // It leaves with the slide: visible at once when it comes in, hidden only
    // after the `C` spring when it goes out, so the motion still shows both.
    // `data-org-level` is written by slideOrgSwitcher; no attribute = level 0.
    '& [data-org-l1], & [data-org-l2]': {
        transition: 'visibility 0s'
    },
    '&:not([data-org-level="1"]) [data-org-l2]': {
        visibility: 'hidden',
        transition: 'visibility 0s linear C'
    },
    '&[data-org-level="1"] [data-org-l1]': {
        visibility: 'hidden',
        transition: 'visibility 0s linear C'
    },
    onInit: (el)=>{
        if (typeof requestAnimationFrame === 'undefined' || !el.node) return;
        // Always (re)open sized to L1. Clear any stale inline height FIRST — a height
        // left over from a previous open's L2 drill (or a single-rAF measurement
        // taken before the orgs list had laid out) would otherwise persist and
        // mis-size the panel, reading as a big gap above/below the content. Then
        // measure after a DOUBLE rAF so the L1 list is actually flushed before we
        // pin the height. (2026-06-22 per Nika "OrgSwitcher content sometimes has
        // big padding top".)
        el.node.style.height = '';
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
                const l1 = el.node && el.node.querySelector('[data-org-l1]');
                if (l1 && el.node) el.node.style.height = l1.scrollHeight + 'px';
            }));
    },
    Slider: {
        attr: {
            'data-org-slider': 'true'
        },
        position: 'relative',
        flow: 'x',
        width: '100%',
        align: 'start',
        transition: 'transform C springBezier',
        // THE LIST SCROLLS, THE FOOTER DOES NOT.
        //
        // The smbls dropdown portal that hosts this menu caps itself at 70vh and
        // scrolls (inline `max-height: 70vh; overflow: auto` on the portal node —
        // MenuPanel's own 60vh is overridden to `none` above, so the portal's cap
        // is the one that binds). The footer rows — Admin, Create organization
        // (Delete organization then too; it moved to Settings › Danger zone,
        // Q10 A) — sit AFTER the org list, so on an account with many
        // orgs they were pushed past that cap and out of sight. Measured on
        // my.symbols.app 2026-09-04 with 18 orgs: L1 was 706px tall in a 600px
        // port, and the Admin row's top sat at y=646, 46px below the fold. The
        // portal does scroll, but macOS overlay scrollbars paint nothing at rest,
        // so the menu simply looked like it had no admin link at all.
        //
        // So L1 takes the cap itself and gives it to the ORG LIST: the list is the
        // part that grows without bound, the footer is fixed-size and must always
        // be reachable. `minHeight: 0` is required — a flex item's default
        // `min-height: auto` refuses to shrink below its content and would keep
        // the overflow on the outside. The 70dvh literal mirrors the portal's own
        // 70vh cap — dynamic units, so on iOS Safari (where vh is the LARGE
        // viewport, the URL bar hidden) the list fits the screen the person
        // actually sees and never exceeds the portal (dvh <= vh everywhere); L2
        // below carries the same pair for the same reason.
        L1: {
            attr: {
                'data-org-l1': 'true'
            },
            width: '100%',
            flexShrink: '0',
            flow: 'y',
            padding: 'Z',
            maxHeight: '70dvh',
            boxSizing: 'border-box',
            // A long membership list gets a filter (DESIGN_SPEC §9: more than eight
            // orgs). The kit's compact search capsule; the query lives on the
            // menu's own state; the menu re-measures L1 after the list changes.
            OrgSearch: {
                extends: 'AppFieldSearch',
                hide: (el, s)=>el.scope.orgs(s.root).length <= 8,
                flexShrink: '0',
                marginBottom: 'Y',
                placeholder: (el)=>el.call('polyglot', 'common.action.search'),
                aria: {
                    label: (el)=>el.call('polyglot', 'shell.orgSwitcher.switchAria')
                },
                value: (el, s)=>s.orgQuery || '',
                onInput: (e, el, s)=>{
                    s.update({
                        orgQuery: e.target && e.target.value || ''
                    });
                    el.scope.remeasureL1(el);
                },
                onClear: (e, el, s)=>{
                    s.update({
                        orgQuery: ''
                    });
                    el.scope.remeasureL1(el);
                }
            },
            Orgs: {
                flow: 'y',
                // The only flex item that may give up height. Everything below it in
                // L1 is pinned with `flexShrink: '0'` — without that the 1px Divider
                // (content height 0) is the cheapest thing for the browser to shrink,
                // and it disappears first.
                flex: '1 1 auto',
                minHeight: '0',
                overflowY: 'auto',
                // Don't chain the list's edge-bounce to the page behind the menu —
                // the same guideline MenuPanel applies to its own scroller.
                overscrollBehavior: 'contain',
                childExtends: 'AppOrgSwitcherItem',
                childrenAs: 'state',
                children: (el, s)=>el.scope.matchingOrgs(s.root, s.orgQuery)
            },
            NoOrgMatches: {
                tag: 'p',
                flexShrink: '0',
                margin: '0',
                padding: 'Y Z1',
                fontSize: 'Z1',
                color: 'caption',
                hide: (el, s)=>!(s.orgQuery || '').trim() || el.scope.matchingOrgs(s.root, s.orgQuery).length > 0,
                text: '{{ common.state.noMatches | polyglot }}'
            },
            // The footer is set apart by space, not a hairline (no rules inside a
            // rounded surface) — a pinned 1px spacer inside its margin.
            Divider: {
                height: '1px',
                flexShrink: '0',
                margin: 'Y 0'
            },
            // Admin link — only visible when the user holds an org-management role
            // on the currently active org. Tier hierarchy mirrors the server-side
            // ORG_MGMT_ROLES set used by tickets/functions/cycleStore.js's
            // `canManageCycles`: owner / co-owner / admin / maintainer. Routes to
            // /admin (workspace/pages/admin/admin.js) — the Users & Roles panel.
            AdminLink: {
                // House context-dropdown row chrome (padding/round/fontSize/hover).
                extends: 'MenuPanelItem',
                flexShrink: '0',
                hide: (el, s)=>{
                    const active = el.scope.activeOrg(s.root);
                    const role = active?.role;
                    return !(role === 'owner' || role === 'co-owner' || role === 'admin' || role === 'maintainer');
                },
                text: '{{ shell.orgSwitcher.admin | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('closeDropdown', 'appOrgSwitcher');
                    el.router('/admin', el.getRoot());
                }
            },
            // "Delete organization" is NOT here (Q10 A, Nika 2026-09-26): it moved to
            // Settings › Danger zone (MemberProfile.ProfileDanger.DeleteOrgRow), with
            // its confirm step. A destructive org action does not belong in the menu
            // people open to switch; the switcher keeps Admin and + Create.
            // Footer action — opens the inline AppCreateOrgModal (sibling
            // component, root-mounted) instead of routing to a canvas URL. The
            // old `canvasUrl('/organizations/new')` resolved to
            // `https://canvas.<tier>.symbols.app/organizations/new`, but that
            // host is NXDOMAIN and the path isn't routed on canvas either —
            // bug #2186. Keeping the create flow in-shell also avoids losing
            // the user's current workspace context.
            CreateOrg: {
                // House context-dropdown row chrome; footer action stays muted
                // (caption) and brightens to title on the house theme-aware hover.
                extends: 'MenuPanelItem',
                flexShrink: '0',
                color: 'caption',
                // House MenuPanelItem hover (the `hover` wash token) plus a
                // caption→title brighten for the muted footer action.
                ':hover': {
                    color: 'title',
                    background: 'hover'
                },
                text: '{{ shell.orgSwitcher.createOrg | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('closeDropdown', 'appOrgSwitcher');
                    el.call('openCreateOrgModal');
                }
            }
        },
        // Same cap as L1 (see its comment): the workspace groups are the growing
        // part, the Back header must stay reachable at the top of the port.
        L2: {
            attr: {
                'data-org-l2': 'true'
            },
            // Only L1 determines the intrinsic menu width; L2 slides into its box.
            position: 'absolute',
            left: '100%',
            top: '0',
            width: '100%',
            flexShrink: '0',
            flow: 'y',
            padding: 'Z',
            maxHeight: '70dvh',
            boxSizing: 'border-box',
            Back: {
                attr: {
                    'data-org-back': 'true'
                },
                tag: 'button',
                type: 'button',
                flexShrink: '0',
                flow: 'x',
                align: 'center left',
                gap: 'Z',
                width: '100%',
                borderWidth: '0',
                background: 'transparent',
                cursor: 'pointer',
                // House context-dropdown row chrome (padding/round/fontSize/hover);
                // keeps the bold weight + back-icon layout of the L2 header.
                padding: 'Y Z1',
                round: 'radiusControl',
                color: 'title',
                fontWeight: '700',
                fontSize: 'Z1',
                marginBottom: 'V',
                // House MenuPanelItem hover (the `hover` wash token).
                ':hover': {
                    background: 'hover'
                },
                BackIcon: {
                    extends: 'Icon',
                    name: 'arrowAngleLeft',
                    boxSize: 'A',
                    flexShrink: '0'
                },
                Title: {
                    tag: 'span',
                    attr: {
                        'data-org-l2-title': 'true'
                    },
                    flex: '1',
                    minWidth: '0',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    text: '{{ shell.orgSwitcher.workspaces | polyglot }}'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.scope.slideOrgSwitcher(el.node, 0);
                }
            },
            Groups: {
                flow: 'y',
                flex: '1 1 auto',
                minHeight: '0',
                overflowY: 'auto',
                overscrollBehavior: 'contain',
                childExtends: 'AppWsGroup',
                childrenAs: 'state',
                children: (el, s)=>el.scope.orgs(s.root)
            }
        }
    }
};
const $3a06f6cac03e440f$export$49a29de5aebddbba = {
    // FA204 / frank trap — see AppOrgSwitcher.scope's header comment above for
    // the full rationale. `activeOrg` (+ chain) and `slideOrgSwitcher` are
    // duplicated verbatim from AppOrgSwitcherMenu's own scope.
    scope: {
        mongoActiveOrgId (root) {
            const org = root && root.org;
            return org && (org.id || org._id) || '';
        },
        rawOrgs (root) {
            // the switcher's list: functions/visibleOrgs.js (see `_rawOrgs`)
            const fromState = Array.isArray(root?.orgs) ? root.orgs : null;
            return (0, $dot7l.visibleOrgs)(fromState || [], {
                keep: [
                    root?.org?.id,
                    root?.org?._id,
                    root?.org?.slug,
                    root?._pendingActiveOrgId
                ]
            });
        },
        // The row MARK's image (Nika 2026-10-31): the org's own logoSvg wins,
        // else the company profile logo /auth/me sends as `profileLogoSrc` (https
        // only), else nothing (the letter). Reads only the ROW's OWN keys: a
        // `childrenAs: 'state'` row reads a key it lacks from the ROOT state, and
        // a root-level logo must never paint every row. A src that failed to load
        // (onError records it) is the letter too.
        orgMarkSrc (s) {
            if (!s) return '';
            // read first (a tracked read: a later write re-runs the mark), then
            // keep the value only when the row itself holds the key
            const own = (k)=>{
                const v = s[k];
                return Object.prototype.hasOwnProperty.call(s, k) ? v : undefined;
            };
            const branding = own('branding');
            const svg = own('logoSvg') || branding && branding.logoSvg;
            let src = '';
            if (typeof svg === 'string' && /^\s*<svg[\s>]/i.test(svg)) src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg.trim());
            else {
                const url = own('profileLogoSrc');
                if (typeof url === 'string' && /^https:\/\/\S+$/i.test(url)) src = url;
            }
            return src && own('orgMarkFailedSrc') !== src ? src : '';
        },
        orgs (root) {
            const raw = this.rawOrgs(root);
            if (!raw.length) return [];
            const invalid = root?._invalidOrgs;
            if (Array.isArray(invalid) && invalid.length) {
                const skip = new Set(invalid);
                const filtered = raw.filter((o)=>!skip.has(o.id));
                return filtered.length ? filtered : raw;
            }
            return raw;
        },
        workspaces (root) {
            const byOrg = root && root.orgWorkspaces;
            if (!byOrg || typeof byOrg !== 'object') return [];
            const out = [];
            for (const k of Object.keys(byOrg)){
                const list = byOrg[k];
                if (Array.isArray(list)) out.push(...list);
            }
            return out;
        },
        activeWsId (root) {
            if (root?.workspace?.id) return String(root.workspace.id);
            try {
                const ls = (0, $jhJrJ.getActiveWorkspacePointer)();
                if (ls) return ls;
            } catch (err) {
                console.warn('[AppOrgSwitcherItem] read activeWorkspace failed:', err?.message || err);
            }
            return '';
        },
        activeOrg (root) {
            const orgs = this.orgs(root);
            const claimOrgId = this.mongoActiveOrgId(root);
            if (!orgs.length) {
                const stateOrg = root?.org;
                if (stateOrg && (stateOrg.id || stateOrg._id)) return {
                    id: stateOrg.id || stateOrg._id,
                    name: stateOrg.name || stateOrg.displayName
                };
                if (claimOrgId) return {
                    id: claimOrgId,
                    name: root?.org?.name || ''
                };
                return null;
            }
            const pendingId = root?._pendingActiveOrgId;
            if (pendingId) {
                const pending = orgs.find((o)=>o.id === pendingId);
                if (pending) return pending;
            }
            if (claimOrgId) {
                const fromClaim = orgs.find((o)=>o.id === claimOrgId);
                if (fromClaim) return fromClaim;
            }
            const activeId = this.activeWsId(root);
            const w = this.workspaces(root).find((x)=>(x.id || x.workspace_id || x._id) === activeId);
            if (!w) return orgs[0] || null;
            return orgs.find((o)=>o.id === (w.org_id || w.organization)) || null;
        },
        slideOrgSwitcher (fromNode, level, orgId, orgName) {
            if (!fromNode || typeof fromNode.closest !== 'function') return;
            const menu = fromNode.closest('[role="menu"]');
            if (!menu) return;
            const slider = menu.querySelector('[data-org-slider]');
            // The level on the menu: the menu's static rules take the layer that
            // is off stage out of paint and out of the Tab order after the slide.
            menu.setAttribute('data-org-level', level === 1 ? '1' : '0');
            if (level === 1) {
                menu.querySelectorAll('[data-ws-group]').forEach((g)=>{
                    g.style.display = g.getAttribute('data-ws-group') === orgId ? '' : 'none';
                });
                const title = menu.querySelector('[data-org-l2-title]');
                if (title && orgName) title.textContent = orgName;
                if (slider) slider.style.transform = 'translateX(-100%)';
                const l2 = menu.querySelector('[data-org-l2]');
                if (l2) menu.style.height = l2.scrollHeight + 'px';
            } else {
                if (slider) slider.style.transform = 'translateX(0)';
                const l1 = menu.querySelector('[data-org-l1]');
                if (l1) menu.style.height = l1.scrollHeight + 'px';
            }
        }
    },
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    width: '100%',
    // Row chrome = the house MenuPanelItem recipe (kept inline — the active
    // background factory needs to interleave with it): Y/Z1 padding, the
    // control radius, Z1 fontSize, theme-aware :hover wash.
    padding: 'Y Z1',
    round: 'radiusControl',
    borderWidth: '0',
    // Active row gets the subtle FilesSidebar active wash (white @10%, same as
    // /files FilesScopeSeg / FilesTypeFilterRow) instead of the harsh near-opaque
    // overlayStrong block (2026-06-14 per Nika "show active item by background
    // just like FilesSidebar"); the active row keeps that wash on hover.
    background: (el, s)=>{
        const active = el.scope.activeOrg(s.root);
        // Non-active rows return undefined (NOT 'transparent'): a factory background
        // renders as an INLINE style, and an inline `background:var(--color-transparent)`
        // outranks the `:hover` CLASS rule below — that's why the rows never washed on
        // hover. With no inline bg the `:hover` rule applies; the active row keeps its
        // inline wash (which correctly persists on hover, as intended).
        return active && active.id === s.id ? 'selected' : undefined;
    },
    cursor: 'pointer',
    fontSize: 'Z1',
    fontWeight: '500',
    color: 'title',
    textAlign: 'left',
    // Expose the active org to assistive tech, not just the background wash.
    'aria-current': (el, s)=>{
        const active = el.scope.activeOrg(s.root);
        return active && active.id === s.id ? 'true' : 'false';
    },
    // House MenuPanelItem :hover wash — the `hover` token as a FLAT prop (a
    // `:hover` block with only `@dark`/`@light` sub-blocks emits NOTHING through
    // css-in-props; the adaptive token needs no split anyway). The active wash
    // lives on the base `background` above.
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    // The org's MARK — a small squircle with its first letter on the neutral
    // plate (DESIGN_SPEC §9: "rows = org squircle + name + role micro-label").
    // One grapheme, never re-cased: a Georgian name keeps its Mkhedruli letter.
    OrgMark: {
        tag: 'span',
        display: 'flex',
        align: 'center center',
        flexShrink: '0',
        boxSize: 'avatarXs',
        round: 'radiusControl',
        background: 'widgetPlate',
        color: 'title',
        fontSize: 'Z',
        fontWeight: '500',
        lineHeight: '1',
        overflow: 'hidden',
        ariaHidden: 'true',
        // the letter only while no logo shows (scope.orgMarkSrc)
        text: (el, s)=>el.scope?.orgMarkSrc?.(s) ? '' : Array.from(String(s.name || s.displayName || '').trim())[0] || '',
        // The logo, when the org has one: the org's own logoSvg, else the company
        // profile logo. Decorative (the row's Name carries the label). A logo that
        // fails to load records its src on the row, so the mark shows the letter.
        Img: {
            boxSize: '100%',
            objectFit: 'cover',
            round: 'radiusControl',
            alt: '',
            hide: (el, s)=>!el.scope?.orgMarkSrc?.(s),
            src: (el, s)=>el.scope?.orgMarkSrc?.(s) || null,
            onError: (e, el, s)=>{
                const src = el.scope?.orgMarkSrc?.(s);
                if (src && s && typeof s.update === 'function') s.update({
                    orgMarkFailedSrc: src
                });
            }
        }
    },
    Name: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ':hover': {
            textOverflow: 'clip'
        },
        '&:hover > span': {
            width: 'max-content',
            overflow: 'visible'
        },
        onMouseenter: (e, el)=>{
            const node = el.node;
            const text = el.Text?.node;
            if (!node || !text || typeof text.animate !== 'function') return;
            text.getAnimations().forEach((animation)=>animation.cancel());
            const distance = text.scrollWidth - node.clientWidth;
            if (distance <= 0) return;
            if (typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            // Pause at each end, then travel back; leaving restores the ellipsis.
            const travel = Math.max(1200, distance * 35);
            const pause = 700;
            const duration = travel + pause * 2;
            text.animate([
                {
                    transform: 'translateX(0)',
                    offset: 0
                },
                {
                    transform: 'translateX(0)',
                    offset: pause / duration
                },
                {
                    transform: `translateX(-${distance}px)`,
                    offset: 1 - pause / duration
                },
                {
                    transform: `translateX(-${distance}px)`,
                    offset: 1
                }
            ], {
                duration: duration,
                iterations: Infinity,
                direction: 'alternate',
                easing: 'linear'
            });
        },
        onMouseleave: (e, el)=>{
            el.Text?.node?.getAnimations().forEach((animation)=>animation.cancel());
        },
        onDestroy: (el)=>{
            el.Text?.node?.getAnimations().forEach((animation)=>animation.cancel());
        },
        Text: {
            tag: 'span',
            display: 'block',
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: (el, s)=>s.name
        }
    },
    // Per-org attention badge. Reads from `root.orgNotifCount[orgId]` —
    // a simple count keyed by org id. Populated by whatever cross-org
    // notifications aggregator lands server-side (see NEEDED_FOR_SERVER
    // §I8); renders an empty string when the count is 0/undefined so the
    // slot stays invisible rather than showing stale layout.
    NotifBadge: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        // Reviewed (fixed-colour sweep): kept — fixed alert-badge pairing
        // (background is the non-adaptive `red` accent), the same convention
        // Messenger/NotificationBell/meet's badges all use.
        color: 'white',
        // Fixed alert-badge pairing, deliberately NOT theme-adaptive — an alert
        // reads red on both shells. But brand `red` (#EB6650) is tuned as a PLATE
        // colour, and white on it measures 3.21:1: fine for a dot (3:1 non-text
        // floor) and a fail for a COUNT, which is text. `redDeep` is the same
        // alert red deepened — white on #A83520 = 6.53:1. Measured across every
        // route by the aa-contrast sweep, 2026-08-09; 15 violation groups traced
        // to this one badge shape.
        background: 'redDeep',
        round: 'radiusPill',
        padding: 'V Z',
        minWidth: 'Z1',
        textAlign: 'center',
        text: (el, s)=>{
            const count = s.root?.orgNotifCount?.[s.id] || 0;
            return count > 0 ? count > 99 ? '99+' : String(count) : '';
        },
        // Collapse the badge entirely when count is 0. Using visibility
        // keeps the flex gap consistent; display:none would cause layout
        // jitter on state updates in DOMQL v3.14.
        display: (el, s)=>{
            const count = s.root?.orgNotifCount?.[s.id] || 0;
            return count > 0 ? 'inline-block' : 'none';
        }
    },
    // The role as the mono micro-label (it labels data); `caption` rather than
    // the label's own `inactive` — the active row sits on the `selected` wash,
    // where `inactive` drops under 4.5:1 (AppMicroLabel's note).
    Role: {
        extends: 'AppMicroLabel',
        flexShrink: '0',
        whiteSpace: 'nowrap',
        color: 'caption',
        text: (el, s)=>s.role || 'member'
    },
    // The current org: the check, in ink — selection is monochrome (P5; it was
    // green). An ICON, not the ✓ text glyph.
    Check: {
        extends: 'Icon',
        flexShrink: '0',
        name: 'check',
        boxSize: 'A',
        color: 'title',
        hide: (el, s)=>{
            const active = el.scope.activeOrg(s.root);
            return !(active && active.id === s.id);
        }
    },
    // Chevron hint that the row drills into workspaces — quiet ink, no opacity.
    Chevron: {
        extends: 'Icon',
        flexShrink: '0',
        name: 'arrowAngleRight',
        boxSize: 'Z1',
        color: 'inactive'
    },
    // Drilling into an org slides the menu to its workspaces (level 2). The
    // actual switch commits when a workspace is picked (AppWsItem) — 2026-06-09
    // per Nika, the 2-level org → workspace dropdown.
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.scope.slideOrgSwitcher(el.node, 1, s.id, s.name);
    }
};
// Commit a switch to `org` with a specific home workspace (the picked one).
// The org-row switch logic, extracted — now the level-2 workspace rows call it.
// THE SWITCH DEADLINE (work.astio.ai 2026-10-08, Nika: an org picked in the
// header menu left "Switching workspace" on screen for ever). The switch
// awaited `sdk.switchOrg` with no bound; every step inside it is an unbounded
// network wait (the PATCH, the token refresh behind it, the workspace hop), so
// one that never answered never reached `_endSwitching`. Now the await races
// ORG_SWITCH_DEADLINE_MS; `_wsSwitching` ALWAYS clears (finally) and the toast
// offers a retry (`retryOrgSwitch` -> globalThis.__orgSwitchRetry).
// Follow-ups M1–M3 (review-two-hotfixes.md, 2026-10-09):
//  · M3 — the only caller passes a homeWorkspaceId, so the 12 s reload
//    fallback is armed on every switch: the deadline (10 s) fires FIRST and its
//    catch disarms the fallback.
//  · M2 / B1 / B2 — the server is the truth. A timeout always ends in ONE
//    full reload (the boot reads the server's org/workspace): the client never
//    rolls back alone, and no late SDK answer or socket echo can land in a page
//    that was told the switch failed.
//  · M1 — one switch generation (globalThis.__orgSwitchState). The SDK call is
//    shared by key: "Try again" while it is still in flight RE-JOINS it, never
//    races a second one; only the newest generation clears the loader flags.
const $3a06f6cac03e440f$var$ORG_SWITCH_DEADLINE_MS = 10000;
const $3a06f6cac03e440f$var$ORG_SWITCH_TIMEOUT = 'ORG_SWITCH_TIMEOUT';
const $3a06f6cac03e440f$var$_withSwitchDeadline = (work)=>new Promise((resolve, reject)=>{
        const timer = setTimeout(()=>{
            const err = new Error('the switch did not answer in ' + $3a06f6cac03e440f$var$ORG_SWITCH_DEADLINE_MS / 1000 + ' s');
            err.code = $3a06f6cac03e440f$var$ORG_SWITCH_TIMEOUT;
            reject(err);
        }, $3a06f6cac03e440f$var$ORG_SWITCH_DEADLINE_MS);
        let pending;
        try {
            pending = Promise.resolve(work());
        } catch (err) {
            pending = Promise.reject(err);
        }
        pending.then((value)=>{
            clearTimeout(timer);
            resolve(value);
        }, (err)=>{
            clearTimeout(timer);
            reject(err);
        });
    });
const $3a06f6cac03e440f$var$_orgSwitchState = ()=>{
    if (!globalThis.__orgSwitchState) globalThis.__orgSwitchState = {
        gen: 0,
        pending: null
    };
    return globalThis.__orgSwitchState;
};
// The in-flight SDK switch for `key`, shared: a second commit for the same
// target re-joins it instead of starting another.
const $3a06f6cac03e440f$var$_sharedSwitchCall = (key, start)=>{
    const st = $3a06f6cac03e440f$var$_orgSwitchState();
    if (st.pending && st.pending.key === key) return st.pending.promise;
    let run;
    try {
        run = Promise.resolve(start());
    } catch (err) {
        run = Promise.reject(err);
    }
    st.pending = {
        key: key,
        promise: run
    };
    const clear = ()=>{
        if (st.pending && st.pending.promise === run) st.pending = null;
    };
    run.then(clear, clear);
    return run;
};
// N4 (Nika 2026-10-09, "Go to that org's own host"): on a white-label host a
// brand only ever shows its own org. A switch to ANOTHER org leaves the host
// with one top-level navigation to that org's own host — its VERIFIED
// white-label domain from the server record (the org's custom-domain rows,
// the same SDK read the admin Domains page uses), else the channel's shell
// host (shared workspaceOrigin). No in-place switch happens there, so the
// half-switch risk (B1/B2) cannot. NO token travels: every remote handoff is
// refused (P0, d16ce904f) — the user signs in on the target host if needed.
// The domain read is bounded; a refusal (only org managers may list the
// rows), an error or a timeout means "no verified domain known".
const $3a06f6cac03e440f$var$ORG_HOST_LOOKUP_MS = 3000;
const $3a06f6cac03e440f$var$_orgOwnHostUrl = async (el, orgId, orgSlug)=>{
    let domain = null;
    try {
        if (el.sdk && typeof el.sdk.listOrgCustomDomains === 'function') {
            const res = await Promise.race([
                Promise.resolve(el.sdk.listOrgCustomDomains(orgId)),
                new Promise((resolve)=>setTimeout(()=>resolve(null), $3a06f6cac03e440f$var$ORG_HOST_LOOKUP_MS))
            ]);
            const rows = res && (res.customDomains || res.data && res.data.customDomains) || [];
            const row = Array.isArray(rows) ? rows.find((r)=>r && r.domain && r.verifiedAt) : null;
            domain = row ? String(row.domain).trim().toLowerCase() : null;
        }
    } catch (_) {
        domain = null;
    }
    const here = typeof window !== 'undefined' && window.location ? window.location.hostname : '';
    if (domain && /^[a-z0-9.-]+$/.test(domain) && domain !== here) return `https://${domain}/`;
    // The shell host of THIS deployment's plane (ruling b): the served channel
    // first — a customer domain's hostname names no channel, and the
    // hostname-only resolver would fall back to the PROD shell on a staging
    // white-label host — then the hostname resolver.
    const channel = (0, $29wU0.deploymentChannel)();
    const shell = channel && (0, $hmkNw.shellUrl)(channel) || (0, $grPR9.workspaceOrigin)();
    try {
        const u = new URL(shell);
        // N5: land in the org the user PICKED (`/w/<slug>/`), not the server's
        // active one; a slug that is not slug-shaped never reaches the path.
        const slug = typeof orgSlug === 'string' && /^[a-z0-9][a-z0-9_-]*$/i.test(orgSlug) ? orgSlug : null;
        const path = slug ? (0, $9juhh.withWorkspacePrefix)(slug, '/').replace(/\/?$/, '/') : '/';
        if (u.hostname !== here) return u.origin + path;
    } catch (_) {
    /* no shell origin — stay */ }
    return null;
};
async function $3a06f6cac03e440f$var$_commitOrgSwitch(el, root, org, homeWorkspaceId, label) {
    if (!org) return;
    // N4: leaving a white-label host for another org is a navigation, never an
    // in-place switch.
    if (String(org.id) !== String($3a06f6cac03e440f$var$_mongoActiveOrgId(root)) && typeof window !== 'undefined' && window.location && el.call('isCustomDomainHost') === true) {
        el.call('closeDropdown', 'appOrgSwitcher');
        // N7: the host lookup can take up to ORG_HOST_LOOKUP_MS — show the loader
        $3a06f6cac03e440f$var$_startSwitching(root, label || org.name, org.id);
        let target = null;
        try {
            target = await $3a06f6cac03e440f$var$_orgOwnHostUrl(el, org.id, org.slug || org.username);
        } finally{
            if (!target) $3a06f6cac03e440f$var$_endSwitching(root);
        }
        if (target) {
            window.location.assign(target);
            return;
        }
    }
    const _st = $3a06f6cac03e440f$var$_orgSwitchState();
    const _gen = ++_st.gen;
    let _ended = false;
    const _end = (extra)=>{
        if (_ended) return;
        _ended = true;
        // a newer switch owns the loader flags now — never clear them under it
        if (_gen !== _st.gen) return;
        $3a06f6cac03e440f$var$_endSwitching(root, extra);
    };
    // A workspace pick is EITHER a cross-org switch OR a workspace switch within
    // the org you're already on. sdk.switchOrg early-returns { changed: false }
    // when the org is unchanged and so NEVER federates the workspace — that's the
    // "picked another workspace in my current org and nothing happened" bug. Route
    // same-org picks through switchWorkspace directly. Capture the active org
    // BEFORE _startSwitching sets the optimistic pending id.
    // Mongo only — root.org.id (the resolved active-org row) is the canonical
    // current-org id.
    const _currentOrgId = $3a06f6cac03e440f$var$_mongoActiveOrgId(root);
    const _orgChanged = String(org.id) !== String(_currentOrgId);
    $3a06f6cac03e440f$var$_startSwitching(root, label || org.name, org.id);
    el.call('closeDropdown', 'appOrgSwitcher');
    // Arm the reload fallback BEFORE the switch. The in-place refetch
    // (onWorkspaceChange — fired by sdk.orgSwitched / the claims refresh) calls
    // clearWorkspaceSwitchFallback() on its FIRST line, so arming first lets the
    // common in-place path CANCEL this timer → NO reload, a smooth in-place switch.
    // It used to be armed AFTER `await switchOrg`, by which point onWorkspaceChange
    // had already run and cleared a not-yet-armed timer — so the late timer always
    // survived and hard-reloaded the window ~5s after every switch (the "switches
    // then reloads" bug). The reload is now a true last resort: it only fires if
    // the refetch never runs within 12s (a genuinely stuck federated round-trip).
    if (homeWorkspaceId) {
        $3a06f6cac03e440f$export$b0a763c3ca50cce0();
        if (!globalThis.__wsSwitchFallbackState) globalThis.__wsSwitchFallbackState = {
            timer: null
        };
        globalThis.__wsSwitchFallbackState.timer = setTimeout(()=>{
            // The bag is created, never deleted, by production code — but this
            // callback runs 12 s later and a throw inside a timer has no catcher,
            // so it never assumes the bag is still there.
            if (globalThis.__wsSwitchFallbackState) globalThis.__wsSwitchFallbackState.timer = null;
            if (typeof window !== 'undefined') {
                console.warn("[AppOrgSwitcher] in-place workspace refresh never ran \u2014 reloading");
                window.location.reload();
            }
        }, 12000);
    }
    // No local retry here — the SDK itself retries a pre-send
    // NETWORK_UNREACHABLE failure (e.g. a nodemon restart window) at its
    // request chokepoint for both `setActiveOrganization` and
    // `setActiveWorkspace` (see sdk/src/services/BaseService.js
    // RETRY_SAFE_METHOD_NAMES), which `sdk.switchOrg`/`sdk.switchWorkspace`
    // call internally. A second retry loop wrapped around them here just
    // multiplied the wait (4 tries x 1200ms on top of the SDK's own
    // exponential backoff) before a real, non-transient failure could
    // surface to the user.
    try {
        if (!_orgChanged && homeWorkspaceId) {
            // Same org → switch ONLY the workspace (switchOrg would no-op and never
            // federate). switchWorkspace's federation returns { ok: false } instead of
            // throwing on a forbidden/failed bridge call, so surface that as an error
            // rather than silently leaving the user where they were.
            const res = await $3a06f6cac03e440f$var$_withSwitchDeadline(()=>$3a06f6cac03e440f$var$_sharedSwitchCall('ws:' + homeWorkspaceId, ()=>el.sdk.switchWorkspace(homeWorkspaceId)));
            if (res && res.ok === false) throw new Error(res.error && res.error.message || res.error || 'workspace switch failed');
        } else // Cross-org: switchOrg persists the org (Mongo) AND federates the
        // workspace via an inner switchWorkspace, so it emits BOTH
        // sdk.orgSwitched and sdk.workspaceSwitched. Flag the window so the
        // shell's workspaceSwitched handler defers to its orgSwitched handler
        // and the in-place refetch runs once, not twice.
        // The flag lives as long as the SDK call itself (not the deadline): a
        // late answer still emits workspaceSwitched while the call runs.
        await $3a06f6cac03e440f$var$_withSwitchDeadline(()=>$3a06f6cac03e440f$var$_sharedSwitchCall('org:' + org.id + ':' + (homeWorkspaceId || ''), ()=>{
                if (el.sdk) el.sdk.__switchingOrg = true;
                const call = Promise.resolve(el.sdk.switchOrg(org.id, {
                    homeWorkspaceId: homeWorkspaceId
                }));
                const off = ()=>{
                    if (el.sdk) el.sdk.__switchingOrg = false;
                };
                call.then(off, off);
                return call;
            }));
        _end();
        if (typeof window !== 'undefined' && org.slug) {
            const m = window.location.pathname.match(/^\/studio\/[^/]+(\/.*)?$/);
            if (m) el.router(`/studio/${org.slug}${m[1] || ''}`, el.getRoot());
            else if ($3a06f6cac03e440f$var$_allowOptimisticUrlRewrite(window.location.pathname, homeWorkspaceId)) {
                const rest = (0, $9juhh.stripWorkspacePrefix)(window.location.pathname);
                el.router((0, $9juhh.withWorkspacePrefix)(org.slug, rest), el.getRoot());
            }
        }
    } catch (err) {
        // Switch failed — cancel the reload (we surface a toast instead of bouncing).
        $3a06f6cac03e440f$export$b0a763c3ca50cce0();
        const msg = err?.message || String(err) || 'unknown error';
        const timedOut = err?.code === $3a06f6cac03e440f$var$ORG_SWITCH_TIMEOUT;
        // B1/B2 (review of 65076304e): the deadline stops only the WAIT — the SDK
        // switch keeps running, and its late answer (or the server's
        // active-org-changed echo) would move this tab after any "still in your
        // previous organization" message; and the server may already hold the new
        // org/workspace. So a timeout always ends in ONE full reload: the boot reads
        // the server's truth, no late answer can land in this page, and the client
        // never rolls back alone. (The 12 s fallback is disarmed above.)
        if (timedOut && typeof window !== 'undefined' && window.location) {
            console.warn("[AppOrgSwitcher] switch did not finish in time \u2014 reloading into the server state");
            _end();
            window.location.reload();
            return;
        }
        const notMember = err?.status === 403 || /not a member of target org/i.test(msg);
        // A network-class failure is transient — never permanently remove the org OR
        // workspace over a dropped connection; the user retries once they're back.
        const isNetwork = timedOut || /failed to fetch|network|unreachable|connection|load failed/i.test(msg);
        const extra = {};
        if (notMember) {
            const prev = Array.isArray(root?._invalidOrgs) ? root._invalidOrgs : [];
            if (!prev.includes(org.id)) extra._invalidOrgs = [
                ...prev,
                org.id
            ];
        }
        // A genuine (non-network) failure to switch to THIS workspace means the row
        // only ever errors — drop it from the switcher (see _orgWorkspaces's filter),
        // exactly like a not-member org drops from the org list. Guarded to real
        // failures so a transient blip doesn't hide a good workspace.
        if (homeWorkspaceId && !isNetwork) {
            const prevW = Array.isArray(root?._invalidWorkspaces) ? root._invalidWorkspaces : [];
            if (!prevW.includes(homeWorkspaceId)) extra._invalidWorkspaces = [
                ...prevW,
                homeWorkspaceId
            ];
        }
        _end(Object.keys(extra).length ? extra : undefined);
        console.warn('[AppOrgSwitcher] switch threw:', msg);
        // the toast's retry runs this same switch again (functions/retryOrgSwitch.js);
        // none for a membership refusal — a retry only meets the same 403 (N3)
        globalThis.__orgSwitchRetry = notMember ? null : ()=>$3a06f6cac03e440f$var$_commitOrgSwitch(el, root, org, homeWorkspaceId, label);
        el.call('openNotification', {
            title: el.call('polyglot', 'shell.orgSwitcher.switchFailed').replace('{name}', label || org.name || el.call('polyglot', 'shell.orgSwitcher.workspaceFallback')),
            // Sanitized for the user — a network-class failure otherwise shows the
            // SDK's developer-facing diagnostic (host, VPN/DNS/adblocker hints, the
            // raw "Failed to fetch"). `msg` above (raw) is still used for the
            // notMember regex check and the console.warn.
            message: (0, $1gOQB.userFacingErrorMessage)(err, {
                networkMessage: el.call('polyglot', 'shell.orgSwitcher.networkError'),
                fallback: ()=>msg
            }),
            type: 'error',
            duration: 8000,
            ...notMember ? {} : {
                action: {
                    call: 'retryOrgSwitch'
                },
                actionLabel: 'common.action.try_again'
            }
        });
    } finally{
        // whatever happened above, the switch flag never outlives the switch
        _end();
    }
}
const $3a06f6cac03e440f$export$29a7f897916538a4 = {
    // FA204 / frank trap — see AppOrgSwitcher.scope's header comment above for
    // the full rationale. `orgWorkspaces` (+ its `workspaces` dependency) is
    // duplicated verbatim.
    scope: {
        workspaces (root) {
            const byOrg = root && root.orgWorkspaces;
            if (!byOrg || typeof byOrg !== 'object') return [];
            const out = [];
            for (const k of Object.keys(byOrg)){
                const list = byOrg[k];
                if (Array.isArray(list)) out.push(...list);
            }
            return out;
        },
        orgWorkspaces (orgId, root) {
            const fetched = root && root.orgWorkspaces && root.orgWorkspaces[orgId];
            const base = Array.isArray(fetched) ? fetched : this.workspaces(root).filter((w)=>(w.org_id || w.organization) === orgId);
            const invalid = root?._invalidWorkspaces;
            if (Array.isArray(invalid) && invalid.length) {
                const skip = new Set(invalid);
                const filtered = base.filter((w)=>!skip.has(w.id || w.workspace_id || w._id));
                return filtered.length ? filtered : base;
            }
            return base;
        }
    },
    attr: {
        'data-ws-group': (el, s)=>s.id
    },
    style: {
        display: 'none'
    },
    flow: 'y',
    Items: {
        flow: 'y',
        childExtends: 'AppWsItem',
        childrenAs: 'state',
        children: (el, s)=>el.scope.orgWorkspaces(s.id, s.root)
    },
    Empty: {
        hide: (el, s)=>el.scope.orgWorkspaces(s.id, s.root).length > 0,
        tag: 'p',
        margin: '0',
        // Match the L2 row padding/type so the empty-state label aligns with
        // the workspace rows it replaces.
        padding: 'Y Z1',
        fontSize: 'Z1',
        color: 'caption',
        text: '{{ shell.orgSwitcher.noWorkspaces | polyglot }}'
    },
    // "+ New workspace" — create a workspace in THIS org (`s` is the org), the L2
    // mirror of L1's "+ Create organization" footer (2026-06-14 per Nika). Gated
    // to org-management roles (the set AdminLink uses). Surfaced
    // optimistically into root.orgWorkspaces (the Mongo source the L2 lists
    // read) so the new workspace shows immediately without a round-trip.
    NewWs: {
        hide: (el, s)=>{
            const r = s.role;
            return !(r === 'owner' || r === 'co-owner' || r === 'admin' || r === 'maintainer');
        },
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        width: '100%',
        marginTop: 'V',
        padding: 'Y Z1',
        round: 'radiusControl',
        borderWidth: '0',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: 'Z1',
        fontWeight: '500',
        color: 'caption',
        textAlign: 'left',
        'aria-label': (el)=>el.call('polyglot', 'shell.orgSwitcher.newWorkspaceAria'),
        // House MenuPanelItem hover (the `hover` wash token) plus a
        // caption→title brighten for the muted footer action.
        ':hover': {
            color: 'title',
            background: 'hover'
        },
        Icon: {
            extends: 'Icon',
            name: 'plus',
            boxSize: 'A',
            minWidth: 'A'
        },
        Label: {
            tag: 'span',
            text: '{{ shell.orgSwitcher.newWorkspace | polyglot }}'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const root = s.root;
            const orgId = s.id;
            el.call('promptDialog', {
                title: el.call('polyglot', 'shell.orgSwitcher.newWorkspace'),
                message: el.call('polyglot', 'shell.orgSwitcher.newWorkspacePrompt').replace('{org}', s.name || el.call('polyglot', 'shell.orgSwitcher.orgFallback')),
                placeholder: el.call('polyglot', 'shell.orgSwitcher.newWorkspacePlaceholder'),
                confirmText: el.call('polyglot', 'common.action.create'),
                onConfirm: async (value)=>{
                    const displayName = (value || '').trim();
                    if (!displayName) return;
                    try {
                        const res = await el.sdk.createWorkspace({
                            organization: orgId,
                            displayName: displayName
                        });
                        const ws = res && (res.data || res.workspace || res) || null;
                        const wid = ws && (ws._id || ws.id);
                        if (wid) {
                            // Surface the new workspace optimistically in root.orgWorkspaces
                            // — the Mongo source the L2 lists read (_orgWorkspaces/_workspaces).
                            // Normalized to id/name/org_id like the SDK prefetch so the row +
                            // active-check + switch read it.
                            const byOrg = {
                                ...root.orgWorkspaces || {}
                            };
                            byOrg[orgId] = [
                                ...Array.isArray(byOrg[orgId]) ? byOrg[orgId] : [],
                                {
                                    id: wid,
                                    workspace_id: wid,
                                    org_id: orgId,
                                    organization: orgId,
                                    type: ws.type || 'shared',
                                    displayName: displayName,
                                    name: displayName
                                }
                            ];
                            root.update({
                                orgWorkspaces: byOrg
                            });
                        }
                    } catch (err) {
                        console.warn('[AppOrgSwitcher] createWorkspace failed:', err && err.message ? err.message : err);
                        el.call('openNotification', {
                            title: el.call('polyglot', 'shell.orgSwitcher.workspaceNotCreated'),
                            message: err && err.message || el.call('polyglot', 'shell.orgSwitcher.createFailed'),
                            type: 'warning'
                        });
                    }
                }
            });
        }
    }
};
const $3a06f6cac03e440f$export$37a8c9383d275203 = {
    // FA204 / frank trap — see AppOrgSwitcher.scope's header comment above for
    // the full rationale. `activeWsId`/`orgs` (+ chain) are duplicated
    // verbatim for the RENDER-time reads below (background/aria-current/
    // Check.hide — everything that runs on mount, which is the surface this
    // sweep's acceptance bar (zero console errors on catalog page load)
    // actually covers).
    //
    // DELIBERATE, DOCUMENTED EXCEPTION — `onClick`'s call into `_commitOrgSwitch`
    // stays a bare module-scope reference, NOT `el.scope`-ified, unlike every
    // other call site in this file. It is NOT part of this file's emitted
    // `globalScope` surface (frank's emission gate names zero defects here), and
    // the commit flow only runs on a genuine interactive click — never on page
    // load or mount — needs a real SDK session, and is not exercised by a static
    // catalog sample.
    //
    // The original reason for the exception is now GONE and must not be quoted
    // back: it used to be that `_commitOrgSwitch` shared a module-scope
    // `_wsFallbackTimer` closure with the EXPORTED
    // `clearWorkspaceSwitchFallback`, which is imported and called
    // bare/argument-less by `packages/workspace/functions/loadPrivateData.js` (a
    // DIFFERENT package), so scope-ifying this one call would have orphaned that
    // timer. The timer now lives on `globalThis.__wsSwitchFallbackState`
    // (WS-SHARED-MODULE-LET-BLOCKS-EVERY-PUSH-1), which both packages reach
    // whatever the bundler does — so a future sweep MAY scope-ify this call.
    // That change needs its own live workspace-switch verification and is out of
    // this ticket's scope.
    scope: {
        mongoActiveOrgId (root) {
            const org = root && root.org;
            return org && (org.id || org._id) || '';
        },
        rawOrgs (root) {
            // the switcher's list: functions/visibleOrgs.js (see `_rawOrgs`)
            const fromState = Array.isArray(root?.orgs) ? root.orgs : null;
            return (0, $dot7l.visibleOrgs)(fromState || [], {
                keep: [
                    root?.org?.id,
                    root?.org?._id,
                    root?.org?.slug,
                    root?._pendingActiveOrgId
                ]
            });
        },
        orgs (root) {
            const raw = this.rawOrgs(root);
            if (!raw.length) return [];
            const invalid = root?._invalidOrgs;
            if (Array.isArray(invalid) && invalid.length) {
                const skip = new Set(invalid);
                const filtered = raw.filter((o)=>!skip.has(o.id));
                return filtered.length ? filtered : raw;
            }
            return raw;
        },
        activeWsId (root) {
            if (root?.workspace?.id) return String(root.workspace.id);
            try {
                const ls = (0, $jhJrJ.getActiveWorkspacePointer)();
                if (ls) return ls;
            } catch (err) {
                console.warn('[AppWsItem] read activeWorkspace failed:', err?.message || err);
            }
            return '';
        }
    },
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    width: '100%',
    // House context-dropdown row chrome (Y/Z1 padding, the control radius, Z1
    // fontSize, :hover) — matches AppOrgSwitcherItem so L1 and L2 rows read
    // identically; the active workspace wears the `selected` wash.
    padding: 'Y Z1',
    round: 'radiusControl',
    borderWidth: '0',
    background: (el, s)=>{
        const a = el.scope.activeWsId(s.root);
        const w = s.id || s.workspace_id || s._id;
        // undefined (not 'transparent') on non-active rows — see AppOrgSwitcherItem:
        // an inline transparent background defeats the :hover class wash below.
        return a && a === w ? 'selected' : undefined;
    },
    cursor: 'pointer',
    fontSize: 'Z1',
    fontWeight: '500',
    color: 'title',
    textAlign: 'left',
    // Expose the active workspace to assistive tech alongside the checkmark.
    'aria-current': (el, s)=>{
        const a = el.scope.activeWsId(s.root);
        const w = s.id || s.workspace_id || s._id;
        return a && a === w ? 'true' : 'false';
    },
    // House MenuPanelItem :hover wash — the `hover` token as a flat prop (see
    // AppOrgSwitcherItem; a `:hover` block with only `@dark`/`@light` sub-blocks
    // emits no rule in css-in-props).
    ':hover': {
        background: 'hover'
    },
    Name: {
        tag: 'span',
        flex: '1',
        text: (el, s)=>s.name
    },
    Role: {
        extends: 'AppMicroLabel',
        color: 'caption',
        onInit: async (el, s)=>{
            if (s.role) return;
            const wsId = s.id || s.workspace_id || s._id;
            if (!wsId) {
                console.warn('[AppWsItem] workspace id not found');
                return;
            }
            const sdk = el.sdk || el.context?.sdk || el.getRoot()?.sdk;
            if (!sdk) {
                console.warn('[AppWsItem] sdk not found');
                return;
            }
            try {
                const fetchPerms = typeof sdk.getWorkspacePermissions === 'function' ? (id)=>sdk.getWorkspacePermissions(id) : typeof sdk.execute === 'function' ? (id)=>sdk.execute('workspace', 'getWorkspacePermissions', id) : null;
                if (!fetchPerms) {
                    console.warn('[AppWsItem] cannot fetch permissions');
                    return;
                }
                const res = await fetchPerms(wsId);
                s.role = res?.role || res?.data?.role || (typeof res === 'string' ? res : null);
            } catch (err) {
                console.warn('[AppWsItem] getWorkspacePermissions failed:', err?.message || err);
            }
        },
        text: (el, s)=>s.role || ''
    },
    // The current workspace: the check in ink (P5 — selection is monochrome).
    Check: {
        extends: 'Icon',
        name: 'check',
        boxSize: 'A',
        color: 'title',
        hide: (el, s)=>{
            const a = el.scope.activeWsId(s.root);
            const w = s.id || s.workspace_id || s._id;
            return !(a && a === w);
        }
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const orgId = s.org_id || s.organization;
        // The workspace's org is normally one of root.orgs (shared id-space), but
        // fall back to a minimal { id } so the switch still commits if it isn't —
        // _commitOrgSwitch only needs the org id, never the full record.
        const org = el.scope.orgs(s.root).find((o)=>o.id === orgId) || (orgId ? {
            id: orgId
        } : null);
        const wsId = s.id || s.workspace_id || s._id;
        // See the DELIBERATE, DOCUMENTED EXCEPTION comment on this component's
        // own `scope` above — _commitOrgSwitch stays a bare module reference.
        // Returned so a caller (the tests) can await the whole switch.
        return $3a06f6cac03e440f$var$_commitOrgSwitch(el, s.root, org, wsId, s.name);
    }
};
const $3a06f6cac03e440f$export$1c630aede5a7912c = {
    display: 'none'
};

});
parcelRegister("1gOQB", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $0eceba49f9381af2$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isTransportIntegrityError", () => $0eceba49f9381af2$export$8ff9fc37a2824389);
$parcel$export(module.exports, "userFacingErrorMessage", () => $0eceba49f9381af2$export$aaf189bf7ac29ad1);
// userFacingErrorMessage — turns a raw JS/SDK error into a short, safe
// string for end users. Two call sites hit this: the AI chat transport
// (simoneAiTransport.js onError) and the org/workspace switcher's failure
// toast (AppOrgSwitcher.js _commitOrgSwitch) — both used to show the raw
// `err.message`, which for a network-class failure is the SDK's
// diagnostic string built for developers (host, VPN/DNS/adblocker hints,
// the literal "Failed to fetch") — alarming and meaningless to a user.
//
// Network-class detection mirrors the SDK's own classifier
// (sdk/src/services/BaseService.js `_isNetworkFailure` / `NETWORK_UNREACHABLE`):
// prefer the tagged `err.code`, fall back to matching the message shape in
// case an untagged fetch-layer TypeError slips through.
//
// The raw error should still go to console.warn/console.error at the call
// site for debugging — only the string shown to the user goes through here.
//
// FA204/FA207 / frank trap — `_NETWORK_ERROR_RX` (module-scope) and
// `isNetworkError` (a sibling export, read bare by userFacingErrorMessage)
// are both unresolvable once this file's exports are individually
// frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers; readerVoice.js precedent).
// Both are now inlined self-contained in each consumer.
function $0eceba49f9381af2$export$476aa014e2fd89d5(err) {
    const NETWORK_ERROR_RX = /failed to fetch|network unreachable|networkerror|load failed/i;
    return err?.code === 'NETWORK_UNREACHABLE' || NETWORK_ERROR_RX.test(err?.message || '');
}
function $0eceba49f9381af2$export$8ff9fc37a2824389(err) {
    const STREAM_INTEGRITY_RX = /empty sse stream|no deltas,?\s*no tool calls|no error frame|ai provider unavailable|produced no output|reported usage|incomplete\/corrupted|corrupted completion/i;
    return STREAM_INTEGRITY_RX.test(err?.message || '');
}
function $0eceba49f9381af2$export$aaf189bf7ac29ad1(err, { networkMessage: networkMessage, streamMessage: streamMessage, fallback: fallback } = {}) {
    const NETWORK_ERROR_RX = /failed to fetch|network unreachable|networkerror|load failed/i;
    const isNetwork = err?.code === 'NETWORK_UNREACHABLE' || NETWORK_ERROR_RX.test(err?.message || '');
    if (isNetwork) return networkMessage || "Couldn't reach the server \u2014 check your connection and try again.";
    if ($0eceba49f9381af2$export$8ff9fc37a2824389(err)) return streamMessage || "The AI service didn't respond cleanly. Try again \u2014 if it keeps happening, switching models often helps.";
    if (typeof fallback === 'function') return fallback(err);
    const msg = (err?.message || String(err) || '').trim();
    return msg || 'Something went wrong.';
}

});

parcelRegister("cQy7L", function(module, exports) {

$parcel$export(module.exports, "ORG_SWITCHER_DROPDOWN_ID", () => $95a4cfb97f0ffb8d$export$1b8ba0d8d4389d24);
// The dropdown layer id openOrgSwitcherMenu opens the org switcher under.
// Shared so the workspace shell's Panel pin
// (workspace/functions/orgSwitcherPanelPin.js) matches the same layer
// without a copy of the string.
const $95a4cfb97f0ffb8d$export$1b8ba0d8d4389d24 = 'appOrgSwitcher';

});


parcelRegister("aWIip", function(module, exports) {

$parcel$export(module.exports, "HEADER_ISLAND_MIN_HEIGHT", () => $7f81ae690d561802$export$2e833cc8508b73ce);
$parcel$export(module.exports, "AppHeader", () => $7f81ae690d561802$export$9bd256435c34a030);
$parcel$export(module.exports, "AppHeaderWithIcons", () => $7f81ae690d561802$export$bb6373a7174a2595);
$parcel$export(module.exports, "AppNavLink", () => $7f81ae690d561802$export$a602c5acb020e155);

var $2zkc2 = parcelRequire("2zkc2");

var $4SiPM = parcelRequire("4SiPM");

var $kvDhE = parcelRequire("kvDhE");

var $hg33k = parcelRequire("hg33k");

var $9GdJK = parcelRequire("9GdJK");

var $debL2 = parcelRequire("debL2");
const $7f81ae690d561802$export$2e833cc8508b73ce = '2.26rem';
const $7f81ae690d561802$export$9bd256435c34a030 = {
    // FA204 / frank trap — every imperative responsive-sync helper below lives
    // in `scope`, not module scope: a bare module-scope const/function
    // silently reads as undefined once the component is frank.toJSON'd for
    // platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Called via
    // `el.scope.<name>(...)` from any descendant factory (`scope:` merges onto
    // every instance). Regular `function` syntax (not arrows) throughout this
    // object — `el.scope.foo()` binds `this` to `el.scope`, so sibling helpers
    // call each other via `this.<name>(...)` instead of a bare identifier
    // (object-literal properties can't see each other as free variables).
    scope: {
        // Kept for the `onInit`/`watchMediaQueries` call sites below (those
        // resolve fine via `el.scope`). Query strings, evaluated once here —
        // plain values, not function bodies, so they bake to literal strings at
        // serialization time same as HEADER_ISLAND_MIN_HEIGHT above.
        MOBILE_HEADER_SEARCH_QUERY: (0, $debL2.default).mobileL,
        TABLET_HEADER_SEARCH_QUERY: (0, $debL2.default).tabletS,
        TABLET_MIDDLE_MAX_WIDTH: 'calc(100% - var(--hdr-left-w) - var(--hdr-right-w) - 2 * (var(--spacing-X2) + var(--spacing-A)))',
        TABLET_MIDDLE_LEFT: 'calc(var(--hdr-left-w) + var(--spacing-X2) + var(--spacing-A))',
        clearInlineStyles (node, properties) {
            if (!node) return;
            for (const property of properties)node.style.removeProperty(property);
        },
        // The tablet writers below own the TOP navbar only: on a rail or at the
        // bottom (functions/navbarLayout.js) they clear what they wrote and stand
        // aside — the header's own case blocks lay it out there.
        navAtTop (el) {
            const root = el && el.state && el.state.root;
            const nav = el && typeof el.call === 'function' ? el.call('navbarLayoutRead', root) : null;
            return !nav || nav.position === 'top';
        },
        applyNowAndNextFrame (apply) {
            apply();
            window.requestAnimationFrame?.(apply);
        },
        watchMediaQueries (el, key, queries, sync) {
            if (typeof window === 'undefined' || el[key]) return;
            const mediaQueries = queries.map((query)=>window.matchMedia?.(query)).filter(Boolean);
            if (!mediaQueries.length) return;
            const handler = ()=>sync();
            for (const query of mediaQueries){
                if (query.addEventListener) query.addEventListener('change', handler);
                else if (query.addListener) query.addListener(handler);
            }
            el[key] = {
                mediaQueries: mediaQueries,
                handler: handler
            };
        },
        unwatchMediaQueries (el, key) {
            const watcher = el?.[key];
            if (!watcher) return;
            for (const query of watcher.mediaQueries){
                if (query.removeEventListener) query.removeEventListener('change', watcher.handler);
                else if (query.removeListener) query.removeListener(watcher.handler);
            }
            el[key] = null;
        },
        clearHeaderLeftCompactStyle (node) {
            if (!node) return;
            this.clearInlineStyles(node, [
                'width',
                'min-height',
                'max-height',
                'padding',
                'gap',
                'flex-direction',
                'border-radius',
                'box-sizing',
                'align-items',
                'justify-content',
                'position'
            ]);
            const logo = node.querySelector(':scope > [data-key="Logo"]');
            this.clearInlineStyles(logo, [
                'position',
                'inset',
                'width',
                'height',
                'padding',
                'align-items',
                'justify-content'
            ]);
            const actions = node.querySelector(':scope > [data-key="HeaderActions"]');
            this.clearInlineStyles(actions, [
                'opacity',
                'max-height',
                'transform',
                'pointer-events',
                'overflow',
                'display'
            ]);
        },
        syncHeaderLeftCompactLayout (el, s) {
            if (typeof window === 'undefined' || !el?.node) return;
            const compact = window.matchMedia?.(this.MOBILE_HEADER_SEARCH_QUERY).matches && !!(s.root?._canvasSlot || s.root?._canvasSlotSecond);
            this.clearHeaderLeftCompactStyle(el.node);
            const doc = document.documentElement;
            if (!compact) {
                delete doc.dataset.headerLeftCompact;
                return;
            }
            doc.dataset.headerLeftCompact = 'true';
            const logo = el.node.querySelector(':scope > [data-key="Logo"]');
            const actions = el.node.querySelector(':scope > [data-key="HeaderActions"]');
            // Keep origin/main's logo position, but constrain the compact surface
            // to an equal box so the base navbar cannot stretch into a horizontal
            // pill.
            el.node.style.setProperty('width', '2.5rem');
            el.node.style.setProperty('min-height', '2.5rem');
            el.node.style.setProperty('max-height', '2.5rem');
            el.node.style.setProperty('padding', '0');
            el.node.style.setProperty('gap', '0');
            el.node.style.setProperty('flex-direction', 'row');
            el.node.style.setProperty('border-radius', '50%');
            el.node.style.setProperty('box-sizing', 'border-box');
            el.node.style.setProperty('align-items', 'center');
            el.node.style.setProperty('justify-content', 'center');
            el.node.style.setProperty('position', 'relative');
            if (logo) {
                logo.style.setProperty('position', 'absolute');
                logo.style.setProperty('inset', '0');
                logo.style.setProperty('width', '100%');
                logo.style.setProperty('height', '100%');
                logo.style.setProperty('padding', '0');
                logo.style.setProperty('align-items', 'center');
                logo.style.setProperty('justify-content', 'center');
            }
            if (!actions) return;
            actions.style.setProperty('display', 'none');
            actions.style.setProperty('pointer-events', 'none');
        },
        // Only what the tablet lane below writes inline. NOT z-index
        // (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): nothing here sets it since the
        // phone path's inline `z-index: 20` left (workspace f4c5b736d), and the
        // framework lands the open pill's own state (`.isSearchOpen`: opacity,
        // pointer events, z) on the node's style — clearing z-index on every
        // update dropped the open pill back under the header islands on a phone
        // (measured on dev d2803c9e6: open, opacity 1, z auto).
        clearHeaderSearchResponsiveStyle (node) {
            this.clearInlineStyles(node, [
                'left',
                'right',
                'top',
                'width',
                'max-width',
                'min-width',
                'transform'
            ]);
        },
        syncHeaderSearchResponsiveLayout (el, s) {
            if (typeof window === 'undefined' || !el?.node) return;
            const open = !!s.root?._headerSearchOpen;
            // TABLET_HEADER_SEARCH_QUERY (media.tabletS) is a bare max-width:1024px
            // — it still matches at a 390px phone. Excluding
            // MOBILE_HEADER_SEARCH_QUERY (media.mobileL, ≤768px) here is the
            // JS-side twin of the designSystem/media.js tabletSOnly CSS token:
            // this function writes `!important` INLINE styles, which outrank any
            // class (including the '@mobileL' one-deck overrides), so the
            // CSS-level tabletSOnly fix alone cannot stop this from also winning
            // at phone widths — this guard has to live here too (2026-08-02, "one
            // deck" mobile merge — live-verified this was pinning HeaderSearch's
            // tablet lane offsets on top of the merged deck).
            const tablet = !!window.matchMedia?.(this.TABLET_HEADER_SEARCH_QUERY).matches && !window.matchMedia?.(this.MOBILE_HEADER_SEARCH_QUERY).matches;
            this.clearHeaderSearchResponsiveStyle(el.node);
            if (!this.navAtTop(el)) return;
            if (tablet) {
                // Same-name auto-extension can let HeaderSearch's base
                // left/top/transform beat the nested @tabletS props. Pin the
                // measured start-aligned lane inline, using the canonical
                // design-system media queries above.
                const applyTablet = ()=>{
                    el.node.style.setProperty('left', this.TABLET_MIDDLE_LEFT, 'important');
                    el.node.style.setProperty('right', 'auto', 'important');
                    el.node.style.setProperty('top', 'var(--spacing-X2)', 'important');
                    el.node.style.setProperty('max-width', this.TABLET_MIDDLE_MAX_WIDTH, 'important');
                    el.node.style.setProperty('min-width', '0', 'important');
                    el.node.style.setProperty('transform', open ? 'scale(1)' : 'scale(0.96)', 'important');
                };
                this.applyNowAndNextFrame(applyTablet);
                return;
            }
        },
        syncHeaderTabsTabletLayout (headerNode) {
            if (typeof window === 'undefined' || !headerNode) return;
            const node = headerNode.querySelector(':scope > [data-key="HeaderTabs"]');
            if (!node) return;
            this.clearInlineStyles(node, [
                'left',
                'right',
                'top',
                'width',
                'max-width',
                'transform'
            ]);
            // the top navbar's only (see navAtTop): the header names its place
            const place = headerNode.getAttribute && headerNode.getAttribute('data-nav-position');
            if (place && place !== 'top') return;
            // Exclude mobileL — same reasoning as syncHeaderSearchResponsiveLayout
            // above (bare tabletS still matches at 390px, and this function's
            // `!important` inline styles would outrank the '@mobileL' one-deck
            // flex override otherwise; this was the actual root cause of
            // HeaderTabs rendering ~60px past the right edge of a 390px viewport
            // before this fix — the CSS-level tabletSOnly rename alone was not
            // enough).
            const tablet = !!window.matchMedia?.(this.TABLET_HEADER_SEARCH_QUERY).matches && !window.matchMedia?.(this.MOBILE_HEADER_SEARCH_QUERY).matches;
            if (!tablet) return;
            const apply = ()=>{
                node.style.setProperty('left', this.TABLET_MIDDLE_LEFT, 'important');
                node.style.setProperty('right', 'auto', 'important');
                node.style.setProperty('top', 'var(--spacing-X2)', 'important');
                node.style.setProperty('width', 'fit-content', 'important');
                node.style.setProperty('max-width', this.TABLET_MIDDLE_MAX_WIDTH, 'important');
                node.style.setProperty('transform', 'none', 'important');
            };
            this.applyNowAndNextFrame(apply);
        },
        clearHeaderRightResponsiveStyle (node) {
            this.clearInlineStyles(node, [
                'position',
                'left',
                'right',
                'top',
                'margin-left',
                'max-width',
                'box-sizing',
                'background',
                'box-shadow',
                'padding',
                'min-height',
                'backdrop-filter',
                '-webkit-backdrop-filter'
            ]);
        },
        syncHeaderRightResponsiveLayout (el) {
            if (typeof window === 'undefined' || !el?.node) return;
            const mobile = window.matchMedia?.(this.MOBILE_HEADER_SEARCH_QUERY).matches;
            // Exclude mobile — bare tabletS still matches at 390px, and this
            // branch's `!important` inline `position:fixed` used to win there
            // too, UNCONDITIONALLY pinning HeaderRight to the raw viewport corner
            // and taking it OUT of the "one deck" flex row entirely (2026-08-02
            // fix — this was the literal root cause of the reported "avatar
            // pinned hard against the right screen edge, no gutter" bug: it was
            // never a flex child on phone at all). The merged mobile deck now
            // handles HeaderRight's position/background purely via the static
            // '@mobileL' class below (flex:'0 0 auto' + the deck's own padding
            // for the gutter) — this function owns tabletS-and-wider only.
            const tablet = !!window.matchMedia?.(this.TABLET_HEADER_SEARCH_QUERY).matches && !mobile;
            this.clearHeaderRightResponsiveStyle(el.node);
            if (!this.navAtTop(el)) return;
            if (tablet) {
                // The vertical left rail makes the header taller, but HeaderRight
                // remains a top-row island. Pin it to the VISUAL viewport: canvas
                // routes can make the AppHeader's absolute containing block wider
                // than window.innerWidth, so an absolute `right` still places the
                // avatar beyond the visible right edge.
                const applyTablet = ()=>{
                    el.node.style.setProperty('position', 'fixed', 'important');
                    el.node.style.setProperty('left', 'auto', 'important');
                    el.node.style.setProperty('right', 'calc(env(safe-area-inset-right) + var(--spacing-X2))', 'important');
                    el.node.style.setProperty('top', 'calc(env(safe-area-inset-top) + var(--spacing-X2))', 'important');
                    el.node.style.setProperty('margin-left', '0', 'important');
                    el.node.style.setProperty('max-width', 'calc(100% - var(--hdr-left-w) - 2 * var(--spacing-X2) - var(--spacing-A))', 'important');
                    el.node.style.setProperty('box-sizing', 'border-box', 'important');
                };
                this.applyNowAndNextFrame(applyTablet);
                return;
            }
            if (mobile) {
                // Independent of the tablet branch above (mutually exclusive now —
                // see the `tablet` guard) — belt-and-suspenders backdrop-removal,
                // matching the static '@mobileL' class below via the SAME
                // imperative-override idiom every other responsive-sync in this
                // file uses, without any of the tablet branch's position/right/top
                // fixed-viewport pinning.
                const applyMobile = ()=>{
                    el.node.style.setProperty('background', 'transparent', 'important');
                    el.node.style.setProperty('box-shadow', 'none', 'important');
                    el.node.style.setProperty('padding', '0', 'important');
                    el.node.style.setProperty('min-height', '0', 'important');
                    el.node.style.setProperty('backdrop-filter', 'none', 'important');
                    el.node.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
                };
                this.applyNowAndNextFrame(applyMobile);
            }
        }
    },
    // Shared floating-island chrome (Navbar + spacing/round). `theme` is
    // nulled and the background is transparent by default so the chrome
    // floats over canvas content — solid dark only while the home PageSlot
    // (AppWindow) is open, so it stays legible over app content.
    extends: 'IconNavbar',
    // Banner landmark — IconNavbar → brand Navbar is tag:'aside'; override the
    // tag to the semantic `<header>` so the persistent app header carries the
    // implicit `banner` role natively. The previous `attr: { role: 'banner' }`
    // kept the aside tag, and `banner` is not an allowed role on `<aside>` per
    // ARIA-in-HTML — axe `aria-allowed-role` (MARKETPLACE-AUDIT residue,
    // tickets/fable.md 2026-08-09). A top-level `<header>` (not nested in
    // main/section/article) IS the banner landmark, no explicit role needed.
    tag: 'header',
    // UI-NAVBAR-BLACK-GROUND-1 (Nika, option 2): the BLACK lives on the navbar
    // CONTAINER — this root spans the full strip (absolute, left/right pinned)
    // — while the islands stay unthemed (theme: null on HeaderLeft/HeaderRight,
    // UI-PROJECT-SWITCHER-GROUND-1). One continuous ground, no chip edges, no
    // gap. `navbar` theme = gray1.9+6 + blur dark / gray15.95 + blur light — a
    // token, never a raw colour. (558ea223c removed the transparent overrides
    // but THIS line was dropped by an aborted edit script — the write below is
    // the actual option-2 change.)
    //
    // ⚠️ REVERSED 2026-08-18 — Nika, verbatim: "black bg should not be on entire
    // navbar - only on islands". Option 2 (black on this container) is OUT; the
    // black moved to HeaderLeft/HeaderRight below. This root goes back to
    // theme: null AND regains the 2026-06-10 transparency pair, because that
    // pair is what keeps the bar from painting over an open PageSlot — removing
    // it was a side effect of the option-2 pass, not an intended change.
    theme: null,
    // Stay transparent even while a PageSlot / home AppWindow is open (2026-06-10
    // per Nika "remove header bg change when pageslot is open") — the HeaderLeft/
    // HeaderRight islands carry their own legible background over content.
    background: 'transparent',
    backdropFilter: 'none',
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'X2',
    round: '0',
    // Compact header font context (icons/chrome land at ≈12.5px). The Parcel
    // dev-server happens to emit this via a scratch token quirk — HeaderSearch's
    // `fontSize: '1.0625rem'` compiles to a `--font-size-Z` class that gets
    // hoisted onto the header root — but `smbls build` (prod) does NOT, so
    // dev.my/prod rendered the navbar a full step larger than localhost.
    // Declaring `fontSize: 'Z'` here (+ on HeaderLeft) makes the compact context
    // INTENTIONAL so it survives the production build and dev/prod match the
    // localhost size (Nika 2026-06-12 "keep the localhost sizes on dev + prod").
    // On the dev-server this is a no-op — the same `_fs-var--font-size-z` class
    // is already applied. See memory: scratch-devserver-vs-prod-token-mismatch.
    fontSize: 'Z',
    // The measured island widths — the onCreate ResizeObserver below writes
    // both on this node, inline, from the first frame it gets. These are only
    // the PRE-MEASURE values (the server render, the frame before the observer
    // publishes, a background tab with no animation frames), declared ONCE here
    // as spacing tokens so every consumer below — the centred-pill clamp and
    // the tablet lane offsets — reads one binding instead of its own raw px
    // fallback (brief §4.3 item 2, 2026-09-24). F / F2 are em-relative, so they
    // resolve in the consumer's font: in the search's 18.06px context F ≈
    // 200px and F2 ≈ 262px, where the old fallbacks were 210px and 270px; the
    // tablet lane's old 0px default slid the middle pill UNDER the left island
    // until the first measure (measured islands at 1920px: 162px and 252px).
    '--hdr-left-w': 'var(--spacing-F)',
    '--hdr-right-w': 'var(--spacing-F2)',
    // Overlay header (2026-06-06 per Nika): absolute over the page on every
    // surface — content flows underneath — rather than occupying a grid row.
    position: 'absolute',
    // iPad / WKWebView safe areas — inset the overlay off the status-bar notch and
    // (landscape) the camera housing. env() is 0 on non-notched devices, so this
    // is a no-op everywhere else. Paired with --shell-top's matching top inset in
    // workspace/app.js so page content still clears the now-lower header.
    top: 'env(safe-area-inset-top)',
    left: 'env(safe-area-inset-left)',
    right: 'env(safe-area-inset-right)',
    // Above every canvas element — including a dragged tile that briefly
    // raises itself to z=1000 in ProjectNode/IntegrationNode/etc.
    zIndex: '1100',
    // WHERE THE NAVBAR SITS (Nika 2026-10-24: "make sidebar optional to be
    // positioned at the top left right or bottom … left and right sidebars can
    // be toggle expandable"; functions/navbarLayout.js). The host frame places
    // the header — the workspace shell's overlay, the comm app's grid — and the
    // header turns to fit: on a RAIL (left or right) the three islands stack
    // into one column, the actions over the strip over the account. Each island
    // shares this root's `pill` fill (the skins rewrite that theme), painted by
    // the column's `:before` (the rail rule below). One surface covers the
    // flexible space above the account as well as the controls, without
    // stacking three blur layers. At the bottom the row stays a row.
    // `data-nav-position` is the tablet writers' gate (scope.navAtTop) and the
    // hosts' hook.
    //
    // THE RAIL IS AN ATTRIBUTE, NOT A CASE. Every element that turns on a rail
    // carries `data-nav-rail` ('narrow' | 'wide'; none off a rail) and its rail
    // rules select on it — CSS rules compounded onto the element's own class.
    // Never `isX` case blocks here: smbls 3.14.841 lands a case's keys as inline
    // styles, and this header's own layout writers (the tablet lanes, the
    // compact logo — scope above) clear inline properties by name on every
    // update, so a rail case was wiped wherever a writer clears the same key
    // (measured on dev 50e520dd0: the head stayed a 157px row, the search pill
    // sat mid-screen). A rule is never touched by `style.removeProperty`, and a
    // writer stands aside off the top (navAtTop), so nothing inline outranks
    // it there. The general `[data-nav-rail]` rule and its `="narrow"` /
    // `="wide"` rules never write the same key: they share one specificity, and
    // their order in the sheet must not decide.
    'data-nav-position': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).position,
    'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
    //
    // THE RAIL'S GLASS IS ITS `:before`, NEVER THE COLUMN ITSELF (Nika
    // 2026-10-27: "fix navbar search button click on workspace for both left
    // and top navbar modes"). A `backdrop-filter` — the `pill` theme's blur —
    // makes its element the containing block of every `position: fixed`
    // descendant. The column carried it, so the search pill's "top centre of
    // the screen" (HeaderSearch's rail rule) resolved inside the column, and
    // the column's clip cut it away: a click on the rail's search opened the
    // search, focused its input and opened the launcher, and none of it showed
    // (measured on dev 2fc624ff0 at 1920px: the pill's `left: 50%` = 30px, its
    // box -313…382px under the logo, the launcher at the rail's corner). The
    // pseudo paints the same `pill` fill and blur under the islands, so the
    // rail still reads as one surface, and the column stays a plain box that
    // a fixed descendant passes through. `isolation` keeps the pseudo's
    // negative layer inside the column on every host (it adds no containing
    // block). Each island keeps the pill's ink from its own theme.
    '&[data-nav-rail]': {
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        gap: '0',
        padding: '0',
        round: 'radiusCard',
        overflow: 'hidden',
        isolation: 'isolate',
        ':before': {
            content: '""',
            position: 'absolute',
            inset: '0',
            zIndex: '-1',
            pointerEvents: 'none',
            borderRadius: 'inherit',
            theme: 'pill'
        }
    },
    // a wide (expanded) rail keeps one width whatever its names measure — the
    // page rail's own (AppSidebar `G`); a narrow rail is as wide as its glyphs
    '&[data-nav-rail="wide"]': {
        width: 'G'
    },
    '&[data-nav-rail="narrow"]': {
        width: 'D',
        '@coarse': {
            minWidth: 'calc(var(--size-controlH) + 2 * var(--spacing-Z))'
        }
    },
    // Was `background: 'transparent'` + `backdropFilter: 'none'` (2026-06-10
    // "remove header bg change when pageslot is open" — legibility then came
    // from the islands' own glass). The islands are unthemed now, so the
    // legible ground moved UP to this container: the `navbar` theme above
    // paints the whole strip continuously in both themes (UI-NAVBAR-BLACK-
    // GROUND-1, option 2). No transparent override left to fight it.
    // "One deck" merge (2026-08-02 per Nika "make navbars on mobile smarter,
    // more compact, modern … native-like"). Replaces three independently
    // floating glass islands (measured live at 390×844: HeaderLeft alone ran
    // 53.1px tall and 290px wide, HeaderTabs/HeaderSearch started inside that
    // same span — a physical overlap) with ONE full-width bar carrying the
    // ONLY backdrop-filter surface in the header: HeaderLeft/HeaderTabs/
    // HeaderRight go transparent at this breakpoint (their own '@mobileL'
    // blocks below) and this root paints the shared glass instead — merging
    // three compositor layers into one roughly halves the header's GPU
    // compositing cost on a phone, the actual performance story here.
    '@mobileL': {
        alignItems: 'center',
        gap: 'Z',
        // Full-bleed bar, not a floating inset pill (the OLD per-island look):
        // native top bars sit flush; content aligns to the SAME 'A' gutter
        // MainColumn's mobile padding uses (packages/workspace/pages/main.js
        // '@mobileL' padding: 'D1 A F A') via this padding's horizontal 'A', so
        // the deck's content and the page's content share one vertical grid
        // line. Longhand (not a 4-value shorthand) per the calc()/token
        // compiler gotcha — this one has no calc() to trip it, but every other
        // safe-area edge below does, so all four stay explicit for consistency.
        paddingTop: 'V',
        paddingBottom: 'V',
        paddingLeft: 'A',
        paddingRight: 'A',
        overflowX: 'clip',
        // THE TAP-TARGET TOKEN, not a rem gauge (2026-09-04 per Nika "on mobile
        // version, navbars and text are too small").
        //
        // This was `2.618rem`, with a comment reasoning "1.618² em at the 17px
        // root ≈ 44.5px … clears the 44pt tap-target guideline outright". The
        // root is NOT 17px on a phone. Measured live in a 390px viewport: the
        // document root computes 13px (16px at 1196px — the root is itself
        // responsive), so `2.618rem` landed 34.03px and the bar painted 38px
        // tall. Every rem gauge in this file inherited the same 24% shortfall,
        // and it is why the mobile deck read small.
        //
        // `controlH` is the house 44px control height from designSystem/sizes.js
        // — an absolute px token precisely because a tap target is a PHYSICAL
        // guideline, not a typographic one, so it must not scale with a root
        // that shrinks on the very devices the guideline exists for.
        minHeight: 'controlH',
        // The deck's own text steps up with the bar. `Z` computes 12.04px at the
        // phone's 13px root — under the 13px floor this shell uses for body text
        // everywhere else; `A` is exactly 1em (13px) in that context.
        fontSize: 'A',
        // The one shared glass surface (see the merge note above). Consumers
        // that want theme-driven canvas-card-glass everywhere else in this file
        // reference it unconditionally; nesting it here is the SAME token
        // resolution, just scoped to this breakpoint only — proven safe by the
        // `'@light'` nested inside `':hover'` blocks already shipping in
        // AppOrgSwitcher.js (nested selector wrapping is orthogonal to which
        // selectors are nested).
        // The skins' `pill` theme (see HeaderLeft): the deck is the header's one
        // pill on a phone.
        theme: 'pill',
        borderWidth: '0',
        // Slides fully off-screen on scroll-condense (see the
        // html[data-nav-condensed] rule in workspace/app.js) — transform-only,
        // so this is the one property that needs a transition; gated to this
        // breakpoint so desktop never pays for (or shows) a transform it never
        // sets. prefers-reduced-motion collapses this to an instant swap via the
        // existing global reduced-motion floor in app.js — no separate handling
        // needed here.
        transition: '240ms defaultBezier transform'
    },
    // Publish the LIVE left/right island widths as CSS vars on the header node.
    // The centered pill family (HeaderTabs / HeaderSearch) clamps its max-width
    // against them, so dead-centering — the design contract — can never slide
    // the pill under the islands when the header narrows: small screens, the
    // docked-assistant inset (the shell CSS shrinks this header by
    // --assistant-width), or a workspace navbar with many module tabs
    // (2026-07-27 per Nika "navbar looks jammed … add margin on middle section
    // so it does not stick"). Same measured-var pattern as the shell's
    // --shell-top / --prompt-clear ResizeObservers (workspace/app.js) — the
    // framework has no container queries, and pure CSS cannot express
    // "centered but clear of two variable-width siblings".
    onCreate: (el)=>{
        // One document-level scroll-condense arm for the mobile deck (see
        // packages/shared/functions/navCondense.js) — idempotent, so mounting
        // AppHeader more than once in a session (a route remount) never attaches
        // a second listener. The phone-width query travels as an argument from
        // this element's own `scope:` (baked to a literal string at
        // serialization time) — navCondense.js must not import the brand
        // designSystem itself, see its header comment.
        el.call('armNavCondense', el.scope.MOBILE_HEADER_SEARCH_QUERY);
        if (typeof window === 'undefined' || typeof ResizeObserver === 'undefined') return;
        if (el._islandRo) return;
        const publish = ()=>{
            const node = el.node;
            if (!node) return;
            const left = node.querySelector(':scope > [data-key="HeaderLeft"]');
            const right = node.querySelector(':scope > [data-key="HeaderRight"]');
            const w = (n)=>Math.ceil(n?.getBoundingClientRect?.().width || 0) + 'px';
            node.style.setProperty('--hdr-left-w', w(left));
            node.style.setProperty('--hdr-right-w', w(right));
            // Publish the tablet rail width to the shell root so page-owned floating
            // rails (TicketsSidebar, Studio AppSidebar, etc.) can reserve the same
            // measured lane instead of trying to solve overlap with z-index.
            // Vertical rail mode RETIRED (iPad, 2026-08-01 per Nika "fix navbar
            // consistency" — twice): the left island stays a horizontal pill at
            // every width, one island family. The measured --hdr-left-w above keeps
            // the tabs lane clear of it; page-owned floating rails fall back to
            // their base (non-lane) positioning now that the attr is never set.
            const doc = document.documentElement;
            delete doc.dataset.headerLeftRail;
            doc.style.removeProperty('--header-left-rail-w');
            el.scope.syncHeaderTabsTabletLayout(node);
        };
        const ro = new ResizeObserver(publish);
        const observe = ()=>{
            const node = el.node;
            if (!node) return;
            ro.observe(node);
            const left = node.querySelector(':scope > [data-key="HeaderLeft"]');
            const right = node.querySelector(':scope > [data-key="HeaderRight"]');
            if (left) ro.observe(left);
            if (right) ro.observe(right);
            publish();
        };
        el._islandRo = ro;
        // Children mount after the header's own create — defer one frame so the
        // island nodes exist before the first observe/publish.
        window.requestAnimationFrame?.(observe) || setTimeout(observe, 0);
    },
    onRemove: (el)=>{
        el._islandRo?.disconnect?.();
        el._islandRo = null;
        if (typeof document !== 'undefined') {
            delete document.documentElement.dataset.headerLeftRail;
            document.documentElement.style.removeProperty('--header-left-rail-w');
        }
    },
    // Auth-page hiding is owned by the shell mount (workspace/app.js AppHeader.hide
    // → AUTH_PATHS), the single source of truth. This component used to carry its
    // OWN narrow hide (/login + /signin only) which, taking precedence over the
    // shell's broader gate, let the header flash on /signup, /reset-password,
    // /verify-email, etc. Removed so the shell's full AUTH_PATHS set governs.
    // Left glass island — Logo + chrome action icons grouped into ONE
    // canvas-card-glass navbar so the header reads as themed islands like the
    // other navbars (2026-06-08 per Nika: "put Logo and HeaderActions in a
    // navbar that unifies it; theme canvas-card-glass as other navbars").
    HeaderLeft: {
        extends: 'IconNavbar',
        // Plain `<div>`, not IconNavbar's default `<aside>`: this island is a
        // visual control cluster INSIDE the banner, not complementary page
        // content. Two unlabeled `<aside>`s (this + HeaderRight) exposed two
        // identical `complementary` landmarks — axe `landmark-unique`
        // (MARKETPLACE-AUDIT residue, tickets/fable.md 2026-08-09). Landmarks
        // are for top-level page regions; chrome sub-groups stay generic.
        tag: 'div',
        // UI-PROJECT-SWITCHER-GROUND-1 (Nika 2026-08-18, verbatim: "removes gray
        // background from project switcher and keeps it consistant so no empty
        // black right area"): NO glass on this island. The org/project switcher's
        // "grey chip" WAS this island's canvas-card-glass fill (measured live:
        // rgba(4,4,4,.85) dark / rgba(255,255,255,.95) light) — the buttons
        // themselves are `tertiary` = transparent at rest. The AppHeader bar is
        // transparent by design, so with the island fill gone the whole strip
        // resolves to the ONE page ground (the stage) — no chip, no gap, and no
        // second painted ground to drift at the next theme change. Hover/active
        // washes on the controls stay. Applied to BOTH desktop islands (stripping
        // one just moves the seam); the @mobileL merged deck keeps its glass (the
        // condensed header's legibility layer — mobile is already ONE surface).
        // `theme: null` — not merely dropping the glass: the IconNavbar base this
        // island extends carries `theme: 'navbar'` (gray1.9+6 dark — measured
        // rgba(10,10,10,.9) live after the first cut), so an absent theme falls
        // back to a THIRD ground. Null clears the inherited theme outright.
        // ⚠️ REVERSED 2026-08-18 (Nika: "only on islands"): the black lives HERE
        // now, not on the container. `navbar` is the token the IconNavbar base
        // already carried — restoring it, NOT the canvas-card-glass that was the
        // grey chip Nika removed in UI-PROJECT-SWITCHER-GROUND-1. Glass stays off.
        // THE PILL (2026-09-26, the two skins — HOME_AMBIENT_SKIN_SPEC §1,
        // DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1): every bar of the
        // header row carries the brand `pill` theme. In the solid skin it IS the
        // `navbar` recipe (pillSolid under a 35px blur); the ambient skin rewrites
        // it to the card glass at the root. Its own name because menus and
        // toolbars also carry `navbar`, and those stay opaque in both skins.
        theme: 'pill',
        // No border (match the search pill), and grow to the search's height. The
        // search is position:absolute (out of the flex flow), so the islands can't
        // auto-stretch to it — pin minHeight to the search height (~38.5px). rem
        // (root = 17px) keeps it scope-independent, like the search's fontSize.
        borderWidth: '0',
        // Pin the compact em context so mounting or updating UnreadBadge cannot
        // make this island inherit the larger application font size.
        fontSize: '0.735rem',
        minHeight: $7f81ae690d561802$export$2e833cc8508b73ce,
        maxHeight: '20rem',
        // THE CAPSULE NEVER CUTS ITS CONTENT (overflow law §3b.1 — a plate clips
        // for its radius only, and this pill's background is rounded by its own
        // border-radius). A clip here cut the top of the bell's unread badge
        // ("21", Nika 2026-09-28) — the badge floats off the bell's corner, the
        // house placement it shares with the chat icon's. Nothing else needs it:
        // the compact phone state hides the actions itself, and the dropdowns
        // render in the shell-root layer, not inside this island.
        overflow: 'visible',
        subscribeTo: [
            '_canvasSlot',
            '_canvasSlotSecond'
        ],
        // ON A RAIL (the root's note — attribute rules, never cases: this island's
        // compact writer clears its inline layout on every update): the head of
        // the one column — the logo, the rail's toggle, the actions. Narrow, they
        // stack; wide (expanded), the logo and the toggle share the first row and
        // the actions run under them.
        'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
        '&[data-nav-rail]': {
            background: 'transparent',
            backdropFilter: 'none',
            gap: 'Z',
            padding: 'Z',
            paddingBottom: '0',
            maxHeight: 'none',
            round: '0',
            fontSize: 'inherit',
            flexShrink: '0',
            // IN FLOW (the note on HeaderRight's own rail block): a row's sticky
            // recipe buys nothing in a column and costs a layer over the tab list.
            position: 'relative'
        },
        '&[data-nav-rail="narrow"]': {
            flexDirection: 'column'
        },
        '&[data-nav-rail="wide"]': {
            flexWrap: 'wrap',
            justifyContent: 'space-between'
        },
        onCreate: (el, s)=>{
            el.scope.syncHeaderLeftCompactLayout(el, s);
            el.scope.watchMediaQueries(el, '_headerLeftMedia', [
                el.scope.MOBILE_HEADER_SEARCH_QUERY
            ], ()=>el.scope.syncHeaderLeftCompactLayout(el, s));
        },
        onUpdate: (el, s)=>el.scope.syncHeaderLeftCompactLayout(el, s),
        onRemove: (el)=>{
            el.scope.clearHeaderLeftCompactStyle(el?.node);
            if (typeof document !== 'undefined') delete document.documentElement.dataset.headerLeftCompact;
            el.scope.unwatchMediaQueries(el, '_headerLeftMedia');
        },
        // Slightly roomier horizontal padding (2026-06-09 per Nika "increase
        // padding x in HeaderLeft") — keep IconNavbar's vertical 'V', bump the
        // horizontal 'Z' → 'Z1' so the icon row has more side breathing room.
        padding: 'V Z1',
        // Tablet: stay a HORIZONTAL pill — the vertical-rail mode is retired
        // (iPad, 2026-08-01 per Nika "fix navbar consistency" — the rail read as
        // a different system next to the horizontal pill family). Compact the
        // paddings/gaps like mobile so the island cedes lane width to the tabs
        // pill, whose measured-var clamp + overflow chevron own the tight-lane
        // problem.
        //
        // tabletSOnly (not tabletS): this block's `padding` disagrees with
        // '@mobileL' below on the SAME property, and a bare max-width tabletS
        // (≤1024px) still matches at 390px too — the atomic CSS engine's global
        // class-insertion order, not source order, would then decide the winner
        // (verified live: it does NOT reliably favor the narrower breakpoint).
        // tabletSOnly (1024–769px) never overlaps '@mobileL' (≤768px), so this
        // can never win a tie it shouldn't. See designSystem/media.js.
        '@tabletSOnly': {
            padding: 'V Z',
            gap: 'Z'
        },
        // "One deck" leading zone (2026-08-02) — the shared glass now lives on
        // the AppHeader root, so this island goes transparent; overflow must
        // open up too, or the AppOrgSwitcher mount's own tapSlop ':after' (below)
        // gets clipped at this box's edge instead of growing past it.
        '@mobileL': {
            background: 'transparent',
            backdropFilter: 'none',
            boxShadow: 'none',
            padding: '0',
            minHeight: '0',
            maxHeight: 'none',
            overflow: 'visible',
            flex: '0 0 auto',
            // Release the `fontSize: '0.735rem'` pin above, for the same reason the
            // root's minHeight moved off rem: at the phone's 13px root that pin
            // computes 9.55px, and it is what made the org-switcher label measure
            // 9.28px on a 390px screen (2026-09-04 per Nika "navbars and text are
            // too small"). The pin exists to stop UnreadBadge inflating this
            // island's em context — a token does that job just as well, and this
            // one tracks the deck instead of a root that is not there.
            fontSize: 'Z'
        },
        Logo: {
            extends: 'Link',
            'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
            '&[data-nav-rail]': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'controlHCompact',
                height: 'controlHCompact',
                minWidth: 'controlHCompact',
                minHeight: 'controlHCompact',
                padding: '0',
                boxSizing: 'border-box',
                '@coarse': {
                    width: 'controlH',
                    height: 'controlH',
                    minWidth: 'controlH',
                    minHeight: 'controlH'
                }
            },
            href: '/',
            aria: {
                label: (el)=>el.call('polyglot', 'shell.header.logo.ariaLabel')
            },
            cursor: 'pointer',
            color: 'title',
            padding: 'Y',
            align: 'center center',
            // A finger's target — the 44pt FLOOR (_touchTarget.js): the home logo
            // measured 18 x 18 at 834px and 21 x 21 at 1032+ (dev DFI, touch
            // simulated, DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1).
            '@coarse': {
                position: 'relative',
                ...(0, $9GdJK.touchFloor)
            },
            // Hidden in the merged mobile deck — redundant with the leading-zone
            // switcher below AND with HeaderTabs' MobileTabs label strip, whose
            // FIRST entry is the same home destination this logo links to.
            '@mobileL': {
                display: 'none'
            },
            // `extends: 'Icon'` so the glyph actually renders — a bare `icon` prop
            // on a plain div drew an empty box (the old Logo was hide-gated for
            // members, so this path never drew the logo before the flatten).
            LogoIcon: {
                extends: 'Icon',
                name: 'logov2',
                // Header icon size, tuned live with Nika (2026-06-09): settled on the
                // base 'A' (≈1em ≈12.5px in the header's compact font context). Kept
                // explicit so every HeaderLeft glyph stays in lockstep.
                boxSize: 'A A',
                aspectRatio: '1 / 1'
            }
        },
        // THE RAIL'S TOGGLE (functions/navbarLayout.js navbarRailToggle; Nika
        // 2026-10-24: "left and right sidebars can be toggle expandable"): the
        // names beside the glyphs, or the glyphs alone — on a rail only. The glyph
        // is a window with its column on the rail's own side.
        NavRailToggle: {
            extends: [
                'CompactIconButton',
                'NavbarTooltipTrigger'
            ],
            hide: (el, s)=>!(el.call('navbarLayoutRead', s.root) || {}).rail,
            color: 'title',
            title: (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).expanded ? el.call('polyglot', 'shell.navbar.collapse') : el.call('polyglot', 'shell.navbar.expand'),
            'aria-label': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).expanded ? el.call('polyglot', 'shell.navbar.collapse') : el.call('polyglot', 'shell.navbar.expand'),
            'aria-expanded': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).expanded ? 'true' : 'false',
            Icon: {
                name: (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).position === 'right' ? 'lnSidebarRight' : 'lnSidebarLeft',
                boxSize: 'A A'
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('navbarRailToggle');
            }
        },
        // Keep the primary destinations directly below the rail toggle, in
        // DOM order as well as visual order. Their bar/phone mounts stay hidden
        // here; every mount reuses the same action and focus behavior.
        HeaderHomeBtn: {
            hide: (el, s)=>!(el.call('navbarLayoutRead', s.root) || {}).rail
        },
        SearchBtn: {
            hide: (el, s)=>!(el.call('navbarLayoutRead', s.root) || {}).rail
        },
        // Left action cluster — the chrome icons grouped in ONE flat flex, right
        // after the logo (2026-06-08 per Nika: "icons to left, org switcher to
        // the right"). Membership-gated items keep their own hide gates.
        HeaderActions: {
            // Rail actions form one column; expanded rows add the localized name
            // beside each glyph, below the logo and collapse control.
            'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
            // Separate communication from Home/Search and the app list, using
            // equal insets on both sides of each boundary.
            '&[data-nav-rail]': {
                borderTop: 'hairline solid line',
                borderBottom: 'hairline solid line',
                paddingTop: 'Z',
                paddingBottom: 'Z'
            },
            '&[data-nav-rail="narrow"]': {
                flexDirection: 'column',
                gap: 'Z'
            },
            '&[data-nav-rail="wide"]': {
                flexBasis: '100%',
                width: '100%',
                flexDirection: 'column',
                alignItems: 'stretch',
                gap: 'Z'
            },
            flow: 'x',
            align: 'center',
            gap: 'A',
            // Theme-aware chrome icons. `childProps` pushes the color onto each
            // button so it wins over their own color, and the icons inherit it via
            // `fill: currentColor`.
            color: 'title',
            childProps: {
                color: 'title'
            },
            maxHeight: '20rem',
            // Hidden in the merged mobile deck (2026-08-02) — four action icons +
            // the leading switcher + the center nav strip + search + avatar do not
            // fit one compact ~44px row on a 390px phone without recreating the
            // exact overlap/jam this redesign exists to fix. See the ship report:
            // this is a deliberate, flagged scope cut, not an oversight.
            '@mobileL': {
                display: 'none'
            },
            // (TicketsButton removed 2026-06-09 per Nika — the Tickets canvas tab in
            // the centered HeaderTabs bar covers this jump now.)
            Messenger: {
                extends: [
                    'Messenger',
                    'NavbarRailControl'
                ],
                hide: (el)=>!(0, $2zkc2.checkActiveMember)(el),
                // The tooltip plugin reads this at SHOW time: nothing to show while
                // the chat drawer is open, so "Direct messages" never paints over the
                // Chats panel it just opened (live on dev 2026-09-26 — the bell's
                // fix, the same contract; DESIGN_SPEC §5 Tooltip).
                tooltipText: (el, s)=>s.root?._chatDrawerOpen || (el.call('navbarLayoutRead', s.root) || {}).expanded ? '' : el.call('polyglot', 'shell.messenger.tooltip'),
                // Match the HeaderLeft icon size (kept in lockstep, 2026-06-09).
                // Active (drawer-open) highlight is rendered by IconButton, which
                // honors the `active:` prop Messenger declares (2026-06-14).
                Icon: {
                    boxSize: 'A A'
                }
            },
            // Mail — the built-in email client (/mail), sitting between the
            // messenger and the call button so the three "reach a person" chrome
            // icons read as one group. Dark by default: the `mail` feature flag
            // ships `defaultOn: false` (functions/featureFlagsData.js), so this
            // button stays hidden until an admin turns Mail on at /flags.
            //
            // The gate is `navItemVisible(root, '/mail')`, the same route→flag
            // resolver every navigation surface uses (ROUTE_FLAGS maps '/mail' →
            // 'mail'), never a hand-rolled flag read — one resolver, no drift.
            // `subscribeTo` is required, not decorative: a root-state read inside
            // a factory does NOT auto-subscribe the element, so without it the
            // flag flip at /flags would not re-run this `hide` until a reload
            // (same pair AppNavbar and CanvasViewNav subscribe to).
            Mail: {
                // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
                extends: [
                    'IconButton',
                    'NavbarRailControl'
                ],
                subscribeTo: [
                    '_featureFlags',
                    'workspace',
                    '_mailDrawerOpen'
                ],
                hide: (el, s)=>{
                    if (!(0, $2zkc2.checkActiveMember)(el)) return true;
                    return !(0, $4SiPM.navItemVisible)(s && s.root, '/mail');
                },
                title: (el)=>el.call('polyglot', 'shell.header.mail.tooltip'),
                // Nothing to show while its drawer is open (same contract as the
                // bell and the messenger).
                tooltipText: (el, s)=>s.root?._mailDrawerOpen || (el.call('navbarLayoutRead', s.root) || {}).expanded ? '' : el.call('polyglot', 'shell.header.mail.tooltip'),
                aria: {
                    label: (el)=>el.call('polyglot', 'shell.header.mail.tooltip')
                },
                // Open-state highlight while the mail drawer is open — the Messenger
                // button's contract (Messenger.js + _activeHighlight.js): the class
                // factory reads the signal itself so it stays reactive.
                ...(0, $hg33k.activeHighlight),
                class: {
                    isActive: (el, s)=>!!(s && s.root && s.root._mailDrawerOpen)
                },
                active: (el, s)=>!!(s && s.root && s.root._mailDrawerOpen),
                // `name` (not `icon`) — required, not stylistic. See the NewCall
                // comment below and components/headerIconGate.test.js: IconText's
                // `Icon.if` gate never reads the child's own `el.icon`, so an
                // `icon:` key here renders an EMPTY button.
                Icon: {
                    name: 'email',
                    boxSize: 'A A'
                },
                // 2026-09-05 per Nika "mail should open sidebar just like chats": the
                // button toggles the MailOverlay — the same left glass float the
                // Messenger opens — never the /mail page. Same choreography as
                // Messenger.js: fold the lazily-bundled mail context FIRST (so the
                // shell's MailOverlaySlot can mount), then flip the overlay key through
                // headerOverlayPatch so the other header overlays close. When the mail
                // package is not registered (an older shell, a test root), fall back
                // to the /mail page in the PageSlot rather than a dead click.
                onClick: async (e, el, s)=>{
                    e.stopPropagation();
                    const root = s && s.root;
                    const fns = el && el.context && el.context.functions;
                    if (!root || !fns || typeof fns.ensureMailContext !== 'function') {
                        el.call('openAppPage', '/mail', {
                            preferSlot: true,
                            split: e.metaKey || e.ctrlKey
                        });
                        return;
                    }
                    const opening = !root._mailDrawerOpen;
                    if (opening) {
                        const okFold = await el.call('ensureMailContext');
                        if (okFold === false) return;
                        if (root.notificationsPanelOpen) el.call('closeDropdown');
                    }
                    root.update((0, $kvDhE.headerOverlayPatch)('mail', opening));
                }
            },
            // Start a call from anywhere (2026-06-12 per Nika "add call icon in
            // top left navbar") — opens the meet New-call modal; the modal's
            // Start routes to /meet and joins. Hidden where the meet functions
            // aren't registered (no-backend apps) or for non-members.
            NewCall: {
                // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
                extends: [
                    'IconButton',
                    'NavbarRailControl'
                ],
                hide: (el)=>{
                    if (!(0, $2zkc2.checkActiveMember)(el)) return true;
                    return typeof el?.context?.functions?.openNewRoomModal !== 'function';
                },
                title: (el)=>el.call('polyglot', 'shell.header.newCall.tooltip'),
                aria: {
                    label: (el)=>el.call('polyglot', 'shell.header.newCall.tooltip')
                },
                // `name` (not `icon`) — required, not stylistic. IconText.Icon.if
                // (smbls default-config components/Icon/index.js) never reads the
                // child's own `el.icon`, only `el.name` (or `parent.icon`), so this
                // rendered an empty button after smbls `2e4ba032e` removed the
                // SquareButton `icon:'smile'` placeholder that had been masking the
                // wrong key (tickets/opus.md P1, 2026-08-09). Same shape as
                // HomeBtn/SearchBtn/ArrowBtn (HeaderTabs.js).
                Icon: {
                    name: 'video',
                    boxSize: 'A A'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('openNewRoomModal');
                }
            },
            NotificationWrapper: {
                hide: (el)=>!(0, $2zkc2.checkActiveMember)(el),
                position: 'relative',
                color: 'title',
                // NotificationBell sets its own muted color, so the group's title
                // doesn't reach it via inheritance — pin it explicitly. Icon bumped
                // to match the HeaderLeft icon size (kept in lockstep, 2026-06-09).
                // Active (panel-open) highlight is rendered by IconButton via the
                // `active:` prop NotificationBell declares (2026-06-14).
                NotificationBell: {
                    extends: [
                        'NotificationBell',
                        'NavbarRailControl'
                    ],
                    '&[data-nav-rail="wide"] > [data-key="UnreadBadge"]': {
                        position: 'static',
                        marginLeft: 'auto',
                        order: '2',
                        flexShrink: '0'
                    },
                    color: 'title',
                    tooltipText: (el, s)=>s.root?.notificationsPanelOpen || (el.call('navbarLayoutRead', s.root) || {}).expanded ? '' : el.call('polyglot', 'shell.notificationBell.tooltip'),
                    Icon: {
                        boxSize: 'A A'
                    }
                }
            }
        },
        // Leading-zone identity affordance — "one deck" @mobileL merge
        // (2026-08-02 per Nika): "the workspace/identity affordance (the
        // existing switcher entry point, compacted)". A SECOND AppOrgSwitcher
        // mount, not a relocation of HeaderRight's — its Trigger anchors the
        // dropdown to itself (`anchorEl: el`), so a second instance is safe and
        // self-contained; _prefetchOrgWorkspaces' module-level in-flight guard
        // makes the doubled onCreate poll a harmless no-op. Desktop untouched
        // (hidden there); on mobile it replaces Logo/HeaderActions above — Home
        // is still one tap away as MobileTabs' leading entry (HeaderTabs.js), so
        // nothing here is a lost destination.
        //
        // NOTE for the demo-lockdown reader: app.js neutralizes THIS instance
        // too (mirroring the HeaderRight.AppOrgSwitcher override there) — see
        // the matching `HeaderLeft: { AppOrgSwitcher: {...} }` block in
        // workspace/app.js's AppHeader mount.
        AppOrgSwitcher: {
            display: 'none',
            '@mobileL': {
                display: 'flex'
            },
            Trigger: {
                padding: 'Y1 Z1',
                // Coarse tap-slop — Trigger extends brand `Button`, which (unlike
                // NavbarButton/IconButton) carries none of its own.
                '@coarse': {
                    position: 'relative',
                    ':after': {
                        content: '""',
                        position: 'absolute',
                        inset: 'tapSlop'
                    }
                },
                Label: {
                    // Tightened 2026-08-02 (from 'F') per the same "give the strip the
                    // center it was designed to own" pass that moved Search out of
                    // HeaderTabs — the org name only needs to be RECOGNIZABLE, not
                    // fully spelled out, and every px it claims here is a px the
                    // MobileTabs label strip doesn't get (HeaderTabs is flex:1, so it
                    // absorbs whatever the leading/trailing zones don't).
                    //
                    // …but B1 overshot: it clipped "Natali" to a bare "N…", and a
                    // workspace switcher that cannot name its workspace has lost the
                    // one job the leading zone exists for (measured live at 390px).
                    // C1 recognizes a typical name while still yielding most of what
                    // the 'F' original was hoarding.
                    maxWidth: 'C1',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    // The overflow law (HOME_AMBIENT_SKIN_SPEC §3b rule 8): a name cut
                    // to fit a phone header names itself in full on hover.
                    title: (el, s)=>el.scope.activeOrg(s.root)?.name || el.call('polyglot', 'shell.orgSwitcher.orgLabel')
                }
            }
        }
    },
    // Centered search pill — same chrome + footprint (width H3) as the
    // bottom CanvasPromptTextarea (per Nika). Absolute + translate keeps it
    // dead-centered regardless of the left/right cluster widths; the
    // canvas-card-glass theme and no border make search and prompt read as
    // one family of AI-adjacent inputs.
    //
    // FOCUS IS THE GLOBAL RING (brief §4.3, 2026-09-24). The pill used to paint
    // its own blue two-ring glow plus a lift shadow on `:focus-within`; a
    // component never re-implements focus. The input inside is the focusable
    // control and fills the pill (radiusPill, 1px short of each edge), so the
    // brand reset's `input:focus-visible` ring (shadow token `focusRing`,
    // specificity 0,1,1) lands on the pill's own outline — the input's base
    // `boxShadow: 'none'` is a single class (0,1,0) and never outranks it
    // (measured on the served stylesheet). The pill FLOATS over live content,
    // so it keeps the `float` level its theme already paints at rest; focus
    // is a state, not a new elevation, so nothing lifts.
    HeaderSearch: {
        // Morphs in/out (crossfade + subtle scale) with HeaderTabs instead of an
        // instant hide (2026-06-14 per Nika "add morphing animation when search is
        // clicked"). Driven by the reactive `.isSearchOpen` class — a reactive
        // opacity/transform factory freezes in v3.14, whereas the class toggles
        // reliably and CSS transitions its static values. Closed = faded + scaled
        // down + non-interactive (kept in the DOM so the transition can run).
        isSearchOpen: (el, s)=>!!s.root?._headerSearchOpen,
        // `_slotSplitIntent` too: its arrival while the search is open re-focuses
        // the input (focusSearchOnOpen), and onUpdate must run to see it.
        subscribeTo: [
            '_headerSearchOpen',
            '_slotSplitIntent',
            // the navbar's place: the tablet writer re-runs, and stands aside off the top
            '_homeLook',
            'userPrefs',
            '_isPhoneViewport'
        ],
        // ON A RAIL (the root's note — an attribute rule: the tablet writer
        // clears this pill's inline top / left / width on every update) the pill
        // opens at the top centre of the screen — a rail column is too narrow to
        // hold it, and the strip it would cover stays usable. Fixed, so the rail's
        // rounded clip never cuts it. That holds only while no ancestor is a
        // containing block for a fixed box, so the column paints its glass on a
        // `:before` (the root's rail rule, locked by
        // __tests__/navbarSearchOpensOnEveryNavbar.test.js). Its four transforms
        // read variables (base, `.isSearchOpen`, both tablet blocks below — each
        // falls back to its own value as before), so this rule moves the pill
        // without writing the key the inline `.isSearchOpen` writes.
        'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
        '&[data-nav-rail]': {
            position: 'fixed',
            top: 'Z1',
            left: '50%',
            right: 'auto',
            width: 'H3',
            maxWidth: 'calc(100vw - 2 * var(--spacing-C))',
            '--hs-closed': 'translateX(-50%) scale(0.96)',
            '--hs-open': 'translateX(-50%) scale(1)',
            '--hs-closed-tab': 'translateX(-50%) scale(0.96)',
            '--hs-open-tab': 'translateX(-50%) scale(1)'
        },
        scope: {
            // A11Y-1 (2026-08-15): focus-on-open + focus-restore-on-close for the
            // search morph. Same edge-detected-transition / bounded-poll / return-
            // focus idiom as ContextDropdown.js's `focusMenuOnOpen` (Modal.js and
            // AppDialog's open/close focus-lifecycle ship the same `_wasOpen`
            // shape) — NOT requestAnimationFrame, same reasoning as there: Chrome
            // throttles rAF in backgrounded/automated tabs, and this element is
            // still `opacity:0`/mid-220ms-transition on the frame `.isSearchOpen`
            // first flips, so a single rAF tick can still measure a pre-layout
            // 0×0 box. The bounded poll instead waits for a real
            // offsetWidth/offsetHeight before focusing.
            //
            // Closing (Escape, the X button, the search button's second press, or
            // a press outside — closeSearchOnOutsidePress below) runs through ONE
            // state flip whichever path fired: HeaderSearch.js's Input.onKeydown
            // Escape handler and ClearSearchMorph set `_headerSearchOpen: false`,
            // and the other two reach the same writes through the shared
            // `closeHeaderSearch` — so restoring focus HERE, on the false-edge,
            // covers every dismiss path without duplicating the restore call at
            // each one. `__headerSearchReturnFocusTo` is stashed on root by
            // SearchBtn's own handler (HeaderTabs.js) — NOT `document.activeElement`
            // captured here, because that handler calls `e.preventDefault()`, so
            // the button never actually receives default browser focus to read
            // back. An outside press clears it first: focus follows that press.
            // Where focus returns when a ⌘K-opened search closes and nothing held
            // focus before it (HeaderSearch.onDocumentKeydown asks): the visible
            // SearchBtn that owns this pill — the HeaderTabs copy on desktop and
            // tablet, the HeaderRight copy on a phone.
            // THE OPEN SEARCH KEEPS THE KEYBOARD (ledger WH-5 — sam, keyboard only:
            // with Ctrl+K open, Tab left the panel for the hidden buttons of the bar
            // behind it, and the first result tile took ~21 presses). Between the
            // input and the Close X the browser's own order stands; at either edge
            // the keyboard goes to the open launcher (the workspace's
            // focusSearchLauncher: its first row forward, its last row back — the
            // launcher keeps Tab inside itself from there), else the two wrap. The
            // morph's two controls by their DOMQL references, never a node query (a
            // hidden results row must not move an edge). Returns whether it moved
            // focus.
            keepSearchTab (e, el, s) {
                if (!e || e.key !== 'Tab' || e.defaultPrevented) return false;
                if (!(s && s.root && s.root._headerSearchOpen)) return false;
                const own = [
                    el.Form?.Input?.node,
                    el.ClearSearchMorph?.node
                ].filter((n)=>n && typeof n.focus === 'function');
                if (!own.length) return false;
                const first = own[0];
                const last = own[own.length - 1];
                const doc = el.node?.ownerDocument || (typeof document === 'undefined' ? null : document);
                const active = doc && doc.activeElement;
                if (active !== (e.shiftKey ? first : last)) return false;
                e.preventDefault();
                const handed = typeof el?.context?.functions?.focusSearchLauncher === 'function' && !!el.call('focusSearchLauncher', e.shiftKey ? 'last' : 'first');
                if (!handed) (e.shiftKey ? last : first).focus();
                return true;
            },
            searchReturnTarget (el) {
                const header = el && el.parent;
                const candidates = [
                    header?.HeaderLeft?.SearchBtn?.node,
                    header?.HeaderTabs?.SearchBtn?.node,
                    header?.HeaderRight?.SearchBtn?.node
                ];
                return candidates.find((n)=>n && n.offsetParent !== null) || null;
            },
            // A PRESS OUTSIDE THE OPEN SEARCH ENDS IT (`onDocumentMousedown` below
            // — the note there). A press that belongs to the search leaves it
            // open: the pill; the visible search button, whose press toggles (the
            // trigger's own job, as the dropdown plugin leaves its anchor's press
            // to the trigger); the launcher's own panel and any other panel of the
            // dropdown host; the context menu's panel (a launcher tile's or a
            // result row's menu — its row acts on the click that follows); and a
            // dialog, the phone navigation or a phone rail, which own every press
            // while they are up.
            //
            // BY PLACE, NOT BY STATE, for the context menu: it lays a backdrop over
            // the whole screen and shuts on that backdrop's POINTERDOWN, which the
            // browser fires before this mousedown, so its state is gone by now. A
            // press on that backdrop dismisses the menu AND the search: the
            // launcher ends with the menu (focus lands on the page), and a pill
            // left open behind it is the half-closed search N2 removed (measured
            // live on dev 2026-10-28, the launcher tile's menu). A closed host takes
            // no press: the context menu is hidden, the dropdown and dialog hosts
            // are `pointer-events: none` with nothing open in them. All by DOMQL
            // reference and `contains`, never a node query. Returns whether it
            // closed.
            closeSearchOnOutsidePress (ev, el, s) {
                const root = s && s.root;
                const target = ev && ev.target;
                if (!root || !root._headerSearchOpen || !target || !el || !el.node) return false;
                if (el.node.contains(target)) return false;
                const trigger = this.searchReturnTarget(el);
                if (trigger && trigger.contains(target)) return false;
                const layer = typeof el.context?.functions?.shellOverlayOpen === 'function' ? el.call('shellOverlayOpen') : null;
                if ([
                    'modalRoot',
                    'phoneNav',
                    'mobileRail'
                ].includes(layer)) return false;
                const shell = typeof el.getRoot === 'function' ? el.getRoot() : null;
                const owners = [
                    shell?.DropdownRoot,
                    shell?.ContextDropdown?.Menu,
                    shell?.ModalRoot
                ];
                if (owners.some((owner)=>owner?.node && owner.node.contains(target))) return false;
                return !!el.call('closeHeaderSearch', {
                    returnFocusTo: null
                });
            },
            focusSearchOnOpen (el, s) {
                if (typeof window === 'undefined' || !el) return;
                const isOpen = !!s.root?._headerSearchOpen;
                // A split intent that ARRIVES while the search is already open (a
                // pane's split button asks the open search for the next pick) is an
                // open request too: the input takes focus again. The intent's own
                // edge, never a close-then-open of the search to fake an open edge.
                const intent = !!s.root?._slotSplitIntent;
                const intentArrived = isOpen && intent && !el._wasSplitIntent;
                el._wasSplitIntent = intent;
                if (isOpen === el._wasSearchOpen && !intentArrived) return;
                el._wasSearchOpen = isOpen;
                if (!isOpen) {
                    const returnTo = s.root?.__headerSearchReturnFocusTo;
                    if (returnTo && typeof returnTo.focus === 'function') returnTo.focus();
                    if (s.root) s.root.__headerSearchReturnFocusTo = null;
                    return;
                }
                el.__searchFocusGen = (el.__searchFocusGen || 0) + 1;
                const gen = el.__searchFocusGen;
                let ticks = 0;
                const tick = ()=>{
                    if (gen !== el.__searchFocusGen || !el.node) return;
                    if (el.node.offsetWidth > 0 && el.node.offsetHeight > 0) {
                        const input = el.Form?.Input?.node;
                        if (input && typeof input.focus === 'function') input.focus();
                        return;
                    }
                    if (++ticks < 10) window.setTimeout(tick, 20);
                };
                tick();
            }
        },
        opacity: '0',
        pointerEvents: 'none',
        // CLOSED IS GONE FOR THE KEYBOARD AND THE SCREEN READER TOO (ledger WH-5:
        // the opacity-hidden input and "Close search" were Tab stops on every
        // page). The morph leaves the accessibility tree and its two controls the
        // Tab order (their own `tabindex` below) — not `inert` / `visibility:
        // hidden`: the phone's SearchBtn focuses the input INSIDE its tap (iOS
        // raises the keyboard for nothing else) right after it writes
        // `_headerSearchOpen`, and a reactive attribute lands one microtask later,
        // so an inert input would refuse that focus. tabindex -1 keeps script
        // focus, and both attributes are gone before the task ends.
        ariaHidden: (el, s)=>s.root?._headerSearchOpen ? null : 'true',
        onKeydown: (e, el, s)=>el.scope.keepSearchTab(e, el, s),
        // AN OUTSIDE PRESS ENDS THE SEARCH, ON EVERY NAVBAR (N2, Nika 2026-10-27).
        // The focus note above always named this close, and it never existed:
        // the field's blur (HeaderSearch.js Input.onBlur) ends only the results
        // and the launcher (`closeNavSearch`), never `_headerSearchOpen`. So a
        // press on the page closed the launcher and left the pill open with
        // focus on <body> — measured live on dev 6d3da4967, on a top bar and on
        // a left rail. The dropdown plugin's own outside-press contract: a
        // capture-phase document mousedown that lets the press through, so the
        // pill and its launcher end on the SAME press and the press still lands
        // where it was aimed (a tab, the composer, a page control). What counts
        // as outside: scope.closeSearchOnOutsidePress. Focus follows the press;
        // Escape, the X and the button's own toggle still hand it back to the
        // button. FA503: declared, so DOMQL registers it once and removes it in
        // dispose().
        onDocumentMousedown: {
            capture: true,
            handler: (ev, el, s)=>el.scope.closeSearchOnOutsidePress(ev, el, s)
        },
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'var(--hs-closed, translate(-50%, -50%) scale(0.96))',
        width: 'H3',
        // Clamp the centered pill so it can never overlap the measured islands
        // (see the header's island-width observer above): the symmetric 2×max()
        // keeps it dead-centered while guaranteeing an --spacing-A clearance on
        // BOTH sides; `width: H3` still caps the natural size. Fallbacks cover
        // the pre-measure frame.
        maxWidth: 'calc(100% - 2 * (max(var(--hdr-left-w), var(--hdr-right-w)) + var(--spacing-A)))',
        minWidth: '0',
        // The em-based H3 width token resolves against the element's font-size,
        // so the search must sit in the SAME font context as the bottom
        // CanvasPromptTextarea (font-size `A` = 18.0625px) to land on the same
        // 725px. The `A` token can't be used here — `--font-size-a` is undefined
        // in the absolute header's DOM scope (font tokens live on the app root) —
        // so pin the equivalent in scope-independent rem: 18.0625 / 17 = 1.0625.
        fontSize: '1.0625rem',
        // ONE ROW, FOUR BARS. The same gauge HeaderLeft/HeaderTabs/HeaderRight
        // read above and below — the search used to size itself purely from its
        // input and rendered 41px against their 38px (measured live at 1920px,
        // 2026-09-20). With the variant's own padding step (HeaderSearch.js) the
        // input is 37.80px, so this gauge is what the row finally measures, and
        // it can never drift from the islands again.
        minHeight: $7f81ae690d561802$export$2e833cc8508b73ce,
        // The header's pill (the skins' `pill` theme — see HeaderLeft): the same
        // surface as the islands and the tab strip in both skins.
        theme: 'pill',
        borderWidth: '0',
        onCreate: (el, s)=>{
            el.scope.syncHeaderSearchResponsiveLayout(el, s);
            el.scope.watchMediaQueries(el, '_headerSearchMedia', [
                el.scope.MOBILE_HEADER_SEARCH_QUERY,
                el.scope.TABLET_HEADER_SEARCH_QUERY
            ], ()=>el.scope.syncHeaderSearchResponsiveLayout(el, s));
            el.scope.focusSearchOnOpen(el, s);
        },
        onUpdate: (el, s)=>{
            el.scope.syncHeaderSearchResponsiveLayout(el, s);
            el.scope.focusSearchOnOpen(el, s);
        },
        onRemove: (el)=>{
            el.scope.clearHeaderSearchResponsiveStyle(el?.node);
            el.scope.unwatchMediaQueries(el, '_headerSearchMedia');
        },
        transition: 'opacity 220ms defaultBezier, transform 220ms defaultBezier',
        '.isSearchOpen': {
            opacity: '1',
            pointerEvents: 'auto',
            // a rail opens the pill beside itself, unshifted (`--hs-open`, the
            // rail block below); the top and the bottom centre it as ever
            transform: 'var(--hs-open, translate(-50%, -50%) scale(1))',
            // The open pill stacks OVER the header islands (HeaderLeft / HeaderRight
            // extend the brand Navbar: sticky, z 9). It used to lift only while its
            // input held focus (the dropdown parent's `:focus-within` z 1000), so
            // an open pill whose input had not taken focus yet — a phone tap, where
            // the focus came from a timer — or had handed it to the launcher sat
            // UNDER them: the org name, the search button and the avatar drawn over
            // "Search across everything…" (measured on dev DFI at 375 / 393 / 440,
            // DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1).
            zIndex: '10',
            '@tabletS': {
                transform: 'var(--hs-open-tab, scale(1))'
            },
            '@mobileL': {
                left: 'A',
                right: 'A',
                width: 'auto',
                maxWidth: 'none',
                // Centred in the phone deck. A shell that pins the open pill under
                // the screen's top edge itself (the workspace phone dock, its
                // `phoneNavigationStyles`) sets `--hs-open-phone: none`. A variable,
                // because the framework emits this block `!important` (the pill also
                // writes its open keys inline), so a shell rule on `transform` itself
                // never wins: measured on dev 2fc624ff0 at 390px, the open pill kept
                // this -50% shift under the dock's `transform: none`, and its top
                // 7.6px sat above the screen.
                transform: 'var(--hs-open-phone, translateY(-50%) scale(1))'
            }
        },
        '@tabletS': {
            // Start inside the measured lane between the left island and
            // HeaderRight. Keep the search's normal width, clamping it to whatever
            // space remains instead of stretching and centering it across the lane.
            left: 'calc(var(--hdr-left-w) + var(--spacing-X2) + var(--spacing-A))',
            right: 'auto',
            top: 'X2',
            width: 'H3',
            maxWidth: 'calc(100% - var(--hdr-left-w) - var(--hdr-right-w) - 2 * (var(--spacing-X2) + var(--spacing-A)))',
            transform: 'var(--hs-closed-tab, scale(0.96))'
        },
        '@mobileL': {
            left: '50%',
            right: 'auto',
            top: '50%',
            // NO scale on a phone (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): the open
            // pill's own transform lands inline and the tablet-lane cleanup above
            // strips inline transform on every update (it must — a phone turning
            // out of the tablet band takes the lane's inline transform with it),
            // and the open state's nested phone block did not re-attach on the
            // live flip: the OPEN phone pill read this closed scale(0.96), centred
            // (measured on dev 60c343516 at 375 / 393 / 440). Unscaled here, the
            // phone morph is the opacity crossfade alone and the open pill is full
            // size whichever path lands.
            transform: 'translate(-50%, -50%)',
            width: 'calc(100dvw - var(--spacing-C))',
            maxWidth: 'calc(100dvw - var(--spacing-C))',
            minWidth: '0'
        },
        Form: {
            '@mobileL': {
                width: '100%',
                minWidth: '0',
                maxWidth: '100%'
            },
            Input: {
                background: 'transparent',
                // out of the Tab order while the morph is closed (WH-5, see above)
                tabindex: (el, s)=>s.root?._headerSearchOpen ? null : '-1',
                '@mobileL': {
                    width: '100%',
                    minWidth: '0',
                    maxWidth: '100%'
                }
            },
            // The ⌘K caps stop a `Y` step before the Close X (it replaces the
            // chevron here): the X's inset `A` plus its `controlHCompact` box.
            // Sizes come from the tokens, so the caps can never slide under the X
            // at any root size.
            Shortcut: {
                right: 'calc(A + controlHCompact + Y)'
            }
        },
        // Hide the decorative apps chevron in the morph; show a clickable X that
        // resets the search back to the tab bar (item 1 per Nika "active Search
        // should have X so it gets back to initial state").
        ArrowDown: {
            hide: true
        },
        // THE house close X (brand CloseButton — F2, one X for every panel).
        ClearSearchMorph: {
            extends: 'CloseButton',
            position: 'absolute',
            right: 'A',
            top: '50%',
            transform: 'translateY(-50%)',
            'aria-label': (el)=>el.call('polyglot', 'shell.headerSearch.close'),
            // out of the Tab order while the morph is closed (WH-5, see above)
            tabindex: (el, s)=>s.root?._headerSearchOpen ? null : '-1',
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const input = el.parent?.node?.querySelector('input');
                if (input) input.value = '';
                try {
                    el.call('closeNavSearch');
                } catch (err) {
                    console.warn('[AppHeader] closeNavSearch unavailable:', err);
                }
                s.root.update({
                    _headerSearchOpen: false,
                    _navSearchOpen: false
                });
            }
        }
    },
    // Segmented canvas-nav — the default centered header element, swapped to
    // HeaderSearch when the search morph opens (2026-06-09 per Nika). The
    // component (HeaderTabs.js) owns its own centered+absolute anchor.
    HeaderTabs: {
        // Crossfades out as HeaderSearch morphs in (opacity only — HeaderTabs owns
        // its own centering transform, so don't clobber it). 2026-06-14 per Nika.
        // Not on a rail: the pill opens at the top of the screen there, clear of
        // the strip, which stays usable.
        isSearchOpen: (el, s)=>!!s.root?._headerSearchOpen && !(el.call('navbarLayoutRead', s.root) || {}).rail,
        // ON A RAIL (the root's note — attribute rules: the tablet writer clears
        // this island's inline left / top / width / transform) the strip is the
        // middle of the one column: in the flow (not the centred pill), the tabs
        // stacked; narrow, centred on the glyphs, wide, as wide as the rail.
        'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
        '&[data-nav-rail]': {
            position: 'relative',
            background: 'transparent',
            backdropFilter: 'none',
            left: 'auto',
            top: 'auto',
            transform: 'none',
            width: 'auto',
            maxWidth: 'none',
            flex: '0 1 auto',
            minHeight: '0',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: 'Z',
            padding: 'Z',
            paddingBottom: '0',
            round: '0'
        },
        '&[data-nav-rail="wide"]': {
            alignItems: 'stretch'
        },
        // Share the sibling islands' height so the three read as one row. Set here
        // rather than inside HeaderTabs.js so all three heights stay derivable from
        // the one HEADER_ISLAND_MIN_HEIGHT above — HeaderTabs.js owns its own
        // centering/anchor, this only pins vertical geometry.
        minHeight: $7f81ae690d561802$export$2e833cc8508b73ce,
        alignItems: 'center',
        opacity: '1',
        pointerEvents: 'auto',
        transition: 'opacity 200ms defaultBezier',
        '.isSearchOpen': {
            opacity: '0',
            pointerEvents: 'none'
        },
        // tabletSOnly (not tabletS): this block's left/right/top/width/maxWidth/
        // transform all disagree with '@mobileL' below on the SAME properties —
        // exactly the live-verified cascade-tie bug (see designSystem/media.js
        // tabletSOnly's own comment): a bare max-width tabletS still matches at
        // 390px, and the atomic engine's global class-insertion order (not which
        // block is "more specific") decided the winner, so HeaderTabs rendered
        // 60px off the right edge of the viewport with the mobileL block
        // silently losing every one of these properties. tabletSOnly (1024–
        // 769px) can never overlap '@mobileL' (≤768px).
        '@tabletSOnly': {
            left: 'calc(var(--hdr-left-w) + var(--spacing-X2) + var(--spacing-A))',
            right: 'auto',
            top: 'X2',
            width: 'fit-content',
            maxWidth: 'calc(100% - var(--hdr-left-w) - var(--hdr-right-w) - 2 * (var(--spacing-X2) + var(--spacing-A)))',
            transform: 'none'
        },
        // "One deck" center zone (2026-08-02) — HeaderTabs stops being an
        // absolutely-centered pill clamped between the islands' measured widths
        // and becomes a normal flex participant sitting BETWEEN HeaderLeft and
        // HeaderRight in the deck's own row (the measured --hdr-left-w/
        // --hdr-right-w clamp above is a tabletSOnly-and-wider concern only — at
        // this breakpoint the deck's own flex layout does the job instead). Its
        // own glass goes transparent: the shared surface now lives on the
        // AppHeader root (see the merge note there). HeaderTabs.js's own
        // '@mobileL' block (gap/padding) still applies underneath this one.
        '@mobileL': {
            position: 'relative',
            left: 'auto',
            right: 'auto',
            top: 'auto',
            transform: 'none',
            flex: '1 1 0%',
            minWidth: '0',
            width: 'auto',
            maxWidth: 'none',
            height: '100%',
            minHeight: '0',
            background: 'transparent',
            backdropFilter: 'none',
            boxShadow: 'none',
            borderWidth: '0'
        }
    },
    // Right glass island — org switcher, presence, and the avatar menu grouped
    // into ONE canvas-card-glass navbar, pushed to the right edge via
    // marginLeft:auto (2026-06-08 per Nika: "same for AppOrgSwitcher and
    // MeWrapper"). marginLeft moved off AppOrgSwitcher onto this wrapper.
    HeaderRight: {
        extends: 'IconNavbar',
        // Plain `<div>` — same landmark-unique reasoning as HeaderLeft above.
        tag: 'div',
        // UI-PROJECT-SWITCHER-GROUND-1 (Nika 2026-08-18, verbatim: "removes gray
        // background from project switcher and keeps it consistant so no empty
        // black right area"): NO glass on this island. The org/project switcher's
        // "grey chip" WAS this island's canvas-card-glass fill (measured live:
        // rgba(4,4,4,.85) dark / rgba(255,255,255,.95) light) — the buttons
        // themselves are `tertiary` = transparent at rest. The AppHeader bar is
        // transparent by design, so with the island fill gone the whole strip
        // resolves to the ONE page ground (the stage) — no chip, no gap, and no
        // second painted ground to drift at the next theme change. Hover/active
        // washes on the controls stay. Applied to BOTH desktop islands (stripping
        // one just moves the seam); the @mobileL merged deck keeps its glass (the
        // condensed header's legibility layer — mobile is already ONE surface).
        // `theme: null` — not merely dropping the glass: the IconNavbar base this
        // island extends carries `theme: 'navbar'` (gray1.9+6 dark — measured
        // rgba(10,10,10,.9) live after the first cut), so an absent theme falls
        // back to a THIRD ground. Null clears the inherited theme outright.
        // ⚠️ REVERSED 2026-08-18 (Nika: "only on islands"): the black lives HERE
        // now, not on the container. `navbar` is the token the IconNavbar base
        // already carried — restoring it, NOT the canvas-card-glass that was the
        // grey chip Nika removed in UI-PROJECT-SWITCHER-GROUND-1. Glass stays off.
        // THE PILL (2026-09-26, the two skins — HOME_AMBIENT_SKIN_SPEC §1,
        // DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1): every bar of the
        // header row carries the brand `pill` theme. In the solid skin it IS the
        // `navbar` recipe (pillSolid under a 35px blur); the ambient skin rewrites
        // it to the card glass at the root. Its own name because menus and
        // toolbars also carry `navbar`, and those stay opaque in both skins.
        theme: 'pill',
        marginLeft: 'auto',
        // Match HeaderLeft: no border + same minHeight as the search pill.
        borderWidth: '0',
        minHeight: $7f81ae690d561802$export$2e833cc8508b73ce,
        // Roomier spacing between the right-cluster items — presence avatars, org
        // switcher, account menu (2026-06-10 per Nika "increase gap between things
        // in orgswitcher navbar").
        gap: 'A',
        // The avatar sits as far from the pill's right edge as from its top and
        // bottom (Nika 2026-09-24, verbatim: "reduce space on avatar navbar at
        // top right so avatar has same space at right as top and bottom").
        // Measured live at 1920px: top 5.11px, bottom 5.11px, right 18.00px —
        // the trailing edge carried the island's horizontal Z (8.76px) where the
        // top carries V (1.28px), plus MeWrapper's own marginRight Y (5.41px).
        // The trailing padding now IS the vertical one (V); the square,
        // centred MeWrapper adds the same slack on every side, so right = top =
        // bottom. The leading edge keeps Z for the org switcher.
        padding: 'V V V Z',
        // tabletMOnly (not tabletM): this block's gap/padding disagree with
        // '@mobileL' below on the SAME properties — the live-verified
        // cascade-tie bug (see designSystem/media.js tabletSOnly's comment for
        // the full mechanism). tabletMOnly (1280–769px) never overlaps
        // '@mobileL' (≤768px).
        '@tabletMOnly': {
            // Compact one step before the vertical-rail breakpoint so the org island
            // and the middle tabs keep a visible gutter around ~1050px.
            gap: 'Z',
            padding: 'V V V Z',
            fontSize: 'Y'
        },
        // the navbar's place: the tablet writer (onUpdate) re-runs, and stands
        // aside off the top (scope.navAtTop)
        subscribeTo: [
            '_homeLook',
            'userPrefs',
            '_isPhoneViewport'
        ],
        // ON A RAIL (the root's note — attribute rules: the tablet writer clears
        // this island's inline padding / min-height / margin) the foot of the one
        // column: the switcher and the account, stacked; wide, the switcher's
        // name runs full width and the avatar keeps to the start (MeWrapper).
        'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
        '&[data-nav-rail]': {
            flexDirection: 'column',
            background: 'transparent',
            backdropFilter: 'none',
            marginLeft: '0',
            marginTop: 'auto',
            minHeight: '0',
            gap: 'Z',
            padding: 'Z',
            round: '0',
            fontSize: 'inherit',
            flexShrink: '0',
            // IN FLOW, never a sticky layer over the destinations
            // (DESIGN-SHELL-RAIL-TRAILING-CLUSTER-COVERS-TABS-1). This island
            // extends the brand Navbar — `position: sticky`, `top: 0`, `z-index: 9`,
            // a ROW's recipe. The rail is a column that does not scroll, so sticky
            // buys nothing here and costs a painted layer over the tab list:
            // `elementFromPoint` on the tail of that list answered `HeaderRight` and
            // its `Icon` at 1194 x 834 (the parent card's live matrix), and a
            // focus() into a tab the lane clips scrolls this `overflow: hidden`
            // rail, which would slide a sticky island down across the tabs. The
            // tabs' own room is the lane's (HeaderTabs.Tabs scrolls what it cannot
            // show); this island only keeps its size and its place at the foot.
            position: 'relative'
        },
        '&[data-nav-rail="wide"]': {
            alignItems: 'stretch'
        },
        onCreate: (el)=>{
            el.scope.syncHeaderRightResponsiveLayout(el);
            el.scope.watchMediaQueries(el, '_headerRightMedia', [
                el.scope.MOBILE_HEADER_SEARCH_QUERY,
                el.scope.TABLET_HEADER_SEARCH_QUERY
            ], ()=>el.scope.syncHeaderRightResponsiveLayout(el));
        },
        onUpdate: (el)=>el.scope.syncHeaderRightResponsiveLayout(el),
        onRemove: (el)=>{
            el.scope.clearHeaderRightResponsiveStyle(el?.node);
            el.scope.unwatchMediaQueries(el, '_headerRightMedia');
        },
        '@mobileL': {
            // Online members and org switcher are hidden here, so avoid rendering a
            // second glass island behind the standalone avatar trigger — the
            // shared surface now lives on the AppHeader root (the "one deck"
            // merge). backdropFilter listed explicitly for completeness alongside
            // background/boxShadow: scope.syncHeaderRightResponsiveLayout already clears
            // it imperatively on every real phone (mobileL implies its `tablet`
            // gate), this static rule just makes the class-level contract match.
            gap: '0',
            padding: '0',
            minHeight: '0',
            maxWidth: 'none',
            background: 'transparent',
            backdropFilter: 'none',
            boxShadow: 'none',
            // Trailing edge, A-line gutter from the viewport edge (never flush) —
            // AppHeader root's own '@mobileL' paddingRight: 'A' already provides
            // it; this island's own padding stays 0 so it doesn't double up.
            flex: '0 0 auto'
        },
        // Presence avatars moved OUT of the header to the fixed bottom-left dock
        // (2026-07-25 per Nika "move this to bottom left corner") — see
        // OnlineMembersDock in workspace/components/OnlineMembers.js, mounted at
        // the shell root in workspace/app.js.
        // Org-name label matched to the tab bar (item 4 per Nika — the org
        // switcher looked smaller). The 'A' token resolves per font-context
        // (~12.5px here vs ~15px in HeaderTabs), so pin a scope-independent rem
        // on BOTH (here + HeaderTab) so they render identically.
        AppOrgSwitcher: {
            order: '2',
            '@mobileL': {
                display: 'none'
            },
            // a narrow rail stacks the switcher over the invite; a wide one keeps
            // them in a row, the invite at the far end (the root's note: attribute
            // rules)
            'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
            '&[data-nav-rail="narrow"]': {
                flexDirection: 'column',
                gap: 'Z'
            },
            '&[data-nav-rail="wide"]': {
                justifyContent: 'space-between'
            },
            Trigger: {
                // a narrow rail has no room for the name: a square with its monogram
                // (Label below), the chevron off
                'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
                '&[data-nav-rail="narrow"]': {
                    minWidth: 'controlHCompact',
                    padding: '0',
                    justifyContent: 'center'
                },
                Icon: {
                    hide: (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode === 'narrow'
                },
                Label: {
                    // the name, or on a narrow rail its monogram (functions/
                    // navbarLayout.js navbarRailLabel — the one rule, which the
                    // workspace shell's own label override calls too)
                    text: (el, s)=>el.call('navbarRailLabel', el.scope.activeOrg(s.root)?.name || el.call('polyglot', 'shell.orgSwitcher.orgLabel'), s.root),
                    'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
                    '&[data-nav-rail="narrow"]': {
                        fontWeight: '700'
                    },
                    fontSize: '0.9rem',
                    // A TABLET HEADER IS FOR THE TABS (DESIGN-SHELL-RESPONSIVE-IOS-
                    // SAFARI-1). The centred tab island is clamped symmetrically to the
                    // WIDER side island (`maxWidth: 100% - 2 × max(left, right)`), so a
                    // long workspace name on this side starved the tabs: on dev DFI
                    // ("Decentralized Fleet Intelligence - Flintelligence", ~330px) the
                    // tabs read "Validators Inci…" at 1032px and 834px while ~200px sat
                    // empty left of them. At ≤1280 the name is cut to `F` with an
                    // ellipsis and names itself in full on hover (the overflow law, as
                    // the phone header's copy above); the switcher menu lists it whole.
                    '@tabletM': {
                        fontSize: '0.78rem',
                        maxWidth: 'F',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    },
                    title: (el, s)=>el.scope.activeOrg(s.root)?.name || el.call('polyglot', 'shell.orgSwitcher.orgLabel')
                }
            }
        },
        // Trailing-zone search — @mobileL "one deck" merge (2026-08-02, revised
        // same day per a live-probe finding: SearchBtn competing with MobileTabs
        // for HeaderTabs' width was capping the label strip at 80px of 212px
        // available). Bare-key auto-extend from the top-level SearchBtn export
        // (HeaderTabs.js) — desktop/tablet keep the OTHER mount, in HeaderTabs
        // (hidden here at those widths); this one is mobile-only, sitting beside
        // the avatar per the brief's own "Trailing zone: search + avatar".
        SearchBtn: {
            display: 'none',
            '@mobileL': {
                display: 'flex',
                order: '50'
            }
        },
        MeWrapper: {
            extends: 'AppControl',
            compact: true,
            tag: 'button',
            type: 'button',
            ariaLabel: (el)=>el.call('polyglot', 'shell.accountMenu.open'),
            ariaHaspopup: 'menu',
            // `controlHCompact`, not `controlH`, and MEASURED: every other control
            // in this trailing group renders 36px, so a 44px avatar wrapper made
            // the whole right-hand bar 47px against 38px for the leading zone and
            // the tab strip — it sat 4px proud at BOTH ends of a 56px header
            // (live, 1920px, 2026-09-20). The tap-target guideline is not lost
            // here: on a coarse pointer the enlarged area comes from the `:after`
            // pseudo below, whose `inset: tapSlop` is what actually receives the
            // finger, and @coarse restores the full `controlH` box as well.
            minWidth: 'controlHCompact',
            minHeight: 'controlHCompact',
            padding: '0',
            // No margin of its own: the trailing air is the pill's trailing padding
            // (HeaderRight, above), equal to its vertical padding (Nika 2026-09-24).
            // The 2026-09-20 `marginRight: 'Y'` stacked 5.41px on top of the
            // island's padding and left the avatar 18px from the edge against 5px
            // above and below. Never a top padding here either — it de-centres the
            // avatar inside this `align: center center` wrapper.
            borderWidth: '0',
            background: 'transparent',
            color: 'title',
            round: 'radiusPill',
            align: 'center center',
            // Keep the avatar last in the flex row regardless of which membership-
            // gated siblings render before it.
            order: '99',
            // The account wrapper occupies its whole touch target. Its avatar
            // is visual content; neither needs a hit area over adjacent controls.
            position: 'relative',
            '@coarse': {
                // The full 44px box comes back for a finger. It lives HERE and not
                // beside the base `minHeight` above because a second `'@coarse'` key
                // in this same object would silently win — last key defined, not
                // merged — and the base would look applied while doing nothing.
                minWidth: 'controlH',
                minHeight: 'controlH',
                position: 'relative',
                ':after': {
                    display: 'none'
                }
            },
            cursor: 'pointer',
            // a wide rail stretches the column's rows; the avatar keeps its square
            // at the start, as the tabs and the switcher's name do (the root's note)
            'data-nav-rail': (el, s)=>(el.call('navbarLayoutRead', s.root) || {}).railMode,
            '&[data-nav-rail="wide"]': {
                width: '100%',
                justifyContent: 'flex-start',
                gap: 'Z',
                padding: '0 Z',
                height: 'controlHCompact',
                round: 'radiusControl'
            },
            ':hover': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            },
            ':focus-visible': {
                shadow: 'focusRingInset'
            },
            AccountLabel: {
                tag: 'span',
                hide: (el, s)=>!(el.call('navbarLayoutRead', s.root) || {}).expanded,
                text: '{{ shell.accountMenu.open | polyglot }}',
                order: '1',
                fontSize: 'A',
                minWidth: '0',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            onClick: (e, el)=>el.call('openAccountMenu', el.lookdown('Me') || el),
            // Avatar trigger — opens the account menu through the shared
            // @symbo.ls/dropdown plugin (migrated 2026-06-10 from the legacy
            // hand-rolled `root.showMeMenu` opacity/pointerEvents overlay; the
            // plugin owns placement, outside-click dismiss and ESC). Menu
            // content is built HERE, in the opener, with `root` captured —
            // content rendered in the dropdown portal doesn't inherit page
            // state reliably (cf. AppOrgSwitcher / team-and-agents
            // dropdown-panel-content-reactivity), so every row acts through
            // the captured `root`, never its own `s.root`.
            Me: {
                extends: 'Avatar',
                avatarType: 'initials',
                boxSize: 'B1',
                cursor: 'pointer',
                position: 'relative',
                // The parent supplies the full touch target.
                '@coarse': {
                    position: 'relative',
                    ':after': {
                        display: 'none'
                    }
                },
                ariaHidden: true,
                // Decorative: the MeWrapper button carries the name
                // (`shell.accountMenu.open`). Without an own `alt` the framework
                // Avatar names the image after its element key, so a Georgian
                // session announced the English word "Me". `''` wins there
                // (`el.alt != null`), and an empty alt is the decorative image.
                alt: '',
                src: (el, s)=>el.call('avatarUrlFor', s.root?.currentUserEmail),
                ':hover': {
                    filter: 'brightness(1.15)'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    // Open the shared house ContextDropdown (the same dropdown the /files
                    // context menu uses) so the account menu reuses its EXACT shape +
                    // styles (MenuPanel / MenuPanelItem). Anchored under the avatar,
                    // right-aligned; the rows + dispatch live in accountMenuItems /
                    // accountMenuAction (shared/functions/accountMenu.js), and the open
                    // itself is `openAccountMenu` there — shared with MeWrapper, which
                    // owns the coarse-pointer tap area (see its comment above).
                    el.call('openAccountMenu', el);
                }
            }
        }
    }
};
const $7f81ae690d561802$export$bb6373a7174a2595 = $7f81ae690d561802$export$9bd256435c34a030;
const $7f81ae690d561802$export$a602c5acb020e155 = {
    extends: 'Link',
    cursor: 'pointer',
    padding: 'X1 A',
    round: 'radiusPill',
    textDecoration: 'none',
    transition: 'all 200ms ease',
    color: 'caption',
    fontSize: 'Z2',
    fontWeight: '500',
    href: (el, s)=>s.href,
    // The rail rows carry bundle KEYS (workspace/components/IntranetAppHeader.js
    // NAV_LINKS). That producer already resolves them, but a second consumer
    // that does not would ship a raw dotted key to the screen, so the render
    // site resolves too — `translate()` is a no-op on an already-resolved string
    // and on a tenant-supplied label alike.
    text: (el, s)=>el.call('polyglot', s.label || ''),
    background: (el, s)=>s.root.currentPath === s.href ? 'blue.2' : 'transparent',
    ':hover': {
        background: 'hover'
    }
};

});
parcelRegister("2zkc2", function(module, exports) {

$parcel$export(module.exports, "checkActiveMember", () => $1dee8393b4ed0caf$export$267f5bde56f910c1);
$parcel$export(module.exports, "isIntranetRoute", () => $1dee8393b4ed0caf$export$771e985219e76a27);

var $9UgmD = parcelRequire("9UgmD");
const $1dee8393b4ed0caf$export$267f5bde56f910c1 = (el)=>{
    const fn = el?.context?.methods?.isActiveMember;
    if (typeof fn !== 'function') return true;
    return !!fn.call(el, el?.state);
};
const $1dee8393b4ed0caf$export$771e985219e76a27 = (s)=>{
    const path = s?.root?.currentPath || s?.root?.route || '/';
    return (0, $9UgmD.INTRANET_PATHS).includes(path);
};

});

parcelRegister("kvDhE", function(module, exports) {

$parcel$export(module.exports, "headerOverlayPatch", () => $eee52cd06700d98a$export$bd8d9830648f5bdc);
// FA204 / frank trap — OVERLAY_STATE_KEYS used to be a bare module-scope
// const, read from inside this exported function's own body: unresolvable
// once this file's exports are individually frank.toJSON'd for platform
// delivery (project_frank_drops_module_local_helpers). Inlined as a local —
// no other export in this file needs it, so no duplication required.
const $eee52cd06700d98a$export$bd8d9830648f5bdc = (activeOverlay, opening, extra = {})=>{
    const OVERLAY_STATE_KEYS = {
        assistant: 'assistantOpen',
        chat: '_chatDrawerOpen',
        mail: '_mailDrawerOpen',
        notifications: 'notificationsPanelOpen'
    };
    const activeKey = OVERLAY_STATE_KEYS[activeOverlay];
    if (!activeKey) return {
        ...extra
    };
    const patch = {
        [activeKey]: opening,
        ...extra
    };
    if (!opening) return patch;
    for (const [overlay, stateKey] of Object.entries(OVERLAY_STATE_KEYS))if (overlay !== activeOverlay) patch[stateKey] = false;
    return patch;
};

});

parcelRegister("hg33k", function(module, exports) {

$parcel$export(module.exports, "activeHighlight", () => $c9064c7ab792dc23$export$57a7d3215d6fc99d);
// Shared active-highlight for header/navbar chrome buttons (Messenger,
// NotificationBell, AppAssistantToggle, …). The house active/selected
// surface — the `selected` wash token + title text (DESIGN_LANGUAGE.md
// §4.3) — matching the AppNavbar active route, the org switcher, and the
// settings rail. (The old near-opaque `overlayStrong` block is retired
// from state duty: it inverted the active state on light shells.)
//
// Spread onto a button AND pair with `class: { isActive: <factory that
// reads the open signal directly> }`. The class factory MUST read the
// reactive source itself (e.g. `s.root._chatDrawerOpen`) — NOT the
// resolved `el.active` prop: a sibling factory reading `el.active`
// doesn't subscribe to the underlying signal, so it freezes at mount
// (verified live 2026-06-14 — that's why honoring `active:` on the brand
// IconButton couldn't work, and the visual lives on each component
// instead, where it owns its own signal and renders wherever it mounts).
const $c9064c7ab792dc23$export$57a7d3215d6fc99d = {
    '.isActive': {
        background: 'selected',
        color: 'title'
    }
};

});

parcelRegister("debL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a15b404a98b47d7$export$2e2bcd8739ae039);
const $9a15b404a98b47d7$var$mobileL = '(max-width: 768px)';
var $9a15b404a98b47d7$export$2e2bcd8739ae039 = {
    // Every 'X<' starts at N.02px, not N. Both sides of a pair are inclusive, so
    // `min-width: N` with `max-width: N` matched BOTH '@X' and '@X<' at exactly
    // N px and the later rule won by sheet order. The values equal the smbls
    // >= 3.14.827 defaults (default-config/default/media.js). They stay explicit
    // here because a library's map fills its consumers key by key: the old
    // `min-width: N` copies overrode the framework default on every consumer
    // (the landing navFlow band 1025-1280 paired with '@tabletM<' needs 1280.02px).
    tv: '(min-width: 2780px)',
    screenL: '(max-width: 1920px)',
    'screenL<': '(min-width: 1920.02px)',
    screenM: '(max-width: 1680px)',
    'screenM<': '(min-width: 1680.02px)',
    screenS: '(max-width: 1440px)',
    'screenS<': '(min-width: 1440.02px)',
    tabletL: '(max-width: 1366px)',
    'tabletL<': '(min-width: 1366.02px)',
    tabletM: '(max-width: 1280px)',
    'tabletM<': '(min-width: 1280.02px)',
    tabletS: '(max-width: 1024px)',
    'tabletS<': '(min-width: 1024.02px)',
    mobileL: $9a15b404a98b47d7$var$mobileL,
    appMobile: '@container app-surface ' + $9a15b404a98b47d7$var$mobileL,
    'mobileL<': '(min-width: 768.02px)',
    mobileM: '(max-width: 560px)',
    'mobileM<': '(min-width: 560.02px)',
    mobileS: '(max-width: 480px)',
    'mobileS<': '(min-width: 480.02px)',
    mobileXS: '(max-width: 375px)',
    'mobileXS<': '(min-width: 375.02px)',
    coarse: '(pointer: coarse)',
    // `coarse` alone is not a partition: a `(pointer: none)` device (keyboard-only
    // nav, some TVs) matches neither `coarse` nor a plain base value written to
    // "catch the rest" — on the hosted append-only atomic sheet, a base prop can
    // also simply beat its own `@coarse` override regardless of device. The fix is
    // a disjoint partition: tombstone the base to `null` and declare the value on
    // EVERY band. Pair `@coarse` with BOTH `@fine` and `@nopointer` — together they
    // match every device exactly once, with no base value left to race.
    fine: '(pointer: fine)',
    nopointer: '(pointer: none)',
    touch: '(hover: none) and (pointer: coarse)',
    light: '(prefers-color-scheme: light)',
    dark: '(prefers-color-scheme: dark)',
    // User preferences an overlay answers (white-label spec §4.9, §6.5).
    // `reduceMotion`: the reset already snaps every animation and transition
    // under it and lands the final keyframe — a component writes
    // `'@reduceMotion': { … }` only for motion the reset cannot see (a WAAPI
    // engine, a scroll-linked effect). `reduceTransparency`: backdrops drop
    // their blur and glass popovers turn opaque —
    // `'@reduceTransparency': { backdropFilter: 'none' }` at the consumer.
    reduceMotion: '(prefers-reduced-motion: reduce)',
    reduceTransparency: '(prefers-reduced-transparency: reduce)',
    print: 'print',
    heightXXL: '(max-height: 1440px)',
    heightXL: '(max-height: 1280px)',
    heightL: '(max-height: 1024px)',
    heightM: '(max-height: 900px)',
    heightS: '(max-height: 768px)',
    heightXS: '(max-height: 480px)'
};

});


parcelRegister("hKCTj", function(module, exports) {

$parcel$export(module.exports, "appShellStyles", () => $cec4e680d57877a9$export$e8cee26cf7733831);
$parcel$export(module.exports, "installAppShellSync", () => $cec4e680d57877a9$export$3056e2ca3eebffce);
$parcel$export(module.exports, "uninstallAppShellSync", () => $cec4e680d57877a9$export$78a9947426547bb5);
// Shared app-level layout. Both intranet and canvas extend this to get:
//   - The common grid (single 1fr body row; the header is an absolute overlay)
//   - Document theme + root font-size
//   - Height + margin-right transition for the shared AppAssistant drawer
//     (value `H` matches AppAssistant's default width)
//
// Path-sync (publishing `window.location.pathname` / `.search` onto
// `root.currentPath` / `root.currentSearch`) is exposed as a HELPER
// function `installAppShellSync(el, s)` rather than a lifecycle hook.
// DOMQL's extends-merge replaces functions entirely, so an app that
// overrides `onCreate` on its extending shell would silently drop a
// base-level `onCreate`. Consumers invoke the helper from their own
// `onCreate` — explicit, no surprises.
//
// Consumers add their own overlays, modals, drawers as root children.
// The header slot is intentionally undeclared here: intranet mounts
// `IntranetAppHeader` and canvas mounts `CanvasAppHeader`, both of which
// extend the shared `AppHeader` base.
// The root app component in smbls does NOT inherit properties via
// `extends:` the same way children do — merging into the smblsapp root
// is handled differently. So instead of extending a component, each
// app.js imports `appShellStyles` and spreads it directly.
const $cec4e680d57877a9$export$e8cee26cf7733831 = {
    display: 'grid',
    // Single body row. AppHeader is now a `position: absolute` overlay (the
    // canvas-card-glass navbar islands, 2026-06-09), so it no longer occupies
    // a grid row. With the old `auto 1fr`, the smbls router content — the only
    // in-flow grid child — auto-placed into the `auto` row and collapsed to its
    // own min height, leaving the `1fr` row empty below it (the /tickets void
    // and every short-content app page). One `1fr` row makes content fill the
    // viewport; each app offsets below the absolute header via its own padding
    // / the `data-shell-route` CSS, and tall content scrolls inside its body.
    gridTemplateRows: '1fr',
    // NOT a bare `1fr` — that is `minmax(auto, 1fr)`, whose automatic minimum
    // is the item's min-content contribution. Any app whose content holds a
    // horizontal rail (overflow-x: auto over a long card row) inflates the
    // column to the rail's max-content width (measured 6788px at BOTH a 390px
    // and a 768px viewport on the marketplace root), and every descendant lays
    // out at that width instead of the viewport width. `minmax(0, 1fr)` floors
    // the track at 0 so the column always resolves to the viewport
    // (WS-APPSHELL-1FR-COLUMN-BLOWS-OUT-ON-RAIL-CONTENT-1). The app roots that
    // inline a static mirror of this object carry the same floor — keep them
    // in sync.
    gridTemplateColumns: 'minmax(0, 1fr)',
    width: '100%',
    maxWidth: 'none',
    // `minHeight` (not `height`) so pages with long content grow past the
    // viewport and the viewport's own scrollbar handles scrolling. Apps
    // that need a strict viewport fit (canvas, marketplace) override with
    // `height: '100dvh'` + `overflow: 'hidden'` locally.
    minHeight: '100dvh',
    // Start with both axes visible. The framework's default can sometimes
    // land `overflow-y: auto` on the root, which turns the shell into a
    // scroll container and prevents the viewport from scrolling on long
    // pages. Apps that want to scroll inside the shell (canvas, marketplace)
    // set their own overflow explicitly.
    overflowX: 'visible',
    overflowY: 'visible',
    theme: 'document',
    transition: 'margin-right 200ms ease',
    marginRight: (el, s)=>s.root?.assistantOpen ? 'H' : '0'
};
const $cec4e680d57877a9$export$3056e2ca3eebffce = function installAppShellSync(s) {
    const el = this;
    const win = el.context?.window || window;
    if (!win.__smblsPathPatched) {
        win.__smblsPathPatched = true;
        const origPush = win.history.pushState;
        const origReplace = win.history.replaceState;
        win.history.pushState = function(...args) {
            const r = origPush.apply(this, args);
            win.dispatchEvent(new Event('locationchange'));
            return r;
        };
        win.history.replaceState = function(...args) {
            const r = origReplace.apply(this, args);
            win.dispatchEvent(new Event('locationchange'));
            return r;
        };
    }
    const root = s?.root || s || el.state?.root || el.state;
    if (!root || typeof root.update !== 'function') return null;
    const sync = ()=>{
        const path = win.location.pathname;
        const search = win.location.search;
        const patch = {};
        if (root.currentPath !== path) {
            patch.currentPath = path;
            // Scroll reset on route change. AppShell can be either the scroll
            // container (when an app sets `overflowY: auto` on its root) or a
            // plain grid that lets the viewport scroll — hit both so either
            // mode lands at the top on navigation.
            if (el.node && typeof el.node.scrollTo === 'function') el.node.scrollTo({
                top: 0
            });
            if (typeof win.scrollTo === 'function') win.scrollTo({
                top: 0
            });
        }
        if (root.currentSearch !== search) patch.currentSearch = search;
        if (Object.keys(patch).length) root.update(patch);
    };
    el._appShellSync = sync;
    if (typeof win.queueMicrotask === 'function') win.queueMicrotask(sync);
    else Promise.resolve().then(sync);
    win.addEventListener('popstate', sync);
    win.addEventListener('locationchange', sync);
    return sync;
};
const $cec4e680d57877a9$export$78a9947426547bb5 = function uninstallAppShellSync() {
    const el = this;
    const win = el.context?.window || window;
    if (el._appShellSync) {
        win.removeEventListener('popstate', el._appShellSync);
        win.removeEventListener('locationchange', el._appShellSync);
        el._appShellSync = null;
    }
};

});

parcelRegister("aRm2v", function(module, exports) {

$parcel$export(module.exports, "AppAssistantToggle", () => $7e7ff32afd83b544$export$dbaa49ea45fc6e74);
// AppAssistantToggle — the magic-star button in AppHeader that flips
// `root.assistantOpen`. The workspace shell's AssistantDrawer (and the
// simone Chat it wraps) reads that flag for its visibility, so the
// toggle is the canonical opener across every workspace surface.
//
// Extracted 2026-06-02 from the legacy shared/components/AppAssistant.js
// so that AppAssistant.js (the heavy drawer body — replaced by
// AssistantDrawer + simone Chat) can be deleted without taking the
// toggle button with it. AppHeader.js mounts AppAssistantToggle by
// bare-key auto-extend, so no consumer changes were required for the
// extraction.
//
// hide rule gates on whether the host registered an `aiStream`
// function. This was originally a guard against showing the toggle in
// apps without a wired AI backend. The new SDK ai service resolves at
// boot via installAppShellSync + simoneAiTransport — both shells that
// mount this toggle (workspace, canvas) also register aiStream — so
// the guard is effectively a no-op in production but kept for the
// dev-time warning + the canvas-standalone case (where aiStream might
// not yet be wired).

var $hg33k = parcelRequire("hg33k");

var $kvDhE = parcelRequire("kvDhE");
const $7e7ff32afd83b544$export$dbaa49ea45fc6e74 = {
    extends: 'IconButton',
    // FA204 / frank trap — `_toggleAssistantDrawer` lives in `scope`, not
    // module scope: a bare module-scope const silently reads as undefined
    // once the component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Called via
    // `el.scope.toggleAssistantDrawer(...)` from the pointer/keyboard handlers
    // below.
    scope: {
        // Treat "minimized-open" (assistantOpen but collapsed to the pill chip)
        // as NOT fully open, so the star REVEALS the drawer from the chip
        // instead of toggling the assistant off. `!assistantOpen` alone was
        // false in the minimized state, so a press set assistantOpen:false and
        // left nothing visible — the user had to press twice. To DISMISS from
        // minimized, use the drawer's close (✕) after revealing.
        toggleAssistantDrawer: (e, el, s)=>{
            const opening = !s.root.assistantOpen || s.root.assistantDock === 'minimized';
            const patch = (0, $kvDhE.headerOverlayPatch)('assistant', opening);
            // Reveal on open: a minimized dock (persisted or just-minimized)
            // promotes to a visible 'right' dock so the star never opens into an
            // empty pill-only state. (Where `assistantDock` is unset — the
            // standalone extension — no-op.)
            if (opening && s.root.assistantDock === 'minimized') patch.assistantDock = 'right';
            if (opening && s.root.notificationsPanelOpen) el.call('closeDropdown');
            s.root.update(patch);
        }
    },
    title: (el)=>el.call('polyglot', 'shell.assistantToggle.tooltip'),
    'aria-label': (el)=>el.call('polyglot', 'shell.assistantToggle.ariaLabel'),
    active: (el, s)=>!!s.root?.assistantOpen,
    // Open-state highlight on the component (reactive signal read).
    ...(0, $hg33k.activeHighlight),
    class: {
        isActive: (el, s)=>!!s.root?.assistantOpen
    },
    hide: (el)=>{
        const fn = el?.context?.functions?.aiStream;
        const missing = typeof fn !== 'function';
        return missing;
    },
    // Pointer = onMousedown (fires on the original target before chrome
    // re-renders — worst under PageSlot load churn — can swap the node mid
    // gesture and eat the click); keyboard = detail-0 click. The guard keeps
    // one gesture from double-firing the TOGGLE (open-then-close reads as
    // "the star does nothing"). Same split as HeaderTabs/NotificationBell.
    onMousedown: (e, el, s)=>{
        if (e.button !== 0) return;
        el.scope.toggleAssistantDrawer(e, el, s);
    },
    onClick: (e, el, s)=>{
        if (e.detail !== 0) return;
        el.scope.toggleAssistantDrawer(e, el, s);
    },
    // `name` (not `icon`) — required, not stylistic. See Messenger.js's Icon
    // comment for the full mechanism: IconText.Icon.if never reads the
    // child's own `el.icon`, only `el.name` (or `parent.icon`). This toggle
    // rendered empty after smbls `2e4ba032e` removed the SquareButton
    // `icon:'smile'` placeholder that had been masking the wrong key
    // (tickets/opus.md P1, 2026-08-09).
    Icon: {
        name: 'magicstar',
        boxSize: 'A A'
    }
};

});

parcelRegister("1b1YZ", function(module, exports) {

$parcel$export(module.exports, "CanvasMessage", () => $0db85b4501bf6796$export$57e55fecbcb580ba);
// CanvasMessage — reusable floating message/notice pill.
//
// Generalized out of the canvas /team-and-agents HelpBox: a small card-themed,
// bordered, rounded pill that floats over a surface and carries arbitrary
// consumer content (help text, a Lottie, a CTA, …) plus an OPTIONAL dismiss
// "×" button.
//
// Nothing is hardcoded to a single consumer:
//   - `dismissKey`  — name of the root state flag that hides the pill once the
//                     user dismisses it. When unset, NO dismiss button renders
//                     and the pill stays put (a non-dismissible notice).
//                     The flag is read off `s.root[dismissKey]` and written
//                     `true` on click, so it persists across SPA navigation.
//   - positioning   — defaults to the bottom-right corner of the nearest
//                     positioned ancestor (`position: absolute`). Any consumer
//                     can override `position` / `top` / `right` / `bottom` /
//                     `left` (e.g. DemoClaimBanner pins it `fixed` bottom-left).
//
// The pill renders whatever children the consumer passes — CanvasMessage owns
// only the chrome (card surface, hairline border, radius, padding) and the
// dismiss affordance.

var $2zRqK = parcelRequire("2zRqK");
const $0db85b4501bf6796$export$57e55fecbcb580ba = {
    // Floating chrome. `absolute` anchors to the nearest positioned ancestor by
    // default (the canvas Stage in the HelpBox case); consumers needing
    // viewport anchoring override to `fixed`.
    position: 'absolute',
    right: 'A2',
    bottom: 'A2',
    flow: 'y',
    gap: 'V',
    padding: 'Z A',
    round: 'radiusControl',
    theme: 'card',
    // No hairline border (per Nika, on the HelpBox and the tickets tip). The
    // design language separates by FILL contrast — the `card` theme already
    // supplies the surface — and the only sanctioned stroke is the dashed
    // state-ring, which this is not.
    borderWidth: '0',
    fontSize: 'Z2',
    // `caption` on top of the pill's own 0.92 opacity left the text and its
    // icons doubly dimmed. `subtitle` keeps it secondary without washing out.
    color: 'subtitle',
    maxWidth: 'G',
    zIndex: '5',
    opacity: '0.92',
    // Hide once dismissed — only meaningful when a `dismissKey` is supplied.
    // `hide:` (not `if:`) keeps the node in the DOM so a CSS transition can run
    // and so re-showing (consumer clears the flag) doesn't rebuild children.
    hide: (el, s)=>!!(el.dismissKey && s.root?.[el.dismissKey]),
    '@mobileL': {
        display: 'none'
    },
    // Dismiss "×" — top-right of the pill. Renders ONLY when the consumer wired
    // a `dismissKey`; otherwise the notice is permanent. Clicking sets that flag
    // on root so the `hide:` above retracts the pill.
    // THE house close X (brand CloseButton — F2, one X for every panel): 36px
    // circle, 16px glyph, hover wash; coarse pointers get the 44pt tap slop.
    DismissBtn: {
        extends: 'CloseButton',
        if: (el)=>!!el.parent?.dismissKey,
        position: 'absolute',
        top: 'Y',
        right: 'Y',
        ':active': {
            opacity: '0.7'
        },
        title: (el)=>el.call('polyglot', 'editor.canvasMessage.dismiss'),
        ariaLabel: (el)=>el.call('polyglot', 'editor.canvasMessage.dismiss'),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const key = el.parent?.dismissKey;
            if (!key) return;
            s.root.update({
                [key]: true
            });
            (0, $2zRqK.setPref)(key, '1');
        }
    }
};

});
parcelRegister("2zRqK", function(module, exports) {

$parcel$export(module.exports, "getPref", () => $1e084bcecb10402f$export$5a3d9fff44d1c4a0);
$parcel$export(module.exports, "setPref", () => $1e084bcecb10402f$export$e24d7c6b90493ae7);
$parcel$export(module.exports, "clearPref", () => $1e084bcecb10402f$export$40445c847c75de48);
$parcel$export(module.exports, "ACTIVE_ORG", () => $1e084bcecb10402f$export$d9ecd1289243d0da);
// Cross-app user preferences. Persisted in a parent-domain cookie so
// canvas (canvas.localhost) and the workspace app
// (workspace.localhost / us-at.symbols.app) read the same value.
parcelRequire("S1wNg");
var $dNwK1 = parcelRequire("dNwK1");
const $1e084bcecb10402f$var$COOKIE_PREFIX = 'smbls_pref_';
const $1e084bcecb10402f$var$ONE_YEAR = 31536000;
function $1e084bcecb10402f$export$5a3d9fff44d1c4a0(key) {
    return (0, $dNwK1.readCookie)($1e084bcecb10402f$var$COOKIE_PREFIX + key);
}
function $1e084bcecb10402f$export$e24d7c6b90493ae7(key, value) {
    (0, $dNwK1.writeCookie)($1e084bcecb10402f$var$COOKIE_PREFIX + key, value, $1e084bcecb10402f$var$ONE_YEAR);
}
function $1e084bcecb10402f$export$40445c847c75de48(key) {
    (0, $dNwK1.writeCookie)($1e084bcecb10402f$var$COOKIE_PREFIX + key, null, 0);
}
const $1e084bcecb10402f$export$d9ecd1289243d0da = 'activeOrg';

});


parcelRegister("9cuzK", function(module, exports) {

$parcel$export(module.exports, "CanvasHelpCard", () => $6b2cf3be08bd57d1$export$ec182b584988275b);
// CanvasHelpCard — the house floating help / tip card. Extends the generic
// CanvasMessage pill (floating chrome + optional dismiss ×) and layers on the
// glassy canvas-card surface plus a slightly higher bottom offset so the pill
// clears a surface's bottom border instead of kissing it. Consumers supply the
// content (help lines, a Lottie, …) and an optional `dismissKey`.
//
// Used by the /team-and-agents canvas help pill and the home dashboard
// context-menu tip, so both read in-family. (2026-06-29 per Nika.)
const $6b2cf3be08bd57d1$export$ec182b584988275b = {
    extends: 'CanvasMessage',
    // Glassy canvas card surface — the same theme the tickets / infra / chat
    // drawers use — instead of CanvasMessage's flat `card` theme.
    theme: 'canvas-card-glass',
    // Lift off the surface's bottom edge: CanvasMessage's A2 sat flush against the
    // canvas bottom border (and under the floating Zoombar). C1 clears the bottom
    // chrome on the canvas pages with a little breathing room above it.
    // While a call's dock shows in the same corner (the shell's
    // --calldock-clear: its top edge from the viewport bottom), the tip stacks
    // A above it instead of under it. Unset (no shell) or 0 → C1, as before.
    bottom: 'max(var(--spacing-C1), calc(var(--calldock-clear, 0%) + var(--spacing-A)))',
    // The page-sidebar rule (Nika 2026-10-29; shared functions/pageSidebar.js):
    // a tip on a page whose sidebar sits on the RIGHT (beside a left navbar)
    // moves to the bottom-LEFT corner, so it never covers the rail. Opt-in: the
    // instance sets `'data-sidebar-side': (el, s) =>
    // (el.call('pageSidebarRead', s.root, el) || {}).side`.
    '&[data-sidebar-side="right"]': {
        right: 'auto',
        left: 'A2'
    },
    // Every help tip leads with the swipe animation the /team-and-agents HelpBox
    // established (2026-07-03 per Nika "should have lottie animation just like
    // /team-and-agents") — consumers can override `Lottie` (same key merges) or
    // null it out.
    //
    // LMC-F1 (2026-08-11): decorative by construction, not tagged as such —
    // every consumer (CtxMenuTip, tickets board Stage tip, canvas
    // team-and-agents HelpBox) pairs this Lottie with sibling text lines that
    // carry the actual instruction ("Right-click for options", "Drag cards
    // between columns.", …); the swipe mark is a visual accent, never the sole
    // carrier of the message. That already made it EXEMPT under WCAG 1.4.11 —
    // it just wasn't marked, so the AA icon-contrast walker measured it anyway
    // and mis-scored it: the source asset bakes literal white AND black shapes
    // (verified via lottie-web's `renderer:'svg'` output, `paints:2` on a live
    // probe), deliberately composited via CtxMenuTip's own `mixBlendMode:
    // 'difference'` override so either shape reads correctly against the
    // glass card regardless of theme — a technique the walker's plain
    // fill/stroke sampling cannot see (it does not evaluate blend modes), so it
    // flagged the raw baked colors as failing in BOTH themes (1.01 light /
    // 1.08 dark) when the actual composited render is legible. `ariaHidden`
    // makes the existing exemption explicit instead of leaving a decorative
    // animation to keep tripping the scanner — same pattern already used for
    // `LoaderRatio.Spinner`.
    //
    // DESIGN-CANVAS-HELP-CARD-LIGHT-LOTTIE-1 (2026-10-04): the `difference`
    // blend lives HERE, on the shared card, not only on CtxMenuTip — the
    // asset's white shape vanished on the light glass card for every other
    // consumer (/tasks, /team-and-agents, the canvas dashboard). `difference`
    // reads both baked shapes against the card's real surface in either theme,
    // with no per-theme colour.
    Lottie: {
        src: 'swipe-right.json',
        fontSize: 'B1',
        margin: '- auto - auto',
        mixBlendMode: 'difference',
        ariaHidden: 'true'
    }
};

});

parcelRegister("aFAVR", function(module, exports) {

$parcel$export(module.exports, "CommonCard", () => $7c4a61ae11f8441c$export$ba844440fc96ec36);
// The house CARD — every content card paints the branded `card` surface
// (Nika 2026-09-24, Q2 (B)). The rail cards (AppSidebar's children) are the
// AppSidebarCard built on this one: its corner and padding on the brand
// `navbar` glass (Nika 2026-10-30, "A: navbar glass" — AppSidebar.js,
// __tests__/sidebarGlass.test.js). The `card` surface is one fill step above
// the sheet, gray3 dark / gray15 light, with its own ink (brand theme.js
// `card`, the same surface as the admin AdminCard). On the app frame (gray2 /
// gray16) it reads 1.19:1 dark / 1.08:1 light; on the standard stage 1.62 /
// 1.26.
//
// It used to paint the SHEET's own pair (`overlayStrong` dark / `white`
// light): 1.00:1 dark and 1.04:1 light against the frame on 22 admin pages,
// so no card on the sheet could read as a card, and neither could the rail.
// The sheet itself (AppMain) no longer extends this component — it is flat,
// the frame colour, and the sticky PageHeader paints that same colour.
// Guarded by __tests__/commonCardLightGround.test.js.
const $7c4a61ae11f8441c$export$ba844440fc96ec36 = {
    theme: 'card',
    round: 'radiusCard',
    padding: 'A'
};

});

parcelRegister("fGbQV", function(module, exports) {

$parcel$export(module.exports, "CommentThread", () => $b6a3f8ee9a47185b$export$534dc0e681c6a2d7);
// CommentThread — threaded discussion on ANY entity (VaultOS v2 design §3.5).
//
// Bound to ONE `entityRef` ({ type, id } or the `ref:<type>:<id>` string form,
// functions/entityRef.js) and backed by the shared comments spine
// (`sdk.execute('comments', 'list' | 'create' | 'update' | 'remove', …)` →
// /core/comments/*). Because it keys on the uniform ref, the SAME component
// serves a canvas entity node, a training record, a document, a mail thread
// and anything a later surface registers — there is no per-entity copy.
//
// MOUNT IT BY BARE KEY from any package:
//   CommentThread: { entityRef: { type: 'record', id: 'vault.items/i-1' } }
//   CommentThread: { entityRef: (el, s) => s.selectedRef, canManageOthers: true }
//
// `canManageOthers` mirrors the server's role gate (editor-or-above may touch
// another member's comment; an author may always touch their own). It is a
// PROP, not a lookup: this package cannot know how a given consumer resolves
// its viewer's workspace role, and guessing would either hide a button the
// server allows or offer one it refuses. Left unset the thread offers delete
// on the viewer's OWN comments only — the safe half, and the true one for a
// plain member.
//
// ── FA204 / frank trap ──────────────────────────────────────────────────────
// Every helper is a `scope` method called as `el.scope.<name>`, never a
// module-scope const read from inside a factory: those read as undefined once
// this component is frank.toJSON'd for platform delivery. The pure reducers
// live in functions/commentThread.js and are reached with `el.call`, which is
// a runtime string lookup and therefore brender-safe.
//
// ── DESIGN ──────────────────────────────────────────────────────────────────
// Flat and borderless (design-direction §8): rows separate by fill contrast
// and whitespace, never by a hairline. One nesting level only — a thread is a
// conversation, not a tree (see commentThread.js for the reducer's reasoning).
// Zero shadows; the host sheet owns the elevation.
const $b6a3f8ee9a47185b$export$534dc0e681c6a2d7 = {
    scope: {
        // THE host resolver. `el.scope` is inherited by every descendant, so a
        // button four levels down calls the same methods — but `entityRef` and
        // `canManageOthers` are props on the MOUNT, and the component's own state
        // bag lives there too. Every method below starts here rather than counting
        // `el.parent` hops, which is what breaks the moment a wrapper is inserted.
        // Falls back to the passed element so a method never operates on null.
        hostOf (el) {
            let n = el;
            while(n){
                if (n.entityRef) return n;
                n = n.parent;
            }
            return el;
        },
        // The `ref:<type>:<id>` identity this mount is bound to. Also the LATCH
        // key: the thread reloads when — and only when — the ref changes.
        refKey (el) {
            try {
                return el.call('formatEntityRef', el.entityRef) || '';
            } catch (_) {
                return '';
            }
        },
        // Load the thread for the mount `el` belongs to. Callable from any
        // descendant — `this.hostOf` resolves the mount and its state bag.
        // Idempotent per ref: the lifecycle hooks latch on `el._threadFor`, so a
        // re-render never re-fetches.
        async load (el) {
            const host = this.hostOf(el);
            const s = host.state;
            if (!s || typeof s.update !== 'function') return;
            let filter = null;
            try {
                filter = host.call('commentListFilter', host.entityRef);
            } catch (_) {
                filter = null;
            }
            if (!filter) {
                s.update({
                    rows: [],
                    loading: false,
                    error: '',
                    errorOp: ''
                });
                return;
            }
            const sdk = host.sdk;
            if (!sdk || typeof sdk.execute !== 'function') {
                // No SDK on this host (docs, preview, a storybook mount) — render the
                // empty state rather than an error the reader can do nothing about.
                s.update({
                    rows: [],
                    loading: false,
                    error: '',
                    errorOp: ''
                });
                return;
            }
            s.update({
                loading: true,
                error: '',
                errorOp: ''
            });
            try {
                const raw = await sdk.execute('comments', 'list', filter);
                s.update({
                    rows: host.call('commentThreadRows', raw, {
                        email: s.root && s.root.currentUserEmail || '',
                        canManageOthers: !!host.canManageOthers
                    }),
                    loading: false,
                    error: '',
                    errorOp: ''
                });
            } catch (err) {
                s.update({
                    rows: [],
                    loading: false,
                    error: err && err.message || 'error',
                    errorOp: 'load'
                });
            }
        },
        // Post the composer's draft, as a reply when one is aimed. Clears the
        // draft only AFTER the server accepts it — user input is never disposable,
        // and a failed post that also ate the text is the worst of both.
        async post (el) {
            const host = this.hostOf(el);
            const s = host.state;
            if (!s || typeof s.update !== 'function' || s.busy) return;
            let payload = null;
            try {
                payload = host.call('commentCreatePayload', host.entityRef, s.draft, s.replyTo);
            } catch (_) {
                payload = null;
            }
            if (!payload) return;
            const sdk = host.sdk;
            if (!sdk || typeof sdk.execute !== 'function') return;
            s.update({
                busy: true,
                error: '',
                errorOp: ''
            });
            try {
                await sdk.execute('comments', 'create', {
                    payload: payload
                });
                s.update({
                    draft: '',
                    replyTo: null,
                    replyToName: '',
                    busy: false
                });
                await this.load(host);
            } catch (err) {
                // The draft is deliberately NOT cleared on failure — user input is
                // never disposable, and a post that ate the text is worse than one
                // that just failed.
                s.update({
                    busy: false,
                    error: err && err.message || 'error',
                    errorOp: 'post'
                });
            }
        },
        // Soft-delete. The server keeps the row so replies survive; the reducer
        // then drops the tombstone unless it has children.
        async remove (el, id) {
            const host = this.hostOf(el);
            const s = host.state;
            if (!id || !s || typeof s.update !== 'function' || s.busy) return;
            const sdk = host.sdk;
            if (!sdk || typeof sdk.execute !== 'function') return;
            s.update({
                busy: true,
                error: '',
                errorOp: ''
            });
            try {
                await sdk.execute('comments', 'remove', {
                    id: id
                });
                s.update({
                    busy: false
                });
                await this.load(host);
            } catch (err) {
                s.update({
                    busy: false,
                    error: err && err.message || 'error',
                    errorOp: 'remove'
                });
            }
        },
        // Aim the composer at a comment (or clear the aim with a null id).
        aimReply (el, id, name) {
            const host = this.hostOf(el);
            const s = host.state;
            if (!s || typeof s.update !== 'function') return;
            s.update({
                replyTo: id || null,
                replyToName: name || ''
            });
        }
    },
    // `rows` holds the REDUCED list (commentThreadRows output), not the raw
    // response: the reduction runs once per load instead of once per paint, and
    // every child factory reads one shape. Every key is declared here so a
    // child's state walk-up stops at this component instead of running to the
    // root — the same trap the simone composer's `images` note records.
    state: {
        rows: [],
        loading: false,
        error: '',
        // WHICH operation failed. One `error` string used to serve all three write
        // paths, so a rejected POST printed "Comments could not be loaded." — a
        // sentence about the wrong half of the component, and one that also hid
        // the fact that the list had loaded fine. Measured live on 2026-09-07:
        // the comments spine accepted `list` for a `record` entityRef and refused
        // `create` for the same ref, and the thread reported a load failure.
        // Declared here, like every other key, so a child's state walk-up stops at
        // this component (v3.14 drops an undeclared key on `update`).
        errorOp: '',
        draft: '',
        replyTo: null,
        replyToName: '',
        busy: false
    },
    flow: 'y',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    // The ref can arrive as a reactive prop, so the load is latched on the
    // resolved key rather than fired once: `onInit` covers a mount that already
    // knows its ref, `onUpdate` covers a sheet whose ref lands one paint later
    // or changes when the user selects a different node. `el._threadFor` is an
    // INSTANCE flag, never root state — root.update silently drops any key the
    // consumer's schema does not declare, and this is not state anyone else
    // reads (the same technique the chat Composer's `_dragOver` uses).
    onInit: (el, s)=>{
        const key = el.scope.refKey(el);
        if (!key || el._threadFor === key) return;
        el._threadFor = key;
        el.scope.load(el);
    },
    onUpdate: (el, s)=>{
        const key = el.scope.refKey(el);
        if (!key || el._threadFor === key) return;
        el._threadFor = key;
        s.update({
            draft: '',
            replyTo: null,
            replyToName: ''
        });
        el.scope.load(el);
    },
    Head: {
        flow: 'x',
        align: 'center left',
        gap: 'Y',
        width: '100%',
        minWidth: '0',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            text: '{{ shell.comments.title | polyglot }}'
        },
        Count: {
            tag: 'span',
            if: (el, s)=>!!(s.rows && s.rows.length),
            text: (el, s)=>String(s.rows.length),
            fontSize: 'Z1',
            color: 'caption'
        }
    },
    Status: {
        tag: 'p',
        // One line for all three quiet states, in priority order: an error the
        // reader should see, the load, then "nothing here yet". `hide` not `if` —
        // the line keeps its slot so the list never jumps as the state settles.
        hide: (el, s)=>!(s.error || s.loading || !(s.rows && s.rows.length)),
        margin: '0',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>s.error ? el.call('polyglot', s.errorOp === 'post' ? 'shell.comments.postError' : s.errorOp === 'remove' ? 'shell.comments.removeError' : 'shell.comments.error') : s.loading ? el.call('polyglot', 'shell.comments.loading') : el.call('polyglot', 'shell.comments.empty')
    },
    List: {
        flow: 'y',
        gap: 'Y',
        width: '100%',
        minWidth: '0',
        childrenAs: 'state',
        children: (el, s)=>(s.rows || []).map((r)=>({
                    key: r.id,
                    ...r
                })),
        childExtends: 'CommentThreadItem'
    },
    Composer: {
        flow: 'y',
        gap: 'X',
        width: '100%',
        minWidth: '0',
        ReplyingTo: {
            tag: 'button',
            type: 'button',
            hide: (el, s)=>!s.replyTo,
            alignSelf: 'flex-start',
            flow: 'x',
            align: 'center center',
            gap: 'Y',
            padding: 'X Z',
            round: 'radiusPill',
            background: 'overlay',
            borderWidth: '0',
            cursor: 'pointer',
            fontSize: 'X',
            color: 'caption',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            aria: {
                label: (el)=>el.call('polyglot', 'shell.comments.cancelReply')
            },
            Label: {
                tag: 'span',
                text: (el, s)=>el.call('polyglot', 'shell.comments.replyingTo').replace('{name}', s.replyToName || '')
            },
            X: {
                tag: 'span',
                text: "\u2715"
            },
            onClick: (e, el)=>{
                e.preventDefault();
                el.scope.aimReply(el, null, '');
            }
        },
        Field: {
            tag: 'textarea',
            rows: '2',
            resize: 'none',
            width: '100%',
            minWidth: '0',
            padding: 'Z Z1',
            round: 'radiusControl',
            background: 'overlay',
            border: 'none',
            outline: 'none',
            color: 'title',
            fontSize: 'Z1',
            fontFamily: 'inherit',
            ':focus-visible': {
                shadow: 'none'
            },
            placeholder: (el)=>el.call('polyglot', 'shell.comments.placeholder'),
            value: (el, s)=>s.draft || '',
            disabled: (el, s)=>!!s.busy,
            onInput: (e, el, s)=>s.update({
                    draft: e.target.value
                }),
            onKeydown: (e, el, s)=>{
                // Cmd/Ctrl+Enter posts; plain Enter keeps writing. A comment is prose,
                // not a chat line — the opposite convention to the simone composer,
                // and the one every long-form comment box uses.
                if (e.key !== 'Enter' || !(e.metaKey || e.ctrlKey)) return;
                e.preventDefault();
                el.scope.post(el);
            }
        },
        PostBtn: {
            tag: 'button',
            type: 'button',
            alignSelf: 'flex-end',
            padding: 'Y Z1',
            minHeight: 'controlHCompact',
            round: 'radiusPill',
            borderWidth: '0',
            cursor: 'pointer',
            fontSize: 'Y2',
            fontWeight: '700',
            // Solid house chip, same surface the assistant's follow-up pills use —
            // fill-contrast separation, no outline.
            theme: 'layer',
            color: 'title',
            transition: 'B defaultBezier background',
            ':hover': {
                background: 'hover'
            },
            disabled: (el, s)=>!!s.busy || !String(s.draft || '').trim(),
            isIdle: (el, s)=>!String(s.draft || '').trim(),
            '.isIdle': {
                opacity: '.5',
                cursor: 'default'
            },
            text: '{{ shell.comments.post | polyglot }}',
            onClick: (e, el)=>{
                e.preventDefault();
                el.scope.post(el);
            }
        }
    }
};

});

parcelRegister("aU53X", function(module, exports) {

$parcel$export(module.exports, "CommentThreadItem", () => $7f030fba6181d97a$export$4c32a4c97aeeeb22);
// CommentThreadItem — ONE comment in a CommentThread (VaultOS v2 design §3.5).
// Mounted by CommentThread's `List` via `childExtends: 'CommentThreadItem'`;
// its state is one reduced row from `commentThreadRows`
// (functions/commentThread.js):
//   { id, body, author, authorEmail, createdAt, editedAt, replyTo, deleted,
//     depth, ownedByMe, canRemove, replyCount }
//
// A SEPARATE component, not an inline `childExtends: {}` (FA808), so a
// consumer that needs a different row — a compact one in a canvas sheet, a
// wide one on a records page — overrides this key instead of forking the
// thread.
//
// IT DEPENDS ON ITS HOST for behaviour and nothing else: `el.scope.aimReply`
// and `el.scope.remove` are CommentThread's own scope methods, and `el.scope`
// is inherited by every descendant, so the row needs no props, no imports and
// no `el.parent` hop-counting. Mounting it outside a CommentThread renders a
// correct, inert row.
//
// Flat and borderless: a reply steps one wash deeper and indents, which is
// the whole nesting language (design-direction §8). No hairline, no shadow.
const $7f030fba6181d97a$export$4c32a4c97aeeeb22 = {
    flow: 'y',
    gap: 'X',
    width: '100%',
    minWidth: '0',
    padding: 'Z Z1',
    round: 'radiusControl',
    // Fill contrast, not a rule: a reply steps one wash deeper and indents,
    // which is the entire nesting language here (design-direction §8).
    background: (el, s)=>s.depth ? 'selected' : 'overlay',
    isReply: (el, s)=>!!s.depth,
    '.isReply': {
        marginLeft: 'A'
    },
    // A surviving tombstone reads as the quiet ink — legible, unmistakable,
    // no strike-through noise.
    isRemoved: (el, s)=>!!s.deleted,
    // D-2 (2026-09-24): this text can sit on a washed dark row, where `inactive`
    // reads 4.29:1 on `hover` and 3.33:1 on `selected` — both under 4.5 — so the
    // quiet ink here is `caption`. (A reply sits on the `selected` wash.)
    '.isRemoved': {
        color: 'caption'
    },
    Meta: {
        flow: 'x',
        align: 'center left',
        gap: 'Y',
        width: '100%',
        minWidth: '0',
        // One fontSize across the row so the author, the time and the tag
        // share a baseline (Rule 34 — spacing tokens are em-based).
        fontSize: 'Y2',
        Author: {
            tag: 'span',
            fontWeight: '700',
            color: 'title',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: '0',
            text: (el, s)=>s.author || el.call('polyglot', 'shell.comments.unknown')
        },
        Time: {
            tag: 'span',
            if: (el, s)=>!!s.createdAt,
            color: 'caption',
            whiteSpace: 'nowrap',
            flexShrink: '0',
            text: (el, s)=>el.call('commentTimeLabel', s.createdAt)
        },
        Edited: {
            tag: 'span',
            if: (el, s)=>!!s.editedAt && !s.deleted,
            color: 'caption',
            whiteSpace: 'nowrap',
            flexShrink: '0',
            text: '{{ shell.comments.edited | polyglot }}'
        }
    },
    Body: {
        tag: 'p',
        if: (el, s)=>!s.deleted,
        margin: '0',
        fontSize: 'Z1',
        color: 'title',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
        minWidth: '0',
        text: (el, s)=>s.body
    },
    Removed: {
        tag: 'p',
        if: (el, s)=>!!s.deleted,
        margin: '0',
        fontSize: 'Z1',
        fontStyle: 'italic',
        // D-2: on a reply this note sits on the `selected` wash (see isRemoved).
        color: 'caption',
        text: '{{ shell.comments.removed | polyglot }}'
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center left',
        // Both affordances are text buttons on the row's own wash — no
        // outlines, no icon buttons for two words (design-direction §8/§9).
        hide: (el, s)=>!!s.deleted,
        ReplyBtn: {
            tag: 'button',
            type: 'button',
            // One nesting level: a reply to a reply would render at the same
            // depth anyway, so the affordance is offered on roots only and the
            // thread cannot grow a second indent.
            hide: (el, s)=>!!s.depth,
            padding: '0',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y2',
            color: 'caption',
            ':hover': {
                color: 'title'
            },
            text: '{{ shell.comments.reply | polyglot }}',
            onClick: (e, el, s)=>{
                e.preventDefault();
                el.scope.aimReply(el, s.id, s.author || '');
            }
        },
        RemoveBtn: {
            tag: 'button',
            type: 'button',
            hide: (el, s)=>!s.canRemove,
            padding: '0',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y2',
            color: 'caption',
            ':hover': {
                color: 'dangerInk'
            },
            text: '{{ shell.comments.remove | polyglot }}',
            onClick: (e, el, s)=>{
                e.preventDefault();
                el.scope.remove(el, s.id);
            }
        }
    }
};

});

parcelRegister("kUZsQ", function(module, exports) {

$parcel$export(module.exports, "AppPage", () => $f3a8b726c4633362$export$e2e9b8b5e72b52f3);
const $f3a8b726c4633362$export$e2e9b8b5e72b52f3 = {
    flow: 'x',
    width: '100%',
    maxWidth: 'none',
    minWidth: '0',
    margin: '0',
    padding: '0',
    overflow: 'hidden',
    theme: 'document',
    // UI-ADMIN-PAGES-GROUND-1 (Nika 2026-08-18: "since we changed and switched
    // to general root background - you need to fix bg on those related pages
    // too"): every AppPage sits on the ONE ground chain — the active module's
    // `--stage-bg` override, else the design-system stage token — instead of
    // the `document` theme's own opaque surface, which painted OVER the shell
    // root's stage on all ~70 shell pages (admin/* included). Inline `style`,
    // not a theme change: it wins over the theme's class rule, the var() chain
    // is theme-agnostic (canvasBackground.js rule 1), and `theme: 'document'`
    // above still supplies the ink roles. Same paint main.js already carries;
    // a page that genuinely needs the document surface declares its own
    // background (the PageSlot does).
    style: {
        background: 'var(--stage-bg, var(--color-stage))'
    },
    '@mobileL': {
        flow: 'y',
        overflowX: 'clip'
    },
    // PageSlot supplies the named container. A split pane can be compact
    // even when the browser is wide; use the same posture as a narrow route.
    '@appMobile': {
        flow: 'y',
        overflowX: 'clip'
    }
};

});

parcelRegister("3qumM", function(module, exports) {

$parcel$export(module.exports, "AppCollectionPage", () => $27eb5aec8bf19500$export$d4f544097087d71c);
// Installed collection apps share one content grid in a route or PageSlot.
// The host keeps window controls; the app supplies its heading and actions.
//
// ONE SCROLLER PER PAGE (Nika 2026-10-27: "header takes too much space and
// there is small space left for content scroll. use full page scroll and do
// not make inside overflow for pageslot contents"). AppMain is the page's one
// scroller: the header scrolls away with the records, and the Body grows with
// its content instead of scrolling inside itself. Measured on dev before the
// change (kestrel-assist, 1920x873 window): the pane gave the CRM board 621 of
// 747 px under a fixed 126 px header, Production 538 under 209. After it the
// whole 747 px pane scrolls as one page.
//
// AppMain, not the page root, because the root also holds the app's rail
// (AppCollectionSidebar): the rail stays in view beside the scrolling page
// and needs no sticky positioning. The root never overflows — the route
// mount's own `overflow: auto` (workspace app.js) and the PageSlot host's
// stay idle. AppMain is no stacking context (no z-index, transform or
// filter), so a fixed dialog or toast inside it is never clipped to it on
// iOS (the PageSlot host's iOS fixed-layer rule).
//
// An app page restates none of this: no `overflow`, `flex` or `minHeight` on
// its Body (apps/tests/appScrollContract.test.js). A data region that must
// scroll SIDEWAYS (a kanban, a wide table) keeps its own `overflowX`.
const $27eb5aec8bf19500$export$d4f544097087d71c = {
    extends: 'AppPage',
    height: '100%',
    minHeight: '0',
    position: 'relative',
    // Reserve the rail's position without creating one for apps that omit it.
    AppSidebar: null,
    AppMain: {
        margin: '0',
        // x hidden keeps the rounded sheet's edge; y auto makes it the scroller
        overflow: 'hidden auto',
        overscrollBehavior: 'contain',
        '@mobileL': {
            margin: '0'
        },
        '@appMobile': {
            margin: '0'
        },
        // frank-allow FA806 — AppMain owns this existing Header slot
        Header: {
            extends: 'PageHeader',
            // It scrolls with the page: a sticky bar would keep the same height off
            // the records on every scroll position.
            position: 'static',
            // Compact (the same request): the window bar above already names the
            // app, so the header keeps one step under the bar and a half step over
            // the Body.
            padding: 'Z B Y',
            gap: 'Z',
            align: 'flex-end space-between',
            '@mobileL': {
                padding: 'Z A Y'
            },
            '@appMobile': {
                padding: 'Z A Y'
            },
            LeftGroup: {
                flow: 'y',
                align: 'flex-start flex-start',
                gap: 'Y'
            }
        },
        Body: {
            margin: '0',
            padding: 'Z B B',
            gap: 'B',
            boxSizing: 'border-box',
            // Grows with its records (never shrinks below them) and fills a short
            // page; AppMain scrolls it.
            flex: '1 0 auto',
            overflow: 'visible',
            '@mobileL': {
                padding: 'Z A A'
            },
            '@appMobile': {
                padding: 'Z A A'
            }
        }
    }
};

});

parcelRegister("kg5mN", function(module, exports) {

$parcel$export(module.exports, "AppCollectionSidebar", () => $ebf976fa978b5ef7$export$bec1c5eddc89c801);
// A collection rail stays subordinate to the app's records. The compact
// rules use available pane space, including a narrow pane on a wide screen.
//
// THE RAIL IS ITS CARD, on the one sidebar glass (Nika 2026-10-30: "Glass
// like all sidebars (Recommended)"): the shared AppSidebarCard (AppSidebar.js
// — the brand `navbar` glass, the `float` lift, the CommonCard corner), listed
// first so the AppSidebar column recipe wins where the two overlap. This
// reverses the opaque `cardSolid` rail of the app-frame pass (abe8f88cd) on
// purpose: every sidebar paints one surface. Its padding is set here again;
// the type size stays the column's (no fontSize on the card).
const $ebf976fa978b5ef7$export$bec1c5eddc89c801 = {
    extends: [
        'AppSidebarCard',
        'AppSidebar'
    ],
    width: 'G',
    minWidth: '0',
    maxWidth: '100%',
    height: 'fit-content',
    maxHeight: 'calc(100% - 2 * var(--spacing-A))',
    alignSelf: 'flex-start',
    margin: 'A 0 A A',
    padding: 'A',
    gap: 'Z',
    overflow: 'auto',
    overscrollBehavior: 'contain',
    Top: null,
    PeopleSection: null,
    ViewSwitcher: null,
    Middle: {
        display: 'contents'
    },
    '@mobileL': {
        width: 'auto',
        alignSelf: 'stretch',
        margin: 'A A 0',
        padding: 'A',
        maxHeight: '30dvh'
    },
    '@appMobile': {
        width: 'auto',
        alignSelf: 'stretch',
        margin: 'A A 0',
        padding: 'A',
        maxHeight: '30%'
    }
};

});

parcelRegister("fJMZw", function(module, exports) {

$parcel$export(module.exports, "PageSrTitle", () => $b7510f9cea926e97$export$a202167814c2ef6a);
// PageSrTitle — the page title of a surface that shows none.
//
// One title per host (workspace design-direction.md §3). Most pages print
// their title and that title is the `h1`. A few surfaces open straight on
// their content by design — the home board, mail, the marketplace browse view
// (its hero was removed on purpose, 2026-09-03), the agents board — so their
// dedicated URL had NO `h1` and a screen reader landed on a page with no name
// (live walk 2026-09-21). The design does not change: the page mounts
// `PageSrTitle: { text: '{{ key | polyglot }}' }` and gains a heading that is
// announced and never seen.
//
// VISUALLY hidden, never `display: none` / `visibility` / `opacity`: those
// remove the node from the accessibility tree, the one place it must be. The
// 1px clip box is the sr-only idiom the framework's own Checkbox states as the
// single raw-px exception. An absolutely positioned child takes no flex item
// and no grid cell, so mounting it moves nothing.
//
// Under a PageSlot pane bar the bar is already the `h1` and already names the
// page, so this one leaves the tree there (`hide` does mean display:none).
const $b7510f9cea926e97$export$a202167814c2ef6a = {
    tag: 'h1',
    hide: (el, s)=>el.call('paneTitleBarShown', s),
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    padding: '0',
    border: '0',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap'
};

});

parcelRegister("jrxOi", function(module, exports) {

$parcel$export(module.exports, "AppMain", () => $e27ac3ebbf966356$export$d9658a619df134e1);
const $e27ac3ebbf966356$export$d9658a619df134e1 = {
    // THE SHEET IS FLAT (Nika 2026-09-24, Q2 (B)): it paints the SHEET pair
    // the app frame paints — gray2 dark / gray16 light, the pair app.js loads
    // into an app route's content element (`--stage-bg: light-dark(gray16,
    // gray2)`) — THE FRAME PAIR, written in three places: this file,
    // workspace/app.js and workspace/components/PageHeader.js, which move
    // together — so on an app route it never steps
    // off the frame, and only the cards and the rail on it step (CommonCard =
    // the brand `card`: 1.19:1 dark / 1.08:1 light). The sticky PageHeader
    // paints the same pair. On a canvas route (no content sheet there) it is
    // still a real sheet over the stage: 1.93:1 dark / 1.37:1 light on the
    // standard stage — the stage chain would have left its text on the bare
    // stage (a danger line read 4.20:1). It extended CommonCard and painted
    // `overlayStrong` / `white`: 1.00:1 dark and 1.04:1 light against the
    // frame, a second sheet no one could see that left every card on it flat.
    background: 'gray2',
    '@light': {
        background: 'gray16'
    },
    round: 'radiusCard',
    flow: 'y',
    flex: '1 1 0',
    minWidth: '0',
    minHeight: '0',
    overflow: 'hidden',
    margin: '- X2 X2 -',
    // No padding — AppMain is a container for Header + Body that each own
    // their inner spacing. (The CommonCard 'A' it once inherited inflated
    // panzoom canvas pages, and others, by 10px on every side.)
    padding: '0',
    '@mobileL': {
        margin: '0 X2 X2'
    },
    '@appMobile': {
        margin: '0 X2 X2'
    },
    Header: {
        flow: 'x',
        flex: '0 0 auto'
    },
    Body: {
        flex: '1 1 0',
        flow: 'y',
        minHeight: '0',
        minWidth: '0',
        overflow: 'hidden',
        position: 'relative'
    }
};

});

parcelRegister("2EVNH", function(module, exports) {

$parcel$export(module.exports, "AppSidebarCard", () => $1efc272ea4e27aaa$export$8eece08b558d1163);
$parcel$export(module.exports, "AppSidebar", () => $1efc272ea4e27aaa$export$5b229532c5a8c084);
$parcel$export(module.exports, "PeopleGroup", () => $1efc272ea4e27aaa$export$7c7e61f64744b9);
$parcel$export(module.exports, "AppPersonRow", () => $1efc272ea4e27aaa$export$9ea2ed864c273f8b);

var $cEFVO = parcelRequire("cEFVO");
const $1efc272ea4e27aaa$export$8eece08b558d1163 = {
    extends: 'CommonCard',
    theme: 'navbar',
    shadow: 'float',
    '@reduceTransparency': {
        theme: 'dialog',
        backdropFilter: 'none'
    }
};
const $1efc272ea4e27aaa$export$5b229532c5a8c084 = {
    // THE PAGE-NAV MARK (DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1): every page's
    // own nav is an AppSidebar, and says so. The PageSlot window's sidebar
    // icon finds the page's nav by it (canvas components/PageSlot.js
    // `_toggleSidebar`) and hides / shows it through the same per-page choice
    // as the sidebar's own button below (functions/pageSidebar.js). `attr`
    // merges across extends, so every rail that extends this one carries it.
    attr: {
        'data-app-sidebar': ''
    },
    // THE SIDE AND THE CHOICE (Nika 2026-10-29 — functions/pageSidebar.js):
    // the sidebar sits on the side the navbar does not take (right beside a
    // left rail, left everywhere else) and the person can hide it, per page.
    // Two attributes carry the posture; the rules below are static, so a
    // change costs one style recalc. Reactive through what pageSidebarRead
    // reads (the look, the phone flag, the address, the pane keys).
    //
    // THE OPT-IN: a page moves its sidebar onto the side rule and gets the hide
    // button by setting `pageSidebar: true` on its instance — one page at a
    // time, each checked on both sides. Without it the sidebar stays on the
    // left with no button (no `data-sidebar-side`), as before; the hidden
    // choice and the reopen tab hold for every page, because the PageSlot
    // window's icon reaches every page's sidebar.
    pageSidebar: false,
    subscribeTo: [
        '_homeLook',
        'userPrefs',
        '_isPhoneViewport',
        'currentPath',
        '_canvasSlot',
        '_canvasSlotSecond'
    ],
    'data-sidebar-side': (el, s)=>{
        const now = el.call('pageSidebarRead', s.root, el) || {};
        return now.follows ? now.side || 'left' : null;
    },
    'data-sidebar-hidden': (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).hidden ? 'true' : null,
    // THE BUTTON'S CORNER: the column says when its hide button shows (opted in,
    // on a host that remembers, not a phone), so the first card can make room
    // for it — the two rules after the mirror below.
    'data-sidebar-toggleable': (el, s)=>{
        const now = el.call('pageSidebarRead', s.root, el) || {};
        return now.follows && now.toggleable ? 'true' : null;
    },
    // THE MIRROR: after the page (`order`), the padding turned round — the
    // X2 edge gap on the screen's side, Z towards the page. The page sheet
    // (AppMain) keeps its X2 gutter on its right; the sidebar steps back over
    // it (`marginLeft: -X2`), so the gap between the sheet and the first card
    // is Z on both sides, as before. A narrow pane keeps the stacked posture
    // (the sidebar above the page).
    '&[data-sidebar-side="right"]': {
        order: '1',
        padding: 'X2 X2 X2 Z',
        marginLeft: '-X2',
        '@mobileL': {
            order: '0',
            padding: 'Z A',
            marginLeft: '0'
        },
        '@appMobile': {
            order: '0',
            padding: 'Z A',
            marginLeft: '0'
        }
    },
    // THE FREE CORNER: the hide button sits in the first card's top-right corner
    // on every page. A first card whose first row is a caption (VIEWS, a group
    // heading, an eyebrow) leaves that corner free by itself. A card that starts
    // with a full-width row (a link list, a selectable row) marks itself
    // `data-sidebar-band`: its top padding becomes a head band — the button with
    // one Y above and below it — so the button never sits on a link. A header row
    // whose own actions end at that corner (the calendar's month arrows) marks
    // itself `data-sidebar-head-end` and keeps them clear of the button (the
    // band, less the card's own A padding). Both only while the button shows.
    '&[data-sidebar-toggleable] > [data-sidebar-band]': {
        paddingTop: 'calc(var(--size-controlHCompact) + 2 * var(--spacing-Y))',
        '@coarse': {
            paddingTop: 'calc(var(--size-controlH) + 2 * var(--spacing-Y))'
        }
    },
    '&[data-sidebar-toggleable] [data-sidebar-head-end]': {
        paddingRight: 'calc(var(--size-controlHCompact) + 2 * var(--spacing-Y) - var(--spacing-A))',
        '@coarse': {
            paddingRight: 'calc(var(--size-controlH) + 2 * var(--spacing-Y) - var(--spacing-A))'
        }
    },
    // HIDDEN: the column keeps its edge gaps and shrinks to the reopen tab; every
    // card leaves (display none — out of the flow and out of the Tab order).
    // The width floors a page sets on its own instance are released here (an
    // attribute rule outranks an instance's single class). A rail that IS its
    // card (the column extends AppSidebarCard, its Middle unwrapped) paints
    // nothing while hidden, so the tab stands alone and no glass box stays.
    '&[data-sidebar-hidden]': {
        width: 'auto',
        minWidth: '0',
        maxWidth: 'none',
        pointerEvents: 'none',
        background: 'transparent',
        boxShadow: 'none',
        backdropFilter: 'none'
    },
    '&[data-sidebar-hidden] > *': {
        display: 'none'
    },
    '&[data-sidebar-hidden] > [data-sidebar-reopen]': {
        display: 'flex',
        pointerEvents: 'auto'
    },
    flow: 'y',
    width: 'G',
    minWidth: 'G',
    maxWidth: '100%',
    boxSizing: 'border-box',
    alignSelf: 'stretch',
    // The positioning context of the hide button below (a page that floats its
    // sidebar sets its own `absolute` / `fixed`).
    position: 'relative',
    color: 'title',
    // visible, NOT hidden: this wrapper is invisible layout chrome while the
    // CARDS inside it (childExtends AppSidebarCard) carry the
    // `0 8px 32px` float shadow — a hidden overflow guillotined every card's
    // shadow at the nav box on all four sides, so the rails read as flat
    // cutouts (2026-07-29 per Nika "fix that shadows cut on canvas
    // sidebars"). Scrolling lives INSIDE the cards (each rail's Middle has
    // its own overflow: auto), so the wrapper never needed to clip.
    overflow: 'visible',
    // One step (X2) on the top, outer and bottom edges, so a rail card floats
    // evenly inside the rounded page sheet; Z is the gap to the page beside
    // it. The top used to be '-': the card met the sheet's top edge while it
    // stood 5px in on the left and the bottom (measured 2026-10-24 on every
    // comm-host rail and on the workspace /chat).
    padding: 'X2 Z X2 X2',
    gap: 'Z',
    fontSize: 'Z',
    flex: '0 0 auto',
    '@mobileL': {
        width: '100%',
        minWidth: '0',
        maxWidth: '100%',
        maxHeight: '42dvh',
        padding: 'Z A',
        overflow: 'auto'
    },
    // The PANE twin is not a copy of the phone rule (design-direction.md §4):
    // `dvh` is the WINDOW's height, and a pane is shorter than its window. At
    // 42dvh the stacked rail took 381px of a 798px pane and left the task 363px
    // (45%), measured live 2026-09-22 on /people and /bookmarks at 715px. 30dvh —
    // the cap the files rail already uses — gives the rail 272px and the task
    // 471px (59%), measured the same way; the rail scrolls inside itself, as before (§5: navigation must
    // leave room for the task).
    '@appMobile': {
        width: '100%',
        minWidth: '0',
        maxWidth: '100%',
        maxHeight: '30dvh',
        padding: 'Z A',
        overflow: 'auto'
    },
    childExtends: 'AppSidebarCard',
    childProps: {
        flow: 'y',
        minWidth: '0',
        maxWidth: '100%'
    },
    // Global view switcher — its OWN card (AppSidebarCard via childExtends) above
    // the other sidebar cards, jumping between Frontend (/studio), Infra (/infra),
    // Tasks (/tickets), Agents (/agents). A base key, so it renders above the
    // extenders' Middle. (2026-06-18 per Nika "move the canvas switcher to
    // another card inside the sidebar above Middle".) SELF-GATING: visible ONLY
    // on the routes the switcher itself contains (isViewNavRoute) — any other
    // rail extending AppSidebar (calendar, resolutions, feed, preview, …)
    // hides it automatically, so per-rail `ViewSwitcher: null` overrides are an
    // eager opt-out, not load-bearing. (2026-07-24 per Nika "ViewSwitcher in
    // sidebar should be only visible for pages that it contains".)
    ViewSwitcher: {
        hide: (el, s)=>!(0, $cEFVO.isViewNavRoute)(s, el),
        subscribeTo: [
            'currentPath',
            '_canvasSlot',
            '_canvasSlotSecond'
        ],
        flexShrink: '0',
        ViewNav: {
            extends: 'CanvasViewNavGroup'
        }
    },
    // THE HIDE BUTTON — one place on every page: the top-RIGHT corner of the
    // sidebar's first card, on either side (card headers start at the left, so
    // that corner is free; the tasks and studio x sat there), the house icon
    // button (PageSlotHeaderBtn: 36px circle, `iconSm` glyph, hover / pressed
    // washes, the plugin tooltip). The glyph is a window with its column on
    // the sidebar's own side. Not a card: `ignoreChildExtends` keeps the
    // column's AppSidebarCard off it. Only on a sidebar that opted in
    // (`pageSidebar: true` — its first card's own corner is checked free);
    // absent where the host cannot remember the choice, and on a phone
    // (MobileRailSheet is the phone rail).
    SidebarToggle: {
        extends: 'PageSlotHeaderBtn',
        ignoreChildExtends: true,
        subscribeTo: [
            '_homeLook',
            'userPrefs',
            '_isPhoneViewport',
            'currentPath'
        ],
        hide: (el, s)=>{
            const now = el.call('pageSidebarRead', s.root, el) || {};
            return !now.toggleable || !now.follows;
        },
        'data-sidebar-toggle': 'true',
        'data-side': (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).side || 'left',
        position: 'absolute',
        zIndex: '2',
        top: 'calc(var(--spacing-X2) + var(--spacing-Y))',
        right: 'calc(var(--spacing-Z) + var(--spacing-Y))',
        // the column's right padding is X2 on the right side (the mirror below)
        '&[data-side="right"]': {
            right: 'calc(var(--spacing-X2) + var(--spacing-Y))'
        },
        ':active': {
            background: 'selected',
            color: 'title'
        },
        title: (el)=>el.call('polyglot', 'canvas.pageSlot.sidebarHide'),
        // An icon-only control: its name is the label, not the tooltip alone.
        'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.sidebarHide'),
        'aria-expanded': 'true',
        Icon: {
            name: (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).side === 'right' ? 'lnSidebarRight' : 'lnSidebarLeft'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const now = el.call('pageSidebarRead', s.root, el) || {};
            if (!now.toggleable) return;
            el.call('pageSidebarSet', now.key, true);
            // The button leaves with the cards: the focus goes to the tab that
            // brings them back (once the hidden rule has landed).
            const tab = el.parent && el.parent.SidebarReopen && el.parent.SidebarReopen.ReopenBtn;
            if (typeof requestAnimationFrame === 'function') requestAnimationFrame(()=>{
                if (tab && tab.node && typeof tab.node.focus === 'function') tab.node.focus({
                    preventScroll: true
                });
            });
        }
    },
    // THE REOPEN TAB — at the page edge while the sidebar is hidden: the
    // collapsed column keeps its edge gaps, so the tab sits where the first
    // card's outer corner was. A small floating island (the sidebar card's own
    // glass and lift, as a pill) around the same icon button; the column's
    // hidden rule shows it, nothing else.
    // On every page sidebar, opted in or not: a choice made from a PageSlot
    // window reaches the page at its own URL, and this is the way back there.
    SidebarReopen: {
        extends: 'AppSidebarCard',
        ignoreChildExtends: true,
        'data-sidebar-reopen': 'true',
        display: 'none',
        flexShrink: '0',
        alignSelf: 'flex-start',
        round: 'radiusPill',
        padding: 'V',
        ReopenBtn: {
            extends: 'PageSlotHeaderBtn',
            subscribeTo: [
                '_homeLook',
                'userPrefs',
                '_isPhoneViewport',
                'currentPath'
            ],
            color: 'title',
            ':active': {
                background: 'selected',
                color: 'title'
            },
            title: (el)=>el.call('polyglot', 'canvas.pageSlot.sidebarShow'),
            'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.sidebarShow'),
            'aria-expanded': 'false',
            // The tip opens into the page, away from the edge the tab sits on.
            tooltipPlacement: (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).side === 'right' ? 'left' : 'right',
            Icon: {
                name: (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).side === 'right' ? 'lnSidebarRight' : 'lnSidebarLeft'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const now = el.call('pageSidebarRead', s.root, el) || {};
                if (!now.toggleable) return;
                el.call('pageSidebarSet', now.key, false);
                const bar = el.parent && el.parent.parent;
                const toggle = bar && bar.SidebarToggle;
                if (typeof requestAnimationFrame === 'function') requestAnimationFrame(()=>{
                    if (toggle && toggle.node && typeof toggle.node.focus === 'function') toggle.node.focus({
                        preventScroll: true
                    });
                });
            }
        }
    }
};
const $1efc272ea4e27aaa$export$7c7e61f64744b9 = {
    flow: 'y',
    gap: 'Z',
    marginBottom: 'Z1',
    // The rail eyebrow — the same law as AppSidebarGroup's (brief §4.3 item 3):
    // `Z` in the rail's `Z` font context is the 11.8px `Y` role (em tokens).
    CaptionTitle: {
        fontSize: 'Z',
        fontWeight: '500',
        Text: {
            text: (el)=>el.call('polyglot', el.parent?.parent?.label || '')
        }
    },
    List: {
        flow: 'y',
        gap: 'Y',
        childExtends: 'AppPersonRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const group = el.parent.groupName;
            // Only 'team' group is active after equity/cap-table removal.
            // Advisor/investor/share-class groups returned empty in the old app
            // (peopleByShareClass filtered on equity data that no longer loads).
            if (group === 'team') return el.call('activeMembers') || [];
            return [];
        }
    }
};
const $1efc272ea4e27aaa$export$9ea2ed864c273f8b = {
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Z Z1',
    margin: '- -Z1',
    round: 'radiusControl',
    fontSize: 'Z1',
    cursor: 'pointer',
    attr: {
        'data-personrow': 'true',
        'data-email': (el, s)=>s && (s.email || s.user?.email) || ''
    },
    ':hover': {
        background: 'hover'
    },
    // Opens the shell-root person popover (PersonPopoverCard on the
    // @symbo.ls/dropdown layer): the row is the anchor, the layer owns
    // placement, viewport-edge auto-flip, outside-click AND Escape.
    //
    // It used to write `root.selectedPerson` with a hand-clamped x/y for a
    // page-mounted `position: fixed` card. Three defects lived in that: the
    // clamp asserted a 320px width the card never declared and was copy-pasted
    // in chat, the card had no Escape key, and inside a workspace pane it
    // opened far from the row or was clipped away entirely. What does that
    // inside a pane is the PANE's transform (its open motion and the phone
    // drag; a transform makes the containing block of a fixed descendant) and
    // its `overflow: hidden` — not its `container-type: inline-size`, which
    // makes no containing block for a fixed child (Chrome 154, WebKit 26.4,
    // measured 2026-10-05). The dropdown layer owns all three.
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const email = s.email || s.user?.email;
        if (!email) return;
        el.call('openPersonPopover', email, el, s.name || s.user?.name || '');
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        src: (el, s)=>el.call('avatarUrl', s && (s.name || s.user?.name))
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s?.name || s?.user?.name || s?.email || s?.user?.email || ''
        },
        Caption: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s?.position || s?.role || s?.membership?.role || ''
        }
    }
};

});

parcelRegister("aTXvN", function(module, exports) {

$parcel$export(module.exports, "AppSidebarGroup", () => $7efd344098368b81$export$256b942f8c6d3386);
// The generic labeled sidebar-group shell — a flow-y group with a
// caption-title header that reads its `label` prop. Promoted VERBATIM from
// tickets/components/Sidebar.js's TicketsSidebarGroup (WS-SUITE-RED-
// BASELINE-1, 2026-08-18): canvas referenced `extends:
// 'TicketsSidebarGroup'` from FIVE sites (ProjectCanvasSidebar ×4, the
// studios TypeFilterGroup), which resolves in the workspace SHELL (it
// merges every feature package) but NOT in the standalone canvas app —
// canvas's sharedLibraries are brand/shared/monaco/preview/marketplace,
// no tickets — so the group chrome silently degraded there. Cross-app
// component imports are banned (eslint no-restricted-imports: "use
// shared/components instead"), so the shell lives HERE, where every
// package's registry already reaches. The tickets-local
// `TicketsSidebarGroup` remains for tickets' own call sites; folding it
// into `extends: 'AppSidebarGroup'` is its owning lane's one-liner.
const $7efd344098368b81$export$256b942f8c6d3386 = {
    flow: 'y',
    gap: 'Z',
    marginBottom: 'A',
    Header: {
        flow: 'x',
        align: 'center left',
        padding: 'V 0',
        // THE EYEBROW (brief §4.3 item 3, P44): the `Y` role (11.8px at the 17px
        // root), 500, uppercase, `inactive` — the brand CaptionTitle brings the
        // uppercase and the `inactive` ink (6.38:1 measured on the dark card);
        // this sets the size and weight. The size is written `Z`, not `Y`:
        // typography tokens are em-relative and every rail sets `fontSize: 'Z'`
        // (14.17px), where `Y` renders 9.84px — under the brief's own 11.8px
        // floor (G11) — and `Z` renders 11.81px, the `Y` role exactly (measured
        // live 2026-09-24; the old `Y2` was 11.05px). The label is a bundle key or a plain string: polyglot
        // returns a non-key verbatim, so both read right (TicketsSidebarGroup,
        // which this was promoted from, always translated it).
        CaptionTitle: {
            flex: '1',
            fontSize: 'Z',
            fontWeight: '500',
            Text: {
                text: (el)=>el.call('polyglot', el.parent?.parent?.parent?.label || '')
            }
        }
    }
};

});

parcelRegister("40ace", function(module, exports) {

$parcel$export(module.exports, "AppSidebarRow", () => $2e9f124a78a7f83e$export$1efb76aef0a5dc65);
// The rail row — brief §4.3 item 3 (P31, P44), 2026-09-24. ONE row law for
// every sidebar, declared on the primitive (Rule 65), so no rail restates it:
//
//   - a LINE icon at `iconSm` and a label at 500, `caption` ink at rest;
//   - hover = the `hover` wash + `title` ink; pressed = the `selected` wash;
//   - the ACTIVE row (`isActive`, supplied by the consumer) = the `selected`
//     wash + `title` ink + 700;
//   - an optional right-aligned META count (`meta`) in `inactive`, tabular
//     by the brand's html default;
//   - EXACTLY `controlHCompact` (36) tall, `controlH` (44) on a coarse
//     pointer: no vertical padding, so the min-height alone sets the height
//     (with `Z` padding the row measured 44.88px at a 17px font — the
//     brief's "39px" class of row);
//   - focus = the global ring only. A `selected` wash on :focus-visible made a
//     keyboard-focused row read as the ACTIVE one, so the row paints none.
//
// Contrast (DESIGN_LANGUAGE §4.2, D-2): on the dark `hover` wash `inactive`
// reads 4.29:1 and on the dark `selected` wash 3.33:1 — both under 4.5. So the
// meta ink is a custom property the ROW owns: `inactive` at rest, `caption` on
// hover, pressed and active. The meta child reads it; no child key is nested
// in a state block (never a valid selector) and no node is touched.
//
// The ACTIVE half rides on a `data-active` attribute block, not on
// `.isActive`: a `.isX` block is painted INLINE and that painter drops custom
// properties (measured live 2026-09-24: the active row's style attribute held
// background, color and weight but no --sidebar-row-meta, so the meta stayed
// `inactive` at 3.29:1). An attribute block compiles to a CLASS rule, where a
// custom property survives — the same way the :hover and :active ones do.
//
// Why a new shared primitive: the shell's `SidebarRow` lives in the workspace
// package, which a standalone app (canvas) never loads, and every rail
// restated its active look at the call site. `SidebarRow` folds into
// `extends: 'AppSidebarRow'` as its owning lane's one-liner, the same path
// `AppSidebarGroup` took from `TicketsSidebarGroup`.
const $2e9f124a78a7f83e$export$1efb76aef0a5dc65 = {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    minHeight: 'controlHCompact',
    padding: '0 Z1',
    round: 'radiusControl',
    cursor: (el)=>el.onClick ? 'pointer' : 'default',
    background: 'transparent',
    color: 'caption',
    fontWeight: '500',
    '--sidebar-row-meta': 'var(--color-inactive)',
    // Keyboard-operable once a consumer attaches onClick: role + tabindex make
    // it focusable so the global :focus-visible ring engages, and Enter/Space
    // mirror the click. A key from a nested control (a row menu) stays its own.
    'data-sidebar-row': 'true',
    role: (el)=>el.onClick ? 'button' : null,
    tabindex: (el)=>el.onClick ? '0' : null,
    onKeydown: (e, el, s, ctx)=>{
        if (e.target !== el.node || e.defaultPrevented) return;
        if ((e.key === 'Enter' || e.key === ' ') && el.onClick) {
            e.preventDefault();
            el.onClick(e, el, s, ctx);
        }
    },
    ':hover': {
        background: 'hover',
        color: 'title',
        '--sidebar-row-meta': 'var(--color-caption)'
    },
    ':active': {
        background: 'selected',
        color: 'title',
        '--sidebar-row-meta': 'var(--color-caption)'
    },
    '.isActive': {
        background: 'selected',
        color: 'title',
        fontWeight: '700'
    },
    'data-active': (el, s)=>{
        const active = el.isActive;
        return (typeof active === 'function' ? active(el, s) : active) ? 'true' : null;
    },
    '[data-active="true"]': {
        '--sidebar-row-meta': 'var(--color-caption)'
    },
    '@coarse': {
        minHeight: 'controlH'
    },
    '@mobileL': {
        minHeight: 'controlH'
    },
    touchAction: 'manipulation',
    // `if:` beside `hide:`, same predicate inverted. A HIDDEN Icon is still a
    // MOUNTED Icon, and the built-in resolves its name from
    // `el.name || el.icon || el.key`: a row naming no glyph answered `undefined`
    // here, fell through to the KEY and warned `[Icon] Unknown icon name "Icon"`
    // while painting the `noIcon` placeholder behind the hide. `hide:` stays as
    // the fallback for a runtime whose `if:` is inert. Same fix as
    // ContextDropdownItem.Icon — see the comment at that slot.
    Icon: {
        if: (el, s)=>!!(el.parent?.icon || s?.icon),
        icon: (el, s)=>el.parent?.icon || s?.icon,
        hide: (el, s)=>!(el.parent?.icon || s?.icon),
        'aria-hidden': true,
        boxSize: 'iconSm',
        flexShrink: '0'
    },
    // A bundle key or a plain string: polyglot returns a non-key verbatim.
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>el.call('polyglot', el.parent?.label ?? s?.label ?? '')
    },
    Meta: {
        tag: 'span',
        fontSize: 'Z',
        fontWeight: '400',
        flexShrink: '0',
        color: 'var(--sidebar-row-meta)',
        text: (el, s)=>String(el.parent?.meta ?? s?.meta ?? ''),
        hide: (el, s)=>{
            const meta = el.parent?.meta ?? s?.meta;
            return meta === undefined || meta === null || meta === '';
        }
    }
};

});

parcelRegister("gfX3l", function(module, exports) {

$parcel$export(module.exports, "AppTable", () => $bd5bdab88d7c647f$export$e9979de50b227577);
$parcel$export(module.exports, "AppTableHead", () => $bd5bdab88d7c647f$export$28e10f99a5d5c845);
$parcel$export(module.exports, "AppTableRow", () => $bd5bdab88d7c647f$export$717036fd23c2e707);
$parcel$export(module.exports, "AppTableNum", () => $bd5bdab88d7c647f$export$fd6a854f3f5c8e57);
// Shared table primitives — brief §4.5 (P31, P33), 2026-09-24. The house data
// table, as the page tables (ws) adopt it:
//
//   AppTable {                         role=table, rows separate by a GAP
//     AppTableHead { columns, … }      the tonal header row
//     AppTableRow  { columns, … }      one per record
//   }
//
// Rows are Grid boxes (the MembersTable / admin table shape) carrying the ARIA
// table roles, so a row can own its radius and fill: the hover is a rounded
// capsule and the header a rounded plate, with NO stroke anywhere (§2.5: row
// separators inside rounded cards are banned — a gap and the hover tint
// separate rows; D-4). Head and rows take the SAME `columns` from the page
// and share the row font, so their em-based padding and gap line up.
//
// Contrast, computed in __tests__/tableKit.test.js from the brand values:
//   header ink on the `widgetPlate` header over the card —
//     light `inactive` (gray6) ≈ 6.4:1; dark `inactive` (gray10) ≈ 4.44:1,
//     UNDER 4.5 (the same effect D-2 found on the dark washes), so the dark
//     header takes `caption` (gray13) ≈ 8:1.
//
// A FIXED TAG on the table, the header and every row (admin audit, lane C
// 2026-09-24): DOMQL takes an element's KEY as its HTML tag when the key
// names one, so a row keyed by a record id `canvas` rendered a <canvas>
// (which paints none of its children), `form` a <form>, and a table keyed
// `Table` a real <table>. The roles cannot work on those; a div can.
//
// Every direct child of a row takes role="cell", so a control goes INSIDE a
// plain child (the cell) — a <button> made a cell loses its button role.
const $bd5bdab88d7c647f$export$e9979de50b227577 = {
    tag: 'div',
    role: 'table',
    flow: 'y',
    gap: 'W',
    width: '100%',
    minWidth: '0'
};
const $bd5bdab88d7c647f$export$28e10f99a5d5c845 = {
    extends: 'Grid',
    tag: 'div',
    role: 'row',
    alignItems: 'center',
    minHeight: 'controlHCompact',
    padding: '0 A',
    columnGap: 'A',
    round: 'radiusControl',
    background: 'widgetPlate',
    childProps: {
        role: 'columnheader',
        minWidth: '0',
        fontSize: 'Y',
        fontWeight: '500',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: 'inactive',
        '@dark': {
            color: 'caption'
        }
    }
};
const $bd5bdab88d7c647f$export$717036fd23c2e707 = {
    extends: 'Grid',
    tag: 'div',
    role: 'row',
    alignItems: 'center',
    minHeight: 'controlH',
    padding: '0 A',
    columnGap: 'A',
    round: 'radiusControl',
    color: 'title',
    ':hover': {
        background: 'hover'
    },
    childProps: {
        role: 'cell',
        minWidth: '0'
    }
};
const $bd5bdab88d7c647f$export$fd6a854f3f5c8e57 = {
    role: 'cell',
    fontFamily: 'Code',
    fontSize: 'Z',
    textAlign: 'right',
    justifySelf: 'end',
    whiteSpace: 'nowrap'
};

});

parcelRegister("kIo44", function(module, exports) {

$parcel$export(module.exports, "AppStatusChip", () => $f14a9578dead3fc5$export$b18f5ecd2eecdda1);
// The status cell — brief §4.5 (P31, P55), 2026-09-24: tint + dot + label.
//
// The chip law (brief K6): a span, `radiusPill`, `W2 Y1`. The LABEL carries
// the meaning (never colour alone), inked with the brand's semantic hue inks,
// which clear 4.5:1 in both schemes. The tint is a 10% mix of the chip's OWN
// ink (Rule 67: a tint of currentColor follows the ink per scheme — no raw
// hue, so no `raw-hue-ink` survivor), and the dot takes the ink. A status
// with no hue is the same rule over `caption`: a neutral plate.
//
//   status: 'success' → `successInk`   status: 'danger' → `dangerInk`
//   status: 'warning' → `warningInk`   no status        → `caption`
//
// Contrast is computed in __tests__/tableKit.test.js from the brand values:
// every ink on its own tint, on the white and on the dark card.
//
// A new primitive, not an extension: the default-library BulletCaption /
// StatusDot / Badge are not linked into these apps (their registry has none
// of them), and the shared badges are single-purpose (InstallableStateBadge,
// ConnectionBadge).
const $f14a9578dead3fc5$export$b18f5ecd2eecdda1 = {
    tag: 'span',
    flow: 'x',
    align: 'center',
    gap: 'X2',
    width: 'fit-content',
    padding: 'W2 Y1',
    round: 'radiusPill',
    fontSize: 'Y1',
    fontWeight: '500',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    background: 'color-mix(in srgb, currentColor 10%, var(--color-tintBase))',
    color: 'caption',
    isSuccess: (el, s)=>(el.status ?? s?.status) === 'success',
    isDanger: (el, s)=>(el.status ?? s?.status) === 'danger',
    isWarning: (el, s)=>(el.status ?? s?.status) === 'warning',
    '.isSuccess': {
        color: 'successInk'
    },
    '.isDanger': {
        color: 'dangerInk'
    },
    '.isWarning': {
        color: 'warningInk'
    },
    Dot: {
        tag: 'span',
        'aria-hidden': true,
        boxSize: 'Y1',
        flexShrink: '0',
        round: 'radiusPill',
        background: 'currentColor'
    },
    // A bundle key or a plain string: polyglot returns a non-key verbatim.
    Label: {
        tag: 'span',
        text: (el, s)=>el.call('polyglot', el.parent?.label ?? s?.label ?? '')
    }
};

});

parcelRegister("cKe5X", function(module, exports) {

$parcel$export(module.exports, "AppPagination", () => $9474b6e673451735$export$ef31b58689479356);
$parcel$export(module.exports, "AppPaginationStep", () => $9474b6e673451735$export$1434ae0f31d6be30);
$parcel$export(module.exports, "AppPaginationPrevious", () => $9474b6e673451735$export$de5f0ae2a3263791);
$parcel$export(module.exports, "AppPaginationNext", () => $9474b6e673451735$export$4f2c0c9f29ef69c8);
// The table footer pager — brief §4.5 (P25, P31), 2026-09-24:
//
//   [ Previous ]  ( 1  2  [3]  4 )  [ Next ]
//
// - The pages are a CHOICE control, so they ARE the brand `TabSet`: the
//   `widgetPlate` capsule track, transparent chips, and the chosen page as
//   the full inversion — `highlight` fill + `highlight-reversed` ink (D-1).
//   The default-library `Pagination` these apps do not link (their registry
//   has no such component), so it could not be the base.
// - Previous and Next are TEXT buttons: the quiet `tertiary` control (brief
//   K2), disabled at the ends — `disabled` ink, no fill, never opacity.
//
// State contract (read from the element's state, like any DOMQL collection):
//   s.page       the current page, 1-based
//   s.pageCount  how many pages
// A click writes `s.page`; the owner reacts to it (e.g. `fetch: { page:
// (el, s) => s.page }`). The chosen chip also carries aria-current="page".
const $9474b6e673451735$export$ef31b58689479356 = {
    tag: 'nav',
    ariaLabel: (el)=>el.call('polyglot', 'common.pagination.label'),
    flow: 'x',
    align: 'center',
    gap: 'Z',
    AppPaginationPrevious: {},
    TabSet: {
        // A WINDOW of pages, never one chip per page of a long list: the first,
        // the last, and the current page with two on each side (at most 7 — see
        // functions/appPageWindow.js). Keyed by page number, so a window that
        // shifts keeps the chips it shares.
        children: (el, s)=>el.call('appPageWindow', s.page, s.pageCount).map((page)=>({
                    key: `page-${page}`,
                    page: page,
                    text: String(page)
                })),
        childProps: {
            isActive: (el, s)=>el.page === (s.page || 1),
            ariaCurrent: (el, s)=>el.page === (s.page || 1) ? 'page' : null,
            onClick: (e, el, s)=>s.update({
                    page: el.page
                })
        }
    },
    AppPaginationNext: {}
};
const $9474b6e673451735$export$1434ae0f31d6be30 = {
    extends: 'Button',
    theme: 'tertiary',
    ':disabled': {
        color: 'disabled',
        background: 'transparent',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    }
};
const $9474b6e673451735$export$de5f0ae2a3263791 = {
    extends: 'AppPaginationStep',
    text: '{{ common.action.previous | polyglot }}',
    disabled: (el, s)=>(s.page || 1) <= 1,
    onClick: (e, el, s)=>{
        if ((s.page || 1) > 1) s.update({
            page: (s.page || 1) - 1
        });
    }
};
const $9474b6e673451735$export$4f2c0c9f29ef69c8 = {
    extends: 'AppPaginationStep',
    text: '{{ common.action.next | polyglot }}',
    disabled: (el, s)=>(s.page || 1) >= (s.pageCount || 1),
    onClick: (e, el, s)=>{
        if ((s.page || 1) < (s.pageCount || 1)) s.update({
            page: (s.page || 1) + 1
        });
    }
};

});

parcelRegister("kHUTZ", function(module, exports) {

$parcel$export(module.exports, "PeopleSection", () => $f133f66333834a71$export$dd2d4d0b8ec52ff3);
const $f133f66333834a71$export$dd2d4d0b8ec52ff3 = {
    flow: 'y',
    padding: 'A B',
    gap: 'Z1',
    flex: '1',
    minHeight: '0',
    overflow: 'auto'
};

});

parcelRegister("gto75", function(module, exports) {

$parcel$export(module.exports, "NotificationWrapper", () => $bfe20f3229f7e5d6$export$3785346a4fed4152);
$parcel$export(module.exports, "NotificationRow", () => $bfe20f3229f7e5d6$export$5d68a62471681b79);
$parcel$export(module.exports, "NotificationPanel", () => $bfe20f3229f7e5d6$export$20171ad88b646892);
// Shared notifications bridge.
//
// NotificationWrapper (self-loading, primes `root.notifs`) is now defined
// HERE, locally — relocated from `@symbo-ls/workspace-shell/functions/
// notifications/collab/{index,components}.js` (opus lane, 2026-08-19,
// tickets/opus.md census H2). It used to be a cross-package re-export; that
// re-export NEVER resolved for any consumer that declares `shared` without
// also declaring `workspace-shell` (docs, marketplace, analytics) — a
// plain top-level `export {X} from '@symbo-ls/<lib>/...'` barrel is stubbed
// to `""` by frank regardless of declaration (FRANK-PAGES-BAG-1,
// tickets/done.md — the declared-library resolver only rewrites free-var
// reads inside serialized FUNCTION BODIES, never a top-level module
// binding, which frank resolves by evaluating the esbuild bundle in Node at
// push time, where every `@symbo-ls/*` specifier is unconditionally
// externalized+stubbed). `AppHeader.js` (below, this same package)
// bare-keys `NotificationWrapper` — every app merging `shared` depends on
// this resolving to a real component, so "declare the shell" could never
// have fixed it; only owning the definition locally does.
//
// CANONICAL COPY. `workspace-shell`'s own
// `functions/notifications/collab/components.js` keeps a DELIBERATE, NOT
// accidental, local duplicate for its own boot — see that file's header for
// why (it is project-local there, which already wins over any shared-
// library merge for the shell's own render tree, and redirecting it to
// import `@symbo-ls/workspace-shared` here would add a NEW cross-package
// edge on the shell's own `smbls push`, itself frank-published despite
// `bundler: parcel`, risking the identical stub trap this relocation just
// fixed — see tickets/opus.md for the full reasoning). Keep the two bodies
// in sync by hand if either changes; this one is the one every OTHER
// consumer (canvas, marketplace, docs, analytics, preview) actually gets.
//
// Reads via `../functions/notifications/listNotifications.js` — a local,
// self-contained copy of the same query (own `./sdk.js` getSDK, no
// cross-package import), replacing the old relative `import('./queries.js')`
// into workspace-shell's own collab/ folder.
//
// NotificationPanel is the SOLE copy (duplicate-name collision fix,
// 2026-07-27) and since 2026-07-31 it is a DROPDOWN-LAYER CONTENT component:
// the bell opens it via `el.call('openDropdown', { content: { extends:
// 'NotificationPanel' } })`, so it renders inside the shell-root
// DropdownRoot (position:fixed, viewport coords, glass theme, ESC +
// outside-click owned by the plugin). It previously mounted absolutely
// INSIDE the header with its own zIndex:3000 + a hand-rolled mousedown
// closer — trapped in the header's stacking context, painted under bespoke
// page surfaces (which climb to 10001), and duplicated dismissal logic the
// layer already owns. Layout-only now: no position, no zIndex, no display
// gate, no document listeners.
//
// It lives HERE, not in workspace/components, because SHARED is the layer
// every app scope merges (canvas's standalone bundle links shared, never the
// workspace package) — one canonical panel everywhere, and its
// el.call('markNotificationRead' | 'markAllNotificationsRead') resolve from
// shared/functions too.
//
// NotificationBell is owned by ./NotificationBell.js (this bridge does not
// re-export it, so frank's duplicate-export scan doesn't flag both files).

var $eVGss = parcelRequire("eVGss");

var $9Psdu = parcelRequire("9Psdu");
const $bfe20f3229f7e5d6$export$3785346a4fed4152 = {
    // FA204 / frank trap (project_frank_drops_module_local_helpers) — the
    // load helper lives ON `scope`, not as a bare module-scope const, exactly
    // like NotificationRow's/NotificationPanel's own `scope` blocks below in
    // this file: a bare module-scope function referenced only from inside a
    // serialized factory (`onInit`/`onUpdate` are factory-shaped values too)
    // reads as undefined once frank.toJSON's this component for platform
    // delivery. `el.scope.foo(...)` binds `this` to `el.scope`, same
    // convention as NotificationPanel's `unread()` calling `this.all(...)`.
    //
    // Loads root.notifs once a real recipient email is known, and re-loads if
    // it changes (sign-out/sign-in in the same tab). Guarding on
    // `el._loadedFor === email` (not a bare "already ran" boolean) mirrors the
    // fix verified live 2026-07-30 against the PersonPopover Ping action in
    // the original workspace-shell copy this was relocated from: the previous
    // guard set `el._loaded = true` UNCONDITIONALLY before checking
    // `currentUserEmail`, so if this component's first (and, absent a
    // subscription, likely ONLY) onRender fired before auth hydration
    // finished — routine on a fresh boot — it saw an empty email, bailed, and
    // never got another chance.
    scope: {
        loadNotifs (el, s) {
            const email = s.root?.currentUserEmail;
            if (!email || el._loadedFor === email) return;
            el._loadedFor = email;
            (async ()=>{
                const { data: data } = await (0, $eVGss.listNotifications)();
                const rows = (data || []).map((n)=>({
                        ...n,
                        createdAt: n.created_at,
                        read: !!n.read
                    }));
                s.root.update({
                    notifs: rows
                });
            })();
        }
    },
    position: 'relative',
    subscribeTo: [
        'currentUserEmail'
    ],
    onInit: (el, s)=>el.scope.loadNotifs(el, s),
    onUpdate: (el, s)=>el.scope.loadNotifs(el, s),
    // Panel is dropdown-layer content now (the bell opens it via
    // openDropdown) — mounting it here would render a second, in-flow copy.
    NotificationBell: {}
};
const $bfe20f3229f7e5d6$export$5d68a62471681b79 = {
    // FA204 / frank trap — ICON_BY_TYPE/timeAgo used to be bare module-scope
    // const/function read from inside nested factories (`name`, `text`).
    // Those read as undefined once this component was frank.toJSON'd for
    // platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called via
    // `el.scope.<name>`.
    scope: {
        ICON_BY_TYPE: {
            mention: 'chat',
            ticket_assign: 'check',
            calendar_invite: 'date',
            doc_share: 'document',
            system: 'settings',
            // The comms-phone pipeline (a WhatsApp / SMS message, a missed call)
            channel_message: 'chat',
            channel_missed_call: 'phone'
        },
        // Compact format ("now" / "5m" / "3h" / "2d" / "1w") for the tight meta
        // column of a notification row — intentionally distinct from the verbose
        // house `el.call('timeAgo', ts)` ("5 mins ago") used on ticket cards.
        //
        // `el` first: the unit letter is a WORD too. `3d` read English on a
        // Georgian inbox (live walk 2026-09-21); the bundle carries the compact
        // form per language (`common.timeShort.*`, `{count} დღე`). A language with no
        // such key keeps the English letter, never a key string.
        timeAgo (el, iso) {
            if (!iso) return '';
            const short = (key, count, fallback)=>{
                const text = el && el.call ? el.call('polyglot', key) : null;
                return text && text !== key ? text.replace('{count}', count) : fallback;
            };
            const ms = Date.now() - new Date(iso).getTime();
            const mins = Math.floor(ms / 60000);
            if (mins < 1) return short('common.timeShort.now', '', 'now');
            if (mins < 60) return short('common.timeShort.minutes', mins, `${mins}m`);
            const hrs = Math.floor(mins / 60);
            if (hrs < 24) return short('common.timeShort.hours', hrs, `${hrs}h`);
            const days = Math.floor(hrs / 24);
            if (days < 7) return short('common.timeShort.days', days, `${days}d`);
            const weeks = Math.floor(days / 7);
            return short('common.timeShort.weeks', weeks, `${weeks}w`);
        },
        notificationBody (el, notification) {
            const body = el.call('htmlToPlainText', notification?.body) || '';
            const metadata = notification?.metadata;
            if (metadata?.kind !== 'meeting_starting' || !metadata.startAt) return body;
            const start = new Date(metadata.startAt);
            if (!Number.isFinite(start.getTime())) return body;
            const localTime = el.call('localizedDate', start, {
                hour: 'numeric',
                minute: '2-digit'
            });
            if (!localTime) return body;
            // The scheduler's prose currently includes a server-formatted time.
            // Keep the copy, but replace that clock with the canonical instant in
            // the viewer's locale/timezone.
            return body.replace(/(\bat\s+)\d{1,2}:\d{2}(?:\s*[AP]M)?/i, `$1${localTime}`);
        }
    },
    tag: 'button',
    type: 'button',
    width: '100%',
    flow: 'x',
    gap: 'Z1',
    align: 'flex-start',
    padding: 'Z1 Z',
    round: 'radiusControl',
    borderWidth: '0',
    background: 'transparent',
    color: 'title',
    textAlign: 'left',
    cursor: 'pointer',
    position: 'relative',
    transition: 'background-color A defaultBezier',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    // The lists that hold this row scroll (overflow: auto), where the house
    // ring's outer spread is clipped — the inset variant, as MenuPanelItem.
    ':focus-visible': {
        shadow: 'focusRingInset'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('markNotificationRead', s.id);
        // The row's own href, else the one its type implies (a channel message or
        // missed call → the sender's CRM contact, or the CRM inbox) —
        // functions/notificationHrefOf.js, shared with the toast.
        const href = el.call('notificationHrefOf', {
            href: s.href,
            type: s.type,
            metadata: s.metadata
        });
        if (href) {
            // No-op outside a dropdown layer (the /inbox page) — the plugin's
            // close is idempotent when nothing is open.
            el.call('closeDropdown');
            // Feature-modal first: a ticket/event notification opens its detail
            // modal IN PLACE (TicketsDetailModal / CalEventDetailModal — current
            // route preserved), anything else keeps the shared slot-vs-navigate
            // decision (openNotificationTarget.js owns the mapping; it hands
            // non-modal targets to openInSlot — shared with the toast click).
            el.call('openNotificationTarget', {
                href: href,
                type: s.type,
                metadata: s.metadata
            }, el);
        }
    },
    // The type glyph on the neutral plate.
    IconWrap: {
        tag: 'span',
        display: 'flex',
        width: 'B1',
        height: 'B1',
        minWidth: 'B1',
        round: 'radiusPill',
        align: 'center center',
        flexShrink: '0',
        background: 'widgetPlate',
        color: 'caption',
        Icon: {
            name: (el, s)=>el.scope.ICON_BY_TYPE[s.type] || 'star',
            boxSize: 'A'
        }
    },
    Body: {
        tag: 'span',
        display: 'flex',
        flex: '1',
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        // PRIMARY text: never cut (overflow law, HOME_AMBIENT_SKIN_SPEC §3b
        // rule 8) — it wraps, and a long unbroken word (an email, a URL, a
        // Georgian compound) breaks anywhere rather than pushing the time out.
        NTitle: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: (el, s)=>s.read ? '500' : '700',
            color: 'title',
            minWidth: '0',
            overflowWrap: 'anywhere',
            text: (el, s)=>s.title || ''
        },
        NBody: {
            // PROSE, never markup. A calendar invitation carries the event
            // description, and a Google Calendar description is HTML — the row
            // printed `<p>Global Tech Weekend…` with its tags (measured live). Still
            // `text:`, so nothing is ever parsed; the helper only reads it as a line.
            // A body that is ONLY markup mounts no empty line.
            if: (el, s)=>!!el.scope.notificationBody(el, s),
            // Secondary meta: one line, and the whole text on hover (rule 8 — an
            // ellipsis only where the full text rides in `title`).
            tag: 'span',
            fontSize: 'Z',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            title: (el, s)=>el.scope.notificationBody(el, s),
            text: (el, s)=>el.scope.notificationBody(el, s)
        }
    },
    Meta: {
        tag: 'span',
        display: 'flex',
        flow: 'y',
        align: 'center flex-end',
        gap: 'V',
        flexShrink: '0',
        Time: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.scope.timeAgo(el, s.createdAt || s.created_at)
        },
        // Attention is the accent (P7): the one hue on the row, as a dot.
        UnreadDot: {
            tag: 'span',
            display: 'block',
            hide: (el, s)=>!!s.read,
            width: 'Z',
            height: 'Z',
            round: 'radiusPill',
            background: 'blue',
            flexShrink: '0'
        }
    }
};
const $bfe20f3229f7e5d6$export$20171ad88b646892 = {
    // FA204 / frank trap — all/unread/filtered used to be bare module-scope
    // const/function read from inside nested factories (`hide`, `text`,
    // `children`). Those read as undefined once this component was
    // frank.toJSON'd for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called via
    // `el.scope.<name>`; `unread` calls the sibling `all` via `this.all(...)`
    // (el.scope.foo() binds `this` to el.scope — object-literal properties
    // can't see each other as bare identifiers otherwise). Not duplicated from
    // NotificationRow's scope above — each top-level export's `scope` only
    // resolves within its own tree, and NotificationRow doesn't need these.
    scope: {
        // The notification-center list, on its OWN key `root.notifs` (persisted
        // rows {id,type,title,body,href,read,createdAt}). The transient toast
        // queue keeps the shared `root.notifications` key (GlobalNotification) —
        // separate keys stop center rows from rendering as toasts or inflating
        // the bell count.
        all (root) {
            return root?.notifs || [];
        },
        unread (root) {
            return this.all(root).filter((n)=>!n.read).length;
        },
        // All / Unread / Workspace share ONE routing rule with the /inbox page —
        // both surfaces are meant to stay byte-identical (see NotificationRow's
        // header) and each previously carried its own copy of this.
        filtered (root) {
            return (0, $9Psdu.filterNotifications)(root, root?._notifFilter);
        },
        // Focus moves INTO the popover on open (DESIGN_SPEC §6.6): the first
        // notification, else the panel itself. After a frame — the dropdown
        // plugin positions the panel on the next frame, and `preventScroll`
        // keeps the focus from scrolling anything mid-entrance. Once per mount.
        focusIn (el) {
            if (el._focusedIn || !el.node || typeof el.node.focus !== 'function') return;
            el._focusedIn = true;
            const run = ()=>{
                if (!el.node || !el.node.isConnected) return;
                const list = el.List;
                const rows = list && typeof list.getChildren === 'function' ? list.getChildren() : [];
                const first = rows && rows[0] && rows[0].node;
                const target = first && first.offsetParent !== null ? first : el.node;
                try {
                    target.focus({
                        preventScroll: true
                    });
                } catch (_) {
                    target.focus();
                }
            };
            if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
            else run();
        }
    },
    role: 'dialog',
    ariaLabelledby: 'shellNotificationsTitle',
    // Focusable as the fallback target (an empty list); never in the Tab order.
    tabindex: '-1',
    // A FLEX COLUMN THAT CLIPS NOTHING (the overflow law, HOME_AMBIENT_SKIN_SPEC
    // §3b; live on dev 2c2b6d978, Georgian): the header and the filter stay,
    // the List is the one scroll container and gives way, so the panel never
    // outgrows the dropdown's own 72vh and the "View all" foot is never cut.
    // It was `overflow: hidden` round a 56vh list — on a 757px window the foot
    // fell outside — and at `overlaySm` (400) the Georgian filter's third
    // segment ("სამუშაო სივრცე") was clipped at the panel edge. `overlayMd`
    // (480) holds all three in both languages.
    flow: 'y',
    width: 'overlayMd',
    maxWidth: '92vw',
    maxHeight: '72dvh',
    minHeight: '0',
    padding: '0',
    onRender: (el)=>el.scope.focusIn(el),
    Header: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        padding: 'A A Z1 A',
        flexShrink: '0',
        // The title and the unread count on one line, one size (r077 r086). It
        // takes the row's free width and may wrap (never ellipsis, never over
        // the actions): in Georgian the nowrap title ran 110px over the old
        // text "Mark all as read" capsule (live on dev 2c2b6d978).
        TitleGroup: {
            flow: 'x',
            align: 'baseline flex-start',
            gap: 'Y',
            flex: '1 1 auto',
            minWidth: '0',
            Title: {
                tag: 'h2',
                id: 'shellNotificationsTitle',
                margin: '0',
                text: '{{ shell.notifications.panel.title | polyglot }}',
                fontWeight: '700',
                fontSize: 'B',
                lineHeight: '1.25',
                color: 'title',
                minWidth: '0',
                overflowWrap: 'anywhere'
            },
            Count: {
                hide: (el, s)=>el.scope.unread(s.root) === 0,
                tag: 'span',
                fontFamily: 'Code',
                fontSize: 'B',
                fontWeight: '500',
                lineHeight: '1.25',
                fontVariantNumeric: 'tabular-nums',
                color: 'inactive',
                text: (el, s)=>String(el.scope.unread(s.root))
            }
        },
        Actions: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            flexShrink: '0',
            // Lives in the HEADER, not on the filter track: /inbox keeps its own in
            // its header too, so the two surfaces agree. In this 480px popover it
            // is the icon beside the close X — a square on the compact control box
            // (all icon buttons are 1/1, Nika 2026-09-26), named by its tooltip and
            // its accessible name. As a text capsule its Georgian label
            // ("ყველა წაკითხულად მონიშვნა") left the title no room (live on dev
            // 2c2b6d978); the /inbox page keeps the text form in its wide header.
            //
            // On the kit's icon-only square (CompactIconButton — the brand icon
            // law restated at the call site until the brand publish lands:
            // controlHCompact, aspect 1 / 1, padding 0, flex-shrink 0, border-box),
            // beside the brand CloseButton it stands next to.
            MarkAllBtn: {
                extends: [
                    'CompactIconButton',
                    'TitleTooltipTrigger'
                ],
                icon: 'checkmark',
                type: 'button',
                theme: 'transparent',
                background: 'transparent',
                color: 'caption',
                ':hover': {
                    background: 'hover',
                    color: 'title'
                },
                title: (el)=>el.call('polyglot', 'shell.notifications.markAllRead'),
                hide: (el, s)=>el.scope.unread(s.root) === 0,
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('markAllNotificationsRead');
                }
            },
            // THE house close X (brand CloseButton — F2, one X for every panel).
            CloseButton: {
                extends: 'CloseButton',
                title: (el)=>el.call('polyglot', 'shell.notifications.close'),
                aria: {
                    label: (el)=>el.call('polyglot', 'shell.notifications.close')
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('closeDropdown');
                    s.root.update({
                        notificationsPanelOpen: false
                    });
                }
            }
        }
    },
    // All / Unread / Workspace — the shared segmented control at VIEW strength.
    // The filter is the root's `_notifFilter` (declared in state, default
    // 'all'); `isNotifFilterActive` lights All for an unset or unknown value.
    Filter: {
        extends: 'AppSegmented',
        variant: 'view',
        margin: '0 A Z1 A',
        flexShrink: '0',
        options: [
            {
                value: 'all',
                label: 'shell.notifications.tab.all'
            },
            {
                value: 'unread',
                label: 'shell.notifications.tab.unread'
            },
            {
                value: 'workspace',
                label: 'shell.notifications.tab.workspace'
            }
        ],
        childProps: {
            isActive: (el, s)=>(0, $9Psdu.isNotifFilterActive)(s.root, el.optionValue),
            ariaPressed: (el, s)=>(0, $9Psdu.isNotifFilterActive)(s.root, el.optionValue) ? 'true' : 'false',
            // "Unread · 8" while anything is unread — the segment says what it
            // holds (the /inbox track does the same with its own bundle key).
            text: (el, s)=>{
                const n = el.optionValue === 'unread' ? el.scope.unread(s.root) : 0;
                return n > 0 ? el.call('polyglot', 'shell.notifications.tab.unreadCount').replace('{count}', n) : el.call('polyglot', el.optionLabel || '');
            },
            title: (el)=>el.optionValue === 'workspace' ? el.call('polyglot', 'shell.notifications.tab.workspaceTooltip') : null,
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root.update({
                    _notifFilter: el.optionValue
                });
            }
        }
    },
    // Empty state is a SIBLING of the List slot, never a child — smbls 3.14
    // treats children:+childExtends: as the authoritative child set on a node,
    // so a named key declared inside List gets wiped by the children factory
    // every render. The shared poster: the bell on the neutral plate, one line
    // specific to the filter ("You're all caught up" would be a lie when other
    // workspaces still have rows waiting one tab away).
    Empty: {
        extends: 'EmptyState',
        hide: (el, s)=>!!el.scope.filtered(s.root).length,
        icon: 'bell',
        padding: 'C A',
        heading: (el, s)=>{
            const f = s.root?._notifFilter;
            if (f === 'unread') return 'shell.notifications.empty.unread';
            if (f === 'workspace') return 'shell.notifications.empty.workspace';
            return 'shell.notifications.empty.all';
        }
    },
    // Rounded rows separated by breathing room + hover tint — never hairline
    // row borders inside a rounded surface (house rule).
    List: {
        hide: (el, s)=>!el.scope.filtered(s.root).length,
        // THE one scroll container of the panel: it takes what the header, the
        // filter and the foot leave inside the panel's 72vh, never a height of
        // its own (it was 56vh, which the foot then fell under).
        overflow: 'auto',
        overscrollBehavior: 'contain',
        flex: '1 1 auto',
        minHeight: '0',
        flow: 'y',
        gap: 'X',
        padding: '0 Z Z Z',
        childrenAs: 'state',
        children: (el, s)=>el.scope.filtered(s.root).slice(0, 40),
        childExtends: 'NotificationRow'
    },
    // Into the full inbox — a ghost capsule, centred; no separator line (gap
    // does the work).
    Footer: {
        extends: 'AppCapsuleBtnGhost',
        compact: true,
        alignSelf: 'center',
        flexShrink: '0',
        margin: 'X 0 Z',
        text: '{{ shell.notifications.viewAll | polyglot }}',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('closeDropdown');
            // Slot-first (2026-08-06 per Nika "notifications should open in
            // pageslot") — mounts /inbox in the shell PageSlot over the current
            // route; consumers without an /inbox slot def (canvas standalone,
            // where this panel still opens as a dropdown) keep the full-page
            // navigation openInSlot falls back to, routes-walk included.
            el.call('openInSlot', '/inbox', el);
        }
    }
};

});
parcelRegister("eVGss", function(module, exports) {

$parcel$export(module.exports, "listNotifications", () => $ade752dbc8352ff8$export$3f7dacf8d16faf1b);
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $ade752dbc8352ff8$export$3f7dacf8d16faf1b = async ()=>{
    try {
        const rows = await (0, $1NxyO.getSDK)().execute('workspaceProject.notifications', 'list');
        return {
            data: Array.isArray(rows) ? rows : rows?.data || [],
            error: null
        };
    } catch (error) {
        return {
            data: [],
            error: error
        };
    }
};

});

parcelRegister("9Psdu", function(module, exports) {

$parcel$export(module.exports, "isCurrentWorkspaceNotification", () => $727ec3b76f0e223b$export$6d2fc7da93e6bc14);
$parcel$export(module.exports, "filterNotifications", () => $727ec3b76f0e223b$export$be660cc27bdda7e0);
$parcel$export(module.exports, "currentWorkspaceCount", () => $727ec3b76f0e223b$export$2f824447bb0762c7);
$parcel$export(module.exports, "isNotifFilterActive", () => $727ec3b76f0e223b$export$9e02afab48be1c07);
// Which workspace does a notification belong to?
//
// The inbox is NOT single-workspace. `workspaceProject.notifications list` is
// scoped by the ambient claim, but the ROWS carry hrefs minted elsewhere:
// server-side ticket notifications build `/w/<orgSlug>/<workspaceSlug>/task/<id>`
// (server ticketNotifications.js `buildTicketHref`), so a row can name another
// org entirely — "QA tickets from the system org arriving in your inbox", the
// case openNotificationTarget.js already carries a whole `_hardLoadCrossOrgHref`
// branch for, because clicking one has to hard-load out of the current org.
//
// The "Workspace" tab (2026-08-08 per Nika) is the filter for that: show only
// what belongs to the workspace you are looking at.
//
// PURE path/state predicate — no DOM, no el.call, direct-ESM import like its
// neighbours workspacePrefix.js / openInSlot.js, so the bell panel (shared) and
// the /inbox page (workspace shell) can share one rule.
//
// It deliberately composes the two EXISTING authorities rather than re-deriving
// either:
//   • org       → isCrossOrgNotificationHref (openNotificationTarget.js), whose
//                 active-org read is documented as matching mwtRouter/
//                 workspaceUrlSync so it "can never disagree with the URL
//                 machinery about which org the session is in"
//   • workspace → workspaceUrlHandle (activeWorkspacePointer.js), the ONE rule
//                 every URL stamper uses for the active workspace's segment
// If the tab used its own notion, a row could sit in "Workspace" and still
// hard-navigate you out of the workspace when clicked.

var $9juhh = parcelRequire("9juhh");

var $7hnoP = parcelRequire("7hnoP");

var $jhJrJ = parcelRequire("jhJrJ");
const $727ec3b76f0e223b$export$6d2fc7da93e6bc14 = (notif, root)=>{
    // Every string that addresses the ACTIVE workspace — see the file-header
    // comment above for why this is a set rather than one value.
    const activeHandles = (r)=>{
        const ws = r && r.workspace || null;
        const fromUrl = (0, $9juhh.getWorkspaceRawSegments)(r && r.currentPath || '').seg2;
        const fromRecord = ws ? [
            (0, $jhJrJ.workspaceUrlHandle)(ws),
            ws.slug,
            ws.key,
            ws.id,
            ws._id
        ] : [];
        return [
            fromUrl,
            ...fromRecord
        ].filter(Boolean).map((v)=>String(v).toLowerCase());
    };
    const href = notif && notif.href;
    if (!href || typeof href !== 'string') return true;
    // Different org → definitively not this workspace.
    if ((0, $7hnoP.isCrossOrgNotificationHref)(href, root)) return false;
    const { orgSlug: orgSlug, seg2: seg2 } = (0, $9juhh.getWorkspaceRawSegments)(href);
    // No `/w/` prefix at all → workspace-relative → current.
    if (!orgSlug || !seg2) return true;
    const handles = activeHandles(root);
    // Cold boot: the session has not resolved a workspace yet, so nothing can be
    // called foreign. Show the whole (already org-checked) list rather than an
    // empty tab that fills in a moment later.
    if (!handles.length) return true;
    // Mine by name, whichever field the producer stamped.
    if (handles.indexOf(String(seg2).toLowerCase()) >= 0) return true;
    // Segment 2 is only a WORKSPACE when the org actually has one by that handle
    // — `/w/acme/tickets` and `/w/acme/chat` put a ROUTE there (the ambiguity
    // parseWorkspacePath resolves data-driven via the boot-registered resolver).
    // Comparing raw segments instead would hide every org-level route row.
    // Unresolved (resolver not registered yet, or it says "route") falls through
    // to SHOWN: never hide what we cannot positively place as someone else's.
    return (0, $9juhh.getWorkspacePathHandle)(href) == null;
};
const $727ec3b76f0e223b$export$be660cc27bdda7e0 = (root, filter)=>{
    // FA204 / frank trap — self-contained inline copy, see the file-header
    // note on `isCurrentWorkspaceNotification` above.
    const isMine = (notif, r)=>{
        const activeHandles = (x)=>{
            const ws = x && x.workspace || null;
            const fromUrl = (0, $9juhh.getWorkspaceRawSegments)(x && x.currentPath || '').seg2;
            const fromRecord = ws ? [
                (0, $jhJrJ.workspaceUrlHandle)(ws),
                ws.slug,
                ws.key,
                ws.id,
                ws._id
            ] : [];
            return [
                fromUrl,
                ...fromRecord
            ].filter(Boolean).map((v)=>String(v).toLowerCase());
        };
        const href = notif && notif.href;
        if (!href || typeof href !== 'string') return true;
        if ((0, $7hnoP.isCrossOrgNotificationHref)(href, r)) return false;
        const { orgSlug: orgSlug, seg2: seg2 } = (0, $9juhh.getWorkspaceRawSegments)(href);
        if (!orgSlug || !seg2) return true;
        const handles = activeHandles(r);
        if (!handles.length) return true;
        if (handles.indexOf(String(seg2).toLowerCase()) >= 0) return true;
        return (0, $9juhh.getWorkspacePathHandle)(href) == null;
    };
    const all = root && root.notifs || [];
    if (filter === 'unread') return all.filter((n)=>!n.read);
    if (filter === 'workspace') return all.filter((n)=>isMine(n, root));
    return all;
};
const $727ec3b76f0e223b$export$2f824447bb0762c7 = (root)=>{
    const isMine = (notif, r)=>{
        const activeHandles = (x)=>{
            const ws = x && x.workspace || null;
            const fromUrl = (0, $9juhh.getWorkspaceRawSegments)(x && x.currentPath || '').seg2;
            const fromRecord = ws ? [
                (0, $jhJrJ.workspaceUrlHandle)(ws),
                ws.slug,
                ws.key,
                ws.id,
                ws._id
            ] : [];
            return [
                fromUrl,
                ...fromRecord
            ].filter(Boolean).map((v)=>String(v).toLowerCase());
        };
        const href = notif && notif.href;
        if (!href || typeof href !== 'string') return true;
        if ((0, $7hnoP.isCrossOrgNotificationHref)(href, r)) return false;
        const { orgSlug: orgSlug, seg2: seg2 } = (0, $9juhh.getWorkspaceRawSegments)(href);
        if (!orgSlug || !seg2) return true;
        const handles = activeHandles(r);
        if (!handles.length) return true;
        if (handles.indexOf(String(seg2).toLowerCase()) >= 0) return true;
        return (0, $9juhh.getWorkspacePathHandle)(href) == null;
    };
    return (root && root.notifs || []).filter((n)=>isMine(n, root)).length;
};
const $727ec3b76f0e223b$export$9e02afab48be1c07 = (root, tab)=>{
    const f = root && root._notifFilter || 'all';
    return tab === 'all' ? f !== 'unread' && f !== 'workspace' : f === tab;
};

});
parcelRegister("7hnoP", function(module, exports) {

$parcel$export(module.exports, "isCrossOrgNotificationHref", () => $54cc458f85992fba$export$f070fd69ac6428ec);
$parcel$export(module.exports, "openNotificationTarget", () => $54cc458f85992fba$export$97b7e3c45e32febf);
// openNotificationTarget — the ONE "what does clicking this notification DO"
// decision (2026-08-06 per Nika "notifications should open in pageslot - also
// tickets, events and such features should be opened in their modals").
//
// A notification that references an entity with a FEATURE MODAL opens that
// modal IN PLACE — the current route never changes:
//   ticket → TicketsDetailModal (via the workspace shell's global
//            openTicketDetailModal, a @symbo.ls/windows layer mounted at
//            shell scope — opens over ANY route, not just /tickets)
//   event  → CalEventDetailModal (via openEventDetailModal, same layer)
// Everything else keeps the shared openInSlot decision (shell PageSlot when
// the route has a slot def, full navigation otherwise) so a click never
// silently does nothing.
//
// It does NOT call the modal openers directly: pageContext.js's
// `selectPageItem(kind, id)` already owns "resolve this entity id from any
// route and open its canonical surface" — loaded-row lookup, SDK fetch
// fallback for tickets, and the /calendar?event= handoff for events outside
// the loaded window (which fetches + maps + opens the SAME modal there).
// Reusing it keeps one open path per entity instead of a fourth copy of the
// fetch-and-normalize logic.
//
// Lives HERE, beside openInSlot.js and for the same reason (see that file's
// header): canvas's standalone bundle links shared, never workspace, and
// NotificationRow + the toast stack render there too. selectPageItem is a
// WORKSPACE-SHELL function, so this dispatcher feature-tests
// `context.functions.selectPageItem` and degrades to openInSlot wherever the
// shell layer isn't merged (canvas / marketplace / preview standalone).
//
// Entity resolution reads BOTH the row's `metadata` (server ticket
// notifications carry `metadata.ticketObjectId` — see
// server/src/domains/tickets/services/ticketNotifications.js `_emit`;
// calendar invites carry `metadata.eventId` — calendar/functions/saveEvent.js)
// AND the href (`/ticket/<id>` path, legacy `?ticket=` / `?event=` params), so
// pre-metadata rows already in the inbox keep working.
//
// CROSS-ORG hrefs (`/w/<other-org>/…` — e.g. QA tickets from the system org
// arriving in your inbox) are the ONE input the in-place machinery cannot
// serve: selectPageItem is current-org scoped (loaded rows + the org-scoped
// tickets/docs SDK services) and a bare `el.router` into a foreign `/w/` URL
// strands the tab — the ws-handle resolver only knows the ACTIVE org's
// workspaces, so the route classifies as Not-found under the CURRENT org's
// chrome (tickets/workspace.md "cross-org ticket/event targets land on
// 'Not found'"). Those divert to a FULL page load of the href before any
// in-place attempt — see _hardLoadCrossOrgHref for why that is the correct
// org transition. Same-org hrefs never enter that branch.

var $9juhh = parcelRequire("9juhh");

var $f0yEX = parcelRequire("f0yEX");
const $54cc458f85992fba$export$1d304de9bb810559 = (notif)=>{
    const _str = (v)=>v == null ? '' : String(v);
    const _decode = (v)=>{
        try {
            return decodeURIComponent(v);
        } catch (_) {
            return v;
        }
    };
    if (!notif || typeof notif !== 'object') return null;
    const href = _str(notif.href);
    const meta = notif.metadata && typeof notif.metadata === 'object' ? notif.metadata : {};
    const clean = (0, $9juhh.stripWorkspacePrefix)(href.split('?')[0].split('#')[0]);
    // Ticket — server rows: href '/ticket/<mongoId>' (+ optional /w/<org>/<ws>
    // prefix), metadata.ticketObjectId + metadata.ticketId (human key). Legacy
    // client rows: '/tickets/…?ticket=<number|id>'. sdk.tickets.get accepts
    // both id forms (see tickets/pages/view.js).
    const ticketPath = clean.match(/^\/ticket\/([^/]+)$/);
    const ticketParam = href.match(/[?&]ticket=([^&#]+)/);
    const ticketId = _str(meta.ticketObjectId) || (ticketPath ? _decode(ticketPath[1]) : '') || (ticketParam ? _decode(ticketParam[1]) : '');
    if (ticketId) return {
        kind: 'ticket',
        id: ticketId
    };
    // Event — calendar invites use metadata.eventId; meeting-start notifications
    // use metadata.calendarEventId. Both keep a query-free '/calendar' href so
    // the desktop-notification click path survives. Legacy deep links carry
    // '?event=<id>' or the calendar's old '#event=<id>' hash.
    const eventParam = href.match(/[?&#]event=([^&#]+)/);
    const eventId = _str(meta.eventId) || _str(meta.calendarEventId) || (eventParam ? _decode(eventParam[1]) : '');
    if (eventId) return {
        kind: 'event',
        id: eventId
    };
    return null;
};
const $54cc458f85992fba$export$f070fd69ac6428ec = (href, root)=>{
    const _str = (v)=>v == null ? '' : String(v);
    const hrefSlug = (0, $9juhh.getWorkspacePrefixSlug)(_str(href));
    if (!hrefSlug) return false;
    const org = root && root.org;
    const activeSlug = org && (org.slug || org.username) || null;
    return !!activeSlug && hrefSlug !== activeSlug;
};
const $54cc458f85992fba$export$97b7e3c45e32febf = async function(notif, el) {
    // FA204 / frank trap — self-contained inline copies of _str/
    // isCrossOrgNotificationHref/_hardLoadCrossOrgHref/resolveNotificationTarget
    // (a bare sibling-export call is exactly as unresolvable post-frank.toJSON
    // as a module-local read — the exports above stay live for their own real
    // consumers, the two test files named in the file header).
    const _str = (v)=>v == null ? '' : String(v);
    const _isCrossOrgNotificationHref = (href, root)=>{
        const hrefSlug = (0, $9juhh.getWorkspacePrefixSlug)(_str(href));
        if (!hrefSlug) return false;
        const org = root && root.org;
        const activeSlug = org && (org.slug || org.username) || null;
        return !!activeSlug && hrefSlug !== activeSlug;
    };
    const _hardLoadCrossOrgHref = (el, href)=>{
        const win = el?.context?.window || (typeof window !== 'undefined' ? window : null);
        if (!win || !win.location || typeof win.location.assign !== 'function') return false;
        try {
            win.location.assign(href);
            return true;
        } catch (_) {
            return false;
        }
    };
    const _resolveNotificationTarget = (notif)=>{
        const _decode = (v)=>{
            try {
                return decodeURIComponent(v);
            } catch (_) {
                return v;
            }
        };
        if (!notif || typeof notif !== 'object') return null;
        const href = _str(notif.href);
        const meta = notif.metadata && typeof notif.metadata === 'object' ? notif.metadata : {};
        const clean = (0, $9juhh.stripWorkspacePrefix)(href.split('?')[0].split('#')[0]);
        const ticketPath = clean.match(/^\/ticket\/([^/]+)$/);
        const ticketParam = href.match(/[?&]ticket=([^&#]+)/);
        const ticketId = _str(meta.ticketObjectId) || (ticketPath ? _decode(ticketPath[1]) : '') || (ticketParam ? _decode(ticketParam[1]) : '');
        if (ticketId) return {
            kind: 'ticket',
            id: ticketId
        };
        const eventParam = href.match(/[?&#]event=([^&#]+)/);
        const eventId = _str(meta.eventId) || _str(meta.calendarEventId) || (eventParam ? _decode(eventParam[1]) : '');
        if (eventId) return {
            kind: 'event',
            id: eventId
        };
        return null;
    };
    const target = el || this;
    if (!target || !notif) return;
    const row = typeof notif === 'string' ? {
        href: notif
    } : notif;
    const href = _str(row.href);
    // Cross-org target — divert BEFORE the in-place attempt: selectPageItem's
    // loaded-row lookup + SDK fetch are current-org scoped, so for a foreign
    // entity it can only fail (a wasted round trip) or, worse, surface a
    // foreign record over the wrong org's chrome. A notification click must
    // NEVER silently redirect (2026-08-06 per Nika "should open pageSlot or
    // modal - not redirect - same for all notifications"): the cross-org case
    // opens the house confirm MODAL naming the target org, and only an
    // explicit confirm runs the full-load org transition (correct by
    // construction — bootShell F1 boots the URL's org pre-render). Guarded so
    // same-org hrefs keep the existing in-place path byte-identically; without
    // the confirmDialog function (canvas standalone) or a window, fall through
    // to the existing resolution path rather than dead-ending the click.
    if (_isCrossOrgNotificationHref(href, target.state?.root)) {
        const orgSlug = (0, $9juhh.getWorkspacePrefixSlug)(href);
        const canConfirm = typeof target.context?.functions?.confirmDialog === 'function';
        if (canConfirm) {
            target.call('confirmDialog', {
                title: target.call('polyglot', 'shell.notifications.otherOrg.title'),
                message: target.call('polyglot', 'shell.notifications.otherOrg.message').replace('{org}', orgSlug),
                confirmText: target.call('polyglot', 'shell.notifications.otherOrg.confirm'),
                icon: 'arrowRight',
                onConfirm: ()=>_hardLoadCrossOrgHref(target, href)
            });
            return;
        }
        if (_hardLoadCrossOrgHref(target, href)) return;
    }
    const resolved = _resolveNotificationTarget(row);
    if (resolved && typeof target.context?.functions?.selectPageItem === 'function') try {
        const res = await target.call('selectPageItem', resolved.kind, resolved.id);
        if (res && res.ok === true) return;
    } catch (err) {
        console.warn('[openNotificationTarget]', err?.message || err);
    }
    // Fallback — entity gone / fetch failed / shell layer absent: hand the href
    // to the shared slot-vs-navigate decision so the click still lands
    // somewhere honest (e.g. /ticket/<id>'s full page shows its own
    // "not in your organization" state).
    if (href) (0, $f0yEX.openInSlot).call(target, href, target);
};

});
parcelRegister("f0yEX", function(module, exports) {

$parcel$export(module.exports, "canOpenInSlot", () => $aed1bdc3d2fd0035$export$db308a674aeae850);
$parcel$export(module.exports, "openInSlot", () => $aed1bdc3d2fd0035$export$49963be3451927ed);
// openInSlot — the ONE "open this href in the shell PageSlot, else navigate"
// decision, extracted so NotificationRow (Notifications.js — the bell
// dropdown panel AND /inbox), the toast click handler (GlobalNotification.js),
// and the global search dropdown (workspace/functions/search/globalSearch.js
// navigateSearchResult) can never drift into three slightly-different
// implementations (2026-08-02 per Nika "notifications/searchdropdown open in
// pageslot not page").
//
// Lives HERE, not in workspace/functions, for the same reason
// markNotificationRead does (see that file's header): canvas's standalone
// bundle links shared but never workspace, and NotificationRow renders there
// too (canvas's own dashboard PageSlot instance) — an
// el.call('openInSlot', …) fired from that context must resolve here.
//
// Route-support check mirrors the EXACT resolution chain
// canvas/components/PageSlot.js's `_defFor` uses (documented in
// workspace/state-app.js's `_canvasSlot` comment: "_defFor → root._slotResolve
// → context.pages") so this can never open a route the slot itself would
// render as an empty sheet, and never guesses at an allowlist that could
// drift from the real mount.
//
// Tickets sub-routes opened from OUTSIDE the tickets app are a deliberate,
// Nika-directed exception (fix ba958f95 "open tickets search results
// in-canvas, not the CanvasPageSlot overlay"): /tickets owns a full-bleed
// pan/zoom canvas, so a subview like /tickets/my floating as an overlay over
// an unrelated page (e.g. /studio) reads wrong. External openers — this
// function — always take the full route into /tickets. TicketsSidebar's OWN
// internal slot navigation (tickets/components/Sidebar.js) is unaffected: it
// writes root._canvasSlot directly and never routes through this function.

var $63tJn = parcelRequire("63tJn");

var $66IRm = parcelRequire("66IRm");
const $aed1bdc3d2fd0035$export$db308a674aeae850 = function(href, el) {
    const forceNavigate = (h)=>/^\/(tickets|tasks)(\/|\?|#|$)/.test(h || '') || /^\/task\//.test(h || '');
    const hasSlotDef = (e, root, clean)=>!!(root && root._aiAnswerPages && root._aiAnswerPages[clean] || root && typeof root._slotResolve === 'function' && root._slotResolve(clean) || e?.context?.pages?.[clean]);
    const target = el || this;
    const root = target?.state?.root;
    if (!href || !target || !root) return false;
    if (forceNavigate(href)) return false;
    return hasSlotDef(target, root, href.split('?')[0]);
};
const $aed1bdc3d2fd0035$export$49963be3451927ed = function(href, el) {
    const forceNavigate = (h)=>/^\/(tickets|tasks)(\/|\?|#|$)/.test(h || '') || /^\/task\//.test(h || '');
    const hasSlotDef = (e, root, clean)=>!!(root && root._aiAnswerPages && root._aiAnswerPages[clean] || root && typeof root._slotResolve === 'function' && root._slotResolve(clean) || e?.context?.pages?.[clean]);
    // Walk up from `el` to the nearest routes-bearing ancestor and drive a
    // real SPA navigation — the same idiom every el.router() call site in this
    // codebase uses (NotificationRow, pageContext.js's routeEl(), chat's
    // data-ref-* handlers) rather than el.getRoot(), which doesn't reliably
    // carry `.routes` from inside a portal-rendered layer (dropdown / toast
    // stack).
    const navigate = (e, h)=>{
        let rootEl = e;
        while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
        if (rootEl && typeof e.router === 'function') e.router(h, rootEl);
    };
    const target = el || this;
    const root = target?.state?.root;
    if (!href || !target || !root || typeof root.update !== 'function') return;
    if (forceNavigate(href)) {
        navigate(target, href);
        return;
    }
    const clean = href.split('?')[0];
    if (hasSlotDef(target, root, clean)) {
        // PANE-SCOPED targeting (split-view fix, 2026-08-06 per Nika "fix bug
        // when its on split view - it often changes both views on navigation
        // click"): an open fired from INSIDE a slot pane targets that pane's own
        // state key (slotPaneKeyFor walks to the pane/host stamp PageSlot lays
        // down) — a second-pane interaction must never retarget the primary. And
        // a route already living in the second pane re-focuses/deep-links THERE
        // instead of duplicating into the primary — the iPad "tap an app that's
        // already in the split" semantics.
        //
        // A SPLIT INTENT (the pane header's split button armed it: the NEXT pick
        // lands beside the primary) wins: the pick opens in the SECOND pane — in
        // the primary only when none is open — and the intent is spent in the
        // SAME update, so no frame shows the pick landed while the split still
        // reads "arming", and a later pick never lands beside it again.
        if (root._slotSplitIntent) {
            root.update({
                [root._canvasSlot ? '_canvasSlotSecond' : '_canvasSlot']: href,
                _slotSplitIntent: false
            });
            return;
        }
        let paneKey = (0, $66IRm.slotPaneKeyFor)(target);
        if (paneKey === '_canvasSlot' && root._canvasSlotSecond && (0, $63tJn.cleanHref)(root._canvasSlotSecond) === clean) paneKey = '_canvasSlotSecond';
        root.update({
            [paneKey]: href
        });
        return;
    }
    navigate(target, href);
};

});
parcelRegister("63tJn", function(module, exports) {

$parcel$export(module.exports, "MINIMIZED_SLOTS_CAP", () => $468a15d84ec81e90$export$c2f68919208d6dd3);
$parcel$export(module.exports, "cleanHref", () => $468a15d84ec81e90$export$ca183b7f8e2b8271);
$parcel$export(module.exports, "hasMinimizedEntry", () => $468a15d84ec81e90$export$55cc97777ecb6c70);
$parcel$export(module.exports, "minimizeEntry", () => $468a15d84ec81e90$export$77b83678f070e96a);
$parcel$export(module.exports, "removeMinimizedEntry", () => $468a15d84ec81e90$export$13dc0d9231b2c4e0);
$parcel$export(module.exports, "minimizedSlotsStorageKey", () => $468a15d84ec81e90$export$e3dbbcb6b254165c);
$parcel$export(module.exports, "readMinimizedList", () => $468a15d84ec81e90$export$fed6a329d1a8cbd5);
$parcel$export(module.exports, "writeMinimizedList", () => $468a15d84ec81e90$export$9566c2b5084234c9);
$parcel$export(module.exports, "shortSlotTitle", () => $468a15d84ec81e90$export$929ba8aa436c18b6);
// minimizedSlots — pure list + persistence logic for the shell PageSlot's
// minimize-to-dock feature (2026-08-06 per Nika "we should support minimize
// feature for apps, to continue exactly where it left off").
//
// The REACTIVE side lives in canvas/components/PageSlot.js (keep-alive hosts,
// MinimizeBtn) + canvas/components/MinimizedDock.js (the chips bar); this
// module owns only the decisions that are pure data → data, so they are
// testable without a DOM and can never drift between the two consumers:
//
//   • `root._minimizedSlots` shape — ordered array (oldest → newest) of
//     { href, title, icon, wsId, minimizedAt } entries, cap 5 (minimizing a
//     6th evicts the oldest — the caller unmounts the evicted host).
//   • per-workspace sessionStorage persistence of the LIST ONLY (the mounted
//     keep-alive hosts are in-memory by nature): after a reload the dock
//     offers the same apps as COLD restores (fresh mount, best-effort
//     continuation). Per-tab sessionStorage matches the per-tab workspace
//     pointer convention (activeWorkspacePointer.js).
//
// Lives in shared/functions (not workspace/) for the same reason openInSlot
// does: PageSlot renders under the shell but ships in the canvas package,
// which links shared and never workspace. `functions/index.js` DOES barrel
// this file (`export * from './minimizedSlots.js'`) — openInSlot.js's own
// `import { cleanHref } from './minimizedSlots.js'` is a plain cross-file
// ESM import, which is safe (resolves via frank's globalScope fallback).
//
// FA204 / frank trap — _validEntry/STORAGE_PREFIX/_storage used to live at
// module scope, plus bare sibling-export calls (cleanHref/
// minimizedSlotsStorageKey/MINIMIZED_SLOTS_CAP) between the exports below.
// Each export now carries its own self-contained inline copy of whichever
// locals/siblings it actually calls.
const $468a15d84ec81e90$export$c2f68919208d6dd3 = 5;
const $468a15d84ec81e90$export$ca183b7f8e2b8271 = (href)=>String(href || '').split('?')[0].split('#')[0];
const $468a15d84ec81e90$export$55cc97777ecb6c70 = (list, href)=>{
    const _cleanHref = (h)=>String(h || '').split('?')[0].split('#')[0];
    const _validEntry = (en)=>!!(en && typeof en === 'object' && typeof en.href === 'string' && en.href);
    const clean = _cleanHref(href);
    return Array.isArray(list) && list.some((en)=>_validEntry(en) && _cleanHref(en.href) === clean);
};
const $468a15d84ec81e90$export$77b83678f070e96a = (list, entry, cap)=>{
    const MINIMIZED_SLOTS_CAP = 5;
    const _cleanHref = (h)=>String(h || '').split('?')[0].split('#')[0];
    const _validEntry = (en)=>!!(en && typeof en === 'object' && typeof en.href === 'string' && en.href);
    if (!_validEntry(entry)) return {
        list: Array.isArray(list) ? list : [],
        evicted: []
    };
    const clean = _cleanHref(entry.href);
    const base = (Array.isArray(list) ? list : []).filter((en)=>_validEntry(en) && _cleanHref(en.href) !== clean);
    const next = [
        ...base,
        entry
    ];
    const max = Number.isFinite(cap) && cap > 0 ? cap : MINIMIZED_SLOTS_CAP;
    if (next.length <= max) return {
        list: next,
        evicted: []
    };
    // Oldest first by position — the list is kept in minimize order, so the
    // front IS the oldest (`minimizedAt` is carried for display/debug, not
    // re-sorted: a caller-supplied clock can't reorder identity).
    return {
        list: next.slice(next.length - max),
        evicted: next.slice(0, next.length - max)
    };
};
const $468a15d84ec81e90$export$13dc0d9231b2c4e0 = (list, href)=>{
    const _cleanHref = (h)=>String(h || '').split('?')[0].split('#')[0];
    const _validEntry = (en)=>!!(en && typeof en === 'object' && typeof en.href === 'string' && en.href);
    const clean = _cleanHref(href);
    return (Array.isArray(list) ? list : []).filter((en)=>_validEntry(en) && _cleanHref(en.href) !== clean);
};
const $468a15d84ec81e90$export$e3dbbcb6b254165c = (wsId)=>'minimizedSlots.' + String(wsId || 'default');
const $468a15d84ec81e90$export$fed6a329d1a8cbd5 = (wsId, storage)=>{
    const MINIMIZED_SLOTS_CAP = 5;
    const _minimizedSlotsStorageKey = (id)=>'minimizedSlots.' + String(id || 'default');
    const _validEntry = (en)=>!!(en && typeof en === 'object' && typeof en.href === 'string' && en.href);
    const _storage = (storage)=>{
        if (storage) return storage;
        try {
            return globalThis.sessionStorage || null;
        } catch (_) {
            return null;
        }
    };
    const store = _storage(storage);
    if (!store || !wsId) return [];
    let raw = null;
    try {
        raw = store.getItem(_minimizedSlotsStorageKey(wsId));
    } catch (_) {
        return [];
    }
    if (!raw) return [];
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (_) {
        return [];
    }
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(_validEntry).filter((en)=>!en.wsId || String(en.wsId) === String(wsId)).slice(0, MINIMIZED_SLOTS_CAP);
};
const $468a15d84ec81e90$export$9566c2b5084234c9 = (wsId, list, storage)=>{
    const _minimizedSlotsStorageKey = (id)=>'minimizedSlots.' + String(id || 'default');
    const _validEntry = (en)=>!!(en && typeof en === 'object' && typeof en.href === 'string' && en.href);
    const _storage = (storage)=>{
        if (storage) return storage;
        try {
            return globalThis.sessionStorage || null;
        } catch (_) {
            return null;
        }
    };
    const store = _storage(storage);
    if (!store || !wsId) return;
    try {
        const entries = (Array.isArray(list) ? list : []).filter(_validEntry);
        if (!entries.length) store.removeItem(_minimizedSlotsStorageKey(wsId));
        else store.setItem(_minimizedSlotsStorageKey(wsId), JSON.stringify(entries));
    } catch (_) {
    /* best-effort */ }
};
const $468a15d84ec81e90$export$929ba8aa436c18b6 = (title)=>{
    const t = String(title || '').trim();
    if (!t) return t;
    const cut = t.split(' / ')[0].trim();
    return cut || t;
};

});

parcelRegister("66IRm", function(module, exports) {

$parcel$export(module.exports, "SLOT_PANE_PRIMARY", () => $472619c93a650162$export$9806e54433dbbf6e);
$parcel$export(module.exports, "SLOT_PANE_SECOND", () => $472619c93a650162$export$53fdedeaa0ebd1eb);
$parcel$export(module.exports, "slotPaneKeyFor", () => $472619c93a650162$export$7e2c6340ff87f3cc);
$parcel$export(module.exports, "slotPaneKeyForStrict", () => $472619c93a650162$export$53686bfb676d1ed9);
$parcel$export(module.exports, "paneTitleBarShown", () => $472619c93a650162$export$d35aab82eb30d6ca);
$parcel$export(module.exports, "pageTitleTag", () => $472619c93a650162$export$f47e6d2ed3cbc2bd);
// slotPane — resolve which PageSlot PANE an interaction originated in, so
// every slot opener can target that pane's OWN state key (split-view fix,
// 2026-08-06 per Nika "fix bug when its on split view - it often changes both
// views on navigation click").
//
// canvas/components/PageSlot.js stamps `_slotPaneKey` on each pane element
// AND on every keep-alive host it mounts a page into ('_canvasSlot' for the
// primary, '_canvasSlotSecond' for the split second). Walking the element
// parent chain from a click's origin therefore answers "which pane am I
// inside?" without any opener needing PageSlot internals — outside a pane
// (navbar, launcher, notifications, toasts) the walk falls through to the
// primary, which is the long-standing default every opener already had.
//
// Lives in shared/functions for the same reason openInSlot/minimizedSlots do:
// PageSlot ships in the canvas package while openAppPage lives in the
// workspace package, and shared is the one package both link. Imported by
// DIRECT path (the workspacePrefix.js idiom) — package-internal plumbing, not
// an el.call surface.
const $472619c93a650162$export$9806e54433dbbf6e = '_canvasSlot';
const $472619c93a650162$export$53fdedeaa0ebd1eb = '_canvasSlotSecond';
const $472619c93a650162$export$7e2c6340ff87f3cc = (el)=>{
    let node = el;
    let hops = 0;
    while(node && hops < 100){
        const key = node._slotPaneKey;
        if (key === $472619c93a650162$export$9806e54433dbbf6e || key === $472619c93a650162$export$53fdedeaa0ebd1eb) return key;
        if (node.parent === node) break;
        node = node.parent;
        hops++;
    }
    return $472619c93a650162$export$9806e54433dbbf6e;
};
const $472619c93a650162$export$53686bfb676d1ed9 = (el)=>{
    let node = el;
    let hops = 0;
    while(node && hops < 100){
        const key = node._slotPaneKey;
        if (key === '_canvasSlot' || key === '_canvasSlotSecond') return key;
        if (node.parent === node) break;
        node = node.parent;
        hops++;
    }
    return null;
};
function $472619c93a650162$export$d35aab82eb30d6ca(state) {
    if (!this.call('slotPaneKeyForStrict', this)) return false;
    const functions = this.context && this.context.functions || {};
    const root = state && state.root || this.state && this.state.root;
    if (typeof functions.moduleRailActive === 'function' && functions.moduleRailActive(root)) return true;
    return !(typeof functions.moduleImmersiveActive === 'function' && functions.moduleImmersiveActive(root));
}
function $472619c93a650162$export$f47e6d2ed3cbc2bd(state) {
    return this.call('paneTitleBarShown', state) ? 'h2' : 'h1';
}

});





parcelRegister("gNIod", function(module, exports) {

$parcel$export(module.exports, "Messenger", () => $c3b3a7c7c1e0f162$export$1182391b36b9d1bf);
// Shared messenger button for the app header. Toggles `root._chatDrawerOpen`
// and, on open, bootstraps chat state via `@symbo.ls/collab-features` so the
// drawer renders immediately after. Unread badge is driven by the same
// package's `chat.unreadCount` helper; it lazy-loads once per app and
// caches the function on `root.__chatUnreadMod`.

var $hg33k = parcelRequire("hg33k");

var $kvDhE = parcelRequire("kvDhE");



const $c3b3a7c7c1e0f162$export$1182391b36b9d1bf = {
    // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
    extends: [
        'IconButton',
        'NavbarTooltipTrigger'
    ],
    // Open-state highlight, on the component (works wherever it mounts).
    // class factory reads the signal directly so it stays reactive.
    ...(0, $hg33k.activeHighlight),
    class: {
        isActive: (el, s)=>!!s.root?._chatDrawerOpen
    },
    // INTERACT-1 item 4 (tickets/sonnet.md, WAVE-H interaction sweep,
    // 2026-08-14/15): live DOM inspection found this button — one of the two
    // top-left icon-only nav buttons (chat + notification bell, both in
    // AppHeader.js's HeaderLeft.HeaderActions cluster) — rendering with
    // NEITHER a `title` NOR an `aria-label` attribute. `title` stays flat
    // (unchanged — confirmed correct: `mcp__symbols-mcp__audit_component`
    // flags an `attr: { title }` wrapper as FA105, and smbls's own
    // attrs-in-props test suite (FA-L11, 2026-04-30) asserts flat `title`
    // promotes correctly on any tag, `button` included — an `attr` wrapper
    // would be a REGRESSION in canonical syntax, not a fix). Switched
    // `aria: { label }` (nested-object expansion path) to the bare
    // `'aria-label'` kebab key (direct-passthrough path,
    // `filterAttributesByTagName`'s "kebab-case aria-label passes through
    // unchanged" contract) — same value, a genuinely different code path,
    // and the exact convention AppHeader.js's own ClearSearchMorph/Me already
    // use in this package. If this is still unlabeled after this ships,
    // suspect a stale dist predating FA-L11 (rebuild, don't re-wrap in attr)
    // rather than re-adding the attr wrapper.
    //
    // Tooltip is "Direct messages" (not just "Messenger") so it reads as
    // clearly distinct from the `/chat` nav entry's "Team chat". Both used
    // to surface as "Chat"/"Messenger" with identical glyphs, which the
    // workspace-bug #2184 flagged as ambiguous.
    title: (el)=>el.call('polyglot', 'shell.messenger.tooltip'),
    'aria-label': (el)=>el.call('polyglot', 'shell.messenger.tooltip'),
    active: (el, s)=>!!s.root?._chatDrawerOpen,
    onClick: async (e, el, s)=>{
        const opening = !s.root._chatDrawerOpen;
        // Bundle-fold: the MessengerOverlay (and the whole chat UI tree) lives in
        // the lazily-folded chat context — fold BEFORE flipping the flag so the
        // overlay's if-latch (app.js) can mount it. Closing needs no fold.
        if (opening) {
            const okFold = await el.call('ensureChatContext');
            if (okFold === false) return;
            if (s.root.notificationsPanelOpen) el.call('closeDropdown');
        }
        // Open to the list only — clear any prior selection so MessengerChat stays
        // closed until the user picks a channel/DM.
        s.root.update((0, $kvDhE.headerOverlayPatch)('chat', opening, opening ? {
            activeChannelId: null
        } : {}));
        if (!opening) return;
        // A BUNDLER resolves this specifier; a SERVED record does not — the
        // published page carries no import map for `@symbo-ls/workspace-chat/...`,
        // so the browser answers "Failed to resolve module specifier". Measured on
        // the served UI-kit catalog (2026-09-20). The drawer is ALREADY OPEN by
        // the line above, so this failure cannot be swallowed: a silent catch
        // leaves an empty panel and no explanation. It fills the drawer's own
        // error slot instead — the same `_chatDrawerError` key
        // chat/functions/collab/drawer.js writes on a failed load and renders in
        // its DrawerError child, so there is one failure surface, not two.
        try {
            const chat = await (parcelRequire("1Noi3"));
            if (chat.bootstrapChatState) await chat.bootstrapChatState(s.root);
            else {
                const { data: data } = await chat.listChannels();
                const channels = data || [];
                const active = channels[0]?.id || null;
                s.root.update({
                    _chatDrawerChannels: channels,
                    _chatDrawerChannelId: active,
                    _chatDrawerLoading: false
                });
                if (active) {
                    const res = await chat.listMessages({
                        channelId: active
                    });
                    // No `.reverse()` — this endpoint already answers oldest row first
                    // (verified 2026-09-22; see chat/functions/collab/queries.js
                    // `listMessages`). Nothing renders `_chatDrawerMessages` today, so
                    // this is the same wrong assumption lying in wait for whoever wires
                    // it up. `limit` dropped so the one default in `listMessages` owns
                    // that number.
                    s.root.update({
                        _chatDrawerMessages: res.data || []
                    });
                }
            }
        } catch (err) {
            console.error('[messenger] chat collab module failed to load:', err?.message || err);
            s.root.update({
                _chatDrawerLoading: false,
                _chatDrawerError: el.call('polyglot', 'shell.messenger.loadFailed')
            });
        }
    },
    // Lazy-load the unread helper once per app so the UnreadBadge factories
    // can compute synchronously from DOMQL.
    //
    // PURE ENHANCEMENT — it must fail SILENTLY. The same unresolvable specifier
    // as onClick above throws here on a served record, and it surfaced as
    // `[DOMQL] Lifecycle "onRender" error` on every mount of any header that
    // carries this button. Nothing depends on the helper: `UnreadBadge.if`
    // already answers false without it, so the badge is simply absent and the
    // header is otherwise whole. A console error for a missing badge is noise,
    // not information — the ONE place the user is owed a message is the click
    // path, which has it.
    onRender: async (el, s)=>{
        if (s.root?.__chatUnreadMod) return;
        try {
            const chat = await (parcelRequire("1Noi3"));
            const chatUtils = await Promise.resolve((parcelRequire("4CrGc")));
            s.root.update({
                __chatUnreadMod: {
                    unreadCount: chat.unreadCount,
                    // Workspace resolver so the badge counts ONLY the active
                    // workspace's unreads (cross-workspace memberships are skipped).
                    getActiveWorkspaceId: chatUtils.getActiveWorkspaceId
                }
            });
        } catch (_) {
        // No badge in this host. See the note above.
        }
    },
    // `comments` — a rectangular speech-bubble glyph (2026-06-08 per Nika:
    // "chat icon without circle"). The previous `sfMessageFill` was a filled
    // bubble enclosed in a circle; this drops the circle while still reading
    // as messaging, and stays distinct from the `/chat` nav's rounded `chat`
    // glyph. Registered in `@symbo-ls/brand/designSystem/icons.js`.
    //
    // `name` (not `icon`) — required, not stylistic. `IconText.Icon.if`
    // (smbls default-config components/Icon/index.js) gates child-creation on
    // `parent.icon || el.name || el.sfSymbols || parent.sfSymbols`; it never
    // reads the child's OWN `el.icon`. `SquareButton` used to ship a
    // `icon: 'smile'` placeholder that made `parent.icon` truthy for every
    // descendant, so this child rendered anyway despite using the wrong key —
    // until smbls `2e4ba032e` (2026-08-08) correctly removed that placeholder
    // (it was leaking a stray smiley onto unrelated text-only buttons), which
    // exposed this as a silent empty button (tickets/opus.md P1, 2026-08-09).
    // Same shape as the header's own working icons (HeaderTabs.js HomeBtn/
    // SearchBtn/ArrowBtn: `Icon: { name: '<glyph>', ... }`) — match that, not
    // a third shape.
    Icon: {
        name: 'comments',
        boxSize: 'A A'
    },
    UnreadBadge: {
        if: (el, s)=>{
            const { unreadCount: unreadCount, getActiveWorkspaceId: getActiveWorkspaceId } = s.root?.__chatUnreadMod || {};
            if (!unreadCount) return false;
            return unreadCount({
                messagesByChannel: s.root?.messagesByChannel,
                channelMembers: s.root?.channelMembers,
                currentUserEmail: s.root?.currentUserEmail,
                activeWorkspaceId: getActiveWorkspaceId ? getActiveWorkspaceId(s.root) : null
            }) > 0;
        },
        position: 'absolute',
        top: '0',
        right: '0',
        minWidth: 'Z',
        height: 'Z',
        padding: '0 V',
        round: 'radiusPill',
        // Fixed alert-badge pairing, deliberately NOT theme-adaptive — an alert
        // reads red on both shells. But brand `red` (#EB6650) is tuned as a PLATE
        // colour, and white on it measures 3.21:1: fine for a dot (3:1 non-text
        // floor) and a fail for a COUNT, which is text. `redDeep` is the same
        // alert red deepened — white on #A83520 = 6.53:1. Measured across every
        // route by the aa-contrast sweep, 2026-08-09; 15 violation groups traced
        // to this one badge shape.
        background: 'redDeep',
        color: 'white',
        fontSize: 'W',
        fontWeight: '700',
        lineHeight: '1',
        align: 'center center',
        pointerEvents: 'none',
        text: (el, s)=>{
            const { unreadCount: unreadCount, getActiveWorkspaceId: getActiveWorkspaceId } = s.root?.__chatUnreadMod || {};
            if (!unreadCount) return '';
            const n = unreadCount({
                messagesByChannel: s.root?.messagesByChannel,
                channelMembers: s.root?.channelMembers,
                currentUserEmail: s.root?.currentUserEmail,
                activeWorkspaceId: getActiveWorkspaceId ? getActiveWorkspaceId(s.root) : null
            });
            return n > 99 ? '99+' : String(n);
        }
    }
};

});
parcelRegister("1Noi3", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9B18p"))) : import("9B18p")).then(()=>parcelRequire('bhOEB'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("4CrGc", function(module, exports) {

$parcel$export(module.exports, "rowToMessage", () => $35d02ea279bb9511$export$de50266104c2ad29);
$parcel$export(module.exports, "hoverTimestamp", () => $35d02ea279bb9511$export$464c42715b7ad0bd);
$parcel$export(module.exports, "normEmail", () => $35d02ea279bb9511$export$883b5bdcd2062f38);
$parcel$export(module.exports, "distinctOthers", () => $35d02ea279bb9511$export$3f63fab750bb9bd5);
$parcel$export(module.exports, "mergeChannelLists", () => $35d02ea279bb9511$export$1dfea6fac2db654d);
$parcel$export(module.exports, "mergeMemberLists", () => $35d02ea279bb9511$export$59f7582a4568c648);
$parcel$export(module.exports, "rowToChannel", () => $35d02ea279bb9511$export$2324ba16057d4458);
$parcel$export(module.exports, "filterChannelsToActiveWorkspace", () => $35d02ea279bb9511$export$5938f438d03c904a);
$parcel$export(module.exports, "isChannelVisibleInRail", () => $35d02ea279bb9511$export$8d80f3967f6fbe23);
$parcel$export(module.exports, "unreadCount", () => $35d02ea279bb9511$export$acb9fd9c5a541324);
$parcel$export(module.exports, "mutedChannels", () => $35d02ea279bb9511$export$4d14912bb87de3de);
$parcel$export(module.exports, "channelDisplayName", () => $35d02ea279bb9511$export$27109ced7a4912bf);
$parcel$export(module.exports, "chatHeaderTitle", () => $35d02ea279bb9511$export$7cc0f07baf5704c0);
$parcel$export(module.exports, "isMine", () => $35d02ea279bb9511$export$91073ceadef08af8);
$parcel$export(module.exports, "chatPageSize", () => $35d02ea279bb9511$export$ecc9bf92baa0765e);
$parcel$export(module.exports, "getVisible", () => $35d02ea279bb9511$export$beef12433c48032);
$parcel$export(module.exports, "replyTarget", () => $35d02ea279bb9511$export$dae56bff0b3b70ef);
$parcel$export(module.exports, "liveThreadCount", () => $35d02ea279bb9511$export$537d31d9dca6025);
$parcel$export(module.exports, "parentMessage", () => $35d02ea279bb9511$export$b8669153b623644e);
$parcel$export(module.exports, "isEmailOnline", () => $35d02ea279bb9511$export$bfefe6fcbdd3de5f);
$parcel$export(module.exports, "isChatChannelInView", () => $35d02ea279bb9511$export$5aef47f59364ae5e);
$parcel$export(module.exports, "channelMemberCount", () => $35d02ea279bb9511$export$252ce396742368b1);
$parcel$export(module.exports, "chatConversationInfo", () => $35d02ea279bb9511$export$ea1437cd396932e7);
$parcel$export(module.exports, "channelMemberSummary", () => $35d02ea279bb9511$export$d17a2a6a3057011e);
$parcel$export(module.exports, "BROADCAST_MENTION_TOKENS", () => $35d02ea279bb9511$export$fcba3e09a864d7e3);
$parcel$export(module.exports, "BROADCAST_MENTION_CAPTION", () => $35d02ea279bb9511$export$133488383f2a39b4);
$parcel$export(module.exports, "isBroadcastMention", () => $35d02ea279bb9511$export$a4a631160e649b8f);
$parcel$export(module.exports, "getActiveWorkspaceId", () => $35d02ea279bb9511$export$161fdbebd8545dcd);
$parcel$export(module.exports, "scopedChannels", () => $35d02ea279bb9511$export$ae08a3c846d5ef0);
$parcel$export(module.exports, "scopedChannelIdSet", () => $35d02ea279bb9511$export$2e1b68a5a441fbbf);
$parcel$export(module.exports, "scopeMembersToActiveWorkspace", () => $35d02ea279bb9511$export$6d886a352e03cb57);
$parcel$export(module.exports, "rowInActiveWorkspace", () => $35d02ea279bb9511$export$91bec3f7661e339b);
$parcel$export(module.exports, "buildDMChannels", () => $35d02ea279bb9511$export$587d95e3f07d1c9b);
$parcel$export(module.exports, "sortMessagesByTime", () => $35d02ea279bb9511$export$627f9f087e713f27);
$parcel$export(module.exports, "setChannelMessages", () => $35d02ea279bb9511$export$84dfb2cbb0c7c57);
$parcel$export(module.exports, "channelHistoryPageSize", () => $35d02ea279bb9511$export$c959ab96465e5a6d);
$parcel$export(module.exports, "hasChannelHistory", () => $35d02ea279bb9511$export$b2e980ae119aa802);
$parcel$export(module.exports, "mergeChannelHistory", () => $35d02ea279bb9511$export$ef54f1d4dff851a1);
$parcel$export(module.exports, "mergeBulkMessages", () => $35d02ea279bb9511$export$f83c6d21d3aa58ae);
$parcel$export(module.exports, "deleteChannelMessages", () => $35d02ea279bb9511$export$fc3095a8dd99abb6);
$parcel$export(module.exports, "groupMessages", () => $35d02ea279bb9511$export$6e0f5ca138042cea);
// Pure helpers — no Supabase calls live here. Imports + writes happen in
// sendMessage / subscribeRealtime / createChannel / markRead.

var $6RzDA = parcelRequire("6RzDA");

var $76fm2 = parcelRequire("76fm2");

var $9juhh = parcelRequire("9juhh");

var $kUU0b = parcelRequire("kUU0b");

var $agSJI = parcelRequire("agSJI");
const $35d02ea279bb9511$export$de50266104c2ad29 = (r)=>({
        id: r.id,
        channelId: r.channel_id,
        authorEmail: r.author_email,
        body: r.body,
        attachments: r.attachments || null,
        replyTo: r.reply_to,
        threadRoot: r.thread_root,
        threadCount: r.thread_count || 0,
        editedAt: r.edited_at,
        deleted: !!r.deleted,
        createdAt: r.created_at,
        // Soft column — `created_at` parsed to epoch ms ONCE, here, so the sort key
        // is a plain number. sortMessagesByTime runs on every setChannelMessages
        // write and would otherwise build two Dates per comparison. A missing or
        // unparseable `created_at` reads as 0 (sorts first), never NaN.
        createdAtTimestamp: Date.parse(r.created_at) || 0,
        reactions: r.reactions
    });
function $35d02ea279bb9511$export$464c42715b7ad0bd(ts) {
    const el = this && typeof this.call === 'function' ? this : null;
    if (!ts) return '';
    const d = new Date(ts);
    if (Number.isNaN(d.getTime())) return '';
    const dayOpts = {
        weekday: 'long',
        day: 'numeric',
        month: 'short'
    };
    const timeOpts = {
        hour: '2-digit',
        minute: '2-digit'
    };
    // Only a non-empty STRING counts, so a registry without localizedDate keeps
    // the old browser-locale output.
    const dayOut = el ? el.call('localizedDate', d, dayOpts) : '';
    const timeOut = el ? el.call('localizedDate', d, timeOpts) : '';
    const day = typeof dayOut === 'string' && dayOut ? dayOut : d.toLocaleDateString(undefined, dayOpts);
    const time = typeof timeOut === 'string' && timeOut ? timeOut : d.toLocaleTimeString(undefined, timeOpts);
    return `${day}, ${time}`;
}
const $35d02ea279bb9511$export$883b5bdcd2062f38 = (e)=>typeof e === 'string' ? e.toLowerCase().trim() : null;
const $35d02ea279bb9511$export$3f63fab750bb9bd5 = (emails, me)=>{
    const meNorm = $35d02ea279bb9511$export$883b5bdcd2062f38(me);
    const out = [];
    const seen = new Set();
    for (const e of emails || []){
        const n = $35d02ea279bb9511$export$883b5bdcd2062f38(e);
        if (!n || n === meNorm || seen.has(n)) continue;
        seen.add(n);
        out.push(n);
    }
    return out;
};
const $35d02ea279bb9511$export$1dfea6fac2db654d = (fetched, local)=>{
    const out = [
        ...Array.isArray(fetched) ? fetched : []
    ];
    const ids = new Set(out.map((c)=>c && c.id).filter(Boolean));
    for (const c of local || []){
        if (!c || !c.id || ids.has(c.id)) continue;
        ids.add(c.id);
        out.push(c);
    }
    return out;
};
const $35d02ea279bb9511$export$59f7582a4568c648 = (fetched, local)=>{
    const out = [
        ...Array.isArray(fetched) ? fetched : []
    ];
    const key = (m)=>`${m && m.channel_id}\x00${$35d02ea279bb9511$export$883b5bdcd2062f38(m && m.member_email) || ''}`;
    const seen = new Set(out.map(key));
    for (const m of local || []){
        if (!m || !m.channel_id || !m.member_email) continue;
        const k = key(m);
        if (seen.has(k)) continue;
        seen.add(k);
        out.push(m);
    }
    return out;
};
const $35d02ea279bb9511$export$2324ba16057d4458 = (r)=>({
        id: r.id,
        kind: r.kind,
        name: r.name,
        topic: r.topic,
        // Carry workspace_id through so consumers can strictly scope the
        // channel list to the active workspace. The chat_channels RLS
        // predicate is `(workspace_id = jwt_active_workspace()) OR
        // jwt_is_channel_member(id)` — that second clause means a user who
        // was added as a member of a Symbols-org channel still sees it when
        // their active org is "Personal". Surface workspace_id so the
        // workspace UI can filter strictly: only show channels that BELONG
        // to the active workspace, matching the user's mental model.
        workspaceId: r.workspace_id,
        // CHAT-AGENT-CONNECT (migration 0147) — when set, this channel is wired to
        // an assistant agent (e.g. simone-agent@symbols.app). The server-side
        // ChatAgentSubscriber replies in-thread on @simone/@simona mention or
        // thread-reply; the UI uses it to surface the agent as a channel
        // participant (mention highlight + author name).
        agentEmail: r.agent_email || null,
        isPrivate: !!r.is_private,
        isArchived: !!r.is_archived,
        createdBy: r.created_by,
        createdAt: r.created_at,
        updatedAt: r.updated_at
    });
const $35d02ea279bb9511$export$5938f438d03c904a = (channels, activeWorkspaceId)=>{
    const list = Array.isArray(channels) ? channels : [];
    if (!activeWorkspaceId) return list;
    return list.filter((c)=>!c.workspaceId || c.workspaceId === activeWorkspaceId);
};
const $35d02ea279bb9511$export$8d80f3967f6fbe23 = (channel, { isMember: isMember, activeWorkspaceId: activeWorkspaceId } = {})=>{
    if (!channel || channel.kind !== 'channel') return false;
    if (isMember) return true;
    if (channel.isPrivate) return false;
    if (!activeWorkspaceId) return false;
    return String(channel.workspaceId || '') === String(activeWorkspaceId);
};
const $35d02ea279bb9511$export$acb9fd9c5a541324 = (messages, lastReadAt, currentUserEmail)=>{
    if (!Array.isArray(messages) || !messages.length) return 0;
    const cutoff = lastReadAt ? new Date(lastReadAt).getTime() : 0;
    let n = 0;
    for (const m of messages){
        if (m.deleted) continue;
        if (m.authorEmail === currentUserEmail) continue;
        const t = m.createdAt ? new Date(m.createdAt).getTime() : 0;
        if (t > cutoff) n++;
    }
    return n;
};
// Per-(channelMembers identity, me) cache of the set of muted channel ids.
// Invalidates automatically when channelMembers is replaced (which happens
// on every realtime upsert). Drastically cuts the cost of `_isMuted` calls
// on every sidebar row during render.
const $35d02ea279bb9511$var$_mutedCache = new WeakMap();
const $35d02ea279bb9511$export$4d14912bb87de3de = (channelMembers, me)=>{
    if (!channelMembers || !me) return $35d02ea279bb9511$var$_EMPTY_SET;
    let cached = $35d02ea279bb9511$var$_mutedCache.get(channelMembers);
    if (cached && cached._me === me) return cached;
    const set = new Set();
    for (const m of channelMembers)if (m.member_email === me && m.muted) set.add(m.channel_id);
    set._me = me;
    $35d02ea279bb9511$var$_mutedCache.set(channelMembers, set);
    return set;
};
const $35d02ea279bb9511$var$_EMPTY_SET = new Set();
const $35d02ea279bb9511$export$27109ced7a4912bf = (channel, members, peopleByEmail, currentUserEmail, opts = {})=>{
    if (!channel) return '';
    // Returns a real name, or a polyglot KEY for a nameless conversation. Every
    // render site resolves the WHOLE returned string through polyglot, and
    // translate() passes a real name (and a '# ' prefix) through unchanged.
    if (channel.kind === 'channel') return channel.name || 'chat.channel.channelFallback';
    // Dedupe participants case-insensitively — legacy membership rows can hold
    // the same person under two casings, which rendered titles like
    // "Viktor, Viktor" (one human, twice). Same normalization the composer
    // paths use (normEmail), applied at display so polluted rows read right.
    const meNorm = $35d02ea279bb9511$export$883b5bdcd2062f38(currentUserEmail);
    const seenOthers = new Set();
    const others = (members || []).filter((m)=>{
        if (m.channel_id !== channel.id) return false;
        const n = $35d02ea279bb9511$export$883b5bdcd2062f38(m.member_email);
        if (!n || n === meNorm || seenOthers.has(n)) return false;
        seenOthers.add(n);
        return true;
    }).map((m)=>{
        const full = peopleByEmail[m.member_email]?.name || m.member_email;
        return opts.firstOnly ? (0, $76fm2.firstName)(full) : full;
    });
    if (channel.kind === 'dm') return others[0] || 'chat.channel.directMessage';
    return others.join(', ') || 'chat.channel.groupDm';
};
const $35d02ea279bb9511$export$7cc0f07baf5704c0 = (root)=>{
    if (!root) return 'chat.header.selectChannel';
    const activeId = root.activeChannelId;
    if (!activeId) return 'chat.header.selectChannel';
    const ch = (root.channels || []).find((c)=>c.id === activeId);
    if (!ch) return 'chat.channel.channelFallback';
    const prefix = ch.kind === 'channel' ? '# ' : '';
    return prefix + $35d02ea279bb9511$export$27109ced7a4912bf(ch, root.channelMembers || [], (0, $agSJI.chatPeopleByEmail)(root), root.currentUserEmail, {
        firstOnly: ch.kind === 'group_dm'
    });
};
const $35d02ea279bb9511$export$91073ceadef08af8 = (s)=>!!(s && s.root && s.authorEmail && s.authorEmail === s.root.currentUserEmail);
const $35d02ea279bb9511$export$ecc9bf92baa0765e = ()=>50;
const $35d02ea279bb9511$export$beef12433c48032 = (root, channelId)=>root && root.chatVisibleCounts && root.chatVisibleCounts[channelId] || $35d02ea279bb9511$export$ecc9bf92baa0765e();
const $35d02ea279bb9511$export$dae56bff0b3b70ef = (s)=>{
    if (!s || !s.replyTo || !s.root) return null;
    const cid = s.channelId || s.root.activeChannelId;
    const list = (s.root.messagesByChannel || {})[cid] || [];
    return list.find((m)=>m.id === s.replyTo) || null;
};
const $35d02ea279bb9511$export$537d31d9dca6025 = (s)=>{
    if (!s || !s.id || !s.root) return 0;
    const cid = s.channelId || s.root.activeChannelId;
    if (!cid) return parseInt(s.threadCount, 10) || 0;
    const list = (s.root.messagesByChannel || {})[cid] || [];
    return list.filter((m)=>m.threadRoot === s.id).length;
};
const $35d02ea279bb9511$export$b8669153b623644e = (root)=>{
    if (!root || !root.activeChannelId || !root.activeThreadRootId) return null;
    const list = (root.messagesByChannel || {})[root.activeChannelId] || [];
    return list.find((m)=>m.id === root.activeThreadRootId) || null;
};
const $35d02ea279bb9511$export$bfefe6fcbdd3de5f = (root, email)=>{
    if (!root || !email) return false;
    const target = String(email).toLowerCase();
    return (root.onlineUsers || []).some((u)=>u && u.email && String(u.email).toLowerCase() === target);
};
const $35d02ea279bb9511$export$5aef47f59364ae5e = (root, channelId)=>{
    if (!root || !channelId) return false;
    const onChatRoute = (0, $9juhh.stripWorkspacePrefix)(root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/')) === '/chat';
    return root.activeChannelId === channelId && (root._chatDrawerOpen || onChatRoute) && typeof document !== 'undefined' && document.hasFocus();
};
const $35d02ea279bb9511$export$252ce396742368b1 = (root, channelId)=>{
    const id = channelId ?? root?.activeChannelId;
    if (!root || !id) return 0;
    const seen = new Set();
    for (const m of root.channelMembers || [])if (m && m.channel_id === id && m.member_email) seen.add($35d02ea279bb9511$export$883b5bdcd2062f38(m.member_email));
    return seen.size;
};
const $35d02ea279bb9511$export$ea1437cd396932e7 = (root, channelId)=>{
    const id = channelId ?? root?.activeChannelId;
    const ch = id ? (root?.channels || []).find((c)=>c.id === id) : null;
    if (!ch) return null;
    const kind = ch.kind || 'channel';
    const people = (0, $agSJI.chatPeopleByEmail)(root);
    const title = $35d02ea279bb9511$export$27109ced7a4912bf(ch, root.channelMembers || [], people, root.currentUserEmail, {
        firstOnly: kind === 'group_dm'
    });
    const info = {
        id: id,
        kind: kind,
        title: title,
        isPrivate: !!(ch.is_private ?? ch.isPrivate),
        topic: String(ch.topic || '').trim()
    };
    if (kind === 'dm') {
        const me = $35d02ea279bb9511$export$883b5bdcd2062f38(root.currentUserEmail);
        const other = (root.channelMembers || []).find((m)=>m && m.channel_id === id && $35d02ea279bb9511$export$883b5bdcd2062f38(m.member_email) !== me);
        const email = other && other.member_email || null;
        const person = email && people[email] || null;
        info.partnerEmail = email;
        info.partnerName = person && person.name || title;
        info.partnerTitle = String(person && (person.title || person.jobTitle) || '').trim();
        info.online = $35d02ea279bb9511$export$bfefe6fcbdd3de5f(root, email);
    }
    return info;
};
const $35d02ea279bb9511$export$d17a2a6a3057011e = (root, channelId, max = 3)=>{
    const id = channelId ?? root?.activeChannelId;
    const ch = id ? (root?.channels || []).find((c)=>c.id === id) : null;
    if (!ch) return {
        count: 0,
        names: []
    };
    const byEmail = (0, $agSJI.chatPeopleByEmail)(root);
    const byId = new Map();
    for (const p of root.people || []){
        const uid = p && (p.user_id || p.userId);
        if (uid && !byId.has(uid)) byId.set(uid, p);
    }
    const seen = new Set();
    const names = [];
    for (const m of root.channelMembers || []){
        if (!m || m.channel_id !== id) continue;
        const uid = m.user_id || m.userId;
        const email = $35d02ea279bb9511$export$883b5bdcd2062f38(m.member_email);
        const key = uid ? `id:${uid}` : email;
        if (!key || seen.has(key)) continue;
        seen.add(key);
        const person = m.member_email && byEmail[m.member_email] || uid && byId.get(uid) || null;
        const name = person && person.name || email;
        if (names.length < max && name) names.push(name);
    }
    return {
        count: seen.size,
        names: names
    };
};
const $35d02ea279bb9511$export$fcba3e09a864d7e3 = [
    'all',
    'everyone'
];
const $35d02ea279bb9511$export$133488383f2a39b4 = 'chat.composer.broadcastCaption';
const $35d02ea279bb9511$var$_BROADCAST_MENTION_RE = new RegExp(`(?<=^|\\s)@(${$35d02ea279bb9511$export$fcba3e09a864d7e3.join('|')})\\b`, 'i');
const $35d02ea279bb9511$export$a4a631160e649b8f = (body)=>!!body && $35d02ea279bb9511$var$_BROADCAST_MENTION_RE.test(body);
const $35d02ea279bb9511$export$161fdbebd8545dcd = (root, channel)=>channel?.workspaceId || // The workspace the TAB is actually viewing — URL-derived (/w/<slug>),
    // written by bootShell's auth-snapshot resolution and replaced by the
    // in-app switch flow. Under the multi-tab model (MULTI_WORKSPACE_TABS.md)
    // this is the ONLY per-tab truth: both fallbacks below are process-global
    // mirrors of the SDK/claim context, which URL-based workspace browsing
    // never rotates — scoping against them stamped chat creates into (and
    // listed rows from) whatever workspace another session had active
    // (verified live 2026-07-22, /w/uhy tab creating DMs into bellforge).
    root?.workspace?.id || // Mirror of sdk._context.activeWorkspaceId, written by onWorkspaceChange
    // when an in-app switch resolves. Still outranks the JWT claim: the
    // federated re-mint is async/best-effort (and can never land while the
    // federation plane is down), so jwtClaims.active_workspace_id can point
    // at the PREVIOUS workspace indefinitely — scoping against it filtered
    // the NEW workspace's channels to zero (verified live 2026-07-13,
    // aihouse → Symbols Intranet switch).
    root?.activeWorkspaceId || root?.jwtClaims?.active_workspace_id || root?.org?.id || root?.jwtClaims?.workspace_org_id || null;
const $35d02ea279bb9511$export$ae08a3c846d5ef0 = (root)=>$35d02ea279bb9511$export$5938f438d03c904a(root?.channels || [], $35d02ea279bb9511$export$161fdbebd8545dcd(root));
const $35d02ea279bb9511$export$2e1b68a5a441fbbf = (root)=>new Set($35d02ea279bb9511$export$ae08a3c846d5ef0(root).map((c)=>c.id));
const $35d02ea279bb9511$export$6d886a352e03cb57 = (rows, root)=>{
    const list = Array.isArray(rows) ? rows : [];
    const activeWs = $35d02ea279bb9511$export$161fdbebd8545dcd(root);
    if (!activeWs) return list;
    const chIds = $35d02ea279bb9511$export$2e1b68a5a441fbbf(root);
    return list.filter((m)=>{
        if (m && m.workspace_id) return m.workspace_id === activeWs;
        return !m || !m.channel_id || chIds.size === 0 || chIds.has(m.channel_id);
    });
};
const $35d02ea279bb9511$export$91bec3f7661e339b = (root, row)=>{
    if (!row) return false;
    const activeWs = $35d02ea279bb9511$export$161fdbebd8545dcd(root);
    if (!activeWs) return true;
    const ws = row.workspace_id || row.workspaceId;
    if (ws) return ws === activeWs;
    const chId = row.channel_id || row.channelId;
    if (!chId) return true;
    const ch = (root?.channels || []).find((c)=>c.id === chId);
    if (!ch) return true;
    return !ch.workspaceId || ch.workspaceId === activeWs;
};
const $35d02ea279bb9511$export$587d95e3f07d1c9b = (root, external)=>{
    if (!root) return [];
    const me = root.currentUserEmail;
    const meNorm = $35d02ea279bb9511$export$883b5bdcd2062f38(me);
    const members = root.channelMembers || [];
    // Normalized so case-variant membership rows can't misclassify an internal
    // teammate as external (or split one person across two identities below).
    // Includes every person a member row names by user_id — without it a
    // non-manager (whose /people rows carry no peer email) filed EVERY DM with
    // a teammate under External People.
    const peopleEmails = new Set(Object.keys((0, $agSJI.chatPeopleByEmail)(root)).map($35d02ea279bb9511$export$883b5bdcd2062f38).filter(Boolean));
    // Scope DMs to the active workspace too — a DM under symbols workspace
    // shouldn't appear when the personal-org is active. Prefer the drift-
    // corrected `root.workspace.id` from bootShell._resolveAuthSnapshot
    // over the raw JWT claim: `jwtClaims.active_workspace_id` lags behind
    // `sdk.setActiveOrganization` and can point at a workspace in a previous
    // org (yielding zero matches and an empty DM list). Mirrors Sidebar.js's
    // `_activeWorkspaceId` — keep these two in sync.
    const activeWs = $35d02ea279bb9511$export$161fdbebd8545dcd(root);
    const scopedChannels = $35d02ea279bb9511$export$5938f438d03c904a(root.channels || [], activeWs);
    // Others are DISTINCT + case-normalized (distinctOthers): membership rows
    // can duplicate one person under two casings, and the raw list made the
    // same human count as two "others" — which split one person across two
    // sidebar rows (two DM rows for the same teammate; dragging one onto the
    // other then composed a bogus "group of the duplicated person") and
    // misflagged real 1:1s as group conversations below.
    const myChannelOthers = new Map();
    for (const ch of scopedChannels){
        if (ch.kind !== 'dm' && ch.kind !== 'group_dm') continue;
        const all = members.filter((m)=>m.channel_id === ch.id).map((m)=>m.member_email);
        if (!all.some((e)=>$35d02ea279bb9511$export$883b5bdcd2062f38(e) === meNorm)) continue;
        const others = $35d02ea279bb9511$export$3f63fab750bb9bd5(all, me);
        if (!others.length) continue;
        myChannelOthers.set(ch.id, others);
    }
    const seenIds = new Set();
    const seenMemberKeys = new Set();
    return scopedChannels.filter((c)=>{
        if (!myChannelOthers.has(c.id)) return false;
        if (seenIds.has(c.id)) return false;
        const others = myChannelOthers.get(c.id);
        const allInternal = others.every((e)=>peopleEmails.has(e));
        if (external ? allInternal : !allInternal) return false;
        const memberKey = others.slice().sort().join(',');
        if (seenMemberKeys.has(memberKey)) return false;
        seenIds.add(c.id);
        seenMemberKeys.add(memberKey);
        // A true 1:1 DM has exactly ONE distinct other member. A channel labelled
        // `dm` with 2+ others is really a group conversation (stale/wrong server
        // `kind`). `ChatDMRow` only renders the FIRST other member, so several
        // such channels that share a first member (e.g. me+imad+zajim,
        // me+imad+toko) all render as the same name → visible duplicates in
        // DIRECT MESSAGES. Normalize them to group_dm so they render once each in
        // GROUPS instead. Idempotent (only dm→group_dm, never the reverse).
        if (c.kind === 'dm' && others.length > 1) c.kind = 'group_dm';
        return true;
    });
};
const $35d02ea279bb9511$export$627f9f087e713f27 = (messages)=>{
    const keyOf = (m)=>Number.isFinite(m?.createdAtTimestamp) ? m.createdAtTimestamp : Date.parse(m?.createdAt) || 0;
    return (Array.isArray(messages) ? messages.slice() : []).sort((a, b)=>keyOf(a) - keyOf(b) || String(a?.id || '').localeCompare(String(b?.id || '')));
};
const $35d02ea279bb9511$export$84dfb2cbb0c7c57 = (root, channelId, next, issuedFor)=>{
    if (!root || !channelId) return false;
    if (issuedFor !== undefined && (0, $kUU0b.wsIdOf)(root) !== issuedFor) return false;
    // Lazily materialise the nested store before the first per-channel write
    // (realtime can fire before the bulk fetch resolves). One container write,
    // then only per-channel mutations from here on.
    if (!root.messagesByChannel) root.update({
        messagesByChannel: {}
    });
    // Non-arrays pass through untouched. MessageList reads `undefined` as "no
    // history read has landed for this channel yet" (LoadingBubbles) and `[]`
    // as "a read landed with no rows" (Empty) — coercing one into the other
    // here would swap the skeletons for a premature "No messages yet".
    root.messagesByChannel[channelId] = Array.isArray(next) ? $35d02ea279bb9511$export$627f9f087e713f27(next) : next;
    return true;
};
const $35d02ea279bb9511$export$c959ab96465e5a6d = ()=>200;
const $35d02ea279bb9511$export$b2e980ae119aa802 = (list)=>Array.isArray(list) && list.some((m)=>!!m && !m._live);
const $35d02ea279bb9511$export$ef54f1d4dff851a1 = (current, fetched)=>{
    const keyOf = (m)=>Number.isFinite(m?.createdAtTimestamp) ? m.createdAtTimestamp : Date.parse(m?.createdAt) || 0;
    const idOf = (m)=>String(m && m.id);
    const page = (Array.isArray(fetched) ? fetched : []).filter((m)=>m && m.id != null);
    const cur = (Array.isArray(current) ? current : []).filter(Boolean);
    const pageIds = new Set(page.map(idOf));
    const history = cur.filter((m)=>!m._live);
    let keepHistory = true;
    if (page.length && history.length && !history.some((m)=>pageIds.has(idOf(m)))) {
        const newest = (list)=>list.reduce((n, m)=>Math.max(n, keyOf(m)), -Infinity);
        const oldest = (list)=>list.reduce((n, m)=>Math.min(n, keyOf(m)), Infinity);
        const full = $35d02ea279bb9511$export$c959ab96465e5a6d();
        if (newest(page) < oldest(history) && page.length >= full) return $35d02ea279bb9511$export$627f9f087e713f27(cur);
        if (newest(history) < oldest(page) && history.length >= full) keepHistory = false;
    }
    const kept = cur.filter((m)=>!pageIds.has(idOf(m)) && (keepHistory || m._live));
    return $35d02ea279bb9511$export$627f9f087e713f27([
        ...page,
        ...kept
    ]);
};
const $35d02ea279bb9511$export$f83c6d21d3aa58ae = (current, buckets)=>{
    const cur = current && typeof current === 'object' ? current : {};
    const out = {};
    for (const k of Object.keys(cur))out[k] = cur[k];
    for (const k of Object.keys(buckets || {}))out[k] = $35d02ea279bb9511$export$ef54f1d4dff851a1(cur[k], buckets[k]);
    return out;
};
const $35d02ea279bb9511$export$fc3095a8dd99abb6 = (root, channelId, issuedFor)=>{
    if (!root || !channelId || !root.messagesByChannel) return false;
    if (issuedFor !== undefined && (0, $kUU0b.wsIdOf)(root) !== issuedFor) return false;
    delete root.messagesByChannel[channelId];
    return true;
};
const $35d02ea279bb9511$export$6e0f5ca138042cea = (messages = [], opts = {})=>{
    const FIVE_MIN = 300000;
    const win = opts && opts.newFrom;
    const from = win && win.from != null ? new Date(win.from).getTime() : null;
    const until = win && win.until != null ? new Date(win.until).getTime() : Infinity;
    const meNorm = opts && opts.me ? $35d02ea279bb9511$export$883b5bdcd2062f38(opts.me) : null;
    let marked = false;
    let lastAuthor = null;
    let lastTime = 0;
    let lastDay = null;
    return messages.map((m)=>{
        const t = new Date(m.createdAt).getTime();
        const day = (0, $6RzDA.localDate)(new Date(m.createdAt));
        const newDay = day !== lastDay;
        const firstNew = !marked && from != null && t > from && t <= until && $35d02ea279bb9511$export$883b5bdcd2062f38(m.authorEmail) !== meNorm;
        if (firstNew) marked = true;
        const grouped = !newDay && !firstNew && m.authorEmail === lastAuthor && t - lastTime < FIVE_MIN;
        lastAuthor = m.authorEmail;
        lastTime = t;
        lastDay = day;
        return {
            ...m,
            _grouped: grouped,
            _newDay: newDay,
            _day: day,
            _firstNew: firstNew
        };
    });
};

});
parcelRegister("6RzDA", function(module, exports) {

$parcel$export(module.exports, "pad2", () => $4ff35633c9dad41b$export$9decc9dc70e2c76f);
$parcel$export(module.exports, "localDate", () => $4ff35633c9dad41b$export$d30d8547ed0ef255);
$parcel$export(module.exports, "localTime", () => $4ff35633c9dad41b$export$f0dfd716e7b023cd);
$parcel$export(module.exports, "todayISO", () => $4ff35633c9dad41b$export$424906fec691dc17);
$parcel$export(module.exports, "dayLabel", () => $4ff35633c9dad41b$export$fed04f446fd15195);
$parcel$export(module.exports, "clockTime", () => $4ff35633c9dad41b$export$f9a26c3ca99aeecf);
$parcel$export(module.exports, "shortDate", () => $4ff35633c9dad41b$export$26e685d98fdeb12f);
// FA204/FA207 / frank trap — `pad2` (a sibling export) and `_tzParts` (a
// module-scope helper backed by a module-scope memoization `Map`) were both
// read bare from other exports' own bodies: unresolvable once this file's
// exports are individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers; readerVoice.js precedent). Both
// are now self-contained locals per consumer. The per-timezone
// Intl.DateTimeFormat memoization is DROPPED rather than re-homed (there's no
// el/root argument anywhere in this file to hoist a shared cache onto, and a
// stale/undefined cache here would throw — `_tzPartsCache.get` on
// `undefined` — not just degrade quietly, unlike the documented
// _wsHandleResolver-style exceptions elsewhere in this sweep) — each call
// constructs its own formatter; correctness is unaffected, only the
// cross-call memoization is lost.
const $4ff35633c9dad41b$export$9decc9dc70e2c76f = (n)=>String(n).padStart(2, '0');
const $4ff35633c9dad41b$export$d30d8547ed0ef255 = (d, tz)=>{
    const pad = (n)=>String(n).padStart(2, '0');
    if (!tz) return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const tzParts = (date, timeZone)=>{
        const fmt = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        const parts = {};
        for (const p of fmt.formatToParts(date))if (p.type !== 'literal') parts[p.type] = p.value;
        // Intl returns '24' for midnight in some locales — normalize to '00'.
        if (parts.hour === '24') parts.hour = '00';
        return parts;
    };
    const p = tzParts(d, tz);
    return `${p.year}-${p.month}-${p.day}`;
};
const $4ff35633c9dad41b$export$f0dfd716e7b023cd = (d, tz)=>{
    const pad = (n)=>String(n).padStart(2, '0');
    if (!tz) return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
    const tzParts = (date, timeZone)=>{
        const fmt = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        const parts = {};
        for (const p of fmt.formatToParts(date))if (p.type !== 'literal') parts[p.type] = p.value;
        if (parts.hour === '24') parts.hour = '00';
        return parts;
    };
    const p = tzParts(d, tz);
    return `${p.hour}:${p.minute}`;
};
const $4ff35633c9dad41b$export$424906fec691dc17 = ()=>{
    const local = (d)=>`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return local(new Date());
};
function $4ff35633c9dad41b$export$fed04f446fd15195(iso) {
    const el = this && typeof this.call === 'function' ? this : null;
    const word = (key, fallback)=>{
        const text = el ? el.call('polyglot', key) : null;
        return text && text !== key ? text : fallback;
    };
    const local = (d)=>`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const d = new Date(iso);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    if (local(d) === local(today)) return word('common.time.today', 'Today');
    if (local(d) === local(yesterday)) return word('common.time.yesterday', 'Yesterday');
    const opts = {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
    };
    // Only a non-empty STRING counts: a registry without localizedDate (a
    // standalone surface, a test stub that echoes its argument) keeps the old
    // browser-locale output rather than painting nothing, or a Date.
    const out = el ? el.call('localizedDate', d, opts) : '';
    return typeof out === 'string' && out ? out : d.toLocaleDateString(undefined, opts);
}
function $4ff35633c9dad41b$export$f9a26c3ca99aeecf(ts) {
    const el = this && typeof this.call === 'function' ? this : null;
    const d = new Date(ts);
    const opts = {
        hour: '2-digit',
        minute: '2-digit'
    };
    const out = el ? el.call('localizedDate', d, opts) : '';
    return typeof out === 'string' && out ? out : d.toLocaleTimeString(undefined, opts);
}
function $4ff35633c9dad41b$export$26e685d98fdeb12f(value) {
    const el = this && typeof this.call === 'function' ? this : null;
    if (!value) return '';
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const opts = {
        month: 'short',
        day: 'numeric'
    };
    if (d.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
    const out = el ? el.call('localizedDate', d, opts) : '';
    return typeof out === 'string' && out ? out : d.toLocaleDateString(undefined, opts);
}

});

parcelRegister("kUU0b", function(module, exports) {

$parcel$export(module.exports, "wsIdOf", () => $f3a47a6c06e2a25b$export$2f030010e0ef3300);
$parcel$export(module.exports, "sameWorkspaceWriter", () => $f3a47a6c06e2a25b$export$a8d9ac2d63d85b3b);
// CHAT-LATE-WRITES-NO-TENANT-GUARD-1 — the chat package's copy of the canonical
// "drop a reply that outlived its tenant" writer.
//
// WHY CHAT NEEDED ONE AT ALL. Registering a key as workspace-scoped (the
// shell's state-app.js) wipes it ON the switch. It cannot stop a request
// ISSUED in workspace A from writing its reply into workspace B afterwards.
// Chat is the package with the most of those: every channel loader, every
// membership mutation, every message send and every attachment upload writes
// a workspace-scoped key AFTER an `await`. Before this module the package had
// zero guards, so a switch mid-upload left `{ [A-channelId]: [] }` sitting in
// workspace B's `pendingAttachments`, and a slow channel fetch repopulated B's
// sidebar with A's channels.
//
// DROPPING is right rather than rerouting or retrying: the payload describes a
// workspace the user is no longer looking at, and PHASE-1 of the switch has
// already restored the correct empty for the one they are.
//
// ⛔ CAPTURE BEFORE THE AWAIT. `sameWorkspaceWriter(root)` must be called on
// the SAME tick as the request, before the first `await` — it snapshots the
// workspace id at call time. Calling it inside the `.then()` snapshots the NEW
// workspace and the guard can never fire.
//
// ⛔ TWO SHAPES, ONE PRIMITIVE. Most chat writes are patches, so they take
// `sameWorkspaceWriter(root)` and call `_write({...})`. `messagesByChannel` is
// NOT written as a patch — `chatUtils.setChannelMessages` assigns the nested
// per-channel key directly so one channel's arrival does not re-fire every
// other channel's subscribers. Those call sites capture `wsIdOf(root)` before
// the await instead and hand the token to `setChannelMessages` /
// `deleteChannelMessages`, which do the same comparison this file's writer
// does. Same module, same snapshot rule, one comparison per shape.
//
// ⛔ WHY THIS FILE EXISTS THREE TIMES. The shell owns the canonical copy at
// workspace/functions/sameWorkspaceWriter.js and `tickets` keeps a second one.
// `chat` is a SUB-APP and must not import the shell either, so it keeps this
// third one, held byte-identical below the comments by
// __tests__/chatLateWriteTenantScope.test.js's drift pin (it strips comments
// and compares code, so documenting each copy in its own words is not a
// drift). Consumers inside this package import THIS module — never re-inline it.
// Both id shapes are live on root: `workspace.id` from the SDK's workspace
// payload and `workspace._id` from the raw Mongo document. Stringified so a
// numeric id and its string form never read as two different tenants.
const $f3a47a6c06e2a25b$export$2f030010e0ef3300 = (root)=>String(root?.workspace?.id || root?.workspace?._id || '');
const $f3a47a6c06e2a25b$export$a8d9ac2d63d85b3b = (root)=>{
    // Keep the registered function self-contained when Frank revives its source.
    const idOf = (state)=>String(state?.workspace?.id || state?.workspace?._id || '');
    const issuedFor = idOf(root);
    return (patch)=>{
        if (idOf(root) !== issuedFor) return false;
        root.update(patch);
        return true;
    };
};

});

parcelRegister("agSJI", function(module, exports) {

$parcel$export(module.exports, "chatEmailByUserId", () => $77a5db860dac5112$export$81729baab2995a75);
$parcel$export(module.exports, "chatPeopleByEmail", () => $77a5db860dac5112$export$a4998190edec84db);
$parcel$export(module.exports, "chatFindPerson", () => $77a5db860dac5112$export$4e88cc14d74634ee);
$parcel$export(module.exports, "withChatEmails", () => $77a5db860dac5112$export$8f485af5a3ef99);
$parcel$export(module.exports, "chatServerKnowsUserIds", () => $77a5db860dac5112$export$7f8ddc1d20ed7ff6);
$parcel$export(module.exports, "chatPickablePeople", () => $77a5db860dac5112$export$dff1c7e0c2b68556);
$parcel$export(module.exports, "chatPersonKey", () => $77a5db860dac5112$export$7562857a79b0f8cb);
$parcel$export(module.exports, "splitChatPersonKeys", () => $77a5db860dac5112$export$f947c155aa7c9593);
// Chat ↔ people identity bridge.
//
// /people answers a NON-MANAGER its peers WITHOUT email — the server's
// reduced projection (PeopleService, 2026-08-14) carries user_id + name +
// avatar only; the caller's own row stays full. Chat is keyed by email
// (member_email, author_email), so for an editor, an SMM or a client every
// peer was nameless: authors rendered as raw emails, the channel / DM pickers
// had nobody to pick, and @mentions inserted a display name the server could
// never resolve. A manager gets full rows and never sees any of it.
//
// The server stamps chat member rows with `user_id` (the /people id form).
// These functions join the two: a person's email comes from the member rows
// the caller can already read, and a person known only by id is picked as
// `uid:<id>` and resolved server-side (member_user_ids on create, user_id on
// add — restricted to members of the workspace).
//
// Each function is self-contained (frank serializes them one by one); the
// per-root cache follows peopleUtils' `root.__peopleUtilsCache` pattern.
// user id → member email, from root.channelMembers rows that carry user_id.
// Memoized per channelMembers array (every write replaces the array).
function $77a5db860dac5112$export$81729baab2995a75(root) {
    const rows = root && root.channelMembers;
    if (!Array.isArray(rows) || !rows.length) return new Map();
    let bag = root.__chatPeopleCache;
    if (!bag || typeof bag.get !== 'function') {
        bag = new WeakMap();
        try {
            root.__chatPeopleCache = bag;
        } catch (_) {}
    }
    let map = bag.get(rows);
    if (map) return map;
    map = new Map();
    for (const r of rows)if (r && r.user_id != null && r.member_email) map.set(String(r.user_id), String(r.member_email).trim().toLowerCase());
    bag.set(rows, map);
    return map;
}
function $77a5db860dac5112$export$a4998190edec84db(root) {
    const r = root && typeof root === 'object' && ('people' in root || 'channelMembers' in root) ? root : this && this.state && this.state.root;
    if (!r) return {};
    const people = Array.isArray(r.people) ? r.people : [];
    const rows = Array.isArray(r.channelMembers) ? r.channelMembers : [];
    let bag = r.__chatPeopleCache;
    if (!bag || typeof bag.get !== 'function') {
        bag = new WeakMap();
        try {
            r.__chatPeopleCache = bag;
        } catch (_) {}
    }
    const hit = bag.get(people);
    if (hit && hit.rows === rows) return hit.map;
    const map = Object.create(null);
    const byId = new Map();
    for (const p of people){
        if (!p) continue;
        if (p.email) map[String(p.email).trim().toLowerCase()] = p;
        const id = p.userId ?? p.user_id;
        if (id != null && id !== '') byId.set(String(id), p);
    }
    for (const m of rows){
        if (!m || m.user_id == null || !m.member_email) continue;
        const email = String(m.member_email).trim().toLowerCase();
        if (map[email]) continue;
        const p = byId.get(String(m.user_id));
        if (p) map[email] = p.email ? p : {
            ...p,
            email: email
        };
    }
    bag.set(people, {
        rows: rows,
        map: map
    });
    return map;
}
function $77a5db860dac5112$export$4e88cc14d74634ee(rootOrEmail, maybeEmail) {
    const bare = typeof rootOrEmail === 'string' && maybeEmail === undefined;
    const root = bare ? this && this.state && this.state.root : rootOrEmail;
    const email = bare ? rootOrEmail : maybeEmail;
    if (!root || !email) return null;
    let p = null;
    try {
        p = this && typeof this.call === 'function' ? this.call('findPerson', root, email) : null;
    } catch (_) {
        p = null;
    }
    if (p) return p;
    const map = this && typeof this.call === 'function' ? this.call('chatPeopleByEmail', root) : $77a5db860dac5112$export$a4998190edec84db(root);
    return map && map[String(email).trim().toLowerCase()] || null;
}
function $77a5db860dac5112$export$8f485af5a3ef99(root, people) {
    const list = Array.isArray(people) ? people : [];
    const rows = root && root.channelMembers;
    if (!Array.isArray(rows) || !rows.length) return list;
    const byId = new Map();
    for (const r of rows)if (r && r.user_id != null && r.member_email) byId.set(String(r.user_id), String(r.member_email).trim().toLowerCase());
    if (!byId.size) return list;
    return list.map((p)=>{
        if (!p || p.email) return p;
        const id = p.userId ?? p.user_id;
        const email = id != null ? byId.get(String(id)) : null;
        return email ? {
            ...p,
            email: email
        } : p;
    });
}
function $77a5db860dac5112$export$7f8ddc1d20ed7ff6(root) {
    const rows = root && root.channelMembers;
    if (!Array.isArray(rows)) return false;
    for (const r of rows)if (r && r.user_id != null) return true;
    return false;
}
function $77a5db860dac5112$export$dff1c7e0c2b68556(root) {
    const r = root || this && this.state && this.state.root;
    if (!r) return [];
    const base = this && typeof this.call === 'function' ? this.call('activeMembers', r) : r.people || [];
    const me = r.currentUserEmail ? String(r.currentUserEmail).trim().toLowerCase() : null;
    const rows = Array.isArray(r.channelMembers) ? r.channelMembers : [];
    const byId = new Map();
    let knowsIds = false;
    for (const m of rows)if (m && m.user_id != null) {
        knowsIds = true;
        if (m.member_email) byId.set(String(m.user_id), String(m.member_email).trim().toLowerCase());
    }
    const out = [];
    for (const p of Array.isArray(base) ? base : []){
        if (!p) continue;
        const id = p.userId ?? p.user_id;
        const email = p.email ? String(p.email).trim().toLowerCase() : id != null ? byId.get(String(id)) : null;
        if (email && email === me) continue;
        if (email) out.push(p.email ? p : {
            ...p,
            email: email
        });
        else if (knowsIds && id != null && id !== '') out.push(p);
    }
    return out;
}
function $77a5db860dac5112$export$7562857a79b0f8cb(person) {
    if (!person) return null;
    if (person.email) return String(person.email).trim().toLowerCase();
    const id = person.userId ?? person.user_id;
    return id != null && id !== '' ? 'uid:' + String(id) : null;
}
function $77a5db860dac5112$export$f947c155aa7c9593(keys) {
    const emails = [];
    const userIds = [];
    for (const k of Array.isArray(keys) ? keys : []){
        if (!k) continue;
        const s = String(k);
        if (s.startsWith('uid:')) {
            const id = s.slice(4);
            if (id && !userIds.includes(id)) userIds.push(id);
        } else if (!emails.includes(s)) emails.push(s);
    }
    return {
        emails: emails,
        userIds: userIds
    };
}

});



parcelRegister("3mGlV", function(module, exports) {

$parcel$export(module.exports, "ProjectCard", () => $2734478bdfe08b32$export$bacf8f04493bf68c);
$parcel$export(module.exports, "EmptyProjectCard", () => $2734478bdfe08b32$export$17a0a903ba6ca90e);
// Generic project card — link tile used on /, /<owner> dashboards,
// and the home ProjectsSection. Routes to `/<owner>/<key>` for the
// product canvas; the "Open in Websites" shortcut on hover routes to
// `/studio/<owner>/<ws>/<key>`, the Websites board of the project's
// workspace.
//
// Inputs (DOMQL state):
//   s.owner       — string, org slug (preferred)
//   s.workspace   — object { slug, organization?: { slug } } (fallback shape
//                   that matches what sdk.getProjects returns)
//   s.key         — string, project key
//   s.name        — display name
//   s.description — short blurb
//   s.icon        — optional explicit icon URL (overrides screenshot)
//
// Empty-state sibling: `EmptyProjectCard` renders a dashed "+ Create
// your first project" placeholder when a workspace has no projects yet.
// Click invokes `el.call('openNewProjectPicker')` if registered;
// otherwise falls back to routing to `/add-app`.

var $eVQcI = parcelRequire("eVQcI");

var $kfa5L = parcelRequire("kfa5L");
const $2734478bdfe08b32$export$bacf8f04493bf68c = {
    // FA204 / frank trap — _gradientFor/_slugOf/_ownerOf/_wsSlugOf used to be
    // bare module-scope const/functions read from inside `background`/
    // `onClick` (serialized factories); they silently read as undefined once
    // this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Moved into `scope`,
    // called via `el.scope.<name>`; siblings call each other via `this.<name>`
    // (el.scope.foo() binds `this` to el.scope — object-literal properties
    // can't see each other as bare identifiers otherwise). EmptyProjectCard
    // below doesn't read any of these, so no duplication needed there.
    scope: {
        // `sdk.getProjects` returns `p.owner = { slug, id, type }` (an object),
        // so a naive `s.owner` would template-literal stringify to
        // "[object Object]" in the route URL. Always extract `.slug` from the
        // object shape; only fall back to the string-shaped tiers below.
        slugOf (v) {
            if (!v) return '';
            if (typeof v === 'string') return v;
            return v.slug || v.key || '';
        },
        ownerOf (s) {
            return this.slugOf(s?.owner) || this.slugOf(s?.workspace?.organization) || this.slugOf(s?.workspace) || '';
        },
        wsSlugOf (s) {
            return this.slugOf(s?.workspace) || this.slugOf(s?.workspaceSlug);
        }
    },
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: '0',
    // Same silhouette + plate as a /studio ProjectNode, so the two surfaces read
    // as one family: radiusControl, canvas-card-glass, the 1px `line` border that
    // is the studio family standard, and NO drop shadow (studios.js strips it too
    // — "flat tiles read cleaner", Nika 2026-06-05).
    round: 'radiusControl',
    theme: 'canvas-card-glass',
    border: '1px solid line',
    // `canvas-card-glass` ships a drop shadow; /studio strips it on its own
    // ProjectNode (studios.js: "flat tiles read cleaner against the dark
    // canvas") and the design direction budgets one shadow per screen. Measured
    // before this line: the card rendered `rgba(0,0,0,0.35) 0 4px 16px` while a
    // studio node rendered none — so separation comes from the `line` border and
    // the fill contrast, not from lift.
    boxShadow: 'none',
    overflow: 'hidden',
    cursor: 'pointer',
    textAlign: 'left',
    padding: '0',
    position: 'relative',
    // The card itself no longer lifts/changes border on hover. The hover
    // affordance lives on the poster (Cover) instead — it zooms slightly.
    ':hover > [data-studio-btn]': {
        opacity: '1'
    },
    ':hover > [data-cover]': {
        transform: 'scale(1.04)'
    },
    // Touch has no hover, and smbls e3333d298 gates every emitted `:hover` rule
    // behind `@media (hover: hover)` — so on a phone the Studio button would sit
    // at its rest opacity: 0 forever and the only route into a project's studio
    // from the card would be gone. Reveal it on coarse pointers. The Cover zoom
    // stays hover-only: it is decoration, not an affordance.
    '@coarse': {
        '> [data-studio-btn]': {
            opacity: '1'
        }
    },
    onClick: (e, el, s)=>{
        // Ignore clicks that came from the Studio button (which stops
        // propagation but we double-guard via the data attribute).
        if (e.target?.closest?.('[data-studio-btn]')) return;
        const owner = el.scope.ownerOf(s);
        const key = s.key;
        if (!owner || !key) return;
        el.router(`/${owner}/${key}`, el.getRoot());
    },
    Cover: {
        dataCover: true,
        aspectRatio: '16 / 9',
        width: '100%',
        // Rounded poster with a small gap below so all four corners read as
        // rounded; zoom on card hover (driven by the parent ':hover' rule).
        round: 'radiusControl',
        overflow: 'hidden',
        marginBottom: 'V',
        transition: '260ms defaultBezier transform',
        // THE FALLBACK UNDER THE PICTURE (Fly QA 2026-10-18, D6): the cover
        // screenshot 404s for most projects (screenshots.api.symbols.app — 6 of 7
        // probed) and the tile was a blank plate. The cover is now two layers: the
        // project's initials on the solid card plate, and OVER them the picture
        // (CoverShot). A picture that loads covers the initials; one that fails
        // paints nothing, so the initials show — no load event, no state.
        position: 'relative',
        display: 'flex',
        align: 'center center',
        background: 'cardSolid',
        CoverInitials: {
            tag: 'span',
            ariaHidden: 'true',
            fontSize: 'D',
            fontWeight: '700',
            lineHeight: '1',
            color: 'caption',
            text: (el, s)=>String(s && (s.name || s.key) || '').split(/[\s._-]+/).filter(Boolean).slice(0, 2).map((w)=>w.charAt(0).toUpperCase()).join('')
        },
        CoverShot: {
            position: 'absolute',
            inset: '0',
            background: (el, s)=>{
                const owner = el.scope.ownerOf(s);
                const key = s && s.key || '';
                if (s && s.icon) return `center / cover no-repeat url("${s.icon}")`;
                if (owner && key) return `url("${(0, $eVQcI.projectScreenshotUrl)({
                    owner: owner,
                    key: key
                })}") center / cover no-repeat`;
                return 'none';
            }
        }
    },
    Body: {
        flow: 'y',
        gap: 'V',
        padding: 'Z A',
        Name: {
            tag: 'h4',
            margin: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || s.key || el.call('polyglot', 'editor.project.untitled')
        },
        Desc: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.description || (s.key ? `/${s.key}` : '')
        }
    },
    // Hover-revealed shortcut to the Websites board (the /studio view). Lives
    // over the Cover (top-right) so it doesn't fight the Body layout.
    // THE APP SPLIT (docs/APP_SPLIT.md vocabulary): it read "Apps" — the HUB's
    // word (shell.app.studio, the navbar's) — on every website card (dev Fly
    // "Websites" list, 2026-10-21). It now names its own action, so the label
    // is also the button's accessible name and no tooltip repeats it. The old
    // aria-label and title were one-shot el.call reads that kept the boot
    // language after a switch; the label's template follows the language.
    StudioBtn: {
        tag: 'button',
        type: 'button',
        dataStudioBtn: true,
        position: 'absolute',
        top: 'Z',
        right: 'Z',
        padding: 'V Z',
        round: 'radiusControl',
        // Longhand on purpose: colour tokens inside the `border` shorthand are
        // not resolved (the shorthand token-resolution trap).
        // Reviewed (fixed-colour sweep): kept — this glass pill floats over the
        // Cover (an arbitrary screenshot or per-project gradient), so it needs a
        // guaranteed-contrast fixed scrim in both themes (case 1: control over
        // arbitrary imagery), like TutorialsRowItem's play-button backdrop.
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'white.18',
        background: 'black.55',
        color: 'white',
        fontSize: 'Y2',
        fontWeight: '700',
        cursor: 'pointer',
        opacity: '0',
        transition: '160ms defaultBezier opacity, 160ms defaultBezier background',
        ':hover': {
            background: 'black.78'
        },
        // Pressed: one more step of the same scrim (Rule 65).
        ':active': {
            background: 'black.92'
        },
        // It rests at opacity 0 and only the card's hover revealed it, so a
        // keyboard focus landed on nothing. The brand reset paints the ring.
        ':focus-visible': {
            opacity: '1'
        },
        flow: 'x',
        align: 'center',
        gap: 'V',
        Label: {
            tag: 'span',
            whiteSpace: 'nowrap',
            text: '{{ editor.project.openInWebsites | polyglot }}'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const owner = el.scope.ownerOf(s);
            const key = s.key;
            if (!owner) return;
            const wsSlug = el.scope.wsSlugOf(s);
            const parts = [
                '/studio',
                owner
            ];
            if (wsSlug) parts.push(wsSlug);
            if (key) parts.push(key);
            el.router(parts.join('/'), el.getRoot());
        }
    }
};
const $2734478bdfe08b32$export$17a0a903ba6ca90e = {
    // Same footprint as ProjectCard so it slots cleanly into the same
    // grid: Cover spans 16/9, Body sits below — no auto-stretch to the
    // full row height.
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: '0',
    round: 'radiusControl',
    border: 'hairline dashed line',
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    padding: '0',
    alignSelf: 'flex-start',
    color: 'caption',
    overflow: 'hidden',
    transition: '180ms defaultBezier border-color, 180ms defaultBezier color',
    ':hover': {
        borderColor: 'blue',
        color: 'title'
    },
    Cover: {
        aspectRatio: '16 / 9',
        width: '100%',
        // When the card carries a FIXED height (the home Projects widget's
        // AddCard pins 200px + overflow:hidden), a wide grid column makes
        // 16/9 of the width + the Body exceed the card — and the Body's
        // bottom padding got clipped. Let the cover compress (flexShrink +
        // minHeight 0) so the Body always fits; in unconstrained usage the
        // aspect ratio still wins.
        flexShrink: '1',
        minHeight: '0',
        flow: 'y',
        align: 'center center',
        gap: 'V',
        background: 'overlay',
        Plus: {
            width: 'B',
            height: 'B',
            round: '50%',
            align: 'center center',
            background: 'dialog',
            color: 'title',
            fontSize: 'B',
            fontWeight: '300',
            text: '+'
        }
    },
    Body: {
        flow: 'y',
        gap: 'V',
        padding: 'Z A',
        // Never clipped in fixed-height cards — the Cover above compresses
        // instead (see its flexShrink note).
        flexShrink: '0',
        Title: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: '{{ editor.project.createFirst | polyglot }}'
        },
        Hint: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            text: '{{ editor.project.inThisWorkspace | polyglot }}'
        }
    },
    // Open the NewProjectPickerBody @symbo.ls/windows modal — same shape as
    // the inline `openNewProjectPicker` helper in
    // canvas/components/StudioNavbar.js: seed a fresh `root.newProjectPicker`
    // carrier the body reads via s.root, then push the custom-template layer
    // in the shared ModalRoot. onClose (fires on X / backdrop / ESC /
    // closeModal) clears the carrier on any dismiss path.
    onClick: (e, el, s)=>{
        e.preventDefault();
        (0, $kfa5L.openNewProjectPickerModal)(el, s.root);
    }
};

});
parcelRegister("kfa5L", function(module, exports) {

$parcel$export(module.exports, "newProjectPickerState", () => $ebcd096e484661fe$export$97404c488a83b75e);
$parcel$export(module.exports, "openNewProjectPickerModal", () => $ebcd096e484661fe$export$23632f5335947ea0);
const $ebcd096e484661fe$export$97404c488a83b75e = (root, overrides = {})=>({
        open: true,
        tab: 'featured',
        templateId: 'blank',
        templateProject: null,
        projectType: 'website',
        ownerSlug: root?.userSlug || root?.activeWorkspace || root?.slug || null,
        name: '',
        creating: false,
        error: null,
        _libList: null,
        _libQuery: '',
        ...overrides
    });
const $ebcd096e484661fe$export$23632f5335947ea0 = (el, root, overrides)=>{
    const state = {
        open: true,
        tab: 'featured',
        templateId: 'blank',
        templateProject: null,
        projectType: 'website',
        ownerSlug: root?.userSlug || root?.activeWorkspace || root?.slug || null,
        name: '',
        creating: false,
        error: null,
        _libList: null,
        _libQuery: '',
        ...overrides
    };
    root?.update({
        newProjectPicker: state
    });
    // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
    // ('90vh'), which the raw `openModal({ template: 'custom' })` layer does
    // not — without it ModalWindow has no outer scroll containment and the
    // ModalHeader holding the Close X is pushed off-screen on a short viewport.
    el.call('openCustomModal', {
        id: 'newProjectPicker',
        width: '670px',
        content: {
            extends: 'NewProjectPickerBody'
        },
        onClose: ()=>root?.update({
                newProjectPicker: {
                    open: false
                }
            })
    });
};

});


parcelRegister("dq2gm", function(module, exports) {

$parcel$export(module.exports, "AnalyticsNavbar", () => $9c4f757495892b4a$export$c11f5d0fd4cb9c32);
// Primary tab strip for the merged analytics surface — exactly two
// pills, mirroring the App-Store-style segmented control:
//
//   Projects  → /analytics             (per-project / site visitor analytics
//                                       family: Overview + Map + Logs — the
//                                       secondary view strip lives in
//                                       AnalyticsHeader, not here)
//   Workspace → /workspace-analytics   (workspace usage dashboard)
//
// Family classification (2026-08-11 division per Nika "divide all ws
// specific analytics"): the geo MAP is visitor/project data → Projects
// wherever its URL lives; the LOGS diagnostic feed is workspace
// telemetry → Workspace wherever its URL lives (canonical
// /workspace-analytics/logs/*, plus the /analytics/logs/* and bare
// /logs aliases).
//
// Active state derives from `root.currentPath` (set by AppShell's
// locationchange patch) or `root._canvasSlot` (in-PageSlot mode), so
// clicks route through `el.router`/slot updates and the highlight
// follows reactively.

var $9juhh = parcelRequire("9juhh");
const $9c4f757495892b4a$export$c11f5d0fd4cb9c32 = {
    // FA204 / frank trap — TABS + activeKey used to be bare module-scope
    // const/function read from inside `Tabs.children` (a serialized factory);
    // they read as undefined once this component was frank.toJSON'd for
    // platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called
    // via `el.scope.<name>`.
    scope: {
        TABS: [
            {
                key: 'projects',
                label: 'editor.analyticsNavbar.projects',
                route: '/analytics'
            },
            {
                key: 'workspace',
                label: 'editor.analyticsNavbar.workspace',
                route: '/workspace-analytics'
            }
        ],
        activeKey (root) {
            // In the workspace's home PageSlot the URL stays on '/', so the active
            // route is the slot value; standalone analytics has it undefined and
            // falls back to the real path. Strip any `/w/<org-slug>` prefix so the
            // routes still classify under multi-workspace tabs (§6d).
            const path = (0, $9juhh.stripWorkspacePrefix)(root?._canvasSlot || root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/')).split('?')[0];
            // Logs classify under Workspace on every alias; the map stays a
            // Projects view even at its legacy /workspace-analytics/map URL.
            if (path.includes('/logs')) return 'workspace';
            if (path.startsWith('/workspace-analytics/map')) return 'projects';
            if (path === '/workspace-analytics' || path.startsWith('/workspace-analytics/')) return 'workspace';
            return 'projects';
        }
    },
    flow: 'x',
    align: 'center center',
    gap: 'V',
    padding: 'A B',
    // Chrome hairline under the tab strip (design-direction.md §8 /
    // DESIGN_LANGUAGE §2.5 — the exact PageHeader `borderBottomWidth: hairline`
    // pattern the doc names for retirement) — removed; the page content below
    // separates by its own surface, not a stroke here.
    Tabs: {
        flow: 'x',
        align: 'center',
        gap: 'V',
        padding: 'V',
        round: 'radiusPill',
        background: 'overlay',
        // Card-outline on top of an already-opaque `overlay` fill — the fill
        // alone separates the pill strip (same redundant-stroke pattern as
        // tickets/Cards.js's fix).
        // Re-run `children` when the route changes so each tab's state carries a
        // fresh `active` flag (see the note on childExtends below). `_canvasSlot`
        // is the in-PageSlot equivalent of a navigation.
        subscribeTo: [
            'currentPath',
            '_canvasSlot'
        ],
        childrenAs: 'state',
        // Resolve active ONCE per render and hand it to each child as state,
        // rather than having every child re-derive it from `s.root`.
        children: (el, s)=>{
            const active = el.scope.activeKey(s.root);
            return el.scope.TABS.map((t)=>({
                    ...t,
                    active: t.key === active
                }));
        },
        childExtends: {
            tag: 'button',
            type: 'button',
            attr: {
                role: 'tab'
            },
            minHeight: 'controlHCompact',
            padding: '0 Z',
            round: 'radiusPill',
            border: '0',
            cursor: 'pointer',
            fontSize: 'Z',
            fontWeight: '700',
            whiteSpace: 'nowrap',
            transition: '160ms defaultBezier background, 160ms defaultBezier color',
            // Active paint goes through the CONDITIONAL CLASS, not a style factory.
            // Measured 2026-08-08: with `background`/`color` as `(el, s) =>` factories
            // reading `s.root`, all tabs rendered byte-identical class lists with
            // NO background class at all — the factories evaluated once against a
            // childrenAs child and froze. The parent recomputes `active` into child
            // state AND the paint hangs off `.isActive`, so whichever mechanism the
            // runtime honours, the strip is correct.
            background: 'transparent',
            color: 'caption',
            isActive: (el, s)=>!!s.active,
            '.isActive': {
                background: 'selected',
                color: 'title'
            },
            ariaSelected: (el, s)=>s.active ? 'true' : 'false',
            ':hover': {
                color: 'title'
            },
            text: (el, s)=>el.call('polyglot', s.label || ''),
            onClick: (e, el, s)=>{
                e.preventDefault();
                if (s.active) return;
                // Inside the workspace's home AppWindow (PageSlot) swap the slot
                // content in-place — `el.router` would navigate to a full page and
                // leave the PageSlot, blanking the layout (2026-06-09 per Nika
                // "switching tabs should stay in PageSlot"). The slot routes are
                // registered in the workspace's _APP_WINDOW_PAGES.
                if (s.root?._canvasSlot) {
                    s.root.update({
                        _canvasSlot: s.route
                    });
                    return;
                }
                el.router(s.route, el.getRoot());
            }
        }
    }
};

});

parcelRegister("ddYOf", function(module, exports) {

$parcel$export(module.exports, "RemoteTableCard", () => $9a0ba8b99d03d041$export$2ee2600a87044e7e);
const $9a0ba8b99d03d041$export$2ee2600a87044e7e = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'V',
    padding: 'A',
    round: 'radiusControl',
    background: 'overlay',
    cursor: 'pointer',
    textAlign: 'left',
    // Fill-contrast hover (was a `borderColor: 'title'` swap on top of an
    // already-redundant `line` border — border-habit sweep, design-direction.md
    // §8). Uses the `hover` state token, NOT `overlayStrong`: §4.3/§8.1 makes
    // overlayStrong a sheet WASH, never a state fill — it inverted active states
    // on light — so states take `hover`/`selected`. The `designLanguageLocks`
    // `overlaystrong-as-state` rule enforces exactly this and caught the first
    // pass of this line.
    ':hover': {
        background: 'hover'
    },
    transition: 'background 150ms ease',
    onClick: (e, el, s)=>{
        const base = el.parent?.__remoteBasePath || '/data/external';
        const target = el.call('makeRemoteUrl', base, {
            slug: s.slug,
            table: s.name
        });
        const root = el.call('findRouteRoot', el) || el.getRoot();
        if (root) el.router(target, root);
    },
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.name
        },
        ColumnCount: {
            padding: 'V Z',
            round: 'radiusPill',
            background: 'overlayStrong',
            color: 'caption',
            fontSize: 'Y1',
            fontWeight: '700',
            text: (el, s)=>`${(s.columns || []).length} cols`
        }
    },
    ColumnPreview: {
        tag: 'p',
        fontSize: 'Y2',
        color: 'caption',
        margin: '0',
        lineHeight: '1.4',
        lineClamp: '2',
        text: (el, s)=>{
            const cols = s.columns || [];
            return cols.map((c)=>c.name).slice(0, 8).join(', ') + (cols.length > 8 ? "\u2026" : '');
        }
    }
};

});

parcelRegister("jnMI8", function(module, exports) {

$parcel$export(module.exports, "RemoteRowTr", () => $e1c5f34513552af6$export$35c07715d36a8b74);
$parcel$export(module.exports, "RemoteRowTable", () => $e1c5f34513552af6$export$80c6477bfcc96a9f);
// Paged, realtime-subscribed rows for one external Supabase table.
// Click a row to open RemoteRowEditor (update mode).
const $e1c5f34513552af6$export$35c07715d36a8b74 = {
    tag: 'tr',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        const { slug: slug, table: table } = el.call('parseRemotePath');
        const schema = el.call('schemaForRemoteTable', s.root, slug, table);
        const values = {};
        for (const c of schema?.columns || []){
            const v = s.__row?.[c.name];
            values[c.name] = v == null ? '' : typeof v === 'object' ? JSON.stringify(v) : String(v);
        }
        s.root.update({
            _extEditor: {
                mode: 'update',
                slug: slug,
                table: table,
                values: values,
                original: s.__row
            }
        });
    },
    childExtends: {
        tag: 'td',
        padding: 'Z',
        borderBottomWidth: 'hairline',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        fontSize: 'Y2',
        color: 'title',
        fontFamily: 'mono',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '320px',
        text: (el, s)=>{
            const v = s.value;
            if (v == null) return '';
            if (typeof v === 'string') return v;
            if (typeof v === 'object') return JSON.stringify(v);
            return String(v);
        }
    },
    childrenAs: 'state',
    children: (el, s)=>{
        const row = s.__row || {};
        return (s.__cols || []).map((c)=>({
                name: c.name,
                value: row[c.name]
            }));
    }
};
const $e1c5f34513552af6$export$80c6477bfcc96a9f = {
    overflow: 'auto',
    round: 'radiusControl',
    // Fill-contrast card (was a `line` border redundant on top of this same
    // `overlay` fill — border-habit sweep, design-direction.md §8). The inner
    // `<td>`/`<th>` dividers below are KEPT — dense-data-table exception,
    // §2.5, same as MembersTable.
    background: 'overlay',
    Inner: {
        tag: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: 'Y2',
        Head: {
            tag: 'thead',
            background: 'overlayStrong',
            Row: {
                tag: 'tr',
                childExtends: {
                    tag: 'th',
                    padding: 'Z',
                    textAlign: 'left',
                    color: 'caption',
                    fontWeight: '700',
                    letterSpacing: '.04em',
                    textTransform: 'uppercase',
                    fontSize: 'Y1',
                    borderBottomWidth: 'hairline',
                    borderBottomStyle: 'solid',
                    borderBottomColor: 'line',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.name
                },
                childrenAs: 'state',
                children: (el, s)=>{
                    const { slug: slug, table: table } = el.call('parseRemotePath');
                    if (!slug || !table) return [];
                    const schema = el.call('schemaForRemoteTable', s.root, slug, table);
                    return schema?.columns || [];
                }
            }
        },
        Body: {
            tag: 'tbody',
            childExtends: 'RemoteRowTr',
            childrenAs: 'state',
            children: (el, s)=>{
                const rows = s.root?._extRows || [];
                const { slug: slug, table: table } = el.call('parseRemotePath');
                const schema = el.call('schemaForRemoteTable', s.root, slug, table);
                const cols = schema?.columns || [];
                return rows.map((r, idx)=>({
                        __row: r,
                        __idx: idx,
                        __cols: cols
                    }));
            }
        }
    }
};

});

parcelRegister("2zb3W", function(module, exports) {

$parcel$export(module.exports, "RemoteRowField", () => $1de76e786b3874d2$export$2f1522e16b2052ef);
$parcel$export(module.exports, "RemoteRowEditor", () => $1de76e786b3874d2$export$fee7e3bc4d5737b4);
// Side-panel row editor (insert or update). Reads + writes
// `root._extEditor`. Save/delete flow through saveRemoteRow /
// deleteRemoteRow. Opens when `_extEditor` is non-null.
const $1de76e786b3874d2$export$2f1522e16b2052ef = {
    flow: 'y',
    gap: 'V',
    // FA204: read by the boolean choice's chips via `el.scope` — a module-scope
    // helper would read as undefined once frank serializes the component.
    scope: {
        boolValue (s) {
            const v = s.root?._extEditor?.values?.[s.fieldKey];
            if (v === true || v === 'true') return 'true';
            if (v === false || v === 'false') return 'false';
            return '';
        }
    },
    Label: {
        tag: 'label',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>{
            const col = s.col || {};
            const parts = [
                col.name
            ];
            if (col.is_primary_key) parts.push('(PK)');
            if (!col.nullable) parts.push('*');
            return parts.join(' ');
        }
    },
    TypeHint: {
        tag: 'span',
        fontSize: 'Y1',
        color: 'caption',
        text: (el, s)=>{
            const col = s.col || {};
            return col.format ? `${col.type} \xb7 ${col.format}` : col.type || '';
        }
    },
    Input: {
        hide: (el, s)=>{
            const col = s.col || {};
            return col.type === 'boolean' || col.format === 'jsonb' || col.format === 'json';
        },
        tag: 'input',
        type: 'text',
        width: '100%',
        theme: 'field',
        minHeight: 'controlH',
        round: 'radiusControl',
        color: 'title',
        fontFamily: 'mono',
        fontSize: 'Z2',
        padding: '0 A',
        disabled: (el, s)=>{
            const ed = s.root?._extEditor;
            const col = s.col || {};
            return ed?.mode === 'update' && col.is_primary_key;
        },
        placeholder: (el, s)=>{
            const col = s.col || {};
            if (col.format === 'uuid') return '00000000-0000-0000-0000-000000000000';
            if (col.format === 'date-time') return '2026-01-01T00:00:00Z';
            return col.nullable ? '(null)' : '';
        },
        value: (el, s)=>{
            const ed = s.root?._extEditor;
            return ed?.values?.[s.fieldKey] ?? '';
        },
        onInput: (e, el, s)=>{
            const ed = s.root?._extEditor;
            if (!ed) return;
            s.root.update({
                _extEditor: {
                    ...ed,
                    values: {
                        ...ed.values || {},
                        [s.fieldKey]: e.target.value
                    }
                }
            });
        }
    },
    // A boolean column is a 3-way CHOICE (empty / true / false), so it is a
    // segmented control, not a native select (brief §4.4, 2026-09-24). Its
    // value lives in the editor draft on root, so the chips carry that wiring;
    // the look is AppSegmented's (the brand TabSet with the D-1 inversion).
    AppSegmented: {
        hide: (el, s)=>s.col?.type !== 'boolean',
        ariaLabel: (el, s)=>s.col?.name || '',
        options: [
            {
                value: '',
                label: "\u2014"
            },
            {
                value: 'true',
                label: 'true'
            },
            {
                value: 'false',
                label: 'false'
            }
        ],
        childProps: {
            isActive: (el, s)=>el.scope.boolValue(s) === el.optionValue,
            ariaPressed: (el, s)=>el.scope.boolValue(s) === el.optionValue ? 'true' : 'false',
            onClick: (e, el, s)=>{
                const ed = s.root?._extEditor;
                if (!ed) return;
                s.root.update({
                    _extEditor: {
                        ...ed,
                        values: {
                            ...ed.values || {},
                            [s.fieldKey]: el.optionValue
                        }
                    }
                });
            }
        }
    },
    JsonArea: {
        hide: (el, s)=>{
            const col = s.col || {};
            return col.format !== 'jsonb' && col.format !== 'json';
        },
        tag: 'textarea',
        rows: '4',
        width: '100%',
        theme: 'field',
        minHeight: 'controlH',
        round: 'radiusControl',
        color: 'title',
        fontFamily: 'mono',
        fontSize: 'Y2',
        padding: 'Z',
        placeholder: '{} or []',
        value: (el, s)=>{
            const ed = s.root?._extEditor;
            return ed?.values?.[s.fieldKey] ?? '';
        },
        onInput: (e, el, s)=>{
            const ed = s.root?._extEditor;
            if (!ed) return;
            s.root.update({
                _extEditor: {
                    ...ed,
                    values: {
                        ...ed.values || {},
                        [s.fieldKey]: e.target.value
                    }
                }
            });
        }
    }
};
const $1de76e786b3874d2$export$fee7e3bc4d5737b4 = {
    hide: (el, s)=>!s.root?._extEditor,
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    background: 'scrim',
    zIndex: '100',
    align: 'flex-start flex-end',
    onClick: (e, el, s)=>{
        if (e.target === el.node) s.root.update({
            _extEditor: null
        });
    },
    Panel: {
        width: '520px',
        height: '100%',
        // Fill-contrast sheet (was a left-edge `line` border — border-habit
        // sweep, design-direction.md §8) — the panel's own opaque `document`
        // fill + `overlay` elevation shadow already separate it from the page.
        background: 'document',
        overflow: 'auto',
        flow: 'y',
        shadow: 'overlay',
        Header: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A',
            // Bottom divider removed (border-habit sweep, design-direction.md §8)
            // — padding + typographic hierarchy already separate Header from Body,
            // same precedent as AiActionConfirmCard.
            Title: {
                flow: 'y',
                gap: 'V',
                H2: {
                    tag: 'h2',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title',
                    margin: '0',
                    text: (el, s)=>el.call('polyglot', s.root?._extEditor?.mode === 'insert' ? 'editor.remote.newRow' : 'editor.remote.editRow')
                },
                Meta: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>{
                        const ed = s.root?._extEditor;
                        if (!ed) return '';
                        return `${ed.slug} \xb7 ${ed.table}`;
                    }
                }
            },
            // THE house close X (brand CloseButton — F2, one X for every panel).
            CloseBtn: {
                extends: 'CloseButton',
                onClick: (e, el, s)=>s.root.update({
                        _extEditor: null
                    })
            }
        },
        Body: {
            padding: 'A',
            flow: 'y',
            gap: 'Z1',
            Fields: {
                flow: 'y',
                gap: 'Z1',
                childExtends: 'RemoteRowField',
                childrenAs: 'state',
                children: (el, s)=>{
                    const ed = s.root?._extEditor;
                    if (!ed) return [];
                    const schema = el.call('schemaForRemoteTable', s.root, ed.slug, ed.table);
                    return (schema?.columns || []).map((c)=>({
                            col: c,
                            fieldKey: c.name
                        }));
                }
            }
        },
        Footer: {
            flow: 'x',
            align: 'center space-between',
            padding: 'A',
            gap: 'Z',
            // Top divider removed (border-habit sweep, design-direction.md §8) —
            // Footer's own `overlay` fill already separates it from Body.
            background: 'overlay',
            position: 'sticky',
            bottom: '0',
            DeleteBtn: {
                tag: 'button',
                type: 'button',
                hide: (el, s)=>s.root?._extEditor?.mode !== 'update',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                // Ghost fill (was transparent + `line` outline — the outlined-button
                // habit, border-habit sweep). Rest = overlay, hover = the danger
                // tint (§8.1 state matrix: danger → red ink, hover red.1).
                background: 'overlay',
                color: 'red',
                ':hover': {
                    background: 'red.1'
                },
                fontSize: 'Z2',
                cursor: 'pointer',
                text: '{{ editor.remote.deleteRow | polyglot }}',
                onClick: async (e, el, s)=>{
                    if (!window.confirm(el.call('polyglot', 'editor.remote.confirmDelete'))) return;
                    const res = await el.call('deleteRemoteRow', s.root);
                    if (res?.ok) el.call('openNotification', {
                        title: el.call('polyglot', 'editor.remote.rowDeleted'),
                        type: 'success'
                    });
                    else el.call('openNotification', {
                        title: el.call('polyglot', 'editor.remote.deleteFailed'),
                        message: res?.error,
                        type: 'error'
                    });
                }
            },
            Right: {
                flow: 'x',
                gap: 'Z',
                CancelBtn: {
                    tag: 'button',
                    type: 'button',
                    minHeight: 'controlH',
                    padding: '0 A',
                    round: 'radiusPill',
                    // Ghost fill (was transparent + `line` outline — the
                    // outlined-button habit, border-habit sweep). Rest = overlay,
                    // hover = the house hover wash.
                    background: 'overlay',
                    color: 'title',
                    ':hover': {
                        background: 'hover'
                    },
                    fontSize: 'Z2',
                    cursor: 'pointer',
                    text: '{{ common.action.cancel | polyglot }}',
                    onClick: (e, el, s)=>s.root.update({
                            _extEditor: null
                        })
                },
                SaveBtn: {
                    tag: 'button',
                    type: 'button',
                    minHeight: 'controlH',
                    padding: '0 A',
                    round: 'radiusPill',
                    // Reviewed (fixed-colour sweep): kept — fixed brand-accent CTA,
                    // mirrors CancelBtn's sibling (adaptive `title` on `overlay`);
                    // this button's own backing never adapts.
                    background: 'blue',
                    color: 'fillInk',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    cursor: 'pointer',
                    border: 'none',
                    text: (el, s)=>el.call('polyglot', s.root?._extEditorSaving ? 'common.state.saving' : 'common.action.save'),
                    onClick: async (e, el, s)=>{
                        const res = await el.call('saveRemoteRow', s.root);
                        if (res?.ok) el.call('openNotification', {
                            title: el.call('polyglot', 'common.state.saved'),
                            type: 'success'
                        });
                        else el.call('openNotification', {
                            title: el.call('polyglot', 'editor.remote.saveFailed'),
                            message: res?.error,
                            type: 'error'
                        });
                    }
                }
            }
        }
    }
};

});

parcelRegister("89Iq9", function(module, exports) {

$parcel$export(module.exports, "RemoteSchemaList", () => $5f019f0a7c056ce4$export$2c8c70ed7d513cd2);
// Tables grid for one external project. Click a card to view rows.
const $5f019f0a7c056ce4$export$2c8c70ed7d513cd2 = {
    hide: (el, s)=>{
        const p = el.call('parseRemotePath');
        return !p.slug || !!p.table;
    },
    flow: 'y',
    gap: 'A',
    LoadingState: {
        hide: (el, s)=>!s.root?._extSchemaLoading,
        padding: 'C',
        textAlign: 'center',
        color: 'caption',
        fontSize: 'Z2',
        text: '{{ editor.remote.introspecting | polyglot }}'
    },
    ErrorState: {
        hide: (el, s)=>!s.root?._extSchemaError,
        padding: 'A',
        round: 'radiusControl',
        background: 'overlayStrong',
        color: 'red',
        fontSize: 'Z2',
        text: (el, s)=>s.root?._extSchemaError || ''
    },
    TableGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: 'A',
        childExtends: 'RemoteTableCard',
        childrenAs: 'state',
        children: (el, s)=>{
            const { slug: slug } = el.call('parseRemotePath');
            if (!slug) return [];
            const tables = s.root?._extSchemaBySlug?.[slug] || [];
            return tables.map((t)=>({
                    ...t,
                    slug: slug
                }));
        }
    }
};

});

parcelRegister("7evUq", function(module, exports) {

$parcel$export(module.exports, "InstallableStateBadge", () => $544297b63606135a$export$a1963638b5b6d3da);
$parcel$export(module.exports, "InstallableRailChip", () => $544297b63606135a$export$f49870ed9d9a8efc);
$parcel$export(module.exports, "InstallableGridCard", () => $544297b63606135a$export$65df3c6c6153e22e);
$parcel$export(module.exports, "InstallableListRow", () => $544297b63606135a$export$6d7e9c530d199bbd);
$parcel$export(module.exports, "InstallableRailItem", () => $544297b63606135a$export$5902caf46b31d368);
// InstallableRailItem — one chip/card/row in an InstallableRail.
//
// State shape (set by parent via childrenAs:'state'):
//   display    { icon, label, tagline, color? }  — from IntegrationKind.display
//   installed  boolean                            — true when an instance exists
//   domain     string                             — 'integration'|'library'|'mcp'|…
//   kind       string                             — kind key, e.g. 'github'
//   _layout    'rail'|'grid'|'list'              — forwarded from parent
// ── Installed state badge ─────────────────────────────────────────────
const $544297b63606135a$export$a1963638b5b6d3da = {
    tag: 'span',
    padding: 'X2 Y2',
    round: 'radiusPill',
    fontSize: 'Y1',
    fontWeight: '700',
    letterSpacing: '0.04em',
    background: (el, s)=>s.installed ? 'green.1' : 'overlayStrong',
    color: (el, s)=>s.installed ? 'green' : 'caption',
    text: (el, s)=>el.call('polyglot', s.installed ? 'apps.rail.installed' : 'apps.rail.available')
};
const $544297b63606135a$export$f49870ed9d9a8efc = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'Y',
    align: 'center left',
    padding: 'Y Z',
    round: 'radiusControl',
    // Fill-contrast chip (was a `line` border — border-habit sweep,
    // design-direction.md §8) — the chip's own conditional background already
    // separates it from the rail.
    background: (el, s)=>s.installed ? 'overlayStrong' : 'document',
    cursor: 'pointer',
    flexShrink: '0',
    whiteSpace: 'nowrap',
    // A <button> centres its text by user-agent default; every variant of this
    // item pins it to the start edge (RTL-safe), so a wrapped line never centres.
    textAlign: 'start',
    transition: 'B defaultBezier',
    transitionProperty: 'background',
    // Brand language: hover is a FILL STEP on the neutral `hover` token. The
    // chip and the card washed `blue.1` while the list row stepped `hover` —
    // one family, two hover languages. Hue never marks a state in chrome.
    ':hover': {
        background: 'hover'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    Icon: {
        fontSize: 'B',
        name: (el, s)=>s.display?.icon || s.kind || 'grid',
        color: (el, s)=>s.display?.color || 'title'
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>s.display?.label || s.kind || ''
    },
    InstallableStateBadge: {
        hide: (el, s)=>!s.installed
    },
    onClick: (e, el, s)=>{
        el.call('openInstallableModal', {
            domain: s.domain,
            kind: s.kind,
            installed: s.installed,
            // Forwarded so openInstallableModal can resolve no-catalogue domains
            // (mcp) straight from the tile's own self-derived state instead of
            // guessing at the marketplace's global catalog (tickets/workspace.md
            // "installed-tile manage click resolves against the wrong catalog").
            display: s.display
        });
    }
};
const $544297b63606135a$export$65df3c6c6153e22e = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'Y',
    padding: 'Z Z2',
    round: 'radiusCard',
    // Fill-contrast card (was a `line` border — border-habit sweep,
    // design-direction.md §8) — the card's own `document` fill already
    // separates it from the grid's container.
    background: 'document',
    cursor: 'pointer',
    align: 'start left',
    // See InstallableRailChip: without this a WRAPPED tagline centres every
    // line (seen live on the "Postgres" card of the mcp grid).
    textAlign: 'start',
    transition: 'B defaultBezier',
    transitionProperty: 'background',
    ':hover': {
        background: 'hover'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    CardHeader: {
        flow: 'x',
        gap: 'Y',
        align: 'center space-between',
        width: '100%',
        Icon: {
            fontSize: 'C',
            name: (el, s)=>s.display?.icon || s.kind || 'grid',
            color: (el, s)=>s.display?.color || 'title'
        },
        InstallableStateBadge: {
            hide: (el, s)=>!s.installed
        }
    },
    CardBody: {
        flow: 'y',
        gap: 'X2',
        align: 'start left',
        CardLabel: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.display?.label || s.kind || ''
        },
        CardTagline: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            lineHeight: '1.4',
            overflow: 'hidden',
            text: (el, s)=>el.call('polyglot', s.display?.tagline || s.display?.description || '')
        }
    },
    onClick: (e, el, s)=>{
        el.call('openInstallableModal', {
            domain: s.domain,
            kind: s.kind,
            installed: s.installed,
            display: s.display
        });
    }
};
const $544297b63606135a$export$6d7e9c530d199bbd = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Y Z2',
    // Row divider removed (was a bottom `line` border — border-habit sweep,
    // design-direction.md §8; §2.5 house rule: row separators inside rounded
    // cards stay banned — hover tint alone carries the row boundary here).
    background: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'start',
    transition: 'B defaultBezier',
    transitionProperty: 'background',
    ':hover': {
        background: 'hover'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    Icon: {
        fontSize: 'B',
        name: (el, s)=>s.display?.icon || s.kind || 'grid',
        color: (el, s)=>s.display?.color || 'title',
        flexShrink: '0'
    },
    Info: {
        flow: 'y',
        gap: 'X2',
        flex: '1 1 0',
        minWidth: '0',
        RowLabel: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.display?.label || s.kind || ''
        },
        RowTagline: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            color: 'paragraph',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.call('polyglot', s.display?.tagline || s.display?.description || '')
        }
    },
    InstallableStateBadge: {
        flexShrink: '0'
    },
    ChevronIcon: {
        extends: 'Icon',
        name: 'arrow right',
        fontSize: 'Z2',
        color: 'caption',
        flexShrink: '0'
    },
    onClick: (e, el, s)=>{
        el.call('openInstallableModal', {
            domain: s.domain,
            kind: s.kind,
            installed: s.installed,
            display: s.display
        });
    }
};
const $544297b63606135a$export$5902caf46b31d368 = {
    InstallableRailChip: {
        hide: (el, s)=>s._layout !== 'rail',
        domain: (el, s)=>s.domain,
        kind: (el, s)=>s.kind,
        display: (el, s)=>s.display,
        installed: (el, s)=>s.installed
    },
    InstallableGridCard: {
        hide: (el, s)=>s._layout !== 'grid',
        domain: (el, s)=>s.domain,
        kind: (el, s)=>s.kind,
        display: (el, s)=>s.display,
        installed: (el, s)=>s.installed
    },
    InstallableListRow: {
        hide: (el, s)=>s._layout !== 'list',
        domain: (el, s)=>s.domain,
        kind: (el, s)=>s.kind,
        display: (el, s)=>s.display,
        installed: (el, s)=>s.installed
    }
};

});

parcelRegister("kbO9I", function(module, exports) {

$parcel$export(module.exports, "InstallableRailAddButton", () => $eb2bbd9581606dfd$export$f6295fff5648df5b);
$parcel$export(module.exports, "InstallableRailEmpty", () => $eb2bbd9581606dfd$export$949dbda2a48ca1b2);
$parcel$export(module.exports, "InstallableRailSkeleton", () => $eb2bbd9581606dfd$export$bd8eaac2c4a74596);
$parcel$export(module.exports, "InstallableRailHeader", () => $eb2bbd9581606dfd$export$93f1668b0294386b);
$parcel$export(module.exports, "InstallableRail", () => $eb2bbd9581606dfd$export$3e84008fc72231e4);
$parcel$export(module.exports, "__installableRailInternals", () => $eb2bbd9581606dfd$export$70edcaa19516c77);
// InstallableRail — generic catalog + instances rail/grid/list.
//
// Renders one of three layouts of installable items (integrations,
// libraries, MCP connectors, plugins, templates) for a given scopeType.
//
// Props (set on the RAIL element, at the mount site):
//   domain        – 'integration'|'library'|'mcp'|'plugin'|'template'
//   scopeType     – 'org'|'workspace'|'project'
//                   NOTE: `scope` is a DOMQL v3.14 reserved keyword (CSS-variable
//                   scope mixin). Always use `scopeType` for this prop.
//   scopeId       – active org / workspace / project id
//   heading       – rail header copy, a bundle KEY or prose (optional).
//                   NOT `title`: that is a global HTML attribute, so the
//                   framework writes it on the rail node and the browser
//                   shows it as a tooltip over the whole rail
//                   (docs/I18N-CONVENTION.md §1.2). `title` is still read as
//                   the back-compat fallback.
//   emptyHint     – empty-state CTA copy, a bundle KEY or prose (optional)
//   layout        – 'rail'|'grid'|'list'  (default: 'rail')
//   catalogFilter – { category?, applicable_to?, … } extra catalogue filter.
//                   NOT `filter`: that is a CSS property, so css-in-props
//                   takes it for a style. `filter` is still read as the
//                   back-compat fallback.
//   onAddClick    – optional hook before modal opens
//   onInstanceClick – optional manage-deeplink override
//
// HOW A DESCENDANT READS A MOUNT PROP — ONE mechanism: `scope.railProp`.
// A mount prop lives on the rail ELEMENT, never in state. A descendant finds
// its rail with the framework's own `el.lookup` (the rail marks itself with
// `isInstallableRail`) and reads the prop off it, at any depth. This file used
// to carry three mechanisms for the same four props — sixteen
// `el.parent?.parent?.domain` forwards, state reads that no host ever
// satisfied (so the header title NEVER rendered), and a fixed four-hop walk
// added on top of both. Pinned in
// __tests__/installableRailPropDelivery.test.js through the real renderer.
//
// Seed props (offline/demo hosts — see marketplace/pages/installable-rail-
// demo.js). When `seedKinds` is set the rail renders it and performs NO
// network read and NO poll: a demo surface must not depend on a live
// backend, and it must not depend on a FAILING one either.
//   seedKinds     – array of catalogue rows to display instead of fetching
//   seedInstances – array of instance rows (optional, defaults to [])
//
// STATE THIS COMPONENT OWNS (WS-RAIL-ROOT-STATE-HANG-1, 2026-09-20). The four
// load slots live in the rail's OWN element state, never at root:
//   railLoading    boolean
//   railError      string|null
//   railKinds      array of catalogue rows
//   railInstances  array of instance rows
// They used to be root keys prefixed `_installableRail_<domain>_<scopeType>_*`
// — the prefix existed ONLY so two rails on one page could not collide, which
// element state gives for free. Root state was the wrong home for three
// measured reasons:
//   1. RE-ENTRANCY. `onInit` -> `loadRail` -> root write is a write that
//      re-renders the WHOLE page, including the rail's own mount site. Any
//      mount site that rebuilds its subtree from root state therefore
//      re-creates the rail, whose fresh `onInit` loads again — and the
//      in-flight guard cannot stop it, because the terminal
//      `loading: false` write releases the guard in the same turn. An
//      element-state write re-renders the rail's OWN subtree only, so the
//      rail can never re-create itself. The cycle has no edge left to close.
//   2. UNDECLARED ROOT KEYS. Every key here is computed
//      (`_installableRail_${domain}_${scopeType}_kinds`), so no state-defaults
//      tier can declare it and module scope splits it into two signals — a
//      write nobody reads. Element state has no such tier.
//   3. Two rails with the SAME domain+scopeType shared one key set and one
//      guard, so the second rail silently rendered the first one's data.
// Children read them off their inherited state: `s.railKinds`, `s.railLoading`
// (the rail's state node is the state every descendant inherits — nested
// `childrenAs: 'state'` rows excepted, and those never read these slots).
//
// Data contract (Phase 1 — display.* columns assumed present):
//   kind row: { kind, domain, category, display: { icon, label, tagline, color? },
//               applicable_to_scopes, enabled, … }
//   instance:  { kind, scope_type, scope_id, slug, display_name, enabled, … }
//
// Per-domain backend status (tickets/workspace.md "InstallableRail: 4 of 5
// domains have no instances backend" — audited 2026-08-08):
//   integration – real backend both halves. Catalogue = IntegrationKind
//                 (`GET /org-integrations/kinds`); instances =
//                 `GET /org-integrations` via listScopedIntegrations. REQUIRES
//                 orgId (see orgId contract below).
//   mcp         – real backend for INSTANCES ONLY: `/core/mcp-connectors`
//                 (workspace-scoped server-side from the caller's claims — no
//                 orgId needed, unlike integration). There is NO kinds
//                 catalogue for mcp (McpConnector rows are free-form
//                 name+url, not chosen from an enum) — IntegrationKind does
//                 not carry a `domain` field, so blindly reusing it here
//                 would silently show the integration catalogue (GitHub/
//                 Slack/…) mislabeled as MCP servers. Instead each installed
//                 connector is rendered as its OWN self-describing tile (see
//                 `_deriveSelfKinds`) — accurate, not a lie, no invented
//                 catalogue.
//   library/template/plugin – no server collection for either half. Any
//                 "installed" signal for library/template today lives in the
//                 marketplace package's per-workspace localStorage list
//                 (`marketplace.installed`), a LAYER ABOVE this shared
//                 component (shared may not import from a feature package —
//                 wrong dependency direction) — so this component correctly
//                 renders an honest empty catalogue for these three rather
//                 than a wrong or borrowed one. Wire a real reader here if/
//                 when a server collection exists for them.
// ── State key helpers ─────────────────────────────────────────────────
// The root-state key helpers that used to live here (_railKey/_getKinds/
// _getInstances/_isLoading/_getError) went with the root keys themselves —
// see "STATE THIS COMPONENT OWNS" above. `__installableRailInternals` never
// exported them, so nothing outside this file could read them.

var $2hTF2 = parcelRequire("2hTF2");

var $kwtE9 = parcelRequire("kwtE9");
const $eb2bbd9581606dfd$var$_hasInstalled = (instances, kind)=>instances.some((i)=>i.kind === kind);
// Domains with a real kinds/catalogue backend today. ONLY `integration`
// (IntegrationKind has no `domain` column — it IS the integration catalogue,
// nothing else). Reusing it for other domains would silently mislabel its
// rows (e.g. rendering GitHub/Slack/Notion as "Featured templates" — this
// was live in canvas DashboardRows.js's TemplatesRail (domain:'template')
// until this fix, since `_fetchKinds` never filtered by domain at all).
const $eb2bbd9581606dfd$var$_KIND_CATALOG_DOMAINS = new Set([
    'integration'
]);
// Catalogue read. The integration-kinds catalogue now lives in Mongo,
// served by the main server (GET /org-integrations/kinds). Delegate to the
// shared, migration-aware loader (`listIntegrationKinds`) and filter the
// catalogue down to the kinds applicable to this scopeType client-side.
// Returns [] for any domain with no real catalogue backend (see
// _KIND_CATALOG_DOMAINS) — an honest empty catalogue, never a borrowed one.
const $eb2bbd9581606dfd$var$_fetchKinds = async (domain, scopeType)=>{
    if (typeof window === 'undefined') return [];
    if (!$eb2bbd9581606dfd$var$_KIND_CATALOG_DOMAINS.has(domain)) return [];
    try {
        const kinds = await (0, $2hTF2.listIntegrationKinds)();
        return kinds.filter((k)=>{
            if (k.enabled === false) return false;
            const scopes = k.applicable_to_scopes || k.applicableToScopes;
            if (scopeType && Array.isArray(scopes)) return scopes.includes(scopeType);
            return true;
        });
    } catch (err) {
        console.warn('[InstallableRail] listIntegrationKinds failed', err && err.message);
        return [];
    }
};
// Domains without a kinds catalogue (see _KIND_CATALOG_DOMAINS) but WITH a
// real instances backend (today: mcp) render each installed instance as its
// own self-describing tile — always "installed" — instead of intersecting
// against a catalogue that doesn't exist. Without this, `RailStrip` et al
// (which map over `kinds`, not `instances`) would show real installed
// connectors as if the domain had nothing at all — the exact silent-empty
// failure this ticket exists to stop, just moved one layer down.
const $eb2bbd9581606dfd$var$_deriveSelfKinds = (domain, instances)=>(instances || []).map((i)=>({
            kind: i.kind,
            domain: domain,
            display: {
                icon: domain === 'mcp' ? 'terminal' : 'grid',
                label: i.display_name || i.kind,
                tagline: i._sourceUrl || ''
            },
            enabled: i.enabled !== false
        }));
// Domains whose "installed instances" have a real backend. `integration`
// (`GET /org-integrations`) and `mcp` (`GET /core/mcp-connectors`, mapped
// below) do. `library` / `plugin` / `template` do not — a full-monorepo
// route sweep (2026-08-02) found no such route in any domain module, and
// re-audited 2026-08-08: still true. Their "installed" signal today, if any,
// lives in the marketplace package's per-workspace localStorage list — a
// feature-package concern this shared component must not reach into (wrong
// dependency direction: shared is a dependency OF marketplace, never the
// reverse). See the file-header comment for the full per-domain audit.
const $eb2bbd9581606dfd$var$_INSTANCE_BACKED_DOMAINS = new Set([
    'integration',
    'mcp'
]);
// The warn-once flag lives on `globalThis.__installableRailWarnedNoBackend`,
// never a module-scope `let`: frank revives the functions with no module
// scope, so a `let` read here is an unresolvable identifier that refuses
// every publish bundling this component (FA201, pointerCapability.js template).
// Fetch installed instances for a given scopeType — SDK-only (integrations
// remediation #6: the last raw-fetch leaf in this file).
//
// The previous raw fetch was ALSO wrong for `integration`, silently: it sent
// `scope_type` / `scope_id` (snake_case) and NO `orgId`, while
// GET /core/org-integrations requires `orgId` and reads camelCase
// `scopeType` / `scopeId` — so the server answered 400 `invalid_input` on
// every call and the `!res.ok` guard turned it into `[]`. The rail's
// installed half has been dead since it shipped. Routing through the shared
// `listScopedIntegrations` facade fixes the contract AND normalizes rows
// the same way every other integrations consumer sees them.
//
// `orgId` is a PER-DOMAIN requirement, not a blanket one:
//   integration – REQUIRED by GET /core/org-integrations. For `scopeType:
//     'org'` the scopeId IS the org id (that's how the production mount in
//     canvas DashboardRows resolves it); workspace/project scopes must pass
//     it explicitly via the `orgId` prop, resolved from `root.org` (NOT the
//     SDK's activeOrgId — that's a Promise-gated init flag with nothing
//     resolved yet on a bare cold load; `root.org` is what auth/boot URL-pins
//     from `/w/<org>` | `/<owner>/<key>` | `/studio/<owner>` before the SDK
//     has caught up — see reconcileMwtOrgFromUrl / workspaceUrlSync.js). A
//     workspace/project mount that omits it now THROWS in dev instead of
//     silently rendering empty (below) — this is the failure this ticket was
//     opened to stop.
//   mcp – NOT required. `/core/mcp-connectors` derives the tenant from the
//     caller's workspace claim server-side (McpConnectorController), so no
//     orgId is threaded through at all.
const $eb2bbd9581606dfd$var$_fetchInstances = async (domain, scopeType, scopeId, orgId)=>{
    if (typeof window === 'undefined') return [];
    // Skip while the scope hasn't resolved yet (e.g. scopeId not loaded).
    if (!scopeId || typeof scopeId === 'function') return [];
    if (!$eb2bbd9581606dfd$var$_INSTANCE_BACKED_DOMAINS.has(domain)) {
        if (!globalThis.__installableRailWarnedNoBackend) {
            globalThis.__installableRailWarnedNoBackend = true;
            console.warn(`[InstallableRail] no instances backend for domain "${domain}" \u{2014} ` + 'rendering catalogue only (see tickets/workspace.md "InstallableRail")');
        }
        return [];
    }
    if (domain === 'mcp') {
        // Workspace-scoped, claims-derived — org scope carries no scopeId filter
        // (org-scoped connectors are stored with scopeId:null; omitting the
        // param matches any scopeId within scopeType, which IS "org-scoped").
        const { data: data, error: error } = await (0, $kwtE9.listConnectors)({
            scopeType: scopeType,
            scopeId: scopeType === 'org' ? undefined : scopeId
        });
        if (error) throw new Error(error);
        return (data || []).map((row)=>({
                kind: row.id,
                slug: row.id,
                scope_type: row.scope_type,
                scope_id: row.scope_id,
                display_name: row.name,
                enabled: row.status === 'enabled',
                _sourceUrl: row.url
            }));
    }
    // integration — the only remaining orgId-requiring domain.
    const resolvedOrgId = orgId || (scopeType === 'org' ? scopeId : null);
    if (!resolvedOrgId) {
        if (scopeType !== 'org' && true) throw new Error(`[InstallableRail] domain="integration" scopeType="${scopeType}" mount is ` + "missing an orgId prop \u2014 pass orgId explicitly (dev-only hard fail; " + 'silently rendering empty is the exact failure tickets/workspace.md ' + '"InstallableRail" was opened to stop). Resolve it from root.org, not ' + "sdk.activeOrgId \u2014 see the _fetchInstances doc comment.");
        return [];
    }
    try {
        return await (0, $2hTF2.listScopedIntegrations)({
            type: scopeType,
            orgId: resolvedOrgId,
            id: scopeType === 'org' ? null : scopeId
        });
    } catch (err) {
        // Surface the failure instead of masking it as "nothing installed" —
        // KEY-IN-STATE: this throws into `scope.loadRail`'s catch, which writes
        // the message to the rail's own `railError` slot. Neither has an element;
        // the render site resolves.
        throw new Error(err?.message || 'apps.rail.error.loadInstalled');
    }
};
// `_loadRail` lived here (a root-state writer, duplicated into `scope` for the
// frank module-scope trap). It is gone with the root keys — `scope.loadRail`
// below is the only loader, and it writes the RAIL's own element state.
// ── Mount-prop readers ────────────────────────────────────────────────
// ONE object, set as the `scope` of every part that reads a mount prop AND
// spread into the rail's own scope. Each part carries it itself because a part
// can be mounted with NO rail above it — the UI-kit catalog mounts every
// component bare — and an element with no scoped ancestor has no `el.scope`
// at all: every `el.scope.x?.()` read in a text effect threw there (measured
// through the real renderer, __tests__/installableRailPropDelivery.test.js).
// A `scope:` VALUE is copied into each component when the module loads, so
// this survives frank; a bare read of the const from inside a factory would
// not (FA204).
const $eb2bbd9581606dfd$var$_railReaders = {
    // Bug C fix: DOMQL v3.14 props may be function-typed when accessed via
    // `el.X` in onInit — the framework doesn't auto-evaluate factory props
    // on access. Resolve here before passing to async fetch helpers so no
    // function literal ever reaches a URLSearchParams value.
    resolveElProp (el, s, prop) {
        const v = el[prop];
        return typeof v === 'function' ? v(el, s) : v;
    },
    // THE RAIL ELEMENT, from the rail itself or from any descendant. The rail
    // marks itself (`isInstallableRail`), so the walk is the framework's own
    // `lookup` and has no depth to get wrong.
    railOf (el) {
        if (!el) return null;
        if (el.isInstallableRail === true) return el;
        return typeof el.lookup === 'function' ? el.lookup((node)=>node.isInstallableRail === true) : null;
    },
    // A MOUNT PROP LIVES ON THE RAIL ELEMENT, NEVER IN STATE. Every reader
    // inside the rail used to read `s.domain` / `s.title`, resolved
    // `undefined` in every host, and rendered a header with no title and a
    // sentence with no noun in it — found live on
    // /marketplace/installable-rail-demo, 2026-09-20. Read it off the rail,
    // through `resolveElProp`, with the RAIL's own state: a mount-site factory
    // (`scopeId: (el, s) => … s.owner`) was written against that state.
    //
    // NOT for a prop whose VALUE is a function (`onAddClick`): this cannot
    // tell a prop factory from a callback, and would invoke the host's
    // callback during a render. Read those raw off `railOf(el)`.
    railProp (el, s, prop) {
        const rail = this.railOf(el);
        if (!rail) return undefined;
        return this.resolveElProp(rail, rail.state || s, prop);
    },
    // `heading` first, `title` as the back-compat fallback (see the props
    // header for why `title` cannot be the name).
    railHeading (el, s) {
        return this.railProp(el, s, 'heading') || this.railProp(el, s, 'title') || '';
    },
    // The empty hint is a WHOLE sentence per scope. The old single sentence
    // took the raw scopeType (`… for this {scope} yet.`), so the Georgian one
    // carried the English word `workspace` — and no placeholder can inflect a
    // Georgian noun. The keys stay LITERAL (docs/I18N-CONVENTION.md §1.3).
    SCOPE_HINT_KEYS: {
        workspace: 'apps.rail.emptyHint.workspace',
        org: 'apps.rail.emptyHint.org',
        project: 'apps.rail.emptyHint.project'
    },
    scopeHintKey (el, s) {
        const key = this.SCOPE_HINT_KEYS[this.railProp(el, s, 'scopeType')];
        return typeof key === 'string' ? key : this.SCOPE_HINT_KEYS.workspace;
    },
    // The domain WORD is user-facing copy inside a translated frame, so it is
    // translated too. English pluralises `library` as `libraries`, never
    // `librarys`, so the plural comes from the NOUN and never from a suffix
    // on the placeholder; ka carries its own word for each. These are the App
    // Store's own nouns, already shipped in both languages. The keys stay
    // LITERAL: a key built by concatenation is invisible to the i18n parity
    // and orphan gates (docs/I18N-CONVENTION.md).
    DOMAIN_NOUNS: {
        integration: {
            one: 'marketplace.kind.integration.noun',
            many: 'marketplace.kind.integration.nouns'
        },
        library: {
            one: 'marketplace.kind.library.noun',
            many: 'marketplace.kind.library.nouns'
        },
        mcp: {
            one: 'marketplace.kind.mcp.noun',
            many: 'marketplace.kind.mcp.nouns'
        },
        plugin: {
            one: 'marketplace.kind.plugin.noun',
            many: 'marketplace.kind.plugin.nouns'
        },
        template: {
            one: 'marketplace.kind.template.noun',
            many: 'marketplace.kind.template.nouns'
        }
    },
    // The noun for a host that supplies no domain at all — the UI-kit catalog
    // mounts every component bare. A missing noun is not acceptable output,
    // so the sentence still names something.
    GENERIC_NOUN: {
        one: 'marketplace.kind.app.noun',
        many: 'marketplace.kind.app.nouns'
    },
    domainNoun (el, s, form) {
        const domain = this.railProp(el, s, 'domain');
        // Read the form off the entry rather than test the domain: an unknown
        // word (`constructor`) reaches Object.prototype through the map, and a
        // prototype member carries no `one`/`many`, so it falls through here.
        const entry = this.DOMAIN_NOUNS[domain];
        const key = entry && entry[form] || this.GENERIC_NOUN[form];
        const word = el.call('polyglot', key);
        // `translate` answers the KEY ITSELF for a key no bundle carries. Never
        // show that to a user — the raw domain word is at least a real noun.
        return word && word !== key ? word : domain || '';
    }
};
const $eb2bbd9581606dfd$export$f6295fff5648df5b = {
    scope: $eb2bbd9581606dfd$var$_railReaders,
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'Y',
    align: 'center center',
    minHeight: 'controlH',
    padding: '0 A',
    round: 'radiusPill',
    borderWidth: 'hairline',
    borderStyle: 'dashed',
    borderColor: 'line',
    background: 'transparent',
    // Raw-hue sweep (LMC-4, measured 2026-08-11 aa-contrast walk): `blue` is
    // the raw brand hue, tuned for a near-black ground — on the demo rail's
    // wash it measured 2.77:1 (rail layout) / 3.21:1 (grid/list layouts) in
    // light mode, below the 4.5:1 floor. `accentInk` is the same hue re-toned
    // as an adaptive [light,dark] pair. The `:hover` wash/border below stay
    // the raw hue — decoration on a known transparent ground, not ink.
    color: 'accentInk',
    fontSize: 'Z2',
    fontWeight: '700',
    cursor: 'pointer',
    flexShrink: '0',
    transition: 'B defaultBezier',
    transitionProperty: 'background, border-color',
    ':hover': {
        background: 'blue.1',
        borderColor: 'blue.5'
    },
    '@media(prefers-reduced-motion:reduce)': {
        transition: 'none'
    },
    Icon: {
        name: 'plus',
        fontSize: 'Z2',
        color: 'accentInk'
    },
    Label: {
        tag: 'span',
        // `{domain}` is the rail's own domain word ('integration', 'library', …).
        // It is a NOUN inside a translated frame, so it is translated too — see
        // `scope.domainNoun`.
        text: (el, s)=>el.call('polyglot', 'apps.rail.add').replace('{domain}', el.scope.domainNoun(el, s, 'one') || el.call('polyglot', 'marketplace.kind.app.noun'))
    },
    onClick: (e, el, s)=>{
        // Resolved NOW, off the rail: a `scopeId` factory reads root state that can
        // land after the rail mounted, so a value captured at mount would open the
        // modal on no scope.
        const prop = (name)=>el.scope.railProp(el, s, name);
        const domain = prop('domain');
        // `onAddClick` is a CALLBACK, so it is read raw off the rail and never
        // through `railProp`, which would invoke it as a prop factory.
        const onAddClick = el.scope.railOf(el)?.onAddClick;
        if (typeof onAddClick === 'function') onAddClick(domain);
        el.call('openInstallableModal', {
            domain: domain,
            defaultScope: {
                type: prop('scopeType'),
                id: prop('scopeId')
            },
            catalogFilter: prop('catalogFilter') ?? prop('filter')
        });
    }
};
const $eb2bbd9581606dfd$export$949dbda2a48ca1b2 = {
    scope: $eb2bbd9581606dfd$var$_railReaders,
    flow: 'y',
    gap: 'Z',
    align: 'center center',
    padding: 'B A',
    round: 'radiusCard',
    borderWidth: 'hairline',
    borderStyle: 'dashed',
    borderColor: 'line',
    background: 'overlayStrong',
    width: '100%',
    EmptyIcon: {
        extends: 'Icon',
        name: (el, s)=>{
            const icons = {
                integration: 'grid',
                library: 'bookmark',
                mcp: 'terminal',
                plugin: 'puzzle',
                template: 'layers'
            };
            // Same map read as `domainNoun`: take the VALUE and check it, so an
            // unknown domain cannot reach a prototype member.
            const icon = icons[el.scope.railProp(el, s, 'domain')];
            return typeof icon === 'string' ? icon : 'grid';
        },
        fontSize: 'D',
        color: 'caption'
    },
    EmptyLabel: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        textAlign: 'center',
        text: (el, s)=>{
            const emptyHint = el.scope.railProp(el, s, 'emptyHint');
            return emptyHint ? el.call('polyglot', emptyHint) : el.call('polyglot', 'apps.rail.empty.title').replace('{domain}', // No scope means no rail above this mount (the UI-kit catalog
            // mounts the component bare), and the generic noun keeps the
            // sentence whole.
            el.scope.domainNoun(el, s, 'one') || el.call('polyglot', 'marketplace.kind.app.noun'));
        }
    },
    EmptyHint: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        fontWeight: '400',
        color: 'caption',
        textAlign: 'center',
        text: (el, s)=>el.call('polyglot', // No scope means no rail above this mount (the UI-kit catalog mounts
            // the component bare); `workspace` is the default it always had.
            el.scope.scopeHintKey(el, s)).replace('{domain}', el.scope.domainNoun(el, s, 'many') || el.call('polyglot', 'marketplace.kind.app.nouns'))
    },
    AddButton: {
        extends: 'InstallableRailAddButton'
    }
};
const $eb2bbd9581606dfd$export$bd8eaac2c4a74596 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    childExtends: {
        round: 'radiusControl',
        background: 'line',
        height: 'B',
        width: 'E',
        flexShrink: '0',
        // Pulse animation via opacity — respects prefers-reduced-motion at
        // the keyframe level (no JS toggle needed).
        animation: 'pulse 1.5s ease-in-out infinite',
        '@media(prefers-reduced-motion:reduce)': {
            animation: 'none',
            opacity: '0.5'
        }
    },
    Item_1: {
        width: 'E'
    },
    Item_2: {
        width: 'D2',
        opacity: '0.8'
    },
    Item_3: {
        width: 'D2',
        opacity: '0.6'
    }
};
const $eb2bbd9581606dfd$export$93f1668b0294386b = {
    scope: $eb2bbd9581606dfd$var$_railReaders,
    flow: 'x',
    gap: 'Z',
    align: 'center space-between',
    TitleGroup: {
        flow: 'x',
        gap: 'Y',
        align: 'center left',
        TitleIcon: {
            extends: 'Icon',
            name: (el, s)=>{
                const icons = {
                    integration: 'grid',
                    library: 'bookmark',
                    mcp: 'terminal',
                    plugin: 'puzzle',
                    template: 'layers'
                };
                const icon = icons[el.scope.railProp(el, s, 'domain')];
                return typeof icon === 'string' ? icon : 'grid';
            },
            fontSize: 'B',
            color: 'caption',
            hide: (el, s)=>!el.scope.railProp(el, s, 'domain')
        },
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            hide: (el, s)=>!el.scope.railHeading(el, s),
            // A mount site passes a bundle KEY or prose as the rail `heading`
            // (canvas DashboardRows.js passes keys), so the render site resolves it —
            // the same shape `EmptyState`, `TutorialGifNotification` and
            // `InstallableRailItem`'s tagline already use. `translate()` returns its
            // input unchanged, so a caller that passes prose is untouched.
            text: (el, s)=>el.call('polyglot', el.scope.railHeading(el, s) || '')
        }
    },
    AddButton: {
        extends: 'InstallableRailAddButton',
        // In list layout hide from header — the list footer carries it.
        hide: (el, s)=>(el.scope.railProp(el, s, 'layout') || 'rail') === 'list'
    }
};
const $eb2bbd9581606dfd$export$3e84008fc72231e4 = {
    // FA204 / frank trap (workspace d6ea1142, project_frank_drops_module_local_
    // helpers) — every helper this component's factories/lifecycle hooks read
    // used to be a bare module-scope const/function above; it read as
    // undefined once frank.toJSON'd for platform delivery. Duplicated here
    // (not shared with the module-scope originals) because those originals
    // stay module-scope ONLY to back `__installableRailInternals` (below) —
    // the offline unit test's seam onto the per-domain backend audit — and a
    // shared `warnedMissingDomainBackend` "once" flag would otherwise let a
    // test call and a live mount silence each other's warning. Every OTHER
    // InstallableRail factory below is scope-only.
    scope: {
        ...$eb2bbd9581606dfd$var$_railReaders,
        POLL_INTERVAL: 30000,
        KIND_CATALOG_DOMAINS: new Set([
            'integration'
        ]),
        INSTANCE_BACKED_DOMAINS: new Set([
            'integration',
            'mcp'
        ]),
        warnedMissingDomainBackend: false,
        hasInstalled (instances, kind) {
            return instances.some((i)=>i.kind === kind);
        },
        // The three layout strips differ by ONE word. `hide` and `children` were
        // written out three times each.
        stripHidden (el, s, layout) {
            if ((this.railProp(el, s, 'layout') || 'rail') !== layout) return true;
            return s.railLoading || s.railKinds.length === 0;
        },
        stripRows (el, s, layout) {
            const domain = this.railProp(el, s, 'domain');
            return s.railKinds.map((k)=>({
                    domain: domain,
                    kind: k.kind,
                    display: k.display || {
                        icon: k.icon,
                        label: k.label,
                        tagline: k.description
                    },
                    installed: this.hasInstalled(s.railInstances, k.kind),
                    _layout: layout
                }));
        },
        // Resolve the four load inputs FRESH off the rail, then load. `onInit`,
        // the poll tick and Retry all come through here, so none of them can pass
        // an unresolved factory to the loader.
        reload (rail) {
            const s = rail.state;
            return this.loadRail(rail, this.resolveElProp(rail, s, 'domain'), this.resolveElProp(rail, s, 'scopeType'), this.resolveElProp(rail, s, 'scopeId'), this.resolveElProp(rail, s, 'orgId'));
        },
        // See the module-scope `_deriveSelfKinds` above for the full reasoning
        // (identical logic, duplicated per the file-header note).
        deriveSelfKinds (domain, instances) {
            return (instances || []).map((i)=>({
                    kind: i.kind,
                    domain: domain,
                    display: {
                        icon: domain === 'mcp' ? 'terminal' : 'grid',
                        label: i.display_name || i.kind,
                        tagline: i._sourceUrl || ''
                    },
                    enabled: i.enabled !== false
                }));
        },
        // See the module-scope `_fetchKinds` above for the full reasoning
        // (identical logic, duplicated per the file-header note).
        async fetchKinds (domain, scopeType) {
            if (typeof window === 'undefined') return [];
            if (!this.KIND_CATALOG_DOMAINS.has(domain)) return [];
            try {
                const kinds = await (0, $2hTF2.listIntegrationKinds)();
                return kinds.filter((k)=>{
                    if (k.enabled === false) return false;
                    const scopes = k.applicable_to_scopes || k.applicableToScopes;
                    if (scopeType && Array.isArray(scopes)) return scopes.includes(scopeType);
                    return true;
                });
            } catch (err) {
                console.warn('[InstallableRail] listIntegrationKinds failed', err && err.message);
                return [];
            }
        },
        // See the module-scope `_fetchInstances` above for the full reasoning
        // (identical logic, duplicated per the file-header note).
        async fetchInstances (domain, scopeType, scopeId, orgId) {
            if (typeof window === 'undefined') return [];
            if (!scopeId || typeof scopeId === 'function') return [];
            if (!this.INSTANCE_BACKED_DOMAINS.has(domain)) {
                if (!this.warnedMissingDomainBackend) {
                    this.warnedMissingDomainBackend = true;
                    console.warn(`[InstallableRail] no instances backend for domain "${domain}" \u{2014} ` + 'rendering catalogue only (see tickets/workspace.md "InstallableRail")');
                }
                return [];
            }
            if (domain === 'mcp') {
                const { data: data, error: error } = await (0, $kwtE9.listConnectors)({
                    scopeType: scopeType,
                    scopeId: scopeType === 'org' ? undefined : scopeId
                });
                if (error) throw new Error(error);
                return (data || []).map((row)=>({
                        kind: row.id,
                        slug: row.id,
                        scope_type: row.scope_type,
                        scope_id: row.scope_id,
                        display_name: row.name,
                        enabled: row.status === 'enabled',
                        _sourceUrl: row.url
                    }));
            }
            // integration — the only remaining orgId-requiring domain.
            const resolvedOrgId = orgId || (scopeType === 'org' ? scopeId : null);
            if (!resolvedOrgId) {
                if (scopeType !== 'org' && true) throw new Error(`[InstallableRail] domain="integration" scopeType="${scopeType}" mount is ` + "missing an orgId prop \u2014 pass orgId explicitly (dev-only hard fail; " + 'silently rendering empty is the exact failure tickets/workspace.md ' + '"InstallableRail" was opened to stop). Resolve it from root.org, not ' + "sdk.activeOrgId \u2014 see the fetchInstances doc comment.");
                return [];
            }
            try {
                return await (0, $2hTF2.listScopedIntegrations)({
                    type: scopeType,
                    orgId: resolvedOrgId,
                    id: scopeType === 'org' ? null : scopeId
                });
            } catch (err) {
                // KEY-IN-STATE: this throws into `loadRail`'s catch, which writes the
                // message to the rail's own `railError` slot. Neither has an element;
                // the render site resolves.
                throw new Error(err?.message || 'apps.rail.error.loadInstalled');
            }
        },
        // THE LOADER. Takes the rail ELEMENT and writes the rail's OWN state —
        // never root state. A root write re-renders the whole page and can
        // re-create this very element, which re-runs `onInit` and loads again;
        // the terminal `railLoading: false` write releases the in-flight guard in
        // the same turn, so that cycle never settles (WS-RAIL-ROOT-STATE-HANG-1).
        // An element-state write re-renders this rail's subtree only.
        async loadRail (el, domain, scopeType, scopeId, orgId) {
            if (!el?.state?.update || !domain || !scopeType) return;
            // A load that resolves after the rail was removed must not write —
            // `onDestroy` sets the flag, and the write would otherwise touch a
            // state node that is no longer mounted.
            if (el._railGone) return;
            if (el.state.railLoading) return;
            el.state.update({
                railLoading: true,
                railError: null
            });
            try {
                const [kinds, instances] = await Promise.all([
                    this.fetchKinds(domain, scopeType),
                    this.fetchInstances(domain, scopeType, scopeId, orgId)
                ]);
                const resolvedKinds = !this.KIND_CATALOG_DOMAINS.has(domain) && this.INSTANCE_BACKED_DOMAINS.has(domain) ? this.deriveSelfKinds(domain, instances) : kinds;
                if (el._railGone || !el.state?.update) return;
                el.state.update({
                    railKinds: resolvedKinds,
                    railInstances: instances,
                    railLoading: false
                });
            } catch (err) {
                if (el._railGone || !el.state?.update) return;
                el.state.update({
                    railLoading: false,
                    railError: err?.message || 'apps.rail.error.load'
                });
            }
        }
    },
    flow: 'y',
    gap: 'Z',
    // What `scope.railOf` looks for. A plain prop, so it survives frank and a
    // mount site that names the rail anything (`IntegrationsRail`, `Rail_2`).
    isInstallableRail: true,
    // The rail's OWN load slots. Declared, so every descendant inherits real
    // values on the first render instead of reading `undefined` off root.
    // A mount site's own state keys still reach the descendants (state
    // inheritance), so `scopeId: (el, s) => … s.owner` at a call site keeps
    // working — measured, not assumed.
    state: {
        railLoading: false,
        railError: null,
        railKinds: [],
        railInstances: []
    },
    // ── Initialise: load catalogue + instances, start poll ──────────────
    onInit: (el, s)=>{
        // (`orgId` is REQUIRED by GET /core/org-integrations. Mounts that use a
        // workspace/project scope must pass it explicitly; an `org` scope's
        // scopeId already IS the org id — resolved inside scope.fetchInstances.)
        const domain = el.scope.resolveElProp(el, s, 'domain');
        const scopeType = el.scope.resolveElProp(el, s, 'scopeType');
        if (!domain || !scopeType) return;
        // Offline/demo host: render the seed, read nothing, poll nothing.
        const seedKinds = el.scope.resolveElProp(el, s, 'seedKinds');
        if (seedKinds) {
            el.state.update({
                railKinds: seedKinds,
                railInstances: el.scope.resolveElProp(el, s, 'seedInstances') || [],
                railLoading: false,
                railError: null
            });
            return;
        }
        // Kick off the first fetch.
        el.scope.reload(el);
        // Poll every 30 s as fallback realtime. `reload` resolves the inputs again
        // on each tick — an org id can land after the first render (lazy auth
        // hydration). The timer id lives on the element (transient; not state).
        el._railPollTimer = setInterval(()=>el.scope.reload(el), el.scope.POLL_INTERVAL);
    },
    // Clean up poll timer on destroy, and close the write window for any load
    // still in flight (its `await` resumes on a removed element otherwise).
    onDestroy: (el, s)=>{
        el._railGone = true;
        if (el._railPollTimer) {
            clearInterval(el._railPollTimer);
            el._railPollTimer = null;
        }
    },
    // ── Header ───────────────────────────────────────────────────────────
    InstallableRailHeader: {
        hide: (el, s)=>!el.scope.railHeading(el, s) && !el.scope.railProp(el, s, 'domain')
    },
    // ── Loading skeleton (while first fetch is in flight) ────────────────
    InstallableRailSkeleton: {
        hide: (el, s)=>!s.railLoading
    },
    // ── Error banner ─────────────────────────────────────────────────────
    // Reviewed (border-habit sweep): KEPT, flagged not fixed — this is a
    // status-colour-matched border (`red.5` on `red.1`, §4.2 status-tint
    // pattern), not an instance of the ticketed `line`-token class. Still
    // outside §2.5's 4 surviving-stroke exceptions on a strict reading, so a
    // candidate for a future status-banner pass — left for that ticket rather
    // than folded in here.
    ErrorBanner: {
        flow: 'x',
        gap: 'Y',
        align: 'center left',
        padding: 'Y Z',
        round: 'radiusControl',
        background: 'red.1',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'red.5',
        hide: (el, s)=>!s.railError,
        Icon: {
            name: 'exclMark',
            fontSize: 'Z2',
            color: 'red'
        },
        Message: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'red',
            // KEY-IN-STATE: the loader writes a bundle KEY (or the server's own
            // message); the render site resolves it. It used to print the raw key.
            text: (el, s)=>el.call('polyglot', s.railError || '')
        },
        RetryButton: {
            tag: 'button',
            type: 'button',
            padding: 'X2 Y',
            round: 'radiusControl',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y1',
            color: 'red',
            textDecoration: 'underline',
            text: '{{ common.action.try_again | polyglot }}',
            onClick: (e, el)=>{
                const rail = el.scope.railOf(el);
                if (rail) el.scope.reload(rail);
            }
        }
    },
    // ── Empty state ───────────────────────────────────────────────────────
    InstallableRailEmpty: {
        // Show empty only when not loading, no error, and no kinds found.
        hide: (el, s)=>!!(s.railLoading || s.railError || s.railKinds.length > 0)
    },
    // ── Rail layout (horizontal scroll strip) ────────────────────────────
    RailStrip: {
        flow: 'x',
        gap: 'Z',
        overflowX: 'auto',
        overflowY: 'hidden',
        padding: 'X2 0',
        // Hide scrollbar visually but keep scroll accessible.
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': {
            display: 'none'
        },
        hide: (el, s)=>el.scope.stripHidden(el, s, 'rail'),
        childExtends: 'InstallableRailItem',
        childrenAs: 'state',
        children: (el, s)=>el.scope.stripRows(el, s, 'rail'),
        // Trailing add button at the end of the chip row.
        // `ignoreChildExtends`: the strip's `childExtends` reaches EVERY child, the
        // named ones included, and the framework MERGES it with a child's own
        // `extends`. Without the opt-out this button was also an
        // InstallableRailItem — three stray icons, an "Available" badge and a
        // chevron inside it, its own label squeezed onto two lines (seen live).
        AddButton: {
            extends: 'InstallableRailAddButton',
            ignoreChildExtends: true
        }
    },
    // ── Grid layout (responsive card grid) ───────────────────────────────
    GridStrip: {
        display: 'grid',
        // Rule 27 — the track is a design-system value. F1 (233px) is the spacing
        // token nearest the old raw 220px minimum; `var(--spacing-F1)` is the form
        // that survives INSIDE minmax() (the grid-track resolver lifts bare
        // letters at the top level only), and `min(100%, …)` stops the track
        // overflowing a pane narrower than one card — the house pairing
        // (workspace components/PersonCard.js PeopleGrid).
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-F1)), 1fr))',
        gap: 'Z',
        hide: (el, s)=>el.scope.stripHidden(el, s, 'grid'),
        childExtends: 'InstallableRailItem',
        childrenAs: 'state',
        children: (el, s)=>el.scope.stripRows(el, s, 'grid')
    },
    // ── List layout (vertical management list) ────────────────────────────
    ListStrip: {
        flow: 'y',
        round: 'radiusCard',
        // Fill-contrast card (was a `line` border — border-habit sweep,
        // design-direction.md §8) — the card's own `document` fill already
        // separates it from its container.
        background: 'document',
        overflow: 'hidden',
        hide: (el, s)=>el.scope.stripHidden(el, s, 'list'),
        childExtends: 'InstallableRailItem',
        childrenAs: 'state',
        children: (el, s)=>el.scope.stripRows(el, s, 'list'),
        // List footer: "Add" button at the bottom of the list.
        ListAddRow: {
            // Not a catalogue row — see RailStrip.AddButton.
            ignoreChildExtends: true,
            flow: 'x',
            gap: 'Y',
            align: 'center left',
            padding: 'Y Z2',
            // Top divider removed (border-habit sweep, design-direction.md §8) —
            // ListStrip's own opaque `document` fill + rounded/`overflow: hidden`
            // wrapper already reads as one continuous card.
            AddButton: {
                extends: 'InstallableRailAddButton'
            }
        }
    }
};
const $eb2bbd9581606dfd$export$70edcaa19516c77 = {
    INSTANCE_BACKED_DOMAINS: $eb2bbd9581606dfd$var$_INSTANCE_BACKED_DOMAINS,
    KIND_CATALOG_DOMAINS: $eb2bbd9581606dfd$var$_KIND_CATALOG_DOMAINS,
    fetchInstances: $eb2bbd9581606dfd$var$_fetchInstances,
    fetchKinds: $eb2bbd9581606dfd$var$_fetchKinds,
    deriveSelfKinds: $eb2bbd9581606dfd$var$_deriveSelfKinds,
    hasInstalled: $eb2bbd9581606dfd$var$_hasInstalled
};

});
parcelRegister("kwtE9", function(module, exports) {

$parcel$export(module.exports, "listConnectors", () => $ef0dcb05827ec5ba$export$5c32629e639be49f);
$parcel$export(module.exports, "installConnector", () => $ef0dcb05827ec5ba$export$d9238261bf4fae2d);
$parcel$export(module.exports, "discoverCapabilities", () => $ef0dcb05827ec5ba$export$2624c843b5958ba7);
$parcel$export(module.exports, "enableConnector", () => $ef0dcb05827ec5ba$export$ee79419b4f8ae98c);
$parcel$export(module.exports, "disableConnector", () => $ef0dcb05827ec5ba$export$934ad11716cb70c8);
$parcel$export(module.exports, "deleteConnector", () => $ef0dcb05827ec5ba$export$8fc5777482cc8024);
// MCP connector SDK bridge — client-side wrappers over the server's
// /core/mcp-connectors routes (Mongo-backed). Secrets (auth tokens) are
// written server-side via integration_secrets and referenced by
// auth_secret_id FK — they never travel through the browser in plain text.
//
// Runtime contract: JSON-RPC 2.0 over SSE / WebSocket / HTTP transport.
// Capability discovery (tools/list + resources/list) runs server-side on
// install and is cached in the `capabilities` column.
//
// Scoping: the server filters rows by the authenticated active workspace,
// so a user only ever sees their own workspace's connectors. The reader
// wire shape is snake_case ({ id, name, url, scope_type, scope_id, status,
// transport, auth_kind, capabilities }), so the admin UI + canvas rail
// don't branch.
//
// (The legacy governance-Supabase read/write path — `_gov().from('mcp_connectors')`
// gated on __USE_CORE_MCP__ — was removed with that project; /core/mcp-connectors
// is now the sole source.)
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
// ── Helpers ───────────────────────────────────────────────────────────────────
//
// SDK-only transport (integrations remediation #6 — tickets/server.md). This
// module used to own a hand-rolled `_serverFetch`: its own channel-base
// resolution, its own localStorage token read, and a bare `{ error }` return
// convention — one of the three raw-fetch leaves that blocked normalising the
// integrations response envelope. `_viaSdk` keeps that RETURN CONTRACT
// (payload on success, `{ error }` on failure) so none of the exported
// functions below had to change shape, while auth + base URL move to the
// SDK's TokenManager / channel resolver.
const $ef0dcb05827ec5ba$var$_viaSdk = async (run)=>{
    try {
        const res = await run((0, $1NxyO.getSDK)());
        return res || {
            error: 'empty response'
        };
    } catch (err) {
        // The SDK throws on non-2xx and on transport failure; surface both in
        // the legacy shape, preserving the HTTP status when the error carries it.
        const status = err?.status || err?.statusCode;
        return {
            error: err?.message || 'network error',
            ...status ? {
                status: status
            } : {}
        };
    }
};
const $ef0dcb05827ec5ba$export$5c32629e639be49f = async ({ scopeType: scopeType, scopeId: scopeId } = {})=>{
    const qs = new URLSearchParams();
    if (scopeType) qs.set('scope_type', scopeType);
    if (scopeId != null) qs.set('scope_id', String(scopeId));
    const res = await $ef0dcb05827ec5ba$var$_viaSdk((sdk)=>sdk.mcpConnectorList(Object.fromEntries(qs)));
    if (res?.error) return {
        data: [],
        error: res.error
    };
    return {
        data: res?.connectors || [],
        error: null
    };
};
const $ef0dcb05827ec5ba$export$d9238261bf4fae2d = async ({ workspaceId: workspaceId, scopeType: scopeType = 'workspace', scopeId: scopeId = null, name: name, url: url, transport: transport = 'sse', authKind: authKind = 'none', authToken: authToken })=>{
    if (!workspaceId) return {
        ok: false,
        error: 'workspaceId required'
    };
    if (!url) return {
        ok: false,
        error: 'url required'
    };
    if (!name) return {
        ok: false,
        error: 'name required'
    };
    // Route through the server endpoint so it can store the secret in Vault
    // and run capability discovery without exposing the token to the DB.
    const result = await $ef0dcb05827ec5ba$var$_viaSdk((sdk)=>sdk.mcpConnectorCreate({
            workspaceId: workspaceId,
            scopeType: scopeType,
            scopeId: scopeId,
            name: name,
            url: url,
            transport: transport,
            authKind: authKind,
            authToken: authToken
        }));
    if (result.error) return {
        ok: false,
        error: result.error
    };
    return {
        ok: true,
        data: result
    };
};
const $ef0dcb05827ec5ba$export$2624c843b5958ba7 = async (connectorId)=>{
    if (!connectorId) return {
        ok: false,
        error: 'connectorId required'
    };
    const result = await $ef0dcb05827ec5ba$var$_viaSdk((sdk)=>sdk.mcpConnectorDiscover(connectorId));
    if (result.error) return {
        ok: false,
        error: result.error
    };
    return {
        ok: true,
        capabilities: result.capabilities || result
    };
};
const $ef0dcb05827ec5ba$export$ee79419b4f8ae98c = async (connectorId)=>{
    const res = await $ef0dcb05827ec5ba$var$_viaSdk((sdk)=>sdk.mcpConnectorSetStatus(connectorId, {
            status: 'enabled'
        }));
    return res?.error ? {
        ok: false,
        error: res.error
    } : {
        ok: true
    };
};
const $ef0dcb05827ec5ba$export$934ad11716cb70c8 = async (connectorId)=>{
    const res = await $ef0dcb05827ec5ba$var$_viaSdk((sdk)=>sdk.mcpConnectorSetStatus(connectorId, {
            status: 'disabled'
        }));
    return res?.error ? {
        ok: false,
        error: res.error
    } : {
        ok: true
    };
};
const $ef0dcb05827ec5ba$export$8fc5777482cc8024 = async (connectorId)=>{
    const res = await $ef0dcb05827ec5ba$var$_viaSdk((sdk)=>sdk.mcpConnectorRemove(connectorId));
    return res?.error ? {
        ok: false,
        error: res.error
    } : {
        ok: true
    };
};

});


parcelRegister("gK6O1", function(module, exports) {

$parcel$export(module.exports, "InstallableModalStub", () => $c30638b65c2a5dbf$export$c9dd3bdf492f7f70);
// InstallableModalStub — Phase 3 placeholder modal.
//
// Mounted at each consuming app root alongside the existing Modal overlay.
// Opens whenever root.state._installableModal is set (by openInstallableModal).
// Closing clears that key.
//
// Phase 4 (MarketplaceInstallModal extensibility) replaces this component
// with the real install/manage flow. The stateKey '_installableModal' and the
// close pattern are the stable contract Phase 4 hooks into.
//
// Mount at app root (e.g. canvas/app.js, intranet/app.js):
//   InstallableModalStub: {}
//
// No additional props needed — reads everything from root.state._installableModal.
const $c30638b65c2a5dbf$export$c9dd3bdf492f7f70 = {
    extends: 'Modal',
    stateKey: '_installableModal',
    Window: {
        extends: 'ModalWindow',
        width: 'H2',
        maxWidth: '90vw',
        // Its header is custom (TitleGroup > Title), so the dialog is named by
        // that h2 (DESIGN-WL-SHARED-MODAL-DIALOG-HAS-NO-ACCESSIBLE-NAME-1).
        ariaLabelledby: 'InstallableModalStubTitle',
        ModalHeader: {
            flow: 'x',
            gap: 'Z',
            align: 'center space-between',
            padding: '0 0 Z 0',
            TitleGroup: {
                flow: 'y',
                gap: 'X2',
                Title: {
                    tag: 'h2',
                    id: 'InstallableModalStubTitle',
                    margin: '0',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>{
                        const data = s.root?._installableModal;
                        if (!data) return el.call('polyglot', 'apps.installModal.install');
                        const label = data.kind || data.domain || '';
                        return el.call('polyglot', data.installed ? 'apps.installModal.manageItem' : 'apps.installModal.installItem').replace('{item}', label);
                    }
                },
                Subtitle: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'Z2',
                    fontWeight: '400',
                    color: 'caption',
                    text: (el, s)=>{
                        const data = s.root?._installableModal;
                        if (!data) return '';
                        const parts = [];
                        if (data.domain) parts.push(el.call('polyglot', 'apps.installModal.domain').replace('{domain}', data.domain));
                        if (data.defaultScope?.type) parts.push(el.call('polyglot', 'apps.installModal.scope').replace('{scope}', data.defaultScope.type));
                        return parts.join(" \xb7 ");
                    }
                }
            },
            // THE house close X (brand CloseButton — F2, one X for every panel).
            CloseButton: {
                extends: 'CloseButton',
                onClick: (e, el, s)=>{
                    s.root?.update({
                        _installableModal: null
                    });
                }
            }
        },
        // ── Phase 4 notice ────────────────────────────────────────────────────
        PhaseNotice: {
            flow: 'y',
            gap: 'Z',
            padding: 'Z A',
            round: 'radiusCard',
            background: 'blue.1',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            borderColor: 'blue.3',
            NoticeRow: {
                flow: 'x',
                gap: 'Y',
                align: 'center left',
                Icon: {
                    name: 'info',
                    fontSize: 'Z2',
                    color: 'blue'
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'blue',
                    text: '{{ apps.installStub.comingSoon | polyglot }}'
                }
            },
            Description: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y2',
                color: 'paragraph',
                lineHeight: '1.5',
                text: (el, s)=>{
                    const data = s.root?._installableModal;
                    if (!data) return '';
                    return `openInstallableModal was called with: domain="${data.domain || "\u2014"}", ` + `kind="${data.kind || "\u2014"}", installed=${!!data.installed}. ` + 'Phase 4 MarketplaceInstallModal extensibility will wire this up with the ' + 'full install / manage flow.';
                }
            }
        },
        // ── Args debug display ────────────────────────────────────────────────
        ArgsDisplay: {
            flow: 'y',
            gap: 'Y',
            padding: 'Z A',
            round: 'radiusCard',
            background: 'overlayStrong',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            borderColor: 'line',
            ArgsLabel: {
                tag: 'span',
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '0.04em',
                color: 'caption',
                text: '{{ apps.installStub.receivedArgs | polyglot }}'
            },
            ArgsCode: {
                tag: 'pre',
                margin: '0',
                fontSize: 'Y2',
                color: 'paragraph',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                text: (el, s)=>{
                    const data = s.root?._installableModal;
                    return data ? JSON.stringify(data, null, 2) : '{}';
                }
            }
        },
        // ── Footer ────────────────────────────────────────────────────────────
        ModalFooter: {
            extends: 'ModalFooter',
            flow: 'x',
            gap: 'Y',
            align: 'center right',
            DismissButton: {
                tag: 'button',
                type: 'button',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                background: 'overlayStrong',
                border: 'none',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: '{{ apps.installStub.dismiss | polyglot }}',
                // Was `background: 'line'` — `line` is a stroke/hairline token
                // (['gray13','gray5'], meant for 1px dividers), not a state fill;
                // used as a full button hover fill it reads as a flat, out-of-
                // character gray block instead of an interaction wash. Same defect
                // class as `overlayStrong`-as-state (DESIGN_LANGUAGE §4.3/§8.1),
                // just a different token — `hover` (['black.05','white.07']) is the
                // one actually named for this role. Found while watching for this
                // exact class during LMC-4 (2026-08-10).
                ':hover': {
                    background: 'hover'
                },
                onClick: (e, el, s)=>{
                    s.root?.update({
                        _installableModal: null
                    });
                }
            }
        }
    }
};

});

parcelRegister("jWDyl", function(module, exports) {

$parcel$export(module.exports, "MobileRailSheet", () => $e8521d78cd35bd82$export$dca6a9956c424f1f);
// MobileRailSheet — the ONE off-canvas rail for phones. Every desktop side
// rail (tickets filters, calendar controls, chat conversations, documents
// browse) renders its content inside this sheet at @mobileL, so the whole
// platform answers to a single gesture: left-edge pull opens (see
// shared/functions/edgeSwipe.js), scrim tap / left-flick / Escape closes.
// The opaque sheet docks to the left edge, keeps its controls above the
// device safe areas, and owns keyboard focus only while it is open.
//
// Usage (inside an app's page/stage — the sheet gates itself to phones):
//   MobileRailSheet: {
//     stateKey: '_ticketsRailOpen',
//     railLabel: 'Filters',
//     Card: { Content: { ...the rail's existing children... } }
//   }
// Content mounts at Card.Content — the sheet root is the fixed inset:0
// overlay (scrim + card), so a root-level `Content` key would render an
// orphan div on the overlay instead. (Corrected 2026-08-02 after the
// tickets adoption caught the doc/implementation mismatch.)
// The consumer supplies Content; open/close state lives on root[stateKey]
// so the opener FAB, the edge gesture and the sheet all agree.
//
// Detail contract (per Nika "pay attention to details"): symmetric spacing
// (A padding, Z rhythm), no horizontal overflow (minWidth 0 throughout),
// overscroll contained, home-indicator + notch respected, reduced-motion
// collapses the slide to an instant swap (the global floor also covers it).
const $e8521d78cd35bd82$export$dca6a9956c424f1f = {
    // Phone-only: desktop keeps its persistent rails. Reactive — a plain
    // create-time matchMedia read would leave the sheet stuck at whatever the
    // viewport was on mount (desktop window resized down = no rail at all).
    // The onCreate watcher below flips `_isPhoneViewport` on the root, so this
    // factory re-runs on the real breakpoint change.
    hide: (el, s)=>{
        if (typeof window === 'undefined') return true;
        const flag = s.root?._isPhoneViewport;
        if (typeof flag === 'boolean') return !flag;
        return !window.matchMedia('(max-width: 768px)').matches;
    },
    // Function form (smbls 5a709adad+): the open/close key is a PROP, so the
    // static array can't express it. Root-state reads inside factories do NOT
    // auto-subscribe a descendant — without this the sheet's state said open
    // while the card stayed parked at translateX(-105%) (caught live 2026-08-02).
    subscribeTo: (el)=>[
            '_isPhoneViewport',
            el.stateKey
        ].filter(Boolean),
    scope: {
        syncRailFocus (el, open) {
            if (typeof document === 'undefined' || open === el.__railWasOpen) return;
            el.__railWasOpen = open;
            if (el.__railFocusFrame != null && typeof cancelAnimationFrame === 'function') {
                cancelAnimationFrame(el.__railFocusFrame);
                el.__railFocusFrame = null;
            }
            if (open) {
                el.__railReturnFocus = document.activeElement;
                const enter = ()=>{
                    el.__railFocusFrame = null;
                    if (!el.__railWasOpen || !el.Card?.node) return;
                    el.Card.node.focus({
                        preventScroll: true
                    });
                };
                if (typeof requestAnimationFrame === 'function') el.__railFocusFrame = requestAnimationFrame(enter);
                else Promise.resolve().then(enter);
            } else {
                const opener = el.__railReturnFocus;
                el.__railReturnFocus = null;
                // A nested dialog or a route change can own focus now. Do not take
                // it back from that surface when this rail closes underneath it.
                const active = document.activeElement;
                const inside = active === el.node || el.node?.contains?.(active);
                if (inside && opener?.isConnected !== false && opener?.focus) opener.focus({
                    preventScroll: true
                });
            }
        },
        // One reader for the phone breakpoint, shared by the create-time seed and
        // the `onWindowResize` prop below. The media query is re-read on every
        // call, so no listener has to carry the previous answer.
        publishRailViewport (el) {
            if (typeof window === 'undefined' || !window.matchMedia) return;
            const matches = !!window.matchMedia('(max-width: 768px)').matches;
            const r = el.getRootState();
            if (r && r._isPhoneViewport !== matches) r.update({
                _isPhoneViewport: matches
            }, {
                preventFetch: true
            });
        }
    },
    position: 'fixed',
    inset: '0',
    zIndex: '1400',
    isOpen: (el, s)=>{
        const open = s.root?._isPhoneViewport !== false && !!s.root?.[el.stateKey];
        el.scope.syncRailFocus(el, open);
        return open;
    },
    dataOpen: (el)=>!!el.isOpen,
    ariaHidden: (el)=>el.isOpen ? 'false' : 'true',
    // Visibility removes closed controls from keyboard navigation. The old
    // translated card still accepted Tab even when it ignored the pointer.
    visibility: 'hidden',
    '&[data-open]': {
        visibility: 'visible'
    },
    // Closed: the whole overlay ignores the pointer; open: it owns it.
    pointerEvents: (el)=>el.isOpen ? 'auto' : 'none',
    dataMobileRail: (el)=>el.stateKey || '',
    // Scrim — plain veil, tap closes. Opacity (compositor-friendly) only.
    // subscribeTo is per-ELEMENT: the root's subscription re-runs the root's own
    // factories, not its children's — Scrim and Card each subscribe themselves.
    Scrim: {
        position: 'absolute',
        inset: '0',
        // Adaptive (was fixed 'black.45') — the design system ships a
        // purpose-built token for exactly this ("Modal/sheet backdrops...
        // `scrimSoft` keeps it readable behind a bottom sheet", color.js).
        background: 'scrimSoft',
        subscribeTo: (el)=>[
                el.parent.stateKey
            ].filter(Boolean),
        opacity: (el, s)=>s.root?.[el.parent.stateKey] ? '1' : '0',
        // The veil's motion in tokens (DESIGN_SPEC §6.4): it fades in on C and
        // out one letter faster, on B (was a raw 220ms both ways). The state
        // reaches the CSS as `data-open` + a static rule — a factory-valued
        // transition would be written inline and could not differ per direction.
        dataOpen: (el, s)=>!!s.root?.[el.parent.stateKey],
        transition: 'opacity B defaultBezier',
        '&[data-open]': {
            transition: 'opacity C defaultBezier'
        },
        onClick: (e, el, s)=>{
            s.root.update({
                [el.parent.stateKey]: false
            }, {
                preventFetch: true
            });
        }
    },
    // Same opaque surface and geometry as AppDialog. Card.Content remains
    // stable so every existing page keeps its own rail content and state key.
    Card: {
        dataRailCard: true,
        role: 'dialog',
        ariaModal: 'true',
        ariaLabel: (el)=>el.parent.railLabel || el.call('polyglot', 'shell.headerTabs.primaryNav'),
        tabindex: '-1',
        subscribeTo: (el)=>[
                el.parent.stateKey
            ].filter(Boolean),
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        width: 'overlaySm',
        // A strip of the page stays in view beside the card: the sheet reads as
        // a drawer over the page, and the scrim strip is a real tap target.
        maxWidth: 'calc(100% - C)',
        boxSizing: 'border-box',
        theme: 'dialog',
        backdropFilter: 'none',
        borderWidth: '0',
        round: '0 radiusSheet radiusSheet 0',
        flow: 'y',
        minWidth: '0',
        overflow: 'hidden',
        overscrollBehavior: 'contain',
        // Notch + home-indicator clearance INSIDE the card so content never
        // hides behind hardware; symmetric A side padding.
        //
        // LONGHANDS, deliberately. The atomic compiler resolves a value that is
        // EITHER a design-system token (`A`) or ONE self-contained raw expression
        // (`calc(env(…) + var(…))` hashes to its own class, same as the shell's
        // `calc(var(--spacing-X) * -1)` rules). A 4-value SHORTHAND that mixes the
        // two forms resolves to neither and empty-rules — the first cut of this
        // file shipped exactly that and the card rendered with padding:0 (caught
        // live at 390px, 2026-08-02). Longhands keep each value in a form the
        // compiler can classify.
        paddingTop: 'calc(env(safe-area-inset-top) + var(--spacing-A))',
        paddingBottom: 'calc(env(safe-area-inset-bottom) + var(--spacing-A))',
        paddingLeft: 'calc(env(safe-area-inset-left) + var(--spacing-A))',
        paddingRight: 'A',
        transform: (el, s)=>s.root?.[el.parent.stateKey] ? 'translateX(0)' : 'translateX(-6.5%)',
        // The side sheet's motion in tokens (§6.4): in on D along the spring the
        // PageSlot window uses, out on C (was a raw 260ms both ways).
        dataOpen: (el, s)=>!!s.root?.[el.parent.stateKey],
        transition: 'transform C defaultBezier',
        '&[data-open]': {
            transition: 'transform D springBezier'
        },
        shadow: 'overlay',
        ':focus-visible': {
            boxShadow: 'var(--shadow-overlay)'
        },
        onKeydown: (e, el)=>{
            if (!e.defaultPrevented) el.call('appDialogTrapTab', e);
        },
        // Grab affordance + label row — the sheet introduces itself, then the
        // consumer's Content takes over.
        Header: {
            flow: 'x',
            align: 'center space-between',
            minWidth: '0',
            flexShrink: '0',
            marginBottom: 'Z',
            Title: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                text: (el)=>el.parent.parent.parent.railLabel || el.call('polyglot', 'shell.headerTabs.primaryNav')
            },
            // THE house close X (brand CloseButton — F2, one X for every panel);
            // the coarse-pointer 44pt tap slop comes from its IconButton base.
            CloseButton: {
                onClick: (e, el, s)=>{
                    s.root.update({
                        [el.parent.parent.parent.stateKey]: false
                    }, {
                        preventFetch: true
                    });
                }
            }
        },
        // Consumer content mounts here (childExtends/children supplied by the
        // app). minWidth 0 so nothing inside can force horizontal overflow.
        Content: {
            flow: 'y',
            minWidth: '0',
            minHeight: '0',
            flex: '1',
            overflow: 'auto',
            overscrollBehavior: 'contain'
        },
        // Close on left-flick over the open sheet — the mirror of the opening
        // pull, so the gesture is symmetric. FA503: declared handlers on THIS
        // element's own node, so DOMQL registers each once and removes it in
        // dispose(). The pre-fix shape armed them from `onRender` behind a
        // `node.__railFlickArmed` latch and never removed either one; the gesture
        // origin lived in a closure that the latch then pinned for the node's
        // whole life. It rides own element fields now (the `el._docClickGuard`
        // idiom already used across this package) — per instance, collected with
        // the element, never a global and never a signal.
        onPointerdown: (e, el)=>{
            el.__railFlickX = e.clientX;
            el.__railFlickY = e.clientY;
        },
        onPointerup: (e, el)=>{
            const sx = el.__railFlickX;
            if (sx == null) return;
            const dx = e.clientX - sx;
            const dy = Math.abs(e.clientY - el.__railFlickY);
            el.__railFlickX = null;
            if (dx < -56 && dy < 48) el.getRootState().update({
                [el.parent.stateKey]: false
            }, {
                preventFetch: true
            });
        }
    },
    // Viewport watcher — publishes the phone breakpoint to root state so the
    // `hide` factory above stays correct across resizes/rotation.
    //
    // FA503 / Rule 64: was a MediaQueryList `change` listener latched on a
    // `window.__railViewportWatch` global — a global WRITE, never removed, and
    // it pinned the FIRST sheet's element for the life of the tab (a second
    // rail, or a re-mounted one, published through a dead element). `resize` is
    // the framework-owned window event that carries the same edge; the query
    // itself is still the source of truth, re-read on every call.
    onCreate: (el)=>el.scope.publishRailViewport(el),
    onWindowResize: (ev, el)=>el.scope.publishRailViewport(el),
    onRemove: (el)=>el.scope.syncRailFocus(el, false),
    // Escape closes (hardware keyboards exist on phones too). Was a raw
    // `doc.addEventListener('keydown')` latched on `doc.__railEscArmed` with no
    // removal: the first sheet to render owned the only listener, kept its
    // element alive after unmount, and closed by ITS `stateKey` forever.
    onDocumentKeydown: (e, el)=>{
        if (e.key !== 'Escape' || e.defaultPrevented) return;
        const key = el.stateKey;
        const r = el.getRootState();
        if (!key || !r?.[key] || r._isPhoneViewport === false) return;
        const layer = typeof el.context?.functions?.shellOverlayOpen === 'function' ? el.call('shellOverlayOpen') : null;
        if (layer && layer !== 'mobileRail') return;
        // A portal dialog can sit outside this rail, and an inline dialog can
        // sit inside it. The nearest dialog owns Escape in both cases.
        const target = e.target || typeof document !== 'undefined' && document.activeElement;
        const dialog = target?.closest?.('[role="dialog"], [aria-modal="true"]');
        if (dialog && dialog !== el.Card?.node) return;
        e.preventDefault?.();
        e.stopPropagation?.();
        r.update({
            [key]: false
        }, {
            preventFetch: true
        });
    }
};

});

parcelRegister("eqDg1", function(module, exports) {

$parcel$export(module.exports, "WorkspaceSwitcherItem", () => $a811f21736184a02$export$67852071a44b6476);
// WorkspaceSwitcherItem — one workspace row for /studio/<owner> switchers.
//
// The old in-page `WorkspaceSwitcher` wrapper (Trigger + `_wsSwitcherMenuOpen`
// panel + document outside-click) was DELETED 2026-06-10: it was a dead,
// unmounted duplicate of the board workspace switcher, which now lives on the
// @symbo.ls/dropdown plugin (`boardWsSwitcher` in canvas/pages/studios.js).
// This row stays because the /studio sidebar's workspaces section
// (canvas/pages/dashboard.js) childExtends it.
//
// Data source: `root._workspacesForOwner` and `root._activeWsSlug` — both
// populated by the studios page; rows write via `el.router` so deep-links
// stay shareable.
const $a811f21736184a02$export$67852071a44b6476 = {
    // FA204 / frank trap — ownerSlugFromPath used to be a bare module-scope
    // const read from inside `onClick` (a serialized factory); it reads as
    // undefined once this component is frank.toJSON'd for platform delivery
    // (workspace d6ea1142, project_frank_drops_module_local_helpers). Moved
    // into `scope`, called via `el.scope.ownerSlugFromPath`.
    scope: {
        ownerSlugFromPath: (path)=>{
            const segs = (path || '').split('/').filter(Boolean);
            return segs[0] === 'workspaces' || segs[0] === 'studio' ? segs[1] || '' : '';
        }
    },
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    width: '100%',
    padding: 'Z1 A',
    round: 'radiusControl',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    color: 'title',
    textAlign: 'left',
    // Active = the house `selected` wash; non-active returns undefined, NOT
    // 'transparent' — an inline transparent background outranks the `:hover`
    // class wash (same trap as AppOrgSwitcher, 261be696).
    background: (el, s)=>s.root?._activeWsSlug === s.slug ? 'selected' : undefined,
    ':hover': {
        background: 'hover'
    },
    Name: {
        tag: 'span',
        flex: '1',
        text: (el, s)=>s.displayName || s.slug || 'workspace'
    },
    Check: {
        tag: 'span',
        color: 'green',
        text: (el, s)=>s.root?._activeWsSlug === s.slug ? "\u2713" : ''
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const path = s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
        const owner = el.scope.ownerSlugFromPath(path);
        if (!owner) return;
        const target = s.slug ? `/studio/${owner}/${s.slug}` : `/studio/${owner}`;
        el.router(target, el.getRoot());
    }
};

});

parcelRegister("lPQ46", function(module, exports) {

$parcel$export(module.exports, "LangSwitcherItem", () => $fe56bf6d96daec2a$export$dde008690a1a9e35);
$parcel$export(module.exports, "LangSwitcherMenu", () => $fe56bf6d96daec2a$export$52f105f5bb756a34);
$parcel$export(module.exports, "LangSwitcher", () => $fe56bf6d96daec2a$export$7c78b168673b6051);
// LangSwitcher — interface language selector. Migrated 2026-06-03 from
// a bespoke `dropdown.update({ style: {...} })` toggle to the
// @symbo.ls/dropdown plugin so positioning + edge-flip + outside-click
// + ESC dismiss are all owned by the shared DropdownRoot.
//
// The list comes from `functions/languages.js` — the platform's canonical
// language registry — not from a local copy. The four codes that used to be
// hardcoded here (en/de/fr/es) included three whose `i18n/<lang>/*.json`
// bundles were empty `{}`: picking one silently kept the whole UI in English,
// which reads as a broken translation rather than an absent language. Adding a
// language is now ONE edit to `PLATFORM_LANGUAGES` plus its bundles.

var $cvFPD = parcelRequire("cvFPD");
const $fe56bf6d96daec2a$export$dde008690a1a9e35 = {
    // House menu row (MenuPanelItem) so it inherits the shared visible :hover
    // wash + chrome — reuse the dropdown recipe instead of a bespoke Button
    // (which had no :hover at all).
    extends: 'MenuPanelItem',
    flow: 'x',
    gap: 'Z1',
    Code: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'caption',
        width: 'B',
        text: (el, s)=>(s.code || '').toUpperCase()
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        // The ENDONYM — a language is named in its own language, never translated
        // into the current one ("Deutsch", not "German"). Georgian has no letter
        // case, so no casing is applied to it anywhere.
        //
        // Width: Georgian sets 12–17% longer than English, and `ქართული` is the
        // longest label the registry can produce today. MenuPanelItem carries
        // `whiteSpace: 'nowrap'`, so the row cannot wrap — but the panel below
        // sizes on content (`minWidth: 'G'` ≈ 6 steps up the spacing sequence,
        // `maxWidth: '100%'`), which is several times the ~95px the widest
        // Code+gap+Label row needs. No clipping, no restyle required.
        text: (el, s)=>s.endonym || s.code || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('closeDropdown', 'langSwitcher');
        // `el.call` binds `this` to the element inside `setLang`, which is how it
        // reaches `context.polyglot`, the root state and the SDK. It used to be an
        // arrow function, which cannot take that binding — the click changed
        // `<html lang>` and localStorage and nothing else.
        el.call('setLang', s.code);
    }
};
const $fe56bf6d96daec2a$export$52f105f5bb756a34 = {
    extends: 'MenuPanel',
    minWidth: 'G',
    textAlign: 'left',
    childExtends: 'LangSwitcherItem',
    childrenAs: 'state',
    // The registry rows verbatim ({ code, endonym, english, dir }) — no derived
    // copy, so the switcher can never drift from what the platform ships.
    children: (0, $cvFPD.PLATFORM_LANGUAGES)
};
const $fe56bf6d96daec2a$export$7c78b168673b6051 = {
    position: 'relative',
    flow: 'y',
    gap: 'Y',
    // THE lock test, carried on `scope` so no serialized handler reads a bare
    // module-scope binding (FA204 — the same reason `LanguageSelectField` carries
    // `endonym` here rather than importing it inside a prop). The resolution is
    // INLINED rather than calling `functions/languages.js`'s `resolveLang`: that
    // file is a frank section barrel and a cross-barrel read from inside a
    // serialized prop is unresolvable in the eval-revived runtime. Pinned to
    // `setLang`'s own gate by __tests__/i18nBootLanguage.test.js, which fails on
    // any root where this lock and that refusal disagree.
    scope: {
        SUPPORTED: [
            'en',
            'ka'
        ],
        // The ONE language `setLang` accepts inside the active workspace, or null
        // when it accepts any (no active workspace — a standalone or public
        // surface).
        //
        // THE LAW (Nika, 2026-09-10): inside a workspace its RESOLVED language
        // rules — enforced pair → `settings.language` → the white-label brand →
        // English — under 'default' and 'enforced' alike. `applyWorkspaceLangPolicy`
        // re-applies that on every active-workspace event, so an unlocked switcher
        // here offered a switch that painted and then snapped back. A record still
        // IN FLIGHT (an id, no `settings`, not stamped full) holds the active
        // language, exactly as the policy and `setLang` hold it.
        lockedLang (root) {
            const ws = root && root.workspace && typeof root.workspace === 'object' ? root.workspace : null;
            if (!ws) return null;
            const list = this.SUPPORTED || [];
            const ok = (c)=>typeof c === 'string' && list.indexOf(c) !== -1;
            const settings = ws.settings && typeof ws.settings === 'object' ? ws.settings : null;
            const pending = !settings && ws._shape !== 'full' && !!(ws.id || ws._id) && !ws._completionUnreachable;
            if (pending) return ok(root.lang) ? root.lang : 'en';
            const brand = root.whitelabelBrand && root.whitelabelBrand.lang;
            return (settings && settings.languagePolicy === 'enforced' && ok(settings.language) ? settings.language : null) || (settings && ok(settings.language) ? settings.language : null) || (ok(brand) ? brand : null) || 'en';
        }
    },
    Trigger: {
        extends: 'Button',
        padding: 'Z1 A',
        round: 'radiusControl',
        // A locked switcher is not a control. `disabled` is what says so to the
        // keyboard and to assistive tech, and the primitive owns the `:disabled`
        // look (Rule 65) — nothing about the state is restyled here.
        disabled: (el, s)=>!!el.scope.lockedLang(s.root),
        cursor: (el, s)=>el.scope.lockedLang(s.root) ? 'default' : 'pointer',
        theme: 'tertiary',
        // Rule 48 — no hardcoded user-facing string, including the accessible
        // name. The function form (not `{{ … | polyglot }}`) is used because these
        // are ATTRIBUTES: a template resolves ONCE, in the static attribute pass,
        // and would print its own braces into a tooltip. `polyglot` always returns
        // a string, and a reactive prop re-evaluates when the root state's `lang`
        // changes, so the label follows the switch.
        //
        // Under a lock the name says the workspace owns the language, rather than
        // offering a change that will not happen — a control announced as "Change
        // language" and then refusing is worse than one that says why.
        title: (el, s)=>el.call('polyglot', el.scope.lockedLang(s.root) ? 'common.language.lockedByWorkspace' : 'common.language.change'),
        'aria-label': (el, s)=>el.call('polyglot', el.scope.lockedLang(s.root) ? 'common.language.lockedByWorkspace' : 'common.language.change'),
        'aria-haspopup': (el, s)=>el.scope.lockedLang(s.root) ? null : 'menu',
        Code: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            // The two-letter CODE, always Latin — `.toUpperCase()` is a no-op on
            // Georgian text but the code itself is `ka`, so the trigger reads `KA`.
            //
            // Under a lock this shows the ENFORCED code, not `root.lang`. They agree
            // once the policy has been applied, but this prop is also what paints
            // during the window before it — and a trigger that briefly advertises a
            // language the workspace refuses is the one thing a locked control must
            // never do.
            //
            // FA515 — `lang` is read UNCONDITIONALLY, into a local, BEFORE the lock
            // is consulted. On the right of a `||` a locked run short-circuits past
            // the signal and never tracks it, so leaving the enforced workspace
            // would leave this trigger frozen on the enforced code.
            text: (el, s)=>{
                const active = s.root?.lang;
                return (el.scope.lockedLang(s.root) || active || 'en').toUpperCase();
            }
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            // Layer 2 of the lock. `disabled` above already stops the pointer and the
            // keyboard; this stops everything else that can reach a handler, and it
            // is why the menu's own items need no guard of their own — they are
            // never mounted. `setLang` refuses independently (layer 3), which is what
            // covers the cross-tab echo that reaches no control at all.
            if (el.scope.lockedLang(s.root)) return;
            el.call('openDropdown', {
                anchorEl: el,
                id: 'langSwitcher',
                placement: 'bottom-end',
                // ORGSWITCHER-PANEL-SURFACE-1 sweep: the width lives ONCE, on the body
                // (`LangSwitcherMenu.minWidth: 'G'`). The raw `minWidth: '200px'` that
                // used to sit here pinned the plugin shell to a px value that cannot
                // track an em body — the same shape that made the org switcher paint a
                // strip of the shell's own surface down its right edge. `round` is
                // handed through so the shell matches the body's `radiusCard`.
                round: 'radiusCard',
                content: {
                    extends: 'LangSwitcherMenu'
                }
            });
        }
    },
    // The one line that explains the lock. A disabled control with no reason
    // beside it reads as a bug, not as a policy.
    //
    // `if:` (not `hide:`) so the line does not exist at all where nothing locks
    // (no active workspace) — and it is the LAST child,
    // so the gate resolving after the workspace record hydrates moves nothing
    // already on screen (Rule 66). The same placement the admin card's own
    // `if:`-gated section uses, for the same reason.
    Caption: {
        tag: 'span',
        if: (el, s)=>!!el.scope.lockedLang(s.root),
        fontSize: 'Y2',
        color: 'caption',
        // The FUNCTION form, not `{{ … | polyglot }}`. Nothing on the account
        // path carries a polyglot TEMPLATE (pinned by LanguageSelectField.test.js)
        // — canvas serves this same page at its own /settings, and the function
        // form is the one that registers its own effect and cannot be frozen by
        // the static attribute pass.
        text: (el)=>el.call('polyglot', 'common.language.setByWorkspace')
    }
};

});
parcelRegister("cvFPD", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LANG", () => $91b8d4393cb2442c$export$90898903f0729f34);
$parcel$export(module.exports, "PLATFORM_LANGUAGES", () => $91b8d4393cb2442c$export$917b2c9fe0f89162);
$parcel$export(module.exports, "LANGUAGE_POLICIES", () => $91b8d4393cb2442c$export$3fb2f14f00645f1);
$parcel$export(module.exports, "DEFAULT_LANGUAGE_POLICY", () => $91b8d4393cb2442c$export$58044c1efb309f6d);
$parcel$export(module.exports, "enforcedWorkspaceLang", () => $91b8d4393cb2442c$export$f10805ec5497eae4);
$parcel$export(module.exports, "isSupportedLang", () => $91b8d4393cb2442c$export$d9b582a1f954c2c8);
$parcel$export(module.exports, "langDir", () => $91b8d4393cb2442c$export$cff67007d15cddbd);
$parcel$export(module.exports, "resolveLang", () => $91b8d4393cb2442c$export$8d59e223cd8ebc88);
/**
 * languages.js — the platform's CANONICAL language registry.
 *
 * One source of truth for: which languages the platform ships, how each one
 * is labelled in a switcher, which direction it sets, and how a session's
 * active language is resolved from the three places a preference can live.
 *
 * Every consumer reads from here — `i18nLoader.js` (which bundles to load),
 * `LangSwitcher.js` (what to list), `setLang.js` (what to accept), the boot
 * sequence (what to start in), the account + workspace settings rows, and
 * the server-side allowlist mirror. Adding a language is ONE edit to
 * `PLATFORM_LANGUAGES` plus its `i18n/<code>/*.json` bundles.
 *
 * ── Frank / FA204 trap (same shape as setLang.js and i18nLoader.js) ────────
 * `functions/` is a frank SECTION BARREL: every export in this directory is
 * emitted as its own entry, and a bare module-scope const read from inside an
 * exported function is unresolvable in the eval-revived runtime. So the codes
 * each function needs are INLINED in that function's own body rather than
 * read off the sibling `PLATFORM_LANGUAGES` export. The array stays exported
 * because cross-package consumers (LangSwitcher, settings rows, landing,
 * docs) import it as a normal ESM binding, which is resolvable.
 */ /** The language every surface falls back to. Nika, 2026-09-02: default English. */ const $91b8d4393cb2442c$export$90898903f0729f34 = 'en';
const $91b8d4393cb2442c$export$917b2c9fe0f89162 = [
    {
        code: 'en',
        endonym: 'English',
        english: 'English',
        dir: 'ltr'
    },
    {
        code: 'ka',
        endonym: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        english: 'Georgian',
        dir: 'ltr'
    }
];
const $91b8d4393cb2442c$export$3fb2f14f00645f1 = [
    'default',
    'enforced'
];
const $91b8d4393cb2442c$export$58044c1efb309f6d = 'default';
const $91b8d4393cb2442c$export$f10805ec5497eae4 = (settings)=>{
    const SUPPORTED = [
        'en',
        'ka'
    ];
    const bag = settings || {};
    if (bag.languagePolicy !== 'enforced') return null;
    const code = bag.language;
    return typeof code === 'string' && SUPPORTED.indexOf(code) !== -1 ? code : null;
};
const $91b8d4393cb2442c$export$d9b582a1f954c2c8 = (code)=>{
    const SUPPORTED = [
        'en',
        'ka'
    ];
    return typeof code === 'string' && SUPPORTED.indexOf(code) !== -1;
};
const $91b8d4393cb2442c$export$cff67007d15cddbd = (code)=>{
    const RTL_LANGS = [
        'ar',
        'he',
        'fa',
        'ur'
    ];
    return RTL_LANGS.indexOf(code) !== -1 ? 'rtl' : 'ltr';
};
const $91b8d4393cb2442c$export$8d59e223cd8ebc88 = (sources)=>{
    const SUPPORTED = [
        'en',
        'ka'
    ];
    const src = sources || {};
    const ok = (c)=>typeof c === 'string' && SUPPORTED.indexOf(c) !== -1;
    if (ok(src.workspaceEnforced)) return src.workspaceEnforced;
    if (ok(src.workspaceDefault)) return src.workspaceDefault;
    if (ok(src.brandDefault)) return src.brandDefault;
    return 'en';
};

});


parcelRegister("2SfFY", function(module, exports) {

$parcel$export(module.exports, "LanguageSelectField", () => $217cc8dba46ca639$export$303456c1946c64cb);
$parcel$export(module.exports, "InterfaceLanguageField", () => $217cc8dba46ca639$export$aafdf35c8d01a637);
$parcel$export(module.exports, "InterfaceLanguageSelect", () => $217cc8dba46ca639$export$df751daaf4c947d0);
$parcel$export(module.exports, "LanguageOption", () => $217cc8dba46ca639$export$6fd3f9b5f8169b2d);
// LanguageSelectField — THE one language control for the whole platform.
//
// Surfaces that need a "pick a language" field and must not drift:
//   • the legacy Platform Options grid (pages/settings.js);
//   • the workspace ADMIN default (workspace-shell
//     pages/admin/workspace-settings.js — moved there from
//     pages/admin/dashboard-defaults.js on 2026-09-02), which reaches this by
//     bare key through the shared-library component merge.
//
// The ACCOUNT PAGE carries NO language control since 2026-09-10 (Nika:
// "default language is english. only workspaces that are specifically set as
// Georgian should render in georgian"): the interface language is the
// WORKSPACE's own setting (functions/languages.js resolveLang), so a per-person
// switcher there changed nothing past the next reload. Its Language card had
// carried `InterfaceLanguageSelect` until 2026-09-02, then `LangSwitcher`
// (components/LangSwitcher.js) — the designed dropdown, which now ships in
// the barrel and is mounted on no shell surface. `InterfaceLanguageSelect` + `LanguageOption` are consequently
// UNMOUNTED: kept as the no-portal form of the same control (a native select
// needs no DropdownRoot), not as a live surface. Delete them, or mount them,
// before treating them as either.
//
// Two exports, split by what varies:
//
//   LanguageSelectField     the CHROME and the OPTION LIST. It knows which
//                           languages ship and how to label them. It knows
//                           nothing about where the current value lives or
//                           who writes it, so the admin surface can bind it
//                           to `workspace.settings.language` and an SDK
//                           write without fighting a built-in handler.
//
//   InterfaceLanguageField  the PERSON's own language, bound. Reads
//                           `root.lang`, writes through `setLang`. This is
//                           what every user-facing surface mounts, so the
//                           read and the write exist in ONE place instead
//                           of once per page.
//
// Callers supply only their own labels (`Title.text`, the dropdown header)
// and, for LanguageSelectField, the value + handler.
//
// THE CALLER STILL OWNS ITS OWN LABELS. This file wires only the strings it
// declares itself (the select's `aria-label`); a `Title.text` belongs to the
// surface that mounts the control, because each surface names the control
// differently.
//
// Polyglot IS available everywhere now. `context.polyglot` moved into this
// package's own context.js, and `mergeOneLibrary` copies a top-level key
// wholesale into any consumer that does not declare one — so canvas,
// marketplace and preview all inherit it. Verified by running the real
// `mergeSharedLibraries` over canvas's real context: polyglot absent before,
// present after, 77 keys per language.
//
// It was NOT available when this file was written, and the failure mode is
// worth keeping written down: with the filter unregistered,
// `replaceLiteralsWithObjectFields` returns '' (smbls/packages/utils/string.js)
// and `el.call` returns `undefined` (element/src/methods.js), which the text
// effect skips on its `val != null` guard. Both polyglot forms render EMPTY,
// never the key. Any surface that mounts this control without the shared
// library must supply plain strings.
//
// Every language is labelled by its ENDONYM — its own name in its own
// language. "Georgian" is unreadable to the exact person hunting for
// Georgian.
//
// The canonical registry is functions/languages.js. Nothing here restates a
// language list; adding a language stays ONE edit to PLATFORM_LANGUAGES.
//
// FA204 / frank trap — the registry is read at DEFINITION time for the
// static `options` array, and carried on `scope` for the value label, so no
// serialized handler ever reads a bare module-scope binding. Same shape as
// components/AiModelSwitcher.js.

var $cvFPD = parcelRequire("cvFPD");
const $217cc8dba46ca639$export$303456c1946c64cb = {
    extends: 'SelectDropdownWithTitle',
    scope: {
        LANGS: (0, $cvFPD.PLATFORM_LANGUAGES),
        SUPPORTED: [
            'en',
            'ka'
        ],
        // Code → the language's own name. Falls back to the registry's first
        // entry so a code the platform no longer ships cannot leave the control
        // blank.
        endonym (code) {
            const list = this.LANGS || [];
            for (const lang of list)if (lang.code === code) return lang.endonym;
            return list.length ? list[0].endonym : '';
        },
        // The ONE language `setLang` accepts inside the active workspace, or null
        // when it accepts any (no active workspace — a standalone or public
        // surface). THE LAW (Nika, 2026-09-10): inside a workspace its RESOLVED
        // language rules — enforced pair → `settings.language` → the white-label
        // brand → English — under 'default' and 'enforced' alike, and
        // `applyWorkspaceLangPolicy` re-applies it on every active-workspace event.
        // A record still IN FLIGHT (an id, no `settings`, not stamped full) holds
        // the active language, exactly as the policy and `setLang` hold it.
        //
        // Declared HERE, on the unbound chrome, rather than on
        // `InterfaceLanguageField` below, for a mechanical reason: `scope` merge
        // semantics across an `extends` chain are not something this control
        // should depend on, and a second `scope` block on the subclass would put
        // `endonym` (read by a nested prop) at the mercy of them. Only
        // `InterfaceLanguageField` CALLS it. The workspace-admin card also extends
        // this component and must never lock: the value it edits is the workspace
        // default itself, not the reader's own language.
        //
        // FA204 / frank trap — the resolution is INLINED rather than reading
        // `functions/languages.js`'s `resolveLang` from inside a serialized prop,
        // exactly like the registry inlines its own lists. Pinned to `setLang`'s
        // own gate by __tests__/i18nBootLanguage.test.js.
        lockedLang (root) {
            const ws = root && root.workspace && typeof root.workspace === 'object' ? root.workspace : null;
            if (!ws) return null;
            const list = this.SUPPORTED || [];
            const ok = (c)=>typeof c === 'string' && list.indexOf(c) !== -1;
            const settings = ws.settings && typeof ws.settings === 'object' ? ws.settings : null;
            const pending = !settings && ws._shape !== 'full' && !!(ws.id || ws._id) && !ws._completionUnreachable;
            if (pending) return ok(root.lang) ? root.lang : 'en';
            const brand = root.whitelabelBrand && root.whitelabelBrand.lang;
            return (settings && settings.languagePolicy === 'enforced' && ok(settings.language) ? settings.language : null) || (settings && ok(settings.language) ? settings.language : null) || (ok(brand) ? brand : null) || 'en';
        }
    },
    Title: {
        // The adaptive light/dark neutral pair used for every de-emphasized
        // field label in this family — at full strength. It also carried
        // opacity .65, which faded the label to 4.66:1 in light (admin audit,
        // 2026-09-24): the quiet ink is the de-emphasis, never an opacity.
        color: 'caption'
    },
    SelectDropdown: {
        Dropdown: {
            top: '121%',
            options: (0, $cvFPD.PLATFORM_LANGUAGES).map((lang)=>({
                    key: lang.code,
                    text: lang.endonym
                })),
            ListInDropdown: {
                childProps: {
                    extends: 'KeyValueColumnFields',
                    // NO `text:` here. KeyValueColumnFields already renders the option
                    // label in its own `Text` slot (`s.text || s.value || s.key`), and
                    // this row HAS children, so a `text:` on the row adds a SECOND text
                    // node beside them: every option read "English ✓ English". The row
                    // is a chassis with slots, not a leaf.
                    fontWeight: '400'
                }
            }
        }
    }
};
const $217cc8dba46ca639$export$aafdf35c8d01a637 = {
    extends: 'LanguageSelectField',
    SelectDropdown: {
        // LOCKED whenever there is an active workspace: its resolved language
        // rules (see `lockedLang` above). `DropdownField` is a real
        // `<button>`, so `disabled` is the whole mechanism: the panel cannot open,
        // the control leaves the tab order, and assistive tech announces the state
        // — no bespoke look, no second affordance, and the `:disabled` styling
        // stays owned by the primitive (Rule 65).
        disabled: (el, s)=>!!el.scope.lockedLang(s.root),
        Value: {
            Text: {
                // Reads the ACTIVE language off ROOT STATE, never a snapshot taken
                // at render: the shell's LangSwitcher, another tab, or a fresh
                // account preference can all change it, and this control has to
                // follow rather than describe a stale choice.
                //
                // Under a lock it reads the ENFORCED language instead. The two agree
                // once the policy has been applied, but this prop also paints during
                // the window before it, and a locked field must never show a value
                // the workspace refuses.
                //
                // FA515 — `s.root.lang` is read UNCONDITIONALLY, into a local, BEFORE
                // the lock is consulted. Reading it on the right of a `||` would mean
                // a locked run short-circuits past the signal and never tracks it, so
                // unlocking (leaving the enforced workspace) would leave this label
                // frozen on the enforced language. Same trap the original guard
                // (`s.root && s.root.lang`) was written to avoid.
                text: (el, s)=>{
                    const active = s.root.lang;
                    return el.scope.endonym(el.scope.lockedLang(s.root) || active);
                }
            }
        },
        Dropdown: {
            onChoose: (ev, el, s, ctx, calleeElement)=>{
                // Belt to `disabled`'s braces. A disabled button cannot open this
                // panel, so this is unreachable through the UI — it is here because a
                // control that writes must state its own refusal, not inherit it from
                // a sibling prop that a later edit could drop. `setLang` refuses a
                // third time, which is what covers callers that are not this control.
                if (el.scope.lockedLang(s.root)) return;
                el.call('setLang', calleeElement.state.key);
            },
            ListInDropdown: {
                childProps: {
                    // FA515 — `lang` read unconditionally first; see `Value.Text` above.
                    isActive: (el, s)=>{
                        const active = s.root.lang;
                        return (el.scope.lockedLang(s.root) || active) === s.key;
                    }
                }
            }
        }
    },
    // The one line that says WHY the field is dead. `if:` (not `hide:`) so it
    // does not exist where nothing locks (no active workspace), and LAST so the
    // gate resolving after the workspace record hydrates moves nothing already
    // on screen (Rule 66). `Group` (this control's chassis, via
    // SelectDropdownWithTitle → GroupField) is `flow: 'y'`, so it lands directly
    // under the control it qualifies — where the reader needs it, after they
    // have seen the control.
    Caption: {
        tag: 'span',
        if: (el, s)=>!!el.scope.lockedLang(s.root),
        fontSize: 'Z2',
        color: 'caption',
        // The FUNCTION form, not `{{ … | polyglot }}`. Nothing on the account
        // path carries a polyglot TEMPLATE (pinned by LanguageSelectField.test.js)
        // — canvas serves this same page at its own /settings, and the function
        // form is the one that registers its own effect and cannot be frozen by
        // the static attribute pass.
        text: (el)=>el.call('polyglot', 'common.language.setByWorkspace')
    }
};
const $217cc8dba46ca639$export$df751daaf4c947d0 = {
    tag: 'select',
    theme: 'field',
    minHeight: 'controlH',
    padding: '0 A',
    round: 'radiusControl',
    color: 'title',
    fontSize: 'Z2',
    cursor: 'pointer',
    // The visible RowLabel is not associated with this control by `for`/`id`,
    // so a screen reader would otherwise announce an unnamed combo box.
    //
    // A FUNCTION, not a `{{ … | polyglot }}` string. A static template on an
    // ATTRIBUTE resolves exactly ONCE, in applyAttrsInProps, which then
    // OVERWRITES the prop with the resolved text (element/src/create.js) — the
    // label would freeze in whatever language was active at first paint. Only
    // `text:` gets a reactive template effect. A function-valued flat attribute
    // registers its own createEffect, and `polyglot` reads `root.lang` through
    // `getActiveLang`, so the effect re-fires on every language switch.
    //
    // `settings.language.title` is an EXISTING key in i18n/{en,ka}/settings.json:
    // "Interface language" / "ინტერფეისის ენა". Both bundles ship in
    // `context.polyglot.translations`, so no fetch is involved.
    'aria-label': (el)=>el.call('polyglot', 'settings.language.title'),
    scope: {
        LANGS: (0, $cvFPD.PLATFORM_LANGUAGES)
    },
    // FA808 / Rule 10 — a NAMED component, never an inline `childExtends: {…}`
    // object: frank's serializer cannot carry the inline form, so the published
    // build would render an option-less select. (The neighbouring DigestSelect /
    // MentionSelect rows in MemberProfile.js still use the inline shape; that is
    // pre-existing debt, not a licence to add another one.)
    childExtends: 'LanguageOption',
    childrenAs: 'state',
    children: (el)=>el.scope.LANGS.map((lang)=>({
                value: lang.code,
                text: lang.endonym
            })),
    // FA515 — `s.root.lang` is read UNCONDITIONALLY so the signal is tracked and
    // the control follows a language changed from the shell switcher or another
    // tab.
    value: (el, s)=>s.root.lang,
    // `setLang` owns the entire write. No second writer here.
    onChange: (e, el)=>el.call('setLang', e.target.value)
};
const $217cc8dba46ca639$export$6fd3f9b5f8169b2d = {
    tag: 'option',
    value: (el, s)=>s.value,
    text: (el, s)=>s.text || s.value || ''
};

});

parcelRegister("aX9VO", function(module, exports) {

$parcel$export(module.exports, "ThemeToggle", () => $7f971e4363f8f1eb$export$173e0a822059eddc);
// ThemeToggle — cycles through 'auto' | 'light' | 'dark' theme modes.
// Applies via changeGlobalTheme (never direct data-theme mutation).
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.
// Per DESIGN domain knowledge: never mutate data-theme from project code;
// use changeGlobalTheme(name) from scratch.
//
// Mode arithmetic + persistence live in the shared `cycleTheme` helper
// (shared/functions/cycleTheme.js); the verbose ThemeItem row in
// AppHeader shares the same helper so both surfaces stay in sync.
// An icon-only control, so it is the kit's square (CompactIconButton — the
// icon-button law, DESIGN-WL-ICON-BUTTONS-SQUARE-1). It was the capsule Button
// atom with a `Z1` padding: a 44 px min-height around a narrower glyph box,
// never 1 / 1. The quiet `tertiary` theme and the round plate come from
// IconButton / CompactIconButton.
const $7f971e4363f8f1eb$export$173e0a822059eddc = {
    extends: 'CompactIconButton',
    title: (el, s)=>el.call('labelForTheme', s.root?.themeMode),
    Icon: {
        name: (el, s)=>el.call('iconForTheme', s.root?.themeMode)
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const next = el.call('cycleTheme', s.root);
        // Apply through the framework-approved path so scratch owns data-theme
        // and design-system reprocessing. cycleTheme already wrote root state +
        // localStorage; this surface just needs to flip the runtime theme.
        el.call('changeGlobalTheme', next);
        // An EXPLICIT choice also lands on the user record (user_preferences.
        // themeMode) so it follows the user across devices and wins over `auto`
        // thereafter (Nika 2026-08-16). Fire-and-forget: the local cache above
        // already applied it; the record is the durable copy.
        el.call('persistThemeModeToUser', s.root, el.sdk, next);
    }
};

});

parcelRegister("xk9sQ", function(module, exports) {

$parcel$export(module.exports, "NotificationBell", () => $0642b6e137b61f7c$export$da43598a51abd858);

var $hg33k = parcelRequire("hg33k");

var $kvDhE = parcelRequire("kvDhE");
const $0642b6e137b61f7c$export$da43598a51abd858 = {
    // FA204 / frank trap — unread/slotOpenOnInbox/toggleNotificationsPanel
    // used to be bare module-scope const/function read from inside
    // `active`/`class.isActive`/`hide`/`text`/`onMousedown`/`onClick`
    // factories; they read as undefined once this component is frank.toJSON'd
    // for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`;
    // toggleNotificationsPanel calls its sibling via `this.slotOpenOnInbox`
    // (object-literal properties can't see each other as bare identifiers).
    scope: {
        unread (root) {
            return (root?.notifs || []).filter((n)=>!n.read).length;
        },
        slotOpenOnInbox (root) {
            return root?._canvasSlot === '/inbox';
        },
        toggleNotificationsPanel (e, el, s) {
            e.preventDefault();
            e.stopPropagation();
            // Icon press = the dropdown panel, ALWAYS (see the header note — the
            // PageSlot inbox is the panel's expand affordance, never the icon's).
            // A bell press while the slot inbox is open closes the slot first so
            // the two notification surfaces never stack.
            if (this.slotOpenOnInbox(s.root)) {
                s.root.update({
                    _canvasSlot: null,
                    _canvasSlotSecond: null,
                    _slotFullscreen: null
                });
                return;
            }
            if (typeof el?.context?.functions?.openDropdown !== 'function') {
                el.router('/inbox', el.getRoot());
                return;
            }
            if (s.root?.notificationsPanelOpen) {
                el.call('closeDropdown');
                return;
            }
            // The bell's tooltip must not sit over the panel it just opened (live
            // 2026-09-26: "Notifications" stayed painted over the open popover).
            // Close a tooltip already on screen; `tooltipText` below answers
            // nothing while the panel is open, so a pending show stays dark too.
            el.call('closeTooltip', el.tooltipId || el.key);
            el.call('openDropdown', {
                // Under the bell on a top navbar; beside a left or right rail, from
                // the rail's outer edge (functions/navbarLayout.js navbarMenuAnchor —
                // under the bell it opened over the rail).
                ...el.call('navbarMenuAnchor', 'bottom-start'),
                id: 'notifications',
                // The popover recipe (DESIGN_SPEC §6.1): the shell glass on the
                // overlay elevation, the card radius, the panel's own width token.
                // The plugin Panel is chromeless by default since
                // FW-DROPDOWN-PANEL-STALE-SHELL-PAINT-1; theme + shadow + round opt
                // back in explicitly.
                // The panel's own width (NotificationPanel: overlayMd — the Georgian
                // filter needs it).
                minWidth: 'overlayMd',
                maxHeight: '72dvh',
                round: 'radiusCard',
                theme: 'canvas-card-glass',
                shadow: 'overlay',
                content: {
                    extends: 'NotificationPanel'
                },
                onOpen: ()=>s.root.update((0, $kvDhE.headerOverlayPatch)('notifications', true)),
                onClose: ()=>s.root.update({
                        notificationsPanelOpen: false
                    })
            });
        }
    },
    // The house tooltip, fed by `title` (TitleTooltipTrigger keeps the native one off).
    extends: [
        'IconButton',
        'NavbarTooltipTrigger'
    ],
    // INTERACT-1 item 4 (tickets/sonnet.md, WAVE-H interaction sweep,
    // 2026-08-14/15): live DOM inspection found this button — the other of
    // the two top-left icon-only nav buttons flagged alongside Messenger.js's
    // chat icon — rendering with NEITHER a `title` NOR an `aria-label`
    // attribute. `title` stays flat (unchanged); switched `aria: { label }`
    // to the bare `'aria-label'` kebab key. See Messenger.js's matching note
    // for the full reasoning — including why an `attr: { title }` wrapper was
    // tried and reverted (FA105 Frankability violation + a regression from
    // the framework's own confirmed-correct flat-promotion path).
    title: (el)=>el.call('polyglot', 'shell.notificationBell.tooltip'),
    'aria-label': (el)=>el.call('polyglot', 'shell.notificationBell.tooltip'),
    // The tooltip plugin reads this at SHOW time: nothing to show while the
    // panel is open, so the name never paints over the popover it labels.
    tooltipText: (el, s)=>s.root?.notificationsPanelOpen ? '' : el.call('polyglot', 'shell.notificationBell.tooltip'),
    // The trigger's popup semantics: a dialog, and whether it is open.
    ariaHaspopup: 'dialog',
    ariaExpanded: (el, s)=>s.root?.notificationsPanelOpen ? 'true' : 'false',
    position: 'relative',
    // `notifs` is written by NotificationWrapper AFTER this bell has mounted,
    // so the badge must re-render on that write or it would show the boot-time
    // count forever. `_canvasSlot` drives the slot-path active ring.
    subscribeTo: [
        'notifs',
        'notificationsPanelOpen',
        '_canvasSlot'
    ],
    active: (el, s)=>!!s.root?.notificationsPanelOpen || el.scope.slotOpenOnInbox(s.root),
    ...(0, $hg33k.activeHighlight),
    class: {
        isActive: (el, s)=>!!s.root?.notificationsPanelOpen || el.scope.slotOpenOnInbox(s.root)
    },
    // `name` (not `icon`) — required, not stylistic. See Messenger.js's Icon
    // comment for the full mechanism: IconText.Icon.if never reads the
    // child's own `el.icon`, only `el.name` (or `parent.icon`). This bell
    // rendered empty after smbls `2e4ba032e` removed the SquareButton
    // `icon:'smile'` placeholder that had been masking the wrong key
    // (tickets/opus.md P1, 2026-08-09).
    Icon: {
        name: 'bell',
        boxSize: 'A A'
    },
    // Crisp alarm pill, floated just off the bell's corner. `hide:`, not
    // `if:` — v3.14's `if` is a MOUNT-TIME gate that never re-creates the
    // element: mounted at zero it would stay gone no matter how many
    // notifications arrived (the exact transition a badge exists to show).
    UnreadBadge: {
        hide: (el, s)=>el.scope.unread(s.root) === 0,
        position: 'absolute',
        top: '-X',
        right: '-X',
        minWidth: 'A1',
        height: 'A1',
        padding: '0 W',
        round: 'radiusPill',
        // Fixed alert-badge pairing, deliberately NOT theme-adaptive — an alert
        // reads red on both shells. But brand `red` (#EB6650) is tuned as a PLATE
        // colour, and white on it measures 3.21:1: fine for a dot (3:1 non-text
        // floor) and a fail for a COUNT, which is text. `redDeep` is the same
        // alert red deepened — white on #A83520 = 6.53:1. Measured across every
        // route by the aa-contrast sweep, 2026-08-09; 15 violation groups traced
        // to this one badge shape.
        background: 'redDeep',
        color: 'white',
        fontSize: 'Y2',
        fontWeight: '700',
        lineHeight: '1',
        align: 'center center',
        pointerEvents: 'none',
        text: (el, s)=>{
            const count = el.scope.unread(s.root);
            return count > 99 ? '99+' : String(count);
        }
    },
    // Pointer path = onMousedown (fires on the ORIGINAL target before a
    // reactive re-render can swap the node out from under the gesture — the
    // header's documented dead-click window, most frequent while a PageSlot's
    // load churn re-renders the chrome); keyboard path = onClick with
    // `detail === 0` (Enter/Space synthesize detail-0 clicks). The guard keeps
    // a single pointer gesture from firing the TOGGLE twice (mousedown +
    // click = open-then-close = "the bell doesn't open"). Same split
    // HeaderTabs' _openTab/SearchBtn established.
    onMousedown: (e, el, s)=>{
        if (e.button !== 0) return;
        el.scope.toggleNotificationsPanel(e, el, s);
    },
    onClick: (e, el, s)=>{
        if (e.detail !== 0) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        el.scope.toggleNotificationsPanel(e, el, s);
    }
};

});

parcelRegister("6HheX", function(module, exports) {

$parcel$export(module.exports, "NavbarTooltipTrigger", () => $4e0421c53d944155$export$c81f51240378a674);
// NavbarTooltipTrigger — the house tooltip (brand TitleTooltipTrigger, fed by
// the control's `title`) for a control ON THE NAVBAR. Extend it in place of
// TitleTooltipTrigger beside the button base:
//
//   extends: ['IconButton', 'NavbarTooltipTrigger']
//
// Nika 2026-10-25: "make tooltips smooth and instant … also when its left
// sidebar show tooltips on right and so on". Three props the plugin's
// TooltipTrigger reads at SHOW time (a function-valued custom prop re-runs on
// every read), so each follows the navbar's place as it is now:
//   - `tooltipPlacement`: away from the bar, into the page — under a top bar
//     (as ever), above a bottom bar, right of a left rail, left of a right
//     rail (functions/navbarLayout.js navbarTooltipPlacement);
//   - `tooltipAnchorRect`: on a rail, the rail's outer edge at the control's
//     height (navbarRailRect), so the bubble starts past the rail instead of
//     6px past a glyph that sits inside it; null elsewhere — the control's
//     own box, as ever. A plugin without the prop ignores it;
//   - `tooltipDelay: 0`: the name shows the moment the pointer arrives — the
//     navbar is read by sweeping across it, and the plugin's 250ms first-show
//     delay made every glyph wait.
const $4e0421c53d944155$export$c81f51240378a674 = {
    extends: 'TitleTooltipTrigger',
    tooltipPlacement: (el)=>el.call('navbarTooltipPlacement'),
    tooltipAnchorRect: (el)=>el.call('navbarRailRect'),
    tooltipDelay: 0
};

});

parcelRegister("8pn2a", function(module, exports) {

$parcel$export(module.exports, "DesignSystemBanners", () => $61f2869776b126a7$export$ba63ea72cd7e3c82);
// Ported from platform-legacy/readonly/platform/components/DesignSystemBanners.js
// v3 → v3.14: extend → extends, props: wrapper stripped, childExtend → childExtends.
// TODO: verify TutorialBanner dependency — not in default-config and may need
// to be supplied by a sub-app's components/index.js if this is mounted.
const $61f2869776b126a7$export$ba63ea72cd7e3c82 = {
    extends: 'Flex',
    align: 'stretch space-between',
    gap: 'B1',
    childrenAs: 'state',
    children: [
        {
            title: 'Setting up global themes',
            p: '15 sec tutorial',
            theme: 'theme',
            href: '/design-system/watch/colors'
        },
        {
            title: 'Adding more colors',
            p: '3 mins tutorial',
            theme: 'color',
            href: '/design-system/watch/colors'
        },
        {
            title: 'How typography works',
            p: '3 mins tutorial',
            theme: 'typography',
            href: '/design-system/watch/colors'
        },
        {
            title: 'How to get spacing units',
            p: '45 sec tutorial',
            theme: 'space',
            href: '/design-system/watch/colors'
        },
        {
            title: 'Adding and using icons',
            p: '45 sec tutorial',
            theme: 'icons',
            href: '/design-system/watch/colors'
        }
    ],
    childExtends: 'TutorialBanner'
};

});

parcelRegister("gXhoO", function(module, exports) {

$parcel$export(module.exports, "DesignSystemSummary", () => $c57fa724152a949f$export$1bbac1d71dfc3e3);
// Ported from platform-legacy/readonly/platform/components/DesignSystemSummary.js
// v3 → v3.14: extend → extends. No props: wrapper to flatten.
// TODO: verify SummaryComponent dependency in current sharedLibraries chain.
const $c57fa724152a949f$export$1bbac1d71dfc3e3 = {
    extends: 'Group',
    Title: {
        margin: '- - A',
        text: '{{ editor.ds.title | polyglot }}'
    },
    Box: {
        columns: '14.3rem',
        gap: 'B1',
        style: {
            width: '-webkit-fill-available'
        },
        childExtends: 'SummaryComponent',
        children: (el, s)=>el.call('applyDesignSystemSummaryCollection'),
        childrenAs: 'state'
    }
};

});

parcelRegister("5W12D", function(module, exports) {

$parcel$export(module.exports, "DesignSystemSummaryMinimal", () => $45232d55ad934fbf$export$a28c8f37a430d70f);
// Ported from platform-legacy/readonly/platform/components/DesignSystemSummaryMinimal.js
// v3 → v3.14: extend → extends. Extends DesignSystemSummary (also ported in
// this folder — load order matters; the barrel registers both).
const $45232d55ad934fbf$export$a28c8f37a430d70f = {
    extends: 'DesignSystemSummary',
    Title: {
        text: '{{ editor.ds.title | polyglot }}',
        gap: 'Z',
        margin: '0',
        color: 'caption'
    },
    Box: {
        width: '100%',
        flexFlow: 'row wrap',
        gap: 'Z',
        childExtends: 'SummaryComponent',
        childProps: {
            style: {
                width: '100%'
            },
            margin: '0',
            flex: '0 1 47%',
            DesignComponentProperties: null
        }
    }
};

});

parcelRegister("aqF41", function(module, exports) {

$parcel$export(module.exports, "FilesSidebarGettingStarted", () => $797c2f83a9773975$export$b69a602b401deebe);
// Ported from platform-legacy/readonly/platform/components/FilesSidebarGettingStarted.js
// v3 → v3.14: extend → extends, top-level props: wrapper stripped. The
// childExtends entry that used a v3-style `props: (el, s) => …` factory
// returning a shape object was flattened to per-property reactive
// accessors that each compute `isDone` lazily — same effective behaviour,
// v3.14-compliant.
//
// All el.call('X', …) invocations preserved verbatim (FA001).
//
// TODO: verify FilesSidebarSection / FilesSidebarTitle / FilesSidebarList /
// FilesSidebarListItem / FileSidebarAddNewItem dependencies — these are
// editor-canvas chrome components that may need to come from a separate
// sub-app's components/index.js when this is mounted.
const $797c2f83a9773975$export$b69a602b401deebe = {
    // FA204 / frank trap — isDone used to be a bare module-scope const read
    // from inside the childExtends `pointerEvents`/`text`/`visibility`/
    // `opacity`/`color` factories; it reads as undefined once this component
    // is frank.toJSON'd for platform delivery (workspace d6ea1142,
    // project_frank_drops_module_local_helpers). Moved into `scope`, called
    // via `el.scope.isDone`.
    scope: {
        isDone: (el)=>el.call?.('exec', el.parent?.isDone, el.parent)
    },
    extends: 'FilesSidebarSection',
    theme: 'layer',
    padding: '- Y1',
    margin: '- -Y1',
    textTransform: 'none',
    round: '--canvas-round',
    if: (el)=>el.isEditMode?.(),
    FilesSidebarTitle: {
        position: 'relative',
        theme: null,
        'IconButton.question': null,
        IconButton_arrow: null,
        Span: {
            fontWeight: '300',
            margin: 'Z - Z Y2',
            Text: {
                text: '{{ editor.dashboard.gettingStarted | polyglot }}'
            }
        }
    },
    FilesSidebarList: {
        padding: '- - Z',
        FileSidebarAddNewItem: null,
        onMouseleave: null,
        hide: false,
        childExtends: [
            {
                // v3 had a single `props: (el, s) => { isDone = …; return {…} }`
                // factory here. Flattened to per-property reactive accessors —
                // each re-evaluates `isDone` against the parent's own `isDone`
                // predicate at render time.
                pointerEvents: (el, s)=>el.scope.isDone(el) ? 'none' : 'auto',
                Span: {
                    text: (el, s)=>el.scope.isDone(el.parent) ? '  ' : "\u30FB",
                    Icon: {
                        visibility: (el, s)=>el.scope.isDone(el.parent.parent) ? 'visible' : undefined,
                        opacity: (el, s)=>el.scope.isDone(el.parent.parent) ? 1 : undefined,
                        color: (el, s)=>el.scope.isDone(el.parent.parent) ? 'green' : undefined
                    }
                }
            },
            'FilesSidebarListItem'
        ],
        childProps: {
            fontWeight: '400',
            isActive: false,
            isCurrent: false,
            Span: {
                Icon: {
                    name: 'check',
                    onClick: (ev, el, s)=>{}
                }
            }
        },
        childrenAs: 'props',
        children: ()=>[
                {
                    Text: {
                        text: '{{ learn.checklist.createComponent | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getSchema?.('components') || {}).length > 0,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/add-component');
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.reuseComponent | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getSchema?.('components') || {}).length > 1,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        const componentFound = Object.values(el.getSchema?.('components') || {})[0];
                        if (!componentFound?.key) return el.call('openNotification', {
                            title: el.call('polyglot', 'learn.checklist.noComponent.title'),
                            message: el.call('polyglot', 'learn.checklist.noComponent.message'),
                            type: 'transparentPattern'
                        });
                        await el.call('openRouterModal', '/add-component', {
                            key: componentFound.key + 'Reused',
                            title: (componentFound.title || componentFound.key) + ' Reused',
                            type: 'components',
                            value: {
                                [componentFound.key]: {}
                            },
                            code: `export default {\n  // Reusable component:\n  ${componentFound.key}: {\n    // Overwrite properties... \n  },\n}`,
                            advanced: true
                        });
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.createPage | polyglot }}'
                    },
                    isDone: (el)=>(el.getSchema?.('pages') || {})['/'],
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/add-page', {
                            title: 'Main page',
                            key: '/',
                            type: 'pages',
                            value: {
                                '/': {
                                    H1: {
                                        text: 'Hello Symbols'
                                    }
                                }
                            },
                            code: `export default {\n  '/': {\n    H1: { text: 'Hello Symbols' } \n  },\n}`,
                            advanced: true
                        });
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.openPage | polyglot }}'
                    },
                    isDone: (el)=>el.call?.('getCookie', el.getAppKey?.() + '_projectRemotePageWasViewed'),
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        const pageFound = Object.values(el.getSchema?.('pages') || {})[0];
                        if (!pageFound?.key) return el.call('openNotification', {
                            title: el.call('polyglot', 'learn.checklist.noPage.title'),
                            message: el.call('polyglot', 'learn.checklist.noPage.message'),
                            type: 'transparentPattern'
                        });
                        const url = `https://${el.getAppKey?.()}/${pageFound.key}`;
                        window.open(url, 'Symbols preview');
                        el.call('setCookie', el.getAppKey?.() + '_projectRemotePageWasViewed', true);
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.importLibrary | polyglot }}'
                    },
                    // add flag to confirm component was added
                    // isDone: el =>
                    //   Object.keys(el.getSchema('components')).length > 1,
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        el.call('openLibrary');
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.uploadLogo | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getData?.('files') || {}).length > 0,
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/add-file');
                    }
                },
                {
                    Text: {
                        text: '{{ learn.checklist.addColor | polyglot }}'
                    },
                    isDone: (el)=>Object.keys(el.getData?.('designSystem')?.COLOR || {}).length > 2,
                    onClick: (ev, el)=>{
                        ev.stopPropagation();
                        el.call('activeAddingFloatingPanel', ev, 'color');
                    }
                },
                // {
                //   Text: { text: 'Setup a global theme' },
                //   isDone: el => Boolean(el.getData('designSystem').THEME?.document['@' + el.call('getSystemGlobalTheme')]),
                //   onClick: (ev, el) => {
                //     ev.stopPropagation()
                //     el.call('activeAddingFloatingPanel', ev, 'global_theme')
                //   }
                // }
                {
                    Text: {
                        text: '{{ learn.checklist.publish | polyglot }}'
                    },
                    // isDone: el => {
                    //   const version = el.getRootState('version')
                    //   const parts = version?.split('.') || []
                    //   return parts.length === 3 && parts[1] !== '0'
                    // },
                    isDone: (el)=>el.call?.('getCookie', el.getAppKey?.() + '_projectWasPublished'),
                    onClick: async (ev, el)=>{
                        ev.stopPropagation();
                        await el.call('openRouterModal', '/publish');
                    }
                }
            ]
    }
};

});

parcelRegister("5a3jD", function(module, exports) {

$parcel$export(module.exports, "CanvasDots", () => $3c20755575b97e56$export$2a7c95cb025236f9);
$parcel$export(module.exports, "CanvasSidebarIsland", () => $3c20755575b97e56$export$78019fb2a0da6346);
$parcel$export(module.exports, "CanvasSidebarCard", () => $3c20755575b97e56$export$f6288f6484814ff0);
$parcel$export(module.exports, "CanvasMobileSidebarPanelChrome", () => $3c20755575b97e56$export$ed986ce2617c5199);
$parcel$export(module.exports, "CanvasCreateMenuItem", () => $3c20755575b97e56$export$1f685fe09ab37e14);
$parcel$export(module.exports, "CanvasCreateMenuBody", () => $3c20755575b97e56$export$a973d2c4e2feeb4);
$parcel$export(module.exports, "CanvasCreateIsland", () => $3c20755575b97e56$export$227e57acc237f8ca);
$parcel$export(module.exports, "CanvasPrimaryCreateIsland", () => $3c20755575b97e56$export$b6b82b435d48e44c);
$parcel$export(module.exports, "CANVAS_DOTS_DARK", () => (parcelRequire("jlzPZ")).CANVAS_DOTS_DARK);
$parcel$export(module.exports, "CANVAS_DOTS_LIGHT", () => (parcelRequire("jlzPZ")).CANVAS_DOTS_LIGHT);
// Shared canvas-page scaffold — the chrome every pan/zoom canvas surface
// (/studio, /team-and-agents, /tickets, /files …) was repeating inline:
// the dots layer, the left glass sidebar island, and the floating
// right-center create-"+" island with its glass menu. Extracted
// 2026-06-10 per Nika: "make /team and /tickets page canvases similar to
// /studio — reuse in shared whatever is possible for all those canvas
// pages." /studio remains the visual reference; pages extend these by
// bare key and override only what's page-specific.

var $jlzPZ = parcelRequire("jlzPZ");
const $3c20755575b97e56$export$2a7c95cb025236f9 = {
    position: 'absolute',
    inset: '0',
    pointerEvents: 'none',
    opacity: '0.38',
    style: {
        backgroundImage: 'var(--canvas-dots-image)',
        backgroundSize: '24px 24px'
    },
    '@dark': {
        '--canvas-dots-image': (0, $jlzPZ.CANVAS_DOTS_DARK)
    },
    '@light': {
        '--canvas-dots-image': (0, $jlzPZ.CANVAS_DOTS_LIGHT)
    }
};
const $3c20755575b97e56$export$78019fb2a0da6346 = {
    position: 'absolute',
    left: 'X2',
    // --shell-top (= D1 + 3px, defined once in app.js __shell-content-scroll): kept
    // in lockstep with the shell content offset and the CanvasPageSlot top so the
    // rail's top edge never drifts from a page opened in the slot beside it (+3px
    // navbar-gap nudge 2026-06-24). Passed as the BARE custom-property name so
    // scratch wraps it in var() once (a 'var(...)' or calc value gets re-wrapped /
    // hashed into an empty atomic rule). bottom stays D1 — only the top is shared.
    top: '--shell-top',
    bottom: 'D1',
    width: 'G+C',
    minWidth: 'G+C',
    zIndex: '20',
    flow: 'y',
    gap: 'V',
    pointerEvents: 'auto',
    '@mobileL': {
        position: 'fixed',
        left: 'A',
        right: 'A',
        top: '--shell-top',
        bottom: 'auto',
        width: 'auto',
        minWidth: '0',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        maxHeight: '34dvh',
        overflow: 'auto'
    }
};
const $3c20755575b97e56$export$f6288f6484814ff0 = {
    extends: 'CanvasSidebarIsland',
    theme: 'dialog',
    // Longhand — the theme re-emits border longhands after shorthands.
    borderWidth: '0',
    round: 'radiusCard',
    padding: 'A',
    overflow: 'auto',
    shadow: 'float',
    '@mobileL': {
        padding: 'Z1',
        round: 'radiusCard'
    }
};
const $3c20755575b97e56$export$ed986ce2617c5199 = {
    // Border habit removed — the opaque `document` fill + `shadow: 'overlay'`
    // elevation already fully separate this panel from the dotted canvas
    // behind it (design-direction.md §8 — fill contrast, not a stroke).
    background: 'document',
    color: 'title',
    // An opaque sheet in both skins (the skin contract): no backdrop filter.
    // The glass theme a consumer carries on desktop (canvas-card-glass, 35px)
    // would still blur a backdrop this opaque fill covers completely — 'none'
    // switches that cost off. (It was a literal blur(18px) that no pixel showed.)
    backdropFilter: 'none',
    animation: 'none',
    shadow: 'overlay'
};
const $3c20755575b97e56$export$1f685fe09ab37e14 = {
    extends: 'MenuPanelItem',
    attr: {
        role: 'menuitem'
    },
    title: (el)=>el.label || '',
    flow: 'y',
    align: 'start left',
    gap: '2px',
    // Visible hover so these rows highlight clearly when reused as the cascade
    // menu's 2nd-level flyout — MenuPanelItem's inherited hover (gray6.05) is
    // near-invisible on the dark canvas glass. Matches the cascade's 1st-level
    // row wash (2026-06-14 per Nika "second level of context menu has no hover").
    // Flat `hover` token prop — a :hover block of only @dark/@light sub-blocks
    // emits nothing through css-in-props, and the token pair is byte-identical.
    ':hover': {
        background: 'hover'
    },
    Name: {
        tag: 'span',
        display: 'flex',
        flow: 'x',
        gap: 'Y',
        align: 'center left',
        Icon: {
            icon: (el)=>el.parent?.parent?.iconName || '',
            fontSize: 'Z2',
            opacity: '0.65',
            ariaHidden: 'true'
        },
        Label: {
            tag: 'span',
            text: (el)=>el.parent?.parent?.label || '',
            fontSize: 'Z2',
            fontWeight: '700'
        }
    },
    Hint: {
        tag: 'span',
        text: (el)=>el.parent?.hint || '',
        fontSize: 'Z',
        color: 'caption'
    }
};
const $3c20755575b97e56$export$a973d2c4e2feeb4 = {
    extends: 'MenuPanel',
    minWidth: '220px',
    gap: '2px',
    ariaLabel: (el)=>el.call('polyglot', 'editor.canvasCreate.new'),
    '@mobileL': {
        minWidth: '220px',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        maxHeight: '60dvh',
        overflow: 'auto'
    }
};
const $3c20755575b97e56$export$227e57acc237f8ca = {
    position: 'absolute',
    top: '50%',
    right: 'V',
    transform: 'translateY(-50%)',
    zIndex: 30,
    padding: 'V',
    round: 'radiusPill',
    theme: 'dialog',
    borderWidth: '0',
    flow: 'y',
    gap: 'V',
    align: 'center',
    pointerEvents: 'auto',
    shadow: 'float',
    // THE MIRROR (opt-in — functions/pageSidebar.js): the island sits opposite
    // the page's sidebar. A page whose sidebar follows the side rule sets
    // `data-sidebar-side` on its island (`(el, s) => el.call('pageSidebarRead',
    // s.root, el).side`); beside a left navbar the sidebar is on the right, so
    // the island takes the left edge. An island without the attribute stays
    // where it is (a page whose sidebar has not moved yet). The phone reads
    // 'left' (its own dock below holds).
    '&[data-sidebar-side="right"]': {
        right: 'auto',
        left: 'V'
    },
    '@mobileL': {
        position: 'fixed',
        top: 'auto',
        right: 'A',
        // Sit above the composer AND the phone suggestion-chip row (--chip-row,
        // defined in the shell's band system in workspace/app.js). A flat D1 put
        // every canvas FAB — studios, tickets, team, infra — inside the chips'
        // band, and the chips paint over them.
        bottom: 'calc(var(--slot-bottom) + var(--chip-row))',
        transform: 'none',
        flow: 'x'
    },
    AddBtn: {
        tag: 'button',
        type: 'button',
        width: 'controlHCompact',
        height: 'controlHCompact',
        round: '50%',
        border: '0',
        // INVARIANT for consumers: this ink is correct ONLY against the
        // translucent washes declared just below (and against the `overlay`
        // washes CanvasNavbar/StudioNavbar substitute). It is a top-level
        // declared prop, so since smbls f6757537d — which made declared props
        // beat the `theme:` compound — it OUTVOTES any `theme:` an extending
        // consumer sets. A consumer that overrides the fill to a solid ink
        // primary must therefore declare its own `color:` too; `theme: 'primary'`
        // alone will silently keep this `title` and paint ink-on-ink. That is
        // exactly how the tickets board create button reached 1.13:1 with an
        // invisible "+" (fixed workspace cf0323af — see tickets/fable.md).
        // Audited 2026-08-09: board.js was the only consumer overriding the
        // fill; infra, CanvasNavbar, StudioNavbar, team-and-agents and
        // ProjectCanvasSidebar all pair correctly with a wash or set their own
        // ink. Do NOT "fix" this by moving the colour into the @-blocks (same
        // specificity, no effect) or by deleting it (every default island then
        // drops from `title` to the island's dimmer inherited caption ink).
        color: 'title',
        '@dark': {
            background: 'white.08',
            ':hover': {
                background: 'white.18'
            }
        },
        '@light': {
            background: 'black.06',
            ':hover': {
                background: 'black.12'
            }
        },
        fontSize: 'B',
        fontWeight: '400',
        lineHeight: '1',
        cursor: 'pointer',
        title: (el)=>el.call('polyglot', 'common.action.create'),
        ariaLabel: (el)=>el.call('polyglot', 'common.action.create'),
        ariaHaspopup: 'true',
        text: '+',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const island = el.parent;
            const content = island?.menuContent;
            if (!content) return;
            el.call('openDropdown', {
                id: island.menuId || 'canvasCreate',
                anchorEl: el,
                placement: 'left-start',
                content: content
            });
        }
    }
};
const $3c20755575b97e56$export$b6b82b435d48e44c = {
    extends: 'CanvasCreateIsland',
    AddBtn: {
        // The island's base '+' text glyph is replaced by the DS `plus` icon.
        text: null,
        align: 'center center',
        // Solid-ink primary fill. The island's inherited translucent washes are
        // overridden per theme to the primary fill so the solid-ink look renders.
        // The base island also nests a wash `:hover` INSIDE each @-block, which
        // outvotes the `theme: 'primary'` hover pair — so the hover/active steps
        // are re-declared here from the theme's own auto vars (measured live
        // 2026-08-21: without this, hover painted rgba(0,0,0,.12) under white ink).
        '@dark': {
            background: '--theme-primary-background',
            ':hover': {
                background: '--theme-primary-hover-background'
            },
            ':active': {
                background: '--theme-primary-active-background'
            }
        },
        '@light': {
            background: '--theme-primary-background',
            ':hover': {
                background: '--theme-primary-hover-background'
            },
            ':active': {
                background: '--theme-primary-active-background'
            }
        },
        // @coarse touch-target floor; fine pointers unaffected.
        '@coarse': {
            minWidth: 'C',
            minHeight: 'C'
        },
        ':active': {
            transform: 'scale(0.96)'
        },
        theme: 'primary',
        // The INK must be declared explicitly — the base CanvasCreateIsland.AddBtn
        // declares a top-level `color: 'title'` that outvotes the theme compound
        // (smbls f6757537d); `theme: 'primary'` alone paints ink-on-ink.
        color: '--theme-primary-color',
        Icon: {
            extends: 'Icon',
            name: 'plus',
            boxSize: 'A',
            pointerEvents: 'none'
        }
    }
};

});

parcelRegister("hDEG5", function(module, exports) {

$parcel$export(module.exports, "AgentAvatar", () => $cd75a1fa1866722b$export$38b71b080e1832c8);
// AgentAvatar — the agent presence circle from the landing HeroCanvas
// (company/packages/landing/components/HeroCanvas.js _agentAvatar), promoted
// to shared per Nika 2026-06-12 ("show agent avatar that we use in landing —
// you can also move it to shared AgentAvatar — and reuse it here"): a yellow
// circle wearing the robot glyph as a CSS mask, so the glyph punches through
// in the surface color. Size by overriding boxSize; colors are DS tokens
// (the landing keeps its cv* palette locally).
// Robot glyph (antenna + head + two eye holes via even-odd), inlined as a
// data-URI for use as a CSS mask.
const $cd75a1fa1866722b$var$ROBOT_SVG = "url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><circle cx='12' cy='2.6' r='1.3' fill='black'/><rect x='11.3' y='2.8' width='1.4' height='3.2' fill='black'/><path fill='black' fill-rule='evenodd' d='M8 5.8h8a4 4 0 0 1 4 4v5.4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9.8A4 4 0 0 1 8 5.8ZM9.2 10.2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4ZM14.8 10.2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Z'/></svg>\")";
const $cd75a1fa1866722b$export$38b71b080e1832c8 = {
    tag: 'span',
    flow: 'x',
    align: 'center center',
    boxSize: 'Z1 Z1',
    round: '50%',
    flexShrink: '0',
    background: 'yellow',
    Bot: {
        tag: 'span',
        width: '66%',
        height: '66%',
        background: 'document',
        // FLAT props, never `style:` — an inline style block is applied with
        // setProperty and gets no -webkit- twin, while a flat mask longhand's class
        // rule carries both spellings (atomic VENDOR_TWINS).
        maskImage: $cd75a1fa1866722b$var$ROBOT_SVG,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center'
    }
};

});

parcelRegister("fqlx7", function(module, exports) {

$parcel$export(module.exports, "PageSlotHeaderBtn", () => $b3a9fcbf281672f8$export$65e8b74d68d9724e);
// Round transparent icon button with the house `hover` wash — the recipe the
// PageSlot pane header (Back / Forward / Expand / Split / Fullscreen /
// Minimize / Close) and the MinimizedDock dismiss use. Promoted to shared
// 2026-07-12 (/simplify review); the same shape used to exist inline in
// CanvasSplitView.CloseBtn and the HeaderTabs / AppHeader circle buttons.
//
// F2 "one close button" (Nika 2026-08-16): re-based on brand `IconButton`
// with the exact geometry of brand `CloseButton` — `controlHCompact` (36px)
// circle, `iconSm` (16px) glyph, no fill at rest, `hover` wash, caption→title
// ink — so a PageSlot / MinimizedDock X is pixel-identical to every other
// sidebar and modal X. Consumers keep passing their own `Icon` (name); an
// `Icon` override that only names the glyph inherits `iconSm` from here.
// Touch controls use the standard controlH box so adjacent targets do not
// overlap. Fine-pointer desktop controls keep the compact house geometry.
// IconButton also brings the accessible name: a reactive `aria-label` that
// follows the `title` (or a name the call site declares). Fixed-px on purpose —
// device-physical chrome must not scale with the surface's font size
// (sizes.js §3/§6).
// Tooltips (2026-09-02 per Nika "add tooltips to pageslot header icons"):
// the house plugin surface, not the native delayed title. Consumers keep
// passing `title`; the brand `TitleTooltipTrigger` hands it to the plugin and
// keeps the native attribute off so the two surfaces never double up. Hosts
// without a shell-mounted TooltipRoot simply never receive openTooltip — the
// same graceful degrade every NavbarButton consumer already relies on.
//
// This file used to carry a VERBATIM paste of the NavbarButton bridge (a
// one-shot `onRender` copy of the title into `tooltipText` and `aria-label`).
// The copy froze both at the FIRST render's language — English on a Georgian
// boot — and, being a paste, it missed the brand fix that retired the same
// copy there (3.14.791). The bridge is one brand component now; this button
// keeps no copy of it (pageSlotHeaderBtnTooltip.test.js).
const $b3a9fcbf281672f8$export$65e8b74d68d9724e = {
    extends: [
        'IconButton',
        'AppControl',
        'TitleTooltipTrigger'
    ],
    compact: true,
    theme: 'transparent',
    type: 'button',
    boxSize: 'controlHCompact',
    padding: '0',
    round: '50%',
    flexShrink: '0',
    align: 'center center',
    background: 'transparent',
    color: 'inactive',
    cursor: 'pointer',
    transitionProperty: 'background, color',
    transition: 'A defaultBezier',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    '@coarse': {
        boxSize: 'controlH',
        ':after': {
            inset: '0'
        }
    },
    Icon: {
        boxSize: 'iconSm',
        display: 'block',
        flexShrink: '0'
    }
};

});

parcelRegister("fv7w7", function(module, exports) {

$parcel$export(module.exports, "VoiceOverlay", () => $b48f94ff0fac2750$export$86135c822d056ca8);
// The voice CALL SCREEN — the expanded posture of a voice session, behind the
// Expand button of the call bars (the in-composer VoiceStrip and the island).
// Mounted ONCE per app root next to ModalRoot (workspace/app.js always;
// canvas/app.js gated `if: !_inShell` so the shell's mount serves embedded
// canvas). Session mechanics (mic, the live voice agent of a talk call, the
// server voice engines — Whisper STT + 11labs TTS — and command routing) live
// in functions/voiceSession.js and in this component's `scope`; this
// component owns the screen:
//
//   • edge glow — the brand `themeDark` conic gradient, blurred and masked to
//     the viewport edges, hue-drifting and swelling with the live mic level
//   • the call (2026-10-22, the call redesign — the anatomy of the Fly call
//     Nika approved for shaker): who you are talking to and the clock across
//     the top with Minimize; the orb and the status word; the conversation as
//     captions; Stop speaking / Try again in a reserved slot; Type · End ·
//     Mute. All of it the SHARED call chrome (components/VoiceControls.js).
//
// ONE POSTURE since the island unification (T14, tickets/ai-fable.md): this
// overlay is the FULL immersive surface only. The island (SimoneReasoningPill)
// renders the minimized call. While minimized, THIS element stays mounted and
// keeps hosting the engine (scope handles, onStateUpdate watcher, Esc
// binding); only its visuals hide. The island reads the analyser straight off
// this element's scope via the same lookdown the engine uses.
//
// All 60 fps work happens in `onFrame` via `setNodeStyles` (never state), and
// show/hide is the ModalCard opacity pattern — `.isActive` bound to
// `s.root.voiceOpen` — so enter/exit transitions survive. The orb's ring
// carries NO transform transition on purpose: a running transition pins a
// property the frame loop rewrites constantly (see
// reference_css_transition_defeats_important).
// VoiceLangItem/VoiceLangMenu/VOICE_LANGS retired
// (VOICE-TALK-ONLY-REMOVE-DEAD-CONVAI-UI-1): voiceLang had no reader in the
// Simone loop — voiceTranscribe sends no language hint and
// voiceTts({ text }) sends none (Whisper auto-detects, per voiceSession.js's
// own header) — so the picker changed nothing a Talk user heard.
// Talk-mode turns are read straight off the live assistant thread, so the
// streamed reply APPENDS into a scrolling log instead of one line being
// replaced (2026-08-02 per Nika). `voiceChatKey` is the surface prefix the
// session captured at start ('' general | '_ax_' add-app | '_db_' dashboard) —
// the same namespacing sendPrompt uses.
// ——— voice ⟷ chat exclusivity (2026-08-06 per Nika "when voice is open, no
// point to have chat - they are morphing into each other") ———
//
// While a voice surface is in the FOREGROUND — the full overlay or a composer
// strip: `voiceOpen && (voiceHost || !voiceMinimized)` (the strip deliberately
// ignores the minimized axis, so `voiceHost` alone keeps it visible) — an open
// assistant drawer would stream the very same conversation beside it: command
// turns dispatch through sendPrompt into the exact thread the drawer renders,
// while the voice log mirrors them into `voiceTurns`. So on the foreground
// rising edge the drawer is docked to its EXISTING 'minimized' posture (the
// shipped MinimizeBtn path — pill-handle semantics, animated hide, grid column
// released) and restored when the session ENDS.
//
// Deliberately asymmetric: restore fires on the voiceOpen FALLING edge (session
// end), never on minimize — after _commitAssistant hands off to the island
// (`voiceMinimized: true`), the island IS the streaming surface, and
// re-expanding the drawer at that exact moment would put the same reply on
// screen twice again. The island's own close is the restore moment.
//
//   • plain root.update, never setAssistantDock — that helper persists the dock
//     to localStorage, and this is session choreography (the same distinction
//     _syncShellRoute's reveal-on-open documents in workspace/app.js).
//   • voiceHost === 'chat' is exempt: the strip renders INSIDE the drawer's own
//     composer there — the drawer IS the voice surface.
//   • edge-triggered via scope-held previous flags: a user who re-expands the
//     drawer mid-session wins — suppression asserts once at open, never again.
//   • memory lives on this element's scope (the session host every other voice
//     runtime handle lives on), NOT a new root key: it cannot outlive the
//     session, needs no state-registry pairing, and can never leak across
//     workspace switches.
//   • gated on root.assistantOpen being truthy — canvas/preview roots never
//     declare assistant keys (undeclared-root-key rule) so they never take a
//     write; the restore branch only runs if this helper minimized the drawer.


const $b48f94ff0fac2750$export$86135c822d056ca8 = {
    // Marks this element as the session host — voiceSession functions resolve it
    // via getRoot().lookdown('VoiceOverlay') and keep every runtime handle
    // (stream, analyser, recognition, utterance, timers) on this scope.
    //
    // FA204 / frank trap — `syncChatSuppression` used to be a bare module-scope
    // const read from inside `onStateUpdate` (a serialized factory). It read as
    // undefined once this component was frank.toJSON'd for platform delivery
    // (workspace d6ea1142, project_frank_drops_module_local_helpers). Moved
    // into `scope`, called via `el.scope.syncChatSuppression(el)`.
    scope: {
        __isVoiceOverlay: true,
        // Standard WAI-ARIA dialog-open focus contract for the FULL surface
        // (`role: 'dialog'`, `ariaModal: 'true'` below) — nothing moved focus
        // into or out of this overlay before (confirmed: zero `.focus()` calls
        // anywhere across the voice surface), so a keyboard/screen-reader user
        // pressing the mic got no confirmation the dialog had taken over, and
        // closing it dropped focus to nowhere. The RESTORE half lives in
        // voiceSession.js (`_restoreFocus`, called from every teardown path) —
        // this half only handles moving focus IN, since it is the one place
        // that actually knows when the isActive predicate flips true.
        //
        // Edge-triggered off the SAME boolean the CSS `.isActive` class uses
        // (never fires while already open, never fights the opacity/visibility
        // transition), exactly the `voicePrevForeground` pattern immediately
        // below — deliberately a SEPARATE prev-flag so the two edge detectors
        // can never interfere with each other.
        //
        // Targets the header's Minimize (CallMinimize, not the overlay root) — a
        // real, labelled, always-present next-action for a surface with no text
        // input of its own to focus, and the one an accidental Enter cannot
        // hang up on.
        //
        // WAITS FOR THE SURFACE TO BE VISIBLE, it does not assume one frame
        // (VOICE-OVERLAY-STATE-HOOK-DEAD-1 live measurement, 2026-08-22):
        // `focus()` on a descendant of a `visibility: hidden` element is a no-op,
        // and the `.isActive` class that lifts `visibility: hidden` lands SEVERAL
        // frames after the state edge — measured on the running shell, the node
        // still read `visibility: hidden` at rAF #1 (+152 ms) and rAF #2
        // (+541 ms) and only flipped at ~+940 ms. A single rAF therefore focused
        // nothing, which is exactly the residual the ticket reports
        // (`document.activeElement` stayed BODY). So: re-check on each frame,
        // for a bounded number of frames, and bail the moment the surface stops
        // being the full one or the user has already focused inside it.
        // `getComputedStyle` here is a style read of THIS element's OWN node (no
        // selector, no DOM walk) — the only honest way to know the transition
        // has actually made the dialog focusable.
        syncFocus (el) {
            const root = el.state && (el.state.root || el.state);
            if (!root) return;
            const active = !!(root.voiceOpen && !root.voiceMinimized && !root.voiceHost);
            const sc = el.scope;
            const wasActive = !!sc.voiceFocusPrevActive;
            sc.voiceFocusPrevActive = active;
            if (!active || wasActive) return;
            // ~1 s of frames on a 60 fps box, and far longer on a loaded one —
            // every attempt re-reads the posture, so an overrun can never focus a
            // surface the user already dismissed.
            let framesLeft = 60;
            const attempt = ()=>{
                if (!el.node || !el.node.isConnected) return;
                const st = el.state && (el.state.root || el.state);
                if (!st || !st.voiceOpen || st.voiceMinimized || st.voiceHost) return;
                const doc = el.node.ownerDocument;
                const view = doc && doc.defaultView;
                const hidden = view && typeof view.getComputedStyle === 'function' ? view.getComputedStyle(el.node).visibility === 'hidden' : false;
                if (hidden) {
                    if (framesLeft-- > 0) requestAnimationFrame(attempt);
                    return;
                }
                // A user who already reached inside the dialog keeps their focus.
                if (doc && doc.activeElement && el.node.contains(doc.activeElement)) return;
                const safeBtn = el.lookdown && el.lookdown('CallMinimize');
                const target = safeBtn && safeBtn.node || el.node;
                if (target && typeof target.focus === 'function') target.focus();
            };
            requestAnimationFrame(attempt);
        },
        syncChatSuppression (el) {
            const root = el.state && (el.state.root || el.state);
            if (!root || !root.update) return;
            const sc = el.scope;
            const foreground = !!(root.voiceOpen && (root.voiceHost || !root.voiceMinimized));
            const open = !!root.voiceOpen;
            const wasForeground = !!sc.voicePrevForeground;
            const wasOpen = !!sc.voicePrevOpen;
            sc.voicePrevForeground = foreground;
            sc.voicePrevOpen = open;
            if (foreground && !wasForeground) {
                if (root.assistantOpen && root.assistantDock !== 'minimized' && root.voiceHost !== 'chat') {
                    sc.voiceDockRestore = root.assistantDock || 'right';
                    root.update({
                        assistantDock: 'minimized'
                    });
                }
                return;
            }
            if (!open && wasOpen && sc.voiceDockRestore) {
                const dock = sc.voiceDockRestore;
                sc.voiceDockRestore = null;
                // Dock only — assistantOpen is never touched, so a drawer the user
                // closed outright mid-session stays closed (the dock value is inert
                // while closed).
                root.update({
                    assistantDock: dock
                });
            }
        },
        // ——— voice engine plumbing (FA204/FA207 frank trap) ———
        //
        // Every one of these used to be a module-scope `const _name = (overlay,
        // ...) => {...}` split across functions/voiceSession.js AND
        // functions/voiceConvai.js — both files independently declared their own
        // `_overlayOf`/`_rootOf`/`_voiceOf`/`_up` (the exact same-name collision
        // frank's own esbuild-dedup rename warned about, `_rootOf2`/`_cache2`
        // style), and every sibling-helper bare call inside them (`_teardown`
        // calling `_stopConvai`, `_speak` calling `_play`, etc.) was a frank trap
        // the moment those functions/*.js files got frank.toJSON'd for platform
        // delivery: each exported `el.call` handler is serialized independently,
        // so a free reference to a module-scope sibling reads as `undefined`
        // post-serialization (project_frank_drops_module_local_helpers).
        //
        // Fix: this whole engine is genuinely ONE piece of state machinery keyed
        // off a single VoiceOverlay instance (`voiceSession.js`'s own header:
        // "every runtime handle lives on the VoiceOverlay element's scope") — so
        // it belongs in THIS component's `scope: {}`, the same construct
        // `syncFocus`/`syncChatSuppression` above already use, and the same one
        // AppOrgSwitcher.js's `rawOrgs`/`activeOrg` pair uses for cross-calling
        // scope methods (`this.rawOrgs(root)`). `scope: {}` is confirmed to
        // survive frank serialization as ONE co-located blob (live Chrome MCP
        // verification, tickets/sonnet.md 2026-08-12 addendum: `el.scope.foo`
        // resolves directly in the served platform payload). voiceSession.js and
        // voiceConvai.js now call these via `overlay.scope.<name>(...)`; every
        // cross-method call inside this block uses `this.<name>(...)`.
        //
        // `_overlayOf` itself is NOT here — it is how callers GET to
        // `overlay.scope` in the first place, so it can't live on the thing it
        // resolves. It stays a tiny (4-line) self-contained local, duplicated in
        // every `el.call` export in voiceSession.js/voiceConvai.js (FA207).
        // `_resume` (voiceSession.js line 272, an unused re-arm-listening helper
        // with zero call sites anywhere in the file — confirmed via the acorn
        // AST sweep and a plain grep) was dead code and is not migrated.
        rootOf (overlay) {
            const st = overlay && overlay.state;
            return st && st.root || st;
        },
        voiceOf (overlay) {
            const sc = overlay.scope;
            if (!sc.voice) sc.voice = {};
            return sc.voice;
        },
        // THREE surfaces render voice state (full VoiceOverlay, in-composer
        // VoiceStrip, the unified island in SimoneReasoningPill), so every write
        // goes UNSCOPED and repaints them all. The server engines emit per-turn
        // transitions only — the several-per-second interim tick that once
        // earned a scoped update is gone with the browser recognizer.
        up (overlay, patch) {
            const root = this.rootOf(overlay);
            if (!root || !root.update) return;
            root.update(patch, {
                preventFetch: true
            });
        },
        // THE canonical transcript primitive — inline copy of the exported
        // `appendVoiceTurn` (voiceSession.js; kept exported for its own unit
        // test, `voiceSession.test.js`, per FA207/pattern-4: a same-file bare
        // call from a private helper is the same frank trap as a sibling-export
        // call, so the logic is duplicated here rather than referenced bare).
        // Upserts by `id`: a streaming agent turn keeps the same id and is
        // rewritten as its text grows, which is what preserves token-by-token
        // streaming through a state-backed log.
        turn (overlay, entry) {
            const root = this.rootOf(overlay);
            if (!root || !entry || !entry.id) return;
            const list = Array.isArray(root.voiceTurns) ? root.voiceTurns : [];
            const max = 50;
            const at = list.findIndex((t)=>t && t.id === entry.id);
            const next = at === -1 ? list.concat([
                entry
            ]) : list.slice();
            if (at !== -1) next[at] = {
                ...next[at],
                ...entry
            };
            const turns = next.length > max ? next.slice(next.length - max) : next;
            this.up(overlay, {
                voiceTurns: turns
            });
        },
        // An executed canvas command, logged as text into the one thread. `kind:
        // 'action'` lets the UI render an outcome differently from speech without
        // knowing which engine ran (2026-08-03 per Nika "in command mode it
        // should also text the answers").
        actionTurn (overlay, label) {
            const text = String(label || '').trim();
            if (!text) return;
            const v = this.voiceOf(overlay);
            v.turnSeq = (v.turnSeq || 0) + 1;
            this.turn(overlay, {
                id: 'a' + v.turnSeq,
                role: 'agent',
                kind: 'action',
                text: text
            });
        },
        // Mirror the scope-held engine handle into reactive state. Both must move
        // together: `v.engine` drives dispatch, `root.voiceEngine` lets the UI
        // say which engine is live.
        setEngine (overlay, name) {
            const v = this.voiceOf(overlay);
            v.engine = name;
            this.up(overlay, {
                voiceEngine: name
            });
        },
        // `key` is a bundle key, resolved HERE — `voiceError` is written into root
        // state and read back by the status line below, so it has to be a string by
        // the time it lands (I18N-CONVENTION: data handed to a state carrier
        // resolves eagerly at the call site). `detail` is server prose appended
        // verbatim behind the translated headline.
        fail (overlay, key, detail) {
            const v = this.voiceOf(overlay);
            this.stopRecorder(v);
            // `|| key` is the SAFETY half, not a fallback for a missing translation:
            // `translate()` already returns the key itself on a miss, so this only
            // fires when polyglot is not registered at all (a bare stub, a surface
            // booted without the plugin). Without it an unregistered resolver turns
            // every voice error into the literal string 'undefined'. Server prose
            // arriving here instead of a key passes straight through either way.
            const headline = overlay.call('polyglot', key) || key;
            this.up(overlay, {
                voiceStatus: 'error',
                voiceError: headline + (detail ? " \u2014 " + detail : '')
            });
        },
        // The 503 path — the server names the missing env var and the operator
        // step. Surface it verbatim behind the headline (VoiceService docs: the
        // message is the difference between "voice is broken" and "voice isn't
        // provisioned"), stripping the server's own headline so the copy doesn't
        // stutter.
        notProvisioned (overlay, err) {
            const detail = String(err && err.message || '').replace(/^Voice \w+ is unavailable:\s*/i, '');
            this.fail(overlay, 'shell.voice.error.notProvisioned', detail);
        },
        stopTracks (v) {
            if (v.stream) {
                v.stream.getTracks().forEach((t)=>t.stop());
                v.stream = null;
            }
            if (v.audioCtx) {
                try {
                    v.audioCtx.close();
                } catch (_) {}
                v.audioCtx = null;
            }
            // The live agent installs an analyser-shaped adapter over its client's
            // spectra (`startAgentEngine`) — releasing OUR capture must not tear
            // down THEIR wave source; `stopAgent` releases it.
            if (!(v.analyser && v.analyser.__agent)) {
                v.analyser = null;
                v.bins = null;
            }
        },
        // Chat state keys are namespaced per surface — same map as sendPrompt.js.
        // Shared across voiceSession.js's `commitAssistant` (below) AND the
        // exported `voiceStart` (which needs it before a session even opens).
        chatPrefix (scope) {
            return scope === 'addapp' ? '_ax_' : scope === 'dashboard' ? '_db_' : '';
        },
        // The SDK instance — same accessor chain the shell uses (app.js:
        // `el.sdk || el.context?.methods?.sdk`), so the engine works on every
        // mount.
        sdkOf (overlay) {
            return overlay.sdk || overlay.context && overlay.context.methods && overlay.context.methods.sdk || null;
        },
        async mic (overlay) {
            const v = this.voiceOf(overlay);
            if (v.stream) return;
            const md = typeof navigator !== 'undefined' && navigator.mediaDevices;
            if (!md || !md.getUserMedia) {
                this.fail(overlay, 'shell.voice.error.micUnsupported');
                return;
            }
            try {
                // echoCancellation keeps the recorder from capturing the spoken reply
                // out of the speakers; AGC keeps quiet speech above the silence
                // threshold.
                const stream = await md.getUserMedia({
                    audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true
                    }
                });
                if (!overlay.node || !v.active) {
                    stream.getTracks().forEach((t)=>t.stop());
                    return;
                }
                const Ctx = window.AudioContext || window.webkitAudioContext;
                const audioCtx = new Ctx();
                const analyser = audioCtx.createAnalyser();
                analyser.fftSize = 128;
                analyser.smoothingTimeConstant = 0.72;
                audioCtx.createMediaStreamSource(stream).connect(analyser);
                v.stream = stream;
                v.audioCtx = audioCtx;
                v.analyser = analyser;
                v.bins = new Uint8Array(analyser.frequencyBinCount);
            } catch (err) {
                this.fail(overlay, err && (err.name === 'NotAllowedError' || err.name === 'SecurityError') ? 'shell.voice.error.micDenied' : 'shell.voice.error.micOpenFailed');
            }
        },
        flashDone (overlay, label) {
            const v = this.voiceOf(overlay);
            this.up(overlay, {
                voiceStatus: 'done',
                voiceResult: label || 'Done'
            });
            clearTimeout(v.doneTimer);
            v.doneTimer = setTimeout(()=>{
                if (!overlay.node || !v.active) return;
                // A command is a one-off: it executed, the answer is in the thread,
                // the ✓ has been shown — get out of the user's way (2026-08-02 per
                // Nika). The SIMONE talk loop goes back to listening instead — a
                // conversation ends only on ✕/Esc.
                if (v.engine === 'simone') this.relisten(overlay);
                else this.teardown(overlay);
            }, 1100);
        },
        // ——— STT engine: MediaRecorder → sdk.voiceTranscribe ———
        record (overlay) {
            const v = this.voiceOf(overlay);
            if (!v.stream || v.recorder) return;
            const MR = typeof window !== 'undefined' && window.MediaRecorder;
            if (!MR) {
                this.fail(overlay, 'shell.voice.error.recorderUnsupported');
                return;
            }
            let mime = '';
            const candidates = [
                'audio/webm;codecs=opus',
                'audio/webm',
                'audio/mp4'
            ];
            for (const c of candidates)if (MR.isTypeSupported && MR.isTypeSupported(c)) {
                mime = c;
                break;
            }
            let recorder;
            try {
                recorder = mime ? new MR(v.stream, {
                    mimeType: mime
                }) : new MR(v.stream);
            } catch (_) {
                this.fail(overlay, 'shell.voice.error.recorderStartFailed');
                return;
            }
            v.chunks = [];
            recorder.ondataavailable = (ev)=>{
                if (ev.data && ev.data.size) v.chunks.push(ev.data);
            };
            recorder.onstop = ()=>{
                if (v.recorder === recorder) this.transcribe(overlay);
            };
            v.recorder = recorder;
            v.heardSpeech = false;
            v.lastSpeechAt = 0;
            v.recordStartedAt = Date.now();
            try {
                recorder.start();
            } catch (_) {
                v.recorder = null;
                this.fail(overlay, 'shell.voice.error.recorderStartFailed');
                return;
            }
            clearInterval(v.silenceLoop);
            v.silenceLoop = setInterval(()=>this.watchSilence(overlay), 150);
        },
        // End-of-utterance detection off the SAME analyser the waveform reads:
        // mark speech while the level is above threshold, commit after a silence
        // gap, and hard-stop at the cap. Whisper has no interim results, so this
        // watcher is what turns an open mic into a one-shot utterance.
        watchSilence (overlay) {
            // Average analyser level (0..1) above which the frame counts as
            // speech. AGC (requested in `mic`) normalises quiet mics toward this
            // band.
            const SPEECH_LEVEL = 0.05;
            // Silence gap after heard speech that commits the utterance.
            const SILENCE_COMMIT_MS = 1500;
            // Hard cap per utterance — a stuck session must not record forever.
            const MAX_UTTERANCE_MS = 45000;
            const v = this.voiceOf(overlay);
            const root = this.rootOf(overlay);
            if (!v.recorder || v.recorder.state !== 'recording') return;
            if (root && root.voiceMicMuted) return;
            let level = 0;
            if (v.analyser && v.bins) {
                v.analyser.getByteFrequencyData(v.bins);
                let sum = 0;
                for(let i = 0; i < v.bins.length; i++)sum += v.bins[i];
                level = sum / (v.bins.length * 255);
            }
            const now = Date.now();
            if (level > SPEECH_LEVEL) {
                v.heardSpeech = true;
                v.lastSpeechAt = now;
            }
            const tooLong = now - v.recordStartedAt > MAX_UTTERANCE_MS;
            const silent = v.heardSpeech && v.lastSpeechAt && now - v.lastSpeechAt > SILENCE_COMMIT_MS;
            if (tooLong || silent) this.finishRecording(overlay);
        },
        // Stop capturing and let the recorder's onstop hand the clip to
        // `transcribe`.
        finishRecording (overlay) {
            const v = this.voiceOf(overlay);
            clearInterval(v.silenceLoop);
            v.silenceLoop = null;
            const rec = v.recorder;
            if (!rec) return;
            this.up(overlay, {
                voiceStatus: 'thinking'
            });
            try {
                if (rec.state !== 'inactive') rec.stop();
                else if (v.recorder === rec) this.transcribe(overlay);
            } catch (_) {
                v.recorder = null;
            }
        },
        // Release the recorder WITHOUT transcribing (teardown, mode switch,
        // failure).
        stopRecorder (v) {
            clearInterval(v.silenceLoop);
            v.silenceLoop = null;
            v.sttToken = null;
            const rec = v.recorder;
            v.recorder = null;
            v.chunks = null;
            if (rec) {
                rec.ondataavailable = null;
                rec.onstop = null;
                try {
                    if (rec.state !== 'inactive') rec.stop();
                } catch (_) {}
            }
        },
        async transcribe (overlay) {
            const v = this.voiceOf(overlay);
            const rec = v.recorder;
            v.recorder = null;
            const chunks = v.chunks || [];
            v.chunks = null;
            if (!v.active) return;
            const type = rec && rec.mimeType || 'audio/webm';
            const blob = new Blob(chunks, {
                type: type.split(';')[0]
            });
            // A clip in which the live level never crossed the speech threshold is
            // NOT sent. Whisper turns silence and room noise into stock phrases —
            // one second of digital silence came back as " Thank you." on dev
            // 2026-10-04 — so the 45 s cap in a quiet room (or a hold released
            // without a word) handed the assistant a turn nobody said, and the
            // answer was spoken and billed. Judged only while the level is live
            // (analyser + bins, context running): without a level to read, the clip
            // is sent as before rather than dropped unheard.
            const levelLive = !!(v.analyser && v.bins && (!v.audioCtx || !v.audioCtx.state || v.audioCtx.state === 'running'));
            if (!blob.size || levelLive && !v.heardSpeech) {
                if (v.closeAfterCommit) this.teardown(overlay);
                else if (v.engine === 'simone') this.relisten(overlay);
                else this.fail(overlay, 'shell.voice.error.noSpeech');
                return;
            }
            const sdk = this.sdkOf(overlay);
            if (!sdk || typeof sdk.voiceTranscribe !== 'function') {
                this.fail(overlay, 'shell.voice.error.unavailableHere');
                return;
            }
            const recExt = (mime)=>{
                const m = String(mime || '').toLowerCase();
                if (m.includes('mp4')) return 'mp4';
                if (m.includes('ogg')) return 'ogg';
                return 'webm';
            };
            const token = {};
            v.sttToken = token;
            let out = null;
            try {
                // The speaker's UI language is Whisper's hint — without it a
                // Georgian clip came back as Latin transliteration (dev 2026-10-07).
                // The server keeps only its own languages.
                const root = this.rootOf(overlay);
                const lang = root && typeof root.lang === 'string' && root.lang ? root.lang : null;
                const args = {
                    audio: blob,
                    filename: 'clip.' + recExt(type)
                };
                if (lang) args.language = lang;
                out = await sdk.voiceTranscribe(args);
            } catch (err) {
                if (v.sttToken !== token || !v.active) return;
                if (err && err.status === 503) this.notProvisioned(overlay, err);
                else this.fail(overlay, 'shell.voice.error.transcribeFailed');
                return;
            }
            if (v.sttToken !== token || !v.active) return;
            const text = String(out && out.text || '').trim();
            // Whisper renders pure silence as '' or a lone punctuation mark.
            if (!text || /^[.,!?\s]+$/.test(text)) {
                if (v.closeAfterCommit) this.teardown(overlay);
                else if (v.engine === 'simone') this.relisten(overlay);
                else this.fail(overlay, 'shell.voice.error.noSpeech');
                return;
            }
            this.commit(overlay, text);
        },
        // ——— TTS: sdk.voiceTts → one primed Audio element ———
        // One reusable Audio element, created INSIDE the user gesture that starts
        // a session. Autoplay policy ties playback to user activation and the
        // reply plays seconds after the click — an element that already played (a
        // silent clip, paused immediately) keeps its permission for every later
        // src swap. Replaces v1's speechSynthesis priming.
        primeAudio (overlay) {
            // A minimal valid silent WAV (44-byte header + 4 silent samples) used
            // to unlock the reply element inside the user gesture here.
            const SILENT_WAV = 'data:audio/wav;base64,UklGRiwAAABXQVZFZm10IBAAAAABAAEAQB8AAIA+AAACABAAZGF0YQgAAAAAAAAAAAAAAA==';
            const v = this.voiceOf(overlay);
            if (v.audioEl) return;
            if (typeof window === 'undefined' || typeof window.Audio !== 'function') return;
            try {
                const audio = new window.Audio(SILENT_WAV);
                audio.playsInline = true;
                const p = audio.play();
                if (p && typeof p.catch === 'function') p.catch(()=>{});
                try {
                    audio.pause();
                } catch (_) {}
                v.audioEl = audio;
            } catch (_) {}
        },
        // Cut the current spoken reply short — clearing the token first makes
        // every in-flight callback and the streaming pump abandon themselves;
        // aborting the controller cancels the SDK fetch (the server aborts
        // upstream on disconnect).
        stopSpeaking (overlay) {
            const v = this.voiceOf(overlay);
            v.speakToken = null;
            clearTimeout(v.speakGuard);
            v.speakGuard = null;
            if (v.speakAbort) {
                try {
                    v.speakAbort.abort();
                } catch (_) {}
                v.speakAbort = null;
            }
            if (v.audioEl) try {
                v.audioEl.pause();
            } catch (_) {}
            if (v.speakUrl) {
                try {
                    URL.revokeObjectURL(v.speakUrl);
                } catch (_) {}
                v.speakUrl = null;
            }
        },
        // Play a streaming TTS Response. MediaSource lets playback start while
        // bytes are still arriving (the whole point of the server streaming the
        // clip); where the mime isn't MSE-supported it falls back to blob +
        // object URL — still correct, just first-audio waits for the download.
        // Resolves when playback ends, errors, or is paused (the stop path
        // pauses).
        play (overlay, res, token) {
            const self = this;
            return new Promise((resolve)=>{
                const v = self.voiceOf(overlay);
                if (!v.audioEl) v.audioEl = new window.Audio();
                const audio = v.audioEl;
                let settled = false;
                const finish = ()=>{
                    if (settled) return;
                    settled = true;
                    audio.onended = null;
                    audio.onerror = null;
                    audio.onpause = null;
                    resolve();
                };
                audio.onended = finish;
                audio.onerror = finish;
                audio.onpause = finish;
                const type = String(res.headers && res.headers.get('content-type') || 'audio/mpeg').split(';')[0].trim();
                const MS = typeof window !== 'undefined' && window.MediaSource;
                const canStream = MS && MS.isTypeSupported && MS.isTypeSupported(type) && res.body && res.body.getReader;
                if (canStream) {
                    const ms = new MS();
                    if (v.speakUrl) try {
                        URL.revokeObjectURL(v.speakUrl);
                    } catch (_) {}
                    v.speakUrl = URL.createObjectURL(ms);
                    audio.src = v.speakUrl;
                    ms.addEventListener('sourceopen', async ()=>{
                        let sb;
                        try {
                            sb = ms.addSourceBuffer(type);
                        } catch (_) {
                            finish();
                            return;
                        }
                        const reader = res.body.getReader();
                        const append = (chunk)=>new Promise((ok)=>{
                                sb.addEventListener('updateend', ok, {
                                    once: true
                                });
                                try {
                                    sb.appendBuffer(chunk);
                                } catch (_) {
                                    ok();
                                }
                            });
                        try {
                            for(;;){
                                const { done: done, value: value } = await reader.read();
                                if (v.speakToken !== token) {
                                    try {
                                        reader.cancel();
                                    } catch (_) {}
                                    break;
                                }
                                if (done) break;
                                await append(value);
                            }
                        } catch (_) {}
                        try {
                            if (ms.readyState === 'open') ms.endOfStream();
                        } catch (_) {}
                    }, {
                        once: true
                    });
                    const p = audio.play();
                    if (p && typeof p.catch === 'function') p.catch(finish);
                } else res.blob().then((b)=>{
                    if (v.speakToken !== token) {
                        finish();
                        return;
                    }
                    if (v.speakUrl) try {
                        URL.revokeObjectURL(v.speakUrl);
                    } catch (_) {}
                    v.speakUrl = URL.createObjectURL(b);
                    audio.src = v.speakUrl;
                    const p = audio.play();
                    if (p && typeof p.catch === 'function') p.catch(finish);
                }).catch(finish);
            });
        },
        // The workspace's own ElevenLabs voice for the spoken reply —
        // `settings.voice.voiceId`, an id (not a secret) the workspace chose.
        // Without it every workspace spoke in the server's default voice: the
        // SDK and the TTS route carry `voiceId`, only this call dropped it.
        // DECISION site (workspaceSettings.js §5): "no voice set" and "record not
        // loaded yet" both fall to the server default, which is the right answer
        // for both. Shape-checked so a typo never reaches the TTS URL.
        ttsVoiceOf (overlay) {
            // THE workspace voice reader (functions/workspaceVoice.js) — the same
            // one speakReply uses, so the overlay and typed answers never differ.
            const fns = overlay && overlay.context && overlay.context.functions || {};
            if (typeof fns.workspaceVoiceId !== 'function') return null;
            return overlay.call('workspaceVoiceId', this.rootOf(overlay)) || null;
        },
        async speak (overlay, text) {
            const v = this.voiceOf(overlay);
            if (!text) {
                this.afterSpeak(overlay);
                return;
            }
            const sdk = this.sdkOf(overlay);
            if (!sdk || typeof sdk.voiceTts !== 'function') {
                this.afterSpeak(overlay);
                return;
            }
            this.up(overlay, {
                voiceStatus: 'speaking'
            });
            // The talk loop hears the person over its own reply (the barge-in).
            this.startBargeWatch(overlay);
            const token = {};
            v.speakToken = token;
            const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
            v.speakAbort = ctrl;
            // Hard cap so a stalled stream can never wedge the session in
            // 'speaking' — generous (~11 chars/s + slack); the normal end path
            // clears it first.
            clearTimeout(v.speakGuard);
            v.speakGuard = setTimeout(()=>{
                if (v.speakToken !== token) return;
                this.stopSpeaking(overlay);
                this.afterSpeak(overlay);
            }, Math.min(120000, 8000 + text.length * 90));
            const ttsArgs = {
                text: text,
                signal: ctrl && ctrl.signal
            };
            const voiceId = this.ttsVoiceOf(overlay);
            if (voiceId) ttsArgs.voiceId = voiceId;
            try {
                const res = await sdk.voiceTts(ttsArgs);
                if (v.speakToken !== token || !v.active) return;
                await this.play(overlay, res, token);
            } catch (err) {
                if (v.speakToken !== token || !v.active) return;
                this.stopSpeaking(overlay);
                if (err && err.status === 503) {
                    // Secrets unprovisioned — say so and stop. The text answer already
                    // stands in the thread; never fall back to a browser voice.
                    this.notProvisioned(overlay, err);
                    return;
                }
                // Transient TTS failure: the reply is on screen — finish the
                // exchange silently rather than erroring a delivered answer.
                this.afterSpeak(overlay);
                return;
            }
            if (v.speakToken !== token || !v.active) return;
            this.stopSpeaking(overlay);
            this.afterSpeak(overlay);
        },
        afterSpeak (overlay) {
            const v = this.voiceOf(overlay);
            if (!overlay.node || !v.active) return;
            // A notice said MID-turn (an ask waits on the person — holdForAsk) is
            // not the turn's end: the turn is still out, so the loop holds for the
            // answer instead of listening.
            if (v.awaiting && v.awaiting.notice) {
                this.noticeSaid(overlay);
                return;
            }
            // The spoken reply is the END of a one-off command exchange, and the
            // END OF ONE TURN of the SIMONE talk loop — which goes straight back to
            // listening (speak → listen is the loop's closing edge).
            if (v.engine === 'simone') this.relisten(overlay);
            else this.teardown(overlay);
        },
        // ——— SIMONE talk loop: the listen edge ———
        // Re-arm the mic for the next utterance of a continuous conversation
        // (VOICE-TALK-ONLY-SIMONE-1 part 3, route A). Reached after a spoken
        // reply, a stop-speaking barge-in, an unclear clip, or a ✓ action. The
        // mic stream + analyser survive across turns (teardown is the only
        // release), so this is a plain `record`; a stream lost mid-session (device
        // unplugged, permission revoked) re-runs the engine start. A user-muted
        // mic stays muted — voiceMicToggle's unmute re-arms via `record`.
        relisten (overlay) {
            const v = this.voiceOf(overlay);
            if (!overlay.node || !v.active) return;
            v.awaiting = null;
            clearInterval(v.turnPoll);
            v.turnPoll = null;
            clearTimeout(v.stopTimer);
            this.stopBargeWatch(v);
            this.up(overlay, {
                voiceStatus: 'listening',
                voiceInterim: '',
                voiceResult: '',
                voiceError: ''
            });
            const root = this.rootOf(overlay);
            if (root && root.voiceMicMuted) return;
            if (!v.stream) {
                this.startRecorderEngine(overlay, 'simone');
                return;
            }
            if (!v.recorder) this.record(overlay);
        },
        // ——— SIMONE talk loop: the barge-in ———
        // The person speaks over the agent (Nika 2026-10-23: "fly voice and ai
        // should stop when I talk, add interrupting"). While a turn is out — the
        // ask dispatched and the agent thinking (`awaiting`), or its reply playing
        // (`speaking`) — the SAME analyser the waveform reads keeps listening
        // (the mic stream lives for the whole session). Sustained speech over it
        // is an interrupt: the voice stops, the turn being made stops (the host's
        // own stop — the shell's Fly ends the page in the making, its chat ends
        // the reply being written), a late answer
        // is never spoken, and the new utterance records at once. The bar while
        // the reply plays is higher than while the agent thinks: the echo
        // canceller (`mic` asks for echoCancellation) takes the reply out of the
        // mic, and what it leaves must not count as the person. A muted mic never
        // interrupts. The talk loop only; a one-shot command just finishes.
        startBargeWatch (overlay) {
            const v = this.voiceOf(overlay);
            this.stopBargeWatch(v);
            // No level to read (the mic never opened): nothing to hear the person by.
            if (!overlay.node || !v.active || v.engine !== 'simone' || !v.analyser || !v.bins) return;
            // A turn whose ask waits on the person is never cut by speech: the stop
            // would decline a parked step and strand a question's card. The person
            // answers it on the screen.
            if (v.awaiting && v.awaiting.waitStep) return;
            v.bargeLoop = setInterval(()=>this.watchBarge(overlay), 100);
        },
        stopBargeWatch (v) {
            clearInterval(v.bargeLoop);
            v.bargeLoop = null;
            v.bargeFrames = 0;
        },
        watchBarge (overlay) {
            // Average analyser level (watchSilence's own measure) that counts as
            // the person speaking: over a reply that plays, and over a turn being
            // made (the room is quiet then — the agent is not speaking).
            const BARGE_LEVEL_SPEAKING = 0.08;
            const BARGE_LEVEL_THINKING = 0.05;
            // Consecutive 100 ms frames above the bar: speech, not a cough or a
            // click.
            const BARGE_FRAMES = 3;
            const v = this.voiceOf(overlay);
            const root = this.rootOf(overlay);
            const status = root && root.voiceStatus;
            const out = status === 'speaking' || status === 'thinking' && !!v.awaiting;
            // An ask that waits on the person holds the turn (startBargeWatch).
            const held = !!(v.awaiting && v.awaiting.waitStep);
            if (!overlay.node || !v.active || v.engine !== 'simone' || !out || held || !v.analyser || !v.bins) {
                this.stopBargeWatch(v);
                return;
            }
            if (root.voiceMicMuted || v.recorder) {
                v.bargeFrames = 0;
                return;
            }
            v.analyser.getByteFrequencyData(v.bins);
            let sum = 0;
            for(let i = 0; i < v.bins.length; i++)sum += v.bins[i];
            const level = sum / (v.bins.length * 255);
            const bar = status === 'speaking' ? BARGE_LEVEL_SPEAKING : BARGE_LEVEL_THINKING;
            v.bargeFrames = level > bar ? (v.bargeFrames || 0) + 1 : 0;
            if (v.bargeFrames >= BARGE_FRAMES) this.barge(overlay);
        },
        barge (overlay) {
            const v = this.voiceOf(overlay);
            const root = this.rootOf(overlay);
            this.stopBargeWatch(v);
            if (!overlay.node || !v.active || !root) return;
            const turn = v.awaiting;
            v.awaiting = null;
            this.stopSpeaking(overlay);
            // The turn being made stops with the voice — the host's own stop: the
            // Fly page in the making, or the chat reply being written (its scope's
            // turn; the shell's assistantTurnStop).
            const fns = overlay.context && overlay.context.functions || {};
            if (turn && turn.type === 'fly' && typeof fns.assistantFlyStop === 'function') try {
                overlay.call('assistantFlyStop');
            } catch (_) {}
            if (turn && turn.type === 'chat' && typeof fns.assistantTurnStop === 'function') try {
                overlay.call('assistantTurnStop', v.chatScope || 'general');
            } catch (_) {}
            // A reply that was streaming into the log stops where it was cut.
            const id = turn && turn.turnId;
            const list = Array.isArray(root.voiceTurns) ? root.voiceTurns : [];
            if (id && list.some((t)=>t && t.id === id)) this.turn(overlay, {
                id: id,
                streaming: false
            });
            // Listen at once: the person is already speaking — the clip counts as
            // speech from its first frame.
            this.relisten(overlay);
            if (v.recorder) {
                v.heardSpeech = true;
                v.lastSpeechAt = Date.now();
            }
        },
        // ——— what waits on the person: a step for the OK, a question for a pick ———
        //
        // Two kinds of ask stop a turn on the person, and the server turn waits
        // on that tool's result, so Simone says NOTHING until the person answers:
        //   • an approval — the client gate parks a write the turn wants to make
        //     (simoneAiTransport.runClientToolWithAuth): its tool row turns
        //     `status: 'approval'`; Run or Skip answers it;
        //   • a question — ask_user hangs a confirm/choice card on the message
        //     (simoneAiTransport askUser); the card's buttons answer it
        //     (resolveChatCard).
        // The typing flag tells nothing: a live parked step keeps it on, a step
        // whose follow window ended has it off, a question turns it off — each
        // time with the narration as the newest text. So the ask is read off the
        // thread (voiceOnStateChange → heldAsk), the call screen shows it (AiAsk),
        // and the voice says it.
        // The ask of this turn that waits on the person, or null — the newest
        // among the assistant rows after the person's last line (a new line
        // closes both kinds: simoneAiTransport.supersedeParkedAiToolApprovals):
        //   { kind: 'approval', id, label, tool } — a tool row in the `approval`
        //     status (`label`: the server's words for the step);
        //   { kind: 'choice', id, prompt, options } — a confirm/choice card nobody
        //     answered (`options`: its button labels, in order, in the words the
        //     screen shows — the ONE rule the card and the call screen read,
        //     functions/askCardOptions, through the overlay: a confirm with no
        //     labels of its own is Confirm / Cancel in the page language).
        // Mirrors AiAsk.scope.waitingIn (the call screen and the island show the
        // same ask).
        heldAsk (rows, overlay) {
            const list = Array.isArray(rows) ? rows : [];
            for(let i = list.length - 1; i >= 0; i--){
                const m = list[i];
                if (!m) continue;
                if (m.role === 'user') return null;
                if (m.role !== 'assistant') continue;
                const tools = Array.isArray(m.tools) ? m.tools : [];
                for(let j = tools.length - 1; j >= 0; j--){
                    const t = tools[j];
                    if (t && t.status === 'approval') return {
                        kind: 'approval',
                        id: t.id,
                        label: t.label,
                        tool: t.tool
                    };
                }
                const cards = Array.isArray(m.cards) ? m.cards : [];
                for(let j = cards.length - 1; j >= 0; j--){
                    const c = cards[j];
                    const asks = !!c && (c.type === 'choice' || c.type === 'confirm');
                    if (!asks || !c._cardId || c._resolved) continue;
                    let answers = null;
                    try {
                        answers = overlay && overlay.call('askCardOptions', c);
                    } catch (_) {
                        answers = null;
                    }
                    const options = (Array.isArray(answers) ? answers : []).map((o)=>String(o.label)).filter(Boolean);
                    return {
                        kind: 'choice',
                        id: 'card:' + c._cardId,
                        prompt: typeof c.prompt === 'string' ? c.prompt.trim() : '',
                        options: options
                    };
                }
            }
            return null;
        },
        // What the voice says while an ask waits, in the person's language. A
        // step: in its own words (the server's label, already in the turn's
        // language — the words the call screen shows), and that Run or Skip on
        // the screen answers it. A question: the question itself (the model's
        // words, in the turn's language), and that the answer is chosen on the
        // screen. An ask with no words of its own: the line without them.
        askNotice (overlay, ask) {
            const t = (key)=>{
                let raw = '';
                try {
                    raw = overlay.call('polyglot', key);
                } catch (_) {
                    raw = '';
                }
                return typeof raw === 'string' && raw !== key ? raw : '';
            };
            if (ask && ask.kind === 'choice') {
                const prompt = ask.prompt || '';
                // A question that ends without a stop gets one, so the line after it
                // is a sentence of its own.
                const said = prompt && !/[.?!…:;]$/.test(prompt) ? prompt + '.' : prompt;
                const line = said ? t('ai.voice.choiceNotice') : '';
                if (line && line.includes('{prompt}')) return line.split('{prompt}').join(said);
                return t('ai.voice.choiceNoticeBare');
            }
            const label = ask && typeof ask.label === 'string' ? ask.label.trim() : '';
            const line = label ? t('ai.voice.askNotice') : '';
            if (line && line.includes('{step}')) return line.split('{step}').join(label);
            return t('ai.voice.askNoticeBare');
        },
        // The loop (or the one-shot command) reached an ask that waits. The voice
        // says so ONCE per ask; then the loop HOLDS — 'waiting' for a step's OK,
        // 'choosing' for a question's pick: no listening (a new utterance is a new
        // send, and a new send closes the ask unanswered —
        // simoneAiTransport.supersedeParkedAiToolApprovals), no barge-in (its stop
        // declines a parked step — settleParkedAiToolApprovals — and strands a
        // question's card), no turn timeout (the time on the screen is the
        // person's). The answer on the screen resumes the turn (askAnswered). The
        // one-shot command says it and ends: the ask stays where the island and
        // the thread still offer it.
        holdForAsk (overlay, ask) {
            const v = this.voiceOf(overlay);
            const turn = v.awaiting;
            if (!turn || !ask || turn.waitStep === ask.id) return;
            turn.waitStep = ask.id;
            turn.waitKind = ask.kind;
            this.stopBargeWatch(v);
            const said = this.askNotice(overlay, ask);
            if (v.engine !== 'simone') {
                v.awaiting = null;
                clearInterval(v.turnPoll);
                v.turnPoll = null;
                this.speak(overlay, said);
                return;
            }
            // Set before speaking: a voice that cannot speak ends at once.
            turn.notice = true;
            this.speak(overlay, said);
        },
        // The notice ended — said, cut by Stop speaking, or dropped by a failed
        // voice. Hold for the answer, and read the thread again at once: the
        // answer may have come while the notice played (its reply waited, so
        // nothing talked over the notice).
        noticeSaid (overlay) {
            const v = this.voiceOf(overlay);
            const turn = v.awaiting;
            if (turn) turn.notice = false;
            const choosing = !!turn && turn.waitKind === 'choice';
            this.up(overlay, {
                voiceStatus: choosing ? 'choosing' : 'waiting'
            });
            try {
                overlay.call('voiceOnStateChange');
            } catch (_) {}
        },
        // The ask was answered on the screen — Run, Skip, a pick — (or a newer
        // send took it): the turn goes on, on a fresh clock — the time on the
        // screen was the person's, not Simone's. The loop thinks again, with the
        // barge-in back on; the live agent's turn states go on as they were.
        askAnswered (overlay) {
            const v = this.voiceOf(overlay);
            const turn = v.awaiting;
            if (!turn || !turn.waitStep) return;
            turn.waitStep = null;
            turn.waitKind = null;
            if (turn.tool) {
                turn.startedAt = Date.now();
                return;
            }
            v.turnStartedAt = Date.now();
            const root = this.rootOf(overlay);
            const held = root && (root.voiceStatus === 'waiting' || root.voiceStatus === 'choosing');
            if (held) {
                this.up(overlay, {
                    voiceStatus: 'thinking'
                });
                this.startBargeWatch(overlay);
            }
        },
        // ——— commit pipeline (command mode) ———
        commit (overlay, text) {
            const v = this.voiceOf(overlay);
            clearTimeout(v.stopTimer);
            this.up(overlay, {
                voiceFinal: text,
                voiceInterim: ''
            });
            // Every committed utterance is a transcript turn — the reply needs its
            // question above it in the one thread.
            v.turnSeq = (v.turnSeq || 0) + 1;
            this.turn(overlay, {
                id: 'u' + v.turnSeq,
                role: 'user',
                text: text
            });
            // TALK = the SIMONE loop: every utterance is a conversation turn for
            // our agent — Simone is the intelligence (route A). The host command
            // grammar (canvas "zoom to fit" …) stays the one-shot COMMAND path's
            // first responder.
            if (v.engine === 'simone') this.commitAssistant(overlay, text);
            else this.commitCommand(overlay, text);
        },
        commitCommand (overlay, text) {
            const v = this.voiceOf(overlay);
            this.up(overlay, {
                voiceStatus: 'thinking'
            });
            const fns = overlay.context && overlay.context.functions;
            let res = null;
            if (fns && typeof fns.voiceProjectCommand === 'function') res = overlay.call('voiceProjectCommand', text);
            if (res && res.handled) {
                if (res.awaiting === 'freestyle') {
                    v.awaiting = {
                        type: 'freestyle'
                    };
                    return;
                }
                this.actionTurn(overlay, res.label);
                this.flashDone(overlay, res.label);
                return;
            }
            // No host command layer (or nothing matched) — let the assistant have
            // it.
            this.commitAssistant(overlay, text);
        },
        commitAssistant (overlay, text) {
            const root = this.rootOf(overlay);
            const v = this.voiceOf(overlay);
            // FLY MODE (workspace docs/FLY_MODE.md): a spoken ask composes a PAGE
            // in the main area, like a typed one, and the page's opening is what
            // the voice says — the talk loop then listens again. Only where the
            // shell's fly engine is registered and the board service answers here.
            const fns = overlay && overlay.context && overlay.context.functions || {};
            if (root.assistantMode === 'fly' && root._aiBoardsAvailable === true && typeof fns.assistantFlyGenerate === 'function') {
                const turnId = 'a' + (v.turnSeq || 0);
                v.awaiting = {
                    type: 'fly',
                    turnId: turnId
                };
                v.turnStartedAt = Date.now();
                this.up(overlay, {
                    voiceStatus: 'thinking',
                    voiceMinimized: true,
                    voiceHost: null
                });
                // Speech over the page in the making stops it (the barge-in).
                this.startBargeWatch(overlay);
                Promise.resolve(overlay.call('assistantFlyGenerate', text)).then((page)=>{
                    if (!v.active || !v.awaiting || v.awaiting.turnId !== turnId) return;
                    v.awaiting = null;
                    if (!page || page.status !== 'ready') {
                        const why = page && typeof fns.assistantFlyStatusKey === 'function' ? overlay.call('assistantFlyStatusKey', page) : '';
                        this.fail(overlay, why || 'workspace.assistantFly.failed');
                        return;
                    }
                    const said = String(page.opening || page.title || '').trim();
                    if (said) this.turn(overlay, {
                        id: turnId,
                        role: 'agent',
                        text: said
                    });
                    this.speak(overlay, said);
                }, ()=>{
                    if (!v.active || !v.awaiting || v.awaiting.turnId !== turnId) return;
                    v.awaiting = null;
                    this.fail(overlay, 'workspace.assistantFly.failed');
                });
                return;
            }
            if (root.bridgeStatus !== 'open') {
                this.fail(overlay, 'shell.voice.error.assistantOffline');
                return;
            }
            // turnId is the STABLE transcript id for the reply this dispatch will
            // produce — voiceOnStateChange rewrites that one entry as the
            // assistant streams, which is what keeps token-by-token growth visible
            // in a state-backed log instead of one blob at the end.
            // `since`: the thread's length before the send — a step that waits for
            // the person's OK is this turn's only after it (an older parked step is
            // superseded by this very send, maybe a tick later).
            const k = this.chatPrefix(v.chatScope);
            const sent = Array.isArray(root[k + 'chatMessages']) ? root[k + 'chatMessages'].length : 0;
            v.awaiting = {
                type: 'chat',
                k: k,
                turnId: 'a' + (v.turnSeq || 0),
                since: sent
            };
            // Turn clock — voiceOnStateChange's timeout guard reads it so a
            // transport that never flips chatTyping back cannot wedge the session
            // in 'thinking' forever.
            v.turnStartedAt = Date.now();
            overlay.call('sendPrompt', text, v.chatScope || 'general');
            // Hand the screen back the moment the turn is dispatched: the surface
            // collapses to the unified island so the reply streams in beside a
            // visible, usable workspace. Nulling voiceHost releases a hosting
            // composer.
            this.up(overlay, {
                voiceStatus: 'thinking',
                voiceMinimized: true,
                voiceHost: null
            });
            // Speech over the answer being written drops it (the barge-in).
            this.startBargeWatch(overlay);
            // Backstop poll. The turn resolves through voiceOnStateChange (wired to
            // the overlay's onStateUpdate), but a transport that patches the
            // thread with a scoped/quiet update would never reach that hook and
            // the session would wedge in 'thinking' forever. The resolver is
            // idempotent and cheap, so poll it too and let whichever path fires
            // first win.
            clearInterval(v.turnPoll);
            v.turnPoll = setInterval(()=>{
                try {
                    overlay.call('voiceOnStateChange');
                } catch (_) {}
            }, 500);
        },
        // ——— engine switch ———
        // `name` is the engine the recorder serves: 'recorder' (one-shot COMMAND)
        // or 'simone' (the continuous TALK loop) — same capture, different
        // commit/after-speak edges.
        async startRecorderEngine (overlay, name) {
            const v = this.voiceOf(overlay);
            this.setEngine(overlay, name || 'recorder');
            await this.mic(overlay);
            if (!v.active || !v.stream) return;
            const root = this.rootOf(overlay);
            // Engine swaps respect a user-muted mic — unmute re-arms via
            // voiceMicToggle.
            if (root && root.voiceMicMuted) return;
            this.record(overlay);
        },
        // ——— TALK: the live voice agent ———
        //
        // Nika 2026-10-26: "workspace voice mode should have voice assistant just
        // like we have on fly … implement … with 11labs voice assistant"; her
        // design answer the same night: "11labs talks, Simone acts". An
        // ElevenLabs agent (the Agents Platform, `@elevenlabs/client` over
        // WebRTC) hears and talks in real time: the greeting, live captions, turn
        // taking, the person talking over it. It holds no workspace data. Every
        // workspace question and action goes to Simone (`ask_workspace` →
        // sendPrompt into the voice thread) and every "show me" to Fly
        // (`show_page` → assistantFlyGenerate): CLIENT TOOLS that run here, with
        // the person's own grants. The agent's prompt and the tool names live on
        // the API server (src/domains/ai-voice/voiceAgentDefinition.js); the two
        // lists change together.
        //
        // The agent is private: a call starts only with a single-use token from
        // `sdk.voiceAgentSession` (POST /core/ai/voice/agent — members only, rate
        // limited, in the workspace's own voice). Where that is missing — an
        // older SDK, a server without the route (404) or without the agent (503),
        // a runtime without the client package — talk is the SIMONE loop above,
        // which every server has.
        //
        // The call's minutes cost workspace credits (Nika 2026-10-26: "chain it
        // to credits system so users pay for it as credits"): the server reserves
        // them before it mints the token and answers 402 when the workspace
        // cannot pay. That is a refusal with its own words, never the Simone loop
        // (its turns need the same credits): the 402 names the limit — the
        // balance, an owner's spend cap, the org pool's share for this workspace
        // — and so do the words. When a limit ends the call before the agent's
        // own length limit, the session says when (`maxSeconds`) and which limit
        // (`maxSecondsReason`), and the call ends there in those words. A
        // microphone the browser already blocks is said BEFORE a token is minted:
        // a token holds the workspace's credits while its call may still start.
        //
        // Engine name 'agent'. Its handles live on `v`: `agent` (the live
        // conversation), `agentToken` (one attempt — every callback checks it, so
        // a late callback of an ended attempt never touches the call),
        // `agentMuted` (the cut Stop speaking makes), `agentShows` (Fly pages
        // still being made for it), `agentPaid` (the end of the paid time).
        // The client package, loaded on first use (FA206 — an npm package is a
        // dynamic import inside a handler; pinned in dependencies.js, the runtime
        // importmap, and in package.json). Its own method, so a test hands in a
        // fake client.
        agentClient () {
            return (parcelRequire("h5RR3"));
        },
        // True when the browser already knows the microphone is blocked here
        // (Permissions API). Unknown or unsupported is false: the call's own mic
        // request then asks.
        async micBlocked () {
            try {
                const perms = typeof navigator !== 'undefined' && navigator.permissions;
                if (!perms || typeof perms.query !== 'function') return false;
                const status = await perms.query({
                    name: 'microphone'
                });
                return !!status && status.state === 'denied';
            } catch (_) {
                return false;
            }
        },
        // `opts.plain`: the retry in the agent's own language (English) after a
        // session in the person's language never got going — some agents do not
        // take every language.
        async startAgentEngine (overlay, opts) {
            const v = this.voiceOf(overlay);
            const o = opts || {};
            this.stopAgent(overlay);
            this.setEngine(overlay, 'agent');
            this.up(overlay, {
                voiceStatus: 'connecting',
                voiceInterim: '',
                voiceError: ''
            });
            const token = {};
            v.agentToken = token;
            v.agentHeard = false;
            v.agentPlain = !!o.plain;
            v.agentLang = null;
            const mine = ()=>v.agentToken === token && !!v.active && !!overlay.node;
            const root = this.rootOf(overlay) || {};
            const sdk = this.sdkOf(overlay);
            const ws = root.workspace;
            const workspaceId = ws && (ws.id || ws._id) ? String(ws.id || ws._id) : null;
            // The SIMONE loop: the same call surface on the server pipeline.
            const toLoop = ()=>{
                if (!mine()) return;
                v.agentToken = null;
                this.up(overlay, {
                    voiceStatus: 'listening',
                    voiceEngineReason: 'agent-unavailable'
                });
                this.startRecorderEngine(overlay, 'simone');
            };
            const blocked = await this.micBlocked();
            if (!mine()) return;
            if (blocked) {
                v.agentToken = null;
                this.fail(overlay, 'shell.voice.error.micDenied');
                return;
            }
            let session = null;
            try {
                session = await sdk.voiceAgentSession(workspaceId ? {
                    workspaceId: workspaceId
                } : {});
            } catch (err) {
                if (!mine()) return;
                const status = err && err.status;
                if (status === 404 || status === 503) {
                    toLoop();
                    return;
                }
                v.agentToken = null;
                this.fail(overlay, status === 429 ? 'shell.voice.error.agentBusy' : status === 402 ? this.agentLimitText(err.code, false) : 'shell.voice.error.agentStartFailed');
                return;
            }
            if (!mine()) return;
            if (!session || typeof session.conversationToken !== 'string' || !session.conversationToken) {
                toLoop();
                return;
            }
            // The paid time runs from the token: the call it opens is never longer.
            const paid = Number(session.maxSeconds);
            const paidUntil = Number.isFinite(paid) && paid > 0 ? Date.now() + paid * 1000 : 0;
            const paidBy = session.maxSecondsReason;
            let Conversation = null;
            try {
                const mod = await this.agentClient();
                // Named export ONLY: the web build has no default export, and
                // Parcel's production scope hoisting refuses any `default` access on
                // such a module as a hard build error (the retired engine broke every
                // dev deploy on it, 2026-08-02).
                Conversation = mod && mod.Conversation;
            } catch (_) {
                Conversation = null;
            }
            if (!mine()) return;
            if (!Conversation || typeof Conversation.startSession !== 'function') {
                toLoop();
                return;
            }
            // Who and where, for the agent's prompt; the greeting in the person's
            // language with their first name. The English retry keeps the agent's
            // own greeting and language.
            const code = String(root.lang || '').toLowerCase().split(/[-_]/)[0];
            const lang = !o.plain && /^[a-z]{2,3}$/.test(code) ? code : 'en';
            let languageName = 'English';
            try {
                languageName = new Intl.DisplayNames([
                    'en'
                ], {
                    type: 'language'
                }).of(lang) || lang;
            } catch (_) {
                languageName = lang;
            }
            const user = root.user || {};
            const first = String(user.name || '').trim().split(/\s+/)[0];
            const wsName = String(ws && (ws.displayName || ws.name || ws.slug) || '').trim();
            const dynamicVariables = {
                language_name: languageName
            };
            if (first) dynamicVariables.user_name = first;
            if (wsName) dynamicVariables.workspace_name = wsName;
            const overrides = {};
            if (!o.plain) {
                const greeting = first ? String(overlay.call('polyglot', 'shell.voice.agent.greeting') || '').replace('{name}', ()=>first) : String(overlay.call('polyglot', 'shell.voice.agent.greetingNoName') || '');
                const agent = {};
                if (greeting && !/^shell\./.test(greeting)) agent.firstMessage = greeting;
                if (lang !== 'en') {
                    agent.language = lang;
                    v.agentLang = lang;
                }
                if (Object.keys(agent).length) overrides.agent = agent;
            }
            if (typeof session.voiceId === 'string' && session.voiceId) overrides.tts = {
                voiceId: session.voiceId
            };
            let conv = null;
            try {
                conv = await Conversation.startSession({
                    conversationToken: session.conversationToken,
                    connectionType: session.connectionType === 'websocket' ? 'websocket' : 'webrtc',
                    overrides: overrides,
                    dynamicVariables: dynamicVariables,
                    // A tool call is the agent on the line, as a word from it is (the
                    // join watch at the end).
                    clientTools: {
                        ask_workspace: (params)=>{
                            if (!mine()) return 'Error: the call has ended.';
                            v.agentHeard = true;
                            return this.agentAsk(overlay, params);
                        },
                        show_page: (params)=>{
                            if (!mine()) return {
                                status: 'failed',
                                reason: 'call ended'
                            };
                            v.agentHeard = true;
                            return this.agentShow(overlay, params);
                        }
                    },
                    onModeChange: (m)=>{
                        if (mine()) this.agentMode(overlay, m && m.mode);
                    },
                    onMessage: (msg)=>{
                        if (mine()) this.agentCaption(overlay, msg);
                    },
                    onAgentResponseCorrection: (c)=>{
                        if (mine()) this.agentCorrection(overlay, c);
                    },
                    // Events the client has no callback for arrive here — the live
                    // partial transcript of the person among them.
                    onDebug: (ev)=>{
                        if (!mine() || !ev || ev.type !== 'tentative_user_transcript') return;
                        const said = ev.tentative_user_transcription_event;
                        const text = String(said && said.user_transcript || '').trim();
                        const r = this.rootOf(overlay);
                        if (text && !(r && r.voiceMicMuted)) this.up(overlay, {
                            voiceInterim: text
                        });
                    },
                    onDisconnect: (details)=>{
                        // Our own end clears the token first: past this guard the far
                        // side ended the call.
                        if (v.agentToken === token) this.agentEnded(overlay, details);
                    },
                    // Non-fatal client errors; a fatal one ends the call (onDisconnect).
                    onError: ()=>{}
                });
            } catch (err) {
                if (!mine()) return;
                v.agentToken = null;
                if (err && (err.name === 'NotAllowedError' || err.name === 'SecurityError')) {
                    this.fail(overlay, 'shell.voice.error.micDenied');
                    return;
                }
                if (v.agentLang) {
                    this.startAgentEngine(overlay, {
                        plain: true
                    });
                    return;
                }
                this.fail(overlay, 'shell.voice.error.agentStartFailed');
                return;
            }
            // Ended, superseded or switched while it connected: end it, never
            // adopt it.
            if (!mine()) {
                try {
                    const r = conv && conv.endSession();
                    if (r && typeof r.catch === 'function') r.catch(()=>{});
                } catch (_) {}
                return;
            }
            v.agent = conv;
            v.agentMuted = false;
            // A mic muted while the call connected stays muted.
            const state = this.rootOf(overlay);
            if (state && state.voiceMicMuted) this.agentMicMuted(overlay, true);
            // The orb's ring and the island read `v.analyser` (voiceCallFrame): an
            // analyser-shaped adapter over the call's own spectra, the louder of
            // the person and the agent per band.
            const bins = 64;
            v.analyser = {
                __agent: true,
                frequencyBinCount: bins,
                getByteFrequencyData: (out)=>{
                    let a = null;
                    let b = null;
                    try {
                        a = conv.getInputByteFrequencyData();
                        b = conv.getOutputByteFrequencyData();
                    } catch (_) {}
                    const len = a && a.length || b && b.length || 0;
                    if (!len) {
                        out.fill(0);
                        return;
                    }
                    const stride = len / out.length;
                    for(let i = 0; i < out.length; i++){
                        const from = Math.floor(i * stride);
                        const to = Math.max(from + 1, Math.floor((i + 1) * stride));
                        let peak = 0;
                        for(let j = from; j < to && j < len; j++){
                            const x = a ? a[j] : 0;
                            const y = b ? b[j] : 0;
                            const m = x > y ? x : y;
                            if (m > peak) peak = m;
                        }
                        out[i] = peak;
                    }
                }
            };
            v.bins = new Uint8Array(bins);
            if (state && state.voiceStatus === 'connecting') this.up(overlay, {
                voiceStatus: 'listening'
            });
            // The agent joins the call from its own side and greets first. One
            // that never does (an outage, a token that waited too long — seen live
            // on dev, 2026-10-26) leaves a silent call that says "listening": no
            // word from it in 15 s is a start that failed (in the person's
            // language: once more in English first, as a drop before a word is).
            clearTimeout(v.agentWatch);
            v.agentWatch = setTimeout(()=>{
                v.agentWatch = null;
                if (v.agentToken === token && !v.agentHeard) this.agentEnded(overlay, null);
            }, 15000);
            // The workspace's credits pay until `paidUntil`: the call ends there.
            clearTimeout(v.agentPaid);
            v.agentPaid = paidUntil ? setTimeout(()=>{
                v.agentPaid = null;
                if (v.agentToken === token) this.agentCreditsEnded(overlay, paidBy);
            }, Math.max(0, paidUntil - Date.now())) : null;
        },
        // The words for the limit that refuses a call or ends it: the balance,
        // an owner's spend cap, or the org pool's share for this workspace. A
        // refused start names it in the 402's `error` (the SDK's `err.code`), a
        // paid time in the session's `maxSecondsReason`; anything else is the
        // balance, which every older server meant.
        agentLimitText (limit, ended) {
            const cap = limit === 'spend_cap' || limit === 'spend_cap_exceeded';
            const share = limit === 'allocation' || limit === 'allocation_exceeded';
            if (ended) {
                if (cap) return 'shell.voice.error.agentSpendCapEnded';
                if (share) return 'shell.voice.error.agentAllocationEnded';
                return 'shell.voice.error.agentCreditsEnded';
            }
            if (cap) return 'shell.voice.error.agentSpendCap';
            if (share) return 'shell.voice.error.agentAllocation';
            return 'shell.voice.error.agentNoCredits';
        },
        // The paid time ran out: the call ends and the error line says which
        // limit ended it. Try again asks the server again — 402 while nothing is
        // left, a new call once there is room.
        agentCreditsEnded (overlay, limit) {
            const v = this.voiceOf(overlay);
            this.stopAgent(overlay);
            if (!v.active || !overlay.node) return;
            this.fail(overlay, this.agentLimitText(limit, true));
        },
        // The agent's turn edges. Speaking: the reply plays (unless the person
        // stopped it — the cut turn still drains on the wire). Listening: the
        // reply ended; while a tool is still out the agent is waiting for its
        // answer, which the call shows as thinking.
        agentMode (overlay, mode) {
            const v = this.voiceOf(overlay);
            if (mode === 'speaking') {
                v.agentHeard = true;
                if (!v.agentMuted) this.up(overlay, {
                    voiceStatus: 'speaking'
                });
                return;
            }
            if (mode !== 'listening') return;
            this.agentRestoreVolume(v);
            const asking = !!(v.awaiting && v.awaiting.tool && !v.awaiting.tool.answered);
            this.up(overlay, {
                voiceStatus: asking || v.agentShows > 0 ? 'thinking' : 'listening'
            });
        },
        // The captions: the person's final words and the agent's reply, both into
        // the one thread (voiceTurns) the call screen, the island and the strip
        // render. A user line with no word in it ("...") is the platform's
        // silence marker (the turn timeout passed with nothing said), never the
        // person's words: it stays out of the thread.
        agentCaption (overlay, msg) {
            const v = this.voiceOf(overlay);
            const text = String(msg && msg.message || '').trim();
            if (!text) return;
            const user = (msg.role || msg.source) === 'user';
            if (user && !/[\p{L}\p{N}]/u.test(text)) return;
            v.turnSeq = (v.turnSeq || 0) + 1;
            if (user) {
                // The person spoke: a reply they cut is over.
                this.agentRestoreVolume(v);
                this.up(overlay, {
                    voiceFinal: text,
                    voiceInterim: ''
                });
                this.turn(overlay, {
                    id: 'u' + v.turnSeq,
                    role: 'user',
                    text: text
                });
                return;
            }
            v.agentHeard = true;
            v.agentTurnId = 'a' + v.turnSeq;
            this.turn(overlay, {
                id: v.agentTurnId,
                role: 'agent',
                text: text
            });
        },
        // The person talked over the reply: the agent's line keeps only what was
        // said aloud.
        agentCorrection (overlay, c) {
            const v = this.voiceOf(overlay);
            const text = String(c && c.corrected_agent_response || '').trim();
            if (v.agentTurnId && text) this.turn(overlay, {
                id: v.agentTurnId,
                text: text
            });
        },
        // The far side ended the call. 'agent': the agent hung up (it said
        // goodbye and called end_call, or the call reached its length limit) —
        // the call ends here too. Anything else: the line dropped — say so and
        // keep the call so Try again reconnects. A call that never got going:
        // once more in English if it asked for another language, else the start
        // failed.
        agentEnded (overlay, details) {
            const v = this.voiceOf(overlay);
            const heard = !!v.agentHeard;
            const retry = !!v.agentLang && !v.agentPlain;
            this.stopAgent(overlay);
            if (!v.active || !overlay.node) return;
            if (!heard) {
                if (retry) this.startAgentEngine(overlay, {
                    plain: true
                });
                else this.fail(overlay, 'shell.voice.error.agentStartFailed');
                return;
            }
            if (details && details.reason === 'agent') {
                this.teardown(overlay);
                return;
            }
            this.fail(overlay, 'shell.voice.error.agentDisconnected');
        },
        // ask_workspace — the agent's question or action for the workspace,
        // asked of Simone in the voice thread with the person's own grants, in
        // ASSISTANT mode (a text answer the agent can say, even when the
        // person's own mode is Fly — a page is show_page's job). Resolves with
        // the answer (voiceOnStateChange → agentSettle), or after 50 s with
        // "still working" — the agent waits 60 s for a tool at most
        // (voiceAgentDefinition.js); the late answer follows as context.
        agentAsk (overlay, params) {
            const v = this.voiceOf(overlay);
            const root = this.rootOf(overlay);
            const request = String(params && params.request || '').replace(/\s+/g, ' ').trim();
            if (!request) return Promise.resolve('Error: the request is empty.');
            if (!root || root.bridgeStatus !== 'open') return Promise.resolve('Error: the workspace assistant is offline right now.');
            // One ask at a time: a newer one answers the older as replaced.
            if (v.awaiting && v.awaiting.tool) this.agentSettle(overlay, {
                error: 'replaced by a newer request'
            });
            return new Promise((resolve)=>{
                const tool = {
                    request: request,
                    resolve: resolve,
                    answered: false,
                    timer: null
                };
                const k = this.chatPrefix(v.chatScope);
                // `since`: the thread's length before the ask — only a row after it
                // can be this ask (the same words may have been asked before).
                const since = Array.isArray(root[k + 'chatMessages']) ? root[k + 'chatMessages'].length : 0;
                v.awaiting = {
                    type: 'chat',
                    k: k,
                    tool: tool,
                    since: since,
                    startedAt: Date.now()
                };
                tool.timer = setTimeout(()=>{
                    if (tool.answered) return;
                    tool.answered = true;
                    resolve('Still working on it. Tell the user the answer comes in a moment.');
                }, 50000);
                try {
                    overlay.call('sendPrompt', request, v.chatScope || 'general', undefined, undefined, {
                        mode: 'assistant'
                    });
                } catch (_) {
                    this.agentSettle(overlay, {
                        error: 'the workspace assistant could not take the request'
                    });
                    return;
                }
                this.up(overlay, {
                    voiceStatus: 'thinking'
                });
                // The same backstop poll as the loop's chat turn (commitAssistant).
                clearInterval(v.turnPoll);
                v.turnPoll = setInterval(()=>{
                    try {
                        overlay.call('voiceOnStateChange');
                    } catch (_) {}
                }, 500);
            });
        },
        // The ask_workspace turn ended (voiceOnStateChange read it off the
        // thread): `out` = { text } or { error }. The answer goes back as the
        // tool's result, as plain text the agent can say; an answer after the
        // tool already said "still working" reaches the agent as context, and it
        // tells the person on its next turn.
        agentSettle (overlay, out) {
            const v = this.voiceOf(overlay);
            const turn = v.awaiting;
            if (!turn || !turn.tool) return;
            v.awaiting = null;
            clearInterval(v.turnPoll);
            v.turnPoll = null;
            const tool = turn.tool;
            clearTimeout(tool.timer);
            // Markdown → words: no code, no markup, a link is its text; a long
            // answer keeps its first 1800 characters.
            const plain = (text)=>{
                const t = String(text || '').replace(/```[\s\S]*?```/g, ' ').replace(/`([^`]*)`/g, '$1').replace(/!\[[^\]]*\]\([^)]*\)/g, ' ').replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/[#*_>~|]/g, ' ').replace(/\s+/g, ' ').trim();
                return t.length > 1800 ? t.slice(0, 1797) + "\u2026" : t;
            };
            const error = out && out.error ? plain(out.error) : '';
            const answer = error ? '' : plain(out && out.text);
            if (!tool.answered) {
                tool.answered = true;
                tool.resolve(error ? 'Error: ' + error : answer || 'Done.');
            } else if (v.agent && typeof v.agent.sendContextualUpdate === 'function') try {
                v.agent.sendContextualUpdate('Simone finished the request "' + tool.request + '". ' + (error ? 'It failed: ' + error : 'The answer: ' + answer));
            } catch (_) {}
            const root = this.rootOf(overlay);
            if (root && root.voiceStatus === 'thinking' && !(v.agentShows > 0)) this.up(overlay, {
                voiceStatus: 'listening'
            });
        },
        // An ask of this request waits on the person (voiceOnStateChange read it
        // off the thread; the call screen shows it — AiAsk). The agent hears it
        // at once, as the tool's result: not done yet — a step waits for Run or
        // Skip on the screen, or a question (its words and its options) waits for
        // the person's pick there. It cannot answer either, and asking again does
        // not: a new ask is a new send, which closes the ask unanswered. A tool
        // already answered ("still working", or an ask before this one) hears it
        // as context. The request stays open: the reply after the answer on the
        // screen follows as context (agentSettle), on a fresh clock
        // (askAnswered).
        agentWaits (overlay, ask) {
            const v = this.voiceOf(overlay);
            const turn = v.awaiting;
            if (!turn || !turn.tool || !ask || turn.waitStep === ask.id) return;
            turn.waitStep = ask.id;
            turn.waitKind = ask.kind;
            const tool = turn.tool;
            let text = '';
            if (ask.kind === 'choice') {
                const quoted = (ask.options || []).map((o)=>'"' + o + '"').join(', ');
                text = 'Not done yet: Simone asks the user a question on the screen and waits for their answer' + (ask.prompt ? ': "' + ask.prompt + '" ' : '. ') + (quoted ? 'The options: ' + quoted + '. ' : '') + 'Tell the user the question: they choose their answer on the screen. ' + 'You cannot choose it for them, and asking the workspace again does not answer it. ' + 'Never say it is done.';
            } else {
                const label = typeof ask.label === 'string' ? ask.label.trim() : '';
                const what = label || String(ask.tool || 'a step').replace(/^module_fn_/, '').replace(/_/g, ' ');
                // The buttons by the words the screen shows, in the page language.
                const word = (key)=>{
                    let raw = '';
                    try {
                        raw = overlay.call('polyglot', key);
                    } catch (_) {
                        raw = '';
                    }
                    return typeof raw === 'string' && raw && raw !== key ? raw : '';
                };
                const run = word('ai.tool.run');
                const skip = word('ai.tool.skip');
                const press = run && skip ? 'they press "' + run + '" or "' + skip + '" on the screen. ' : 'they answer it on the screen. ';
                text = 'Not done yet: "' + what + '" waits for the user\u2019s approval on the screen and has not run. ' + 'Tell the user it waits for their OK: ' + press + 'You cannot approve it, and asking the workspace again does not approve it. ' + 'Never say it is done.';
            }
            if (!tool.answered) {
                clearTimeout(tool.timer);
                tool.answered = true;
                tool.resolve(text);
            } else if (v.agent && typeof v.agent.sendContextualUpdate === 'function') try {
                v.agent.sendContextualUpdate(text);
            } catch (_) {}
            // The tool is answered: the agent talks on while the ask waits.
            const root = this.rootOf(overlay);
            if (root && root.voiceStatus === 'thinking' && !(v.agentShows > 0)) this.up(overlay, {
                voiceStatus: 'listening'
            });
        },
        // show_page — Fly makes the page the agent was asked for on the
        // workspace canvas, as a spoken Fly ask does in the loop; the call steps
        // down to the island so the page is in view. Resolves within 25 s:
        // `ready` (the page's title and opening), `building` (it keeps building;
        // when it lands the agent hears it as context), `unavailable` (no Fly
        // here — the agent asks Simone instead) or `failed`.
        agentShow (overlay, params) {
            const v = this.voiceOf(overlay);
            const root = this.rootOf(overlay);
            const fns = overlay.context && overlay.context.functions || {};
            const request = String(params && params.request || '').replace(/\s+/g, ' ').trim();
            if (!request) return Promise.resolve({
                status: 'failed',
                reason: 'empty request'
            });
            if (!root || root._aiBoardsAvailable !== true || typeof fns.assistantFlyGenerate !== 'function') return Promise.resolve({
                status: 'unavailable'
            });
            const token = v.agentToken;
            v.agentShows = (v.agentShows || 0) + 1;
            this.up(overlay, {
                voiceStatus: 'thinking',
                voiceMinimized: true,
                voiceHost: null
            });
            const resultOf = (page)=>{
                if (page && page.status === 'ready') return {
                    status: 'ready',
                    title: String(page.title || '').trim(),
                    opening: String(page.opening || '').trim()
                };
                const why = page && page.error || 'failed';
                return why === 'unavailable' ? {
                    status: 'unavailable'
                } : {
                    status: 'failed',
                    reason: why
                };
            };
            return new Promise((resolve)=>{
                let answered = false;
                const timer = setTimeout(()=>{
                    answered = true;
                    resolve({
                        status: 'building'
                    });
                }, 25000);
                Promise.resolve().then(function() {
                    return (parcelRequire("h5RR3"));
                }).then((res)=>overlay.call('assistantFlyGenerate', request)).catch(()=>null).then((page)=>{
                    clearTimeout(timer);
                    v.agentShows = Math.max(0, (v.agentShows || 1) - 1);
                    const live = v.agentToken === token && !!v.active;
                    const out = resultOf(page);
                    if (live && out.status === 'ready' && out.title) this.actionTurn(overlay, out.title);
                    if (!answered) {
                        answered = true;
                        resolve(out);
                        return;
                    }
                    if (!live || !v.agent || typeof v.agent.sendContextualUpdate !== 'function') return;
                    try {
                        v.agent.sendContextualUpdate(out.status === 'ready' ? 'The page "' + out.title + '" is on the screen now.' : 'The page could not be built (' + (out.reason || out.status) + ').');
                    } catch (_) {}
                });
            });
        },
        // Stop speaking on the live call. WebRTC has no client-side cut (the
        // client's own interrupt is a no-op there; the agent stops when the
        // PERSON speaks): the reply's sound goes to zero and the agent hears the
        // person is active (it holds its next turn a moment). The sound comes
        // back on the agent's next listening edge or the person's next words —
        // after 15 s at the latest, so a missing edge never leaves the call mute.
        agentStopSpeaking (overlay) {
            const v = this.voiceOf(overlay);
            const conv = v.agent;
            if (!conv) return false;
            try {
                conv.setVolume({
                    volume: 0
                });
                v.agentMuted = true;
            } catch (_) {}
            try {
                conv.sendUserActivity();
            } catch (_) {}
            clearTimeout(v.agentUnmute);
            v.agentUnmute = setTimeout(()=>this.agentRestoreVolume(v), 15000);
            this.up(overlay, {
                voiceStatus: 'listening'
            });
            return true;
        },
        agentRestoreVolume (v) {
            clearTimeout(v.agentUnmute);
            v.agentUnmute = null;
            if (!v.agentMuted) return;
            v.agentMuted = false;
            try {
                if (v.agent) v.agent.setVolume({
                    volume: 1
                });
            } catch (_) {}
        },
        // The input axis on the live call (voiceMicToggle): the agent stops
        // hearing; the call goes on.
        agentMicMuted (overlay, muted) {
            const v = this.voiceOf(overlay);
            if (!v.agent || typeof v.agent.setMicMuted !== 'function') return false;
            try {
                v.agent.setMicMuted(!!muted);
            } catch (_) {
                return false;
            }
            return true;
        },
        // End the live call and release what it holds. Clearing the token first
        // makes every callback of this attempt — and an attempt still connecting
        // — abandon itself. A tool still out is answered, so the agent never
        // waits on a call that is gone.
        stopAgent (overlay) {
            const v = this.voiceOf(overlay);
            const conv = v.agent;
            v.agent = null;
            v.agentToken = null;
            clearTimeout(v.agentWatch);
            v.agentWatch = null;
            clearTimeout(v.agentPaid);
            v.agentPaid = null;
            clearTimeout(v.agentUnmute);
            v.agentUnmute = null;
            v.agentMuted = false;
            v.agentTurnId = null;
            v.agentShows = 0;
            const turn = v.awaiting;
            if (turn && turn.tool) {
                v.awaiting = null;
                clearInterval(v.turnPoll);
                v.turnPoll = null;
                clearTimeout(turn.tool.timer);
                if (!turn.tool.answered) {
                    turn.tool.answered = true;
                    try {
                        turn.tool.resolve('Error: the call ended.');
                    } catch (_) {}
                }
            }
            if (v.analyser && v.analyser.__agent) {
                v.analyser = null;
                v.bins = null;
            }
            if (conv) try {
                const r = conv.endSession();
                if (r && typeof r.catch === 'function') r.catch(()=>{});
            } catch (_) {}
        },
        // Engine switch:
        //   COMMAND — the one-shot server pipeline (recorder → Whisper → host
        //             grammar / Simone → 11labs → close).
        //   TALK    — the live voice agent (`startAgentEngine`, Nika 2026-10-26:
        //             "11labs talks, Simone acts"). Where the agent is not
        //             available, the SIMONE loop on the SAME server pipeline as
        //             command (VOICE-TALK-ONLY-SIMONE-1 part 3, route A): recorder
        //             → Whisper → Simone (sendPrompt → sdk.ai transport) → 11labs
        //             speaks the FINAL turn text → recorder … until ✕/Esc.
        // Any (re)start — Try again, a mode switch — ends a live agent call first.
        startEngine (overlay) {
            const root = this.rootOf(overlay);
            this.stopAgent(overlay);
            if (!root || root.voiceMode !== 'talk') {
                this.up(overlay, {
                    voiceEngineReason: 'command-mode'
                });
                this.startRecorderEngine(overlay, 'recorder');
                return;
            }
            this.up(overlay, {
                voiceEngineReason: null
            });
            const sdk = this.sdkOf(overlay);
            if (sdk && typeof sdk.voiceAgentSession === 'function') {
                this.startAgentEngine(overlay);
                return;
            }
            this.startRecorderEngine(overlay, 'simone');
        },
        // WAI-ARIA dialog-close focus restore — the other half of `syncFocus`
        // above (which moves focus IN when the full surface opens). Give back
        // whatever had focus when the session STARTED — `voiceStart` (in
        // voiceSession.js) captures it before the overlay/strip/island ever
        // takes over. Idempotent (clears `focusOrigin` first) and defensive: a
        // node that unmounted mid-session (route change, size toggle) is
        // silently skipped rather than thrown on.
        restoreFocus (v) {
            const node = v.focusOrigin;
            v.focusOrigin = null;
            if (node && node.isConnected && typeof node.focus === 'function') try {
                node.focus();
            } catch (_) {}
        },
        teardown (overlay) {
            const v = this.voiceOf(overlay);
            v.active = false;
            this.stopAgent(overlay);
            v.awaiting = null;
            v.closeAfterCommit = false;
            clearTimeout(v.doneTimer);
            clearTimeout(v.stopTimer);
            clearInterval(v.turnPoll);
            v.turnPoll = null;
            this.stopBargeWatch(v);
            this.stopRecorder(v);
            this.stopSpeaking(overlay);
            this.stopTracks(v);
            v.engine = null;
            this.up(overlay, {
                voiceOpen: false,
                voiceMinimized: false,
                // Session end releases the composer — every voiceHost reader ANDs
                // with voiceOpen so this is pure hygiene, but it closes the
                // stale-host class: the next open starts from null unless ITS
                // gesture sets one.
                voiceHost: null,
                voiceStatus: 'idle',
                voiceInterim: '',
                voiceResult: '',
                voiceMicMuted: false,
                voiceEngine: null,
                voiceEngineReason: null,
                voiceStartedAt: 0
            });
            this.restoreFocus(v);
        }
    },
    position: 'fixed',
    inset: '0',
    zIndex: '10600',
    flow: 'y',
    align: 'center center',
    // The header floats over the top edge (CallHeader, absolute); the column
    // keeps clear of it on a short screen.
    padding: 'D B C',
    boxSizing: 'border-box',
    background: 'black.6',
    // style-object form required for backdrop-filter (css-in-props leak bug).
    style: {
        backdropFilter: 'blur(28px) saturate(1.2)',
        WebkitBackdropFilter: 'blur(28px) saturate(1.2)'
    },
    // The Siri surface is dark in both schemes.
    themeModifier: 'dark',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'C opacity defaultBezier, C visibility defaultBezier',
    // Visible only as the FULL surface: `voiceMinimized` hands rendering to the
    // island (SimoneReasoningPill) and `voiceHost` (composer strip, T18) hands it
    // to the composer — in both cases the session keeps running here (this
    // element stays the engine host: scope handles, onStateUpdate watcher, Esc
    // binding all live on). Guarded reads: either key may not exist on every
    // root; absence means the classic full-screen behavior.
    isActive: (el, s)=>!!(s.root && s.root.voiceOpen && !s.root.voiceMinimized && !s.root.voiceHost),
    '.isActive': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto'
    },
    role: 'dialog',
    ariaModal: 'true',
    aria: {
        label: (el)=>el.call('polyglot', 'shell.voice.call.title')
    },
    onInit: (el, s)=>{
        const root = s && s.root || s;
        // Announce the host so mic buttons render (Chat surfaces without this
        // overlay — chrome-connect, ext-ui — never show a mic).
        if (root && root.update) root.update({
            voiceHostReady: true
        }, {
            preventFetch: true
        });
    },
    // Escape takes away the TOP voice layer, and never ends a call by itself
    // (2026-10-22, the call redesign): the call screen steps down to the island
    // (voiceMinimize — the call goes on); the composer strip, which replaced the
    // text input, gives the input back by ending the voice input it is; the
    // island is ambient, so there Escape belongs to whatever the page has open.
    // A genuine window-level browser event, so it is DECLARED (FA503):
    // registered once per instance, removed in dispose().
    onWindowKeydown: (e, el)=>{
        if (e.key !== 'Escape') return;
        const st = el.state && (el.state.root || el.state);
        if (!st || !st.voiceOpen) return;
        if (st.voiceHost) el.call('voiceStop');
        else if (!st.voiceMinimized) el.call('voiceMinimize');
    },
    onBeforeRemove: (el)=>el.call('voiceTeardown'),
    // ——— the state watcher (VOICE-OVERLAY-STATE-HOOK-DEAD-1) ———
    //
    // `onStateUpdate` in DOMQL v3.14 is a DECLARATIVE effect, not an event:
    // `smbls/packages/element/src/create.js` registers it ONLY when a sibling
    // `stateDeps` ARRAY is present (`typeof element.onStateUpdate === 'function'
    // && Array.isArray(element.stateDeps)`), and no legacy `stateUpdate` event
    // is emitted anywhere in the framework. This block shipped for months with
    // NO `stateDeps` and the legacy `(changes, el)` signature, so it never ran
    // once: focus never entered the dialog, the voice⟷chat exclusivity never
    // asserted, and a Talk turn resolved on the 500 ms `turnPoll` backstop
    // ALONE (an up-to-500 ms lag before Simone's answer is spoken).
    //
    // Every selector below is read UP FRONT inside the framework's own effect,
    // so the subscription never depends on the handler's control flow (the
    // conditional-read tracking gap `stateDeps` exists to close). They are also
    // each self-contained — a `stateDeps` entry is serialized on its own by
    // frank.toJSON, exactly like the props around it, so a shared module-scope
    // root-resolver would read as `undefined` on the platform payload (FA204,
    // project_frank_drops_module_local_helpers — the same trap that moved
    // `syncChatSuppression` onto `scope`).
    //
    // What each dep is for:
    //   • voiceOpen / voiceMinimized / voiceHost — the posture axes both
    //     `syncFocus` (full-surface rising edge) and `syncChatSuppression`
    //     (foreground rising edge, session-end falling edge) are edge-triggered on.
    //   • `<prefix>chatTyping` / `<prefix>chatMessages` for all three thread
    //     prefixes `chatPrefix()` can produce ('' general | '_ax_' add-app |
    //     '_db_' dashboard) — the awaited prefix is only known at runtime
    //     (`v.awaiting.k`), and a dep read must not be conditional, so all
    //     three are subscribed. Reading a key a given root never declares is
    //     safe and mints a lazy signal (signal/store.js), so canvas/preview
    //     roots take no write and still re-fire if the key ever lands.
    //   • freestyleBusy / freestyleError — the other awaited turn type.
    // Deliberately NOT deps: `assistantOpen`/`assistantDock`. The handler WRITES
    // `assistantDock`; watching it would re-enter the effect on its own write.
    stateDeps: [
        (el, s)=>(s && (s.root || s) || {}).voiceOpen,
        (el, s)=>(s && (s.root || s) || {}).voiceMinimized,
        (el, s)=>(s && (s.root || s) || {}).voiceHost,
        (el, s)=>(s && (s.root || s) || {}).chatTyping,
        (el, s)=>(s && (s.root || s) || {})._ax_chatTyping,
        (el, s)=>(s && (s.root || s) || {})._db_chatTyping,
        (el, s)=>(s && (s.root || s) || {}).chatMessages,
        (el, s)=>(s && (s.root || s) || {})._ax_chatMessages,
        (el, s)=>(s && (s.root || s) || {})._db_chatMessages,
        (el, s)=>(s && (s.root || s) || {}).freestyleBusy,
        (el, s)=>(s && (s.root || s) || {}).freestyleError
    ],
    // Watches async turns the session started (assistant reply, freestyle build),
    // then runs the voice⟷chat exclusivity choreography (see _syncChatSuppression
    // above) — engine watcher first, so the turn resolution a dock write triggers
    // re-entry for has already been processed. v3.14 signature:
    // `(el, state, context, { prev, next })`.
    onStateUpdate: (el)=>{
        el.call('voiceOnStateChange');
        el.scope.syncChatSuppression(el);
        el.scope.syncFocus(el);
    },
    // A click on the scrim steps down to the island, like Escape — a stray
    // click beside the controls must never hang up. (While minimized the root is
    // invisible with pointerEvents none; the guard covers a synthetic click
    // during the posture swap.)
    onClick: (e, el, s)=>{
        if (e.target !== el.node) return;
        if (s.root && s.root.voiceMinimized) return;
        el.call('voiceMinimize');
    },
    // The edge glow is cached once — the frame loop below runs at 60 fps and
    // must not walk the tree (the orb ring and the clock are voiceCallFrame's,
    // which caches its own).
    onRender: (el)=>{
        if (!el.node) return;
        el.scope.voiceGlowEl = el.lookdown && el.lookdown('Glow') || null;
    },
    onFrame: (el, s)=>{
        const root = s && s.root || s;
        if (!root || !root.voiceOpen) return;
        // Strip-hosted (T18) or minimized (the island runs the call chrome off
        // its own frame loop): the screen is invisible — skip the 60fps work.
        if (root.voiceHost || root.voiceMinimized) return;
        // The orb's ring and the clock; answers the live mic level.
        const level = el.call('voiceCallFrame') || 0;
        const sc = el.scope;
        sc.voiceT = (sc.voiceT || 0) + 1 / 60;
        const t = sc.voiceT;
        const glow = sc.voiceGlowEl;
        if (glow && glow.setNodeStyles) {
            const status = root.voiceStatus;
            const speakPulse = status === 'speaking' ? 0.12 * Math.abs(Math.sin(t * 4.4)) : 0;
            glow.setNodeStyles({
                opacity: Math.min(1, 0.5 + level * 1.5 + speakPulse).toFixed(3),
                filter: 'blur(52px) saturate(1.35) hue-rotate(' + Math.round(t * 16 % 360) + 'deg)'
            });
        }
    },
    // ——— visuals ———
    // Edge glow — brand conic gradient masked away from the center so it hugs
    // the viewport rim, exactly the Apple-Intelligence treatment.
    Glow: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        backgroundImage: 'themeDark',
        opacity: '.5',
        // flat, so the atomic engine adds the -webkit- twin (an inline style block never gets one)
        maskImage: 'radial-gradient(ellipse at center, transparent 46%, black 86%)',
        style: {
            filter: 'blur(52px) saturate(1.35)',
            willChange: 'filter, opacity'
        }
    },
    // ——— the call screen (2026-10-22): who you are talking to and the call's
    // clock across the top, the orb in the middle, the conversation as
    // captions under it, and the three call controls at the bottom — the
    // anatomy of the Fly call Nika approved for shaker, on this surface's own
    // dark scrim and edge glow. Every piece is the SHARED call chrome
    // (components/VoiceControls.js) the two bars carry too.
    // The top edge: the identity on the left; the clock and Minimize on the
    // right. Minimize sits where a dismiss is looked for, and it is the one
    // dismiss that cannot hang up.
    CallHeader: {
        position: 'absolute',
        top: 'B',
        left: 'B',
        right: 'B',
        flow: 'x',
        align: 'center space-between',
        gap: 'A',
        // Which engine runs is said here, honestly (the engine tag's job,
        // 2026-08-02 per Nika "not sure if elevenlabs agent is speaking"): talk
        // is Simone, the one-shot hold is a voice command. The tooltip carries the
        // full sentence.
        CallIdentity: {
            flow: 'y',
            gap: 'W',
            minWidth: '0',
            titleDeps: [
                'voiceMode'
            ],
            title: (el, s)=>el.call('polyglot', (s.root && s.root.voiceMode) === 'talk' ? 'shell.voice.engine.whyTalk' : 'shell.voice.engine.whyCommand'),
            CallName: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '500',
                color: 'title',
                whiteSpace: 'nowrap',
                textDeps: [
                    'voiceMode'
                ],
                // `Simone` is the agent's own NAME and stays Latin (glossary rule 4).
                text: (el, s)=>(s.root && s.root.voiceMode) === 'talk' ? 'Simone' : el.call('polyglot', 'shell.voice.engine.voice')
            },
            CallKind: {
                tag: 'span',
                fontSize: 'Z',
                color: 'caption',
                whiteSpace: 'nowrap',
                textDeps: [
                    'voiceMode'
                ],
                text: (el, s)=>el.call('polyglot', (s.root && s.root.voiceMode) === 'talk' ? 'shell.voice.call.title' : 'shell.voice.call.commandTitle')
            }
        },
        CallTrail: {
            flow: 'x',
            align: 'center flex-end',
            gap: 'Z',
            flexShrink: '0',
            VoiceCallClock: {
                fontSize: 'Z1'
            },
            // The dialog's focus move-in (scope syncFocus) lands here — the safe
            // control, never the hang-up.
            CallMinimize: {
                extends: 'NavbarButton',
                icon: 'minimize',
                title: (el)=>el.call('polyglot', 'shell.voice.call.minimize'),
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('voiceMinimize');
                }
            }
        }
    },
    Center: {
        flow: 'y',
        align: 'center center',
        gap: 'A',
        // Column gauge — the SAME `H` token as the bottom chat prompt
        // (CanvasPromptTextarea's base width), so every posture of the call
        // shares the composer stack's footprint (2026-08-06 per Nika "give voice
        // ai the same maxwidth as chatprompt").
        maxWidth: 'H',
        maxHeight: '100%',
        minHeight: '0',
        padding: 'B',
        boxSizing: 'border-box',
        position: 'relative',
        width: '100%',
        transform: 'translateY(var(--spacing-A2))',
        transition: 'C transform defaultBezier',
        isActive: (el, s)=>!!(s.root && s.root.voiceOpen),
        '.isActive': {
            transform: 'translateY(0)'
        },
        // The orb at call size; its ring breathes with the mic and the reply.
        VoiceOrb: {
            boxSize: 'D1',
            marginBottom: 'Z',
            VoiceOrbCore: {
                Icon: {
                    boxSize: '38%'
                }
            }
        },
        // The lifecycle word, large — the clock is in the header. Here it wraps:
        // an error is read in full on the call screen (a bar cuts it to a line).
        VoiceCallStatus: {
            align: 'center center',
            maxWidth: '100%',
            VoiceCallWord: {
                fontSize: 'A2',
                textAlign: 'center',
                whiteSpace: 'normal'
            },
            // One clock per screen — it is in the header.
            VoiceCallClock: null
        },
        // THE CAPTIONS — the shared transcript (components/VoiceLog.js), at the
        // screen's reading size; the newest line reads first. The only place the
        // answers appear (2026-08-06 per Nika "do not mix answering with two
        // sections").
        VoiceLog: {
            fontSize: 'A1',
            maxHeight: 'F',
            flexShrink: '1',
            minHeight: '0',
            aria: {
                label: (el)=>el.call('polyglot', 'shell.voice.call.transcript')
            }
        },
        // Live partial speech — reserved for engines that emit interims (the
        // server pipeline commits whole utterances, so this is usually empty).
        Interim: {
            tag: 'p',
            fontSize: 'B1',
            color: 'caption',
            lineHeight: '1.35',
            textAlign: 'center',
            aria: {
                live: 'polite'
            },
            textDeps: [
                'voiceInterim'
            ],
            text: (el, s)=>s.root && s.root.voiceInterim || ''
        },
        // THE ASK — what waits on the person, as the island shows it (the shared
        // AiAsk: a step with what it will write and Run · Skip · Run all on the
        // row's own settle, or a question with one button per option on the
        // card's own writer, and a live region that says "Needs your OK" or
        // "Waiting for your choice"). The island and the strip are hidden while
        // this screen is up, and the live agent keeps it up for its whole ask, so
        // the call shows the ask itself. In the column's flow, under the words:
        // it comes once per ask, and the column re-centres as the captions grow
        // anyway — a box kept for it would sit empty on every other turn.
        AiAsk: {},
        // The turn's one contextual action — Stop speaking while the reply plays,
        // Try again after an error. The slot keeps its box when empty (Rule 66):
        // the controls under it never jump as the assistant starts and stops
        // talking. The hidden button is out of the tab order and the tree.
        CallTurnSlot: {
            flow: 'x',
            align: 'center center',
            // Exactly the pill's height, so showing it moves nothing (measured: a
            // min-height slot grew 3px under the pill and nudged the whole column).
            height: 'B2',
            childExtends: 'Button',
            childProps: {
                flow: 'x',
                gap: 'Y2',
                align: 'center center',
                height: 'B2',
                boxSizing: 'border-box',
                padding: '0 A1',
                round: 'radiusPill',
                theme: 'transparent',
                background: 'white.12',
                color: 'title',
                fontSize: 'Z1',
                fontWeight: '500',
                flexShrink: '0',
                ':hover': {
                    background: 'white.2'
                }
            },
            StopSpeaking: {
                display: null,
                showDeps: [
                    'voiceStatus'
                ],
                show: (el, s)=>!!(s.root && s.root.voiceStatus === 'speaking'),
                aria: {
                    label: (el)=>el.call('polyglot', 'shell.voice.stopSpeaking')
                },
                Icon: {
                    name: 'stop'
                },
                Label: {
                    tag: 'span',
                    text: '{{ shell.voice.stopSpeaking | polyglot }}'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('voiceStopSpeaking');
                }
            },
            TryAgain: {
                display: null,
                showDeps: [
                    'voiceStatus'
                ],
                show: (el, s)=>!!(s.root && s.root.voiceStatus === 'error'),
                aria: {
                    label: (el)=>el.call('polyglot', 'shell.voice.retry')
                },
                Icon: {
                    name: 'refresh'
                },
                Label: {
                    tag: 'span',
                    text: '{{ shell.voice.retry | polyglot }}'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('voiceRetry');
                }
            }
        },
        // Type · End · Mute.
        VoiceCallActions: {},
        // The hint sits on the dark scrim, not on a scheme surface: `themeModifier:
        // 'dark'` forces only this surface's own `theme`, so an adaptive `caption`
        // here resolved the LIGHT scheme's near-black ink on the dark scrim
        // (1.52:1 measured live over the sky, served 12a4f7826), and the old extra
        // .7 opacity sank it further. The ink is the dark surface's caption
        // (gray13); in light the `black.6` scrim over a white card leaves a
        // mid-grey ground (rgb 102), so the light scheme takes the next step up
        // (gray15) - both clear 4.5:1 at the worst ground
        // (__tests__/voiceHintInk.test.js). No opacity on text.
        Hint: {
            tag: 'span',
            fontSize: 'Z',
            color: 'gray13',
            '@light': {
                color: 'gray15'
            },
            textAlign: 'center',
            text: (el, s)=>{
                const r = s.root || s;
                return el.call('polyglot', r.voiceMode === 'talk' ? 'shell.voice.hint.talk' : 'shell.voice.hint.command');
            }
        }
    }
};

});
parcelRegister("h5RR3", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hOYhe"))) : import("hOYhe")).then(()=>parcelRequire('dHF6z'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("9RnXx", function(module, exports) {

$parcel$export(module.exports, "VoiceStrip", () => $01da409d44f12bca$export$4ac02fcfa12294e6);
// In-composer voice surface (T18) — when a composer hosts voice, this strip
// REPLACES the text input in place (same shell, same gauge) instead of the
// full-screen VoiceOverlay stacking over the page.
//
// HOST-ANNOUNCEMENT CONTRACT (root.voiceHost — declared in canvas/state.js and
// workspace/state-app.js): 'canvas' | 'chat' | null — which composer currently
// OWNS the voice surface.
//   • The composer's VoiceBtn writes voiceHost synchronously (preventFetch) in
//     its onPointerdown, BEFORE voicePttPress — by the time the engine flips
//     voiceOpen the host is already known.
//   • While voiceOpen && voiceHost matches this strip's `hostKey` prop, the
//     strip is THE voice surface. The voiceMinimized axis is deliberately
//     ignored here: the strip is already composer-sized, so "minimized" is
//     meaningless while a composer hosts — this also keeps the engine's
//     talk-mode auto-minimize from ever leaving the session surfaceless.
//   • VoiceOverlay gates BOTH its postures on !voiceHost: full-screen at
//     voiceOpen && !voiceHost && !voiceMinimized, mini card at
//     voiceOpen && voiceMinimized && !voiceHost.
//   • Handing the session off to the island = CLEARING voiceHost (the shared
//     VoiceControls Type button writes { voiceMinimized: true,
//     voiceHost: null }); handing it to the call screen = voiceExpand, which
//     clears it too. voiceHost is never cleared on plain close — a stale
//     value is inert because every consumer AND-s it with voiceOpen, and every
//     open path re-asserts its own value.
//
// BECAUSE the strip is the surface users actually get (both mic buttons set a
// host), it must carry the FULL control set — stop-speaking, mute, expand and
// the hang-up included (2026-08-02 per Nika "add talk / command switcher - i
// dont see it": controls that lived only on the overlay were unreachable).
// The row is the SHARED call row (components/VoiceControls.js VoiceCallRow),
// identical in anatomy to the island's head; the words float above it in the
// SHARED bubble stack (_simone/AiBubbleStack.js), as they do over the island.
//
// Layout note (v3.14): `flow` is STATIC. Reactive layout props compute once at
// mount, so the strip is always a column and its rows show/hide instead.
const $01da409d44f12bca$export$4ac02fcfa12294e6 = {
    // FA204 / frank trap — hosting used to be a bare module-scope const read
    // from inside `display` (a serialized factory); it reads as undefined once
    // this component is frank.toJSON'd for platform delivery (workspace
    // d6ea1142, project_frank_drops_module_local_helpers). Moved into `scope`,
    // called via `el.scope.hosting`.
    scope: {
        // Is this strip instance the live voice host? Self-contained (no
        // cross-helper calls — the frank hoisted-helper constraint Chat.js
        // documents).
        hosting: (el, s)=>!!(s && s.root && s.root.voiceOpen && el.hostKey && s.root.voiceHost === el.hostKey)
    },
    // Mounted-closed root → reactive `display:` predicate, NOT `hide:` (house
    // display-gate rule — a hide:'d mounted-closed root sticks at display:none).
    // The whole subtree is gated here, so children never re-check hosting.
    display: (el, s)=>el.scope.hosting(el, s) ? 'flex' : 'none',
    // "The morph should feel like ONE object changing state, not a swap"
    // (the ticket's own words). Before this, the swap between the typing UI
    // (Textarea/PromptButtons/CircleButton) and this strip was a hard
    // display:none↔flex cut with NO transition at all — the one moment in
    // this whole file family without one (every size/posture change around
    // it uses `transition: 'B all defaultBezier'`). display can't be
    // transitioned (a browser/CSS limit, not a DOMQL gap — this element is
    // legitimately "mounted-closed", see the comment above; switching its
    // gate to opacity/visibility to make it transitionable is the exact
    // anti-pattern that comment already warns off), so the fix is a genuine
    // CSS `animation` (design-system token, not a raw keyframe — same
    // `animation: 'fadeInUpShort'` seam already used elsewhere in this
    // codebase, e.g. tickets/pages/epics.js, chat/MessengerOverlay.js).
    // Unlike `transition`, an `animation` replays every time the element
    // re-enters the render tree, so it fires on every hosting cycle, not
    // just first mount. Short (opacity + ≤10%-ish rise), design-direction.md
    // §13's "single fade-rise" — the same restrained shape as VoiceOverlay's
    // own entrance. `fadeInUpShort` = brand/designSystem/animation.js
    // (translate3d 6.5%, opacity 0→1) — an existing registered token, not a
    // new keyframe.
    animation: 'fadeInUpShort',
    flow: 'y',
    align: 'stretch',
    width: '100%',
    minWidth: '0',
    // The anchor of the words above the bar (AiBubbleStack sits on this
    // strip's top edge, whatever positions the composer around it).
    position: 'relative',
    // The call's words float ABOVE the strip as bubbles. A host whose composer
    // box clips its overflow cannot float them — the assistant drawer's (Chat:
    // the brand prompt box is overflow hidden, and its thread is on screen and
    // shows the ask) — and sets `floatWords: false`: that strip keeps the newest
    // line in its row instead.
    floatWords: true,
    // Equal on every side — and on the resting pill this inset is what keeps
    // the orb and the hang-up concentric with the capsule's round ends (the
    // pill's half-height is the 36px control row's half plus this inset).
    padding: 'Y',
    // The call's 60 fps half — the orb's ring and the clock — only while THIS
    // strip is the call (two strips are mounted: the canvas prompt and the
    // assistant drawer's composer).
    onFrame: (el, s)=>{
        if (!el.scope || !el.scope.hosting(el, s)) return;
        el.call('voiceCallFrame');
    },
    // THE CALL BAR (2026-10-22, the call redesign) — the shared row: the orb,
    // the status word with the call's clock (over the hint, before anyone has
    // spoken), and the controls: [Try again | Stop] Type · Mute · Expand · End
    // call. One row at the control height: it never grows with the call.
    VoiceCallRow: {},
    // THE WORDS, AS BUBBLES ABOVE THE BAR (2026-10-28, Nika: "captions should be
    // like bubble and should not resize ai navbar") — the same stack the island
    // floats over its bar: the newest two lines of the call (the person's live
    // partial as it is heard), and a step that waits for the person's OK while
    // the thread is not on screen. Only where it can float (`floatWords`).
    AiBubbleStack: {
        if: (el)=>!!el.parent && el.parent.floatWords !== false
    }
};

});

parcelRegister("52P3m", function(module, exports) {

$parcel$export(module.exports, "VoiceLog", () => $3ac4bdbd60dbeab2$export$b791ea3873523616);
// The conversation transcript — ONE implementation for every surface that
// shows what was said (full VoiceOverlay, in-composer VoiceStrip, and the
// minimized island in SimoneReasoningPill). It previously existed twice,
// near-identically, and the strip would have made three (Rule 63); hosts now
// reference the bare key and override only what differs.
//
// SOURCE PRECEDENCE — deliberately NOT a branch on which engine is live:
//   1. `root.voiceTurns` — the engine-agnostic contract both engines write
//      ({ id, role: 'user' | 'agent' | 'action', text, streaming? }).
//   2. the assistant thread (`<voiceChatKey>chatMessages`) — the legacy source
//      the Web-Speech talk path routes through. Kept as a fallback so the log
//      never goes blank in the window before/while `voiceTurns` is populated,
//      and so a host that only has the thread still reads correctly.
// Surfaces must never ask WHICH engine is running: they render these rows.
//
// A host that needs a DIFFERENT set of rows (the island merges the assistant
// conversation into the same list so there is one thread to follow, rather
// than a voice log and a chat preview that replace each other) supplies a
// `turnsSource` factory. Deliberately not named `rows` — that is a real HTML
// attribute and DOMQL would mirror it onto the node.
//
// Why this exists at all: an ElevenLabs conversation produced NO text on any
// surface — the engine wrote a reply key nothing read, and the overlay log
// only ever derived from the assistant thread, which conversational turns
// never enter (2026-08-02 per Nika "it should also show texts").
const $3ac4bdbd60dbeab2$export$b791ea3873523616 = {
    // FA204 / frank trap (workspace d6ea1142, project_frank_drops_module_local_
    // helpers) — every helper below used to be a bare module-scope const,
    // read from inside `show`/`children`/`onRender`/`onUpdate`; undefined once
    // frank.toJSON'd for platform delivery. All are pure/stateless (no mutable
    // state lives here — see `stick` below for why the ONE thing that needed a
    // durable slot, the scroll signature, stays on `el`, not scope: scope is
    // the same shared object across every instance of a component, and the
    // three VoiceLog hosts — overlay, strip, island — would fight over one
    // signature if it lived here).
    scope: {
        // 'action' is a command-mode RESULT (the canvas actually did something)
        // rather than speech. It earns its own row kind so a single list can
        // still tell doing from talking (2026-08-02 per Nika "in command mode it
        // should also text the answers") — before this, a command flashed a ✓
        // and left no trace.
        norm (role) {
            return role === 'user' ? 'user' : role === 'action' ? 'action' : 'agent';
        },
        // Newest 14 turns, normalised and stable-keyed so DOMQL diffs rows in
        // place (that is what makes a streaming reply read as growing text
        // rather than a line being swapped out).
        rows (root) {
            const live = root && root.voiceTurns || [];
            if (live.length) return live.filter((t)=>t && String(t.text || '').trim()).slice(-14).map((t, i)=>({
                    id: t.id || 'vt' + i,
                    // `kind` wins over `role`: action turns are written as
                    // { role: 'agent', kind: 'action' } (voiceSession _actionTurn),
                    // so role-first evaluation rendered every executed command as
                    // plain assistant speech and the 'action' branch below was
                    // unreachable.
                    role: this.norm(t.kind || t.role),
                    text: t.text,
                    streaming: !!t.streaming
                }));
            const msgs = root && root[(root.voiceChatKey || '') + 'chatMessages'] || [];
            return msgs.filter((m)=>m && (m.role === 'user' || m.role === 'assistant') && String(m.text || '').trim()).slice(-14).map((m, i)=>({
                    id: m.id || 'vm' + i,
                    role: this.norm(m.role),
                    text: m.text,
                    streaming: false
                }));
        },
        // Resolve the host's override once per evaluation, falling back to the
        // shared source. Called from both `show` and `children` so they can
        // never disagree.
        resolve (el, s) {
            const src = el && el.turnsSource;
            const out = typeof src === 'function' ? src(el, s) : src;
            return out || this.rows(s && s.root);
        },
        // Stick to the newest turn — scroll this log's own node to its bottom
        // whenever a NEW turn appears or the streaming tail grows (2026-08-06
        // per Nika "always scroll at the bottom of voice thread when new
        // something pops"). Two parts:
        //
        //   • content signature (row count + last row's text length): onUpdate
        //     fires for EVERY root update — voiceStatus flips, interim text,
        //     unrelated app state — and yanking the scroll on churn that grew
        //     nothing would fight a user reading an older turn. Only actual
        //     thread growth scrolls. Stored on the element (the MessageList
        //     `el._roBottom` convention), NOT on scope — see the file-header
        //     note.
        //   • rAF before writing scrollTop — same reason as ChatMessageList: the
        //     hook can run before this update wave's child mutations lay out,
        //     and a scrollHeight read that early sticks to the PREVIOUS bottom,
        //     which is exactly the reported "does not follow new turns" bug.
        //
        // No near-bottom anti-yank check (deliberate divergence from
        // ChatMessageList): the ask is ALWAYS bottom on new content, and this is
        // a capped 14-row live transcript, not a paginated history the user
        // scrolls back through mid-turn.
        stick (el) {
            const rows = this.resolve(el, el.state);
            const last = rows.length ? rows[rows.length - 1] : null;
            const sig = rows.length + ':' + (last ? String(last.text || '').length : 0);
            if (el._voiceLogSig === sig) return;
            el._voiceLogSig = sig;
            const node = el.node;
            if (!node) return;
            requestAnimationFrame(()=>{
                if (!node.isConnected) return;
                // `.scrollTo()` (a method call), not `.scrollTop =` (a property
                // assignment) — FA511 treats el.node as read-only from project
                // code; `.scrollTo()` is a sanctioned exception. No `behavior`, so
                // still the same instant jump as before — a safe swap, not a
                // rewrite. (The identical `X.scrollTop = X.scrollHeight` shape
                // exists elsewhere in chat/MessageList.js, chat/ThreadPanel.js and
                // shared/_simone/Chat.js — out of this ticket's scope, left as-is.)
                node.scrollTo(0, node.scrollHeight);
            });
        },
        // Returns a bundle KEY; the `Who` child resolves it at its render site.
        who (role) {
            if (role === 'user') return 'shell.voice.log.you';
            if (role === 'action') return 'shell.voice.log.done';
            return 'shell.voice.log.assistant';
        },
        // One accent, and only where it means something (brand: green = a thing
        // that actually happened). Speech stays monochrome so actions are the
        // only colour in the thread and read instantly; the speaker is quiet ink
        // either way — the line under it is what matters.
        whoColor (role) {
            return role === 'action' ? 'green' : 'caption';
        }
    },
    display: null,
    show: (el, s)=>el.scope.resolve(el, s).length > 0,
    flow: 'y',
    gap: 'Z',
    width: '100%',
    maxHeight: 'F',
    overflow: 'hidden auto',
    textAlign: 'left',
    // CAPTIONS, not a log (2026-10-22, the call redesign): a quiet sentence-case
    // speaker over each line instead of a shouting uppercase eyebrow, and the
    // NEWEST line in the title ink so the eye lands on what was just said; the
    // older lines step back to the paragraph ink. Sizes are relative to the
    // host's own fontSize (the island reads at Z1, the call screen at A1) —
    // the type tokens are em-based, so one set serves every host.
    children: (el, s)=>{
        const rows = el.scope.resolve(el, s);
        return rows.map((m, i)=>({
                key: m.id,
                flow: 'y',
                gap: 'W',
                Who: {
                    tag: 'span',
                    text: el.call('polyglot', el.scope.who(m.role)),
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: el.scope.whoColor(m.role)
                },
                Body: {
                    tag: 'p',
                    // The ellipsis is the only streaming affordance — a caret would need a
                    // per-frame animation on a node the transcript rebuilds constantly.
                    text: m.streaming ? m.text + "\u2026" : m.text,
                    fontSize: 'A',
                    lineHeight: '1.45',
                    color: i === rows.length - 1 ? 'title' : 'paragraph'
                }
            }));
    },
    onRender: (el)=>el.scope.stick(el),
    onUpdate: (el)=>el.scope.stick(el)
};

});

parcelRegister("jRZCg", function(module, exports) {

$parcel$export(module.exports, "VoiceEngineTag", () => $e772c339a3932689$export$5f7ef13b7a5e5c21);
$parcel$export(module.exports, "VoiceOrb", () => $e772c339a3932689$export$137595cb299b5ce);
$parcel$export(module.exports, "VoiceCallClock", () => $e772c339a3932689$export$da19669ffde04a56);
$parcel$export(module.exports, "VoiceCallStatus", () => $e772c339a3932689$export$3461d7e0a7213);
$parcel$export(module.exports, "VoiceCallCaption", () => $e772c339a3932689$export$486de05ddb9d628c);
$parcel$export(module.exports, "VoiceCallRow", () => $e772c339a3932689$export$c52b5e619cc7ae23);
$parcel$export(module.exports, "VoiceControls", () => $e772c339a3932689$export$de0a73111a96fef6);
$parcel$export(module.exports, "VoiceCallAction", () => $e772c339a3932689$export$f62a08f2c57eb980);
$parcel$export(module.exports, "VoiceCallActions", () => $e772c339a3932689$export$2cc4f4e75759d4b8);
// Shared voice chrome — ONE call anatomy for every posture a voice session
// takes: the in-composer strip (VoiceStrip), the bottom-centre island
// (SimoneReasoningPill's voice case) and the expanded call screen
// (VoiceOverlay). Each host composes these pieces; none grows its own set.
//
// THE CALL (Nika 2026-10-22: "improve design and UX of voice calling mode in
// workspace, both in bottom bar and when its expanded"). The reference is the
// Fly call she approved for shaker on 2026-10-18 — an orb, live captions, mute,
// end, a clock. Before this the three postures each drew the session their own
// way: a 13-bar dash wave and a centred engine tag in the island, a bare status
// line in the strip, a waveform with no mute and no way back to the bar on the
// full screen (its only exit ended the session). Now:
//
//   • VoiceOrb         — the assistant's presence: an ink disc carrying the state
//                        glyph, with a ring that follows the mic level while it
//                        listens and pulses while it speaks
//   • VoiceCallStatus  — the lifecycle word and the call clock ("Listening 0:42")
//   • VoiceCallCaption — the newest line of the conversation, one line (bars)
//   • VoiceControls    — the bar controls, one set and one order in both bars:
//                        [Try again | Stop] [Type] [Mute] [Expand] [End call]
//   • VoiceCallActions — the expanded screen's labelled trio: Type · End · Mute
//
// Every control is state-derived, never host-derived: the same component
// behaves correctly on a composer strip (voiceHost set) and on the island
// (voiceHost null) without either host configuring it. The 60 fps half (the
// orb's ring, the clock's tick) is `voiceCallFrame` (functions/voiceSession.js),
// run from the onFrame of whichever host is on show.
// Which engine is actually running. Deliberately quiet — a dot plus a word,
// at caption weight — but present, so a live agent conversation and the
// one-shot pipeline never look identical (2026-08-02 per Nika "not sure if
// elevenlabs agent is speaking"). Absent when no session is live. The call
// surfaces now say it in the expanded header (VoiceCallIdentity); this tag
// stays registered for the UI kit's specimen.
const $e772c339a3932689$export$5f7ef13b7a5e5c21 = {
    // FA204 / frank trap — `_engineWhy` used to be a bare module-scope function
    // read from inside `title` (a serialized factory); it silently read as
    // undefined once this component is frank.toJSON'd for platform delivery
    // (workspace d6ea1142, project_frank_drops_module_local_helpers). Moved
    // into `scope`, called via `el.scope.engineWhy`.
    scope: {
        // Why the live engine is the one it is. Talk-only
        // (VOICE-TALK-ONLY-REMOVE-DEAD-CONVAI-UI-1): only the live SIMONE/command
        // split remains. Returns a bundle KEY; the `title:` call site resolves it
        // (an attribute takes the FUNCTION form, I18N-CONVENTION §1).
        engineWhy (root) {
            const r = root || {};
            if (r.voiceMode !== 'talk') return 'shell.voice.engine.whyCommand';
            return 'shell.voice.engine.whyTalk';
        }
    },
    display: null,
    // FA515 — `voiceOpen && voiceEngine` short-circuits: any run where
    // voiceOpen is falsy never reads voiceEngine at all. Declarative deps make
    // the subscription independent of control flow (workspace ff9de771).
    showDeps: [
        'voiceOpen',
        'voiceEngine'
    ],
    show: (el, s)=>!!(s.root && s.root.voiceOpen && s.root.voiceEngine),
    flow: 'x',
    align: 'center center',
    gap: 'Y',
    flexShrink: '0',
    // Say WHY, not just what — the tooltip carries the full sentence.
    title: (el, s)=>el.call('polyglot', el.scope.engineWhy(s && s.root)),
    Dot: {
        width: 'Y',
        height: 'Y',
        round: 'radiusPill',
        flexShrink: '0',
        backgroundDeps: [
            'voiceEngine'
        ],
        // Talk is Simone on both talk engines: the live agent and the loop.
        background: (el, s)=>{
            const engine = s && s.root && s.root.voiceEngine;
            return engine === 'simone' || engine === 'agent' ? 'title' : 'caption';
        }
    },
    Label: {
        tag: 'span',
        fontSize: 'Y',
        fontWeight: '700',
        letterSpacing: '.06em',
        textTransform: 'uppercase',
        color: 'caption',
        whiteSpace: 'nowrap',
        textDeps: [
            'voiceEngine'
        ],
        // `Simone` is the agent's own NAME and stays Latin (glossary rule 4).
        text: (el, s)=>{
            const engine = s && s.root && s.root.voiceEngine;
            return engine === 'simone' || engine === 'agent' ? 'Simone' : el.call('polyglot', 'shell.voice.engine.voice');
        }
    }
};
const $e772c339a3932689$export$137595cb299b5ce = {
    scope: {
        orbGlyph (root) {
            const r = root || {};
            if (r.voiceStatus === 'error') return 'warning';
            if (r.voiceMicMuted) return 'micOff';
            if (r.voiceStatus === 'speaking') return 'wave';
            if (r.voiceStatus === 'thinking') return 'magicstar';
            // The loop holds: a step waits for the person's OK on the screen, or a
            // question for their pick.
            if (r.voiceStatus === 'waiting' || r.voiceStatus === 'choosing') return 'clock';
            if (r.voiceStatus === 'done') return 'checkmark';
            return 'mic';
        }
    },
    aria: {
        hidden: 'true'
    },
    position: 'relative',
    flexShrink: '0',
    boxSize: 'B2',
    // Scaled per frame by voiceCallFrame (setNodeStyles — never state). It
    // starts flush with the disc, so a host whose frame loop is not running
    // (a hidden tab) still shows a clean disc.
    VoiceOrbRing: {
        position: 'absolute',
        inset: '0',
        round: '100%',
        background: 'title',
        opacity: '0.14',
        pointerEvents: 'none',
        transformOrigin: 'center center',
        transform: 'scale(1)'
    },
    VoiceOrbCore: {
        position: 'relative',
        boxSize: '100%',
        round: '100%',
        flow: 'x',
        align: 'center center',
        background: 'title',
        color: 'document',
        transition: 'B background defaultBezier, B color defaultBezier',
        // An error is a real status: the error fill and the ink the brand measured
        // against it (errorFillBg / errorFillInk — the `error` theme's own pair).
        isError: (el, s)=>(s.root && s.root.voiceStatus) === 'error',
        '.isError': {
            background: 'errorFillBg',
            color: 'errorFillInk'
        },
        Icon: {
            name: (el, s)=>el.scope.orbGlyph(s.root),
            boxSize: '45%'
        }
    }
};
const $e772c339a3932689$export$da19669ffde04a56 = {
    tag: 'span',
    state: {
        secs: 0
    },
    scope: {
        clockText (secs) {
            const t = Math.max(0, Math.floor(Number(secs) || 0));
            const h = Math.floor(t / 3600);
            const m = Math.floor(t % 3600 / 60);
            const ss = String(t % 60).padStart(2, '0');
            return h ? h + ':' + String(m).padStart(2, '0') + ':' + ss : m + ':' + ss;
        }
    },
    display: null,
    // Function deps: a string dep reads `s[key]`, and `s` is this clock's own
    // state — the session keys live on the root.
    showDeps: [
        (el, s)=>s.root && s.root.voiceOpen,
        (el, s)=>s.root && s.root.voiceStartedAt
    ],
    show: (el, s)=>!!(s.root && s.root.voiceOpen && s.root.voiceStartedAt),
    flexShrink: '0',
    fontSize: 'Z',
    lineHeight: '1.2',
    color: 'caption',
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    title: (el)=>el.call('polyglot', 'shell.voice.call.duration'),
    text: (el, s)=>el.scope.clockText(s.secs)
};
const $e772c339a3932689$export$3461d7e0a7213 = {
    scope: {
        // Returns DISPLAY TEXT — the error copy is already resolved when it lands
        // in root state (VoiceOverlay.scope.fail), the rest are bundle keys.
        callStatusText (el, root) {
            const r = root || {};
            const t = (k)=>el.call('polyglot', k);
            if (r.voiceStatus === 'error') return r.voiceError || t('shell.voice.status.error');
            // The live agent's call is still connecting (VoiceOverlay.scope.startAgentEngine).
            if (r.voiceStatus === 'connecting') return t('shell.voice.status.connecting');
            // The loop holds for the person (VoiceOverlay.scope.holdForAsk): the
            // thread's own words — a step that waits for the OK (ChatMessage, the
            // island), a question that waits for a pick (the ask_user row).
            if (r.voiceStatus === 'waiting') return t('ai.chat.needsOk');
            if (r.voiceStatus === 'choosing') return t('ai.toolStep.choose');
            if (r.voiceMicMuted && r.voiceStatus !== 'speaking') return t('shell.voice.call.muted');
            if (r.voiceStatus === 'thinking') return t('shell.voice.status.thinking');
            if (r.voiceStatus === 'speaking') return t('shell.voice.status.speaking');
            if (r.voiceStatus === 'done') return "\u2713 " + t('shell.voice.status.done');
            return t(r.voiceMode === 'talk' ? 'shell.voice.call.listening' : 'shell.voice.status.listening');
        }
    },
    flow: 'x',
    // Baseline, not centre: the word and the smaller clock read as one line.
    align: 'baseline flex-start',
    gap: 'Y1',
    minWidth: '0',
    role: 'status',
    aria: {
        live: 'polite'
    },
    VoiceCallWord: {
        tag: 'span',
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: 'Z1',
        fontWeight: '500',
        // The bar's two lines fit the 36px control height (see VoiceCallInfo).
        lineHeight: '1.2',
        color: (el, s)=>(s.root && s.root.voiceStatus) === 'error' ? 'dangerInk' : 'title',
        text: (el, s)=>el.scope.callStatusText(el, s.root),
        title: (el, s)=>el.scope.callStatusText(el, s.root)
    },
    VoiceCallClock: {}
};
const $e772c339a3932689$export$486de05ddb9d628c = {
    scope: {
        // Mirrors VoiceLog's source precedence (voiceTurns, then the assistant
        // thread) — the newest non-empty row only.
        latestTurn (root) {
            const live = root && root.voiceTurns || [];
            for(let i = live.length - 1; i >= 0; i--){
                const t = live[i];
                if (t && String(t.text || '').trim()) {
                    const role = t.kind === 'action' ? 'action' : t.role === 'user' ? 'user' : 'agent';
                    return {
                        role: role,
                        text: String(t.text).trim()
                    };
                }
            }
            return null;
        },
        captionText (el, root) {
            const r = root || {};
            const turn = this.latestTurn(r);
            if (!turn) return el.call('polyglot', r.voiceMode === 'talk' ? 'shell.voice.call.speakNaturally' : 'shell.voice.hint.command');
            const who = turn.role === 'user' ? 'shell.voice.log.you' : turn.role === 'action' ? 'shell.voice.log.done' : 'shell.voice.log.assistant';
            return el.call('polyglot', who) + ': ' + turn.text.replace(/\s+/g, ' ');
        }
    },
    tag: 'span',
    minWidth: '0',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 'Z',
    lineHeight: '1.2',
    color: 'caption',
    text: (el, s)=>el.scope.captionText(el, s.root),
    title: (el, s)=>el.scope.captionText(el, s.root)
};
const $e772c339a3932689$export$c52b5e619cc7ae23 = {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    VoiceOrb: {},
    // Two tight lines that stay inside the 36px control height, so the row is
    // exactly as tall as the orb and the buttons — and on the composer's
    // capsule the strip's inset then keeps the orb and the hang-up concentric
    // with its round ends.
    VoiceCallInfo: {
        flow: 'y',
        gap: '0',
        minWidth: '0',
        flex: '1 1 auto',
        VoiceCallStatus: {},
        // The hint before anyone has spoken; then the bubbles above carry the
        // lines — unless this strip cannot float them (VoiceStrip floatWords).
        VoiceCallCaption: {
            hide: (el, s)=>{
                const strip = typeof el.lookup === 'function' ? el.lookup('VoiceStrip') : null;
                return !!strip && strip.floatWords !== false && !!el.scope.latestTurn(s.root);
            }
        }
    },
    VoiceControls: {}
};
const $e772c339a3932689$export$de0a73111a96fef6 = {
    // FA204 / frank trap — every helper lives in `scope`, called via
    // `el.scope.<name>` (project_frank_drops_module_local_helpers).
    scope: {
        // Type = "give me the text input back". While a composer HOSTS a live talk
        // session that means handing the conversation to the island (the session
        // survives, only the surface owner changes) and putting the caret in the
        // field the strip gave back; the one-shot command and an errored session
        // have nothing to hand off, so it ends voice.
        backToTyping (el, s) {
            const r = s && s.root;
            if (!r || !r.update) return;
            if (r.voiceHost && r.voiceMode === 'talk' && r.voiceStatus !== 'error') {
                r.update({
                    voiceMinimized: true,
                    voiceHost: null
                }, {
                    preventFetch: true
                });
                // After the write: the field's `hide` re-runs in the update's
                // microtask, and the focus is queued behind it (the strip stays in
                // the tree while hidden, so the field is still found through it).
                el.call('voiceFocusComposer');
            } else el.call('voiceStop');
        }
    },
    flow: 'x',
    align: 'center center',
    gap: 'Y',
    flexShrink: '0',
    role: 'group',
    aria: {
        label: (el)=>el.call('polyglot', 'shell.voice.call.controls')
    },
    // Every control is a NavbarButton with a semantically-named key — the
    // shared base rides on childExtends, and the names stay readable for every
    // reference to "KeyboardBtn", "the mute button" etc. in the file family.
    childExtends: 'NavbarButton',
    // `error` must never be a dead end: nothing re-arms from it on its own. A
    // registered `voiceRetry` re-runs the engine switch; without it, stop and
    // open a fresh session in the same mode (which also re-primes the reply
    // audio inside this click).
    RetryBtn: {
        display: null,
        showDeps: [
            'voiceStatus'
        ],
        show: (el, s)=>(s.root && s.root.voiceStatus) === 'error',
        icon: 'refresh',
        title: (el)=>el.call('polyglot', 'shell.voice.retry'),
        flexShrink: '0',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const fns = el.context && el.context.functions || {};
            if (typeof fns.voiceRetry === 'function') {
                el.call('voiceRetry');
                return;
            }
            const r = s && s.root;
            el.call('voiceStop');
            el.call('voiceStart', {
                mode: r && r.voiceMode === 'talk' ? 'talk' : 'command'
            });
        }
    },
    // Halts the spoken reply WITHOUT ending the session — the talk loop goes
    // straight back to listening (the barge-in).
    StopBtn: {
        display: null,
        showDeps: [
            'voiceStatus'
        ],
        show: (el, s)=>(s.root && s.root.voiceStatus) === 'speaking',
        icon: 'stop',
        title: (el)=>el.call('polyglot', 'shell.voice.stopSpeaking'),
        flexShrink: '0',
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('voiceStopSpeaking');
        }
    },
    // Not on a phone: the composer row has no room for five controls beside the
    // status (it cut "Speaking…" to "S…" at 390px), the call hands itself to the
    // island after the first line anyway, and the call screen keeps Type.
    KeyboardBtn: {
        display: null,
        showDeps: [
            'voiceOpen',
            'voiceHost',
            '_isPhoneViewport'
        ],
        show: (el, s)=>!!(s.root && s.root.voiceOpen && s.root.voiceHost && s.root._isPhoneViewport !== true),
        icon: 'keyboard',
        title: (el)=>el.call('polyglot', 'shell.voice.backToTyping'),
        flexShrink: '0',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.scope.backToTyping(el, s);
        }
    },
    // INPUT-axis mute: never ends the session, never changes posture. A toggle
    // with a FIXED name — aria-pressed says the state (the WorkspaceCallPanel
    // rule); the tooltip says what a click does. Pressed = the danger ink on its
    // own wash, so a muted mic reads from across the room (the meet dock's OFF
    // plate).
    MicBtn: {
        icon: (el, s)=>s.root && s.root.voiceMicMuted ? 'micOff' : 'mic',
        'aria-label': (el)=>el.call('polyglot', 'shell.voice.mic.mute'),
        'aria-pressed': (el, s)=>String(!!(s.root && s.root.voiceMicMuted)),
        title: (el, s)=>el.call('polyglot', s.root && s.root.voiceMicMuted ? 'shell.voice.mic.unmute' : 'shell.voice.mic.mute'),
        flexShrink: '0',
        isMuted: (el, s)=>!!(s.root && s.root.voiceMicMuted),
        '.isMuted': {
            color: 'dangerInk',
            background: 'color-mix(in srgb, currentColor 14%, transparent)'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('voiceMicToggle');
        }
    },
    // A bar opens the call screen. From the composer strip too: voiceExpand
    // releases the hosting composer, so the screen (which shows only while no
    // composer hosts) can take over.
    ExpandBtn: {
        display: null,
        showDeps: [
            'voiceOpen',
            'voiceMinimized',
            'voiceHost'
        ],
        show: (el, s)=>!!(s.root && s.root.voiceOpen && (s.root.voiceMinimized || s.root.voiceHost)),
        icon: 'fullscreen',
        title: (el)=>el.call('polyglot', 'shell.voice.expand'),
        flexShrink: '0',
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('voiceExpand');
        }
    },
    // End call — the house hang-up (WorkspaceCallPanel's HangUp): the `error`
    // status fill with its own measured ink, the handset turned down.
    EndBtn: {
        theme: 'error',
        icon: 'phone',
        title: (el)=>el.call('polyglot', 'shell.voice.call.end'),
        flexShrink: '0',
        Icon: {
            transform: 'rotate(135deg)'
        },
        ':hover': {
            filter: 'brightness(1.08)'
        },
        ':active': {
            transform: 'scale(0.94)'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('voiceStop');
        }
    }
};
const $e772c339a3932689$export$f62a08f2c57eb980 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    align: 'center center',
    gap: 'Y1',
    minWidth: 'D',
    padding: 'Y',
    round: 'radiusCard',
    background: 'transparent',
    borderWidth: '0',
    color: 'title',
    cursor: 'pointer',
    transition: 'B filter defaultBezier, B transform defaultBezier',
    // Hover brightens the rendered fill (the disc's wash or the hang-up plate)
    // and the word with it — never an opacity fade (Rule 65).
    ':hover': {
        filter: 'brightness(1.25)'
    },
    ':active': {
        transform: 'scale(0.96)'
    },
    VoiceCallDisc: {
        boxSize: 'C1',
        round: '100%',
        flow: 'x',
        align: 'center center',
        background: 'white.12',
        transition: 'B background defaultBezier, B color defaultBezier',
        Icon: {
            boxSize: 'A1'
        }
    },
    VoiceCallLabel: {
        tag: 'span',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'caption',
        whiteSpace: 'nowrap'
    }
};
const $e772c339a3932689$export$2cc4f4e75759d4b8 = {
    role: 'group',
    aria: {
        label: (el)=>el.call('polyglot', 'shell.voice.call.controls')
    },
    flow: 'x',
    align: 'flex-start center',
    gap: 'A',
    childExtends: 'VoiceCallAction',
    TypeAction: {
        'aria-label': (el)=>el.call('polyglot', 'shell.voice.call.typeInstead'),
        title: (el)=>el.call('polyglot', 'shell.voice.call.typeInstead'),
        VoiceCallDisc: {
            Icon: {
                name: 'keyboard'
            }
        },
        VoiceCallLabel: {
            text: '{{ shell.voice.call.type | polyglot }}'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('voiceMinimize');
            el.call('voiceFocusComposer');
        }
    },
    EndAction: {
        'aria-label': (el)=>el.call('polyglot', 'shell.voice.call.end'),
        title: (el)=>el.call('polyglot', 'shell.voice.call.end'),
        // The hang-up plate: the error fill and the ink the brand measured on it
        // (the `error` theme's own pair, set as props — a theme here would lose
        // to the disc's own wash).
        VoiceCallDisc: {
            background: 'errorFillBg',
            color: 'errorFillInk',
            Icon: {
                name: 'phone',
                transform: 'rotate(135deg)'
            }
        },
        VoiceCallLabel: {
            text: '{{ shell.voice.call.endShort | polyglot }}'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('voiceStop');
        }
    },
    MuteAction: {
        'aria-label': (el)=>el.call('polyglot', 'shell.voice.mic.mute'),
        'aria-pressed': (el, s)=>String(!!(s.root && s.root.voiceMicMuted)),
        title: (el, s)=>el.call('polyglot', s.root && s.root.voiceMicMuted ? 'shell.voice.mic.unmute' : 'shell.voice.mic.mute'),
        VoiceCallDisc: {
            // Pressed = the bar MicBtn's own treatment: the danger ink on its wash.
            isMuted: (el, s)=>!!(s.root && s.root.voiceMicMuted),
            '.isMuted': {
                color: 'dangerInk',
                background: 'color-mix(in srgb, currentColor 18%, transparent)'
            },
            Icon: {
                name: (el, s)=>s.root && s.root.voiceMicMuted ? 'micOff' : 'mic'
            }
        },
        VoiceCallLabel: {
            text: '{{ shell.voice.call.mute | polyglot }}'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('voiceMicToggle');
        }
    }
};

});

parcelRegister("bQFOG", function(module, exports) {

$parcel$export(module.exports, "cascadeMenu", () => $8a04fceae5120b26$export$943c402f19fc5858);
// CascadeMenu — a reusable, multi-level (nested) context menu for the canvas
// dropdown plugin. Hand the result of `cascadeMenu(items)` to the opener:
//
//   el.call('openDropdown', { id, anchorRect, content: cascadeMenu(items) })
//
// Item shape:
//   { label, icon?, hint?, danger?, ariaLabel?, title?, onClick?(e, el, s),
//     children?: [ ...nested items ],   // recursive cascade (any depth)
//     submenuBody?: { ...DOMQL menu rows } }  // OR drop in an existing body
//   { divider: true }                         // a separator row
//
// An item with `children` / `submenuBody` renders a ▸ and reveals a flyout
// submenu — a NEW absolutely-positioned panel off its own row — on hover/focus.
// Reveal is pure CSS (`:hover > [data-submenu]`), so nesting is fully general:
// every level reuses this same builder and reveals independently of the others.
//
// Two gotchas this handles:
//  - A parent row is a <div>, NOT a <button>: its flyout contains buttons, and
//    button-in-button is invalid HTML (the browser drops the nested buttons).
//    Leaf (action) rows stay <button>s.
//  - The dropdown plugin's panel is `overflow: auto`, which clips a flyout that
//    sits at `left: 100%`. The body clears the panel's overflow on mount.
// Build a menu body (glass card chrome from the shared CanvasCreateMenuBody)
// holding one row per item. Recursion happens inside cascadeRow for submenus.
//
// FA204 / frank trap — `cascadeRow` (+ its `CASCADE_ROW` chrome constant)
// used to be module-scope, read from this function's own body: an exported
// function reading a module-scope sibling is exactly as unresolvable post
// frank.toJSON as a component reading a module-scope const (workspace
// d6ea1142 / 8732aa07, project_frank_drops_module_local_helpers). Both now
// live as self-contained locals INSIDE `cascadeMenu`, the one consumer —
// `cascadeRow`'s own recursive call into `cascadeMenu` for submenus is safe
// (a named function referencing its own binding is intrinsic to the
// function's text, not a module-scope resolution).
function $8a04fceae5120b26$export$943c402f19fc5858(items) {
    // STUDIO-NEW-1 (2026-08-14): the flyout's reveal is pure CSS
    // (`:hover > [data-submenu]`), so — unlike the top-level dropdown Panel,
    // which flips side via computePosition.js — it has zero notion of the
    // viewport edge. `left: 100%` from a row anchored in the right/bottom
    // quadrant of the screen (the common case: the CanvasCreateIsland "+"
    // trigger sits at the far right edge by design, and a right-click
    // context menu can land anywhere the user clicks) pushes the flyout
    // mostly or entirely past the browser edge. Reproduced live: the
    // "New" flyout rendered as an unreachable sliver past the right
    // viewport edge, and clicking the coordinates devtools reported for
    // "Create project" landed outside the (invisible, off-canvas) row and
    // fell through to the outside-click handler — closing the menu instead
    // of opening the picker.
    //
    // Fix: measure on reveal (mouseenter / focus — by then the browser has
    // just applied the :hover/:focus-within `display:flex`, so a
    // synchronous getBoundingClientRect() reflects the flyout's real,
    // laid-out size) and flip to whichever side/edge actually has room.
    // Kept as a LOCAL closure (not module-scope) — a module-scope helper
    // read by this exported function is unresolvable after frank.toJSON
    // (see the cascadeRow/CASCADE_ROW note below); this is the same fix
    // shape, one level up.
    const FLYOUT_EDGE_PAD = 8;
    function flipSubmenuIntoView(rowNode) {
        if (typeof window === 'undefined' || !rowNode) return;
        const sub = rowNode.querySelector('[data-submenu="menu"]');
        if (!sub) return;
        // Reset to the CSS default before measuring — otherwise a stale flip
        // from a previous hover (before a resize, say) would measure its own
        // already-flipped box instead of the natural one.
        sub.style.left = '';
        sub.style.right = '';
        sub.style.marginLeft = '';
        sub.style.marginRight = '';
        sub.style.top = '';
        sub.style.bottom = '';
        const subRect = sub.getBoundingClientRect();
        const rowRect = rowNode.getBoundingClientRect();
        if (rowRect.right + subRect.width + FLYOUT_EDGE_PAD > window.innerWidth) {
            sub.style.left = 'auto';
            sub.style.right = '100%';
            sub.style.marginLeft = '0';
            sub.style.marginRight = 'var(--spacing-v)';
        }
        if (rowRect.top + subRect.height + FLYOUT_EDGE_PAD > window.innerHeight) {
            sub.style.top = 'auto';
            sub.style.bottom = '-6px';
        }
    }
    // Row chrome shared by every item — mirrors the /files + /studio context
    // rows (MenuPanelItem/ctxMenuRow look) so the menu reads as the house
    // dropdown.
    const CASCADE_ROW = {
        role: 'menuitem',
        position: 'relative',
        display: 'flex',
        flow: 'x',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'Z',
        width: '100%',
        padding: 'Y Z',
        round: 'radiusControl',
        border: '0',
        background: 'transparent',
        textAlign: 'left',
        fontSize: 'Z2',
        cursor: 'pointer',
        flexShrink: '0',
        whiteSpace: 'nowrap'
    };
    function cascadeRow(item) {
        const kids = Array.isArray(item.children) && item.children.length ? item.children : null;
        const hasSub = !!(kids || item.submenuBody);
        const row = {
            ...CASCADE_ROW,
            // Parent rows are <div>s (hover containers — their flyout holds buttons, and
            // button-in-button is invalid); leaf actions are <button>s.
            tag: hasSub ? 'div' : 'button',
            ...hasSub ? {
                tabindex: '0'
            } : {
                type: 'button'
            },
            'aria-label': item.ariaLabel || item.label,
            ...item.title ? {
                title: item.title
            } : {},
            // Was `'white'` for normal rows — a theme-INVARIANT literal, so every
            // cascade row rendered white-on-light in the light shell, i.e. invisible.
            // `title` is the adaptive ink token ContextDropdown already uses for the
            // same rows, and the hover tint moves onto `overlay` so it reads in BOTH
            // themes instead of only over a dark panel.
            color: 'title',
            // A `danger` item is THE house danger row, the same three parts
            // MenuPanelItem and ContextDropdownItem render: `data-danger` (a FLAT
            // `dataDanger`), `dangerInk` at rest keyed on it, and the brand error
            // fill pair under the pointer, on hover AND press. It was the raw
            // palette `red` with a `red.15` hover tint and no press state. The
            // danger row carries no plain `:hover` wash, so no rule of equal
            // specificity can win over the fill pair by stylesheet order.
            ...item.danger ? {
                dataDanger: true,
                '&[data-danger]': {
                    color: 'dangerInk'
                },
                '&[data-danger]:hover': {
                    background: 'errorFillBg',
                    color: 'errorFillInk'
                },
                '&[data-danger]:active': {
                    background: 'errorFillBg',
                    color: 'errorFillInk'
                }
            } : {
                ':hover': {
                    background: 'overlay'
                }
            },
            // THE house ring, inset (the panel clips) — same token MenuPanelItem
            // uses; was a raw px + rgba blue outline, a third ring style (F1).
            ':focus-visible': {
                shadow: 'focusRingInset'
            },
            // Left side — icon + label, ellipsised so a long label never widens the row.
            Main: {
                display: 'flex',
                flow: 'x',
                alignItems: 'center',
                gap: 'Y',
                minWidth: '0',
                ...item.icon ? {
                    Icon: {
                        extends: 'Icon',
                        icon: item.icon,
                        boxSize: 'A',
                        // Same fix as the row's own `color` above — 'white.65' was
                        // invisible in the light shell.
                        color: 'title.65',
                        flexShrink: '0'
                    }
                } : {},
                Label: {
                    tag: 'span',
                    text: item.label,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }
            }
        };
        // Leaf actions fire onClick; parents (with a submenu) only reveal the flyout.
        if (item.onClick && !hasSub) row.onClick = (e, el, s)=>{
            e.stopPropagation();
            item.onClick(e, el, s);
        };
        if (hasSub) {
            // Keep the parent hovered while the pointer crosses the visual gap to the
            // flyout. Without this transparent bridge, marginLeft creates a dead zone
            // that closes the pure-CSS submenu before the pointer can reach it.
            // Mirrored on ::before (left side) too — flipSubmenuIntoView can flip the
            // flyout to open leftward when the row is near the right viewport edge
            // (STUDIO-NEW-1), and a bridge only on the right would leave a dead zone
            // on the side the flyout actually opened on.
            row['::after'] = {
                content: '""',
                position: 'absolute',
                left: '100%',
                top: '-V',
                bottom: '-V',
                width: 'V'
            };
            row['::before'] = {
                content: '""',
                position: 'absolute',
                right: '100%',
                top: '-V',
                bottom: '-V',
                width: 'V'
            };
            row.Chevron = {
                tag: 'span',
                text: "\u25B8",
                fontSize: 'Z1',
                color: 'title.4',
                flexShrink: '0'
            };
            // Reveal THIS row's own flyout (direct child only → each level independent)
            // and measure/flip it into the viewport (STUDIO-NEW-1 — see
            // flipSubmenuIntoView above for why the CSS reveal alone isn't enough).
            row[':hover > [data-submenu]'] = {
                display: 'flex'
            };
            row[':focus-within > [data-submenu]'] = {
                display: 'flex'
            };
            row.onMouseenter = (e, el)=>flipSubmenuIntoView(el.node);
            row.onFocus = (e, el)=>flipSubmenuIntoView(el.node);
            row.Submenu = {
                ...kids ? $8a04fceae5120b26$export$943c402f19fc5858(kids) : {
                    extends: 'CanvasCreateMenuBody',
                    flow: 'y',
                    gap: '2px',
                    ...item.submenuBody
                },
                attr: {
                    'data-submenu': 'menu'
                },
                position: 'absolute',
                left: '100%',
                top: '-6px',
                marginLeft: 'V',
                display: 'none',
                zIndex: '40',
                overflow: 'visible',
                // The flyout is absolutely positioned inside its ROW, so its width is
                // computed against the row's narrow containing block: MenuPanel's
                // inherited maxWidth:100% clamped it to the row, minWidth:220px floored
                // it back up, and the CanvasCreateMenuItem hint lines ("Slide deck
                // (Symbols deck template).", …) spilled past the 220px panel edge.
                // Release the inherited clamp + size the flyout to its own widest row.
                // (2026-07-03 per Nika "context menu > New > menu has texts out of menu".)
                width: 'max-content',
                maxWidth: 'none'
            };
        } else if (item.hint) row.Hint = {
            tag: 'span',
            text: item.hint,
            fontSize: 'Z1',
            color: 'title.3',
            flexShrink: '0'
        };
        return row;
    }
    const body = {
        extends: 'CanvasCreateMenuBody',
        flow: 'y',
        gap: '2px',
        overflow: 'visible',
        // The dropdown plugin's panel is overflow:auto — that clips a flyout sitting
        // at left:100%. Clear it on mount so the cascade can escape the panel box.
        onRender: (el)=>{
            const panel = el.node && el.node.closest && el.node.closest('[data-smbls-dropdown="panel"]');
            if (panel) panel.style.overflow = 'visible';
        }
    };
    (items || []).forEach((item, i)=>{
        if (!item) return;
        if (item.divider) body['D' + i] = {
            extends: 'Line',
            role: 'separator',
            margin: 'V 0'
        };
        else body['R' + i] = cascadeRow(item);
    });
    return body;
}

});

parcelRegister("6UOpF", function(module, exports) {

$parcel$export(module.exports, "InstallProvider", () => $508f14048a88371f$export$8321f64825701dc4);
const $508f14048a88371f$export$8321f64825701dc4 = {
    P: {
        color: 'inactive',
        margin: '0 - Z2',
        children: [
            '4. Wrap your root app within ',
            {
                extends: 'Labeled',
                text: '<SymbolsProvider>'
            }
        ]
    },
    CodePreviewWithTitle: {
        margin: 'Z1 0 0',
        Title: null,
        value: `import React from 'react'
import ReactDOM from 'react-dom'
import { SymbolsProvider } from '@symbo.ls/react'

ReactDOM.render(
  <SymbolsProvider>
    // ... your app
  </SymbolsProvider>
, document.body)`
    }
};

});

parcelRegister("5mEi1", function(module, exports) {

$parcel$export(module.exports, "OrderingItem", () => $3e7e4280cd61f17e$export$58bd8f06265c2b9b);
// Row template for `add-font-family-modal.js`'s font-stack ordering list —
// moved out of the page module and registered here (2026-08-14, bare-string
// extends registration sweep) because a bare-string `childExtends:
// 'OrderingItem'` resolves ONLY against the live `context.components`
// registry (smbls's `resolveExtend`, smbls/packages/element/src/extends.js),
// never against a sibling key or a page-local declaration. Defining it
// inline in the page (as a sibling of the `Tools` node that childExtends it)
// left it permanently unresolvable — same defect class as the AdminLedgerRow
// bug (workspace eb5a41bd): every ordering row silently mounted as a bare
// unstyled div.
const $3e7e4280cd61f17e$export$58bd8f06265c2b9b = {
    Buttons: null,
    Span: {
        text: (el, s)=>`${parseInt(s.parent.value?.length + 1)}. `
    },
    Tool: {
        width: '22em',
        maxWidth: '22em',
        Value: {
            color: 'white.5',
            Text: {
                text: 'Helvetica, Arial, sans-serif, --system-default'
            }
        },
        Buttons: {
            children: [
                {
                    theme: 'transparent'
                }
            ],
            childrenAs: 'props'
        }
    }
};

});

parcelRegister("8CdFi", function(module, exports) {

$parcel$export(module.exports, "ColorSelectWithTitle", () => $645c78f33366f365$export$6b6a1752f281788d);
// Field row used by `add-global-theme-modal.js`'s color-token picker list —
// registered here (2026-08-14, bare-string extends registration sweep)
// because a bare-string `childExtends: 'ColorSelectWithTitle'` resolves
// ONLY against the live `context.components` registry (smbls's
// `resolveExtend`, smbls/packages/element/src/extends.js). This exact
// component already existed at
// workspace/packages/design-system/components/ColorSelectWithTitle.js, but
// its export is commented out of that package's barrel ("depends on
// GroupField") and design-system is never a shared library of `shared` (or
// of anything `shared` is consumed by), so it was unreachable from here
// regardless — a genuinely different registration gap than a page-local
// definition, same underlying defect class: every color-token row on the
// global-theme modal silently mounted as a bare unstyled div. `GroupField`
// is a brand component, always present alongside `shared` in every real
// host in this monorepo.
const $645c78f33366f365$export$6b6a1752f281788d = {
    extends: 'GroupField',
    minWidth: 'F2',
    Title: {
        text: '{{ editor.color.select | polyglot }}'
    },
    ColorSelect: {
        width: '100%',
        Dropdown: {
            width: '100%',
            top: '110%'
        }
    }
};

});

parcelRegister("bh6kd", function(module, exports) {

$parcel$export(module.exports, "schemeOf", () => $8356304540bc2b1d$export$bb1a58176e79e6bf);
$parcel$export(module.exports, "onAccentFor", () => $8356304540bc2b1d$export$1653321ceefcc017);
$parcel$export(module.exports, "accentOf", () => $8356304540bc2b1d$export$b95ad5f51a8b3337);
$parcel$export(module.exports, "whitelabelGround", () => $8356304540bc2b1d$export$1ecbd2a211df8f68);
$parcel$export(module.exports, "whitelabelBackdrop", () => $8356304540bc2b1d$export$516042aaeae43f7);
$parcel$export(module.exports, "accentInkOn", () => $8356304540bc2b1d$export$f91ac81f0bc5d229);
$parcel$export(module.exports, "sizedSvg", () => $8356304540bc2b1d$export$b873c9984e96a9a0);
$parcel$export(module.exports, "WhitelabelLockup", () => $8356304540bc2b1d$export$77901f23a80137c0);
$parcel$export(module.exports, "WhitelabelSignin", () => $8356304540bc2b1d$export$b307355e8783f80d);
$parcel$export(module.exports, "WhitelabelPersonaRow", () => $8356304540bc2b1d$export$1a7578b3cf709198);
$parcel$export(module.exports, "WhitelabelRoleRow", () => $8356304540bc2b1d$export$634cfe1fcedf6f10);
// WhitelabelSignin — the standalone, record-driven branded sign-in surface
// (WHITELABEL-BRANDED-BOOT-1).
//
// Nika, 2026-08-19: "make it beautiful and branded just for bellforge and
// dont chain it to workspace code - its bellforge specific", and later
// "https://app.bellforge.eu/login does not render bellforge login screen".
//
// ── Why it is rendered from the signin PAGE, not registered as a route ───
// '/signin' and '/login' are registered in THREE page maps
// (shared/pages/identity-index.js, workspace/pages/index.js,
// canvas/pages/index.js) which are merged at boot in an order that silently
// overwrote a route-level registration: measured 2026-08-19,
// shellPages['/signin'] held the branded page while the live
// context.pages['/signin'] still resolved the shared one, and gating all
// three did not win. So this is a COMPONENT the shared signin page renders
// instead of its LoginWindow when a brand is present — the page that already
// renders cannot be out-voted.
//
// ── It chains to nothing ────────────────────────────────────────────────
// It extends no component and wraps no component; it only calls the same SDK
// auth methods the shared login does. That matters: a project component
// named `LoginWindow` doing `extends: 'LoginWindow'` COLLAPSES the shared one
// (it itself extends ModalWindow) — that shipped once, dropped the entire
// Google/GitHub/email column, and had to be reverted (workspace cbbf88fa0).
//
// Everything visible comes from the org's `branding` record resolved pre-auth
// (workspace functions/whitelabelBrand.js). Nothing here knows what
// "bellforge" is — the next white-label org gets the same surface from its
// own record, with no deploy.
// ⚠️ KEY-NAME DISCIPLINE: a bare child key AUTO-EXTENDS a built-in or
// registered component of the same name. Two shipped bugs came from exactly
// this and both looked like styling faults: a child keyed `Mark` rendered an
// HTML <mark> (UA default background — measured rgb(255,255,0) behind the
// logo, "remove yellow bg on bellforge logo"), and a child keyed `Logo`
// resolved to the brand `Logo` component and rendered as an <a> with its own
// content, so the injected SVG never appeared. Every child key here is
// deliberately non-colliding (BrandGlyph, CardHead, AccentBar, HeadText,
// AccentRule, OrRow, PersonaTile, PersonaName, GoogleBtn, GoogleLabel, SubmitBtn) — do not
// "tidy" them back to generic names.
//
// ⚠️ CSS DISCIPLINE FOR THIS FILE, learned the hard way on the first draft:
//  - NO `border:` shorthand. Use `boxShadow: 'inset 0 0 0 1px …'` for a
//    hairline — the shorthand-with-raw-value path is the documented
//    outline/border shorthand token trap and it took the CSS engine down.
//  - NO shared object spread into two child slots, and no reading a custom
//    prop off `el.parent`. Each card declares its own title inline.
// ── Palette ──────────────────────────────────────────────────────────────
// Colours are literal, not tokens, because this surface paints its OWN
// ground and therefore cannot inherit the shell's adaptive inks — a
// `title`/`caption` token here resolves against the SHELL theme and can land
// dark-on-dark. So the surface carries BOTH schemes itself (Nika 2026-08-19:
// "make both versions - light by default") and picks one per render.
//
// Only the ACCENT comes from the record in both schemes; the grounds are
// per-scheme: a record's `background` is its DARK ground (bellforge navy),
// and `backgroundLight` its light one, each falling back to a neutral so an
// org that supplies neither still gets a correct, readable surface.
const $8356304540bc2b1d$var$GOLD = '#D9A93B';
// `cardShadow` = the hairline PLUS a soft lift, so the card reads as one
// object on the tinted ground (Nika 2026-10-14, "make it more beautiful").
// `rule` is the divider ink; `glow` is how much of the tenant accent tints
// the ground behind the card (whitelabelBackdrop) — stronger on dark, where
// the same mix reads fainter.
const $8356304540bc2b1d$var$SCHEMES = {
    light: {
        ground: '#F4F4F2',
        card: '#FFFFFF',
        hairline: 'inset 0 0 0 1px rgba(20, 22, 30, 0.10)',
        cardShadow: 'inset 0 0 0 1px rgba(20, 22, 30, 0.08), 0 1px 2px rgba(20, 22, 30, 0.04), 0 24px 48px -24px rgba(20, 22, 30, 0.18)',
        rule: 'rgba(20, 22, 30, 0.10)',
        glow: '16%',
        ink: 'rgba(17, 20, 28, 0.94)',
        inkSoft: 'rgba(17, 20, 28, 0.60)',
        field: 'rgba(255, 255, 255, 0.92)',
        rowHover: 'rgba(20, 22, 30, 0.05)',
        onAccent: '#1F2A44',
        danger: '#A83520'
    },
    dark: {
        ground: '#0C0C0D',
        card: 'rgba(255, 255, 255, 0.045)',
        hairline: 'inset 0 0 0 1px rgba(255, 255, 255, 0.09)',
        cardShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.09), 0 24px 48px -24px rgba(0, 0, 0, 0.6)',
        rule: 'rgba(255, 255, 255, 0.10)',
        glow: '24%',
        ink: 'rgba(255, 255, 255, 0.94)',
        inkSoft: 'rgba(255, 255, 255, 0.62)',
        field: 'rgba(255, 255, 255, 0.06)',
        rowHover: 'rgba(255, 255, 255, 0.06)',
        onAccent: '#1F2A44',
        danger: '#FF8C78'
    }
};
// The interaction washes every control on this surface shares (Rule 65 /
// Rule 67): a tint of the control's OWN ink, so one value is right on both
// schemes and on any tenant ground. Bound once, referenced everywhere.
const $8356304540bc2b1d$var$WASH_HOVER = 'linear-gradient(color-mix(in srgb, currentColor 7%, transparent), color-mix(in srgb, currentColor 7%, transparent))';
const $8356304540bc2b1d$var$WASH_ACTIVE = 'linear-gradient(color-mix(in srgb, currentColor 12%, transparent), color-mix(in srgb, currentColor 12%, transparent))';
// The focus ring is an OUTLINE, never a box-shadow: reactive props are written
// inline in this build, so a control's own reactive `boxShadow` hairline would
// beat any `:focus` box-shadow and the ring would never show.
const $8356304540bc2b1d$var$FOCUS_RING = 'color-mix(in srgb, currentColor 45%, transparent)';
// ── Control shapes ───────────────────────────────────────────────────────
// FACTORIES, not shared objects: each call returns a FRESH object, so no two
// slots ever hold the same reference (the CSS-discipline note above). One
// geometry for every control on the card — the control height, the control
// radius and one horizontal inset — so the field, the primary and the
// secondary button line up edge to edge (Nika's standing rule: symmetry).
const $8356304540bc2b1d$var$wlCaption = (key)=>({
        tag: 'label',
        fontSize: 'Z',
        fontWeight: '500',
        margin: 'Z 0 0',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
        text: '{{ ' + key + ' | polyglot }}'
    });
const $8356304540bc2b1d$var$wlField = (extra)=>({
        tag: 'input',
        width: '100%',
        minHeight: 'controlH',
        padding: '0 Z1',
        round: 'radiusControl',
        fontSize: 'Z1',
        borderWidth: '0',
        background: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).field,
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
        boxShadow: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).hairline,
        transition: 'B defaultBezier',
        transitionProperty: 'box-shadow, background-image',
        ':hover': {
            backgroundImage: $8356304540bc2b1d$var$WASH_HOVER
        },
        ':focus': {
            outlineStyle: 'solid',
            outlineWidth: 'hairline2',
            outlineOffset: 'hairline',
            outlineColor: $8356304540bc2b1d$var$FOCUS_RING
        },
        ...extra
    });
// The primary action: the tenant accent as the FILL, its ink derived for AA
// (onAccentFor). Hover/active step the fill itself (brightness), never the
// label's opacity (Rule 65).
const $8356304540bc2b1d$var$wlPrimary = (extra)=>({
        tag: 'button',
        width: '100%',
        minHeight: 'controlH',
        padding: '0 A',
        round: 'radiusControl',
        borderWidth: '0',
        cursor: 'pointer',
        fontSize: 'Z1',
        fontWeight: '700',
        color: (el, s)=>$8356304540bc2b1d$export$1653321ceefcc017(s),
        background: (el, s)=>$8356304540bc2b1d$export$b95ad5f51a8b3337(s),
        transition: 'B defaultBezier',
        transitionProperty: 'filter',
        ':hover': {
            filter: 'brightness(1.08)'
        },
        ':active': {
            filter: 'brightness(0.92)'
        },
        ':focus-visible': {
            outlineStyle: 'solid',
            outlineWidth: 'hairline2',
            outlineOffset: 'hairline2',
            outlineColor: 'CanvasText'
        },
        ...extra
    });
// The secondary action: an outlined control in the scheme's ink.
const $8356304540bc2b1d$var$wlSecondary = (extra)=>({
        tag: 'button',
        type: 'button',
        width: '100%',
        minHeight: 'controlH',
        padding: '0 A',
        display: 'flex',
        align: 'center center',
        gap: 'Z',
        round: 'radiusControl',
        borderWidth: '0',
        cursor: 'pointer',
        fontSize: 'Z1',
        fontWeight: '500',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
        background: 'transparent',
        boxShadow: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).hairline,
        transition: 'B defaultBezier',
        transitionProperty: 'background-image, box-shadow',
        ':hover': {
            backgroundImage: $8356304540bc2b1d$var$WASH_HOVER
        },
        ':active': {
            backgroundImage: $8356304540bc2b1d$var$WASH_ACTIVE
        },
        ':focus-visible': {
            outlineStyle: 'solid',
            outlineWidth: 'hairline2',
            outlineOffset: 'hairline',
            outlineColor: $8356304540bc2b1d$var$FOCUS_RING
        },
        ...extra
    });
const $8356304540bc2b1d$var$brandOf = (s)=>s && s.root && s.root.whitelabelBrand || null;
const $8356304540bc2b1d$export$bb1a58176e79e6bf = (s)=>{
    const b = $8356304540bc2b1d$var$brandOf(s);
    let stored = null;
    try {
        if (typeof localStorage !== 'undefined') stored = localStorage.getItem('themeMode');
    } catch (_) {}
    if (stored === 'light' || stored === 'dark') return $8356304540bc2b1d$var$SCHEMES[stored];
    if (stored === 'auto') {
        let prefersDark = false;
        try {
            prefersDark = !!(typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
        } catch (_) {}
        return prefersDark ? $8356304540bc2b1d$var$SCHEMES.dark : $8356304540bc2b1d$var$SCHEMES.light;
    }
    const recorded = b && b.theme;
    if (recorded === 'dark' || recorded === 'light') return $8356304540bc2b1d$var$SCHEMES[recorded];
    return $8356304540bc2b1d$var$SCHEMES.light;
};
const $8356304540bc2b1d$export$1ecbd2a211df8f68 = (s)=>{
    const b = $8356304540bc2b1d$var$brandOf(s);
    const scheme = $8356304540bc2b1d$export$bb1a58176e79e6bf(s);
    if (scheme === $8356304540bc2b1d$var$SCHEMES.dark) return b && b.background || $8356304540bc2b1d$var$SCHEMES.dark.ground;
    return b && b.backgroundLight || $8356304540bc2b1d$var$SCHEMES.light.ground;
};
const $8356304540bc2b1d$export$b95ad5f51a8b3337 = (s)=>{
    const b = $8356304540bc2b1d$var$brandOf(s);
    return b && b.accent || $8356304540bc2b1d$var$GOLD;
};
const $8356304540bc2b1d$export$516042aaeae43f7 = (s)=>{
    const glow = $8356304540bc2b1d$export$bb1a58176e79e6bf(s).glow;
    return `radial-gradient(120% 70% at 50% -10%, color-mix(in srgb, ${$8356304540bc2b1d$export$b95ad5f51a8b3337(s)} ${glow}, transparent), transparent 70%)`;
};
// ── CONTRAST, DERIVED FROM THE TENANT'S OWN HUE (A2-01 / A2-02) ────────────
// This card paints from a RECORD, before any design system exists (a
// signed-out boot on a custom domain), which is why every value in SCHEMES is
// a literal. That is fine for the grounds — they are ours. It is NOT fine for
// anything painted against `accent`, because the accent is the TENANT'S, and a
// single fixed ink cannot be legible on every hue a customer may choose.
//
// Measured on vault.pr.symbols.app, 2026-09-09:
//   "Log in"       ink #1F2A44 on the tenant accent #5065FF = 3.15:1 (needs 4.5)
//   "VAULT PARTNERS" accent #5065FF on the light ground     = 4.11:1 (needs 4.5)
// The same two literals are correct on the DEFAULT gold accent, which is what
// they were chosen against and why this shipped.
//
// So both are derived now. `_wlLum` / `_wlContrast` are the standard WCAG
// relative-luminance pair; each helper below is self-contained (this file's
// FA204 posture) and every one of them falls back to today's literal when a
// colour cannot be parsed, so an unparseable record can never blank a control.
const $8356304540bc2b1d$var$_wlRgb = (c)=>{
    const v = String(c || '').trim();
    const hex = v.charAt(0) === '#' ? v.slice(1) : null;
    if (hex && (hex.length === 3 || hex.length === 6)) {
        const f = hex.length === 3 ? hex.replace(/./g, (ch)=>ch + ch) : hex;
        const n = parseInt(f, 16);
        if (!Number.isNaN(n)) return [
            n >> 16 & 255,
            n >> 8 & 255,
            n & 255
        ];
    }
    const m = v.match(/rgba?\(\s*([0-9.]+)[,\s]+([0-9.]+)[,\s]+([0-9.]+)/i);
    if (m) return [
        Number(m[1]),
        Number(m[2]),
        Number(m[3])
    ];
    return null;
};
const $8356304540bc2b1d$var$_wlLum = (rgb)=>{
    const ch = rgb.map((v)=>{
        const x = v / 255;
        return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2];
};
const $8356304540bc2b1d$var$_wlContrast = (a, b)=>{
    const ra = $8356304540bc2b1d$var$_wlRgb(a);
    const rb = $8356304540bc2b1d$var$_wlRgb(b);
    if (!ra || !rb) return null;
    const la = $8356304540bc2b1d$var$_wlLum(ra);
    const lb = $8356304540bc2b1d$var$_wlLum(rb);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
};
const $8356304540bc2b1d$export$1653321ceefcc017 = (s)=>{
    const fixed = $8356304540bc2b1d$export$bb1a58176e79e6bf(s).onAccent;
    const accent = $8356304540bc2b1d$export$b95ad5f51a8b3337(s);
    const c = $8356304540bc2b1d$var$_wlContrast(fixed, accent);
    if (c === null || c >= 4.5) return fixed;
    // White is right on a dark accent and black on a light one; a MID hue needs
    // whichever wins, not a fixed preference — grey is the case where guessing
    // white lands at 3.9:1 and still fails.
    const white = $8356304540bc2b1d$var$_wlContrast('#FFFFFF', accent) || 0;
    const black = $8356304540bc2b1d$var$_wlContrast('#111820', accent) || 0;
    return white >= black ? '#FFFFFF' : '#111820';
};
const $8356304540bc2b1d$export$f91ac81f0bc5d229 = (s, ground)=>{
    const accent = $8356304540bc2b1d$export$b95ad5f51a8b3337(s);
    const rgb = $8356304540bc2b1d$var$_wlRgb(accent);
    if (!rgb || $8356304540bc2b1d$var$_wlRgb(ground) === null) return accent;
    if ($8356304540bc2b1d$var$_wlContrast(accent, ground) >= 4.5) return accent;
    let cur = rgb;
    for(let i = 0; i < 12; i++){
        cur = cur.map((v)=>Math.round(v * 0.92));
        const hex = '#' + cur.map((v)=>Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('');
        if ($8356304540bc2b1d$var$_wlContrast(hex, ground) >= 4.5) return hex;
    }
    return '#' + cur.map((v)=>Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('');
};
const $8356304540bc2b1d$var$hasPersonas = (s)=>{
    const b = $8356304540bc2b1d$var$brandOf(s);
    return !!(b && Array.isArray(b.personaSignins) && b.personaSignins.length);
};
const $8356304540bc2b1d$export$b873c9984e96a9a0 = (markup, px)=>{
    if (typeof markup !== 'string' || !markup) return '';
    if (!/^\s*<svg\b/i.test(markup)) return markup;
    const vb = markup.match(/viewBox\s*=\s*["']\s*([\d.+-]+)[ ,]+([\d.+-]+)[ ,]+([\d.+-]+)[ ,]+([\d.+-]+)/i);
    let w = px;
    if (vb) {
        const ratio = parseFloat(vb[3]) / Math.max(1e-6, parseFloat(vb[4]));
        if (isFinite(ratio) && ratio > 0) w = Math.round(Math.min(ratio, 5.4) * px);
    }
    return markup.replace(/\s(width|height)\s*=\s*(".*?"|'.*?')/gi, '').replace(/^\s*<svg\b/i, `<svg width="${w}" height="${px}" preserveAspectRatio="xMidYMid meet"`);
};
// Kick the org's public onboarding config exactly once, then park it on
// state. The role list is NEVER hardcoded: it is an allowlist published by
// the org itself, so "every type except admin" is the SERVER's decision (the
// four published roles carry no admin) and a copy change needs no redeploy.
// Guarded through state rather than a module flag so a remount re-reads.
const $8356304540bc2b1d$var$kickOnboarding = (el, s)=>{
    const b = $8356304540bc2b1d$var$brandOf(s);
    if (!b || !b.workspaceKey || s.onboardingKicked) return;
    s.update({
        onboardingKicked: true
    }, {
        preventUpdate: true
    });
    Promise.resolve(el.call('fetchWhitelabelOnboarding', {
        workspaceKey: b.workspaceKey
    })).then((cfg)=>{
        // null = unconfigured, disabled, or unreachable — all indistinguishable
        // to a visitor, so the whole signup affordance simply stays hidden.
        if (cfg && cfg.roles && cfg.roles.length) s.update({
            onboardingRoles: cfg.roles,
            onboardingCaptcha: cfg.captcha || null
        });
    }).catch(()=>{});
};
// The signup affordance appears only once the org has published a usable
// role list — an org with no public onboarding shows a pure login screen.
const $8356304540bc2b1d$var$canSignUp = (s)=>!!(s && s.onboardingRoles && s.onboardingRoles.length);
// Which mode the card is in. Signup can never be the mode while the org has
// published nothing, so a late-arriving null config cannot strand a visitor
// on a form they are unable to submit.
const $8356304540bc2b1d$var$isSignup = (s)=>s && s.mode === 'signup' && $8356304540bc2b1d$var$canSignUp(s);
const $8356304540bc2b1d$var$PERSONA_TINTS = [
    $8356304540bc2b1d$var$GOLD,
    '#1D9E75',
    '#2F5FA5',
    '#6B4EA0'
];
const $8356304540bc2b1d$var$personaTint = (key)=>{
    const k = typeof key === 'string' ? key : '';
    let h = 0;
    for(let i = 0; i < k.length; i++)h = h * 31 + k.charCodeAt(i) >>> 0;
    return $8356304540bc2b1d$var$PERSONA_TINTS[h % $8356304540bc2b1d$var$PERSONA_TINTS.length];
};
const $8356304540bc2b1d$export$77901f23a80137c0 = {
    display: 'flex',
    flow: 'y',
    align: 'center center',
    gap: 'Y',
    margin: '0 0 B',
    // ⚠️ Named `Logo`, NOT `Mark`, and with an explicit tag: a child keyed
    // `Mark` renders an HTML <mark> element, which every browser paints with
    // a default YELLOW background — measured `rgb(255,255,0)` behind the
    // logo on app.bellforge.eu (Nika: "remove yellow bg on bellforge logo").
    // That colour was never in the design system; it was UA styling arriving
    // through the key name.
    BrandGlyph: {
        tag: 'div',
        display: 'flex',
        align: 'center center',
        margin: '0 0 Y',
        color: (el, s)=>$8356304540bc2b1d$export$b95ad5f51a8b3337(s),
        html: (el, s)=>{
            const b = $8356304540bc2b1d$var$brandOf(s);
            return $8356304540bc2b1d$export$b873c9984e96a9a0(b && b.logoSvg, 48);
        },
        aria: {
            hidden: 'true'
        }
    },
    Wordmark: {
        tag: 'h1',
        fontSize: 'C',
        fontWeight: '700',
        letterSpacing: '-0.01em',
        lineHeight: '1.1',
        textAlign: 'center',
        margin: '0',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
        text: (el, s)=>{
            const b = $8356304540bc2b1d$var$brandOf(s);
            return b && b.name || el.call('polyglot', 'auth.whitelabel.wordmarkFallback');
        }
    },
    Tagline: {
        tag: 'div',
        fontSize: 'Z',
        fontWeight: '500',
        letterSpacing: '0.08em',
        lineHeight: '1.4',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).inkSoft,
        textAlign: 'center',
        display: (el, s)=>{
            const b = $8356304540bc2b1d$var$brandOf(s);
            return b && b.tagline ? 'block' : 'none';
        },
        text: (el, s)=>{
            const b = $8356304540bc2b1d$var$brandOf(s);
            return b && b.tagline || '';
        }
    }
};
const $8356304540bc2b1d$export$b307355e8783f80d = {
    tag: 'section',
    position: 'fixed',
    inset: '0',
    width: 'auto',
    minHeight: '0',
    overflowY: 'auto',
    display: 'flex',
    flow: 'y',
    align: 'center center',
    padding: 'C A',
    // ⚠️ THE WHOLE SURFACE is the fixed full-viewport layer — there is no
    // separate ground element.
    // Measured on app.bellforge.eu: the shell's routed `content` wrapper
    // carries a responsive `padding-left/right` (44.5px at a 2560px viewport),
    // so a background on an in-flow element starts at x=45 and leaves dark
    // bands — Nika: "black edges". Making THIS element `position: fixed;
    // inset: 0` is immune to every ancestor's padding, needs no `100vw` (which
    // adds scrollbar-width overflow) and no negative margins tuned to a token.
    //
    // ⚠️ DO NOT go back to a separate fixed `Ground` CHILD. That is what the
    // previous build did and it PAINTED OVER the whole screen: a positioned
    // child paints above its static in-flow siblings, and this runtime is
    // known to drop `zIndex` (project_module_runtime_drops_transform_zindex),
    // so the intended z-order never applied. It reported as "login screen
    // looks empty" / "bare navy with only the accent rule". It also defeated
    // the obvious check — the ground carried `pointerEvents: 'none'`, so
    // `elementFromPoint` returned the text UNDERNEATH and the overlay looked
    // innocent while still covering it.
    color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
    background: (el, s)=>$8356304540bc2b1d$export$1ecbd2a211df8f68(s),
    backgroundImage: (el, s)=>$8356304540bc2b1d$export$516042aaeae43f7(s),
    backgroundRepeat: 'no-repeat',
    state: {
        loading: false,
        // Which auth entry is in flight: '' | 'form' | 'google' | a persona key.
        // ONE slot on purpose — the card has four ways in (form, Google, N demo
        // personas) and they must be mutually exclusive: two concurrent sign-ins
        // race each other's tokens. Every entry checks it before starting, and a
        // successful persona/Google sign-in deliberately never clears it — the
        // busy label holds until the full-page reload lands, so there is no
        // "clicked, nothing happening" gap (Nika: "add loading state on
        // signin/demo signins").
        authBusy: '',
        identifier: '',
        password: '',
        error: '',
        // Signup ("request an invitation") — a second MODE of this one card
        // rather than a second surface, so the brand lockup, scheme and ground
        // are shared and cannot drift apart.
        mode: 'signin',
        onboardingKicked: false,
        onboardingRoles: null,
        onboardingCaptcha: null,
        // Written by WhitelabelTurnstile, read by SuSubmit. Empty until the
        // widget issues a token, and empty again after every attempt — a
        // Turnstile token is single-use.
        captchaToken: '',
        captchaWidgetId: null,
        suName: '',
        suEmail: '',
        suRole: '',
        suBusy: false,
        suStatus: '',
        suOk: false
    },
    // The brand lives on ROOT state and can arrive AFTER first paint (the
    // late-apply path in whitelabelBrand.js). Without declaring the key this
    // element never re-renders on that write. Declared lists are the binding
    // contract in this build.
    subscribeTo: [
        'whitelabelBrand'
    ],
    // The tab title is the sign-in PAGE's metadata (pages/auth/signin.js: the
    // org name on a branded host), which helmet re-runs when the brand lands —
    // this surface writes no document.title.
    onRender: (el, s)=>{
        $8356304540bc2b1d$var$kickOnboarding(el, s);
    },
    // The brand (and with it the workspace key) can land after first paint.
    onUpdate: (el, s)=>{
        $8356304540bc2b1d$var$kickOnboarding(el, s);
    },
    Lockup: $8356304540bc2b1d$export$77901f23a80137c0,
    // ONE card, one measure (Nika 2026-10-14): with no demo personas the board
    // is the login card alone, at the overlay-small measure every auth card on
    // a branded host shares — it used to stretch to the two-card width (~870px
    // of form). Personas on: the two-card measure.
    Board: {
        display: 'flex',
        align: 'stretch center',
        gap: 'A',
        width: '100%',
        maxWidth: (el, s)=>$8356304540bc2b1d$var$hasPersonas(s) ? 'overlayXl' : 'overlaySm',
        '@media (max-width: 780px)': {
            flow: 'column',
            maxWidth: 'overlaySm'
        },
        // LEFT — demo personas. Absent unless the org enabled them: the server
        // omits `personaSignins` unless the flag is on AND the channel is
        // non-production.
        Demo: {
            flex: '1 1 0',
            minWidth: '0',
            padding: 'B1',
            '@mobileL': {
                padding: 'B'
            },
            round: 'radiusCard',
            background: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).card,
            boxShadow: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).cardShadow,
            display: (el, s)=>$8356304540bc2b1d$var$hasPersonas(s) ? 'block' : 'none',
            CardHead: {
                display: 'flex',
                align: 'center left',
                gap: 'Y',
                margin: '0 0 X',
                AccentBar: {
                    width: '3px',
                    height: '15px',
                    round: 'radiusPill',
                    flex: 'none',
                    background: (el, s)=>$8356304540bc2b1d$export$b95ad5f51a8b3337(s)
                },
                HeadText: {
                    tag: 'div',
                    fontSize: 'Z1',
                    fontWeight: '700',
                    color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
                    text: '{{ auth.whitelabel.demo.title | polyglot }}'
                }
            },
            Sub: {
                tag: 'div',
                fontSize: 'Z',
                color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).inkSoft,
                margin: '0 0 A',
                text: '{{ auth.whitelabel.demo.hint | polyglot }}'
            },
            Rows: {
                display: 'flex',
                flow: 'y',
                gap: 'V',
                childExtends: 'WhitelabelPersonaRow',
                childrenAs: 'state',
                children: (el, s)=>{
                    const b = $8356304540bc2b1d$var$brandOf(s);
                    return (b && b.personaSignins || []).filter((r)=>r && r.key && r.label).map((r)=>({
                            key: r.key,
                            label: r.label
                        }));
                }
            }
        },
        // RIGHT — real sign-in: email/password + Google. Symmetric inset on all
        // four sides; the heading block is centred under the centred lockup.
        Login: {
            flex: '1 1 0',
            minWidth: '0',
            padding: 'B1',
            '@mobileL': {
                padding: 'B'
            },
            round: 'radiusCard',
            background: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).card,
            boxShadow: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).cardShadow,
            CardHead: {
                display: 'flex',
                align: 'center center',
                margin: '0 0 X',
                HeadText: {
                    tag: 'div',
                    fontSize: 'B',
                    fontWeight: '700',
                    lineHeight: '1.2',
                    textAlign: 'center',
                    color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
                    // The org's own name, never a literal — this surface serves every
                    // white-label host, not just one.
                    text: (el, s)=>{
                        if (!$8356304540bc2b1d$var$isSignup(s)) return el.call('polyglot', 'auth.whitelabel.head.login');
                        const b = $8356304540bc2b1d$var$brandOf(s);
                        // The branded form interpolates the org name into ONE key rather
                        // than concatenating two fragments — a translation orders the
                        // words its own way.
                        return b && b.name ? el.call('polyglot', 'auth.whitelabel.head.signupBranded').replace('{brand}', b.name) : el.call('polyglot', 'auth.whitelabel.head.signup');
                    }
                }
            },
            Sub: {
                tag: 'div',
                fontSize: 'Z1',
                lineHeight: '1.5',
                textAlign: 'center',
                color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).inkSoft,
                margin: '0 0 A',
                text: (el, s)=>el.call('polyglot', $8356304540bc2b1d$var$isSignup(s) ? 'auth.whitelabel.sub.signup' : 'auth.whitelabel.sub.login')
            },
            Form: {
                tag: 'form',
                display: (el, s)=>$8356304540bc2b1d$var$isSignup(s) ? 'none' : 'flex',
                flow: 'y',
                gap: 'Y',
                onSubmit: async (e, el, s)=>{
                    e.preventDefault();
                    if (s.loading || s.authBusy) return;
                    const identifier = String(s.identifier || '').trim();
                    const password = String(s.password || '');
                    if (!identifier || !password) {
                        s.update({
                            error: el.call('polyglot', 'auth.whitelabel.needCredentials')
                        });
                        return;
                    }
                    s.update({
                        loading: true,
                        authBusy: 'form',
                        error: ''
                    });
                    try {
                        const loginResult = await el.sdk.login(identifier, password);
                        // A sign-in on this origin: its refresh token is its own (review D1).
                        el.call('markOwnSession');
                        await el.call('initializeUserSession', {
                            loginData: loginResult
                        });
                        if (typeof window !== 'undefined') window.location.assign('/');
                    } catch (err) {
                        s.update({
                            loading: false,
                            authBusy: '',
                            error: err && err.message || el.call('polyglot', 'auth.whitelabel.signinFailed')
                        });
                    }
                },
                EmailCaption: $8356304540bc2b1d$var$wlCaption('auth.whitelabel.email'),
                Email: $8356304540bc2b1d$var$wlField({
                    type: 'text',
                    autocomplete: 'username',
                    placeholder: 'you@example.com',
                    onInput: (e, el, s)=>s.update({
                            identifier: e.target.value
                        }, {
                            preventUpdate: true
                        })
                }),
                PasswordCaption: $8356304540bc2b1d$var$wlCaption('auth.whitelabel.password'),
                Password: $8356304540bc2b1d$var$wlField({
                    type: 'password',
                    autocomplete: 'current-password',
                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                    onInput: (e, el, s)=>s.update({
                            password: e.target.value
                        }, {
                            preventUpdate: true
                        })
                }),
                Err: {
                    tag: 'div',
                    fontSize: 'Y',
                    color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).danger,
                    display: (el, s)=>s.error ? 'block' : 'none',
                    text: (el, s)=>s.error || ''
                },
                SubmitBtn: $8356304540bc2b1d$var$wlPrimary({
                    type: 'submit',
                    margin: 'Z 0 0',
                    opacity: (el, s)=>s.loading ? '0.6' : '1',
                    text: (el, s)=>el.call('polyglot', s.loading ? 'auth.whitelabel.signingIn' : 'auth.whitelabel.submit')
                })
            },
            OrRow: {
                // Hidden in signup: that flow mints an INVITATION, so an OAuth button
                // beside it would promise an account it cannot create.
                display: (el, s)=>$8356304540bc2b1d$var$isSignup(s) ? 'none' : 'flex',
                align: 'center center',
                gap: 'Z',
                margin: 'A 0',
                L1: {
                    flex: '1',
                    height: 'hairline',
                    background: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).rule
                },
                W: {
                    tag: 'span',
                    fontSize: 'Z',
                    color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).inkSoft,
                    text: '{{ auth.whitelabel.or | polyglot }}'
                },
                L2: {
                    flex: '1',
                    height: 'hairline',
                    background: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).rule
                }
            },
            // Google — the SAME SDK path the shared login uses (initCodeClient
            // popup → sdk.googleAuthCallback), not a reimplementation of the auth.
            // Hidden when the environment carries no client id, so it can never
            // render a dead button.
            // An outlined control with the provider's own glyph from the design
            // system's icon set (`googleLogoNormal`, the same glyph the platform
            // login shows) — never inline SVG (Rule 62).
            GoogleBtn: $8356304540bc2b1d$var$wlSecondary({
                Icon: {
                    icon: 'googleLogoNormal',
                    boxSize: 'iconMd',
                    flex: 'none'
                },
                GoogleLabel: {
                    tag: 'span',
                    text: (el, s)=>el.call('polyglot', s.authBusy === 'google' ? 'auth.whitelabel.signingIn' : 'auth.whitelabel.google')
                },
                opacity: (el, s)=>s.authBusy && s.authBusy !== 'google' ? '0.5' : '1',
                display: (el, s)=>{
                    if ($8356304540bc2b1d$var$isSignup(s)) return 'none';
                    const env = el.sdk && el.sdk.environment;
                    return env && env.googleClientId ? 'flex' : 'none';
                },
                onClick: async (e, el, s)=>{
                    if (s.authBusy) return;
                    const env = el.sdk && el.sdk.environment;
                    const clientId = env && env.googleClientId;
                    const g = typeof window !== 'undefined' ? window.google : null;
                    if (!clientId || !g || !g.accounts || !g.accounts.oauth2) {
                        s.update({
                            error: el.call('polyglot', 'auth.whitelabel.googleUnavailable')
                        });
                        return;
                    }
                    try {
                        const client = g.accounts.oauth2.initCodeClient({
                            client_id: clientId,
                            scope: 'openid email profile',
                            ux_mode: 'popup',
                            callback: async (resp)=>{
                                if (!resp || !resp.code) return;
                                // Busy from the exchange onward only: a popup the visitor
                                // dismisses never reaches this callback, so claiming the slot
                                // any earlier would strand the whole card busy forever.
                                s.update({
                                    authBusy: 'google'
                                });
                                try {
                                    const loginResult = await el.sdk.googleAuthCallback(resp.code, 'postmessage');
                                    // A sign-in on this origin: its refresh token is its own (review D1).
                                    el.call('markOwnSession');
                                    await el.call('initializeUserSession', {
                                        loginData: loginResult
                                    });
                                    if (typeof window !== 'undefined') window.location.assign('/');
                                } catch (err) {
                                    s.update({
                                        authBusy: '',
                                        error: err && err.message || el.call('polyglot', 'auth.whitelabel.googleFailed')
                                    });
                                }
                            }
                        });
                        client.requestCode();
                    } catch (err) {
                        s.update({
                            error: el.call('polyglot', 'auth.whitelabel.googleUnavailable')
                        });
                    }
                }
            }),
            // ── SIGNUP: request an invitation ──────────────────────────────────
            // Deliberately NOT a password form. The programme's own landing states
            // it outright ("An invitation, not a password form"): this mints a
            // workspace invitation, and accepting that invitation is what creates
            // the account. Building credentials here would be a second
            // account-creation path for the same org.
            SignupPane: {
                display: (el, s)=>$8356304540bc2b1d$var$isSignup(s) ? 'flex' : 'none',
                flow: 'y',
                gap: 'Y',
                RoleCaption: $8356304540bc2b1d$var$wlCaption('auth.whitelabel.request.role'),
                RoleList: {
                    display: 'flex',
                    flow: 'y',
                    gap: 'V',
                    margin: '0 0 X',
                    childExtends: 'WhitelabelRoleRow',
                    childrenAs: 'state',
                    children: (el, s)=>s.onboardingRoles || []
                },
                NameCaption: $8356304540bc2b1d$var$wlCaption('auth.whitelabel.request.name'),
                SuName: $8356304540bc2b1d$var$wlField({
                    type: 'text',
                    autocomplete: 'name',
                    placeholder: (el)=>el.call('polyglot', 'auth.whitelabel.request.namePlaceholder'),
                    onInput: (e, el, s)=>s.update({
                            suName: e.target.value
                        }, {
                            preventUpdate: true
                        })
                }),
                EmailCaption: $8356304540bc2b1d$var$wlCaption('auth.whitelabel.request.email'),
                SuEmail: $8356304540bc2b1d$var$wlField({
                    type: 'email',
                    autocomplete: 'email',
                    placeholder: 'jane@firm.com',
                    onInput: (e, el, s)=>s.update({
                            suEmail: e.target.value
                        }, {
                            preventUpdate: true
                        })
                }),
                // One reserved line for both outcomes, so a result never shifts the
                // card (zero-shift: the space is held whether or not it is filled).
                SuStatus: {
                    tag: 'div',
                    fontSize: 'Y',
                    minHeight: 'X',
                    color: (el, s)=>s.suOk ? $8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink : $8356304540bc2b1d$export$bb1a58176e79e6bf(s).danger,
                    text: (el, s)=>s.suStatus || ''
                },
                // Below the status line on purpose: the server's `captcha_failed`
                // message says "complete the verification below", so the widget has
                // to BE below it. Renders nothing when the org configured no
                // captcha — `onboardingCaptcha` is null and the slot stays out.
                WhitelabelTurnstile: {},
                SuSubmit: $8356304540bc2b1d$var$wlPrimary({
                    type: 'button',
                    margin: 'Y 0 0',
                    opacity: (el, s)=>s.suBusy ? '0.6' : '1',
                    text: (el, s)=>el.call('polyglot', s.suBusy ? 'auth.whitelabel.request.sending' : 'auth.whitelabel.request.submit'),
                    onClick: async (e, el, s)=>{
                        if (s.suBusy) return;
                        const b = $8356304540bc2b1d$var$brandOf(s);
                        s.update({
                            suBusy: true,
                            suStatus: '',
                            suOk: false
                        });
                        const res = await el.call('submitWhitelabelOnboarding', {
                            workspaceKey: b && b.workspaceKey,
                            name: s.suName,
                            email: s.suEmail,
                            role: s.suRole,
                            // Absent when the org configured no captcha — the server then
                            // never asks for one. Present and stale is the failure the
                            // reset below prevents.
                            captchaToken: s.captchaToken
                        });
                        // Every attempt spends the token, pass or fail. Reset before the
                        // visitor can press again, or the second press replays a dead
                        // token and reads as `captcha_failed`.
                        el.call('resetWhitelabelTurnstile', {
                            state: s
                        });
                        s.update({
                            suBusy: false,
                            suOk: !!(res && res.ok),
                            suStatus: res && res.message || ''
                        });
                    }
                }),
                FinePrint: {
                    tag: 'div',
                    margin: 'V 0 0',
                    fontSize: 'Y',
                    color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).inkSoft,
                    text: '{{ auth.whitelabel.request.note | polyglot }}'
                }
            },
            // Only rendered once the org has actually published a role list, so a
            // login-only org never shows a door that leads nowhere.
            ModeSwitch: {
                tag: 'button',
                type: 'button',
                display: (el, s)=>$8356304540bc2b1d$var$canSignUp(s) ? 'block' : 'none',
                width: '100%',
                margin: 'A 0 0',
                padding: 'Y 0',
                background: 'transparent',
                borderWidth: '0',
                cursor: 'pointer',
                fontSize: 'Z',
                fontWeight: '500',
                // The brand hue as INK, darkened only as far as AA needs on this
                // ground (A2-02) — a link-weight control, so it reads as the accent.
                color: (el, s)=>$8356304540bc2b1d$export$f91ac81f0bc5d229(s, $8356304540bc2b1d$export$1ecbd2a211df8f68(s)),
                textDecoration: 'none',
                ':hover': {
                    textDecoration: 'underline'
                },
                ':active': {
                    textDecoration: 'underline',
                    filter: 'brightness(0.85)'
                },
                ':focus-visible': {
                    outlineStyle: 'solid',
                    outlineWidth: 'hairline2',
                    outlineOffset: 'hairline2',
                    outlineColor: 'currentColor'
                },
                text: (el, s)=>el.call('polyglot', $8356304540bc2b1d$var$isSignup(s) ? 'auth.whitelabel.switchToLogin' : 'auth.whitelabel.switchToSignup'),
                onClick: (e, el, s)=>s.update({
                        mode: $8356304540bc2b1d$var$isSignup(s) ? 'signin' : 'signup',
                        error: '',
                        suStatus: '',
                        suOk: false
                    })
            }
        }
    },
    Foot: {
        tag: 'div',
        margin: 'A 0 0',
        fontSize: 'Y',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).inkSoft,
        textAlign: 'center',
        display: (el, s)=>$8356304540bc2b1d$var$hasPersonas(s) ? 'block' : 'none',
        text: '{{ auth.whitelabel.demo.note | polyglot }}'
    }
};
const $8356304540bc2b1d$export$1a7578b3cf709198 = {
    tag: 'button',
    type: 'button',
    width: '100%',
    display: 'flex',
    align: 'center left',
    gap: 'Z',
    padding: 'Y Z',
    round: 'radiusControl',
    cursor: (el, s)=>s.parent && s.parent.authBusy ? 'default' : 'pointer',
    borderWidth: '0',
    background: 'transparent',
    textAlign: 'left',
    ':hover': {
        background: 'rgba(127,127,127,0.16)'
    },
    // The whole row dims while ANOTHER entry is signing in; itself it swaps to
    // an explicit "Signing in…" (below) so the click always answers visibly.
    opacity: (el, s)=>s.parent && s.parent.authBusy && s.parent.authBusy !== s.key ? '0.5' : '1',
    aria: {
        label: (el, s)=>el.call('polyglot', 'auth.whitelabel.persona.aria').replace('{name}', s.label || ''),
        busy: (el, s)=>s.parent && s.parent.authBusy === s.key ? 'true' : 'false'
    },
    PersonaTile: {
        display: 'flex',
        align: 'center center',
        flex: 'none',
        boxSize: 'B',
        round: 'radiusControl',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'white',
        background: (el, s)=>$8356304540bc2b1d$var$personaTint(s.key),
        // While THIS persona signs in, the initial gives way to the same flip the
        // branded loader mark uses — one motion vocabulary for "bellforge is
        // working", and no new spinner primitive.
        animation: (el, s)=>s.parent && s.parent.authBusy === s.key ? 'flipY' : 'none',
        animationDuration: '1.2s',
        animationIterationCount: 'infinite',
        text: (el, s)=>String(s.label || s.key || '?').trim().charAt(0).toUpperCase()
    },
    PersonaName: {
        tag: 'span',
        flex: '1',
        minWidth: '0',
        fontSize: 'Z1',
        fontWeight: '500',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
        text: (el, s)=>s.parent && s.parent.authBusy === s.key ? el.call('polyglot', 'auth.whitelabel.signingIn') : el.call('polyglot', s.label || '')
    },
    onClick: async (e, el, s)=>{
        // The PARENT slot, not an element flag: `el.__busy` only stopped a
        // double-click on the SAME row — a second persona (or the form, or
        // Google) could still start a concurrent sign-in and race tokens. One
        // shared slot makes the four entry points mutually exclusive AND gives
        // the row its visible busy state, which an element property never could.
        if (s.parent && (s.parent.authBusy || s.parent.loading)) return;
        if (s.parent && s.parent.update) s.parent.update({
            authBusy: s.key,
            error: ''
        });
        const res = await el.call('whitelabelPersonaSignin', s.key);
        if (res && res.ok === false) // Failure releases the slot; success holds it — the label stays
        // "Signing in…" until the full-page reload lands, so there is no
        // clicked-but-nothing-happening gap.
        {
            if (s.parent && s.parent.update) s.parent.update({
                authBusy: '',
                error: res.message || ''
            });
        }
    }
};
const $8356304540bc2b1d$export$634cfe1fcedf6f10 = {
    tag: 'button',
    type: 'button',
    width: '100%',
    display: 'flex',
    flow: 'y',
    gap: 'V',
    padding: 'Y Z',
    round: 'radiusControl',
    cursor: 'pointer',
    borderWidth: '0',
    textAlign: 'left',
    background: (el, s)=>s.parent && s.parent.suRole === s.key ? 'rgba(127,127,127,0.16)' : 'transparent',
    boxShadow: (el, s)=>s.parent && s.parent.suRole === s.key ? $8356304540bc2b1d$export$bb1a58176e79e6bf(s).hairline : 'none',
    ':hover': {
        background: 'rgba(127,127,127,0.16)'
    },
    // The pressed state is what a screen reader has to read here — a colour
    // change alone would announce nothing.
    aria: {
        pressed: (el, s)=>s.parent && s.parent.suRole === s.key ? 'true' : 'false',
        label: (el, s)=>el.call('polyglot', 'auth.whitelabel.role.aria').replace('{name}', s.label || '')
    },
    RoleName: {
        tag: 'span',
        fontSize: 'Z1',
        fontWeight: '500',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).ink,
        text: (el, s)=>s.label
    },
    RoleDesc: {
        tag: 'span',
        fontSize: 'Y',
        color: (el, s)=>$8356304540bc2b1d$export$bb1a58176e79e6bf(s).inkSoft,
        display: (el, s)=>s.description ? 'block' : 'none',
        text: (el, s)=>s.description || ''
    },
    onClick: (e, el, s)=>{
        if (s.parent && s.parent.update) s.parent.update({
            suRole: s.key,
            suStatus: '',
            suOk: false
        });
    }
};

});

parcelRegister("dVCfH", function(module, exports) {

$parcel$export(module.exports, "WhitelabelAccent", () => $a23e4559dccfc579$export$2389dca21d82438a);
// WhitelabelAccent — a MIXIN for a design-system primary button on the auth
// cards (signup / reset-password forms, accept-invite). On a white-label host
// it wears the tenant accent exactly like the branded sign-in's own button
// (WhitelabelSignin.js), so login, signup, reset and accept-invite read as
// one family (Nika 2026-10-14: "update login screen make it more beautiful
// for astio login").
//
//   CheckButton: { extends: ['WhitelabelAccent', 'CheckButton'], … }
//
// Off a branded host it is inert: `color` / `background` answer undefined and
// the `.isBranded` block never applies — the button keeps its `primary` theme
// pixel for pixel.
//
// The accent is a RECORD value with no design-system token to name, so it
// arrives through a reactive prop (applied inline, see below). Hover / active
// step the fill itself (brightness), never the label's opacity (Rule 65).
//
// Self-contained (FA204): no module-scope helper and no import; the colour
// maths is reached through the function registry
// (functions/whitelabelAuthPaint.js).
const $a23e4559dccfc579$export$2389dca21d82438a = {
    subscribeTo: [
        'whitelabelBrand'
    ],
    isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
    // Reactive props apply INLINE in this build (measured on the dev shell,
    // 2026-10-14), which is what lets the accent beat the theme's
    // `[data-theme]` rules and its hover fill. `undefined` off a branded host:
    // nothing is written and the `primary` theme paints as before.
    color: (el, s)=>{
        const paint = el.call('whitelabelAuthPaint', s);
        return paint ? paint.ink : undefined;
    },
    background: (el, s)=>{
        const paint = el.call('whitelabelAuthPaint', s);
        return paint ? paint.fill : undefined;
    },
    '.isBranded': {
        width: '100%',
        round: 'radiusControl',
        ':hover': {
            filter: 'brightness(1.08)'
        },
        ':active': {
            filter: 'brightness(0.92)'
        }
    }
};

});

parcelRegister("9anS6", function(module, exports) {

$parcel$export(module.exports, "WhitelabelAuthWindow", () => $6ac790a6908476aa$export$c2f0d0af703c7c3e);
// WhitelabelAuthWindow — a MIXIN that gives the shared LoginWindow its
// white-label shape on the pages that place it (signup, reset-password):
//
//   LoginWindow: { extends: ['WhitelabelAuthWindow', 'LoginWindow'], … }
//
// On a branded host (root.whitelabelBrand set) the window becomes ONE centred
// column at the branded sign-in's card measure and inset, the heading block
// centres, and the OAuth group trades the platform's "another way to sign in"
// heading for a plain "or" rule with full-width provider buttons — the same
// family as the branded sign-in (WhitelabelSignin.js; Nika 2026-10-14).
//
// Why a mixin and not edits to LoginWindow.js: the shared Symbols login
// component carries no branding logic (locked by workspace
// __tests__/whitelabelBrand.test.js, "SYMBOLS IS UNTOUCHED"). Every value
// here sits in an `.isBranded` block (Rule 19) or a brand-gated `hide`, so on
// the platform the window renders exactly as LoginWindow declares it.
//
// Child keys are deliberately non-colliding (OrDivider, OrRule_1/2, OrWord).
const $6ac790a6908476aa$export$c2f0d0af703c7c3e = {
    subscribeTo: [
        'whitelabelBrand'
    ],
    isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
    '.isBranded': {
        width: '100%',
        maxWidth: 'overlaySm',
        minHeight: 'auto',
        padding: 'B1',
        gap: 'A',
        align: 'stretch flex-start'
    },
    ModalHeader: {
        Hgroup: {
            isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
            '.isBranded': {
                textAlign: 'center',
                align: 'center center',
                width: '100%'
            },
            H: {
                isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
                '.isBranded': {
                    fontSize: 'B1'
                }
            }
        }
    },
    Flex: {
        isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
        '.isBranded': {
            flow: 'column',
            gap: 'A',
            padding: 'Y 0 0'
        },
        RequestAccessButtons: {
            isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
            '.isBranded': {
                gap: 'Z'
            },
            OrDivider: {
                hide: (el, s)=>!s.root.whitelabelBrand,
                // First in the group: a mixin's new child lands AFTER the base's.
                order: '-1',
                display: 'flex',
                align: 'center center',
                gap: 'Z',
                width: '100%',
                OrRule_1: {
                    flex: '1',
                    height: 'hairline',
                    background: 'line'
                },
                OrWord: {
                    tag: 'span',
                    fontSize: 'Z',
                    color: 'caption',
                    text: '{{ auth.whitelabel.or | polyglot }}'
                },
                OrRule_2: {
                    flex: '1',
                    height: 'hairline',
                    background: 'line'
                }
            },
            Hgroup: {
                hide: (el, s)=>!!s.root.whitelabelBrand
            },
            Flex: {
                isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
                '.isBranded': {
                    flow: 'y',
                    gap: 'Z',
                    width: '100%'
                },
                GoogleSignInButton: {
                    isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
                    '.isBranded': {
                        margin: '0',
                        width: '100%',
                        align: 'center center',
                        round: 'radiusControl'
                    }
                },
                GithubSignInButton: {
                    isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
                    '.isBranded': {
                        margin: '0',
                        width: '100%',
                        align: 'center center',
                        round: 'radiusControl'
                    }
                }
            }
        }
    }
};

});

parcelRegister("kzmyu", function(module, exports) {

$parcel$export(module.exports, "WhitelabelTurnstile", () => $ef989288ff8587ce$export$8ecbd580d5c6be57);
// WhitelabelTurnstile — the captcha slot both white-label onboarding panes
// mount (WS-SHELL-PANES-RENDER-TURNSTILE-WIDGET-1).
//
// It is a SLOT, not a widget: Cloudflare renders its own iframe into this
// node. Everything imperative lives in `functions/whitelabelTurnstile.js`
// and is reached through `el.call`, so this file stays declarative.
//
// ── State contract (the pane owns the state; this element declares none) ──
//   reads  `onboardingCaptcha` — `{ provider, siteKey }` from
//          `GET /core/onboarding/options`, parked by the pane's own kick.
//          Absent ⇒ this element renders nothing at all.
//   writes `captchaToken`    — the single-use token the submit sends
//   writes `captchaWidgetId` — the id the submit resets after every attempt
//
// Declaring no `state:` is deliberate: the element must share the pane's
// state so the submit button (a sibling, not a child) reads the same token.
//
// ⚠️ Hostname allowlist: a Turnstile widget only issues a token on the
// hostnames configured on the widget itself. The shared key covers
// `localhost`, `symbo.ls` and `symbols.app` (subdomains included, so
// `*.pr.symbols.app` is covered). A customer's own domain must be added to
// the widget before the pane can get a token there.
const $ef989288ff8587ce$var$_siteKey = (s)=>{
    const c = s && s.onboardingCaptcha;
    return c && c.siteKey ? String(c.siteKey).trim() : '';
};
const $ef989288ff8587ce$export$8ecbd580d5c6be57 = {
    tag: 'div',
    margin: 'V 0 0',
    // Both channels, like every other conditional row in these panes. `hide:`
    // is CSS-only in this runtime (a hidden node still exists and still runs
    // its lifecycle — the mount function gates on the site key itself, never
    // on visibility); `display` keeps a re-shown one from painting as a block
    // of empty space.
    hide: (el, s)=>!$ef989288ff8587ce$var$_siteKey(s),
    display: (el, s)=>$ef989288ff8587ce$var$_siteKey(s) ? 'block' : 'none',
    // Per-instance, non-reactive storage for the widget id + the site key it
    // was rendered for — the mount latch that keeps `onRender` + `onUpdate`
    // from stacking two widgets in one node.
    scope: {
        turnstileWidgetId: null,
        turnstileSiteKey: null
    },
    // The captcha config lands AFTER first paint (the options call is async),
    // so the mount must be attempted on both lifecycle points; the function
    // itself is idempotent per site key.
    onRender: (el, s)=>el.call('mountWhitelabelTurnstile', {
            state: s
        }),
    onUpdate: (el, s)=>el.call('mountWhitelabelTurnstile', {
            state: s
        }),
    onRemove: (el, s)=>el.call('removeWhitelabelTurnstile', {
            state: s
        })
};

});

parcelRegister("754l3", function(module, exports) {

$parcel$export(module.exports, "AppGlyphPlate", () => $527c5d976eeba9c6$export$4a939b9d322a6cc1);
$parcel$export(module.exports, "GlyphPlateHolder", () => $527c5d976eeba9c6$export$9821be56380b66df);
$parcel$export(module.exports, "NavTabGlyph", () => $527c5d976eeba9c6$export$50ee510a8f961748);
// Moved from workspace/components/AppGlyphTile.js (unit 2, 27bb58d37) into the shared kit in unit 3: the navbar
// tabs (shared/components/HeaderTabs.js) wear it too, so it cannot live in one app's package.
// THE GLYPH PLATE (dropdowns spec 2026-09-30 §4, §5) — the plate of the NEW glyph language: a square with a
// hairline ring at rest (the one stroke the redesign allows, after Nika's hairline tile references) and the
// glyph in title ink. It never styles its own states: the HOLDER does, through the `data-glyph-plate` hook
// (the MenuPanelItem keycap pattern) — hover, keyboard focus and "the app you are in" INVERT the plate
// (`highlight` fill, `title-reversed` ink); `[aria-current="page"]` on the holder also shows the orange dot.
// The search launcher wears it with the PIXEL glyphs (iconXl = two screen pixels per cell).
//
//   IconTile: { extends: 'AppGlyphPlate' }   — the launcher: the PIXEL glyph of the tile row (`s`)
//   Glyph: { extends: 'AppGlyphPlate', Icon: { name: (el, s) => el.call('glyphNameFor', {…}, 'ln') } }
//                                            — the navigation names its LINE glyph at the mount
const $527c5d976eeba9c6$export$4a939b9d322a6cc1 = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0',
    boxSizing: 'border-box',
    boxSize: 'glyphPlate',
    minWidth: 'glyphPlate',
    round: 'radiusControl',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    background: 'transparent',
    color: 'title',
    dataGlyphPlate: true,
    transition: 'background-color A defaultBezier, color A defaultBezier, border-color A defaultBezier',
    Icon: {
        name: (el, s)=>el.call('glyphNameFor', s, 'px'),
        boxSize: 'iconXl'
    },
    // "you are here" — shown by the holder's `[aria-current="page"]` rule, hidden otherwise (a FILL hue, the
    // one colour of the language)
    Dot: {
        tag: 'span',
        dataGlyphDot: true,
        ariaHidden: 'true',
        display: 'none',
        position: 'absolute',
        top: '-X',
        right: '-X',
        boxSize: 'glyphDot',
        round: 'radiusPill',
        background: 'orange'
    }
};
const $527c5d976eeba9c6$export$9821be56380b66df = {
    '&:hover [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    '&:focus-visible [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    '&[aria-current="page"] [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    '&[aria-current="page"] [data-glyph-dot]': {
        display: 'block'
    }
};
const $527c5d976eeba9c6$export$50ee510a8f961748 = {
    extends: 'AppGlyphPlate',
    order: '-1',
    boxSize: 'glyphPlateXs',
    minWidth: 'glyphPlateXs',
    round: 'radiusPill',
    borderColor: 'transparent',
    Icon: {
        name: (el, s)=>el.call('glyphNameFor', {
                route: s && s.path,
                icon: s && s.icon,
                glyph: s && s.icon,
                label: s && s.label,
                appKey: s && s.appKey
            }, 'ln'),
        boxSize: 'iconSm'
    }
};

});


parcelRegister("gbEhA", function(module, exports) {
// Barrel for frank extraction — see context.js note on pages wiring.
// account/index.js + auth/accept-invite.js + auth/waitlist-invite.js: the
// other auth/*.js pages already ride identity-index.js's own re-export
// below, but these three have no path through it — added alongside their
// consumers' deep-subpath fix (tickets/execution-board.md §1: a per-file
// specifier like '@symbo-ls/workspace-shared/pages/auth/accept-invite.js'
// cannot resolve through the platform's public importmap once this package
// is pushed as a library).

var $cvD80 = parcelRequire("cvD80");

var $O1juh = parcelRequire("O1juh");

var $eTMEY = parcelRequire("eTMEY");

var $lnteu = parcelRequire("lnteu");

var $5DlCK = parcelRequire("5DlCK");

var $hFpke = parcelRequire("hFpke");

var $hWmCC = parcelRequire("hWmCC");

var $8lWcZ = parcelRequire("8lWcZ");

var $87eDF = parcelRequire("87eDF");

var $imLTG = parcelRequire("imLTG");

var $dipGV = parcelRequire("dipGV");

var $7q4g1 = parcelRequire("7q4g1");

var $ltb7b = parcelRequire("ltb7b");

var $lnHgR = parcelRequire("lnHgR");

var $2O447 = parcelRequire("2O447");

var $1H7rU = parcelRequire("1H7rU");

var $k8Un4 = parcelRequire("k8Un4");

var $qZfri = parcelRequire("qZfri");

var $hFZ7H = parcelRequire("hFZ7H");

var $2njD1 = parcelRequire("2njD1");

var $gsbvm = parcelRequire("gsbvm");

var $9BPMF = parcelRequire("9BPMF");

var $ew9Jc = parcelRequire("ew9Jc");

var $esytx = parcelRequire("esytx");

var $6lb7e = parcelRequire("6lb7e");

var $7i3KY = parcelRequire("7i3KY");

var $eYQti = parcelRequire("eYQti");

var $21M33 = parcelRequire("21M33");

var $ezb1c = parcelRequire("ezb1c");

var $dpjKU = parcelRequire("dpjKU");

var $bLD5X = parcelRequire("bLD5X");

var $agTHT = parcelRequire("agTHT");

var $AJQbf = parcelRequire("AJQbf");

var $dmOpl = parcelRequire("dmOpl");

var $2kTUW = parcelRequire("2kTUW");

var $gkItP = parcelRequire("gkItP");

var $21gF2 = parcelRequire("21gF2");

var $4Swxz = parcelRequire("4Swxz");

var $agPef = parcelRequire("agPef");

var $84txb = parcelRequire("84txb");

var $3upCa = parcelRequire("3upCa");

var $7Ha5w = parcelRequire("7Ha5w");

var $iFQsA = parcelRequire("iFQsA");

var $55lAe = parcelRequire("55lAe");

var $4BEj7 = parcelRequire("4BEj7");

var $7LjA6 = parcelRequire("7LjA6");

var $fPlod = parcelRequire("fPlod");

var $gCszs = parcelRequire("gCszs");

var $26MfW = parcelRequire("26MfW");

var $2eE8e = parcelRequire("2eE8e");

var $4WlVO = parcelRequire("4WlVO");

var $exKv7 = parcelRequire("exKv7");

var $iKHyy = parcelRequire("iKHyy");

var $hdhas = parcelRequire("hdhas");

var $6nKaQ = parcelRequire("6nKaQ");

var $ga0Rt = parcelRequire("ga0Rt");

var $avx10 = parcelRequire("avx10");

var $gzGBq = parcelRequire("gzGBq");

var $cUIBX = parcelRequire("cUIBX");

var $610V7 = parcelRequire("610V7");
$parcel$exportWildcard(module.exports, $cvD80);
$parcel$exportWildcard(module.exports, $O1juh);
$parcel$exportWildcard(module.exports, $eTMEY);
$parcel$exportWildcard(module.exports, $lnteu);
$parcel$exportWildcard(module.exports, $5DlCK);
$parcel$exportWildcard(module.exports, $hFpke);
$parcel$exportWildcard(module.exports, $hWmCC);
$parcel$exportWildcard(module.exports, $8lWcZ);
$parcel$exportWildcard(module.exports, $87eDF);
$parcel$exportWildcard(module.exports, $imLTG);
$parcel$exportWildcard(module.exports, $dipGV);
$parcel$exportWildcard(module.exports, $7q4g1);
$parcel$exportWildcard(module.exports, $ltb7b);
$parcel$exportWildcard(module.exports, $lnHgR);
$parcel$exportWildcard(module.exports, $2O447);
$parcel$exportWildcard(module.exports, $1H7rU);
$parcel$exportWildcard(module.exports, $k8Un4);
$parcel$exportWildcard(module.exports, $qZfri);
$parcel$exportWildcard(module.exports, $hFZ7H);
$parcel$exportWildcard(module.exports, $2njD1);
$parcel$exportWildcard(module.exports, $gsbvm);
$parcel$exportWildcard(module.exports, $9BPMF);
$parcel$exportWildcard(module.exports, $ew9Jc);
$parcel$exportWildcard(module.exports, $esytx);
$parcel$exportWildcard(module.exports, $6lb7e);
$parcel$exportWildcard(module.exports, $7i3KY);
$parcel$exportWildcard(module.exports, $eYQti);
$parcel$exportWildcard(module.exports, $21M33);
$parcel$exportWildcard(module.exports, $ezb1c);
$parcel$exportWildcard(module.exports, $dpjKU);
$parcel$exportWildcard(module.exports, $bLD5X);
$parcel$exportWildcard(module.exports, $agTHT);
$parcel$exportWildcard(module.exports, $AJQbf);
$parcel$exportWildcard(module.exports, $dmOpl);
$parcel$exportWildcard(module.exports, $2kTUW);
$parcel$exportWildcard(module.exports, $gkItP);
$parcel$exportWildcard(module.exports, $21gF2);
$parcel$exportWildcard(module.exports, $4Swxz);
$parcel$exportWildcard(module.exports, $agPef);
$parcel$exportWildcard(module.exports, $84txb);
$parcel$exportWildcard(module.exports, $3upCa);
$parcel$exportWildcard(module.exports, $7Ha5w);
$parcel$exportWildcard(module.exports, $iFQsA);
$parcel$exportWildcard(module.exports, $55lAe);
$parcel$exportWildcard(module.exports, $4BEj7);
$parcel$exportWildcard(module.exports, $7LjA6);
$parcel$exportWildcard(module.exports, $fPlod);
$parcel$exportWildcard(module.exports, $gCszs);
$parcel$exportWildcard(module.exports, $26MfW);
$parcel$exportWildcard(module.exports, $2eE8e);
$parcel$exportWildcard(module.exports, $4WlVO);
$parcel$exportWildcard(module.exports, $exKv7);
$parcel$exportWildcard(module.exports, $iKHyy);
$parcel$exportWildcard(module.exports, $hdhas);
$parcel$exportWildcard(module.exports, $6nKaQ);
$parcel$exportWildcard(module.exports, $ga0Rt);
$parcel$exportWildcard(module.exports, $avx10);
$parcel$exportWildcard(module.exports, $gzGBq);
$parcel$exportWildcard(module.exports, $cUIBX);
$parcel$exportWildcard(module.exports, $610V7);

});
parcelRegister("cvD80", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "account", () => (parcelRequire("2eE8e")).profile);
$parcel$export(module.exports, "default", () => (parcelRequire("2eE8e")).profile);
// Barrel re-export — Phase 7 dispatch resolves `account` page here.
// The account shell covers /profile, /orgs, and /account/* routes.

var $2eE8e = parcelRequire("2eE8e");

});
parcelRegister("2eE8e", function(module, exports) {

$parcel$export(module.exports, "profile", () => $1a0c04e83f442e46$export$4882ae973e0491e);
const $1a0c04e83f442e46$export$4882ae973e0491e = {
    extends: 'ContentPage',
    // TWO VIEWS of one page (member-profile stage 3, memberProfileAccess.js
    // memberProfileView): /settings is the person's own settings, every other
    // route a member's profile. The settings tab reads "Settings / <brand>"; it
    // read "<name> / People / <brand>", the profile's title (live 2026-10-28).
    metadata: (el, s)=>{
        if (el.call('memberProfileView', s) === 'settings') return {
            title: el.call('pageTitle', 'account.profile.settingsTitle')
        };
        const person = el.call('findMe', s);
        // Until the person loads, the page's own word in the active language. A
        // fixed English 'Profile' here read "Profile / ადამიანები / Symbols ჩატი"
        // on a cold Georgian /profile (dev.comm 2026-10-30).
        const name = person?.name || el.call('polyglot', 'account.page.userProfile.title');
        const section = el.call('polyglot', 'account.profile.section');
        return {
            title: name + ' / ' + section + ' / ' + el.call('brandName')
        };
    },
    // `eyebrow` is a CUSTOM prop, so a function value is auto-invoked (Rule 70)
    // and ContentPage's `el.parent.parent.parent.eyebrow` reads the resolved
    // string.
    //
    // There is NO `title:` prop any more. `title` is a global HTML attribute
    // that ContentPage read as CONTENT — the one case with no working rewrite
    // form (docs/I18N-CONVENTION.md §1.2), which is why the heading sat in
    // English long after the rest of the page was extracted. Overriding
    // ContentPage's Title SLOT (PageMain.Header, bottom of this file) solves it
    // without a ContentPage change, and dropping the prop also drops the stray
    // native tooltip it put on the page element. ContentPage's Title reads
    // `…parent.title || ''` and this page supplies its own `text:`, so nothing
    // reads the removed prop.
    eyebrow: (el)=>el.call('polyglot', 'account.profile.eyebrow'),
    // Every entry carries TWO strings, and they are not the same thing.
    //
    // `sectionKey` is the SCROLL KEY. ContentPageSectionLink matches it against
    // `[data-content-section="<key>"]` in MemberProfile.js and writes it to
    // `root.contentSection`. It is the English string those attributes already
    // carry, and it must NEVER be translated — a translated key breaks the
    // scroll on the first switch, and breaks any link that names a section.
    // MemberProfile.js therefore needs no edit: its attribute stops being a
    // label and becomes an opaque key.
    //
    // `label` is the VISIBLE string, and it goes through polyglot.
    // `el.call('polyglot', key)` — the FUNCTION form, not a `{{ … | polyglot }}`
    // template. Only `text:` gets a reactive template effect; a template on an
    // ATTRIBUTE is resolved once in the static attribute pass, which overwrites
    // the prop, so it freezes in the boot language. The function form reads
    // `root.lang` through `getActiveLang`, and this whole factory runs inside
    // ContentPage's reactive `children` factory, so the list re-renders on a
    // switch. Polyglot is registered on every app that mounts this page:
    // `context.polyglot` lives in this package's own context.js and every
    // consumer (workspace, canvas, marketplace, preview, analytics) inherits it
    // wholesale through mergeOneLibrary's copy-whole-key branch.
    //
    // The keys live in i18n/{en,ka}/account.json and are parity-checked by
    // components/LanguageSelectField.test.js. Add a section => add the key to
    // BOTH bundles.
    //
    // The list itself is ONE shared function since stage 3
    // (memberProfileAccess.js memberProfileSections): this page and the shell's
    // /my ask it, so each rail lists exactly the cards its view shows.
    sections: (el, s)=>el.call('memberProfileSections', s),
    // Content mounts in ContentPage's main column (PageMain.Body) — the
    // notes-page skeleton; see components/ContentPage.js.
    PageMain: {
        // The heading. FUNCTION form, not a `{{ … | polyglot }}` template: a
        // `text:` on a leaf switches under both forms, but this whole path is
        // held to one form by components/LanguageSelectField.test.js — templates
        // freeze on an ATTRIBUTE, and one file mixing both invites the wrong one
        // being copied onto an attribute next.
        Header: {
            LeftGroup: {
                // The heading names the view: Settings on /settings, Profile
                // elsewhere. One title per host (design-direction.md §3): under a
                // pane bar the settings heading is the bar word for word, so it
                // yields there; the profile heading says more than the bar (the
                // person's name), so it stays as the pane's `h2`.
                Title: {
                    hide: (el, s)=>{
                        const view = el.call('memberProfileView', s);
                        const underBar = !!el.call('paneTitleBarShown', s);
                        return view === 'settings' && underBar;
                    },
                    text: (el, s)=>el.call('polyglot', el.call('memberProfileView', s) === 'settings' ? 'account.profile.settingsTitle' : 'account.profile.title')
                }
            }
        },
        Body: {
            PageBody: {
                flow: 'y',
                gap: 'D',
                flex: '1',
                minWidth: '0',
                // FULL WIDTH (2026-09-03 per Nika "content layout adapt to layout -
                // make it full width"). The old `maxWidth: 'I'` cap stranded a 799px
                // column on the left of a 1649px body — two thirds of the page was
                // empty. MemberProfile now flows its cards in two stacks per view
                // (a wide main stack beside a narrow side stack), so no row is
                // wider than its stack.
                width: '100%',
                MemberProfile: {
                    // Mail (architecture/MAIL.md §3.4) — the account card ships with
                    // @symbo-ls/workspace-mail and is mounted HERE because this page is
                    // the account surface every consumer reaches at /settings (and
                    // canvas's /settings). It sits at the END OF THE SETTINGS MAIN STACK,
                    // after Notifications (stage 3): it mounted as a loose root item
                    // after both settings stacks, on a line of its own.
                    //
                    // ONE GATE with its rail row (memberProfileAccess.js
                    // showsMailSettings): the component is registered (canvas links no
                    // mail package), it is your own page, and the `mail` feature flag is
                    // on for this workspace (`navItemVisible`, never a hand-rolled flag
                    // read). The stack itself shows on /settings only.
                    //
                    // ⚠️ NO `subscribeTo` HERE. DOMQL assigns an ARRAY wholesale rather
                    // than merging it, so a mount-site `subscribeTo: ['_featureFlags',
                    // 'workspace']` DELETED the card's own four keys (mailAccounts,
                    // mailSetup, mailSettingsDraft, mailSettingsBusy) — the card would
                    // have stopped re-rendering on every write its own data plane
                    // makes. `ifDeps` is what this gate actually needs and it is
                    // narrower: the framework reads the declared selectors inside the
                    // `if` effect itself, so the flag flip re-runs THIS gate without
                    // touching the component's own subscriptions.
                    SettingsMain: {
                        MailAccountSettingsCard: {
                            ifDeps: [
                                (el, s)=>s?.root && s.root._featureFlags,
                                (el, s)=>s?.root && s.root.workspace
                            ],
                            if: (el, s)=>!!el.call('showsMailSettings', s)
                        }
                    }
                }
            }
        }
    }
};

});


parcelRegister("O1juh", function(module, exports) {

$parcel$export(module.exports, "acceptInvite", () => $0965b06c44e07411$export$f17229473791149b);
// Accept-invitation surface — ONE page mounted at all four emailed invite
// paths (the server's buildInviteUrl targets, previously unrouted 404s —
// the P0 invite dead-end, 2026-08-06):
//
//   /accept-invite            → PROJECT invitation      → sdk.acceptInvite
//   /accept-org-invite        → ORGANIZATION invitation → sdk.acceptOrgInvitation
//   /accept-team-invite       → TEAM invitation         → sdk.acceptTeamInvitation
//   /accept-workspace-invite  → WORKSPACE invitation    → sdk.acceptWorkspaceInvitation
//
// Flow: parse kind (from the path) + the token. Unauthed visitors are routed
// to /login?next=<this path, token in the fragment> so the token survives the
// sign-in round-trip (signin/LoginWindow already honor ?next). Authed visitors get
// the matching SDK accept call, a progress → success/error card, and on
// success the joined org is activated (sdk.switchOrg — same convention as
// AppCreateOrgModal) before a hard replace('/') re-keys claims + queries.
//
// Same LoginWindow-family chrome as the other auth pages: authPageTheme
// backdrop + brand ModalWindow card (ModalHeader's Close is dropped — a
// full-page surface has nothing to close to, see LoginWindow #2278).
//
// THE TOKEN STAYS IN MEMORY (INVITE-MAGIC-LINK-1 hardening, review
// 2026-10-09). It is a bearer credential: `#token=` on a magic link,
// `?token=` on an emailed invitation. The first script of
// workspace/index.html takes it out of the address bar on these paths before
// any other script runs (and sets Referrer-Policy no-referrer); this page
// takes it from there (`el.call('takeInviteToken')`) and keeps it in a local
// for the preview and accept POSTs. The way back after sign-in carries it in
// the FRAGMENT, which no server sees.

var $lJuW8 = parcelRequire("lJuW8");
const $0965b06c44e07411$var$KIND_BY_PATH = {
    '/accept-invite': 'project',
    '/accept-org-invite': 'organization',
    '/accept-team-invite': 'team',
    '/accept-workspace-invite': 'workspace'
};
// Bundle KEYS, not copy — `kindLabel` is interpolated into several sentences
// and every render site resolves it through polyglot (which returns a non-key
// verbatim, so an older state value still reads).
const $0965b06c44e07411$var$KIND_LABEL = {
    project: 'auth.acceptInvite.kind.project',
    organization: 'auth.acceptInvite.kind.organization',
    team: 'auth.acceptInvite.kind.team',
    workspace: 'auth.acceptInvite.kind.workspace'
};
// The kind in the CASE its sentence needs — one literal key per form. A
// Georgian case ending cannot be glued onto the nominative: "ამ {kind}-ის
// წევრი" read "ამ პროექტი-ის წევრი" (the genitive is პროექტის), "შეუერთდით
// {kind}-ს" read "სამუშაო სივრცე-ს". English forms equal the plain noun, so
// `{kind}` stays one placeholder in both languages
// (shared/__tests__/acceptInviteGeorgianCase.test.js).
const $0965b06c44e07411$var$KIND_OF = {
    project: 'auth.acceptInvite.kindOf.project',
    organization: 'auth.acceptInvite.kindOf.organization',
    team: 'auth.acceptInvite.kindOf.team',
    workspace: 'auth.acceptInvite.kindOf.workspace'
};
const $0965b06c44e07411$var$KIND_TO = {
    project: 'auth.acceptInvite.kindTo.project',
    organization: 'auth.acceptInvite.kindTo.organization',
    team: 'auth.acceptInvite.kindTo.team',
    workspace: 'auth.acceptInvite.kindTo.workspace'
};
const $0965b06c44e07411$var$KIND_IN = {
    project: 'auth.acceptInvite.kindIn.project',
    organization: 'auth.acceptInvite.kindIn.organization',
    team: 'auth.acceptInvite.kindIn.team',
    workspace: 'auth.acceptInvite.kindIn.workspace'
};
// The token this page load took, for the path it was taken on — in memory
// for the life of the document, never in storage or the URL. It exists for
// ONE case: a REMOUNT of this page with no navigation. A warm start mounts an
// early shell before the session check; when that check finds no user, the
// boot disposes the early shell and mounts a fresh one (shared/functions/
// bootShell.js `_disposeEarlyShell`, guest routes only), and this page runs
// again — after the token already left the address bar. Dropped once the
// invitation is accepted.
//
// FA201 / frank trap (WS-SHARED-MODULE-LET-BLOCKS-EVERY-PUSH-1; gazer's push
// was refused on it 2026-10-18): this used to be a module-scope
// `let _heldInvite`, read by `_parseInviteUrl`. frank revives a page's
// functions with no module scope, so the read was an unresolvable identifier
// and the emission gate refused every project that bundles this page.
// Re-homed onto a NON-enumerable `globalThis.__acceptInviteHeld` (the
// pointerCapability.js template) and deleted the moment the invitation
// settles — still memory only, never storage or the URL.
// Read the invite kind from the CURRENT path and TAKE the token (query or
// fragment) out of the address bar into memory. Reading window.location
// directly is the established auth-page convention here (signin/signup do
// the same for ?next / ?token) — these pages own the entry URL by definition.
const $0965b06c44e07411$var$_parseInviteUrl = (el)=>{
    if (typeof window === 'undefined') return {
        kind: null,
        token: null
    };
    const url = new URL(window.location.href);
    const path = url.pathname.replace(/\/+$/, '') || '/';
    const taken = el.call('takeInviteToken') || null;
    if (taken) Object.defineProperty(globalThis, '__acceptInviteHeld', {
        value: {
            path: path,
            token: taken
        },
        writable: true,
        configurable: true,
        enumerable: false
    });
    const heldInvite = globalThis.__acceptInviteHeld;
    const held = heldInvite && heldInvite.path === path ? heldInvite.token : null;
    return {
        kind: $0965b06c44e07411$var$KIND_BY_PATH[path] || null,
        token: taken || held
    };
};
// The way back to this page after sign-in / sign-up: this path, the live
// query (never a token) and the token in the FRAGMENT — the landing after
// sign-in never sends it to a server, and this page takes it out of the
// address bar again on arrival.
const $0965b06c44e07411$var$_returnPath = (token)=>{
    const url = new URL(window.location.href);
    url.searchParams.delete('token');
    const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
    hash.set('token', token);
    return url.pathname + url.search + '#' + hash.toString();
};
const $0965b06c44e07411$var$_acceptByKind = (el, kind, token)=>{
    if (kind === 'organization') return el.sdk.acceptOrgInvitation({
        token: token
    });
    if (kind === 'team') return el.sdk.acceptTeamInvitation({
        token: token
    });
    if (kind === 'workspace') return el.sdk.acceptWorkspaceInvitation({
        token: token
    });
    return el.sdk.acceptInvite(token);
};
// Personalized invite context (INVITE-JOIN-PAGE-PERSONALIZED-1) — the
// public preview endpoint names the workspace/org/inviter for a token so
// this page can say "Join Acme" instead of the generic word "invitation".
// FEATURE-DETECTED: older SDK/server builds return null and every caller
// degrades to the previous generic copy. Never throws.
const $0965b06c44e07411$var$_fetchPreview = async (el, token)=>{
    try {
        if (typeof el.sdk?.getInvitationPreview !== 'function') return null;
        const res = await el.sdk.getInvitationPreview({
            token: token
        });
        const p = res?.data || res || null;
        if (!p || typeof p !== 'object') return null;
        return {
            status: p.status || 'pending',
            workspaceName: p.workspaceName || '',
            orgName: p.orgName || p.organizationName || '',
            inviterName: p.inviterName || '',
            inviteeEmail: p.inviteeEmail || p.email || '',
            role: p.role || '',
            // INVITE-MAGIC-LINK-1 — false only for an org magic link (bound to no
            // email); an older server sends nothing, which reads as email-bound.
            emailBound: p.emailBound !== false
        };
    } catch (_) {
        return null;
    }
};
// What the invite is asking the user to join, for headlines/copy — the most
// specific name the preview carries, else '' so every render site takes its
// generic-copy branch. The fallback used to be `the ${label}` — and `label` is
// a bundle KEY, so a preview without names headlined "Join the
// auth.acceptInvite.kind.project".
const $0965b06c44e07411$var$_joinTargetName = (preview)=>preview?.workspaceName || preview?.orgName || '';
// What the HEADING names: the ORGANIZATION, for every invite kind (Nika
// 2026-10-14: "instead of 'Join Default' we say 'Join orgname'" — an org's
// default workspace is literally named "Default"). The body copy keeps the
// workspace name (`targetName`) where it adds information.
const $0965b06c44e07411$var$_joinHeadName = (s)=>s.orgName || s.targetName || '';
// Which org did this invite land the user in? (Used to activate it so the
// user wakes up INSIDE the org they just joined.)
const $0965b06c44e07411$var$_resolveJoinedOrgId = async (el, kind, data)=>{
    try {
        if (kind === 'organization') return data?.member?.organization || null;
        if (kind === 'team') return data?.organizationId || null;
        if (kind === 'workspace') {
            // The accept response carries the org id directly (bare ObjectId);
            // the getWorkspace round-trip is only the older-server fallback.
            if (data?.organization) return String(data.organization);
            const wsId = data?.workspace;
            if (!wsId) return null;
            const ws = await el.sdk.getWorkspace(String(wsId));
            return ws?.organization || ws?.org_id || null;
        }
    } catch (_) {
    /* org activation is best-effort — the membership already exists */ }
    return null;
};
// Surface the joined org + workspace in the switcher's data sources
// BEFORE the switch commits, so the shell renders them the moment the
// switch pipeline rebuilds — the same optimistic-merge convention
// AppOrgSwitcher's "+ New workspace" uses for root.orgWorkspaces. Shapes
// mirror the canonical writers: root.orgs rows come from /auth/me
// user.organizations ({ id, slug, name, type, role }); orgWorkspaces rows
// are the normalized SDK-prefetch shape. The next auth tick re-derives
// both from the server, so a minimal row here can only be corrected,
// never fought.
// Root STATE, never the root ELEMENT: `el.getRoot().update({...})` writes an
// element prop (measured live 2026-08-27 on dev — the flag landed on
// `root._usernamePromptPending`, `root.state` never saw it, so
// UsernamePromptGate / NoOrgOverlay, which read `s.root`, never fired and the
// switcher never learned the joined org). Same resolver as
// functions/usernamePrompt.js `_rootState`.
const $0965b06c44e07411$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
const $0965b06c44e07411$var$_mergeJoinedIntoState = async (el, kind, data, orgId)=>{
    const root = $0965b06c44e07411$var$_rootState(el);
    if (!root || !orgId) return null;
    const patch = {};
    const orgs = Array.isArray(root.orgs) ? root.orgs : [];
    if (!orgs.some((o)=>String(o?.id || o?._id) === String(orgId))) patch.orgs = [
        ...orgs,
        {
            id: String(orgId),
            slug: data?.organizationSlug || '',
            name: data?.organizationName || data?.organizationSlug || 'Organization',
            // The org's REAL type, off the accept response
            // (WS-INVITE-LIVE-SWITCH-SKIPS-PERSONAL-ORG-1). This row used to be
            // hardcoded `'team'`, which is wrong for the commonest case there is:
            // an invite sent from a personal account. Null on an older server —
            // the next auth tick re-derives the row from /auth/me either way.
            type: data?.organizationType || null,
            role: 'contributor'
        }
    ];
    const wsId = kind === 'workspace' && data?.workspace ? String(data.workspace) : null;
    if (wsId) {
        let ws = null;
        try {
            ws = await el.sdk.getWorkspace(wsId);
        } catch (_) {
            ws = null;
        }
        const byOrg = {
            ...root.orgWorkspaces || {}
        };
        const rows = Array.isArray(byOrg[orgId]) ? byOrg[orgId] : [];
        if (!rows.some((w)=>String(w?.id || w?.workspace_id) === wsId)) {
            const displayName = ws?.displayName || ws?.name || data?.workspaceName || data?.workspaceSlug || 'Workspace';
            byOrg[orgId] = [
                ...rows,
                {
                    id: wsId,
                    workspace_id: wsId,
                    org_id: String(orgId),
                    organization: String(orgId),
                    // The URL handle this row must be matchable BY. `findWorkspaceInOrg`
                    // (and the shell's registerWorkspaceHandleResolver, which uses it)
                    // matches slug → key → id in that order, so a row carrying only an id
                    // could not claim the `/w/<org>/<slug-or-key>` path this page routes
                    // to — segment 2 read as a route name and the deep link fell apart.
                    slug: ws?.slug || data?.workspaceSlug || null,
                    key: ws?.key || data?.workspaceKey || null,
                    type: ws?.type || 'shared',
                    displayName: displayName,
                    name: displayName
                }
            ];
            patch.orgWorkspaces = byOrg;
        }
    }
    if (Object.keys(patch).length) root.update(patch);
    return wsId;
};
// Server error → human message. The SDK surfaces the server's error body
// as Error.message, so we classify on substrings. `link`: the invitation is a
// magic link, where "not pending" means someone already used it (or it was
// turned off) — say that, not the email invitation's "no longer active".
const $0965b06c44e07411$var$_friendlyError = (el, kind, message, { link: link = false } = {})=>{
    const msg = String(message || '');
    const t = (key)=>el.call('polyglot', key);
    if (link && /not pending/i.test(msg)) return {
        text: t('auth.acceptInvite.linkUsed')
    };
    if (/already a member/i.test(msg)) return {
        already: true,
        text: t('auth.acceptInvite.alreadyMember').replace('{kind}', t($0965b06c44e07411$var$KIND_OF[kind] || 'auth.acceptInvite.kindOf.invitation'))
    };
    // The server's JWT-verify failure reads 'Invalid or expired token'
    // (genuinely ambiguous server-side) — classify it BEFORE the plain
    // /expired/ branch, which is reserved for the record-level
    // 'Invitation expired'.
    if (/invalid or expired/i.test(msg)) return {
        text: t('auth.acceptInvite.invalidOrExpired')
    };
    if (/expired/i.test(msg)) return {
        text: t('auth.acceptInvite.expired')
    };
    if (/not pending|revoked/i.test(msg)) return {
        text: t('auth.acceptInvite.inactive')
    };
    if (/email.?mismatch/i.test(msg)) return {
        text: t('auth.acceptInvite.wrongEmail')
    };
    if (/not found/i.test(msg)) return {
        text: t('auth.acceptInvite.notFound')
    };
    if (/invalid/i.test(msg)) return {
        text: t('auth.acceptInvite.invalid')
    };
    return {
        text: msg || t('auth.acceptInvite.generic')
    };
};
// The invitation is already settled for THIS visitor: "Already a member", or
// a spent invitation whose org the signed-in visitor belongs to (the sign-up
// path accepts inline, then sends them through sign-in back here). Success
// copy, then a fresh boot on '/' — with the joined org made active first when
// its id is known.
const $0965b06c44e07411$var$_settleAlreadyMember = async (el, s, kind, orgId)=>{
    delete globalThis.__acceptInviteHeld;
    const friendly = $0965b06c44e07411$var$_friendlyError(el, kind, 'Already a member');
    s.update({
        status: 'success',
        message: friendly.text,
        dest: '/'
    });
    if (orgId) try {
        await el.sdk.switchOrg(String(orgId));
    } catch (_) {
    /* activation is best-effort — the membership already exists */ }
    setTimeout(()=>window.location.replace('/'), 900);
};
// The org an ORG or TEAM invitation is for, read off its token — for routing
// only; the server decides access (functions/inviteToken.js).
const $0965b06c44e07411$var$_invitationOrgId = (el, token)=>{
    const claims = el.call('inviteTokenClaims', token);
    return claims && claims.organizationId || null;
};
// Does the signed-in visitor belong to `orgId`? /auth/me's
// user.organizations, then the shell's own org rows.
const $0965b06c44e07411$var$_memberOfOrg = (el, me, orgId)=>{
    const fromMe = me?.user?.organizations || me?.data?.user?.organizations || me?.organizations || [];
    const fromRoot = ($0965b06c44e07411$var$_rootState(el) || {}).orgs || [];
    return [
        ...fromMe,
        ...fromRoot
    ].some((o)=>String(o?.id || o?._id || '') === String(orgId));
};
const $0965b06c44e07411$var$_runAcceptFlow = async (el, s)=>{
    if (typeof window === 'undefined') return;
    const { kind: kind, token: token } = $0965b06c44e07411$var$_parseInviteUrl(el);
    const label = $0965b06c44e07411$var$KIND_LABEL[kind] || 'auth.acceptInvite.kind.invitation';
    s.update({
        kindLabel: label,
        kindInLabel: $0965b06c44e07411$var$KIND_IN[kind] || 'auth.acceptInvite.kindIn.invitation'
    });
    // Tell the shell an invite flow owns this beat — NoOrgOverlay suppresses
    // its org-creation gate while this is up (an invitee is JOINING an org;
    // pushing them to create one was the reported confusion).
    try {
        $0965b06c44e07411$var$_rootState(el)?.update({
            _inviteFlowActive: true
        });
    } catch (_) {
    /* shell-less mounts (tests) have no root state to flag */ }
    if (!token) {
        s.update({
            status: 'error',
            message: el.call('polyglot', 'auth.acceptInvite.missingToken')
        });
        return;
    }
    // Auth gate — the page renders pre-auth (guest-allowlisted) so IT owns
    // the choice of path and the token survives via ?next=. getMe() is the
    // authoritative session probe (init-gated Promise, safe to await).
    // No session, no probe: with no stored token (or the shell's verdict is
    // "signed out"), /auth/me can only answer 401 — measured on the
    // white-label landing, a clean profile (2026-10-11). An SDK without
    // getAuthToken keeps the probe.
    // The verdict is isAuthorised()'s (methods/canvas.js): once the shell's
    // session pass is ready (root._authReady), root.signedIn follows an
    // in-place sign-in; the boot gate's answer stands only until then. An
    // invited sign-up's "Continue" opens the account in the page and routes
    // here under a boot that said "signed out" — reading the boot flag alone
    // showed that member the signed-out welcome (gita.pr, 2026-10-28).
    let me = null;
    const _bootSignedIn = el.context?.bootSignedIn;
    const _root = $0965b06c44e07411$var$_rootState(el);
    const _signedIn = typeof _bootSignedIn === 'boolean' && _root && _root._authReady === true && typeof _root.signedIn === 'boolean' ? _root.signedIn : _bootSignedIn;
    const _noSession = _signedIn === false || typeof el.sdk?.getAuthToken === 'function' && !el.sdk.getAuthToken();
    if (!_noSession) try {
        me = await el.sdk.getMe();
    } catch (_) {
        me = null;
    }
    // Name the thing being joined as early as possible — both branches
    // below read it. Null on older builds → generic copy everywhere.
    const preview = await $0965b06c44e07411$var$_fetchPreview(el, token);
    if (preview) {
        s.update({
            targetName: $0965b06c44e07411$var$_joinTargetName(preview),
            orgName: preview.orgName,
            inviterName: preview.inviterName,
            inviteeEmail: preview.inviteeEmail,
            linkInvite: preview.emailBound === false
        });
        // A dead invite reads the same signed-in or signed-out — say so
        // before asking anyone to authenticate for it.
        if (preview.status === 'expired') {
            s.update({
                status: 'error',
                message: el.call('polyglot', 'auth.acceptInvite.expired')
            });
            return;
        }
        if (preview.status === 'revoked') {
            s.update({
                status: 'error',
                message: el.call('polyglot', 'auth.acceptInvite.inactive')
            });
            return;
        }
        // INVITE-MAGIC-LINK-1 — a SPENT invitation. Whoever spent it is usually
        // the one coming back: an invited sign-up (an emailed invitation, or a
        // link through a verified OAuth sign-in) accepts inline, then goes
        // through sign-in to this page. A signed-in visitor who already belongs
        // to the invitation's org is in — say so and open it, instead of an
        // accept call that can only answer "not pending". A magic link spent by
        // anyone else no longer works — say that before asking anyone to sign
        // in. An email invitation otherwise keeps its path below.
        if (preview.status === 'accepted') {
            const orgId = $0965b06c44e07411$var$_invitationOrgId(el, token);
            if (me && orgId && $0965b06c44e07411$var$_memberOfOrg(el, me, orgId)) {
                await $0965b06c44e07411$var$_settleAlreadyMember(el, s, kind, orgId);
                return;
            }
            if (preview.emailBound === false) {
                s.update({
                    status: 'error',
                    message: el.call('polyglot', 'auth.acceptInvite.linkUsed')
                });
                return;
            }
        }
    }
    // Both signed-out actions and the wrong-account beat need these.
    const returnPath = $0965b06c44e07411$var$_returnPath(token);
    const loginPath = '/login?next=' + encodeURIComponent(returnPath);
    const signupPath = '/signup?token=' + encodeURIComponent(token) + '&next=' + encodeURIComponent(returnPath);
    s.update({
        loginPath: loginPath,
        signupPath: signupPath
    });
    if (!me) {
        // Signed-out invitee — the WELCOME beat (INVITE-JOIN-PAGE-
        // PERSONALIZED-1): a personalized join card offering account creation
        // (the common case — invites target new teammates) with sign-in as
        // the secondary path. The token rides to signup via ?token= (its
        // register flow verifies + auto-accepts it) and to sign-in via ?next=
        // back to this page. Older builds with no preview still get the
        // welcome card, just with generic copy.
        s.update({
            status: 'welcome'
        });
        return;
    }
    // Signed in as the WRONG account — say which email the invite wants
    // before burning the accept call on a guaranteed email_mismatch.
    const myEmail = String(me?.email || me?.data?.user?.email || me?.user?.email || '').toLowerCase();
    if (preview?.inviteeEmail && myEmail && preview.inviteeEmail.toLowerCase() !== myEmail) {
        s.update({
            status: 'mismatch',
            message: el.call('polyglot', 'auth.acceptInvite.mismatch')// Function replacers: an email local part may hold `$&` / `$1`.
            .replace('{invited}', ()=>preview.inviteeEmail).replace('{current}', ()=>myEmail)
        });
        return;
    }
    s.update({
        status: 'accepting'
    });
    try {
        const data = await $0965b06c44e07411$var$_acceptByKind(el, kind, token);
        const orgId = await $0965b06c44e07411$var$_resolveJoinedOrgId(el, kind, data);
        // GA-W3.3 — a WORKSPACE invite lands the user INSIDE that workspace
        // (the accept response carries the org + workspace handles), never on
        // the generic dashboard.
        //
        // WS-INVITE-LIVE-SWITCH-SKIPS-PERSONAL-ORG-1 — this used to require
        // `workspaceSlug` and fall back to '/' without it, which is what every
        // real invite hit: `Workspace.slug` is OPTIONAL and null on every
        // workspace minted before slug allocation existed (143 of 143 under the
        // org measured on dev), so the deep link degraded to the dashboard for
        // the common case. The handle rule is `slug || key || id` — the SAME
        // precedence `workspaceUrlHandle` and `findWorkspaceInOrg` use, inlined
        // rather than imported (FA001/FA204: a bare sibling-export read is
        // unresolvable post-frank, and this page owns its own entry URL anyway).
        // '/' now means only "no org slug to build a path from at all".
        const wsHandle = kind === 'workspace' ? data?.workspaceSlug || data?.workspaceKey || (data?.workspace ? String(data.workspace) : '') : '';
        const dest = kind === 'workspace' && data?.organizationSlug && wsHandle ? `/w/${data.organizationSlug}/${wsHandle}` : '/';
        // LIVE activation (INVITE-ACCEPT-ACTIVATES-WORKSPACE-LIVE-1): merge the
        // joined org + workspace into the switcher's data sources, then commit
        // the switch through the same sdk.switchOrg pipeline the switcher's own
        // _commitOrgSwitch uses — its orgSwitched event drives the shell's
        // in-place wipe + refetch (epoch-guarded, tenant-scoped since the
        // 2026-07-18 switch fixes), so no page reload is needed.
        let switched = false;
        if (orgId) {
            const wsId = await $0965b06c44e07411$var$_mergeJoinedIntoState(el, kind, data, orgId);
            try {
                await el.sdk.switchOrg(String(orgId), wsId ? {
                    homeWorkspaceId: wsId
                } : undefined);
                switched = true;
            } catch (switchErr) {
                // Older servers reject the switch for workspace-kind invites (no
                // org membership row yet) — fall back to the hard-reload recovery.
                console.warn('[accept-invite] activate joined org failed:', switchErr?.message || switchErr);
            }
        }
        delete globalThis.__acceptInviteHeld;
        s.update({
            status: 'success',
            message: el.call('polyglot', 'auth.acceptInvite.joined').replace('{kind}', el.call('polyglot', $0965b06c44e07411$var$KIND_TO[kind] || 'auth.acceptInvite.kindTo.invitation')),
            dest: dest
        });
        // Queue the invitee's LIGHT onboarding step — the username nudge
        // (UsernamePromptGate opens it once after landing; the DONE key caps
        // it at one showing ever). Live path: root flag. Fallback path:
        // persisted marker, because the hard reload wipes root state.
        if (switched) {
            try {
                $0965b06c44e07411$var$_rootState(el)?.update({
                    _usernamePromptPending: true,
                    _inviteFlowActive: false
                });
            } catch (_) {
            /* flag is a nudge trigger — never worth failing the accept over */ }
            // Paint the success beat, strip the consumed token from history
            // (query only — the router below performs the real path change, so
            // handing it an already-current path must stay impossible), then
            // SPA-route into the joined workspace. The switch pipeline has
            // already rebuilt state; a reload would only redo that work and
            // lose the no-reload acceptance this page now owns.
            try {
                window.history.replaceState({}, '', window.location.pathname);
            } catch (_) {
            /* history is cosmetic here — the router below still lands */ }
            setTimeout(()=>el.router(dest, el.getRoot()), 900);
        } else {
            try {
                el.call('persistUsernamePromptPending');
            } catch (_) {
            /* function registry absent (non-workspace shell) — nudge skipped */ }
            // Recovery convention (AppCreateOrgModal / NoOrgOverlay): a fresh
            // boot re-keys every claim read + `method: 'select'` query.
            // replace() keeps the consumed-token URL out of history.
            setTimeout(()=>window.location.replace(dest), 900);
        }
    } catch (err) {
        // Review D1 — a link joins only a VERIFIED account; an unverified one gets
        // 403 `email_not_verified` and the link stays open. Say what to do, in the
        // session language: the server's code, never its English message.
        if (err?.cause?.error === 'email_not_verified') {
            s.update({
                status: 'error',
                message: el.call('polyglot', 'auth.acceptInvite.verifyFirst')
            });
            return;
        }
        const friendly = $0965b06c44e07411$var$_friendlyError(el, kind, err?.message, {
            link: s.linkInvite === true
        });
        if (friendly.already) {
            // Idempotent replay (double-click, refresh) — treat as success.
            $0965b06c44e07411$var$_settleAlreadyMember(el, s, kind, null);
            return;
        }
        console.warn('[accept-invite] accept failed:', err?.message || err);
        s.update({
            status: 'error',
            message: friendly.text
        });
    }
};
const $0965b06c44e07411$export$f17229473791149b = {
    extends: 'Page',
    // On a white-label host the tab names the org ("<page> / <org>"). While the
    // brand is not there, the page answers NO title: the edge-stamped one stays
    // while it loads, and the shell's route wrapper supplies its own title once
    // the host turns out to have no brand (shell functions/authWrapperTitle.js).
    // isCustomDomainHost is a shell function; elsewhere this is a platform page.
    metadata: (el)=>{
        if (el.state?.root?.whitelabelBrand?.name) return {
            title: el.call('pageTitle', 'auth.page.acceptInvite.title')
        };
        const fns = el.context?.functions;
        if (typeof fns?.isCustomDomainHost === 'function' && el.call('isCustomDomainHost')) return {
            title: undefined
        };
        return {
            title: el.call('pageTitle', 'auth.page.acceptInvite.title')
        };
    },
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    '@mobileL': {
        padding: 'A'
    },
    width: '100%',
    height: '100dvh',
    maxWidth: 'none',
    ...(0, $lJuW8.authPageTheme),
    ModalWindow: {
        // State + flow live ON the card, not the page: brand ModalWindow
        // declares `state: {}` (an isolated scope — see LoginWindow's note),
        // so bindings inside the card can only see state owned HERE. Initial
        // keys make every reactive factory below register its dep at first
        // render. `status`: checking → accepting → success | error (or →
        // redirect when unauthed).
        state: {
            status: 'checking',
            message: '',
            kindLabel: 'auth.acceptInvite.kind.invitation',
            kindInLabel: 'auth.acceptInvite.kindIn.invitation',
            dest: '/',
            // Personalization (preview-fed; empty on older builds → generic copy)
            targetName: '',
            orgName: '',
            inviterName: '',
            inviteeEmail: '',
            // INVITE-MAGIC-LINK-1 — the invitation is a magic link (bound to no
            // email): any account may accept it, once.
            linkInvite: false,
            // Signed-out welcome-beat destinations
            signupPath: '',
            loginPath: ''
        },
        onCreate: (el, s)=>{
            $0965b06c44e07411$var$_runAcceptFlow(el, s);
        },
        // The org's logo + name on a white-label host (the branded sign-in's
        // lockup, components/WhitelabelSignin.js); nothing on a platform host.
        WhitelabelLockup: {
            order: '-1',
            subscribeTo: [
                'whitelabelBrand'
            ],
            hide: (el, s)=>!(s.root && s.root.whitelabelBrand),
            // On this card the lockup sits on the design-system card ground, not
            // the branded sign-in's: its ink is the card's own (title / caption,
            // AA on that ground by the design system), and the name is not a
            // heading — the card's own heading stays the page's one h1.
            Wordmark: {
                tag: 'div',
                color: 'title'
            },
            Tagline: {
                color: 'caption'
            }
        },
        // Full-page card, not a floating dialog: neutralize the modal
        // positioning the same way LoginWindow does.
        position: 'relative',
        transform: 'none',
        top: 'auto',
        left: 'auto',
        margin: 'auto',
        border: 'none',
        boxShadow: 'none',
        width: '100%',
        maxWidth: 'I_default',
        minHeight: 'F',
        padding: 'B B2 C1',
        // White-label host: the branded sign-in's card measure and inset, so the
        // invitation reads as the same family as login and signup (Nika
        // 2026-10-14). Platform values above stay untouched.
        isBranded: (el, s)=>!!(s.root && s.root.whitelabelBrand),
        '.isBranded': {
            maxWidth: 'overlaySm',
            minHeight: 'auto',
            padding: 'B1'
        },
        gap: 'B',
        align: 'center center',
        textAlign: 'center',
        // Drop the inherited header (its Close X has nothing to close to on a
        // full-page surface — see LoginWindow's #2278 note); this card renders
        // its own heading below.
        ModalHeader: null,
        // Progress overlay while we probe the session / call the accept
        // endpoint — same scrim treatment as LoginWindow's sign-in beat.
        LoadingGifSection: {
            background: 'scrim',
            position: 'absolute',
            inset: '0',
            fullSize: true,
            transition: 'B defaultBezier',
            transitionProperty: 'opacity, visibility',
            pointerEvents: (el, s)=>s.status === 'checking' || s.status === 'accepting' || s.status === 'redirect' ? 'auto' : 'none',
            opacity: (el, s)=>s.status === 'checking' || s.status === 'accepting' || s.status === 'redirect' ? 1 : 0,
            visibility: (el, s)=>s.status === 'checking' || s.status === 'accepting' || s.status === 'redirect' ? 'visible' : 'hidden'
        },
        // Override the brand Hgroup's OWN H + P children (adding new keys
        // would render beside the 'Heading'/'Paragraph' defaults, not replace
        // them).
        Hgroup: {
            gap: 'Y',
            H: {
                // The page's ONE h1 (the brand Hgroup defaults H to h3; the org
                // lockup's name above is a div on this card) — through the shared
                // title level, which answers h2 only under a pane title bar.
                tag: (el, s)=>el.call('pageTitleTag', s),
                // White-label host: the branded cards' heading size (WhitelabelAuthWindow).
                isBranded: (el, s)=>!!(s.root && s.root.whitelabelBrand),
                '.isBranded': {
                    fontSize: 'B1'
                },
                text: (el, s)=>{
                    const t = (key)=>el.call('polyglot', key);
                    const head = $0965b06c44e07411$var$_joinHeadName(s);
                    if (s.status === 'welcome') return head ? t('auth.acceptInvite.h.welcomeNamed').replace('{name}', ()=>head) : t('auth.acceptInvite.h.welcome');
                    if (s.status === 'mismatch') return t('auth.acceptInvite.h.mismatch');
                    if (s.status === 'success') return t('auth.acceptInvite.h.success');
                    if (s.status === 'error') return t('auth.acceptInvite.h.error');
                    if (s.status === 'redirect') return t('auth.acceptInvite.h.redirect');
                    return head ? t('auth.acceptInvite.h.joiningNamed').replace('{name}', ()=>head) : t('auth.acceptInvite.h.joining');
                }
            },
            P: {
                lineHeight: '1.5em',
                text: (el, s)=>{
                    const t = (key)=>el.call('polyglot', key);
                    if (s.status === 'welcome') {
                        const who = s.inviterName ? t('auth.acceptInvite.p.whoNamed').replace('{name}', ()=>s.inviterName) : t('auth.acceptInvite.p.who');
                        const where = s.targetName ? s.orgName && s.orgName !== s.targetName ? t('auth.acceptInvite.p.whereNamedOrg').replace('{name}', ()=>s.targetName).replace('{org}', ()=>s.orgName) : t('auth.acceptInvite.p.whereNamed').replace('{name}', ()=>s.targetName) : s.orgName ? t('auth.acceptInvite.p.whereNamed').replace('{name}', ()=>s.orgName) : t('auth.acceptInvite.p.whereKind').replace('{kind}', t(s.kindInLabel));
                        const as = s.inviteeEmail ? t('auth.acceptInvite.p.as').replace('{email}', ()=>s.inviteeEmail) : '';
                        return t('auth.acceptInvite.p.welcome').replace('{who}', ()=>who).replace('{where}', ()=>where).replace('{as}', ()=>as);
                    }
                    if (s.status === 'mismatch') return s.message;
                    if (s.status === 'success' || s.status === 'error') return s.message;
                    if (s.status === 'redirect') return t('auth.acceptInvite.p.redirect');
                    return t('auth.acceptInvite.p.checking').replace('{kind}', t(s.kindLabel));
                }
            }
        },
        // Signed-out welcome beat — create-account first (invites mostly
        // target new teammates), sign-in second. Both destinations carry the
        // token/return path computed in _runAcceptFlow.
        WelcomeActions: {
            flow: 'y',
            gap: 'Z1',
            width: '100%',
            align: 'center center',
            hide: (el, s)=>s.status !== 'welcome',
            CreateAccountButton: {
                extends: [
                    'WhitelabelAccent',
                    'Button'
                ],
                theme: 'primary',
                type: 'button',
                minHeight: 'controlH',
                padding: '0 B',
                round: 'radiusPill',
                fontSize: 'Z2',
                fontWeight: '700',
                text: '{{ auth.acceptInvite.createAccount | polyglot }}',
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    el.router(s.signupPath || '/signup', el.getRoot());
                }
            },
            SignInButton: {
                extends: 'Button',
                type: 'button',
                isBranded: (el, s)=>!!(s.root && s.root.whitelabelBrand),
                '.isBranded': {
                    width: '100%',
                    round: 'radiusControl',
                    minHeight: 'controlH'
                },
                background: 'hover',
                color: 'paragraph',
                minHeight: 'controlHCompact',
                padding: '0 A2',
                round: 'radiusPill',
                fontSize: 'Z',
                text: '{{ auth.acceptInvite.haveAccount | polyglot }}',
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    el.router(s.loginPath || '/login', el.getRoot());
                }
            }
        },
        // Wrong-account beat — one action: switch accounts (sign out, then
        // back to sign-in with the invite as the return path).
        SwitchAccountButton: {
            extends: [
                'WhitelabelAccent',
                'Button'
            ],
            theme: 'primary',
            type: 'button',
            minHeight: 'controlH',
            padding: '0 B',
            round: 'radiusPill',
            fontSize: 'Z2',
            fontWeight: '700',
            text: '{{ auth.acceptInvite.switchAccount | polyglot }}',
            hide: (el, s)=>s.status !== 'mismatch',
            onClick: async (ev, el, s)=>{
                ev.preventDefault();
                try {
                    if (typeof el.sdk?.logout === 'function') await el.sdk.logout();
                } catch (_) {
                /* a failed sign-out still lands on /login, which can switch */ }
                el.router(s.loginPath || '/login', el.getRoot());
            }
        },
        CheckButton: {
            extends: [
                'WhitelabelAccent',
                'CheckButton'
            ],
            icon: null,
            type: 'button',
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2',
            fontWeight: '700',
            // Both labels were hardcoded English — the button every invitee presses
            // last read "Open workspace" in a Georgian session.
            text: (el, s)=>el.call('polyglot', s.status === 'error' ? 'auth.acceptInvite.goToWorkspace' : 'auth.acceptInvite.openWorkspace'),
            hide: (el, s)=>s.status !== 'success' && s.status !== 'error',
            onClick: (ev, el, s)=>{
                ev.preventDefault();
                if (typeof window === 'undefined') return;
                // Land on the SAME destination the success path computed — the
                // joined workspace, not the generic dashboard. Success state means
                // the in-place switch already ran (or its fallback reload is
                // queued); the error state still needs the fresh-boot recovery.
                const dest = s.dest || '/';
                if (s.status === 'success') el.router(dest, el.getRoot());
                else window.location.replace(dest);
            }
        }
    }
};

});
parcelRegister("lJuW8", function(module, exports) {

$parcel$export(module.exports, "authPageTheme", () => $fd25cc4eea2996f2$export$2d727730dab51f36);
const $fd25cc4eea2996f2$export$2d727730dab51f36 = {
    theme: 'document',
    background: 'gray15',
    '@dark': {
        background: 'gray1+6'
    },
    '@light': {
        background: 'gray15'
    },
    // White-label host (root.whitelabelBrand set — Nika 2026-10-14): the same
    // soft accent light behind the card as the branded sign-in, and its page
    // inset, so signup / reset / accept-invite sit in the same scene as login.
    // Inert on the platform: `style` answers an empty object and `.isBranded`
    // never applies. Inline `style` because the light is mixed from the tenant
    // accent, a record value with no design-system token
    // (functions/whitelabelAuthPaint.js).
    subscribeTo: [
        'whitelabelBrand'
    ],
    isBranded: (el, s)=>!!(s && s.root && s.root.whitelabelBrand),
    style: (el, s)=>{
        const paint = el.call('whitelabelAuthPaint', s);
        return paint ? {
            backgroundImage: paint.backdrop,
            backgroundRepeat: 'no-repeat'
        } : {};
    },
    '.isBranded': {
        padding: 'C A'
    }
};

});


parcelRegister("eTMEY", function(module, exports) {

$parcel$export(module.exports, "waitlistInvite", () => $ad8bf293dcdff4d0$export$3f120d3418f0d0f3);
// /waitlist-invite → /signup redirect. The server's waitlist emails link
// here (buildInviteUrl('waitlist-invite', token)); a waitlist invitee has
// no account by definition, so the right landing is the SIGNUP flow with
// the token preserved — signup.js already consumes `?token=` (seeds the
// email field and passes it to sdk.register as `inviteToken`, which the
// server exchanges for a trusted, pre-verified signup + waitlist-entry
// onboarding). Same tiny redirect-page convention as logs-redirect.

var $1sP0S = parcelRequire("1sP0S");

var $lJuW8 = parcelRequire("lJuW8");
const $ad8bf293dcdff4d0$export$3f120d3418f0d0f3 = {
    extends: 'Page',
    metadata: (el)=>({
            title: el.call('polyglot', 'auth.page.waitlistInvite.title')
        }),
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    height: '100dvh',
    maxWidth: 'none',
    ...(0, $lJuW8.authPageTheme),
    onCreate: (el)=>{
        if (typeof window === 'undefined') return;
        try {
            // Carry the WHOLE query through (token + any campaign params) via the
            // shared helper — tickets/sonnet.md "auth-page redirects still drop
            // the query": this used to hand-roll `+ search` itself, the one site
            // that already knew the query had to be carried while every other
            // auth redirect dropped it. Routed through `withLiveQuery` now so
            // there is exactly one mechanism for this, not two.
            el.router((0, $1sP0S.withLiveQuery)('/signup'), el.getRoot());
        } catch (err) {
            window.location.replace('/signup');
        }
    },
    Notice: {
        tag: 'span',
        fontSize: 'Y',
        color: 'caption',
        text: '{{ auth.waitlistInvite.opening | polyglot }}'
    }
};

});
parcelRegister("1sP0S", function(module, exports) {

$parcel$export(module.exports, "withLiveQuery", () => $110ffa1b2bab074d$export$40d5b7467a62dc5b);
$parcel$export(module.exports, "queryHashTail", () => $110ffa1b2bab074d$export$d47955cebdb9df5b);
// bootRedirectQuery.js — preserve the live query string + hash across a
// redirect that rebuilds its target from a bare path.
//
// tickets/sonnet.md "auth-page redirects still drop the query, and
// `?claim=credits` is exactly what they drop" — the router ticket
// (opus.md, DONE workspace 6d146d9a) fixed this same class at the shell
// boundary (packages/workspace/functions/bootRedirectQuery.js — THREE call
// sites: app.js's two `el.router(_withLiveQuery('/'), …)` bounces +
// demoRouteGuard.js's `queryHashTail(query, hash)` pre-mount guard) but
// never reached `packages/shared/pages/auth/*` — the auth pages' own
// post-login / post-signup / post-reset / post-invite redirects, all of
// which rebuild a bare target path (`el.router('/signup-confirmation', …)`,
// `el.router('/signin', …)`, etc.) that silently drops `window.location`'s
// query string the same way the shell's bounces used to.
//
// This is a SEPARATE file from packages/workspace/functions/
// bootRedirectQuery.js, not a cross-package import of it: `packages/shared`
// (published as `@symbo-ls/workspace-shared`) is consumed by every app —
// canvas, marketplace, chat, calendar, meet, documents, tickets — not just
// the workspace shell (see packages/canvas/pages/index.js importing these
// exact auth pages via the published package name). A relative import
// reaching OUT of packages/shared into packages/workspace would tie every
// consumer to workspace-shell-internal code it doesn't have, and even a
// same-repo deep subpath into `@symbo-ls/workspace-shared/functions/*` is
// documented as unsafe through the platform's importmap once this project
// is pushed as a library (see packages/workspace/app.js's "Bare
// shared-library import" note, tickets/execution-board.md §1) — so the
// canonical implementation lives once per package boundary, not once
// globally. Same algorithm, same acceptance shape, correct scope.
//
// Used by two shapes across the auth pages:
//   • `withLiveQuery(path)` — reads the OUTGOING (current) window location
//     and appends it to a redirect target rebuilt from a bare path
//     (signin.js's `next || '/'`, signup.js's `/signup-confirmation`,
//     reset-password.js's `/signin`, waitlist-invite.js's `/signup`).
//   • `queryHashTail(query, hash)` — for the one site that already has a
//     parsed query/hash pair in hand (accept-invite.js encodes `fullPath`
//     itself via `encodeURIComponent`, so it doesn't need this shape, but
//     the export exists for parity with the shell + any future call site
//     that receives a router-parsed query object instead of `window`).
const $110ffa1b2bab074d$export$40d5b7467a62dc5b = (path, win = typeof window !== 'undefined' ? window : null)=>{
    if (!win?.location) return path;
    return path + (win.location.search || '') + (win.location.hash || '');
};
const $110ffa1b2bab074d$export$d47955cebdb9df5b = (query, hash)=>{
    const qs = query && Object.keys(query).length ? '?' + new URLSearchParams(query).toString() : '';
    return qs + (hash || '');
};

});


parcelRegister("lnteu", function(module, exports) {

$parcel$export(module.exports, "addBranchModal", () => $f9026bf004dad203$export$918926c95ec2d3d3);
const $f9026bf004dad203$export$918926c95ec2d3d3 = {
    extend: 'ModalWindow',
    props: {
        width: '100%',
        maxWidth: 'I'
    },
    tag: 'form',
    state: {
        branch: ''
    },
    ModalHeader: {
        title: 'Add new branch',
        p: 'Add custom canvas pages to manage your components in isolation'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A C1 C1',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'B3',
        childProps: {
            width: '50%'
        },
        InputField: {
            Title: {
                text: '{{ editor.addBranch.name | polyglot }}'
            },
            Input: {
                value: '{{ branch }}',
                required: true,
                placeholder: (el)=>el.call('polyglot', 'editor.addBranch.namePlaceholder'),
                onInput: (ev, el, s)=>{
                    const { node: node } = el;
                    const { value: value } = node;
                    const start = node.selectionStart;
                    const end = node.selectionEnd;
                    const allowedCharacters = /[^a-zA-Z0-9_\-/]/gu;
                    const cleanedValue = value.replace(allowedCharacters, '');
                    if (value !== cleanedValue) {
                        el.node.value = cleanedValue;
                        node.setSelectionRange(start, end);
                    }
                    s.branch = cleanedValue;
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            text: '{{ common.action.save | polyglot }}'
        }
    },
    on: {
        submit: async (e, el, s, ctx)=>{
            e.preventDefault();
            if (!s.branch) return;
            const res = await el.sdk.createBranch(s.branch);
            if (res.version) {
                await el.call('setActiveBranch', s.branch);
                await el.call('closeRouterModal');
            } else el.call('openNotification', {
                title: el.call('polyglot', 'editor.addComponent.error.title'),
                message: el.call('polyglot', 'editor.addBranch.createFailed').replace('{branch}', s.branch),
                type: 'error'
            });
        }
    }
};

});

parcelRegister("5DlCK", function(module, exports) {

$parcel$export(module.exports, "addCanvasModal", () => $41a15e53aced546e$export$800f196c1060945f);
const $41a15e53aced546e$export$800f196c1060945f = {
    extend: 'ModalWindow',
    props: {
        width: '100%',
        maxWidth: 'I',
        onSubmit: async (e, el, s)=>{
            e.preventDefault();
            await el.call('addCanvasPage', s);
            await el.call('closeRouterModal');
        }
    },
    tag: 'form',
    state: {
        title: '',
        freeform: true
    },
    ModalHeader: {
        title: 'Add new canvas',
        p: 'Add custom canvas pages to manage your components in isolation'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A C1 C1',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'B3',
        childProps: {
            width: '50%'
        },
        InputField: {
            Title: {
                text: '{{ editor.addCanvas.title | polyglot }}'
            },
            Input: {
                value: '{{ title }}',
                required: true,
                placeholder: (el)=>el.call('polyglot', 'editor.addCanvas.titlePlaceholder'),
                onKeyup: (e, el, s)=>s.update({
                        title: el.node.value
                    })
            }
        },
        Group: {
            margin: 'A - -',
            Title: {
                text: '{{ editor.addCanvas.freeform | polyglot }}'
            },
            SwitchFieldWithCaption: {
                width: 'max-content',
                align: 'start start',
                onChange: (ev, el, s)=>{
                    s.toggle('freeform');
                },
                Input: {
                    checked: ({ state: state })=>!state.freeform
                },
                SwitchField: {},
                Caption: {
                    padding: '0',
                    opacity: '.65',
                    color: 'gray7',
                    text: '{{ editor.addCanvas.gravity | polyglot }}'
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            text: '{{ common.action.save | polyglot }}'
        }
    }
};

});

parcelRegister("hFpke", function(module, exports) {

$parcel$export(module.exports, "addCaseModal", () => $cdc9e915b330acaa$export$8bd54be5d505574d);
const $cdc9e915b330acaa$export$8bd54be5d505574d = {
    extend: 'ModalWindow',
    props: {
        width: '100%',
        maxWidth: 'I3'
    },
    tag: 'form',
    state: {
        key: '',
        value: ()=>{
        // Do nothing
        }
    },
    ModalHeader: {
        title: 'Add a case',
        p: 'Add case and use it across component properties'
    },
    Flex: {
        padding: 'A C3 0',
        minHeight: 'G2',
        flow: 'column',
        gap: 'B3',
        width: '100%',
        'InputField.key': {
            maxWidth: '50%',
            Title: {
                text: '{{ editor.addComponent.key | polyglot }}'
            },
            Input: {
                value: '{{ key }}',
                required: true,
                placeholder: 'isSafari',
                onkeydown: (ev)=>{
                    // prevent space
                    if (ev.keyCode === 32) ev.preventDefault();
                },
                onKeyup: (e, el, s)=>{
                    const val = el.node.value;
                    s.update({
                        key: val
                    });
                }
            }
        },
        'Group.code': {
            minWidth: '100%',
            Title: {
                text: '{{ editor.addCase.value | polyglot }}'
            },
            CodePreviewWidget: {
                props: (el, s)=>({
                        minWidth: '100%',
                        widthRange: null,
                        theme: 'field-static',
                        round: 'X2',
                        padding: 'X2 X2 X2 -',
                        minHeight: 'G1',
                        Monaco: {
                            foldLevel: false,
                            opacity: 1,
                            debounceDuration: 0,
                            fileTab: {
                                code: el.call('isString', s.value) ? s.value : el.stringifyCode(s.value) || 'export default {}',
                                type: 'javascript',
                                filename: 'case.js',
                                fileTabKey: 'function'
                            },
                            onCodeEditCallback: async (editor)=>{
                                const value = await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue());
                                s.value = value;
                            }
                        }
                    })
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}'
        }
    },
    on: {
        init: (el, s)=>{
            const key = el.call('getLastLocationPath').slice(1);
            const value = el.getDesignSystem('cases')?.[key];
            if (!value || !key) return;
            s.update({
                value: value,
                key: key
            }, {
                overwrite: true,
                preventUpdate: true
            });
        },
        submit: async (e, el, s, ctx)=>{
            e.preventDefault();
            const key = s.key || {};
            const { value: value } = s;
            const t = setTimeout(async ()=>{
                await el.updateDesignSystem(`cases.${key}`, value);
                clearTimeout(t);
            }, 75);
            await el.call('closeRouterModal');
        }
    }
};

});

parcelRegister("hWmCC", function(module, exports) {

$parcel$export(module.exports, "addCnameModal", () => $d0f966b0f6129f73$export$43ad3cd7c44194c8);
const $d0f966b0f6129f73$export$43ad3cd7c44194c8 = {
    extend: [
        'ModalWindow',
        'Form'
    ],
    props: {
        width: '100%',
        maxWidth: 'I'
    },
    tag: 'form',
    state: {
        cname: '',
        validationMessage: ''
    },
    ModalHeader: {
        title: 'Go to your DNS manager'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'B3',
        childProps: {
            width: '50%'
        },
        InputField: {
            Title: {
                text: '{{ publish.dns.cname | polyglot }}'
            },
            Input: {
                value: '{{ cname }}',
                required: true,
                placeholder: 'eg. test.com or www.test.com or sub.test.com',
                onInput: (ev, el, st)=>{
                    const { node: node } = el;
                    const { value: value } = node;
                    const regex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/gu;
                    if (!regex.test(value)) {
                        st.replace({
                            cname: null,
                            validationMessage: 'Invalid cname'
                        });
                        return;
                    }
                    st.update({
                        validationMessage: '',
                        cname: value
                    });
                }
            },
            Label: {
                show: (ev, st)=>st.validationMessage,
                color: 'red',
                text: (ev, st)=>st.validationMessage
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            text: '{{ common.action.save | polyglot }}',
            ':hover': {
                cursor: 'pointer'
            }
        }
    },
    onSubmit: async (e, el, st, ctx)=>{
        e.preventDefault();
        if (!st.cname) return;
        const urlParams = new URLSearchParams(ctx.window.location.search);
        const type = urlParams.get('type');
        const domainName = urlParams.get('domainName');
        if (!type || !domainName) return;
        const { root: root } = st;
        if (root && root.domains && root.domains[type]) {
            if (root.domains[type].cname === st.cname) {
                st.replace({
                    validationMessage: `CNAME with this name is already added for '${type}' environment`
                });
                return;
            }
        }
    }
};

});

parcelRegister("8lWcZ", function(module, exports) {

$parcel$export(module.exports, "addColorModal", () => $0191c3de9d9540d2$export$b5d5ca8d433ce75c);


const $0191c3de9d9540d2$export$b5d5ca8d433ce75c = {
    extend: 'ModalWindow',
    tag: 'form',
    ModalHeader: {
        title: 'Add color',
        p: 'Select the color of your theme, give a name and type the specific code.'
    },
    Flex: {
        gap: 'C1',
        padding: 'Z2 -',
        ColorPreview: {
            minWidth: 'auto',
            minHeight: 'auto',
            aspectRatio: '1 / 1',
            margin: '-W',
            flex: 3.5
        },
        Fields: {
            flex: 5,
            flexFlow: 'y',
            gap: 'B1',
            ColorPickerWithTitle: {
                Title: {
                    text: '{{ editor.addColor.code | polyglot }}'
                },
                ColorPicker: {
                    Input: {
                        placeholder: '#123',
                        onInput: async (ev, el, s, ctx)=>{
                            const isEditing = window.location.pathname.includes('edit-color');
                            if (s.changedByInput && s.key || isEditing) return;
                            const value = ev.target.value;
                            // nameTheColor's ~42 KB color table stays out of the eager
                            // bundle — loaded on demand (bundle-split T2)
                            const { nameTheColor: nameTheColor } = await (parcelRequire("437II"));
                            const key = ctx.utils.toCamelCase(nameTheColor.name(value)[1]);
                            s.update({
                                value: value,
                                key: key
                            });
                        }
                    },
                    Value: {
                        ColorTemplate: {},
                        Text: {
                            text: '{{ value }}'
                        }
                    }
                }
            },
            // The shared field kit (components/AppField.js): caption label above
            // the control, the brand `field` fill with the hairline edge.
            AppField: {
                label: (el)=>el.call('polyglot', 'editor.addColor.name'),
                AppInput: {
                    placeholder: 'PinkPanther',
                    value: '{{ key }}',
                    onInput: (e, el, s)=>{
                        s.update({
                            changedByInput: true,
                            key: el.node.value
                        });
                    }
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            icon: 'plus',
            text: '{{ common.action.add | polyglot }}'
        }
    },
    props: {
        onInit: async (el, s, ctx)=>{
            if (!el.getDesignSystem()) return;
            const lastPath = el.call('getLastLocationPath');
            const value = window.location.hash;
            let key;
            if (value) {
                // lazy — see onInput above (bundle-split T2)
                const { nameTheColor: nameTheColor } = await (parcelRequire("437II"));
                key = el.call('toCamelCase', nameTheColor.name(value)[1]);
            } else key = lastPath !== '/add-color' && lastPath.slice(1);
            s.quietUpdate({
                key: key,
                value: value
            });
        },
        onSubmit: (e, el, s, ctx)=>{
            e.preventDefault();
            const { key: key, value: value } = s;
            if (!key || !value) return;
            ctx.utils.closeModal(el, s, ctx);
            const t = setTimeout(()=>{
                el.updateDesignSystem({
                    color: {
                        [key]: value
                    }
                });
                clearTimeout(t);
            }, 75);
        }
    }
};

});
parcelRegister("437II", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("aubdj"))) : import("aubdj")).then(()=>parcelRequire('aA28K'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("87eDF", function(module, exports) {

$parcel$export(module.exports, "addComponentModal", () => $5e8a5528e680022c$export$c00f66ff66a480c3);
const $5e8a5528e680022c$export$c00f66ff66a480c3 = {
    extend: 'ModalWindow',
    props: {
        overflow: 'hidden',
        width: '100%',
        maxWidth: 'I3',
        onSubmit: async (e, el, s, ctx)=>{
            e.preventDefault();
            const obj = s.parse();
            const { type: type, key: key } = obj;
            if (!key) {
                el.call('openNotification', {
                    title: el.call('polyglot', 'editor.addComponent.validation.title'),
                    message: el.call('polyglot', 'editor.addComponent.keyRequired'),
                    type: 'warning'
                });
                return;
            }
            const exists = el.getDataItem(key, type) || el.getSchemaItem(key, type);
            if (exists) {
                el.call('openNotification', {
                    title: el.call('polyglot', 'editor.addComponent.exists.title').replace('{kind}', el.getSingular(s.type)),
                    message: el.call('polyglot', 'editor.addComponent.exists.message').replace('{key}', s.key).replace('{kind}', el.getSingular(s.type)),
                    type: 'error'
                });
                return;
            }
            const res = await el.call('createItem', s.type, s.key, obj);
            if (res?.success) el.call('closeRouterModal');
            else el.call('openNotification', {
                title: el.call('polyglot', 'editor.addComponent.error.title'),
                message: el.call('polyglot', 'editor.addComponent.error.message').replace('{type}', s.type).replace('{title}', s.title),
                type: 'error'
            });
        }
    },
    tag: 'form',
    state: {
        type: 'components',
        key: '',
        value: {},
        title: '',
        description: '',
        category: '',
        code: '',
        tags: [],
        state: '',
        props: {},
        settings: {
            gridOptions: {
                w: 2,
                h: 1
            }
        },
        interactivity: [],
        dataTypes: []
    },
    ModalHeader: {
        title: 'Add a new component',
        p: 'Fill initial settings and choose a template'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A C3 0',
        minHeight: 'G3',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'C1',
        'Flex.info': {
            width: '100%',
            flow: 'column',
            gap: 'B3',
            childProps: {
                width: '50%'
            },
            // The shared field kit (components/AppField.js): the caption label
            // above the control, the brand `field` fill with the hairline edge.
            // edit-component-modal.js extends this page and disables this field
            // BY KEY (`'AppField.key'` → `AppInput: { disabled }`), so the two
            // pages move together.
            'AppField.key': {
                label: (el)=>el.call('polyglot', 'editor.addComponent.key'),
                AppInput: {
                    required: true,
                    value: '{{ key }}',
                    placeholder: 'CardSidebar',
                    onKeydown: (e, el)=>{
                        const val = el.node.value;
                        const preventChars = el.call('stringIncludesAny', val, [
                            '&',
                            '*',
                            '-',
                            ':',
                            '@',
                            '.',
                            '/',
                            '!',
                            ' '
                        ]);
                        if (preventChars) {
                            e.preventDefault();
                            return false;
                        }
                        return true;
                    },
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        s.update({
                            touched: true,
                            key: val.replace(/[^a-zA-Z]/gu, '')
                        });
                    }
                }
            },
            'GroupField.draft': {
                margin: 'A - -',
                align: 'start',
                Title: {
                    text: '{{ editor.addComponent.isDraft | polyglot }}'
                },
                SwitchFieldWithCaption: {
                    align: 'start start',
                    onChange: (ev, el, s)=>{
                        s.update({
                            draft: !s.draft
                        });
                    },
                    Input: {
                        checked: ({ state: state })=>state.draft
                    },
                    SwitchField: {},
                    Caption: {
                        padding: '0',
                        opacity: '.65',
                        color: 'gray7',
                        text: '{{ editor.addComponent.draft | polyglot }}'
                    }
                }
            }
        },
        'Button.showAdvanced': {
            margin: '- -Z2',
            gap: 'X',
            background: 'transparent',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            theme: 'common-card-outline-interactive',
            icon: (el, s)=>`arrow angle ${s.advanced ? 'up' : 'down'}`,
            text: (el, s)=>el.call('polyglot', s.advanced ? 'editor.advanced.hide' : 'editor.advanced.show'),
            onClick: (ev, el, s)=>s.update({
                    advanced: !s.advanced
                })
        },
        'Flex.advanced': {
            hide: ({ state: state })=>!state.advanced,
            flow: 'column',
            align: 'flex-start space-between',
            gap: 'C1',
            width: '100%',
            // The text fields here are the shared field kit (components/AppField.js):
            // the caption label above the control, the brand `field` fill with the
            // hairline edge. The controls carry behaviour only.
            'AppField.title': {
                label: (el)=>el.call('polyglot', 'editor.addComponent.title'),
                AppInput: {
                    value: '{{ title }}',
                    placeholder: 'Card with Sidebar',
                    autofocus: true,
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        const canApplyKey = !s.touched && window.location.pathname.includes('/add-component');
                        const obj = {
                            title: val
                        };
                        if (canApplyKey) obj.key = el.call('toTitleCase', val).replace(/[^a-zA-Z]/gu, '');
                        s.update(obj);
                    }
                }
            },
            'GroupField.value': {
                minWidth: '100%',
                Title: {
                    text: '{{ editor.addComponent.initialCode | polyglot }}'
                },
                CodePreviewWidget: {
                    props: (el, s)=>({
                            minWidth: '100%',
                            widthRange: null,
                            theme: 'field-static',
                            round: 'X2',
                            padding: 'X2 X2 X2 -',
                            minHeight: 'G1',
                            Monaco: {
                                foldLevel: false,
                                opacity: 1,
                                fileTab: {
                                    code: s.code ? el.call('decodeNewlines', s.code) : s.value ? el.stringifyCode(s.value) : 'export default {}',
                                    type: 'javascript',
                                    filename: 'value.js',
                                    fileTabKey: 'value'
                                },
                                onCodeEditCallback: async (editor)=>{
                                    const code = editor.getValue();
                                    const value = await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ code);
                                    s.quietReplace({
                                        code: el.call('encodeNewlines', code),
                                        value: value
                                    });
                                }
                            }
                        })
                }
            },
            'AppField.description': {
                width: '100%',
                label: (el)=>el.call('polyglot', 'editor.addComponent.description'),
                AppTextarea: {
                    placeholder: (el)=>el.call('polyglot', 'editor.addComponent.descriptionPlaceholder'),
                    text: '{{ description }}',
                    onKeyup: (e, el, s)=>{
                        s.update({
                            description: el.node.value
                        });
                    }
                }
            },
            // The comma hint is the kit's `hint` line, under the control.
            'AppField.tags': {
                width: '50%',
                label: (el)=>el.call('polyglot', 'editor.addComponent.tags'),
                hint: (el)=>el.call('polyglot', 'editor.addComponent.tagsHint'),
                AppInput: {
                    placeholder: 'Landing, Survey',
                    value: (el, s)=>el.call('isArray', s.tags) ? s.tags.join(', ') : s,
                    onKeyup: (e, el, s)=>{
                        s.tags = el.node.value.split(',').map((v)=>v.trim());
                        s.update({
                            tags: s.tags
                        });
                    }
                }
            },
            'AppField.figmaUrl': {
                width: '50%',
                label: (el)=>el.call('polyglot', 'editor.addComponent.figmaUrl'),
                AppInput: {
                    value: '{{ figmaUrl }}',
                    placeholder: 'https://figma.com/...',
                    onChange: (e, el, s)=>{
                        const { value: value } = el.node;
                        s.update({
                            figmaUrl: value
                        });
                    }
                }
            },
            'AppField.stateStr': {
                if: (el, s, ctx)=>s.stateStr || s.state && ctx.utils.isString(s.state),
                width: '50%',
                label: (el)=>el.call('polyglot', 'editor.addComponent.statePath'),
                AppInput: {
                    placeholder: 'about/team',
                    value: (el, s)=>s.state,
                    onKeyup: (e, el, s)=>s.update({
                            state: el.node.value
                        })
                }
            },
            'Group.state': {
                if: (el, s, ctx)=>!s.stateStr || !s.state || s.state && !ctx.utils.isString(s.state),
                props: {
                    minWidth: '100%'
                },
                Title: {
                    text: '{{ editor.addComponent.mockupState | polyglot }}'
                },
                CodePreviewWidget: {
                    props: (el, s)=>({
                            minWidth: '100%',
                            widthRange: null,
                            theme: 'field-static',
                            round: 'X2',
                            padding: 'X2 X2 X2 -',
                            minHeight: 'G1',
                            Monaco: {
                                foldLevel: false,
                                opacity: 1,
                                fileTab: {
                                    code: s.state ? el.stringifyCode(s.state, el, s) : 'export default {}',
                                    type: 'javascript',
                                    filename: 'state.js',
                                    fileTabKey: 'state'
                                },
                                onCodeEditCallback: async (editor)=>{
                                    const state = await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue());
                                    s.quietReplace({
                                        state: state
                                    });
                                }
                            }
                        })
                }
            },
            'SurveyIconicOptions.interactivity': {
                multiple: true,
                width: '100%',
                lowercase: true,
                margin: '0',
                Title: {
                    text: '{{ editor.addComponent.interactivityTypes | polyglot }}'
                },
                options: {
                    'Option.Hover': {
                        icon: 'hover outline'
                    },
                    'Option.Click': {
                        icon: 'click outline'
                    },
                    'Option.Choose': {
                        icon: 'choose outline'
                    },
                    'Option.Drag': {
                        icon: 'drag outline'
                    },
                    'Option.Input': {
                        icon: 'input outline'
                    },
                    'Option.Focus': {
                        icon: 'focus outline'
                    },
                    Other: null
                }
            },
            'SurveyIconicOptions.dataTypes': {
                multiple: true,
                width: '100%',
                lowercase: true,
                margin: '0',
                Title: {
                    text: '{{ editor.addComponent.valueTypes | polyglot }}'
                },
                options: {
                    'Option.Boolean': {
                        icon: 'boolean outline'
                    },
                    'Option.Int': {
                        icon: 'int outline'
                    },
                    'Option.String': {
                        icon: 'string outline'
                    },
                    'Option.Object': {
                        icon: 'object outline'
                    },
                    'Option.Array': {
                        icon: 'array outline'
                    },
                    'Option.Date': {
                        icon: 'date outline'
                    },
                    Other: null
                }
            },
            'Group.props': {
                props: {
                    minWidth: '100%'
                },
                Title: {
                    text: '{{ editor.addComponent.frameProperties | polyglot }}'
                },
                CodePreviewWidget: {
                    minWidth: '100%',
                    widthRange: null,
                    theme: 'field-static',
                    round: 'X2',
                    padding: 'X2 X2 X2 -',
                    minHeight: 'G1',
                    props: (el, s)=>({
                            Monaco: {
                                foldLevel: false,
                                opacity: 1,
                                fileTab: {
                                    code: el.stringifyCode(s.props),
                                    type: 'javascript',
                                    filename: 'props.js',
                                    fileTabKey: 'props'
                                },
                                onCodeEditCallback: async (editor)=>{
                                    const props = await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue());
                                    if (props?.[s.key]) props.demoComponent = props[s.key];
                                    s.quietReplace({
                                        props: props
                                    });
                                }
                            }
                        })
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            icon: 'arrow right',
            text: '{{ common.action.next | polyglot }}'
        }
    }
};

});

parcelRegister("imLTG", function(module, exports) {

$parcel$export(module.exports, "addCustomDomainModal", () => $d5ef6f6f52992d36$export$fd55b42482cc5e2d);
const $d5ef6f6f52992d36$export$fd55b42482cc5e2d = {
    extend: [
        'ModalWindow',
        'Form'
    ],
    props: {
        width: '100%',
        maxWidth: 'I'
    },
    tag: 'form',
    state: {
        domainName: '',
        validationMessage: ''
    },
    ModalHeader: {
        title: 'Add custom domain',
        p: 'Add custom domain to manage your domain in isolation'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'B3',
        childProps: {
            width: '50%'
        },
        InputField: {
            Title: {
                text: '{{ publish.domains.name | polyglot }}'
            },
            Input: {
                value: '{{ domainName }}',
                required: true,
                placeholder: 'eg. test.com or www.test.com',
                onInput: (ev, el, st)=>{
                    const { node: node } = el;
                    const { value: value } = node;
                    const regex = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/gu;
                    if (!regex.test(value)) {
                        st.replace({
                            domainName: null,
                            validationMessage: 'Invalid domain name'
                        });
                        return;
                    }
                    st.update({
                        validationMessage: '',
                        domainName: value
                    });
                }
            },
            Label: {
                show: (ev, st)=>st.validationMessage,
                color: 'red',
                text: (ev, st)=>st.validationMessage
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            text: '{{ common.action.next | polyglot }}',
            icon: 'arrow right',
            ':hover': {
                cursor: 'pointer'
            }
        }
    },
    onSubmit: (e, el, st, ctx)=>{
        e.preventDefault();
        if (!st.domainName) return;
        const urlParams = new URLSearchParams(ctx.window.location.search);
        const type = urlParams.get('type');
        if (!type) return;
        const { root: root } = st;
        if (root && root.domains && root.domains[type]) {
            if (root.domains[type].domain === st.domainName) {
                st.replace({
                    validationMessage: `Domain with this name is already added for '${type}' environment`
                });
                return;
            }
        }
        el.router(ctx.window.location.pathname.replace('/add-domain', `/add-cname?type=${type}&domainName=${st.domainName}`), el.getRoot());
        ctx.window.location.reload();
    }
};

});

parcelRegister("dipGV", function(module, exports) {

$parcel$export(module.exports, "addDependencyModal", () => $9ae0e28db79bdeb4$export$551e61fe96fbcca3);
const $9ae0e28db79bdeb4$export$551e61fe96fbcca3 = {
    extends: 'ModalWindow',
    width: '100%',
    minHeight: 'G3',
    maxWidth: 'I',
    tag: 'form',
    state: {
        name: '',
        version: '',
        schemaVersion: 'latest',
        type: 'dependencies',
        packages: [],
        isLoadingPackages: false,
        error: '',
        disabled: false
    },
    ModalHeader: {
        title: 'Add dependency',
        p: 'Symbols will make cloud build for your NPM dependency'
    },
    LoadingGifSection: {
        fullscreen: true,
        position: 'absolute',
        inset: '0',
        hide: (el, s)=>!s.loading
    },
    Flex: {
        padding: 'A C3 0',
        flow: 'column',
        gap: 'B3',
        width: '70%',
        // The shared field kit (components/AppField.js): the caption label above
        // the control, the brand `field` fill with the hairline edge. The key
        // wiring moved WITH the fields: edit-dependency-modal.js extends this
        // page and overrides `'AppField.name'` BY KEY (a disabled `AppInput`, no
        // `Dropdown`), and the Dropdown's `onChoose` below reaches
        // `el.parent.AppInput` and `'AppField.schemaVersion'` → `.AppInput` by
        // key (add-dependency-modal.test.js, addModalsFieldKit.test.js).
        'AppField.name': {
            // An explicit base list turns the key's auto-extend off, so AppField
            // is named here beside the package search's DropdownParent.
            extends: [
                'AppField',
                'DropdownParent'
            ],
            ':focus-within': {
                zIndex: 1000,
                '& [dropdown]': {
                    transform: 'translate3d(0,0,0)',
                    opacity: 1,
                    visibility: 'visible'
                }
            },
            label: (el)=>el.call('polyglot', 'editor.addDependency.package'),
            AppInput: {
                required: true,
                value: '{{ name }}',
                placeholder: (el)=>el.call('polyglot', 'editor.addDependency.packagePlaceholder'),
                onInput: (ev, el, s)=>{
                    const name = el.node.value;
                    s.update({
                        name: name
                    });
                    if (name) {
                        s.update({
                            isLoadingPackages: true
                        });
                        if (name.length < 2) return;
                        const t = setTimeout(async ()=>{
                            await el.call('searchNpmPackages', name);
                            clearTimeout(t);
                        }, 1000);
                    } else s.replace({
                        packages: []
                    });
                }
            },
            Dropdown: {
                // The brand field's Group `childProps` gave the menu the field's
                // width; the kit field has no childProps, so the menu keeps it here.
                // `left` is a flat prop: an own prop beats the brand Dropdown's
                // `left: '50%'` at merge time (the `style: { left: 0 }` wrapper it
                // replaces relied on class order — FA108).
                width: '100%',
                left: '0',
                options: (el, s)=>s.packages,
                onChoose: (ev, el, s, _ctx, calleeElement)=>{
                    const { name: pkgName, version: pkgVersion } = calleeElement.state;
                    s.update({
                        name: pkgName,
                        version: pkgVersion,
                        schemaVersion: 'latest'
                    });
                    el.parent.AppInput.node.value = pkgName;
                    // LOOKUP-SHAPE-1: threw inline on a miss — guarded so choosing a
                    // package can't crash the modal if the version field isn't
                    // resolvable at this instant.
                    const schemaVersionInput = el.lookup('AppField.schemaVersion')?.AppInput;
                    if (schemaVersionInput?.node) schemaVersionInput.node.value = pkgVersion ? `^${pkgVersion}` : s.schemaVersion || 'latest';
                },
                DropdownHeader: {
                    if: (el, s)=>s.packages.length === 0 && s.name.length > 2,
                    text: '{{ editor.addDependency.noResults | polyglot }}'
                },
                ListInDropdown: {
                    childProps: {
                        isActive: (el, s)=>s.parent.name === s.name,
                        text: '{{ name }}',
                        fontWeight: '400',
                        Span: {
                            opacity: '0.5',
                            text: ' @{{ version }}'
                        }
                    }
                }
            }
        },
        'AppField.schemaVersion': {
            label: (el)=>el.call('polyglot', 'editor.addDependency.version'),
            AppInput: {
                required: true,
                placeholder: (el)=>el.call('polyglot', 'editor.addDependency.versionPlaceholder'),
                value: '{{ schemaVersion }}',
                onInput: (e, el, s)=>{
                    const schemaVersion = el.node.value;
                    s.update({
                        schemaVersion: schemaVersion
                    });
                    if (!s.name || s.name.length < 2) return;
                    const t = setTimeout(async ()=>{
                        await el.call('fetchNpmPackage', s.name, schemaVersion);
                        clearTimeout(t);
                    }, 1000);
                }
            },
            // The resolved version is the kit's hint line under the control (the
            // brand field showed it as a bare text row). Both factories read
            // state, so the line follows every resolve and takes no space while
            // there is no version.
            FieldHint: {
                text: (el, s)=>s.version || '',
                hide: (el, s)=>!s.version
            }
        },
        Error: {
            text: (el, s)=>s.error,
            color: 'red'
        }
    },
    ModalFooter: {
        margin: 'auto - -',
        CheckButton: {
            type: 'submit',
            reverse: true,
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}',
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2'
        }
    },
    onSubmit: async (e, el, s, ctx)=>{
        e.preventDefault();
        if (s.disabled) return;
        const { name: name, version: version } = s;
        await window.fetch(`https://pkg.symbo.ls/${name}@${version}`).then(async (res)=>{
            if (!res.ok) {
                s.update({
                    error: await res.text(),
                    disabled: false
                });
                return;
            }
            const [resolvedVersion] = res.url.substring(`https://pkg.symbo.ls/${name}@`.length).split('/');
            const value = s.version;
            const obj = {
                key: name,
                value: value,
                resolvedVersion: resolvedVersion,
                type: s.type,
                version: s.schemaVersion
            };
            const exists = el.getDependencies(name);
            const action = exists ? 'updateItem' : 'addItem';
            try {
                await el.sdk[action]('dependencies', obj, {
                    message: exists ? 'Updated dependency' : 'Added dependency'
                });
                await el.call('rerenderFileSidebarByType', 'dependencies');
                await el.call('closeRouterModal');
            } catch (err) {
                console.error(err);
                el.call('openNotification', {
                    type: 'error',
                    message: err.message
                });
            } finally{
                s.update({
                    loading: false,
                    disabled: false
                });
            }
        });
    }
};

});

parcelRegister("7q4g1", function(module, exports) {

$parcel$export(module.exports, "addFileModal", () => $566e438cf1b8a931$export$a82e76296ac62f0a);
const $566e438cf1b8a931$export$a82e76296ac62f0a = {
    extends: 'ModalWindow',
    tag: 'form',
    state: {
        key: '',
        type: 'files',
        code: '',
        content: {}
    },
    props: {
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const { content: content, key: key, code: code, type: type, format: format } = s;
            if (!key) {
                el.call('openNotification', {
                    title: el.call('polyglot', 'editor.addComponent.validation.title'),
                    message: el.call('polyglot', 'editor.addFile.keyRequired'),
                    type: 'warning'
                });
                return;
            }
            if (content?.src) content.src = content.src.replace('https://files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev/', 'https://files.symbo.ls/');
            const obj = {
                content: content,
                code: code,
                key: key,
                type: type,
                format: format
            };
            const exists = el.getFiles(key);
            const path = [
                'files',
                key
            ];
            el.sdk.updateData([
                [
                    'update',
                    path,
                    obj
                ]
            ], {
                message: exists ? `Updated ${key}` : `Created ${key}`
            });
            // TODO: use event instead of calling rerenderFileSidebarByType function
            await el.call('rerenderFileSidebarByType', 'files');
            await el.call('closeRouterModal');
            el.getCanvasContext().files[key] = obj;
        }
    },
    ModalHeader: {
        title: 'Add a new file',
        p: null
    },
    Flex: {
        overflow: 'auto',
        maxHeight: 'G3',
        boxSize: 'auto I',
        padding: '0 C 0',
        align: 'start',
        gap: 'B',
        flow: 'column',
        InputField: {
            hide: (el, s)=>!s.content?.src,
            width: '100%',
            Title: {
                fontSize: 'Z',
                text: '{{ editor.addFile.name | polyglot }}'
            },
            Input: {
                placeholder: 'new.html',
                value: '{{ key }}',
                onChange: (e, el, s)=>{
                    const val = el.node.value;
                    s.update({
                        key: val,
                        format: val.split('.').slice(-1)[0]
                    }, {
                        forceMonacoUpdate: true
                    });
                }
            }
        },
        UploadAvatar: {
            if: (el, s)=>s.type !== 'code',
            width: '100%',
            position: 'relative',
            Title: {
                fontSize: 'Z',
                text: '{{ editor.addFile.upload | polyglot }}'
            },
            UploadIcon: {
                margin: '0 -X2',
                minHeight: 'F3',
                flex: 1,
                Avatar: null,
                Input: {
                    onChange: async (ev, el, s)=>{
                        const [contents] = ev.target.files;
                        if (!contents) return;
                        await el.call('uploadFile', contents);
                    }
                },
                onDragenter: (ev, el)=>{
                    ev.preventDefault();
                    el.node.style.background = 'rgba(255, 255, 255, 0.1)';
                },
                onDragover: (ev, el)=>{
                    ev.preventDefault();
                    el.node.style.background = 'rgba(255, 255, 255, 0.1)';
                },
                onDragleave: (ev, el)=>{
                    ev.preventDefault();
                    el.node.style.background = 'rgba(255, 255, 255, 0.02)';
                },
                onDrop: async (ev, el, s)=>{
                    ev.preventDefault();
                    ev.stopPropagation();
                    el.node.style.background = 'rgba(255, 255, 255, 0.02)';
                    const { files: files } = ev.dataTransfer;
                    if (!files || !files.length) return;
                    await el.call('uploadFile', files[0]);
                }
            },
            ErrorMessage: {
                if: (el, s)=>s.errorMessage,
                color: 'red',
                fontSize: 'Z',
                text: (el, s)=>s.errorMessage
            },
            FilePreview: {
                if: (el, s)=>s.content?.src,
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate3d(-50%, -40%, 1px)',
                href: null
            }
        },
        PublicURL: {
            extends: 'CodePreviewWithTitle',
            minWidth: '100%',
            if: (el, s)=>s.content?.src,
            Title: {
                fontSize: 'Z',
                fontWeight: '400',
                text: '{{ editor.addFile.publicUrl | polyglot }}'
            },
            CodePreview: {
                padding: 'A A B2',
                theme: 'field-static',
                text: (el, s)=>s.content?.src
            },
            Buttons: {
                Copy: {
                    value: (el, s)=>s.content?.src
                },
                Link: {
                    href: (el, s)=>s.content?.src,
                    target: '_blank'
                }
            }
        },
        CodePreviewWithTitle: {
            minWidth: '100%',
            if: (el, s)=>s.content?.src,
            Title: {
                fontWeight: '400',
                text: '{{ editor.addFile.usingAsProperty | polyglot }}'
            },
            CodePreview: {
                padding: 'A A B2',
                theme: 'field-static',
                text: (el, s)=>`{
  Img: {
    src: '${s.content?.src}'
  }
}`
            },
            Buttons: {
                Copy: {
                    value: (el, s)=>`{
  Img: {
    src: '${s.content?.src}'
  }
}`
                },
                Link: null
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            text: '{{ common.action.add | polyglot }}'
        }
    }
};

});

parcelRegister("ltb7b", function(module, exports) {

$parcel$export(module.exports, "addFontFamilyModal", () => $fa14ed8fb70c410d$export$fea857e8c9058a02);
const $fa14ed8fb70c410d$export$fea857e8c9058a02 = {
    extends: 'ModalWindow',
    tag: 'form',
    state: {
        familyName: '',
        value: {
            type: 'serif',
            value: [
                'inherit'
            ]
        }
    },
    ModalHeader: {
        title: 'Font Family',
        p: 'Set up font-family and fonts ordering'
    },
    Flex: {
        props: {
            flexAlign: 'stretch center',
            gap: 'C',
            padding: '0 E 0 0'
        },
        Fields: {
            flexFlow: 'y',
            gap: 'B1',
            InputField: {
                Title: {
                    text: '{{ editor.addFontFamily.name | polyglot }}'
                },
                Input: {
                    placeholder: (el)=>el.call('polyglot', 'editor.addFontFamily.namePlaceholder'),
                    value: (el, s)=>s.familyName,
                    onKeyup: (e, el, s)=>{
                        s.update({
                            [el.parent.key]: el.node.value
                        });
                    },
                    onChange: (e, el, s)=>{
                        if (s.familyName) return;
                        const familyName = toCamelCase(s.familyName);
                        s.update({
                            familyName: familyName
                        });
                    }
                }
            },
            GroupField: {
                Title: {
                    text: '{{ editor.addFontFamily.type | polyglot }}'
                },
                DropdownField: {
                    Value: {
                        Text: {
                            text: (el, s)=>s.value && s.value.type || el.call('polyglot', 'editor.addFontFamily.allCategories')
                        }
                    }
                }
            }
        },
        Group: {
            state: 'value',
            padding: '0 0 0 B2',
            style: {
                borderLeft: '.06)'
            },
            Title: {
                text: '{{ editor.addFontFamily.ordering | polyglot }}'
            },
            Content: {
                Tools: {
                    flexFlow: 'y',
                    gap: 'A',
                    childExtends: 'OrderingItem',
                    children: (el, state)=>{
                        return Object.values(state.value);
                    },
                    childrenAs: 'state'
                },
                SquareButton: {
                    theme: 'quaternary',
                    icon: 'plus',
                    margin: 'A 0 B1 A1',
                    onClick: (ev, el, s)=>{
                        s.add('inherit');
                    }
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            text: '{{ common.action.okay | polyglot }}'
        }
    },
    on: {
        submit: (e, el, s)=>{
            e.preventDefault();
            const { value: value, familyName: familyName } = s;
            if (!familyName || !value) return;
            ctx.utils.closeModal(el, s, ctx);
            const t = setTimeout(()=>{
                el.updateDesignSystem({
                    fontFamily: {
                        [familyName]: value
                    }
                });
                clearTimeout(t);
            }, 75);
        }
    }
};

});

parcelRegister("lnHgR", function(module, exports) {

$parcel$export(module.exports, "addFunctionModal", () => $f90d4facaf7bf6f7$export$e409b61a2511abf4);
const $f90d4facaf7bf6f7$export$e409b61a2511abf4 = {
    extend: 'ModalWindow',
    props: {
        width: '100%',
        maxWidth: 'I3'
    },
    tag: 'form',
    state: {
        key: '',
        title: '',
        type: 'functions',
        value: ()=>{
        // Do nothing
        }
    },
    ModalHeader: {
        title: 'Add a new function'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A C3 0',
        minHeight: 'G3',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'C1',
        'Flex.info': {
            flow: 'column',
            gap: 'B3',
            width: '50%',
            // The shared field kit (components/AppField.js): the caption label
            // above the control, the brand `field` fill with the hairline edge.
            // edit-function-modal.js extends this page and overrides both fields
            // BY KEY (`'AppField.title': {}`, and `'AppField.key'` with a disabled
            // `AppInput`), so the two pages move together.
            'AppField.title': {
                label: (el)=>el.call('polyglot', 'editor.addFunction.title'),
                AppInput: {
                    value: '{{ title }}',
                    required: true,
                    placeholder: (el)=>el.call('polyglot', 'editor.addFunction.titlePlaceholder'),
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        const obj = {
                            title: val
                        };
                        const canApplyKey = !s.touched && window.location.pathname.includes('/add-function');
                        if (canApplyKey) obj.key = el.call('toCamelCase', val.toLowerCase()).replace(/[^a-zA-Z]/gu, '');
                        s.update(obj);
                    }
                }
            },
            'AppField.key': {
                label: (el)=>el.call('polyglot', 'editor.addComponent.key'),
                AppInput: {
                    value: '{{ key }}',
                    required: true,
                    placeholder: 'fetchExample',
                    onKeydown: (e, el)=>{
                        const val = el.node.value;
                        const NOT_ALLOWED = [
                            '&',
                            '*',
                            '-',
                            ':',
                            '@',
                            '.',
                            '/',
                            '!',
                            ' '
                        ];
                        const preventChars = el.call('stringIncludesAny', val, NOT_ALLOWED);
                        if (preventChars) e.preventDefault();
                    },
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        s.update({
                            touched: true,
                            key: val.replace(/[^a-zA-Z]/gu, '')
                        });
                    }
                }
            }
        },
        'Group.code': {
            minWidth: '100%',
            Title: {
                text: '{{ editor.addFunction.code | polyglot }}'
            },
            CodePreviewWidget: {
                props: (el, s)=>({
                        minWidth: '100%',
                        widthRange: null,
                        theme: 'field-static',
                        round: 'X2',
                        padding: 'X2 X2 X2 -',
                        minHeight: 'G1',
                        Monaco: {
                            foldLevel: false,
                            opacity: 1,
                            fileTab: {
                                code: el.call('stringifyCode', s.value),
                                type: 'javascript',
                                filename: 'function.js',
                                fileTabKey: 'function'
                            },
                            onCodeEditCallback: async (editor)=>{
                                s.quietReplace({
                                    value: await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue())
                                });
                            }
                        }
                    })
            }
        },
        'Button.showAdvanced': {
            margin: '- -Z2',
            gap: 'X',
            background: 'transparent',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            theme: 'common-card-outline-interactive',
            icon: (el, s)=>`arrow angle ${s.advanced ? 'up' : 'down'}`,
            text: (el, s)=>el.call('polyglot', s.advanced ? 'editor.advanced.hide' : 'editor.advanced.show'),
            onClick: (ev, el, s)=>s.update({
                    advanced: !s.advanced
                })
        },
        'Flex.advanced': {
            hide: ({ state: state })=>!state.advanced,
            flow: 'column',
            align: 'flex-start space-between',
            gap: 'C1',
            width: '100%',
            // The shared field kit (components/AppField.js): the caption label
            // above the control, the brand `field` fill with the hairline edge.
            'AppField.description': {
                width: '100%',
                label: (el)=>el.call('polyglot', 'editor.addComponent.description'),
                AppTextarea: {
                    value: (el, s)=>s[el.key.split('.')[1]],
                    placeholder: (el)=>el.call('polyglot', 'editor.addFunction.descriptionPlaceholder'),
                    onKeyup: (e, el, s)=>{
                        s.update({
                            description: el.node.value
                        });
                    }
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            icon: 'arrow right',
            text: '{{ common.action.next | polyglot }}'
        }
    },
    onSubmit: async (e, el, s)=>{
        e.preventDefault();
        const exists = el.getFunctions(s.key);
        try {
            if (s.value) try {
                const res = exists ? await el.call('updateItem', s.type, s.key, s) : await el.call('createItem', s.type, s.key);
                if (res?.success) await el.call('closeRouterModal');
                else el.call('openNotification', {
                    title: el.call('polyglot', 'editor.addComponent.error.title'),
                    message: el.call('polyglot', 'editor.addFunction.createFailed').replace('{key}', s.key),
                    type: 'error'
                });
            } catch (err) {
                console.log(`in addFunctionModal catch`, err.message);
                el.call('openNotification', {
                    title: el.call('polyglot', 'editor.addComponent.error.title'),
                    message: el.call('polyglot', 'editor.addFunction.createFailed').replace('{key}', s.key),
                    type: 'error'
                });
            }
        } catch (err) {
            console.log(`in addFunctionModal catch`, err.message);
            el.call('openNotification', {
                title: el.call('polyglot', 'editor.addComponent.error.title'),
                message: el.call('polyglot', 'editor.addFunction.codeError'),
                type: 'error'
            });
        }
    }
};

});

parcelRegister("2O447", function(module, exports) {

$parcel$export(module.exports, "addGlobalThemeModal", () => $20b36799635603c9$export$14d807bee9d45658);
const $20b36799635603c9$export$14d807bee9d45658 = {
    extends: 'ModalWindow',
    tag: 'form',
    state: {
        value: {}
    },
    props: {
        onSubmit: async (e, el, s, ctx)=>{
            e.preventDefault();
            const { value: value, themeModifier: themeModifier } = s;
            if (!themeModifier || !value) return;
            const modifierName = themeModifier.slice(0, 1) === '@' ? themeModifier : `@${themeModifier}`;
            await el.call('closeRouterModal');
            const t = setTimeout(async ()=>{
                await el.updateDesignSystem({
                    theme: {
                        document: {
                            [modifierName]: value
                        }
                    }
                });
                clearTimeout(t);
            }, 75);
        }
    },
    ModalHeader: {
        title: 'Add global theme',
        p: 'Adding new <body> styling theme'
    },
    Preview: {
        props: (el, s)=>{
            const { color: color, background: background } = s.value;
            return {
                color: el.call('getColorValue', color),
                background: el.call('getColorValue', background),
                margin: '0 -A2',
                minHeight: 'B2',
                textAlign: 'center',
                round: 'V',
                padding: 'B C'
            };
        },
        H5: (el)=>el.getRootState().sampleText
    },
    Flex_fields: {
        padding: 'A C3 0',
        if: (el, s)=>s.themeModifier !== '@light' && s.themeModifier !== '@dark',
        InputField: {
            Title: {
                text: '{{ editor.addGlobalTheme.name | polyglot }}'
            },
            Input: {
                placeholder: (el)=>el.call('polyglot', 'editor.addGlobalTheme.namePlaceholder'),
                value: '{{ themeModifier }}',
                onKeyup: (e, el, s)=>{
                    s.update({
                        themeModifier: el.node.value
                    });
                }
            }
        }
    },
    Flex: {
        gap: 'A',
        padding: '0 C3 C1',
        align: 'center flex-start',
        childExtends: 'ColorSelectWithTitle',
        childProps: {
            width: '100%',
            ColorSelect: {
                props: (el, s)=>{
                    const { color: color } = el.getDesignSystem();
                    if (!color || !s.value) return null;
                    const key = s.value[el.parent.key];
                    const obj = {
                        property: el.parent.key,
                        Value: {
                            Box: {
                                background: key || 'transparentBg',
                                backgroundSize: '6px 6px'
                            },
                            Text: {
                                text: key || 'inherit'
                            }
                        },
                        Dropdown: {
                            maxHeight: 'G'
                        }
                    };
                    if (!key) return obj;
                    const value = el.call('getColorValue', key);
                    obj.title.box.background = value || key || 'transparentBg';
                    return obj;
                },
                Dropdown: {
                    onChoose: (ev, el, s, ctx, calleeElement)=>{
                        const { key: key } = el.parent.parent;
                        const value = {
                            [key]: calleeElement.state.key
                        };
                        s.update({
                            value: value
                        });
                    }
                }
            }
        },
        Background: {
            Title: {
                text: '{{ editor.addGlobalTheme.background | polyglot }}'
            },
            ColorSelect: {}
        },
        Color: {
            Title: {
                text: '{{ editor.addGlobalTheme.textColor | polyglot }}'
            },
            ColorSelect: {}
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            text: '{{ common.action.save | polyglot }}'
        }
    }
};

});

parcelRegister("1H7rU", function(module, exports) {

$parcel$export(module.exports, "addIconModal", () => $13bf95dbd9bc42c5$export$271b2bf8067c5a15);
const $13bf95dbd9bc42c5$export$271b2bf8067c5a15 = {
    extends: 'ModalWindow',
    tag: 'form',
    ModalHeader: {
        title: 'Icon Preview',
        p: 'Upload icons in SVG format'
    },
    Flex: {
        align: 'start space-between',
        gap: 'C1',
        padding: '0 C3 0 0',
        IconPreview: {
            display: 'flex',
            minWidth: 'F2+Z',
            flex: 3.5,
            color: 'gray10',
            position: 'relative',
            aspectRatio: '1/1',
            Svg: {
                position: 'absolute',
                boxSize: '100%',
                src: '<svg xmlns="http://www.w3.org/2000/svg" width="197" height="197" viewBox="0 0 197 197"><g fill="none" fill-rule="evenodd" stroke="#525474" stroke-width=".1" transform="translate(.5 .5)"><path d="M98,196.000245 L98,196.000245 C43.87705,196.000245 0,152.123195 0,98.000245 C0,43.874845 43.87705,0.000244999999 98,0.000244999999 C152.12295,0.000244999999 196,43.874845 196,98.000245 C196,152.123195 152.12295,196.000245 98,196.000245 Z"/><polygon points="9.8 186.2 186.2 186.2 186.2 9.8 9.8 9.8"/><polygon points="19.6 196 176.4 196 176.4 0 19.6 0"/><polygon points="0 176.4 196 176.4 196 19.6 0 19.6"/></g></svg>'
            },
            Svg_2: {
                position: 'absolute',
                boxSize: '100%',
                fontSize: '12.5em',
                src: (el, s)=>s.src,
                '@light': {
                    style: {
                        fill: 'var(--color-caption-light)'
                    }
                },
                '@dark': {
                    style: {
                        fill: 'var(--color-caption-dark)'
                    }
                }
            }
        },
        Flex: {
            flex: 5,
            flexFlow: 'y',
            gap: 'A2',
            InputField: {
                Title: {
                    text: '{{ editor.addIcon.name | polyglot }}'
                },
                Input: {
                    placeholder: 'Eg: Arrow Right',
                    value: '{{ iconName }}'
                }
            },
            UploadAvatar: {
                Title: {
                    text: '{{ editor.addIcon.upload | polyglot }}'
                },
                UploadIcon: {
                    flow: 'x',
                    whiteSpace: 'nowrap',
                    gap: 'A',
                    padding: 'A A2',
                    P: {
                        text: null,
                        Span: {
                            text: '{{ editor.addIcon.uploadHint | polyglot }}'
                        }
                    },
                    Input: {
                        onChange: (evt, el, s)=>{
                            // Retrieve the first (and only!) File from the FileList object
                            var file = evt.target.files[0];
                            console.log(file);
                            if (file) {
                                var reader = new window.FileReader();
                                reader.onload = function(e) {
                                    var contents = e.target.result;
                                    const fileName = file.name.split('.svg')[0];
                                    console.log(fileName);
                                    console.log(contents);
                                    s.update({
                                        src: contents,
                                        iconName: el.call('toCamelCase', fileName).replaceAll('-', '')
                                    });
                                };
                                reader.readAsText(file);
                            }
                        }
                    }
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            text: '{{ common.action.save | polyglot }}'
        }
    },
    props: {
        onSubmit: (e, el, s)=>{
            e.preventDefault();
            const { iconName: iconName, src: src } = s;
            if (!iconName || !src) return;
            el.call('closeRouterModal', el, s);
            const t = setTimeout(()=>{
                el.updateDesignSystem({
                    icons: {
                        [iconName]: src
                    }
                });
                clearTimeout(t);
            }, 75);
        }
    }
};

});

parcelRegister("k8Un4", function(module, exports) {

$parcel$export(module.exports, "addMethodModal", () => $eaa0482303627ce3$export$c99cdbbdeaf6b432);
const $eaa0482303627ce3$export$c99cdbbdeaf6b432 = {
    extend: 'ModalWindow',
    props: {
        width: '100%',
        maxWidth: 'I3'
    },
    tag: 'form',
    state: {
        key: '',
        title: '',
        type: 'method',
        value: ()=>{}
    },
    ModalHeader: {
        title: 'Add a new method'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A C3 0',
        minHeight: 'G3',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'C1',
        'Flex.info': {
            flow: 'column',
            gap: 'B3',
            width: '50%',
            // The fields are the shared field kit (components/AppField.js): the
            // caption label above the control, the brand `field` fill with the
            // hairline edge. The controls carry behaviour only.
            'AppField.title': {
                label: (el)=>el.call('polyglot', 'editor.addMethod.title'),
                AppInput: {
                    value: '{{ title }}',
                    required: true,
                    placeholder: (el)=>el.call('polyglot', 'editor.addMethod.titlePlaceholder'),
                    onKeyup: (e, el, s, ctx)=>{
                        const val = el.node.value;
                        const obj = {
                            title: val
                        };
                        const canApplyKey = !s.touched && window.location.pathname.includes('/add-method');
                        if (canApplyKey) obj.key = el.call('toCamelCase', val.toLowerCase()).replace(/[^a-zA-Z]/g, '');
                        s.update(obj);
                    }
                }
            },
            'AppField.key': {
                label: (el)=>el.call('polyglot', 'editor.addComponent.key'),
                AppInput: {
                    value: '{{ key }}',
                    required: true,
                    placeholder: 'fetchExample',
                    onKeydown: (e, el, s, ctx)=>{
                        const val = el.node.value;
                        const NOT_ALLOWED = [
                            '&',
                            '*',
                            '-',
                            ':',
                            '@',
                            '.',
                            '/',
                            '!',
                            ' '
                        ];
                        const preventChars = el.call('stringIncludesAny', val, NOT_ALLOWED);
                        if (preventChars) e.preventDefault();
                    },
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        s.update({
                            touched: true,
                            key: val.replace(/[^a-zA-Z]/g, '')
                        });
                    }
                }
            }
        },
        'Group.code': {
            minWidth: '100%',
            Title: {
                text: '{{ editor.addMethod.code | polyglot }}'
            },
            CodePreviewWidget: {
                props: (el, s, ctx)=>({
                        minWidth: '100%',
                        widthRange: null,
                        theme: 'field-static',
                        round: 'X2',
                        padding: 'X2 X2 X2 -',
                        minHeight: 'G1',
                        Monaco: {
                            foldLevel: false,
                            opacity: 1,
                            fileTab: {
                                code: el.call('stringifyCode', s.value),
                                type: 'javascript',
                                filename: 'method.js',
                                fileTabKey: 'method'
                            },
                            onCodeEditCallback: async (editor)=>{
                                s.quietReplace({
                                    value: await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue())
                                });
                            }
                        }
                    })
            }
        },
        'Button.showAdvanced': {
            margin: '- -Z2',
            gap: 'X',
            background: 'transparent',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            theme: 'common-card-outline-interactive',
            icon: (el, s)=>`arrow angle ${s.advanced ? 'up' : 'down'}`,
            text: (el, s)=>el.call('polyglot', s.advanced ? 'editor.addMethod.hideAdvanced' : 'editor.addMethod.showAdvanced'),
            onClick: (ev, el, s)=>s.update({
                    advanced: !s.advanced
                })
        },
        'Flex.advanced': {
            hide: ({ state: state })=>!state.advanced,
            flow: 'column',
            align: 'flex-start space-between',
            gap: 'C1',
            width: '100%',
            'AppField.description': {
                width: '100%',
                label: (el)=>el.call('polyglot', 'editor.addComponent.description'),
                AppTextarea: {
                    value: (el, s)=>s[el.key.split('.')[1]],
                    placeholder: (el)=>el.call('polyglot', 'editor.addMethod.descriptionPlaceholder'),
                    onKeyup: (e, el, s)=>{
                        s.update({
                            description: el.node.value
                        });
                    }
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            icon: 'arrow right',
            text: '{{ common.action.next | polyglot }}'
        }
    },
    on: {
        submit: (e, el, s, ctx)=>{
            e.preventDefault();
            const key = s.key;
            if (el.getData('methods')[key]) return window.alert(`${key} method already exists`);
            el.call('closeRouterModal', el, s, ctx);
            setTimeout(()=>{
                const item = el.setItem(s.parse());
                el.addItemOnCanvasPage(item);
            }, 75);
        }
    }
};

});

parcelRegister("qZfri", function(module, exports) {

$parcel$export(module.exports, "addPageModal", () => $0511f067514a9836$export$e863bf483d4ebd97);
const $0511f067514a9836$export$e863bf483d4ebd97 = {
    extends: '/add-component-modal',
    state: {
        type: 'pages',
        settings: {
            gridOptions: {
                w: 3,
                h: 3
            }
        }
    },
    props: {
        width: '100%',
        maxWidth: 'I3'
    },
    ModalHeader: {
        title: 'Create a new page',
        p: 'Fill initial settings and choose a template'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A C3 0',
        minHeight: 'G3',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'C1',
        'Flex.info': {
            'InputField.key': {
                Title: {
                    text: '{{ editor.addPage.path | polyglot }}'
                },
                Input: {
                    placeholder: 'E.g, /portfolio',
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        s.update({
                            touched: true,
                            key: val.startsWith('/') ? val : `/${val}`
                        });
                    },
                    onKeydown: (e, el)=>{
                        const val = el.node.value;
                        const preventChars = el.call('stringIncludesAny', val, [
                            '&',
                            ':',
                            '@',
                            '.',
                            '!',
                            ' '
                        ]);
                        if (preventChars) {
                            e.preventDefault();
                            return false;
                        }
                        return true;
                    }
                }
            }
        },
        'Flex.advanced': {
            'InputField.title': {
                Title: {
                    text: '{{ editor.addPage.title | polyglot }}'
                },
                Input: {
                    placeholder: 'E.g. Design Porfolio',
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        const keyFromTitle = val.toLowerCase().replace(/[^a-z0-9]/gu, '-');
                        const key = [
                            'main',
                            'index'
                        ].includes(keyFromTitle) ? '' : keyFromTitle;
                        const canApplyKey = !s.touched;
                        const obj = {
                            title: val
                        };
                        if (canApplyKey) obj.key = `/${key}`;
                        s.update(obj);
                    }
                }
            }
        }
    }
};

});

parcelRegister("hFZ7H", function(module, exports) {

$parcel$export(module.exports, "addSecretModal", () => $cde5adc62686b55a$export$1d9426232e720db2);
const $cde5adc62686b55a$export$1d9426232e720db2 = {
    extends: 'ModalWindow',
    width: '100%',
    maxWidth: 'I3',
    tag: 'form',
    state: {
        name: ''
    },
    ModalHeader: {
        title: 'Add a secret',
        p: 'Add secret hide keys while reusing in your functions'
    },
    Flex: {
        padding: 'A C3 0',
        minHeight: 'G2',
        flow: 'column',
        gap: 'B3',
        width: '50%',
        'InputField.name': {
            Title: {
                text: '{{ editor.addComponent.key | polyglot }}'
            },
            Input: {
                required: true,
                value: '{{ name }}',
                placeholder: 'secretKey',
                onKeyup: (e, el, s)=>{
                    const val = el.node.value;
                    s.update({
                        name: val
                    });
                }
            }
        },
        'InputField.key': {
            Title: {
                text: '{{ editor.addSecret.value | polyglot }}'
            },
            Input: {
                required: true,
                value: '{{ key }}',
                placeholder: (el)=>el.call('polyglot', 'editor.addSecret.valuePlaceholder'),
                onKeyup: (e, el, s)=>{
                    const val = el.node.value;
                    s.update({
                        key: val
                    });
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}',
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2'
        }
    },
    onInit: (el, s)=>{
        const name = el.call('getLastLocationPath')?.slice(1);
        const key = el.getSecrets(name);
        if (!name || !key) return;
        s.quietUpdate({
            name: name,
            key: key
        });
    },
    onSubmit: async (e, el, s, ctx)=>{
        e.preventDefault();
        const exists = el.getFunctions(s.key);
        const action = exists ? 'updateItem' : 'addItem';
        const res = await el.sdk[action](`functions`, s);
        if (res?.version) await el.call('closeRouterModal');
        else el.call('openNotification', {
            title: el.call('polyglot', 'editor.addComponent.error.title'),
            message: el.call('polyglot', 'editor.addFunction.createFailed').replace('{key}', s.key),
            type: 'error'
        });
    }
};

});

parcelRegister("2njD1", function(module, exports) {

$parcel$export(module.exports, "addSnippetModal", () => $1bacf48918a2167e$export$2f12e66f907b27b0);
const $1bacf48918a2167e$export$2f12e66f907b27b0 = {
    extend: 'ModalWindow',
    props: {
        width: '100%',
        maxWidth: 'I3'
    },
    tag: 'form',
    state: {
        key: '',
        title: '',
        type: 'snippet',
        value: ()=>{}
    },
    ModalHeader: {
        title: 'Add a new snippet'
    },
    Flex: {
        overflow: 'auto',
        padding: 'A C3 0',
        minHeight: 'G3',
        minWidth: '100%',
        flow: 'column',
        flexAlign: 'flex-start space-between',
        gap: 'C1',
        'Flex.info': {
            flow: 'column',
            gap: 'B3',
            width: '50%',
            // The fields are the shared field kit (components/AppField.js): the
            // caption label above the control, the brand `field` fill with the
            // hairline edge. The controls carry behaviour only.
            'AppField.title': {
                label: (el)=>el.call('polyglot', 'editor.addSnippet.title'),
                AppInput: {
                    value: '{{ title }}',
                    required: true,
                    placeholder: (el)=>el.call('polyglot', 'editor.addSnippet.titlePlaceholder'),
                    onKeyup: (e, el, s, ctx)=>{
                        const val = el.node.value;
                        const obj = {
                            title: val
                        };
                        const canApplyKey = !s.touched && window.location.pathname.includes('/add-snippet');
                        if (canApplyKey) obj.key = el.call('toCamelCase', val.toLowerCase()).replace(/[^a-zA-Z]/g, '');
                        s.update(obj);
                    }
                }
            },
            'AppField.key': {
                label: (el)=>el.call('polyglot', 'editor.addComponent.key'),
                AppInput: {
                    value: '{{ key }}',
                    required: true,
                    placeholder: 'fetchExample',
                    onKeydown: (e, el, s, ctx)=>{
                        const val = el.node.value;
                        const NOT_ALLOWED = [
                            '&',
                            '*',
                            '-',
                            ':',
                            '@',
                            '.',
                            '/',
                            '!',
                            ' '
                        ];
                        const preventChars = el.call('stringIncludesAny', val, NOT_ALLOWED);
                        if (preventChars) e.preventDefault();
                    },
                    onKeyup: (e, el, s)=>{
                        const val = el.node.value;
                        s.update({
                            touched: true,
                            key: val.replace(/[^a-zA-Z]/g, '')
                        });
                    }
                }
            }
        },
        'Group.code': {
            minWidth: '100%',
            Title: {
                text: '{{ editor.addSnippet.code | polyglot }}'
            },
            CodePreviewWidget: {
                props: (el, s, ctx)=>({
                        minWidth: '100%',
                        widthRange: null,
                        theme: 'field-static',
                        round: 'X2',
                        padding: 'X2 X2 X2 -',
                        minHeight: 'G1',
                        Monaco: {
                            foldLevel: false,
                            opacity: 1,
                            fileTab: {
                                code: el.call('stringifyCode', s.value),
                                type: 'javascript',
                                filename: 'snippet.js',
                                fileTabKey: 'snippet'
                            },
                            onCodeEditCallback: async (editor)=>{
                                s.quietReplace({
                                    value: await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue())
                                });
                            }
                        }
                    })
            }
        },
        'Button.showAdvanced': {
            margin: '- -Z2',
            gap: 'X',
            background: 'transparent',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            theme: 'common-card-outline-interactive',
            icon: (el, s)=>`arrow angle ${s.advanced ? 'up' : 'down'}`,
            text: (el, s)=>el.call('polyglot', s.advanced ? 'editor.addSnippet.hideAdvanced' : 'editor.addSnippet.showAdvanced'),
            onClick: (ev, el, s)=>s.update({
                    advanced: !s.advanced
                })
        },
        'Flex.advanced': {
            hide: ({ state: state })=>!state.advanced,
            flow: 'column',
            align: 'flex-start space-between',
            gap: 'C1',
            width: '100%',
            'AppField.description': {
                width: '100%',
                label: (el)=>el.call('polyglot', 'editor.addComponent.description'),
                AppTextarea: {
                    value: (el, s)=>s[el.key.split('.')[1]],
                    placeholder: (el)=>el.call('polyglot', 'editor.addSnippet.descriptionPlaceholder'),
                    onKeyup: (e, el, s)=>{
                        s.update({
                            description: el.node.value
                        });
                    }
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            reverse: true,
            icon: 'arrow right',
            text: '{{ common.action.next | polyglot }}'
        }
    },
    on: {
        submit: (e, el, s, ctx)=>{
            e.preventDefault();
            const key = s.key;
            if (el.getData('snippets')[key]) return window.alert(`${key} snippet already exists`);
            el.call('closeRouterModal', el, s, ctx);
            setTimeout(()=>{
                const item = el.setItem(s.parse());
                el.addItemOnCanvasPage(item);
            }, 75);
        }
    }
};

});

parcelRegister("gsbvm", function(module, exports) {

$parcel$export(module.exports, "addThemeModal", () => $bfa82f78a3000311$export$1ccd474ee971f023);
const $bfa82f78a3000311$export$1ccd474ee971f023 = {
    extend: '/add-global-theme-modal',
    props: {
        onSubmit: (e, el, s)=>{
            e.preventDefault();
            const { value: value, themeModifier: themeModifier } = s;
            if (themeModifier && value) {
                const sceneTheme = el.getRootState().sceneTheme;
                const globalTheme = '@' + sceneTheme;
                const inversedKey = globalTheme === '@dark' ? '@light' : '@dark';
                const inversedValue = {
                    color: value.background,
                    background: value.color
                };
                el.updateDesignSystem({
                    theme: {
                        [themeModifier]: {
                            [globalTheme]: value,
                            [inversedKey]: inversedValue
                        }
                    }
                });
                el.call('closeRouterModal', el, s);
            }
        }
    },
    ModalHeader: {
        title: 'Add a new theme',
        p: null
    }
};

});

parcelRegister("9BPMF", function(module, exports) {

$parcel$export(module.exports, "browserExtension", () => $6fefbcfc687dd233$export$825e1df450235de1);
const $6fefbcfc687dd233$export$825e1df450235de1 = {
    extend: 'Flex',
    props: {
        flow: 'y',
        gap: 'X2',
        width: '100%',
        height: '100%',
        padding: 'X'
    },
    state: {
        recents: [],
        extensionInstalled: 'Boolean(window.chrome && window.chrome.runtime)'
    },
    ExtensionCanvasNavbar: {},
    Window: {
        flex: 1,
        width: '100%',
        theme: 'modal',
        round: 'radiusCard',
        overflow: 'hidden',
        position: 'relative',
        Iframe: {
            background: 'white',
            src: '{{ url }}',
            border: 0,
            hide: (el, s)=>!s.url,
            height: '100%',
            width: '100%'
        },
        Message: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            hide: (el, s)=>s.extensionInstalled && s.url,
            P: {
                color: 'disabled',
                text: '{{ editor.ext.urlHint | polyglot }}'
            }
        },
        InstallExt: {
            hide: (el, s)=>!s.extensionInstalled
        },
        Chosen: {
            hide: (el, s)=>!s.parent.inspectedItem,
            position: 'absolute',
            inset: '0'
        }
    }
};

});

parcelRegister("ew9Jc", function(module, exports) {

$parcel$export(module.exports, "browserPreview", () => $a91b999e7630bec1$export$40ccccb3e553b73f);
const $a91b999e7630bec1$export$40ccccb3e553b73f = {
    extend: 'Flex',
    state: {
        searchTerm: '',
        recents: []
    },
    scope: {
        getInitialValues: (el, s)=>{
            const selected = s.key || el.getSelectedKey?.();
            if (!selected) return;
            const type = s.type || el.getSelected().state.type;
            const route = type === 'pages' ? `${selected}` : `/component?key=${selected}&hideUi=true`;
            const isPage = type?.startsWith('/');
            const prefix = (isPage ? '&' : '?') + 'env=';
            const env = s.env || 'Current';
            s.envUrl = ({
                Current: prefix + 'dev',
                Development: '',
                Staging: prefix + 'staging',
                Production: prefix + 'production'
            })[env];
            const path = el.getCanvasPathname();
            const domain = 'preview.symbo.ls';
            const origin = `https://${domain}${path}`;
            const urlWithEnv = `${origin}${route}`;
            const appkey = el.getAppKey();
            const url = `https://${appkey}${route}`;
            s.selected = selected;
            s.path = path;
            s.url = url;
            s.urlWithEnv = urlWithEnv;
        }
    },
    props: {
        flow: 'y',
        gap: 'X2',
        width: '100%',
        height: '100%',
        padding: 'X',
        onInit: (el, s)=>{
            el.scope.getInitialValues(el, s);
        },
        onBeforeUpdate: (_, el, s)=>{
            el.scope.getInitialValues(el, s);
        }
    },
    PreviewCanvasNavbar: {},
    Window: {
        flex: 1,
        width: '100%',
        theme: 'modal',
        round: 'radiusCard',
        overflow: 'hidden',
        position: 'relative',
        Iframe: {
            background: 'white',
            src: '{{ url }}',
            border: 0,
            hide: (el, s)=>!s.url,
            height: '100%',
            width: '100%'
        },
        Message: {
            hide: (el, s)=>s.url,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            P: {
                color: 'disabled',
                text: '{{ editor.previewModes.selectHint | polyglot }}'
            }
        }
    }
};

});

parcelRegister("esytx", function(module, exports) {

$parcel$export(module.exports, "compileMarkdown", () => $a86e6c53ec7ffbea$export$a6503a42d9d7bb48);
// Computed specifier — see functions/compileCode.js's `_DOMPILER_PKG` header
// comment (same package, same "a literal specifier hard-fails the whole
// shell build when the wasm artifact is absent" reason).
const $a86e6c53ec7ffbea$var$_DOMPILER_PKG = [
    '@symbo.ls',
    'dompiler'
].join('/');

const $a86e6c53ec7ffbea$export$a6503a42d9d7bb48 = {
    extend: 'Flex',
    props: {
        align: 'stretch start',
        padding: 'V1',
        flex: 1,
        gap: 'W'
    },
    CodePreviewWidget: {
        props: (el, s)=>({
                flex: 1,
                widthRange: null,
                theme: 'field-static',
                round: 'X2',
                padding: 'X2 X2 X2 -',
                minHeight: 'G1',
                maxHeight: '100%',
                Monaco: {
                    foldLevel: false,
                    opacity: 1,
                    fileTab: {
                        code: s.text,
                        type: 'javascript',
                        filename: 'props.js',
                        fileTabKey: 'props'
                    },
                    onCodeEditCallback: async (editor)=>{
                        const beautify = await (parcelRequire("7vDIr"));
                        // `convertDomqlToReact` was referenced bare, never imported —
                        // `frank to-json`: `unresolvable-scope-read` (present in NEITHER
                        // globalScope nor any declared `scope`), a guaranteed
                        // ReferenceError. Dynamic-imported per FA206, matching
                        // functions/compileCode.js's own `symbols-to-react` branch (same
                        // package, same computed-specifier reason).
                        const { convertDomqlToReact: convertDomqlToReact } = await import($a86e6c53ec7ffbea$var$_DOMPILER_PKG);
                        const text = editor.getValue();
                        const compiled = await convertDomqlToReact(text);
                        const code = await beautify.js(compiled, {
                            indent_size: 2,
                            space_in_empty_paren: true,
                            preserve_newlines: false,
                            brace_style: 'collapse',
                            break_chained_methods: false
                        });
                        s.replace({
                            code: formatImports(code)
                        });
                    }
                }
            })
    },
    CodePreviewWithTitle: {
        flex: 1,
        height: '100%',
        value: '{{ code }}',
        Title: null,
        CodePreview: {
            round: 'X2',
            height: '100%',
            margin: '0'
        },
        Buttons: {
            padding: '0 Y2'
        }
    }
};

});
parcelRegister("7vDIr", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("2UcL4"))) : import("2UcL4")).then(()=>parcelRequire('g95Jx'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("6lb7e", function(module, exports) {

$parcel$export(module.exports, "compileModal", () => $49dd53999d54baba$export$123e6b9e2e486afd);
const $49dd53999d54baba$export$123e6b9e2e486afd = {
    IconButton: {
        icon: 'crossmark',
        padding: 'Y2',
        position: 'absolute',
        top: 'X',
        right: 'X',
        // eslint-disable-next-line no-restricted-syntax -- icon-only close button, not text
        color: 'inactive',
        onClick: (ev, el, s, ctx)=>el.call('closeRouterModal')
    },
    Compile: {
        extends: '/compile',
        Flex_header: {
            padding: '0 C1 X A'
        }
    },
    props: {
        align: 'stretch',
        theme: 'modal',
        gap: 'A',
        width: '100%',
        padding: 'X X X',
        height: '100%'
    }
};

});

parcelRegister("7i3KY", function(module, exports) {

$parcel$export(module.exports, "compile", () => compile);
const compile = {
    style: {
        padding: '0 !important'
    },
    state: {
        source: `
# Markdown to Symbols Compiler

Welcome to the **Markdown to Symbols** compiler! This tool converts markdown syntax into Symbols (DOMQL) format.

## Headings

### This is H3
#### This is H4
##### This is H5
###### This is H6

`,
        dist: '',
        compilingMethod: 'markdown-to-symbols'
    },
    Flex_header: {
        align: 'end space-between',
        padding: '0 A X',
        fontSize: 'Z1',
        Strong: {
            text: '{{ editor.compile.title | polyglot }}'
        },
        P: {
            margin: '0',
            text: '{{ editor.compile.subtitle | polyglot }}'
        },
        Toolbar: {
            flexFlow: 'y',
            flexAlign: 'end',
            gap: 'X2',
            align: 'center start',
            Button_dropdown: {
                extends: [
                    'Button',
                    'DropdownParentFocus'
                ],
                theme: 'secondary',
                gap: 'Z',
                flow: 'row-reverse',
                padding: 'Y2 Z2',
                icon: 'arrow angle down',
                text: (_, s)=>{
                    const methods = {
                        'markdown-to-symbols': "Markdown \u2192 Symbols",
                        'tailwind-to-symbols': "Tailwind \u2192 Symbols",
                        'symbols-to-tailwind': "Symbols \u2192 Tailwind",
                        'symbols-to-react': "Symbols \u2192 React"
                    };
                    return methods[s.compilingMethod] || 'Select method';
                },
                Dropdown: {
                    left: '0',
                    align: 'start',
                    top: '110%',
                    onChoose: (_ev, _el, s, _ctx, calleeElement)=>{
                        const method = calleeElement.state.value;
                        s.update({
                            compilingMethod: method
                        });
                    },
                    ListInDropdown: {
                        childProps: {
                            extends: 'Button',
                            textAlign: 'start',
                            padding: 'Z1 A',
                            color: 'inactive',
                            round: 'radiusPill',
                            theme: null,
                            fontWeight: '400',
                            align: 'center start',
                            ':hover': {
                                theme: 'field'
                            },
                            '.isActive': {
                                theme: 'field'
                            },
                            isActive: (_, s)=>{
                                return s.parent.parent.compilingMethod === s.value;
                            }
                        },
                        childrenAs: 'state',
                        children: [
                            {
                                value: 'markdown-to-symbols',
                                text: '{{ editor.compile.markdownToSymbols | polyglot }}'
                            },
                            {
                                value: 'tailwind-to-symbols',
                                text: '{{ editor.compile.tailwindToSymbols | polyglot }}'
                            },
                            {
                                value: 'symbols-to-tailwind',
                                text: '{{ editor.compile.symbolsToTailwind | polyglot }}'
                            },
                            {
                                value: 'symbols-to-react',
                                text: '{{ editor.compile.symbolsToReact | polyglot }}'
                            }
                        ]
                    }
                }
            }
        }
    },
    Flex: {
        align: 'stretch start',
        padding: 'V1',
        flex: 1,
        gap: 'W',
        flexFlow: 'row',
        height: '100%',
        CodePreviewWidget_from: {
            flex: 1,
            theme: 'field-static',
            round: 'X2',
            padding: 'X2 X2 X2 -',
            minHeight: 'G1',
            maxHeight: '100%',
            widthRange: 'auto',
            overflow: 'hidden',
            Header: {
                order: '-1',
                padding: '- Z Z',
                borderBottom: 'hairline solid line',
                color: 'inactive',
                fontSize: 'Y',
                textTransform: 'uppercase',
                text: '{{ editor.compile.source | polyglot }}'
            },
            Monaco: {
                foldLevel: false,
                opacity: 1,
                beautify: false,
                formatOnPaste: false,
                formatOnType: false,
                fileTab: {
                    code: (_, s)=>s.source || '',
                    type: (_, s)=>{
                        if (s.compilingMethod === 'markdown-to-symbols') return 'markdown';
                        if (s.compilingMethod === 'tailwind-to-symbols') return 'css';
                        return 'javascript';
                    },
                    filename: (_, s)=>{
                        if (s.compilingMethod === 'markdown-to-symbols') return 'source.md';
                        if (s.compilingMethod === 'tailwind-to-symbols') return 'source.css';
                        if (s.compilingMethod === 'symbols-to-tailwind') return 'source.js';
                        return 'source.js';
                    }
                },
                onCodeEditCallback: async (editor, _2, el, s)=>{
                    const source = editor.getValue();
                    let parentState = s;
                    while(parentState.parent && !parentState.compilingMethod)parentState = parentState.parent;
                    if (source === parentState.source) return;
                    const dist = await el.call('compileCode', source, parentState.compilingMethod);
                    parentState.update({
                        source: source,
                        dist: dist
                    }, {
                        forceMonacoUpdate: true,
                        preventUpdate: [
                            'CodePreviewWidget_from'
                        ]
                    });
                }
            }
        },
        CodePreviewWidget_to: {
            flex: 1,
            theme: 'field-static',
            round: 'X2',
            padding: 'X2 X2 X2 -',
            minHeight: 'G1',
            maxHeight: '100%',
            widthRange: 'auto',
            overflow: 'hidden',
            Header: {
                order: '-1',
                padding: '- Z Z',
                borderBottom: 'hairline solid line',
                color: 'inactive',
                fontSize: 'Y',
                textTransform: 'uppercase',
                text: '{{ editor.compile.target | polyglot }}'
            },
            Monaco: {
                foldLevel: false,
                opacity: 1,
                readOnly: true,
                fileTab: {
                    code: (_, s)=>s.dist || '// Compiling...',
                    type: 'javascript',
                    filename: 'output.js'
                },
                onCodeEditCallback: async ()=>{}
            }
        },
        PreviewContainer: {
            if: (_, s)=>s.compilingMethod.endsWith('-to-symbols'),
            flex: 1,
            padding: 'X2',
            theme: 'field-static',
            round: 'X2',
            overflow: 'auto',
            minHeight: 'G1',
            flexFlow: 'column',
            Header: {
                padding: '- Z Z',
                borderBottom: 'hairline solid line',
                color: 'inactive',
                fontSize: 'Y',
                textTransform: 'uppercase',
                text: '{{ editor.selectedNavbar.preview | polyglot }}'
            },
            Content: {
                padding: 'A B',
                overflow: 'auto',
                flex: 1,
                flexFlow: 'column',
                gap: '0',
                children: (_, s)=>{
                    if (!s.dist) return [
                        {
                            text: '{{ editor.compile.working | polyglot }}'
                        }
                    ];
                    try {
                        let code = s.dist.replace(/^export\s+const\s+\w+\s*=\s*/, '').trim();
                        if (code.endsWith(';')) code = code.slice(0, -1);
                        const result = eval(`(${code})`);
                        const { props, __order, ...content } = result;
                        if (__order && __order.length > 0) return __order.map((key)=>content[key]);
                        return Object.values(content);
                    } catch (error) {
                        console.error('[Preview] Eval error:', error);
                        return [
                            {
                                P: {
                                    text: (el)=>el.call('polyglot', 'editor.compile.previewError').replace('{error}', error.message),
                                    color: 'red'
                                }
                            }
                        ];
                    }
                }
            }
        }
    },
    props: {
        flexFlow: 'y',
        gap: 'Y1',
        round: 'radiusCard',
        width: '100%',
        padding: 'Y1',
        height: '100%',
        ':hover .close': {
            opacity: 1,
            visibility: 'visible'
        },
        // `:hover` rules are `@media (hover: hover)`-gated since smbls e3333d298,
        // so on touch this reveal never runs — and a `visibility: hidden` rest
        // state is not just invisible, it is not hit-testable either. Mirror the
        // reveal for coarse pointers; fine pointers unaffected.
        '@coarse': {
            '.close': {
                opacity: 1,
                visibility: 'visible'
            }
        },
        onInit: async (el, s)=>{
            const dist = await el.call('compileCode', s.source, s.compilingMethod);
            s.update({
                dist: dist
            });
        },
        onBeforeUpdate: async (changes, el, s)=>{
            const { source, compilingMethod } = changes;
            if (source !== undefined || compilingMethod !== undefined) {
                const newSource = source !== undefined ? source : s.source;
                const newMethod = compilingMethod !== undefined ? compilingMethod : s.compilingMethod;
                const dist = await el.call('compileCode', newSource, newMethod);
                s.dist = dist;
            }
        }
    }
};

});

parcelRegister("eYQti", function(module, exports) {

$parcel$export(module.exports, "editBranchModal", () => $ae7f5f02e6560e17$export$d9de62232ba19820);
const $ae7f5f02e6560e17$export$d9de62232ba19820 = {
    extends: '/add-branch-modal',
    ModalHeader: {
        title: 'Edit {{ branch }} branch',
        p: 'Edit branch name or delete it'
    },
    state: (el)=>({
            branch: el.getActiveBranch()
        }),
    Flex: {
        InputField: {
            Input: {}
        },
        Flex: {
            if: (el, s)=>s.error,
            text: (el, s)=>s.error
        }
    },
    ModalFooter: {
        CheckButton: {},
        IconButton: {
            icon: 'trash outline',
            onClick: async (e, el, s, ctx)=>{
                e.preventDefault();
                try {
                    await el.sdk.deleteBranch(el.getActiveBranch());
                    await el.call('setActiveBranch', 'main');
                    await el.call('closeRouterModal');
                } catch (err) {
                    s.update({
                        error: err.message
                    });
                }
            }
        }
    },
    on: {
        submit: async (e, el, s, ctx)=>{
            e.preventDefault();
            if (!s.branch) return s.update({
                error: 'Branch name cannot be empty'
            });
            if (s.branch === el.getActiveBranch()) return s.update({
                error: 'No changes'
            });
            try {
                await el.sdk.renameBranch(el.getRootState().projectId, el.getActiveBranch(), s.branch);
                await el.call('setActiveBranch', s.branch);
                await el.call('closeRouterModal');
            } catch (err) {
                s.update({
                    error: err.message
                });
            }
        }
    }
};

});

parcelRegister("21M33", function(module, exports) {

$parcel$export(module.exports, "editCanvasModal", () => $17a0f22b65624664$export$84f720852f1423ff);
const $17a0f22b65624664$export$84f720852f1423ff = {
    extends: '/add-canvas-modal',
    ModalHeader: {
        title: 'Edit {{ title }} canvas',
        p: 'Edit custom canvas page'
    },
    Flex: {
        InputField: {
            pointerEvents: 'none',
            Input: {
                opacity: '.65',
                disabled: 'disabled'
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2'
        },
        IconButton: {
            icon: 'trash outline',
            onClick: async (ev, el, s)=>{
                await el.call('deleteCanvasPage', s.key);
            }
        }
    },
    onInit: async (el, s)=>{
        const key = s.key || el.call('getLastLocationPath').slice(1);
        await s.quietReplace(canvasPageData);
    },
    onSubmit: async (e, el, s, ctx)=>{
        e.preventDefault();
        await el.call('addCanvasPage', s, {
            preventNameCheck: true
        });
        await el.call('closeRouterModal');
    }
};

});

parcelRegister("ezb1c", function(module, exports) {

$parcel$export(module.exports, "editCaseModal", () => $a9ace198237e4686$export$ce523b63e2123b43);
const $a9ace198237e4686$export$ce523b63e2123b43 = {
    extends: '/add-case-modal',
    ModalHeader: {
        title: 'Edit {{ key }} case',
        p: null
    },
    Flex: {},
    ModalFooter: {
        CheckButton: {},
        IconButton: {
            icon: 'trash outline',
            onClick: async (ev, el, s, ctx)=>{
                const text = 'Do you want to remove the case?';
                if (window.confirm(text)) {
                    await el.updateDesignSystem(`cases.${s.key}`);
                    await el.call('closeRouterModal');
                }
            }
        }
    },
    on: {
        init: (el, s)=>{
            const key = s.key || el.call('getLastLocationPath').slice(1);
            const value = el.getDesignSystem('cases')?.[key];
            if (!value || !key) return;
            s.update({
                value: value,
                key: key,
                oldName: key
            });
        },
        submit: async (e, el, s, ctx)=>{
            e.preventDefault();
            await el.bulkUpdateDesignSystem([
                {
                    type: 'delete',
                    path: [
                        'cases',
                        s.oldName
                    ]
                },
                {
                    type: 'update',
                    path: [
                        'cases',
                        s.key
                    ],
                    value: s.value
                }
            ], 'Updated Case');
            const t = setTimeout(async ()=>{
                await el.updateDesignSystem(`cases.${s.key}`, s.value);
                clearTimeout(t);
            }, 75);
            await el.call('closeRouterModal');
        }
    }
};

});

parcelRegister("dpjKU", function(module, exports) {

$parcel$export(module.exports, "editColorModal", () => $9c2cef39a460d60b$export$335de43e577248f5);
const $9c2cef39a460d60b$export$335de43e577248f5 = {
    extend: '/add-color-modal',
    ModalHeader: {
        title: 'Edit "{{ key }}" color'
    },
    Flex: {},
    ModalFooter: {
        props: {
            gap: 'A'
        },
        CheckButton: {
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}'
        },
        'IconButton.copy': {
            extends: [
                'Link',
                'IconButton'
            ],
            margin: '- - - auto',
            icon: 'copy outline',
            href: (el, s)=>'/color/add-color/' + s.value
        },
        'IconButton.trash': {
            if: (el, s)=>el.getDesignSystem('color')[s.key],
            icon: 'trash outline',
            onClick: (ev, el, s)=>{
                const { key: key } = s;
                const text = 'Do you want to remove the color?';
                if (key && window.confirm(text)) {
                    const color = el.getDesignSystem('color');
                    delete color[key];
                    el.getRootState().update({
                        designSystem: {
                            color: color
                        }
                    });
                    el.call('closeRouterModal', el, s);
                }
            }
        }
    },
    props: {
        onInit: (el, s)=>{
            const path = window.location.pathname;
            const pathArray = path.split('edit-color/');
            // `getDesignSystem('color')` already merges builtins (`getBuiltins()`)
            // UNDER the project's own saved color table (see
            // methods/design-system.js), so `color[key]` alone covers both a
            // project-defined color AND a built-in one — no separate fallback
            // read is needed. The removed `el.getRootState().DEFAULT_DESIGN_SYSTEM`
            // fallback was dead AND crash-prone: that root-state key is never set
            // anywhere in current source (same defect class fixed in
            // workspace/packages/design-system's ColorPalleteSection/
            // GradientsSection/SemanticColorsSection/ThemesSection, CAT-3), so it
            // would have thrown `Cannot read properties of undefined` the moment
            // `color[key]` was ever falsy.
            const color = el.getDesignSystem('color');
            if (!color) return;
            const key = pathArray[1];
            const value = color[key];
            if (!key || !value) return;
            s.update({
                key: key,
                value: value || key
            }, {
                preventUpdate: true,
                preventContentUpdate: true
            });
        }
    }
};

});

parcelRegister("bLD5X", function(module, exports) {

$parcel$export(module.exports, "editComponentModal", () => $891268f665524e25$export$2ef721b6f8cb9fb3);
const $891268f665524e25$export$2ef721b6f8cb9fb3 = {
    extend: '/add-component-modal',
    props: {
        onInit: (el, s)=>{
            const componentKey = s.key || el.call('getLastLocationPath').slice(1);
            const item = el.getItem(componentKey);
            return item && s.quietReplace(item);
        },
        onSubmit: async (e, el, s, ctx)=>{
            e.preventDefault();
            const obj = s.parse();
            const { type: type, key: key } = obj;
            delete obj.advanced;
            if (!key) {
                el.call('openNotification', {
                    title: el.call('polyglot', 'editor.addComponent.validation.title'),
                    message: el.call('polyglot', 'editor.addComponent.keyRequired'),
                    type: 'warning'
                });
                return;
            }
            const res = el.call('updateItem', type, key, obj, {
                forceChosenUpdate: true
            });
            if (res?.success) el.call('closeRouterModal');
            else el.call('openNotification', {
                title: el.call('polyglot', 'editor.addComponent.error.title'),
                message: el.call('polyglot', 'editor.addComponent.error.message').replace('{type}', s.type).replace('{title}', s.title),
                type: 'error'
            });
        }
    },
    ModalHeader: {
        title: 'Edit {{ key }} component',
        p: 'Edit a platform schema for component'
    },
    Flex: {
        'Flex.info': {
            // The key is fixed once the component exists: the kit's disabled state
            // (the real attribute, the `field-disabled` pair, the not-allowed
            // cursor) — never an opacity dim (DESIGN_LANGUAGE §8.1), and no
            // `pointerEvents: 'none'`, which hid that cursor.
            'AppField.key': {
                AppInput: {
                    disabled: true
                }
            }
        },
        'Button.showAdvanced': {},
        'Flex.advanced': {
            'GroupField.value': null
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}'
        },
        IconButton: {
            icon: 'trash outline',
            onClick: async (ev, el, s, ctx)=>{
                if (s.key && window.confirm(`Do you want to remove the ${s.type}?`)) {
                    el.sdk.deleteItem(`${s.type}s`, s.key);
                    await el.call('closeRouterModal');
                }
            }
        }
    }
};

});

parcelRegister("agTHT", function(module, exports) {

$parcel$export(module.exports, "editDependencyModal", () => $77a69c3dac178afa$export$aaf10a2c25eff6b3);
const $77a69c3dac178afa$export$aaf10a2c25eff6b3 = {
    extends: '/add-dependency-modal',
    ModalHeader: {
        title: 'Edit {{ name }} dependency',
        p: 'Edit or update NPM package dependency and version'
    },
    Flex: {
        // The add page's kit field, by key: the package is fixed once added — the
        // control takes the kit's disabled state (the real attribute and the
        // `field-disabled` pair) and the package search menu goes.
        'AppField.name': {
            AppInput: {
                disabled: true
            },
            Dropdown: null
        }
    },
    Flex_Codes: {
        if: (el, s)=>el.getDependencies(s.name),
        flow: 'column',
        gap: 'B3',
        padding: 'A C3 C3',
        TerminalWithTitle: {
            maxWidth: '50%',
            Title: {
                text: '{{ editor.editDependency.cdnUrl | polyglot }}'
            },
            Terminal: {
                theme: 'field-static',
                icon: null,
                margin: '0 0 0 -Y',
                value: (el, s)=>`https://pkg.symbo.ls/${s.name}/${el.getDependencies(s.name)}.js`
            }
        },
        CodeWithTitle: {
            P: {
                color: 'gray8',
                margin: '0',
                text: '{{ editor.editDependency.cdnFile | polyglot }}'
            },
            CodePreviewWithTitle: {
                margin: 'Z1 0 0',
                value: (el, s)=>`const ${el.call('toCamelCase', s.name)} = await window.require('${s.name}')`,
                Title: null,
                CodePreview: {
                    theme: 'field-static'
                },
                Buttons: {
                    FrameworkSwitcher: null
                }
            }
        },
        Status: {
            text: '{{ status }}'
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}'
        },
        IconButton: {
            margin: '- - - auto',
            icon: 'trash outline',
            onClick: async (ev, el, s, ctx)=>{
                if (!window.confirm('Are you sure you want to remove this dependency?')) return;
                await el.call('deleteDependency');
                await el.call('closeRouterModal');
            }
        }
    },
    props: {
        onInit: (el, s)=>{
            const name = s.name || s.key || el.call('getLastLocationPath').slice(1);
            const value = s.value || el.getDependencies(name);
            const pkgObj = el.getPackages(name);
            const version = value || s.version || s.value || pkgObj?.resolvedVersion;
            if (!name || !value || !pkgObj) return;
            s.quietReplace({
                ...pkgObj,
                name: name,
                version: version,
                value: version,
                schemaVersion: pkgObj?.version
            });
        }
    }
};

});

parcelRegister("AJQbf", function(module, exports) {

$parcel$export(module.exports, "editFileModal", () => $06e6ebe63ae447fe$export$a486754732ff9917);
const $06e6ebe63ae447fe$export$a486754732ff9917 = {
    extends: '/add-file-modal',
    ModalHeader: {
        title: 'Edit {{ key }} file',
        p: null
    },
    Flex: {
        InputField: {
            pointerEvents: 'none',
            Input: {
                opacity: '.65',
                disabled: 'disabled'
            }
        },
        'CommonSection.type': null
    },
    ModalFooter: {
        CheckBuuon: {},
        IconButton: {
            icon: 'trash outline',
            onClick: async (ev, el, s, ctx)=>{
                if (s.key && window.confirm('Do you want to remove the file?')) {
                    el.sdk.deleteItem('files', s.key);
                    await el.call('rerenderFileSidebarByType', 'files');
                    await el.call('closeRouterModal');
                }
            }
        }
    },
    props: {
        onInit: (el, s)=>{
            const key = s.key || el.call('getLastLocationPath').slice(1);
            const content = el.getFiles(key);
            s.quietUpdate({
                key: key,
                ...content
            });
        }
    }
};

});

parcelRegister("dmOpl", function(module, exports) {

$parcel$export(module.exports, "editFontFamilyModal", () => $9bb46e610c4d043e$export$c205ea6b3c735dca);
const $9bb46e610c4d043e$export$c205ea6b3c735dca = {};

});

parcelRegister("2kTUW", function(module, exports) {

$parcel$export(module.exports, "editFunctionModal", () => $1b38d315dc5248e6$export$dd6a0b37e11ff4d0);
const $1b38d315dc5248e6$export$dd6a0b37e11ff4d0 = {
    extend: '/add-function-modal',
    ModalHeader: {
        title: 'Edit {{ key }} function'
    },
    Flex: {
        'Flex.info': {
            'AppField.title': {},
            // The key is fixed once the function exists: the kit's disabled state
            // (the real attribute, the `field-disabled` pair, the not-allowed
            // cursor) — never an opacity dim (DESIGN_LANGUAGE §8.1), and no
            // `pointerEvents: 'none'`, which hid that cursor.
            'AppField.key': {
                AppInput: {
                    disabled: true
                }
            }
        },
        'Group.code': {
            minWidth: '100%',
            Title: {
                text: '{{ editor.addFunction.code | polyglot }}'
            },
            CodePreviewWidget: {
                props: (el, s)=>({
                        minWidth: '100%',
                        widthRange: null,
                        theme: 'field-static',
                        round: 'X2',
                        padding: 'X2 X2 X2 -',
                        minHeight: 'G1',
                        Monaco: {
                            foldLevel: false,
                            opacity: 1,
                            fileTab: {
                                code: el.call('stringifyCode', s.value),
                                type: 'javascript',
                                filename: 'function.js',
                                fileTabKey: 'function'
                            },
                            onCodeEditCallback: async (editor)=>{
                                const code = editor.getValue();
                                const value = await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ code, {
                                    onError: (err)=>{
                                        s.update({
                                            err: err
                                        });
                                    }
                                });
                                if (!value) return;
                                s.quietReplace({
                                    code: el.call('encodeNewlines', code),
                                    value: value
                                }, {
                                    hoistUpdate: true
                                });
                            }
                        }
                    })
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}'
        },
        IconButton: {
            icon: 'trash outline',
            onClick: async (ev, el, s)=>{
                el.call('removeItem', 'function', s.key);
                el.call('closeRouterModal');
            }
        }
    },
    // Flat v3.14 handlers. They sat in an `on: { init, submit }` wrapper, which
    // the v3.14 engine never reads (it fires `element.onInit` and binds
    // `element.onSubmit` only): the page never loaded its function, and the
    // add page's `onSubmit` (inherited through `extend`) ran on save instead.
    // Flat is safe here — the add page carries no `props.onInit` /
    // `props.onSubmit`, which would override an instance's flat handler at
    // merge time (edit-component-modal.js keeps its `props` for that reason).
    onInit: (el, s)=>{
        const key = s.key || el.call('getLastLocationPath').slice(1);
        const item = el.getItem(key, s.type);
        return item && s.quietReplace(item);
    },
    onSubmit: async (e, el, s)=>{
        e.preventDefault();
        el.call('updateItem', s.type, s.key, s);
        await el.call('closeRouterModal');
    }
};

});

parcelRegister("gkItP", function(module, exports) {

$parcel$export(module.exports, "editGlobalThemeModal", () => $be4104706b9c2ee8$export$da28375a9545661a);
const $be4104706b9c2ee8$export$da28375a9545661a = {
    extends: '/add-global-theme-modal',
    ModalHeader: (el, s, ctx)=>({
            title: ctx.utils.toTitleCase(`${s.themeModifier?.slice(1)} Theme`),
            p: `Customise document ${s.themeModifier} theme`
        }),
    Preview: {},
    Flex_fields: {},
    Flex: {},
    ModalFooter: {
        CheckButton: {},
        'IconButton.trash': {
            icon: 'trash outline',
            onClick: async (ev, el, s)=>{
                const { themeModifier: themeModifier } = s;
                const theme = el.getDesignSystem('theme');
                const text = 'Do you want to remove the color?';
                if (themeModifier && window.confirm(text)) {
                    delete theme.document[themeModifier];
                    await el.updateDesignSystem({
                        theme: {
                            document: theme.document
                        }
                    });
                    el.call('closeRouterModal', el, s);
                }
            }
        }
    },
    props: {
        onInit: (el, s)=>{
            const theme = el.getDesignSystem('theme');
            if (!theme) return;
            const docThemes = theme.document;
            const themeModifier = s.key || window.location.pathname.split('global-theme/')[1];
            const value = docThemes[themeModifier];
            if (!value || !themeModifier) return;
            s.update({
                themeModifier: themeModifier,
                value: value
            }, {
                preventUpdate: true,
                preventContentUpdate: true
            });
        }
    }
};

});

parcelRegister("21gF2", function(module, exports) {

$parcel$export(module.exports, "editIconModal", () => $17889946289886d5$export$963409f53d76078b);
const $17889946289886d5$export$963409f53d76078b = {
    extend: '/add-icon-modal',
    ModalHeader: {
        title: 'Icon Preview',
        p: null
    },
    Flex: {},
    ModalFooter: {
        'IconButton.trash': {
            icon: 'trash outline',
            onClick: (ev, el, s)=>{
                const { iconName: iconName } = s;
                const text = 'Do you want to remove the icon?';
                if (iconName && window.confirm(text)) {
                    const icons = el.getDesignSystem('icons');
                    delete icons[iconName];
                    el.updateDesignSystem({
                        icons: icons
                    });
                    el.context.closeModal(el, s);
                }
            }
        }
    },
    on: {
        init: (el, s)=>{
            const path = window.location.pathname;
            const iconName = path.split('edit-icon/')[1];
            const icons = el.getDesignSystem('icons');
            if (!iconName) return;
            const DEFAULT_ICONS = el.getRootState().DEFAULT_ICONS;
            const iconInLib = (icons || DEFAULT_ICONS)[iconName] || DEFAULT_ICONS[iconName];
            if (!iconName || !iconInLib) return;
            s.update({
                iconName: iconName,
                src: iconInLib
            }, {
                preventUpdate: true
            });
        },
        submit: (e, el, s)=>{
            e.preventDefault();
        }
    }
};

});

parcelRegister("4Swxz", function(module, exports) {

$parcel$export(module.exports, "editMethodModal", () => $38d57270b226e3c2$export$5958ca6c5cc48e13);
const $38d57270b226e3c2$export$5958ca6c5cc48e13 = {
    extend: '/add-method-modal',
    ModalHeader: {
        title: 'Edit {{ key }} method'
    },
    Flex: {},
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}'
        },
        IconButton: {
            icon: 'trash outline',
            onClick: (ev, el, s, ctx)=>{
                // The item key comes from the route, the same read `on.init` makes —
                // a bare `key` here was never bound (a ReferenceError locally, and a
                // read off the shared globalScope once published).
                const key = el.call('getLastLocationPath').slice(1);
                const text = 'Do you want to remove the method?';
                if (key && window.confirm(text)) {
                    el.removeItem(s.parse());
                    el.call('closeRouterModal', el, s, ctx);
                }
            }
        }
    },
    on: {
        init: (el, s, ctx)=>{
            const key = el.call('getLastLocationPath').slice(1);
            const item = el.getItem(key);
            return item && s.quietReplace(item);
        },
        submit: (e, el, s, ctx)=>{
            e.preventDefault();
            el.updateItem(s.parse());
            ctx.utils.closeModal(el, s, ctx);
        }
    }
};

});

parcelRegister("agPef", function(module, exports) {

$parcel$export(module.exports, "editPageModal", () => $77a32300e2200588$export$a0f0d36c39ce1ec3);
const $77a32300e2200588$export$a0f0d36c39ce1ec3 = {
    extend: [
        '/edit-component-modal',
        '/add-page-modal'
    ],
    props: {
        onInit: (el, s)=>{
            let pageKey = s.key;
            if (!pageKey) {
                const route = el.call('getLastLocationPath');
                const isIndex = route === '/main' || route === '/index';
                pageKey = `/${(isIndex ? '/' : route).slice(1).replaceAll('..', '/')}`;
            }
            const item = el.getItem(pageKey, 'pages');
            return item && s.quietReplace(item);
        }
    },
    ModalHeader: {
        title: 'Edit {{ key }} page',
        p: 'Fill initial settings and choose a template'
    }
};

});

parcelRegister("84txb", function(module, exports) {

$parcel$export(module.exports, "editSecretModal", () => $5e059b53c6cc1fe4$export$763b8c55d86d1742);
const $5e059b53c6cc1fe4$export$763b8c55d86d1742 = {
    extends: '/add-secret-modal',
    ModalHeader: {
        title: 'Edit a secret',
        p: 'Edit secret hide keys while reusing in your functions'
    },
    Flex: {
        'InputField.key': {
            Input: {
                opacity: '.35',
                disabled: true,
                value: 'hidden'
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            minHeight: 'controlH',
            padding: '0 A',
            fontSize: 'Z2'
        },
        IconButton: {
            icon: 'trash outline',
            onClick: async (ev, el, s, ctx)=>{
                el.call('removeItem', 'secret', s.key);
                el.call('closeRouterModal');
            }
        }
    }
};

});

parcelRegister("3upCa", function(module, exports) {

$parcel$export(module.exports, "editSnippetModal", () => $28a80af38a6bafef$export$6d3af0ee7cc65340);
const $28a80af38a6bafef$export$6d3af0ee7cc65340 = {
    extend: '/add-snippet-modal',
    ModalHeader: {
        title: 'Edit {{ key }} snippet'
    },
    Flex: {},
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            icon: 'checkmark',
            text: '{{ common.action.save | polyglot }}'
        },
        IconButton: {
            icon: 'trash outline',
            onClick: (ev, el, s, ctx)=>{
                // The item key comes from the route, the same read `on.init` makes —
                // a bare `key` here was never bound (a ReferenceError locally, and a
                // read off the shared globalScope once published).
                const key = el.call('getLastLocationPath').slice(1);
                const text = 'Do you want to remove the snippet?';
                if (key && window.confirm(text)) {
                    el.removeItem(s.parse());
                    el.call('closeRouterModal', el, s, ctx);
                }
            }
        }
    },
    on: {
        init: (el, s, ctx)=>{
            const key = el.call('getLastLocationPath').slice(1);
            const item = el.getItem(key);
            return item && s.quietReplace(item);
        },
        submit: (e, el, s, ctx)=>{
            e.preventDefault();
            el.updateItem(s.parse());
            ctx.utils.closeModal(el, s, ctx);
        }
    }
};

});

parcelRegister("7Ha5w", function(module, exports) {

$parcel$export(module.exports, "feedbackModal", () => $59a45fd874319a01$export$4cc51e2a84772110);
const $59a45fd874319a01$export$4cc51e2a84772110 = {
    extends: 'ModalWindow',
    ModalHeader: {
        title: 'Let us know'
    },
    Flex: {}
};

});

parcelRegister("iFQsA", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $d984bfd28670a98f$export$e7aa7bc5c1b3cfb3);
const $d984bfd28670a98f$export$e7aa7bc5c1b3cfb3 = {
    props: {
        flexFlow: 'y',
        gap: 'C1',
        padding: 'D1',
        align: 'start'
    },
    state: {
        method: 'GET',
        type: 'state',
        headers: {},
        headersArr: [],
        params: {},
        paramsArr: [],
        auth: {},
        authArr: [],
        body: {},
        runtime: false,
        title: '',
        key: ''
    },
    GroupField: {
        width: '100%',
        Title: {
            text: '{{ editor.fetch.endpointUrl | polyglot }}'
        },
        Flex: {
            flow: 'x',
            align: 'stretch start',
            childProps: {
                borderRadius: 'Y',
                ':first-child': {
                    borderRadius: 'Y 0 0 Y'
                },
                ':last-child': {
                    borderRadius: '0 Y Y 0'
                }
            },
            SelectField: {
                Select: {
                    theme: null,
                    borderRadius: 'X2',
                    Get: {
                        text: 'Get',
                        value: 'GET'
                    },
                    Post: {
                        text: 'Post',
                        value: 'POST'
                    },
                    Patch: {
                        text: 'Patch',
                        value: 'PATCH'
                    },
                    Update: {
                        text: 'Update',
                        value: 'UPDATE'
                    },
                    Delete: {
                        text: 'Delete',
                        value: 'DELETE'
                    },
                    onChange: (event, element, state)=>{
                        state.update({
                            method: element.node.value
                        });
                        console.log(element.node.value);
                    }
                }
            },
            VerticalLine: {
                margin: 0,
                background: 'line-highlight'
            },
            Input_endpointUrl: {
                flex: 1,
                paddingBlock: 'Z1',
                placeholder: (el)=>el.call('polyglot', 'editor.fetch.routePlaceholder'),
                width: '400px',
                onInput: (event, element, state)=>{
                    state.quietUpdate({
                        endpointUrl: element.node.value
                    });
                }
            }
        }
    },
    Flex: {
        width: '100%',
        flow: 'y',
        gap: 'B2',
        childExtends: 'Flex',
        childProps: {
            flow: 'y',
            gap: 'Z2',
            align: 'start'
        },
        Params: {
            Flex: {
                flow: 'y',
                gap: 'Z2',
                align: 'start',
                hide: (el, s)=>!s.paramsArr.length,
                Span: {
                    color: 'paragraph',
                    text: '{{ editor.fetch.params | polyglot }}'
                },
                Flex: {
                    flow: 'y',
                    gap: 'Z',
                    childdisplay: 'flex',
                    childProps: {
                        gap: 'X2',
                        align: 'center',
                        // ——— the row-sync watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-FETCH-DS-1) ———
                        //
                        // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the
                        // framework registers it ONLY when a sibling `stateDeps` ARRAY
                        // exists, and no legacy `stateUpdate` event is emitted. This
                        // block shipped with NO `stateDeps` and the legacy `(_, el, s)`
                        // signature, so it never ran once — and it is the ONLY writer of
                        // an edited row back into the request, so a typed paramsArr pair
                        // never reached `paramsArr` / `params`.
                        //
                        // Deps (each self-contained — FA204): the row's own `key` and
                        // `value`, the pair the debounced `onInput` above writes. The
                        // handler writes to the PARENT state only, so it never re-enters.
                        stateDeps: [
                            (el, s)=>(s || {}).key,
                            (el, s)=>(s || {}).value
                        ],
                        // v3.14 signature: `(el, state, context, { prev, next })`.
                        onStateUpdate: (el, s, ctx, { prev: prev })=>{
                            const page = s.parent;
                            if (!page) return;
                            const rows = page.paramsArr || [];
                            const prevKey = prev[0];
                            const prevValue = prev[1];
                            // `childKey = rawChild.key || index` (create.js), so `el.key`
                            // is the PARAM NAME for every named row — an `el.key` index
                            // write would put a string property on the array. Locate the
                            // slot by the snapshot the row held BEFORE this edit.
                            let index = -1;
                            for(let i = 0; i < rows.length; i++){
                                const row = rows[i];
                                if (row && row.key === prevKey && row.value === prevValue) {
                                    index = i;
                                    break;
                                }
                            }
                            if (index < 0) {
                                const asIndex = parseInt(el.key, 10);
                                index = Number.isInteger(asIndex) ? asIndex : -1;
                            }
                            if (index > -1) rows[index] = s.parse();
                            const { key: key, value: value } = s;
                            const map = page.params;
                            // A renamed key must not leave the old entry in the request.
                            if (prevKey && prevKey !== key && map) delete map[prevKey];
                            if (!key || !value) return;
                            // Write THROUGH the map store, never `quietUpdate({ params: … })`:
                            // a store `update` merges only at the TOP level, so a nested
                            // `{ params: { [key]: value } }` REPLACES the whole map and
                            // erases every other row. A direct key write also skips the
                            // parent re-render that would rebuild the rows and drop the
                            // caret mid-typing.
                            if (map) map[key] = value;
                            else page.quietUpdate({
                                params: {
                                    [key]: value
                                }
                            });
                        },
                        childProps: (el)=>({
                                onInput: el.call('debounce', (event, element, state)=>{
                                    state.update({
                                        [element.key.split('_')[1]]: element.node.value
                                    });
                                }, 1000)
                            }),
                        Input_key: {
                            padding: 'Z A',
                            value: '{{ key }}',
                            placeholder: (el)=>el.call('polyglot', 'editor.fetch.paramKey')
                        },
                        Input_value: {
                            padding: 'Z A',
                            value: '{{ value }}',
                            placeholder: (el)=>el.call('polyglot', 'editor.fetch.paramValue')
                        },
                        IconButton: {
                            icon: 'trash',
                            onClick: (ev, el, s)=>{
                                s.parent.apply((s2)=>{
                                    delete s2.params[s2.key];
                                    s2.paramsArr.splice(parseInt(el.parent.key, 10), 1);
                                });
                            }
                        }
                    },
                    children: (el, s)=>s.paramsArr,
                    childrenAs: 'state'
                }
            },
            AddItemButton: {
                Caption: {
                    text: '{{ editor.fetch.addParams | polyglot }}'
                },
                onClick: (ev, el, s)=>{
                    s.apply((s2)=>{
                        s2.paramsArr.push({});
                    });
                }
            }
        },
        Auth: {
            Flex: {
                flow: 'y',
                gap: 'Z2',
                align: 'start',
                hide: (el, s)=>!s.authArr.length,
                Span: {
                    color: 'paragraph',
                    text: '{{ editor.fetch.auth | polyglot }}'
                },
                Flex: {
                    flow: 'y',
                    gap: 'Z',
                    childdisplay: 'flex',
                    childProps: {
                        gap: 'X2',
                        align: 'center',
                        // ——— the row-sync watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-FETCH-DS-1) ———
                        //
                        // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the
                        // framework registers it ONLY when a sibling `stateDeps` ARRAY
                        // exists, and no legacy `stateUpdate` event is emitted. This
                        // block shipped with NO `stateDeps` and the legacy `(_, el, s)`
                        // signature, so it never ran once — and it is the ONLY writer of
                        // an edited row back into the request, so a typed authArr pair
                        // never reached `authArr` / `auth`.
                        //
                        // Deps (each self-contained — FA204): the row's own `key` and
                        // `value`, the pair the debounced `onInput` above writes. The
                        // handler writes to the PARENT state only, so it never re-enters.
                        stateDeps: [
                            (el, s)=>(s || {}).key,
                            (el, s)=>(s || {}).value
                        ],
                        // v3.14 signature: `(el, state, context, { prev, next })`.
                        onStateUpdate: (el, s, ctx, { prev: prev })=>{
                            const page = s.parent;
                            if (!page) return;
                            const rows = page.authArr || [];
                            const prevKey = prev[0];
                            const prevValue = prev[1];
                            // `childKey = rawChild.key || index` (create.js), so `el.key`
                            // is the PARAM NAME for every named row — an `el.key` index
                            // write would put a string property on the array. Locate the
                            // slot by the snapshot the row held BEFORE this edit.
                            let index = -1;
                            for(let i = 0; i < rows.length; i++){
                                const row = rows[i];
                                if (row && row.key === prevKey && row.value === prevValue) {
                                    index = i;
                                    break;
                                }
                            }
                            if (index < 0) {
                                const asIndex = parseInt(el.key, 10);
                                index = Number.isInteger(asIndex) ? asIndex : -1;
                            }
                            if (index > -1) rows[index] = s.parse();
                            const { key: key, value: value } = s;
                            const map = page.auth;
                            // A renamed key must not leave the old entry in the request.
                            if (prevKey && prevKey !== key && map) delete map[prevKey];
                            if (!key || !value) return;
                            // Write THROUGH the map store, never `quietUpdate({ auth: … })`:
                            // a store `update` merges only at the TOP level, so a nested
                            // `{ auth: { [key]: value } }` REPLACES the whole map and
                            // erases every other row. A direct key write also skips the
                            // parent re-render that would rebuild the rows and drop the
                            // caret mid-typing.
                            if (map) map[key] = value;
                            else page.quietUpdate({
                                auth: {
                                    [key]: value
                                }
                            });
                        },
                        childProps: (el)=>({
                                onInput: el.call('debounce', (event, element, state)=>{
                                    state.update({
                                        [element.key.split('_')[1]]: element.node.value
                                    });
                                }, 1000)
                            }),
                        Input_key: {
                            padding: 'Z A',
                            value: '{{ key }}',
                            placeholder: (el)=>el.call('polyglot', 'editor.fetch.authKey')
                        },
                        Input_value: {
                            padding: 'Z A',
                            value: '{{ value }}',
                            placeholder: (el)=>el.call('polyglot', 'editor.fetch.authValue')
                        },
                        IconButton: {
                            icon: 'trash',
                            onClick: (ev, el, s)=>{
                                s.parent.apply((s2)=>{
                                    delete s2.auth[s2.key];
                                    s2.authArr.splice(parseInt(el.parent.key, 10), 1);
                                });
                            }
                        }
                    },
                    children: (el, s)=>s.authArr,
                    childrenAs: 'state'
                }
            },
            AddItemButton: {
                Caption: {
                    text: '{{ editor.fetch.addAuth | polyglot }}'
                },
                onClick: (ev, el, s)=>{
                    s.apply((s2)=>{
                        s2.authArr.push({});
                    });
                }
            }
        },
        Headers: {
            Flex: {
                flow: 'y',
                gap: 'Z2',
                align: 'start',
                hide: (el, s)=>!s.headersArr.length,
                Span: {
                    color: 'paragraph',
                    text: '{{ editor.fetch.headers | polyglot }}'
                },
                Flex: {
                    flow: 'y',
                    gap: 'Z',
                    childdisplay: 'flex',
                    childProps: {
                        gap: 'X2',
                        align: 'center',
                        // ——— the row-sync watcher (WS-DEAD-ONSTATEUPDATE-HOOKS-FETCH-DS-1) ———
                        //
                        // `onStateUpdate` is a DECLARATIVE effect in DOMQL v3.14: the
                        // framework registers it ONLY when a sibling `stateDeps` ARRAY
                        // exists, and no legacy `stateUpdate` event is emitted. This
                        // block shipped with NO `stateDeps` and the legacy `(_, el, s)`
                        // signature, so it never ran once — and it is the ONLY writer of
                        // an edited row back into the request, so a typed headersArr pair
                        // never reached `headersArr` / `headers`.
                        //
                        // Deps (each self-contained — FA204): the row's own `key` and
                        // `value`, the pair the debounced `onInput` above writes. The
                        // handler writes to the PARENT state only, so it never re-enters.
                        stateDeps: [
                            (el, s)=>(s || {}).key,
                            (el, s)=>(s || {}).value
                        ],
                        // v3.14 signature: `(el, state, context, { prev, next })`.
                        onStateUpdate: (el, s, ctx, { prev: prev })=>{
                            const page = s.parent;
                            if (!page) return;
                            const rows = page.headersArr || [];
                            const prevKey = prev[0];
                            const prevValue = prev[1];
                            // `childKey = rawChild.key || index` (create.js), so `el.key`
                            // is the PARAM NAME for every named row — an `el.key` index
                            // write would put a string property on the array. Locate the
                            // slot by the snapshot the row held BEFORE this edit.
                            let index = -1;
                            for(let i = 0; i < rows.length; i++){
                                const row = rows[i];
                                if (row && row.key === prevKey && row.value === prevValue) {
                                    index = i;
                                    break;
                                }
                            }
                            if (index < 0) {
                                const asIndex = parseInt(el.key, 10);
                                index = Number.isInteger(asIndex) ? asIndex : -1;
                            }
                            if (index > -1) rows[index] = s.parse();
                            const { key: key, value: value } = s;
                            const map = page.headers;
                            // A renamed key must not leave the old entry in the request.
                            if (prevKey && prevKey !== key && map) delete map[prevKey];
                            if (!key || !value) return;
                            // Write THROUGH the map store, never `quietUpdate({ headers: … })`:
                            // a store `update` merges only at the TOP level, so a nested
                            // `{ headers: { [key]: value } }` REPLACES the whole map and
                            // erases every other row. A direct key write also skips the
                            // parent re-render that would rebuild the rows and drop the
                            // caret mid-typing.
                            if (map) map[key] = value;
                            else page.quietUpdate({
                                headers: {
                                    [key]: value
                                }
                            });
                        },
                        childProps: (el)=>({
                                onInput: el.call('debounce', (event, element, state)=>{
                                    state.update({
                                        [element.key.split('_')[1]]: element.node.value
                                    });
                                }, 1000)
                            }),
                        Input_key: {
                            padding: 'Z A',
                            value: '{{ key }}',
                            placeholder: (el)=>el.call('polyglot', 'editor.fetch.headerKey')
                        },
                        Input_value: {
                            padding: 'Z A',
                            value: '{{ value }}',
                            placeholder: (el)=>el.call('polyglot', 'editor.fetch.headerValue')
                        },
                        IconButton: {
                            icon: 'trash',
                            onClick: (ev, el, s)=>{
                                s.parent.apply((s2)=>{
                                    delete s2.headers[s2.key];
                                    s2.headersArr.splice(parseInt(el.parent.key, 10), 1);
                                });
                            }
                        }
                    },
                    children: (el, s)=>s.headersArr,
                    childrenAs: 'state'
                }
            },
            AddItemButton: {
                Caption: {
                    text: '{{ editor.fetch.addHeaders | polyglot }}'
                },
                onClick: (ev, el, s)=>{
                    s.apply((s2)=>{
                        s2.headersArr.push({});
                    });
                }
            }
        },
        BodyParam: {
            if: (el, s)=>[
                    'post',
                    'update'
                ].includes(s.method.toLowerCase()),
            flow: 'y',
            gap: 'X2',
            align: 'stretch',
            width: '100%',
            Span: {
                hide: (el, s)=>!s.showBody,
                color: 'paragraph',
                text: '{{ editor.fetch.body | polyglot }}',
                width: '100%'
            },
            CodePreviewWidget: {
                hide: (el2, s2)=>!s2.showBody,
                minWidth: '100%',
                widthRange: null,
                theme: 'field-static',
                round: 'X2',
                padding: 'X2 X2 X2 -',
                minHeight: 'G1',
                props: (el, s)=>({
                        Monaco: {
                            foldLevel: false,
                            opacity: 1,
                            fileTab: {
                                code: el.call('stringifyCode', s.value, el, s),
                                type: 'javascript',
                                filename: 'function.js',
                                fileTabKey: 'function'
                            },
                            onCodeEditCallback: async (editor)=>{
                                s.quietReplace({
                                    body: await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue())
                                });
                            }
                        }
                    })
            },
            AddItemButton: {
                IconButton: {
                    icon: (el, s)=>s.showBody ? 'crossmark' : 'plus'
                },
                Caption: {
                    text: (el, s)=>el.call('polyglot', s.showBody ? 'editor.fetch.removeBody' : 'editor.fetch.addBody')
                },
                onClick: (ev, el, s)=>{
                    s.apply((s2)=>{
                        s2.toggle('showBody');
                    });
                }
            }
        }
    },
    ContinueButton: {
        alignSelf: 'start',
        text: '{{ editor.fetch.previewRequest | polyglot }}',
        onClick: async (ev, el, s)=>{
            try {
                const response = await el.call('sendRequest', s.parse());
                console.log(response);
                s.update({
                    value: response
                });
            } catch (ex) {
                if (ex?.message) return el.call('openNotification', {
                    title: el.call('polyglot', 'editor.fetch.error'),
                    message: ex.message,
                    type: 'error'
                });
            }
        }
    },
    CodePreviewWithTitle: {
        Line: {
            order: '-3',
            width: '100%'
        },
        width: '100%',
        maxWidth: '50vw',
        hide: (el, s)=>!s.value,
        value: (el, s)=>JSON.stringify(s.value),
        onUpdate: async (el, s)=>{
            const code = el.call('stringifyCode', s.value);
            const value = await el.call('prettifyCode', code);
            return el.setProps({
                value: value
            }, {
                preventUpdateListener: true
            });
        },
        CodePreview: {
            maxHeight: 'H+C1'
        }
    },
    Saving: {
        width: '100%',
        flexFlow: 'y',
        flexAlign: 'start start',
        gap: 'C1',
        hide: (el, s)=>!s.value,
        Line: {
            order: '-3',
            width: '100%'
        },
        TitleField: {
            key: 'title',
            Title: {
                text: '{{ editor.fetch.stateTitle | polyglot }}'
            },
            Input: {
                placeholder: (el)=>el.call('polyglot', 'editor.fetch.stateTitlePlaceholder')
            }
        },
        TitleField_key: {
            key: 'key',
            Title: {
                text: '{{ editor.fetch.stateKey | polyglot }}'
            },
            Input: {
                placeholder: (el)=>el.call('polyglot', 'editor.fetch.stateKeyPlaceholder')
            }
        },
        SwitchFieldWithCaption: {
            Caption: {
                text: '{{ editor.fetch.runtime | polyglot }}'
            },
            onChange: (ev, el, s)=>s.toggle('runtime')
        },
        CodePreviewWithTitle: {
            maxWidth: '50vw',
            show: (el, s)=>s.runtime,
            value: (el)=>el.call('codifyFetch')
        },
        SaveButton: {
            extends: 'ContinueButton',
            tag: 'button',
            alignSelf: 'start',
            type: 'submit',
            text: '{{ common.action.save | polyglot }}',
            onClick: async (ev, el, s)=>{
                // if (runtime) {
                //   element.getRootState()[title] = resolve(data)
                // } else {
                // }
                // `message: `${ex}`` used to stand here in both branches — `ex` is a
                // catch binding belonging to a DIFFERENT handler further up this file
                // (the fetch-preview `catch (ex)`), never in scope here. ESM is strict
                // mode, so clicking Save with an empty key or value threw
                // `ReferenceError: ex is not defined` instead of showing the
                // validation notice. There is no exception to report in either branch;
                // the message states what is missing.
                if (!s.key) return el.call('openNotification', {
                    title: el.call('polyglot', 'editor.fetch.keyRequired.title'),
                    message: el.call('polyglot', 'editor.fetch.keyRequired.message'),
                    type: 'error'
                });
                if (!s.value) return el.call('openNotification', {
                    title: el.call('polyglot', 'editor.fetch.valueRequired.title'),
                    message: el.call('polyglot', 'editor.fetch.valueRequired.message'),
                    type: 'error'
                });
                const { runtime: runtime } = s;
                if (runtime) {
                    s.value = el.call('codifyFetch');
                    console.log(s.value);
                }
                // `${key}` was a bare undeclared identifier here too — the entry's key
                // lives on this element's own state, which the guard above already
                // reads as `s.key`.
                const data = el.sdk.addItem(s.type, s.parse(), {
                    message: `Added state section ${s.key}`
                });
                console.log(data);
            }
        }
    }
};

});

parcelRegister("55lAe", function(module, exports) {

$parcel$export(module.exports, "grids", () => $3b3e2960e4c5a617$export$5c5a246395cc6cbc);
const $3b3e2960e4c5a617$export$5c5a246395cc6cbc = {
    P: {
        text: '{{ editor.panel.grids | polyglot }}',
        margin: '0 - Z2',
        userSelect: 'none',
        color: 'inactive',
        fontSize: 'Y',
        textTransform: 'uppercase'
    }
};

});

parcelRegister("4BEj7", function(module, exports) {

$parcel$export(module.exports, "icons", () => $35a9e25794199b6e$export$df03f54e09e486fa);
const $35a9e25794199b6e$export$df03f54e09e486fa = {
    props: {},
    SectionHeader: {
        props: {
            margin: '- - B1'
        },
        heading: {
            Title: {
                text: '{{ editor.panel.icons | polyglot }}'
            }
        },
        nav: {
            add: {
                props: ()=>({
                        icon: 'plus',
                        href: window.location.pathname + '/add-icon'
                    })
            }
        }
    },
    Flex: {
        flow: 'y',
        gap: 'C1',
        lazyLoad: true,
        childExtends: 'IconsGroup',
        childrenAs: 'state',
        children: (el)=>false
    }
};

});

parcelRegister("7LjA6", function(module, exports) {

$parcel$export(module.exports, "identityRoutes", () => $5a6c1c9cbe41c9e8$export$745f4dfb133ff3f8);
$parcel$export(module.exports, "login", () => (parcelRequire("61AX5")).signin);
$parcel$export(module.exports, "signin", () => (parcelRequire("61AX5")).signin);
$parcel$export(module.exports, "signup", () => (parcelRequire("4pida")).signup);
$parcel$export(module.exports, "signupConfirmation", () => (parcelRequire("b2cOO")).signupConfirmation);
$parcel$export(module.exports, "resetPassword", () => (parcelRequire("d0MBX")).resetPassword);
$parcel$export(module.exports, "authCallback", () => (parcelRequire("5ilmn")).callback);
$parcel$export(module.exports, "magicCallback", () => (parcelRequire("4prUv")).magicCallback);
$parcel$export(module.exports, "profile", () => (parcelRequire("2eE8e")).profile);
// Identity pages — consumed via sharedLibraries; each app's pages/index.js
// imports from here rather than maintaining its own copy.
//
// Admin pages are NOT re-exported here (deleted 2026-08-21,
// WORKSPACE-SHELL-UNDECLARED-IMPORTS-1): a top-level re-export of a
// `@symbo-ls/workspace-shell/pages/admin/*` import is stubbed by frank at
// push time and published as `""`, which then shadowed the shell's real
// values in every consumer (FRANK-PAGES-BAG-1). The shell lazy-loads
// /admin/* from its own local source and declares itself where needed.
parcelRequire("fEKlv");
var $61AX5 = parcelRequire("61AX5");

var $61AX5 = parcelRequire("61AX5");

var $4pida = parcelRequire("4pida");

var $b2cOO = parcelRequire("b2cOO");

var $d0MBX = parcelRequire("d0MBX");

var $5ilmn = parcelRequire("5ilmn");

var $4prUv = parcelRequire("4prUv");

var $2eE8e = parcelRequire("2eE8e");
const $5a6c1c9cbe41c9e8$export$745f4dfb133ff3f8 = {
    '/login': (0, $61AX5.signin),
    '/signin': (0, $61AX5.signin),
    '/signup': (0, $4pida.signup),
    '/signup-confirmation': (0, $b2cOO.signupConfirmation),
    '/reset-password': (0, $d0MBX.resetPassword),
    '/auth/callback': (0, $5ilmn.callback),
    '/github-auth-callback': (0, $5ilmn.callback),
    '/auth/magic-callback': (0, $4prUv.magicCallback),
    // `/settings` is the canonical route for the signed-in user's own
    // account screen (profile fields, availability, equity, notifications,
    // sessions, danger zone). `/profile` stays as a legacy alias because
    // PersonCard, ProfileModal, admin tools still link with `?u=<email>`
    // for cross-user viewing. Public profiles live at `/user/:slug`.
    '/settings': (0, $2eE8e.profile),
    '/profile': (0, $2eE8e.profile)
};

});
parcelRegister("fEKlv", function(module, exports) {

$parcel$export(module.exports, "login", () => (parcelRequire("61AX5")).signin);
// /login is an alias for /signin — both render the LoginWindow chrome
// (modal-style card with Google/GitHub OAuth + email/password form).
// Keep the export name `login` so existing route tables
// (workspace-project/pages/index.js maps `/login` to it) don't change.

var $61AX5 = parcelRequire("61AX5");

});
parcelRegister("61AX5", function(module, exports) {

$parcel$export(module.exports, "signin", () => $462f7ffb76d3f0a1$export$54f63e0bb65a6adc);
// The handoff, OAuth-next and redirect-query helpers are registered shared
// functions (functions/index.js) and are reached through `el.call` — no
// sibling imports (FA001). The auth page theme is the one import left: a
// style object with no registered home yet.

var $lJuW8 = parcelRequire("lJuW8");
const $462f7ffb76d3f0a1$export$54f63e0bb65a6adc = {
    extends: 'Page',
    // The tab title. A white-label host shows "<page> / <org>", like every
    // other page (pageTitle); helmet re-runs this factory when the brand lands.
    // While the brand is still loading on such a host the factory answers NO
    // title, so helmet leaves the current one — the edge stamps the org name
    // into the first <title> — instead of flashing "… / Symbols" (relman,
    // vault.pr: 2,487 ms "… / Symbols" before the brand). A platform host keeps
    // its own title. isCustomDomainHost is a shell function; elsewhere it is not
    // registered and the page is a platform surface.
    metadata: (el)=>{
        const brandNameNow = el.state?.root?.whitelabelBrand?.name;
        if (brandNameNow) return {
            title: el.call('pageTitle', 'auth.page.signin.titlePlain')
        };
        const fns = el.context?.functions;
        const whiteLabelHost = typeof fns?.isCustomDomainHost === 'function' && !!el.call('isCustomDomainHost');
        if (whiteLabelHost) return {
            title: undefined
        };
        return {
            title: el.call('polyglot', 'auth.page.signin.title')
        };
    },
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    '@mobileL': {
        padding: 'A'
    },
    width: '100%',
    height: '100dvh',
    maxWidth: 'none',
    ...(0, $lJuW8.authPageTheme),
    // Initial state so `s.loading` is reactively read from the first
    // paint — CheckButton in LoginForm binds text/disabled/opacity to it.
    state: {
        loading: false,
        identifier: '',
        password: ''
    },
    onRender: (el)=>el.call('stashOAuthNext'),
    // Cross-origin auto-handoff: a signed-in user landing here via the
    // preview's bounce (`?redirect=<previewUrl>`) shouldn't have to retype
    // their credentials. If the SDK already holds a valid session, mint a
    // handoff fragment immediately and bounce back to the preview. Without
    // this the preview's `_redirectToWorkspaceLogin` traps the user in
    // this form even though every credential they'd type is one they
    // already have. Caught live 2026-05-18 on hotcard's preview.
    //
    // AUTH-HANDOFF-NARROW-TARGETS: a target that renders a user project (a
    // `<owner>--<key>` preview host) is handed the session only after the
    // server confirms the project is private AND this user may read it
    // (`confirmHandoffTarget`). The shell's cold-boot guard
    // (redirectIfUnauthed) defers exactly those targets to this hook. A
    // refused project target sends the signed-in user home, never to the
    // target.
    onInit: async (el, s)=>{
        if (typeof window === 'undefined') return;
        const redirectParam = new URL(window.location.href).searchParams.get('redirect');
        if (!redirectParam) return;
        const verdict = el.call('classifyHandoffTarget', redirectParam).verdict;
        if (verdict === 'refused') return;
        const sdk = el.sdk;
        if (!sdk || typeof sdk.getAuthToken !== 'function') return;
        const accessToken = sdk.getAuthToken();
        if (!accessToken) return;
        let me = null;
        try {
            me = await sdk.getMe?.();
        } catch (_) {
            return;
        }
        if (!me) return;
        if (!await el.call('confirmHandoffTarget', redirectParam, sdk)) {
            console.warn('[signin] handoff refused: the server did not confirm access to the target project');
            if (verdict === 'confirm') try {
                await el.router('/', el.getRoot());
            } catch (_) {
            /* router not ready — the signed-in user stays on this page */ }
            return;
        }
        // Best-effort refresh-token discovery — SDK doesn't expose a sync
        // accessor but it's persisted under the canonical key.
        const refreshToken = window.localStorage.getItem('symbols_refresh_token') || '';
        const payload = el.call('encodeHandoffPayload', {
            accessToken: accessToken,
            refreshToken: refreshToken,
            expiresAt: 0,
            expiresIn: 0
        });
        // frank-allow FA401 — full-page handoff to a trusted target (same origin or local dev), fragment only when cross-origin
        window.location.replace(el.call('appendHandoffFragment', redirectParam, payload));
    },
    // WHITELABEL-BRANDED-BOOT-1 — on a host whose org has a branding record,
    // this page renders the standalone branded surface INSTEAD of the generic
    // LoginWindow. `root.whitelabelBrand` is resolved pre-auth and is null on
    // every platform host and on any custom domain without a record, so
    // my.symbols.app / canvas / preview / marketplace are byte-identical to
    // before. `hide` AND an explicit `display` on both slots: `if:` is inert in
    // this v3.14 build and FW-HIDE-UNAPPLIED-1 can clobber a first-run-true
    // `hide` (fixed in unpublished smbls 7031e3d60).
    //
    // ⚠️ Rendered HERE rather than registered as a route: '/signin' and
    // '/login' live in three page maps merged at boot, and a route-level
    // registration was silently out-voted (measured — shellPages held the
    // branded page while the live context resolved the shared one).
    WhitelabelSignin: {
        hide: (el, s)=>!(s.root && s.root.whitelabelBrand),
        display: (el, s)=>s.root && s.root.whitelabelBrand ? 'flex' : 'none'
    },
    LoginWindow: {
        hide: (el, s)=>!!(s.root && s.root.whitelabelBrand),
        // TWO REAL BRANCHES. This was `: null`, a TOMBSTONE that deletes the
        // INHERITED declaration — and LoginWindow declares `flow: 'column'`
        // (components/LoginWindow.js:115), which is a flex display. So on the
        // ORDINARY non-white-label path — the common case — the erased
        // declaration dropped the window from a flex column to a block, taking
        // its whole internal layout with it.
        // `'flex'` is the value `flow: 'column'` resolves to, and it matches
        // both the sibling `WhitelabelSignin` six lines above and
        // LoginWindow.js:508, which already write two real branches.
        display: (el, s)=>s.root && s.root.whitelabelBrand ? 'none' : 'flex',
        // THE ADDRESS A FINISHED SIGN-UP HANDS OVER (R2-m10, persona sam typed it
        // again). The sign-up card opens the new account itself when it can
        // (signup.js openSignupSession); when it cannot, it sends the person here
        // with the address in the ROOT state (`_signInEmail`), never in the URL.
        // Read once, here, before the form exists, and cleared. The copy for the
        // field lives on this element (`__handedEmail`), not in state: a `state`
        // block here would REPLACE LoginWindow's own declaration (loading,
        // identifier, password), and the field must not track anything reactive.
        onInit: (el, s)=>{
            const handed = s.root && s.root._signInEmail;
            if (!handed) return;
            el.__handedEmail = handed;
            s.quietUpdate({
                identifier: handed
            });
            s.root.update({
                _signInEmail: ''
            });
        },
        Flex: {
            LoginForm: {
                Flex: {
                    Identifier: {
                        Input: {
                            // The handed address, once, at creation. A value bound to the
                            // typed `identifier` raced with typing (LoginForm.js); this one
                            // reads no state, so typing never writes it back.
                            value: (el)=>{
                                const card = typeof el.lookup === 'function' ? el.lookup('LoginWindow') : null;
                                return card && card.__handedEmail || '';
                            }
                        }
                    },
                    Password: {
                        Input: {
                            // With the address in the field, the password is the one field
                            // left: the cursor waits there. `onMounted`, not `onRender`: the
                            // form is built before it is attached, and a focus then is lost.
                            onMounted: (el)=>{
                                const card = typeof el.lookup === 'function' ? el.lookup('LoginWindow') : null;
                                if (!card || !card.__handedEmail) return;
                                if (el.node && typeof el.node.focus === 'function') el.node.focus();
                            }
                        }
                    }
                }
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            // Read from LoginWindow state (mirrored from inputs via their
            // onInput handlers in LoginForm). Reading `input.value` directly
            // here is unreliable — Chrome's password manager clears the
            // type=password field at form-submission time as a privacy
            // measure, so a DOM read returns '' even though the user typed.
            const root = el.node;
            const identifier = (s.identifier || root.querySelector('input[autocomplete="username"]')?.value || '').trim().toLowerCase();
            const password = s.password || root.querySelector('input[type="password"]')?.value || '';
            if (!identifier || !password) {
                el.call('openNotification', {
                    title: el.call('polyglot', 'auth.signin.missingFields.title'),
                    message: el.call('polyglot', 'auth.signin.missingFields.message'),
                    type: 'error'
                });
                return;
            }
            s.update({
                loading: true
            });
            try {
                const pluginSession = el.call('getPluginSessionFromUrl');
                const loginResult = pluginSession ? await el.sdk.login(identifier, password, {
                    session: pluginSession
                }) : await el.sdk.login(identifier, password);
                // A sign-in on this origin: its refresh token is its own (review D1).
                el.call('markOwnSession');
                await el.call('initializeUserSession', {
                    loginData: loginResult
                });
                // Cross-origin handoff: when `?redirect=<previewUrl>` is set
                // AND the target passes confirmHandoffTarget (a trusted host, or a
                // project host the server confirms for this user), mint a fragment
                // handoff and replace location instead of routing into the
                // dashboard. This is what makes `https://<x>.preview.symbols.app/...`
                // bounce through `my.symbols.app/signin` and come back signed-in.
                const redirectParam = typeof window !== 'undefined' ? new URL(window.location.href).searchParams.get('redirect') : null;
                if (redirectParam && await el.call('confirmHandoffTarget', redirectParam, el.sdk)) {
                    const tokens = loginResult?.tokens || loginResult?.data?.tokens || {};
                    const accessToken = tokens.accessToken || tokens.access_token || (typeof el.sdk.getAuthToken === 'function' ? el.sdk.getAuthToken() : null);
                    const refreshToken = tokens.refreshToken || tokens.refresh_token || '';
                    const expiresIn = tokens.accessTokenExp?.expiresIn || tokens.expiresIn || tokens.expires_in || 0;
                    const expiresAt = expiresIn ? Date.now() + expiresIn * 1000 : 0;
                    if (accessToken) {
                        const payload = el.call('encodeHandoffPayload', {
                            accessToken: accessToken,
                            refreshToken: refreshToken,
                            expiresAt: expiresAt,
                            expiresIn: expiresIn
                        });
                        const target = el.call('appendHandoffFragment', redirectParam, payload);
                        // frank-allow FA401 — full-page handoff to a trusted target (same origin or local dev), fragment only when cross-origin
                        window.location.replace(target);
                        return;
                    }
                }
                // SIGNUP-INTENT — with no explicit `next`, a paid plan picked on
                // symbols.app/built-with opens its checkout once
                // (functions/signupIntent.js).
                const next = (typeof window !== 'undefined' ? new URL(window.location.href).searchParams.get('next') : null) || el.call('takeSignupCheckoutNext');
                s.update({
                    loading: false
                });
                // smbls's router is async; awaiting routes the rejection
                // through the outer try/catch instead of surfacing as an
                // unhandled-in-promise (`Cannot read properties of undefined
                // (reading '/*')` when the auth-state remount transiently
                // leaves `el.getRoot().routes` undefined).
                //
                // withLiveQuery carries the CURRENT address bar's query/hash (e.g.
                // `?claim=credits`) onto a BARE `'/'` bounce — tickets/sonnet.md
                // "auth-page redirects still drop the query" — a bare `'/'`
                // silently dropped it (same class the router ticket fixed one
                // layer up, opus.md workspace 6d146d9a). Only applied when `next`
                // is absent: `next` is already a fully-specified destination
                // (frequently carrying its own query, e.g. `/accept-invite?token=…`
                // from accept-invite.js's `/login?next=…` bounce) — appending the
                // CURRENT page's raw query string on top of it would re-embed a
                // redundant `next=` param and, worse, produce a malformed
                // double-`?` URL whenever `next`'s own target already has a query.
                await el.router(next || el.call('withLiveQuery', '/'), el.getRoot());
            } catch (error) {
                // Classify: an incorrect-credentials response (401 / "password
                // is incorrect" / "invalid credentials") is a normal user-typo
                // path, not a system fault — surface via the in-UI notification
                // below, but log at `debug` instead of `error` so it doesn't
                // pollute /logs/bugs with one warn per failed-typo. Real
                // failures (5xx, network, malformed response) keep the error
                // log so the analyze pipeline still picks them up.
                const msg = error?.message || String(error);
                const isCredentialFailure = error?.status === 401 || /password is incorrect/i.test(msg) || /invalid credentials/i.test(msg) || /user not found/i.test(msg);
                if (isCredentialFailure) console.debug('[signin] credential check failed:', msg);
                else console.error('Failed to sign in:', error);
                s.update({
                    loading: false
                });
                el.call('openNotification', {
                    title: el.call('polyglot', 'auth.signin.failed'),
                    message: error?.message || el.call('polyglot', 'auth.signin.failedMessage'),
                    type: 'error'
                });
            }
        }
    }
};

});


parcelRegister("4pida", function(module, exports) {

$parcel$export(module.exports, "signup", () => $33579f9ec88ba575$export$7200a869094fec36);
// Signup page — same LoginWindow chrome as /signin so OAuth works as
// "sign up with Google/GitHub" (sdk.googleAuth / sdk.githubAuth on
// the Symbols server upserts the user, so first-time vs returning
// is handled server-side), and the email/password path uses
// SignupForm with the SDK register call.
//
// PERSONA AUDIT r1 (elena: 150% zoom; sam: keyboard only) — what this page now
// does beyond the form:
//   • the keyboard order IS the visual order: the form first, the OAuth column
//     after it (the white-label mixin used to come first in `extends`, which put
//     its `RequestAccessButtons` slot ahead of the form in the DOM);
//   • the right column speaks sign-up ("Another way to sign up", "Continue with
//     Google"), the form says where an existing account signs in, and the
//     privacy policy + terms are two links under the button;
//   • the password rule is printed under the field — the server's rule as a
//     live checklist when the SDK can read the sign-up policy, the rule's own
//     sentence otherwise;
//   • a finished sign-up STAYS on this page: "Check your email" names the
//     address, says whether the mail went out, and hands the person on with
//     one button — into the new account, signed in (`register` answers with
//     the account's session; R2-m10), or, when there is no session to open, to
//     sign-in with the address already in the field. It used to be a
//     bottom-centre toast on the NEXT page (it covered the Google button at
//     150% zoom, vanished in 3.5 s, named no address) and focus fell to <body>
//     on the page change. Focus now lands on the heading and the message is
//     read from an always-mounted live region;
//   • the page's own errors are told IN the form, not in a bottom-centre toast
//     (at 150% zoom the toast sat on the Sign up button): an empty submit or a
//     failed register in a line above the button, a refused password in a line
//     under the rule;
//   • a short screen scrolls and the card keeps its content (see the card's
//     `flexShrink` below).

var $klqGv = parcelRequire("klqGv");

var $lJuW8 = parcelRequire("lJuW8");
// A visually hidden box that stays in the accessibility tree — the sr-only
// idiom of components/PageSrTitle.js, in tokens: never display / visibility /
// opacity, those take the text out of the one place it has to be. Spread into
// definitions at load; no handler reads it.
const $33579f9ec88ba575$var$SR_ONLY = {
    position: 'absolute',
    width: 'hairline',
    height: 'hairline',
    padding: '0',
    border: '0',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap'
};
// Seed the form from the invitation in `?token=`. An EMAILED invitation names
// its address: the field is set to it and locked (the server accepts only that
// address). A MAGIC LINK (INVITE-MAGIC-LINK-1) names none: the field stays
// empty and editable — any address may join through it. It used to lock the
// field for ANY token, which on a magic link left an empty field nobody could
// type into. The claims are read for the form only, never for access
// (functions/inviteToken.js); a malformed token seeds nothing.
//
// Runs on the LoginWindow (its onInit, below): LoginWindow declares its own
// state, and that is the scope SignupForm reads — a write to the PAGE state
// never reached the field (same reason as reset-password.js).
const $33579f9ec88ba575$var$_seedFromInviteToken = (el, s, token)=>{
    if (typeof window === 'undefined') return;
    if (!token) return;
    const claims = el.call('inviteTokenClaims', token);
    if (claims && claims.email) s.quietUpdate({
        email: claims.email,
        hasToken: true,
        inviteEmailBound: true
    });
    else if (claims) s.quietUpdate({
        hasToken: false,
        inviteEmailBound: false
    });
};
// Name the org the invite joins (INVITE-JOIN-PAGE-
// PERSONALIZED-1) so signup can say "Join Acme" instead of the generic
// headline. Feature-detected: no preview method (older SDK/server) or a
// dead token just keeps the generic copy — never blocks the form.
const $33579f9ec88ba575$var$_seedInvitePreview = async (el, s, token)=>{
    if (typeof window === 'undefined') return;
    try {
        if (!token || typeof el.sdk?.getInvitationPreview !== 'function') return;
        const res = await el.sdk.getInvitationPreview({
            token: token
        });
        const p = res?.data || res || null;
        // The ORGANIZATION's name heads the card — "Join <org>" for every invite
        // (Nika 2026-10-14: "instead of 'Join Default' we say 'Join orgname'"; a
        // workspace name such as an org's default "Default" says nothing to an
        // invitee). The workspace name is the fallback for an older preview that
        // carries no org name.
        const name = p?.orgName || p?.organizationName || p?.workspaceName || '';
        if (name && p?.status !== 'expired' && p?.status !== 'revoked') s.update({
            inviteTargetName: name,
            inviteInviterName: p?.inviterName || ''
        });
    } catch (_) {
    /* personalization only — the generic headline stands */ }
};
// TAKE the invitation token OUT of the address bar, once, on mount — the same
// way the accept page does (functions/inviteToken.js takeInviteToken: the boot
// step in workspace/index.html parks it on a hard load, an in-app navigation
// reads the address bar). It is a bearer credential; /signup used to keep
// `?token=` in the URL for the whole visit (D2 follow-up, live on the
// white-label landing 2026-10-11). The copy lives on the LoginWindow element
// (never reactive state, never storage) for the seed, the preview and the
// register call. Without takeInviteToken registered, the address bar is read
// as before.
//
// A RELOAD of /signup has no `?token=` left (it was taken on the first mount),
// but the accept page's `next` return path still carries it — so the invite
// context (locked email, "Join <org>") is rebuilt from there
// (functions/inviteToken.js inviteTokenFromNext).
const $33579f9ec88ba575$var$_takeSignupInvite = (el)=>{
    if (typeof window === 'undefined') return null;
    const canCall = typeof el.call === 'function';
    const taken = canCall ? el.call('takeInviteToken') : undefined;
    if (taken) return taken;
    const fromNext = canCall ? el.call('inviteTokenFromNext') : undefined;
    if (fromNext) return fromNext;
    if (taken !== undefined) return null;
    return new URLSearchParams(window.location.search).get('token');
};
const $33579f9ec88ba575$export$7200a869094fec36 = {
    extends: 'Page',
    // On a white-label host the tab names the org ("<page> / <org>"). While the
    // brand is not there, the page answers NO title: the edge-stamped one stays
    // while it loads, and the shell's route wrapper supplies its own title once
    // the host turns out to have no brand (shell functions/authWrapperTitle.js).
    // isCustomDomainHost is a shell function; elsewhere this is a platform page.
    metadata: (el)=>{
        if (el.state?.root?.whitelabelBrand?.name) return {
            title: el.call('pageTitle', 'auth.page.signup.title')
        };
        const fns = el.context?.functions;
        if (typeof fns?.isCustomDomainHost === 'function' && el.call('isCustomDomainHost')) return {
            title: undefined
        };
        return {
            title: el.call('pageTitle', 'auth.page.signup.title')
        };
    },
    flow: 'y',
    // Centred across, TOP-aligned down: the card centres itself down the page with
    // its own `margin: auto` (LoginWindow) while it fits, and a card taller than
    // the screen starts at the top and scrolls. `align: 'center center'` would
    // centre the OVERFLOW too, and the top of a tall card would sit above the
    // scroll origin, out of reach (853×533 = 150% zoom).
    align: 'center flex-start',
    // `C` on every side: with the privacy line, the sign-in line and the password
    // rule the card is 681px tall, and the old `D` above and below (68px each)
    // pushed a 768px laptop screen into a scroll.
    padding: 'C',
    width: '100%',
    // The page is AT LEAST the screen and grows with its card (it was exactly the
    // screen, `height: 100dvh`, which clamps a host that gives the page no scroller
    // of its own). In the shell the page is the `main` scroller itself, a fixed
    // screen high — what keeps the card whole there is `flexShrink` on the card
    // below.
    height: 'auto',
    minHeight: '100dvh',
    maxWidth: 'none',
    ...(0, $lJuW8.authPageTheme),
    // Initial state so `s.loading` is reactively read from the first paint —
    // CheckButton in SignupForm binds text/disabled/opacity to it.
    state: {
        loading: false,
        identifier: '',
        password: '',
        claimCredits: false,
        // SIGNUP-INTENT (symbols.app/built-with) — read ONCE in onInit, like
        // `claimCredits`, and forwarded on the register body. Flat strings: an
        // object value here would become a nested state instance.
        preset: '',
        acqSource: '',
        acqMedium: '',
        acqCampaign: '',
        acqRef: '',
        acqPlan: ''
    },
    onInit: (el, s)=>{
        (0, $klqGv.stashOAuthNext)();
        // SIGNUP-INTENT — also kept for an OAuth sign-up, which never uses the
        // register body below (functions/signupIntent.js).
        el.call('stashSignupIntent');
        // CREDITS-CLAIM (tickets/sonnet.md) — read `?claim=credits` ONCE, at
        // construction, and carry it as state for the rest of the page's life.
        // The workspace router STRIPS the query string on the post-auth boot
        // redirect (separate ticket, opus.md), so reading `location.search`
        // again after that redirect would silently lose the intent. Reading it
        // here — before any navigation exists — and forwarding it as a body
        // field on `register()` (never as a query param on the redirect target)
        // is the fix the server side was built to expect.
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            if (params.get('claim') === 'credits') s.quietUpdate({
                claimCredits: true
            });
            // SIGNUP-INTENT — the symbols.app/built-with sign-up link carries
            // `preset` (an industry preset key), `plan` and where the visitor came
            // from (`ref` + `utm_*`). Read here for the same reason as the claim
            // above (the post-auth redirect strips the query). The server
            // shape-validates every value and drops a bad one — none of this can
            // block a signup (server core/utils/signupIntent.js).
            s.quietUpdate({
                preset: params.get('preset') || '',
                acqSource: params.get('utm_source') || '',
                acqMedium: params.get('utm_medium') || '',
                acqCampaign: params.get('utm_campaign') || '',
                acqRef: params.get('ref') || '',
                acqPlan: params.get('plan') || ''
            });
        }
    },
    LoginWindow: {
        // White-label host: the branded card shape (components/WhitelabelAuthWindow.js)
        // — inert on the platform.
        //
        // LoginWindow comes FIRST on purpose. The key order of a merged block is the
        // order in which the extends name each key, and the mixin names
        // `Flex.RequestAccessButtons`: listed first, it put the OAuth buttons ahead
        // of the form in the DOM (Tab went Google → GitHub → Email, sam F8), while
        // LoginWindow's own empty slots (`SignupForm: null` …, "keep keyboard order
        // aligned with the visible form-first layout") are what keep the form ahead
        // of them. The two declare no leaf in common — the mixin only adds
        // `.isBranded` blocks and brand-gated hides — so the order of the list moves
        // no value; pinned by __tests__/signupPageAudit.test.js.
        extends: [
            'LoginWindow',
            'WhitelabelAuthWindow'
        ],
        // A finished sign-up is a short card: it gives up the form's minimum height
        // and the section gap (LoginWindow pins `minHeight` so the content swap while
        // SIGNING IN does not resize it; this swap is the end of the page's job).
        isDone: (el, s)=>!!s.done,
        '.isDone': {
            minHeight: 'auto',
            gap: 'A'
        },
        // The card is as tall as its content, never shorter. Two things made it
        // shorter on a short screen (853×533 = 150% zoom; persona elena, shots
        // 001–004: the white card ended above the Sign up button, the last rows and
        // the OAuth buttons hung below it on the grey):
        //   • the shell's `main` is a column flex scroller one screen high, and a
        //     flex item shrinks (`flex-shrink: 1`) down to its `minHeight` — so the
        //     card shrank to the screen while its content (`overflow: visible`)
        //     spilled out of it. `flexShrink: 0` keeps the card whole; `main` scrolls,
        //     and the card's own `margin: auto` centres it only while it fits, so the
        //     top of a tall card is never cut off;
        //   • ModalWindow caps a sheet at the screen minus the overlay gutter
        //     (`maxHeight: calc(100dvh - 2 * overlayGutter)`). This is a page, not an
        //     overlay: no cap.
        flexShrink: '0',
        maxHeight: 'none',
        // Helpers of this page. `scope`, not module-scope helpers: a module-local
        // function read from a handler is dropped when the component is frank'd
        // for platform delivery (the LoginWindow note above `completeGoogleLogin`),
        // and `scope` merges with LoginWindow's own (shallow, base first).
        scope: {
            // Where "Sign in" leads: the sign-in route carrying the live query/hash
            // (`?next=`, `claim`, campaign params — tickets/sonnet.md "auth-page
            // redirects still drop the query") MINUS `token`: the invitation is spent
            // at sign-up, and the invite page comes back through `next`.
            signInPath (el) {
                const live = new URL(el.call('withLiveQuery', '/login') || '/login', 'https://local.invalid');
                live.searchParams.delete('token');
                return live.pathname + live.search + live.hash;
            },
            // The sentence under the heading of a finished sign-up. The address and
            // the credits go in through FUNCTION replacers (a string replacement
            // would expand `$&` inside them).
            doneMessage (el, s) {
                return el.call('polyglot', s.doneMessageKey).replace('{email}', ()=>s.doneEmail).replace('{credits}', ()=>String(s.doneCredits));
            },
            // Whether a failed register is the server refusing the PASSWORD — by the
            // body the SDK keeps as the error's cause (`error`, and `missing` once
            // the server lists the parts), else by the message it carries. Anything
            // else is the page's own error line (SignupFormError).
            isPasswordRefusal (ex) {
                const body = ex && ex.cause && (ex.cause.cause || ex.cause) || {};
                return body.error === 'Password validation failed' || Array.isArray(body.missing) && body.missing.length > 0 || /password (validation failed|must)/i.test(String(ex && ex.message || ''));
            },
            // The rule's parts for the checklist, from the policy the server
            // published (state: pwMin / pwLower / pwUpper / pwDigit / pwSpecial) and
            // the password as typed. Order = the server's: length, lower, upper,
            // digit, special.
            passwordParts (el, s) {
                const pw = String(s.password || '');
                const word = (key)=>el.call('polyglot', key);
                const parts = [];
                if (s.pwMin > 0) parts.push({
                    key: 'length',
                    ok: pw.length >= s.pwMin,
                    word: word('auth.signup.passwordRule.length').replace('{count}', ()=>String(s.pwMin))
                });
                if (s.pwLower) parts.push({
                    key: 'lower',
                    ok: /[a-z]/.test(pw),
                    word: word('auth.signup.passwordRule.lower')
                });
                if (s.pwUpper) parts.push({
                    key: 'upper',
                    ok: /[A-Z]/.test(pw),
                    word: word('auth.signup.passwordRule.upper')
                });
                if (s.pwDigit) parts.push({
                    key: 'digit',
                    ok: /[0-9]/.test(pw),
                    word: word('auth.signup.passwordRule.digit')
                });
                if (s.pwSpecial) {
                    const chars = Array.from(String(s.pwSpecial));
                    parts.push({
                        key: 'special',
                        ok: chars.some((c)=>pw.includes(c)),
                        word: word('auth.signup.passwordRule.special').replace('{chars}', ()=>chars.join(' '))
                    });
                }
                return parts.map((p)=>({
                        ...p,
                        status: word(p.ok ? 'auth.signup.passwordRule.met' : 'auth.signup.passwordRule.unmet')
                    }));
            },
            // Read the server's sign-up policy through the SDK, when the SDK can
            // (`getSignupPolicy` → GET /core/auth/signup-policy, public:
            // `{ password: { minLength, lower, upper, digit, special }, … }`). No
            // method, no answer, or a rule that is not a rule: the page keeps the
            // rule's own sentence. Flat state keys — an object would become a nested
            // state instance.
            async readPasswordPolicy (el, s) {
                const read = el.sdk && el.sdk.getSignupPolicy;
                if (typeof read !== 'function') return;
                try {
                    const res = await read.call(el.sdk);
                    const rule = res && res.data && res.data.password || res && res.password || null;
                    const min = rule ? Number(rule.minLength) : 0;
                    if (!rule || !Number.isInteger(min) || min < 1 || min > 128) return;
                    s.update({
                        pwPolicy: true,
                        pwMin: min,
                        pwLower: rule.lower === true,
                        pwUpper: rule.upper === true,
                        pwDigit: rule.digit === true,
                        pwSpecial: typeof rule.special === 'string' ? rule.special : ''
                    });
                } catch (_) {
                /* the rule's own sentence stands */ }
            },
            // The send-again cooldown: the seconds left tick down in state, once a
            // second, and stop when the card leaves the document. The timer lives on
            // the element (`el.__resendTimer`), never in state.
            startResendWait (el, s, seconds) {
                if (el.__resendTimer) clearInterval(el.__resendTimer);
                s.update({
                    resendWait: seconds
                });
                el.__resendTimer = setInterval(()=>{
                    const left = (s.resendWait || 0) - 1;
                    const gone = !el.node || el.node.isConnected === false;
                    if (left <= 0 || gone) {
                        clearInterval(el.__resendTimer);
                        el.__resendTimer = null;
                        if (!gone) s.update({
                            resendWait: 0
                        });
                        return;
                    }
                    s.update({
                        resendWait: left
                    });
                }, 1000);
            },
            // "Continue" opens the new account: no second sign-in (R2-m10, persona
            // sam typed the address and the password again on /login). `register`
            // answers with the account's session tokens (the server mints them and
            // stores the refresh token). onSubmit keeps it on this card
            // (`__signupSession`: never in state, never in storage before the person
            // continues), and this opens it with the steps a sign-in takes (signin.js
            // onSubmit): the SDK adopts the tokens, getMe hydrates the session
            // (USER_UPDATED: the shell marks the person signed in before the router's
            // guard runs), initializeUserSession fills the root. Answers true once
            // the account is open. Answers false, with nothing half-open left
            // behind, when there is no session to open or opening it fails.
            async openSignupSession (el) {
                const card = typeof el.lookup === 'function' ? el.lookup('LoginWindow') : null;
                if (!card) return false;
                if (card.__signupOpened) return true;
                const session = card.__signupSession;
                card.__signupSession = null;
                const sdk = el.sdk;
                const tokens = session && session.tokens;
                if (!tokens || !tokens.accessToken || !sdk) return false;
                if (typeof sdk.adoptTokens !== 'function' || typeof sdk.getMe !== 'function') return false;
                const exp = tokens.accessTokenExp || {};
                try {
                    const adopted = await sdk.adoptTokens({
                        accessToken: tokens.accessToken,
                        refreshToken: tokens.refreshToken,
                        expiresIn: exp.expiresIn,
                        expiresAt: exp.expiresAt
                    });
                    if (!adopted) return false;
                    // A session on this origin: its refresh token is its own (review D1).
                    el.call('markOwnSession');
                    // No hydrated user, no open account: the shell would hold the
                    // tokens and wait for a user that never comes.
                    const me = await sdk.getMe();
                    const user = me && (me.user || me);
                    if (!user) throw new Error('no session user');
                    await el.call('initializeUserSession', {
                        loginData: {
                            user: user,
                            tokens: tokens
                        }
                    });
                } catch (_) {
                    try {
                        if (typeof sdk.logout === 'function') await sdk.logout();
                    } catch (_e) {
                    /* nothing more to undo */ }
                    return false;
                }
                card.__signupOpened = true;
                return true;
            },
            // Where "Continue" goes once the account is open: where a sign-in from
            // signInPath would have sent the person (signin.js onSubmit). The
            // request's `next`, same-origin only (consumeOAuthNext's clamp); else the
            // checkout a paid-plan link queued; else home with the live query, minus
            // the spent invitation `token`. A stashed OAuth `next` is spent, not
            // followed: this sign-up made no OAuth round trip. A `?redirect=`
            // hand-off goes through sign-in, whose onInit hands the open session on;
            // a target that sign-in refuses goes home (sign-in would stop on its form).
            signedInNext (el) {
                const href = typeof window !== 'undefined' ? window.location.href : 'https://local.invalid/';
                const params = new URL(href).searchParams;
                const redirect = params.get('redirect');
                if (redirect) {
                    const target = el.call('classifyHandoffTarget', redirect);
                    if (!target || target.verdict !== 'refused') return el.scope.signInPath(el);
                }
                el.call('consumeOAuthNext');
                const asked = params.get('next');
                const next = asked ? el.call('consumeOAuthNext', asked) : '/';
                if (next && next !== '/') return next;
                const checkout = el.call('takeSignupCheckoutNext');
                if (checkout) return checkout;
                const home = new URL(el.call('withLiveQuery', '/') || '/', 'https://local.invalid');
                home.searchParams.delete('token');
                home.searchParams.delete('next');
                return home.pathname + home.search + home.hash;
            },
            // No account to open: sign-in, as before, with the address handed over
            // through the ROOT state (`_signInEmail`), never the URL. signin.js puts
            // it in the field, reads it once and clears it.
            handToSignIn (el, s) {
                if (s.root && s.doneEmail) s.root.update({
                    _signInEmail: s.doneEmail
                });
                return el.router(s.doneNext || '/login', el.getRoot());
            }
        },
        // The invitation's keys live HERE, on LoginWindow's own state — the scope
        // SignupForm and the header read (deep-merged with LoginWindow's own
        // declaration). Declared up front so every binding below tracks them
        // from the first paint.
        //   email / hasToken   the invited address, locked (emailed invitation)
        //   inviteEmailBound   false for a magic link: any address may join
        //   inviteTargetName / inviteInviterName   the preview's names
        //   pw*                the password rule the SDK read (pwPolicy false = none:
        //                      the rule's own sentence shows); passwordRefused: the
        //                      server turned the password down (cleared on typing)
        //   done*              the finished sign-up: what the card says, the address
        //                      it went to, whether the mail left, whether "Continue"
        //                      opens the new account (doneSignedIn) and where it goes
        //                      when it cannot (doneNext)
        //   resend*            the send-again control (busy / seconds left / its note)
        //   formError          '' | 'missing' | 'failed': the page's own error line under
        //                      the fields (formErrorText = the server's words for 'failed');
        //                      `name` is declared so the line's factory tracks it from the
        //                      first paint (an undefined read is not tracked)
        //   loading            LoginWindow's own key, declared again: this block
        //                      REPLACES the component's `state` (measured, smbls
        //                      3.14.841), and an undeclared `loading` read the ROOT
        //                      state's — the scrim, the "Creating…" button and the
        //                      Continue guard followed the shell's loading, not this card's
        state: {
            loading: false,
            email: '',
            name: '',
            hasToken: false,
            inviteEmailBound: true,
            inviteTargetName: '',
            inviteInviterName: '',
            pwPolicy: false,
            pwMin: 0,
            pwLower: false,
            pwUpper: false,
            pwDigit: false,
            pwSpecial: '',
            passwordRefused: false,
            formError: '',
            formErrorText: '',
            done: false,
            doneTitleKey: '',
            doneMessageKey: '',
            doneEmail: '',
            doneCredits: 0,
            doneMailed: false,
            doneNext: '',
            doneSignedIn: false,
            resendBusy: false,
            resendWait: 0,
            resendNoteKey: ''
        },
        onInit: (el, s)=>{
            el.__inviteToken = $33579f9ec88ba575$var$_takeSignupInvite(el);
            $33579f9ec88ba575$var$_seedFromInviteToken(el, s, el.__inviteToken);
            $33579f9ec88ba575$var$_seedInvitePreview(el, s, el.__inviteToken);
            // The password rule, when the SDK offers the sign-up policy.
            if (el.scope && el.sdk && typeof el.sdk.getSignupPolicy === 'function') el.scope.readPasswordPolicy(el, s);
        },
        // The org's logo + name on a white-label host (the branded sign-in's
        // lockup, components/WhitelabelSignin.js); nothing on a platform host.
        WhitelabelLockup: {
            order: '-1',
            subscribeTo: [
                'whitelabelBrand'
            ],
            hide: (el, s)=>!(s.root && s.root.whitelabelBrand),
            // On this card the lockup sits on the design-system card ground, not
            // the branded sign-in's: its ink is the card's own (title / caption,
            // AA on that ground by the design system), and the name is not a
            // heading — the card's own heading stays the page's one h1.
            Wordmark: {
                tag: 'div',
                color: 'title'
            },
            Tagline: {
                color: 'caption'
            }
        },
        ModalHeader: {
            Hgroup: {
                H: {
                    // Reachable by script, never by Tab: the finished sign-up puts focus
                    // HERE (the form it was on has just left the page), so the next
                    // thing a keyboard or a screen reader meets is the new heading.
                    tabindex: '-1',
                    width: 'fit-content',
                    maxWidth: '100%',
                    // Room for the focus ring: the brand ring (a box-shadow band) hugs the
                    // element's own box, and a heading box is as tight as its glyphs. The
                    // padding gives the band air; the equal negative margin takes the
                    // same room back, so nothing around the heading moves.
                    padding: 'X Y',
                    margin: '-X -Y',
                    round: 'radiusControl',
                    // An invitation names what it joins; a white-label host names its
                    // org (a brand without a name gets the neutral heading — never the
                    // platform's "Symbols" on a branded host); the platform keeps its
                    // own heading (Nika: "Keep Symbols on the platform"). Names go in
                    // through a FUNCTION replacer: a string replacement would expand
                    // `$&` / `$1` inside a name. A finished sign-up names what happened
                    // instead ("Check your email").
                    subscribeTo: [
                        'whitelabelBrand'
                    ],
                    text: (el, s)=>{
                        if (s.done) return el.call('polyglot', s.doneTitleKey);
                        if (s.inviteTargetName) {
                            const target = s.inviteTargetName;
                            return el.call('polyglot', 'auth.acceptInvite.h.welcomeNamed').replace('{name}', ()=>target);
                        }
                        const brand = s.root?.whitelabelBrand;
                        if (!brand) return el.call('polyglot', 'auth.signup.heading');
                        const org = brand.name;
                        return org ? el.call('polyglot', 'auth.signup.headingNamed').replace('{name}', ()=>org) : el.call('polyglot', 'auth.signup.headingNeutral');
                    }
                },
                P: {
                    hide: (el, s)=>!s.inviteTargetName && !s.done,
                    // The finished sign-up's sentence is THE message of the page, not a
                    // subtitle: body size, body ink.
                    fontSize: (el, s)=>s.done ? 'A' : 'Z1',
                    color: (el, s)=>s.done ? 'paragraph' : 'inactive',
                    text: (el, s)=>{
                        if (s.done) return el.scope.doneMessage(el, s);
                        const named = !!s.inviteInviterName;
                        const key = s.inviteEmailBound === false ? named ? 'auth.signup.invite.linkNamed' : 'auth.signup.invite.link' : named ? 'auth.signup.invite.boundNamed' : 'auth.signup.invite.bound';
                        return el.call('polyglot', key).replace('{name}', ()=>s.inviteInviterName || '');
                    }
                }
            }
        },
        // WHITELABEL-SIGNUP-TYPE-1 (Nika decision A) — an OPTIONAL account-type
        // picker for the WHITE-LABEL branded signup. Feature-detected and inert
        // everywhere else: it renders ONLY when the branded org's public branding
        // record (resolved pre-auth on a custom-domain host — workspace
        // functions/whitelabelBrand.js) carries a `signupTypes` list. On
        // my.symbols.app and every platform host `root.whitelabelBrand` is null,
        // so this field stays hidden and contributes NO `type` — the Symbols
        // signup is byte-identical to before (same gated-child shape signin.js
        // uses for the branded WhitelabelSignin surface).
        //
        // ⛔ SECURITY BOUNDARY (decision A): the chosen value is a PROFILE
        // PREFERENCE only. Its ONLY effect is the `type` field on the register
        // body below. It triggers NO join/grant/switch, calls NO membership or
        // org endpoint, and auto-selects NO org. Access stays invite-driven. If
        // this is ever wired to anything other than the register `type`, stop —
        // that would cross decision A.
        AccountType: {
            extends: 'InputField',
            // Re-render when the brand lands AFTER first paint (the late-apply path
            // in whitelabelBrand.js), the same contract the branded signin uses.
            subscribeTo: [
                'whitelabelBrand'
            ],
            width: '100%',
            // A finished sign-up has no field left to fill.
            hide: (el, s)=>{
                if (s.done) return true;
                const b = s.root && s.root.whitelabelBrand;
                const list = b && Array.isArray(b.signupTypes) ? b.signupTypes : [];
                return !list.some((t)=>t && t.key && t.label);
            },
            display: (el, s)=>{
                if (s.done) return 'none';
                const b = s.root && s.root.whitelabelBrand;
                const list = b && Array.isArray(b.signupTypes) ? b.signupTypes : [];
                return list.some((t)=>t && t.key && t.label) ? null : 'none';
            },
            Title: {
                text: '{{ auth.signup.accountType | polyglot }}',
                padding: '- - 0'
            },
            // Reuses InputField's field styling verbatim (same tokens the Email /
            // Name / Password inputs use); only the tag and the option list differ.
            // The options come from the RECORD — never a hardcoded Searcher /
            // Investor list. The server's accountType.js is explicit: the canonical
            // list lives in the branded org's `branding`, not in client code.
            Input: {
                tag: 'select',
                name: 'accountType',
                theme: 'field',
                minHeight: 'controlH',
                round: 'radiusControl',
                fontSize: 'Z2',
                padding: '0 A',
                width: '100%',
                value: (el, s)=>s.accountType || '',
                onChange: (ev, el, s)=>s.update({
                        accountType: el.node.value
                    }),
                childrenAs: 'props',
                // The children factory reads `s.root.whitelabelBrand` only behind a
                // truthiness guard, so the signal tracker never registers the dep on a
                // run where the brand is still null (the common first-paint case on a
                // slow lookup). Declare it explicitly so a late-arriving brand re-fires
                // the option list (FA515).
                childrenDeps: [
                    'whitelabelBrand'
                ],
                children: (el, s)=>{
                    const b = s.root && s.root.whitelabelBrand;
                    const list = b && Array.isArray(b.signupTypes) ? b.signupTypes : [];
                    const opts = list.filter((t)=>t && t.key && t.label).map((t)=>({
                            value: String(t.key),
                            text: String(t.label)
                        }));
                    // Leading empty option: nothing is preselected, so a visitor who
                    // ignores the field sends no `type` and the signup is unchanged.
                    return [
                        {
                            value: '',
                            text: el.call('polyglot', 'auth.signup.accountTypePlaceholder')
                        }
                    ].concat(opts);
                },
                childProps: {
                    tag: 'option'
                }
            }
        },
        // The form and the OAuth column leave the card when the sign-up is done.
        Flex: {
            hide: (el, s)=>!!s.done,
            SignupForm: {
                Password: {
                    Input: {
                        // The rule under the field describes it; a password the server
                        // turned down is marked invalid until the next keystroke.
                        aria: {
                            describedby: 'signup-password-rule',
                            invalid: (el, s)=>s.passwordRefused ? 'true' : null
                        }
                    },
                    // THE PASSWORD RULE ("Keep rule, show it" — Nika 2026-10-24). It sits
                    // in the field's own label, so it is phrasing content (spans). Two
                    // faces of ONE rule: the sentence (the first paint, and always when the
                    // SDK cannot read the policy) and the live checklist (once the SDK has
                    // read the server's policy — one swap, started in onInit, a few lines
                    // of height, before a person is at the field). The refusal line below
                    // is mounted from the first paint, empty, so the alert region exists
                    // before it speaks (Rule 66).
                    SignupPasswordRule: {
                        tag: 'span',
                        id: 'signup-password-rule',
                        flow: 'y',
                        gap: 'Y',
                        fontSize: 'Z1',
                        lineHeight: '1.4',
                        color: 'caption',
                        SignupPasswordRuleText: {
                            tag: 'span',
                            hide: (el, s)=>!!s.pwPolicy,
                            text: '{{ auth.signup.passwordRule.text | polyglot }}'
                        },
                        SignupPasswordRuleList: {
                            tag: 'span',
                            role: 'list',
                            hide: (el, s)=>!s.pwPolicy,
                            flow: 'x',
                            flexWrap: 'wrap',
                            gap: 'Y A',
                            children: (el, s)=>s.pwPolicy ? el.scope.passwordParts(el, s) : [],
                            childrenAs: 'state',
                            childProps: {
                                tag: 'span',
                                role: 'listitem',
                                flow: 'x',
                                gap: 'Y',
                                align: 'center flex-start',
                                isMet: (el, s)=>!!s.ok,
                                '.isMet': {
                                    color: 'successInk'
                                },
                                // The circle is the part's mark; the tick shows once it is met.
                                // The words "met" / "not met" are for a screen reader only — the
                                // state must not live in colour alone.
                                SignupRuleMark: {
                                    tag: 'span',
                                    boxSize: 'iconSm',
                                    flexShrink: '0',
                                    round: 'radiusPill',
                                    borderWidth: 'hairline',
                                    borderStyle: 'solid',
                                    borderColor: 'currentColor',
                                    align: 'center center',
                                    Icon: {
                                        name: 'checkmark',
                                        boxSize: 'iconXs',
                                        hide: (el, s)=>!s.ok
                                    }
                                },
                                SignupRuleWord: {
                                    tag: 'span',
                                    text: (el, s)=>s.word
                                },
                                SignupRuleStatus: {
                                    tag: 'span',
                                    ...$33579f9ec88ba575$var$SR_ONLY,
                                    text: (el, s)=>`(${s.status})`
                                }
                            }
                        },
                        // Mounted, empty and without a box until the server refuses the
                        // password: a live region must exist before its text does.
                        SignupPasswordRefusal: {
                            tag: 'span',
                            role: 'alert',
                            color: 'dangerInk',
                            marginTop: (el, s)=>s.passwordRefused ? 'Y' : '0',
                            text: (el, s)=>s.passwordRefused ? el.call('polyglot', 'auth.signup.passwordRule.failed') : ''
                        }
                    }
                },
                // Under the button, in the footer (a div: the old `label` footer made a
                // click on any text beside the button press it). The page is for new
                // accounts, so the way back for an existing one sits right here, and the
                // two legal pages are two short links — never a sentence of consent.
                ModalFooter: {
                    // THE PAGE'S OWN ERROR LINE — an empty submit, or a failed register. It
                    // was a toast at the bottom centre of the screen: at 150% zoom (853×533)
                    // it sat on the Sign up button (measured on the live dev shell: the
                    // toast covered the button's centre). Here it is in the form, above the
                    // button, mounted from the first paint and empty (so the alert region
                    // exists before it speaks, and an empty line has no box — Rule 66). A
                    // "missing" line goes away by itself once the three fields hold text.
                    SignupFormError: {
                        tag: 'p',
                        role: 'alert',
                        order: '-1',
                        width: '100%',
                        margin: '0',
                        fontSize: 'Z2',
                        lineHeight: '1.4',
                        color: 'dangerInk',
                        text: (el, s)=>{
                            if (s.formError === 'failed') {
                                const title = el.call('polyglot', 'auth.signup.failed');
                                return s.formErrorText ? `${title}: ${s.formErrorText}` : title;
                            }
                            if (s.formError === 'missing' && !(s.email && s.name && s.password)) return `${el.call('polyglot', 'auth.signup.missingFields.title')}: ${el.call('polyglot', 'auth.signup.missingFields.message')}`;
                            return '';
                        }
                    },
                    SignupHaveAccount: {
                        flow: 'x',
                        flexWrap: 'wrap',
                        align: 'center center',
                        gap: 'Y',
                        margin: 'Z - -',
                        fontSize: 'Z2',
                        color: 'caption',
                        SignupHaveAccountPrompt: {
                            tag: 'span',
                            text: '{{ auth.signup.haveAccount.prompt | polyglot }}'
                        },
                        SignupLink_signin: {
                            fontWeight: '500',
                            href: (el)=>el.scope.signInPath(el),
                            text: '{{ auth.signup.haveAccount.link | polyglot }}'
                        }
                    },
                    // The privacy policy and the terms (persona elena: "I looked for a
                    // privacy statement before I gave my name. I found none."). They open
                    // in a new tab — the form must survive the read. The addresses are the
                    // catalog's, one per language: the shell has no legal-link source of
                    // its own; these are the public site's `/privacy` and `/terms` routes.
                    // Not shown on a white-label host: those pages are Symbols'.
                    SignupLegal: {
                        subscribeTo: [
                            'whitelabelBrand'
                        ],
                        hide: (el, s)=>!!(s.root && s.root.whitelabelBrand),
                        flow: 'x',
                        flexWrap: 'wrap',
                        align: 'center center',
                        gap: 'A',
                        fontSize: 'Z1',
                        // On a touch screen each link answers a 44pt square (SignupLink): the
                        // two rows sit far enough apart that those squares do not overlap.
                        '@coarse': {
                            margin: 'A - -'
                        },
                        SignupLink_privacy: {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            href: (el)=>el.call('polyglot', 'auth.signup.legal.privacyHref'),
                            text: '{{ auth.signup.legal.privacy | polyglot }}',
                            aria: {
                                label: (el)=>`${el.call('polyglot', 'auth.signup.legal.privacy')} (${el.call('polyglot', 'auth.signup.legal.newTab')})`
                            }
                        },
                        SignupLink_terms: {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            href: (el)=>el.call('polyglot', 'auth.signup.legal.termsHref'),
                            text: '{{ auth.signup.legal.terms | polyglot }}',
                            aria: {
                                label: (el)=>`${el.call('polyglot', 'auth.signup.legal.terms')} (${el.call('polyglot', 'auth.signup.legal.newTab')})`
                            }
                        }
                    }
                }
            },
            // This is the SIGN-UP page: the OAuth column says so (the sign-in copy
            // read "Another way to sign in" / "Sign in with Google" above a form that
            // creates an account). "Continue with" is true for both a new and a
            // returning person — the server upserts.
            RequestAccessButtons: {
                Hgroup: {
                    H: {
                        text: '{{ auth.signup.alternativeHeading | polyglot }}'
                    }
                },
                Flex: {
                    GoogleSignInButton: {
                        text: '{{ auth.signup.google | polyglot }}'
                    },
                    GithubSignInButton: {
                        text: '{{ auth.signup.github | polyglot }}'
                    }
                }
            }
        },
        // The announcement of a finished sign-up: mounted from the first paint and
        // empty (so the screen reader is already listening), read out when the
        // sentence arrives. The heading takes focus separately, so the two read as
        // "Check your email, heading" and then the sentence — not the same words twice.
        SignupAnnounce: {
            tag: 'p',
            role: 'status',
            ...$33579f9ec88ba575$var$SR_ONLY,
            text: (el, s)=>{
                if (!s.done) return '';
                if (s.resendNoteKey) return el.call('polyglot', s.resendNoteKey).replace('{email}', ()=>s.doneEmail);
                const hint = s.doneMailed ? ` ${el.call('polyglot', 'auth.signup.checkEmail.hint')}` : '';
                return el.scope.doneMessage(el, s) + hint;
            }
        },
        // THE FINISHED SIGN-UP. The card keeps its place; the form and the OAuth
        // column are gone; the heading and the sentence above say what happened.
        SignupDone: {
            hide: (el, s)=>!s.done,
            flow: 'y',
            gap: 'A',
            width: '100%',
            // The address the mail went to, for the kinds whose own sentence does not
            // name it (credits, an invitation that still needs verifying). "Check
            // your email" itself names it in its sentence.
            SignupDoneTo: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'paragraph',
                hide: (el, s)=>!s.doneMailed || s.doneMessageKey === 'auth.signup.checkEmail.sent',
                text: (el, s)=>el.call('polyglot', 'auth.signup.checkEmail.sent').replace('{email}', ()=>s.doneEmail)
            },
            SignupDoneHint: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z1',
                color: 'caption',
                hide: (el, s)=>!s.doneMailed,
                text: '{{ auth.signup.checkEmail.hint | polyglot }}'
            },
            // The one way on: into the new account, signed in (scope.openSignupSession),
            // or, with no session to open, to sign-in with the address handed over
            // (scope.handToSignIn). While the account opens, LoginWindow's loading
            // scrim covers the card, as it does for a sign-in.
            CheckButton_continue: {
                // The tenant accent on a white-label host (inert on the platform). The
                // mixin comes AFTER CheckButton: its key names CheckButton already (the
                // part before `_`), and frank-audit FA806 reports the other order
                // ("rename to WhitelabelAccent: {} and drop the extends") on a key like this.
                // The mixin declares only `color` / `background` factories (undefined off
                // a branded host) and an `.isBranded` block, so CheckButton's theme paints
                // the platform button either way.
                extends: [
                    'CheckButton',
                    'WhitelabelAccent'
                ],
                type: 'button',
                icon: null,
                width: '100%',
                text: (el, s)=>el.call('polyglot', s.doneSignedIn ? 'common.action.continue' : 'auth.signup.done.continue'),
                onClick: async (ev, el, s)=>{
                    if (ev && ev.preventDefault) ev.preventDefault();
                    if (s.loading) return;
                    if (!s.doneSignedIn) return el.scope.handToSignIn(el, s);
                    s.update({
                        loading: true
                    });
                    if (!await el.scope.openSignupSession(el)) {
                        s.update({
                            loading: false
                        });
                        return el.scope.handToSignIn(el, s);
                    }
                    try {
                        await el.router(el.scope.signedInNext(el), el.getRoot());
                    } catch (_) {
                        // The account is open and the route did not take: pressing again
                        // routes again (openSignupSession answers true at once).
                        s.update({
                            loading: false
                        });
                    }
                }
            },
            // SEND AGAIN — through the SDK, with a cooldown, and only where the SDK has
            // a way to do it from a signed-out page. Today it has none:
            // `resendVerification` needs the session this page does not have, and the
            // server answers it 401. The control stays out of the card until the SDK
            // offers `resendRegistrationConfirmation({ email })` (a public route that
            // answers alike for any address, rate-limited server-side); the cooldown
            // below keeps one person from asking again and again.
            Button_resend: {
                theme: 'quaternary',
                type: 'button',
                width: '100%',
                hide: (el, s)=>!s.doneMailed || !(el.sdk && typeof el.sdk.resendRegistrationConfirmation === 'function'),
                disabled: (el, s)=>!!s.resendBusy || s.resendWait > 0,
                text: (el, s)=>s.resendWait > 0 ? el.call('polyglot', 'auth.signup.resend.wait').replace('{seconds}', ()=>String(s.resendWait)) : el.call('polyglot', 'auth.signup.resend.action'),
                onClick: async (ev, el, s)=>{
                    if (ev && ev.preventDefault) ev.preventDefault();
                    const send = el.sdk && el.sdk.resendRegistrationConfirmation;
                    if (typeof send !== 'function' || s.resendBusy || s.resendWait > 0) return;
                    s.update({
                        resendBusy: true,
                        resendNoteKey: ''
                    });
                    let sent = false;
                    try {
                        await send.call(el.sdk, {
                            email: s.doneEmail
                        });
                        sent = true;
                    } catch (_) {
                    /* the note below says so */ }
                    s.update({
                        resendBusy: false,
                        resendNoteKey: sent ? 'auth.signup.resend.sent' : 'auth.signup.resend.failed'
                    });
                    el.scope.startResendWait(el, s, sent ? 60 : 15);
                }
            },
            SignupResendNote: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z1',
                color: 'caption',
                hide: (el, s)=>!s.resendNoteKey,
                text: (el, s)=>s.resendNoteKey ? el.call('polyglot', s.resendNoteKey).replace('{email}', ()=>s.doneEmail) : ''
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const root = el.node;
            const email = (s.email || root.querySelector('input[autocomplete="email"]')?.value || '').trim().toLowerCase();
            const password = s.password || root.querySelector('input[type="password"]')?.value || '';
            const name = (s.name || root.querySelector('input[autocomplete="name"]')?.value || '').trim();
            if (!email || !password || !name) {
                // Told in the form (SignupFormError), and the cursor goes to the first
                // field that is empty — a keyboard user lands where the work is.
                s.update({
                    formError: 'missing'
                });
                const first = !email ? 'Email' : !name ? 'Name' : 'Password';
                const form = el.Flex && el.Flex.SignupForm;
                const input = form && form[first] && form[first].Input && form[first].Input.node;
                if (input && typeof input.focus === 'function') input.focus();
                return;
            }
            s.update({
                loading: true,
                formError: '',
                formErrorText: ''
            });
            const inviteToken = el.__inviteToken || (typeof window !== 'undefined' ? new URL(window.location.href).searchParams.get('token') : null);
            // SIGNUP-INTENT — only the fields the link actually carried.
            const intent = {
                source: s.acqSource,
                medium: s.acqMedium,
                campaign: s.acqCampaign,
                ref: s.acqRef,
                plan: s.acqPlan
            };
            const acquisition = {};
            Object.keys(intent).forEach((k)=>{
                if (intent[k]) acquisition[k] = intent[k];
            });
            let registerResult;
            try {
                const pluginSession = el.call('getPluginSessionFromUrl');
                const payload = {
                    email: email,
                    password: password,
                    name: name,
                    callbackUrl: `${window.location.origin}/signup-confirmation`,
                    inviteToken: inviteToken,
                    // WHITELABEL-SIGNUP-TYPE-1 (decision A) — the account type chosen on
                    // the branded signup, persisted server-side as a PROFILE PREFERENCE
                    // (user.preferences.accountType) that grants NO access. Feature-
                    // detected: `undefined` on every platform host (no branded picker)
                    // and whenever the visitor left the picker unset, so JSON.stringify
                    // drops the key and the register request is byte-identical to
                    // before. The server shape-gates it (accountType.js) and ignores a
                    // malformed value — it can never block a signup.
                    type: s.accountType || undefined,
                    // CREDITS-CLAIM — the body flag, not the query param (see onInit
                    // comment above). Claims inline, in this same request, and the
                    // server hands the outcome back as `data.creditsClaim`.
                    claimCredits: !!s.claimCredits,
                    // SIGNUP-INTENT — `undefined` when the link carried none, so
                    // JSON.stringify drops the keys and a plain signup is unchanged.
                    // With a valid preset the server installs that industry's apps in
                    // the new personal workspace (`data.presetApplied`).
                    preset: s.preset || undefined,
                    acquisition: Object.keys(acquisition).length ? acquisition : undefined
                };
                if (pluginSession) registerResult = await el.sdk.register(payload, {
                    session: pluginSession
                });
                else registerResult = await el.sdk.register(payload);
            } catch (ex) {
                s.update({
                    loading: false
                });
                // The server turned the PASSWORD down: say so at the field (the rule is
                // printed right there), mark it, and put the cursor back in it. The
                // server's own text is an English list; the field's line is the page's.
                if (el.scope && el.scope.isPasswordRefusal(ex)) {
                    s.update({
                        passwordRefused: true
                    });
                    const field = el.Flex && el.Flex.SignupForm && el.Flex.SignupForm.Password;
                    const input = field && field.Input && field.Input.node;
                    if (input && typeof input.focus === 'function') input.focus();
                    return;
                }
                s.update({
                    formError: 'failed',
                    formErrorText: ex?.message || String(ex)
                });
                return;
            }
            s.update({
                loading: false
            });
            if (typeof window !== 'undefined' && window.plausible) window.plausible('Signup');
            // CREDITS-CLAIM acceptance: "ends with 100 in the top-up bucket AND is
            // told so on screen" — a human has to actually see this, once, on
            // arrival, without hunting for a balance. `creditsClaim` is only
            // present when `claimCredits` was requested; `null` means the claim
            // attempt failed server-side (registration still succeeded) — never
            // claim a landing that didn't happen. The card says it and STAYS until
            // the person moves on (it was a 6 s toast on the next page).
            const claim = registerResult?.creditsClaim;
            const verified = !!registerResult?.user?.emailVerified;
            // `verificationEmailSent: false` is the server saying the mail did not
            // leave (the transport failed); an older server sends no field, which
            // reads as "sent". An invitation that proved the address sends none.
            const mailFailed = registerResult?.verificationEmailSent === false;
            let titleKey = 'auth.signup.checkEmail.title';
            let messageKey = 'auth.signup.checkEmail.sent';
            if (claim?.claimed) {
                titleKey = 'auth.signup.creditsAdded.title';
                messageKey = 'auth.signup.creditsAdded.message';
            } else if (claim?.alreadyClaimed) {
                // Symmetric with the standalone claim endpoint — impossible on a
                // genuinely fresh signup, but never render this as an error.
                titleKey = 'auth.signup.alreadyCredits.title';
                messageKey = 'auth.signup.alreadyCredits.message';
            } else if (inviteToken) {
                // An emailed invitation proved the address: the server accepted it
                // inline (verified). A magic link did not (INVITE-MAGIC-LINK-1): its
                // verification email is on its way, and the link joins only once the
                // address is verified (review D1) — so the card says to verify first.
                titleKey = 'auth.signup.inviteReady.title';
                messageKey = verified ? 'auth.signup.inviteReady.message' : 'auth.signup.inviteReady.verify';
            }
            if (mailFailed) {
                // Never "check your email" for a mail that was not sent.
                messageKey = 'auth.signup.notSent.message';
                if (titleKey === 'auth.signup.checkEmail.title') titleKey = 'auth.signup.notSent.title';
            }
            // The new account's session: `register` answers with its tokens. Kept
            // on this element for "Continue" (scope.openSignupSession), never in
            // state. The card offers to continue signed in only where the
            // SDK can adopt it; then the sentences that said "sign in" say what is
            // true.
            const tokens = registerResult && registerResult.tokens;
            el.__signupSession = tokens && tokens.accessToken ? {
                tokens: tokens
            } : null;
            el.__signupOpened = false;
            const canOpen = !!el.__signupSession && !!el.sdk && typeof el.sdk.adoptTokens === 'function';
            if (canOpen) {
                const signedInKey = {
                    'auth.signup.inviteReady.message': 'auth.signup.inviteReady.messageSignedIn',
                    'auth.signup.inviteReady.verify': 'auth.signup.inviteReady.verifySignedIn',
                    'auth.signup.notSent.message': 'auth.signup.notSent.messageSignedIn'
                }[messageKey];
                if (signedInKey) messageKey = signedInKey;
            }
            // Never to `/signup-confirmation` (pre-existing #5, fixed with
            // INVITE-MAGIC-LINK-1). That page is the target of the EMAILED verify
            // link and runs its confirmation at once (it needs that link's `?token=`
            // + `&email=`): a sign-up routed there confirmed against whatever
            // `?token=` the sign-up URL carried — after an invited sign-up the
            // INVITATION token — and answered "Invalid confirmation link" (a plain
            // sign-up, with no token, the same). "Continue" opens the new account
            // and goes on signed in; `doneNext` is where it goes when there is no
            // session to open: sign-in (signInPath carries the live query/hash MINUS
            // `token`).
            s.update({
                done: true,
                doneTitleKey: titleKey,
                doneMessageKey: messageKey,
                doneEmail: email,
                doneCredits: Number(claim?.total ?? 100),
                doneMailed: !mailFailed && !verified,
                doneNext: el.scope ? el.scope.signInPath(el) : '/login',
                doneSignedIn: canOpen
            });
            // The form the person was on has just left the page: put focus on the
            // new heading (it was left on <body>, and a keyboard user started over).
            const heading = el.ModalHeader && el.ModalHeader.Hgroup && el.ModalHeader.Hgroup.H;
            if (heading && heading.node && typeof heading.node.focus === 'function') heading.node.focus();
        }
    }
};

});

parcelRegister("b2cOO", function(module, exports) {

$parcel$export(module.exports, "signupConfirmation", () => $8089d31fdbb09be5$export$9c079914996cc79c);

var $lJuW8 = parcelRequire("lJuW8");
const $8089d31fdbb09be5$export$9c079914996cc79c = {
    extends: 'Page',
    metadata: (el)=>({
            title: el.call('polyglot', 'auth.page.signupConfirmation.title')
        }),
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    height: '100dvh',
    maxWidth: 'none',
    ...(0, $lJuW8.authPageTheme),
    // Review r3 D5: nothing is confirmed on load — the person presses
    // Continue (confirmEmail). D4: a confirm that dropped the pre-set password
    // leaves `setPasswordToken` and the ConfirmSetPassword step.
    // Review r4 N2: previewConfirmation fills targetEmail (server-read) and
    // otherAccountEmail (a different signed-in account) before Continue.
    state: {
        awaitingContinue: true,
        previewRequested: false,
        previewReady: false,
        targetEmail: '',
        otherAccountEmail: '',
        loading: false,
        success: false,
        error: null,
        emailTaken: false,
        setPasswordToken: null,
        newPassword: '',
        savingPassword: false,
        setPasswordError: null
    },
    ConfirmCard: {
        flow: 'y',
        gap: 'C',
        padding: 'D',
        width: '100%',
        maxWidth: 'I',
        round: 'radiusSheet',
        background: 'overlay',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'line',
        Head: {
            flow: 'y',
            gap: 'A',
            Eyebrow: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: 'blue',
                text: '{{ auth.confirm.eyebrow | polyglot }}'
            },
            Title: {
                tag: 'h1',
                fontSize: 'D',
                fontWeight: '700',
                color: 'title',
                letterSpacing: '-0.02em',
                text: '{{ auth.confirm.heading | polyglot }}'
            }
        },
        Body: {
            flow: 'y',
            gap: 'B',
            align: 'center center',
            ConfirmContinue: {
                if: (el, s)=>!!s.awaitingContinue,
                flow: 'y',
                align: 'center center',
                gap: 'B',
                width: '100%',
                // Read only (review r4 N2): names the account; never confirms.
                onRender: (el)=>{
                    el.call('previewConfirmation');
                },
                PreviewPending: {
                    if: (el, s)=>!s.previewReady,
                    LoadingSpinner: {
                        boxSize: 'C'
                    }
                },
                P: {
                    if: (el, s)=>!!s.previewReady,
                    text: '{{ auth.confirm.continueBody | polyglot }}',
                    textAlign: 'center',
                    color: 'paragraph',
                    maxWidth: 'G'
                },
                TargetEmail: {
                    if: (el, s)=>!!s.previewReady && !!s.targetEmail,
                    tag: 'strong',
                    text: (el, s)=>s.targetEmail,
                    color: 'title',
                    textAlign: 'center',
                    wordBreak: 'break-all'
                },
                OtherAccountNotice: {
                    if: (el, s)=>!!s.previewReady && !!s.otherAccountEmail,
                    role: 'alert',
                    text: (el, s)=>el.call('polyglot', s.targetEmail ? 'auth.confirm.otherAccount' : 'auth.confirm.otherAccountUnnamed').replace('{email}', s.otherAccountEmail),
                    textAlign: 'center',
                    color: 'warningInk',
                    maxWidth: 'G'
                },
                ContinueButton: {
                    if: (el, s)=>!!s.previewReady,
                    extends: [
                        'Button',
                        'ClickableItem'
                    ],
                    text: (el, s)=>el.call('polyglot', s.otherAccountEmail ? 'auth.confirm.switchContinue' : 'auth.confirm.continue'),
                    width: '100%',
                    onClick: async (_, el)=>{
                        await el.call('confirmEmail');
                    }
                }
            },
            LoadingState: {
                if: (el, s)=>s.loading,
                flow: 'y',
                align: 'center center',
                gap: 'B',
                LoadingSpinner: {
                    boxSize: 'D'
                },
                Text: {
                    text: '{{ auth.confirm.loading | polyglot }}',
                    fontSize: 'B',
                    color: 'caption'
                }
            },
            EmailConfirmationSuccess: {
                if: (el, s)=>!s.loading && s.success && !s.setPasswordToken
            },
            ConfirmSetPassword: {
                if: (el, s)=>!s.loading && s.success && !!s.setPasswordToken
            },
            EmailConfirmationError: {
                if: (el, s)=>!s.awaitingContinue && !s.loading && !s.success && !s.emailTaken
            },
            EmailConfirmationTaken: {
                if: (el, s)=>!s.loading && !!s.emailTaken
            }
        }
    }
};

});

parcelRegister("d0MBX", function(module, exports) {

$parcel$export(module.exports, "resetPassword", () => $9790fb9e05cdf94a$export$dc726c8e334dd814);
// Reset-password page — single LoginWindow that swaps between two
// inner forms based on whether the URL carries a `?token=…`:
//   - no token (entry point):  ResetEmailForm (request the reset link)
//   - has token (email link):  ResetPasswordsForm (set a new password)
//
// OAuth buttons stay visible in either mode so the user can pivot to
// "sign in with Google" if they remember after starting the reset.
//
// State ownership: LoginWindow declares its own `state` block — the
// page's own `state` is unreachable to the form's `onInput` /
// `onSubmit` handlers, which all resolve `s` to the closest state
// owner (LoginWindow). So every reset-password field has to live on
// LoginWindow.state, and the URL-param hydration in onInit has to
// target the same scope.

var $1sP0S = parcelRequire("1sP0S");

var $lJuW8 = parcelRequire("lJuW8");
const $9790fb9e05cdf94a$export$dc726c8e334dd814 = {
    extends: 'Page',
    metadata: (el)=>({
            title: el.call('polyglot', 'auth.page.resetPassword.title')
        }),
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    height: '100dvh',
    maxWidth: 'none',
    ...(0, $lJuW8.authPageTheme),
    LoginWindow: {
        // White-label host: the branded card shape and the org lockup, the same
        // as signup and the branded sign-in (components/WhitelabelAuthWindow.js) —
        // inert on the platform.
        extends: [
            'WhitelabelAuthWindow',
            'LoginWindow'
        ],
        WhitelabelLockup: {
            order: '-1',
            subscribeTo: [
                'whitelabelBrand'
            ],
            hide: (el, s)=>!(s.root && s.root.whitelabelBrand),
            Wordmark: {
                tag: 'div',
                color: 'title'
            },
            Tagline: {
                color: 'caption'
            }
        },
        // Override LoginWindow's default `{ loading, identifier, password }`
        // state with the fields the reset flow actually uses. Without this
        // override, `s.email`, `s.token`, `s.sent`, etc. read as undefined
        // inside onSubmit because LoginWindow's default shape doesn't have
        // them — the reset request hits the SDK with email='' and silently
        // shows the "Email required" path, OR the token-based confirm path
        // never fires because `s.token` is always undefined.
        state: {
            loading: false,
            sent: false,
            touched: false,
            email: '',
            password: '',
            repeatPassword: '',
            token: null,
            passwordTouched: false,
            repeatPasswordTouched: false
        },
        // Hydrate token + email from the URL query string. Runs on the
        // LoginWindow itself so `s` is the same scope the rest of the form
        // reads from.
        onInit: (el, s)=>{
            if (typeof window === 'undefined') return;
            const url = new URL(window.location.href);
            // #2301 — must be `update`, not `quietUpdate`: the ResetPasswordsForm
            // `if: (el,s) => !!s.token` factory has to re-evaluate once the token
            // lands, otherwise it stays hidden and the user only sees the email
            // request step (looks like a plain sign-in page).
            s.update({
                token: url.searchParams.get('token') || null,
                email: url.searchParams.get('email') || ''
            });
        },
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>el.call('polyglot', s.token ? 'auth.resetPassword.heading.set' : 'auth.resetPassword.heading.request')
                },
                P: null
            }
        },
        Flex: {
            // Step 1: request a reset email. Hidden once the user lands here
            // via an email link that carried the token. Also hidden after a
            // successful send so the SentNotice gets the column to itself.
            ResetEmailForm: {
                if: (el, s)=>!s.token && !s.sent
            },
            // Step 2: set the new password. Hidden until a token is present.
            ResetPasswordsForm: {
                if: (el, s)=>!!s.token
            },
            // After a successful reset request, swap the form for a notice.
            // (Sits at the same level so the LoginWindow Flex layout doesn't
            // collapse when the form is hidden.)
            SentNotice: {
                if: (el, s)=>s.sent && !s.token,
                flow: 'y',
                gap: 'A',
                Body: {
                    tag: 'p',
                    color: 'caption',
                    fontSize: 'A',
                    text: (el, s)=>s.email ? el.call('polyglot', 'auth.resetPassword.sentNotice').replace('{email}', ()=>s.email) : el.call('polyglot', 'auth.resetPassword.sentNoticeNoEmail')
                }
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            // Branch on which mode the form is currently in. Two onSubmit
            // closures was simpler in the old inline page — here we share
            // one because LoginWindow has tag:'form' and there's only one
            // submit handler per form element.
            if (s.token) return await $9790fb9e05cdf94a$var$_submitNewPassword(el, s);
            return await $9790fb9e05cdf94a$var$_submitRequestReset(el, s);
        }
    }
};
const $9790fb9e05cdf94a$var$_submitRequestReset = async (el, s)=>{
    // Read from state first, then fall back to a live DOM read in case
    // signal-tracking dropped a keystroke (matches the signin.js
    // pattern — password managers and rapid typing can race the state
    // mirror). Without the fallback the form silently shows the
    // "Email required" path even though the user clearly typed.
    const node = el.node;
    const email = (s.email || node?.querySelector?.('input[autocomplete="username"]')?.value || '').trim().toLowerCase();
    if (!email) {
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.resetPassword.emailRequired.title'),
            message: el.call('polyglot', 'auth.resetPassword.emailRequired.message'),
            type: 'error'
        });
        s.update({
            touched: true
        });
        return;
    }
    s.update({
        loading: true
    });
    try {
        await el.sdk.requestPasswordReset(email);
        s.update({
            sent: true,
            loading: false,
            email: email
        });
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.resetPassword.linkSent.title'),
            message: el.call('polyglot', 'auth.resetPassword.linkSent.message').replace('{email}', email),
            type: 'success'
        });
    } catch (e) {
        console.error('[reset-password] requestPasswordReset failed:', e);
        s.update({
            loading: false
        });
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.resetPassword.sendFailed'),
            message: e?.message || String(e) || el.call('polyglot', 'auth.login.tryAgain'),
            type: 'error'
        });
    }
};
const $9790fb9e05cdf94a$var$_submitNewPassword = async (el, s)=>{
    // Same state + DOM-fallback pattern as the email field — the two
    // password inputs lose their state mirror under rapid typing /
    // password-manager autofill, and reading the DOM at submit time
    // catches values the signal tracker dropped.
    const node = el.node;
    const pwInputs = node?.querySelectorAll?.('input[type="password"]') || [];
    const password = s.password || pwInputs[0]?.value || '';
    const repeat = s.repeatPassword || pwInputs[1]?.value || '';
    if (!password || !repeat) {
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.resetPassword.missingFields.title'),
            message: el.call('polyglot', 'auth.resetPassword.missingFields.message'),
            type: 'error'
        });
        s.update({
            passwordTouched: true,
            repeatPasswordTouched: true
        });
        return;
    }
    if (password !== repeat) {
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.resetPassword.mismatchTitle'),
            message: el.call('polyglot', 'auth.resetPassword.mismatchMessage'),
            type: 'error'
        });
        s.update({
            repeatPasswordTouched: true
        });
        return;
    }
    s.update({
        loading: true
    });
    try {
        await el.sdk.confirmPasswordReset(s.token, password);
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.resetPassword.updated.title'),
            message: el.call('polyglot', 'auth.resetPassword.updated.message'),
            type: 'success'
        });
        // withLiveQuery carries the live query/hash onto `/signin` —
        // tickets/sonnet.md "auth-page redirects still drop the query". A
        // bare `/signin` silently dropped any param riding alongside the
        // reset (e.g. `?next=`, `?claim=credits` from an earlier hop).
        setTimeout(()=>el.router((0, $1sP0S.withLiveQuery)('/signin'), el.getRoot()), 250);
    } catch (e) {
        console.error('[reset-password] confirmPasswordReset failed:', e);
        s.update({
            loading: false
        });
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.resetPassword.updateFailed'),
            message: e?.message || String(e) || el.call('polyglot', 'auth.login.tryAgain'),
            type: 'error'
        });
    }
};

});

parcelRegister("5ilmn", function(module, exports) {

$parcel$export(module.exports, "callback", () => $3daf33d6ce37bd49$export$eb872837e3137261);
// /github-auth-callback (and /auth/callback as a generic fallback) —
// completes a GitHub OAuth handshake against the SYMBOLS SDK.
//
// Flow:
//   1. GitHub redirects here with `?code=<...>` after the user authorizes.
//   2. We pull the invite token out of localStorage (it was stashed by
//      the OAuth click handler in LoginWindow because GitHub's redirect
//      strips arbitrary query params).
//   3. `el.sdk.githubAuth(code, inviteToken)` POSTs to /auth/github on
//      the Symbols server, which exchanges the code with GitHub's API,
//      creates/finds the user in MongoDB, and returns a Symbols SDK
//      session (TokenManager auto-persists the access + refresh tokens).
//   4. `initializeUserSession` hydrates the in-memory user via the SDK.
//   5. Route to `?next=` (read from URL or localStorage stash) or `/`.
//
// Errors surface inline so an OAuth misconfig (provider disabled,
// callback URL mismatch, etc.) is visible instead of a black screen.
//
// EVERY status this page shows is a bundle KEY in `s.statusKey`, resolved at
// render time — never a literal. This line of text IS the whole page while
// the handshake runs, so an English literal here left a Georgian arrival
// reading English from the first frame to the last, and no key gate could see
// it: the PROP check reads `text: '<literal>'`, and these sat behind a `||`
// inside a reactive function or under a plain state key. A failure is
// classified to a CODE by `functions/authCallbackError.js`; the provider's
// own words go to the console, never to the screen.
// (DESIGN-AUTH-CALLBACK-STATUS-TEXT-IS-ENGLISH-ONLY-ON-A-GEORGIAN-ARRIVAL-1;
// the gate is `pages/auth/callbackStatusI18n.test.js` plus this file's entry
// in `__tests__/i18nSharedExtraction.test.js` BRANCH_CLEAR.)

var $e2Fqo = parcelRequire("e2Fqo");

var $klqGv = parcelRequire("klqGv");
const $3daf33d6ce37bd49$export$eb872837e3137261 = {
    extends: 'Page',
    metadata: (el)=>({
            title: el.call('polyglot', 'auth.page.callback.title')
        }),
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    height: '100dvh',
    maxWidth: 'none',
    Card: {
        flow: 'column',
        align: 'center center',
        gap: 'A',
        padding: 'C',
        round: 'radiusCard',
        theme: 'dialog',
        border: 'hairline solid blue.1',
        minWidth: 'F',
        Status: {
            tag: 'p',
            fontSize: 'A',
            // `statusKey` is a bundle KEY, never copy — see the note above.
            text: (el, s)=>el.call('polyglot', s.statusKey || 'auth.callback.signingIn'),
            color: (el, s)=>s.error ? 'red' : 'fg.0'
        },
        onRender: async (el, s)=>{
            // Idempotency guard — onRender can fire twice in dev under HMR.
            if (s.exchangeStarted) return;
            s.update({
                exchangeStarted: true,
                statusKey: 'auth.callback.verifyingGithub',
                error: false
            });
            const url = new URL(window.location.href);
            const code = url.searchParams.get('code');
            // The CODE classifies (`access_denied`, `bad_verification_code`); the
            // description is prose. Both reach the console, neither reaches the
            // screen — they are English and in no bundle.
            const errorCode = url.searchParams.get('error');
            const errorDetail = url.searchParams.get('error_description');
            if (errorCode || errorDetail) {
                console.error('[github-auth-callback] provider refused:', errorCode, errorDetail);
                s.update({
                    error: true,
                    statusKey: el.call('authCallbackErrorKey', errorCode || errorDetail)
                });
                return;
            }
            if (!code) {
                s.update({
                    error: true,
                    statusKey: 'auth.callback.error.missingCode'
                });
                return;
            }
            try {
                const inviteToken = (0, $e2Fqo.readInviteToken)('github');
                const loginResult = await el.sdk.githubAuth(code, inviteToken);
                // A sign-in on this origin: its refresh token is its own (review D1).
                el.call('markOwnSession');
                s.update({
                    statusKey: 'auth.callback.hydrating'
                });
                await el.call('initializeUserSession', {
                    loginData: loginResult
                });
                s.update({
                    statusKey: 'auth.callback.redirecting'
                });
                const next = (0, $klqGv.consumeOAuthNext)(url.searchParams.get('next'));
                // SIGNUP-INTENT — see functions/signupIntent.js
                window.location.replace(next === '/' ? el.call('takeSignupCheckoutNext') || next : next);
            } catch (err) {
                console.error('[github-auth-callback] failed:', err);
                s.update({
                    error: true,
                    statusKey: el.call('authCallbackErrorKey', err)
                });
            }
        },
        BackLink: {
            extends: 'Link',
            href: '/login',
            text: '{{ auth.callback.backToSignIn | polyglot }}',
            show: (el, s)=>!!s.error,
            fontSize: 'Z2'
        }
    }
};

});

parcelRegister("4prUv", function(module, exports) {

$parcel$export(module.exports, "magicCallback", () => $335f25a772717392$export$9737ef61e1b4d136);
// /auth/magic-callback — final hop in the magic-link sign-in web flow.
//
// Server side (server/src/domains/auth/controllers/AuthController.js
// confirmMagicLink): user clicks the link in their email →
// `<api>/auth/magic-link/confirm?token=<...>` → server validates the
// token, mints SDK access + refresh tokens, redirects to:
//
//   <shell>/auth/magic-callback#access_token=<...>&refresh_token=<...>
//                              &access_exp=<ms>&refresh_exp=<ms>
//                              &redirect=<optional>
//
// Tokens land in the URL HASH (not query) so they don't appear in
// HTTP logs or Referer headers as the page loads. We parse them out,
// hand them to the SDK's TokenManager (which persists to localStorage),
// hydrate the user via initializeUserSession, then strip the hash and
// route to `redirect` (clamped to a same-origin path) or `/`.
//
// Errors surface inline rather than silently bouncing — a missing
// token in the hash, an SDK persist failure, or a getMe() rejection
// all give the user a clear message + a back link.
//
// EVERY status this page shows is a bundle KEY in `s.statusKey`, resolved at
// render time — never a literal. This line of text IS the whole page while
// the handshake runs, so an English literal here left a Georgian arrival
// reading English from the first frame to the last, and no key gate could see
// it: the PROP check reads `text: '<literal>'`, and these sat behind a `||`
// inside a reactive function or under a plain state key. A failure is
// classified to a CODE by `functions/authCallbackError.js`; the SDK's own
// message goes to the console, never to the screen.
// (DESIGN-AUTH-CALLBACK-STATUS-TEXT-IS-ENGLISH-ONLY-ON-A-GEORGIAN-ARRIVAL-1;
// the gate is `pages/auth/callbackStatusI18n.test.js` plus this file's entry
// in `__tests__/i18nSharedExtraction.test.js` BRANCH_CLEAR.)
const $335f25a772717392$var$_parseHashTokens = ()=>{
    if (typeof window === 'undefined') return null;
    // Server uses `#access_token=...` (URL hash, not query) so secrets
    // don't appear in HTTP logs / Referer headers during the bounce.
    const hash = (window.location.hash || '').replace(/^#/, '');
    if (!hash) return null;
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');
    const accessExp = params.get('access_exp');
    if (!accessToken || !refreshToken) return null;
    return {
        accessToken: accessToken,
        refreshToken: refreshToken,
        accessExp: accessExp ? Number(accessExp) : null,
        refreshExp: params.get('refresh_exp') ? Number(params.get('refresh_exp')) : null,
        redirect: params.get('redirect')
    };
};
const $335f25a772717392$var$_clearHash = ()=>{
    if (typeof window === 'undefined') return;
    // Replace the URL without the hash so a refresh / back-button doesn't
    // re-fire the callback with the same single-use tokens. `replaceState`
    // avoids adding a history entry; the server's 302 already created one.
    try {
        const clean = `${window.location.pathname}${window.location.search}`;
        window.history.replaceState(null, '', clean);
    } catch (_) {
    /* sandbox may throw — non-fatal */ }
};
const $335f25a772717392$export$9737ef61e1b4d136 = {
    extends: 'Page',
    metadata: (el)=>({
            title: el.call('polyglot', 'auth.page.callback.title')
        }),
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    height: '100dvh',
    maxWidth: 'none',
    Card: {
        flow: 'column',
        align: 'center center',
        gap: 'A',
        padding: 'C',
        round: 'radiusCard',
        theme: 'dialog',
        border: 'hairline solid blue.1',
        minWidth: 'F',
        Status: {
            tag: 'p',
            fontSize: 'A',
            // `statusKey` is a bundle KEY, never copy — see the note above.
            text: (el, s)=>el.call('polyglot', s.statusKey || 'auth.callback.verifyingLink'),
            color: (el, s)=>s.error ? 'red' : 'fg.0'
        },
        onRender: async (el, s)=>{
            // Idempotency guard — onRender can fire multiple times under HMR
            // and the tokens are single-use, so we mustn't replay them.
            if (s.exchangeStarted) return;
            s.update({
                exchangeStarted: true,
                statusKey: 'auth.callback.persisting',
                error: false
            });
            const parsed = $335f25a772717392$var$_parseHashTokens();
            if (!parsed) {
                s.update({
                    error: true,
                    statusKey: 'auth.callback.error.linkMalformed'
                });
                return;
            }
            const { accessToken: accessToken, refreshToken: refreshToken, accessExp: accessExp, redirect: redirect } = parsed;
            $335f25a772717392$var$_clearHash();
            try {
                // SDK doesn't expose a public setTokens — go through TokenManager
                // directly. This matches what AuthService.googleAuth /
                // confirmRegistration / etc. do internally on a successful login.
                const sdk = el.sdk;
                const tokenManager = sdk?._tokenManager;
                if (!tokenManager?.setTokens) throw new Error('SDK token manager unavailable');
                const expiresIn = accessExp ? Math.max(0, Math.floor((accessExp - Date.now()) / 1000)) : null;
                tokenManager.setTokens({
                    access_token: accessToken,
                    refresh_token: refreshToken,
                    expires_in: expiresIn,
                    token_type: 'Bearer'
                });
                // A sign-in on this origin: its refresh token is its own (review D1).
                el.call('markOwnSession');
                s.update({
                    statusKey: 'auth.callback.loadingAccount'
                });
                // getMe() is the standard hydration call — bootShell uses the
                // same one. Wrapping in try/catch so a transient network blip
                // doesn't strand the user with valid tokens but no profile.
                let user = null;
                try {
                    user = await sdk.getMe?.();
                } catch (err) {
                    console.warn('[magic-callback] getMe failed (tokens still valid):', err?.message || err);
                }
                if (user) await el.call('initializeUserSession', {
                    loginData: {
                        user: user,
                        tokens: {
                            accessToken: accessToken,
                            refreshToken: refreshToken,
                            accessTokenExp: accessExp ? {
                                expiresAt: accessExp
                            } : undefined
                        }
                    }
                });
                s.update({
                    statusKey: 'auth.callback.redirecting'
                });
                // `redirect` comes from a hash anyone can craft: clamp it to a
                // same-origin path. A `javascript:` value would run script on this
                // origin right after the session swap; an absolute URL would be an
                // open redirect. consumeOAuthNext answers '/' for both.
                const next = el.call('consumeOAuthNext', redirect) || '/';
                // Use top-level navigation so the SDK reads the freshly-persisted
                // localStorage tokens via its normal init path on the next page —
                // matches what /github-auth-callback does.
                window.location.replace(next);
            } catch (err) {
                console.error('[magic-callback] sign-in failed:', err);
                s.update({
                    error: true,
                    statusKey: el.call('authCallbackErrorKey', err)
                });
            }
        },
        BackLink: {
            extends: 'Link',
            href: '/login',
            text: '{{ auth.callback.backToSignIn | polyglot }}',
            show: (el, s)=>!!s.error,
            fontSize: 'Z2'
        }
    }
};

});


parcelRegister("fPlod", function(module, exports) {

$parcel$export(module.exports, "install", () => $b85c35f0f8a7fdf3$export$4b3e715f166fdd78);
const $b85c35f0f8a7fdf3$export$4b3e715f166fdd78 = {
    extend: [
        'Page',
        'Flex'
    ],
    state: {
        installTab: 'Development'
    },
    props: {
        flow: 'y',
        maxWidth: 'none',
        padding: 'D3+Z D3'
    },
    InstallHero: {},
    Space: {
        boxSize: 'D3'
    },
    InstallTabs: {},
    Line: {
        margin: '0'
    },
    Flex: {
        margin: 'C1 -',
        flow: 'y',
        gap: 'C1',
        childExtends: 'Flex',
        childProps: {
            flow: 'y'
        },
        InstallDomain: {
            gap: 'C1',
            show: (el, s)=>s.installTab === 'Domain'
        },
        InstallLiveExt: {
            show: (el, s)=>s.installTab === 'Live'
        },
        IfCdn: {
            gap: 'C1',
            show: (el, s)=>s.installTab === 'Development' && el.getActivePkgManager() === 'cdn',
            InstallCdn: {},
            Line: {
                margin: 'B2 0 0',
                maxWidth: 'D1'
            },
            InstallLiveExt: {}
        },
        IfNotCdn: {
            gap: 'C1',
            show: (el, s)=>s.installTab === 'Development' && el.getActivePkgManager() !== 'cdn',
            TerminalWithTitle: {
                maxWidth: '50%',
                '@tabletM': {
                    maxWidth: 'none'
                },
                Title: {
                    text: (el)=>`1. Install Symbols via ${el.getActivePkgManager()}:`
                },
                Terminal: {
                    margin: '0 0 0 -Y',
                    value: (el)=>el.getActivePkgManager() === 'npm' ? {
                            domql: 'npm i smbls --save',
                            react: 'npm i @symbo.ls/react --save'
                        } : el.getActivePkgManager() === 'yarn' ? {
                            domql: 'yarn add smbls',
                            react: 'yarn add @symbo.ls/react'
                        } : el.getActivePkgManager() === 'pnpm' ? {
                            domql: 'pnpm add smbls',
                            react: 'pnpm add @symbo.ls/react'
                        } : '// bash'
                }
            },
            InstallSymbolsJson: {},
            InstallSync: {},
            InstallProvider: {
                if: (el)=>el.getRootState().framework === 'react'
            }
        }
    },
    Line_2: {
        margin: 'B2 -'
    },
    InstallFooter: {}
};

});

parcelRegister("gCszs", function(module, exports) {

$parcel$export(module.exports, "invite", () => $c1965b86729bff31$export$dd37b42f82fee9c3);
const $c1965b86729bff31$export$dd37b42f82fee9c3 = {
    extend: 'Flex',
    state: {
        role: 'guest'
    },
    props: {
        flow: 'column',
        align: 'center',
        height: '100%'
    },
    Form: {
        margin: 'auto',
        maxWidth: 'H',
        width: '100%',
        Hgroup: {
            margin: '- - C1',
            H: {
                text: '{{ members.invite.heading | polyglot }}'
            },
            P: null
        },
        InviteForm: {
            gap: 'A2'
        },
        P: {
            gap: 'E',
            margin: 'A2 - C1 -',
            color: 'gray7',
            maxWidth: 'G1',
            text: '{{ members.invite.body | polyglot }}'
        },
        ContinueButton: {
            tag: 'button',
            type: 'submit',
            margin: 'C1 - - -Y2',
            text: '{{ common.action.invite | polyglot }}',
            theme: 'primary'
        },
        CancelButton: {
            tag: 'button',
            type: 'button',
            margin: 'C1 - - Y1',
            text: '{{ common.action.cancel | polyglot }}',
            theme: 'secondary',
            onClick: async (ev, el)=>{
                const isModal = el.getWindow('modal') === 'Invite';
                if (isModal) await el.call('openRouterModal', '/settings', {
                    key: '/project-account'
                });
                else if (el.isCanvas()) await el.call('closeRouterModal');
                else await el.router('/', el.getRoot());
            }
        },
        onSubmit: async (ev, el, s)=>{
            ev.preventDefault();
            const { name: name, email: email, role: role } = s;
            const { projectId: projectId } = el.getRootState();
            try {
                if (projectId && email && role && name) {
                    // NOTE: We need to be able to invite both registered and non-registered users
                    // (the server builds the accept URL itself — no callbackUrl needed)
                    await el.sdk.inviteMember(projectId, email, role, {
                        name: name
                    });
                    el.call('openNotification', {
                        title: el.call('polyglot', 'members.invite.success.title'),
                        message: el.call('polyglot', 'members.invite.success.message').replace('{name}', name),
                        type: 'success'
                    });
                    el.node.reset();
                    s.set({
                        role: 'guest'
                    });
                } else el.call('openNotification', {
                    title: el.call('polyglot', 'members.invite.validation.title'),
                    message: el.call('polyglot', 'members.invite.validation.message'),
                    type: 'warning'
                });
            } catch (err) {
                el.call('openNotification', {
                    title: el.call('polyglot', 'members.invite.error.title'),
                    message: `${err}`,
                    type: 'error'
                });
                console.error(err);
            }
        }
    }
};

});

parcelRegister("26MfW", function(module, exports) {

$parcel$export(module.exports, "foldSharedLibContext", () => $189192fcd33ad2ce$export$de6daded83629f59);
$parcel$export(module.exports, "lazyPage", () => $189192fcd33ad2ce$export$f0824772714954c5);
$parcel$export(module.exports, "lazySharedLib", () => $189192fcd33ad2ce$export$3c75c6f66e16f17b);
$parcel$export(module.exports, "lazySharedLibPage", () => $189192fcd33ad2ce$export$267bc1a9baf1c971);
// Route-based code-splitting helper (canonical home — consumed by the
// workspace shell AND sub-app packages like analytics, so every package's
// page registry can defer its page modules to dynamic-import chunks).
//
// Wraps a heavy sub-app page module in a lightweight placeholder so its code
// lands in a separate dynamic `import()` chunk instead of the initial shell
// bundle. Today `workspace/context.js` → `pages/index.js` (and `pages/main.js`'s
// `_APP_WINDOW_PAGES`) STATICALLY import every sub-app page, so loading ANY
// workspace route — including `/` — pulls the entire sub-app page payload
// (~800K of source; canvas pages alone are 528K) into the context chunk. That
// is the dominant driver of the ~5.8s cold FCP.
//
// The placeholder registers the route eagerly (so smbls's auto-router and the
// home AppWindow PageSlot can mount it synchronously), then on create it
// imports the real page module and swaps it in via `el.set` — the same
// imperative-mount pattern the home AgentsWidget canvas uses (verified: a
// ~500-node `el.set` mount is ~741ms and does NOT freeze the renderer).
//
// Used IDENTICALLY by:
//   • the auto-router (a `context.pages['/route']` value), and
//   • the home AppWindow PageSlot (`_APP_WINDOW_PAGES['/route']`),
// since both just `el.set()` the value — the placeholder self-loads either way.
//
// Usage:
//   '/chat': lazyPage(
//     () => import('@symbo-ls/workspace-chat/pages/index.js').then(m => m.home),
//     { title: 'Chat / Symbols Workspace' }
//   )
//
// The loader MUST resolve to the page object (do the `.then(m => m.export)` in
// the loader) so a single dynamic import per sub-app package yields one async
// chunk shared by all of that package's routes.
// NOTE on lifecycle: `el.set(page)` routes through `context.__create`
// (element/src/methods.js set → create.js), which fires the loaded page's
// own onCreate/onRender on the mounted content element. Do NOT invoke the
// page's lifecycle manually here — that double-runs non-idempotent onCreate
// work (presence subscriptions, board loaders) against the wrapper element,
// which has no onRemove to clean them up.
// Add-missing fold of a shared-library context ({ components, functions,
// state? }) into the LIVE app registry — the single mechanism behind the
// lazySharedLib / lazySharedLibPage route folds AND imperative folds (the
// messenger's ensureChatContext). Never clobbers an existing key: the eager
// slice / an earlier fold wins, so double-folding is a no-op by design.
const $189192fcd33ad2ce$export$de6daded83629f59 = (root, lib)=>{
    const ctx = root.context;
    if (lib?.components && ctx?.components) {
        for(const k in lib.components)if (!ctx.components[k]) ctx.components[k] = lib.components[k];
    }
    if (lib?.functions && ctx?.functions) {
        for(const k in lib.functions)if (!ctx.functions[k]) ctx.functions[k] = lib.functions[k];
    }
    if (lib?.state) {
        const seed = {};
        for(const k in lib.state)if (root[k] === undefined) seed[k] = lib.state[k];
        if (Object.keys(seed).length) root.update?.(seed);
    }
};
const $189192fcd33ad2ce$export$f0824772714954c5 = (loader, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: // Carry the title so @symbo.ls/helmet sets the tab title immediately, before
        // the chunk resolves; the real page's own `metadata` re-applies on mount.
        metadata,
        // The loader rides in `scope`, never a closure over the factory argument: a
        // published library serializes this definition, and a closure's free
        // variable is gone there (frank FA205) — the route stayed on its
        // placeholder. Same shape as the shell's own pages/lazyPage.js.
        scope: {
            loader: loader
        },
        onCreate: async (el)=>{
            if (el.__lazyLoaded) return;
            el.__lazyLoaded = true;
            // Late-resolve guard — the chunk import is async, so the router (or the
            // AppWindow PageSlot) can navigate away while it's in flight. The
            // placeholder's node is then detached, and el.set on a detached element
            // REVIVES the dead page as a second router content node at the shell root
            // — observed as the /admin page rendering below home after the demo
            // route guard bounced /admin → / before the admin chunk resolved (the
            // shell grid split into two ~half-viewport rows, and the dead page's
            // helmet re-wrote the tab title). Skipping the swap when the node is no
            // longer in the document closes the race for both mount paths.
            // "Gone" means DISPOSED — dispose() clears el.__ref (and el.node) — not
            // "not connected YET": smbls 3.14.84x builds an app's whole first view
            // detached and attaches it in one insertion (firstRender), so a loader
            // that settles before that insertion is NOT a navigation away. The old
            // `!el.node.isConnected` guard read it as gone and left the route on its
            // skeleton forever (the shell's signed-out /login, 2026-10-21, fixed
            // the same way in workspace af8b61d14). el.whenConnected runs the swap
            // now when connected, else in the task that inserts the node, and never
            // for a disposed element.
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const page = await el.scope.loader();
                if (!page) throw new Error('loader resolved empty');
                _place({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                });
            } catch (err) {
                console.error('[lazyPage] failed to load route module:', err && err.message);
                _place({
                    tag: 'div',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ shell.errorState.lazyPage | polyglot }}'
                });
            }
        }
    });
const $189192fcd33ad2ce$export$3c75c6f66e16f17b = (ctxLoader, pickPage, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        scope: {
            ctxLoader: ctxLoader,
            pickPage: pickPage
        },
        onCreate: async (el)=>{
            if (el.__lazyLibLoaded) return;
            el.__lazyLibLoaded = true;
            // The late-resolve guard of lazyPage above (disposed → never; not
            // attached yet → when it is).
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const mod = await el.scope.ctxLoader();
                // context.js default export: { components, functions, state?, pages }
                const lib = mod && mod.default ? mod.default : mod;
                // A shared-lib context that resolves with NO components AND NO functions
                // is a broken/stale bundle — its `import * as` namespaces came across
                // empty (default imports like `pages`/`state` can still be fine). The
                // add-missing merges below would then silently no-op and the mounted
                // page's bare keys would render an empty shell (the observed blank
                // Marketplace, 2026-07-21). Fail into the catch — which resets the retry
                // guard + shows a Refresh prompt — instead of a silent blank page.
                if (!lib || !lib.components && !lib.functions) throw new Error("shared-lib context resolved with no components/functions \u2014 stale/mismatched bundle (rebuild needed)");
                const root = el.getRoot?.() || el;
                $189192fcd33ad2ce$export$de6daded83629f59(root, lib);
                const page = el.scope.pickPage(lib);
                if (!page) throw new Error('shared-lib page resolved empty');
                _place({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                });
            } catch (err) {
                // Reset the load guard so a transient/stale failure (a flapping dev
                // server, or a bundle that hasn't rebuilt yet) can retry on the next
                // mount instead of leaving the route permanently dead. (The guard is set
                // eagerly above to prevent re-entrancy during the in-flight import.)
                el.__lazyLibLoaded = false;
                console.error('[lazySharedLib] load failed:', err && err.message);
                _place({
                    tag: 'div',
                    role: 'alert',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ shell.errorState.lazyPage | polyglot }}'
                });
            }
        }
    });
const $189192fcd33ad2ce$export$267bc1a9baf1c971 = (ctxLoader, pageLoader, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        scope: {
            ctxLoader: ctxLoader,
            pageLoader: pageLoader
        },
        onCreate: async (el)=>{
            if (el.__lazyLibPageLoaded) return;
            el.__lazyLibPageLoaded = true;
            // The late-resolve guard of lazyPage above (disposed → never; not
            // attached yet → when it is).
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const mod = await el.scope.ctxLoader();
                // context.js default export: { components, functions, state? }
                const lib = mod && mod.default ? mod.default : mod;
                const root = el.getRoot?.() || el;
                $189192fcd33ad2ce$export$de6daded83629f59(root, lib);
                const page = await el.scope.pageLoader();
                if (!page) throw new Error('page loader resolved empty');
                _place({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                });
            } catch (err) {
                console.error('[lazySharedLibPage] load failed:', err && err.message);
                _place({
                    tag: 'div',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ shell.errorState.lazyPage | polyglot }}'
                });
            }
        }
    });

});

parcelRegister("4WlVO", function(module, exports) {

$parcel$export(module.exports, "projectCode", () => $398d975a3012009b$export$e5a6d2c0631319ef);
const $398d975a3012009b$export$e5a6d2c0631319ef = {
    state: {
        placeholders: {
            'index.html': `<html background="#000">
  <head>
    '\$' '\$'
  </head>
  <body>
    <script defer type="text/javascript">
      '\$';
    </script>
  </body>
</html>`,
            'app.js': `export default {
  props: {
    theme: 'document',
  },
}`,
            'context.js': `export default {
    key: '\$',
    designSystem: '\$',
    state: '\$',
    components: '\$',
    pages: {
      '/component': Component,
      ...'\$',
    },
    snippets: '\$',
    methods: '\$',
    functions: '\$',
    editor: '\$',
    files: '\$',
    dependencies: '\$',
    schema: '\$',
    routerOptions: {
      scrollToTop: true,
    },
    domqlOptions: {
      alowRefReference: true,
    },
  }`,
            'index.js': `export default {
  props: {
    theme: 'document',
  },
}`
        },
        selected: {},
        selectedKey: '// placeholder'
    },
    IconButton: {
        icon: 'crossmark',
        padding: 'Y2',
        position: 'absolute',
        top: 'X',
        right: 'X',
        // eslint-disable-next-line no-restricted-syntax -- icon-only close button, not text
        color: 'inactive',
        onClick: (ev, el, s, ctx)=>el.call('closeRouterModal')
    },
    Overflow: {
        overflow: 'hidden auto',
        flexFlow: 'y',
        gap: 'B2',
        widthRange: 'F2',
        padding: '- Z - -',
        borderWidth: '0 1px 0 0',
        borderStyle: 'solid',
        borderColor: 'line',
        fontSize: 'Z1',
        ProjectCodeSidebar: {}
    },
    Content: {
        extends: 'Flex',
        flex: 1,
        childExtends: 'Flex',
        childProps: {
            flow: 'y',
            flex: 1,
            height: '100%',
            padding: '- Z2',
            Header: {
                order: '-1',
                padding: '- Z Z X',
                borderBottom: 'hairline solid line',
                color: 'inactive',
                fontSize: 'Y',
                textTransform: 'uppercase'
            },
            CodePreviewWidget: {
                flex: 1,
                widthRange: 'auto',
                maxWidth: 'none',
                width: '99.9%',
                round: 'radiusControl',
                padding: 'Y X2 X2 -',
                theme: 'field-static',
                overflow: 'hidden',
                Monaco: {
                    readOnly: (el)=>el.isReadOnly(),
                    foldLevel: false,
                    opacity: 1,
                    fileTab: {
                        type: 'javascript',
                        fileTabKey: 'function'
                    }
                }
            }
        },
        ProjectCodeData: {},
        ProjectCodeSchema: {
            hide: (el, s)=>{
                const found = el.call('getWhichKey', s.type);
                return !found.includes('DATA_TYPES');
            }
        }
    },
    props: {
        flexFlow: 'x',
        width: '100%',
        height: '100%',
        padding: 'Z2 A1 X',
        align: 'stretch',
        gap: 'A',
        theme: 'modal',
        '& .monaco-editor': {
            style: {
                width: '100%'
            }
        },
        onInit: (el, s)=>{
            const baseUrl = `https://${el.getAppKey()}`;
            s.placeholders['sitemap.xml'] = el.call('generateSitemap', baseUrl, el.getData('pages'));
        }
    }
};

});

parcelRegister("exKv7", function(module, exports) {

$parcel$export(module.exports, "publishModal", () => $a96837e25da63155$export$90745f2147dee19c);
const $a96837e25da63155$export$90745f2147dee19c = {
    tag: 'form',
    state: {
        isLoading: false,
        isConfirming: false
    },
    ModalHeader: {
        margin: '0',
        title: 'Publish',
        p: 'Publish changes and release version.',
        Article: {
            P: {
                margin: '0'
            }
        }
    },
    Cnt: {
        margin: 'auto',
        padding: 'C1',
        LoadingGif: {
            hide: (el, s)=>s.changes,
            inCenter: null
        },
        P: {
            hide: (el, s)=>!s.changes,
            text: (el, s)=>s.changes && Object.keys(s.changes).length ? 'Changes to release:' : 'No new data to release.'
        },
        Changes: {
            children: (el, s)=>s.changes && Object.keys(s.changes).filter((key)=>s.changes[key].length || Object.keys(s.changes[key]).length).map((key)=>({
                        extends: 'P',
                        text: (el)=>key === 'other' ? el.call('polyglot', 'publish.modal.otherPaths') : `${key}: ${s.changes[key].join(', ')}`
                    }))
        }
    },
    ConfirmTip: {
        hide: (el, s)=>!s.isConfirming,
        tag: 'P',
        color: 'paragraph',
        text: '{{ publish.modal.confirmAgain | polyglot }}'
    },
    ModalFooter: {
        CheckButton: null,
        PublishButton: {
            LoadingGif: {
                width: '1.8em',
                height: '1.8em',
                hide: (el, s)=>!s.isLoading,
                margin: '0 auto',
                opacity: '.9'
            },
            extends: [
                'Button',
                'ClickableItem'
            ],
            icon: (el, s)=>s.isLoading ? '' : 'checkmark',
            type: 'submit',
            text: (el, s)=>s.isLoading ? '' : el.call('polyglot', s.isConfirming ? 'publish.modal.confirm' : 'publish.action.publish'),
            disabled: (el, s)=>!s.changes || !Object.keys(s.changes).length || s.isLoading,
            padding: 'Z1 B1 Z1 B',
            minWidth: '12em',
            round: 'radiusPill',
            flexAlign: 'center center',
            theme: 'primary',
            gap: 'X2',
            ':disabled': {
                opacity: '.35',
                theme: 'secondary'
            }
        }
    },
    extend: 'ModalWindow',
    props: {
        maxWidth: '65vw',
        width: '100%',
        maxHeight: '65vh',
        height: '100%',
        onRender: async (el, s)=>{
            await el.sdk.checkpoint();
            const { projectId: projectId, branch: branch } = el.getRootState();
            const changes = await el.sdk.getBranchChanges(projectId, branch);
            const reducedChanges = changes.reduce((acc, v)=>{
                const isSchema = v[1][0] === 'schema';
                const key = isSchema ? v[1][1] : v[1][0];
                const subKey = isSchema ? v[1][2] : v[1][1];
                if (acc[key]) {
                    if (!subKey) acc[key].push(...Object.keys(v[2]));
                    else if (!acc[key].includes(subKey)) acc[key].push(subKey);
                } else acc.other.push(key);
                return acc;
            }, {
                components: [],
                pages: [],
                functions: [],
                designSystem: [],
                other: []
            });
            s.replace({
                changes: reducedChanges
            });
        },
        onSubmit: async (e, el, s)=>{
            e.preventDefault();
            if (s.isLoading) return;
            // First click shows confirmation state
            if (!s.isConfirming) {
                s.update({
                    isConfirming: true
                });
                return;
            }
            s.update({
                isLoading: true,
                isConfirming: false
            });
            const rootState = el.getRootState();
            const { projectId: projectId, branch: branch, version: version } = rootState;
            const result = await el.sdk.publishVersion(projectId, {
                version: version,
                branch: branch
            });
            rootState.replace({
                version: result.value
            }, {
                preventUpdate: true
            });
            // Notify other UI parts
            el.sdk.rootBus.emit('version:published', {
                projectId: projectId,
                version: result.value
            });
            s.update({
                isLoading: false
            });
            await el.call('closeRouterModal');
            el.call('setCookie', `${el.getAppKey()}_projectWasPublished`, true);
        }
    }
};

});

parcelRegister("iKHyy", function(module, exports) {

$parcel$export(module.exports, "resetModal", () => $da6e4f418d33e171$export$25aad40bccc73c84);
const $da6e4f418d33e171$export$25aad40bccc73c84 = {
    extends: 'ModalWindow',
    tag: 'form',
    state: null,
    ModalHeader: {
        title: 'Reset',
        p: 'Do you want to revert to the latest release?'
    },
    cnt: {
        props: {
            padding: '- B1 - -'
        },
        P: {
            props: {
                color: 'paragraph'
            },
            text: (el)=>el.call('polyglot', 'editor.resetModal.reverting').replace('{version}', el.getRootState().version)
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            text: '{{ common.action.reset | polyglot }}'
        }
    },
    on: {
        submit: async (e, el, s, ctx)=>{
            e.preventDefault();
            await el.call('closeRouterModal');
        }
    }
};

});

parcelRegister("hdhas", function(module, exports) {

$parcel$export(module.exports, "settings", () => $c880f7b47c01925b$export$a5a6e0b888b2c992);
const $c880f7b47c01925b$export$a5a6e0b888b2c992 = {
    SettingsSection: {
        extends: 'SettingsSection',
        Title: {
            text: '{{ settings.platform.title | polyglot }}'
        },
        Grid: {
            '@tabletM': {
                columns: 'repeat(3, 1fr)'
            },
            children: [
                {
                    extends: 'SelectDropdownWithTitle',
                    ignoreChildExtend: true,
                    // Row-separator-as-chrome (design-direction.md §8 / DESIGN_LANGUAGE
                    // §2.5) — was a top border split across '@dark'/'@light' with raw
                    // `--color-line-dark`/`--color-line-light` custom-property names,
                    // not even wrapped in a token. The row's own top padding already
                    // separates it from the grid above.
                    padding: 'B1 - -',
                    Title: {
                        opacity: '.65',
                        // Was a raw `gray7` hue — a single fixed value with no light/dark
                        // pair (Rule 69), composited with this row's `.65` opacity it
                        // measured 2.6:1 light / 2.09:1 dark (needs 4.5; AA walk
                        // 2026-08-09, LMC-4). `caption` is the adaptive neutral pair used
                        // for this same de-emphasized-label role elsewhere on this page
                        // (SwitchFieldWithCaption.Caption) — verified >=4.6 light /
                        // >=5.7 dark at this exact opacity.
                        color: 'caption',
                        text: '{{ settings.platform.defaultTheme | polyglot }}'
                    },
                    SelectDropdown: {
                        Value: {
                            Text: {
                                text: (el)=>el.getRootState('globalTheme')
                            }
                        },
                        Dropdown: {
                            top: '121%',
                            options: [
                                {
                                    key: 'auto',
                                    labelKey: 'settings.platform.theme.auto'
                                },
                                {
                                    key: 'dark',
                                    labelKey: 'settings.platform.theme.dark'
                                },
                                {
                                    key: 'light',
                                    labelKey: 'settings.platform.theme.light'
                                }
                            ],
                            onChoose: (ev, el, s, ctx, calleeElement)=>{
                                const theme = calleeElement.state.key;
                                el.getRootState().update({
                                    globalTheme: theme,
                                    sceneTheme: theme
                                }, {
                                    message: `Updated global theme to ${theme}`
                                });
                                el.getRoot().call('setCookie', 'sceneTheme', theme);
                                el.getRoot().call('setCookie', 'globalTheme', theme);
                            },
                            DropdownHeader: {
                                text: '{{ settings.platform.globalTheme | polyglot }}'
                            },
                            ListInDropdown: {
                                childProps: {
                                    extends: 'KeyValueColumnFields',
                                    isActive: (el, s)=>el.getRootState('globalTheme') === s.key,
                                    // NO `text:` here. KeyValueColumnFields renders the option
                                    // label in its own `Text` slot (`s.text || s.value || s.key`)
                                    // and the row HAS children, so a `text:` on the row appends a
                                    // SECOND text node beside them — every option rendered its
                                    // label twice with the checkmark between ("Auto ✓ Auto").
                                    // Same fix as components/LanguageSelectField.js.
                                    fontWeight: '400',
                                    // The options carry polyglot KEYS (labelKey): a '{{ … | polyglot }}'
                                    // string read out of row state is data to the template resolver since
                                    // smbls 3c416df0c, and this Text slot painted raw 'Auto / Dark / Light'.
                                    Text: {
                                        text: (el, s)=>el.call('polyglot', s.labelKey)
                                    }
                                }
                            }
                        }
                    }
                },
                // Interface language — the person's OWN choice, next to the theme row.
                //
                // THE shared control (components/LanguageSelectField.js). The option
                // list, the endonym labelling, the `root.lang` read and the `setLang`
                // write all live there ONCE, so this row, the account page's Language
                // card and the workspace-admin default cannot drift apart.
                //
                // Only the grid-specific chrome and this row's own labels sit here.
                {
                    extends: 'InterfaceLanguageField',
                    ignoreChildExtend: true,
                    padding: 'B1 - -',
                    Title: {
                        text: '{{ settings.language.title | polyglot }}'
                    },
                    SelectDropdown: {
                        Dropdown: {
                            DropdownHeader: {
                                text: '{{ settings.language.title | polyglot }}'
                            }
                        }
                    }
                },
                {
                    key: 'optimizedMode',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.lowPerformance')
                        }
                    },
                    Caption: {
                        text: '{{ settings.platform.lowPerformance | polyglot }}'
                    },
                    onChange: (ev, el)=>{
                        const val = el.getUserSettings('optimizedMode');
                        el.setAllUserSettings({
                            optimizedMode: !val,
                            debuggingMode: !val,
                            thumbnailPreview: !val,
                            openOnDblClick: !val,
                            explorerAutoscroll: val,
                            allowFilesidebarPreview: val,
                            allowTabs: val,
                            allowTabPreview: val,
                            showGrid: val,
                            useGlassmorphism: val,
                            allowZoombar: val,
                            allowTeamCursors: val,
                            showReferences: val,
                            allowAutoPosition: val,
                            useAnimations: val
                        }, {
                            message: 'Reset settings'
                        });
                    }
                },
                {
                    key: 'explorer',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.enableExplorer')
                        }
                    },
                    Caption: {
                        text: '{{ settings.platform.enableExplorer | polyglot }}'
                    }
                },
                {
                    key: 'debuggingMode',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.debugging')
                        }
                    },
                    Caption: {
                        text: '{{ settings.platform.debugging | polyglot }}'
                    }
                },
                {
                    key: 'useDomql3',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.domql3')
                        }
                    },
                    Caption: {
                        text: '{{ settings.platform.domql3 | polyglot }}'
                    }
                },
                {
                    key: 'useGlassmorphism',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.glassSidebars')
                        }
                    },
                    Caption: {
                        text: '{{ settings.platform.glassSidebars | polyglot }}'
                    }
                },
                {
                    key: 'allowFilesidebarPreview',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.filePreviews')
                        }
                    },
                    Caption: {
                        text: '{{ settings.platform.filePreviews | polyglot }}'
                    }
                },
                {
                    key: 'explorerAutoscroll',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.scrollFilesSidebar')
                        }
                    },
                    Caption: {
                        text: '{{ settings.platform.scrollFilesSidebar | polyglot }}'
                    }
                }
            ]
        }
    },
    CanvasSettings: {
        extends: 'SettingsSection',
        Title: {
            text: '{{ settings.canvas.title | polyglot }}',
            QuestionMarkTooltip: {
                onClick: (ev, el)=>{
                    el.setAllUserSettings({
                        optimizedMode: false,
                        thumbnailPreview: false,
                        showGrid: true,
                        allowTabs: true,
                        allowZoombar: true,
                        allowAutoPosition: true,
                        allowTabPreview: true,
                        useAnimations: true
                    }, {
                        message: 'Reset settings'
                    });
                }
            }
        },
        Grid: {
            '@tabletM': {
                columns: 'repeat(3, 1fr)'
            },
            children: [
                {
                    key: 'thumbnailPreview',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.imagePreviews')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.imagePreviews | polyglot }}'
                    }
                },
                {
                    key: 'allowTeamCursors',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.teamCursors')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.teamCursors | polyglot }}'
                    }
                },
                {
                    key: 'showReferences',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.componentReferences')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.componentReferences | polyglot }}'
                    }
                },
                {
                    key: 'allowCanvasReplaceRouter',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.linkScroll')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.linkScroll | polyglot }}'
                    }
                },
                {
                    key: 'openOnDblClick',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.doubleClickOpen')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.doubleClickOpen | polyglot }}'
                    }
                },
                {
                    key: 'autoSelectSidebar',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.autoSelectSidebar')
                        }
                    },
                    Caption: {
                        // Was 'Double click to open:' — copy-pasted from the
                        // openOnDblClick row above (SETTINGS-IA-1); this toggle is
                        // autoSelectSidebar, an unrelated control.
                        text: '{{ settings.canvas.autoSelectSidebar | polyglot }}'
                    }
                },
                {
                    key: 'showGrid',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.showGrid')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.showGrid | polyglot }}'
                    }
                },
                {
                    key: 'allowTitleOnArtboard',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.artboardTitles')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.artboardTitles | polyglot }}'
                    }
                },
                {
                    key: 'allowZoombar',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.zoomBar')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.zoomBar | polyglot }}'
                    }
                },
                {
                    key: 'allowAutoPosition',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.autoPositioning')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.autoPositioning | polyglot }}'
                    }
                },
                {
                    key: 'allowInitialSelection',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.autoInitialSelection')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.autoInitialSelection | polyglot }}'
                    }
                },
                {
                    key: 'useAnimations',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.animations')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.animations | polyglot }}'
                    }
                },
                {
                    key: 'autoCleanConsole',
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.autoCleanConsole')
                        }
                    },
                    Caption: {
                        text: '{{ settings.canvas.autoCleanConsole | polyglot }}'
                    }
                }
            ]
        }
    },
    DesignSystemOptions: {},
    SyncingSettings: {
        extends: 'SettingsSection',
        state: 'settings',
        Title: {
            text: '{{ settings.sync.title | polyglot }}'
        },
        Grid: {
            '@tabletM': {
                columns: 'repeat(3, 1fr)'
            },
            children: [
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.syncNavigation')
                        }
                    },
                    onChange: (ev, el)=>{
                        el.toggleUserSettings('presentMode');
                    },
                    Caption: {
                        text: '{{ settings.sync.navigation | polyglot }}'
                    },
                    Input: {
                        checked: (el)=>el.getUserSettings('presentMode')
                    }
                },
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.syncTeamNavigation')
                        }
                    },
                    Caption: {
                        text: '{{ settings.sync.teamNavigation | polyglot }}'
                    }
                },
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.syncTeamNavigation')
                        }
                    },
                    Caption: {
                        text: '{{ settings.sync.forceReload | polyglot }}'
                    },
                    Input: null,
                    SwitchField: null,
                    IconButton: {
                        order: 5,
                        icon: 'reload',
                        onClick: (ev, el)=>{
                            const agreed = window.confirm(el.call('polyglot', 'settings.sync.forceReloadConfirm'));
                            if (agreed) el.getRootState().update({}, {
                                forceReload: true,
                                preventShModalUpdate: true
                            });
                        }
                    }
                },
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.syncTeamNavigation')
                        }
                    },
                    Caption: {
                        text: '{{ settings.sync.forceNavigate | polyglot }}'
                    },
                    Input: null,
                    SwitchField: null,
                    IconButton: {
                        order: 5,
                        icon: 'arrowUp',
                        onClick: (ev, el)=>{
                            const url = window.prompt(el.call('polyglot', 'settings.sync.forceNavigatePrompt'), window.location.pathname);
                            el.getRootState().update({}, {
                                forceNavigate: url,
                                preventShModalUpdate: true
                            });
                        }
                    }
                }
            ]
        }
    },
    WebsiteSettings: {
        extends: 'SettingsSection',
        state: 'settings',
        Title: {
            text: '{{ settings.website.title | polyglot }}'
        },
        Grid: {
            '@tabletM': {
                columns: 'repeat(3, 1fr)'
            },
            children: [
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.fetchData')
                        }
                    },
                    Caption: {
                        text: '{{ settings.website.fetchData | polyglot }}'
                    }
                },
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.asyncLoading')
                        }
                    },
                    Caption: {
                        text: '{{ settings.website.asyncLoading | polyglot }}'
                    }
                },
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.allowInspecting')
                        }
                    },
                    Caption: {
                        text: '{{ settings.website.allowInspecting | polyglot }}'
                    }
                },
                {
                    QuestionMarkTooltip: {
                        TooltipHidden: {
                            shapeDirection: 'top',
                            description: (el)=>el.call('polyglot', 'settings.tip.liveSync')
                        }
                    },
                    Caption: {
                        text: '{{ settings.website.liveSync | polyglot }}'
                    }
                }
            ]
        }
    },
    CodeEditor: {
        extends: 'Flex',
        flow: 'y',
        state: 'settings/codeEditor',
        SectionTitle: {
            text: '{{ settings.codeEditor.title | polyglot }}',
            margin: '- - A2'
        },
        Flex: {
            gap: 'C1',
            // SIZE-1 item 2 (tickets/sonnet.md, WAVE-G, 2026-08-14/15): both
            // direct children below (the fields-panel Flex + CodePreviewWidget)
            // are `flex: 1` via this SAME childProps — the textbook flex-overflow
            // trap: a flex child's default `min-width: auto` lets its own
            // intrinsic content (an unwrapped long line in Monaco, per
            // CodePreviewWidget's `wordWrap: 'off'` default) dictate a width
            // wider than its flex-basis, which is what was producing the
            // horizontal scrollbar / off-viewport Input measured on this page.
            // `minWidth: '0'` here fixes BOTH children in one place instead of
            // duplicating the token twice — same abstraction childProps already
            // uses for `flex: 1`.
            childProps: {
                flex: 1,
                minWidth: '0'
            },
            Flex: {
                props: {
                    flow: 'y',
                    gap: 'B1'
                },
                childExtend: {
                    extend: 'Grid',
                    props: {
                        gap: 'B1 C3',
                        templateColumns: 'repeat(2, 1fr)'
                    }
                },
                inputs: {
                    childExtend: {
                        extend: 'InputField',
                        Input: {
                            onInput: (ev, el, s)=>{
                                el.call('setCookie', codeEditor);
                            // el.sdk.set(['settings', ''], (el.props.isNumber ? parseInt : v => v)(
                            //       el.node.value
                            //     ), {
                            //       forceMonacoUpdate: true
                            //     })
                            // )
                            }
                        }
                    },
                    fontFamily: {
                        Title: {
                            text: '{{ settings.codeEditor.fontFamily | polyglot }}'
                        },
                        Input: {
                            placeholder: (el)=>el.call('polyglot', 'settings.codeEditor.fontFamilyPlaceholder'),
                            value: '{{ fontFamily }}'
                        }
                    },
                    fontSize: {
                        Title: {
                            text: '{{ settings.codeEditor.fontSize | polyglot }}'
                        },
                        Input: {
                            placeholder: '14',
                            value: '{{ fontSize }}'
                        }
                    },
                    lineHeight: {
                        Title: {
                            text: '{{ settings.codeEditor.lineHeight | polyglot }}'
                        },
                        Input: {
                            placeholder: '20',
                            value: '{{ lineHeight }}'
                        }
                    },
                    editorDebounce: {
                        Title: {
                            text: '{{ settings.codeEditor.debounce | polyglot }}'
                        },
                        Input: {
                            placeholder: '20',
                            value: (el, s)=>s.editorDebounce || 250
                        }
                    }
                },
                selects: {
                    childExtend: {
                        extend: 'SelectDropdownWithTitle',
                        Title: {
                            text: (el, s)=>s[el.parent.key]
                        },
                        SelectDropdown: {
                            Dropdown: {
                                top: '121%',
                                onChoose: (ev, el, s, ctx, calleeElement)=>{
                                    const { key: key } = el.parent.parent;
                                    s.update({
                                        [key]: calleeElement.state.value
                                    }, {
                                        message: `Updated ${key} settings`,
                                        forceMonacoUpdate: true
                                    });
                                },
                                ListInDropdown: {
                                    childExtends: {
                                        extend: 'KeyValueColumnFields',
                                        props: (el, s)=>({
                                                isActive: el.getRootState('settings').codeEditor?.[el.parent.parent.parent.parent.key] === s.value,
                                                text: s.value,
                                                fontWeight: '400'
                                            })
                                    }
                                }
                            }
                        }
                    },
                    tabSize: {
                        props: {},
                        Title: {
                            text: '{{ settings.codeEditor.tabSize | polyglot }}'
                        },
                        SelectDropdown: {
                            Value: {
                                Text: {
                                    text: ({ state: state })=>state.tabSize || 2
                                }
                            },
                            Dropdown: {
                                options: [
                                    2,
                                    4,
                                    6,
                                    8
                                ],
                                DropdownHeader: {
                                    text: '{{ settings.codeEditor.tabSize | polyglot }}'
                                }
                            }
                        }
                    },
                    wordWrap: {
                        props: {},
                        Title: {
                            text: '{{ settings.codeEditor.wordWrap | polyglot }}'
                        },
                        SelectDropdown: {
                            Value: {
                                Text: {
                                    text: ({ state: state })=>state.wordWrap || 'off'
                                }
                            },
                            Dropdown: {
                                options: [
                                    'off',
                                    'on',
                                    'wordWrapColumn',
                                    'bounded'
                                ],
                                DropdownHeader: {
                                    text: '{{ settings.codeEditor.wordWrap | polyglot }}'
                                }
                            }
                        }
                    }
                },
                toggles: {
                    childExtend: {
                        extend: 'SwitchFieldWithCaption',
                        props: {
                            cursor: 'pointer',
                            // Row-separator-as-chrome (design-direction.md §8 /
                            // DESIGN_LANGUAGE §2.5) — was a top border split across
                            // '@dark'/'@light' with raw `--color-line-dark`/
                            // `--color-line-light` custom-property names, not even
                            // wrapped in a token. Top padding below already separates
                            // each generated toggle row.
                            padding: 'B1 - -',
                            onChange: (ev, el, s)=>{
                                const { key: key } = el;
                                const val = s[key];
                                s.update({
                                    [key]: !val
                                }, {
                                    message: `Updated ${key} settings`,
                                    forceMonacoUpdate: true
                                });
                            }
                        },
                        Input: {
                            checked: ({ parent: parent, state: state })=>state[parent.key]
                        },
                        Caption: {},
                        SwitchField: {}
                    },
                    fontLigatures: {
                        props: {
                            QuestionMarkTooltip: {
                                TooltipHidden: {
                                    shapeDirection: 'top',
                                    description: (el)=>el.call('polyglot', 'settings.tip.fetchData')
                                }
                            },
                            Caption: {
                                text: '{{ settings.codeEditor.fontLigature | polyglot }}'
                            }
                        }
                    },
                    'minimap.enabled': {
                        props: {
                            QuestionMarkTooltip: {
                                TooltipHidden: {
                                    shapeDirection: 'top',
                                    description: (el)=>el.call('polyglot', 'settings.tip.fetchData')
                                }
                            },
                            Caption: {
                                text: '{{ settings.codeEditor.minimap | polyglot }}'
                            }
                        }
                    },
                    folding: {
                        props: {
                            QuestionMarkTooltip: {
                                TooltipHidden: {
                                    shapeDirection: 'top',
                                    description: (el)=>el.call('polyglot', 'settings.tip.fetchData')
                                }
                            },
                            Caption: {
                                text: '{{ settings.codeEditor.folding | polyglot }}'
                            }
                        }
                    }
                }
            },
            CodePreviewWidget: {
                // SIZE-1 item 2: `widthRange: null` used to sit here with no
                // explaining comment, unlike every other deliberate override in
                // this file — nulling it strips CodePreviewWidget's own default
                // responsive width clamp (`widthRange: 'H1'`,
                // packages/monaco/components/CodePreviewWidget.js), which only
                // compounds the flex-overflow trap fixed above. Removed so this
                // panel falls back to its own sensible default.
                props: (el, s)=>({
                        Monaco: {
                            foldLevel: null,
                            fileTab: {
                                code: el.stringifyCode(s.parse()),
                                filename: 'codeEditor.js'
                            },
                            onCodeEditCallback: async (editor)=>{
                                const codeEditor1 = await el.call('parseStringCode', /* N5: parse the buffer, never eval it */ editor.getValue());
                                el.getRootState('settings').codeEditor = codeEditor1;
                                s.set(codeEditor1, {
                                    message: 'Updated cope editor preferences'
                                });
                            }
                        }
                    })
            }
        },
        IconText: {
            extends: 'DocsLink',
            margin: 'B1 - -',
            color: 'inactive',
            alignSelf: 'end',
            cursor: 'pointer',
            gap: 'X2',
            target: 'blank',
            href: 'https://microsoft.github.io/monaco-editor/typedoc/variables/editor.EditorOptions.html',
            icon: 'questionMarkFill',
            text: '{{ settings.codeEditor.monacoOptions | polyglot }}',
            fontWeight: 400
        }
    },
    SettingsFooter: {},
    extend: [
        'Page',
        'Flex'
    ],
    props: {
        flow: 'y',
        gap: 'D1'
    }
};

});

parcelRegister("6nKaQ", function(module, exports) {

$parcel$export(module.exports, "shareModal", () => $4a58b5377d5fe3e4$export$236be14cb52f38ab);
const $4a58b5377d5fe3e4$export$236be14cb52f38ab = {
    extend: 'ModalWindow',
    tag: 'form',
    ModalHeader: {
        title: 'Share',
        p: 'Share?'
    },
    Flex: {},
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            text: '{{ common.action.share | polyglot }}'
        }
    },
    on: {
        submit: (e, el, s, ctx)=>{
            e.preventDefault();
        }
    }
};

});

parcelRegister("ga0Rt", function(module, exports) {

$parcel$export(module.exports, "tutorialModal", () => $bc3e3f97790e19e7$export$6462aba67b8c79ca);
const $bc3e3f97790e19e7$export$6462aba67b8c79ca = {
    extend: 'ModalWindow',
    tag: 'form',
    ModalHeader: {
        props: ({ state: state })=>({
                title: state.title,
                p: state.description
            })
    },
    Flex: {
        align: 'stretch flex-start',
        gap: 'C1',
        padding: 'Z2 -',
        Iframe: {
            props: (el, s)=>({
                    boxSize: '315px 560px',
                    src: s.youtube,
                    // `title` on an iframe is the a11y NAME screen readers announce, so it
                    // is an HTML attribute and takes the FUNCTION form
                    // (docs/I18N-CONVENTION.md §1). `s.title` carries the KEY.
                    title: el.call('polyglot', s.title),
                    border: '0',
                    round: 'X2',
                    margin: '-B -Z -Z',
                    minHeight: '0',
                    allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
                    allowfullscreen: true
                })
        }
    },
    on: {
        init: (el, s)=>{
            s.update({
                // KEY-IN-STATE — the iframe's `title` resolves these through
                // `el.call('polyglot', …)` above. `ModalHeader` reads `title`/`p`
                // as CONTENT and renders NEITHER today (its `Hgroup.H` carries no
                // `text:`), so that path is inert either way — see the
                // `#modalHeader` entries in `__tests__/i18nSharedExtraction.test.js`.
                title: 'editor.tutorialModal.title',
                description: 'editor.tutorialModal.descr',
                youtube: 'https://www.youtube.com/embed/QIdimVDuSEU?si=NaGhGaHADN8jj_aH&amp;controls=0'
            }, {
                preventUpdate: true
            });
        }
    }
};

});

parcelRegister("avx10", function(module, exports) {

$parcel$export(module.exports, "uploadFontModal", () => $7a6668c1de743c0e$export$cbabd69ef08e278a);
const $7a6668c1de743c0e$export$cbabd69ef08e278a = {
    extend: 'ModalWindow',
    tag: 'form',
    state: {
        isVariable: false,
        sampleText: 'Today is a big day for our tribe. The year ends.',
        value: {}
    },
    props: {
        padding: 'A B',
        onInit: (el, s)=>{
            const path = window.location.pathname;
            const pathArray = path.split('edit-font/');
            const { font: font } = el.getDesignSystem();
            const key = pathArray[1];
            if (key && font[key]) {
                const value = el.call('deepClone', font[key]);
                return s.update({
                    key: key,
                    value: value
                }, {
                    preventUpdate: true
                });
            }
            s.update({
                value: []
            }, {
                preventUpdate: true
            });
        },
        onSubmit: (e, el, s, ctx)=>{
            e.preventDefault();
            const { key: key, value: value } = s;
            if (!key || !value) return;
            const t = setTimeout(()=>{
                el.updateDesignSystem({
                    font: {
                        [key]: value
                    }
                });
                clearTimeout(t);
            }, 75);
            el.call('closeRouterModal', el, s, ctx);
        }
    },
    ModalHeader: {
        title: 'Upload font'
    },
    Flex: {
        align: 'stretch center',
        gap: 'C',
        minHeight: 'G',
        maxHeight: 'H2',
        padding: '0 B A 0',
        Flex: {
            flow: 'column',
            gap: 'B1',
            minWidth: 'F1',
            padding: '0 B2 0 0',
            position: 'sticky',
            top: '0',
            style: {
                borderRight: '.06)'
            },
            InputField: {
                Title: {
                    text: '{{ editor.uploadFont.name | polyglot }}'
                },
                Input: {
                    placeholder: (el)=>el.call('polyglot', 'editor.uploadFont.namePlaceholder'),
                    value: '{{ key }}',
                    onKeyup: (e, el, s)=>{
                        s.update({
                            key: el.node.value
                        });
                    },
                    onChange: (e, el, s)=>{
                        s.update({
                            key: el.node.value
                        });
                    }
                }
            },
            CheckboxField: (el, s)=>({
                    Input: {
                        checked: s.isVariable
                    },
                    onChange: (ev, el, s)=>{
                        ev.preventDefault();
                        const isVar = !s.isVariable;
                        const val = s.value;
                        if (isVar) {
                            if (el.call('isArray', val)) {
                                s.value = val[0];
                                s.value.isVariable = true;
                            }
                        } else if (!el.call('isArray', val)) {
                            if (val.isVariable) delete val.isVariable;
                            s.value = [
                                val
                            ];
                        }
                        s.toggle('isVariable');
                    }
                })
        },
        Group: {
            tag: 'section',
            Title: {
                text: '{{ editor.uploadFont.weights | polyglot }}'
            },
            Flex: {
                flow: 'column',
                gap: 'A',
                childExtends: 'FontWeightObject',
                childProps: {
                    position: 'relative',
                    LoadingGifSection: {
                        show: (el, s)=>s.loading,
                        zIndex: 1001,
                        position: 'absolute',
                        inset: '0',
                        theme: 'quaternary'
                    }
                },
                children: (el, s)=>{
                    if (s.isVariable) return [
                        s.value
                    ];
                    return s.value;
                },
                childrenAs: 'state'
            },
            UploadIcon: {
                width: '100%',
                hide: (el, s)=>s.isVariable && s.url,
                Input: {
                    opacity: '0',
                    position: 'absolute',
                    boxSize: '0',
                    type: 'file',
                    onChange: async (ev, el, s, ctx)=>{
                        try {
                            const name = el.node.value;
                            if (!name) return;
                            if (!s.value) s.value = [];
                            const value = s.value;
                            if (el.call('isArray', s.value)) s.applyFunction((s)=>value.push({
                                    name: name,
                                    loading: true
                                }));
                            else s.update({
                                loading: true
                            });
                            const { src: src } = await ctx.utils.client.stream('db:file-upload', {
                                contents: ev.target.files[0]
                            });
                            const currentValue = value[value.length - 1];
                            delete currentValue.loading;
                            delete currentValue.name;
                            delete currentValue.error;
                            const url = src.replace('files-production-symbols-platform-development-en-d5-u3-p7x0.based.dev', 'files.symbo.ls');
                            if (el.call('isArray', s.value)) s.applyFunction((s)=>value[value.length - 1] = {
                                    url: url,
                                    loading: false
                                });
                            else s.update({
                                url: url,
                                loading: false
                            });
                            if (!s.key) s.key = 'myfont';
                            ctx.utils.init({
                                font: {
                                    [s.key]: value
                                }
                            });
                        } catch (e) {
                            if (el.call('isArray', s.value)) s.applyFunction((s)=>s.value[s.value.length - 1] = {
                                    loading: false,
                                    error: e
                                });
                            else s.update({
                                loading: false,
                                error: e
                            });
                            el.error(e);
                        }
                    }
                }
            }
        }
    },
    ModalFooter: {
        CheckButton: {
            type: 'submit',
            text: '{{ common.action.save | polyglot }}'
        }
    }
};

});

parcelRegister("gzGBq", function(module, exports) {

$parcel$export(module.exports, "userProfile", () => $c110f63c04fe771b$export$9e5ae5b26d156995);
$parcel$export(module.exports, "__userProfileInternals", () => (parcelRequire("jn5Js")).__userProfileInternals);
// /u/:slug — public user profile.
//
// Shows: hero (avatar + name + bio + Follow), activity chart,
// public projects, integrations, agents, followers/following.
//
// Resolves the viewed user from the URL slug (last URL segment).
// Falls back to the current user when the slug matches the user's
// own email-prefix or slug, so /u/<me> renders the same surface as
// /profile but in the public-facing layout.
//
// Slug resolution (in order):
//   1. exact match on `peopleAll[*].slug` if populated
//   2. email-prefix match (e.g. `nika` → `nika@symbols.app`)
//   3. fallback `{ email: <slug>@symbols.app, name: <slug> }` so
//      profile pages can be shared even before the directory
//      hydrates the row.
//
// Activity chart writes to `_profileActivity` (separate root key
// from tickets' `_activityData`) so the two charts on /tickets and
// /u/:slug don't fight over the same store.
// Slug resolution + data loaders live in `functions/userProfileData.js`, not
// here: the workspace shell must be able to re-run them on a same-route
// workspace switch (PROFILE-PAGE-NO-REHYDRATE-ON-SWITCH-1). This page is now
// only the mount-time caller.

var $jn5Js = parcelRequire("jn5Js");
const $c110f63c04fe771b$export$9e5ae5b26d156995 = {
    extends: 'Page',
    metadata: (el)=>({
            title: el.call('pageTitle', 'account.page.userProfile.title')
        }),
    maxWidth: 'none',
    padding: '0',
    // Mount-time hydration. The SAME function the shell re-runs on a
    // workspace switch (loadPrivateData.js PHASE 2) — one resolver, two
    // callers, so the two paths can never drift.
    onCreate: async (el, s)=>{
        await (0, $jn5Js.hydrateUserProfile)(s.root);
    },
    onRemove: (el)=>{
        const root = el.getRoot();
        if (!root) return;
        root.update({
            _profileSlug: null,
            _profileViewed: null,
            _profileActivity: {},
            _profileProjects: null
        });
    },
    // Loader — shown only during the resolution round-trip so neither
    // the real profile nor the 404 chrome flashes for the wrong identity.
    // Hidden via `display: none` (not `if:`) so the page DOM stays mounted
    // and child fetches keep their context.
    ProfileResolving: {
        extends: 'Flex',
        hide: (el, s)=>!s.root?._profileLoading,
        flow: 'y',
        align: 'center center',
        minHeight: '40vh',
        // Indeterminate busy state — Spinner, never a "Loading…" string (§9).
        LoadingSpinner: {
            color: 'caption'
        }
    },
    UserProfile: {
        hide: (el, s)=>!!s.root?._profileLoading || !!s.root?._profileViewed?._notFound
    },
    // 404 chrome — shown when `_resolveViewedAsync` couldn't match the
    // slug anywhere (local people directory + server username lookup).
    ProfileNotFound: {
        extends: 'Flex',
        if: (el, s)=>!s.root?._profileLoading && !!s.root?._profileViewed?._notFound,
        flow: 'y',
        align: 'center center',
        gap: 'B',
        padding: 'D',
        minHeight: '60vh',
        H: {
            tag: 'h1',
            text: '404',
            fontSize: 'F',
            fontWeight: '700',
            color: 'title',
            lineHeight: '1',
            margin: '0'
        },
        P: {
            tag: 'p',
            text: (el, s)=>`No user found at /user/${s.root?._profileSlug || ''}`,
            color: 'caption',
            fontSize: 'A',
            margin: '0'
        },
        Link: {
            href: '/team-members',
            text: '{{ account.userProfile.browseAll | polyglot }}',
            color: 'blue',
            fontWeight: '500',
            margin: 'A - -'
        }
    }
};

});
parcelRegister("jn5Js", function(module, exports) {

$parcel$export(module.exports, "hydrateUserProfile", () => $e1a49c92ef256014$export$c24cfdd137a4cb8f);
$parcel$export(module.exports, "isUserProfilePath", () => $e1a49c92ef256014$export$ed224713172bd825);
$parcel$export(module.exports, "__userProfileInternals", () => $e1a49c92ef256014$export$99f9c55d07cf173c);
// userProfileData — slug resolution + data loaders for the /user/:slug and
// /u/:slug profile surface.
//
// WHY THIS FILE EXISTS (PROFILE-PAGE-NO-REHYDRATE-ON-SWITCH-1): these
// loaders used to be module-private inside `pages/userProfile.js`, so no
// other caller could re-run them. The workspace shell's PHASE-1 tenant wipe
// (workspace/scopes.js, bucket ⑦) drains `_profileViewed` + `_profileActivity`
// on every workspace switch, but a SAME-ROUTE switch never remounts the page,
// so `onCreate` — the only caller of the resolver — never ran again and the
// profile sat on its empty shell until a navigation.
//
// Moving the loaders here gives the switch a PHASE-2 pair, exactly like the
// chat / tickets / calendar / meet surfaces already have: the shell imports
// `hydrateUserProfile` from this `functions/` subpath (the proven cross-
// package import shape — see functions/teams.js) and re-runs the same
// hydration the page runs on mount. One resolver, two callers, no polling and
// no DOM reads.
//
// `hydrateUserProfile(root, opts)` is the single entry point:
//   opts.slug   — override the slug (default: read from the URL)
//   opts.write  — patch writer (default `root.update`). The shell passes its
//                 epoch-guarded `put` so a superseded switch cannot repaint.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $aU444 = parcelRequire("aU444");

var $9juhh = parcelRequire("9juhh");

var $29wU0 = parcelRequire("29wU0");
// Accepts both `/user/:slug` (canonical, used in shared links) and
// `/u/:slug` (compact alias). Both routes mount this page.
// The workspace-prefixed form (`/w/<org>/<ws>/user/<slug>`) is the SHIPPED
// URL shape on every workspace-scoped tab — the router matches the route on
// the stripped path, so the page mounted while this raw-pathname regex
// returned '' and the profile resolved to nobody (found live while verifying
// PROFILE-PAGE-NO-REHYDRATE-ON-SWITCH-1: `_profileSlug: ''`, `_profileViewed:
// null` on /w/system/hq/user/marina). Strip the prefix with the same helper
// the navbar/tabs use, so both URL shapes resolve identically.
const $e1a49c92ef256014$var$_slugFromPath = ()=>{
    if (typeof window === 'undefined') return '';
    const path = (0, $9juhh.stripWorkspacePrefix)(window.location.pathname) || '/';
    const m = path.match(/^\/(?:user|u)\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
};
// Synchronous resolver — checks the local `peopleAll` directory. Returns
// the matched person or null. The async `_resolveViewedAsync` below
// extends this with a /core/auth/user?username=… lookup so canonical
// Mongo usernames (e.g. `nikoloza` for `nika@symbols.app`) resolve even
// though the Supabase `people` view doesn't carry the username column.
const $e1a49c92ef256014$var$_resolveLocal = (root, slug)=>{
    if (!slug) return null;
    const all = (root.peopleAll || []).concat(root.people || []);
    const byEmail = all.find((p)=>(p.email || '').toLowerCase() === slug.toLowerCase());
    if (byEmail) return byEmail;
    const bySlug = all.find((p)=>p.slug === slug);
    if (bySlug) return bySlug;
    const byPrefix = all.find((p)=>((p.email || '').split('@')[0] || '') === slug);
    if (byPrefix) return byPrefix;
    return null;
};
// Stamp an authoritative `_isSelf` marker on a resolved record when it is
// provably the signed-in user. The viewer identity (currentUserEmail /
// currentUserId) may not have hydrated yet, so we also match the slug against
// the current user's known username / email-prefix. Once stamped, the
// FollowBtn `hide` factory hides the control deterministically — independent
// of currentUser* timing (#self-follow).
const $e1a49c92ef256014$var$_markSelfIfMe = (root, rec, slug)=>{
    if (!rec || rec._isSelf) return rec;
    const meEmail = (root?.currentUserEmail || '').toLowerCase();
    const recEmail = (rec.email || '').toLowerCase();
    const meUser = (root?.currentUserUsername || '').toLowerCase();
    const meId = (root?.currentUserId || '').toString();
    const recId = (rec.userId || rec.id || rec._id || '').toString();
    const slugLc = (slug || '').toLowerCase();
    const isSelf = !!meEmail && meEmail === recEmail || !!meId && !!recId && meId === recId || !!meUser && (meUser === slugLc || meUser === (recEmail.split('@')[0] || '')) || !!meEmail && meEmail.split('@')[0] === slugLc;
    return isSelf ? {
        ...rec,
        _isSelf: true
    } : rec;
};
// Build a self-record from the hydrated client identity. Used when the slug is
// provably the signed-in user but no people-directory row carries the canonical
// username (e.g. `nikoloza` for `nika@symbols.app`) — without this the resolver
// would fall through to the 404 fallback and `_notFound` would HIDE your own
// profile entirely (and, on the rare race where it did render, leave the Follow
// button without a self marker). Stamps `_isSelf` so the control hides
// deterministically regardless of currentUser* timing (#self-follow).
const $e1a49c92ef256014$var$_selfRecordIfSlugIsMe = (root, slug)=>{
    const slugLc = (slug || '').toLowerCase();
    if (!slugLc) return null;
    const meEmail = (root?.currentUserEmail || '').toLowerCase();
    const meUser = (root?.currentUserUsername || '').toLowerCase();
    const mePrefix = meEmail.split('@')[0] || '';
    const isMe = !!meUser && meUser === slugLc || !!mePrefix && mePrefix === slugLc || !!meEmail && meEmail === slugLc;
    if (!isMe) return null;
    return {
        email: root.currentUserEmail || '',
        name: root.currentUserName || root.currentUserUsername || slug,
        slug: root.currentUserUsername || slug,
        avatar: root.currentUserAvatar || '',
        userId: (root.currentUserId || '').toString(),
        _isSelf: true
    };
};
// PROFILE-PERSIST-1: merge the authoritative self-record (identity fields
// only — email/name/slug/avatar/userId/_isSelf, built from currentUser*
// client state) with the richer `_resolveLocal` row when the local directory
// ALSO has one for this person. `selfEarly` alone carries no bio/position/
// location/city/startDate, so returning it unconditionally (the pre-fix
// behavior of step 0 below) silently discarded those fields on every load of
// your own profile by username — even though `onCreate` awaits
// `listOrgMembers` (hydrating `peopleAll`) BEFORE ever calling
// `_resolveViewedAsync`, so the richer row is normally already available by
// the time this runs. Identity stays authoritative from `selfEarly` (spread
// last, wins on overlap); HR fields ride along from `local`.  `_resolveLocal`
// can legitimately return null before hydration (or for a genuinely
// directory-less account) — degrade to the plain self-record shape rather
// than throwing.
const $e1a49c92ef256014$var$_mergeSelfWithLocal = (root, slug, selfEarly)=>{
    const local = $e1a49c92ef256014$var$_resolveLocal(root, slug);
    return local ? {
        ...local,
        ...selfEarly
    } : selfEarly;
};
// SILENT-SAVE-FAIL-1 surface 4 (second half): the canonical-username self
// path below (the `getMe()` branch, reached when neither the slug-vs-
// currentUser* short-circuit NOR the local-directory lookup already matched)
// hand-built an identity-only record — email/name/slug/avatar/userId/
// _isSelf — with no bio/position/location/etc, same six-field shape
// `_mergeSelfWithLocal` already fixed for the OTHER self path. Mirrors that
// fix: merge the richer local-directory row in, keyed by the now-known
// email (the local directory keys on email/slug/email-prefix, never on the
// Mongo `username` this branch resolved by, so a slug-keyed lookup here
// would still miss even when the row exists).
const $e1a49c92ef256014$var$_mergeMeRecWithLocal = (root, slug, identity)=>{
    const local = $e1a49c92ef256014$var$_resolveLocal(root, identity.email) || $e1a49c92ef256014$var$_resolveLocal(root, slug);
    return local ? {
        ...local,
        ...identity
    } : identity;
};
const $e1a49c92ef256014$var$_resolveViewedAsync = async (root, slug)=>{
    if (!slug) return null;
    // 0. Authoritative self short-circuit — if the slug is the signed-in user's
    //    own username / email-prefix, resolve to SELF from hydrated client
    //    state, merged with the local directory row for HR fields (bio/
    //    position/location/startDate/etc — see _mergeSelfWithLocal above).
    //    Runs first so `/user/<my-username>` always renders your own profile
    //    with the self marker, even when the people directory lacks a username
    //    row and getMe() is slow/empty (the path that previously dead-ended at
    //    _notFound).
    const selfEarly = $e1a49c92ef256014$var$_selfRecordIfSlugIsMe(root, slug);
    if (selfEarly) return $e1a49c92ef256014$var$_mergeSelfWithLocal(root, slug, selfEarly);
    // 1. Local people-directory match (email, slug, prefix).
    const local = $e1a49c92ef256014$var$_resolveLocal(root, slug);
    if (local) return $e1a49c92ef256014$var$_markSelfIfMe(root, local, slug);
    // 2. Server lookup by Mongo username — `/core/auth/user?username=<slug>`.
    //    People view doesn't have the `username` column (it lives in Mongo
    //    `User.username`), so this is the only path that resolves canonical
    //    slugs like `nikoloza` for `nika@symbols.app`.
    try {
        const me = await (0, $1NxyO.getSDK)().getMe?.();
        const meRec = me?.data?.user || me?.user || me;
        if (meRec && (meRec.username === slug || meRec.email === slug)) {
            // The viewed person is the current user — surface from the cached
            // /core/auth/me record so the hero renders without an extra fetch.
            const identity = {
                email: meRec.email,
                name: meRec.name,
                slug: meRec.username,
                avatar: meRec.avatar,
                userId: meRec._id || meRec.id || '',
                // Authoritative self marker — getMe() proved the slug is the
                // signed-in user, so the Follow control hides even if
                // root.currentUserEmail / currentUserId haven't hydrated yet.
                // Closes the "follow yourself" gap (#self-follow).
                _isSelf: true
            };
            // SILENT-SAVE-FAIL-1 surface 4: merge in the local directory row (see
            // _mergeMeRecWithLocal) so bio/position/location/etc. survive on this
            // path too — without it, this was the second of two six-field
            // hand-built records that structurally could never carry the bio the
            // user just saved.
            return $e1a49c92ef256014$var$_mergeMeRecWithLocal(root, slug, identity);
        }
    } catch (_) {
    /* swallow — fall through to the server lookup */ }
    try {
        // SDK first (WS-SDK-AUTH-USER-LOOKUP-METHOD-1): sdk.getUserByUsername
        // wraps GET /core/auth/user?username=, carries its own token through
        // TokenManager (no hand-read localStorage token), and unwraps the
        // envelope to the user object. Feature-detected because the registry
        // sdk (3.14.785) predates the method — consumers resolving a registry
        // copy take the raw-fetch fallback below until the next sdk publish,
        // and the fallback dies with that publish. When the method EXISTS it
        // owns this lookup outright: it hits the same endpoint, so re-fetching
        // on its miss would only repeat the same answer.
        const sdk = (0, $1NxyO.getSDK)();
        if (typeof sdk?.getUserByUsername === 'function') try {
            const u = await sdk.getUserByUsername(slug);
            if (u && (u.email || u.username)) return {
                email: u.email,
                name: u.name,
                slug: u.username || slug,
                avatar: u.avatar
            };
        } catch (_) {
        /* not found / auth error — fall through to the 404 marker */ }
        else {
            const tok = typeof window !== 'undefined' ? window.localStorage.getItem('symbols_access_token') : null;
            if (tok) {
                // The canonical resolver — NOT a hand-rolled base. The old ternary
                // read the raw localStorage pin ('local' → literal localhost:8080,
                // anything else → window.location.origin, i.e. the PORTLESS PROXY on
                // dev hosts) and ignored ?channel= and SYMBOLS_API_CHANNEL entirely —
                // one of the "localhost:8080 error despite the override" call sites.
                const apiBase = (0, $29wU0.workspaceApiBase)();
                const resp = await fetch(`${apiBase}/core/auth/user?username=${encodeURIComponent(slug)}`, {
                    headers: {
                        Authorization: 'Bearer ' + tok
                    }
                });
                if (resp.ok) {
                    const body = await resp.json();
                    const u = body?.data?.user || body?.user || body;
                    if (u && (u.email || u.username)) return {
                        email: u.email,
                        name: u.name,
                        slug: u.username || slug,
                        avatar: u.avatar
                    };
                }
            }
        }
    } catch (_) {
    /* swallow */ }
    // No match anywhere — return a not-found marker so the page renders
    // the 404 chrome. The page hides UserProfile and shows ProfileNotFound
    // based on this flag.
    return {
        email: slug.includes('@') ? slug : `${slug}@symbols.app`,
        name: slug.replace(/[._-]+/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase()),
        slug: slug,
        _notFound: true
    };
};
const $e1a49c92ef256014$var$_loadActivity = async (root, email, write)=>{
    if (!email) return;
    try {
        const since = new Date();
        since.setDate(since.getDate() - 365);
        const sinceDate = since.toISOString().slice(0, 10);
        const result = await (0, $1NxyO.getSDK)().execute('workspaceProject.activity', 'heatmap', {
            filter: {
                user_email: email,
                since: sinceDate,
                select: 'activity_type, score, occurred_on'
            }
        }).catch(()=>null);
        const data = Array.isArray(result?.data) ? result.data : result?.data || result || [];
        const counts = {};
        for (const row of data || []){
            const day = row.occurred_on;
            if (!day) continue;
            if (!counts[day]) counts[day] = {
                score: 0,
                marker: 0,
                breakdown: {}
            };
            counts[day].score += row.score || 0;
            counts[day].breakdown[row.activity_type] = (counts[day].breakdown[row.activity_type] || 0) + 1;
            if (row.activity_type === 'standup') counts[day].marker++;
        }
        write({
            _profileActivity: counts
        });
    } catch (err) {
        console.warn('[userProfile/activity]', err?.message || err);
        write({
            _profileActivity: {}
        });
    }
};
const $e1a49c92ef256014$var$_loadPublicProjects = async (root, slug, write)=>{
    if (!slug) return;
    try {
        const sdk = (0, $1NxyO.getSDK)();
        if (!sdk?.listPublicProjects) return;
        const rows = await sdk.listPublicProjects({
            owner: slug,
            limit: 100
        }).catch(()=>null);
        const list = Array.isArray(rows) ? rows : rows?.data || [];
        const projects = list.filter((p)=>{
            const o = p.workspace?.organization?.slug || p.workspace?.slug || '';
            return o === slug;
        });
        write({
            _profileProjects: projects
        });
    } catch (err) {
        console.warn('[userProfile/projects]', err?.message || err);
        write({
            _profileProjects: []
        });
    }
};
const $e1a49c92ef256014$export$c24cfdd137a4cb8f = async (root, opts = {})=>{
    if (!root) return null;
    const write = typeof opts.write === 'function' ? opts.write : (patch)=>root.update?.(patch);
    const slug = opts.slug != null ? opts.slug : $e1a49c92ef256014$var$_slugFromPath();
    write({
        _profileSlug: slug,
        _profileViewed: null,
        _profileLoading: true,
        _profileActivity: {},
        _profileProjects: null,
        _profileTab: root._profileTab || 'projects'
    });
    // Eagerly hydrate the people directory if it's empty. The local resolver
    // path (`_resolveLocal`) needs `peopleAll` to find people by email /
    // email-prefix; the server fallback handles canonical Mongo usernames.
    // On a workspace switch the roster is wiped and re-put by the shell, so
    // this is the re-fetch that makes the local match work again.
    const peopleLoaded = (root.peopleAll || []).length > 0 || (root.people || []).length > 0;
    if (!peopleLoaded) try {
        // Migrated workspaceProject.people → users.members. Args discarded
        // server-side; full member list returned.
        const list = await (0, $aU444.listOrgMembers)((0, $1NxyO.getSDK)());
        if (list && list.length) write({
            peopleAll: list
        });
    } catch (_) {
    // Best-effort; the async resolver below still falls through to
    // /core/auth/user?username=<slug>.
    }
    const viewed = await $e1a49c92ef256014$var$_resolveViewedAsync(root, slug);
    write({
        _profileViewed: viewed,
        _profileLoading: false
    });
    if (viewed?.email && !viewed._notFound) $e1a49c92ef256014$var$_loadActivity(root, viewed.email, write);
    if (slug && !viewed?._notFound) $e1a49c92ef256014$var$_loadPublicProjects(root, slug, write);
    return viewed;
};
const $e1a49c92ef256014$export$ed224713172bd825 = (path)=>{
    const p = path != null ? path : typeof window !== 'undefined' ? window.location.pathname : '';
    return /^\/(?:user|u)\/[^/?#]+/.test(p || '');
};
const $e1a49c92ef256014$export$99f9c55d07cf173c = {
    slugFromPath: $e1a49c92ef256014$var$_slugFromPath,
    resolveLocal: $e1a49c92ef256014$var$_resolveLocal,
    markSelfIfMe: $e1a49c92ef256014$var$_markSelfIfMe,
    selfRecordIfSlugIsMe: $e1a49c92ef256014$var$_selfRecordIfSlugIsMe,
    mergeSelfWithLocal: $e1a49c92ef256014$var$_mergeSelfWithLocal,
    mergeMeRecWithLocal: $e1a49c92ef256014$var$_mergeMeRecWithLocal,
    resolveViewedAsync: $e1a49c92ef256014$var$_resolveViewedAsync
};

});
parcelRegister("aU444", function(module, exports) {

$parcel$export(module.exports, "listOrgMembers", () => $7f024980a6438062$export$bf10e5d0731aa5e6);
$parcel$export(module.exports, "invalidateOrgMembers", () => $7f024980a6438062$export$25225ccc9412c4d1);
// Shared helper — fetch the full org member list via SDK and normalise
// the envelope. All call sites that need `sdk.execute('users.members','list')`
// should go through here so envelope unwrap logic lives in one place.
//
// Lives in `shared/functions` (moved from `workspace/functions` 2026-08-09,
// tickets/fable.md "shared/pages/userProfile.js imports a cross-PACKAGE
// sibling") because `shared/pages/userProfile.js` needs it and `shared` is a
// library consumed by workspace/marketplace/canvas — never the other way
// around. `workspace`'s own call sites (loadPrivateData.js, pages/main.js,
// pages/admin/danger.js) now import this file directly via the package
// specifier, the same convention every other cross-package workspace→shared
// reach already uses.
//
// The server's EntityDispatcher discards args for users.members.list so
// the call always returns the full list (capped to ~200 members by the
// server route).
//
// DEDUPE (perf): boot fires this several times (loadPrivateData people fetch +
// its later fan-out, loadAllTeams, grants) — each a ~10s round-trip on a cold
// backend (measured: users/members ×3 on /studio). We coalesce them here:
//   - an in-flight promise is shared by concurrent callers, and
//   - the resolved list is cached for a short TTL so the near-sequential boot
//     callers reuse it too.
// The TTL is short (org roster rarely changes) so post-boot reads stay fresh;
// `invalidateOrgMembers()` clears it explicitly after a membership mutation.
// FA204 / frank trap — `_inflight`/`_inflightOrg`/`_cache`/`_cacheAt`/
// `_cacheOrg` used to live at module scope and get referenced bare from
// both exports below (this function takes an `sdk` arg, not `el`/`root`, so
// there's no DOMQL element to hang state on) — re-homed onto
// `globalThis.__listOrgMembersState` per the mwtFlag.js/pointerCapability.js
// template; each export carries its own self-contained lazy-init of that
// same global object rather than a shared module-scope getter, which would
// be exactly the same bare-sibling-export trap one level down.
// `TTL_MS`/`_unwrap`/`_activeOrg` were pure with one caller
// (listOrgMembers) — inlined alongside it.
// `workspaceId` (optional) — the workspace the TAB is viewing (root.workspace
// .id, URL-derived). When passed, the server scopes the roster to THAT
// workspace's org (membership-verified) instead of the caller's global
// activeOrganization claim, which lags URL-based workspace browsing (multi-
// tab: two tabs on different orgs each get their own roster). The cache/
// in-flight key includes it so tabs on different workspaces never share rows.
async function $7f024980a6438062$export$bf10e5d0731aa5e6(sdk, workspaceId) {
    if (!globalThis.__listOrgMembersState) globalThis.__listOrgMembersState = {
        inflight: null,
        inflightOrg: null,
        cache: null,
        cacheAt: 0,
        cacheOrg: null
    };
    const state = globalThis.__listOrgMembersState;
    const TTL_MS = 15000;
    const unwrap = (rows)=>Array.isArray(rows) ? rows : rows?.data || rows?.people || rows?.rows || [];
    // The org roster is per-organization, so the cache AND the in-flight
    // promise MUST be keyed by the active org id — otherwise a switch within
    // the 15s TTL (or while a fetch under the previous org's token is still
    // in flight) hands the caller the PREVIOUS org's roster (the "people
    // list shows the old org after switching" bug). switchOrg updates
    // sdk._context.activeOrgId before the roster refetch fires, so a
    // mismatched cache / in-flight is treated as a miss.
    const activeOrg = (s)=>s?._context?.activeOrgId != null ? String(s._context.activeOrgId) : null;
    const org = (workspaceId ? 'ws:' + workspaceId + ':' : '') + activeOrg(sdk);
    if (state.cache && state.cacheOrg === org && Date.now() - state.cacheAt < TTL_MS) return state.cache;
    if (state.inflight && state.inflightOrg === org) return state.inflight;
    const inflight = (async ()=>{
        const rows = await sdk.execute('users.members', 'list', workspaceId ? {
            workspaceId: workspaceId
        } : undefined).catch(()=>null);
        const list = unwrap(rows);
        // Don't cache an empty/failed result — let the next caller retry.
        if (list.length) {
            state.cache = list;
            state.cacheAt = Date.now();
            state.cacheOrg = org;
        }
        return list;
    })();
    state.inflight = inflight;
    state.inflightOrg = org;
    try {
        return await inflight;
    } finally{
        // Only clear if a concurrent different-org call hasn't already replaced it.
        if (state.inflight === inflight) {
            state.inflight = null;
            state.inflightOrg = null;
        }
    }
}
function $7f024980a6438062$export$25225ccc9412c4d1() {
    if (!globalThis.__listOrgMembersState) return;
    globalThis.__listOrgMembersState.cache = null;
    globalThis.__listOrgMembersState.cacheAt = 0;
    globalThis.__listOrgMembersState.cacheOrg = null;
}

});



parcelRegister("cUIBX", function(module, exports) {

$parcel$export(module.exports, "waitlist", () => $966d51dde280ccb9$export$4fd09d08b607c3f1);
const $966d51dde280ccb9$export$4fd09d08b607c3f1 = {
    extends: 'Flex',
    flow: 'column',
    align: 'center',
    height: '100%',
    flex: '1',
    onSubmit: async (ev, el, s)=>{
        ev.preventDefault();
        const { email: email, name: name } = s.parse ? s.parse() : s;
        await el.sdk.addToWaitlist({
            email: email,
            name: name
        });
        el.router('/', el.getRoot());
        if (window.plausible) window.plausible('Signup to Waitlist');
    },
    Content: {
        tag: 'form',
        maxWidth: 'H',
        width: '100%',
        margin: 'auto',
        Hgroup: {
            margin: '- - C1',
            H: {
                text: '{{ auth.waitlist.heading | polyglot }}'
            },
            P: {
                text: '{{ auth.waitlist.body | polyglot }}'
            }
        },
        WaitlistForm: {
            margin: '- - - -Y2',
            gap: 'Z2'
        },
        ContinueButton: {
            type: 'submit',
            margin: 'C1 - - -Y2',
            text: '{{ auth.waitlist.submit | polyglot }}',
            theme: 'primary',
            minHeight: 'controlH',
            round: 'radiusPill',
            fontSize: 'Z2',
            fontWeight: '700'
        }
    },
    Footer: {}
};

});

parcelRegister("610V7", function(module, exports) {

$parcel$export(module.exports, "welcomeModal", () => $46138ccbdca52ca2$export$ea1b7e291e955de2);
const $46138ccbdca52ca2$export$ea1b7e291e955de2 = {
    extend: 'ModalWindow',
    tag: 'form',
    ModalHeader: {
        props: ({ state: state })=>({
                title: state.title,
                p: state.description
            })
    },
    Flex: {
        align: 'stretch flex-start',
        gap: 'C1',
        padding: 'Z2 -',
        Iframe: {
            props: (el, s)=>({
                    boxSize: '315px 560px',
                    src: s.youtube,
                    // `title` on an iframe is the a11y NAME screen readers announce, so it
                    // is an HTML attribute and takes the FUNCTION form
                    // (docs/I18N-CONVENTION.md §1). `s.title` carries the KEY.
                    title: el.call('polyglot', s.title),
                    border: '0',
                    round: 'X2',
                    margin: '-B -Z -Z',
                    minHeight: '0',
                    allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
                    allowfullscreen: true
                })
        }
    },
    on: {
        init: (el, s)=>{
            s.update({
                // KEY-IN-STATE — the iframe's `title` resolves these through
                // `el.call('polyglot', …)` above. `ModalHeader` reads `title`/`p`
                // as CONTENT and renders NEITHER today (its `Hgroup.H` carries no
                // `text:`), so that path is inert either way — see the
                // `#modalHeader` entries in `__tests__/i18nSharedExtraction.test.js`.
                title: 'editor.welcomeModal.title',
                description: 'editor.welcomeModal.descr',
                youtube: 'https://www.youtube.com/embed/QIdimVDuSEU?si=NaGhGaHADN8jj_aH&amp;controls=0'
            }, {
                preventUpdate: true
            });
        }
    }
};

});


parcelRegister("guSQX", function(module, exports) {

$parcel$export(module.exports, "openDropdown", () => $c029ff611100fe38$export$7b15a90e43f21cea);
$parcel$export(module.exports, "closeDropdown", () => $c029ff611100fe38$export$9772d2b5987ea925);
$parcel$export(module.exports, "setDropdownInert", () => $c029ff611100fe38$export$bb72042877e61007);
$parcel$export(module.exports, "sendPrompt", () => (parcelRequire("5qaoL")).sendPrompt);
$parcel$export(module.exports, "newSession", () => (parcelRequire("5qaoL")).newSession);
$parcel$export(module.exports, "switchSession", () => (parcelRequire("5qaoL")).switchSession);
$parcel$export(module.exports, "deleteSession", () => (parcelRequire("5qaoL")).deleteSession);
$parcel$export(module.exports, "hydrateServerSessions", () => (parcelRequire("5qaoL")).hydrateServerSessions);
$parcel$export(module.exports, "restoreActiveThread", () => (parcelRequire("5qaoL")).restoreActiveThread);
$parcel$export(module.exports, "buildAiAwareness", () => (parcelRequire("5qaoL")).buildAiAwareness);
$parcel$export(module.exports, "retryOrgSwitch", () => (parcelRequire("3JzjK")).retryOrgSwitch);
$parcel$export(module.exports, "bootShell", () => (parcelRequire("rm3Ji")).bootShell);
$parcel$export(module.exports, "bootPrepare", () => (parcelRequire("7fShD")).bootPrepare);
$parcel$export(module.exports, "bootResolve", () => (parcelRequire("9TBFw")).bootResolve);
$parcel$export(module.exports, "bootApply", () => (parcelRequire("de89x")).bootApply);
$parcel$export(module.exports, "registerSdkAdapter", () => (parcelRequire("8NTf1")).registerSdkAdapter);
$parcel$export(module.exports, "DEFAULT_LANG", () => (parcelRequire("cvFPD")).DEFAULT_LANG);
$parcel$export(module.exports, "DEFAULT_LANGUAGE_POLICY", () => (parcelRequire("cvFPD")).DEFAULT_LANGUAGE_POLICY);
$parcel$export(module.exports, "LANGUAGE_POLICIES", () => (parcelRequire("cvFPD")).LANGUAGE_POLICIES);
$parcel$export(module.exports, "PLATFORM_LANGUAGES", () => (parcelRequire("cvFPD")).PLATFORM_LANGUAGES);
$parcel$export(module.exports, "enforcedWorkspaceLang", () => (parcelRequire("cvFPD")).enforcedWorkspaceLang);
$parcel$export(module.exports, "isSupportedLang", () => (parcelRequire("cvFPD")).isSupportedLang);
$parcel$export(module.exports, "langDir", () => (parcelRequire("cvFPD")).langDir);
$parcel$export(module.exports, "resolveLang", () => (parcelRequire("cvFPD")).resolveLang);
$parcel$export(module.exports, "setLang", () => (parcelRequire("UyBCS")).setLang);
$parcel$export(module.exports, "applyWorkspaceLangPolicy", () => (parcelRequire("1axdt")).applyWorkspaceLangPolicy);
$parcel$export(module.exports, "pageTitle", () => (parcelRequire("drkt6")).pageTitle);
$parcel$export(module.exports, "brandName", () => (parcelRequire("drkt6")).brandName);
$parcel$export(module.exports, "resolvePageMetadataTitle", () => (parcelRequire("drkt6")).resolvePageMetadataTitle);
$parcel$export(module.exports, "loadI18nNamespace", () => (parcelRequire("j7gGM")).loadI18nNamespace);
$parcel$export(module.exports, "loadI18nNamespaces", () => (parcelRequire("j7gGM")).loadI18nNamespaces);
$parcel$export(module.exports, "hasI18nBundle", () => (parcelRequire("j7gGM")).hasI18nBundle);
$parcel$export(module.exports, "dropNonEnglishCache", () => (parcelRequire("j7gGM")).dropNonEnglishCache);
$parcel$export(module.exports, "getLoadedNamespaces", () => (parcelRequire("j7gGM")).getLoadedNamespaces);
$parcel$export(module.exports, "mergeAllNamespaces", () => (parcelRequire("j7gGM")).mergeAllNamespaces);
$parcel$export(module.exports, "i18nStaticTranslations", () => (parcelRequire("j7gGM")).i18nStaticTranslations);
$parcel$export(module.exports, "i18nStaticEnglish", () => (parcelRequire("j7gGM")).i18nStaticEnglish);
$parcel$export(module.exports, "timeAgo", () => (parcelRequire("kHrku")).timeAgo);
$parcel$export(module.exports, "zoneLabel", () => (parcelRequire("1ty3Y")).zoneLabel);
$parcel$export(module.exports, "playNotifySound", () => (parcelRequire("dfJUb")).playNotifySound);
$parcel$export(module.exports, "htmlToPlainText", () => (parcelRequire("3cqmC")).htmlToPlainText);
$parcel$export(module.exports, "localizedDate", () => (parcelRequire("50gPy")).localizedDate);
$parcel$export(module.exports, "inkOnPlate", () => (parcelRequire("8k31d")).inkOnPlate);
$parcel$export(module.exports, "openInSlot", () => (parcelRequire("f0yEX")).openInSlot);
$parcel$export(module.exports, "canOpenInSlot", () => (parcelRequire("f0yEX")).canOpenInSlot);
$parcel$export(module.exports, "openNotificationTarget", () => (parcelRequire("7hnoP")).openNotificationTarget);
$parcel$export(module.exports, "notificationHrefOf", () => (parcelRequire("lO82q")).notificationHrefOf);
$parcel$export(module.exports, "DRAG_REF_MIME", () => (parcelRequire("6zKVW")).DRAG_REF_MIME);
$parcel$export(module.exports, "DRAG_REF_KINDS", () => (parcelRequire("6zKVW")).DRAG_REF_KINDS);
$parcel$export(module.exports, "REF_DROP_ATTR", () => (parcelRequire("6zKVW")).REF_DROP_ATTR);
$parcel$export(module.exports, "setDragRef", () => (parcelRequire("6zKVW")).setDragRef);
$parcel$export(module.exports, "hasDragRef", () => (parcelRequire("6zKVW")).hasDragRef);
$parcel$export(module.exports, "hasDragFiles", () => (parcelRequire("6zKVW")).hasDragFiles);
$parcel$export(module.exports, "readDragRef", () => (parcelRequire("6zKVW")).readDragRef);
$parcel$export(module.exports, "dragRefLabel", () => (parcelRequire("6zKVW")).dragRefLabel);
$parcel$export(module.exports, "dragRefIcon", () => (parcelRequire("6zKVW")).dragRefIcon);
$parcel$export(module.exports, "dragRefToText", () => (parcelRequire("6zKVW")).dragRefToText);
$parcel$export(module.exports, "refDropTargetFrom", () => (parcelRequire("6zKVW")).refDropTargetFrom);
$parcel$export(module.exports, "dispatchRefDrop", () => (parcelRequire("6zKVW")).dispatchRefDrop);
$parcel$export(module.exports, "ENTITY_REF_TYPES", () => (parcelRequire("drrN1")).ENTITY_REF_TYPES);
$parcel$export(module.exports, "parseEntityRef", () => (parcelRequire("drrN1")).parseEntityRef);
$parcel$export(module.exports, "formatEntityRef", () => (parcelRequire("drrN1")).formatEntityRef);
$parcel$export(module.exports, "isEntityRef", () => (parcelRequire("drrN1")).isEntityRef);
$parcel$export(module.exports, "entityRefHref", () => (parcelRequire("drrN1")).entityRefHref);
$parcel$export(module.exports, "entityRefIcon", () => (parcelRequire("drrN1")).entityRefIcon);
$parcel$export(module.exports, "entityRefKindKey", () => (parcelRequire("drrN1")).entityRefKindKey);
$parcel$export(module.exports, "commentRowsFrom", () => (parcelRequire("8YjBp")).commentRowsFrom);
$parcel$export(module.exports, "commentAuthorLabel", () => (parcelRequire("8YjBp")).commentAuthorLabel);
$parcel$export(module.exports, "commentTimeLabel", () => (parcelRequire("8YjBp")).commentTimeLabel);
$parcel$export(module.exports, "canManageComment", () => (parcelRequire("8YjBp")).canManageComment);
$parcel$export(module.exports, "commentThreadRows", () => (parcelRequire("8YjBp")).commentThreadRows);
$parcel$export(module.exports, "commentCreatePayload", () => (parcelRequire("8YjBp")).commentCreatePayload);
$parcel$export(module.exports, "commentListFilter", () => (parcelRequire("8YjBp")).commentListFilter);
$parcel$export(module.exports, "buildPromptPayload", () => (parcelRequire("g6SPq")).buildPromptPayload);
$parcel$export(module.exports, "clearedPromptState", () => (parcelRequire("g6SPq")).clearedPromptState);
$parcel$export(module.exports, "removePromptAttachment", () => (parcelRequire("g6SPq")).removePromptAttachment);
$parcel$export(module.exports, "removePickedElement", () => (parcelRequire("g6SPq")).removePickedElement);
$parcel$export(module.exports, "accountMenuItems", () => (parcelRequire("9XFqh")).accountMenuItems);
$parcel$export(module.exports, "accountMenuAction", () => (parcelRequire("9XFqh")).accountMenuAction);
$parcel$export(module.exports, "openAccountMenu", () => (parcelRequire("9XFqh")).openAccountMenu);
$parcel$export(module.exports, "openAccountPage", () => (parcelRequire("9XFqh")).openAccountPage);
$parcel$export(module.exports, "navbarTabMenuItems", () => (parcelRequire("AxJRF")).navbarTabMenuItems);
$parcel$export(module.exports, "navbarTabMenuAction", () => (parcelRequire("AxJRF")).navbarTabMenuAction);
$parcel$export(module.exports, "navbarTabPrefs", () => (parcelRequire("AxJRF")).navbarTabPrefs);
$parcel$export(module.exports, "applyNavbarTabPrefs", () => (parcelRequire("AxJRF")).applyNavbarTabPrefs);
$parcel$export(module.exports, "saveNavbarTabOrder", () => (parcelRequire("AxJRF")).saveNavbarTabOrder);
$parcel$export(module.exports, "toggleCustomNavbarPin", () => (parcelRequire("AxJRF")).toggleCustomNavbarPin);
$parcel$export(module.exports, "renderAssistantMarkdown", () => (parcelRequire("7UbLZ")).renderAssistantMarkdown);
$parcel$export(module.exports, "getPref", () => (parcelRequire("2zRqK")).getPref);
$parcel$export(module.exports, "setPref", () => (parcelRequire("2zRqK")).setPref);
$parcel$export(module.exports, "clearPref", () => (parcelRequire("2zRqK")).clearPref);
$parcel$export(module.exports, "ACTIVE_ORG", () => (parcelRequire("2zRqK")).ACTIVE_ORG);
$parcel$export(module.exports, "collectSdkTokens", () => (parcelRequire("b1lQC")).collectSdkTokens);
$parcel$export(module.exports, "callCapability", () => (parcelRequire("2hTF2")).callCapability);
$parcel$export(module.exports, "listIntegrationKinds", () => (parcelRequire("2hTF2")).listIntegrationKinds);
$parcel$export(module.exports, "listScopedIntegrations", () => (parcelRequire("2hTF2")).listScopedIntegrations);
$parcel$export(module.exports, "loadIntegrationCatalogue", () => (parcelRequire("2hTF2")).loadIntegrationCatalogue);
$parcel$export(module.exports, "saveIntegration", () => (parcelRequire("2hTF2")).saveIntegration);
$parcel$export(module.exports, "deleteIntegration", () => (parcelRequire("2hTF2")).deleteIntegration);
$parcel$export(module.exports, "listOrgIntegrations", () => (parcelRequire("2hTF2")).listOrgIntegrations);
$parcel$export(module.exports, "addIntegrationFromMarketplace", () => (parcelRequire("2hTF2")).addIntegrationFromMarketplace);
$parcel$export(module.exports, "assignIntegrationScope", () => (parcelRequire("2hTF2")).assignIntegrationScope);
$parcel$export(module.exports, "reorderIntegrations", () => (parcelRequire("2hTF2")).reorderIntegrations);
$parcel$export(module.exports, "loadIntegrationUnits", () => (parcelRequire("2hTF2")).loadIntegrationUnits);
$parcel$export(module.exports, "loadOrgIntegrations", () => (parcelRequire("2hTF2")).loadOrgIntegrations);
$parcel$export(module.exports, "loadWorkspaceIntegrations", () => (parcelRequire("2hTF2")).loadWorkspaceIntegrations);
$parcel$export(module.exports, "loadProjectIntegrations", () => (parcelRequire("2hTF2")).loadProjectIntegrations);
$parcel$export(module.exports, "findIntegrationsByCapability", () => (parcelRequire("2hTF2")).findIntegrationsByCapability);
$parcel$export(module.exports, "listMarketplaceEntitlements", () => (parcelRequire("2hTF2")).listMarketplaceEntitlements);
$parcel$export(module.exports, "checkMarketplaceEntitlement", () => (parcelRequire("2hTF2")).checkMarketplaceEntitlement);
$parcel$export(module.exports, "installMarketplaceIntegration", () => (parcelRequire("2hTF2")).installMarketplaceIntegration);
$parcel$export(module.exports, "uninstallMarketplaceIntegration", () => (parcelRequire("2hTF2")).uninstallMarketplaceIntegration);
$parcel$export(module.exports, "createIframeApp", () => (parcelRequire("gyjjS")).createIframeApp);
$parcel$export(module.exports, "injectSprites", () => (parcelRequire("gyjjS")).injectSprites);
$parcel$export(module.exports, "embedComponent", () => (parcelRequire("ev6YB")).embedComponent);
$parcel$export(module.exports, "embedDesignSystem", () => (parcelRequire("bUsGn")).embedDesignSystem);
$parcel$export(module.exports, "mountUserCode", () => (parcelRequire("lLBGE")).mountUserCode);
$parcel$export(module.exports, "prewarmUserCode", () => (parcelRequire("lLBGE")).prewarmUserCode);
$parcel$export(module.exports, "getUserCodeHandle", () => (parcelRequire("lLBGE")).getUserCodeHandle);
$parcel$export(module.exports, "userCodeSandbox", () => (parcelRequire("lLBGE")).userCodeSandbox);
$parcel$export(module.exports, "findScopeKey", () => (parcelRequire("lLBGE")).findScopeKey);
$parcel$export(module.exports, "listConnectors", () => (parcelRequire("kwtE9")).listConnectors);
$parcel$export(module.exports, "installConnector", () => (parcelRequire("kwtE9")).installConnector);
$parcel$export(module.exports, "enableConnector", () => (parcelRequire("kwtE9")).enableConnector);
$parcel$export(module.exports, "disableConnector", () => (parcelRequire("kwtE9")).disableConnector);
$parcel$export(module.exports, "deleteConnector", () => (parcelRequire("kwtE9")).deleteConnector);
$parcel$export(module.exports, "discoverCapabilities", () => (parcelRequire("kwtE9")).discoverCapabilities);
$parcel$export(module.exports, "marketplaceCatalog", () => (parcelRequire("duVrF")).marketplaceCatalog);
$parcel$export(module.exports, "catalogSearchText", () => (parcelRequire("duVrF")).catalogSearchText);
$parcel$export(module.exports, "catalogSearchRank", () => (parcelRequire("co4gh")).catalogSearchRank);
$parcel$export(module.exports, "catalogSearchIncludes", () => (parcelRequire("co4gh")).catalogSearchIncludes);
$parcel$export(module.exports, "catalogSearchThreshold", () => (parcelRequire("co4gh")).catalogSearchThreshold);
$parcel$export(module.exports, "hydrateUserProfile", () => (parcelRequire("jn5Js")).hydrateUserProfile);
$parcel$export(module.exports, "isUserProfilePath", () => (parcelRequire("jn5Js")).isUserProfilePath);
$parcel$export(module.exports, "voiceStart", () => (parcelRequire("joPMm")).voiceStart);
$parcel$export(module.exports, "voiceStop", () => (parcelRequire("joPMm")).voiceStop);
$parcel$export(module.exports, "voiceToggle", () => (parcelRequire("joPMm")).voiceToggle);
$parcel$export(module.exports, "voiceSetMode", () => (parcelRequire("joPMm")).voiceSetMode);
$parcel$export(module.exports, "voiceExpand", () => (parcelRequire("joPMm")).voiceExpand);
$parcel$export(module.exports, "voiceMinimize", () => (parcelRequire("joPMm")).voiceMinimize);
$parcel$export(module.exports, "voiceFocusComposer", () => (parcelRequire("joPMm")).voiceFocusComposer);
$parcel$export(module.exports, "voiceCallFrame", () => (parcelRequire("joPMm")).voiceCallFrame);
$parcel$export(module.exports, "voicePttPress", () => (parcelRequire("joPMm")).voicePttPress);
$parcel$export(module.exports, "voicePttRelease", () => (parcelRequire("joPMm")).voicePttRelease);
$parcel$export(module.exports, "voicePttCancel", () => (parcelRequire("joPMm")).voicePttCancel);
$parcel$export(module.exports, "voiceCommitAndClose", () => (parcelRequire("joPMm")).voiceCommitAndClose);
$parcel$export(module.exports, "voiceOnStateChange", () => (parcelRequire("joPMm")).voiceOnStateChange);
$parcel$export(module.exports, "voiceTeardown", () => (parcelRequire("joPMm")).voiceTeardown);
$parcel$export(module.exports, "voiceStopSpeaking", () => (parcelRequire("joPMm")).voiceStopSpeaking);
$parcel$export(module.exports, "voiceEngineFallback", () => (parcelRequire("joPMm")).voiceEngineFallback);
$parcel$export(module.exports, "voiceMicToggle", () => (parcelRequire("joPMm")).voiceMicToggle);
$parcel$export(module.exports, "voiceAddTurn", () => (parcelRequire("joPMm")).voiceAddTurn);
$parcel$export(module.exports, "voiceRetry", () => (parcelRequire("joPMm")).voiceRetry);
$parcel$export(module.exports, "appendVoiceTurn", () => (parcelRequire("joPMm")).appendVoiceTurn);
$parcel$export(module.exports, "applyPublicBootLang", () => (parcelRequire("aNuMw")).applyPublicBootLang);
$parcel$export(module.exports, "settleWhitelabelBrand", () => (parcelRequire("aNuMw")).settleWhitelabelBrand);
// openModal/closeModal/closeAllModals/confirmDialog/alertDialog/promptDialog
// (@symbo.ls/windows) and openTooltip/closeTooltip (@symbo.ls/tooltip) are
// NOT re-exported here —
// the smbls runtime supplies them (prepareContext, smbls cedec5903); a bag
// re-export of an externalized specifier publishes as ""
// (WORKSPACE-SHELL-UNDECLARED-IMPORTS-1). The dropdown pair is the
// exception: `openDropdown` (the house defaults) and `closeDropdown` are
// real wrappers below, so every library that merges shared reaches ONE
// closeDropdown — the shell's bare plugin re-export published as "" and
// preview's same-named navbar reset collided with it.
// MODAL-X-OVERFLOW-1 — safe-default-maxHeight wrapper for
// `openModal({ template: 'custom' })` layers. See openCustomModal.js.

var $7Fon0 = parcelRequire("7Fon0");

var $kXwM5 = parcelRequire("kXwM5");

var $98BVX = parcelRequire("98BVX");

var $3H5Xg = parcelRequire("3H5Xg");

var $422uJ = parcelRequire("422uJ");

var $cAekN = parcelRequire("cAekN");

var $8ERrM = parcelRequire("8ERrM");

var $bW43f = parcelRequire("bW43f");

var $l32Xg = parcelRequire("l32Xg");

var $8SWNA = parcelRequire("8SWNA");

var $cL2Gr = parcelRequire("cL2Gr");

var $eviUK = parcelRequire("eviUK");

var $3jSgq = parcelRequire("3jSgq");

var $5e5Ez = parcelRequire("5e5Ez");

var $bwohf = parcelRequire("bwohf");

var $5qaoL = parcelRequire("5qaoL");

var $iWt3l = parcelRequire("iWt3l");

var $2Oceb = parcelRequire("2Oceb");

var $hbCVi = parcelRequire("hbCVi");

var $1ibbm = parcelRequire("1ibbm");

var $lgGcZ = parcelRequire("lgGcZ");

var $bgxQx = parcelRequire("bgxQx");

var $gEeRm = parcelRequire("gEeRm");

var $gt4uV = parcelRequire("gt4uV");

var $gT7Pk = parcelRequire("gT7Pk");

var $aty1O = parcelRequire("aty1O");

var $9qcV0 = parcelRequire("9qcV0");

var $cqSvZ = parcelRequire("cqSvZ");

var $9Nls3 = parcelRequire("9Nls3");

var $c7KfS = parcelRequire("c7KfS");

var $jl4gf = parcelRequire("jl4gf");

var $9qRgv = parcelRequire("9qRgv");

var $jnnl1 = parcelRequire("jnnl1");

var $3CWNx = parcelRequire("3CWNx");

var $le0yX = parcelRequire("le0yX");

var $lF4Ko = parcelRequire("lF4Ko");

var $5LAZU = parcelRequire("5LAZU");

var $jtbYB = parcelRequire("jtbYB");

var $edgad = parcelRequire("edgad");

var $8aizM = parcelRequire("8aizM");

var $44txC = parcelRequire("44txC");

var $eoJPD = parcelRequire("eoJPD");

var $glrHw = parcelRequire("glrHw");

var $1D39j = parcelRequire("1D39j");

var $ge15T = parcelRequire("ge15T");

var $fGay4 = parcelRequire("fGay4");

var $hrcPT = parcelRequire("hrcPT");

var $hSlMV = parcelRequire("hSlMV");

var $lM1GM = parcelRequire("lM1GM");

var $687hg = parcelRequire("687hg");

var $hpKFp = parcelRequire("hpKFp");

var $jhJrJ = parcelRequire("jhJrJ");

var $dot7l = parcelRequire("dot7l");

var $1Xpun = parcelRequire("1Xpun");

var $2zkc2 = parcelRequire("2zkc2");

var $jcoQe = parcelRequire("jcoQe");

var $eVQcI = parcelRequire("eVQcI");

var $lmB2G = parcelRequire("lmB2G");

var $8g9xF = parcelRequire("8g9xF");

var $1P3BE = parcelRequire("1P3BE");

var $h7bUm = parcelRequire("h7bUm");

var $eVGss = parcelRequire("eVGss");

var $euTsI = parcelRequire("euTsI");

var $kessp = parcelRequire("kessp");

var $928cN = parcelRequire("928cN");

var $grPR9 = parcelRequire("grPR9");

var $cQ06p = parcelRequire("cQ06p");

var $3JzjK = parcelRequire("3JzjK");

var $1k6V7 = parcelRequire("1k6V7");

var $hPqW2 = parcelRequire("hPqW2");

var $3xVCk = parcelRequire("3xVCk");

var $ez5lb = parcelRequire("ez5lb");

var $flGcp = parcelRequire("flGcp");

var $89exv = parcelRequire("89exv");

var $fpmKQ = parcelRequire("fpmKQ");

var $kkyxm = parcelRequire("kkyxm");

var $5Wuyg = parcelRequire("5Wuyg");

var $8R9ka = parcelRequire("8R9ka");

var $2Yh87 = parcelRequire("2Yh87");

var $5MRNC = parcelRequire("5MRNC");

var $5jv03 = parcelRequire("5jv03");

var $dvhZ1 = parcelRequire("dvhZ1");

var $kqx4y = parcelRequire("kqx4y");

var $j3ApK = parcelRequire("j3ApK");

var $cO4Du = parcelRequire("cO4Du");

var $bTIk3 = parcelRequire("bTIk3");

var $35Ta9 = parcelRequire("35Ta9");

var $fW7s5 = parcelRequire("fW7s5");

var $8ZCF3 = parcelRequire("8ZCF3");

var $b9FHP = parcelRequire("b9FHP");

var $ihnfM = parcelRequire("ihnfM");

var $3NC9D = parcelRequire("3NC9D");

var $duYxQ = parcelRequire("duYxQ");

var $8A4TU = parcelRequire("8A4TU");

var $ge9rC = parcelRequire("ge9rC");

var $gOFBH = parcelRequire("gOFBH");

var $fGnco = parcelRequire("fGnco");

var $6X4XN = parcelRequire("6X4XN");

var $eXsA7 = parcelRequire("eXsA7");

var $2olvW = parcelRequire("2olvW");

var $8hLkC = parcelRequire("8hLkC");

var $8c8Hz = parcelRequire("8c8Hz");

var $b05XF = parcelRequire("b05XF");

var $2s8AP = parcelRequire("2s8AP");

var $3IV5G = parcelRequire("3IV5G");

var $bUPew = parcelRequire("bUPew");

var $WuWK6 = parcelRequire("WuWK6");

var $7sAM5 = parcelRequire("7sAM5");

var $5AAY8 = parcelRequire("5AAY8");

var $cYOLJ = parcelRequire("cYOLJ");

var $buj0C = parcelRequire("buj0C");

var $eB1UF = parcelRequire("eB1UF");

var $7WebU = parcelRequire("7WebU");

var $1e8HI = parcelRequire("1e8HI");

var $4UuWq = parcelRequire("4UuWq");

var $15aON = parcelRequire("15aON");

var $1S5xC = parcelRequire("1S5xC");

var $e8rh4 = parcelRequire("e8rh4");

var $alaSg = parcelRequire("alaSg");

var $7ofJk = parcelRequire("7ofJk");

var $ijKP7 = parcelRequire("ijKP7");

var $1duun = parcelRequire("1duun");

var $7JjHI = parcelRequire("7JjHI");

var $1VIh3 = parcelRequire("1VIh3");

var $cRhmz = parcelRequire("cRhmz");

var $3wbNu = parcelRequire("3wbNu");

var $7llmN = parcelRequire("7llmN");

var $j7FZS = parcelRequire("j7FZS");

var $3nv81 = parcelRequire("3nv81");

var $9cSoa = parcelRequire("9cSoa");

var $4RUe0 = parcelRequire("4RUe0");

var $2oK39 = parcelRequire("2oK39");

var $k8EDy = parcelRequire("k8EDy");

var $6h2OJ = parcelRequire("6h2OJ");

var $cD3Av = parcelRequire("cD3Av");

var $eYIZl = parcelRequire("eYIZl");

var $bRqtF = parcelRequire("bRqtF");

var $bzQ3E = parcelRequire("bzQ3E");

var $cgtjK = parcelRequire("cgtjK");

var $fOdRG = parcelRequire("fOdRG");

var $kjygi = parcelRequire("kjygi");

var $lykMl = parcelRequire("lykMl");

var $kUTqn = parcelRequire("kUTqn");

var $aU444 = parcelRequire("aU444");

var $4xYPy = parcelRequire("4xYPy");

var $7hbEo = parcelRequire("7hbEo");

var $amN0s = parcelRequire("amN0s");

var $ipW4B = parcelRequire("ipW4B");

var $6cUG1 = parcelRequire("6cUG1");

var $k2xRl = parcelRequire("k2xRl");

var $51O3G = parcelRequire("51O3G");

var $9UTQi = parcelRequire("9UTQi");

var $rm3Ji = parcelRequire("rm3Ji");

var $7fShD = parcelRequire("7fShD");

var $9TBFw = parcelRequire("9TBFw");

var $de89x = parcelRequire("de89x");

var $8NTf1 = parcelRequire("8NTf1");

var $cvFPD = parcelRequire("cvFPD");

var $UyBCS = parcelRequire("UyBCS");

var $1axdt = parcelRequire("1axdt");

var $drkt6 = parcelRequire("drkt6");

var $j7gGM = parcelRequire("j7gGM");

var $aR6hx = parcelRequire("aR6hx");

var $kHrku = parcelRequire("kHrku");

var $1ty3Y = parcelRequire("1ty3Y");

var $dfJUb = parcelRequire("dfJUb");

var $3cqmC = parcelRequire("3cqmC");

var $50gPy = parcelRequire("50gPy");

var $8k31d = parcelRequire("8k31d");

var $f0yEX = parcelRequire("f0yEX");

var $7hnoP = parcelRequire("7hnoP");

var $lO82q = parcelRequire("lO82q");

var $6zKVW = parcelRequire("6zKVW");

var $drrN1 = parcelRequire("drrN1");

var $8YjBp = parcelRequire("8YjBp");

var $g6SPq = parcelRequire("g6SPq");

var $9XFqh = parcelRequire("9XFqh");

var $AxJRF = parcelRequire("AxJRF");

var $7UbLZ = parcelRequire("7UbLZ");

var $2zRqK = parcelRequire("2zRqK");

var $b1lQC = parcelRequire("b1lQC");

var $2hTF2 = parcelRequire("2hTF2");
parcelRequire("8aWPx");
var $gyjjS = parcelRequire("gyjjS");
var $ev6YB = parcelRequire("ev6YB");
var $bUsGn = parcelRequire("bUsGn");
var $lLBGE = parcelRequire("lLBGE");

var $kwtE9 = parcelRequire("kwtE9");

var $duVrF = parcelRequire("duVrF");

var $co4gh = parcelRequire("co4gh");

var $jn5Js = parcelRequire("jn5Js");

var $joPMm = parcelRequire("joPMm");

var $5PkPu = parcelRequire("5PkPu");

var $9IIym = parcelRequire("9IIym");

var $m13h3 = parcelRequire("m13h3");

var $kANrO = parcelRequire("kANrO");

var $2d1Zl = parcelRequire("2d1Zl");

var $6JQYC = parcelRequire("6JQYC");

var $541DJ = parcelRequire("541DJ");

var $guNGz = parcelRequire("guNGz");

var $kBsR3 = parcelRequire("kBsR3");

var $65dfg = parcelRequire("65dfg");

var $92gMy = parcelRequire("92gMy");

var $gDbv0 = parcelRequire("gDbv0");

var $6CwS3 = parcelRequire("6CwS3");

var $MSYnq = parcelRequire("MSYnq");

var $1sP0S = parcelRequire("1sP0S");

var $fR7qV = parcelRequire("fR7qV");

var $jlzPZ = parcelRequire("jlzPZ");

var $fnRiS = parcelRequire("fnRiS");

var $frXJg = parcelRequire("frXJg");

var $2N9Vv = parcelRequire("2N9Vv");

var $cnoxk = parcelRequire("cnoxk");

var $6RzDA = parcelRequire("6RzDA");

var $iA4IC = parcelRequire("iA4IC");

var $4SiPM = parcelRequire("4SiPM");

var $cQy7L = parcelRequire("cQy7L");

var $3BQmv = parcelRequire("3BQmv");

var $jXr1P = parcelRequire("jXr1P");

var $hGAnX = parcelRequire("hGAnX");

var $5Wa4N = parcelRequire("5Wa4N");

var $e2Fqo = parcelRequire("e2Fqo");

var $fCegb = parcelRequire("fCegb");

var $gGHbJ = parcelRequire("gGHbJ");

var $hHiFC = parcelRequire("hHiFC");

var $9UpD3 = parcelRequire("9UpD3");

var $7Ybqe = parcelRequire("7Ybqe");

var $eHqP0 = parcelRequire("eHqP0");

var $63tJn = parcelRequire("63tJn");

var $i6RWv = parcelRequire("i6RWv");

var $fDBlu = parcelRequire("fDBlu");

var $iXsus = parcelRequire("iXsus");

var $kfa5L = parcelRequire("kfa5L");

var $9Psdu = parcelRequire("9Psdu");

var $76fm2 = parcelRequire("76fm2");

var $klqGv = parcelRequire("klqGv");

var $2UHAL = parcelRequire("2UHAL");

var $cKIiY = parcelRequire("cKIiY");

var $1G1eN = parcelRequire("1G1eN");

var $RhMOd = parcelRequire("RhMOd");

var $e3DJf = parcelRequire("e3DJf");

var $aFPBz = parcelRequire("aFPBz");

var $lUr30 = parcelRequire("lUr30");

var $kg2OA = parcelRequire("kg2OA");

var $7hR4u = parcelRequire("7hR4u");

var $eEiQY = parcelRequire("eEiQY");

var $h1nln = parcelRequire("h1nln");

var $e0RDd = parcelRequire("e0RDd");

var $66IRm = parcelRequire("66IRm");

var $53J05 = parcelRequire("53J05");

var $1zcOx = parcelRequire("1zcOx");

var $789Y4 = parcelRequire("789Y4");

var $3gQso = parcelRequire("3gQso");

var $dEMgh = parcelRequire("dEMgh");

var $1gOQB = parcelRequire("1gOQB");

var $29wU0 = parcelRequire("29wU0");

var $yREI6 = parcelRequire("yREI6");

var $dMFBu = parcelRequire("dMFBu");

var $9juhh = parcelRequire("9juhh");

var $FZkPK = parcelRequire("FZkPK");

var $g3Ned = parcelRequire("g3Ned");

var $jH1GV = parcelRequire("jH1GV");

var $cRTCE = parcelRequire("cRTCE");

var $8tcVD = parcelRequire("8tcVD");

var $5kIsd = parcelRequire("5kIsd");

var $hZBHz = parcelRequire("hZBHz");

var $1guEp = parcelRequire("1guEp");

var $9YPeu = parcelRequire("9YPeu");

var $aNuMw = parcelRequire("aNuMw");

var $bWtfD = parcelRequire("bWtfD");
function $c029ff611100fe38$export$7b15a90e43f21cea(opts) {
    if (!opts || typeof opts !== 'object') return $kXwM5.openDropdown.call(this, opts);
    const o = {
        ...opts
    };
    if (o.theme && o.shadow === undefined) o.shadow = 'overlay';
    let overDialog = false;
    const anchor = o.anchorEl && typeof o.anchorEl === 'object' && 'parent' in o.anchorEl ? o.anchorEl : null;
    for(let p = anchor, depth = 0; p && depth < 256; p = p.parent, depth++)if (p.role === 'dialog') {
        overDialog = true;
        break;
    }
    if (overDialog && (!o.theme || o.theme === 'dialog')) {
        if (o.theme && o.background === undefined) o.background = 'raised';
        const c = o.content;
        if (c && typeof c === 'object' && c.background === undefined) {
            const components = this && this.context && this.context.components || {};
            const base = typeof c.extends === 'string' ? components[c.extends] : null;
            const bodyTheme = c.theme !== undefined ? c.theme : base && base.theme;
            if (!bodyTheme || bodyTheme === 'dialog') o.content = {
                ...c,
                background: 'raised'
            };
        }
    }
    // 3. THE ROOT MIRROR (design-d2, 2026-10-01): the open layer's id on the
    // root (`_dropdownLayer`), set by the layer's own onOpen and cleared by its
    // onClose — the plugin fires both on every open, replace and close. A
    // surface below a menu reads it reactively (the composer's focus panel,
    // _simone/Suggestions.js, stops painting under a menu). The caller's own
    // onOpen / onClose still run.
    const rootState = this && this.state && this.state.root || this && typeof this.getRoot === 'function' && this.getRoot() && this.getRoot().state || null;
    if (rootState && typeof rootState.update === 'function') {
        const ownOpen = o.onOpen;
        const ownClose = o.onClose;
        const mark = o.id || true;
        o.onOpen = (layer)=>{
            rootState.update({
                _dropdownLayer: mark
            }, {
                preventFetch: true
            });
            if (typeof ownOpen === 'function') return ownOpen(layer);
        };
        o.onClose = (layer)=>{
            if (rootState._dropdownLayer === mark) rootState.update({
                _dropdownLayer: null
            }, {
                preventFetch: true
            });
            if (typeof ownClose === 'function') return ownClose(layer);
        };
    }
    return $kXwM5.openDropdown.call(this, o);
}
function $c029ff611100fe38$export$9772d2b5987ea925(...args) {
    return $kXwM5.closeDropdown.apply(this, args);
}
function $c029ff611100fe38$export$bb72042877e61007(...args) {
    const key = [
        'set',
        'Dropdown',
        'Inert'
    ].join('');
    const fn = $kXwM5[key];
    if (typeof fn !== 'function') return;
    return fn.apply(this, args);
}
$parcel$exportWildcard(module.exports, $7Fon0);
$parcel$exportWildcard(module.exports, $98BVX);
$parcel$exportWildcard(module.exports, $3H5Xg);
$parcel$exportWildcard(module.exports, $422uJ);
$parcel$exportWildcard(module.exports, $cAekN);
$parcel$exportWildcard(module.exports, $8ERrM);
$parcel$exportWildcard(module.exports, $bW43f);
$parcel$exportWildcard(module.exports, $l32Xg);
$parcel$exportWildcard(module.exports, $8SWNA);
$parcel$exportWildcard(module.exports, $cL2Gr);
$parcel$exportWildcard(module.exports, $eviUK);
$parcel$exportWildcard(module.exports, $3jSgq);
$parcel$exportWildcard(module.exports, $5e5Ez);
$parcel$exportWildcard(module.exports, $bwohf);
$parcel$exportWildcard(module.exports, $iWt3l);
$parcel$exportWildcard(module.exports, $2Oceb);
$parcel$exportWildcard(module.exports, $hbCVi);
$parcel$exportWildcard(module.exports, $1ibbm);
$parcel$exportWildcard(module.exports, $lgGcZ);
$parcel$exportWildcard(module.exports, $bgxQx);
$parcel$exportWildcard(module.exports, $gEeRm);
$parcel$exportWildcard(module.exports, $gt4uV);
$parcel$exportWildcard(module.exports, $gT7Pk);
$parcel$exportWildcard(module.exports, $aty1O);
$parcel$exportWildcard(module.exports, $9qcV0);
$parcel$exportWildcard(module.exports, $cqSvZ);
$parcel$exportWildcard(module.exports, $9Nls3);
$parcel$exportWildcard(module.exports, $c7KfS);
$parcel$exportWildcard(module.exports, $jl4gf);
$parcel$exportWildcard(module.exports, $9qRgv);
$parcel$exportWildcard(module.exports, $jnnl1);
$parcel$exportWildcard(module.exports, $3CWNx);
$parcel$exportWildcard(module.exports, $le0yX);
$parcel$exportWildcard(module.exports, $lF4Ko);
$parcel$exportWildcard(module.exports, $5LAZU);
$parcel$exportWildcard(module.exports, $jtbYB);
$parcel$exportWildcard(module.exports, $edgad);
$parcel$exportWildcard(module.exports, $8aizM);
$parcel$exportWildcard(module.exports, $44txC);
$parcel$exportWildcard(module.exports, $eoJPD);
$parcel$exportWildcard(module.exports, $glrHw);
$parcel$exportWildcard(module.exports, $1D39j);
$parcel$exportWildcard(module.exports, $ge15T);
$parcel$exportWildcard(module.exports, $fGay4);
$parcel$exportWildcard(module.exports, $hrcPT);
$parcel$exportWildcard(module.exports, $hSlMV);
$parcel$exportWildcard(module.exports, $lM1GM);
$parcel$exportWildcard(module.exports, $687hg);
$parcel$exportWildcard(module.exports, $hpKFp);
$parcel$exportWildcard(module.exports, $jhJrJ);
$parcel$exportWildcard(module.exports, $dot7l);
$parcel$exportWildcard(module.exports, $1Xpun);
$parcel$exportWildcard(module.exports, $2zkc2);
$parcel$exportWildcard(module.exports, $jcoQe);
$parcel$exportWildcard(module.exports, $eVQcI);
$parcel$exportWildcard(module.exports, $lmB2G);
$parcel$exportWildcard(module.exports, $8g9xF);
$parcel$exportWildcard(module.exports, $1P3BE);
$parcel$exportWildcard(module.exports, $h7bUm);
$parcel$exportWildcard(module.exports, $eVGss);
$parcel$exportWildcard(module.exports, $euTsI);
$parcel$exportWildcard(module.exports, $kessp);
$parcel$exportWildcard(module.exports, $928cN);
$parcel$exportWildcard(module.exports, $grPR9);
$parcel$exportWildcard(module.exports, $cQ06p);
$parcel$exportWildcard(module.exports, $1k6V7);
$parcel$exportWildcard(module.exports, $hPqW2);
$parcel$exportWildcard(module.exports, $3xVCk);
$parcel$exportWildcard(module.exports, $ez5lb);
$parcel$exportWildcard(module.exports, $flGcp);
$parcel$exportWildcard(module.exports, $89exv);
$parcel$exportWildcard(module.exports, $fpmKQ);
$parcel$exportWildcard(module.exports, $kkyxm);
$parcel$exportWildcard(module.exports, $5Wuyg);
$parcel$exportWildcard(module.exports, $8R9ka);
$parcel$exportWildcard(module.exports, $2Yh87);
$parcel$exportWildcard(module.exports, $5MRNC);
$parcel$exportWildcard(module.exports, $5jv03);
$parcel$exportWildcard(module.exports, $dvhZ1);
$parcel$exportWildcard(module.exports, $kqx4y);
$parcel$exportWildcard(module.exports, $j3ApK);
$parcel$exportWildcard(module.exports, $cO4Du);
$parcel$exportWildcard(module.exports, $bTIk3);
$parcel$exportWildcard(module.exports, $35Ta9);
$parcel$exportWildcard(module.exports, $fW7s5);
$parcel$exportWildcard(module.exports, $8ZCF3);
$parcel$exportWildcard(module.exports, $b9FHP);
$parcel$exportWildcard(module.exports, $ihnfM);
$parcel$exportWildcard(module.exports, $3NC9D);
$parcel$exportWildcard(module.exports, $duYxQ);
$parcel$exportWildcard(module.exports, $8A4TU);
$parcel$exportWildcard(module.exports, $ge9rC);
$parcel$exportWildcard(module.exports, $gOFBH);
$parcel$exportWildcard(module.exports, $fGnco);
$parcel$exportWildcard(module.exports, $6X4XN);
$parcel$exportWildcard(module.exports, $eXsA7);
$parcel$exportWildcard(module.exports, $2olvW);
$parcel$exportWildcard(module.exports, $8hLkC);
$parcel$exportWildcard(module.exports, $8c8Hz);
$parcel$exportWildcard(module.exports, $b05XF);
$parcel$exportWildcard(module.exports, $2s8AP);
$parcel$exportWildcard(module.exports, $3IV5G);
$parcel$exportWildcard(module.exports, $bUPew);
$parcel$exportWildcard(module.exports, $WuWK6);
$parcel$exportWildcard(module.exports, $7sAM5);
$parcel$exportWildcard(module.exports, $5AAY8);
$parcel$exportWildcard(module.exports, $cYOLJ);
$parcel$exportWildcard(module.exports, $buj0C);
$parcel$exportWildcard(module.exports, $eB1UF);
$parcel$exportWildcard(module.exports, $7WebU);
$parcel$exportWildcard(module.exports, $1e8HI);
$parcel$exportWildcard(module.exports, $4UuWq);
$parcel$exportWildcard(module.exports, $15aON);
$parcel$exportWildcard(module.exports, $1S5xC);
$parcel$exportWildcard(module.exports, $e8rh4);
$parcel$exportWildcard(module.exports, $alaSg);
$parcel$exportWildcard(module.exports, $7ofJk);
$parcel$exportWildcard(module.exports, $ijKP7);
$parcel$exportWildcard(module.exports, $1duun);
$parcel$exportWildcard(module.exports, $7JjHI);
$parcel$exportWildcard(module.exports, $1VIh3);
$parcel$exportWildcard(module.exports, $cRhmz);
$parcel$exportWildcard(module.exports, $3wbNu);
$parcel$exportWildcard(module.exports, $7llmN);
$parcel$exportWildcard(module.exports, $j7FZS);
$parcel$exportWildcard(module.exports, $3nv81);
$parcel$exportWildcard(module.exports, $9cSoa);
$parcel$exportWildcard(module.exports, $4RUe0);
$parcel$exportWildcard(module.exports, $2oK39);
$parcel$exportWildcard(module.exports, $k8EDy);
$parcel$exportWildcard(module.exports, $6h2OJ);
$parcel$exportWildcard(module.exports, $cD3Av);
$parcel$exportWildcard(module.exports, $eYIZl);
$parcel$exportWildcard(module.exports, $bRqtF);
$parcel$exportWildcard(module.exports, $bzQ3E);
$parcel$exportWildcard(module.exports, $cgtjK);
$parcel$exportWildcard(module.exports, $fOdRG);
$parcel$exportWildcard(module.exports, $kjygi);
$parcel$exportWildcard(module.exports, $lykMl);
$parcel$exportWildcard(module.exports, $kUTqn);
$parcel$exportWildcard(module.exports, $aU444);
$parcel$exportWildcard(module.exports, $4xYPy);
$parcel$exportWildcard(module.exports, $7hbEo);
$parcel$exportWildcard(module.exports, $amN0s);
$parcel$exportWildcard(module.exports, $ipW4B);
$parcel$exportWildcard(module.exports, $6cUG1);
$parcel$exportWildcard(module.exports, $k2xRl);
$parcel$exportWildcard(module.exports, $51O3G);
$parcel$exportWildcard(module.exports, $9UTQi);
$parcel$exportWildcard(module.exports, $aR6hx);
$parcel$exportWildcard(module.exports, $5PkPu);
$parcel$exportWildcard(module.exports, $9IIym);
$parcel$exportWildcard(module.exports, $m13h3);
$parcel$exportWildcard(module.exports, $kANrO);
$parcel$exportWildcard(module.exports, $2d1Zl);
$parcel$exportWildcard(module.exports, $6JQYC);
$parcel$exportWildcard(module.exports, $541DJ);
$parcel$exportWildcard(module.exports, $guNGz);
$parcel$exportWildcard(module.exports, $kBsR3);
$parcel$exportWildcard(module.exports, $65dfg);
$parcel$exportWildcard(module.exports, $92gMy);
$parcel$exportWildcard(module.exports, $gDbv0);
$parcel$exportWildcard(module.exports, $6CwS3);
$parcel$exportWildcard(module.exports, $MSYnq);
$parcel$exportWildcard(module.exports, $1sP0S);
$parcel$exportWildcard(module.exports, $fR7qV);
$parcel$exportWildcard(module.exports, $jlzPZ);
$parcel$exportWildcard(module.exports, $fnRiS);
$parcel$exportWildcard(module.exports, $frXJg);
$parcel$exportWildcard(module.exports, $2N9Vv);
$parcel$exportWildcard(module.exports, $cnoxk);
$parcel$exportWildcard(module.exports, $6RzDA);
$parcel$exportWildcard(module.exports, $iA4IC);
$parcel$exportWildcard(module.exports, $4SiPM);
$parcel$exportWildcard(module.exports, $cQy7L);
$parcel$exportWildcard(module.exports, $3BQmv);
$parcel$exportWildcard(module.exports, $jXr1P);
$parcel$exportWildcard(module.exports, $hGAnX);
$parcel$exportWildcard(module.exports, $5Wa4N);
$parcel$exportWildcard(module.exports, $e2Fqo);
$parcel$exportWildcard(module.exports, $fCegb);
$parcel$exportWildcard(module.exports, $gGHbJ);
$parcel$exportWildcard(module.exports, $hHiFC);
$parcel$exportWildcard(module.exports, $9UpD3);
$parcel$exportWildcard(module.exports, $7Ybqe);
$parcel$exportWildcard(module.exports, $eHqP0);
$parcel$exportWildcard(module.exports, $63tJn);
$parcel$exportWildcard(module.exports, $i6RWv);
$parcel$exportWildcard(module.exports, $fDBlu);
$parcel$exportWildcard(module.exports, $iXsus);
$parcel$exportWildcard(module.exports, $kfa5L);
$parcel$exportWildcard(module.exports, $9Psdu);
$parcel$exportWildcard(module.exports, $76fm2);
$parcel$exportWildcard(module.exports, $klqGv);
$parcel$exportWildcard(module.exports, $2UHAL);
$parcel$exportWildcard(module.exports, $cKIiY);
$parcel$exportWildcard(module.exports, $1G1eN);
$parcel$exportWildcard(module.exports, $RhMOd);
$parcel$exportWildcard(module.exports, $e3DJf);
$parcel$exportWildcard(module.exports, $aFPBz);
$parcel$exportWildcard(module.exports, $lUr30);
$parcel$exportWildcard(module.exports, $kg2OA);
$parcel$exportWildcard(module.exports, $7hR4u);
$parcel$exportWildcard(module.exports, $eEiQY);
$parcel$exportWildcard(module.exports, $h1nln);
$parcel$exportWildcard(module.exports, $e0RDd);
$parcel$exportWildcard(module.exports, $66IRm);
$parcel$exportWildcard(module.exports, $53J05);
$parcel$exportWildcard(module.exports, $1zcOx);
$parcel$exportWildcard(module.exports, $789Y4);
$parcel$exportWildcard(module.exports, $3gQso);
$parcel$exportWildcard(module.exports, $dEMgh);
$parcel$exportWildcard(module.exports, $1gOQB);
$parcel$exportWildcard(module.exports, $29wU0);
$parcel$exportWildcard(module.exports, $yREI6);
$parcel$exportWildcard(module.exports, $dMFBu);
$parcel$exportWildcard(module.exports, $9juhh);
$parcel$exportWildcard(module.exports, $FZkPK);
$parcel$exportWildcard(module.exports, $g3Ned);
$parcel$exportWildcard(module.exports, $jH1GV);
$parcel$exportWildcard(module.exports, $cRTCE);
$parcel$exportWildcard(module.exports, $8tcVD);
$parcel$exportWildcard(module.exports, $5kIsd);
$parcel$exportWildcard(module.exports, $hZBHz);
$parcel$exportWildcard(module.exports, $1guEp);
$parcel$exportWildcard(module.exports, $9YPeu);
$parcel$exportWildcard(module.exports, $bWtfD);

});
parcelRegister("7Fon0", function(module, exports) {

$parcel$export(module.exports, "openCustomModal", () => $594f44228faa0dec$export$995a4fe1fa7ae768);
// Shared wrapper around `el.call('openModal', { template: 'custom', ... })`
// — MODAL-X-OVERFLOW-1 root-layer fix.
//
// @symbo.ls/windows' ModalLayer.js deliberately sets `overflow: 'visible'`
// on the outer ModalWindow chrome and defaults `maxHeight` to `null` when a
// custom-template layer's own descriptor doesn't supply one (2026-06-03 —
// avoids the rounded-corner clip eating the Close X on `overflow: 'auto'`).
// The trade-off: every custom-template modal that skips `maxHeight` on its
// own `openModal` call has NO outer scroll containment. On a short viewport
// (or with unusually tall body content) the centered backdrop box overflows
// equally top and bottom, and the body's `ModalHeader` — with the Close X —
// is the first thing pushed off-screen. That reads as "the modal lost its
// close button", even though CloseButton itself renders correctly.
//
// `openCustomModal` supplies a safe default `maxHeight` so callers get
// correct outer containment for free; pass your own `maxHeight` to override
// per call (a few modals genuinely need more/less room). This only fixes
// the OUTER ceiling — the BODY component still needs its own scrollable
// region inside that ceiling (`flex: '1', minHeight: '0', overflow: 'auto'`
// on the content block that should scroll, with ModalHeader / a footer
// Actions row left OUTSIDE it so they stay pinned — see
// `chat/components/ChannelSettingsModal.js`'s Header/Content/Footer split,
// or `workspace/components/AppCreateOrgModal.js`'s Header/Fields/Actions
// split, for the canonical shape).
function $594f44228faa0dec$export$995a4fe1fa7ae768(opts = {}) {
    return this.call('openModal', {
        maxHeight: '90dvh',
        ...opts,
        template: 'custom'
    });
}

});

parcelRegister("kXwM5", function(module, exports) {

var $cEpNz = parcelRequire("cEpNz");

var $eKLwk = parcelRequire("eKLwk");
$parcel$exportWildcard(module.exports, $cEpNz);
$parcel$exportWildcard(module.exports, $eKLwk);

});
parcelRegister("cEpNz", function(module, exports) {

$parcel$export(module.exports, "dropdownComponents", () => $935d3b83218c1b57$export$906ef91b4237551a);
$parcel$export(module.exports, "Dropdown", () => (parcelRequire("b1KVm")).Dropdown);
$parcel$export(module.exports, "DropdownList", () => (parcelRequire("b1KVm")).DropdownList);
$parcel$export(module.exports, "DropdownParent", () => (parcelRequire("b1KVm")).DropdownParent);
$parcel$export(module.exports, "DropdownParentFocus", () => (parcelRequire("b1KVm")).DropdownParentFocus);
$parcel$export(module.exports, "DropdownRoot", () => (parcelRequire("4kTba")).DropdownRoot);
$parcel$export(module.exports, "DropdownSiblingFocus", () => (parcelRequire("b1KVm")).DropdownSiblingFocus);
$parcel$export(module.exports, "DropdownTrigger", () => (parcelRequire("afwpn")).DropdownTrigger);

var $4kTba = parcelRequire("4kTba");

var $afwpn = parcelRequire("afwpn");

var $b1KVm = parcelRequire("b1KVm");
const $935d3b83218c1b57$export$906ef91b4237551a = {
    DropdownRoot: (0, $4kTba.DropdownRoot),
    DropdownTrigger: (0, $afwpn.DropdownTrigger),
    Dropdown: (0, $b1KVm.Dropdown),
    DropdownList: (0, $b1KVm.DropdownList),
    DropdownParent: (0, $b1KVm.DropdownParent),
    DropdownParentFocus: (0, $b1KVm.DropdownParentFocus),
    DropdownSiblingFocus: (0, $b1KVm.DropdownSiblingFocus)
};

});
parcelRegister("4kTba", function(module, exports) {

$parcel$export(module.exports, "DropdownRoot", () => $3283d51e0d52f3f0$export$a07767dbf4087719);

var $eY4Ct = parcelRequire("eY4Ct");

var $f39o3 = parcelRequire("f39o3");

var $giSd8 = parcelRequire("giSd8");
const $3283d51e0d52f3f0$var$c = (e, t)=>{
    const n = `${t.maxHeight}px`;
    return e?.maxHeight ? `min(${e.maxHeight}, ${n})` : n;
}, $3283d51e0d52f3f0$var$u = (e)=>{
    const t = e.getBoundingClientRect(), n = e.offsetWidth || t.width, o = Math.max(e.offsetHeight || t.height, e.scrollHeight || 0);
    return {
        width: n,
        height: o
    };
}, $3283d51e0d52f3f0$var$y = `
@keyframes smbls-dropdown-fade-in {
  from { opacity: 0; transform: var(--smbls-dropdown-from, translateY(-6px)) scale(0.98); }
  to   { opacity: 1; transform: translate3d(0, 0, 0) scale(1); }
}
[data-smbls-dropdown="panel"][data-smbls-open="true"] {
  /* The one place the keyframe is declared \u2014 name and fill only. Duration
     and curve are the design system's motion tokens, carried by the Panel's
     own animationDuration ('B') and animationTimingFunction
     ('defaultBezier') props as atomic classes; an animation shorthand here
     would reset both. The content-mount effect owns the data-smbls-open
     flag and toggles it off and on to restart the keyframe per layer
     (FW-DROPDOWN-ROOT-OVERLAY-DEFAULTS-ROLE-FOCUS-1).

     The fill is backwards, never forwards: the keyframe ends on the Panel's
     own open style (opacity 1, no transform), so nothing needs holding. A
     forwards fill keeps the Panel under an opacity animation for its whole
     open life, and that makes it a BACKDROP ROOT: a backdrop-filter on the
     dropdown body then samples the Panel's own empty surface and the page
     behind is never blurred (__tests__/dropdownPanelBackdropRoot.test.js).
     During the fade itself the Panel is still one \u2014 that is what a group
     opacity is; the blur arrives when the fade ends. */
  animation-name: smbls-dropdown-fade-in;
  animation-fill-mode: backwards;
  transform-origin: top center;
}
@media (prefers-reduced-motion: reduce) {
  [data-smbls-dropdown="panel"] {
    animation: none !important;
  }
}
[data-smbls-dropdown="panel"][data-smbls-surface] {
  background: var(--smbls-dropdown-surface) !important;
}
[data-smbls-dropdown="panel"] {
  /* The panel is a pure positioning shell \u2014 menu BODIES own their card
     chrome (padding/round/border via e.g. CanvasCreateMenuBody), so the
     panel itself stays chromeless. !important for the same reason as the
     surface rule above: the theme prop re-emits border longhands inline
     on every re-render and would beat any declarative zero
     (2026-06-10 per Nika "remove Panel border and padding"). */
  border-width: 0 !important;
  padding: 0 !important;
}
[data-smbls-dropdown="panel"]:not([data-smbls-themed]):not([data-smbls-surface]) {
  /* Chromeless guarantee for the REUSED panel node: css-in-props'
     reactive effect applies styles only when its resolver returns a
     result (element/src/create.js "if (cssResult && element.node)") \u2014
     it never CLEARS, so a previously themed layer's inline
     background/color/box-shadow would survive into the next unthemed
     layer. _applyChrome flags opt-in chrome with data-smbls-themed /
     data-smbls-shadowed; these :not() rules neutralise the stale paint
     channels for everyone else. Background keeps :not([data-smbls-surface])
     so the caller surface-override rule above still wins on ties. */
  background: transparent !important;
}
[data-smbls-dropdown="panel"]:not([data-smbls-themed]) {
  color: inherit !important;
  /* A glass theme's backdrop-filter is a paint channel like the two above.
     Left on an unthemed layer it blurs the page behind a body that asked for
     no blur, and it makes the Panel a backdrop root for that body. */
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}
[data-smbls-dropdown="panel"]:not([data-smbls-shadowed]) {
  box-shadow: none !important;
}
`, $3283d51e0d52f3f0$var$w = ()=>{
    if (typeof document > "u" || document.getElementById("smbls-dropdown-css")) return;
    const e = document.createElement("style");
    e.id = "smbls-dropdown-css", e.textContent = $3283d51e0d52f3f0$var$y, document.head.appendChild(e);
}, $3283d51e0d52f3f0$var$f = (e, t)=>{
    if (!e.node) return;
    const n = t?.background;
    if (!n) e.node.removeAttribute("data-smbls-surface");
    else {
        const o = /^[a-z][\w.+-]*$/i.test(n) ? `var(--color-${n})` : n;
        e.node.style.setProperty("--smbls-dropdown-surface", o), e.node.setAttribute("data-smbls-surface", "");
    }
    t?.theme ? e.node.setAttribute("data-smbls-themed", "") : e.node.removeAttribute("data-smbls-themed"), t?.shadow || e.scope?.bodyShadow ? e.node.setAttribute("data-smbls-shadowed", "") : e.node.removeAttribute("data-smbls-shadowed");
}, $3283d51e0d52f3f0$var$_ = (e)=>{
    if (!e) return null;
    const t = typeof e.shadow == "function" ? e.shadow(e, e.state) : e.shadow;
    return typeof t == "string" && t ? t : null;
}, $3283d51e0d52f3f0$var$g = (e)=>{
    e.node && (e.node.removeAttribute("data-smbls-open"), e.node.offsetWidth, e.node.setAttribute("data-smbls-open", "true"));
}, $3283d51e0d52f3f0$var$v = [
    [
        "role",
        "role"
    ],
    [
        "aria-label",
        "ariaLabel"
    ],
    [
        "aria-labelledby",
        "ariaLabelledby"
    ]
], $3283d51e0d52f3f0$var$h = (e, t)=>{
    if (!e.node) return;
    const n = new Set;
    for (const [o, r] of $3283d51e0d52f3f0$var$v){
        const a = t?.[r];
        a && (e.node.setAttribute(o, a), n.add(o));
    }
    if (e.__a11yAttrs) for (const o of e.__a11yAttrs)n.has(o) || e.node.removeAttribute(o);
    e.__a11yAttrs = n, e.__panelTabindex && (e.node.removeAttribute("tabindex"), e.__panelTabindex = !1);
}, $3283d51e0d52f3f0$var$x = 'a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex], [contenteditable]:not([contenteditable="false"])', $3283d51e0d52f3f0$var$k = (e)=>{
    const t = e.node;
    if (t) {
        for (const n of t.querySelectorAll($3283d51e0d52f3f0$var$x)){
            if (n.matches(":disabled")) continue;
            const o = n.getAttribute("tabindex");
            if (!(o !== null && parseInt(o, 10) < 0) && (n.focus({
                preventScroll: !0
            }), t.ownerDocument.activeElement === n)) return;
        }
        t.setAttribute("tabindex", "-1"), e.__panelTabindex = !0, t.focus({
            preventScroll: !0
        });
    }
}, $3283d51e0d52f3f0$export$a07767dbf4087719 = {
    tag: "div",
    attr: {
        "data-smbls-dropdown-root": "true"
    },
    position: "fixed",
    inset: "0",
    zIndex: "1500",
    pointerEvents: "none",
    state: {
        layer: null
    },
    onInit: (e)=>{
        if ($3283d51e0d52f3f0$var$w(), typeof window > "u") return;
        const t = (o)=>{
            o.key !== "Escape" || o.defaultPrevented || e.state?.layer && (o.preventDefault(), (0, $giSd8.closeDropdown).call(e));
        };
        window.addEventListener("keydown", t), e.__dropdownEscHandler = t;
        const n = (o)=>{
            const r = e.state?.layer;
            if (!r) return;
            const a = e.node?.querySelector('[data-smbls-dropdown="panel"]');
            if (a && a.contains(o.target)) return;
            const s = r.anchor;
            if (s) {
                const d = o.clientX, p = o.clientY;
                if (d >= s.left && d <= s.right && p >= s.top && p <= s.bottom) return;
            }
            (0, $giSd8.closeDropdown).call(e);
        };
        document.addEventListener("mousedown", n, !0), e.__dropdownClickHandler = n;
    },
    onRemove: (e)=>{
        typeof window > "u" || (e.__dropdownEscHandler && window.removeEventListener("keydown", e.__dropdownEscHandler), e.__dropdownClickHandler && document.removeEventListener("mousedown", e.__dropdownClickHandler, !0));
    },
    PanelHost: {
        tag: "div",
        position: "fixed",
        inset: "0",
        pointerEvents: "none",
        subscribeTo: [
            "layer"
        ],
        layer: (e, t)=>t?.layer || null,
        Panel: {
            tag: "div",
            attr: {
                "data-smbls-dropdown": "panel"
            },
            position: "fixed",
            subscribeTo: [
                "layer"
            ],
            left: (e)=>{
                const t = e.parent?.layer;
                if (!t?.anchor) return "-9999px";
                const n = e._lastSize || {
                    width: 280,
                    height: 200
                };
                return (0, $f39o3.computePosition)(t.anchor, n, t.placement).left + "px";
            },
            top: (e)=>{
                const t = e.parent?.layer;
                if (!t?.anchor) return "-9999px";
                const n = e._lastSize || {
                    width: 280,
                    height: 200
                };
                return (0, $f39o3.computePosition)(t.anchor, n, t.placement).top + "px";
            },
            style: (e)=>{
                const t = e.parent?.layer;
                if (!t?.anchor) return {};
                const n = e._lastSize || {
                    width: 280,
                    height: 200
                };
                return {
                    "--smbls-dropdown-from": (0, $f39o3.fadeInTransform)((0, $f39o3.computePosition)(t.anchor, n, t.placement).side)
                };
            },
            minWidth: (e)=>e.parent?.layer?.minWidth || "180px",
            maxWidth: (e)=>e.parent?.layer?.maxWidth || "90vw",
            maxHeight: (e)=>{
                const t = e.parent?.layer;
                if (!t?.anchor) return "none";
                const n = e._lastSize || {
                    width: 280,
                    height: 200
                };
                return $3283d51e0d52f3f0$var$c(t, (0, $f39o3.computePosition)(t.anchor, n, t.placement));
            },
            overflow: "auto",
            overscrollBehavior: "contain",
            padding: "0",
            round: (e)=>e.parent?.layer?.round || "radiusCard",
            theme: (e)=>e.parent?.layer?.theme || null,
            border: "none",
            borderWidth: "0",
            shadow: (e)=>e.parent?.layer?.shadow || e.scope?.bodyShadow || null,
            scope: {
                bodyShadow: null
            },
            animationDuration: "B",
            animationTimingFunction: "defaultBezier",
            pointerEvents: (e)=>{
                const t = e.parent?.layer;
                return t ? t.inert ? "none" : "auto" : "none";
            },
            opacity: (e)=>e.parent?.layer ? "1" : "0",
            onClick: (e)=>e.stopPropagation(),
            onInit: (e)=>{
                const t = (0, $eY4Ct.createEffect)(()=>{
                    const n = e.parent?.layer, o = n?.content || null, r = n?.id || null;
                    if (!o) {
                        if (e.__lastLayerId != null) {
                            try {
                                e.removeContent?.();
                            } catch  {}
                            e.__lastLayerId = null, $3283d51e0d52f3f0$var$h(e, null), e.node?.removeAttribute("data-smbls-open"), e.scope && (e.scope.bodyShadow = null);
                        }
                        return;
                    }
                    if (e.__lastLayerId !== r) {
                        e.__lastLayerId = r;
                        try {
                            e.set(o);
                        } catch (a) {
                            console.warn("[dropdown] content set failed:", a);
                        }
                        e.scope && (e.scope.bodyShadow = $3283d51e0d52f3f0$var$_(e.content)), $3283d51e0d52f3f0$var$f(e, n), $3283d51e0d52f3f0$var$h(e, n), $3283d51e0d52f3f0$var$g(e), n.focusIn && $3283d51e0d52f3f0$var$k(e), !(typeof requestAnimationFrame > "u") && requestAnimationFrame(()=>{
                            if (!e.node) return;
                            $3283d51e0d52f3f0$var$f(e, n);
                            const a = e.parent?.layer;
                            if (!a?.anchor) return;
                            const s = $3283d51e0d52f3f0$var$u(e.node);
                            e._lastSize = s;
                            const d = (0, $f39o3.computePosition)(a.anchor, s, a.placement);
                            e.node.style.maxHeight = $3283d51e0d52f3f0$var$c(a, d), e.node.style.left = d.left + "px", e.node.style.top = d.top + "px", e.node.style.setProperty("--smbls-dropdown-from", (0, $f39o3.fadeInTransform)(d.side));
                        });
                    }
                });
                e.__ref && e.__ref.__effects?.push(t);
            },
            onRender: (e)=>{
                if (!e?.node) return;
                const t = e.parent?.layer;
                if (!t?.anchor) return;
                const n = $3283d51e0d52f3f0$var$u(e.node), o = e._lastSize;
                (!o || Math.abs(o.width - n.width) > 1 || Math.abs(o.height - n.height) > 1) && (e._lastSize = n);
                const a = (0, $f39o3.computePosition)(t.anchor, n, t.placement);
                e.node.style.maxHeight = $3283d51e0d52f3f0$var$c(t, a), e.node.style.left = a.left + "px", e.node.style.top = a.top + "px", e.node.style.setProperty("--smbls-dropdown-from", (0, $f39o3.fadeInTransform)(a.side));
            }
        }
    }
};

});
parcelRegister("eY4Ct", function(module, exports) {

$parcel$export(module.exports, "ANIMATION_PROPS", () => dT);
$parcel$export(module.exports, "ARIA_ROLES", () => eK);
$parcel$export(module.exports, "ATTR_TRANSFORMS", () => zr);
$parcel$export(module.exports, "BARE_SEQUENCE_TOKEN_RE", () => $n);
$parcel$export(module.exports, "BLOCK_PROPS", () => pT);
$parcel$export(module.exports, "BREAKPOINTS_CONTAINER_NAME", () => SP);
$parcel$export(module.exports, "BREAKPOINT_PROPS", () => wT);
$parcel$export(module.exports, "BRENDER_LAZY_META", () => Ng);
$parcel$export(module.exports, "BRENDER_REGISTRY_BLOCK", () => ru);
$parcel$export(module.exports, "BRENDER_REGISTRY_TREE_BLOCK", () => su);
$parcel$export(module.exports, "BRENDER_STAMP_META", () => Bg);
$parcel$export(module.exports, "CDN_PROVIDERS", () => cn);
$parcel$export(module.exports, "COMPOUND_CSS_KEYWORDS", () => ei);
$parcel$export(module.exports, "CONFIG", () => si);
$parcel$export(module.exports, "CONFIG_MERGE_EXL", () => ue);
$parcel$export(module.exports, "CSS_LONGHAND_SHORTHANDS", () => gn);
$parcel$export(module.exports, "CSS_NAMED_COLOR_HEX", () => Ya);
$parcel$export(module.exports, "CSS_NATIVE_COLOR_REGEX", () => Fo);
$parcel$export(module.exports, "CSS_PROPS_REGISTRY", () => St);
$parcel$export(module.exports, "CSS_PROP_WRITES", () => xT);
$parcel$export(module.exports, "CSS_SHORTHAND_LONGHANDS", () => kt);
$parcel$export(module.exports, "CSS_UNITS", () => ga);
$parcel$export(module.exports, "DEFAULT_CONFIG", () => Ni);
$parcel$export(module.exports, "DEFAULT_CSS_PROPERTIES_LIST", () => Ft);
$parcel$export(module.exports, "DELEGATED_EVENTS", () => kc);
$parcel$export(module.exports, "DESIGN_SYSTEM_BLOCK", () => lu);
$parcel$export(module.exports, "DESIGN_SYSTEM_DEFERRED", () => cu);
$parcel$export(module.exports, "DESIGN_SYSTEM_LINK", () => au);
$parcel$export(module.exports, "DESIGN_SYSTEM_OPTIONS", () => aC);
$parcel$export(module.exports, "DIALOG_COPY", () => rp);
$parcel$export(module.exports, "DOMQL_EVENTS", () => RS);
$parcel$export(module.exports, "DOMQ_PROPERTIES", () => pr);
$parcel$export(module.exports, "DOM_EVENTS", () => cI);
$parcel$export(module.exports, "ELEMENT_METHOD_OVERRIDE_POINTS", () => wa);
$parcel$export(module.exports, "ENV", () => QS);
$parcel$export(module.exports, "FACTORY", () => Ve);
$parcel$export(module.exports, "FLEX_PROPS", () => _T);
$parcel$export(module.exports, "FONT_PROPS", () => hT);
$parcel$export(module.exports, "GRID_PROPS", () => bT);
$parcel$export(module.exports, "HOST_FORCED_ATTR", () => uu);
$parcel$export(module.exports, "HOST_FORCED_ROBOTS", () => dk);
$parcel$export(module.exports, "HOST_FORCED_VALUE", () => du);
$parcel$export(module.exports, "HOST_PACKAGE_ERROR_CODES", () => In);
$parcel$export(module.exports, "HOST_PACKAGE_LOADER_KEY", () => Fa);
$parcel$export(module.exports, "HOST_PACKAGE_PATH_BASE", () => Eg);
$parcel$export(module.exports, "HOST_REGISTERED_PACKAGES", () => $p);
$parcel$export(module.exports, "HOST_SOURCES_GLOBAL", () => Tr);
$parcel$export(module.exports, "HOST_SOURCES_TAG_ATTR", () => Ag);
$parcel$export(module.exports, "HTML_ATTRIBUTES", () => tr);
$parcel$export(module.exports, "HTML_TAGS", () => Ta);
$parcel$export(module.exports, "LAZY_HOST_IMPORT_FORMS", () => Na);
$parcel$export(module.exports, "LIBRARY_PACKAGES", () => Ig);
$parcel$export(module.exports, "LIBRARY_SCOPES_KEY", () => Vs);
$parcel$export(module.exports, "LIFECYCLE_EVENTS", () => uo);
$parcel$export(module.exports, "LIVE_KEYS", () => R0);
$parcel$export(module.exports, "METHODS", () => gr);
$parcel$export(module.exports, "METHODS_EXL", () => Vl);
$parcel$export(module.exports, "MISC_PROPS", () => gT);
$parcel$export(module.exports, "MIXINS", () => Hm);
$parcel$export(module.exports, "NODE_ENV", () => Rn);
$parcel$export(module.exports, "OPTIONS", () => Af);
$parcel$export(module.exports, "PACKAGE_MANAGER_TO_CDN", () => Er);
$parcel$export(module.exports, "PARSED_DOMQ_PROPERTIES", () => Hl);
$parcel$export(module.exports, "POLYGLOT_LANG_STORAGE_KEY", () => lh);
$parcel$export(module.exports, "POLYGLOT_TRANSLATIONS_FROM_LANG", () => _S);
$parcel$export(module.exports, "POSITION_PROPS", () => mT);
$parcel$export(module.exports, "PREPARED_FORMAT", () => gc);
$parcel$export(module.exports, "PRERENDER_REGISTRY_FORMATS", () => mC);
$parcel$export(module.exports, "PROPS_METHODS", () => hr);
$parcel$export(module.exports, "PROTOTYPE_KEYS", () => je);
$parcel$export(module.exports, "REGISTRY", () => Kt);
$parcel$export(module.exports, "RESERVED_STORE_METHODS", () => eR);
$parcel$export(module.exports, "REVIVED_MARK", () => Yl);
$parcel$export(module.exports, "ROUTER_OPTIONS", () => bb);
$parcel$export(module.exports, "ROUTE_HEAD_KEYS", () => Mg);
$parcel$export(module.exports, "SHADOWED_COMPONENTS", () => Ea);
$parcel$export(module.exports, "SIGNAL_ENGINE_KEY", () => pa);
$parcel$export(module.exports, "SIGNAL_INSTANCES_KEY", () => ua);
$parcel$export(module.exports, "SMBLS_PATH_PREFIX", () => Ba);
$parcel$export(module.exports, "STANDARD_SCHEME_QUERIES", () => pm);
$parcel$export(module.exports, "STATE_DATA_MERGE_EXL", () => Yh);
$parcel$export(module.exports, "STATE_PROPERTIES", () => OS);
$parcel$export(module.exports, "STORE_METHOD_NAMES", () => tR);
$parcel$export(module.exports, "SVG_TAGS", () => Rc);
$parcel$export(module.exports, "THEME_PROPS", () => yT);
$parcel$export(module.exports, "TILING_POSITION_KEYWORDS", () => nd);
$parcel$export(module.exports, "TILING_SIZE_KEYWORDS", () => ed);
$parcel$export(module.exports, "TIMING_PROPS", () => yd);
$parcel$export(module.exports, "TYPES", () => Il);
$parcel$export(module.exports, "UNIVERSAL_RESERVED_KEYS", () => xg);
$parcel$export(module.exports, "VALUE_TRANSFORMERS", () => vm);
$parcel$export(module.exports, "VERSION", () => Y1);
$parcel$export(module.exports, "WORKER_SCRIPT_BASE", () => Ma);
$parcel$export(module.exports, "WORKER_SCRIPT_NAME", () => Tg);
$parcel$export(module.exports, "__resetBuiltinMethodWarnings", () => Jx);
$parcel$export(module.exports, "__resetSignalEngine", () => Xb);
$parcel$export(module.exports, "__resetSignalInstances", () => Yb);
$parcel$export(module.exports, "__resetSkinWarnings", () => _0);
$parcel$export(module.exports, "__resetStateShadowWarnings", () => nR);
$parcel$export(module.exports, "activateConfig", () => BL);
$parcel$export(module.exports, "addCaching", () => Vh);
$parcel$export(module.exports, "addContext", () => Hh);
$parcel$export(module.exports, "addDelegatedEvent", () => pd);
$parcel$export(module.exports, "addExtend", () => yw);
$parcel$export(module.exports, "addExtends", () => eo);
$parcel$export(module.exports, "addItemAfterEveryElement", () => cS);
$parcel$export(module.exports, "addMethods", () => Ic);
$parcel$export(module.exports, "addProtoToArray", () => Nl);
$parcel$export(module.exports, "addRef", () => $h);
$parcel$export(module.exports, "adoptPrepared", () => Iv);
$parcel$export(module.exports, "aliasCaseVariants", () => oc);
$parcel$export(module.exports, "alternateLinkKey", () => Zs);
$parcel$export(module.exports, "animation", () => Yk);
$parcel$export(module.exports, "appendSVGSprite", () => Qu);
$parcel$export(module.exports, "appendSvgIconsSprite", () => yi);
$parcel$export(module.exports, "applyAttrTransforms", () => GT);
$parcel$export(module.exports, "applyCSS", () => Bv);
$parcel$export(module.exports, "applyDependentState", () => Iw);
$parcel$export(module.exports, "applyDocument", () => Zu);
$parcel$export(module.exports, "applyEvent", () => gg);
$parcel$export(module.exports, "applyEventUpdate", () => mg);
$parcel$export(module.exports, "applyExtends", () => vc);
$parcel$export(module.exports, "applyHeadings", () => bm);
$parcel$export(module.exports, "applyInitialState", () => cy);
$parcel$export(module.exports, "applyMediaSequenceVars", () => Pr);
$parcel$export(module.exports, "applyProps", () => ff);
$parcel$export(module.exports, "applyReset", () => Ju);
$parcel$export(module.exports, "applySequenceGlobalVars", () => Pu);
$parcel$export(module.exports, "applySequenceVars", () => zo);
$parcel$export(module.exports, "applySkins", () => Hu);
$parcel$export(module.exports, "applySpacingSequence", () => Fu);
$parcel$export(module.exports, "applyStateMethods", () => Le);
$parcel$export(module.exports, "applyThemeRoot", () => sd);
$parcel$export(module.exports, "applyTimingSequence", () => Xu);
$parcel$export(module.exports, "applyTrueProps", () => vT);
$parcel$export(module.exports, "applyTypographySequence", () => Gu);
$parcel$export(module.exports, "arrayContainsOtherArray", () => eS);
$parcel$export(module.exports, "arraysEqual", () => fS);
$parcel$export(module.exports, "arrayzeValue", () => Js);
$parcel$export(module.exports, "assertEmitIntegrity", () => q0);
$parcel$export(module.exports, "atSchemes", () => Br);
$parcel$export(module.exports, "bareLibraryKey", () => Kf);
$parcel$export(module.exports, "batch", () => th);
$parcel$export(module.exports, "bindLibraryGlobalScopes", () => qf);
$parcel$export(module.exports, "breakpoints", () => Gk);
$parcel$export(module.exports, "breakpointsContainerName", () => Ac);
$parcel$export(module.exports, "brenderLazyMeta", () => fk);
$parcel$export(module.exports, "brenderStampMeta", () => lk);
$parcel$export(module.exports, "buildImgSrcset", () => gu);
$parcel$export(module.exports, "buildSkinVarStyles", () => gi);
$parcel$export(module.exports, "buildSourcesAndImg", () => mu);
$parcel$export(module.exports, "buildThemeVarStyles", () => m_);
$parcel$export(module.exports, "cache", () => gx);
$parcel$export(module.exports, "cacheNode", () => Hr);
$parcel$export(module.exports, "call", () => Ax);
$parcel$export(module.exports, "callStateMethod", () => kd);
$parcel$export(module.exports, "camelToAttr", () => er);
$parcel$export(module.exports, "camelToLowerAttr", () => dI);
$parcel$export(module.exports, "captureSnapshot", () => Ox);
$parcel$export(module.exports, "changeGlobalTheme", () => Om);
$parcel$export(module.exports, "changeLightness", () => Ck);
$parcel$export(module.exports, "checkAttributeByTagName", () => qe);
$parcel$export(module.exports, "checkEventFunctions", () => KT);
$parcel$export(module.exports, "checkForStateTypes", () => Rw);
$parcel$export(module.exports, "checkIfBoxSize", () => Nu);
$parcel$export(module.exports, "checkIfInherits", () => qh);
$parcel$export(module.exports, "checkIfStringIsInArray", () => pS);
$parcel$export(module.exports, "class", () => t0);
$parcel$export(module.exports, "classifyHostPackageReads", () => Mx);
$parcel$export(module.exports, "clone", () => NS);
$parcel$export(module.exports, "cloneAndMergeArrayExtend", () => tf);
$parcel$export(module.exports, "cloneFunction", () => mS);
$parcel$export(module.exports, "collectExtendsList", () => Lo);
$parcel$export(module.exports, "color", () => jk);
$parcel$export(module.exports, "colorPairSchemes", () => Bu);
$parcel$export(module.exports, "colorStringToRgbaArray", () => ln);
$parcel$export(module.exports, "components", () => il);
$parcel$export(module.exports, "compositeOverBackdrop", () => oi);
$parcel$export(module.exports, "compoundLayers", () => Za);
$parcel$export(module.exports, "concatAddExtends", () => hw);
$parcel$export(module.exports, "containerBreakpointQuery", () => ST);
$parcel$export(module.exports, "contrastRatio", () => Ja);
$parcel$export(module.exports, "convertSvgToSymbol", () => Mu);
$parcel$export(module.exports, "copyJavaScriptToClipboard", () => yk);
$parcel$export(module.exports, "copyStringToClipboard", () => mk);
$parcel$export(module.exports, "countUntrackedReads", () => nh);
$parcel$export(module.exports, "create", () => UC);
$parcel$export(module.exports, "createAsync", () => att);
$parcel$export(module.exports, "createBasedOnType", () => Fh);
$parcel$export(module.exports, "createComputed", () => QC);
$parcel$export(module.exports, "createConfig", () => Au);
$parcel$export(module.exports, "createDefine", () => zU);
$parcel$export(module.exports, "createDomqlElement", () => Fp);
$parcel$export(module.exports, "createEffect", () => q);
$parcel$export(module.exports, "createElement", () => Cw);
$parcel$export(module.exports, "createElementExtends", () => vh);
$parcel$export(module.exports, "createExtends", () => nf);
$parcel$export(module.exports, "createExtendsFromKeys", () => Aa);
$parcel$export(module.exports, "createExtendsStack", () => Dh);
$parcel$export(module.exports, "createHTMLNode", () => Cc);
$parcel$export(module.exports, "createIfConditionFlag", () => ow);
$parcel$export(module.exports, "createInheritedState", () => Dw);
$parcel$export(module.exports, "createKey", () => Jl);
$parcel$export(module.exports, "createNestedObject", () => WS);
$parcel$export(module.exports, "createNestedObjectByKeyPath", () => Pw);
$parcel$export(module.exports, "createObjectWithoutPrototype", () => bh);
$parcel$export(module.exports, "createParent", () => jh);
$parcel$export(module.exports, "createPath", () => Uh);
$parcel$export(module.exports, "createPristineConfig", () => lm);
$parcel$export(module.exports, "createProps", () => uf);
$parcel$export(module.exports, "createPropsStack", () => Bh);
$parcel$export(module.exports, "createPrunedLibraryIconLoader", () => Hg);
$parcel$export(module.exports, "createRoot", () => Ow);
$parcel$export(module.exports, "createScope", () => Bw);
$parcel$export(module.exports, "createScopeStore", () => oh);
$parcel$export(module.exports, "createSignal", () => On);
$parcel$export(module.exports, "createSkeleton", () => ltt);
$parcel$export(module.exports, "createSnapshotId", () => Ql);
$parcel$export(module.exports, "createState", () => jT);
$parcel$export(module.exports, "createStore", () => vo);
$parcel$export(module.exports, "createSync", () => ctt);
$parcel$export(module.exports, "css", () => Ke);
$parcel$export(module.exports, "cssCamelName", () => fd);
$parcel$export(module.exports, "cssMediaVars", () => am);
$parcel$export(module.exports, "cssPropName", () => Re);
$parcel$export(module.exports, "cssShorthandDepth", () => mc);
$parcel$export(module.exports, "cssShorthandStatesLonghand", () => yc);
$parcel$export(module.exports, "cssShorthandStatesThemeLonghand", () => id);
$parcel$export(module.exports, "cssVars", () => im);
$parcel$export(module.exports, "currentPathname", () => bs);
$parcel$export(module.exports, "customDecodeURIComponent", () => vS);
$parcel$export(module.exports, "customEncodeURIComponent", () => AS);
$parcel$export(module.exports, "cutArrayAfterValue", () => iS);
$parcel$export(module.exports, "cutArrayBeforeValue", () => sS);
$parcel$export(module.exports, "debounce", () => Fl);
$parcel$export(module.exports, "debounceOnContext", () => hS);
$parcel$export(module.exports, "decodeBrenderRegistry", () => iu);
$parcel$export(module.exports, "decodeNewlines", () => ES);
$parcel$export(module.exports, "deepClone", () => ft);
$parcel$export(module.exports, "deepContains", () => VS);
$parcel$export(module.exports, "deepDefaults", () => Va);
$parcel$export(module.exports, "deepDestringifyFunctions", () => xe);
$parcel$export(module.exports, "deepExtend", () => Th);
$parcel$export(module.exports, "deepMerge", () => mt);
$parcel$export(module.exports, "deepMergeExtends", () => no);
$parcel$export(module.exports, "deepStringifyFunctions", () => Wl);
$parcel$export(module.exports, "defaultDefine", () => ia);
$parcel$export(module.exports, "defineResolvedThemeSignal", () => Lr);
$parcel$export(module.exports, "defineSetter", () => Tx);
$parcel$export(module.exports, "defineThemeSignal", () => Dr);
$parcel$export(module.exports, "designSystemBlock", () => ck);
$parcel$export(module.exports, "designSystemLink", () => ak);
$parcel$export(module.exports, "destringifyGlobalScope", () => vs);
$parcel$export(module.exports, "destroy", () => ra);
$parcel$export(module.exports, "detectHeightOnInit", () => jx);
$parcel$export(module.exports, "detectInfiniteLoop", () => YS);
$parcel$export(module.exports, "detectTag", () => Hn);
$parcel$export(module.exports, "devices", () => qk);
$parcel$export(module.exports, "dispose", () => Sn);
$parcel$export(module.exports, "effectiveGlobalTheme", () => y_);
$parcel$export(module.exports, "elementPath", () => an);
$parcel$export(module.exports, "encodeNewlines", () => TS);
$parcel$export(module.exports, "error", () => js);
$parcel$export(module.exports, "escapeHtml", () => H);
$parcel$export(module.exports, "escapeRegExp", () => SS);
$parcel$export(module.exports, "evaluateText", () => Pn);
$parcel$export(module.exports, "excludeKeysFromObject", () => ZS);
$parcel$export(module.exports, "exec", () => bt);
$parcel$export(module.exports, "executeAttr", () => fK);
$parcel$export(module.exports, "exetuteClassPerComponent", () => D9);
$parcel$export(module.exports, "exposeBagGlobalScopes", () => Yf);
$parcel$export(module.exports, "extendCachedRegistry", () => gw);
$parcel$export(module.exports, "extendStackRegistry", () => of);
$parcel$export(module.exports, "extractArrayExtend", () => sf);
$parcel$export(module.exports, "extractConditionalAttrs", () => qT);
$parcel$export(module.exports, "faviconLinkKey", () => Or);
$parcel$export(module.exports, "fetchLibraryData", () => Ys);
$parcel$export(module.exports, "fibonacciNumberByIndex", () => Ux);
$parcel$export(module.exports, "fileEntryUrl", () => Fg);
$parcel$export(module.exports, "filterArrays", () => uS);
$parcel$export(module.exports, "filterArraysFast", () => dS);
$parcel$export(module.exports, "filterAttributesByTagName", () => lK);
$parcel$export(module.exports, "finalizeExtends", () => Lh);
$parcel$export(module.exports, "findClosestNumber", () => $g);
$parcel$export(module.exports, "findClosestNumberInFactory", () => gk);
$parcel$export(module.exports, "findHeadingLetter", () => um);
$parcel$export(module.exports, "findHeadings", () => Lu);
$parcel$export(module.exports, "findInheritedState", () => Gh);
$parcel$export(module.exports, "findKeyPosition", () => xS);
$parcel$export(module.exports, "flattenExtend", () => va);
$parcel$export(module.exports, "font", () => Ik);
$parcel$export(module.exports, "fontFace", () => Nk);
$parcel$export(module.exports, "fontFamily", () => Mk);
$parcel$export(module.exports, "fontFamilyTypes", () => Bk);
$parcel$export(module.exports, "forcedScheme", () => di);
$parcel$export(module.exports, "formatDate", () => $x);
$parcel$export(module.exports, "generateHash", () => wh);
$parcel$export(module.exports, "generateHeadArrayTags", () => Ka);
$parcel$export(module.exports, "generateKey", () => Zl);
$parcel$export(module.exports, "generateMetaTags", () => pk);
$parcel$export(module.exports, "generateSequence", () => Ee);
$parcel$export(module.exports, "generateSequencePosition", () => l0);
$parcel$export(module.exports, "generateSprite", () => Iu);
$parcel$export(module.exports, "generateSubSequence", () => Ru);
$parcel$export(module.exports, "get", () => Sx);
$parcel$export(module.exports, "getActiveConfig", () => L);
$parcel$export(module.exports, "getActiveDocument", () => fo);
$parcel$export(module.exports, "getActiveLang", () => fs);
$parcel$export(module.exports, "getCDNDirUrl", () => Og);
$parcel$export(module.exports, "getCDNUrl", () => Mn);
$parcel$export(module.exports, "getCacheSize", () => eT);
$parcel$export(module.exports, "getCapitalCaseKeys", () => bw);
$parcel$export(module.exports, "getCdnProviderFromConfig", () => Ua);
$parcel$export(module.exports, "getChildStateInKey", () => Kh);
$parcel$export(module.exports, "getChildren", () => kx);
$parcel$export(module.exports, "getColor", () => ct);
$parcel$export(module.exports, "getColorShade", () => Gg);
$parcel$export(module.exports, "getContext", () => Mf);
$parcel$export(module.exports, "getCookie", () => cw);
$parcel$export(module.exports, "getDB", () => jf);
$parcel$export(module.exports, "getDefaultOrFirstKey", () => jo);
$parcel$export(module.exports, "getEmitStats", () => jm);
$parcel$export(module.exports, "getEmotionStylesheet", () => kk);
$parcel$export(module.exports, "getExtendsInElement", () => _w);
$parcel$export(module.exports, "getExtendsStack", () => ef);
$parcel$export(module.exports, "getExtendsStackRegistry", () => kh);
$parcel$export(module.exports, "getFnPrefixAndValue", () => Vo);
$parcel$export(module.exports, "getFontFace", () => Dk);
$parcel$export(module.exports, "getFontFaceEach", () => ri);
$parcel$export(module.exports, "getFontFaceEachString", () => nm);
$parcel$export(module.exports, "getFontFaceString", () => Lk);
$parcel$export(module.exports, "getFontFamily", () => Ku);
$parcel$export(module.exports, "getFontFormat", () => tm);
$parcel$export(module.exports, "getFontSizeByKey", () => qu);
$parcel$export(module.exports, "getFrequencyInArray", () => nS);
$parcel$export(module.exports, "getFunctionSource", () => Ue);
$parcel$export(module.exports, "getHashedExtend", () => rf);
$parcel$export(module.exports, "getImportMapScript", () => Fx);
$parcel$export(module.exports, "getInObjectByPath", () => qS);
$parcel$export(module.exports, "getLanguages", () => Dp);
$parcel$export(module.exports, "getLocalStateLang", () => Mp);
$parcel$export(module.exports, "getLocalStorage", () => fw);
$parcel$export(module.exports, "getMediaBorder", () => Uu);
$parcel$export(module.exports, "getMediaColor", () => Wt);
$parcel$export(module.exports, "getMediaTheme", () => hn);
$parcel$export(module.exports, "getNev", () => nw);
$parcel$export(module.exports, "getObserver", () => $e);
$parcel$export(module.exports, "getPageMetadata", () => hk);
$parcel$export(module.exports, "getParentStateInKey", () => Wh);
$parcel$export(module.exports, "getPath", () => Cf);
$parcel$export(module.exports, "getPendingLang", () => Rp);
$parcel$export(module.exports, "getQuery", () => Uf);
$parcel$export(module.exports, "getRef", () => xx);
$parcel$export(module.exports, "getResolvedThemeSignal", () => ML);
$parcel$export(module.exports, "getRgbTone", () => Fn);
$parcel$export(module.exports, "getRoot", () => Lf);
$parcel$export(module.exports, "getRootContext", () => If);
$parcel$export(module.exports, "getRootData", () => Pf);
$parcel$export(module.exports, "getRootState", () => Df);
$parcel$export(module.exports, "getRootStateInKey", () => zh);
$parcel$export(module.exports, "getSafeInk", () => mm);
$parcel$export(module.exports, "getSafeInkInfo", () => g0);
$parcel$export(module.exports, "getSequenceValue", () => ii);
$parcel$export(module.exports, "getSequenceValueBySymbols", () => Du);
$parcel$export(module.exports, "getSequenceValuePropertyPair", () => lo);
$parcel$export(module.exports, "getShadow", () => ju);
$parcel$export(module.exports, "getShapeByKey", () => Yu);
$parcel$export(module.exports, "getSignals", () => JC);
$parcel$export(module.exports, "getSizeValue", () => rc);
$parcel$export(module.exports, "getSpacingBasedOnRatio", () => ze);
$parcel$export(module.exports, "getSpacingByKey", () => Ut);
$parcel$export(module.exports, "getSpreadChildren", () => Sw);
$parcel$export(module.exports, "getSubratio", () => Cu);
$parcel$export(module.exports, "getSubratioDifference", () => Ou);
$parcel$export(module.exports, "getSystemGlobalTheme", () => he);
$parcel$export(module.exports, "getTheme", () => x0);
$parcel$export(module.exports, "getThemeSignal", () => IL);
$parcel$export(module.exports, "getTimingByKey", () => Ae);
$parcel$export(module.exports, "getTimingFunction", () => We);
$parcel$export(module.exports, "global", () => Qb);
$parcel$export(module.exports, "gradient", () => Uk);
$parcel$export(module.exports, "grid", () => Jk);
$parcel$export(module.exports, "hasFunction", () => ie);
$parcel$export(module.exports, "hasHandlerPlugin", () => _a);
$parcel$export(module.exports, "hasOwnProperty", () => jS);
$parcel$export(module.exports, "hashContent", () => Bn);
$parcel$export(module.exports, "hexToRgb", () => Ek);
$parcel$export(module.exports, "hexToRgbArray", () => Vg);
$parcel$export(module.exports, "hexToRgba", () => vk);
$parcel$export(module.exports, "hostPackageAssetPath", () => Lx);
$parcel$export(module.exports, "hostPackageSourcesScript", () => vg);
$parcel$export(module.exports, "hostPackageSourcesTag", () => Bx);
$parcel$export(module.exports, "hslToRgb", () => Kg);
$parcel$export(module.exports, "icons", () => zk);
$parcel$export(module.exports, "importHostPackage", () => vb);
$parcel$export(module.exports, "inForcedColors", () => ai);
$parcel$export(module.exports, "inheritChildExtends", () => Ch);
$parcel$export(module.exports, "inheritChildPropsExtends", () => Oh);
$parcel$export(module.exports, "inheritParentProps", () => df);
$parcel$export(module.exports, "inheritRecursiveChildExtends", () => Rh);
$parcel$export(module.exports, "init", () => To);
$parcel$export(module.exports, "initPolyglot", () => Tb);
$parcel$export(module.exports, "initProps", () => Aw);
$parcel$export(module.exports, "injectGlobal", () => Lt);
$parcel$export(module.exports, "insertAfterImportMap", () => uk);
$parcel$export(module.exports, "installPrunedLibraryIconLoader", () => hu);
$parcel$export(module.exports, "is", () => Se);
$parcel$export(module.exports, "isArray", () => B);
$parcel$export(module.exports, "isBoolean", () => sh);
$parcel$export(module.exports, "isBuiltinElementMethod", () => CS);
$parcel$export(module.exports, "isCSSVar", () => Nt);
$parcel$export(module.exports, "isContextComponent", () => ww);
$parcel$export(module.exports, "isCyclic", () => XS);
$parcel$export(module.exports, "isDOMNode", () => _e);
$parcel$export(module.exports, "isDate", () => ah);
$parcel$export(module.exports, "isDefined", () => jt);
$parcel$export(module.exports, "isDevelopment", () => yr);
$parcel$export(module.exports, "isDomDocument", () => Oo);
$parcel$export(module.exports, "isEmpty", () => yh);
$parcel$export(module.exports, "isEmptyObject", () => US);
$parcel$export(module.exports, "isEnumeratedTrueFalseAttr", () => vi);
$parcel$export(module.exports, "isEqualDeep", () => _h);
$parcel$export(module.exports, "isFailedRevival", () => Es);
$parcel$export(module.exports, "isForcedColorsQuery", () => ci);
$parcel$export(module.exports, "isFunction", () => P);
$parcel$export(module.exports, "isGoogleFontsUrl", () => tc);
$parcel$export(module.exports, "isHostObject", () => Co);
$parcel$export(module.exports, "isHostPackageSpecifier", () => Hf);
$parcel$export(module.exports, "isHtmlElement", () => Pl);
$parcel$export(module.exports, "isInertCompoundValue", () => Yg);
$parcel$export(module.exports, "isIntendedSystemColorWord", () => li);
$parcel$export(module.exports, "isLazyFunction", () => FS);
$parcel$export(module.exports, "isLocal", () => ew);
$parcel$export(module.exports, "isLoudDevRuntime", () => et);
$parcel$export(module.exports, "isMalformedDependency", () => Us);
$parcel$export(module.exports, "isMethod", () => vx);
$parcel$export(module.exports, "isMobile", () => iw);
$parcel$export(module.exports, "isNativeColorToken", () => ni);
$parcel$export(module.exports, "isNode", () => Ro);
$parcel$export(module.exports, "isNot", () => tS);
$parcel$export(module.exports, "isNotProduction", () => Do);
$parcel$export(module.exports, "isNull", () => ih);
$parcel$export(module.exports, "isNumber", () => be);
$parcel$export(module.exports, "isObject", () => k);
$parcel$export(module.exports, "isObjectLike", () => z);
$parcel$export(module.exports, "isPhoto", () => Hx);
$parcel$export(module.exports, "isPlainColor", () => Mr);
$parcel$export(module.exports, "isPolyglotRetranslatableKey", () => mf);
$parcel$export(module.exports, "isPolyglotWritableKey", () => Cs);
$parcel$export(module.exports, "isProduction", () => mr);
$parcel$export(module.exports, "isProtectedElementMethod", () => xs);
$parcel$export(module.exports, "isRawUnitValue", () => Ll);
$parcel$export(module.exports, "isResolvedColor", () => fn);
$parcel$export(module.exports, "isRevived", () => As);
$parcel$export(module.exports, "isSameRoutePage", () => nu);
$parcel$export(module.exports, "isScalingUnit", () => gs);
$parcel$export(module.exports, "isStaging", () => tw);
$parcel$export(module.exports, "isState", () => Lw);
$parcel$export(module.exports, "isStore", () => xt);
$parcel$export(module.exports, "isString", () => E);
$parcel$export(module.exports, "isStringFunction", () => ur);
$parcel$export(module.exports, "isStringTag", () => ql);
$parcel$export(module.exports, "isSvgTag", () => Un);
$parcel$export(module.exports, "isTest", () => Sh);
$parcel$export(module.exports, "isTesting", () => JS);
$parcel$export(module.exports, "isTracking", () => HT);
$parcel$export(module.exports, "isUndefined", () => Xt);
$parcel$export(module.exports, "isUniversallyReservedKey", () => Cx);
$parcel$export(module.exports, "isUnresolvableDependency", () => Ar);
$parcel$export(module.exports, "isValidDependencyMap", () => Hs);
$parcel$export(module.exports, "isValidHtmlTag", () => dw);
$parcel$export(module.exports, "isValidTag", () => Oc);
$parcel$export(module.exports, "isWasmLoaded", () => L2);
$parcel$export(module.exports, "isWrappedLibrary", () => ke);
$parcel$export(module.exports, "isWritableFamilyBucket", () => Zb);
$parcel$export(module.exports, "joinArrays", () => ma);
$parcel$export(module.exports, "joinCompoundLayers", () => Qa);
$parcel$export(module.exports, "jointStacks", () => mw);
$parcel$export(module.exports, "jsonForScript", () => Ls);
$parcel$export(module.exports, "keyframes", () => xc);
$parcel$export(module.exports, "keys", () => Sg);
$parcel$export(module.exports, "lazyHostImportExpr", () => Ix);
$parcel$export(module.exports, "libraryIconPruneReplacer", () => xk);
$parcel$export(module.exports, "libraryIdentifier", () => jg);
$parcel$export(module.exports, "libraryPackageSpecs", () => Ks);
$parcel$export(module.exports, "librarySpecsFor", () => Pg);
$parcel$export(module.exports, "linearChannelToSrgb", () => Zg);
$parcel$export(module.exports, "literalPairCompound", () => pi);
$parcel$export(module.exports, "literalSchemeMap", () => Ko);
$parcel$export(module.exports, "loadCssFile", () => Kx);
$parcel$export(module.exports, "loadJavascript", () => Gx);
$parcel$export(module.exports, "loadJavascriptFile", () => Vx);
$parcel$export(module.exports, "loadJavascriptFileEmbedSync", () => Wx);
$parcel$export(module.exports, "loadJavascriptFileSync", () => zx);
$parcel$export(module.exports, "loadRemoteCSS", () => qx);
$parcel$export(module.exports, "loadRemoteScript", () => Ha);
$parcel$export(module.exports, "loadTranslations", () => la);
$parcel$export(module.exports, "loadWasm", () => D2);
$parcel$export(module.exports, "log", () => Ex);
$parcel$export(module.exports, "logGroupIf", () => sw);
$parcel$export(module.exports, "logIf", () => rw);
$parcel$export(module.exports, "lookdown", () => _x);
$parcel$export(module.exports, "lookdownAll", () => bx);
$parcel$export(module.exports, "lookup", () => yx);
$parcel$export(module.exports, "lowercaseFirstLetter", () => Ss);
$parcel$export(module.exports, "makeObjectWithoutPrototype", () => HS);
$parcel$export(module.exports, "map", () => BS);
$parcel$export(module.exports, "mapStringsWithContextComponents", () => cf);
$parcel$export(module.exports, "markPolyglotSeeded", () => ro);
$parcel$export(module.exports, "markRevived", () => ka);
$parcel$export(module.exports, "markTextNotReady", () => Ia);
$parcel$export(module.exports, "matchesComponentNaming", () => oo);
$parcel$export(module.exports, "media", () => Fk);
$parcel$export(module.exports, "memoize", () => gS);
$parcel$export(module.exports, "merge", () => Dt);
$parcel$export(module.exports, "mergeSharedLibraries", () => Zf);
$parcel$export(module.exports, "mergeSharedLibraryDesignSystems", () => Qf);
$parcel$export(module.exports, "mergeSharedLibraryTranslations", () => Jf);
$parcel$export(module.exports, "mergeStateData", () => _r);
$parcel$export(module.exports, "mixTwoColors", () => Tk);
$parcel$export(module.exports, "mixTwoRgb", () => Ok);
$parcel$export(module.exports, "mixTwoRgba", () => qg);
$parcel$export(module.exports, "nextElement", () => Nf);
$parcel$export(module.exports, "normalizeIgnoreList", () => za);
$parcel$export(module.exports, "normalizeLibraryKey", () => zs);
$parcel$export(module.exports, "numToLetterMap", () => dn);
$parcel$export(module.exports, "objectToString", () => Kl);
$parcel$export(module.exports, "objectizeStringProperty", () => lf);
$parcel$export(module.exports, "oklabToLinearSrgb", () => Qg);
$parcel$export(module.exports, "oklabToOklch", () => bu);
$parcel$export(module.exports, "oklchToGamutSafeSrgb", () => Su);
$parcel$export(module.exports, "oklchToOklab", () => Jg);
$parcel$export(module.exports, "opacify", () => Xa);
$parcel$export(module.exports, "overwrite", () => Xl);
$parcel$export(module.exports, "overwriteDeep", () => le);
$parcel$export(module.exports, "overwriteShallow", () => Os);
$parcel$export(module.exports, "overwriteState", () => Mw);
$parcel$export(module.exports, "parkHostObject", () => fr);
$parcel$export(module.exports, "parse", () => wg);
$parcel$export(module.exports, "parseColorToken", () => ee);
$parcel$export(module.exports, "parseDeep", () => vf);
$parcel$export(module.exports, "payloadHasComputedIconName", () => Ug);
$parcel$export(module.exports, "pickStartLang", () => ph);
$parcel$export(module.exports, "pickupElementFromProps", () => Ih);
$parcel$export(module.exports, "pickupPropsFromElement", () => Ph);
$parcel$export(module.exports, "planLibraryIconPrune", () => wk);
$parcel$export(module.exports, "polyglotAddressLang", () => uh);
$parcel$export(module.exports, "polyglotDefaultLang", () => fh);
$parcel$export(module.exports, "polyglotEarlyStartLang", () => ys);
$parcel$export(module.exports, "polyglotFallbackLang", () => te);
$parcel$export(module.exports, "polyglotFunctions", () => Bp);
$parcel$export(module.exports, "polyglotLangStorageKey", () => Sa);
$parcel$export(module.exports, "polyglotLanguages", () => we);
$parcel$export(module.exports, "polyglotPlugin", () => wl);
$parcel$export(module.exports, "polyglotSeededKeys", () => br);
$parcel$export(module.exports, "polyglotStartLang", () => _s);
$parcel$export(module.exports, "polyglotStartRule", () => dh);
$parcel$export(module.exports, "polyglotStartupScript", () => bS);
$parcel$export(module.exports, "polyglotTranslations", () => dr);
$parcel$export(module.exports, "popConfig", () => ut);
$parcel$export(module.exports, "popStaticCssPass", () => Jm);
$parcel$export(module.exports, "prepareContext", () => $C);
$parcel$export(module.exports, "previousElement", () => Ff);
$parcel$export(module.exports, "promoteActiveRootState", () => La);
$parcel$export(module.exports, "propExists", () => Tw);
$parcel$export(module.exports, "propertizeElement", () => Mh);
$parcel$export(module.exports, "propertizeUpdate", () => kw);
$parcel$export(module.exports, "pushConfig", () => pt);
$parcel$export(module.exports, "pushStaticCssPass", () => Qm);
$parcel$export(module.exports, "quietColorProbe", () => fi);
$parcel$export(module.exports, "quietSequenceProbe", () => Ho);
$parcel$export(module.exports, "readBrenderLazyGroups", () => fu);
$parcel$export(module.exports, "readBrenderStamp", () => Ps);
$parcel$export(module.exports, "readJsonDataBlock", () => io);
$parcel$export(module.exports, "recordRules", () => ud);
$parcel$export(module.exports, "recordShadowedComponent", () => af);
$parcel$export(module.exports, "refreshContextProto", () => Mc);
$parcel$export(module.exports, "registerEvent", () => Tc);
$parcel$export(module.exports, "registerHostPackages", () => jp);
$parcel$export(module.exports, "registerSignalInstance", () => da);
$parcel$export(module.exports, "reinit", () => Mv);
$parcel$export(module.exports, "relativeLuminance", () => ti);
$parcel$export(module.exports, "remove", () => Pc);
$parcel$export(module.exports, "removeChars", () => _k);
$parcel$export(module.exports, "removeCookie", () => lw);
$parcel$export(module.exports, "removeDelegatedEvent", () => hd);
$parcel$export(module.exports, "removeDuplicateProps", () => hf);
$parcel$export(module.exports, "removeDuplicatesInArray", () => ya);
$parcel$export(module.exports, "removeFromArray", () => oS);
$parcel$export(module.exports, "removeFromObject", () => zS);
$parcel$export(module.exports, "removeNestedKeyByPath", () => KS);
$parcel$export(module.exports, "removeValueFromArray", () => Bl);
$parcel$export(module.exports, "removeValueFromArrayAll", () => aS);
$parcel$export(module.exports, "reorderArrayByValues", () => lS);
$parcel$export(module.exports, "repairLegacyArrowScopePreamble", () => zl);
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", () => Zt);
$parcel$export(module.exports, "replaceOctalEscapeSequences", () => kS);
$parcel$export(module.exports, "replayRules", () => dd);
$parcel$export(module.exports, "resetEmitStats", () => G0);
$parcel$export(module.exports, "resolveAsset", () => Te);
$parcel$export(module.exports, "resolveBorderValue", () => de);
$parcel$export(module.exports, "resolveColorRgb", () => ui);
$parcel$export(module.exports, "resolveColorsInGradient", () => Fr);
$parcel$export(module.exports, "resolveComponentTier", () => Ah);
$parcel$export(module.exports, "resolveCompoundWords", () => $o);
$parcel$export(module.exports, "resolveConfigDocument", () => ha);
$parcel$export(module.exports, "resolveDesignSystemClass", () => OP);
$parcel$export(module.exports, "resolveDialogCopy", () => ce);
$parcel$export(module.exports, "resolveFileReferences", () => Cr);
$parcel$export(module.exports, "resolveFileSource", () => WT);
$parcel$export(module.exports, "resolveFileUrl", () => un);
$parcel$export(module.exports, "resolveGridTracks", () => bP);
$parcel$export(module.exports, "resolveHandler", () => ba);
$parcel$export(module.exports, "resolvePolyglotTranslations", () => ms);
$parcel$export(module.exports, "resolvePropValue", () => Vr);
$parcel$export(module.exports, "resolveRouterHref", () => ly);
$parcel$export(module.exports, "resolveShadowNonColorWord", () => ic);
$parcel$export(module.exports, "resolveShadowValue", () => hi);
$parcel$export(module.exports, "resolveSharedLibraries", () => tu);
$parcel$export(module.exports, "resolveStyleBlockTokens", () => CT);
$parcel$export(module.exports, "returnSubThemeOrDefault", () => Rk);
$parcel$export(module.exports, "returnValueAsText", () => Nh);
$parcel$export(module.exports, "reviveConfig", () => Dm);
$parcel$export(module.exports, "rgbArrayToHex", () => zg);
$parcel$export(module.exports, "rgbToHSL", () => Wg);
$parcel$export(module.exports, "rgbToHex", () => Ak);
$parcel$export(module.exports, "routeEntryMetadata", () => Mo);
$parcel$export(module.exports, "routeEntryPage", () => eu);
$parcel$export(module.exports, "runPluginHook", () => Cn);
$parcel$export(module.exports, "runThroughMedia", () => _m);
$parcel$export(module.exports, "runtimeProvidesHostPackageLoader", () => Px);
$parcel$export(module.exports, "schemeGuardSelector", () => gm);
$parcel$export(module.exports, "schemeMediaQuery", () => hm);
$parcel$export(module.exports, "scopeElementParam", () => hh);
$parcel$export(module.exports, "scopeReceiverExpression", () => IS);
$parcel$export(module.exports, "scratchDefaultConfig", () => nc);
$parcel$export(module.exports, "scratchSystem", () => uc);
$parcel$export(module.exports, "scratchUtils", () => Ir);
$parcel$export(module.exports, "self", () => Jb);
$parcel$export(module.exports, "semanticIcons", () => Wk);
$parcel$export(module.exports, "sequence", () => Uo);
$parcel$export(module.exports, "serializeAttrValue", () => mo);
$parcel$export(module.exports, "serializeConfig", () => Rm);
$parcel$export(module.exports, "servedSharedLibraries", () => sk);
$parcel$export(module.exports, "set", () => bi);
$parcel$export(module.exports, "setActiveConfig", () => cm);
$parcel$export(module.exports, "setActiveDocument", () => K0);
$parcel$export(module.exports, "setActiveRootState", () => Rf);
$parcel$export(module.exports, "setAdaptiveSchemeVar", () => Nr);
$parcel$export(module.exports, "setClass", () => LY);
$parcel$export(module.exports, "setClassname", () => L9);
$parcel$export(module.exports, "setColor", () => Wo);
$parcel$export(module.exports, "setCookie", () => aw);
$parcel$export(module.exports, "setCssEngineHook", () => g_);
$parcel$export(module.exports, "setCustomFont", () => wu);
$parcel$export(module.exports, "setCustomFontMedia", () => Rr);
$parcel$export(module.exports, "setEach", () => rd);
$parcel$export(module.exports, "setFont", () => Wu);
$parcel$export(module.exports, "setFontFamily", () => lc);
$parcel$export(module.exports, "setFontImport", () => ec);
$parcel$export(module.exports, "setGradient", () => sc);
$parcel$export(module.exports, "setHashedExtend", () => xh);
$parcel$export(module.exports, "setInCustomFontMedia", () => em);
$parcel$export(module.exports, "setInObjectByPath", () => GS);
$parcel$export(module.exports, "setLang", () => Pp);
$parcel$export(module.exports, "setLocalStorage", () => uw);
$parcel$export(module.exports, "setMediaTheme", () => cc);
$parcel$export(module.exports, "setNodeStyles", () => bg);
$parcel$export(module.exports, "setObserver", () => Rl);
$parcel$export(module.exports, "setProps", () => wx);
$parcel$export(module.exports, "setPropsPrototype", () => pf);
$parcel$export(module.exports, "setSVG", () => fc);
$parcel$export(module.exports, "setScalingVar", () => vu);
$parcel$export(module.exports, "setShadow", () => $r);
$parcel$export(module.exports, "setSubScalingVar", () => fm);
$parcel$export(module.exports, "setSvgIcon", () => mi);
$parcel$export(module.exports, "setTheme", () => zu);
$parcel$export(module.exports, "setValue", () => C0);
$parcel$export(module.exports, "setVariables", () => f0);
$parcel$export(module.exports, "setWasmEngine", () => ld);
$parcel$export(module.exports, "settled", () => eh);
$parcel$export(module.exports, "shadow", () => Vk);
$parcel$export(module.exports, "shadowedComponentsOf", () => Eh);
$parcel$export(module.exports, "shape", () => o0);
$parcel$export(module.exports, "sharedLibrary", () => Qx);
$parcel$export(module.exports, "sharedLibraryBagEntry", () => qs);
$parcel$export(module.exports, "sharedLibraryDependencies", () => rk);
$parcel$export(module.exports, "sharedLibraryFiles", () => Gs);
$parcel$export(module.exports, "sizes", () => n0);
$parcel$export(module.exports, "skinLiteralBlocks", () => Vu);
$parcel$export(module.exports, "skins", () => r0);
$parcel$export(module.exports, "sortByTier", () => J0);
$parcel$export(module.exports, "spacing", () => $k);
$parcel$export(module.exports, "splitCompoundWords", () => yu);
$parcel$export(module.exports, "splitPackageSpecifier", () => Vf);
$parcel$export(module.exports, "splitSelectorList", () => Zo);
$parcel$export(module.exports, "splitSpacedValue", () => $u);
$parcel$export(module.exports, "splitTopLevelCommas", () => Nn);
$parcel$export(module.exports, "splitTopLevelSpaces", () => at);
$parcel$export(module.exports, "splitTransition", () => Am);
$parcel$export(module.exports, "spotByPath", () => Of);
$parcel$export(module.exports, "srcsetFor", () => Ga);
$parcel$export(module.exports, "srgbChannelToLinear", () => Xg);
$parcel$export(module.exports, "srgbToOklab", () => _u);
$parcel$export(module.exports, "stringIncludesAny", () => Ul);
$parcel$export(module.exports, "stringToObject", () => $S);
$parcel$export(module.exports, "stripVersionRangePrefix", () => zf);
$parcel$export(module.exports, "svg", () => Xk);
$parcel$export(module.exports, "svgData", () => om);
$parcel$export(module.exports, "svg_data", () => Zk);
$parcel$export(module.exports, "swapItemsInArray", () => rS);
$parcel$export(module.exports, "syncProps", () => gf);
$parcel$export(module.exports, "templates", () => Qk);
$parcel$export(module.exports, "theme", () => Hk);
$parcel$export(module.exports, "themeColorKey", () => Qs);
$parcel$export(module.exports, "tierOfStyle", () => Q0);
$parcel$export(module.exports, "timing", () => Kk);
$parcel$export(module.exports, "toCamel", () => Eu);
$parcel$export(module.exports, "toCamelCase", () => Bo);
$parcel$export(module.exports, "toDashCase", () => pu);
$parcel$export(module.exports, "toDescriptionCase", () => Sk);
$parcel$export(module.exports, "toLinearChannel", () => qa);
$parcel$export(module.exports, "toPriorityOrder", () => en);
$parcel$export(module.exports, "toTitleCase", () => bk);
$parcel$export(module.exports, "toggleFullscreen", () => Nx);
$parcel$export(module.exports, "transformBackgroundImage", () => km);
$parcel$export(module.exports, "transformBorder", () => Sm);
$parcel$export(module.exports, "transformBorderRadius", () => Go);
$parcel$export(module.exports, "transformBoxShadow", () => td);
$parcel$export(module.exports, "transformClassname", () => RP);
$parcel$export(module.exports, "transformDuration", () => od);
$parcel$export(module.exports, "transformGridTemplate", () => Em);
$parcel$export(module.exports, "transformShadow", () => xm);
$parcel$export(module.exports, "transformSize", () => It);
$parcel$export(module.exports, "transformSizeRatio", () => $);
$parcel$export(module.exports, "transformTextStroke", () => wm);
$parcel$export(module.exports, "transformTilingValue", () => _i);
$parcel$export(module.exports, "transformTransition", () => O0);
$parcel$export(module.exports, "transformersByPrefix", () => OT);
$parcel$export(module.exports, "transfromGap", () => Tm);
$parcel$export(module.exports, "translate", () => Lp);
$parcel$export(module.exports, "triggerEventOn", () => Io);
$parcel$export(module.exports, "triggerEventOnUpdate", () => hx);
$parcel$export(module.exports, "trimStringFromSymbols", () => wS);
$parcel$export(module.exports, "typography", () => xu);
$parcel$export(module.exports, "unit", () => Pk);
$parcel$export(module.exports, "unstackArrayOfObjects", () => Ml);
$parcel$export(module.exports, "untrack", () => hs);
$parcel$export(module.exports, "update", () => Lc);
$parcel$export(module.exports, "updateProps", () => vw);
$parcel$export(module.exports, "updateVars", () => DY);
$parcel$export(module.exports, "upsertTranslation", () => Ip);
$parcel$export(module.exports, "useCssInProps", () => ne);
$parcel$export(module.exports, "useHostState", () => UT);
$parcel$export(module.exports, "usePropsAsCSS", () => vP);
$parcel$export(module.exports, "useSelectorsAsCSS", () => CP);
$parcel$export(module.exports, "variables", () => $f);
$parcel$export(module.exports, "vars", () => e0);
$parcel$export(module.exports, "verbose", () => Pa);
$parcel$export(module.exports, "viewTransition", () => s0);
$parcel$export(module.exports, "warn", () => Bf);
$parcel$export(module.exports, "warnLibraryAliasCollision", () => Wa);
$parcel$export(module.exports, "warnStateKeyShadowsMethod", () => rh);
$parcel$export(module.exports, "window", () => R);
$parcel$export(module.exports, "withPolyglotTranslations", () => $l);
$parcel$export(module.exports, "workerNameFromPath", () => Dx);
$parcel$export(module.exports, "workerScriptPath", () => Rx);
$parcel$export(module.exports, "wrapHoverRule", () => Xo);
var O4 = Object.defineProperty;
var F = (t, e)=>{
    for(var n in e)O4(t, n, {
        get: e[n],
        enumerable: !0
    });
    return t;
};
var KC = /*@__PURE__*/ F({}, {
    ANIMATION_PROPS: ()=>dT,
    ARIA_ROLES: ()=>eK,
    ATTR_TRANSFORMS: ()=>zr,
    BARE_SEQUENCE_TOKEN_RE: ()=>$n,
    BLOCK_PROPS: ()=>pT,
    BREAKPOINTS_CONTAINER_NAME: ()=>SP,
    BREAKPOINT_PROPS: ()=>wT,
    BRENDER_LAZY_META: ()=>Ng,
    BRENDER_REGISTRY_BLOCK: ()=>ru,
    BRENDER_REGISTRY_TREE_BLOCK: ()=>su,
    BRENDER_STAMP_META: ()=>Bg,
    CDN_PROVIDERS: ()=>cn,
    COMPOUND_CSS_KEYWORDS: ()=>ei,
    CONFIG: ()=>si,
    CONFIG_MERGE_EXL: ()=>ue,
    CSS_LONGHAND_SHORTHANDS: ()=>gn,
    CSS_NAMED_COLOR_HEX: ()=>Ya,
    CSS_NATIVE_COLOR_REGEX: ()=>Fo,
    CSS_PROPS_REGISTRY: ()=>St,
    CSS_PROP_WRITES: ()=>xT,
    CSS_SHORTHAND_LONGHANDS: ()=>kt,
    CSS_UNITS: ()=>ga,
    DEFAULT_CONFIG: ()=>Ni,
    DEFAULT_CSS_PROPERTIES_LIST: ()=>Ft,
    DELEGATED_EVENTS: ()=>kc,
    DESIGN_SYSTEM_BLOCK: ()=>lu,
    DESIGN_SYSTEM_DEFERRED: ()=>cu,
    DESIGN_SYSTEM_LINK: ()=>au,
    DESIGN_SYSTEM_OPTIONS: ()=>aC,
    DIALOG_COPY: ()=>rp,
    DOMQL_EVENTS: ()=>RS,
    DOMQ_PROPERTIES: ()=>pr,
    DOM_EVENTS: ()=>cI,
    ELEMENT_METHOD_OVERRIDE_POINTS: ()=>wa,
    ENV: ()=>QS,
    FACTORY: ()=>Ve,
    FLEX_PROPS: ()=>_T,
    FONT_PROPS: ()=>hT,
    GRID_PROPS: ()=>bT,
    HOST_FORCED_ATTR: ()=>uu,
    HOST_FORCED_ROBOTS: ()=>dk,
    HOST_FORCED_VALUE: ()=>du,
    HOST_PACKAGE_ERROR_CODES: ()=>In,
    HOST_PACKAGE_LOADER_KEY: ()=>Fa,
    HOST_PACKAGE_PATH_BASE: ()=>Eg,
    HOST_REGISTERED_PACKAGES: ()=>$p,
    HOST_SOURCES_GLOBAL: ()=>Tr,
    HOST_SOURCES_TAG_ATTR: ()=>Ag,
    HTML_ATTRIBUTES: ()=>tr,
    HTML_TAGS: ()=>Ta,
    LAZY_HOST_IMPORT_FORMS: ()=>Na,
    LIBRARY_PACKAGES: ()=>Ig,
    LIBRARY_SCOPES_KEY: ()=>Vs,
    LIFECYCLE_EVENTS: ()=>uo,
    LIVE_KEYS: ()=>R0,
    METHODS: ()=>gr,
    METHODS_EXL: ()=>Vl,
    MISC_PROPS: ()=>gT,
    MIXINS: ()=>Hm,
    NODE_ENV: ()=>Rn,
    OPTIONS: ()=>Af,
    PACKAGE_MANAGER_TO_CDN: ()=>Er,
    PARSED_DOMQ_PROPERTIES: ()=>Hl,
    POLYGLOT_LANG_STORAGE_KEY: ()=>lh,
    POLYGLOT_TRANSLATIONS_FROM_LANG: ()=>_S,
    POSITION_PROPS: ()=>mT,
    PREPARED_FORMAT: ()=>gc,
    PRERENDER_REGISTRY_FORMATS: ()=>mC,
    PROPS_METHODS: ()=>hr,
    PROTOTYPE_KEYS: ()=>je,
    REGISTRY: ()=>Kt,
    RESERVED_STORE_METHODS: ()=>eR,
    REVIVED_MARK: ()=>Yl,
    ROUTER_OPTIONS: ()=>bb,
    ROUTE_HEAD_KEYS: ()=>Mg,
    SHADOWED_COMPONENTS: ()=>Ea,
    SIGNAL_ENGINE_KEY: ()=>pa,
    SIGNAL_INSTANCES_KEY: ()=>ua,
    SMBLS_PATH_PREFIX: ()=>Ba,
    STANDARD_SCHEME_QUERIES: ()=>pm,
    STATE_DATA_MERGE_EXL: ()=>Yh,
    STATE_PROPERTIES: ()=>OS,
    STORE_METHOD_NAMES: ()=>tR,
    SVG_TAGS: ()=>Rc,
    THEME_PROPS: ()=>yT,
    TILING_POSITION_KEYWORDS: ()=>nd,
    TILING_SIZE_KEYWORDS: ()=>ed,
    TIMING_PROPS: ()=>yd,
    TYPES: ()=>Il,
    UNIVERSAL_RESERVED_KEYS: ()=>xg,
    VALUE_TRANSFORMERS: ()=>vm,
    VERSION: ()=>Y1,
    WORKER_SCRIPT_BASE: ()=>Ma,
    WORKER_SCRIPT_NAME: ()=>Tg,
    __resetBuiltinMethodWarnings: ()=>Jx,
    __resetSignalEngine: ()=>Xb,
    __resetSignalInstances: ()=>Yb,
    __resetSkinWarnings: ()=>_0,
    __resetStateShadowWarnings: ()=>nR,
    activateConfig: ()=>BL,
    addCaching: ()=>Vh,
    addContext: ()=>Hh,
    addDelegatedEvent: ()=>pd,
    addExtend: ()=>yw,
    addExtends: ()=>eo,
    addItemAfterEveryElement: ()=>cS,
    addMethods: ()=>Ic,
    addProtoToArray: ()=>Nl,
    addRef: ()=>$h,
    adoptPrepared: ()=>Iv,
    aliasCaseVariants: ()=>oc,
    alternateLinkKey: ()=>Zs,
    animation: ()=>Yk,
    appendSVGSprite: ()=>Qu,
    appendSvgIconsSprite: ()=>yi,
    applyAttrTransforms: ()=>GT,
    applyCSS: ()=>Bv,
    applyDependentState: ()=>Iw,
    applyDocument: ()=>Zu,
    applyEvent: ()=>gg,
    applyEventUpdate: ()=>mg,
    applyExtends: ()=>vc,
    applyHeadings: ()=>bm,
    applyInitialState: ()=>cy,
    applyMediaSequenceVars: ()=>Pr,
    applyProps: ()=>ff,
    applyReset: ()=>Ju,
    applySequenceGlobalVars: ()=>Pu,
    applySequenceVars: ()=>zo,
    applySkins: ()=>Hu,
    applySpacingSequence: ()=>Fu,
    applyStateMethods: ()=>Le,
    applyThemeRoot: ()=>sd,
    applyTimingSequence: ()=>Xu,
    applyTrueProps: ()=>vT,
    applyTypographySequence: ()=>Gu,
    arrayContainsOtherArray: ()=>eS,
    arraysEqual: ()=>fS,
    arrayzeValue: ()=>Js,
    assertEmitIntegrity: ()=>q0,
    atSchemes: ()=>Br,
    bareLibraryKey: ()=>Kf,
    batch: ()=>th,
    bindLibraryGlobalScopes: ()=>qf,
    breakpoints: ()=>Gk,
    breakpointsContainerName: ()=>Ac,
    brenderLazyMeta: ()=>fk,
    brenderStampMeta: ()=>lk,
    buildImgSrcset: ()=>gu,
    buildSkinVarStyles: ()=>gi,
    buildSourcesAndImg: ()=>mu,
    buildThemeVarStyles: ()=>m_,
    cache: ()=>gx,
    cacheNode: ()=>Hr,
    call: ()=>Ax,
    callStateMethod: ()=>kd,
    camelToAttr: ()=>er,
    camelToLowerAttr: ()=>dI,
    captureSnapshot: ()=>Ox,
    changeGlobalTheme: ()=>Om,
    changeLightness: ()=>Ck,
    checkAttributeByTagName: ()=>qe,
    checkEventFunctions: ()=>KT,
    checkForStateTypes: ()=>Rw,
    checkIfBoxSize: ()=>Nu,
    checkIfInherits: ()=>qh,
    checkIfStringIsInArray: ()=>pS,
    class: ()=>t0,
    classifyHostPackageReads: ()=>Mx,
    clone: ()=>NS,
    cloneAndMergeArrayExtend: ()=>tf,
    cloneFunction: ()=>mS,
    collectExtendsList: ()=>Lo,
    color: ()=>jk,
    colorPairSchemes: ()=>Bu,
    colorStringToRgbaArray: ()=>ln,
    components: ()=>il,
    compositeOverBackdrop: ()=>oi,
    compoundLayers: ()=>Za,
    concatAddExtends: ()=>hw,
    containerBreakpointQuery: ()=>ST,
    contrastRatio: ()=>Ja,
    convertSvgToSymbol: ()=>Mu,
    copyJavaScriptToClipboard: ()=>yk,
    copyStringToClipboard: ()=>mk,
    countUntrackedReads: ()=>nh,
    create: ()=>UC,
    createAsync: ()=>att,
    createBasedOnType: ()=>Fh,
    createComputed: ()=>QC,
    createConfig: ()=>Au,
    createDefine: ()=>zU,
    createDomqlElement: ()=>Fp,
    createEffect: ()=>q,
    createElement: ()=>Cw,
    createElementExtends: ()=>vh,
    createExtends: ()=>nf,
    createExtendsFromKeys: ()=>Aa,
    createExtendsStack: ()=>Dh,
    createHTMLNode: ()=>Cc,
    createIfConditionFlag: ()=>ow,
    createInheritedState: ()=>Dw,
    createKey: ()=>Jl,
    createNestedObject: ()=>WS,
    createNestedObjectByKeyPath: ()=>Pw,
    createObjectWithoutPrototype: ()=>bh,
    createParent: ()=>jh,
    createPath: ()=>Uh,
    createPristineConfig: ()=>lm,
    createProps: ()=>uf,
    createPropsStack: ()=>Bh,
    createPrunedLibraryIconLoader: ()=>Hg,
    createRoot: ()=>Ow,
    createScope: ()=>Bw,
    createScopeStore: ()=>oh,
    createSignal: ()=>On,
    createSkeleton: ()=>ltt,
    createSnapshotId: ()=>Ql,
    createState: ()=>jT,
    createStore: ()=>vo,
    createSync: ()=>ctt,
    css: ()=>Ke,
    cssCamelName: ()=>fd,
    cssMediaVars: ()=>am,
    cssPropName: ()=>Re,
    cssShorthandDepth: ()=>mc,
    cssShorthandStatesLonghand: ()=>yc,
    cssShorthandStatesThemeLonghand: ()=>id,
    cssVars: ()=>im,
    currentPathname: ()=>bs,
    customDecodeURIComponent: ()=>vS,
    customEncodeURIComponent: ()=>AS,
    cutArrayAfterValue: ()=>iS,
    cutArrayBeforeValue: ()=>sS,
    debounce: ()=>Fl,
    debounceOnContext: ()=>hS,
    decodeBrenderRegistry: ()=>iu,
    decodeNewlines: ()=>ES,
    deepClone: ()=>ft,
    deepContains: ()=>VS,
    deepDefaults: ()=>Va,
    deepDestringifyFunctions: ()=>xe,
    deepExtend: ()=>Th,
    deepMerge: ()=>mt,
    deepMergeExtends: ()=>no,
    deepStringifyFunctions: ()=>Wl,
    defaultDefine: ()=>ia,
    defineResolvedThemeSignal: ()=>Lr,
    defineSetter: ()=>Tx,
    defineThemeSignal: ()=>Dr,
    designSystemBlock: ()=>ck,
    designSystemLink: ()=>ak,
    destringifyGlobalScope: ()=>vs,
    destroy: ()=>ra,
    detectHeightOnInit: ()=>jx,
    detectInfiniteLoop: ()=>YS,
    detectTag: ()=>Hn,
    devices: ()=>qk,
    dispose: ()=>Sn,
    effectiveGlobalTheme: ()=>y_,
    elementPath: ()=>an,
    encodeNewlines: ()=>TS,
    error: ()=>js,
    escapeHtml: ()=>H,
    escapeRegExp: ()=>SS,
    evaluateText: ()=>Pn,
    excludeKeysFromObject: ()=>ZS,
    exec: ()=>bt,
    executeAttr: ()=>fK,
    exetuteClassPerComponent: ()=>D9,
    exposeBagGlobalScopes: ()=>Yf,
    extendCachedRegistry: ()=>gw,
    extendStackRegistry: ()=>of,
    extractArrayExtend: ()=>sf,
    extractConditionalAttrs: ()=>qT,
    faviconLinkKey: ()=>Or,
    fetchLibraryData: ()=>Ys,
    fibonacciNumberByIndex: ()=>Ux,
    fileEntryUrl: ()=>Fg,
    filterArrays: ()=>uS,
    filterArraysFast: ()=>dS,
    filterAttributesByTagName: ()=>lK,
    finalizeExtends: ()=>Lh,
    findClosestNumber: ()=>$g,
    findClosestNumberInFactory: ()=>gk,
    findHeadingLetter: ()=>um,
    findHeadings: ()=>Lu,
    findInheritedState: ()=>Gh,
    findKeyPosition: ()=>xS,
    flattenExtend: ()=>va,
    font: ()=>Ik,
    fontFace: ()=>Nk,
    fontFamily: ()=>Mk,
    fontFamilyTypes: ()=>Bk,
    forcedScheme: ()=>di,
    formatDate: ()=>$x,
    generateHash: ()=>wh,
    generateHeadArrayTags: ()=>Ka,
    generateKey: ()=>Zl,
    generateMetaTags: ()=>pk,
    generateSequence: ()=>Ee,
    generateSequencePosition: ()=>l0,
    generateSprite: ()=>Iu,
    generateSubSequence: ()=>Ru,
    get: ()=>Sx,
    getActiveConfig: ()=>L,
    getActiveDocument: ()=>fo,
    getActiveLang: ()=>fs,
    getCDNDirUrl: ()=>Og,
    getCDNUrl: ()=>Mn,
    getCacheSize: ()=>eT,
    getCapitalCaseKeys: ()=>bw,
    getCdnProviderFromConfig: ()=>Ua,
    getChildStateInKey: ()=>Kh,
    getChildren: ()=>kx,
    getColor: ()=>ct,
    getColorShade: ()=>Gg,
    getContext: ()=>Mf,
    getCookie: ()=>cw,
    getDB: ()=>jf,
    getDefaultOrFirstKey: ()=>jo,
    getEmitStats: ()=>jm,
    getEmotionStylesheet: ()=>kk,
    getExtendsInElement: ()=>_w,
    getExtendsStack: ()=>ef,
    getExtendsStackRegistry: ()=>kh,
    getFnPrefixAndValue: ()=>Vo,
    getFontFace: ()=>Dk,
    getFontFaceEach: ()=>ri,
    getFontFaceEachString: ()=>nm,
    getFontFaceString: ()=>Lk,
    getFontFamily: ()=>Ku,
    getFontFormat: ()=>tm,
    getFontSizeByKey: ()=>qu,
    getFrequencyInArray: ()=>nS,
    getFunctionSource: ()=>Ue,
    getHashedExtend: ()=>rf,
    getImportMapScript: ()=>Fx,
    getInObjectByPath: ()=>qS,
    getLanguages: ()=>Dp,
    getLocalStateLang: ()=>Mp,
    getLocalStorage: ()=>fw,
    getMediaBorder: ()=>Uu,
    getMediaColor: ()=>Wt,
    getMediaTheme: ()=>hn,
    getNev: ()=>nw,
    getObserver: ()=>$e,
    getPageMetadata: ()=>hk,
    getParentStateInKey: ()=>Wh,
    getPath: ()=>Cf,
    getPendingLang: ()=>Rp,
    getQuery: ()=>Uf,
    getRef: ()=>xx,
    getResolvedThemeSignal: ()=>ML,
    getRgbTone: ()=>Fn,
    getRoot: ()=>Lf,
    getRootContext: ()=>If,
    getRootData: ()=>Pf,
    getRootState: ()=>Df,
    getRootStateInKey: ()=>zh,
    getSafeInk: ()=>mm,
    getSafeInkInfo: ()=>g0,
    getSequenceValue: ()=>ii,
    getSequenceValueBySymbols: ()=>Du,
    getSequenceValuePropertyPair: ()=>lo,
    getShadow: ()=>ju,
    getShapeByKey: ()=>Yu,
    getSignals: ()=>JC,
    getSizeValue: ()=>rc,
    getSpacingBasedOnRatio: ()=>ze,
    getSpacingByKey: ()=>Ut,
    getSpreadChildren: ()=>Sw,
    getSubratio: ()=>Cu,
    getSubratioDifference: ()=>Ou,
    getSystemGlobalTheme: ()=>he,
    getTheme: ()=>x0,
    getThemeSignal: ()=>IL,
    getTimingByKey: ()=>Ae,
    getTimingFunction: ()=>We,
    global: ()=>Qb,
    gradient: ()=>Uk,
    grid: ()=>Jk,
    hasFunction: ()=>ie,
    hasHandlerPlugin: ()=>_a,
    hasOwnProperty: ()=>jS,
    hashContent: ()=>Bn,
    hexToRgb: ()=>Ek,
    hexToRgbArray: ()=>Vg,
    hexToRgba: ()=>vk,
    hostPackageAssetPath: ()=>Lx,
    hostPackageSourcesScript: ()=>vg,
    hostPackageSourcesTag: ()=>Bx,
    hslToRgb: ()=>Kg,
    icons: ()=>zk,
    importHostPackage: ()=>vb,
    inForcedColors: ()=>ai,
    inheritChildExtends: ()=>Ch,
    inheritChildPropsExtends: ()=>Oh,
    inheritParentProps: ()=>df,
    inheritRecursiveChildExtends: ()=>Rh,
    init: ()=>To,
    initPolyglot: ()=>Tb,
    initProps: ()=>Aw,
    injectGlobal: ()=>Lt,
    insertAfterImportMap: ()=>uk,
    installPrunedLibraryIconLoader: ()=>hu,
    is: ()=>Se,
    isArray: ()=>B,
    isBoolean: ()=>sh,
    isBuiltinElementMethod: ()=>CS,
    isCSSVar: ()=>Nt,
    isContextComponent: ()=>ww,
    isCyclic: ()=>XS,
    isDOMNode: ()=>_e,
    isDate: ()=>ah,
    isDefined: ()=>jt,
    isDevelopment: ()=>yr,
    isDomDocument: ()=>Oo,
    isEmpty: ()=>yh,
    isEmptyObject: ()=>US,
    isEnumeratedTrueFalseAttr: ()=>vi,
    isEqualDeep: ()=>_h,
    isFailedRevival: ()=>Es,
    isForcedColorsQuery: ()=>ci,
    isFunction: ()=>P,
    isGoogleFontsUrl: ()=>tc,
    isHostObject: ()=>Co,
    isHostPackageSpecifier: ()=>Hf,
    isHtmlElement: ()=>Pl,
    isInertCompoundValue: ()=>Yg,
    isIntendedSystemColorWord: ()=>li,
    isLazyFunction: ()=>FS,
    isLocal: ()=>ew,
    isLoudDevRuntime: ()=>et,
    isMalformedDependency: ()=>Us,
    isMethod: ()=>vx,
    isMobile: ()=>iw,
    isNativeColorToken: ()=>ni,
    isNode: ()=>Ro,
    isNot: ()=>tS,
    isNotProduction: ()=>Do,
    isNull: ()=>ih,
    isNumber: ()=>be,
    isObject: ()=>k,
    isObjectLike: ()=>z,
    isPhoto: ()=>Hx,
    isPlainColor: ()=>Mr,
    isPolyglotRetranslatableKey: ()=>mf,
    isPolyglotWritableKey: ()=>Cs,
    isProduction: ()=>mr,
    isProtectedElementMethod: ()=>xs,
    isRawUnitValue: ()=>Ll,
    isResolvedColor: ()=>fn,
    isRevived: ()=>As,
    isSameRoutePage: ()=>nu,
    isScalingUnit: ()=>gs,
    isStaging: ()=>tw,
    isState: ()=>Lw,
    isStore: ()=>xt,
    isString: ()=>E,
    isStringFunction: ()=>ur,
    isStringTag: ()=>ql,
    isSvgTag: ()=>Un,
    isTest: ()=>Sh,
    isTesting: ()=>JS,
    isTracking: ()=>HT,
    isUndefined: ()=>Xt,
    isUniversallyReservedKey: ()=>Cx,
    isUnresolvableDependency: ()=>Ar,
    isValidDependencyMap: ()=>Hs,
    isValidHtmlTag: ()=>dw,
    isValidTag: ()=>Oc,
    isWasmLoaded: ()=>L2,
    isWrappedLibrary: ()=>ke,
    isWritableFamilyBucket: ()=>Zb,
    joinArrays: ()=>ma,
    joinCompoundLayers: ()=>Qa,
    jointStacks: ()=>mw,
    jsonForScript: ()=>Ls,
    keyframes: ()=>xc,
    keys: ()=>Sg,
    lazyHostImportExpr: ()=>Ix,
    libraryIconPruneReplacer: ()=>xk,
    libraryIdentifier: ()=>jg,
    libraryPackageSpecs: ()=>Ks,
    librarySpecsFor: ()=>Pg,
    linearChannelToSrgb: ()=>Zg,
    literalPairCompound: ()=>pi,
    literalSchemeMap: ()=>Ko,
    loadCssFile: ()=>Kx,
    loadJavascript: ()=>Gx,
    loadJavascriptFile: ()=>Vx,
    loadJavascriptFileEmbedSync: ()=>Wx,
    loadJavascriptFileSync: ()=>zx,
    loadRemoteCSS: ()=>qx,
    loadRemoteScript: ()=>Ha,
    loadTranslations: ()=>la,
    loadWasm: ()=>D2,
    log: ()=>Ex,
    logGroupIf: ()=>sw,
    logIf: ()=>rw,
    lookdown: ()=>_x,
    lookdownAll: ()=>bx,
    lookup: ()=>yx,
    lowercaseFirstLetter: ()=>Ss,
    makeObjectWithoutPrototype: ()=>HS,
    map: ()=>BS,
    mapStringsWithContextComponents: ()=>cf,
    markPolyglotSeeded: ()=>ro,
    markRevived: ()=>ka,
    markTextNotReady: ()=>Ia,
    matchesComponentNaming: ()=>oo,
    media: ()=>Fk,
    memoize: ()=>gS,
    merge: ()=>Dt,
    mergeSharedLibraries: ()=>Zf,
    mergeSharedLibraryDesignSystems: ()=>Qf,
    mergeSharedLibraryTranslations: ()=>Jf,
    mergeStateData: ()=>_r,
    mixTwoColors: ()=>Tk,
    mixTwoRgb: ()=>Ok,
    mixTwoRgba: ()=>qg,
    nextElement: ()=>Nf,
    normalizeIgnoreList: ()=>za,
    normalizeLibraryKey: ()=>zs,
    numToLetterMap: ()=>dn,
    objectToString: ()=>Kl,
    objectizeStringProperty: ()=>lf,
    oklabToLinearSrgb: ()=>Qg,
    oklabToOklch: ()=>bu,
    oklchToGamutSafeSrgb: ()=>Su,
    oklchToOklab: ()=>Jg,
    opacify: ()=>Xa,
    overwrite: ()=>Xl,
    overwriteDeep: ()=>le,
    overwriteShallow: ()=>Os,
    overwriteState: ()=>Mw,
    parkHostObject: ()=>fr,
    parse: ()=>wg,
    parseColorToken: ()=>ee,
    parseDeep: ()=>vf,
    payloadHasComputedIconName: ()=>Ug,
    pickStartLang: ()=>ph,
    pickupElementFromProps: ()=>Ih,
    pickupPropsFromElement: ()=>Ph,
    planLibraryIconPrune: ()=>wk,
    polyglotAddressLang: ()=>uh,
    polyglotDefaultLang: ()=>fh,
    polyglotEarlyStartLang: ()=>ys,
    polyglotFallbackLang: ()=>te,
    polyglotFunctions: ()=>Bp,
    polyglotLangStorageKey: ()=>Sa,
    polyglotLanguages: ()=>we,
    polyglotPlugin: ()=>wl,
    polyglotSeededKeys: ()=>br,
    polyglotStartLang: ()=>_s,
    polyglotStartRule: ()=>dh,
    polyglotStartupScript: ()=>bS,
    polyglotTranslations: ()=>dr,
    popConfig: ()=>ut,
    popStaticCssPass: ()=>Jm,
    prepareContext: ()=>$C,
    previousElement: ()=>Ff,
    promoteActiveRootState: ()=>La,
    propExists: ()=>Tw,
    propertizeElement: ()=>Mh,
    propertizeUpdate: ()=>kw,
    pushConfig: ()=>pt,
    pushStaticCssPass: ()=>Qm,
    quietColorProbe: ()=>fi,
    quietSequenceProbe: ()=>Ho,
    readBrenderLazyGroups: ()=>fu,
    readBrenderStamp: ()=>Ps,
    readJsonDataBlock: ()=>io,
    recordRules: ()=>ud,
    recordShadowedComponent: ()=>af,
    refreshContextProto: ()=>Mc,
    registerEvent: ()=>Tc,
    registerHostPackages: ()=>jp,
    registerSignalInstance: ()=>da,
    reinit: ()=>Mv,
    relativeLuminance: ()=>ti,
    remove: ()=>Pc,
    removeChars: ()=>_k,
    removeCookie: ()=>lw,
    removeDelegatedEvent: ()=>hd,
    removeDuplicateProps: ()=>hf,
    removeDuplicatesInArray: ()=>ya,
    removeFromArray: ()=>oS,
    removeFromObject: ()=>zS,
    removeNestedKeyByPath: ()=>KS,
    removeValueFromArray: ()=>Bl,
    removeValueFromArrayAll: ()=>aS,
    reorderArrayByValues: ()=>lS,
    repairLegacyArrowScopePreamble: ()=>zl,
    replaceLiteralsWithObjectFields: ()=>Zt,
    replaceOctalEscapeSequences: ()=>kS,
    replayRules: ()=>dd,
    resetEmitStats: ()=>G0,
    resolveAsset: ()=>Te,
    resolveBorderValue: ()=>de,
    resolveColorRgb: ()=>ui,
    resolveColorsInGradient: ()=>Fr,
    resolveComponentTier: ()=>Ah,
    resolveCompoundWords: ()=>$o,
    resolveConfigDocument: ()=>ha,
    resolveDesignSystemClass: ()=>OP,
    resolveDialogCopy: ()=>ce,
    resolveFileReferences: ()=>Cr,
    resolveFileSource: ()=>WT,
    resolveFileUrl: ()=>un,
    resolveGridTracks: ()=>bP,
    resolveHandler: ()=>ba,
    resolvePolyglotTranslations: ()=>ms,
    resolvePropValue: ()=>Vr,
    resolveRouterHref: ()=>ly,
    resolveShadowNonColorWord: ()=>ic,
    resolveShadowValue: ()=>hi,
    resolveSharedLibraries: ()=>tu,
    resolveStyleBlockTokens: ()=>CT,
    returnSubThemeOrDefault: ()=>Rk,
    returnValueAsText: ()=>Nh,
    reviveConfig: ()=>Dm,
    rgbArrayToHex: ()=>zg,
    rgbToHSL: ()=>Wg,
    rgbToHex: ()=>Ak,
    routeEntryMetadata: ()=>Mo,
    routeEntryPage: ()=>eu,
    runPluginHook: ()=>Cn,
    runThroughMedia: ()=>_m,
    runtimeProvidesHostPackageLoader: ()=>Px,
    schemeGuardSelector: ()=>gm,
    schemeMediaQuery: ()=>hm,
    scopeElementParam: ()=>hh,
    scopeReceiverExpression: ()=>IS,
    scratchDefaultConfig: ()=>nc,
    scratchSystem: ()=>uc,
    scratchUtils: ()=>Ir,
    self: ()=>Jb,
    semanticIcons: ()=>Wk,
    sequence: ()=>Uo,
    serializeAttrValue: ()=>mo,
    serializeConfig: ()=>Rm,
    servedSharedLibraries: ()=>sk,
    set: ()=>bi,
    setActiveConfig: ()=>cm,
    setActiveDocument: ()=>K0,
    setActiveRootState: ()=>Rf,
    setAdaptiveSchemeVar: ()=>Nr,
    setClass: ()=>LY,
    setClassname: ()=>L9,
    setColor: ()=>Wo,
    setCookie: ()=>aw,
    setCssEngineHook: ()=>g_,
    setCustomFont: ()=>wu,
    setCustomFontMedia: ()=>Rr,
    setEach: ()=>rd,
    setFont: ()=>Wu,
    setFontFamily: ()=>lc,
    setFontImport: ()=>ec,
    setGradient: ()=>sc,
    setHashedExtend: ()=>xh,
    setInCustomFontMedia: ()=>em,
    setInObjectByPath: ()=>GS,
    setLang: ()=>Pp,
    setLocalStorage: ()=>uw,
    setMediaTheme: ()=>cc,
    setNodeStyles: ()=>bg,
    setObserver: ()=>Rl,
    setProps: ()=>wx,
    setPropsPrototype: ()=>pf,
    setSVG: ()=>fc,
    setScalingVar: ()=>vu,
    setShadow: ()=>$r,
    setSubScalingVar: ()=>fm,
    setSvgIcon: ()=>mi,
    setTheme: ()=>zu,
    setValue: ()=>C0,
    setVariables: ()=>f0,
    setWasmEngine: ()=>ld,
    settled: ()=>eh,
    shadow: ()=>Vk,
    shadowedComponentsOf: ()=>Eh,
    shape: ()=>o0,
    sharedLibrary: ()=>Qx,
    sharedLibraryBagEntry: ()=>qs,
    sharedLibraryDependencies: ()=>rk,
    sharedLibraryFiles: ()=>Gs,
    sizes: ()=>n0,
    skinLiteralBlocks: ()=>Vu,
    skins: ()=>r0,
    sortByTier: ()=>J0,
    spacing: ()=>$k,
    splitCompoundWords: ()=>yu,
    splitPackageSpecifier: ()=>Vf,
    splitSelectorList: ()=>Zo,
    splitSpacedValue: ()=>$u,
    splitTopLevelCommas: ()=>Nn,
    splitTopLevelSpaces: ()=>at,
    splitTransition: ()=>Am,
    spotByPath: ()=>Of,
    srcsetFor: ()=>Ga,
    srgbChannelToLinear: ()=>Xg,
    srgbToOklab: ()=>_u,
    stringIncludesAny: ()=>Ul,
    stringToObject: ()=>$S,
    stripVersionRangePrefix: ()=>zf,
    svg: ()=>Xk,
    svgData: ()=>om,
    svg_data: ()=>Zk,
    swapItemsInArray: ()=>rS,
    syncProps: ()=>gf,
    templates: ()=>Qk,
    theme: ()=>Hk,
    themeColorKey: ()=>Qs,
    tierOfStyle: ()=>Q0,
    timing: ()=>Kk,
    toCamel: ()=>Eu,
    toCamelCase: ()=>Bo,
    toDashCase: ()=>pu,
    toDescriptionCase: ()=>Sk,
    toLinearChannel: ()=>qa,
    toPriorityOrder: ()=>en,
    toTitleCase: ()=>bk,
    toggleFullscreen: ()=>Nx,
    transformBackgroundImage: ()=>km,
    transformBorder: ()=>Sm,
    transformBorderRadius: ()=>Go,
    transformBoxShadow: ()=>td,
    transformClassname: ()=>RP,
    transformDuration: ()=>od,
    transformGridTemplate: ()=>Em,
    transformShadow: ()=>xm,
    transformSize: ()=>It,
    transformSizeRatio: ()=>$,
    transformTextStroke: ()=>wm,
    transformTilingValue: ()=>_i,
    transformTransition: ()=>O0,
    transformersByPrefix: ()=>OT,
    transfromGap: ()=>Tm,
    translate: ()=>Lp,
    triggerEventOn: ()=>Io,
    triggerEventOnUpdate: ()=>hx,
    trimStringFromSymbols: ()=>wS,
    typography: ()=>xu,
    unit: ()=>Pk,
    unstackArrayOfObjects: ()=>Ml,
    untrack: ()=>hs,
    update: ()=>Lc,
    updateProps: ()=>vw,
    updateVars: ()=>DY,
    upsertTranslation: ()=>Ip,
    useCssInProps: ()=>ne,
    useHostState: ()=>UT,
    usePropsAsCSS: ()=>vP,
    useSelectorsAsCSS: ()=>CP,
    variables: ()=>$f,
    vars: ()=>e0,
    verbose: ()=>Pa,
    viewTransition: ()=>s0,
    warn: ()=>Bf,
    warnLibraryAliasCollision: ()=>Wa,
    warnStateKeyShadowsMethod: ()=>rh,
    window: ()=>R,
    withPolyglotTranslations: ()=>$l,
    workerNameFromPath: ()=>Dx,
    workerScriptPath: ()=>Rx,
    wrapHoverRule: ()=>Xo
});
var Dl = /*@__PURE__*/ F({}, {
    RESERVED_STORE_METHODS: ()=>eR,
    SIGNAL_ENGINE_KEY: ()=>pa,
    SIGNAL_INSTANCES_KEY: ()=>ua,
    STORE_METHOD_NAMES: ()=>tR,
    VERSION: ()=>K4,
    __resetSignalEngine: ()=>Xb,
    __resetSignalInstances: ()=>Yb,
    __resetStateShadowWarnings: ()=>nR,
    batch: ()=>th,
    countUntrackedReads: ()=>nh,
    createComputed: ()=>QC,
    createEffect: ()=>q,
    createScopeStore: ()=>oh,
    createSignal: ()=>On,
    createStore: ()=>vo,
    getObserver: ()=>$e,
    getSignals: ()=>JC,
    isStore: ()=>xt,
    registerSignalInstance: ()=>da,
    setObserver: ()=>Rl,
    settled: ()=>eh,
    untrack: ()=>hs,
    warnStateKeyShadowsMethod: ()=>rh
});
var Hb = /*@__PURE__*/ F({}, {
    WRITE_JOURNAL: ()=>El,
    batch: ()=>Ol,
    countUntrackedReads: ()=>D4,
    createComputed: ()=>L4,
    createEffect: ()=>P4,
    createSignal: ()=>Jn,
    getObserver: ()=>$b,
    journalWrite: ()=>vl,
    noteUntrackedRead: ()=>Fe,
    setObserver: ()=>C4,
    settled: ()=>Ub,
    untrack: ()=>R4
});
var Jt = null, kl = 0, Tl = [], $b = ()=>Jt, C4 = (t)=>{
    Jt = t;
};
function R4(t) {
    let e = Jt;
    if (!e) return t();
    Jt = null;
    try {
        return t();
    } finally{
        Jt = e;
    }
}
var Mb = 0, Wp = 0;
function Fe() {
    Mb !== 0 && Wp++;
}
function D4(t) {
    let e = Wp;
    Mb++;
    let n;
    try {
        t();
    } finally{
        n = Wp - e, --Mb === 0 && (Wp = 0);
    }
    return n;
}
var Kp = 0, Bb = [];
function Jn(t) {
    let e = new Set;
    function n() {
        return Jt && (e.add(Jt), Jt._sources.add(s)), t;
    }
    function o(i) {
        i !== t && (t = i, j4(e));
    }
    function r() {
        return t;
    }
    let s = {
        get: n,
        set: o,
        peek: r,
        _subscribers: e,
        _type: "signal"
    };
    return s;
}
function L4(t) {
    let e, n = !0, o = new Set, r = {
        _sources: new Set,
        _type: "computed",
        _subscribers: o,
        _execute () {
            Fb(r);
            let s = Jt;
            Jt = r;
            try {
                e = t(), n = !1;
            } finally{
                Jt = s;
            }
        },
        _notify () {
            n = !0, o.size > 0 && XC(o);
        },
        get () {
            return Jt && (o.add(Jt), Jt._sources.add(r)), n && r._execute(), e;
        },
        peek () {
            return n && r._execute(), e;
        }
    };
    return r._execute(), r;
}
var tn = new Set, Gp = !1, El = [];
function vl(t) {
    El.push(t), El.length > 32 && El.shift();
}
function P4(t, e) {
    let n = e?.depth ?? 0, o = {
        _sources: new Set,
        _type: "effect",
        _depth: n,
        _label: e?.label,
        _disposed: !1,
        _subscribers: new Set,
        _execute () {
            if (o._disposed) return;
            Fb(o);
            let r = Jt;
            Jt = o;
            try {
                t();
            } catch (s) {
                console.error("[smbls] effect error:", s);
            } finally{
                Jt = r;
            }
        },
        _notify () {
            o._disposed || (kl > 0 ? Tl.push(o) : Kp > 0 ? Bb.push(o) : jb(o));
        },
        dispose () {
            o._disposed = !0, Fb(o);
        }
    };
    return o._execute(), o;
}
function Ol(t) {
    kl++;
    try {
        t();
    } finally{
        kl--, kl === 0 && $4();
    }
}
var qp = !1, GC = 1e3, I4 = 8, M4 = 256, B4 = 4;
function qC() {
    return typeof performance < "u" ? performance.now() : Date.now();
}
function jb(t) {
    tn.add(t), !qp && (Gp || (Gp = !0, queueMicrotask(YC)));
}
var fa = [];
function N4() {
    if (tn.size === 1) {
        let [e] = tn;
        return tn.clear(), e._disposed ? 0 : (e._execute(), 1);
    }
    fa.length = 0;
    for (let e of tn)fa.push(e);
    tn.clear(), fa.sort((e, n)=>e._depth - n._depth);
    let t = 0;
    for(let e = 0; e < fa.length; e++){
        let n = fa[e];
        n._disposed || (n._execute(), t++);
    }
    return fa.length = 0, t;
}
function YC(t = 0, e = 0) {
    if (Gp = !1, tn.size === 0) {
        Al.length && Nb();
        return;
    }
    qp = !0;
    let n = qC(), o = !1;
    try {
        for(; tn.size > 0;){
            if (++t > GC) {
                let r = new Map;
                for (let c of tn){
                    let l = c._label;
                    if (typeof l == "function") try {
                        l = l();
                    } catch  {
                        l = "<label error>";
                    }
                    if (l = l || "<unlabeled>", r.set(l, (r.get(l) || 0) + 1), r.size >= 12) break;
                }
                let s = [
                    ...r.entries()
                ].map(([c, l])=>l > 1 ? `${c} \xD7${l}` : c).join(", "), i = new Map;
                for (let c of El)i.set(c, (i.get(c) || 0) + 1);
                let a = [
                    ...i.entries()
                ].map(([c, l])=>l > 1 ? `${c} \xD7${l}` : c).join(", ");
                console.error("[smbls] reactive effect cascade exceeded", GC, "passes in a single flush \u2014 breaking to avoid hanging the thread.", "This usually means an effect (or an onUpdate/subscribeTo handler", "it calls into) unconditionally writes back a signal it depends on.", "Still queued at break (the loop participants):", s || "<queue empty>", "\u2014 last notifying store writes:", a || "<none recorded>"), tn.clear();
                break;
            }
            if (e += N4(), tn.size > 0 && (e >= M4 || t >= B4) && qC() - n > I4) {
                o = !0, setTimeout(()=>YC(t, e), 0);
                break;
            }
        }
    } finally{
        o || (qp = !1, Al.length && Nb());
    }
}
var Al = [];
function F4() {
    return tn.size === 0 && !Gp && !qp && Tl.length === 0 && kl === 0;
}
function Nb() {
    if (Al.length === 0 || !F4()) return;
    let t = Al.splice(0);
    for(let e = 0; e < t.length; e++)t[e]();
}
function Ub() {
    return new Promise((t)=>{
        Al.push(t), queueMicrotask(Nb);
    });
}
function $4() {
    for(let t = 0; t < Tl.length; t++)jb(Tl[t]);
    Tl.length = 0;
}
function XC(t) {
    Kp++;
    try {
        for (let e of t)e._notify();
    } finally{
        if (Kp--, Kp === 0 && Bb.length > 0) {
            let e = Bb.splice(0);
            for(let n = 0; n < e.length; n++)jb(e[n]);
        }
    }
}
function j4(t) {
    XC(t);
}
function Fb(t) {
    for (let e of t._sources)e._subscribers.delete(t);
    t._sources.clear();
}
var qb = /*@__PURE__*/ F({}, {
    RESERVED_STORE_METHODS: ()=>Cl,
    STORE_METHOD_NAMES: ()=>Gb,
    __resetStateShadowWarnings: ()=>U4,
    createScopeStore: ()=>W4,
    createStore: ()=>Xp,
    getSignals: ()=>z4,
    isStore: ()=>V4,
    warnStateKeyShadowsMethod: ()=>Kb
});
var vn = Symbol("store"), Zp = Symbol("signals"), Gb = [
    "update",
    "parse",
    "clean",
    "keys",
    "values",
    "replace",
    "add",
    "remove",
    "destroy",
    "quietUpdate"
], Cl = new Set(Gb), Wb = new Set, Vb = (t, e)=>t ? t + "." + e : String(e);
function Kb(t, e) {
    let n = (e || "") + "::" + t;
    if (Wb.has(n)) return;
    Wb.add(n);
    let o = e ? `state.${e}` : "state", r = `[smbls/state] "${t}" is a reserved store-method name and was written as DATA at ${o}.${t}. The value is preserved and readable \u2014 data wins over the method \u2014 but "${o}.${t}(\u2026)" no longer reaches the store method on this node. Use "${o}.$${t}(\u2026)" for the method, or rename the data key. Reserved: ${Gb.join(", ")}.`;
    typeof console < "u" && console.warn;
}
function U4() {
    Wb.clear();
}
var zb = (t)=>!t || typeof t != "object" || Array.isArray(t) || t[vn] || Object.isFrozen(t) || typeof Node < "u" && t instanceof Node || t.__ref || t.nodeType || t.nodeName || !Qp(t), H4 = 12, Qp = (t)=>{
    if (!t || typeof t != "object") return !1;
    let e = Object.getPrototypeOf(t);
    return e === Object.prototype || e === null;
};
function Jp(t, e, n) {
    if (t === e) return !0;
    if (n > H4) return !1;
    if (Array.isArray(t) || Array.isArray(e)) {
        if (!Array.isArray(t) || !Array.isArray(e) || t.length !== e.length) return !1;
        for(let o = 0; o < t.length; o++)if (!Jp(t[o], e[o], n + 1)) return !1;
        return !0;
    }
    if (Qp(t) && Qp(e)) {
        let o = Object.keys(t), r = Object.keys(e);
        if (o.length !== r.length) return !1;
        for (let s of o)if (!Object.prototype.hasOwnProperty.call(e, s) || !Jp(t[s], e[s], n + 1)) return !1;
        return !0;
    }
    return !1;
}
function Xp(t, e, n, o) {
    n === void 0 && (n = 0), o === void 0 && (o = "");
    let r = {}, s = {}, i = (w)=>Object.prototype.hasOwnProperty.call(r, w) && Object.prototype.hasOwnProperty.call(s, w), a = (w)=>{
        if (!o || !e || typeof e.isDataOnlyKey != "function") return !1;
        let _ = o.indexOf(".");
        return !!e.isDataOnlyKey(_ === -1 ? o : o.slice(0, _), w);
    }, c = e && e.maxDepth || 8;
    if (t && typeof t == "object") for(let w in t){
        if (w === "__proto__" || !Object.prototype.hasOwnProperty.call(t, w)) continue;
        if (w.startsWith("__")) {
            s[w] = t[w];
            continue;
        }
        Cl.has(w) && !a(w) && Kb(w, o);
        let _ = t[w];
        n < c && _ && typeof _ == "object" && !zb(_) ? (s[w] = _, r[w] = Jn(Xp(_, e, n + 1, Vb(o, w)))) : (s[w] = _, r[w] = Jn(_));
    }
    let l = new Proxy(s, {
        get (w, _) {
            if (_ === vn) return !0;
            if (_ === Zp) return r;
            if (_ === "__raw") return w;
            if (_ === "$update") return u;
            if (_ === "$parse") return g;
            if (_ === "$clean") return h;
            if (_ === "$keys") return m;
            if (_ === "$values") return y;
            if (_ === "$replace") return b;
            if (_ === "$add") return T;
            if (_ === "$remove") return v;
            if (_ === "$destroy") return S;
            if (_ === "$quietUpdate") return d;
            if (_ === "$settled") return p;
            if (Cl.has(_) && !Object.prototype.hasOwnProperty.call(r, _)) switch(_){
                case "update":
                    return u;
                case "parse":
                    return g;
                case "clean":
                    return h;
                case "keys":
                    return m;
                case "values":
                    return y;
                case "replace":
                    return b;
                case "add":
                    return T;
                case "remove":
                    return v;
                case "destroy":
                    return S;
                case "quietUpdate":
                    return d;
            }
            if (_ === "__element") return w.__element;
            if (_ === "parent") return w.parent;
            if (_ === "root") return w.root;
            if (Object.prototype.hasOwnProperty.call(r, _)) {
                let A = r[_].get();
                if (A !== void 0 || !(_ !== "root" && w.root && w.root !== l)) return A;
            }
            if (w[_] !== void 0) return typeof _ == "string" && Fe(), w[_];
            let x = typeof _ == "string" && !_.startsWith("__") && _ !== "then" && _ !== "constructor" && $b() != null;
            if (_ !== "root" && w.root && w.root !== l) {
                let A = w.root[_];
                return x && !Object.prototype.hasOwnProperty.call(r, _) && (r[_] = Jn(void 0), r[_].get()), A;
            }
            if (x) return r[_] = Jn(void 0), r[_].get();
            typeof _ == "string" && _.charCodeAt(0) === 95 && _.charCodeAt(1) === 95 && Fe();
        },
        set (w, _, x) {
            if (_ === "__proto__") return !1;
            if (_ === "__element" || _ === "parent" || _ === "root" || typeof _ == "string" && _.startsWith("__") && !Object.prototype.hasOwnProperty.call(r, _)) return w[_] = x, !0;
            Cl.has(_) && !a(_) && Kb(_, o);
            let A = Vb(o, _);
            if (Object.prototype.hasOwnProperty.call(r, _)) {
                if (x && typeof x == "object" && !zb(x)) {
                    if (x === w[_]) return !0;
                    let O = r[_].peek(), C = O && O[vn] ? O.$parse() : O;
                    if (Jp(x, C, 0)) return !0;
                    w[_] = x, vl(A), r[_].set(Xp(x, e, n + 1, A));
                } else {
                    if (Array.isArray(x) && x !== w[_] && Array.isArray(r[_].peek()) && Jp(x, r[_].peek(), 0)) return !0;
                    r[_].peek() !== x && vl(A), w[_] = x, r[_].set(x);
                }
            } else w[_] = x, x && typeof x == "object" && !zb(x) ? r[_] = Jn(Xp(x, e, n + 1, A)) : r[_] = Jn(x);
            return !0;
        },
        has (w, _) {
            return Fe(), typeof _ == "string" && _.charCodeAt(0) === 36 && Cl.has(_.slice(1)) ? !0 : _ in w;
        },
        ownKeys (w) {
            return Fe(), Object.keys(r).filter(i);
        },
        getOwnPropertyDescriptor (w, _) {
            return Fe(), i(_) ? {
                enumerable: !0,
                configurable: !0,
                value: r[_].peek()
            } : Object.getOwnPropertyDescriptor(w, _);
        },
        deleteProperty (w, _) {
            if (Object.prototype.hasOwnProperty.call(r, _)) {
                let x = r[_];
                x.peek() !== void 0 && vl(Vb(o, _)), x.set(void 0), x._subscribers.size === 0 && delete r[_];
            }
            return delete w[_], !0;
        }
    });
    function f(w, _) {
        let x = s.__element;
        return !x || typeof x.onBeforeStateUpdate != "function" || _?.preventBeforeStateUpdateListener ? !0 : x.onBeforeStateUpdate(x, l, x.context, {
            changes: w,
            options: _
        }) !== !1;
    }
    function u(w, _) {
        if (w && typeof w == "object" && !f(w, _)) return l;
        Ol(()=>{
            for(let A in w)A !== "__proto__" && (l[A] = w[A]);
        });
        let x = s.__element;
        return x && x.onUpdate && !_?.quiet && x.onUpdate(x, l, x.context), l;
    }
    function d(w) {
        return u(w, {
            quiet: !0
        });
    }
    function p() {
        return Ub().then(()=>l);
    }
    function g(w) {
        if (Fe(), w || (w = new Set), w.has(l)) return "[Circular]";
        w.add(l);
        let _ = {};
        for(let x in r){
            if (x === "parent" || x === "root" || x.startsWith("__") || !Object.prototype.hasOwnProperty.call(s, x)) continue;
            let A = r[x].peek();
            A && A[vn] ? _[x] = A.$parse(w) : _[x] = A;
        }
        return _;
    }
    function h() {
        return Ol(()=>{
            for(let w in r)delete l[w];
        }), l;
    }
    function m() {
        return Fe(), Object.keys(r).filter(i);
    }
    function y() {
        return Fe(), Object.keys(r).filter(i).map((w)=>r[w].peek());
    }
    function b(w, _) {
        return w && typeof w == "object" && !f(w, _) || Ol(()=>{
            for(let x in r)x in w || delete l[x];
            for(let x in w)x !== "__proto__" && (l[x] = w[x]);
        }), l;
    }
    function T(w, _) {
        let x = Object.prototype.hasOwnProperty.call(r, w) ? r[w].peek() : s[w];
        if (Array.isArray(x)) return l[w] = [
            ...x,
            _
        ], l;
        if (x && typeof x == "object" && !Array.isArray(x)) {
            if (Qp(_)) x[vn] ? x.$update(_) : l[w] = {
                ...x,
                ..._
            };
            else {
                let A = String(Object.keys(x).length);
                x[vn] ? x.$update({
                    [A]: _
                }) : l[w] = {
                    ...x,
                    [A]: _
                };
            }
            return l;
        }
        return l[w] = _, l;
    }
    function v(w) {
        return delete l[w], l;
    }
    function S() {
        h(), s.__element = null, s.parent = null;
    }
    return l;
}
function V4(t) {
    return t && t[vn] === !0;
}
function z4(t) {
    return t[Zp];
}
function W4(t, e) {
    let n = {}, o = {};
    if (t && typeof t == "object") for(let a in t)o[a] = t[a], n[a] = Jn(t[a]);
    let r = (a)=>{
        if (Object.prototype.hasOwnProperty.call(n, a)) return n;
        let c = e;
        for(; c;){
            let l = c[Zp];
            if (l && Object.prototype.hasOwnProperty.call(l, a)) return l;
            c = c[vn] ? c[Yp] : null;
        }
        return null;
    }, s = ()=>{
        let a = e;
        for(; a && a[vn];)a = a[Yp];
        return a && typeof a == "object" ? a : null;
    };
    return new Proxy(o, {
        get (a, c) {
            return c === vn ? !0 : c === Zp ? n : c === Yp ? e : c === "__raw" ? a : Object.prototype.hasOwnProperty.call(n, c) ? n[c].get() : e && c !== "then" && c !== "constructor" ? e[c] : a[c];
        },
        set (a, c, l) {
            let f = r(c);
            if (f) return f === n && (a[c] = l), f[c].set(l), !0;
            let u = s();
            return u && Object.prototype.hasOwnProperty.call(u, c) ? (u[c] = l, !0) : (a[c] = l, n[c] = Jn(l), !0);
        },
        has (a, c) {
            if (Fe(), c in n || c in a) return !0;
            let l = e;
            for(; l;){
                if (c in l) return !0;
                l = l[vn] ? l[Yp] : null;
            }
            return !1;
        },
        ownKeys () {
            return Fe(), Object.keys(n);
        },
        getOwnPropertyDescriptor (a, c) {
            return Fe(), c in n ? {
                enumerable: !0,
                configurable: !0,
                value: n[c].peek()
            } : Object.getOwnPropertyDescriptor(a, c);
        }
    });
}
var Yp = Symbol("scope.parent");
var ps = "3.14.790";
var ua = "__SMBLS_SIGNAL_INSTANCES__", da = (t, e, n)=>{
    let o = e || (typeof globalThis < "u" ? globalThis : null);
    if (!o) return null;
    let r = o[ua] || (o[ua] = {
        versions: [],
        engines: 0,
        reported: !1
    });
    return typeof r.engines != "number" && (r.engines = r.versions.length), r.versions.push(t || ps), n || r.engines++, r.engines > 1 && !r.reported && (r.reported = !0, console.error("[smbls] duplicate @symbo.ls/signal instance \u2014", r.engines, "copies of the reactive engine are loaded on this page:", r.versions.join(", ") + ".", "Each copy keeps its own observer and effect queue, so an effect created", "by one copy never re-fires from another copy's store writes, and one", "copy's cascade breaker cannot see the other's queue.", "Copies of the SAME version adopt a single engine automatically, so", "this means the versions above DIFFER: a fossil copy is resolving beside", "the current one. That is a dependency-graph fault, not an application", "bug \u2014 align the version wherever @symbo.ls/signal is imported, then", "regenerate the lockfile so exactly one version resolves.")), r;
}, Yb = (t)=>{
    let e = t || (typeof globalThis < "u" ? globalThis : null);
    e && delete e[ua];
};
var pa = "__SMBLS_SIGNAL_ENGINE__", ZC = (t, e, n)=>{
    let o = e || ps, r = n || (typeof globalThis < "u" ? globalThis : null);
    if (!r) return t;
    let s = r[pa];
    return s && s.engine && s.version === o ? (da(o, r, !0), s.engine) : (s || (r[pa] = {
        version: o,
        engine: t
    }), da(o, r, !1), t);
}, Xb = (t)=>{
    let e = t || (typeof globalThis < "u" ? globalThis : null);
    e && delete e[pa];
};
var Bt = ZC({
    ...Hb,
    ...qb,
    VERSION: ps
}, ps), On = Bt.createSignal, QC = Bt.createComputed, q = Bt.createEffect, th = Bt.batch, $e = Bt.getObserver, Rl = Bt.setObserver, hs = Bt.untrack || ((t)=>{
    let e = Bt.getObserver();
    if (!e) return t();
    Bt.setObserver(null);
    try {
        return t();
    } finally{
        Bt.setObserver(e);
    }
}), eh = Bt.settled || (()=>Promise.resolve()), nh = Bt.countUntrackedReads || ((t)=>(t(), 0)), vo = Bt.createStore, oh = Bt.createScopeStore, xt = Bt.isStore, JC = Bt.getSignals, tR = Bt.STORE_METHOD_NAMES, eR = Bt.RESERVED_STORE_METHODS, rh = Bt.warnStateKeyShadowsMethod, nR = Bt.__resetStateShadowWarnings, K4 = Bt.VERSION;
var Um = /*@__PURE__*/ F({}, {
    CSS_LONGHAND_SHORTHANDS: ()=>gn,
    CSS_SHORTHAND_LONGHANDS: ()=>kt,
    assertEmitIntegrity: ()=>q0,
    css: ()=>Ke,
    cssCamelName: ()=>fd,
    cssPropName: ()=>Re,
    cssShorthandDepth: ()=>mc,
    cssShorthandStatesLonghand: ()=>yc,
    cssShorthandStatesThemeLonghand: ()=>id,
    getActiveDocument: ()=>fo,
    getCacheSize: ()=>eT,
    getEmitStats: ()=>jm,
    injectGlobal: ()=>Lt,
    keyframes: ()=>xc,
    recordRules: ()=>ud,
    replayRules: ()=>dd,
    reset: ()=>q1,
    resetEmitStats: ()=>G0,
    setActiveDocument: ()=>K0,
    setWasmEngine: ()=>ld,
    sortByTier: ()=>J0,
    splitSelectorList: ()=>Zo,
    tierOfStyle: ()=>Q0,
    wrapHoverRule: ()=>Xo
});
var D0 = /*@__PURE__*/ F({}, {
    BARE_SEQUENCE_TOKEN_RE: ()=>$n,
    COMPOUND_CSS_KEYWORDS: ()=>ei,
    CONFIG: ()=>si,
    CONFIG_MERGE_EXL: ()=>ue,
    CSS_NAMED_COLOR_HEX: ()=>Ya,
    CSS_NATIVE_COLOR_REGEX: ()=>Fo,
    CSS_UNITS: ()=>ga,
    FACTORY: ()=>Ve,
    LIVE_KEYS: ()=>R0,
    PREPARED_FORMAT: ()=>gc,
    STANDARD_SCHEME_QUERIES: ()=>pm,
    TILING_POSITION_KEYWORDS: ()=>nd,
    TILING_SIZE_KEYWORDS: ()=>ed,
    VALUE_TRANSFORMERS: ()=>vm,
    __resetSkinWarnings: ()=>_0,
    activateConfig: ()=>BL,
    aliasCaseVariants: ()=>oc,
    animation: ()=>Yk,
    appendSVGSprite: ()=>Qu,
    appendSvgIconsSprite: ()=>yi,
    applyDocument: ()=>Zu,
    applyHeadings: ()=>bm,
    applyMediaSequenceVars: ()=>Pr,
    applyReset: ()=>Ju,
    applySequenceGlobalVars: ()=>Pu,
    applySequenceVars: ()=>zo,
    applySkins: ()=>Hu,
    applySpacingSequence: ()=>Fu,
    applyThemeRoot: ()=>sd,
    applyTimingSequence: ()=>Xu,
    applyTypographySequence: ()=>Gu,
    atSchemes: ()=>Br,
    breakpoints: ()=>Gk,
    buildSkinVarStyles: ()=>gi,
    changeGlobalTheme: ()=>Om,
    changeLightness: ()=>Ck,
    checkIfBoxSize: ()=>Nu,
    class: ()=>t0,
    color: ()=>jk,
    colorPairSchemes: ()=>Bu,
    colorStringToRgbaArray: ()=>ln,
    compositeOverBackdrop: ()=>oi,
    compoundLayers: ()=>Za,
    contrastRatio: ()=>Ja,
    convertSvgToSymbol: ()=>Mu,
    createConfig: ()=>Au,
    createPristineConfig: ()=>lm,
    cssMediaVars: ()=>am,
    cssVars: ()=>im,
    defineResolvedThemeSignal: ()=>Lr,
    defineThemeSignal: ()=>Dr,
    devices: ()=>qk,
    document: ()=>LL,
    findHeadingLetter: ()=>um,
    findHeadings: ()=>Lu,
    font: ()=>Ik,
    fontFace: ()=>Nk,
    fontFamily: ()=>Mk,
    fontFamilyTypes: ()=>Bk,
    forcedScheme: ()=>di,
    generateSequence: ()=>Ee,
    generateSequencePosition: ()=>l0,
    generateSprite: ()=>Iu,
    generateSubSequence: ()=>Ru,
    getActiveConfig: ()=>L,
    getColor: ()=>ct,
    getColorShade: ()=>Gg,
    getDefaultOrFirstKey: ()=>jo,
    getFnPrefixAndValue: ()=>Vo,
    getFontFace: ()=>Dk,
    getFontFaceEach: ()=>ri,
    getFontFaceEachString: ()=>nm,
    getFontFaceString: ()=>Lk,
    getFontFamily: ()=>Ku,
    getFontFormat: ()=>tm,
    getFontSizeByKey: ()=>qu,
    getMediaBorder: ()=>Uu,
    getMediaColor: ()=>Wt,
    getMediaTheme: ()=>hn,
    getResolvedThemeSignal: ()=>ML,
    getRgbTone: ()=>Fn,
    getSafeInk: ()=>mm,
    getSafeInkInfo: ()=>g0,
    getSequenceValue: ()=>ii,
    getSequenceValueBySymbols: ()=>Du,
    getSequenceValuePropertyPair: ()=>lo,
    getShadow: ()=>ju,
    getShapeByKey: ()=>Yu,
    getSizeValue: ()=>rc,
    getSpacingBasedOnRatio: ()=>ze,
    getSpacingByKey: ()=>Ut,
    getSubratio: ()=>Cu,
    getSubratioDifference: ()=>Ou,
    getTheme: ()=>x0,
    getThemeSignal: ()=>IL,
    getTimingByKey: ()=>Ae,
    getTimingFunction: ()=>We,
    gradient: ()=>Uk,
    grid: ()=>Jk,
    hexToRgb: ()=>Ek,
    hexToRgbArray: ()=>Vg,
    hexToRgba: ()=>vk,
    hslToRgb: ()=>Kg,
    icons: ()=>zk,
    inForcedColors: ()=>ai,
    isCSSVar: ()=>Nt,
    isDomDocument: ()=>Oo,
    isForcedColorsQuery: ()=>ci,
    isGoogleFontsUrl: ()=>tc,
    isHostObject: ()=>Co,
    isInertCompoundValue: ()=>Yg,
    isIntendedSystemColorWord: ()=>li,
    isNativeColorToken: ()=>ni,
    isPlainColor: ()=>Mr,
    isRawUnitValue: ()=>Ll,
    isResolvedColor: ()=>fn,
    isScalingUnit: ()=>gs,
    isWritableFamilyBucket: ()=>Zb,
    joinCompoundLayers: ()=>Qa,
    linearChannelToSrgb: ()=>Zg,
    literalPairCompound: ()=>pi,
    literalSchemeMap: ()=>Ko,
    media: ()=>Fk,
    mixTwoColors: ()=>Tk,
    mixTwoRgb: ()=>Ok,
    mixTwoRgba: ()=>qg,
    numToLetterMap: ()=>dn,
    oklabToLinearSrgb: ()=>Qg,
    oklabToOklch: ()=>bu,
    oklchToGamutSafeSrgb: ()=>Su,
    oklchToOklab: ()=>Jg,
    opacify: ()=>Xa,
    parkHostObject: ()=>fr,
    parseColorToken: ()=>ee,
    popConfig: ()=>ut,
    pushConfig: ()=>pt,
    quietColorProbe: ()=>fi,
    quietSequenceProbe: ()=>Ho,
    relativeLuminance: ()=>ti,
    reset: ()=>PL,
    resolveBorderValue: ()=>de,
    resolveColorRgb: ()=>ui,
    resolveColorsInGradient: ()=>Fr,
    resolveCompoundWords: ()=>$o,
    resolveConfigDocument: ()=>ha,
    resolveFileUrl: ()=>un,
    resolveShadowNonColorWord: ()=>ic,
    resolveShadowValue: ()=>hi,
    returnSubThemeOrDefault: ()=>Rk,
    reviveConfig: ()=>Dm,
    rgbArrayToHex: ()=>zg,
    rgbToHSL: ()=>Wg,
    rgbToHex: ()=>Ak,
    runThroughMedia: ()=>_m,
    schemeGuardSelector: ()=>gm,
    schemeMediaQuery: ()=>hm,
    scratchDefaultConfig: ()=>nc,
    scratchSystem: ()=>uc,
    scratchUtils: ()=>Ir,
    semanticIcons: ()=>Wk,
    sequence: ()=>Uo,
    serializeConfig: ()=>Rm,
    set: ()=>bi,
    setActiveConfig: ()=>cm,
    setAdaptiveSchemeVar: ()=>Nr,
    setColor: ()=>Wo,
    setCustomFont: ()=>wu,
    setCustomFontMedia: ()=>Rr,
    setEach: ()=>rd,
    setFont: ()=>Wu,
    setFontFamily: ()=>lc,
    setFontImport: ()=>ec,
    setGradient: ()=>sc,
    setInCustomFontMedia: ()=>em,
    setMediaTheme: ()=>cc,
    setSVG: ()=>fc,
    setScalingVar: ()=>vu,
    setShadow: ()=>$r,
    setSubScalingVar: ()=>fm,
    setSvgIcon: ()=>mi,
    setTheme: ()=>zu,
    setValue: ()=>C0,
    setVariables: ()=>f0,
    shadow: ()=>Vk,
    shape: ()=>o0,
    sizes: ()=>n0,
    skinLiteralBlocks: ()=>Vu,
    skins: ()=>r0,
    spacing: ()=>$k,
    splitCompoundWords: ()=>yu,
    splitSpacedValue: ()=>$u,
    splitTopLevelCommas: ()=>Nn,
    splitTopLevelSpaces: ()=>at,
    splitTransition: ()=>Am,
    srgbChannelToLinear: ()=>Xg,
    srgbToOklab: ()=>_u,
    svg: ()=>Xk,
    svgData: ()=>om,
    svg_data: ()=>Zk,
    templates: ()=>Qk,
    theme: ()=>Hk,
    timing: ()=>Kk,
    toCamel: ()=>Eu,
    toLinearChannel: ()=>qa,
    transformBackgroundImage: ()=>km,
    transformBorder: ()=>Sm,
    transformBorderRadius: ()=>Go,
    transformBoxShadow: ()=>td,
    transformDuration: ()=>od,
    transformGridTemplate: ()=>Em,
    transformShadow: ()=>xm,
    transformSize: ()=>It,
    transformSizeRatio: ()=>$,
    transformTextStroke: ()=>wm,
    transformTilingValue: ()=>_i,
    transformTransition: ()=>O0,
    transfromGap: ()=>Tm,
    typography: ()=>xu,
    unit: ()=>Pk,
    vars: ()=>e0,
    viewTransition: ()=>s0
});
var Ir = /*@__PURE__*/ F({}, {
    BARE_SEQUENCE_TOKEN_RE: ()=>$n,
    COMPOUND_CSS_KEYWORDS: ()=>ei,
    CSS_NAMED_COLOR_HEX: ()=>Ya,
    CSS_NATIVE_COLOR_REGEX: ()=>Fo,
    CSS_UNITS: ()=>ga,
    applyMediaSequenceVars: ()=>Pr,
    applySequenceGlobalVars: ()=>Pu,
    applySequenceVars: ()=>zo,
    changeLightness: ()=>Ck,
    colorStringToRgbaArray: ()=>ln,
    compositeOverBackdrop: ()=>oi,
    compoundLayers: ()=>Za,
    contrastRatio: ()=>Ja,
    convertSvgToSymbol: ()=>Mu,
    findHeadingLetter: ()=>um,
    findHeadings: ()=>Lu,
    generateSequence: ()=>Ee,
    generateSequencePosition: ()=>l0,
    generateSprite: ()=>Iu,
    generateSubSequence: ()=>Ru,
    getColorShade: ()=>Gg,
    getDefaultOrFirstKey: ()=>jo,
    getFnPrefixAndValue: ()=>Vo,
    getFontFace: ()=>Dk,
    getFontFaceEach: ()=>ri,
    getFontFaceEachString: ()=>nm,
    getFontFaceString: ()=>Lk,
    getFontFormat: ()=>tm,
    getRgbTone: ()=>Fn,
    getSequenceValue: ()=>ii,
    getSequenceValueBySymbols: ()=>Du,
    getSequenceValuePropertyPair: ()=>lo,
    getSizeValue: ()=>rc,
    getSubratio: ()=>Cu,
    getSubratioDifference: ()=>Ou,
    hexToRgb: ()=>Ek,
    hexToRgbArray: ()=>Vg,
    hexToRgba: ()=>vk,
    hslToRgb: ()=>Kg,
    isCSSVar: ()=>Nt,
    isDomDocument: ()=>Oo,
    isGoogleFontsUrl: ()=>tc,
    isHostObject: ()=>Co,
    isInertCompoundValue: ()=>Yg,
    isNativeColorToken: ()=>ni,
    isRawUnitValue: ()=>Ll,
    isResolvedColor: ()=>fn,
    isScalingUnit: ()=>gs,
    isWritableFamilyBucket: ()=>Zb,
    joinCompoundLayers: ()=>Qa,
    linearChannelToSrgb: ()=>Zg,
    mixTwoColors: ()=>Tk,
    mixTwoRgb: ()=>Ok,
    mixTwoRgba: ()=>qg,
    numToLetterMap: ()=>dn,
    oklabToLinearSrgb: ()=>Qg,
    oklabToOklch: ()=>bu,
    oklchToGamutSafeSrgb: ()=>Su,
    oklchToOklab: ()=>Jg,
    opacify: ()=>Xa,
    parkHostObject: ()=>fr,
    parseColorToken: ()=>ee,
    quietSequenceProbe: ()=>Ho,
    relativeLuminance: ()=>ti,
    resolveCompoundWords: ()=>$o,
    resolveConfigDocument: ()=>ha,
    resolveFileUrl: ()=>un,
    returnSubThemeOrDefault: ()=>Rk,
    rgbArrayToHex: ()=>zg,
    rgbToHSL: ()=>Wg,
    rgbToHex: ()=>Ak,
    setCustomFont: ()=>wu,
    setCustomFontMedia: ()=>Rr,
    setFontImport: ()=>ec,
    setInCustomFontMedia: ()=>em,
    setScalingVar: ()=>vu,
    setSubScalingVar: ()=>fm,
    setVariables: ()=>f0,
    splitCompoundWords: ()=>yu,
    splitTopLevelCommas: ()=>Nn,
    splitTopLevelSpaces: ()=>at,
    srgbChannelToLinear: ()=>Xg,
    srgbToOklab: ()=>_u,
    toLinearChannel: ()=>qa
});
var Oo = (t)=>!!(t && t.documentElement && typeof t.createElement == "function" && t.head !== void 0), Co = (t)=>{
    if (t === null || typeof t != "object") return !1;
    let e = Object.prototype.toString.call(t);
    return !!(e !== "[object Object]" && e !== "[object Array]" || typeof t.nodeType == "number" || t.defaultView || t.window === t || t.self === t);
}, Zb = (t)=>t !== null && typeof t == "object" && !Co(t), fr = (t, e, n)=>{
    if (!t) return;
    if (Oo(n)) {
        t.__domDocument || (t.__domDocument = n);
        return;
    }
    let o = `__host_${e}`;
    t[o] || (t[o] = n);
}, ha = (t)=>t ? Oo(t.__domDocument) ? t.__domDocument : Oo(t.document) ? t.document : null : null;
var gs = (t)=>t === "em" || t === "rem" || t === "vw" || t === "vh" || t === "vmax" || t === "vmin", ga = [
    "px",
    "cm",
    "mm",
    "in",
    "pt",
    "pc",
    "em",
    "rem",
    "ex",
    "cap",
    "ch",
    "ic",
    "lh",
    "rlh",
    "%",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax",
    "deg",
    "rad",
    "grad",
    "turn",
    "s",
    "ms",
    "dpi",
    "dpcm",
    "dppx",
    "fr",
    "auto"
], G4 = (t)=>t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), q4 = new RegExp(`^-?(?:\\d+\\.?\\d*|\\.\\d+)(?:${ga.filter((t)=>t !== "auto").map(G4).join("|")})$`), Ll = (t)=>q4.test(String(t).trim());
var No = /*@__PURE__*/ F({}, {
    BRENDER_LAZY_META: ()=>Ng,
    BRENDER_REGISTRY_BLOCK: ()=>ru,
    BRENDER_REGISTRY_TREE_BLOCK: ()=>su,
    BRENDER_STAMP_META: ()=>Bg,
    CDN_PROVIDERS: ()=>cn,
    DESIGN_SYSTEM_BLOCK: ()=>lu,
    DESIGN_SYSTEM_DEFERRED: ()=>cu,
    DESIGN_SYSTEM_LINK: ()=>au,
    DOMQL_EVENTS: ()=>RS,
    DOMQ_PROPERTIES: ()=>pr,
    ELEMENT_METHOD_OVERRIDE_POINTS: ()=>wa,
    ENV: ()=>QS,
    HOST_FORCED_ATTR: ()=>uu,
    HOST_FORCED_ROBOTS: ()=>dk,
    HOST_FORCED_VALUE: ()=>du,
    HOST_PACKAGE_ERROR_CODES: ()=>In,
    HOST_PACKAGE_LOADER_KEY: ()=>Fa,
    HOST_PACKAGE_PATH_BASE: ()=>Eg,
    HOST_SOURCES_GLOBAL: ()=>Tr,
    HOST_SOURCES_TAG_ATTR: ()=>Ag,
    HTML_TAGS: ()=>Ta,
    LAZY_HOST_IMPORT_FORMS: ()=>Na,
    LIBRARY_PACKAGES: ()=>Ig,
    LIBRARY_SCOPES_KEY: ()=>Vs,
    METHODS: ()=>gr,
    METHODS_EXL: ()=>Vl,
    NODE_ENV: ()=>Rn,
    OPTIONS: ()=>Af,
    PACKAGE_MANAGER_TO_CDN: ()=>Er,
    PARSED_DOMQ_PROPERTIES: ()=>Hl,
    POLYGLOT_LANG_STORAGE_KEY: ()=>lh,
    POLYGLOT_TRANSLATIONS_FROM_LANG: ()=>_S,
    PROPS_METHODS: ()=>hr,
    PROTOTYPE_KEYS: ()=>je,
    REVIVED_MARK: ()=>Yl,
    ROUTE_HEAD_KEYS: ()=>Mg,
    SHADOWED_COMPONENTS: ()=>Ea,
    SMBLS_PATH_PREFIX: ()=>Ba,
    STATE_DATA_MERGE_EXL: ()=>Yh,
    STATE_METHODS: ()=>ws,
    STATE_PROPERTIES: ()=>OS,
    SVG_TAGS: ()=>xR,
    TYPES: ()=>Il,
    UNIVERSAL_RESERVED_KEYS: ()=>xg,
    WORKER_SCRIPT_BASE: ()=>Ma,
    WORKER_SCRIPT_NAME: ()=>Tg,
    __resetBuiltinMethodWarnings: ()=>Jx,
    addCaching: ()=>Vh,
    addContext: ()=>Hh,
    addExtend: ()=>yw,
    addExtends: ()=>eo,
    addItemAfterEveryElement: ()=>cS,
    addProtoToArray: ()=>Nl,
    addRef: ()=>$h,
    alternateLinkKey: ()=>Zs,
    applyDependentState: ()=>Iw,
    applyEvent: ()=>gg,
    applyEventUpdate: ()=>mg,
    applyExtends: ()=>ER,
    applyProps: ()=>ff,
    arrayContainsOtherArray: ()=>eS,
    arraysEqual: ()=>fS,
    arrayzeValue: ()=>Js,
    bareLibraryKey: ()=>Kf,
    bindLibraryGlobalScopes: ()=>qf,
    brenderLazyMeta: ()=>fk,
    brenderStampMeta: ()=>lk,
    buildImgSrcset: ()=>gu,
    buildSourcesAndImg: ()=>mu,
    cache: ()=>gx,
    call: ()=>Ax,
    captureSnapshot: ()=>Ox,
    checkForStateTypes: ()=>Rw,
    checkIfInherits: ()=>qh,
    checkIfStringIsInArray: ()=>pS,
    classifyHostPackageReads: ()=>Mx,
    clone: ()=>NS,
    cloneAndMergeArrayExtend: ()=>tf,
    cloneFunction: ()=>mS,
    collectExtendsList: ()=>Lo,
    concatAddExtends: ()=>hw,
    copyJavaScriptToClipboard: ()=>yk,
    copyStringToClipboard: ()=>mk,
    createBasedOnType: ()=>Fh,
    createElement: ()=>Cw,
    createElementExtends: ()=>vh,
    createExtends: ()=>nf,
    createExtendsFromKeys: ()=>Aa,
    createExtendsStack: ()=>Dh,
    createIfConditionFlag: ()=>ow,
    createInheritedState: ()=>Dw,
    createKey: ()=>Jl,
    createNestedObject: ()=>WS,
    createNestedObjectByKeyPath: ()=>Pw,
    createObjectWithoutPrototype: ()=>bh,
    createParent: ()=>jh,
    createPath: ()=>Uh,
    createProps: ()=>uf,
    createPropsStack: ()=>Bh,
    createPrunedLibraryIconLoader: ()=>Hg,
    createRoot: ()=>Ow,
    createScope: ()=>Bw,
    createSnapshotId: ()=>Ql,
    currentPathname: ()=>bs,
    customDecodeURIComponent: ()=>vS,
    customEncodeURIComponent: ()=>AS,
    cutArrayAfterValue: ()=>iS,
    cutArrayBeforeValue: ()=>sS,
    debounce: ()=>Fl,
    debounceOnContext: ()=>hS,
    decodeBrenderRegistry: ()=>iu,
    decodeNewlines: ()=>ES,
    deepClone: ()=>ft,
    deepContains: ()=>VS,
    deepDefaults: ()=>Va,
    deepDestringifyFunctions: ()=>xe,
    deepExtend: ()=>Th,
    deepMerge: ()=>mt,
    deepMergeExtends: ()=>no,
    deepStringifyFunctions: ()=>Wl,
    defineSetter: ()=>Tx,
    designSystemBlock: ()=>ck,
    designSystemLink: ()=>ak,
    destringifyGlobalScope: ()=>vs,
    detectHeightOnInit: ()=>jx,
    detectInfiniteLoop: ()=>YS,
    document: ()=>wt,
    elementPath: ()=>an,
    encodeNewlines: ()=>TS,
    error: ()=>js,
    escapeHtml: ()=>H,
    escapeRegExp: ()=>SS,
    evaluateText: ()=>Pn,
    excludeKeysFromObject: ()=>ZS,
    exec: ()=>bt,
    exposeBagGlobalScopes: ()=>Yf,
    extendCachedRegistry: ()=>gw,
    extendStackRegistry: ()=>of,
    extractArrayExtend: ()=>sf,
    faviconLinkKey: ()=>Or,
    fetchLibraryData: ()=>Ys,
    fibonacciNumberByIndex: ()=>Ux,
    fileEntryUrl: ()=>Fg,
    filterArrays: ()=>uS,
    filterArraysFast: ()=>dS,
    finalizeExtends: ()=>Lh,
    findClosestNumber: ()=>$g,
    findClosestNumberInFactory: ()=>gk,
    findInheritedState: ()=>Gh,
    findKeyPosition: ()=>xS,
    flattenExtend: ()=>va,
    formatDate: ()=>$x,
    generateHash: ()=>wh,
    generateHeadArrayTags: ()=>Ka,
    generateKey: ()=>Zl,
    generateMetaTags: ()=>pk,
    get: ()=>Sx,
    getCDNDirUrl: ()=>Og,
    getCDNUrl: ()=>Mn,
    getCapitalCaseKeys: ()=>bw,
    getCdnProviderFromConfig: ()=>Ua,
    getChildStateInKey: ()=>Kh,
    getChildren: ()=>kx,
    getContext: ()=>Mf,
    getCookie: ()=>cw,
    getDB: ()=>jf,
    getEmotionStylesheet: ()=>kk,
    getExtendsInElement: ()=>_w,
    getExtendsStack: ()=>ef,
    getExtendsStackRegistry: ()=>kh,
    getFrequencyInArray: ()=>nS,
    getFunctionSource: ()=>Ue,
    getHashedExtend: ()=>rf,
    getImportMapScript: ()=>Fx,
    getInObjectByPath: ()=>qS,
    getLocalStorage: ()=>fw,
    getNev: ()=>nw,
    getPageMetadata: ()=>hk,
    getParentStateInKey: ()=>Wh,
    getPath: ()=>Cf,
    getQuery: ()=>Uf,
    getRef: ()=>xx,
    getRoot: ()=>Lf,
    getRootContext: ()=>If,
    getRootData: ()=>Pf,
    getRootState: ()=>Df,
    getRootStateInKey: ()=>zh,
    getSpreadChildren: ()=>Sw,
    global: ()=>Qb,
    hasFunction: ()=>ie,
    hasHandlerPlugin: ()=>_a,
    hasOwnProperty: ()=>jS,
    hashContent: ()=>Bn,
    hostPackageAssetPath: ()=>Lx,
    hostPackageSourcesScript: ()=>vg,
    hostPackageSourcesTag: ()=>Bx,
    inheritChildExtends: ()=>Ch,
    inheritChildPropsExtends: ()=>Oh,
    inheritParentProps: ()=>df,
    inheritRecursiveChildExtends: ()=>Rh,
    initProps: ()=>Aw,
    insertAfterImportMap: ()=>uk,
    installPrunedLibraryIconLoader: ()=>hu,
    is: ()=>Se,
    isArray: ()=>B,
    isBoolean: ()=>sh,
    isBuiltinElementMethod: ()=>CS,
    isContextComponent: ()=>ww,
    isCyclic: ()=>XS,
    isDOMNode: ()=>_e,
    isDate: ()=>ah,
    isDefined: ()=>jt,
    isDevelopment: ()=>yr,
    isEmpty: ()=>yh,
    isEmptyObject: ()=>US,
    isEqualDeep: ()=>_h,
    isFailedRevival: ()=>Es,
    isFunction: ()=>P,
    isHostPackageSpecifier: ()=>Hf,
    isHtmlElement: ()=>Pl,
    isLazyFunction: ()=>FS,
    isLocal: ()=>ew,
    isLoudDevRuntime: ()=>et,
    isMalformedDependency: ()=>Us,
    isMethod: ()=>vx,
    isMobile: ()=>iw,
    isNode: ()=>Ro,
    isNot: ()=>tS,
    isNotProduction: ()=>Do,
    isNull: ()=>ih,
    isNumber: ()=>be,
    isObject: ()=>k,
    isObjectLike: ()=>z,
    isPhoto: ()=>Hx,
    isPolyglotRetranslatableKey: ()=>mf,
    isPolyglotWritableKey: ()=>Cs,
    isProduction: ()=>mr,
    isProtectedElementMethod: ()=>xs,
    isRevived: ()=>As,
    isSameRoutePage: ()=>nu,
    isStaging: ()=>tw,
    isState: ()=>Lw,
    isString: ()=>E,
    isStringFunction: ()=>ur,
    isStringTag: ()=>ql,
    isTest: ()=>Sh,
    isTesting: ()=>JS,
    isUndefined: ()=>Xt,
    isUniversallyReservedKey: ()=>Cx,
    isUnresolvableDependency: ()=>Ar,
    isValidDependencyMap: ()=>Hs,
    isValidHtmlTag: ()=>dw,
    isWrappedLibrary: ()=>ke,
    joinArrays: ()=>ma,
    jointStacks: ()=>mw,
    jsonForScript: ()=>Ls,
    keys: ()=>Sg,
    lazyHostImportExpr: ()=>Ix,
    libraryIconPruneReplacer: ()=>xk,
    libraryIdentifier: ()=>jg,
    libraryPackageSpecs: ()=>Ks,
    librarySpecsFor: ()=>Pg,
    loadCssFile: ()=>Kx,
    loadJavascript: ()=>Gx,
    loadJavascriptFile: ()=>Vx,
    loadJavascriptFileEmbedSync: ()=>Wx,
    loadJavascriptFileSync: ()=>zx,
    loadRemoteCSS: ()=>qx,
    loadRemoteScript: ()=>Ha,
    log: ()=>Ex,
    logGroupIf: ()=>sw,
    logIf: ()=>rw,
    lookdown: ()=>_x,
    lookdownAll: ()=>bx,
    lookup: ()=>yx,
    lowercaseFirstLetter: ()=>Ss,
    makeObjectWithoutPrototype: ()=>HS,
    map: ()=>BS,
    mapStringsWithContextComponents: ()=>cf,
    markPolyglotSeeded: ()=>ro,
    markRevived: ()=>ka,
    markTextNotReady: ()=>Ia,
    matchesComponentNaming: ()=>oo,
    memoize: ()=>gS,
    merge: ()=>Dt,
    mergeSharedLibraries: ()=>Zf,
    mergeSharedLibraryDesignSystems: ()=>Qf,
    mergeSharedLibraryTranslations: ()=>Jf,
    mergeStateData: ()=>_r,
    nextElement: ()=>Nf,
    normalizeIgnoreList: ()=>za,
    normalizeLibraryKey: ()=>zs,
    objectToString: ()=>Kl,
    objectizeStringProperty: ()=>lf,
    overwrite: ()=>Xl,
    overwriteDeep: ()=>le,
    overwriteShallow: ()=>Os,
    overwriteState: ()=>Mw,
    parse: ()=>wg,
    parseDeep: ()=>vf,
    payloadHasComputedIconName: ()=>Ug,
    pickStartLang: ()=>ph,
    pickupElementFromProps: ()=>Ih,
    pickupPropsFromElement: ()=>Ph,
    planLibraryIconPrune: ()=>wk,
    polyglotAddressLang: ()=>uh,
    polyglotDefaultLang: ()=>fh,
    polyglotEarlyStartLang: ()=>ys,
    polyglotFallbackLang: ()=>te,
    polyglotLangStorageKey: ()=>Sa,
    polyglotLanguages: ()=>we,
    polyglotSeededKeys: ()=>br,
    polyglotStartLang: ()=>_s,
    polyglotStartRule: ()=>dh,
    polyglotStartupScript: ()=>bS,
    polyglotTranslations: ()=>dr,
    previousElement: ()=>Ff,
    promoteActiveRootState: ()=>La,
    propExists: ()=>Tw,
    propertizeElement: ()=>Mh,
    propertizeUpdate: ()=>kw,
    readBrenderLazyGroups: ()=>fu,
    readBrenderStamp: ()=>Ps,
    readJsonDataBlock: ()=>io,
    recordShadowedComponent: ()=>af,
    remove: ()=>VD,
    removeChars: ()=>_k,
    removeCookie: ()=>lw,
    removeDuplicateProps: ()=>hf,
    removeDuplicatesInArray: ()=>ya,
    removeFromArray: ()=>oS,
    removeFromObject: ()=>zS,
    removeNestedKeyByPath: ()=>KS,
    removeValueFromArray: ()=>Bl,
    removeValueFromArrayAll: ()=>aS,
    reorderArrayByValues: ()=>lS,
    repairLegacyArrowScopePreamble: ()=>zl,
    replaceLiteralsWithObjectFields: ()=>Zt,
    replaceOctalEscapeSequences: ()=>kS,
    resolveAsset: ()=>Te,
    resolveComponentTier: ()=>Ah,
    resolveFileReferences: ()=>Cr,
    resolveHandler: ()=>ba,
    resolvePolyglotTranslations: ()=>ms,
    resolveSharedLibraries: ()=>tu,
    returnValueAsText: ()=>Nh,
    routeEntryMetadata: ()=>Mo,
    routeEntryPage: ()=>eu,
    runPluginHook: ()=>Cn,
    runtimeProvidesHostPackageLoader: ()=>Px,
    scopeElementParam: ()=>hh,
    scopeReceiverExpression: ()=>IS,
    self: ()=>Jb,
    servedSharedLibraries: ()=>sk,
    setActiveRootState: ()=>Rf,
    setCookie: ()=>aw,
    setHashedExtend: ()=>xh,
    setInObjectByPath: ()=>GS,
    setLocalStorage: ()=>uw,
    setNodeStyles: ()=>bg,
    setProps: ()=>wx,
    setPropsPrototype: ()=>pf,
    shadowedComponentsOf: ()=>Eh,
    sharedLibrary: ()=>Qx,
    sharedLibraryBagEntry: ()=>qs,
    sharedLibraryDependencies: ()=>rk,
    sharedLibraryFiles: ()=>Gs,
    splitPackageSpecifier: ()=>Vf,
    spotByPath: ()=>Of,
    srcsetFor: ()=>Ga,
    stringIncludesAny: ()=>Ul,
    stringToObject: ()=>$S,
    stripVersionRangePrefix: ()=>zf,
    swapItemsInArray: ()=>rS,
    syncProps: ()=>gf,
    themeColorKey: ()=>Qs,
    toCamelCase: ()=>Bo,
    toDashCase: ()=>pu,
    toDescriptionCase: ()=>Sk,
    toPriorityOrder: ()=>en,
    toTitleCase: ()=>bk,
    toggleFullscreen: ()=>Nx,
    triggerEventOn: ()=>Io,
    triggerEventOnUpdate: ()=>hx,
    trimStringFromSymbols: ()=>wS,
    unstackArrayOfObjects: ()=>Ml,
    update: ()=>Ew,
    updateProps: ()=>vw,
    variables: ()=>$f,
    verbose: ()=>Pa,
    warn: ()=>Bf,
    warnLibraryAliasCollision: ()=>Wa,
    window: ()=>R,
    withPolyglotTranslations: ()=>$l,
    workerNameFromPath: ()=>Dx,
    workerScriptPath: ()=>Rx
});
var Qb = globalThis, Jb = globalThis, R = globalThis, wt = R.document;
var Ro = (t)=>(typeof Node == "object" ? t instanceof R.Node : t && typeof t == "object" && typeof t.nodeType == "number" && typeof t.nodeName == "string") || !1, Pl = (t)=>(typeof HTMLElement == "object" ? t instanceof R.HTMLElement : t && typeof t == "object" && t !== null && t.nodeType === 1 && typeof t.nodeName == "string") || !1, _e = (t)=>t === null || typeof t != "object" ? !1 : typeof R < "u" && (R.Node && t instanceof R.Node || R.Window && t instanceof R.Window || t === R || wt !== void 0 && t === wt);
var k = (t)=>t === null ? !1 : typeof t == "object" && t.constructor === Object, E = (t)=>typeof t == "string", be = (t)=>typeof t == "number", P = (t)=>typeof t == "function", sh = (t)=>t === !0 || t === !1, ih = (t)=>t === null, B = (t)=>Array.isArray(t), ah = (t)=>t instanceof Date, z = (t)=>t === null ? !1 : typeof t == "object", jt = (t)=>t !== void 0, Xt = (t)=>t === void 0, Il = {
    boolean: sh,
    array: B,
    object: k,
    string: E,
    date: ah,
    number: be,
    null: ih,
    function: P,
    objectLike: z,
    node: Ro,
    htmlElement: Pl,
    defined: jt
}, Se = (t)=>(...e)=>e.some((n)=>Il[n](t)), tS = (t)=>(...e)=>!e.some((n)=>Il[n](t));
var eS = (t, e)=>e.every((n)=>t.includes(n)), nS = (t, e)=>{
    let n = 0;
    for(let o = 0; o < t.length; o++)t[o] === e && n++;
    return n;
}, oS = (t, e)=>{
    if (E(e) && (e = parseInt(e)), be(e)) {
        if (e < 0 || e >= t.length || isNaN(e)) throw new Error("Invalid index");
        t.splice(e, 1);
    } else throw new Error("Invalid index");
    return t;
}, rS = (t, e, n)=>{
    e < 0 || n < 0 || e >= t.length || n >= t.length || ([t[e], t[n]] = [
        t[n],
        t[e]
    ]);
}, ma = (...t)=>[].concat(...t), Ml = (t, e = [])=>t.reduce((n, o)=>mt(n, ft(o, {
            exclude: e
        }), e), {}), sS = (t, e)=>{
    let n = t.indexOf(e);
    return n !== -1 ? t.slice(0, n) : t;
}, iS = (t, e)=>{
    if (!B(t)) return;
    let n = t.indexOf(e);
    return n !== -1 ? t.slice(n + 1) : t;
}, Bl = (t, e)=>{
    let n = t.indexOf(e);
    if (n > -1) {
        let o = [
            ...t
        ];
        return o.splice(n, 1), o;
    }
    return t;
}, aS = (t, e)=>t.filter((n)=>n !== e), cS = (t, e)=>{
    let n = [];
    for(let o = 0; o < t.length; o++)n.push(t[o]), o < t.length - 1 && n.push(e);
    return n;
}, lS = (t, e, n)=>{
    let o = [
        ...t
    ], r = o.indexOf(e), s = o.indexOf(n);
    if (r !== -1 && s !== -1) {
        let i = o.splice(r, 1)[0], a = s < r ? s : s + 1;
        o.splice(a, 0, i);
    }
    return o;
}, fS = (t, e)=>{
    if (t.length !== e.length) return !1;
    for(let n = 0; n < t.length; n++)if (t[n] !== e[n]) return !1;
    return !0;
}, uS = (t, e)=>t.filter((n)=>!e.includes(n)), dS = (t, e)=>{
    let n = new Set(e);
    return t.filter((o)=>!n.has(o));
}, pS = (t, e)=>{
    if (!t) return 0;
    let n = 0;
    for(let o = 0; o < e.length; o++)t.includes(e[o]) && n++;
    return n;
}, ya = (t)=>B(t) ? [
        ...new Set(t)
    ] : t, Nl = (t, e)=>{
    for(let n in e)Object.defineProperty(t, n, {
        value: e[n],
        enumerable: !1,
        configurable: !0,
        writable: !0
    });
};
var Y4 = Symbol.for("smbls.serverUtils"), to = (t, e)=>{
    let n = globalThis[Y4];
    return typeof n != "function" ? Promise.reject(new Error(`[smbls] ${t} is server-only in this build and no smbls runtime registered its loader`)) : n().then((o)=>o[t](...e));
};
function Fl(t, e, n) {
    let o;
    return function() {
        let r = this, s = arguments, i = function() {
            o = null, n || t.apply(r, s);
        }, a = n && !o;
        clearTimeout(o), o = setTimeout(i, e), a && t.apply(r, s);
    };
}
var hS = (t, e, n = 300)=>{
    let o;
    return (...r)=>{
        clearTimeout(o), o = setTimeout(()=>{
            e.apply(t, r);
        }, n);
    };
}, gS = (t)=>{
    let e = {};
    return (...n)=>{
        let o = n[0];
        if (o in e) return e[o];
        {
            let r = t(o);
            return e[o] = r, r;
        }
    };
}, X4 = /^\s*(?:async\s+)?(?:function\b|\([^)]*\)\s*=>|[a-zA-Z_$][\w$]*\s*=>)/, ur = (t)=>X4.test(t), _a = (t)=>{
    let e = t?.plugins;
    if (!e || !e.length) return !1;
    for (let n of e)if (n.resolveHandler) return !0;
    return !1;
}, ba = (t, e)=>{
    if (typeof t == "function") return t;
    let n = e?.context?.plugins;
    if (!n) return t;
    for (let o of n)if (o.resolveHandler) {
        let r = o.resolveHandler(t, e);
        if (typeof r == "function") return r;
    }
    return t;
}, Cn = (t, e, ...n)=>{
    let o = e?.context?.plugins;
    if (!o) return !1;
    let r = !1;
    for (let s of o)typeof s[t] == "function" && (s[t](e, ...n), r = !0);
    return r;
};
function mS(t, e = window) {
    let n = function() {
        return t.apply(e, arguments);
    };
    for(let o in t)Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    return n;
}
var lh = "smbls_lang", _S = "designSystem.lang", Z4 = (t, e)=>{
    let n = t;
    for (let o of e.split(".")){
        if (!n || typeof n != "object" || !Object.prototype.hasOwnProperty.call(n, o)) return;
        n = n[o];
    }
    return n;
}, ch = (t)=>!!t && typeof t == "object" && !Array.isArray(t), Q4 = (t)=>[
        t,
        t.config,
        t.settings
    ], dr = (t, e)=>{
    if (!e || typeof e != "object") return;
    let n = e.translations, o = e.translationsFrom, r = typeof o == "string" && o ? Z4(t, o) : void 0;
    if (!ch(r)) return n;
    if (n === void 0 || n === r) return r;
    if (!ch(n)) return n;
    let s = {
        ...r
    };
    for(let i in n){
        let a = n[i];
        s[i] = ch(a) && ch(r[i]) ? {
            ...r[i],
            ...a
        } : a;
    }
    return s;
}, yS = (t)=>!!t && typeof t == "object" && typeof t.translationsFrom == "string" && !!t.translationsFrom, ms = (t)=>{
    if (!t || typeof t != "object") return t;
    for (let e of Q4(t)){
        let n = e && typeof e == "object" ? e.polyglot : null;
        if (!yS(n)) continue;
        let o = dr(t, n);
        o !== void 0 && o !== n.translations && (n.translations = o);
    }
    return t;
}, $l = (t)=>{
    if (!t || typeof t != "object") return t;
    let e = t, n = ()=>e === t ? e = {
            ...t
        } : e;
    if (yS(t.polyglot)) {
        let o = dr(t, t.polyglot);
        o !== void 0 && o !== t.polyglot.translations && (n().polyglot = {
            ...t.polyglot,
            translations: o
        });
    }
    for (let o of [
        "config",
        "settings"
    ]){
        let r = t[o], s = r && typeof r == "object" ? r.polyglot : null;
        if (!yS(s)) continue;
        let i = dr(t, s);
        i !== void 0 && i !== s.translations && (n()[o] = {
            ...r,
            polyglot: {
                ...s,
                translations: i
            }
        });
    }
    return e;
}, Sa = (t)=>t && t.storageLangKey || lh, fh = (t)=>{
    let e = t && t.defaultLang;
    if (typeof e == "function") try {
        e = e(t);
    } catch  {
        e = null;
    }
    return typeof e == "string" && e && !ur(e) ? e : null;
}, te = (t, e)=>t || fh(e) || "en", J4 = "@symbo.ls/fetch:EARLY", ys = (t)=>{
    try {
        let e = t && t[Symbol.for(J4)], n = e && e.startLang;
        return typeof n == "string" && n ? n : null;
    } catch  {
        return null;
    }
}, we = (t, e = !0)=>{
    let n = t && t.languages;
    if (typeof n == "function") try {
        n = n(t);
    } catch  {
        n = null;
    }
    return Array.isArray(n) && n.length ? n.filter((o)=>typeof o == "string") : e ? Object.keys(t && t.translations || {}) : [];
}, uh = (t, e)=>{
    if (!e) return null;
    let n = we(e), o = /^\/([^/?#]+)/.exec(String(t || ""));
    if (!o) return null;
    let r = o[1].toLowerCase();
    for (let s of n)if (typeof s == "string" && s.toLowerCase() === r) return s;
    return null;
}, dh = (t, e)=>{
    let n = we(t), o = t && t.addressLang, r = o && typeof o == "object" && !Array.isArray(o), s = r ? o.mode : o, i = {
        languages: n,
        address: s === !1 ? !1 : s === "fallback" || s === "strict" ? s : !0,
        fallback: te(e, t)
    }, a = r && Array.isArray(o.except) ? o.except.filter((c)=>typeof c == "string" && c) : [];
    return a.length && (i.except = a), i;
}, ph = (t, e, n)=>{
    if (t && t.except && t.except.length) {
        let r = String(e || "").split(/[?#]/)[0].split("/").filter(Boolean);
        for(let s = 0; s < t.except.length; s++){
            let i = String(t.except[s]).split("/").filter(Boolean);
            if (i[i.length - 1] === "*" && i.pop(), i.length > r.length) continue;
            let a = !0;
            for(let c = 0; c < i.length && a; c++)i[c].charAt(0) !== ":" && i[c] !== r[c] && (a = !1);
            if (a) {
                t = {
                    languages: t.languages,
                    address: t.address !== !1,
                    fallback: t.fallback
                };
                break;
            }
        }
    }
    let o = null;
    if (t && t.address !== !1) {
        let r = /^\/([^/?#]+)/.exec(String(e || "")), s = t && t.languages || [];
        if (r) {
            let i = r[1].toLowerCase();
            for(let a = 0; a < s.length && !o; a++)String(s[a]).toLowerCase() === i && (o = s[a]);
        }
    }
    return o && (t.address !== "fallback" || !n) ? o : t && t.address === "strict" ? t.fallback || "" : n || t && t.fallback || "";
}, _s = ({ polyglot: t, pathname: e, stored: n, stateLang: o, started: r } = {})=>typeof r == "string" && r || ph(dh(t, o), e, n), bs = (t)=>{
    try {
        let e = t && t.location || typeof globalThis < "u" && globalThis.location;
        return e && typeof e.pathname == "string" ? e.pathname : "";
    } catch  {
        return "";
    }
}, bS = ({ polyglot: t, translations: e, lang: n, pathname: o, attrs: r = "" } = {})=>{
    if (!e || typeof e != "object") return "";
    let s = t && t.storagePrefix || "", i = t && t.storageLangKey || "", a = [];
    for(let c in e){
        let l = e[c];
        l && typeof l == "object" && a.push(`localStorage.setItem(${JSON.stringify(s + c)},${JSON.stringify(JSON.stringify(l))})`);
    }
    if (i) {
        let c = n || uh(o, t) || te(void 0, t);
        a.push(`if(!localStorage.getItem(${JSON.stringify(i)}))localStorage.setItem(${JSON.stringify(i)},${JSON.stringify(c)})`);
    }
    return a.length ? `<script${r}>try{${a.join(";")}}catch(e){}<\/script>` : "";
};
var SS = (t)=>t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Ul = (t, e)=>{
    for (let n of e)if (t.includes(n)) return !0;
    return !1;
}, wS = (t, e)=>{
    let n = new RegExp(`[${e.join("\\")}]`, "g");
    return t.replace(n, "");
}, tV = {
    2: /{{\s*((?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}/g,
    3: /{{{(\s*(?:\.\.\/)*)([\w\d.]+)\s*(?:\|\s*([\w\d.]+))?\s*}}}/g
}, jl = (t, e)=>e.split(".").reduce((n, o)=>n?.[o], t), eV = (t, e)=>{
    if (!t || !t.__ref) return !0;
    let n = t;
    for(; n;){
        if (n.allowRuntimeTemplates === !0) return !0;
        let o = n.__ref && n.__ref.__authoredTemplates;
        if (o && o.has(e)) return !0;
        n = n.parent;
    }
    return !1;
};
function Zt(t, e, n = {}) {
    let { bracketsLength: o = 2, authored: r = !1 } = n, s = o === 3 ? "{{{" : "{{";
    if (!t.includes(s) || r !== !0 && !eV(this, t)) return t;
    let i = tV[o], a = e || this.state || {}, c = this;
    return t.replace(i, (l, f, u, d)=>{
        let p = u.trim();
        if (d) {
            let g = c?.context, h = g?.functions?.[d] || g?.utils?.[d] || g?.methods?.[d] || g?.snippets?.[d] || c?.[d];
            if (h && typeof h == "function") try {
                return String(h.call(c, p) ?? "");
            } catch  {
                return "";
            }
            return "";
        }
        if (f) {
            let g = (f.match(/\.\.\//g) || []).length, h = a;
            for(let y = 0; y < g; y++){
                if (!h || !h.parent) return "";
                h = h.parent;
            }
            if (p === "parent") return String(h.value ?? "");
            let m = jl(h, p);
            return m != null && typeof m == "object" ? "" : String(m ?? "");
        } else {
            let g = jl(a, p);
            if (g != null && typeof g != "object") return String(g);
            let h = c?.context?.polyglot;
            if (h?.translations) {
                let m = te(a?.root?.lang || a?.lang || c?.context?.state?.lang, h), y = h.translations[m];
                if (y) {
                    let T = jl(y, p);
                    if (T != null && typeof T != "object") return String(T);
                    for(let v in y){
                        let S = y[v];
                        if (S && typeof S == "object" && !Array.isArray(S)) {
                            let w = jl(S, p);
                            if (w != null && typeof w != "object") return String(w);
                        }
                    }
                }
                let b = jl(h.translations, p);
                if (b != null && typeof b != "object") return String(b);
            }
            return "";
        }
    });
}
var Ss = (t)=>`${t.charAt(0).toLowerCase()}${t.slice(1)}`, xS = (t, e)=>{
    let n = t.split(`
`), o = -1, r = -1, s = -1, i = -1, a = new RegExp(`\\b${e}\\b\\s*:\\s*`), c = 0, l = !1;
    for(let f = 0; f < n.length; f++)if (a.test(n[f]) && !l) {
        if (l = !0, o = f + 1, s = n[f].indexOf(e) + 1, n[f].includes("{}")) {
            r = o, i = n[f].indexOf("{}") + 3;
            break;
        }
        let u = n[f].slice(s + e.length);
        if (u.includes("{") || u.includes("[")) c = 1;
        else {
            r = f + 1, i = n[f].length + 1;
            break;
        }
    } else if (l && (c += (n[f].match(/{/g) || []).length, c += (n[f].match(/\[/g) || []).length, c -= (n[f].match(/}/g) || []).length, c -= (n[f].match(/]/g) || []).length, c === 0)) {
        r = f + 1, i = n[f].lastIndexOf("}") !== -1 ? n[f].lastIndexOf("}") + 2 : n[f].length + 1;
        break;
    }
    return {
        startColumn: s,
        endColumn: i,
        startLineNumber: o,
        endLineNumber: r
    };
}, nV = /\\([0-7]{1,3})/g, kS = (t)=>t.replace(nV, (e, n)=>String.fromCharCode(parseInt(n, 8))), TS = (t)=>t.replace(/\n/g, "/////n").replace(/`/g, "/////tilde").replace(/\$/g, "/////dlrsgn"), ES = (t)=>t.replace(/\/\/\/\/\/n/g, `
`).replace(/\/\/\/\/\/tilde/g, "`").replace(/\/\/\/\/\/dlrsgn/g, "$"), oV = /[^a-zA-Z0-9\s]/g, AS = (t)=>t.replace(oV, (e)=>"%" + e.charCodeAt(0).toString(16).toUpperCase()), vS = (t)=>t.replace(/%[0-9A-Fa-f]{2}/g, (e)=>String.fromCharCode(parseInt(e.slice(1), 16)));
var pr = new Set([
    "attr",
    "style",
    "text",
    "html",
    "content",
    "data",
    "classlist",
    "state",
    "scope",
    "root",
    "deps",
    "extend",
    "extends",
    "$router",
    "routes",
    "children",
    "childExtend",
    "childExtends",
    "childExtendRecursive",
    "childExtendsRecursive",
    "props",
    "if",
    "define",
    "__name",
    "__ref",
    "__hash",
    "__text",
    "key",
    "tag",
    "query",
    "parent",
    "node",
    "variables",
    "on",
    "fetch",
    "component",
    "context",
    "preventContentUpdate",
    "preventContentRecreate"
]), Hl = new Set([
    "attr",
    "style",
    "text",
    "html",
    "content",
    "data",
    "class",
    "state",
    "scope",
    "children",
    "props",
    "if",
    "key",
    "tag",
    "query",
    "on",
    "context"
]), OS = [
    "ref",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "root"
], ws = new Set([
    "update",
    "parse",
    "clean",
    "create",
    "destroy",
    "add",
    "toggle",
    "remove",
    "apply",
    "set",
    "reset",
    "replace",
    "quietReplace",
    "quietUpdate",
    "applyReplace",
    "applyFunction",
    "keys",
    "values",
    "ref",
    "rootUpdate",
    "parentUpdate",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "root",
    "setByPath",
    "setPathCollection",
    "removeByPath",
    "removePathCollection",
    "getByPath"
]), hr = new Set([
    "update",
    "__element"
]), gr = new Set([
    "set",
    "reset",
    "update",
    "remove",
    "updateContent",
    "removeContent",
    "lookup",
    "lookdown",
    "lookdownAll",
    "whenConnected",
    "getRef",
    "getPath",
    "setNodeStyles",
    "spotByPath",
    "keys",
    "parse",
    "setProps",
    "parseDeep",
    "variables",
    "if",
    "log",
    "verbose",
    "warn",
    "error",
    "call",
    "nextElement",
    "previousElement",
    "getRootState",
    "getRoot",
    "getRootData",
    "getRootContext",
    "getContext",
    "getQuery",
    "getDB",
    "getChildren",
    "getAdoption",
    "facesReady",
    "checkFaces",
    "preventContentUpdate",
    "preventContentRecreate"
]), CS = (t)=>gr.has(t), wa = new Set([
    "log",
    "warn",
    "error",
    "verbose"
]), xs = (t)=>gr.has(t) && !wa.has(t), je = new Set([
    "__proto__",
    "constructor",
    "prototype"
]), Vl = new Set([
    "node",
    "context",
    "extends",
    "__element",
    "__ref",
    ...gr,
    ...ws,
    ...hr
]), RS = new Set([
    "init",
    "beforeClassAssign",
    "render",
    "renderRouter",
    "attachNode",
    "stateInit",
    "stateCreated",
    "beforeStateUpdate",
    "stateUpdate",
    "beforeUpdate",
    "done",
    "create",
    "complete",
    "frame",
    "update",
    "fetchError",
    "fetchComplete"
]);
var LS = [
    "$R?.scope ?? $R?.context?.globalScope ?? {}",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && Object.getPrototypeOf(s) !== g) Object.setPrototypeOf(s, g); return s ?? g ?? {}; })()",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) Object.setPrototypeOf(s, g); return s ?? g ?? {}; })()",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) { try { Object.setPrototypeOf(s, g) } catch (_) {} } return s ?? g ?? {}; })()",
    "(() => { const s = $R?.scope; const g = $R?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) { let __p = g, __cyc = false; while (__p) { if (__p === s) { __cyc = true; break } __p = Object.getPrototypeOf(__p) } if (!__cyc) { try { Object.setPrototypeOf(s, g) } catch (_) {} } } return s ?? g ?? {}; })()",
    "(() => { const r = $R; const s = r?.scope; const g = r?.context?.globalScope; if (s && g && s !== g && Object.getPrototypeOf(s) !== g) { let __p = g, __cyc = false; while (__p) { if (__p === s) { __cyc = true; break } __p = Object.getPrototypeOf(__p) } if (!__cyc) { try { Object.setPrototypeOf(s, g) } catch (_) {} } } return s ?? g ?? (r && typeof r === 'object' && r !== globalThis ? r : {}); })()"
], PS = (t, e)=>t.split("$R").join(e), rV = LS.map((t)=>[
        PS(t, "this"),
        t
    ]), IS = (t)=>PS(LS[LS.length - 1], t), DS = "const __scope = ", sV = /^\(globalThis\[Symbol\.for\('smbls\.libraryScope'\)\] \|\| \(\(_, v\) => v\)\)\("(?:[^"\\]|\\.)*", /, iV = /^\s*(?:async\s*)?(?:\(([^()[\]{}'"`/]*)\)|([A-Za-z_$][\w$]*))\s*=>\s*\{\s*/, aV = /^[A-Za-z_$][\w$]*$/, xa = (t, e)=>typeof t == "string" && new RegExp("^" + e + "\\d*$").test(t), hh = (t, e)=>{
    if (t.length >= 2 && xa(t[0], "el")) return t[0];
    if (t.length >= 2 && xa(t[1], "el")) return t[1];
    if (t.length >= 1 && xa(t[0], "el") || xa(t[0], "element") || xa(t[0], "node")) return t[0];
    if (typeof e == "function") {
        let n = e();
        if (n && t.includes(n)) return n;
    }
    return t.find((n)=>xa(n, "element")) || null;
}, zl = (t)=>{
    if (typeof t != "string" || t.indexOf(DS) === -1 || t.indexOf("this") === -1) return t;
    let e = iV.exec(t);
    if (!e) return t;
    let n = e[0].length;
    if (!t.startsWith(DS, n)) return t;
    n += DS.length;
    let o = sV.exec(t.slice(n, n + 400));
    o && (n += o[0].length);
    let r = rV.find(([l])=>t.startsWith(l, n));
    if (!r) return t;
    let s = n + r[0].length;
    if (t[s] !== (o ? ")" : ";")) return t;
    let a = (e[1] !== void 0 ? e[1] : e[2]).split(",").map((l)=>l.split("=")[0].trim()).filter(Boolean);
    if (a.some((l)=>!aV.test(l))) return t;
    let c = hh(a);
    return c ? t.slice(0, n) + PS(r[1], c) + t.slice(s) : t;
};
var oR = "production", Ts = (t)=>t.charCodeAt(0) === 95 && t.charCodeAt(1) === 95, bt = (t, e, n, o)=>{
    if (P(t)) return e ? typeof t.call != "function" ? t : t.call(e, e, n || e.state, o || e.context) : void 0;
    if (t != null && e?.context?.plugins && (B(t) || k(t) && !_e(t))) {
        let r = e.context.plugins;
        for (let s of r)if (s.resolveHandler) {
            let i = s.resolveHandler(t, e);
            if (typeof i == "function") return bt(i, e, n, o);
        }
    }
    return t;
}, BS = (t, e, n)=>{
    for(let o in e)t[o] = bt(e[o], n);
}, Dt = (t, e, n = [])=>{
    let o = n instanceof Set;
    for(let r in e)Object.prototype.hasOwnProperty.call(e, r) && (Ts(r) || (o ? n.has(r) : n.includes(r)) || t[r] === void 0 && (t[r] = e[r]));
    return t;
}, mt = (t, e, n = Vl)=>uR(t, e, n, null), uR = (t, e, n, o)=>{
    if (t === e) return t;
    if (o) {
        for(let s = 0; s < o.length; s += 2)if (o[s] === t && o[s + 1] === e) return t;
    }
    let r = n instanceof Set;
    for(let s in e){
        if (!Object.prototype.hasOwnProperty.call(e, s) || Ts(s) || s === "constructor" || s === "prototype" || (r ? n.has(s) : n.includes(s))) continue;
        let i = t[s], a = e[s];
        if (z(i) && z(a)) {
            let c = o || [];
            c.push(t, e), uR(i, a, n, c), c.length -= 2;
        } else i === void 0 && (t[s] = a);
    }
    return t;
}, NS = (t, e = [])=>{
    let n = e instanceof Set, o = {};
    for(let r in t)Object.prototype.hasOwnProperty.call(t, r) && (Ts(r) || (n ? e.has(r) : e.includes(r)) || (o[r] = t[r]));
    return o;
}, ft = (t, e = {})=>{
    let { exclude: n = [], cleanUndefined: o = !1, cleanNull: r = !1, visited: s = new WeakMap, handleExtends: i = !1 } = e;
    if (!z(t) || _e(t)) return t;
    if (s.has(t)) return s.get(t);
    let a = n instanceof Set ? n : n.length > 3 ? new Set(n) : null, c = (u)=>a ? a.has(u) : n.includes(u), l = B(t) ? [] : {};
    s.set(t, l);
    let f = [
        [
            t,
            l
        ]
    ];
    for(; f.length;){
        let [u, d] = f.pop();
        for(let p in u){
            if (!Object.prototype.hasOwnProperty.call(u, p) || Ts(p) || p === "__proto__" || c(p)) continue;
            let g = u[p];
            if (!(o && g === void 0) && !(r && g === null)) {
                if (_e(g)) {
                    d[p] = g;
                    continue;
                }
                if (i && p === "extends" && B(g)) {
                    d[p] = Ml(g, n);
                    continue;
                }
                if (P(g)) {
                    d[p] = g;
                    continue;
                }
                if (z(g)) {
                    if (s.has(g)) d[p] = s.get(g);
                    else {
                        let h = B(g) ? [] : {};
                        s.set(g, h), d[p] = h, f.push([
                            g,
                            h
                        ]);
                    }
                } else d[p] = g;
            }
        }
    }
    return l;
}, Wl = (t, e = {})=>{
    (t.node || t.__ref || t.parent || t.__element || t.parse) && ((t.__element || t.parent?.__element).warn("Trying to clone element or state at", t), t = t.parse?.());
    for(let n in t){
        let o = t[n];
        if (P(o)) e[n] = o.toString();
        else if (k(o)) e[n] = {}, Wl(o, e[n]);
        else if (B(o)) {
            let r = e[n] = [];
            for(let s = 0; s < o.length; s++){
                let i = o[s];
                k(i) ? (r[s] = {}, Wl(i, r[s])) : P(i) ? r[s] = i.toString() : r[s] = i;
            }
        } else e[n] = o;
    }
    return e;
}, cV = /^[A-Za-z_$][A-Za-z0-9_$]*$/, lV = (t)=>`'${String(t).replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/\r/g, "\\r").replace(/\n/g, "\\n")}'`, rR = (t)=>{
    let e = String(t);
    return Ul(e, [
        `
`,
        "'"
    ]) ? "`" + e.replace(/\\/g, "\\\\").replace(/`/g, "\\`").replace(/\$\{/g, "\\${") + "`" : "'" + e.replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/\r/g, "\\r") + "'";
}, Kl = (t = {}, e = 0)=>{
    if (t === null || typeof t != "object" || t instanceof RegExp) return String(t);
    let n = !1;
    for(let s in t){
        n = !0;
        break;
    }
    if (!n) return "{}";
    let o = "  ".repeat(e), r = `{
`;
    for(let s in t){
        if (!Object.prototype.hasOwnProperty.call(t, s)) continue;
        let i = t[s], a = cV.test(s) ? s : lV(s);
        if (r += `${o}  ${a}: `, i instanceof RegExp) r += String(i);
        else if (B(i)) {
            r += `[
`;
            for (let c of i)c instanceof RegExp ? r += `${o}    ${String(c)},
` : z(c) && c !== null ? r += `${o}    ${Kl(c, e + 2)},
` : E(c) ? r += `${o}    ${rR(c)},
` : r += `${o}    ${c},
`;
            r += `${o}  ]`;
        } else z(i) ? r += Kl(i, e + 1) : E(i) ? r += rR(i) : r += i;
        r += `,
`;
    }
    return r += `${o}}`, r;
}, fV = [
    /^\(\s*\{[^}]*\}\s*\)\s*=>/,
    /^(\([^)]*\)|[^=]*)\s*=>/,
    /^function[\s(]/,
    /^async\s+/,
    /^\(\s*function/,
    /^[a-zA-Z_$][a-zA-Z0-9_$]*\s*=>/,
    /^(?:\*\s*)?[a-zA-Z_$][\w$]*\s*\((?:[^()]|\([^()]*\))*\)\s*\{[\s\S]*\}$/
], uV = /^["[{]/, dV = /^(export|import)\s/, ie = (t)=>{
    if (!t) return !1;
    let e = t.trim();
    if (e === "" || e === "{}" || e === "[]") return !1;
    let n = e.includes("=>");
    if (!n && e.charCodeAt(0) !== 40 && !e.startsWith("function") && !e.startsWith("async") && !(e.charCodeAt(e.length - 1) === 125 && e.includes("(")) || dV.test(e) || !fV.some((s)=>s.test(e))) return !1;
    let r = e.charCodeAt(0);
    return !(r === 123 && !n || r === 91 || uV.test(e) && !n);
}, dR = (t)=>(0, eval)(t), pV = (t, e)=>{
    let n = /^(\s*(?:async\s+)?function\s*[\w$]*\s*\([^)]*\)\s*)\{/.exec(t);
    if (!n) return null;
    let o = n[0].length, r = [], s = o, i = 1, a = null, c = t.length, l = new RegExp("^(?:const|let|var)\\s+" + e + "\\b");
    for(; s < c && i > 0;){
        let u = t[s];
        if (u === "/" && t[s + 1] === "/") {
            let d = t.indexOf(`
`, s);
            s = d === -1 ? c : d;
            continue;
        }
        if (u === "/" && t[s + 1] === "*") {
            let d = t.indexOf("*/", s + 2);
            s = d === -1 ? c : d + 2;
            continue;
        }
        if (u === '"' || u === "'" || u === "`") {
            let d = u;
            for(s++; s < c;){
                if (t[s] === "\\") {
                    s += 2;
                    continue;
                }
                if (t[s] === d) {
                    s++;
                    break;
                }
                if (d === "`" && t[s] === "$" && t[s + 1] === "{") {
                    s += 2;
                    let p = 1;
                    for(; s < c && p > 0;)t[s] === "{" ? p++ : t[s] === "}" && p--, s++;
                    continue;
                }
                s++;
            }
            continue;
        }
        if (u === "{") {
            i++, s++;
            continue;
        }
        if (u === "}") {
            i--, s++;
            continue;
        }
        if (i === 1 && l.test(t.slice(s))) {
            let d = s, p = 0, g = s;
            for(; g < c;){
                let h = t[g];
                if (h === '"' || h === "'" || h === "`") {
                    let m = h;
                    for(g++; g < c;){
                        if (t[g] === "\\") {
                            g += 2;
                            continue;
                        }
                        if (t[g] === m) {
                            g++;
                            break;
                        }
                        g++;
                    }
                    continue;
                }
                if (h === "(" || h === "[" || h === "{") {
                    p++, g++;
                    continue;
                }
                if (h === ")" || h === "]" || h === "}") {
                    if (p === 0) break;
                    p--, g++;
                    continue;
                }
                if (p === 0 && (h === ";" || h === `
`)) {
                    g++;
                    break;
                }
                g++;
            }
            r.push([
                d,
                g
            ]), s = g;
            continue;
        }
        s++;
    }
    if (!r.length) return null;
    let f = t;
    for(let u = r.length - 1; u >= 0; u--)f = f.slice(0, r[u][0]) + f.slice(r[u][1]);
    return f;
}, Gl = (t, e, n, o)=>{
    let r = String(t).trimStart();
    if (/^(export|import)\s/.test(r)) return t;
    t = zl(t);
    try {
        return n.window.eval(`(${t})`);
    } catch (s) {
        let i = s && s.message ? s.message : String(s), a = /await is only valid in async/.test(i), c = /Identifier '([^']+)' has already been declared/.exec(i), l = null;
        if (a) {
            let f = String(t).trim();
            if (/^function[\s(]/.test(f)) try {
                l = n.window.eval("(async " + f + ")");
            } catch  {}
        } else if (c) {
            let f = String(t), u = c[1];
            for(let d = 0; d < 5; d++){
                let p = pV(f, u);
                if (!p || p === f) break;
                f = p;
                try {
                    l = n.window.eval("(" + f + ")");
                    break;
                } catch (g) {
                    let h = /Identifier '([^']+)' has already been declared/.exec(g && g.message || String(g));
                    if (!h || h[1] !== u) break;
                }
            }
        }
        if (!l && /Unexpected (token '\{'|identifier)/.test(i)) try {
            let f = n.window.eval("({" + t + "})");
            if (f && typeof f == "object") {
                let u = Object.keys(f);
                u.length === 1 && typeof f[u[0]] == "function" && (l = f[u[0]]);
            }
        } catch  {}
        return l || (typeof console < "u" && console.warn && console.warn(`[smbls] deepDestringifyFunctions: eval failed on ${e} \u2014 ` + (o ? "revived lazily, so its source compiled on this first use; it acts as the string it replaces (a call returns the source text, el.call treats it as not callable). Reason: " : "value will be left as a string. Reason: ") + i + `.
First 200 chars of source: ` + String(t).slice(0, 200)), t);
    }
}, pR = 1, MS = 2, ks = new WeakMap, hV = /^(async\s+)?function(?![\w$])\s*(\*)?\s*([A-Za-z_$][\w$]*)?\s*\((?:[^()'"`/]|\([^()'"`/]*\))*\)\s*\{/, gV = /^(async\s+)?[A-Za-z_$][\w$]*\s*=>/, mV = /^(async\s*)?\((?:[^()'"`/]|\([^()'"`/]*\))*\)\s*=>/, yV = /^(async\s+)?([A-Za-z_$][\w$]*)\s*\((?:[^()'"`/]|\([^()'"`/]*\))*\)\s*\{/, _V = new Set([
    "if",
    "for",
    "while",
    "switch",
    "catch",
    "with",
    "do",
    "return",
    "typeof",
    "void",
    "delete",
    "new",
    "in",
    "of",
    "instanceof",
    "function",
    "class",
    "const",
    "let",
    "var",
    "await",
    "yield",
    "import",
    "export",
    "try",
    "else",
    "throw",
    "case",
    "default",
    "break",
    "continue",
    "debugger",
    "finally",
    "super",
    "this",
    "null",
    "true",
    "false",
    "async",
    "get",
    "set",
    "static"
]), sR = (t)=>t >= 48 && t <= 57 || t >= 65 && t <= 90 || t >= 97 && t <= 122 || t === 36 || t === 95, bV = (t, e, n)=>{
    let o = t.indexOf(e, n);
    for(; o !== -1;){
        let r = o + e.length;
        if ((o === 0 || !sR(t.charCodeAt(o - 1))) && (r >= t.length || !sR(t.charCodeAt(r)))) return !0;
        o = t.indexOf(e, r);
    }
    return !1;
}, iR = (t)=>{
    let e = t.length - 1;
    for(; e >= 0 && t.charCodeAt(e) <= 32;)e--;
    return e < 0 ? -1 : t.charCodeAt(e);
}, SV = (t)=>{
    let e = t, n = 0;
    for(; n < e.length && e.charCodeAt(n) <= 32;)n++;
    n && (e = e.slice(n));
    let o = hV.exec(e);
    if (o) {
        if (o[2] || iR(e) !== 125) return null;
        let r = o[3] || "";
        return r && bV(e, r, o[0].indexOf("(")) || e.indexOf("arguments.callee") !== -1 ? null : {
            src: t,
            name: r,
            kind: o[1] ? MS : pR,
            async: !!o[1],
            fn: void 0
        };
    }
    return o = gV.exec(e) || mV.exec(e), o ? {
        src: t,
        name: "",
        kind: MS,
        async: !!o[1],
        fn: void 0
    } : (o = yV.exec(e), o && !_V.has(o[2]) && iR(e) === 125 ? e.indexOf("arguments.callee") !== -1 ? null : {
        src: t,
        name: o[2],
        kind: MS,
        async: !!o[1],
        fn: void 0
    } : null);
}, aR = (t)=>t.index === -1 ? `"${t.key}"` : `array index ${t.index} (prop "${t.key}")`, gh = (t)=>{
    let e = Gl(t.src, aR(t), t.opts, !0), n = null;
    return typeof e == "function" ? n = e : (t.value = e, typeof e != "string" && typeof console < "u" && console.warn && console.warn(`[smbls] deepDestringifyFunctions: ${aR(t)} did not evaluate to a function \u2014 the lazily revived function returns that value.
First 200 chars of source: ` + String(t.src).slice(0, 200))), t.fn = n, t.opts = null, n;
}, wV = (t, e, n)=>Reflect.construct(t, e, n);
function xV() {
    let t = ks.get(this);
    return t ? t.src.trim() : Function.prototype.toString.call(this);
}
var kV = {
    length: {
        get () {
            let t = ks.get(this);
            if (!t) return 0;
            let e = t.fn === void 0 ? gh(t) : t.fn;
            return e ? e.length : 0;
        },
        configurable: !0
    },
    name: {
        get () {
            let t = ks.get(this);
            return t ? t.name : "";
        },
        configurable: !0
    },
    toString: {
        value: xV,
        writable: !0,
        configurable: !0
    }
}, TV = Object.getPrototypeOf(async function() {}), EV = (t)=>{
    let e;
    return t.kind === pR ? e = function() {
        let n = t.fn === void 0 ? gh(t) : t.fn;
        return n === null ? t.value : new.target ? wV(n, arguments, new.target) : n.apply(this, arguments);
    } : e = ({
        lazy () {
            let n = t.fn === void 0 ? gh(t) : t.fn;
            return n === null ? t.value : n.apply(this, arguments);
        }
    }).lazy, ks.set(e, t), Object.defineProperties(e, kV), t.async && Object.setPrototypeOf(e, TV), e;
}, cR = (t, e, n, o)=>{
    let r = SV(t);
    return r ? (r.key = e, r.index = n, r.opts = o, EV(r)) : Gl(t, n === -1 ? `"${e}"` : `array index ${n} (prop "${e}")`, o);
}, FS = (t)=>typeof t == "function" && ks.has(t), Ue = (t)=>{
    let e = ks.get(t);
    return e ? e.src.trim() : Function.prototype.toString.call(t);
}, Es = (t)=>{
    let e = typeof t == "function" ? ks.get(t) : void 0;
    return e ? (e.fn === void 0 ? gh(e) : e.fn) === null : !1;
}, AV = new Set([
    "components",
    "pages",
    "functions",
    "methods",
    "snippets",
    "app",
    "globalScope"
]), hR = {
    window: {
        eval: dR
    }
}, xe = (t, e = {}, n = hR)=>{
    if (!t || typeof t != "object") return e;
    (!n || !n.window || typeof n.window.eval != "function") && (n = {
        ...n,
        window: {
            eval: dR
        }
    });
    let o = n.lazy === !0, r = n.lazy === "context", s = (a, c, l)=>o || r && (a === t ? AV.has(c) : l), i = [
        [
            t,
            e,
            o
        ]
    ];
    for(; i.length;){
        let [a, c, l] = i.pop();
        for(let f in a){
            if (!Object.prototype.hasOwnProperty.call(a, f) || je.has(f)) continue;
            let u = a[f];
            if (E(u)) ie(u) ? c[f] = l ? cR(u, f, -1, n) : Gl(u, `"${f}"`, n) : c[f] = u;
            else if (B(u)) {
                let d = c[f] = [], p = s(a, f, l);
                for(let g = 0; g < u.length; g++){
                    let h = u[g];
                    if (E(h)) d.push(ie(h) ? p ? cR(h, f, g, n) : Gl(h, `array index ${g} (prop "${f}")`, n) : h);
                    else if (k(h)) {
                        let m = fR(h);
                        if (m !== null) d.push(m);
                        else {
                            let y = {};
                            d.push(y), i.push([
                                h,
                                y,
                                p
                            ]);
                        }
                    } else d.push(h);
                }
            } else if (k(u)) {
                let d = fR(u);
                if (d !== null) {
                    c[f] = d;
                    continue;
                }
                let p = c[f] && typeof c[f] == "object" && !B(c[f]) ? c[f] : c[f] = {};
                i.push([
                    u,
                    p,
                    s(a, f, l)
                ]);
            } else c[f] = u;
        }
    }
    return ka(e);
}, gR = "Set", mR = "Map", yR = "RegExp", _R = "WeakMap", bR = "WeakSet", SR = "String", wR = (t)=>{
    if (!t || typeof t != "object" || t.__type !== SR || !E(t.value)) return !1;
    let e = Object.keys(t);
    return e.length === 2 && e.includes("value");
}, ql = wR, Yl = Symbol.for("smbls.revived"), ka = (t)=>{
    if (t && typeof t == "object") try {
        t[Yl] = !0;
    } catch  {}
    return t;
}, As = (t)=>!!(t && typeof t == "object" && t[Yl] === !0), lR = (t)=>{
    let e = Object.keys(t);
    return e.length === 1 && e[0] === "__type";
}, mh = (t, e, n)=>{
    if (!t || typeof t != "object") return t;
    if (wR(t)) return t.value;
    let o = (a)=>mh(a, e || (e = new WeakMap)), r = (a)=>n && E(a) ? n(a) : mh(a, e, n);
    if (t.__type === gR && B(t.values)) return new Set(t.values.map(o));
    if (t.__type === mR && B(t.entries)) return new Map(t.entries.map((a)=>B(a) ? [
            o(a[0]),
            o(a[1])
        ] : a));
    if (t.__type === _R && lR(t)) return new WeakMap;
    if (t.__type === bR && lR(t)) return new WeakSet;
    if (t.__type === yR && E(t.source)) try {
        return new RegExp(t.source, E(t.flags) ? t.flags : "");
    } catch  {
        return t;
    }
    if (e || (e = new WeakMap), e.has(t)) return e.get(t);
    let s = !1;
    if (B(t)) {
        let a = new Array(t.length);
        e.set(t, a);
        for(let c = 0; c < t.length; c++)a[c] = r(t[c]), a[c] !== t[c] && (s = !0);
        return s || e.set(t, t), s ? a : t;
    }
    let i = {};
    e.set(t, i);
    for (let a of Object.keys(t)){
        if (je.has(a)) {
            s = !0;
            continue;
        }
        i[a] = r(t[a]), i[a] !== t[a] && (s = !0);
    }
    return s || e.set(t, t), s ? i : t;
}, fR = (t)=>{
    if (!t || typeof t != "object") return null;
    let e = t.__type;
    if (e !== yR && e !== gR && e !== mR && e !== _R && e !== bR && e !== SR) return null;
    let n = mh(t);
    return n === t ? null : n;
}, vV = (t)=>ie(t) ? Gl(t, "globalScope constant member", hR) : t, vs = (t)=>{
    if (!t || typeof t != "object") return t;
    let e = {}, n = [];
    for (let i of Object.keys(t)){
        if (je.has(i)) continue;
        let a = t[i];
        E(a) && ie(a) ? n.push([
            i,
            a
        ]) : e[i] = mh(a, void 0, vV);
    }
    if (n.length === 0) return e;
    let o = (i)=>/^[A-Za-z_$][\w$]*$/.test(i), r = n.filter(([i])=>o(i)), s = Object.keys(e).filter(o).map((i)=>`var ${i} = __gs__[${JSON.stringify(i)}];`).join(`
`);
    try {
        let i = r.map(([l, f])=>`var ${l} = (${f});`).join(`
`), a = "{ " + r.map(([l])=>`${JSON.stringify(l)}: ${l}`).join(", ") + " }", c = R.eval(`(function(__gs__) { ${s}
${i}
 return ${a}; })`)(e);
        Object.assign(e, c);
    } catch  {
        for (let [a, c] of r)try {
            let l = Object.keys(e).filter(o).map((f)=>`var ${f} = __gs__[${JSON.stringify(f)}];`).join(`
`);
            e[a] = R.eval(`(function(__gs__) { ${l}
 return (${c}); })`)(e);
        } catch  {
            try {
                e[a] = R.eval(`(${c})`);
            } catch  {
                e[a] = c;
            }
        }
    }
    for (let [i, a] of n)if (!o(i)) try {
        e[i] = R.eval(`(${a})`);
    } catch  {
        e[i] = a;
    }
    return e;
}, $S = (t, e = {
    verbose: !0
})=>{
    try {
        return t ? R.eval("(" + t + ")") : {};
    } catch (n) {
        e.verbose && console.warn(n);
    }
}, jS = (t, ...e)=>Object.prototype.hasOwnProperty.call(t, ...e), yh = (t)=>{
    for(let e in t)return !1;
    return !0;
}, US = (t)=>k(t) && yh(t), HS = ()=>Object.create(null), Xl = (t, e, n = {})=>{
    let o = n.exclude || [], r = n.preventUnderscore;
    for(let s in e)o.includes(s) || !r && Ts(s) || s === "constructor" || s === "prototype" || e[s] !== void 0 && (t[s] = e[s]);
    return t;
}, Os = (t, e, n = [])=>{
    let o = n instanceof Set;
    for(let r in e)Ts(r) || r === "constructor" || r === "prototype" || (o ? n.has(r) : n.includes(r)) || (t[r] = e[r]);
    return t;
}, le = (t, e, n = {}, o = new WeakMap)=>{
    if (!z(t) || !z(e) || _e(t) || _e(e)) return e;
    if (o.has(t)) return o.get(t);
    o.set(t, t);
    let r = n.exclude, s = r ? r instanceof Set ? r : new Set(r) : null, i = !n.preventForce;
    for(let a in e){
        if (!Object.prototype.hasOwnProperty.call(e, a) || s && s.has(a) || i && Ts(a) || a === "constructor" || a === "prototype") continue;
        let c = t[a], l = e[a];
        _e(l) ? t[a] = l : z(c) && z(l) ? t[a] = le(c, l, n, o) : l !== void 0 && (t[a] = l);
    }
    return t;
}, _h = (t, e, n = new Set)=>{
    if (typeof t != "object" || typeof e != "object" || t === null || e === null) return t === e;
    if (n.has(t) || n.has(e)) return !0;
    n.add(t), n.add(e);
    let o = Object.keys(t), r = Object.keys(e);
    if (o.length !== r.length) return !1;
    for(let s = 0; s < o.length; s++){
        let i = o[s];
        if (!Object.prototype.hasOwnProperty.call(e, i) || !_h(t[i], e[i], n)) return !1;
    }
    return !0;
}, OV = new Set([
    "node",
    "__ref"
]), VS = (t, e, n = OV)=>{
    if (t === e) return !0;
    if (!z(t) || !z(e) || _e(t) || _e(e)) return t === e;
    let o = n instanceof Set ? n : new Set(n), r = new WeakSet;
    function s(i, a) {
        if (r.has(a)) return !0;
        r.add(a);
        for(let c in a){
            if (!Object.prototype.hasOwnProperty.call(a, c) || o.has(c)) continue;
            if (!Object.prototype.hasOwnProperty.call(i, c)) return !1;
            let l = a[c], f = i[c];
            if (_e(l) || _e(f)) {
                if (l !== f) return !1;
            } else if (z(l) && z(f)) {
                if (!s(f, l)) return !1;
            } else if (l !== f) return !1;
        }
        return !0;
    }
    return s(t, e);
}, zS = (t, e)=>{
    if (e == null) return t;
    if (Se(e)("string", "number")) delete t[e];
    else if (B(e)) for(let n = 0; n < e.length; n++)delete t[e[n]];
    else throw new Error("Invalid input: props must be a string or an array of strings");
    return t;
}, bh = (t)=>{
    if (t === null || typeof t != "object") return t;
    let e = Object.create(null);
    for(let n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = bh(t[n]));
    return e;
}, WS = (t, e)=>{
    if (t.length === 0) return e;
    let n = {}, o = n;
    for(let r = 0; r < t.length; r++)r === t.length - 1 && e ? o[t[r]] = e : (o[t[r]] = {}, o = o[t[r]]);
    return n;
}, KS = (t, e)=>{
    if (!Array.isArray(e)) throw new Error("Path must be an array.");
    let n = t;
    for(let r = 0; r < e.length - 1; r++){
        if (n[e[r]] === void 0) return;
        n = n[e[r]];
    }
    let o = e[e.length - 1];
    n && Object.prototype.hasOwnProperty.call(n, o) && delete n[o];
}, GS = (t, e, n)=>{
    if (!Array.isArray(e)) throw new Error("Path must be an array.");
    let o = t;
    for(let r = 0; r < e.length - 1; r++)(!o[e[r]] || typeof o[e[r]] != "object") && (o[e[r]] = {}), o = o[e[r]];
    return o[e[e.length - 1]] = n, t;
}, qS = (t, e)=>{
    if (!Array.isArray(e)) throw new Error("Path must be an array.");
    let n = t;
    for(let o = 0; o < e.length; o++){
        if (n == null) return;
        n = n[e[o]];
    }
    return n;
}, YS = (t)=>{
    let n = [], o = 0;
    for(let r = 0; r < t.length; r++)if (n.length < 2) n.push(t[r]);
    else if (t[r] === n[r % 2] ? o++ : (n = [
        t[r - 1],
        t[r]
    ], o = 1), o >= 20) return (oR === "test" || oR === "development") && console.warn("Warning: Potential infinite loop detected due to repeated sequence:", n), !0;
}, XS = (t)=>{
    let e = new WeakSet;
    function n(o) {
        if (o && typeof o == "object") {
            if (e.has(o)) return !0;
            e.add(o);
            for(let r in o)if (Object.prototype.hasOwnProperty.call(o, r) && n(o[r])) return console.log(o, "cycle at " + r), !0;
        }
        return !1;
    }
    return n(t);
}, ZS = (t, e)=>{
    let n = e instanceof Set ? e : new Set(e), o = {};
    for(let r in t)Object.prototype.hasOwnProperty.call(t, r) && !n.has(r) && (o[r] = t[r]);
    return o;
};
var Zl = function() {
    let t = 0;
    function e() {
        return t++, t;
    }
    return e;
}(), Ql = Zl, Jl = (t, e, n)=>(bt(n, t) || n || t.key || Zl()).toString();
var Rn = "production", QS = Rn, mr = (t = Rn)=>t === "production", Sh = (t = Rn)=>t === "testing" || t === "test", JS = Sh, tw = (t = Rn)=>t === "staging", ew = (t = Rn)=>t === "local", yr = (t = Rn)=>t === "development" || t === "dev" || t === "local", nw = (t, e = Rn)=>e[t], Do = (t = Rn)=>!mr(t), et = (t)=>{
    if (!t && true) return !1;
    let e = t && "env" in t ? t.env : void 0;
    if (e && e !== "production") return !0;
    let n = t && "hostname" in t ? t.hostname : typeof location < "u" ? location.hostname : void 0;
    return typeof n == "string" && n ? n === "localhost" || n === "127.0.0.1" || n.endsWith(".localhost") : !1;
};
var ow = (t, e)=>{
    let { __ref: n } = t, o = t.if;
    if (P(o)) {
        let r;
        try {
            r = o(t, t.state, t.context);
        } catch (s) {
            typeof console < "u" && console.warn("[DOMQL] if condition error:", s), delete n.__if;
            return;
        }
        r ? n.__if = !0 : delete n.__if;
    } else o != null && typeof o == "object" ? bt(o, t) ? n.__if = !0 : delete n.__if : n.__if = !0;
};
var rw = (t, ...e)=>{
    t && e.map((n)=>console.log(n));
}, sw = (t, e, ...n)=>{
    t && (console.group(e), n.map((o)=>console.log(o)), console.groupEnd(e));
};
var iw = typeof navigator > "u" ? !1 : /Mobi/.test(navigator.userAgent), aw = (t, e, n = 365)=>{
    if (Xt(wt) || Xt(wt.cookie)) return;
    let o = new Date;
    o.setTime(o.getTime() + n * 86400000);
    let r = `expires=${o.toUTCString()}`;
    wt.cookie = `${t}=${e};${r};path=/`;
}, cw = (t)=>{
    if (Xt(wt) || Xt(wt.cookie)) return;
    let e = `${t}=`, o = decodeURIComponent(wt.cookie).split(";");
    for(let r = 0; r < o.length; r++){
        let s = o[r];
        for(; s.charAt(0) === " ";)s = s.substring(1);
        if (s.indexOf(e) === 0) return s.substring(e.length, s.length);
    }
    return "";
}, lw = (t)=>{
    Xt(wt) || Xt(wt.cookie) || (wt.cookie = t + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
};
function fw(t) {
    let e;
    try {
        if (!window.localStorage) return;
        e = window.localStorage.getItem(t);
    } catch  {
        return;
    }
    if (e !== null) try {
        return JSON.parse(e);
    } catch  {
        return;
    }
}
function uw(t, e) {
    if (e != null) try {
        if (!window.localStorage) return;
        let n = typeof e == "object" ? JSON.stringify(e) : e;
        window.localStorage.setItem(t, n);
    } catch  {}
}
var Ta = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style",
        "noscript",
        "script"
    ],
    body: new Set([
        "string",
        "style",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "search",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "hgroup",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "hgroup",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        "svg",
        "path",
        "circle",
        "ellipse",
        "line",
        "polygon",
        "polyline",
        "rect",
        "g",
        "defs",
        "symbol",
        "use",
        "text",
        "tspan",
        "image",
        "clipPath",
        "mask",
        "pattern",
        "marker",
        "linearGradient",
        "radialGradient",
        "stop",
        "filter",
        "feGaussianBlur",
        "feOffset",
        "feMerge",
        "feMergeNode",
        "feBlend",
        "feColorMatrix",
        "feFlood",
        "feComposite",
        "foreignObject"
    ])
}, xR = new Set([
    "svg",
    "path",
    "circle",
    "ellipse",
    "line",
    "polygon",
    "polyline",
    "rect",
    "g",
    "defs",
    "symbol",
    "use",
    "text",
    "tspan",
    "image",
    "clipPath",
    "mask",
    "pattern",
    "marker",
    "linearGradient",
    "radialGradient",
    "stop",
    "filter",
    "feGaussianBlur",
    "feOffset",
    "feMerge",
    "feMergeNode",
    "feBlend",
    "feColorMatrix",
    "feFlood",
    "feComposite",
    "foreignObject"
]), dw = (t)=>Ta.body.has(t);
var pw = "production", kR = (t)=>t.sourcemap !== !1 && pw !== "production", Lo = (t)=>{
    if (!t) return [];
    let e = [], n = t.extends;
    n && (B(n) ? e.push(...n) : e.push(n));
    let o = t.extend;
    return o && (B(o) ? e.push(...o) : e.push(o)), e;
}, en = (t)=>{
    if (!B(t)) return t;
    let e = [];
    for(let n = t.length - 1; n >= 0; n--){
        let o = t[n];
        e.push(B(o) ? en(o) : o);
    }
    return e;
}, Aa = (t)=>{
    if (t.includes("+")) return t.split("+").filter(oo);
    if (t.includes("_")) {
        let [e] = t.split("_");
        return [
            e
        ];
    }
    if (t.includes(".") && !oo(t.split(".")[1])) {
        let [e] = t.split(".");
        return [
            e
        ];
    }
    return [
        t
    ];
}, nf = (t, e, n)=>{
    let o = [], r = Aa(n);
    r && (o = [
        ...r
    ]);
    let s = en(Lo(t));
    return s.length && (o = [
        ...o,
        ...s
    ]), o;
}, eo = (t, e)=>{
    let { __ref: n } = e, { __extends: o } = n;
    if (!t) return o;
    let r = e.variant, s = e.context;
    if (r && s?.components && !Array.isArray(t) && typeof t == "string") {
        let i = `${t}.${r}`;
        s.components[i] && (t = i);
    }
    return o.includes(t) || (o = Array.isArray(t) ? [
        ...o,
        ...t
    ] : [
        ...o,
        t
    ], n.__extends = o), o;
}, hw = (t, e)=>{
    if (!t) return e;
    let { extends: n } = e, o = B(n) ? n : [
        n
    ], r = B(t) ? t : [
        t
    ];
    return {
        ...e,
        extends: ma(r, o)
    };
}, wh = ()=>Math.random().toString(36).substring(2), of = {}, gw = {}, rf = (t)=>of[t.__hash], xh = (t, e)=>{
    let n = wh();
    return E(t) || (t.__hash = n), n !== "__proto__" && n !== "constructor" && n !== "prototype" && (of[n] = e), e;
}, kh = (t, e)=>t.__hash ? e.concat(rf(t)) : xh(t, e), sf = (t, e, n, o = new Set, r, s, i)=>{
    for (let a of t)B(a) ? sf(a, e, n, o, r, s, i) : va(a, e, n, o, r, void 0, s, i);
    return e;
}, Th = (t, e, n, o = new Set, r, s, i)=>{
    let a = Lo(t), c = {
        ...t
    };
    delete c.extends, delete c.extend;
    let l = !1;
    for(let f in c){
        l = !0;
        break;
    }
    return l && (e.push(c), r && r.push(s)), a.length && va(en(a), e, n, o, r, s, i, t), e;
}, va = (t, e, n, o = new Set, r, s, i, a)=>{
    if (!t || o.has(t)) return e;
    if (B(t)) return sf(t, e, n, o, r, i, a);
    let c = s;
    return E(t) ? (c = t, t = cf(t, n, void 0, void 0, a)) : i && k(t) && i.has(t) && (c = i.get(t)), o.has(t) || (o.add(t), t?.extends || t?.extend ? Th(t, e, n, o, r, c, i) : t && (e.push(t), r && r.push(c))), e;
}, CV = new Set([
    "parent",
    "node",
    "__ref",
    "__proto__",
    "extends",
    "extend",
    "childExtends",
    "childExtendsRecursive"
]), no = (t, e, n, o, r)=>{
    e = ft(e);
    for(let s in e){
        if (CV.has(s)) continue;
        let i = t[s], a = e[s];
        if (a !== void 0 && Object.prototype.hasOwnProperty.call(e, s) && s !== "__proto__" && s !== "constructor" && s !== "prototype") {
            if (i === void 0) t[s] = a, n && o ? k(a) && !B(a) ? (n[s] = n[s] || {}, TR(n[s], a, o)) : n[s] = o : n && r?.[s] && (n[s] = r[s]);
            else if (k(i) && k(a)) {
                let c = n ? n[s] = n[s] || {} : void 0, l = r?.[s];
                oo(s) ? t[s] = no(i, a, c, o, l) : no(i, a, c, o, l);
            }
            if (s === "extends" || s === "childExtends" || s === "childExtendsRecursive") {
                if (B(i) && B(a)) t[s] = i.concat(a);
                else if (B(i) && k(a)) {
                    let c = no({}, i);
                    t[s] = no(c, a);
                }
            }
        }
    }
    return t;
}, TR = (t, e, n, o)=>{
    if (o || (o = new WeakSet), !o.has(e)) {
        o.add(e);
        for(let r in e){
            if (!Object.prototype.hasOwnProperty.call(e, r) || r === "__proto__" || r === "constructor" || r === "prototype") continue;
            let s = e[r];
            k(s) && !B(s) ? (t[r] = t[r] || {}, TR(t[r], s, n, o)) : t[r] = n;
        }
    }
}, tf = (t, e, n)=>t.reduce((o, r, s)=>{
        let i = ft(r), a = n ? n[s] : void 0;
        return no(o, i, e, a);
    }, {}), Ea = Symbol.for("smbls.shadowedComponents"), Eh = (t, e)=>{
    let n = t && t[Ea];
    return n ? n.get(e) : void 0;
}, af = (t, e, n)=>{
    if (!t || !n || typeof n != "object" || B(n) || t.components && t.components[e] === n) return;
    let o = t[Ea];
    o || (o = new Map, Object.defineProperty(t, Ea, {
        configurable: !0,
        enumerable: !1,
        writable: !0,
        value: o
    }));
    let r = o.get(e);
    r ? r.includes(n) || r.push(n) : o.set(e, [
        n
    ]);
}, Ah = (t, e, n, o)=>{
    let r = Eh(o, e), s = r ? r.length + 1 : 1, i = null, a = !1;
    for(let c = 0; c <= s; c++){
        let l = c === 0 ? t[e] : c === s ? t["smbls." + e] : r[c - 1];
        if (l) {
            if (l === n) a = !0;
            else {
                if (a) return l;
                i === null && (i = l);
            }
        }
    }
    return a ? null : i;
}, cf = (t, e, n = {}, o, r)=>{
    let s = e?.components || n.components, i = e?.pages || n.pages;
    if (E(t)) {
        let a = s && (s[t + "." + o] || Ah(s, t, r, e)), c = i && t.charCodeAt(0) === 47 && i[t];
        if (a) return a;
        if (c) return c;
        n.verbose && (pw === "test" || pw === "development") && console.warn("Extend is string but component was not found:", t);
        return;
    }
    return t;
}, mw = (t, e)=>[].concat(t.slice(0, 1)).concat(e.slice(0, 1)).concat(t.slice(1)).concat(e.slice(1)), ef = (t, e, n, o)=>{
    if (!t) return [];
    if (t.__hash) return rf(t) || [];
    let s = va(t, [], e, new Set, n, void 0, o);
    return n ? s : kh(t, s);
}, yw = (t, e)=>{
    if (!t) return e;
    let n = B(t) ? t : [
        t
    ];
    return ma(n, e);
}, _w = (t)=>{
    let e = [];
    function n(o) {
        for(let r in o)Object.prototype.hasOwnProperty.call(o, r) && (oo(r) && e.push(r), r === "extends" && (typeof o[r] == "string" ? e.push(o[r]) : Array.isArray(o[r]) && (e = e.concat(o[r]))), typeof o[r] == "object" && o[r] !== null && n(o[r]));
    }
    return n(t), e;
}, vh = (t, e, n = {})=>{
    let { __ref: o } = t, r = t.context || e.context, s = t.variant, i = Lo(t);
    if (i.length) {
        let a = en(i), [c, ...l] = a, f = typeof c == "string" && s && r?.components ? `${c}.${s}` : null;
        f && r.components[f] ? eo([
            f,
            ...l
        ], t) : eo(a, t);
    }
    return Oh(t, e, n), Ch(t, e, n), Rh(t, e, n), t.component && eo(en(bt(t.component, t)), t), r.defaultExtends && eo(en(r.defaultExtends), t), ya(o.__extends);
}, Oh = (t, e, n = {})=>{
    let { __ref: o } = t;
    return n.ignoreChildExtends || t.ignoreChildExtends || e.childProps?.extends && eo(en(e.childProps.extends), t), o.__extends;
}, Ch = (t, e, n = {})=>{
    let { __ref: o } = t, r = n.ignoreChildExtends || t.ignoreChildExtends, s = e.childExtends;
    return !r && s && eo(en(s), t), o.__extends;
}, Rh = (t, e, n = {})=>{
    let { __ref: o } = t, r = e.childExtendsRecursive, s = n.ignoreChildExtendsRecursive || t.ignoreChildExtendsRecursive, i = t.key === "__text";
    return r && !i && !s && eo(en(r), t), o.__extends;
}, Dh = (t, e, n = {})=>{
    let { __ref: o } = t, r = t.context || e.context, s = t.variant, i = kR(n), a = i ? [
        ...o.__extends
    ] : null, c = ya(o.__extends.map((l, f)=>cf(l, r, n, f === 0 && s, t)));
    if (i) {
        let l = new WeakMap;
        for(let d = 0; d < c.length; d++){
            let p = c[d], g = a[d];
            p && k(p) && E(g) && l.set(p, g);
        }
        let f = [], u = ef(c, r, f, l);
        o.__extendsStack = u, o.__extendsNames = f;
    } else {
        let l = ef(c, r);
        o.__extendsStack = l;
    }
    return o.__extendsStack;
}, Lh = (t, e, n = {})=>{
    let { __ref: o } = t, { __extendsStack: r } = o;
    if (kR(n)) {
        let s = {}, i = o.__extendsNames || [], a = tf(r, s, i), c = {};
        no(t, a, c, void 0, s), o.__sourcemap = c;
    } else {
        let s = tf(r);
        no(t, s);
    }
    return t;
}, ER = (t, e, n = {})=>(vh(t, e, n), Dh(t, e, n), Lh(t, e, n), t);
var oo = (t)=>{
    if (!E(t) || !t.length) return !1;
    let e = t.charCodeAt(0);
    return e >= 65 && e <= 90;
};
function bw(t) {
    return Object.keys(t).filter((e)=>/^[A-Z]/.test(e));
}
function Sw(t) {
    return Object.keys(t).filter((e)=>/^\d+$/.test(e));
}
function ww(t, e, n) {
    let { context: o } = e || {}, [r] = Aa(n), s = n || r;
    return o?.components?.[s] || o?.pages?.[s];
}
function AR(t, e) {
    let { props: n, on: o } = e, r = Ss(t.split("on")[1]), s = o[r], i = n[t];
    P(s) ? o[r] = (...a)=>{
        if (s(...a) !== !1 && P(i)) return i(...a);
    } : o[r] = i;
}
var xw = /^[A-Z]/, vR = /^\d+$/, OR = new Set([
    ":",
    "@",
    "[",
    "*",
    "+",
    "~",
    "&",
    ">",
    "$",
    "-",
    ".",
    "!"
]), RV = new Set([
    "extend",
    "props",
    "text",
    "tag",
    "on",
    "if",
    "childExtend",
    "children",
    "childrenAs",
    "state",
    "html",
    "attr",
    "define",
    "content"
]), DV = (t)=>{
    if (!t || typeof t != "object" || Array.isArray(t)) return !1;
    for(let e in t)if (RV.has(e) || xw.test(e)) return !0;
    return !1;
}, uf = (t, e, n)=>{
    let { props: o, __ref: r } = t;
    if (r.__propsStack = [], o) r.__initialProps = o;
    else return {};
    return z(o) ? {
        ...o
    } : (r.__propsStack.push(o), {});
};
function Ph(t, e = {}) {
    let n = e.cachedKeys || [];
    for(let o in t){
        let r = t[o];
        if (o.length > 2 && o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o[2] === o[2].toUpperCase() && (P(r) || r != null && _a(this.context))) {
            let g = Ss(o.slice(2));
            t.on && (t.on[g] = r), delete t[o];
            continue;
        }
        if (o === "childProps") {
            t.props[o] = r, delete t[o], n.push(o);
            continue;
        }
        let a = this.define?.[o], c = this.context?.define?.[o], l = k(a) || P(a), f = k(c) || P(c);
        if (l || f) continue;
        let u = o.charAt(0);
        if (OR.has(u)) {
            t.props[o] = r, delete t[o], n.push(o);
            continue;
        }
        let d = xw.test(o) || vR.test(o) || DV(r), p = pr.has(o);
        !d && !p && (o in t.props || (t.props[o] = r), delete t[o], n.push(o));
    }
    return t;
}
function Ih(t = this, e) {
    let n = e.cachedKeys || [];
    for(let o in t.props){
        let r = t.props[o], s = o.length > 2 && o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110, i = P(r) || r != null && _a(this.context);
        if (s && i) {
            AR(o, t), delete t.props[o];
            continue;
        }
        if (n.includes(o) || o === "childProps") continue;
        let a = o.charAt(0);
        if (OR.has(a)) continue;
        let c = this.define?.[o], l = this.context?.define?.[o], f = k(c) || P(c), u = k(l) || P(l), d = xw.test(o) || vR.test(o), p = pr.has(o);
        (d || p || f || u) && (t[o] === void 0 || r === null) && (t[o] = r, t.props && delete t.props[o]);
    }
    return t;
}
function Mh(t = this) {
    let e = [];
    return Ph.call(this, t, {
        cachedKeys: e
    }), Ih.call(this, t, {
        cachedKeys: e
    }), t;
}
function kw(t = {}) {
    return t.on || (t.on = {}), t.props || (t.props = {}), Mh.call(this, t);
}
var lf = (t)=>Se(t)("string", "number") ? {
        inheritedString: t
    } : t, Tw = (t, e)=>!t || !e.length ? !1 : e.includes(t), df = (t, e)=>{
    let { __ref: n } = t, o = n.__propsStack || [], r = e.props;
    if (!r) return o;
    let s = r[t.key], i = r.childProps || e.childProps, a = t.props?.ignoreChildProps;
    if (i && !a) {
        let c = lf(i);
        o.unshift(c);
    }
    if (s) {
        let c = lf(s);
        o.unshift(c);
    }
    return o;
};
function Ew(t, e) {
    this.__element.update({
        props: t
    }, e);
}
function pf(t) {
    let e = {
        update: Ew.bind(t.props),
        __element: t
    };
    Object.setPrototypeOf(t.props, e);
}
var hf = (t)=>{
    let e = new Set;
    return t.filter((n)=>!n || hr.has(n) || e.has(n) ? !1 : (e.add(n), !0));
}, gf = (t, e, n)=>(e.props = t.reduce((o, r)=>{
        if (hr.has(r)) return o;
        for(; P(r);)r = bt(r, e);
        return mt(o, ft(r, {
            exclude: hr
        }));
    }, {}), pf(e), e.props), Bh = (t, e)=>{
    let { props: n, __ref: o } = t, r = o.__propsStack || [];
    if (e?.props && (r = [
        ...df(t, e)
    ]), k(n) ? r.push(n) : n === "inherit" && e?.props ? r.push(e.props) : n && r.push(n), B(o.__extendsStack)) for(let s = 0; s < o.__extendsStack.length; s++){
        let i = o.__extendsStack[s];
        i.props && i.props !== n && r.push(i.props);
    }
    return o.__propsStack = hf(r), o.__propsStack;
}, ff = (t, e)=>{
    let { __ref: n } = t, o = Bh(t, e);
    o.length ? gf(o, t) : (n.__propsStack = [], t.props = {});
}, Aw = function(t, e, n) {
    let { __ref: o } = t;
    if (o.__if) ff(t, e);
    else try {
        ff(t, e);
    } catch (r) {
        t.context?.designSystem?.verbose && console.warn("initProps error at", o.path?.join("."), r), t.props = {}, o.__propsStack = [];
    }
    return pf(t), t;
}, vw = (t, e, n)=>{
    let { __ref: o } = e, s = [
        ...o.__propsStack || []
    ], i = df(e, n);
    return i.length && (s = [
        ...i,
        ...s
    ]), t && (s = [
        t,
        ...s
    ]), o.__propsStack = hf(s), o.__propsStack.length && gf(o.__propsStack, e), e;
};
var CR = "production", Nh = (t, e, n)=>{
    let o = e.childExtends && e.childExtends.tag, r = e.childProps && e.childProps.tag, s = Ta.body.has(n) && n;
    return {
        text: t,
        tag: o || r || s || "string"
    };
}, Fh = (t, e, n)=>{
    if (t === void 0) return (CR === "test" || CR === "development") && console.warn(n, "element is undefined in", e?.__ref?.path), {};
    if (t !== null) return t === !0 ? {} : Se(t)("string", "number") ? Nh(t, e, n) : P(t) ? {
        props: t
    } : t;
}, $h = (t, e)=>{
    let n = {};
    return n.origin = t, n.parent = e, n;
}, jh = (t, e, n, o, r)=>{
    if (!e) return r;
    if (Ro(e)) {
        let s = {
            key: ":root",
            node: e
        };
        return r[`${n}_parent`] = s, s;
    }
    return e;
}, Ow = (t, e)=>{
    let { __ref: n } = t, { __ref: o } = e, r = e && e.key === ":root";
    n?.root || (n.root = r ? t : o?.root);
}, Uh = (t, e, n)=>{
    let { __ref: o } = e;
    return o || (o = e.ref = {}), o.path || (o.path = []), o.path.concat(n);
}, Hh = (t, e, n, o, r)=>(o.context && !r.context && !t.context && (r.context = o.context), o.context || e.context || r.context || t.context), Vh = (t, e, n)=>{
    let o = $h(t, e);
    return t.__ref = o, o.__defineCache || (o.__defineCache = {}), o.__exec || (o.__exec = {}), o.__execProps || (o.__execProps = {}), o.__class || (o.__class = {}), o.__classNames || (o.__classNames = {}), o.__attr || (o.__attr = {}), o.__changes || (o.__changes = []), o.__children || (o.__children = []), o.__extends = nf(t, e, n), o.path = Uh(t, e, n), o;
}, Cw = (t, e, n, o, r)=>{
    let i = t?.__hash ? {
        extends: [
            t
        ]
    } : Fh(t, e, n);
    if (!i) return;
    let a = jh(i, e, n, o, r), c = Jl(i, a, n);
    Vh(i, a, c);
    let l = uf(i, a, c), f = Hh(i, a, c, o, r), u = i.on || {};
    return {
        ...i,
        key: c,
        props: l,
        parent: a,
        context: f,
        on: u
    };
};
var Rw = (t)=>{
    let { state: e, props: n, __ref: o } = t, r = n?.state || e;
    return Se(r)("string", "number") ? (o.__state = r, {
        value: r
    }) : r === !0 ? (o.__state = t.key, {}) : r ? (o.__hasRootState = !0, r) : !1;
}, zh = (t, e)=>{
    if (!t.includes("~/")) return;
    if (t.split("~/").length > 1) return e.root;
}, Wh = (t, e)=>{
    if (!t.includes("../")) return;
    let o = t.split("../").length - 1;
    for(let r = 0; r < o; r++){
        if (!e.parent) return null;
        e = e.parent;
    }
    return e;
}, Kh = (t, e, n = {})=>{
    let o = E(t) ? t.split("/") : [
        t
    ], r = o.length - 1;
    for(let s = 0; s < r; s++){
        let i = o[s], a = o[s + 1];
        if (i === "__proto__" || a === "__proto__") return;
        let c = e[i];
        c || (c = e[i] = {}), c[a] || (c[a] = {}), t = a, e = c;
    }
    return n.returnParent ? e : e[t];
}, Gh = (t, e, n = {})=>{
    let r = t.__ref.__state;
    if (!qh(t)) return;
    let s = zh(r, e.state), i = e.state;
    if (s) i = s, r = r.replaceAll("~/", "");
    else {
        let a = Wh(r, e.state);
        a && (i = a, r = r.replaceAll("../", ""));
    }
    if (i) return Kh(r, i, n);
}, Dw = (t, e)=>{
    let n = t.__ref, o = Gh(t, e);
    if (o === void 0) return t.state;
    if (Se(o)("object", "array")) return ft(o);
    if (Se(o)("string", "number", "boolean")) return n.__stateType = typeof o, {
        value: o
    };
}, qh = (t)=>{
    let { __ref: e } = t, n = e?.__state;
    return !!(n && Se(n)("number", "string", "boolean"));
}, Lw = function(t) {
    return z(t) ? !!(t.update && t.parse && t.clean && t.create && t.parent && t.destroy && t.rootUpdate && t.parentUpdate && t.keys && t.values && t.toggle && t.replace && t.quietUpdate && t.quietReplace && t.add && t.apply && t.applyReplace && t.setByPath && t.setPathCollection && t.removeByPath && t.removePathCollection && t.getByPath && t.applyFunction && t.__element && t.__children) : !1;
}, Pw = (t, e)=>{
    if (!t) return e || {};
    let n = t.split("/"), o = {}, r = o, s = n.length - 1;
    for(let i = 0; i <= s; i++)r[n[i]] = i === s ? e || {} : {}, r = r[n[i]];
    return o;
}, Iw = (t, e)=>{
    let { __element: n } = e, o = n?.state;
    if (!o) return;
    let r = ft(o, ws), s = {
        [t.key]: r
    }, i = k(o.__depends) ? {
        ...o.__depends,
        ...s
    } : s;
    return Array.isArray(o) ? Nl(o, {
        ...Object.getPrototypeOf(o),
        __depends: i
    }) : Object.setPrototypeOf(o, {
        ...Object.getPrototypeOf(o),
        __depends: i
    }), r;
}, Yh = new Set([
    "parent",
    "root"
]), RR = new Set, LV = (t)=>{
    RR.has(t) || RR.add(t);
}, PR = (t, e, n, o)=>{
    if (t === e) return t;
    for(let r = 0; r < o.length; r += 2)if (o[r] === t && o[r + 1] === e) return t;
    for(let r in e){
        if (!Object.prototype.hasOwnProperty.call(e, r) || r.charCodeAt(0) === 95 && r.charCodeAt(1) === 95 || r === "constructor" || r === "prototype") continue;
        let s = n ? n + "." + r : r;
        if (Yh.has(r)) {
            LV(s);
            continue;
        }
        let i = t[r], a = e[r];
        z(i) && z(a) ? (o.push(t, e), PR(i, a, s, o), o.length -= 2) : i === void 0 && (t[r] = a);
    }
    return t;
}, _r = (t, e)=>!z(t) || !z(e) ? t : PR(t, e, "", []), Mw = (t, e, n = {})=>{
    let { overwrite: o } = n;
    if (!o) return;
    let r = o === "shallow";
    if (o === "merge") {
        mt(t, e, ws);
        return;
    }
    (r ? Os : le)(t, e, ws);
}, DR = "__polyglotSeededKeys", br = (t)=>{
    if (!k(t)) return new Set;
    let e = t[DR];
    if (!(e instanceof Set)) {
        e = new Set;
        try {
            Object.defineProperty(t, DR, {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            });
        } catch  {}
    }
    return e;
}, Cs = (t, e, n)=>br(t).has(e) ? !0 : !k(n) || n[e] === void 0, LR = "__polyglotSeededValues", IR = (t)=>{
    if (!k(t)) return new Map;
    let e = t[LR];
    if (!(e instanceof Map)) {
        e = new Map;
        try {
            Object.defineProperty(t, LR, {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
            });
        } catch  {}
    }
    return e;
}, MR = (t)=>{
    if (t === null || typeof t != "object") return typeof t + ":" + String(t);
    try {
        return "json:" + JSON.stringify(t);
    } catch  {
        return null;
    }
}, mf = (t, e, n)=>{
    if (!br(t).has(e)) return !1;
    let o = IR(t);
    if (!o.has(e)) return !0;
    let r = k(n) || Array.isArray(n) ? n[e] : void 0, s = MR(r);
    return s !== null && s === o.get(e);
}, ro = (t, e, ...n)=>(br(t).add(e), n.length && IR(t).set(e, MR(n[0])), e);
var PV = (t, e)=>{
    let n = e;
    for(; n;){
        if (n === t) return !0;
        n = Object.getPrototypeOf(n);
    }
    return !1;
}, Bw = (t, e)=>{
    let { __ref: n } = t, o = t.context || e.context || n.root?.context;
    o && !o.globalScope && (o.globalScope = {});
    let r = e.scope || n.root?.scope, s = o?.globalScope;
    if (!t.scope) r ? t.scope = r : s ? t.scope = Object.create(s) : t.scope = {};
    else if (typeof t.scope == "object" && t.scope !== null && Object.getPrototypeOf(t.scope) === Object.prototype) {
        let i = r || s;
        i && !PV(t.scope, i) && Object.setPrototypeOf(t.scope, i);
    }
};
var $s = /*@__PURE__*/ F({}, {
    EARLY_KEY: ()=>so,
    SEED_BLOCK: ()=>yf,
    STALE_ATTRIBUTE: ()=>zw,
    createAdapter: ()=>d5,
    createEarlySeedBlock: ()=>zR,
    createEarlySeedScript: ()=>ZR,
    default: ()=>G5,
    earlyKey: ()=>xr,
    executeFetch: ()=>px,
    fetchFunctions: ()=>V5,
    fetchPlugin: ()=>K5,
    fetchRunsOf: ()=>h5,
    hasAdapter: ()=>u5,
    initAdapterAuth: ()=>sg,
    parseDuration: ()=>Sr,
    queryClient: ()=>H5,
    registerAdapter: ()=>f5,
    requestsInFlight: ()=>cD,
    resolveDb: ()=>xD,
    revalidateSeed: ()=>z5,
    seedFromPage: ()=>$D,
    seedIsStale: ()=>YR,
    whenRequestsIdle: ()=>lD,
    whenSeedTaken: ()=>qR
});
var Nw = /*@__PURE__*/ F({}, {
    localAdapter: ()=>BR,
    setup: ()=>MV
});
var Xh = (t, e)=>{
    if (!e) return !0;
    for(let n in e){
        let o = e[n];
        if (o === null) {
            if (t[n] !== null && t[n] !== void 0) return !1;
        } else if (Array.isArray(o)) {
            if (!o.includes(t[n])) return !1;
        } else if (typeof o == "object") {
            for(let r in o)if (r === "gt" && !(t[n] > o[r]) || r === "gte" && !(t[n] >= o[r]) || r === "lt" && !(t[n] < o[r]) || r === "lte" && !(t[n] <= o[r]) || r === "neq" && t[n] === o[r] || r === "like" && !String(t[n]).includes(o[r])) return !1;
        } else if (t[n] !== o) return !1;
    }
    return !0;
}, IV = (t, { order: e, limit: n, offset: o, single: r })=>{
    let s = [
        ...t
    ];
    if (e) {
        let i = typeof e == "string" ? e : e.by, a = e.asc !== !1;
        s.sort((c, l)=>c[i] < l[i] ? a ? -1 : 1 : c[i] > l[i] ? a ? 1 : -1 : 0);
    }
    return o && (s = s.slice(o)), n && (s = s.slice(0, n)), r ? {
        data: s[0] || null,
        error: null
    } : {
        data: s,
        error: null
    };
}, MV = async ({ data: t, ...e })=>BR(t, e), BR = (t = {}, e = {})=>{
    let n = {}, o = {}, r = e.persist !== !1 && typeof localStorage < "u", s = e.prefix || "smbls_db_", i = (f)=>{
        if (!n[f]) {
            if (r) try {
                let u = localStorage.getItem(s + f);
                n[f] = u ? JSON.parse(u) : t[f] || [];
            } catch  {
                n[f] = t[f] || [];
            }
            else n[f] = t[f] || [];
        }
        return n[f];
    }, a = (f)=>{
        if (r) try {
            localStorage.setItem(s + f, JSON.stringify(n[f]));
        } catch  {}
    }, c = (f, u, d, p)=>{
        let g = o[f];
        if (g) for (let h of g)h(d, p, {
            event: u,
            table: f
        });
    }, l = Date.now();
    return {
        name: "local",
        store: n,
        select: async ({ from: f, params: u, ...d })=>{
            let g = i(f).filter((h)=>Xh(h, u));
            return IV(g, d);
        },
        insert: async ({ from: f, data: u })=>{
            let d = i(f), g = (Array.isArray(u) ? u : [
                u
            ]).map((h)=>{
                let m = {
                    id: h.id || ++l,
                    ...h
                };
                return d.push(m), m;
            });
            a(f);
            for (let h of g)c(f, "INSERT", h, null);
            return {
                data: Array.isArray(u) ? g : g[0],
                error: null
            };
        },
        update: async ({ from: f, data: u, params: d })=>{
            let p = i(f), g = [];
            for(let h = 0; h < p.length; h++)if (Xh(p[h], d)) {
                let m = {
                    ...p[h]
                };
                Object.assign(p[h], u), g.push(p[h]), c(f, "UPDATE", p[h], m);
            }
            return a(f), {
                data: g,
                error: null
            };
        },
        upsert: async ({ from: f, data: u, params: d })=>{
            let p = i(f), g = Array.isArray(u) ? u : [
                u
            ], h = [];
            for (let m of g){
                let y = d || (m.id !== void 0 ? {
                    id: m.id
                } : null), b = y ? p.findIndex((T)=>Xh(T, y)) : -1;
                if (b > -1) {
                    let T = {
                        ...p[b]
                    };
                    Object.assign(p[b], m), h.push(p[b]), c(f, "UPDATE", p[b], T);
                } else {
                    let T = {
                        id: m.id || ++l,
                        ...m
                    };
                    p.push(T), h.push(T), c(f, "INSERT", T, null);
                }
            }
            return a(f), {
                data: Array.isArray(u) ? h : h[0],
                error: null
            };
        },
        delete: async ({ from: f, params: u })=>{
            let d = i(f), p = [];
            for(let g = d.length - 1; g >= 0; g--)Xh(d[g], u) && (p.push(d[g]), d.splice(g, 1), c(f, "DELETE", null, p[p.length - 1]));
            return a(f), {
                data: p,
                error: null
            };
        },
        subscribe: ({ from: f, on: u }, d)=>{
            o[f] || (o[f] = []);
            let p = (g, h, m)=>{
                u && u !== "*" && u !== m.event || d(g, h, m);
            };
            return o[f].push(p), ()=>{
                let g = o[f].indexOf(p);
                g > -1 && o[f].splice(g, 1);
            };
        }
    };
};
var $w = /*@__PURE__*/ F({}, {
    createSdkAdapter: ()=>jR,
    setup: ()=>zV
});
var NR = Symbol.for("@symbo.ls/fetch:SYMBOLS_SDK"), Fw = "[@symbo.ls/fetch] symbols adapter: ", BV = ({ params: t, single: e, limit: n, offset: o, order: r, options: s })=>({
        filter: t,
        params: t,
        single: e,
        limit: n,
        offset: o,
        order: r,
        options: s,
        ...t || {}
    }), FR = ({ data: t, params: e })=>({
        payload: t,
        data: t,
        ...e || {}
    }), NV = ({ params: t, data: e })=>({
        id: t?.id ?? t?.number,
        number: t?.number ?? t?.id,
        payload: e,
        data: e,
        ...t || {}
    }), FV = ({ params: t })=>({
        id: t?.id ?? t?.number,
        number: t?.number ?? t?.id,
        ...t || {}
    }), Rs = (t)=>{
    let e;
    try {
        e = t();
    } catch (n) {
        e = Promise.reject(n);
    }
    return Promise.resolve(e).then((n)=>({
            data: n,
            error: null
        }), (n)=>({
            data: null,
            error: n
        }));
}, $R = (t)=>{
    try {
        typeof t == "function" ? t() : t && typeof t.unsubscribe == "function" && t.unsubscribe();
    } catch  {}
}, jR = (t, e = "symbols")=>({
        name: e,
        select: (n)=>Rs(()=>t(n.from, "list", BV(n))).then(({ data: o, error: r })=>({
                    data: n.single && Array.isArray(o) ? o[0] : o,
                    error: r
                })),
        rpc: (n)=>Rs(()=>t(n.from, "rpc", n.params)),
        insert: (n)=>Rs(()=>t(n.from, "create", FR(n))),
        update: (n)=>Rs(()=>t(n.from, "update", NV(n))),
        upsert: (n)=>Rs(()=>t(n.from, "upsert", {
                    ...FR(n),
                    onConflict: n.onConflict
                })),
        delete: (n)=>Rs(()=>t(n.from, "remove", FV(n))),
        subscribe: (n, o)=>{
            let r = null, s = !1;
            return Rs(()=>t(n.from, "subscribe", {
                    ...n.params || {},
                    filter: n.params
                }, o)).then(({ data: i })=>{
                if (s) return $R(i);
                r = typeof i == "function" || i && typeof i.unsubscribe == "function" ? ()=>$R(i) : null;
            }), ()=>{
                s = !0, r && r();
            };
        }
    }), $V = (t)=>typeof t == "function" ? t : !t || typeof t != "object" ? null : typeof t.SDK == "function" ? t.SDK : typeof t.default == "function" ? t.default : t.default && typeof t.default.SDK == "function" ? t.default.SDK : null, jV = ()=>{
    let t = globalThis.__SYMBOLS_ENV__;
    if (!t || typeof t != "object") return {};
    let e = (n)=>typeof n == "string" && n ? n : void 0;
    return {
        apiUrl: e(t.apiUrl),
        socketUrl: e(t.socketUrl)
    };
}, UV = async (t, e)=>{
    let n = $V(await t());
    if (!n) throw new Error(Fw + "load() resolved no SDK class (a module with an `SDK` export, or the class)");
    let o = {
        tokenStorage: "memory",
        tracking: {
            enabled: !1
        }
    };
    e.apiUrl && (o.apiUrl = e.apiUrl), e.socketUrl && (o.socketUrl = e.socketUrl);
    let r = new n(o);
    if (typeof r.initialize == "function" && await r.initialize(e.apiUrl ? {
        apiUrl: e.apiUrl
    } : {}), typeof r.execute != "function") throw new Error(Fw + "this SDK has no execute() (the entity dispatcher this adapter calls)");
    return r;
}, HV = (t)=>{
    let e = jV(), n = e.apiUrl || "", o = globalThis[NR] || (globalThis[NR] = new Map), r = o.get(n);
    return r || (r = UV(t, e), o.set(n, r), r.then(null, ()=>{
        o.get(n) === r && o.delete(n);
    })), r;
}, VV = (t)=>{
    let e = t.executor;
    if (typeof e == "function") return (o, r, s, i)=>e(o, r, s, i);
    let n = t.sdk;
    if (n && typeof n.execute == "function") return (o, r, s, i)=>n.execute(o, r, s, i);
    if (typeof t.load == "function") {
        let o = t.load;
        return (r, s, i, a)=>HV(o).then((c)=>c.execute(r, s, i, a));
    }
    return null;
}, zV = (t = {}, e)=>{
    let n = VV(t || {});
    if (!n) throw new Error(Fw + "pass { load } (a function that imports the platform SDK: `load: () => import(...)`), { sdk } (an SDK instance with .execute) or { executor } (a function with the same signature) in your fetch config.");
    return e && e.serverRender ? null : jR(n);
};
var Sr = (t)=>{
    if (!t) return 0;
    if (typeof t == "number") return t;
    let e = t.match(/^(\d+)(ms|s|m|h)$/);
    if (!e) return 0;
    let n = parseInt(e[1]), o = e[2];
    return o === "ms" ? n : o === "s" ? n * 1e3 : o === "m" ? n * 6e4 : o === "h" ? n * 36e5 : 0;
};
var so = "@symbo.ls/fetch:EARLY", wr = 3e4, xr = (t, e)=>{
    let n = new URL(t);
    return n.searchParams.sort(), n.toString() + " " + (e || "");
}, jw = (t)=>{
    if (t == null) return !0;
    if (typeof t != "object" || Array.isArray(t)) return !1;
    let e = Object.getPrototypeOf(t);
    if (e !== Object.prototype && e !== null) return !1;
    for(let n in t){
        let o = t[n];
        if (!(o === void 0 || typeof o == "string" || typeof o == "boolean") && !(typeof o == "number" && isFinite(o))) return !1;
    }
    return !0;
};
var Dn = ()=>Symbol.for(so), Uw = (t, e)=>{
    let n = [];
    for(let o in t || {}){
        let r = o.toLowerCase(), s = {
            name: o,
            header: r,
            param: t[o],
            found: !1,
            value: void 0
        };
        for(let i in e || {})i.toLowerCase() === r && (s.found = !0, s.value = e[i]);
        n.push(s);
    }
    return n;
}, UR = (t, e)=>{
    if (!t || typeof t != "object" || !e || typeof e != "object") return t;
    let n = {
        ...t
    };
    return n.query === void 0 && e.query !== void 0 && (n.query = e.query), n.rpc === void 0 && e.rpc !== void 0 && (n.rpc = e.rpc), n;
}, HR = (t, e, n)=>{
    let o = Dn();
    if (WV(n), !t || typeof t != "object") {
        let i = globalThis[o];
        return i && i.seeded ? {
            carried: {},
            rpc: !1,
            maxAge: wr,
            seeded: !0
        } : null;
    }
    globalThis[o] || (globalThis[o] = {
        entries: {}
    });
    let r = {};
    for (let { header: i, found: a, value: c } of Uw(t.query, e))a && (r[i] = c);
    let s = typeof t.maxAge == "number" && t.maxAge >= 0 ? t.maxAge : wr;
    return {
        carried: r,
        rpc: t.rpc === "get",
        maxAge: s,
        seeded: !!globalThis[o].seeded
    };
}, Hw = (t, e = wr, n)=>{
    let o = globalThis[Dn()], r = o && o.entries && o.entries[t];
    return !r || (delete o.entries[t], !(Date.now() - r.time <= e)) ? null : r.seeded ? (o.stale && n && (r.seeded.taken = Ww(o, t, n())), Promise.resolve(r.seeded)) : r.ready ? Promise.resolve(r.ready) : Promise.resolve(r.answer).then((s)=>s && s.ok && !s.bodyUsed ? s : null, ()=>null);
}, Vw = ()=>{
    let t = globalThis[Dn()];
    t && t.entries && (t.entries = {});
}, VR = (t)=>(Array.isArray(t) ? t : []).filter((e)=>e && typeof e.url == "string" && typeof e.body == "string").map((e)=>({
            k: xr(e.url, e.lang || ""),
            s: e.status || 200,
            t: e.type || "application/json",
            b: e.body
        })), yf = 'script[type="application/json"][data-fetch-seed]', zR = (t, e)=>{
    let n = VR(t);
    return n.length ? (e && typeof e == "object" && Object.keys(e).length && n.push({
        r: e
    }), '<script type="application/json" data-fetch-seed>' + Ls(n) + "<\/script>") : "";
}, WR = ()=>{
    let t = globalThis[Dn()];
    return !t || !t.runs ? null : Date.now() - t.runsTime <= wr ? t.runs : (t.runs = null, null);
}, KR = ()=>!!WR(), GR = (t)=>{
    let e = WR(), n = e && typeof t == "string" ? e[t] : null;
    return Array.isArray(n) && n.length ? n : null;
}, WV = (t)=>{
    let e = io(globalThis.document, yf, {
        remove: !0
    }), n = t === !1 ? null : e && e.value;
    if (!Array.isArray(n) || !n.length) {
        let c = globalThis[Dn()];
        c && c.stale || (Ds = null);
        return;
    }
    let o = Dn(), r = globalThis[o] || (globalThis[o] = {
        entries: {}
    });
    r.entries || (r.entries = {}), r.seeded = !0;
    let s = Date.now();
    for (let c of n){
        if (c && c.r && typeof c.r == "object" && !Array.isArray(c.r)) {
            r.runs = Object.assign(r.runs || {}, c.r), r.runsTime = Date.now();
            continue;
        }
        !c || typeof c.k != "string" || typeof c.b != "string" || r.entries[c.k] || (r.entries[c.k] = {
            time: s,
            seeded: {
                seeded: !0,
                status: c.s || 200,
                type: c.t || "application/json",
                body: c.b
            }
        });
    }
    let i = Ps(globalThis.document) || {
        stamp: null,
        time: null
    }, a = KV(t, i.stamp, i.time);
    a ? (r.stale = a, r.seedConfig = t && typeof t == "object" ? t : null) : Ds = null;
}, zw = "data-smbls-stale", KV = (t, e, n)=>{
    let o = globalThis.document && globalThis.document.documentElement;
    if (o && typeof o.hasAttribute == "function" && o.hasAttribute(zw)) return !0;
    if (!t || typeof t != "object") return !1;
    if (t.maxAge != null && n !== null) {
        let r = Sr(t.maxAge);
        if (r > 0 && Date.now() - n > r) return !0;
    }
    if (typeof t.isStale != "function") return !1;
    try {
        let r = t.isStale(e, {
            time: n
        });
        return r && typeof r.then == "function" ? Promise.resolve(r).then(Boolean, ()=>!1) : !!r;
    } catch  {
        return !1;
    }
}, Ww = (t, e, n)=>{
    let o = {
        key: e,
        again: n,
        result: null,
        cacheKey: null
    };
    if ((t.taken || (t.taken = [])).push(o), Ds) {
        let r = Ds;
        Ds = null;
        for (let s of r)try {
            s();
        } catch  {}
    }
    return o;
}, Ds = null, qR = (t)=>{
    let e = globalThis[Dn()];
    return e && e.seeded && !e.stale || e && e.stale && e.revalidated ? !1 : e && e.stale && e.taken && e.taken.length ? (t(), !0) : ((Ds || (Ds = new Set)).add(t), !0);
}, Zh = (t, e)=>{
    let n = globalThis[Dn()];
    !n || !t || typeof t != "object" || (e.result = t, (n.results || (n.results = new WeakMap)).set(t, e));
}, Kw = (t, e)=>{
    let n = globalThis[Dn()], o = n && n.results && t ? n.results.get(t) : null;
    o && (o.cacheKey = e);
}, YR = ()=>{
    let t = globalThis[Dn()];
    return !!(t && t.stale && !t.revalidated);
}, XR = async ()=>{
    let t = globalThis[Dn()];
    if (!t || !t.stale || t.revalidated) return null;
    t.revalidated = !0;
    let e = await t.stale, n = t.taken || [];
    return t.taken = [], t.results = null, e ? {
        taken: n,
        config: t.seedConfig || {}
    } : null;
}, ZR = (t)=>{
    let e = VR(t);
    if (!e.length) return "";
    let n = Ls(e);
    return "<script>(function(){try{var k=Symbol.for(" + JSON.stringify(so) + "),r=globalThis[k]||(globalThis[k]={entries:{}}),t=Date.now(),l=" + n + ';r.seeded=true;r.entries=r.entries||{};for(var i=0;i<l.length;i++){var e=l[i];r.entries[e.k]={time:t,answer:Promise.resolve(new Response(e.b,{status:e.s,headers:{"content-type":e.t}}))}}}catch(e){}})()<\/script>';
};
var GV = (t, e, n)=>{
    let o = new URL(t);
    return o.searchParams.delete(n || "limit"), o.searchParams.sort(), o.toString() + " " + (e || "");
}, qV = (t, e, n)=>{
    if (!t || !t.slices) return null;
    let o = new URL(e).searchParams;
    for (let r of t.sliceParams || [
        "limit"
    ]){
        let s = +o.get(r), i = s > 0 && t.slices[GV(e, n, r)];
        if (i && i.length) return {
            slots: i,
            limit: s
        };
    }
    return null;
}, Gw = (t, e, n, o)=>Array.isArray(t) ? {
        seeded: !0,
        status: n,
        type: o,
        body: JSON.stringify(t.slice(0, e))
    } : null, QR = (t, e, n, o)=>{
    let r = globalThis[Symbol.for(so)], s = qV(r, t, e);
    if (!s) return null;
    let { slots: i, limit: a } = s;
    for(let c = 0; c < i.length; c++){
        let l = r.entries && r.entries[i[c]];
        if (!(!l || !o(l, a))) return delete r.entries[i[c]], i.splice(c, 1), [
            l,
            a,
            Date.now() - l.time <= n
        ];
    }
    return null;
}, JR = (t, e, n = wr)=>{
    let o = QR(t, e, n, (i, a)=>i.limit >= a);
    if (!o || !o[2]) return null;
    let [r, s] = o;
    if (r.ready) try {
        return Promise.resolve(Gw(JSON.parse(r.ready.body), s, r.ready.status, r.ready.type));
    } catch  {
        return null;
    }
    return Promise.resolve(r.answer).then((i)=>{
        if (!i || !i.ok || i.bodyUsed) return null;
        let a = i.headers && i.headers.get("content-type") || "application/json";
        return i.json().then((c)=>Gw(c, s, i.status, a));
    }).catch(()=>null);
}, tD = (t, e, n, o, r)=>{
    let s = globalThis[Symbol.for(so)];
    if (!s || !s.atInit || !s.entries) return null;
    let i = (l)=>l.ready && Date.now() - l.time <= o, a = s.entries[t];
    if (a) {
        let l = i(a) && r(a.ready);
        return l && delete s.entries[t], l || null;
    }
    let c = null;
    return QR(e, n, o, (l, f)=>{
        if (!i(l)) return !1;
        let u = l.ready;
        if (l.limit >= f) try {
            u = Gw(JSON.parse(u.body), f, u.status, u.type);
        } catch  {
            u = null;
        }
        return c = u && r(u), c && l.limit < f && (c.partial = !0), !!c;
    }), c;
}, eD = ()=>{
    let t = globalThis[Symbol.for(so)];
    if (!t || !t.atInit || !t.entries) return !1;
    for(let e in t.entries)if (t.entries[e] && t.entries[e].ready) return !0;
    return !1;
};
var nD = ()=>globalThis[Symbol.for(so)], oD = (t, e = wr, n, o)=>{
    let r = nD(), s = r && r.entries && r.entries[t];
    if (!s || !s.seeded || !(Date.now() - s.time <= e)) return null;
    let i = o(s.seeded);
    return i ? (delete r.entries[t], r.stale && n && Zh(i, Ww(r, t, n())), i) : null;
}, rD = ()=>{
    let t = nD();
    if (t && t.atInit && eD()) return !0;
    if (t && t.seeded) {
        for(let n in t.entries)if (t.entries[n] && t.entries[n].seeded) return !0;
        return !1;
    }
    let e = globalThis.document;
    return !!(e && typeof e.querySelector == "function" && e.querySelector(yf));
};
var Zw = /*@__PURE__*/ F({}, {
    buildUrl: ()=>_f,
    headerEntries: ()=>hD,
    restAdapter: ()=>tg,
    selectQuery: ()=>Yw,
    setup: ()=>r5,
    withQuery: ()=>bf
});
var sD = Symbol.for("@symbo.ls/fetch:IN_FLIGHT"), Qh = ()=>globalThis[sD] || (globalThis[sD] = {
        count: 0,
        waiters: []
    }), iD = ()=>{
    Qh().count++;
}, aD = ()=>{
    let t = Qh();
    if (t.count = t.count > 0 ? t.count - 1 : 0, t.count === 0 && t.waiters.length) {
        let e = t.waiters;
        t.waiters = [];
        for (let n of e)n();
    }
}, cD = ()=>Qh().count, lD = ()=>{
    let t = Qh();
    return t.count === 0 ? Promise.resolve() : new Promise((e)=>{
        t.waiters.push(e);
    });
};
var _f = (t, e, n)=>{
    let o = e && !e.startsWith("/") ? "/" : "", r = new URL(`${t}${o}${e}`);
    if (n) for(let s in n){
        let i = n[s];
        i != null && r.searchParams.set(s, typeof i == "object" ? JSON.stringify(i) : i);
    }
    return r.toString();
}, Yw = ({ params: t, select: e, limit: n, offset: o, order: r, single: s })=>{
    let i = {
        ...t
    };
    return e && (i.select = e), n && (i.limit = n), o && (i.offset = o), s && (i.single = !0), r && (typeof r == "string" ? i.order = r : Array.isArray(r) ? i.order = r.map((a)=>`${a.by}:${a.asc === !1 ? "desc" : "asc"}`).join(",") : r.by && (i.order = `${r.by}:${r.asc === !1 ? "desc" : "asc"}`)), i;
}, dD = (t)=>Object.prototype.toString.call(t).slice(8, -1), Jh = [
    "auto",
    "json",
    "text",
    "blob",
    "arrayBuffer",
    "stream",
    "response"
], YV = {
    json: async (t)=>{
        let e = await t.text();
        return e ? JSON.parse(e) : null;
    },
    text: (t)=>t.text(),
    blob: (t)=>t.blob(),
    arrayBuffer: (t)=>t.arrayBuffer(),
    stream: (t)=>t.body,
    response: (t)=>t
}, XV = (t)=>{
    let e = t.headers.get("content-type");
    return e && e.includes("json") ? t.json() : t.text();
}, ZV = async (t)=>{
    let e = await t.text(), n = t.headers.get("content-type");
    if (e && n && n.includes("json")) try {
        return JSON.parse(e);
    } catch  {}
    return e;
}, fD = (t, e)=>t?.message || t?.error || e.statusText || `HTTP ${e.status}`, uD = (t, e, n)=>{
    let o = {
        data: e,
        error: n,
        status: t.status
    }, r = t.headers.get("retry-after");
    return r !== null && (o.retryAfter = r), o;
}, Xw = (t, e)=>{
    let n = t.body, o = e === "json" || e === "auto" && /json/i.test(t.type);
    if (!o && e !== "auto" && e !== "text") return null;
    let r;
    try {
        r = o ? n ? JSON.parse(n) : null : n;
    } catch  {
        return !1;
    }
    return {
        data: r,
        error: null,
        status: t.status
    };
}, nn = async (t, e, n, o)=>{
    let r = n ?? "auto";
    if (!Jh.includes(r)) throw new TypeError(`@symbo.ls/fetch rest: unknown responseType "${r}" \u2014 use one of: ${Jh.join(", ")}`);
    iD();
    try {
        return await pD(t, e, r, o);
    } finally{
        aD();
    }
}, pD = async (t, e, n, o)=>{
    let r = o ? await o : null;
    if (r && r.seeded === !0) {
        let i = Xw(r, n);
        if (r.taken && i !== !1) {
            let a = i || await pD(t, e, n, Promise.resolve(new Response(r.body, {
                status: r.status,
                headers: {
                    "content-type": r.type
                }
            })));
            return Zh(a, r.taken), a;
        }
        if (i) return i;
        r = i === !1 ? null : new Response(r.body, {
            status: r.status,
            headers: {
                "content-type": r.type
            }
        });
    }
    let s = r || await globalThis.fetch(t, e);
    if (n === "auto") {
        let i = await XV(s);
        return s.ok ? {
            data: i,
            error: null,
            status: s.status
        } : uD(s, i, fD(i, s));
    }
    if (!s.ok) {
        let i = await ZV(n === "response" ? s.clone() : s);
        return uD(s, n === "response" ? s : i, fD(i, s));
    }
    return {
        data: await YV[n](s),
        error: null,
        status: s.status
    };
}, QV = [
    "FormData",
    "Blob",
    "File",
    "URLSearchParams",
    "ReadableStream",
    "ArrayBuffer"
], JV = (t)=>t !== null && typeof t == "object" && (ArrayBuffer.isView(t) || QV.includes(dD(t))), hD = (t)=>Array.isArray(t) ? t : typeof t.entries == "function" ? t.entries() : Object.entries(t), qw = (...t)=>{
    let e = {}, n = new Map;
    for (let o of t)if (o) for (let [r, s] of hD(o)){
        let i = r.toLowerCase();
        if (n.has(i) && delete e[n.get(i)], s == null) {
            n.delete(i);
            continue;
        }
        n.set(i, r), e[r] = s;
    }
    return e;
}, t5 = {
    "Content-Type": "application/json"
}, e5 = {
    "Content-Type": void 0
}, n5 = (t)=>{
    if (!t || typeof t != "object") return null;
    let e = {};
    for (let { header: n, param: o } of Uw(t.query))e[n] = o;
    return {
        params: e,
        rpc: t.rpc === "get"
    };
}, o5 = "content-type", bf = (t, e)=>{
    let n = Object.keys(e);
    if (!n.length) return t;
    let o = new URL(t);
    for (let r of n)o.searchParams.set(r, e[r]);
    return o.toString();
}, r5 = async ({ url: t, headers: e, auth: n, fetchOptions: o, early: r, reads: s, seed: i })=>{
    if (!t) throw new Error("@symbo.ls/fetch rest: url is required");
    return tg(t, e, n, o, r, s, i);
}, tg = (t, e = {}, n, o = {}, r, s, i)=>{
    let a = n?.token || null, c = HR(UR(r, s), e, i), l = n5(s), f = (_)=>{
        if (!l) return null;
        let x = {}, A = {}, O = {};
        for(let C in _){
            let N = C.toLowerCase();
            if (N === "authorization") return null;
            if (N === o5) continue;
            A[C] = _[C];
            let I = l.params[N];
            I ? O[I] = _[C] : x[C] = _[C];
        }
        return {
            headers: x,
            adoptHeaders: A,
            query: O
        };
    }, u = (_)=>{
        let x = "";
        for(let A in _){
            let O = A.toLowerCase();
            if (O === "accept-language") x = String(_[A]);
            else if (c.carried[O] !== _[A]) return null;
        }
        return x;
    }, d = (_, x)=>{
        if (!c) return null;
        let A = u(x);
        if (A === null) return null;
        try {
            let O = _();
            return Hw(xr(O, A), c.maxAge) || JR(O, A, c.maxAge);
        } catch  {
            return null;
        }
    }, p = (_, x, A)=>{
        if (!c) return null;
        let O = u(x), C = A ?? "auto";
        if (O === null || !Jh.includes(C)) return null;
        try {
            return tD(xr(_, O), _, O, c.maxAge, (N)=>Xw(N, C) || null);
        } catch  {
            return null;
        }
    }, g = (_, x, A, O, C, N, I)=>{
        if (!c || !c.seeded) return null;
        let M = "";
        for(let K in x){
            let V = K.toLowerCase();
            if (V === "accept-language") M = String(x[K]);
            else if (V !== "accept") return null;
        }
        try {
            return Hw(xr(_, M), c.maxAge, ()=>m(A, O, C, _, N, I));
        } catch  {
            return null;
        }
    }, h = (_, x, A, O, C, N, I)=>{
        if (!c || !c.seeded) return null;
        let M = "";
        for(let V in x){
            let J = V.toLowerCase();
            if (J === "accept-language") M = String(x[V]);
            else if (J !== "accept") return null;
        }
        let K = I ?? "auto";
        if (!Jh.includes(K)) return null;
        try {
            return oD(xr(_, M), c.maxAge, ()=>m(A, O, C, _, N, I), (V)=>Xw(V, K) || null);
        } catch  {
            return null;
        }
    }, m = (_, x, A, O, C, N)=>({
            method: _,
            from: x,
            params: A,
            send: ()=>nn(O, C, N, null)
        }), y = ()=>a ? {
            Authorization: `Bearer ${a}`
        } : null, b = (_)=>qw(e, y(), _), T = (_)=>({
            ...o,
            ..._
        }), v = (_, x, A)=>{
        if (!JV(x)) return T({
            method: _,
            headers: qw(e, y(), t5, A),
            body: JSON.stringify(x)
        });
        let O = {
            method: _,
            headers: qw(e, y(), e5, A),
            body: x
        };
        return dD(x) === "ReadableStream" && (O.duplex = "half"), T(O);
    }, S = (_, x)=>{
        let A = x || t;
        if (_ && (_.startsWith("http://") || _.startsWith("https://"))) return _;
        let O = _ && !_.startsWith("/") ? "/" : "";
        return `${A}${O}${_ || ""}`;
    };
    return {
        name: "rest",
        setToken: (_)=>{
            a = _;
        },
        getSession: async ()=>{
            if (!n?.sessionUrl) return a ? {
                token: a
            } : null;
            let _ = await nn(S(n.sessionUrl, n.baseUrl), T({
                headers: b()
            }));
            return _.error ? null : _.data;
        },
        signIn: async (_)=>{
            if (!n?.signInUrl) throw new Error("rest: auth.signInUrl not configured");
            let x = await nn(S(n.signInUrl, n.baseUrl), v("POST", _));
            return x.data?.token && (a = x.data.token), x;
        },
        signOut: async ()=>(n?.signOutUrl && await nn(S(n.signOutUrl, n.baseUrl), T({
                method: "POST",
                headers: b()
            })), a = null, {
                error: null
            }),
        select: ({ from: _, params: x, select: A, limit: O, offset: C, order: N, single: I, headers: M, baseUrl: K, responseType: V })=>{
            let J = _f(K || t, _ || "", Yw({
                params: x,
                select: A,
                limit: O,
                offset: C,
                order: N,
                single: I
            })), ht = b(M), nt = f(ht);
            if (nt) {
                let Y = T({
                    headers: nt.headers
                }), G = bf(J, nt.query);
                return nn(G, Y, V, g(G, nt.headers, "select", _, x, Y, V) || d(()=>J, nt.adoptHeaders));
            }
            let tt = T({
                headers: ht
            });
            return nn(J, tt, V, g(J, tt.headers, "select", _, x, tt, V) || d(()=>J, tt.headers));
        },
        seeded: ({ method: _, from: x, params: A, select: O, limit: C, offset: N, order: I, single: M, headers: K, baseUrl: V, responseType: J, read: ht })=>{
            if (!c) return null;
            if (_ === "select") {
                let nt = _f(V || t, x || "", Yw({
                    params: A,
                    select: O,
                    limit: C,
                    offset: N,
                    order: I,
                    single: M
                })), tt = b(K), Y = f(tt);
                if (Y) {
                    let st = T({
                        headers: Y.headers
                    });
                    return c.seeded && h(bf(nt, Y.query), Y.headers, "select", x, A, st, J) || p(nt, Y.adoptHeaders, J);
                }
                let G = T({
                    headers: tt
                });
                return c.seeded && h(nt, G.headers, "select", x, A, G, J) || p(nt, G.headers, J);
            }
            if (_ === "rpc") {
                if (!(ht === !0 && l && l.rpc && jw(A))) return null;
                let nt = f(b(K));
                if (!nt) return null;
                let tt;
                try {
                    tt = _f(V || t, `rpc/${x}`, A);
                } catch  {
                    return null;
                }
                let Y = T({
                    method: "GET",
                    headers: nt.headers
                });
                return c.seeded && h(bf(tt, nt.query), nt.headers, "rpc", x, A, Y, J) || p(tt, nt.adoptHeaders, J);
            }
            return null;
        },
        rpc: async ({ from: _, params: x, headers: A, baseUrl: O, responseType: C, read: N })=>{
            let I = jw(x), M = ()=>_f(O || t, `rpc/${_}`, x), K = (G)=>nn(S(`rpc/${_}`, O), v("POST", x, A), C, G), V = b(A), J = N === !0 && l && l.rpc && I ? f(V) : null, ht = null;
            if (J) try {
                ht = M();
            } catch  {
                ht = null;
            }
            if (!ht) return K(c && c.rpc && I ? d(M, V) : null);
            let nt = T({
                method: "GET",
                headers: J.headers
            }), tt = bf(ht, J.query), Y = await nn(tt, nt, C, g(tt, J.headers, "rpc", _, x, nt, C) || d(()=>ht, J.adoptHeaders));
            return Y.status === 405 ? K(null) : Y;
        },
        insert: ({ from: _, data: x, headers: A, baseUrl: O, responseType: C })=>nn(S(_, O), v("POST", x, A), C),
        update: ({ from: _, data: x, params: A, method: O, headers: C, baseUrl: N, responseType: I })=>{
            let M = A?.id || x?.id, K = M ? `${_}/${M}` : _;
            return nn(S(K, N), v(O || "PATCH", x, C), I);
        },
        upsert: ({ from: _, data: x, params: A, method: O, headers: C, baseUrl: N, responseType: I })=>{
            let M = A?.id || x?.id, K = M ? `${_}/${M}` : _;
            return nn(S(K, N), v(O || "PUT", x, C), I);
        },
        delete: ({ from: _, params: x, headers: A, baseUrl: O, responseType: C })=>{
            let N = x?.id, I = N ? `${_}/${N}` : _;
            return nn(S(I, O), T({
                method: "DELETE",
                headers: b(A)
            }), C);
        }
    };
};
var gD = new Set, j = (t, e)=>{
    if (gD.has(t) || (gD.add(t), typeof console > "u" || !console.error)) return;
    let n = e && e.__ref && e.__ref.path, o = n && n.length ? ` (at <${n.join(".")}>)` : "";
    console.error(`[smbls] "${t}"${o} is not in this build: symbols.json build.treeShakeFeatures left it out because neither the project source nor its build settings use it. Add "${t}" to build.treeShakeFeatures.keep.`);
};
var s5 = ()=>Nw, i5 = ()=>$w, a5 = [
    "select",
    "rpc",
    "insert",
    "update",
    "upsert",
    "delete",
    "subscribe"
], wD = {
    rest: ()=>Promise.resolve(Zw),
    local: ()=>Promise.resolve().then(s5),
    symbols: ()=>Promise.resolve().then(i5)
}, eg = Symbol.for("@symbo.ls/fetch:CUSTOM_ADAPTERS"), Is = (()=>{
    if (typeof globalThis < "u" && globalThis[eg]) return globalThis[eg];
    let t = {};
    if (typeof globalThis < "u") try {
        return Object.defineProperty(globalThis, eg, {
            value: t,
            writable: !1,
            configurable: !1,
            enumerable: !1
        }), globalThis[eg];
    } catch  {}
    return t;
})(), ng = Symbol.for("@symbo.ls/fetch:PENDING_ADAPTERS"), ox = (()=>{
    if (typeof globalThis < "u" && globalThis[ng]) return globalThis[ng];
    let t = {};
    if (typeof globalThis < "u") try {
        return Object.defineProperty(globalThis, ng, {
            value: t,
            writable: !1,
            configurable: !1,
            enumerable: !1
        }), globalThis[ng];
    } catch  {}
    return t;
})(), c5 = 5e3, l5 = (t)=>new Promise((e)=>{
        if (Is[t]) return e(Is[t]);
        let n = ox[t] ||= [], o = !1, r = ()=>{
            o || (o = !0, e(Is[t] || null));
        };
        n.push(r), setTimeout(r, c5);
    }), f5 = (t, e)=>{
    Is[t] = e;
    let n = ox[t];
    if (n && n.length) {
        ox[t] = [];
        for (let o of n)o();
    }
}, u5 = (t)=>typeof t == "string" && !!(Is[t] || wD[t]), d5 = (t)=>{
    let e = {};
    for (let n of a5)t[n] && (e[n] = t[n]);
    return e.name = t.name || "custom", e;
}, xD = async (t, e)=>{
    if (!t) return null;
    if (typeof t.select == "function") return t;
    let { adapter: n, ...o } = t, r = typeof n == "string" ? n : typeof t == "string" ? t : null;
    if (!r) return null;
    let s = Is[r] || wD[r];
    if (!s && (s = await l5(r), !s)) throw new Error(`Unknown db adapter: "${r}". Use registerAdapter() for adapters with optional deps.`);
    let i = await s();
    if (!i || typeof i.setup != "function") throw new Error(`Adapter "${r}" loader returned a module without a setup() function. Got keys: [${Object.keys(i || {}).join(", ")}]. Likely a bundler chunk-resolution issue.`);
    return i.setup(o, e);
}, kf = (t)=>!!t && !!t.isolateFetchCache, rx = Symbol.for("@symbo.ls/fetch:runs"), kD = (t)=>(t.method === "select" || t.method === "rpc") && !Ef(t) && !t.infinite && !Fs(t), p5 = (t, e, n)=>{
    if (typeof n != "number") return;
    let o = t[rx];
    if (!o) {
        o = new Map;
        try {
            Object.defineProperty(t, rx, {
                value: o,
                configurable: !0
            });
        } catch  {
            return;
        }
    }
    let r = o.get(e);
    r || o.set(e, r = new Set), r.add(n);
}, h5 = (t, e = an)=>{
    let n = t && t[rx], o = {};
    if (!n) return o;
    for (let [r, s] of n){
        if (!r || !r.__ref) continue;
        let i;
        try {
            i = e(r);
        } catch  {
            continue;
        }
        if (typeof i != "string") continue;
        let a = o[i] || (o[i] = []);
        for (let c of s)a.includes(c) || a.push(c);
        a.sort((c, l)=>c - l);
    }
    return o;
}, TD = ()=>({
        cache: new Map,
        subscribers: new Map,
        active: new Map,
        invalidatedAt: new Map,
        reconnectedAt: 0,
        mounted: new Set
    }), on = TD(), mD = new WeakMap, He = (t)=>{
    if (!kf(t)) return on;
    let e = mD.get(t);
    return e || mD.set(t, e = TD()), e;
}, Tf = 0, ig = new WeakMap, fg = (t, e, n, o, r = t.page, s = t.cursor)=>{
    if (t.cache?.key) return t.cache.key;
    let { from: i, method: a, infinite: c } = t, l = n ? `${n}:` : "", f = o ? `:${o}` : "", u = r ? ":p" + JSON.stringify(r) : "", d = s != null ? ":c" + JSON.stringify(s) : "";
    return `${i}:${a}:${l}${JSON.stringify(e || "")}${c ? ":infinite" : ""}${u}${d}${f}`;
}, Ms = (t, e)=>t.cache.get(e) || null, Ra = (t, e, n, o, r = ++Tf, s = !1)=>{
    let i = {
        data: n,
        error: o,
        time: Date.now(),
        stale: s,
        seq: r
    };
    t.cache.set(e, i);
    let a = t.subscribers.get(e);
    if (a) for (let c of a)P(c) && c(i);
    return i;
}, rg = (t, e, n)=>{
    let o = e ? t.cache.get(e) : null;
    return o && !o.error && o.seq > n ? o : null;
}, lx = (t, e, n)=>(t.invalidatedAt.get(e) || 0) > n, sx = (t, e, n)=>{
    let o = ig.get(n) || 0;
    return o > t.reconnectedAt && !lx(t, e, o);
}, ag = (t, e)=>{
    t.invalidatedAt.set(e, ++Tf);
}, ED = (t, e)=>{
    t.cache.delete(e), ag(t, e);
};
var ug = (t)=>!t && t !== !1 ? {
        staleTime: 6e4,
        gcTime: 3e5
    } : t === !1 ? null : t === !0 ? {
        staleTime: 6e4,
        gcTime: 3e5
    } : typeof t == "number" ? {
        staleTime: t,
        gcTime: Math.max(t * 5, 3e5)
    } : E(t) ? {
        staleTime: Sr(t),
        gcTime: 3e5
    } : {
        staleTime: Sr(t.stale || t.staleTime) || 6e4,
        gcTime: Sr(t.gc || t.gcTime || t.expire) || 3e5,
        key: t.key
    }, AD = (t)=>!!t.ref && t.element.__ref === t.ref, g5 = ({ config: t, element: e, context: n })=>{
    try {
        return fx(t, e, n);
    } catch  {
        return null;
    }
}, og = null, m5 = ()=>{
    og || (og = setInterval(()=>{
        let t = Date.now(), { cache: e, subscribers: n, active: o, invalidatedAt: r, mounted: s } = on;
        for (let [i, a] of e){
            let c = n.get(i);
            !(c && c.size > 0) && t - a.time > (a.gcTime || 3e5) && e.delete(i);
        }
        for (let [i] of r)!e.has(i) && !o.has(i) && r.delete(i);
        for (let i of s)AD(i) || s.delete(i);
    }, 3e4), og.unref && og.unref());
};
m5();
var yD = 3, vD = 3e4, Qw = (t)=>Math.min(1e3 * 2 ** t, vD), y5 = (t, e)=>{
    for (let n of [
        t?.status,
        e?.status,
        e?.statusCode
    ]){
        let o = typeof n == "string" && /^\d{3}$/.test(n) ? Number(n) : n;
        if (Number.isInteger(o) && o >= 100 && o < 600) return o;
    }
    return null;
}, _5 = (t)=>t >= 400 && t < 500 && t !== 408 && t !== 429, b5 = (t)=>{
    if (t == null) return null;
    let e = String(t).trim();
    if (/^\d+$/.test(e)) return Number(e) * 1e3;
    if (!/[a-z]/i.test(e)) return null;
    let n = Date.parse(e);
    return Number.isNaN(n) ? null : Math.max(0, n - Date.now());
}, OD = (t, e)=>{
    let n = t.retry;
    return n === void 0 && e ? {
        count: 0
    } : n === !1 ? {
        count: 0
    } : n === !0 || n === void 0 ? {
        count: yD,
        delay: Qw
    } : typeof n == "number" ? {
        count: n,
        delay: Qw
    } : {
        count: n.count ?? yD,
        delay: P(n.delay) ? n.delay : typeof n.delay == "number" ? ()=>n.delay : Qw
    };
}, CD = async (t, e)=>{
    let { count: n, delay: o } = e, r, s = !1, i = (a, c, l)=>{
        if (a >= n) return null;
        let f = y5(c, l);
        if (f !== null && _5(f)) return null;
        if (f === 429) {
            if (s) return null;
            s = !0;
            let u = b5(c?.retryAfter ?? l?.retryAfter);
            if (u !== null) return u <= vD ? {
                ms: u
            } : null;
        }
        return {
            ms: P(o) ? o(a, l) : o
        };
    };
    for(let a = 0; a <= n; a++)try {
        let c = await t();
        if (c?.error) {
            r = c.error;
            let l = i(a, c, r);
            if (l) {
                await new Promise((f)=>setTimeout(f, l.ms));
                continue;
            }
            return c;
        }
        return c;
    } catch (c) {
        r = c;
        let l = i(a, null, c);
        if (l) {
            await new Promise((f)=>setTimeout(f, l.ms));
            continue;
        }
        throw c;
    }
    return {
        data: null,
        error: r
    };
}, Ca = {
    focus: new Set,
    online: new Set
}, _D = !1, RD = ()=>{
    if (_D || typeof window > "u") return;
    _D = !0;
    let t = ()=>{
        for (let n of Ca.focus)n();
    }, e = ()=>{
        on.reconnectedAt = ++Tf;
        for (let n of Ca.online)n();
    };
    window.addEventListener("visibilitychange", ()=>{
        document.visibilityState === "visible" && t();
    }), window.addEventListener("focus", t), window.addEventListener("online", e);
}, DD = (t, e)=>{
    let n = e.__ref;
    if (t === !0) return {
        from: n.__state || e.key,
        method: "select",
        query: !0,
        on: "create"
    };
    if (E(t)) return {
        from: t,
        method: "select",
        query: !0,
        on: "create"
    };
    if (k(t)) {
        let o = {
            ...t
        };
        return o.from = o.from || n.__state || e.key, o.method = o.method || "select", o.on = S5(o.on), o.query === void 0 && (o.query = !0), o;
    }
    return null;
}, S5 = (t)=>{
    if (!B(t)) return E(t) && t ? t : "create";
    let e = [];
    for (let n of t)E(n) && n && !e.includes(n) && e.push(n);
    return e.length ? e.length === 1 ? e[0] : e : "create";
}, LD = (t)=>B(t.on) ? t.on : [
        t.on || "create"
    ], Bs = (t, e)=>B(t.on) ? t.on.includes(e) : (t.on || "create") === e, w5 = [
    "insert",
    "update",
    "upsert",
    "delete"
], PD = (t)=>w5.includes(t), Ef = (t)=>t.mutation === !0 ? !0 : t.mutation === !1 || t.method !== "rpc" ? !1 : Bs(t, "submit") || Bs(t, "click") || t.invalidates != null, Ns = (t, e)=>{
    let n = t?.state?.root || e?.state?.root;
    if (n?.lang) return n.lang;
}, wf = (t, e)=>{
    let o = (t?.state?.root || e?.state?.root)?.__fetchScope;
    return o ? String(o) : void 0;
}, Da = (t, e, n)=>{
    let o;
    if (!t) o = void 0;
    else if (P(t)) o = t(e, e.state);
    else {
        o = {};
        for(let r in t){
            let s = t[r];
            o[r] = P(s) ? s(e, e.state) : s;
        }
    }
    return o;
}, Po = (t, e)=>P(t) ? t(e, e.state) : t, fx = (t, e, n)=>fg(t, Da(t.params, e, n), wf(e, n), Ns(e, n), Po(t.page, e), Po(t.cursor, e)), sg = async (t, e)=>{
    if (!t || t.__authInitialized || (t.__authInitialized = !0, !t.getSession)) return;
    let n = (o, r)=>{
        let s = e.state?.root;
        s?.update && s.update({
            auth: {
                user: o,
                session: r,
                loading: !1
            }
        });
    };
    try {
        let o = await t.getSession();
        n(o?.user || null, o);
    } catch (o) {
        console.warn("[fetch] Failed to restore auth session:", o.message);
    }
    t.onAuthStateChange && t.onAuthStateChange((o, r)=>{
        n(r?.user || null, r);
    });
}, x5 = async (t, e)=>{
    if (P(t.select)) return t.auth !== !1 && await sg(t, e), t;
    if (t.__resolved) return t.auth !== !1 && await sg(t.__resolved, e), t.__resolved;
    if (t.__resolving) return t.__resolving;
    t.__resolving = xD(t, {
        serverRender: kf(e)
    });
    let n;
    try {
        n = await t.__resolving;
    } finally{
        delete t.__resolving;
    }
    return n ? (n.auth = t.auth, n.url = t.url, n.key = t.key, t.__resolved = n, e.fetch = n, t.auth !== !1 && await sg(n, e), n) : null;
}, ux = async (t, e, n, o)=>{
    try {
        return await x5(t, e);
    } catch (r) {
        return n && (Ln(n, lg(r)), rn(n, "onFetchError", r), sn(o, n, "onFetchError", r)), null;
    }
}, rn = (t, e, ...n)=>{
    let o = P(t[e]) ? t[e] : null;
    o && o.call(t, ...n, t, t.state, t.context);
}, sn = (t, e, n, ...o)=>{
    let r = t && P(t[n]) ? t[n] : null;
    r && r.call(e, ...o, e, e.state, e.context);
}, Sf = (t)=>{
    let e = {}, n = t.node;
    if (!n) return e;
    if (n.tagName === "FORM") {
        let r = new FormData(n);
        for (let [s, i] of r.entries())e[s] = i;
        return e;
    }
    let o = n.querySelectorAll("input, textarea, select");
    for(let r = 0; r < o.length; r++){
        let s = o[r], i = s.name || s.getAttribute("name");
        i && (s.type === "checkbox" ? e[i] = s.checked : s.type === "file" ? e[i] = s.files : e[i] = s.value);
    }
    return e;
}, Fs = (t)=>t.responseType === "stream" || t.responseType === "response", k5 = [
    "Blob",
    "File",
    "ArrayBuffer",
    "ReadableStream",
    "Response"
], ix = (t)=>t !== null && typeof t == "object" && (ArrayBuffer.isView(t) || k5.includes(Object.prototype.toString.call(t).slice(8, -1))), ao = (t, e, n, o = {})=>{
    if (!n && ix(e)) return;
    let r = n && n.startsWith("~/"), s = r && t.state?.root || t.state;
    if (s?.update) {
        if (r) {
            let i = n.slice(2);
            e && typeof e == "object" && !Array.isArray(e) && !ix(e) && i in e ? s.update(e, {
                preventFetch: !0,
                ...o
            }) : s.update({
                [i]: e
            }, {
                preventFetch: !0,
                ...o
            });
        } else {
            let i = n ? {
                [n]: e
            } : e;
            s.update(i, {
                preventFetch: !0,
                ...o
            });
        }
    }
}, Oa = (t, e, n)=>{
    let o = e.partialAs;
    if (!o || !E(o)) return;
    let r = o.startsWith("~/"), s = r && t.state?.root || t.state;
    s?.update && s.update({
        [r ? o.slice(2) : o]: n
    }, {
        preventFetch: !0
    });
}, cg = Object.freeze({
    isFetching: !1,
    isLoading: !1,
    isStale: !1,
    isSuccess: !0,
    error: null,
    status: "success",
    fetchStatus: "idle"
}), T5 = Object.freeze({
    isFetching: !0,
    isLoading: !1,
    isStale: !1,
    isSuccess: !1,
    error: null,
    status: "pending",
    fetchStatus: "fetching"
}), lg = (t)=>({
        isFetching: !1,
        isLoading: !1,
        isStale: !1,
        isSuccess: !1,
        error: t,
        status: "error",
        fetchStatus: "idle"
    }), Ln = (t, e)=>{
    let n = t?.__ref;
    n && (n.__fetchStatus = {
        ...e,
        isError: !!e.error
    }, n.__fetching = e.isFetching, n.__fetchError = e.error);
}, Jw = (t, e, n)=>{
    let o = t.__pages && t.__pages.length ? t.__pages : [
        n
    ];
    P(e.getNextPageParam) && (t.__nextPageParam = e.getNextPageParam(o[o.length - 1], o), t.__hasNextPage = t.__nextPageParam != null), P(e.getPreviousPageParam) && (t.__prevPageParam = e.getPreviousPageParam(o[0], o), t.__hasPreviousPage = t.__prevPageParam != null);
}, dg = (t)=>k(t.infinite) ? t.infinite : null, E5 = (t, e)=>{
    let n = t;
    for (let o of e.split(".")){
        if (n == null) return;
        n = n[o];
    }
    return n;
}, ID = (t, e, n)=>{
    let [o, ...r] = e.split("."), s = B(t) ? [
        ...t
    ] : {
        ...t
    };
    return s[o] = r.length ? ID(k(t?.[o]) ? t[o] : {}, r.join("."), n) : n, s;
}, MD = (t, e)=>{
    let n = dg(t)?.rows;
    return P(n) ? n(e) : E(n) ? E5(e, n) : e;
}, tx = (t, e)=>P(dg(t)?.merge) ? e != null : B(MD(t, e)), ex = (t, e, n)=>{
    let o = dg(t);
    if (o && P(o.merge)) return o.merge(e, n, n.state);
    let r = [].concat(...e.map((s)=>MD(t, s) || []));
    return o && E(o.rows) ? ID(e[e.length - 1], o.rows, r) : r;
}, A5 = (t, e, n)=>{
    let o = dg(t)?.param;
    return P(o) ? o(n, {
        ...e
    }) : {
        ...e,
        [E(o) ? o : "cursor"]: n
    };
}, dx = (t, e, n, o, r, s)=>{
    let { from: i, single: a, limit: c, offset: l, order: f, headers: u, baseUrl: d, responseType: p } = t, g = {
        from: i,
        select: e,
        params: n,
        single: a,
        limit: c,
        offset: l,
        order: f,
        headers: u,
        baseUrl: d
    };
    if (p !== void 0 && (g.responseType = p), o && (g.headers = {
        ...g.headers,
        "Accept-Language": o
    }), r !== void 0) {
        if (k(r)) r.offset !== void 0 && (g.offset = r.offset), r.limit !== void 0 && (g.limit = r.limit), r.cursor !== void 0 && (g.params = {
            ...g.params,
            cursor: r.cursor
        });
        else if (typeof r == "number") {
            let h = t.pageSize || c || 20;
            g.offset = (r - 1) * h, g.limit = h;
        }
    }
    return s !== void 0 && (g.params = A5(t, g.params, s)), g;
}, pg = (t)=>typeof t.__slot == "number" ? t.__slot : t, v5 = (t, e, n)=>{
    t.__fetchAsked || (t.__fetchAsked = new Map), t.__fetchAsked.set(pg(e), n);
}, O5 = (t, e, n)=>{
    let o = t.__fetchAsked && t.__fetchAsked.get(pg(e));
    return o === void 0 || o === n;
}, C5 = (t, e, n, o)=>{
    let r = t.__fetchTaken && t.__fetchTaken.get(pg(e));
    return !r || r.key !== n || r.seq < o;
}, R5 = (t, e, n, o)=>{
    t.__fetchTaken || (t.__fetchTaken = new Map), t.__fetchTaken.set(pg(e), {
        key: n,
        seq: o
    });
}, co = async (t, e, n, o = {})=>{
    let r = n?.fetch;
    if (!r || !e || !e.__ref) return;
    let s = e.__ref, i = wf(e, n);
    (!s.__fetchScopeOwner || s.__fetchScopeOwner.scope !== i) && (s.__fetchScopeOwner = {
        scope: i
    });
    let a = s.__fetchScopeOwner, c = ()=>e.__ref === s && s.__fetchScopeOwner === a && wf(e, n) === i;
    if (t.enabled === !1 || P(t.enabled) && !t.enabled(e, e.state) || t.skip === !0 || P(t.skip) && t.skip(e, e.state)) return;
    kf(n) && kD(t) && p5(n, e, t.__slot);
    let l = await ux(r, n, e, t);
    if (!l || !c()) return;
    let { from: f, method: u, query: d, params: p, cache: g, transform: h, single: m, auth: y, fields: b, as: T, limit: v, offset: S, order: w, headers: _, baseUrl: x, responseType: A, page: O, cursor: C, infinite: N, placeholderData: I, initialData: M, select: K, keepPreviousData: V } = t, J = (Z)=>(P(K) && (Z = K(Z, e, e.state)), h && (Z = h(Z, e, e.state)), Z), ht = (Z)=>{
        Ln(e, lg(Z)), Oa(e, t, !1), rn(e, "onFetchError", Z), sn(t, e, "onFetchError", Z);
    }, nt = E(K) ? K : void 0;
    if (d && P(e.getQuery)) {
        let Z = e.getQuery(l.name || "paths");
        Z && (nt = Z.select || Z.length && Z.join(",") || nt);
    }
    let tt = Da(p, e, n), Y = Po(O, e), G = Po(C, e), st = Ef(t), ot = Fs(t) || st ? null : ug(g), dt = OD(t, st || PD(u)), X = Ns(e, n), U = ot ? fg(t, tt, i, X, Y, G) : null, Rt = He(n), gt = !!U && !N;
    gt && v5(s, t, U);
    let Tt = (Z)=>!gt || O5(s, t, U) && C5(s, t, U, Z), Yt = (Z)=>{
        gt && R5(s, t, U, Z);
    };
    if (!s.__fetchInitialized && U && (s.__fetchInitialized = !0, M !== void 0)) {
        let Z = P(M) ? M() : M;
        Ra(Rt, U, Z, null);
    }
    if ((u === "select" || u === "rpc") && U && ot && !o.refresh && !o.force) {
        let Z = Ms(Rt, U);
        if (Z && !Z.error) {
            let vt = Date.now() - Z.time, lt = Z.stale || vt > (ot.staleTime || 0), Mt = N && tx(t, Z.data);
            Mt && !s.__pages && (s.__pages = [
                Z.data
            ], Jw(s, t, Z.data));
            let zt = J(Mt ? ex(t, [
                Z.data
            ], e) : Z.data);
            if (!c()) return;
            if (!lt) {
                Ln(e, cg), ao(e, zt, T), Oa(e, t, !!Z.partial), s.__seededOnCreate && s.__seededOnCreate.delete(U) && (rn(e, "onFetchComplete", zt), sn(t, e, "onFetchComplete", zt));
                return;
            }
            ao(e, zt, T), Oa(e, t, !!Z.partial);
        } else if (I !== void 0) {
            let vt = P(I) ? I(e, e.state) : I;
            vt !== void 0 && ao(e, vt, T);
        }
    }
    let Ot = U && !o.force ? Rt.active.get(U) : null;
    if (Ot && sx(Rt, U, Ot)) {
        let Z = ig.get(Ot) || 0;
        try {
            let vt = await Promise.race([
                Ot,
                new Promise((lt, Mt)=>setTimeout(()=>Mt("DEDUP_TIMEOUT"), 15e3))
            ]);
            if (!c()) return;
            if (vt?.error) Tt(Z) && ht(vt.error);
            else if (vt?.data !== void 0) {
                let lt = !N && rg(Rt, U, Z), Mt = lt ? lt.seq : Z;
                if (!Tt(Mt)) return;
                let zt = lt ? lt.data : vt.data;
                N && tx(t, zt) && (s.__pages = [
                    zt
                ], Jw(s, t, zt), zt = ex(t, s.__pages, e));
                let Je = J(zt);
                if (!c()) return;
                Yt(Mt), ao(e, Je, T), Oa(e, t, !1), rn(e, "onFetchComplete", Je), sn(t, e, "onFetchComplete", Je);
            }
        } catch (vt) {
            if (!c()) return;
            vt !== "DEDUP_TIMEOUT" && Tt(Z) && ht(vt);
        }
        return;
    }
    let Ze = !Ms(Rt, U)?.data;
    Ln(e, {
        isFetching: !0,
        isLoading: Ze,
        isStale: !1,
        isSuccess: !1,
        error: null,
        status: "pending",
        fetchStatus: "fetching"
    }), rn(e, "onFetchStart"), sn(t, e, "onFetchStart");
    let Et = n?.analyze?.emitNetwork, Qe = Et ? typeof performance < "u" ? performance.now() : Date.now() : 0;
    Et && Et({
        phase: "start",
        mode: "query",
        from: f,
        method: u,
        cacheKey: U,
        lang: X
    });
    let lr = ()=>{
        Et && Et({
            phase: "success",
            mode: "query",
            ok: !0,
            from: f,
            method: u,
            cacheKey: U,
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - Qe
        });
    }, xl = async ()=>{
        if (!c()) return;
        if (y !== !1 && l.auth !== !1 && l.getSession) {
            let lt = await l.getSession();
            if (!c()) return;
            if (y === !0 && !lt) {
                let Mt = {
                    message: "Not authenticated"
                };
                return ht(Mt), {
                    data: null,
                    error: Mt
                };
            }
        }
        let Z = l[u];
        if (!P(Z)) return {
            data: null,
            error: {
                message: `Method "${u}" not found on adapter`
            }
        };
        let vt = dx(t, nt, tt, Ns(e, n), Y, G);
        if (u === "insert" || u === "update" || u === "upsert") {
            let lt;
            if (b === !0 || Bs(t, "submit")) lt = Sf(e);
            else if (B(b)) {
                let Mt = Sf(e);
                lt = {};
                for (let zt of b)lt[zt] = Mt[zt];
            } else e.state?.parse ? lt = e.state.parse() : k(e.state) && (lt = {
                ...e.state
            });
            h && (lt = h(lt, e, e.state)), vt.data = lt;
        }
        if (u === "rpc") {
            if (Bs(t, "submit")) {
                let lt = Sf(e);
                vt.params = t.transformParams ? t.transformParams(lt, e, e.state) : lt;
            }
            vt.read = !st && t.read !== !1;
        }
        if (u === "subscribe") {
            if (P(s.__unsubscribe)) {
                let Mt = s.__unsubscribe;
                s.__unsubscribe = null;
                try {
                    Mt();
                } catch  {}
            }
            let lt = l.subscribe({
                from: f,
                params: tt,
                on: t.subscribeOn
            }, (Mt, zt, Je)=>{
                c() && (ao(e, Mt, T), rn(e, "onFetchComplete", Mt), sn(t, e, "onFetchComplete", Mt));
            });
            return c() ? (s.__unsubscribe = lt, {
                data: null,
                error: null,
                subscribed: !0
            }) : (P(lt) && lt(), {
                data: null,
                error: null,
                subscribed: !0
            });
        }
        return Z(vt);
    }, At = ++Tf, $t = CD(xl, dt);
    ig.set($t, At), U && Rt.active.set(U, $t);
    try {
        let Z = await $t;
        if (U && Z && !st && Kw(Z, U), st && t.invalidates && Z && !Z.error && !Z.subscribed && BD(Rt, t.invalidates, f), !c() || Z?.subscribed) return;
        let { data: vt, error: lt } = Z || {};
        if (lt) {
            U && !rg(Rt, U, At) && Ra(Rt, U, null, lt, At), Tt(At) && ht(lt), Et && Et({
                phase: "error",
                mode: "query",
                from: f,
                method: u,
                cacheKey: U,
                error: lt.message || lt,
                durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - Qe
            });
            return;
        }
        if (vt !== void 0) {
            let Mt = vt, zt = At;
            if ((u === "select" || u === "rpc") && U) {
                let Ib = !N && rg(Rt, U, At);
                if (Ib) Mt = Ib.data, zt = Ib.seq;
                else {
                    let v4 = Ra(Rt, U, vt, null, At, lx(Rt, U, At));
                    v4.gcTime = ot?.gcTime || 3e5;
                }
            }
            if (!Tt(zt)) {
                lr();
                return;
            }
            let Je = Mt;
            if (N && tx(t, vt) && ((!s.__pages || !o.direction) && (s.__pages = []), o.direction === "previous" ? s.__pages.unshift(vt) : s.__pages.push(vt), Je = ex(t, s.__pages, e), Jw(s, t, vt)), Je = J(Je), !c()) return;
            Yt(zt), Ln(e, cg), (!V || Je !== void 0) && ao(e, Je, T), Oa(e, t, !1), rn(e, "onFetchComplete", Je), sn(t, e, "onFetchComplete", Je), lr();
        }
    } catch (Z) {
        if (!c()) return;
        Tt(At) && ht(Z), Et && Et({
            phase: "error",
            mode: "query",
            from: f,
            method: u,
            cacheKey: U,
            error: Z.message || String(Z),
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - Qe
        });
    } finally{
        U && Rt.active.get(U) === $t && Rt.active.delete(U);
    }
}, D5 = (t, e, n)=>{
    let o = e.__ref;
    if (o) {
        o.__fetchListeners || (o.__fetchListeners = []);
        for (let r of LD(t))L5(r, t, e, n);
    }
}, L5 = (t, e, n, o)=>{
    let r = n.__ref, s = e.__runner || co;
    if (t === "submit") {
        let i = (c)=>{
            c.preventDefault(), s(e, n, o);
        }, a = n.node;
        a && (a.addEventListener("submit", i), r.__fetchListeners.push(()=>a.removeEventListener("submit", i)));
    } else if (t === "click") {
        let i = ()=>s(e, n, o), a = n.node;
        a && (a.addEventListener("click", i), r.__fetchListeners.push(()=>a.removeEventListener("click", i)));
    } else t === "stateChange" && P5(e, n, o, s);
}, P5 = (t, e, n, o)=>{
    let r = e.__ref, s, i = q(()=>{
        let a;
        try {
            a = JSON.stringify([
                Da(t.params, e, n) ?? null,
                P(t.enabled) ? !!t.enabled(e, e.state) : t.enabled !== !1,
                P(t.skip) ? !!t.skip(e, e.state) : t.skip === !0,
                Po(t.page, e) ?? null
            ]);
        } catch  {
            return;
        }
        if (s === void 0) {
            s = a;
            return;
        }
        a !== s && (s = a, queueMicrotask(()=>o(t, e, n)));
    });
    Array.isArray(r.__effects) ? r.__effects.push(i) : r.__fetchListeners.push(()=>i.dispose());
}, I5 = (t, e, n)=>{
    let o = e.__ref;
    o.__fetchCleanups || (o.__fetchCleanups = []), RD();
    let r = t.refetchInterval;
    if (r) {
        let c = typeof r == "number" ? r : Sr(r);
        if (c > 0) {
            let l = setInterval(()=>{
                (t.refetchIntervalInBackground || typeof document > "u" || document.visibilityState === "visible") && co(t, e, n, {
                    force: !0
                });
            }, c);
            o.__fetchCleanups.push(()=>clearInterval(l));
        }
    }
    let s = Fs(t), i = t.refetchOnWindowFocus === void 0 ? !s : t.refetchOnWindowFocus !== !1, a = t.refetchOnReconnect === void 0 ? !s : t.refetchOnReconnect !== !1;
    if (i) {
        let c = ()=>{
            let l = fx(t, e, n), f = Ms(He(n), l), u = ug(t.cache);
            (!f || f.stale || Date.now() - f.time > (u?.staleTime || 0)) && co(t, e, n, {
                refresh: !0
            });
        };
        Ca.focus.add(c), o.__fetchCleanups.push(()=>Ca.focus.delete(c));
    }
    if (a) {
        let c = ()=>co(t, e, n, {
                refresh: !0
            });
        Ca.online.add(c), o.__fetchCleanups.push(()=>Ca.online.delete(c));
    }
}, M5 = (t, e, n)=>{
    let o = t.__ref;
    if (o.__fetchLangQueries = n, o.__fetchLangEffect) return;
    let r, s = !1, i = q(()=>{
        let a = Ns(t, e);
        if (!s) {
            s = !0, r = a;
            return;
        }
        if (a === r) return;
        let c = r;
        r = a, !(!c || !a) && queueMicrotask(()=>{
            for (let l of o.__fetchLangQueries || [])co(l, t, e);
        });
    });
    o.__fetchLangEffect = i, Array.isArray(o.__effects) ? o.__effects.push(i) : (o.__fetchListeners || (o.__fetchListeners = []), o.__fetchListeners.push(()=>i.dispose()));
}, B5 = (t, e, n)=>{
    if (!e.optimistic) return null;
    let o = t.__ref, r = e.as, s = t.state?.parse ? t.state.parse() : k(t.state) ? {
        ...t.state
    } : t.state;
    o.__optimisticSnapshot = s;
    let i = P(e.optimistic) ? e.optimistic(n, s, t) : e.optimistic;
    return i !== void 0 && ao(t, i, r), s;
}, nx = (t, e)=>{
    let n = t.__ref;
    if (!n || !e.optimistic) return;
    let o = n.__optimisticSnapshot;
    o !== void 0 && (ao(t, o, e.as), delete n.__optimisticSnapshot);
}, xf = (t)=>{
    if (!t) return ()=>!0;
    if (E(t)) return (e)=>e.includes(t);
    if (B(t)) {
        let e = t.join(":");
        return (n)=>n.includes(e);
    }
    return t instanceof RegExp ? (e)=>(t.lastIndex = 0, t.test(e)) : P(t) ? (e)=>{
        try {
            return !!t(e);
        } catch  {
            return !1;
        }
    } : ()=>!1;
}, N5 = (t, e)=>{
    let n = [];
    for (let o of t.mounted){
        if (!AD(o)) {
            t.mounted.delete(o);
            continue;
        }
        let r = g5(o);
        r && e(r) && n.push(co(o.config, o.element, o.context, {
            refresh: !0
        }));
    }
    return Promise.allSettled(n).then(()=>{});
}, hg = (t, e)=>{
    Vw();
    for (let [n, o] of t.cache)e(n) && (o.stale = !0, ag(t, n));
    for (let [n] of t.active)!t.cache.has(n) && e(n) && ag(t, n);
    return N5(t, e);
}, BD = (t, e, n)=>{
    let o = (B(e) ? e : [
        e
    ]).map((r)=>r === !0 || r === "*" ? (s)=>s.startsWith(n + ":") : r ? xf(r) : ()=>!1);
    return hg(t, (r)=>o.some((s)=>s(r)));
}, ax = (t, e)=>{
    for (let [n] of t.cache)e(n) && ED(t, n);
    for (let [n] of t.active)e(n) && ag(t, n);
}, cx = ()=>!0, ND = (t, e)=>Ms(t, e)?.data ?? void 0, FD = (t, e, n)=>{
    let o = Ms(t, e), r = P(n) ? n(o?.data) : n;
    Ra(t, e, r, null);
}, F5 = async (t, e, n)=>{
    let o = n?.fetch;
    if (!o) return;
    let r = await ux(o, n, e, t);
    if (!r) return;
    let s = e.__ref, { method: i, from: a, fields: c, transform: l, as: f, auth: u, headers: d, baseUrl: p, responseType: g, invalidates: h, optimistic: m, onMutate: y, onSuccess: b, onError: T, onSettled: v } = t, S;
    if (c === !0 || Bs(t, "submit")) S = Sf(e);
    else if (B(c)) {
        let A = Sf(e);
        S = {};
        for (let O of c)S[O] = A[O];
    } else e.state?.parse ? S = e.state.parse() : k(e.state) && (S = {
        ...e.state
    });
    l && (S = l(S, e, e.state)), P(y) && y(S, e, e.state);
    let w = m ? B5(e, t, S) : null;
    Ln(e, {
        isFetching: !0,
        isLoading: !1,
        isStale: !1,
        isSuccess: !1,
        error: null,
        status: "pending",
        fetchStatus: "fetching"
    }), rn(e, "onFetchStart"), sn(t, e, "onFetchStart");
    let _ = n?.analyze?.emitNetwork, x = _ ? typeof performance < "u" ? performance.now() : Date.now() : 0;
    _ && _({
        phase: "start",
        mode: "mutation",
        from: a,
        method: i
    });
    try {
        if (u !== !1 && r.auth !== !1 && r.getSession) {
            let V = await r.getSession();
            if (u === !0 && !V) {
                w !== void 0 && nx(e, t);
                let J = {
                    message: "Not authenticated"
                };
                rn(e, "onFetchError", J), sn(t, e, "onFetchError", J);
                return;
            }
        }
        let A = r[i];
        if (!P(A)) return;
        let O = {
            from: a,
            data: S,
            headers: d,
            baseUrl: p
        };
        g !== void 0 && (O.responseType = g), t.params && (O.params = Da(t.params, e, n));
        let C = Ns(e, n);
        C && (O.headers = {
            ...O.headers,
            "Accept-Language": C
        });
        let N = OD(t, !0), I = await CD(()=>A(O), N), { data: M, error: K } = I || {};
        if (K) {
            w !== void 0 && nx(e, t), Ln(e, lg(K)), rn(e, "onFetchError", K), sn(t, e, "onFetchError", K), P(T) && T(K, S, e), P(v) && v(null, K, S, e), _ && _({
                phase: "error",
                mode: "mutation",
                from: a,
                method: i,
                error: K.message || String(K),
                durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - x
            });
            return;
        }
        if (delete s.__optimisticSnapshot, Ln(e, cg), M !== void 0 && (f || !ix(M))) {
            let V = f ? {
                [f]: M
            } : M;
            e.state?.update && e.state.update(V, {
                preventFetch: !0
            });
        }
        rn(e, "onFetchComplete", M), sn(t, e, "onFetchComplete", M), P(b) && b(M, S, e), P(v) && v(M, null, S, e), _ && _({
            phase: "success",
            mode: "mutation",
            ok: !0,
            from: a,
            method: i,
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - x
        }), h && BD(He(n), h, a);
    } catch (A) {
        w !== void 0 && nx(e, t), Ln(e, lg(A)), rn(e, "onFetchError", A), sn(t, e, "onFetchError", A), P(T) && T(A, S, e), P(v) && v(null, A, S, e), _ && _({
            phase: "error",
            mode: "mutation",
            from: a,
            method: i,
            error: A.message || String(A),
            durationMs: (typeof performance < "u" ? performance.now() : Date.now()) - x
        });
    } finally{
        s.__fetching = !1;
    }
}, $5 = (t)=>{
    let e = (n)=>{
        try {
            n();
        } catch  {}
    };
    for (let n of t.__fetchCleanups || [])e(n);
    for (let n of t.__fetchListeners || [])e(n);
    P(t.__unsubscribe) && e(t.__unsubscribe);
    for (let n of t.__fetchMounted || [])He(n.context).mounted.delete(n);
    t.__fetchCleanups = [], t.__fetchListeners = [], t.__unsubscribe = null, t.__fetchMounted = [];
}, bD = (t, e)=>{
    if (!t) return null;
    if (P(t.select)) return t;
    if (t.__resolved) return t.__resolved;
    if (t.__resolving) return null;
    let n = typeof t.adapter == "string" ? t.adapter : null;
    if (n !== "rest" || Is[n] || !t.url) return null;
    let { adapter: o, ...r } = t, s = tg(r.url, r.headers, r.auth, r.fetchOptions, r.early, r.reads, r.seed);
    return s.auth = t.auth, s.url = t.url, s.key = t.key, t.__resolved = s, e.fetch = s, s;
}, j5 = (t)=>Bs(t, "create") && (t.method === "select" || t.method === "rpc") && !Ef(t) && !t.infinite && !Fs(t), $D = (t)=>{
    let e = t && t.context;
    if (!e || !e.fetch || kf(e)) return;
    let n = t.__ref;
    if (!n || !t.fetch || !(rD() || KR())) return;
    let o;
    try {
        o = bt(t.fetch, t);
    } catch  {
        return;
    }
    if (!o) return;
    let r = B(o) ? o : [
        o
    ], s = bD(e.fetch, e), i = s && P(s.seeded) ? GR(an(t)) : null;
    for(let a = 0; a < r.length; a++){
        let c;
        try {
            c = DD(bt(r[a], t), t);
        } catch  {
            continue;
        }
        if (!c) continue;
        let l = !!i && i.includes(a);
        if (l) {
            if (!kD(c)) continue;
        } else {
            if (!j5(c) || c.enabled === !1 || c.skip === !0) continue;
            try {
                if (P(c.enabled) && !c.enabled(t, t.state) || P(c.skip) && c.skip(t, t.state)) continue;
            } catch  {
                continue;
            }
        }
        let f = ug(c.cache);
        if (!f) continue;
        let u = bD(e.fetch, e);
        if (!u || !P(u.seeded)) return;
        U5(c, f, u, t, e, n, l);
    }
}, U5 = (t, e, n, o, r, s, i)=>{
    let a = E(t.select) ? t.select : void 0, c, l, f, u, d;
    try {
        if (t.query && P(o.getQuery)) {
            let b = o.getQuery(n.name || "paths");
            b && (a = b.select || b.length && b.join(",") || a);
        }
        c = Da(t.params, o, r), l = Po(t.page, o), f = Po(t.cursor, o);
        let y = Ns(o, r);
        u = fg(t, c, wf(o, r), y, l, f), d = dx(t, a, c, y, l, f);
    } catch  {
        return;
    }
    let p = He(r), g = Ms(p, u), h, m = !1;
    if (g && !g.error) {
        if (!i || g.stale || Date.now() - g.time > (e.staleTime || 0)) return;
        h = g.data;
    } else {
        t.method === "rpc" && (d.read = t.read !== !1);
        let y = n.seeded({
            method: t.method,
            ...d
        });
        if (!y || y.error || y.data === void 0) return;
        let b = Ra(p, u, y.data, null);
        b.gcTime = e.gcTime || 3e5, y.partial && (b.stale = !0, b.partial = !0, m = !0), Kw(y, u), h = y.data;
    }
    s.__fetchInitialized = !0, m && Ln(o, T5);
    try {
        P(t.select) && (h = t.select(h, o, o.state)), t.transform && (h = t.transform(h, o, o.state));
    } catch  {
        return;
    }
    if (m) {
        ao(o, h, t.as), Oa(o, t, !0);
        return;
    }
    Ln(o, cg), ao(o, h, t.as), (s.__seededOnCreate || (s.__seededOnCreate = new Set)).add(u);
}, px = (t, e, n, o)=>{
    if (!t || !o?.fetch) return;
    let s = bt(t, e);
    if (!s) return;
    let i = [], a = B(s) ? s : [
        s
    ];
    for(let p = 0; p < a.length; p++){
        let g = DD(B(s) ? bt(a[p], e) : a[p], e);
        g && (g.__slot = p, i.push(g));
    }
    let c = e.__ref, l = He(o);
    if (c.__fetchMounted) for (let p of c.__fetchMounted)l.mounted.delete(p);
    c.__fetchMounted = [], !c.__fetchDisposer && B(c.__effects) && (c.__fetchDisposer = {
        dispose: ()=>$5(c)
    }, c.__effects.push(c.__fetchDisposer));
    let f = !kf(o);
    f && RD();
    let u = [];
    for (let p of i){
        let g = PD(p.method), h = g ? F5 : co, m = !g && !Ef(p) && p.method !== "subscribe", y = Bs(p, "create");
        if (y && h(p, e, o), (!y || LD(p).length > 1) && queueMicrotask(()=>D5({
                ...p,
                __runner: h
            }, e, o)), m && y && (f && (p.refetchInterval || p.refetchOnWindowFocus !== !1 || p.refetchOnReconnect !== !1) && I5(p, e, o), f && !Fs(p) && u.push(p), !Fs(p))) {
            let b = {
                element: e,
                ref: c,
                config: p,
                context: o
            };
            l.mounted.add(b), c.__fetchMounted.push(b);
        }
    }
    (u.length || c.__fetchLangEffect) && M5(e, o, u), c.refetch = (p)=>{
        for (let g of i)co(g, e, o, {
            force: !0,
            ...p
        });
    };
    let d = i.find((p)=>p.infinite);
    c.fetchNextPage = ()=>{
        let p = d;
        if (!p) return;
        let g = c.__nextPageParam;
        if (g == null) return;
        let h = {
            ...p,
            cursor: g
        };
        co(h, e, o, {
            direction: "next",
            force: !0
        });
    }, c.fetchPreviousPage = ()=>{
        let p = d;
        if (!p) return;
        let g = c.__prevPageParam;
        if (g == null) return;
        let h = {
            ...p,
            cursor: g
        };
        co(h, e, o, {
            direction: "previous",
            force: !0
        });
    };
}, jD = async (t, e, n, o)=>{
    let r = o?.fetch;
    if (!r || !e) return;
    let s = {
        method: "select",
        ...e
    }, { method: i } = s, a = Ef(s), c = Fs(s) || a ? null : ug(s.cache), l = n ? Da(s.params, n, o) : s.params, f = n ? Po(s.page, n) : s.page, u = n ? Po(s.cursor, n) : s.cursor, d = Ns(n, o), p = c ? fg(s, l, wf(n, o), d, f, u) : null;
    if (p) {
        let v = Ms(t, p);
        if (v && !v.error && !v.stale && Date.now() - v.time <= (c.staleTime || 0)) return {
            data: v.data,
            error: null
        };
        let S = t.active.get(p);
        if (S && sx(t, p, S)) return S;
    }
    let g = await ux(r, o, n, e);
    if (!g) return;
    let h = g[i];
    if (!P(h)) return;
    let m = dx(s, E(s.select) ? s.select : void 0, l, d, f, u);
    i === "rpc" && (m.read = !a && s.read !== !1);
    let y = p ? t.active.get(p) : null;
    if (y && sx(t, p, y)) return y;
    let b = ++Tf, T = (async ()=>{
        let v = await h(m);
        if (p && v?.data !== void 0 && !v?.error && !rg(t, p, b)) {
            let S = Ra(t, p, v.data, null, b, lx(t, p, b));
            S.gcTime = c.gcTime || 3e5;
        }
        return v;
    })();
    ig.set(T, b), p && t.active.set(p, T);
    try {
        return await T;
    } finally{
        p && t.active.get(p) === T && t.active.delete(p);
    }
}, H5 = {
    invalidateQueries: (t)=>hg(on, xf(t)),
    removeQueries: (t)=>{
        ax(on, t ? xf(t) : cx);
    },
    getQueryData: (t)=>ND(on, t),
    setQueryData: (t, e)=>{
        FD(on, t, e);
    },
    prefetchQuery: (t, e)=>jD(He(e), t, null, e),
    getCache: ()=>on.cache,
    clear: ()=>ax(on, cx),
    dropNonLang: (t)=>{
        if (!t) return;
        let e = `:${t}`;
        for (let [n] of on.cache)n.match(/:([a-z]{2,3})$/i) && (n.endsWith(e) || ED(on, n));
    }
}, SD = (t, e)=>k(t) ? fx({
        method: "select",
        ...t
    }, e, e?.context) : t, V5 = {
    invalidateQueries (t) {
        return hg(He(this?.context), xf(t));
    },
    removeQueries (t) {
        ax(He(this?.context), t ? xf(t) : cx);
    },
    getQueryData (t) {
        return ND(He(this?.context), SD(t, this));
    },
    setQueryData (t, e) {
        FD(He(this?.context), SD(t, this), e);
    },
    prefetchQuery (t) {
        return jD(He(this?.context), t, this, this?.context);
    }
}, z5 = async (t)=>{
    let e = await XR();
    if (!e) return null;
    let { taken: n, config: o } = e, r = new Set, s = [];
    for (let c of n)c.cacheKey ? r.add(c.cacheKey) : s.push(c);
    Vw();
    let i = [], a = async (c)=>{
        try {
            let l = await c.again.send();
            if (!l || l.error) return;
            let f = c.result ? c.result.data : void 0;
            if (W5(l.data, f)) return;
            let { method: u, from: d, params: p } = c.again;
            i.push({
                method: u,
                from: d,
                params: p,
                data: l.data,
                previous: f
            });
        } catch  {}
    };
    if (await Promise.all([
        r.size ? hg(on, (c)=>r.has(c)) : null,
        ...s.map(a)
    ]), i.length && P(o.onRefresh)) try {
        o.onRefresh(i, t);
    } catch (c) {
        console.error("[@symbo.ls/fetch] seed.onRefresh failed:", c);
    }
    return {
        queries: r.size,
        reads: s.length,
        changed: i.length
    };
}, W5 = (t, e)=>{
    if (t === e) return !0;
    try {
        return JSON.stringify(t) === JSON.stringify(e);
    } catch  {
        return !1;
    }
}, K5 = {
    name: "fetch",
    init (t) {
        t.fetch && $D(t);
    },
    create (t) {
        let e = t.fetch;
        e && (t.parent || He(t.context).active.clear(), px(e, t, t.state, t.context));
    }
};
var G5 = px;
var UD = (t, e)=>{
    let n = "on" + t.charAt(0).toUpperCase() + t.slice(1);
    return e[n];
}, gg = (t, e, n, o, r)=>{
    if (t = ba(t, e), !!P(t)) try {
        let s = t.call(e, e, n || e.state, o || e.context, r);
        return s && typeof s.then == "function" && s.catch((i)=>{
            e.error = i, i instanceof ReferenceError ? console.warn("[DOMQL] Async event warning:", i.message) : console.error("[DOMQL] Async event error:", i);
        }), s;
    } catch (s) {
        if (e.error = s, s instanceof ReferenceError ? console.warn("[DOMQL] Event handler warning:", s.message) : console.error("[DOMQL] Event handler error:", s), e.context?.strictMode) throw s;
    }
}, Io = (t, e, n)=>{
    if (!e) throw new Error("Element is required");
    Cn(t, e, n);
    let o = UD(t, e);
    if (o) {
        let { state: r, context: s } = e;
        return gg(o, e, r, s, n);
    }
}, mg = (t, e, n, o, r, s)=>{
    if (t = ba(t, n), !!P(t)) try {
        let i = t.call(n, e, n, o || n.state, r || n.context, s);
        return i && typeof i.then == "function" && i.catch((a)=>{
            n.error = a, console.error("[DOMQL] Async event update error:", a);
        }), i;
    } catch (i) {
        if (n.error = i, console.error("[DOMQL] Event update error:", i), n.context?.strictMode) throw i;
    }
}, hx = (t, e, n, o)=>{
    Cn(t, n, e, o);
    let r = UD(t, n);
    if (r) {
        let { state: s, context: i } = n;
        return mg(r, e, n, s, i, o);
    }
};
var gx = {}, Af = {};
var q5 = ()=>$s, kr = "production";
function Of(t) {
    let e = this, { __ref: n } = e, o = [].concat(t), r = n.root[o[0]];
    if (!o || !o.length) return console.log(o, "on", e.key, "is undefined");
    for(; r.key === o[0] && (o.shift(), !!o.length);)if (r = r[o[0]], !r) return;
    return r;
}
function yx(t) {
    let e = this, { parent: n } = e;
    if (P(t)) return n.state && t(n, n.state, n.context) ? n : n.parent ? n.lookup(t) : void 0;
    if (e[t]) return e[t];
    for(; n.param !== t;){
        if (n[t]) return n[t];
        if (n = n.parent, !n) return;
    }
    return n;
}
function _x(t) {
    let e = this, { __ref: n } = e, o = n?.__children;
    if (o) for(let r = 0; r < o.length; r++){
        let s = o[r], i = e[s];
        if (s === t) return i;
        if (P(t)) {
            let c = t(i, i.state, i.context);
            if (i.state && c) return i;
        }
        let a = i?.lookdown?.(t);
        if (a) return a;
    }
}
function bx(t, e = []) {
    let n = this, { __ref: o } = n, r = o?.__children;
    if (r) {
        for(let s = 0; s < r.length; s++){
            let i = r[s], a = n[i];
            if (i === t) e.push(a);
            else if (P(t)) {
                let c = t(a, a.state, a.context);
                a.state && c && e.push(a);
            }
            a?.lookdownAll?.(t, e);
        }
        return e.length ? e : void 0;
    }
}
function bg(t = {}) {
    let e = this;
    if (e.node?.style) {
        for(let n in t){
            let o = t[n], r = e[n];
            if (k(o) && r) bg.call(r, o);
            else if (o != null) {
                let s = n.replace(/[A-Z]/g, (a)=>"-" + a.toLowerCase()), i = String(o).replace(/\s*!important\s*$/, "");
                e.node.style.setProperty(s, i, "important");
            }
        }
        return e;
    }
}
function VD(t) {
    let e = this;
    if (Io("beforeRemove", e, t) === !1) return e;
    P(e.node.remove) ? e.node.remove() : mr() || e.log(), delete e.parent[e.key], e.parent.__ref && (e.parent.__ref.__children = Bl(e.parent.__ref.__children, e.key)), Io("remove", e, t);
}
function Sx(t) {
    return this[t];
}
function wx(t, e) {
    let n = this;
    if (t) return n.update(t, e), n;
}
function xx(t) {
    return t ? this.__ref && this.__ref[t] : this.__ref;
}
function kx() {
    let t = this.getRef("__children");
    return Array.isArray(t) ? t.map((e)=>this[e]) : [];
}
function Cf() {
    return this.getRef().path;
}
var _g = null, Rf = (t)=>{
    _g = t || null;
}, La = (t, e)=>{
    t && e && _g === t && (_g = e);
}, HD = ()=>_g || null;
function Df(t) {
    let e = null, n = (o)=>o.__element && o.root?.isRootState;
    if (!this) e = HD();
    else if (n(this)) e = this.root;
    else if (this.__ref && this.__ref.path) {
        let o = this.state && n(this.state), r = P(this.state) && this.parent.state && n(this.parent.state);
        (o || r) && (e = this.state.root || this.parent.state.root);
    }
    return e || (e = HD()), t ? e?.[t] : e;
}
function Lf(t) {
    let e = this?.__ref?.root || this.getRootState()?.__element;
    if (!e) throw new Error(`[smbls] getRoot() could not resolve a root element for "${this?.key || "<unknown>"}" \u2014 it has no __ref (never went through create()) and no root state is registered. Answering undefined here used to no-op silently for every caller.`);
    return Object.keys(e).length > 0 && t ? e[t] : e;
}
function Pf(t) {
    return this.getRoot("data") && Object.keys(this.getRoot("data")).length > 0 && t ? this.getRoot("data")[t] : this.getRoot("data");
}
function If(t) {
    let e = this.getRoot()?.context;
    return t ? e[t] : e;
}
function Mf(t) {
    let e = this.context;
    return t ? e[t] : e;
}
var Tx = (t, e, n, o)=>Object.defineProperty(t, e, {
        get: n,
        set: o
    });
function Sg() {
    let t = this, e = [];
    for(let n in t)!Object.prototype.hasOwnProperty.call(t, n) || pr.has(n) && !Hl.has(n) || e.push(n);
    return e;
}
function wg(t = []) {
    let e = this, n = {}, o = Sg.call(e), r = o.includes("children"), s = t.length ? new Set(t) : null;
    for(let i = 0; i < o.length; i++){
        let a = o[i];
        if (s && s.has(a) || !Object.prototype.hasOwnProperty.call(e, a) || r && a === "content") continue;
        let c = e[a];
        if (a === "state") {
            if (e.__ref && !e.__ref.__hasRootState) continue;
            let l = P(c && c.parse) ? c.parse() : c;
            n[a] = P(l) ? l : JSON.parse(JSON.stringify(l || {}));
        } else if (a === "scope") {
            if (e.__ref && !e.__ref.__hasRootScope) continue;
            n[a] = JSON.parse(JSON.stringify(c || {}));
        } else if (a === "props") {
            let { __element: l, update: f, ...u } = e[a];
            n[a] = u;
        } else jt(c) && Object.prototype.hasOwnProperty.call(e, a) && (n[a] = c);
    }
    return n;
}
function vf(t = [], e = new WeakSet) {
    let n = this;
    if (e.has(n)) return;
    e.add(n);
    let o = wg.call(n, t), r = t.length ? new Set(t) : null;
    for(let s in o){
        if (r && r.has(s) || !Object.prototype.hasOwnProperty.call(n, s)) continue;
        let i = o[s];
        Array.isArray(i) ? o[s] = i.map((a)=>z(a) ? vf.call(a, t, e) : a) : z(i) && (o[s] = vf.call(i, t, e));
    }
    return o;
}
function Pa(...t) {
    if (kr !== "test" && kr !== "development") return;
    let e = this, { __ref: n } = e;
    return console.groupCollapsed(e.key), t.length ? t.forEach((o)=>console.log(`%c${o}:
`, "font-weight: bold", e[o])) : (console.log(n.path), e.keys().forEach((r)=>console.log(`%c${r}:`, "font-weight: bold", e[r]))), console.log(e), console.groupEnd(e.key), e;
}
function Ex(...t) {
    (kr === "test" || kr === "development") && console.log(...t);
}
function Bf(...t) {
    (kr === "test" || kr === "development") && console.warn(...t);
}
function js(...t) {
    if (kr === "test" || kr === "development") {
        if (t[t.length - 1]?.debugger) debugger;
        throw t[t.length - 1]?.verbose && Pa.call(this), new Error(...t);
    }
}
function Nf() {
    let t = this, { key: e, parent: n } = t, { __children: o } = n.__ref, r = o.indexOf(e), s = o[r + 1];
    return n[s];
}
function Ff(t) {
    let e = t || this, { key: n, parent: o } = e, { __children: r } = o.__ref;
    if (!r) return;
    let s = r.indexOf(n);
    return o[r[s - 1]];
}
function $f(t = {}) {
    let e = this;
    e.data || (e.data = {}), e.data.varCaches || (e.data.varCaches = {});
    let n = e.data.varCaches, o = {}, r;
    for(let s in t)t[s] !== n[s] && (r = !0, o[s] = t[s]);
    return {
        changed: (s)=>{
            if (!r) return;
            let i = s(o, ft(n));
            for(let a in o)n[a] = o[a];
            return i;
        },
        timeout: (s, i)=>{
            if (!r) return;
            let a = setTimeout(()=>{
                s(o), clearTimeout(a);
            }, i);
        }
    };
}
function Ax(t, ...e) {
    let n = this.context, o = n.utils?.[t] || n.functions?.[t] || n.methods?.[t] || n.snippets?.[t];
    if (o && !Es(o)) try {
        let r = o.call(this, ...e);
        return r && typeof r.then == "function" && r.catch((s)=>{
            js.call(this, s);
        }), r;
    } catch (r) {
        if (js.call(this, r), n?.strictMode) throw r;
    }
}
var Y5 = "[smbls] getDB needs @symbo.ls/fetch, which the smbls embed bundle does not include: add @symbo.ls/fetch to the page's importmap (the runtime import then resolves) or use the full smbls bundle.", yg = ()=>Promise.resolve().then(q5).catch((t)=>{
        throw new Error(Y5, {
            cause: t
        });
    });
async function jf() {
    let t = this, e = t.context?.fetch;
    if (!e) return null;
    if (typeof e.select == "function") {
        if (!e.__authInitialized && e.getSession) {
            let { initAdapterAuth: r } = await yg();
            await r(e, t.context);
        }
        return e;
    }
    if (e.__resolved) {
        if (!e.__resolved.__authInitialized && e.__resolved.getSession) {
            let { initAdapterAuth: r } = await yg();
            await r(e.__resolved, t.context);
        }
        return e.__resolved;
    }
    if (e.__resolving) return e.__resolving;
    let n = yg().then(({ resolveDb: r })=>r(e));
    e.__resolving = n;
    let o = await n;
    if (e.__resolved = o, t.context.fetch = o, delete e.__resolving, o?.getSession) {
        let { initAdapterAuth: r } = await yg();
        await r(o, t.context);
    }
    return o;
}
function Uf(t) {
    let e = this, n = t || Af.useStateQuery || e.context?.useStateQuery;
    if (!n) return null;
    let o = {};
    if (mx(e, o), n === !0) return o;
    let r = nz[n];
    return r ? r(o) : o;
}
var mx = (t, e)=>{
    let n = t.__ref;
    if (!n) return;
    let o = n.__state;
    o && typeof o == "string" && X5(e, o);
    let r = n.__children;
    if (r) for(let a = 0; a < r.length; a++){
        let c = t[r[a]];
        c && c.__ref && mx(c, e);
    }
    let s = n.contentElementKey || "content", i = t[s];
    i && i.__ref && mx(i, e);
}, X5 = (t, e)=>{
    let o = e.replaceAll("../", "").replaceAll("~/", "").split("/"), r = t;
    for(let s = 0; s < o.length; s++){
        let i = o[s];
        s === o.length - 1 ? r[i] || (r[i] = !0) : (r[i] === !0 && (r[i] = {}), r[i] || (r[i] = {}), r = r[i]);
    }
}, zD = (t, e = 0)=>{
    let n = "  ".repeat(e), o = Object.entries(t);
    return o.length ? o.map(([s, i])=>i === !0 ? `${n}${s}` : `${n}${s} {
${zD(i, e + 1)}
${n}}`).join(`
`) : "";
}, Z5 = (t)=>`{
${zD(t, 1)}
}`, Q5 = (t)=>{
    let e = {
        fields: {},
        include: []
    }, n = (o, r)=>{
        let s = [];
        for(let i in o)if (o[i] === !0) s.push(i);
        else {
            let a = r ? `${r}.${i}` : i;
            e.include.push(a), n(o[i], a);
        }
        s.length && (e.fields[r || "_root"] = s);
    };
    return n(t, ""), e;
}, J5 = (t)=>{
    let e = (s)=>{
        let i = [], a = [];
        for(let c in s)if (s[c] === !0) i.push(c);
        else {
            let l = e(s[c]), f = [];
            l.select && f.push(`$select=${l.select}`), l.expand && f.push(`$expand=${l.expand}`), a.push(f.length ? `${c}(${f.join(";")})` : c);
        }
        return {
            select: i.length ? i.join(",") : "",
            expand: a.length ? a.join(",") : ""
        };
    }, { select: n, expand: o } = e(t), r = [];
    return n && r.push(`$select=${n}`), o && r.push(`$expand=${o}`), r.join("&");
}, tz = (t, e)=>{
    let n = [], o = [], r = new Set, s = (f, u, d)=>{
        r.add(u), d && o.push(`LEFT JOIN ${u} ON ${u}.${d}_id = ${d}.id`);
        for(let p in f)f[p] === !0 ? n.push(`${u}.${p}`) : s(f[p], p, u);
    }, i = Object.keys(t);
    i.length === 1 && t[i[0]] !== !0 ? s(t[i[0]], i[0], null) : s(t, "_root", null);
    let a = [
        ...r
    ][0] || "_root", c = n.length ? n.join(", ") : "*", l = o.length ? `
` + o.join(`
`) : "";
    return `SELECT ${c}
FROM ${a}${l}`;
}, ez = (t)=>{
    let e = [], n = (o, r)=>{
        for(let s in o){
            let i = r ? `${r}/${s}` : s;
            o[s] === !0 ? e.push(i) : n(o[s], i);
        }
    };
    return n(t, ""), e;
}, nz = {
    graphql: Z5,
    "json-api": Q5,
    odata: J5,
    sql: tz,
    paths: ez
};
function vx(t, e) {
    return !!(gr.has(t) || e?.context?.methods?.[t]);
}
var oz = {
    snapshotId: Ql
}, Ox = (t, e)=>{
    let n = t.__ref, { currentSnapshot: o, calleeElement: r } = e;
    if (!r || r === t) {
        let a = oz.snapshotId();
        return n.__currentSnapshot = a, [
            a,
            t
        ];
    }
    let i = r.__ref.__currentSnapshot;
    return o < i ? [
        i,
        r,
        !0
    ] : [
        i,
        r
    ];
};
var xg = new Set([
    "__proto__",
    "constructor",
    "prototype",
    "_id",
    "__v",
    "id",
    "createdAt",
    "updatedAt",
    "schema"
]), Cx = (t)=>typeof t == "string" && xg.has(t);
var kg = Symbol.for("@symbo.ls/utils:textReady"), rz = ()=>{
    let t = globalThis[kg];
    if (!t) {
        t = {
            depth: 0,
            ready: !0
        };
        try {
            Object.defineProperty(globalThis, kg, {
                value: t,
                configurable: !0
            });
        } catch  {
            globalThis[kg] = t;
        }
    }
    return t;
};
function Pn(t) {
    let e = rz(), n = e.ready;
    e.depth++, e.ready = !0;
    try {
        return {
            value: t(),
            ready: e.ready
        };
    } finally{
        e.depth--, e.ready = n;
    }
}
function Ia() {
    let t = globalThis[kg];
    t && t.depth > 0 && (t.ready = !1);
}
var an = (t)=>{
    let e = t.__ref;
    if (e && e.__hydrationPath !== void 0) return e.__hydrationPath;
    let n = t.parent, o = n && n.__ref ? an(n) : null, r = o === null ? "" : o ? o + "." + t.key : String(t.key);
    return e && (e.__hydrationPath = r), r;
};
var Ba = "/__smbls/", Ma = Ba + "workers/", Tg = /^[A-Za-z_$][\w$-]*$/, Rx = (t)=>Ma + t + ".js", Dx = (t)=>{
    if (typeof t != "string" || !t.startsWith(Ma)) return null;
    let e = t.slice(Ma.length);
    if (!e.endsWith(".js")) return null;
    let n = e.slice(0, -3);
    return Tg.test(n) ? n : null;
};
var Tr = "__SMBLS_HOST_SOURCES__", Eg = Ba + "host/", Lx = (t, e)=>{
    if (typeof e != "string" || !/^[0-9a-f]{16,}$/.test(e)) return "";
    let o = String(t || "").split("/").pop().replace(/[^A-Za-z0-9_-]/g, "") || "package";
    return Eg + o + "." + e.slice(0, 16) + ".js";
}, Ag = "data-smbls-host-packages", Fa = "smbls.importHostPackage", Px = (t)=>typeof t == "string" && t.includes(Fa), In = Object.freeze({
    UNKNOWN: "SMBLS_HOST_PACKAGE_UNKNOWN",
    NO_SOURCE: "SMBLS_HOST_PACKAGE_NO_SOURCE",
    NO_DOM: "SMBLS_HOST_PACKAGE_NO_DOM",
    NO_GLOBAL: "SMBLS_HOST_PACKAGE_NO_GLOBAL",
    LOAD_FAILED: "SMBLS_HOST_PACKAGE_LOAD_FAILED",
    TIMEOUT: "SMBLS_HOST_PACKAGE_TIMEOUT",
    NO_LOADER: "SMBLS_HOST_PACKAGE_NO_LOADER"
}), Na = Object.freeze([
    Object.freeze({
        prefix: "Promise.resolve(",
        suffix: ").then(function (__smblsSpec) { var __smblsHit = (globalThis.__SMBLS_PKGS__ || {})[__smblsSpec]; if (__smblsHit) return __smblsHit; var __smblsLoad = globalThis[Symbol.for('smbls.importHostPackage')]; if (typeof __smblsLoad === 'function') return __smblsLoad(__smblsSpec); throw Object.assign(new Error('[smbls] host package ' + __smblsSpec + ' cannot load on demand: no smbls runtime on the page provides importHostPackage'), { code: 'SMBLS_HOST_PACKAGE_NO_LOADER', specifier: __smblsSpec, retryable: false }) })"
    })
]), sz = /^[A-Za-z0-9@._/-]{1,214}$/, Hf = (t)=>typeof t == "string" && sz.test(t), Ix = (t)=>{
    if (!Hf(t)) throw new TypeError("[smbls] lazyHostImportExpr: not a package specifier: " + JSON.stringify(t));
    let e = Na[Na.length - 1];
    return e.prefix + "'" + t + "'" + e.suffix;
}, Mx = (t, e, n)=>{
    if (typeof t != "string" || typeof e != "string" || !e) return "none";
    let o = n && Number.isFinite(n.start) ? Math.max(0, n.start) : 0, r = n && Number.isFinite(n.end) ? Math.min(t.length, n.end) : t.length, s = 0, i = o;
    for(; i < r;){
        let a = t.indexOf(e, i);
        if (a === -1 || a + e.length > r) break;
        if (!az(t, e, a, o, r)) {
            i = a + e.length;
            continue;
        }
        let c = cz(t, e, a, o, r);
        if (c === -1) return "static";
        s++, i = c;
    }
    return s > 0 ? "lazy" : "none";
}, WD = "'\"`", iz = /\\(?:u00(?:22|27|60)|x(?:22|27|60))$/i, az = (t, e, n, o, r)=>{
    let s = n === o || WD.includes(t[n - 1]) || iz.test(t.slice(Math.max(o, n - 6), n)), i = n + e.length, a = i === r || WD.includes(t[i]) || t[i] === "\\" || t[i] === "/";
    return s && a;
}, cz = (t, e, n, o, r)=>{
    for (let s of Na){
        let i = s.prefix + "'", a = "'" + s.suffix, c = n - i.length, l = n + e.length + a.length;
        if (!(c < o || l > r) && t.startsWith(i, c) && t.startsWith(a, n + e.length)) return l;
    }
    return -1;
}, lz = /^[A-Za-z_$][A-Za-z0-9_$]*$/, fz = (t)=>{
    if (!t || typeof t != "object") return null;
    let { src: e, integrity: n, global: o, version: r } = t;
    if (typeof e != "string" || !e || /\s/.test(e) || typeof o != "string" || !lz.test(o)) return null;
    let s = {
        src: e
    };
    return typeof n == "string" && n && (s.integrity = n), s.global = o, typeof r == "string" && r && (s.version = r), s;
}, uz = (t)=>JSON.stringify(t).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029"), vg = (t)=>{
    if (!t || typeof t != "object") return "";
    let e = {}, n = !1;
    for (let o of Object.keys(t)){
        if (!Hf(o)) continue;
        let r = fz(t[o]);
        r && (e[o] = r, n = !0);
    }
    return n ? "(function (g) { var s = g." + Tr + " || (g." + Tr + " = {}); var d = " + uz(e) + "; for (var k in d) { if (!Object.prototype.hasOwnProperty.call(s, k)) s[k] = d[k] } })(typeof globalThis !== 'undefined' ? globalThis : window);" : "";
}, Bx = (t)=>{
    let e = vg(t);
    return e ? "<script " + Ag + '="lazy">' + e + "<\/script>" : "";
};
async function Nx(t) {
    if (document.fullscreenElement) await document.exitFullscreen();
    else try {
        await (this.node || document).requestFullscreen();
    } catch (e) {
        console.warn(`Error attempting to enable fullscreen mode: ${e.message} (${e.name})`);
    }
}
var $a = (t)=>t !== "latest" ? `@${t}` : "", ja = (t)=>t ? `/${t}` : "", Vf = (t)=>{
    let e = typeof t == "string" ? t.replace(/\/+$/, "") : "";
    if (!e) return {
        name: "",
        subpath: ""
    };
    let n = e.split("/"), o = e.startsWith("@") ? 2 : 1;
    return {
        name: n.slice(0, o).join("/"),
        subpath: n.slice(o).join("/")
    };
}, cn = {
    skypack: {
        url: "https://cdn.skypack.dev",
        formatUrl: (t, e, n)=>`${cn.skypack.url}/${t}${$a(e)}${ja(n)}`
    },
    esmsh: {
        url: "https://esm.sh",
        formatUrl: (t, e, n)=>`${cn.esmsh.url}/${t}${$a(e)}${ja(n)}`
    },
    unpkg: {
        url: "https://unpkg.com",
        formatUrl: (t, e, n)=>`${cn.unpkg.url}/${t}${$a(e)}${ja(n)}?module`
    },
    jsdelivr: {
        url: "https://cdn.jsdelivr.net/npm",
        formatUrl: (t, e, n)=>`${cn.jsdelivr.url}/${t}${$a(e)}${ja(n)}/+esm`
    },
    symbols: {
        url: "https://pkg.symbo.ls",
        formatUrl: (t, e, n)=>`${cn.symbols.url}/${t}${$a(e)}${ja(n)}/+esm`
    }
}, Er = {
    "esm.sh": "esmsh",
    unpkg: "unpkg",
    skypack: "skypack",
    jsdelivr: "jsdelivr",
    "pkg.symbo.ls": "symbols"
}, Ua = (t = {})=>{
    let { packageManager: e } = t;
    return Er[e] || null;
}, zf = (t)=>{
    if (typeof t != "string") return t;
    let e = t.trim().match(/^[\^~](\d.*)$/);
    return e ? e[1] : t;
}, Mn = (t, e = "latest", n = "esmsh")=>{
    let o = cn[n] || cn.esmsh, { name: r, subpath: s } = Vf(t);
    return o.formatUrl(r || t, zf(e), s);
}, Og = (t, e = "latest", n = "esmsh")=>{
    let o = cn[n] || cn.esmsh, r = zf(e), { name: s, subpath: i } = Vf(t);
    return `${o.url}/${s || t}${$a(r)}${ja(i)}/`;
}, dz = /^node:|^@symbo-ls\//, Ar = (t)=>typeof t == "string" && dz.test(t), pz = /[<>…]/, Us = (t)=>typeof t == "string" && pz.test(t), Hs = (t)=>!!t && typeof t == "object" && !Array.isArray(t), Fx = (t, e = "skypack", n = {})=>{
    let o = t.dependencies;
    if (!Hs(o)) return "";
    let r = Object.keys(o);
    if (!r.length) return "";
    let s = n.pin || {}, i = {};
    for (let f of r){
        if (Ar(f) || Us(f)) continue;
        let u = s[f] || o[f] || "latest";
        i[f] = Mn(f, u, e), f.endsWith("/") || (i[f + "/"] = Og(f, u, e));
    }
    if (!Object.keys(i).length) return "";
    let a = '<script type="importmap">', c = "<\/script>", l = `{
    "imports": ${JSON.stringify(i, null, 2)}
  }`;
    return `${a}${l}${c}`;
};
var $x = (t)=>{
    if (!t) return "";
    let e = new Date(t), n = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(e), o = new Intl.DateTimeFormat("en", {
        month: "short"
    }).format(e);
    return `${new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(e)} ${o}, ${n}`;
};
var jx = (t, e)=>{
    let n = setTimeout(()=>{
        let { props: o } = t;
        if (!e.clientHeight) {
            let { node: { clientHeight: r } } = t;
            r && (e.clientHeight = r);
        }
        if (e.active) {
            if (o.height === "auto") return;
            t.update({
                height: e.clientHeight
            }, {
                preventBeforeUpdateListener: !0,
                preventChildrenUpdate: !0
            });
            let r = setTimeout(()=>{
                t.update({
                    height: "auto"
                }, {
                    preventBeforeUpdateListener: !0,
                    preventChildrenUpdate: !0
                }), clearTimeout(r);
            }, 450);
        } else t.update({
            height: "0"
        }, {
            preventBeforeUpdateListener: !0,
            preventChildrenUpdate: !0
        });
        clearTimeout(n);
    });
};
var Ux = function(e) {
    let n = [
        0,
        1
    ];
    for(let o = 2; o <= e; o++)n[o] = n[o - 1] + n[o - 2];
    return n[e];
};
var Hx = (t)=>[
        "jpeg",
        "gif",
        "jpg",
        "png",
        "tiff",
        "woff"
    ].includes(t);
var Vx = (t, e = !1, n = document, o = "text/javascript")=>new Promise((r, s)=>{
        try {
            let i = n.createElement("script");
            i.type = o, i.async = e, i.src = t, i.addEventListener("load", (a)=>{
                r({
                    status: !0
                });
            }), i.addEventListener("error", (a)=>{
                s(new Error({
                    status: !1,
                    message: `Failed to load the script ${t}`
                }));
            }), n.body.appendChild(i);
        } catch (i) {
            s(i);
        }
    }), zx = (t, e = document, n = "text/javascript")=>new Promise((o, r)=>{
        let s = e.createElement("script");
        s.type = n, s.src = t;
        let i = e.createElement("div");
        i.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.8);z-index:9999;", e.body.appendChild(i), s.onload = ()=>{
            e.body.removeChild(i), o();
        }, s.onerror = ()=>{
            e.body.removeChild(i), r(new Error(`Failed to load: ${t}`));
        }, e.body.appendChild(s);
    }), Wx = (t, e = document, n, o = "text/javascript")=>{
    let r = new window.XMLHttpRequest;
    if (r.open("GET", t, !1), r.send(), r.status === 200) {
        let s = e.createElement("script");
        s.type = o, s.text = r.responseText, e.body.appendChild(s), typeof n == "function" && n();
    } else throw new Error(`Failed to load the script ${t}`);
}, Kx = (t, e = !1, n = document, o = "text/javascript")=>new Promise((r, s)=>{
        try {
            let i = n.createElement("link");
            i.rel = "stylesheet", i.href = t, i.addEventListener("load", (a)=>{
                r({
                    status: !0
                });
            }), n.head.appendChild(i);
        } catch (i) {
            s(i);
        }
    }), Gx = (t, e = !1, n = document, o = "text/javascript", r = "smbls-script")=>{
    try {
        let s = n.createElement("script");
        s.type = o, s.async = e, s.id = r, s.innerHTML = t, n.body.appendChild(s);
    } catch (s) {
        console.warn(s);
    }
};
function Ha(t, e = {}) {
    let { window: n = globalThis } = e, { document: o = n.document } = e;
    return new Promise((r, s)=>{
        let i = o.querySelector(`script[src="${t}"]`);
        if (i) return r(i);
        let a = o.createElement("script");
        a.src = t, a.async = e.async === !0, a.type = e.type || "text/javascript", e.id && (a.id = e.id), e.integrity && (a.integrity = e.integrity), e.crossOrigin && (a.crossOrigin = e.crossOrigin), a.onload = ()=>{
            a.onerror = a.onload = null, r(a);
        }, a.onerror = ()=>{
            a.onerror = a.onload = null, s(new Error(`Failed to load script: ${t}`));
        }, o.head.appendChild(a);
    });
}
async function qx(t, e = {}) {
    let { window: n = globalThis } = e, { document: o = n.document } = e;
    return new Promise((r, s)=>{
        let i = o.querySelector(`link[href="${t}"]`);
        if (i) return r(i);
        let a = o.createElement("link");
        a.href = t, a.rel = e.rel || "stylesheet", a.type = "text/css", a.media = e.media || "all", e.id && (a.id = e.id), e.integrity && (a.integrity = e.integrity), e.crossOrigin && (a.crossOrigin = e.crossOrigin), a.onload = ()=>{
            a.onerror = a.onload = null, r(a);
        }, a.onerror = ()=>{
            a.onerror = a.onload = null, s(new Error(`Failed to load stylesheet: ${t}`));
        }, o.head.appendChild(a);
    });
}
var KD = new Set, fe = (t)=>{
    KD.has(t) || (KD.add(t), !(typeof console > "u" || !console.error) && console.error(`[smbls] ${t}: this build has no shared-library support \u2014 \`smbls build\` found no shared library in the project (sharedLibraries.js, symbols.json sharedLibraries), so it left that code out. Declare the library there, or remove symbols.json build.treeShakeLibraries.`));
};
var Yx = "system", hz = "https://smbls-kv.nika-980.workers.dev", gz = "https://api.symbols.app", mz = "/v1/library-icons/";
function zs(t) {
    let e = String(t || "").trim();
    if (!e) return {
        owner: Yx,
        key: "",
        full: ""
    };
    let n = null, o = e;
    if (e.includes("/")) {
        let s = e.indexOf("/");
        n = e.slice(0, s), o = e.slice(s + 1);
    }
    o = o.replace(/\.symbo\.ls$/iu, ""), n || (n = Yx);
    let r = o ? `${n}/${o}` : "";
    return {
        owner: n,
        key: o,
        full: r
    };
}
var Ct = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), Qt = je, yz = (t)=>k(t) || t !== null && typeof t == "object" && !Array.isArray(t) && Object.getPrototypeOf(t) === null, vr = (t, e, n, o)=>{
    let r = Array.isArray(t);
    if (!r && !yz(t)) return t;
    if (o && o.has(t)) return o.get(t);
    let s = o || new Map, i = r ? [] : {};
    if (s.set(t, i), r) for(let a = 0; a < t.length; a++)i[a] = vr(t[a], e, n, s);
    else for(let a in t){
        if (!Ct(t, a) || Qt.has(a)) continue;
        let c = n ? `${n}/${a}` : a;
        e && e.has(c) || (i[a] = vr(t[a], e, c, s));
    }
    return s.delete(t), i;
}, Va = (t, e, n, o)=>{
    for(let r in e){
        if (!Ct(e, r) || Qt.has(r)) continue;
        let s = o ? `${o}/${r}` : r;
        n && n.has(s) || (r in t ? k(t[r]) && k(e[r]) && Va(t[r], e[r], n, s) : t[r] = vr(e[r], n, s));
    }
}, Gf = (t, e, n)=>{
    if (!k(t) || !e.size) return t;
    let o = `${n}/`, r = !1;
    for (let i of e)if (i.startsWith(o)) {
        r = !0;
        break;
    }
    if (!r) return t;
    let s = {};
    for(let i in t){
        if (!Object.prototype.hasOwnProperty.call(t, i) || Qt.has(i)) continue;
        let a = `${n}/${i}`;
        e.has(a) || (s[i] = Gf(t[i], e, a));
    }
    return s;
}, _z = (t, e)=>{
    if (t !== e || !k(t)) return t;
    let n = {};
    for(let o in t)Ct(t, o) && !Qt.has(o) && (n[o] = t[o]);
    return n;
}, sL = new Set, bz = new Set([
    "components",
    "pages",
    "functions",
    "snippets",
    "methods"
]), Cg = (t, e)=>e === "" && bz.has(t), Dg = [
    "fontFamily",
    "fontfamily",
    "font_family",
    "FONT_FAMILY"
], GD = (t)=>{
    let e = new Map;
    if (!k(t)) return e;
    for (let n of Dg){
        let o = t[n];
        if (k(o)) for(let r in o)!k(o[r]) || !o[r].isDefault || (e.has(n) || e.set(n, new Set), e.get(n).add(r));
    }
    return e;
}, iL = (t, e)=>{
    for (let n of Dg){
        let o = t[n];
        if (!k(o)) continue;
        let r = e.get(n), s = null;
        for(let i in o){
            let a = o[i];
            if (!k(a) || !a.isDefault || r && r.has(i)) continue;
            let c = {
                ...a
            };
            delete c.isDefault, s || (s = {
                ...o
            }), s[i] = c;
        }
        s && (t[n] = s);
    }
}, Sz = (t)=>{
    let e = new Map;
    if (!k(t)) return e;
    for (let n of Dg){
        let o = t[n];
        k(o) && e.set(n, new Set(Object.keys(o)));
    }
    return e;
}, aL = (t, e)=>{
    if (k(t)) for (let n of Dg){
        let o = t[n];
        if (!k(o)) continue;
        let r = e.get(n), s = null;
        for(let i in o){
            let a = o[i];
            !k(a) || a.isSharedLibrary || r && r.has(i) || (s || (s = {
                ...o
            }), s[i] = {
                ...a,
                isSharedLibrary: !0
            });
        }
        s && (t[n] = s);
    }
}, wz = (t)=>t.replace(/\.js$/iu, ""), za = (t)=>{
    let e = new Set;
    if (!Array.isArray(t)) return e;
    for (let n of t){
        if (!E(n)) continue;
        let o = n.split("/").map((r)=>wz(r.trim())).filter(Boolean).join("/");
        o && e.add(o);
    }
    return e;
}, Qx = (t, e = {})=>({
        library: t,
        ignoreList: Array.isArray(e.ignoreList) ? e.ignoreList : []
    }), ke = (t)=>k(t) && Array.isArray(t.ignoreList) && ("library" in t || "key" in t || "name" in t), cL = (t)=>t.library !== void 0 ? t.library : t.key ?? t.name, Xx = new Set, Jx = ()=>{
    Xx.clear();
}, xz = (t, e)=>{
    let n = e.filter((o)=>!Xx.has(o));
    if (n.length) for (let o of n)Xx.add(o);
}, kz = (t, e, n)=>{
    let o = null;
    for(let r in t)if (xs(r) && (e.has(`methods/${r}`) || n.push(r), !o)) {
        o = {};
        for(let s in t)!Ct(t, s) || Qt.has(s) || xs(s) || (o[s] = t[s]);
    }
    return o || t;
}, Ws = (t, e)=>{
    let n = za(t.sharedLibIgnore);
    return t.sharePages === !1 && n.add("pages"), n.size ? new Set([
        ...e,
        ...n
    ]) : e;
}, tk = [
    "functions",
    "methods",
    "snippets"
], lL = [
    "components",
    "pages"
], qD = Symbol.for("smbls.libraryScope"), Vs = "__libraryScopes", ek = new Map, Tz = ()=>Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4), Ez = /const __scope = |const __peers_* = |const _s_* = el\?\.scope|\?\.context\?\.globalScope\?\./, fL = (t)=>{
    try {
        return Ue(t);
    } catch  {
        return null;
    }
}, uL = (t)=>{
    if (typeof t != "function") return null;
    let e = fL(t);
    return E(e) && Ez.test(e) && ie(e) ? e : null;
}, YD = (t)=>E(t) && ie(t) || uL(t) !== null, Az = (t)=>{
    let e = t.globalScope;
    return k(e) && Object.keys(e).some((n)=>YD(e[n])) ? !0 : tk.some((n)=>{
        let o = t[n];
        return !!o && typeof o == "object" && Object.keys(o).some((r)=>YD(o[r]));
    });
}, vz = (t, e, n)=>{
    let o = t.globalScope, r = e.globalScope;
    if (n.has("globalScope") || !k(o) || !k(r) || !Az(e)) return 0;
    let s = 0;
    for (let i of Object.keys(r))n.has(`globalScope/${i}`) || Ct(o, i) && s++;
    return s;
}, Oz = [
    [
        /const __scope = (\(\(\) => \{ const r = [\s\S]*?\}\)\(\));/g,
        "const __scope = $RESOLVE($1);"
    ],
    [
        /const __scope = this \?\? \{\};/g,
        "const __scope = $RESOLVE(this ?? {});"
    ],
    [
        /const (__peers_*) = (this && this !== globalThis && this\.context && this\.context\.globalScope \? this\.scope \?\? this\.context\.globalScope : this);/g,
        "const $1 = $RESOLVE($2);"
    ],
    [
        /const (_s_*) = (el\?\.scope \?\? el\?\.context\?\.globalScope \?\? \{\});/g,
        "const $1 = $RESOLVE($2);"
    ],
    [
        /(?<![\w$.])(this|[A-Za-z_$][\w$]*)\?\.context\?\.globalScope\?\./g,
        "$RESOLVE($1?.context?.globalScope)?."
    ]
], Cz = (t)=>{
    let e = t.split(""), n = [], o = 0, r = 0, s = (a, c)=>{
        for(let l = a; l < c; l++)e[l] !== `
` && (e[l] = "~");
    }, i = ()=>{
        let a = o;
        for(; o < t.length;){
            let c = t[o];
            if (c === "\\") {
                o += 2;
                continue;
            }
            if (c === "`") {
                s(a, o), o++;
                return;
            }
            if (c === "$" && t[o + 1] === "{") {
                s(a, o), o += 2, n.push(r), r++;
                return;
            }
            o++;
        }
        s(a, o);
    };
    for(; o < t.length;){
        let a = t[o];
        if (a === "/" && t[o + 1] === "/") {
            let c = t.indexOf(`
`, o), l = c === -1 ? t.length : c;
            s(o, l), o = l;
            continue;
        }
        if (a === "/" && t[o + 1] === "*") {
            let c = t.indexOf("*/", o + 2), l = c === -1 ? t.length : c + 2;
            s(o, l), o = l;
            continue;
        }
        if (a === '"' || a === "'") {
            let c = a, l = ++o;
            for(; o < t.length && t[o] !== c && t[o] !== `
`;)t[o] === "\\" && o++, o++;
            s(l, o), o++;
            continue;
        }
        if (a === "`") {
            o++, i();
            continue;
        }
        if (a === "{") {
            r++, o++;
            continue;
        }
        if (a === "}") {
            if (r--, n.length && r === n[n.length - 1]) {
                n.pop(), o++, i();
                continue;
            }
            o++;
            continue;
        }
        o++;
    }
    return e.join("");
}, XD = (t, e)=>{
    if (!E(t) || !t.includes("__scope = ") && !t.includes("__peers") && !/const _s_* = /.test(t) && !t.includes("?.context?.globalScope?.") || !ie(t)) return t;
    let n = `(globalThis[Symbol.for('smbls.libraryScope')] || ((_, v) => v))(${JSON.stringify(e)}, `, o = t;
    for (let [r, s] of Oz){
        let i = Cz(o);
        o = o.replace(r, (...a)=>{
            let c = a[a.length - 2];
            return i[c] === "~" || i[c] !== o[c] ? a[0] : s.replace(/\$RESOLVE\(/g, n).replace(/\$(\d)/g, (l, f)=>a[Number(f)]);
        });
    }
    return o;
}, nk = (t, e)=>{
    if (E(t)) return XD(t, e);
    let n = uL(t);
    return n === null ? t : XD(n, e);
}, Rz = {
    lazy: !0,
    window: globalThis
}, dL = (t, e)=>{
    let n = nk(t, e);
    if (n === t || !E(n)) return n;
    try {
        let o = xe({
            v: n
        }, {}, Rz).v;
        return typeof o != "function" ? n : (Object.defineProperty(o, "toJSON", {
            value: ()=>n,
            configurable: !0
        }), o);
    } catch  {
        return n;
    }
}, Zx = (t)=>{
    if (!t || typeof t != "object") return !1;
    if (Array.isArray(t)) return !0;
    let e = Object.getPrototypeOf(t);
    return e === Object.prototype || e === null;
}, Dz = (t, e)=>{
    let n = new WeakMap, o = (r)=>{
        if (E(r) || typeof r == "function") return dL(r, e);
        if (ql(r) || !Zx(r)) return r;
        if (n.has(r)) return n.get(r);
        let s = Array.isArray(r) ? [] : Object.getPrototypeOf(r) === null ? Object.create(null) : {};
        n.set(r, s);
        for (let i of Object.keys(r))Qt.has(i) || (s[i] = o(r[i]));
        return s;
    };
    return o(t);
}, Lz = (t, e)=>{
    let n = {
        ...t
    };
    n.globalScope = pL(t.globalScope, e);
    for (let o of tk){
        let r = t[o];
        if (!Zx(r)) continue;
        let s = {};
        for (let i of Object.keys(r))Qt.has(i) || (s[i] = dL(r[i], e));
        n[o] = s;
    }
    for (let o of lL)Zx(t[o]) && (n[o] = Dz(t[o], e));
    return n;
}, ZD = new WeakMap, Pz = (t, e, n)=>{
    let o = ZD.get(t);
    o || ZD.set(t, o = new Map);
    let r = o.get(e);
    if (r) return r;
    let s = (i, a)=>Ct(n, i) && n[i] === a;
    return r = new Proxy(t, {
        get (i, a) {
            if (typeof a == "symbol" || Ct(i, a)) return Reflect.get(i, a);
            let c = Reflect.get(i, a);
            return Ct(e, a) && (c === void 0 || s(a, c)) || c === void 0 ? e[a] : c;
        },
        set (i, a, c) {
            return typeof a != "symbol" && !Ct(i, a) && Ct(e, a) ? (e[a] = c, !0) : Reflect.set(i, a, c);
        },
        has: (i, a)=>Reflect.has(i, a) || a in e
    }), o.set(e, r), r;
}, Iz = (t)=>!!t && typeof t == "object" && !!t.__raw && typeof t.__raw == "object", Mz = (t, e)=>{
    let n = ek.get(t);
    return n ? e === n.consumerGs ? n.libGs : Iz(e) ? Pz(e, n.libGs, n.consumerGs) : e : e;
}, Bz = ()=>{
    typeof globalThis[qD] != "function" && Object.defineProperty(globalThis, qD, {
        value: Mz,
        configurable: !0
    });
}, Lg = (t)=>{
    let e = t[Vs];
    return Array.isArray(e) ? e : null;
}, ok = (t)=>ke(t) ? t.library : t, Nz = (t, e, n)=>{
    let o = Lg(t);
    return !!o && o.some((r)=>r && r.index === e && (!r.key || r.key === n.key) && E(r.id) && Fz(t, r.id));
}, Fz = (t, e)=>{
    let n = JSON.stringify(e), o = new Set, r = (s)=>{
        if (E(s)) return s.includes(n);
        if (!s || typeof s != "object" || o.has(s)) return !1;
        o.add(s);
        for(let i in s)if (r(s[i])) return !0;
        return !1;
    };
    for (let s of [
        "globalScope",
        ...tk,
        ...lL
    ])if (r(t[s])) return !0;
    return !1;
}, pL = (t, e)=>{
    let n = {};
    for (let o of Object.keys(t))Qt.has(o) || (n[o] = nk(t[o], e));
    return n;
}, QD = new WeakMap, qf = (t, e = null)=>{
    let n = t && Lg(t);
    if (!n || !n.length) return 0;
    let o = t.globalScope;
    if (!k(o)) return 0;
    let r = Array.isArray(t.sharedLibraries) ? t.sharedLibraries : [], s = QD.get(o);
    s || QD.set(o, s = new Set), Bz();
    let i = 0;
    for (let a of n){
        if (!a || !E(a.id) || s.has(a.id)) continue;
        let c = ok(r[a.index]);
        if (!c || !k(c.globalScope) || a.key && c.key !== a.key) continue;
        let l = (p)=>typeof p == "function" ? fL(p) : p, f = (p, g)=>{
            if (p === g) return !0;
            let h = l(p), m = l(g);
            return E(h) || E(m) ? h === m : JSON.stringify(p) === JSON.stringify(g);
        }, u = k(e) ? (Array.isArray(a.landed) ? a.landed : []).filter((p)=>E(p) && Ct(c.globalScope, p) && Ct(e, p) && f(e[p], nk(c.globalScope[p], a.id))) : [], d = vs(pL(c.globalScope, a.id));
        Object.setPrototypeOf(d, o), ek.set(a.id, {
            libGs: d,
            consumerGs: o
        });
        for (let p of u)o[p] = d[p];
        s.add(a.id), i++;
    }
    return i;
}, $z = /^@symbo[-.]ls\//, Kf = (t)=>t.includes("/") ? t.slice(t.indexOf("/") + 1) : t, Pg = (t)=>[
        `@symbo-ls/${t}`,
        `@symbo.ls/${t}`
    ], Ks = (t, e)=>{
    let n = [];
    if (!Array.isArray(t) || !t.length) return n;
    let o = new Map, r = (i, a, c)=>{
        for (let l of Pg(i)){
            let f = o.get(l);
            if (f === void 0) {
                o.set(l, a), n.push([
                    l,
                    a
                ]);
                continue;
            }
            f !== a && c && typeof e == "function" && e({
                spec: l,
                kept: f,
                refused: a
            });
        }
    }, s = [];
    for (let i of t){
        let a = ok(i);
        if (!a || typeof a != "object" || a.__isStub) continue;
        let c = a.key || a.name || a.__libraryKey, l = [];
        for (let f of [
            a.key,
            a.name,
            a.__libraryKey,
            a.__libraryName
        ]){
            if (typeof f != "string" || !f || f !== c && !$z.test(f)) continue;
            let u = Kf(f);
            u && !l.includes(u) && l.push(u);
        }
        l.forEach((f, u)=>{
            u === 0 && c && Kf(c) === f ? r(f, a, !1) : s.push([
                f,
                a
            ]);
        });
    }
    for (let [i, a] of s)r(i, a, !0);
    return n;
}, Wa = ({ spec: t, kept: e, refused: n })=>{
    typeof console;
}, JD = [
    "functions",
    "methods",
    "snippets"
], Ig = Symbol.for("smbls.libraryPackages"), Wf = new WeakMap, jz = (t)=>!!t && typeof t == "object" && !Array.isArray(t), Uz = (t)=>({
        get globalScope () {
            return t();
        }
    }), tL = (t, e, n)=>{
    let o = {};
    for (let r of Object.keys(t))Qt.has(r) || (o[r] = t[r]);
    return Object.defineProperty(o, "context", {
        configurable: !0,
        enumerable: !1,
        writable: !0,
        value: Uz(e)
    }), Wf.set(o, n), o;
}, eL = (t)=>!jz(t) || !Wf.has(t) && Object.prototype.hasOwnProperty.call(t, "context"), Yf = (t)=>{
    if (!t || typeof t != "object") return;
    let e = ()=>t.globalScope;
    for (let o of JD){
        let r = t[o];
        eL(r) || Wf.get(r) === t || (t[o] = tL(r, e, t));
    }
    if (Array.isArray(t.sharedLibraries)) {
        let o = Lg(t) || [];
        t.sharedLibraries = t.sharedLibraries.map((r, s)=>{
            let i = ke(r) && r && "library" in r, a = ok(r);
            if (!a || typeof a != "object" || a.__isStub || Wf.get(a) === t) return r;
            let c = o.find((u)=>u && u.index === s && (!u.key || u.key === a.key)), l = ()=>{
                let u = c && ek.get(c.id);
                return u && u.consumerGs === t.globalScope ? u.libGs : t.globalScope;
            }, f = {
                ...a
            };
            for (let u of JD)eL(a[u]) || (f[u] = tL(a[u], l, t));
            return Wf.set(f, t), i ? {
                ...r,
                library: f
            } : f;
        });
    }
    let n = t.globalScope;
    if (n && typeof n == "object") {
        let o = {};
        for (let [r, s] of Ks(t.sharedLibraries, Wa))o[r] = s;
        try {
            Object.defineProperty(n, Ig, {
                configurable: !0,
                enumerable: !1,
                writable: !0,
                value: o
            });
        } catch  {}
    }
}, Rg = "polyglot/translations", Hz = (t, e)=>{
    let n = t;
    for (let o of e.split(".")){
        if (!n || typeof n != "object" || !Ct(n, o)) return !1;
        n = n[o];
    }
    return n !== void 0;
}, hL = (t, e, n, o, r = !1)=>{
    for(let s in e){
        if (!Ct(e, s) || Qt.has(s)) continue;
        let i = `${o}/${s}`;
        if (!n.has(i)) {
            if (Ct(t, s)) k(t[s]) && k(e[s]) && hL(t[s], e[s], n, i);
            else {
                if (r && s.includes(".") && Hz(t, s)) continue;
                t[s] = vr(e[s], n, i);
            }
        }
    }
}, gL = (t, e, n)=>{
    if (!("translations" in t)) {
        t.translations = vr(e, n, Rg);
        return;
    }
    let o = t.translations;
    if (!k(o) || !k(e) || t.fetch) return;
    let r = null;
    for(let s in e){
        if (!Ct(e, s) || Qt.has(s)) continue;
        let i = `${Rg}/${s}`;
        if (!n.has(i)) {
            if (Ct(o, s)) {
                k(o[s]) && k(e[s]) && hL(o[s], e[s], n, i, !0);
                continue;
            }
            k(e[s]) && (r || (r = new Set(we(t, !1))), r.has(s) && (o[s] = vr(e[s], n, i)));
        }
    }
}, Vz = (t, e)=>{
    let n = {};
    for(let o in t){
        if (!Ct(t, o) || Qt.has(o)) continue;
        let r = `polyglot/${o}`;
        e.has(r) || (n[o] = o === "translations" ? vr(t[o], e, r) : Gf(t[o], e, r));
    }
    return n;
}, mL = (t)=>$l(t), zz = (t, e, n, o = "library", r = -1)=>{
    let s = mL(e), i = Ws(s, n), a = !Nz(t, r, s) && vz(t, s, i) > 0 ? `${o}#${Tz()}` : null, c = a ? Lz(s, a) : s, l = a ? new Set(Object.keys(t.globalScope)) : null, f = [];
    for(let u in c)if (Object.prototype.hasOwnProperty.call(c, u) && !(u === "sharePages" || u === "sharedLibIgnore") && u !== Vs && !u.startsWith("__") && !Qt.has(u) && u !== "app" && !i.has(u)) {
        if (k(c[u]) && k(t[u])) {
            if (u === "designSystem") Va(t[u], c[u], i, u);
            else {
                for(let d in c[u])if (!Qt.has(d) && !i.has(`${u}/${d}`) && !(u === "polyglot" && d === "translations")) {
                    if (u === "methods" && xs(d)) {
                        d in t[u] || f.push(d);
                        continue;
                    }
                    d in t[u] ? Cg(u, t[u][d]) && !Cg(u, c[u][d]) ? t[u][d] = c[u][d] : u === "components" && af(t, d, c[u][d]) : t[u][d] = c[u][d];
                }
                u === "polyglot" && Ct(c.polyglot, "translations") && !i.has(Rg) && gL(t.polyglot, c.polyglot.translations, i);
            }
        } else if (!(u in t)) {
            let d = c[u], p = u === "methods" && d && typeof d == "object" ? kz(d, i, f) : d;
            u === "designSystem" ? t[u] = vr(p, i, u) : u === "polyglot" && k(p) ? t[u] = Vz(p, i) : t[u] = _z(Gf(p, i, u), s[u]);
        }
    }
    a && (Lg(t) || (t[Vs] = []), t[Vs].push({
        id: a,
        index: r,
        key: E(s.key) ? s.key : null,
        landed: Object.keys(c.globalScope).filter((u)=>!l.has(u))
    })), f.length && xz(o, f);
}, Wz = (t, e, n)=>{
    if (t !== e) {
        let o = cL(t);
        if (E(o) && o) return o;
        if (t.key || t.name) return t.key || t.name;
    }
    return e && (e.key || e.name) || `sharedLibraries[${n}]`;
}, Kz = `${Yx}/default`, Gz = (t)=>E(t) && t !== "" && zs(t).full === Kz, qz = (t, e)=>{
    if (E(e.key) && e.key) return e.key;
    if (t !== e) {
        if (E(t.key) && t.key) return t.key;
        if (E(t.name) && t.name) return t.name;
    }
    return null;
}, Xf = (t)=>{
    let e = [], n = [];
    for(let o = 0; o < t.length; o++){
        let r = t[o], s = r, i = sL;
        if (ke(s) && (i = za(s.ignoreList), s = s.library), !k(s)) continue;
        let a = {
            entry: r,
            lib: s,
            ignore: i,
            index: o
        };
        Gz(qz(r, s)) ? n.push(a) : e.push(a);
    }
    return {
        linked: e,
        bases: n
    };
}, yL = (t, e, n)=>{
    let o = e(), r = GD(o), s = Sz(o), { linked: i, bases: a } = Xf(t);
    for (let f of i)n(f);
    let c = !r.size && a.length ? GD(e()) : null;
    for (let f of a)n(f);
    return {
        claims: r.size ? r : c && c.size ? c : null,
        ownFamilies: s
    };
}, Zf = (t, e)=>{
    if (!e || !e.length) return;
    let { claims: n, ownFamilies: o } = yL(e, ()=>t.designSystem, ({ entry: r, lib: s, ignore: i, index: a })=>zz(t, s, i, Wz(r, s, a), a));
    aL(t.designSystem, o), n && iL(t.designSystem, n);
}, Gs = (t, e)=>{
    let n = k(t) ? t : null;
    if (!Array.isArray(e) || !e.length) return n || {};
    let o = n ? {
        ...n
    } : {}, { linked: r, bases: s } = Xf(e);
    for (let { lib: i, ignore: a } of [
        ...r,
        ...s
    ]){
        let c = Ws(i, a);
        if (c.has("files")) continue;
        let l = i.files;
        if (k(l)) for(let f in l)!Object.prototype.hasOwnProperty.call(l, f) || Qt.has(f) || c.has(`files/${f}`) || f in o || (o[f] = l[f]);
    }
    return o;
}, nL = (t)=>{
    let e = {};
    for(let n in t)Ct(t, n) && !Qt.has(n) && (e[n] = t[n]);
    return e;
}, rk = (t, e)=>{
    let n = k(t) ? nL(t) : t;
    if (!Array.isArray(e) || !e.length) return n;
    let o = n, { linked: r, bases: s } = Xf(e);
    for (let { lib: i, ignore: a } of [
        ...r,
        ...s
    ]){
        if (!Ct(i, "dependencies")) continue;
        let c = Ws(i, a);
        if (c.has("dependencies")) continue;
        let l = i.dependencies;
        if (k(l) && k(o)) for(let f in l)!Ct(l, f) || Qt.has(f) || c.has(`dependencies/${f}`) || f in o || (o[f] = l[f]);
        else o === void 0 && (o = k(l) ? nL(Gf(l, c, "dependencies")) : l);
    }
    if (!k(o)) return o;
    for (let [i] of Ks(e))delete o[i];
    return o;
}, Yz = (t)=>t === "key" || t === "name" || t === "owner" || t === "sharePages" || t === "sharedLibIgnore" || t.startsWith("__"), Xz = (t)=>{
    let e = [];
    for (let n of [
        t,
        t.config,
        t.settings
    ]){
        let o = k(n) ? n.polyglot : null, r = k(o) ? o.translationsFrom : null;
        E(r) && r && e.push(r.split(".").join("/"));
    }
    return e;
}, Zz = (t, e)=>Yz(t.split("/")[0]) ? !1 : !e.some((n)=>n === t || n.startsWith(`${t}/`) || t.startsWith(`${n}/`)), Qz = (t, e)=>{
    let n = Xz(t), o = new Set;
    for (let s of e)Zz(s, n) && o.add(s);
    if (!o.size) return t;
    let r = null;
    for(let s in t){
        if (!Ct(t, s)) continue;
        let i = t[s], a = o.has(s) ? void 0 : Gf(i, o, s);
        !o.has(s) && a === i || (r || (r = {
            ...t
        }), o.has(s) ? delete r[s] : r[s] = a);
    }
    return r || t;
}, sk = (t)=>{
    if (!Array.isArray(t) || !t.length) return t;
    let e = null;
    for(let n = 0; n < t.length; n++){
        let o = t[n], r = ke(o), s = r ? o.library : o;
        if (!k(s)) continue;
        let i = Ws(s, r ? za(o.ignoreList) : sL), a = i.size ? Qz(s, i) : s;
        a !== s && (e || (e = t.slice()), e[n] = r ? {
            ...o,
            library: a
        } : a);
    }
    return e || t;
}, qs = (t, e, n, o)=>{
    if (typeof e != "string" || Qt.has(e)) return;
    let r = n && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, e) ? n[e] : void 0;
    if (r !== void 0 && !Cg(t, r) || !Array.isArray(o) || !o.length) return r;
    let { linked: s, bases: i } = Xf(o);
    for (let { lib: a, ignore: c } of [
        ...s,
        ...i
    ]){
        let l = Ws(a, c);
        if (l.has(t) || l.has(`${t}/${e}`)) continue;
        let f = a[t];
        if (!(!k(f) || !Object.prototype.hasOwnProperty.call(f, e)) && !Cg(t, f[e])) return f[e];
    }
    return r;
}, Qf = (t, e, n = Va)=>{
    if (!k(t) || !Array.isArray(e) || !e.length) return t;
    let { claims: o, ownFamilies: r } = yL(e, ()=>t, ({ lib: s, ignore: i })=>{
        let a = s.designSystem;
        if (!a || typeof a != "object") return;
        let c = Ws(s, i);
        c.has("designSystem") || n(t, a, c, "designSystem");
    });
    return aL(t, r), o && iL(t, o), t;
}, Jf = (t, e)=>{
    if (!k(t) || !Array.isArray(e) || !e.length) return t;
    let { linked: n, bases: o } = Xf(e);
    for (let { lib: r, ignore: s } of [
        ...n,
        ...o
    ]){
        let i = mL(r), a = i.polyglot;
        if (!k(a) || !Ct(a, "translations")) continue;
        let c = Ws(i, s);
        c.has("polyglot") || c.has(Rg) || gL(t, a.translations, c);
    }
    return t;
};
async function Ys(t, e = {}) {
    let n = e.provider || "kv";
    if (n === "same-origin") return tW(t, e);
    if (n === "api") return oL(t, e);
    let o = await Jz(t, e);
    return o || oL(t, e);
}
async function Jz(t, e = {}) {
    let n = e.kvBaseUrl || hz, o = e.env || "production", r = `${n}/kv/${encodeURIComponent(t)}?env=${o}`;
    try {
        let s = await fetch(r, {
            method: "GET"
        });
        return s.ok && (await s.json())?.value || null;
    } catch  {
        return null;
    }
}
async function tW(t, e = {}) {
    let n = e.sameOriginBase;
    if (!n) return null;
    let o = Array.isArray(e.names) && e.names.length ? `?names=${e.names.map(encodeURIComponent).join(",")}` : "", r = `${n}${mz}${encodeURIComponent(t)}${o}`;
    try {
        let s = await fetch(r, {
            method: "GET"
        });
        return s.ok ? await s.json() : null;
    } catch  {
        return null;
    }
}
async function oL(t, e = {}) {
    let n = e.apiBaseUrl || gz, { owner: o, key: r } = zs(t);
    try {
        let s = `${n}/core/projects/libraries/available?search=${encodeURIComponent(r)}&owner=${encodeURIComponent(o)}&limit=10`, i = await fetch(s, {
            method: "GET"
        });
        if (!i.ok) return null;
        let a = await i.json(), l = (a?.items || a?.data || (Array.isArray(a) ? a : [])).find((g)=>{
            let { key: h } = zs(g?.key);
            return h.toLowerCase() === r.toLowerCase();
        });
        if (!l?.id && !l?._id) return null;
        let f = l.id || l._id, u = `${n}/core/projects/${encodeURIComponent(f)}/data?branch=main`, d = await fetch(u, {
            method: "GET"
        });
        if (!d.ok) return null;
        let p = await d.json();
        return p?.data || p || null;
    } catch  {
        return null;
    }
}
async function rL(t, e = {}) {
    if (k(t)) return t;
    if (E(t)) {
        let { full: n } = zs(t);
        if (!n) return null;
        try {
            let o = await Ys(n, e);
            return o || console.warn(`[smbls] Shared library "${n}" not found`), o;
        } catch (o) {
            return console.warn(`[smbls] Failed to fetch shared library "${n}":`, o.message), null;
        }
    }
    return null;
}
async function tu(t, e = {}) {
    return !t || !t.length ? [] : (await Promise.all(t.map(async (o)=>{
        if (ke(o)) {
            let r = await rL(cL(o), e);
            return r ? {
                library: r,
                ignoreList: o.ignoreList
            } : null;
        }
        return rL(o, e);
    }))).filter(Boolean);
}
var Mg = Object.freeze([
    "metadata",
    "helmet"
]), eW = 8, eu = (t)=>{
    if (E(t)) return t || null;
    if (!t || typeof t != "object" || Array.isArray(t) || !E(t.extends) || !t.extends) return null;
    for(let e in t)if (e !== "extends" && !Mg.includes(e)) return null;
    return t.extends;
}, nu = (t, e)=>{
    if (t === e) return !0;
    let n = eu(t);
    return n !== null && n === eu(e);
}, _L = (t, e)=>{
    if (!E(e) || !e || je.has(e)) return null;
    if (typeof t == "function") return t(e) || null;
    if (!t || typeof t != "object") return null;
    let n = (o)=>Object.prototype.hasOwnProperty.call(t, o) ? t[o] : void 0;
    return n(e) || n(`smbls.${e}`) || null;
}, bL = (t, e)=>{
    if (E(t)) {
        if (!t.includes(">")) return _L(e, t);
        let n = t.split(">").map((r)=>r.trim()), o = _L(e, n[0]);
        for(let r = 1; r < n.length && o; r++)o = je.has(n[r]) ? null : o[n[r]];
        return o && typeof o == "object" ? o : null;
    }
    return t && typeof t == "object" && !Array.isArray(t) ? t : null;
}, Xs = (t)=>!!t && typeof t == "object" && !Array.isArray(t), SL = (t, e)=>{
    let n = {
        ...t
    };
    for(let o in e)je.has(o) || (n[o] = Xs(n[o]) && Xs(e[o]) ? SL(n[o], e[o]) : e[o]);
    return n;
}, nW = (t, e)=>{
    let n = [], o = 0, r = (s, i)=>{
        if (!(i.has(s) || o >= eW)) {
            i.add(s), o++;
            for (let a of Lo(s)){
                let c = bL(a, e);
                c && r(c, i);
            }
            s.metadata !== void 0 && n.push(s.metadata);
        }
    };
    for (let s of Lo(t)){
        let i = bL(s, e);
        i && i !== t && r(i, new Set([
            t
        ]));
    }
    return n;
}, oW = (t)=>{
    let e;
    for (let n of t)e === void 0 ? e = Xs(n) ? {
        ...n
    } : n : Xs(e) && Xs(n) ? e = SL(e, n) : e = n;
    return e;
}, Mo = (t, e)=>{
    let n = E(t) ? {
        extends: t
    } : t;
    if (!n || typeof n != "object" || Array.isArray(n)) return;
    let o = n.metadata !== void 0 ? n.metadata : n.helmet, r = oW(nW(n, e));
    return o === void 0 ? r : Xs(o) && Xs(r) ? {
        ...r,
        ...o
    } : o;
};
var H = (t)=>{
    if (t == null) return "";
    let e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
    };
    return t.toString().replace(/[&<>"']/g, (n)=>e[n]);
}, Ls = (t)=>JSON.stringify(t).replace(/</g, "\\u003c").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029"), io = (t, e, { remove: n = !1, warn: o } = {})=>{
    if (!t || typeof t.querySelector != "function") return null;
    let r = null;
    try {
        r = t.querySelector(e);
    } catch  {
        return null;
    }
    if (!r) return null;
    n && r.parentNode && r.parentNode.removeChild(r);
    let s;
    try {
        s = JSON.parse(r.textContent || "");
    } catch (i) {
        o && o(i);
    }
    return {
        value: s,
        block: r
    };
}, ru = 'script[type="application/json"][data-brender="registry"]', su = 'script[type="application/json"][data-brender="registry-tree"]', iu = (t)=>{
    if (!k(t) || t.f !== "tree" || !Array.isArray(t.e) || t.e.length % 3) return null;
    let e = t.e, n = [], o = {}, r = 0;
    for(let s = 0, i = 0; s < e.length; s += 3, i++){
        let a = e[s], c = e[s + 1], l = e[s + 2];
        if (!Number.isInteger(a) || a < 0 || a > i || typeof c != "string" || !Number.isInteger(l)) return null;
        let f = a ? n[i - a] + "." + c : c;
        r += l, n.push(f), o[f] = "br-" + r;
    }
    return o;
}, au = 'link[rel="preload"][data-smbls="design-system"]', cu = 'meta[name="smbls-design-system"][data-smbls="design-system"]', lu = 'script[type="application/json"][data-smbls="design-system"]', rW = (t)=>k(t) && k(t.config) && Array.isArray(t.rules), ak = (t, e)=>e && e.defer === !0 ? '<meta name="smbls-design-system" content="' + H(t) + '" data-smbls="design-system">' : '<link rel="preload" href="' + H(t) + '" as="fetch" crossorigin="anonymous" data-smbls="design-system">', ck = (t)=>rW(t) ? '<script type="application/json" data-smbls="design-system">' + Ls(t) + "<\/script>" : "", Bg = 'meta[name="brender-stamp"]', lk = ({ stamp: t, time: e } = {})=>'<meta name="brender-stamp" content="' + H(t) + '" data-time="' + (typeof e == "number" && isFinite(e) ? Math.round(e) : "") + '">', Ps = (t)=>{
    if (!t || typeof t.querySelector != "function") return null;
    let e = null;
    try {
        e = t.querySelector(Bg);
    } catch  {
        return null;
    }
    if (!e) return null;
    let n = parseInt(e.getAttribute("data-time"), 10);
    return {
        stamp: e.getAttribute("content") || "",
        time: isFinite(n) ? n : null
    };
}, Ng = 'meta[name="brender-lazy"]', fk = (t)=>{
    let e = Array.isArray(t) ? t.filter((n)=>typeof n == "string" && /^[^\s"<>&]+$/.test(n)) : [];
    return e.length ? '<meta name="brender-lazy" content="' + H(e.join(" ")) + '">' : "";
}, fu = (t)=>{
    if (!t || typeof t.querySelector != "function") return [];
    let e = null;
    try {
        e = t.querySelector(Ng);
    } catch  {
        return [];
    }
    return e ? String(e.getAttribute("content") || "").split(/\s+/).filter(Boolean) : [];
}, sW = /<script\b(?:[^>"']|"[^"]*"|'[^']*')*\btype\s*=\s*["']?importmap["']?(?:[^>"']|"[^"]*"|'[^']*')*>[\s\S]*?<\/script\s*>/gi, uk = (t, e)=>{
    let n = -1;
    for (let o of String(t).matchAll(sW))n = o.index + o[0].length;
    return n === -1 ? null : t.slice(0, n) + `
  ` + e + t.slice(n);
}, wL = (t)=>Object.entries(t || {}).filter(([e, n])=>n !== void 0).map(([e, n])=>`${e}="${H(n)}"`).join(" "), Bn = (t)=>{
    let e = 5381, n = String(t);
    for(let o = 0; o < n.length; o++)e = (e * 33 ^ n.charCodeAt(o)) >>> 0;
    return e.toString(36);
}, iW = new Set([
    "jsonLd",
    "styles",
    "scripts"
]), aW = new Set([
    "source"
]), Ka = (t)=>{
    let e = [];
    if (Array.isArray(t.jsonLd)) for (let n of t.jsonLd){
        if (n == null) continue;
        let o = typeof n == "string" ? n : JSON.stringify(n), r = String(o).replace(/<\/script/gi, "<\\/script");
        e.push(`<script type="application/ld+json" data-smbls-jsonld="${Bn(o)}">${r}<\/script>`);
    }
    if (Array.isArray(t.styles)) for (let n of t.styles){
        if (n == null || !String(n).trim()) continue;
        let o = String(n).replace(/<\/style/gi, "<\\/style");
        e.push(`<style data-smbls-style="${Bn(o)}">${o}</style>`);
    }
    if (Array.isArray(t.scripts)) for (let n of t.scripts){
        if (!n) continue;
        let o = typeof n == "string", r = o ? n : n.src;
        if (!r && !n.body) continue;
        let s = [];
        r && s.push(`src="${H(r)}"`), o || (n.type && s.push(`type="${H(n.type)}"`), n.async && s.push("async"), n.defer && s.push("defer"), n.integrity && s.push(`integrity="${H(n.integrity)}"`), n.crossorigin && s.push(`crossorigin="${H(n.crossorigin)}"`), n.referrerpolicy && s.push(`referrerpolicy="${H(n.referrerpolicy)}"`), n.nomodule && s.push("nomodule"));
        let i = ` data-smbls-script="${H(r || Bn(n.body || ""))}"`;
        if (!o && n.body) {
            let a = String(n.body).replace(/<\/script/gi, "<\\/script");
            e.push(`<script ${s.join(" ")}${i}>${a}<\/script>`);
        } else e.push(`<script ${s.join(" ")}${i}><\/script>`);
    }
    return e;
}, Zs = (t)=>`${t.hreflang || ""}|${t.href || ""}`, Or = (t)=>k(t) ? Bn(JSON.stringify(t)) : String(t), Qs = (t)=>k(t) ? Bn(JSON.stringify(t)) : String(t), cW = (t, e, n)=>t === "favicons" ? Array.isArray(e) && (typeof n == "string" || k(n)) ? ` data-smbls-favicon="${H(Or(n))}"` : "" : (t === "icon" || t === "favicon") && typeof e == "string" ? ` data-smbls-single-icon="${H(e)}"` : "", lW = (t)=>k(t) ? ` data-smbls-alternate="${H(Zs(t))}"` : "", uu = "data-smbls-host", du = "forced", dk = `meta[name="robots"][${uu}="${du}"]`, pk = (t, e)=>{
    let n = !e;
    n && (t = {
        ...t,
        robots: "noindex"
    });
    let o = !1, r = Object.entries(t).reduce((s, [i, a])=>{
        if (!a && a !== 0 && a !== !1 || iW.has(i) || aW.has(i)) return s;
        if (i === "title") return s.push(`<title>${H(a)}</title>`), s;
        if (i === "robots" && n) return s.push(`<meta name="robots" content="noindex" ${uu}="${du}">`), s;
        if (i === "canonical") return s.push(`<link rel="canonical" href="${H(a)}">`), s;
        if (i === "manifest") return s.push(`<link rel="manifest" href="${H(a)}">`), s;
        if (i === "favicon" || i === "favicons" || i === "icon" || i === "icons") return (Array.isArray(a) ? a : [
            a
        ]).forEach((d)=>{
            let p = cW(i, a, d);
            if (typeof d == "string") s.push(`<link rel="icon" href="${H(d)}"${p}>`);
            else if (typeof d == "object") {
                let g = wL(d);
                /rel=/.test(g) ? s.push(`<link ${g}${p}>`) : s.push(`<link rel="icon" ${g}${p}>`);
            }
        }), s;
        if (i === "alternate") return (Array.isArray(a) ? a : [
            a
        ]).forEach((d)=>{
            if (d && typeof d == "object") {
                let p = Object.entries(d).filter(([g, h])=>h !== void 0).map(([g, h])=>`${g}="${H(h)}"`).join(" ");
                s.push(`<link rel="alternate" ${p}${lW(d)}>`);
            }
        }), s;
        if (i === "theme-color" && Array.isArray(a)) return a.forEach((u)=>{
            if (!k(u)) return;
            let d = wL({
                name: "theme-color",
                content: u.content,
                media: u.media
            });
            s.push(`<meta ${d} data-smbls-theme-color="${H(Qs(u))}">`);
        }), s;
        let c = (u, d, p = "name")=>{
            if (typeof d == "string" || typeof d == "number" || typeof d == "boolean") s.push(`<meta ${p}="${H(u)}" content="${H(d)}">`);
            else if (Array.isArray(d)) d.forEach((g)=>{
                if (typeof g == "string" || typeof g == "number" || typeof g == "boolean") s.push(`<meta ${p}="${H(u)}" content="${H(g)}">`);
                else if (typeof g == "object") {
                    let h = Object.entries(g).filter(([m, y])=>y !== void 0).map(([m, y])=>`${m}="${H(y)}"`).join(" ");
                    s.push(`<meta ${h}>`);
                }
            });
            else if (typeof d == "object") {
                let g = Object.entries(d).filter(([h, m])=>m !== void 0).map(([h, m])=>`${h}="${H(m)}"`).join(" ");
                s.push(`<meta ${g}>`);
            }
        };
        if (i.startsWith("http-equiv:")) {
            let u = i.replace("http-equiv:", "");
            return c(u, a, "http-equiv"), s;
        }
        if (i.startsWith("itemprop:")) {
            let u = i.replace("itemprop:", "");
            return c(u, a, "itemprop"), s;
        }
        let f = [
            "og:",
            "twitter:",
            "fb:",
            "article:",
            "profile:",
            "book:",
            "business:",
            "music:",
            "product:",
            "video:",
            "DC:",
            "DCTERMS:"
        ].find((u)=>i.startsWith(u));
        if (f) {
            let u = i.replace(f, "");
            return c(`${f.replace(":", "")}:${u}`, a, f === "twitter:" || f === "DC:" || f === "DCTERMS:" ? "name" : "property"), s;
        }
        if (i.startsWith("apple:") || i.startsWith("msapplication:")) {
            let u = i.startsWith("apple:") ? "apple-" : "msapplication-", d = i.replace(/^apple:|^msapplication:/, "");
            return c(`${u}${d}`, a, "name"), s;
        }
        return i === "viewport" && (o = !0), c(i, a), s;
    }, [
        '<meta charset="UTF-8">'
    ]);
    return o || r.splice(1, 0, '<meta name="viewport" content="width=device-width, initial-scale=1">'), r.push(...Ka(t)), r.join(`
`);
}, fW = (t)=>typeof t == "string" && t.length > 0 && !t.startsWith("/") && !t.startsWith("http"), ou = (t)=>typeof t == "string" && t.length > 0, Fg = (t)=>{
    if (!t || typeof t != "object") return null;
    if (ou(t.src)) return t.src;
    let e = t.content;
    return !e || typeof e != "object" ? null : ou(e.src) ? e.src : ou(e.storageUrl) ? e.storageUrl : null;
}, uW = new Set([
    "icon",
    "favicon",
    "icons",
    "favicons"
]), xL = (t, e)=>{
    if (typeof t == "string") return e(t);
    if (!k(t)) return t;
    let n = {
        ...t
    };
    return ou(n.href) && (n.href = e(n.href)), ou(n.src) && (n.src = e(n.src)), n;
};
function Cr(t, e) {
    if (!e || typeof e != "object") return t;
    let n = (r)=>!fW(r) || !Object.prototype.hasOwnProperty.call(e, r) ? r : Fg(e[r]) || r, o = {
        ...t
    };
    for (let [r, s] of Object.entries(o))uW.has(r) ? o[r] = Array.isArray(s) ? s.map((i)=>xL(i, n)) : xL(s, n) : typeof s == "string" ? o[r] = n(s) : Array.isArray(s) && (o[r] = s.map((i)=>typeof i == "string" ? n(i) : i));
    return o;
}
function ik(t, e) {
    if (!t || !e) return;
    let n = e.split("."), o = t;
    for (let r of n){
        if (o == null || typeof o != "object") return;
        o = o[r];
    }
    return o;
}
function dW(t, e) {
    let n = ik(t, e);
    if (typeof n == "number") return Number.isFinite(n) ? n : void 0;
    if (typeof n == "string" && !ur(n)) return n;
}
function pW(t, e, n, o) {
    let s = (e.config || e.settings || {}).polyglot || e.polyglot, i = te(n?.lang, s), c = (dr(e, s) || {})[i] || {}, l = [
        n?.state,
        o,
        e.state
    ].filter((d)=>d && typeof d == "object"), f = (d)=>{
        for (let p of l){
            let g = dW(p, d);
            if (g !== void 0) return g;
        }
    }, u = {
        ...t
    };
    for (let [d, p] of Object.entries(u))typeof p != "string" || !p.includes("{{") || (u[d] = p.replace(/\{\{\s*([^|{}]+?)\s*(?:\|\s*(\w+)\s*)?\}\}/g, (g, h, m)=>{
        let y = h.trim();
        if (m === "polyglot") return c[y] ?? ik(c, y) ?? g;
        if (m === "getLocalStateLang") return f(y + i) ?? g;
        let b = f(y);
        return b !== void 0 ? b : c[y] ?? ik(c, y) ?? g;
    }));
    return u;
}
function kL(t) {
    if (!k(t)) return {};
    let e = {
        ...t
    };
    for (let [n, o] of Object.entries(e))if (typeof o == "function") {
        let r = o.toString(), s = r.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (s) {
            e[n] = `{{ ${s[1]} | getLocalStateLang }}`;
            continue;
        }
        let i = r.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (i) {
            e[n] = `{{ ${i[1]} | polyglot }}`;
            continue;
        }
        let a = r.match(/s\.(\w+(?:\.\w+)+)/);
        if (a) {
            e[n] = `{{ ${a[1]} }}`;
            continue;
        }
        delete e[n];
    } else if (typeof o == "string") {
        let r = o.match(/el\.call\(\s*["']getLocalStateLang["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (r) {
            e[n] = `{{ ${r[1]} | getLocalStateLang }}`;
            continue;
        }
        let s = o.match(/el\.call\(\s*["']polyglot["']\s*,\s*["']([^"']+)["']\s*\)/);
        if (s) {
            e[n] = `{{ ${s[1]} | polyglot }}`;
            continue;
        }
        if (o.includes("=>") && o.includes("s.")) {
            let i = o.match(/s\.(\w+(?:\.\w+)+)/);
            if (i) {
                e[n] = `{{ ${i[1]} }}`;
                continue;
            }
        }
        ur(o) && delete e[n];
    }
    return e;
}
var TL = (t)=>t.replace(/^\//, "").split("/"), hW = (t)=>{
    try {
        return decodeURIComponent(t);
    } catch  {
        return t;
    }
}, gW = (t, e)=>{
    if (typeof t != "string" || typeof e != "string") return null;
    let n = TL(e).filter(Boolean), o = {};
    return t !== "/*" && TL(t).forEach((r, s)=>{
        let i = /^:(.+)/.exec(r);
        i && n[s] && (o[i[1]] = hW(n[s]));
    }), {
        route: t,
        routePath: "/" + (n[0] || ""),
        params: o
    };
}, mW = (t, e)=>qs("components", e, t.components, t.sharedLibraries);
function hk(t, e, n, { isProduction: o = !1, channel: r = "production" } = {}) {
    let s = t.pages?.[e], i = k(s?.state) && s?.state, a = Mo(s, (m)=>mW(t, m)) || i || {}, c = kL(a), l = new Set(Object.keys(c)), f = t.app?.metadata || {}, u = kL(f), d = {};
    if (t.integrations?.seo ? d = {
        ...t.integrations.seo,
        ...u,
        ...c
    } : Object.keys(u).length ? d = {
        ...u,
        ...c
    } : d = {
        ...c
    }, !d.title) {
        let m = t.name || t.key;
        m ? o ? d.title = m : r === "development" ? d.title = `${m} / dev:symbo.ls` : r === "staging" ? d.title = `${m} / staging:symbo.ls` : d.title = `${m} / symbo.ls` : d.title = "Symbols demo";
    }
    d = pW(d, t, n, gW(e, n?.actualPathname)), d.title && (l.has("title") || !d["og:title"]) && (l.has("og:title") || (d["og:title"] = d.title)), d.description && (l.has("description") || !d["og:description"]) && (l.has("og:description") || (d["og:description"] = d.description)), d.title && !d["twitter:title"] && (d["twitter:title"] = d.title), d.description && !d["twitter:description"] && (d["twitter:description"] = d.description);
    let p = l.has("og:url") ? d["og:url"] : l.has("url") ? d.url : void 0, g = n?.actualPathname || e;
    if (p) d["og:url"] = p;
    else if (d["og:url"] || d.url) {
        let m = (d["og:url"] || d.url || "").replace(/\/$/, "");
        if (m && g && g !== "/") {
            let y = g.startsWith("/") ? g : "/" + g;
            d["og:url"] = m + y;
        }
    }
    d = Cr(d, Gs(t.files, t.sharedLibraries));
    let h = t.name || t.app?.metadata?.title || t.app?.name || "";
    for (let [m, y] of Object.entries(d))if (typeof y == "string" && y.includes("{{")) {
        let b = y.replace(/\{\{[^}]*\}\}/g, "").trim();
        b ? d[m] = b : m === "title" ? d[m] = h : delete d[m];
    }
    return d;
}
var $g = (t, e)=>(B(e) ? e : Object.values(e)).reduce((n, o)=>Math.abs(o - t) < Math.abs(n - t) ? o : n), gk = (t, e)=>(t = parseFloat(t), k(e) && (e = Object.values(e)), $g(t, e));
var mk = async (t)=>{
    try {
        await navigator.clipboard.writeText(t);
    } catch (e) {
        console.warn("Failed to copy text: ", e);
    }
}, yk = async (t)=>{
    try {
        let e = new Blob([
            t
        ], {
            type: "text/javascript"
        }), n = new window.ClipboardItem({
            "text/plain": e
        });
        await navigator.clipboard.write([
            n
        ]), console.log("JavaScript code copied to clipboard as text/javascript");
    } catch (e) {
        console.error("Failed to copy JavaScript code: ", e);
    }
}, _k = (t)=>t.replace(/[^a-zA-Z0-9_]/g, ""), Bo = (t)=>(typeof t != "string" && (t = String(t || "")), t.replace(/(?:^\w|[A-Z]|\b\w)/g, function(e, n) {
        return n === 0 ? e.toLowerCase() : e.toUpperCase();
    }).replace(/\s+/g, "")), bk = (t)=>t && t.replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.substr(1).toLowerCase()), pu = (t)=>t.replace(/[^a-zA-Z0-9]/g, " ").trim().toLowerCase().replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, ""), Sk = (t = "")=>{
    if (typeof t != "string") return;
    let e = t.replace(/([A-Z])/g, " $1");
    return e.charAt(0).toUpperCase() + e.slice(1);
}, Js = (t)=>{
    if (B(t)) return t;
    if (E(t)) return t.split(" ");
    if (k(t)) return Object.values(t);
    if (be(t)) return [
        t
    ];
};
var EL = /[A-Za-z_$][A-Za-z0-9_$-]*/g, AL = /[A-Za-z_$][A-Za-z0-9_$]*(?: [A-Za-z0-9_$]+){1,5}/g, yW = (t, e)=>{
    EL.lastIndex = 0;
    let n;
    for(; n = EL.exec(t);){
        let r = n[0];
        if (e.add(r), r.indexOf("-") !== -1) for (let s of r.split("-"))s && e.add(s);
    }
    AL.lastIndex = 0;
    let o;
    for(; o = AL.exec(t);){
        let r = o[0].split(" ");
        for(let s = 0; s < r.length - 1; s++)for(let i = 2; i <= 6 && s + i <= r.length; i++)e.add(Bo(r.slice(s, s + i).join(" ")));
    }
    return e;
}, CL = (t)=>ke(t) ? t.library : t, vL = [
    "components",
    "pages",
    "snippets"
], _W = [
    "name",
    "icon"
], jg = (t)=>{
    if (!k(t)) return null;
    let e = t.key;
    if (!e) return null;
    let n = t.owner, o = k(n) ? n.slug : n;
    return o ? `${o}/${e}` : String(e);
}, bW = /^\s*(?:async\s+)?(?:function\b|\(|[A-Za-z_$][A-Za-z0-9_$]*\s*=>)/, Ug = (t)=>{
    let e = new Set, n = (o)=>{
        if (Array.isArray(o)) {
            for (let r of o)if (n(r)) return !0;
            return !1;
        }
        if (!k(o) || e.has(o)) return !1;
        e.add(o);
        for (let r of _W){
            let s = o[r];
            if (typeof s == "string" && bW.test(s)) return !0;
        }
        for (let r of Object.keys(o))if (n(o[r])) return !0;
        return !1;
    };
    for (let o of vL)if (n(t[o])) return !0;
    for (let o of t.sharedLibraries || []){
        let r = CL(o);
        if (k(r)) {
            for (let s of vL)if (n(r[s])) return !0;
        }
    }
    return !1;
}, wk = (t, e = {})=>{
    if (!k(t) || !Array.isArray(t.sharedLibraries)) return null;
    let n = k(t.settings) ? t.settings.libraryIconPrune : void 0;
    if (n === !1) return null;
    let o = !!(e && e.lateLoad);
    if (n !== !0 && !o && Ug(t)) return null;
    let r = [];
    for (let p of t.sharedLibraries){
        let g = CL(p), h = k(g) && g.designSystem, m = k(h) && h.icons;
        if (!k(m)) continue;
        let y = jg(g);
        y && r.push({
            id: y,
            icons: m,
            designSystem: h
        });
    }
    if (!r.length) return null;
    let s = new Set(r.map((p)=>p.designSystem)), i = JSON.stringify(t, function(p, g) {
        if (p !== "__ssr" && !(p === "icons" && s.has(this))) return g;
    });
    if (typeof i != "string") return null;
    let a = yW(i, new Set), c = new Map, l = [], f = 0, u = 0, d = 0;
    for (let p of r){
        let g = [];
        for (let h of Object.keys(p.icons)){
            if (a.has(h)) {
                u++;
                continue;
            }
            g.push(h);
            let m = p.icons[h];
            d += h.length + (typeof m == "string" ? m.length : 0);
        }
        g.length && (f += g.length, c.set(p.icons, new Set(g)), l.push({
            id: p.id,
            icons: g
        }));
    }
    return f ? {
        drops: c,
        prune: {
            libraries: l
        },
        report: {
            icons: f,
            kept: u,
            bytes: d
        }
    } : null;
}, xk = (t)=>function(e, n) {
        let o = t.get(this);
        if (!(o && o.has(e))) return n;
    }, RL = (t)=>{
    let e = k(t) && k(t.designSystem) && t.designSystem.icons;
    return k(e) ? e : null;
}, SW = ()=>null, OL = 512, wW = (t, e)=>{
    let n = new Map, o = null, r = (i, a, c)=>{
        let l = (f)=>{
            for (let u of a)c.get(u)(f && Object.prototype.hasOwnProperty.call(f, u) ? f : null);
        };
        Ys(i, {
            ...e,
            names: a
        }).then(RL, SW).then(l);
    }, s = ()=>{
        let i = o;
        o = null;
        for (let [a, c] of i){
            let l = [
                ...c.keys()
            ];
            for(let f = 0; f < l.length; f += OL)r(a, l.slice(f, f + OL), c);
        }
    };
    return (i)=>{
        let a = t.get(i);
        if (!a) return null;
        let c = n.get(i);
        if (!c) {
            o || (o = new Map, Promise.resolve().then(s));
            let l = o.get(a);
            l || o.set(a, l = new Map), c = new Promise((f)=>l.set(i, f)), n.set(i, c);
        }
        return c;
    };
}, Hg = (t, e = {})=>{
    let n = new Map;
    for (let i of t && t.libraries || [])if (!(!i || !i.id || !Array.isArray(i.icons))) for (let a of i.icons)n.has(a) || n.set(a, i.id);
    if (!n.size) return null;
    let o = t && typeof t.sameOriginBase == "string" && t.sameOriginBase;
    if (o) return wW(n, {
        ...e,
        provider: "same-origin",
        sameOriginBase: o
    });
    let r = new Map, s = (i)=>{
        let a = r.get(i);
        return a || (a = Promise.resolve().then(()=>Ys(i, e)).then(RL), r.set(i, a)), a;
    };
    return (i)=>{
        let a = n.get(i);
        return a ? s(a) : null;
    };
}, hu = (t, e = {})=>{
    if (!k(t)) return !1;
    let n = t.__libraryIconPrune;
    if (!k(n)) return !1;
    let o = t.designSystem;
    if (!k(o) || o.iconsLoader) return !1;
    let r = Hg(n, e);
    return r ? (o.iconsLoader = r, !0) : !1;
};
var kk = ()=>{
    let t = document.styleSheets[0], e = "";
    if (t) try {
        let n = t.cssRules || t.rules;
        for(let o = 0; o < n.length; o++)e += n[o].cssText;
    } catch (n) {
        console.error("Unable to access CSS rules. This may be due to CORS restrictions:", n);
    }
    return e;
};
var Te = (t)=>{
    let e = t && t.src;
    if (!e || typeof e != "string") return null;
    let n = t.context;
    if (!n) return null;
    let o = n.assets && n.assets[e] || n.files && n.files[e];
    if (!o) return null;
    if (typeof o == "string") return {
        src: o,
        type: null,
        variants: null
    };
    if (typeof o == "object") {
        if (typeof o.src == "string") return o;
        let r = o.content, s = r && r.src;
        if (typeof s == "string") return {
            ...o,
            src: s,
            type: o.type ?? r.type ?? null,
            variants: o.variants ?? r.variants ?? null
        };
    }
    return null;
}, Ga = (t, { keepOneX: e = !0 } = {})=>{
    if (!Array.isArray(t) || !t.length) return "";
    let n = t.some((r)=>typeof r.width == "number"), o = [];
    for (let r of t)n && typeof r.width == "number" ? o.push(`${r.src} ${r.width}w`) : n || (r.scale === 1 && e ? o.push(r.src) : r.scale && r.scale !== 1 && o.push(`${r.src} ${r.scale}x`));
    return o.join(", ");
}, gu = (t)=>{
    if (!t || !Array.isArray(t.variants)) return "";
    let e = t.variants.filter((n)=>n.format === t.type);
    return Ga(e, {
        keepOneX: !1
    });
}, mu = (t, e)=>{
    if (!t || typeof t != "object" || typeof t.src != "string") return [];
    if (!Array.isArray(t.variants) || !t.variants.length) return [
        {
            tag: "img",
            attr: {
                src: t.src,
                alt: e || ""
            }
        }
    ];
    let n = new Map;
    for (let a of t.variants)n.has(a.format) || n.set(a.format, []), n.get(a.format).push(a);
    let o = [];
    for (let [a, c] of n)a !== t.type && o.push({
        tag: "source",
        attr: {
            type: a,
            srcset: Ga(c, {
                keepOneX: !0
            })
        }
    });
    let r = n.get(t.type) || [], s = Ga(r, {
        keepOneX: !1
    }), i = {
        src: t.src,
        alt: e || ""
    };
    return s && (i.srcset = s), [
        ...o,
        {
            tag: "img",
            attr: i
        }
    ];
};
var Ya = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
}, ln = (t)=>{
    if (t === "") return [
        0,
        0,
        0,
        0
    ];
    if (t.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    let e = Ya[t.toLowerCase()];
    if (e && (t = e), t[0] === "#") return t.length < 7 && (t = "#" + t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + (t.length > 4 ? t[4] + t[4] : "")), [
        parseInt(t.substr(1, 2), 16),
        parseInt(t.substr(3, 2), 16),
        parseInt(t.substr(5, 2), 16),
        t.length > 7 ? parseInt(t.substr(7, 2), 16) / 255 : 1
    ];
    if (t.indexOf("rgb") === -1 && wt && R) {
        let n = wt.body.appendChild(wt.createElement("fictum")), o = "rgb(1, 2, 3)";
        if (n.style.color = o, n.style.color !== o) {
            wt.body.removeChild(n);
            return;
        }
        if (n.style.color = t, n.style.color === o || n.style.color === "") return wt.body.removeChild(n), [
            0,
            0,
            0,
            0
        ];
        t = R.getComputedStyle(n).color, wt.body.removeChild(n);
    }
    return t.indexOf("rgb") === 0 ? (t.indexOf("rgba") === -1 && (t = `${t}, 1`), t.match(/[\.\d]+/g).map((n)=>+n)) : [
        0,
        0,
        0,
        0
    ];
}, Tk = (t, e, n = .5)=>(t = ln(t), e = ln(e), qg(t, e, n)), Ek = (t, e = 1)=>{
    let [n, o, r] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return `rgb(${n},${o},${r})`;
}, Vg = (t, e = 1)=>{
    let [n, o, r] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return [
        n,
        o,
        r
    ];
}, Ak = (t, e, n)=>"#" + (16777216 | t << 16 | e << 8 | n).toString(16).slice(1), zg = ([t, e, n])=>(16777216 + (t << 16) + (e << 8) + n).toString(16).slice(1), vk = (t, e = 1)=>{
    let [n, o, r] = t.match(/\w\w/g).map((s)=>parseInt(s, 16));
    return `rgba(${n},${o},${r},${e})`;
}, Ok = (t, e, n = .5)=>{
    let o = [];
    for(let r = 0; r < 3; r++)o[r] = ~~(t[r] + (e[r] - t[r]) * n);
    return `rgb(${o})`;
}, Ck = (t, e)=>{
    let [n, o, r] = e, s = Math.max(0, Math.min(100, r + parseFloat(t)));
    return [
        n,
        o,
        s
    ];
}, Wg = (t, e, n)=>{
    let o = Math.max(t, e, n), r = o - Math.min(t, e, n), s = 1 - Math.abs(o + o - r - 1), i = r && (o == t ? (e - n) / r : o == e ? 2 + (n - t) / r : 4 + (t - e) / r);
    return [
        60 * (i < 0 ? i + 6 : i),
        s ? r / s : 0,
        (o + o - r) / 2
    ];
}, Kg = (t, e, n, o = e * Math.min(n, 1 - n), r = (s, i = (s + t / 30) % 12)=>n - o * Math.max(Math.min(i - 3, 9 - i, 1), -1))=>[
        r(0),
        r(8),
        r(4)
    ], Gg = (t, e)=>{
    let n = parseInt(t, 16), o = (n >> 16) + e;
    o > 255 ? o = 255 : o < 0 && (o = 0);
    let r = (n >> 8 & 255) + e;
    r > 255 ? r = 255 : r < 0 && (r = 0);
    let s = (n & 255) + e;
    return s > 255 ? s = 255 : s < 0 && (s = 0), ((s | r << 8 | o << 16) + 16777216).toString(16).slice(1);
}, qg = (t, e, n = .5)=>{
    let o = [];
    for(let r = 0; r < 4; r++){
        let s = r === 3 ? (i)=>i : Math.round;
        o[r] = s(t[r] + (e[r] - t[r]) * n);
    }
    return `rgba(${o})`;
}, Xa = (t, e)=>{
    let n = ln(t);
    if (!n) {
        Do();
        return;
    }
    return n[3] = e, `rgba(${n})`;
}, Nt = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, ei = new Set([
    "currentcolor",
    "transparent",
    "thin",
    "medium",
    "thick"
]), Fo = /(?:rgba?\(|hsla?\(|#[0-9a-fA-F]{3,8}\b)/, xW = /^(?:#[0-9a-f]{3,8}|(?:rgba?|hsla?|hwb|lab|lch|oklab|oklch|color|color-mix|light-dark)\([\s\S]*\))$/i, ni = (t)=>xW.test(t), yu = (t)=>t.indexOf("(") === -1 ? t.split(/\s+/) : at(t), Yg = (t, e)=>{
    let n = t.length, o = 0, r = 0;
    for(let s = 0; s <= n; s++){
        let i = s < n ? t.charCodeAt(s) : 32;
        if (i === 40) {
            o++;
            continue;
        }
        if (i === 41) {
            o > 0 && o--;
            continue;
        }
        if (!(o > 0 || !(i <= 32 || i === 44 || i > 127 && /\s/.test(t[s])))) {
            if (s > r && !kW(t, r, s, e)) return !1;
            r = s + 1;
        }
    }
    return !0;
}, kW = (t, e, n, o)=>{
    let r = t.charCodeAt(e);
    if (r >= 48 && r <= 57) return !0;
    let s = t.slice(e, n);
    return ni(s) || o !== void 0 && o.has(s);
}, Za = (t, e)=>e ? Nn(t).map((n)=>yu(n.trim())) : [
        yu(t)
    ], Qa = (t)=>{
    let e = t[0].join(" ");
    for(let n = 1; n < t.length; n++)e += ", " + t[n].join(" ");
    return e;
}, $o = (t, e, { commas: n, keywords: o }, r, s)=>{
    let i = Fo.test(t);
    if (i && Yg(t, o)) return t;
    let a = Za(t, n), c = !1;
    try {
        for (let l of a)for(let f = 0; f < l.length; f++){
            let u = l[f], d = TW(u, e, o, r, s);
            d !== u && (l[f] = d, c = !0);
        }
    } catch (l) {
        if (i) return t;
        throw l;
    }
    return i && !c ? t : Qa(a);
}, TW = (t, e, n, o, r)=>t ? Nt(t) ? `var(${t})` : ni(t) || n !== void 0 && n.has(t) ? t : e(t, o, r) : "", EW = /^([a-zA-Z]\w*(?:-[a-zA-Z]\w*)*)(?:\.(\d+))?(?:([+-]\d+|=\d+))?$/, ee = (t)=>{
    if (!E(t)) return null;
    if (Fo.test(t)) return {
        passthrough: t
    };
    if (Nt(t)) return {
        cssVar: t
    };
    let e = t.match(EW);
    if (!e) return null;
    let [, n, o, r] = e, s = o !== void 0 ? `0.${o}` : void 0, i = r && r[0] === "=" ? r.slice(1) : r;
    return {
        name: n,
        alpha: s,
        tone: i
    };
}, fn = (t)=>E(t) && (t.includes("rgb") || t.includes("var(") || t.includes("#")), Nn = (t)=>{
    let e = [], n = "", o = 0;
    for (let r of t){
        if (r === "(" ? o += 1 : r === ")" && o > 0 && (o -= 1), r === "," && o === 0) {
            e.push(n), n = "";
            continue;
        }
        n += r;
    }
    return (n.length || !e.length) && e.push(n), e;
}, at = (t)=>{
    let e = [], n = "", o = 0;
    for (let r of t){
        if (r === "(" ? o += 1 : r === ")" && o > 0 && (o -= 1), o === 0 && /\s/.test(r)) {
            n.length && e.push(n), n = "";
            continue;
        }
        n += r;
    }
    return n.length && e.push(n), e;
}, qa = (t)=>(t /= 255, t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4)), ti = (t)=>.2126 * qa(t[0]) + .7152 * qa(t[1]) + .0722 * qa(t[2]), Ja = (t, e)=>{
    let n = ti(t) + .05, o = ti(e) + .05;
    return n > o ? n / o : o / n;
}, Xg = (t)=>(t /= 255, t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4)), Zg = (t)=>(t <= .0031308 ? t * 12.92 : 1.055 * Math.pow(t, 1 / 2.4) - .055) * 255, _u = ([t, e, n])=>{
    let [o, r, s] = [
        t,
        e,
        n
    ].map(Xg), i = .4122214708 * o + .5363325363 * r + .0514459929 * s, a = .2119034982 * o + .6806995451 * r + .1073969566 * s, c = .0883024619 * o + .2817188376 * r + .6299787005 * s, l = Math.cbrt(i), f = Math.cbrt(a), u = Math.cbrt(c);
    return [
        .2104542553 * l + .793617785 * f - .0040720468 * u,
        1.9779984951 * l - 2.428592205 * f + .4505937099 * u,
        .0259040371 * l + .7827717662 * f - .808675766 * u
    ];
}, Qg = ([t, e, n])=>{
    let o = t + .3963377774 * e + .2158037573 * n, r = t - .1055613458 * e - .0638541728 * n, s = t - .0894841775 * e - 1.291485548 * n, i = o ** 3, a = r ** 3, c = s ** 3;
    return [
        4.0767416621 * i - 3.3077115913 * a + .2309699292 * c,
        -1.2684380046 * i + 2.6097574011 * a - .3413193965 * c,
        -0.0041960863 * i - .7034186147 * a + 1.707614701 * c
    ];
}, bu = ([t, e, n])=>{
    let o = Math.atan2(n, e) * 180 / Math.PI;
    return o < 0 && (o += 360), [
        t,
        Math.sqrt(e * e + n * n),
        o
    ];
}, Jg = ([t, e, n])=>{
    let o = n * Math.PI / 180;
    return [
        t,
        e * Math.cos(o),
        e * Math.sin(o)
    ];
}, Su = (t, e, n, o = 24)=>{
    let r = (a)=>Qg(Jg([
            t,
            a,
            n
        ])), s = (a)=>a.every((c)=>c >= -0.0001 && c <= 1.0001), i = r(e);
    if (!s(i)) {
        let a = 0, c = e;
        for(let l = 0; l < o; l++){
            let f = (a + c) / 2;
            s(r(f)) ? a = f : c = f;
        }
        i = r(a);
    }
    return i.map((a)=>Zg(Math.max(0, Math.min(1, a))));
}, oi = (t, e = 1, n = [
    255,
    255,
    255
])=>e >= 1 ? t : t.map((o, r)=>o * e + n[r] * (1 - e)), Fn = (t, e)=>{
    E(t) && t.includes("rgb") && (t = ln(t).join(", ")), E(t) && (t = t.split(",").map((r)=>parseFloat(r.trim()))), be(e) && (e += "");
    let n = zg(t), o = e.slice(0, 1);
    if (o === "-" || o === "+") {
        let r = Gg(n, parseFloat(e));
        return Vg(r).join(", ");
    } else {
        let [r, s, i] = t, [a, c] = Wg(r / 255, s / 255, i / 255), l = Math.max(0, Math.min(100, parseFloat(e))) / 100;
        return Kg(a, c, l).map((u)=>Math.round(Math.max(0, Math.min(1, u)) * 255)).join(", ");
    }
};
var Rk = (t, e)=>{
    if (t) return t.themes && t.themes[e] ? t.themes[e] : t[e] ? [
        t,
        t[e]
    ] : t;
};
var un = (t, e)=>{
    if (!t || !e) return null;
    try {
        return new URL(t), null;
    } catch  {}
    let n = e[t];
    return n ? n.content && n.content.src : null;
}, jo = (t, e)=>{
    if (!t) return;
    if (e != null && e !== "" && e !== "default") {
        let s = t[e];
        return s && typeof s == "object" ? s.value : void 0;
    }
    let o = ()=>Object.keys(t).find((s)=>s !== "default" && t[s] && t[s].value && !t[s].isSystemFallback && !t[s].isSharedLibrary);
    if (t.__defaultKey) {
        let s = t[t.__defaultKey];
        if (s && s.isSystemFallback) {
            let i = o();
            if (i) return t[i].value;
        }
        if (s) return s.value;
    }
    let r = o() || Object.keys(t).find((s)=>s !== "default" && t[s] && t[s].value);
    return r && t[r] && t[r].value;
}, DL = {
    woff2: "woff2",
    woff: "woff",
    ttf: "truetype",
    otf: "opentype",
    eot: "embedded-opentype",
    ttc: "collection"
}, tm = (t)=>{
    if (typeof t != "string" || !t) return null;
    let e = t.split(/[#?]/)[0].split(".").pop().trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(DL, e) ? DL[e] : null;
}, tc = (t)=>t && (t.includes("fonts.googleapis.com") || t.includes("fonts.gstatic.com")), ec = (t)=>`@import url('${t}');`, em = (t)=>`@font-face { ${t} }`, wu = (t, e, n, o = {})=>{
    let i = (Array.isArray(e) ? e : [
        e
    ]).filter((a)=>typeof a == "string" && a).map((a)=>{
        let c = tm(a), l = c ? ` format('${c}')` : "";
        return `url('${a}')${l}`;
    }).join(`,
       `);
    return `
  font-family: '${t}';
  font-style: ${o.fontStyle || "normal"};${n ? `
  font-weight: ${n};` : ""}${o.fontStretch ? `
  font-stretch: ${o.fontStretch};` : ""}${o.fontDisplay ? `
  font-display: ${o.fontDisplay};` : ""}${o.unicodeRange ? `
  unicode-range: ${o.unicodeRange};` : ""}
  src: ${i};`;
}, Rr = (t, e, n, o)=>`@font-face {${wu(t, e, n, o)}
}`, ri = (t, e, n)=>Object.keys(e).map((r)=>{
        let { url: s, fontWeight: i, fontStyle: a, fontDisplay: c, fontStretch: l, unicodeRange: f } = e[r], u = Array.isArray(s) ? s.map((d)=>un(d, n) || d) : un(s, n) || s;
        return wu(t, u, i, {
            fontStyle: a,
            fontDisplay: c,
            fontStretch: l,
            unicodeRange: f
        });
    }), Dk = (t)=>Object.keys(t).map((n)=>ri(n, t[n].value)), nm = (t, e, n)=>{
    if (e && e.isVariable) {
        let s = un(e.url, n) || e.url;
        return tc(s) ? ec(s) : Rr(t, s, e.fontWeight, {
            fontStretch: e.fontStretch,
            fontDisplay: e.fontDisplay || "swap",
            unicodeRange: e.unicodeRange
        });
    }
    if (e[0]) return ri(t, e, n).map(em);
    let r = Array.isArray(e.url) ? e.url.map((s)=>un(s, n) || s) : un(e.url, n) || e.url;
    return Rr(t, r, e.fontWeight, {
        fontStyle: e.fontStyle,
        fontDisplay: e.fontDisplay,
        fontStretch: e.fontStretch,
        unicodeRange: e.unicodeRange
    });
}, Lk = (t, e)=>Object.keys(t).map((o)=>nm(o, t[o].value, e));
var nc = /*@__PURE__*/ F({}, {
    animation: ()=>Yk,
    breakpoints: ()=>Gk,
    class: ()=>t0,
    color: ()=>jk,
    devices: ()=>qk,
    document: ()=>LL,
    font: ()=>Ik,
    fontFace: ()=>Nk,
    fontFamily: ()=>Mk,
    fontFamilyTypes: ()=>Bk,
    gradient: ()=>Uk,
    grid: ()=>Jk,
    icons: ()=>zk,
    media: ()=>Fk,
    reset: ()=>PL,
    semanticIcons: ()=>Wk,
    sequence: ()=>Uo,
    shadow: ()=>Vk,
    shape: ()=>o0,
    sizes: ()=>n0,
    skins: ()=>r0,
    spacing: ()=>$k,
    svg: ()=>Xk,
    svgData: ()=>om,
    svg_data: ()=>Zk,
    templates: ()=>Qk,
    theme: ()=>Hk,
    timing: ()=>Kk,
    typography: ()=>xu,
    unit: ()=>Pk,
    vars: ()=>e0,
    viewTransition: ()=>s0
});
var Uo = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    "double-octave": 4
};
var Pk = {
    default: "em"
};
var AW = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: Uo["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
}, xu = AW;
var Ik = {};
var Mk = {}, Bk = {
    "sans-serif": "Helvetica, Arial, sans-serif",
    serif: "Times New Roman, Georgia, serif",
    monospace: "Courier New, monospace"
}, Nk = {};
var Fk = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};
var vW = {
    base: xu.base,
    type: "spacing",
    ratio: Uo.phi,
    range: [
        -5,
        15
    ],
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
}, $k = vW;
var jk = {}, Uk = {};
var Hk = {};
var Vk = {};
var zk = {}, Wk = {};
var OW = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: Uo["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: !1,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
}, Kk = OW;
var LL = {};
var Gk = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
}, qk = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};
var Yk = {};
var Xk = {}, om = {}, Zk = om;
var Qk = {};
var CW = {}, Jk = CW;
var t0 = {};
var PL = {}, e0 = {}, n0 = {}, o0 = {}, r0 = {}, s0 = {};
var im = {}, am = {}, ue = new Set, rm = nc, sm = {}, Eu = (t)=>t.replace(/_([a-z])/g, (e, n)=>n.toUpperCase());
for(let t in rm){
    let e = t.toLowerCase();
    sm[e] = rm[t];
    let n = Eu(e);
    n !== e && (sm[n] = rm[t]), e !== t && (sm[t] = rm[t]);
}
var si = {
    verbose: !1,
    useVariable: !0,
    useReset: !0,
    globalTheme: "auto",
    cssVars: im,
    cssMediaVars: am,
    CSS_VARS: im,
    CSS_MEDIA_VARS: am,
    cssSkinVars: {},
    cssSkinFallback: {},
    _scratchConfig: !0,
    ...sm
}, Dr = (t, e)=>{
    if (!t) return null;
    if (t.__globalThemeSignal) return jt(e) && t.__globalThemeSignal.set(e), t.__globalThemeSignal;
    let n = jt(e) ? e : t.globalTheme, o = On(jt(n) ? n : "auto");
    return Object.defineProperty(t, "globalTheme", {
        get () {
            return o.get();
        },
        set (r) {
            o.set(r);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(t, "__globalThemeSignal", {
        value: o,
        enumerable: !1,
        configurable: !0,
        writable: !0
    }), o;
}, IL = (t)=>t ? Dr(t) : null, Lr = (t, e)=>{
    if (!t) return null;
    if (t.__resolvedThemeSignal) return jt(e) && t.__resolvedThemeSignal.set(e), t.__resolvedThemeSignal;
    let n = jt(e) ? e : t.resolvedTheme, o = On(jt(n) ? n : null);
    return Object.defineProperty(t, "resolvedTheme", {
        get () {
            return o.get();
        },
        set (r) {
            o.set(r);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t, "__resolvedThemeSignal", {
        value: o,
        enumerable: !1,
        configurable: !0,
        writable: !0
    }), o;
}, ML = (t)=>t ? Lr(t) : null;
Dr(si);
Lr(si);
var ku = ft(si), Ve = {
    active: "0",
    0: si
}, BL = (t)=>(jt(t) && (Ve.active = t), Ve[t || Ve.active]), Tu = [], pt = (t)=>{
    t && t._scratchConfig && Tu.push(t);
}, ut = ()=>{
    Tu.pop();
}, L = (t)=>Tu.length ? Tu[Tu.length - 1] : Ve[t || Ve.active] || si, cm = (t)=>{
    if (k(t)) return Ve.active = "1", Ve[1] = mt(t, ft(ku), ue), oc(Ve[1]), Dr(Ve[1]), Lr(Ve[1]), t;
}, RW = [
    "useReset",
    "useFontImport",
    "useIconSprite",
    "useSvgSprite",
    "useDocumentTheme",
    "useDefaultIcons",
    "useDefaultConfig"
], DW = [
    "useVariable",
    "globalTheme",
    "verbose"
], LW = [
    [
        "fontfamily",
        "fontFamily",
        "font_family"
    ],
    [
        "fontfamilytypes",
        "fontFamilyTypes"
    ],
    [
        "semanticicons",
        "semanticIcons"
    ],
    [
        "svgdata",
        "svgData",
        "svg_data"
    ]
], oc = (t)=>{
    for (let e of LW){
        let n;
        for (let o of e){
            let r = t[o];
            k(r) && (n = n ? mt(n, r, ue) : r);
        }
        if (n) for (let o of e)k(t[o]) && (t[o] = n);
    }
}, NL = (t)=>(t.cssVars = {}, t.cssMediaVars = {}, t.CSS_VARS = t.cssVars, t.CSS_MEDIA_VARS = t.cssMediaVars, t.cssSkinVars = {}, t.cssSkinFallback = {}, t._scratchConfig = !0, oc(t), Dr(t), Lr(t), t), lm = ()=>NL(ft(ku)), Au = (t, e, { cleanBase: n = !1 } = {})=>{
    let o = n ? null : L(), r = ft(!n && o && o._scratchConfig ? o : ku);
    for (let i of RW)delete r[i];
    for (let i of DW)Object.prototype.hasOwnProperty.call(ku, i) ? r[i] = ku[i] : delete r[i];
    let s = NL(mt(e || {}, r, ue));
    return t && (Ve[t] = s), s;
};
var $n = /^-?[A-Z][0-9]?$/, i0 = 0, Ho = (t)=>{
    i0++;
    try {
        return t();
    } finally{
        i0--;
    }
}, dn = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
}, PW = Object.keys(dn).reduce((t, e)=>(t[dn[e]] = Number(e), t), {}), IW = (t, e, n, o)=>{
    if ($n.test(e)) {
        if (t && Object.keys(t).length) return t[e] !== void 0;
        let r = PW[e.slice(0, 1)];
        if (r === void 0) return !1;
        let { range: s } = n;
        return !Array.isArray(s) || s.length < 2 ? !0 : r >= Math.min(s[0], s[1]) && r <= Math.max(s[0], s[1]);
    }
    if (o && Object.keys(o).length) return !1;
}, c0 = (t, e)=>{
    let { key: n, variable: o, value: r, scaling: s, index: i, scalingVariable: a } = t;
    e.sequence[n] = {
        key: n,
        decimal: ~~(r * 100) / 100,
        val: ~~r,
        scaling: s,
        index: i,
        scalingVariable: a,
        variable: o
    }, e.scales[n] = s;
    let c = FL.has(e.unit) ? "rem" : e.unit;
    e.vars[o] = s + c;
}, Vo = (t)=>{
    if (!t.includes("(")) return t;
    let e = t.trim(), n = e.indexOf("("), o = e.slice(0, n), r = 0, s = -1;
    for(let i = n; i < e.length; i++){
        let a = e[i];
        if (a === "(") r++;
        else if (a === ")" && (r--, r === 0)) {
            s = i;
            break;
        }
    }
    return s === -1 || /\s/.test(o) || e.slice(s + 1).trim() !== "" ? [
        void 0,
        t
    ] : [
        o,
        e.slice(n + 1, s)
    ];
}, a0 = "\0", MW = (t, e)=>{
    let n = "", o = 0, r = "";
    for (let s of t){
        if (o === 0 && s !== "(") {
            n += s;
            continue;
        }
        r += s, s === "(" ? o++ : s === ")" && (o--, o === 0 && (n += a0 + e.length + a0, e.push(r), r = ""));
    }
    return n + r;
}, BW = (t, e)=>t.indexOf(a0) === -1 ? t : t.replace(/\u0000(\d+)\u0000/g, (n, o)=>e[Number(o)]), NW = /^(calc|min|max|clamp)\((.*)\)$/, FW = (t, e)=>{
    let n = NW.exec(t);
    return n ? `${n[1]}(${Du(n[2], e)})` : t.indexOf("(") !== -1 ? t : ii(t, e);
}, FL = new Set([
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh"
]), vu = (t, e)=>{
    let { base: n, type: o, unit: r } = e, s = FL.has(r) ? "rem" : r, i = (gs(s) ? 1 : n) + s;
    if (t === 0) return i;
    let c = "--" + (e.varPrefix ? e.varPrefix + "-" : "") + (o && o.replace(".", "-")), l = `${c}-ratio`;
    if (t > 0) {
        let f = dn[t - 1];
        return `calc(var(${c}-${f}) * var(${l}))`;
    }
    if (t < 0) {
        let f = dn[t + 1], u = Math.abs(t), d = Math.pow($L, 2 * u), p = dn[u];
        return p ? `max(calc(var(${c}-${f}) / var(${l})), calc(var(${c}-${p}) / ${d.toFixed(4)}))` : `calc(var(${c}-${f}) / var(${l}))`;
    }
}, fm = (t, e, n, o)=>{
    let { type: r } = o, i = t === 2 && e.length === 2 ? t + 1 : t, l = `${"--" + (o.varPrefix ? o.varPrefix + "-" : "") + (r && r.replace(".", "-"))}-sub-ratio-`;
    return `calc(var(${n}) * var(${l + i}))`;
}, Ou = (t, e)=>{
    let o = (t * e - t) / 1.618, r = t * e - o, s = t + o, i = (r + s) / 2;
    return [
        r,
        i,
        s
    ];
}, Cu = (t, e)=>Ou(t, e).map((n)=>n / t), Ru = (t, e)=>{
    let { key: n, base: o, value: r, ratio: s, variable: i, index: a } = t, l = ~~(r * s) - ~~r, f, [u, d, p] = Ou(r, s);
    l > 16 ? f = [
        u,
        d,
        p
    ] : f = [
        u,
        p
    ], f.forEach((g, h)=>{
        let m = ~~(g / o * 1e3) / 1e3, y = i + (h + 1), b = a + (h + 1) / 10, T = fm(h + 1, f, i, e), v = {
            key: n + (h + 1),
            variable: y,
            value: g,
            scaling: m,
            scalingVariable: T,
            index: b
        };
        c0(v, e);
    });
}, $L = 1.618, $W = (t, e, n)=>{
    if (t >= 0) return e * Math.pow(n, t);
    let o = Math.abs(t), r = e * Math.pow(n, t), s = e * Math.pow(n, o) / Math.pow($L, 2 * o);
    return Math.max(r, s);
}, Ee = (t)=>{
    let { type: e, base: n, ratio: o, range: r, subSequence: s } = t, i = Math.abs(r[0]) + Math.abs(r[1]), c = "--" + (t.varPrefix ? t.varPrefix + "-" : "") + (e && e.replace(".", "-")) + "-";
    for(let l = 0; l <= i; l++){
        let f = r[1] - l, u = dn[f], d = $W(f, n, o), p = ~~(d / n * 100) / 100, g = c + u, h = vu(f, t), m = {
            key: u,
            variable: g,
            value: d,
            base: n,
            scaling: p,
            scalingVariable: h,
            ratio: o,
            index: f
        };
        c0(m, t), s && Ru(m, t);
    }
    return t;
}, l0 = (t, e = 0)=>{
    let { type: n, base: o, ratio: r, subSequence: s } = t, i = E(e) ? e : dn[e], a = E(e) ? Object.entries(dn).find(([, m])=>m === e)?.[0] : e;
    if (!i) return null;
    let c = {
        sequence: {},
        scales: {},
        vars: {},
        ...t
    }, l = o * Math.pow(r, a), f = ~~(l / o * 100) / 100, p = "--" + (t.varPrefix ? t.varPrefix + "-" : "") + (n && n.replace(".", "-")) + "-" + i, g = vu(a, t), h = {
        key: i,
        variable: p,
        value: l,
        base: o,
        scaling: f,
        scalingVariable: g,
        ratio: r,
        index: a
    };
    return c0(h, c), s && Ru(h, c), c;
}, rc = (t, e)=>{
    if (!t || !E(e) || !e) return;
    let n = t[e] || t[e.toLowerCase()];
    if (n !== void 0) return e.charCodeAt(0) === 45 ? `calc(${n} * -1)` : n;
    if (e.charCodeAt(0) !== 45 || e.length < 2) return;
    let o = e.slice(1), r = t[o] || t[o.toLowerCase()];
    if (r !== void 0) return `calc(${r} * -1)`;
}, ii = (t = "A", e)=>{
    let n = L(), { unit: o } = n;
    if (E(t) && Nt(t)) return `var(${t})`;
    if (E(t) && /^(?:env|var|calc|min|max|clamp)\(/.test(t.trim())) return t;
    if (E(t)) {
        let S = rc(n.sizes, t);
        if (S !== void 0) return S;
    }
    let { sequence: r, unit: s = o.default, useVariable: i } = e, a = /^-?[a-zA-Z]/i, c = a.test(t);
    if (Ll(t) || !c || [
        "none",
        "auto",
        "max-content",
        "min-content",
        "fit-content",
        "inherit",
        "initial",
        "unset",
        "revert",
        "revert-layer"
    ].includes(t)) return t;
    let d = `--${e.varPrefix ? e.varPrefix + "-" : ""}${pu(e.type.replace(".", "-"))}-`, p = t.toUpperCase(), g = p.slice(0, 1) === "-" ? "-" : "", h = g ? p.slice(1) : p, m = "";
    h.includes("_") && (m = "_" + h.split("_")[1].toLowerCase(), h = h.split("_")[0]);
    let y = (S)=>a.test(S) ? `var(${d}${S}${m})` : S;
    if (h.includes("+")) {
        let [S, w] = h.split("+"), _ = `${y(S)} + ${y(w)}`;
        return g ? `calc((${_}) * -1)` : `calc(${_})`;
    } else if (h.includes("*")) {
        let [S, w] = h.split("*"), _ = `${y(S)} * ${y(w)}`;
        return g ? `calc((${_}) * -1)` : `calc(${_})`;
    } else if (h.includes("-")) {
        let [S, w] = h.split("-"), _ = `${y(S)} - ${y(w)}`;
        return g ? `calc((${_}) * -1)` : `calc(${_})`;
    }
    !r[h] && h.length === 2 && (n.verbose, h = h.slice(0, 1));
    let b = r ? r[h] : null, T = !!(i || n.useVariable);
    if ((T ? IW(r, h, e, n.sizes) : !!b) === !1) {
        if (i0 > 0) return;
        return;
    }
    if (T) {
        let S = `var(${d}${h}${m})`;
        return g ? `calc(${S} * -1)` : S;
    }
    return s === "ms" || s === "s" ? g + b.val + s : g + b.scaling + s;
}, Du = (t, e)=>{
    if (![
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((i)=>t.includes(i + " ")).length) return t;
    let o = /(\s+-\s+|\s*[+*/,]\s*)/, r = [];
    return MW(t, r).split(o).map((i)=>{
        let a = BW(i, r), c = a.trim();
        return !c || [
            "+",
            "-",
            "*",
            "/",
            ","
        ].includes(c) ? a : FW(c, e);
    }).join("");
}, lo = (t, e, n, o)=>{
    if (typeof t != "string") return L().verbose, {
        [e]: t
    };
    if (t === "-" || t === "") return {};
    if (!o && t.includes("(")) {
        if (/^(?:env|var)\(/.test(t.trim())) return {
            [e]: t
        };
        let s = Vo(t);
        o = s[0], t = s[1];
    }
    return [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((s)=>t.includes(s + " ")).length ? t = Du(t, n) : t = ii(t, n), {
        [e]: o ? `${o}(${t})` : t
    };
}, um = (t, e)=>dn[t - e], Lu = (t)=>{
    let { h1Matches: e, sequence: n } = t;
    return new Array(6).fill(null).map((o, r)=>{
        let s = um(e, r);
        return n[s];
    });
};
var f0 = (t, e)=>{
    let n = L(), { cssVars: o } = n;
    z(t.value) || (o[t.var] = t.value);
}, Pu = (t, e, n)=>{
    let o = L(), { unit: r } = o, s = e.unit || r.default, { base: i, ratio: a, type: c } = e, f = "--" + (e.varPrefix ? e.varPrefix + "-" : "") + (c && c.replace(".", "-"));
    t[`${f}-base`] = i, t[`${f}-unit`] = s;
    let u = `${f}-ratio`;
    t[u] = a;
    let [d, p, g] = Cu(i, a);
    t[`${f}-sub-ratio-1`] = `calc(var(${f}-ratio) * ${d / a})`, t[`${f}-sub-ratio-2`] = `calc(var(${f}-ratio) * ${p / a})`, t[`${f}-sub-ratio-3`] = `calc(var(${f}-ratio) * ${g / a})`;
}, jL = new Set([
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh"
]), zo = (t, e = {})=>{
    let n = L(), { unit: o, timing: r, cssVars: s } = n, i = t.unit || o.default, a = jL.has(i) ? "rem" : i, { mediaRegenerate: c, sequence: l, scales: f } = t;
    c || Pu(s, t, e);
    for(let u in l){
        let d = l[u], p = (t.type === r.type ? l[u].val : f[u]) + a;
        if (!c) {
            s[d.variable + "_default"] = p, s[d.variable] = d.scalingVariable;
            continue;
        }
        e.useDefault === !1 ? s[d.variable] = p : (s[d.variable + "_default"] = p, s[d.variable] = `var(${d.variable + "_default"})`);
    }
}, Pr = (t, e, n = {})=>{
    let o = L(), { unit: r, media: s, cssVars: i } = o, a = e.slice(1), c = t[e], l = c.unit || t.unit || r.default, f = jL.has(l) ? "rem" : l, { mediaRegenerate: u } = t, { sequence: d, scales: p } = c, g = s && s[a];
    if (g) {
        if (!u) {
            let h = i[`@media ${g}`];
            h || (h = i[`@media ${g}`] = {}), Pu(h, c, n);
            let m = t.unit || r.default;
            if (f !== m && d) for(let y in d){
                let b = d[y], T = p[y] + f;
                h[b.variable + "_default"] = T, h[b.variable] = T;
            }
            return;
        }
        for(let h in d){
            let m = d[h], y = (gs(f) ? p[h] : d[h].val) + f, b = i[`@media ${g}`];
            b || (b = i[`@media ${g}`] = {}), b[m.variable] = `var(${m.variable + "_" + a})`, i[m.variable + "_" + a] = y;
        }
    }
};
var HL = Do(), Iu = (t)=>{
    let e = L(), n = "";
    for(let o in t)e.__svgCache[o] || (e.__svgCache[o] = !0, n += t[o]);
    return n;
}, jW = (t)=>{
    let e = t && (t.default || t);
    if (!E(e)) return HL, {};
    let n = e.match(/<svg\s+(.*?)>/);
    if (!n || !n[1]) return {};
    let r = n[1].match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return r ? r.reduce((s, i)=>{
        let [a, c] = i.split("=");
        return s[a] = c.replace(/['"]/g, ""), s;
    }, {}) : {};
}, UW = (t, e)=>{
    let n = [];
    if (t.replace(/id="([^"]*)"/g, (r, s)=>(n.push(s), r)), !n.length) return t;
    let o = t;
    for (let r of n){
        let s = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), i = `${e}-${r}`;
        o = o.replace(new RegExp(`id="${s}"`, "g"), `id="${i}"`).replace(new RegExp(`url\\(#${s}\\)`, "g"), `url(#${i})`).replace(new RegExp(`xlink:href="#${s}"`, "g"), `xlink:href="#${i}"`).replace(new RegExp(`href="#${s}"`, "g"), `href="#${i}"`);
    }
    return o;
}, UL = new Set, HW = /\s(?:id|xmlns|viewBox|width|height)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'>]+)/g, Mu = (t, e)=>{
    let n = e && e.default ? e.default : e;
    if (!E(n)) return HL && !UL.has(t) && UL.add(t), "";
    e = n;
    let o = e.match(/^<symbol\b[^>]*\bid="([^"]*)"/);
    if (o) {
        let d = o[1];
        return d === t ? e : e.replace(`id="${d}"`, `id="${t}"`);
    }
    let r = jW(e), { width: s, height: i } = r, a = r.viewBox || `0 0 ${s || 24} ${i || 24}`, c = "http://www.w3.org/2000/svg", l = UW(e, t), f = `<symbol id="${t}" xmlns="${c}" viewBox="${a}"`, u = l.replace("<svg", f);
    return u = u.replace(/^<symbol\b[^>]*>/, (d)=>f + d.slice(f.length).replace(HW, "")), u = u.replace("</svg", "</symbol"), u = WW(u), u;
}, VW = "line|circle|ellipse|rect|polyline|polygon|path|stop|use|image", zW = new RegExp(`<(${VW})\\b([^>]*?)\\s*/>`, "g"), WW = (t)=>t.replace(zW, "<$1$2></$1>");
var uc = /*@__PURE__*/ F({}, {
    STANDARD_SCHEME_QUERIES: ()=>pm,
    __resetSkinWarnings: ()=>_0,
    appendSVGSprite: ()=>Qu,
    appendSvgIconsSprite: ()=>yi,
    applyDocument: ()=>Zu,
    applyHeadings: ()=>bm,
    applyReset: ()=>Ju,
    applySkins: ()=>Hu,
    applySpacingSequence: ()=>Fu,
    applyTimingSequence: ()=>Xu,
    applyTypographySequence: ()=>Gu,
    atSchemes: ()=>Br,
    buildSkinVarStyles: ()=>gi,
    checkIfBoxSize: ()=>Nu,
    colorPairSchemes: ()=>Bu,
    forcedScheme: ()=>di,
    getColor: ()=>ct,
    getFontFamily: ()=>Ku,
    getFontSizeByKey: ()=>qu,
    getMediaBorder: ()=>Uu,
    getMediaColor: ()=>Wt,
    getMediaTheme: ()=>hn,
    getSafeInk: ()=>mm,
    getSafeInkInfo: ()=>g0,
    getShadow: ()=>ju,
    getShapeByKey: ()=>Yu,
    getSpacingBasedOnRatio: ()=>ze,
    getSpacingByKey: ()=>Ut,
    getTheme: ()=>x0,
    getTimingByKey: ()=>Ae,
    getTimingFunction: ()=>We,
    inForcedColors: ()=>ai,
    isForcedColorsQuery: ()=>ci,
    isIntendedSystemColorWord: ()=>li,
    isPlainColor: ()=>Mr,
    literalPairCompound: ()=>pi,
    literalSchemeMap: ()=>Ko,
    quietColorProbe: ()=>fi,
    resolveBorderValue: ()=>de,
    resolveColorRgb: ()=>ui,
    resolveColorsInGradient: ()=>Fr,
    resolveShadowNonColorWord: ()=>ic,
    resolveShadowValue: ()=>hi,
    runThroughMedia: ()=>_m,
    schemeGuardSelector: ()=>gm,
    schemeMediaQuery: ()=>hm,
    setAdaptiveSchemeVar: ()=>Nr,
    setColor: ()=>Wo,
    setFont: ()=>Wu,
    setFontFamily: ()=>lc,
    setGradient: ()=>sc,
    setMediaTheme: ()=>cc,
    setSVG: ()=>fc,
    setShadow: ()=>$r,
    setSvgIcon: ()=>mi,
    setTheme: ()=>zu,
    skinLiteralBlocks: ()=>Vu,
    splitSpacedValue: ()=>$u
});
var pm = {
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)"
}, hm = (t, e)=>{
    let n = e.media && e.media[t] || pm[t];
    return n ? "@media " + (n === "print" ? `${n}` : `screen and ${n}`) : null;
}, gm = (t)=>{
    let e = t.scopeSelector || ":root";
    return `${e === ":root" ? ":root:not([data-theme])" : `:root:not([data-theme]) ${e}:not([data-theme])`} &`;
}, pn = new Set, KL = new Set([
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkgrey",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkslategrey",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dimgrey",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "green",
    "greenyellow",
    "grey",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightslategrey",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "slategrey",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
]), GL = [
    "AccentColor",
    "AccentColorText",
    "ActiveText",
    "ButtonBorder",
    "ButtonFace",
    "ButtonText",
    "Canvas",
    "CanvasText",
    "Field",
    "FieldText",
    "GrayText",
    "Highlight",
    "HighlightText",
    "LinkText",
    "Mark",
    "MarkText",
    "SelectedItem",
    "SelectedItemText",
    "VisitedText",
    "ActiveBorder",
    "ActiveCaption",
    "AppWorkspace",
    "Background",
    "ButtonHighlight",
    "ButtonShadow",
    "CaptionText",
    "InactiveBorder",
    "InactiveCaption",
    "InactiveCaptionText",
    "InfoBackground",
    "InfoText",
    "Menu",
    "MenuText",
    "Scrollbar",
    "ThreeDDarkShadow",
    "ThreeDFace",
    "ThreeDHighlight",
    "ThreeDLightShadow",
    "ThreeDShadow",
    "Window",
    "WindowFrame",
    "WindowText"
], qL = new Set(GL.map((t)=>t.toLowerCase())), KW = new Set(GL), u0 = 0, ai = (t)=>{
    u0++;
    try {
        return t();
    } finally{
        u0--;
    }
}, GW = /(^|[^\w-])(not\s+)?\(\s*forced-colors\s*(?::\s*(active|none)\s*)?\)/i, ci = (t)=>{
    if (!E(t)) return !1;
    let e = t.match(GW);
    return !e || e[2] || e[3] && e[3].toLowerCase() === "none" ? !1 : !/^\s*(?:@media\s+)?not\b/i.test(t);
}, YL = (t)=>u0 > 0 || KW.has(t), li = (t)=>E(t) && qL.has(t.toLowerCase()) && YL(t), qW = /^(?:#[0-9a-f]{3,8}$|(?:rgba?|hsla?|hwb|lab|lch|oklab|oklch|color|color-mix)\()/i, YW = /gradient\(|url\(|image-set\(|var\(/i, XW = new Set([
    "transparent",
    "currentColor",
    "currentcolor"
]), Mr = (t)=>{
    if (!E(t)) return !1;
    let e = t.trim();
    return YW.test(e) ? !1 : qW.test(e) ? !0 : KL.has(e) || XW.has(e);
}, dm = new Set, VL = (t)=>{
    if (!t) return !1;
    let { color: e, gradient: n } = t;
    return !!(k(e) && Object.keys(e).length || k(n) && Object.keys(n).length);
}, zL = new Set, d0 = 0, fi = (t)=>{
    d0++;
    try {
        return t();
    } finally{
        d0--;
    }
}, ZW = (t, e)=>{
    if (!E(t) || t.indexOf(" ") === -1) return null;
    let n = t.replace(/\s+/g, ""), o = ee(n);
    if (!o || o.passthrough || o.cssVar) return null;
    let { color: r, gradient: s } = e;
    return !r[o.name] && !s[o.name] ? null : n;
}, p0 = (t, e, n)=>{
    let o = ZW(t, n);
    if (o) {
        if (!zL.has(t)) {
            zL.add(t);
            let a = n && n.name ? ` (design system \`${n.name}\`)` : "";
        }
        return;
    }
    let r = ee(t);
    if (r && r.name && !r.passthrough && !r.cssVar && (r.alpha !== void 0 || r.tone !== void 0) && VL(n) && !n.color[r.name] && !n.gradient[r.name]) {
        if (!d0 && !dm.has(t)) {
            dm.add(t);
            let a = n && n.name ? ` (design system \`${n.name}\`)` : "";
        }
        return;
    }
    let s = E(e) ? e.toLowerCase() : "", i = qL.has(s);
    if (!KL.has(s) && !i || i && YL(e) || !VL(n)) return t;
    if (!dm.has(s)) {
        dm.add(s);
        let a = n && n.name ? ` (design system \`${n.name}\`)` : "";
    }
}, XL = (t, e, n)=>{
    let o = e !== void 0 ? e : 1;
    if (!n) return `rgb(from ${t} r g b / ${o})`;
    if (n.charCodeAt(0) === 43 || n.charCodeAt(0) === 45) {
        let s = parseFloat(n), i = s < 0 ? "-" : "+", a = Math.abs(s);
        return `rgb(from ${t} calc(r ${i} ${a}) calc(g ${i} ${a}) calc(b ${i} ${a}) / ${o})`;
    }
    return `hsl(from ${t} h s ${n}% / ${o})`;
}, ct = (t, e, n)=>{
    let o = n || L();
    if (!E(t)) {
        o.verbose;
        return;
    }
    if (Nt(t)) return `var(${t})`;
    e && t[e] && (t = t[e]);
    let r, s, i;
    if (B(t)) [r, s, i] = t;
    else {
        let u = ee(t);
        if (!u) {
            let { color: d, gradient: p } = o, g = p[t] || d[t];
            return g ? (e && g[e] && (g = g[e]), o.useVariable ? `var(${g.var})` : g.value) : p0(t, t, o);
        }
        if (u.passthrough) return u.passthrough;
        if (u.cssVar) return `var(${u.cssVar})`;
        r = u.name, s = u.alpha, i = u.tone;
    }
    let { color: a, gradient: c } = o, l = a[r] || c[r];
    if (!l) return p0(t, r, o);
    if (e) {
        if (l[e] !== void 0) l = l[e];
        else if (B(l)) {
            let u = e.charCodeAt(0) === 64 ? e.slice(1) : e;
            u === "dark" ? l = l[1] !== void 0 ? l[1] : l[0] : (u !== "light" && o.verbose, l = l[0]);
        } else o.verbose;
    }
    if (E(l)) {
        if (pn.has(r)) return l;
        pn.add(r);
        try {
            return ct(l, null, n);
        } finally{
            pn.delete(r);
        }
    }
    let f = l.rgb;
    if (!f) {
        let u = o.useVariable ? `var(${l.var})` : l.value;
        return (s || i) && u ? XL(u, s, i) : u;
    }
    return i && !l[i] && (f = Fn(f, i), l[i] = {
        rgb: f,
        var: `${l.var}-${i}`
    }), l[i] && (f = l[i].rgb), s ? `rgba(${f}, ${s})` : i ? `rgba(${f}, ${l.alpha !== void 0 ? l.alpha : 1})` : o.useVariable ? `var(${l.var})` : l.value !== void 0 ? l.value : `rgb(${f})`;
}, WL = (t)=>{
    let e = ln(t);
    return !e || e.length < 3 || e[0] === 0 && e[1] === 0 && e[2] === 0 && e[3] === 0 && t.toLowerCase() !== "transparent" ? null : {
        rgb: [
            e[0],
            e[1],
            e[2]
        ],
        alpha: e[3] !== void 0 ? e[3] : 1
    };
}, QW = (t, e)=>{
    if (!e) return t;
    let n = t.rgb;
    if (e.tone) {
        let r = Fn(n, e.tone);
        n = E(r) ? r.split(",").map((s)=>parseFloat(s.trim())) : r;
    }
    let o = e.alpha !== void 0 ? parseFloat(e.alpha) : t.alpha;
    return {
        rgb: n,
        alpha: o
    };
}, ui = (t, e, n)=>{
    let o = e || L();
    if (!E(t)) return null;
    let r = ee(t);
    if (r) {
        if (r.passthrough) {
            let d = ln(r.passthrough);
            return d && d.length >= 3 ? {
                rgb: [
                    d[0],
                    d[1],
                    d[2]
                ],
                alpha: d[3] !== void 0 ? d[3] : 1
            } : null;
        }
        if (r.cssVar) return null;
    }
    let s = r ? r.name : t, { color: i, gradient: a } = o, c = i[s] || a[s];
    if (!c) return WL(t);
    if (E(c)) {
        let d;
        if (pn.has(s)) d = WL(c);
        else {
            pn.add(s);
            try {
                d = ui(c, o, n);
            } finally{
                pn.delete(s);
            }
        }
        return d ? QW(d, r) : null;
    }
    if (c.rgb === void 0 && k(c)) {
        let d = `@${n || "light"}`;
        c = c[d] !== void 0 ? c[d] : c["@light"];
    }
    if (!c || c.rgb === void 0) return null;
    let l = c.rgb;
    r && r.tone && (l = Fn(l, r.tone));
    let f = E(l) ? l.split(",").map((d)=>parseFloat(d.trim())) : l, u = r && r.alpha !== void 0 ? parseFloat(r.alpha) : c.alpha !== void 0 ? c.alpha : 1;
    return {
        rgb: f,
        alpha: u
    };
}, ZL = (t)=>k(t) && t.value !== void 0 && (t.rgb !== void 0 || t.var !== void 0), Br = (t)=>{
    let e = [];
    for(let n in t)n.charCodeAt(0) === 64 && e.push(n.slice(1));
    return e;
}, h0 = (t)=>{
    if (!k(t) || t.value !== void 0) return null;
    for(let n in t)if (n !== "var" && (n.charCodeAt(0) !== 64 || !ZL(t[n]))) return null;
    let e = Br(t);
    return e.length ? e : null;
}, JW = (t)=>E(t && t.var) && h0(t) !== null, t3 = (t, e, n, o, r)=>{
    let s = h0(e);
    if (!s) return;
    if (E(e.var)) {
        let c = `var(${e.var})`;
        return n || o ? XL(c, n, o) : c;
    }
    if (s.length !== 2 || !s.includes("light") || !s.includes("dark")) return;
    let i = ct(t, "@light", r), a = ct(t, "@dark", r);
    if (!(!Mr(i) || !Mr(a))) return i === a ? i : `light-dark(${i}, ${a})`;
}, Bu = (t, e)=>{
    if (!t) return null;
    let n = e || L(), o = ee(t), r = o ? o.name : t, s = r && n.color && n.color[r];
    if (B(s)) return [
        "light",
        "dark"
    ];
    if (!k(s) || s.value !== void 0) return null;
    let i = Br(s);
    return i.length ? i : null;
}, Ko = (t, e, n)=>{
    let o = {}, r = gm(e);
    for (let s of t){
        let i = n(s);
        if (i !== void 0 && (o[`[data-theme="${s}"] &`] = i, s === "light" || s === "dark")) {
            let a = hm(s, e);
            a && (o[a] = {
                [r]: i
            });
        }
    }
    return o;
}, di = (t, e)=>t || (e.globalTheme === "auto" ? null : e.globalTheme), pi = (t, e, n, { commas: o, resolve: r, resolveScheme: s })=>{
    let i = Za(t, o), a = null;
    for (let f of i)for (let u of f){
        let d = Bu(u, n);
        if (d) for (let p of d)(a || (a = [])).includes(p) || a.push(p);
    }
    if (!a) return;
    let c = (f)=>Qa(i.map((u)=>u.map((d)=>{
                if (!Bu(d, n)) return d;
                let p = f(d);
                return E(p) ? p : d;
            }))), l = di(e, n);
    return l ? r(c((f)=>Wt(f, l, n)), l) : Ko(a, n, (f)=>s(f, c));
}, Wt = (t, e, n)=>{
    let o = n || L();
    if (e = di(e, o), !E(t)) {
        o.verbose;
        return;
    }
    if (Nt(t)) return `var(${t})`;
    let r, s, i;
    if (B(t)) r = t[0];
    else {
        let u = ee(t);
        if (u) {
            if (u.passthrough) return u.passthrough;
            if (u.cssVar) return `var(${u.cssVar})`;
            r = u.name, s = u.alpha, i = u.tone;
        } else r = t;
    }
    let { color: a, gradient: c } = o, l = a[r] || c[r], f = k(l);
    if (f && l.value) return ct(t, `@${e}`, n);
    if (f) {
        if (o.useVariable && l.var) return s || i ? ct(t, null, n) : `var(${l.var})`;
        if (e) {
            if (!o.useVariable && a[r] === l) {
                let u = t3(t, l, s, i, n);
                if (u !== void 0) return u;
            }
            return ct(t, `@${e}`, n);
        } else return Ko(Br(l), o, (u)=>ct(t, "@" + u, n));
    } else return p0(t, r, o);
}, Nr = (t, e, n, o)=>{
    let s = `--${o.varPrefix ? o.varPrefix + "-" : ""}${e}-${n}`, i, a = {};
    for(let c in t){
        if (c.charCodeAt(0) !== 64) continue;
        let l = c.slice(1), f = t[c], u = f && (f.value || f);
        !u || typeof u != "string" || (a[l] = u, (l === "light" || i === void 0) && (i = u));
    }
    if (i !== void 0) {
        o.cssVars[s] = i, o.cssMediaVars || (o.cssMediaVars = {});
        for(let c in a){
            let l = `[data-theme="${c}"]`;
            if (o.cssMediaVars[l] || (o.cssMediaVars[l] = {}), o.cssMediaVars[l][s] = a[c], c === "light" || c === "dark") {
                let f = `@media (prefers-color-scheme: ${c})`;
                o.cssMediaVars[f] || (o.cssMediaVars[f] = {}), o.cssMediaVars[f][s] = a[c];
            }
        }
        return t.var = s, s;
    }
}, Wo = (t, e, n)=>{
    let o = L();
    if (ZL(t)) return o.useVariable && t.var && (o.cssVars[t.var] = t.value), t;
    if (!o.useVariable && JW(t)) return t;
    if (E(t) && Nt(t)) {
        let h = t.slice(2), m = h.trim().indexOf(" ") !== -1;
        if (t = m ? h : ct(h), m || !(t.includes("rgb") || t.includes("var") || t.includes("#"))) {
            let y = h.trim().split(/\s+/), b = o.color[y[0]];
            if (b && !b.value && !b.rgb && (E(b) || B(b) || k(b)) && !pn.has(y[0])) {
                pn.add(y[0]);
                try {
                    o.color[y[0]] = Wo(b, y[0]);
                } finally{
                    pn.delete(y[0]);
                }
                b = o.color[y[0]];
            }
            if (b && b.value) {
                let T = b.rgb, v = y[1] !== void 0 ? y[1] : "1", S = y[2];
                S && (T = Fn(T, S)), t = `rgba(${T}, ${v})`;
            } else {
                let T = y[2], v = y[1] !== void 0 ? y[1] : "1";
                if (T) try {
                    let S = ln(y[0]);
                    S && S.length >= 3 ? t = `rgba(${Fn(S.slice(0, 3).join(", "), T)}, ${v})` : t = y[0];
                } catch  {
                    t = y[0];
                }
                else t = y[0];
            }
        }
    }
    if (B(t) && (t = {
        "@light": t[0],
        "@dark": t[1] !== void 0 ? t[1] : t[0]
    }), k(t)) {
        let h = {};
        for(let m in t)m !== "var" && (h[m] = Wo(t[m], e, m.slice(0, 1) === "@" ? m.slice(1) : m));
        return o.useVariable && Nr(h, "color", e, o), h;
    }
    let s = `--${o.varPrefix ? o.varPrefix + "-" : ""}color-${e}` + (n ? `-${n}` : ""), i = t.value || t;
    if (E(i) && !i.includes("(") && !i.startsWith("#")) {
        let h = ee(i);
        if (h && h.name && !h.passthrough && !h.cssVar) {
            let m = o.color[h.name];
            if (m && !m.value && !m.rgb && (E(m) || B(m) || k(m)) && !pn.has(h.name)) {
                pn.add(h.name);
                try {
                    o.color[h.name] = Wo(m, h.name);
                } finally{
                    pn.delete(h.name);
                }
            }
            let y = o.color[h.name], b = h0(y);
            if (b) {
                if (h.alpha === void 0 && h.tone === void 0) return y;
                let T = {};
                for (let v of b){
                    let S = y["@" + v], w = S.rgb;
                    h.tone && (w = Fn(w, h.tone));
                    let _ = h.alpha !== void 0 ? parseFloat(h.alpha) : S.alpha !== void 0 ? S.alpha : 1;
                    T["@" + v] = `rgba(${w}, ${_})`;
                }
                return Wo(T, e, n);
            }
            if (y && y.rgb) {
                let T = y.rgb;
                h.tone && (T = Fn(T, h.tone));
                let v = h.alpha !== void 0 ? parseFloat(h.alpha) : y.alpha !== void 0 ? y.alpha : 1;
                i = `rgba(${T}, ${v})`;
            }
        }
    }
    let a = ln(i), [c, l, f, u = 1] = a, d = parseFloat(u.toFixed(2)), p = `${c}, ${l}, ${f}`, g = `rgba(${p}, ${d})`;
    return o.useVariable && (o.cssVars[s] = g), {
        var: s,
        rgb: p,
        alpha: d,
        value: g
    };
}, e3 = new Set([
    "to",
    "top",
    "bottom",
    "left",
    "right",
    "center",
    "at",
    "circle",
    "ellipse",
    "closest-side",
    "farthest-side",
    "closest-corner",
    "farthest-corner"
]), Fr = (t, e)=>{
    let n = t.indexOf("(");
    if (n === -1) return t;
    let o = t.slice(0, n + 1), r = t.slice(n + 1, t.lastIndexOf(")")), s = ")", i = Nn(r), a = !1, c = i.map((l)=>(l = l.trim(), l.split(/\s+/).map((u)=>{
            if (!u || /^\d/.test(u) || u === "0" || e3.has(u) || u === "transparent" || Fo.test(u)) return u;
            let d = ct(u);
            return fn(d) ? (a = !0, d) : u;
        }).join(" ")));
    return a ? o + c.join(", ") + s : t;
}, sc = (t, e, n)=>{
    let o = L();
    if (k(t) && t.value !== void 0 && t.var !== void 0) return o.useVariable && (o.cssVars[t.var] = t.value), t;
    if (E(t) && Nt(t) && (t = ct(t.slice(2))), B(t) && (t = {
        "@light": t[0],
        "@dark": t[1] !== void 0 ? t[1] : t[0]
    }), k(t)) {
        let a = {};
        for(let c in t)c !== "var" && (a[c] = sc(t[c], e, c.slice(0, 1) === "@" ? c.slice(1) : c));
        return o.useVariable && Nr(a, "gradient", e, o), a;
    }
    let s = `--${o.varPrefix ? o.varPrefix + "-" : ""}gradient-${e}` + (n ? `-${n}` : ""), i = Fr(t.value || t);
    return o.useVariable && (o.cssVars[s] = i), {
        var: s,
        value: i
    };
};
var mm = (t, e, n = {}, o)=>{
    let r = o || L(), { min: s = 4.5, large: i = !1, scheme: a, meta: c = !1, maxIterations: l = 15 } = n, f = i ? 3 : s, u = a || (r.globalTheme && r.globalTheme !== "auto" ? r.globalTheme : "light"), d = E(e) ? e : String(e), p = ee(t), g = p && !p.passthrough && !p.cssVar ? p.name : null, h = (ot, dt)=>c ? {
            value: ot,
            ...dt
        } : ot;
    if (g) {
        let ot = r.color[`${g}Safe`];
        if (ot) {
            let dt = `${d}@${u}`, X = ot[dt] !== void 0 ? ot[dt] : ot[d];
            if (X !== void 0) {
                let U = X && X.rgb !== void 0 ? r.useVariable && X.var ? `var(${X.var})` : X.value : ct(X, null, r);
                return h(U, {
                    ratio: null,
                    deviation: 0,
                    derived: !1,
                    overridden: !0
                });
            }
        }
    }
    let m = ct(t, u ? `@${u}` : null, r), y = ui(t, r, u), b = ui(e, r, u);
    if (!y || !b) return r.verbose, h(m, {
        ratio: null,
        deviation: 0,
        derived: !1,
        overridden: !1,
        unresolved: !0
    });
    let T = oi(b.rgb, b.alpha), v = oi(y.rgb, y.alpha, T), S = Ja(v, T);
    if (S >= f - .02) return h(m, {
        ratio: S,
        deviation: 0,
        derived: !1,
        overridden: !1
    });
    let [w, _, x] = _u(y.rgb), [, A, O] = bu([
        w,
        _,
        x
    ]), C = ti(T) > .5, N = C ? w : 1 - w, I = (ot)=>{
        let dt = C ? w - ot : w + ot, X = Math.max(0, Math.min(1, dt));
        return {
            rgb: Su(X, A, O),
            L: X
        };
    }, M = (ot)=>{
        let { rgb: dt } = I(ot), X = oi(dt.map((U)=>Math.round(U)), y.alpha, T);
        return Ja(X, T);
    }, K = 0, V = N, J = M(V) >= f;
    if (J) for(let ot = 0; ot < l; ot++){
        let dt = (K + V) / 2;
        M(dt) >= f ? V = dt : K = dt;
    }
    else K = V;
    let { rgb: ht, L: nt } = I(V), tt = ht.map((ot)=>Math.round(ot)), Y = M(V), G = y.alpha < 1 ? `rgba(${tt.join(", ")}, ${y.alpha})` : `rgb(${tt.join(", ")})`, st = Math.abs(nt - w) * 100;
    return h(G, {
        rgb: tt,
        ratio: Y,
        startRatio: S,
        deviation: st,
        derived: !0,
        overridden: !1,
        reachable: J
    });
}, g0 = (t, e, n = {}, o)=>mm(t, e, {
        ...n,
        meta: !0
    }, o);
var QL = new Set, ym = (t, e)=>{
    let n = L().media, o = n && n[e];
    if (o) return o;
    let r = t + " @" + e;
    return QL.has(r) || QL.add(r), null;
};
var n3 = (t)=>{
    let n = L().spacing || {}, o = parseFloat(t.spacingRatio), r = {
        ...n,
        ratio: Number.isFinite(o) ? o : n.ratio,
        sequence: {},
        scales: {}
    };
    return Ee(r), r;
}, o3 = (t)=>{
    for(let e in t){
        let n = t[e];
        if (!(e.slice(0, 1) === "@") || !ym("spacing", e.slice(1))) continue;
        let { type: r, base: s, ratio: i, range: a, subSequence: c, h1Matches: l, unit: f } = t;
        Dt(n, {
            type: r,
            base: s,
            ratio: i,
            range: a,
            subSequence: c,
            h1Matches: l,
            unit: f,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), Ee(n), Pr(t, e);
    }
}, Nu = (t)=>{
    let e = t.toLowerCase(), n = e.includes("width") || e.includes("height"), o = e.includes("border") || e.includes("outline");
    return n && !o;
}, Fu = ()=>{
    let t = L(), { spacing: e } = t;
    Ee(e), zo(e), o3(e);
}, r3 = (t)=>{
    let e = L(), { spacing: n } = e;
    return !t || !t.sequence ? n : Object.keys(t.sequence).length > 0 ? t : Ee(t);
}, Ut = (t, e = "padding", n, o)=>{
    let r = r3(n);
    if (E(t)) {
        if (!o && /^(?:env|var)\(/.test(t.trim())) return {
            [e]: t
        };
        if (!o && t.includes("(")) {
            let i = Vo(t);
            o = i[0], t = i[1];
        }
    }
    let s = o ? [
        t
    ] : E(t) && t.includes("(") ? at(t) : Js(t);
    if (B(s)) {
        if (s.length > 1) {
            let i = "";
            e === "borderWidth" && (e = "border", i = "Width");
            let a = {
                2: [
                    "Block",
                    "Inline"
                ],
                3: [
                    "BlockStart",
                    "Inline",
                    "BlockEnd"
                ],
                4: [
                    "BlockStart",
                    "InlineEnd",
                    "BlockEnd",
                    "InlineStart"
                ]
            }, c = (l, f)=>lo(s[f], e + l + i, r, o);
            return a[s.length].map((l, f)=>c(l, f));
        }
        return lo(t, e, r, o);
    }
}, ze = (t, e, n, o)=>{
    let r = L(), { spacing: s } = r, i = n || t[e];
    if (!o && E(i) && /^(?:env|var)\(/.test(i.trim())) return {
        [e]: i
    };
    if (!o && E(i) && i.includes("(")) {
        let a = Vo(i);
        o = a[0], i = a[1];
    }
    if (t.spacingRatio) {
        let a = n3(t);
        return Ut(i, e, a, o);
    }
    return Ut(i, e, s, o);
}, $u = (t)=>{
    let e = (n)=>{
        let o = [
            "+",
            "-",
            "*",
            "/"
        ].includes(n), r = ga.some((i)=>t.includes(i));
        return o || r ? n : n.length < 3 && /[A-Z]/.test(n) ? n + "_default" : n;
    };
    return t.split(",").map((n)=>n.trim()).map(e).join(",").split(" ").map(e).join(" ");
};
var s3 = {
    commas: !0
}, hi = (t, e, n)=>E(t) ? $o(t, i3, s3, e, n) : t, i3 = (t, e, n)=>{
    let o = fi(()=>ct(t, e));
    return fn(o) ? o : ic(t, n);
}, ic = (t, e)=>{
    if (/^\d/.test(t) || t.includes("px") || t.slice(-2) === "em" || t === "inset" || t === "none" || li(t) || ei.has(t.toLowerCase())) return t;
    e && e(t);
    let n = Ho(()=>Ut(t, "shadow"));
    return n && n.shadow ? n.shadow : t;
}, $r = (t, e, n, o)=>{
    let r = L();
    if (k(t) && t.value !== void 0 && t.var !== void 0) return r.useVariable && (r.cssVars[t.var] = t.value), t;
    if (B(t)) {
        let a = {
            "@light": $r(t[0], e, "light"),
            "@dark": $r(t[1], e, "dark")
        };
        return r.useVariable && Nr(a, "shadow", e, r), a;
    }
    if (k(t)) {
        let a = {};
        for(let c in t)a[c] = $r(t[c], e, c.startsWith("@") ? c.slice(1) : c);
        return r.useVariable && Nr(a, "shadow", e, r), a;
    }
    E(t) && (t = hi(t));
    let i = `--${r.varPrefix ? r.varPrefix + "-" : ""}shadow-${e}` + (n ? `-${n}` : "");
    return r.useVariable && (r.cssVars[i] = t), {
        var: i,
        value: t
    };
}, ju = (t, e)=>{
    let n = L();
    if (e = di(e, n), !E(t)) {
        n.verbose;
        return;
    }
    if (Nt(t)) return `var(${t})`;
    let [o] = B(t) ? t : t.split(" "), s = n.shadow[o], i = k(s);
    if (!s) return n.verbose, t;
    if (i && !s.value && n.useVariable && s.var) return `var(${s.var})`;
    if (e) {
        let a = s["@" + e] || s[e];
        if (a) return a.value !== void 0 ? a.value : a;
        n.verbose;
    }
    return i && s.value ? s.value : i ? Ko(Br(s), n, (a)=>{
        let c = s["@" + a];
        return c && (c.value !== void 0 ? c.value : c);
    }) : (n.verbose, t);
};
var a3 = new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
    "initial"
]), c3 = {
    commas: !1,
    keywords: a3
}, de = (t, e, n)=>{
    if (t == null) return;
    let o = t + "", r = o.trim();
    return r === "none" || r === "0" || r === "initial" || r === "inherit" || r === "unset" ? o : $o(o, l3, c3, e, n);
}, l3 = (t, e, n)=>{
    if (/^\d/.test(t)) return t;
    let o = fi(()=>ct(t, e));
    if (fn(o)) return o;
    if (li(t) || ei.has(t.toLowerCase())) return t;
    n && n(t);
    let r = Ho(()=>Ut(t, "border"));
    return r && r.border ? r.border : t;
}, Uu = (t, e, n)=>{
    let o = n || L();
    if (o.useVariable || !E(t)) return de(t);
    let r = pi(t, e, o, {
        commas: !1,
        resolve: (s)=>de(s),
        resolveScheme: (s)=>de(t, "@" + s)
    });
    return r !== void 0 ? r : de(t);
};
var f3 = new Set([
    "fallback"
]), m0 = new Set, y0 = (t, e)=>{
    m0.has(t) || m0.add(t);
}, _0 = ()=>{
    m0.clear();
}, JL = (t)=>{
    for(let e in t)delete t[e];
    return t;
}, e1 = (t, e)=>{
    let n = e.color || {};
    return !E(t) || !Object.prototype.hasOwnProperty.call(n, t) ? t : `var(--${e.varPrefix ? e.varPrefix + "-" : ""}color-${t})`;
}, Hu = ()=>{
    let t = L(), e = k(t.cssSkinVars) ? JL(t.cssSkinVars) : t.cssSkinVars = {}, n = k(t.cssSkinFallback) ? JL(t.cssSkinFallback) : t.cssSkinFallback = {}, o = t.skins;
    if (!k(o)) return e;
    let r = t.varPrefix ? t.varPrefix + "-" : "", s = t.cssVars || {};
    for(let i in o){
        let a = o[i];
        if (!k(a)) continue;
        let c = {};
        for(let l in a){
            if (f3.has(l)) continue;
            let f = a[l];
            if (k(f)) for(let u in f){
                let d = `--${r}theme-${l}-${u}`;
                t.useVariable !== !1 && !(d in s) && y0(`${i}/${l}/${u}`, `[scratch] skin "${i}" rewrites theme "${l}" param "${u}", which the theme does not declare \u2014 no element reads ${d}, so the skin changes nothing there. Declare "${u}" on the "${l}" theme (its no-skin value).`), c[d] = e1(f[u], t);
            }
        }
        e[i] = c, E(a.fallback) && (n[i] = a.fallback);
    }
    for(let i in n){
        let a = n[i];
        e[a] || (y0(`${i}/fallback/${a}`, `[scratch] skin "${i}" falls back to "${a}", which is not a declared skin \u2014 the reduced-transparency fallback is skipped.`), delete n[i]);
    }
    return e;
}, Vu = (t, e, n, o)=>{
    let r = n.skins;
    if (!k(r)) return;
    let s = (g)=>{
        let h = r[g][t], m = k(h) ? h[e] : void 0;
        return E(m) || typeof m == "number" ? e1(m, n) : void 0;
    }, i = {}, a = {};
    for(let g in r){
        if (!k(r[g])) continue;
        let h = s(g);
        h !== void 0 && (i[g] = h);
    }
    let c = Object.keys(i);
    if (!c.length) return;
    for(let g in r){
        if (!k(r[g])) continue;
        let h = r[g].fallback, m = E(h) && k(r[h]) && i[h] !== void 0 ? i[h] : i[g];
        m !== void 0 && (a[g] = m);
    }
    o && y0(`${t}/${e}/scheme`, `[scratch] theme "${t}" gives "${e}" a value per scheme and a skin sets it too. "${e}" reaches the element as a literal, so the scheme's rule can tie with the skin's or win over it. Write "${e}" once on the "${t}" theme (outside the schemes).`);
    let l = (g)=>`[data-skin="${g}"]`, f = (g, h)=>g in i && h in i && i[g] !== i[h] ? i[h] : void 0, u = {};
    for (let g of c)u[`${l(g)} &`] = {
        [e]: i[g]
    };
    for (let g of c)for (let h of c){
        let m = g === h ? void 0 : f(g, h);
        m !== void 0 && (u[`${l(g)} ${l(h)} &`] = {
            [e]: m
        });
    }
    let d = {}, p = Object.keys(a);
    for (let g of p)a[g] !== i[g] && (d[`${l(g)} &`] = {
        [e]: a[g]
    });
    for (let g of p)for (let h of p){
        if (g === h) continue;
        let m = f(g, h);
        (a[g] !== a[h] || m !== void 0) && m !== a[h] && (d[`${l(g)} ${l(h)} &`] = {
            [e]: a[h]
        });
    }
    return Object.keys(d).length && (u["@media (prefers-reduced-transparency: reduce)"] = d), u;
}, t1 = (t, e)=>{
    let n = `[data-skin="${t}"]`;
    return !e || e === ":root" ? `:root${n}, ${n}` : `${e}${n}, ${n} ${e}, ${e} ${n}`;
}, gi = (t, e, n)=>{
    let o = {};
    if (!k(t)) return o;
    for(let s in t)o[t1(s, n)] = t[s];
    let r = {};
    for(let s in e || {}){
        let i = t[e[s]];
        i && (r[t1(s, n)] = i);
    }
    return Object.keys(r).length && (o["@media (prefers-reduced-transparency: reduce)"] = r), o;
};
var u3 = new Set([
    "black",
    "white",
    "red",
    "green",
    "blue",
    "yellow",
    "orange",
    "purple",
    "pink",
    "brown",
    "gray",
    "grey",
    "cyan",
    "magenta",
    "lime",
    "olive",
    "navy",
    "teal",
    "aqua",
    "maroon",
    "silver",
    "fuchsia",
    "transparent",
    "currentColor",
    "currentcolor",
    "inherit",
    "initial",
    "unset",
    "none",
    "aliceblue",
    "antiquewhite",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "blanchedalmond",
    "blueviolet",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkgrey",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkslategrey",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dimgrey",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightslategrey",
    "lightsteelblue",
    "lightyellow",
    "limegreen",
    "linen",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "oldlace",
    "olivedrab",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "plum",
    "powderblue",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "skyblue",
    "slateblue",
    "slategray",
    "slategrey",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "whitesmoke",
    "yellowgreen",
    "rebeccapurple"
]), n1 = [
    "color",
    "Color",
    "background",
    "Background",
    "fill",
    "Fill",
    "stroke",
    "Stroke"
], i1 = (t)=>{
    for(let e = 0; e < n1.length; e++)if (t.includes(n1[e])) return !0;
    return !1;
}, d3 = {
    boxShadow: hi,
    textShadow: hi,
    border: de,
    borderTop: de,
    borderRight: de,
    borderBottom: de,
    borderLeft: de,
    outline: de,
    columnRule: de
}, p3 = (t)=>{
    if (!t) return !1;
    let e = ee(t);
    return !e || !e.name || e.passthrough || e.cssVar ? !1 : e.alpha !== void 0 || e.tone !== void 0;
}, o1 = new Set, h3 = (t, e, n, o, r, s)=>{
    return;
}, w0 = (t, e, n, o)=>{
    let r = d3[e];
    if (!r) return ct(n, o);
    let s = null, i = r(n, o, (a)=>{
        !s && p3(a) && (s = a);
    });
    return s && h3(t, e, o, n, i, s), i;
}, x0 = (t, e)=>hn(t, e), g3 = (t)=>k(t) && z(t.value), m3 = (t)=>{
    for(let e in t){
        let n = t[e];
        if (E(n) && n.startsWith("var(--")) return !0;
    }
    return !1;
}, zu = (t, e)=>{
    let n = L();
    return g3(t) ? !n.useVariable && m3(t) ? t : cc(t.value, e) : cc(t, e);
}, a1 = (t, e)=>{
    let n = new Set;
    for (let o of e){
        let r = o.slice(0, 1);
        if (!(r === "@" || r === "." || r === ":") && i1(o)) for(let s in t){
            if (n.has(s)) continue;
            let i = t[s]?.[o];
            if (i === void 0) continue;
            let a = ct(i, `@${s}`);
            a !== void 0 && E(a) && /^[a-z][a-zA-Z]+$/.test(a) && !u3.has(a) && n.add(s);
        }
    }
    return n;
}, c1 = (t)=>t.startsWith("[data-theme=") || t.startsWith("[data-skin=") || t.startsWith("@media"), ac = (t, e)=>{
    for(let n in e){
        let o = e[n];
        k(o) ? ac(t[n] || (t[n] = {}), o) : t[n] = o;
    }
    return t;
}, r1 = (t, e, n, o, r)=>ac(t, Ko(o, r, (s)=>({
            [e]: n[s]
        }))), l1 = (t, e, n, o)=>{
    let r = {}, s = Object.keys(e).filter((c)=>e[c] !== n);
    if (!s.length) return n === void 0 ? void 0 : (r[t] = n, r);
    let i = e.light !== void 0 ? e.light : n, a = e.dark !== void 0 ? e.dark : n;
    if (i1(t) && Mr(i) && Mr(a)) {
        r[t] = i === a ? i : `light-dark(${i}, ${a})`;
        let c = Object.keys(e).filter((l)=>l !== "light" && l !== "dark");
        r1(r, t, e, c, o);
    } else n !== void 0 && (r[t] = n), r1(r, t, e, s, o);
    return r;
}, y3 = new Set([
    "backdropFilter",
    "WebkitBackdropFilter"
]), f1 = new WeakSet, u1 = (t, e, n, o)=>{
    let r = n.globalTheme !== void 0 ? n.globalTheme : "auto", s = r && r !== "auto" ? String(r).replace(/^'|'$/g, "") : null, i = new Set(o ? Object.keys(o) : []);
    for(let l in t)if (t[l]) for (let f of Object.keys(t[l]))i.add(f);
    let a = a1(t, i), c = {};
    for (let l of i){
        let f = l.slice(0, 1);
        if (f === "@") continue;
        if (f === "." || f === ":") {
            let m = {};
            for(let T in t)z(t[T]?.[l]) && (m[T] = t[T][l]);
            let y = o && z(o[l]) ? o[l] : void 0;
            if (!Object.keys(m).length && !y) continue;
            let b = f === "." ? l.slice(1) : l.replace(/^:+/, "");
            c[l] = u1(m, `${e}-${b}`, n, y);
            continue;
        }
        let u = o && !z(o[l]) ? o[l] : void 0, d = new Set(Object.keys(t));
        u !== void 0 && (d.add("light"), d.add("dark"), s && d.add(s));
        let p = {}, g;
        for (let m of d){
            if (a.has(m)) continue;
            let y = t[m]?.[l];
            if ((y === void 0 || z(y)) && (y = u), y === void 0) continue;
            let b = w0(e, l, y, `@${m}`);
            b !== void 0 && (p[m] = b, (s && m === s || !s && (m === "light" || g === void 0)) && (g = b));
        }
        let h = l1(l, p, g, n);
        h && (ac(c, h), c[`.${l}`] = h);
    }
    return (c.background || c.color || c.backgroundColor) && (c[".inversed"] = {
        color: c.background || c.backgroundColor,
        background: c.color
    }), c;
}, b0 = (t, e, n, o)=>{
    let { cssVars: r } = n;
    n.cssMediaVars || (n.cssMediaVars = {});
    let s = n.cssMediaVars, i = n.globalTheme !== void 0 ? n.globalTheme : "auto", a = i && i !== "auto" ? String(i).replace(/^'|'$/g, "") : null, c = {}, l = new Set(o ? Object.keys(o) : []);
    for(let u in t)if (t[u]) for (let d of Object.keys(t[u]))l.add(d);
    let f = a1(t, l);
    for (let u of l){
        let d = u.slice(0, 1), p = z(o?.[u]) || Object.values(t).some((g)=>z(g?.[u]));
        if (d === "." && p) {
            let g = u.slice(1), h = {};
            for(let y in t)z(t[y]?.[u]) && (h[y] = t[y][u]);
            let m = z(o?.[u]) ? o[u] : void 0;
            c[u] = b0(h, `${e}-${g}`, n, m);
        } else if (d === ":" && p) {
            let g = u.replace(/^:+/, ""), h = {};
            for(let y in t)z(t[y]?.[u]) && (h[y] = t[y][u]);
            let m = z(o?.[u]) ? o[u] : void 0;
            c[u] = b0(h, `${e}-${g}`, n, m);
        } else if (d !== "@" && d !== "." && d !== ":") {
            let h = `--${n.varPrefix ? n.varPrefix + "-" : ""}theme-${e}-${u}`, m = o && !z(o[u]) ? o[u] : void 0, y = new Set(Object.keys(t));
            m !== void 0 && (y.add("light"), y.add("dark"), a && y.add(a));
            let b, T = !1, v = {};
            for (let S of y){
                if (f.has(S)) continue;
                let w = t[S]?.[u];
                if ((w === void 0 || z(w)) && (w = m), w === void 0) continue;
                let _ = w0(e, u, w, `@${S}`);
                if (_ === void 0) continue;
                T = !0, v[S] = _, (a && S === a || !a && (S === "light" || b === void 0)) && (b = _);
                let x = `[data-theme="${S}"]`;
                if (s[x] || (s[x] = {}), s[x][h] = _, S === "dark" || S === "light") {
                    let A = `@media (prefers-color-scheme: ${S})`;
                    s[A] || (s[A] = {}), s[A][h] = _;
                }
            }
            if (b !== void 0 && (r[h] = b), !T) continue;
            if (y3.has(u)) {
                let S = l1(u, v, b, n);
                if (S) {
                    let w = Vu(e, u, n, Object.keys(v).some((_)=>v[_] !== b));
                    w && ac(S, w), ac(c, S), c[`.${u}`] = S;
                }
                continue;
            }
            c[u] = `var(${h})`, c[`.${u}`] = {
                [u]: c[u]
            };
        }
    }
    (c.background || c.color || c.backgroundColor) && (c[".inversed"] = {
        color: c.background || c.backgroundColor,
        background: c.color
    });
    for(let u in c)c1(u) && z(c[u]) && f1.add(c[u]);
    return c;
}, cc = (t, e, n, o)=>{
    let r = L(), { cssVars: s } = r, i = {
        value: t
    }, a = !n && !o, c, l;
    if (z(t)) {
        if (a && r.useVariable) {
            let f = {}, u = {};
            for(let d in t)d.startsWith("@") ? z(t[d]) && (f[d.slice(1)] = t[d]) : u[d] = t[d];
            (Object.keys(f).length || Object.keys(u).length) && (l = b0(f, e, r, u), Object.assign(i, l));
        } else if (a) {
            let f = {}, u = {};
            for(let d in t)d.startsWith("@") ? z(t[d]) && (f[d.slice(1)] = t[d]) : u[d] = t[d];
            c = u1(f, e, r, u), Object.assign(i, c);
        }
        for(let f in t){
            let u = f.slice(0, 1), d = t[f];
            if (u === "@" || u === ":" || u === ".") {
                let p = u === "@" && f;
                i[f] = cc(d, e, f, o || p);
            } else if (!a) {
                let p = w0(e, f, d, o), g = [
                    ...new Set([
                        o,
                        n
                    ].filter((b)=>b).map((b)=>b.slice(1)))
                ], h = g.length ? "-" + g.join("-") : "", y = `--${r.varPrefix ? r.varPrefix + "-" : ""}theme-${e}${h}-${f}`;
                r.useVariable ? (r.useThemeSuffixedVars && (s[y] = p), i[f] = `var(${y})`) : i[f] = p, i[`.${f}`] = {
                    [f]: i[f]
                };
            }
        }
        if (c) for(let f in c){
            let u = f.slice(0, 1);
            (u === "." || u === ":") && z(t[f]) && (i[f] = c[f]);
        }
        if (l) for(let f in l){
            let u = f.slice(0, 1);
            (u === "." || u === ":") && z(t[f]) && (i[f] = l[f]);
        }
        !i[".inversed"] && (i.background || i.color || i.backgroundColor) && (i[".inversed"] = {
            color: i.background || i.backgroundColor,
            background: i.color
        });
    }
    if (E(t) && Nt(t)) {
        let u = r.theme[t.slice(2)];
        return hn(u, o);
    }
    return i;
}, _3 = /(::[a-z-]+(?:\([^()]*\))?|:(?:before|after|first-line|first-letter))(?::[a-z-]+(?:\([^()]*\))?)*$/i, b3 = /^::(?:-webkit-scrollbar|part\()/i, S0 = (t, e, n)=>{
    let o = {};
    for(let r in t){
        let s = r.slice(0, 1);
        if (z(t[r])) {
            if (c1(r) && (e || f1.has(t[r]))) o[r] = ac({}, t[r]);
            else {
                if (s === "@") continue;
                if (s === ":") {
                    let i = r.match(_3);
                    if (n && (i || !b3.test(n))) continue;
                    o[`&${r}`] = S0(t[r], e, n || (i ? i[1] : null));
                } else if (s === ".") {
                    if (n) continue;
                    o[`&${r}`] = S0(t[r], e);
                }
            }
        } else o[r] = t[r];
    }
    return o;
}, d1 = (t, e)=>{
    let n = e.shift();
    return t[n] ? d1(t[n], e) : t;
}, s1 = (t, e)=>B(e) ? d1(t, e) : E(e) && t[e] ? t[e] : t;
var hn = (t, e)=>{
    let n = L();
    if (E(t) && Nt(t) && (t = hn(t.slice(2))), !t || !E(t)) {
        n.verbose;
        return;
    }
    let [o, ...r] = B(t) ? t : t.split(" "), s = n.theme[o];
    return s && r.length ? s = s1(s, r) : s && e && (s = s1(s, e)), S0(s, !n.useVariable);
};
var Wu = (t, e)=>{
    let n = L(), o = `--font-${e}`;
    if (!t || B(t) && !t[0]) return;
    let r;
    if (t.isVariable) {
        let s = un(t.url, n.files) || t.url;
        tc(s) ? r = ec(s) : r = Rr(e, s, t.fontWeight, {
            fontStretch: t.fontStretch,
            fontDisplay: t.fontDisplay || "swap",
            unicodeRange: t.unicodeRange
        });
    } else if (t[0]) r = ri(e, t, n.files);
    else {
        let s = Array.isArray(t.url) ? t.url.map((i)=>un(i, n.files) || i) : un(t.url, n.files) || t.url;
        r = Rr(e, s, t.fontWeight, {
            fontStyle: t.fontStyle,
            fontDisplay: t.fontDisplay,
            fontStretch: t.fontStretch,
            unicodeRange: t.unicodeRange
        });
    }
    return {
        var: o,
        value: t,
        fontFace: r
    };
}, g1 = new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "emoji",
    "math",
    "fangsong",
    "inherit",
    "initial",
    "unset",
    "revert",
    "revert-layer"
]), S3 = (t)=>g1.has(t.toLowerCase()) || /[\s,'"(]/.test(t.trim()), p1 = new Set, Ku = (t, e)=>{
    let n = L(), { fontFamily: o } = n, r = e || o, s = jo(r, t);
    if (s !== void 0 || t == null || t === "" || t === "default") return s;
    if (!E(t)) return jo(r);
    if (!S3(t)) return Do() && !p1.has(t) && p1.add(t), jo(r);
}, h1 = (t)=>{
    let e = t.trim(), n = e.replace(/^(['"])(.*)\1$/, "$2").trim(), o = n.replace(/\s+/g, " ").toLowerCase();
    return n !== e && g1.has(o) ? '"' + o + '"' : o;
}, lc = (t, e)=>{
    let n = L(), { fontFamily: o, fontFamilyTypes: r } = n;
    if (k(t) && E(t.value) && E(t.var)) return n.useVariable && (n.cssVars[t.var] = t.value), t;
    let { value: s, type: i } = t;
    t.isDefault && (!t.isSystemFallback || !o.__defaultKey) && (o.__defaultKey = e), k(s) && (s = Js(s));
    let c = `--${n.varPrefix ? n.varPrefix + "-" : ""}font-family-${e}`, l = (p)=>p && !p.startsWith("--"), f = [
        ...s
    ].map((p)=>String(p).trim()).filter(l), u = new Set;
    for (let p of f)for (let g of p.split(","))u.add(h1(g));
    for (let p of String(r[i] ?? "").split(",")){
        let g = p.trim();
        if (!l(g)) continue;
        let h = h1(g);
        u.has(h) || (u.add(h), f.push(g));
    }
    let d = f.join(", ");
    return n.useVariable && (n.cssVars[c] = d), {
        var: c,
        value: d,
        arr: s,
        type: i,
        isSystemFallback: !!t.isSystemFallback,
        isSharedLibrary: !!t.isSharedLibrary
    };
};
var _m = (t)=>{
    let e = L(), { typography: n } = e;
    for(let o in t){
        let r = o.slice(0, 1) === "@", s = t[o];
        if (!r) continue;
        let { mediaRegenerate: i } = t, a = o.slice(1), c = ym("typography", a);
        if (!c) continue;
        let { type: l, base: f, ratio: u, range: d, subSequence: p, h1Matches: g, unit: h } = t;
        Dt(s, {
            type: l,
            base: f,
            ratio: u,
            range: d,
            subSequence: p,
            h1Matches: g,
            unit: h
        });
        let m = new Set([
            "vw",
            "vh",
            "vmin",
            "vmax",
            "svw",
            "svh",
            "lvw",
            "lvh",
            "dvw",
            "dvh"
        ]), y = s.unit || h, b = !s.unit && m.has(h) ? "rem" : y, T = "@media " + (c === "print" ? `${c}` : `screen and ${c}`);
        if (n.templates[T] = {
            fontSize: s.base / n.browserDefault + b
        }, !i) {
            Dt(s, {
                sequence: {},
                scales: {},
                vars: {}
            }), Ee(s), Pr(t, o);
            continue;
        }
        Dt(s, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), Ee(s), Pr(t, o);
    }
}, bm = (t)=>{
    let e = L();
    if (t.h1Matches) {
        let n = t.unit, o = Lu(t), { templates: r } = t;
        for(let s in o){
            let i = `h${parseInt(s) + 1}`, a = r[i];
            r[i] = {
                fontSize: e.useVariable ? `var(${o[s]?.variable})` : `${o[s]?.scaling}${n}`,
                margin: a ? a.margin : 0,
                lineHeight: a ? a.lineHeight : t.lineHeight,
                letterSpacing: a ? a.letterSpacing : t.letterSpacing,
                fontWeight: a ? a.fontWeight : 900 - s * 100
            };
        }
    }
}, Gu = ()=>{
    let t = L(), { typography: e } = t;
    Ee(e), bm(e), zo(e), _m(e);
}, qu = (t)=>{
    let e = L(), { typography: n } = e;
    return lo(t, "fontSize", n);
};
var Yu = (t)=>{
    if (!E(t)) return;
    let n = L().shape;
    if (n) return n[t] !== void 0 ? n[t] : n[t.toLowerCase()];
};
var Xu = ()=>{
    let t = L(), { timing: e } = t;
    Ee(e), zo(e);
}, We = (t)=>{
    let e = L(), { timing: n } = e;
    return n[t] || n[Bo(t)] || t;
}, Ae = (t, e = "timing")=>{
    let n = L(), { timing: o } = n;
    return lo(t, e, o);
};
var Zu = ()=>{
    let t = L(), { fontFamily: e, theme: n, typography: o } = t, r = t.document;
    return Co(r) ? (fr(t, "document", r), r = t.document = {}) : r || (r = t.document = {}), Dt(r, {
        theme: n.document,
        fontFamily: jo(e),
        fontSize: o.base,
        lineHeight: o.lineHeight
    });
};
var E0 = {
    document: wt
}, m1 = new WeakMap, y1 = new WeakMap, w3 = 128, _1 = 1048576, k0 = 8192, A0 = (t)=>t.nodeType === 1 && t.localName === "symbol" && t.getAttribute("id"), w1 = (t)=>t.nodeType === 8 || t.nodeType === 3 && !t.textContent.trim(), x3 = (t, e)=>{
    let n = 1, o = t.ownerDocument;
    if (o && typeof o.createTreeWalker == "function") {
        let s = o.createTreeWalker(t, 4294967295);
        for(; s.nextNode();)if (++n > e) return n;
        return n;
    }
    let r = [
        t
    ];
    for(; r.length;){
        let s = r.pop().childNodes || [];
        for(let i = 0; i < s.length; i++){
            if (++n > e) return n;
            r.push(s[i]);
        }
    }
    return n;
}, T0 = (t, e)=>{
    if (typeof t.importNode == "function") return t.importNode(e, !0);
    let n = e.cloneNode(!0);
    return typeof t.adoptNode == "function" ? t.adoptNode(n) : n;
}, k3 = (t, e)=>{
    if (typeof t.prepend == "function") return t.prepend(e);
    let n = t.firstChild !== void 0 ? t.firstChild : t.childNodes && t.childNodes[0];
    return typeof t.insertBefore == "function" ? t.insertBefore(e, n || null) : t.appendChild(e);
}, fc = (t, e)=>{
    let n = L();
    if (!t) {
        n.verbose;
        return;
    }
    return n.useSvgSprite ? Mu(e, t) : t;
}, Qu = (t, e = E0)=>{
    let n = L(), o = Object.keys(t).length ? {} : n.svg;
    for(let r in t)o[r] = t[r];
    k1(o, e);
}, mi = (t, e)=>{
    let n = L();
    return n.useIconSprite && !n.semanticIcons?.[e] ? fc(t, e) : t;
}, yi = (t, e = E0)=>{
    let n = L(), o = Object.keys(t).length ? {} : n.icons;
    for(let r in t)o[r] = t[r];
    k1(o, e);
}, x1 = (t, e = {
    isRoot: !0
})=>{
    if (!t || !t.createElementNS) return;
    let n = t.createElementNS("http://www.w3.org/2000/svg", "svg");
    return e.isRoot && (n.setAttribute("aria-hidden", "true"), n.setAttribute("width", "0"), n.setAttribute("height", "0"), n.setAttribute("style", "position:absolute"), n.setAttribute("id", "svgSprite")), n;
}, T3 = (t)=>{
    let e = t && t.defaultView;
    return e && typeof e.DOMParser == "function" ? e.DOMParser : typeof DOMParser < "u" ? DOMParser : null;
}, E3 = (t, e)=>{
    let n = T3(t);
    if (n) {
        let o = `<svg xmlns="http://www.w3.org/2000/svg">${e}</svg>`, s = new n().parseFromString(o, "image/svg+xml");
        return s.querySelector("parsererror") ? null : s.documentElement;
    }
    return null;
}, A3 = (t, e, n)=>{
    let o = String(n), r = y1.get(e), s = r?.entries.get(o);
    if (s) return r.entries.delete(o), r.entries.set(o, s), s.root;
    let i = E3(t, o);
    if (i || (i = x1(t, {
        isRoot: !1
    }), i.innerHTML = o), o.length > _1) return i;
    let a = x3(i, k0);
    if (a > k0) return i;
    for(r || (r = {
        entries: new Map,
        units: 0,
        nodes: 0
    }, y1.set(e, r)); r.entries.size >= w3 || r.units + o.length > _1 || r.nodes + a > k0;){
        let c = r.entries.keys().next().value, l = r.entries.get(c);
        r.units -= c.length, r.nodes -= l.nodes, r.entries.delete(c);
    }
    return r.entries.set(o, {
        root: i,
        nodes: a
    }), r.units += o.length, r.nodes += a, i;
}, b1 = (t)=>{
    let e = new Map;
    for (let n of t.children){
        let o = A0(n);
        if (!o) continue;
        let r = e.get(o) || [];
        r.push(n), e.set(o, r);
    }
    return e;
}, v3 = (t)=>t.replace(/["\\\u0000-\u001f\u007f]/g, (e)=>`\\${e.charCodeAt(0).toString(16)} `), S1 = (t, e, n, o)=>{
    let r = 0, s = e.childElementCount > 8 ? b1(n) : null, i = (a)=>{
        if (!s) try {
            return [
                ...n.querySelectorAll(`symbol[id="${v3(a)}"]`)
            ].filter((c)=>c.parentNode === n);
        } catch  {
            s = b1(n);
        }
        return s.get(a);
    };
    for (let a of e.childNodes){
        if (w1(a)) continue;
        let c = A0(a);
        if (!c && o) {
            let u = r++, d = o.nodes[u];
            if (!d && o.complete || d?.parentNode === n) continue;
            let p = T0(t, d || a);
            n.appendChild(p), o.nodes[u] = p;
            continue;
        }
        let l = c && i(c), f = l && l[0];
        if (!f) f = T0(t, a), n.appendChild(f);
        else if (!f.isEqualNode(a)) {
            let u = T0(t, a);
            n.replaceChild(u, f), f = u;
        }
        if (l) for(let u = 1; u < l.length; u++)l[u].remove();
        c && s && s.set(c, [
            f
        ]);
    }
}, k1 = (t, e = E0)=>{
    let n = L(), o = e.document || wt;
    if (!o || !o.documentElement) return n.verbose, Iu(t);
    let r = o.querySelector("#svgSprite"), s = "";
    for(let d in t)s += t[d];
    let i = r || x1(o);
    if (!i || !i.nodeType) return;
    let a = (d)=>A3(o, i, d), c = a(s), l = m1.get(i);
    l || m1.set(i, l = new WeakMap);
    let f = l.get(n);
    if (f || l.set(n, f = new Map), [
        ...c.childNodes
    ].some((d)=>!w1(d) && !A0(d))) {
        let d = [];
        for(let p in t)d.push(p);
        for (let p of d){
            let g = f.get(p);
            g || f.set(p, g = {
                nodes: [],
                complete: !1
            }), S1(o, d.length === 1 ? c : a(t[p]), i, g), g.complete = !0;
        }
    } else {
        S1(o, c, i);
        for(let d in t)f.has(d) || f.set(d, {
            nodes: [],
            complete: !0
        });
    }
    r || k3(o.body, i);
    for(let d in t)n.__svgCache[d] = !0;
};
var Ju = (t = {})=>{
    let e = L(), n = e.typography || {}, o = e.document || {}, r = k(e.reset) ? e.reset : e.reset = {};
    if (r[":root"]) {
        let c = r, l = n.templates || {};
        c.body = {
            ...e.useDocumentTheme ? hn("document") : {},
            ...l.body
        }, c.h1 = l.h1, c.h2 = l.h2, c.h3 = l.h3, c.h4 = l.h4, c.h5 = l.h5, c.h6 = l.h6;
    }
    let { body: s, ...i } = n.templates || {}, a = e.useDocumentTheme ? hn("document") : {};
    if (r.html && le(r.html, a), n.unit) for(let c in i){
        if (c.slice(0, 6) !== "@media") continue;
        let l = i[c];
        delete i[c], !(!l || !l.fontSize) && (r[c] || (r[c] = {}), r[c].html || (r[c].html = {}), r[c].html.fontSize === void 0 && (r[c].html.fontSize = l.fontSize));
    }
    if (n.unit) {
        let c = e.media || {};
        for(let l in n){
            if (l.charAt(0) !== "@") continue;
            let f = n[l];
            if (!f || f.unit === n.unit || !f.unit) continue;
            let u = f.unit, d = f.base || n.base, p = f.browserDefault || n.browserDefault, g = l.slice(1), h = c[g];
            if (!h) continue;
            let m = "@media " + (h === "print" ? h : "screen and " + h);
            r[m] || (r[m] = {}), r[m].html || (r[m].html = {}), r[m].html.fontSize = d / p + u;
        }
    }
    return mt(Dt(r, t), {
        html: {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0",
            left: "0",
            margin: "0",
            WebkitFontSmoothing: "subpixel-antialiased",
            textSizeAdjust: "100%",
            WebkitTextSizeAdjust: "100%",
            ...a,
            fontSize: n.unit ? n.base / n.browserDefault + n.unit : n.browserDefault + "px",
            fontFamily: o.fontFamily,
            lineHeight: o.lineHeight
        },
        body: {
            boxSizing: "border-box",
            height: "100%",
            margin: 0,
            fontFamily: o.fontFamily,
            fontSize: n.unit ? "1" + e.unit.default : n.base / n.browserDefault + e.unit.default,
            ...i,
            ...s
        },
        a: {
            color: "currentColor"
        },
        button: {
            color: "inherit",
            font: "inherit",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            appearance: "none",
            WebkitAppearance: "none"
        },
        "input, select, textarea": {
            color: "inherit",
            font: "inherit"
        },
        fieldset: {
            border: 0,
            padding: 0,
            margin: 0
        }
    }, ue);
};
var Sm = (t, e)=>Uu(t, e), wm = (t)=>{
    if (E(t)) return Fo.test(t) ? t : t.split(/\s+/).map((e)=>{
        if (e = e.trim(), !e) return "";
        if (Nt(e)) return `var(${e})`;
        if (/^\d/.test(e) || e.includes("px") || e === "0") return e;
        let n = ct(e);
        return fn(n) ? n : e;
    }).join(" ");
}, xm = (t, e)=>ju(t, e), td = (t, e)=>{
    if (!E(t)) return;
    let n = L();
    if (!n.useVariable) {
        let o = O3(t, e, n);
        if (o !== void 0) return o;
    }
    return v0(t, e);
}, O3 = (t, e, n)=>pi(t, e === "auto" ? null : e, n, {
        commas: !0,
        resolve: v0,
        resolveScheme: (o, r)=>v0(r((s)=>ct(s, "@" + o, n)), null)
    }), v0 = (t, e)=>$o(t, R3, C3, e), C3 = {
    commas: !0,
    keywords: new Set([
        "inset",
        "none"
    ])
}, R3 = (t, e)=>{
    if (!fn(ct(t))) return ic(t);
    let n = Wt(t, e);
    return k(n) ? Object.values(n).filter((o)=>o.includes(": " + e))[0] : n;
}, km = (t, e)=>{
    if (!E(t)) return;
    let n = L();
    return Nn(t).map((o)=>{
        let r = o.trim();
        if (Nt(r)) return `var(${r})`;
        if (/^var\(/.test(r) || r.includes("url")) return r;
        if (n.gradient?.[r]) {
            let s = Wt(r, e);
            if (E(s)) return s;
            if (k(s)) {
                for(let i in s)if (E(s[i])) return s[i];
            }
            return r;
        }
        return r.includes("gradient") ? Fr(r, e) : r.includes("/") || r.startsWith("http") || r.includes(".") && !ee(r) ? `url(${r})` : r;
    }).join(", ");
}, ed = new Set([
    "auto",
    "cover",
    "contain"
]), nd = new Set([
    "center",
    "top",
    "bottom",
    "left",
    "right"
]), D3 = (t, e, n, o)=>{
    if (n.has(t)) return t;
    let r = Ho(()=>ze(o, e, t));
    return r && r[e] !== void 0 ? r[e] : t;
}, _i = (t, e, n, o)=>E(t) ? Nn(t).map((r)=>at(r.trim()).map((s)=>D3(s, e, n, o)).join(" ")).join(", ") : t, Tm = (t)=>E(t) && at(t).map((e)=>Ut(e, "gap").gap).join(" "), Em = (t)=>{
    if (!E(t)) return t;
    let e = L();
    return at(t).map((n)=>$n.test(n) ? ii(n, e.spacing) : n).join(" ");
}, O0 = (t)=>{
    if (!E(t)) return;
    let e = t.split(" ");
    return e.length ? e.map((n)=>Nt(n) ? `var(${n})` : n.length < 3 || n.includes("ms") ? Ae(n).timing || n : We(n) ? We(n) : n).join(" ") : t;
}, od = (t, e, n)=>{
    if (E(t)) return t.split(",").map((o)=>Ae(o).timing || o).join(",");
}, Am = (t)=>{
    if (!E(t)) return;
    let e = t.split(",");
    if (e.length) return e.map(O0).join(",");
};
function It(t, e, n = {}, o = {}) {
    let r = bt.call(this, e || n[t]);
    if (r == null) return;
    let s;
    if (E(r)) {
        if (/^(?:env|var)\(/.test(r.trim())) return {
            [t]: r
        };
        if (r.includes("(")) {
            let c = Vo(r);
            s = c[0], r = c[1];
        }
        let i = n.scaleBoxSize, a = Nu(t);
        !i && a && !o.ratio && (r = $u(r));
    }
    return o.ratio ? ze(n, t, r, s) : Ut(r, t, void 0, s);
}
var $ = (t, e = null, n)=>It(t, e, n, {
        ratio: !0
    }), L3 = (t, e, n)=>E(t) ? at(t).map((o)=>$n.test(o) ? ze(e, n, o)[n] : o).join(" ") : t, Go = (t, e, n, o = "borderRadius")=>{
    if (E(t)) return {
        [o]: at(t).map((r)=>{
            let s = Yu(r);
            return s !== void 0 ? L3(s, e, n) : ze(e, n, r)[n];
        }).join(" ")
    };
};
var dc = "__smblsThemeRootOwner", pc = (t)=>{
    let e = t && t.__prefersListener, n = t && t.__prefersMq;
    if (e && n) try {
        typeof n.removeEventListener == "function" ? n.removeEventListener("change", e) : typeof n.removeListener == "function" && n.removeListener(e);
    } catch  {
        try {
            n.removeListener(e);
        } catch  {}
    }
    t && (t.__prefersListener = null, t.__prefersMq = null);
}, T1 = (t, e, n)=>{
    if (!(!t || !e)) {
        pc(t), t.__prefersListener = n, t.__prefersMq = e;
        try {
            e.addEventListener("change", n);
        } catch  {
            e.addListener(n);
        }
    }
}, P3 = (t, e)=>{
    let n = L(), { cssVars: o } = n, r = e.startsWith("--") ? e : `--${e}`;
    return o[r] = t, t;
}, pe = (t)=>t, I3 = (t, e)=>{
    if (E(t) || be(t)) {
        let n = L();
        if (n.cssVars && e) {
            let o = n.varPrefix ? n.varPrefix + "-" : "";
            n.cssVars[`--${o}size-${e}`] = t;
        }
    }
    return t;
}, vm = {
    color: Wo,
    gradient: sc,
    font: Wu,
    fontFamily: lc,
    fontfamily: lc,
    theme: zu,
    icons: mi,
    semanticIcons: pe,
    semanticicons: pe,
    svg: fc,
    svgData: pe,
    typography: pe,
    shadow: $r,
    spacing: pe,
    media: pe,
    grid: pe,
    class: pe,
    timing: pe,
    reset: pe,
    unit: pe,
    animation: pe,
    vars: P3,
    sizes: I3,
    shape: pe,
    skins: pe,
    viewTransition: pe
}, M3 = new Map([
    [
        "gradient",
        [
            "color"
        ]
    ],
    [
        "theme",
        [
            "color",
            "gradient",
            "skins"
        ]
    ],
    [
        "shadow",
        [
            "color"
        ]
    ]
]), B3 = (t, e, n, o)=>{
    fr(t, n, e);
    let r = {};
    for (let s of o)t[s] === e && (t[s] = r);
    return t.verbose, r;
}, C0 = (t, e, n)=>{
    let o = L(), r = Eu(t), s = r.toLowerCase(), i = o[r] || o[s] || o[t], a = Co(i) ? B3(o, i, s, [
        r,
        s,
        t
    ]) : i, c = vm[r] || vm[s];
    if (c) try {
        let l = c(e, n);
        return a && (a[n] = l), a;
    } catch (l) {
        o.verbose;
    }
    if (!c) {
        let l = a || (o[s] = {});
        return l[n] = e, l;
    }
    o.verbose;
}, rd = (t, e)=>{
    let n = L(), o = t.toLowerCase();
    if (Co(e)) return fr(n, o, e), n.verbose, n[o] || n[t];
    if (e == null) return n.verbose, n[o] || n[t];
    let r = Object.keys(e).sort((s, i)=>{
        let a = k(e[s]) || B(e[s]) ? 1 : 0, c = k(e[i]) || B(e[i]) ? 1 : 0;
        return a - c;
    });
    if (o === "color") {
        let s = n[o] || (n[o] = {});
        for (let i of r)i in s || (s[i] = e[i]);
    }
    return r.forEach((s)=>{
        try {
            return C0(o, e[s], s);
        } catch (i) {
            n.verbose;
        }
    }), n[o] || n[t];
}, Om = (t, e)=>{
    let n = e || L();
    n.globalTheme = t;
    let r = ha(n) || (typeof document < "u" ? document : null), s = r && r.defaultView || (typeof window < "u" ? window : null);
    if (r) {
        let a = n.themeRoot || r.documentElement, c = t && t !== "auto";
        if (a[dc] = n, c) pc(n), a.setAttribute("data-theme", t), n.resolvedTheme = t, t === "dark" || t === "light" ? a.style.colorScheme = t : a.style.colorScheme = "light dark";
        else if (s && s.matchMedia) {
            let l = (u)=>{
                let d = u.matches ? "dark" : "light";
                a.setAttribute("data-theme", d), n.resolvedTheme = d;
            }, f = s.matchMedia("(prefers-color-scheme: dark)");
            l(f), a.style.colorScheme = "light dark", T1(n, f, l);
        } else pc(n), a.setAttribute("data-theme", "light"), n.resolvedTheme = "light", a.style.colorScheme = "light";
    }
    let i = n.varPrefix ? `--${n.varPrefix}-theme-` : "--theme-";
    for(let a in n.cssVars)a.startsWith(i) && delete n.cssVars[a];
    for(let a in n.cssMediaVars)delete n.cssMediaVars[a];
    if (r && n.cssVars) {
        let a = n.scopeSelector || ":root", c = r.styleSheets;
        for(let l = 0; l < c.length; l++)try {
            let f = c[l].cssRules;
            for(let u = 0; u < f.length; u++)if (f[u].selectorText === a) {
                for(let d in n.cssVars)f[u].style.setProperty(d, n.cssVars[d]);
                return n;
            }
        } catch  {}
    }
    return n;
}, sd = (t)=>{
    let n = ha(t) || (typeof document < "u" ? document : null), o = n && n.defaultView || (typeof window < "u" ? window : null), r = n && (t.themeRoot || n.documentElement);
    if (r && typeof r.setAttribute == "function") {
        if (t.globalTheme && t.globalTheme !== "auto") pc(t), r.setAttribute("data-theme", t.globalTheme), t.resolvedTheme = t.globalTheme, r[dc] = t, t.globalTheme === "dark" || t.globalTheme === "light" ? r.style.colorScheme = t.globalTheme : r.style.colorScheme = "light dark";
        else if (r[dc] && r[dc] !== t && r.hasAttribute("data-theme")) pc(t), t.resolvedTheme = r.getAttribute("data-theme");
        else if (o && o.matchMedia) {
            let i = (c)=>{
                let l = c.matches ? "dark" : "light";
                r.setAttribute("data-theme", l), t.resolvedTheme = l;
            }, a = o.matchMedia("(prefers-color-scheme: dark)");
            i(a), r.style.colorScheme = "light dark", r[dc] = t, T1(t, a, i);
        } else pc(t), r.setAttribute("data-theme", "light"), t.resolvedTheme = "light", r.style.colorScheme = "light", r[dc] = t;
    }
}, N3 = {}, bi = (t, e = N3)=>{
    let n = e.config || L(), { version: o, verbose: r, useVariable: s, useReset: i, useSvgSprite: a, useFontImport: c, useIconSprite: l, globalTheme: f, themeRoot: u, useDocumentTheme: d, useDefaultConfig: p, semanticIcons: g, hoverMedia: h, focusableRing: m, faceWait: y, files: b, assets: T, ...v } = t;
    e.newConfig && (n = cm(e.newConfig)), Oo(v.document) && (n.__domDocument = v.document, delete v.document), Oo(n.document) && (n.__domDocument || (n.__domDocument = n.document), n.document = {}), b !== void 0 && (n.files = b), T !== void 0 && (n.assets = T), r !== void 0 && (n.verbose = r), s !== void 0 && (n.useVariable = s), i !== void 0 && (n.useReset = i), c !== void 0 && (n.useFontImport = c), a !== void 0 && (n.useSvgSprite = a), l !== void 0 && (n.useIconSprite = l), d !== void 0 && (n.useDocumentTheme = d), f !== void 0 && (n.globalTheme = f), u !== void 0 && (n.themeRoot = u), t.useThemeSuffixedVars !== void 0 && (n.useThemeSuffixedVars = t.useThemeSuffixedVars), p !== void 0 && (n.useDefaultConfig = p), g !== void 0 && (n.semanticIcons = g), h !== void 0 && (n.hoverMedia = h), m !== void 0 && (n.focusableRing = m), y !== void 0 && (n.faceWait = y), n.verbose, sd(n), n.__svgCache || (n.__svgCache = {}), oc(v);
    let S = Object.keys(v).filter((I)=>!I.startsWith("__")), w = new Set(S);
    S.forEach((I)=>{
        let M = I.toLowerCase();
        M !== I && w.has(M) && mt(v[M], v[I], ue);
    });
    let _ = [], x = new Set;
    S.forEach((I)=>{
        let M = I.toLowerCase(), K = M !== I && w.has(M) ? M : I;
        x.has(K) || (x.add(K), _.push(K));
    });
    let A = new Map;
    _.forEach((I)=>{
        let M = I.toLowerCase();
        A.has(M) || A.set(M, []), A.get(M).push(I);
    });
    let O = new Set, C = (I)=>{
        if (O.has(I)) return;
        O.add(I);
        let M = M3.get(I.toLowerCase());
        M && M.forEach((K)=>(A.get(K) || []).forEach(C)), rd(I, v[I]);
    };
    if (_.forEach(C), n.varPrefix && (n.typography && (n.typography.varPrefix = n.varPrefix), n.spacing && (n.spacing.varPrefix = n.varPrefix), n.timing && (n.timing.varPrefix = n.varPrefix)), v.typography) try {
        Gu();
    } catch (I) {
        n.verbose;
    }
    if (v.spacing) try {
        Fu();
    } catch (I) {
        n.verbose;
    }
    if (v.timing) try {
        Xu();
    } catch (I) {
        n.verbose;
    }
    try {
        Hu();
    } catch (I) {
        n.verbose;
    }
    Zu();
    let N = Ju();
    return N && (n.reset = N), n;
};
var gc = 1, R0 = [
    "font",
    "files",
    "assets",
    "themeRoot"
], F3 = new Set(R0), hc = "$smbls", Cm = (t)=>{
    if (t === null || typeof t != "object") return !1;
    let e = Object.getPrototypeOf(t);
    return e === Object.prototype || e === null;
}, $3 = (t)=>t.startsWith("__") || F3.has(t), Rm = (t)=>{
    if (!Cm(t)) return null;
    let e = new Map, n = !1, o = (s)=>{
        if (n) return;
        if (s === void 0) return {
            [hc]: "u"
        };
        if (s === null || typeof s == "string" || typeof s == "boolean") return s;
        if (typeof s == "number") return Number.isFinite(s) && !Object.is(s, -0) ? s : {
            [hc]: "n",
            v: Object.is(s, -0) ? "-0" : String(s)
        };
        if (typeof s != "object") {
            n = !0;
            return;
        }
        let i = e.get(s);
        if (i !== void 0) return {
            [hc]: "r",
            i: i
        };
        if (Array.isArray(s)) {
            e.set(s, e.size);
            let c = new Array(s.length);
            for(let l = 0; l < s.length; l++){
                if (!(l in s)) {
                    n = !0;
                    return;
                }
                c[l] = o(s[l]);
            }
            return c;
        }
        if (!Cm(s) || Object.prototype.hasOwnProperty.call(s, hc)) {
            n = !0;
            return;
        }
        e.set(s, e.size);
        let a = {};
        for (let c of Object.keys(s))a[c] = o(s[c]);
        return a;
    }, r = {};
    for (let s of Object.keys(t))if (!$3(s) && (r[s] = o(t[s]), n)) return null;
    return r;
}, j3 = (t, e)=>{
    let n = Object.keys(e), o = 0;
    for(let r in t){
        if (o === n.length) return !0;
        if (r !== n[o]) return !1;
        o++;
    }
    return o === n.length;
}, Dm = (t, e)=>{
    let n = [], o = (s, i)=>{
        if (s === null || typeof s != "object") return s;
        if (Array.isArray(s)) {
            let l = new Array(s.length);
            n.push(l);
            for(let f = 0; f < s.length; f++)l[f] = o(s[f]);
            return l;
        }
        let a = s[hc];
        if (typeof a == "string") {
            if (a === "u") return;
            if (a === "n") return s.v === "-0" ? -0 : Number(s.v);
            if (a === "r") return n[s.i];
        }
        let c = i;
        if (c && !j3(s, c)) for (let l of Object.keys(c))delete c[l];
        else c || (c = {});
        n.push(c);
        for(let l in s)c[l] = o(s[l]);
        return c;
    }, r = new Set;
    for(let s in t){
        let i = t[s], a = e[s], c = Cm(a) && !r.has(a) && Cm(i) && typeof i[hc] != "string" ? a : null;
        c && r.add(c);
        let l = o(i, c);
        l !== a && (e[s] = l);
    }
    return e;
};
var W = (t, e)=>e.split(" ").map((n)=>t + "-" + n), I0 = "top right bottom left", M0 = I0 + " block block-start block-end inline inline-start inline-end", ve = "start end", Yo = "width style color", Lm = (t)=>W(t, M0), U3 = (()=>{
    let t = W("border", "width style color image");
    for (let e of M0.split(" "))t.push("border-" + e, ...W("border-" + e, Yo));
    return t;
})(), E1 = (t)=>[
        ...W("border-" + t, Yo + " start end"),
        ...W("border-" + t + "-start", Yo),
        ...W("border-" + t + "-end", Yo)
    ], kt = {
    animation: W("animation", "name duration timing-function delay iteration-count direction fill-mode play-state timeline range range-start range-end"),
    background: W("background", "image position position-x position-y size repeat origin clip attachment color"),
    border: U3
};
for (let t of [
    "width",
    "style",
    "color"
])kt["border-" + t] = M0.split(" ").map((e)=>"border-" + e + "-" + t);
for (let t of I0.split(" "))kt["border-" + t] = W("border-" + t, Yo);
kt["border-block"] = E1("block");
kt["border-inline"] = E1("inline");
Object.assign(kt, {
    "border-image": W("border-image", "source slice width outset repeat"),
    "border-radius": "top-left top-right bottom-right bottom-left start-start start-end end-start end-end".split(" ").map((t)=>"border-" + t + "-radius"),
    columns: W("column", "width count"),
    "column-rule": W("column-rule", Yo),
    container: W("container", "name type"),
    "contain-intrinsic-size": W("contain-intrinsic", "width height"),
    flex: W("flex", "grow shrink basis"),
    "flex-flow": W("flex", "direction wrap"),
    font: [
        ...W("font", "style variant weight stretch size"),
        "line-height",
        ...W("font", "family size-adjust kerning feature-settings variation-settings optical-sizing")
    ],
    gap: [
        "row-gap",
        "column-gap"
    ],
    grid: W("grid", "template template-rows template-columns template-areas auto-rows auto-columns auto-flow"),
    "grid-template": W("grid-template", "rows columns areas"),
    "grid-area": W("grid", "row column row-start row-end column-start column-end"),
    "grid-row": W("grid-row", ve),
    "grid-column": W("grid-column", ve),
    inset: [
        ...I0.split(" "),
        ...W("inset", "block block-start block-end inline inline-start inline-end")
    ],
    "inset-block": W("inset-block", ve),
    "inset-inline": W("inset-inline", ve),
    "list-style": W("list-style", "type position image"),
    margin: Lm("margin"),
    "margin-block": W("margin-block", ve),
    "margin-inline": W("margin-inline", ve),
    mask: W("mask", "image mode repeat position clip origin size composite"),
    offset: W("offset", "position path distance rotate anchor"),
    outline: W("outline", Yo),
    overflow: W("overflow", "x y"),
    "overscroll-behavior": W("overscroll-behavior", "x y"),
    padding: Lm("padding"),
    "padding-block": W("padding-block", ve),
    "padding-inline": W("padding-inline", ve)
});
for (let t of [
    "content",
    "items",
    "self"
])kt["place-" + t] = [
    "align-" + t,
    "justify-" + t
];
Object.assign(kt, {
    "scroll-margin": Lm("scroll-margin"),
    "scroll-padding": Lm("scroll-padding"),
    "text-decoration": W("text-decoration", "line style color thickness"),
    "text-emphasis": W("text-emphasis", "style color"),
    transition: W("transition", "property duration timing-function delay behavior")
});
var H3 = "block-start block-end inline-start inline-end".split(" ");
for (let t of H3)kt["border-" + t] = W("border-" + t, Yo);
for (let t of [
    "block",
    "inline"
])for (let e of Yo.split(" "))kt["border-" + t + "-" + e] = W("border-" + t, ve.split(" ").map((n)=>n + "-" + e).join(" "));
Object.assign(kt, {
    "animation-range": W("animation-range", ve),
    "background-position": W("background-position", "x y"),
    "font-variant": W("font-variant", "alternates caps east-asian emoji ligatures numeric position"),
    "font-synthesis": W("font-synthesis", "weight style small-caps"),
    marker: W("marker", "start mid end"),
    "position-try": W("position-try", "order fallbacks"),
    "scroll-margin-block": W("scroll-margin-block", ve),
    "scroll-margin-inline": W("scroll-margin-inline", ve),
    "scroll-padding-block": W("scroll-padding-block", ve),
    "scroll-padding-inline": W("scroll-padding-inline", ve),
    "scroll-timeline": W("scroll-timeline", "name axis"),
    "view-timeline": W("view-timeline", "name axis inset"),
    "text-box": W("text-box", "trim edge"),
    "text-wrap": W("text-wrap", "mode style"),
    "white-space": [
        "white-space-collapse",
        "text-wrap-mode"
    ]
});
kt.font.push("font-language-override");
var qo = (t)=>"corner-" + t + "-shape";
kt["corner-shape"] = [
    ..."top-left top-right bottom-right bottom-left start-start start-end end-start end-end".split(" "),
    ..."top right bottom left block-start block-end inline-start inline-end".split(" ")
].map(qo);
Object.assign(kt, {
    "corner-top-shape": [
        "top-left",
        "top-right"
    ].map(qo),
    "corner-right-shape": [
        "top-right",
        "bottom-right"
    ].map(qo),
    "corner-bottom-shape": [
        "bottom-left",
        "bottom-right"
    ].map(qo),
    "corner-left-shape": [
        "top-left",
        "bottom-left"
    ].map(qo),
    "corner-block-start-shape": [
        "start-start",
        "start-end"
    ].map(qo),
    "corner-block-end-shape": [
        "end-start",
        "end-end"
    ].map(qo),
    "corner-inline-start-shape": [
        "start-start",
        "end-start"
    ].map(qo),
    "corner-inline-end-shape": [
        "start-end",
        "end-end"
    ].map(qo)
});
for(let t in kt){
    let e = kt[t], n = new Set(e);
    for(let o = 0; o < e.length; o++){
        let r = kt[e[o]];
        if (r) for (let s of r)n.has(s) || (n.add(s), e.push(s));
    }
}
var gn = {};
for(let t in kt)for (let e of kt[t])(gn[e] || (gn[e] = [])).push(t);
var L0 = new Map, A1 = (t)=>{
    let e = L0.get(t);
    if (e !== void 0) return e;
    L0.set(t, 0), e = 0;
    let n = gn[t];
    if (n) for(let o = 0; o < n.length; o++)e = Math.max(e, A1(n[o]) + 1);
    return L0.set(t, e), e;
};
function mc(t) {
    if (typeof t != "string") return 0;
    let e = t.charCodeAt(0) === 45 && t.charCodeAt(1) !== 45 ? t.replace(/^-(webkit|moz|ms|o)-/, "") : t;
    return Object.prototype.hasOwnProperty.call(gn, e) ? A1(e) : 0;
}
var V3 = /^(?:margin|padding|inset|scroll-margin|scroll-padding)(?:-(?:block|inline))?$|^border(?:-(?:block|inline))?-(?:width|style|color)$|^(?:border-radius|corner(?:-[a-z]+)*-shape|gap|overflow|overscroll-behavior|place-(?:content|items|self)|background-position|contain-intrinsic-size)$/, v1 = /^(?:border(?:-(?:top|right|bottom|left|block|inline)(?:-(?:start|end))?)?|outline|column-rule)$/, z3 = new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
    "auto"
]), P0 = (t)=>at(String(t).replace(/\s*!important\s*$/, ""));
function yc(t, e, n) {
    let o = kt[t];
    if (!o || o.indexOf(n) === -1) return !1;
    if (V3.test(t)) return !0;
    if (!v1.test(t) || typeof e == "function" || e == null || n.indexOf("border-image") === 0) return !1;
    let r = P0(e);
    return r.length >= 3 ? !0 : /-style$/.test(n) && r.some((s)=>z3.has(s.toLowerCase()));
}
var W3 = new Set([
    "thin",
    "medium",
    "thick"
]), K3 = (t)=>/^[+-]?\.?\d/.test(t) || W3.has(t.toLowerCase()) || /^(?:calc|min|max|clamp)\(/i.test(t) || /^var\(--(?:[a-zA-Z0-9]{1,6}-)?spacing-/.test(t), G3 = (t)=>t === "transparent" || t === "currentcolor" || Object.prototype.hasOwnProperty.call(Ya, t), q3 = (t)=>ni(t) || /^var\(--(?:(?!theme-|shadow-)[a-zA-Z0-9]{1,6}-)?color-/.test(t) || G3(t.toLowerCase()), Y3 = /-(width|style|color)$/;
function id(t, e, n) {
    if (yc(t, e, n)) return !0;
    let o = kt[t];
    if (!o || o.indexOf(n) === -1 || typeof e == "function" || e == null) return !1;
    if (v1.test(t)) {
        if (n.indexOf("border-image") === 0) return !1;
        let r = Y3.exec(n);
        if (!r) return !1;
        let s = P0(e);
        return s.length === 1 && /^(?:0|none)$/i.test(s[0]) ? r[1] !== "color" : r[1] === "width" && s.some(K3);
    }
    if (t === "background" && n === "background-color") {
        let r = P0(e);
        return r.length === 1 && q3(r[0]);
    }
    return !1;
}
var Sc = new Map, U1 = null, B0 = null, X3 = null;
function ld(t) {
    t.batchAtomicCss && (B0 = t.batchAtomicCss), t.compoundCssClass && (X3 = t.compoundCssClass);
}
var Z3 = new Set, C1 = (t)=>!!(t && t.documentElement && typeof t.createElement == "function" && t.head !== void 0);
function K0(t) {
    try {
        let e = L();
        e && (e.__domDocument = t);
    } catch  {}
    t && Z3.add(t);
}
function fo() {
    try {
        let t = L();
        if (t) {
            if (C1(t.__domDocument)) return t.__domDocument;
            if (C1(t.document)) return t.document;
        }
    } catch  {}
    return typeof document < "u" ? document : null;
}
var Oe = {
    atomic: 0,
    variable: 0,
    global: 0,
    keyframes: 0,
    duplicate: 0,
    invalid: 0,
    dropped: 0
};
function jm() {
    return {
        ...Oe
    };
}
function G0() {
    for(let t in Oe)Oe[t] = 0;
    Nm = !1;
}
var Nm = !1, Mm = (t, e)=>`${t} ${e}${t === 1 ? "" : "s"}`;
function Q3(t) {
    let e = Date.parse(t);
    if (!isFinite(e)) return "";
    let n = Math.floor((Date.now() - e) / 864e5);
    return n < 1 ? " (today)" : ` (${Mm(n, "day")} ago)`;
}
function J3() {
    try {
        let t = u6();
        if (!t.length) return -1;
        let e = 0;
        for(let n = 0; n < t.length; n++)e += t[n].cssRules ? t[n].cssRules.length : 0;
        return e;
    } catch  {
        return -1;
    }
}
function t6(t, e) {
    if (Nm) return !1;
    Nm = !0;
    let n = "n/a \u2014 running from src/ (unbuilt), so no dist is in play", o = "this IS the source", r = "@symbo.ls/css";
    return console.error(`[@symbo.ls/css] CSS EMIT FAILURE (${t}) \u2014 the engine emitted ${Mm(Oe.variable, "variable rule")} and ${Mm(Oe.atomic, "atomic rule")}, while the design system held ${Mm(e, "CSS variable")}.
  The document will render UNSTYLED and nothing else will report an error.
  This is what a STALE dist/ looks like: an obsolete emitter against a current design system.
  package : ${r}
  built   : ${n}
  source  : ${o}
  emitted : ${JSON.stringify(Oe)}
  sheets  : the style[data-smbls] tiers currently hold ${J3()} rule(s)
  FIX     : cd smbls && npm run check:stale   # every package whose src is newer than its dist
            then rebuild the listed packages and clear the app's .parcel-cache
  Do NOT trust any browser measurement taken on this page until that reads clean.`), !0;
}
function H1() {
    try {
        let t = L(), e = t && (t.CSS_VARS || t.cssVars);
        return e ? Object.keys(e).length : 0;
    } catch  {
        return 0;
    }
}
function N0(t) {
    Nm || Oe.variable > 0 || Oe.atomic > 0 || V1(Math.max(t, H1()));
}
function q0(t) {
    let e = t && (t.CSS_VARS || t.cssVars);
    return V1(e ? Object.keys(e).length : H1());
}
function V1(t) {
    let e = jm();
    if (t === 0) return {
        ok: !0,
        reason: "no-design-system",
        stats: e,
        varCount: t
    };
    if (!tT()) return {
        ok: !0,
        reason: "no-sheet",
        stats: e,
        varCount: t
    };
    if (e.variable > 0 || e.atomic > 0) return {
        ok: !0,
        reason: null,
        stats: e,
        varCount: t
    };
    let n = e.invalid > 0 ? "every rule was rejected as malformed" : "no rule was ever produced";
    return t6(n, t), {
        ok: !1,
        reason: n,
        stats: e,
        varCount: t
    };
}
var e6 = {
    display: "d",
    position: "pos",
    padding: "p",
    paddingTop: "pt",
    paddingRight: "pr",
    paddingBottom: "pb",
    paddingLeft: "pl",
    margin: "m",
    marginTop: "mt",
    marginRight: "mr",
    marginBottom: "mb",
    marginLeft: "ml",
    width: "w",
    height: "h",
    minWidth: "mnw",
    minHeight: "mnh",
    maxWidth: "mxw",
    maxHeight: "mxh",
    top: "t",
    right: "r",
    bottom: "b",
    left: "l",
    flex: "fx",
    flexDirection: "fxd",
    flexWrap: "fxw",
    flexGrow: "fxg",
    flexShrink: "fxs",
    flexBasis: "fxb",
    justifyContent: "jc",
    alignItems: "ai",
    alignSelf: "as",
    alignContent: "ac",
    gap: "g",
    rowGap: "rg",
    columnGap: "cg",
    gridTemplateColumns: "gtc",
    gridTemplateRows: "gtr",
    gridColumn: "gc",
    gridRow: "gr",
    overflow: "of",
    overflowX: "ofx",
    overflowY: "ofy",
    fontSize: "fs",
    fontWeight: "fw",
    fontFamily: "ff",
    fontStyle: "fst",
    lineHeight: "lh",
    letterSpacing: "ls",
    textAlign: "ta",
    textDecoration: "td",
    textTransform: "tt",
    color: "c",
    background: "bg",
    backgroundColor: "bgc",
    backgroundImage: "bgi",
    border: "bd",
    borderRadius: "br",
    borderColor: "bdc",
    borderWidth: "bdw",
    borderStyle: "bds",
    boxShadow: "bxsh",
    opacity: "op",
    zIndex: "z",
    cursor: "cur",
    transition: "tr",
    transform: "tf",
    animation: "an",
    visibility: "vis",
    whiteSpace: "ws",
    wordBreak: "wb",
    objectFit: "obj",
    pointerEvents: "pe",
    userSelect: "us",
    boxSizing: "bxz",
    outline: "ol",
    listStyle: "lis",
    textOverflow: "txo",
    verticalAlign: "va",
    float: "fl",
    clear: "cl",
    content: "cnt",
    backdropFilter: "bdf",
    filter: "flt",
    resize: "rsz",
    appearance: "apr",
    fill: "fil",
    stroke: "stk"
};
function n6(t) {
    return t.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase());
}
var bc = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, R1 = new Map, Re = (t)=>{
    if (bc(t)) return t;
    let e = R1.get(t);
    return e === void 0 && (e = n6(t), R1.set(t, e)), e;
}, D1 = new Map, fd = (t)=>{
    if (bc(t)) return t;
    let e = D1.get(t);
    return e === void 0 && (e = t.replace(/-([a-z])/g, (n, o)=>o.toUpperCase()), D1.set(t, e)), e;
};
function Fm(t) {
    let e = 2166136261;
    for(let n = 0; n < t.length; n++)e ^= t.charCodeAt(n), e = e * 16777619 >>> 0;
    return e.toString(36);
}
function o6(t) {
    let e = String(t);
    return e.length <= 20 ? e.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_-]/g, "").toLowerCase() : Fm(e);
}
var r6 = {
    "backdrop-filter": "-webkit-backdrop-filter",
    "user-select": "-webkit-user-select",
    "mask-image": "-webkit-mask-image",
    "mask-size": "-webkit-mask-size",
    "mask-repeat": "-webkit-mask-repeat",
    "mask-position": "-webkit-mask-position",
    "mask-clip": "-webkit-mask-clip",
    "mask-origin": "-webkit-mask-origin",
    "background-clip": "-webkit-background-clip"
};
function Si(t, e) {
    let n = r6[t];
    return n ? `${t}:${e};${n}:${e};` : `${t}:${e};`;
}
function F0(t) {
    let e = "";
    for(let n in t){
        let o = t[n];
        if (typeof o != "object" || o === null) continue;
        let r = "";
        for(let s in o)o[s] != null && (r += Si(Re(s), o[s]));
        e += `${n}{${r}}`;
    }
    return e;
}
function $0(t) {
    return t.charCodeAt(0) === 64 && !wc(t);
}
function L1(t) {
    let e = "";
    for(let n in t){
        let o = t[n];
        if (!$0(n) || typeof o != "object" || o === null) continue;
        let r = "";
        for(let s in o){
            let i = o[s];
            i == null || typeof i == "object" || (r += Si(Re(s), i));
        }
        e += `${n}{${r}}`;
    }
    return e;
}
var s6 = "@media (hover: hover)", i6 = /(?:^|[^\\]):hover(?![\w-])/;
function Y0() {
    try {
        let t = L();
        if (t && t.hoverMedia === !1) return !1;
    } catch  {}
    return !0;
}
function Xo(t, e, n) {
    return n === !1 || !i6.test(e) || n === void 0 && !Y0() ? t : `${s6}{${t}}`;
}
var X0 = new Map;
function a6(t, e, n, o) {
    let r = Sc.get(t);
    if (!r) {
        let c = e6[e] || Fm(e), l = o6(n);
        r = o ? `_${o}_${c}-${l}` : `_${c}-${l}`, Sc.set(t, r);
    }
    let i = typeof n == "string" && (n.indexOf("}") !== -1 || n.indexOf("{") !== -1) ? null : `.${r}{${Si(Re(e), n)}}`, a = {
        className: r,
        rule: i,
        tier: i === null ? null : Z0(i, !0, "atomic")
    };
    return X0.set(t, a), a;
}
function P1(t, e, n) {
    let o = (n ? n + "" : "") + t + ":" + e, r = X0.get(o) || a6(o, t, e, n);
    return r.rule !== null && mn(r.rule, void 0, "atomic", !0, r.tier), r.className;
}
var I1 = new WeakMap, M1 = new WeakMap;
function mn(t, e, n, o, r) {
    let s = r || Z0(t, o, n);
    cd && !e && cd.push([
        t,
        n || "global",
        s
    ]);
    let i = f6(e, s);
    if (!i) return Oe.dropped++, "dropped";
    let a = i.sheet, c = i.rules;
    if (c || (c = I1.get(a), c || (c = new Set, I1.set(a, c)), i.rules = c), c.has(t)) return Oe.duplicate++, Oe[n || "global"]++, "duplicate";
    let l = M1.get(a);
    if (l && l.has(t)) return Oe.invalid++, "invalid";
    try {
        a.insertRule(t, a.cssRules.length);
    } catch  {
        return l || (l = new Set, M1.set(a, l)), l.add(t), Oe.invalid++, "invalid";
    }
    return c.add(t), Oe[n || "global"]++, "inserted";
}
var Ce = "0:0", j0 = "1:0", z1 = "0:99", B1 = /\((max|min)-width:\s*([\d.]+)(px|em|rem)?\)/g;
function Z0(t, e, n) {
    if (typeof t != "string" || !t) return Ce;
    if (t.charCodeAt(0) === 64) {
        if (!t.startsWith("@media") && !t.startsWith("@supports") && !t.startsWith("@container")) return Ce;
        let i = 1 / 0, a = -1 / 0;
        B1.lastIndex = 0;
        let c;
        for(; c = B1.exec(t);){
            let l = parseFloat(c[2]) * (c[3] === "em" || c[3] === "rem" ? 16 : 1);
            c[1] === "max" ? i = Math.min(i, l) : a = Math.max(a, l);
        }
        return i !== 1 / 0 ? "2:" + -i : a !== -1 / 0 ? "3:" + a : j0;
    }
    if (t.charCodeAt(0) !== 46) return n === "atomic" && !e ? z1 : Ce;
    if (!/^\.[\w-]+\{/.test(t)) return j0;
    if (!e) return Ce;
    let o = t.indexOf("{"), r = t.indexOf(":", o);
    if (r === -1) return Ce;
    let s = mc(t.slice(o + 1, r).trim());
    return s ? "0:" + s : Ce;
}
var _c = null, c6 = ()=>{
    if (_c) return _c;
    let t = 0;
    for(let e in gn)t = Math.max(t, mc(e));
    _c = [
        Ce
    ];
    for(let e = 1; e <= t; e++)_c.push("0:" + e);
    return _c.push(z1, j0), _c;
}, N1 = (t)=>{
    let e = t.indexOf(":");
    return [
        Number(t.slice(0, e)),
        Number(t.slice(e + 1))
    ];
}, W1 = (t, e)=>{
    let [n, o] = N1(t), [r, s] = N1(e);
    return n !== r ? n - r : o - s;
}, F1 = (t, e)=>W1(t, e) < 0, K1 = (t)=>t.getAttribute("data-tier") || Ce, l6 = /^\d+:-?\d+(?:\.\d+)?$/;
function Q0(t) {
    return !t || typeof t.hasAttribute != "function" || !t.hasAttribute("data-smbls") ? null : K1(t);
}
function J0(t, e) {
    let n = Array.from(t || [], (o, r)=>{
        let s = typeof e == "function" ? e(o) : null;
        return {
            item: o,
            i: r,
            tier: typeof s == "string" && l6.test(s) ? s : Ce
        };
    });
    return n.sort((o, r)=>W1(o.tier, r.tier) || o.i - r.i), n.map((o)=>o.item);
}
var U0 = new WeakMap, Bm = !1, ad = null, H0 = 0;
function f6(t, e) {
    if (Bm && !t) {
        let n = ad && U0.get(ad), o = n && n.get(e);
        if (o && o.epoch === H0) return o;
        let r = $m(ad, e);
        return r && (r.epoch = H0), r;
    }
    return $m(t || fo(), e);
}
function tT(t, e) {
    let n = $m(t || fo(), e);
    return n ? n.sheet : null;
}
function $m(t, e) {
    if (!t || !t.head) return null;
    let n = e || Ce, o = U0.get(t);
    o || (o = new Map, U0.set(t, o));
    let r = o.get(n);
    if (r && r.node.parentNode === t.head && r.node.sheet === r.sheet) return r;
    if (n !== Ce) {
        let c = c6();
        for(let l = 0; l < c.length && F1(c[l], n); l++)$m(t, c[l]);
    }
    let s = n === Ce ? t.head.querySelector("style[data-smbls]:not([data-tier])") : t.head.querySelector(`style[data-smbls][data-tier="${n}"]`);
    if (!s) {
        s = t.createElement("style"), s.setAttribute("data-smbls", ""), n !== Ce && s.setAttribute("data-tier", n);
        let c = t.head.querySelectorAll("style[data-smbls]"), l = null;
        for(let u = 0; u < c.length; u++)if (F1(n, K1(c[u]))) {
            l = c[u];
            break;
        }
        let f = c.length ? c[c.length - 1] : null;
        if (l) t.head.insertBefore(s, l);
        else if (f) t.head.insertBefore(s, f.nextSibling);
        else {
            let u = t.head.querySelector('style[data-brender], style[data-emotion="smbls"]');
            u ? t.head.insertBefore(s, u) : t.head.appendChild(s);
        }
    }
    let i = s.sheet;
    if (!i) return o.delete(n), null;
    let a = {
        sheet: i,
        node: s,
        rules: null,
        epoch: 0
    };
    return o.set(n, a), n === Ce && (U1 = i), a;
}
function u6(t) {
    let e = t || fo();
    if (!e || !e.head) return [];
    let n = [], o = e.head.querySelectorAll("style[data-smbls]");
    for(let r = 0; r < o.length; r++)o[r].sheet && n.push(o[r].sheet);
    return n;
}
var d6 = 8;
function Ke(t, e, n, o) {
    if (!t || typeof t != "object") return "";
    if (Bm) return $1(t, n, o);
    Bm = !0, ad = fo(), H0++;
    try {
        return $1(t, n, o);
    } finally{
        Bm = !1, ad = null;
    }
}
function $1(t, e, n) {
    let o = !!(n && n.state), r = null, s = 0, i = [], a = [], c = Object.keys(t);
    for(let f = 0; f < c.length; f++){
        let u = c[f], d = t[u];
        d == null || d === !1 || d === "" || (typeof d == "object" ? a.push([
            u,
            d
        ]) : B0 && !bc(u) ? (r || (r = []), r.push(u, String(d)), s++) : i.push(P1(u, String(d), e)));
    }
    if (r && s >= d6) {
        let f = r.join("\0"), u = B0(f), d = u.indexOf("\0"), p = u.substring(0, d), g = u.substring(d + 1);
        if (g) {
            let h = g.split(`
`);
            for(let m = 0; m < h.length; m++)h[m] && mn(h[m], void 0, "atomic", !0);
        }
        i.push(p);
    } else if (r) for(let f = 0; f < r.length; f += 2)i.push(P1(r[f], r[f + 1], e));
    let l = [];
    for(let f = 0; f < a.length; f++)l.push(m6(a[f][0], a[f][1], e, o));
    return i.concat(l).join(" ").trim();
}
var j1 = new Map, p6 = /^&?:(hover|focus|focus-visible|focus-within|active)(?![\w-])/;
function wc(t) {
    return /^@(media|supports|container)\b/.test(t);
}
function Zo(t) {
    let e = [], n = 0, o = 0;
    for(let r = 0; r < t.length; r++){
        let s = t.charCodeAt(r);
        s === 40 ? n++ : s === 41 ? n-- : s === 44 && n === 0 && (e.push(t.slice(o, r).trim()), o = r + 1);
    }
    return e.push(t.slice(o).trim()), e;
}
function h6(t) {
    return typeof t != "string" || !t || wc(t) ? !1 : Zo(t).every((e)=>p6.test(e));
}
var G1 = (t)=>{
    let e = Object.prototype.toString.call(t);
    return e === "[object Object]" || e === "[object Array]";
}, V0 = 32, z0 = 1024, W0 = !1;
function Im(t, e, n) {
    if (W0) return;
    W0 = !0;
    let o = [
        e,
        ...n
    ], r = o.length > 12 ? [
        ...o.slice(0, 6),
        `\u2026${o.length - 9} more\u2026`,
        ...o.slice(-3)
    ] : o;
}
function g6(t) {
    try {
        return JSON.stringify(t);
    } catch  {
        let n = [], o = 0;
        return JSON.stringify(t, function(r, s) {
            if (!s || typeof s != "object") return s;
            for(; n.length && n[n.length - 1] !== this;)n.pop();
            if (!(n.length && (n.includes(s) || !G1(s) || n.length > V0 || ++o > z0))) return n.push(s), s;
        });
    }
}
function m6(t, e, n, o) {
    let r = g6(e), s = t.indexOf(":hover") !== -1 || r.indexOf(":hover") !== -1, i = s && Y0(), a = (n ? n + "" : "") + t + r + (s && !i ? "rawhover" : "") + (o ? "state" : ""), c = Sc.get(a);
    if (c) {
        let S = j1.get(c);
        if (S) for(let w = 0; w < S.length; w += 2)mn(S[w], void 0, "atomic", void 0, S[w + 1]);
        return c;
    }
    c = n ? `_${n}_c${Fm(a)}` : `_c${Fm(a)}`;
    let l = o ? `.${c}.${c}` : `.${c}`, f = h6(t) ? `${l}.${c}` : l, u = "", d = [], p = (S)=>typeof S == "string" && (S.indexOf("{") !== -1 || S.indexOf("}") !== -1), g = new Set, h = 0, m = (S, w)=>{
        g.add(w);
        let _ = "", x = Object.keys(w);
        for(let A = 0; A < x.length; A++){
            let O = x[A], C = w[O];
            if (C != null) {
                if (typeof C == "object") {
                    let N = [
                        ...S,
                        O
                    ];
                    g.has(C) ? Im("a style value that loops back to one of its own ancestors", t, N) : G1(C) ? N.length > V0 ? Im(`a style block nested more than ${V0} levels deep`, t, N) : ++h > z0 ? Im(`a style object with more than ${z0} nested blocks`, t, N) : m(N, C) : Im(`a ${Object.prototype.toString.call(C).slice(8, -1)} (not a style block)`, t, N);
                } else {
                    if (p(C)) continue;
                    _ += Si(Re(O), C);
                }
            }
        }
        g.delete(w), _ && (S.length === 0 ? u += _ : d.push({
            chain: S,
            body: _
        }));
    };
    m([], e);
    let y = (S)=>S.startsWith(":") || S.startsWith("["), b = (S, w = !0)=>{
        let _ = w && S.length === 1 ? f : l;
        if (!S.length) return _;
        let x = Zo(S[0]).map((A)=>A.includes("&") ? A.replace(/&/g, _) : y(A) ? `${_}${A}` : `${_} ${A}`);
        for(let A = 1; A < S.length; A++){
            let O = Zo(S[A]), C = [];
            for (let N of x)for (let I of O)I.includes("&") ? C.push(I.replace(/&/g, N)) : y(I) ? C.push(N + I) : C.push(N + " " + I);
            x = C;
        }
        return x.join(", ");
    }, T = [], v = (S, w)=>{
        let _ = S.filter(wc), x = b(S.filter((C)=>!wc(C)), _.length === 0), A = `${x}{${w}}`;
        for(let C = _.length - 1; C >= 0; C--)A = `${_[C]}{${A}}`;
        A = Xo(A, x, i);
        let O = Z0(A, void 0, "atomic");
        T.push(A, O), mn(A, void 0, "atomic", void 0, O);
    };
    u && v([
        t
    ], u);
    for (let S of d)v([
        t,
        ...S.chain
    ], S.body);
    return j1.set(c, T), Sc.set(a, c), c;
}
var cd = null;
function ud(t) {
    let e = cd, n = [];
    cd = n;
    try {
        t();
    } finally{
        cd = e;
    }
    return n;
}
function dd(t) {
    if (!Array.isArray(t)) return;
    tT();
    let e = 0;
    for (let n of t){
        if (!Array.isArray(n) || typeof n[0] != "string") continue;
        let o = n[1] || "global";
        o === "variable" && e++, mn(n[0], void 0, o, void 0, n[2] || void 0);
    }
    e > 0 && N0(e);
}
function Lt(t) {
    if (t == null || typeof t != "string" && typeof t != "object") return;
    if (tT(), typeof t == "string") {
        let s = t.indexOf("--") !== -1;
        mn(t, void 0, s ? "variable" : "global"), s && N0(1);
        return;
    }
    let e = Y0(), n = 0, o = Object.keys(t), r = (s)=>{
        let i = s.match(/max-width:\s*(\d+)/);
        return i ? parseInt(i[1]) : 0;
    };
    o.sort((s, i)=>{
        let a = s.startsWith("@media"), c = i.startsWith("@media");
        return !a && !c ? 0 : a ? c ? r(i) - r(s) : 1 : -1;
    });
    for (let s of o){
        let i = t[s];
        if (s.startsWith("@keyframes")) {
            let a = F0(i);
            a && mn(`${s}{${a}}`, void 0, "keyframes");
            continue;
        }
        if (wc(s)) for(let a in i){
            let c = i[a];
            if (a.startsWith("@keyframes")) {
                let l = F0(c);
                l && mn(`${s}{${a}{${l}}}`, void 0, "keyframes");
                continue;
            }
            if (typeof c == "object" && c !== null) {
                let l = "", f = 0, u = a.charCodeAt(0) === 64;
                for(let d in c){
                    let p = c[d];
                    p != null && (u && typeof p == "object" || (bc(d) && f++, l += Si(Re(d), p)));
                }
                u && (l += L1(c)), n += f, mn(Xo(`${s}{${a}{${l}}}`, a, e), void 0, f ? "variable" : "global");
            } else if (c != null) {
                let l = bc(a);
                l && n++, mn(`${s}{${Si(Re(a), c)}}`, void 0, l ? "variable" : "global");
            }
        }
        else {
            let a = "", c = !1, l = 0, f = s.charCodeAt(0) === 64;
            for(let u in i){
                let d = i[u];
                if (d != null) {
                    if (typeof d == "object") {
                        if (f && $0(u)) continue;
                        c = !0;
                    } else bc(u) && l++, a += Si(Re(u), d);
                }
            }
            if (f && (a += L1(i)), n += l, a && mn(Xo(`${s}{${a}}`, s, e), void 0, l ? "variable" : "global"), c) {
                let u = [], d = [];
                for(let p in i)if (typeof i[p] == "object" && i[p] !== null) {
                    if (f && $0(p)) continue;
                    wc(p) ? u.push(p) : d.push(p);
                }
                u.sort((p, g)=>{
                    let h = (m)=>{
                        let y = m.match(/max-width:\s*(\d+)/);
                        return y ? parseInt(y[1]) : 0;
                    };
                    return h(g) - h(p);
                });
                for (let p of d)Lt({
                    [`${s} ${p}`]: i[p]
                });
                for (let p of u)Lt({
                    [p]: {
                        [s]: i[p]
                    }
                });
            }
        }
    }
    n > 0 && N0(n);
}
function xc(t, e) {
    return mn(`@keyframes ${t}{${F0(e)}}`, void 0, "keyframes"), t;
}
function q1() {
    Sc.clear(), X0.clear(), U1 = null, W0 = !1;
}
function eT() {
    return Sc.size;
}
var Y1 = "3.14.880";
var Uy = /*@__PURE__*/ F({}, {
    DELEGATED_EVENTS: ()=>kc,
    LIFECYCLE_EVENTS: ()=>uo,
    MIXINS: ()=>Hm,
    MOUNT_YIELD_BUDGET_MS: ()=>Li,
    NON_BUBBLING_EVENTS: ()=>Vm,
    REGISTRY: ()=>Kt,
    SVG_TAGS: ()=>Rc,
    addDelegatedEvent: ()=>pd,
    addMethods: ()=>Ic,
    adoptHydrationNode: ()=>PE,
    applyExtends: ()=>vc,
    attachElement: ()=>qr,
    cacheNode: ()=>Hr,
    create: ()=>Gt,
    createHTMLNode: ()=>Cc,
    detectTag: ()=>Hn,
    dispose: ()=>Sn,
    dropMountWork: ()=>zd,
    elementPath: ()=>an,
    flushMounts: ()=>Uc,
    globalEventKeyInfo: ()=>qm,
    holdMountFlush: ()=>Ri,
    inertOutsidePlugin: ()=>Zc,
    isSvgTag: ()=>Un,
    isValidTag: ()=>Oc,
    mountIdle: ()=>Qr,
    mountPending: ()=>Ly,
    mountYieldBudget: ()=>wo,
    refreshContextProto: ()=>Mc,
    registerEvent: ()=>Tc,
    registerGlobalEvent: ()=>Ym,
    releaseMount: ()=>Xe,
    remove: ()=>Pc,
    removeDelegatedEvent: ()=>hd,
    replaceRecord: ()=>vy,
    settleBuiltAttributes: ()=>Xr,
    update: ()=>Lc,
    whenConnected: ()=>jn,
    whenMountIdle: ()=>ae,
    whenMounted: ()=>Gn,
    yieldToMain: ()=>xo
});
var Q = {
    viewEvents: null,
    chains: null,
    rows: null,
    hydration: null,
    mount: null,
    containerVw: null,
    faceWait: null
}, jr = {
    bridge: null
};
var Kt = new Set([
    "extends",
    "children",
    "content",
    "childrenAs",
    "childExtends",
    "childExtendsRecursive",
    "childProps",
    "inheritParentProps",
    "state",
    "if",
    "deferUntil",
    "define",
    "deps",
    "tag",
    "attr",
    "style",
    "text",
    "html",
    "value",
    "data",
    "classlist",
    "class",
    "vars",
    "scope",
    "root",
    "context",
    "$router",
    "routes",
    "fetch",
    "variables",
    "query",
    "key",
    "component",
    "preventContentUpdate",
    "preventContentRecreate",
    "subscribeTo",
    "autoGrow",
    "faceWait",
    "srcObject",
    "allowRuntimeTemplates",
    "__name",
    "__ref",
    "__hash",
    "__text",
    "parent",
    "node"
]), Hm = {
    text: "text",
    html: "html",
    style: "style",
    attr: "attr",
    data: "data",
    classlist: "classlist",
    state: "state",
    scope: "scope"
}, uo = new Set([
    "start",
    "init",
    "complete",
    "attachNode",
    "stateInit",
    "stateCreated",
    "beforeUpdate",
    "update",
    "afterUpdate",
    "beforeClassAssign",
    "lazyLoad",
    "render",
    "renderRouter",
    "done",
    "create",
    "frame",
    "mounted",
    "contentUpdate",
    "startUpdate",
    "stateUpdate",
    "beforeStateUpdate",
    "initInspect",
    "initSync",
    "beforeRemove",
    "remove",
    "bridgeMount",
    "bridgeUpdate",
    "bridgeDestroy"
]), Vm = new Set([
    "load",
    "error",
    "abort",
    "scroll",
    "canplay",
    "canplaythrough",
    "ended",
    "pause",
    "play",
    "playing",
    "ratechange",
    "seeked",
    "seeking",
    "stalled",
    "suspend",
    "timeupdate",
    "volumechange",
    "waiting",
    "durationchange",
    "loadeddata",
    "loadedmetadata",
    "progress",
    "emptied",
    "resize"
]), zm = new Set([
    "wheel",
    "mousewheel",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel"
]), kc = new Set([
    "click",
    "dblclick",
    "mousedown",
    "mouseup",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "mouseover",
    "mouseout",
    "pointerdown",
    "pointerup",
    "pointermove",
    "pointerenter",
    "pointerleave",
    "pointerover",
    "pointerout",
    "touchstart",
    "touchend",
    "touchmove",
    "keydown",
    "keyup",
    "keypress",
    "input",
    "change",
    "submit",
    "reset",
    "focus",
    "blur",
    "focusin",
    "focusout",
    "wheel",
    "contextmenu",
    "drag",
    "dragstart",
    "dragend",
    "dragenter",
    "dragleave",
    "dragover",
    "drop"
]);
var wi = new Set;
function Qo(t) {
    let e = t && t.node;
    if (!e) return !1;
    let n = e.nodeType === 11 ? t.__ref?.__fragmentAnchor : e;
    return n ? n.isConnected !== !1 : !1;
}
function jn(t, e) {
    let n = t && t.node, o = t && t.__ref;
    if (!(!n || !o || typeof e != "function")) {
        if (Qo(t)) {
            e(t);
            return;
        }
        (o.__onConnected || (o.__onConnected = [])).push(e), wi.add(t);
    }
}
function Wm() {
    if (wi.size) for (let t of wi){
        let e = t.__ref, n = t.node;
        if (!e || !n) {
            wi.delete(t);
            continue;
        }
        if (!Qo(t)) continue;
        wi.delete(t);
        let o = e.__onConnected;
        if (e.__onConnected = null, !!o) for(let r = 0; r < o.length; r++)try {
            o[r](t);
        } catch (s) {
            typeof console < "u" && console.error && console.error("[smbls] whenConnected callback failed:", s?.message || s);
        }
    }
}
function X1(t) {
    wi.size && wi.delete(t) && t.__ref && (t.__ref.__onConnected = null);
}
var rT = new WeakMap, y6 = {
    passive: !0
}, _6 = {
    passive: !0,
    capture: !0
}, tP = (t, e)=>zm.has(t) ? e ? _6 : y6 : e || !1;
function eP(t) {
    let e = rT.get(t);
    return e || (e = {
        handlers: new Map,
        installed: new Set
    }, rT.set(t, e)), e;
}
function b6(t, e) {
    let n = eP(e);
    if (n.installed.has(t)) return;
    n.installed.add(t);
    let o = t === "focus" || t === "blur" || t === "focusin" || t === "focusout" || t === "mouseenter" || t === "mouseleave" || t === "pointerenter" || t === "pointerleave", r = t === "mouseenter" || t === "mouseleave" || t === "pointerenter" || t === "pointerleave";
    e.addEventListener(t, (s)=>{
        if (r) {
            let a = s.target, c = n.handlers.get(t), l = c && a ? c.get(a) : null;
            if (!l || s.relatedTarget && typeof a.contains == "function" && a.contains(s.relatedTarget)) return;
            l(s);
            return;
        }
        let i = s.target;
        for(; i && i !== e;){
            let a = n.handlers.get(t);
            if (a) {
                let c = a.get(i);
                if (c && (c(s), s.cancelBubble)) return;
            }
            i = i.parentNode;
        }
    }, tP(t, o));
}
function pd(t, e, n, o) {
    o || (o = e.ownerDocument?.documentElement || e.getRootNode());
    let r = eP(o);
    b6(t, o), r.handlers.has(t) || r.handlers.set(t, new WeakMap), r.handlers.get(t).set(e, n);
}
function hd(t, e, n) {
    n || (n = e.ownerDocument?.documentElement || e.getRootNode());
    let o = rT.get(n);
    if (!o) return;
    let r = o.handlers.get(t);
    r && r.delete(e);
}
function yn(t) {
    if (t.charCodeAt(0) !== 111 || t.charCodeAt(1) !== 110) return !1;
    let e = t.charCodeAt(2);
    return e >= 65 && e <= 90;
}
function Km(t) {
    return t.charAt(2).toLowerCase() + t.slice(3);
}
var S6 = /^[A-Za-z_$][\w$]*$/;
function gd(t, e) {
    return typeof e != "string" || !S6.test(e) ? e : function(o) {
        return t.call(e, o);
    };
}
function w6(t) {
    return kc.has(t) && !uo.has(t);
}
function Gm(t, e) {
    let { context: n } = t, o = n?.designSystem;
    return (r)=>{
        o && pt(o);
        try {
            let s = e.call(t, r, t, t.state, n);
            if (s && typeof s.then == "function") {
                s.catch((i)=>{
                    t.error = i, console.error("[DOMQL] Async event error:", i);
                }).finally(()=>{
                    o && ut();
                });
                return;
            }
        } catch (s) {
            if (t.error = s, console.error("[DOMQL] Event error:", s), n?.strictMode) throw s;
        }
        o && ut();
    };
}
var nP = (t)=>!!t && (t.capture === !0 || typeof t.passive == "boolean" || t.once === !0);
function x6(t, e) {
    return nP(e) ? {
        capture: e.capture === !0,
        passive: typeof e.passive == "boolean" ? e.passive : zm.has(t),
        once: e.once === !0
    } : tP(t, !1);
}
function k6(t, e, n) {
    return (o)=>{
        let r = o.target;
        if (r && r.nodeType !== 1 && (r = r.parentElement), !r || typeof r.closest != "function") return;
        let s;
        try {
            s = r.closest(e);
        } catch  {
            return;
        }
        s && t.contains(s) && n(o);
    };
}
function Tc(t, e, n, o) {
    let { node: r, context: s } = e;
    if (!r) return;
    let i = Gm(e, n), a = o && typeof o.selector == "string" && o.selector;
    a && (i = k6(r, a, i));
    let l = !Vm.has(t) && w6(t) && !nP(o), f = l ? null : x6(t, o);
    if (l) {
        let u = s?.rootNode || r.ownerDocument?.documentElement;
        pd(t, r, i, u);
    } else r.addEventListener(t, i, f);
    e.__ref.__eventCleanup || (e.__ref.__eventCleanup = []), e.__ref.__eventCleanup.push(()=>{
        if (l) {
            let u = s?.rootNode || r.ownerDocument?.documentElement;
            hd(t, r, u);
        } else r.removeEventListener(t, i, f);
    });
}
var nT = [
    [
        "onDocument",
        "document"
    ],
    [
        "onWindow",
        "window"
    ],
    [
        "onVisualViewport",
        "visualViewport"
    ],
    [
        "onMediaQuery",
        "mediaQuery"
    ]
];
function qm(t) {
    if (typeof t != "string") return null;
    for(let e = 0; e < nT.length; e++){
        let n = nT[e][0];
        if (t.length <= n.length || !t.startsWith(n)) continue;
        let o = t.charCodeAt(n.length);
        if (!(o < 65 || o > 90)) return {
            target: nT[e][1],
            eventName: t.slice(n.length).toLowerCase()
        };
    }
    return null;
}
function T6(t, e, n) {
    let o = e, r = !1, s, i = !1, a = null;
    return e && typeof e == "object" && typeof e != "function" && (o = e.handler, r = !!e.capture, i = !!e.once, typeof e.passive == "boolean" && (s = e.passive), typeof e.query == "string" && (a = e.query)), o = gd(t, o), typeof o != "function" ? null : (s === void 0 && (s = zm.has(n)), {
        handler: o,
        capture: r,
        passive: s,
        once: i,
        query: a
    });
}
function E6(t, e, n) {
    let o = t.node?.ownerDocument || t.context?.document || (typeof document < "u" ? document : null);
    if (!o || typeof o.addEventListener != "function") return null;
    if (e === "document") return o;
    let r = o.defaultView || (typeof window < "u" ? window : null);
    if (!r) return null;
    if (e === "window") return typeof r.addEventListener == "function" ? r : null;
    if (e === "visualViewport") {
        let s = r.visualViewport;
        return s && typeof s.addEventListener == "function" ? s : null;
    }
    if (e === "mediaQuery") {
        let s = n && n.query;
        if (typeof s != "string" || !s.trim() || typeof r.matchMedia != "function") return null;
        try {
            return r.matchMedia(s) || null;
        } catch  {
            return null;
        }
    }
    return null;
}
var oT = /^@media\s+/i, A6 = /^[@[.#&:>*~+]/, Z1 = new Set;
function Q1(t, e) {}
function v6(t, e) {
    if (typeof e != "string") return null;
    let n = e.trim();
    if (!n) return null;
    let o = t.context?.designSystem?.media, r = (i)=>{
        let a = o && typeof o == "object" ? o[i] : void 0;
        return typeof a == "string" && a.trim() ? a.trim() : null;
    }, s = n;
    if (n.charCodeAt(0) === 64 && !oT.test(n)) {
        if (s = r(n.slice(1)), !s) return Q1(n, "is not a key of designSystem.media"), null;
    } else s = r(n) || n;
    return oT.test(s) ? s.replace(oT, "").trim() || null : A6.test(s) ? (Q1(n, `names "${s}", which is not a media query`), null) : s;
}
function O6(t, e, n, o) {
    try {
        return t.addEventListener(e, n, o), !0;
    } catch  {
        return typeof t.addListener == "function" ? (t.addListener(n), !0) : !1;
    }
}
function oP(t, e, n, o) {
    try {
        t.removeEventListener(e, n, o);
    } catch  {
        typeof t.removeListener == "function" && t.removeListener(n);
    }
}
function Ym(t, e, n) {
    if (e.__ref) {
        if (Array.isArray(n)) {
            if (t.target !== "mediaQuery") return;
            for(let r = 0; r < n.length; r++)J1(t, e, n[r]);
            return;
        }
        J1(t, e, n);
    }
}
function J1(t, e, n) {
    let o = e.__ref, r = T6(e, n, t.eventName);
    if (!r || t.target === "mediaQuery" && t.eventName !== "change" || t.target === "mediaQuery" && (r.query = v6(e, r.query), !r.query)) return;
    let s = E6(e, t.target, r);
    if (!s) return;
    let i = t.target + ":" + (r.query ? r.query + ":" : "") + t.eventName + ":" + (r.capture ? 1 : 0);
    if (o.__globalEvents && o.__globalEvents.has(i)) return;
    let a = Gm(e, r.handler), c = t.target === "window" && t.eventName === "load", l = !1, f = (p)=>{
        if (Qo(e)) {
            if (c) {
                if (l) return;
                l = !0;
            }
            a(p);
        }
    }, u = {
        capture: r.capture,
        passive: r.passive,
        once: r.once
    };
    if (!O6(s, t.eventName, f, u)) return;
    o.__globalEvents || (o.__globalEvents = new Map);
    let d = {
        target: s,
        eventName: t.eventName,
        listener: f,
        options: u
    };
    o.__globalEvents.set(i, d), o.__eventCleanup || (o.__eventCleanup = []), o.__eventCleanup.push(()=>{
        oP(s, t.eventName, f, u), o.__globalEvents && o.__globalEvents.delete(i);
    }), c && C6(e, i, d, ()=>l);
}
function C6(t, e, n, o) {
    let r = n.target.document;
    !r || r.readyState !== "complete" || jn(t, ()=>queueMicrotask(()=>{
            let s = t.__ref;
            if (o() || !s || !s.__globalEvents || s.__globalEvents.get(e) !== n) return;
            let i = n.target, a = typeof i.Event == "function" ? i.Event : typeof Event == "function" ? Event : null;
            a && (n.listener(new a("load")), n.options.once && o() && oP(i, "load", n.listener, n.options));
        }));
}
var sT = Symbol("handlerChain.none"), R6 = new Set([
    "inView",
    "leaveView"
]), D6 = new Set([
    "bridgeMount",
    "bridgeUpdate",
    "bridgeDestroy"
]), Ec = new WeakMap, rP = new WeakMap, lT = !1, iT = (t)=>t !== null && typeof t == "object" && t.always === !0;
function L6(t) {
    let e = Km(t);
    return R6.has(e) ? !0 : uo.has(e) && !D6.has(e);
}
var sP = new Set;
function P6(t) {
    sP.has(t);
}
function aT(t) {
    return t && typeof t == "object" ? {
        handler: t.handler,
        options: t
    } : {
        handler: t,
        options: null
    };
}
function md(t, e) {
    let n = {
        always: t,
        own: e,
        list: e ? t.concat(e) : t,
        next: null,
        prims: null,
        cleared: null
    }, o = function(...s) {
        return B6(n, this, s);
    };
    return Ec.set(o, n), lT = !0, o;
}
function cT(t) {
    let e = rP.get(t);
    return e || (e = md([
        aT(t)
    ], null), rP.set(t, e)), e;
}
function I6(t, e) {
    let n = Ec.get(t);
    if (e == null || e === !1) return n.own ? n.cleared || (n.cleared = md(n.always, null)) : t;
    if (typeof e != "object" && typeof e != "function") {
        let i = n.prims || (n.prims = new Map), a = i.get(e);
        return a || i.set(e, a = md(n.always, aT(e))), a;
    }
    let o = n.next || (n.next = new WeakMap), r = o.get(e);
    if (r) return r;
    let s = iT(e) ? Ec.get(cT(e)) : typeof e == "function" ? Ec.get(e) : void 0;
    return r = s ? md(n.always.concat(s.always), s.own) : md(n.always, aT(e)), o.set(e, r), r;
}
function M6(t, e, n) {
    let o = iT(e), r = !o && lT && typeof e == "function" && Ec.has(e);
    if (!o && !r && !iT(n)) return sT;
    if (!L6(t)) return P6(t), sT;
    let s = o ? cT(e) : r ? e : null;
    return s ? I6(s, n) : cT(n);
}
function iP(t, e, n, o) {
    if (!yn(e)) return !1;
    let r = M6(e, n, o);
    return r === sT ? !1 : (t[e] = r, !0);
}
function fT(t) {
    if (typeof t == "function") {
        let e = lT ? Ec.get(t) : void 0;
        return e ? e.list : [
            {
                handler: t,
                options: null
            }
        ];
    }
    return typeof t == "string" ? [
        {
            handler: t,
            options: null
        }
    ] : t && typeof t == "object" ? [
        {
            handler: t.handler,
            options: t
        }
    ] : [];
}
function B6(t, e, n) {
    let o = t.list, r, s = !1, i = null, a = !1, c;
    for(let l = 0; l < o.length; l++){
        let f = o[l].handler;
        if (typeof f != "function") continue;
        let u;
        try {
            u = f.apply(e, n);
        } catch (d) {
            a ? console.error("[smbls] lifecycle handler error:", d) : (a = !0, c = d);
            continue;
        }
        u === !1 ? s = !0 : u && typeof u.then == "function" && (i || (i = [])).push(u), r = u;
    }
    if (a) {
        if (i) for (let l of i)l.then(null, (f)=>console.error("[smbls] lifecycle handler error:", f));
        throw c;
    }
    return s ? !1 : i ? i.length === 1 ? i[0] : N6(i) : r;
}
function N6(t) {
    return Promise.allSettled(t).then((e)=>{
        let n = null;
        for (let o of e)o.status === "rejected" && (n ? console.error("[smbls] lifecycle handler error:", o.reason) : n = o);
        if (n) throw n.reason;
    });
}
var F6 = 1e-6, aP = new WeakMap;
function $6(t, e, n) {
    let o = t.defaultView, r = o && o.IntersectionObserver;
    if (typeof r != "function") return null;
    let s = aP.get(t);
    s || aP.set(t, s = new Map);
    let i = e + "|" + n, a = s.get(i);
    if (a) return a;
    a = {
        id: i,
        byKey: s,
        threshold: e,
        targets: new Map,
        observer: null
    };
    try {
        let c = n ? {
            threshold: e,
            rootMargin: n
        } : {
            threshold: e
        };
        a.observer = new r((l)=>j6(a, l), c);
    } catch  {
        return null;
    }
    return s.set(i, a), a;
}
function j6(t, e) {
    for(let n = 0; n < e.length; n++){
        let o = e[n], r = t.targets.get(o.target);
        if (!r) continue;
        let s = !!o.isIntersecting && o.intersectionRatio >= t.threshold - F6;
        if (s === r.inView) continue;
        r.inView = s;
        let i = s ? "in" : "leave", a = r.subs.slice();
        for(let c = 0; c < a.length; c++){
            let l = a[c];
            if (!(l.kind !== i || l.dead)) {
                l.once && lP(t, r, l);
                try {
                    l.run(o);
                } catch (f) {
                    U6(f);
                }
            }
        }
    }
}
function U6(t) {
    typeof globalThis.reportError == "function" ? globalThis.reportError(t) : queueMicrotask(()=>{
        throw t;
    });
}
function lP(t, e, n) {
    if (n.dead) return;
    n.dead = !0;
    let o = e.subs.indexOf(n);
    o !== -1 && e.subs.splice(o, 1), !e.subs.length && (t.targets.delete(e.node), t.observer.unobserve(e.node), !t.targets.size && (t.observer.disconnect(), t.byKey.delete(t.id)));
}
function cP(t, e, n, o, r) {
    let s = gd(t, r.handler), i = r.options;
    if (typeof s != "function") return;
    let a = i && i.threshold, c = typeof a == "number" && a >= 0 && a <= 1 ? a : 0, l = i && typeof i.rootMargin == "string" ? i.rootMargin.trim() : "", f = $6(n, c, l);
    if (!f) return;
    let u = f.targets.get(e);
    u || (u = {
        node: e,
        inView: !1,
        subs: []
    }, f.targets.set(e, u), f.observer.observe(e));
    let d = {
        kind: o,
        once: !!(i && i.once === !0),
        run: Gm(t, s),
        dead: !1
    };
    u.subs.push(d);
    let p = t.__ref;
    p.__eventCleanup || (p.__eventCleanup = []), p.__eventCleanup.push(()=>lP(f, u, d));
}
function fP(t) {
    let e = t.node;
    if (!e || e.nodeType !== 1) return;
    let n = e.ownerDocument, o = n && n.defaultView;
    if (!o || typeof o.IntersectionObserver != "function") return;
    let r = fT(t.onInView);
    for(let i = 0; i < r.length; i++)cP(t, e, n, "in", r[i]);
    let s = fT(t.onLeaveView);
    for(let i = 0; i < s.length; i++)cP(t, e, n, "leave", s[i]);
}
function _n(t, e) {
    let n = t && t.context && t.context.designSystem;
    if (!n) return e();
    pt(n);
    try {
        return e();
    } finally{
        ut();
    }
}
var De = hs || ((t)=>{
    let e = $e();
    if (!e) return t();
    Rl(null);
    try {
        return t();
    } finally{
        Rl(e);
    }
});
var hP = [
    "ease",
    "linear",
    "ease-in",
    "ease-out",
    "ease-in-out",
    "step-start",
    "step-end"
], H6 = [
    "none",
    "forwards",
    "backwards",
    "both"
], V6 = [
    "normal",
    "reverse",
    "alternate",
    "alternate-reverse"
], z6 = [
    "running",
    "paused"
], W6 = /^(?:translate(?:3d|x|y|z)?\((?:\s*0[a-z%]*\s*,?)+\)|scale(?:3d|x|y|z)?\((?:\s*1(?:\.0+)?\s*,?)+\)|rotate(?:3d|x|y|z)?\((?:\s*0[a-z%]*\s*,?)+\)|skew(?:x|y)?\((?:\s*0[a-z%]*\s*,?)+\)|matrix\(\s*1\s*,\s*0\s*,\s*0\s*,\s*1\s*,\s*0\s*,\s*0\s*\))$/, K6 = (t)=>{
    let e = String(t).trim().toLowerCase();
    if (e === "" || e === "none" || e === "initial" || e === "unset") return !0;
    let n = e.match(/[a-z0-9]+\([^()]*\)/g);
    return !n || n.join("").replace(/\s+/g, "") !== e.replace(/\s+/g, "") ? !1 : n.every((o)=>W6.test(o.replace(/\s+/g, "")));
}, uP = (t)=>/^(?:\s*0[a-z%]*)+\s*$/.test(String(t).toLowerCase()) || /^(none|initial|unset)$/.test(String(t).trim().toLowerCase()), G6 = {
    transform: K6,
    translate: uP,
    rotate: (t)=>uP(t) || /^\s*(?:[xyz]\s+)?0(?:deg|rad|turn|grad)?\s*$/.test(String(t).toLowerCase()),
    scale: (t)=>/^(none|initial|unset)$/.test(String(t).trim().toLowerCase()) || /^(?:\s*1(?:\.0+)?)+\s*$/.test(String(t)),
    opacity: (t)=>/^(initial|unset)$/.test(String(t).trim().toLowerCase()) || Number(t) === 1
}, q6 = (t)=>{
    let e = String(t).trim().toLowerCase();
    if (e === "from") return 0;
    if (e === "to") return 100;
    let n = e.match(/^(\d+(?:\.\d+)?)%$/);
    return n ? Number(n[1]) : null;
}, Y6 = (t)=>{
    if (!k(t)) return null;
    let e = null, n = -1;
    for(let o in t){
        let r = q6(o);
        r == null || !k(t[o]) || r >= n && (n = r, e = t[o]);
    }
    return e;
}, X6 = (t)=>{
    let e = Y6(t);
    if (!e) return !1;
    let n = Object.keys(e);
    if (!n.length) return !1;
    for (let o of n){
        let r = G6[o];
        if (!r) return !1;
        let s = e[o];
        if (s == null || typeof s == "object" || typeof s == "function" || !r(s)) return !1;
    }
    return !0;
}, Z6 = (t, e)=>{
    if (k(t)) return t;
    let { animation: n } = e.context && e.context.designSystem || {}, o = n && n[t];
    return k(o) ? o : null;
}, Q6 = [
    "reverse",
    "alternate",
    "alternate-reverse"
], gP = (t, e, n)=>{
    let o = n || e.animationDirection;
    return o && Q6.includes(String(o)) ? "both" : X6(Z6(t, e)) ? "backwards" : "both";
}, J6 = 0, dP = new Map, uT = (t, e)=>{
    let { animation: n } = e.context && e.context.designSystem || {};
    if (k(t)) {
        let r = JSON.stringify(t), s = dP.get(r);
        if (s) return s;
        let i = `smbls-anim-${J6++}`, a = xc(i, t);
        return dP.set(r, a), a;
    }
    let o = n && n[t];
    return k(o) ? xc(t, o) : t;
}, mP = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)m?s$/i, t9 = /^(?:\d+(?:\.\d*)?|\.\d+)$/, yP = /^(?:cubic-bezier|steps|linear)\(/, e9 = /^(?:calc|min|max|clamp)\(/, n9 = (t)=>t.includes("(") || t.startsWith("--"), o9 = (t, e)=>{
    if (!$n.test(t)) return !1;
    let n = e && e.sequence;
    if (!k(n)) return !1;
    let o = t.charCodeAt(0) === 45 ? t.slice(1) : t;
    return !!(n[o] || o.length === 2 && n[o[0]]);
}, r9 = (t)=>{
    if (!E(t)) return !1;
    let e = t.trim();
    return hP.includes(e) || yP.test(e) || e.startsWith("var(");
}, s9 = (t, e)=>!!e && r9(e[t] || e[Bo(t)]), i9 = [
    "duration",
    "timingFunction",
    "delay",
    "iterationCount",
    "direction",
    "fillMode",
    "playState"
], a9 = (t)=>at(String(t)), c9 = (t, e, n)=>{
    let o = {
        duration: null,
        delay: null,
        timingFunction: null,
        iterationCount: null,
        direction: null,
        fillMode: null,
        playState: null
    }, r = null, s = [], i = [], a = (u, d)=>o[u] != null ? !1 : (o[u] = d, !0), c = (u, d)=>{
        a(u, d) || s.push(d);
    };
    for (let u of a9(t))e && e[u] ? r = u : mP.test(u) || o9(u, n) ? a("duration", u) || a("delay", u) : hP.includes(u) || s9(u, n) ? c("timingFunction", u) : yP.test(u) ? a("timingFunction", u) : u === "infinite" ? c("iterationCount", u) : t9.test(u) ? a("iterationCount", Number(u)) : V6.includes(u) ? c("direction", u) : H6.includes(u) ? c("fillMode", u) : z6.includes(u) ? c("playState", u) : n9(u) ? i.push(u) : s.push(u);
    let l = r || s[0] || i.shift() || null, f = new Set;
    for (let u of i){
        let d = i9.find((p)=>o[p] == null);
        if (!d) break;
        o[d] = u.startsWith("--") ? `var(${u})` : u, f.add(d);
    }
    return {
        name: l,
        ...o,
        opaqueSlots: f
    };
}, l9 = (t, e)=>{
    let { animation: n } = e.context && e.context.designSystem || {}, { timing: o } = L() || {};
    return Nn(String(t)).map((r)=>r.trim()).filter(Boolean).map((r)=>c9(r, n, o));
}, pP = (t, e)=>mP.test(t) || e && !e9.test(t) && !/^(?:var|env)\(/.test(t) ? t : Ae(t).timing || t, f9 = (t, e)=>{
    let n = (o)=>t.opaqueSlots.has(o);
    return {
        animationName: t.name == null ? void 0 : uT(t.name, e),
        animationDuration: t.duration != null ? pP(t.duration, n("duration")) : Ae(e.animationDuration || "A").timing,
        animationDelay: t.delay != null ? pP(t.delay, n("delay")) : Ae(e.animationDelay || "0s").timing,
        animationTimingFunction: t.timingFunction != null ? n("timingFunction") ? t.timingFunction : We(t.timingFunction) : We(e.animationTimingFunction || "ease"),
        animationFillMode: t.fillMode || e.animationFillMode || gP(t.name, e, t.direction),
        animationIterationCount: t.iterationCount != null ? t.iterationCount : e.animationIterationCount || 1,
        animationPlayState: t.playState || e.animationPlayState,
        animationDirection: t.direction || e.animationDirection
    };
}, u9 = {
    animationName: "none",
    animationPlayState: "running",
    animationDirection: "normal"
}, d9 = (t, e)=>{
    let n = t.map((r)=>f9(r, e));
    if (n.length === 1) return n[0];
    let o = {};
    for(let r in n[0]){
        let s = n.map((i)=>i[r]);
        s.every((i)=>i == null) || (o[r] = s.map((i)=>i ?? u9[r]).join(", "));
    }
    return o;
}, dT = {
    animation: (t, e)=>{
        if (t != null) {
            if (E(t) && /[\s,]/.test(t)) {
                let n = l9(t, e);
                if (n.length) return d9(n, e);
            }
            return {
                animationName: uT(t, e),
                animationDuration: Ae(e.animationDuration || "A").timing,
                animationDelay: Ae(e.animationDelay || "0s").timing,
                animationTimingFunction: We(e.animationTimingFunction || "ease"),
                animationFillMode: e.animationFillMode || gP(t, e),
                animationIterationCount: e.animationIterationCount || 1,
                animationPlayState: e.animationPlayState,
                animationDirection: e.animationDirection
            };
        }
    },
    animationName: (t, e)=>({
            animationName: uT(t, e)
        }),
    animationDuration: (t)=>({
            animationDuration: Ae(t).timing
        }),
    animationDelay: (t)=>({
            animationDelay: Ae(t).timing
        }),
    animationTimingFunction: (t)=>({
            animationTimingFunction: We(t)
        }),
    animationIterationCount: (t)=>({
            animationIterationCount: t
        }),
    animationFillMode: (t)=>({
            animationFillMode: t
        }),
    animationPlayState: (t)=>({
            animationPlayState: t
        }),
    animationDirection: (t)=>({
            animationDirection: t
        })
};
var Xm = (t, e, n)=>{
    if (typeof e == "number" && (e = String(e)), !E(e)) return;
    let [o, r] = at(e);
    return {
        ...$(t + "Start", o, n),
        ...$(t + "End", r || o, n)
    };
}, pT = {
    show: (t)=>t ? void 0 : {
            display: "none !important"
        },
    hide: (t)=>t ? {
            display: "none !important"
        } : void 0,
    height: (t, e)=>$("height", t, e),
    width: (t, e)=>$("width", t, e),
    boxSizing: (t)=>Xt(t) ? {
            boxSizing: "border-box"
        } : {
            boxSizing: t
        },
    boxSize: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("height", e),
            ...It("width", n || e)
        };
    },
    inlineSize: (t, e)=>$("inlineSize", t, e),
    blockSize: (t, e)=>$("blockSize", t, e),
    minWidth: (t, e)=>$("minWidth", t, e),
    maxWidth: (t, e)=>$("maxWidth", t, e),
    widthRange: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("minWidth", e),
            ...It("maxWidth", n || e)
        };
    },
    minHeight: (t, e)=>$("minHeight", t, e),
    maxHeight: (t, e)=>$("maxHeight", t, e),
    heightRange: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("minHeight", e),
            ...It("maxHeight", n || e)
        };
    },
    size: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...$("inlineSize", e),
            ...$("blockSize", n || e)
        };
    },
    minBlockSize: (t, e)=>$("minBlockSize", t, e),
    minInlineSize: (t, e)=>$("minInlineSize", t, e),
    maxBlockSize: (t, e)=>$("maxBlockSize", t, e),
    maxInlineSize: (t, e)=>$("maxInlineSize", t, e),
    minSize: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("minInlineSize", e),
            ...It("minBlockSize", n || e)
        };
    },
    maxSize: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("maxInlineSize", e),
            ...It("maxBlockSize", n || e)
        };
    },
    borderWidth: (t, e)=>$("borderWidth", t, e),
    borderTopWidth: (t, e)=>$("borderTopWidth", t, e),
    borderRightWidth: (t, e)=>$("borderRightWidth", t, e),
    borderBottomWidth: (t, e)=>$("borderBottomWidth", t, e),
    borderLeftWidth: (t, e)=>$("borderLeftWidth", t, e),
    textDecorationThickness: (t, e)=>$("textDecorationThickness", t, e),
    textUnderlineOffset: (t, e)=>$("textUnderlineOffset", t, e),
    padding: (t, e)=>$("padding", t, e),
    paddingInline: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("paddingInlineStart", e),
            ...It("paddingInlineEnd", n || e)
        };
    },
    paddingBlock: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("paddingBlockStart", e),
            ...It("paddingBlockEnd", n || e)
        };
    },
    paddingTop: (t, e)=>$("paddingBlockStart", t, e),
    paddingBottom: (t, e)=>$("paddingBlockEnd", t, e),
    paddingLeft: (t, e)=>$("paddingInlineStart", t, e),
    paddingRight: (t, e)=>$("paddingInlineEnd", t, e),
    paddingBlockStart: (t, e)=>$("paddingBlockStart", t, e),
    paddingBlockEnd: (t, e)=>$("paddingBlockEnd", t, e),
    paddingInlineStart: (t, e)=>$("paddingInlineStart", t, e),
    paddingInlineEnd: (t, e)=>$("paddingInlineEnd", t, e),
    margin: (t, e)=>$("margin", t, e),
    marginInline: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("marginInlineStart", e),
            ...It("marginInlineEnd", n || e)
        };
    },
    marginBlock: (t)=>{
        if (!E(t)) return;
        let [e, n] = at(t);
        return {
            ...It("marginBlockStart", e),
            ...It("marginBlockEnd", n || e)
        };
    },
    marginTop: (t, e)=>$("marginBlockStart", t, e),
    marginBottom: (t, e)=>$("marginBlockEnd", t, e),
    marginLeft: (t, e)=>$("marginInlineStart", t, e),
    marginRight: (t, e)=>$("marginInlineEnd", t, e),
    marginInlineStart: (t, e)=>$("marginInlineStart", t, e),
    marginInlineEnd: (t, e)=>$("marginInlineEnd", t, e),
    marginBlockStart: (t, e)=>$("marginBlockStart", t, e),
    marginBlockEnd: (t, e)=>$("marginBlockEnd", t, e),
    scrollMargin: (t, e)=>$("scrollMargin", t, e),
    scrollMarginTop: (t, e)=>$("scrollMarginTop", t, e),
    scrollMarginRight: (t, e)=>$("scrollMarginRight", t, e),
    scrollMarginBottom: (t, e)=>$("scrollMarginBottom", t, e),
    scrollMarginLeft: (t, e)=>$("scrollMarginLeft", t, e),
    scrollMarginBlock: (t, e)=>Xm("scrollMarginBlock", t, e),
    scrollMarginInline: (t, e)=>Xm("scrollMarginInline", t, e),
    scrollMarginBlockStart: (t, e)=>$("scrollMarginBlockStart", t, e),
    scrollMarginBlockEnd: (t, e)=>$("scrollMarginBlockEnd", t, e),
    scrollMarginInlineStart: (t, e)=>$("scrollMarginInlineStart", t, e),
    scrollMarginInlineEnd: (t, e)=>$("scrollMarginInlineEnd", t, e),
    scrollPadding: (t, e)=>$("scrollPadding", t, e),
    scrollPaddingTop: (t, e)=>$("scrollPaddingTop", t, e),
    scrollPaddingRight: (t, e)=>$("scrollPaddingRight", t, e),
    scrollPaddingBottom: (t, e)=>$("scrollPaddingBottom", t, e),
    scrollPaddingLeft: (t, e)=>$("scrollPaddingLeft", t, e),
    scrollPaddingBlock: (t, e)=>Xm("scrollPaddingBlock", t, e),
    scrollPaddingInline: (t, e)=>Xm("scrollPaddingInline", t, e),
    scrollPaddingBlockStart: (t, e)=>$("scrollPaddingBlockStart", t, e),
    scrollPaddingBlockEnd: (t, e)=>$("scrollPaddingBlockEnd", t, e),
    scrollPaddingInlineStart: (t, e)=>$("scrollPaddingInlineStart", t, e),
    scrollPaddingInlineEnd: (t, e)=>$("scrollPaddingInlineEnd", t, e),
    gap: (t)=>({
            gap: Tm(t)
        }),
    columnGap: (t, e)=>ze(e, "columnGap", t),
    rowGap: (t, e)=>ze(e, "rowGap", t),
    flexWrap: (t)=>{
        if (t != null) return {
            display: "flex",
            flexWrap: t
        };
    },
    flexFlow: (t, e)=>{
        let n = e.reverse;
        if (!E(t)) return;
        let [o, r] = (t || "row").split(" ");
        return (t.startsWith("x") || t === "row") && (o = "row"), (t.startsWith("y") || t === "column") && (o = "column"), {
            display: "flex",
            flexFlow: (o || "") + (!o.includes("-reverse") && n ? "-reverse" : "") + " " + (r || "")
        };
    },
    flexAlign: (t)=>{
        if (!E(t)) return;
        let [e, n] = t.split(" ");
        return {
            display: "flex",
            alignItems: e,
            justifyContent: n
        };
    },
    round: (t, e)=>Go(t ?? e.borderRadius, e, "round"),
    borderRadius: (t, e)=>Go(t ?? e.round, e, "borderRadius"),
    borderTopLeftRadius: (t, e)=>Go(t, e, "borderTopLeftRadius", "borderTopLeftRadius"),
    borderTopRightRadius: (t, e)=>Go(t, e, "borderTopRightRadius", "borderTopRightRadius"),
    borderBottomLeftRadius: (t, e)=>Go(t, e, "borderBottomLeftRadius", "borderBottomLeftRadius"),
    borderBottomRightRadius: (t, e)=>Go(t, e, "borderBottomRightRadius", "borderBottomRightRadius"),
    backgroundSize: (t, e)=>({
            backgroundSize: _i(t, "backgroundSize", ed, e)
        }),
    backgroundPosition: (t, e)=>({
            backgroundPosition: _i(t, "backgroundPosition", nd, e)
        }),
    maskSize: (t, e)=>({
            maskSize: _i(t, "maskSize", ed, e)
        }),
    maskPosition: (t, e)=>({
            maskPosition: _i(t, "maskPosition", nd, e)
        })
};
var hT = {
    fontSize: (t)=>qu(t) || t,
    fontFamily: (t)=>({
            fontFamily: Ku(t) || t
        }),
    fontWeight: (t)=>({
            fontWeight: t,
            fontVariationSettings: '"wght" ' + t
        }),
    lineClamp: (t)=>{
        if (t != null) return t === "none" ? {
            WebkitLineClamp: "none",
            lineClamp: "none"
        } : {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: String(t),
            lineClamp: String(t),
            overflow: "hidden"
        };
    }
};
var gT = {
    overflow: (t)=>({
            overflow: t
        }),
    cursor: (t, e, n, o)=>{
        if (!t) return;
        let r = o.assets && o.assets[t];
        if (r && r.content) t = `url(${r.content.src})`;
        else {
            let s = o.files && o.files[t];
            s && s.content && (t = `url(${s.content.src})`);
        }
        return {
            cursor: t
        };
    },
    opacity: (t)=>t != null ? {
            opacity: String(t)
        } : void 0,
    visibility: (t)=>t != null ? {
            visibility: t
        } : void 0,
    pointerEvents: (t)=>t != null ? {
            pointerEvents: t
        } : void 0
};
var mT = {
    inset: (t, e)=>{
        if (e.call("isNumber", t)) return {
            inset: t
        };
        if (e.call("isString", t)) return {
            inset: at(t).map((n)=>Ut(n, "k").k).join(" ")
        };
    },
    left: (t)=>Ut(t, "left"),
    top: (t)=>Ut(t, "top"),
    right: (t)=>Ut(t, "right"),
    bottom: (t)=>Ut(t, "bottom"),
    verticalInset: (t)=>{
        if (typeof t != "string") return;
        let e = at(t).map((n)=>Ut(n, "k").k);
        return {
            top: e[0],
            bottom: e[1] || e[0]
        };
    },
    horizontalInset: (t)=>{
        if (typeof t != "string") return;
        let e = at(t).map((n)=>Ut(n, "k").k);
        return {
            left: e[0],
            right: e[1] || e[0]
        };
    }
};
var Zm = 0, Qm = ()=>{
    Zm++;
}, Jm = ()=>{
    Zm > 0 && Zm--;
}, he = ({ context: t, state: e })=>{
    let n = t?.designSystem, o = e?.root?.globalTheme || n?.globalTheme;
    return o && o !== "auto" ? o : Zm > 0 ? null : n && n.resolvedTheme || null;
}, ge = (t, e)=>{
    if (e == null || e === "") return;
    if (!k(e)) return {
        [t]: e
    };
    let n = {}, o = !1;
    for(let r in e){
        let s = e[r];
        if (!(s == null || s === "")) {
            if (k(s)) {
                let i = ge(t, s);
                i && (n[r] = i, o = !0);
                continue;
            }
            n[r] = {
                [t]: s
            }, o = !0;
        }
    }
    return o ? n : void 0;
}, _P = (t)=>{
    let e = {};
    for(let n in t){
        let o = t[n];
        e[n] = k(o) ? _P(o) : E(o) ? o + " !important" : o;
    }
    return e;
}, xi = (t)=>(e, n)=>{
        let o = n && E(e) && !L().useVariable, r = Sm(e, o ? he(n) : null);
        return k(r) ? ge(t, r) : {
            [t]: r
        };
    }, yT = {
    theme: (t, e)=>{
        if (t) return e.themeModifier ? hn(t, `@${e.themeModifier}`) : hn(t);
    },
    color: (t, e)=>{
        let n = he(e);
        if (t) return ge("color", Wt(t, n));
    },
    background: (t, e)=>{
        let n = he(e);
        if (t) return E(t) && t.includes("gradient") && t.includes("(") ? {
            background: Fr(t, n)
        } : ge("background", Wt(t, n));
    },
    backgroundColor: (t, e)=>{
        let n = he(e);
        if (t) return ge("backgroundColor", Wt(t, n));
    },
    backgroundImage: (t, e, n, o)=>{
        let r = he(e);
        if (!t) return;
        let s = o.assets && o.assets[t];
        if (s && s.content) t = s.content.src;
        else {
            let i = o.files && o.files[t];
            i && i.content && (t = i.content.src);
        }
        return ge("backgroundImage", km(t, r));
    },
    textStroke: (t)=>{
        let e = wm(t);
        if (e != null) return {
            WebkitTextStroke: e
        };
    },
    outline: xi("outline"),
    outlineWidth: (t, e)=>$("outlineWidth", t, e),
    outlineColor: (t, e)=>{
        let n = he(e);
        if (t) return ge("outlineColor", Wt(t, n));
    },
    outlineOffset: (t, e)=>$("outlineOffset", t, e),
    border: xi("border"),
    borderColor: (t, e)=>{
        let n = he(e);
        if (t) return ge("borderColor", Wt(t, n));
    },
    borderTopColor: (t, e)=>{
        let n = he(e);
        if (t) return ge("borderTopColor", Wt(t, n));
    },
    borderBottomColor: (t, e)=>{
        let n = he(e);
        if (t) return ge("borderBottomColor", Wt(t, n));
    },
    borderLeftColor: (t, e)=>{
        let n = he(e);
        if (t) return ge("borderLeftColor", Wt(t, n));
    },
    borderRightColor: (t, e)=>{
        let n = he(e);
        if (t) return ge("borderRightColor", Wt(t, n));
    },
    borderLeft: xi("borderLeft"),
    borderTop: xi("borderTop"),
    borderRight: xi("borderRight"),
    borderBottom: xi("borderBottom"),
    shadow: (t, e)=>{
        let n = he(e);
        if (t) return ge("boxShadow", xm(t, n));
    },
    boxShadow: (t, e)=>{
        if (!E(t)) return;
        let [n, o] = t.split("!importan"), r = he(e), s = o ? " !important" : "", i = td(n.trim(), r);
        return E(i) ? {
            boxShadow: i + s
        } : ge("boxShadow", s ? _P(i) : i);
    },
    textShadow: (t, e)=>ge("textShadow", td(t, e ? he(e) : null)),
    columnRule: xi("columnRule")
};
var yd = {
    transition: (t)=>{
        let e = Am(t);
        if (e != null) return {
            transition: e
        };
    },
    transitionDuration: (t)=>({
            transitionDuration: od(t)
        }),
    transitionDelay: (t)=>({
            transitionDelay: od(t)
        }),
    transitionTimingFunction: (t)=>({
            transitionTimingFunction: We(t)
        }),
    transitionProperty: (t)=>({
            transitionProperty: t,
            willChange: t
        })
};
var _T = {
    flow: (t, e)=>{
        let n = e.reverse;
        if (!E(t)) return;
        let [o, r] = (t || "row").split(" ");
        return (t.startsWith("x") || t === "row") && (o = "row"), (t.startsWith("y") || t === "column") && (o = "column"), {
            display: "flex",
            flexFlow: (o || "") + (!o.includes("-reverse") && n ? "-reverse" : "") + " " + (r || "")
        };
    },
    wrap: (t, e)=>{
        if (t != null) return {
            display: "flex",
            flexWrap: t
        };
    },
    align: (t, e)=>{
        if (!E(t)) return;
        let [n, o] = t.split(" ");
        return {
            display: "flex",
            alignItems: n,
            justifyContent: o
        };
    }
};
var p9 = /(^|[^\w.-])([A-Za-z_][\w-]*)/g, bP = (t)=>{
    if (!E(t)) return t;
    let e = L().sizes;
    return e ? t.replace(p9, (n, o, r)=>{
        let s = e[r];
        return s == null ? n : o + String(s);
    }) : t;
}, po = (t)=>bP(Em(t)), bT = {
    gridTemplateColumns: (t)=>({
            gridTemplateColumns: po(t)
        }),
    gridTemplateRows: (t)=>({
            gridTemplateRows: po(t)
        }),
    gridAutoColumns: (t)=>({
            gridAutoColumns: po(t)
        }),
    gridAutoRows: (t)=>({
            gridAutoRows: po(t)
        }),
    area: (t)=>({
            gridArea: t
        }),
    template: (t)=>({
            gridTemplate: t
        }),
    templateAreas: (t)=>({
            gridTemplateAreas: t
        }),
    column: (t)=>({
            gridColumn: t
        }),
    columns: (t)=>({
            gridTemplateColumns: po(t)
        }),
    templateColumns: (t)=>({
            gridTemplateColumns: po(t)
        }),
    autoColumns: (t)=>({
            gridAutoColumns: po(t)
        }),
    columnStart: (t)=>({
            gridColumnStart: t
        }),
    row: (t)=>({
            gridRow: t
        }),
    rows: (t)=>({
            gridTemplateRows: po(t)
        }),
    templateRows: (t)=>({
            gridTemplateRows: po(t)
        }),
    autoRows: (t)=>({
            gridAutoRows: po(t)
        }),
    rowStart: (t)=>({
            gridRowStart: t
        }),
    autoFlow: (t)=>({
            gridAutoFlow: t
        })
};
var SP = "breakpoints", h9 = new Set([
    "window",
    "media"
]), wP = /^-?[A-Za-z_][\w-]*$/, xP = new Set([
    "none",
    "and",
    "or",
    "not",
    "initial",
    "inherit",
    "unset",
    "revert",
    "revert-layer",
    "default"
]), g9 = (t)=>{
    let e = t && t.containerName;
    if (typeof e != "string") return null;
    let n = e.trim().split(/\s+/)[0];
    return n && wP.test(n) && !xP.has(n) ? n : null;
}, Ac = (t, e)=>{
    if (typeof t == "function") try {
        t = t(e, e && e.state, e && e.context);
    } catch  {
        return null;
    }
    if (typeof t != "string") return null;
    let n = t.trim();
    return !n || h9.has(n) ? null : n === "container" ? g9(e) || SP : wP.test(n) && !xP.has(n) ? n : null;
}, m9 = /^@media\s+/i, y9 = /^(?:only\s+)?(?:screen|all)\s+and\s+/i, _9 = /(?:^|[^\w-])(?:(?:min|max)-)?(?:width|inline-size)(?![\w-])/i, b9 = /height|block-size|aspect-ratio|orientation|device-|resolution/i, ST = (t)=>{
    if (typeof t != "string") return null;
    let e = t.trim().replace(m9, "").replace(y9, "").trim();
    if (!e || e.indexOf(",") !== -1) return null;
    let n = e.split(/\s+(?:and|or)\s+/i);
    for (let o of n){
        let r = o.trim();
        if (r.charCodeAt(0) !== 40 || r.charCodeAt(r.length - 1) !== 41) return null;
        let s = r.slice(1, -1);
        if (s.indexOf("(") !== -1 || s.indexOf(")") !== -1 || !_9.test(s) || b9.test(s)) return null;
    }
    return e;
}, wT = {
    breakpointsFrom: (t, e)=>{
        let n = Ac(t, e);
        if (!n) return;
        let o = {}, r = e && e.container != null;
        return !r && (!e || e.containerType == null) && (o.containerType = "inline-size"), !r && (!e || e.containerName == null) && (o.containerName = n), o;
    }
};
var xT = {
    show: [
        "display"
    ],
    hide: [
        "display"
    ],
    boxSize: [
        "height",
        "width"
    ],
    widthRange: [
        "minWidth",
        "maxWidth"
    ],
    heightRange: [
        "minHeight",
        "maxHeight"
    ],
    size: [
        "inlineSize",
        "blockSize"
    ],
    minSize: [
        "minInlineSize",
        "minBlockSize"
    ],
    maxSize: [
        "maxInlineSize",
        "maxBlockSize"
    ],
    marginTop: [
        "marginBlockStart"
    ],
    marginBottom: [
        "marginBlockEnd"
    ],
    marginLeft: [
        "marginInlineStart"
    ],
    marginRight: [
        "marginInlineEnd"
    ],
    paddingTop: [
        "paddingBlockStart"
    ],
    paddingBottom: [
        "paddingBlockEnd"
    ],
    paddingLeft: [
        "paddingInlineStart"
    ],
    paddingRight: [
        "paddingInlineEnd"
    ],
    flexWrap: [
        "display",
        "flexWrap"
    ],
    flexFlow: [
        "display",
        "flexFlow"
    ],
    flexAlign: [
        "display",
        "alignItems",
        "justifyContent"
    ],
    round: [
        "borderRadius"
    ],
    flow: [
        "display",
        "flexFlow"
    ],
    wrap: [
        "display",
        "flexWrap"
    ],
    align: [
        "display",
        "alignItems",
        "justifyContent"
    ],
    fontWeight: [
        "fontWeight",
        "fontVariationSettings"
    ],
    lineClamp: [
        "display",
        "WebkitBoxOrient",
        "WebkitLineClamp",
        "lineClamp",
        "overflow"
    ],
    transitionProperty: [
        "transitionProperty",
        "willChange"
    ],
    area: [
        "gridArea"
    ],
    template: [
        "gridTemplate"
    ],
    templateAreas: [
        "gridTemplateAreas"
    ],
    column: [
        "gridColumn"
    ],
    columns: [
        "gridTemplateColumns"
    ],
    templateColumns: [
        "gridTemplateColumns"
    ],
    autoColumns: [
        "gridAutoColumns"
    ],
    columnStart: [
        "gridColumnStart"
    ],
    row: [
        "gridRow"
    ],
    rows: [
        "gridTemplateRows"
    ],
    templateRows: [
        "gridTemplateRows"
    ],
    autoRows: [
        "gridAutoRows"
    ],
    rowStart: [
        "gridRowStart"
    ],
    autoFlow: [
        "gridAutoFlow"
    ],
    verticalInset: [
        "top",
        "bottom"
    ],
    horizontalInset: [
        "left",
        "right"
    ],
    shadow: [
        "boxShadow"
    ],
    textStroke: [
        "WebkitTextStroke"
    ],
    breakpointsFrom: [
        "containerType",
        "containerName"
    ]
};
var St = {
    ...dT,
    ...pT,
    ...hT,
    ...gT,
    ...mT,
    ...yT,
    ...yd,
    ..._T,
    ...bT,
    ...wT
};
var Ft = new Set([
    "accentColor",
    "alignContent",
    "alignItems",
    "alignSelf",
    "alignmentBaseline",
    "all",
    "anchorName",
    "anchorScope",
    "animation",
    "animationDelay",
    "animationDirection",
    "animationDuration",
    "animationFillMode",
    "animationIterationCount",
    "animationName",
    "animationPlayState",
    "animationRange",
    "animationRangeEnd",
    "animationRangeStart",
    "animationTimeline",
    "animationTimingFunction",
    "appearance",
    "aspectRatio",
    "backdropFilter",
    "backfaceVisibility",
    "background",
    "backgroundAttachment",
    "backgroundBlendMode",
    "backgroundClip",
    "backgroundColor",
    "backgroundImage",
    "backgroundOrigin",
    "backgroundPosition",
    "backgroundPositionX",
    "backgroundPositionY",
    "backgroundRepeat",
    "backgroundRepeatX",
    "backgroundRepeatY",
    "backgroundSize",
    "baselineShift",
    "blockSize",
    "border",
    "borderBlock",
    "borderBlockColor",
    "borderBlockEnd",
    "borderBlockEndColor",
    "borderBlockEndStyle",
    "borderBlockEndWidth",
    "borderBlockStart",
    "borderBlockStartColor",
    "borderBlockStartStyle",
    "borderBlockStartWidth",
    "borderBlockStyle",
    "borderBlockWidth",
    "borderBottom",
    "borderBottomColor",
    "borderBottomLeftRadius",
    "borderBottomRightRadius",
    "borderBottomStyle",
    "borderBottomWidth",
    "borderCollapse",
    "borderColor",
    "borderImage",
    "borderImageOutset",
    "borderImageRepeat",
    "borderImageSlice",
    "borderImageSource",
    "borderImageWidth",
    "borderLeft",
    "borderLeftColor",
    "borderLeftStyle",
    "borderLeftWidth",
    "borderRadius",
    "borderRight",
    "borderRightColor",
    "borderRightStyle",
    "borderRightWidth",
    "borderSpacing",
    "borderStyle",
    "borderTop",
    "borderTopColor",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderTopStyle",
    "borderTopWidth",
    "borderWidth",
    "bottom",
    "boxDecorationBreak",
    "boxShadow",
    "boxSizing",
    "breakAfter",
    "breakBefore",
    "breakInside",
    "captionSide",
    "caretColor",
    "clear",
    "clip",
    "clipPath",
    "color",
    "colorAdjust",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorRendering",
    "columnCount",
    "columnFill",
    "columnGap",
    "columnRule",
    "columnRuleColor",
    "columnRuleStyle",
    "columnRuleWidth",
    "columnSpan",
    "columnWidth",
    "columns",
    "contain",
    "containIntrinsicBlockSize",
    "containIntrinsicHeight",
    "containIntrinsicInlineSize",
    "containIntrinsicSize",
    "containIntrinsicWidth",
    "container",
    "containerName",
    "containerType",
    "content",
    "contentVisibility",
    "counterIncrement",
    "counterReset",
    "cursor",
    "direction",
    "display",
    "emptyCells",
    "fieldSizing",
    "fill",
    "filter",
    "flex",
    "flexBasis",
    "flexDirection",
    "flexFlow",
    "flexGrow",
    "flexShrink",
    "flexWrap",
    "float",
    "font",
    "fontFamily",
    "fontFeatureSettings",
    "fontKerning",
    "fontLanguageOverride",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontVariantAlternates",
    "fontVariantCaps",
    "fontVariantEastAsian",
    "fontVariantNumeric",
    "fontVariantPosition",
    "fontWeight",
    "fontVariationSettings",
    "fontSynthesis",
    "forcedColorAdjust",
    "gap",
    "grid",
    "gridArea",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridColumn",
    "gridColumnEnd",
    "gridColumnGap",
    "gridColumnStart",
    "gridGap",
    "gridRow",
    "gridRowEnd",
    "gridRowGap",
    "gridRowStart",
    "gridTemplate",
    "gridTemplateAreas",
    "gridTemplateColumns",
    "gridTemplateRows",
    "height",
    "hyphens",
    "imageOrientation",
    "imageRendering",
    "imeMode",
    "inset",
    "insetBlock",
    "insetBlockEnd",
    "insetBlockStart",
    "insetInline",
    "insetInlineEnd",
    "insetInlineStart",
    "initialLetter",
    "interpolateSize",
    "isolation",
    "justifyContent",
    "justifyItems",
    "justifySelf",
    "left",
    "letterSpacing",
    "lineBreak",
    "lineClamp",
    "lineHeight",
    "listStyle",
    "listStyleImage",
    "listStylePosition",
    "listStyleType",
    "margin",
    "marginBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBlock",
    "marginBlockEnd",
    "marginBlockStart",
    "marginInline",
    "marginInlineEnd",
    "marginInlineStart",
    "mask",
    "maskBorder",
    "maskBorderImage",
    "maskBorderOutset",
    "maskBorderRepeat",
    "maskBorderSlice",
    "maskBorderSource",
    "maskBorderWidth",
    "maskClip",
    "maskComposite",
    "maskImage",
    "maskOrigin",
    "maskPosition",
    "maskRepeat",
    "maskSize",
    "maskType",
    "maxBlockSize",
    "maxHeight",
    "maxInlineSize",
    "maxWidth",
    "minBlockSize",
    "minHeight",
    "minInlineSize",
    "minWidth",
    "mixBlendMode",
    "objectFit",
    "objectPosition",
    "objectViewBox",
    "offset",
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "opacity",
    "order",
    "orientation",
    "outline",
    "outlineColor",
    "outlineOffset",
    "outlineStyle",
    "outlineWidth",
    "overflow",
    "overflowAnchor",
    "overflowClip",
    "overflowScrolling",
    "overflowWrap",
    "overflowX",
    "overflowY",
    "overscrollBehavior",
    "overscrollBehaviorX",
    "overscrollBehaviorY",
    "padding",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "pageBreakAfter",
    "pageBreakBefore",
    "pageBreakInside",
    "paintOrder",
    "perspective",
    "perspectiveOrigin",
    "placeContent",
    "placeItems",
    "placeSelf",
    "pointerEvents",
    "position",
    "positionAnchor",
    "positionArea",
    "positionTry",
    "positionTryFallbacks",
    "positionTryOrder",
    "positionVisibility",
    "resize",
    "right",
    "rotate",
    "rowGap",
    "scrollBehavior",
    "scrollMargin",
    "scrollMarginBlock",
    "scrollMarginBlockEnd",
    "scrollMarginBlockStart",
    "scrollMarginBottom",
    "scrollMarginInline",
    "scrollMarginInlineEnd",
    "scrollMarginInlineStart",
    "scrollMarginLeft",
    "scrollMarginRight",
    "scrollMarginTop",
    "scrollPadding",
    "scrollPaddingBlock",
    "scrollPaddingBlockEnd",
    "scrollPaddingBlockStart",
    "scrollPaddingBottom",
    "scrollPaddingInline",
    "scrollPaddingInlineEnd",
    "scrollPaddingInlineStart",
    "scrollPaddingLeft",
    "scrollPaddingRight",
    "scrollPaddingTop",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollSnapType",
    "scrollTimeline",
    "scrollTimelineAxis",
    "scrollTimelineName",
    "scrollbarColor",
    "scrollbarGutter",
    "scrollbarWidth",
    "shapeImageThreshold",
    "shapeMargin",
    "shapeOutside",
    "stroke",
    "tabSize",
    "tableLayout",
    "textAlign",
    "textAlignLast",
    "textBox",
    "textBoxEdge",
    "textBoxTrim",
    "textDecoration",
    "textDecorationColor",
    "textDecorationLine",
    "textDecorationSkipInk",
    "textDecorationStyle",
    "textDecorationThickness",
    "textIndent",
    "textOverflow",
    "textShadow",
    "textTransform",
    "textUnderlineOffset",
    "textWrap",
    "textWrapMode",
    "textWrapStyle",
    "timelineScope",
    "top",
    "touchAction",
    "transform",
    "transformOrigin",
    "transformStyle",
    "transition",
    "transitionDelay",
    "transitionDuration",
    "transitionProperty",
    "transitionTimingFunction",
    "translate",
    "translateX",
    "translateY",
    "translateZ",
    "unicodeBidi",
    "userSelect",
    "verticalAlign",
    "viewTimeline",
    "viewTimelineAxis",
    "viewTimelineInset",
    "viewTimelineName",
    "viewTransitionClass",
    "viewTransitionName",
    "visibility",
    "whiteSpace",
    "widows",
    "width",
    "willChange",
    "wordBreak",
    "wordSpacing",
    "wordWrap",
    "writingMode",
    "zIndex"
]);
var S9 = /^[a-z][0-9]?$/, kP = /var\(\s*(--[A-Za-z0-9-]+)/g, w9 = (t)=>{
    let e = new Set, n = new Set;
    if (!t || typeof t != "object") return {
        knownLetters: e,
        knownVars: n
    };
    for(let o in t){
        let r = t[o];
        if (!(!r || typeof r != "object")) {
            if (r.sequence && typeof r.sequence == "object") for(let s in r.sequence)e.add(s);
            if (r.vars && typeof r.vars == "object") for(let s in r.vars)n.add(s);
        }
    }
    return {
        knownLetters: e,
        knownVars: n
    };
}, x9 = Object.prototype.propertyIsEnumerable, TP = (t, e)=>{
    if (!t || typeof t != "object") return !1;
    for(let n in t){
        let o = t[n];
        if (!o || typeof o != "object") continue;
        let r = o.sequence;
        if (r && typeof r == "object" && x9.call(r, e)) return !0;
    }
    return !1;
}, kT = /[(),\s]+/, TT = (t, e)=>{
    let n = null, o = t.split(kT);
    for(let r = 0; r < o.length; r++){
        let s = o[r];
        s && e(s) && (n || (n = [])).push(s);
    }
    return n;
}, ET = (t, e)=>$n.test(t) && e(t.charCodeAt(0) === 45 ? t.slice(1) : t), k9 = (t, e)=>{
    if (!e.size) return [];
    let n = (r)=>e.has(r), o = TT(t, (r)=>ET(r, n));
    return o ? [
        ...new Set(o)
    ] : [];
}, T9 = (t, e)=>{
    if (!e.size) return [];
    let n = [];
    kP.lastIndex = 0;
    let o;
    for(; o = kP.exec(t);){
        let r = o[1];
        if (e.has(r)) continue;
        let s = r.lastIndexOf("-");
        if (s === -1) continue;
        let i = r.slice(s + 1);
        if (!S9.test(i)) continue;
        let a = r.slice(0, s + 1) + i.toUpperCase();
        a !== r && e.has(a) && n.push({
            varName: r,
            corrected: a
        });
    }
    return n;
}, ty = new Set, EP = (t, e, n)=>{
    return;
};
var E9 = /^\[data-theme=(?:"([^"]+)"|'([^']+)')\]$/, A9 = (t, e, n)=>{
    let { context: o } = n;
    if (!o.designSystem?.media) return;
    let r = t.slice(1), s = o.designSystem.media[r], i = ci(s || t) ? ai(()=>ne(e, n)) : ne(e, n);
    if (!s) return {
        [t]: i
    };
    if (/^@(media|supports|container)\b/.test(s)) return {
        [s]: i
    };
    if (s === "print") return {
        "@media print": i
    };
    if (s[0] === "(") return {
        [`@media screen and ${s}`]: i
    };
    let a = s.match(E9), c = a ? a[1] || a[2] : r, l = {
        [`${s} &`]: i
    };
    if (c === "dark" || c === "light") {
        let f = o.designSystem?.scopeSelector || ":root", u = f === ":root" ? ":root:not([data-theme])" : `${f}:not([data-theme])`;
        l[`@media (prefers-color-scheme: ${c})`] = {
            [`${u} &`]: i
        };
    }
    return l;
}, AP = (t, e, n)=>({
        [t]: ne(e, n)
    }), _d = (t, e, n)=>{
    let o = `&${t}`, r = ne(e, n);
    if (t.includes(",") && r) {
        let s = {}, i = {};
        for(let a in r)typeof r[a] == "object" && r[a] !== null ? i[a] = r[a] : s[a] = r[a];
        if (Object.keys(i).length) {
            let a = o.split(",").map((l)=>l.trim()), c = {};
            Object.keys(s).length && (c[o] = s);
            for(let l in i){
                let f = a.map((u)=>`${u} ${l}`).join(", ");
                c[f] = i[l];
            }
            return c;
        }
    }
    return {
        [o]: r
    };
}, AT = (t, e)=>{
    let n = e.context?.cases?.[t];
    if (n !== void 0) return P(n) ? n.call(e, e) : !!n;
}, v9 = (t, e, n)=>{
    let o = t.slice(1), r = AT(o, n);
    if (r === void 0 && (r = !!n[o]), !!r) return ne(e, n);
}, O9 = (t, e, n)=>({
        [t]: e
    }), C9 = (t, e, n)=>{
    let o = t.slice(1), r = n[o] === !0 || n.state?.[o];
    if (!r) {
        if (typeof n[o] == "function") try {
            r = n[o](n, n.state, n.context);
        } catch  {}
        else {
            let s = AT(o, n);
            s !== void 0 && (r = s);
        }
    }
    if (r) return ne(e, n);
}, R9 = (t, e, n)=>{
    let o = t.slice(1), r = n[o] === !0 || n.state?.[o];
    if (!r) {
        if (typeof n[o] == "function") try {
            r = n[o](n, n.state, n.context);
        } catch  {}
        else {
            let s = AT(o, n);
            s !== void 0 && (r = s);
        }
    }
    if (!r) return ne(e, n);
}, vT = (t, e)=>ne(t, e), OT = {
    "@": A9,
    ":": _d,
    "[": _d,
    "*": _d,
    "+": _d,
    "~": _d,
    "&": AP,
    ">": AP,
    $: v9,
    "-": O9,
    ".": C9,
    "!": R9
};
var ey = mr(), vP = (t, e, n)=>{
    let o = e?.context?.designSystem;
    o && pt(o);
    try {
        let r = {}, s = {}, i = (a, c)=>{
            if (n.unpack) {
                r = {
                    ...r,
                    ...c
                };
                return;
            }
            r[a] = c;
        };
        for(let a in t){
            let c = t[a];
            if (c !== null) {
                if (a === "class" && E(c)) {
                    let l = OP(c, e);
                    l && (n.unpack ? Dt(r, l) : r.designSystemClass = l);
                } else if (a === "true") {
                    let l = bt(c, e);
                    Dt(r, vT(l, e));
                } else if (e.classlist?.[a]) {
                    let l = e.classlist[a], f = P(l) ? l(e, e.state, e.context) : l;
                    f && i(a, f), !ey && k(r[a]) && (r[a].label = a);
                } else if (St[a]) {
                    let l = bt(c, e);
                    if (l === null) continue;
                    B(l) && (l = l.reduce((u, d)=>Dt(u, d), {}));
                    let f = St[a](l, e, e.state, e.context);
                    B(f) && (f = f.reduce((u, d)=>Dt(u, d), {})), f && i(a, f), !ey && k(r[a]) && (r[a].label = a);
                } else if (Ft.has(a)) {
                    let l = bt(c, e);
                    if (l === null) continue;
                    typeof l == "string" && l.charCodeAt(0) === 45 && l.charCodeAt(1) === 45 && (l = `var(${l})`), ey || EP(a, l, e), i(a, {
                        [a]: l
                    }), !ey && k(r[a]) && (r[a].label = a);
                } else s[a] = c;
            }
        }
        return [
            r,
            s
        ];
    } finally{
        o && ut();
    }
}, OP = (t, e)=>{
    if (!E(t)) return;
    let n = e?.context?.designSystem?.class;
    if (!n) return;
    let o;
    for (let r of t.split(" ")){
        if (!r) continue;
        let s = n[r];
        if (!k(s)) continue;
        let i = ft(s);
        o = o ? le(o, i) : i;
    }
    if (o) return ne(o, e);
}, CP = (t, e)=>{
    let n = {};
    for(let o in t){
        let r = OT[o.slice(0, 1)];
        if (r) {
            let s = r(o, t[o], e);
            if (s) for(let i in s)Object.prototype.hasOwnProperty.call(s, i) && (n[i] && typeof n[i] == "object" && typeof s[i] == "object" ? le(n[i], s[i]) : n[i] = s[i]);
        }
    }
    return n;
}, ne = (t, e, n = {
    unpack: !0
})=>{
    let [o, r] = vP(t, e, n), s = CP(r, e), i = !1;
    for(let a in s){
        i = !0;
        break;
    }
    if (i) {
        if (n.unpack) return Xl(o, s);
        o._selectors = s;
    }
    return o;
}, D9 = (t, e)=>{
    let n = {};
    if (t.class) for(let o in t.class)n[o] = t.class[o](e);
    return n;
};
var RP = (t)=>{
    if (k(t)) return ne(t, t);
}, L9 = (t, e)=>{
    let n = RP(t);
    return typeof e == "function" ? e(n) : Ke(n);
};
var DP = /\s*!important\s*$/, P9 = ()=>{
    let t;
    try {
        t = L();
    } catch  {
        t = null;
    }
    let e = t && t.sizes && typeof t.sizes == "object" ? t.sizes : null, n = null, o = (s)=>{
        n || (n = new Map);
        let i = n.get(s);
        return i === void 0 && (i = TP(t, s), n.set(s, i)), i;
    }, r = (s)=>rc(e, s) !== void 0;
    return {
        isToken: (s)=>s.charCodeAt(0) !== 35 && (ET(s, o) || r(s))
    };
}, I9 = (t, e)=>{
    let n = String(t).split(kT);
    for(let o = 0; o < n.length; o++)if (n[o] === e) return !0;
    return !1;
}, M9 = (t, e)=>{
    let n = typeof globalThis < "u" ? globalThis.CSS : void 0;
    if (!n || typeof n.supports != "function") return !1;
    try {
        return n.supports(Re(t), e);
    } catch  {
        return !1;
    }
}, LP = new Set, B9 = (t, e, n)=>{
    return;
}, N9 = (t, e)=>{
    if (!t || typeof t != "object") return !1;
    let n = !1;
    for(let o in t){
        let r = t[o];
        if (r != null) {
            if (typeof r == "object" || typeof r == "function") return !1;
            for (let s of e)if (I9(r, s)) return !1;
            n = !0;
        }
    }
    return n;
}, F9 = (t, e, n, o)=>{
    if (!E(e) || !e || t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45) return null;
    let r = St[t];
    if (!r || !Ft.has(t)) return null;
    let s = DP.test(e), i = s ? e.replace(DP, "") : e, a = TT(i, o.isToken);
    if (!a || M9(t, i)) return null;
    let c;
    try {
        c = r(i, n, n?.state, n?.context);
    } catch  {
        c = null;
    }
    if (Array.isArray(c)) {
        let f = {};
        for (let u of c)u && typeof u == "object" && Object.assign(f, u);
        c = f;
    }
    if (!N9(c, a)) return B9(n, t, e), null;
    let l = {};
    for(let f in c){
        let u = c[f];
        u != null && (l[f] = s ? String(u) + " !important" : u);
    }
    return l;
}, PP = (t, e, n)=>{
    let o = {}, r = !1;
    for(let s in t){
        let i = t[s];
        if (s.charCodeAt(0) === 38 && i && typeof i == "object" && !Array.isArray(i)) {
            let c = PP(i, e, n);
            c !== i && (r = !0), o[s] = c;
            continue;
        }
        let a = F9(s, i, e, n);
        a ? (r = !0, Object.assign(o, a)) : o[s] = i;
    }
    return r ? o : t;
}, CT = (t, e)=>!t || typeof t != "object" || Array.isArray(t) ? t : PP(t, e, P9());
if (!kt || !gn) throw new Error("@symbo.ls/element: the installed @symbo.ls/css does not export CSS_SHORTHAND_LONGHANDS / CSS_LONGHAND_SHORTHANDS (the CSS shorthand family table, packages/css/src/cssLonghands.js). This element needs the @symbo.ls/css published in the same release \u2014 update @symbo.ls/css.");
var ny = kt, Ur = gn, oy = yc || (()=>!1), IP = id || oy, MP = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, Jo = Re || ((t)=>MP(t) ? t : t.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase())), bd = fd || ((t)=>MP(t) ? t : t.replace(/-([a-z])/g, (e, n)=>n.toUpperCase()));
function NP(t) {
    let e = [];
    return t.extends && (Array.isArray(t.extends) ? e.push(...t.extends) : e.push(t.extends)), t.extend && (Array.isArray(t.extend) ? e.push(...t.extend) : e.push(t.extend)), e;
}
function vc(t, e, n) {
    let o = NP(e);
    if (!o.length) return;
    let r = t.context || n?.context || {}, s = r.components || {};
    for(let i = 0; i < o.length; i++){
        let a = FP(o[i], s, r, e);
        a && a !== e && $P(t, a, n, new Set([
            e
        ]));
    }
}
var $9 = Symbol.for("smbls.shadowedComponents");
function j9(t, e, n, o) {
    let r = o && o[$9], s = r ? r.get(e) : void 0, i = s ? s.length + 1 : 1, a = null, c = !1;
    for(let l = 0; l <= i; l++){
        let f = l === 0 ? t[e] : l === i ? t[`smbls.${e}`] : s[l - 1];
        if (f) {
            if (f === n) c = !0;
            else {
                if (c) return f;
                a === null && (a = f);
            }
        }
    }
    return c ? null : a;
}
function FP(t, e, n, o) {
    if (typeof t == "string") {
        if (t.includes(">")) {
            let r = t.split(">").map((i)=>i.trim()), s = e[r[0]] || e[`smbls.${r[0]}`];
            for(let i = 1; i < r.length && s; i++)s = s[r[i]];
            return s || null;
        }
        return j9(e, t, o, n);
    }
    return typeof t == "object" && t !== null ? t : null;
}
function $P(t, e, n, o = new Set) {
    if (o.has(e)) return;
    o.add(e);
    let r = NP(e);
    if (r.length) {
        let i = t.context || n?.context || {}, a = i.components || {};
        for(let c = 0; c < r.length; c++){
            let l = FP(r[c], a, i, e);
            l && $P(t, l, n, o);
        }
    }
    let s = DT(t);
    for(let i in e){
        if (i === "extends" || i === "extend") continue;
        let a = e[i];
        s && s.mark(i);
        let c = Q.chains;
        c !== null && c(t, i, t[i], a) || (t[i] === void 0 ? a && typeof a == "object" && !Array.isArray(a) && typeof a != "function" ? t[i] = {
            ...a
        } : t[i] = a : typeof t[i] == "object" && typeof a == "object" && !Array.isArray(t[i]) && !Array.isArray(a) && t[i] !== null && a !== null ? t[i] = Ge(t[i], a) : t[i] = a);
    }
}
var RT = class {
    constructor(){
        this.rank = 0, this.ranks = null;
    }
    mark(e) {
        U9(e) && (this.ranks || (this.ranks = new Map), this.ranks.set(e, this.rank));
    }
    get(e) {
        return this.ranks ? this.ranks.get(e) : void 0;
    }
    get size() {
        return this.ranks ? this.ranks.size : 0;
    }
}, ry = new Set;
for (let t of [
    Ur,
    ny
])for(let e in t)ry.add(e), ry.add(bd(e));
var BP = new Map;
function U9(t) {
    let e = t.charCodeAt(0);
    if (e >= 65 && e <= 90 || e >= 48 && e <= 57) return !1;
    let n = BP.get(t);
    return n === void 0 && (n = !!St[t] || ry.has(t) || t.indexOf("-") >= 0 && !(t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45) && ry.has(Jo(t)), BP.set(t, n)), n;
}
function DT(t) {
    let e = t && t.__ref;
    if (!e) return null;
    let n = e.__mergeLayer;
    return n || (n = e.__mergeLayer = new RT), n.rank++, n;
}
function jP(t) {
    let e = t && t.__ref && t.__ref.__mergeLayer;
    if (!e || !e.ranks) return;
    let n;
    for (let o of e.ranks.values())if (n === void 0) n = o;
    else if (o !== n) return;
    e.ranks = null;
}
function Ge(t, e) {
    let n = {
        ...t
    }, o = Q.chains;
    for(let r in e){
        let s = n[r], i = e[r];
        o !== null && o(n, r, s, i) || (s && i && typeof s == "object" && typeof i == "object" && !Array.isArray(s) && !Array.isArray(i) && typeof s != "function" && typeof i != "function" ? n[r] = Ge(s, i) : n[r] = i);
    }
    return n;
}
var ho = "http://www.w3.org/2000/svg", Rc = new Set([
    "svg",
    "path",
    "circle",
    "ellipse",
    "line",
    "polyline",
    "polygon",
    "rect",
    "g",
    "defs",
    "use",
    "symbol",
    "clipPath",
    "mask",
    "pattern",
    "image",
    "text",
    "tspan",
    "textPath",
    "marker",
    "linearGradient",
    "radialGradient",
    "stop",
    "filter",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feFlood",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "feSpecularLighting",
    "feTile",
    "feTurbulence",
    "animate",
    "animateMotion",
    "animateTransform",
    "set",
    "foreignObject",
    "desc",
    "title",
    "metadata"
]), H9 = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "string",
    "fragment",
    "shadow"
]);
function Oc(t) {
    return H9.has(t) || Rc.has(t);
}
function Un(t) {
    return Rc.has(t);
}
function Hn(t) {
    let { tag: e, key: n } = t;
    if (typeof e == "function") try {
        e = e(t, t.state, t.context);
    } catch (s) {
        e = void 0, typeof console < "u" && console.error && console.error(`[smbls] \`tag:\` factory threw on "${n || "<anon>"}" \u2014 falling back to key-based tag detection:`, s?.message || s);
    }
    if (e === !0 && (e = n), typeof e == "string" && Oc(e)) return e;
    if (!n || typeof n != "string") return "div";
    let o = new Set([
        "html",
        "head",
        "body",
        "meta",
        "link",
        "script",
        "style",
        "title",
        "base",
        "noscript",
        "template",
        "th",
        "tr",
        "td",
        "thead",
        "tbody",
        "tfoot",
        "caption",
        "col",
        "colgroup"
    ]), r = n.toLowerCase();
    return r.includes(".") && (r = r.split(".")[0]), r.includes("_") && (r = r.split("_")[0]), Oc(r) && !o.has(r) ? r : "div";
}
var UP = {};
function Cc(t, e) {
    let n = e?.context?.document || globalThis.document;
    if (!n) return null;
    if (t === "string") return n.createTextNode(e?.text || "");
    if (t === "fragment") return n.createDocumentFragment();
    if (Un(t)) {
        let o = e?.parent;
        if (t === "svg" || o?.node?.namespaceURI === ho) return n.createElementNS(ho, t);
        if (t !== "svg") return n.createElement("div");
    }
    return n.createElement(t);
}
function Hr(t) {
    let e = t.tag = Hn(t), o = Un(e) && (e === "svg" || t.parent?.node?.namespaceURI === ho) ? "svg:" + e : e, r = t?.context?.document || globalThis.document, s = UP[o];
    if (s || (s = UP[o] = Cc(e, t)), !s) return null;
    let i = r && s.ownerDocument !== r ? Cc(e, t) : s.cloneNode(!0);
    return e === "string" && (i.nodeValue = t.text || ""), i;
}
function Sd(t, e) {
    return e && e.parentNode === t ? e.nextSibling : t.firstChild;
}
var HP = new WeakMap, VP = null, zP = null;
function V9(t, e) {
    let n = t === VP ? zP : HP.get(t);
    (!n || n.length !== t.length) && (n = {
        length: t.length,
        hooks: new Map
    }, HP.set(t, n)), VP = t, zP = n;
    let o = n.hooks.get(e);
    if (o === void 0) {
        o = !1;
        for (let r of t)if (typeof r[e] == "function") {
            o = !0;
            break;
        }
        n.hooks.set(e, o);
    }
    return o;
}
function LT(t, e) {
    let n = t && t.context && t.context.plugins;
    return !!(n && n.length && V9(n, e));
}
function Vn(t, e, ...n) {
    return LT(e, t) ? Cn(t, e, ...n) : !1;
}
function bn(t, e, n) {
    Vn("error", t, {
        hook: e,
        error: n
    }) || console.error(`[DOMQL] Lifecycle "${e}" error:`, n);
}
function ki(t, e) {
    try {
        Vn("renderError", t, e);
    } catch (n) {
        console.error("[smbls] renderError hook threw:", n);
    }
}
var z9 = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
function KP(t, e, n) {
    return De(()=>_n(t, ()=>e.call(t, n, t, t.state, t.context)));
}
function W9(t, e) {
    return;
}
function sy(t) {
    let e = t.__ref, n = t.node;
    if (!e || !n || e.__bridge || typeof t.onBridgeMount != "function") return;
    if (!("scrollHeight" in n)) return;
    let o = e.__bridge = {
        settled: !1,
        failed: !1,
        disposed: !1,
        destroyed: !1,
        instance: void 0,
        effect: null
    };
    e.contentManaged = !0, W9(t, e);
    let r;
    try {
        r = KP(t, t.onBridgeMount, n);
    } catch (s) {
        if (o.failed = !0, bn(t, "onBridgeMount", s), t.context?.strictMode) throw s;
        return;
    }
    if (r && typeof r.then == "function") {
        r.then((s)=>WP(t, o, s), (s)=>{
            o.failed = !0, bn(t, "onBridgeMount", s);
        });
        return;
    }
    WP(t, o, r);
}
function WP(t, e, n) {
    if (e.settled = !0, e.instance = n, e.disposed) {
        GP(t, e);
        return;
    }
    if (Object.defineProperty(t, "bridge", {
        value: n,
        writable: !0,
        configurable: !0,
        enumerable: !1
    }), typeof t.onBridgeUpdate != "function") return;
    let o = t.__ref;
    e.effect = q(()=>{
        e.disposed || _n(t, ()=>{
            try {
                let r = t.onBridgeUpdate.call(t, e.instance, t, t.state, t.context);
                r && typeof r.then == "function" && r.catch((s)=>bn(t, "onBridgeUpdate", s));
            } catch (r) {
                bn(t, "onBridgeUpdate", r);
            }
        });
    }, {
        depth: o.path.length,
        label: ()=>o.path.join(".") + "::onBridgeUpdate"
    }), o.__effects.push(e.effect);
}
function iy(t) {
    let e = t.__ref?.__bridge;
    !e || e.disposed || (e.disposed = !0, e.effect && e.effect.dispose(), e.settled && GP(t, e));
}
function GP(t, e) {
    if (e.destroyed) return;
    e.destroyed = !0;
    let n = e.instance;
    if (e.instance = void 0, z9(t, "bridge") && (t.bridge = void 0), typeof t.onBridgeDestroy == "function") try {
        let o = KP(t, t.onBridgeDestroy, n);
        o && typeof o.then == "function" && o.catch((r)=>bn(t, "onBridgeDestroy", r));
    } catch (o) {
        bn(t, "onBridgeDestroy", o);
    }
}
function Dc(t) {
    return t.__mount || (t.__mount = {
        pending: 0,
        tail: null,
        holder: null,
        waiters: null,
        chunkGen: 0,
        attachLater: !1,
        held: !1
    });
}
function wd(t) {
    let e = t.__mount;
    return e ? e.pending : 0;
}
function Lc(t = {}, e = {}) {
    let n = this, o = n.__ref;
    if (!o) return;
    if ((typeof t == "string" || typeof t == "number") && (t = {
        text: t
    }), !e.preventListeners && typeof n.onBeforeUpdate == "function" && ay(o)) try {
        let a = n.onBeforeUpdate(n, n.state, n.context, e);
        if (a && typeof a.then == "function") a.then(()=>go(o, !1), (c)=>{
            go(o, !0), Vn("error", n, {
                hook: "onBeforeUpdate",
                error: c
            }) || console.error("[DOMQL] onBeforeUpdate error:", c);
        });
        else if (go(o, !1), a === !1) return n;
    } catch (a) {
        throw go(o, !0), a;
    }
    let r = !t || Object.keys(t).length === 0, s = [], i = !1;
    th(()=>{
        if (t.state && xt(n.state) && n.state.$update(t.state), t.text !== void 0 && (n.text = t.text, !o.__exec.text && n.node && Ti(n, t.text ?? "")), t.html !== void 0 && (n.html = t.html, !o.__exec.html && n.node && (n.node.innerHTML = t.html)), t.style && n.node?.style) {
            if (!o.__exec.style) {
                let a = Ai(n, t.style);
                for(let c in a){
                    let l = a[c];
                    if (l == null) continue;
                    let f = Jo(c), u = String(l).replace(/\s*!important\s*$/, "");
                    n.node.style.setProperty(f, u, "important");
                }
            }
            n.style || (n.style = {}), Object.assign(n.style, t.style);
        }
        if (t.attr && n.node?.setAttribute) {
            for(let a in t.attr){
                let c = t.attr[a];
                Ei(n.node, a, c);
            }
            n.attr || (n.attr = {}), Object.assign(n.attr, t.attr);
        }
        if (t.data && n.node?.dataset) {
            for(let a in t.data)n.node.dataset[a] = t.data[a];
            n.data || (n.data = {}), Object.assign(n.data, t.data);
        }
        if (t.vars && typeof t.vars == "object" && !Array.isArray(t.vars)) {
            let a = n.vars && typeof n.vars == "object" && !Array.isArray(n.vars) ? n.vars : null;
            n.vars = {
                ...a,
                ...t.vars
            }, i = !0;
        }
        for(let a in t){
            if (Kt.has(a) || a === "state") continue;
            let c = t[a], l = n[a];
            if (l && l.__ref && typeof l.update == "function") l.update(c, e);
            else if (typeof c == "object" && c !== null) {
                let f = a.charCodeAt(0);
                f >= 65 && f <= 90 && Gt(c, n, a, e);
            } else a !== "text" && a !== "html" && a !== "style" && a !== "attr" && a !== "data" && (n[a] = c, typeof c != "function" && s.push(a));
        }
    });
    for(let a = 0; a < s.length; a++)MT(n, s[a]);
    if (n.node) {
        let a = i;
        for(let c = 0; !a && c < s.length; c++)PT(s[c]) && (a = !0);
        a && IT(n);
    }
    if (n.node && r && o.__effects && o.__effects.length) for(let a = 0; a < o.__effects.length; a++){
        let c = o.__effects[a];
        c && !c._disposed && !c._isSubscribeToEffect && typeof c._execute == "function" && c._execute();
    }
    else if (n.node && o.__conditionalRunners) for (let a of o.__conditionalRunners)a();
    return Vn("update", n), !e.preventListeners && typeof n.onUpdate == "function" && n.onUpdate(n, n.state, n.context, e), n;
}
function Sn(t) {
    if (!t) return;
    let e = t.__ref;
    if (!e) return;
    if (e.__onConnected && X1(t), $e()) return De(()=>Sn(t));
    e.__disposed = !0, (e.__faceWait || e.__faceWaitLate) && Q.faceWait !== null && Q.faceWait.dispose(t);
    let n = e.__if === !1 && !e.__ifInitialized;
    if (!n) try {
        typeof t.onBeforeRemove == "function" && t.onBeforeRemove(t, t.state, t.context);
    } catch (s) {
        console.error("[smbls] onBeforeRemove error:", s);
    }
    if (e.__bridge && iy(t), e.__effects) {
        for(let s = 0; s < e.__effects.length; s++)e.__effects[s].dispose();
        e.__effects.length = 0;
    }
    if (typeof e.__releaseMedia == "function" && (e.__releaseMedia(), e.__releaseMedia = null), e.__eventCleanup) {
        for(let s = 0; s < e.__eventCleanup.length; s++)e.__eventCleanup[s]();
        e.__eventCleanup.length = 0;
    }
    if (e.__children) {
        let s = e.__children.slice();
        e.__children.length = 0;
        for(let i = 0; i < s.length; i++){
            let a = t[s[i]];
            a && a.__ref && Sn(a);
        }
    }
    if (e.__ifParked && e.__ifParked.size) {
        let s = [
            ...e.__ifParked
        ];
        e.__ifParked.clear();
        for(let i = 0; i < s.length; i++){
            let a = t[s[i]];
            a && a.__ref && a.parent === t && Sn(a);
        }
    }
    let o = Q.hydration !== null ? t.context?.__replacing : void 0;
    o && Q.hydration.releaseReplaced(o, t), e.__keepNode ? e.__keepNode = !1 : t.node?.parentNode ? t.node.remove() : t.tag === "fragment" && e.__fragmentAnchor?.parentNode && e.__fragmentAnchor.remove();
    let r = t.state?.$destroy || t.state?.destroy;
    if (typeof r == "function" && t.state.__element === t && r.call(t.state), t.parent?.__ref?.__children) {
        let s = t.parent.__ref.__children.indexOf(t.key);
        s !== -1 && t.parent.__ref.__children.splice(s, 1), t.parent.__ref.__ifParked && t.parent.__ref.__ifParked.delete(t.key), delete t.parent[t.key];
    }
    if (!n) try {
        typeof t.onRemove == "function" && t.onRemove(t);
    } catch (s) {
        console.error("[smbls] onRemove error:", s);
    }
    e.__mount && e.__mount.tail && Q.mount.abandon(t, e), t.node = null, t.parent = null, t.__ref = null;
}
function Pc() {
    Sn(this);
}
function FT(t, e, n) {
    let o = t?.context?.analyze;
    if (!o || !o.emit || e === "warn" && !o.shouldCapture("warnings") || e === "error" && !o.shouldCapture("errors")) return;
    let r = n.map((s)=>s?.message || (typeof s == "string" ? s : null)).filter(Boolean).join(" ");
    o.emit({
        id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
        ts: Date.now(),
        type: e === "error" ? "error" : "warning",
        level: e,
        hook: e === "error" ? "el.error" : "el.warn",
        element: {
            key: t.key != null ? String(t.key) : null,
            name: t.__name || null,
            tag: t.tag || null
        },
        message: r || null,
        args: n
    });
}
var qP = new Set;
function YP(t, e, n) {
    let o = String(e);
    if (qP.has(o)) return;
    qP.add(o);
    let r = t?.__ref?.path, s = Array.isArray(r) && r.length ? r.join(".") : t?.key != null ? String(t.key) : "(unknown element)", i = n != null ? `resolves to a non-function (${typeof n}) \u2014 it cannot be called` : "is not registered in context.methods, context.functions, or context.utils, and is not an element method", a = `[smbls] el.call('${o}') at <${s}>: "${o}" ${i}. Returning undefined (unchanged behavior) \u2014 check the name for typos or register the function on the project. Warned once per name; repeat misses are silent.`;
    FT(t, "error", [
        a
    ]), console.error(a);
}
var ZP = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), K9 = new Set, QP = (t)=>ZP(BT, t) && !(wa || K9).has(t), XP = new Set;
function JP(t, e) {
    XP.has(t) || XP.add(t);
}
function G9(...t) {
    return FT(this, "warn", t), Bf.apply(this, t);
}
function q9(...t) {
    return FT(this, "error", t), js.apply(this, t);
}
var BT = {
    update: Lc,
    remove: Pc,
    getDB: jf,
    getQuery: Uf,
    getRootData: Pf,
    getPath: Cf,
    nextElement: Nf,
    previousElement: Ff,
    verbose: Pa,
    warn: G9,
    error: q9,
    variables: $f,
    spotByPath: Of,
    set (t, e, n) {
        let o = this.__ref;
        if (o) {
            if (o.__setLocked) {
                o.__setQueued = {
                    content: t,
                    options: e
                };
                return;
            }
            o.__setLocked = !0;
        }
        let r, s = t != null ? Q.hydration : null, i = s && typeof s.handBack == "function" ? this.context?.__hydration : null, a = i && o?.__children && this.content?.__ref ? s.handBack(i, this.content) : null;
        try {
            if (this.removeContent(), t != null) {
                let c = this.context?.__create;
                try {
                    c && (r = c(t, this, "content", e, n));
                } finally{
                    a && s.settleHandBack(i, a);
                }
            }
            this.__ref && (this.__ref.contentManaged = !0);
        } finally{
            if (o) {
                o.__setLocked = !1;
                let c = o.__setQueued;
                c && (o.__setQueued = null, this.set(c.content, c.options));
            }
        }
        return r;
    },
    reset (t) {
        let e = this.context?.__create;
        if (!e) return this;
        let n = this.parent, o = this.key, r = this.parse();
        return this.remove(), e(r, n, o, t);
    },
    lookup (t) {
        let e = this.parent;
        for(; e;){
            if (typeof t == "function") {
                if (t(e)) return e;
            } else if (typeof t == "string") {
                if (e.key === t) return e;
                if (e[t] && e[t].__ref) return e[t];
            }
            e = e.parent;
        }
        return null;
    },
    whenConnected (t) {
        return jn(this, t);
    },
    lookdown (t) {
        let e = this.__ref;
        if (!e?.__children) return null;
        for (let n of e.__children){
            let o = this[n];
            if (!o) continue;
            if (typeof t == "function") {
                if (t(o)) return o;
            } else if (typeof t == "string" && o.key === t) return o;
            let r = o.lookdown?.(t);
            if (r) return r;
        }
        return null;
    },
    lookdownAll (t, e = []) {
        let n = this.__ref;
        if (!n?.__children) return e;
        for (let o of n.__children){
            let r = this[o];
            r && (typeof t == "function" ? t(r) && e.push(r) : typeof t == "string" && r.key === t && e.push(r), r.lookdownAll?.(t, e));
        }
        return e;
    },
    getRef (t) {
        return t ? this.__ref && this.__ref[t] : this.__ref;
    },
    getChildren () {
        let t = this.__ref && this.__ref.__children;
        return Array.isArray(t) ? t.map((e)=>this[e]) : [];
    },
    getAdoption () {
        let t = this.__ref && this.__ref.__adoption;
        if (t) return t;
        if (this.node) return null;
        let e = Q.hydration;
        return e && typeof e.foresee == "function" ? e.foresee(this) : null;
    },
    facesReady () {
        let t = Q.faceWait;
        return t ? t.ready(this) : Promise.resolve([]);
    },
    checkFaces () {
        let t = Q.faceWait;
        t && t.recheck(this);
    },
    getRoot: Lf,
    getRootState: Df,
    getRootContext: If,
    getContext: Mf,
    parse (t) {
        let e = {}, n = t ? new Set(t) : null, o = this.__ref?.__exec;
        for(let r in this)if (!(r === "parent" || r === "node" || r === "__ref") && !n?.has(r)) {
            if (o && o[r] !== void 0) {
                e[r] = o[r];
                continue;
            }
            typeof this[r] != "function" && (e[r] = this[r]);
        }
        return e;
    },
    parseDeep (t) {
        let e = this.parse(t), n = this.__ref;
        if (n?.__children) for (let o of n.__children)this[o]?.parseDeep && (e[o] = this[o].parseDeep(t));
        return e;
    },
    keys () {
        return Object.keys(this);
    },
    log (...t) {
        if (t.length) {
            let e = {};
            for (let n of t)e[n] = this[n];
            console.log(e);
        } else console.log(this);
    },
    setProps (t, e) {
        return this.update(t, e);
    },
    setNodeStyles (t) {
        if (this.node?.style) for(let e in t){
            let n = t[e];
            if (n == null) continue;
            let o = e.replace(/[A-Z]/g, (s)=>"-" + s.toLowerCase()), r = String(n).replace(/\s*!important\s*$/, "");
            this.node.style.setProperty(o, r, "important");
        }
    },
    call (t, ...e) {
        let n = this.context, o = QP(t);
        o && n?.methods?.[t] && n.methods[t] !== this[t] && JP(t, "el.call");
        let r = o ? this[t] : n?.methods?.[t] || n?.functions?.[t] || n?.utils?.[t] || this[t];
        if (typeof r == "function") {
            let s = Es;
            if (!s || !s(r)) return r.call(this, ...e);
            return;
        }
    },
    removeContent () {
        let t = this.__ref;
        if (!t?.__children) return;
        let e = this.content;
        if (e?.remove) {
            e.remove(), delete this.content;
            let n = t.__children.indexOf("content");
            n !== -1 && t.__children.splice(n, 1);
        }
        e?.node?.parentNode && e.node.parentNode.removeChild(e.node);
    }
}, NT = new WeakMap;
function Y9(t) {
    if (!t) return BT;
    let e = NT.get(t);
    if (e) return e;
    e = Object.create(BT);
    let n = t.methods;
    if (n) for(let o in n)e[o] = n[o];
    return NT.set(t, e), e;
}
function Ic(t) {
    let e = Y9(t.context);
    Object.setPrototypeOf(t, e);
}
function Mc(t) {
    if (!t) return !1;
    let e = NT.get(t);
    if (!e) return !1;
    let n = t.methods;
    if (!n) return !1;
    for(let o in n){
        if (QP(o) && !ZP(e, o)) {
            JP(o, "refreshContextProto");
            continue;
        }
        e[o] = n[o];
    }
    return !0;
}
var VT = /*@__PURE__*/ F({}, {
    STATE_METHODS: ()=>tI,
    applyInitialState: ()=>cy,
    applyStateMethods: ()=>Le,
    callStateMethod: ()=>kd,
    createState: ()=>jT,
    isTracking: ()=>HT,
    useHostState: ()=>UT
});
var tI = new Set([
    "update",
    "parse",
    "clean",
    "destroy",
    "create",
    "add",
    "toggle",
    "remove",
    "set",
    "replace",
    "setByPath",
    "setPathCollection",
    "removeByPath",
    "removePathCollection",
    "getByPath",
    "reset",
    "apply",
    "applyReplace",
    "applyFunction",
    "quietUpdate",
    "quietReplace",
    "rootUpdate",
    "parentUpdate",
    "keys",
    "values",
    "__element",
    "__children",
    "parent",
    "root"
]), xd = (t, e, n)=>{
    Object.defineProperty(t, e, {
        value: n,
        enumerable: !1,
        configurable: !0,
        writable: !0
    });
}, zn = (t, e, n, { onlyIfAbsent: o } = {})=>{
    xd(t, "$" + e, n), !(o && Object.prototype.hasOwnProperty.call(t, e)) && xd(t, e, n);
}, kd = (t, e, ...n)=>{
    if (!t) return;
    let o = t["$" + e];
    if (typeof o == "function") return o.apply(t, n);
    let r = t[e];
    if (typeof r == "function") return r.apply(t, n);
}, Le = (t, e)=>{
    if (xt(e)) {
        let r = e.__raw || e;
        zn(r, "toggle", function(s, i = {}) {
            e[s] = !e[s];
        }, {
            onlyIfAbsent: !0
        }), zn(r, "set", function(s, i = {}) {
            let a = e.__element;
            return typeof s == "object" && s !== null && a && typeof a.onBeforeStateUpdate == "function" && !i.preventBeforeStateUpdateListener && a.onBeforeStateUpdate(a, e, a.context, {
                changes: s,
                options: i
            }) === !1 || (e.$clean({
                preventStateUpdate: !0
            }), typeof s == "object" && s !== null && e.$update(s, {
                ...i,
                preventBeforeStateUpdateListener: !0
            })), e;
        }, {
            onlyIfAbsent: !0
        }), zn(r, "setByPath", function(s, i, a = {}) {
            let c = s.split("."), l = e;
            for(let f = 0; f < c.length - 1; f++)l[c[f]] === void 0 && (l[c[f]] = {}), l = l[c[f]];
            return l[c[c.length - 1]] = i, e;
        }), zn(r, "getByPath", function(s) {
            let i = s.split("."), a = e;
            for(let c = 0; c < i.length; c++){
                if (a == null) return;
                a = a[i[c]];
            }
            return a;
        }), zn(r, "removeByPath", function(s, i = {}) {
            let a = s.split("."), c = e;
            for(let l = 0; l < a.length - 1; l++){
                if (c == null) return e;
                c = c[a[l]];
            }
            return c && delete c[a[a.length - 1]], e;
        }), zn(r, "reset", function(s = {}) {
            let i = e.$parse();
            return e.$set(i, s);
        }), zn(r, "apply", function(s, i = {}) {
            if (typeof s == "function") {
                let a = s(e);
                return e.$update(a, i);
            }
        }), zn(r, "applyFunction", function(s, i = {}) {
            if (typeof s == "function") return s(e), e.$update(e.$parse(), i);
        }), zn(r, "rootUpdate", function(s, i = {}) {
            let a = e;
            for(; a?.parent && xt(a.parent);)a = a.parent;
            return kd(a, "update", s, i);
        }), zn(r, "parentUpdate", function(s, i = {}) {
            if (e.parent) return kd(e.parent, "update", s, i);
        }), zn(r, "quietReplace", function(s, i = {}) {
            return e.$replace(s, {
                quiet: !0,
                ...i
            });
        }), Object.getOwnPropertyDescriptor(r, "root") || Object.defineProperty(r, "root", {
            get: function() {
                let s = e, i = xt(s) ? s : null;
                for(let a = 0; a < 64 && s?.parent && s.parent !== s; a++)s = s.parent, xt(s) && (i = s);
                return i || s;
            },
            enumerable: !1,
            configurable: !0
        });
        return;
    }
    if (!e || typeof e != "object") return;
    let n = ()=>{
        for(let r in e)Object.prototype.hasOwnProperty.call(e, r) && delete e[r];
    }, o = {
        update (r) {
            if (!r || typeof r != "object") return e;
            for(let s in r)e[s] = r[s];
            return e;
        },
        apply (r) {
            if (typeof r != "function") return e;
            let s = r(e);
            return s ? e.$update(s) : e;
        },
        parse () {
            return {
                ...e
            };
        },
        toggle (r) {
            return e[r] = !e[r], e;
        },
        set (r) {
            if (!r || typeof r != "object") return e;
            n();
            for(let s in r)e[s] = r[s];
            return e;
        },
        replace (r) {
            return e.$set(r);
        },
        clean () {
            return n(), e;
        }
    };
    xd(e, "$settled", function() {
        return eh().then(()=>e);
    });
    for(let r in o)if (xd(e, "$" + r, o[r]), typeof e[r] != "function") {
        if (Object.prototype.hasOwnProperty.call(e, r)) {
            rh(r, "");
            continue;
        }
        xd(e, r, o[r]);
    }
};
var jT = function(t, e, n) {
    return t.state = cy(t, e, n), t.state;
}, cy = function(t, e, n) {
    let { __ref: o } = t, r = t.state;
    if (r == null || r === !1) {
        let s = e?.state || {};
        return Le(t, s), s;
    }
    if (typeof r == "string") return o && (o.__state = r), o.__stateType = "string", X9(r, t, e);
    if (typeof r == "number" || typeof r == "boolean") {
        o && (o.__state = r, o.__stateType = typeof r, o.__hasRootState = !0);
        let s = vo({
            value: r
        });
        return s.__element = t, e?.state && (s.parent = e.state), Le(t, s), s;
    }
    if (typeof r == "function" && (r = r(t, e?.state) || {}), typeof r == "object" && !xt(r)) {
        o && (o.__hasRootState = !0), r.isRootState && o && (o.__hasRootState = !0);
        let s = vo({
            ...r
        });
        if (s.__element = t, !Object.getOwnPropertyDescriptor(s, "root")) {
            let i = e?.state?.root || e?.state || s;
            Object.defineProperty(s, "root", {
                get: ()=>i,
                enumerable: !1,
                configurable: !0
            });
        }
        return e?.state && (s.parent = e.state, e.state.__children && (e.state.__children[t.key] = s)), Le(t, s), typeof t.onStateCreated == "function" && t.onStateCreated(t, s, t.context, n), s;
    }
    return xt(r) ? (r.__element = t, r) : e?.state || {};
};
function $T(t, e) {
    if (!e) return t;
    let n = e.split("/"), o = t;
    for (let r of n){
        if (o == null) return {};
        o = o[r];
    }
    return o ?? {};
}
function X9(t, e, n) {
    if (!n?.state) return {};
    if (t === ".") return n.state;
    if (t.startsWith("../")) {
        let r = t.slice(3), s = n.state?.parent;
        return r && s ? $T(s, r) : s ?? n.state ?? {};
    }
    if (t.startsWith("~/")) {
        let r = n.state;
        for(; r?.parent;)r = r.parent;
        let s = t.slice(2);
        return s ? $T(r, s) : r ?? {};
    }
    let o = $T(n.state, t);
    if (o && typeof o == "object" && !xt(o) && !Object.getOwnPropertyDescriptor(o, "root")) {
        let r = n.state?.root || n.state;
        Object.defineProperty(o, "root", {
            get: ()=>r,
            enumerable: !1,
            configurable: !0
        });
    }
    return o;
}
var UT = (t, e)=>{
    if (!t) return nI;
    let n = Q9(t, e);
    return !n || !n.state ? nI : tK(n.state);
}, HT = ()=>$e() != null, Z9 = 128;
function Q9(t, e) {
    let n = typeof e == "function" ? e : typeof e == "string" ? (s)=>!!s?.[e] : (s)=>!!s?.state, o = t, r = null;
    for(let s = 0; s < Z9 && o; s++){
        if (n(o) && o.state) return o;
        if (o.state && !r && (r = o), !o.parent || o.parent === o) break;
        o = o.parent;
    }
    return r;
}
var J9 = {
    get (t, e) {
        return t[e];
    }
}, eI = new WeakMap, tK = (t)=>{
    let e = eI.get(t);
    return e || (e = new Proxy(t, J9), eI.set(t, e)), e;
}, nI = new Proxy(Object.create(null), {
    get () {},
    has () {
        return !1;
    }
});
var eK = [
    "alert",
    "alertdialog",
    "application",
    "article",
    "banner",
    "button",
    "cell",
    "checkbox",
    "columnheader",
    "combobox",
    "complementary",
    "contentinfo",
    "definition",
    "dialog",
    "directory",
    "document",
    "feed",
    "figure",
    "form",
    "grid",
    "gridcell",
    "group",
    "heading",
    "img",
    "link",
    "list",
    "listbox",
    "listitem",
    "log",
    "main",
    "marquee",
    "math",
    "menu",
    "menubar",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "navigation",
    "none",
    "note",
    "option",
    "presentation",
    "progressbar",
    "radio",
    "radiogroup",
    "region",
    "row",
    "rowgroup",
    "rowheader",
    "scrollbar",
    "search",
    "searchbox",
    "separator",
    "slider",
    "spinbutton",
    "status",
    "switch",
    "tab",
    "table",
    "tablist",
    "tabpanel",
    "term",
    "textbox",
    "timer",
    "toolbar",
    "tooltip",
    "tree",
    "treegrid",
    "treeitem"
], nK = [
    "alignment-baseline",
    "baseline-shift",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "color-interpolation",
    "color-interpolation-filters",
    "color-rendering",
    "cursor",
    "direction",
    "display",
    "dominant-baseline",
    "fill-opacity",
    "fill-rule",
    "filter",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "mask",
    "mask-type",
    "opacity",
    "overflow",
    "paint-order",
    "pointer-events",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-overflow",
    "text-rendering",
    "transform",
    "transform-origin",
    "unicode-bidi",
    "vector-effect",
    "visibility",
    "white-space",
    "word-spacing",
    "writing-mode"
], oK = [
    "requiredExtensions",
    "systemLanguage"
], oI = {
    circle: [
        "cx",
        "cy",
        "r",
        "pathLength"
    ],
    ellipse: [
        "cx",
        "cy",
        "rx",
        "ry",
        "pathLength"
    ],
    line: [
        "x1",
        "y1",
        "x2",
        "y2",
        "pathLength"
    ],
    path: [
        "d",
        "pathLength"
    ],
    polygon: [
        "points",
        "pathLength"
    ],
    polyline: [
        "points",
        "pathLength"
    ],
    rect: [
        "x",
        "y",
        "width",
        "height",
        "rx",
        "ry",
        "pathLength"
    ],
    g: [],
    defs: [],
    switch: [],
    symbol: [
        "viewBox",
        "preserveAspectRatio",
        "refX",
        "refY",
        "x",
        "y",
        "width",
        "height"
    ],
    use: [
        "href",
        "xlink:href",
        "x",
        "y",
        "width",
        "height"
    ],
    image: [
        "href",
        "xlink:href",
        "x",
        "y",
        "width",
        "height",
        "preserveAspectRatio",
        "crossorigin"
    ],
    foreignObject: [
        "x",
        "y",
        "width",
        "height"
    ],
    text: [
        "x",
        "y",
        "dx",
        "dy",
        "rotate",
        "textLength",
        "lengthAdjust"
    ],
    tspan: [
        "x",
        "y",
        "dx",
        "dy",
        "rotate",
        "textLength",
        "lengthAdjust"
    ],
    textPath: [
        "href",
        "xlink:href",
        "path",
        "startOffset",
        "method",
        "spacing",
        "side",
        "textLength",
        "lengthAdjust"
    ],
    linearGradient: [
        "x1",
        "y1",
        "x2",
        "y2",
        "gradientUnits",
        "gradientTransform",
        "spreadMethod",
        "href",
        "xlink:href"
    ],
    radialGradient: [
        "cx",
        "cy",
        "r",
        "fx",
        "fy",
        "fr",
        "gradientUnits",
        "gradientTransform",
        "spreadMethod",
        "href",
        "xlink:href"
    ],
    stop: [
        "offset"
    ],
    pattern: [
        "x",
        "y",
        "width",
        "height",
        "patternUnits",
        "patternContentUnits",
        "patternTransform",
        "viewBox",
        "preserveAspectRatio",
        "href",
        "xlink:href"
    ],
    clipPath: [
        "clipPathUnits"
    ],
    mask: [
        "x",
        "y",
        "width",
        "height",
        "maskUnits",
        "maskContentUnits"
    ],
    marker: [
        "viewBox",
        "preserveAspectRatio",
        "refX",
        "refY",
        "markerUnits",
        "markerWidth",
        "markerHeight",
        "orient"
    ],
    filter: [
        "x",
        "y",
        "width",
        "height",
        "filterUnits",
        "primitiveUnits"
    ]
}, rK = new Set([
    "linearGradient",
    "radialGradient",
    "stop",
    "clipPath",
    "mask",
    "marker",
    "pattern",
    "filter",
    "symbol"
]), sK = ()=>{
    let t = {};
    for(let e in oI)t[e] = [
        ...oI[e],
        ...rK.has(e) ? [] : oK,
        ...nK
    ];
    return t;
}, tr = {
    default: [
        "accesskey",
        "autofocus",
        "class",
        "contenteditable",
        "contextmenu",
        "dir",
        "draggable",
        "enterkeyhint",
        "exportparts",
        "headingoffset",
        "headingreset",
        "hidden",
        "id",
        "inputmode",
        "lang",
        "nonce",
        "part",
        "popover",
        "slot",
        "spellcheck",
        "style",
        "tabindex",
        "title",
        "translate",
        "writingsuggestions",
        "inert",
        "radiogroup",
        "role",
        "about",
        "datatype",
        "inlist",
        "prefix",
        "property",
        "resource",
        "typeof",
        "vocab",
        "autocapitalize",
        "autocorrect",
        "autosave",
        "color",
        "itemprop",
        "itemscope",
        "itemtype",
        "itemid",
        "itemref",
        "results",
        "security",
        "unselectable",
        "is"
    ],
    a: [
        "accesskey",
        "charset",
        "coords",
        "download",
        "href",
        "hreflang",
        "name",
        "ping",
        "referrerpolicy",
        "rel",
        "rev",
        "shape",
        "target",
        "type"
    ],
    aria: [
        "aria-activedescendant",
        "aria-atomic",
        "aria-autocomplete",
        "aria-checked",
        "aria-colcount",
        "aria-colindex",
        "aria-colspan",
        "aria-controls",
        "aria-current",
        "aria-describedby",
        "aria-details",
        "aria-dropeffect",
        "aria-errormessage",
        "aria-expanded",
        "aria-flowto",
        "aria-grabbed",
        "aria-haspopup",
        "aria-hidden",
        "aria-invalid",
        "aria-keyshortcuts",
        "aria-label",
        "aria-labelledby",
        "aria-level",
        "aria-live",
        "aria-modal",
        "aria-multiline",
        "aria-multiselectable",
        "aria-orientation",
        "aria-owns",
        "aria-placeholder",
        "aria-posinset",
        "aria-pressed",
        "aria-readonly",
        "aria-relevant",
        "aria-required",
        "aria-roledescription",
        "aria-rowcount",
        "aria-rowindex",
        "aria-rowspan",
        "aria-selected",
        "aria-setsize",
        "aria-sort",
        "aria-valuemax",
        "aria-valuemin",
        "aria-valuenow",
        "aria-valuetext"
    ],
    anchor: [
        "download",
        "href",
        "hreflang",
        "media",
        "ping",
        "rel",
        "target",
        "type",
        "referrerpolicy"
    ],
    audio: [
        "autoplay",
        "controls",
        "crossorigin",
        "loading",
        "loop",
        "muted",
        "preload",
        "src"
    ],
    area: [
        "alt",
        "coords",
        "download",
        "href",
        "hreflang",
        "media",
        "referrerpolicy",
        "rel",
        "shape",
        "target",
        "ping"
    ],
    base: [
        "href",
        "target"
    ],
    blockquote: [
        "cite"
    ],
    button: [
        "command",
        "commandfor",
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "name",
        "popovertarget",
        "popovertargetaction",
        "type",
        "value"
    ],
    canvas: [
        "height",
        "width"
    ],
    col: [
        "span",
        "width"
    ],
    colgroup: [
        "span"
    ],
    data: [
        "value"
    ],
    details: [
        "name",
        "open"
    ],
    del: [
        "cite",
        "datetime"
    ],
    dialog: [
        "closedby",
        "open"
    ],
    embed: [
        "height",
        "src",
        "type",
        "width"
    ],
    fieldset: [
        "disabled",
        "form",
        "name"
    ],
    form: [
        "accept-charset",
        "acceptcharset",
        "action",
        "autocomplete",
        "enctype",
        "method",
        "name",
        "novalidate",
        "target",
        "rel"
    ],
    html: [
        "manifest"
    ],
    iframe: [
        "allow",
        "allowfullscreen",
        "allowtransparency",
        "frameborder",
        "height",
        "loading",
        "marginheight",
        "marginwidth",
        "mozallowfullscreen",
        "name",
        "referrerpolicy",
        "sandbox",
        "scrolling",
        "seamless",
        "src",
        "srcdoc",
        "webkitallowfullscreen",
        "width"
    ],
    img: [
        "alt",
        "controls",
        "crossorigin",
        "decoding",
        "fetchpriority",
        "height",
        "ismap",
        "loading",
        "referrerpolicy",
        "sizes",
        "src",
        "srcset",
        "usemap",
        "width"
    ],
    ins: [
        "cite",
        "datetime"
    ],
    input: [
        "accept",
        "alpha",
        "alt",
        "autocomplete",
        "capture",
        "checked",
        "colorspace",
        "crossorigin",
        "dirname",
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "height",
        "indeterminate",
        "list",
        "max",
        "maxlength",
        "min",
        "minlength",
        "multiple",
        "name",
        "pattern",
        "placeholder",
        "popovertarget",
        "popovertargetaction",
        "readonly",
        "required",
        "size",
        "src",
        "step",
        "type",
        "value",
        "width"
    ],
    keygen: [
        "challenge",
        "disabled",
        "form",
        "keytype",
        "keyparams",
        "name"
    ],
    label: [
        "form",
        "for"
    ],
    li: [
        "value"
    ],
    link: [
        "as",
        "blocking",
        "crossorigin",
        "disabled",
        "fetchpriority",
        "href",
        "hreflang",
        "integrity",
        "media",
        "imagesrcset",
        "imagesizes",
        "referrerpolicy",
        "rel",
        "sizes",
        "type",
        "charset"
    ],
    map: [
        "name"
    ],
    menu: [
        "type"
    ],
    media: [
        "autoplay",
        "controls",
        "currenttime",
        "defaultmuted",
        "defaultplaybackrate",
        "loop",
        "mediagroup",
        "muted",
        "playsinline",
        "preload",
        "src",
        "volume"
    ],
    meta: [
        "charset",
        "content",
        "http-equiv",
        "name",
        "media"
    ],
    meter: [
        "form",
        "high",
        "low",
        "max",
        "min",
        "optimum",
        "value"
    ],
    quote: [
        "cite"
    ],
    object: [
        "classid",
        "data",
        "form",
        "height",
        "name",
        "type",
        "usemap",
        "width",
        "wmode"
    ],
    ol: [
        "reversed",
        "start",
        "type"
    ],
    optgroup: [
        "disabled",
        "label"
    ],
    option: [
        "disabled",
        "label",
        "selected",
        "value"
    ],
    output: [
        "form",
        "for",
        "name"
    ],
    param: [
        "name",
        "value"
    ],
    progress: [
        "max",
        "value"
    ],
    q: [
        "cite"
    ],
    slot: [
        "name"
    ],
    script: [
        "async",
        "blocking",
        "charset",
        "crossorigin",
        "defer",
        "fetchpriority",
        "integrity",
        "nomodule",
        "nonce",
        "referrerpolicy",
        "src",
        "type"
    ],
    select: [
        "autocomplete",
        "disabled",
        "form",
        "multiple",
        "name",
        "required",
        "size",
        "value",
        "onchange"
    ],
    source: [
        "height",
        "media",
        "sizes",
        "src",
        "srcset",
        "type",
        "width"
    ],
    style: [
        "blocking",
        "media",
        "nonce",
        "scoped",
        "type"
    ],
    table: [
        "align",
        "bgcolor",
        "border",
        "cellpadding",
        "cellspacing",
        "frame",
        "rules",
        "summary",
        "width"
    ],
    template: [
        "for",
        "shadowrootclonable",
        "shadowrootcustomelementregistry",
        "shadowrootdelegatesfocus",
        "shadowrootmode",
        "shadowrootserializable",
        "shadowrootslotassignment"
    ],
    textarea: [
        "autocomplete",
        "cols",
        "dirname",
        "disabled",
        "form",
        "maxlength",
        "minlength",
        "name",
        "placeholder",
        "readonly",
        "required",
        "rows",
        "value",
        "wrap"
    ],
    td: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr",
        "height",
        "width",
        "valign"
    ],
    th: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr"
    ],
    time: [
        "datetime"
    ],
    track: [
        "default",
        "kind",
        "label",
        "src",
        "srclang"
    ],
    video: [
        "autoplay",
        "controls",
        "crossorigin",
        "disablepictureinpicture",
        "disableremoteplayback",
        "height",
        "loading",
        "loop",
        "muted",
        "playsinline",
        "poster",
        "preload",
        "src",
        "width"
    ],
    svg: [
        "className",
        "class",
        "color",
        "height",
        "id",
        "lang",
        "max",
        "media",
        "method",
        "min",
        "name",
        "style",
        "target",
        "type",
        "width",
        "role",
        "tabindex",
        "crossorigin",
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "allowReorder",
        "alphabetic",
        "amplitude",
        "arabic-form",
        "ascent",
        "attributeName",
        "attributeType",
        "autoReverse",
        "azimuth",
        "baseFrequency",
        "baseline-shift",
        "baseProfile",
        "bbox",
        "begin",
        "bias",
        "by",
        "calcMode",
        "cap-height",
        "clip",
        "clip-path",
        "clipPathUnits",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "contentScriptType",
        "contentStyleType",
        "cursor",
        "cx",
        "cy",
        "d",
        "decelerate",
        "descent",
        "diffuseConstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "dx",
        "dy",
        "edgeMode",
        "elevation",
        "enable-background",
        "end",
        "exponent",
        "externalResourcesRequired",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterRes",
        "filterUnits",
        "flood-color",
        "flood-opacity",
        "focusable",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "format",
        "from",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "glyphRef",
        "gradientTransform",
        "gradientUnits",
        "hanging",
        "href",
        "horiz-adv-x",
        "horiz-origin-x",
        "ideographic",
        "image-rendering",
        "in2",
        "in",
        "intercept",
        "k1",
        "k2",
        "k3",
        "k4",
        "k",
        "kernelMatrix",
        "kernelUnitLength",
        "kerning",
        "keyPoints",
        "keySplines",
        "keyTimes",
        "lengthAdjust",
        "letter-spacing",
        "lighting-color",
        "limitingConeAngle",
        "local",
        "marker-end",
        "markerHeight",
        "marker-mid",
        "marker-start",
        "markerUnits",
        "markerWidth",
        "mask",
        "maskContentUnits",
        "maskUnits",
        "mathematical",
        "mode",
        "numOctaves",
        "opacity",
        "operator",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "path",
        "pathLength",
        "patternContentUnits",
        "patternTransform",
        "patternUnits",
        "pointer-events",
        "points",
        "pointsAtX",
        "pointsAtY",
        "pointsAtZ",
        "preserveAlpha",
        "preserveAspectRatio",
        "primitiveUnits",
        "r",
        "radius",
        "refX",
        "refY",
        "rendering-intent",
        "repeatCount",
        "repeatDur",
        "requiredExtensions",
        "requiredFeatures",
        "restart",
        "result",
        "rotate",
        "rx",
        "ry",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "spacing",
        "specularConstant",
        "specularExponent",
        "speed",
        "spreadMethod",
        "startOffset",
        "stdDeviation",
        "stemh",
        "stemv",
        "stitchTiles",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "string",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "surfaceScale",
        "systemLanguage",
        "tableValues",
        "targetX",
        "targetY",
        "text-anchor",
        "text-decoration",
        "textLength",
        "text-rendering",
        "to",
        "transform",
        "u1",
        "u2",
        "underline-position",
        "underline-thickness",
        "unicode",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "values",
        "vector-effect",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "v-hanging",
        "v-ideographic",
        "viewBox",
        "viewTarget",
        "visibility",
        "v-mathematical",
        "widths",
        "word-spacing",
        "writing-mode",
        "x1",
        "x2",
        "x",
        "xChannelSelector",
        "x-height",
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:href",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type",
        "xml:base",
        "xml:lang",
        "xmlns",
        "xmlns:xlink",
        "xml:space",
        "y1",
        "y2",
        "y",
        "yChannelSelector",
        "z",
        "zoomAndPan"
    ],
    ...sK()
}, cI = [
    "oncopy",
    "oncut",
    "onpaste",
    "oncompositionend",
    "oncompositionstart",
    "oncompositionupdate",
    "onfocus",
    "onfocusin",
    "onfocusout",
    "onblur",
    "onchange",
    "onbeforeinput",
    "oninput",
    "onreset",
    "onsubmit",
    "oninvalid",
    "onformdata",
    "onload",
    "onerror",
    "ontoggle",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onabort",
    "oncanplay",
    "oncanplaythrough",
    "oncuechange",
    "ondurationchange",
    "onemptied",
    "onencrypted",
    "onended",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onpause",
    "onplay",
    "onplaying",
    "onprogress",
    "onratechange",
    "onseeked",
    "onseeking",
    "onstalled",
    "onsuspend",
    "ontimeupdate",
    "onvolumechange",
    "onwaiting",
    "onauxclick",
    "onclick",
    "oncontextmenu",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragexit",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onselect",
    "onselectionchange",
    "onselectstart",
    "ontouchcancel",
    "ontouchend",
    "ontouchmove",
    "ontouchstart",
    "ongotpointercapture",
    "onpointercancel",
    "onpointerdown",
    "onpointerenter",
    "onpointerleave",
    "onpointermove",
    "onpointerout",
    "onpointerover",
    "onpointerup",
    "onlostpointercapture",
    "onscroll",
    "onresize",
    "onwheel",
    "onanimationstart",
    "onanimationend",
    "onanimationiteration",
    "ontransitionstart",
    "ontransitionrun",
    "ontransitionend",
    "ontransitioncancel",
    "onoutrostart",
    "onoutroend",
    "onintrostart",
    "onintroend",
    "onmessage",
    "onmessageerror",
    "onvisibilitychange",
    "oncancel",
    "onclose",
    "onfullscreenchange",
    "onfullscreenerror"
], lI = (t)=>t.startsWith("aria") && t.length > 4 && t.charCodeAt(4) >= 65 && t.charCodeAt(4) <= 90 ? "aria-" + t.charAt(4).toLowerCase() + t.slice(5).replace(/([A-Z])/g, (e)=>"-" + e.toLowerCase()) : t.startsWith("data") && t.length > 4 && t.charCodeAt(4) >= 65 && t.charCodeAt(4) <= 90 ? "data-" + t.charAt(4).toLowerCase() + t.slice(5).replace(/([A-Z])/g, (e)=>"-" + e.toLowerCase()) : null, rI = new Map, er = (t)=>{
    let e = rI.get(t);
    return e === void 0 && (e = lI(t) || dI(t), rI.set(t, e)), e;
}, fI = new Set([
    "tabIndex",
    "readOnly",
    "maxLength",
    "minLength",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "contentEditable",
    "spellCheck",
    "colSpan",
    "rowSpan",
    "srcSet",
    "crossOrigin",
    "accessKey",
    "inputMode",
    "enterKeyHint",
    "formAction",
    "noValidate",
    "autoCapitalize",
    "autoCorrect",
    "writingSuggestions",
    "headingOffset",
    "headingReset",
    "exportParts"
]), zT = new Set;
for(let t in tr)t === "default" || t === "aria" || t === "svg" || tr[t].forEach((e)=>{
    e.startsWith("on") || zT.add(e);
});
var uI = (t)=>{
    let e = t.charCodeAt(0);
    if (e < 97 || e > 122 || !/[A-Z]/.test(t)) return null;
    let n = t.replace(/[A-Z]/g, (r)=>"-" + r.toLowerCase());
    if (zT.has(n)) return n;
    let o = t.toLowerCase();
    return zT.has(o) ? o : null;
}, dI = (t)=>fI.has(t) ? t.toLowerCase() : uI(t), iK = new Set([
    "draggable",
    "contenteditable",
    "spellcheck",
    "autocorrect",
    "writingsuggestions",
    "translate"
]), aK = new Map([
    [
        "autocorrect",
        [
            "on",
            "off"
        ]
    ],
    [
        "translate",
        [
            "yes",
            "no"
        ]
    ]
]), vi = (t)=>typeof t == "string" && (iK.has(t) || t.startsWith("aria-")), mo = (t, e)=>{
    if (e !== !0 && e !== !1) return e;
    if (vi(t)) {
        let n = aK.get(t);
        return n ? e ? n[0] : n[1] : e ? "true" : "false";
    }
    return e === !0 ? "" : e;
}, sI = new Map, qe = (t, e)=>{
    let n = tr.default, o = Object.prototype.hasOwnProperty.call(tr, t) ? tr[t] : null, r = o ? o.length : -1, s = sI.get(t);
    (!s || s.def !== n || s.defLen !== n.length || s.own !== o || s.ownLen !== r) && (s = {
        def: n,
        defLen: n.length,
        own: o,
        ownLen: r,
        answers: new Map
    }, sI.set(t, s));
    let i = s.answers.get(e);
    return i === void 0 && (i = cK(t, e), s.answers.set(e, i)), i;
}, cK = (t, e)=>{
    if (e.startsWith("aria-") || e.startsWith("data-") || lI(e) || fI.has(e) || tr.default.includes(e)) return !0;
    if (Object.prototype.hasOwnProperty.call(tr, t)) {
        let n = tr[t];
        if (n.includes(e)) return !0;
        let o = uI(e);
        return o !== null && n.includes(o);
    }
    return !1;
}, KT = (t)=>{
    if (!E(t)) return !1;
    let e = t.toLowerCase();
    return cI.includes(e);
}, lK = (t, e, n)=>{
    let o = {};
    for(let r in e)if (Object.prototype.hasOwnProperty.call(e, r)) {
        if (n && r in n) continue;
        if (r === "aria" && e[r] && typeof e[r] == "object") {
            for(let a in e[r])jt(e[r][a]) && (o["aria-" + a] = e[r][a]);
            continue;
        }
        if (r === "data" && e[r] && typeof e[r] == "object") {
            for(let a in e[r])if (jt(e[r][a])) {
                let c = a.replace(/([A-Z])/g, (l)=>"-" + l.toLowerCase());
                o["data-" + c] = e[r][a];
            }
            continue;
        }
        let s = qe(t, r), i = KT(r);
        if (jt(e[r]) && (s || i)) {
            let a = er(r) || r;
            o[a] = e[r];
        }
    }
    return o;
}, fK = (t, e)=>{
    let n = {};
    if (t.attr) for(let o in t.attr)n[o] = t.attr[o](e, e.state, e.context);
    if (t.aria && typeof t.aria == "object") for(let o in t.aria){
        let r = t.aria[o];
        typeof r == "function" && (n["aria-" + o] = r(e, e.state, e.context));
    }
    if (t.data && typeof t.data == "object") for(let o in t.data){
        let r = t.data[o];
        if (typeof r == "function") {
            let s = o.replace(/([A-Z])/g, (i)=>"-" + i.toLowerCase());
            n["data-" + s] = r(e, e.state, e.context);
        }
    }
    return n;
}, Vr = (t, e)=>{
    let n = t.call("exec", e, t);
    if (n) return E(n) && n.includes("{{") && (n = t.call("replaceLiteralsWithObjectFields", n)), n;
}, WT = (t, e)=>{
    let n = (t.preSrc || "") + (Vr(t, e) || "");
    if (!n) return;
    try {
        return new URL(n), n;
    } catch  {}
    let { context: o } = t;
    if (!o.files && !o.assets) return n;
    if (n.startsWith("/assets/")) {
        let r = n.slice(8), s = o.assets && (o.assets[n] || o.assets[r]);
        return s && s.content ? s.content.src : n;
    }
    if (n.startsWith("/files/")) {
        let r = n.slice(7), s = o.files && (o.files[n] || o.files[r]);
        return s && s.content ? s.content.src : n;
    }
    if (o.assets) {
        let r = o.assets[n];
        if (r && r.content) return r.content.src;
    }
    if (o.files) {
        let r = o.files[n];
        if (r && r.content) return r.content.src;
    }
    return n;
}, iI = new WeakSet, ly = (t, e)=>{
    if (!E(e) || e.charAt(0) !== "/") return e;
    let n = e.charAt(1);
    if (n === "/" || n === "\\") return e;
    let o = t && t.context;
    if (!o) return e;
    let { functions: r, snippets: s, utils: i } = o, a = r && r.routerHref || s && s.routerHref || i && i.routerHref;
    if (!P(a)) return e;
    try {
        let c = a.call(t, e, t);
        return E(c) && c ? c : e;
    } catch (c) {
        return iI.has(a) || (iI.add(a), typeof console < "u" && console.warn("[smbls] routerHref threw; links keep the href as written", c)), e;
    }
}, uK = {
    a: !0,
    area: !0
}, zr = {
    src: (t)=>WT(t, t.src),
    href: (t)=>{
        let e = Vr(t, t.href);
        return uK[t.tag] ? ly(t, e) : e;
    },
    action: (t)=>Vr(t, t.action),
    poster: (t)=>WT(t, t.poster),
    data: (t)=>Vr(t, t.data)
}, GT = (t)=>{
    let e = t.tag || "div", n = {};
    for(let o in zr)if (t[o] !== void 0 && qe(e, o)) {
        let r = zr[o](t);
        r !== void 0 && (n[o] = r);
    }
    return n;
}, aI = (t, e)=>{
    let n = e.context?.cases?.[t];
    if (n !== void 0) return P(n) ? n.call(e, e) : !!n;
}, dK = (t, e, n)=>{
    if (t === "$") {
        let r = aI(e, n);
        return r === void 0 && (r = !!n[e]), r;
    }
    let o = n[e] === !0 || n.state[e];
    if (!o) {
        let r = aI(e, n);
        r !== void 0 && (o = r);
    }
    return t === "." ? !!o : !o;
}, pK = new Set([
    "$",
    ".",
    "!"
]), qT = (t, e, n, o = dK)=>{
    let r = {}, s = (i, a, c, l)=>{
        let f = a;
        r[i] = (u)=>{
            if (o(c, l, u)) return P(f) ? f(u, u.state, u.context) : f;
        };
    };
    for(let i in t){
        let a = i.charAt(0);
        if (!pK.has(a)) continue;
        let c = t[i];
        if (!c || typeof c != "object") continue;
        let l = i.slice(1);
        for(let f in c){
            if (n && f in n) continue;
            if (f === "aria" && c[f] && typeof c[f] == "object") {
                for(let g in c[f])s("aria-" + g, c[f][g], a, l);
                continue;
            }
            if (f === "data" && c[f] && typeof c[f] == "object") {
                for(let g in c[f]){
                    let h = g.replace(/([A-Z])/g, (m)=>"-" + m.toLowerCase());
                    s("data-" + h, c[f][g], a, l);
                }
                continue;
            }
            let u = qe(e, f), d = KT(f);
            if (!u && !d) continue;
            let p = er(f) || f;
            s(p, c[f], a, l);
        }
    }
    return r;
};
var fy = "3.14.832";
var pI = "__SMBLS_ELEMENT_ID_ENGINE__", hI = (t, e, n)=>{
    let o = e || fy, r = n || (typeof globalThis < "u" ? globalThis : null);
    if (!r) return t;
    let s = r[pI];
    return s && s.engine && s.version === o ? s.engine : (s || (r[pI] = {
        version: o,
        engine: t
    }), t);
};
var hK = new Set([
    "rows",
    "cols",
    "wrap",
    "fill",
    "stroke",
    "offset"
]), uy = (t, e)=>hK.has(e) && qe(t, e), Wr = (t, e)=>!!(St[e] || Ft && Ft.has(e)) && !uy(t, e);
var qI = hI({
    uniqId: 1,
    scopedStyleId: 0
}, fy), Nc = [], Kr = new Set, hE = !1, YI = 0, jc = null, Od = null;
function Vc() {
    return typeof Date < "u" && typeof Date.now == "function" ? Date.now() : 0;
}
function XI() {
    return typeof document < "u" && document.visibilityState === "hidden";
}
var gK = 250, mK = 1e3;
function yK() {
    return Od && (Od !== (typeof requestAnimationFrame == "function" ? requestAnimationFrame : null) || XI()) ? !0 : Vc() - YI >= mK;
}
function _K() {
    if (hE = !0, YI = Vc(), Od = null, typeof requestAnimationFrame != "function") {
        let t = typeof clearTimeout == "function" ? clearTimeout : null, e = setTimeout(Uc, 0);
        jc = t ? ()=>t(e) : null;
        return;
    }
    if (XI()) {
        let t = typeof clearTimeout == "function" ? clearTimeout : null, e = setTimeout(Uc, gK);
        jc = t ? ()=>t(e) : null;
    } else {
        let t = typeof cancelAnimationFrame == "function" ? cancelAnimationFrame : null;
        Od = requestAnimationFrame;
        let e = requestAnimationFrame(Uc);
        jc = t ? ()=>t(e) : null;
    }
}
function Md() {
    if (hE) {
        if (!yK()) return;
        let t = jc;
        if (jc = null, t) try {
            t();
        } catch  {}
    }
    _K();
}
var ZI = 300, QI = 15e4, aE = 0;
function Ri() {
    aE++;
    let t = !1;
    return ()=>{
        t || (t = !0, !(--aE > 0) && (Nc.length || Kr.size) && Md());
    };
}
function Uc() {
    if (hE = !1, jc = null, Od = null, aE > 0 || (Kr.size && D8(), !Nc.length)) return;
    let t = Nc.splice(0, Nc.length);
    for(let e = 0; e < t.length; e++){
        let n = t[e];
        if (n.node) {
            if (!n.node.isConnected) {
                let o = n.__ref || (n.__ref = {});
                o.__mountAttempts = (o.__mountAttempts || 0) + 1, o.__mountFirstAttemptAt == null && (o.__mountFirstAttemptAt = Vc());
                let r = Vc() - o.__mountFirstAttemptAt;
                o.__mountAttempts <= ZI && r < QI ? (Nc.push(n), Md()) : console.warn("[DOMQL] onMounted dropped after", o.__mountAttempts, "attempts /", r, "ms \u2014 node never connected:", n.key || n.tag || n);
                continue;
            }
            typeof n.onBridgeMount == "function" && sy(n), typeof n.onMounted == "function" && me("Mounted", n, n.__ref?.__mountOptions || {});
        }
    }
}
function cE(t, e) {
    let n = t.__ref?.__autoGrow;
    n && n.active && Id(t, !0), !(typeof t.onMounted != "function" && typeof t.onBridgeMount != "function") && (t.__ref.__mountOptions = e, Nc.push(t), Md());
}
function py(t, e) {
    typeof t.onContentUpdate == "function" && (Vn("contentUpdate", t, e), _n(t, ()=>{
        try {
            t.onContentUpdate(t, t.state, t.context, e);
        } catch (n) {
            if (bn(t, "onContentUpdate", n), t.context?.strictMode) throw n;
        }
    }));
}
function bK(t) {
    return t.toLowerCase();
}
function JI(t) {
    let e = t.charCodeAt(0);
    return e === 58 || e === 64 || e === 38 || e === 91;
}
function hy(t) {
    if (typeof t == "string") return t || void 0;
    if (typeof t == "number" || typeof t == "bigint") return String(t);
}
function tM(t, e, n, o) {
    return by(o, hy(t) || (e && typeof e == "object" ? hy(e.key) : void 0) || String(n));
}
function by(t, e) {
    if (!t || typeof e != "string") return e;
    let n = e;
    for(; SK(t, n);)n = "$" + n;
    return n !== e && wK(t, e, n), n;
}
function SK(t, e) {
    if (Kt.has(e) && e !== "content") return !0;
    if (!(e in t)) return !1;
    let n = t[e];
    return !(n && typeof n == "object" && n.__ref && n.parent === t);
}
var gI = new Set;
function wK(t, e, n) {
    return;
}
function Gt(t, e, n, o = {}, r) {
    if ($e()) return De(()=>Gt(t, e, n, o, r));
    if (t == null || t === !1) return null;
    let s = HK(t);
    (typeof t == "string" || typeof t == "number") && (t = {
        text: t
    }), n = hy(n);
    let i = hy(t.key), a = Object.create(null);
    a.key = n || (i && e ? by(e, i) : i) || `_${qI.uniqId++}`, a.parent = e || null, a.context = t.context || e?.context || o.context || {}, a.context.__create || (a.context.__create = Gt);
    let c = a.__ref = {
        __if: !0,
        __children: [],
        __exec: {},
        __effects: [],
        __eventCleanup: [],
        root: e?.__ref?.root || a,
        path: e?.__ref?.path ? [
            ...e.__ref.path,
            a.key
        ] : [
            a.key
        ],
        origin: t,
        __mount: null,
        __plainRows: null,
        __ifParked: null
    };
    s && (c.__runtimeSource = s);
    let l = r;
    r && (r.holdTail || r.deferAttach) && (r.holdTail && Q.mount !== null && Q.mount.hold(a), r.deferAttach && (Dc(c).attachLater = !0), l = void 0);
    let f = t;
    t = nM(a, t, n, i, e, o);
    let u = mE(a, c);
    if (u != null) {
        let m;
        if (typeof u == "function") try {
            m = u(a, a.state, a.context);
        } catch (y) {
            if (m = !1, c.__ifError = y, typeof console < "u" && console.warn) {
                let b = a.key || a.tag || "?";
                console.warn(`[smbls] \`if:\` evaluator threw on ${b} \u2014 treating as false:`, y?.message || y);
            }
        }
        else m = u;
        c.__if = !!m;
    }
    if (c.__if) typeof u == "function" && (c.__ifInitialized = !0);
    else {
        if (e) {
            e[a.key] = a;
            let y = e.__ref;
            y && (y.__ifParked || (y.__ifParked = new Set)).add(a.key);
        }
        let m = AK(t, n, a.context?.components);
        return m.length && (c.__ifLateMerge = {
            definition: f,
            key: n,
            ownKey: i,
            names: m,
            options: o
        }), typeof u == "function" && fM(a, c, u), a;
    }
    a.tag || (a.tag = Hn(a)), me("Init", a, o);
    let d = Q.hydration, p = a.node = d !== null && d.adopt(a) || Hr(a);
    if (!p) return a;
    let g = d !== null ? a.context?.__replacing : void 0;
    if (g && d.markReplaced(g, a, p), a.tag === "fragment") {
        let y = (a.context?.document || globalThis.document).createComment("");
        p.appendChild(y), c.__fragmentAnchor = y;
    }
    if (me("AttachNode", a, o), p.setAttribute && a.key && p.getAttribute("data-key") !== String(a.key) && p.setAttribute("data-key", a.key), e) {
        let m = e[a.key];
        e[a.key] = a;
        let y = e.__ref?.__children;
        y && (m === void 0 || !y.includes(a.key)) && y.push(a.key);
    }
    p.setAttribute && a.context?.scopeSelector && a.context.scopeSelector !== ":root" && a.context.key && a.key === a.context.key && p.setAttribute("data-smbls-app", a.context.key), a.id && p.setAttribute && (p.id = a.id), LM(a, o), cM(a), lM(a);
    try {
        IM(a, o);
    } catch (m) {
        Sy(a, m);
    }
    let h = c.__mount;
    return h !== null && h.pending > 0 ? (h.attachLater || (o.mountWhole === !0 && !(r && r.holdTail) && xK(a, e) ? h.held = !0 : zc(a, e, l)), h.tail = ()=>Q.mount.finish(a, o), a) : (Hc(a, !0), (h === null || !h.attachLater) && zc(a, e, l), gE(a, o), a);
}
function qr(t) {
    let e = t && t.__ref && t.__ref.__mount;
    return !e || !e.attachLater || (e.attachLater = !1, !t.node || t.__ref.__if === !1) ? !1 : (zc(t, t.parent), !0);
}
function xK(t, e) {
    if (!e || e.tag === "fragment") return !1;
    let n = t.node;
    if (!n || n.nodeType === 11) return !1;
    let o = e.node || (e.nodeType ? e : null);
    return !!o && n.parentNode !== o;
}
function eM(t) {
    let e = t.__ref, n = e && e.__mount;
    if (!n || !n.held || (n.held = !1, e.__if === !1)) return;
    let o = t.node, r = t.parent;
    if (!o || !r) return;
    let s = r.__ref;
    if (!s) {
        zc(t, r);
        return;
    }
    let i = r.node;
    if (!i) return;
    let a = s.__children, c = a ? a.lastIndexOf(t.key) : -1, l;
    for(let f = c - 1; f >= 0; f--){
        let u = r[a[f]], d = u && (nr(u) || (u.tag === "fragment" && u.__ref ? u.__ref.__fragmentAnchor : null));
        if (d && d.parentNode === i) {
            l = d.nextSibling;
            break;
        }
    }
    l === void 0 && (l = Sd(i, s.__textNode)), zc(t, r, l ? {
        position: "before",
        node: l
    } : void 0);
}
function Sy(t, e) {
    if (typeof console < "u" && console.error) {
        let n = t.__ref?.path?.join(".") || t.key || "<root>";
        console.error(`[smbls] createChildren failed at ${n}:`, e?.message || e, e?.stack ? `
` + e.stack.split(`
`).slice(0, 6).join(`
`) : "");
    }
    ki(t, {
        where: "createChildren",
        error: e
    });
}
var YT = [
    "Create",
    "Complete",
    "Render",
    "RenderRouter"
];
function gE(t, e) {
    typeof t.html == "function" && t.node && !t.node.innerHTML && _n(t, ()=>{
        try {
            let n = t.html(t, t.state, t.context);
            n != null && typeof n != "function" && (t.node.innerHTML = n);
        } catch  {}
    });
    for(let n = 0; n < YT.length; n++){
        if (me(YT[n], t, e), !t.__ref) return;
        YT[n] === "Render" && uE(t);
    }
    if (t.__ref.__if !== !1 && cE(t, e), typeof t.onFrame == "function") {
        let n = t.onFrame, o = t.context?.designSystem, r = ()=>{
            if (t.node) {
                if (t.node.isConnected) {
                    o && pt(o);
                    try {
                        n(t, t.state, t.context);
                    } catch (s) {
                        console.error("[DOMQL] onFrame error:", s);
                    } finally{
                        o && ut();
                    }
                }
                requestAnimationFrame(r);
            }
        };
        requestAnimationFrame(r);
    }
}
function gy(t, e) {
    let n = e && e.__ref && e.__ref.__mount;
    !n || !n.tail || n.holder || (n.holder = t, Q.mount.hold(t));
}
var kK = new Set([
    "childProps",
    "attr",
    "style",
    "scope",
    "data",
    "vars"
]);
function nM(t, e, n, o, r, s) {
    if (n && !e.extends && !e.extend) {
        let h = n.indexOf("_"), m = n.indexOf("."), y = h > 0 ? h : -1;
        if (m > 0 && (y < 0 || m < y) && (y = m), y > 0) {
            let b = n.substring(0, y), T = t.context?.components;
            T && (T[b] || T["smbls." + b]) ? e = {
                ...e,
                extends: b
            } : T;
        }
    }
    t.__ref && (t.__ref.__mergeLayer = null), vc(t, e, s);
    let i = DT(t), a = t.props && typeof t.props == "object" ? t.props : null;
    for(let h in e)if (!(h === "parent" || h === "node" || h === "__ref" || h === "extends" || h === "context" || h === "props")) {
        if (h === "key") {
            o && (t.key = r ? by(r, o) : o);
            continue;
        }
        i && i.mark(h), XT(t, h, e[h]);
    }
    if (a) for(let h in a)XT(t, h, a[h]);
    let c = e.props;
    if (c && typeof c == "object") {
        for(let h in c)XT(t, h, c[h]);
        if (i) for(let h in c)i.mark(h);
    }
    jP(t), e.classlist !== void 0 && (t.classlist = e.classlist), e.text !== void 0 && (t.text = e.text), e.html !== void 0 && (t.html = e.html);
    let l = t.scope && typeof t.scope == "object" ? t.scope : null, f = r?.scope, u = t.context && typeof t.context.globalScope == "object" && t.context.globalScope || null, d = f || u || null;
    if (e.scope !== void 0 || l) {
        let h = {};
        l && Object.assign(h, l), e.scope !== void 0 && Object.assign(h, e.scope), t.scope = oh(h, d);
    } else d && (t.scope = d);
    e.if !== void 0 && (t.if = e.if);
    let p = t.__ref, g = VK(t, p && p.__runtimeSource);
    return p && (p.__declaredArrays = g || void 0), Ic(t), vK(t, r, e, s), e;
}
function XT(t, e, n) {
    let o = t[e], r = Q.chains;
    if (r !== null && r(t, e, o, n)) return;
    let s = o && n && typeof o == "object" && typeof n == "object" && !Array.isArray(o) && !Array.isArray(n);
    s && e.charCodeAt(0) >= 65 && e.charCodeAt(0) <= 90 ? t[e] = Ge(o, n) : s && kK.has(e) ? t[e] = {
        ...o,
        ...n
    } : s && JI(e) ? t[e] = Ge(o, n) : t[e] = n;
}
var TK = new Set([
    "key",
    "parent",
    "context",
    "__ref"
]);
function EK(t, e) {
    for (let o of Object.keys(t))TK.has(o) || delete t[o];
    let n = e.definition;
    if (!n.extends && !n.extend && typeof e.key == "string") {
        let o = t.context?.components || {}, r = o[e.key] || o["smbls." + e.key];
        r && (n = {
            ...n,
            extends: r
        });
    }
    De(()=>nM(t, n, e.key, e.ownKey, t.parent, e.options));
}
function AK(t, e, n) {
    let o = n || {}, r = (a)=>!!(o[a] || o["smbls." + a]), s = [], i = [];
    if (t.extends && i.push(...Array.isArray(t.extends) ? t.extends : [
        t.extends
    ]), t.extend && i.push(...Array.isArray(t.extend) ? t.extend : [
        t.extend
    ]), i.length) {
        for (let a of i){
            if (typeof a != "string") continue;
            let c = a.includes(">") ? a.split(">")[0].trim() : a;
            r(c) || s.push(c);
        }
        return s;
    }
    if (typeof e == "string" && /^[A-Z]/.test(e)) {
        let a = -1, c = e.indexOf("_"), l = e.indexOf(".");
        c > 0 && (a = c), l > 0 && (a < 0 || l < a) && (a = l);
        let f = a > 0 ? e.substring(0, a) : e;
        r(f) || s.push(f);
    }
    return s;
}
function ZT(t, e, n) {
    if (typeof t.onStateInit != "function" && !LT(t, "stateInit")) return;
    let o = t.state;
    t.state = e;
    try {
        me("StateInit", t, n);
    } finally{
        t.state = o;
    }
}
var QT = (t)=>({
        isDataOnlyKey: (e)=>br(t).has(e)
    });
function vK(t, e, n, o) {
    let r = !e, s = n.state && typeof n.state == "object" && !Array.isArray(n.state) && Object.keys(n.state).length === 0, i = r && s && t.context?.state, a = n.state !== void 0 && !i ? n.state : t.state && !xt(t.state) ? t.state : void 0;
    if (a == null) {
        if (e?.state) t.state = e.state, Le(t, t.state);
        else if (t.context?.state) {
            let c = t.context.state, l = {
                ...c
            }, f = t.context?.polyglot;
            if (f?.translations) {
                let u = t.context, d = te(c.lang, f), p = new Set, g = (y, b)=>{
                    p.has(y) || Cs(u, y, l) && (l[y] = b, p.add(y), ro(u, y, b));
                }, h = f.translations[d];
                if (h && typeof h == "object") for(let y in h)g(y, h[y]);
                let m = new Set(we(f, !1));
                for(let y in f.translations)m.has(y) || g(y, f.translations[y]);
            }
            xt(l) || ZT(t, l, o), t.state = xt(l) ? l : vo(l, QT(t.context)), t.state.__element = t, t.state.root = t.state, Le(t, t.state), La?.(c, t.state), me("StateCreated", t, o);
        } else t.state = {}, Object.defineProperty(t.state, "root", {
            value: t.state,
            enumerable: !1,
            configurable: !0,
            writable: !0
        }), Le(t, t.state);
        return;
    }
    if (typeof a == "string") {
        if (t.state = rM(a, e), t.state && typeof t.state == "object" && !xt(t.state)) {
            let c = e?.state?.root || e?.state || t.state;
            Object.defineProperty(t.state, "root", {
                value: c,
                enumerable: !1,
                configurable: !0,
                writable: !0
            });
        }
        Le(t, t.state), CK(t, a, e), me("StateCreated", t, o);
        return;
    }
    if (typeof a == "function") {
        let c = a(t, e?.state);
        if (xt(c)) t.state = c;
        else {
            let l = c || {};
            ZT(t, l, o), t.state = vo(l, e?.state ? void 0 : QT(t.context));
        }
    } else if (xt(a)) t.state = a;
    else {
        let c = {
            ...a
        };
        ZT(t, c, o), t.state = vo(c, e?.state ? void 0 : QT(t.context));
    }
    t.state.__element = t, e?.state ? (t.state.parent = e.state, t.state.root = e.state.root || e.state) : t.state.root = t.state, Le(t, t.state), La?.(a, t.state), me("StateCreated", t, o);
}
function mI(t, e) {
    if (!e) return t;
    let n = e.split("/"), o = t;
    for (let r of n){
        if (o == null) return {};
        o = o[r];
    }
    return o ?? {};
}
function oM(t, e) {
    let n = e.state;
    return t.startsWith("~/") ? [
        n && (n.root || n),
        t.slice(2)
    ] : t.startsWith("../") ? [
        n,
        t.slice(3)
    ] : [
        n,
        t
    ];
}
function rM(t, e) {
    if (!e) return {};
    if (t === ".") return e.state || {};
    if (t.startsWith("../") || t.startsWith("~/")) {
        let [r, s] = oM(t, e);
        return s ? mI(r, s) : r ?? {};
    }
    if (e.state?.[t] !== void 0) return e.state[t];
    let n = mI(e.state, t);
    if (n != null && Object.keys(n).length > 0) return n;
    let o = e.context?.polyglot;
    if (o?.translations) {
        let r = te(e.state?.root?.lang, o), s = o.translations[r];
        if (s?.[t] !== void 0) return s[t];
        if (o.translations[t] !== void 0) return o.translations[t];
    }
    return {};
}
function OK(t, e) {
    let [n, o] = oM(t, e);
    if (!o || !n || typeof n != "object") return;
    let r = n[o];
    if (r !== void 0 || o.indexOf("/") === -1) return r;
    let s = n;
    for (let i of o.split("/")){
        if (s == null || typeof s != "object") return;
        s = s[i];
    }
    return s;
}
function CK(t, e, n) {
    let o = t.__ref;
    if (!o || !n || e === "." || !xt(n.state)) return;
    o.__stateBinding && o.__stateBinding.dispose();
    let r = De(()=>q(()=>{
            let s = OK(e, n);
            !s || typeof s != "object" || s === t.state || De(()=>sM(t, t.state, s, !0));
        }, {
            depth: o.path ? o.path.length : 0,
            label: yt(o, "state")
        }));
    r._isStateBinding = !0, o.__stateBinding = r, o.__effects && o.__effects.push(r);
}
function sM(t, e, n, o) {
    let r = t.__ref;
    if (!r) return;
    if (o || t.state === e) {
        t.state = n, o && Le(t, n), _I(r);
        let i = r.__children;
        if (i) for(let a = 0; a < i.length; a++){
            let c = t[i[a]];
            c && c.__ref && c.parent === t && sM(c, e, n, !1);
        }
        return;
    }
    if (r.__stateBinding) {
        r.__stateBinding._notify();
        return;
    }
    let s = t.state;
    s && typeof s == "object" && s.parent === e && (s.parent = n, _I(r));
}
function yI(t, e) {
    let n = t.__ifParked;
    if (!n || !n.size) return e;
    for (let o of n)e.includes(o) || e.push(o);
    return e;
}
function _I(t) {
    let e = t.__effects;
    if (e) for(let n = 0; n < e.length; n++){
        let o = e[n];
        o && !o._disposed && !o._isStateBinding && !o._isSubscribeToEffect && typeof o._notify == "function" && o._notify();
    }
}
var RK = new Set([
    "s",
    "state",
    "ctx",
    "context"
]), JT = new WeakMap;
function DK(t) {
    if (JT.has(t)) return JT.get(t);
    let e = null;
    try {
        let n = typeof Ue == "function" ? Ue(t) : Function.prototype.toString.call(t);
        if (typeof n == "string") {
            let o = n.match(/^\s*(?:async\s+)?([A-Za-z_$][\w$]*)\s*=>/) || n.match(/^[^(]*\(([^)]*)\)/);
            o && (e = {
                params: o[1].split(",").map((r)=>r.trim())
            });
        }
    } catch  {}
    return JT.set(t, e), e;
}
function LK(t) {
    let e = DK(t);
    return e ? e.params.map((n)=>n.split("=")[0].trim()).filter(Boolean) : [];
}
var PK = 3, IK = /^(is|has)[A-Z0-9_$]/, MK = new Set([
    "routerOptions"
]), bI = new WeakSet;
function BK(t, e) {
    if (typeof t != "function" || t.length !== 2 || e && (IK.test(e) || MK.has(e)) || bI.has(t)) return !1;
    let n = LK(t);
    if (n.length < 2) return !1;
    let o = n[1].replace(/[{}[\]]/g, "").trim();
    return o.length < PK || RK.has(o) ? !1 : (bI.add(t), !0);
}
function NK(t) {
    let e = t.__ref, n = t.tag || "div", o = t.context?.designSystem, r = [], s = Object.keys(t);
    for(let i = 0; i < s.length; i++){
        let a = s[i];
        if (typeof t[a] != "function" || Kt.has(a)) continue;
        let c = a.charCodeAt(0);
        c >= 65 && c <= 90 || yn(a) || St[a] || Ft && Ft.has(a) || c !== 45 && (qe(n, a) || r.push({
            prop: a,
            fn: t[a]
        }));
    }
    for(let i = 0; i < r.length; i++){
        let { prop: a, fn: c } = r[i];
        e.__exec[a] = c, Object.defineProperty(t, a, {
            get () {
                o && pt(o);
                try {
                    return c(t, t.state, t.context);
                } catch  {
                    return;
                } finally{
                    o && ut();
                }
            },
            set (l) {
                delete e.__exec[a], Object.defineProperty(t, a, {
                    value: l,
                    writable: !0,
                    configurable: !0,
                    enumerable: !0
                });
            },
            configurable: !0,
            enumerable: !0
        });
    }
}
function FK(t, e) {
    if (!(!Array.isArray(e) || e.length === 0)) for(let n = 0; n < e.length; n++){
        let o = e[n];
        try {
            typeof o == "function" ? o(t, t.state, t.context) : typeof o == "string" && t.state?.[o];
        } catch  {}
    }
}
function Ht(t, e, n) {
    return !Array.isArray(e) || e.length === 0 ? n : function(...o) {
        return FK(t, e), n.apply(this, o);
    };
}
function Bc(t, e) {
    if (!(!t || Array.isArray(t) || typeof t != "object")) return t[e];
}
function yt(t, e) {
    return ()=>t.path.join(".") + "::" + e;
}
var SI = new Set;
function oe(t, e, n) {
    return;
}
var wI = /(['"`])((?:\\.|(?!\1)[^\\])*)\1/g, xI = new WeakMap, $K = (t)=>{
    let e = xI.get(t);
    if (e !== void 0) return e;
    e = null;
    let n;
    try {
        n = String(t);
    } catch  {
        n = "";
    }
    if (n.includes("{{")) {
        wI.lastIndex = 0;
        let o;
        for(; (o = wI.exec(n)) !== null;)o[2].includes("{{") && (e || (e = [])).push(o[2]);
    }
    return xI.set(t, e), e;
}, jK = (t, e)=>{
    let n = $K(t);
    if (n) for(let o = 0; o < n.length; o++)e.add(n[o]);
}, UK = (t, e)=>!yn(t) && !Wr(e, t), tE = (t, e, n, o, r)=>{
    if (typeof e == "string") {
        !r && e.includes("{{") && n.add(e);
        return;
    }
    typeof e == "function" && UK(t, o) && jK(e, n);
}, lE = new WeakMap, Cd = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), Rd = (t)=>{
    if (typeof t == "string" || typeof t == "number") return {
        text: t
    };
    if (!t || typeof t != "object" || Array.isArray(t)) return null;
    let e = t.props;
    return e && typeof e == "object" && !Array.isArray(e) ? Ge(t, e) : t;
}, Dd = (t, e)=>t && e ? Ge(t, e) : t || e || null, iM = (t, e)=>{
    let n = t.__ref && t.__ref.__runtimeSource;
    return !!n && Cd(n, e);
}, Gr = (t, e)=>iM(t, e) ? Rd(t.__ref.__runtimeSource[e]) : null, Oi = (t, e)=>(e && t && typeof t == "object" && lE.set(t, e), t), HK = (t)=>{
    if (!t || typeof t != "object") return;
    let e = lE.get(t);
    return e && lE.delete(t), e;
}, fE = (t, e, n)=>{
    if (typeof t == "string") {
        t.includes("{{") && e.add(t);
        return;
    }
    if (!(!t || typeof t != "object" || n.has(t))) {
        if (n.add(t), Array.isArray(t)) {
            for(let o = 0; o < t.length; o++)fE(t[o], e, n);
            return;
        }
        if (!t.__ref) for (let o of Object.keys(t)){
            if (o === "state") continue;
            let r = Object.getOwnPropertyDescriptor(t, o);
            r && "value" in r && fE(r.value, e, n);
        }
    }
}, VK = (t, e)=>{
    let n = null;
    for (let o of Object.keys(t)){
        if (Kt.has(o) || e && Cd(e, o)) continue;
        let r = Object.getOwnPropertyDescriptor(t, o), s = r && r.value;
        if (!Array.isArray(s)) continue;
        let i = new Set;
        fE(s, i, new Set), i.size && (n || (n = new Map), n.set(s, i));
    }
    return n;
}, kI = (t, e)=>{
    if (Array.isArray(e)) for(let n = t; n; n = n.parent){
        let o = n.__ref && n.__ref.__declaredArrays, r = o && o.get(e);
        if (!r) continue;
        let s = t.__ref;
        s.__authoredTemplates || (s.__authoredTemplates = new Set);
        for (let i of r)s.__authoredTemplates.add(i);
        return;
    }
}, aM = [
    "attr",
    "aria",
    "data",
    "metadata"
], zK = (t)=>{
    if (aM.includes(t)) return !0;
    let e = t.charCodeAt(0);
    return e === 46 || e === 33 || e === 64;
}, WK = (t, e)=>{
    let n = new Set, o = t.tag || "div";
    for (let r of Object.keys(t)){
        let s = Object.getOwnPropertyDescriptor(t, r), i = s && s.value, a = !!e && Cd(e, r);
        if (i && typeof i == "object" && !Array.isArray(i)) {
            if (!zK(r)) continue;
            let c = a ? e[r] : null, l = c && typeof c == "object" ? c : null, f = r.charCodeAt(0) === 46 || r.charCodeAt(0) === 33;
            for(let u in i){
                let d = a && (!l || Cd(l, u)), p = i[u];
                if (f && p && typeof p == "object" && !Array.isArray(p) && aM.includes(u)) {
                    for(let g in p)tE(g, p[g], n, o, d);
                    continue;
                }
                tE(u, p, n, o, d);
            }
            continue;
        }
        tE(r, i, n, o, a);
    }
    return n;
};
function cM(t, e) {
    let n = t.__ref, o = !!(e && e.skipIfEffect), r = WK(t, n.__runtimeSource);
    if (n.__authoredTemplates) for (let l of r)n.__authoredTemplates.add(l);
    else n.__authoredTemplates = r;
    if (NK(t), typeof t.text == "function") {
        let l = t.text, f = Ht(t, t.textDeps, l), u = ()=>{
            let p = f(t, t.state, t.context);
            return t.node && typeof p == "string" && p.includes("{{") && (p = Zt.call(t, p, t.state)), p;
        }, d = q(()=>{
            if (!n.contentManaged) try {
                let p = EI(t, n, u);
                if (p === Pe) return;
                t.node && p != null && typeof p != "function" && typeof p != "object" && Ti(t, p);
            } catch (p) {
                oe(n, "text", p);
            }
        }, {
            depth: n.path.length,
            label: yt(n, "text")
        });
        n.__effects.push(d), n.__exec.text = l;
    } else if (typeof t.text == "string" && t.text.includes("{{")) {
        let l = t.text, f = ()=>Zt.call(t, l, t.state), u = q(()=>{
            if (n.contentManaged) return;
            let d = EI(t, n, f);
            d !== Pe && (d != null && (t.text = d), t.node && Ti(t, d ?? ""));
        }, {
            depth: n.path.length,
            label: yt(n, "text")
        });
        n.__effects.push(u), n.__exec.text = l;
    }
    let s = t.tag || "div";
    for (let l of Object.keys(t))if (typeof t[l] == "function" && !Kt.has(l) && !yn(l) && !n.__exec[l] && !uy(s, l)) {
        if (St[l]) {
            let f = t[l], u = Ht(t, t[l + "Deps"], f), d = l, p, g = null, h = null, m, y = ()=>{
                for (let v of h)t.node.classList.remove(v);
                h = null, m = void 0;
            }, b = ()=>{
                hM(t, d, g, null), dy(t, d, null), g = null;
            }, T = q(()=>{
                let v = t.context?.designSystem;
                v && pt(v);
                try {
                    let S = u(t, t.state, t.context);
                    Qm();
                    let w;
                    try {
                        w = St[d](S, t, t.state, t.context);
                    } finally{
                        Jm();
                    }
                    if (Array.isArray(w)) {
                        let _ = {};
                        for (let x of w)if (x) for(let A in x)_[A] = x[A];
                        w = _;
                    }
                    if (d === "show" || d === "hide") {
                        t.node && yy(t, d, !!(w && w.display), !0);
                        return;
                    }
                    if (w && t.node && qK(w)) {
                        let _ = Fc(w);
                        if (_ === null || _ !== m) {
                            m = _;
                            let x = Ke(Yr(t, w), null, t.context?.cssPrefix), A = x ? x.split(" ").filter(Boolean) : null;
                            if (t.node.classList) {
                                if (h) for (let O of h)t.node.classList.remove(O);
                                if (A && A.length) for (let O of A)t.node.classList.add(O);
                                h = A;
                            }
                        }
                        g && b(), p = void 0;
                    } else if (w && t.node) {
                        h && y();
                        let _ = Fc(w);
                        if (_ === null || _ !== p || !$c(t.node, g, t)) {
                            p = _;
                            let x = vI(t, w, g, d);
                            g = Ad(t.node, x, t), dy(t, d, g);
                        }
                    } else t.node && (h && y(), g && b(), p = void 0);
                } finally{
                    v && ut();
                }
            }, {
                depth: n.path.length,
                label: yt(n, d)
            });
            n.__effects.push(T), n.__exec[l] = f;
        } else if (Ft && Ft.has(l)) {
            let f = t[l], u = Ht(t, t[l + "Deps"], f), d = l, p, g = null, h = q(()=>{
                let m = t.context?.designSystem;
                m && pt(m);
                try {
                    let y = u(t, t.state, t.context);
                    if (t.node) {
                        if (y != null) {
                            let b = d + ":" + String(y);
                            if (b !== p || !$c(t.node, g, t)) {
                                p = b;
                                let T = {
                                    [d]: y
                                }, v = vI(t, T);
                                g = Ad(t.node, v, t), dy(t, d, g);
                            }
                        } else p = void 0, g = null, dy(t, d, null), d === "display" ? Bd(t, "") : t.node.style[d] = "";
                    }
                } finally{
                    m && ut();
                }
            }, {
                depth: n.path.length,
                label: yt(n, d)
            });
            n.__effects.push(h), n.__exec[l] = f;
        } else if (l.charCodeAt(0) === 45) {
            let f = t[l];
            mM(t, l, f, t[l + "Deps"], l), n.__exec[l] = f;
        }
    }
    if (ZK(t), typeof t.html == "function") {
        let l = t.html, f = Ht(t, t.htmlDeps, l), u = q(()=>{
            _n(t, ()=>{
                let d = f(t, t.state, t.context);
                t.node && d != null && typeof d != "function" && (t.node.innerHTML = d);
            });
        }, {
            depth: n.path.length,
            label: yt(n, "html")
        });
        n.__effects.push(u), n.__exec.html = l;
    }
    if (typeof t.value == "function") {
        let l = t.value, f = Ht(t, t.valueDeps, l), u = ()=>{
            let p = f(t, t.state, t.context);
            return typeof p == "string" && p.includes("{{") && (p = Zt.call(t, p, t.state)), p;
        }, d = q(()=>{
            try {
                let p = yo(t, n, "value", u);
                if (p === Pe) return;
                AI(t, p);
            } catch (p) {
                oe(n, "value", p);
            }
        }, {
            depth: n.path.length,
            label: yt(n, "value")
        });
        n.__effects.push(d), n.__exec.value = l;
    } else if (typeof t.value == "string" && t.value.includes("{{")) {
        let l = t.value, f = ()=>Zt.call(t, l, t.state), u = q(()=>{
            try {
                let d = yo(t, n, "value", f);
                if (d === Pe) return;
                AI(t, d);
            } catch (d) {
                oe(n, "value", d);
            }
        }, {
            depth: n.path.length,
            label: yt(n, "value")
        });
        n.__effects.push(u), n.__exec.value = l;
    }
    if (typeof t.style == "function") {
        let l = t.style, f = Ht(t, t.styleDeps, l), u, d = null, p, g, h, m, y = q(()=>{
            let b = f(t, t.state, t.context), T = t.context && t.context.designSystem, v;
            if (b && typeof b == "object" && b === p && T === h) {
                let w = Fc(b);
                v = w !== null && w === g ? m : Ai(t, b), g = w;
            } else v = Ai(t, b), g = void 0;
            p = b, h = T, m = v;
            let S = Fc(v);
            (S === null || S !== u || !$c(t.node, d, t)) && (u = S, dE(t.node, d, v, t), bo(t.node, v, t), d = Ad(t.node, v, t));
        }, {
            depth: n.path.length,
            label: yt(n, "style")
        });
        n.__effects.push(y), n.__exec.style = l;
    } else if (t.style && typeof t.style == "object") for(let l in t.style){
        let f = t.style[l];
        if (typeof f != "function") continue;
        let u = Ht(t, Bc(t.styleDeps, l), f), d, p = null, g = q(()=>{
            try {
                let h = u(t, t.state, t.context);
                if (t.node) {
                    let m = l + ":" + String(h);
                    if (m !== d || !$c(t.node, p, t)) {
                        d = m;
                        let y = Ai(t, {
                            [l]: h
                        });
                        dE(t.node, p, Object.assign({}, y, {
                            [l]: ""
                        }), t), bo(t.node, y, t), p = Ad(t.node, y, t);
                    }
                }
            } catch (h) {
                oe(n, "style." + l, h);
            }
        }, {
            depth: n.path.length,
            label: yt(n, "style." + l)
        });
        n.__effects.push(g);
    }
    if (t.attr && typeof t.attr == "object") {
        for(let l in t.attr)if (typeof t.attr[l] == "function") {
            let f = Ht(t, Bc(t.attrDeps, l), t.attr[l]), u = l, d = u.toLowerCase(), p = ()=>{
                let h = f(t, t.state, t.context);
                return typeof h == "string" && h.includes("{{") && (h = Zt.call(t, h, t.state)), h;
            }, g = q(()=>{
                try {
                    let h = yo(t, n, d, p);
                    if (h === Pe) return;
                    t.node?.setAttribute && Ei(t.node, u, h);
                } catch (h) {
                    oe(n, "attr." + u, h);
                }
            }, {
                depth: n.path.length,
                label: yt(n, "attr." + u)
            });
            g._attrName = u.toLowerCase(), n.__effects.push(g);
        } else if (typeof t.attr[l] == "string" && t.attr[l].includes("{{")) {
            let f = t.attr[l], u = l, d = u.toLowerCase(), p = ()=>Zt.call(t, f, t.state), g = q(()=>{
                try {
                    let h = yo(t, n, d, p);
                    if (h === Pe || !t.node || !t.node.setAttribute) return;
                    t.node.setAttribute(u, mo(u, h ?? ""));
                } catch (h) {
                    oe(n, "attr." + u, h);
                }
            }, {
                depth: n.path.length,
                label: yt(n, "attr." + u)
            });
            g._attrName = u.toLowerCase(), n.__effects.push(g);
        }
    }
    if (t.aria && typeof t.aria == "object") for(let l in t.aria){
        let f = t.aria[l];
        if (typeof f == "string" && f.includes("{{")) {
            let h = f, m = "aria-" + l.replace(/[A-Z]/g, (T)=>"-" + T.toLowerCase()), y = ()=>Zt.call(t, h, t.state), b = q(()=>{
                try {
                    let T = yo(t, n, m, y);
                    if (T === Pe || !t.node || !t.node.setAttribute) return;
                    t.node.setAttribute(m, mo(m, T ?? ""));
                } catch (T) {
                    oe(n, "aria." + l, T);
                }
            }, {
                depth: n.path.length,
                label: yt(n, "aria." + l)
            });
            b._attrName = m, n.__effects.push(b);
            continue;
        }
        if (typeof f != "function") continue;
        let u = Ht(t, Bc(t.ariaDeps, l), t.aria[l]), d = "aria-" + l.replace(/[A-Z]/g, (h)=>"-" + h.toLowerCase()), p = ()=>u(t, t.state, t.context), g = q(()=>{
            try {
                let h = yo(t, n, d, p);
                if (h === Pe || !t.node?.setAttribute) return;
                Ei(t.node, d, h);
            } catch (h) {
                oe(n, "aria." + l, h);
            }
        }, {
            depth: n.path.length,
            label: yt(n, "aria." + l)
        });
        g._attrName = d, n.__effects.push(g);
    }
    if (t.data && typeof t.data == "object") for(let l in t.data){
        let f = t.data[l];
        if (typeof f == "string" && f.includes("{{")) {
            let m = f, y = "data-" + l.replace(/[A-Z]/g, (v)=>"-" + v.toLowerCase()), b = ()=>Zt.call(t, m, t.state), T = q(()=>{
                try {
                    let v = yo(t, n, y, b);
                    if (v === Pe || !t.node || !t.node.setAttribute) return;
                    t.node.setAttribute(y, v ?? "");
                } catch (v) {
                    oe(n, "data." + l, v);
                }
            }, {
                depth: n.path.length,
                label: yt(n, "data." + l)
            });
            T._attrName = y, n.__effects.push(T);
            continue;
        }
        if (typeof f != "function") continue;
        let u = Ht(t, Bc(t.dataDeps, l), t.data[l]), p = "data-" + l.replace(/[A-Z]/g, (m)=>"-" + m.toLowerCase()), g = ()=>u(t, t.state, t.context), h = q(()=>{
            try {
                let m = yo(t, n, p, g);
                if (m === Pe || !t.node?.setAttribute) return;
                m == null || m === !1 ? t.node.removeAttribute(p) : typeof m != "function" && typeof m != "object" && t.node.setAttribute(p, m === !0 ? "" : m);
            } catch (m) {
                oe(n, "data." + l, m);
            }
        }, {
            depth: n.path.length,
            label: yt(n, "data." + l)
        });
        h._attrName = p, n.__effects.push(h);
    }
    let i = t.classlist && typeof t.classlist == "object" && !Array.isArray(t.classlist) ? t.classlist : t.class && typeof t.class == "object" && !Array.isArray(t.class) ? t.class : null;
    if (i) for(let l in i){
        if (typeof i[l] != "function") continue;
        let f = Ht(t, Bc(t.classDeps, l), i[l]), u = q(()=>{
            try {
                let d = f(t, t.state, t.context);
                if (!t.node?.classList) return;
                typeof d == "string" ? t.node.classList.add(d) : d ? t.node.classList.add(l) : t.node.classList.remove(l);
            } catch (d) {
                oe(n, "class." + l, d);
            }
        }, {
            depth: n.path.length,
            label: yt(n, "class." + l)
        });
        n.__effects.push(u);
    }
    let a = o ? null : mE(t, n);
    typeof a == "function" && fM(t, n, a);
    for (let l of Object.keys(t)){
        if (Kt.has(l) || typeof t[l] != "function") continue;
        let f = l.charCodeAt(0);
        if (f >= 65 && f <= 90 || yn(l)) continue;
        let u = t[l];
        n.__exec[l] = u;
        let d = t.tag || "div";
        if (qe(d, l) && !Wr(d, l)) {
            let p = er(l) || l, g = Ht(t, t[l + "Deps"], u), h = p.toLowerCase(), m = ()=>{
                let b = g(t, t.state, t.context);
                return typeof b == "string" && b.includes("{{") && (b = Zt.call(t, b, t.state)), b;
            }, y = q(()=>{
                try {
                    let b = yo(t, n, h, m);
                    if (b === Pe) return;
                    let T = zr[l];
                    if (T && b != null) {
                        let v = T(t);
                        v !== void 0 && (b = v);
                    }
                    t.node?.setAttribute && Ei(t.node, p, b, !0);
                } catch (b) {
                    oe(n, l, b);
                }
            }, {
                depth: n.path.length,
                label: yt(n, l)
            });
            y._attrName = p.toLowerCase(), n.__effects.push(y);
        }
    }
    let c = t.tag || "div";
    for (let l of Object.keys(t)){
        if (Kt.has(l)) continue;
        let f = t[l];
        if (typeof f != "string" || !f.includes("{{")) continue;
        let u = l.charCodeAt(0);
        if (u >= 65 && u <= 90 || yn(l) || Wr(c, l) || zr[l] || !qe(c, l)) continue;
        let d = er(l) || l, p = d.toLowerCase(), g = ()=>Zt.call(t, f, t.state), h = q(()=>{
            try {
                let m = yo(t, n, p, g);
                if (m === Pe || !t.node || !t.node.setAttribute) return;
                t.node.setAttribute(d, mo(d, m ?? ""));
            } catch (m) {
                oe(n, l, m);
            }
        }, {
            depth: n.path.length,
            label: yt(n, l)
        });
        h._attrName = d.toLowerCase(), n.__effects.push(h);
    }
    if (s8(t), k8(t), typeof t.onStateUpdate == "function" && Array.isArray(t.stateDeps)) {
        let l = t.onStateUpdate, f = t.stateDeps, u = !1, d = [], p = q(()=>{
            let g = [];
            for(let y = 0; y < f.length; y++){
                let b = f[y];
                try {
                    g[y] = typeof b == "function" ? b(t, t.state, t.context) : t.state?.[b];
                } catch  {
                    g[y] = void 0;
                }
            }
            if (!u) {
                u = !0, d = g;
                return;
            }
            let h = g.length !== d.length;
            for(let y = 0; !h && y < g.length; y++)g[y] !== d[y] && (h = !0);
            let m = d;
            d = g, h && _n(t, ()=>{
                try {
                    l(t, t.state, t.context, {
                        prev: m,
                        next: g
                    });
                } catch (y) {
                    if (bn(t, "onStateUpdate", y), t.context?.strictMode) throw y;
                }
            });
        }, {
            depth: n.path.length,
            label: yt(n, "onStateUpdate")
        });
        n.__effects.push(p);
    }
    y8(t);
}
function TI(t) {
    let e = t.__ref.__mount;
    if (e !== null && e.attachLater) return;
    let n = t.parent, o = n?.node;
    if (!o || !t.node) {
        zc(t, t.parent);
        return;
    }
    let r = null, s = Object.keys(n), i = s.indexOf(t.key);
    for(let c = i + 1; c < s.length; c++){
        let l = n[s[c]];
        if (l?.node?.parentNode === o) {
            r = l.node;
            break;
        }
    }
    t.node.parentNode === o && t.node.nextSibling === r || (r ? o.insertBefore(t.node, r) : o.appendChild(t.node)), Wm();
}
function lM(t) {
    uM(t), C8(t), AM(t), U8(t), j8(t);
}
function mE(t, e) {
    let n = t.deferUntil;
    if (typeof n != "function" || e.__deferOpen) return t.if;
    let o = t.if;
    return (r, s, i)=>{
        if (!e.__deferOpen) {
            let a;
            try {
                a = n(r, s, i);
            } catch (c) {
                let l = e.__deferUntilError === void 0;
                if (e.__deferUntilError = c, l && typeof console < "u" && console.warn) {
                    let f = r.key || r.tag || "?";
                    console.warn(`[smbls] \`deferUntil:\` threw on ${f} \u2014 treating as false:`, c?.message || c);
                }
                return !1;
            }
            if (!a) return !1;
            e.__deferOpen = !0;
        }
        return o == null ? !0 : typeof o == "function" ? o(r, s, i) : o;
    };
}
function fM(t, e, n) {
    let o = Ht(t, t.ifDeps, n), r = q(()=>{
        let s = !e.__ifInitialized && e.__ifLateMerge;
        if (s) {
            let l = t.context?.components || {};
            if (s.names.some((f)=>l[f] || l["smbls." + f])) {
                e.__ifLateMerge = null, EK(t, s);
                let f = mE(t, e);
                o = Ht(t, t.ifDeps, typeof f == "function" ? f : n);
            }
        }
        let i;
        try {
            i = o(t, t.state, t.context);
        } catch (l) {
            if (i = !1, e.__ifError = l, typeof console < "u" && console.warn) {
                let f = t.key || t.tag || "?";
                console.warn(`[smbls] \`if:\` reactive effect threw on ${f} \u2014 treating as false:`, l?.message || l);
            }
            return;
        }
        let a = e.__if;
        e.__if = !!i;
        let c = e.__mount;
        if (!(!a && e.__if && c !== null && c.held)) {
            if (a && !e.__if && t.node) {
                t.node.remove();
                try {
                    typeof t.onRemove == "function" && t.onRemove(t);
                } catch (l) {
                    console.error("[smbls] onRemove error:", l);
                }
            } else if (!a && e.__if) {
                if (e.__ifInitialized) t.node || (t.node = Hr(t)), t.node && (t.node.ref = t), TI(t), uM(t), AM(t), me("Render", t, {}), uE(t), cE(t, {});
                else {
                    e.__ifInitialized = !0, e.__ifLateMerge = null, t.tag || (t.tag = Hn(t)), me("Init", t, {});
                    let l = Q.hydration;
                    if (!t.node) {
                        t.node = l !== null && l.adopt(t) || Hr(t);
                        let f = l !== null && t.node ? t.context?.__replacing : void 0;
                        f && l.markReplaced(f, t, t.node);
                    }
                    if (!t.node) return;
                    if (t.node.ref = t, t.parent?.__ref?.__children && !t.parent.__ref.__children.includes(t.key) && t.parent.__ref.__children.push(t.key), t.parent?.__ref?.__ifParked && t.parent.__ref.__ifParked.delete(t.key), t.tag === "fragment" && !e.__fragmentAnchor) {
                        let u = (t.context?.document || globalThis.document).createComment("");
                        t.node.appendChild(u), e.__fragmentAnchor = u;
                    }
                    me("AttachNode", t, {}), t.node.setAttribute && t.key && t.node.setAttribute("data-key", t.key), t.id && t.node.setAttribute && (t.node.id = t.id), LM(t, {}), cM(t, {
                        skipIfEffect: !0
                    }), lM(t), IM(t, {}), TI(t), me("Create", t, {}), me("Complete", t, {}), me("Render", t, {}), uE(t), me("RenderRouter", t, {}), cE(t, {});
                }
            }
        }
    }, {
        depth: e.path.length,
        label: yt(e, "if")
    });
    e.__effects.push(r);
}
var Pe = Symbol("builtTextKept");
function EI(t, e, n) {
    let o = e.__builtText;
    if (!o) return n();
    if (o.parentNode !== t.node || typeof Pn != "function") return e.__builtText = null, n();
    let { value: r, ready: s } = Pn(n);
    return s ? r : Pe;
}
function yo(t, e, n, o) {
    let r = e.__builtAttrs;
    if (!r || !r.values.has(n)) return o();
    let s = t.node;
    if (s !== r.node || typeof Pn != "function") return e.__builtAttrs = null, o();
    let { value: i, ready: a } = Pn(o);
    return a ? (r.values.delete(n), r.values.size || (e.__builtAttrs = null), i) : (s.setAttribute(n, r.values.get(n)), Pe);
}
function Ti(t, e) {
    let n = t.node;
    if (!n) return;
    t.__ref && t.__ref.__builtText && (t.__ref.__builtText = null);
    let o = e == null || typeof e == "object" ? "" : String(e);
    if (t.tag === "string") {
        n.nodeValue !== o && (n.nodeValue = o);
        return;
    }
    let r = t.__ref, s = r ? r.__textNode : null;
    if (s && s.parentNode !== n && (s = null), !s) {
        let a = n.firstChild;
        a && a.nodeType === 3 && (s = a);
    }
    s ? s.nodeValue !== o && (s.nodeValue = o) : n.firstChild ? (s = (n.ownerDocument || t.context?.document || globalThis.document).createTextNode(o), n.insertBefore(s, n.firstChild)) : (n.textContent = o, s = n.firstChild && n.firstChild.nodeType === 3 ? n.firstChild : null), r && (r.__textNode = s || null);
    let i = Q.faceWait;
    i !== null && i.active && i.text(t);
}
function uE(t) {
    let e = Q.faceWait;
    e !== null && e.rendered(t);
}
function KK(t, e) {
    return e !== "checked" || !t || t.tagName !== "INPUT" ? null : t.hasAttribute("checked");
}
function GK(t, e) {
    if (e === null) return;
    let n = t.hasAttribute("checked");
    n !== e && t.checked !== n && (t.checked = n);
}
function Ei(t, e, n, o) {
    n == null || n === !1 && !vi(e) ? my(t, e, null) : typeof n == "function" || typeof n == "object" || (o && e === "src" && "src" in t ? t.src = n : my(t, e, mo(e, n)));
}
function my(t, e, n) {
    let o = KK(t, e);
    n == null ? t.removeAttribute(e) : t.setAttribute(e, n), GK(t, o);
}
function AI(t, e) {
    let n = t.node;
    if (!n || !("value" in n)) return;
    let o = e == null ? "" : String(e);
    if (n.value === o) return;
    let r = n.ownerDocument, s = !!r && r.activeElement === n, i = s && typeof n.selectionStart == "number" ? n.selectionStart : null, a = s && typeof n.selectionEnd == "number" ? n.selectionEnd : null;
    if (n.value = o, s && i != null && a != null) try {
        n.setSelectionRange(i, a);
    } catch  {}
    let c = t.__ref && t.__ref.__autoGrow;
    c && c.active && c.resize();
}
function uM(t) {
    let { node: e } = t;
    if (e) {
        if ((typeof t.text == "string" && !t.text.includes("{{") || typeof t.text == "number") && Ti(t, t.text), CM(t), typeof t.html == "string" && (e.innerHTML = t.html), t.value != null && typeof t.value != "function" && !(typeof t.value == "string" && t.value.includes("{{")) && "value" in e) {
            let n = String(t.value);
            e.value !== n && (e.value = n);
        }
        if (t.style && typeof t.style == "object") {
            let n = t.style;
            for(let o in t.style)if (typeof t.style[o] == "function") {
                n = {};
                for(let r in t.style)typeof t.style[r] != "function" && (n[r] = t.style[r]);
                break;
            }
            bo(e, Ai(t, n), t);
        }
        if (t.attr && typeof t.attr == "object") for(let n in t.attr){
            let o = t.attr[n];
            typeof o == "function" || typeof o == "object" || o != null && (typeof o == "string" && o.includes("{{") || o === !1 && !vi(n) || e.setAttribute && e.setAttribute(n, mo(n, o)));
        }
        if (typeof t.themeModifier == "string" && t.themeModifier && e.setAttribute && e.setAttribute("data-theme", t.themeModifier), t.data && typeof t.data == "object") for(let n in t.data){
            let o = t.data[n];
            typeof o == "function" || typeof o == "object" || o == null || o === !1 || typeof o == "string" && o.includes("{{") || e.dataset && (e.dataset[n] = o === !0 ? "" : o);
        }
        if (t.classlist || t.class) {
            let n = t.classlist || t.class;
            if (typeof n == "string") n.split(" ").forEach((o)=>o && e.classList.add(o));
            else if (typeof n == "object") for(let o in n){
                let r = typeof n[o] == "function" ? n[o](t, t.state, t.context) : n[o];
                r && e.classList.add(typeof r == "string" ? r : o);
            }
        }
    }
}
function Fc(t) {
    if (t == null || typeof t != "object") return "s:" + String(t);
    try {
        return "o:" + JSON.stringify(t);
    } catch  {
        return null;
    }
}
function qK(t) {
    if (!t || typeof t != "object") return !1;
    for(let e in t){
        let n = t[e];
        if (n && typeof n == "object" && !Array.isArray(n)) return !0;
    }
    return !1;
}
function Ad(t, e, n) {
    if (!t || !t.style || !e) return null;
    let o = t.style, r = [];
    for(let s in e){
        if (e[s] == null || s.charAt(0) === "&") continue;
        let a = _o(s);
        r.push(a, Wc(n, o, a), bE(n, o, a));
    }
    return r;
}
function dM(t, e) {
    return typeof t.getPropertyValue == "function" ? t.getPropertyValue(e) : "";
}
function pM(t, e) {
    return typeof t.getPropertyPriority == "function" ? t.getPropertyPriority(e) : "";
}
function _o(t) {
    return Jo(t);
}
function dE(t, e, n, o) {
    if (!t || !t.style || !e || !e.length) return;
    let r = t.style, s = new Set;
    if (n && typeof n == "object") for(let i in n)n[i] == null || i.charAt(0) === "&" || s.add(_o(i));
    for(let i = 0; i < e.length; i += 3){
        let a = e[i];
        s.has(a) || Wc(o, r, a) === e[i + 1] && (o && a === "display" ? Bd(o, "") : typeof r.removeProperty == "function" && r.removeProperty(a));
    }
}
function dy(t, e, n) {
    let o = t.__ref;
    o && (n ? (o.__heldInline || (o.__heldInline = new Map)).set(e, n) : o.__heldInline && o.__heldInline.delete(e));
}
function YK(t, e, n) {
    if (t.__heldInline) {
        for (let [o, r] of t.__heldInline)if (o !== e) {
            for(let s = 0; s < r.length; s += 3)if (r[s] === n) return !0;
        }
    }
    return !1;
}
function hM(t, e, n, o) {
    let r = t.__ref, s = t.node;
    if (!r || !n || !s || !s.style) return;
    let i = r.__inlineCssKeys, a = null;
    for(let u = 0; u < n.length; u += 3){
        let d = n[u];
        o && o.has(d) || YK(r, e, d) || (a || (a = []), a.push(u), i && i.delete(d));
    }
    if (!a) return;
    let c = i && yE(t, i), l = s.style, f = [];
    for (let u of a){
        let d = n[u];
        c && c[d] !== void 0 || Wc(t, l, d) === n[u + 1] && f.push(d);
    }
    for (let u of f)u === "display" ? Bd(t, "") : typeof l.removeProperty == "function" && l.removeProperty(u);
}
function XK(t, e, n) {
    let o = [];
    for(let i = 0; i < e.length; i += 3)o.push(e[i]);
    let r = !1;
    for(let i in n){
        let a = Ur[i];
        o.some((c)=>a.includes(c)) && (r = !0, o.includes(i) || o.push(i));
    }
    if (!r) return;
    let s = t.node.style;
    e.length = 0;
    for (let i of o)e.push(i, Wc(t, s, i), bE(t, s, i));
}
function $c(t, e, n) {
    if (!e || !t || !t.style) return !1;
    let o = t.style;
    for(let r = 0; r < e.length; r += 3)if (Wc(n, o, e[r]) !== e[r + 1] || bE(n, o, e[r]) !== e[r + 2]) return !1;
    return !0;
}
var Ld = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, gM = (t)=>typeof t == "number" || t === !0 || typeof t == "string" && t !== "", wy = (t)=>Ld(t) ? t : "--" + t;
function xy(t, e) {
    if (!So(t)) return null;
    let n = null;
    for (let o of Object.keys(t)){
        if (!o) continue;
        let r = t[o];
        if (typeof r == "function") {
            if (!e) continue;
            r = r(e, e.state, e.context);
        }
        gM(r) && (n || (n = {}), n[wy(o)] = r);
    }
    return n;
}
function mM(t, e, n, o, r) {
    yM(t, r, Ht(t, o, n), (s)=>gM(s) ? {
            [e]: s
        } : null);
}
function yM(t, e, n, o, r) {
    let s = t.__ref, i, a = null, c = q(()=>{
        _n(t, ()=>{
            try {
                let l = o(n(t, t.state, t.context)), f = t.node;
                if (!f || !f.style) return;
                let u = Fc(l);
                (u === null || u !== i || !$c(f, a)) && (i = u, dE(f, a, l), l && bo(f, Yr(t, l)), a = l ? Ad(f, l) : null, r && r(l));
            } catch (l) {
                oe(s, e, l);
            }
        });
    }, {
        depth: s.path.length,
        label: yt(s, e)
    });
    s.__effects.push(c);
}
function ZK(t) {
    let e = t.__ref, n = t.vars;
    if (typeof n == "function") {
        QK(t, n), e.__exec.vars = n;
        return;
    }
    if (So(n)) for (let o of Object.keys(n)){
        let r = n[o];
        !o || typeof r != "function" || mM(t, wy(o), r, Bc(t.varsDeps, o), "vars." + o);
    }
}
function QK(t, e) {
    let n = t.__ref;
    yM(t, "vars", Ht(t, t.varsDeps, e), (o)=>xy(o), (o)=>{
        n.__varsInline = o ? new Set(Object.keys(o)) : null;
    });
}
function JK(t, e) {
    if (typeof t[e] == "function" && (Wr(t.tag || "div", e) || e.charCodeAt(0) === 45)) return !0;
    if (!Ld(e)) return !1;
    let n = t.vars;
    if (typeof n == "function") {
        let o = t.__ref && t.__ref.__varsInline;
        return !!(o && o.has(e));
    }
    if (!So(n)) return !1;
    for (let o of Object.keys(n))if (typeof n[o] == "function" && wy(o) === e) return !0;
    return !1;
}
function t8(t) {
    let e = null;
    for(let n in t)t[n] != null && n.charAt(0) !== "&" && (e || (e = new Set), e.add(_o(n)));
    return e;
}
function e8(t, e, n, o) {
    let r = t.__ref;
    if (!r) return;
    let s = null;
    if (n) for (let i of n){
        if (o && o.has(i)) continue;
        let a = e[i];
        if (a == null || typeof a == "object") continue;
        let c = _o(i);
        Ur[c] && (s || (s = {}), s[c] = a);
    }
    r.__declaredLonghands = s;
}
function yE(t, e) {
    let n = t.__ref, o = n && n.__declaredLonghands;
    if (!o || !e) return null;
    let r = null;
    for(let s in o){
        if (e.has(s)) continue;
        let i = Ur[s], a = !1;
        for(let c = 0; c < i.length; c++)if (e.has(i[c])) {
            a = !0;
            break;
        }
        a && (r || (r = {}), r[s] = o[s]);
    }
    return r;
}
function vI(t, e, n, o) {
    let r = t.node, s = t8(e), i = s && yE(t, s);
    if (n && hM(t, o, n, i ? new Set([
        ...s,
        ...Object.keys(i)
    ]) : s), bo(r, e, t), !s) return e;
    let a = t.__ref;
    if (a) {
        if (a.__inlineCssKeys) for (let c of s)a.__inlineCssKeys.add(c);
        else a.__inlineCssKeys = new Set(s);
    }
    return i ? (bo(r, Yr(t, i)), Object.assign({}, e, i)) : e;
}
function n8(t) {
    let e = t.__ref;
    if (!e || !e.__inlineCssKeys || !e.__declaredLonghands) return;
    let n = yE(t, e.__inlineCssKeys);
    if (!n) return;
    let o = [];
    if (e.__heldInline) for (let r of e.__heldInline.values())$c(t.node, r, t) && o.push(r);
    bo(t.node, Yr(t, n));
    for (let r of o)XK(t, r, n);
}
function Ai(t, e) {
    return !e || typeof e != "object" ? e : _n(t, ()=>{
        try {
            return CT(e, t);
        } catch  {
            return e;
        }
    });
}
var _M = "none", _E = (t)=>!!(t && t.__hiddenBy && t.__hiddenBy.size), OI = (t)=>dM(t, "display") === _M && pM(t, "display") === "important";
function bM(t, e) {
    e ? t.setProperty("display", e[0], e[1]) : typeof t.removeProperty == "function" ? t.removeProperty("display") : t.display = "";
}
function yy(t, e, n, o) {
    let r = t.__ref, s = t.node;
    if (!r || !s || !s.style) return;
    let i = r.__hiddenBy, a = !!(i && i.size);
    n ? (i || (i = r.__hiddenBy = new Set), i.add(e)) : i && i.delete(e);
    let c = s.style;
    i && i.size ? OI(c) || c.setProperty("display", _M, "important") : (a || o && OI(c)) && bM(c, r.__shownDisplay || null);
}
function Bd(t, e, n) {
    let o = t.__ref, r = e ? [
        String(e),
        n || ""
    ] : null;
    o && (o.__shownDisplay = r);
    let s = t.node;
    !s || !s.style || _E(o) || bM(s.style, r);
}
function Wc(t, e, n) {
    let o = n === "display" && t && t.__ref;
    return _E(o) ? o.__shownDisplay ? o.__shownDisplay[0] : "" : dM(e, n);
}
function bE(t, e, n) {
    let o = n === "display" && t && t.__ref;
    return _E(o) ? o.__shownDisplay ? o.__shownDisplay[1] : "" : pM(e, n);
}
function bo(t, e, n) {
    if (!t || !e || !t.style) return;
    n && (e = Yr(n, e));
    let o = null;
    for(let r in e){
        let s = e[r];
        if (s != null) {
            if (r.charAt(0) === "&" && typeof s == "object") {
                o || (o = {}), o[r] = s;
                continue;
            }
            try {
                let i = String(s);
                if (typeof s == "object" && i === "[object Object]") continue;
                let a = Jo(r), c = i.trim(), l = /\s*!important\s*$/.test(c), f = c.replace(/\s*!important\s*$/, "");
                if (n && a === "display") {
                    Bd(n, f, l ? "important" : "");
                    continue;
                }
                t.style.setProperty(a, f, l ? "important" : "");
            } catch  {}
        }
    }
    o && o8(t, o);
}
function o8(t, e) {
    let n = `_ds${qI.scopedStyleId++}`;
    t.classList.add(n);
    let o = t.ownerDocument, r = o.querySelector("style[data-smbls-scoped]");
    r || (r = o.createElement("style"), r.setAttribute("data-smbls-scoped", ""), o.head.appendChild(r));
    let s = "";
    for(let i in e){
        let a = "." + n, c = Zo(i.replace(/&/g, a)).map((f)=>f.includes(a) ? f : a + f).join(", "), l = e[i];
        if (typeof l == "object") {
            let f = "", u = "";
            for(let d in l){
                let p = l[d];
                if (typeof p == "object") {
                    let g = Zo(c), h = d.includes("&") ? g.map((y)=>d.replace(/&/g, y)).join(", ") : g.map((y)=>`${y} ${d}`).join(", "), m = "";
                    for(let y in p)m += `${_o(y)}: ${p[y]};`;
                    u += Xo(`${h} { ${m} }`, h) + `
`;
                } else f += `${_o(d)}: ${p};`;
            }
            f && (s += Xo(`${c} { ${f} }`, c) + `
`), u && (s += u);
        }
    }
    s && (r.textContent += s);
}
var CI = new Set;
function RI(t) {
    if (!Array.isArray(t)) return "";
    let e = [];
    for(let n = 0; n < t.length; n++)typeof t[n] == "string" && t[n].length && e.push(t[n]);
    return e.sort(), e.join("|");
}
function r8(t, e, n) {
    let o = RI(n);
    queueMicrotask(()=>{
        if (!t.__ref) return;
        let r;
        try {
            r = e(t, t.state, t.context);
        } catch  {
            return;
        }
        if (RI(r) === o) return;
        let s = t.__ref.path ? t.__ref.path.join(".") : t.key || "?";
        CI.has(s) || (CI.add(s), console.warn(`[smbls] subscribeTo function at "${s}" resolved to a DIFFERENT key list one microtask after create \u2014 wired [${n.join(", ") || "(none)"}], probed [${Array.isArray(r) ? r.join(", ") : String(r)}]. subscribeTo's function form is resolved ONCE at element-create time (registerSubscribeToEffects, @symbo.ls/element core.js) \u2014 this element stays wired to the ORIGINAL list for its whole lifetime, so this drift is invisible to the reactive effect and any key only present in the new list will never trigger onUpdate. If the watched key genuinely is not known until later (e.g. a module config that loads after shell boot), route the write through an imperative call instead of subscribeTo \u2014 see functions/moduleOpenBridge.js's moduleOpenPage (workspace repo) for the house pattern.`));
    });
}
function s8(t) {
    let e = t.subscribeTo, n = typeof e == "function", o = e;
    if (n) try {
        o = e(t, t.state, t.context);
    } catch  {
        o = null;
    }
    if (n, !Array.isArray(o) || o.length === 0) return;
    let r = t.__ref;
    for(let s = 0; s < o.length; s++){
        let i = o[s];
        if (typeof i != "string" || i.length === 0) continue;
        let a = i.split("."), c = a[0], l = a.slice(1), f = {
            value: !1
        }, u = q(()=>{
            let d = t.state && (xt(t.state) ? t.state.root : null);
            if (!d || !xt(d)) return;
            let p = d;
            p = p[c];
            for(let h = 0; h < l.length && !(p == null || typeof p != "object"); h++)if (xt(p)) p = p[l[h]];
            else break;
            if (!f.value) return;
            let g = !1;
            if (typeof t.onBeforeUpdate == "function" && _n(t, ()=>{
                try {
                    if (ay(r)) {
                        let h = t.onBeforeUpdate(t, t.state, t.context, {
                            updateBySubscription: !0
                        });
                        h && typeof h.then == "function" ? h.then(()=>go(r, !1), (m)=>{
                            go(r, !0), Vn("error", t, {
                                hook: "onBeforeUpdate",
                                error: m
                            }) || console.error("[DOMQL] subscribeTo onBeforeUpdate error:", m);
                        }) : (go(r, !1), h === !1 && (g = !0));
                    }
                } catch (h) {
                    go(r, !0), Vn("error", t, {
                        hook: "onBeforeUpdate",
                        error: h
                    }) || console.error("[DOMQL] subscribeTo onBeforeUpdate error:", h);
                }
            }), !g && t.node && r.__effects) for(let h = 0; h < r.__effects.length; h++){
                let m = r.__effects[h];
                m && m !== u && !m._disposed && !m._isSubscribeToEffect && typeof m._execute == "function" && m._execute();
            }
            !g && typeof t.onUpdate == "function" && _n(t, ()=>{
                try {
                    t.onUpdate(t, t.state, t.context);
                } catch (h) {
                    Vn("error", t, {
                        hook: "onUpdate",
                        error: h
                    }) || console.error("[DOMQL] subscribeTo onUpdate error:", h);
                }
            });
        }, {
            depth: r.path.length,
            label: yt(r, "subscribeTo(" + i + ")")
        });
        f.value = !0, u._isSubscribeToEffect = !0, r.__effects.push(u);
    }
}
function SE(t, e) {
    return t.charCodeAt(0) === 64 && t.length > 1 && !t.startsWith("@media") && !t.startsWith("@keyframes") && !t.startsWith("@supports") && !t.startsWith("@container") && (t === "@dark" || t === "@light" || !e.context?.designSystem?.media?.[t.slice(1)]);
}
function wE(t, e) {
    if (t.charCodeAt(0) !== 64 || /^@(media|supports|container|keyframes)\b/.test(t)) return t;
    let n = e.context?.designSystem?.media?.[t.slice(1)];
    if (!n) return t;
    if (typeof n == "string" && !/^@(supports|container)\b/.test(n)) {
        let o = xM(e);
        if (o) {
            let r = ST(n);
            if (r) return `@container ${o} ${r}`;
        }
    }
    return /^@(media|supports|container)\b/.test(n) ? n : `@media ${n}`;
}
function xE(t, e, n, o, r) {
    let s = r || a8(t);
    return ci(t) ? ai(()=>Pd(e, n, !1, o, s)) : Pd(e, n, !1, o, s);
}
var i8 = /(::[a-z-]+(?:\([^()]*\))?|:(?:before|after|first-line|first-letter))(?::[a-z-]+(?:\([^()]*\))?)*\s*$/i;
function a8(t) {
    if (typeof t != "string" || t.charCodeAt(0) === 64) return null;
    let e = t.match(i8);
    return e ? e[1] : null;
}
var c8 = /^::(?:-webkit-scrollbar|part\()/i, l8 = /^(?::[a-z-]+(?:\([^()]*\))?)+$/i;
function f8(t) {
    let e = [], n = 0, o = 0;
    for(let r = 0; r < t.length; r++){
        let s = t.charCodeAt(r);
        s === 40 ? n++ : s === 41 ? n-- : s === 44 && n === 0 && (e.push(t.slice(o, r)), o = r + 1);
    }
    return e.push(t.slice(o)), e;
}
function SM(t, e) {
    if (t.charCodeAt(0) === 64) return !0;
    let n = c8.test(e);
    for (let o of f8(t)){
        let r = o.trim(), s = r.lastIndexOf("&"), i = s === -1 ? r : r.slice(s + 1);
        if (!(s !== -1 && i === "") && !(n && l8.test(i))) return !1;
    }
    return !0;
}
function wM(t, e) {
    let n = null;
    for(let o in t){
        let r = t[o];
        if (!So(r)) continue;
        let s = SM(o, e) ? wM(r, e) : void 0;
        s !== r && (n || (n = {
            ...t
        }), s === void 0 ? delete n[o] : n[o] = s);
    }
    return n || t;
}
function xM(t) {
    let e = t.__ref;
    if (e && e.__breakpointContainer !== void 0) return e.__breakpointContainer;
    let n = null;
    for(let o = t.parent; o && typeof o == "object"; o = o.parent){
        let r = o.breakpointsFrom;
        if (r != null && r !== !1) {
            n = Ac(r, o);
            break;
        }
    }
    return e && (e.__breakpointContainer = n), n;
}
function Yr(t, e) {
    let n = Q.containerVw;
    return n !== null && n.on && e && xM(t) ? n.lengths(e) : e;
}
function u8(t, e) {
    return Q.containerVw !== null && Q.containerVw.scope(t, e);
}
var DI = new Set;
function d8(t, e) {
    let n = e?.__ref?.path ? e.__ref.path.join(".") : e?.key || "?", o = n + "::" + t;
    DI.has(o) || (DI.add(o), console.warn(`[smbls/css] "${t}" at ${n} is a CHILD-COMPONENT key nested inside a pseudo/selector block (":hover", "@dark", etc.) \u2014 that is never a valid CSS selector fragment. The rule is DROPPED (not shipped as a dead/never-matching selector). To reveal a child on a parent state, target the child's OWN class from the parent selector instead, e.g. move the declaration onto the child element itself, or use a sibling-selector combinator in a top-level style block.`));
}
var LI = new Map;
function p8(t) {
    let e = LI.get(t);
    if (e) return e;
    e = [];
    let n = (o)=>{
        if (o) for (let r of o)e.push(bd(r));
    };
    return n(Ur[t]), n(ny[t]), LI.set(t, e), e;
}
function vd(t, e, n) {
    return JK(t, e) || !!(n && n.has(e));
}
var Td = null;
function h8(t) {
    if (!Td) {
        Td = new Map;
        let e = xT;
        if (e) {
            for (let n of Object.keys(e))if (!(n === "hide" || n === "show")) for (let o of e[n]){
                if (o === n) continue;
                let r = Td.get(o);
                r || Td.set(o, r = []), r.push(n);
            }
        }
    }
    return Td.get(t);
}
function PI(t, e, n) {
    if (vd(t, e, n)) return !0;
    let o = h8(e);
    if (o) {
        for(let r = 0; r < o.length; r++)if (vd(t, o[r], n)) return !0;
    }
    return !1;
}
function g8(t, e, n) {
    if (PI(t, e, n)) return !0;
    let o = p8(_o(e));
    for(let r = 0; r < o.length; r++)if (PI(t, o[r], n)) return !0;
    return !1;
}
function Pd(t, e, n, o, r) {
    let s = {}, i = new Set, a = (l, f, u)=>{
        if (r && So(f)) {
            if (!SM(l, r)) return;
            f = wM(f, r);
        }
        let d = !Object.prototype.hasOwnProperty.call(s, l);
        s[l] = f, d && (u || g8(e, l, o)) && i.add(l);
    }, c = (l, f, u)=>{
        if (St[l]) {
            let d = St[l](f, e, e.state, e.context);
            if (d) {
                let p = Array.isArray(d) ? d : [
                    d
                ];
                for (let g of p)if (g) for (let h of Object.keys(g))a(h, g[h], u);
            }
        } else a(l, f, u);
    };
    for(let l in t){
        if (!Object.prototype.hasOwnProperty.call(t, l)) continue;
        let f = t[l];
        if (typeof f == "function" && (f = f(e, e.state, e.context)), !(f == null || typeof f == "function")) {
            if (typeof f == "object" && !Array.isArray(f)) {
                if (l === "style") {
                    for(let p in f){
                        let g = f[p];
                        typeof g == "function" && (g = g(e, e.state, e.context)), !(g == null || typeof g == "function") && c(p, g, vd(e, p, o));
                    }
                    continue;
                }
                if (l === "vars") {
                    let p = xy(f, e);
                    if (p) for(let g in p)c(g, p[g], vd(e, g, o));
                    continue;
                }
                if (SE(l, e)) {
                    let p = Pd(f, e, !1, o, r);
                    Object.keys(p).length && (s[`[data-theme="${l.slice(1)}"] &`] = p);
                    continue;
                }
                if (/^[A-Z][A-Za-z0-9]*$/.test(l)) continue;
                let u = wE(l, e), d = xE(u, f, e, o, r);
                Object.keys(d).length && (s[u] = d);
                continue;
            }
            c(l, f, vd(e, l, o));
        }
    }
    if (n) for(let l in s)i.add(l);
    for (let l of i){
        let f = s[l];
        typeof f == "string" && !f.includes("!important") && (s[l] = f + " !important");
    }
    return s;
}
var So = (t)=>!!t && typeof t == "object" && !Array.isArray(t);
function kM(t, e) {
    for(let n in e){
        let o = e[n];
        t[n] = So(o) ? kM(So(t[n]) ? t[n] : {}, o) : o;
    }
    return t;
}
function m8(t, e) {
    if (!So(e)) return;
    let n;
    for (let o of t.split(" ")){
        let r = o ? e[o] : null;
        So(r) && (n = kM(n || {}, r));
    }
    return n;
}
function kE(t, e) {
    if (e === void 0 && (e = 0), e > 8) return !1;
    if (typeof t == "function") return !0;
    if (t && typeof t == "object" && !Array.isArray(t)) {
        for(let n in t)if (Object.prototype.hasOwnProperty.call(t, n) && kE(t[n], e + 1)) return !0;
    }
    return !1;
}
function TM(t, e, n) {
    if (!e || typeof e != "object" || Array.isArray(e)) return null;
    if (SE(t, n)) {
        let s = Pd(e, n, !1);
        return Object.keys(s).length ? {
            cssProp: `[data-theme="${t.slice(1)}"] &`,
            block: s
        } : null;
    }
    let o = wE(t, n), r = xE(o, e, n);
    return Object.keys(r).length ? {
        cssProp: o,
        block: r
    } : null;
}
function y8(t) {
    let e = t.__ref;
    for (let n of Object.keys(t)){
        if (!JI(n)) continue;
        let o = t[n];
        if (!o || typeof o != "object" || Array.isArray(o) || !kE(o)) continue;
        let r = null, s, i = q(()=>{
            if (!t.node) return;
            let a = t.context?.designSystem;
            a && pt(a);
            let c, l = !1;
            try {
                let f = TM(n, o, t), u = f ? Fc(f.block) + "::" + f.cssProp : null;
                if (u !== null && u === s) l = !0;
                else if (s = u, f) {
                    let d = Ke(Yr(t, {
                        [f.cssProp]: f.block
                    }), null, t.context?.cssPrefix);
                    c = d ? d.split(" ").filter(Boolean) : null;
                } else c = null;
            } finally{
                a && ut();
            }
            if (!(l || !t.node.classList)) {
                if (r) for (let f of r)t.node.classList.remove(f);
                if (c && c.length) for (let f of c)t.node.classList.add(f);
                r = c;
            }
        }, {
            depth: e.path.length,
            label: yt(e, "cssBlock(" + n + ")")
        });
        e.__effects.push(i);
    }
}
var _8 = ()=>!0, b8 = (t, e)=>{
    let n = t.charAt(0);
    return (n === ":" || n === "@" || n === "&" || n === "[") && e && typeof e == "object" && !Array.isArray(e) ? !0 : !!St[t] || !!(Ft && Ft.has(t)) || Ld(t) || t === "vars";
};
function S8(t, e, n) {
    let o = {}, r = !1;
    for(let a in n)Object.prototype.hasOwnProperty.call(n, a) && (a !== "data" && a !== "aria" && (b8(a, n[a]) || Kt.has(a)) ? o[a] = !0 : r = !0);
    if (!r) return null;
    let s = qT({
        [e]: n
    }, t.tag || "div", o, _8), i = null;
    for(let a in s)/^on/i.test(a) || (i || (i = {}), i[a] = s[a]);
    return i;
}
function II(t, e, n, o, r, s) {
    let i = t.node, a = null, c = (l)=>{
        (a || (a = [])).push(l);
    };
    for(let l in o){
        let f = e.owners.get(l), u = f === n;
        if (!s && f !== void 0 && !u) continue;
        let d;
        try {
            d = o[l](t);
        } catch (g) {
            oe(t.__ref, "conditional(" + n + ")." + l, g), u && c(l);
            continue;
        }
        if (typeof d == "string" && d.includes("{{") && (d = Zt.call(t, d, t.state)), u && i.getAttribute(l) !== e.written.get(l)) {
            c(l);
            continue;
        }
        if (d == null || typeof d == "object" || typeof d == "function") {
            u && EM(i, e, l);
            continue;
        }
        let p = d === !1 && !vi(l) ? null : String(mo(l, d));
        c(l), !(u && p === e.written.get(l)) && (f === void 0 && e.base.set(l, i.getAttribute(l)), my(i, l, p), e.owners.set(l, n), e.written.set(l, p));
    }
    r.appliedAttrs = a;
}
function EM(t, e, n) {
    t.getAttribute(n) === e.written.get(n) && my(t, n, e.base.get(n)), e.owners.delete(n), e.base.delete(n), e.written.delete(n);
}
function w8(t, e, n, o) {
    let r = o.appliedAttrs;
    if (o.appliedAttrs = null, !!r) for (let s of r)e.owners.get(s) === n && EM(t.node, e, s);
}
function AM(t) {
    let e = t.__ref && t.__ref.__conditionalAttrs, n = t.node;
    if (!(!e || !e.owners.size || !n || !n.getAttribute)) for (let o of e.owners.keys()){
        let r = e.written.get(o), s = n.getAttribute(o);
        s !== r && (e.base.set(o, s), r == null ? n.removeAttribute(o) : n.setAttribute(o, r));
    }
}
var eE, x8 = ()=>eE === void 0 ? eE = false : eE;
function MI(t, e) {
    let n = nh;
    typeof n == "function" ? t.untrackedReads += n(e) : e();
}
function k8(t) {
    let e = t.__ref;
    e.__conditionalRunners = [];
    let n = null, o = new Map;
    for (let r of Object.keys(t)){
        let s = r.charAt(0);
        if (s !== "." && s !== "!") continue;
        let i = r.slice(1);
        if (!i) continue;
        if (/[:@\s>~+[\]]/.test(i)) {
            if (typeof console < "u" && console.warn) {
                let m = i.split(/[:@\s>~+[\]]/)[0];
            }
            continue;
        }
        let a = t[r];
        if (!a || typeof a != "object") continue;
        let c = s === "!", l = {
            lastMatch: !1,
            appliedKeys: null,
            appliedClasses: null,
            appliedAttrs: null,
            hides: !1,
            probe: !1,
            untrackedReads: 0
        }, f = S8(t, r, a);
        f && !n && (n = e.__conditionalAttrs = {
            owners: new Map,
            base: new Map,
            written: new Map
        });
        let u = new Set;
        for(let m in a){
            if (!Object.prototype.hasOwnProperty.call(a, m)) continue;
            let y = m.charAt(0), b = a[m];
            if (!((y === ":" || y === "@" || y === "&" || y === "[") && b && typeof b == "object" && !Array.isArray(b))) {
                if (m === "vars" && So(b)) {
                    for (let T of Object.keys(b))T && u.add(wy(T));
                    continue;
                }
                u.add(m);
            }
        }
        let d = ()=>{
            let m, y = l.probe, b;
            if (y ? MI(l, ()=>{
                b = t[i];
            }) : b = t[i], b === void 0) {
                let S = !!t.state && i in t.state, w = t.state ? t.state[i] : void 0;
                if (S || w !== void 0) m = w;
                else {
                    let _ = t.context?.cases?.[i];
                    if (_ === void 0) return;
                    try {
                        m = typeof _ == "function" ? _.call(t, t) : _;
                    } catch (x) {
                        m = !1, e.__conditionalError = x, typeof console < "u" && console.warn && console.warn(`[smbls] conditional \`${r}\` case fn threw on ${t.key || "?"} \u2014 treating as false:`, x?.message || x);
                    }
                }
            } else if (typeof b == "function") try {
                y ? MI(l, ()=>{
                    m = b(t, t.state, t.context);
                }) : m = b(t, t.state, t.context);
            } catch (S) {
                m = !1, e.__conditionalError = S, typeof console < "u" && console.warn && console.warn(`[smbls] conditional \`${r}\` predicate threw on ${t.key || "?"} \u2014 treating as false:`, S?.message || S);
            }
            else m = b;
            y && (l.probe = !1);
            let T = c ? !m : !!m;
            if (!t.node) return;
            let v = t.context?.designSystem;
            if (T === l.lastMatch) {
                if (T && f && t.node.setAttribute) {
                    v && pt(v);
                    try {
                        II(t, n, r, f, l, !1);
                    } finally{
                        v && ut();
                    }
                }
                return;
            }
            l.lastMatch = T, v && pt(v);
            try {
                if (T) {
                    let S = {}, w = {}, _ = !1, x = !1;
                    for(let O in a){
                        if (!Object.prototype.hasOwnProperty.call(a, O)) continue;
                        let C = a[O], N = O.charAt(0);
                        if ((N === ":" || N === "@" || N === "&" || N === "[") && C && typeof C == "object" && !Array.isArray(C)) {
                            if (SE(O, t)) {
                                let M = Pd(C, t, !1, u);
                                Object.keys(M).length && (w[`[data-theme="${O.slice(1)}"] &`] = M, _ = !0);
                            } else {
                                let M = wE(O, t), K = xE(M, C, t, u);
                                Object.keys(K).length && (w[M] = K, _ = !0);
                            }
                            continue;
                        }
                        let I = typeof C == "function" ? C(t, t.state, t.context) : C;
                        if (I != null) {
                            if (O === "hide" || O === "show") {
                                let M = St[O](I, t, t.state, t.context);
                                M && M.display && (x = !0);
                            } else if (St[O]) {
                                let M = St[O](I, t, t.state, t.context);
                                if (M) {
                                    let K = Array.isArray(M) ? M : [
                                        M
                                    ];
                                    for (let V of K)V && Object.assign(S, V);
                                }
                            } else if (Ft && Ft.has(O)) S[O] = I;
                            else if (Ld(O)) S[O] = I;
                            else if (O === "vars") {
                                let M = xy(I, t);
                                M && Object.assign(S, M);
                            }
                        }
                    }
                    (x || l.hides) && (l.hides = x, yy(t, r, x));
                    let A = Object.keys(S);
                    if (A.length) {
                        bo(t.node, S, t);
                        for (let O of A){
                            let C = o.get(O);
                            C || (C = [], o.set(O, C));
                            let N = C.findIndex((I)=>I.key === r);
                            N !== -1 && C.splice(N, 1), C.push({
                                key: r,
                                value: S[O]
                            });
                        }
                        l.appliedKeys = A;
                    } else l.appliedKeys = null;
                    if (_) {
                        let O = Ke(Yr(t, w), null, t.context?.cssPrefix, {
                            state: !0
                        }), C = O ? O.split(" ").filter(Boolean) : [];
                        if (C.length && t.node.classList) {
                            for (let N of C)t.node.classList.add(N);
                            l.appliedClasses = C;
                        } else l.appliedClasses = null;
                    } else if (l.appliedClasses) {
                        for (let O of l.appliedClasses)t.node.classList.remove(O);
                        l.appliedClasses = null;
                    }
                    f && t.node.setAttribute && II(t, n, r, f, l, !0);
                } else {
                    if (l.appliedAttrs && w8(t, n, r, l), l.appliedKeys) {
                        for (let S of l.appliedKeys){
                            let w = o.get(S);
                            if (!w) continue;
                            let _ = w.findIndex((x)=>x.key === r);
                            if (_ !== -1) {
                                if (w.splice(_, 1), w.length) {
                                    let x = w[w.length - 1].value, A = Jo(S), O = String(x).trim().replace(/\s*!important\s*$/, "");
                                    Wc(t, t.node.style, A) !== O && bo(t.node, {
                                        [S]: x
                                    }, t);
                                } else o.delete(S), Ld(S) ? t.node.style.removeProperty(S) : Jo(S) === "display" ? Bd(t, "") : t.node.style[S] = "";
                            }
                        }
                        l.appliedKeys = null;
                    }
                    if (l.hides && (l.hides = !1, yy(t, r, !1)), l.appliedClasses) {
                        for (let S of l.appliedClasses)t.node.classList.remove(S);
                        l.appliedClasses = null;
                    }
                }
            } finally{
                v && ut();
            }
        };
        e.__conditionalRunners.push(d);
        let p = t[i + "Deps"], g = Ht(t, p, d);
        x8() && typeof (e.__exec && e.__exec[i] || t[i]) == "function" && !(Array.isArray(p) && p.length === 0) && (l.probe = !0);
        let h = q(g, {
            depth: e.path.length,
            label: yt(e, "conditional(" + r + ")")
        });
        l.probe && (l.probe = !1), l.untrackedReads > 0 && h._sources.size, e.__effects.push(h);
    }
}
var nE = new WeakSet, oE = new WeakMap;
function T8(t) {
    let e = oE.get(t);
    if (e === "painted") return !1;
    if (e === void 0) {
        oE.set(t, "open");
        let n = t.defaultView, o = ()=>{
            oE.set(t, "painted");
        };
        n && typeof n.requestAnimationFrame == "function" ? n.requestAnimationFrame(o) : setTimeout(o, 0);
    }
    return !0;
}
var rE = new WeakSet;
function E8(t) {
    if (rE.has(t)) return;
    rE.add(t);
    let e = ()=>{
        rE.delete(t);
        let o = t.body || t.documentElement;
        o && o.offsetWidth;
    }, n = t.defaultView;
    n && typeof n.requestAnimationFrame == "function" ? n.requestAnimationFrame(e) : setTimeout(e, 0);
}
function A8(t, e) {
    let n = t.ownerDocument;
    if (n && !T8(n)) {
        if (Q.hydration !== null && e && e.context && e.context.__hydration) {
            E8(n);
            return;
        }
        nE.has(n) || (nE.add(n), queueMicrotask(()=>{
            nE.delete(n);
            let o = n.body || n.documentElement;
            o && o.offsetWidth;
        }));
    }
}
var sE = new WeakSet, BI = !1;
function NI(t) {
    return t.startsWith("[data-theme=") || t.startsWith("[data-skin=") || t.startsWith("@media") && (t.includes("prefers-color-scheme") || t.includes("prefers-reduced-transparency"));
}
function pE(t, e) {
    let n = {
        ...t
    };
    for(let o in e){
        let r = e[o], s = n[o];
        n[o] = r && typeof r == "object" && s && typeof s == "object" ? pE(s, r) : r;
    }
    return n;
}
function vM(t, e) {
    let n = {};
    for(let o in t){
        let r = t[o];
        if (r && typeof r == "object") {
            let s = vM(r, e);
            Object.keys(s).length && (n[o] = s);
        } else e(o) || (n[o] = r);
    }
    return n;
}
function FI(t, e, n) {
    let o = TE(t);
    if (!o) return !1;
    for(let r = 0; r < o.length; r += 3){
        let s = o[r + 1];
        if (!n.has(s)) continue;
        let i = e[s];
        if (!(i == null || typeof i == "object") && IP(o[r], i, o[r + 2])) return !0;
    }
    return !1;
}
function v8(t, e, n) {
    let o = 1 / 0, r = -1 / 0;
    for (let i of e.values())i < o && (o = i), i > r && (r = i);
    if (n) for (let i of n.values())i > r && (r = i);
    if (r <= o) return null;
    let s = null;
    for (let [i, a] of e){
        if (a === r) continue;
        let c = TE(i);
        if (c) for(let l = 0; l < c.length; l += 3){
            let f = c[l], u = c[l + 1], d = c[l + 2], p = t[u] != null ? e.get(u) : void 0, g = n && n.get(f), h = p !== void 0 && p > a && oy(f, t[u], d), m = !h && g !== void 0 && g > a && oy(f, void 0, d);
            if (h || m) {
                h && delete t[i], s || (s = new Set), s.add(i);
                break;
            }
        }
    }
    return s;
}
var $I = new Map;
function TE(t) {
    let e = $I.get(t);
    if (e !== void 0) return e;
    let n = _o(t), o = Ur[n];
    if (e = null, Array.isArray(o)) {
        e = [];
        for (let r of o)e.push(r, bd(r), n);
    }
    return $I.set(t, e), e;
}
var OM = new Set([
    "page",
    "zoom"
]), O8 = (t, e)=>{
    OM.add(t);
    let n = typeof CSS < "u" ? CSS : null;
    if (!n || typeof n.supports != "function") return;
    let o = !1;
    try {
        o = n.supports(_o(t), String(e));
    } catch  {
        o = !1;
    }
    o && console.warn(`[smbls] css: "${t}: ${e}" is valid CSS, but smbls has no entry for "${t}", so the element gets no CSS for it. Write it in style: { ${t}: \u2026 } for now, and report the missing property.`);
};
function CM(t) {
    let { node: e } = t;
    if (!e) return;
    if (BI || (BI = !0, Ke({
        display: "none"
    })), sE.has(t)) {
        console.error("[applyCssInProps] re-entry detected for element", t.key, "prop path:", t.__ref?.path);
        return;
    }
    sE.add(t);
    let n = t.context?.designSystem;
    n && pt(n), Qm();
    try {
        let o = {}, r = !1, s = [], i = null, a = null, c = null, l = null, f = t.__ref && t.__ref.__mergeLayer, u, d = null, p = null, g = !1, h = (S, w)=>{
            if (w && typeof w == "object" && NI(S)) {
                c || (c = {});
                let _ = c[S];
                _ && (w = pE(_, w)), c[S] = w;
            } else (w === null || typeof w != "object") && (l || (l = new Set), l.add(S), u !== void 0 && (d || (d = new Map), d.set(S, u)));
            o[S] = w;
        };
        if (Object.prototype.hasOwnProperty.call(t, "theme") && typeof t.theme != "function" && St.theme) {
            let S = St.theme(t.theme, t, t.state, t.context);
            if (S) {
                let w = (_)=>{
                    for(let x in _){
                        let A = _[x];
                        A && typeof A == "object" ? NI(x) && (i || (i = {}), i[x] = A) : TE(x) && (a || (a = [])).push(x), o[x] = A;
                    }
                };
                if (Array.isArray(S)) for (let _ of S)_ && w(_);
                else w(S);
                r = !0;
            }
        }
        let m = (S, w)=>{
            if (S === "vars") {
                let _ = xy(w);
                if (_) {
                    for(let x in _)h(x, _[x]);
                    r = !0;
                }
                return;
            }
            if (S === "hide" || S === "show") {
                let _ = St[S](w, t, t.state, t.context);
                _ && _.display && (g = !0);
                return;
            }
            if (St[S]) {
                let _ = St[S](w, t, t.state, t.context);
                if (_) {
                    if (Array.isArray(_)) {
                        for (let x of _)if (x) for(let A in x)h(A, x[A]);
                    } else for(let x in _)h(x, _[x]);
                    r = !0;
                }
            } else if (Ft && Ft.has(S)) w != null && typeof w != "object" && (h(S, w), r = !0);
            else if (S.charCodeAt(0) === 45) w != null && typeof w != "object" && (h(S, w), r = !0);
            else if (S.charAt(0) === "&" || S.charAt(0) === "@" || S.charAt(0) === ":" || S.charAt(0) === "[") {
                if (w && typeof w == "object" && !Array.isArray(w)) {
                    if (kE(w)) return;
                    let _ = TM(S, w, t);
                    _ && (h(_.cssProp, _.block), r = !0);
                }
            } else (typeof w == "string" || typeof w == "number") && OM.has(S);
        };
        if (typeof t.class == "string") {
            let S = m8(t.class, t.context?.designSystem?.class);
            if (S) for(let w in S)m(w, S[w]);
        }
        let y = l ? new Set(l) : null, b = t.tag || "div";
        for (let S of Object.keys(t)){
            if (typeof t[S] == "function") {
                let _ = f && f.get(S);
                _ !== void 0 && Wr(b, S) && (p || (p = new Map), p.set(_o(S), _));
                continue;
            }
            if (u = f ? f.get(S) : void 0, S === "vars") {
                m(S, t[S]);
                continue;
            }
            if (Kt.has(S) || S === "theme") continue;
            let w = S.charCodeAt(0);
            w >= 65 && w <= 90 || yn(S) || uy(b, S) || m(S, t[S]);
        }
        u = void 0;
        let T = d ? v8(o, d, p) : null;
        if (a && l) for (let S of a)l.has(S) || !(S in o) || FI(S, o, l) && delete o[S];
        if (i) {
            let S = l ? (w)=>l.has(w) || FI(w, o, l) : null;
            for(let w in i){
                let _ = S ? vM(i[w], S) : i[w];
                c && c[w] && (_ = pE(_, c[w])), Object.keys(_).length ? o[w] = _ : delete o[w];
            }
        }
        if (e8(t, o, l, T ? new Set([
            ...y || [],
            ...T
        ]) : y), yy(t, "static", g), t.breakpointsFrom != null && u8(t, o) && (r = !0), r) {
            o.display && String(o.display).includes("!important") && (bo(e, {
                display: o.display
            }, t), delete o.display);
            let S = t.display != null && typeof t.display != "function" ? t.display : t.hide === !0 || t.show === !1 ? "none" : null;
            typeof S == "string" && S !== "" && o.display && o.display !== S && (o.display = S);
            let w = Ke(Yr(t, o), null, t.context?.cssPrefix);
            if (s = w ? w.split(" ").filter(Boolean) : [], w && e.classList) {
                let _ = s, x = !1;
                for (let A of _)e.classList.add(A), x || (A.charCodeAt(0) === 95 && A.charCodeAt(1) === 99 || A.charCodeAt(0) === 95 && A.indexOf("_c", 1) !== -1) && (x = !0);
                x && A8(e, t);
            }
        }
        let v = t.__ref;
        if (v) {
            let S = v.__staticCssClasses;
            if (S && e.classList) {
                let w = new Set(s);
                for (let _ of S)w.has(_) || e.classList.remove(_);
            }
            v.__staticCssClasses = s;
        }
        n8(t);
    } finally{
        Jm(), n && ut(), sE.delete(t);
    }
}
var PT = (t)=>!!St[t] || !!(Ft && Ft.has(t)) || typeof t == "string" && t.charCodeAt(0) === 45;
function IT(t) {
    t && t.node && CM(t);
}
function C8(t) {
    let { node: e } = t;
    if (!e || !e.setAttribute) return;
    if (t.aria && typeof t.aria == "object") for(let r in t.aria){
        let s = t.aria[r];
        if (typeof s == "function" || typeof s == "object" || s == null || typeof s == "string" && s.includes("{{")) continue;
        let i = "aria-" + r.replace(/[A-Z]/g, (a)=>"-" + a.toLowerCase());
        e.setAttribute(i, mo(i, s));
    }
    let n = GT(t);
    for(let r in n){
        let s = n[r];
        s != null && s !== !1 && typeof s != "function" && typeof s != "object" && e.setAttribute(r, s === !0 ? "" : s);
    }
    let o = t.tag || "div";
    for (let r of Object.keys(t)){
        if (typeof t[r] == "function" || Kt.has(r) || r === "on" || n[r] !== void 0) continue;
        let s = r.charCodeAt(0);
        if (!(s >= 65 && s <= 90) && !yn(r) && !Wr(o, r) && qe(o, r)) {
            let i = t[r];
            if (i == null) continue;
            if (typeof i == "string" && i.includes("{{")) {
                if (!zr[r]) continue;
                i = Zt.call(t, i, t.state);
            }
            if (i == null || typeof i == "function" || typeof i == "object" || i === !1 && !vi(er(r) || r)) continue;
            let a = er(r) || r;
            e.setAttribute(a, mo(a, i));
        }
    }
}
function MT(t, e) {
    let { node: n } = t;
    if (!n || !n.setAttribute) return;
    let o = e.charCodeAt(0);
    if (o >= 65 && o <= 90 || yn(e)) return;
    let r = t.tag || "div";
    if (Wr(r, e) || !qe(r, e)) return;
    let s = er(e) || e, i = s.toLowerCase(), a = t.__ref && t.__ref.__effects, c = !1;
    if (a) for(let u = 0; u < a.length; u++){
        let d = a[u];
        d && d._attrName === i && !d._disposed && typeof d._execute == "function" && (c = !0, d._execute());
    }
    if (c) return;
    let l = t[e], f = zr[e];
    if (f && l != null) {
        let u = f(t);
        u !== void 0 && (l = u);
    }
    typeof l == "string" && l.includes("{{") && (l = Zt.call(t, l, t.state)), Ei(n, s, l);
}
function R8(t, e) {
    let n = t.node, o = t.__ref, r = o.__autoGrow;
    if (!e) {
        if (r && r.active) {
            try {
                n.removeEventListener("input", r.resize);
            } catch  {}
            UI(r), Kr.delete(t), n.style.height = "", r.appliedMax != null && n.style.maxHeight === r.appliedMax && (n.style.maxHeight = ""), VI(n, r, !1), r.active = !1, r.appliedMax = null, r.lastMeasure = 0;
        }
        return;
    }
    r || (r = o.__autoGrow = {
        active: !1,
        appliedMax: null,
        lastMeasure: 0,
        lastWidth: null,
        watch: null,
        awaitingLayout: !1,
        appliedScroll: !1,
        fontsHooked: !1,
        attachAttempts: 0,
        firstAttemptAt: null,
        resize: ()=>{
            if (!n.isConnected) {
                Id(t, !0);
                return;
            }
            if (!(n.scrollHeight > 0)) {
                r.awaitingLayout = !0, jI(t, r);
                return;
            }
            r.awaitingLayout = !1;
            let i = P8(n), a = I8(i), c = n.style.height;
            n.style.height = "0px", a && iE(n);
            let l = n.scrollHeight;
            if (!(l > 0)) {
                n.style.height = c, a && iE(n);
                return;
            }
            let f = M8(n, i), u = f != null && l < f ? f : l, d = F8(i), p = d != null && u > d;
            n.style.height = N8(p ? d : u, i) + "px", a && iE(n), VI(n, r, p), r.lastMeasure = l, r.lastWidth = n.clientWidth, jI(t, r);
        }
    }, o.__eventCleanup || (o.__eventCleanup = []), o.__eventCleanup.push(()=>{
        try {
            n.removeEventListener("input", r.resize);
        } catch  {}
        UI(r), Kr.delete(t);
    })), r.active || (n.addEventListener("input", r.resize), r.active = !0, L8(t, r));
    let s = typeof e == "object" && e.max != null ? String(e.max) : null;
    s !== r.appliedMax && (s == null ? r.appliedMax != null && n.style.maxHeight === r.appliedMax && (n.style.maxHeight = "") : n.style.maxHeight = s, r.appliedMax = s), r.resize();
}
function Id(t, e) {
    let n = t.__ref?.__autoGrow;
    n && (e && (n.attachAttempts = 0, n.firstAttemptAt = null), Kr.add(t), Md());
}
function D8() {
    let t = Array.from(Kr);
    Kr.clear();
    for(let e = 0; e < t.length; e++){
        let n = t[e], o = n.node, r = n.__ref?.__autoGrow;
        if (!(!o || !r || !r.active)) {
            if (!o.isConnected) {
                r.firstAttemptAt == null && (r.firstAttemptAt = Vc()), r.attachAttempts += 1, r.attachAttempts <= ZI && Vc() - r.firstAttemptAt < QI && (Kr.add(n), Md());
                continue;
            }
            r.attachAttempts = 0, r.firstAttemptAt = null, r.resize();
        }
    }
}
function jI(t, e) {
    if (e.watch) return;
    let n = t.node;
    if (!n) return;
    let o = n.ownerDocument && n.ownerDocument.defaultView, r = o && o.ResizeObserver || (typeof ResizeObserver == "function" ? ResizeObserver : null);
    if (typeof r != "function") return;
    let s = ()=>{
        if (!e.active || !n.isConnected || !(n.scrollHeight > 0)) return;
        if (e.awaitingLayout) {
            e.awaitingLayout = !1, Id(t, !0);
            return;
        }
        let a = n.clientWidth;
        e.lastWidth != null && Math.abs(a - e.lastWidth) < .5 || (e.lastWidth = a, Id(t, !0));
    }, i;
    try {
        i = new r(s), i.observe(n);
    } catch  {
        return;
    }
    e.watch = i;
}
function UI(t) {
    let e = t.watch;
    if (e) {
        t.watch = null;
        try {
            e.disconnect();
        } catch  {}
    }
}
function L8(t, e) {
    if (e.fontsHooked) return;
    e.fontsHooked = !0;
    let n = t.node && t.node.ownerDocument, o = n && n.fonts && n.fonts.ready;
    !o || typeof o.then != "function" || o.then(()=>{
        e.active && t.node && Id(t, !0);
    }, ()=>{});
}
function P8(t) {
    let e = t.ownerDocument && t.ownerDocument.defaultView;
    try {
        return e && e.getComputedStyle ? e.getComputedStyle(t) : null;
    } catch  {
        return null;
    }
}
var Ci = (t)=>typeof t == "string" && /^\s*-?\d*\.?\d+px\s*$/.test(t) ? parseFloat(t) : null, EE = (t)=>(Ci(t.paddingTop) || 0) + (Ci(t.paddingBottom) || 0), RM = (t)=>(Ci(t.borderTopWidth) || 0) + (Ci(t.borderBottomWidth) || 0);
function I8(t) {
    if (!t) return !1;
    let e = String(t.transitionProperty || "").split(","), n = String(t.transitionDuration || "0s").split(",");
    for(let o = 0; o < e.length; o++){
        let r = e[o].trim();
        if (!(r !== "all" && r !== "height") && parseFloat(n[o % n.length]) > 0) return !0;
    }
    return !1;
}
function iE(t) {
    if (typeof t.getAnimations != "function") return;
    let e;
    try {
        e = t.getAnimations();
    } catch  {
        return;
    }
    for(let n = 0; n < e.length; n++){
        let o = e[n];
        if (o && o.transitionProperty === "height") try {
            o.cancel();
        } catch  {}
    }
}
function M8(t, e) {
    if (!e || !t.hasAttribute || !t.hasAttribute("rows")) return null;
    let n = parseInt(t.getAttribute("rows"), 10);
    if (!(n > 0)) return null;
    let o = Ci(e.lineHeight) || B8(t, e);
    return o > 0 ? n * o + EE(e) : null;
}
var Ed = [
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "fontStretch",
    "fontSize",
    "fontFamily",
    "lineHeight",
    "letterSpacing"
], HI = new WeakMap;
function B8(t, e) {
    let n = t.ownerDocument, o = n && (n.body || n.documentElement);
    if (!o || !n.createElement) return null;
    let r = HI.get(n);
    r || (r = new Map, HI.set(n, r));
    let s = Ed.map((l)=>e[l] || "").join("|");
    if (r.has(s)) return r.get(s);
    let i = n.createElement("textarea");
    i.rows = 1, i.setAttribute("aria-hidden", "true"), i.tabIndex = -1;
    let a = i.style;
    a.position = "absolute", a.visibility = "hidden", a.top = "0", a.left = "-9999px", a.height = "auto", a.minHeight = "0", a.maxHeight = "none", a.padding = "0", a.border = "0", a.boxSizing = "content-box", a.overflow = "hidden";
    for(let l = 0; l < Ed.length; l++)e[Ed[l]] && (a[Ed[l]] = e[Ed[l]]);
    let c = 0;
    try {
        o.appendChild(i), c = i.clientHeight;
    } catch  {
        c = 0;
    } finally{
        i.parentNode && i.parentNode.removeChild(i);
    }
    return c > 0 ? (r.set(s, c), c) : null;
}
function N8(t, e) {
    return e ? e.boxSizing === "border-box" ? t + RM(e) : e.boxSizing === "content-box" ? Math.max(0, t - EE(e)) : t : t;
}
function F8(t) {
    if (!t) return null;
    let e = Ci(t.maxHeight);
    if (e == null || !(e > 0)) return null;
    let n = EE(t), o = RM(t), r = t.boxSizing === "border-box" ? e - o : e + n, s = Ci(t.lineHeight);
    if (!(s > 0)) return r;
    let i = Math.floor((r - n) / s + 1e-6);
    return i >= 1 ? i * s + n : r;
}
function VI(t, e, n) {
    n ? e.appliedScroll || (t.style.overflowY = "auto", e.appliedScroll = !0) : e.appliedScroll && (t.style.overflowY === "auto" && (t.style.overflowY = ""), e.appliedScroll = !1);
}
var zI = [
    "srcObject",
    "muted"
], $8 = (t, e)=>t === "muted" ? e === !0 || e === "" || e === "true" || e === "muted" : e ?? null;
function j8(t) {
    let e = t.node, n = t.__ref;
    if (!(!e || !n)) for(let o = 0; o < zI.length; o++){
        let r = zI[o], s = t[r];
        if (s === void 0 || !(r in e)) continue;
        let i = (a)=>{
            let c = $8(r, a);
            if (e[r] !== c) try {
                e[r] = c;
            } catch (l) {
                oe(n, r, l);
            }
        };
        if (typeof s == "function") {
            let a = Ht(t, t[r + "Deps"], s), c = q(()=>{
                try {
                    i(a(t, t.state, t.context));
                } catch (l) {
                    oe(n, r, l);
                }
            }, {
                depth: n.path.length,
                label: yt(n, r)
            });
            n.__effects.push(c), n.__exec[r] = s;
        } else i(s);
        r === "srcObject" && (n.__releaseMedia = ()=>{
            try {
                e.srcObject != null && (e.srcObject = null);
            } catch  {}
        });
    }
}
function U8(t) {
    if (!t.autoGrow) return;
    let e = t.node;
    if (!e || e.tagName !== "TEXTAREA") return;
    let n = t.__ref, o = t.autoGrow, r = typeof o == "function" ? Ht(t, t.autoGrowDeps, o) : null, s = q(()=>{
        let i = t.autoGrow, a = i;
        if (typeof i == "function") try {
            a = (i === o && r ? r : i)(t, t.state, t.context);
        } catch  {
            a = null;
        }
        R8(t, a);
    }, {
        depth: n.path.length,
        label: yt(n, "autoGrow")
    });
    n.__effects || (n.__effects = []), n.__effects.push(s), r && (n.__exec.autoGrow = o);
}
var DM = new Set([
    "onSwipe",
    "onSwipeLeft",
    "onSwipeRight",
    "onSwipeUp",
    "onSwipeDown"
]);
function LM(t, e) {
    let n = !1;
    for (let o of Object.keys(t)){
        if (!yn(o) || DM.has(o)) continue;
        if (o === "onInView" || o === "onLeaveView") {
            n = !0;
            continue;
        }
        let r = qm(o);
        if (r) {
            Ym(r, t, t[o]);
            continue;
        }
        let s = t[o], i = null;
        if (s && typeof s == "object" && !Array.isArray(s) && (i = s, s = i.handler), s = gd(t, s), typeof s != "function") continue;
        let a = Km(o);
        uo.has(a) || Tc(bK(a), t, s, i);
    }
    H8(t), n && Q.viewEvents && Q.viewEvents(t);
}
function H8(t) {
    let e = t.node;
    if (!e || !e.addEventListener) return;
    let n = {}, o = !1;
    for (let d of DM){
        let p = t[d];
        typeof p == "function" && (n[d] = p, o = !0);
    }
    if (!o) return;
    let r = typeof t.swipeThreshold == "number" ? t.swipeThreshold : 40, s = typeof t.swipeMaxDuration == "number" ? t.swipeMaxDuration : 600, i = 0, a = 0, c = 0, l = !1, f = (d)=>{
        let p = d.touches && d.touches[0] || d.changedTouches && d.changedTouches[0];
        p && (i = p.clientX, a = p.clientY, c = Date.now(), l = !0);
    }, u = (d)=>{
        if (!l) return;
        l = !1;
        let p = d.changedTouches && d.changedTouches[0] || d.touches && d.touches[0];
        if (!p) return;
        let g = p.clientX - i, h = p.clientY - a, m = Date.now() - c;
        if (m > s) return;
        let y = Math.abs(g), b = Math.abs(h);
        if (Math.max(y, b) < r) return;
        let T;
        if (y > b * 1.2) T = g < 0 ? "left" : "right";
        else if (b > y * 1.2) T = h < 0 ? "up" : "down";
        else return;
        let v = "onSwipe" + T.charAt(0).toUpperCase() + T.slice(1), S = n[v], w = n.onSwipe;
        S && S.call(t, d, t, t.state, t.context), w && w.call(t, {
            direction: T,
            dx: g,
            dy: h,
            dt: m,
            event: d
        }, t, t.state, t.context);
    };
    e.addEventListener("touchstart", f, {
        passive: !0
    }), e.addEventListener("touchend", u, {
        passive: !0
    }), t.__ref.__eventCleanup || (t.__ref.__eventCleanup = []), t.__ref.__eventCleanup.push(()=>{
        try {
            e.removeEventListener("touchstart", f);
        } catch  {}
        try {
            e.removeEventListener("touchend", u);
        } catch  {}
    });
}
function AE(t, e, n, o, r, s, i, a) {
    let c = e;
    (typeof c == "string" || typeof c == "number") && (c = {
        text: c
    });
    let l = o;
    if (typeof o == "function") try {
        l = o(t, c);
    } catch  {
        l = null;
    }
    let f = typeof o == "function" ? Rd(l) : r;
    if (a && !i && (f = Dd(f, Rd(e))), i) {
        let u = e;
        (typeof e == "string" || typeof e == "number") && (u = {
            value: e,
            text: e
        }), c = l ? {
            ...l,
            state: u
        } : {
            state: u
        };
    } else l && (c = Ge(l, c));
    return c = Nd(c, s), {
        def: c,
        key: tM(c?.key, e, n, t),
        supplied: f,
        props: l
    };
}
function Nd(t, e) {
    if (!e || !t || t.ignoreChildExtends) return t;
    if (!t.extends) return {
        ...t,
        extends: e
    };
    let n = Array.isArray(t.extends) ? t.extends : [
        t.extends
    ], o = Array.isArray(e) ? e : [
        e
    ];
    return {
        ...t,
        extends: [
            ...o,
            ...n
        ]
    };
}
var nr = (t)=>{
    let e = t && t.__ref;
    if (!e || e.__if === !1 || e.__mount && e.__mount.held) return null;
    let n = t.node;
    return n && n.nodeType !== 11 ? n : null;
}, PM = (t, e)=>e ? e.nextSibling : Sd(t.node, t.__ref.__textNode), ky = (t, e, n)=>{
    let o = PM(t, n);
    return e !== o && t.node.insertBefore(e, o), e;
}, Fd = (t, e)=>{
    let n = PM(t, e);
    return n ? {
        position: "before",
        node: n
    } : void 0;
};
function vE(t, e, n) {
    let o = null;
    for(let r = 0; r < e.length; r++){
        if (n && n.has(e[r])) continue;
        let s = nr(t[e[r]]);
        s && (o = ky(t, s, o));
    }
}
function WI(t, e, n, o) {
    let r = Q.rows, s = r !== null && t.childrenAs !== "state" && t.tag !== "fragment" ? r.track(t) : null, i = OE(t, e, n, o, !0, s);
    return t.__ref.__plainRows = s && (i || e == null || e === !1) ? s : null, i;
}
function OE(t, e, n, o, r, s) {
    if (!e || !t.node) return;
    let i = t.childExtends, a = Gr(t, "childProps"), c = t.__ref, l = Q.mount, f = o > 0 && t.tag !== "fragment" && c ? o : 0;
    if (Array.isArray(e)) {
        let u = t.childProps, d = t.childrenAs === "state", p = (g, h)=>{
            let m = AE(t, e[g], g, u, a, i, d, r);
            s && s.add(m.key, e[g], m, u, i);
            try {
                let y = Gt(Oi(m.def, m.supplied), t, m.key, n, h);
                return !y && s && s.none(m.key), gy(t, y), y;
            } catch (y) {
                if (s && s.failed(m.key), typeof console < "u" && console.error) {
                    let b = t.__ref?.path?.join(".") || t.key || "<root>";
                    console.error(`[smbls] child "${m.key}" failed to construct at ${b} (initial render, skipping this row):`, y?.message || y);
                }
                return ki(t, {
                    where: "child",
                    key: m.key,
                    error: y
                }), null;
            }
        };
        if (!f) {
            for(let g = 0; g < e.length && !(c && c.__disposed); g++)p(g);
            return !0;
        }
        return l.rows(t, e.length, p, f), !0;
    }
    if (typeof e == "string") {
        let u = rM(e, t);
        if (Array.isArray(u)) return OE(t, u, n, o, !0, s);
    }
    if (typeof e == "object") {
        let u = (p, g)=>{
            if (Kt.has(p)) return !1;
            let h = e[p];
            if (h == null || h === !1) return !1;
            let m = r ? Dd(a, Rd(h)) : a;
            (typeof h == "string" || typeof h == "number") && (h = {
                text: h
            }), t.childProps && (h = Ge(t.childProps, h)), h = Nd(h, i);
            let y = Gt(Oi(h, m), t, by(t, p), n, g);
            return gy(t, y), y;
        };
        if (!f) {
            for(let p in e)u(p);
            return;
        }
        let d = [];
        for(let p in e)d.push(p);
        l.rows(t, d.length, (p, g)=>u(d[p], g), f);
    }
}
function Hc(t, e) {
    let n = t.node;
    if (!n || n.tagName !== "SELECT") return;
    let o = n.options;
    if (!o || !o.length) return;
    let r = t.__ref, s = r && r.__exec && r.__exec.value, i = typeof s == "function", a = t.value != null && typeof t.value != "function";
    if (i || a) {
        let f;
        if (i) try {
            f = s(t, t.state, t.context);
        } catch  {
            return;
        }
        else f = t.value, typeof f == "string" && f.includes("{{") && (f = Zt.call(t, f, t.state));
        let u = f == null ? "" : String(f);
        n.value !== u && (n.value = u);
        return;
    }
    let c = e || !(r && r.__selectSynced);
    if (r && (r.__selectSynced = !0), !c) return;
    let l = -1;
    for(let f = 0; f < o.length; f++)o[f].defaultSelected && (l = f);
    l >= 0 && n.selectedIndex !== l && (n.selectedIndex = l);
}
function IM(t, e) {
    let { children: n, content: o } = t, r = t.childExtends, s = typeof n == "function", i = s || iM(t, "children");
    if (typeof n == "function") {
        let u = n, d = t.__ref, p = !1, g, h = Ht(t, t.childrenDeps, u), m = q(()=>{
            let y = p;
            p = !0;
            let b;
            try {
                b = h(t, t.state, t.context);
            } catch (O) {
                if (typeof console < "u" && console.error) {
                    let C = t.__ref?.path?.join(".") || t.key || "<root>";
                    console.error(`[smbls] \`children:\` factory threw at ${C}${y ? "" : " (initial run, treating as empty)"}:`, O?.message || O);
                }
                ki(t, {
                    where: "children",
                    error: O
                });
                return;
            }
            if (!y) {
                g = b;
                return;
            }
            if (b === t.children) return;
            kI(t, b), t.children = b, d.__mount && d.__mount.chunkGen++;
            let T = typeof t.onContentUpdate == "function", v = T ? [] : null, S = T ? [] : null, w = T ? [] : null;
            if (Array.isArray(b) && t.childrenAs === "state") {
                let O = t.childProps, C = [], N = new Map;
                for(let tt = 0; tt < b.length; tt++){
                    let Y = b[tt], G = O;
                    if (typeof O == "function") try {
                        G = O(t, Y);
                    } catch  {
                        G = null;
                    }
                    let st = tM(G && G.key, Y, tt, t);
                    C.push(st), N.set(st, {
                        rawChild: Y,
                        childProps: G
                    });
                }
                let I = new Set(C), M = yI(d, d.__children.slice());
                for (let tt of M)if (!I.has(tt)) {
                    let Y = t[tt];
                    Y?.remove && Y.remove(), delete t[tt], S && S.push(tt);
                }
                let K = t.childExtends, J = !(t.tag === "fragment") && !!t.node, ht = null, nt = new Set;
                for (let tt of C){
                    let Y = N.get(tt), G = Y.rawChild, st = t[tt];
                    if (st && st.state) {
                        if (G && typeof G == "object") {
                            let gt = st.state, Tt = gt.$replace || gt.replace, Yt = gt.$update || gt.update;
                            try {
                                if (typeof Tt == "function") Tt.call(gt, G);
                                else if (typeof Yt == "function") {
                                    for(let Ot in gt)if (!(Ot === "__element" || Ot === "root" || Ot === "parent" || Ot === "update") && !Object.prototype.hasOwnProperty.call(G, Ot)) try {
                                        gt[Ot] = void 0;
                                    } catch  {}
                                    Yt.call(gt, G);
                                } else for(let Ot in G)gt[Ot] = G[Ot];
                            } catch (Ot) {
                                if (typeof console < "u" && console.error) {
                                    let Ze = t.__ref?.path?.join(".") || t.key || "<root>";
                                    console.error(`[smbls] child "${tt}" failed to patch at ${Ze} (reconcile, keeping its previous data for this pass):`, Ot?.message || Ot);
                                }
                            }
                        }
                        if (w && w.push(tt), J) {
                            let gt = nr(st);
                            gt && (ht = ky(t, gt, ht));
                        }
                        continue;
                    }
                    let ot = G;
                    (typeof G == "string" || typeof G == "number") && (ot = {
                        value: G,
                        text: G
                    });
                    let dt = Y.childProps, X = Nd(dt ? {
                        ...dt,
                        state: ot
                    } : {
                        state: ot
                    }, K), U = typeof O == "function" ? Rd(dt) : Gr(t, "childProps"), Rt;
                    try {
                        Rt = Gt(Oi(X, U), t, tt, e, J ? Fd(t, ht) : void 0);
                    } catch (gt) {
                        if (typeof console < "u" && console.error) {
                            let Tt = t.__ref?.path?.join(".") || t.key || "<root>";
                            console.error(`[smbls] child "${tt}" failed to construct at ${Tt} (reconcile, skipping this row):`, gt?.message || gt);
                        }
                        ki(t, {
                            where: "child",
                            key: tt,
                            error: gt
                        }), nt.add(tt);
                        continue;
                    }
                    if (d.__disposed) return;
                    if (J) {
                        let gt = nr(Rt);
                        gt && (ht = gt);
                    }
                    v && v.push(tt);
                }
                J && vE(t, C, nt.size ? nt : null), d.__children = nt.size ? C.filter((tt)=>!nt.has(tt)) : C, T && (v.length || S.length) && py(t, {
                    added: v,
                    removed: S,
                    kept: w
                }), Hc(t, !1);
                return;
            }
            if (t.childrenAs !== "state" && d.__plainRows && Q.rows.reconcile(t, d, b, e, T)) {
                Hc(t, !1);
                return;
            }
            let A = T ? [
                ...d.__children
            ] : null;
            for (let O of yI(d, [
                ...d.__children
            ])){
                let C = t[O];
                C?.remove && C.remove(), delete t[O];
            }
            d.__children = [], WI(t, b, e, 0), Hc(t, !1), T && py(t, {
                added: [
                    ...d.__children
                ],
                removed: A,
                kept: []
            });
        }, {
            depth: d.path.length,
            label: yt(d, "children")
        });
        d.__effects.push(m), n = g, kI(t, n), t.children = n;
    }
    let a = Q.mount, c = a !== null ? a.budgetOf(t, e) : 0, l = wd(t.__ref), f = s ? WI(t, n, e, c) : OE(t, n, e, c, i);
    if (c && wd(t.__ref) > l) {
        a.defer(t, c, ()=>KI(t, e, n, o, r, f, c));
        return;
    }
    KI(t, e, n, o, r, f, c);
}
function KI(t, e, n, o, r, s, i) {
    let a = wd(t.__ref);
    if (o != null && !(o && o.__ref)) {
        let c = o;
        typeof c == "string" || typeof c == "number" ? c = {
            text: c
        } : typeof c != "object" && (c = {}), t.childProps && (c = Ge(t.childProps, c)), c = Nd(c, r);
        let l = Dd(Gr(t, "childProps"), Gr(t, "content"));
        gy(t, Gt(Oi(c, l), t, "content", e));
    }
    if (!(n && !s)) {
        if (i && wd(t.__ref) > a) {
            Q.mount.defer(t, i, ()=>GI(t, e, r, i));
            return;
        }
        GI(t, e, r, i);
    }
}
function GI(t, e, n, o) {
    let r = t.context?.components || {}, s = t.__ref && t.__ref.__runtimeSource, i = s ? {} : null;
    {
        let l = Object.keys(t);
        for(let f = 0; f < l.length; f++){
            let u = l[f];
            if (!u.endsWith("Extends") || typeof t[u] != "string") continue;
            let d = u.slice(0, -7);
            if (!d || d.charCodeAt(0) < 65 || d.charCodeAt(0) > 90) continue;
            let p = {
                extends: t[u]
            };
            delete t[u];
            for(let g = f + 1; g < l.length; g++){
                let h = l[g], m = h.charCodeAt(0);
                if (m >= 65 && m <= 90 || Kt.has(h) || typeof t[h] == "function" && (h.startsWith("on") || h.startsWith("."))) break;
                let y = t[h];
                y !== void 0 && (p[h] = y, delete t[h], i && Cd(s, h) && (i[d] || (i[d] = {}), i[d][h] = s[h]));
            }
            t[d] && typeof t[d] == "object" ? t[d] = {
                ...p,
                ...t[d]
            } : t[d] = p;
        }
    }
    let a = Object.keys(t), c = (l)=>{
        if (Kt.has(l) || typeof t[l] != "object" || t[l] === null) return !1;
        let f = l.charCodeAt(0);
        if (f < 65 || f > 90) return !1;
        let u = t[l];
        if (u.__ref) return !1;
        if (!u.extends && !u.extend) {
            let p = r[l] || r[`smbls.${l}`];
            p && (u = {
                ...u,
                extends: p
            });
        }
        t.childProps && (u = Ge(t.childProps, u)), u = Nd(u, n);
        let d = s ? Dd(Gr(t, "childProps"), Dd(i[l] || null, Gr(t, l))) : null;
        gy(t, Gt(Oi(u, d), t, l, e));
    };
    if (!o) {
        for (let l of a)c(l);
        return;
    }
    Q.mount.run(t, a.length, (l)=>c(a[l]), o);
}
function zc(t, e, n) {
    let { node: o } = t;
    if (!o) return;
    o.ref = t;
    let r = e?.tag === "fragment" ? e.__ref?.__fragmentAnchor : null;
    if (r) {
        let c = r.parentNode;
        if (c) {
            if (n?.position === "before" && n.node) c.insertBefore(o, n.node);
            else if (n?.position === "after" && n.node) {
                let l = n.node.nextSibling;
                c.insertBefore(o, l || r);
            } else c.insertBefore(o, r);
            Wm();
            return;
        }
    }
    let s = e?.node || (e?.nodeType ? e : null);
    if (!s) return;
    if (!n && Q.hydration !== null) {
        let c = t.context && t.context.__hydration;
        if (c && Q.hydration.place(c, t, e, s, o)) return;
    }
    let i = n?.node, a = o.parentNode === s;
    if (i && i.parentNode !== s) (!a || o.nextSibling) && s.appendChild(o);
    else if (n?.position === "before" && i) i !== o && (!a || o.nextSibling !== i) && s.insertBefore(o, i);
    else if (n?.position === "after" && n.node) {
        let c = n.node.nextSibling;
        c === o || (c ? s.insertBefore(o, c) : s.appendChild(o));
    } else (!a || o.nextSibling) && s.appendChild(o);
    Wm();
}
var _y = 3;
function ay(t) {
    return !t || t.__inBeforeUpdate || (t.__beforeUpdateFailCount || 0) >= _y ? !1 : (t.__inBeforeUpdate = !0, !0);
}
function go(t, e) {
    t && (t.__inBeforeUpdate = !1, e ? (t.__beforeUpdateFailCount = (t.__beforeUpdateFailCount || 0) + 1, t.__beforeUpdateFailCount === _y && typeof console < "u" && console.error && console.error(`[DOMQL] onBeforeUpdate failed ${_y}x in a row on this element \u2014 pausing automatic retries until a future prop/state change re-arms it.`)) : t.__beforeUpdateFailCount = 0);
}
function me(t, e, n) {
    let o = t.charAt(0).toLowerCase() + t.slice(1);
    Vn(o, e, n);
    let r = "on" + t, s = e[r];
    if (typeof s == "function") {
        let c = t === "Render" ? "__inRender" : t === "RenderRouter" ? "__inRenderRouter" : null;
        if (c) {
            if (e.__ref[c]) return !0;
            e.__ref[c] = !0;
        }
        let l = e.context?.designSystem;
        l && pt(l);
        let f = !!c;
        try {
            let u = s(e, e.state, e.context, n);
            if (u && typeof u.then == "function") {
                let d = e.__ref;
                return u.catch((p)=>{
                    bn(e, r, p);
                }).finally(()=>{
                    c && d && (d[c] = !1);
                }), f = !1, !0;
            }
            if (u === !1) return !1;
        } catch (u) {
            if (bn(e, r, u), e.context?.strictMode) throw u;
        } finally{
            l && ut(), f && e.__ref && (e.__ref[c] = !1);
        }
    }
    return !0;
}
var $d = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), FM = 1e3, $M = 24, CE = Object.freeze({}), LE = Object.freeze({}), Kc = 0, Ty = (t)=>{
    if (xt(t) || $d(t, "__ref")) return !1;
    let e = Object.getPrototypeOf(t);
    return e === Object.prototype || e === null;
};
function RE(t, e, n) {
    if (t === null || typeof t != "object") return t;
    if (--Kc < 0 || e > $M) {
        Kc = -1;
        return;
    }
    if (Array.isArray(t)) {
        let r = new Array(t.length);
        for(let s = 0; s < t.length; s++)r[s] = n ? t[s] : RE(t[s], e + 1, !1);
        return r;
    }
    if (n || !Ty(t)) return t;
    let o = {};
    for(let r in t)$d(t, r) && (o[r] = RE(t[r], e + 1, r === "extends" || r === "childExtends"));
    return o;
}
function MM(t) {
    Kc = FM;
    let e;
    try {
        e = RE(t, 0, !1);
    } catch  {
        return CE;
    }
    return Kc < 0 ? CE : e;
}
function DE(t, e, n, o) {
    if (t === e) return !0;
    if (t === null || typeof t != "object" || e === null || typeof e != "object" || --Kc < 0 || n > $M) return !1;
    if (Array.isArray(t)) {
        if (!Array.isArray(e) || e.length !== t.length) return !1;
        for(let s = 0; s < t.length; s++)if (o ? t[s] !== e[s] : !DE(t[s], e[s], n + 1, !1)) return !1;
        return !0;
    }
    if (o || Array.isArray(e) || !Ty(t) || !Ty(e)) return !1;
    let r = 0;
    for(let s in t)if ($d(t, s) && (r++, !$d(e, s) || !DE(t[s], e[s], n + 1, s === "extends" || s === "childExtends"))) return !1;
    for(let s in e)$d(e, s) && r--;
    return r === 0;
}
function BM(t, e) {
    if (e === CE || e === LE) return !1;
    Kc = FM;
    try {
        return DE(t, e, 0, !1);
    } catch  {
        return !1;
    }
}
var Ey = (t)=>$e() ? De(()=>MM(t)) : MM(t), NM = (t, e)=>$e() ? De(()=>BM(t, e)) : BM(t, e);
function jM(t, e, n, o) {
    let r = t;
    return r && typeof r == "object" && !Array.isArray(r) && !Ty(r) && (o || n && !r.ignoreChildExtends) && (r = o ? Ge({}, r) : {
        ...r
    }), typeof e == "function" ? {
        item: r,
        props: o
    } : r;
}
var UM = (t)=>({
        childProps: typeof t.childProps == "function" ? void 0 : t.childProps,
        childExtends: t.childExtends
    }), Ay = class {
    constructor(e, n){
        this.shared = e, this.rows = n;
    }
    add(e, n, o, r, s) {
        this.rows.set(e, Ey(jM(n, r, s, o.props)));
    }
    failed(e) {
        this.rows.set(e, LE);
    }
    none(e) {
        this.rows.delete(e);
    }
}, V8 = Object.freeze([]);
function z8(t, e, n, o, r) {
    let s = e.__plainRows.rows, i = e.__plainRows.shared, a = UM(t), c = NM(a, i), l = t.childProps, f = Gr(t, "childProps"), u = t.childExtends, d = new Array(n.length), p = new Map;
    for(let _ = 0; _ < n.length; _++){
        let x = AE(t, n[_], _, l, f, u, !1, !0);
        if (p.has(x.key)) return !1;
        p.set(x.key, x), d[_] = x;
    }
    for(let _ = 0; _ < d.length; _++){
        let x = d[_];
        x.input = jM(n[_], l, u, x.props);
        let A = c ? s.get(x.key) : void 0;
        if (A === void 0) continue;
        let O = t[x.key];
        O && O.__ref && O.parent === t && NM(x.input, A) && (x.kept = !0, x.snap = A);
    }
    let g = r ? [] : null;
    for (let _ of s.keys()){
        let x = p.get(_);
        if (x && x.kept) continue;
        let A = t[_];
        A?.remove && A.remove(), delete t[_], g && g.push(_);
    }
    let h = r ? [] : null, m = r ? [] : null, y = new Map, b = null, T = null;
    for(let _ = 0; _ < d.length; _++){
        let x = d[_];
        if (x.kept) {
            y.set(x.key, x.snap), m && m.push(x.key);
            let C = nr(t[x.key]);
            C && (T = ky(t, C, T));
            continue;
        }
        y.set(x.key, Ey(x.input));
        let A;
        try {
            A = Gt(Oi(x.def, x.supplied), t, x.key, o, Fd(t, T));
        } catch (C) {
            if (y.set(x.key, LE), b || (b = new Set), b.add(x.key), typeof console < "u" && console.error) {
                let N = e.path?.join(".") || t.key || "<root>";
                console.error(`[smbls] child "${x.key}" failed to construct at ${N} (re-run, skipping this row):`, C?.message || C);
            }
            ki(t, {
                where: "child",
                key: x.key,
                error: C
            });
            continue;
        }
        if (e.__disposed) return !0;
        if (!A) {
            y.delete(x.key);
            continue;
        }
        let O = nr(A);
        O && (T = O), h && h.push(x.key);
    }
    e.__plainRows = new Ay(c ? i : Ey(a), y);
    let v = Array.from(y.keys());
    vE(t, v, b);
    let S = new Set(e.__children), w = [];
    for(let _ = 0; _ < v.length; _++)S.has(v[_]) && w.push(v[_]);
    for (let _ of e.__children)y.has(_) || w.push(_);
    return e.__children = w, r && (h.length || g.length) && py(t, {
        added: h,
        removed: g,
        kept: m
    }), !0;
}
var HM = {
    track: (t)=>new Ay(Ey(UM(t)), new Map),
    reconcile (t, e, n, o, r) {
        let s = Array.isArray(n) ? n : n == null || n === !1 ? V8 : null;
        return !!s && z8(t, e, s, o, r);
    }
};
var W8 = new Set([
    "src",
    "srcset"
]), K8 = new Set([
    "class",
    "style",
    "id",
    "data-br"
]), G8 = new Set([
    "sizes",
    "loading",
    "fetchpriority",
    "decoding",
    "crossorigin",
    "referrerpolicy",
    "width",
    "height"
]), q8 = new Set([
    "sizes",
    "media",
    "type",
    "width",
    "height"
]), Y8 = (t)=>t === "img" ? G8 : t === "source" ? q8 : null, X8 = (t)=>t.charCodeAt(0) === 97 && t.startsWith("aria-") || t.charCodeAt(0) === 100 && t.startsWith("data-") && t !== "data-br" && t !== "data-key", VM = (t, e)=>{
    for (let n of e){
        let o = t.nodes.get(n.target);
        o && (o.delete(n.attributeName), o.size || t.nodes.delete(n.target));
    }
}, Z8 = (t, e, n)=>{
    let o = t.built;
    if (!o) {
        let r = e.ownerDocument && e.ownerDocument.defaultView && e.ownerDocument.defaultView.MutationObserver || (typeof MutationObserver == "function" ? MutationObserver : null);
        if (!r) return !1;
        let s = new Map;
        o = t.built = {
            nodes: s,
            observer: null
        }, o.observer = new r((i)=>VM(o, i));
    }
    return o.nodes.set(e, new Set(n)), o.observer.observe(e, {
        attributes: !0,
        attributeFilter: n
    }), !0;
};
function Xr(t) {
    let e = t && t.built;
    if (!e) return 0;
    t.built = null, VM(e, e.observer.takeRecords()), e.observer.disconnect();
    let n = 0;
    for (let [o, r] of e.nodes)for (let s of r)o.hasAttribute(s) && (o.removeAttribute(s), n++);
    return e.nodes.clear(), n;
}
function PE(t) {
    let e = t?.context?.__hydration;
    if (!e) return null;
    let n = t.tag = Hn(t);
    if (n === "string" || n === "fragment") return null;
    let o = an(t), r = e.registry[o === "" ? "__root" : o], s = r !== void 0 ? e.nodes[r] : null;
    if (!s || s.nodeType !== 1 || e.claimed.has(s)) return r !== void 0 && e.misses++, null;
    let i = Un(n) && (n === "svg" || t.parent?.node?.namespaceURI === ho), a = Un(n) && !i && n !== "svg" ? "div" : n, c = i ? s.namespaceURI === ho : s.namespaceURI !== ho;
    if (s.localName !== a || !c) return e.misses++, null;
    e.claimed.add(s), e.adopted++, t.__ref && (t.__ref.__adoption = "adopted");
    let l = e.pending;
    if (l && l.delete(s)) {
        let p = s.parentNode, g = p ? (e.pendingIn.get(p) || 1) - 1 : 0;
        g > 0 ? e.pendingIn.set(p, g) : p && e.pendingIn.delete(p);
    }
    let f = null, u = null, d = Y8(s.localName);
    for (let p of Array.from(s.getAttributeNames ? s.getAttributeNames() : []))W8.has(p) || p === "data-key" || (K8.has(p) || (u || (u = new Map)).set(p, s.getAttribute(p)), !(d && d.has(p)) && (X8(p) ? (f || (f = [])).push(p) : s.removeAttribute(p)));
    if (f && !Z8(e, s, f)) for (let p of f)s.removeAttribute(p);
    if (u && t.__ref && (t.__ref.__builtAttrs = {
        node: s,
        values: u
    }), l) {
        let p = 0, g = 0, h = s.firstChild, m = t.text != null && h && h.nodeType === 3 && !l.has(h) ? h : null;
        m && t.__ref && (t.__ref.__builtText = m);
        for(let y = s.firstChild; y;){
            let b = y.nextSibling;
            y !== m && !l.has(y) && (y.nodeType === 3 ? p++ : y.nodeType !== 8 && g++, s.removeChild(y)), y = b;
        }
        (g || p > (t.text != null && !m ? 1 : 0)) && (e.whole || (e.whole = new Set)).add(t);
    } else for(; s.firstChild;)s.removeChild(s.firstChild);
    return s.localName === "img" && s.complete && s.naturalWidth > 0 && J8(s), s;
}
var Q8 = 500;
function J8(t) {
    let e = !1, n = !1, o = (r)=>{
        r.isTrusted && (n ? r.stopImmediatePropagation() : e = !0, t.removeEventListener("load", o, !0));
    };
    t.addEventListener("load", o, !0), setTimeout(()=>{
        if (!e) {
            if (!(t.complete && t.naturalWidth > 0)) {
                t.removeEventListener("load", o, !0);
                return;
            }
            n = !0, t.dispatchEvent(new Event("load")), setTimeout(()=>t.removeEventListener("load", o, !0), Q8);
        }
    }, 0);
}
function tG(t, e, n, o, r) {
    if (r.parentNode === o && t.claimed.has(r)) return !0;
    let s = t.pendingIn;
    if (!s || !s.has(o)) return !1;
    let i, a = n && n.__ref, c = a && a.__children, l = c ? c.lastIndexOf(e.key) : -1;
    for(let f = l - 1; f >= 0; f--){
        let u = n[c[f]], d = u && u.node;
        if (d && d !== r && d.parentNode === o) {
            i = d.nextSibling;
            break;
        }
    }
    return i === void 0 && (i = Sd(o, a && a.__textNode)), i === r || o.insertBefore(r, i), !0;
}
function eG(t, e) {
    let n = t.whole;
    if (!n) return !1;
    if (n.has(e)) return !0;
    let o = e.parent;
    return !o || !n.has(o) ? !1 : (n.add(e), !0);
}
function nG(t, e) {
    let n = e && e.__ref, o = e && e.node;
    if (!n || !o || !t.pending || !t.claimed.has(o)) return null;
    let r = o.parentNode;
    return r ? (t.claimed.delete(o), t.adopted--, t.pending.add(o), t.pendingIn.set(r, (t.pendingIn.get(r) || 0) + 1), n.__keepNode = !0, o) : null;
}
function oG(t, e) {
    if (!e || !t.pending || !t.pending.delete(e)) return;
    let n = e.parentNode;
    if (n) {
        let o = (t.pendingIn.get(n) || 1) - 1;
        o > 0 ? t.pendingIn.set(n, o) : t.pendingIn.delete(n), e.remove();
    }
}
var Wn = "\0", jd = "#";
function vy(t) {
    let e = new Set, n = new Map, o = (r, s)=>{
        let i = r.getAttribute("data-key"), a = i === null ? s : s ? s + Wn + i : jd;
        if (a) {
            let c = a + Wn + r.localName, l = n.get(c) || 0;
            n.set(c, l + 1), e.add(c + Wn + l);
        }
        for (let c of r.children)o(c, a);
    };
    for (let r of t || [])r && r.nodeType === 1 && o(r, "");
    return {
        places: e,
        chains: new WeakMap,
        taken: new Map,
        slots: new WeakMap
    };
}
var zM = (t)=>{
    let e = [];
    for(let n = t; n; n = n.parent){
        let o = n.node, r = o && o.nodeType === 1 ? o.getAttribute("data-key") : null;
        r !== null && e.push(r);
    }
    return e.length ? (e.pop(), e.length ? jd + Wn + e.reverse().join(Wn) : jd) : "";
};
function rG(t, e, n) {
    let o = e.parent, r = o ? t.chains.get(o) : "";
    r === void 0 && (r = zM(o));
    let s = n.nodeType === 1 && e.key ? r ? r + Wn + e.key : jd : r;
    if (t.chains.set(e, s), n.nodeType !== 1 || !s) return;
    let i = s + Wn + n.localName, a = t.taken.get(i);
    a || t.taken.set(i, a = new Set);
    let c = 0;
    for(; a.has(c);)c++;
    a.add(c), t.slots.set(e, [
        i,
        c
    ]), t.places.has(i + Wn + c) && e.__ref && (e.__ref.__adoption = "replaced");
}
function sG(t) {
    let e = t && t.context;
    if (!e || !e.__hydration && !e.__replacing) return null;
    let n = typeof t.tag == "string" ? t.tag : Hn(t);
    if (n === "string" || n === "fragment") return null;
    let o = Un(n) && (n === "svg" || t.parent?.node?.namespaceURI === ho), r = Un(n) && !o && n !== "svg" ? "div" : n, s = e.__hydration;
    if (s) {
        let g = an(t), h = s.registry[g === "" ? "__root" : g], m = h !== void 0 ? s.nodes[h] : null;
        if (!m || m.nodeType !== 1 || s.claimed.has(m)) return null;
        let y = o ? m.namespaceURI === ho : m.namespaceURI !== ho;
        return m.localName === r && y ? "adopted" : null;
    }
    let i = e.__replacing;
    if (!t.key) return null;
    let a = t.parent, c = a ? i.chains.get(a) : "";
    c === void 0 && (c = zM(a));
    let l = c ? c + Wn + t.key : jd, f = o ? r : String(r).toLowerCase(), u = l + Wn + f, d = i.taken.get(u), p = 0;
    for(; d && d.has(p);)p++;
    return i.places.has(u + Wn + p) ? "replaced" : null;
}
function iG(t, e) {
    let n = t.slots.get(e);
    if (!n) return;
    t.slots.delete(e);
    let o = t.taken.get(n[0]);
    o && o.delete(n[1]);
}
var WM = {
    adopt: PE,
    place: tG,
    whole: eG,
    settle: Xr,
    handBack: nG,
    settleHandBack: oG,
    markReplaced: rG,
    releaseReplaced: iG,
    foresee: sG
};
var Li = 50;
function wo(t) {
    return t === !0 ? Li : typeof t == "number" && t > 0 ? t : 0;
}
var Kn = [], qc = !1, Zr = 0, or = Li, Vd = !1, Cy = [], Ry = typeof performance < "u" && typeof performance.now == "function" ? ()=>performance.now() : ()=>Date.now(), Oy = [], Ud = null;
function aG(t) {
    if (!Ud) {
        let e = new MessageChannel;
        e.port1.onmessage = ()=>{
            let n = Oy.shift();
            !Oy.length && typeof e.port1.unref == "function" && e.port1.unref(), n && n();
        }, Ud = e;
    }
    Oy.push(t), Oy.length === 1 && typeof Ud.port1.ref == "function" && Ud.port1.ref(), Ud.port2.postMessage(0);
}
function NE(t) {
    let e = typeof globalThis < "u" ? globalThis.scheduler : null;
    if (e && typeof e.yield == "function") {
        e.yield().then(t, t);
        return;
    }
    if (typeof setImmediate == "function") {
        setImmediate(t);
        return;
    }
    if (typeof MessageChannel == "function") {
        aG(t);
        return;
    }
    setTimeout(t, 0);
}
function xo() {
    return new Promise((t)=>NE(t));
}
var Hd = 0, ME = 0, BE = 0, Gc = 0;
function FE() {
    Hd = 0, ME = Zr, BE = 0, Gc = 0;
}
function KM() {
    if (!Zr) return !1;
    if (Hd++, Gc > 0) return Gc--, !1;
    let t = Ry(), e = t - Zr, n = e / Hd, o = (t - ME) / (Hd - BE), r = o > n ? o : n;
    ME = t, BE = Hd;
    let s = or - e - r;
    return s <= 0 ? (Vd = !0, !0) : (Gc = r > 0 ? Math.floor(s / r / 2) : 0, !1);
}
var Di = 0;
function GM(t = Li) {
    Di === 0 && !Zr ? (Zr = Ry(), Vd = !1, or = t, FE()) : t < or && (or = t, Gc = 0), Di++;
}
var Ye = null, IE = !1, cG = typeof queueMicrotask == "function" ? queueMicrotask : (t)=>Promise.resolve().then(t);
function $E() {
    Zr = 0, Vd = !1, or = Li, FE();
}
function lG() {
    IE || (IE = !0, cG(()=>{
        IE = !1, Di === 0 && $E();
    }));
}
function qM() {
    Di > 0 && Di--, !(Di !== 0 || Ye !== null) && (qc ? lG() : $E());
}
function jE(t, e = Li, n = null) {
    let o = {
        fn: t,
        budget: e,
        lease: n
    };
    Ye ? Ye.push(o) : Kn.push(o), qc || (qc = !0, NE(YM));
}
function UE(t) {
    let e = t && t.context;
    return e && e.__mountLease || null;
}
function zd(t) {
    if (!t) return;
    let e = 0;
    for(let n = 0; n < Kn.length; n++){
        let o = Kn[n];
        o.lease !== t && (Kn[e++] = o);
    }
    if (Kn.length = e, Ye) {
        let n = 0;
        for(let o = 0; o < Ye.length; o++)Ye[o].lease !== t && (Ye[n++] = Ye[o]);
        Ye.length = n;
    }
    typeof t.lost == "function" && t.lost();
}
function fG(t) {
    if (t.lease !== null && !t.lease.live()) {
        zd(t.lease);
        return;
    }
    let e = Ye;
    Ye = [];
    try {
        t.fn();
    } catch (n) {
        typeof console < "u" && console.error && console.error("[smbls] deferred mount chunk failed:", n?.message || n);
    } finally{
        let n = Ye;
        Ye = e, n.length && Kn.unshift(...n);
    }
}
function ae() {
    return !qc && !Kn.length ? Promise.resolve() : new Promise((t)=>Cy.push(t));
}
function Qr() {
    return !qc && !Kn.length;
}
function uG() {
    if (!Cy.length) return;
    let t = Cy;
    Cy = [];
    for(let e = 0; e < t.length; e++)t[e]();
}
function YM() {
    for(Zr = Ry(), Vd = !1, or = 1 / 0, FE(); Kn.length;){
        let t = Kn.shift();
        if (t.budget < or && (or = t.budget, Gc = 0), fG(t), Vd || Ry() - Zr >= or) break;
    }
    if (Di = 0, $E(), Kn.length) {
        NE(YM);
        return;
    }
    qc = !1, uG();
}
function Dy(t) {
    Dc(t.__ref).pending++;
}
function Xe(t) {
    let e = t && t.__ref, n = e && e.__mount;
    if (!n || !(n.pending > 0) || --n.pending > 0 || e.__disposed) return;
    let o = n.tail;
    o && (n.tail = null, o());
}
function Ly(t) {
    let e = t && t.__ref && t.__ref.__mount;
    return !!(e && e.tail);
}
function Gn(t) {
    let e = t && t.__ref && t.__ref.__mount;
    return !e || !e.tail ? Promise.resolve(t) : new Promise((n)=>{
        (e.waiters || (e.waiters = [])).push(n);
    });
}
function HE(t, e = t && t.__ref) {
    let n = e && e.__mount, o = n && n.waiters;
    if (o) {
        n.waiters = null;
        for(let r = 0; r < o.length; r++)o[r](t);
    }
}
function XM(t, e = t && t.__ref) {
    let n = e && e.__mount;
    if (!n || !n.tail) return;
    n.tail = null, n.pending = 0;
    let o = n.holder;
    n.holder = null, HE(t, e), o && Xe(o);
}
function dG(t, e) {
    let n = e && e.mountYield;
    if (!n && !t.yieldChildren) return 0;
    let o = Q.hydration !== null && t.context ? t.context.__hydration : null;
    if (o && Q.hydration.whole(o, t)) return 0;
    let r = n ? wo(n) : 0, s = wo(t.yieldChildren);
    return r && s ? r < s ? r : s : r || s;
}
function ZM(t, e, n, o, r) {
    GM(o);
    try {
        QM(t, t.__ref, 0, e, n, o, r, !1);
    } finally{
        qM();
    }
}
function QM(t, e, n, o, r, s, i, a) {
    try {
        for(let c = n; c < o; c++){
            let l = e.__mount, f = l ? l.pending : 0;
            if (r(c) === !1) continue;
            if (e.__disposed) break;
            let u = KM(), d = e.__mount;
            if (c + 1 < o && (u || (d ? d.pending : 0) > f)) {
                i && i.onSuspend && i.onSuspend(), a || Dy(t);
                let p = c + 1;
                jE(()=>pG(t, e, p, o, r, s, i), s, UE(t));
                return;
            }
        }
    } catch (c) {
        if (!a) throw c;
        Sy(t, c);
    }
    a && Xe(t);
}
function pG(t, e, n, o, r, s, i) {
    if (e.__disposed || i && i.isStale && i.isStale()) {
        Xe(t);
        return;
    }
    QM(t, e, n, o, r, s, i, !0);
}
function hG(t, e, n) {
    Dy(t), jE(()=>{
        try {
            let o = t.__ref;
            o && !o.__disposed && n();
        } catch (o) {
            Sy(t, o);
        } finally{
            Xe(t);
        }
    }, e, UE(t));
}
function gG(t, e, n, o) {
    let r = t.__ref, s = Dc(r), i = ++s.chunkGen, a = t.node, c = [], l = !1;
    ZM(t, e, (f)=>{
        let u = n(f, l ? Fd(t, mG(a, c)) : void 0), d = JM(u);
        return d ? c.push(d) : u && u.__ref.__mount && u.__ref.__mount.held && c.push(u), u;
    }, o, {
        isStale: ()=>s.chunkGen !== i,
        onSuspend: ()=>{
            l = !0;
        }
    });
}
function JM(t) {
    let e = nr(t);
    if (e) return e;
    let n = t && t.__ref;
    return n && n.__if !== !1 && t.tag === "fragment" && n.__fragmentAnchor || null;
}
function mG(t, e) {
    for(let n = e.length - 1; n >= 0; n--){
        let o = e[n].__ref ? JM(e[n]) : e[n];
        if (o && o.parentNode === t) return o;
    }
    return null;
}
function yG(t, e) {
    let n = t.__ref;
    try {
        Hc(t, !0), eM(t), gE(t, e);
    } finally{
        HE(t, n);
        let o = n.__mount, r = o && o.holder;
        r && (o.holder = null, Xe(r));
    }
}
var tB = {
    budgetOf: dG,
    run: ZM,
    rows: gG,
    defer: hG,
    hold: Dy,
    finish: yG,
    abandon: XM
};
var Py = "--smbls-cvw", _G = /(^|[^\w.-])(-?(?:\d+\.?\d*|\.\d+))[sld]?vw\b/g, nB = /\d[sld]?vw\b/, oB = (t)=>t.replace(_G, "$1calc($2 * var(" + Py + "))"), rB = (t)=>{
    if (typeof t == "string") return nB.test(t) ? oB(t) : t;
    if (!t || typeof t != "object" || Array.isArray(t)) return t;
    let e = null;
    for(let n in t){
        let o = t[n], r = n === Py ? o : rB(o);
        r !== o && ((e || (e = Object.assign({}, t)))[n] = r);
    }
    return e || t;
}, bG = (t)=>{
    let e = L().cssVars || {}, n = {
        [Py]: t
    }, o = [];
    for(let r in e){
        let s = e[r];
        typeof s == "string" && nB.test(s) && (n[r] = oB(s), o.push(r));
    }
    for(let r = 0; r < o.length; r++){
        let s = "var(" + o[r];
        for(let i in e){
            let a = e[i];
            !(i in n) && typeof a == "string" && (a.includes(s + ")") || a.includes(s + ",")) && (n[i] = a, o.push(i));
        }
    }
    return n;
}, eB = new WeakSet, sB = {
    on: !1,
    lengths: rB,
    scope (t, e) {
        let n = t.breakpointsFrom, o = "1cqi";
        if (Ac(n, t)) {
            this.on = !0;
            let r = t.node && t.node.ownerDocument && t.node.ownerDocument.defaultView || globalThis;
            if (!eB.has(r)) {
                eB.add(r);
                try {
                    r.CSS.registerProperty({
                        name: Py,
                        syntax: "<length>",
                        inherits: !0,
                        initialValue: "1vw"
                    });
                } catch  {}
            }
        } else {
            try {
                typeof n == "function" && (n = n(t, t.state, t.context));
            } catch  {
                return;
            }
            if (!this.on || typeof n != "string" || !/^(window|media)$/.test(n.trim())) return;
            o = "1vw";
        }
        return e["& > *"] = Object.assign(bG(o), e["& > *"]), !0;
    }
};
var JE = 3e3, Pi = "data-smbls-face-wait", SG = new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "math",
    "emoji",
    "fangsong",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "inherit",
    "initial",
    "unset",
    "revert"
]), iB = new WeakMap, Xc = new Set, By = !1, Ny = 0, tA = (t)=>String(t || "").trim().replace(/^(["'])(.*)\1$/, "$2").toLowerCase(), pB = (t)=>t && t.defaultView || null;
function hB(t) {
    if (!t) return null;
    let e = iB.get(t);
    if (e !== void 0) return e;
    let n = pB(t), o = t.fonts;
    return e = n && o && typeof o.forEach == "function" && typeof n.getComputedStyle == "function" ? {
        doc: t,
        win: n,
        fonts: o,
        waits: new Map,
        watches: new Map,
        links: null,
        observer: null,
        attributes: null,
        fontKeys: null,
        written: null,
        sheet: null,
        inline: null,
        inlineKey: "",
        table: null,
        tableSize: 0
    } : null, iB.set(t, e), e;
}
var eA = (t)=>{
    let e = t && t.node;
    return e && e.ownerDocument || t?.context?.document || (typeof document < "u" ? document : null);
}, wG = (t)=>{
    let e = [];
    for (let n of String(t || "U+0-10FFFF").split(",")){
        let o = /U\+([0-9A-F?]+)(?:-([0-9A-F]+))?/i.exec(n);
        if (!o) continue;
        let r = parseInt(o[1].replace(/\?/g, "0"), 16), s = parseInt(o[2] || o[1].replace(/\?/g, "F"), 16);
        e.push([
            r,
            s
        ]);
    }
    return e.length ? e : [
        [
            0,
            1114111
        ]
    ];
}, gB = (t)=>t === "bold" ? 700 : t === "normal" || t === "bolder" || t === "lighter" ? 400 : Number(t) || 400, mB = (t)=>{
    let e = String(t || "400").trim().split(/\s+/).map(gB);
    return [
        e[0],
        e[1] === void 0 ? e[0] : e[1]
    ];
}, nA = (t)=>{
    let e = String(t || "normal").trim().toLowerCase();
    return e.startsWith("italic") ? "italic" : e.startsWith("oblique") ? "oblique" : "normal";
}, Wd = (t, e)=>{
    let n = new RegExp(`(?:^|[;{\\s])${e}\\s*:\\s*([^;}]+)`, "i").exec(t);
    return n ? n[1].trim() : "";
}, yB = (t, e, n, o)=>tA(t) + "|" + mB(e).join("-") + "|" + nA(n) + "|" + String(o || "U+0-10FFFF").replace(/\s+/g, "").toUpperCase(), aB = new WeakMap;
function xG(t) {
    let e = aB.get(t);
    if (e === void 0) {
        let n = t.cssText || "";
        e = (t.type === 5 || /^\s*@font-face/i.test(n)) && /url\(\s*['"]?data:/i.test(Wd(n, "src")) ? yB(Wd(n, "font-family"), Wd(n, "font-weight"), Wd(n, "font-style"), Wd(n, "unicode-range")) : "", aB.set(t, e);
    }
    return e;
}
function kG(t) {
    let e = t.doc.styleSheets, n = (e ? e.length : 0) + ":" + (t.fonts.size || 0);
    if (t.inline && t.inlineKey === n) return t.inline;
    let o = new Set;
    for(let r = 0; e && r < e.length; r++){
        let s;
        try {
            s = e[r].cssRules;
        } catch  {
            continue;
        }
        for(let i = 0; s && i < s.length; i++){
            let a = s[i];
            if (typeof a.type == "number" && a.type !== 5) continue;
            let c = xG(a);
            c && o.add(c);
        }
    }
    return t.inline = o, t.inlineKey = n, o;
}
function zE(t) {
    let e = t.fonts.size || 0;
    if (t.table && t.tableSize === e) return t.table;
    let n = new Map, o = 0;
    t.fonts.forEach((s)=>{
        let i = tA(s.family), a = {
            face: s,
            order: o++,
            ranges: wG(s.unicodeRange),
            weight: mB(s.weight),
            style: nA(s.style),
            key: yB(s.family, s.weight, s.style, s.unicodeRange)
        }, c = n.get(i);
        c ? c.push(a) : n.set(i, [
            a
        ]);
    }), t.table = n, t.tableSize = e;
    let r = ()=>{
        t.table === n && (t.table = null);
    };
    return typeof queueMicrotask == "function" ? queueMicrotask(r) : Promise.resolve().then(r), n;
}
var TG = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
};
function cB(t, [e, n]) {
    if (t >= e && t <= n) return 0;
    let o = n < t, r = o ? t - n : e - t;
    return t >= 400 && t <= 500 ? !o && e <= 500 ? 1e3 + r : o ? 2e3 + r : 3e3 + r : t < 400 ? o ? 1e3 + r : 2e3 + r : o ? 2e3 + r : 1e3 + r;
}
function EG(t, e, n) {
    let o = e.weight + "|" + e.style, r = n.get(o);
    if (r) return r;
    let s = t;
    for (let c of TG[e.style]){
        let l = t.filter((f)=>f.style === c);
        if (l.length) {
            s = l;
            break;
        }
    }
    let i = 1 / 0;
    for (let c of s)i = Math.min(i, cB(e.weight, c.weight));
    let a = s.filter((c)=>cB(e.weight, c.weight) === i);
    return n.set(o, a), a;
}
var AG = (t, e)=>t.ranges.some(([n, o])=>e >= n && e <= o);
function vG(t, e, n, o, r, s, i) {
    for (let a of n){
        if (SG.has(a)) return null;
        let c = e.get(a);
        if (!c) {
            s.missing = !0;
            continue;
        }
        let l = i.get(a);
        l || i.set(a, l = new Map);
        let f = EG(c, o, l).filter((p)=>AG(p, r));
        if (!f.length) continue;
        if (f.length === 1) return f[0].face;
        let u = kG(t);
        return (f.find((p)=>u.has(p.key)) || f[f.length - 1]).face;
    }
    return null;
}
function OG(t, e) {
    let n = [];
    if (!t || !t.childNodes) return n;
    if (!e) {
        for (let s of t.childNodes)s.nodeType === 3 && s.nodeValue && n.push(s);
        return n;
    }
    let o = t.ownerDocument;
    if (o && typeof o.createTreeWalker == "function") {
        let s = o.createTreeWalker(t, 4);
        for(let i = s.nextNode(); i; i = s.nextNode())i.nodeValue && n.push(i);
        return n;
    }
    let r = (s)=>{
        for (let i of s.childNodes)i.nodeType === 3 ? i.nodeValue && n.push(i) : r(i);
    };
    return r(t), n;
}
var _B = (t)=>t.fontFamily + "|" + t.fontWeight + "|" + t.fontStyle;
function bB(t, e) {
    let n = t.win.getComputedStyle(e);
    return {
        key: _B(n),
        stack: String(n.fontFamily || "").split(",").map(tA).filter(Boolean),
        want: {
            weight: gB(String(n.fontWeight || "400")),
            style: nA(n.fontStyle)
        }
    };
}
function My(t, e, n, o = zE(t), r = null) {
    let s = {
        missing: !1
    }, i = new Set, a = new Map;
    r && a.set(e, r);
    let c = new Map;
    for (let l of OG(e, n)){
        let f = l.parentNode;
        if (!f || f.nodeType !== 1) continue;
        let u = a.get(f);
        if (u || (u = bB(t, f), a.set(f, u)), !u.stack.length) continue;
        let d = new Set;
        for (let p of l.nodeValue){
            let g = p.codePointAt(0);
            if (g < 32 || d.has(g)) continue;
            d.add(g);
            let h = vG(t, o, u.stack, u.want, g, s, c);
            h && i.add(h);
        }
    }
    return {
        faces: [
            ...i
        ],
        missing: s.missing
    };
}
var SB = (t, e)=>e.status === "loaded" || !!(t.waits.get(e) || {}).done;
function WE(t, e) {
    let n = t.waits.get(e);
    return n || (n = {
        done: !1,
        promise: null
    }, t.waits.set(e, n), n.promise = new Promise((o)=>{
        let r = ()=>{
            n.done = !0, o();
        };
        t.win.setTimeout(r, JE);
        try {
            Promise.resolve(e.load()).then(r, r);
        } catch  {
            r();
        }
    })), n.promise;
}
function KE(t) {
    if (t.links && t.links.done) return null;
    let e = t.doc.querySelectorAll ? t.doc.querySelectorAll('link[rel="stylesheet"][data-smbls-font]') : [], n = [];
    for (let o of e)o.sheet || n.push(o);
    if (!n.length) return null;
    if (!t.links) {
        let o = t.links = {
            done: !1,
            promise: null
        };
        o.promise = new Promise((r)=>{
            let s = ()=>{
                o.done = !0, r();
            };
            t.win.setTimeout(s, JE);
            let i = n.length, a = ()=>{
                --i <= 0 && s();
            };
            for (let c of n)c.addEventListener("load", a, {
                once: !0
            }), c.addEventListener("error", a, {
                once: !0
            });
        });
    }
    return t.links.promise;
}
function CG(t) {
    if (t.sheet) return;
    let e = t.doc, n = e.createElement("style");
    n.setAttribute(Pi, ""), (e.head || e.documentElement).appendChild(n);
    let o = n.sheet, r = [
        `[${Pi}="wait"]{visibility:hidden}`,
        `@media print{[${Pi}="wait"]{visibility:visible}}`
    ];
    if (o && typeof o.insertRule == "function") for (let s of r)try {
        o.insertRule(s, o.cssRules.length);
    } catch  {}
    else n.textContent = r.join("");
    t.sheet = n;
}
var Ii = null;
function GE(t, e) {
    if (Ii) return void Ii.push(()=>GE(t, e));
    let n = e.node;
    !n || !n.setAttribute || (CG(t), n.getAttribute(Pi) !== "wait" && n.setAttribute(Pi, "wait"));
}
function Gd(t) {
    if (Ii) return void Ii.push(()=>Gd(t));
    let e = t.node;
    e && e.removeAttribute && e.hasAttribute && e.hasAttribute(Pi) && e.removeAttribute(Pi);
}
var wB = (t, e)=>{
    try {
        return t.win.getComputedStyle(e).display === "contents";
    } catch  {
        return !1;
    }
};
function xB(t, e) {
    if (typeof e.checkVisibility == "function") {
        if (e.checkVisibility()) return !0;
    } else if (typeof e.getClientRects != "function" || e.getClientRects().length > 0) return !0;
    if (!wB(t, e)) return !1;
    let n = t.doc;
    if (typeof n.createRange != "function") return !0;
    let o = n.createRange();
    return o.selectNodeContents(e), typeof o.getClientRects != "function" || o.getClientRects().length > 0;
}
function RG(t, e) {
    let n = t.win.ResizeObserver;
    return typeof n != "function" ? !1 : (t.observer || (t.observer = new n((o)=>{
        let r = [];
        for (let s of o){
            let i = s.target && s.target.__smblsFaceWait;
            if (!i) {
                t.observer.unobserve(s.target);
                continue;
            }
            xB(t, s.target) && (t.observer.unobserve(s.target), s.target.__smblsFaceWait = null, r.push(i));
        }
        r.length && TB(r);
    })), e.node.__smblsFaceWait = e, t.observer.observe(e.node), !0);
}
var DG = [
    "class",
    "style",
    "lang"
], Mi = new Set, qE = new Set, LG = (t, e)=>{
    try {
        return _B(t.win.getComputedStyle(e));
    } catch  {
        return "";
    }
};
function PG(t, e) {
    if (Mi.size) {
        for (let n of e){
            let o = n.target;
            o && o.nodeType === 1 && t.written.add(o);
        }
        t.written.size && ($y.add(t), EB(t.win));
    }
}
var lB = (t)=>!!(t.__ref && t.__ref.__faceWaitSeen) && !Xc.has(t);
function IG(t) {
    let e = t.written;
    if (t.written = new Set, !Mi.size || !e.size || !t.fontKeys) return;
    let n = new Map, o = (s, i)=>{
        if (!lB(i)) return;
        let a = n.get(s);
        a ? a.push(i) : n.set(s, [
            i
        ]);
    };
    for (let s of e)for(let i = s; i && i.nodeType === 1; i = i.parentNode){
        let a = i.__smblsFaceArm;
        a && (i === s || a.__ref?.__faceWait === "tree") && o(s, a);
    }
    for (let s of Mi)if (!(!s.node || !lB(s))) for(let i = s.node.parentNode; i && i.nodeType === 1; i = i.parentNode)e.has(i) && o(i, s);
    if (!n.size) return;
    let r = new Set;
    for (let [s, i] of n){
        let a = LG(t, s);
        if (t.fontKeys.get(s) !== a) {
            t.fontKeys.set(s, a);
            for (let c of i)r.add(c);
        }
    }
    for (let s of r)Jr(s);
}
function MG(t) {
    if (t.attributes) return;
    let e = t.win.MutationObserver, n = t.doc.documentElement;
    typeof e != "function" || !n || (t.fontKeys = new WeakMap, t.written = new Set, t.attributes = new e((o)=>{
        try {
            PG(t, o);
        } catch  {}
    }), t.attributes.observe(n, {
        attributes: !0,
        subtree: !0,
        attributeFilter: DG
    }), qE.add(t));
}
function BG() {
    for (let t of qE)t.attributes.disconnect(), $y.delete(t), t.written = null, t.attributes = null, t.fontKeys = null;
    qE.clear();
}
function NG(t) {
    let e = t.faceWait;
    if (typeof e == "function") try {
        e = e(t, t.state, t.context);
    } catch  {
        e = void 0;
    }
    if (e === !0) return "tree";
    if (e === !1 || t.tag === "string" || t.context?.designSystem?.faceWait !== !0) return null;
    let n = t.__ref && t.__ref.__textNode;
    return n && n.nodeValue ? "own" : "late";
}
var kB = 0;
function Iy(t, e) {
    !t.__faceWaitLate != !e && (t.__faceWaitLate = e || null, kB += e ? 1 : -1);
}
function fB(t) {
    let e = t.__ref;
    if (!e || !e.__faceWait) return;
    if (!Qo(t)) {
        e.__faceWaitConnect || (e.__faceWaitConnect = !0, jn(t, ()=>{
            e.__faceWaitConnect = !1, Jr(t);
        }));
        return;
    }
    let n = hB(eA(t));
    if (!n) return;
    let o = t.node;
    MG(n);
    let r = null;
    try {
        r = bB(n, o);
    } catch  {}
    n.fontKeys && n.fontKeys.set(o, r ? r.key : "");
    let { faces: s, missing: i } = My(n, o, e.__faceWait === "tree", FG(n), r), a = s.filter((f)=>!SB(n, f)), c = i ? KE(n) : null;
    if (!a.length && !c) return Gd(t);
    if (!xB(n, o) && RG(n, t)) {
        wB(n, o) || GE(n, t);
        return;
    }
    GE(n, t);
    let l = e.__faceWaitToken = (e.__faceWaitToken || 0) + 1;
    Promise.all([
        ...a.map((f)=>WE(n, f)),
        c
    ]).then(()=>{
        e.__faceWaitToken === l && e.__faceWait && Jr(t);
    });
}
var Kd = null;
function FG(t) {
    if (!Kd) return zE(t);
    let e = Kd.get(t);
    return e || Kd.set(t, e = zE(t)), e;
}
function TB(t) {
    if (Ii) {
        for (let n of t)try {
            fB(n);
        } catch  {
            Gd(n);
        }
        return;
    }
    Kd = new Map;
    let e = Ii = [];
    try {
        for (let n of t)try {
            fB(n);
        } catch  {
            Gd(n);
        }
    } finally{
        Kd = null, Ii = null;
        for (let n of e)try {
            n();
        } catch  {}
    }
}
function YE() {
    By = !1;
    let t = [
        ...Xc
    ];
    Xc.clear(), t.length && TB(t);
}
var Fy = new Map, XE = !1, ZE = new Set, $G = (t, e)=>typeof t.requestAnimationFrame == "function" ? t.requestAnimationFrame(e) : -t.setTimeout(e, 16);
var $y = new Set;
function jG(t, e) {
    let n = t.MessageChannel || (typeof MessageChannel == "function" ? MessageChannel : null);
    if (n) {
        let o = new n;
        o.port1.onmessage = ()=>{
            o.port1.close(), e();
        }, o.port2.postMessage(0);
        return;
    }
    t.setTimeout(e, 0);
}
function EB(t) {
    !t || Fy.has(t) || Fy.set(t, $G(t, ()=>UG(t)));
}
function UG(t) {
    Fy.delete(t), XE = !0;
    try {
        for (let e of [
            ...$y
        ]){
            $y.delete(e);
            try {
                e.written && IG(e);
            } catch  {}
        }
        YE();
    } finally{
        XE = !1;
    }
    typeof t.requestAnimationFrame == "function" && (ZE.add(t), jG(t, ()=>{
        ZE.delete(t);
    })), Xc.size && AB();
}
var HG = (t)=>!!t && typeof t.requestAnimationFrame == "function" && !(t.document && t.document.visibilityState === "hidden");
function AB() {
    By || (By = !0, typeof queueMicrotask == "function" ? queueMicrotask(YE) : Promise.resolve().then(YE));
}
function Jr(t) {
    if (Xc.add(t), XE || By) return;
    let e = pB(eA(t));
    if (!Fy.has(e)) {
        if (!ZE.has(e) && HG(e)) return EB(e);
        AB();
    }
}
var VG = 1e4, uB = 200, zG = (t)=>!!t.loaded && typeof t.loaded.then == "function", dB = (t, e)=>{
    let n = t.watches.get(e);
    return n || (n = new Promise((o)=>{
        let r = Math.ceil(VG / uB), s = ()=>{
            if (e.status === "loaded") return o(e);
            if (r-- <= 0) return o(null);
            t.win.setTimeout(s, uB);
        };
        s();
    }), t.watches.set(e, n), n);
}, Yc = (t, e = [], n = null)=>{
    let o = e.filter((r)=>r.status !== "loaded" && (r.status === "error" ? !!n : zG(r)));
    return Object.defineProperty(t, "late", {
        value: o.length ? Promise.all(o.map((r)=>r.status === "error" ? dB(n, r) : r.loaded.then(()=>r, ()=>n ? dB(n, r) : null))).then((r)=>r.filter(Boolean)) : null
    }), t;
};
function WG(t) {
    return new Promise((e)=>{
        try {
            let n = eA(t), o = hB(n);
            if (!o || !t.node) return e(Yc([]));
            let r = ()=>{
                let { faces: a } = My(o, t.node, !0);
                return Yc(a.filter((c)=>c.status === "loaded"), a, o);
            }, s = ()=>{
                let { faces: a, missing: c } = My(o, t.node, !0);
                if (!a.length && !c) return e(Yc([]));
                let l = a.filter((d)=>d.status !== "loaded");
                if (!l.length && !(c && KE(o))) return e(Yc(a));
                if (t.__ref && t.__ref.__adoption === "adopted" && "__smblsFacesReady" in o.win) {
                    Promise.resolve(o.win.__smblsFacesReady).then(()=>e(r()), ()=>e(r()));
                    return;
                }
                let u = c ? KE(o) : null;
                Promise.all([
                    ...l.map((d)=>WE(o, d)),
                    u
                ]).then(()=>{
                    if (!u) return e(r());
                    let d = My(o, t.node, !0).faces.filter((p)=>!SB(o, p));
                    Promise.all(d.map((p)=>WE(o, p))).then(()=>e(r()));
                }, ()=>e(r()));
            };
            if (Qo(t)) return s();
            let i = !1;
            o.win.setTimeout(()=>{
                i || (i = !0, e(Yc([])));
            }, JE), jn(t, ()=>{
                i || (i = !0, s());
            });
        } catch  {
            e(Yc([]));
        }
    });
}
var vB = {
    get active () {
        return Ny > 0 || QE > 0 || kB > 0;
    },
    rendered (t) {
        let e = t.__ref;
        if (!e) return;
        let n = NG(t);
        if (n === "late" ? (Iy(e, !0), n = null) : e.__faceWaitLate && Iy(e, !1), !(!n && !e.__faceWait)) {
            if (n !== e.__faceWait && VE(t, n), !n) return Gd(t);
            if (e.__adoption === "adopted" && !e.__faceWaitSeen) {
                e.__faceWaitSeen = !0;
                return;
            }
            e.__faceWaitSeen = !0, Jr(t);
        }
    },
    text (t) {
        let e = t.__ref;
        if (e && e.__faceWaitLate) {
            let n = e.__textNode;
            n && n.nodeValue && (Iy(e, !1), VE(t, "own"), e.__faceWaitSeen = !0, Jr(t));
        } else e && e.__faceWait && e.__faceWaitSeen && Jr(t);
        if (Ny) for(let n = t.parent; n; n = n.parent){
            let o = n.__ref;
            o && o.__faceWait === "tree" && o.__faceWaitSeen && Jr(n);
        }
    },
    ready: WG,
    recheck (t) {
        let e = t && t.node;
        for (let n of Mi)(n === t || e && n.node && e.contains(n.node)) && (n.__ref && (n.__ref.__faceWaitSeen = !0), Jr(n));
    },
    dispose (t) {
        let e = t.__ref;
        e && e.__faceWait && VE(t, null), e && e.__faceWaitLate && Iy(e, !1), Xc.delete(t);
    }
}, QE = 0;
function VE(t, e) {
    let n = t.__ref, o = n.__faceWait;
    o === "tree" ? Ny-- : o === "own" && QE--, e === "tree" ? Ny++ : e === "own" && QE++, n.__faceWait = e || null;
    let r = t.node;
    e ? (Mi.add(t), r && (r.__smblsFaceArm = t)) : (Mi.delete(t), n.__faceWaitToken = (n.__faceWaitToken || 0) + 1, r && r.__smblsFaceWait && (r.__smblsFaceWait = null), r && r.__smblsFaceArm === t && (r.__smblsFaceArm = null), Mi.size || BG());
}
function OB() {
    Q.viewEvents = fP, Q.chains = iP, Q.rows = HM, Q.hydration = WM, Q.mount = tB, Q.containerVw = sB, Q.faceWait = vB;
}
OB();
var Bi = "inertOutside", GG = new Set([
    "SCRIPT",
    "STYLE",
    "LINK",
    "META",
    "TEMPLATE",
    "NOSCRIPT",
    "BASE",
    "TITLE"
]), qG = 'a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex], [contenteditable]:not([contenteditable="false"])', YG = {
    attributes: !0,
    attributeFilter: [
        "inert"
    ]
}, CB = new WeakMap, RB = new WeakMap, qd = new Set, DB = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
function ts(t) {
    try {
        return De(t);
    } catch (e) {
        console.error("[smbls] inertOutside:", e);
    }
}
function LB(t) {
    let e = ()=>ts(t);
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e);
}
function XG(t) {
    if (!t || !t.defaultView || !("activeElement" in t)) return null;
    let e = CB.get(t);
    if (e) return e;
    let n = t.defaultView.MutationObserver || globalThis.MutationObserver;
    return typeof n != "function" ? null : (e = {
        doc: t,
        layers: [],
        held: new Map,
        top: null,
        observer: null
    }, e.observer = new n((o)=>ts(()=>jy(e, o))), CB.set(t, e), e);
}
function oA(t, e) {
    let n = t.element.node;
    return !!n && n.nodeType === 1 && n.isConnected && n.ownerDocument === e;
}
function ZG(t) {
    let e = t.activeElement;
    return e && e !== t.body && e !== t.documentElement ? e : null;
}
var PB = (t)=>!!(t.closest && t.closest("[inert]"));
function QG(t) {
    let e = t.ownerDocument, n = new Set, o = [];
    for(let r = t; r !== e.body; r = r.parentNode){
        let s = r.parentNode;
        if (!s || s.nodeType !== 1 || s === e.documentElement) break;
        o.push(s);
        for(let i = s.firstElementChild; i; i = i.nextElementSibling)i !== r && !GG.has(i.tagName) && n.add(i);
    }
    return {
        outside: n,
        parents: o
    };
}
function IB(t, e) {
    for(let n = 0; n < e.length; n++){
        let { type: o, target: r } = e[n];
        o === "attributes" && t.held.has(r) && t.held.set(r, !r.hasAttribute("inert"));
    }
}
function jy(t, e) {
    let { doc: n, held: o, observer: r } = t;
    e && IB(t, e), IB(t, r.takeRecords());
    let s = t.top, i = [];
    for (let u of t.layers){
        let d = oA(u, n);
        d && !u.live && (i.push(u), u.returnFocus = ZG(n)), u.live = d;
    }
    i.length && (t.layers = t.layers.filter((u)=>!i.includes(u)).concat(i));
    let a = null;
    for(let u = t.layers.length - 1; u >= 0 && !a; u--)t.layers[u].live && (a = t.layers[u]);
    t.top = a;
    let { outside: c, parents: l } = a ? QG(a.element.node) : {
        outside: new Set,
        parents: []
    };
    for (let [u, d] of o)c.has(u) || (d && u.removeAttribute("inert"), o.delete(u));
    for (let u of c)o.has(u) || o.set(u, !1), u.hasAttribute("inert") || (u.setAttribute("inert", ""), o.set(u, !0));
    r.takeRecords(), r.disconnect();
    for (let u of l)r.observe(u, {
        childList: !0
    });
    for (let u of o.keys())r.observe(u, YG);
    t.layers.some((u)=>!u.live) ? qd.add(t) : qd.delete(t);
    for (let u of t.layers)!u.live && !u.connecting && !Qo(u.element) && (u.connecting = !0, jn(u.element, ()=>ts(()=>{
            u.connecting = !1, u.declared && !u.live && oA(u, t.doc) && jy(t);
        })));
    if (a === s) return;
    let f = s && !(s.declared && s.live) ? s : null;
    if (a && i.includes(a)) f && f.returnFocus && (a.returnFocus = f.returnFocus), LB(()=>BB(t, a));
    else if (f) {
        let u = f.returnFocus;
        LB(()=>JG(t, f, u));
    }
    f && (f.returnFocus = null);
}
function BB(t, e) {
    let n = e.element.node;
    if (t.top !== e || !n || !n.isConnected) return;
    let o = t.doc, r = o.activeElement;
    if (r && n.contains(r)) return;
    let s = new Set, i = (a, c)=>{
        if (s.has(a) || (s.add(a), a.matches(":disabled"))) return !1;
        let l = c && a.getAttribute("tabindex");
        return l && parseInt(l, 10) < 0 ? !1 : (a.focus(), o.activeElement === a);
    };
    for (let a of n.querySelectorAll("[autofocus]"))if (i(a, !1)) return;
    for (let a of n.querySelectorAll(qG))if (i(a, !0)) return;
    r && r !== o.body && typeof r.blur == "function" && r.blur();
}
function JG(t, e, n) {
    if (e.declared && e.live) return;
    let o = t.doc, r = o.activeElement, s = e.element.node;
    (!r || r === o.body || s && s.contains(r) || PB(r)) && (n && n.isConnected && n.ownerDocument === o && !PB(n) && (n.focus({
        preventScroll: !0
    }), o.activeElement === n) || t.top && BB(t, t.top));
}
function rA(t, e) {
    if (t.declared === e) return;
    let n = t.manager;
    if (t.declared = e, t.live = !1, e) n.layers.push(t);
    else {
        let o = n.layers.indexOf(t);
        o !== -1 && n.layers.splice(o, 1);
    }
    jy(n);
}
function NB(t) {
    let e = t[Bi];
    if (typeof e == "function") try {
        e = e(t, t.state, t.context);
    } catch  {
        e = !1;
    }
    return !!e;
}
function MB(t) {
    let e = RB.get(t);
    if (e) return e;
    let n = t.__ref, o = t.node;
    if (!n || !o || o.nodeType !== 1) return null;
    let r = XG(o.ownerDocument);
    if (!r) return null;
    e = {
        element: t,
        manager: r,
        declared: !1,
        live: !1,
        connecting: !1,
        returnFocus: null
    }, RB.set(t, e);
    let s = q(()=>{
        let i = NB(t);
        ts(()=>rA(e, i));
    }, {
        depth: n.path.length,
        label: ()=>n.path.join(".") + "::" + Bi
    });
    return n.__effects || (n.__effects = []), n.__effects.push(s), n.__eventCleanup || (n.__eventCleanup = []), n.__eventCleanup.push(()=>ts(()=>rA(e, !1))), e;
}
function t7() {
    for (let t of qd){
        if (!t.doc.defaultView) {
            qd.delete(t);
            continue;
        }
        t.layers.some((e)=>!e.live && oA(e, t.doc)) && jy(t);
    }
}
var Zc = {
    name: Bi,
    create (t) {
        if (DB(t, Bi)) ts(()=>MB(t));
    },
    render () {
        qd.size && ts(t7);
    },
    update (t) {
        if (DB(t, Bi)) ts(()=>{
            let e = MB(t);
            e && rA(e, NB(t));
        });
    }
};
var FB = {
    blue: "#213eb0",
    green: "#389d34",
    red: "#e15c55",
    yellow: "#EDCB38",
    orange: "#e97c16",
    transparent: "rgba(0, 0, 0, 0)",
    black: "black",
    gray: "#4e4e50",
    gray1: "gray-74",
    gray3: "gray-42",
    white: "white",
    title: [
        "gray-168",
        "gray+168"
    ],
    caption: [
        "gray-68",
        "gray+146"
    ],
    paragraph: [
        "gray-42",
        "gray+120"
    ],
    disabled: [
        "gray-26",
        "gray+26"
    ],
    line: [
        "gray-16",
        "gray+16"
    ],
    inactive: [
        "gray-48",
        "gray+120"
    ],
    scrim: [
        "black.45",
        "black.55"
    ],
    scrimSoft: [
        "black.2",
        "black.3"
    ],
    blueDeep: "#0A5CB8",
    blueBright: "#47A8FF",
    accentInk: [
        "blueDeep",
        "blueBright"
    ],
    greenDeep: "#2A6E28",
    greenBright: "#7FD07B",
    successInk: [
        "greenDeep",
        "greenBright"
    ],
    redDeep: "#A83520",
    redBright: "#FF8C78",
    dangerInk: [
        "redDeep",
        "redBright"
    ],
    orangeDeep: "#94500F",
    orangeBright: "#F4A45E",
    warningInk: [
        "orangeDeep",
        "orangeBright"
    ],
    magentaDeep: "#A100A1",
    magentaBright: "#FF7AFF",
    magentaInk: [
        "magentaDeep",
        "magentaBright"
    ]
}, $B = {
    "gradient-blue-light": `linear-gradient(to right,
    rgba(4, 116, 242, 1),
    rgba(0, 48, 103, 1)
  )`,
    "gradient-blue-dark": `linear-gradient(to right,
    #0474F2,
    #003067
  )`,
    "gradient-dark": `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
    "gradient-dark-active": `linear-gradient(0deg,
    rgba(0,0,0,0.09) 0%,
    rgba(0,0,0,0.1) 100%
  )`,
    "gradient-light": `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
    "gradient-light-active": `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
    "gradient-colorful": `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 31%,
    #1E54F0 36%,
    #8B4CCA 69%,
    #C66894 100%
  )`
};
var e7 = {
    primary: {
        "@dark": {
            color: "white",
            background: "blue",
            ".color-only": {
                color: "blue"
            },
            ".inactive": {
                background: "gray+16"
            },
            ".gradient": {
                color: "white",
                background: "gradient-blue-dark"
            }
        },
        "@light": {
            color: "white",
            background: "gradient-blue-light",
            ".color-only": {
                color: "blue"
            },
            ".gradient": {
                color: "white",
                background: "gradient-colorful"
            }
        }
    },
    secondary: {
        "@dark": {
            color: "white",
            background: "green",
            ".color-only": {
                color: "green"
            }
        },
        "@light": {
            color: "white",
            background: "green",
            ".color-only": {
                color: "green"
            }
        },
        ".child": "--primary"
    },
    tertiary: {
        "@dark": {
            color: "white",
            background: "gray.92+8"
        },
        "@light": {
            background: "gray.1"
        }
    },
    quaternary: {
        "@light": {
            color: "white",
            background: "gradient-light"
        },
        "@dark": {
            color: "white",
            background: "gradient-dark-active"
        }
    },
    quinary: {
        "@dark": {
            color: "gray=90",
            background: "gradient-light",
            ":hover": {
                color: "gray=95",
                background: "gradient-light-active"
            },
            ":focus": {
                color: "gray=120",
                background: "gradient-light-active"
            },
            ":active": {
                color: "gray=120",
                background: "gradient-light-active"
            },
            ".active": {
                color: "gray=120",
                background: "gradient-light-active"
            }
        },
        "@light": {
            color: "gray3",
            background: "gradient-dark",
            ":hover": {
                color: "gray1",
                background: "gradient-dark-active"
            },
            ":active": {
                color: "gray1",
                background: "gradient-dark-active"
            },
            ".active": {
                color: "gray1",
                background: "gradient-dark-active"
            }
        }
    }
}, n7 = {
    alert: {
        "@dark": {
            color: "white",
            background: "red"
        }
    },
    warning: {
        "@dark": {
            color: "black",
            background: "yellow"
        }
    },
    success: {
        "@dark": {
            color: "black",
            background: "green"
        }
    }
}, o7 = {
    field: {
        "@light": {
            color: "black",
            background: "gray.975+144",
            borderColor: "gray.975+144",
            "::placeholder": {
                color: "gray-68"
            }
        },
        "@dark": {
            color: "white",
            background: "gray.975-52",
            borderColor: "gray.975-52",
            "::placeholder": {
                color: "gray+68"
            }
        }
    },
    label: {
        "@dark": {
            color: "white",
            background: "gray.92+8"
        },
        "@light": {
            background: "gray.1"
        },
        ".light": {
            color: "white",
            background: "gray3"
        },
        ".dark": {
            color: "white",
            background: "black.35"
        }
    },
    card: {
        "@light": {
            background: "gray.975+150"
        },
        "@dark": {
            color: "white",
            background: "gray.975-56"
        },
        ".child": {
            color: "white",
            background: "gray3"
        },
        ".secondary": {
            color: "white",
            background: "gradient-blue-dark",
            ".child": {
                color: "white",
                background: "black.35"
            }
        }
    },
    dialog: {
        "@dark": {
            color: "white",
            background: "gray.92",
            ".helper": {
                color: "white",
                background: "black"
            }
        },
        "@light": {
            color: "black",
            background: "gray+159"
        }
    }
}, jB = {
    document: {
        "@light": {
            color: "black",
            background: "white"
        },
        "@dark": {
            color: "white",
            background: "black"
        }
    },
    ...e7,
    ...n7,
    ...o7,
    backdrop: {
        "@light": {
            background: "scrim",
            backdropFilter: "blur(8px)"
        },
        "@dark": {
            background: "scrim",
            backdropFilter: "blur(8px)"
        }
    },
    backdropSoft: {
        "@light": {
            background: "scrimSoft",
            backdropFilter: "blur(4px)"
        },
        "@dark": {
            background: "scrimSoft",
            backdropFilter: "blur(4px)"
        }
    },
    none: {
        color: "none",
        background: "none"
    },
    transparent: {
        color: "currentColor",
        background: "transparent"
    }
};
var UB = {
    base: 16,
    ratio: 1.25,
    subSequence: !0,
    useCapsize: !0,
    templates: {}
};
var HB = {
    ratio: 1.618,
    subSequence: !0
};
var VB = {
    SourceSans: [
        {
            url: ""
        }
    ]
}, zB = {
    system: {
        isDefault: !0,
        isSystemFallback: !0,
        value: [
            "system-ui",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            '"Noto Sans"',
            '"Liberation Sans"'
        ],
        type: "sans-serif"
    }
};
var WB = new Set, r7 = (t)=>t === "icon" ? "build.treeShakeIcons" : "build.treeShakeComponents", sA = (t, e, n)=>{
    let o = t + ":" + e;
    if (WB.has(o) || (WB.add(o), typeof console > "u" || !console.error)) return;
    let r = n && n.__ref && n.__ref.path, s = r && r.length ? ` (at <${r.join(".")}>)` : "", i = r7(t);
    console.error(`[smbls] ${t === "icon" ? "Icon" : "Component"} "${e}"${s} is not in this build: symbols.json ${i} left it out because the project source never names it. Add "${e}" to ${i}.keep.`);
}, D = (t)=>({
        onInit: {
            always: !0,
            handler: (e)=>sA("component", t, e)
        }
    }), KB = new Set, GB = (t)=>{
    for (let e of t)e && KB.add(e);
}, qB = (t)=>KB.has(t);
var iA = {
    symbols: '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42"><path fill="currentColor" fill-rule="evenodd" d="M26.6448969,0.699064106 C31.4862479,1.83000067 35.6718819,4.48073656 38.3104478,8.91022511 C40.5212645,12.5974948 41.4936378,17.0951724 40.5085112,21.3679841 C39.7174644,25.0315254 37.8558379,27.853625 34.8002871,29.8369535 C31.9792925,31.7073227 27.90737,32.069064 24.6776501,31.3213124 C23.2887047,30.9944607 20.6411869,29.9775216 19.044333,28.0178349 C17.5928447,26.2365433 17.1250067,23.5192397 17.0461096,22.8419583 C16.9044422,21.6258334 17.1065683,20.249997 17.3800113,19.0276209 C17.9614095,16.4655592 18.9984397,14.7924534 21.1401118,13.3818866 C22.95018,12.1750388 24.6834696,11.8738651 26.7601335,12.3496124 C28.1855093,12.6880929 29.4520072,13.526716 30.3514025,14.7276098 C30.6271426,15.093878 30.8260324,15.4389318 31.059655,15.8362933 L30.9598079,15.7715366 C29.6377659,14.9422902 28.1654404,14.6590001 26.6448969,15.0752526 C25.2996601,15.4486698 24.1453463,16.3687006 23.4390969,17.6304467 C22.6973258,18.9448239 22.4839364,20.5087166 22.8465467,21.9733145 C23.2152637,23.4394215 24.1276197,24.6832715 25.381967,25.429977 C26.7647836,26.2608222 28.5893081,26.47537 30.1320438,26.0161118 C32.0344739,25.4497656 33.5958796,24.1165457 34.5824098,22.3233381 C35.8078311,20.0959926 36.0316242,17.5753145 35.4197363,15.1376991 C34.8712232,12.9726344 33.491011,11.1258939 31.7578503,9.86101942 C28.3978494,7.40873928 23.8145474,6.88014849 19.8961329,8.1555193 C16.9596954,9.11146975 14.399202,11.0657028 12.6221782,13.707146 C10.5375814,16.8894059 9.73736372,20.794518 10.3986926,24.5579956 C10.9302311,27.7327705 12.5716868,31.0242929 14.8485647,33.1339502 C15.5517576,33.7855358 16.0056239,34.2996296 16.8186608,34.9238068 C16.1252729,35.6670587 15.729719,36.1210912 15.0276006,36.8553491 L10.5425168,41.6144377 C8.59431563,40.2572487 6.84060794,38.6181461 5.33246714,36.7448351 C1.65619854,32.1632109 -0.0655234106,26.1858125 0.562658817,20.1851649 C1.1000136,14.4158268 3.81414269,9.08050481 8.0996615,5.36924966 C12.3107417,1.69300072 17.6911238,0.0107792851 23.1108097,0.299129816 C25.006381,0.458182488 26.18441,0.591493918 26.6448969,0.699064106 Z"/></svg>',
    logo: '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42"><path fill="currentColor" fill-rule="evenodd" d="M26.6448969,0.699064106 C31.4862479,1.83000067 35.6718819,4.48073656 38.3104478,8.91022511 C40.5212645,12.5974948 41.4936378,17.0951724 40.5085112,21.3679841 C39.7174644,25.0315254 37.8558379,27.853625 34.8002871,29.8369535 C31.9792925,31.7073227 27.90737,32.069064 24.6776501,31.3213124 C23.2887047,30.9944607 20.6411869,29.9775216 19.044333,28.0178349 C17.5928447,26.2365433 17.1250067,23.5192397 17.0461096,22.8419583 C16.9044422,21.6258334 17.1065683,20.249997 17.3800113,19.0276209 C17.9614095,16.4655592 18.9984397,14.7924534 21.1401118,13.3818866 C22.95018,12.1750388 24.6834696,11.8738651 26.7601335,12.3496124 C28.1855093,12.6880929 29.4520072,13.526716 30.3514025,14.7276098 C30.6271426,15.093878 30.8260324,15.4389318 31.059655,15.8362933 L30.9598079,15.7715366 C29.6377659,14.9422902 28.1654404,14.6590001 26.6448969,15.0752526 C25.2996601,15.4486698 24.1453463,16.3687006 23.4390969,17.6304467 C22.6973258,18.9448239 22.4839364,20.5087166 22.8465467,21.9733145 C23.2152637,23.4394215 24.1276197,24.6832715 25.381967,25.429977 C26.7647836,26.2608222 28.5893081,26.47537 30.1320438,26.0161118 C32.0344739,25.4497656 33.5958796,24.1165457 34.5824098,22.3233381 C35.8078311,20.0959926 36.0316242,17.5753145 35.4197363,15.1376991 C34.8712232,12.9726344 33.491011,11.1258939 31.7578503,9.86101942 C28.3978494,7.40873928 23.8145474,6.88014849 19.8961329,8.1555193 C16.9596954,9.11146975 14.399202,11.0657028 12.6221782,13.707146 C10.5375814,16.8894059 9.73736372,20.794518 10.3986926,24.5579956 C10.9302311,27.7327705 12.5716868,31.0242929 14.8485647,33.1339502 C15.5517576,33.7855358 16.0056239,34.2996296 16.8186608,34.9238068 C16.1252729,35.6670587 15.729719,36.1210912 15.0276006,36.8553491 L10.5425168,41.6144377 C8.59431563,40.2572487 6.84060794,38.6181461 5.33246714,36.7448351 C1.65619854,32.1632109 -0.0655234106,26.1858125 0.562658817,20.1851649 C1.1000136,14.4158268 3.81414269,9.08050481 8.0996615,5.36924966 C12.3107417,1.69300072 17.6911238,0.0107792851 23.1108097,0.299129816 C25.006381,0.458182488 26.18441,0.591493918 26.6448969,0.699064106 Z"/></svg>',
    arrowDownCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-circle"><circle cx="12" cy="12" r="10"/><path d="M8 12l4 4 4-4M12 8v8"/></svg>',
    arrowDownLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-left"><path d="M17 7L7 17M17 17H7V7"/></svg>',
    arrowDownRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-right"><path d="M7 7l10 10M17 7v10H7"/></svg>',
    arrowDown: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>',
    arrowLeftCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left-circle"><circle cx="12" cy="12" r="10"/><path d="M12 8l-4 4 4 4M16 12H8"/></svg>',
    arrowLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    arrowRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
    arrowRightCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle cx="12" cy="12" r="10"/><path d="M12 16l4-4-4-4M8 12h8"/></svg>',
    arrowUpCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-circle"><circle cx="12" cy="12" r="10"/><path d="M16 12l-4-4-4 4M12 16V8"/></svg>',
    arrowUpLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-left"><path d="M17 17L7 7M7 17V7h10"/></svg>',
    arrowUpRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-right"><path d="M7 17L17 7M7 7h10v10"/></svg>',
    arrowUp: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up"><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    checkCircle: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>',
    check: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><path d="M20 6L9 17l-5-5"/></svg>',
    chevronDown: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><path d="M6 9l6 6 6-6"/></svg>',
    chevronLeft: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><path d="M15 18l-6-6 6-6"/></svg>',
    chevronRight: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><path d="M9 18l6-6-6-6"/></svg>',
    chevronUp: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><path d="M18 15l-6-6-6 6"/></svg>',
    copy: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>',
    eyeOff: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"/></svg>',
    eye: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    info: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>',
    lock: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>',
    minus: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><path d="M5 12h14"/></svg>',
    sun: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sun"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>',
    moon: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-moon"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>',
    moreHorizontal: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>',
    moreVertical: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>',
    send: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
    smile: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-smile"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></svg>',
    search: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>',
    upload: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>',
    video: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>',
    x: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    star: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>',
    plus: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><path d="M12 5v14M5 12h14"/></svg>',
    warning: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-triangle"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01"/></svg>',
    document: '<svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>'
};
var YB = {
    tv: "(min-width: 2780px)",
    screenL: "(max-width: 1920px)",
    "screenL<": "(min-width: 1920.02px)",
    screenM: "(max-width: 1680px)",
    "screenM<": "(min-width: 1680.02px)",
    screenS: "(max-width: 1440px)",
    "screenS<": "(min-width: 1440.02px)",
    tabletL: "(max-width: 1366px)",
    "tabletL<": "(min-width: 1366.02px)",
    tabletM: "(max-width: 1280px)",
    "tabletM<": "(min-width: 1280.02px)",
    tabletS: "(max-width: 1024px)",
    "tabletS<": "(min-width: 1024.02px)",
    mobileL: "(max-width: 768px)",
    "mobileL<": "(min-width: 768.02px)",
    mobileM: "(max-width: 560px)",
    "mobileM<": "(min-width: 560.02px)",
    mobileS: "(max-width: 480px)",
    "mobileS<": "(min-width: 480.02px)",
    mobileXS: "(max-width: 375px)",
    "mobileXS<": "(min-width: 375.02px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};
var XB = {
    base: 150,
    ratio: 1.333,
    unit: "ms",
    subSequence: !0,
    defaultBezier: "cubic-bezier(.29, .67, .51, .97)",
    springBezier: "cubic-bezier(.32, .72, 0, 1)"
};
var ZB = {
    radiusControl: "12px",
    radiusCard: "17px",
    radiusSheet: "24px",
    radiusPill: "999px",
    controlH: "44px",
    controlHCompact: "36px",
    grabberW: "36px",
    grabberH: "5px"
};
var Ni = {
    version: "0.0.1",
    color: FB,
    gradient: $B,
    theme: jB,
    typography: UB,
    spacing: HB,
    font: VB,
    fontFamily: zB,
    timing: XB,
    icons: iA,
    media: YB,
    sizes: ZB,
    reset: {
        html: {},
        body: {}
    },
    animation: {
        fadeIn: {
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        },
        modalIn: {
            from: {
                transform: "scale(0.95)",
                opacity: 0
            },
            to: {
                transform: "",
                opacity: 1
            }
        },
        modalOut: {
            to: {
                transform: "scale(0.95)",
                opacity: 0
            }
        },
        modalInUp: {
            from: {
                transform: "translate3d(0, 6.5%, 0)",
                opacity: 0
            },
            to: {
                transform: "",
                opacity: 1
            }
        },
        modalOutDown: {
            to: {
                transform: "translate3d(0, 6.5%, 0)",
                opacity: 0
            }
        }
    },
    devices: {},
    class: {},
    svg: {},
    grid: {},
    shape: {}
};
var il = /*@__PURE__*/ F({}, {
    A: ()=>f$,
    AssetPicture: ()=>gN,
    Audio: ()=>_N,
    Avatar: ()=>N$,
    B: ()=>NN,
    Block: ()=>QB,
    Box: ()=>Wy,
    Br: ()=>UN,
    Bridge: ()=>YN,
    Button: ()=>p$,
    ButtonSet: ()=>y$,
    COMPONENTS: ()=>Ki,
    Caption: ()=>ON,
    Checkbox: ()=>QN,
    CheckboxHgroup: ()=>JN,
    Circle: ()=>dN,
    CircleButton: ()=>g$,
    Clickable: ()=>lN,
    Data: ()=>$N,
    Dialog: ()=>E$,
    DialogFooter: ()=>v$,
    DialogHeader: ()=>A$,
    Dropdown: ()=>f2,
    DropdownDisclosure: ()=>p2,
    DropdownList: ()=>u2,
    DropdownParent: ()=>d2,
    DropdownParentFocus: ()=>h2,
    DropdownSiblingFocus: ()=>g2,
    FileIcon: ()=>pF,
    Flex: ()=>tN,
    Focusable: ()=>fN,
    FocusableComponent: ()=>uN,
    Footnote: ()=>BN,
    Form: ()=>iN,
    Grid: ()=>nN,
    Gutter: ()=>rN,
    H1: ()=>wN,
    H2: ()=>xN,
    H3: ()=>kN,
    H4: ()=>TN,
    H5: ()=>EN,
    H6: ()=>AN,
    Headline: ()=>IN,
    Hgroup: ()=>KN,
    HgroupButton: ()=>qN,
    HgroupRows: ()=>GN,
    Hoverable: ()=>cN,
    Hr: ()=>jN,
    I: ()=>FN,
    Icon: ()=>uF,
    IconButton: ()=>_$,
    IconText: ()=>dF,
    Iframe: ()=>aN,
    Img: ()=>sN,
    Inline: ()=>JB,
    InlineFlex: ()=>eN,
    InlineGrid: ()=>oN,
    Input: ()=>XN,
    Italic: ()=>LN,
    KangorooButton: ()=>m$,
    Li: ()=>HN,
    Link: ()=>sv,
    Notification: ()=>m2,
    NumberInput: ()=>ZN,
    Ol: ()=>zN,
    P: ()=>vN,
    Picture: ()=>hN,
    Radio: ()=>tF,
    RadioHgroup: ()=>eF,
    Range: ()=>F$,
    RouteLink: ()=>u$,
    RouterLink: ()=>iv,
    SHAPES: ()=>Vy,
    Select: ()=>d$,
    Shape: ()=>pA,
    Span: ()=>SN,
    SquareButton: ()=>h$,
    Strong: ()=>CN,
    Subhead: ()=>MN,
    Svg: ()=>mN,
    Text: ()=>bN,
    Textarea: ()=>rF,
    TextareaWithButton: ()=>sF,
    Theme: ()=>pN,
    Title: ()=>PN,
    Toggle: ()=>nF,
    ToggleHgroup: ()=>oF,
    Tooltip: ()=>I$,
    TooltipHidden: ()=>M$,
    TooltipLayer: ()=>ip,
    TooltipParent: ()=>B$,
    U: ()=>RN,
    Ul: ()=>VN,
    Underline: ()=>DN,
    Video: ()=>yN,
    depth: ()=>zy,
    focusableRingEnabled: ()=>Yd,
    focusableRingToken: ()=>uA,
    focusableRingValue: ()=>Fi,
    getSystemGlobalTheme: ()=>Xd
});
var aA = /*@__PURE__*/ F({}, {
    Block: ()=>QB,
    Flex: ()=>tN,
    Grid: ()=>nN,
    Gutter: ()=>rN,
    Inline: ()=>JB,
    InlineFlex: ()=>eN,
    InlineGrid: ()=>oN
});
var QB = {
    display: "block"
}, JB = {
    display: "inline"
}, tN = {
    display: "flex"
}, eN = {
    display: "inline-flex"
}, nN = {
    display: "grid"
}, oN = {
    display: "inline-grid"
}, rN = {
    boxSize: "C1"
};
var cA = /*@__PURE__*/ F({}, {
    Img: ()=>sN
});
var sN = {
    tag: "img",
    attr: {
        title: (t)=>t.title,
        alt: (t)=>t.alt != null ? t.alt : t.title || "",
        src: (t)=>{
            let e = Te(t);
            return e && e.src || t.src;
        },
        srcset: (t)=>{
            let e = Te(t);
            return (e ? gu(e) : "") || t.srcset || t.srcSet;
        }
    }
};
var lA = /*@__PURE__*/ F({}, {
    Form: ()=>iN
});
var iN = {
    tag: "form"
};
var fA = /*@__PURE__*/ F({}, {
    Iframe: ()=>aN
});
var aN = {
    tag: "iframe",
    position: "relative",
    minWidth: "G",
    minHeight: "G"
};
var dA = /*@__PURE__*/ F({}, {
    Clickable: ()=>lN,
    Focusable: ()=>fN,
    FocusableComponent: ()=>uN,
    Hoverable: ()=>cN,
    focusableRingEnabled: ()=>Yd,
    focusableRingToken: ()=>uA,
    focusableRingValue: ()=>Fi
});
var s7 = {
    appearance: "none",
    fontFamily: "inherit"
}, cN = {
    transition: "opacity C defaultBezier, transform C defaultBezier",
    opacity: .85,
    ":hover": {
        opacity: .9,
        transform: "scale(1.015)"
    },
    ":active": {
        opacity: 1,
        transform: "scale(1.015)"
    },
    ".active": {
        opacity: 1,
        transform: "scale(1.015)",
        ":hover": {
            opacity: 1
        }
    }
}, lN = {
    extends: "Hoverable",
    ":active": {
        opacity: 1,
        transform: "scale(1.015)"
    },
    ".active": {
        opacity: 1
    }
};
function Yd(t) {
    let e = t.context && t.context.designSystem;
    return !e || e.focusableRing !== !1;
}
function uA(t) {
    let e = t.context && t.context.designSystem, n = e && e.focusableRing;
    if (typeof n == "string") return n ? {
        outline: n,
        outlineOffset: void 0
    } : null;
    if (!n || typeof n != "object" || Array.isArray(n)) return null;
    let o = n.outline || void 0, r = n.outlineOffset != null && n.outlineOffset !== "" ? n.outlineOffset : void 0;
    return o || r !== void 0 ? {
        outline: o,
        outlineOffset: r
    } : null;
}
function Fi(t, e, n) {
    let o = uA(t);
    return o && o[e] !== void 0 ? o[e] : n;
}
var fN = {
    border: "none",
    outline: (t)=>Yd(t) ? "solid 0 currentColor" : "none",
    ":focus-visible": {
        opacity: 1,
        outline: (t)=>Yd(t) ? Fi(t, "outline", "solid X currentColor") : "none",
        outlineOffset: (t)=>Yd(t) ? Fi(t, "outlineOffset") : void 0
    }
}, uN = {
    extends: "Focusable",
    tag: "button",
    fontSize: "A",
    type: "button",
    border: "none",
    textDecoration: "none",
    lineHeight: "1",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
    cursor: "pointer",
    ":disabled": {
        cursor: "not-allowed"
    },
    style: s7
};
var mA = /*@__PURE__*/ F({}, {
    Picture: ()=>hN
});
var gA = /*@__PURE__*/ F({}, {
    Theme: ()=>pN,
    getSystemGlobalTheme: ()=>Xd
});
var hA = /*@__PURE__*/ F({}, {
    Circle: ()=>dN,
    SHAPES: ()=>Vy,
    Shape: ()=>pA,
    default: ()=>i7,
    depth: ()=>zy
});
var wn = L(), zy = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${wn.unit.default} 4${wn.unit.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${wn.unit.default} 6${wn.unit.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${wn.unit.default} 10${wn.unit.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${wn.unit.default} 16${wn.unit.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${wn.unit.default} 26${wn.unit.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${wn.unit.default} 42${wn.unit.default}`
    }
}, Qc = (t)=>ct(t.shapeDirectionColor) || ct(t.borderColor) || ct(t.backgroundColor) || ct(t.background), Hy = (t)=>{
    let e = yd.transition(t.transition, t);
    return e && e.transition;
}, Vy = {
    rectangle: {},
    circle: {
        borderRadius: "100%"
    },
    bubble: {},
    tv: {
        borderRadius: "1.15em/2.5em"
    },
    tooltip: (t)=>({
            position: t.position || "relative",
            "&:before": {
                content: '""',
                display: "block",
                width: "0px",
                height: "0px",
                border: ".35em solid",
                borderColor: Qc(t),
                transition: Hy(t),
                transitionProperty: "border-color",
                position: "absolute",
                borderRadius: ".15em"
            }
        }),
    tooltipDirection: {
        top: {
            "&:before": {
                top: "0",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                right: "0",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                bottom: "0",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                left: "0",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        }
    },
    tag: (t)=>({
            position: "relative",
            "&:before": {
                content: '""',
                display: "block",
                background: Qc(t),
                transition: Hy(t),
                transitionProperty: "background",
                borderRadius: ".25em",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%"
            }
        }),
    tagDirection: {
        top: {
            "&:before": {
                bottom: "100%",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                left: "100%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                top: "100%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                right: "100%",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        }
    },
    hexagon: (t)=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                borderRadius: ".25em",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%",
                background: Qc(t),
                transition: Hy(t),
                transitionProperty: "background"
            },
            "&:before": {
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            },
            "&:after": {
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }),
    chevron: (t)=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                transition: Hy(t),
                transitionProperty: "background"
            },
            "&:before": {
                background: `linear-gradient(225deg, ${Qc(t)} 25%, transparent 25%), linear-gradient(315deg, ${Qc(t)} 25%, transparent 25%)`
            },
            "&:after": {
                background: Qc(t),
                borderRadius: ".25em"
            }
        }),
    chevronDirection: {
        left: {
            "&:before": {
                height: "100%",
                left: "100%",
                transform: "translate3d(-1%, -50%, 1px) scale(-1, 1)"
            },
            "&:after": {
                height: "73%",
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                height: "100%",
                left: "0",
                transform: "translate3d(-99%, -50%, 1px)"
            },
            "&:after": {
                height: "73%",
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }
    }
}, pA = {
    deps: {
        exec: bt,
        getSpacingBasedOnRatio: ze,
        getMediaColor: Wt
    },
    classlist: {
        shape: (t)=>t.deps.exec(Vy[t.shape], t),
        shapeDirection: (t)=>{
            if (!t.shape || !t.shapeDirection) return;
            let e = Vy[t.shape + "Direction"];
            return t.shape && e ? e[t.shapeDirection || "left"] : null;
        },
        shapeDirectionColor: (t)=>{
            let e = {
                borderColor: t.deps.getMediaColor(t.background || t.backgroundColor)
            };
            return t.shapeDirection ? e : null;
        }
    }
}, dN = {
    round: "100%"
}, i7 = pA;
var Xd = ({ context: t, state: e })=>{
    let n = e && e.root, o = n && n.globalTheme || t.designSystem && t.designSystem.globalTheme;
    return o === "auto" ? null : o;
}, pN = {
    deps: {
        depth: zy
    },
    classlist: {
        depth: (t)=>!Xt(t.depth) && t.deps.depth[t.depth]
    }
};
var hN = {
    deps: {
        getSystemGlobalTheme: Xd
    },
    tag: "picture",
    childExtends: {
        deps: {
            getSystemGlobalTheme: Xd
        },
        tag: "source",
        attr: {
            media: (t)=>{
                let { key: e, context: n, deps: o } = t, { media: r } = n.designSystem, s = o.getSystemGlobalTheme(t), i = (t.media || e).slice(1);
                return i === s ? "(min-width: 0px)" : i === "dark" || i === "light" ? "(max-width: 0px)" : r[i];
            }
        }
    },
    Img: {
        width: "inherit",
        ignoreChildExtends: !0,
        height: "inherit",
        src: (t, e)=>t.parent?.src || e.src
    }
};
var yA = /*@__PURE__*/ F({}, {
    AssetPicture: ()=>gN
});
var gN = {
    tag: "picture",
    children: (t)=>{
        let e = Te(t);
        if (e) return mu(e, t.alt);
    }
};
var _A = /*@__PURE__*/ F({}, {
    Svg: ()=>mN
});
var mN = {
    tag: "svg",
    attr: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    html: (t)=>{
        let { context: e } = t;
        if (t.semanticIcons) return;
        if (t.html && typeof t.html != "function") return t.call("exec", t.html, t);
        let { designSystem: n, utils: o } = e, r = n && n.svg, s = t.spriteId || n && n.useSvgSprite, i = t.call("exec", t.src, t), a = (d)=>`<use xlink:href="#${d}" />`;
        if (typeof i == "string") {
            let d = i.match(/^\s*<symbol\b[^>]*\bid="([^"]+)"/);
            if (d) {
                let p = d[1], g = e.document || (typeof document < "u" ? document : null);
                if (!(g && typeof g.getElementById == "function" && g.getElementById(p))) {
                    let m = o && o.scratchSystem && o.scratchSystem.appendSVGSprite;
                    n && !n.__svgCache && (n.__svgCache = {}), typeof m == "function" ? m({
                        [p]: i
                    }, {
                        document: g
                    }) : o && typeof o.init == "function" && o.init({
                        svg: {
                            [p]: i
                        }
                    }, {
                        document: g,
                        emotion: e.emotion
                    });
                }
                return a(p);
            }
        }
        if (!s && i) return i;
        let c = t.spriteId;
        if (c) return a(c);
        if (r && r[i]) return a(i);
        let l = Symbol.for(i), f = r[l];
        if (f && r[f]) return a(f);
        if (!i) return a("");
        if (typeof i == "string" && !i.includes("<")) return typeof console < "u" && console.warn && console.warn(`[Svg] Unknown sprite symbol "${i}" \u2014 not registered in design-system sprite. Set the icon name to one that exists in designSystem.icons / context.svg, or register the SVG body via utils.init({ svg: { '${i}': '<svg>...</svg>' } }).`), a("");
        let u = 0;
        for(let d = 0; d < i.length; d++)u = (u << 5) - u + i.charCodeAt(d) | 0;
        return f = r[l] = `svg-${(u >>> 0).toString(36)}`, o.init({
            svg: {
                [f]: i
            }
        }, {
            document: e.document,
            emotion: e.emotion
        }), a(f);
    }
};
var bA = /*@__PURE__*/ F({}, {
    Video: ()=>yN
});
var yN = {
    tag: "video",
    controls: !0,
    attr: {
        src: (t)=>{
            let e = Te(t);
            return e && e.src || t.src;
        }
    },
    children: (t)=>{
        let e = Te(t);
        if (!(!e || !Array.isArray(e.variants) || !e.variants.length)) return e.variants.map((n)=>({
                tag: "source",
                attr: {
                    src: n.src,
                    type: n.format
                }
            }));
    },
    childExtends: {
        tag: "source"
    }
};
var SA = /*@__PURE__*/ F({}, {
    Audio: ()=>_N
});
var _N = {
    tag: "audio",
    controls: !0,
    attr: {
        src: (t)=>{
            let e = Te(t);
            return e && e.src || t.src;
        }
    },
    children: (t)=>{
        let e = Te(t);
        if (!(!e || !Array.isArray(e.variants) || !e.variants.length)) return e.variants.map((n)=>({
                tag: "source",
                attr: {
                    src: n.src,
                    type: n.format
                }
            }));
    },
    childExtends: {
        tag: "source"
    }
};
var wA = /*@__PURE__*/ F({}, {
    B: ()=>NN,
    Caption: ()=>ON,
    Data: ()=>$N,
    Footnote: ()=>BN,
    H1: ()=>wN,
    H2: ()=>xN,
    H3: ()=>kN,
    H4: ()=>TN,
    H5: ()=>EN,
    H6: ()=>AN,
    Headline: ()=>IN,
    I: ()=>FN,
    Italic: ()=>LN,
    P: ()=>vN,
    Span: ()=>SN,
    Strong: ()=>CN,
    Subhead: ()=>MN,
    Text: ()=>bN,
    Title: ()=>PN,
    U: ()=>RN,
    Underline: ()=>DN
});
var bN = {}, SN = {
    tag: "span"
}, wN = {
    tag: "h1"
}, xN = {
    tag: "h2"
}, kN = {
    tag: "h3"
}, TN = {
    tag: "h4"
}, EN = {
    tag: "h5"
}, AN = {
    tag: "h6"
}, vN = {
    tag: "p"
}, ON = {
    tag: "caption"
}, CN = {
    tag: "strong",
    fontWeight: "700"
}, RN = {
    tag: "u"
}, DN = {
    tag: "u"
}, LN = {
    tag: "i"
}, PN = {}, IN = {
    tag: "h6",
    fontSize: "B",
    fontWeight: 500
}, MN = {
    tag: "span",
    fontSize: "Z1"
}, BN = {
    tag: "span",
    fontSize: "Z"
}, NN = {
    tag: "b"
}, FN = {
    tag: "i"
}, $N = {
    tag: "data"
};
var xA = /*@__PURE__*/ F({}, {
    Box: ()=>Wy,
    Br: ()=>UN,
    Hr: ()=>jN,
    Li: ()=>HN,
    Ol: ()=>zN,
    Ul: ()=>VN
});
var a7 = (t)=>{
    if (!t.context) return;
    let { props: e, __ref: n } = t, o = ne(e, t, {
        unpack: !1
    });
    n.__class = o;
}, Wy = {
    extends: [
        "Shape",
        "Theme"
    ],
    boxSizing: "border-box",
    onBeforeClassAssign: a7
}, jN = {
    tag: "hr",
    margin: "C1 0"
}, UN = {
    tag: "br"
}, HN = {
    tag: "li"
}, VN = {
    tag: "ul",
    childExtends: {
        extends: "Li"
    }
}, zN = {
    tag: "ol",
    childExtends: {
        extends: "Li"
    }
};
var kA = /*@__PURE__*/ F({}, {
    Hgroup: ()=>KN,
    HgroupButton: ()=>qN,
    HgroupRows: ()=>GN
});
var WN = (t)=>{
    if (t.text != null || t.html != null) return !0;
    for(let e in t){
        let n = e.charCodeAt(0);
        if (n >= 65 && n <= 90) return !0;
    }
    return !1;
}, KN = {
    display: "flex",
    tag: "hgroup",
    flow: "y",
    gap: "Y2",
    H: {
        if: WN,
        color: "title",
        tag: "h3",
        lineHeight: "1em",
        margin: "0"
    },
    P: {
        if: WN,
        margin: "0",
        color: "paragraph"
    }
}, GN = {
    extends: "Hgroup",
    H: {
        display: "flex",
        color: "title",
        align: "center space-between"
    },
    P: {
        color: "paragraph",
        align: "center space-between"
    }
}, qN = {
    extends: "HgroupRows",
    H: {
        justifyContent: "space-between",
        Span: {},
        Button: {
            background: "transparent",
            color: "currentColor",
            padding: "0",
            Icon: {
                name: "x",
                fontSize: "C"
            }
        }
    },
    P: {}
};
var TA = /*@__PURE__*/ F({}, {
    Bridge: ()=>YN
});
var YN = {
    tag: "div"
};
var EA = /*@__PURE__*/ F({}, {
    Input: ()=>XN
});
var XN = {
    extends: [
        "Focusable"
    ],
    tag: "input",
    border: "none",
    theme: "field",
    fontSize: "A",
    round: "C",
    lineHeight: "1",
    padding: "Z2 B",
    attr: {
        pattern: (t)=>t.pattern,
        name: (t)=>t.name,
        placeholder: (t)=>t.placeholder,
        value: (t)=>{
            if (!t.value) return;
            let e = t.call("exec", t.value, t);
            return t.call("isString", e) && e.includes("{{") ? t.call("replaceLiteralsWithObjectFields", e) : e;
        },
        checked: (t)=>t.call("exec", t.checked, t),
        disabled: (t)=>t.disabled || null,
        required: (t)=>t.required,
        type: (t)=>t.type
    }
};
var AA = /*@__PURE__*/ F({}, {
    NumberInput: ()=>ZN
});
var ZN = {
    extends: [
        "Flex",
        "Input"
    ],
    type: "number",
    boxSize: "C+X",
    align: "center center",
    textAlign: "center",
    round: "Y1",
    theme: "transparent",
    border: "1px solid line",
    placeholder: "0",
    fontWeight: "400",
    "::-webkit-inner-spin-button": {
        appearance: "none"
    },
    attr: {
        step: (t)=>t.step,
        min: (t)=>t.min,
        max: (t)=>t.max
    }
};
var vA = /*@__PURE__*/ F({}, {
    Checkbox: ()=>QN,
    CheckboxHgroup: ()=>JN
});
var QN = {
    extends: "Focusable",
    tag: "label",
    boxSize: "fit-content fit-content",
    cursor: "pointer",
    round: "Y",
    Input: {
        type: "checkbox",
        position: "absolute",
        opacity: "0",
        width: "1px",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        ":checked + div": {
            theme: "primary"
        },
        ":checked + div > svg": {
            transform: "none",
            opacity: "1"
        },
        ":focus-visible + div": {
            outline: (t)=>Fi(t, "outline", "solid X currentColor"),
            outlineOffset: (t)=>Fi(t, "outlineOffset", "Z")
        },
        attr: {
            checked: (t)=>t.call("exec", t.parent.checked)
        }
    },
    Flex: {
        align: "center center",
        fontSize: "B1",
        padding: "V",
        theme: "field",
        round: "X2",
        transition: "background A defaultBezier",
        Icon: {
            icon: "check",
            opacity: "0",
            transform: "scale(0.9) rotate(-15deg)",
            transition: "opacity B defaultBezier"
        }
    }
}, JN = {
    display: "flex",
    tag: "label",
    boxSize: "fit-content",
    align: "flex-start flex-start",
    gap: "A",
    Checkbox: {
        tag: "div"
    },
    HgroupRows: {
        gap: "Z1",
        margin: "Y - - -"
    }
};
var OA = /*@__PURE__*/ F({}, {
    Radio: ()=>tF,
    RadioHgroup: ()=>eF
});
var tF = {
    extends: "Checkbox",
    Input: {
        type: "radio",
        ":checked + div:after": {
            opacity: "1"
        }
    },
    Flex: {
        round: "100%",
        padding: "Y",
        ":after": {
            content: '""',
            display: "block",
            boxSize: "X+W1",
            round: "100%",
            background: "white",
            opacity: "0",
            transition: "opacity .15s ease-in-out"
        },
        Icon: null
    }
}, eF = {
    extends: "CheckboxHgroup",
    Checkbox: null,
    Radio: {}
};
var CA = /*@__PURE__*/ F({}, {
    Toggle: ()=>nF,
    ToggleHgroup: ()=>oF
});
var nF = {
    extends: "Checkbox",
    Input: {
        role: "switch",
        ":checked + div": {
            background: "green2+8",
            justifyContent: "flex-end"
        }
    },
    Flex: {
        boxSize: "A1 B1",
        padding: "- W_default",
        round: "D",
        align: "center flex-start",
        theme: "field",
        border: "none",
        transition: "opacity .15s ease",
        ":after": {
            content: '""',
            boxSize: "A A",
            round: "100%",
            background: "white",
            boxShadow: "gray.2 1px 1px Z"
        },
        Icon: null
    }
}, oF = {
    extends: "CheckboxHgroup",
    Checkbox: null,
    Toggle: {}
};
var RA = /*@__PURE__*/ F({}, {
    Textarea: ()=>rF,
    TextareaWithButton: ()=>sF
});
var rF = {
    tag: "textarea",
    extends: [
        "Input",
        "Flex"
    ],
    fontfamily: "Avenir",
    placeholder: "Leave us a message...",
    padding: "A",
    theme: "field",
    border: "none",
    minHeight: "E_default",
    width: "100%",
    height: "E1_default",
    fontFamily: "inherit",
    round: "Z2",
    lineHeight: 1.4,
    ".outlined": {
        borderWidth: "1px",
        borderStyle: "solid"
    }
}, sF = {
    display: "flex",
    gap: "Y2",
    Textarea: {
        height: "C2+W",
        minWidth: "H",
        padding: "A",
        fontSize: "Z1",
        round: "Z2",
        minHeight: "fit-content"
    },
    SquareButton: {
        background: "blue",
        Icon: {
            name: "send"
        }
    }
};
var PA = /*@__PURE__*/ F({}, {
    FileIcon: ()=>pF,
    Icon: ()=>uF,
    IconText: ()=>dF
});
var iF = new Set, aF = (t, e)=>{
    if (!iF.has(t) && (iF.add(t), typeof console < "u" && console.warn)) {
        let n = e && e.__ref && e.__ref.path, o = n && n.length ? ` at <${n.join(".")}>` : "";
        console.warn(`[Icon] Unknown icon name "${t}"${o} \u2014 not registered in designSystem.icons, rendering the noIcon placeholder. Fix the name or register the icon in the design system.`);
    }
}, cF = (t, e)=>{
    let n = t.find((o)=>o && qB(o));
    return n ? (sA("icon", n, e), !0) : !1;
}, lF = new WeakMap, c7 = (t)=>{
    let e = lF.get(t);
    return e || (e = {
        pending: new Map,
        waiting: new Map,
        failed: new Set
    }, lF.set(t, e)), e;
}, l7 = (t, e)=>{
    if (!t) return null;
    let n = t.default || t;
    return typeof n == "string" ? n.trim() ? {
        [e]: n
    } : null : typeof n == "object" && !Array.isArray(n) && Object.keys(n).length ? n : null;
}, f7 = (t, e, n)=>{
    let o = n && n.context && n.context.document || (typeof document < "u" ? document : null);
    pt(t);
    try {
        let r = L();
        r && !r.__svgCache && (r.__svgCache = {}), t.__svgCache || (t.__svgCache = {});
        let s = {};
        for(let i in e){
            let a = mi(e[i], i);
            a && (t.icons[i] = a, s[i] = a);
        }
        return t.useIconSprite && o && Object.keys(s).length && yi(s, {
            document: o
        }), Object.keys(s).length > 0;
    } finally{
        ut();
    }
}, u7 = (t, e, n, o, r)=>{
    let s = t && t.designSystem, i = s && s.iconsLoader;
    if (typeof i != "function" || !s.icons) return !1;
    let a = c7(s);
    if (a.failed.has(e)) return !1;
    let c = a.waiting.get(e);
    if (c || (c = new Set, a.waiting.set(e, c)), c.add(r), a.pending.has(e)) return !0;
    let l = ()=>i(e, t), f = Promise.resolve().then(l).then((u)=>{
        let d = l7(u, n);
        return d ? f7(s, d, o) : !1;
    }).catch((u)=>(typeof console < "u" && console.error && console.error(`[Icon] iconsLoader failed for "${e}":`, u), !1)).then((u)=>{
        a.pending.delete(e);
        let d = a.waiting.get(e);
        a.waiting.delete(e), u || a.failed.add(e), d && d.forEach((p)=>{
            try {
                p(u);
            } catch (g) {
                console.error("[Icon] repaint error:", g);
            }
        });
    });
    return a.pending.set(e, f), !0;
}, d7 = "0 0 24 24", p7 = /<(symbol|svg)\b[^>]*>/i, h7 = {
    viewBox: /\sviewBox\s*=\s*(?:"([^"]*)"|'([^']*)')/i,
    width: /\swidth\s*=\s*(?:"([^"]*)"|'([^']*)')/i,
    height: /\sheight\s*=\s*(?:"([^"]*)"|'([^']*)')/i
}, DA = (t, e)=>{
    let n = t.match(h7[e]);
    return n ? n[1] !== void 0 ? n[1] : n[2] : void 0;
}, fF = (t)=>{
    let e = typeof t == "string" && t.match(/^\s*(\d*\.?\d+)\s*(?:px)?\s*$/);
    return e ? Number(e[1]) : void 0;
}, g7 = (t, e)=>{
    if (typeof t != "string") return;
    let n = t.match(p7);
    if (!n) return;
    let o = (DA(n[0], "viewBox") || "").trim().split(/[\s,]+/).map(Number), r = o.length === 4 && o[2] > 0 && o[3] > 0 ? [
        o[2],
        o[3]
    ] : void 0, s = fF(DA(n[0], "width")), i = fF(DA(n[0], "height")), a = s > 0 && i > 0 ? [
        s,
        i
    ] : void 0, c = n[1].toLowerCase() === "symbol" || e ? r || a : a || r;
    return c ? `0 0 ${c[0]} ${c[1]}` : void 0;
}, LA = (t)=>{
    let e = t.call("exec", t.viewBox, t);
    if (e) return e;
    let n = t.context && t.context.designSystem, o = !!(t.spriteId || n && n.useSvgSprite);
    return g7(t.call("exec", t.src, t), o) || d7;
}, uF = {
    extends: "Svg",
    width: "A",
    height: "A",
    display: "inline-block",
    style: {
        fill: "currentColor",
        "*": {
            fill: "currentColor"
        }
    },
    onInit: (t, e, n)=>{
        let { parent: o } = t, { icons: r, useIconSprite: s, verbose: i } = n && n.designSystem, { toCamelCase: a } = n && n.utils, c = !1, l = (h, m)=>{
            try {
                return {
                    value: t.call("exec", h, m)
                };
            } catch (y) {
                if (t.__ref && (t.__ref.__iconNameError = y), !c && typeof console < "u" && console.warn) {
                    c = !0;
                    let b = t.__ref && t.__ref.path, T = b && b.length ? ` at <${b.join(".")}>` : "";
                    console.warn(`[Icon] name/icon factory threw${T} \u2014 treated as no name (a painted glyph stays):`, y && y.message || y);
                }
                return {
                    threw: !0
                };
            }
        }, f = (h, m)=>{
            let { semanticIcons: y } = m && m.designSystem, { toCamelCase: b } = m && m.utils, v = b(h).split(/([a-z])([A-Z])/g), S = v[1] ? v[0] : h.split(".")[0].split(" ")[0], w = y && y[S];
            if (w) {
                let _ = h.includes(".") ? "sfsymbols." + h.split(".").slice(1).join(".") : "sfsymbols";
                return h = w[_] || w[h.split(".")[0].split(" ")[0]], {
                    tag: "span",
                    semanticIcons: !0,
                    width: "A",
                    height: "A",
                    lineHeight: "1em",
                    ":after": {
                        fontSize: "Z",
                        fontWeight: "300",
                        content: `"${h}"`,
                        textAlign: "center",
                        display: "inline-block",
                        style: {
                            color: "currentColor",
                            fontFamily: "'SF Pro Icons', 'SF Pro', 'SF Symbols', 'Segoe UI'"
                        }
                    }
                };
            }
        }, u = (h)=>{
            let { key: m } = h, y = l(h.name || h.icon || m, h);
            if (y.threw) return {
                name: m,
                threw: !0
            };
            let b = y.value;
            return h.call("isString", b) && b.includes("{{") && (b = h.call("replaceLiteralsWithObjectFields", b)), {
                name: h.call("isString", b) ? b : m
            };
        }, d = t.src, p, g = ()=>{
            let h = u(t);
            if (h.threw && t.node && t.node.innerHTML) return;
            let m = h.name, y = m;
            if (m.includes(" ")) {
                let I = m.split(" ");
                m = I[0] + I.slice(1).map((M)=>M.charAt(0).toUpperCase() + M.slice(1)).join("");
            }
            let b = a(m), T = b.split(/([a-z])([A-Z])/g), v = f(y, n);
            if (v) {
                Object.assign(t, v);
                return;
            }
            let S, w = t[".isActive"];
            w && (w.name || w.icon) && t.isActive && (S = l(w.name || w.icon, t).value);
            let _ = o && o[".isActive"];
            _ && _.icon && o.isActive && (S = l(_.icon || _.Icon.name || _.Icon.icon, t).value), t.call("isString", S) && S.includes("{{") && (S = t.call("replaceLiteralsWithObjectFields", S));
            let x;
            r[S] && (x = S), r[b] ? x = b : r[T[0] + T[1]] ? x = T[0] + T[1] : r[T[0]] ? x = T[0] : i && t.warn("Can't find icon:", m, x);
            let A = r[x], O = o && o.src || d;
            !A && !O && (u7(n, y, b, t, (M)=>{
                if (!(p && p._disposed)) {
                    if (!M) return aF(y, t);
                    g();
                }
            }) || !1 || aF(y, t));
            let C = s && x, N = A || O || r.noIcon;
            if (!(t.spriteId === C && t.src === N && t.node && t.node.innerHTML)) {
                if (t.spriteId = C, t.src = N, typeof t.html == "function" && t.node) {
                    let I = t.context && t.context.designSystem;
                    I && pt(I);
                    try {
                        let M = t.html(t, t.state, t.context);
                        M != null && typeof M != "function" && (t.node.innerHTML = M);
                    } finally{
                        I && ut();
                    }
                }
                t.node && t.attr && t.attr.viewBox === LA && t.node.setAttribute("viewBox", LA(t));
            }
        };
        p = q(g, {
            depth: t.__ref && t.__ref.path && t.__ref.path.length || 0
        }), t.__ref && (t.__ref.__effects || (t.__ref.__effects = []), t.__ref.__effects.push(p));
    },
    attr: {
        viewBox: LA,
        "aria-hidden": (t)=>t.ariaLabel || t.role === "img" ? null : "true",
        focusable: "false"
    }
}, dF = {
    display: "flex",
    align: "center center",
    lineHeight: 1,
    ".reversed": {
        flow: "row-reverse"
    },
    ".vertical": {
        flow: "column"
    },
    Icon: {
        if: (t)=>{
            let { parent: e } = t, n = t.call("exec", t.icon, t);
            return t.call("exec", n || e.icon || t.name || t.sfSymbols || e.sfSymbols, t);
        },
        icon: (t)=>t.call("exec", t.parent.icon, t.parent)
    },
    text: (t)=>t.text
}, pF = {
    display: "flex",
    theme: "tertiary",
    boxSize: "C1",
    align: "center center",
    round: "Z2",
    Icon: {
        fontSize: "B",
        margin: "auto",
        icon: "document"
    }
};
var av = /*@__PURE__*/ F({}, {
    A: ()=>f$,
    Link: ()=>sv,
    RouteLink: ()=>u$,
    RouterLink: ()=>iv
});
var nl = /*@__PURE__*/ F({}, {
    default: ()=>lq,
    getActiveRoute: ()=>rv,
    lastLevel: ()=>Zy,
    lastPathname: ()=>el,
    loadLazy: ()=>XA,
    matchRoute: ()=>ev,
    parseQuery: ()=>nv,
    parseRoutePattern: ()=>Xy,
    resolveRouterElement: ()=>op,
    router: ()=>xn,
    runGuards: ()=>o$,
    saveScrollPosition: ()=>Jd
});
var IA = "__smblsRouter", MA = new WeakMap, m7 = 0, BA = ()=>Date.now().toString(36) + (++m7).toString(36) + Math.random().toString(36).slice(2, 6), NA = (t)=>{
    try {
        let e = t && t.history;
        if (e && typeof e.pushState == "function" && typeof e.replaceState == "function" && typeof e.go == "function") return e;
    } catch  {}
    return null;
}, rr = (t)=>{
    try {
        return t.state;
    } catch  {
        return;
    }
}, Qd = (t)=>{
    try {
        let { pathname: e, search: n, hash: o } = t.location;
        return e + n + o;
    } catch  {
        return null;
    }
}, yF = (t)=>{
    if (!t || typeof t != "object" || Array.isArray(t)) return !1;
    let e = Object.getPrototypeOf(t);
    return e === null || Object.getPrototypeOf(e) === null;
}, _F = (t)=>{
    let e = yF(t) ? t[IA] : null;
    return e && typeof e.key == "string" && typeof e.chain == "string" && Number.isInteger(e.index) ? e : null;
}, FA = (t, e)=>t == null ? {
        [IA]: e
    } : yF(t) ? {
        ...t,
        [IA]: e
    } : null, $A = ()=>({
        key: BA(),
        index: 0,
        chain: BA()
    }), Jc = (t, e)=>{
    let n = _F(e);
    return {
        key: n ? n.key : null,
        index: n ? n.index : null,
        chain: n ? n.chain : null,
        url: Qd(t),
        state: e
    };
}, bF = (t, e)=>{
    let n = _F(t);
    return e.key ? !!n && n.key === e.key : !n && t === e.state;
}, Zd = (t, e, n)=>!!n && Qd(t) === n.url && bF(e, n), jA = (t, e, n)=>({
        ...t,
        url: e,
        state: n
    }), UA = (t, e)=>{
    let n = rr(e), o = Jc(t, n);
    if (o.key) return o;
    let r = $A(), s = FA(n, r);
    if (!s) return o;
    try {
        e.replaceState(s, null);
    } catch  {
        return o;
    }
    return jA(r, o.url, s);
}, y7 = (t, e)=>{
    let n = MA.get(t);
    return !n && e && (n = {
        current: null,
        pending: null,
        expect: null,
        seq: 0,
        pops: new WeakMap,
        positions: null,
        scrollNode: null,
        restore: null
    }, MA.set(t, n)), n || null;
}, SF = "smbls.router.scroll", hF = 100, _7 = 1e3, gF = [
    "wheel",
    "touchstart",
    "keydown",
    "pointerdown"
], wF = (t)=>{
    try {
        return t.sessionStorage || null;
    } catch  {
        return null;
    }
}, xF = (t)=>{
    try {
        let e = JSON.parse(t.getItem(SF) || "[]");
        return Array.isArray(e) ? e.filter((n)=>Array.isArray(n) && typeof n[0] == "string") : [];
    } catch  {
        return [];
    }
}, kF = (t, e)=>{
    if (!t.positions) {
        t.positions = new Map;
        let n = wF(e);
        if (n) for (let [o, r] of xF(n))r && Number.isFinite(r.top) && Number.isFinite(r.left) && t.positions.set(o, {
            top: r.top,
            left: r.left
        });
    }
    return t.positions;
}, HA = (t, e, n, o)=>{
    let r = kF(t, e);
    r.delete(n), r.set(n, {
        top: Math.round(Number(o.scrollTop) || 0),
        left: Math.round(Number(o.scrollLeft) || 0)
    }), r.size > hF && r.delete(r.keys().next().value);
    let s = wF(e);
    if (s) try {
        let i = new Map(xF(s));
        for (let [a, c] of r)i.delete(a), i.set(a, c);
        s.setItem(SF, JSON.stringify(Array.from(i).slice(-hF)));
    } catch  {}
}, mF = (t, e, n)=>{
    (!e || e.visibilityState !== "hidden") && typeof t.requestAnimationFrame == "function" ? t.requestAnimationFrame(n) : typeof t.setTimeout == "function" ? t.setTimeout(n, 16) : setTimeout(n, 16);
}, b7 = (t, e, n, o, r, s, i)=>{
    n.restore && n.restore.end("replaced"), n.restore = o;
    let a = typeof i == "number" && i >= 0 ? i : _7, c = ()=>Math.max(0, (Number(r.scrollHeight) || 0) - (Number(r.clientHeight) || 0)), l = (h, m)=>{
        typeof r.scrollTo == "function" ? r.scrollTo({
            top: h,
            left: m,
            behavior: "instant"
        }) : (r.scrollTop = h, r.scrollLeft = m);
    }, f = typeof t.addEventListener == "function", u = ()=>o.end("visitor");
    if (o.end = (h)=>{
        if (!o.outcome && (o.outcome = h, f)) for (let m of gF)t.removeEventListener(m, u, !0);
    }, c() >= s.top - 1) return l(s.top, s.left), o.end("placed");
    Number(r.scrollTop) > 0 && l(0, 0);
    let d = Number(r.scrollTop) || 0, p = Date.now();
    if (f) for (let h of gF)t.addEventListener(h, u, {
        capture: !0,
        passive: !0
    });
    let g = ()=>{
        if (o.outcome) return;
        if (n.seq !== o.seq) return o.end("overtaken");
        if (Math.abs((Number(r.scrollTop) || 0) - d) > 1) return o.end("visitor");
        let h = c() >= s.top - 1;
        if (!h && Date.now() - p < a) return mF(t, e, g);
        l(Math.min(s.top, c()), s.left), o.end(h ? "placed" : "clamped");
    };
    mF(t, e, g);
}, S7 = (t, e)=>{
    let { win: n, history: o, track: r } = t, s = r.pops.get(e);
    if (s) return s;
    let i = Jc(n, rr(o)), a = r.expect;
    r.expect = null;
    let c;
    if (a && i.key === a.key && i.url === a.url) c = {
        echo: !0
    };
    else {
        let l = r.current, f = !!(i.key && l && l.key === i.key), u = f ? null : l;
        u && u.key && t.scrollNode && HA(r, n, u.key, t.scrollNode), c = {
            to: i,
            from: u,
            stay: f,
            seq: r.seq,
            settled: !1,
            committed: !1
        }, r.pending = c;
    }
    return r.pops.set(e, c), c;
}, w7 = (t)=>{
    let { win: e, history: n, track: o } = t, r = rr(n);
    if (o.pending && Zd(e, r, o.pending.to) || o.expect && Zd(e, r, o.expect.away)) return;
    let s = o.current;
    if (s && (s.key ? bF(r, s) : Zd(e, r, s))) {
        s.url = Qd(e), s.state = r;
        return;
    }
    o.current = t.restore ? UA(e, n) : Jc(e, r), o.pending = null, o.seq++;
}, TF = (t, e, n)=>{
    let o = e.scrollRestoration === "restore", r = NA(t), s = o || Array.isArray(e.guards) && e.guards.length > 0, i = r && y7(r, s);
    if (!i) return null;
    let a = {
        win: t,
        history: r,
        track: i,
        restore: o,
        scrollNode: o && n ? n : null,
        pop: null
    };
    a.scrollNode && (i.scrollNode = a.scrollNode);
    let c = e.event;
    return c && c.type === "popstate" ? a.pop = S7(a, c) : w7(a), a;
}, Ky = (t, e)=>{
    e.settled = !0, t.pending === e && (t.pending = null);
}, VA = (t)=>{
    let e = t && t.pop;
    if (!e || e.echo) return !0;
    if (e.settled) return e.committed;
    let { win: n, history: o, track: r } = t;
    return Ky(r, e), r.seq !== e.seq || !Zd(n, rr(o), e.to) ? !1 : (r.current = t.restore && !e.to.key ? UA(n, o) : e.to, r.seq++, e.committed = !0, !0);
}, EF = (t)=>{
    let e = t && t.pop;
    e && !e.echo && !e.settled && Ky(t.track, e);
}, x7 = (t, e, n)=>{
    try {
        t.addEventListener("popstate", ()=>{
            e.expect === n && (e.expect = null);
        }, {
            once: !0
        });
    } catch  {}
}, zA = (t, e)=>{
    let n = t && t.pop;
    if (!n || n.echo || n.settled) return;
    let { win: o, history: r, track: s } = t;
    Ky(s, n);
    let i = n.from;
    if (!i || s.seq !== n.seq || !Zd(o, rr(r), n.to)) return;
    let a = n.to;
    if (!e && i.key && a.key && i.chain === a.chain && i.index !== a.index) {
        let f = s.expect = {
            key: i.key,
            url: i.url,
            away: a
        };
        x7(o, s, f);
        try {
            r.go(i.index - a.index);
        } catch  {
            s.expect = null;
        }
        return;
    }
    let c = $A(), l = FA(i.state, c);
    try {
        r.replaceState(l || i.state, null, i.url);
    } catch  {
        return;
    }
    s.current = l ? jA(c, i.url, l) : Jc(o, rr(r)), s.seq++;
}, AF = (t, e)=>{
    let n = Qd(e);
    t && n !== null && (t.__routerAddress = n);
}, WA = (t, e, n)=>{
    let o = t && t.pop;
    if (o && !o.echo && o.from) return zA(t, !0);
    o && !o.settled && Ky(t.track, o);
    let r = NA(n), s = e && e.__routerAddress;
    if (!(!r || !s || s === Qd(n))) try {
        r.replaceState(rr(r), null, s);
    } catch  {}
}, vF = (t, e, n, o, r = t && t.win)=>{
    if (!t) {
        try {
            o ? r.history.replaceState(e, null, n) : r.history.pushState(e, null, n);
        } catch  {}
        return;
    }
    let { history: s, track: i } = t, a = i.current;
    !o && a && a.key && t.scrollNode && HA(i, r, a.key, t.scrollNode);
    let c = o ? Jc(r, rr(s)) : UA(r, s), l = c.key ? o ? {
        key: c.key,
        index: c.index,
        chain: c.chain
    } : {
        key: BA(),
        index: c.index + 1,
        chain: c.chain
    } : $A(), f = FA(e, l);
    try {
        o ? s.replaceState(f || e, null, n) : s.pushState(f || e, null, n);
    } catch  {
        return;
    }
    i.current = f ? jA(l, n, f) : Jc(r, rr(s)), i.pending = null, i.expect = null, i.seq++;
}, OF = (t, e, n, o)=>{
    if (!t || !t.restore || !e) return !1;
    let r = t.pop;
    if (r ? r.stay || !r.committed : !n.initialRender) return !1;
    let { win: s, track: i } = t, a = i.current, c = a && a.key && kF(i, s).get(a.key);
    if (!c) return !1;
    let l = i.restore;
    return !!l && l.key === a.key && (r ? l.pop === r : !l.pop && l.seq === i.seq) && l.outcome === "visitor" || b7(s, o, i, {
        key: a.key,
        pop: r,
        seq: i.seq,
        outcome: null
    }, e, c, n.scrollRestoreTimeout), !0;
}, Jd = (t)=>{
    let e = NA(t), n = e && MA.get(e);
    !n || !n.scrollNode || !n.current || !n.current.key || HA(n, t, n.current.key, n.scrollNode);
};
var LF = [
    "components",
    "functions",
    "methods",
    "snippets"
], PF = new Set([
    "pages",
    ...LF
]), KA = new Set([
    "default",
    "__esModule"
]), es = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), Vt = (t)=>!!t && typeof t == "object" && !Array.isArray(t), Gy = new WeakMap, CF = new WeakMap, GA = new WeakMap, RF = new Set, $i = (t, e = console.warn)=>{
    RF.has(t) || (RF.add(t), e(t));
}, IF = (t)=>Vt(t && t.lazy), MF = (t, e)=>{
    let n = t && t.lazy;
    return Vt(n) && es(n, e) ? n[e] : void 0;
}, tp = (t, e)=>{
    let n = MF(t, e);
    return Vt(n) && es(n, "load") ? n.load : n;
}, k7 = (t, e)=>{
    let n = MF(t, e);
    return Vt(n) && typeof n.when == "function" ? n.when : null;
}, T7 = (t)=>{
    let e = new Error(`[smbls/router] lazy group "${t}" waits: its \`when\` said false \u2014 nothing was requested`);
    return e.code = "LAZY_WAITING", e;
}, qA = (t, e)=>{
    let n = Gy.get(t);
    n || (Gy.set(t, n = new Map), t.__teardowns = t.__teardowns || [], t.__teardowns.push(()=>{
        for (let r of n.values())r.disposed = !0, r.waiting.clear();
        Gy.delete(t);
    }));
    let o = n.get(e);
    return o || (o = {
        status: "idle",
        attempts: 0,
        promise: null,
        failure: null,
        disposed: !1,
        pages: null,
        waiting: new Set,
        maps: new Set
    }, n.set(e, o)), o;
}, BF = (t, e)=>!IF(e) || !Vt(t) || !es(t, "lazy") ? null : typeof t.lazy == "string" && t.lazy ? t.lazy : null, Yy = (t)=>!!t && typeof t == "object" && GA.has(t), NF = (t, e)=>(t && t.lazy && typeof t.lazy == "object" && j("lazyRoutes", e), null), FF = (t)=>t && (t.status === "error" || t.status === "reload" || t.status === "waiting") ? t.status : "loading", E7 = (t, e)=>typeof tp(t, e) != "function" ? "error" : FF(Gy.get(t)?.get(e)), A7 = (t, e)=>{
    let n = CF.get(t);
    if (n && n.group === e) return n;
    let { lazy: o, state: r, ...s } = t, i = r == null || Vt(r) || typeof r == "function";
    i ? s.state = (c, l)=>{
        let f = typeof r == "function" ? r(c, l) : r;
        return {
            ...Vt(f) ? f : null,
            lazyStatus: E7(c.context, e)
        };
    } : s.state = r;
    let a = {
        definition: s,
        group: e,
        hasStatus: i
    };
    return CF.set(t, a), GA.set(s, a), a;
}, v7 = (t)=>t.__ref && t.__ref.contentElementKey || "content", tl = (t, e)=>{
    let n = t && t.__ref && t.__ref.__routerRendered, o = n && Yy(n.content) ? GA.get(n.content) : null;
    return !o || o.group !== e ? null : {
        record: o,
        page: t[v7(t)]
    };
}, qy = (t, e, n)=>{
    let o = tl(t, e);
    if (!o || !o.record.hasStatus) return;
    let r = o.page && o.page.state;
    if (!(!r || typeof r.update != "function" || r.lazyStatus === n)) try {
        r.update({
            lazyStatus: n
        });
    } catch (s) {
        console.error(`[smbls/router] lazy group "${e}": could not show the "${n}" status on its placeholder`, s);
    }
}, O7 = (t)=>Vt(t) ? !Object.keys(t).some((n)=>PF.has(n)) && Vt(t.default) ? t.default : t : {}, C7 = (t)=>{
    let e = {};
    if (!Vt(t)) return e;
    for (let n of Object.keys(t)){
        if (KA.has(n)) continue;
        let o = n.charCodeAt(0) === 47, r = o ? n : "/" + (n === "index" ? "" : n);
        (o || !es(e, r)) && (e[r] = t[n]);
    }
    return e;
}, $F = (t, e, n, o, r)=>{
    if (!Vt(t)) return 0;
    let s = 0;
    for (let i of Object.keys(t))BF(t[i], o) === e && (s++, es(n, i) ? t[i] = n[i] : delete t[i]);
    for (let i of Object.keys(n))es(t, i) ? t[i] !== n[i] && r.push(`pages['${i}']`) : t[i] = n[i];
    return s;
}, DF = (t, e, n)=>{
    let o = t[e];
    if (!Vt(o)) {
        t[e] = {
            ...n
        };
        return;
    }
    try {
        for(let r in n)o[r] = n[r];
        if (Object.keys(n).every((r)=>o[r] === n[r])) return;
    } catch  {}
    t[e] = {
        ...o,
        ...n
    };
}, R7 = (t)=>{
    let e = t.__ref && t.__ref.origin;
    if (!Vt(e)) return [];
    let n = [].concat(e.extends || [], e.extend || []);
    if (n.length) return n.filter((s)=>typeof s == "string").map((s)=>(s.includes(">") ? s.split(">")[0] : s).trim());
    let o = t.key;
    if (typeof o != "string" || !/^[A-Z]/.test(o)) return [];
    let r = [
        o.indexOf("_"),
        o.indexOf(".")
    ].filter((s)=>s > 0);
    return [
        r.length ? o.slice(0, Math.min(...r)) : o
    ];
}, D7 = (t, e, n, o)=>{
    let r = new Set;
    for (let i of o.waiting){
        let a = tl(i, e);
        a && a.page && r.add(a.page);
    }
    let s = (i)=>{
        let a = i && i.__ref && i.__ref.__children;
        if (Array.isArray(a)) for (let c of a){
            let l = i[c];
            if (!(!l || !l.__ref || r.has(l) || !l.node)) {
                for (let f of R7(l)){
                    if (!n.has(f)) continue;
                    let u = (l.__ref.path || [
                        l.key
                    ]).join(" \u203A ");
                    $i(`[smbls/router] lazy group "${e}": ${u} was built before the group loaded, so it renders without "${f}". A built element never takes a later registration \u2014 build it after el.call('loadLazy', '${e}') resolves (an \`if:\` gate does that), or keep "${f}" out of the group.`);
                }
                s(l);
            }
        }
    };
    s(t);
}, L7 = (t, e, n, o)=>{
    let r = t.context, s = O7(n), i = false, a = [], c = new Set;
    if (i) for (let p of Object.keys(s))PF.has(p) || KA.has(p) || $i(`[smbls/router] lazy group "${e}" exports \`${p}\`, which a lazy group cannot add \u2014 it adds pages, components, functions, methods and snippets only. Declare the rest with the app.`);
    let l = !1;
    for (let p of LF){
        let g = s[p];
        if (!Vt(g)) continue;
        let h = Vt(r[p]) ? r[p] : {}, m = {};
        for (let b of Object.keys(g))if (!KA.has(b)) {
            if (es(h, b)) {
                h[b] !== g[b] && a.push(`${p}.${b}`);
                continue;
            }
            m[b] = g[b];
        }
        let y = Object.keys(m);
        if (y.length && (DF(r, p, m), p === "components" && y.forEach((b)=>c.add(b)), p === "methods" && (l = !0), (p === "functions" || p === "snippets") && Vt(r.utils))) {
            let b = {};
            for (let T of y)es(r.utils, T) || (b[T] = m[T]);
            Object.keys(b).length && DF(r, "utils", b);
        }
    }
    l && Mc(r);
    let f = C7(s.pages);
    o.pages = f;
    let u = null;
    try {
        u = typeof t.getRoot == "function" ? t.getRoot() : null;
    } catch  {}
    let d = new Set;
    Vt(r.pages) && d.add(r.pages), u && Vt(u.routes) && d.add(u.routes);
    for (let p of o.maps)d.add(p);
    for (let p of o.waiting)Vt(p.routes) && d.add(p.routes);
    for (let p of d)$F(p, e, f, r, a);
    i && a.length && $i(`[smbls/router] lazy group "${e}" redefines ${a.join(", ")}, which the app already has \u2014 the app's own value stays. Rename them: frank refuses the same collision at \`smbls push\`.`), i && c.size && u && D7(u, e, c, o);
}, jF = (t, e)=>{
    let n = t && t.__ref, o = n && n.__lazyRoute;
    if (!o || o.group !== e || (n.__lazyRoute = null, typeof t.set != "function") || !tl(t, e)) return;
    let r = ()=>o.rerender({
            pushState: !1,
            replace: !1,
            scrollToTop: !1,
            guards: [],
            lazy: {
                group: e,
                status: "loaded"
            }
        }), s = ()=>{
        o.first && !tl(t, e) && UF(t.context, e);
    };
    Promise.resolve().then(r).then(s).catch((i)=>console.error(`[smbls/router] lazy group "${e}" loaded, but its route failed to render`, i));
}, ep = (t)=>!!t && (typeof t == "object" || typeof t == "function") && typeof t.then == "function", P7 = (t, e, n)=>!!t && (ep(e) && e === t.returned || !!n && typeof n == "object" && n === t.error), YA = (t, e)=>{
    let n = t.context, o = qA(n, e);
    if (o.status === "loading" || o.status === "loaded") return o.promise;
    let r = tp(n, e), s = k7(n, e), i = o.failure;
    o.status = "loading";
    let a, c = !1, l = !1, f = ()=>s ? s(t) : !0, u = (p)=>{
        if (p === !1) throw l = !0, T7(e);
        return a = r(o.attempts++);
    }, d = Promise.resolve().then(f).then(u).then((p)=>{
        c = !0, o.disposed || L7(t, e, p, o);
    }).then(()=>{
        o.status = "loaded", o.failure = null;
        let p = [
            ...o.waiting
        ];
        o.waiting.clear();
        for (let g of p)jF(g, e);
    }, (p)=>{
        if (l) {
            if (o.status = "waiting", o.promise = null, o.disposed) throw p;
            for (let h of [
                ...o.waiting
            ])tl(h, e) ? qy(h, e, "waiting") : o.waiting.delete(h);
            throw p;
        }
        let g = !c && P7(i, a, p);
        if (o.failure = c ? null : {
            returned: a,
            error: p
        }, o.status = g ? "reload" : "error", o.promise = null, o.disposed) throw p;
        g ? $i(`[smbls/router] lazy group "${e}" cannot load in this page: its loader handed back the import that already failed (the same promise or the same error) and requested nothing \u2014 a bundler that keeps a failed dynamic import (parcel) does this. Its routes show their placeholder with lazyStatus 'reload'; reloading the page loads the group.`, (h)=>console.error(h, p)) : console.error(`[smbls/router] lazy group "${e}" failed to load. Its routes show their placeholder with lazyStatus 'error'; the next navigation to one of them, or loadLazy('${e}'), calls the group's loader again.`, p);
        for (let h of [
            ...o.waiting
        ])tl(h, e) ? qy(h, e, o.status) : o.waiting.delete(h);
        throw p;
    });
    d.catch(()=>{}), o.promise = d;
    for (let p of o.waiting)qy(p, e, "loading");
    return d;
}, I7 = (t, e)=>{
    let n = t && t.lazyFirstView;
    return n === !0 || Array.isArray(n) && n.includes(e);
}, UF = (t, e)=>{
    t && (t.__lazyFirstViews || (t.__lazyFirstViews = new Set), t.__lazyFirstViews.add(e));
}, M7 = (t, e)=>{
    let n = t.context, o = ()=>(UF(n, e), !0), r = ()=>!1;
    return Promise.resolve(YA(t, e)).then(o, r);
}, HF = (t, e, n, o = null)=>{
    let r = e && e.context;
    let s = BF(t, r);
    if (!s) return null;
    let i = qA(r, s);
    if (Vt(n) && i.maps.add(n), i.status === "loaded" && $F(n, s, i.pages || {}, r, []) > 0) return {
        rematch: !0
    };
    let a = typeof tp(r, s) == "function";
    if (a && o && o.initialRender && !o.__lazyAwaited && I7(r, s)) return {
        wait: M7(e, s),
        group: s
    };
    let c = o && o.__lazyAwaited && (i.status === "error" || i.status === "reload" || i.status === "waiting");
    return a && !c ? YA(e, s) : $i(`[smbls/router] a route names lazy group "${s}", which context.lazy does not declare as a loader (\`lazy: { ${s}: () => import('./\u2026') }\`) \u2014 it shows its placeholder in the error state.`, console.error), {
        content: A7(t, s).definition,
        group: s,
        status: a ? "loading" : "error",
        first: !!(o && o.initialRender)
    };
}, VF = (t, e, n)=>{
    if (!e || !e.group || e.status === "error") return;
    let o = t.context, r = t.__ref;
    if (!r || typeof tp(o, e.group) != "function") return;
    let s = qA(o, e.group);
    if (r.__lazyRoute = {
        group: e.group,
        rerender: n,
        first: !!e.first
    }, qy(t, e.group, FF(s)), s.status === "loaded") {
        let i = ()=>jF(t, e.group);
        Promise.resolve().then(i);
        return;
    }
    s.waiting.add(t);
};
function XA(t) {
    let e = this, n = e && e.context;
    if (!n) return Promise.reject(new TypeError("[smbls/router] loadLazy runs on an element: el.call('loadLazy', name)"));
    let o = tp(n, t);
    return typeof o != "function" ? (o === void 0 && IF(n), Promise.resolve()) : YA(e, t);
}
var B7 = (t, e, n)=>({
        ...t.context && t.context.domqlOptions,
        ...e.mountOptions,
        contentElementKey: n
    }), zF = (t, e, n)=>{
    let o = n.mountOptions;
    if (!o) return;
    let r = e.context && e.context.domqlOptions;
    for(let s in o)t[s] = r && s in r ? r[s] : void 0;
}, ZF = (t)=>{
    let e = wo;
    return typeof e == "function" ? e(t.mountYield) > 0 : t.mountYield === !0;
}, N7 = (t)=>{
    let e = t && t.context && t.context.__hydration;
    return !!e && e.adopted > 0;
}, F7 = (t)=>{
    let e = Ly;
    return typeof e != "function" || !e(t) ? null : Gn(t);
}, tv = Object.freeze({
    holdTail: !0
}), $7 = (t)=>typeof t.holdPage == "function" && typeof Xe == "function", QF = (t, e)=>{
    let n = ()=>Xe(t);
    ep(e) ? e.then(n, n) : n();
}, j7 = (t, e)=>{
    let n = null;
    try {
        n = t.holdPage(e);
    } catch  {}
    QF(e, n);
}, JF = Object.freeze({
    holdTail: !0,
    deferAttach: !0
}), U7 = (t, e, n, o)=>{
    let r = t.firstView;
    if (!r || typeof Xe != "function" || typeof qr != "function") return null;
    if (!r.committed) return tv;
    if (!ZF(o)) return null;
    let s = e.node;
    return !e[n] && s && s.isConnected ? JF : (o.mountYield = void 0, null);
}, H7 = async ()=>{
    await ae();
    let t = Qr;
    if (typeof t == "function") for(; !t();)await ae();
}, V7 = (t, e, n, o)=>{
    if (e === tv) {
        t.firstView.page = n, QF(n, t.firstView.commit);
        return;
    }
    e === JF && H7().then(()=>{
        n.__ref && o() && qr(n), Xe(n);
    });
}, t$ = /^:(.+)/, e$ = /^\*$/, WF = new Map, Xy = (t)=>{
    let e = WF.get(t);
    if (e) return e;
    let n = t.replace(/^\//, "").split("/"), o = [], r = !1;
    for(let i = 0; i < n.length; i++){
        let a = n[i].match(t$);
        a ? o.push({
            index: i,
            name: a[1]
        }) : e$.test(n[i]) && (r = !0);
    }
    let s = {
        segments: n,
        params: o,
        hasWildcard: r,
        pattern: t
    };
    return WF.set(t, s), s;
}, ev = (t, e, n = 0)=>{
    let r = t.replace(/^\//, "").split("/").filter(Boolean).slice(n), s = "/" + (r[0] || "");
    if (!e) return {
        key: null,
        content: null,
        params: {},
        routePath: s
    };
    let i = null, a = -1, c = {};
    for(let l in e){
        if (l === "/*") continue;
        let f = Xy(l), u = z7(r, f);
        u > a && (a = u, i = l, c = n$(r, f));
    }
    return !i && e["/*"] && (i = "/*"), {
        key: i,
        content: i ? e[i] : null,
        params: c,
        routePath: s
    };
}, z7 = (t, e)=>{
    let { segments: n, hasWildcard: o } = e;
    if (!o && n.length !== t.length && n.length !== 1 && n.length > t.length) return -1;
    let r = 0, s = Math.min(n.length, t.length);
    for(let i = 0; i < s; i++)if (n[i] === t[i]) r += 3;
    else if (t$.test(n[i])) r += 1;
    else if (e$.test(n[i])) r += .5;
    else return -1;
    return r;
}, W7 = (t)=>{
    try {
        return decodeURIComponent(t);
    } catch  {
        return t;
    }
}, n$ = (t, e)=>{
    let n = {};
    for (let { index: o, name: r } of e.params)t[o] && (n[r] = W7(t[o]));
    return n;
}, nv = (t)=>{
    if (!t || t === "?") return {};
    let e = {};
    return new URLSearchParams(t).forEach((o, r)=>{
        e[r] !== void 0 ? (Array.isArray(e[r]) || (e[r] = [
            e[r]
        ]), e[r].push(o)) : e[r] = o;
    }), e;
}, QA = (t)=>!!t && typeof t == "object" && typeof t.route == "string", KF = (t)=>t === !1 || typeof t == "string" || QA(t) ? t : void 0, K7 = 10, ov = (t, e, n = 0)=>{
    for(let o = n; o < t.length; o++){
        let r = t[o](e);
        if (ep(r)) return Promise.resolve(r).then((i)=>{
            let a = KF(i);
            return a === void 0 ? ov(t, e, o + 1) : a;
        });
        let s = KF(r);
        if (s !== void 0) return s;
    }
    return !0;
}, o$ = async (t, e)=>!t || !t.length ? !0 : ov(t, e), GF = (t, e, n, o)=>{
    if (typeof t != "string" || !n || !Object.prototype.hasOwnProperty.call(n, t)) return null;
    let r = n[t];
    if (!r) return null;
    let s = e.replace(/^\//, "").split("/").filter(Boolean).slice(o || 0);
    return {
        route: t,
        content: r,
        params: t === "/*" ? {} : n$(s, Xy(t))
    };
}, G7 = (t, e)=>{
    let n = nu;
    return typeof n == "function" ? n(t, e) : t === e;
}, JA = (t)=>k(t) && E(t.extends) && Object.keys(t).every((e)=>e === "extends" || e === "metadata" || e === "helmet") ? t.extends : t, r$ = (t, e, n = 0)=>[].concat(t.extends || [], t.extend || []).reduce((o, r)=>{
        let s = E(r) ? e && e[r] : r;
        if (!s || typeof s != "object" || n > 7) return o;
        let i = s.metadata !== void 0 ? s.metadata : r$(s, e, n + 1);
        return i !== void 0 ? i : o;
    }, void 0), q7 = (t, e)=>JA(t) !== t || t.metadata === void 0 || k(t.metadata) && k(r$(t, e && e.context && e.context.components)), s$ = (t, e)=>{
    let n = Mo;
    if (typeof n == "function") return n(t, e && e.context && e.context.components);
}, Y7 = (t, e, n)=>{
    if (!e || typeof e != "object" || e.metadata === void 0 && e.helmet === void 0) return t;
    let o = s$(e, n);
    return o !== void 0 && o !== e.metadata && (t.metadata = o), t;
}, X7 = (t, e)=>{
    !t || typeof t != "object" || !t.__ref || Cn("routeHead", t, s$(e, t), e);
}, op = (t, e)=>{
    if (!e) return t;
    let n = Array.isArray(e) ? e : e.split("."), o = t;
    for (let r of n){
        if (!o || !o[r]) return null;
        o = o[r];
    }
    return o;
}, Z7 = (t, e)=>{
    let n = e.customRouterElement;
    if (!n || !t.__ref || t.__ref.root !== t) return t;
    let o = op(t, n);
    return !o || o === t ? t : (t.routes && (o.routes = t.routes), o);
}, rv = (t = 0, e)=>{
    e || (e = typeof R < "u" ? R.location.pathname : "/");
    let o = e.split("/")[t + 1];
    if (o) return `/${o}`;
}, el, Zy = 0, qF = 0, ZA = (t)=>!t || t === "srcdoc" || t === "about:srcdoc" ? "/" : t, Q7 = (t)=>t && (t.scrollingElement || t.documentElement) || null, i$ = {
    level: Zy,
    pushState: !0,
    replace: !1,
    initialRender: !1,
    scrollToTop: !0,
    scrollToNode: !1,
    scrollBody: !1,
    useFragment: !1,
    updateState: !0,
    scrollToOffset: 0,
    contentElementKey: "content",
    scrollToOptions: {
        behavior: "smooth"
    },
    useParamsMatching: !0,
    exitTimeout: 300,
    scrollRestoreTimeout: 1e3
}, a$ = (t, e)=>{
    if (!t || t.visibilityState !== "visible") return !1;
    try {
        let n = e && typeof e.matchMedia == "function" && e.matchMedia("(prefers-reduced-motion: reduce)");
        if (n && n.matches) return !1;
    } catch  {}
    return !0;
}, c$ = (t)=>{
    let e = t.__routeExit;
    e && (t.__routeExit = null, e.abort());
}, J7 = (t, e, n, o, r, s, i)=>{
    let a = e.__routeExit;
    if (a && a.page === n) return a.wait;
    if (c$(e), !n || !n.node || typeof t.onRouteExit > "u" || !a$(s, i)) return null;
    let c = typeof r == "number" && r >= 0 ? r : i$.exitTimeout, l = typeof AbortController == "function" ? new AbortController : null, f = {
        ...o,
        page: n,
        timeout: c,
        signal: l ? l.signal : void 0
    }, u;
    try {
        u = Io("routeExit", t, f);
    } catch  {
        return null;
    }
    if (!u || typeof u.then != "function") return null;
    let d = {
        page: n,
        abort: ()=>{
            l && !l.signal.aborted && l.abort();
        }
    };
    return d.wait = new Promise((p)=>{
        let g = setTimeout(()=>{
            d.abort(), p();
        }, c), h = ()=>{
            clearTimeout(g), p();
        };
        u.then(h, h);
    }), e.__routeExit = d, d.wait;
}, np = new WeakMap, tq = (t)=>t === !0 ? {} : t && typeof t == "object" && !Array.isArray(t) ? t : null, eq = (t, e, n, o)=>{
    let r = tq(t.transition);
    return !r || !e || Yy(e.content) || !n || typeof n.startViewTransition != "function" || np.get(n) > 0 || !a$(n, o) ? null : r;
}, nq = (t)=>{
    let e = t.__routeTransition;
    if (!(!e || e.updating)) try {
        e.transition.skipTransition();
    } catch  {}
}, oq = (t)=>{
    let e = typeof t.types == "string" ? [
        t.types
    ] : t.types;
    return Array.isArray(e) ? e.filter((n)=>typeof n == "string" && n) : [];
}, rq = (t)=>{
    try {
        let e = t && t.ViewTransition;
        return !!e && "types" in e.prototype;
    } catch  {
        return !1;
    }
}, sq = 100, iq = 1e3, YF = (t, e)=>t === !1 ? 1 / 0 : typeof t == "number" && t >= 0 ? t : e, XF = (t)=>{
    let e = t && t.performance;
    return e && typeof e.now == "function" ? e.now() : Date.now();
}, aq = (t)=>{
    t && typeof t.then == "function" && t.then(null, ()=>{});
}, cq = (t, e, n, o, r, s, i)=>{
    let a = t.node, c = a && a.style, l = typeof n.name == "string" && n.name ? n.name : null, f = e.__routeTransition, u = {
        transition: null,
        updating: !1,
        name: l,
        previousName: f && f.name && c ? f.previousName : c && c.viewTransitionName || ""
    }, d = ()=>{
        if (e.__routerNavSeq === s) {
            u.updating = !0, u.swapStarted = XF(r), np.set(o, (np.get(o) || 0) + 1);
            try {
                return i();
            } finally{
                np.set(o, np.get(o) - 1), u.updating = !1;
            }
        }
    }, p = ()=>{
        l && c && c.viewTransitionName === l && (c.viewTransitionName = u.previousName);
    };
    l && c && (c.viewTransitionName = l);
    let g = oq(n), h = null;
    try {
        h = g.length && rq(r) ? o.startViewTransition({
            update: d,
            types: g
        }) : o.startViewTransition(d);
    } catch  {}
    if (!h) return p(), null;
    u.transition = h, e.__routeTransition = u, aq(h.ready);
    let m = !1, y = null, b = ()=>{
        m = !0, y !== null && (r.clearTimeout(y), y = null), e.__routeTransition === u && (e.__routeTransition = null, p());
    }, T = ()=>{
        if (!(m || e.__routeTransition !== u)) try {
            h.skipTransition();
        } catch  {}
    };
    h.finished && typeof h.finished.then == "function" ? h.finished.then(b, b) : b();
    let v = YF(n.swapBudget, sq), S = YF(n.timeout, iq);
    S !== 1 / 0 && h.ready && typeof h.ready.then == "function" && r && typeof r.setTimeout == "function" && h.ready.then(()=>{
        m || (y = r.setTimeout(()=>{
            y = null, T();
        }, S));
    }, ()=>{});
    let w = h.updateCallbackDone;
    return !w || typeof w.then != "function" ? Promise.resolve() : (v !== 1 / 0 && w.then(()=>{
        u.swapStarted !== void 0 && XF(r) - u.swapStarted > v && T();
    }, ()=>{}), w);
}, xn = async (t, e, n = {}, o = {})=>{
    let r = e || void 0, s = r?.context?.window || R, i = r?.context?.document || wt, a = {
        ...i$,
        ...r.context.routerOptions,
        ...o
    };
    Zy = a.lastLevel, r = Z7(r, a);
    let c = !(o && o.render === !1), l = r.__ref;
    (a.contentElementKey !== "content" && a.contentElementKey !== l.contentElementKey || !l.contentElementKey) && (l.contentElementKey = a.contentElementKey || "content");
    let f = l.contentElementKey || a.contentElementKey || "content", u = s.location.origin !== "null" ? s.location.origin : "http://localhost";
    t = ZA(t);
    let d = typeof s.URL == "function" ? s.URL : typeof globalThis < "u" && globalThis.URL || URL, p = new d(u + t), { pathname: g, search: h, hash: m } = p, y = nv(h), b = r.node, T = m && m !== s.location.hash.slice(1), v = g !== el, S = el, w = ++qF;
    el = g;
    let _ = ()=>{
        qF === w && (el = S);
    }, x = l.__routerRendered, A, O, C, N;
    if (a.useParamsMatching) {
        let X = ev(g, r.routes, a.level);
        A = X.key, O = X.routePath, C = X.content, N = X.params;
    } else {
        A = rv(a.level, g), O = A;
        let X = r.routes;
        C = X ? X[A || "/"] || X["/*"] : null, N = {};
    }
    if (o && o.route != null) {
        let X = GF(o.route, g, r.routes, a.level);
        !X && a.silent, A = X ? X.route : o.route, C = X ? X.content : null, N = X ? X.params : {};
    }
    a.scrollNode === void 0 && (a.scrollNode = Q7(i));
    let I = a.scrollToNode ? b : a.scrollNode;
    if (r.state?.root?.debugging) {
        r.state.root.debugging = !1;
        return;
    }
    let M = TF(s, a, I);
    if (M && M.pop && M.pop.echo) return;
    if (!C) {
        _(), a.onNotFound ? a.onNotFound({
            pathname: g,
            route: A,
            element: r
        }) : (a.silent || console.warn("[smbls/router] no content matched for path", g, "\u2014 available routes:", Object.keys(r.routes || {})), a.event && a.event.type === "popstate" && WA(M, l, s));
        return;
    }
    let K = o && o.lazy ? l.__routerStartSeq : l.__routerStartSeq = (l.__routerStartSeq || 0) + 1;
    if (a.guards && a.guards.length) {
        let X = {
            pathname: g,
            route: A,
            params: N,
            query: y,
            hash: m,
            element: r,
            state: n
        }, U = ov(a.guards, X);
        if (ep(U) && (U = await U, l.__routerStartSeq !== K)) {
            _(), EF(M);
            return;
        }
        if (U === !1) {
            _(), zA(M);
            return;
        }
        let Rt = (Tt)=>{
            let Yt = new d(u + ZA(Tt));
            return Yt.pathname === g && Yt.search === h && Yt.hash === m;
        }, gt = typeof U == "string" ? U : QA(U) && typeof U.path == "string" && !Rt(U.path) ? U.path : null;
        if (QA(U) && gt === null) {
            let Tt = GF(U.route, g, r.routes, a.level);
            if (!Tt) {
                a.silent, _(), a.onNotFound ? a.onNotFound({
                    pathname: g,
                    route: U.route,
                    element: r
                }) : a.event && a.event.type === "popstate" && WA(M, l, s);
                return;
            }
            A = Tt.route, C = Tt.content, N = Tt.params, o = {
                ...o,
                route: Tt.route
            };
        } else if (gt !== null) {
            let Tt = !!(M && M.pop);
            if (Tt && !VA(M)) return;
            let Yt = [
                ...o && o.__redirectChain || [],
                g
            ], Ot = new d(u + ZA(gt)).pathname, Ze = Yt.includes(Ot) || Yt.length >= K7;
            Ze && a.silent;
            let Et = {
                ...o,
                __redirectChain: Yt
            };
            return Ze && (Et.guards = []), typeof U == "string" ? delete Et.route : Et.route = U.route, Tt && (Et.event = void 0), delete Et.render, (Tt || a.initialRender) && (Et.pushState = !0, Et.replace = !0), xn(gt, e, n, Et);
        }
    }
    let V = c ? HF(C, r, r.routes, a) : null;
    if (V && V.rematch) return xn(t, r, n, o);
    if (V && V.wait) {
        let X = l.__routerNavSeq;
        return await V.wait, l.__routerNavSeq !== X || typeof r?.set != "function" ? void 0 : xn(t, r, n, {
            ...o,
            guards: [],
            __lazyAwaited: !0
        });
    }
    V && (C = V.content, a.lazy = {
        group: V.group,
        status: V.status
    });
    let J = l.__routerNavSeq = (l.__routerNavSeq || 0) + 1, ht = !x || x.content !== C || x.route !== A, nt = !!x && G7(x.content, C), Y = !(!c || a.keepSamePage === !0 && nt && a.force !== !0) && (v || ht || a.force === !0);
    if (Y && x && !Yy(x.content)) {
        let X = J7(r, l, r[f], {
            from: x.route,
            to: A,
            pathname: g,
            params: N,
            query: y,
            hash: m
        }, a.exitTimeout, i, s);
        if (X && (await X, l.__routerNavSeq !== J || (l.__routeExit && l.__routeExit.wait === X && (l.__routeExit = null), typeof r?.set != "function"))) return;
    } else c$(l);
    let G = Y ? eq(a, x, i, s) : null;
    if (Y && nq(l), a.pushState) {
        let X = g + (h || "") + (m || "");
        vF(M, n, X, a.replace, s);
    } else M && VA(M);
    AF(l, s);
    let st = B7(r, a, f), ot = ()=>{
        let X = Y ? U7(a, r, f, st) : null, U = (!!x || ZF(st)) && !!I && I.scrollTop === 0 && !I.scrollLeft, Rt = !x && !!a.initialRender && !!I && N7(r) && (Number(I.scrollTop) > 0 || Number(I.scrollLeft) > 0), Tt = v || !T ? {
            route: A,
            routePath: O,
            hash: m,
            params: N,
            query: y,
            debugging: !1
        } : {
            params: N,
            query: y
        };
        a.updateState && r.state.update(Tt, {
            preventContentUpdate: !0
        });
        let Yt = null;
        if (Y) {
            f && a.removeOldElement && r[f].remove();
            let Ze = r.__ref?.origin?.content, Et = {};
            if (Ze) for(let At in Ze){
                let $t = Ze[At];
                At === "__ref" || At === "props" || At === "node" || At === "parent" || At === "key" || (typeof $t == "string" || typeof $t == "number" || typeof $t == "boolean" || typeof $t == "object" && $t !== null && !$t.node && !$t.__ref) && (Et[At] = $t);
            }
            let Qe = Y7({
                ...Et,
                ...typeof C == "object" ? C : {
                    extends: C
                }
            }, C, r);
            a.useFragment && (Qe.tag = "fragment");
            let lr = {
                content: C,
                route: A
            }, xl = l.__routerRendered;
            try {
                if (typeof r?.set != "function") return;
                l.__routerRendered = lr;
                let At = !X && $7(a), $t = r.set(Qe, st, X || (At ? tv : void 0));
                $t && X ? V7(a, X, $t, ()=>l.__routerNavSeq === J) : $t && At && j7(a, $t), Yt = F7(r[f]);
            } catch (At) {
                l.__routerRendered === lr && (l.__routerRendered = xl), console.error("[smbls/router] failed to render route content", g, At);
                try {
                    Cn("renderError", r, {
                        where: "route",
                        route: g,
                        error: At
                    });
                } catch ($t) {
                    console.error("[smbls/router] renderError hook threw:", $t);
                }
            }
        } else nt && x.route !== A && l.__routerRendered === x && (l.__routerRendered = {
            content: C,
            route: A
        }, C !== x.content && X7(r[f], C));
        let Ot = ()=>{
            let Ze = !v && T, Et = !c || OF(M, I, a, i);
            if (!Et && !Rt && a.scrollToTop && !Ze && !U && I?.scrollTo && I.scrollTo({
                ...a.scrollToOptions || {},
                top: 0,
                left: 0
            }), !Et && !Rt && a.scrollToNode && C[f]?.node?.scrollTo && C[f].node.scrollTo({
                ...a.scrollToOptions || {},
                top: 0,
                left: 0
            }), !Et && m) {
                let Qe = i.getElementById(m.slice(1));
                if (Qe && I?.scrollTo) {
                    let lr = s.getComputedStyle ? s.getComputedStyle(Qe) : null, xl = lr && parseFloat(lr.scrollMarginTop) || 0, At = Qe.getBoundingClientRect().top + I.scrollTop - xl - (a.scrollToOffset || 0);
                    I.scrollTo({
                        ...a.scrollToOptions || {},
                        top: At,
                        left: 0
                    });
                }
            }
            V && VF(r, V, (Qe)=>xn(t, r, n, {
                    ...o,
                    ...Qe
                })), Io("routeChanged", r, a);
        };
        if (Yt) return Yt.then(()=>{
            zF(st, r, a), l.__routerNavSeq === J && Ot();
        });
        zF(st, r, a), Ot();
    }, dt = G ? cq(r, l, G, i, s, J, ot) : null;
    if (dt) {
        await dt;
        return;
    }
    return ot();
}, lq = xn;
var fq = (t, e)=>{
    if (!t) return !1;
    if (t.defaultPrevented || typeof t.button == "number" && t.button !== 0 || t.metaKey || t.ctrlKey || t.shiftKey || t.altKey) return !0;
    let n = e.node;
    if (!n || typeof n.getAttribute != "function") return !1;
    let o = n.getAttribute("target");
    return o && o.toLowerCase() !== "_self" ? !0 : n.hasAttribute("download");
}, uq = (t, e)=>{
    let n = t.slice(1), o = e.node && e.node.ownerDocument, r = n && o ? o.getElementById(n) : null;
    r && (typeof r.scrollIntoView == "function" && r.scrollIntoView(), typeof r.focus == "function" && (r.hasAttribute("tabindex") || r.setAttribute("tabindex", "-1"), r.focus()));
}, l$ = (t, e, n)=>{
    let { context: o } = e, { href: r, scrollToTop: s, stopPropagation: i } = e, a = e.call("exec", r, e);
    if (e.call("isString", a) && a.includes("{{") && (a = e.call("replaceLiteralsWithObjectFields", a)), i && t.stopPropagation(), !a || fq(t, e)) return;
    if (a.startsWith("#")) {
        t.preventDefault(), uq(a, e);
        return;
    }
    let { utils: c, snippets: l, functions: f, routerOptions: u } = o, d = e.__ref.root, p = a.startsWith("http://") || a.startsWith("https://") || a.startsWith("mailto:") || a.startsWith("tel:") || a.startsWith("sketch:") || a.startsWith("whatsapp:") || a.startsWith("sms:") || a.startsWith("skype:") || a.startsWith("viber:") || a.startsWith("callto:") || a.startsWith("facetime:") || a.startsWith("facetime-audio:") || a.startsWith("geo:") || a.startsWith("maps:");
    if (a && !p) {
        t.preventDefault();
        try {
            let g = d;
            if (u && u.customRouterElement) {
                let h = Array.isArray(u.customRouterElement) ? u.customRouterElement : u.customRouterElement.split("."), m = d;
                for (let y of h){
                    if (!m || !m[y]) {
                        m = null;
                        break;
                    }
                    m = m[y];
                }
                m && (g = m, d.routes && (g.routes = d.routes));
            }
            (f.router || l.router || c.router || xn)(a, g, {}, {
                scrollToOptions: {
                    behavior: "instant"
                },
                scrollToTop: e.call("isDefined", s) ? s : !0,
                ...u,
                ...e.routerOptions
            });
        } catch (g) {
            console.warn(g);
        }
    }
}, sv = {
    extends: "Focusable",
    tag: "a",
    aria: {},
    fontWeight: "bold",
    textDecoration: "none",
    color: "currentColor",
    draggable: !1,
    attr: {
        href: (t)=>ly(t, Vr(t, t.href) || Vr(t, t.call("exec", t, t).href)),
        "aria-label": (t)=>t.aria ? t.aria.label : t.text
    },
    onClick: l$
}, f$ = {
    extends: "Link"
}, iv = {
    onClick: l$
}, u$ = {
    extends: [
        sv,
        iv
    ]
};
var cv = /*@__PURE__*/ F({}, {
    Select: ()=>d$
});
var d$ = {
    extends: "Focusable",
    tag: "select",
    fontSize: "A",
    border: "none",
    boxSizing: "border-box",
    theme: "field",
    cursor: "pointer",
    childProps: {
        tag: "option",
        attr: {
            value: (t)=>t.value,
            selected: (t)=>t.selected,
            disabled: (t)=>t.disabled
        }
    },
    attr: {
        name: (t)=>t.name,
        disabled: (t)=>t.disabled,
        value: (t)=>{
            if (!t.value) return;
            let e = t.call("exec", t.value, t);
            return t.call("isString", e) && e.includes("{{") ? t.call("replaceLiteralsWithObjectFields", e) : e;
        }
    }
};
var lv = /*@__PURE__*/ F({}, {
    Button: ()=>p$,
    ButtonSet: ()=>y$,
    CircleButton: ()=>g$,
    IconButton: ()=>_$,
    KangorooButton: ()=>m$,
    SquareButton: ()=>h$
});
var p$ = {
    extends: [
        "IconText",
        "FocusableComponent"
    ],
    tag: "button",
    minHeight: "controlH",
    fontSize: "Z2",
    type: "button",
    border: "none",
    display: "inline-flex",
    align: "center center",
    textDecoration: "none",
    lineHeight: "1",
    whiteSpace: "nowrap",
    padding: "0 A",
    fontWeight: "700",
    fontFamily: "inherit",
    round: "radiusPill",
    disabled: (t)=>t.call("exec", t.disabled)
}, h$ = {
    extends: "Button",
    fontSize: "A",
    width: "A",
    minHeight: "auto",
    padding: "Z",
    aspectRatio: "1 / 1",
    boxSize: "fit-content fit-content",
    justifyContent: "center",
    round: "Z2",
    boxSizing: "content-box"
}, g$ = {
    extends: "SquareButton",
    round: "C"
}, m$ = {
    extends: "Button",
    childExtends: "IconText"
}, y$ = {
    tag: "nav",
    display: "flex",
    childExtends: "SquareButton"
}, _$ = {
    extends: [
        "SquareButton",
        "ClickableItem"
    ],
    round: "Z"
};
var uv = /*@__PURE__*/ F({}, {
    Dialog: ()=>E$,
    DialogFooter: ()=>v$,
    DialogHeader: ()=>A$
});
var dq = (t)=>{
    for(let e in t)Object.freeze(t[e]);
    return Object.freeze(t);
}, rp = dq({
    en: {
        "dialog.title": "Title",
        "dialog.close": "Close",
        "dialog.cancel": "Cancel",
        "dialog.ok": "OK",
        "dialog.confirm": "Confirm",
        "dialog.confirmTitle": "Are you sure?",
        "dialog.confirmMessage": "This action cannot be undone.",
        "dialog.alertTitle": "Notice",
        "dialog.promptTitle": "Enter a value"
    },
    ka: {
        "dialog.title": "\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8",
        "dialog.close": "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0",
        "dialog.cancel": "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0",
        "dialog.ok": "\u10D9\u10D0\u10E0\u10D2\u10D8",
        "dialog.confirm": "\u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0",
        "dialog.confirmTitle": "\u10D3\u10D0\u10E0\u10EC\u10DB\u10E3\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D7?",
        "dialog.confirmMessage": "\u10D0\u10DB \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0.",
        "dialog.alertTitle": "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0",
        "dialog.promptTitle": "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"
    }
}), b$ = (t, e)=>typeof t == "string" && t !== "" && t !== e, S$ = [
    "methods",
    "functions",
    "utils"
], w$ = (t, e)=>{
    let n = t && t.context;
    if (!n) return !1;
    for(let o = 0; o < S$.length; o++){
        let r = n[S$[o]];
        if (r && typeof r[e] == "function") return !0;
    }
    return !1;
}, pq = (t, e)=>typeof t == "string" && Object.prototype.hasOwnProperty.call(rp, t) ? rp[t][e] : void 0;
function ce(t, e) {
    if (w$(t, "polyglot")) {
        let r = t.call("polyglot", e);
        if (b$(r, e)) return r;
    }
    let n = w$(t, "getActiveLang") ? t.call("getActiveLang") : void 0, o = pq(n, e);
    return b$(o, e) ? o : rp.en[e] || "";
}
var hq = {
    ok: 1,
    cancel: 1
}, ji = new WeakMap, gq = 0, kn = (t)=>{
    let e = t && t.node;
    return e && e.nodeType === 1 ? e : null;
}, fv = (t)=>{
    let e = ji.get(t);
    return e || (e = {
        id: "smbls-dialog-" + ++gq,
        want: void 0,
        waiting: !1
    }, ji.set(t, e)), e;
}, sp = (t, e, n, o)=>t[e] !== void 0 || n !== void 0 && t[n] !== void 0 || !!t.attr && typeof t.attr == "object" && t.attr[e] !== void 0 || o !== void 0 && !!t.aria && typeof t.aria == "object" && t.aria[o] !== void 0, ol = (t, e, n)=>{
    n === null ? t.removeAttribute(e) : t.setAttribute(e, n);
}, x$ = (t)=>{
    let e = ji.get(t), n = kn(t);
    if (!e || !n) return !0;
    if (!n.isConnected) return !1;
    if (e.want) {
        if (!n.open && typeof n.showModal == "function") try {
            n.showModal();
        } catch  {}
    } else n.open && typeof n.close == "function" && n.close();
    return !0;
}, k$ = (t)=>{
    queueMicrotask(()=>{
        if (x$(t)) return;
        let e = ji.get(t);
        !e || e.waiting || typeof t.whenConnected != "function" || (e.waiting = !0, t.whenConnected(()=>{
            e.waiting = !1, x$(t);
        }));
    });
}, mq = (t)=>{
    let e = t.__ref;
    if (!e || !kn(t) || !Object.prototype.hasOwnProperty.call(t, "modal") || sp(t, "data-dialog")) return;
    let n = q(()=>{
        let o = t.modal, r = kn(t);
        if (!r) return;
        if (o == null) {
            ol(r, "data-dialog", null);
            return;
        }
        ol(r, "data-dialog", "modal");
        let s = fv(t), i = !!o;
        s.want !== i && (s.want = i, k$(t));
    }, {
        depth: e.path && e.path.length || 0
    });
    e.__effects || (e.__effects = []), e.__effects.push(n);
}, yq = (t)=>t.dialogTitle === !0, _q = (t)=>{
    for(let e = t; e; e = e.parent)if (e.tag === "dialog") return e;
    return null;
}, T$ = (t)=>{
    let e = _q(t);
    return !e || !e.locked;
}, bq = (t)=>t.key === "Escape" || t.key === "Esc", Sq = (t)=>{
    let e = t.__ref, n = kn(t);
    if (!e || !n || !Object.prototype.hasOwnProperty.call(t, "locked")) return;
    let o = fv(t), r = !sp(t, "closedby", "closedBy"), s = q(()=>{
        let l = !!t.locked, f = kn(t);
        f && r && ol(f, "closedby", l ? "none" : null);
    }, {
        depth: e.path && e.path.length || 0
    });
    e.__effects || (e.__effects = []), e.__effects.push(s);
    let i = (l)=>{
        t.locked && l.preventDefault();
    }, a = t.context && t.context.window || n.ownerDocument.defaultView, c = (l)=>{
        let f = kn(t);
        f && f.open && f.isConnected && bq(l) && t.locked && l.preventDefault();
    };
    n.addEventListener("cancel", i), a && a.addEventListener("keydown", c), o.unlock = ()=>{
        n.removeEventListener("cancel", i), a && a.removeEventListener("keydown", c);
    };
}, wq = (t)=>{
    let e = kn(t);
    if (!e || e.hasAttribute("aria-labelledby") || e.hasAttribute("aria-label") || sp(t, "aria-labelledby", "ariaLabelledby", "labelledby")) return;
    let n = typeof t.lookdown == "function" ? t.lookdown(yq) : null, o = kn(n);
    if (!o) return;
    let r = o.getAttribute("id");
    if (!r) {
        if (sp(n, "id")) return;
        r = fv(t).id + "-title", ol(o, "id", r);
    }
    ol(e, "aria-labelledby", r);
}, xq = (t, e)=>{
    let n = kn(e), o = t.target;
    if (!n || t.defaultPrevented || !o || typeof o.closest != "function") return;
    let r = o.closest("[data-dialog-action]");
    if (!r || !n.contains(r)) return;
    let s = r.getAttribute("data-dialog-action");
    if (hq[s] !== 1) return;
    let i = n.ownerDocument.defaultView, a = new i.Event(s, {
        cancelable: !0
    });
    n.dispatchEvent(a), !a.defaultPrevented && n.open && typeof n.close == "function" && n.close(s);
}, kq = (t)=>{
    let e = ji.get(t);
    e && e.unlock && (e.unlock(), e.unlock = null);
    let n = kn(t);
    e && e.want !== void 0 && n && n.open && typeof n.close == "function" && n.close();
}, Tq = (t)=>{
    let e = ji.get(t), n = kn(t);
    e && e.want !== void 0 && n && !n.isConnected && n.hasAttribute("open") && n.removeAttribute("open");
}, Eq = (t)=>{
    let e = ji.get(t);
    e && e.want && k$(t);
}, Aq = (t)=>{
    let e = kn(t);
    if (!e || !Object.prototype.hasOwnProperty.call(t, "modal") || sp(t, "data-dialog")) return;
    let n = t.modal;
    if (typeof n == "function") try {
        n = n(t, t.state);
    } catch  {
        return;
    }
    n != null && ol(e, "data-dialog", "modal");
}, E$ = {
    display: "flex",
    tag: "dialog",
    flow: "column",
    border: "0",
    theme: "dialog",
    round: "Z2",
    '[data-dialog="modal"]:not([open])': {
        display: "none"
    },
    onAttachNode: {
        always: !0,
        handler: (t)=>Aq(t)
    },
    onComplete: {
        always: !0,
        handler: (t)=>{
            mq(t), Sq(t), wq(t);
        }
    },
    onRender: {
        always: !0,
        handler: (t)=>Eq(t)
    },
    onClick: (t, e)=>xq(t, e),
    onBeforeRemove: {
        always: !0,
        handler: (t)=>kq(t)
    },
    onRemove: {
        always: !0,
        handler: (t)=>Tq(t)
    }
}, A$ = {
    extends: "Hgroup",
    minWidth: "100%",
    gap: "A",
    Title: {
        align: "center space-between",
        Text: {
            dialogTitle: !0,
            text: (t)=>ce(t, "dialog.title")
        },
        SquareButton: {
            if: T$,
            icon: "x",
            theme: "transparent",
            aria: {
                label: (t)=>ce(t, "dialog.close")
            },
            data: {
                dialogAction: "cancel"
            }
        }
    },
    Paragraph: {
        color: "caption"
    }
}, v$ = {
    display: "flex",
    align: "center flex-end",
    gap: "X2",
    margin: "auto - -",
    padding: "Y2 X2",
    childExtends: {
        extends: "Button",
        textTransform: "uppercase",
        background: "transparent",
        "@dark": {
            theme: "primary @dark .color-only"
        },
        "@light": {
            theme: "primary @light .color-only"
        },
        "&": {
            padding: "Z A"
        },
        ":hover": {
            theme: "tertiary"
        },
        ":active": {
            background: "white.1"
        }
    },
    Cancel: {
        if: T$,
        text: (t)=>ce(t, "dialog.cancel"),
        data: {
            dialogAction: "cancel"
        }
    },
    Ok: {
        text: (t)=>ce(t, "dialog.ok"),
        data: {
            dialogAction: "ok"
        }
    }
};
var mv = /*@__PURE__*/ F({}, {
    Tooltip: ()=>I$,
    TooltipHidden: ()=>M$,
    TooltipLayer: ()=>ip,
    TooltipParent: ()=>B$
});
var vq = '[data-tooltip]:not([data-tooltip=""])', O$ = {
    top: 1,
    bottom: 1,
    left: 1,
    right: 1
}, dv = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
}, Ui = 6, C$ = new WeakMap, Oq = 0, Ie = (t)=>{
    let e = C$.get(t);
    return e || (e = {
        id: "smbls-tooltip-" + ++Oq,
        hover: null,
        focus: null,
        shown: null,
        dismissed: null,
        showTimer: null,
        hideTimer: null
    }, C$.set(t, e)), e;
}, pv = (t)=>{
    let e = t && t.nodeType !== 1 ? t.parentElement : t;
    return e && typeof e.closest == "function" ? e : null;
}, Cq = (t)=>{
    let e = t.parent && t.parent.node;
    return e && e.nodeType === 1 ? e : null;
}, Rq = (t)=>{
    for(let e = t.firstElementChild; e; e = e.nextElementSibling)if (e.hasAttribute("data-tooltip-layer")) return !0;
    return !1;
}, R$ = (t, e)=>{
    let n = Cq(t);
    if (!e || !n) return null;
    let o;
    try {
        o = e.closest(vq);
    } catch  {
        return null;
    }
    if (!o || !n.contains(o)) return null;
    for(let r = o; r && r !== n; r = r.parentElement)if (Rq(r)) return null;
    return o;
}, Dq = (t, e)=>!!(e && t.node && t.node.contains(e)), Lq = (t)=>{
    try {
        return t.matches(":focus-visible");
    } catch  {
        return !0;
    }
}, D$ = (t, e)=>typeof t == "number" && t >= 0 ? t : e, e_ = (t)=>{
    t.showTimer && (clearTimeout(t.showTimer), t.showTimer = null), t.hideTimer && (clearTimeout(t.hideTimer), t.hideTimer = null);
}, hv = (t)=>!!(t.node && t.node.isConnected && t.state && typeof t.state.update == "function"), Pq = (t, e)=>{
    let n = (t.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
    n.indexOf(e) === -1 && n.push(e), t.setAttribute("aria-describedby", n.join(" "));
}, gv = (t, e)=>{
    if (!t || typeof t.getAttribute != "function") return;
    let n = t.getAttribute("aria-describedby");
    if (n == null) return;
    let o = n.split(/\s+/).filter((r)=>r && r !== e);
    o.length ? t.setAttribute("aria-describedby", o.join(" ")) : t.removeAttribute("aria-describedby");
}, Iq = (t, e, n, o, r)=>{
    let s = {
        top: t.top,
        bottom: r - t.bottom,
        left: t.left,
        right: o - t.right
    }, i = (f)=>(f === "top" || f === "bottom" ? e.height : e.width) + Ui;
    s[n] < i(n) && s[dv[n]] >= i(dv[n]) && (n = dv[n]);
    let a, c;
    n === "top" || n === "bottom" ? (a = t.left + (t.width - e.width) / 2, c = n === "bottom" ? t.bottom + Ui : t.top - e.height - Ui) : (c = t.top + (t.height - e.height) / 2, a = n === "right" ? t.right + Ui : t.left - e.width - Ui);
    let l = (f, u)=>Math.max(Ui, Math.min(u - Ui, f));
    return {
        left: l(a, o - e.width),
        top: l(c, r - e.height),
        side: n
    };
}, Mq = (t)=>{
    let e = t.ownerDocument, n = e && e.defaultView, o = e && e.documentElement;
    return {
        width: o && o.clientWidth || n && n.innerWidth || 0,
        height: o && o.clientHeight || n && n.innerHeight || 0
    };
}, Bq = (t)=>(t.title || "") + (t.description || ""), Jy = (t, e = 0)=>{
    let o = Ie(t).shown;
    if (!o || !hv(t)) return;
    if (!o.isConnected) {
        t_(t);
        return;
    }
    let r = t.node, s = t.state;
    if (r.textContent !== Bq(s)) {
        e < 3 && setTimeout(()=>Jy(t, e + 1), 0);
        return;
    }
    let i = o.getBoundingClientRect(), a = r.getBoundingClientRect(), c = a.left - (s.x || 0), l = a.top - (s.y || 0), f = Mq(r), u = o.getAttribute("data-tooltip-placement"), d = O$[u] ? u : O$[t.tooltipPlacement] ? t.tooltipPlacement : "bottom", p = Iq(i, {
        width: a.width,
        height: a.height
    }, d, f.width, f.height);
    s.update({
        x: Math.round(p.left - c),
        y: Math.round(p.top - l),
        side: p.side,
        placed: !0
    });
}, Nq = (t)=>{
    typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t);
}, L$ = (t, e)=>{
    let n = Ie(t);
    e_(n), !(!hv(t) || !e.isConnected) && (n.shown && n.shown !== e && gv(n.shown, n.id), n.shown = e, Pq(e, n.id), t.state.update({
        open: !0,
        placed: !1,
        title: e.getAttribute("data-tooltip") || "",
        description: e.getAttribute("data-tooltip-description") || ""
    }), Nq(()=>Jy(t)));
};
function t_(t) {
    let e = Ie(t);
    e_(e), e.shown && gv(e.shown, e.id), e.shown = null, hv(t) && t.state.open && t.state.update({
        open: !1
    });
}
var Qy = (t, e)=>{
    let n = Ie(t);
    n.dismissed && n.dismissed !== n.hover && n.dismissed !== n.focus && (n.dismissed = null);
    let o = n.hover && n.hover !== n.dismissed ? n.hover : n.focus && n.focus !== n.dismissed ? n.focus : null;
    if (o === n.shown) {
        e_(n);
        return;
    }
    if (!o) {
        if (n.showTimer && (clearTimeout(n.showTimer), n.showTimer = null), !n.shown || n.hideTimer) return;
        if (e) {
            t_(t);
            return;
        }
        n.hideTimer = setTimeout(()=>{
            n.hideTimer = null, t_(t);
        }, D$(t.tooltipHideDelay, 100));
        return;
    }
    if (n.hideTimer && (clearTimeout(n.hideTimer), n.hideTimer = null), e || n.shown) {
        L$(t, o);
        return;
    }
    n.showTimer && clearTimeout(n.showTimer), n.showTimer = setTimeout(()=>{
        n.showTimer = null, L$(t, o);
    }, D$(t.tooltipDelay, 250));
}, P$ = (t)=>{
    let e = Ie(t);
    e.shown && (e.dismissed = e.shown, t_(t));
}, ip = {
    role: "tooltip",
    id: (t)=>Ie(t).id,
    data: {
        tooltipLayer: !0
    },
    state: {
        open: !1,
        placed: !1,
        title: "",
        description: "",
        x: 0,
        y: 0,
        side: "bottom"
    },
    tooltipPlacement: "bottom",
    display: "flex",
    flow: "column",
    gap: "X",
    theme: "dialog",
    padding: "Z1 A",
    round: "Y2",
    width: "max-content",
    maxWidth: "F2",
    textAlign: "center",
    position: "fixed",
    zIndex: 2500,
    opacity: (t, e)=>e.open && e.placed ? "1" : "0",
    visibility: (t, e)=>e.open && e.placed ? "visible" : "hidden",
    pointerEvents: (t, e)=>e.open ? "auto" : "none",
    transition: "opacity A defaultBezier, visibility A defaultBezier",
    style: (t, e)=>({
            top: (e.y || 0) + "px",
            left: (e.x || 0) + "px"
        }),
    Text: {
        if: (t, e)=>!!e.title,
        text: (t, e)=>e.title,
        fontWeight: 500,
        color: "currentColor"
    },
    P: {
        if: (t, e)=>!!e.description,
        text: (t, e)=>e.description,
        fontSize: "Z2",
        margin: "0",
        color: "currentColor",
        fontWeight: 400
    },
    onDocumentPointerover: {
        capture: !0,
        passive: !0,
        handler: (t, e)=>{
            if (t.pointerType === "touch") return;
            let n = Ie(e), o = pv(t.target), r = Dq(e, o) ? n.shown : R$(e, o);
            r === n.hover && (r || !n.shown) || (n.hover = r, Qy(e, !1));
        }
    },
    onDocumentPointerout: {
        capture: !0,
        passive: !0,
        handler: (t, e)=>{
            if (t.relatedTarget) return;
            let n = Ie(e);
            n.hover && (n.hover = null, Qy(e, !1));
        }
    },
    onDocumentPointerdown: {
        capture: !0,
        passive: !0,
        handler: (t, e)=>{
            let n = Ie(e), o = pv(t.target);
            n.shown && o && n.shown.contains(o) && P$(e);
        }
    },
    onDocumentFocusin: {
        capture: !0,
        handler: (t, e)=>{
            let n = Ie(e), o = pv(t.target), r = o && Lq(o) ? R$(e, o) : null;
            r !== n.focus && (n.focus = r, Qy(e, !0));
        }
    },
    onDocumentFocusout: {
        capture: !0,
        handler: (t, e)=>{
            if (t.relatedTarget) return;
            let n = Ie(e);
            n.focus && (n.focus = null, Qy(e, !0));
        }
    },
    onDocumentKeydown: {
        capture: !0,
        handler: (t, e)=>{
            (t.key === "Escape" || t.key === "Esc") && P$(e);
        }
    },
    onDocumentScroll: {
        capture: !0,
        passive: !0,
        handler: (t, e)=>{
            Ie(e).shown && Jy(e);
        }
    },
    onWindowResize: (t, e)=>{
        Ie(e).shown && Jy(e);
    },
    onBeforeRemove: (t)=>{
        let e = Ie(t);
        e_(e), e.shown && gv(e.shown, e.id), e.shown = e.hover = e.focus = e.dismissed = null;
    }
};
var I$ = {
    display: "flex",
    theme: "dialog",
    flow: "column",
    shape: "tooltip",
    shapeDirection: "left",
    padding: "Z1 A",
    round: "Y2",
    width: "fit-content",
    minWidth: "D2",
    maxWidth: "F2",
    gap: "X",
    textAlign: "center",
    attr: {
        tooltip: !0
    },
    Title: {
        if: (t)=>jt(t.parent.title) || t.parent.title,
        width: "fit-content",
        fontWeight: 500,
        color: "currentColor",
        text: (t)=>t.parent.title
    },
    P: {
        if: (t, e)=>t.call("isDefined", t.call("exec", t.parent.description, t)) || t.text,
        width: "fit-content",
        fontSize: "Z2",
        margin: "0",
        color: "currentColor",
        fontWeight: "400",
        text: (t, e)=>t.call("exec", t.parent.description, t)
    }
}, M$ = {
    extends: "Tooltip",
    position: "absolute",
    pointerEvents: "none",
    opacity: "0",
    visibility: "hidden",
    transition: "C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform",
    onInit: (t)=>{
        let e = !t.shapeDirection || t.shapeDirection === "top" ? {
            top: "112%",
            left: "50%",
            transform: "translate3d(-50%,10%,0)",
            ".isActive": {
                transform: "translate3d(-50%,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "right" ? {
            transform: "translate3d(10%,-50%,0)",
            left: "112%",
            top: "50%",
            ".isActive": {
                transform: "translate3d(0%,-50%,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "bottom" ? {
            transform: "translate3d(-50%,-10%,0)",
            bottom: "112%",
            left: "50%",
            ".isActive": {
                transform: "translate3d(-50%,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "left" ? {
            transform: "translate3d(10%,-50%,0)",
            right: "112%",
            top: "50%",
            ".isActive": {
                transform: "translate3d(0%,-50%,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : {};
        Object.assign(t, e);
    }
}, B$ = {
    position: "relative",
    zIndex: 999,
    onInit: (t)=>{
        let { Tooltip: e, TooltipHidden: n } = t, o = e || n;
        if (!o) return;
        let r = o && o[".isActive"];
        Object.assign(t, {
            ":hover, &:focus-visible": {
                zIndex: 1e3,
                "& [tooltip]": r || {
                    transform: "translate3d(-50%, 0, 0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        });
    }
};
var yv = /*@__PURE__*/ F({}, {
    Avatar: ()=>N$
});
var Fq = (t)=>{
    let n = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="32" fill="#71718A"/><text x="32" y="42" font-family="system-ui,sans-serif" font-size="28" font-weight="700" text-anchor="middle" fill="#fff">${String(t || "").trim().charAt(0).toUpperCase() || "?"}</text></svg>`;
    return "data:image/svg+xml;utf8," + encodeURIComponent(n);
}, N$ = {
    extends: "Img",
    display: "block",
    avatarType: "adventurer-neutral",
    borderRadius: "100%",
    boxSize: "C+X C+X",
    src: (t)=>`https://api.dicebear.com/7.x/${t.avatarType || "initials"}/svg?seed=${t.key || "no-avatar"}`,
    onError: (t, e)=>{
        if (!e.node || e.node.__avatarFallbackApplied) return;
        e.node.__avatarFallbackApplied = !0;
        let n = e.node.getAttribute("alt") || (e.key !== "no-avatar" ? e.key : "");
        e.node.src = Fq(n);
    },
    attr: {
        alt: (t)=>t.alt != null ? t.alt : t.text ? t.call("exec", t.text, t) : t.key && t.key !== "no-avatar" ? t.key : ""
    }
};
var _v = /*@__PURE__*/ F({}, {
    Range: ()=>F$
});
var F$ = {
    tag: "input",
    appearance: "none",
    width: "100%",
    height: "2px",
    outline: "none",
    flex: 1,
    onInput: (t, e, n)=>{
        n.update({
            value: parseFloat(e.node.value)
        });
    },
    onChange: (t, e, n)=>{
        n.update({
            value: parseFloat(e.node.value)
        });
    },
    "::-webkit-slider-thumb": {
        boxSizing: "content-box",
        width: "8px",
        height: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "100%",
        opacity: ".8",
        appearance: "none"
    },
    "::-webkit-slider-runnable-track": {},
    "@dark": {
        background: "white.2",
        "::-webkit-slider-thumb": {
            background: "#232526",
            borderColor: Xa("#454646", .75)
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: Xa("#fff", .35)
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "#3C6AC0"
            }
        }
    },
    "@light": {
        background: "gray9",
        "::-webkit-slider-thumb": {
            background: "white",
            borderColor: "gray9"
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: "gray7"
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "blue"
            }
        }
    },
    deps: {
        returnPropertyValue: (t, e, n)=>{
            let o = t.call("exec", t[e], t);
            return (t.call("isFunction", o) ? o(t, t.state) : o !== void 0 ? o : n !== void 0 ? n : 0) + "";
        }
    },
    attr: {
        type: "range",
        value: (t, e)=>t.call("exec", e.value || t.value || t.defaultValue, t),
        min: (t, e)=>t.deps.returnPropertyValue(t, "min", 0),
        max: (t, e)=>t.deps.returnPropertyValue(t, "max", 100),
        step: (t, e)=>t.deps.returnPropertyValue(t, "step", 1)
    }
};
var Ov = /*@__PURE__*/ F({}, {
    Dropdown: ()=>f2,
    DropdownDisclosure: ()=>p2,
    DropdownList: ()=>u2,
    DropdownParent: ()=>d2,
    DropdownParentFocus: ()=>h2,
    DropdownSiblingFocus: ()=>g2
});
var a_ = "hover", H$ = "focus", ap = "sibling", sr = "disclosure", $$ = {
    menu: 1,
    listbox: 1,
    tree: 1,
    grid: 1,
    dialog: 1
}, $q = {
    DIV: 1,
    SPAN: 1,
    LABEL: 1,
    P: 1,
    STRONG: 1,
    B: 1,
    EM: 1,
    SMALL: 1,
    H1: 1,
    H2: 1,
    H3: 1,
    H4: 1,
    H5: 1,
    H6: 1
}, jq = {
    BUTTON: 1,
    INPUT: 1,
    SELECT: 1,
    TEXTAREA: 1
}, Uq = 'button, a[href], [role^="menuitem"], [role="option"]', Hq = {
    ArrowDown: 1,
    Down: 1,
    ArrowUp: -1,
    Up: -1,
    Home: "first",
    End: "last"
}, o_ = new WeakMap, r_ = new WeakMap, s_ = new WeakMap, Sv = new WeakMap, V$ = new WeakSet, Vq = 0, _t = (t)=>{
    let e = t && t.node;
    return e && e.nodeType === 1 ? e : null;
}, rl = (t, e)=>{
    let n = _t(t);
    return n ? n.getAttribute(e) : null;
}, Pt = (t, e)=>{
    let n = _t(t);
    return !!n && !!e && (n === e || n.contains(e));
}, bv = (t)=>{
    let e = _t(t);
    return !!e && e.hasAttribute("dropdown");
}, wv = (t)=>{
    let e = _t(t);
    return !!e && e.tagName === "BUTTON";
}, n_ = (t)=>wv(t) || rl(t, "role") === "button", j$ = (t)=>{
    let e = _t(t);
    return !!e && $q[e.tagName] === 1 && !e.isContentEditable;
}, z$ = (t)=>{
    let e = _t(t);
    return !!e && !e.disabled && !e.hidden && e.getAttribute("aria-disabled") !== "true";
}, cp = (t)=>{
    let e = rl(t, "role");
    return !!e && e.indexOf("menuitem") === 0 && z$(t);
}, zq = (t)=>{
    let e = _t(t);
    if (!e || !z$(t)) return !1;
    if (jq[e.tagName] === 1) return e.getAttribute("type") !== "hidden";
    if (e.tagName === "A" && e.hasAttribute("href")) return !0;
    let n = e.getAttribute("tabindex");
    return n !== null && parseInt(n, 10) >= 0;
}, Hi = (t)=>t && typeof t.getChildren == "function" ? t.getChildren() : [], Me = (t)=>t && typeof t.dropdownMode == "string" ? t.dropdownMode : null, xv = (t)=>{
    let e = t && t.Input_trigger;
    return e && e.__ref ? e : null;
}, W$ = {
    tabindex: "tabIndex",
    "aria-expanded": "ariaExpanded",
    "aria-haspopup": "ariaHaspopup",
    "aria-controls": "ariaControls",
    "aria-labelledby": "ariaLabelledby",
    "aria-label": "ariaLabel",
    "aria-hidden": "ariaHidden"
}, K$ = (t, e)=>{
    if (t[e] !== void 0) return !0;
    let n = W$[e];
    if (n !== void 0 && t[n] !== void 0) return !0;
    let o = t.attr;
    if (o && typeof o == "object" && o[e] !== void 0) return !0;
    if (e.indexOf("aria-") === 0) {
        let r = t.aria;
        if (r && typeof r == "object" && r[e.slice(5)] !== void 0) return !0;
    }
    return !1;
}, Wq = (t, e)=>{
    let n = W$[e], o = t.attr;
    return typeof t[e] == "function" || n !== void 0 && typeof t[n] == "function" || !!o && typeof o == "object" && typeof o[e] == "function";
}, ko = (t, e, n)=>!e.hasAttribute(n) && !K$(t, n), ns = (t, e, n)=>{
    n === null ? t.removeAttribute(e) : t.setAttribute(e, n);
}, Kq = (t, e)=>{
    let n = _t(t);
    if (n) for(let o in e)ns(n, o, e[o]);
}, i_ = (t)=>{
    let e = _t(t);
    return !e || typeof e.focus != "function" ? !1 : (e.focus(), e.ownerDocument.activeElement === e);
}, Gq = (t)=>{
    let e = o_.get(t);
    return e || (e = {
        id: "smbls-dropdown-" + ++Vq,
        open: null,
        trigger: null,
        panel: null,
        popup: null,
        popupRole: null,
        owns: !1,
        pressedOpen: !1,
        written: null,
        outside: null,
        outsideDoc: null
    }, o_.set(t, e)), e;
}, U$ = (t, e)=>!!e && !!_t(e) && !!t && t[e.key] === e, qq = (t, e)=>{
    let n = null, o = null;
    if (e === ap) {
        let s = t.parent ? Hi(t.parent) : [];
        for(let i = s.indexOf(t) + 1; i > 0 && i < s.length && s[i]; i++)if (bv(s[i])) {
            n = s[i];
            break;
        }
        return (n_(t) || j$(t)) && (o = t), {
            panel: n,
            trigger: o
        };
    }
    let r = Hi(t);
    for(let s = 0; s < r.length; s++)if (bv(r[s])) {
        n = r[s];
        break;
    }
    if (n_(t)) return {
        panel: n,
        trigger: t
    };
    for(let s = 0; s < r.length; s++){
        let i = r[s];
        if (!(!_t(i) || i.key === "Input_trigger" || bv(i))) {
            (n_(i) || j$(i)) && (o = i);
            break;
        }
    }
    return {
        panel: n,
        trigger: o
    };
}, Yq = (t)=>{
    let e = rl(t, "role");
    if (e && $$[e] === 1) return {
        el: t,
        role: e
    };
    let n = Hi(t);
    for(let o = 0; o < n.length; o++){
        let r = rl(n[o], "role");
        if (r && $$[r] === 1) return {
            el: n[o],
            role: r
        };
    }
    return null;
}, Tn = (t)=>{
    let e = Me(t);
    if (!e || !_t(t)) return null;
    let n = Gq(t);
    if (n.trigger) {
        let p = e === ap ? t.parent : t;
        if ((n.trigger === t || U$(t, n.trigger)) && U$(p, n.panel)) return n;
    }
    let { panel: o, trigger: r } = qq(t, e);
    if (!o || !r) return n.trigger = n.panel = n.popup = null, null;
    n.trigger = r, n.panel = o;
    let s = e === sr ? null : Yq(o);
    n.popup = s ? s.el : null, n.popupRole = s ? s.role : null;
    let i = _t(r), a = {}, c = i.getAttribute("id");
    n.popupRole === "menu" && !c && ko(r, i, "id") && (a.id = c = n.id + "-trigger"), n_(r) || (ko(r, i, "role") && (a.role = "button"), ko(r, i, "tabindex") && (a.tabindex = "0")), n.popupRole && ko(r, i, "aria-haspopup") && (a["aria-haspopup"] = n.popupRole);
    let l = _t(o), f = l.getAttribute("id");
    if (!f && ko(o, l, "id") && (f = n.id + "-panel", ns(l, "id", f)), f && ko(r, i, "aria-controls") && (a["aria-controls"] = f), n.owns = ko(r, i, "aria-expanded"), n.written = {
        open: null,
        expanded: null
    }, n.owns && (n.written.expanded = c_(t, n) ? "true" : "false", a["aria-expanded"] = n.written.expanded), Kq(r, a), n.popupRole === "menu" && c) {
        let p = _t(n.popup);
        ko(n.popup, p, "aria-label") && ko(n.popup, p, "aria-labelledby") && ns(p, "aria-labelledby", c);
    }
    r !== t && e === H$ && rl(t, "tabindex") === "0" && !Wq(t, "tabindex") && ns(_t(t), "tabindex", "-1");
    let u = xv(t), d = _t(u);
    return d && !d.hasAttribute("tabindex") && (K$(u, "tabindex") || ns(d, "tabindex", "-1"), ko(u, d, "aria-hidden") && ns(d, "aria-hidden", "true")), Vi(t, n), n;
}, G$ = (t)=>{
    let e = _t(t), n = e && e.ownerDocument.activeElement;
    return n && n !== e.ownerDocument.body ? n : null;
}, q$ = (t)=>Pt(t, G$(t)), c_ = (t, e, n)=>{
    if (e.open !== null) return e.open;
    let o = Me(t);
    return n || o === a_ || o === sr ? !1 : q$(t);
}, Vi = (t, e, n)=>{
    let o = e.open === null ? null : String(e.open);
    if (e.written.open !== o) {
        e.written.open = o;
        let s = _t(t);
        s && ns(s, "data-dropdown-open", o);
    }
    if (!e.owns) return;
    let r = c_(t, e, n) ? "true" : "false";
    if (e.written.expanded !== r) {
        e.written.expanded = r;
        let s = _t(e.trigger);
        s && ns(s, "aria-expanded", r);
    }
}, Wi = (t)=>{
    let e = r_.get(t);
    return e || (e = {
        stop: null,
        stopItem: null,
        chosen: !1,
        ready: !1,
        settling: !1,
        checks: null,
        checkRows: null,
        owned: !1
    }, r_.set(t, e)), e;
}, Y$ = (t, e)=>{
    if (t.stopItem === e && t.stop === e.key) return;
    let n = t.stopItem && s_.get(t.stopItem);
    t.stop = e.key, t.stopItem = e, n && n.set(!1);
    let o = s_.get(e);
    o && o.set(!0);
}, X$ = (t, e)=>{
    let n = Wi(t);
    n.chosen = !0, Y$(n, e);
}, Z$ = (t)=>{
    let e = Wi(t);
    if (e.settling = !1, e.chosen) return;
    let n = Hi(t);
    for(let o = 0; o < n.length; o++)if (cp(n[o])) {
        Y$(e, n[o]);
        return;
    }
}, Q$ = (t, e)=>{
    if (!e || !e.contains(t)) return !1;
    let n = [];
    for(let r = t; r !== e; r = r.parentElement)n.push(r);
    n.push(e);
    let o = !1;
    for(let r = n.length - 1; r >= 0; r--){
        let s = typeof n[r].getAnimations == "function" ? n[r].getAnimations() : [];
        for(let i = 0; i < s.length; i++)s[i].transitionProperty === "visibility" && (s[i].finish(), o = !0);
    }
    return o;
}, J$ = (t, e)=>{
    let n = _t(t);
    if (!n) return;
    let o = n.ownerDocument.activeElement, r = i_(t);
    !r && e && n.ownerDocument.activeElement === o && Q$(n, _t(e)) && (r = i_(t));
    let s = t.parent;
    r && s && r_.has(s) && X$(s, t);
}, Xq = (t)=>{
    let e = t.popupRole === "menu" ? t.popup : t.panel;
    return !e || typeof e.lookdownAll != "function" ? [] : e.lookdownAll(t.popupRole === "menu" ? cp : zq);
}, Zq = (t, e, n)=>{
    if (n === "trigger") {
        let s = G$(t);
        (!Pt(t, s) && !Pt(e.panel, s) || Pt(xv(t), s)) && i_(e.trigger);
        return;
    }
    let o = Xq(e);
    if (!o.length) return;
    let r = n === "last" ? o[o.length - 1] : null;
    if (!r) for(let s = 0; s < o.length && !r; s++)rl(o[s], "aria-checked") === "true" && (r = o[s]);
    J$(r || o[0], e.panel);
}, kv = (t, e, n)=>{
    let o = _t(t), r = o && o.ownerDocument;
    n && !e.outside && r ? (e.outside = (s)=>{
        if (!_t(t) || !_t(t).isConnected) {
            kv(t, e, !1);
            return;
        }
        Pt(t, s.target) || Pt(e.panel, s.target) || ye(t, e, !1);
    }, e.outsideDoc = r, r.addEventListener("pointerdown", e.outside, !0)) : !n && e.outside && (e.outsideDoc.removeEventListener("pointerdown", e.outside, !0), e.outside = e.outsideDoc = null);
}, t2 = (t, e)=>{
    let n = _t(t), o = n && n.ownerDocument && n.ownerDocument.defaultView;
    if (!o || typeof o.Event != "function") return;
    let r = new o.Event("toggle");
    Object.defineProperty(r, "newState", {
        value: e ? "open" : "closed"
    }), Object.defineProperty(r, "oldState", {
        value: e ? "closed" : "open"
    }), n.dispatchEvent(r);
}, sl = (t, e, n)=>{
    let o = e.open === !0;
    if (e.open = !0, Vi(t, e), Me(t) === sr) {
        kv(t, e, !0);
        let r = _t(e.panel);
        r && Q$(r, r), o || t2(t, !0);
    }
    n && Zq(t, e, n);
}, ye = (t, e, n)=>{
    let o = e.open === !0;
    e.open = !1, Vi(t, e), e.outside && kv(t, e, !1), n && i_(e.trigger), o && Me(t) === sr && t2(t, !1);
}, Qq = (t)=>{
    let e = t.__ref;
    if (!e || Me(t) !== sr || !Object.prototype.hasOwnProperty.call(t, "open")) return;
    let n = q(()=>{
        let o = t.open;
        o != null && hs(()=>{
            let r = Tn(t);
            !r || !!o == (r.open === !0) || (o ? sl(t, r, null) : ye(t, r, q$(t)));
        });
    }, {
        depth: e.path && e.path.length || 0
    });
    e.__effects || (e.__effects = []), e.__effects.push(n);
}, l_ = (t, e, n)=>e.trigger === t ? !Pt(e.panel, n) : Pt(e.trigger, n) ? !0 : Pt(xv(t), n), Tv = (t, e)=>{
    let n = e && typeof e.closest == "function" ? e.closest(Uq) : null;
    return !!n && Pt(t, n);
}, e2 = (t, e, n)=>{
    let o = t.key;
    o === "Escape" || o === "Esc" ? (t.preventDefault(), ye(e, n, !0)) : o === "Tab" && n.popupRole === "menu" && Pt(n.popup, t.target) && ye(e, n, !1);
}, f_ = (t)=>{
    Me(t) === ap && t.parent && V$.add(t.parent), Tn(t), Qq(t);
}, u_ = (t, e)=>{
    let n = Tn(e);
    n && (n.pressedOpen = c_(e, n));
}, Jq = (t, e)=>{
    let n = o_.get(e);
    !n || !n.trigger || n.open !== !1 || Me(e) !== a_ || (n.open = null, Vi(e, n));
}, d_ = (t, e)=>{
    if (Me(e) === sr) {
        eY(t, e);
        return;
    }
    if (t.defaultPrevented) return;
    let n = Tn(e);
    if (!n) return;
    let o = t.target;
    if (Pt(n.panel, o)) {
        if (Me(e) !== a_ || !Tv(n.panel, o)) return;
        (n.open === !0 || t.detail === 0) && ye(e, n, !0);
        return;
    }
    if (!l_(e, n, o)) return;
    let r = t.detail === 0 ? n.open === !0 : n.pressedOpen;
    n.pressedOpen = !1, r ? ye(e, n, !0) : sl(e, n, n.popupRole === "menu" ? "first" : "trigger");
}, p_ = (t, e)=>{
    if (t.defaultPrevented) return;
    if (Me(e) === sr) {
        nY(t, e);
        return;
    }
    let n = Tn(e);
    if (!n) return;
    let o = t.target;
    if (Pt(n.panel, o)) {
        e2(t, e, n);
        return;
    }
    if (!l_(e, n, o)) return;
    let r = t.key;
    if (r === "ArrowDown" || r === "Down" || r === "ArrowUp" || r === "Up") t.preventDefault(), sl(e, n, r === "ArrowUp" || r === "Up" ? "last" : "first");
    else if (r === "Escape" || r === "Esc") {
        if (!c_(e, n)) return;
        t.preventDefault(), ye(e, n, !1);
    } else (r === "Enter" || r === " " || r === "Spacebar") && !wv(n.trigger) && (t.preventDefault(), n.open === !0 ? ye(e, n, !0) : sl(e, n, n.popupRole === "menu" ? "first" : "trigger"));
}, tY = (t)=>!!(t.ctrlKey || t.metaKey || t.shiftKey || t.altKey), eY = (t, e)=>{
    let n = Tn(e);
    if (!n) return;
    let o = t.target;
    if (Pt(n.panel, o)) {
        n.open === !0 && !tY(t) && e.keepOpen !== !0 && Tv(n.panel, o) && ye(e, n, !0);
        return;
    }
    if (t.defaultPrevented || !l_(e, n, o)) return;
    let r = t.detail === 0 ? n.open === !0 : n.pressedOpen;
    n.pressedOpen = !1, r ? ye(e, n, !0) : sl(e, n, "trigger");
}, nY = (t, e)=>{
    let n = Tn(e);
    if (!n) return;
    let o = t.key;
    if (o === "Escape" || o === "Esc") {
        if (n.open !== !0) return;
        t.preventDefault(), ye(e, n, !0);
        return;
    }
    (o === "Enter" || o === " " || o === "Spacebar") && !wv(n.trigger) && !Pt(n.panel, t.target) && l_(e, n, t.target) && (t.preventDefault(), n.open === !0 ? ye(e, n, !0) : sl(e, n, "trigger"));
}, Ev = (t, e)=>{
    let n = Tn(e);
    n && (n.open === null && Pt(n.panel, t.target) && (n.open = !0), Vi(e, n));
}, lp = (t, e)=>{
    let n = o_.get(e);
    if (!n || !n.trigger) return;
    let o = t.relatedTarget;
    if (Me(e) === sr) {
        n.open === !0 && o && !Pt(e, o) && !Pt(n.panel, o) && ye(e, n, !1);
        return;
    }
    if (o && (Pt(e, o) || Pt(n.panel, o))) {
        n.open === null && Pt(n.panel, o) && (n.open = !0, Vi(e, n));
        return;
    }
    n.open = null, Vi(e, n, !0);
}, n2 = (t)=>{
    let e = t.parent;
    if (!e || !V$.has(e)) return null;
    let n = Hi(e);
    for(let o = n.indexOf(t) - 1; o >= 0 && n[o]; o--)if (Me(n[o]) === ap) return n[o];
    return null;
}, Av = (t)=>{
    let e = n2(t), n = e ? Tn(e) : null;
    return n && n.panel === t ? {
        ctrl: e,
        rec: n
    } : null;
}, o2 = (t)=>{
    let e = n2(t);
    e && Tn(e);
}, r2 = (t, e)=>{
    if (t.defaultPrevented) return;
    let n = Av(e);
    n && e2(t, n.ctrl, n.rec);
}, s2 = (t, e)=>{
    if (t.defaultPrevented || !Tv(e, t.target)) return;
    let n = Av(e);
    n && ye(n.ctrl, n.rec, !0);
}, i2 = (t, e)=>{
    let n = Av(e);
    n && lp(t, n.ctrl);
}, oY = (t, e)=>{
    let n = e.parent, o = Me(n) ? Tn(n) : null;
    if (o && o.panel === e) {
        ye(n, o, !0);
        return;
    }
    let r = _t(e), s = r && r.ownerDocument.activeElement;
    s && typeof s.blur == "function" && s.blur();
}, a2 = (t, e)=>{
    if (Me(e.parent) && Tn(e.parent)) return;
    let n = _t(e);
    n && n === n.ownerDocument.activeElement && n.blur();
}, rY = (t, e)=>{
    if (t.defaultPrevented) return;
    let n = Hq[t.key];
    if (!n) return;
    let o = typeof e.lookdownAll == "function" ? e.lookdownAll(cp) : [];
    if (!o.length) return;
    let r = -1;
    for(let i = 0; i < o.length && r === -1; i++)Pt(o[i], t.target) && (r = i);
    let s;
    n === "first" ? s = 0 : n === "last" ? s = o.length - 1 : r === -1 ? s = n > 0 ? 0 : o.length - 1 : s = (r + n + o.length) % o.length, t.preventDefault(), J$(o[s]);
}, sY = (t, e)=>{
    let n = Hi(e);
    for(let o = 0; o < n.length; o++)if (Pt(n[o], t.target)) {
        cp(n[o]) && X$(e, n[o]);
        return;
    }
}, iY = (t)=>{
    let e = t.parent;
    if (!e) return "0";
    let n = Wi(e), o = s_.get(t);
    if (!o) {
        n.stop === null && (n.stop = t.key);
        let r = n.stop === t.key;
        r && (n.stopItem = t), n.ready && !n.chosen && !n.settling && (n.settling = !0, queueMicrotask(()=>Z$(e))), o = On(r), s_.set(t, o);
    }
    return o.get() ? "0" : "-1";
}, aY = (t)=>{
    o2(t);
    let e = Wi(t);
    e.ready = !0, !(e.stopItem && e.stopItem.parent === t && cp(e.stopItem)) && Z$(t);
}, cY = (t)=>{
    let e = Sv.get(t), n = !e;
    n && (e = {
        tick: On(0),
        seen: 0,
        checked: !1
    }, Sv.set(t, e));
    let o = e.tick.get();
    return o === e.seen && (e.checked = !!hs(()=>t.isActive)), e.seen = o, n && t.parent && fY(t.parent), e.checked ? "true" : "false";
}, lY = (t, e)=>{
    if (e.checkRows.get(), !t.node) {
        l2(t);
        return;
    }
    let n = Hi(t);
    for(let o = 0; o < n.length; o++){
        let r = Sv.get(n[o]);
        if (!r) continue;
        let s = !!n[o].isActive;
        s !== r.checked && (r.checked = s, r.tick.set(r.tick.peek() + 1));
    }
}, c2 = (t)=>{
    let e = Wi(t);
    e.checks || (e.checkRows || (e.checkRows = On(0)), e.checks = q(()=>lY(t, e), {
        label: "DropdownList.checks"
    }));
}, l2 = (t)=>{
    let e = r_.get(t);
    !e || !e.checks || (e.checks.dispose(), e.checks = null);
}, fY = (t)=>{
    let e = Wi(t);
    e.checks ? e.checkRows.set(e.checkRows.peek() + 1) : e.owned || c2(t);
}, uY = (t)=>{
    Wi(t).owned = !0;
}, zi = {
    transform: "translate3d(0,0,0)",
    opacity: 1,
    visibility: "visible"
}, vv = {
    opacity: 0,
    visibility: "hidden"
}, f2 = {
    attr: {
        dropdown: !0
    },
    position: "absolute",
    top: "100%",
    left: "0",
    zIndex: 1e3,
    theme: "quaternary",
    padding: "Y",
    round: "Z2",
    flow: "column",
    gap: "X",
    transition: "transform B defaultBezier, opacity B defaultBezier, visibility B defaultBezier",
    transform: "translate3d(0,10%,0)",
    opacity: 0,
    visibility: "hidden",
    onComplete: {
        always: !0,
        handler: o2
    },
    onKeydown: r2,
    onClick: s2,
    onFocusout: i2
}, u2 = {
    display: "flex",
    attr: {
        dropdown: !0
    },
    role: "menu",
    padding: "0 Y",
    maxHeight: "G",
    flow: "column",
    theme: "quaternary",
    overflow: "hidden auto",
    listStyleType: "none",
    transition: "transform B defaultBezier, opacity B defaultBezier, visibility B defaultBezier",
    children: (t)=>t.options || [],
    childrenAs: "props",
    ".hidden": {
        transform: "translate3d(0,10%,0)",
        opacity: 0,
        visibility: "hidden"
    },
    onKeydown: (t, e)=>{
        rY(t, e), r2(t, e);
    },
    onInit: {
        always: !0,
        handler: uY
    },
    onComplete: {
        always: !0,
        handler: aY
    },
    onRender: {
        always: !0,
        handler: c2
    },
    onBeforeRemove: {
        always: !0,
        handler: l2
    },
    onFocusin: sY,
    onClick: s2,
    onFocusout: i2,
    childExtends: {
        extends: "Button",
        state: {},
        role: "menuitemradio",
        tabindex: (t)=>iY(t),
        aria: {
            checked: (t)=>cY(t)
        },
        isActive: (t, e)=>e.active === t.key,
        position: "relative",
        round: "0",
        align: "center flex-end",
        flow: "row-reverse",
        padding: "Z2 C Z2 Y2",
        margin: "0",
        gap: "Y2",
        theme: "quaternary .child",
        ":hover": {
            style: {
                svg: {
                    opacity: "0.5"
                }
            }
        },
        ':where([aria-checked="true"])': {
            style: {
                svg: {
                    opacity: "1"
                }
            }
        },
        Icon: {
            name: "check",
            opacity: "0.1"
        },
        ":not(:first-child)": {
            "@dark": {
                border: "solid gray4.65"
            },
            "@light": {
                border: "solid gray11"
            },
            borderWidth: "1px 0 0"
        }
    }
}, d2 = {
    position: "relative",
    zIndex: 999,
    dropdownMode: a_,
    ":hover": {
        zIndex: 1e3,
        "& [dropdown]": {
            ...zi
        }
    },
    '[data-dropdown-open="true"]': {
        zIndex: 1e3,
        "& [dropdown]": {
            ...zi
        }
    },
    '[data-dropdown-open="false"]:hover': {
        "& [dropdown]": {
            ...vv
        }
    },
    onComplete: {
        always: !0,
        handler: f_
    },
    onPointerdown: u_,
    onPointerenter: Jq,
    onClick: d_,
    onKeydown: p_,
    onFocusin: Ev,
    onFocusout: lp
}, p2 = {
    position: "relative",
    dropdownMode: sr,
    '[data-dropdown-open="true"]': {
        zIndex: 1e3,
        "& > [dropdown]": {
            ...zi
        }
    },
    onComplete: {
        always: !0,
        handler: f_
    },
    onPointerdown: u_,
    onClick: d_,
    onKeydown: p_,
    onFocusout: lp
}, h2 = {
    position: "relative",
    tabindex: "0",
    dropdownMode: H$,
    ":focus-within": {
        zIndex: 1e3,
        "& [dropdown]": {
            ...zi
        }
    },
    '[data-dropdown-open="true"]': {
        zIndex: 1e3,
        "& [dropdown]": {
            ...zi
        }
    },
    '[data-dropdown-open="false"]:focus-within': {
        "& [dropdown]": {
            ...vv
        }
    },
    onComplete: {
        always: !0,
        handler: f_
    },
    onPointerdown: u_,
    onClick: d_,
    onKeydown: p_,
    onFocusin: Ev,
    onFocusout: lp,
    Input_trigger: {
        type: "checkbox",
        opacity: "0",
        position: "absolute",
        inset: "0",
        width: "100%",
        height: "100%",
        cursor: "pointer",
        onClick: (t, e)=>a2(t, e)
    },
    Dropdown: {
        onClick: (t, e)=>oY(t, e)
    }
}, g2 = {
    position: "relative",
    tabindex: "0",
    dropdownMode: ap,
    ":focus-within": {
        zIndex: 1e3,
        "& ~ [dropdown]": {
            ...zi
        }
    },
    '[data-dropdown-open="true"]': {
        zIndex: 1e3,
        "& ~ [dropdown]": {
            ...zi
        }
    },
    '[data-dropdown-open="false"]:focus-within': {
        "& ~ [dropdown]": {
            ...vv
        }
    },
    onComplete: {
        always: !0,
        handler: f_
    },
    onPointerdown: u_,
    onClick: d_,
    onKeydown: p_,
    onFocusin: Ev,
    onFocusout: lp,
    Input_trigger: {
        type: "checkbox",
        opacity: "0",
        position: "absolute",
        inset: "0",
        width: "100%",
        height: "100%",
        cursor: "pointer",
        onClick: (t, e)=>a2(t, e)
    }
};
var Cv = /*@__PURE__*/ F({}, {
    Notification: ()=>m2
});
var m2 = {
    display: "flex",
    theme: "alert",
    padding: "Z1 B Z A",
    round: "A A A Y2",
    gap: "X2",
    cursor: "pointer",
    align: "flex-start center",
    IconText: {
        Icon: {
            name: "info outline"
        },
        Text: {
            ":empty": {
                hide: !0
            }
        }
    },
    Hgroup: {
        extends: [
            "Flex",
            "Hgroup"
        ],
        flow: "y",
        align: "flex-start",
        gap: "X2",
        H: {
            tag: "h6",
            margin: "0",
            fontWeight: "600",
            lineHeight: "1em",
            text: "Notification",
            ":empty": {
                hide: !0
            }
        },
        P: {
            fontSize: "Z",
            margin: "0",
            text: "is not always a distraction",
            ":empty": {
                hide: !0
            }
        }
    }
};
var Ki = Object.assign({}, aA, cA, lA, fA, dA, mA, yA, _A, hA, bA, SA, gA, wA, xA, kA, TA, EA, AA, vA, OA, CA, RA, PA, av, cv, lv, uv, mv, yv, _v, Ov, Cv);
function _2(t) {
    return Rv(t, 0, void 0);
}
function Rv(t, e, n) {
    if (t == null) return 0;
    if (typeof t != "object") return y2(String(t));
    if (e >= 512) return 2246822507;
    let o = n;
    if (e >= 64) {
        if (o === void 0) o = new Set;
        else if (o.has(t)) return 2654435769;
        o.add(t);
    }
    let r = 2166136261;
    if (Array.isArray(t)) {
        r = (r ^ 91) * 16777619;
        for(let s = 0; s < t.length; s++)r = (r ^ Rv(t[s], e + 1, o)) * 16777619;
    } else {
        let s = Object.keys(t).sort();
        for(let i = 0; i < s.length; i++)r = (r ^ y2(s[i])) * 16777619, r = (r ^ Rv(t[s[i]], e + 1, o)) * 16777619;
    }
    return e >= 64 && o.delete(t), r >>> 0;
}
function y2(t) {
    let e = 2166136261;
    for(let n = 0; n < t.length; n++)e ^= t.charCodeAt(n), e = e * 16777619 >>> 0;
    return e;
}
function b2(t, e) {
    return Dv(t, e, 0, void 0, void 0);
}
function Dv(t, e, n, o, r) {
    if (t === e) return !0;
    if (t === null || e === null || typeof t != typeof e || typeof t != "object" || n >= 512) return !1;
    let s = o, i = r;
    if (n >= 64) {
        if (s === void 0) s = [], i = [];
        else {
            let c = s.indexOf(t);
            if (c >= 0) return i[c] === e;
            if (i.indexOf(e) >= 0) return !1;
        }
        s.push(t), i.push(e);
    }
    let a = hY(t, e, n, s, i);
    return n >= 64 && (s.pop(), i.pop()), a;
}
function hY(t, e, n, o, r) {
    if (Array.isArray(t)) {
        if (!Array.isArray(e) || t.length !== e.length) return !1;
        for(let a = 0; a < t.length; a++)if (!Dv(t[a], e[a], n + 1, o, r)) return !1;
        return !0;
    }
    let s = Object.keys(t), i = Object.keys(e);
    if (s.length !== i.length) return !1;
    for(let a = 0; a < s.length; a++){
        let c = s[a];
        if (!Object.prototype.hasOwnProperty.call(e, c) || !Dv(t[c], e[c], n + 1, o, r)) return !1;
    }
    return !0;
}
function S2(t, e) {
    return w2(t, e, 0, void 0);
}
function w2(t, e, n, o) {
    if (e === void 0) return t;
    if (t === void 0) return e;
    if (e === null) return null;
    if (typeof e != "object" || Array.isArray(e)) return e;
    if (typeof t != "object" || Array.isArray(t)) return {
        ...e
    };
    if (n >= 512) return e;
    let r = o;
    if (n >= 64) {
        if (r === void 0) r = new Set;
        else if (r.has(e)) return t;
        r.add(e);
    }
    let s = !1, i = {};
    for(let a in t)if (a in e) {
        let c = w2(t[a], e[a], n + 1, r);
        i[a] = c, c !== t[a] && (s = !0);
    } else i[a] = t[a];
    for(let a in e)a in t || (i[a] = e[a], s = !0);
    return n >= 64 && r.delete(e), s ? i : t;
}
function x2(t, e) {
    return k2(t, e, 0, void 0);
}
function k2(t, e, n, o) {
    if (!e || typeof e != "object") return t;
    if (!t || typeof t != "object") return e;
    if (n >= 512 || (o || (o = new WeakSet), o.has(e))) return t;
    o.add(e);
    for(let r in e){
        let s = e[r];
        s && typeof s == "object" && !Array.isArray(s) && t[r] && typeof t[r] == "object" && !Array.isArray(t[r]) ? k2(t[r], s, n + 1, o) : t[r] = s;
    }
    return t;
}
function os(t) {
    let e = 2166136261;
    for(let n = 0; n < t.length; n++)e ^= t.charCodeAt(n), e = e * 16777619 >>> 0;
    return e.toString(36);
}
function al(t) {
    return t.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase());
}
function up(t) {
    let e = String(t);
    return e.length <= 20 ? e.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_-]/g, "").toLowerCase() : os(e);
}
function T2(t) {
    return t.split(`
`).map(os).join(`
`);
}
var E2 = {
    display: "d",
    position: "pos",
    padding: "p",
    paddingTop: "pt",
    paddingRight: "pr",
    paddingBottom: "pb",
    paddingLeft: "pl",
    paddingBlock: "pbl",
    paddingInline: "pin",
    margin: "m",
    marginTop: "mt",
    marginRight: "mr",
    marginBottom: "mb",
    marginLeft: "ml",
    marginBlock: "mbl",
    marginInline: "min",
    width: "w",
    height: "h",
    minWidth: "mnw",
    minHeight: "mnh",
    maxWidth: "mxw",
    maxHeight: "mxh",
    top: "t",
    right: "r",
    bottom: "b",
    left: "l",
    flex: "fx",
    flexDirection: "fxd",
    flexWrap: "fxw",
    flexGrow: "fxg",
    flexShrink: "fxs",
    flexBasis: "fxb",
    justifyContent: "jc",
    alignItems: "ai",
    alignSelf: "as",
    alignContent: "ac",
    gap: "g",
    rowGap: "rg",
    columnGap: "cg",
    gridTemplateColumns: "gtc",
    gridTemplateRows: "gtr",
    gridColumn: "gc",
    gridRow: "gr",
    overflow: "of",
    overflowX: "ofx",
    overflowY: "ofy",
    fontSize: "fs",
    fontWeight: "fw",
    fontFamily: "ff",
    fontStyle: "fst",
    lineHeight: "lh",
    letterSpacing: "ls",
    textAlign: "ta",
    textDecoration: "td",
    textTransform: "tt",
    color: "c",
    background: "bg",
    backgroundColor: "bgc",
    backgroundImage: "bgi",
    border: "bd",
    borderRadius: "br",
    borderColor: "bdc",
    borderWidth: "bdw",
    borderStyle: "bds",
    boxShadow: "bxsh",
    opacity: "op",
    zIndex: "z",
    cursor: "cur",
    transition: "tr",
    transform: "tf",
    animation: "an",
    visibility: "vis",
    whiteSpace: "ws",
    wordBreak: "wb",
    objectFit: "obj",
    pointerEvents: "pe",
    userSelect: "us",
    boxSizing: "bxz",
    outline: "ol",
    listStyle: "lis",
    textOverflow: "txo",
    verticalAlign: "va",
    float: "fl",
    clear: "cl",
    content: "cnt",
    backdropFilter: "bdf",
    filter: "flt",
    resize: "rsz",
    appearance: "apr",
    fill: "fil",
    stroke: "stk",
    scrollBehavior: "sb",
    inset: "ins"
};
function A2(t, e) {
    let n = E2[t] || os(t), o = up(e), r = `_${n}-${o}`, s = al(t), i = _Y[s], a = i ? `${s}: ${e};${i}: ${e}` : `${s}: ${e}`, c = `.${r}{${a}}`;
    return `${r}
${c}`;
}
var _Y = {
    "backdrop-filter": "-webkit-backdrop-filter",
    "user-select": "-webkit-user-select",
    "mask-image": "-webkit-mask-image",
    "mask-size": "-webkit-mask-size",
    "mask-repeat": "-webkit-mask-repeat",
    "mask-position": "-webkit-mask-position",
    "mask-clip": "-webkit-mask-clip",
    "mask-origin": "-webkit-mask-origin",
    "background-clip": "-webkit-background-clip"
}, bY = "@media (hover: hover)", SY = /(?:^|[^\\]):hover(?![\w-])/, v2 = (t)=>typeof t == "string" && (t.indexOf("{") !== -1 || t.indexOf("}") !== -1);
function O2(t) {
    let e = t.split("\0"), n = [], o = [];
    for(let r = 0; r + 1 < e.length; r += 2){
        let s = e[r], i = e[r + 1];
        if (!i || v2(i)) continue;
        let a = E2[s] || os(s), c = up(i), l = `_${a}-${c}`, f = al(s);
        n.push(l), o.push(`.${l}{${f}:${i}}`);
    }
    return n.join(" ") + "\0" + o.join(`
`);
}
function C2(t, e, n) {
    let o = t + e, r = `_c${os(o)}`, s = e.split("\0"), i = "";
    for(let l = 0; l + 1 < s.length; l += 2){
        let f = s[l], u = s[l + 1];
        u && (v2(u) || (i += `${al(f)}:${u};`));
    }
    let a, c;
    if (t.startsWith("@media")) c = `.${r}`, a = `${t}{${c}{${i}}}`;
    else if (t.startsWith(":") || t.startsWith("&") || t.startsWith("[") && !t.includes("&")) {
        let l = t.startsWith("&") ? t.slice(1) : t;
        c = `.${r}${l}`, a = `${c}{${i}}`;
    } else t.includes("&") ? (c = t.replace("&", `.${r}`), a = `${c}{${i}}`) : (c = `.${r} ${t}`, a = `${c}{${i}}`);
    return n !== !1 && SY.test(c) && (a = `${bY}{${a}}`), `${r}
${a}`;
}
var Lv = null;
function g_(t) {
    Lv = t;
}
var qn = {
    structuralHash: _2,
    deepEqual: b2,
    mergeStructural: S2,
    overwriteDeep: x2,
    shortHash: os,
    toKebab: al,
    sanitizeValue: up,
    batchShortHash: T2,
    atomicCssClass: A2,
    batchAtomicCss: O2,
    compoundCssClass: C2
}, R2 = !1, h_ = null;
function D2(t) {
    return h_ || (h_ = import(t || "@symbo.ls/wasm/pkg").then((e)=>(e.structuralHash && (qn.structuralHash = e.structuralHash), e.deepEqual && (qn.deepEqual = e.deepEqual), e.mergeStructural && (qn.mergeStructural = e.mergeStructural), e.overwriteDeep && (qn.overwriteDeep = e.overwriteDeep), e.shortHash && (qn.shortHash = e.shortHash), e.toKebab && (qn.toKebab = e.toKebab), e.sanitizeValue && (qn.sanitizeValue = e.sanitizeValue), e.batchShortHash && (qn.batchShortHash = e.batchShortHash), e.atomicCssClass && (qn.atomicCssClass = e.atomicCssClass), e.batchAtomicCss && (qn.batchAtomicCss = e.batchAtomicCss), e.compoundCssClass && (qn.compoundCssClass = e.compoundCssClass), R2 = !0, Lv && e.batchAtomicCss && Lv({
            batchAtomicCss: e.batchAtomicCss,
            compoundCssClass: e.compoundCssClass
        }), !0)).catch((e)=>(console.debug("[smbls] WASM not available, using JS fallbacks:", e.message), !1)), h_);
}
function L2() {
    return R2;
}
var dp = /*@__PURE__*/ F({}, {
    BRENDER_LAZY_META: ()=>Ng,
    BRENDER_REGISTRY_BLOCK: ()=>ru,
    BRENDER_REGISTRY_TREE_BLOCK: ()=>su,
    BRENDER_STAMP_META: ()=>Bg,
    CDN_PROVIDERS: ()=>cn,
    DESIGN_SYSTEM_BLOCK: ()=>lu,
    DESIGN_SYSTEM_DEFERRED: ()=>cu,
    DESIGN_SYSTEM_LINK: ()=>au,
    DOMQL_EVENTS: ()=>RS,
    DOMQ_PROPERTIES: ()=>pr,
    ELEMENT_METHOD_OVERRIDE_POINTS: ()=>wa,
    ENV: ()=>QS,
    HOST_FORCED_ATTR: ()=>uu,
    HOST_FORCED_ROBOTS: ()=>dk,
    HOST_FORCED_VALUE: ()=>du,
    HOST_PACKAGE_ERROR_CODES: ()=>In,
    HOST_PACKAGE_LOADER_KEY: ()=>Fa,
    HOST_PACKAGE_PATH_BASE: ()=>Eg,
    HOST_SOURCES_GLOBAL: ()=>Tr,
    HOST_SOURCES_TAG_ATTR: ()=>Ag,
    HTML_TAGS: ()=>Ta,
    LAZY_HOST_IMPORT_FORMS: ()=>Na,
    LIBRARY_PACKAGES: ()=>Ig,
    LIBRARY_SCOPES_KEY: ()=>Vs,
    METHODS: ()=>gr,
    METHODS_EXL: ()=>Vl,
    NODE_ENV: ()=>Rn,
    OPTIONS: ()=>Af,
    PACKAGE_MANAGER_TO_CDN: ()=>Er,
    PARSED_DOMQ_PROPERTIES: ()=>Hl,
    POLYGLOT_LANG_STORAGE_KEY: ()=>lh,
    POLYGLOT_TRANSLATIONS_FROM_LANG: ()=>_S,
    PROPS_METHODS: ()=>hr,
    PROTOTYPE_KEYS: ()=>je,
    REVIVED_MARK: ()=>Yl,
    ROUTE_HEAD_KEYS: ()=>Mg,
    SHADOWED_COMPONENTS: ()=>Ea,
    SMBLS_PATH_PREFIX: ()=>Ba,
    STATE_DATA_MERGE_EXL: ()=>Yh,
    STATE_METHODS: ()=>ws,
    STATE_PROPERTIES: ()=>OS,
    SVG_TAGS: ()=>xR,
    TYPES: ()=>Il,
    UNIVERSAL_RESERVED_KEYS: ()=>xg,
    WORKER_SCRIPT_BASE: ()=>Ma,
    WORKER_SCRIPT_NAME: ()=>Tg,
    __resetBuiltinMethodWarnings: ()=>Jx,
    addCaching: ()=>Vh,
    addContext: ()=>Hh,
    addExtend: ()=>yw,
    addExtends: ()=>eo,
    addItemAfterEveryElement: ()=>cS,
    addProtoToArray: ()=>Nl,
    addRef: ()=>$h,
    alternateLinkKey: ()=>Zs,
    applyCSS: ()=>Bv,
    applyDependentState: ()=>Iw,
    applyEvent: ()=>gg,
    applyEventUpdate: ()=>mg,
    applyExtends: ()=>ER,
    applyProps: ()=>ff,
    arrayContainsOtherArray: ()=>eS,
    arraysEqual: ()=>fS,
    arrayzeValue: ()=>Js,
    bareLibraryKey: ()=>Kf,
    bindLibraryGlobalScopes: ()=>qf,
    brenderLazyMeta: ()=>fk,
    brenderStampMeta: ()=>lk,
    buildImgSrcset: ()=>gu,
    buildSourcesAndImg: ()=>mu,
    cache: ()=>gx,
    call: ()=>Ax,
    captureSnapshot: ()=>Ox,
    checkForStateTypes: ()=>Rw,
    checkIfInherits: ()=>qh,
    checkIfStringIsInArray: ()=>pS,
    classifyHostPackageReads: ()=>Mx,
    clone: ()=>NS,
    cloneAndMergeArrayExtend: ()=>tf,
    cloneFunction: ()=>mS,
    collectExtendsList: ()=>Lo,
    concatAddExtends: ()=>hw,
    copyJavaScriptToClipboard: ()=>yk,
    copyStringToClipboard: ()=>mk,
    createBasedOnType: ()=>Fh,
    createElement: ()=>Cw,
    createElementExtends: ()=>vh,
    createExtends: ()=>nf,
    createExtendsFromKeys: ()=>Aa,
    createExtendsStack: ()=>Dh,
    createIfConditionFlag: ()=>ow,
    createInheritedState: ()=>Dw,
    createKey: ()=>Jl,
    createNestedObject: ()=>WS,
    createNestedObjectByKeyPath: ()=>Pw,
    createObjectWithoutPrototype: ()=>bh,
    createParent: ()=>jh,
    createPath: ()=>Uh,
    createProps: ()=>uf,
    createPropsStack: ()=>Bh,
    createPrunedLibraryIconLoader: ()=>Hg,
    createRoot: ()=>Ow,
    createScope: ()=>Bw,
    createSnapshotId: ()=>Ql,
    currentPathname: ()=>bs,
    customDecodeURIComponent: ()=>vS,
    customEncodeURIComponent: ()=>AS,
    cutArrayAfterValue: ()=>iS,
    cutArrayBeforeValue: ()=>sS,
    debounce: ()=>Fl,
    debounceOnContext: ()=>hS,
    decodeBrenderRegistry: ()=>iu,
    decodeNewlines: ()=>ES,
    deepClone: ()=>ft,
    deepContains: ()=>VS,
    deepDefaults: ()=>Va,
    deepDestringifyFunctions: ()=>xe,
    deepExtend: ()=>Th,
    deepMerge: ()=>mt,
    deepMergeExtends: ()=>no,
    deepStringifyFunctions: ()=>Wl,
    defineSetter: ()=>Tx,
    designSystemBlock: ()=>ck,
    designSystemLink: ()=>ak,
    destringifyGlobalScope: ()=>vs,
    detectHeightOnInit: ()=>jx,
    detectInfiniteLoop: ()=>YS,
    document: ()=>wt,
    elementPath: ()=>an,
    encodeNewlines: ()=>TS,
    error: ()=>js,
    escapeHtml: ()=>H,
    escapeRegExp: ()=>SS,
    evaluateText: ()=>Pn,
    excludeKeysFromObject: ()=>ZS,
    exec: ()=>bt,
    exposeBagGlobalScopes: ()=>Yf,
    extendCachedRegistry: ()=>gw,
    extendStackRegistry: ()=>of,
    extractArrayExtend: ()=>sf,
    faviconLinkKey: ()=>Or,
    fetchLibraryData: ()=>Ys,
    fibonacciNumberByIndex: ()=>Ux,
    fileEntryUrl: ()=>Fg,
    filterArrays: ()=>uS,
    filterArraysFast: ()=>dS,
    finalizeExtends: ()=>Lh,
    findClosestNumber: ()=>$g,
    findClosestNumberInFactory: ()=>gk,
    findInheritedState: ()=>Gh,
    findKeyPosition: ()=>xS,
    flattenExtend: ()=>va,
    formatDate: ()=>$x,
    generateHash: ()=>wh,
    generateHeadArrayTags: ()=>Ka,
    generateKey: ()=>Zl,
    generateMetaTags: ()=>pk,
    get: ()=>Sx,
    getActiveRoute: ()=>rv,
    getCDNDirUrl: ()=>Og,
    getCDNUrl: ()=>Mn,
    getCapitalCaseKeys: ()=>bw,
    getCdnProviderFromConfig: ()=>Ua,
    getChildStateInKey: ()=>Kh,
    getChildren: ()=>kx,
    getContext: ()=>Mf,
    getCookie: ()=>cw,
    getDB: ()=>jf,
    getEmotionStylesheet: ()=>kk,
    getExtendsInElement: ()=>_w,
    getExtendsStack: ()=>ef,
    getExtendsStackRegistry: ()=>kh,
    getFrequencyInArray: ()=>nS,
    getFunctionSource: ()=>Ue,
    getHashedExtend: ()=>rf,
    getImportMapScript: ()=>Fx,
    getInObjectByPath: ()=>qS,
    getLocalStorage: ()=>fw,
    getNev: ()=>nw,
    getPageMetadata: ()=>hk,
    getParentStateInKey: ()=>Wh,
    getPath: ()=>Cf,
    getQuery: ()=>Uf,
    getRef: ()=>xx,
    getRoot: ()=>Lf,
    getRootContext: ()=>If,
    getRootData: ()=>Pf,
    getRootState: ()=>Df,
    getRootStateInKey: ()=>zh,
    getSpreadChildren: ()=>Sw,
    global: ()=>Qb,
    hasFunction: ()=>ie,
    hasHandlerPlugin: ()=>_a,
    hasOwnProperty: ()=>jS,
    hashContent: ()=>Bn,
    hostPackageAssetPath: ()=>Lx,
    hostPackageSourcesScript: ()=>vg,
    hostPackageSourcesTag: ()=>Bx,
    inheritChildExtends: ()=>Ch,
    inheritChildPropsExtends: ()=>Oh,
    inheritParentProps: ()=>df,
    inheritRecursiveChildExtends: ()=>Rh,
    init: ()=>To,
    initProps: ()=>Aw,
    insertAfterImportMap: ()=>uk,
    installPrunedLibraryIconLoader: ()=>hu,
    is: ()=>Se,
    isArray: ()=>B,
    isBoolean: ()=>sh,
    isBuiltinElementMethod: ()=>CS,
    isContextComponent: ()=>ww,
    isCyclic: ()=>XS,
    isDOMNode: ()=>_e,
    isDate: ()=>ah,
    isDefined: ()=>jt,
    isDevelopment: ()=>yr,
    isEmpty: ()=>yh,
    isEmptyObject: ()=>US,
    isEqualDeep: ()=>_h,
    isFailedRevival: ()=>Es,
    isFunction: ()=>P,
    isHostPackageSpecifier: ()=>Hf,
    isHtmlElement: ()=>Pl,
    isLazyFunction: ()=>FS,
    isLocal: ()=>ew,
    isLoudDevRuntime: ()=>et,
    isMalformedDependency: ()=>Us,
    isMethod: ()=>vx,
    isMobile: ()=>iw,
    isNode: ()=>Ro,
    isNot: ()=>tS,
    isNotProduction: ()=>Do,
    isNull: ()=>ih,
    isNumber: ()=>be,
    isObject: ()=>k,
    isObjectLike: ()=>z,
    isPhoto: ()=>Hx,
    isPolyglotRetranslatableKey: ()=>mf,
    isPolyglotWritableKey: ()=>Cs,
    isProduction: ()=>mr,
    isProtectedElementMethod: ()=>xs,
    isRevived: ()=>As,
    isSameRoutePage: ()=>nu,
    isStaging: ()=>tw,
    isState: ()=>Lw,
    isString: ()=>E,
    isStringFunction: ()=>ur,
    isStringTag: ()=>ql,
    isTest: ()=>Sh,
    isTesting: ()=>JS,
    isUndefined: ()=>Xt,
    isUniversallyReservedKey: ()=>Cx,
    isUnresolvableDependency: ()=>Ar,
    isValidDependencyMap: ()=>Hs,
    isValidHtmlTag: ()=>dw,
    isWrappedLibrary: ()=>ke,
    joinArrays: ()=>ma,
    jointStacks: ()=>mw,
    jsonForScript: ()=>Ls,
    keys: ()=>Sg,
    lastLevel: ()=>Zy,
    lastPathname: ()=>el,
    lazyHostImportExpr: ()=>Ix,
    libraryIconPruneReplacer: ()=>xk,
    libraryIdentifier: ()=>jg,
    libraryPackageSpecs: ()=>Ks,
    librarySpecsFor: ()=>Pg,
    loadCssFile: ()=>Kx,
    loadJavascript: ()=>Gx,
    loadJavascriptFile: ()=>Vx,
    loadJavascriptFileEmbedSync: ()=>Wx,
    loadJavascriptFileSync: ()=>zx,
    loadLazy: ()=>XA,
    loadRemoteCSS: ()=>qx,
    loadRemoteScript: ()=>Ha,
    log: ()=>Ex,
    logGroupIf: ()=>sw,
    logIf: ()=>rw,
    lookdown: ()=>_x,
    lookdownAll: ()=>bx,
    lookup: ()=>yx,
    lowercaseFirstLetter: ()=>Ss,
    makeObjectWithoutPrototype: ()=>HS,
    map: ()=>BS,
    mapStringsWithContextComponents: ()=>cf,
    markPolyglotSeeded: ()=>ro,
    markRevived: ()=>ka,
    markTextNotReady: ()=>Ia,
    matchRoute: ()=>ev,
    matchesComponentNaming: ()=>oo,
    memoize: ()=>gS,
    merge: ()=>Dt,
    mergeSharedLibraries: ()=>Zf,
    mergeSharedLibraryDesignSystems: ()=>Qf,
    mergeSharedLibraryTranslations: ()=>Jf,
    mergeStateData: ()=>_r,
    nextElement: ()=>Nf,
    normalizeIgnoreList: ()=>za,
    normalizeLibraryKey: ()=>zs,
    objectToString: ()=>Kl,
    objectizeStringProperty: ()=>lf,
    overwrite: ()=>Xl,
    overwriteDeep: ()=>le,
    overwriteShallow: ()=>Os,
    overwriteState: ()=>Mw,
    parse: ()=>wg,
    parseDeep: ()=>vf,
    parseQuery: ()=>nv,
    parseRoutePattern: ()=>Xy,
    payloadHasComputedIconName: ()=>Ug,
    pickStartLang: ()=>ph,
    pickupElementFromProps: ()=>Ih,
    pickupPropsFromElement: ()=>Ph,
    planLibraryIconPrune: ()=>wk,
    polyglotAddressLang: ()=>uh,
    polyglotDefaultLang: ()=>fh,
    polyglotEarlyStartLang: ()=>ys,
    polyglotFallbackLang: ()=>te,
    polyglotLangStorageKey: ()=>Sa,
    polyglotLanguages: ()=>we,
    polyglotSeededKeys: ()=>br,
    polyglotStartLang: ()=>_s,
    polyglotStartRule: ()=>dh,
    polyglotStartupScript: ()=>bS,
    polyglotTranslations: ()=>dr,
    previousElement: ()=>Ff,
    promoteActiveRootState: ()=>La,
    propExists: ()=>Tw,
    propertizeElement: ()=>Mh,
    propertizeUpdate: ()=>kw,
    readBrenderLazyGroups: ()=>fu,
    readBrenderStamp: ()=>Ps,
    readJsonDataBlock: ()=>io,
    recordShadowedComponent: ()=>af,
    reinit: ()=>Mv,
    remove: ()=>VD,
    removeChars: ()=>_k,
    removeCookie: ()=>lw,
    removeDuplicateProps: ()=>hf,
    removeDuplicatesInArray: ()=>ya,
    removeFromArray: ()=>oS,
    removeFromObject: ()=>zS,
    removeNestedKeyByPath: ()=>KS,
    removeValueFromArray: ()=>Bl,
    removeValueFromArrayAll: ()=>aS,
    reorderArrayByValues: ()=>lS,
    repairLegacyArrowScopePreamble: ()=>zl,
    replaceLiteralsWithObjectFields: ()=>Zt,
    replaceOctalEscapeSequences: ()=>kS,
    resolveAsset: ()=>Te,
    resolveComponentTier: ()=>Ah,
    resolveFileReferences: ()=>Cr,
    resolveHandler: ()=>ba,
    resolvePolyglotTranslations: ()=>ms,
    resolveRouterElement: ()=>op,
    resolveSharedLibraries: ()=>tu,
    returnValueAsText: ()=>Nh,
    routeEntryMetadata: ()=>Mo,
    routeEntryPage: ()=>eu,
    router: ()=>xn,
    runGuards: ()=>o$,
    runPluginHook: ()=>Cn,
    runtimeProvidesHostPackageLoader: ()=>Px,
    saveScrollPosition: ()=>Jd,
    scopeElementParam: ()=>hh,
    scopeReceiverExpression: ()=>IS,
    scratchSystem: ()=>uc,
    scratchUtils: ()=>Ir,
    self: ()=>Jb,
    servedSharedLibraries: ()=>sk,
    set: ()=>bi,
    setActiveRootState: ()=>Rf,
    setCookie: ()=>aw,
    setHashedExtend: ()=>xh,
    setInObjectByPath: ()=>GS,
    setLocalStorage: ()=>uw,
    setNodeStyles: ()=>bg,
    setProps: ()=>wx,
    setPropsPrototype: ()=>pf,
    shadowedComponentsOf: ()=>Eh,
    sharedLibrary: ()=>Qx,
    sharedLibraryBagEntry: ()=>qs,
    sharedLibraryDependencies: ()=>rk,
    sharedLibraryFiles: ()=>Gs,
    splitPackageSpecifier: ()=>Vf,
    spotByPath: ()=>Of,
    srcsetFor: ()=>Ga,
    stringIncludesAny: ()=>Ul,
    stringToObject: ()=>$S,
    stripVersionRangePrefix: ()=>zf,
    swapItemsInArray: ()=>rS,
    syncProps: ()=>gf,
    themeColorKey: ()=>Qs,
    toCamelCase: ()=>Bo,
    toDashCase: ()=>pu,
    toDescriptionCase: ()=>Sk,
    toPriorityOrder: ()=>en,
    toTitleCase: ()=>bk,
    toggleFullscreen: ()=>Nx,
    triggerEventOn: ()=>Io,
    triggerEventOnUpdate: ()=>hx,
    trimStringFromSymbols: ()=>wS,
    unstackArrayOfObjects: ()=>Ml,
    update: ()=>Ew,
    updateProps: ()=>vw,
    variables: ()=>$f,
    verbose: ()=>Pa,
    warn: ()=>Bf,
    warnLibraryAliasCollision: ()=>Wa,
    window: ()=>R,
    withPolyglotTranslations: ()=>$l,
    workerNameFromPath: ()=>Dx,
    workerScriptPath: ()=>Rx
});
var xY = {
    group: "group",
    imagePair: "image-pair",
    "image-pair": "image-pair",
    old: "old",
    new: "new"
}, kY = /^(?:\*|\.?-?[_a-zA-Z][\w-]*)$/, TY = /^-?[_a-zA-Z][\w-]*$/, EY = new Set([
    "root",
    "*"
]), AY = "@media (prefers-reduced-motion: no-preference)", vY = "@media (prefers-reduced-motion: reduce)", OY = (t, e)=>{
    let n = E(t) ? {
        animation: t
    } : k(t) ? t : null;
    if (!n) return null;
    let o;
    try {
        o = ne(n, e);
    } catch  {
        return null;
    }
    let r = {};
    for(let s in o){
        let i = o[s];
        (E(i) || be(i)) && (r[s] = i);
    }
    return Object.keys(r).length ? r : null;
}, P2 = (t, e, n = {})=>{
    if (!k(t)) return null;
    let o = !n.scope || n.scope === ":root", r = (l)=>{
        n.verbose;
    }, s = {
        key: "viewTransition",
        state: {},
        context: {
            designSystem: e
        }
    }, i = {}, a = {}, c = (l, f, u)=>{
        for(let d in f){
            if (d === "types" && !u) continue;
            let p = xY[d];
            if (!p) {
                r(`${l}.${d} is not a view-transition part (group, imagePair, old, new)`);
                continue;
            }
            let g = `${u}::view-transition-${p}(${l})`, h = OY(f[d], s);
            h && (i[g] = h, a[g] = {
                animation: "none"
            });
        }
    };
    for(let l in t){
        let f = t[l];
        if (k(f)) {
            if (!kY.test(l)) {
                r(`"${l}" is not a view-transition name`);
                continue;
            }
            if (!o && EY.has(l)) {
                r(`"${l}" belongs to the document's primary app; a scoped app (${n.scope}) emits its own names only`);
                continue;
            }
            if (c(l, f, ""), k(f.types)) for(let u in f.types){
                if (!TY.test(u) || !k(f.types[u])) {
                    r(`${l}.types.${u} is not a view-transition type with parts`);
                    continue;
                }
                c(l, f.types[u], `:root:active-view-transition-type(${u})`);
            }
        }
    }
    return Object.keys(i).length ? {
        [AY]: i,
        [vY]: a
    } : null;
};
var CY = L(), M2 = (t = CY, e)=>{
    let n = k(e.localFile) ? e.localFile : {}, o = ft(n.designSystem || {});
    return mt(t, o, ue);
}, RY = {
    useVariable: !0,
    useReset: !0,
    useFontImport: !0,
    useIconSprite: !0,
    useDocumentTheme: !0,
    useSvgSprite: !0
}, m_ = (t, e)=>{
    let n = !e || e === ":root", o = {};
    for(let r in t)if (r.startsWith("@media")) {
        let s = n ? ":root:not([data-theme])" : `:root:not([data-theme]) ${e}:not([data-theme])`;
        o[r] = {
            [s]: t[r]
        };
    } else n ? o[r] = t[r] : o[`${e}${r}, ${r} ${e}`] = t[r];
    return o;
}, Pv = (t, e)=>{
    t.CSS_MEDIA_VARS && Lt(m_(t.CSS_MEDIA_VARS, e));
    let n = gi(t.cssSkinVars, t.cssSkinFallback, e);
    Object.keys(n).length && Lt(n);
}, B2 = (t, e)=>{
    let n = P2(t.viewTransition, t, {
        scope: e,
        verbose: t.verbose
    });
    n && Lt(n);
}, y_ = (t)=>{
    if (typeof window < "u" && window.location) try {
        let e = new URLSearchParams(window.location.search).get("globalTheme");
        if (e) return e;
    } catch  {}
    return t;
}, I2 = (t, e)=>{
    t.useVariable && (Lt({
        [e]: t.CSS_VARS
    }), Pv(t, e)), t.useReset && Lt(t.reset);
    let n = t.animation;
    if (n) {
        let o = {};
        for(let r in n)o[`@keyframes ${r}`] = n[r];
        Lt(o);
    }
    B2(t, e);
}, N2 = (t, e, n, o, r)=>{
    let s = null;
    return r ? dd(r) : n.recordCss ? s = ud(()=>I2(t, e)) : I2(t, e), (o.svg || t.useSvgSprite) && Qu(t.svg, {
        document: n.document
    }), (o.icons || t.useIconSprite) && yi(t.icons, {
        document: n.document
    }), s;
}, To = (t, e = RY)=>{
    let n = M2(t || {}, e), o = e.scopeSelector || ":root", r = y_(e.globalTheme), s = bi({
        verbose: e.verbose,
        useReset: e.useReset,
        useFontImport: e.useFontImport,
        useVariable: e.useVariable,
        useSvgSprite: e.useSvgSprite,
        useDocumentTheme: e.useDocumentTheme,
        useIconSprite: e.useIconSprite,
        useDefaultConfig: e.useDefaultConfig,
        globalTheme: r,
        themeRoot: e.themeRoot,
        files: e.files,
        assets: e.assets,
        ...n
    }, {
        newConfig: e.newConfig,
        config: e.config
    });
    s && (s.scopeSelector = o);
    let i = {
        svg: !!t.svg,
        icons: !!t.icons
    }, a = N2(s, o, e, i);
    return a && typeof e.recordCss == "function" && e.recordCss({
        rules: a,
        sprites: i
    }), s;
}, Iv = (t, e, n, o)=>{
    let r = n.scopeSelector || ":root";
    if (Dm(t.config, e), n.files !== void 0 && (e.files = n.files), n.assets !== void 0 && (e.assets = n.assets), n.themeRoot !== void 0 && (e.themeRoot = n.themeRoot), Dr(e), Lr(e), sd(e), e.__svgCache = {}, o) {
        pt(e);
        try {
            rd("font", o);
        } finally{
            ut();
        }
    }
    pt(e);
    try {
        N2(e, r, n, t.sprites || {}, t.rules);
    } finally{
        ut();
    }
    return e;
}, __ = {}, Mv = (t, e = __)=>{
    let n = M2(t || {}, e), o = e.scopeSelector || ":root", r = bi({
        verbose: !1,
        ...n
    });
    return e.preventInject || (Lt({
        [o]: r.CSS_VARS
    }), Pv(r, o), Lt(r.reset), B2(r, o)), r;
}, Bv = (t, e = __)=>{
    Lt(t);
}, DY = (t, e = __)=>{
    let n = e.scopeSelector || ":root";
    Lt({
        [n]: t.CSS_VARS
    }), Pv(t, n);
};
var LY = (t, e = __)=>{};
var F2 = 10, PY = (t)=>{
    let e = t && t.window || (typeof window < "u" ? window : null);
    return !!e && typeof e.requestAnimationFrame == "function";
}, IY = (t)=>{
    try {
        let e = t.defaultView;
        return e && e.frameElement || null;
    } catch  {
        return null;
    }
}, MY = (t)=>{
    let e = t && t.document || (typeof document < "u" ? document : null);
    if (!e) return ()=>!0;
    let n = !!e.defaultView, o = IY(e);
    return ()=>!(n && !e.defaultView || o && !o.isConnected);
}, $2 = Symbol("smbls.bootGone"), j2 = (t)=>{
    let e, n = {
        live: MY(t),
        dead: !1,
        gone: new Promise((o)=>{
            e = o;
        }),
        lost () {
            n.dead || (n.dead = !0, e($2));
        }
    };
    return n;
}, cl = (t)=>t ? t.dead ? !1 : t.live() ? !0 : (zd(t), !1) : !0, BY = (t, e)=>e ? Promise.race([
        t,
        e.gone
    ]) : t, rs = async (t, e)=>await BY(t, e) !== $2 && cl(e), Nv = (t)=>{
    if (!(!t || !t.__ref)) try {
        Sn(t);
    } catch  {}
}, U2 = new WeakSet, qi = (t)=>(U2.add(t), t), pp = (t)=>!!t && typeof t == "object" && U2.has(t), H2 = (t)=>{
    let e = t && typeof t == "object" ? t.firstRender : void 0;
    if (e === !1 || !PY(t)) return null;
    if (e === void 0 || e === !0) return {
        budget: F2,
        progressive: !1
    };
    if (e && typeof e == "object") {
        let o = e.budget === void 0 ? F2 : wo(e.budget);
        return o ? {
            budget: o,
            progressive: e.progressive === !0
        } : null;
    }
    let n = wo(e);
    return n ? {
        budget: n,
        progressive: !1
    } : null;
}, Fv = new WeakMap, $v = (t, e)=>(Fv.set(t, e), e), jv = (t)=>{
    Fv.delete(t);
}, V2 = (t)=>{
    let e = t && Fv.get(t);
    return !e || e.routeTaken ? null : (e.routeTaken = !0, e);
}, NY = Object.freeze({
    deferAttach: !0
}), S_ = async (t, e, n, o, r)=>{
    let s = r.lease || null;
    if (await xo(), !cl(s)) return null;
    let i = o.mountYield;
    i === void 0 && (o.mountYield = r.budget);
    let a = o.mountWhole;
    a === void 0 && (o.mountWhole = !r.progressive), r.pageOptions = {
        mountYield: o.mountYield,
        mountWhole: o.mountWhole
    };
    let c;
    r.commit = new Promise((d)=>{
        c = d;
    }), r.committed = !1;
    let l = !r.progressive;
    $v(n, r);
    let f = Ri(), u = null;
    s && (n.__mountLease = s);
    try {
        if (u = Gt(t, e, n.key, o, l ? NY : void 0), !await rs(Gn(u), s) || r.routeReady && !await rs(r.routeReady, s) || !await rs(ae(), s)) return b_(u);
        for(; !Qr();)if (!await rs(ae(), s)) return b_(u);
        return l && (typeof r.beforeAttach == "function" && r.beforeAttach(), qr(u), typeof r.afterAttach == "function" && r.afterAttach(u)), r.committed = !0, c(), r.page && await Gn(r.page), await ae(), u;
    } finally{
        r.committed = !0, c(), f(), o.mountYield = i, o.mountWhole = a, s && (n.__mountLease = null), jv(n);
    }
}, b_ = (t)=>(Nv(t), null);
var W2 = (t)=>!t || t === "srcdoc" || t === "about:srcdoc" || t === "blank" || t === "about:blank" ? "/" : t, FY = (t)=>{
    let e = t && t.initialPath;
    return typeof e != "string" || !e ? null : e[0] === "/" ? e : "/" + e;
}, Hv = {
    initRouter: !0,
    injectRouterInLinkComponent: !0,
    popState: !0
}, $Y = (t, e)=>{
    if (!e) return t;
    let n = Array.isArray(e) ? e : e.split("."), o = t;
    for (let r of n){
        if (!o || !o[r]) return null;
        o = o[r];
    }
    return o;
}, hp = (t, e)=>(op || $Y)(t, e), jY = [
    "manual",
    "auto",
    "restore"
], Uv = new WeakMap, z2 = (t, e)=>{
    let n = e.claims[e.claims.length - 1], o = n ? n.value : e.found;
    t.scrollRestoration !== o && (t.scrollRestoration = o);
}, UY = (t, e)=>{
    let n = e && e.scrollRestoration;
    if (n != null) {
        if (!jY.includes(n)) {
            if (t.verbose !== !1) {
                let o = typeof n == "string" ? JSON.stringify(n) : `a ${typeof n}`;
            }
            return;
        }
        try {
            let o = t.window || R, r = o && o.history;
            if (!r || !("scrollRestoration" in r)) return;
            let s = Uv.get(r);
            s || (s = {
                found: r.scrollRestoration,
                claims: []
            }, Uv.set(r, s));
            let i = {
                value: n === "restore" ? "manual" : n
            };
            s.claims.push(i), z2(r, s), t.__teardowns = t.__teardowns || [], t.__teardowns.push(()=>{
                let a = s.claims.indexOf(i);
                if (a !== -1) {
                    s.claims.splice(a, 1), s.claims.length || Uv.delete(r);
                    try {
                        z2(r, s);
                    } catch  {}
                }
            });
        } catch  {}
    }
}, HY = (t, e)=>{
    if (!e || e.scrollRestoration !== "restore") return;
    let n = Jd, o = t.window || R;
    if (typeof n != "function" || !o || typeof o.addEventListener != "function") return;
    let r = t.document || o.document, s = ()=>n(o), i = ()=>{
        r.visibilityState === "hidden" && n(o);
    };
    o.addEventListener("pagehide", s);
    let a = !!r && typeof r.addEventListener == "function";
    a && r.addEventListener("visibilitychange", i), t.__teardowns = t.__teardowns || [], t.__teardowns.push(()=>{
        o.removeEventListener("pagehide", s), a && r.removeEventListener("visibilitychange", i);
    });
}, K2 = (t, e)=>{
    if (e.router === !1) return;
    e.router === !0 ? e.router = Hv : e.router = Dt(e.router || {}, Hv);
    let n = e.router;
    UY(e, n), HY(e, n);
    let o = (i, a)=>{
        let c = i.context?.window || R, l = FY(n);
        if (!l) {
            if (!c.location) return;
            let { pathname: u, search: d, hash: p } = c.location;
            u = W2(u), l = u + d + p;
        }
        let f = i;
        if (n.customRouterElement) {
            let u = hp(i, n.customRouterElement);
            u && (f = u, i.routes && (f.routes = i.routes));
        }
        if (f.routes) return xn(l, f, {}, {
            initialRender: !0,
            pushState: !1,
            ...a
        });
    }, r = async (i, a)=>{
        let c = V2(i.context);
        if (c) return VY(i, c, o);
        await o(i);
    }, s = !Xt(t.onRenderRouter);
    return n && n.initRouter && !s && (t.onRenderRouter = (i, a)=>e.__firstNavigation = r(i, a)), zY(e, n), n;
}, VY = (t, e, n)=>{
    let o;
    return e.routeReady = new Promise((s)=>{
        o = s;
    }), (async ()=>{
        try {
            if (await xo(), !t.__ref || !cl(e.lease)) return;
            let s = n(t, e.progressive ? {
                mountOptions: e.pageOptions
            } : {
                mountOptions: e.pageOptions,
                firstView: e
            });
            await ae(), o(), await s;
        } finally{
            o();
        }
    })();
}, Vv = (t, e)=>{
    if (e.router === !1) return;
    let n = e.router || Hv;
    if (!n.popState) return;
    let o = e.utils && e.utils.router ? e.utils.router : xn, r = e.window || R, s = async (i)=>{
        let { pathname: a, search: c, hash: l } = r.location;
        a = W2(a);
        let f = a + c + l, u = t;
        if (n.customRouterElement) {
            let d = hp(t, n.customRouterElement);
            d && (u = d, t.routes && (u.routes = t.routes));
        }
        await u.call("router", f, u, {}, {
            pushState: !1,
            scrollToTop: !1,
            level: 0,
            event: i
        });
    };
    r.addEventListener("popstate", s), e.__teardowns = e.__teardowns || [], e.__teardowns.push(()=>r.removeEventListener("popstate", s));
}, zY = (t, e)=>{
    let { components: n } = t;
    if (e && e.injectRouterInLinkComponent) return mt(n.Link || n["smbls.Link"], n.RouterLink || n["smbls.RouterLink"]);
};
var Qv = /*@__PURE__*/ F({}, {
    components: ()=>Xv,
    functions: ()=>ir
});
var Zv = /*@__PURE__*/ F({}, {
    AlertTemplate: ()=>D_,
    ConfirmTemplate: ()=>R_,
    CustomTemplate: ()=>P_,
    ModalLayer: ()=>C_,
    ModalRoot: ()=>O_,
    PromptTemplate: ()=>L_,
    windowsComponents: ()=>Xv
});
var Kv = /*@__PURE__*/ F({}, {
    alertDialog: ()=>A_,
    closeAllModals: ()=>T_,
    closeModal: ()=>k_,
    confirmDialog: ()=>E_,
    getLayer: ()=>w_,
    openModal: ()=>x_,
    promptDialog: ()=>v_,
    windowsFunctions: ()=>ir
});
function rt(t) {
    let e = t;
    for(; e;){
        if (e.layer !== void 0) return e.layer;
        e = e.parent;
    }
    return null;
}
function Yn(t) {
    let e = t;
    for(; e;){
        if (e.layer !== void 0) return !!e.layerExiting;
        e = e.parent;
    }
    return !1;
}
function Eo(t) {
    let e = t?.title;
    return e == null ? "" : String(e).trim();
}
function Ao(t, e) {
    return !t || !t.id || t.template !== e ? null : e === "custom" ? Eo(t) ? "modal-title-" + t.id : null : e === "confirm" || e === "alert" || e === "prompt" ? "modal-title-" + t.id : null;
}
function ll(t) {
    let e = t;
    for(; e;){
        if (e.key === "ModalRoot") return e;
        if (e.ModalRoot && e.ModalRoot.__ref) return e.ModalRoot;
        e = e.parent;
    }
    let n = t?.getRoot?.();
    return n?.ModalRoot ? n.ModalRoot : typeof globalThis < "u" && globalThis.__SMBLS_WINDOWS_MODAL_ROOT__?.__ref ? globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ : null;
}
function w_() {
    return rt(this);
}
var WY = "(prefers-reduced-motion: reduce)", zv = (t)=>t?.node || t?.__ref?.node || null, Wv = (t, e)=>zv(t && t["ModalLayer_" + e]), KY = ()=>typeof window < "u" && typeof window.matchMedia == "function" && !!window.matchMedia(WY).matches, q2 = (t, e)=>{
    let n = Wv(t, e);
    !n || typeof n.style?.setProperty != "function" || (n.style.setProperty("display", "none", "important"), n.style.setProperty("opacity", "0", "important"), n.style.setProperty("visibility", "hidden", "important"), n.style.setProperty("pointer-events", "none", "important"));
}, GY = (t, e)=>{
    let n = Wv(t, e);
    !n || typeof n.style?.removeProperty != "function" || (n.style.removeProperty("display"), n.style.removeProperty("opacity"), n.style.removeProperty("visibility"), n.style.removeProperty("pointer-events"));
}, qY = (t, e)=>{
    let n = Wv(t, e);
    return !!n && typeof n.getAnimations == "function" && !KY();
}, G2 = (t)=>{
    if (!t || typeof t.getAnimations != "function") return [];
    let e = [];
    for (let n of t.getAnimations()){
        let o = typeof n?.effect?.getComputedTiming == "function" ? n.effect.getComputedTiming() : null;
        o && o.iterations === 1 / 0 || typeof n?.finished?.then == "function" && e.push(n.finished.then(()=>{}, ()=>{}));
    }
    return e;
};
function YY(t, e, n) {
    if (!t?.__ref) return;
    let o = t.__layerExits;
    if (!o || o[e] !== n) return;
    delete o[e];
    let r = t.state;
    if (r) {
        if (r.leaving?.[e]) {
            let s = Array.from(r.leaving);
            s[e] = null, r.update({
                leaving: s
            });
        }
        r.stack?.[e] || q2(t, e);
    }
}
var XY = (t)=>{
    typeof requestAnimationFrame == "function" ? requestAnimationFrame(()=>t()) : setTimeout(t, 0);
}, ZY = (t, e, n)=>{
    XY(()=>{
        if (!t.__ref || t.__layerExits?.[e] !== n) return;
        let o = t["ModalLayer_" + e];
        Promise.all([
            ...G2(zv(o)),
            ...G2(zv(o?.ModalWindow))
        ]).then(()=>YY(t, e, n));
    });
};
function Y2(t, e) {
    t.__layerExits && delete t.__layerExits[e], GY(t, e);
    let n = t.state?.leaving;
    if (!n?.[e]) return null;
    let o = Array.from(n);
    return o[e] = null, o;
}
function Yi(t, e) {
    let n = t?.state, o = n?.stack || [], r = [], s = [], i = [];
    for(let d = 0; d < o.length; d++){
        let p = !!e(o[d], d);
        i[d] = !p, p ? r.push(o[d]) : s.push(o[d]);
    }
    if (!s.length) return s;
    let a = n.leaving || [], c = Array.from(a), l = [], f = [];
    for(let d = r.length; d < o.length; d++)i[d] && qY(t, d) ? (c[d] = o[d], l.push(d)) : (c[d] = null, f.push(d));
    let u = c.some((d, p)=>(d || null) !== (a[p] || null));
    n.update(u ? {
        stack: r,
        leaving: c
    } : {
        stack: r
    });
    for (let d of f)q2(t, d);
    if (l.length) {
        t.__layerExits || (t.__layerExits = {});
        for (let d of l){
            let p = {};
            t.__layerExits[d] = p, ZY(t, d, p);
        }
    }
    return s;
}
function x_(t = {}) {
    let e = ll(this);
    if (!e) return null;
    e.__modalIdCounter = (e.__modalIdCounter || 0) + 1;
    let n = t.id || `modal_${e.__modalIdCounter}_${Date.now().toString(36)}`, o = {
        id: n,
        template: t.template || "custom",
        title: t.title,
        message: t.message,
        icon: t.icon,
        confirmText: t.confirmText,
        cancelText: t.cancelText,
        okText: t.okText,
        confirmTheme: t.confirmTheme,
        placeholder: t.placeholder,
        defaultValue: t.defaultValue,
        dismissOnBackdrop: t.dismissOnBackdrop,
        content: t.content,
        width: t.width,
        maxWidth: t.maxWidth,
        maxHeight: t.maxHeight,
        onConfirm: t.onConfirm,
        onCancel: t.onCancel,
        onOk: t.onOk,
        onClose: t.onClose
    }, r = e.state?.stack || [];
    if (r.length >= 5) return console.warn("[windows] openModal: stack already at the 5-layer maximum, dropping the new layer. Close some modals first."), null;
    let s = r.length, i = Y2(e, s);
    return e.state.update(i ? {
        stack: [
            ...r,
            o
        ],
        leaving: i
    } : {
        stack: [
            ...r,
            o
        ]
    }), n;
}
function k_(t) {
    let e = ll(this);
    if (!e) return;
    let n = e.state?.stack || [];
    if (!n.length) return;
    let o = n.length - 1, r = Yi(e, t ? (s)=>s.id !== t : (s, i)=>i !== o);
    for (let s of r)if (typeof s.onClose == "function") try {
        s.onClose();
    } catch (i) {
        console.warn("[windows] onClose threw:", i);
    }
}
function T_() {
    let t = ll(this);
    if (!t) return;
    let e = Yi(t, ()=>!1);
    for(let n = e.length - 1; n >= 0; n--){
        let o = e[n];
        if (typeof o?.onClose == "function") try {
            o.onClose();
        } catch (r) {
            console.warn("[windows] onClose threw:", r);
        }
    }
}
function E_(t) {
    let e = typeof t == "string" ? {
        message: t
    } : t || {};
    return this.call("openModal", {
        ...e,
        template: "confirm"
    });
}
function A_(t) {
    let e = typeof t == "string" ? {
        message: t
    } : t || {};
    return this.call("openModal", {
        ...e,
        template: "alert"
    });
}
function v_(t) {
    let e = typeof t == "string" ? {
        message: t
    } : t || {};
    return this.call("openModal", {
        ...e,
        template: "prompt"
    });
}
var ir = {
    openModal: x_,
    closeModal: k_,
    closeAllModals: T_,
    confirmDialog: E_,
    alertDialog: A_,
    promptDialog: v_,
    getLayer: w_
};
var QY = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
].join(","), X2 = (t)=>{
    if (!t?.querySelectorAll) return [];
    let e = t.querySelectorAll(QY), n = [];
    for(let o = 0; o < e.length; o++){
        let r = e[o];
        (r.offsetParent !== null || r === document.activeElement) && n.push(r);
    }
    return n;
}, JY = (t)=>{
    if (!t?.querySelectorAll) return !1;
    let e = t.querySelectorAll("[autofocus]");
    for(let n = 0; n < e.length; n++){
        let o = e[n];
        if (!(o.offsetParent === null || o.matches(":disabled") || typeof o.focus != "function")) {
            try {
                o.focus();
            } catch  {
                continue;
            }
            if (document.activeElement === o) return !0;
        }
    }
    return !1;
}, Z2 = (t)=>{
    let e = t.state?.stack || [];
    if (!e.length) return null;
    let n = t["ModalLayer_" + (e.length - 1)];
    return n?.node || n?.__ref?.node || null;
}, O_ = {
    tag: "div",
    position: "fixed",
    inset: "0",
    zIndex: "2000",
    pointerEvents: "none",
    state: {
        stack: [],
        leaving: []
    },
    subscribeTo: [
        "stack"
    ],
    ModalLayer_0: {
        __slotIndex: 0,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (t, e)=>e?.stack?.[0] || e?.leaving?.[0] || null,
        layerExiting: (t, e)=>!e?.stack?.[0] && !!e?.leaving?.[0],
        opacity: (t)=>t.layer && !t.layerExiting ? "1" : "0",
        visibility: (t)=>t.layer ? "visible" : "hidden",
        pointerEvents: (t)=>t.layer && !t.layerExiting ? "auto" : "none"
    },
    ModalLayer_1: {
        __slotIndex: 1,
        deferUntil: (t, e)=>(e?.stack?.length || 0) >= 1,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (t, e)=>e?.stack?.[1] || e?.leaving?.[1] || null,
        layerExiting: (t, e)=>!e?.stack?.[1] && !!e?.leaving?.[1],
        opacity: (t)=>t.layer && !t.layerExiting ? "1" : "0",
        visibility: (t)=>t.layer ? "visible" : "hidden",
        pointerEvents: (t)=>t.layer && !t.layerExiting ? "auto" : "none"
    },
    ModalLayer_2: {
        __slotIndex: 2,
        deferUntil: (t, e)=>(e?.stack?.length || 0) >= 2,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (t, e)=>e?.stack?.[2] || e?.leaving?.[2] || null,
        layerExiting: (t, e)=>!e?.stack?.[2] && !!e?.leaving?.[2],
        opacity: (t)=>t.layer && !t.layerExiting ? "1" : "0",
        visibility: (t)=>t.layer ? "visible" : "hidden",
        pointerEvents: (t)=>t.layer && !t.layerExiting ? "auto" : "none"
    },
    ModalLayer_3: {
        __slotIndex: 3,
        deferUntil: (t, e)=>(e?.stack?.length || 0) >= 3,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (t, e)=>e?.stack?.[3] || e?.leaving?.[3] || null,
        layerExiting: (t, e)=>!e?.stack?.[3] && !!e?.leaving?.[3],
        opacity: (t)=>t.layer && !t.layerExiting ? "1" : "0",
        visibility: (t)=>t.layer ? "visible" : "hidden",
        pointerEvents: (t)=>t.layer && !t.layerExiting ? "auto" : "none"
    },
    ModalLayer_4: {
        __slotIndex: 4,
        deferUntil: (t, e)=>(e?.stack?.length || 0) >= 4,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (t, e)=>e?.stack?.[4] || e?.leaving?.[4] || null,
        layerExiting: (t, e)=>!e?.stack?.[4] && !!e?.leaving?.[4],
        opacity: (t)=>t.layer && !t.layerExiting ? "1" : "0",
        visibility: (t)=>t.layer ? "visible" : "hidden",
        pointerEvents: (t)=>t.layer && !t.layerExiting ? "auto" : "none"
    },
    onInit: (t, e)=>{
        if (typeof window > "u") return;
        globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ = t;
        let n = t.context;
        if (n) {
            n.functions || (n.functions = {});
            for(let c in ir)c in n.functions || (n.functions[c] = ir[c]);
        }
        t.__modalOpeners = t.__modalOpeners || [], t.__prevStackLen = t.state && t.state.stack && t.state.stack.length || 0;
        let o = (c)=>{
            if (typeof c?.onCancel == "function") try {
                c.onCancel();
            } catch (l) {
                console.warn("[windows] onCancel threw:", l);
            }
            if (typeof c?.onClose == "function") try {
                c.onClose();
            } catch (l) {
                console.warn("[windows] onClose threw:", l);
            }
        }, r = ()=>{
            let c = (t.state?.stack || []).length - 1;
            if (!(c < 0)) for (let l of Yi(t, (f, u)=>u !== c))o(l);
        }, s = (c)=>{
            let l = t.state?.stack;
            if (l?.length) {
                if (c.key === "Tab") {
                    let f = Z2(t);
                    if (!f) return;
                    let u = X2(f);
                    if (!u.length) {
                        c.preventDefault();
                        let m = f.querySelector?.('[role="dialog"]') || f;
                        try {
                            m.focus?.();
                        } catch  {}
                        return;
                    }
                    let d = u[0], p = u[u.length - 1], g = document.activeElement;
                    if (!f.contains(g)) {
                        c.preventDefault();
                        try {
                            d.focus();
                        } catch  {}
                        return;
                    }
                    if (c.shiftKey && g === d) {
                        c.preventDefault();
                        try {
                            p.focus();
                        } catch  {}
                    } else if (!c.shiftKey && g === p) {
                        c.preventDefault();
                        try {
                            d.focus();
                        } catch  {}
                    }
                    return;
                }
                c.key !== "Escape" || c.defaultPrevented || l[l.length - 1]?.dismissOnBackdrop !== !1 && (c.preventDefault(), r());
            }
        };
        window.addEventListener("keydown", s), t.__escHandler = s;
        let i = (c)=>{
            let l = t.state?.stack || [];
            if (!(c < 0 || c >= l.length)) for (let f of Yi(t, (u, d)=>d !== c))o(f);
        }, a = (c)=>{
            let l = t.state?.stack || [];
            if (!l.length) return;
            let f = c.target?.closest?.('[data-key="Close"]');
            if (f) {
                for(let u = l.length - 1; u >= 0; u--){
                    let d = t["ModalLayer_" + u], p = d?.node || d?.__ref?.node;
                    if (p && p.contains(f)) {
                        c.preventDefault(), c.stopPropagation(), i(u);
                        return;
                    }
                }
                return;
            }
            for(let u = l.length - 1; u >= 0; u--){
                let d = t["ModalLayer_" + u];
                if ((d?.node || d?.__ref?.node) === c.target) {
                    if (l[u]?.dismissOnBackdrop === !1) return;
                    c.preventDefault(), c.stopPropagation(), i(u);
                    return;
                }
            }
        };
        document.addEventListener("click", a, !0), t.__clickDelegate = a;
    },
    onUpdate: (t)=>{
        if (typeof window > "u") return;
        let n = (t.state && t.state.stack || []).length, o = t.__prevStackLen || 0;
        if (n !== o) {
            if (t.__prevStackLen = n, t.__modalOpeners = t.__modalOpeners || [], n > o) t.__modalOpeners[n] = document.activeElement && document.activeElement !== document.body ? document.activeElement : t.__modalOpeners[n] || null, typeof requestAnimationFrame == "function" && requestAnimationFrame(()=>{
                let r = Z2(t);
                if (!r || JY(r)) return;
                let i = X2(r)[0] || r.querySelector && r.querySelector('[role="dialog"]') || r;
                try {
                    i.focus && i.focus();
                } catch  {}
            });
            else {
                let r = null;
                for(let s = o; s > n; s--)t.__modalOpeners[s] && (r = r || t.__modalOpeners[s]), t.__modalOpeners[s] = null;
                if (r && typeof r.focus == "function" && r.isConnected !== !1) try {
                    r.focus();
                } catch  {}
            }
        }
    },
    onDestroy: (t)=>{
        typeof window > "u" || (globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ === t && (globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ = null), t.__escHandler && (window.removeEventListener("keydown", t.__escHandler), delete t.__escHandler), t.__clickDelegate && (document.removeEventListener("click", t.__clickDelegate, !0), delete t.__clickDelegate));
    }
};
var C_ = {
    tag: "div",
    position: "fixed",
    inset: "0",
    alignItems: "center",
    justifyContent: "center",
    padding: "A",
    "@mobileL": {
        padding: "0",
        alignItems: "flex-end"
    },
    childExtends: "ModalPhoneSheet",
    theme: "backdrop",
    transition: "opacity C defaultBezier",
    zIndex: (t, e)=>`${2e3 + (t.__slotIndex || 0) * 10}`,
    display: (t, e)=>t.layer ? "flex" : "none",
    opacity: (t, e)=>t.layer && !t.layerExiting ? "1" : "0",
    visibility: (t, e)=>t.layer ? "visible" : "hidden",
    pointerEvents: (t, e)=>t.layer && !t.layerExiting ? "auto" : "none",
    inert: (t)=>!!t.layerExiting,
    ModalWindow: {
        attr: {
            role: "dialog",
            "aria-modal": "true",
            tabindex: "-1",
            "aria-labelledby": (t)=>{
                let e = rt(t);
                return Ao(e, e?.template);
            }
        },
        width: (t)=>rt(t)?.width || "H",
        maxWidth: (t)=>rt(t)?.maxWidth || "90vw",
        flow: "y",
        maxHeight: (t)=>rt(t)?.maxHeight || "100%",
        animation: "modalIn",
        animationDuration: "D",
        animationTimingFunction: "springBezier",
        isLayerExiting: (t)=>Yn(t),
        ".isLayerExiting": {
            animationName: "modalOut",
            animationDuration: "C",
            animationTimingFunction: "defaultBezier",
            animationFillMode: "forwards",
            "@mobileL": {
                animationName: "modalOutDown"
            }
        },
        onClick: (t)=>t.stopPropagation(),
        onMousedown: (t)=>t.stopPropagation(),
        ModalHeader: {
            display: "none"
        },
        overflow: "visible",
        ConfirmTemplate: {
            hide: (t)=>rt(t)?.template !== "confirm"
        },
        AlertTemplate: {
            hide: (t)=>rt(t)?.template !== "alert"
        },
        PromptTemplate: {
            hide: (t)=>rt(t)?.template !== "prompt"
        },
        CustomTemplate: {
            hide: (t)=>rt(t)?.template !== "custom"
        }
    }
};
var Q2 = (t, e, n)=>rt(t)?.[e] || n, Gv = (t, e, n)=>rt(t)?.[e] || ce(t, n), tX = (t)=>{
    let e = rt(t)?.icon;
    return e === null || e === !1;
}, R_ = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    ModalHeader: {
        Hgroup: {
            H: {
                text: (t)=>Eo(rt(t)) || ce(t, "dialog.confirmTitle"),
                attr: {
                    id: (t)=>Ao(rt(t), "confirm")
                }
            },
            P: {
                if: ()=>!1
            }
        },
        Icons: {
            hide: (t)=>tX(t),
            Indicator: {
                extends: "Icon",
                opacity: ".7",
                icon: (t)=>Q2(t, "icon", "warning")
            }
        }
    },
    ModalBody: {
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        P: {
            tag: "p",
            margin: "0",
            text: (t)=>Gv(t, "message", "dialog.confirmMessage"),
            color: "inactive"
        }
    },
    ModalFooter: {
        flow: "x",
        gap: "Z1",
        align: "center end",
        flexShrink: "0",
        CancelBtn: {
            extends: "CancelButton",
            text: (t)=>Gv(t, "cancelText", "dialog.cancel"),
            onClick: (t, e, n)=>{
                if (Yn(e)) return;
                let o = rt(e);
                if (o?.onCancel) try {
                    o.onCancel();
                } catch (r) {
                    console.warn("[windows] confirm.onCancel threw:", r);
                }
                e.call("closeModal", o?.id);
            }
        },
        ConfirmBtn: {
            extends: "Button",
            theme: (t)=>Q2(t, "confirmTheme", "primary"),
            text: (t)=>Gv(t, "confirmText", "dialog.confirm"),
            onClick: (t, e, n)=>{
                if (Yn(e)) return;
                let o = rt(e);
                if (o?.onConfirm) try {
                    o.onConfirm();
                } catch (r) {
                    console.warn("[windows] confirm.onConfirm threw:", r);
                }
                e.call("closeModal", o?.id);
            }
        }
    }
};
var qv = (t, e, n)=>rt(t)?.[e] || n, eX = (t, e, n)=>rt(t)?.[e] || ce(t, n), D_ = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    ModalHeader: {
        Hgroup: {
            H: {
                text: (t)=>Eo(rt(t)) || ce(t, "dialog.alertTitle"),
                attr: {
                    id: (t)=>Ao(rt(t), "alert")
                }
            },
            P: {
                if: ()=>!1
            }
        },
        Icons: {
            Indicator: {
                extends: "Icon",
                opacity: ".7",
                icon: (t)=>qv(t, "icon", "info")
            }
        }
    },
    ModalBody: {
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        hide: (t)=>!qv(t, "message", ""),
        P: {
            tag: "p",
            margin: "0",
            text: (t)=>qv(t, "message", ""),
            color: "inactive"
        }
    },
    ModalFooter: {
        flow: "x",
        align: "center end",
        flexShrink: "0",
        OkBtn: {
            extends: "Button",
            theme: "primary",
            text: (t)=>eX(t, "okText", "dialog.ok"),
            onClick: (t, e, n)=>{
                if (Yn(e)) return;
                let o = rt(e);
                if (o?.onOk) try {
                    o.onOk();
                } catch (r) {
                    console.warn("[windows] alert.onOk threw:", r);
                }
                e.call("closeModal", o?.id);
            }
        }
    }
};
var Yv = (t, e, n)=>rt(t)?.[e] || n, J2 = (t, e, n)=>rt(t)?.[e] || ce(t, n), L_ = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    scope: {
        value: ""
    },
    onRender: (t, e)=>{
        let n = rt(t);
        if (!n || t.scope._seededLayerId === n.id) return;
        t.scope._seededLayerId = n.id, t.scope.value = n.defaultValue || "";
        let o = t.InputRow && t.InputRow.node;
        o && (o.value = t.scope.value);
    },
    onUpdate: (t, e)=>{
        let n = rt(t);
        if (!n || t.scope._seededLayerId === n.id) return;
        t.scope._seededLayerId = n.id, t.scope.value = n.defaultValue || "";
        let o = t.InputRow && t.InputRow.node;
        o && (o.value = t.scope.value);
    },
    ModalHeader: {
        Hgroup: {
            H: {
                text: (t)=>Eo(rt(t)) || ce(t, "dialog.promptTitle"),
                attr: {
                    id: (t)=>Ao(rt(t), "prompt")
                }
            },
            P: {
                if: ()=>!1
            }
        }
    },
    ModalBody: {
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        hide: (t)=>!Yv(t, "message", ""),
        P: {
            tag: "p",
            margin: "0",
            text: (t)=>Yv(t, "message", ""),
            color: "inactive"
        }
    },
    InputRow: {
        extends: "Input",
        flexShrink: "0",
        autofocus: !0,
        placeholder: (t)=>Yv(t, "placeholder", ""),
        value: (t, e)=>t.parent.scope?.value || "",
        onInput: (t, e, n)=>{
            e.parent.scope.value = t.target.value;
        },
        onKeydown: (t, e, n)=>{
            if (t.key !== "Enter" || Yn(e)) return;
            t.preventDefault();
            let o = rt(e), r = e.parent.scope?.value || "";
            if (o?.onConfirm) try {
                o.onConfirm(r);
            } catch (s) {
                console.warn("[windows] prompt.onConfirm threw:", s);
            }
            e.call("closeModal", o?.id);
        }
    },
    ModalFooter: {
        flow: "x",
        gap: "Z1",
        align: "center end",
        flexShrink: "0",
        CancelBtn: {
            extends: "CancelButton",
            text: (t)=>J2(t, "cancelText", "dialog.cancel"),
            onClick: (t, e, n)=>{
                if (Yn(e)) return;
                let o = rt(e);
                if (o?.onCancel) try {
                    o.onCancel();
                } catch (r) {
                    console.warn("[windows] prompt.onCancel threw:", r);
                }
                e.call("closeModal", o?.id);
            }
        },
        ConfirmBtn: {
            extends: "Button",
            theme: "primary",
            text: (t)=>J2(t, "confirmText", "dialog.ok"),
            onClick: (t, e, n)=>{
                if (Yn(e)) return;
                let o = rt(e), r = e.parent.parent.scope?.value || "";
                if (o?.onConfirm) try {
                    o.onConfirm(r);
                } catch (s) {
                    console.warn("[windows] prompt.onConfirm threw:", s);
                }
                e.call("closeModal", o?.id);
            }
        }
    }
};
var P_ = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    Title: {
        tag: "h2",
        text: (t)=>Eo(rt(t)),
        hide: (t)=>!Eo(rt(t)),
        position: "absolute",
        width: "1px",
        height: "1px",
        margin: "-1px",
        padding: "0",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: "0",
        attr: {
            id: (t)=>Ao(rt(t), "custom")
        }
    },
    Slot: {
        tag: "div",
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        onInit: (t)=>{
            let e = q(()=>{
                let n = rt(t), o = n?.content || null, r = n?.id || null;
                if (!o) {
                    t.__lastLayerId != null && (t.removeContent(), t.__lastLayerId = null);
                    return;
                }
                if (t.__lastLayerId !== r) {
                    t.__lastLayerId = r;
                    try {
                        t.set(o);
                        let s = t.content?.context;
                        if (s) {
                            s.functions || (s.functions = {});
                            for(let i in ir)i in s.functions || (s.functions[i] = ir[i]);
                        }
                    } catch (s) {
                        console.warn("[windows] custom.content set failed:", s);
                    }
                }
            });
            t.__ref && t.__ref.__effects.push(e);
        }
    }
};
var tj = {
    extends: "Button",
    theme: "tertiary"
};
var ej = {
    theme: "dialog",
    padding: "B",
    round: "radiusSheet"
}, nj = {
    flow: "x",
    align: "start space-between",
    gap: "A"
};
var oj = {
    "@mobileL": {
        position: "relative",
        boxSizing: "border-box",
        minWidth: "100%",
        maxHeight: "92%",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        borderBottomWidth: "env(safe-area-inset-bottom)",
        borderBottomStyle: "solid",
        borderBottomColor: "transparent",
        animationName: "modalInUp",
        transformOrigin: "bottom center"
    },
    SheetGrabber: {
        "aria-hidden": "true",
        display: "none",
        position: "absolute",
        top: "Y",
        left: "50%",
        width: "grabberW",
        height: "grabberH",
        round: "radiusPill",
        background: "line",
        transform: "translateX(-50%)",
        pointerEvents: "none",
        "@mobileL": {
            display: "block"
        }
    }
};
var Xv = {
    ModalRoot: O_,
    ModalLayer: C_,
    ConfirmTemplate: R_,
    AlertTemplate: D_,
    PromptTemplate: L_,
    CustomTemplate: P_,
    "smbls.CancelButton": tj,
    "smbls.ModalWindow": ej,
    "smbls.ModalHeader": nj,
    "smbls.ModalPhoneSheet": oj
};
var aO = /*@__PURE__*/ F({}, {
    components: ()=>oO,
    functions: ()=>sO
});
var rO = /*@__PURE__*/ F({}, {
    Dropdown: ()=>$_,
    DropdownList: ()=>j_,
    DropdownParent: ()=>U_,
    DropdownParentFocus: ()=>H_,
    DropdownRoot: ()=>N_,
    DropdownSiblingFocus: ()=>V_,
    DropdownTrigger: ()=>F_,
    dropdownComponents: ()=>oO
});
var rj = (t, e, n)=>({
        bottom: n - t.bottom,
        top: t.top,
        right: e - t.right,
        left: t.left
    }), nX = (t, e, n, o)=>{
    let r = rj(t, n, o), s = (i)=>r[i] >= e.height + 8;
    return s("bottom") ? "bottom" : s("top") ? "top" : r.bottom >= r.top ? "bottom" : "top";
}, oX = (t, e, n, o, r)=>{
    let s = rj(e, o, r), i = t === "top" || t === "bottom" ? n.height + 8 : n.width + 8;
    if (s[t] >= i) return t;
    let a = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
    }[t];
    return a && s[a] >= i || a && s[a] > s[t] ? a : t;
};
var Jv = (t, e, n)=>{
    let o;
    return t === "bottom" ? o = n - e.bottom - 16 : t === "top" ? o = e.top - 16 : o = n - 16, Math.max(40, Math.floor(o));
}, I_ = (t, e, n)=>Math.max(e, Math.min(n, t)), ar = (t, e, n = "auto")=>{
    if (!t) {
        let g = typeof window < "u" ? window.innerHeight : 768;
        return {
            left: 0,
            top: 0,
            side: "bottom",
            align: "start",
            maxHeight: Jv("center", null, g)
        };
    }
    let o = typeof window < "u" ? window.innerWidth : 1024, r = typeof window < "u" ? window.innerHeight : 768, s = {
        width: Math.max(120, e?.width || 0),
        height: Math.max(40, e?.height || 0)
    };
    if (n === "center") {
        let g = Jv("center", t, r), h = Math.min(s.height, g), m = I_((o - s.width) / 2, 8, Math.max(8, o - s.width - 8)), y = I_((r - h) / 2, 8, Math.max(8, r - h - 8));
        return {
            left: m,
            top: y,
            side: "center",
            align: "center",
            maxHeight: g
        };
    }
    let i, a;
    if (n === "auto") i = nX(t, s, o, r), a = "start";
    else {
        let g = n.split("-");
        i = g[0], a = g[1] || "start", i = oX(i, t, s, o, r);
    }
    let c = Jv(i, t, r), l = Math.min(s.height, c), f, u;
    i === "bottom" || i === "top" ? (a === "start" ? f = t.left : a === "end" ? f = t.right - s.width : f = t.left + (t.width - s.width) / 2, u = i === "bottom" ? t.bottom + 8 : t.top - l - 8) : (a === "start" ? u = t.top : a === "end" ? u = t.bottom - l : u = t.top + (t.height - l) / 2, f = i === "right" ? t.right + 8 : t.left - s.width - 8);
    let d = Math.max(8, o - s.width - 8), p = Math.max(8, r - l - 8);
    return f = I_(f, 8, d), u = I_(u, 8, p), {
        left: f,
        top: u,
        side: i,
        align: a,
        maxHeight: c
    };
}, fl = (t)=>{
    switch(t){
        case "bottom":
            return "translateY(-6px)";
        case "top":
            return "translateY(6px)";
        case "left":
            return "translateX(6px)";
        case "right":
            return "translateX(-6px)";
        case "center":
            return "translateY(0px)";
        default:
            return "translateY(-6px)";
    }
};
var ss = {
    placement: "auto",
    trigger: "click",
    offset: 8,
    minWidth: "180px",
    maxWidth: "90vw",
    maxHeight: null
}, rX = (t)=>{
    if (!t || typeof t.getBoundingClientRect != "function") return null;
    let e = t.getBoundingClientRect();
    return {
        left: e.left,
        top: e.top,
        right: e.right,
        bottom: e.bottom,
        width: e.width,
        height: e.height
    };
}, tO = (t)=>t?.getRoot?.()?.DropdownRoot || null, sX = 0, iX = ()=>`dropdown_${++sX}_${Date.now().toString(36)}`;
function M_(t = {}) {
    let e = tO(this);
    if (!e) return null;
    let n = t.anchorEl?.node || t.anchorEl, o = t.anchorRect || rX(n);
    if (!o) return null;
    let r = t.id || iX(), i = t.restoreEl?.node || t.restoreEl || n || (typeof document < "u" ? document.activeElement : null), a = {
        id: r,
        content: t.content || null,
        anchor: o,
        placement: t.placement || ss.placement,
        trigger: t.trigger || ss.trigger,
        offset: t.offset ?? ss.offset,
        minWidth: t.minWidth || ss.minWidth,
        maxWidth: t.maxWidth || ss.maxWidth,
        maxHeight: t.maxHeight || ss.maxHeight,
        theme: t.theme || null,
        shadow: t.shadow || null,
        background: t.background || null,
        round: t.round || null,
        role: t.role || null,
        ariaLabel: t.ariaLabel || null,
        ariaLabelledby: t.ariaLabelledby || null,
        focusIn: !!t.focusIn,
        onOpen: t.onOpen,
        onClose: t.onClose,
        restoreEl: i
    }, c = e.state?.layer;
    if (c?.onClose) try {
        c.onClose(c);
    } catch (l) {
        console.warn("[dropdown] prev onClose threw:", l);
    }
    if (e.state.update({
        layer: a
    }), typeof a.onOpen == "function") try {
        a.onOpen(a);
    } catch (l) {
        console.warn("[dropdown] onOpen threw:", l);
    }
    return r;
}
function B_(t) {
    let e = tO(this);
    if (!e) return;
    let n = e.state?.layer;
    n && e.state.update({
        layer: {
            ...n,
            inert: !!t
        }
    });
}
function Xi(t) {
    let e = tO(this);
    if (!e) return;
    let n = e.state?.layer;
    if (!n) return;
    let o = typeof t == "string" ? t : t?.id;
    if (o && n.id && o !== n.id) return;
    let r = n.onClose, s = n.restoreEl, i = typeof document < "u" ? document : null, a = i ? i.activeElement : null, c = e.node?.querySelector?.('[data-smbls-dropdown="panel"]'), l = !a || a === i?.body, f = !!(c && a && c.contains(a)), u = l || f;
    if (e.state.update({
        layer: null
    }), u && s && typeof s.focus == "function") try {
        s.focus();
    } catch (d) {
        console.warn("[dropdown] focus restore threw:", d);
    }
    if (typeof r == "function") try {
        r(n);
    } catch (d) {
        console.warn("[dropdown] onClose threw:", d);
    }
}
var eO = (t, e)=>{
    let n = `${e.maxHeight}px`;
    return t?.maxHeight ? `min(${t.maxHeight}, ${n})` : n;
}, sj = (t)=>{
    let e = t.getBoundingClientRect(), n = t.offsetWidth || e.width, o = Math.max(t.offsetHeight || e.height, t.scrollHeight || 0);
    return {
        width: n,
        height: o
    };
}, aX = `
@keyframes smbls-dropdown-fade-in {
  from { opacity: 0; transform: var(--smbls-dropdown-from, translateY(-6px)) scale(0.98); }
  to   { opacity: 1; transform: translate3d(0, 0, 0) scale(1); }
}
[data-smbls-dropdown="panel"][data-smbls-open="true"] {
  /* The one place the keyframe is declared \u2014 name and fill only. Duration
     and curve are the design system's motion tokens, carried by the Panel's
     own animationDuration ('B') and animationTimingFunction
     ('defaultBezier') props as atomic classes; an animation shorthand here
     would reset both. The content-mount effect owns the data-smbls-open
     flag and toggles it off and on to restart the keyframe per layer
     (FW-DROPDOWN-ROOT-OVERLAY-DEFAULTS-ROLE-FOCUS-1).

     The fill is backwards, never forwards: the keyframe ends on the Panel's
     own open style (opacity 1, no transform), so nothing needs holding. A
     forwards fill keeps the Panel under an opacity animation for its whole
     open life, and that makes it a BACKDROP ROOT: a backdrop-filter on the
     dropdown body then samples the Panel's own empty surface and the page
     behind is never blurred (__tests__/dropdownPanelBackdropRoot.test.js).
     During the fade itself the Panel is still one \u2014 that is what a group
     opacity is; the blur arrives when the fade ends. */
  animation-name: smbls-dropdown-fade-in;
  animation-fill-mode: backwards;
  transform-origin: top center;
}
@media (prefers-reduced-motion: reduce) {
  [data-smbls-dropdown="panel"] {
    animation: none !important;
  }
}
[data-smbls-dropdown="panel"][data-smbls-surface] {
  background: var(--smbls-dropdown-surface) !important;
}
[data-smbls-dropdown="panel"] {
  /* The panel is a pure positioning shell \u2014 menu BODIES own their card
     chrome (padding/round/border via e.g. CanvasCreateMenuBody), so the
     panel itself stays chromeless. !important for the same reason as the
     surface rule above: the theme prop re-emits border longhands inline
     on every re-render and would beat any declarative zero
     (2026-06-10 per Nika "remove Panel border and padding"). */
  border-width: 0 !important;
  padding: 0 !important;
}
[data-smbls-dropdown="panel"]:not([data-smbls-themed]):not([data-smbls-surface]) {
  /* Chromeless guarantee for the REUSED panel node: css-in-props'
     reactive effect applies styles only when its resolver returns a
     result (element/src/create.js "if (cssResult && element.node)") \u2014
     it never CLEARS, so a previously themed layer's inline
     background/color/box-shadow would survive into the next unthemed
     layer. _applyChrome flags opt-in chrome with data-smbls-themed /
     data-smbls-shadowed; these :not() rules neutralise the stale paint
     channels for everyone else. Background keeps :not([data-smbls-surface])
     so the caller surface-override rule above still wins on ties. */
  background: transparent !important;
}
[data-smbls-dropdown="panel"]:not([data-smbls-themed]) {
  color: inherit !important;
  /* A glass theme's backdrop-filter is a paint channel like the two above.
     Left on an unthemed layer it blurs the page behind a body that asked for
     no blur, and it makes the Panel a backdrop root for that body. */
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}
[data-smbls-dropdown="panel"]:not([data-smbls-shadowed]) {
  box-shadow: none !important;
}
`, cX = ()=>{
    if (typeof document > "u" || document.getElementById("smbls-dropdown-css")) return;
    let t = document.createElement("style");
    t.id = "smbls-dropdown-css", t.textContent = aX, document.head.appendChild(t);
}, ij = (t, e)=>{
    if (!t.node) return;
    let n = e?.background;
    if (!n) t.node.removeAttribute("data-smbls-surface");
    else {
        let o = /^[a-z][\w.+-]*$/i.test(n) ? `var(--color-${n})` : n;
        t.node.style.setProperty("--smbls-dropdown-surface", o), t.node.setAttribute("data-smbls-surface", "");
    }
    e?.theme ? t.node.setAttribute("data-smbls-themed", "") : t.node.removeAttribute("data-smbls-themed"), e?.shadow || t.scope?.bodyShadow ? t.node.setAttribute("data-smbls-shadowed", "") : t.node.removeAttribute("data-smbls-shadowed");
}, lX = (t)=>{
    if (!t) return null;
    let e = typeof t.shadow == "function" ? t.shadow(t, t.state) : t.shadow;
    return typeof e == "string" && e ? e : null;
}, fX = (t)=>{
    t.node && (t.node.removeAttribute("data-smbls-open"), t.node.offsetWidth, t.node.setAttribute("data-smbls-open", "true"));
}, uX = [
    [
        "role",
        "role"
    ],
    [
        "aria-label",
        "ariaLabel"
    ],
    [
        "aria-labelledby",
        "ariaLabelledby"
    ]
], aj = (t, e)=>{
    if (!t.node) return;
    let n = new Set;
    for (let [o, r] of uX){
        let s = e?.[r];
        s && (t.node.setAttribute(o, s), n.add(o));
    }
    if (t.__a11yAttrs) for (let o of t.__a11yAttrs)n.has(o) || t.node.removeAttribute(o);
    t.__a11yAttrs = n, t.__panelTabindex && (t.node.removeAttribute("tabindex"), t.__panelTabindex = !1);
}, dX = 'a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex], [contenteditable]:not([contenteditable="false"])', pX = (t)=>{
    let e = t.node;
    if (e) {
        for (let n of e.querySelectorAll(dX)){
            if (n.matches(":disabled")) continue;
            let o = n.getAttribute("tabindex");
            if (!(o !== null && parseInt(o, 10) < 0) && (n.focus({
                preventScroll: !0
            }), e.ownerDocument.activeElement === n)) return;
        }
        e.setAttribute("tabindex", "-1"), t.__panelTabindex = !0, e.focus({
            preventScroll: !0
        });
    }
}, N_ = {
    tag: "div",
    attr: {
        "data-smbls-dropdown-root": "true"
    },
    position: "fixed",
    inset: "0",
    zIndex: "1500",
    pointerEvents: "none",
    state: {
        layer: null
    },
    onInit: (t)=>{
        if (cX(), typeof window > "u") return;
        let e = (o)=>{
            o.key !== "Escape" || o.defaultPrevented || t.state?.layer && (o.preventDefault(), Xi.call(t));
        };
        window.addEventListener("keydown", e), t.__dropdownEscHandler = e;
        let n = (o)=>{
            let r = t.state?.layer;
            if (!r) return;
            let s = t.node?.querySelector('[data-smbls-dropdown="panel"]');
            if (s && s.contains(o.target)) return;
            let i = r.anchor;
            if (i) {
                let a = o.clientX, c = o.clientY;
                if (a >= i.left && a <= i.right && c >= i.top && c <= i.bottom) return;
            }
            Xi.call(t);
        };
        document.addEventListener("mousedown", n, !0), t.__dropdownClickHandler = n;
    },
    onRemove: (t)=>{
        typeof window > "u" || (t.__dropdownEscHandler && window.removeEventListener("keydown", t.__dropdownEscHandler), t.__dropdownClickHandler && document.removeEventListener("mousedown", t.__dropdownClickHandler, !0));
    },
    PanelHost: {
        tag: "div",
        position: "fixed",
        inset: "0",
        pointerEvents: "none",
        subscribeTo: [
            "layer"
        ],
        layer: (t, e)=>e?.layer || null,
        Panel: {
            tag: "div",
            attr: {
                "data-smbls-dropdown": "panel"
            },
            position: "fixed",
            subscribeTo: [
                "layer"
            ],
            left: (t)=>{
                let e = t.parent?.layer;
                if (!e?.anchor) return "-9999px";
                let n = t._lastSize || {
                    width: 280,
                    height: 200
                };
                return ar(e.anchor, n, e.placement).left + "px";
            },
            top: (t)=>{
                let e = t.parent?.layer;
                if (!e?.anchor) return "-9999px";
                let n = t._lastSize || {
                    width: 280,
                    height: 200
                };
                return ar(e.anchor, n, e.placement).top + "px";
            },
            style: (t)=>{
                let e = t.parent?.layer;
                if (!e?.anchor) return {};
                let n = t._lastSize || {
                    width: 280,
                    height: 200
                };
                return {
                    "--smbls-dropdown-from": fl(ar(e.anchor, n, e.placement).side)
                };
            },
            minWidth: (t)=>t.parent?.layer?.minWidth || "180px",
            maxWidth: (t)=>t.parent?.layer?.maxWidth || "90vw",
            maxHeight: (t)=>{
                let e = t.parent?.layer;
                if (!e?.anchor) return "none";
                let n = t._lastSize || {
                    width: 280,
                    height: 200
                };
                return eO(e, ar(e.anchor, n, e.placement));
            },
            overflow: "auto",
            overscrollBehavior: "contain",
            padding: "0",
            round: (t)=>t.parent?.layer?.round || "radiusCard",
            theme: (t)=>t.parent?.layer?.theme || null,
            border: "none",
            borderWidth: "0",
            shadow: (t)=>t.parent?.layer?.shadow || t.scope?.bodyShadow || null,
            scope: {
                bodyShadow: null
            },
            animationDuration: "B",
            animationTimingFunction: "defaultBezier",
            pointerEvents: (t)=>{
                let e = t.parent?.layer;
                return e ? e.inert ? "none" : "auto" : "none";
            },
            opacity: (t)=>t.parent?.layer ? "1" : "0",
            onClick: (t)=>t.stopPropagation(),
            onInit: (t)=>{
                let e = q(()=>{
                    let n = t.parent?.layer, o = n?.content || null, r = n?.id || null;
                    if (!o) {
                        if (t.__lastLayerId != null) {
                            try {
                                t.removeContent?.();
                            } catch  {}
                            t.__lastLayerId = null, aj(t, null), t.node?.removeAttribute("data-smbls-open"), t.scope && (t.scope.bodyShadow = null);
                        }
                        return;
                    }
                    if (t.__lastLayerId !== r) {
                        t.__lastLayerId = r;
                        try {
                            t.set(o);
                        } catch (s) {
                            console.warn("[dropdown] content set failed:", s);
                        }
                        t.scope && (t.scope.bodyShadow = lX(t.content)), ij(t, n), aj(t, n), fX(t), n.focusIn && pX(t), !(typeof requestAnimationFrame > "u") && requestAnimationFrame(()=>{
                            if (!t.node) return;
                            ij(t, n);
                            let s = t.parent?.layer;
                            if (!s?.anchor) return;
                            let i = sj(t.node);
                            t._lastSize = i;
                            let a = ar(s.anchor, i, s.placement);
                            t.node.style.maxHeight = eO(s, a), t.node.style.left = a.left + "px", t.node.style.top = a.top + "px", t.node.style.setProperty("--smbls-dropdown-from", fl(a.side));
                        });
                    }
                });
                t.__ref && t.__ref.__effects?.push(e);
            },
            onRender: (t)=>{
                if (!t?.node) return;
                let e = t.parent?.layer;
                if (!e?.anchor) return;
                let n = sj(t.node), o = t._lastSize;
                (!o || Math.abs(o.width - n.width) > 1 || Math.abs(o.height - n.height) > 1) && (t._lastSize = n);
                let s = ar(e.anchor, n, e.placement);
                t.node.style.maxHeight = eO(e, s), t.node.style.left = s.left + "px", t.node.style.top = s.top + "px", t.node.style.setProperty("--smbls-dropdown-from", fl(s.side));
            }
        }
    }
};
var nO = (t)=>{
    let o = t?.getRoot?.()?.DropdownRoot?.state?.layer;
    if (o && t.dropdownId && o.id === t.dropdownId) {
        t.call("closeDropdown");
        return;
    }
    let r = {
        anchorEl: t,
        trigger: t.dropdownTrigger || "click",
        placement: t.dropdownPlacement || "auto",
        content: t.dropdownContent || null,
        minWidth: t.dropdownMinWidth,
        maxWidth: t.dropdownMaxWidth,
        maxHeight: t.dropdownMaxHeight,
        theme: t.dropdownTheme,
        offset: t.dropdownOffset,
        id: t.dropdownId,
        onOpen: t.onDropdownOpen,
        onClose: t.onDropdownClose
    };
    for(let s in r)r[s] === void 0 && delete r[s];
    t.call("openDropdown", r);
}, F_ = {
    position: "relative",
    onClick: (t, e)=>{
        (e.dropdownTrigger || "click") === "click" && (t.preventDefault(), t.stopPropagation(), nO(e));
    },
    onFocus: (t, e)=>{
        e.dropdownTrigger === "focus" && nO(e);
    },
    onMouseenter: (t, e)=>{
        e.dropdownTrigger === "hover" && (e._hoverTimer && clearTimeout(e._hoverTimer), e._hoverTimer = setTimeout(()=>nO(e), 120));
    },
    onMouseleave: (t, e)=>{
        e.dropdownTrigger === "hover" && (e._hoverTimer && (clearTimeout(e._hoverTimer), e._hoverTimer = null), e._closeTimer = setTimeout(()=>e.call("closeDropdown"), 250));
    }
};
var $_ = {
    extends: "smbls.Dropdown"
}, j_ = {
    extends: "smbls.DropdownList"
}, U_ = {
    extends: "smbls.DropdownParent"
}, H_ = {
    extends: "smbls.DropdownParentFocus"
}, V_ = {
    extends: "smbls.DropdownSiblingFocus"
};
var oO = {
    DropdownRoot: N_,
    DropdownTrigger: F_,
    Dropdown: $_,
    DropdownList: j_,
    DropdownParent: U_,
    DropdownParentFocus: H_,
    DropdownSiblingFocus: V_
};
var iO = /*@__PURE__*/ F({}, {
    DROPDOWN_DEFAULTS: ()=>ss,
    closeDropdown: ()=>Xi,
    computePosition: ()=>ar,
    dropdownFunctions: ()=>sO,
    fadeInTransform: ()=>fl,
    openDropdown: ()=>M_,
    setDropdownInert: ()=>B_
});
var sO = {
    openDropdown: M_,
    closeDropdown: Xi,
    setDropdownInert: B_
};
var hO = /*@__PURE__*/ F({}, {
    components: ()=>Oj,
    functions: ()=>Cj
});
var hX = (t, e, n)=>({
        bottom: n - t.bottom,
        top: t.top,
        right: e - t.right,
        left: t.left
    }), gX = (t, e, n, o, r)=>{
    let s = hX(e, o, r), i = t === "top" || t === "bottom" ? n.height + 6 : n.width + 6;
    if (s[t] >= i) return t;
    let a = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
    }[t];
    return a && s[a] >= i ? a : t;
}, cj = (t, e, n)=>Math.max(e, Math.min(n, t)), fj = (t, e, n = "bottom")=>{
    if (!t) return {
        left: 0,
        top: 0,
        side: "bottom"
    };
    let o = typeof window < "u" ? window.innerWidth : 1024, r = typeof window < "u" ? window.innerHeight : 768, s = gX(n, t, e, o, r), i, a;
    return s === "bottom" || s === "top" ? (i = t.left + (t.width - e.width) / 2, a = s === "bottom" ? t.bottom + 6 : t.top - e.height - 6) : (a = t.top + (t.height - e.height) / 2, i = s === "right" ? t.right + 6 : t.left - e.width - 6), i = cj(i, 6, o - e.width - 6), a = cj(a, 6, r - e.height - 6), {
        left: i,
        top: a,
        side: s
    };
}, lj = {
    bottom: [
        "0",
        "-10%"
    ],
    top: [
        "0",
        "10%"
    ],
    left: [
        "10%",
        "0"
    ],
    right: [
        "-10%",
        "0"
    ]
}, uj = (t)=>(lj[t] || lj.bottom).join(" ");
var is = {
    placement: "bottom",
    theme: "dialog",
    delay: 250,
    hideDelay: 100,
    warmWindow: 300
}, dj = (t)=>{
    if (!t || typeof t != "object") return null;
    let e = Number(t.left), n = Number(t.top), o = Number(t.width ?? t.right - t.left), r = Number(t.height ?? t.bottom - t.top), s = {
        left: e,
        top: n,
        right: Number(t.right ?? e + o),
        bottom: Number(t.bottom ?? n + r),
        width: o,
        height: r
    };
    for(let i in s)if (!Number.isFinite(s[i])) return null;
    return s;
}, mX = (t)=>!t || typeof t.getBoundingClientRect != "function" ? null : dj(t.getBoundingClientRect()), cO = (t)=>t?.getRoot?.()?.TooltipRoot || null, lO = (t)=>{
    let e = t?.state?.tip;
    return e ? typeof e.$parse == "function" ? e.$parse() : {
        ...e
    } : null;
}, fO = (t)=>!!(t && t.open !== !1 && t.size), pj = (t, e = Date.now())=>{
    let n = cO(t)?.state?.tip;
    return n ? n.open !== !1 ? !0 : typeof n.closedAt == "number" && e - n.closedAt < is.warmWindow : !1;
}, hj = (t, e, n = 0)=>{
    let o = lO(t);
    if (!o || o.id !== e || o.open === !1) return;
    let r = t.Panel?.node;
    if (!r || typeof r.getBoundingClientRect != "function") return;
    if (r.textContent !== (o.text || "")) {
        n < 3 && setTimeout(()=>hj(t, e, n + 1), 0);
        return;
    }
    let s = r.getBoundingClientRect();
    t.state.update({
        tip: {
            ...o,
            size: {
                width: s.width,
                height: s.height
            }
        }
    });
}, yX = (t)=>{
    typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t);
}, _X = 0, bX = ()=>`tooltip_${++_X}_${Date.now().toString(36)}`;
function gj(t = {}) {
    let e = cO(this);
    if (!e) return null;
    let n = t.anchorEl?.node || t.anchorEl, o = dj(t.anchorRect);
    t.anchorRect != null && o;
    let r = o || mX(n);
    if (!r) return null;
    let s = t.id || bX(), i = lO(e), a = fO(i), c = {
        id: s,
        owner: t.owner || null,
        text: t.text || "",
        anchor: r,
        placement: t.placement || is.placement,
        theme: t.theme || is.theme,
        open: !0,
        glide: a,
        size: a ? i.size : null
    };
    return e.state.update({
        tip: c
    }), yX(()=>hj(e, s)), s;
}
function mj(t) {
    let e = cO(this);
    if (!e) return;
    let n = lO(e);
    if (!n || n.open === !1) return;
    let o = typeof t == "string" ? t : t?.id;
    if (o && n.id && o !== n.id) return;
    let r = typeof t == "object" ? t?.owner : null;
    r && n.owner && r !== n.owner || e.state.update({
        tip: {
            ...n,
            open: !1,
            closedAt: Date.now()
        }
    });
}
var yj = (t)=>{
    let e = t.tip;
    return e?.anchor ? fj(e.anchor, e.size || {
        width: 0,
        height: 0
    }, e.placement) : null;
}, uO = (t)=>fO(t.tip), SX = (t)=>{
    let e = t.tip;
    return !e || e.open === !1 ? "Z opacity defaultBezier, Z translate defaultBezier, Z visibility defaultBezier, Z transform defaultBezier" : e.size ? e.glide ? "A transform defaultBezier, A translate defaultBezier, A opacity defaultBezier, A visibility defaultBezier" : "A opacity defaultBezier, A translate defaultBezier, A visibility defaultBezier" : "Z opacity defaultBezier, Z visibility defaultBezier";
}, _j = (t)=>{
    let e = typeof window < "u" && window.devicePixelRatio || 1;
    return Math.round(t * e) / e;
}, bj = {
    tag: "div",
    attr: {
        "data-smbls-tooltip-root": "true"
    },
    position: "fixed",
    inset: "0",
    zIndex: "2500",
    pointerEvents: "none",
    state: {
        tip: null
    },
    onDocumentKeydown: (t, e)=>{
        t.key !== "Escape" || t.defaultPrevented || !e.state?.tip || e.state.tip.open === !1 || (t.preventDefault(), e.call("closeTooltip"));
    },
    onDocumentClick: {
        capture: !0,
        handler: (t, e)=>e.call("closeTooltip")
    },
    onWindowResize: (t, e)=>e.call("closeTooltip"),
    Panel: {
        tag: "div",
        attr: {
            "data-smbls-tooltip": "panel"
        },
        role: "tooltip",
        position: "fixed",
        left: "0",
        top: "0",
        tip: (t, e)=>e?.tip || null,
        transform: (t)=>{
            let e = yj(t);
            return e ? `translate3d(${_j(e.left)}px, ${_j(e.top)}px, 0)` : "translate3d(-9999px, -9999px, 0)";
        },
        translate: (t)=>{
            if (uO(t)) return "0 0";
            let e = yj(t);
            return uj(e ? e.side : "bottom");
        },
        text: (t)=>t.tip?.text || "",
        theme: (t)=>t.tip?.theme || is.theme,
        width: "max-content",
        maxWidth: "280px",
        padding: "Y2 Z",
        round: "Z",
        fontSize: "Y2",
        lineHeight: "1.35",
        whiteSpace: "normal",
        pointerEvents: "none",
        opacity: (t)=>uO(t) ? "1" : "0",
        visibility: (t)=>uO(t) ? "visible" : "hidden",
        transition: (t)=>SX(t)
    }
};
var dO = (t)=>{
    if (!t.tooltipText) return;
    let e = t.node;
    e && e.hasAttribute && e.hasAttribute("title") && e.removeAttribute("title");
}, wX = 0, pO = (t)=>t._tooltipOwner || (t._tooltipOwner = `tooltip_trigger_${++wX}`), Sj = (t)=>{
    t.tooltipText && t.node?.isConnected !== !1 && (dO(t), t.call("openTooltip", {
        anchorEl: t,
        anchorRect: t.tooltipAnchorRect || void 0,
        text: t.tooltipText,
        placement: t.tooltipPlacement || "bottom",
        theme: t.tooltipTheme,
        id: t.tooltipId || t.key,
        owner: pO(t)
    }));
}, wj = (t)=>{
    if (t._tooltipHideTimer && (clearTimeout(t._tooltipHideTimer), t._tooltipHideTimer = null), pj(t)) {
        t._tooltipShowTimer && (clearTimeout(t._tooltipShowTimer), t._tooltipShowTimer = null), Sj(t);
        return;
    }
    t._tooltipShowTimer || (t._tooltipShowTimer = setTimeout(()=>{
        t._tooltipShowTimer = null, Sj(t);
    }, t.tooltipDelay ?? is.delay));
}, xj = (t)=>{
    t._tooltipShowTimer && (clearTimeout(t._tooltipShowTimer), t._tooltipShowTimer = null), !t._tooltipHideTimer && (t._tooltipHideTimer = setTimeout(()=>{
        t._tooltipHideTimer = null, t.call("closeTooltip", {
            id: t.tooltipId || t.key,
            owner: pO(t)
        });
    }, t.tooltipHideDelay ?? is.hideDelay));
}, kj = (t)=>{
    t._tooltipShowTimer && clearTimeout(t._tooltipShowTimer), t._tooltipHideTimer && clearTimeout(t._tooltipHideTimer), t._tooltipShowTimer = null, t._tooltipHideTimer = null, t.call("closeTooltip", {
        id: t.tooltipId || t.key,
        owner: pO(t)
    });
}, Tj = {
    onMouseenter: (t, e)=>wj(e),
    onMouseleave: (t, e)=>xj(e),
    onFocus: (t, e)=>wj(e),
    onBlur: (t, e)=>xj(e),
    onKeydown: (t, e)=>{
        if (t.key !== "Escape" || t.defaultPrevented) return;
        let n = e.getRoot()?.TooltipRoot?.state?.tip;
        !e._tooltipShowTimer && !(n && n.open !== !1 && n.owner === e._tooltipOwner) || (t.preventDefault(), kj(e));
    },
    onRemove: {
        always: !0,
        handler: kj
    },
    onMouseover: (t, e)=>dO(e),
    onFocusin: (t, e)=>dO(e)
};
var Ej = {
    display: "flex",
    theme: "dialog",
    flow: "column",
    shape: "tooltip",
    shapeDirection: "left",
    padding: "Z1 A",
    round: "Y2",
    width: "fit-content",
    minWidth: "D2",
    maxWidth: "F2",
    gap: "X",
    textAlign: "center",
    attr: {
        tooltip: !0
    },
    Title: {
        if: (t)=>t.call("isDefined", t.parent.title) || t.parent.title,
        width: "fit-content",
        fontWeight: 500,
        color: "currentColor",
        text: (t)=>t.parent.title
    },
    P: {
        if: (t, e)=>t.call("isDefined", t.call("exec", t.parent.description, t)) || t.text,
        width: "fit-content",
        fontSize: "Z2",
        margin: "0",
        color: "currentColor",
        fontWeight: "400",
        text: (t, e)=>t.call("exec", t.parent.description, t)
    }
}, Aj = {
    extends: "Tooltip",
    position: "absolute",
    pointerEvents: "none",
    opacity: "0",
    visibility: "hidden",
    transition: "C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform",
    onInit: (t)=>{
        let e = !t.shapeDirection || t.shapeDirection === "top" ? {
            top: "112%",
            left: "50%",
            transform: "translate3d(-50%,10%,0)",
            ".isActive": {
                transform: "translate3d(-50%,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "right" ? {
            transform: "translate3d(10%,-50%,0)",
            left: "112%",
            top: "50%",
            ".isActive": {
                transform: "translate3d(0%,-50%,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "bottom" ? {
            transform: "translate3d(-50%,-10%,0)",
            bottom: "112%",
            left: "50%",
            ".isActive": {
                transform: "translate3d(-50%,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "left" ? {
            transform: "translate3d(10%,-50%,0)",
            right: "112%",
            top: "50%",
            ".isActive": {
                transform: "translate3d(0%,-50%,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : {};
        Object.assign(t, e);
    },
    style: (t)=>{
        if (!t.scope || !t.scope.tooltipOpen) return {
            opacity: "",
            visibility: "",
            transform: ""
        };
        let e = t.shapeDirection;
        return {
            opacity: "1",
            visibility: "visible",
            transform: e === "left" || e === "right" ? "translate3d(0%,-50%,0)" : "translate3d(-50%,0,0)"
        };
    },
    styleDeps: [
        (t)=>t.scope && t.scope.tooltipOpen
    ]
}, vj = {
    position: "relative",
    zIndex: 999,
    scope: {
        tooltipOpen: !1
    },
    onInit: (t)=>{
        let { Tooltip: e, TooltipHidden: n } = t, o = e || n;
        if (!o) return;
        let r = o && o[".isActive"];
        Object.assign(t, {
            ":hover, &:focus-visible": {
                zIndex: 1e3,
                "& [tooltip]": r || {
                    transform: "translate3d(-50%, 0, 0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        });
    },
    onPointerdown: (t, e)=>{
        t.pointerType !== "touch" || !e.scope || (e.scope.tooltipOpen = !e.scope.tooltipOpen);
    },
    onDocumentKeydown: (t, e)=>{
        t.key !== "Escape" || !e.scope || !e.scope.tooltipOpen || (e.scope.tooltipOpen = !1);
    },
    onDocumentPointerdown: (t, e)=>{
        !e.scope || !e.scope.tooltipOpen || e.node && e.node.contains(t.target) || (e.scope.tooltipOpen = !1);
    }
};
var Oj = {
    TooltipRoot: bj,
    TooltipTrigger: Tj,
    Tooltip: Ej,
    TooltipHidden: Aj,
    TooltipParent: vj
};
var Cj = {
    openTooltip: gj,
    closeTooltip: mj
};
var _p = /*@__PURE__*/ F({}, {
    LEVELS: ()=>gp,
    analyzePlugin: ()=>z_,
    attachBrowserListeners: ()=>J_,
    attachNetworkListeners: ()=>yp,
    classifyEvent: ()=>wO,
    createAnalyzeState: ()=>$j,
    createBeaconSink: ()=>TO,
    createConsoleSink: ()=>xO,
    createDedupe: ()=>_O,
    createEnrich: ()=>mO,
    createMemorySink: ()=>kO,
    createPipeline: ()=>q_,
    createRedact: ()=>G_,
    createRemoteSink: ()=>X_,
    createSample: ()=>bO,
    createSummarize: ()=>yO,
    default: ()=>z_,
    emitFetchEvent: ()=>Nj,
    makeEvent: ()=>it,
    meetsLevel: ()=>W_,
    normalizeLevel: ()=>mp,
    resolveSinks: ()=>Q_,
    summarizeElement: ()=>Zi
});
var xX = 0, kX = ()=>`${Date.now().toString(36)}-${(xX++).toString(36)}`, it = (t, e, n = {})=>({
        id: kX(),
        ts: Date.now(),
        type: t,
        level: e,
        ...n
    }), TX = (t)=>{
    let e = [], n = t, o = 0;
    for(; n && o < 32;)n.key != null && e.unshift(String(n.key)), n = n.parent, o++;
    return e.join(" > ");
}, Zi = (t)=>t ? {
        key: t.key != null ? String(t.key) : null,
        name: t.__name || t.name || null,
        path: TX(t),
        tag: t.tag || null,
        component: t.component || null,
        route: t.context?.routerOptions?.currentRoute || null
    } : null;
var ul = (t)=>t?.context?.analyze, EX = {
    init: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    create: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    render: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    beforeRemove: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    },
    remove: {
        category: "lifecycle",
        type: "lifecycle",
        level: "debug"
    }
}, AX = (t, { category: e, type: n, level: o })=>(r)=>{
        let s = ul(r);
        !s || !s.shouldCapture(e) || s.emit(it(n, o, {
            hook: t,
            element: Zi(r)
        }));
    }, Rj = (t)=>(e, n)=>{
        let o = ul(e);
        !o || !o.shouldCapture("state") || o.emit(it("state", "debug", {
            hook: t,
            element: Zi(e),
            changedKeys: n?.changedKeys || null
        }));
    }, z_ = {
    name: "analyze",
    error (t, e) {
        let n = ul(t);
        if (!n || n.config.enabled === !1 || !n.shouldCapture("errors")) return;
        let o = e?.error || e?.err || (e instanceof Error ? e : null);
        n.emit(it("error", "error", {
            hook: e?.hook || "error",
            element: Zi(t),
            error: o,
            message: o?.message || (typeof e?.message == "string" ? e.message : null)
        }));
    },
    renderRouter (t) {
        let e = ul(t);
        e && (!e.shouldCapture("navigation") && !e.shouldCapture("lifecycle") || e.emit(it("navigation", "info", {
            hook: "renderRouter",
            route: t.context?.routerOptions?.currentRoute || null
        })));
    },
    beforeUpdate (t) {
        let e = ul(t);
        !e || !e.shouldCapture("updates") || t.__ref && (t.__ref.__analyzeUpdateStart = typeof performance < "u" ? performance.now() : Date.now());
    },
    update (t) {
        let e = ul(t);
        if (!e || !e.shouldCapture("updates")) return;
        let n = null;
        t.__ref?.__analyzeUpdateStart != null && (n = (typeof performance < "u" ? performance.now() : Date.now()) - t.__ref.__analyzeUpdateStart, t.__ref.__analyzeUpdateStart = null), e.emit(it("update", "debug", {
            hook: "update",
            element: Zi(t),
            durationMs: n
        }));
    },
    beforeStateUpdate: Rj("beforeStateUpdate"),
    stateUpdate: Rj("stateUpdate")
};
for (let [t, e] of Object.entries(EX))z_[t] = AX(t, e);
var gp = {
    error: 0,
    warn: 1,
    info: 2,
    debug: 3,
    trace: 4
};
var W_ = (t, e)=>{
    let n = gp[t], o = gp[e];
    return n == null || o == null ? !0 : n <= o;
}, mp = (t)=>gp[t] != null ? t : "warn";
var K_ = /password|token|secret|ssn|card|cvv|pin|apikey|api_key|auth|email|otp/i;
var vX = (t, e)=>{
    for (let n of e)if (n instanceof RegExp) {
        if (n.test(t)) return !0;
    } else if (typeof n == "string" && t.toLowerCase().includes(n.toLowerCase())) return !0;
    return !1;
}, OX = (t, e)=>{
    if (e !== "redact") {
        if (e === "hash") {
            let n = 0, o = String(t);
            for(let r = 0; r < o.length; r++)n = (n << 5) - n + o.charCodeAt(r) | 0;
            return `#${(n >>> 0).toString(36)}`;
        }
        return "***";
    }
}, gO = (t, e, n, o)=>{
    if (o > 6 || t == null || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map((s)=>gO(s, e, n, o + 1));
    let r = {};
    for (let s of Object.keys(t))if (vX(s, e) || K_.test(s)) {
        let a = OX(t[s], n);
        a !== void 0 && (r[s] = a);
    } else r[s] = gO(t[s], e, n, o + 1);
    return r;
}, G_ = (t = [], e = "mask")=>{
    let n = Array.isArray(t) ? t : [
        t
    ];
    return (o)=>{
        if (!o) return o;
        let { id: r, ts: s, type: i, level: a, hook: c, error: l, message: f, durationMs: u, element: d, target: p, ...g } = o, h = gO(g, n, e, 0);
        return {
            id: r,
            ts: s,
            type: i,
            level: a,
            hook: c,
            error: l,
            message: f,
            durationMs: u,
            element: d,
            target: p,
            ...h
        };
    };
};
var mO = (t)=>{
    let e = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`, n = typeof navigator < "u" ? navigator.userAgent : null, o = t.config.buildHash || null, r = t.config.appId || null;
    return (s)=>{
        if (!s) return s;
        let i = t.context?.routerOptions?.currentRoute || null, a = R, c = a && a.innerWidth ? {
            w: a.innerWidth,
            h: a.innerHeight
        } : null;
        return {
            ...s,
            session: e,
            app: {
                id: r,
                build: o,
                route: i
            },
            meta: {
                ua: n,
                viewport: c
            }
        };
    };
}, yO = ()=>(t)=>{
        if (!t) return t;
        if (t.element && typeof t.element == "object") {
            let e = t.element;
            (e.node || e.parent || e.__ref) && (t = {
                ...t,
                element: {
                    key: e.key != null ? String(e.key) : null,
                    name: e.__name || e.name || null,
                    tag: e.tag || null,
                    component: e.component || null
                }
            });
        }
        return t.error instanceof Error && (t = {
            ...t,
            error: {
                name: t.error.name,
                message: t.error.message,
                stack: t.error.stack
            }
        }), t;
    }, _O = (t = 1e3, e = 500)=>{
    let n = new Map;
    return (o)=>{
        if (!o) return o;
        let r = `${o.type}:${o.level}:${o.message || ""}:${o.error?.message || ""}`, s = n.get(r), i = o.ts || Date.now();
        if (s && i - s < t) return null;
        if (n.set(r, i), n.size > e) {
            let a = Math.ceil(e / 10), c = 0;
            for (let l of n.keys()){
                if (c++ >= a) break;
                n.delete(l);
            }
        }
        return o;
    };
}, bO = (t)=>(e)=>{
        if (!e) return e;
        let n = t[e.type];
        return n == null || n >= 1 ? e : Math.random() > n ? null : e;
    }, Dj = {
    redact: (t)=>G_(t.config.redact || [], t.config.maskStrategy),
    enrich: (t)=>mO(t),
    summarize: ()=>yO(),
    dedupe: (t)=>_O(t.config.cache?.dedupeWindowMs || 1e3),
    sample: (t)=>bO(t.config.sample || {})
}, CX = (t, e)=>{
    if (typeof t == "function") return t;
    if (typeof t == "string") {
        let n = Dj[t];
        return n ? n(e) : null;
    }
    return null;
}, q_ = (t)=>{
    let e = t.config, n = Array.isArray(e.transformers) ? e.transformers.slice() : [], o = n.findIndex((s)=>s === "redact");
    o >= 0 && n.splice(o, 1);
    let r = [];
    e.redact !== !1 && r.push(Dj.redact(t));
    for (let s of n){
        let i = CX(s, t);
        i && r.push(i);
    }
    return (s)=>{
        let i = s;
        for (let a of r){
            if (i == null) return null;
            let c = a(i);
            if (c == null) return null;
            if (Array.isArray(c)) {
                let l = r.slice(r.indexOf(a) + 1), f = [];
                for (let u of c){
                    let d = u, p = !1;
                    for (let g of l)if (d = g(d), d == null) {
                        p = !0;
                        break;
                    }
                    !p && d != null && f.push(d);
                }
                return f;
            }
            i = c;
        }
        return i;
    };
};
var Y_ = typeof R < "u" && typeof R.document < "u", RX = 5e3, DX = 50, LX = 3, PX = 1500, IX = 1e3, wO = (t)=>t ? t.level === "error" || t.type === "error" ? "bug" : t.type === "network" ? "network" : t.type === "console" ? t.level === "error" || t.level === "warn" ? "bug" : "log" : t.level === "warn" ? "bug" : t.level === "info" ? "log" : "verbose" : "verbose", MX = (t)=>{
    try {
        return JSON.stringify(t);
    } catch  {
        return null;
    }
}, BX = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch  {
        return null;
    }
}, NX = (t)=>{
    if (!t) return null;
    let e = String(t), n;
    return (n = e.match(/Edg\/([\d.]+)/)) ? {
        name: "Edge",
        version: n[1]
    } : (n = e.match(/OPR\/([\d.]+)/)) ? {
        name: "Opera",
        version: n[1]
    } : (n = e.match(/Firefox\/([\d.]+)/)) ? {
        name: "Firefox",
        version: n[1]
    } : /Chrome\/([\d.]+)/.test(e) && /Safari\//.test(e) ? (n = e.match(/Chrome\/([\d.]+)/), {
        name: "Chrome",
        version: n[1]
    }) : (n = e.match(/Version\/([\d.]+).*Safari/)) ? {
        name: "Safari",
        version: n[1]
    } : {
        name: null,
        version: null
    };
}, FX = ()=>{
    if (!Y_) return null;
    try {
        let t = R.document?.documentElement?.getAttribute("data-theme") || null, e = typeof R.matchMedia == "function" ? R.matchMedia("(prefers-color-scheme: dark)").matches : null;
        return {
            active: t || (e ? "dark" : e === !1 ? "light" : null),
            forced: t || null,
            prefers: e == null ? null : e ? "dark" : "light"
        };
    } catch  {
        return null;
    }
}, $X = ()=>{
    if (!Y_) return null;
    let t = R.location, e = typeof navigator < "u" ? navigator : null, n = typeof screen < "u" ? screen : null;
    return {
        url: t?.href || null,
        path: t?.pathname || null,
        referrer: R.document?.referrer || null,
        title: R.document?.title || null,
        ua: e?.userAgent || null,
        browser: NX(e?.userAgent),
        language: e?.language || null,
        languages: e?.languages || null,
        timezone: BX(),
        viewport: R.innerWidth ? {
            w: R.innerWidth,
            h: R.innerHeight,
            dpr: R.devicePixelRatio || 1
        } : null,
        screen: n ? {
            w: n.width || null,
            h: n.height || null,
            availW: n.availWidth || null,
            availH: n.availHeight || null,
            colorDepth: n.colorDepth || null,
            orientation: n.orientation?.type || null
        } : null,
        theme: FX()
    };
}, X_ = (t = {})=>{
    let e = t.url, n = typeof t.transport == "function" ? t.transport : null, o = typeof t.syncTransport == "function" ? t.syncTransport : null;
    if (!e && !n) return ()=>{};
    let r = t.apiKey || null, s = t.appKey || t.appId || null, i = t.tenantKey || t.tenant || null, a = t.release || null, c = t.env || null, l = t.sdk || null, f = typeof t.getAuth == "function" ? t.getAuth : null, u = typeof t.getContext == "function" ? t.getContext : null, d = typeof t.classify == "function" ? t.classify : wO, p = typeof t.beforeSend == "function" ? t.beforeSend : null, g = t.debug === !0, h = typeof t.getDebug == "function" ? t.getDebug : null, m = t.batchMs != null ? t.batchMs : RX, y = t.maxBatch || DX, b = t.maxRetries != null ? t.maxRetries : LX, T = t.backoffMs || PX, v = t.queueLimit || IX, S = t.sampleRate != null ? t.sampleRate : 1, w = ()=>typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`, _ = t.sessionId || w(), x = [], A = [], O = null, C = null, N = ()=>{
        O || !x.length || (O = setTimeout(V, m));
    }, I = (Y)=>{
        if (C) return;
        let G = T * Math.pow(2, Math.max(0, Y - 1));
        C = setTimeout(()=>{
            if (C = null, !A.length) return;
            let st = A.shift();
            K(st.envelope, st.attempt);
        }, G);
    }, M = (Y, G = !1)=>{
        let st = u ? SO(u) : null, ot = {
            id: _,
            sentAt: Date.now()
        };
        G && (ot.endedAt = Date.now());
        let dt = {
            v: 1,
            session: ot,
            app: {
                key: s,
                release: a,
                env: c
            },
            tenant: i,
            sdk: l,
            page: $X(),
            user: st?.user || null,
            traits: st?.traits || null,
            tags: st?.tags || null,
            events: Y
        };
        if ((h ? SO(h) === !0 : g) && (dt.app.debug = !0), p) try {
            return p(dt) || null;
        } catch  {
            return dt;
        }
        return dt;
    }, K = async (Y, G = 1)=>{
        if (Y) try {
            let st = !0;
            if (n) {
                let ot = await n(Y);
                st = ot !== !1 && ot?.ok !== !1;
            } else st = await jX(e, Y, {
                apiKey: r,
                getAuth: f
            });
            !st && G < b && (A.push({
                envelope: Y,
                attempt: G + 1
            }), I(G + 1));
        } catch  {
            G < b && (A.push({
                envelope: Y,
                attempt: G + 1
            }), I(G + 1));
        }
    }, V = (Y = !1, G = !1)=>{
        if (O && (clearTimeout(O), O = null), !x.length && !G) return;
        let st = x;
        x = [];
        let ot = M(st, G);
        if (ot) {
            if (Y && Y_) {
                if (typeof o == "function" && SO(()=>o(ot))) return;
                if (navigator.sendBeacon && e) {
                    let dt = MX(ot);
                    if (dt) try {
                        navigator.sendBeacon(e, new R.Blob([
                            dt
                        ], {
                            type: "application/json"
                        }));
                        return;
                    } catch  {}
                }
            }
            K(ot);
        }
    }, J = !1, ht = ()=>{
        J || (J = !0, V(!0, !0));
    };
    Y_ && (R.addEventListener("pagehide", ht, {
        passive: !0
    }), R.addEventListener("beforeunload", ht, {
        passive: !0
    }), R.addEventListener("visibilitychange", ()=>{
        R.document.visibilityState === "hidden" && V(!0);
    }, {
        passive: !0
    }));
    let nt = (Y)=>{
        if (!Y || S < 1 && Math.random() > S) return;
        J && (J = !1);
        let G = {
            ...Y,
            log_type: d(Y)
        };
        x.push(G), x.length > v && (x = x.slice(-v)), x.length >= y ? V() : N();
    }, tt = (Y)=>(V(!1, !0), _ = Y || w(), J = !1, nt.sessionId = _, _);
    return nt.flush = ()=>V(!1), nt.endSession = ht, nt.startNewSession = tt, nt.sessionId = _, nt;
}, SO = (t)=>{
    try {
        return t();
    } catch  {
        return null;
    }
}, jX = async (t, e, { apiKey: n, getAuth: o })=>{
    let r = {
        "Content-Type": "application/json",
        "X-Analyze-Beacon": "1"
    };
    if (n && (r["X-Analyze-Key"] = n), o) try {
        let s = await o();
        s && (r.Authorization = `Bearer ${s}`);
    } catch  {}
    try {
        return (await fetch(t, {
            method: "POST",
            headers: r,
            body: JSON.stringify(e),
            keepalive: !0,
            credentials: "omit",
            mode: "cors"
        })).ok;
    } catch  {
        return !1;
    }
};
var UX = {
    error: "\x1B[31m",
    warn: "\x1B[33m",
    info: "\x1B[36m",
    debug: "\x1B[90m",
    trace: "\x1B[90m"
}, HX = "\x1B[0m", Z_ = typeof R < "u" && typeof R.document < "u", xO = (t = {})=>{
    let e = t.minLevel || null, n = console.error.bind(console), o = console.warn.bind(console), r = console.log.bind(console);
    return (s)=>{
        if (!s) return;
        let i = s.level === "error" ? n : s.level === "warn" ? o : r, a = `[analyze:${s.type}]`;
        if (Z_) i(a, s);
        else {
            let c = UX[s.level] || "";
            i(`${c}${a}${HX}`, s);
        }
    };
}, kO = (t, e = {})=>{
    let n = e.max || t.config.cache?.max || 500, o = new Array(n), r = 0, s = 0, i = (a)=>{
        o[r] = a, r = (r + 1) % n, s < n && s++;
    };
    return t.__memory = {
        push: i,
        snapshot: ()=>{
            let a = new Array(s), c = (r - s + n) % n;
            for(let l = 0; l < s; l++)a[l] = o[(c + l) % n];
            return a;
        },
        query: (a = {})=>{
            let c = t.__memory.snapshot(), l = a.sinceMs ? Date.now() - a.sinceMs : 0;
            return c.filter((f)=>!(!f || a.level && f.level !== a.level || a.type && f.type !== a.type || l && f.ts < l));
        },
        clear: ()=>{
            r = 0, s = 0;
        }
    }, i;
}, TO = (t = {})=>{
    let e = t.url, n = t.batchMs != null ? t.batchMs : 5e3, o = t.maxBatch || 50;
    if (!e) return ()=>{};
    let r = [], s = null, i = ()=>{
        if (s && (clearTimeout(s), s = null), !r.length) return;
        let c = JSON.stringify({
            events: r
        });
        r = [];
        let l = Z_ ? new R.Blob([
            c
        ], {
            type: "application/json"
        }) : c;
        if (Z_ && navigator.sendBeacon) try {
            navigator.sendBeacon(e, l);
            return;
        } catch  {}
        typeof fetch < "u" && fetch(e, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Analyze-Beacon": "1"
            },
            body: c,
            keepalive: !0
        }).catch(()=>{});
    };
    Z_ && (R.addEventListener("pagehide", i, {
        passive: !0
    }), R.addEventListener("beforeunload", i, {
        passive: !0
    }));
    let a = (c)=>{
        c && (r.push(c), r.length >= o ? i() : s || (s = setTimeout(i, n)));
    };
    return a.flush = i, a;
}, Lj = {
    console: xO,
    memory: kO,
    beacon: TO,
    remote: X_
}, Pj = (t, e)=>e.getDebug != null || e.debug != null ? e : {
        ...e,
        getDebug: ()=>t.config.debug === !0
    }, Q_ = (t)=>{
    let e = Array.isArray(t.config.sinks) ? t.config.sinks : [
        "console"
    ], n = [];
    for (let o of e)if (typeof o == "function") n.push(o);
    else if (typeof o == "string") {
        let r = Lj[o];
        if (!r) continue;
        n.push(o === "memory" ? r(t, {}) : r(o === "remote" ? Pj(t, {}) : {}));
    } else if (o && typeof o == "object" && o.type) {
        let r = Lj[o.type];
        if (!r) continue;
        n.push(o.type === "memory" ? r(t, o) : r(o.type === "remote" ? Pj(t, o) : o));
    }
    return n;
};
var VX = typeof R < "u" && typeof R.document < "u", zX = new Set([
    "password",
    "hidden"
]), Ij = (t, e)=>{
    let n = 0, o = null, r = null;
    return (...s)=>{
        let i = Date.now();
        i - n >= e ? (n = i, t(...s)) : (r = s, o || (o = setTimeout(()=>{
            n = Date.now(), o = null, r && (t(...r), r = null);
        }, e - (i - n))));
    };
}, EO = "__analyzeKeyPath", dl = (t)=>{
    let e = t.target;
    if (!e) return {
        selector: null,
        key: null,
        path: null
    };
    if (e[EO]) return e[EO];
    let n = [], o = e, r = 0, s = null;
    for(; o && r < 64;){
        if (o.getAttribute) {
            let a = o.getAttribute("data-key");
            a && (s == null && (s = a), n.unshift(a));
        }
        o = o.parentNode, r++;
    }
    let i;
    if (n.length) i = {
        selector: null,
        key: s,
        path: n.join(" > "),
        tag: e.tagName?.toLowerCase() || null
    };
    else {
        let a = (e.tagName || "unknown").toLowerCase(), c = e.id ? `#${e.id}` : "", l = e.className && typeof e.className == "string" ? "." + e.className.trim().split(/\s+/).slice(0, 2).join(".") : "";
        i = {
            selector: `${a}${c}${l}`,
            key: null,
            path: null
        };
    }
    try {
        e[EO] = i;
    } catch  {}
    return i;
}, WX = (t, e)=>{
    if (e === "mask") return "***";
    if (e !== "redact") {
        if (e === "hash") {
            let n = 0, o = String(t || "");
            for(let r = 0; r < o.length; r++)n = (n << 5) - n + o.charCodeAt(r) | 0;
            return `#${(n >>> 0).toString(36)}`;
        }
        return "***";
    }
}, KX = (t)=>!!(!t || t.tagName === "INPUT" && zX.has(t.type) || K_.test(t.name || "") || K_.test(t.id || "") || t.dataset?.analyze === "skip"), J_ = (t)=>{
    if (!VX) return;
    let e = t.config.capture, n = t.config.throttle, o = t.__teardown, r = (s, i, a, c)=>{
        s.addEventListener(i, a, c), o.push(()=>s.removeEventListener(i, a, c));
    };
    if (e.errors && (r(R, "error", (s)=>{
        t.emit(it("error", "error", {
            hook: "window.onerror",
            message: s.message || null,
            error: s.error || null,
            source: s.filename || null,
            line: s.lineno || null,
            col: s.colno || null
        }));
    }), r(R, "unhandledrejection", (s)=>{
        let i = s.reason, a = i instanceof Error ? i : null;
        t.emit(it("error", "error", {
            hook: "unhandledrejection",
            message: a?.message || (typeof i == "string" ? i : "Unhandled promise rejection"),
            error: a
        }));
    })), e.pointer) {
        r(R, "click", (i)=>{
            t.emit(it("pointer", "info", {
                hook: "click",
                target: dl(i),
                button: i.button,
                x: i.clientX,
                y: i.clientY,
                modifiers: Mj(i)
            }));
        }, {
            passive: !0,
            capture: !0
        }), r(R, "dblclick", (i)=>{
            t.emit(it("pointer", "info", {
                hook: "dblclick",
                target: dl(i),
                x: i.clientX,
                y: i.clientY
            }));
        }, {
            passive: !0,
            capture: !0
        }), r(R, "contextmenu", (i)=>{
            t.emit(it("pointer", "info", {
                hook: "contextmenu",
                target: dl(i),
                x: i.clientX,
                y: i.clientY
            }));
        }, {
            passive: !0,
            capture: !0
        });
        let s = Ij((i)=>{
            t.emit(it("pointer", "trace", {
                hook: "pointermove",
                x: i.clientX,
                y: i.clientY
            }));
        }, n.pointermove);
        r(R, "pointermove", s, {
            passive: !0
        });
    }
    if (e.keyboard && r(R, "keydown", (s)=>{
        t.emit(it("keyboard", "info", {
            hook: "keydown",
            code: s.code,
            key: s.key && s.key.length === 1 ? "\xB7" : s.key,
            modifiers: Mj(s),
            target: dl(s)
        }));
    }, {
        passive: !0,
        capture: !0
    }), e.forms) {
        let s = (i)=>{
            let a = i.target;
            if (!a || !a.tagName || ![
                "INPUT",
                "TEXTAREA",
                "SELECT"
            ].includes(a.tagName)) return;
            let l = KX(a), f = a.dataset?.analyze === "track", u = null;
            f && !l ? u = a.value : t.config.maskFormValues !== !1 && (u = WX(a.value, t.config.maskStrategy)), t.emit(it("forms", "info", {
                hook: i.type,
                target: dl(i),
                field: {
                    name: a.name || null,
                    type: a.type || a.tagName.toLowerCase()
                },
                value: u
            }));
        };
        r(R, "input", s, {
            passive: !0,
            capture: !0
        }), r(R, "change", s, {
            passive: !0,
            capture: !0
        }), r(R, "submit", (i)=>{
            t.emit(it("forms", "info", {
                hook: "submit",
                target: dl(i)
            }));
        }, {
            passive: !0,
            capture: !0
        });
    }
    if (e.scroll) {
        let s = Ij(()=>{
            t.emit(it("scroll", "trace", {
                hook: "scroll",
                x: R.scrollX,
                y: R.scrollY
            }));
        }, n.scroll);
        r(R, "scroll", s, {
            passive: !0,
            capture: !0
        });
    }
    if (e.viewport) {
        let s = Fl(()=>{
            t.emit(it("viewport", "info", {
                hook: "resize",
                w: R.innerWidth,
                h: R.innerHeight,
                dpr: R.devicePixelRatio || 1
            }));
        }, n.resize);
        r(R, "resize", s, {
            passive: !0
        }), r(R, "orientationchange", ()=>{
            t.emit(it("viewport", "info", {
                hook: "orientationchange",
                orientation: typeof screen < "u" && screen.orientation ? screen.orientation.type : null
            }));
        }, {
            passive: !0
        }), r(R.document, "visibilitychange", ()=>{
            t.emit(it("viewport", "info", {
                hook: "visibilitychange",
                hidden: R.document.hidden
            }));
        }, {
            passive: !0
        }), t.emit(it("viewport", "info", {
            hook: "initial",
            w: R.innerWidth,
            h: R.innerHeight,
            dpr: R.devicePixelRatio || 1
        }));
    }
    if (e.console) for (let s of [
        "log",
        "warn",
        "error",
        "debug"
    ]){
        let i = console[s];
        console[s] = function(...a) {
            try {
                t.emit(it("console", s === "error" ? "error" : s === "warn" ? "warn" : "debug", {
                    hook: `console.${s}`,
                    args: a.map(Bj)
                }));
            } catch  {}
            return i.apply(console, a);
        }, o.push(()=>{
            console[s] = i;
        });
    }
    if (e.performance && typeof PerformanceObserver < "u") try {
        let s = new PerformanceObserver((a)=>{
            for (let c of a.getEntries())t.emit(it("performance", "info", {
                hook: c.entryType,
                name: c.name,
                startTime: c.startTime,
                duration: c.duration,
                value: c.value != null ? c.value : null
            }));
        }), i = [
            "largest-contentful-paint",
            "layout-shift",
            "longtask",
            "paint",
            "first-input",
            "event"
        ];
        for (let a of i)try {
            s.observe({
                type: a,
                buffered: !0
            });
        } catch  {}
        o.push(()=>s.disconnect());
    } catch  {}
}, Mj = (t)=>({
        shift: !!t.shiftKey,
        ctrl: !!t.ctrlKey,
        alt: !!t.altKey,
        meta: !!t.metaKey
    }), GX = (t)=>{
    let e = {
        name: t.name || "Error",
        message: typeof t.message == "string" ? t.message : String(t),
        stack: typeof t.stack == "string" ? t.stack : null
    };
    return t.cause !== void 0 && (e.cause = Bj(t.cause)), e;
}, Bj = (t)=>{
    if (t == null) return t;
    if (t instanceof Error) return GX(t);
    if (typeof t == "object") try {
        return JSON.parse(JSON.stringify(t));
    } catch  {
        return String(t);
    }
    return t;
};
var qX = typeof R < "u" && typeof R.document < "u", Nj = (t, e)=>{
    let n = t?.analyze;
    if (!n || !n.shouldCapture("network")) return;
    let o = e.phase === "error" ? "error" : "info";
    n.emit(it("network", o, {
        hook: `fetch.${e.phase}`,
        source: "symbo-fetch",
        ...e
    }));
}, yp = (t)=>{
    if (qX && t.config.capture.network && !t.__networkListeners) {
        if (t.__networkListeners = !0, t.__teardown.push(()=>{
            t.__networkListeners = !1;
        }), typeof R.fetch == "function") {
            let e = R.fetch.bind(R), n = function(o, r) {
                if (r?.headers?.["X-Analyze-Beacon"] || !t.shouldCapture("network")) return e(o, r);
                let s = typeof o == "string" ? o : o && o.url || "", i = (r?.method || typeof o == "object" && o?.method || "GET").toUpperCase(), a = typeof performance < "u" ? performance.now() : Date.now();
                return t.emit(it("network", "info", {
                    hook: "fetch.start",
                    source: "window.fetch",
                    url: s,
                    method: i
                })), e(o, r).then((c)=>{
                    let l = (typeof performance < "u" ? performance.now() : Date.now()) - a;
                    return t.emit(it("network", c.ok ? "info" : "warn", {
                        hook: "fetch.success",
                        source: "window.fetch",
                        url: s,
                        method: i,
                        status: c.status,
                        ok: c.ok,
                        durationMs: l
                    })), c;
                }).catch((c)=>{
                    let l = (typeof performance < "u" ? performance.now() : Date.now()) - a;
                    throw t.emit(it("network", "error", {
                        hook: "fetch.error",
                        source: "window.fetch",
                        url: s,
                        method: i,
                        error: c,
                        durationMs: l
                    })), c;
                });
            };
            R.fetch = n, t.__teardown.push(()=>{
                R.fetch = e;
            });
        }
        if (typeof R.XMLHttpRequest == "function") {
            let e = R.XMLHttpRequest, n = e.prototype.open, o = e.prototype.send;
            e.prototype.open = function(r, s) {
                return this.__analyze = {
                    method: String(r).toUpperCase(),
                    url: String(s)
                }, n.apply(this, arguments);
            }, e.prototype.send = function(r) {
                let s = this.__analyze;
                if (!s || !t.shouldCapture("network")) return o.apply(this, arguments);
                let i = typeof performance < "u" ? performance.now() : Date.now();
                t.emit(it("network", "info", {
                    hook: "xhr.start",
                    source: "xhr",
                    url: s.url,
                    method: s.method
                }));
                let a = ()=>{
                    let l = (typeof performance < "u" ? performance.now() : Date.now()) - i, f = this.status >= 200 && this.status < 400;
                    t.emit(it("network", f ? "info" : "warn", {
                        hook: "xhr.success",
                        source: "xhr",
                        url: s.url,
                        method: s.method,
                        status: this.status,
                        ok: f,
                        durationMs: l
                    }));
                }, c = ()=>{
                    let l = (typeof performance < "u" ? performance.now() : Date.now()) - i;
                    t.emit(it("network", "error", {
                        hook: "xhr.error",
                        source: "xhr",
                        url: s.url,
                        method: s.method,
                        status: this.status,
                        durationMs: l
                    }));
                };
                return this.addEventListener("loadend", a), this.addEventListener("error", c), o.apply(this, arguments);
            }, t.__teardown.push(()=>{
                e.prototype.open = n, e.prototype.send = o;
            });
        }
    }
};
var YX = {
    errors: !0,
    warnings: !0,
    pointer: !1,
    keyboard: !1,
    forms: !1,
    scroll: !1,
    viewport: !1,
    network: !1,
    performance: !1,
    navigation: !1,
    console: !1,
    lifecycle: !1,
    state: !1,
    updates: !1,
    replay: !1,
    telemetry: !1
}, XX = {
    errors: !0,
    warnings: !0,
    pointer: !0,
    keyboard: !0,
    forms: !0,
    scroll: !0,
    viewport: !0,
    navigation: !0,
    state: !0
}, ZX = {
    errors: !0,
    warnings: !0,
    pointer: !0,
    navigation: !0,
    performance: !0,
    viewport: !0
}, QX = {
    errors: !0,
    warnings: !0,
    console: !0,
    network: !1,
    navigation: !0,
    performance: !0,
    viewport: !0,
    lifecycle: !1,
    state: !1,
    updates: !1
}, JX = (t)=>{
    let e = {
        ...YX,
        ...t
    };
    return e.replay && Object.assign(e, XX), e.telemetry && Object.assign(e, ZX), e.remote && Object.assign(e, QX), Object.assign(e, t), e;
}, tZ = 64, eZ = ()=>{
    if (typeof R > "u" || !R.location) return null;
    try {
        let e = new URLSearchParams(R.location.search).get("analyze");
        return e || null;
    } catch  {
        return null;
    }
}, $j = (t = {})=>{
    let e = t === !0 ? {} : {
        ...t
    };
    e.capture = JX(e.capture || {});
    let n = eZ();
    (n === "debug" || e.debug) && (e.level = "debug", e.debug = !0, e.capture = {
        ...e.capture,
        lifecycle: !0,
        state: !0,
        updates: !0,
        console: !0,
        network: !0
    }), n === "off" && (e.enabled = !1), e.level = mp(e.level || "warn"), e.cache = {
        max: 500,
        dedupeWindowMs: 1e3,
        ...e.cache || {}
    }, e.throttle = {
        pointermove: 80,
        mousemove: 80,
        scroll: 100,
        resize: 200,
        ...e.throttle || {}
    }, e.maskFormValues == null && (e.maskFormValues = !0), e.maskStrategy || (e.maskStrategy = "mask"), Array.isArray(e.sinks) || (e.sinks = [
        "console",
        "memory"
    ]), Array.isArray(e.transformers) || (e.transformers = [
        "enrich",
        "summarize"
    ]);
    let o = {
        config: e,
        context: null,
        __ready: !1,
        __paused: !1,
        __preBuffer: [],
        __teardown: [],
        __pipeline: null,
        __sinks: null,
        __memory: null,
        __initialSnapshot: null
    }, r = ()=>{
        o.__pipeline || (o.__pipeline = q_(o), o.__sinks = Q_(o));
    };
    return o.shouldCapture = (s)=>o.config.enabled === !1 ? !1 : !!o.config.capture[s], o.emit = (s)=>{
        if (s && o.config.enabled !== !1 && !o.__paused && W_(s.level, o.config.level)) {
            if (!o.__ready) {
                if (s.level !== "error" && !o.config.captureDuringHydration) return;
                o.__preBuffer.length < tZ && o.__preBuffer.push(s);
                return;
            }
            r(), Fj(o, s);
        }
    }, o.activate = (s)=>{
        if (o.context == null && (o.context = s || null), o.__ready) return;
        o.__ready = !0;
        let i = o.__preBuffer;
        if (o.__preBuffer = [], i.length) {
            r();
            for (let a of i)Fj(o, a);
        }
        try {
            J_(o);
        } catch (a) {
            console.error("[analyze] browser attach error:", a);
        }
        try {
            yp(o);
        } catch (a) {
            console.error("[analyze] network attach error:", a);
        }
        for (let a of o.__onActivate || [])try {
            a(o);
        } catch (c) {
            console.error("[analyze] onActivate error:", c);
        }
    }, o.pause = ()=>{
        o.__paused = !0;
    }, o.resume = ()=>{
        o.__paused = !1;
    }, o.setLevel = (s)=>{
        o.config.level = mp(s);
    }, o.setCapture = (s, i)=>{
        if (o.config.capture[s] = !!i, s === "network" && i && o.__ready) try {
            yp(o);
        } catch (a) {
            console.error("[analyze] network attach error:", a);
        }
    }, o.query = (s)=>o.__memory ? o.__memory.query(s) : [], o.snapshot = ()=>o.__memory ? o.__memory.snapshot() : [], o.emitNetwork = (s)=>{
        if (!o.shouldCapture("network")) return;
        let i = s?.phase, a = i === "error" ? "error" : i === "success" && s.ok === !1 ? "warn" : "info";
        o.emit({
            id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
            ts: Date.now(),
            type: "network",
            level: a,
            hook: `fetch.${i || "unknown"}`,
            ...s
        });
    }, o.flush = ()=>{
        if (o.__sinks) for (let s of o.__sinks)typeof s.flush == "function" && s.flush();
    }, o.startNewSession = (s)=>{
        let i = s || (typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`), a = Array.isArray(o.config.sinks) ? o.config.sinks : [];
        for (let c of a)c && typeof c == "object" && c.type === "remote" && (c.sessionId = i);
        if (o.__sinks) for (let c of o.__sinks)typeof c.startNewSession == "function" && c.startNewSession(i);
        return i;
    }, o.replay = ()=>({
            initialSnapshot: o.__initialSnapshot,
            events: o.snapshot()
        }), o.destroy = ()=>{
        for (let s of o.__teardown)try {
            s();
        } catch  {}
        o.__teardown = [], o.__ready = !1, o.__paused = !0;
    }, o.__onActivate = [], o.onActivate = (s)=>{
        o.__onActivate.push(s);
    }, o;
}, Fj = (t, e)=>{
    let n = t.__pipeline(e);
    if (n == null) return;
    let o = Array.isArray(n) ? n : [
        n
    ];
    for (let r of o){
        if (typeof t.config.onEvent == "function") try {
            t.config.onEvent(r);
        } catch  {}
        for (let s of t.__sinks)try {
            s(r);
        } catch (i) {
            console.error("[analyze] sink error:", i);
        }
    }
};
var PO = /*@__PURE__*/ F({}, {
    shorthandPlugin: ()=>eb
});
var LO = /*@__PURE__*/ F({}, {
    PRESERVE_VALUE_KEYS: ()=>se,
    SKIP_INLINE_KEYS: ()=>as,
    abbrToProp: ()=>re,
    decode: ()=>zj,
    encode: ()=>Uj,
    expand: ()=>Ji,
    isComponentKey: ()=>Xn,
    isSelectorKey: ()=>Zn,
    parse: ()=>ta,
    parseFurther: ()=>na,
    propToAbbr: ()=>En,
    shorten: ()=>bp,
    shorthandPlugin: ()=>eb,
    stringify: ()=>Qi,
    stringifyFurther: ()=>ea
});
var En = {
    attr: "at",
    childExtends: "cex",
    childExtendsRecursive: "cexr",
    childProps: "cp",
    children: "ch",
    childrenAs: "cha",
    class: "cl",
    content: "cnt",
    context: "ctx",
    data: "dt",
    extends: "ext",
    hide: "hd",
    html: "htm",
    if: "if",
    ignoreChildExtends: "icex",
    key: "ky",
    query: "qy",
    routes: "rt",
    scope: "scp",
    show: "shw",
    state: "st",
    style: "sy",
    tag: "tg",
    text: "tx",
    align: "aln",
    boxSize: "bsz",
    flow: "fl",
    heightRange: "hr",
    horizontalInset: "hi",
    round: "rnd",
    shadow: "shd",
    size: "sz",
    templateColumns: "tcol",
    verticalInset: "vi",
    widthRange: "wr",
    wrap: "wrp",
    aspectRatio: "ar",
    blockSize: "bks",
    boxSizing: "bxs",
    height: "h",
    inlineSize: "ins",
    margin: "m",
    marginBottom: "mb",
    marginLeft: "ml",
    marginRight: "mr",
    marginTop: "mt",
    maxBlockSize: "mxbs",
    maxHeight: "mxh",
    maxInlineSize: "mxis",
    maxWidth: "mxw",
    minBlockSize: "mnbs",
    minHeight: "mnh",
    minInlineSize: "mnis",
    minWidth: "mnw",
    padding: "p",
    paddingBottom: "pb",
    paddingInline: "pil",
    paddingLeft: "pl",
    paddingRight: "pr",
    paddingTop: "pt",
    width: "w",
    alignContent: "ac",
    alignItems: "ai",
    alignSelf: "as",
    flex: "fx",
    flexBasis: "fxb",
    flexDirection: "fxd",
    flexFlow: "fxf",
    flexGrow: "fxg",
    flexShrink: "fxs",
    flexWrap: "fxw",
    gap: "g",
    justifyContent: "jc",
    justifyItems: "ji",
    justifySelf: "js",
    order: "od",
    placeContent: "pcn",
    placeItems: "pit",
    placeSelf: "psl",
    rowGap: "rg",
    columnGap: "cg",
    gridArea: "ga",
    gridAutoColumns: "gac",
    gridAutoFlow: "gaf",
    gridAutoRows: "gar",
    gridColumn: "gc",
    gridColumnEnd: "gce",
    gridColumnStart: "gcs",
    gridRow: "gr",
    gridRowEnd: "gre",
    gridRowStart: "grs",
    gridTemplateAreas: "gta",
    gridTemplateColumns: "gtc",
    gridTemplateRows: "gtr",
    bottom: "bot",
    float: "flt",
    inset: "ist",
    left: "lft",
    position: "pos",
    right: "rgt",
    top: "tp",
    zIndex: "zi",
    clear: "clr",
    contain: "ctn",
    cursor: "cur",
    display: "d",
    opacity: "op",
    overflow: "ov",
    overflowX: "ovx",
    overflowY: "ovy",
    pointerEvents: "pe",
    resize: "rsz",
    userSelect: "us",
    visibility: "vis",
    background: "bg",
    backgroundAttachment: "bga",
    backgroundBlendMode: "bgbm",
    backgroundClip: "bgcl",
    backgroundColor: "bgc",
    backgroundImage: "bgi",
    backgroundOrigin: "bgo",
    backgroundPosition: "bgp",
    backgroundPositionX: "bgpx",
    backgroundPositionY: "bgpy",
    backgroundRepeat: "bgr",
    backgroundRepeatX: "bgrx",
    backgroundRepeatY: "bgry",
    backgroundSize: "bgs",
    color: "c",
    theme: "thm",
    themeModifier: "thmm",
    border: "bd",
    borderBottom: "bdb",
    borderBottomLeftRadius: "bdblr",
    borderBottomRightRadius: "bdbrr",
    borderCollapse: "bdcl",
    borderColor: "bdc",
    borderImage: "bdi",
    borderImageOutset: "bdio",
    borderImageRepeat: "bdir",
    borderImageSlice: "bdis",
    borderImageSource: "bdisrc",
    borderImageWidth: "bdiw",
    borderLeft: "bdl",
    borderRadius: "bdr",
    borderRight: "bdrg",
    borderSpacing: "bdsp",
    borderStyle: "bdst",
    borderTop: "bdt",
    borderTopLeftRadius: "bdtlr",
    borderTopRightRadius: "bdtrr",
    borderWidth: "bdw",
    outline: "ol",
    outlineColor: "olc",
    outlineOffset: "olo",
    outlineStyle: "ols",
    outlineWidth: "olw",
    boxShadow: "bxsh",
    textShadow: "txsh",
    direction: "dir",
    fontDisplay: "fdi",
    fontFamily: "ff",
    fontFeatureSettings: "ffs",
    fontKerning: "fk",
    fontOpticalSizing: "fos",
    fontPalette: "fpl",
    fontSize: "fs",
    fontSizeAdjust: "fsa",
    fontSmooth: "fsm",
    fontStretch: "fsr",
    fontStyle: "fsy",
    fontSynthesis: "fsyn",
    fontVariant: "fv",
    fontVariationSettings: "fvs",
    fontWeight: "fw",
    hyphens: "hyp",
    letterSpacing: "ls",
    lineHeight: "lh",
    tabSize: "tsz",
    textAlign: "ta",
    textDecoration: "td",
    textDecorationColor: "tdc",
    textDecorationLine: "tdl",
    textDecorationStyle: "tds",
    textIndent: "ti",
    textOverflow: "tov",
    textStroke: "tsk",
    textTransform: "tt",
    unicodeBidi: "ub",
    verticalAlign: "va",
    whiteSpace: "ws",
    wordBreak: "wbr",
    wordSpacing: "wsp",
    wordWrap: "wwr",
    writingMode: "wm",
    captionSide: "cps",
    counterIncrement: "ci",
    counterReset: "cr",
    emptyCells: "ec",
    listStyle: "lst",
    listStyleImage: "lsi",
    listStylePosition: "lsp",
    listStyleType: "lsty",
    quotes: "qt",
    tableLayout: "tl",
    columnCount: "cc",
    columnFill: "cf",
    columnRule: "crl",
    columnRuleColor: "crlc",
    columnRuleStyle: "crls",
    columnRuleWidth: "crlw",
    columnSpan: "cspn",
    columnWidth: "cwi",
    columns: "col",
    backdropFilter: "bdf",
    boxDecorationBreak: "bxdb",
    clipPath: "cpth",
    filter: "fil",
    isolation: "iso",
    mixBlendMode: "mbm",
    objectFit: "obf",
    objectPosition: "obp",
    perspective: "prs",
    perspectiveOrigin: "prso",
    willChange: "wc",
    transform: "tf",
    transformOrigin: "tfo",
    transformStyle: "tfs",
    transition: "trn",
    transitionDelay: "trnd",
    transitionDuration: "trndr",
    transitionProperty: "trnp",
    transitionTimingFunction: "trntf",
    animation: "an",
    animationDelay: "and",
    animationDirection: "andr",
    animationDuration: "andur",
    animationFillMode: "anfm",
    animationIterationCount: "anic",
    animationName: "ann",
    animationPlayState: "anps",
    animationTimingFunction: "antf",
    scrollBehavior: "sb",
    scrollMargin: "smr",
    scrollMarginBottom: "smrb",
    scrollMarginLeft: "smrl",
    scrollMarginRight: "smrr",
    scrollMarginTop: "smrt",
    scrollPadding: "spd",
    scrollPaddingBottom: "spdb",
    scrollPaddingLeft: "spdl",
    scrollPaddingRight: "spdr",
    scrollPaddingTop: "spdt",
    scrollSnapAlign: "ssa",
    scrollSnapStop: "sss",
    scrollSnapType: "sst",
    breakAfter: "bka",
    breakBefore: "bkb",
    breakInside: "bki",
    pageBreakAfter: "pbka",
    pageBreakBefore: "pbkb",
    pageBreakInside: "pbki",
    accessKey: "ack",
    className: "cn",
    contentEditable: "ced",
    contextMenu: "cmu",
    draggable: "drg",
    hidden: "hid",
    id: "id",
    is: "is",
    lang: "lng",
    nonce: "nnc",
    spellCheck: "spc",
    tabIndex: "tbi",
    title: "ttl",
    translate: "trl",
    accept: "acp",
    acceptCharset: "accs",
    action: "act",
    autoComplete: "atc",
    autoFocus: "atf",
    capture: "cap",
    challenge: "chg",
    checked: "chk",
    cols: "cls",
    colSpan: "csn",
    controls: "ctl",
    default: "def",
    defer: "dfr",
    disabled: "dis",
    encType: "ect",
    form: "frm",
    formAction: "fac",
    formEncType: "fect",
    formMethod: "fme",
    formNoValidate: "fnv",
    formTarget: "ftg",
    high: "hgh",
    inputMode: "imd",
    kind: "knd",
    label: "lbl",
    list: "lis",
    loop: "lp",
    low: "lw",
    max: "mx",
    maxLength: "mxl",
    method: "mtd",
    min: "mn",
    minLength: "mnl",
    multiple: "mul",
    muted: "mut",
    name: "nm",
    open: "opn",
    optimum: "opt",
    pattern: "ptn",
    placeholder: "phd",
    readOnly: "ro",
    required: "req",
    reversed: "rev",
    rows: "rws",
    rowSpan: "rsn",
    selected: "sel",
    span: "spn",
    start: "srt",
    step: "stp",
    type: "typ",
    value: "val",
    download: "dl",
    href: "hrf",
    hrefLang: "hrl",
    ping: "png",
    referrerPolicy: "rfp",
    rel: "rl",
    target: "tgt",
    allow: "alw",
    allowFullScreen: "afs",
    allowPaymentRequest: "apr",
    alt: "alt",
    cellPadding: "cpg",
    cellSpacing: "csg",
    cite: "cit",
    coords: "crd",
    crossOrigin: "cor",
    dateTime: "dtm",
    fetchPriority: "fpr",
    headers: "hds",
    httpEquiv: "hte",
    integrity: "itg",
    isMap: "ism",
    keyType: "kty",
    loading: "ldg",
    manifest: "mft",
    media: "mda",
    poster: "pst",
    preload: "prl",
    radioGroup: "rdg",
    sandbox: "sbx",
    scoped: "scod",
    seamless: "sml",
    shape: "shp",
    sizes: "szs",
    src: "src",
    srcDoc: "srd",
    srcLang: "srl",
    srcSet: "srs",
    useMap: "ump",
    ariaActiveDescendant: "aad",
    ariaAtomic: "aat",
    ariaBusy: "abu",
    ariaChecked: "achk",
    ariaControls: "acl",
    ariaCurrent: "acr",
    ariaDescribedBy: "adb",
    ariaDetails: "adt",
    ariaDisabled: "adis",
    ariaDropEffect: "ade",
    ariaErrorMessage: "aem",
    ariaExpanded: "aexp",
    ariaGrabbed: "agr",
    ariaHasPopup: "ahp",
    ariaHidden: "ahid",
    ariaInvalid: "ainv",
    ariaLabel: "alb",
    ariaLabelledBy: "alby",
    ariaLive: "alv",
    ariaModal: "amod",
    ariaMultiSelectable: "ams",
    ariaOrientation: "aor",
    ariaOwns: "aow",
    ariaPosInSet: "apis",
    ariaPressed: "aprs",
    ariaReadOnly: "aro",
    ariaRelevant: "arl",
    ariaRequired: "areq",
    ariaSelected: "asel",
    ariaSetSize: "assz",
    ariaValueMax: "avmx",
    ariaValueMin: "avmn",
    ariaValueNow: "avn",
    role: "role",
    onInit: "@in",
    onRender: "@rn",
    onUpdate: "@up",
    onStateChange: "@sc",
    onStateUpdate: "@su",
    onClick: "@ck",
    onContextMenu: "@cm",
    onDblClick: "@dc",
    onMouseDown: "@md",
    onMouseEnter: "@me",
    onMouseLeave: "@ml",
    onMouseMove: "@mm",
    onMouseOut: "@mo",
    onMouseOver: "@mv",
    onMouseUp: "@mu",
    onKeyDown: "@kd",
    onKeyPress: "@kp",
    onKeyUp: "@ku",
    onBlur: "@bl",
    onFocus: "@fc",
    onFocusIn: "@fi",
    onFocusOut: "@fo",
    onBeforeInput: "@bi",
    onChange: "@cg",
    onFormData: "@fd",
    onInput: "@ip",
    onInvalid: "@iv",
    onReset: "@rs",
    onSearch: "@sr",
    onSelect: "@sl",
    onSubmit: "@sm",
    onTouchCancel: "@tc",
    onTouchEnd: "@te",
    onTouchMove: "@tm",
    onTouchStart: "@ts",
    onPointerCancel: "@pc",
    onPointerDown: "@pd",
    onPointerEnter: "@pe",
    onPointerLeave: "@ple",
    onPointerMove: "@pm",
    onPointerOut: "@po",
    onPointerOver: "@pov",
    onPointerUp: "@pu",
    onDrag: "@dg",
    onDragEnd: "@dge",
    onDragEnter: "@dgn",
    onDragLeave: "@dgl",
    onDragOver: "@dgo",
    onDragStart: "@dgs",
    onDrop: "@dp",
    onResize: "@rz",
    onScroll: "@scl",
    onWheel: "@wh",
    onCopy: "@cy",
    onCut: "@ct",
    onPaste: "@pt",
    onCompositionEnd: "@cpe",
    onCompositionStart: "@cps",
    onCompositionUpdate: "@cpu",
    onAnimationEnd: "@ae",
    onAnimationIteration: "@ai",
    onAnimationStart: "@as",
    onTransitionEnd: "@tre",
    onTransitionStart: "@trs",
    onAbort: "@ab",
    onCanPlay: "@cap",
    onCanPlayThrough: "@cpt",
    onDurationChange: "@duc",
    onEmptied: "@em",
    onEncrypted: "@enc",
    onEnded: "@end",
    onError: "@er",
    onLoad: "@ld",
    onLoadedData: "@ldd",
    onLoadedMetadata: "@ldm",
    onPause: "@pa",
    onPlay: "@pl",
    onPlaying: "@plg",
    onProgress: "@prg",
    onRateChange: "@rc",
    onSeeked: "@sk",
    onSeeking: "@skg",
    onStalled: "@stl",
    onSuspend: "@ssp",
    onTimeUpdate: "@tu",
    onVolumeChange: "@vc",
    onWaiting: "@wt",
    icon: "ico",
    iconText: "ict",
    lookup: "lkp",
    router: "rtr",
    shapeModifier: "shpm"
}, re = Object.create(null);
for(let t in En)re[En[t]] = t;
var AO = Object.create(null);
for(let t in En){
    let e = En[t];
    if (AO[e]) throw new Error(`Duplicate abbreviation "${e}" for "${t}" \u2014 already used by "${AO[e]}"`);
    AO[e] = t;
}
var se = new Set([
    "state",
    "st",
    "scope",
    "scp",
    "attr",
    "at",
    "style",
    "sy",
    "data",
    "dt",
    "context",
    "ctx",
    "query",
    "qy",
    "class",
    "cl"
]), as = new Set([
    "text",
    "tx",
    "html",
    "htm",
    "content",
    "cnt",
    "placeholder",
    "phd",
    "src",
    "href",
    "hrf"
]);
function Xn(t) {
    return /^[A-Z]/.test(t);
}
function Zn(t) {
    return /^[:@.!$>&]/.test(t) || t.startsWith("> ");
}
function Uj(t) {
    if (!t || typeof t != "object") return "";
    let e = [];
    for(let n in t){
        let o = t[n];
        if (typeof o == "function" || o !== null && typeof o == "object" && !Array.isArray(o) || o === void 0) continue;
        let r = En[n] || n;
        if (o === !0) e.push(r);
        else if (o === !1) e.push("!" + r);
        else if (Array.isArray(o)) {
            let s = o.map((i)=>tb(i));
            e.push(r + ":" + s.join(","));
        } else e.push(r + ":" + tb(o));
    }
    return e.join(" ");
}
function tb(t) {
    return String(t).replace(/ /g, "_");
}
function bp(t) {
    if (!t || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map(function(n) {
        return n !== null && typeof n == "object" ? bp(n) : n;
    });
    let e = {};
    for(let n in t){
        let o = t[n];
        if (Xn(n)) {
            e[n] = vO(o);
            continue;
        }
        if (Zn(n)) {
            e[n] = vO(o);
            continue;
        }
        let r = En[n] || n;
        if (se.has(n) || se.has(r)) {
            e[r] = o;
            continue;
        }
        e[r] = vO(o);
    }
    return e;
}
function vO(t) {
    return t == null || typeof t == "function" ? t : Array.isArray(t) ? t.map(function(e) {
        return e !== null && typeof e == "object" ? bp(e) : e;
    }) : typeof t == "object" ? bp(t) : t;
}
function Qi(t) {
    if (!t || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map(function(o) {
        return o !== null && typeof o == "object" ? Qi(o) : o;
    });
    let e = {}, n = [];
    for(let o in t){
        let r = t[o];
        if (Xn(o)) {
            e[o] = jj(r);
            continue;
        }
        if (Zn(o)) {
            e[o] = jj(r);
            continue;
        }
        let s = En[o] || o;
        if (se.has(o) || se.has(s)) {
            e[s] = r;
            continue;
        }
        if (typeof r == "function") {
            e[s] = r;
            continue;
        }
        if (r == null) {
            e[s] = r;
            continue;
        }
        if (as.has(o) || as.has(s)) {
            e[s] = r;
            continue;
        }
        if (Array.isArray(r)) {
            if (r.some(function(a) {
                return a !== null && typeof a == "object";
            })) {
                e[s] = r.map(function(a) {
                    return a !== null && typeof a == "object" ? Qi(a) : a;
                });
                continue;
            }
            if (r.length <= 1) {
                e[s] = r;
                continue;
            }
            n.push(s + ":" + r.map(tb).join(","));
            continue;
        }
        if (typeof r == "object") {
            e[s] = Qi(r);
            continue;
        }
        r === !0 ? n.push(s) : r === !1 ? n.push("!" + s) : typeof r == "number" || typeof r == "string" && (r.includes(",") || r.includes("_")) ? e[s] = r : n.push(s + ":" + tb(r));
    }
    return n.length && (e.in = n.join(" ")), e;
}
function jj(t) {
    return t == null || typeof t == "function" ? t : Array.isArray(t) ? t.map(function(e) {
        return e !== null && typeof e == "object" ? Qi(e) : e;
    }) : typeof t == "object" ? Qi(t) : t;
}
function zj(t) {
    if (!t || typeof t != "string") return {};
    let e = {}, n = Wj(t);
    for (let o of n){
        if (o.startsWith("!")) {
            let c = o.slice(1), l = re[c] || c;
            e[l] = !1;
            continue;
        }
        let r = o.indexOf(":");
        if (r === -1) {
            let c = re[o] || o;
            e[c] = !0;
            continue;
        }
        let s = o.slice(0, r), i = o.slice(r + 1), a = re[s] || s;
        if (i.includes(",")) {
            e[a] = i.split(",").map(Hj);
            continue;
        }
        e[a] = Hj(i);
    }
    return e;
}
function Wj(t) {
    return t.trim().split(/\s+/).filter(Boolean);
}
function Hj(t) {
    let e = t.replace(/_/g, " ");
    return /^-?\d+(\.\d+)?$/.test(e) ? Number(e) : e;
}
function Vj(t) {
    return t.replace(/_/g, " ");
}
function nZ(t) {
    if (!t || typeof t != "string") return {};
    let e = {}, n = Wj(t);
    for (let o of n){
        if (o.startsWith("!")) {
            let c = o.slice(1), l = re[c] || c;
            e[l] = !1;
            continue;
        }
        let r = o.indexOf(":");
        if (r === -1) {
            let c = re[o] || o;
            e[c] = !0;
            continue;
        }
        let s = o.slice(0, r), i = o.slice(r + 1), a = re[s] || s;
        if (i.includes(",")) {
            e[a] = i.split(",").map(Vj);
            continue;
        }
        e[a] = Vj(i);
    }
    return e;
}
function Ji(t) {
    if (!t || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map(function(n) {
        return n !== null && typeof n == "object" ? Ji(n) : n;
    });
    let e = {};
    for(let n in t){
        let o = t[n];
        if (Xn(n)) {
            e[n] = OO(o);
            continue;
        }
        let r = re[n] || n;
        if (Zn(n) && r === n) {
            e[n] = OO(o);
            continue;
        }
        if (se.has(r) || se.has(n)) {
            e[r] = o;
            continue;
        }
        e[r] = OO(o);
    }
    return e;
}
function OO(t) {
    return t == null || typeof t == "function" ? t : Array.isArray(t) ? t.map(function(e) {
        return e !== null && typeof e == "object" ? Ji(e) : e;
    }) : typeof t == "object" ? Ji(t) : t;
}
function ta(t) {
    if (!t || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map(function(n) {
        return n !== null && typeof n == "object" ? ta(n) : n;
    });
    let e = {};
    if (typeof t.in == "string") {
        let n = nZ(t.in);
        for(let o in n)e[o] = n[o];
    }
    for(let n in t){
        if (n === "in") continue;
        let o = t[n];
        if (Xn(n)) {
            e[n] = CO(o);
            continue;
        }
        let r = re[n] || n;
        if (Zn(n) && r === n) {
            e[n] = CO(o);
            continue;
        }
        if (se.has(r) || se.has(n)) {
            e[r] = o;
            continue;
        }
        e[r] = CO(o);
    }
    return e;
}
function CO(t) {
    return t == null || typeof t == "function" ? t : Array.isArray(t) ? t.map(function(e) {
        return e !== null && typeof e == "object" ? ta(e) : e;
    }) : typeof t == "object" ? ta(t) : t;
}
function Kj(t) {
    return String(t).replace(/\\/g, "\\\\").replace(/_/g, "\\_").replace(/,/g, "\\,").replace(/ /g, "_");
}
function oZ(t) {
    let e = "", n = 0;
    for(; n < t.length;){
        if (t[n] === "\\" && n + 1 < t.length) {
            let o = t[n + 1];
            if (o === "," || o === "_" || o === "\\") {
                e += o, n += 2;
                continue;
            }
        }
        t[n] === "_" ? e += " " : e += t[n], n++;
    }
    return e;
}
function rZ(t) {
    let e = [], n = "", o = 0;
    for(; o < t.length;){
        if (t[o] === "\\" && o + 1 < t.length) {
            n += t[o] + t[o + 1], o += 2;
            continue;
        }
        if (t[o] === ",") {
            e.push(n), n = "", o++;
            continue;
        }
        n += t[o], o++;
    }
    return e.push(n), e;
}
function Gj(t) {
    if (t == null || typeof t != "object" || Array.isArray(t)) return !1;
    let e = Object.keys(t);
    return e.length === 1 && e[0] === "in" && typeof t.in == "string";
}
function ea(t) {
    if (!t || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map(function(o) {
        return o !== null && typeof o == "object" ? ea(o) : o;
    });
    let e = {}, n = [];
    for(let o in t){
        let r = t[o];
        if (Xn(o)) {
            let i = qj(r);
            e[o] = Gj(i) ? i.in : i;
            continue;
        }
        if (Zn(o)) {
            let i = qj(r);
            e[o] = Gj(i) ? i.in : i;
            continue;
        }
        let s = En[o] || o;
        if (se.has(o) || se.has(s)) {
            e[s] = r;
            continue;
        }
        if (typeof r == "function") {
            e[s] = r;
            continue;
        }
        if (r == null) {
            e[s] = r;
            continue;
        }
        if (as.has(o) || as.has(s)) {
            e[s] = r;
            continue;
        }
        if (Array.isArray(r)) {
            if (r.some(function(a) {
                return a !== null && typeof a == "object";
            })) {
                e[s] = r.map(function(a) {
                    return a !== null && typeof a == "object" ? ea(a) : a;
                });
                continue;
            }
            if (r.length <= 1) {
                e[s] = r;
                continue;
            }
            n.push(s + ":" + r.map(Kj).join(","));
            continue;
        }
        if (typeof r == "object") {
            e[s] = ea(r);
            continue;
        }
        if (r === !0) {
            n.push(s);
            continue;
        }
        if (r === !1) {
            n.push("!" + s);
            continue;
        }
        if (typeof r == "number") {
            n.push(s + ":#" + r);
            continue;
        }
        n.push(s + ":" + Kj(r));
    }
    return n.length && (e.in = n.join(" ")), e;
}
function qj(t) {
    return t == null || typeof t == "function" ? t : Array.isArray(t) ? t.map(function(e) {
        return e !== null && typeof e == "object" ? ea(e) : e;
    }) : typeof t == "object" ? ea(t) : t;
}
function Yj(t) {
    return t.startsWith("#") && /^#-?\d+(\.\d+)?$/.test(t) ? Number(t.slice(1)) : oZ(t);
}
function RO(t) {
    if (!t || typeof t != "string") return {};
    let e = {}, n = t.trim().split(/\s+/).filter(Boolean);
    for (let o of n){
        if (o.startsWith("!")) {
            let l = o.slice(1), f = re[l] || l;
            e[f] = !1;
            continue;
        }
        let r = o.indexOf(":");
        if (r === -1) {
            let l = re[o] || o;
            e[l] = !0;
            continue;
        }
        let s = o.slice(0, r), i = o.slice(r + 1), a = re[s] || s, c = rZ(i);
        if (c.length > 1) {
            e[a] = c.map(Yj);
            continue;
        }
        e[a] = Yj(i);
    }
    return e;
}
function na(t) {
    if (!t || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map(function(n) {
        return n !== null && typeof n == "object" ? na(n) : n;
    });
    let e = {};
    if (typeof t.in == "string") {
        let n = RO(t.in);
        for(let o in n)e[o] = n[o];
    }
    for(let n in t){
        if (n === "in") continue;
        let o = t[n];
        if (Xn(n)) {
            typeof o == "string" ? e[n] = RO(o) : e[n] = DO(o);
            continue;
        }
        let r = re[n] || n;
        if (Zn(n) && r === n) {
            typeof o == "string" ? e[n] = RO(o) : e[n] = DO(o);
            continue;
        }
        if (se.has(r) || se.has(n)) {
            e[r] = o;
            continue;
        }
        e[r] = DO(o);
    }
    return e;
}
function DO(t) {
    return t == null || typeof t == "function" ? t : Array.isArray(t) ? t.map(function(e) {
        return e !== null && typeof e == "object" ? na(e) : e;
    }) : typeof t == "object" ? na(t) : t;
}
var sZ = {
    shorten: Ji,
    stringify: ta,
    stringifyFurther: na
};
function iZ(t, e) {
    if (!t || typeof t != "object") return t;
    if (Array.isArray(t)) return t.map((o)=>e(o));
    let n = {};
    for(let o in t){
        let r = t[o];
        n[o] = r && typeof r == "object" ? e(r) : r;
    }
    return n;
}
var aZ = [
    "components",
    "pages",
    "snippets"
], eb = {
    name: "shorthand",
    prepareContext (t) {
        let e = t.shorthand;
        if (!e) return;
        let o = sZ[e === !0 ? "shorten" : e];
        if (o) {
            for (let r of aZ)t[r] && (t[r] = iZ(t[r], o));
            t.app && typeof t.app == "object" && (t.app = o(t.app));
        }
    }
};
var Sp = /*@__PURE__*/ F({}, {
    Inspect: ()=>nb,
    inspectPlugin: ()=>lZ
});
function Xj(t) {
    return E(t) ? t : B(t) ? t.find((e)=>E(e)) : "";
}
function IO(t) {
    if (!t) return;
    let e = t.__ref.__componentKey, n = t.extends && Xj(t.extends), o = t.parent && t.parent.childExtends && Xj(t.parent.childExtends);
    return (e || n || o || "").split("_")[0].split(".")[0].split("+")[0];
}
function ob(t) {
    if (!t || !t.__ref) return;
    let { components: e, pages: n, editor: o } = t.context, r = IO(t);
    return o && o.onInitInspect && !o.onInitInspect(r, t, t.state) ? ob(t.parent) : r && (e[r] || n[r]) ? t : ob(t.parent);
}
var cZ = (t, e, n)=>{
    let o = n.window || window;
    o.onkeydown = (r)=>{
        r.altKey && r.shiftKey && t.state.update({
            debugging: !0,
            preventSelect: !0
        }, {
            preventUpdate: !0,
            preventContentUpdate: !0,
            preventRecursive: !0
        });
    }, o.onkeyup = (r)=>{
        t.state.preventSelect && (!r.altKey || !r.shiftKey) && (t.state.replace({
            debugging: !1,
            preventSelect: !1
        }, {
            preventUpdate: !0,
            preventContentUpdate: !0,
            preventRecursive: !0
        }), t.Inspector.state.update({
            area: !1
        }));
    };
}, nb = {
    ".preventSelect": {
        userSelect: "none"
    },
    "!preventSelect": {
        userSelect: "auto"
    },
    onInspect: cZ,
    onMousemove: (t, e, n)=>{
        let o = t.target.ref, r = ob(o), s = e.Inspector.state;
        if (!r || !n.debugging || !r.__ref) return s.update({
            area: !1
        });
        let i = IO(r), a = (l)=>{
            s.update({
                area: l,
                focusKey: i
            });
        }, c = ()=>{
            if (t.altKey && t.shiftKey) {
                let { x: l, y: f, width: u, height: d } = r.node.getBoundingClientRect(), p = {
                    x: l,
                    y: f,
                    width: u,
                    height: d
                };
                if (!s.area) return a(p);
                s.area.x !== p.x && a(p);
            } else s.area && s.update({
                area: !1
            });
        };
        window.requestAnimationFrame(()=>{
            c(), window.requestAnimationFrame(c);
        });
    },
    onMousedown: (t, e, n)=>{
        if (!n.debugging) return;
        let o = t.target.ref, r = ob(o);
        if (!r) return;
        let s = IO(r);
        if (!s) return;
        let i = o.context.editor;
        if (i && i.onInspect) return i.onInspect(s, o, o.state, {
            allowRouterWhileInspect: !0
        });
        let a = JSON.stringify({
            componentKey: `${s}`
        });
        return o.context.socket?.emit && o.context.socket.emit("route", a), t.preventDefault(), t.stopPropagation(), !1;
    },
    Inspector: {
        state: {},
        transition: "all, defaultBezier, X",
        position: "fixed",
        hide: (t, e)=>!(e.area && e.parent.debugging),
        style: {
            boxShadow: "0 0 10px #3686F733, 0 0 0 3px #3686F766, 0 0 100vmax 100vmax #000A",
            zIndex: "9999999",
            borderRadius: "10px",
            pointerEvents: "none"
        },
        Span: {
            position: "absolute",
            margin: "A2 0",
            fontSize: "Z",
            color: "text",
            zIndex: "99999999",
            transition: "all, defaultBezier, X",
            textDecoration: "underline",
            fontWeight: "500",
            top: "100%",
            style: {
                boxShadow: "0 25px 10px 35px black",
                textShadow: "0 0 10px black"
            },
            text: "{{ focusKey }}"
        },
        onInit: ({ context: t })=>{
            let { components: e } = t;
            if (k(e)) {
                let { Content: n, ...o } = e;
                for(let r in o)il[r] || (o[r].__ref || (o[r].__ref = {}), o[r].__ref.__componentKey || (o[r].__ref.__componentKey = r));
            }
        },
        onBeforeUpdate: (t, e, n)=>{
            let { area: o } = n, r = n.area && n.parent.debugging, s;
            if (!r) s = "display: none !important";
            else if (o) {
                let { x: i, y: a, width: c, height: l } = o;
                s = `
            display: block !important;
            top: ${a - 6}px;
            left: ${i - 6}px;
            width: ${c + 12}px;
            height: ${l + 12}px;
          `;
            }
            return e.node.style = s, e.Span.node.innerText = n.focusKey, !1;
        }
    }
}, lZ = {
    name: "inspect",
    beforeCreate (t, e) {
        Array.isArray(t.extends) ? t.extends.push(nb) : t.extends ? t.extends = [
            t.extends,
            nb
        ] : t.extends = [
            nb
        ];
    }
};
var WO = /*@__PURE__*/ F({}, {
    DefaultSyncApp: ()=>bZ,
    FORBIDDEN_SEGMENTS: ()=>wp,
    Notifications: ()=>ib,
    SyncComponent: ()=>zO,
    applyOpsToCtx: ()=>xp,
    collabIdentity: ()=>UO,
    connectToSocket: ()=>rU,
    deletePath: ()=>MO,
    describeCandidates: ()=>HO,
    isSafePath: ()=>rb,
    liveSyncTransport: ()=>sb,
    notificationsPlugin: ()=>kZ,
    onOps: ()=>jO,
    onSnapshot: ()=>$O,
    ownerSlugOf: ()=>gl,
    seedRawDesignSystem: ()=>hl,
    setPath: ()=>BO,
    syncPlugin: ()=>xZ,
    wantsLiveSync: ()=>pl
});
var wp = new Set([
    "__proto__",
    "constructor",
    "prototype"
]), rb = (t)=>{
    if (!Array.isArray(t)) return !1;
    for(let e = 0; e < t.length; e++)if (wp.has(t[e])) return !1;
    return !0;
}, MO = (t, e)=>{
    !t || !rb(e) || e.reduce((n, o, r, s)=>{
        if (n && o in n) {
            if (r !== s.length - 1) return n[o];
            delete n[o];
        }
    }, t);
}, BO = (t, e, n, o = !1)=>{
    !t || !rb(e) || e.reduce((r, s, i, a)=>{
        if (r) {
            if (i !== a.length - 1) return !r[s] && o && (r[s] = {}), r[s];
            r[s] = n;
        }
    }, t);
}, xp = (t, e)=>{
    let n = new Set;
    if (!Array.isArray(e)) return n;
    for (let [o, r, s] of e)if (!(!Array.isArray(r) || !r.length)) switch(n.add(r[0]), o){
        case "delete":
            MO(t, r);
            break;
        case "update":
        case "set":
            BO(t, r, s, !0);
            break;
        default:
            break;
    }
    return n;
}, Qj = (t, e)=>{
    if (!e || typeof e != "object" || Array.isArray(e)) return null;
    let n = t && (t.__raw || t) || {}, o = null;
    for (let r of Object.keys(e))wp.has(r) || Object.prototype.hasOwnProperty.call(n, r) || (o || (o = {}), o[r] = e[r]);
    return o;
}, fZ = ()=>typeof R < "u" && !!R && !!R.__SYMBOLS_ENV__, uZ = ()=>{
    try {
        if (R.self !== R.top) return !0;
    } catch  {
        return !0;
    }
    try {
        return new URLSearchParams(R.location.search).has("liveSync");
    } catch  {
        return !1;
    }
}, Zj = Object.freeze({
    mode: null,
    baseUrl: null
}), sb = (t)=>{
    let e = t && t.editor && t.editor.socketUrl || t && t.settings && t.settings.socketUrl;
    return typeof e == "string" && e ? fZ() && !uZ() ? Zj : {
        mode: "collab",
        baseUrl: e
    } : t && t.editor && t.editor.runtime === "runner" ? {
        mode: "runner",
        baseUrl: null
    } : Zj;
}, pl = (t)=>sb(t).mode !== null, hl = (t, e)=>{
    !t || !e || typeof e != "object" || (t.__rawDesignSystem = JSON.parse(JSON.stringify(e)));
}, Jj = (t, e, n, o = "designSystem")=>{
    for(let r in e){
        if (wp.has(r)) continue;
        let s = `${o}/${r}`;
        if (n.has(s)) continue;
        let i = e[r], a = t[r];
        if (i && typeof i == "object" && !Array.isArray(i)) {
            if (!a || typeof a != "object" || Array.isArray(a)) {
                if (r in t) continue;
                t[r] = {};
            }
            Jj(t[r], i, n, s);
        } else r in t || (t[r] = Array.isArray(i) ? JSON.parse(JSON.stringify(i)) : i);
    }
}, NO = (t, e)=>{
    if (!t || !t.__rawDesignSystem) return null;
    if (Array.isArray(e) && e.length) {
        let r = {
            designSystem: t.__rawDesignSystem
        };
        xp(r, e);
    }
    let n = JSON.parse(JSON.stringify(t.__rawDesignSystem)), o = Array.isArray(t.sharedLibraries) ? t.sharedLibraries : [];
    return Qf(n, o, Jj);
}, FO = (t)=>{
    !t || !t.polyglot || !Array.isArray(t.sharedLibraries) || Jf(t.polyglot, t.sharedLibraries);
}, tU = (t)=>{
    let e = ms;
    return typeof e == "function" && t && typeof t == "object" && !Array.isArray(t) && e(t), t;
};
var $O = (t, e, n)=>{
    let o = !1;
    return (r = {})=>{
        let { data: s } = r, { schema: i } = r;
        s && (s = t.call("deepDestringifyFunctions", s, Array.isArray(s) ? [] : {}), tU(s), Object.entries(s).forEach(([a, c])=>{
            if (n[a] && typeof n[a] == "object") {
                if (a === "designSystem") {
                    if (hl(n, c), o) {
                        let l = NO(n);
                        l && To(l);
                    }
                } else Os(n[a], c);
            } else n[a] = c;
        }), "polyglot" in s && FO(n), o = !0, i && (n.schema = i));
    };
}, jO = (t, e, n)=>(o = {})=>{
        let { changes: r } = o;
        if (!r || !Array.isArray(r) || !r.length) return;
        r = t.call("deepDestringifyFunctions", r, Array.isArray(r) ? [] : {});
        let s = r.filter((c)=>Array.isArray(c) && Array.isArray(c[1]) && c[1][0] === "designSystem"), i = s.length ? r.filter((c)=>!s.includes(c)) : r, a = xp(n, i);
        if (s.length && a.add("designSystem"), a.has("polyglot") && FO(n), a.has("designSystem")) {
            let c = NO(n, s);
            c ? To(c) : n.__warnedNoRawDesignSystem || (n.__warnedNoRawDesignSystem = !0, console.warn("[sync] design-system op ignored: no raw design system was seeded on this client. Re-initing from the processed config would corrupt every token, so the update is skipped \u2014 reload to pick it up. Seed it at boot with seedRawDesignSystem(ctx, ds)."));
        }
        if (a.has("state")) {
            let c = Qj(e, n.state);
            if (c) {
                let l = typeof e.$update == "function" ? e.$update : e.update;
                typeof l == "function" && l.call(e, c);
            }
        }
        if ([
            "pages",
            "components",
            "snippets",
            "functions",
            "assets"
        ].some((c)=>a.has(c))) {
            let { pathname: c, search: l, hash: f } = n.window.location;
            t.call("router", c + l + f, t.__ref.root, {}, {
                scrollToTop: !1,
                force: !0
            });
        }
    };
var dZ = {
    success: "green",
    error: "red",
    warning: "yellow"
}, eU = (t, e, n)=>{
    if (t.symbols) {
        if (!n.connected) {
            n.notifications.connected = {
                title: "Connected",
                message: "to the Symbols live server"
            }, n.update({
                connected: !0
            });
            let o = setTimeout(()=>{
                delete n.notifications.connected, e.notifications.content.connected.update({
                    animation: "fadeOutDown"
                }), n.update({
                    connected: !0
                }), clearTimeout(o);
            }, 3e3);
        }
    } else if (n.connected) {
        n.notifications.connected = {
            title: "Disconnected",
            type: "error"
        }, n.update({
            connected: !1
        });
        let o = setTimeout(()=>{
            delete n.notifications.connected, e.notifications.content.connected && e.notifications.content.connected.update({
                animation: "fadeOutDown"
            }), n.update({
                connected: !0
            }), clearTimeout(o);
        }, 3e3);
    }
}, ib = {
    state: {
        notifications: []
    },
    Notifications: {
        position: "fixed",
        left: "A2",
        bottom: "Z2",
        zIndex: "999",
        childExtends: "Notification",
        childProps: ({ state: t })=>({
                animationDuration: "C",
                background: dZ[t.type || "success"],
                icon: null,
                Flex: {
                    Title: {
                        text: "{{ title }}"
                    },
                    P: {
                        text: "{{ title }}"
                    }
                },
                onRender: (e, n, o)=>{
                    n.update({
                        animation: "fadeInUp"
                    });
                },
                onClick: (e, n, o)=>{
                    delete o.notifications[n.key], n.update({
                        animation: "fadeOutDown"
                    }), o.onClose && o.onClose(e, n, o);
                }
            }),
        IconText: null,
        childrenAs: "state",
        children: ({ state: t })=>t.notifications
    }
};
var cs = (t)=>typeof t == "string" && t.trim() ? t.trim() : null, gl = (t)=>{
    let e = cs(t);
    return e || t && typeof t == "object" && (cs(t.slug) || cs(t.username)) || null;
}, UO = (t)=>{
    let e = t && t.editor || {}, n = t && t.symbolsConfig || {}, o = cs(e.projectId), r = cs(e.projectKey);
    if (r) return {
        projectId: o,
        projectKey: r,
        owner: gl(e.owner)
    };
    let s = cs(t && t.key), i = cs(n.key), a = gl(n.owner);
    if (s && i && a && s === `${a}--${i}`) return {
        projectId: o,
        projectKey: i,
        owner: a
    };
    if (s) {
        let c = gl(t.owner) || (s === i ? a : null);
        return {
            projectId: o,
            projectKey: s,
            owner: c
        };
    }
    return i ? {
        projectId: o,
        projectKey: i,
        owner: a
    } : {
        projectId: o,
        projectKey: null,
        owner: null
    };
}, HO = (t)=>(Array.isArray(t) ? t : []).map((e)=>e && typeof e == "object" ? [
            gl(e.owner),
            cs(e.key)
        ].filter(Boolean).join("/") : "").filter(Boolean).join(", ");
var pZ = !1, hZ = ()=>pZ ? "http://localhost:8080" : "https://api.symbols.app", VO = null;

var gZ = ()=>(VO || (VO = (parcelRequire("kfQD7")).then((t)=>{
        let e = t && (t.io || t.default);
        if (typeof e != "function") throw new TypeError("socket.io-client exports no io()");
        return e;
    }).catch((t)=>(console.warn("[sync] socket.io-client failed to load \u2014 live sync disabled", t), null))), VO), nU = async (t, { quiet: e = !1 } = {})=>{
    try {
        let n = t || hZ(), o = await R.fetch(`${n}/service-token`, {
            method: "GET"
        });
        if (o && o.ok === !1) throw new Error(`service-token answered ${o.status}`);
        let r;
        try {
            let s = await o.clone().json();
            if (s && typeof s.token == "string") return s.token.trim() || void 0;
            r = await o.text();
        } catch  {
            r = await o.text();
        }
        return (r || "").replace(/\s+/gu, "") || void 0;
    } catch (n) {
        e || console.warn("[sync] Failed to fetch service-token", n);
    }
}, oU = (t, e, n, o)=>{
    t.on("snapshot", $O(e, n, o)), t.on("ops", jO(e, n, o)), t.on("clients", (r)=>{
        o.editor?.verbose && eU(r, e, n);
    }), t.on("disconnect", (r)=>{
        o.editor?.verbose && console.info("[sync] disconnected", r);
    });
}, mZ = async (t, e, n, o, r)=>{
    let { projectId: s, projectKey: i, owner: a } = UO(n);
    if (!i && !s) return console.warn("[sync] ctx.key missing \u2014 collab cannot authenticate"), null;
    if (!s && !a) return console.error(`[sync] collab disabled: project key '${i}' has no owner. A bare key is not unique across owners \u2014 set \`owner\` (symbols.json / context.owner) or \`editor.projectId\`.`), null;
    let c = await nU(o);
    if (!c) return console.warn("[sync] no service token \u2014 collab disabled"), null;
    let l = await r;
    if (!l) return null;
    let f = {
        projectId: s,
        projectKey: i,
        branch: "main",
        live: !0,
        clientType: "platform"
    };
    a && (f.owner = a);
    let u = null, d = !1, p = !1, g = ()=>{
        d = !0, u && typeof u.disconnect == "function" && u.disconnect();
    }, h = c;
    return u = l(o, {
        path: "/collab-socket",
        transports: [
            "websocket"
        ],
        auth: (y)=>{
            let b = h ? Promise.resolve(h) : nU(o, {
                quiet: !0
            });
            h = null, b.then((T)=>{
                if (!d) {
                    if (!T) {
                        console.warn("[sync] service token refresh failed \u2014 live sync stopped (reload the page to retry)"), g();
                        return;
                    }
                    y({
                        token: T,
                        ...f
                    });
                }
            });
        },
        reconnectionAttempts: 1 / 0,
        reconnectionDelayMax: 4e3
    }), u.on("connect", ()=>{
        p = !1, n.editor?.verbose && console.info("[sync] connected (collab)");
    }), u.on("snapshot", ()=>{
        p = !0;
    }), u.on("error", (y)=>{
        if (!(d || !y || typeof y != "object")) {
            if (y.code === "ambiguous_key") {
                let b = HO(y.candidates);
                console.error(`[sync] collab refused: project key '${i}' names more than one project` + (b ? ` (${b})` : "") + " \u2014 set `owner` (symbols.json / context.owner) or `editor.projectId`."), g();
                return;
            }
            !p && y.code && (console.warn(`[sync] collab join refused (${y.code}${y.message ? `: ${y.message}` : ""}) \u2014 live sync stopped`), g());
        }
    }), u.on("disconnect", ()=>{
        if (!(d || u.active)) {
            if (!p) {
                console.warn(`[sync] collab join refused for ${yZ(f)} \u2014 the server closed the handshake (live sync joins public projects as a viewer only). Live sync stopped.`), d = !0;
                return;
            }
            p = !1, u.connect();
        }
    }), oU(u, t, e, n), u;
}, yZ = ({ projectId: t, projectKey: e, owner: n })=>n && e ? `${n}/${e}` : t || e || "the project", _Z = async (t, e, n, o)=>{
    let r = await o;
    if (!r) return null;
    let s = r({
        transports: [
            "websocket",
            "polling"
        ],
        reconnectionAttempts: 1 / 0,
        reconnectionDelayMax: 4e3
    });
    return s.on("connect", ()=>{
        n.editor?.verbose !== !1 && console.info("[sync] connected (runner)");
    }), oU(s, t, e, n), s.on("reload", ()=>{
        typeof R < "u" && R.location && R.location.reload();
    }), s;
}, rU = async (t, e, n)=>{
    let { mode: o, baseUrl: r } = sb(n);
    if (!o) return null;
    let s = gZ();
    return o === "collab" ? mZ(t, e, n, r, s) : o === "runner" ? _Z(t, e, n, s) : null;
}, zO = {
    onInit: rU
}, bZ = {
    extends: [
        zO,
        ib
    ]
}, sU = (t)=>typeof t > "u", SZ = (t)=>!!(t?.editor?.socketUrl || t?.settings?.socketUrl), wZ = (t)=>t?.editor?.runtime === "runner", iU = (t, e)=>{
    Array.isArray(t.extends) ? t.extends.push(e) : t.extends ? t.extends = [
        t.extends,
        e
    ] : t.extends = [
        e
    ];
}, xZ = {
    name: "sync",
    beforeCreate (t, e) {
        let n = e && e.editor;
        (n && !sU(n.liveSync) ? n.liveSync : pl(e)) && (SZ(e) && !wZ(e) && !e?.key || iU(t, zO));
    }
}, kZ = {
    name: "notifications",
    beforeCreate (t, e) {
        if (!e) return;
        let n = sU(e.notifications) ? null : e.notifications, o = e.editor && e.editor.verbose === !0;
        (n === !0 || n !== !1 && o) && iU(t, ib);
    }
};
var ZO = /*@__PURE__*/ F({}, {
    readVisitorInput: ()=>RZ,
    restoreVisitorInput: ()=>LZ,
    settleVisitorInput: ()=>BZ,
    watchVisitorScroll: ()=>CZ
});
var ab = "input, textarea, select", TZ = new Set([
    "hidden",
    "file",
    "button",
    "submit",
    "reset",
    "image"
]), kp = "\0", EZ = "#", ml = (t)=>!!t && t.nodeType === 1, AZ = (t)=>t.localName === "input" ? "input:" + t.type : t.localName, aU = (t)=>{
    let e = new Map, n = new Map, o = new Map, r = (s, i)=>{
        let a = s.getAttribute("data-key"), c = a === null ? i : i ? i + kp + a : EZ;
        if (c) {
            let l = c + kp + AZ(s), f = e.get(l) || 0;
            e.set(l, f + 1);
            let u = l + kp + f;
            n.set(s, u), o.set(u, s);
        }
        for (let l of s.children)r(l, c);
    };
    for (let s of t)ml(s) && r(s, "");
    return {
        byNode: n,
        byPlace: o
    };
}, KO = (t, e)=>t.some((n)=>n === e || ml(n) && n.contains(e)), vZ = (t)=>{
    let e = -1;
    for(let n = 0; n < t.options.length; n++)t.options[n].defaultSelected && (e = n);
    if (e !== -1) return e;
    for(let n = 0; n < t.options.length; n++)if (!t.options[n].disabled) return n;
    return -1;
}, GO = (t)=>{
    let e = [];
    for (let n of t.options)n.selected && e.push(n.value);
    return e;
}, OZ = (t)=>{
    if (t.localName === "select") {
        if (t.multiple) {
            for (let e of t.options)if (e.selected !== e.defaultSelected) return {
                picked: GO(t)
            };
            return null;
        }
        return t.selectedIndex !== vZ(t) ? {
            picked: GO(t)
        } : null;
    }
    if (t.localName === "input") {
        if (TZ.has(t.type)) return null;
        if (t.type === "checkbox") return t.checked !== t.defaultChecked ? {
            checked: t.checked
        } : null;
        if (t.type === "radio") return t.checked && !t.defaultChecked ? {
            checked: !0
        } : null;
    }
    return t.value !== t.defaultValue ? {
        value: t.value
    } : null;
}, qO = (t)=>{
    try {
        return typeof t.selectionStart != "number" ? null : {
            start: t.selectionStart,
            end: t.selectionEnd,
            direction: t.selectionDirection || "none"
        };
    } catch  {
        return null;
    }
}, Tp = (t)=>({
        left: t.scrollLeft || 0,
        top: t.scrollTop || 0
    }), CZ = (t, e, n, { now: o = !1 } = {})=>{
    let r = {
        elements: new Map,
        viewport: null,
        finish: ()=>{},
        stop: ()=>{}
    };
    if (!e || typeof e.addEventListener != "function" || !t || !t.length) return r;
    let s = (d)=>{
        let p = Tp(d);
        p.top || p.left ? r.elements.set(d, p) : r.elements.delete(d);
    }, i = ()=>{
        let d = e.scrollingElement ? Tp(e.scrollingElement) : null;
        r.viewport = d && (d.top || d.left) ? d : null;
    }, a = (d)=>{
        let p = d.target;
        p === e || p === e.documentElement || p === e.scrollingElement ? i() : ml(p) && KO(t, p) && s(p);
    }, c = ()=>{
        i();
        for (let d of t)if (ml(d)) {
            s(d);
            for (let p of d.querySelectorAll("*"))s(p);
        }
    }, l = null, f = !1, u = ()=>{
        l !== null && (n && typeof n.cancelAnimationFrame == "function" && n.cancelAnimationFrame(l), l = null);
    };
    return e.addEventListener("scroll", a, {
        capture: !0,
        passive: !0
    }), !o && n && typeof n.requestAnimationFrame == "function" ? l = n.requestAnimationFrame(()=>{
        l = null, f || c();
    }) : c(), r.stop = ()=>{
        f || (f = !0, u(), e.removeEventListener("scroll", a, {
            capture: !0
        }));
    }, r.finish = ()=>{
        f || (l !== null && (u(), c()), r.stop());
    }, r;
}, RZ = (t, e, n)=>{
    if (n && n.finish(), !t || !t.length) return null;
    let o = [];
    for (let p of t){
        if (!ml(p)) continue;
        let g = p.matches(ab) ? [
            p
        ] : [];
        for (let h of p.querySelectorAll(ab))g.push(h);
        for (let h of g){
            let m = OZ(h);
            m && o.push([
                h,
                m
            ]);
        }
    }
    let r = e && e.activeElement, s = ml(r) && r !== e.body && KO(t, r) ? r : null, i = n ? [
        ...n.elements
    ].filter(([p])=>KO(t, p)) : [], a = n ? n.viewport : null;
    if (!o.length && !s && !i.length && !a) return null;
    let { byNode: c } = aU(t), l = [];
    for (let [p, g] of o){
        let h = c.get(p);
        h && l.push({
            place: h,
            ...g,
            left: p !== s
        });
    }
    let f = s ? c.get(s) : void 0, u = f ? {
        place: f,
        selection: s.matches(ab) ? qO(s) : null
    } : null, d = [];
    for (let [p, g] of i){
        let h = c.get(p);
        h && d.push({
            place: h,
            ...g
        });
    }
    return !l.length && !u && !d.length && !a ? null : {
        fields: l,
        focus: u,
        scrolled: d,
        viewport: a
    };
}, cU = (t, e)=>{
    if ("picked" in e) {
        if (t.localName !== "select") return !1;
        if (t.multiple) {
            for (let n of t.options)n.selected = e.picked.includes(n.value);
            return !0;
        }
        return e.picked.length ? (t.value = e.picked[0], t.value === e.picked[0]) : !1;
    }
    return "checked" in e ? t.type !== "checkbox" && t.type !== "radio" ? !1 : (t.checked = e.checked, !0) : t.localName !== "textarea" && t.localName !== "input" ? !1 : (t.value = e.value, t.value === e.value);
}, DZ = (t, e)=>"picked" in e ? t.multiple ? GO(t).join(kp) === e.picked.join(kp) : t.value === e.picked[0] : "checked" in e ? t.checked === e.checked : t.value === e.value, YO = (t, e)=>{
    if (!(!e || typeof t.setSelectionRange != "function")) try {
        t.setSelectionRange(e.start, e.end, e.direction);
    } catch  {}
}, XO = (t, e)=>{
    if (!(!t || typeof t.focus != "function")) {
        try {
            t.focus({
                preventScroll: !0
            });
        } catch  {
            t.focus();
        }
        YO(t, e);
    }
}, lU = (t, { top: e, left: n })=>{
    t.scrollTop !== e && (t.scrollTop = e), t.scrollLeft !== n && (t.scrollLeft = n);
}, LZ = (t, e, n)=>{
    if (!t || !e || !e.children) return null;
    let o = {
        fields: [],
        focus: null,
        scrolled: []
    }, { byPlace: r } = aU(e.children);
    for (let i of t.fields){
        let a = r.get(i.place);
        if (!a || a.disabled || a.readOnly || !cU(a, i)) continue;
        let c = {
            node: a,
            field: i,
            edited: !1,
            onEdit: null
        };
        c.onEdit = ()=>{
            c.edited = !0;
        }, a.addEventListener("input", c.onEdit), a.addEventListener("change", c.onEdit), o.fields.push(c);
    }
    if (t.focus) {
        let i = r.get(t.focus.place);
        i && (XO(i, t.focus.selection), o.focus = {
            node: i,
            selection: t.focus.selection
        });
    }
    let s = t.scrolled.map(({ place: i, top: a, left: c })=>[
            r.get(i),
            {
                top: a,
                left: c
            }
        ]);
    t.viewport && n && n.scrollingElement && s.push([
        n.scrollingElement,
        t.viewport
    ]);
    for (let [i, a] of s)i && (lU(i, a), o.scrolled.push({
        node: i,
        to: a,
        at: Tp(i)
    }));
    return o;
}, PZ = ({ to: t, at: e }, n)=>n.top === e.top && n.left === e.left && (n.top !== t.top || n.left !== t.left), IZ = (t, e, n)=>{
    let o = n.activeElement && n.activeElement !== n.body ? n.activeElement : null, r = new Set(e.scrolled.map((i)=>i.node));
    n.scrollingElement && r.add(n.scrollingElement);
    let s = (i)=>{
        for(let a = i && i.parentElement; a; a = a.parentElement)r.add(a);
    };
    for (let { node: i } of t)s(i);
    return s(o), {
        active: o,
        selection: o && o.matches(ab) ? qO(o) : null,
        scrolls: [
            ...r
        ].map((i)=>[
                i,
                Tp(i)
            ])
    };
}, MZ = (t, e)=>{
    let n = e.activeElement && e.activeElement !== e.body ? e.activeElement : null;
    if (t.active && t.active.isConnected) {
        if (n !== t.active) XO(t.active, t.selection);
        else if (t.selection) {
            let o = qO(n);
            (!o || o.start !== t.selection.start || o.end !== t.selection.end) && YO(n, t.selection);
        }
    } else n && typeof n.blur == "function" && n.blur();
    for (let [o, r] of t.scrolls)o.scrollTop = r.top, o.scrollLeft = r.left;
}, BZ = (t, e)=>{
    if (!t || !e) return;
    let n = [], o = null;
    for (let a of t.fields){
        let { node: c, field: l } = a;
        if (c.removeEventListener("input", a.onEdit), c.removeEventListener("change", a.onEdit), !(a.edited || !c.isConnected)) {
            if (!DZ(c, l)) {
                if (!cU(c, l)) continue;
                t.focus && t.focus.node === c && (o = c);
            }
            n.push(a);
        }
    }
    let r = t.focus;
    if (r && r.node.isConnected) {
        let a = e.activeElement;
        !a || a === e.body ? XO(r.node, r.selection) : a === o && YO(o, r.selection);
    }
    for (let a of t.scrolled)a.node.isConnected && PZ(a, Tp(a.node)) && lU(a.node, a.to);
    let s = e.defaultView && e.defaultView.Event || (typeof Event == "function" ? Event : null);
    if (!n.length || !s) return;
    let i = IZ(n, t, e);
    for (let { node: a, field: c } of n)a.dispatchEvent(new s("input", {
        bubbles: !0
    })), (!("value" in c) || c.left) && a.dispatchEvent(new s("change", {
        bubbles: !0
    }));
    MZ(i, e);
};
var JO = /*@__PURE__*/ F({}, {
    fetchAsync: ()=>UZ,
    fetchSync: ()=>jZ,
    remoteAppkey: ()=>hU
});
var fU = R && R.location && typeof R.location.host == "string" ? R.location.host : null, QO = fU !== null ? fU.includes("dev.") : yr(), dU = QO ? "http://localhost:8080/get" : "https://api.symbols.app/get", NZ = {
    endpoint: dU
}, pU = async (t, e = NZ)=>{
    let n = e.endpoint || dU, o = e.serviceRoute ? B(e.serviceRoute) ? e.serviceRoute.map((s)=>s.toLowerCase() + "=true").join("&") : e.serviceRoute : "", r;
    try {
        return r = await globalThis.fetch(n + "/?" + o, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-AppKey": t,
                "X-Metadata": e.metadata
            }
        }), await r.json();
    } catch (s) {
        if (P(e.onError)) return e.onError(s);
        console.error(s);
    }
}, uU = (t)=>{
    if (typeof t == "string") return t.trim() || null;
    if (k(t)) {
        if (typeof t.slug == "string" && t.slug.trim()) return t.slug.trim();
        if (typeof t.username == "string" && t.username.trim()) return t.username.trim();
    }
    return null;
}, hU = (t, e = {})=>{
    let n = typeof t == "string" ? t.trim() : "";
    if (!n) return null;
    if (/^[^/]+\/[^/]+$/.test(n)) return n;
    let o = e.symbolsConfig || {}, r = uU(o.owner);
    if (r && o.key && n === `${r}--${o.key}`) return `${r}/${o.key}`;
    let s = uU(e.owner) || (o.key === n ? r : null);
    return s ? `${s}/${n}` : null;
}, gU = (t, e)=>{
    let n = hU(t, e);
    return n || console.error(`[smbls] editor.remote: project key '${t}' has no owner \u2014 remote fetch skipped. A bare key is not unique across owners; set \`owner\` (symbols.json / options.owner) or pass key as "owner/key".`), n;
}, FZ = async (t, e)=>{
    let { editor: n } = e;
    if (n && n.remote) {
        let o = gU(t, e);
        if (!o) return e;
        let r = await pU(o, n), s = QO || e.isDevelopment ? xe(r) : xe(r.releases[0]);
        n.serviceRoute ? B(n.serviceRoute) ? n.serviceRoute.forEach((i)=>{
            le(e[i], s[i.toLowerCase()]);
        }) : le(e[n.serviceRoute], s) : [
            "state",
            "designSystem",
            "components",
            "snippets",
            "pages",
            "utils",
            "files",
            "assets",
            "packages",
            "functions",
            "globalScope"
        ].forEach((i)=>{
            le(e[i], s[i.toLowerCase()]);
        });
    }
    return e;
}, $Z = async (t, e, n)=>{
    let { editor: o } = e;
    if (o && o.remote) {
        let r = gU(t, e);
        if (!r) return;
        let s = await pU(r, o), i = QO || e.isDevelopment ? xe(s) : xe(s.releases[0]);
        n(i);
    }
}, jZ = async (t, e)=>{
    if (t && e.editor) try {
        e.editor.async || await FZ(t, e);
    } catch (n) {
        console.error(n);
    }
}, UZ = (t, e, n, o)=>{
    if (e && n.editor) try {
        n.editor.async && $Z(e, n, o || ((r)=>{
            let s = r.designSystem;
            k(s) && n.utils.init(s), k(r.state) && t.state.set(r.state);
        }));
    } catch (r) {
        console.error(r);
    }
};
var tC = /*@__PURE__*/ F({}, {
    installLazyParts: ()=>VZ
});
var mU = new WeakSet, HZ = (t, e)=>Array.isArray(t.plugins) && t.plugins.some((n)=>n && n.name === e), VZ = (t)=>{
    !t || mU.has(t) || mU.add(t);
};
var zZ = {
    windows: ()=>Promise.resolve(Qv),
    dropdown: ()=>Promise.resolve(aO),
    tooltip: ()=>Promise.resolve(hO),
    analyze: ()=>Promise.resolve(_p),
    shorthand: ()=>Promise.resolve(PO),
    inspect: ()=>Promise.resolve(Sp),
    sync: ()=>Promise.resolve(WO),
    fetch: ()=>Promise.resolve($s),
    visitorInput: ()=>Promise.resolve(ZO),
    fetchOnCreate: ()=>Promise.resolve(JO),
    lazyParts: ()=>Promise.resolve(null)
}, Be = (t, e)=>Array.isArray(t.plugins) && t.plugins.some((n)=>n && n.name === e), yU = (t)=>{
    let e = [];
    return t.shorthand && e.push("shorthand"), t.analyze && !Be(t, "analyze") && e.push("analyze"), t.inspect && !Be(t, "inspect") && e.push("inspect"), t.fetch && e.push("fetch"), t.windows !== !1 && e.push("windows"), t.dropdown !== !1 && e.push("dropdown"), t.tooltip !== !1 && e.push("tooltip"), e;
}, Ep = {}, _U = {}, qt = (t)=>{
    if (Ep[t]) return Ep[t];
    let e = zZ[t];
    return e ? (Ep[t] = e().then((n)=>(_U[t] = n, n), (n)=>(delete Ep[t], console.error(`[smbls] the ${t} module failed to load; the app runs without it`, n), null)), Ep[t]) : Promise.resolve(null);
}, oa = (t)=>_U[t] || null;
var ra = (t)=>{
    if (!t || t.__destroyed) return !1;
    let e = t.context;
    if (!e) return t.__destroyed = !0, !1;
    if (Array.isArray(e.__teardowns)) {
        for (let n of e.__teardowns)try {
            n();
        } catch (o) {
            console.error("[smbls] destroy teardown error:", o);
        }
        e.__teardowns.length = 0;
    }
    try {
        Sn(t);
    } catch (n) {
        console.error("[smbls] dispose error:", n);
    }
    if (e.fetch && e.fetch.__resolved && delete e.fetch.__resolved, e.fetch && e.fetch.__resolving && delete e.fetch.__resolving, e.db && e.db.__resolved && delete e.db.__resolved, e.db && e.db.__resolving && delete e.db.__resolving, e.analyze?.destroy) try {
        e.analyze.destroy();
    } catch (n) {
        console.error("[analyze] destroy error:", n);
    }
    return t.__destroyed = !0, !0;
};
var iC = /*@__PURE__*/ F({}, {
    Helmet: ()=>jU,
    applyElementMetadata: ()=>mb,
    applyMetadata: ()=>XZ,
    default: ()=>xQ,
    extractMetadata: ()=>qZ,
    generateHeadHtml: ()=>wQ,
    helmetPlugin: ()=>yb,
    resolveMetadata: ()=>yl
});
var An = {
    title: {
        tag: "title"
    },
    description: {
        tag: "meta",
        attr: "name",
        key: "description"
    },
    keywords: {
        tag: "meta",
        attr: "name",
        key: "keywords"
    },
    robots: {
        tag: "meta",
        attr: "name",
        key: "robots"
    },
    author: {
        tag: "meta",
        attr: "name",
        key: "author"
    },
    canonical: {
        tag: "link",
        attr: "rel",
        key: "canonical",
        valueAttr: "href"
    },
    image: {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    url: {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    siteName: {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    type: {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    locale: {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "og:title": {
        tag: "meta",
        attr: "property",
        key: "og:title"
    },
    "og:description": {
        tag: "meta",
        attr: "property",
        key: "og:description"
    },
    "og:image": {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    "og:url": {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    "og:type": {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    "og:site_name": {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    "og:locale": {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "twitter:card": {
        tag: "meta",
        attr: "name",
        key: "twitter:card"
    },
    "twitter:title": {
        tag: "meta",
        attr: "name",
        key: "twitter:title"
    },
    "twitter:description": {
        tag: "meta",
        attr: "name",
        key: "twitter:description"
    },
    "twitter:image": {
        tag: "meta",
        attr: "name",
        key: "twitter:image"
    },
    "twitter:site": {
        tag: "meta",
        attr: "name",
        key: "twitter:site"
    },
    "theme-color": {
        tag: "meta",
        attr: "name",
        key: "theme-color"
    }
}, cr = (t)=>{
    if (t.tag === "link") return `link[${t.attr}="${t.key}"]`;
    if (t.tag && !t.attr && !t.key) return t.tag;
    if (t.tag && t.attr && t.key) {
        let e = `${t.tag}[${t.attr}="${t.key}"]`;
        return t.key === "theme-color" ? `${e}:not([data-smbls-theme-color])` : e;
    }
}, bU = (t)=>xe({
        v: t
    }).v, SU = (t, e, n, o)=>{
    try {
        return bt(t, e, n);
    } catch (r) {
        console.warn(`[helmet] metadata factory for "${o}" threw; treating as unset:`, r && r.message || r);
        return;
    }
}, Ap = Object.freeze({
    authored: !0
}), cb = (t, e)=>!t || typeof Pn != "function" ? {
        value: e(),
        ready: !0
    } : Pn(e), yl = (t, e, n, o)=>{
    if (!t) return {};
    let r = o?.pending instanceof Set ? o.pending : null, s = t;
    E(s) && ie(s) && (s = bU(s));
    let i = P(s), a = !i && o?.authored === !0, c = !0, l;
    if (i) {
        let f = cb(r, ()=>SU(s, e, n, "metadata"));
        l = f.value, c = f.ready;
    } else l = k(s) ? {
        ...s
    } : {};
    if (!k(l)) return {};
    if (!c) for(let f in l)r.add(f);
    for(let f in l){
        let u = l[f], d = a && E(u) && !ie(u);
        if (E(u) && ie(u) && (u = bU(u)), P(u)) {
            let p = u, g = cb(r, ()=>SU(p, e, n, f));
            u = g.value, g.ready || r.add(f);
        } else E(u) && ie(u) && (u = void 0);
        if (E(u) && u.includes("{{") && e?.call) {
            let p = u, g = cb(r, ()=>d ? e.call("replaceLiteralsWithObjectFields", p, n, Ap) : e.call("replaceLiteralsWithObjectFields", p, n));
            u = g.value, g.ready || r.add(f);
        }
        l[f] = u;
    }
    return l;
}, WZ = (t)=>!!t && typeof t == "object" && (t.notFound === !0 || t.metadata?.notFound === !0), KZ = (t, e, n)=>{
    if (Object.prototype.hasOwnProperty.call(t, e)) return t[e];
    if (E(n) && Object.prototype.hasOwnProperty.call(t, n)) return t[n];
    if (t["/*"]) return t["/*"];
    if (t["*"]) return t["*"];
    for(let o in t)if (WZ(t[o])) return t[o];
}, GZ = (t, e)=>{
    let n = Mo;
    if (typeof n != "function") return e.metadata || e.helmet;
    let o = qs, r = typeof o == "function" ? (s)=>o("components", s, t.components, t.sharedLibraries) : t.components;
    return n(e, r);
}, qZ = (t, e = "/", n, o, r)=>{
    let s = t.pages || {}, i = KZ(s, e, o?.route), a = {};
    if (t.integrations?.seo && (a = {
        ...t.integrations.seo
    }), t.app?.metadata) {
        let f = yl(t.app.metadata, n, o, Ap);
        a = {
            ...a,
            ...f
        };
    }
    let c = new Set;
    if (i) {
        let f = GZ(t, i) || {}, u = r ? yl(f, r, r.state, Ap) : yl(f, n, o, Ap);
        for(let d in u)c.add(d);
        a = {
            ...a,
            ...u
        }, !a.title && i.state?.title && (a.title = i.state.title, c.add("title")), !a.description && i.state?.description && (a.description = i.state.description, c.add("description"));
    }
    a.title || (a.title = t.name || "Symbols"), a.title && (c.has("title") || !a["og:title"]) && (c.has("og:title") || (a["og:title"] = a.title)), a.description && (c.has("description") || !a["og:description"]) && (c.has("og:description") || (a["og:description"] = a.description)), a.title && !a["twitter:title"] && (a["twitter:title"] = a.title), a.description && !a["twitter:description"] && (a["twitter:description"] = a.description);
    let l = c.has("og:url") ? a["og:url"] : c.has("url") ? a.url : void 0;
    if (l) a["og:url"] = l;
    else if (a["og:url"] || a.url) {
        let f = (a["og:url"] || a.url || "").replace(/\/$/, "");
        if (f && e && e !== "/") {
            let u = e.startsWith("/") ? e : "/" + e;
            a["og:url"] = f + u;
        }
    }
    return Cr(a, Gs(t.files, t.sharedLibraries));
}, kU = (t, e, n)=>Cr(yl(t, e, e.state, n ? {
        pending: n
    } : void 0), e.context?.files), lb = (t)=>t.context?.document || typeof document < "u" && document, TU = (t)=>Object.prototype.hasOwnProperty.call(An, t), db = new Map;
for(let t in An){
    let e = cr(An[t]);
    db.has(e) || db.set(e, An[t]);
}
var hb = (t)=>t.head || t.querySelector("head"), Cp = (t, e)=>{
    let n = hb(t);
    return n ? n.querySelector(e) : null;
}, vp = (t, e)=>e.tag === "title" ? t.textContent : t.getAttribute(e.valueAttr || "content"), Op = (t, e, n)=>{
    e.tag === "title" ? t.textContent = n : t.setAttribute(e.valueAttr || "content", n);
}, sC = (t, e)=>{
    let n = hb(e);
    if (!n) return null;
    let o = e.createElement(t.tag);
    return t.attr && o.setAttribute(t.attr, t.key), n.appendChild(o), o;
}, sa = (t, e, n, o)=>{
    let r = t.head || t.querySelector("head");
    if (!r) return;
    let s = new Map;
    for (let a of r.querySelectorAll(`[${e}]`))s.set(a.getAttribute(e), a);
    let i = new Map;
    n.forEach((a, c)=>{
        i.has(a) || i.set(a, c);
    });
    for (let [a, c] of s)i.has(a) || c.remove();
    for (let a of n){
        if (s.has(a)) continue;
        let c = o(a, i.get(a));
        c && (c.setAttribute(e, a), r.appendChild(c));
    }
}, EU = (t, e)=>{
    let o = (e || []).filter((s)=>s != null).map((s)=>E(s) ? s : JSON.stringify(s)), r = o.map(Bn);
    sa(t, "data-smbls-jsonld", r, (s, i)=>{
        let a = t.createElement("script");
        return a.setAttribute("type", "application/ld+json"), a.textContent = o[i], a;
    });
}, AU = (t, e)=>{
    let n = (e || []).filter((r)=>r != null && String(r).trim()), o = n.map(Bn);
    sa(t, "data-smbls-style", o, (r, s)=>{
        let i = t.createElement("style");
        return i.textContent = String(n[s]), i;
    });
}, vU = (t)=>(t || []).filter((e)=>e && (E(e) ? e.trim() : e.src)), OU = (t)=>E(t) ? t : String(t.src), CU = (t, e)=>{
    let n = t.createElement("script");
    return E(e) ? n.setAttribute("src", e) : (e.src && n.setAttribute("src", e.src), e.type && n.setAttribute("type", e.type), e.async && (n.async = !0), e.defer && (n.defer = !0), e.integrity && n.setAttribute("integrity", e.integrity), e.crossorigin && n.setAttribute("crossorigin", e.crossorigin), e.referrerpolicy && n.setAttribute("referrerpolicy", e.referrerpolicy), e.nomodule && (n.noModule = !0), e.body && (n.textContent = String(e.body))), n;
}, YZ = (t, e)=>{
    let n = vU(e), o = n.map(OU);
    sa(t, "data-smbls-script", o, (r, s)=>CU(t, n[s]));
}, RU = (t, e)=>{
    let n = (e || []).filter((r)=>k(r)), o = n.map(Zs);
    sa(t, "data-smbls-alternate", o, (r, s)=>{
        let i = t.createElement("link");
        i.setAttribute("rel", "alternate");
        for (let [a, c] of Object.entries(n[s]))i.setAttribute(a, c);
        return i;
    });
}, DU = (t, e)=>{
    let n = (e || []).filter((r)=>r != null), o = n.map(Or);
    sa(t, "data-smbls-favicon", o, (r, s)=>{
        let i = n[s], a = t.createElement("link");
        if (a.setAttribute("rel", "icon"), k(i)) for (let [c, l] of Object.entries(i))a.setAttribute(c, l);
        else a.setAttribute("href", String(i));
        return a;
    });
}, LU = (t, e)=>{
    let n = e ? String(e) : "", o = n.endsWith(".svg") ? "image/svg+xml" : n.endsWith(".png") ? "image/png" : "";
    sa(t, "data-smbls-single-icon", n ? [
        n
    ] : [], (r)=>{
        let s = t.createElement("link");
        return s.setAttribute("rel", "icon"), s.setAttribute("href", r), o && s.setAttribute("type", o), s;
    });
}, PU = (t, e)=>{
    let n = (e || []).filter((r)=>k(r)), o = n.map(Qs);
    sa(t, "data-smbls-theme-color", o, (r, s)=>{
        let i = n[s], a = t.createElement("meta");
        return a.setAttribute("name", "theme-color"), i.content !== void 0 && a.setAttribute("content", i.content), i.media !== void 0 && a.setAttribute("media", i.media), a;
    });
}, XZ = (t, e)=>{
    if (!(!k(t) || !e)) {
        for(let n in t){
            let o = t[n];
            if (o == null || !TU(n) || n === "theme-color" && Array.isArray(o)) continue;
            let r = An[n], s = Cp(e, cr(r)) || sC(r, e);
            s && $U(s, r, o) && Op(s, r, o);
        }
        Array.isArray(t.jsonLd) && EU(e, t.jsonLd), Array.isArray(t.styles) && AU(e, t.styles), Array.isArray(t.scripts) && YZ(e, t.scripts), Array.isArray(t.alternate) && RU(e, t.alternate), Array.isArray(t.favicons) && DU(e, t.favicons), (t.icon || t.favicon) && LU(e, t.icon || t.favicon), Array.isArray(t["theme-color"]) && PU(e, t["theme-color"]);
    }
}, eC = new WeakMap, pb = new WeakMap, gb = (t)=>{
    let e = t.location;
    return e && E(e.pathname) ? e.pathname : null;
}, ZZ = 'meta[name="smbls-head"][content="served"]', QZ = 'meta[name="brender"], meta[name="brender-stamp"], ' + ZZ, JZ = (t)=>{
    try {
        return !!Cp(t, QZ);
    } catch  {
        return !1;
    }
}, IU = (t)=>!!t && t.__ref?.root === t, MU = (t)=>{
    let e = eC.get(t);
    return e || (e = {
        doc: t,
        built: JZ(t),
        layers: [],
        servedPath: gb(t),
        originals: new Map,
        owned: new Set,
        lists: new Set,
        firstPage: void 0,
        firstPageWatched: !1
    }, eC.set(t, e)), e;
}, tQ = (t, e)=>{
    if (!t || gb(e) === null || t.context && t.context.router === !1 || typeof t.onRenderRouter != "function") return !1;
    let n = t.routes;
    if (!n || typeof n != "object") return !1;
    for(let o in n)return !0;
    return !1;
}, BU = (t, e)=>{
    t.firstPage === void 0 && (t.firstPage = tQ(e && e.__ref && e.__ref.root, t.doc) ? "held" : "open");
}, NU = (t)=>{
    if (t.firstPage === "held") {
        t.firstPage = "shown";
        try {
            rC(t);
        } catch (e) {
            console.warn("[helmet] could not render the head after the first page:", e && e.message || e);
        }
    }
}, eQ = (t, e)=>{
    let n = MU(e);
    BU(n, t), !(n.firstPage !== "held" || n.firstPageWatched) && (n.firstPageWatched = !0, queueMicrotask(()=>{
        let o = t.context && t.context.__firstNavigation, r = ()=>NU(n);
        o && typeof o.then == "function" ? o.then(r, r) : r();
    }));
}, nQ = (t, e)=>{
    for(let n = e.parent; n && n !== n.parent; n = n.parent)if (n === t) return !0;
    return !1;
}, wU = (t)=>{
    try {
        return JSON.stringify(t === void 0 ? null : t) ?? null;
    } catch  {
        return null;
    }
}, oQ = (t)=>{
    if (!k(t)) return !0;
    for(let e in t)if (t[e] !== void 0 && t[e] !== null) return !1;
    return !0;
}, rQ = (t, e)=>{
    let n = pb.get(t);
    if (n) return n;
    let o = MU(e);
    BU(o, t);
    let r = {
        element: t,
        values: null,
        pending: null,
        signature: wU(null),
        disposed: !1,
        root: IU(t),
        firstReady: null,
        defaultsHeld: !0,
        effects: [],
        set (i, a) {
            if (r.disposed) return;
            let c = a && a.size ? a : null, l = wU(i), f = l === null ? null : c ? l + "\0" + [
                ...c
            ].sort().join("\0") : l;
            r.values = i, r.pending = c, r.root && !c && l !== null && (r.firstReady === null ? r.firstReady = l : l !== r.firstReady && (r.defaultsHeld = !1)), !(f !== null && f === r.signature) && (r.signature = f, rC(o));
        },
        dispose () {
            if (r.disposed) return;
            r.disposed = !0;
            let i = o.layers.indexOf(r);
            if (i !== -1 && o.layers.splice(i, 1), !oQ(r.values)) try {
                rC(o);
            } catch (a) {
                console.warn("[helmet] could not re-render the head after an element left:", a && a.message || a);
            }
        }
    }, s = o.layers.length;
    for(let i = 0; i < o.layers.length; i++)if (nQ(t, o.layers[i].element)) {
        s = i;
        break;
    }
    return o.layers.splice(s, 0, r), pb.set(t, r), r;
}, nC = (t, e, n, o)=>{
    let r = rQ(t, e), s = q(()=>{
        let a = new Set, c = n(a);
        r.set(c, a), o && o(c);
    });
    r.effects.push({
        effect: s,
        onResolved: o
    });
    let i = t.__ref?.__effects;
    i && i.push(s, r);
}, oC = new WeakMap, sQ = (t, e, n)=>Cr(yl(t, e, e.state, n ? {
        pending: n,
        authored: !0
    } : Ap), e.context?.files), iQ = (t, e)=>{
    let n = t.__ref?.__effects, o = [];
    for (let { effect: s, onResolved: i } of e.effects){
        s.dispose(), i && o.push(i);
        let a = n ? n.indexOf(s) : -1;
        a !== -1 && n.splice(a, 1);
    }
    e.effects.length = 0;
    let r = q(()=>{
        let s = new Set, i = ub(t, s);
        e.set(i, s);
        for (let a of o)a(i);
    });
    e.effects.push({
        effect: r,
        onResolved: null
    }), n && n.push(r);
}, aQ = cr(An.title), cQ = cr(An.description), lQ = cr(An["og:title"]), fQ = cr(An["og:description"]), uQ = cr(An["twitter:title"]), dQ = cr(An["twitter:description"]), xU = (t, e, n, o)=>{
    let r = t.get(e);
    if (!r || !r.value) return;
    let s = t.get(n);
    (!s || !s.value || s.rank < r.rank) && t.set(n, r);
    let i = t.get(o);
    (!i || !i.value) && t.set(o, r);
}, fb = {
    jsonLd: EU,
    styles: AU,
    alternate: RU,
    favicons: DU,
    icon: LU,
    "theme-color": PU
}, pQ = Object.keys(fb).filter((t)=>t !== "icon"), hQ = (t)=>{
    let e = new Map, n = {}, o = [];
    for(let r = 0; r < t.length; r++){
        let s = t[r].values;
        if (!k(s)) continue;
        let i = t[r].pending;
        for(let c in s){
            let l = s[c];
            l == null || !TU(c) || c === "theme-color" && Array.isArray(l) || e.set(cr(An[c]), {
                value: String(l),
                rank: r,
                waiting: !!(i && i.has(c))
            });
        }
        for (let c of pQ)Array.isArray(s[c]) && (n[c] = s[c]);
        let a = s.icon || s.favicon;
        a && (n.icon = a), Array.isArray(s.scripts) && o.push(...s.scripts);
    }
    return xU(e, aQ, lQ, uQ), xU(e, cQ, fQ, dQ), {
        tags: e,
        lists: n,
        scripts: o
    };
}, gQ = "data-smbls-host", FU = (t)=>!!t && typeof t.getAttribute == "function" && t.getAttribute(gQ) === "forced", mQ = /(^|[\s,])(noindex|none)($|[\s,])/i, $U = (t, e, n)=>!FU(t) || e.key === "robots" && mQ.test(String(n)), yQ = (t, e, n)=>{
    let { doc: o, originals: r } = t, s = db.get(e), i = Cp(o, e), a = r.get(e);
    if (a || (a = {
        value: i ? vp(i, s) : null,
        rendered: !1
    }, r.set(e, a)), a.value === n && (a.rendered = !0), i || (i = sC(s, o)), !!i) {
        if (!$U(i, s, n)) {
            a.value !== null && vp(i, s) !== a.value && Op(i, s, a.value), t.owned.add(e);
            return;
        }
        vp(i, s) !== n && Op(i, s, n), t.owned.add(e);
    }
}, _Q = (t, e)=>{
    let { doc: n } = t;
    t.owned.delete(e);
    let o = db.get(e), r = Cp(n, e), s = t.originals.get(e);
    if (FU(r)) {
        s && s.value !== null && vp(r, o) !== s.value && Op(r, o, s.value);
        return;
    }
    if (s && s.value !== null && !s.rendered && gb(n) === t.servedPath) {
        let a = r || sC(o, n);
        a && vp(a, o) !== s.value && Op(a, o, s.value);
    } else r && r.remove();
}, bQ = (t, e)=>{
    let n = vU(e);
    if (!n.length) return;
    let o = hb(t), r = new Set;
    for (let s of o.querySelectorAll("[data-smbls-script]"))r.add(s.getAttribute("data-smbls-script"));
    for (let s of n){
        let i = OU(s);
        if (r.has(i)) continue;
        let a = CU(t, s);
        a.setAttribute("data-smbls-script", i), o.appendChild(a), r.add(i);
    }
}, SQ = (t, e, n)=>{
    let o = t.layers[n];
    return !t.built || !o || !o.root || !o.defaultsHeld || t.owned.has(e) || gb(t.doc) !== t.servedPath ? !1 : !!Cp(t.doc, e);
}, rC = (t)=>{
    let { doc: e } = t;
    if (t.firstPage === "held" || !hb(e)) return;
    let { tags: n, lists: o, scripts: r } = hQ(t.layers);
    for (let s of [
        ...t.owned
    ])n.has(s) || _Q(t, s);
    for (let [s, { value: i, rank: a, waiting: c }] of n)c || SQ(t, s, a) || yQ(t, s, i);
    for(let s in fb)o[s] !== void 0 ? (fb[s](e, o[s]), t.lists.add(s)) : t.lists.delete(s) && fb[s](e, null);
    bQ(e, r);
}, wQ = (t)=>{
    let e = [
        '<meta charset="UTF-8">'
    ], n = new Set([
        "charset",
        "jsonLd",
        "styles",
        "scripts"
    ]), o = !1;
    for (let [r, s] of Object.entries(t)){
        if (!s && s !== 0 && s !== !1 || n.has(r) || typeof s == "function") continue;
        if (r === "title") {
            e.push(`<title>${H(s)}</title>`);
            continue;
        }
        if (r === "viewport") {
            o || (e.push(`<meta name="viewport" content="${H(s)}">`), o = !0);
            continue;
        }
        if (r === "canonical") {
            e.push(`<link rel="canonical" href="${H(s)}">`);
            continue;
        }
        if (r === "icon" || r === "favicon") {
            let f = H(s), u = f.endsWith(".svg") ? ' type="image/svg+xml"' : f.endsWith(".png") ? ' type="image/png"' : "";
            e.push(`<link rel="icon" href="${f}"${u} data-smbls-single-icon="${f}">`);
            continue;
        }
        if (r === "favicons" && Array.isArray(s)) {
            s.forEach((f)=>{
                if (k(f)) {
                    let u = Object.entries(f).map(([d, p])=>`${d}="${H(p)}"`).join(" ");
                    e.push(`<link rel="icon" ${u} data-smbls-favicon="${H(Or(f))}">`);
                } else typeof f == "string" && e.push(`<link rel="icon" href="${H(f)}" data-smbls-favicon="${H(Or(f))}">`);
            });
            continue;
        }
        if (r === "alternate" && Array.isArray(s)) {
            s.forEach((f)=>{
                if (k(f)) {
                    let u = Object.entries(f).map(([d, p])=>`${d}="${H(p)}"`).join(" ");
                    e.push(`<link rel="alternate" ${u} data-smbls-alternate="${H(Zs(f))}">`);
                }
            });
            continue;
        }
        if (r === "theme-color" && Array.isArray(s)) {
            s.forEach((f)=>{
                if (!k(f)) return;
                let u = [
                    'name="theme-color"'
                ];
                f.content !== void 0 && u.push(`content="${H(f.content)}"`), f.media !== void 0 && u.push(`media="${H(f.media)}"`), u.push(`data-smbls-theme-color="${H(Qs(f))}"`), e.push(`<meta ${u.join(" ")}>`);
            });
            continue;
        }
        let i = [
            "og:",
            "article:",
            "product:",
            "fb:",
            "profile:",
            "book:",
            "business:",
            "music:",
            "video:"
        ], a = [
            "twitter:",
            "DC:",
            "DCTERMS:"
        ], c = i.some((f)=>r.startsWith(f)), l = a.some((f)=>r.startsWith(f));
        if (r.startsWith("http-equiv:")) {
            let f = r.replace("http-equiv:", "");
            e.push(`<meta http-equiv="${H(f)}" content="${H(s)}">`);
        } else if (r.startsWith("itemprop:")) {
            let f = r.replace("itemprop:", "");
            e.push(`<meta itemprop="${H(f)}" content="${H(s)}">`);
        } else c ? Array.isArray(s) ? s.forEach((f)=>e.push(`<meta property="${H(r)}" content="${H(f)}">`)) : e.push(`<meta property="${H(r)}" content="${H(s)}">`) : l ? e.push(`<meta name="${H(r)}" content="${H(s)}">`) : Array.isArray(s) ? s.forEach((f)=>e.push(`<meta name="${H(r)}" content="${H(f)}">`)) : (typeof s == "string" || typeof s == "number" || typeof s == "boolean") && e.push(`<meta name="${H(r)}" content="${H(s)}">`);
    }
    return o || e.splice(1, 0, '<meta name="viewport" content="width=device-width, initial-scale=1">'), e.push(...Ka(t)), e.join(`
`);
}, jU = {
    define: {
        metadata: (t, e)=>{
            mb(t, e, (n)=>{
                let o = e.state?.root;
                k(o) && (o.$helmet = n);
            });
        }
    }
}, mb = (t, e, n)=>{
    let o = lb(e);
    o && nC(e, o, (r)=>kU(t, e, r), n);
}, ub = (t, e)=>{
    if (oC.has(t)) {
        let s = oC.get(t);
        return s ? sQ(s, t, e) : null;
    }
    let { value: n, ready: o } = cb(e, ()=>t.metadata);
    if (!n) return null;
    let r = kU(n, t, e);
    if (!o && e && k(r)) for(let s in r)e.add(s);
    return r;
}, yb = {
    name: "helmet",
    create (t) {
        let e = IU(t);
        if (!t.metadata && !e) return;
        let n = lb(t);
        n && (e && eQ(t, n), t.metadata && nC(t, n, (o)=>ub(t, o)));
    },
    routeChanged (t) {
        let e = lb(t), n = e && eC.get(e);
        n && NU(n);
    },
    update (t) {
        let e = pb.get(t);
        if (!e) return yb.create(t);
        if (!e.disposed) {
            let n = new Set;
            e.set(ub(t, n), n);
        }
    },
    routeHead (t, e) {
        if (!t || !t.__ref) return;
        let n = lb(t);
        if (!n) return;
        oC.set(t, e === void 0 ? null : e);
        let o = pb.get(t);
        if (!o) {
            e && nC(t, n, (r)=>ub(t, r));
            return;
        }
        o.disposed || iQ(t, o);
    }
}, xQ = jU;
var UU = (t, e, n, o)=>{
    if (!t || !o?.fetch) return;
    let r = oa("fetch");
    if (r) {
        r.executeFetch(t, e, n, o);
        return;
    }
    qt("fetch").then((s)=>{
        s && s.executeFetch(t, e, n, o);
    });
}, HU = (t, e)=>{
    t && mb(t, e);
}, VU = async (t, e)=>{
    if (!t) return;
    let n = {
        tag: "fragment",
        ...t
    }, o = async ()=>{
        await e.set(n, {
            preventDefineUpdate: "$router"
        });
    };
    return e.lazyLoad ? window.requestAnimationFrame(o) : await o(), n;
}, ia = {
    routes: (t)=>t,
    metadata: HU,
    fetch: UU,
    $router: VU
}, zU = (t = {})=>{
    let e = {
        routes: (n)=>n
    };
    return t.metadata !== !1 && (e.metadata = HU), t.fetch !== !1 && (e.fetch = UU), t.router !== !1 && (e.$router = VU), e;
};
var aC = {
    useReset: !0,
    useVariable: !0,
    useIconSprite: !0,
    useSvgSprite: !0,
    useDocumentTheme: !0,
    useDefaultIcons: !0,
    useFontImport: !0,
    useDefaultConfig: !0
}, bb = {
    initRouter: !0,
    popState: !0,
    injectRouterInLinkComponent: !0
}, cC = {
    ...aC,
    router: bb
}, _b = {
    state: {},
    pages: {},
    components: {},
    router: bb,
    define: ia
}, WU = (t)=>{
    let e = {
        ..._b,
        ...t
    };
    for (let n of Object.keys(_b)){
        let o = _b[n];
        e[n] === o && o && typeof o == "object" && (e[n] = {
            ...o
        });
    }
    return e;
}, _l = _b;
var KU = (t, e)=>z(t.extends) ? t.extends : [];
var GU = (t, e)=>{
    let n = e || (typeof globalThis < "u" ? globalThis : null);
    if (!n || !Array.isArray(t)) return null;
    let o = n.__SMBLS_PKGS__ || (n.__SMBLS_PKGS__ = {});
    for (let [r, s] of Ks(t, Wa))o[r] || (o[r] = s);
    return o;
};
var lC = /*@__PURE__*/ F({}, {
    apiUrl: ()=>Sb,
    channelByApiUrl: ()=>ZU,
    channelNames: ()=>TQ,
    channels: ()=>Ne,
    currentChannel: ()=>ls,
    defaultChannel: ()=>PQ,
    deployTarget: ()=>RQ,
    isKnownChannel: ()=>LQ,
    mermaidUrl: ()=>CQ,
    normalizeOwnerSegment: ()=>IQ,
    normalizeProjectKey: ()=>BQ,
    normalizeProjectSlug: ()=>MQ,
    parseSymboLsHost: ()=>NQ,
    previewProjectUrl: ()=>OQ,
    previewUrl: ()=>QU,
    resolveChannel: ()=>ca,
    screenshotCdnHost: ()=>JU,
    screenshotCdnUrl: ()=>DQ,
    setChannel: ()=>EQ,
    shellUrl: ()=>vQ,
    socketUrl: ()=>AQ
});
var Ne = {
    channels: {
        local: {
            api: "http://localhost:8080",
            socket: "http://localhost:8080",
            shell: "http://my.localhost:1355",
            preview: "http://preview.localhost:1355",
            mermaidApex: "localhost:1355",
            deploy: {}
        },
        development: {
            api: "https://dev.api.symbols.app",
            socket: "https://dev.api.symbols.app",
            shell: "https://dev.my.symbols.app",
            preview: "https://dev.preview.symbols.app",
            mermaidApex: "dev.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-dev",
                previewWorker: "smbls-preview-dev",
                mermaidWorker: "mermaid-dev"
            }
        },
        "demo-dev": {
            api: "https://dev.api.symbols.app",
            socket: "https://dev.api.symbols.app",
            shell: "https://dev.demo.symbols.app",
            preview: "https://dev.preview.symbols.app",
            mermaidApex: "dev.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-demo-dev",
                previewWorker: "smbls-preview-dev",
                mermaidWorker: "mermaid-dev"
            }
        },
        next: {
            api: "https://next.api.symbols.app",
            socket: "https://next.api.symbols.app",
            shell: "https://next.my.symbols.app",
            preview: "https://next.preview.symbols.app",
            mermaidApex: "next.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-next",
                previewWorker: "smbls-preview-next",
                mermaidWorker: "mermaid-next"
            }
        },
        test: {
            api: "https://test.api.symbols.app",
            socket: "https://test.api.symbols.app",
            shell: "https://test.my.symbols.app",
            preview: "https://test.preview.symbols.app",
            mermaidApex: "test.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-test",
                previewWorker: "smbls-preview-test",
                mermaidWorker: "mermaid-test"
            }
        },
        upcoming: {
            api: "https://upcoming.api.symbols.app",
            socket: "https://upcoming.api.symbols.app",
            shell: "https://upcoming.my.symbols.app",
            preview: "https://upcoming.preview.symbols.app",
            mermaidApex: "upcoming.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-upcoming",
                previewWorker: "smbls-preview-upcoming",
                mermaidWorker: "mermaid-upcoming"
            }
        },
        staging: {
            api: "https://staging.api.symbols.app",
            socket: "https://staging.api.symbols.app",
            shell: "https://staging.my.symbols.app",
            preview: "https://staging.preview.symbols.app",
            mermaidApex: "staging.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-staging",
                previewWorker: "smbls-preview-staging",
                mermaidWorker: "mermaid-staging"
            }
        },
        demo: {
            api: "https://api.symbols.app",
            socket: "https://api.symbols.app",
            shell: "https://demo.symbols.app",
            preview: "https://preview.symbols.app",
            mermaidApex: "at.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-demo",
                previewWorker: "smbls-preview",
                mermaidWorker: "mermaid"
            }
        },
        production: {
            api: "https://api.symbols.app",
            socket: "https://api.symbols.app",
            shell: "https://my.symbols.app",
            preview: "https://preview.symbols.app",
            mermaidApex: "at.symbo.ls",
            deploy: {
                shellBucket: "smbls-my-prod",
                previewWorker: "smbls-preview",
                mermaidWorker: "mermaid"
            }
        }
    },
    defaultChannel: "production",
    screenshotCdn: "screenshots.api.symbols.app"
};
var TQ = Object.keys(Ne.channels), Qn = (t)=>!!(t && Ne.channels[t]), ca = (t)=>Qn(t) ? Ne.channels[t] : Ne.channels[Ne.defaultChannel], EQ = (t)=>{
    typeof globalThis > "u" || (globalThis.__SYMBOLS_CHANNEL__ = Qn(t) ? t : null, bl = void 0);
}, bl, aa = (t)=>null, ls = ()=>{
    if (bl !== void 0) return bl;
    let t = typeof globalThis < "u" ? globalThis.__SYMBOLS_CHANNEL__ : null, e = aa("SYMBOLS_CHANNEL"), n = aa("NODE_ENV"), o = aa("SYMBOLS_API_URL") || aa("SYMBOLS_API_BASE_URL"), r = o ? ZU(String(o).trim().replace(/\/+$/, "")) : null;
    return bl = Qn(t) && t || Qn(e) && e || Qn(r) && r || Qn(n) && n || Ne.defaultChannel, bl === Ne.defaultChannel && !Qn(t) && !Qn(e) && !Qn(r) && Qn(n), bl;
}, qU = [
    "production",
    "staging",
    "upcoming",
    "next",
    "test",
    "development",
    "local",
    "demo",
    "demo-dev"
], YU = (t)=>{
    let e = qU.indexOf(t);
    return e === -1 ? qU.length : e;
}, ZU = (t)=>{
    if (!t) return null;
    let e = Object.keys(Ne.channels).filter((n)=>Ne.channels[n].api === t);
    return e.length === 0 ? null : e.length === 1 ? e[0] : e.sort((n, o)=>YU(n) - YU(o))[0];
}, Sb = (t = ls())=>aa("SYMBOLS_API_URL") || ca(t).api, AQ = (t = ls())=>aa("SYMBOLS_SOCKET_URL") || ca(t).socket, vQ = (t = ls())=>ca(t).shell || null, QU = (t = ls())=>ca(t).preview || null, OQ = ({ owner: t, key: e, env: n = "production" } = {}, o = ls())=>{
    let r = QU(o);
    if (!r || !t || !e) return null;
    let s = r.match(/^(https?:\/\/)(.+)$/);
    if (!s) return null;
    let [, i, a] = s, c = `${encodeURIComponent(t)}--${encodeURIComponent(e)}`, l = `${i}${c}.${a}/`;
    return !n || n === "production" || n === "prod" ? l : `${l}?env=${encodeURIComponent(n)}`;
}, CQ = ({ owner: t, key: e, env: n = "production" } = {}, o = ls())=>{
    let r = ca(o).mermaidApex;
    if (!r || !t || !e) return null;
    let i = !n || n === "production" || n === "prod" ? "" : `--${encodeURIComponent(n)}`, a = `${encodeURIComponent(t)}--${encodeURIComponent(e)}${i}`;
    return `${r.startsWith("localhost") ? "http" : "https"}://${a}.${r}`;
}, RQ = (t = ls())=>ca(t).deploy || {}, JU = ()=>aa("SYMBOLS_SCREENSHOT_CDN") || Ne.screenshotCdn, DQ = ({ owner: t, key: e, page: n = "root", componentKey: o, env: r = "production", width: s } = {})=>{
    if (!t || !e) return null;
    let i = o ? `component/${encodeURIComponent(o)}` : encodeURIComponent(String(n || "root").replace(/^\/+/, "").replace(/\//g, "-") || "root"), a = [];
    r && r !== "production" && a.push(`env=${encodeURIComponent(r)}`), s && a.push(`w=${Number(s)}`);
    let c = a.length ? `?${a.join("&")}` : "";
    return `https://${JU()}/${encodeURIComponent(t)}/${encodeURIComponent(e)}/${i}.webp${c}`;
}, LQ = Qn, PQ = Ne.defaultChannel, IQ = (t)=>t == null || typeof t != "string" ? "" : String(t).toLowerCase().trim().replace(/[^a-z0-9-]+/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "").slice(0, 32) || "", MQ = (t)=>t == null || typeof t != "string" ? "" : String(t).toLowerCase().trim().replace(/[^a-z0-9-]+/g, "-").replace(/-+/g, "-").replace(/^-+|-+$/g, "").slice(0, 48) || "", BQ = (t, e = {})=>{
    let n = String(t || "").trim();
    if (!n) return "";
    /\.symbo\.ls$/iu.test(n) && (n = n.replace(/\.symbo\.ls$/iu, "")), n.includes("/") && (n = n.split("/").pop());
    let o = typeof e.owner == "string" ? e.owner.trim() : "";
    return o && n.startsWith(`${o}--`) ? n = n.slice(o.length + 2) : !o && n.includes("--") && (n = n.slice(n.indexOf("--") + 2)), n;
}, XU = {
    at: "production",
    prod: "production",
    production: "production",
    dev: "development",
    development: "development",
    next: "next",
    upcoming: "upcoming",
    test: "test",
    staging: "staging"
}, NQ = (t)=>{
    if (typeof t != "string" || !t) return null;
    let e = t.toLowerCase().replace(/^www\./, "").replace(/\/$/, "");
    if (!e.endsWith(".symbo.ls")) return null;
    let n = e.split(".");
    if (n.length < 4 || n.slice(-2).join(".") !== "symbo.ls") return null;
    if (n.length === 4) {
        let s = n[1], i = n[0], a = XU[s];
        if (a && i.includes("--")) {
            let c = i.split("--");
            if (c.length === 2 || c.length === 3) {
                let [l, f, u] = c;
                if (l && f) {
                    let d = u ? XU[u] || u : null;
                    return {
                        projectKey: f,
                        owner: l,
                        env: d || a,
                        sysEnv: a
                    };
                }
            }
        }
    }
    if (n.length >= 5) return {
        projectKey: n[1],
        owner: n[2],
        env: n[0]
    };
    let o = n[1], r = n[0];
    if (r.includes("--")) {
        let [s, i] = r.split("--", 2);
        return !s || !i ? null : {
            projectKey: s,
            owner: o,
            env: i
        };
    }
    return {
        projectKey: r,
        owner: o,
        env: "production"
    };
};
var eH = (t)=>{
    let e = {
        faces: 0,
        links: 0,
        kept: 0
    };
    if (!t) return e;
    let n = UQ(fo());
    for(let o in t){
        let r = t[o];
        if (!r || !r.fontFace) continue;
        let s = Array.isArray(r.fontFace) ? r.fontFace : [
            r.fontFace
        ];
        for (let i of s){
            if (nH(i)) {
                let a = $Q(i);
                a && jQ(a) && e.links++;
                continue;
            }
            if (FQ(i)) {
                if (!tH(i)) continue;
                if (n.has(fC(i))) {
                    e.kept++;
                    continue;
                }
                Lt(i.trim()), e.faces++;
                continue;
            }
            if (typeof i == "string" && i.includes("font-family")) {
                if (!tH(i)) continue;
                if (n.has(fC(i))) {
                    e.kept++;
                    continue;
                }
                Lt(`@font-face { ${i} }`), e.faces++;
            }
        }
    }
    return e;
}, nH = (t)=>typeof t == "string" && t.trim().startsWith("@import"), FQ = (t)=>typeof t == "string" && t.trim().startsWith("@font-face"), $Q = (t)=>{
    if (!nH(t)) return null;
    let e = String(t).match(/url\(\s*['"]?([^'")]+)['"]?\s*\)/);
    return e ? e[1].trim() : null;
}, jQ = (t, e)=>{
    if (typeof t != "string" || !t) return null;
    let n = e || fo();
    if (!n || !n.head) return null;
    let o = "data-smbls-font", r = n.head.querySelectorAll(`link[rel="stylesheet"][${o}]`);
    for(let i = 0; i < r.length; i++)if (r[i].getAttribute(o) === t) return r[i];
    let s = n.createElement("link");
    return s.setAttribute("rel", "stylesheet"), s.setAttribute("href", t), s.setAttribute(o, t), n.head.appendChild(s), s;
}, wb = (t, e)=>{
    let n = new RegExp(`(?:^|[;{\\s])${e}\\s*:\\s*([^;}]+)`, "i").exec(t);
    return n ? n[1].trim().toLowerCase() : null;
}, fC = (t)=>{
    let e = String(t || ""), n = wb(e, "font-family");
    if (!n) return null;
    let o = wb(e, "font-weight") || "400";
    return o === "normal" ? o = "400" : o === "bold" && (o = "700"), n.replace(/^['"]|['"]$/g, "") + "|" + o + "|" + (wb(e, "font-style") || "normal");
}, tH = (t)=>{
    let e = wb(String(t || ""), "src");
    return !!e && e !== "none";
}, uC = (t)=>{
    if (!t) return null;
    let e = t.type;
    if (e === 5) return t.cssText || "";
    if (typeof e == "number") return null;
    let n = t.cssText || "";
    return /^\s*@font-face/i.test(n) ? n : null;
}, UQ = (t)=>{
    let e = new Set, n = t && t.styleSheets;
    if (!n) return e;
    for(let o = 0; o < n.length; o++){
        let r;
        try {
            r = n[o].cssRules;
        } catch  {
            continue;
        }
        if (r) for(let s = 0; s < r.length; s++){
            let i = uC(r[s]);
            if (i === null) continue;
            let a = fC(i);
            a && e.add(a);
        }
    }
    return e;
};
var pC = 'meta[name="brender"]', aH = ()=>oa("visitorInput") || qt("visitorInput"), cH = (t, e)=>{
    if (!hC(t, e)) return;
    let n = xb(t), o = n && typeof n.querySelector == "function" ? n.querySelector(pC) : null, r = o && typeof o.getAttribute == "function" ? o.getAttribute("content") : null;
    (t.hydrate === !1 || r === "replace") && qt("visitorInput");
}, HQ = 3e3, xb = (t)=>t.document || (typeof document < "u" ? document : null), lH = (t, e)=>{
    let n = t.parent;
    return n && n.nodeType === 1 ? n : n && n.node && n.node.nodeType === 1 ? n.node : e ? e.body : null;
}, hC = (t, e)=>{
    if (e && e.__BRENDER__) return !0;
    let n = xb(t);
    if (!n || typeof n.querySelector != "function") return !1;
    let o = n.documentElement;
    if (o && typeof o.hasAttribute == "function" && o.hasAttribute("data-brender") || n.querySelector(pC)) return !0;
    let r = lH(t, n);
    for(let s = r && r.firstElementChild; s; s = s.nextElementSibling)if (s.hasAttribute("data-br")) return !0;
    return !1;
}, fH = (t)=>{
    let e = xb(t);
    return !e || !e.head ? null : Array.from(e.head.querySelectorAll('style[data-emotion="smbls"], style[data-brender]'));
}, gC = (t, e)=>{
    if (!e || !e.length) return;
    let n = [];
    for (let r of e){
        let s = null;
        try {
            s = r.sheet && r.sheet.cssRules;
        } catch  {
            s = null;
        }
        if (s && s.length) for(let i = 0; i < s.length; i++){
            let a = uC(s[i]);
            a !== null && n.push(a);
        }
        else {
            let i = String(r.textContent || "").match(/@font-face\s*\{[^}]*\}/gi);
            i && n.push(...i);
        }
    }
    let o = e.find((r)=>r.parentNode);
    if (n.length && o && t && typeof t.createElement == "function") {
        let r = t.createElement("style");
        r.setAttribute("data-smbls-faces", ""), r.textContent = n.join(`
`), o.parentNode.insertBefore(r, o);
    }
    e.forEach((r)=>{
        r.parentNode && r.remove();
    });
}, oH = (t)=>{
    console.warn("[smbls] the pre-render registry is not JSON \u2014 the page renders fresh:", t.message);
}, mC = [
    "paths",
    "tree"
], VQ = (t, e)=>{
    let n = io(e, su, {
        warn: oH
    });
    if (n) return {
        map: iu(n.value),
        block: n.block
    };
    let o = io(e, ru, {
        warn: oH
    });
    return o ? {
        map: k(o.value) ? o.value : null,
        block: o.block
    } : t && k(t.__BR_REGISTRY__) ? {
        map: t.__BR_REGISTRY__,
        legacy: !0
    } : null;
}, zQ = (t, e, n)=>!n || !n.map || t.hydrate === !1 ? !1 : n.legacy ? t.hydrate === !0 || k(t.hydrate) || !!e && e.__BRENDER_HYDRATE__ === !0 : !0, WQ = (t)=>{
    let e = k(t.hydrate) ? t.hydrate.timeout : void 0;
    return typeof e == "number" && e >= 0 ? e : HQ;
}, yC = (t, e, n)=>{
    if (t && (delete t.__BRENDER__, delete t.__BR_REGISTRY__, delete t.__BRENDER_HYDRATE__), n && n.block && n.block.parentNode && n.block.remove(), e && typeof e.querySelector == "function") {
        let o = e.querySelector(pC);
        o && o.remove();
        let r = e.documentElement;
        r && typeof r.hasAttribute == "function" && r.hasAttribute("data-brender") && r.removeAttribute("data-brender");
    }
}, KQ = ()=>new Promise((t)=>{
        if (typeof MessageChannel == "function") {
            let e = new MessageChannel;
            e.port1.onmessage = ()=>{
                e.port1.close(), t();
            }, e.port2.postMessage(null);
        } else setTimeout(t, 0);
    }), uH = async (t, e)=>{
    let n = t.__firstNavigation;
    if (n && typeof n.then == "function") try {
        await n;
    } catch  {}
    for(let o = 0; o < 20 && e.pending.size; o++){
        let r = oa("fetch"), s = r && typeof r.whenRequestsIdle == "function" ? r.whenRequestsIdle : null;
        if (s && await s(), await KQ(), !s || !(r.requestsInFlight() > 0)) return;
    }
}, GQ = [
    "click",
    "keydown"
], dH = (t, e, n, o, r, s)=>{
    let i = !1, a = null, c = ()=>f(), l = (u)=>{
        let d = u ? "addEventListener" : "removeEventListener";
        if (n && typeof n[d] == "function") for (let p of GQ)n[d](p, c, !0);
        e && typeof e[d] == "function" && e[d]("popstate", c);
    }, f = ()=>{
        if (i) return;
        i = !0, a !== null && clearTimeout(a), l(!1), t.__hydration === o && delete t.__hydration;
        let u = 0;
        for (let d of o.pending)d.parentNode && (d.remove(), u++);
        o.pending.clear(), o.pendingIn.clear(), o.whole = null, Xr(o), gC(n, s), e && (e.__BRENDER_HYDRATION__ = {
            adopted: o.adopted,
            misses: o.misses,
            removed: u
        }), yC(e, n, r), _C(t, e, o.root, !0);
    };
    if (!o.pending.size) return f();
    a = setTimeout(f, WQ(t)), l(!0), uH(t, o).then(f, f);
}, qQ = 1e3, YQ = (t, e)=>{
    t && typeof t.requestIdleCallback == "function" ? t.requestIdleCallback(e, {
        timeout: qQ
    }) : setTimeout(e, 0);
}, rH = (t, e)=>{
    let n = oa("fetch");
    !n || typeof n.seedIsStale != "function" || !n.seedIsStale() || YQ(t, ()=>{
        n.revalidateSeed(e).then((o)=>{
            o && t && ((t.__BRENDER_HYDRATION__ || (t.__BRENDER_HYDRATION__ = {
                replaced: !0
            })).refreshed = o);
        }, (o)=>console.error("[smbls] refreshing a stale pre-rendered page failed:", o));
    });
}, _C = (t, e, n, o)=>{
    let r = oa("fetch");
    if (!r || typeof r.seedIsStale != "function") return;
    let s = ()=>{
        let i = ()=>rH(e, n);
        uH(t, {
            pending: {
                size: 1
            }
        }).then(i, i);
    };
    if (r.seedIsStale()) return o ? rH(e, n) : s();
    typeof r.whenSeedTaken == "function" && r.whenSeedTaken(s);
}, XQ = (t)=>({
        bubbles: !0,
        cancelable: !0,
        composed: !0,
        detail: t.detail,
        screenX: t.screenX,
        screenY: t.screenY,
        clientX: t.clientX,
        clientY: t.clientY,
        ctrlKey: t.ctrlKey,
        shiftKey: t.shiftKey,
        altKey: t.altKey,
        metaKey: t.metaKey,
        button: t.button,
        buttons: t.buttons
    }), ZQ = (t, e, n, o)=>{
    if (!t || typeof t.addEventListener != "function") return {
        replay () {}
    };
    let r = [], s = (a)=>{
        for(let c = a; c && c !== n; c = c.parentNode)if (o.pending.has(c)) return !0;
        return !1;
    }, i = (a)=>{
        s(a.target) && (a.preventDefault(), a.stopImmediatePropagation(), r.push({
            target: a.target,
            init: XQ(a)
        }));
    };
    return t.addEventListener("click", i, !0), {
        replay () {
            t.removeEventListener("click", i, !0);
            let a = e && e.MouseEvent || (typeof MouseEvent == "function" ? MouseEvent : null);
            if (a) for (let { target: c, init: l } of r)c.isConnected && o.claimed.has(QQ(c, n, o)) && c.dispatchEvent(new a("click", l));
        }
    };
}, QQ = (t, e, n)=>{
    for(let o = t; o && o !== e; o = o.parentNode)if (n.claimed.has(o)) return o;
    return null;
}, JQ = async ()=>{
    for(await ae(); !Qr();)await ae();
}, tJ = async (t, e, n, o, r, s, i, a, c, l, f, u)=>{
    let d = f.mountYield, p = f.mountWhole;
    d === void 0 && (f.mountYield = u.budget), p === void 0 && (f.mountWhole = !0);
    let g = $v(r, {
        budget: u.budget,
        progressive: !0,
        pageOptions: {
            mountYield: f.mountYield,
            mountWhole: f.mountWhole
        }
    }), h = Ri(), m = ZQ(i, s, o, a), y = u.lease || null;
    g.lease = y, y && (r.__mountLease = y);
    let b = null, T = !1;
    try {
        try {
            b = t(e, n, r.key, f);
        } catch (v) {
            console.error("[smbls] hydration failed, rendering fresh:", v), delete r.__hydration, Xr(a);
            for (let S of a.claimed)S.parentNode && S.remove();
            return null;
        }
        T = !await rs(Gn(b), y) || g.routeReady && !await rs(g.routeReady, y) || !await rs(JQ(), y), T && (r.__hydration === a && delete r.__hydration, Xr(a), Nv(b));
    } finally{
        f.mountYield = d, f.mountWhole = p, y && (r.__mountLease = null), jv(r), h(), b || m.replay();
    }
    return T ? (m.replay(), qi(k(e) ? e : {})) : (a.root = b, dH(r, s, i, a, c, l), m.replay(), b);
}, sH = (t, e, n, o, r, s, i, a, c, l, f)=>{
    if (!o || typeof o.querySelectorAll != "function") return null;
    let u = (T)=>{
        for(let v = T; v && v !== o; v = v.parentNode)if (v.parentNode === o && v.localName === "svg" && v.id) return !0;
        return !1;
    }, d = {};
    for (let T of o.querySelectorAll("[data-br]")){
        let v = T.getAttribute("data-br");
        u(T) ? T.removeAttribute("data-br") : d[v] = T;
    }
    let p = {}, g = new Set, h = new Map, m = a.map;
    for(let T in m){
        let v = m[T], S = d[v];
        if (!S || p[v]) continue;
        p[v] = S, g.add(S);
        let w = S.parentNode;
        w && h.set(w, (h.get(w) || 0) + 1);
    }
    for(let T in d)p[T] || d[T].removeAttribute("data-br");
    let y = {
        registry: m,
        nodes: p,
        claimed: new Set,
        pending: g,
        pendingIn: h,
        adopted: 0,
        misses: 0
    };
    if (r.__hydration = y, f) return tJ(t, e, n, o, r, s, i, y, a, c, l, f);
    let b;
    try {
        b = t(e, n, r.key, l);
    } catch (T) {
        console.error("[smbls] hydration failed, rendering fresh:", T), delete r.__hydration, Xr(y);
        for (let v of y.claimed)v.parentNode && v.remove();
        return null;
    }
    return y.root = b, dH(r, s, i, y, a, c), b;
}, eJ = (t)=>t.nodeType === 1 || t.nodeType === 3 && /\S/.test(t.nodeValue || ""), bC = (t)=>{
    let e = [];
    if (!t) return e;
    for (let n of t.childNodes){
        if (n.nodeType === 1) {
            let o = n.localName;
            if (o === "script" || o === "link" || o === "style" || o === "svg" && n.id) continue;
        }
        e.push(n);
    }
    return e;
}, pH = (t, e)=>{
    let n = vy(e);
    return t.__replacing = n, ()=>{
        t.__replacing === n && delete t.__replacing;
    };
}, hH = (t)=>{
    t && typeof t.querySelectorAll == "function" && t.querySelectorAll("[data-br]").forEach((e)=>e.removeAttribute("data-br"));
}, iH = (t, e, n, o, r, s, i, a, c, l, f = null)=>{
    if (f) return nJ(e, n, o, r, s, i, a, c, l, f);
    let u = aH();
    return u && typeof u.then == "function" ? bC(o).some(eJ) ? u.then((d)=>dC(d, t, e, n, o, r, s, i, a, c, l)) : dC(null, t, e, n, o, r, s, i, a, c, l) : dC(u, t, e, n, o, r, s, i, a, c, l);
}, dC = (t, e, n, o, r, s, i, a, c, l, f)=>{
    let u = bC(r), d = t ? t.readVisitorInput(u, a, t.watchVisitorScroll(u, a, i, {
        now: !0
    })) : null, p = pH(s, u);
    gC(a, l), u.forEach((h)=>h.remove()), hH(a), i && (i.__BRENDER_HYDRATION__ = {
        replaced: !0
    });
    let g;
    try {
        g = e(n, o, s.key, f);
    } catch (h) {
        throw p(), h;
    }
    return Promise.resolve(g).then((h)=>Gn(h)).then(()=>ae()).then(p, p), yC(i, a, c), d && Promise.resolve(g).then((h)=>Gn(h)).then(()=>ae()).then(()=>t.settleVisitorInput(t.restoreVisitorInput(d, r, a), a), ()=>{}), Promise.resolve(g).then((h)=>_C(s, i, h, !1), ()=>{}), g;
}, nJ = async (t, e, n, o, r, s, i, a, c, l)=>{
    let f = await aH(), u = bC(n), d = f ? f.watchVisitorScroll(u, s, r) : null;
    hH(s), yC(r, s, i), r && (r.__BRENDER_HYDRATION__ = {
        replaced: !0
    });
    let p = pH(o, u), g = null, h = null, m = ()=>{
        p(), g = f ? f.readVisitorInput(u, s, d) : null, gC(s, a), u.forEach((T)=>{
            T.parentNode && T.remove();
        });
    }, y = ()=>{
        h = f ? f.restoreVisitorInput(g, n, s) : null;
    }, b;
    try {
        b = await S_(t, e, o, c, {
            ...l,
            progressive: !1,
            beforeAttach: m,
            afterAttach: y
        });
    } finally{
        p(), d && d.stop();
    }
    return b ? (f && f.settleVisitorInput(h, s), _C(o, r, b, !1), b) : qi(k(t) ? t : {});
}, gH = (t, e, n, o, r, s, i, a = null)=>{
    let c = xb(o), l = n && n.nodeType ? n : n && n.node || lH(o, c), f = VQ(r, c);
    o.prerendered = !0;
    let u = Ps(c);
    u && (o.prerender = u);
    let d = fu(c);
    if (d.length && o.lazyFirstView !== !0) {
        let p = Array.isArray(o.lazyFirstView) ? o.lazyFirstView : [];
        o.lazyFirstView = [
            ...new Set([
                ...p,
                ...d
            ])
        ];
    }
    if (zQ(o, r, f)) {
        if (a) return xo().then(()=>cl(a.lease) ? sH(t, e, n, l, o, r, c, f, s, i, a) : qi(k(e) ? e : {})).then((g)=>g || iH(t, e, n, l, o, r, c, f, s, i));
        let p = sH(t, e, n, l, o, r, c, f, s, i, a);
        if (p) return p;
    }
    return iH(t, e, n, l, o, r, c, f, s, i, a);
};
var SH = (t)=>{
    let e = typeof window < "u" ? window : globalThis || {};
    e.document || (e.document = {
        body: {}
    });
    let n = typeof document < "u" ? document : e.document;
    t.document = t.document || n;
    let o = t.window;
    return o && o !== e && typeof o.URL != "function" ? (typeof console < "u" && console.warn && !globalThis.__smblsRouterUrlWarned && (globalThis.__smblsRouterUrlWarned = !0), t.window = e) : t.window = o || e, t.window;
}, mH = (t = "smbls")=>{
    let e = {};
    for(let n in Ki)Object.prototype.hasOwnProperty.call(Ki, n) && (oo(n) ? e[`smbls.${n}`] = Ki[n] : e[n] = Ki[n]);
    return e;
}, wH = (t)=>t.components ? {
        ...mH(),
        ...t.components
    } : mH(), xH = (t)=>({
        ...dp,
        ...nl,
        ...Ir,
        ...t.utils,
        ...t.snippets,
        ...t.functions
    }), kH = (t)=>({
        ...t.methods || {},
        require: t.utils.require,
        requireOnDemand: t.utils.requireOnDemand,
        router: t.utils.router
    });
var TH = (t)=>typeof globalThis < "u" && globalThis.__SMBLS_PKGS__ && globalThis.__SMBLS_PKGS__[t] || null, oJ = 3e3, rJ = (t, e, n = (o)=>import(o))=>{
    if (typeof globalThis > "u") return Promise.resolve(null);
    try {
        let o = globalThis.__SMBLS_PKGS__ || (globalThis.__SMBLS_PKGS__ = {});
        if (o[t]) return Promise.resolve(o[t]);
        let r = ()=>n(e), s = Promise.resolve().then(r).then((a)=>(a && !o[t] && (o[t] = a), o[t] || null)).catch(()=>null);
        return new Promise((a)=>{
            let c = setTimeout(()=>a(null), oJ);
            s.then((l)=>{
                clearTimeout(c), a(l);
            });
        });
    } catch  {
        return Promise.resolve(null);
    }
}, yH = {}, kC = async ({ dependencies: t, dependenciesOnDemand: e, document: n, preventCaching: o = !1, cdnProvider: r, packageManager: s, symbolsConfig: i, registerDependency: a = rJ })=>{
    if (r || (r = Er[s] || Ua(i) || "esmsh"), !t) return null;
    if (!Hs(t)) return null;
    let c = !1;
    for(let d in t){
        c = !0;
        break;
    }
    if (!c) return null;
    let l = yr() && o ? `?${Math.random()}` : "", f = async (d, p)=>{
        let g = Mn(d, p, r) + l;
        try {
            await Promise.race([
                Ha(g, {
                    document: n,
                    type: "module"
                }),
                new Promise((h, m)=>setTimeout(()=>m(new Error(`Timeout loading ${d}`)), 1e4))
            ]), await a(d, g);
        } catch (h) {
            if (console.error(`Failed to load ${d} from ${r}:`, h), r !== "symbols") try {
                let m = Mn(d, p, "symbols") + l;
                await Promise.race([
                    Ha(m, {
                        document: n,
                        type: "module"
                    }),
                    new Promise((y, b)=>setTimeout(()=>b(new Error(`Timeout fallback ${d}`)), 2e4))
                ]), await a(d, m);
            } catch (m) {
                console.error(`Failed to load ${d} from fallback:`, m);
            }
        }
    }, u = [];
    for(let d in t){
        let p = t[d];
        if (!(e && e[d]) && !yH[d] && (yH[d] = !0, !Ar(d))) {
            if (Us(d)) continue;
            TH(d) || u.push(f(d, p));
        }
    }
    return u.length && await Promise.allSettled(u), t;
}, _H = /\[smbls\] runtime dependency "([^"]+)" is not registered on globalThis\.__SMBLS_PKGS__/g, sJ = (t)=>{
    if (typeof t == "string") return t;
    if (typeof t == "function") try {
        return typeof Ue == "function" ? Ue(t) : Function.prototype.toString.call(t);
    } catch  {
        return "";
    }
    return "";
}, iJ = (t)=>{
    let e = new Set;
    if (!t) return e;
    let n = [
        t.globalScope,
        t.functions,
        t.methods,
        t.snippets
    ];
    for(let o = 0; o < n.length; o++){
        let r = n[o];
        if (!r || typeof r != "object") continue;
        let s = Object.keys(r);
        for(let i = 0; i < s.length; i++){
            let a;
            try {
                a = r[s[i]];
            } catch  {
                continue;
            }
            let c = sJ(a);
            if (!c || c.indexOf("__SMBLS_PKGS__") === -1) continue;
            _H.lastIndex = 0;
            let l;
            for(; (l = _H.exec(c)) !== null;)e.add(l[1]);
        }
    }
    return e;
}, aJ = (t)=>{
    let e = new Set;
    if (!t || typeof t.querySelectorAll != "function") return e;
    let n;
    try {
        n = t.querySelectorAll('script[type="importmap"]');
    } catch  {
        return e;
    }
    for(let o = 0; o < n.length; o++){
        let r;
        try {
            r = JSON.parse(n[o].textContent || "");
        } catch  {
            continue;
        }
        let s = r && typeof r == "object" ? r.imports : null;
        if (s && typeof s == "object") {
            let i = Object.keys(s);
            for(let a = 0; a < i.length; a++)e.add(i[a]);
        }
    }
    return e;
}, cJ = (t, e)=>{
    if (!e || !e.size) return !1;
    if (e.has(t)) return !0;
    for (let n of e)if (n.length > 1 && n.endsWith("/") && t.length > n.length && t.startsWith(n)) return !0;
    return !1;
}, EH = (t, { syncRead: e = iJ(t), runtimeDocument: n = typeof document < "u" ? document : null, importMap: o = aJ(n) } = {})=>{
    let r = t && t.dependencies;
    if (!Hs(r)) return null;
    let s = !t.document || t.document === n, i = t.dependenciesOnDemand, a = null, c = null;
    for(let l in r)s && !(i && i[l]) && !e.has(l) && cJ(l, o) ? (c || (c = {}))[l] = r[l] : (a || (a = {}))[l] = r[l];
    return {
        blocking: a,
        deferred: c
    };
}, lJ = (t)=>import(t), SC = {}, fJ = (t, e)=>{
    if (!e || typeof globalThis > "u") return;
    let n = globalThis.__SMBLS_PKGS__ || (globalThis.__SMBLS_PKGS__ = {});
    n[t] || (n[t] = e);
}, uJ = (t, { importModule: e = lJ } = {})=>{
    let n = [];
    if (!t) return Promise.resolve([]);
    for(let o in t)if (!(Ar(o) || Us(o)) && !TH(o)) {
        if (!SC[o]) {
            let r = ()=>e(o);
            SC[o] = Promise.resolve().then(r).then((s)=>(fJ(o, s), s || null), ()=>null);
        }
        n.push(SC[o]);
    }
    return Promise.all(n);
}, dJ = 2e3, pJ = 3e3, AH = (t, { win: e = typeof window < "u" ? window : null, importModule: n, loadTimeoutMs: o = pJ } = {})=>t ? new Promise((r)=>{
        let s = ()=>{
            uJ(t, {
                importModule: n
            }).then(r, r);
        }, i = ()=>{
            e && typeof e.requestIdleCallback == "function" ? e.requestIdleCallback(s, {
                timeout: dJ
            }) : setTimeout(s, 0);
        }, a = e && e.document;
        if (a && a.readyState && a.readyState !== "complete" && typeof e.addEventListener == "function") {
            let c = !0, l = null, f = ()=>{
                c && (c = !1, clearTimeout(l), typeof e.removeEventListener == "function" && e.removeEventListener("load", f), i());
            };
            e.addEventListener("load", f, {
                once: !0
            }), l = setTimeout(f, o);
        } else i();
    }) : null, vH = async (t, e)=>{
    let n = e.window || window, o = e.cdnProvider || Ua(e.symbolsConfig) || "esmsh", r = async (i)=>async (a, c)=>{
            let f = (i.window || window).packages[a];
            return typeof f == "function" ? f() : f;
        }, s = async (i)=>async (a, c = o)=>{
            let { dependenciesOnDemand: l } = i, f = i.document || document, u = i.window || window;
            if (!u.packages[a] && Ar(a)) return await u.require(a, c);
            if (!u.packages[a]) {
                let d = yr() ? `?${Math.random()}` : "";
                if (l && l[a]) {
                    let p = l[a], g = Mn(a, p, c) + d;
                    try {
                        await i.utils.loadRemoteScript(g, {
                            window: u,
                            document: f
                        });
                    } catch (h) {
                        if (console.error(`Failed to load ${a} from ${c}:`, h), c !== "symbols") {
                            let m = Mn(a, p, "symbols") + d;
                            await i.utils.loadRemoteScript(m, {
                                window: u,
                                document: f
                            });
                        }
                    }
                } else {
                    let p = Mn(a, "latest", c) + d;
                    try {
                        await i.utils.loadRemoteScript(p, {
                            window: u,
                            document: f
                        });
                    } catch (g) {
                        if (console.error(`Failed to load ${a} from ${c}:`, g), c !== "symbols") {
                            let h = Mn(a, "latest", "symbols") + d;
                            await i.utils.loadRemoteScript(h, {
                                window: u,
                                document: f
                            });
                        }
                    }
                    u.packages[a] = "loadedOnDeman";
                }
            }
            return await u.require(a, c);
        };
    n.packages ? n.packages = Dt(n.packages, t) : n.packages = t, n.require || (e.utils.require = await r(e), n.require = e.utils.require), n.requireOnDemand || (e.utils.requireOnDemand = await s(e), n.requireOnDemand = e.utils.requireOnDemand);
}, hJ = /\s+/g, OH = (t, e)=>typeof t == "function" ? t(e, e?.state, e?.context) : t, gJ = (t, e)=>{
    let n = "";
    for(let o in t){
        let r = t[o];
        typeof r == "boolean" && r ? n += ` ${o}` : typeof r == "string" ? n += ` ${r}` : typeof r == "function" && (n += ` ${OH(r, e)}`);
    }
    return n;
}, mJ = (t, e, n)=>{
    if (!t) return;
    let { key: o } = e;
    t === !0 && (t = e.classlist = {
        key: o
    }), typeof t == "string" && (t = e.classlist = {
        default: t
    }), t !== null && typeof t == "object" && !Array.isArray(t) && (t = gJ(t, e));
    let r = t.replace(hJ, " ").trim();
    if (n && typeof n.setAttribute == "function") n.setAttribute("class", r);
    else if (n) try {
        n.className = r;
    } catch  {}
    return r;
}, yJ = ()=>(t, e, n)=>{
        let o = OH(t, e);
        if (t) {
            let { __ref: r } = e;
            r.__class.style = o;
        }
        CH()(e.classlist, e, e.state, !0);
    }, CH = ()=>(t, e, n, o)=>{
        if (e.style && !o) return;
        let { __ref: r } = e, { __class: s, __classNames: i } = r;
        if (!(t === null || typeof t != "object" || Array.isArray(t))) {
            e.class && (i.classProps = e.class), e.attr?.class && (i.class = e.attr.class);
            for(let a in s){
                let c = s[a];
                if (!c) {
                    delete i[a];
                    continue;
                }
                let l;
                typeof c == "string" || typeof c == "number" ? l = c : typeof c == "boolean" ? l = e.key : l = Ke(c), i[a] = l;
            }
            for(let a in i)a === "classProps" || a === "class" || s[a] === void 0 && delete i[a];
            e.node && mJ(i, e, e.node);
        }
    }, _J = ()=>({
        style: yJ(),
        classlist: CH()
    }), bJ = [
    "useReset",
    "useVariable",
    "useFontImport",
    "useIconSprite",
    "useSvgSprite",
    "useDocumentTheme",
    "useDefaultIcons",
    "useDefaultConfig",
    "verbose",
    "globalTheme"
], wC = new WeakSet, xC = !1, SJ = (t)=>!!t && typeof t == "object", wJ = new Set([
    "key",
    "document",
    "files",
    "assets",
    "themeRoot",
    "config",
    "newConfig",
    "recordCss",
    "router"
]), RH = (t)=>t.toLowerCase() === "font", xJ = (t)=>{
    let e = 2166136261, n = 16777619 ^ t.length;
    for(let o = 0; o < t.length; o++){
        let r = t.charCodeAt(o);
        e = Math.imul(e ^ r, 16777619), n = Math.imul(n ^ r, 1540483477);
    }
    return (e >>> 0).toString(36) + "." + (n >>> 0).toString(36) + "." + t.length.toString(36);
}, bH = (t, e)=>typeof e == "function" ? "fn:" + String(e) : e, DH = (t, e)=>{
    let n = {};
    for(let r in t || {})RH(r) || (n[r] = t[r]);
    let o = {};
    for(let r in e)wJ.has(r) || (o[r] = e[r]);
    return o.globalTheme = y_(e.globalTheme) || "auto", xJ("1|" + JSON.stringify(n, bH) + "|" + JSON.stringify(o, bH));
}, kJ = (t)=>{
    let e = {};
    for(let n in t || {})RH(n) && k(t[n]) && mt(e, ft(t[n]), ue);
    return k(Ni.font) && mt(e, ft(Ni.font), ue), e;
}, TJ = (t, e)=>{
    if (t.preparedDesignSystem !== void 0) {
        let o = t.preparedDesignSystem;
        return delete t.preparedDesignSystem, o;
    }
    let n = io(e, lu);
    return n ? n.value : null;
}, LH = (t)=>{
    if (!t || t.preparedDesignSystem !== void 0) return null;
    let e = t.document || (typeof document < "u" ? document : null);
    if (!e || typeof e.querySelector != "function" || typeof globalThis.fetch != "function") return null;
    try {
        let n = e.querySelector(au), o = n && n.href;
        if (o) return globalThis.fetch(o, {
            credentials: "same-origin"
        }).then((c)=>c && c.ok ? c.json() : null).catch(()=>null);
        let r = e.querySelector(cu), s = r && r.getAttribute("content");
        if (!s) return null;
        let i = new URL(s, e.baseURI || void 0).href, a = globalThis.fetch(i, {
            credentials: "same-origin",
            priority: "low"
        }).then((c)=>c && c.ok ? c.json() : null).catch(()=>null);
        return AJ(a, i, t.window || e.defaultView);
    } catch  {
        return null;
    }
}, EJ = (t, e)=>{
    let n = e && e.performance || (typeof performance < "u" ? performance : null);
    if (!n || typeof n.getEntriesByName != "function") return !1;
    try {
        let o = n.getEntriesByName(t);
        for(let r = 0; r < o.length; r++)if (o[r].responseEnd > 0) return !0;
    } catch  {}
    return !1;
}, AJ = (t, e, n)=>{
    let o = !1, r = t.then((s)=>(o = !0, s));
    return r.deferred = !0, r.ready = ()=>o || EJ(e, n), r;
}, PH = (t)=>!!t && (t.deferred !== !0 || t.ready()), vJ = (t)=>k(t) && t.format === 1 && typeof t.fingerprint == "string" && k(t.config) && Array.isArray(t.rules), OJ = (t, e, n, o)=>{
    if (o.localFile) return null;
    let r = Rm(t);
    return r ? {
        format: 1,
        fingerprint: DH(n.designSystem, o),
        config: r,
        rules: e.rules,
        sprites: e.sprites
    } : null;
}, IH = (t, e)=>{
    let n = e.document || (e.parent && e.parent.documentElement ? e.parent : null) || document, o = e.initOptions || {}, r = e.registry || _J(), s = ()=>e.designSystem ? mt(ft(e.designSystem), ft(Ni), ue) : ft(Ni), i = {};
    for (let m of bJ)e[m] !== void 0 && (i[m] = e[m]);
    let a, c = SJ(n), f = c && wC.has(n) && !e.skipDesignSystemInit, u = !f && !xC, d = f ? `[data-smbls-app="${t}"]` : ":root";
    e.scopeSelector = d;
    let p = {
        key: t,
        document: n,
        files: e.files,
        assets: e.assets,
        scopeSelector: d,
        ...cC,
        ...i,
        ...o
    };
    if (e.skipDesignSystemInit) {
        if (a = L(t) || L(), a && (a.__domDocument = n), a?.CSS_VARS) {
            pt(a);
            try {
                Lt({
                    [d]: a.CSS_VARS
                }), a.CSS_MEDIA_VARS && Lt(m_(a.CSS_MEDIA_VARS, d));
                let m = gi(a.cssSkinVars, a.cssSkinFallback, d);
                Object.keys(m).length && Lt(m);
            } finally{
                ut();
            }
        }
    } else if (e.isolateDesignSystem && !f) {
        let m = lm();
        m.__domDocument = n;
        let y = null, b = e.captureDesignSystem ? (T)=>{
            y = T;
        } : void 0;
        pt(m);
        try {
            a = To(s(), {
                ...p,
                config: m,
                recordCss: b
            });
        } finally{
            ut();
        }
        y && (e.preparedDesignSystem = OJ(a, y, e, p));
    } else if (u) {
        let m = L();
        m && (m.__domDocument = n);
        let y = m && m._scratchConfig && !p.localFile ? TJ(e, n) : null;
        vJ(y) && y.fingerprint === DH(e.designSystem, p) ? (a = Iv(y, m, p, kJ(e.designSystem)), e.designSystemSource = "prepared") : (a = To(s(), p), e.designSystemSource = "processed"), a && a !== m && (a.__domDocument = n), c && wC.add(n), xC = !0;
    } else {
        let m = Au(t, s(), {
            cleanBase: !0
        });
        for(let y in i)m[y] = i[y];
        if (m.__domDocument = n, f) {
            let y = t.replace(/[^a-zA-Z0-9]/g, "").substring(0, 6);
            e.cssPrefix = y, m.varPrefix = y;
        }
        pt(m);
        try {
            a = To(m, p);
        } finally{
            ut();
        }
        c && wC.add(n), xC = !0;
    }
    let g = a?.CONFIG || a, h = g?.font;
    if (h) {
        pt(g);
        try {
            eH(h);
        } finally{
            ut();
        }
    }
    return [
        a,
        r
    ];
}, MH = (t, e)=>{
    let n = {};
    e.state && _r(n, e.state), t && t.state && _r(n, t.state);
    let o = e.polyglot;
    if (o) {
        let r = null;
        try {
            typeof localStorage < "u" && (r = localStorage.getItem(o.storageLangKey || "smbls_lang") || localStorage.getItem("lang"));
        } catch  {}
        let s = ys?.(e.window || (typeof window < "u" ? window : null)), i = _s({
            polyglot: o,
            pathname: bs(e.window),
            stored: r,
            stateLang: n.lang,
            started: s
        });
        (r || s || i !== te(n.lang, o)) && i !== n.lang && (n.lang = i), o.translations && CJ(e, o, n, i);
    }
    return n.isRootState = !0, ft(n);
}, CJ = (t, e, n, o)=>{
    let r = new Set, s = new Set, i = (l, f)=>{
        if (!s.has(l)) {
            if (!Cs(t, l, n)) {
                r.add(l);
                return;
            }
            n[l] = f, s.add(l), ro(t, l, f);
        }
    }, a = e.translations[o];
    if (a && typeof a == "object") for(let l in a)i(l, a[l]);
    let c = new Set(we(e, !1));
    for(let l in e.translations)c.has(l) || i(l, e.translations[l]);
    r.size && e.verbose !== !1 && t.verbose;
}, BH = (t, e)=>{
    k(t.routes) && k(e.pages) && Dt(t.routes, e.pages);
    let n = t.routes || e.pages || {}, o = [];
    for(let r in n){
        if (r.charCodeAt(0) === 47) continue;
        let i = "/" + (r === "index" ? "" : r);
        Object.prototype.hasOwnProperty.call(n, i) ? o.push(`${r} -> ${i}`) : n[i] = n[r], delete n[r];
    }
    return o.length && e && e.verbose, n;
}, TC = (t)=>{
    Zf(t, t.sharedLibraries);
};
var CC = /*@__PURE__*/ F({}, {
    default: ()=>zJ,
    getActiveLang: ()=>fs,
    getLanguages: ()=>Dp,
    getLocalStateLang: ()=>Mp,
    getPendingLang: ()=>Rp,
    initPolyglot: ()=>Tb,
    loadTranslations: ()=>la,
    polyglotPlugin: ()=>wl,
    setLang: ()=>Pp,
    trackLoadTranslations: ()=>OC,
    translate: ()=>Lp,
    upsertTranslation: ()=>Ip
});
var RJ = "smbls_t_", DJ = "smbls_tv_", EC = (t)=>{
    let e = t && t.window || (typeof window < "u" ? window : null);
    return e ? e.localStorage : null;
}, Sl = {
    get (t, e) {
        try {
            return EC(t)?.getItem(e) ?? null;
        } catch  {
            return null;
        }
    },
    set (t, e, n) {
        try {
            EC(t)?.setItem(e, n);
        } catch (o) {
            console.warn("[polyglot] localStorage unavailable:", o.message);
        }
    },
    remove (t, e) {
        try {
            EC(t)?.removeItem(e);
        } catch (n) {
            console.warn("[polyglot] localStorage unavailable:", n.message);
        }
    }
}, NH = new WeakMap, FH = (t)=>{
    let e = NH.get(t);
    return e || (e = {}, NH.set(t, e)), e;
}, $H = new WeakMap, zH = (t, e)=>t && typeof t == "object" ? t : e && typeof e == "object" ? e : null, WH = (t)=>{
    let e = $H.get(t);
    return e || (e = {
        seq: 0,
        pending: On(null),
        wake: null
    }, $H.set(t, e)), e;
}, jH = (t, e, n)=>new Promise((o)=>{
        let r = null, s = ()=>{
            r !== null && clearTimeout(r), r = null, t.wake === s && (t.wake = null), o();
        };
        t.wake = s, Promise.resolve(e).then(s, s), n > 0 && (r = setTimeout(s, n));
    }), vC = (t, e)=>!!(t?.translations && t.translations[e]), LJ = 3e3, PJ = 2147483647, IJ = (t)=>{
    let e = t?.fontWait;
    return e === !1 ? 0 : typeof e == "number" ? e > 0 ? Math.min(e, PJ) : 0 : LJ;
}, MJ = /\p{L}/gu, KH = (...t)=>{
    let e = new Set, n = (o, r)=>{
        if (typeof o == "string") {
            let s = o.match(MJ);
            if (s) for(let i = 0; i < s.length; i++)e.add(s[i]);
        } else if (o && typeof o == "object" && r < 8) for(let s in o)n(o[s], r + 1);
    };
    for(let o = 0; o < t.length; o++)n(t[o], 0);
    return Array.from(e).join("");
}, GH = (t, e)=>{
    let n = t?.fonts;
    if (!e || !n || !t.body || typeof n.check != "function" || typeof n.load != "function") return null;
    try {
        let r = (t.defaultView || globalThis).getComputedStyle(t.body).fontFamily;
        if (!r) return null;
        let s = "1em " + r;
        return n.check(s, e) ? null : Promise.resolve(n.load(s, e)).then(()=>{}, ()=>{});
    } catch  {
        return null;
    }
};
function fs() {
    let t = this?.context, e = t?.polyglot, n = this?.state?.root || t?.state?.root;
    return te(n?.lang || t?.state?.lang, e);
}
function Rp() {
    let t = this?.context, e = zH(t, this?.state?.root || t?.state?.root);
    return e ? WH(e).pending.get() : null;
}
function Dp() {
    let t = this?.context?.polyglot;
    return t ? we(t) : [];
}
var kb = (t, e)=>{
    if (!t || !e) return;
    if (t[e] !== void 0) return t[e];
    if (e.indexOf(".") === -1) return;
    let n = e.split("."), o = t;
    for(let r = 0; r < n.length; r++){
        if (o == null) return;
        o = o[n[r]];
    }
    return o;
}, UH = (t, e, n)=>{
    let o = e.lastIndexOf(".");
    if (o === -1) return t[e + "_" + n];
    let r = kb(t, e.substring(0, o));
    if (r != null) return r[e.substring(o + 1) + "_" + n];
};
function Lp(t, e) {
    if (!t) return "";
    let n = this?.context, o = n?.polyglot, r = e || this.call("getActiveLang"), s = this?.state;
    if (s) {
        let l = UH(s, t, r);
        if (l !== void 0) return l;
    }
    if (o?.translations) {
        let l = o.translations[r];
        if (l) {
            let f = kb(l, t);
            if (f !== void 0) return f;
        }
    }
    let i = s?.root || n?.state?.root, a = i?.translations;
    if (a) {
        let l = a[r];
        if (l) {
            let f = kb(l, t);
            if (f !== void 0) return f;
        }
    }
    let c = te(void 0, o);
    if (s) {
        let l = UH(s, t, c);
        if (l !== void 0) return l;
    }
    if (o?.translations) {
        let l = o.translations[c];
        if (l) {
            let f = kb(l, t);
            if (f !== void 0) return f;
        }
    }
    return BJ(o, i, r) && typeof Ia == "function" && Ia(), t;
}
var BJ = (t, e, n)=>!!t?.fetch && !vC(e, n) && !t._fetchFailed?.[n];
async function la(t, e) {
    let n = this?.context, o = n?.polyglot, r = this?.state?.root || n?.state?.root;
    if (!o || !r) return;
    if (e && e.inFlight === !0) return FH(r)[(o.storagePrefix || "smbls") + ":" + t];
    let s = o.storagePrefix || RJ, i = o.storageVersionPrefix || (o.storagePrefix ? o.storagePrefix.replace(/_$/, "v_") : DJ);
    if (o.translations && o.translations[t] && !o.fetch || !o.fetch || o._fetchFailed?.[t]) return;
    if (!r.translations?.[t]) {
        let f = Sl.get(n, s + t);
        if (f) try {
            let u = JSON.parse(f), d = {
                translations: {
                    ...r.translations || {}
                }
            };
            d.translations[t] = u, r.update && r.update(d);
        } catch (u) {
            console.warn("[polyglot] Failed to apply language update:", u.message);
        }
    }
    let a = FH(r), c = (o.storagePrefix || "smbls") + ":" + t;
    if (a[c]) return a[c];
    let l = this;
    return a[c] = (async ()=>{
        try {
            let f = o.fetch, u = parseInt(Sl.get(n, i + t), 10) || 0, d, p, g;
            if (P(f)) {
                let m = await f(t, u, l);
                if (!m || m.changed === !1) return;
                d = m.translations || m.data || m, p = m.version || 0, g = !0;
            } else if (k(f)) {
                let m = l.getDB || (()=>n.fetch), y = P(m) ? await m.call(l) : n.fetch;
                if (!y) return;
                let b = f.rpc || f.from || "get_translations_if_changed", T = {
                    p_lang: t,
                    p_cached_version: u,
                    ...f.params || {}
                }, v = await y.rpc({
                    from: b,
                    params: T
                });
                if (v.error) throw o._fetchFailed || (o._fetchFailed = {}), o._fetchFailed[t] = !0, v.error;
                let S = v.data;
                if (!S || !S.changed) return;
                d = S.translations || {}, p = S.version || 0, g = !0;
            } else return;
            if (!g || !d) return;
            Sl.set(n, s + t, JSON.stringify(d)), p && Sl.set(n, i + t, String(p));
            let h = {
                translations: {
                    ...r.translations || {}
                }
            };
            h.translations[t] = d, r.update && r.update(h);
        } catch (f) {
            if (o.verbose !== !1) {
                let u = f?.message || f?.details || (typeof f == "object" ? JSON.stringify(f) : String(f));
                console.warn("[polyglot] Failed to load translations for", t, "-", u);
            }
        } finally{
            delete a[c];
        }
    })(), a[c];
}
var AC = new WeakMap, HH = Symbol.for("@symbo.ls/polyglot:trackedLoadTranslations");
function OC(t) {
    if (!P(t) || t[HH] || t === la) return t;
    let e = function(n, o) {
        let r = this?.context, s = this?.state?.root || r?.state?.root, a = (r?.polyglot?.storagePrefix || "smbls") + ":" + n;
        if (o && o.inFlight === !0) {
            let l = s && AC.get(s);
            return l && l[a] ? l[a] : la.call(this, n, o);
        }
        let c = t.call(this, n, o);
        if (s && c && typeof c.then == "function") {
            let l = AC.get(s);
            l || AC.set(s, l = {});
            let f = Promise.resolve(c);
            l[a] = f;
            let u = ()=>{
                l[a] === f && delete l[a];
            };
            f.then(u, u);
        }
        return c;
    };
    return e[HH] = !0, e;
}
var NJ = (t, e, n)=>{
    let o = t.__ref;
    if (!o || o.contentManaged || n == null || typeof n == "object") return;
    let r = o.__textNode;
    if (!r || r.parentNode !== e) return;
    let s = String(n);
    r.nodeValue !== s && (r.nodeValue = s);
};
async function Pp(t, e) {
    let n = this?.context, o = n?.polyglot, r = this?.state?.root || n?.state?.root, s = n?.document || globalThis.document;
    if (!r) return;
    e?.persist !== !1 && Sl.set(n, Sa(o), t);
    let i = WH(zH(n, r)), a = ++i.seq;
    i.wake && i.wake();
    let c = ()=>i.seq === a;
    if (this.call("getActiveLang") === t) {
        i.pending.set(null), s?.documentElement && (s.documentElement.lang = t);
        return;
    }
    try {
        if (o?.fetch) {
            let f = this.call("loadTranslations", t);
            if (!vC(r, t)) {
                i.pending.set(t);
                let u = null;
                if (await jH(i, Promise.resolve(f).then(null, (d)=>{
                    u = d;
                }), 0), !c()) return;
                if (u) throw u;
                if (!vC(r, t) && !o.translations?.[t]) return;
            }
        }
        let l = IJ(o);
        if (l > 0 && s?.fonts && s.documentElement?.lang !== t) {
            let f = GH(s, KH(o?.translations?.[t], r.translations?.[t]));
            if (f && (i.pending.set(t), await jH(i, f, l), !c())) return;
        }
        i.pending.set(null), FJ(n, o, r, s, t);
    } finally{
        c() && i.pending.set(null);
    }
}
function FJ(t, e, n, o, r) {
    t?.state && (t.state.lang = r);
    let s = e?.translations?.[r], i = {
        lang: r
    }, a = (c)=>mf(t, c, n);
    if (s && typeof s == "object") for(let c in s){
        if (!a(c)) continue;
        let l = s[c];
        (Array.isArray(l) || typeof l == "string" || typeof l == "number") && (i[c] = l);
    }
    n.update && n.update(i);
    for(let c in i)c !== "lang" && ro(t, c, i[c]);
    if (s && typeof s == "object") for(let c in s){
        if (!a(c)) continue;
        let l = s[c];
        if (l && typeof l == "object" && !Array.isArray(l) && n[c] && typeof n[c] == "object" && !Array.isArray(n[c])) {
            for(let f in l)n[c][f] = l[f];
            ro(t, c, n[c]);
        }
    }
    if (o && s) {
        let c = o.querySelectorAll("[data-key]");
        for (let l of c){
            let f = l.ref;
            if (!f) continue;
            let u = f.__ref?.__exec?.text;
            if (typeof u == "string" && u.includes("{{")) try {
                NJ(f, l, f.call("replaceLiteralsWithObjectFields", u, f.state));
            } catch  {}
        }
    }
    o?.documentElement && (o.documentElement.lang = r);
}
async function Ip(t, e, n) {
    let o = this?.context, r = o?.polyglot, s = this?.state?.root || o?.state?.root;
    if (s?.translations?.[e] && (s.translations[e][t] = n), r?.translations?.[e] && (r.translations[e][t] = n), r?.fetch && k(r.fetch)) {
        let i = this.getDB || (()=>o.fetch), a = P(i) ? await i.call(this) : o.fetch;
        if (!a) return;
        let c = r.fetch.table || "translations", l = await a.upsert({
            from: c,
            data: {
                key: t,
                lang: e,
                text: n
            }
        });
        if (l?.error) throw l.error;
        return l.data;
    }
}
async function Tb() {
    let t = this?.context, e = t?.polyglot;
    if (!e) return;
    let n = this?.state?.root || t?.state?.root;
    if (!n) return;
    let o = Sl.get(t, Sa(e)), r = _s({
        polyglot: e,
        pathname: bs(t.window),
        stored: o,
        stateLang: n.lang || t?.state?.lang,
        started: ys?.(t.window || (typeof window < "u" ? window : null))
    }), s = t?.document || globalThis.document;
    s?.documentElement && (s.documentElement.lang = r), n.update && n.lang !== r && n.update({
        lang: r
    }), e.fetch && !(e.translations && e.translations[r]) && await this.call("loadTranslations", r), jJ(e) && HJ(this, t, e);
}
var $J = 2e3, VH = Symbol.for("@symbo.ls/polyglot:prefetched"), jJ = (t)=>t?.prefetch === !0 || t?.prefetch === "idle", UJ = (t)=>new Promise((e)=>{
        let n = ()=>{
            typeof t.requestIdleCallback == "function" ? t.requestIdleCallback(()=>e(), {
                timeout: $J
            }) : t.setTimeout(e, 1);
        }, o = t.document;
        o && o.readyState && o.readyState !== "complete" && typeof t.addEventListener == "function" ? t.addEventListener("load", n, {
            once: !0
        }) : n();
    }), HJ = (t, e, n)=>{
    let o = e.window || (typeof window < "u" ? window : null);
    if (!o || typeof o.setTimeout != "function") return null;
    let r = o.navigator && o.navigator.connection;
    if (r && r.saveData) return null;
    let s = t?.state?.root || e?.state?.root;
    if (!s || s[VH]) return null;
    try {
        Object.defineProperty(s, VH, {
            value: !0,
            enumerable: !1,
            configurable: !0
        });
    } catch  {
        return null;
    }
    return UJ(o).then(()=>VJ(t, e, n));
};
async function VJ(t, e, n) {
    let o = fs.call(t), r = e.document || globalThis.document;
    for (let s of we(n))if (s !== o) try {
        n.fetch && await t.call("loadTranslations", s);
        let i = t?.state?.root || e?.state?.root, a = i?.translations && i.translations[s] || n.translations && n.translations[s], c = GH(r, KH(a));
        c && await c;
    } catch  {}
}
function Mp(t) {
    try {
        let e = fs.call(this), n = this?.state;
        if (!n) return "";
        let o = t.lastIndexOf(".");
        if (o === -1) return n[t + e] ?? "";
        let r = t.substring(0, o).split("."), s = n;
        for(let i = 0; i < r.length; i++){
            if (s == null) return "";
            s = s[r[i]];
        }
        return s == null ? "" : s[t.substring(o + 1) + e] ?? "";
    } catch  {
        return "";
    }
}
var wl = {
    name: "polyglot",
    render (t) {
        t.parent && t.parent.parent || t.__polyglotInitialized || (t.__polyglotInitialized = !0, Tb.call(t));
    }
}, zJ = wl;
var Bp = {
    polyglot: Lp,
    getLocalStateLang: Mp,
    getActiveLang: fs,
    getLang: fs,
    setLang: Pp,
    getPendingLang: Rp,
    getLanguages: Dp,
    loadTranslations: la,
    upsertTranslation: Ip
};
var DC = /*@__PURE__*/ F({}, {
    SYSTEM_METRICS: ()=>Np,
    capsizeHandler: ()=>RC,
    capsizePlugin: ()=>Ab,
    computeCapsize: ()=>qH,
    default: ()=>WJ,
    resolveFontSizePx: ()=>YH,
    resolveMetrics: ()=>XH
});
var Np = {
    arial: {
        capHeight: 716,
        ascent: 1854,
        descent: -434,
        lineGap: 67,
        unitsPerEm: 2048
    },
    helvetica: {
        capHeight: 714,
        ascent: 770,
        descent: -230,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    "helvetica neue": {
        capHeight: 714,
        ascent: 952,
        descent: -213,
        lineGap: 28,
        unitsPerEm: 1e3
    },
    georgia: {
        capHeight: 1419,
        ascent: 1878,
        descent: -449,
        lineGap: 0,
        unitsPerEm: 2048
    },
    "times new roman": {
        capHeight: 1356,
        ascent: 1825,
        descent: -443,
        lineGap: 87,
        unitsPerEm: 2048
    },
    "courier new": {
        capHeight: 1170,
        ascent: 1705,
        descent: -615,
        lineGap: 0,
        unitsPerEm: 2048
    },
    verdana: {
        capHeight: 1489,
        ascent: 2059,
        descent: -430,
        lineGap: 0,
        unitsPerEm: 2048
    },
    roboto: {
        capHeight: 1456,
        ascent: 1900,
        descent: -500,
        lineGap: 0,
        unitsPerEm: 2048
    },
    "open sans": {
        capHeight: 1462,
        ascent: 2189,
        descent: -600,
        lineGap: 0,
        unitsPerEm: 2048
    },
    inter: {
        capHeight: 1490,
        ascent: 2048,
        descent: -512,
        lineGap: 0,
        unitsPerEm: 2048
    },
    lato: {
        capHeight: 1434,
        ascent: 1974,
        descent: -426,
        lineGap: 0,
        unitsPerEm: 2e3
    },
    "source sans": {
        capHeight: 660,
        ascent: 984,
        descent: -273,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    "source sans pro": {
        capHeight: 660,
        ascent: 984,
        descent: -273,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    "source sans 3": {
        capHeight: 660,
        ascent: 984,
        descent: -273,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    montserrat: {
        capHeight: 700,
        ascent: 968,
        descent: -251,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    poppins: {
        capHeight: 700,
        ascent: 1050,
        descent: -350,
        lineGap: 100,
        unitsPerEm: 1e3
    },
    raleway: {
        capHeight: 710,
        ascent: 1e3,
        descent: -250,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    "dm sans": {
        capHeight: 700,
        ascent: 992,
        descent: -312,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    nunito: {
        capHeight: 705,
        ascent: 1011,
        descent: -353,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    "work sans": {
        capHeight: 684,
        ascent: 930,
        descent: -243,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    manrope: {
        capHeight: 708,
        ascent: 980,
        descent: -300,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    "ibm plex sans": {
        capHeight: 698,
        ascent: 1025,
        descent: -275,
        lineGap: 0,
        unitsPerEm: 1e3
    },
    "plus jakarta sans": {
        capHeight: 720,
        ascent: 1060,
        descent: -300,
        lineGap: 0,
        unitsPerEm: 1e3
    }
}, Eb = (t)=>parseFloat(t.toFixed(4)), qH = (t, e, n)=>{
    let { ascent: o, descent: r, lineGap: s, unitsPerEm: i, capHeight: a } = e, c = Math.abs(r), l = o + c + s, f = n !== void 0 ? n : l / i * t, u = f / t, d = l / i, p = (o - a + s / 2) / i - (u - d) / 2, g = (c + s / 2) / i - (u - d) / 2;
    return {
        fontSize: `${Eb(t / 16)}rem`,
        lineHeight: `${Eb(f)}px`,
        capHeightTrim: `${Eb(-p)}em`,
        baselineTrim: `${Eb(-g)}em`
    };
}, YH = (t, e)=>{
    if (typeof t == "number") return t;
    let n = e?.designSystem;
    if (!n) return null;
    let { typography: o } = n;
    if (o?.sequence) {
        let s = String(t).toUpperCase(), i = o.sequence[s];
        if (i) return i.decimal || i.val;
    }
    let r = parseFloat(t);
    return isNaN(r) ? null : typeof t == "string" && t.endsWith("rem") ? r * (n.typography?.browserDefault || 16) : r;
}, XH = (t, e)=>{
    let o = e?.designSystem?.font_family || {};
    if (t) {
        let s = o[t];
        if (s?.metrics) return s.metrics;
        let i = String(t).toLowerCase().replace(/['"]/g, "").trim();
        if (Np[i]) return Np[i];
    }
    let r = o.default || Object.keys(o)[0];
    if (r) {
        let s = o[r];
        if (s?.metrics) return s.metrics;
        if (s?.value && Array.isArray(s.value)) for (let i of s.value){
            let a = i.toLowerCase().replace(/['"]/g, "").trim();
            if (Np[a]) return Np[a];
        }
    }
    return null;
}, RC = (t, e, n, o)=>{
    if (!t) return;
    let r = YH(e.fontSize, o);
    if (!r) return;
    let s = XH(e.fontFamily, o);
    if (!s) return;
    let i = e.lineHeight ? parseFloat(e.lineHeight) : void 0, { lineHeight: a, capHeightTrim: c, baselineTrim: l } = qH(r, s, i), f = {};
    return e.lineHeight || (f.lineHeight = a), f["::before"] = {
        content: '""',
        marginBottom: c,
        display: "table"
    }, f["::after"] = {
        content: '""',
        marginTop: l,
        display: "table"
    }, f;
}, Ab = {
    name: "capsize",
    init (t) {
        t.useCapsize === void 0 && t.fontSize && (t.useCapsize = !0);
    }
}, WJ = Ab;
var KJ = "@symbo.ls/fetch:EARLY", QH = ()=>new Promise((t)=>setTimeout(t, 0)), GJ = (t)=>{
    let e = typeof globalThis < "u" ? globalThis[Symbol.for(KJ)] : null, n = e && e.afterFirstView;
    return typeof n != "function" || e.afterFirstViewRan ? null : (e.afterFirstViewRan = !0, Promise.resolve(t && t.__firstNavigation).catch(()=>{}).then(QH).then(()=>{
        try {
            n(e.ctx || {});
        } catch (o) {
            console.error("[smbls] fetch.early afterFirstView failed:", o);
        }
    }));
}, ZH = Symbol.for("smbls.afterFirstViewRan"), LC = (t, e)=>{
    let n = GJ(t), o = t && typeof t.afterFirstView == "function" && !t[ZH] ? t.afterFirstView : null;
    if (!o) return n;
    t[ZH] = !0;
    let r = Promise.resolve(t.__firstNavigation).catch(()=>{}).then(QH).then(()=>{
        try {
            return Promise.resolve(o(e, e && e.state, t)).catch((s)=>{
                console.error("[smbls] afterFirstView failed:", s);
            });
        } catch (s) {
            console.error("[smbls] afterFirstView failed:", s);
        }
    });
    return n ? Promise.all([
        n,
        r
    ]).then(()=>{}) : r;
};
var MC = (t)=>!!(t && typeof t == "object" && t.__isStub === !0), BC = (t)=>ke(t) ? t.library !== void 0 ? t.library : t.key ?? t.name : t, qJ = (t, e)=>{
    let n = e?.sharedLibraries, o = Array.isArray(n) ? n.map((i)=>typeof i == "string" ? i : i?.key || i?.name) : n && typeof n == "object" ? Object.keys(n) : null, r = 0, s = (i)=>{
        let a = r++;
        if (typeof i.__libraryKey == "string" && i.__libraryKey) return i.__libraryKey;
        if (o && o[a]) return o[a];
        if (typeof i.__stubId == "string") {
            let c = i.__stubId.match(/^@symbo[-.]ls\/([^/]+)/);
            if (c) return c[1];
        }
        return null;
    };
    return t.map((i)=>{
        let a = BC(i);
        if (!MC(a)) return i;
        let c = s(a);
        return c ? ke(i) ? {
            ...i,
            library: c
        } : c : null;
    }).filter(Boolean);
}, NC = new WeakMap, YJ = {
    lazy: !0,
    window: globalThis
}, t4 = [
    "components",
    "pages",
    "functions",
    "methods",
    "snippets"
], XJ = t4.filter((t)=>t !== "methods"), PC = (t)=>{
    if (!t || typeof t != "object") return !1;
    let e = new WeakSet, n = [
        t
    ];
    for(; n.length;){
        let o = n.pop();
        if (!o || typeof o != "object" || e.has(o)) continue;
        e.add(o);
        let r;
        try {
            r = Object.keys(o);
        } catch  {
            continue;
        }
        for (let s of r){
            let i;
            try {
                i = o[s];
            } catch  {
                continue;
            }
            if (typeof i == "function") return !0;
            i && typeof i == "object" && n.push(i);
        }
    }
    return !1;
}, ZJ = (t, e)=>{
    if (As(e) || As(t)) return "boot-revived";
    if (PC(t)) return "local";
    if (e && typeof e == "object") {
        if (PC(e.app)) return "local";
        for (let n of XJ)if (PC(e[n])) return "local";
    }
    return "raw-json";
}, e4 = (t, e)=>{
    let n = e ? t[e] : t;
    if (!k(n)) return;
    let o = xe(n, {}, YJ);
    try {
        Object.assign(n, o);
    } catch (r) {
        if (e) t[e] = o;
        else throw r;
    }
}, QJ = (t)=>{
    if (!k(t) || As(t)) return t;
    for (let e of [
        ...t4,
        "app"
    ])e4(t, e);
    return ka(t);
}, JJ = (t, e)=>{
    if (!Array.isArray(t)) return t;
    for (let n of t){
        let o = ke(n) ? n.library : n;
        k(o) && !e.has(o) && QJ(o);
    }
    return t;
}, FC = new WeakMap, IC = (t)=>{
    let e = NC.get(t);
    e && (NC.delete(t), AH(e));
}, n4 = (t)=>t.notifications === !0 || t.notifications !== !1 && !!t.editor && t.editor.verbose === !0, ttt = (t)=>!!(t.editor && (t.editor.socketUrl || t.editor.runtime === "runner") || t.settings && t.settings.socketUrl), o4 = (t)=>pl(t), r4 = (t)=>t.sync !== !1 && o4(t) || n4(t), JH = (t, e)=>(...n)=>Promise.all([
            qt("lazyParts").then((o)=>{
                if (!o) throw new Error("[smbls] the framework parts of the lazy groups failed to load");
                o.installLazyParts(t);
            }),
            e(...n)
        ]).then((o)=>o[1]), ett = (t)=>{
    let e = 2166136261;
    for(let n = 0; n < t.length; n++)e = Math.imul(e ^ t.charCodeAt(n), 16777619);
    return (e >>> 0) % 31;
}, ntt = (t, e)=>typeof e != "number" || (e >>> ett(t) & 1) === 1, ott = (t)=>{
    let e = t.lazy;
    if (!e || typeof e != "object" || Array.isArray(e)) return;
    let n = !1, o = {};
    for (let r of Object.keys(e)){
        let s = e[r];
        ntt(r, n) ? typeof s == "function" ? o[r] = JH(t, s) : s && typeof s == "object" && typeof s.load == "function" ? o[r] = {
            ...s,
            load: JH(t, s.load)
        } : o[r] = s : o[r] = s;
    }
    t.lazy = o;
}, s4 = (t)=>{
    let e = {
        shorthand: null,
        analyze: null,
        inspect: null,
        fetch: null,
        sync: null,
        windows: null,
        dropdown: null,
        tooltip: null
    };
    for (let n of yU(t))e[n] = qt(n);
    return r4(t) && (e.sync = qt("sync")), e;
}, $C = async (t, e = {})=>{
    let n = e.symbolsConfig, o = n?.owner && n?.key ? `${n.owner}--${n.key}` : n?.key, r = e.key = e.key || o || (E(t) ? t : "smblsapp");
    (!e.define || e.define === ia) && (e.define = {
        ...ia
    }), e.cssPropsRegistry = St, e.window = SH(e);
    let s = s4(e);
    let i = ZJ(t, e);
    ms(e);
    if (e.sharedLibraries && e.sharedLibraries.length) {
        if (e.sharedLibraries.some((b)=>{
            let T = BC(b);
            return typeof T == "string" || MC(T);
        })) {
            e.sharedLibraries = qJ(e.sharedLibraries, e.symbolsConfig);
            let b = new Set(e.sharedLibraries.map((v)=>BC(v)).filter((v)=>k(v) && !MC(v))), T = await tu(e.sharedLibraries, {
                apiBaseUrl: Sb()
            });
            e.sharedLibraries = i === "raw-json" ? T : JJ(T, b);
        }
        GU(e.sharedLibraries), TC(e);
    }
    pl(e) && hl(e, e.designSystem);
    let a = FC.get(e);
    a && (FC.delete(e), PH(a) && (e.preparedDesignSystem = await a));
    let [c, l] = IH(r, e);
    if (e.designSystem = c, e.registry = l, hu(e, {
        apiBaseUrl: Sb()
    }), e.cases || (e.cases = {}), e.shorthand) {
        let y = await (s.shorthand || qt("shorthand"));
        y && y.shorthandPlugin.prepareContext(e);
    }
    let f = MH(t, e);
    if (e.state = f, Rf(f), e.pages = BH(t, e), e.components = wH(e), e.utils = xH(e), Er[e.packageManager]) {
        let y = EH(e);
        y && y.deferred ? (y.blocking && await kC({
            ...e,
            dependencies: y.blocking
        }), NC.set(e, y.deferred)) : e.dependencies = await kC(e);
    }
    if (e.methods = kH(e), e.routerOptions = K2(t, e), e.defaultExtends = [
        Wy
    ], e.snippets = e.snippets || {}, e.functions = e.functions || {}, e.plugins = e.plugins || [], e.globalScope = e.globalScope || {}, e.plugins.some((y)=>!y || typeof y != "object")) {
        let y = e.plugins.filter((b)=>!b || typeof b != "object");
        e.plugins = e.plugins.filter((b)=>b && typeof b == "object"), e.verbose;
    }
    let u = e.globalScope;
    e.globalScope && k(e.globalScope) && (e.globalScope = vs(e.globalScope));
    let d = (y, b)=>{
        i === "raw-json" && e4(y, b);
    };
    d(t), d(e, "components"), d(e, "pages"), d(e, "functions"), d(e, "methods"), d(e, "snippets"), d(e, "app"), qf(e, u), Yf(e);
    let p = (y)=>y && typeof y.select == "function";
    if (e.fetch?.__resolved && !p(e.fetch.__resolved) && delete e.fetch.__resolved, e.db?.__resolved && !p(e.db.__resolved) && delete e.db.__resolved, e.polyglot && !Be(e, "polyglot")) {
        e.plugins.push(wl);
        for(let y in Bp)typeof e.functions[y] != "function" && (e.functions[y] = Bp[y]);
    }
    if (e.polyglot && e.functions && typeof e.functions.loadTranslations == "function" && (e.functions.loadTranslations = OC(e.functions.loadTranslations)), Be(e, "helmet") || e.plugins.push(yb), !Be(e, "inertOutside") && e.plugins.push(Zc), e.fetch) {
        let y = await (s.fetch || qt("fetch"));
        if (y) {
            Be(e, "fetch") || e.plugins.push(y.fetchPlugin);
            let { fetchFunctions: b } = y;
            for(let T in b)typeof e.functions[T] != "function" && (e.functions[T] = b[T]);
        }
    }
    if (e.designSystem?.typography?.useCapsize !== !1 && !Be(e, "capsize") && (e.plugins.push(Ab), e.cssPropsRegistry.useCapsize = RC), e.shorthand && !Be(e, "shorthand")) {
        let y = await (s.shorthand || qt("shorthand"));
        y && e.plugins.push(y.shorthandPlugin);
    }
    if (e.analyze && !Be(e, "analyze")) {
        let y = await (s.analyze || qt("analyze"));
        if (y) {
            let b = e.analyze === !0 ? {} : e.analyze;
            e.analyze = y.createAnalyzeState(b), e.plugins.push(y.analyzePlugin);
        }
    }
    let g = e.sync !== !1 && o4(e), h = r4(e) ? await (s.sync || qt("sync")) : null;
    if (h && g && !Be(e, "sync") && e.plugins.push(h.syncPlugin), e.inspect && !Be(e, "inspect")) {
        let y = await (s.inspect || qt("inspect"));
        y && e.plugins.push(y.inspectPlugin);
    }
    h && n4(e) && !Be(e, "notifications") && e.plugins.push(h.notificationsPlugin);
    let m = async (y)=>{
        if (e[y] === !1) return;
        let b = await (s[y] || qt(y));
        if (!b) return;
        let { components: T, functions: v } = b;
        for(let S in T)k(e.components[S]) || (e.components[S] = T[S]);
        for(let S in v)typeof e.functions[S] != "function" && (e.functions[S] = v[S]);
    };
    return await m("windows"), await m("dropdown"), await m("tooltip"), e;
}, Fp = async (t, e)=>{
    k(e) || (e = {});
    let n = H2(e);
    s4(e), cH(e, e.window || globalThis.window || null);
    let o = LH(e);
    if (o && FC.set(e, o), n && (n.lease = j2(e), await xo(), !n.lease.live())) return qi(k(t) ? t : {});
    Ro(t) ? (e.parent = t, t = {}) : E(t) ? (e.key = t, t = {}) : k(t) ? t = {
        ...t
    } : t = {};
    let r = e.window || (typeof window < "u" ? window : null), s = hC(e, r);
    let i = s ? fH(e) : null;
    if (await $C(t, e), e.useReset !== !1) {
        let u = e.document || (typeof document < "u" ? document : null);
        if (u) {
            let d = u.head.querySelector("style[data-smbls]");
            d || (d = u.createElement("style"), d.setAttribute("data-smbls", ""), u.head.appendChild(d));
            let p = d.sheet;
            if (p) {
                try {
                    p.insertRule("*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }", 0);
                } catch  {}
                try {
                    p.insertRule("h1, h2, h3, h4, h5, h6 { font-size: inherit; font-weight: inherit; }", 1);
                } catch  {}
            }
        }
    }
    if (e.app && k(e.app)) for(let u in e.app)t[u] === void 0 && (t[u] = e.app[u]);
    t.extends = KU(t, e), e.router !== !1 && (t.routes = e.pages), t.state = e.state, t.context = e, t.data = t.data || {}, e.skipDesignSystemInit || await vH({
        functions: e.functions,
        utils: e.utils,
        snippets: e.snippets,
        ...e.files
    }, e);
    for (let u of e.plugins)if (typeof u.beforeCreate == "function") try {
        u.beforeCreate(t, e);
    } catch (d) {
        console.error(`[smbls] plugin "${u.name || "?"}" beforeCreate error:`, d);
    }
    let a = e.document;
    if (!a || !a.createElement) return IC(e), t;
    let c = e.parent || a.body, l = {
        verbose: e.verbose,
        context: e,
        ...e.domqlOptions
    };
    if (s) {
        let u = await gH(Gt, t, c, e, r, i, l, n);
        return pp(u) || (IC(e), LC(e, u)), u;
    }
    let f = n ? await S_(t, c, e, l, n) : Gt(t, c, e.key, l);
    return f ? (IC(e), LC(e, f), typeof window < "u" && !e.document && (window.__smblsApp = f), f) : qi(t);
};
var rtt = (t, e)=>{
    if (!k(e)) return mt(t, {});
    let { state: n, ...o } = e;
    return mt(t, o), n !== void 0 && (k(t.state) && k(n) ? _r(t.state, n) : t.state === void 0 && (t.state = n)), t;
}, jC = (t, e)=>WU(rtt(t === _l ? {} : t, e)), stt = (t)=>{
    if (typeof document > "u") return;
    let e = t.themeRoot || t.document && t.document.documentElement || document.documentElement;
    if (!e || typeof e.setAttribute != "function") return;
    let n = t.globalTheme || "auto";
    try {
        if (typeof window < "u" && window.location) {
            let s = new URLSearchParams(window.location.search).get("globalTheme");
            s && (n = s);
        }
    } catch  {}
    let o = t.themeStorageKey;
    if (n === "auto" && o && typeof localStorage < "u") try {
        let s = localStorage.getItem(o);
        s && (n = s);
    } catch  {}
    let r = n === "auto" ? (()=>{
        try {
            return typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
        } catch  {
            return "light";
        }
    })() : n;
    e.setAttribute("data-theme", r), t.globalTheme = n, t.themeRoot = e;
}, itt = ()=>{
    if (typeof document > "u") return null;
    try {
        let t = document.querySelector('meta[name="symbols-runtime"]'), e = t && t.getAttribute("content");
        return typeof e == "string" && e ? e : null;
    } catch  {
        return null;
    }
}, i4 = (t)=>{
    let e = itt();
    e && (t.editor || (t.editor = {}), t.editor.runtime || (t.editor.runtime = e), e === "runner" && typeof t.editor.livesync > "u" && (t.editor.livesync = !0));
}, UC = (t, e = _l, n)=>{
    let o = jC(e, n);
    return i4(o), stt(o), Fp(t, o).then((s)=>{
        if (pp(s)) return s.destroy = ()=>ra(s), s;
        if (Vv(s, o), s.destroy = ()=>ra(s), s.navigate = (i, a = {})=>{
            let c = s, l = s.context && s.context.routerOptions;
            if (l && l.customRouterElement) {
                let f = hp(s, l.customRouterElement);
                f && (c = f);
            }
            return c.call("router", i, c, a.state || {}, {
                pushState: !0,
                ...a
            });
        }, s.onCreate && !s.__ref && s.onCreate(s, s.state, s.context, o), s.context?.analyze?.activate) try {
            s.context.analyze.activate(s.context);
        } catch (i) {
            console.error("[analyze] activate error:", i);
        }
        return s;
    }).catch((s)=>{
        throw console.error("[smbls] create error:", s), s;
    });
}, att = (t, e = _l, n)=>{
    let o = UC(t, e, n), r = jC(e, n), s = r.key;
    return s && r.editor && r.editor.async && qt("fetchOnCreate").then((i)=>{
        i && i.fetchAsync(o, s, {
            utils: dp,
            ...r
        });
    }), o;
}, ctt = async (t, e = _l, n)=>{
    let o = jC(e, n);
    i4(o);
    let r = e.key;
    if (r && o.editor) {
        let i = await qt("fetchOnCreate");
        i && await i.fetchSync(r, o);
    }
    let s = await Fp(t, o);
    return pp(s) ? (s.destroy = ()=>ra(s), s) : (Vv(s, o), s.destroy = ()=>ra(s), s.navigate = (i, a = {})=>{
        let c = s, l = s.context && s.context.routerOptions;
        if (l && l.customRouterElement) {
            let f = hp(s, l.customRouterElement);
            f && (c = f);
        }
        return c.call("router", i, c, a.state || {}, {
            pushState: !0,
            ...a
        });
    }, o.onCreate && await o.onCreate(s, s.state, s.context, o), s);
}, ltt = (t = {}, e = _l, n)=>UC({
        deps: {
            isUndefined: Xt
        },
        ...t
    }, mt({
        domqlOptions: {
            onlyResolveExtends: !0
        }
    }, e), n);
var $p = [
    "@symbo.ls/sdk"
], jp = (t, e)=>{
    let n = e || (typeof globalThis < "u" ? globalThis : null);
    if (!n || !t || typeof t != "object") return null;
    let o = n.__SMBLS_PKGS__ || (n.__SMBLS_PKGS__ = {});
    for(let r in t){
        let s = t[r];
        !s || typeof s != "object" && typeof s != "function" || o[r] || (o[r] = s);
    }
    return o;
}, c4 = Symbol.for("smbls.hostPackageLoads"), ftt = 3e4, l4 = ()=>typeof globalThis < "u" ? globalThis : null, a4 = (t)=>!!t && (typeof t == "object" || typeof t == "function"), us = (t, e, n, o)=>Object.assign(new Error("[smbls] host package " + e + " " + o), {
        code: t,
        specifier: e,
        retryable: n
    }), utt = (t, e)=>{
    let n = t[Tr], o = n && typeof n == "object" ? n[e] : null;
    return !o || typeof o != "object" || typeof o.src != "string" || !o.src || typeof o.global != "string" || !o.global ? null : o;
}, dtt = (t)=>{
    let e = t[c4];
    return e && typeof e.get == "function" && typeof e.set == "function" && typeof e.delete == "function" ? e : null;
}, ptt = (t)=>{
    t && t.parentNode && t.parentNode.removeChild(t);
}, htt = (t)=>(j("hostPackages"), Promise.reject(us("SMBLS_HOST_PACKAGE_NO_LOADER", t, !1, "cannot load on demand: this build left the loader out (build.treeShakeFeatures)"))), vb = (t, e)=>{
    let n = e || {}, o = n.target || l4();
    if (!$p.includes(t)) return Promise.reject(us(In.UNKNOWN, t, !1, "is not host-registered; importHostPackage loads only " + $p.join(", ")));
    if (!o) return Promise.reject(us(In.NO_SOURCE, t, !1, "cannot load on demand: there is no page global"));
    let r = o.__SMBLS_PKGS__, s = r && r[t];
    if (s) return Promise.resolve(s);
    let i = dtt(o), a = i && i.get(t);
    if (a) return a;
    let c = utt(o, t);
    if (!c) return Promise.reject(us(In.NO_SOURCE, t, !1, "cannot load on demand: this page declares no source for it (" + Tr + ") and registered no namespace (Smbls.registerHostPackages)"));
    let l = o[c.global];
    if (a4(l)) return jp({
        [t]: l
    }, o), Promise.resolve(o.__SMBLS_PKGS__[t]);
    let f = n.document || o.document;
    if (!f || typeof f.createElement != "function") return Promise.reject(us(In.NO_DOM, t, !1, "cannot load on demand: there is no document to load " + c.src + " into"));
    let u = Number.isFinite(n.timeoutMs) && n.timeoutMs > 0 ? n.timeoutMs : ftt, d = i || (o[c4] = new Map), p = f.createElement("script"), g = null, h = !1, m = null, y, b, T = (S, w, _, x)=>{
        h || (h = !0, g !== null && clearTimeout(g), p.removeEventListener("load", y), p.removeEventListener("error", b), d.get(t) === m && d.delete(t), S ? (ptt(p), x(w)) : _(w));
    };
    m = new Promise((S, w)=>{
        y = ()=>{
            let _ = o[c.global];
            if (!a4(_)) {
                T(!0, us(In.NO_GLOBAL, t, !0, "loaded " + c.src + " but it defined no " + c.global), S, w);
                return;
            }
            jp({
                [t]: _
            }, o), T(!1, o.__SMBLS_PKGS__[t], S, w);
        }, b = ()=>{
            T(!0, us(In.LOAD_FAILED, t, !0, "could not load " + c.src), S, w);
        }, p.addEventListener("load", y), p.addEventListener("error", b), g = setTimeout(()=>{
            T(!0, us(In.TIMEOUT, t, !0, "did not load " + c.src + " within " + u + " ms"), S, w);
        }, u);
    }), d.set(t, m), p.async = !0, typeof c.integrity == "string" && c.integrity && (p.setAttribute("integrity", c.integrity), p.setAttribute("crossorigin", "anonymous")), p.setAttribute("data-smbls-host-package", t), p.setAttribute("src", c.src);
    let v = f.head || f.documentElement || f.body;
    try {
        v.appendChild(p);
    } catch  {
        b();
    }
    return m;
}, HC = (t)=>{
    let e = t || l4();
    if (!e) return null;
    let n = Symbol.for(Fa);
    if (typeof e[n] == "function") return e[n];
    let o = (r, s)=>vb(r, Object.assign({
            target: e
        }, s));
    return e[n] = o, o;
};
var f4 = {
    "@symbo.ls/signal": Dl,
    "@symbo.ls/scratch": D0,
    "@symbo.ls/element": Uy,
    "@symbo.ls/css": Um,
    "@symbo.ls/utils": No,
    "@symbo.ls/state": VT,
    "@symbo.ls/router": nl,
    "@symbo.ls/polyglot": CC,
    "@symbo.ls/helmet": iC,
    "@symbo.ls/fetch": $s,
    "@symbo.ls/capsize": DC,
    "@symbo.ls/shorthand": LO,
    "@symbo.ls/analyze": _p,
    "@symbo.ls/inspect": Sp,
    "@symbo.ls/channels": lC
}, u4 = (t, e)=>{
    let n = t || (typeof globalThis < "u" ? globalThis : {}), o = n.__SMBLS_PKGS__ || (n.__SMBLS_PKGS__ = {});
    for(let r in f4)o[r] || (o[r] = f4[r]);
    if (e) for(let r in e)o[r] || (o[r] = e[r]);
    return o;
}, d4 = (t, e)=>{
    let n = t || (typeof globalThis < "u" ? globalThis : null);
    if (!n || !e || typeof e != "object") return null;
    let o = n.__SMBLS_PKGS__ || (n.__SMBLS_PKGS__ = {});
    for(let r in e){
        let s = e[r];
        if (typeof s != "function" || Object.prototype.hasOwnProperty.call(o, r)) continue;
        let i = (a)=>(Object.defineProperty(o, r, {
                configurable: !0,
                enumerable: !0,
                writable: !0,
                value: a
            }), a);
        Object.defineProperty(o, r, {
            configurable: !0,
            enumerable: !0,
            get: ()=>i(s()),
            set: i
        });
    }
    return o;
};
var WC = /*@__PURE__*/ F({}, {
    BUILD_DOMQL_SYSTEM_PROMPT: ()=>T4,
    DEFAULT_MAX_TOKENS: ()=>Pb,
    DEFAULT_MODEL: ()=>ds,
    DEFAULT_PROVIDER: ()=>Vp,
    DEFAULT_TEMPERATURE: ()=>Lb,
    MODEL_TIER_ALIASES: ()=>zC,
    PROVIDER_MODELS: ()=>Hp,
    SIMONE_BASE_URL: ()=>Up,
    SIMONE_CHAT_PATH: ()=>Ob,
    SIMONE_CODE_PATH: ()=>Cb,
    SIMONE_CODE_SYMBOLS_PATH: ()=>Rb,
    SIMONE_HEALTH_PATH: ()=>Db,
    SIMONE_TOOLS_PATH: ()=>p4,
    WORKSPACE_SYSTEM_PROMPT: ()=>k4,
    buildMessages: ()=>_4,
    chat: ()=>zp,
    health: ()=>y4,
    parseSimoneResponse: ()=>w4,
    resolveModel: ()=>E4,
    streamChat: ()=>zp,
    streamCode: ()=>g4,
    streamCodeSymbols: ()=>m4,
    toLegacyEnvelope: ()=>x4
});
var Up = "https://symbols-service-production.up.railway.app", Ob = "/api/chat", Cb = "/api/code", Rb = "/api/code-symbols", Db = "/api/health", p4 = "/api/tools", Hp = {
    "openai-compatible": [
        "claude-sonnet-4-6",
        "claude-opus-4-6",
        "gpt-4o",
        "gpt-4o-mini",
        "deepseek-chat"
    ],
    anthropic: [
        "claude-sonnet-4-6",
        "claude-sonnet-4-5-20250929",
        "claude-opus-4-1-20250805",
        "claude-haiku-4-5-20251001"
    ],
    openrouter: [
        "google/gemini-3-pro-preview"
    ],
    gemini: [
        "gemini-2.5-pro",
        "gemini-3.1-pro-preview"
    ]
}, Vp = "gemini", ds = Hp[Vp][0], Lb = .7, Pb = 4096;
function gtt(t) {
    if (!t) return null;
    for (let [e, n] of Object.entries(Hp))if (n.includes(t)) return e;
    return null;
}
function h4(t, e) {
    return t ? t.replace(/\/$/, "") + e : e;
}
function mtt(t) {
    if (!t.startsWith("data: ")) return null;
    let e = t.slice(6);
    if (e === "[DONE]") return {
        done: !0
    };
    try {
        return {
            chunk: JSON.parse(e)
        };
    } catch  {
        return {
            raw: e
        };
    }
}
async function zp(t, e = {}, n) {
    let { baseUrl: o = Up, path: r = Ob, model: s = ds, provider: i = gtt(s) || Vp, temperature: a = Lb, maxTokens: c = Pb, effort: l, apiKeys: f, signal: u, headers: d } = e;
    if (!Array.isArray(t) || t.length === 0) throw new TypeError("simone: messages must be a non-empty array");
    let p = {
        messages: t,
        provider: i,
        model: s,
        temperature: a,
        maxTokens: c
    };
    l && (p.effort = l), f && (p.apiKeys = f);
    let g = await fetch(h4(o, r), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "text/event-stream",
            ...d
        },
        body: JSON.stringify(p),
        signal: u
    });
    if (!g.ok) {
        let v = g.statusText;
        try {
            let w = await g.text();
            try {
                let _ = JSON.parse(w);
                v = _.error || _.detail || v;
            } catch  {
                v = w || v;
            }
        } catch  {}
        let S = new Error(`simone: HTTP ${g.status} \u2014 ${v}`);
        throw S.status = g.status, S;
    }
    if (!g.body || typeof g.body.getReader != "function") {
        let v = await g.text();
        return n && n(v), {
            text: v,
            errors: []
        };
    }
    let h = g.body.getReader(), m = new TextDecoder, y = [], b = [], T = "";
    try {
        for(;;){
            let { done: v, value: S } = await h.read();
            if (v) break;
            T += m.decode(S, {
                stream: !0
            });
            let w = T.indexOf(`
`);
            for(; w !== -1;){
                let _ = T.slice(0, w).trim();
                if (T = T.slice(w + 1), _) {
                    let x = mtt(_);
                    if (x?.done) return {
                        text: y.join(""),
                        errors: b
                    };
                    let A = x?.chunk;
                    A?.delta && (y.push(A.delta), n && n(A.delta)), A?.error && b.push(A.error);
                }
                w = T.indexOf(`
`);
            }
        }
        return {
            text: y.join(""),
            errors: b
        };
    } finally{
        h.cancel().catch(()=>{});
    }
}
function g4(t, e = {}, n) {
    return zp(t, {
        ...e,
        path: Cb
    }, n);
}
function m4(t, e = {}, n) {
    return zp(t, {
        ...e,
        path: Rb
    }, n);
}
async function y4(t = {}) {
    let { baseUrl: e = Up, signal: n, headers: o } = t, r = await fetch(h4(e, Db), {
        method: "GET",
        headers: o,
        signal: n
    });
    if (!r.ok) throw new Error(`simone health: HTTP ${r.status}`);
    return r.json();
}
function _4({ system: t, history: e = [], user: n, context: o }) {
    let r = [];
    t && r.push({
        role: "system",
        content: t
    });
    for (let s of e)!s || !s.role || typeof s.content != "string" || !s.content || r.push({
        role: s.role,
        content: s.content
    });
    if (n) {
        let s = n;
        if (o != null) {
            let i = typeof o == "string" ? o : JSON.stringify(o, null, 2);
            s = `${s}

---
Context:
\`\`\`json
${i}
\`\`\``;
        }
        r.push({
            role: "user",
            content: s
        });
    }
    return r;
}
var S4 = /```(?<lang>[a-zA-Z0-9_+-]*)\n(?<code>[\s\S]*?)```/g, ytt = new Set([
    "component",
    "components",
    "page",
    "pages",
    "function",
    "method",
    "state",
    "theme",
    "color",
    "font",
    "icon"
]);
function _tt(t) {
    let e = [];
    for (let n of t.matchAll(S4))e.push({
        lang: (n.groups?.lang || "").toLowerCase(),
        code: n.groups?.code ?? ""
    });
    return e;
}
function btt(t) {
    return t.replace(S4, "").trim();
}
function VC(t) {
    if (!t || !/[{[]/.test(t)) return null;
    try {
        return JSON.parse(t);
    } catch  {}
    try {
        return JSON.parse(t.replace(/,\s*([}\]])/g, "$1"));
    } catch  {}
    return null;
}
function b4(t) {
    return !!t && typeof t == "object" && typeof t.type == "string" && ytt.has(t.type);
}
function w4(t) {
    let e = (typeof t == "string" ? t : "").trim();
    if (!e) return {
        kind: "text",
        text: "",
        message: ""
    };
    let n = _tt(e), o = n.filter((i)=>/^(js|javascript|ts|typescript|jsx|tsx)$/.test(i.lang)), r = n.filter((i)=>i.lang === "json"), s = btt(e);
    for (let i of r){
        let a = VC(i.code);
        if (b4(a)) return {
            kind: "asset",
            text: s || a.description || "",
            asset: a,
            message: a.description || s || `Generated ${a.type}: ${a.title || a.key || ""}`.trim()
        };
    }
    if (o.length > 0) {
        let i = o[0].code, a = VC("[" + i + "]");
        return Array.isArray(a) && a.length > 1 ? {
            kind: "multi",
            text: s,
            assets: a,
            code: i,
            message: s || `Generated ${a.length} items`
        } : {
            kind: "component",
            text: s,
            code: i,
            message: s || "Generated a component"
        };
    }
    if (e.startsWith("{")) {
        let i = VC(e);
        if (b4(i)) return {
            kind: "asset",
            text: i.description || "",
            asset: i,
            message: i.description || `Generated ${i.type}: ${i.title || i.key || ""}`.trim()
        };
    }
    return {
        kind: "text",
        text: e,
        message: e
    };
}
function x4(t) {
    if (!t) return {
        code_response: {
            type: "error",
            content: "Empty response from assistant"
        }
    };
    switch(t.kind){
        case "asset":
            return {
                code_response: {
                    type: "json_response",
                    data: t.asset
                }
            };
        case "multi":
            return {
                code_response: {
                    type: "symbols_component_code",
                    component_code: t.code
                }
            };
        case "component":
            return {
                code_response: {
                    type: "symbols_component_code",
                    component_code: t.code,
                    analysis_text: t.text
                }
            };
        default:
            return {
                code_response: {
                    type: "plain_text_response",
                    content: t.text || t.message || ""
                }
            };
    }
}
var k4 = [
    "You are Simone, the Symbols.app assistant.",
    "You help users build DOMQL v3 components, pages, and design-system entries.",
    'When the user asks for a component or page, return a single ```json fenced block whose body is one asset object with shape { type, key, title, description, value }. type is one of "component", "page", "function", "state", "color", "font", "icon", "theme".',
    "For multiple assets, return one ```js fenced block with comma-separated asset objects.",
    "For general questions, reply with prose only."
].join(" "), T4 = [
    "You are a DOMQL v3.14 code generator for the Symbols workspace.",
    "Output EXECUTABLE DOMQL v3.14 for the requested page(s)/component(s) \u2014 never a description, never a plan, never an explanation.",
    "Author data-first object schemas: child elements are UPPERCASE keys; styling lives in flat element props (NO attr/props/on wrappers); use design-system tokens (color/typography/spacing keys), never raw px/rem/hex/rgba; `extends` and `childExtends` are quoted strings; event handlers are flat (onClick, onInit) \u2014 never on:{} or props:{} wrappers.",
    "OUTPUT FORMAT \u2014 pick ONE:",
    "- SINGLE page/component: emit exactly one ```js fenced code block whose body is a single DOMQL object literal (an expression \u2014 start with `{`, no `export`, no variable assignment, no surrounding prose).",
    '- MULTIPLE pages/components: emit exactly one ```json fenced code block whose body is an object of the shape { "pages": { "PageKey": "<DOMQL object-literal source string>" }, "components": { "CompKey": "<DOMQL object-literal source string>" } }. Include only the sections you produce; each value is the DOMQL source for that key.',
    "Keys are PascalCase. Default to a single page unless the request clearly needs several distinct pages/components.",
    "Emit ONLY the single fenced block. No text before or after it."
].join(`
`), zC = {
    Starter: ds,
    Free: ds,
    Pro: "claude-opus-4-6"
};
function E4(t) {
    return t ? zC[t] || t : ds;
}
g_(ld);
u4(void 0, {
    smbls: KC,
    "@symbo-ls/simone-server": WC
});
d4(void 0, {
    "@symbo.ls/windows": ()=>({
            ...Zv,
            ...Kv
        }),
    "@symbo.ls/dropdown": ()=>({
            ...rO,
            ...iO
        })
});
HC();
var A4 = Symbol.for("smbls.serverUtils");

});
parcelRegister("kfQD7", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("kHC0J"))) : import("kHC0J")).then(()=>parcelRequire('7ODij'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("giSd8", function(module, exports) {

$parcel$export(module.exports, "DROPDOWN_DEFAULTS", () => $bde860e8a643d1f3$export$841025d611a98e9);
$parcel$export(module.exports, "openDropdown", () => $bde860e8a643d1f3$export$7b15a90e43f21cea);
$parcel$export(module.exports, "setDropdownInert", () => $bde860e8a643d1f3$export$bb72042877e61007);
$parcel$export(module.exports, "closeDropdown", () => $bde860e8a643d1f3$export$9772d2b5987ea925);
const $bde860e8a643d1f3$export$841025d611a98e9 = {
    placement: "auto",
    trigger: "click",
    offset: 8,
    minWidth: "180px",
    maxWidth: "90vw",
    maxHeight: null
}, $bde860e8a643d1f3$var$w = (o)=>{
    if (!o || typeof o.getBoundingClientRect != "function") return null;
    const n = o.getBoundingClientRect();
    return {
        left: n.left,
        top: n.top,
        right: n.right,
        bottom: n.bottom,
        width: n.width,
        height: n.height
    };
}, $bde860e8a643d1f3$var$h = (o)=>o?.getRoot?.()?.DropdownRoot || null;
let $bde860e8a643d1f3$var$m = 0;
const $bde860e8a643d1f3$var$g = ()=>`dropdown_${++$bde860e8a643d1f3$var$m}_${Date.now().toString(36)}`;
function $bde860e8a643d1f3$export$7b15a90e43f21cea(o = {}) {
    const n = $bde860e8a643d1f3$var$h(this);
    if (!n) return null;
    const e = o.anchorEl?.node || o.anchorEl, c = o.anchorRect || $bde860e8a643d1f3$var$w(e);
    if (!c) return null;
    const d = o.id || $bde860e8a643d1f3$var$g(), i = o.restoreEl?.node || o.restoreEl || e || (typeof document < "u" ? document.activeElement : null), t = {
        id: d,
        content: o.content || null,
        anchor: c,
        placement: o.placement || $bde860e8a643d1f3$export$841025d611a98e9.placement,
        trigger: o.trigger || $bde860e8a643d1f3$export$841025d611a98e9.trigger,
        offset: o.offset ?? $bde860e8a643d1f3$export$841025d611a98e9.offset,
        minWidth: o.minWidth || $bde860e8a643d1f3$export$841025d611a98e9.minWidth,
        maxWidth: o.maxWidth || $bde860e8a643d1f3$export$841025d611a98e9.maxWidth,
        maxHeight: o.maxHeight || $bde860e8a643d1f3$export$841025d611a98e9.maxHeight,
        theme: o.theme || null,
        shadow: o.shadow || null,
        background: o.background || null,
        round: o.round || null,
        role: o.role || null,
        ariaLabel: o.ariaLabel || null,
        ariaLabelledby: o.ariaLabelledby || null,
        focusIn: !!o.focusIn,
        onOpen: o.onOpen,
        onClose: o.onClose,
        restoreEl: i
    }, r = n.state?.layer;
    if (r?.onClose) try {
        r.onClose(r);
    } catch (a) {
        console.warn("[dropdown] prev onClose threw:", a);
    }
    if (n.state.update({
        layer: t
    }), typeof t.onOpen == "function") try {
        t.onOpen(t);
    } catch (a) {
        console.warn("[dropdown] onOpen threw:", a);
    }
    return d;
}
function $bde860e8a643d1f3$export$bb72042877e61007(o) {
    const n = $bde860e8a643d1f3$var$h(this);
    if (!n) return;
    const e = n.state?.layer;
    e && n.state.update({
        layer: {
            ...e,
            inert: !!o
        }
    });
}
function $bde860e8a643d1f3$export$9772d2b5987ea925(o) {
    const n = $bde860e8a643d1f3$var$h(this);
    if (!n) return;
    const e = n.state?.layer;
    if (!e) return;
    const c = typeof o == "string" ? o : o?.id;
    if (c && e.id && c !== e.id) return;
    const d = e.onClose, s = e.restoreEl, i = typeof document < "u" ? document : null, t = i ? i.activeElement : null, r = n.node?.querySelector?.('[data-smbls-dropdown="panel"]'), a = !t || t === i?.body, f = !!(r && t && r.contains(t)), p = a || f;
    if (n.state.update({
        layer: null
    }), p && s && typeof s.focus == "function") try {
        s.focus();
    } catch (u) {
        console.warn("[dropdown] focus restore threw:", u);
    }
    if (typeof d == "function") try {
        d(e);
    } catch (u) {
        console.warn("[dropdown] onClose threw:", u);
    }
}

});


parcelRegister("afwpn", function(module, exports) {

$parcel$export(module.exports, "DropdownTrigger", () => $776471b49b313215$export$e7eb525bc415b4b4);
const $776471b49b313215$var$t = (o)=>{
    const e = o?.getRoot?.()?.DropdownRoot?.state?.layer;
    if (e && o.dropdownId && e.id === o.dropdownId) {
        o.call("closeDropdown");
        return;
    }
    const n = {
        anchorEl: o,
        trigger: o.dropdownTrigger || "click",
        placement: o.dropdownPlacement || "auto",
        content: o.dropdownContent || null,
        minWidth: o.dropdownMinWidth,
        maxWidth: o.dropdownMaxWidth,
        maxHeight: o.dropdownMaxHeight,
        theme: o.dropdownTheme,
        offset: o.dropdownOffset,
        id: o.dropdownId,
        onOpen: o.onDropdownOpen,
        onClose: o.onDropdownClose
    };
    for(const d in n)n[d] === void 0 && delete n[d];
    o.call("openDropdown", n);
}, $776471b49b313215$export$e7eb525bc415b4b4 = {
    position: "relative",
    onClick: (o, r)=>{
        (r.dropdownTrigger || "click") === "click" && (o.preventDefault(), o.stopPropagation(), $776471b49b313215$var$t(r));
    },
    onFocus: (o, r)=>{
        r.dropdownTrigger === "focus" && $776471b49b313215$var$t(r);
    },
    onMouseenter: (o, r)=>{
        r.dropdownTrigger === "hover" && (r._hoverTimer && clearTimeout(r._hoverTimer), r._hoverTimer = setTimeout(()=>$776471b49b313215$var$t(r), 120));
    },
    onMouseleave: (o, r)=>{
        r.dropdownTrigger === "hover" && (r._hoverTimer && (clearTimeout(r._hoverTimer), r._hoverTimer = null), r._closeTimer = setTimeout(()=>r.call("closeDropdown"), 250));
    }
};

});

parcelRegister("b1KVm", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $80742fd8ebdd19bd$export$931cbfb6bfb85fc);
$parcel$export(module.exports, "DropdownList", () => $80742fd8ebdd19bd$export$e40cc1c58d22b809);
$parcel$export(module.exports, "DropdownParent", () => $80742fd8ebdd19bd$export$b162207c9836937);
$parcel$export(module.exports, "DropdownParentFocus", () => $80742fd8ebdd19bd$export$89c2e92edc22fd8f);
$parcel$export(module.exports, "DropdownSiblingFocus", () => $80742fd8ebdd19bd$export$60701cc380f56748);
const $80742fd8ebdd19bd$export$931cbfb6bfb85fc = {
    extends: "smbls.Dropdown"
}, $80742fd8ebdd19bd$export$e40cc1c58d22b809 = {
    extends: "smbls.DropdownList"
}, $80742fd8ebdd19bd$export$b162207c9836937 = {
    extends: "smbls.DropdownParent"
}, $80742fd8ebdd19bd$export$89c2e92edc22fd8f = {
    extends: "smbls.DropdownParentFocus"
}, $80742fd8ebdd19bd$export$60701cc380f56748 = {
    extends: "smbls.DropdownSiblingFocus"
};

});


parcelRegister("eKLwk", function(module, exports) {

$parcel$export(module.exports, "dropdownFunctions", () => $abda391f73516059$export$f64b614a274e6f48);
$parcel$export(module.exports, "DROPDOWN_DEFAULTS", () => (parcelRequire("giSd8")).DROPDOWN_DEFAULTS);
$parcel$export(module.exports, "closeDropdown", () => (parcelRequire("giSd8")).closeDropdown);
$parcel$export(module.exports, "computePosition", () => (parcelRequire("f39o3")).computePosition);
$parcel$export(module.exports, "fadeInTransform", () => (parcelRequire("f39o3")).fadeInTransform);
$parcel$export(module.exports, "openDropdown", () => (parcelRequire("giSd8")).openDropdown);
$parcel$export(module.exports, "setDropdownInert", () => (parcelRequire("giSd8")).setDropdownInert);

var $giSd8 = parcelRequire("giSd8");

var $f39o3 = parcelRequire("f39o3");
const $abda391f73516059$export$f64b614a274e6f48 = {
    openDropdown: (0, $giSd8.openDropdown),
    closeDropdown: (0, $giSd8.closeDropdown),
    setDropdownInert: (0, $giSd8.setDropdownInert)
};

});


parcelRegister("98BVX", function(module, exports) {

$parcel$export(module.exports, "fetchNpmPackage", () => $6a724941479aacbc$export$42279cf855f851c7);
const $6a724941479aacbc$export$42279cf855f851c7 = async function fetchNpmPackage(name, schemaVersion) {
    await window.fetch(`https://registry.npmjs.com/-/v1/search?text=${name}@${schemaVersion}&size=1`).then(async (res)=>{
        const { objects: objects } = await res.json();
        const [pkg] = objects || [];
        if (!pkg) return;
        const { name: pkgName, version: pkgVersion } = pkg;
        if (pkgName === this.state.name) this.state.replace({
            name: pkgName,
            version: pkgVersion,
            schemaVersion: schemaVersion
        });
    }).catch(()=>{
        if (name === this.state.name) this.state.replace({
            version: null,
            isLoadingPackages: false
        });
    });
};

});

parcelRegister("3H5Xg", function(module, exports) {

$parcel$export(module.exports, "resolveScope", () => (parcelRequire("90sUK")).resolveScope);
// Re-exports the integration scope resolver as a project-registered
// function so any page can pick it up via `el.call('resolveScope', ...)`
// without a file import.
//
// Reads { scopeType, scopeId } off an integration draft state, supplying
// defaults. Used by every integration configure form (governance admin
// pages + marketplace install flow) so scope handling stays centralized.

var $90sUK = parcelRequire("90sUK");

});

parcelRegister("422uJ", function(module, exports) {

$parcel$export(module.exports, "reloadIntegrationHub", () => $2ef948bbd5321400$export$f0dbdf3dafb604f3);
// Registered function — host pages expose this so the shared
// configure form can trigger a catalogue refresh after save / delete.
//
// Default implementation: re-fetch `loadIntegrationCatalogue(orgId)` and
// write the result onto `root._integrationHub`. Pages that need custom
// reload logic can override by redefining the function in their own
// functions/ directory.

var $2hTF2 = parcelRequire("2hTF2");
const $2ef948bbd5321400$export$f0dbdf3dafb604f3 = async function() {
    const root = this?.state?.root || this;
    if (!root) return;
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return;
    try {
        const data = await (0, $2hTF2.loadIntegrationCatalogue)(orgId);
        root.update({
            _integrationHub: data
        });
    } catch  {
    // Silent fail — existing state keeps rendering.
    }
};

});

parcelRegister("8ERrM", function(module, exports) {

$parcel$export(module.exports, "openProjectDomainFlow", () => $64db849ff70ba769$export$f46bf919b47921f6);
// Publish panel → Infra canvas hand-off for custom domains.
//
// The "Custom domain" / "Find your domain" rows in Dropdown.Envs advertised
// the feature but had no handler — the legacy /add-domain + /add-cname modals
// they once pointed at are unrouted, and the second one never persisted
// anything. The REAL flow is the Infra canvas's connect-domain modal
// (infra/components/InfraDomainModal.js, driven by root.infra.domainFlow):
// check DNS → connect → status poll. This hands off to it — park the intent
// on the shell root, route to /infra, and `infraInit`
// (infra/functions/index.js) lifts it into root.infra.domainFlow on mount,
// pre-scoped to the project this canvas is editing.
//
// A root-state hand-off rather than a query string: both pages live in the
// one shell SPA (canvas's route map is merged into workspace's), and
// infraInit re-seeds root.infra WHOLESALE on every mount — anything written
// straight onto root.infra.domainFlow would be wiped before the modal reads
// it. `_infraIntent` follows the shell's underscore convention for transient
// root flags (_canvasSlot, _versionsOpen) and is consumed once.
//
// `this` is the calling element (`el.call('openProjectDomainFlow', opts)`).
// No module-scope helpers — the body must survive frank's per-function
// serialization with only `this` and its argument in reach.
const $64db849ff70ba769$export$f46bf919b47921f6 = function(opts) {
    const options = opts && typeof opts === 'object' ? opts : {};
    const root = this.getRootState() || {};
    // Starter tier: the row shows the Upgrade link instead of the arrow, and a
    // click on the card lands on pricing — the same target as that link.
    if (root.tier === 'starter') return this.call('openRouterModal', '/settings', {
        key: '/pricing'
    });
    const projectId = String(options.projectId || root.projectId || root.data && (root.data._id || root.data.id) || '');
    const step = options.step === 'new' ? 'new' : 'link';
    const envKey = typeof options.envKey === 'string' && options.envKey ? options.envKey : 'production';
    if (typeof root.update === 'function') root.update({
        _infraIntent: {
            domainFlow: {
                step: step,
                phase: 'idle',
                host: '',
                projectId: projectId,
                envKey: envKey
            }
        }
    });
    this.router('/infra', this.getRoot());
};

});

parcelRegister("bW43f", function(module, exports) {

$parcel$export(module.exports, "SIMPLEICONS_404", () => $8b0841082860ae65$export$51fdc4c3fcec3f69);
$parcel$export(module.exports, "sanitiseIconSlug", () => $8b0841082860ae65$export$fa7b7a36a21c8db);
// Simpleicons slugs that return HTTP 404 on cdn.simpleicons.org (trademark
// removals or slugs that never existed). Single source of truth — both the
// marketplace catalogue merger and the canvas integration data-processing
// helpers consume this. Any DB `icon` value in this set is treated as
// absent so the letter-initials chip / glyph renders instead of a broken
// <img>.
const $8b0841082860ae65$export$51fdc4c3fcec3f69 = new Set([
    'amazonwebservices',
    'amazons3',
    'openai',
    'slack',
    'twilio',
    'sendgrid',
    'segment',
    'linkedin',
    'workos',
    'pinecone',
    'logrocket',
    'uploadthing',
    'server',
    'mic',
    'database',
    'ai' // generic name, not in simpleicons (openai placeholder)
]);
const $8b0841082860ae65$export$fa7b7a36a21c8db = (raw)=>{
    if (!raw || raw === 'undefined' || raw === 'null') return null;
    return $8b0841082860ae65$export$51fdc4c3fcec3f69.has(raw) ? null : raw;
};

});

parcelRegister("l32Xg", function(module, exports) {

$parcel$export(module.exports, "profilePath", () => $f52c2b945d278c39$export$d829512685ba9335);
// Build the `/profile?u=<email>` URL for navigating to another user's
// profile page. Coerces `undefined`/`null` to '' so callers don't have
// to guard the input — `encodeURIComponent('')` yields ''.
// Use via `el.call('profilePath', email)` to keep the encoding choice
// (encodeURIComponent vs raw) in one place; if profile URLs switch
// to a different shape (e.g. /users/:slug), every consumer follows.
const $f52c2b945d278c39$export$d829512685ba9335 = (email)=>`/profile?u=${encodeURIComponent(email || '')}`;

});

parcelRegister("8SWNA", function(module, exports) {

$parcel$export(module.exports, "cycleTheme", () => $6780fa1168086301$export$9d02a5ff7df7acb6);
$parcel$export(module.exports, "labelForTheme", () => $6780fa1168086301$export$f33f1f3002f3399c);
$parcel$export(module.exports, "iconForTheme", () => $6780fa1168086301$export$fdca4cdddec310be);
// Shared theme-cycle helpers used by both ThemeToggle (compact icon
// button) and AppHeader.ThemeItem (verbose menu row). Single source of
// truth for `auto → light → dark → auto` ordering and the side-effects:
// reactive state update + localStorage persistence. The framework's
// `changeGlobalTheme` (registered via shared/functions/index.js) is NOT
// called here — the caller invokes it via `el.call('changeGlobalTheme', mode)`
// so this helper stays a plain function with no DOMQL dependency.
//
// Why two surfaces share this: previously ThemeToggle.js and
// AppHeader.ThemeItem each open-coded the same `MODES.indexOf(current) + 1`
// arithmetic + the same localStorage write. Drift was already starting —
// ThemeItem used `s.root.themeMode = next` (direct assignment), ThemeToggle
// did the same but also wrote to localStorage twice. Centralising kills
// the drift.

var $3gQso = parcelRequire("3gQso");
const $6780fa1168086301$export$9d02a5ff7df7acb6 = (root)=>{
    const next = (0, $3gQso.cycleThemeMode)(root?.themeMode);
    if (root) root.themeMode = next;
    return (0, $3gQso.writeStoredThemeMode)(next);
};
const $6780fa1168086301$export$f33f1f3002f3399c = function(mode) {
    const m = mode || 'auto';
    const name = m === 'light' ? this.call('polyglot', 'shell.theme.mode.light') : m === 'dark' ? this.call('polyglot', 'shell.theme.mode.dark') : this.call('polyglot', 'shell.theme.mode.auto');
    return this.call('polyglot', 'shell.theme.label').replace('{mode}', name);
};
const $6780fa1168086301$export$fdca4cdddec310be = (mode)=>{
    if (mode === 'light') return 'sun';
    if (mode === 'dark') return 'moon';
    return 'theme' // auto
    ;
};

});
parcelRegister("3gQso", function(module, exports) {

$parcel$export(module.exports, "THEME_MODES", () => $261b8e8dc9d760f5$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "normalizeThemeMode", () => $261b8e8dc9d760f5$export$2d22672f3870b464);
$parcel$export(module.exports, "readStoredThemeMode", () => $261b8e8dc9d760f5$export$ded11c5f8efd57d4);
$parcel$export(module.exports, "writeStoredThemeMode", () => $261b8e8dc9d760f5$export$f044f86961c0d973);
$parcel$export(module.exports, "cycleThemeMode", () => $261b8e8dc9d760f5$export$35757a97f0e60f6b);
$parcel$export(module.exports, "persistThemeModeToUser", () => $261b8e8dc9d760f5$export$b93e2e416ebf4114);
$parcel$export(module.exports, "reconcileThemeModeFromPrefs", () => $261b8e8dc9d760f5$export$2c42413b4b0624a4);
$parcel$export(module.exports, "readTenantBootThemeMode", () => $261b8e8dc9d760f5$export$8d19529f397854de);
$parcel$export(module.exports, "hasNoStoredThemeMode", () => $261b8e8dc9d760f5$export$ad0e293aa325f8c4);
$parcel$export(module.exports, "resolveBootThemeMode", () => $261b8e8dc9d760f5$export$c360fbf90fa05832);
$parcel$export(module.exports, "resolveWorkspaceThemeMode", () => $261b8e8dc9d760f5$export$32cb156af8f9d868);
$parcel$export(module.exports, "userHasOwnThemeChoice", () => $261b8e8dc9d760f5$export$65cac7cbb4a015d6);
$parcel$export(module.exports, "workspaceThemeModeOf", () => $261b8e8dc9d760f5$export$5be29b0f8a92cf45);
$parcel$export(module.exports, "bootTenantThemeMode", () => $261b8e8dc9d760f5$export$71e83f8d75e40c33);
// FA204/FA207 / frank trap — THEME_MODES (a module-scope/sibling-export
// table) and normalizeThemeMode (a sibling-export function) are read bare by
// every other export below; both are unresolvable once this file's exports
// are individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers; readerVoice.js precedent). Every
// consumer below carries a self-contained local copy. THEME_MODES stays
// exported too — cross-file consumers (bootShell.js, cycleTheme.js,
// workspace/wireGlobalListeners.js) resolve it via a normal ESM import,
// unaffected by frank.
const $261b8e8dc9d760f5$export$6ba72c8346b4c57e = [
    'auto',
    'light',
    'dark'
];
const $261b8e8dc9d760f5$export$2d22672f3870b464 = (mode)=>{
    const modes = [
        'auto',
        'light',
        'dark'
    ];
    return modes.includes(mode) ? mode : 'auto';
};
const $261b8e8dc9d760f5$export$ded11c5f8efd57d4 = (storage = globalThis.localStorage)=>{
    const modes = [
        'auto',
        'light',
        'dark'
    ];
    const normalize = (mode)=>modes.includes(mode) ? mode : 'auto';
    try {
        return normalize(storage?.getItem?.('themeMode'));
    } catch (_) {
        return 'auto';
    }
};
const $261b8e8dc9d760f5$export$f044f86961c0d973 = (mode, storage = globalThis.localStorage)=>{
    const modes = [
        'auto',
        'light',
        'dark'
    ];
    const normalized = modes.includes(mode) ? mode : 'auto';
    try {
        storage?.setItem?.('themeMode', normalized);
    } catch (_) {}
    return normalized;
};
const $261b8e8dc9d760f5$export$35757a97f0e60f6b = (mode)=>{
    const modes = [
        'auto',
        'light',
        'dark'
    ];
    const current = modes.includes(mode) ? mode : 'auto';
    const index = modes.indexOf(current);
    return modes[(index + 1) % modes.length];
};
const $261b8e8dc9d760f5$export$b93e2e416ebf4114 = async (root, sdk, mode)=>{
    const modes = [
        'auto',
        'light',
        'dark'
    ];
    const normalized = modes.includes(mode) ? mode : 'auto';
    if (!root || !sdk || typeof sdk.execute !== 'function') return normalized;
    const prev = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : {};
    if (prev.themeMode === normalized) return normalized;
    const next = {
        ...prev,
        themeMode: normalized
    };
    if (typeof root.update === 'function') root.update({
        userPrefs: next
    }, {
        preventFetch: true
    });
    else root.userPrefs = next;
    try {
        await sdk.execute('workspaceProject.userPreferences', 'update', {
            payload: next
        });
    } catch (e) {
        console.warn('[themeMode] user_preferences themeMode save failed', e);
    }
    return normalized;
};
const $261b8e8dc9d760f5$export$2c42413b4b0624a4 = (currentMode, prefs, storedMode, tenantMode)=>{
    const modes = [
        'auto',
        'light',
        'dark'
    ];
    const norm = (m)=>modes.includes(m) ? m : null;
    const recorded = norm(prefs && typeof prefs === 'object' ? prefs.themeMode : null);
    const current = norm(currentMode) || 'auto';
    if (recorded) {
        // ⚠️ A RECORDED 'auto' IS NOT AN EXPLICIT CHOICE. The account row carries
        // 'auto' for everyone who never picked a theme, and this function cannot
        // tell that apart from a deliberate "follow my OS" — the same ambiguity
        // this file's header already warns about for the LOCAL key.
        //
        // Without this branch the row that means "no preference" actively UNDID
        // the tenant default: boot seeded light for the workspace, this reconcile
        // saw recorded 'auto' !== current 'light', returned { apply: 'auto' }, and
        // `changeGlobalTheme('auto')` then stamped `data-theme` from the OS.
        // Measured on app.bellforge.eu with the OS in dark: the surface painted
        // light while `data-theme` read "dark" at 9.7s and 20.3s, and even an
        // explicit `?globalTheme=light` was overridden. So a tenant default could
        // never survive first paint on any dark-OS machine.
        //
        // Precedence, unchanged in spirit and now actually enforced:
        //   explicit light/dark  >  tenant default  >  'auto' / the OS.
        // An explicit light or dark still wins here, which is what keeps a user
        // who really chose a theme in control of their own account.
        if (recorded === 'auto' && (tenantMode === 'light' || tenantMode === 'dark')) return null;
        return recorded !== current ? {
            apply: recorded
        } : null;
    }
    const local = norm(storedMode);
    if (local && local !== 'auto') return {
        migrate: local
    };
    return null;
};
const $261b8e8dc9d760f5$export$8d19529f397854de = (win = typeof window !== 'undefined' ? window : null)=>{
    try {
        const store = win && win.localStorage;
        const host = win && win.location ? win.location.hostname : '';
        if (!store || !host) return null;
        const raw = store.getItem('wlBoot:' + host);
        const parsed = raw ? JSON.parse(raw) : null;
        const mode = parsed && parsed.theme;
        return mode === 'light' || mode === 'dark' ? mode : null;
    } catch (_) {
        return null;
    }
};
const $261b8e8dc9d760f5$export$ad0e293aa325f8c4 = (storage = globalThis.localStorage)=>{
    // null = "cannot determine" (storage missing or getItem threw) — kept
    // distinct from `true` (raw key genuinely absent) on purpose: a caller
    // must not let "cannot read the raw key" fall into the waiting branch by
    // default (WS-THEME-BOOT-WRONG-MODE-1 condition 2). Only a literal `true`
    // may trigger the bounded wait below.
    if (!storage || typeof storage.getItem !== 'function') return null;
    try {
        return storage.getItem('themeMode') == null;
    } catch (_) {
        return null;
    }
};
const $261b8e8dc9d760f5$export$c360fbf90fa05832 = async ({ themeMode: themeMode, rawKeyAbsent: rawKeyAbsent, sdk: sdk, signedIn: signedIn, timeoutMs: timeoutMs = 300, storage: storage = globalThis.localStorage })=>{
    if (!rawKeyAbsent || !sdk || typeof sdk.execute !== 'function') return {
        mode: themeMode,
        waited: false
    };
    // SIGNED-OUT GUARD (measured on app.bellforge.eu 2026-09-01). `/core/prefs/user`
    // is an AUTHED endpoint. On the /login screen there is no session, so this
    // pre-flight asked it anyway and took a 401 — once per cold boot, in a
    // network trace of 212 responses it was the only one — and then paid the
    // race timeout for an answer that could never arrive. A signed-out visitor
    // has no stored preference to fetch, so the whole pre-flight is dead work.
    // `signedIn` is the CALLER's verdict and only an explicit `false` skips:
    // every existing caller and test that omits it keeps today's behaviour, and
    // a wrong `false` costs nothing but the OS guess that the timeout arm
    // already returns (the `_prefsChain` correction in loadPrivateData.js stays
    // the safety net either way).
    if (signedIn === false) return {
        mode: themeMode,
        waited: false,
        signedOut: true
    };
    // Frank note (this file's rule): the decision is the SAME as
    // reconcileThemeModeFromPrefs(themeMode, prefs, themeMode) — inlined
    // rather than called, because a bare sibling-export read is an
    // unresolvable free identifier once this file's exports are individually
    // frank.toJSON'd (it would throw into the catch below and silently report
    // `errored: true` on every platform-delivered consumer). With stored ===
    // current the migrate branch can never fire, so only `apply` is modelled.
    // Same rule for the hint reader/writer below: inlined, never a sibling call.
    const modes = [
        'auto',
        'light',
        'dark'
    ];
    const norm = (m)=>modes.includes(m) ? m : null;
    const HINT_KEY = 'themeMode:serverHint';
    const readHint = ()=>{
        try {
            const raw = storage?.getItem?.(HINT_KEY);
            return raw === 'none' ? 'none' : norm(raw);
        } catch (_) {
            return null;
        }
    };
    const writeHint = (value)=>{
        try {
            storage?.setItem?.(HINT_KEY, value);
        } catch (_) {}
    };
    const hintOf = (prefs)=>norm(prefs && typeof prefs === 'object' ? prefs.themeMode : null) || 'none';
    const current = norm(themeMode) || 'auto';
    const TIMED_OUT = Symbol('themeBootPrefsTimeout');
    // Fast path — a cached server answer means NO wait at all.
    const hint = readHint();
    if (hint) {
        try {
            Promise.resolve(sdk.execute('workspaceProject.userPreferences', 'get')).then((prefs)=>writeHint(hintOf(prefs))).catch(()=>{});
        } catch (_) {}
        if (hint !== 'none' && hint !== current) return {
            mode: hint,
            waited: false,
            applied: true,
            fromHint: true
        };
        return {
            mode: themeMode,
            waited: false,
            applied: false,
            fromHint: true
        };
    }
    // First boot on this device — the bounded race, unchanged, plus the hint write.
    let pending;
    try {
        pending = Promise.resolve(sdk.execute('workspaceProject.userPreferences', 'get'));
    } catch (_) {
        return {
            mode: themeMode,
            waited: true,
            errored: true
        };
    }
    // Runs even when the timer wins the race, so the NEXT boot pays nothing.
    pending.then((prefs)=>writeHint(hintOf(prefs))).catch(()=>{});
    try {
        const prefs = await Promise.race([
            pending,
            new Promise((resolve)=>setTimeout(()=>resolve(TIMED_OUT), timeoutMs))
        ]);
        if (prefs === TIMED_OUT) return {
            mode: themeMode,
            waited: true,
            timedOut: true
        };
        const recorded = norm(prefs && typeof prefs === 'object' ? prefs.themeMode : null);
        if (recorded && recorded !== current) return {
            mode: recorded,
            waited: true,
            applied: true
        };
        return {
            mode: themeMode,
            waited: true,
            applied: false
        };
    } catch (_) {
        return {
            mode: themeMode,
            waited: true,
            errored: true
        };
    }
};
const $261b8e8dc9d760f5$export$32cb156af8f9d868 = ({ userChoseExplicitly: userChoseExplicitly, workspaceMode: workspaceMode, appliedWorkspaceMode: appliedWorkspaceMode } = {})=>{
    const wsMode = workspaceMode === 'light' || workspaceMode === 'dark' ? workspaceMode : null;
    const applied = appliedWorkspaceMode === 'light' || appliedWorkspaceMode === 'dark' ? appliedWorkspaceMode : null;
    // The user's own choice always wins — including an explicit 'auto'.
    if (userChoseExplicitly) return applied ? {
        revert: true
    } : null;
    if (wsMode) return wsMode === applied ? null : {
        apply: wsMode
    };
    return applied ? {
        revert: true
    } : null;
};
const $261b8e8dc9d760f5$export$65cac7cbb4a015d6 = ({ rawStoredKeyAbsent: rawStoredKeyAbsent, userRecordMode: userRecordMode } = {})=>{
    const recorded = userRecordMode === 'auto' || userRecordMode === 'light' || userRecordMode === 'dark';
    if (recorded) return true;
    return rawStoredKeyAbsent !== true;
};
const $261b8e8dc9d760f5$export$5be29b0f8a92cf45 = (workspace)=>{
    const settings = workspace && typeof workspace === 'object' ? workspace.settings : null;
    const theme = settings && typeof settings === 'object' ? settings.theme : null;
    const mode = theme && typeof theme === 'object' ? theme.mode : theme;
    return mode === 'light' || mode === 'dark' ? mode : null;
};
const $261b8e8dc9d760f5$export$71e83f8d75e40c33 = ({ baseMode: baseMode, userChoseExplicitly: userChoseExplicitly, workspaceMode: workspaceMode, brandMode: brandMode } = {})=>{
    const pick = (m)=>m === 'light' || m === 'dark' ? m : null;
    const base = [
        'auto',
        'light',
        'dark'
    ].includes(baseMode) ? baseMode : 'auto';
    if (userChoseExplicitly) return base;
    return pick(workspaceMode) || pick(brandMode) || base;
};

});


parcelRegister("cL2Gr", function(module, exports) {

$parcel$export(module.exports, "sameOriginTop", () => $949bf4b6d91ab67c$export$eba84fbb0d49c233);
// Returns the topmost same-origin ancestor window.
// Standalone app → window.top. Cross-origin embed → the topmost window
// still accessible without triggering SecurityError. Returns null in non-browser.
const $949bf4b6d91ab67c$export$eba84fbb0d49c233 = ()=>{
    if (typeof window === 'undefined') return null;
    let w = window;
    while(w.parent && w.parent !== w)try {
        w.parent.document;
        w = w.parent;
    } catch  {
        break;
    }
    return w;
};

});

parcelRegister("eviUK", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $a8f2a1f202c43d0c$export$a5575dbeeffdad98);
const $a8f2a1f202c43d0c$export$a5575dbeeffdad98 = async function uploadFile(contents) {
    try {
        const splitName = contents.name.split('.');
        const format = splitName[splitName.length - 1];
        if (!this.call('validateFormat', format)) {
            this.state.update({
                errorMessage: `Not allowed file type: ${format}`
            });
            return;
        }
        const res = await this.sdk.uploadFile(contents);
        this.state.replace({
            key: this.state.key || contents.name,
            content: res,
            format: format
        });
    } catch (error) {
        this.call('openNotification', {
            title: this.call('polyglot', 'editor.addComponent.error.title'),
            message: `${error.message}`,
            type: 'error'
        });
    }
};

});

parcelRegister("3jSgq", function(module, exports) {

$parcel$export(module.exports, "getLastLocationPath", () => $26ad3d1b6854ab98$export$fc729c47e81baa99);
const $26ad3d1b6854ab98$export$fc729c47e81baa99 = function getLastLocationPath(level = 0, route = window.location.pathname) {
    const routeArray = route.split('/');
    const activeRoute = routeArray[routeArray.length - level - 1];
    if (activeRoute) return `/${activeRoute}`;
};

});

parcelRegister("bwohf", function(module, exports) {

$parcel$export(module.exports, "changeGlobalTheme", () => $863583d382e220a0$export$204c4d227c4ac61c);
// el.call('changeGlobalTheme', 'light' | 'dark' | 'auto') — the framework's
// theme switch, registered ONCE, here. Every theme control calls it through
// el.call: shared's ThemeToggle and account menu, the shell's MeMenu / home
// look / the assistant's set_theme tool, canvas's voice command. The shell and
// the marketplace each used to register their own copy under this name; in a
// catalog that merges them the order picked one.
//
// A static import, not `await import('smbls')`: frank resolves a static
// framework import through the framework package registry, so the serialized
// function works on a published page without a browser import map (pinned by
// marketplace/functions/sharedChangeGlobalTheme.test.js). shared already imports smbls statically
// (setLang.js), so this adds nothing to any bundle.

var $eY4Ct = parcelRequire("eY4Ct");
function $863583d382e220a0$export$204c4d227c4ac61c(...args) {
    return (0, $eY4Ct.changeGlobalTheme)(...args);
}

});

parcelRegister("5qaoL", function(module, exports) {

$parcel$export(module.exports, "sendPrompt", () => $3f27726177116bee$export$738cd2174f2d30ef);
$parcel$export(module.exports, "newSession", () => $3f27726177116bee$export$43c80672febddad8);
$parcel$export(module.exports, "switchSession", () => $3f27726177116bee$export$e3a071b49e0dcae8);
$parcel$export(module.exports, "deleteSession", () => $3f27726177116bee$export$f3b72123251cadf);
$parcel$export(module.exports, "hydrateServerSessions", () => $3f27726177116bee$export$c3fece5592184181);
$parcel$export(module.exports, "restoreActiveThread", () => $3f27726177116bee$export$d728b55666a2b84e);
$parcel$export(module.exports, "buildAiAwareness", () => $3f27726177116bee$export$cdaa13c6395ddfd1);
// The assistant's session surface — ONE owner per name, in shared.
//
// ONE SHELL ASSISTANT (Nika, 2026-10-03): the shell has one assistant and one
// chat list on every page; preview standalone keeps its own. Shared's Chat /
// SessionMenu / AiContextBar / VoiceOverlay call these names on every host
// (`el.call('sendPrompt', …)`), and two hosts implement them: the shell and
// preview. They share one bag — the shell spreads preview's functions into
// its own context and folds preview's full context on /preview, and the
// workspace-ui catalog merges both libraries — so a host registering the bare
// name meant the merge order picked the assistant.
//
// So shared registers each name here, and each host registers its
// implementation under its own prefix (`shellSendPrompt`, `previewSendPrompt`,
// …). The dispatcher answers with the SHELL's implementation whenever it is in
// the calling element's bag, else preview's: that is exactly the product rule
// (inside the shell the shell's assistant owns every page; preview standalone
// has no shell). Call sites never change.
//
// Contract: `this` stays the calling element, every argument passes, the
// implementation's return value (a promise for the async ones) returns
// unchanged. A host that misses a name is a hard error, never a silent no-op:
// console.error, and a rejected promise for the async names. The one
// synchronous name, buildAiAwareness (read during render), returns undefined
// after the console.error — the same value an unregistered el.call returns —
// because a promise in its place throws inside every render that reads it.
//
// A page with NO host at all is not a wiring bug. A site can link the shared
// library for its components and have no assistant session: the docs site
// links system/shared, mounts its own chat with its own sendPrompt, and has
// no shell or preview implementation of any name. Its chat calls
// hydrateServerSessions on mount, and the hard error was an uncaught page
// error on every docs page (2026-10-28). There is nothing to load or act on
// there, so every name answers quietly: the async names resolve undefined,
// buildAiAwareness returns undefined, nothing reaches the console.
// Kept self-contained (no module-scope reads) so frank serializes it whole.
const $3f27726177116bee$var$_aiSessionDispatch = (el, name, args, sync)=>{
    const fns = el && el.context && el.context.functions || {};
    const hosts = [
        'shell',
        'preview'
    ];
    const suffix = name.charAt(0).toUpperCase() + name.slice(1);
    for (const host of hosts){
        const impl = fns[host + suffix];
        if (typeof impl === 'function') return impl.apply(el, args);
    }
    // A host is in the bag when it registered any of the seven names below
    // (the names this module exports, as their prefixed suffix).
    const suffixes = [
        'SendPrompt',
        'NewSession',
        'SwitchSession',
        'DeleteSession',
        'HydrateServerSessions',
        'RestoreActiveThread',
        'BuildAiAwareness'
    ];
    const hosted = hosts.some((host)=>suffixes.some((s)=>typeof fns[host + s] === 'function'));
    if (!hosted) return sync ? undefined : Promise.resolve();
    const error = new Error(`[aiSession] no host implements ${name} (looked for shell${suffix}, preview${suffix})`);
    console.error(error.message);
    return sync ? undefined : Promise.reject(error);
};
const $3f27726177116bee$export$738cd2174f2d30ef = function(...args) {
    return $3f27726177116bee$var$_aiSessionDispatch(this, 'sendPrompt', args);
};
const $3f27726177116bee$export$43c80672febddad8 = function(...args) {
    return $3f27726177116bee$var$_aiSessionDispatch(this, 'newSession', args);
};
const $3f27726177116bee$export$e3a071b49e0dcae8 = function(...args) {
    return $3f27726177116bee$var$_aiSessionDispatch(this, 'switchSession', args);
};
const $3f27726177116bee$export$f3b72123251cadf = function(...args) {
    return $3f27726177116bee$var$_aiSessionDispatch(this, 'deleteSession', args);
};
const $3f27726177116bee$export$c3fece5592184181 = function(...args) {
    return $3f27726177116bee$var$_aiSessionDispatch(this, 'hydrateServerSessions', args);
};
const $3f27726177116bee$export$d728b55666a2b84e = function(...args) {
    return $3f27726177116bee$var$_aiSessionDispatch(this, 'restoreActiveThread', args);
};
const $3f27726177116bee$export$cdaa13c6395ddfd1 = function(...args) {
    return $3f27726177116bee$var$_aiSessionDispatch(this, 'buildAiAwareness', args, true);
};

});

parcelRegister("iWt3l", function(module, exports) {

$parcel$export(module.exports, "applyDesignSystemSummaryCollection", () => $dca42e157d104c95$export$e07ddcbb10f12ba);
const $dca42e157d104c95$export$e07ddcbb10f12ba = function applyDesignSystemSummaryCollection() {
    // `getDesignSystem()` with no argument answers whatever is stored — which
    // is nothing at all in a host that never loaded a project. The empty path
    // below (`if (!s) return`) was written for exactly this case; it was just
    // entered one line too late.
    const dataDesignSystem = this.getDesignSystem() || {};
    const s = dataDesignSystem.color ? dataDesignSystem : this.context?.designSystem;
    if (!s) return;
    const { color: color, theme: theme, typography: typography, font: font, fontFamily: fontFamily, spacing: spacing, icons: icons, timing: timing, cases: cases, GRIDS: GRIDS, media: media, devices: devices } = s;
    if (!color) return;
    return [
        {
            icon: 'colorOutline',
            href: '/color',
            iconTheme: 'theme',
            title: 'colors',
            paragraph: 'Theming of an entire app',
            iconBackground: 'red',
            properties: [
                {
                    property: 'Colors',
                    value: color && Object.keys(color).length
                },
                {
                    property: 'Themes',
                    value: theme && Object.keys(theme).length
                }
            ]
        },
        {
            icon: 'typographyOutline',
            href: '/typography',
            iconTheme: 'typography',
            title: 'typography',
            paragraph: 'Style a typed material',
            properties: [
                {
                    property: 'Base size',
                    value: typography && typography.base + 'px'
                },
                {
                    property: 'Ratio',
                    value: typography && typography.ratio
                },
                {
                    property: 'Styles',
                    value: typography && typography.styles && Object.keys(typography.styles).length
                }
            ]
        },
        {
            icon: 'spaceOutline',
            href: '/spacing',
            iconTheme: 'space',
            title: 'Spacing',
            paragraph: 'Manage sizing properties of a space',
            properties: [
                {
                    property: 'Ratio',
                    value: spacing && spacing.ratio
                },
                {
                    property: 'Templates',
                    value: 'TBA'
                }
            ]
        },
        {
            icon: 'shape',
            href: '/shape',
            iconTheme: 'shape',
            title: 'shapes',
            paragraph: 'Design an outline to a chosen component',
            properties: [
                {
                    property: 'HTML',
                    value: '32'
                },
                {
                    property: 'SVG',
                    value: 'TBA'
                }
            ]
        },
        {
            icon: 'iconsOutline',
            href: '/icons',
            iconTheme: 'color',
            title: 'Icons',
            paragraph: 'Label a role of subject with glyphs',
            properties: [
                {
                    property: 'All',
                    value: icons && Object.keys(icons).length
                },
                {
                    property: 'Fill',
                    value: icons && Object.keys(icons).filter((v)=>v.toLowerCase().includes('fill')).length
                },
                {
                    property: 'Linear',
                    value: icons && Object.keys(icons).filter((v)=>v.toLowerCase().includes('outline')).length
                },
                {
                    property: 'Colored',
                    value: icons && Object.keys(icons).filter((v)=>v.toLowerCase().includes('colored')).length
                }
            ]
        },
        {
            icon: 'fontFace',
            href: '/font',
            title: 'Fonts',
            paragraph: 'Fonts and font families',
            properties: [
                {
                    property: 'Fonts',
                    value: font && Object.keys(font).length
                },
                {
                    property: 'Families',
                    value: fontFamily && Object.keys(fontFamily).length
                }
            ]
        },
        {
            icon: 'clock',
            href: '/timing',
            iconTheme: 'icons',
            title: 'Timing',
            paragraph: 'Tokens for transitions and animations',
            properties: [
                {
                    property: 'Timing base',
                    value: timing && timing.base + 'ms'
                },
                {
                    property: 'Ratio',
                    value: timing && timing.ratio
                },
                {
                    property: 'Transitions',
                    value: 'TBA'
                },
                {
                    property: 'Animations',
                    value: 'TBA'
                }
            ]
        },
        {
            icon: 'layout outline',
            href: '/grid',
            title: 'Grids',
            paragraph: 'Grid systems for consistant layout',
            properties: [
                {
                    property: 'All grids',
                    value: GRIDS && Object.keys(GRIDS).length
                }
            ]
        },
        {
            icon: 'boolean outline',
            href: '/cases',
            title: 'Cases',
            paragraph: 'Conditional cases of UA reused in properties',
            properties: [
                {
                    property: 'All cases',
                    value: cases && Object.keys(cases).length
                }
            ]
        },
        {
            icon: 'deviceMobile',
            href: '/media',
            title: 'Breakpoints',
            paragraph: 'Device breakpoints as media and container queries',
            properties: [
                {
                    property: 'Breakpoints',
                    value: media && Object.keys(media).length
                },
                {
                    property: 'Screens',
                    value: devices && Object.keys(devices).length
                }
            ]
        },
        {
            icon: 'threeDots',
            href: '/sequence',
            title: 'Sequence',
            paragraph: 'Mapping system of generative sizing units',
            properties: [
                {
                    property: 'Breakpoints',
                    value: '8'
                },
                {
                    property: 'Screens',
                    value: '3'
                }
            ]
        }
    ];
};

});

parcelRegister("2Oceb", function(module, exports) {

$parcel$export(module.exports, "applyMarkdownToElement", () => (parcelRequire("i41vD")).applyMarkdownToElement);
$parcel$export(module.exports, "markdownToChildren", () => (parcelRequire("i41vD")).markdownToChildren);
$parcel$export(module.exports, "highlightMarkdownRefs", () => (parcelRequire("i41vD")).highlightMarkdownRefs);
// Re-exports the markdown-to-DOM renderer as a project-registered function so
// any page/component can reach it via `el.call('applyMarkdownToElement', ...)`
// — the mandated cross-package access path for `@symbo-ls/*` shared code (a
// raw import gets frank-stubbed at platform-serialization time; see the
// comment above TicketDetailModal.js's renderMarkdown for the full
// rationale). Same pattern as resolveScope.js.
//
// Root cause this file fixes (EDITOR-COLLAPSE-1, tickets/sonnet.md): the
// function itself lived ONLY in components/MarkdownPreview.js, so it was
// merged into `context.components`, never `context.methods` /
// `context.functions` / `context.utils` — the three buckets `el.call`
// actually searches (see smbls/packages/element/src/methods.js
// warnUnresolvedCall). Every `el.call('applyMarkdownToElement', ...)` site
// across the workspace (tickets' TicketDetailModal, chat's ThreadPanel via
// functions/renderMarkdown.js, marketplace's MarketplaceDetailMarkdownBody,
// files' FilesViewer, documents' Editor) was silently returning `undefined`
// and rendering nothing — confirmed live: a ticket body/steps-to-reproduce/
// expected-result saved as `<p>...</p>` (anything NOT matching tickets'
// narrow `_HTML_TAG_RE` whitelist) took the markdown path, called this
// unregistered function, got a no-op, and rendered as an empty box even
// though the record held real content. A sibling field whose content
// happened to be wrapped in a whitelisted tag (`<ul><li>...</li></ul>`)
// rendered fine — same code path, only the bucket lookup differed.
//
// Purely additive: components/MarkdownPreview.js is untouched, so every
// existing `import { applyMarkdownToElement } from
// '@symbo-ls/workspace-shared/components/MarkdownPreview.js'` consumer
// (chat's functions/renderMarkdown.js) keeps working unchanged.
// `highlightMarkdownRefs` rides along for the same reason. It is the
// ##ticket / @@event / +doc card pass on its own, for surfaces that render the
// markdown body through a reactive `children:` factory instead of through
// applyMarkdownToElement's imperative innerHTML write (chat's MessageList and
// ThreadPanel — see the CHAT-STALE-BUBBLE note there).

var $i41vD = parcelRequire("i41vD");

});

parcelRegister("hbCVi", function(module, exports) {

$parcel$export(module.exports, "confirmEmail", () => $c831a81808239e3d$export$d42a822b5f5ae147);
const $c831a81808239e3d$export$d42a822b5f5ae147 = async function confirmEmail() {
    // Review r3 D5: the confirm runs on the page's Continue click, never on
    // load (a mail scanner that runs JS would otherwise confirm, run the
    // cleanup and take the fresh session).
    this.state.update({
        awaitingContinue: false,
        loading: true,
        error: null
    });
    try {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        // The `email` param is display-only and attacker-writable (review r4
        // N2): the page names the address from the server
        // (previewConfirmation). It stays required as the mark of an emailed
        // verify link: an invitation's `?token=` carries no `email`.
        const email = params.get('email');
        if (!token || !email) throw new Error('Invalid confirmation link');
        const result = await this.sdk.confirmRegistration(token);
        // A first proof of the address from a browser with no session for this
        // account (e.g. a demo claim's link opened on another device) makes the
        // server drop the password set before the proof and answer with a fresh
        // session in `result.tokens`. Adopt it through the SDK's TokenManager
        // (an SDK that already adopted it is skipped) and boot signed in —
        // otherwise the user has no password and no session.
        const tokens = result?.tokens;
        const tm = this.sdk?._tokenManager;
        if (tokens?.accessToken && tm?.setTokens) {
            if (tm.getAccessToken?.() !== tokens.accessToken) tm.setTokens({
                access_token: tokens.accessToken,
                refresh_token: tokens.refreshToken,
                expires_in: tokens.accessTokenExp?.expiresIn,
                token_type: 'Bearer'
            });
            // The adopted refresh token is this origin's own (review D1): every
            // sign-in that stores a refresh token marks it.
            this.call('markOwnSession');
            // Review r3 D4: the cleanup dropped the pre-set password and the
            // answer carries a single-use setPasswordToken — stay on the page and
            // ask for a password (or Skip); completeConfirmSignIn re-boots.
            if (result?.setPasswordToken) {
                this.state.update({
                    loading: false,
                    success: true,
                    signedIn: true,
                    error: null,
                    setPasswordToken: result.setPasswordToken
                });
                return;
            }
            this.state.update({
                loading: true,
                success: true,
                signedIn: true,
                error: null
            });
            // frank-allow FA401 — auth hard reset: boot re-derives the session from the adopted tokens (spaReloadCensus class b)
            window.location.replace('/');
            return;
        }
        if (result) {
            // A sign-in on this origin: its refresh token is its own (review D1).
            this.call('markOwnSession');
            this.state.update({
                loading: false,
                success: true
            });
        } else throw new Error('Confirmation failed');
    } catch (error) {
        // 409 "Email taken": a pending email (demo claim) that another account
        // took before the link was clicked. The server burns the token, so a
        // retry cannot succeed — flag it for a dedicated message.
        const http = error?.cause || error;
        if (http?.status === 409 || http?.cause?.error === 'Email taken') {
            this.state.update({
                loading: false,
                success: false,
                emailTaken: true,
                error: null
            });
            return;
        }
        this.state.update({
            loading: false,
            success: false,
            error: error.message
        });
    }
};

});

parcelRegister("1ibbm", function(module, exports) {

$parcel$export(module.exports, "previewConfirmation", () => $0f10257401634c16$export$2dd24633ca56df2e);
// /signup-confirmation, before Continue (server core/auth-takeover-paths
// review r4 N2). Continue signs the browser in as the account the token
// confirms. The page therefore names that account, read from the SERVER
// (sdk.previewRegisterConfirmation — never the `email` URL param, which
// anyone can write), and says so when the browser holds a session for
// another account, so a victim sent an attacker's own link sees whose
// account it is before pressing Continue. Read only: no confirm, no session
// write. Runs once per page (the ConfirmContinue step's onRender).
const $0f10257401634c16$export$2dd24633ca56df2e = async function previewConfirmation() {
    const s = this.state;
    if (s.previewRequested) return;
    s.update({
        previewRequested: true
    });
    const sdk = this.sdk;
    let signedInEmail = '';
    if (sdk?._tokenManager?.getAccessToken?.() && typeof sdk.getMe === 'function') try {
        const me = await sdk.getMe();
        const u = me && (me.data?.user || me.user) || me || {};
        signedInEmail = String(u.email || '');
    } catch (_) {
        signedInEmail = '';
    }
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
        s.update({
            awaitingContinue: false,
            success: false,
            error: this.call('polyglot', 'auth.confirm.invalidLink')
        });
        return;
    }
    // An SDK without the preview (older published build): the address stays
    // unnamed and any signed-in account is reported as possibly replaced.
    if (typeof sdk?.previewRegisterConfirmation !== 'function') {
        s.update({
            previewReady: true,
            targetEmail: '',
            otherAccountEmail: signedInEmail
        });
        return;
    }
    try {
        const out = await sdk.previewRegisterConfirmation(token);
        const targetEmail = String(out?.email || '');
        const other = signedInEmail && signedInEmail.toLowerCase() !== targetEmail.toLowerCase() ? signedInEmail : '';
        s.update({
            previewReady: true,
            targetEmail: targetEmail,
            otherAccountEmail: other
        });
    } catch (error) {
        s.update({
            awaitingContinue: false,
            success: false,
            error: error?.message || 'error'
        });
    }
};

});

parcelRegister("lgGcZ", function(module, exports) {

$parcel$export(module.exports, "completeConfirmSignIn", () => $f7bbd5521937eace$export$fe842ffde974baa9);
// The last step of /signup-confirmation after a confirm that dropped the
// pre-set password (server core/auth-takeover-paths review r3 D4). The fresh
// session is already stored (confirmEmail). With a `password`, set it through
// the single-use token the confirm answer carried
// (sdk.setInitialPassword → POST /auth/set-initial-password); without one
// (Skip), go straight on. Then re-boot signed in. A failed save keeps the
// person on the step with an error, never boots half-done.
const $f7bbd5521937eace$export$fe842ffde974baa9 = async function completeConfirmSignIn(password) {
    const s = this.state;
    if (password) {
        s.update({
            savingPassword: true,
            setPasswordError: null
        });
        try {
            await this.sdk.setInitialPassword(s.setPasswordToken, password);
        } catch (error) {
            s.update({
                savingPassword: false,
                setPasswordError: error?.message || 'error'
            });
            return false;
        }
    }
    // Re-boot with the stored session (the confirm's fresh tokens).
    // frank-allow FA401 — auth hard reset: boot re-derives the session from the adopted tokens (spaReloadCensus class b)
    window.location.replace('/');
    return true;
};

});

parcelRegister("bgxQx", function(module, exports) {

$parcel$export(module.exports, "searchNpmPackages", () => $833b71853984f27d$export$29f31f345bb88a04);
const $833b71853984f27d$export$29f31f345bb88a04 = async function searchNpmPackages(name) {
    await window.fetch(`https://registry.npmjs.com/-/v1/search?text=${name}&size=5`).then(async (res)=>{
        const { objects: objects } = await res.json();
        const packages = objects.map((v)=>({
                name: v.package.name,
                version: v.package.version
            }));
        if (name === this.state.name) this.state.replace({
            packages: packages,
            isLoadingPackages: false
        });
    }).catch(()=>{
        if (name === this.state.name) this.state.replace({
            packages: [],
            isLoadingPackages: false
        });
    });
};

});

parcelRegister("gEeRm", function(module, exports) {

$parcel$export(module.exports, "refreshUserProjects", () => $c1ebe898528d9679$export$b66c22237e2200c3);
const $c1ebe898528d9679$export$b66c22237e2200c3 = async function refreshUserProjects() {
    try {
        // Get current user data and projects from CoreService
        const currentUser = await this.sdk.getUserProfile();
        const userProjects = await this.sdk.getUserProjects();
        const userData = {
            ...currentUser,
            currentUser: currentUser,
            userId: currentUser.id,
            projects: userProjects || []
        };
        // Update the rootState with fresh user data and projects
        const state = this.getRootState();
        this.call('overwrite', state, userData);
        return userData;
    } catch (error) {
        console.error('[refreshUserProjects] Error:', error);
        throw error;
    }
};

});

parcelRegister("gt4uV", function(module, exports) {

$parcel$export(module.exports, "getErroredCodeKey", () => $bfd2d7f4ae1ef660$export$394fecdacc86f55);
const $bfd2d7f4ae1ef660$export$394fecdacc86f55 = function getErroredCodeKey(key) {
    const projectKey = this.getAppKey();
    const componentKey = key || this.state.key;
    return `code-error-${projectKey}_${componentKey}`;
};

});

parcelRegister("gT7Pk", function(module, exports) {

$parcel$export(module.exports, "loadProjectData", () => $c4b7daa54daee7bf$export$416298f1f6a98821);
const $c4b7daa54daee7bf$export$416298f1f6a98821 = async function loadProjectData(projectId, fields = [
    'state',
    'system',
    'settings',
    'designSystem',
    'components',
    'pages',
    'canvas',
    'colors',
    'icons',
    'schema',
    'functions',
    'methods',
    'define',
    'packages',
    'dependencies',
    'files',
    'project'
]) {
    // USER-CODE-ORIGIN review N4: the payload stays AS STORED (function
    // fields are strings). The shell never revives member-authored project
    // code; only the opaque user-code frame does (mountUserCode).
    const projectData = await this.sdk.getProjectData(projectId) || {};
    // If specific fields are requested, return only those
    if (Array.isArray(fields) && fields.length > 0) return fields.reduce((result, field)=>{
        if (field in projectData) result[field] = projectData[field];
        return result;
    }, {});
    return projectData;
};

});

parcelRegister("aty1O", function(module, exports) {

$parcel$export(module.exports, "updateApplicationState", () => $7a07021cfac7ec44$export$c261b3cb6fea64ae);
const $7a07021cfac7ec44$export$c261b3cb6fea64ae = function updateApplicationState({ authToken: authToken, userData: userData, projectData: projectData }) {
    const state = this.getRootState();
    this.call('overwrite', state, {
        authToken: authToken
    });
    this.call('overwrite', state, userData);
    // USER-CODE-ORIGIN review N4: stored AS IS (strings) — the shell never
    // revives member-authored project code; the opaque frame does.
    return this.call('overwrite', state, projectData);
};

});

parcelRegister("9qcV0", function(module, exports) {

$parcel$export(module.exports, "getCodePreviewValue", () => $6dc0901724c42b84$export$975d5cb3731cc322);
// LIVENESS GATE. Four components call this. Two of them — CodePreview.js and
// Command.js — reach it AFTER an `await import('prismjs')`, so the page can
// change between the call site and this body. smbls `dispose()` nulls
// `element.parent` (packages/element/src/dispose.js), and the read of
// `this.parent.value` below then threw
// `Cannot read properties of null (reading 'value')` — measured on the served
// catalog whenever pagination replaced the grid mid-import.
//
// Those two callers gate for themselves now, one line before the call. This
// guard stays as the function's OWN contract: it is registered by name, so a
// published tenant module can `el.call` it after any await of its own, and a
// removed element has no preview to paint — answering nothing is the whole
// contract (every caller already does `if (!code) return`). Terminal.js and
// CodeWithTitleAndButtons.js call it synchronously and never reach the guard.
const $6dc0901724c42b84$export$975d5cb3731cc322 = function getCodePreviewValue(val) {
    if (!this.parent) return;
    const globalState = this.getRootState();
    const parentPropsValue = this.parent.value;
    const value = val || (parentPropsValue ? this.call('exec', parentPropsValue, this.parent) : this.call('exec', this.value, this));
    const framework = globalState?.framework === 'domql' ? 'symbols' : globalState?.framework;
    const code = this.call('isObjectLike', value) ? value[framework] || value['symbols'] || value['domql'] : value;
    if (!code) return;
    const stringifiedCode = this.call('isString', code) ? code : this.call('objectToString', code);
    return this.call('replaceLiteralsWithObjectFields', stringifiedCode);
};

});

parcelRegister("cqSvZ", function(module, exports) {

$parcel$export(module.exports, "addSmblsSubdomain", () => $90d233483e180375$export$b1647d9bf0ff52c3);
const $90d233483e180375$export$b1647d9bf0ff52c3 = async function addSmblsSubdomain(appKey) {
    const config = await this.getConfig();
    const API_URL = config.apiUrl;
    if (this.call('isNotProduction')) return this.warn('Creating domains is only allowed in production');
    const res = await window.fetch(`${API_URL}/add-subdomain`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            domain: appKey
        })
    }).then((response)=>response.json());
    return res;
};

});

parcelRegister("9Nls3", function(module, exports) {

$parcel$export(module.exports, "checkFeatureByPackage", () => $721954806c7b8d19$export$7ccd2786a1d796c1);
const $721954806c7b8d19$export$7ccd2786a1d796c1 = function checkFeatureByPackage(key) {
    const PAGES_PACKAGES_AVAILABILITY_MAP = {
        preview: 0,
        designSystem: 0,
        components: 0,
        integrations: 0,
        settings: 0,
        pages: 0,
        functions: 0,
        state: 0,
        gettingStarted: 0,
        docs: 0,
        colors: 0,
        color: 0,
        media: 0,
        shape: 0,
        typography: 0,
        spacing: 0,
        semantic_color: 0,
        global_themes: 0,
        gradients: 0,
        gradient: 0,
        themes: 0,
        theme: 0,
        icons: 0,
        fonts: 0,
        font: 0,
        cases: 0,
        dependencies: 0,
        secrets: 0,
        content: 0,
        methods: 0,
        snippets: 0,
        files: 0,
        publish: 0
    };
    return Number(this.getRootState()?.package) >= PAGES_PACKAGES_AVAILABILITY_MAP[key];
};

});

parcelRegister("jl4gf", function(module, exports) {

$parcel$export(module.exports, "a11yRootAttrs", () => $e14348a68f9788ba$export$9d352f62e9ba8d5);
$parcel$export(module.exports, "applyA11yPrefs", () => $e14348a68f9788ba$export$8ab784964463695f);
$parcel$export(module.exports, "setA11yPref", () => $e14348a68f9788ba$export$d54cc8e914bbde79);
$parcel$export(module.exports, "resetA11yPrefs", () => $e14348a68f9788ba$export$5b65d6b27e3addf1);
$parcel$export(module.exports, "a11yPrefsAreDefault", () => $e14348a68f9788ba$export$6f388649cfbc92e7);
// a11yPrefs — the accessibility preferences of the workspace app.
//
// The SAME four choices, the same names and the same data-attribute contract
// as the public site (company/packages/landing/functions/a11yPrefs.js), so a
// person who set their preferences on symbols.app finds the identical
// switches inside the product and they behave identically (2026-09-04 per
// Nika "add same accessibility options as we have in landing also in
// workspace settings"):
//
//   a11yFontScale  'sm' | 'md' | 'lg'   one type-scale step down / base / up
//   a11yContrast   boolean              quiet inks become the ink
//   a11yMotion     boolean              transitions and animations stand still
//   a11yLinks      boolean              every link shows its underline
//
// PER PERSON, not per workspace. These live in localStorage on the device,
// like `themeMode` — an admin forcing reduced motion on a whole workspace
// would be the opposite of an accessibility feature. The card sits on the
// account settings page beside Language, which is the same kind of choice.
//
// The shell mirrors the four onto <html> as `data-font-scale` /
// `data-contrast` / `data-motion` / `data-links` (workspace/app.js
// `_syncShellRoute`), and the injected shell sheet scopes the global rules on
// them — the same attribute names the landing's designSystem/reset.js uses.
//
// ⚠ EVERY module-level name here is prefixed `WS_A11Y_`. The published bundle
// puts every functions/*.js file into ONE shared scope, so a bare
// `A11Y_STORAGE_KEY` would resolve to whichever sibling declared it last — the
// landing lost its prefs to keepPlace.js exactly that way (measured
// 2026-09-03, see that file's own note).
const $e14348a68f9788ba$var$WS_A11Y_STORAGE_KEY = 'workspace-a11y';
const $e14348a68f9788ba$var$WS_A11Y_SCALES = [
    'sm',
    'md',
    'lg'
];
const $e14348a68f9788ba$var$WS_A11Y_FLAGS = [
    'a11yContrast',
    'a11yMotion',
    'a11yLinks'
];
const $e14348a68f9788ba$var$wsA11yWindow = (win)=>win || (typeof window !== 'undefined' ? window : null);
const $e14348a68f9788ba$var$wsA11yRead = (win)=>{
    try {
        const raw = win.localStorage.getItem($e14348a68f9788ba$var$WS_A11Y_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (err) {
        return {};
    }
};
const $e14348a68f9788ba$var$wsA11yWrite = (win, prefs)=>{
    try {
        win.localStorage.setItem($e14348a68f9788ba$var$WS_A11Y_STORAGE_KEY, JSON.stringify(prefs));
    } catch (err) {}
};
// stored shape → root-state keys, defaults for anything missing
const $e14348a68f9788ba$var$wsA11yToState = (stored)=>({
        a11yFontScale: $e14348a68f9788ba$var$WS_A11Y_SCALES.indexOf(stored.fontScale) !== -1 ? stored.fontScale : 'md',
        a11yContrast: stored.contrast === true,
        a11yMotion: stored.motion === true,
        a11yLinks: stored.links === true
    });
// root-state keys → stored shape
const $e14348a68f9788ba$var$wsA11yToStored = (state)=>({
        fontScale: $e14348a68f9788ba$var$WS_A11Y_SCALES.indexOf(state?.a11yFontScale) !== -1 ? state.a11yFontScale : 'md',
        contrast: !!state?.a11yContrast,
        motion: !!state?.a11yMotion,
        links: !!state?.a11yLinks
    });
// The <html> attribute mirror, applied by THIS module — whatever owns the
// preference owns its DOM projection.
//
// Deliberately NOT the shell's `_syncShellRoute`: that runs on route change
// and a few subscribed keys, so a preference written from the settings card
// persisted correctly and painted NOTHING until the next navigation (measured
// live 2026-09-04 — localStorage held {"fontScale":"lg"} while <html> carried
// no attribute at all). Writing here also gives the canvas app, which serves
// this same settings page and has no `_syncShellRoute`, identical behaviour.
const $e14348a68f9788ba$var$wsA11yMirror = (root, win)=>{
    const doc = win && win.document || (typeof document !== 'undefined' ? document : null);
    if (!doc || !doc.documentElement) return;
    const attrs = $e14348a68f9788ba$export$9d352f62e9ba8d5(root);
    for (const name of Object.keys(attrs)){
        const value = attrs[name];
        if (value === null) doc.documentElement.removeAttribute(name);
        else doc.documentElement.setAttribute(name, value);
    }
};
const $e14348a68f9788ba$export$9d352f62e9ba8d5 = (root)=>({
        'data-font-scale': root?.a11yFontScale === 'sm' || root?.a11yFontScale === 'lg' ? root.a11yFontScale : null,
        'data-contrast': root?.a11yContrast ? 'high' : null,
        'data-motion': root?.a11yMotion ? 'reduced' : null,
        'data-links': root?.a11yLinks ? 'underline' : null
    });
const $e14348a68f9788ba$export$8ab784964463695f = (root, win)=>{
    const w = $e14348a68f9788ba$var$wsA11yWindow(win);
    if (!root || !w) return null;
    const next = $e14348a68f9788ba$var$wsA11yToState($e14348a68f9788ba$var$wsA11yRead(w));
    if (typeof root.update === 'function') root.update(next, {
        preventFetch: true
    });
    else Object.assign(root, next);
    $e14348a68f9788ba$var$wsA11yMirror(next, w);
    return next;
};
const $e14348a68f9788ba$export$d54cc8e914bbde79 = (root, key, value, win)=>{
    const w = $e14348a68f9788ba$var$wsA11yWindow(win);
    if (!root) return null;
    const patch = {};
    if (key === 'a11yFontScale') patch[key] = $e14348a68f9788ba$var$WS_A11Y_SCALES.indexOf(value) !== -1 ? value : 'md';
    else if ($e14348a68f9788ba$var$WS_A11Y_FLAGS.indexOf(key) !== -1) patch[key] = !!value;
    else return null;
    if (typeof root.update === 'function') root.update(patch, {
        preventFetch: true
    });
    else Object.assign(root, patch);
    const merged = {
        ...typeof root.parse === 'function' ? root.parse() : root,
        ...patch
    };
    const stored = $e14348a68f9788ba$var$wsA11yToStored(merged);
    if (w) $e14348a68f9788ba$var$wsA11yWrite(w, stored);
    $e14348a68f9788ba$var$wsA11yMirror(merged, w);
    return stored;
};
const $e14348a68f9788ba$export$5b65d6b27e3addf1 = (root, win)=>{
    const w = $e14348a68f9788ba$var$wsA11yWindow(win);
    if (!root) return null;
    const next = $e14348a68f9788ba$var$wsA11yToState({});
    if (typeof root.update === 'function') root.update(next, {
        preventFetch: true
    });
    else Object.assign(root, next);
    if (w) $e14348a68f9788ba$var$wsA11yWrite(w, $e14348a68f9788ba$var$wsA11yToStored(next));
    $e14348a68f9788ba$var$wsA11yMirror(next, w);
    return next;
};
const $e14348a68f9788ba$export$6f388649cfbc92e7 = (root)=>{
    const s = $e14348a68f9788ba$var$wsA11yToStored(root || {});
    return s.fontScale === 'md' && !s.contrast && !s.motion && !s.links;
};

});

parcelRegister("jnnl1", function(module, exports) {

$parcel$export(module.exports, "AI_MENTION_TRIGGERS", () => $e1b244c38994db75$export$17aebae39ce09d6b);
$parcel$export(module.exports, "detectMentionRefTrigger", () => $e1b244c38994db75$export$502df388d02b7300);
$parcel$export(module.exports, "mentionRefInsertText", () => $e1b244c38994db75$export$aa38a079b0ded538);
$parcel$export(module.exports, "mentionRefSyncOptions", () => $e1b244c38994db75$export$a6998d55829fb143);
$parcel$export(module.exports, "fetchMentionRefOptions", () => $e1b244c38994db75$export$6fd1adfb9d8ba757);
$parcel$export(module.exports, "mentionRefRowLabel", () => $e1b244c38994db75$export$1f1f0e284d939f9b);
// AI-composer content-reference machinery (2026-09-02 per Nika: "add + icon
// where you select different content - like ticket, member, note etc. it
// could be also mentioned by @ ++ # and etc just like we have in chat").
//
// The trigger grammar and the SDK fetchers deliberately MIRROR the chat
// composer's (packages/chat/functions/messageBody.js TRIGGERS +
// packages/chat/components/Composer.js _fetchRef) — one mental model for
// mentions across chat and the AI prompt. They are re-declared here, under
// DISTINCT exported names, because (a) canvas cannot legally import from the
// chat package (cross-app import boundary, eslint.config.mjs), and (b)
// re-exporting chat's names from shared would collide in the merged
// function registry once the chat context folds into the shell (Rule 63 —
// duplicate names shadow silently). If the trigger grammar ever changes,
// change BOTH tables in the same commit — each file's header names the
// other.
//
// Person/channel options resolve SYNCHRONOUSLY from state the shell already
// holds (root.people — the member directory loadPrivateData maintains;
// root.channels when the chat context has booted). Ticket/event/reference
// options fetch on demand through the SDK — same services, filters and
// 60s cache the chat composer uses.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $e1b244c38994db75$export$17aebae39ce09d6b = [
    {
        prefix: '@@',
        type: 'event'
    },
    {
        prefix: '##',
        type: 'ticket'
    },
    {
        prefix: '@',
        type: 'person'
    },
    {
        prefix: '#',
        type: 'channel'
    },
    {
        prefix: '+',
        type: 'reference'
    }
];
const $e1b244c38994db75$export$502df388d02b7300 = (body, caret)=>{
    if (caret == null || !body) return null;
    const upToCaret = body.slice(0, caret);
    for (const { prefix: prefix, type: type } of $e1b244c38994db75$export$17aebae39ce09d6b){
        const idx = upToCaret.lastIndexOf(prefix);
        if (idx < 0) continue;
        if (idx > 0 && !/\s/.test(body[idx - 1])) continue;
        const after = upToCaret.slice(idx + prefix.length);
        if (!/^[a-zA-Z0-9._\- ]*$/.test(after)) continue;
        return {
            type: type,
            query: after,
            start: idx,
            end: caret
        };
    }
    return null;
};
const $e1b244c38994db75$export$aa38a079b0ded538 = (type, option)=>{
    if (!option) return '';
    if (type === 'person') {
        const handle = (option.email || '').split('@')[0] || option.name;
        return handle ? `@${handle} ` : '';
    }
    if (type === 'channel') return option.name ? `#${option.name} ` : '';
    if (type === 'ticket') {
        const ref = option.number || option.id;
        return ref ? `##${ref} ` : '';
    }
    if (type === 'event') return option.title ? `@@${option.title} ` : '';
    if (type === 'reference') return option.title ? `+${option.title} ` : '';
    return '';
};
const $e1b244c38994db75$var$_normalizeList = (res)=>{
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res.data)) return res.data;
    return [];
};
// 60s soft cache, per type — same shape/TTL as chat's _refCache so the two
// composers put identical load on the services.
const $e1b244c38994db75$var$_cache = {};
const $e1b244c38994db75$var$_cached = async (key, fill)=>{
    if (!$e1b244c38994db75$var$_cache[key]) {
        $e1b244c38994db75$var$_cache[key] = await fill();
        setTimeout(()=>{
            $e1b244c38994db75$var$_cache[key] = null;
        }, 60000);
    }
    return $e1b244c38994db75$var$_cache[key];
};
const $e1b244c38994db75$export$a6998d55829fb143 = (type, query, root)=>{
    const q = (query || '').trim().toLowerCase();
    if (type === 'person') {
        const people = Array.isArray(root && root.people) ? root.people : [];
        return people.filter((p)=>!q || p.email && p.email.toLowerCase().split('@')[0].includes(q) || p.name && p.name.toLowerCase().includes(q)).slice(0, 6);
    }
    if (type === 'channel') return (root && root.channels ? root.channels : []).filter((c)=>c.kind === 'channel' && (!q || c.name && c.name.toLowerCase().includes(q))).slice(0, 6);
    return null;
};
const $e1b244c38994db75$export$6fd1adfb9d8ba757 = async (type, query)=>{
    const q = (query || '').trim().toLowerCase();
    if (type === 'ticket') {
        const rows = await $e1b244c38994db75$var$_cached('tickets', async ()=>{
            const tSvc = await (0, $1NxyO.getSDK)().getService('tickets');
            const res = await tSvc.list({
                deleted: false
            }, {
                limit: 50,
                sortBy: 'updatedAt',
                sortDir: 'desc'
            });
            return $e1b244c38994db75$var$_normalizeList(res);
        });
        return rows.filter((t)=>!q || t.title && t.title.toLowerCase().includes(q) || t.number && String(t.number).includes(q)).slice(0, 6);
    }
    if (type === 'event') {
        const rows = await $e1b244c38994db75$var$_cached('events', async ()=>{
            const res = await (0, $1NxyO.getSDK)().execute('workspaceProject.calendar', 'list', {
                filter: {},
                options: {
                    columns: 'id, title, date, start_time, end_time',
                    order: {
                        date: 'desc'
                    },
                    limit: 50
                }
            });
            return $e1b244c38994db75$var$_normalizeList(res);
        });
        return rows.filter((ev)=>!q || ev.title && ev.title.toLowerCase().includes(q)).slice(0, 6);
    }
    if (type === 'reference') {
        const notes = await $e1b244c38994db75$var$_cached('notes', async ()=>{
            const res = await (0, $1NxyO.getSDK)().execute('docs.notes', 'list', {
                limit: 30
            });
            return $e1b244c38994db75$var$_normalizeList(res).map((n)=>({
                    ...n,
                    id: n.docId || n._id || n.id,
                    _refType: 'note'
                }));
        });
        const kb = await $e1b244c38994db75$var$_cached('kb', async ()=>{
            const res = await (0, $1NxyO.getSDK)().execute('docs.kbArticles', 'list', {
                limit: 30
            });
            return $e1b244c38994db75$var$_normalizeList(res).map((a)=>({
                    ...a,
                    id: a.docId || a._id || a.id,
                    _refType: 'knowledge base'
                }));
        });
        return [
            ...notes,
            ...kb
        ].filter((d)=>!q || d.title && d.title.toLowerCase().includes(q)).slice(0, 6);
    }
    return [];
};
const $e1b244c38994db75$export$1f1f0e284d939f9b = (type, option)=>{
    if (!option) return {
        label: '',
        caption: ''
    };
    if (type === 'person') return {
        label: option.name || option.email || '',
        caption: option.email ? '@' + option.email.split('@')[0] : ''
    };
    if (type === 'channel') return {
        label: '#' + (option.name || ''),
        caption: 'Channel'
    };
    if (type === 'ticket') return {
        label: option.title || String(option.number || option.id || ''),
        caption: option.number ? `##${option.number}` : 'Ticket'
    };
    if (type === 'event') return {
        label: option.title || '',
        caption: option.date || 'Event'
    };
    if (type === 'reference') return {
        label: option.title || '',
        caption: option._refType || 'Reference'
    };
    return {
        label: option.title || option.name || '',
        caption: ''
    };
};

});

parcelRegister("le0yX", function(module, exports) {

$parcel$export(module.exports, "applyAiMentionPick", () => $f73b5785813cd548$export$f645d6d077df4296);
$parcel$export(module.exports, "aiComposerKeydown", () => $f73b5785813cd548$export$3d134fdf853b7864);
// aiComposerKeys — THE pre-send key model of the AI composer, in ONE place.
//
// Why this file exists (2026-09-02, the second half of the '+' attach-menu
// keyboard defect): `workspace/app.js` mounts canvas's `CanvasPromptTextarea`
// at the shell root and overrides `Textarea.onKeydown` at the mount site, to
// route Enter through `homeAiSend` instead of the composer's own `_sendPrompt`.
// A mount-site handler REPLACES the component's own — DOMQL never chains the
// two — so every OTHER key branch the composer declares is dead in the shell
// mount. The first cut re-declared the attach-menu arrow branch inside the
// override, which fixed that one branch and left the MENTION PICKER keys
// (Arrow/Home/End/Enter/Tab/Escape while the '@' / '#' / '##' / '@@' / '+'
// suggestion list is open) still dropped on the home composer.
//
// Enumerating branches per mount is what let the two drift in the first place.
// So both mounts now DELEGATE: `aiComposerKeydown(e, el, s)` owns every key
// that belongs to an open panel, and REPORTS whether it consumed the keystroke.
// Each mount keeps only its own send leg behind that one guard:
//
//   onKeydown: (e, el, s) => {
//     if (aiComposerKeydown(e, el, s)) return      // picker / menu keys
//     if (e.key === 'Enter' && !e.shiftKey) { … }  // this mount's OWN send
//   }
//
// The Enter contract that makes the delegation safe: Enter is consumed here
// ONLY while a mention picker with options is open (it inserts the mention).
// With no picker open the function returns false and the caller's send path
// runs exactly as before — one send, never two.

var $3CWNx = parcelRequire("3CWNx");

var $jnnl1 = parcelRequire("jnnl1");

var $lF4Ko = parcelRequire("lF4Ko");
// The composer's DOMQL key, used to walk from a dropdown ROW back to the
// textarea (a row's own `el.node` is the row). The textarea call sites never
// need it — their `el.node` IS the textarea, checked first.
const $f73b5785813cd548$var$COMPOSER_KEY = 'CanvasPromptTextarea';
// rAF that survives a windowless runtime (bun test, bypass mode) — a bare
// `requestAnimationFrame` reference THROWS there, which turns a picker Enter
// into an aborted handler in the suite. Falls to a 16ms tick.
const $f73b5785813cd548$var$_raf = (fn)=>typeof requestAnimationFrame === 'function' ? requestAnimationFrame(fn) : setTimeout(fn, 16);
const $f73b5785813cd548$var$_textareaOf = (el)=>{
    const node = el && el.node;
    if (!node) return null;
    if (node.tagName === 'TEXTAREA') return node;
    return node.closest?.(`[data-key="${$f73b5785813cd548$var$COMPOSER_KEY}"]`)?.querySelector?.('textarea') || null;
};
const $f73b5785813cd548$export$f645d6d077df4296 = (el, s, option)=>{
    const p = s && s.mentionPicker;
    if (!p) return false;
    const text = (0, $jnnl1.mentionRefInsertText)(p.type, option);
    if (!text) {
        s.update({
            mentionPicker: null
        });
        return true;
    }
    const body = s.draft || '';
    const next = body.slice(0, p.start) + text + body.slice(p.end);
    const caret = p.start + text.length;
    s.update({
        draft: next,
        mentionPicker: null
    });
    $f73b5785813cd548$var$_raf(()=>{
        const ta = $f73b5785813cd548$var$_textareaOf(el);
        if (!ta) return;
        ta.focus();
        try {
            ta.setSelectionRange(caret, caret);
        } catch (_) {}
    });
    return true;
};
const $f73b5785813cd548$export$3d134fdf853b7864 = (e, el, s)=>{
    if (!e || !e.key || !s) return false;
    // An open '+' menu owns the arrow keys. The panel is a SIBLING of the
    // textarea, and DOMQL's delegated keydown walks the ANCESTOR chain of
    // `event.target` (smbls delegate.js `installDelegatedEvent`) — a keystroke
    // typed in the textarea can never reach `AttachMenu.onKeydown`. So the
    // textarea hands focus INTO the menu; every later arrow then arrives at the
    // panel itself. ArrowUp enters at the last row, as on the '+' button.
    // Checked before the mention picker: the two are mutually exclusive in
    // practice, and an open menu is the more recent intent.
    if (s.attachOpen && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
        (0, $3CWNx.armNamedMenuFocus)(el, 'AttachMenu', {
            last: e.key === 'ArrowUp'
        });
        return true;
    }
    const p = s.mentionPicker;
    if (!p) return $f73b5785813cd548$var$_aiPanelKeys(e, el, s);
    const options = p.options || [];
    if (options.length) {
        const n = options.length;
        const idx = p.activeIndex || 0;
        // Home/End jump to the ends of the suggestion list — the same two keys
        // every other menu in this pass answers. The highlight is state-driven
        // (`activeIndex` re-renders the rows), NOT DOM focus: focus must stay in
        // the textarea so the caret and the typed query survive, which is why this
        // list keeps its own key handling here instead of the shared DOM walker
        // the panel menus use.
        let activeIndex = null;
        if (e.key === 'ArrowDown') activeIndex = (idx + 1) % n;
        else if (e.key === 'ArrowUp') activeIndex = (idx - 1 + n) % n;
        else if (e.key === 'Home') activeIndex = 0;
        else if (e.key === 'End') activeIndex = n - 1;
        if (activeIndex !== null) {
            if (typeof e.preventDefault === 'function') e.preventDefault();
            s.update({
                mentionPicker: {
                    ...p,
                    activeIndex: activeIndex
                }
            });
            return true;
        }
        if (e.key === 'Enter' || e.key === 'Tab') {
            if (typeof e.preventDefault === 'function') e.preventDefault();
            $f73b5785813cd548$export$f645d6d077df4296(el, s, options[idx]);
            return true;
        }
        if (e.key === 'Escape') {
            if (typeof e.preventDefault === 'function') e.preventDefault();
            // Close the list only. No blur: the caret, the draft and the typed query
            // all stay exactly where the user left them.
            s.update({
                mentionPicker: null
            });
            return true;
        }
        return false;
    }
    // A picker that is open but still empty (an async type mid-fetch) answers
    // Escape and nothing else.
    if (e.key === 'Escape') {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        s.update({
            mentionPicker: null
        });
        return true;
    }
    return false;
};
// THE FOCUS PANEL's keys from the field (DESIGN-COMPOSER-FOCUS-POPOVER-
// CONTEXT-INSPECT-1; shared functions/aiPanelFocus.js): ↑ in an EMPTY field
// (the caret has nowhere to go) opens the panel on the row nearest the field;
// Escape puts a painted panel away and keeps the field's focus. Never with a
// modifier, never while a picker or the "+" menu owns the keys (checked by
// the caller's order above), never on a host without the panel.
const $f73b5785813cd548$var$_aiPanelKeys = (e, el, s)=>{
    if (e.key !== 'ArrowUp' && e.key !== 'Escape') return false;
    if (e.altKey || e.metaKey || e.ctrlKey || e.shiftKey) return false;
    if (!(0, $lF4Ko.aiPanelOf)(el)) return false;
    if (e.key === 'ArrowUp' && !String(s && s.draft || '').trim()) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        (0, $lF4Ko.aiPanelOpen).call(el, 'rows');
        return true;
    }
    if (e.key === 'Escape' && (0, $lF4Ko.aiPanelShown)(el)) {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
        (0, $lF4Ko.aiPanelDismiss).call(el);
        return true;
    }
    return false;
};

});
parcelRegister("lF4Ko", function(module, exports) {

$parcel$export(module.exports, "aiPanelOf", () => $fc511c01c61e5a7a$export$592f7ab603bc99aa);
$parcel$export(module.exports, "aiPanelShown", () => $fc511c01c61e5a7a$export$dd6cd119593f5e01);
$parcel$export(module.exports, "aiPanelOpen", () => $fc511c01c61e5a7a$export$1cf93e6ab1766a58);
$parcel$export(module.exports, "aiPanelDismiss", () => $fc511c01c61e5a7a$export$7ec6803940fc73);
// aiPanelFocus — opening, focusing and putting away the composer's focus
// panel (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1; the panel is
// components/_simone/Suggestions.js, mounted in CanvasPromptTextarea's
// PromptBand).
//
// The panel PAINTS while the composer has focus (`_promptFocused`) and
// `root._aiPanel` does not say otherwise:
//   null         the resting rule — on focus, except while the assistant's
//                thread or drawer holds the answer (it steps aside for it)
//   'open'       asked for (the context pill, ↑ in an empty field): shown even
//                over the thread, until focus leaves or it is put away
//   'dismissed'  put away (Escape, a pick, a verb) — until the field gets
//                focus again
//
// Every function takes `this` = an element INSIDE the composer (the field,
// the pill, a panel row); the composer is found by its key through `lookup`.

var $3CWNx = parcelRequire("3CWNx");
const $fc511c01c61e5a7a$var$_aipfComposerOf = (el)=>{
    if (!el) return null;
    if (el.key === 'CanvasPromptTextarea') return el;
    return typeof el.lookup === 'function' ? el.lookup('CanvasPromptTextarea') : null;
};
const $fc511c01c61e5a7a$export$592f7ab603bc99aa = (el)=>{
    const composer = $fc511c01c61e5a7a$var$_aipfComposerOf(el);
    const band = composer && composer.PromptBand;
    return band && band.SimoneSuggestions || null;
};
const $fc511c01c61e5a7a$export$dd6cd119593f5e01 = (el)=>{
    const panel = $fc511c01c61e5a7a$export$592f7ab603bc99aa(el);
    return !!(panel && panel.node && (0, $3CWNx.menuNodeVisible)(panel.node));
};
const $fc511c01c61e5a7a$export$1cf93e6ab1766a58 = function aiPanelOpen(target) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    root.update({
        _aiPanel: 'open',
        _promptFocused: true
    }, {
        preventFetch: true
    });
    const panel = $fc511c01c61e5a7a$export$592f7ab603bc99aa(el);
    if (!panel) return true;
    const scope = target === 'scope';
    (0, $3CWNx.focusFirstMenuRow)(()=>panel.node, {
        selector: scope ? '[role="radio"][aria-checked="true"]' : '[role="menuitem"]',
        last: !scope,
        when: (node)=>(0, $3CWNx.menuNodeVisible)(node)
    });
    return true;
};
const $fc511c01c61e5a7a$export$7ec6803940fc73 = function aiPanelDismiss() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const composer = $fc511c01c61e5a7a$var$_aipfComposerOf(el);
    const field = composer && composer.Textarea && composer.Textarea.node;
    const doc = typeof document !== 'undefined' ? document : null;
    if (field && typeof field.focus === 'function' && (!doc || doc.activeElement !== field)) field.focus();
    root.update({
        _aiPanel: 'dismissed'
    }, {
        preventFetch: true
    });
    return true;
};

});


parcelRegister("jtbYB", function(module, exports) {

$parcel$export(module.exports, "storeItemSlug", () => $e2ca040da9daccea$export$9fdb86fabe61ae53);
$parcel$export(module.exports, "storeItemText", () => $e2ca040da9daccea$export$34e4ec19d65c4065);
// THE store-item copy resolver — the one place a store row's human-readable
// `name` / `description` is read for display.
//
// IT LIVES IN `shared/` BECAUSE IT HAS TWO CONSUMERS, NOT ONE. The App Store
// (`packages/marketplace`, which re-exports it from its own barrel so every
// `el.call('storeItemText', …)` site there is unchanged) and the SHELL: an
// installed app contributes its navbar tab + launcher tile from its published
// manifest (`configDefaults.navbar` / `.apps`), and those rows used to print
// the manifest's English literal while the store printed the app's real,
// translated name — "Warehouse" in the navbar, "Inventory / ინვენტარი" in the
// store, for the same record. One name for one app means ONE resolver for both
// surfaces; a second copy in the shell is the drift this file exists to
// prevent. It also has to be EAGER on a shell route: marketplace's own barrel
// folds in only on `/marketplace*`, so a shell-route render site could not
// reach it there at all.
//
// A store row is a LIVE RECORD (`sdk.listPublicProjects({ projectType: … })`,
// `integration_kinds`), so its name and description are CONTENT owned by the
// record, not copy owned by this app. They can never be hardcoded here, and a
// single polyglot key per row would break the moment a third party publishes
// one. So display copy resolves from three sources per field, English LAST.
//
// `name`:
//   1. `item.i18n[lang].name` — the record's own localized content. No
//      endpoint serves this field today; it is the path a third-party
//      publisher takes once the record carries it, and the reason this
//      resolver is ordered rather than a plain polyglot lookup.
//   2. `marketplace.app.<slug>.name` — a polyglot key, for the store apps
//      Symbols itself ships. `translate()` returns its INPUT unchanged when the
//      key is unknown, so a row nobody has translated falls straight through
//      to (3) with no branch here.
//   3. `item.name` — the copy the record already carries (see `description` 3).
//
// `description` — THE APP'S ONE LINE (Nika 2026-10-31, field choice A: one
// text per app, on every surface):
//   1. the App Store listing's tagline (`metadata.store.tagline`,
//      docs/APP_STORE_LISTING.md §2) in the session language, else English,
//      else the first language it has — the rule of the store's own
//      `appStoreText`, so the store page's lead line and every card, row and
//      caption read the same words. There is no shared polyglot line for an
//      app any more (`marketplace.app.<slug>.descr` is gone): the listing the
//      app ships beside its name is its one source.
//   2. `item.i18n[lang].description` — the record's own localized content.
//   3. `item.description` — the copy the record already carries, passed
//      through `translate()` once so a SEED row that stores a polyglot key in
//      that field resolves and a LIVE row's real prose comes back unchanged.
//
// There is never a fourth source and never a per-app special case: a render
// site that reads `item.name` / `item.description` directly is the defect this
// file exists to prevent.
//
// `<slug>` is derived from the record identity (`item.key`, else the last
// segment of `item.id`), NOT from a hand-kept map — a map is a per-app special
// case with extra steps. Two records that fold to the same slug share one key
// space by design; the record's own i18n (source 1) outranks it either way.
//
// A CALLER NEED NOT HOLD A STORE ROW. The contract is `{ key, name }` /
// `{ key, description }` — anything carrying the record's identity plus the
// copy it already has. The shell's navbar/launcher rows pass
// `{ key: row.appKey, name: row.label }` (functions/workspaceConfigs.js stamps
// `appKey` from the installed app's `appId`), so a house app resolves through
// `name` 2 and a third party's app, an extension, or a customer's own renamed
// tab falls through `name` 3 untouched — `translate()` returns its input
// unchanged for an unknown key, so none of that needs a branch here. A caller
// that carries no `store` at all (the /add-app card, the search caption, the
// welcome's app rows) reads the listing of the App Store row with the same
// key in the catalogue the shell already loaded (`root._wsAppsCatalog`, whose
// rows carry `store: { tagline }` — workspace functions/workspaceApps.js). A
// row that says `store: null` has no listing and borrows none, and an item of
// another kind (an integration, a template) never borrows an app's.
// One key segment out of a record identity: `cap-table-app` -> `capTableApp`.
// Key segments are lowerCamelCase (docs/I18N-CONVENTION.md §4) and every i18n
// gate matches `[A-Za-z0-9]`, so a hyphen, underscore or dot in a project key
// has to fold into a camel hump rather than survive into the key.
const $e2ca040da9daccea$var$_storeTextSlugSegment = (raw)=>{
    const parts = String(raw || '').split(/[^A-Za-z0-9]+/).filter(Boolean);
    if (!parts.length) return '';
    const [head, ...rest] = parts;
    if (!/^[A-Za-z]/.test(head)) return '';
    return head.charAt(0).toLowerCase() + head.slice(1) + rest.map((p)=>p.charAt(0).toUpperCase() + p.slice(1)).join('');
};
const $e2ca040da9daccea$export$9fdb86fabe61ae53 = (item)=>{
    if (!item) return '';
    const raw = item.key || String(item.id || '').split('.').pop() || '';
    return $e2ca040da9daccea$var$_storeTextSlugSegment(raw);
};
// The active interface language, through polyglot's OWN resolver — never a
// second hand-written `root.lang > defaultLang > 'en'` chain (a duplicated
// precedence rule always drifts; smbls fixed exactly that in
// `plugins/polyglot/index.js`).
const $e2ca040da9daccea$var$_storeTextLang = (el)=>{
    if (!el || typeof el.call !== 'function') return 'en';
    return el.call('getActiveLang') || 'en';
};
const $e2ca040da9daccea$export$34e4ec19d65c4065 = function(item, field, el) {
    if (!item || !field) return '';
    const source = el || this;
    if (field !== 'name' && field !== 'description') return item[field] || '';
    const lang = $e2ca040da9daccea$var$_storeTextLang(source);
    // description 1 — the App Store listing's tagline: the item's own listing,
    // else (a caller that carries no `store`) the catalogue row's with this key.
    if (field === 'description') {
        const borrows = item.store === undefined && !!item.key && (!item.kind || item.kind === 'app');
        const state = borrows && source ? source.state : null;
        const root = state ? state.root || state : null;
        const want = borrows ? String(item.key).trim().toLowerCase() : '';
        const row = root && Array.isArray(root._wsAppsCatalog) ? root._wsAppsCatalog.find((r)=>r && r.key && String(r.key).trim().toLowerCase() === want) : null;
        const store = borrows ? row && row.store : item.store;
        const tagline = store && typeof store === 'object' ? store.tagline : null;
        if (typeof tagline === 'string' && tagline.trim()) return tagline.trim();
        if (tagline && typeof tagline === 'object') {
            const said = [
                tagline[lang],
                tagline.en,
                ...Object.values(tagline)
            ].find((v)=>typeof v === 'string' && v.trim());
            if (said) return said.trim();
        }
    }
    // name 1 / description 2 — the record's own localized content.
    const localized = item.i18n?.[lang]?.[field];
    if (typeof localized === 'string' && localized.trim()) return localized;
    // name 2 — a polyglot key, for the store apps we ship.
    const slug = field === 'name' ? $e2ca040da9daccea$export$9fdb86fabe61ae53(item) : '';
    if (slug && source && typeof source.call === 'function') {
        const key = `marketplace.app.${slug}.name`;
        const translated = source.call('polyglot', key);
        if (translated && translated !== key) return translated;
    }
    // 3 — the copy the record already carries. On a LIVE row that is real
    // English prose. On a SEED row it is a polyglot key the record itself
    // carries (`apps.catalog.<id>.descr` — packages/shared/functions/
    // marketplaceCatalog.js keys its 31 descriptions the key-in-state way), so
    // it goes through `polyglot` too. `translate()` returns its input unchanged
    // when nothing resolves, so prose is untouched and a key never reaches the
    // screen raw.
    const own = item[field] || '';
    if (!own || !source || typeof source.call !== 'function') return own;
    return source.call('polyglot', own);
};

});

parcelRegister("edgad", function(module, exports) {

$parcel$export(module.exports, "sceneActions", () => $a58ed15cf8e590bb$export$ffcaa80d56d2b0c1);
const $a58ed15cf8e590bb$export$ffcaa80d56d2b0c1 = function sceneActions() {
    return {
        update: async (el, s, ctx)=>{
            const { demoFrameElement: demoFrameElement } = el.data;
            if (!demoFrameElement) return;
            if (s.variant) s.variant = s.variant;
            const demoComponent = el.call('deepClone', s.value);
            const frameProps = {
                ...el.scope.frameProps,
                ...s,
                style: {
                    transform: `scale(${parseFloat(s.zoomLevel, 2)})`
                }
            };
            if (s.base) frameProps.fontSize = s.base + 'px';
            if (s.ratio) frameProps['--spacing-ratio'] = s.ratio;
            demoFrameElement.update(frameProps);
            demoFrameElement.state.set(s.state);
            demoFrameElement.demoComponent.update(demoComponent);
        },
        recreate: async (el, s, ctx)=>{
            if (el.data.demoFrameElement) {
                el.data.demoFrameElement.node.remove();
                el.data.demoFrameElement.remove();
                delete el.data.demoFrameElement;
            }
            await el.onRenderScene?.(el, s, ctx);
        }
    };
};

});

parcelRegister("8aizM", function(module, exports) {

$parcel$export(module.exports, "createBucket", () => $5f1daab98f3e6369$export$1b8f2a181b92603a);
const $5f1daab98f3e6369$export$1b8f2a181b92603a = async function createBucket(project) {
    const API_URL = this.getConfig().apiUrl;
    const randomString = Math.random().toString(36).slice(2, 15);
    const bucket = `symbols-bucket-${project.appKey?.split('.')[0]}-${randomString}`;
    await window.fetch(`${API_URL}/webhook/package`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: project.projectId,
            key: project.appKey,
            bucket: bucket
        })
    }).catch((e)=>{
        throw new Error('Problem with creating bucket', e);
    });
    await this.sdk.setBucket(bucket);
    return bucket;
};

});

parcelRegister("44txC", function(module, exports) {

$parcel$export(module.exports, "findModal", () => $2f6e7371ea7e569c$export$2dd3fdf367431397);
const $2f6e7371ea7e569c$export$2dd3fdf367431397 = function findModal(path) {
    const el = this;
    const pathname = path || window.parent.location.pathname;
    if (!pathname) return {};
    const pathArray = pathname.slice(1).split('/');
    const Modal = el.getModal();
    const lastRoute = pathArray.pop();
    const beforeLastRoute = pathArray.pop();
    const isLastModal = Modal?.routes[`/${lastRoute}`];
    const isLastBeforeModal = Modal?.routes[`/${beforeLastRoute}`];
    return {
        index: isLastModal && 1 || isLastBeforeModal && 2 || 0,
        FoundModal: isLastModal || isLastBeforeModal,
        lastRoute: lastRoute,
        beforeLastRoute: beforeLastRoute
    };
};

});

parcelRegister("eoJPD", function(module, exports) {

$parcel$export(module.exports, "arraizeIconsCategory", () => $a7b6dbd0478a6156$export$866c920f61cf7a80);
const $a7b6dbd0478a6156$export$866c920f61cf7a80 = function arraizeIconsCategory(library, searchTerm) {
    return (()=>{
        const list = Object.keys(library);
        if (searchTerm) return list.filter((value)=>value.includes(searchTerm));
        return list;
    })().map((key)=>({
            key: key,
            value: library[key]
        }));
};

});

parcelRegister("glrHw", function(module, exports) {

$parcel$export(module.exports, "prettifyCode", () => $be64185bf3b2240a$export$5f0d86b4d94900dc);

const $be64185bf3b2240a$export$5f0d86b4d94900dc = async function prettifyCode(code, opts = {}) {
    const beautify = await (parcelRequire("7vDIr"));
    return beautify.js(code, {
        indent_size: 2,
        space_in_empty_paren: true,
        ...opts
    });
};

});

parcelRegister("1D39j", function(module, exports) {

$parcel$export(module.exports, "loadIntercom", () => $12fbe057dade424b$export$132b3e90029bcb16);
const $12fbe057dade424b$export$132b3e90029bcb16 = function loadIntercom() {
    if (typeof window === 'undefined') return;
    // Full Symbols root state
    const s = this.getRootState();
    const APP_ID = 'i3suvh8k';
    const toUnix = (iso)=>iso ? Math.floor(new Date(iso).getTime() / 1000) : undefined;
    // ---------------------------
    // 🔹 USER IDENTITY
    // ---------------------------
    const userId = s.userId;
    const email = s.email;
    const name = s.username || s.projectName || 'User';
    const createdAt = toUnix(s.createdAt);
    const lastLogin = toUnix(s.lastLogin);
    // ---------------------------
    // 🔹 PROJECT (merged “company”) PROFILE
    //    This is what you asked for.
    //    Everything that belongs to a workspace, team,
    //    account, plan, project → goes under this.
    // ---------------------------
    const project = {
        id: s.projectId,
        name: s.projectName,
        key: s.projectKey || s.appKey,
        owner: s.workingProjectOwner || s.owner?.username,
        role: s.projectRole,
        type: s.projectType,
        visibility: s.visibility,
        tier: s.tier,
        subscription_id: s.subscription,
        status: s.status,
        created_at: createdAt,
        updated_at: toUnix(s.updatedAt),
        active_project: this.getAppKey(),
        // Optional but useful for Intercom segmentation:
        seats: s.seats,
        versions_count: s.versionscount,
        docs_context: s.docsContext,
        language: s.language
    };
    // ---------------------------
    // 🔹 EXTRA ATTRIBUTES (remaining root data)
    // ---------------------------
    const customAttributes = {
        access: s.access,
        global_role: s.globalRole,
        auth_provider: s.authProvider,
        last_login_at: lastLogin,
        is_account_owner: s.isAccountOwner,
        environment: s.environment,
        scenes_theme: s.sceneTheme
    };
    const bootAndShow = ()=>{
        if (!window.Intercom || typeof window.Intercom !== 'function') return;
        if (!window.__intercomBooted) {
            window.__intercomBooted = true;
            window.Intercom('boot', {
                app_id: APP_ID,
                hide_default_launcher: true,
                // ---------------------------
                // USER PROFILE
                // ---------------------------
                user_id: userId,
                name: name,
                email: email,
                created_at: createdAt,
                // ---------------------------
                // PROJECT PROFILE (YOUR REQUEST)
                // ---------------------------
                company: project,
                // ---------------------------
                // CUSTOM ATTRIBUTES
                // ---------------------------
                ...customAttributes
            });
        }
        // Safety: hide launcher if anything re-enabled it
        window.Intercom('update', {
            hide_default_launcher: true
        });
        // Open messenger
        window.Intercom('show');
    };
    // Script already loaded
    if (window.__intercomLoaded) {
        bootAndShow();
        return;
    }
    if (window.__loadingIntercom) return;
    window.__loadingIntercom = true;
    // Lazy-load Intercom
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${APP_ID}`;
    script.onload = ()=>{
        window.__intercomLoaded = true;
        bootAndShow();
    };
    document.head.appendChild(script);
};

});

parcelRegister("ge15T", function(module, exports) {

$parcel$export(module.exports, "codifyFetch", () => $bcfecd6cdebcd0b0$export$a423fd08ef0a0cf8);
const $bcfecd6cdebcd0b0$export$a423fd08ef0a0cf8 = function codifyFetch() {
    const s = this.state;
    const data = {
        method: s.method,
        endpointUrl: s.endpointUrl,
        headers: s.headers,
        params: s.params,
        auth: s.auth,
        body: s.body
    };
    const code = this.call('stringifyCode', data, {
        preventExportDefult: true,
        indent: 1
    });
    return `async () => {
  const options = ${code}

  return await window.fetch(options.endpointUrl, options)
}`;
};

});

parcelRegister("fGay4", function(module, exports) {

$parcel$export(module.exports, "getProjectMembers", () => $b6a2f5f8f881e1d0$export$6f905a407a33be1d);
const $b6a2f5f8f881e1d0$export$6f905a407a33be1d = async function getProjectMembers() {
    const s = this.getRootState() || {};
    const ordering = {
        owner: 0,
        admin: 1,
        editor: 2,
        guest: 3
    };
    // No SDK in this host (UI-kit catalog, preview frame, spec host) → fall
    // through to the empty path this function already owns, which seeds the
    // list with the signed-in user. UsersTable.onRender does `s.set(result)`,
    // so this MUST always answer an array.
    const projectMembers = (await this.sdk?.getProjectMembers?.(this.getRootState('projectId')) || []).sort((a, b)=>{
        const roleDiff = ordering[a.role] - ordering[b.role];
        return roleDiff === 0 ? a.name > b.name ? 1 : a.name < b.name ? -1 : 0 : roleDiff;
    });
    if (projectMembers.length === 0) projectMembers.push({
        email: s.email,
        id: s.userId,
        joinedAt: s.createdAt,
        name: s.name,
        role: s.globalRole
    });
    return projectMembers;
};

});

parcelRegister("hrcPT", function(module, exports) {

$parcel$export(module.exports, "invitePolicy", () => $cb1eea4120a3b6e3$export$a3c3c5f5ceaa2525);
$parcel$export(module.exports, "magicLinkOffered", () => $cb1eea4120a3b6e3$export$bf638520742bd8e);
$parcel$export(module.exports, "grantableInviteRoles", () => $cb1eea4120a3b6e3$export$9fdd18e157174637);
// THE INVITE POLICY — the one client rule for "may this person invite, at
// which roles, and whose role may they change, to what". Every control in the
// invite panel (the email form, its role select, the member-row role selects,
// the no-permission caption) reads this ONE function; nothing in the panel
// restates a role table of its own.
//
// Written model: workspace/docs/INVITE-PERMISSIONS-MODEL.md.
//
// IT MIRRORS THE SERVER, rule for rule (server main, 2026-10-08) — so the
// panel never offers a control the server refuses:
//
//   ORG (routes/organizations.js + OrganizationController)
//     POST  /:orgId/invitations        requireOrgRole(ORG_MGMT_ROLES)
//       createInvitation               role ∈ INVITABLE_ORG_ROLES
//                                      rank(caller) >= rank(role)
//                                      a PERSONAL org is refused (400)
//     POST  /:orgId/invitations {kind: 'link'}   (INVITE-MAGIC-LINK-1)
//       createLinkInvitation           the same gate and the same ceiling,
//                                      AND role <= maintainer by its resolved
//                                      base tier (400 link_role_too_high);
//                                      <= 25 open links per org (409
//                                      too_many_open_links — the panel shows
//                                      that refusal; it keeps no count)
//     PATCH /:orgId/members/:memberId  requireOrgRole(ORG_MGMT_ROLES)
//       updateMember                   new role != owner (transfer only)
//                                      co-owner only when the caller is owner
//                                      rank(caller) >= rank(target's CURRENT)
//   PROJECT (routes/projects.js + ProjectMemberController)
//     POST  /:projectId/invite         MANAGE_MEMBERS (admin, owner)
//       inviteMember                   inviter role ∈ {admin, owner}
//                                      admin only when the inviter is owner
//                                      owner never (one owner; transfer)
//     PATCH /:projectId/members/:id    MANAGE_MEMBERS
//       updateMemberRole               role ∈ {guest, editor, admin, owner}
//                                      owner only by an owner
//
// Where the panel is STRICTER than the server it says so below; it is never
// looser. Stricter, on purpose:
//   - a new org role is capped at the caller's own rank (the server checks
//     only the target's CURRENT rank, so a maintainer could lift a member to
//     admin through the API — that gap belongs to the server, not to a menu);
//   - owner rows and your own row are read-only here (ownership moves by
//     transfer; a self-demotion from a dropdown is a foot-gun);
//   - `owner` is never offered (the panel does not transfer ownership).
//
// ONE SOURCE FOR THE CALLER'S ROLE:
//   org      root.org (the active org row) → root.orgs row → the JWT claims
//            (`org_role`, `is_owner`). A row may carry `baseTier` (a custom
//            role resolved to its tier); a custom role WITHOUT a tier is a
//            known role the client cannot rank → no authority shown.
//   project  root.projectRole, plus `hasProjectPermission('inviteMembers')`
//            when the element carries it (the embed answers false there).
//
// LINK ROLES: `linkRoles` is `inviteRoles` capped at maintainer — a magic
// link is a bearer credential (whoever opens it first joins), so it never
// grants admin, whoever makes it. The magic-link select reads it; the email
// form keeps `inviteRoles`.
//
// UNKNOWN vs KNOWN: while the role is still unresolved (boot, an org switch)
// the invite form STAYS — an owner must never lose the control during
// hydration — but it offers only the roles every inviter may grant (org:
// contributor + member; project: guest + editor). Member-row role selects
// stay read-only until the role is known. A KNOWN role that may not invite
// gets no form at all, and the panel says why (`reason`).
//
// Self-contained by design: every table is declared INSIDE the function. It
// is reached through `el.call('invitePolicy', s)` and stringified for
// platform delivery, so a module-scope const read from inside it would read
// as undefined post-frank (FA204).
function $cb1eea4120a3b6e3$export$a3c3c5f5ceaa2525(s) {
    const el = this;
    const root = s && s.root || el && typeof el.getRootState === 'function' && el.getRootState() || {};
    const LABEL = {
        owner: 'members.role.owner',
        'co-owner': 'members.role.coOwner',
        admin: 'members.role.admin',
        maintainer: 'members.role.maintainer',
        member: 'members.role.member',
        contributor: 'members.role.contributor',
        editor: 'members.role.editor',
        guest: 'members.role.guest',
        viewer: 'members.role.viewer'
    };
    const opt = (value)=>({
            value: value,
            labelKey: LABEL[value]
        });
    const me = String(root.currentUserEmail || '').toLowerCase();
    const isSelf = (m)=>!!me && String(m && m.email || '').toLowerCase() === me;
    const none = (context, reason)=>({
            context: context,
            role: null,
            resolved: true,
            mayInvite: false,
            reason: reason,
            inviteRoles: [],
            linkRoles: [],
            defaultRole: null,
            mayManage: false,
            editRolesFor: ()=>[],
            labelKey: (r)=>LABEL[r] || null
        });
    // ── PROJECT ────────────────────────────────────────────────────────
    if (root.projectId) {
        const MGMT = [
            'admin',
            'owner'
        ];
        const role = root.projectRole || null;
        const perm = el && typeof el.hasProjectPermission === 'function' ? !!el.hasProjectPermission('inviteMembers') : true;
        if (!role) return {
            ...none('project', null),
            resolved: false,
            mayInvite: perm,
            reason: perm ? null : 'noPermission',
            inviteRoles: perm ? [
                'guest',
                'editor'
            ].map(opt) : [],
            defaultRole: perm ? 'guest' : null
        };
        const manage = MGMT.includes(role) && perm;
        if (!manage) return {
            ...none('project', 'noPermission'),
            role: role
        };
        const inviteRoles = [
            'guest',
            'editor',
            'admin'
        ].filter((r)=>r !== 'admin' || role === 'owner').map(opt);
        const EDITABLE = [
            'guest',
            'editor',
            'admin'
        ];
        return {
            ...none('project', null),
            role: role,
            mayInvite: true,
            inviteRoles: inviteRoles,
            defaultRole: 'guest',
            mayManage: true,
            editRolesFor: (m)=>{
                if (!m || !m.memberId || isSelf(m)) return [];
                if (!EDITABLE.includes(m.role)) return [];
                return EDITABLE.map(opt);
            }
        };
    }
    // ── ORG ────────────────────────────────────────────────────────────
    const orgId = root.jwtClaims && root.jwtClaims.workspace_org_id;
    if (!orgId) return none(null, null);
    const RANK = {
        contributor: 1,
        member: 2,
        maintainer: 3,
        admin: 4,
        'co-owner': 5,
        owner: 6
    };
    const MGMT = [
        'owner',
        'co-owner',
        'admin',
        'maintainer'
    ];
    const INVITABLE = [
        'contributor',
        'member',
        'maintainer',
        'admin'
    ];
    const EDITABLE = [
        'contributor',
        'member',
        'maintainer',
        'admin',
        'co-owner'
    ];
    const isActive = (o)=>!!o && (!(o.id || o._id) || String(o.id || o._id) === String(orgId));
    const fromRoot = isActive(root.org) ? root.org : null;
    const fromList = (root.orgs || []).find((o)=>o && String(o.id || o._id) === String(orgId)) || null;
    const row = fromRoot || fromList;
    if (row && row.type === 'personal') return none('org', 'personalOrg');
    const claims = root.jwtClaims || {};
    const rawRole = fromRoot && fromRoot.role || fromList && fromList.role || claims.org_role || (claims.is_owner === true ? 'owner' : null);
    const tierOf = (r, b)=>RANK[b] ? b : RANK[r] ? r : null;
    const tier = tierOf(rawRole, fromRoot && fromRoot.baseTier || fromList && fromList.baseTier);
    if (!rawRole) return {
        ...none('org', null),
        resolved: false,
        mayInvite: true,
        reason: null,
        inviteRoles: [
            'contributor',
            'member'
        ].map(opt),
        linkRoles: [
            'contributor',
            'member'
        ].map(opt),
        defaultRole: 'member'
    };
    if (!tier || !MGMT.includes(tier)) return {
        ...none('org', 'noPermission'),
        role: tier || rawRole
    };
    const rank = RANK[tier];
    // The server's LINK_INVITE_MAX_ROLE: the highest role a magic link grants.
    const LINK_MAX = RANK.maintainer;
    return {
        ...none('org', null),
        role: tier,
        mayInvite: true,
        inviteRoles: INVITABLE.filter((r)=>RANK[r] <= rank).map(opt),
        linkRoles: INVITABLE.filter((r)=>RANK[r] <= rank && RANK[r] <= LINK_MAX).map(opt),
        defaultRole: 'member',
        mayManage: true,
        editRolesFor: (m)=>{
            if (!m || !m.memberId || isSelf(m)) return [];
            const targetTier = tierOf(m.role, m.tier);
            if (!targetTier || RANK[targetTier] > rank) return [];
            const choices = EDITABLE.filter((r)=>RANK[r] <= rank && (r !== 'co-owner' || tier === 'owner'));
            // A custom role (or one this caller may not set) has no option that
            // shows it — the row stays read-only rather than display a lie.
            if (!choices.includes(m.role)) return [];
            return choices.map(opt);
        }
    };
}
function $cb1eea4120a3b6e3$export$bf638520742bd8e(s) {
    const el = this;
    const p = el.call('invitePolicy', s);
    return p.context === 'org' && p.mayInvite && p.linkRoles.length > 0 && !!el.sdk && typeof el.sdk.createOrgInvitationLink === 'function';
}
function $cb1eea4120a3b6e3$export$9fdd18e157174637(s) {
    const p = this && typeof this.call === 'function' ? this.call('invitePolicy', s) : null;
    return p && p.inviteRoles || [];
}

});

parcelRegister("hSlMV", function(module, exports) {

$parcel$export(module.exports, "getPrefixForLocalStorage", () => $d03861808d849c3d$export$b0bb5c8c4d68ef36);
const $d03861808d849c3d$export$b0bb5c8c4d68ef36 = function getPrefixForLocalStorage() {};

});

parcelRegister("lM1GM", function(module, exports) {

$parcel$export(module.exports, "addSmblsSubdomains", () => $fd9f641123a0759c$export$1dd5d528565ec1dc);
const $fd9f641123a0759c$export$1dd5d528565ec1dc = async function addSmblsSubdomains(appKey) {
    const res1 = await this.call('addSmblsSubdomain', appKey);
    const res2 = await this.call('addSmblsSubdomain', `www.${appKey}`);
    const successMsg = 'Domain registered successfully';
    if (res1.message.startsWith(successMsg) && res2.message.startsWith(successMsg)) this.call('openNotification', {
        title: successMsg,
        message: this.call('polyglot', 'editor.subdomain.registered').replace('{key}', appKey),
        type: 'success'
    });
    else this.call('openNotification', {
        title: this.call('polyglot', 'editor.subdomain.error'),
        message: res1.message + '\n' + res2.message,
        type: 'error'
    });
};

});

parcelRegister("687hg", function(module, exports) {

$parcel$export(module.exports, "generateSitemap", () => $476922997dc5282e$export$470c106c44438b62);
const $476922997dc5282e$export$470c106c44438b62 = function generateSitemap(baseUrl, routes) {
    const urls = Object.entries(routes).map(([path, config])=>{
        const metadata = config.metadata || {};
        const canonical = metadata.canonical || `${baseUrl}${path === '/' ? '' : path}`;
        return `
  <url>
    <loc>${canonical}</loc>
    <lastmod>${new Date().toISOString()}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>${path === '/' ? '1.0' : '0.8'}</priority>
  </url>`;
    });
    return `<?xml version="1.0" encoding="UTF-8"?>
<urlset 
  xmlns="http://www.sitemaps.org/schemas/sitemap/0.9",
  xmlns:xhtml="http://www.w3.org/1999/xhtml">
${urls.join('\n')}
</urlset>`;
};

});

parcelRegister("hpKFp", function(module, exports) {

$parcel$export(module.exports, "getPluginSessionFromUrl", () => $cad8f888b5fd4f47$export$204e34bc97b6a501);
const $cad8f888b5fd4f47$export$204e34bc97b6a501 = function getPluginSessionFromUrl() {
    if (typeof window === 'undefined') return null;
    let session = null;
    try {
        session = new URL(window.location.href).searchParams.get('session');
    } catch  {
    // Ignore URL parsing errors
    }
    return session;
};

});

parcelRegister("1Xpun", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "scopeWorkspaceListToWhitelabelHost", () => $16cf12b4b315b3c6$export$da3d2ee8537bb45e);
$parcel$export(module.exports, "scopeSnapshotToWhitelabelHost", () => $16cf12b4b315b3c6$export$1286d3a4f30364a);
$parcel$export(module.exports, "default", () => $16cf12b4b315b3c6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "scopeClaimsToWhitelabelHost", () => $16cf12b4b315b3c6$export$f68239c6895e0eb9);
// WS-WHITELABEL-TENANT-SCOPE-1 — a white-label host sees ONE org and ONE
// workspace, and nothing else.
//
// ── WHY THIS EXISTS ────────────────────────────────────────────────────────
// A branded host names its customer in DNS. Everything else about the session
// is still account-wide: `orgs` carries every organisation the signed-in user
// belongs to (17, on the account this was measured with), and any code path
// that falls back to "the session's ambient org/workspace" can therefore land
// on a DIFFERENT customer under this customer's own domain.
//
// That is not hypothetical. Measured on gita.pr.symbols.app 2026-08-31, with
// GITA present in `orgs` the whole time:
//   root.workspace._id  69e54008…  displayName "Moll"  org "community"
// The org switcher read "Symbols Community", the nav was the default
// Studio/Tasks/Files, and none of GITA's apps rendered. Sampled every 60ms for
// 10s: it never corrected. On other loads the same URL resolved GITA — the
// outcome is a race, which is why it reads as "renders another workspace, then
// re-renders to mine".
//
// The existing mitigations all CORRECT state after the fact: customDomainBoot
// resolves the host and navigates (inert with the MWT flag off), or pins the
// org through the SDK. Correcting after the fact is what produces the flash,
// the race, and the loads that never converge.
//
// This function removes the ambient alternative instead. Applied to the boot
// snapshot — the single object every downstream consumer reads for orgs,
// workspaces, the active org and the active workspace — there is no other
// tenant left to fall back TO. Downstream code needs no guard of its own,
// which is the property that makes this hold as new surfaces are added.
//
// ── FAIL CLOSED ────────────────────────────────────────────────────────────
// If the signed-in user is NOT a member of the host's org, this returns an
// EMPTY scope, never their own orgs. A stranger on a customer's domain must
// see nothing — falling back to "their" content is exactly the wrong-tenant
// render this exists to stop, just with the tenants swapped.
//
// The empty scope is expressed with the keys the snapshot ALREADY has
// (`orgs: []`, `org: null`, `workspace: null`) and no new one. An earlier cut
// added a `whitelabelNoAccess` flag; it is deliberately gone. The boot
// snapshot is a CLOSED shape — `__tests__/bootAuthSnapshotClosedShape.test.js`
// enforces that every key either builder emits is allowlisted AND classified
// in state.js — and because that guard reads bootShell.js as TEXT, a key
// introduced HERE would ride the `{ ...restAuth }` spread into root.update
// while remaining invisible to it. Evading a guard is not passing it. A
// no-access SURFACE should add the key deliberately, through the allowlist
// and the classification, at the point something actually renders it.
//
// ── NOT A UI FILTER ────────────────────────────────────────────────────────
// Hiding other organisations in the switcher is a consequence of this, not the
// mechanism. A UI-only filter would leave the wrong tenant loaded and merely
// invisible — still billed, still fetched, still rendered underneath.
//
// Pure by construction: no imports, no I/O, no globals. The whole contract is
// unit-testable without booting the shell (the `isAuthRejection` precedent in
// bootShell.js).
const $16cf12b4b315b3c6$var$idOf = (row)=>row ? String(row.id || row._id || '') : '';
const $16cf12b4b315b3c6$var$orgIdOfWorkspace = (w)=>String(w && (w.org_id || w.organization) || '');
const $16cf12b4b315b3c6$export$da3d2ee8537bb45e = (list, hostScope)=>{
    if (!Array.isArray(list)) return list;
    if (hostScope === false) return [];
    const orgId = hostScope && hostScope.organizationId ? String(hostScope.organizationId) : '';
    if (!orgId) return list;
    const inOrg = list.filter((w)=>$16cf12b4b315b3c6$var$orgIdOfWorkspace(w) === orgId);
    const wantedWs = hostScope.workspaceId ? String(hostScope.workspaceId) : '';
    return wantedWs ? inOrg.filter((w)=>$16cf12b4b315b3c6$var$idOf(w) === wantedWs) : inOrg;
};
const $16cf12b4b315b3c6$export$1286d3a4f30364a = (snapshot, hostScope)=>{
    if (!snapshot || typeof snapshot !== 'object') return snapshot;
    // A customer host that could not prove its tenant renders NONE — never the
    // account's ambient one (WHITELABEL-STRICT-TENANT-SCOPE-1). Same empty
    // shape as the non-member case below.
    if (hostScope === false) return {
        ...snapshot,
        orgs: [],
        workspaces: [],
        org: null,
        workspace: null
    };
    const orgId = hostScope && hostScope.organizationId ? String(hostScope.organizationId) : '';
    // No host scope: a platform host. Untouched — this must never degrade the
    // platform experience to fix the branded one.
    if (!orgId) return snapshot;
    const orgs = Array.isArray(snapshot.orgs) ? snapshot.orgs : [];
    const hostOrg = orgs.find((o)=>$16cf12b4b315b3c6$var$idOf(o) === orgId) || null;
    // Not a member. Empty, never their own orgs — see FAIL CLOSED above.
    if (!hostOrg) return {
        ...snapshot,
        orgs: [],
        workspaces: [],
        org: null,
        workspace: null
    };
    // The host's workspace ONLY (or, when the host names none, this org's). A
    // workspace row carries `org_id` (bootShell's own `workspace?.org_id ||
    // claims.workspace_org_id` precedent).
    const workspaces = $16cf12b4b315b3c6$export$da3d2ee8537bb45e(Array.isArray(snapshot.workspaces) ? snapshot.workspaces : [], hostScope);
    // The host's workspace. When the host names one that is not in the list
    // the user has no membership there: no workspace, never another one. The
    // first-in-org fallback survives only for a host that names none.
    const wantedWs = hostScope.workspaceId ? String(hostScope.workspaceId) : '';
    const workspace = wantedWs ? workspaces.find((w)=>$16cf12b4b315b3c6$var$idOf(w) === wantedWs) || null : workspaces[0] || null;
    // Keep the claims consistent with what was just pinned. Leaving a stale
    // `active_workspace_id` here is precisely how the wrong workspace re-enters
    // downstream (WS-ACTIVE-WORKSPACE-ID-SHAPE-1 read exactly this claim).
    const jwtClaims = {
        ...snapshot.jwtClaims || {}
    };
    jwtClaims.workspace_org_id = orgId;
    if (workspace) jwtClaims.active_workspace_id = $16cf12b4b315b3c6$var$idOf(workspace);
    return {
        ...snapshot,
        orgs: [
            hostOrg
        ],
        workspaces: workspaces,
        org: hostOrg,
        workspace: workspace,
        jwtClaims: jwtClaims
    };
};
var $16cf12b4b315b3c6$export$2e2bcd8739ae039 = $16cf12b4b315b3c6$export$1286d3a4f30364a;
const $16cf12b4b315b3c6$export$f68239c6895e0eb9 = (claims, hostScope)=>{
    if (!claims || typeof claims !== 'object') return claims;
    // The seed's "tenant could not be established" verdict: the tick derives
    // `orgsList` / `workspacesAll` from these two arrays, so emptying them is
    // what keeps every org the account belongs to off this customer's domain
    // (WHITELABEL-STRICT-TENANT-SCOPE-1).
    if (hostScope === false) return {
        ...claims,
        orgs: [],
        workspaces: []
    };
    const orgId = hostScope && hostScope.organizationId ? String(hostScope.organizationId) : '';
    if (!orgId) return claims;
    const hasOrgs = Array.isArray(claims.orgs);
    const hasWorkspaces = Array.isArray(claims.workspaces);
    if (!hasOrgs && !hasWorkspaces) return claims;
    const out = {
        ...claims
    };
    if (hasOrgs) out.orgs = claims.orgs.filter((o)=>$16cf12b4b315b3c6$var$idOf(o) === orgId);
    // The host's ONE workspace — see scopeWorkspaceListToWhitelabelHost.
    if (hasWorkspaces) out.workspaces = $16cf12b4b315b3c6$export$da3d2ee8537bb45e(claims.workspaces, hostScope);
    // `out.orgs` IS the membership test, and it has already run. An empty list
    // means this user has no business on this host — so nothing else is handed
    // to them either. Leaving the host org's workspaces in place would be a
    // list of another tenant's rooms given to a stranger, which is the same
    // disclosure this function exists to close, one level down. (Real claims
    // for a non-member would not carry them; this is the defensive half, and
    // it is the case the test caught.)
    const isMember = hasOrgs && out.orgs.length > 0;
    if (hasOrgs && !isMember) {
        if (hasWorkspaces) out.workspaces = [];
        return out;
    }
    // Pinning is for members only: naming a concrete workspace id to a
    // non-member would hand them a target. When the claims carry no org list at
    // all there is nothing to test membership against, so nothing is pinned.
    if (isMember) {
        const wanted = hostScope.workspaceId ? String(hostScope.workspaceId) : '';
        const fromList = hasWorkspaces ? wanted && out.workspaces.find((w)=>$16cf12b4b315b3c6$var$idOf(w) === wanted) || out.workspaces[0] || null : null;
        // Prefer a workspace VALIDATED against the scoped list; fall back to the
        // host's own id, which the server resolved for this domain. Either way it
        // cannot name another tenant: the list is already filtered, and the host
        // id belongs to the host's org by construction.
        const pinned = fromList ? $16cf12b4b315b3c6$var$idOf(fromList) : wanted;
        if (pinned) out.active_workspace_id = pinned;
        out.workspace_org_id = orgId;
    }
    return out;
};

});

parcelRegister("jcoQe", function(module, exports) {

$parcel$export(module.exports, "installAppShellSync", () => (parcelRequire("hKCTj")).installAppShellSync);
$parcel$export(module.exports, "uninstallAppShellSync", () => (parcelRequire("hKCTj")).uninstallAppShellSync);
// Shared AppShell helpers — call from each project's app.js `onCreate`.
// Re-exports the installer/uninstaller defined alongside the component so
// consumers can pull them either via `el.call('installAppShellSync', s)`
// (after they're registered on the project) or by importing them
// directly from the components module when needed.

var $hKCTj = parcelRequire("hKCTj");

});

parcelRegister("lmB2G", function(module, exports) {

$parcel$export(module.exports, "projectKind", () => $f8d862ddced093a7$export$851bdbacf76101ab);
$parcel$export(module.exports, "projectKindContext", () => $f8d862ddced093a7$export$c9ada5df8fdf30c);
$parcel$export(module.exports, "splitProjectsByKind", () => $f8d862ddced093a7$export$fe8631f000d2edc8);
$parcel$export(module.exports, "loadProjectKindSignals", () => $f8d862ddced093a7$export$a9dda571bc0d1c07);
// THE APP SPLIT — WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES, docs/APP_SPLIT.md.
//
// Nika 2026-10-19: "strictly divide workspace apps from external apps that
// users build. they should not go to the same canvas. workspace apps are pure
// adons on workspace and websites made on it are deployed and published."
//
// A project is exactly ONE of four kinds, decided by WHERE it runs:
//
//   'workspaceApp' — an add-on that runs INSIDE a workspace: a manifest-2
//                    module (system/crm-app, a custom org module, the takeover
//                    module) or an AI-built app (metadata.extension). It is
//                    installed into a workspace and opened from its launcher.
//                    It is never published as a site. It lives on the
//                    Workspace apps page (/apps) and is built in /add-app or
//                    in code (apps/* + smbls push).
//   'website'      — everything built for people OUTSIDE the workspace: a
//                    site, a landing page, a web / mobile / desktop / TV app,
//                    a presentation. It is deployed and published. It lives
//                    on the Websites board (/studio) and is built in the
//                    canvas editor.
//   'library'      — a shared library / design system (a building block of
//                    websites; it renders on the Websites board as a source
//                    of arrows, never as a thing to publish or install).
//   'template'     — a starting point in the marketplace.
//
// EVERY surface that lists or opens projects asks THIS module — never its own
// guess (the old guess was "not installed here = a website", which turned an
// uninstalled system/bi-app into "our website").
//
// Signals, strongest first:
//   1. server markers on the project row — metadata.workspaceModule (catalog
//      or custom module), metadata.extension (AI-built app), metadata.appKind
//      (server-stamped multipage app) — and, on a LOADED project's content,
//      the module manifest (`manifest: 2`, top level or under config). The
//      project LIST endpoint does not return `metadata` yet (the server half
//      of the ticket adds it), so:
//   2. what this workspace knows (`ctx`, built by projectKindContext): the
//      installed app ids (owner/key — the plural list, the takeover module),
//      the AI-built app ids (project _id — the workspace's extension list and
//      every extension ref) and the App Store catalog ids (owner/key).
//
// `ctx` holds plain ARRAYS of strings (root state stores no Set):
//   { installed: ['system/crm-app', …], extensions: ['6a9…', …],
//     modules: ['system/bi-app', …] }
//
// FA204 / frank trap — every export below carries its own inline helpers;
// none reaches a sibling export or a module-local helper bare.

var $kANrO = parcelRequire("kANrO");
const $f8d862ddced093a7$export$851bdbacf76101ab = (project, ctx)=>{
    const p = project && typeof project === 'object' ? project : {};
    const c = ctx && typeof ctx === 'object' ? ctx : {};
    const lc = (v)=>v == null ? '' : String(v).trim().toLowerCase();
    const isObjectId = (v)=>typeof v === 'string' && /^[a-f0-9]{24}$/i.test(v);
    const listHas = (list, v)=>!!v && Array.isArray(list) && list.some((x)=>lc(x) === v);
    const ownerOf = ()=>{
        const o = p.owner;
        if (typeof o === 'string' && o && !isObjectId(o)) return o;
        if (o && typeof o === 'object') {
            const s = o.slug || o.username || o.key;
            if (s) return s;
        }
        if (p.ownerUsername) return p.ownerUsername;
        const org = p.workspace && typeof p.workspace === 'object' && p.workspace.organization;
        if (org && typeof org === 'object' && org.slug) return org.slug;
        // A board node's `id` is already 'owner/key'.
        if (typeof p.id === 'string' && p.id.indexOf('/') > 0) return p.id.split('/')[0];
        return '';
    };
    const type = lc(p.projectType);
    if (p.isSharedLibrary === true || type === 'library') return 'library';
    if (type === 'template') return 'template';
    const m = p.metadata && typeof p.metadata === 'object' ? p.metadata : {};
    if (m.workspaceModule === true || m.extension === true) return 'workspaceApp';
    if (typeof m.appKind === 'string' && m.appKind) return 'workspaceApp';
    // A loaded project's CONTENT (the editor's root.data) carries the module
    // manifest itself: manifest v2 at the top or under config.
    const cfg = p.config && typeof p.config === 'object' ? p.config : {};
    if (p.manifest === 2 || cfg.manifest === 2) return 'workspaceApp';
    const key = lc(String(p.key || '').split('.')[0]);
    const owner = lc(ownerOf());
    const appId = owner && key ? owner + '/' + key : '';
    if (appId && (listHas(c.installed, appId) || listHas(c.modules, appId))) return 'workspaceApp';
    const dbId = lc(p._id || (isObjectId(p.id) ? p.id : ''));
    if (dbId && listHas(c.extensions, dbId)) return 'workspaceApp';
    return 'website';
};
const $f8d862ddced093a7$export$c9ada5df8fdf30c = (root)=>{
    const r = root && typeof root === 'object' ? root : {};
    const lc = (v)=>v == null ? '' : String(v).trim().toLowerCase();
    const isObjectId = (v)=>typeof v === 'string' && /^[a-f0-9]{24}$/i.test(v);
    const installed = new Set();
    const extensions = new Set();
    const modules = new Set();
    const addAppId = (owner, key)=>{
        if (owner && key) installed.add(lc(owner) + '/' + lc(key));
    };
    const wp = r.workspaceProject;
    if (wp && typeof wp.id === 'string' && wp.id.indexOf('/') > 0) installed.add(lc(wp.id));
    for (const a of Array.isArray(r.workspaceApps) ? r.workspaceApps : []){
        if (!a || typeof a.id !== 'string') continue;
        // An AI-built app publishes its project _id as its id.
        if (isObjectId(a.id)) extensions.add(lc(a.id));
        else if (a.id.indexOf('/') > 0) installed.add(lc(a.id));
    }
    const ws = r.workspace && typeof r.workspace === 'object' ? r.workspace : {};
    const settings = ws.settings && typeof ws.settings === 'object' ? ws.settings : {};
    for (const ref of Array.isArray(settings.workspaceApps) ? settings.workspaceApps : []){
        if (!ref || typeof ref !== 'object') continue;
        if (ref.type === 'extension') {
            if (ref.projectId) extensions.add(lc(ref.projectId));
            continue;
        }
        if (!ref.type || ref.type === 'project') addAppId(ref.owner, ref.key);
    }
    const legacy = settings.workspaceModule;
    if (legacy && typeof legacy === 'object') addAppId(legacy.owner, legacy.key);
    for (const x of Array.isArray(r._userApps) ? r._userApps : []){
        const id = x && (x.id || x._id || x.projectId);
        if (id) extensions.add(lc(id));
    }
    for (const x of Array.isArray(r._wsAppsCatalog) ? r._wsAppsCatalog : [])if (x && x.id && String(x.id).indexOf('/') > 0) modules.add(lc(x.id));
    const sig = r._projectKindSignals && typeof r._projectKindSignals === 'object' ? r._projectKindSignals : null;
    if (sig) {
        for (const id of Array.isArray(sig.extensions) ? sig.extensions : [])if (id) extensions.add(lc(id));
        for (const id of Array.isArray(sig.modules) ? sig.modules : [])if (id) modules.add(lc(id));
    }
    return {
        installed: [
            ...installed
        ],
        extensions: [
            ...extensions
        ],
        modules: [
            ...modules
        ]
    };
};
const $f8d862ddced093a7$export$fe8631f000d2edc8 = (list, ctx)=>{
    const out = {
        websites: [],
        workspaceApps: [],
        libraries: [],
        templates: []
    };
    const c = ctx && typeof ctx === 'object' ? ctx : {};
    const lc = (v)=>v == null ? '' : String(v).trim().toLowerCase();
    const isObjectId = (v)=>typeof v === 'string' && /^[a-f0-9]{24}$/i.test(v);
    const listHas = (arr, v)=>!!v && Array.isArray(arr) && arr.some((x)=>lc(x) === v);
    // Inline copy of projectKind (FA204 — no bare sibling reach).
    const kindOf = (project)=>{
        const p = project && typeof project === 'object' ? project : {};
        const type = lc(p.projectType);
        if (p.isSharedLibrary === true || type === 'library') return 'library';
        if (type === 'template') return 'template';
        const m = p.metadata && typeof p.metadata === 'object' ? p.metadata : {};
        if (m.workspaceModule === true || m.extension === true) return 'workspaceApp';
        if (typeof m.appKind === 'string' && m.appKind) return 'workspaceApp';
        const cfg = p.config && typeof p.config === 'object' ? p.config : {};
        if (p.manifest === 2 || cfg.manifest === 2) return 'workspaceApp';
        let owner = '';
        const o = p.owner;
        if (typeof o === 'string' && o && !isObjectId(o)) owner = o;
        else if (o && typeof o === 'object') owner = o.slug || o.username || o.key || '';
        if (!owner && p.ownerUsername) owner = p.ownerUsername;
        if (!owner) {
            const org = p.workspace && typeof p.workspace === 'object' && p.workspace.organization;
            if (org && typeof org === 'object' && org.slug) owner = org.slug;
        }
        if (!owner && typeof p.id === 'string' && p.id.indexOf('/') > 0) owner = p.id.split('/')[0];
        const key = lc(String(p.key || '').split('.')[0]);
        const appId = owner && key ? lc(owner) + '/' + key : '';
        if (appId && (listHas(c.installed, appId) || listHas(c.modules, appId))) return 'workspaceApp';
        const dbId = lc(p._id || (isObjectId(p.id) ? p.id : ''));
        if (dbId && listHas(c.extensions, dbId)) return 'workspaceApp';
        return 'website';
    };
    const bucket = {
        website: 'websites',
        workspaceApp: 'workspaceApps',
        library: 'libraries',
        template: 'templates'
    };
    for (const p of Array.isArray(list) ? list : []){
        if (!p) continue;
        out[bucket[kindOf(p)]].push(p);
    }
    return out;
};
async function $f8d862ddced093a7$export$a9dda571bc0d1c07(opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return null;
    const force = !!(opts && opts.force);
    const wsId = String(root.workspace && (root.workspace.id || root.workspace._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '');
    if (!wsId) return null;
    const prev = root._projectKindSignals && typeof root._projectKindSignals === 'object' ? root._projectKindSignals : null;
    const FRESH_MS = 300000;
    if (!force && prev && prev.wsId === wsId && Date.now() - (prev.at || 0) < FRESH_MS) return prev;
    // One read in flight per element tree (el.scope is per element; the shell
    // root is the shared owner of this read).
    const holder = root.__projectKindSignalsInFlight;
    if (holder && holder.wsId === wsId) return holder.promise;
    const sdk = el.sdk || el.context && el.context.methods && el.context.methods.sdk;
    const lc = (v)=>v == null ? '' : String(v).trim().toLowerCase();
    const readExtensions = async ()=>{
        const ai = (0, $kANrO.getAiService)();
        if (!ai || typeof ai.listExtensions !== 'function') return null;
        const res = await ai.listExtensions({
            workspaceId: wsId
        });
        const arr = Array.isArray(res) ? res : res && (res.data || res.items) || [];
        return arr.map((x)=>x && (x.id || x._id || x.projectId)).filter(Boolean).map(lc);
    };
    const readModules = async ()=>{
        if (!sdk || typeof sdk.listPublicProjects !== 'function') return null;
        const res = await sdk.listPublicProjects({
            workspaceModule: true,
            limit: 100
        });
        const rows = Array.isArray(res) ? res : res && res.data || [];
        return rows.filter((p)=>p && p.metadata && p.metadata.workspaceModule === true && p.key).map((p)=>{
            const owner = p.workspace && p.workspace.organization && p.workspace.organization.slug || p.workspace && p.workspace.slug || (typeof p.owner === 'string' ? p.owner : p.owner && (p.owner.slug || p.owner.username)) || '';
            return owner ? lc(owner) + '/' + lc(p.key) : '';
        }).filter(Boolean);
    };
    const promise = (async ()=>{
        const [ext, mods] = await Promise.all([
            readExtensions().catch(()=>null),
            readModules().catch(()=>null)
        ]);
        // A switch while the reads were in flight: the answer belongs to the old
        // workspace — drop it.
        const nowWs = String(root.workspace && (root.workspace.id || root.workspace._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '');
        if (nowWs !== wsId) return null;
        const same = prev && prev.wsId === wsId;
        const next = {
            wsId: wsId,
            extensions: ext || (same ? prev.extensions || [] : []),
            modules: mods || (same ? prev.modules || [] : []),
            at: Date.now()
        };
        root.update({
            _projectKindSignals: next
        });
        return next;
    })();
    root.__projectKindSignalsInFlight = {
        wsId: wsId,
        promise: promise
    };
    try {
        return await promise;
    } finally{
        if (root.__projectKindSignalsInFlight && root.__projectKindSignalsInFlight.promise === promise) root.__projectKindSignalsInFlight = null;
    }
}

});

parcelRegister("8g9xF", function(module, exports) {

$parcel$export(module.exports, "setNavbarTooltipPosition", () => $6037382f4e465f99$export$f8022f975d76fe07);
// The single implementation (2026-07-27 duplicate-export dedup). There used to
// be two exports under this name: this file, and a copy in
// workspace/functions/ that won at runtime because the workspace barrel is
// spread eagerly over the shared library.
//
// The workspace copy's behaviour is what survived — the version that lived
// here took an `options = {}` param and read it as `options.visible ||
// 'default'`, which can never express "hide" (false is falsy, so it always
// fell through to the shown state), and it called a never-registered
// `el.call('exec', ...)` helper. Every real call site (NavbarTooltipParent,
// AppNavbar, EnvsNavbar, CanvasPagesDropdown) already passes the
// `{ visible: true|false }` / no-args shape this implementation expects.
//
// It lives in SHARED rather than workspace because shared is the layer every
// app scope merges. preview's PreviewNavbar extends NavbarTooltipParent in
// four places, and preview/marketplace/gazer/demo/design-system merge shared
// WITHOUT workspace — keeping the only copy in workspace would have left
// `el.call('setNavbarTooltipPosition')` unresolved in all of them.
const $6037382f4e465f99$export$f8022f975d76fe07 = function setNavbarTooltipPosition(params) {
    const el = this;
    const tooltip = el.lookup('NavbarTooltip');
    if (!tooltip || !tooltip.node) return;
    const node = tooltip.node;
    if (!params || !params.visible) {
        node.style.opacity = '0';
        node.style.visibility = 'hidden';
        node.style.transform = 'translate3d(-50%,-10%,0)';
        return;
    }
    const titleVal = typeof el.title === 'function' ? el.title(el, el.state) : el.title;
    const title = titleVal || '';
    if (tooltip.P && tooltip.P.node) tooltip.P.node.textContent = title;
    const btnRect = el.node.getBoundingClientRect();
    const parentRect = tooltip.parent.node.getBoundingClientRect();
    const left = btnRect.left - parentRect.left + btnRect.width / 2;
    node.style.left = left + 'px';
    node.style.opacity = '1';
    node.style.visibility = 'visible';
    node.style.transform = 'translate3d(-50%,0,0)';
};

});

parcelRegister("1P3BE", function(module, exports) {

$parcel$export(module.exports, "markNotificationRead", () => $153d5a02debf34f2$export$49199adf1afcc108);
$parcel$export(module.exports, "markAllNotificationsRead", () => $153d5a02debf34f2$export$e084b0935ef1b664);
// The single implementation (2026-07-27 duplicate-name collision fix — see
// NotificationPanel dedup in shared/components/Notifications.js for the
// matching component-level move). There used to be one copy of these two
// functions, in workspace/functions/notifications/markNotificationRead.js,
// el.call'd only by the canonical NotificationPanel that lived in
// workspace/components/NotificationBell.js.
//
// It lives in SHARED rather than workspace because shared is the layer every
// app scope merges. Canvas's standalone bundle links shared (never workspace,
// see canvas/sharedLibraries.js) and mounts NotificationPanel through
// AppHeader's NotificationWrapper — keeping the only copy in workspace would
// have left `el.call('markNotificationRead', …)` / `el.call('markAllNotificationsRead')`
// unresolved there once NotificationPanel moved to shared too.
//
// migrated 2026-04-27 to SDK route workspaceProject.notifications (update / markAllRead)
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $153d5a02debf34f2$export$49199adf1afcc108 = async function(notifId) {
    if (!notifId) return;
    const root = this?.state?.root;
    if (!root) return;
    // Optimistic update
    root.update({
        notifs: (root.notifs || []).map((n)=>n.id === notifId ? {
                ...n,
                read: true
            } : n)
    });
    try {
        await (0, $1NxyO.getSDK)().execute('workspaceProject.notifications', 'update', {
            id: notifId
        });
    } catch (e) {
        console.error('[markNotificationRead]', e?.message || e);
    }
};
const $153d5a02debf34f2$export$e084b0935ef1b664 = async function() {
    const root = this?.state?.root;
    if (!root) return;
    const me = root.currentUserEmail;
    if (!me) return;
    // Optimistic update
    root.update({
        notifs: (root.notifs || []).map((n)=>({
                ...n,
                read: true
            }))
    });
    try {
        await (0, $1NxyO.getSDK)().execute('workspaceProject.notifications', 'markAllRead', {});
    } catch (e) {
        console.error('[markAllNotificationsRead]', e?.message || e);
    }
};

});

parcelRegister("h7bUm", function(module, exports) {

$parcel$export(module.exports, "createNotification", () => $c75c53d0dd5559c1$export$9c8f6e8d39c60cf3);
$parcel$export(module.exports, "createNotifications", () => $c75c53d0dd5559c1$export$9baa1bac95edf573);
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $c75c53d0dd5559c1$export$9c8f6e8d39c60cf3 = async function(opts) {
    if (!opts?.userEmail || !opts?.type || !opts?.title) return null;
    // Don't notify yourself
    const me = this?.state?.root?.currentUserEmail;
    if (me && opts.userEmail === me) return null;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.notifications/create
        const result = await (0, $1NxyO.getSDK)().execute('workspaceProject.notifications', 'create', {
            payload: {
                user_email: opts.userEmail,
                type: opts.type,
                title: opts.title,
                body: opts.body || null,
                href: opts.href || null,
                metadata: opts.metadata || {}
            }
        });
        // The worker's insert returns `[{...row}]` (PostgREST `.insert().select()`
        // convention — same array-wrap createChannel.js / createRoom.js / sendMessage.js
        // all unwrap) rather than a bare row or a `{data}` envelope. This was never
        // unwrapped here, so every call silently returned `null` on the *success*
        // path too (verified live: POST succeeded, row landed in Mongo, but this
        // returned `null`) — nobody had noticed because neither existing caller
        // (chat's mention-notify, calendar's invite-notify) checks the return
        // value. Handle all three shapes so `el.call('createNotification', …)`
        // truthiness checks (e.g. a Ping send confirming before showing "sent")
        // are meaningful.
        const row = Array.isArray(result) ? result[0] : result?.data ?? result;
        return row?.id || row?._id || null;
    } catch (e) {
        console.error('[createNotification]', e?.message || e);
        return null;
    }
};
const $c75c53d0dd5559c1$export$9baa1bac95edf573 = async function(recipients, baseOpts) {
    if (!recipients?.length || !baseOpts?.type || !baseOpts?.title) return;
    const me = this?.state?.root?.currentUserEmail;
    const rows = recipients.filter((email)=>email !== me).map((email)=>({
            user_email: email,
            type: baseOpts.type,
            title: baseOpts.title,
            body: baseOpts.body || null,
            href: baseOpts.href || null,
            metadata: baseOpts.metadata || {}
        }));
    if (!rows.length) return;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.notifications/create (fan-out)
        await Promise.all(rows.map((payload)=>(0, $1NxyO.getSDK)().execute('workspaceProject.notifications', 'create', {
                payload: payload
            }).catch((err)=>{
                console.error('[createNotifications]', err?.message || err);
            })));
    } catch (e) {
        console.error('[createNotifications]', e?.message || e);
    }
};

});

parcelRegister("euTsI", function(module, exports) {

$parcel$export(module.exports, "formatImports", () => $a8dee3a8a23d1dc4$export$a444f85bf2d3031a);
const $a8dee3a8a23d1dc4$export$a444f85bf2d3031a = function formatImports(code) {
    return code.replace(/import\s*\{\s*\n\s*([^}]+)\n\s*\}\s*from\s*['"]([^'"]+)['"]/gu, (_, imports, source)=>{
        const cleanedImports = imports.trim();
        return `import { ${cleanedImports} } from '${source}'`;
    });
};

});

parcelRegister("kessp", function(module, exports) {

$parcel$export(module.exports, "inviteMember", () => $ebab307b8ac0796b$export$348cc448ded6dc4b);
const $ebab307b8ac0796b$export$348cc448ded6dc4b = function inviteMember() {
/* console.log(this, this.state, this.context) */ };

});

parcelRegister("928cN", function(module, exports) {

$parcel$export(module.exports, "mirrorAuthSession", () => $693aaa62fa6d14e1$export$8b264bf264b945cb);
// Mirrors the SDK session onto an app's root state so components can read
// `root.signedIn`, `root.currentUserId`, and
// `root.jwtClaims.workspace_org_id` without depending on gov-specific
// modules. All three editor apps (canvas, CMS, gov, future consumers)
// point at the same SDK auth pipeline, so subscribing here gives every
// origin the same identity view.
//
// Usage:
//   onCreate: (el, s) => el.call('mirrorAuthSession', s.root || s)
// Returns an unsubscribe fn — call it to tear down; otherwise the
// subscription lives for the lifetime of the page.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $693aaa62fa6d14e1$export$8b264bf264b945cb = function mirrorAuthSession(root, onSignIn) {
    if (!root || root._authMirrorInstalled) return root?._authMirrorInstalled;
    root._authMirrorInstalled = true;
    // migrated 2026-04-27 to SDK onAuthStateChange (signature is event, session;
    // matches Supabase's shape so the callback body is unchanged).
    let lastUserId = null;
    const unsubscribe = (0, $1NxyO.getSDK)().onAuthStateChange((_event, session)=>{
        const u = session?.user;
        const nextEmail = u?.email || '';
        const nextId = u?.id || '';
        const nextSignedIn = !!u;
        const nextClaims = u?.app_metadata || {};
        const changed = root.signedIn !== nextSignedIn || root.currentUserEmail !== nextEmail || root.currentUserId !== nextId;
        if (changed) root.update({
            signedIn: nextSignedIn,
            currentUserEmail: nextEmail,
            currentUserId: nextId,
            jwtClaims: nextClaims
        });
        else if (nextSignedIn) root.update({
            jwtClaims: nextClaims
        });
        if (nextId && nextId !== lastUserId) {
            lastUserId = nextId;
            if (typeof onSignIn === 'function') onSignIn({
                id: nextId,
                email: nextEmail
            });
        } else if (!nextId) lastUserId = null;
    });
    // SDK's onAuthStateChange returns the unsubscribe fn directly. The previous
    // sdk-bridge implementation returned `{ data: { subscription: { unsubscribe } } }`
    // and the wrapper here adapted that shape — keep returning a plain function so
    // callers can invoke the returned unsub directly.
    const unsub = ()=>{
        if (typeof unsubscribe === 'function') unsubscribe();
    };
    return unsub;
};

});

parcelRegister("cQ06p", function(module, exports) {

$parcel$export(module.exports, "isSessionBridgePeer", () => $958a6bad6e78f86a$export$8d74ed1cfbcbb818);
// Who may read the session through /_session-bridge (HOTFIX 2026-10-08, P0).
//
// Both bridge pages (workspace shell + canvas) used to answer any origin
// matching /^https?:\/\/[^.]+\.symbols\.app$/ — http included, and any
// one-label host such as preview.symbols.app, which renders user project
// code. Rule now: only the exact shell host and comm host (commHost.js) of the
// SAME channel as the page, https, no port; a *.localhost page answers only
// *.localhost peers. Channel hosts come from @symbo.ls/channels.
//
// No channel has a canvas host any more: the standalone canvas hosts
// (`edit.symbols.app`, `canvas.<tier>.symbols.app`) are deleted — Nika
// 2026-10-23, "canvas.dev is deprecated and should be removed", and the rest
// on 2026-10-24. The editor runs inside the shell (canvasUrl.js); only the
// local canvas dev server (`canvas.localhost`) still pairs with the local shell.
//
// FA204 / frank trap — helpers stay inline in the export (see canvasUrl.js).

var $hmkNw = parcelRequire("hmkNw");
const $958a6bad6e78f86a$export$8d74ed1cfbcbb818 = (origin)=>{
    function _hostOf(url) {
        if (!url) return null;
        try {
            return new URL(url).hostname;
        } catch  {
            return null;
        }
    }
    function _isLocalHost(host) {
        return !!host && (host === 'localhost' || host.endsWith('.localhost'));
    }
    // The comm hosts of a channel (commHost.js): the `my` label of its shell
    // host → `comm` (`dev.my.symbols.app` → `dev.comm.symbols.app`), and the
    // legacy `com` name the host had first (`dev.com.symbols.app`) — it answers
    // until that tier's old host redirects to the new one (docs/COMM_HOST.md).
    // A shell host without the `my` label (the demo channels) has none.
    function _commHostsFor(shellHost) {
        const m = /^((?:[a-z0-9-]+\.)*)my\.symbols\.app$/.exec(shellHost || '');
        return m ? [
            `${m[1]}comm.symbols.app`,
            `${m[1]}com.symbols.app`
        ] : [];
    }
    if (typeof origin !== 'string' || typeof window === 'undefined') return false;
    let asker;
    try {
        asker = new URL(origin);
    } catch  {
        return false;
    }
    // Reject anything that is not a bare origin ("null", paths, credentials).
    if (asker.origin !== origin) return false;
    const here = window.location && window.location.hostname;
    if (!here) return false;
    // A local page answers ONLY the local shell and canvas hosts, on the page's
    // own port (the portless proxy, :1355). Never another *.localhost: the local
    // proxy also serves per-project preview hosts (`<owner>--<key>.preview.
    // localhost`) that render user code (review L1, 2026-10-09).
    if (_isLocalHost(here)) {
        const localPeers = [
            'workspace.localhost',
            'canvas.localhost'
        ];
        const herePort = window.location && window.location.port || '';
        return localPeers.includes(asker.hostname) && (!herePort || asker.port === herePort);
    }
    if (asker.protocol !== 'https:' || asker.port) return false;
    for (const name of (0, $hmkNw.channelNames)){
        if (name === 'local') continue;
        const shell = _hostOf((0, $hmkNw.shellUrl)(name));
        if (!shell) continue;
        const comms = _commHostsFor(shell);
        const onChannel = (h)=>h === shell || comms.includes(h);
        if (onChannel(here) && onChannel(asker.hostname)) return true;
    }
    return false;
};

});

parcelRegister("3JzjK", function(module, exports) {

$parcel$export(module.exports, "retryOrgSwitch", () => $2b80f86316bd3735$export$7786aaa2b000ffef);
// The org switcher's "Try again" (AppOrgSwitcher `_commitOrgSwitch`, THE
// SWITCH DEADLINE): runs the switch that just failed or timed out once more.
// The failing switch parks itself on globalThis.__orgSwitchRetry (the same
// cross-package slot pattern as globalThis.__wsSwitchFallbackState), because
// the commit is component-private and the toast action resolves by name.
function $2b80f86316bd3735$export$7786aaa2b000ffef() {
    const retry = globalThis.__orgSwitchRetry;
    globalThis.__orgSwitchRetry = null;
    return typeof retry === 'function' ? retry() : undefined;
}

});

parcelRegister("1k6V7", function(module, exports) {

$parcel$export(module.exports, "collectBridgeTokens", () => $0f6d06f08ab0ee06$export$966aa6ac2b8d5d6);
// What a `/_session-bridge` page hands to its peer origin: the ACCESS token
// and its expiry — never the refresh token.
//
// WHY (2026-10-09): the server ROTATES refresh tokens (every /auth/refresh
// retires the token it was sent; no family revocation, a retired token gets
// 401 REVOKED). The bridge used to hand the peer the whole SDK session
// (collectSdkTokens), refresh token included. Shell and canvas then held one
// single-use refresh token; whichever origin refreshed second was signed out —
// about once per access-token lifetime for every user of both apps.
//
// Rule now: the origin that owns the login keeps its refresh token and is the
// only one that refreshes. The peer holds the access token only, and asks the
// bridge again when it runs out (sessionBridgeReacquire.js, wired into the SDK
// in sdkClient.js).
//
// A bridge page whose own access token has less than RENEW_WITHIN_MS left
// rotates it FIRST when it owns a refresh token, so a peer that re-asks never
// gets a token that dies in the next request. The window is wider than the
// peer's renewal lead (sessionBridgeRenewal.js, 2 min) and the SDK's own 60 s
// refresh buffer — otherwise a peer asking early gets the same dying token
// back. The rotation is the SDK's own (`tokenManager.refreshTokens()`,
// Web-Locks-serialised against this origin's other tabs); `getStoredAuthState`
// runs first only to await SDK init. A bridge page without a refresh token
// never refreshes; it hands over what it holds while that is still valid, or
// nothing.
//
// `getSdk` returns the page's SDK (or a promise of it) and is called — the SDK
// reached, on the light bridge entry even loaded — only when the rotation above
// is actually needed; every bridge surface passes it through the shared
// responder (sessionBridgeResponder.js). `sdk` is the eager form. With neither,
// the page answers from storage only.
//
// FA204 / frank trap — helpers stay inline in the export.

var $7sTYS = parcelRequire("7sTYS");
var $0f6d06f08ab0ee06$require$Buffer = $7sTYS.Buffer;
const $0f6d06f08ab0ee06$export$966aa6ac2b8d5d6 = async ({ sdk: sdk, getSdk: getSdk } = {})=>{
    const RENEW_WITHIN_MS = 300000;
    const storage = (()=>{
        try {
            return typeof localStorage !== 'undefined' && localStorage ? localStorage : null;
        } catch  {
            return null;
        }
    })();
    if (!storage) return null;
    const jwtExpMs = (token)=>{
        try {
            const part = String(token).split('.')[1];
            if (!part) return null;
            let b64 = part.replace(/-/g, '+').replace(/_/g, '/');
            while(b64.length % 4)b64 += '=';
            const json = typeof atob === 'function' ? atob(b64) : $0f6d06f08ab0ee06$require$Buffer.from(b64, 'base64').toString('utf8');
            const exp = JSON.parse(json)?.exp;
            return typeof exp === 'number' ? exp * 1000 : null;
        } catch  {
            return null;
        }
    };
    const read = ()=>{
        const accessToken = storage.getItem('symbols_access_token') || storage.getItem('symbols_bridge_access_token');
        const stored = Number(storage.getItem('symbols_expires_at') || storage.getItem('symbols_bridge_expires_at'));
        const expiresAt = stored > 0 ? stored : accessToken ? jwtExpMs(accessToken) : null;
        return {
            accessToken: accessToken,
            expiresAt: expiresAt
        };
    };
    let session = read();
    const ownsRefresh = !!storage.getItem('symbols_refresh_token');
    const nearExpiry = !session.accessToken || session.expiresAt && session.expiresAt - Date.now() < RENEW_WITHIN_MS;
    if (nearExpiry && ownsRefresh && (sdk || typeof getSdk === 'function')) {
        try {
            if (!sdk) sdk = await getSdk();
            // Awaits SDK init (the root `_tokenManager` is set at the end of it)
            // and recovers an already-expired token through the SDK's own path.
            if (typeof sdk.getStoredAuthState === 'function') await sdk.getStoredAuthState();
            session = read();
            const tm = sdk._tokenManager;
            const stillNear = !session.accessToken || session.expiresAt && session.expiresAt - Date.now() < RENEW_WITHIN_MS;
            if (stillNear && tm?.hasRefreshToken?.() && typeof tm.refreshTokens === 'function') await tm.refreshTokens();
        } catch  {
        /* refresh refused or unreachable — answer from what storage holds */ }
        session = read();
    }
    if (!session.accessToken) return null;
    if (session.expiresAt && session.expiresAt <= Date.now()) return null;
    const out = {
        symbols_access_token: session.accessToken
    };
    if (session.expiresAt) out.symbols_expires_at = String(session.expiresAt);
    return out;
};

});

parcelRegister("hPqW2", function(module, exports) {

$parcel$export(module.exports, "answerSessionBridgeRequest", () => $cfac17d33629352e$export$1fd2c47a41eb1c4e);
$parcel$export(module.exports, "announceSessionBridgeReady", () => $cfac17d33629352e$export$d797d632c713c755);
// The `/_session-bridge` answer — ONE definition for every bridge surface: the
// workspace shell's DOMQL page (workspace pages/session-bridge.js), the
// canvas's (canvas pages/session-bridge.js) and the light bridge entry
// (workspace bridge.html → bridge/index.js), which answers in a fraction of
// the time because it boots nothing but this.
//
// The rules are the bridge's own and unchanged: only an exact same-channel
// peer (sessionBridgePeers.js) is answered and only a
// `symbols-session-request` — both checked before anything is read; storage
// access is asked first (a partitioned frame); the answer is the ACCESS token
// and its expiry, never the refresh token (sessionBridgeTokens.js); no session
// → `{ ok: false, error: 'no-session' }`. The reply goes to the asking frame's
// origin only.
//
// The two rules are imported from their own modules; both are in the
// functions bag, so the imports also resolve on a published surface
// (functions/index.js, as for sdkClient.js / bootResolve.js).

var $cQ06p = parcelRequire("cQ06p");

var $1k6V7 = parcelRequire("1k6V7");
const $cfac17d33629352e$export$1fd2c47a41eb1c4e = async (ev, { getSdk: getSdk } = {})=>{
    if (!ev || !(0, $cQ06p.isSessionBridgePeer)(ev.origin)) return false;
    if (!ev.data || ev.data.type !== 'symbols-session-request') return false;
    const reply = (payload)=>ev.source && ev.source.postMessage({
            type: 'symbols-session-response',
            ...payload
        }, ev.origin);
    // Chrome's Third-Party Storage Partitioning gives a cross-site frame an
    // empty, isolated localStorage by default. requestStorageAccess() promotes
    // it to first-party storage when Chrome's heuristics approve (granted when
    // the person recently visited this host as a top-level page), so the live
    // tokens can be read.
    try {
        if (typeof document !== 'undefined' && typeof document.requestStorageAccess === 'function') await document.requestStorageAccess();
    } catch  {
    // Refused — read the partitioned store. Worst case the answer is
    // `no-session` and the peer shows its own sign-in hint.
    }
    const sdkTokens = await (0, $1k6V7.collectBridgeTokens)({
        getSdk: getSdk
    }) || {};
    if (!sdkTokens.symbols_access_token) {
        reply({
            ok: false,
            error: 'no-session'
        });
        return true;
    }
    reply({
        ok: true,
        sdkTokens: sdkTokens
    });
    return true;
};
const $cfac17d33629352e$export$d797d632c713c755 = ()=>{
    try {
        if (typeof window !== 'undefined' && window.parent && window.parent !== window) window.parent.postMessage({
            type: 'symbols-session-ready'
        }, '*');
    } catch  {
    /* a detached frame — the asker's own retries cover it */ }
};

});

parcelRegister("89exv", function(module, exports) {

$parcel$export(module.exports, "navbarLayoutRead", () => $5eea7132876244ac$export$e3281e883a7243a9);
$parcel$export(module.exports, "navbarLayoutSet", () => $5eea7132876244ac$export$2bfef20a906f10d2);
$parcel$export(module.exports, "navbarRailLabel", () => $5eea7132876244ac$export$7a6ffc3492a96cea);
$parcel$export(module.exports, "navbarRailRect", () => $5eea7132876244ac$export$5b1e329a84a7f8a2);
$parcel$export(module.exports, "navbarMenuAnchor", () => $5eea7132876244ac$export$3fc79394f909ecfd);
$parcel$export(module.exports, "navbarTooltipPlacement", () => $5eea7132876244ac$export$c2afb4bb11adb0a9);
$parcel$export(module.exports, "navbarRailToggle", () => $5eea7132876244ac$export$67b1a7c7d256cb65);
// THE NAVBAR'S PLACE (Nika 2026-10-24: "on both workspaces - com and normal
// make sidebar optional to be positioned at the top left right or bottom. for
// normal workspace keep as is. for com - move to the left. left and right
// sidebars can be toggle expandable"; 2026-10-27: "also make navbar left by
// default").
//
// The header (components/AppHeader.js) is the navbar on both hosts. A person
// places it at the top, on the left, on the right or at the bottom — a choice
// of their own look (workspace functions/homeLook.js), one per host: the
// workspace host's (`navbarPosition`) and the comm host's
// (`commNavbarPosition`). Both open on a left rail by default (the workspace
// host kept its top navbar until 2026-10-27). A left or right rail shows the
// glyphs only, or the glyphs and their names (`…Expanded`). A phone keeps the
// shell's own posture (the header strip and the dock) whatever the choice:
// the layout reads 'top' there.
//
// A host without the look (the canvas or the preview app alone) has its
// navbar at the top: the look functions are read through guarded doors, so it
// reads the defaults without a "not registered" call.
//
// Reactive: the factories that read this subscribe through what it reads —
// the look (`_homeLook`, `userPrefs`) and the phone flag. Every key is read on
// every run, before any decision (a factory that returns before it reads a
// key never re-runs on that key).
//
// FRANK: every export is self-contained (FA204) — the vocabulary and the
// phone query are restated where they are used; siblings through `this.call`.
// → { position: 'top' | 'left' | 'right' | 'bottom', rail, railMode, bottom,
//     expanded, phone, placeable, sidebarSide } — `railMode`: 'narrow' |
//     'wide' on a rail, null off it (the header's `data-nav-rail` attribute —
//     null removes it); `phone`: the shell's own phone posture holds, the
//     choice waits; `placeable`: this host's frame honours the choice;
//     `sidebarSide`: where a page's own sidebar sits (THE PAGE SIDEBAR'S SIDE
//     below)
//
// THE PAGE SIDEBAR'S SIDE (Nika 2026-10-29: "move sidebar at the right - if
// navbar is at the left, and opposite. for top and bottom - keep them"): a
// page's own sidebar (AppSidebar, functions/pageSidebar.js) sits on the side
// the navbar does NOT take — 'right' beside a left rail, 'left' beside a right
// rail, and 'left' (as ever) under a top bar, above a bottom bar, on a phone
// and on a host without the look. So a page sidebar never shares an edge with
// the navbar, and never needs the navbar's inset.
const $5eea7132876244ac$export$e3281e883a7243a9 = function navbarLayoutRead(root) {
    const r = root && typeof root === 'object' ? root : {};
    const phoneFlag = r._isPhoneViewport;
    const fns = this && this.context && this.context.functions;
    const look = fns && typeof fns.homeLookRead === 'function' && this.call('homeLookRead', r) || {};
    const comm = !!(fns && typeof fns.isCommHost === 'function' && this.call('isCommHost'));
    let phone = phoneFlag === true;
    // before the shell's first viewport read the flag is still null: ask the
    // phone query itself (the brand `mobileL`)
    if (phoneFlag == null && typeof window !== 'undefined' && window.matchMedia) try {
        phone = window.matchMedia('(max-width: 768px)').matches;
    } catch (_) {
        phone = false;
    }
    // PLACEABLE: the host's frame places a rail or a bottom bar — both hosts
    // that carry the look: the comm app's grid (workspace comm/app.js) and the
    // workspace shell's frame (workspace app.js, "THE NAVBAR'S PLACE": its
    // content, PageSlot, composer, drawers and page rails clear the bar where
    // it is). A host without the look (the canvas or the preview app alone)
    // keeps the top and offers no choice.
    const placeable = !!(fns && typeof fns.homeLookRead === 'function' && typeof fns.homeLookSet === 'function');
    const chosen = comm ? look.commNavbarPosition : look.navbarPosition;
    const valid = [
        'top',
        'left',
        'right',
        'bottom'
    ].includes(chosen);
    const position = phone || !placeable ? 'top' : valid ? chosen : 'left';
    const rail = position === 'left' || position === 'right';
    const open = comm ? look.commNavbarExpanded : look.navbarExpanded;
    const expanded = rail && open === true;
    return {
        position: position,
        rail: rail,
        railMode: rail ? expanded ? 'wide' : 'narrow' : null,
        bottom: position === 'bottom',
        expanded: expanded,
        phone: phone,
        placeable: placeable,
        sidebarSide: position === 'left' ? 'right' : 'left'
    };
};
const $5eea7132876244ac$export$2bfef20a906f10d2 = function navbarLayoutSet(patch) {
    const fns = this && this.context && this.context.functions;
    if (!fns || typeof fns.homeLookSet !== 'function') return Promise.resolve(null);
    const comm = typeof fns.isCommHost === 'function' && !!this.call('isCommHost');
    const p = patch && typeof patch === 'object' ? patch : {};
    const change = {};
    if ([
        'top',
        'left',
        'right',
        'bottom'
    ].includes(p.position)) change[comm ? 'commNavbarPosition' : 'navbarPosition'] = p.position;
    if (typeof p.expanded === 'boolean') change[comm ? 'commNavbarExpanded' : 'navbarExpanded'] = p.expanded;
    if (!Object.keys(change).length) return Promise.resolve(null);
    return this.call('homeLookSet', change);
};
const $5eea7132876244ac$export$7a6ffc3492a96cea = function navbarRailLabel(name, root) {
    const text = String(name || '');
    const nav = this && typeof this.call === 'function' && this.call('navbarLayoutRead', root) || {};
    if (nav.railMode !== 'narrow') return text;
    return text.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w)=>Array.from(w)[0] || '').join('').replace(/[a-z]/g, (c)=>c.toUpperCase());
};
const $5eea7132876244ac$export$5b1e329a84a7f8a2 = function navbarRailRect(trigger) {
    const t = trigger || this;
    if (!this || typeof this.call !== 'function' || !t) return null;
    const nav = this.call('navbarLayoutRead', this.state && this.state.root) || {};
    if (!nav.rail) return null;
    const bar = typeof t.lookup === 'function' ? t.lookup('AppHeader') : null;
    const box = (n)=>n && typeof n.getBoundingClientRect === 'function' ? n.getBoundingClientRect() : null;
    const edge = box(bar && bar.node);
    const at = box(t.node);
    if (!edge || !at) return null;
    return {
        left: edge.left,
        right: edge.right,
        width: edge.width,
        top: at.top,
        bottom: at.bottom,
        height: at.height
    };
};
const $5eea7132876244ac$export$3fc79394f909ecfd = function navbarMenuAnchor(placement, anchorEl) {
    const own = {
        anchorEl: anchorEl || this,
        placement: placement
    };
    const rect = this && typeof this.call === 'function' ? this.call('navbarRailRect') : null;
    if (!rect) return own;
    const nav = this.call('navbarLayoutRead', this.state && this.state.root) || {};
    const side = nav.position === 'right' ? 'left' : 'right';
    const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
    const lower = rect.top + rect.height / 2 > vh / 2;
    return {
        anchorRect: rect,
        restoreEl: this,
        placement: `${side}-${lower ? 'end' : 'start'}`
    };
};
const $5eea7132876244ac$export$c2afb4bb11adb0a9 = function navbarTooltipPlacement() {
    if (!this || typeof this.call !== 'function') return 'bottom';
    const onBar = typeof this.lookup === 'function' && !!this.lookup('AppHeader');
    const nav = onBar ? this.call('navbarLayoutRead', this.state && this.state.root) || {} : {};
    return ({
        left: 'right',
        right: 'left',
        bottom: 'top'
    })[nav.position] || 'bottom';
};
const $5eea7132876244ac$export$67b1a7c7d256cb65 = function navbarRailToggle() {
    if (!this || typeof this.call !== 'function') return Promise.resolve(null);
    const root = this.state && this.state.root;
    const now = this.call('navbarLayoutRead', root) || {};
    if (!now.rail) return Promise.resolve(null);
    return this.call('navbarLayoutSet', {
        expanded: !now.expanded
    });
};

});

parcelRegister("fpmKQ", function(module, exports) {

$parcel$export(module.exports, "pageSidebarKey", () => $b37ad76ad571317a$export$41b5c201e866ad7d);
$parcel$export(module.exports, "pageSidebarRead", () => $b37ad76ad571317a$export$efb869769332b70c);
$parcel$export(module.exports, "pageSidebarSet", () => $b37ad76ad571317a$export$9a55346cca3ca960);
$parcel$export(module.exports, "pageSidebarToggle", () => $b37ad76ad571317a$export$10a0311ff83d26e7);
// THE PAGE SIDEBAR — its side, the person's hidden choice, and the one toggle
// (Nika 2026-10-29: "for apps, studio, tasks, and all other pages that open in
// shell, move sidebar at the right - if navbar is at the left, and opposite.
// for top and bottom - keep them. also restyle and fix sidebar styles, make
// them consistent and make them toggleable"; the toggle pick: "Hide fully,
// remember per page" — one button at the same place on every page hides the
// sidebar, a small tab at the page edge brings it back, the choice is kept per
// page with the navbar choice, and the PageSlot window's sidebar icon is the
// same toggle).
//
// Every page's own sidebar is the shared AppSidebar (components/AppSidebar.js).
// It reads its posture here and nowhere else:
//
//   el.call('pageSidebarRead', s.root, el)
//     → { key, side: 'left' | 'right', hidden, phone, toggleable, follows }
//   el.call('pageSidebarSet', key, true | false)
//   el.call('pageSidebarToggle')            the calling element's page
//
// SIDE — `navbarLayoutRead(root).sidebarSide` (functions/navbarLayout.js): the
// side the navbar does not take. A phone keeps the shell's phone posture (the
// sidebar reads 'left' and never hidden; MobileRailSheet is the phone rail).
//
// THE OPT-IN (`follows`) — a page moves its sidebar onto the rule by setting
// `pageSidebar: true` on its AppSidebar (one page at a time, so a page whose
// own layout has not been checked on the other side never moves by
// accident). A sidebar without it — and every element inside it — reads
// 'left', as before, and shows no hide button; its hidden choice still holds
// (the PageSlot window's icon reaches every page). Page chrome OUTSIDE the
// sidebar that asks (an island that sits opposite the sidebar) asks on its
// page's behalf: it follows the rule. The PageSlot icon asks with the page's
// own sidebar, so it reads that sidebar's answer.
//
// KEY — one per app page (pageSidebarKey): the page at its own URL and the
// same page in a PageSlot window share it, so the window's icon and the
// page's own toggle always agree.
//
// MEMORY — the person's look (`user_preferences.homeLook.sidebarHidden`, a map
// of page key → boolean), through the look's one writer, homeLookSet (workspace
// functions/homeLook.js): this session at once, this device, the record — the
// same bag and the same precedence as the navbar's place. A host without the
// look (the canvas or the preview app alone) cannot remember, so it offers no
// toggle (`toggleable: false`) and its sidebars always show.
//
// FRANK: every export is self-contained (FA204) — the key rule is restated
// where it is used; siblings are reached through `this.call`.
// The page identity of a route — the first path segment once the workspace
// prefix and the query are gone: '/w/acme/tasks/feed?x=1' → 'tasks',
// '/apps' → 'apps', '/' → 'home'. Bounded by the apps, never by a record id
// (/task/<id> → 'task'), so the stored map stays small.
const $b37ad76ad571317a$export$41b5c201e866ad7d = function pageSidebarKey(path) {
    const raw = String(path || '').split(/[?#]/)[0];
    const fns = this && this.context && this.context.functions;
    const stripped = fns && typeof fns.stripWorkspacePrefix === 'function' ? this.call('stripWorkspacePrefix', raw) : raw.replace(/^\/w\/[a-z0-9-]{1,48}(?=\/|$)/, '');
    const first = String(stripped || '').split('/').filter(Boolean)[0];
    const key = String(first || 'home').toLowerCase();
    return /^[a-z0-9][a-z0-9_-]{0,63}$/.test(key) ? key : 'home';
};
const $b37ad76ad571317a$export$efb869769332b70c = function pageSidebarRead(root, at) {
    const r = root && typeof root === 'object' ? root : {};
    const self = this && typeof this.call === 'function' ? this : null;
    const fns = self && self.context && self.context.functions || {};
    const address = r.currentPath;
    const panes = {
        _canvasSlot: r._canvasSlot,
        _canvasSlotSecond: r._canvasSlotSecond
    };
    const nav = self && typeof fns.navbarLayoutRead === 'function' && self.call('navbarLayoutRead', r) || {};
    const look = self && typeof fns.homeLookRead === 'function' && self.call('homeLookRead', r) || {};
    const pane = self && typeof fns.slotPaneKeyForStrict === 'function' ? self.call('slotPaneKeyForStrict', at || self) : null;
    const path = pane ? panes[pane] : address;
    const key = self ? self.call('pageSidebarKey', path) : 'home';
    const map = look.sidebarHidden && typeof look.sidebarHidden === 'object' ? look.sidebarHidden : {};
    const phone = nav.phone === true;
    const toggleable = !phone && typeof fns.homeLookSet === 'function';
    // THE OPT-IN: the sidebar `at` is or sits in (AppSidebar's own mark, a few
    // steps up — the hide button, the reopen tab and its glyph) follows the
    // rule only with `pageSidebar: true`; outside any sidebar, the caller asks
    // for its page and follows.
    let bar = null;
    let step = at && typeof at === 'object' ? at : null;
    for(let hops = 0; step && hops < 4 && !bar; hops++){
        if (step.attr && Object.prototype.hasOwnProperty.call(step.attr, 'data-app-sidebar')) bar = step;
        step = step.parent;
    }
    const follows = bar ? bar.pageSidebar === true : true;
    return {
        key: key,
        side: follows && !phone && nav.sidebarSide === 'right' ? 'right' : 'left',
        hidden: toggleable && map[key] === true,
        phone: phone,
        toggleable: toggleable,
        follows: follows
    };
};
const $b37ad76ad571317a$export$9a55346cca3ca960 = function pageSidebarSet(key, hidden) {
    const self = this && typeof this.call === 'function' ? this : null;
    const k = String(key || '');
    const fns = self && self.context && self.context.functions || {};
    if (!self || typeof fns.homeLookSet !== 'function' || !/^[a-z0-9][a-z0-9_-]{0,63}$/.test(k)) return Promise.resolve(null);
    return Promise.resolve(self.call('homeLookSet', {
        sidebarHidden: {
            [k]: hidden === true
        }
    }));
};
const $b37ad76ad571317a$export$10a0311ff83d26e7 = function pageSidebarToggle() {
    const self = this && typeof this.call === 'function' ? this : null;
    if (!self) return Promise.resolve(null);
    const now = self.call('pageSidebarRead', self.state && self.state.root, self) || {};
    if (!now.toggleable) return Promise.resolve(null);
    return self.call('pageSidebarSet', now.key, !now.hidden);
};

});

parcelRegister("8R9ka", function(module, exports) {

$parcel$export(module.exports, "markOwnSession", () => $672a81920cef62f6$export$4f4bdfe98d058d6a);
// WHO OWNS THIS ORIGIN'S SESSION (review D1, 2026-10-09; Nika: "No, avoid the
// sign-out").
//
// `symbols_session_source` in localStorage:
//   'own'    — a sign-in on THIS origin wrote the refresh token (password,
//              magic link, OAuth, signup, demo, white-label, handoff). This
//              origin refreshes it and signs out when the server refuses it.
//   'bridge' — the access token was adopted from the `/_session-bridge` peer
//              (sessionBridgeReacquire.js). No refresh token here; ask again.
//   absent   — nothing marked it. A refresh token without a mark on the
//              BORROWING origin (the canvas) is a copy an older bridge build
//              handed over: sdkClient asks the bridge first and only falls back
//              to the token when the bridge has no session — never a sign-out.
//
// `markOwnSession()` is called after every sign-in that stores a refresh
// token. The SDK's TokenManager writes the same mark on its own once it ships
// (sdk branch fix/token-manager-session-reacquirer); this covers the
// published SDK and the paths that write storage directly.
//
// FA204 / frank trap — self-contained.
const $672a81920cef62f6$export$4f4bdfe98d058d6a = ()=>{
    try {
        if (typeof localStorage === 'undefined' || !localStorage) return false;
        if (!localStorage.getItem('symbols_refresh_token')) return false;
        localStorage.setItem('symbols_session_source', 'own');
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("2Yh87", function(module, exports) {

$parcel$export(module.exports, "MarkdownToDomQLCompiler", () => $229e7901ca0ee5cf$export$7bdf8f8706baeb27);
const $229e7901ca0ee5cf$export$7bdf8f8706baeb27 = class MarkdownToDomQLCompiler {
    constructor(){
        this.lineCounter = 0;
        this.sectionCounter = 0;
    }
    compile(markdown, options = {}) {
        const { componentName: componentName = 'MarkdownComponent', containerProps: containerProps = {
            flow: 'y',
            gap: 'C1'
        } } = options;
        const lines = markdown.split('\n');
        const result = {
            props: containerProps
        };
        let listItems = [];
        let inList = false;
        let codeBlock = false;
        let codeContent = [];
        for(let i = 0; i < lines.length; i++){
            const line = lines[i];
            const trimmedLine = line.trim();
            // Handle code blocks
            if (trimmedLine.startsWith('```')) {
                if (codeBlock) {
                    const codeKey = this.generateKey('Code');
                    result[codeKey] = {
                        tag: 'pre',
                        Code: {
                            tag: 'code',
                            text: codeContent.join('\n')
                        }
                    };
                    codeContent = [];
                    codeBlock = false;
                } else codeBlock = true;
                continue;
            }
            if (codeBlock) {
                codeContent.push(line);
                continue;
            }
            // Handle empty lines
            if (!trimmedLine) {
                if (inList && listItems.length > 0) {
                    this.finalizeList(result, listItems);
                    listItems = [];
                    inList = false;
                }
                continue;
            }
            // Handle headings
            if (trimmedLine.startsWith('#')) {
                if (inList) {
                    this.finalizeList(result, listItems);
                    listItems = [];
                    inList = false;
                }
                const level = Math.min(trimmedLine.match(/^#+/)[0].length, 6);
                const text = trimmedLine.replace(/^#+\s*/, '');
                const headingKey = this.generateKey(`H${level}`);
                result[headingKey] = {
                    tag: `h${level}`,
                    text: text
                };
                continue;
            }
            // Handle horizontal rules
            if (trimmedLine.match(/^([-*_])\1{2,}$/)) {
                if (inList) {
                    this.finalizeList(result, listItems);
                    listItems = [];
                    inList = false;
                }
                const hrKey = this.generateKey('Hr');
                result[hrKey] = {
                    tag: 'hr'
                };
                continue;
            }
            // Handle blockquotes
            if (trimmedLine.startsWith('>')) {
                if (inList) {
                    this.finalizeList(result, listItems);
                    listItems = [];
                    inList = false;
                }
                const quoteText = trimmedLine.replace(/^>\s*/, '');
                const parsedContent = this.parseInlineElements(quoteText);
                const blockquoteKey = this.generateKey('Blockquote');
                result[blockquoteKey] = {
                    tag: 'blockquote',
                    P: typeof parsedContent === 'string' ? {
                        tag: 'p',
                        text: parsedContent
                    } : {
                        tag: 'p',
                        children: parsedContent
                    }
                };
                continue;
            }
            // Handle list items
            if (trimmedLine.match(/^[-*+]\s/) || trimmedLine.match(/^\d+\.\s/)) {
                const isOrdered = trimmedLine.match(/^\d+\.\s/);
                const text = trimmedLine.replace(/^(?:[-*+]|\d+\.)\s*/, '');
                if (!inList) {
                    inList = true;
                    listItems = [];
                }
                const parsedContent = this.parseInlineElements(text);
                listItems.push({
                    content: parsedContent,
                    ordered: isOrdered
                });
                continue;
            }
            // Finalize list if we're no longer in one
            if (inList && !trimmedLine.match(/^[-*+]\s/) && !trimmedLine.match(/^\d+\.\s/)) {
                this.finalizeList(result, listItems);
                listItems = [];
                inList = false;
            }
            // Handle paragraphs and other content
            if (trimmedLine) {
                const paragraphKey = this.generateKey('P');
                const parsedContent = this.parseInlineElements(trimmedLine);
                result[paragraphKey] = typeof parsedContent === 'string' ? {
                    tag: 'p',
                    text: parsedContent
                } : {
                    tag: 'p',
                    childExtends: 'Span',
                    children: parsedContent
                };
            }
        }
        if (inList && listItems.length > 0) this.finalizeList(result, listItems);
        return `export const ${componentName} = ${JSON.stringify(result, null, 2)};`;
    }
    // Parse inline elements
    parseInlineElements(text) {
        const elements = [];
        let currentText = '';
        let i = 0;
        while(i < text.length){
            // Handle images ![alt](src)
            if (text[i] === '!' && text[i + 1] === '[') {
                const altEnd = text.indexOf(']', i + 2);
                if (altEnd !== -1 && text[altEnd + 1] === '(') {
                    const srcEnd = text.indexOf(')', altEnd + 2);
                    if (srcEnd !== -1) {
                        if (currentText) {
                            elements.push(currentText);
                            currentText = '';
                        }
                        const alt = text.substring(i + 2, altEnd);
                        const src = text.substring(altEnd + 2, srcEnd);
                        elements.push({
                            Img: {
                                tag: 'img',
                                src: src,
                                alt: alt
                            }
                        });
                        i = srcEnd + 1;
                        continue;
                    }
                }
            }
            // Handle links
            if (text[i] === '[') {
                const linkTextEnd = text.indexOf(']', i);
                if (linkTextEnd !== -1 && text[linkTextEnd + 1] === '(') {
                    const urlEnd = text.indexOf(')', linkTextEnd + 2);
                    if (urlEnd !== -1) {
                        if (currentText) {
                            elements.push(currentText);
                            currentText = '';
                        }
                        const linkText = text.substring(i + 1, linkTextEnd);
                        const url = text.substring(linkTextEnd + 2, urlEnd);
                        elements.push({
                            A: {
                                tag: 'a',
                                href: url,
                                text: linkText
                            }
                        });
                        i = urlEnd + 1;
                        continue;
                    }
                }
            }
            // Handle bold text **text**
            if (text.substr(i, 2) === '**') {
                const endIndex = text.indexOf('**', i + 2);
                if (endIndex !== -1) {
                    if (currentText) {
                        elements.push(currentText);
                        currentText = '';
                    }
                    const boldText = text.substring(i + 2, endIndex);
                    elements.push({
                        Strong: {
                            tag: 'strong',
                            text: boldText
                        }
                    });
                    i = endIndex + 2;
                    continue;
                }
            }
            // Handle italic text *text*
            if (text[i] === '*' && text.substr(i, 2) !== '**') {
                const endIndex = text.indexOf('*', i + 1);
                if (endIndex !== -1) {
                    if (currentText) {
                        elements.push(currentText);
                        currentText = '';
                    }
                    const italicText = text.substring(i + 1, endIndex);
                    elements.push({
                        Em: {
                            tag: 'em',
                            text: italicText
                        }
                    });
                    i = endIndex + 1;
                    continue;
                }
            }
            // Handle inline code `code`
            if (text[i] === '`') {
                if (currentText) {
                    elements.push(currentText);
                    currentText = '';
                }
                const endIndex = text.indexOf('`', i + 1);
                if (endIndex !== -1) {
                    const codeText = text.substring(i + 1, endIndex);
                    elements.push({
                        extends: 'Labeled',
                        text: codeText
                    });
                    i = endIndex + 1;
                    continue;
                }
            }
            // Handle inline code `code`
            if (text[i] === '`') {
                const endIndex = text.indexOf('`', i + 1);
                if (endIndex !== -1) {
                    if (currentText) {
                        elements.push(currentText);
                        currentText = '';
                    }
                    const codeText = text.substring(i + 1, endIndex);
                    elements.push({
                        Code: {
                            tag: 'code',
                            text: codeText
                        }
                    });
                    i = endIndex + 1;
                    continue;
                }
            }
            currentText += text[i];
            i++;
        }
        if (currentText) elements.push(currentText);
        return elements.length === 1 && typeof elements[0] === 'string' ? elements[0] : elements;
    }
    finalizeList(result, listItems) {
        if (listItems.length === 0) return;
        const listKey = this.generateKey('List');
        const isOrdered = listItems[0].ordered;
        result[listKey] = {
            tag: isOrdered ? 'ol' : 'ul',
            children: listItems.map((item)=>({
                    tag: 'li',
                    ...typeof item.content === 'string' ? {
                        text: item.content
                    } : {
                        children: item.content
                    }
                }))
        };
    }
    generateKey(prefix) {
        return `${prefix}_${this.lineCounter++}`;
    }
    reset() {
        this.lineCounter = 0;
        this.sectionCounter = 0;
    }
};

});

parcelRegister("5MRNC", function(module, exports) {

$parcel$export(module.exports, "compileCode", () => $436b2ada7ad3a2b6$export$8a04a650e827380);
// FA204 / frank trap — `_DOMPILER_PKG` used to be a bare module-scope const,
// read from inside this exported function's own body: unresolvable once
// this file's exports are individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers). Inlined as a local.
const $436b2ada7ad3a2b6$export$8a04a650e827380 = async function compileCode(source, method) {
    // Computed specifier — @symbo.ls/dompiler's published entry lazy-loads a
    // NODEJS-target wasm artifact that can never ship in a browser bundle, and
    // a literal specifier makes Parcel statically traverse it and hard-fail
    // the WHOLE shell build when the artifact is absent (2026-08-07 dev-deploy
    // break: "Failed to resolve './dist/wasm/dompiler.js'"). Runtime
    // resolution (importmap / node ctx) is unaffected; a miss lands in the
    // try's catch as the existing "// Compilation Error:" fallback.
    // dompiler@ca04450 fixes the package side (ships the wasm, untraceable
    // inner loader); this keeps the consumer build independent of which
    // dompiler version the lock pins.
    const DOMPILER_PKG = [
        '@symbo.ls',
        'dompiler'
    ].join('/');
    let dist = source;
    try {
        if (method === 'markdown-to-symbols') {
            const { MarkdownToDomQLCompiler: MarkdownToDomQLCompiler } = this.context.functions;
            const compiler = new MarkdownToDomQLCompiler();
            dist = compiler.compile(source, {
                componentName: 'MarkdownComponent'
            });
        } else if (method === 'symbols-to-react') {
            const { convertDomqlToReact: convertDomqlToReact } = await import(DOMPILER_PKG);
            const text = this.call('decodeNewlines', source).replace('export default ', 'export const Component = ');
            const compiled = await convertDomqlToReact(text);
            dist = await this.call('prettifyCode', compiled, {
                indent_size: 2,
                space_in_empty_paren: true,
                preserve_newlines: false,
                brace_style: 'collapse',
                break_chained_methods: false
            });
            dist = this.call('formatImports', dist);
        } else if (method === 'tailwind-to-symbols') dist = '// Tailwind to Symbols compilation not yet implemented\n' + source;
        else if (method === 'symbols-to-tailwind') dist = '// Symbols to Tailwind compilation not yet implemented\n' + source;
        else dist = source;
    } catch (error) {
        console.error('Compilation error:', error);
        dist = `// Compilation Error:\n// ${error.message}\n\n${source}`;
    }
    return dist;
};

});

parcelRegister("5jv03", function(module, exports) {

$parcel$export(module.exports, "compileToHtml", () => $3de6c604a9401977$export$993cbede8d0ab919);
// FA204 / frank trap — every helper this export needs (convertToKebabCase,
// formatAttributes, MAX_DEPTH, compileChildren) is declared INSIDE
// compileToHtml's own body instead of at module scope. compileToHtml is the
// ONLY export, so there's no sibling to keep these split out for; a
// module-scope const/function is unresolvable once compileToHtml is
// individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers) — nested declarations inside the
// exported function's own source are never rewritten and keep working via
// normal JS closures.
const $3de6c604a9401977$export$993cbede8d0ab919 = (props, level = 0)=>{
    const MAX_DEPTH = 100;
    const convertToKebabCase = (str)=>str.replace(/([a-z0-9])([A-Z])/gu, '$1-$2').replace(/([A-Z])([A-Z][a-z])/gu, '$1-$2').toLowerCase();
    const formatAttributes = (attrs, indent = 2, multiline = false)=>{
        if (!attrs || typeof attrs !== 'object') return '';
        const entries = Object.entries(attrs).filter(([key])=>![
                'children',
                'childProps',
                'text',
                'tag'
            ].includes(key) && typeof key === 'string' && key.match(/^[a-zA-Z][a-zA-Z0-9]*$/u));
        if (!multiline || entries.length <= 0) return entries.map(([key, value])=>`${convertToKebabCase(key)}="${value}"`).join(' ');
        return entries.map(([key, value])=>`${' '.repeat(indent + 2)}${convertToKebabCase(key)}="${value}"`).join('\n');
    };
    const compileChildren = (children, childProps = {}, level = 0)=>{
        const indent = ' '.repeat(level * 2);
        let html = '';
        if (!children || typeof children !== 'object') return html;
        Object.entries(children).forEach(([key, value])=>{
            if (!key.match(/^[a-zA-Z][a-zA-Z0-9]*$/u)) return;
            const tagName = convertToKebabCase(key);
            const attributes = formatAttributes(value);
            if (!value || typeof value !== 'object') return;
            if (!value.children) {
                html += `${indent}<${tagName}${attributes ? ` ${attributes}` : ''} />\n`;
                return;
            }
            // Element has children
            html += `${indent}<${tagName}${attributes ? ` ${attributes}` : ''}>\n`;
            if (Array.isArray(value.children)) value.children.forEach((child, index)=>{
                if (!child || typeof child !== 'object') return;
                const childAttributes = {
                    ...value.childProps || {},
                    ...child.childProps || {}
                };
                // First-child and last-child handling
                if (value.childProps && value.childProps[':first-child'] && index === 0) Object.assign(childAttributes, value.childProps[':first-child']);
                if (value.childProps && value.childProps[':last-child'] && index === value.children.length - 1) Object.assign(childAttributes, value.childProps[':last-child']);
                const childAttrs = formatAttributes(childAttributes, level + 1, true);
                const childContent = child.text || '';
                html += `${indent}  <div${childAttrs ? ` ${childAttrs}` : ''}>${childContent}</div>\n`;
            });
            html += `${indent}</${tagName}>\n`;
        });
        return html;
    };
    if (level > MAX_DEPTH) throw new Error('Maximum nesting depth exceeded');
    if (!props || typeof props !== 'object') throw new Error('Invalid input: props must be an object');
    const indent = ' '.repeat(level * 2);
    // Handle root level element with tag
    if (props.tag) {
        const tagName = convertToKebabCase(props.tag);
        const attributes = formatAttributes(props);
        if (!props.children) // Self-closing tag
        return `${indent}<${tagName}${attributes ? ` ${attributes}` : ''} />`;
        // Block-level tag with children
        const childrenHtml = compileChildren(props.children, props.childProps, level + 1);
        return `${indent}<${tagName}${attributes ? ` ${attributes}` : ''}>\n${childrenHtml}\n${indent}</${tagName}>`;
    }
    return compileChildren(props, {}, level);
};

});

parcelRegister("dvhZ1", function(module, exports) {

$parcel$export(module.exports, "stringifyProps", () => $02897c5dce3818f2$export$da9ba81e9f81934b);
$parcel$export(module.exports, "codify", () => $02897c5dce3818f2$export$368d04dc9198c46b);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");

var $5jv03 = parcelRequire("5jv03");
const $02897c5dce3818f2$export$da9ba81e9f81934b = (props, indent = 2)=>(0, $2C0hZ.objectToString)(props, indent);
const $02897c5dce3818f2$export$368d04dc9198c46b = (key, demoProps, appKey, opts = {})=>{
    const hasProps = demoProps && Object.keys(demoProps).length;
    const props = hasProps ? (0, $2C0hZ.objectToString)(demoProps, 2) : '{}';
    const propsForHtml = {
        tag: key,
        ...demoProps
    };
    const html = (0, $5jv03.compileToHtml)(propsForHtml);
    const boxSize = opts.width && opts.height ? ` width: ${opts.width}px; height: ${opts.height}px;` : '';
    return {
        symbols: `{
  ${key}: ${props}
}`,
        domql: `import { ${key} } from '~/smbls/${key}'

const MyComponent = {
  ${key}: ${props}
}`,
        react: hasProps ? `'use strict'

import React from 'react'
import { ${key} } from './${key}.js'

export const Component = () => {
  const props = ${props}
  return <${key} {...props} />
}` : `import { ${key} } from './${key}'

const MyComponent = props => {
  return <${key} {...props} />
}`,
        iframe: `<iframe
  title="${key}"
  style="border: 0; resize: both; padding: 0 10px 10px 0;${boxSize}"
  src="https://${appKey}/component?key=${key}&fullsize=true&hideUi=true" 
  referrerpolicy="no-referrer-when-downgrade"
></iframe>`,
        html: html
    };
};

});

parcelRegister("kqx4y", function(module, exports) {

$parcel$export(module.exports, "isDesignSystemRouteActive", () => $edefe3dcdc10a7d3$export$9745a33aaeba5f19);
$parcel$export(module.exports, "isStateRouteActive", () => $edefe3dcdc10a7d3$export$fdabc61fdeb38104);
$parcel$export(module.exports, "isLibraryComopnentRouteActive", () => $edefe3dcdc10a7d3$export$bea36e69577469cc);
$parcel$export(module.exports, "isPreviewComponentRouteActive", () => $edefe3dcdc10a7d3$export$724d7cb77f6c8c2b);
$parcel$export(module.exports, "isLibraryRouteActive", () => $edefe3dcdc10a7d3$export$40b93a3ed7a125f3);
$parcel$export(module.exports, "isPagesRouteActive", () => $edefe3dcdc10a7d3$export$82b8ff71bc8d3121);
$parcel$export(module.exports, "isSnippetsRouteActive", () => $edefe3dcdc10a7d3$export$ed6e8b7f0d3bb6f3);
$parcel$export(module.exports, "isTutorialsRouteActive", () => $edefe3dcdc10a7d3$export$27c10e04a118bcca);
$parcel$export(module.exports, "isFilesRouteActive", () => $edefe3dcdc10a7d3$export$650524fc9f9e792e);
$parcel$export(module.exports, "isFileRouteActive", () => $edefe3dcdc10a7d3$export$54adf33ca8279b98);
$parcel$export(module.exports, "isStudioRouteActive", () => $edefe3dcdc10a7d3$export$f26b45177f9dc213);
$parcel$export(module.exports, "isSettingsRouteActive", () => $edefe3dcdc10a7d3$export$7a14a33344c55d33);
$parcel$export(module.exports, "isIntegrationsRouteActive", () => $edefe3dcdc10a7d3$export$21aec178c8895f6a);
$parcel$export(module.exports, "isDocsRouteActive", () => $edefe3dcdc10a7d3$export$c5789bfbbfc0dfdc);
// Was `getLocationPath(0, r)` imported from '@symbo.ls/router' — that
// package has never exported a `getLocationPath` (only `getActiveRoute`,
// front-indexed, different semantics), so every export below threw at call
// time and was excluded from the `functions/index.js` barrel (frank
// `dropped-export`, 14 findings, 2026-08-09 frank-compile pass). The real
// last-path-segment helper is local (`./getLastLocationPath.js`, level 0 =
// last segment); importing a sibling project file directly is against the
// sibling-import rule (same call already made in `component.js`'s
// `goToRemovedComponentEditorRoute`), so inline the (level 0, `r` or
// `window.location.pathname`) case every export here needs.
//
// FA204 / frank trap — `_lastRouteSegment` used to be a single module-scope
// const shared by every export below; unresolvable once each export is
// individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers). Each export now carries its
// own self-contained inline copy.
const $edefe3dcdc10a7d3$export$9745a33aaeba5f19 = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/design-system',
        '/typography',
        '/color',
        '/icons',
        '/shape',
        '/font',
        '/timing',
        '/theme',
        '/cases',
        '/media',
        '/grid',
        '/spacing'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$fdabc61fdeb38104 = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/state',
        '/data'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$bea36e69577469cc = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/editor',
        '/export'
    ].includes(route) || (r || window.location.pathname).includes('/editor');
};
const $edefe3dcdc10a7d3$export$724d7cb77f6c8c2b = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/component'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$40b93a3ed7a125f3 = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/component',
        '/components',
        '/layouts',
        '/atoms',
        '/layout',
        '/blocks',
        '/block',
        '/export',
        '/editor',
        '/marketplace',
        '/library'
    ].includes(route) || (r || window.location.pathname).includes('/editor');
};
const $edefe3dcdc10a7d3$export$82b8ff71bc8d3121 = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/pages',
        '/page'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$ed6e8b7f0d3bb6f3 = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/functions'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$27c10e04a118bcca = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/tutorials',
        '/tutorial'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$650524fc9f9e792e = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/files'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$54adf33ca8279b98 = (r)=>(r || window.location.pathname).includes('/edit-file');
const $edefe3dcdc10a7d3$export$f26b45177f9dc213 = (r)=>(r || window.location.pathname).includes('/studio');
const $edefe3dcdc10a7d3$export$7a14a33344c55d33 = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/schema',
        '/settings'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$21aec178c8895f6a = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/integrations',
        '/install',
        '/connect'
    ].includes(route);
};
const $edefe3dcdc10a7d3$export$c5789bfbbfc0dfdc = (r)=>{
    const _lastRouteSegment = (r)=>{
        const route = r || window.location.pathname;
        const parts = route.split('/');
        const seg = parts[parts.length - 1];
        return seg ? `/${seg}` : undefined;
    };
    const route = _lastRouteSegment(r) || '';
    return [
        '/index',
        '/api',
        '/tutorials',
        '/cli',
        '/developers',
        '/playground',
        '/convert',
        '/docs'
    ].includes(route);
};

});

parcelRegister("j3ApK", function(module, exports) {

$parcel$export(module.exports, "getThemeState", () => $ddfa8b3cc094f865$export$6c1c32a51c44427d);
$parcel$export(module.exports, "getProjectThemeValues", () => $ddfa8b3cc094f865$export$672fafd60c8680fc);
$parcel$export(module.exports, "findColorReference", () => $ddfa8b3cc094f865$export$7342cd07f40f5c4a);
$parcel$export(module.exports, "getColorReference", () => $ddfa8b3cc094f865$export$ee4504183db3c328);
$parcel$export(module.exports, "getGradientReference", () => $ddfa8b3cc094f865$export$534dd86b48e67bf2);
$parcel$export(module.exports, "getProjectColorByValue", () => $ddfa8b3cc094f865$export$ea905cca416bbbf2);
$parcel$export(module.exports, "getProjectColorsFactory", () => $ddfa8b3cc094f865$export$fec5ccb673c4b4d4);
$parcel$export(module.exports, "getProjectThemeColors", () => $ddfa8b3cc094f865$export$a691d482543a0646);
$parcel$export(module.exports, "getActiveThemeValue", () => $ddfa8b3cc094f865$export$a532b1a5af38c0fb);
$parcel$export(module.exports, "setThemeValueInProject", () => $ddfa8b3cc094f865$export$2a65b09d44c1de28);
function $ddfa8b3cc094f865$export$6c1c32a51c44427d() {
    const { state: state } = this;
    const themeState = state.key ? state : state.parent;
    return themeState.key ? themeState : themeState.parent;
}
function $ddfa8b3cc094f865$export$672fafd60c8680fc(forcedTheme, globalTheme) {
    const { state: state } = this;
    const sceneTheme = globalTheme || this.call('getGlobalTheme');
    const themeState = state.key ? state : state.parent.key ? state.parent : null;
    if (!themeState) return this.warn('Theme not found', themeState);
    const themeScope = (forcedTheme || themeState.value || themeState)[`@${sceneTheme}`] || {};
    const { color: color, background: background, borderColor: borderColor, outlineColor: outlineColor, ...rest } = themeScope;
    return {
        color: color,
        background: background,
        borderColor: borderColor,
        outlineColor: outlineColor,
        ...rest
    };
}
function $ddfa8b3cc094f865$export$7342cd07f40f5c4a(FACTORY, value) {
    const globalTheme = this.call('getGlobalTheme');
    if (!value || !this.call('isString', value)) return this.error(`Problem with ${value}`);
    const [colorValue] = value.split(' ');
    let color = FACTORY[colorValue];
    if (globalTheme && this.call('isObject', color)) color = color[`@${globalTheme}`];
    if (color && color.slice(0, 2) === '--') color = this.call('findColorReference', FACTORY, color.slice(2));
    return color;
}
function $ddfa8b3cc094f865$export$ee4504183db3c328(value) {
    return this.call('findColorReference', this.getDesignSystem('color'), value);
}
function $ddfa8b3cc094f865$export$534dd86b48e67bf2(value) {
    return this.call('findColorReference', this.getDesignSystem('gradient'), value);
}
function $ddfa8b3cc094f865$export$ea905cca416bbbf2(value) {
    if (!value) return;
    const color = this.call('getColorReference', value);
    if (color && typeof color === 'string') {
        const [colorValue, opacity] = color.split(' ');
        const colorArr = this.call('colorStringToRgbaArray', colorValue);
        const [r, g, b] = colorArr;
        return `rgba(${r}, ${g}, ${b}, ${opacity || 1})`;
    }
    const gradient = this.call('getGradientReference', value);
    return gradient;
}
function $ddfa8b3cc094f865$export$fec5ccb673c4b4d4() {
    return (key)=>this.call('getProjectColorByValue', key);
}
function $ddfa8b3cc094f865$export$a691d482543a0646(forcedTheme, sceneTheme) {
    const { color: color, background: background, borderColor: borderColor, outlineColor: outlineColor, ...rest } = this.call('getProjectThemeValues', forcedTheme, sceneTheme);
    const getFromColorFactory = this.call('getProjectColorsFactory');
    return {
        color: getFromColorFactory(color),
        background: getFromColorFactory(background),
        borderColor: getFromColorFactory(borderColor),
        outlineColor: getFromColorFactory(outlineColor),
        ...rest
    };
}
function $ddfa8b3cc094f865$export$a532b1a5af38c0fb(themeKey) {
    const { sceneTheme: sceneTheme } = this.getRootState();
    const { theme: THEME } = this.getDesignSystem();
    if (!themeKey) themeKey = this.call('getThemeState').themeKey;
    const themeFromData = sceneTheme ? THEME[themeKey][`@${sceneTheme}`] : THEME[themeKey];
    return themeFromData;
}
async function $ddfa8b3cc094f865$export$2a65b09d44c1de28(themeKey, key, val, options) {
    const { sceneTheme: sceneTheme } = this.getRootState();
    const value = {
        [key]: val
    };
    const THEME = {
        [themeKey]: sceneTheme ? {
            [`@${sceneTheme}`]: value
        } : value
    };
    await this.updateDesignSystem({
        theme: THEME
    }, options);
}

});

parcelRegister("cO4Du", function(module, exports) {

$parcel$export(module.exports, "isColorVariable", () => $952dc01fab400713$export$a30cc56bb2eace2d);
function $952dc01fab400713$export$a30cc56bb2eace2d(k, factory) {
    const v = factory[k];
    const isSrtingVar = (v2)=>this.call('isString', v2) && v2.startsWith('--');
    if (this.call('isString', v)) return isSrtingVar(v);
    if (this.call('isArray', v)) return v.some(isSrtingVar);
    if (this.call('isObject', v)) return Object.values(v).some(isSrtingVar);
    return false;
}

});

parcelRegister("bTIk3", function(module, exports) {

$parcel$export(module.exports, "isModalRoute", () => $8a973646257e1f4a$export$dccb6c3b12695432);
function $8a973646257e1f4a$export$dccb6c3b12695432(path) {
    return (this.call('findModal', path) || {}).FoundModal;
}

});

parcelRegister("35Ta9", function(module, exports) {

$parcel$export(module.exports, "appDialogClose", () => $240ca0e28e4ebafe$export$83d218b27a4a4ee3);
// Shared close-writer for AppDialog (see components/AppDialog.js). Any
// descendant of an AppDialog (backdrop, header close button, footer cancel
// button) calls this with the dialog's `stateKey` (+ optional `extraClose`
// patch) to null it out — the exact `root.update({[stateKey]: null, ...})`
// shape already proven in packages/shared/components/Modal.js's
// `_maybeDismiss`, generalized so AppDialog doesn't need its own module-level
// singleton (Rule 33 — no module-level closures).
function $240ca0e28e4ebafe$export$83d218b27a4a4ee3(stateKey, extraClose) {
    const el = this;
    if (!stateKey) return;
    const root = el.state && el.state.root;
    if (!root || !root.update) return;
    root.update(extraClose && typeof extraClose === 'object' ? {
        [stateKey]: null,
        ...extraClose
    } : {
        [stateKey]: null
    });
}

});

parcelRegister("fW7s5", function(module, exports) {

$parcel$export(module.exports, "appDialogSync", () => $b9a20d9f748e308d$export$5659da9e99b9f6f8);
// Open/close focus-lifecycle side effect for AppDialog. Called from inside
// the dialog's own `isOpen` reactive prop factory — the same
// side-effect-inside-a-reactive-prop technique already proven in
// packages/shared/components/Modal.js's `_syncUrl` (called from `Modal`'s
// `isOpen` prop). Per-element state only (`el._wasOpen` / `el._returnFocusTo`
// on `this`), no module-level singleton: AppDialog's Escape handling is
// per-instance (bubbling `onKeydown` on the dialog root), not a shared
// global listener, so there's nothing to coordinate across instances here.
function $b9a20d9f748e308d$export$5659da9e99b9f6f8(open) {
    const el = this;
    if (typeof document === 'undefined') return;
    if (open === el._wasOpen) return;
    el._wasOpen = open;
    if (open) {
        el._returnFocusTo = document.activeElement;
        if (typeof requestAnimationFrame === 'function') requestAnimationFrame(()=>el.call('appDialogFocusPanel'));
        else el.call('appDialogFocusPanel');
    } else {
        if (el._returnFocusTo && el._returnFocusTo.focus) el._returnFocusTo.focus();
        el._returnFocusTo = null;
    }
}

});

parcelRegister("8ZCF3", function(module, exports) {

$parcel$export(module.exports, "appDialogFocusPanel", () => $68c2028699d1bc3c$export$1fec4b627432227c);
// Moves focus into an AppDialog's Panel on open. `this` is the AppDialog
// ROOT element (called from its own `isOpen` factory via `el.call`, deferred
// a frame so the Panel's `hide:`/visibility flip has already landed in the
// DOM) — `el.node` is the root's DOM node, and the Panel is its only
// focusable descendant (Backdrop has none), so a plain `querySelectorAll`
// from the root finds the right candidates without needing a separate
// Panel-scoped call. Reads `el.node` to find the first VISIBLE focusable
// descendant — a read, then a `.focus()` call, both allowed on `el.node`
// per Rule 39; no assignment to `.style`/`.innerHTML`/`.value` anywhere
// here.
//
// `offsetParent !== null` filters out any candidate sitting inside a
// `hide:`-gated (display:none) ancestor — e.g. a conditionally-hidden
// "Cancel" button that renders earlier in DOM order than the always-visible
// "Close" button, or a checkbox inside a `hide`-gated confirmation row
// (NatOrderCancelModal's `ManagerRow`, gated on `needsManager`). A plain
// `querySelector` picks the first DOM-order match regardless of visibility,
// and `.focus()` on a `display:none` element silently no-ops — leaving
// focus wherever it was before the dialog opened. Caught live (scheduling
// app migration, design-agent, tickets/workspace.md a11y ticket) driving
// `NatAppointmentDetailModal`/`NatOrderCancelModal` open in a real browser
// and asserting on `document.activeElement`, not from a source-only review.
// `appDialogTrapTab.js`'s Tab-cycle already used this exact filter — this
// brings the two sibling functions back in sync.
//
// `initialFocus` (AppDialog v2, DESIGN_SPEC §6.6):
//   'field' — the first enabled FORM control (a form: type straight away);
//             falls back to the first focusable, then to the panel
//   'panel' — the Panel itself (`tabindex: -1`): a read-only detail, where
//             landing on its first control (the Close button) made a screen
//             reader skip the title
//   default — 'panel' for a side panel, 'field' for a centre sheet.
// `preventScroll`: the panel is mid-entrance (transformed); a focus scroll
// would jerk the frame behind it.
function $68c2028699d1bc3c$export$1fec4b627432227c() {
    const el = this;
    if (typeof document === 'undefined' || !el.node) return;
    const panel = el.Panel && el.Panel.node;
    const side = el.presentation === 'side' || !el.presentation && el.anchor === 'right';
    const mode = el.initialFocus || (side ? 'panel' : 'field');
    const focus = (n)=>{
        try {
            n.focus({
                preventScroll: true
            });
        } catch (e) {
            n.focus();
        }
    };
    if (mode === 'panel' && panel && panel.focus) return focus(panel);
    const visible = (n)=>n.offsetParent !== null;
    const fields = el.node.querySelectorAll('input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [contenteditable="true"]');
    const field = Array.prototype.find.call(fields, visible);
    if (field && field.focus) return focus(field);
    const nodeList = el.node.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    const focusable = Array.prototype.find.call(nodeList, visible);
    if (focusable && focusable.focus) focus(focusable);
    else if (panel && panel.focus) focus(panel);
    else if (el.node.focus) focus(el.node);
}

});

parcelRegister("b9FHP", function(module, exports) {

$parcel$export(module.exports, "appDialogTrapTab", () => $81f0e2e185a46466$export$87d3087fbb406d14);
// Tab/Shift+Tab cycling confined to an AppDialog's Panel — or a Modal's
// Window (the same trap since 2026-09-26: Tab left CreateAgentModal for the
// page behind, and Escape then did nothing, found by ws-w2). `this` is the
// panel element (called from its own `onKeydown`). Deliberately NOT
// implemented via `inert` on the rest of the page — a recorded trap in this
// codebase: `pointer-events: none` on an inert background silences the
// layer's OWN `mouseenter`/dismiss escape hatches too, so an inert-based
// trap can leave the dialog impossible to close by mouse. A scoped
// Tab-cycle over the panel's own focusable descendants gets the same
// keyboard containment without touching anything outside the panel.
function $81f0e2e185a46466$export$87d3087fbb406d14(e) {
    if (!e || e.key !== 'Tab') return;
    const el = this;
    if (!el.node || typeof document === 'undefined') return;
    // The selector names candidate KINDS; tabbability is decided in the filter,
    // for EVERY candidate. A roving-tabindex member — an ARIA tablist's inactive
    // tab, `role=tab tabindex="-1"` — matches `button:not([disabled])`, but the
    // native Tab order never stops on it: counting it as first/last makes
    // `active === last` unreachable at the true native-last control, and Tab
    // leaks past the panel (APPDIALOG-TRAPTAB-LEAKS-PAST-ROVING-TABINDEX-TABLIST-1,
    // found live on the CRM contact detail panel). The `tabIndex` PROPERTY, not
    // the attribute: it resolves defaults and invalid values the way the
    // browser's own tab order does, and a harness stand-in without it
    // (`undefined < 0` is false) stays tabbable.
    const nodeList = el.node.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]');
    const focusable = Array.prototype.filter.call(nodeList, (n)=>n.offsetParent !== null && !(n.tabIndex < 0));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    // Focus on the PANEL ITSELF (a side panel's `initialFocus: 'panel'`, the
    // Modal window its manageFocus lands on): Shift+Tab from there went to
    // whatever precedes the panel in the document — the page behind. From the
    // panel (or from anywhere not inside it) both directions enter the cycle.
    const atPanel = active === el.node || typeof el.node.contains === 'function' && !el.node.contains(active);
    if (e.shiftKey && (active === first || atPanel)) {
        e.preventDefault();
        last.focus();
    } else if (!e.shiftKey && (active === last || atPanel)) {
        e.preventDefault();
        first.focus();
    }
}

});

parcelRegister("ihnfM", function(module, exports) {

$parcel$export(module.exports, "appDialogCloseNearest", () => $d4ebda2cf61d6820$export$b1d5dd2124db773f);
// The registered entry to an AppDialog's close path (components/AppDialog.js
// v2) — for code OUTSIDE the dialog's own handlers: a consumer's custom
// Cancel, a "Done" that closes after saving, a row action inside the body.
//
//   el.call('appDialogCloseNearest')                        // Close, Cancel
//   el.call('appDialogCloseNearest', { fromBackdrop: true }) // veil semantics
//
// `this` is the element that asks. The logic lives ONCE, on the dialog
// itself (`AppDialog.scope.closeNearest`, reached through the scope chain from
// any descendant): the nearest dialog root; a backdrop click inert while the
// dialog is `dirty` (DESIGN_SPEC §6.7 — no silent loss of unsaved input);
// `closeCall` for a host-driven dialog; otherwise `stateKey` (+ `extraClose`)
// nulled on the root state. The dialog's own Esc / veil / Close / Cancel call
// the scope directly, so they work even where this function is not
// registered (a standalone module's sharedLibraries.js).
//
// Returns true when a close was requested, false when nothing closed —
// including when `this` is not inside an AppDialog.
function $d4ebda2cf61d6820$export$b1d5dd2124db773f(opts) {
    const el = this;
    const scope = el && el.scope;
    if (!scope || typeof scope.closeNearest !== 'function') return false;
    return scope.closeNearest(el, opts);
}

});

parcelRegister("3NC9D", function(module, exports) {

$parcel$export(module.exports, "appPageWindow", () => $2c438b5f466cdc3f$export$68811e1581b675f9);
// The pages a pager's capsule shows — brief §4.5 item 6 (P25, P31): the
// first and the last page, and the current page with two on each side, so
// never more than 7 chips; ascending, and a gap in the numbers shows the
// skipped pages. Lifted from the /data pager (workspace 77a1efbae, its
// `_pageWindow`) into the kit, so every AppPagination windows the same way
// and a page with its own state shape can reuse it:
//
//   el.call('appPageWindow', page, pageCount)  // → [1, 8, 9, 10, 11, 12, 20]
//
// `page` is clamped into 1..pageCount, so a stale page never drops the
// current chip out of the window.
function $2c438b5f466cdc3f$export$68811e1581b675f9(page, pageCount) {
    const total = Math.max(1, Math.floor(Number(pageCount) || 1));
    const cur = Math.min(total, Math.max(1, Math.floor(Number(page) || 1)));
    const pages = new Set([
        1,
        total
    ]);
    for(let p = cur - 2; p <= cur + 2; p++)if (p >= 1 && p <= total) pages.add(p);
    return [
        ...pages
    ].sort((a, b)=>a - b);
}

});

parcelRegister("duYxQ", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $9d3d0aa1f7e1921a$export$bced8d2aada2d1c9);
async function $9d3d0aa1f7e1921a$export$bced8d2aada2d1c9(message) {
    const msgBuffer = new TextEncoder('utf-8').encode(message);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b)=>`00${b.toString(16)}`.slice(-2)).join('');
    return hashHex;
}

});

parcelRegister("8A4TU", function(module, exports) {
// Legacy single-arg variant kept for git-history reference.
// The canonical arraizeIconsCategory(library, searchTerm) lives in
// ./arraizeIconsCategory.js — both files in the same barrel tripped
// frank's duplicate-export scan, so this declaration is no longer
// exported. Remove this file in a follow-up if no consumer regresses.
function $63f57cba6beeb395$var$arraizeIconsCategory(library) {
    return (()=>{
        const list = Object.keys(library);
        if (this.state.searched) return list.filter((value)=>value.includes(this.state.searched));
        return list;
    })().map((key)=>({
            key: key,
            value: library[key]
        }));
}

});

parcelRegister("ge9rC", function(module, exports) {

$parcel$export(module.exports, "goToComponentEditorRoute", () => $bd054799f47b7531$export$c1cfea9471b9485d);
$parcel$export(module.exports, "goToRemovedComponentEditorRoute", () => $bd054799f47b7531$export$8223d435145ba23e);
$parcel$export(module.exports, "goToComponentPreviewRoute", () => $bd054799f47b7531$export$bea75bf4c3c0a6b9);
$parcel$export(module.exports, "getComponentStateSchema", () => $bd054799f47b7531$export$8ec1c53f1edbfd02);
$parcel$export(module.exports, "getPageStateSchema", () => $bd054799f47b7531$export$9d45835e640cf403);
$parcel$export(module.exports, "toggleComponentLock", () => $bd054799f47b7531$export$1e7664e0a174e65e);
$parcel$export(module.exports, "toggleComponentFavorite", () => $bd054799f47b7531$export$e089420601f116c1);
$parcel$export(module.exports, "setError", () => $bd054799f47b7531$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "addItemWithDependencies", () => $bd054799f47b7531$export$2c786875953bf1d);
// From '@symbo.ls/utils', not the 'smbls' barrel — keeps the framework bundle
// out of the eager chunk (same fix as workspace/functions/extensionDesignSystem.js).
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
const $bd054799f47b7531$export$c1cfea9471b9485d = (componentKey, el, state)=>{
    const { pathname: pathname } = window.location;
    const key = componentKey || state.key || state.value;
    let href = `${pathname}/editor/${key}`;
    if (pathname.includes('/editor')) {
        const parts = pathname.split('/');
        parts[parts.length - 1] = key;
        href = parts.join('/');
    }
    if (pathname.includes('/preview')) {
        const parts = pathname.split('/');
        parts[parts.length - 1] = key;
        href = parts.join('/');
    }
    return href;
};
const $bd054799f47b7531$export$8223d435145ba23e = (componentKey)=>{
    // Was `getLastLocationPath()` imported from '@symbo.ls/router' — that
    // package has never exported a `getLastLocationPath` (only
    // `getActiveRoute`, front-indexed, different semantics). The real
    // `getLastLocationPath(level, route)` is local
    // (./getLastLocationPath.js, level 0 = last path segment); importing a
    // sibling project file directly is against the sibling-import rule, so
    // inline the (level 0, current pathname) case this call site needs.
    const routeArray = window.location.pathname.split('/');
    const lastSegment = routeArray[routeArray.length - 1];
    const lastLocationPath = lastSegment ? `/${lastSegment}` : undefined;
    if (lastLocationPath === `/${componentKey}`) return window.location.pathname.split('/').slice(0, -2).join('/');
    return window.location.pathname;
};
const $bd054799f47b7531$export$bea75bf4c3c0a6b9 = (el, state)=>{
    const { pathname: pathname } = window.location;
    let href = `${pathname}/preview/${state.key}`;
    if (pathname.includes('/preview')) {
        const parts = pathname.split('/');
        parts[parts.length - 1] = state.key;
        href = parts.join('/');
    }
    return href;
};
const $bd054799f47b7531$export$8ec1c53f1edbfd02 = (el)=>{
    el.warn('redundant');
};
const $bd054799f47b7531$export$9d45835e640cf403 = async (el)=>{
    const { root: root } = el.parent.state;
    const key = root.route.slice(5) || '/';
    const pageKey = key === '/main' || key === '/index' ? '/' : key;
    const page = el.getData('pages')[pageKey];
    const schema = el.getSchema('pages')[pageKey];
    const designSystem = await el.getDefaultDesignSystem();
    if (!page) {
        if (pageKey === '/DesignSystem') return {
            key: 'DesignSystem',
            title: 'Design System',
            value: (0, $2C0hZ.deepClone)(designSystem)
        };
        else if (pageKey === '/Components') return {
            key: 'Components',
            title: 'Components'
        };
    }
    return {
        ...schema,
        value: (0, $2C0hZ.deepClone)(page)
    };
};
async function $bd054799f47b7531$export$1e7664e0a174e65e() {
    const data = this.getCanvasScope();
    const { inContext: inContext } = data;
    const { key: key } = this.state;
    const type = this.getType(key);
    // Read the CURRENT locked state from the canonical root schema BEFORE
    // mutating any local state — otherwise a chain of two state.toggle()
    // calls (one on `this.state`, one on `inContext.state`) can race the
    // SDK's path-update for #2047 and wipe sibling props (fontSize, color
    // and friends in `value`) that the user just edited but hasn't yet
    // hoisted to the root tree. We let `sdk.updateData` own the propagation
    // and only nudge the two visual surfaces (gridstack widget + the local
    // states) afterwards with field-level patches.
    const currentLocked = !!this.getSchema(type)?.[key]?.locked;
    const nextLocked = !currentLocked;
    // gridstack only — does not touch the embedded iframe content or the
    // component's value tree.
    this.getCanvasFrameWindow().gs.update(inContext.node, {
        locked: nextLocked,
        noResize: nextLocked,
        noMove: nextLocked
    });
    // Persist the targeted field, then patch local UI mirrors with `update`
    // (merge) instead of `toggle` — `toggle` flips whatever the proxy
    // currently holds, which can drift from the truth source if a stray
    // reactive pass has already mutated `locked` underfoot.
    this.sdk.updateData([
        [
            'update',
            [
                'schema',
                type,
                key,
                'locked'
            ],
            nextLocked
        ]
    ], {
        message: `"${key}" ${type.slice(0, -1)} is ${nextLocked ? 'locked' : 'unlocked'}`
    });
    this.state.update({
        locked: nextLocked
    });
    inContext.state.update({
        locked: nextLocked
    });
}
async function $bd054799f47b7531$export$e089420601f116c1() {
    const data = this.getCanvasScope();
    const { inContext: inContext } = data;
    const { key: key } = this.state;
    const type = this.getType(key);
    // See toggleComponentLock for why we read truth from getSchema rather
    // than from the local proxies, and why we patch with `update` rather
    // than `toggle` — see #2047.
    const currentHighlighted = !!this.getSchema(type)?.[key]?.highlighted;
    const nextHighlighted = !currentHighlighted;
    this.sdk.updateData([
        [
            'update',
            [
                'schema',
                type,
                key,
                'highlighted'
            ],
            nextHighlighted
        ]
    ], {
        message: nextHighlighted ? `"${key}" ${type.slice(0, -1)} marked as favorite` : `"${key}" ${type.slice(0, -1)} removed from favorites`
    });
    this.state.update({
        highlighted: nextHighlighted
    });
    inContext.state.update({
        highlighted: nextHighlighted
    });
}
async function $bd054799f47b7531$export$b8d0bb2aa0adefe5() {
    const data = this.getCanvasScope();
    const { inContext: inContext } = data;
    const { value: value, ...schema } = this.state.parse();
    const { key: key } = schema;
    const type = this.getType(key);
    await this.state.toggle('highlighted');
    inContext.state.toggle('highlighted');
    const { highlighted: highlighted } = this.getSchema(type)[key];
    this.sdk.updateData([
        [
            'update',
            [
                'schema',
                type,
                key,
                'highlighted'
            ],
            !highlighted
        ]
    ], {
        message: !highlighted ? `"${key}" ${type.slice(0, -1)} marked as favorite` : `"${key}" ${type.slice(0, -1)} removed from favorites`
    });
// await this.call('rerenderFileSidebarByType', type).update(
//   {},
// )
}
async function $bd054799f47b7531$export$2c786875953bf1d(component, dependencyData, opts = {}) {
    // If component exists on canvas don't add it
    const library = await this.getDefaultComponents();
    const builtInComponents = this.context.components;
    const { type: type, key: key } = component;
    const exists = this.getDataItem(key);
    if (exists) this.return;
    // Duplicate the current component
    const res = await this.call('createItem', type, key, component, opts);
    if (!res.success) return this.call('openNotification', {
        type: 'error',
        title: this.call('polyglot', 'editor.component.duplicateFailed.title'),
        message: this.call('polyglot', 'editor.code.evalError.message')
    });
    const newComponent = this.getItem(key, type);
    if (!newComponent || !newComponent.uses || !newComponent.uses.length) return;
    // Process all dependencies recursively
    const processDependency = async (useKey)=>{
        const isBuiltIn = builtInComponents[`smbls.${useKey}`];
        if (isBuiltIn) return;
        const dependency = dependencyData.find((c)=>c.key === useKey);
        if (!dependency) return;
        if (!dependency.value || typeof dependency.value === 'undefined') dependency.value = library[useKey];
        await this.call('addItemWithDependencies', dependency, dependencyData, {
            skipSelection: true
        });
        // Process nested dependencies
        if (dependency.uses?.length) for (const depUseKey of dependency.uses)await processDependency(depUseKey);
    };
    for (const useKey of newComponent.uses)await processDependency(useKey);
}

});

parcelRegister("gOFBH", function(module, exports) {
// export function updateFunctionFromState() {
//   const { key, value, code } = this.state
//   try {
//     const res = this.call('updateFunction')
//     this.test('Updating Function in data', () => {
//       return this.testCase(
//         'Value equals canvas context',
//         'isEqualFunction',
//         this.getFunctions(key),
//         value
//       )
//     })
//     if (res?.success) {
//       this.call('updateFunctionOnCanvas', code)
//       this.test('Updating Function on Canvas', () => {
//         return (
//           this.testCase(
//             'Value equals root state',
//             'isEqualFunction',
//             this.getFunctions(key),
//             value
//           ) &&
//           this.testCase(
//             'Value equals root state',
//             'isEqual',
//             this.getCanvasCollection()
//               .context.functions[key].toString()
//               .replaceAll('\n', ''),
//             value.toString().replaceAll('\n', '')
//           )
//         )
//       })
//     }
//   } catch (e) {
//     console.error(e)
//   }
// }
// export function updateFunctionOnCanvas(codeStr, type = 'functions') {
//   // window.requestAnimationFrame(() => {
//   const Canvas = this.getCanvas()
//   const { chosen } = this.getCanvasScope()
//   const Collection = this.getCanvasCollection()
//   const { key } = this.state
//   if (Collection) {
//     const { contentWindow } = Canvas.Iframe.node
//     const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
//       secrets: this.getSecrets(),
//       window: contentWindow
//     })
//     const ctx = Collection.context
//     ctx[type][key] = evalCode
//     ctx.utils[key] = evalCode
//     const { packages } = contentWindow
//     packages[type][key] = evalCode
//     packages.utils[key] = evalCode
//   } else {
//     this.error('Canvas Collection was not found')
//   }
//   if (chosen) {
//     const ChosenScene = this.getChosenScene()
//     const { ComponentFrameCanvas } = ChosenScene.ViewSvitcher
//     const ChosenFrame = ComponentFrameCanvas?.Iframe
//     if (!ChosenFrame) {
//       return
//     }
//     const { contentWindow } = ChosenFrame.node
//     const evalCode = this.call('evalStringCodeUnsafe', codeStr, {
//       secrets: this.getSecrets(),
//       window: contentWindow
//     })
//     const { packages } = contentWindow
//     packages[type][key] = evalCode
//     packages.utils[key] = evalCode
//     ChosenFrame.update()
//   }
//   // })
// }
// export function updateFunction() {
//   const { key } = this.state
//   try {
//     return this.sdk.updateItem(
//       this.call('getType'),
//       {
//         ...this.state,
//         key
//       },
//       { message: `Updating function ${key}` }
//     )
//   } catch (err) {
//     this.state.update({
//       err
//     })
//   }
// }
// export async function duplicateFunction() {
//   const { key } = this.state
//   const type = this.call('getType')
//   this.sdk.addItem(
//     type,
//     {
//       ...this.state,
//       key: key.concat('Copy')
//     },
//     {
//       message: `Duplicating function ${key}`,
//       ...this.call('returnAddedCanvasPageChanges', type, key)
//     }
//   )
//   const updatedSection = await this.call('rerenderFileSidebarByType', type)
//   if (!updatedSection) {
//     await this.getDynamicIsland()?.update()
//   }
// }

});

parcelRegister("fGnco", function(module, exports) {

$parcel$export(module.exports, "openFile", () => $b6acc619375ba3b2$export$c47c8b06a9966d9f);
// import { evalStringCodeUnsafe } from './code-stringify'
// export const updateFile = (codeStr, el, s) => {
// const { content, key, code, type, format } = s
// s.getRootState().files[key] = { content, code, key, type, format }
// el.getRootState().update({
//   files: { [key]: s.files[key] }
// }, {
//   message: `Updated ${s.key} function`,
//   preventUpdate: true
// })
// window.requestAnimationFrame(() => {
//   const Canvas = el.getCanvas() || el.__ref.root.data.Canvas
//   const { Iframe } = this.getChosenScene().ComponentFrameCanvas
//   const { contentWindow } = Iframe.node
//   const { chosen, Collection } = Canvas.data.chosen
//   const evalCode = evalStringCodeUnsafe(codeStr, this.getSecrets(), contentWindow)
//   if (chosen || Collection) {
//     const chosenCtx = (chosen || Collection).context
//     chosenCtx.files[s.key].code = evalCode
//   }
//   const { packages } = contentWindow
//   packages.files[s.key] = evalCode
//   packages.functions[s.key] = evalCode
//   packages.utils[s.key] = evalCode
//   Iframe.update()
// })
// }
async function $b6acc619375ba3b2$export$c47c8b06a9966d9f(key) {
    await this.call('openRouterModal', '/edit-file', {
        key: key || this.state.key
    });
}
function $b6acc619375ba3b2$var$appendCopyToFileName(fileName) {
    const dotIndex = fileName.lastIndexOf('.');
    const hasExtension = dotIndex !== -1;
    let name = hasExtension ? fileName.substring(0, dotIndex) : fileName;
    const extension = hasExtension ? fileName.substring(dotIndex) : '';
    // Regular expression to check if '-copy' followed by an optional number exists
    const copyRegex = /-copy(?:-(?<temp1>\d+))?$/u;
    const match = name.match(copyRegex);
    if (match) {
        // If '-copy' exists, increment the number
        const copyNumber = match[1] ? parseInt(match[1], 10) + 1 : 1;
        name = name.replace(copyRegex, `-copy-${copyNumber}`);
    } else // Otherwise, just append '-copy'
    name += '-copy';
    return name + extension;
}

});

parcelRegister("6X4XN", function(module, exports) {

$parcel$export(module.exports, "componentsCollectionByFilter", () => $50fc1a6d40647cbd$export$18c6ece5a99af5c1);
$parcel$export(module.exports, "componentsCollectionFilter", () => $50fc1a6d40647cbd$export$82040223dec21d8d);
// TODO: check if its calling uses await
async function $50fc1a6d40647cbd$export$18c6ece5a99af5c1(limit) {
    const { recents: recents } = this.getRootState();
    const componentShowFilter = this.getUserSettings('componentShowFilter');
    const components = Object.values(this.getSchema('components'));
    if (componentShowFilter === 'all') return limit ? components.filter((v, k)=>k < limit) : components;
    if (componentShowFilter === 'recents') {
        const recentComponents = recents.map((v)=>this.getSchema('components')[v]);
        return limit ? recentComponents.filter((v, k)=>k < limit) : recentComponents;
    }
    if (componentShowFilter === 'builtins') return {} // COMPONENTS
    ;
    if (componentShowFilter === 'library') return await this.getDefaultComponents();
    return components.filter((v)=>v[this.state.type]);
}
function $50fc1a6d40647cbd$export$82040223dec21d8d(arr) {
    const { tags: tags, filters: filters, type: type } = this.state;
    const { recents: recents } = this.getRootState();
    const componentShowFilter = this.getUserSettings('componentShowFilter');
    const { category: category } = filters;
    const categoryFilter = (v)=>{
        if (v.draft) return;
        if (category && tags.length) return v.category === category && this.call('arrayContainsOtherArray', tags, v.tags || []);
        if (category) return v.category === category;
        if (tags.length) return this.call('arrayContainsOtherArray', tags, v.tags || []);
        return true;
    };
    if (componentShowFilter === 'all') return category || tags ? arr.filter(categoryFilter) : arr;
    if (componentShowFilter === 'recents') {
        const recentComponents = recents.map((v)=>this.getSchema('components')[v]).filter((v)=>v);
        return category || tags ? recentComponents.filter(categoryFilter) : recentComponents;
    }
    if (componentShowFilter === 'builtins') return {} // COMPONENTS
    ;
    if (componentShowFilter === 'library') return {} // LIBRARY
    ;
    return category || tags ? arr.filter((v)=>v[type] && categoryFilter(v)) : arr.filter((v)=>v[type]);
}

});

parcelRegister("eXsA7", function(module, exports) {

$parcel$export(module.exports, "findIcon", () => $ae3cbf15f14a8035$export$41266a01e6efb017);
$parcel$export(module.exports, "getProjectIcon", () => $ae3cbf15f14a8035$export$e165bda3046afda);
const $ae3cbf15f14a8035$export$41266a01e6efb017 = (key)=>{
    const iconMap = {
        deviceMobile: [
            'mobile',
            'phone',
            'unset'
        ],
        deviceTabletPortrait: [
            'tabletS'
        ],
        deviceTabletLandscape: [
            'tabletM',
            'tabletL'
        ],
        deviceSmallScreen: [
            'screenS',
            'screenM'
        ],
        deviceBigScreen: [
            'screenL',
            'tv'
        ],
        columnsOutline: [
            'canvas'
        ],
        layoutOutline: [
            'custom'
        ]
    };
    let icon = null;
    const keys = Object.keys(iconMap);
    Object.values(iconMap).forEach((device, index)=>{
        const isInArray = device.includes(key);
        if (isInArray) icon = keys[index];
        else device.forEach((deviceKey)=>{
            if (key.includes(deviceKey)) icon = keys[index];
        });
    });
    return `${icon}Outline`;
};
function $ae3cbf15f14a8035$export$e165bda3046afda() {
    const state = this.getRootState();
    if (state.icon?.src) return state.icon?.src;
    return null;
}

});

parcelRegister("2olvW", function(module, exports) {

$parcel$export(module.exports, "initializeSDK", () => $1bde82f2847e48fd$export$26d3303d189ae997);
$parcel$export(module.exports, "updateSDKContext", () => $1bde82f2847e48fd$export$c0784dc55987d6a3);
$parcel$export(module.exports, "initializeUserSession", () => $1bde82f2847e48fd$export$cb77225f5b9034ef);
$parcel$export(module.exports, "updateUserSession", () => $1bde82f2847e48fd$export$6dee61322d96e5d);

var $1NxyO = parcelRequire("1NxyO");
async function $1bde82f2847e48fd$export$26d3303d189ae997(ctx) {
    const sdk = (0, $1NxyO.getSDK)();
    await (0, $1NxyO.awaitSDKInit)();
    ctx.methods.sdk = sdk;
    return sdk;
}
async function $1bde82f2847e48fd$export$c0784dc55987d6a3({ userData: userData, project: project }) {
    const ctx = {};
    if (userData) ctx.user = userData.user;
    if (project) {
        ctx.appKey = project.key;
        ctx.project = project;
    }
    await this.sdk.updateContext({
        ...ctx,
        state: this.getRootState()
    });
}
async function $1bde82f2847e48fd$export$cb77225f5b9034ef(options) {
    const { loginData: loginData } = options;
    try {
        // Store the current timestamp in sessionStorage
        sessionStorage.setItem('lastInitUserSessionTime', Date.now().toString());
        // Extract user and tokens from login response
        const { user: userData, tokens: tokens } = loginData;
        // Add projects to userData
        const userInfo = {
            ...userData,
            currentUser: userData,
            userId: userData.id
        };
        if (userData.projectId && userData.projectName && userData.appKey) {
            const contextUpdate = {
                userData: userInfo
            };
            await this.call('updateSDKContext', contextUpdate);
            this.call('updateApplicationState', {
                authToken: tokens.accessToken,
                userData: userInfo
            });
            // SIGNUP-INTENT — the link's preset/plan/source, sent once after an
            // explicit sign-in (functions/signupIntent.js); never breaks it.
            try {
                this.call('sendSignupIntent');
            } catch (_) {}
            return;
        }
        this.call('updateApplicationState', {
            authToken: tokens.accessToken,
            userData: userInfo
        });
        // SIGNUP-INTENT — see the branch above
        try {
            this.call('sendSignupIntent');
        } catch (_) {}
    } catch (error) {
        console.error('Failed to initialize user session:', error);
        throw error;
    }
}
async function $1bde82f2847e48fd$export$6dee61322d96e5d({ projectId: projectId }) {
    try {
        // Get current user data from CoreService
        const currentUser = await this.sdk.getUserProfile();
        const userProjects = await this.sdk.getUserProjects();
        const userData = {
            ...currentUser,
            currentUser: currentUser,
            userId: currentUser.id,
            projects: userProjects || []
        };
        if (projectId) {
            const basicProject = await this.sdk.getProject(projectId);
            if (basicProject && basicProject.id) {
                const { key: appKey, name: projectName } = basicProject;
                const currentProjectMember = basicProject.members.find((m)=>m && m.user && m.user.id === userData.id);
                const projectRole = currentProjectMember ? currentProjectMember.role : 'guest';
                const contextUpdate = {
                    userData: userData,
                    ...basicProject && {
                        project: basicProject
                    },
                    ...appKey && {
                        appKey: appKey
                    },
                    ...projectRole && {
                        projectRole: projectRole
                    }
                };
                await this.call('updateSDKContext', contextUpdate);
                const loadedProjectData = await this.call('loadProjectData', projectId);
                const projectData = {
                    ...basicProject,
                    ...loadedProjectData,
                    ...appKey && {
                        appKey: appKey
                    },
                    ...projectId && {
                        projectId: projectId
                    },
                    ...projectName && {
                        projectName: projectName
                    },
                    ...projectRole && {
                        projectRole: projectRole
                    }
                };
                return this.call('updateApplicationState', {
                    userData: userData,
                    projectData: projectData
                });
            }
        }
        this.call('updateApplicationState', {
            userData: userData
        });
    } catch (error) {
        console.error('[updateUserSession] Error:', error);
        throw error;
    }
}

});

parcelRegister("8hLkC", function(module, exports) {

});

parcelRegister("8c8Hz", function(module, exports) {

$parcel$export(module.exports, "previewUrlTokenizer", () => $5f7631b1e2599631$export$d9654de8f8ec7d19);
$parcel$export(module.exports, "screenshotTokenizer", () => $5f7631b1e2599631$export$c0e5e78af970a194);
$parcel$export(module.exports, "imgToBase64Url", () => $5f7631b1e2599631$export$3ebc765b89cdf628);
$parcel$export(module.exports, "createRemoteScreenshot", () => $5f7631b1e2599631$export$679e25a5d8771e9f);
$parcel$export(module.exports, "createMainPageScreenshot", () => $5f7631b1e2599631$export$91f661dcb5b2097a);
function $5f7631b1e2599631$export$d9654de8f8ec7d19(obj) {
    const { appKey: appKey } = obj;
    const key = obj.key ? `?key=${obj.key}` : '';
    const width = obj.width ? `&width=${obj.width}` : '';
    const height = obj.height ? `&height=${obj.height}` : '';
    const globalTheme = obj.globalTheme === 'dark' ? '&dark_mode=true' : '';
    const hideUi = obj.hideUi ? '&hide_ui=true' : '';
    const URI = obj.isPage ? `${obj.key}?` : `/component${key}`;
    return `https://${appKey}${URI}${width}${height}${hideUi}${globalTheme}`;
}
function $5f7631b1e2599631$export$c0e5e78af970a194(obj, opts = {}) {
    // FA204 / frank trap — moved from module scope into this function (sole
    // consumer, pure literal — see longPress.js for the identical shape).
    const DEF_OPTIONS = {
        selector: true,
        lazy_load: true,
        omit_background: true,
        output: true,
        retina: true,
        filetype: 'webp'
    };
    const { appKey: appKey } = obj;
    const key = obj.key ? `?key=${obj.key}` : '';
    const width = obj.width && !opts.pdf ? `&width=${obj.width}` : '';
    const height = obj.height && !opts.pdf ? `&height=${obj.height}` : '';
    const hideUi = obj.hideUi ? `&hide_ui=${true}` : '';
    const URI = obj.isPage ? `${obj.key}?` : `/component${key}`;
    const screenshot = opts.pdf ? '' : '&screenshot=true';
    const componentUrl = encodeURIComponent(`https://${appKey}${URI}${width}${height}${hideUi}${screenshot}`);
    const userAgent = 'user_agent=Mozilla%2F5.0%20(Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7)%20AppleWebKit%2F537.36%20(KHTML%2C%20like%20Gecko)%20Chrome%2F128.0.0.0%20Safari%2F537.36';
    const params = [
        'token=SGG5Q3D-WZN437D-NCC3ZZ2-Q15ZMZG',
        `url=${componentUrl}`,
        userAgent,
        !opts.pdf && width,
        !opts.pdf && height,
        `dark_mode=${obj.globalTheme === 'dark'}`,
        'fresh=true',
        (opts || DEF_OPTIONS).output && 'output=image',
        opts.pdf ? 'file_type=pdf&pdf_options%5Bformat%5D)=A4&pdf_options%5Bmedia%5D)=print&pdf_options%5Blandscape%5D)=false&pdf_options%5Bprint_background%5D)=true&pdf_options%5Bpage_range%5D)=1-50&full_page=true&page_range=1-50&delay=350' : `file_type=${opts?.filetype || DEF_OPTIONS.filetype || 'webp'}`,
        'wait_for_event=domcontentloaded',
        (opts || DEF_OPTIONS).retina && 'retina=true',
        (opts || DEF_OPTIONS).selector && 'selector=%5Bkey%3D%22Component%22%5D',
        (opts || DEF_OPTIONS).lazy_load && 'lazy_load=true',
        (opts || DEF_OPTIONS).omit_background && 'omit_background=true'
    ].filter((v)=>v).join('&');
    return `https://shot.screenshotapi.net/screenshot?&${params}`;
}
function $5f7631b1e2599631$export$3ebc765b89cdf628(img) {
    // Encode the SVG string to Base64
    const base64 = window.btoa(unescape(encodeURIComponent(img)));
    // Create a data URL with the Base64-encoded SVG
    const base64Url = `data:image/svg+xml;base64,${base64}`;
    return base64Url;
}
async function $5f7631b1e2599631$export$679e25a5d8771e9f(opts = {}) {
    const data = this.getCanvasScope();
    const { selected: selected } = data;
    if (!selected?.node) return;
    const { appKey: appKey, sceneTheme: sceneTheme } = this.getRootState();
    const { key: key } = this.state;
    const width = selected.node.offsetWidth;
    const height = selected.node.offsetHeight;
    const isPage = key.startsWith('/');
    const factoryKey = isPage ? 'pages' : 'components';
    const API_URL = this.call('screenshotTokenizer', {
        appKey: appKey,
        isPage: isPage,
        key: key,
        width: width,
        height: height,
        retina: false,
        hideUi: true,
        globalTheme: sceneTheme
    }, {
        pdf: opts.pdf,
        output: false
    });
    const response = await window.fetch(API_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response2)=>response2.json());
    response.smblsUrl = response.screenshot?.replace('https://storage.screenshotapi.net/', 'https://screenshots.api.symbols.app/');
    // el.log(API_URL)
    // el.log(response)
    const screenshot = opts.pdf ? {
        pdf: response
    } : {
        thumbnail: response
    };
    this.getRootState().quietUpdate({
        schema: {
            [factoryKey]: {
                [key]: screenshot
            }
        }
    }, {
        message: `Updated screenshot on "${key}"`
    });
    this.state.quietUpdate(screenshot);
    this.lookup('ComponentEditor').update();
    this.lookup('EditorPanels').state.quietReplace(screenshot);
}
async function $5f7631b1e2599631$export$91f661dcb5b2097a(changes) {
    const pages = changes?.schema?.pages;
    const projectsLength = Object.keys(pages || {}).length;
    const MainPage = pages?.['/'];
    const onlyMainPage = MainPage && projectsLength === 1 && !changes?.schema?.components;
    if (!onlyMainPage) return;
    const { appKey: appKey, sceneTheme: sceneTheme } = this.getRootState();
    const API_URL = this.call('screenshotTokenizer', {
        appKey: appKey,
        isPage: true,
        key: '/',
        width: 920,
        height: 560,
        retina: false,
        hideUi: true,
        globalTheme: sceneTheme
    });
    const response = await window.fetch(API_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response2)=>response2.json());
    // el.log(API_URL)
    // el.log(response)
    const thumbnail = response.screenshot?.replace('https://storage.screenshotapi.net/', 'https://screenshots.api.symbols.app/');
    this.getRootState().quietUpdate({
        thumbnail: thumbnail
    }, {
        preventUpdate: true,
        saveOnly: true,
        preventShModalUpdate: true,
        preventContentUpdate: true,
        message: 'Updated project thumbnail'
    });
    const activeProj = this.getRootState('projects').filter((v)=>v.key === appKey)[0];
    activeProj.thumbnail = thumbnail;
}

});

parcelRegister("b05XF", function(module, exports) {

$parcel$export(module.exports, "goToStudioRoute", () => $8024519fa5b91b20$export$495b783ac587a3a1);
const $8024519fa5b91b20$export$495b783ac587a3a1 = (componentKey)=>`/studio/${componentKey}`;

});

parcelRegister("2s8AP", function(module, exports) {

$parcel$export(module.exports, "updateLocked", () => $1c94dcaa86961a42$export$1b1dc2a42c70db90);
function $1c94dcaa86961a42$export$1b1dc2a42c70db90(key) {
    const prop = `lockedPrevious_${key}`;
    const overlayElem = this[key === 'hovered' ? 'Hovered' : 'Selected'];
    const activeItem = this.getCanvasScope()[key];
    const locked = this.isReadOnly() || activeItem?.state?.locked || activeItem?.state?.content?.src;
    if (this.data[prop] === locked) return;
    this.data[prop] = locked;
    if (locked) overlayElem.setNodeStyles({
        ResizeOverlay: {
            display: 'none'
        },
        DragHandler: {
            display: 'none'
        }
    });
    else overlayElem.setNodeStyles({
        ResizeOverlay: {
            display: 'block'
        },
        DragHandler: {
            display: 'block'
        }
    });
}

});

parcelRegister("3IV5G", function(module, exports) {

$parcel$export(module.exports, "intersectionObserver", () => $2b61c43109dca663$export$ef81a4cd6adfcbc3);
const $2b61c43109dca663$export$ef81a4cd6adfcbc3 = (window)=>(el, s)=>{
        window.requestAnimationFrame(()=>{
            // TODO: add small looping to find node
            if (!el.node) return;
            new window.IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    let t = null;
                    if (entry.isIntersecting) t = setTimeout(()=>{
                        const { scale: scale } = window.scope.positions;
                        if (!el.content) el.set(scale < 0.5 ? '123' : el.data.content(el, s));
                        window.requestAnimationFrame(()=>el.node.style.opacity = 1);
                        clearTimeout(t);
                    }, 35);
                    else {
                        clearTimeout(t);
                        if (el.content) el.removeContent();
                    }
                });
            }).observe(el.node);
        });
    };

});

parcelRegister("bUPew", function(module, exports) {

$parcel$export(module.exports, "editorPanelsReposition", () => $8accaa81e7f4e7a9$export$1276f51dcba930a9);
$parcel$export(module.exports, "createCanvasArtboard", () => $8accaa81e7f4e7a9$export$15527cbb38bd577a);
function $8accaa81e7f4e7a9$export$1276f51dcba930a9() {
    const data = this.getCanvasScope();
    const s = this.state;
    const { priorityCode: priorityCode, activeState: activeState, activeDs: activeDs, activeFunction: activeFunction, componentEditor: componentEditor } = this.getWindow();
    this.variables({
        activeFunction: activeFunction
    }).changed(()=>{
        if (activeFunction) {
            const key = data.activeFunction;
            const schema = this.getSchema('functions')[key] || this.getSchema('methods')[key];
            const value = this.getFunctions(key) || this.getMethods(key);
            const state = this.call('deepClone', {
                key: key,
                value: value,
                ...schema
            });
            this.FunctionEditor.state.set(state, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('function');
        } else {
            this.FunctionEditor.state.set({
                code: null
            }, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('component');
        }
    });
    this.variables({
        activeState: activeState
    }).changed(()=>{
        if (activeState) {
            const key = data.activeState;
            const schema = this.getSchema('state')[key];
            const value = this.getState(key);
            const state = this.call('deepClone', {
                key: key,
                value: value,
                ...schema
            });
            this.StateEditor.state.set(state, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('state');
        } else {
            this.StateEditor.state.set({
                code: null
            }, {
                forceMonacoUpdate: true
            });
            this.changeCodePriority('component');
        }
    });
    this.variables({
        priorityCode: priorityCode
    }).changed(()=>{
        const hasComponent = s.value && componentEditor;
        if (hasComponent && activeFunction) {
            const componentState = !priorityCode || priorityCode === 'component' ? '.isActive' : '!isActive';
            const functionState = priorityCode === 'function' ? '.isActive' : '!isActive';
            this.ComponentEditor.setNodeStyles(this.ComponentEditor.props[componentState]);
            this.FunctionEditor.setNodeStyles(this.FunctionEditor.props[functionState]);
        } else {
            this.ComponentEditor.setNodeStyles(this.ComponentEditor.props['!isActive']);
            this.FunctionEditor.setNodeStyles(this.ComponentEditor.props['!isActive']);
        }
    });
}
async function $8accaa81e7f4e7a9$export$15527cbb38bd577a(type, key, opts) {
    const Collection = this.getCanvasCollection();
    const item = this.getItem(key, type);
    const element = await Collection.append({
        extends: Collection.childExtend,
        state: item
    }, `${Collection.content.__ref.__children.length}`);
    const frameWindow = this.getCanvasFrameWindow();
    const addedGridItem = frameWindow.gs.addWidget(element.node);
    const gridOpts = {
        w: addedGridItem.getAttribute('gs-w'),
        h: addedGridItem.getAttribute('gs-h'),
        x: addedGridItem.getAttribute('gs-x'),
        y: addedGridItem.getAttribute('gs-y')
    };
    // Quietly save grid settings in database
    window.setTimeout(()=>{
        this.sdk.updateData([
            [
                'update',
                [
                    'schema',
                    type,
                    key,
                    'settings',
                    'gridOptions'
                ],
                gridOpts
            ]
        ], {
            skipSidebar: true
        });
    }, 350);
    if (!opts.skipSelection) {
        this.activateSelected(key);
        this.zoomToNode(this.getSelected());
    }
}

});

parcelRegister("WuWK6", function(module, exports) {

$parcel$export(module.exports, "positions", () => $0afd6c379c44f011$export$878041e1e4cd4218);
$parcel$export(module.exports, "scrollStack", () => $0afd6c379c44f011$export$442a5db862090a4f);
$parcel$export(module.exports, "registerScrollListener", () => $0afd6c379c44f011$export$2ae59a3a1c144a62);
const $0afd6c379c44f011$export$878041e1e4cd4218 = {};
const $0afd6c379c44f011$export$442a5db862090a4f = [];
const $0afd6c379c44f011$export$2ae59a3a1c144a62 = (el)=>$0afd6c379c44f011$export$442a5db862090a4f.push(el);
// Guard against Node-side execution (Brender pre-render / SSR / tests):
// these listeners are browser-only and `document` is undefined when this
// module is loaded outside a browser. Without the guard, importing
// shared/functions/index.js — which is now reached by Brender's import
// graph via the freestyle/canvas glue — throws
// `document is not defined` and breaks `bun run build` for every PR.
if (typeof document !== 'undefined') {
    // Add scroll event listener
    document.addEventListener('scroll', (event)=>{
        if ($0afd6c379c44f011$export$442a5db862090a4f.length) // Filter out elements with non-existent nodes
        for(let i = $0afd6c379c44f011$export$442a5db862090a4f.length - 1; i >= 0; i--){
            const v = $0afd6c379c44f011$export$442a5db862090a4f[i];
            if (!v.node || !document.body.contains(v.node)) {
                $0afd6c379c44f011$export$442a5db862090a4f.splice(i, 1);
                continue;
            }
            // Was `v.on.scroll || v.onScroll`. `el.on` was REMOVED in DOMQL v3.14
            // (elements carry flat `onEvent` handlers), so `v.on` is `undefined`
            // and reading `.scroll` off it throws
            // `TypeError: Cannot read properties of undefined (reading 'scroll')`
            // — which, inside this loop, would abort the whole scroll dispatch on
            // the FIRST registered element and silently drop every subsequent
            // element's handler. Latent today only because `registerScrollListener`
            // has zero call sites in the monorepo, so `scrollStack` never fills;
            // it would have fired the moment anything registered. No v3
            // `on: { scroll: … }` authoring remains anywhere in workspace/ or
            // company/, so the flat read is the only one needed.
            const handler = v.onScroll;
            if (handler) handler(event, v, v.state);
        }
    });
    document.addEventListener('mousemove', (event)=>{
        $0afd6c379c44f011$export$878041e1e4cd4218.mouseX = event.clientX;
        $0afd6c379c44f011$export$878041e1e4cd4218.mouseY = event.clientY;
    });
}

});

parcelRegister("7sAM5", function(module, exports) {

$parcel$export(module.exports, "generateGrid", () => $56e7ac9ef91db79d$export$ca2a698f6020fda);
$parcel$export(module.exports, "rerenderGrid", () => $56e7ac9ef91db79d$export$8be1d92f975fcc7);
const $56e7ac9ef91db79d$export$ca2a698f6020fda = (n = 24)=>{
    const obj = {
        '& > .grid-stack-item': {
            width: `${100 / n}%`
        },
        '& > .grid-stack-item[gs-x="1"]': {
            left: `${100 / n}%`
        }
    };
    for(let i = 1; i <= n; i++){
        const percent = `${100 / n * i}%`;
        obj[`& > .grid-stack-item[gs-w="${i}"]`] = {
            width: percent
        };
        obj[`& > .grid-stack-item[gs-x="${i}"]`] = {
            left: percent
        };
    }
    return obj;
};
const $56e7ac9ef91db79d$export$8be1d92f975fcc7 = async (window, el)=>{
    const optimizedMode = el.getUserSettings('optimizedMode');
    const opts = optimizedMode ? {
        ...el.gridOptions,
        // minimal resizing and dragging,
        resizable: {
            handles: 'se'
        },
        draggable: {}
    } : el.gridOptions;
    const isFreeformFalse = el.call('getCurrentCanvasPage')?.freeform === false;
    opts.float = !isFreeformFalse;
    const gs = window.gs = window.GridStack.addGrid(el.node, opts);
    const gridItems = gs.getGridItems().map((v)=>v.gridstackNode);
    await el.updateGridsInSchema(gridItems);
};

});

parcelRegister("5AAY8", function(module, exports) {

$parcel$export(module.exports, "toggleVersion", () => $411cfdccdfd948f7$export$a73d0886b3cfedec);
function $411cfdccdfd948f7$export$a73d0886b3cfedec() {
    const scope = this.getCanvasScope();
    const { isVersionsOpen: isVersionsOpen } = this.getRootState();
    const Versions = this.lookup('Versions');
    const Playground = this.lookup('Playground');
    if (isVersionsOpen) {
        // if (data.explorer) {
        //   scope.explorer = false
        //   this.data.sidebarCached = true
        //   // this.EditorPanels.CanvasProjectSidebar.update()
        // }
        // LOOKUP-SHAPE-1: `Versions`/`Playground` are captured once above (a
        // `lookup()` miss returns undefined) and then derefed unguarded inside
        // nested `window.setTimeout`s below — a miss there threw into nothing
        // (no error surface, user-invisible) instead of throwing loudly where
        // this ran inline. Guarded every deref; a miss now no-ops instead of
        // throwing into a timer.
        const closeVersions = ()=>{
            Playground?.setNodeStyles(Playground?.['.isVersionsOpen']);
            const { selected: selected, chosen: chosen } = scope;
            scope.selectedCached = selected;
            scope.chosenCached = chosen;
            const t2 = window.setTimeout(()=>{
                this.activateSelected(null);
                this.activateChosen(null);
                const t3 = window.setTimeout(()=>{
                    Versions?.VersionsAside?.setNodeStyles(Versions?.VersionsAside?.fadeIn);
                    Versions?.VersionFooter?.setNodeStyles(Versions?.VersionFooter?.fadeIn);
                    clearTimeout(t3);
                }, 35);
                clearTimeout(t2);
            }, 35);
        };
        const t = window.setTimeout(()=>{
            if (Playground) closeVersions();
            else {
                const t2 = window.setTimeout(()=>{
                    closeVersions();
                    clearTimeout(t2);
                }, 350);
            }
            clearTimeout(t);
        }, 350);
    } else {
        Playground?.setNodeStyles(Playground?.['!isVersionsOpen']);
        Versions?.VersionsAside?.setNodeStyles(Versions?.VersionsAside?.fadeOut);
        Versions?.VersionFooter?.setNodeStyles(Versions?.VersionFooter?.fadeOut);
        const t = window.setTimeout(()=>{
            const t2 = window.setTimeout(()=>{
                // if (scope.sidebarCached) {
                //   delete scope.sidebarCached
                //   // this.EditorPanels.update()
                // }
                const t3 = window.setTimeout(()=>{
                    const { selectedCached: selectedCached, chosenCached: chosenCached } = scope;
                    if (selectedCached) this.activateSelected(selectedCached);
                    if (chosenCached) this.activateChosen(chosenCached);
                    clearTimeout(t3);
                }, 35);
                clearTimeout(t2);
            }, 35);
            clearTimeout(t);
        }, 35);
    }
}

});

parcelRegister("cYOLJ", function(module, exports) {

$parcel$export(module.exports, "setFullscreenPosition", () => $97327844b90fe7c3$export$9d9f5f5bc57e7eec);
function $97327844b90fe7c3$export$9d9f5f5bc57e7eec() {
    // const { isVersionsOpen, isFullscreen, isCanvasActive } = this.getRootState()
    const { isVersionsOpen: isVersionsOpen, isFullscreen: isFullscreen } = this.getRootState();
    // const Tabs = this.lookup('CanvasNavbar')
    // console.log(isFullscreen)
    // console.log(isVersionsOpen)
    this.variables({
        isFullscreen: isFullscreen,
        isVersionsOpen: isVersionsOpen
    }).changed(()=>{
        let top;
        // if (isFullscreen || isVersionsOpen) {
        //   top = 'var(--spacing-Y)'
        //   Tabs?.setNodeStyles?.(Tabs.props?.fadeOut)
        // } else {
        //   top = 'var(--spacing-C)'
        //   Tabs?.setNodeStyles?.(Tabs.props?.fadeIn)
        // }
        this.setNodeStyles({
            Library: {
                top: top
            },
            CanvasPane: {
                top: top
            }
        });
    });
}

});

parcelRegister("buj0C", function(module, exports) {

$parcel$export(module.exports, "openChosen", () => $85d13dd533426d10$export$aa9638b682e61bca);
$parcel$export(module.exports, "toggleChosenNavbar", () => $85d13dd533426d10$export$87eb2d7a8ac8230b);
$parcel$export(module.exports, "closeChosen", () => $85d13dd533426d10$export$fd7623d236a723f5);
$parcel$export(module.exports, "adjustChosenFrameSize", () => $85d13dd533426d10$export$21eb8af02f1466a3);
$parcel$export(module.exports, "adjustMainWindow", () => $85d13dd533426d10$export$d794b64e719e2689);
$parcel$export(module.exports, "setChosenInitialPositions", () => $85d13dd533426d10$export$7b4561c420d8271b);
$parcel$export(module.exports, "adjustChosenAfterOpen", () => $85d13dd533426d10$export$ff4295a59c0f8173);
$parcel$export(module.exports, "adjustResponsive", () => $85d13dd533426d10$export$47085748fda14b82);
function $85d13dd533426d10$export$aa9638b682e61bca() {
    this.variables({
        chosen: this.getChosenKey()
    }).changed((changes, prev)=>{
        this.call('canvasFade', true);
        const useAnimations = this.getUserSettings('useAnimations');
        const noPrevious = !prev.chosen;
        this.call('toggleChosenNavbar');
        if (noPrevious && useAnimations) this.call('setChosenInitialPositions');
        this.getChosenScene().update();
    });
}
function $85d13dd533426d10$export$87eb2d7a8ac8230b() {
    if (this.getChosenKey()) {
        this.getChosenSceneNavbar().setNodeStyles({
            display: 'flex'
        });
        this.getEditorPanels()?.ComponentEditor.EditNavbar.setNodeStyles({
            display: 'none'
        });
    } else {
        this.getChosenSceneNavbar().setNodeStyles({
            display: 'none'
        });
        this.getEditorPanels()?.ComponentEditor.EditNavbar.setNodeStyles({
            display: 'flex'
        });
    }
}
function $85d13dd533426d10$export$fd7623d236a723f5() {
    const { isVersionsOpen: isVersionsOpen } = this.getRootState();
    this.call('canvasFade', false);
    this.getChosenViewSvitcher().setNodeStyles({
        transitionProperty: 'none',
        opacity: 0
    });
    this.call('toggleChosenNavbar');
    this.data.loaded = null;
    if (!isVersionsOpen) this.getRootState().isFullscreen = false;
}
function $85d13dd533426d10$export$21eb8af02f1466a3() {
    const scope = this.getCanvasScope();
    const { explorer: explorerInChosenPosChanged, selected: selectedPosChanged, editorActive: editorActive } = scope;
    this.variables({
        editorActive: editorActive,
        explorerInChosenPosChanged: explorerInChosenPosChanged,
        selectedPosChanged: selectedPosChanged
    }).changed(()=>{
        const t = setTimeout(()=>{
            let left = 'var(--canvas-gutter)';
            if (this.call('isString', explorerInChosenPosChanged)) {
                const dynamicIslandElementRect = this.getDynamicIsland().node.getBoundingClientRect();
                // const width = this.getDynamicIsland().node.scrollWidth
                left = `calc(var(--canvas-gutter) + ${dynamicIslandElementRect.left + dynamicIslandElementRect.width}px)`;
            } else if (editorActive) {
                const quickEditorRect = this.getQuickEditor().node.getBoundingClientRect();
                // const width = this.getDynamicIsland().node.scrollWidth
                left = `calc(var(--canvas-gutter) + ${quickEditorRect.left + quickEditorRect.width}px)`;
            }
            this.getChosenElement().setNodeStyles({
                left: left
            });
            clearTimeout(t);
        }, 250);
    });
}
function $85d13dd533426d10$export$d794b64e719e2689() {
    const isFullscreenEditorPanels = this.getRootState('isFullscreen');
    const s = this.state;
    const data = this.getCanvasScope();
    // if (!data) return
    const { docs: docs, fiddle: fiddle, componentEditor: componentEditor, explorer: explorerInChosen, library: library, designSystem: designSystem, selected: selected, activeFunction: activeFunction, activeState: activeState, activeDs: activeDs } = data;
    const isCodeViewerActive = selected && componentEditor || activeFunction || activeState || activeDs;
    const selectedInChosen = this.getSelectedKey();
    const chosenInChosen = this.getChosenKey();
    this.variables({
        selectedInChosen: selectedInChosen,
        chosenInChosen: chosenInChosen,
        isFullscreenEditorPanels: isFullscreenEditorPanels,
        docs: docs,
        fiddle: fiddle,
        library: library,
        designSystem: designSystem,
        explorerInChosen: explorerInChosen,
        componentEditor: componentEditor,
        activeFunction: activeFunction,
        activeState: activeState,
        activeDs: activeDs,
        isCodeViewerActive: isCodeViewerActive
    }).changed(async (changes)=>{
        if (isCodeViewerActive) this.getEditorPanels()?.setNodeStyles({
            display: 'flex'
        });
        else this.getEditorPanels()?.setNodeStyles({
            display: 'none'
        });
        const selectedHasChanged = Object.hasOwn(changes, 'selectedInChosen');
        if (selectedHasChanged) {
            data.hoverLayer = null;
            data.activeLayer = null;
            if (selectedInChosen) {
                const componentState = this.call('deepClone', this.getSelected().state.parse());
                // console.log(componentState)
                await s.set(componentState, {
                    preventStateUpdateListener: true,
                    forceMonacoUpdate: true
                });
            } else if (!selectedInChosen) {
                if (s.value) {
                    delete s.code;
                    await s.remove('value', {
                        preventStateUpdateListener: true,
                        forceMonacoUpdate: false
                    });
                }
            }
            const autoscroll = this.getUserSettings('explorerAutoscroll');
            if (autoscroll && explorerInChosen) {
                await this.call('rerenderFileSidebarByType', 'components');
                await this.call('rerenderFileSidebarByType', 'pages');
            }
        }
        const codeEditorHasChanged = Object.hasOwn(changes, 'isCodeViewerActive');
        if (selectedHasChanged || codeEditorHasChanged) {
            if (isCodeViewerActive) {
                this.getComponentEditor()?.parent.setNodeStyles({
                    display: 'flex'
                });
                this.getComponentEditor()?.setNodeStyles({
                    display: 'flex'
                });
                if (codeEditorHasChanged && !selectedHasChanged) this.getComponentEditor()?.update();
                window.requestAnimationFrame(()=>{
                    this.changeCodePriority('component', this);
                });
            } else {
                this.getComponentEditor()?.parent.setNodeStyles({
                    display: 'none'
                });
                this.getComponentEditor()?.setNodeStyles({
                    display: 'none'
                });
            }
        }
    });
}
function $85d13dd533426d10$export$7b4561c420d8271b() {
    const data = this.getCanvasScope();
    const { positions: positions, chosen: chosen } = data;
    const { scale: scale } = positions;
    const ChosenElem = chosen?.Flex || chosen;
    if (!ChosenElem.node) return;
    const rect = ChosenElem.node.getBoundingClientRect();
    const ChosenScene = this.getChosenScene();
    const chosenScenePos = ChosenScene.node.getBoundingClientRect();
    const ViewSvitcher = ChosenScene.ViewSvitcher;
    // Calculate the position relative to ChosenScene
    const relLeft = rect.left - chosenScenePos.left + ChosenScene.node.scrollLeft;
    const relTop = rect.top - chosenScenePos.top + ChosenScene.node.scrollTop;
    const unscaledWidth = rect.width / scale;
    const unscaledHeight = rect.height / scale;
    // When scaling from center, the top-left corner shifts by:
    // (unscaled_dimension * (scale - 1)) / 2
    // We need to compensate by moving the element back
    const offsetX = unscaledWidth * (scale - 1) / 2;
    const offsetY = unscaledHeight * (scale - 1) / 2;
    const left = relLeft + offsetX;
    const top = relTop + offsetY;
    const right = left + unscaledWidth;
    const bottom = top + unscaledHeight;
    ViewSvitcher.setNodeStyles({
        opacity: 1,
        transitionProperty: 'none',
        transform: `translate3d(0, 0, 1px) scale(${scale})`,
        inset: `${top}px ${ChosenScene.node.offsetWidth - right}px ${ChosenScene.node.offsetHeight - bottom}px ${left}px`
    });
}
function $85d13dd533426d10$export$ff4295a59c0f8173() {
    const { data: data } = this;
    window.requestAnimationFrame(()=>{
        this.getChosenScene().ViewSvitcher.setNodeStyles({
            transform: 'translate3d(0, 0, 1px)',
            transitionProperty: 'transform, inset',
            position: 'absolute',
            opacity: 1,
            inset: '0',
            width: 'auto',
            height: 'auto'
        });
        window.requestAnimationFrame(()=>{
            this.getChosenSceneNavbar().update();
        });
    });
    data.loaded = true;
}
function $85d13dd533426d10$export$47085748fda14b82() {
    const { previewSize: previewSize } = this.getCanvasScope();
    const ChosenScene = this.getChosenScene();
    const { ComponentFrameCanvas: ComponentFrameCanvas } = ChosenScene.ViewSvitcher;
    const isUnset = previewSize === 'unset';
    const isResizable = previewSize === 'resizable';
    const isCustom = previewSize === 'custom';
    const isAllDevices = previewSize === 'canvas';
    this.variables({
        previewSize: previewSize
    }).changed((changes, prev)=>{
        const wasResizable = prev.previewSize === 'resizable';
        const wasCustom = prev.previewSize === 'custom';
        const wasAllDevices = prev.previewSize === 'canvas';
        ComponentFrameCanvas.setNodeStyles({
            transitionProperty: 'transform, max-width, max-height, left, top, right, width, height'
        });
        const t = setTimeout(()=>{
            ComponentFrameCanvas.setNodeStyles({
                transitionProperty: 'transform, max-width, max-height, left, top, right'
            });
            clearTimeout(t);
        }, 350);
        if (isCustom || wasCustom || isAllDevices || wasAllDevices) {
            const t2 = setTimeout(()=>{
                ChosenScene.ViewSvitcher.removeContent();
                ChosenScene.ViewSvitcher.set(ChosenScene.ViewSvitcher.data.content(this, this.state, this.context));
                clearTimeout(t2);
            }, 65);
        }
        if (isAllDevices) {
            const breakpoint = this.context.designSystem.DEVICES.mobileM;
            const [widthVal] = breakpoint;
            const maxWidth = `${widthVal}px`;
            ComponentFrameCanvas.setNodeStyles({
                ...ComponentFrameCanvas.props['.isAllDevices'],
                maxWidth: maxWidth,
                maxHeight: '100%'
            });
            const t2 = setTimeout(()=>{
                if (ChosenScene.ViewSvitcher) ChosenScene.ViewSvitcher.node.scrollBy(3600, 0);
                clearTimeout(t2);
            }, 65);
        // this.setNodeStyles({
        //   content: {}
        // })
        } else if (wasAllDevices) // this.setNodeStyles({
        //   content: {
        //   }
        // })
        ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['!isAllDevices']
        });
        if (isResizable) ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['.isResizable']
        });
        else if (wasResizable) ComponentFrameCanvas.setNodeStyles({
            // height: '100%',
            ...ComponentFrameCanvas.props['!isResizable']
        });
        if (isCustom) ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['.isResponsiveMode']
        });
        else if (wasCustom) ComponentFrameCanvas.setNodeStyles({
            ...ComponentFrameCanvas.props['!isResponsiveMode']
        });
        if (isUnset || !previewSize) ComponentFrameCanvas.setNodeStyles({
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%'
        });
        else if (!isAllDevices && !isResizable && !isCustom) {
            const { DEVICES: DEVICES } = this.context && this.context.designSystem;
            const breakpoint = DEVICES[previewSize];
            const [width, height] = breakpoint;
            const maxWidth = width ? `${width}px` : '100%';
            ComponentFrameCanvas.setNodeStyles({
                width: '100%',
                height: `${height}px`,
                maxWidth: maxWidth
            });
        }
    });
    const responsiveState = ChosenScene.ViewSvitcher.content?.state;
    const responsiveSize = responsiveState?.previewSize;
    if (isCustom) this.variables({
        responsiveSize: responsiveSize
    }).changed(()=>{
        const devices = this.context.designSystem.DEVICES;
        const breakpoint = devices[responsiveSize];
        if (breakpoint) {
            const [widthVal, HeightVal] = breakpoint;
            const maxWidth = `calc(${`${widthVal}px`} - 1.8em)`;
            const maxHeight = `calc(${`${HeightVal}px`} - 5em)`;
            ComponentFrameCanvas.setNodeStyles({
                maxWidth: maxWidth,
                maxHeight: maxHeight
            });
        } else ComponentFrameCanvas.setNodeStyles({
            maxWidth: '100%',
            maxHeight: '100%'
        });
    });
}

});

parcelRegister("eB1UF", function(module, exports) {

$parcel$export(module.exports, "handleLayerPaste", () => $aa06013fe5a4d56a$export$3712d80c46171fd);
$parcel$export(module.exports, "getCodeToCopy", () => $aa06013fe5a4d56a$export$9e726c97c31d5f);
$parcel$export(module.exports, "getActiveLayerCode", () => $aa06013fe5a4d56a$export$8f090cdf15e733f6);
$parcel$export(module.exports, "getFullComponentCode", () => $aa06013fe5a4d56a$export$550970ab68d86e29);
$parcel$export(module.exports, "getUsedComponentsKeys", () => $aa06013fe5a4d56a$export$d04bbea7c1955478);
// Sourced from @symbo.ls/utils, not the monolithic 'smbls' barrel — these are
// plain object helpers (@symbo.ls/utils/object.js) re-exported by smbls
// verbatim. This file is a canvas-editor paste handler (user-triggered, not
// boot), but it's still statically reachable from the shell entry via
// shared/functions/index.js's barrel, so the smaller import keeps the eager
// chunk from paying for the whole framework bundle. See
// workspace/functions/workspaceProjects.js for the same established pattern.
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
async function $aa06013fe5a4d56a$export$3712d80c46171fd(key, layerCode, _) {
    const data = this.getCanvasScope();
    const schema = (0, $2C0hZ.deepClone)(data.selected.state.parse());
    const { activeLayer: activeLayer } = data;
    const updateDiff = activeLayer ? (0, $2C0hZ.createNestedObject)(activeLayer.slice(1), {
        [key]: layerCode || {}
    }) : {
        [key]: layerCode || {}
    };
    (0, $2C0hZ.deepMerge)(schema.value, updateDiff);
    delete schema.code;
    delete schema.codeStr;
    const layerInfo = activeLayer ? `${activeLayer.slice(-1)} layer` : '';
    const componentType = this.getType(schema);
    const commitMessage = `${key} layer is pasted in ${layerInfo} at ${schema.key} ${componentType.slice(0, -1)}`;
    this.sdk.updateItem(componentType, schema, {
        message: commitMessage
    });
    setTimeout(async ()=>{
    // await this.call('updateComponentOnCanvas', schema, {
    //   updatePane: true
    // })
    }, 0);
    if (activeLayer) data.activeLayer.push(key);
    else data.activeLayer = [
        'content',
        key
    ];
}
function $aa06013fe5a4d56a$export$9e726c97c31d5f() {
    const data = this.getCanvasScope();
    if (data.activeLayer) return this.call('getActiveLayerCode');
    return this.call('getFullComponentCode');
}
function $aa06013fe5a4d56a$export$8f090cdf15e733f6() {
    const data = this.getCanvasScope();
    const { activeLayer: activeLayer } = data;
    const value = (0, $2C0hZ.deepClone)(data.selected.state.value);
    const layerCode = activeLayer.reduce((acc, item)=>acc[item] || acc, value);
    const key = activeLayer.length > 1 ? activeLayer[activeLayer.length - 1] : value.key;
    return {
        metadata: 'copiedFromSymbols',
        key: key,
        layerCode: layerCode
    };
}
function $aa06013fe5a4d56a$export$550970ab68d86e29() {
    const data = this.getCanvasScope();
    const code = (0, $2C0hZ.deepClone)(data.selected.state.parse());
    code.metadata = 'copiedFromSymbols';
    return code;
}
function $aa06013fe5a4d56a$export$d04bbea7c1955478(DEFAULT_COMPONENT, allUsed, type, uniqUses = []) {
    let collectedKeys = [];
    allUsed.forEach((key)=>{
        if (!DEFAULT_COMPONENT[key]) {
            const keyElement = this.call('getSchemaItem', key, type);
            if (keyElement && !uniqUses[keyElement]) {
                collectedKeys.push(key);
                collectedKeys = [
                    ...collectedKeys,
                    ...$aa06013fe5a4d56a$export$d04bbea7c1955478.call(this, DEFAULT_COMPONENT, keyElement.uses, keyElement.type, collectedKeys)
                ];
            }
        }
    });
    return collectedKeys;
}

});

parcelRegister("7WebU", function(module, exports) {

$parcel$export(module.exports, "handleActiveLayerDeletion", () => $5c78f542cc6048c0$export$b6101e577079b465);
$parcel$export(module.exports, "handleComponentDeletion", () => $5c78f542cc6048c0$export$b8b73182341c4aa);
// Sourced from @symbo.ls/utils, not the monolithic 'smbls' barrel — same fix
// as workspace/functions/workspaceProjects.js (see that file / shared's
// copy-paste.js for the full why).
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
async function $5c78f542cc6048c0$export$b6101e577079b465(activeLayer) {
    const data = this.getCanvasScope();
    const key = data.activeLayer.pop();
    const schema = (0, $2C0hZ.deepClone)(data.selected.state.parse());
    this.setCanvasMode(false);
    const confirmRemove = `Do you want to remove the "${key}" layer from ${schema.key}?`;
    if (!window.confirm(confirmRemove)) return;
    (0, $2C0hZ.removeNestedKeyByPath)(schema.component, activeLayer.slice(1).concat(key));
    delete schema.code;
    delete schema.codeStr;
    const componentType = schema.key.startsWith('/') ? 'pages' : 'components';
    const commitMessage = `${key} layer is removed from ${schema.key} ${componentType}`;
// await this.updateItem(schema, null, { message: commitMessage })
// await this.updateComponentOnCanvas(schema, { updatePane: true })
}
async function $5c78f542cc6048c0$export$b8b73182341c4aa() {
    const selected = this.getSelected();
    const item = selected?.state;
    if (item) this.call('removeCanvasArtboard', item.type, item.key);
    else this.warn('Cant find component');
}

});

parcelRegister("1e8HI", function(module, exports) {

$parcel$export(module.exports, "APP_PAGES", () => $0e4dd9b100047e7a$export$acc1c5b9f04218ce);
$parcel$export(module.exports, "GUEST_PAGES", () => $0e4dd9b100047e7a$export$e2818e9072fdb09b);
$parcel$export(module.exports, "GREEN_PAGES", () => $0e4dd9b100047e7a$export$d2be480eab2241d6);
$parcel$export(module.exports, "redirectBasedOnAuth", () => $0e4dd9b100047e7a$export$6b6ff5f3b35e0c89);
const $0e4dd9b100047e7a$export$acc1c5b9f04218ce = [
    '/',
    '/dashboard',
    '/cli-connect',
    '/new-tab',
    '/design-system',
    '/canvas',
    // '/extension',
    '/components',
    '/init',
    '/search',
    '/switch',
    '/studio',
    '/schema',
    '/fetch',
    '/onboarding',
    '/settings',
    '/editor',
    '/files',
    '/layouts',
    '/atoms',
    '/marketplace',
    '/editor',
    '/export',
    '/pages',
    '/page',
    '/account',
    '/data',
    '/state',
    '/logout',
    '/color',
    '/theme',
    '/connect',
    '/install',
    '/integrations',
    '/typography',
    '/spacing',
    '/shape',
    '/governance',
    '/font',
    '/cases',
    '/timing',
    '/composite',
    '/icons',
    '/grid',
    '/media'
];
const $0e4dd9b100047e7a$export$e2818e9072fdb09b = [
    '/signin',
    '/reset-password',
    '/access-signup',
    '/signup',
    '/privacy',
    '/terms',
    '/confirm',
    '/get-early-access'
];
const $0e4dd9b100047e7a$export$d2be480eab2241d6 = [
    '/invest',
    '/careers',
    '/sandpack',
    '/compile',
    '/box-model',
    '/box-size',
    '/schedule-demo',
    '/invite',
    '/accept-invite',
    '/google-auth-callback',
    '/github-auth-callback',
    '/docs',
    '/pricing',
    '/pricing-lifetime',
    '/props',
    '/snippet',
    '/functions',
    '/function',
    '/watch',
    '/tutorial',
    '/tutorials',
    '/convert',
    '/playground',
    '/fiddles',
    '/developers',
    '/timeline',
    '/index',
    '/extension',
    '/api',
    '/cli',
    '/waitlist',
    // '/library',
    '/component',
    '/blocks',
    '/block',
    '/properties',
    '/convert',
    '/markdown',
    '/learning-center'
];
function $0e4dd9b100047e7a$export$6b6ff5f3b35e0c89(route) {
    const redirectInside = (innerRoute)=>{
        const pathname = innerRoute;
        const isInApp = this.call('checkIfStringIsInArray', pathname, $0e4dd9b100047e7a$export$acc1c5b9f04218ce);
        const isGreen = this.call('checkIfStringIsInArray', pathname, $0e4dd9b100047e7a$export$d2be480eab2241d6);
        const isInGuests = this.call('checkIfStringIsInArray', pathname, $0e4dd9b100047e7a$export$e2818e9072fdb09b);
        if ((isInApp || isGreen || !isInGuests) && innerRoute && innerRoute !== '/') return innerRoute;
        return '/' // fallback to the workspace home (/dashboard is retired)
        ;
    };
    const redirectOutside = (innnerRoute)=>{
        const isInGuests = this.call('checkIfStringIsInArray', innnerRoute, $0e4dd9b100047e7a$export$e2818e9072fdb09b);
        const isGreen = this.call('checkIfStringIsInArray', innnerRoute, $0e4dd9b100047e7a$export$d2be480eab2241d6);
        if (isInGuests || isGreen) return innnerRoute;
        const path = window.location.pathname;
        // allow embed
        if (path.startsWith('/embed')) return path;
        const [, user, projectKey] = path.split('/');
        // allow if project path matches, TODO: check with server
        if (user && projectKey) return `/${user}/${projectKey}`;
        return '/';
    };
    const isAuthorised = this.isAuthorised();
    if (isAuthorised) return redirectInside(route);
    return redirectOutside(route);
}

});

parcelRegister("4UuWq", function(module, exports) {

$parcel$export(module.exports, "checkPrivilegies", () => $393464ad2aa3602b$export$d9531875d779e24f);
$parcel$export(module.exports, "platformPrivilegies", () => $393464ad2aa3602b$export$9f1f59a80e4c8a7a);
function $393464ad2aa3602b$export$d9531875d779e24f() {}
function $393464ad2aa3602b$export$9f1f59a80e4c8a7a() {
    const platformState = this.getRootState();
    const isDev = platformState.appKey === 'smbls.symbo.ls' || platformState.appKey === 'default.symbo.ls';
    const isAdmin = platformState.userId === 'usb148d6dd' || platformState.userId === 'usb8964b6c';
    if (!isDev || isDev && isAdmin) return true;
}

});

parcelRegister("15aON", function(module, exports) {

$parcel$export(module.exports, "domToSvg", () => $0c9ea66013cdb83c$export$cd250c71e7601320);
async function $0c9ea66013cdb83c$export$cd250c71e7601320(node) {
    if (!node) return;
    const { elementToSVG: elementToSVG } = await window.requireOnDemand('dom-to-svg');
    const svgDocument = elementToSVG(node);
    const svg = new window.XMLSerializer().serializeToString(svgDocument);
    return svg;
}

});

parcelRegister("1S5xC", function(module, exports) {

$parcel$export(module.exports, "clearSession", () => $15cf21f95abb0e9e$export$7809a8af6f3e4c63);
$parcel$export(module.exports, "giveMeAnswer", () => $15cf21f95abb0e9e$export$8af90985472ecadd);
$parcel$export(module.exports, "parseAIAnswer", () => $15cf21f95abb0e9e$export$33b28256335a1637);
$parcel$export(module.exports, "animateMultiple", () => $15cf21f95abb0e9e$export$12fb5297a6392e51);
$parcel$export(module.exports, "setPrompt", () => $15cf21f95abb0e9e$export$4e1853f4cf46b56a);
$parcel$export(module.exports, "handleGreetingResponse", () => $15cf21f95abb0e9e$export$a96d670f3be116b6);
$parcel$export(module.exports, "handleTextResponse", () => $15cf21f95abb0e9e$export$da18648f8f831672);
$parcel$export(module.exports, "handleCodeResponse", () => $15cf21f95abb0e9e$export$437dfbd38e9388b8);
$parcel$export(module.exports, "formatCodeBlock", () => $15cf21f95abb0e9e$export$8dbb8448e0047b22);
$parcel$export(module.exports, "formatTextParts", () => $15cf21f95abb0e9e$export$c3442fa986207734);
$parcel$export(module.exports, "sanitizeComponentCode", () => $15cf21f95abb0e9e$export$bc39e7fd63e237cf);
$parcel$export(module.exports, "buildCodeResponseUI", () => $15cf21f95abb0e9e$export$63fe856bc11eb743);
$parcel$export(module.exports, "buildFallbackMessage", () => $15cf21f95abb0e9e$export$d017e3b65d5db5d);
$parcel$export(module.exports, "submitPrompt", () => $15cf21f95abb0e9e$export$f2d682d614f105bc);

var $aobmx = parcelRequire("aobmx");
var $23J5b = parcelRequire("23J5b");
var $9Er1q = parcelRequire("9Er1q");
function $15cf21f95abb0e9e$export$7809a8af6f3e4c63() {
    const HISTORY_KEY = 'ai_simone_history';
    try {
        localStorage.removeItem(HISTORY_KEY);
    } catch (_) {
    /* ignore */ }
}
async function $15cf21f95abb0e9e$export$8af90985472ecadd(text, images, selectedModel) {
    // Local thread cache — Simone is stateless, so we replay history
    // client-side. Self-contained inline copy, see clearSession above.
    const HISTORY_KEY = 'ai_simone_history';
    function loadHistory() {
        try {
            const raw = localStorage.getItem(HISTORY_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (_) {
            return [];
        }
    }
    function saveHistory(history) {
        try {
            localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(-20)));
        } catch (_) {
        /* quota — drop */ }
    }
    const cleanData = await this.call('getCleanCanvasScope', this.getCanvasScope());
    const context = Object.fromEntries(Object.entries(cleanData).filter(([_, value])=>value !== undefined && value !== null));
    const selectedResource = this.getChosenKey() || this.getSelectedKey();
    if (selectedResource) context.selectedResource = selectedResource;
    const selectedFunction = this.getCanvasScope().activeFunction;
    if (selectedFunction) context.selectedFunction = selectedFunction;
    if (images && images.length > 0) console.warn("[simone] image attachments not supported by /api/code-symbols \u2014 dropping");
    const history = loadHistory();
    const messages = (0, $aobmx.buildMessages)({
        system: (0, $9Er1q.WORKSPACE_SYSTEM_PROMPT),
        history: history,
        user: text,
        context: context
    });
    try {
        const { text: answer, errors: errors } = await (0, $aobmx.streamCodeSymbols)(messages, {
            model: (0, $9Er1q.resolveModel)(selectedModel)
        });
        if (errors && errors.length) console.error('[simone] stream errors:', errors);
        history.push({
            role: 'user',
            content: text
        });
        history.push({
            role: 'assistant',
            content: answer
        });
        saveHistory(history);
        return (0, $23J5b.parseSimoneResponse)(answer);
    } catch (error) {
        console.error('[simone] giveMeAnswer failed:', error);
        return {
            kind: 'error',
            message: this.call('polyglot', 'ai.chat.unreachable').replace('{error}', error.message)
        };
    }
}
function $15cf21f95abb0e9e$export$33b28256335a1637(parsed) {
    if (!parsed) return {
        message: this.call('polyglot', 'ai.chat.noResponse')
    };
    switch(parsed.kind){
        case 'asset':
            return {
                asset: parsed.asset,
                type: (parsed.asset.type || '') + 's',
                message: parsed.message
            };
        case 'multi':
            return {
                asset: parsed.assets,
                multiple: true,
                message: parsed.message
            };
        case 'component':
            return {
                asset: {
                    type: 'component',
                    value: parsed.code,
                    description: parsed.text
                },
                message: parsed.message
            };
        case 'error':
            return {
                message: parsed.message
            };
        case 'text':
        default:
            return {
                message: parsed.text || parsed.message || ''
            };
    }
}
function $15cf21f95abb0e9e$export$12fb5297a6392e51(changes) {
    const jointData = [];
    changes.forEach((item, i)=>{
        if (i % 2 === 0) {
            const [, , value] = item;
            jointData.push({
                value: value
            });
        } else {
            const [, , schema] = item;
            const currentItem = jointData[jointData.length - 1];
            jointData[jointData.length - 1] = {
                ...currentItem,
                ...schema
            };
        }
    });
    jointData.forEach(async (item, i)=>{
    // const t = setTimeout(async () => {
    // await this.addComponentOnCanvas(item)
    // clearTimeout(t)
    // }, i * 350)
    });
}
async function $15cf21f95abb0e9e$export$4e1853f4cf46b56a(msg) {
    const AIMessage = this.getFilesSidebarPrompt().Label.Span;
    await AIMessage.state.update({
        keyword: msg
    });
    const t = setTimeout(()=>{
        AIMessage.update({
            html: AIMessage.state.keyword + '&nbsp;'
        });
        AIMessage.node.focus();
        const t2 = setTimeout(()=>{
            // select all the content in the element
            document.execCommand('selectAll', false, null);
            // collapse selection to the end
            document.getSelection().collapseToEnd();
            clearTimeout(t2);
        }, 35);
        clearTimeout(t);
    }, 35);
}
function $15cf21f95abb0e9e$export$a96d670f3be116b6(responseData) {
    return {
        flow: 'y',
        gap: 'A',
        padding: 'Y2 A',
        shape: 'bubble',
        shapeDirection: 'top right',
        round: 'C X C C',
        theme: 'dialog',
        maxWidth: 'I1',
        children: [
            {
                extends: 'P',
                text: responseData.message,
                fontWeight: '500'
            },
            {
                extends: 'P',
                text: responseData.capabilities_summary,
                margin: 'A 0 Z',
                color: 'caption'
            },
            ...responseData.categories.map((category)=>({
                    flow: 'y',
                    gap: 'Z1',
                    children: [
                        {
                            extends: 'H6',
                            text: category.name,
                            fontSize: 'Z1',
                            margin: '0 0 X'
                        },
                        {
                            flow: 'y',
                            gap: 'X',
                            children: category.items.map((item)=>({
                                    extends: 'P',
                                    text: `- ${item}`,
                                    color: 'caption',
                                    fontSize: 'Z'
                                }))
                        }
                    ]
                }))
        ]
    };
}
function $15cf21f95abb0e9e$export$da18648f8f831672(content) {
    // FA204 / frank trap — self-contained inline copies of formatCodeBlock/
    // formatTextParts, see those exports below for the canonical shape.
    function _formatCodeBlock(part) {
        const code = part.replace(/```(js|javascript)?\n/, '').replace(/```$/, '');
        return {
            extends: 'P',
            text: code,
            theme: 'document',
            padding: 'A',
            round: 'radiusControl',
            fontSize: 'Z',
            fontFamily: 'monospace',
            margin: 'A 0',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all'
        };
    }
    function _formatTextParts(part) {
        return part.split(/(### .*)/g).filter((p)=>p).map((textPart)=>{
            if (textPart.startsWith('### ')) return {
                extends: 'H6',
                text: textPart.substring(4),
                margin: 'A 0 Z',
                fontWeight: 'bold'
            };
            return {
                extends: 'P',
                text: textPart,
                color: 'caption',
                fontSize: 'Z',
                lineHeight: '1.5'
            };
        });
    }
    const parts = content.split(/(```(?:js|javascript)?\n[\s\S]*?```)/g);
    const children = parts.filter((part)=>part).map((part)=>{
        if (part.startsWith('```')) return _formatCodeBlock(part);
        return _formatTextParts(part);
    }).flat();
    return {
        flow: 'y',
        gap: 'A',
        padding: 'Y2 A',
        shape: 'bubble',
        shapeDirection: 'top right',
        round: 'C X C C',
        theme: 'dialog',
        maxWidth: '85%',
        children: children
    };
}
function $15cf21f95abb0e9e$export$437dfbd38e9388b8(message) {
    // FA204 / frank trap — self-contained inline copies of
    // sanitizeComponentCode/buildCodeResponseUI (which itself needs its own
    // copies of formatTextParts/formatCodeBlock — see those exports below).
    function _sanitizeComponentCode(code) {
        return code.replace(/(}\s*)\]/g, '$1}').replace(/,\s*([}\]])/g, '$1');
    }
    function _buildCodeResponseUI(analysis_text, component_code) {
        function _formatCodeBlock(part) {
            const code = part.replace(/```(js|javascript)?\n/, '').replace(/```$/, '');
            return {
                extends: 'P',
                text: code,
                theme: 'document',
                padding: 'A',
                round: 'radiusControl',
                fontSize: 'Z',
                fontFamily: 'monospace',
                margin: 'A 0',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all'
            };
        }
        function _formatTextParts(part) {
            return part.split(/(### .*)/g).filter((p)=>p).map((textPart)=>{
                if (textPart.startsWith('### ')) return {
                    extends: 'H6',
                    text: textPart.substring(4),
                    margin: 'A 0 Z',
                    fontWeight: 'bold'
                };
                return {
                    extends: 'P',
                    text: textPart,
                    color: 'caption',
                    fontSize: 'Z',
                    lineHeight: '1.5'
                };
            });
        }
        function _buildAnalysisSection(analysis_text) {
            return {
                flow: 'y',
                children: _formatTextParts(analysis_text)
            };
        }
        function _buildCodeSection(component_code) {
            return _formatCodeBlock(component_code);
        }
        try {
            return {
                flow: 'x',
                contentEditable: false,
                shape: 'bubble',
                shapeDirection: 'top right',
                round: 'C X C C',
                theme: 'dialog',
                padding: 'Y2 A',
                margin: '- -Z',
                maxWidth: '85%',
                children: [
                    analysis_text && _buildAnalysisSection(analysis_text),
                    component_code && _buildCodeSection(component_code)
                ].filter(Boolean)
            };
        } catch (e) {
            console.error('Failed to parse Symbols component:', e);
            return {
                extends: 'P',
                text: this.call('polyglot', 'ai.chat.renderError').replace('{error}', e.message)
            };
        }
    }
    const { analysis_text: analysis_text, symbols_code_response: symbols_code_response, type: type } = message.code_response || {};
    let component_code = symbols_code_response ? symbols_code_response.component_code : type === 'symbols_component_code' ? message.code_response.component_code : '';
    if (component_code) component_code = _sanitizeComponentCode(component_code);
    if (!component_code && !analysis_text) return {
        extends: 'P',
        text: '{{ ai.chat.invalidCode | polyglot }}'
    };
    return _buildCodeResponseUI(analysis_text, component_code);
}
function $15cf21f95abb0e9e$export$8dbb8448e0047b22(part) {
    const code = part.replace(/```(js|javascript)?\n/, '').replace(/```$/, '');
    return {
        extends: 'P',
        text: code,
        theme: 'document',
        padding: 'A',
        round: 'radiusControl',
        fontSize: 'Z',
        fontFamily: 'monospace',
        margin: 'A 0',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all'
    };
}
function $15cf21f95abb0e9e$export$c3442fa986207734(part) {
    return part.split(/(### .*)/g).filter((p)=>p).map((textPart)=>{
        if (textPart.startsWith('### ')) return {
            extends: 'H6',
            text: textPart.substring(4),
            margin: 'A 0 Z',
            fontWeight: 'bold'
        };
        return {
            extends: 'P',
            text: textPart,
            color: 'caption',
            fontSize: 'Z',
            lineHeight: '1.5'
        };
    });
}
function $15cf21f95abb0e9e$export$bc39e7fd63e237cf(code) {
    return code.replace(/(}\s*)\]/g, '$1}').replace(/,\s*([}\]])/g, '$1');
}
function $15cf21f95abb0e9e$export$63fe856bc11eb743(analysis_text, component_code) {
    function _formatCodeBlock(part) {
        const code = part.replace(/```(js|javascript)?\n/, '').replace(/```$/, '');
        return {
            extends: 'P',
            text: code,
            theme: 'document',
            padding: 'A',
            round: 'radiusControl',
            fontSize: 'Z',
            fontFamily: 'monospace',
            margin: 'A 0',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all'
        };
    }
    function _formatTextParts(part) {
        return part.split(/(### .*)/g).filter((p)=>p).map((textPart)=>{
            if (textPart.startsWith('### ')) return {
                extends: 'H6',
                text: textPart.substring(4),
                margin: 'A 0 Z',
                fontWeight: 'bold'
            };
            return {
                extends: 'P',
                text: textPart,
                color: 'caption',
                fontSize: 'Z',
                lineHeight: '1.5'
            };
        });
    }
    function buildAnalysisSection(analysis_text) {
        return {
            flow: 'y',
            children: _formatTextParts(analysis_text)
        };
    }
    function buildCodeSection(component_code) {
        return _formatCodeBlock(component_code);
    }
    try {
        return {
            flow: 'x',
            contentEditable: false,
            shape: 'bubble',
            shapeDirection: 'top right',
            round: 'C X C C',
            theme: 'dialog',
            padding: 'Y2 A',
            margin: '- -Z',
            maxWidth: '85%',
            children: [
                analysis_text && buildAnalysisSection(analysis_text),
                component_code && buildCodeSection(component_code)
            ].filter(Boolean)
        };
    } catch (e) {
        console.error('Failed to parse Symbols component:', e);
        return {
            extends: 'P',
            text: this.call('polyglot', 'ai.chat.renderError').replace('{error}', e.message)
        };
    }
}
function $15cf21f95abb0e9e$export$d017e3b65d5db5d(message) {
    return {
        extends: 'AIMessage',
        contentEditable: false,
        shape: 'bubble',
        shapeDirection: 'top right',
        round: 'C X C C',
        theme: 'dialog',
        padding: 'Y2 A',
        color: 'paragraph',
        maxWidth: 'I1',
        html: (el, s)=>typeof message === 'object' ? `<pre>${JSON.stringify(message, null, 2)}</pre>` : message
    };
}
async function $15cf21f95abb0e9e$export$f2d682d614f105bc() {
    const el = this;
    const s = this.state;
    const value = s.keyword;
    if (!value) return;
    const images = s.images;
    s.apply((s)=>{
        s.thread.push({
            role: 'user',
            message: value,
            images: [
                ...images
            ]
        });
        s.images = [];
        s.keyword = '';
    });
    el.Flex.Span.node.innerText = '';
    // Add a temporary "thinking" message for better UX
    s.thread.push({
        role: 'agent',
        isThinking: true,
        message: '...'
    });
    s.update();
    const selectedModel = s.model || 'Starter' // Default to Free if no model selected
    ;
    const res = await el.call('giveMeAnswer', value, images, selectedModel);
    const parsed = await el.call('parseAIAnswer', res);
    if (parsed?.asset?.type) parsed.asset.type = el.call('getPlural', parsed.asset.type);
    // Remove "thinking" message
    s.thread.pop();
    if (parsed?.asset && (parsed.asset.type === 'components' || parsed.asset.type === 'pages')) try {
        const asset = parsed.asset;
        const assetType = asset.type // 'components' or 'pages'
        ;
        // First, add the item to the main data store via the SDK
        const res = el.call('createItem', `${assetType}`, asset.key, asset);
        if (res) // Add the AI response with both message and component code
        s.thread.push({
            role: 'agent',
            message: parsed.message || `I've created a ${asset.title} for you.`,
            analysis_text: asset.description,
            component_code: JSON.stringify(asset.value, null, 2),
            component: true
        });
        else // Handle cases where the SDK fails to add the item
        throw new Error(`Could not add ${assetType} '${asset.title}'`);
    } catch (e) {
        console.error('Error adding or rendering component:', e);
        s.thread.push({
            role: 'agent',
            message: this.call('polyglot', 'ai.chat.addComponentError').replace('{error}', e.message)
        });
    }
    else if (parsed.multiple) {
        const asset = parsed.asset;
        const res = el.call('createMultipleItems', asset);
        if (res) // Add the AI response with both message and component code
        s.thread.push({
            role: 'agent',
            message: parsed.message || `I've created a ${asset.title} for you.`,
            analysis_text: asset.description,
            component_code: JSON.stringify(asset.value, null, 2),
            component: true
        });
    } else if (parsed) // For other assets or text, display the information.
    s.thread.push({
        role: 'agent',
        analysis_text: parsed.message,
        component_code: parsed.asset ? JSON.stringify(parsed.asset, null, 2) : null,
        component: !!parsed.asset // Trigger the component renderer path
    });
    else s.thread.push({
        role: 'agent',
        message: this.call('polyglot', 'ai.chat.cannotProcess')
    });
    if (s.activeContent !== 'AI') s.update({
        activeContent: 'AI'
    });
} /*
<!-- page -->
{
  key: '/about',
  title: 'About us page',
  type: 'page',
  description: '...',
  value: { ... },
}

<!-- component -->
{
  key: 'Header',
  title: 'Header component',
  type: 'components',
  description: '...',
  value: { ... },
}

<!-- function -->
{
  type: 'function',
  key: 'makeFn',
  title: 'Making function',
  description: '...',
  value: () => { ... },
}

<!-- method -->
{
  type: 'method',
  key: 'makeFn',
  title: 'Making method',
  description: '...',
  value: () => { ... },
}

<!-- dependency -->
{
  type: 'dependency',
  key: 'smbls',
  version: 'latest',
}

<!-- state -->
{
  type: 'state',
  key: 'products',
  value: [{ key: 'product1', ... }, { product2 }],
}

<!-- file -->
{
  type: 'file',
  key: 'some.jpg',
  value: 'url or base64', // need to check with @Thomas-sls about blob
}

<!-- color -->
{
  type: 'color',
  key: 'blue',
  value: '#123',
}

<!-- semantic colors (dark-light) -->
{
  type: 'color',
  key: 'call-to-action',
  value: {
    '@dark': '#123',
    '@light': '#321'
  },
}

<!-- icon -->
{
  type: 'icon',
  key: 'arrowRight',
  value: '<svg>...</svg>',
}

<!-- media query -->
{
  type: 'media',
  key: '@mobileXs',
  value: '(min-width: 100px)',
}

<!-- font -->
{
  type: 'font',
  key: 'FiraGO',
  value: [{
    // regular,
    url: 'https://cdn.jsdelivr.net/fontsource/fonts/firago@latest/latin-100-normal.woff2', // or base64,
    fontWeight: '400',
    fontStyle: 'normal',
    unicodeRange: 'latin',
  }, {
    // bold,
    url: 'https://cdn.jsdelivr.net/fontsource/fonts/firago@latest/latin-200-normal.woff2', // or base64,
    fontWeight: '700',
    fontStyle: 'normal',
    unicodeRange: 'latin',
  }],
}

<!-- font-family (often coupled with font) -->
{
  type: 'font_family',
  key: 'firaGo',
  key: 'FiraGO',
  familyName: 'FiraGO',
  type: 'serif',
  value: [
    'FiraGO', // maps with font name above
    'Helvetica, Arial, sans-serif, --system-default',
  ]
}

<!-- theme -->
{
  key: 'primary',
  type: 'theme',
  value: {
    color: '...',
    background: '...',
  }
}
*/ 

});
parcelRegister("aobmx", function(module, exports) {

$parcel$export(module.exports, "streamCodeSymbols", () => $7904f59f719bf9b2$export$1c120fe5d415f375);
$parcel$export(module.exports, "buildMessages", () => $7904f59f719bf9b2$export$ba631331fd446a01);

var $6hUMb = parcelRequire("6hUMb");
// The provider that serves a model id — the first one whose list names it.
// Model-only callers (fetchAI, the legacy prompt panel: `{ model:
// resolveModel(tier) }`) must keep reaching the lane that serves the model
// they name; only a call that names neither provider nor a listed model
// falls through to DEFAULT_PROVIDER.
function $7904f59f719bf9b2$var$providerForModel(model) {
    if (!model) return null;
    for (const [provider, models] of Object.entries((0, $6hUMb.PROVIDER_MODELS))){
        if (models.includes(model)) return provider;
    }
    return null;
}
function $7904f59f719bf9b2$var$joinUrl(baseUrl, path) {
    if (!baseUrl) return path;
    return baseUrl.replace(/\/$/, '') + path;
}
function $7904f59f719bf9b2$var$parseSseLine(line) {
    if (!line.startsWith('data: ')) return null;
    const payload = line.slice(6);
    if (payload === '[DONE]') return {
        done: true
    };
    try {
        return {
            chunk: JSON.parse(payload)
        };
    } catch (e) {
        return {
            raw: payload
        };
    }
}
async function $7904f59f719bf9b2$export$c5e7d012e0b9a55f(messages, opts = {}, onDelta) {
    const { baseUrl: baseUrl = (0, $6hUMb.SIMONE_BASE_URL), path: path = (0, $6hUMb.SIMONE_CHAT_PATH), model: model = (0, $6hUMb.DEFAULT_MODEL), provider: provider = $7904f59f719bf9b2$var$providerForModel(model) || (0, $6hUMb.DEFAULT_PROVIDER), temperature: temperature = (0, $6hUMb.DEFAULT_TEMPERATURE), maxTokens: maxTokens = (0, $6hUMb.DEFAULT_MAX_TOKENS), effort: effort, apiKeys: apiKeys, signal: signal, headers: headers } = opts;
    if (!Array.isArray(messages) || messages.length === 0) throw new TypeError('simone: messages must be a non-empty array');
    const body = {
        messages: messages,
        provider: provider,
        model: model,
        temperature: temperature,
        maxTokens: maxTokens
    };
    if (effort) body.effort = effort;
    if (apiKeys) body.apiKeys = apiKeys;
    const response = await fetch($7904f59f719bf9b2$var$joinUrl(baseUrl, path), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/event-stream',
            ...headers
        },
        body: JSON.stringify(body),
        signal: signal
    });
    if (!response.ok) {
        let detail = response.statusText;
        try {
            const errBody = await response.text();
            try {
                const parsed = JSON.parse(errBody);
                detail = parsed.error || parsed.detail || detail;
            } catch (_) {
                detail = errBody || detail;
            }
        } catch (_) {
        /* ignore */ }
        const err = new Error(`simone: HTTP ${response.status} \u{2014} ${detail}`);
        err.status = response.status;
        throw err;
    }
    if (!response.body || typeof response.body.getReader !== 'function') {
        const text = await response.text();
        if (onDelta) onDelta(text);
        return {
            text: text,
            errors: []
        };
    }
    // Accumulate deltas in an array and join at the end — avoids O(n²) string
    // concatenation on long streams.
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    const parts = [];
    const errors = [];
    let buffer = '';
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            let nlIndex = buffer.indexOf('\n');
            while(nlIndex !== -1){
                const line = buffer.slice(0, nlIndex).trim();
                buffer = buffer.slice(nlIndex + 1);
                if (line) {
                    const parsed = $7904f59f719bf9b2$var$parseSseLine(line);
                    if (parsed?.done) return {
                        text: parts.join(''),
                        errors: errors
                    };
                    const chunk = parsed?.chunk;
                    if (chunk?.delta) {
                        parts.push(chunk.delta);
                        if (onDelta) onDelta(chunk.delta);
                    }
                    if (chunk?.error) errors.push(chunk.error);
                }
                nlIndex = buffer.indexOf('\n');
            }
        }
        return {
            text: parts.join(''),
            errors: errors
        };
    } finally{
        // Release the underlying connection on abort/error so it doesn't leak
        // until GC. cancel() rejects pending reads, which is fine here.
        reader.cancel().catch(()=>{});
    }
}
function $7904f59f719bf9b2$export$fa4023ae6da60252(messages, opts = {}, onDelta) {
    return $7904f59f719bf9b2$export$c5e7d012e0b9a55f(messages, {
        ...opts,
        path: (0, $6hUMb.SIMONE_CODE_PATH)
    }, onDelta);
}
function $7904f59f719bf9b2$export$1c120fe5d415f375(messages, opts = {}, onDelta) {
    return $7904f59f719bf9b2$export$c5e7d012e0b9a55f(messages, {
        ...opts,
        path: (0, $6hUMb.SIMONE_CODE_SYMBOLS_PATH)
    }, onDelta);
}
async function $7904f59f719bf9b2$export$f0784a54fb0af903(opts = {}) {
    const { baseUrl: baseUrl = (0, $6hUMb.SIMONE_BASE_URL), signal: signal, headers: headers } = opts;
    const response = await fetch($7904f59f719bf9b2$var$joinUrl(baseUrl, (0, $6hUMb.SIMONE_HEALTH_PATH)), {
        method: 'GET',
        headers: headers,
        signal: signal
    });
    if (!response.ok) throw new Error(`simone health: HTTP ${response.status}`);
    return response.json();
}
function $7904f59f719bf9b2$export$ba631331fd446a01({ system: system, history: history = [], user: user, context: context }) {
    const messages = [];
    if (system) messages.push({
        role: 'system',
        content: system
    });
    for (const m of history){
        if (!m || !m.role || typeof m.content !== 'string' || !m.content) continue;
        messages.push({
            role: m.role,
            content: m.content
        });
    }
    if (user) {
        let content = user;
        if (context !== undefined && context !== null) {
            const ctx = typeof context === 'string' ? context : JSON.stringify(context, null, 2);
            content = `${content}\n\n---\nContext:\n\`\`\`json\n${ctx}\n\`\`\``;
        }
        messages.push({
            role: 'user',
            content: content
        });
    }
    return messages;
}

});
parcelRegister("6hUMb", function(module, exports) {

$parcel$export(module.exports, "SIMONE_BASE_URL", () => $49405f2f4469e05e$export$493896ff32fda58c);
$parcel$export(module.exports, "SIMONE_CHAT_PATH", () => $49405f2f4469e05e$export$33f73ae089344687);
$parcel$export(module.exports, "SIMONE_CODE_PATH", () => $49405f2f4469e05e$export$a5d8281f441a7170);
$parcel$export(module.exports, "SIMONE_CODE_SYMBOLS_PATH", () => $49405f2f4469e05e$export$ca9415329931a8b5);
$parcel$export(module.exports, "SIMONE_HEALTH_PATH", () => $49405f2f4469e05e$export$442d43f2fa88c606);
$parcel$export(module.exports, "PROVIDER_MODELS", () => $49405f2f4469e05e$export$169c10e2ea879ee4);
$parcel$export(module.exports, "DEFAULT_PROVIDER", () => $49405f2f4469e05e$export$7762ba5dedd7a2a8);
$parcel$export(module.exports, "DEFAULT_MODEL", () => $49405f2f4469e05e$export$3d986293bb119696);
$parcel$export(module.exports, "DEFAULT_TEMPERATURE", () => $49405f2f4469e05e$export$3b916a31ece5ac1f);
$parcel$export(module.exports, "DEFAULT_MAX_TOKENS", () => $49405f2f4469e05e$export$8e16c737b9ce83);
const $49405f2f4469e05e$export$493896ff32fda58c = 'https://symbols-service-production.up.railway.app';
const $49405f2f4469e05e$export$33f73ae089344687 = '/api/chat';
const $49405f2f4469e05e$export$a5d8281f441a7170 = '/api/code';
const $49405f2f4469e05e$export$ca9415329931a8b5 = '/api/code-symbols';
const $49405f2f4469e05e$export$442d43f2fa88c606 = '/api/health';
const $49405f2f4469e05e$export$f6f42df1b38bd7be = '/api/tools';
const $49405f2f4469e05e$export$169c10e2ea879ee4 = {
    'openai-compatible': [
        'claude-sonnet-4-6',
        'claude-opus-4-6',
        'gpt-4o',
        'gpt-4o-mini',
        'deepseek-chat'
    ],
    'anthropic': [
        'claude-sonnet-4-6',
        'claude-sonnet-4-5-20250929',
        'claude-opus-4-1-20250805',
        'claude-haiku-4-5-20251001'
    ],
    'openrouter': [
        'google/gemini-3-pro-preview'
    ],
    // First entry = the default gemini model. gemini-2.5-pro is the server
    // router's provider-config default too (server-config default.js), bills at
    // the published Gemini Pro rate, and answered 3/3 on the service's code
    // lanes (2026-09-26). gemini-3-pro-preview is gone: Google answers 404 "no
    // longer available ... use gemini-3.1-pro-preview".
    'gemini': [
        'gemini-2.5-pro',
        'gemini-3.1-pro-preview'
    ]
};
const $49405f2f4469e05e$export$7762ba5dedd7a2a8 = 'gemini';
const $49405f2f4469e05e$export$3d986293bb119696 = $49405f2f4469e05e$export$169c10e2ea879ee4[$49405f2f4469e05e$export$7762ba5dedd7a2a8][0];
const $49405f2f4469e05e$export$3b916a31ece5ac1f = 0.7;
const $49405f2f4469e05e$export$8e16c737b9ce83 = 4096;

});


parcelRegister("23J5b", function(module, exports) {

$parcel$export(module.exports, "parseSimoneResponse", () => $17fed512ff2b3ad7$export$8fba86fc0dd09b8b);
const $17fed512ff2b3ad7$var$FENCE_RE = /```(?<lang>[a-zA-Z0-9_+-]*)\n(?<code>[\s\S]*?)```/g;
const $17fed512ff2b3ad7$var$ASSET_TYPES = new Set([
    'component',
    'components',
    'page',
    'pages',
    'function',
    'method',
    'state',
    'theme',
    'color',
    'font',
    'icon'
]);
function $17fed512ff2b3ad7$var$extractCodeBlocks(text) {
    const blocks = [];
    for (const m of text.matchAll($17fed512ff2b3ad7$var$FENCE_RE))blocks.push({
        lang: (m.groups?.lang || '').toLowerCase(),
        code: m.groups?.code ?? ''
    });
    return blocks;
}
function $17fed512ff2b3ad7$var$stripCodeBlocks(text) {
    return text.replace($17fed512ff2b3ad7$var$FENCE_RE, '').trim();
}
function $17fed512ff2b3ad7$var$tryJson(raw) {
    // Fast-bail on plain prose to skip two parse attempts per non-JSON line.
    if (!raw || !/[{[]/.test(raw)) return null;
    try {
        return JSON.parse(raw);
    } catch (_) {
    /* fall through */ }
    try {
        return JSON.parse(raw.replace(/,\s*([}\]])/g, '$1'));
    } catch (_) {
    /* ignore */ }
    return null;
}
function $17fed512ff2b3ad7$var$looksLikeAsset(obj) {
    return !!obj && typeof obj === 'object' && typeof obj.type === 'string' && $17fed512ff2b3ad7$var$ASSET_TYPES.has(obj.type);
}
function $17fed512ff2b3ad7$export$8fba86fc0dd09b8b(text) {
    const trimmed = (typeof text === 'string' ? text : '').trim();
    if (!trimmed) return {
        kind: 'text',
        text: '',
        message: ''
    };
    const blocks = $17fed512ff2b3ad7$var$extractCodeBlocks(trimmed);
    const codeBlocks = blocks.filter((b)=>/^(js|javascript|ts|typescript|jsx|tsx)$/.test(b.lang));
    const jsonBlocks = blocks.filter((b)=>b.lang === 'json');
    const analysis = $17fed512ff2b3ad7$var$stripCodeBlocks(trimmed);
    for (const block of jsonBlocks){
        const parsed = $17fed512ff2b3ad7$var$tryJson(block.code);
        if ($17fed512ff2b3ad7$var$looksLikeAsset(parsed)) return {
            kind: 'asset',
            text: analysis || parsed.description || '',
            asset: parsed,
            message: parsed.description || analysis || `Generated ${parsed.type}: ${parsed.title || parsed.key || ''}`.trim()
        };
    }
    if (codeBlocks.length > 0) {
        const first = codeBlocks[0].code;
        const wrapped = $17fed512ff2b3ad7$var$tryJson('[' + first + ']');
        if (Array.isArray(wrapped) && wrapped.length > 1) return {
            kind: 'multi',
            text: analysis,
            assets: wrapped,
            code: first,
            message: analysis || `Generated ${wrapped.length} items`
        };
        return {
            kind: 'component',
            text: analysis,
            code: first,
            message: analysis || 'Generated a component'
        };
    }
    if (trimmed.startsWith('{')) {
        const parsed = $17fed512ff2b3ad7$var$tryJson(trimmed);
        if ($17fed512ff2b3ad7$var$looksLikeAsset(parsed)) return {
            kind: 'asset',
            text: parsed.description || '',
            asset: parsed,
            message: parsed.description || `Generated ${parsed.type}: ${parsed.title || parsed.key || ''}`.trim()
        };
    }
    return {
        kind: 'text',
        text: trimmed,
        message: trimmed
    };
}
function $17fed512ff2b3ad7$export$9e1b0d0887a66545(parsed) {
    if (!parsed) return {
        code_response: {
            type: 'error',
            content: 'Empty response from assistant'
        }
    };
    switch(parsed.kind){
        case 'asset':
            return {
                code_response: {
                    type: 'json_response',
                    data: parsed.asset
                }
            };
        case 'multi':
            return {
                code_response: {
                    type: 'symbols_component_code',
                    component_code: parsed.code
                }
            };
        case 'component':
            return {
                code_response: {
                    type: 'symbols_component_code',
                    component_code: parsed.code,
                    analysis_text: parsed.text
                }
            };
        case 'text':
        default:
            return {
                code_response: {
                    type: 'plain_text_response',
                    content: parsed.text || parsed.message || ''
                }
            };
    }
}

});

parcelRegister("9Er1q", function(module, exports) {

$parcel$export(module.exports, "WORKSPACE_SYSTEM_PROMPT", () => $706ccf8118af93e1$export$e7a34ede74a3e6e);
$parcel$export(module.exports, "resolveModel", () => $706ccf8118af93e1$export$3b945beacd66df77);
// Workspace-facing presets — system prompt + model-tier aliasing shared by
// every in-monorepo AI consumer (workspace shared, platform/uikit,
// platform/readonly, extensions/labs). Each consumer imports these
// instead of redeclaring the same constants and resolver locally.

var $6hUMb = parcelRequire("6hUMb");
const $706ccf8118af93e1$export$e7a34ede74a3e6e = [
    'You are Simone, the Symbols.app assistant.',
    'You help users build DOMQL v3 components, pages, and design-system entries.',
    'When the user asks for a component or page, return a single ```json fenced block whose body is one asset object with shape { type, key, title, description, value }. type is one of "component", "page", "function", "state", "color", "font", "icon", "theme".',
    'For multiple assets, return one ```js fenced block with comma-separated asset objects.',
    'For general questions, reply with prose only.'
].join(' ');
const $706ccf8118af93e1$export$7a3be6395620a89 = [
    'You are a DOMQL v3.14 code generator for the Symbols workspace.',
    "Output EXECUTABLE DOMQL v3.14 for the requested page(s)/component(s) \u2014 never a description, never a plan, never an explanation.",
    "Author data-first object schemas: child elements are UPPERCASE keys; styling lives in flat element props (NO attr/props/on wrappers); use design-system tokens (color/typography/spacing keys), never raw px/rem/hex/rgba; `extends` and `childExtends` are quoted strings; event handlers are flat (onClick, onInit) \u2014 never on:{} or props:{} wrappers.",
    "OUTPUT FORMAT \u2014 pick ONE:",
    "- SINGLE page/component: emit exactly one ```js fenced code block whose body is a single DOMQL object literal (an expression \u2014 start with `{`, no `export`, no variable assignment, no surrounding prose).",
    '- MULTIPLE pages/components: emit exactly one ```json fenced code block whose body is an object of the shape { "pages": { "PageKey": "<DOMQL object-literal source string>" }, "components": { "CompKey": "<DOMQL object-literal source string>" } }. Include only the sections you produce; each value is the DOMQL source for that key.',
    'Keys are PascalCase. Default to a single page unless the request clearly needs several distinct pages/components.',
    'Emit ONLY the single fenced block. No text before or after it.'
].join('\n');
const $706ccf8118af93e1$export$50e9840287d0e94e = {
    Starter: (0, $6hUMb.DEFAULT_MODEL),
    Free: (0, $6hUMb.DEFAULT_MODEL),
    Pro: 'claude-opus-4-6'
};
function $706ccf8118af93e1$export$3b945beacd66df77(selected) {
    if (!selected) return 0, $6hUMb.DEFAULT_MODEL;
    return $706ccf8118af93e1$export$50e9840287d0e94e[selected] || selected;
}

});


parcelRegister("e8rh4", function(module, exports) {

$parcel$export(module.exports, "applyLoader", () => $a4a6f82afd91bb16$export$b809f3664143a9b9);
function $a4a6f82afd91bb16$export$b809f3664143a9b9(opts = {}) {
    const t = setTimeout(()=>{
        const { MainLoader: MainLoader } = this.getRoot();
        if (opts.value !== undefined) // Route through `root.update()` so the signal-tracked binding fires.
        // Direct `getRootState().loading = …` mutation bypasses smbls 3.14
        // reactivity (typed-bag schema gates writes through `update()`).
        this.getRoot().update({
            loading: opts.value
        });
        const isLoading = this.getRootState('loading');
        if (opts.force) {
            if (isLoading) MainLoader.update({
                animation: 'scaleOutIn',
                animationDelay: '0'
            });
            else MainLoader.update({
                animation: 'scaleInOut',
                animationDelay: 'F'
            });
            clearTimeout(t);
            return;
        }
        if (isLoading === null || !MainLoader) {
            clearTimeout(t);
            return;
        }
        const loaderAnimation = MainLoader.animation;
        if (isLoading === true) {
            if (loaderAnimation !== 'scaleOutIn') MainLoader.update({
                animation: 'scaleOutIn',
                animationDelay: '0'
            });
        } else if (isLoading === false) {
            if (loaderAnimation !== 'scaleInOut') MainLoader.update({
                animation: 'scaleInOut',
                animationDelay: 'F'
            });
        } else if (loaderAnimation !== 'scaleInOut') MainLoader.update({
            animation: 'scaleInOut',
            animationDelay: 'F'
        });
        clearTimeout(t);
    }, opts.timeout || 150);
} // if (isLoading === true) {
 //   if (loaderAnimation !== 'scaleOutIn') {
 //     Loader.update({ animation: 'scaleOutIn', animationDelay: '0' })
 //   }
 // } else if (isLoading === false) {
 //   if (loaderAnimation !== 'scaleInOut') {
 //     Loader.update({ animation: 'scaleInOut', animationDelay: 'F' })
 //   }
 // } else if (loaderAnimation !== 'scaleInOut') {
 //   Loader.update({ animation: 'scaleInOut', animationDelay: 'F' })
 // }

});

parcelRegister("alaSg", function(module, exports) {

$parcel$export(module.exports, "getNumberValueFromState", () => $78744cf46c9d55bd$export$ebe1324a36f1c00e);
$parcel$export(module.exports, "getLetterValueFromState", () => $78744cf46c9d55bd$export$262059ad41c7021f);
$parcel$export(module.exports, "updateLetterStateValue", () => $78744cf46c9d55bd$export$49c2a86be30f57d1);
$parcel$export(module.exports, "updateNumberStateValue", () => $78744cf46c9d55bd$export$1b035b6b2bd9ae28);
$parcel$export(module.exports, "handleAtKey", () => $78744cf46c9d55bd$export$2823390434059fbe);
$parcel$export(module.exports, "createSpacing", () => $78744cf46c9d55bd$export$31a62238a3f24621);
// FA204 / frank trap — every export below used to share a bank of
// module-scope helper `function`s (getPropertyValues/updateProperty/
// getSpacingValues/validateIndex/updatePropertyValuesAtIndex/
// findClosestSpacingKey/syncNumberInput/syncLetterInput). Unresolvable once
// each export is individually frank.toJSON'd for platform delivery
// (project_frank_drops_module_local_helpers) — each export below now carries
// its own self-contained inline copy of exactly what it calls.
// State getters
function $78744cf46c9d55bd$export$ebe1324a36f1c00e(index, property = null) {
    function getPropertyValues(state, property = null) {
        if (!property) return [];
        return state?.[property]?.split(' ') || [];
    }
    function validateIndex(index, array) {
        return index >= 0 && index < array.length;
    }
    function getSpacingValues(context) {
        return context?.designSystem?.spacing?.sequence || {};
    }
    if (property === 'lineHeight') // this.state.lineHeight is unset on first render (seeded async by
    // whatever page hosts BoxModelMiddle) — Math.abs(undefined) is NaN,
    // which rendered literally as "NaN%" in the input before state caught
    // up. 0 matches this function's own convention two branches below
    // (out-of-range index also falls back to 0) and reads as a sane
    // loading value instead of a visible error.
    return Math.abs(this.state?.[property]) || 0;
    const propertyValues = getPropertyValues(this.state, property);
    if (!validateIndex(index, propertyValues)) return 0;
    const value = propertyValues[index];
    const spacingValues = getSpacingValues(this.context);
    return spacingValues[value]?.val || 'none';
}
function $78744cf46c9d55bd$export$262059ad41c7021f(index, property = null) {
    function getPropertyValues(state, property = null) {
        if (!property) return [];
        return state?.[property]?.split(' ') || [];
    }
    function validateIndex(index, array) {
        return index >= 0 && index < array.length;
    }
    const propertyValues = getPropertyValues(this.state, property);
    if (!validateIndex(index, propertyValues)) return 0;
    return propertyValues[index];
}
function $78744cf46c9d55bd$export$49c2a86be30f57d1(index, property = null) {
    function getPropertyValues(state, property = null) {
        if (!property) return [];
        return state?.[property]?.split(' ') || [];
    }
    function updateProperty(state, propertyValues, property = null) {
        if (!property || !state || !Array.isArray(propertyValues)) return false;
        state.update({
            [property]: propertyValues.join(' ')
        });
        return true;
    }
    function getSpacingValues(context) {
        return context?.designSystem?.spacing?.sequence || {};
    }
    function syncNumberInput(element, value) {
        const numberInput = element?.parent?.NumberValue?.node;
        if (numberInput) numberInput.value = value;
    }
    const value = this.node?.value?.trim()?.toUpperCase();
    const spacingValues = getSpacingValues(this.context);
    // Handle negative values
    const isNegative = property === 'margin' && value?.startsWith('-');
    const letterValue = isNegative ? value.substring(1) : value;
    // Validation
    if (!letterValue || !spacingValues[letterValue]) return null;
    // Get numeric value
    const numericValue = spacingValues[letterValue].val;
    const finalNumericValue = isNegative ? -numericValue : numericValue;
    // Update state
    const propertyValues = getPropertyValues(this.state, property);
    while(propertyValues.length <= index)propertyValues.push('-');
    propertyValues[index] = value;
    // Update UI if state update successful
    if (updateProperty(this.state, propertyValues, property)) syncNumberInput(this, finalNumericValue);
}
function $78744cf46c9d55bd$export$1b035b6b2bd9ae28(index, property = null) {
    function getPropertyValues(state, property = null) {
        if (!property) return [];
        return state?.[property]?.split(' ') || [];
    }
    function updateProperty(state, propertyValues, property = null) {
        if (!property || !state || !Array.isArray(propertyValues)) return false;
        state.update({
            [property]: propertyValues.join(' ')
        });
        return true;
    }
    function getSpacingValues(context) {
        return context?.designSystem?.spacing?.sequence || {};
    }
    function syncLetterInput(element, value) {
        const letterInput = element?.parent?.LetterValue?.node;
        if (letterInput) letterInput.value = value;
    }
    function updatePropertyValuesAtIndex(state, property, index, value, syncFn) {
        const propertyValues = getPropertyValues(state, property);
        while(propertyValues.length <= index)propertyValues.push('-');
        propertyValues[index] = value;
        if (updateProperty(state, propertyValues, property)) syncFn();
    }
    function findClosestSpacingKey(value, spacingValues, property = null) {
        if (typeof value !== 'number') return null;
        // Handle negative values for margin
        const isNegative = value < 0;
        const absValue = Math.abs(value);
        let closestKey = null;
        let closestDiff = Infinity;
        Object.entries(spacingValues).forEach(([key, val])=>{
            const diff = Math.abs(absValue - val.val);
            if (diff < closestDiff) {
                closestDiff = diff;
                closestKey = key;
            }
        });
        return property === 'margin' && isNegative ? `-${closestKey}` : closestKey;
    }
    const value = this.node?.value?.trim();
    if (property === 'lineHeight') {
        this.state.update({
            lineHeight: Math.abs(parseFloat(value)) || 100
        });
        return;
    }
    if ([
        'minWidth',
        'minHeight',
        'maxWidth',
        'maxHeight'
    ].includes(property) && value === 'none') {
        updatePropertyValuesAtIndex(this.state, property, index, 'none', ()=>syncLetterInput(this, ''));
        return;
    }
    if ((property === 'width' || property === 'height') && value === 'auto') {
        updatePropertyValuesAtIndex(this.state, property, index, 'auto', ()=>syncLetterInput(this, ''));
        return;
    }
    // Handle special cases for 0 or '-'
    if (value === '0' || value === '-') {
        updatePropertyValuesAtIndex(this.state, property, index, '-', ()=>syncLetterInput(this, '-'));
        return;
    }
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return null;
    const spacingValues = getSpacingValues(this.context);
    const closestKey = findClosestSpacingKey(numValue, spacingValues, property);
    if (!closestKey) return null;
    updatePropertyValuesAtIndex(this.state, property, index, closestKey, ()=>syncLetterInput(this, closestKey));
}
function $78744cf46c9d55bd$export$2823390434059fbe(key) {
    if (!this.call('isString', key)) return '';
    return key.startsWith('@') ? key : `@${key}`;
}
async function $78744cf46c9d55bd$export$31a62238a3f24621() {
    if (!this.node.elements) {
        console.warn('createSpacing must be used inside a Form');
        return;
    }
    const cleanedKey = this.call('handleAtKey', this.node.elements.item('sidebar-new-item').value);
    await this.updateDesignSystem(`spacing.${cleanedKey}`, {
        ratio: 1.618
    });
}

});

parcelRegister("7ofJk", function(module, exports) {

$parcel$export(module.exports, "setFloatingPanel", () => $5616f9f1d157bbf7$export$fb73d91ab647a6c3);
$parcel$export(module.exports, "handlePanelDelete", () => $5616f9f1d157bbf7$export$5e0808702caa1996);
// FA204 / frank trap — every module-scope mutable + helper below used to be
// referenced bare from the two exports, `setFloatingPanel`/
// `handlePanelDelete` (project_frank_drops_module_local_helpers). This whole
// file coordinates ONE global floating panel singleton (a single DOM
// MutationObserver/ResizeObserver/document click-away listener, the
// re-entrancy `_inFlight`/`_pending*` queue) with no el/root argument stable
// enough to hoist it onto instead (`this` varies per call site) — re-homed
// onto `globalThis.__floatingPanelState`, the pointerCapability.js/
// mwtFlag.js/aiService.js template (the accessor that lazily creates it,
// and every helper that reads/writes it, is now NESTED inside each of the
// two exports below instead of module-scope, so there's no bare same-file
// reference left anywhere).
/**
 * Sets up a floating panel at a given position relative to the component.
 *
 * The floating panel is a component that appears when the user hovers over a
 * component in the DynamicIsland. It displays additional information about the
 * component, such as its props, state, and context.
 *
 * @function setFloatingPanel
 * @param {Object} data The data to display in the floating panel.
 * @param {Object} opts Parameters for the floating panel.
 * @param {Object} opts.panelOffset The position offset of the floating panel
 * @param {Object} opts.customProps Custom Properties for Floating Panel
 */ async function $5616f9f1d157bbf7$export$fb73d91ab647a6c3(data, opts = {}) {
    function floatingPanelState() {
        return globalThis.__floatingPanelState = globalThis.__floatingPanelState || {
            visibilityObserver: null,
            floatingPanelElement: null,
            clickAwayListenerEvent: null,
            cachedOverflow: null,
            resizeObserver: null,
            // Re-entrancy guard. `setFloatingPanel` is async — `await state.set`
            // fires a synchronous DOMQL re-render of the FloatingPanel subtree,
            // which is heavy for colors/themes/icons. Without serialization,
            // rapid clicks on the design-system grid queue dozens of concurrent
            // invocations; each one runs `cleanup()` mid-flight while the prior
            // one is still awaiting state.set, tearing down listeners the next
            // call is about to install and saturating the event loop. The
            // document click-away listener installed by call N is the one that
            // catches click N+1 — so each rapid click closes the panel call N
            // just opened, the visibilityObserver fires cleanup(), and the
            // cycle locks the UI. Tracked under #2064.
            //
            // Serialized so the last-click-wins data is honored (`pendingData`
            // stores the most recent request; once the in-flight call resolves
            // we run one more with the latest data if it changed). This avoids
            // re-entering for every queued click — we collapse N rapid clicks
            // down to "the active one + the last one", regardless of how many
            // the user fires.
            inFlight: null,
            // `null`, not `undefined` — frank's FA201 auto-fix wraps this
            // module-scope mutable state in a `Smut` container that round-trips
            // through JSON at `toJSON` time; `JSON.stringify` drops
            // `undefined`-valued keys entirely, so the emitted Smut container
            // never had a `pendingData` key to write through (frank `to-json`:
            // 14 `unresolvable-scope-read` findings, one per
            // `__scope.Smut._pending*` read/write site — same root class this
            // whole re-home fixes). `null` survives JSON round-tripping and is
            // already the established "no pending" sentinel for the sibling
            // `inFlight` above (never flagged) — same semantics everywhere
            // `pendingData`/`pendingOpts`/`pendingContext` are read as
            // falsy/nullish, so no behavior change.
            pendingData: null,
            pendingOpts: null,
            pendingContext: null,
            panelAuxFn: ()=>null
        };
    }
    function cleanup(state) {
        state.visibilityObserver?.disconnect?.();
        state.resizeObserver?.disconnect?.();
        if (state.clickAwayListenerEvent) window.document.removeEventListener('click', state.clickAwayListenerEvent, {
            capture: true
        });
        state.floatingPanelElement = null;
        state.clickAwayListenerEvent = null;
        state.visibilityObserver = null;
        state.resizeObserver = null;
    }
    function getOverflowElementExists(context, state) {
        if (!state.cachedOverflow) state.cachedOverflow = Boolean(context.getFilesSidebar()?.Overflow?.node);
        return state.cachedOverflow;
    }
    // Reference-equality + shallow-key check so rapid clicks on the
    // same color/icon/method don't trigger a redundant state.set.
    // Different keys/types still go through.
    function isSamePayload(a, b) {
        if (a === b) return true;
        if (!a || !b) return false;
        return a.type === b.type && a.dsType === b.dsType && a.key === b.key;
    }
    async function doSetFloatingPanel(data, opts = {}) {
        const state = floatingPanelState();
        const MAX_HEIGHT_MARGIN_NUM = 50;
        const FLOATING_PANEL_MAX_HEIGHT = `calc(100dvh - ${MAX_HEIGHT_MARGIN_NUM / 2}px)`;
        if (!data || this.call('isEmptyObject', data)) {
            if (state.floatingPanelElement) state.floatingPanelElement?.setNodeStyles?.({
                visibility: 'hidden',
                opacity: '0'
            });
            return;
        }
        cleanup(state);
        state.floatingPanelElement = this.getFloatingPanelElement();
        const calleeElement = opts.callee || data?.element || this;
        const calleeRect = calleeElement.node?.getBoundingClientRect?.() || {};
        state.clickAwayListenerEvent = (ev)=>this.handleClickAway(ev);
        // this is needed to react to external visibility changes of floating panel eg.: handleClickAway placed at Canvas comp.
        state.visibilityObserver = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.target.style?.visibility === 'hidden') cleanup(state);
        });
        state.resizeObserver = new ResizeObserver((entries)=>{
            const [floatingPanelEntry] = entries;
            if (calleeRect.top < floatingPanelEntry.contentRect.height / 2) state.floatingPanelElement.node.style.transform = `translateY(-${floatingPanelEntry.target.offsetTop - MAX_HEIGHT_MARGIN_NUM / 2}px)`;
        });
        state.visibilityObserver.observe(state.floatingPanelElement.node, {
            attributes: true,
            attributeFilter: [
                'style'
            ]
        });
        state.resizeObserver.observe(state.floatingPanelElement.node);
        const calleeLeftPos = calleeRect.left || 0;
        const calleeWidth = calleeRect.width || 0;
        const floatingPanelLeftPos = calleeLeftPos + calleeWidth;
        const updateStyles = (styles)=>{
            state.floatingPanelElement?.setNodeStyles?.({
                ...styles
            });
            if (opts.customProps) state.floatingPanelElement.update(opts.customProps);
        };
        const updateSidebarItem = async (calleeItem, isArtboard)=>{
            if (isArtboard) await this.call('updateItemInSidebar', calleeItem.type, calleeItem.key, opts);
            else {
                const type = calleeItem?.type || state.floatingPanelElement.state.type;
                await this.call('rerenderFileSidebarByType', type);
            }
        };
        // State management
        const updateSceneState = async (newData, calleeItemState, isArtboard, options = {})=>{
            if (state.floatingPanelElement?.state?.type !== newData?.type) options.preventUpdateAfterCount = 1;
            state.floatingPanelElement.state.set(newData, options);
            if (calleeItemState) await updateSidebarItem(calleeItemState, isArtboard);
        };
        const showPanel = ()=>{
            window.document.addEventListener('click', state.clickAwayListenerEvent, {
                capture: true
            });
            if (!state.floatingPanelElement) return;
            state.floatingPanelElement.data.isActive = true;
            const allowDropdownOverflow = state.floatingPanelElement.state?.type === 'semantic_color';
            const top = `${calleeRect.top + calleeRect.height}px`;
            updateStyles({
                opacity: '1',
                visibility: 'visible',
                position: 'absolute',
                transform: 'translateY(-50%)',
                top: top,
                overflow: allowDropdownOverflow ? 'visible' : 'auto',
                maxHeight: FLOATING_PANEL_MAX_HEIGHT,
                left: `${floatingPanelLeftPos}px`
            }, opts);
        };
        const overflowExists = getOverflowElementExists(this, state);
        if (!overflowExists || !state.floatingPanelElement) {
            console.warn('Required components not found for FloatingPanel');
            return;
        }
        try {
            if (this.node) {
                const calleeItemState = // `el.lookup` calls its predicate with ONE argument, so the previous
                // 2-arg `(el, s)` form threw as soon as an ancestor carried both
                // Rename and ContextMenu (the short-circuit hid it everywhere else).
                calleeElement.lookup((ancestor)=>ancestor.Rename && ancestor.ContextMenu && ancestor.state?.key)?.state || null;
                const isArtboard = calleeItemState && this.call('hasArtboard', calleeItemState?.type);
                await updateSceneState(data, calleeItemState, isArtboard);
            }
            showPanel(this);
        } catch (error) {
            console.error('Error setting up floating panel:', error);
        }
    }
    const state = floatingPanelState();
    // Close-intent (no data, empty object) ALWAYS runs synchronously
    // and clears any pending queue + the in-flight marker. This is
    // the user's escape hatch when they hit the X button on the
    // panel after a freeze — without this, a stuck `inFlight` from
    // a degraded prior call would silently drop the close request
    // and leave the palette open (#2071, "color palette stays open").
    const isCloseIntent = !data || this.call('isEmptyObject', data);
    if (isCloseIntent) {
        state.pendingData = null;
        state.pendingOpts = null;
        state.pendingContext = null;
        // Don't await the prior in-flight — it'll resolve into a no-op
        // queue. Just close immediately so the UI is responsive.
        state.inFlight = null;
        return doSetFloatingPanel.call(this, data, opts);
    }
    // Re-entrancy coordinator — body lives in doSetFloatingPanel. See
    // the top-of-file comment on `inFlight` for the rationale. Rapid
    // clicks on color/icon/method/theme items used to queue dozens of
    // overlapping invocations that fought over the same observer
    // singletons + document click listener; this collapses them into
    // "currently-running + most-recent-pending" so the UI never gets
    // wedged. (#2064, #2071)
    if (state.inFlight) {
        // If a click is mid-flight, drop the previous pending payload
        // and replace it with the latest user intent. Same-payload
        // rapid clicks become a no-op since `isSamePayload` returns
        // true and we don't queue a redundant repaint.
        if (!isSamePayload(state.pendingData, data)) {
            state.pendingData = data;
            state.pendingOpts = opts;
            state.pendingContext = this;
        }
        return state.inFlight;
    }
    state.inFlight = (async ()=>{
        try {
            await doSetFloatingPanel.call(this, data, opts);
            // After the active call settles, drain ONE queued payload if
            // the user requested something different mid-flight. We don't
            // drain the whole queue — at most one trailing call — because
            // anything else is staler than the latest pending.
            while(state.pendingData !== null){
                const nextData = state.pendingData;
                const nextOpts = state.pendingOpts;
                const nextCtx = state.pendingContext;
                state.pendingData = null;
                state.pendingOpts = null;
                state.pendingContext = null;
                await doSetFloatingPanel.call(nextCtx, nextData, nextOpts);
            }
        } finally{
            state.inFlight = null;
        }
    })();
    return state.inFlight;
}
function $5616f9f1d157bbf7$export$5e0808702caa1996() {
    // FA204 / frank trap — self-contained inline copy of the state accessor,
    // see setFloatingPanel above. Same globalThis bag, so the listener
    // installed/removed here targets the SAME `panelAuxFn` reference
    // setFloatingPanel's lifecycle relies on.
    function floatingPanelState() {
        return globalThis.__floatingPanelState = globalThis.__floatingPanelState || {
            visibilityObserver: null,
            floatingPanelElement: null,
            clickAwayListenerEvent: null,
            cachedOverflow: null,
            resizeObserver: null,
            inFlight: null,
            pendingData: null,
            pendingOpts: null,
            pendingContext: null,
            panelAuxFn: ()=>null
        };
    }
    async function handlePanelKeyUp(event) {
        if (event.keyCode !== 46 || !this.state.type || this.state.type === 'global_theme' && (this.state.key === '@light' || this.state.key === '@dark') || this.state.type === 'theme' && this.state.key === 'document') return;
        await this.updateDesignSystem(`${(this.state.dsType || this.state.type).toUpperCase()}.${this.state.key}`, null);
        await this.call('setFloatingPanel');
    }
    const state = floatingPanelState();
    document.body.removeEventListener('keyup', state.panelAuxFn);
    state.panelAuxFn = ()=>null;
    if (!this.call('isEmptyObject', this.state)) {
        state.panelAuxFn = handlePanelKeyUp.bind(this);
        document.body.addEventListener('keyup', state.panelAuxFn);
    }
}

});

parcelRegister("ijKP7", function(module, exports) {

$parcel$export(module.exports, "handleDSKeyChange", () => $03710154b96c8aa2$export$76e8813304809075);
$parcel$export(module.exports, "handleGlobalThemeKeyChange", () => $03710154b96c8aa2$export$f74a1eed0eafdafe);
$parcel$export(module.exports, "handleMediaIcon", () => $03710154b96c8aa2$export$d1945d1f75ba8401);
$parcel$export(module.exports, "handleDsNavbarClick", () => $03710154b96c8aa2$export$15efa247ab28fca1);
async function $03710154b96c8aa2$export$76e8813304809075(t, inputName = 'key') {
    if (!this.node.elements) {
        console.warn('handleDSKeyChange must be used inside a Form');
        return;
    }
    const { state: s } = this;
    const type = t.toUpperCase();
    const text = this.node.elements.item(inputName).value;
    if (!text) return;
    const previousKey = s.key;
    const newKey = type === 'SPACING' || type === 'TYPOGRAPHY' ? this.call('handleAtKey', text) : text;
    if (!s.value || !previousKey) return s.update({
        key: newKey
    });
    const path = (k)=>[
            'designSystem',
            type,
            k
        ];
    this.sdk.updateData([
        [
            'update',
            path(newKey),
            s.value
        ],
        [
            'delete',
            path(previousKey)
        ]
    ], {
        message: `Renamed ${previousKey} to ${newKey}`
    });
    // this.lookup('DynamicIsland').update()
    this.updateDesignSystemOnCanvas(this.getDesignSystem());
    s.update({
        key: newKey
    });
    await this.call('rerenderFileSidebarByType', type.toLowerCase());
}
async function $03710154b96c8aa2$export$f74a1eed0eafdafe() {
    if (!this.node.elements) {
        console.warn('handleDSKeyChange must be used inside a Form');
        return;
    }
    const { state: s } = this;
    const type = 'THEME';
    const text = this.node.elements.item('global-theme-key').value;
    if (!text) return;
    const previousKey = s.key;
    const newKey = this.call('handleAtKey', text);
    if (!s.value || !previousKey) return s.update({
        key: newKey
    });
    const path = (k)=>[
            'designSystem',
            type,
            'document',
            k
        ];
    this.sdk.updateData([
        [
            'update',
            path(newKey),
            s.value
        ],
        [
            'delete',
            path(previousKey)
        ]
    ], {
        message: `Renamed Global Theme ${previousKey} to ${newKey}`
    });
    this.lookup('DynamicIsland').update();
    // TODO: Check if this is needed
    this.updateDesignSystemOnCanvas(this.getDesignSystem());
    s.update({
        key: newKey
    });
}
function $03710154b96c8aa2$export$d1945d1f75ba8401(media) {
    const { value: mediaQuery = media } = this.state;
    if (!mediaQuery) return '';
    if (mediaQuery === 'print') return 'print outline';
    if (mediaQuery.includes('prefers-color-scheme: light')) return 'sun outline';
    if (mediaQuery.includes('prefers-color-scheme: dark')) return 'moon outline';
    const widthMatch = mediaQuery.match(/(?:min|max)-width:\s*(?<width>\d+)/u);
    if (!widthMatch) return 'displayPreferencesFill';
    const width = parseInt(widthMatch.groups.width, 10);
    const isMin = mediaQuery.includes('min-width');
    if (width >= 1920) return isMin ? 'device big screen half fill' : 'device big screen outline';
    if (width >= 1366) return isMin ? 'device big screen outline' : 'device small screen outline';
    if (width >= 1024) return isMin ? 'device small screen outline' : 'device tablet landscape outline';
    if (width >= 540) return isMin ? 'device tablet landscape outline' : 'device tablet portrait outline';
    return isMin ? 'device tablet portrait outline' : 'device mobile outline';
}
function $03710154b96c8aa2$export$15efa247ab28fca1() {
    const { key: key } = this.props;
    const val = this.getWindow('explorer') === key ? false : key;
    this.setWindow('explorer', val);
}

});

parcelRegister("1duun", function(module, exports) {

$parcel$export(module.exports, "setScenePosition", () => $0e2ea7cd91c2244a$export$a55086c2c7f0cfe6);
function $0e2ea7cd91c2244a$export$a55086c2c7f0cfe6(passedKey, options = {}) {
    const Scene = this.lookup('ComponentFrameCanvasTooltip');
    const key = passedKey || this.state?.value || this.text;
    if (!options.visible || !key) return Scene.setNodeStyles({
        opacity: '0',
        visibility: 'hidden'
    });
    const type = this.call('getType', key);
    const value = this.getData(type)[key];
    const schema = this.getSchema(type)[key];
    if (!value || !schema || Scene.data.key === schema.key && Scene.visibility === 'visible') return Scene.setNodeStyles({
        opacity: '0',
        visibility: 'hidden'
    });
    Scene.data.key = schema.key;
    let transform;
    if (options.position === 'bottom') {
        const position = `${this.node.getBoundingClientRect().left}px`;
        const translate = `calc(${position} - 50%)`;
        transform = `translate3d(${translate}, 0, 0)`;
    } else if (options.position === 'mouse' && options.mouseEvent) {
        // Position relative to mouse cursor
        const x = options.mouseEvent.clientX //- 250
        ;
        const y = options.mouseEvent.clientY - 35;
        transform = `translate3d(${x}px, ${y}px, 0)`;
    } else {
        const rect = this.node.getBoundingClientRect();
        const tooltipNode = Scene.node;
        const tooltipWidth = tooltipNode.offsetWidth;
        const tooltipHeight = tooltipNode.offsetHeight;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        let top = rect.top - 15;
        let left = rect.left + rect.width / 2 - 50;
        // Clamp left and top to keep tooltip within viewport
        left = Math.max(0, Math.min(left, viewportWidth - tooltipWidth - 35));
        top = Math.max(0, Math.min(top, viewportHeight - tooltipHeight - 35));
        const topPosition = `${top}px`;
        const leftPosition = `${left}px`;
        transform = `translate3d(${leftPosition}, ${topPosition}, 0px)`;
    }
    Scene.setNodeStyles({
        opacity: '1',
        visibility: 'visible',
        transform: transform
    });
    window.requestAnimationFrame(()=>{
        const componentState = this.call('deepClone', {
            value: value,
            ...schema
        });
        Scene.state.set(componentState);
    });
}

});

parcelRegister("7JjHI", function(module, exports) {

$parcel$export(module.exports, "generatePreviewUrl", () => $5a0c05336747a2aa$export$4a1e2a1448915d1e);
$parcel$export(module.exports, "generateUrl", () => $5a0c05336747a2aa$export$bfd283b1e58f27c1);
$parcel$export(module.exports, "openInNewTab", () => $5a0c05336747a2aa$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "buildProjectUrls", () => $5a0c05336747a2aa$export$9ad373d36e296158);

var $hmkNw = parcelRequire("hmkNw");

var $grPR9 = parcelRequire("grPR9");

var $e3DJf = parcelRequire("e3DJf");
function $5a0c05336747a2aa$export$4a1e2a1448915d1e() {
    // Bug #2051: the previous implementation built `https://${appKey}` for
    // production and `${channelApiUrl}/?renderUrl=${appKey}` for everything
    // else. Neither URL points at the canonical preview host
    // (`{owner}--{key}.<tier>.preview.symbols.app`), so the "Open in new
    // tab" button opened a non-existent host that the browser couldn't
    // resolve. Route through `previewProjectUrl` from @symbo.ls/channels —
    // the same builder used by the CLI publish summary and the studios
    // project tile — so the URL is always the published-preview host.
    // FA204 / frank trap — moved from module scope into this function (sole
    // consumer, pure helper — see longPress.js for the identical shape).
    // Resolve the active project's owner/key from root state. Prefers the
    // canonical canvas pathname pair (`workingProjectOwner`/`workingProjectKey`)
    // that the studios router sets, falling back to legacy state shapes used
    // by older canvas modes (raw `owner` username + `appKey`).
    function _resolveProjectIdentity(root) {
        const s = root || {};
        let owner = s.workingProjectOwner || s.owner?.username || (Array.isArray(s.members) ? s.members.find((m)=>m.role === 'owner')?.username : null) || null;
        let rawKey = s.workingProjectKey || s.appKey || s.key || null;
        // Canvas v2 project route: none of the legacy state shapes above are set —
        // root carries only `data` — so "Open in new tab" resolved {null, null} and
        // generatePreviewUrl returned null, a silent dead click (live-verified
        // 2026-08-08 per Nika "icons clicking and functionality"). The /:owner/:key
        // route itself is the canonical identity there; resolveProjectParams is the
        // same shared helper the canvas boot uses.
        if (!owner || !rawKey) {
            const fromRoute = (0, $e3DJf.resolveProjectParams)();
            if (!owner && fromRoute.owner) owner = fromRoute.owner;
            if (!rawKey && fromRoute.key) rawKey = fromRoute.key;
        }
        const key = rawKey ? (0, $hmkNw.normalizeProjectKey)(rawKey, {
            owner: owner
        }) : null;
        return {
            owner: owner ? String(owner).toLowerCase() : null,
            key: key
        };
    }
    const root = this.getRootState() || {};
    const { owner: owner, key: key } = _resolveProjectIdentity(root);
    if (!owner || !key) return null;
    const env = root.ENV || this.getRootState?.('ENV') || 'production';
    // Selected canvas item: append `/component?key=X` or `/<pagePath>` so
    // the preview app deep-links into the right surface.
    const isCanvas = this.call('isCanvas');
    const selected = isCanvas && this.getSelected();
    if (selected?.state?.content?.src) return selected.state.content.src;
    const selectedKey = isCanvas && this.getSelectedKey();
    const version = this.getActiveVersion?.();
    const latestVersion = this.getLatestVersion?.();
    const isOld = version && version !== latestVersion;
    let base = (0, $hmkNw.previewProjectUrl)({
        owner: owner,
        key: key,
        env: env
    });
    if (!base) {
        // Fallback to the rendered API path only when the channel has no
        // preview host configured (local channel without portless mapping).
        const target = key + (selectedKey ? selectedKey.startsWith('/') ? selectedKey : `/component?key=${selectedKey}` : '');
        return `${(0, $hmkNw.apiUrl)(env)}/?renderUrl=${encodeURIComponent(target)}`;
    }
    // `previewProjectUrl` returns a URL ending in `/` (no path), with an
    // optional `?env=…` query when env !== production. Splice the selected
    // path/query INTO the URL preserving the env query.
    const url = new URL(base);
    if (selectedKey) {
        url.pathname = selectedKey.startsWith('/') ? selectedKey : '/component';
        if (!selectedKey.startsWith('/')) url.searchParams.set('key', selectedKey);
    }
    if (isOld) url.searchParams.set('version', version);
    return url.toString();
}
function $5a0c05336747a2aa$export$bfd283b1e58f27c1() {
    const selected = this.getSelected();
    const appKey = this.getAppKey();
    if (!selected) return `${appKey.split('.')[0]}`;
    const key = this.getSelectedKey();
    const isPage = key.startsWith('/');
    const path = isPage ? key : `/${key}`;
    return `symbo.ls/${appKey.split('.')[0]}${path || ''}`;
}
function $5a0c05336747a2aa$export$9e52b10d57ddf9e3() {
    const openUrl = this.call('generatePreviewUrl');
    const url = window.open(openUrl, 'Symbols preview');
    // Setup interval to check when the window is closed
    this.syncCanvas({
        openUrl: openUrl
    });
    const checkInterval = setInterval(()=>{
        if (url && url.closed) {
            this.syncCanvas({
                openUrl: null
            });
            clearInterval(checkInterval);
        }
    }, 1500);
}
function $5a0c05336747a2aa$export$9ad373d36e296158(owner, key, env = 'development') {
    const safeOwner = String(owner || '').trim().toLowerCase();
    const safeKey = (0, $hmkNw.normalizeProjectKey)(key, {
        owner: safeOwner
    });
    if (!safeOwner || !safeKey) return null;
    // Preview stays cross-domain (preview hosts on `*.preview.symbols.app`,
    // a separate origin from the workspace shell). Canvas is mounted at the
    // same origin as the workspace shell via the unified multi-app entry,
    // so the canvas URL is a relative path the SPA router catches without a
    // host hop.
    const channel = (0, $grPR9.currentChannelFromHost)() || (0, $hmkNw.currentChannel)() || undefined;
    // "Open directly" / "Direct (dev|prod)" always open the LIVE deployed app
    // on the canonical mermaid host (`owner--key[--env].at.symbo.ls`), NOT the
    // current host's channel — on workspace.localhost the host channel is
    // 'local', which would resolve mermaidUrl to `…localhost:1355` (the local
    // dev server) instead of the deployed project. The env still rides the
    // `--env` subdomain segment; only the domain is pinned to production.
    // (2026-06-14 per Nika: "Open Directly should open *.at.symbo.ls urls".)
    const directChannel = 'production';
    return {
        safeOwner: safeOwner,
        safeKey: safeKey,
        preview: (0, $hmkNw.previewProjectUrl)({
            owner: safeOwner,
            key: safeKey,
            env: env
        }, channel),
        canvas: `/${safeOwner}/${safeKey}?env=${env}`,
        directDev: (0, $hmkNw.mermaidUrl)({
            owner: safeOwner,
            key: safeKey,
            env: 'development'
        }, directChannel),
        directStaging: (0, $hmkNw.mermaidUrl)({
            owner: safeOwner,
            key: safeKey,
            env: 'staging'
        }, directChannel),
        directProd: (0, $hmkNw.mermaidUrl)({
            owner: safeOwner,
            key: safeKey,
            env: 'production'
        }, directChannel)
    };
}

});
parcelRegister("e3DJf", function(module, exports) {

$parcel$export(module.exports, "resolveProjectParams", () => $a3c029cf43671e75$export$67df3ea6e237ebef);
// Single source of truth for "which project are we loading?" — used by
// every editor surface (canvas, preview, future embeds). Resolves in
// priority order:
//
//   0. Preview-subdomain hostname: `{owner}--{key}.preview.symbols.app`
//      (or `…preview.localhost` for local dev) — when it names a project it
//      OWNS owner + key; the query below cannot override it (D2-iv).
//   1. Explicit URL params: `?owner=…&key=…[&env=…&branch=…&version=…]`
//   2. (the preview hostname again — only reached when it named nothing)
//   3. Workspace-scoped pathname: `/w/{org}/p/{key}` or `/w/{org}/{ws}/p/{key}`
//      (scheme A canvas-project form — owner IS the org segment; see
//      ./projectUrls.js). Any other `/w/…` shape is an intranet route and
//      never yields an owner/key pair.
//   4. Canvas-style pathname: `/{owner}/{key}/…` (excluding reserved
//      chrome routes like `/dashboard`, `/signin`, etc.)
//
// Each source is tried independently — the first non-empty value wins
// per field. Callers can pass their own `reservedPathSegments` set when
// their surface has different chrome routes from canvas; default covers
// the current canvas set.

var $1G1eN = parcelRequire("1G1eN");
function $a3c029cf43671e75$export$67df3ea6e237ebef({ loc: loc = typeof window !== 'undefined' ? window.location : null, reservedPathSegments: reservedPathSegments } = {}) {
    if (!loc) return {
        owner: null,
        key: null,
        env: null,
        branch: null,
        version: null,
        sources: {}
    };
    const DEFAULT_RESERVED_PATHS = new Set([
        'workspaces',
        'dashboard',
        'signin',
        'signup',
        'signup-confirmation',
        'reset-password',
        'waitlist'
    ]);
    // Matches the preview-host shapes:
    //   {owner}--{key}.preview.symbols.app           (prod)
    //   {owner}--{key}.<tier>.preview.symbols.app    (tier — next/dev/staging/upcoming/...)
    //   {owner}--{key}.preview.localhost             (local)
    //   {owner}--{key}.<tier>.preview.localhost      (local tier — rare)
    // The optional `<tier>.` segment lives between the project slug and the
    // literal `preview.` apex, so each tier can serve its own preview surface
    // without tier-specific URL rewriters.
    const PREVIEW_SUBDOMAIN_RE = /^([^.]+)--([^.]+)(?:\.[a-z0-9-]+)?\.preview\.(symbols\.app|localhost)$/;
    function fromParams(params) {
        return {
            owner: params.get('owner') || null,
            key: params.get('key') || null,
            env: params.get('env') || null,
            branch: params.get('branch') || null,
            version: params.get('version') || null
        };
    }
    function fromHost(hostname) {
        const match = hostname.match(PREVIEW_SUBDOMAIN_RE);
        if (match) return {
            owner: match[1],
            key: match[2]
        };
        return {};
    }
    function fromPath(pathname, reserved) {
        const segs = pathname.split('/').filter(Boolean);
        if (!segs.length) return {};
        // Workspace-scoped scheme A: `/w/<org>[/<ws>]/p/<key>` — the org segment is
        // the owner. Every OTHER `/w/…` shape is an intranet route: return {} (not
        // fall-through), otherwise the generic branch below misreads `/w/<org>/…`
        // as owner `w`, key `<org>`.
        if (segs[0] === 'w') {
            const wsProject = (0, $1G1eN.parseWorkspaceProjectPath)(pathname);
            return wsProject ? {
                owner: wsProject.owner,
                key: wsProject.key
            } : {};
        }
        // Canvas-style: first two segments unless the first is a reserved
        // chrome route (dashboard / signin / etc.).
        if (segs.length >= 2 && !reserved.has(segs[0])) return {
            owner: segs[0],
            key: segs[1]
        };
        return {};
    }
    // Fallback moved off the destructuring default — same signature-drift
    // reason as authGuard.js's DEFAULT_AUTH_PATHS / minimizedSlots.js's
    // MINIMIZED_SLOTS_CAP.
    const resolvedReservedPathSegments = reservedPathSegments || DEFAULT_RESERVED_PATHS;
    const params = new URLSearchParams(loc.search);
    const p = fromParams(params);
    const h = fromHost(loc.hostname || '');
    const pa = fromPath(loc.pathname || '', resolvedReservedPathSegments);
    // A preview host that names a project (`<owner>--<key>.preview…`) IS that
    // project's public page: it owns owner + key outright, and a `?owner&key`
    // query never overrides it — not both fields, not one (D2-iv,
    // PREVIEW-HOST-PUBLIC-ONLY). env / branch / version still come from the query.
    if (h.owner && h.key) return {
        owner: h.owner,
        key: h.key,
        env: p.env || null,
        branch: p.branch || null,
        version: p.version || null,
        sources: {
            params: p,
            host: h,
            path: pa
        }
    };
    return {
        owner: p.owner || h.owner || pa.owner || null,
        key: p.key || h.key || pa.key || null,
        env: p.env || null,
        branch: p.branch || null,
        version: p.version || null,
        sources: {
            params: p,
            host: h,
            path: pa
        }
    };
}

});
parcelRegister("1G1eN", function(module, exports) {

$parcel$export(module.exports, "parseWorkspaceProjectPath", () => $138aac71379368ae$export$720f65c9e2ce660e);
$parcel$export(module.exports, "projectHref", () => $138aac71379368ae$export$f0d942990eaa6a6e);
// projectUrls.js — the workspace-scoped canvas-project URL form
// (2026-08-06 per Nika: "for canvas projects
// https://dev.my.symbols.app/w/org/workspace/p/project").
//
//   /w/<org>/p/<key>        → project <org>/<key>, org HQ workspace scope
//   /w/<org>/<ws>/p/<key>   → project <org>/<key>, scoped to workspace <ws>
//   /<owner>/<key>          → legacy/universal form — valid forever (external
//                             links, cross-org projects, signed-out visitors)
//
// The literal `p` segment is a reserved route marker: it can never be a
// workspace handle (static RESERVED_WS_SEG2 gate in ./workspacePrefix.js) and
// never a minted workspace slug (server RESERVED_WORKSPACE_SLUGS,
// src/core/utils/workspaceSlug.js) — so the parse is POSITIONAL and needs no
// workspace data: `p` at segment 3 marks the HQ form, `p` at segment 4 marks
// the workspace form. That keeps cold deep-links parseable before the org's
// workspace list has landed (the shell's handle resolver registers late).
//
// PURE path-string helpers (workspacePrefix.js / guestRoutes.js pattern):
// plain shared/functions module consumed by direct ESM import, NOT via
// el.call. Corrected 2026-08-12 (frank-trap sweep, tickets/sonnet.md) — the
// "NOT registered in functions/index.js — never frank-serialized" claim was
// stale: it IS barrelled (`export * from './projectUrls.js'`), same
// stale-comment class the ticket already flagged for workspacePrefix.js.
// Reads of state/paths are the caller's job (Rule 64: navigation itself still
// goes through el.router).

var $9juhh = parcelRequire("9juhh");

var $g3Ned = parcelRequire("g3Ned");

var $fDBlu = parcelRequire("fDBlu");
const $138aac71379368ae$export$720f65c9e2ce660e = (pathname)=>{
    // FA204 / frank trap — moved from module scope into this function (sole
    // consumer, pure literal — see longPress.js for the identical shape). Org
    // slugs per MODEL: [a-z0-9-]{1,48}. Workspace handles are slugs OR keys
    // (`ws_jfTumkSWof`) or raw ids — same charset as WORKSPACE_TWO_SEG_RE.
    const ORG_SEG_RE = /^[a-z0-9-]{1,48}$/;
    const WS_SEG_RE = /^[A-Za-z0-9_-]{1,64}$/;
    if (typeof pathname !== 'string' || !pathname) return null;
    const segs = pathname.split(/[?#]/)[0].split('/').filter(Boolean);
    if (segs[0] !== 'w') return null;
    const owner = segs[1];
    if (!owner || !ORG_SEG_RE.test(owner)) return null;
    // HQ form: /w/<org>/p/<key>. Checked FIRST — `p` can never be a workspace
    // handle, so segment 3 being `p` is unambiguous (even for an org whose slug
    // is literally `p`: /w/p/p/<key> parses as org `p`, HQ form).
    if (segs[2] === 'p') return segs[3] ? {
        owner: owner,
        wsHandle: null,
        key: segs[3]
    } : null;
    // Workspace form: /w/<org>/<ws>/p/<key>.
    if (segs[3] === 'p' && segs[4] && WS_SEG_RE.test(segs[2])) return {
        owner: owner,
        wsHandle: segs[2],
        key: segs[4]
    };
    return null;
};
const $138aac71379368ae$export$f0d942990eaa6a6e = (root, owner, key)=>{
    const o = String(owner || '').trim();
    const k = String(key || '').trim();
    if (!o || !k) return null;
    const legacy = `/${o}/${k}`;
    if (!(0, $fDBlu.isMwtEnabled)()) return legacy;
    const org = root && root.org;
    const orgSlug = org && (org.slug || org.username) || null;
    if (!orgSlug) return legacy;
    const want = o.toLowerCase();
    const inOwnerOrg = [
        org.slug,
        org.username
    ].filter(Boolean).some((v)=>String(v).toLowerCase() === want);
    if (!inOwnerOrg) return legacy;
    const handle = (0, $g3Ned.resolveWorkspaceUrlHandle)({
        workspace: root.workspace,
        org: org,
        workspaces: Array.isArray(root.workspaces) ? root.workspaces : []
    });
    // Emit the org's canonical URL slug (not the raw owner string): boot's
    // cross-org reconcile resolves the prefix against org slugs, and the
    // project loader resolves the same slug server-side.
    return (0, $9juhh.withWorkspacePath)(orgSlug, handle, `/p/${k}`);
};

});
parcelRegister("g3Ned", function(module, exports) {

$parcel$export(module.exports, "resolveWorkspaceUrlHandle", () => $bb131ce123f75847$export$956bd5458b595de8);
$parcel$export(module.exports, "syncWorkspaceUrl", () => $bb131ce123f75847$export$7d7662180fad616a);
// workspaceUrlSync.js — keeps the address bar naming the workspace the tab is
// actually in.
//
// `/w/<org-slug>` names only the ORG. In an org with two or more workspaces the
// URL was therefore ambiguous: `resolveActiveWorkspace` resolved it to the org's
// HQ workspace, so reloading a non-HQ workspace snapped back to HQ, a copied
// link opened the wrong workspace for the recipient, and two tabs could not hold
// two different workspaces of the same org. `?ws=<handle>` closes that gap; this
// module is the one place that writes it when the ACTIVE workspace changes.
//
// replaceState, never push: switching workspace is not a navigation — the route
// is unchanged and the user should not have to press Back twice to leave the
// page. It mirrors the address-bar canonicalize in mwtRouter.js, which is the
// established pattern here for "correct the URL without navigating" (`el.router`
// remains the only way to actually navigate — Rule 64).
//
// Pure-ish module, direct ESM import (workspacePrefix.js / guestRoutes.js
// pattern). Corrected 2026-08-12 (frank-trap sweep, tickets/sonnet.md) — the
// "not registered in functions/index.js, never frank-serialized" claim below
// was stale: it IS barrelled (`export * from './workspaceUrlSync.js'`), same
// stale-comment class the ticket already flagged for workspacePrefix.js.

var $fDBlu = parcelRequire("fDBlu");

var $9juhh = parcelRequire("9juhh");

var $jhJrJ = parcelRequire("jhJrJ");
const $bb131ce123f75847$export$956bd5458b595de8 = (state)=>{
    const ws = state?.workspace;
    if (!ws) return null;
    // EVERY workspace URL carries its segment — HQ included (2026-08-06 per
    // Nika: "make it consistant" → keep /w/, always stamp the ws segment; the
    // concise HQ short form is gone). This retires the HQ sibling heuristic
    // and its mid-switch org guard wholesale: the handle comes off the
    // workspace record alone, org-independent, exactly like the non-HQ arm
    // always worked. Bare /w/<org> links stay PARSED forever (they resolve to
    // the org's HQ) — the canonicalizer just rewrites them to the full shape
    // on the first sync.
    return (0, $jhJrJ.workspaceUrlHandle)(ws);
};
const $bb131ce123f75847$export$7d7662180fad616a = (state, opts)=>{
    if (!(0, $fDBlu.isMwtEnabled)()) return null;
    // FA204 / frank trap — moved from module scope into this function (sole
    // consumer of both — see longPress.js/dragRef.js for the identical shape).
    //
    // Workspace ids are always minted `ws_<nanoid>` (server/src/core/models/
    // Workspace.js: `key: () => \`ws_${nanoid(10)}\``, nanoid's URL-safe
    // alphabet — `[A-Za-z0-9_-]`). No intranet route ever starts with `ws_`
    // (mwtNav.js's INTRANET_RE), and workspace SLUGS are minted server-side
    // against a reserved blacklist mirroring the static route names — so this
    // shape is an unambiguous, safe signal that a path segment names a
    // workspace, independent of whether this session currently knows that
    // workspace by id.
    const RAW_WORKSPACE_ID_RE = /^ws_[A-Za-z0-9_-]+$/;
    // Whether `seg` (a raw path segment) names a workspace this session should
    // recognize as stale/stray — the active workspace's own handle, ANY
    // sibling in `workspacesList`, OR the raw-id shape every workspace id is
    // minted in. See the original (pre-inline) header comment history for the
    // full "double-stamped URL" rationale (tickets/opus.md).
    const looksLikeStaleWorkspaceSegment = (seg, w0, workspacesList)=>{
        if (!seg) return false;
        const lower = seg.toLowerCase();
        // `default` — the HQ slug convention — is never a route either (see
        // workspacePrefix.js dropDefault). A boot sync that ran before this fix
        // stamped the handle in FRONT of it (`/w/system/hq/default`, "Not
        // found"); such a URL heals here like any other double stamp.
        if (lower === 'default') return true;
        const known = [
            w0,
            ...Array.isArray(workspacesList) ? workspacesList : []
        ];
        for (const w of known){
            if (!w) continue;
            const ids = [
                w.slug,
                w.key,
                w.id ?? w._id
            ].filter(Boolean).map((v)=>String(v).toLowerCase());
            if (ids.includes(lower)) return true;
        }
        return RAW_WORKSPACE_ID_RE.test(seg);
    };
    const win = typeof window !== 'undefined' ? window : null;
    if (!win?.history || !win.location) return null;
    const ws = state?.workspace;
    const path = win.location.pathname || '/';
    const orgScoped = path === '/w' || path.startsWith('/w/');
    let next;
    if (!orgScoped || !ws) {
        // Off the org surface: only self-clean a stale legacy param.
        const current = path + (win.location.search || '');
        next = (0, $9juhh.withWorkspaceQuery)(current, null) + (win.location.hash || '');
    } else {
        const parsed = (0, $9juhh.parseWorkspacePath)(path);
        const stateSlug = state?.org?.slug || state?.org?.username || null;
        const foreignOrgUrl = !!(parsed.orgSlug && stateSlug && parsed.orgSlug !== stateSlug);
        if (foreignOrgUrl && !opts?.rewriteOrg) return null;
        const orgSlug = opts?.rewriteOrg && stateSlug || parsed.orgSlug || stateSlug || null;
        // FA204 / frank trap — self-contained inline copy of resolveWorkspaceUrlHandle
        // (a bare sibling-export read is exactly as unresolvable post-frank as a
        // module-local read); the export above stays live for genuine external
        // consumers (meet/roomUrl.js, workspace/functions/mwtRouter.js).
        const handle = ws ? (0, $jhJrJ.workspaceUrlHandle)(ws) : null;
        let route = parsed.route;
        if (!parsed.wsHandle) {
            // Belt-and-suspenders: if the parse's resolver missed (a call racing
            // boot registration, or a genuinely stray/foreign/deleted workspace
            // segment the resolver never claims) and segment 2 looks like a
            // workspace identifier — strip it manually. Otherwise the rebuild
            // below double-stamps: either the SAME handle twice
            // (`/w/acme/team-b/team-b/tickets`, the original bug this guard
            // shipped for) or, when the stray segment names a DIFFERENT workspace
            // than the active one, the real handle gets stamped in FRONT of the
            // untouched stray id instead of replacing it
            // (`/w/acme/team-b/ws_<stale-id>/tickets`).
            //
            // LOOPED, not a single check: a cold boot that lands DIRECTLY on an
            // already double-stamped URL (`/w/<org>/<realHandle>/ws_<stale-id>/
            // <route>` — e.g. a Stripe `successUrl` captured while the address
            // bar was mid-corruption from an earlier, now-fixed run of this same
            // function) presents TWO consecutive workspace-like segments before
            // the real route starts. `bootShell.js`'s boot-time call always races
            // the resolver (registered later, in `app.js`'s `onCreate`), so the
            // primary `parseWorkspacePath` TWO_SEG_RE+resolver path can never
            // catch this — only this fallback can, and a single strip only ate
            // the first segment (`<realHandle>`) and left `ws_<stale-id>` glued
            // to the front of the rebuilt route, reconstructing the exact same
            // broken URL byte-for-byte (`next === current`, so the function
            // silently no-ops on an already-broken URL instead of healing it —
            // reproduced live against this exact module + Nika's exact reported
            // string; tickets/opus.md cold-boot regression). Bounded by the
            // route's own segment count so it can never run away, and a real
            // route segment can never false-positive here: server-side workspace
            // slugs are minted against a reserved blacklist mirroring the static
            // route names, and raw ids always carry the `ws_` shape prefix (this
            // file's own header comment) — neither can ever collide with an
            // actual route token, so stripping "while it still looks like a
            // workspace" is safe to repeat, not just do once.
            let seg = String(route.split('/')[1] || '');
            while(looksLikeStaleWorkspaceSegment(seg, ws, state?.workspaces)){
                const rest = route.slice(seg.length + 1);
                route = rest === '' ? '/' : rest;
                if (route === '/') break;
                seg = String(route.split('/')[1] || '');
            }
        }
        const rebuilt = orgSlug ? (0, $9juhh.withWorkspacePath)(orgSlug, handle, route) : path;
        next = (0, $9juhh.withWorkspaceQuery)(rebuilt + (win.location.search || ''), null) + (win.location.hash || '');
    }
    const current = path + (win.location.search || '') + (win.location.hash || '');
    if (next === current) return null;
    try {
        win.history.replaceState(win.history.state, '', next);
    } catch  {}
    return next;
};

});




parcelRegister("1VIh3", function(module, exports) {

$parcel$export(module.exports, "capitalize", () => $167d753665e29fa6$export$9a00dee1beb8f576);
function $167d753665e29fa6$export$9a00dee1beb8f576(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("cRhmz", function(module, exports) {

$parcel$export(module.exports, "renameLegacy", () => $95c7e736a22d0690$export$360f7993ab8d5ea7);
$parcel$export(module.exports, "renameComponents", () => $95c7e736a22d0690$export$8f1c3a6251be3aaa);
$parcel$export(module.exports, "renamePages", () => $95c7e736a22d0690$export$5971448592bfb734);
$parcel$export(module.exports, "renameFunctions", () => $95c7e736a22d0690$export$4f535a74fe81b72e);
$parcel$export(module.exports, "renameFiles", () => $95c7e736a22d0690$export$97753adb9ac72312);
async function $95c7e736a22d0690$export$360f7993ab8d5ea7(type, inputName = 'new-key', callback = ()=>null) {
    // FA204 / frank trap — itemTypes/showError moved from module scope into
    // this function (sole consumer, pure helpers — see longPress.js for the
    // identical shape).
    const itemTypes = {
        components: {
            getItems () {
                return this.getComponents();
            },
            updatePath: [
                'components'
            ],
            validateKey: ()=>true,
            getItemTypeName: ()=>'components'
        },
        pages: {
            getItems () {
                return this.getData('pages');
            },
            updatePath: [
                'pages'
            ],
            validateKey: (key)=>key.startsWith('/'),
            getItemTypeName: ()=>'pages',
            validationError: "Page's key must start with /"
        },
        functions: {
            getItems () {
                return this.getFunctions();
            },
            updatePath () {
                return [
                    this.call('getType')
                ];
            },
            validateKey: ()=>true,
            getItemTypeName () {
                return this.call('getType');
            }
        },
        files: {
            getItems () {
                return this.getFiles();
            },
            updatePath: [
                'files'
            ],
            validateKey: (key, originalFormat)=>{
                const [, newFormat] = key.split('.');
                return !newFormat || newFormat === originalFormat;
            },
            validationError: 'This format is different from the original. Please maintain the same format or omit it to reuse.',
            formatKey: (key, originalFormat)=>{
                const [, newFormat] = key.split('.');
                return newFormat ? key : `${key}.${originalFormat}`;
            },
            getItemTypeName () {
                return 'files';
            }
        }
    };
    // LOOKUP-SHAPE-1: `errorEl` (below) used to be derefed unguarded off a
    // `this.lookup('Label')` result — a miss threw inline and rename submit
    // died. Guarded here too so a missing error slot degrades to "no inline
    // error shown" instead of crashing the whole rename flow.
    function showError(errorEl, text) {
        if (!errorEl) return;
        errorEl.update({
            display: 'block!important',
            text: text
        });
        setTimeout(()=>{
            errorEl.update({
                display: '',
                text: ''
            });
        }, 2500);
    }
    const typeConfig = itemTypes[type];
    if (!this.node.elements) {
        console.warn(`rename${type.charAt(0).toUpperCase() + type.slice(1)} must be used on submit of a Form`);
        return;
    }
    const { state: s } = this;
    let newKey = this.node.elements.item(inputName).value;
    const items = typeConfig.getItems.call(this);
    const errorEl = this.lookup('Label')?.Err;
    const handleError = (text)=>{
        showError(errorEl, text);
        this.node.reset();
    };
    if (items[newKey]) {
        handleError(`${typeConfig.getItemTypeName.call(this)} with such key exists. Please enter a new key`);
        return;
    }
    if (typeConfig.validateKey && !typeConfig.validateKey(newKey, s.value.format)) {
        handleError(typeConfig.validationError);
        return;
    }
    if (typeConfig.formatKey) newKey = typeConfig.formatKey(newKey, s.value.format);
    // Rename returns false if the user dismissed the confirm dialog or the
    // rename otherwise didn't go through. In that case we MUST NOT fire the
    // callback — the callback updates the sidebar/state UI optimistically and
    // would leave the UI showing the new name while the data layer still has
    // the old key (fixed in #2042).
    const result = await this.call('rename', s.type, s.key, newKey);
    if (result === false) return;
    // const updatePath = this.call('isFunction', typeConfig.updatePath)
    //   ? typeConfig.updatePath.call(this)
    //   : typeConfig.updatePath
    // const factoryType = updatePath[0]
    // const schema = this.getSchema(factoryType)
    // const hasSchema = schema && schema[s.key]
    // if (hasSchema && hasSchema.key) {
    //   hasSchema.key = newKey
    // }
    // this.sdk.updateData(
    //   [
    //     ['delete', [...updatePath, s.key]],
    //     ['update', [...updatePath, newKey], s.value],
    //     hasSchema && ['delete', ['schema', ...updatePath, s.key]],
    //     hasSchema && ['update', ['schema', ...updatePath, newKey], hasSchema]
    //   ].filter((v) => v),
    //   {
    //     message: `Rename ${typeConfig.getItemTypeName.call(this)} from ${
    //       s.key
    //     } to ${newKey}`
    //   }
    // )
    window.requestAnimationFrame(()=>callback(newKey));
}
async function $95c7e736a22d0690$export$8f1c3a6251be3aaa(inputName = 'NewKey', callback = ()=>null) {
    return await this.call('renameLegacy', 'components', inputName, callback);
}
async function $95c7e736a22d0690$export$5971448592bfb734(inputName = '/new-key', callback = ()=>null) {
    return await this.call('renameLegacy', 'pages', inputName, callback);
}
async function $95c7e736a22d0690$export$4f535a74fe81b72e(inputName = 'newKey', callback = ()=>null) {
    return await this.call('renameLegacy', 'functions', inputName, callback);
}
async function $95c7e736a22d0690$export$97753adb9ac72312(inputName = 'new-key', callback = ()=>null) {
    return await this.call('renameLegacy', 'files', inputName, callback);
}

});

parcelRegister("3wbNu", function(module, exports) {

$parcel$export(module.exports, "openDependency", () => $28fd82ebc4ecddfe$export$332885ef1f1a4198);
$parcel$export(module.exports, "upgradeDependency", () => $28fd82ebc4ecddfe$export$c90a9c98976a46c0);
$parcel$export(module.exports, "fetchLatestDependency", () => $28fd82ebc4ecddfe$export$4a04674e43e0aa90);
$parcel$export(module.exports, "rebuildDependency", () => $28fd82ebc4ecddfe$export$ff8177f875ebea7f);
$parcel$export(module.exports, "deleteDependency", () => $28fd82ebc4ecddfe$export$d68ff131ad0917e4);
function $28fd82ebc4ecddfe$export$332885ef1f1a4198() {
    window.open(`https://www.npmjs.com/package/${this.state.key}`, '_blank').focus();
}
function $28fd82ebc4ecddfe$export$c90a9c98976a46c0() {
    const { key: key, version: targetVersion, type: type } = this.state;
    window.fetch(`https://registry.npmjs.com/${key}`).then(async (res)=>{
        const { versions: v } = await res.json();
        const versions = Object.keys(v);
        const [targetMajor, targetMinor] = targetVersion.split('.').map(Number);
        const matchingPatches = versions.filter((version)=>{
            if (version.includes('-') || version.includes('+')) return false;
            const [major, minor] = version.split('.').map(Number);
            return major === targetMajor && minor === targetMinor;
        });
        const latest = matchingPatches.reduce((initial, current)=>{
            const [, , currentPatch] = current.split('.').map(Number);
            const [, , latestPatch] = initial.split('.').map(Number);
            return currentPatch > latestPatch ? current : latest;
        }, '');
        // TO DO: Adding message toasts to warn the status of the upgrade
        this.sdk.updateItem('dependencies', {
            key: key,
            value: latest || targetVersion,
            type: type,
            version: latest || targetVersion
        }, {
            message: 'Upgraded dependency'
        });
    });
}
function $28fd82ebc4ecddfe$export$4a04674e43e0aa90() {
    this.sdk.updateItem('dependencies', {
        key: this.state.key,
        value: 'latest',
        type: this.state.type,
        version: 'latest'
    }, {
        message: 'Fetched latest dependency'
    });
}
function $28fd82ebc4ecddfe$export$ff8177f875ebea7f() {
// TO DO: Waiting for a SDK function or something to rebuild some dependency if necessary
// https://symbo-ls.slack.com/archives/C084QG0K7A7/p1739831059737529
}
async function $28fd82ebc4ecddfe$export$d68ff131ad0917e4() {
    return this.call('removeItem', 'dependency', this.state.key);
}

});

parcelRegister("7llmN", function(module, exports) {

$parcel$export(module.exports, "shouldTypographyTagRender", () => $558b1189cb8b1d8c$export$8eadd5c2b7105c6c);
$parcel$export(module.exports, "createTypography", () => $558b1189cb8b1d8c$export$c3353a8513e5d9b);
function $558b1189cb8b1d8c$export$8eadd5c2b7105c6c() {
    const { value: value, type: type, isDefault: isDefault } = this.state;
    if (!value || !type || type !== 'ratio' && type !== 'range' && type !== 'base') return false;
    if (isDefault) return Boolean(value);
    const typography = this.getDesignSystem('typography');
    if (!Number.isNaN(Number(value))) return value !== typography[type];
    if (value.includes('px') && type === 'base') return Number(value.replace('px', '')) !== typography[type];
    if (value.includes(',') && type === 'range') return value !== typography[type]?.join(', ');
    return false;
}
async function $558b1189cb8b1d8c$export$c3353a8513e5d9b() {
    if (!this.node.elements) {
        console.warn('createTypography must be used inside a Form');
        return;
    }
    const cleanedKey = this.call('handleAtKey', this.node.elements.item('sidebar-new-item').value);
    const defaultValue = this.getDesignSystem('typography');
    await this.updateDesignSystem(`typography.${cleanedKey}`, {
        base: defaultValue.base ?? 16,
        ratio: defaultValue.ratio ?? 1.25,
        range: defaultValue.range ?? [
            -5,
            12
        ],
        subSequence: defaultValue.subSequence ?? true
    });
}

});

parcelRegister("j7FZS", function(module, exports) {

$parcel$export(module.exports, "handleShadowScrolling", () => $debf3f824acc685f$export$3b77c7fc7b55539f);
function $debf3f824acc685f$export$3b77c7fc7b55539f() {
    const { scrollLeft: scrollLeft, offsetWidth: offsetWidth, scrollWidth: scrollWidth } = this.node;
    const Parent = this.lookup('ScrollShadows');
    if (!Parent) {
        console.warn('ScrollShadowsChild must need a ScrollShadows as a parent');
        return;
    }
    if (scrollLeft === 0 && offsetWidth === scrollWidth) return Parent.update({
        ':after': {
            opacity: '0%'
        },
        ':before': {
            opacity: '0%'
        }
    });
    if (scrollLeft + offsetWidth === scrollWidth) return Parent.update({
        ':after': {
            opacity: '0%'
        }
    });
    Parent.update({
        ':after': {
            opacity: '100%'
        }
    });
    if (scrollLeft === 0) return Parent.update({
        ':before': {
            opacity: '0%'
        }
    });
    Parent.update({
        ':before': {
            opacity: '100%'
        }
    });
}

});

parcelRegister("3nv81", function(module, exports) {

$parcel$export(module.exports, "updateStateFromState", () => $275baa8872aab0a0$export$a6f102d11977d01f);
$parcel$export(module.exports, "updateState", () => $275baa8872aab0a0$export$4971331372cec95a);
$parcel$export(module.exports, "updateStateOnCanvas", () => $275baa8872aab0a0$export$10b5712bd38aa51a);
$parcel$export(module.exports, "removeState", () => $275baa8872aab0a0$export$50bca722ca75f12);
function $275baa8872aab0a0$export$a6f102d11977d01f() {
    const { key: key, value: value, code: code } = this.state;
    try {
        const res = this.call('updateState');
        this.test('Updating State in data', ()=>{
            return this.testCase('Value equals root state', 'isEqualObject', this.getState(key), value);
        });
        if (res?.success) {
            this.call('updateStateOnCanvas', value);
            this.test('Updating State on Canvas', ()=>{
                return this.testCase('Value equals root state', 'isEqualObject', this.getState(key), value) && this.testCase('Value equals Collection state', 'isEqualObject', this.getCanvasCollection().state[key], value) && this.testCase('Value equals Collection context', 'isEqualObject', this.getCanvasContext().state[key], value);
            });
        }
    } catch (e) {
        console.error(e);
    }
}
function $275baa8872aab0a0$export$4971331372cec95a() {
    const { key: key } = this.state;
    try {
        return this.sdk.updateItem('state', {
            ...this.state,
            key: key
        }, {
            message: `Updating state ${key}`
        });
    } catch (err) {
        this.state.update({
            err: err
        });
    }
}
function $275baa8872aab0a0$export$10b5712bd38aa51a(obj, type = 'state') {
    // window.requestAnimationFrame(() => {
    const Collection = this.getCanvasCollection();
    const { key: key } = this.state;
    if (Collection) {
        const ctx = Collection.context;
        ctx[type][key] = obj;
        Collection.state.replace({
            [key]: obj
        });
    } else this.error('Canvas Collection was not found');
    const { chosen: chosen } = this.getCanvasScope();
    chosen;
}
async function $275baa8872aab0a0$export$50bca722ca75f12() {
    return this.call('removeItem', 'state', this.state.key);
}

});

parcelRegister("9cSoa", function(module, exports) {

$parcel$export(module.exports, "shouldDisableRatioButton", () => $6b3f6c8a63296f48$export$d7734c76c04edfe);
$parcel$export(module.exports, "handleRatioButtons", () => $6b3f6c8a63296f48$export$c7a214c433bb65ed);
$parcel$export(module.exports, "handleBaseSizeButtons", () => $6b3f6c8a63296f48$export$84a2031c3dffe169);
$parcel$export(module.exports, "getBaseSizeOptions", () => $6b3f6c8a63296f48$export$c0cff8cdabf1d53);
$parcel$export(module.exports, "getRatioOptions", () => $6b3f6c8a63296f48$export$34b5688f80f8025b);
$parcel$export(module.exports, "renderRangeDropdownValue", () => $6b3f6c8a63296f48$export$37aa944133e84c53);
$parcel$export(module.exports, "generateRangeOptions", () => $6b3f6c8a63296f48$export$431ed294bd30b5b0);
function $6b3f6c8a63296f48$export$d7734c76c04edfe(mode = 1) {
    const sequenceEntries = this.call('getRatioOptions', true);
    const entryIndex = sequenceEntries.findIndex(([, value])=>value === this.state.value);
    return mode === -1 && entryIndex === 0 || mode === 1 && entryIndex === sequenceEntries.length - 1;
}
function $6b3f6c8a63296f48$export$c7a214c433bb65ed(mode = 1) {
    const sequenceEntries = this.call('getRatioOptions', true);
    const entryIndex = sequenceEntries.findIndex(([, value])=>value === this.state.value);
    if (mode === -1 && entryIndex === 0 || mode === 1 && entryIndex === sequenceEntries.length - 1) return;
    const [key, value] = sequenceEntries[entryIndex + 1 * Number(mode)];
    this.state.update({
        key: key,
        value: value
    });
}
function $6b3f6c8a63296f48$export$84a2031c3dffe169(mode = 1) {
    const options = this.call('getBaseSizeOptions');
    const entryIndex = options.findIndex(({ value: value })=>value === this.state.value);
    if (mode === -1 && entryIndex === 0 || mode === 1 && entryIndex === options.length - 1) return;
    const { key: key, value: value } = options[entryIndex + 1 * Number(mode)];
    this.state.update({
        key: key,
        value: value
    });
}
function $6b3f6c8a63296f48$export$c0cff8cdabf1d53() {
    return new Array(14).fill().map((c, index)=>{
        const value = index + 11;
        return {
            key: `1em ~ ${value}px`,
            value: value
        };
    });
}
function $6b3f6c8a63296f48$export$34b5688f80f8025b(entries = false) {
    const sequence = {
        'minor-second': 1.067,
        'major-second': 1.125,
        'minor-third': 1.2,
        'major-third': 1.25,
        'perfect-fourth': 1.333,
        'augmented-fourth': 1.414,
        'perfect-fifth': 1.5,
        'minor-sixth': 1.6,
        'golden-ratio': 1.618,
        'major-sixth': 1.667,
        'square-root-3': 1.732,
        'minor-seventh': 1.778,
        'major-seventh': 1.875,
        octave: 2,
        'square-root-5': 2.23,
        'major-tenth': 2.5,
        'major-eleventh': 2.667,
        'major-twelfth': 3,
        pi: 3.14,
        'double-octave': 4
    };
    if (entries) return Object.entries(sequence);
    return sequence;
}
function $6b3f6c8a63296f48$export$37aa944133e84c53(valueKey, index) {
    const position = valueKey === 'key' ? 0 : 1;
    const key = this.state.key?.[index];
    if (key) return valueKey === 'key' ? key.split(' ~')[position] : `~${key.split(' ~')[position]}`;
    if (!this.state.parent?.value) return null;
    const { base: base, ratio: ratio } = this.state.parent.value;
    const data = this.call('generateSequencePosition', {
        base: base,
        ratio: ratio
    }, this.state.value[index]);
    if (!data) return null;
    const [sequence] = Object.values(data.sequence);
    return valueKey === 'key' ? sequence[valueKey] : `~${sequence[valueKey]}em`;
}
function $6b3f6c8a63296f48$export$431ed294bd30b5b0(quantity, mode = 1) {
    if (!this.state.parent?.value) return [];
    return new Array(quantity).fill().map((c, index)=>{
        const value = index + quantity * mode;
        const { base: base, ratio: ratio } = this.state.parent.value;
        const data = this.call('generateSequencePosition', {
            base: base,
            ratio: ratio
        }, value);
        if (!data) return null;
        const [sequence] = Object.values(data.sequence);
        return {
            key: `${sequence.key} ~${sequence.scaling}em`,
            value: value
        };
    });
}

});

parcelRegister("4RUe0", function(module, exports) {

$parcel$export(module.exports, "createTextStyleStateFields", () => $38b7b9c80437c9ed$export$536c7061a89d298b);
$parcel$export(module.exports, "applyDemoStyles", () => $38b7b9c80437c9ed$export$540ac7da8799f626);
$parcel$export(module.exports, "extractLetterFromVar", () => $38b7b9c80437c9ed$export$5561a9c48ebf1e34);
function $38b7b9c80437c9ed$export$536c7061a89d298b(position) {
    const inheritFromState = this.parent.state.fields.at(position);
    const initValue = this.parent.state.value[inheritFromState.key];
    this.state.update({
        ...inheritFromState,
        value: initValue ?? inheritFromState.value ?? null
    });
}
function $38b7b9c80437c9ed$export$540ac7da8799f626() {
    const { fontWeight: fontWeight, letterWidth: letterWidth, italic: italic, lineHeight: lineHeight, fontFamily: fontFamily, letterSpacing: letterSpacing, fontSize: fontSize } = this.state.value;
    const variations = [
        '"wght"',
        '"wdth"'
    ];
    const variationValues = [
        fontWeight,
        letterWidth
    ];
    const fontFamilyValues = fontFamily && fontFamily !== 'inherit' ? this.getDesignSystem('font_family')[fontFamily].value.join(', ') : 'inherit';
    const textPreview = this.lookdown('Demo');
    textPreview?.setNodeStyles({
        fontVariationSettings: variationValues.map((v, i)=>{
            if (!v) return null;
            return `${variations[i]} ${v}`;
        }).filter((v)=>v).join(', '),
        fontFamily: fontFamilyValues,
        letterSpacing: `${letterSpacing}em`,
        fontStretch: `${letterWidth}em`,
        lineHeight: lineHeight,
        fontWeight: fontWeight,
        fontStyle: italic ? `oblique ${italic / 10}deg` : null
    });
    textPreview?.update({
        fontSize: fontSize
    });
}
function $38b7b9c80437c9ed$export$5561a9c48ebf1e34(input) {
    // Usando regex com grupo de captura nomeado para extrair a letra e o número
    const match = input?.match(/--font-size-(?<letter>[A-Z])(?<number>\d+)?\)/u);
    // Retorna a letra capturada se encontrada, caso contrário retorna null
    return match ? match.groups.letter + (match.groups.number || '') : null;
}

});

parcelRegister("2oK39", function(module, exports) {

$parcel$export(module.exports, "addKeyboardShortcutEvents", () => $1bf18b2ed154eaf6$export$eb5097ef736cb973);

var $3IV5G = parcelRequire("3IV5G");

var $7sAM5 = parcelRequire("7sAM5");

function $1bf18b2ed154eaf6$export$eb5097ef736cb973() {
    const frameWindow = this.node.contentWindow;
    const frameDocument = frameWindow.document;
    const Canvas = this.parent;
    const canvasScope = frameWindow.scope = this.parent.scope;
    canvasScope.positions ||= {};
    canvasScope.window = frameWindow;
    // The full smbls namespace is only a debug/bridge global inside the editor
    // iframe — assign it lazily so this file (eager via the shared barrel)
    // doesn't drag the framework bundle into the eager chunk. index.js warms
    // this chunk at entry, so the assignment resolves ~immediately.
    Promise.resolve((parcelRequire("eY4Ct"))).then((m)=>{
        frameWindow._smbls = m;
    }).catch(()=>{});
    frameWindow.Canvas = Canvas;
    frameWindow.CanvasData = Canvas.scope;
    frameWindow.rerenderGrid = (0, $7sAM5.rerenderGrid);
    frameWindow.isActiveNodeSelectable = (doc, frameDoc)=>this.call('isActiveNodeSelectable', doc, frameDoc);
    frameWindow.platformState = this.getRootState();
    frameWindow.router = this.router;
    frameWindow.intersectionObserver = (0, $3IV5G.intersectionObserver)(frameWindow);
    const escapeKey = (event)=>{
        if (event.key === 'Escape' || event.key === 'Esc') {
            this.setCanvasMode(false);
            this.activateContext(null);
            this.call('setFloatingPanel');
            // Code to execute when ESC is pressed
            if (this.getRootState('activeModal')) this.closeModal();
            else if (canvasScope.docs) this.closeWindow('docs');
            else if (canvasScope.chosen) this.activateChosen(null);
            else if (!this.isCanvasMode('defaultMode')) this.setCanvasMode('defaultMode');
            else if (canvasScope.componentEditor) this.closeWindow('componentEditor');
            else if (frameWindow.scope.selected) this.activateSelected(null);
            else if (canvasScope.explorer) this.closeWindow('explorer');
        }
    };
    const enterKey = (event)=>{
        // Code to execute when ENTER is pressed
        if (event.key === 'Enter' || event.keyCode === 13) {
            const isSelectable = this.call('isActiveNodeSelectable', document, frameDocument);
            if (!isSelectable) {
                if (canvasScope.selected) this.activateChosen(canvasScope.selected);
                else if (canvasScope.hovered && this.getRootState('isModifierPressed')) {
                    this.activateSelected(canvasScope.hovered);
                    this.activateChosen(canvasScope.hovered);
                } else if (canvasScope.hovered) this.activateChosen(canvasScope.hovered);
                setTimeout(()=>{
                    this.setWindow('componentEditor', 'code');
                }, 150);
            }
        }
    };
    const spaceKey = (event)=>{
        // Code to execute when SPACE is pressed
        if (event.key === ' ' || event.keyCode === 32) {
            const isSelectable = this.call('isActiveNodeSelectable', document, frameDocument);
            if (!isSelectable) {
                if (canvasScope.chosen) this.activateChosen(null);
                else if (canvasScope.hovered && this.getRootState('isShiftPressed')) this.activateChosen(canvasScope.hovered);
                else if (canvasScope.selected) this.activateChosen(canvasScope.selected);
                else {
                    const canvasMode = this.getCanvasMode();
                    this.setCanvasMode(canvasMode ? canvasMode === 'panningMode' ? 'defaultMode' : canvasMode === 'defaultMode' ? 'inspectMode' : 'panningMode' : 'panningMode');
                }
            }
        }
    };
    const deleteKey = async (event)=>{
        // Code to execute when DELETE is pressed
        const isDelete = event.key === 'Delete' || event.keyCode === 46;
        const isBackspace = event.key === 'Backspace' || event.keyCode === 8;
        const isSelectable = this.call('isActiveNodeSelectable', document, frameDocument);
        if (!canvasScope.selected || isSelectable || !(isDelete || isBackspace)) return;
        const { activeLayer: activeLayer } = canvasScope;
        if (activeLayer) return await this.call('handleActiveLayerDeletion', activeLayer);
        else if (!canvasScope.chosen) return await this.call('handleComponentDeletion');
    };
    const sKey = (event)=>{
        // Code to execute when S is pressed
        if (event.key === 'S' || event.keyCode === 83) {
            const isSelectable = this.call('isActiveNodeSelectable', document, frameDocument);
            if (!isSelectable) {
                this.syncCanvas();
                this.toggleWindow('explorer');
            }
        }
    };
    const eKey = (event)=>{
        // Code to execute when E is pressed
        if (event.key === 'E' || event.keyCode === 69) {
            const isSelectable = this.call('isActiveNodeSelectable', document, frameDocument);
            if (!isSelectable) {
                const isCode = this.getWindow('componentEditor') === 'code';
                this.setWindow('componentEditor', isCode ? null : 'code');
            }
        }
    };
    const undoRedoKey = (event)=>{
        // Code to execute when Ctrl/Cmd + Z (undo) or Ctrl/Cmd + Shift + Z (redo) is pressed
        const isZKey = event.key?.toLowerCase() === 'z';
        const isModifierPressed = event.ctrlKey || event.metaKey;
        if (isModifierPressed && isZKey) event.preventDefault();
    };
    const toggleKeyEvents = (event)=>{
        const isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
        const isShiftKey = event.key === 'Shift';
        const isAltKey = event.key === 'Alt';
        const isModifierKey = isMac ? event.key === 'Meta' || event.code === 'MetaLeft' || event.code === 'MetaRight' : event.key === 'Control' || event.code === 'ControlLeft' || event.code === 'ControlRight';
        if (event.type === 'keydown') {
            if (isShiftKey) this.getRootState().isShiftPressed = true;
            if (isAltKey) this.getRootState().isAltPressed = true;
            if (isModifierKey) this.getRootState().isModifierPressed = true;
        } else if (event.type === 'keyup') {
            if (isShiftKey) this.getRootState().isShiftPressed = false;
            if (isAltKey) this.getRootState().isAltPressed = false;
            if (isModifierKey) this.getRootState().isModifierPressed = false;
        }
        const isShiftPressed = this.getRootState('isShiftPressed');
        const isAltPressed = this.getRootState('isAltPressed');
        const isModifierPressed = this.getRootState('isModifierPressed');
        const isDefault = this.isCanvasMode('defaultMode');
        if (isModifierPressed) this.setCanvasMode('inspectMode');
        else if (isShiftPressed) this.setCanvasMode('panningMode');
        else this.setCanvasMode('defaultMode');
    };
    // The shell's overlay reader (shared functions/shellOverlayOpen.js): a layer
    // above the canvas — a dialog, a menu, the assistant's main thread over the
    // page — owns the keys, and the editor stands down (Delete and undo would
    // act on a canvas nobody sees). The modifier RELEASE still reaches it.
    const overlayUp = ()=>typeof this.context?.functions?.shellOverlayOpen === 'function' && !!this.call('shellOverlayOpen');
    const keyDownShortcuts = (event)=>{
        if (overlayUp()) return;
        const t = setTimeout(()=>{
            toggleKeyEvents(event);
            clearTimeout(t);
        }, 1);
    };
    frameDocument.addEventListener('keydown', keyDownShortcuts);
    document.addEventListener('keydown', keyDownShortcuts);
    // Listen for keyup event to detect when keys are released
    const keyUpShortcuts = async (event)=>{
        if (document.activeElement.tagName === 'TEXTAREA' || document.activeElement.tagName === 'INPUT' || document.activeElement.contentEditable === 'true' || frameDocument.activeElement.tagName === 'TEXTAREA' || frameDocument.activeElement.tagName === 'INPUT' || frameDocument.activeElement.contentEditable === 'true') {
            // Still need to release modifier keys even in input fields
            toggleKeyEvents(event);
            return;
        }
        if (overlayUp()) {
            toggleKeyEvents(event);
            return;
        }
        escapeKey(event);
        enterKey(event);
        spaceKey(event);
        sKey(event);
        eKey(event);
        toggleKeyEvents(event);
        await deleteKey(event);
        await undoRedoKey(event);
    };
    frameDocument.addEventListener('keyup', keyUpShortcuts);
    document.addEventListener('keyup', keyUpShortcuts);
    const onCopy = ()=>{
        if (!canvasScope.selected || this.call('isActiveNodeSelectable', document, frameDocument)) return;
        const code = this.call('getCodeToCopy');
        const str = this.call('stringifyCode', code);
        this.call('copyStringToClipboard', str);
    // const encoded = _smbls.encodeNewlines(str)
    // this.call('copyStringToClipboard', encoded)
    };
    frameDocument.addEventListener('copy', onCopy);
    document.addEventListener('copy', onCopy);
    const onPaste = async (ev)=>{
        try {
            if (this.call('isActiveNodeSelectable', document, frameDocument)) return;
            // clipboardData must be read synchronously during the event — keep it
            // before any await (parseStringCode is async since the bundle-split).
            const clipboardData = ev.clipboardData.getData('text');
            const parts = clipboardData.split('// COMPONENT SEPARATOR');
            const parsedParts = await Promise.all(parts.map(async (part)=>{
                // USER-CODE-ORIGIN review N4: pasted code stays AS PARSED (function
                // fields are source strings, the stored form) — the shell never
                // evaluates clipboard code; the opaque frame revives it.
                return await this.parseStringCode(part) || {};
            }));
            const codes = parsedParts.filter((code)=>{
                const { metadata: metadata, ...copiedValue } = code;
                if (metadata !== 'copiedFromSymbols' || !copiedValue.key) return false;
                const { key: key, layerCode: layerCode } = copiedValue;
                const isComponent = Boolean(copiedValue.value && copiedValue.settings?.gridOptions);
                console.log(layerCode, isComponent);
                if (!layerCode && !isComponent) return false;
                // const isComponentWithSameKey = key === this.getSelectedKey()
                if (canvasScope.selected && layerCode) ;
                else if (isComponent) return true;
                return false;
            });
            console.log(codes);
            this.call('createMultipleItems', codes // .map(({ ...value }) => value)
            );
        } catch (error) {
            this.error(error);
            this.call('openNotification', {
                type: 'error',
                title: this.call('polyglot', 'shell.clipboard.pasteFailed.title'),
                message: error
            });
        }
    };
    frameDocument.addEventListener('paste', onPaste);
    document.addEventListener('paste', onPaste);
}

});

parcelRegister("k8EDy", function(module, exports) {

$parcel$export(module.exports, "openAutocompleteDropdown", () => $ea9413ab02a91e0f$export$31bbea8c48da2ca1);
$parcel$export(module.exports, "closeAutocompleteDropdown", () => $ea9413ab02a91e0f$export$c5a6b4c2cbc0a5d4);
$parcel$export(module.exports, "moveThroughList", () => $ea9413ab02a91e0f$export$d31396b02184caf6);
// Property-autocomplete dropdown behaviour.
//
// `@symbo.ls/ui` does NOT exist in this checkout: `node_modules/@symbo.ls/ui`
// is a symlink to `platform/uikit/ui`, a directory that was never checked out
// (dangling since Jan 2026). Excluding this module from the barrel was not
// enough — a Symbols project discovers `functions/` BY DIRECTORY, so the
// bundler compiles every file here whether the barrel exports it or not, and
// the unresolvable import failed the entire `workspace` dev build:
//
//   @parcel/core: Failed to resolve '@symbo.ls/ui/Autocomplete/props'
//
// Parcel then serves a build-error page at HTTP 200 while the browser keeps
// running the last good bundle, so the app looks alive and merely stale —
// which is how this survived unnoticed.
//
// `autocompletePropKey` and `prefillValue` were the only consumers of
// `props` / `propsKeys` / `getPropertyValues`. With that package absent they
// could not run at all — they threw at module load before they could be
// called. They are removed rather than left as a build-breaking stub; restore
// them together with a real source for the property catalogue. The three
// functions below never needed it and keep working.
//
// The siblings that never touched the import live in ./prefill-values.js.
function $ea9413ab02a91e0f$export$31bbea8c48da2ca1() {
    if (this.state.dropdown) return;
    this.state.replace({
        dropdown: true
    });
}
function $ea9413ab02a91e0f$export$c5a6b4c2cbc0a5d4() {
    this.state.replace({
        dropdown: false
    });
}
function $ea9413ab02a91e0f$export$d31396b02184caf6(isDown) {
    if (!this.state.dropdown) return;
    const { list: list, prefill: prefill } = this.state;
    let nextIndex = list.indexOf(prefill);
    if (isDown) nextIndex = nextIndex + 1 > list.length - 1 ? 0 : nextIndex + 1;
    else nextIndex = nextIndex - 1 < 0 ? list.length - 1 : nextIndex - 1;
    this.state.update({
        prefill: list[nextIndex]
    });
}

});

parcelRegister("6h2OJ", function(module, exports) {

$parcel$export(module.exports, "sequenceNameToDSItem", () => $49168414c083f8e6$export$99c451dca0070c97);
$parcel$export(module.exports, "prefillSequenceValue", () => $49168414c083f8e6$export$c3250411be2002ea);
$parcel$export(module.exports, "prefillColorValue", () => $49168414c083f8e6$export$9968ba97976f32d4);
$parcel$export(module.exports, "prefillThemeValue", () => $49168414c083f8e6$export$a33e3e41d7f4c063);
$parcel$export(module.exports, "prefillFunctionValue", () => $49168414c083f8e6$export$e52e69690e2265cf);
$parcel$export(module.exports, "prefillComponentValue", () => $49168414c083f8e6$export$986afb9a8154458e);
$parcel$export(module.exports, "setPrefillValues", () => $49168414c083f8e6$export$2368b54e1e472b00);
// Split out of prefill-layers.js (2026-08-06 barrel-omission fix). The
// property-autocomplete dropdown functions that stayed in prefill-layers.js
// (openAutocompleteDropdown, closeAutocompleteDropdown, autocompletePropKey,
// prefillValue, moveThroughList) statically import `props`/`propsKeys`/
// `getPropertyValues` from '@symbo.ls/ui/Autocomplete/props' — a package
// that does not exist on disk in this checkout (its node_modules symlink
// points at a `platform/uikit/ui` directory that was never checked out
// here), so that whole module can't load. These six functions never
// touched that import — they only reach each other through `this.call`
// — so they're extracted here to unblock `el.call('prefillColorValue' |
// 'prefillComponentValue' | 'prefillFunctionValue' | 'prefillSequenceValue'
// | 'setPrefillValues' | 'sequenceNameToDSItem' | 'prefillThemeValue', …)`
// without needing the missing package. See prefill-layers.js for the
// still-blocked half.
function $49168414c083f8e6$export$99c451dca0070c97(name) {
    if (name === 'fontSize') return this.getDesignSystem('typography');
    if (name === 'animationDuration') return this.getDesignSystem('timing');
    return this.getDesignSystem('spacing');
}
function $49168414c083f8e6$export$c3250411be2002ea(sequenceName) {
    const dsItem = this.call('sequenceNameToDSItem', sequenceName);
    const { sequence: sequence } = this.call('generateSequence', {
        base: dsItem.base,
        ratio: dsItem.ratio,
        range: dsItem.range || [
            -5,
            12
        ],
        subSequence: true,
        scales: {},
        sequence: {},
        vars: {}
    });
    if (!sequence) return;
    this.call('setPrefillValues', Object.keys(sequence));
}
function $49168414c083f8e6$export$9968ba97976f32d4() {
    const colors = Object.keys(this.getDesignSystem('color'));
    const gradients = Object.keys(this.getDesignSystem('gradient'));
    const colorList = [
        ...colors,
        ...gradients
    ].sort();
    this.call('setPrefillValues', colorList);
}
function $49168414c083f8e6$export$a33e3e41d7f4c063() {
    const themes = Object.keys(this.getDesignSystem('theme'));
    this.call('setPrefillValues', themes);
}
function $49168414c083f8e6$export$e52e69690e2265cf() {
    const functions = Object.keys(this.getRootState('functions'));
    const methods = Object.keys(this.getRootState('methods'));
    const functionList = [
        ...functions,
        ...methods
    ].sort();
    this.call('setPrefillValues', functionList);
}
function $49168414c083f8e6$export$986afb9a8154458e() {
    const components = Object.keys(this.getRootState('components'));
    const smblsComponents = Object.keys(this.getRootContext('components')).filter((key)=>key.startsWith('smbls.')).map((key)=>key.replace('smbls.', ''));
    const componentList = [
        ...components,
        ...smblsComponents
    ].sort();
    this.call('setPrefillValues', componentList);
}
function $49168414c083f8e6$export$2368b54e1e472b00(values, withFunctionFallback) {
    const value = this.node.textContent;
    const regex = new RegExp(`^${value}`, 'iug');
    const matchedValues = value ? values?.filter((key)=>regex.test(key)) : [];
    if (!matchedValues.length && withFunctionFallback) {
        // Was a bare `prefillFunctionValue()` call — invoked without `this`,
        // which breaks prefillFunctionValue's own `this.getRootState(…)` reads.
        // Sibling functions reach each other via `this.call`, never a raw
        // reference (same rule as project-file imports).
        this.call('prefillFunctionValue');
        return;
    }
    this.state.replace({
        list: matchedValues,
        prefill: matchedValues[0] ?? ''
    });
}

});

parcelRegister("cD3Av", function(module, exports) {

$parcel$export(module.exports, "isVisible", () => $931be909b58a15bf$export$795910f5f15a9633);
function $931be909b58a15bf$export$795910f5f15a9633(element) {
    const elem = element || this.node;
    if (!elem.nodeType || elem.nodeType !== 1) throw Error('element is not a node element');
    const style = window.getComputedStyle(elem);
    if (style.display === 'none') return false;
    if (style.visibility !== 'visible') return false;
    if (style.opacity < 0.1) return false;
    if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height + elem.getBoundingClientRect().width === 0) return false;
    const elemCenter = {
        x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
        y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
    };
    if (elemCenter.x < 0) return false;
    if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
    if (elemCenter.y < 0) return false;
    if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
    let pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);
    do {
        if (pointContainer === elem) return true;
    }while (pointContainer = pointContainer.parentNode);
    return false;
}

});

parcelRegister("eYIZl", function(module, exports) {

$parcel$export(module.exports, "updateMediaQueryState", () => $ae79911309a89922$export$48185540cc0d259b);
function $ae79911309a89922$export$48185540cc0d259b() {
    // FA204 / frank trap — moved from module scope into this file's sole
    // export (self-contained local, pure/stateless helper — see longPress.js).
    function validateCssUnitValue(value) {
        const CssUnitTypes = [
            'em',
            'ex',
            'ch',
            'rem',
            'vw',
            'vh',
            'vmin',
            'vmax',
            '%',
            'cm',
            'mm',
            'in',
            'px',
            'pt',
            'pc'
        ];
        const regexps = CssUnitTypes.map((unit)=>new RegExp(`^[0-9]+${unit}$|^[0-9]+\\.[0-9]+${unit}$`, 'i'));
        const isValid = regexps.find((regexp)=>regexp.test(value)) !== undefined;
        return isValid;
    }
    if (!this.data) this.data = {};
    const { timeout: timeout } = this.data;
    const el = this;
    const floatingPanelState = el.state.parent;
    // float panel state is wiped out => float panel is not open => no need to update state
    if (Object.keys(floatingPanelState).length === 0) return;
    if (timeout) clearTimeout(timeout);
    this.data.timeout = setTimeout(async ()=>{
        const { value: value } = floatingPanelState;
        // check if input is valid
        const nodeValue = el.node.value;
        // only number -> add px at the end
        if (!isNaN(nodeValue)) el.node.value = `${nodeValue}px`;
        if (!validateCssUnitValue(el.node.value)) {
            console.warn('Invalid CSS unit value');
            el.node.value = el.state.value;
            return;
        }
        el.state.quietUpdate({
            value: el.node.value
        });
        let newFloatingPanelValue;
        if (!value) // add: float panel state value is null
        newFloatingPanelValue = `(${el.state.key}: ${el.node.value})`;
        else {
            // update: find the update position to replace the state
            const values = value.split(', ');
            const { position: position } = el.state;
            values[position] = `(${el.state.key}: ${el.node.value})`;
            newFloatingPanelValue = values.join(', ');
        }
        floatingPanelState.quietUpdate({
            value: newFloatingPanelValue
        });
        if (timeout) clearTimeout(timeout);
    }, 1000);
}

});

parcelRegister("bRqtF", function(module, exports) {

$parcel$export(module.exports, "MEDIATYPES", () => $8a292ed7d7b4adf2$export$d2b3673b7dbefbd8);
const $8a292ed7d7b4adf2$export$d2b3673b7dbefbd8 = ()=>[
        {
            text: 'min-width',
            value: 'minWidth'
        },
        {
            text: 'max-width',
            value: 'maxWidth'
        },
        {
            text: 'min-height',
            value: 'minHeight'
        },
        {
            text: 'max-height',
            value: 'maxHeight'
        },
        {
            text: 'exact',
            value: 'exact'
        }
    ];

});

parcelRegister("bzQ3E", function(module, exports) {

$parcel$export(module.exports, "enterCanvas", () => $86db583623115fbd$export$b128cebaf7658ce4);
$parcel$export(module.exports, "leaveCanvas", () => $86db583623115fbd$export$8d88abff2ce15a72);
$parcel$export(module.exports, "switchCanvasProject", () => $86db583623115fbd$export$8510d465f1c7ebb);
// Canvas page navigation helpers for CollabService connection management
// From '@symbo.ls/utils', not the 'smbls' barrel — keeps the framework bundle
// out of the eager chunk (same fix as workspace/functions/extensionDesignSystem.js).
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");
async function $86db583623115fbd$export$b128cebaf7658ce4() {
    const { projectId: projectId, branch: branch = 'main', pro: pro } = this.getRootState();
    if (!this.sdk) {
        if ((0, $dSdIt.isNotProduction)()) console.warn('[enterCanvas] SDK not available');
        return;
    }
    if (!projectId) {
        if ((0, $dSdIt.isNotProduction)()) console.warn('[enterCanvas] Missing projectId, skipping connection');
        return;
    }
    try {
        // `isConnected` is NOT in the shell's `_SYNC_PASS` allowlist, so it goes
        // through the init gate and returns a Promise. Unawaited, `!promise` is
        // always false — this guard skipped the connect() below every single time,
        // so entering the canvas never established the collab connection.
        if (!await this.sdk.isConnected()) {
            await this.sdk.connect({
                projectId: projectId,
                branch: branch,
                pro: pro
            });
            console.log('[enterCanvas] Connected to collaboration for project:', projectId);
        }
    } catch (error) {
        if ((0, $dSdIt.isNotProduction)()) console.error('[enterCanvas] Failed to connect to collaboration:', error);
    }
}
async function $86db583623115fbd$export$8d88abff2ce15a72() {
    if (!this.sdk || !await this.sdk.isConnected()) return;
    try {
        await this.sdk.disconnect();
        if ((0, $dSdIt.isNotProduction)()) console.log('[leaveCanvas] Disconnected from collaboration');
    } catch (error) {
        console.error('[leaveCanvas] Error disconnecting from collaboration:', error);
    }
}
async function $86db583623115fbd$export$8510d465f1c7ebb(projectData) {
    const { projectId: projectId, branch: branch = 'main', pro: pro } = projectData || {};
    if (!this.sdk?.getService) {
        if ((0, $dSdIt.isNotProduction)()) console.warn('[switchCanvasProject] SDK not available');
        return;
    }
    try {
        if (!projectId) throw new Error('projectId is required to switch collaboration room');
        // `getService` is init-gated too, so this must be awaited — unawaited it
        // resolved to a Promise, `collabService?.getConnectionInfo` was undefined,
        // and the whole "already in the right room?" check below was dead code
        // that reconnected on every switch.
        const collabService = await this.sdk.getService('collab');
        const normalizedBranch = branch || 'main';
        const desiredLiveFlag = Boolean(pro);
        if (collabService?.getConnectionInfo) {
            const connectionInfo = collabService.getConnectionInfo();
            const { connected: connected = false, connecting: connecting = false, projectId: currentProjectId, branch: currentBranch, live: currentLive } = connectionInfo || {};
            const matchesProject = currentProjectId === projectId;
            const matchesBranch = (currentBranch || 'main') === normalizedBranch;
            const matchesLive = Boolean(currentLive) === desiredLiveFlag;
            if ((connected || connecting) && matchesProject && matchesBranch && matchesLive) {
                if ((0, $dSdIt.isNotProduction)()) console.log('[switchCanvasProject] Already connected to requested collaboration room; skipping reconnect');
                return;
            }
        }
        // Connect to new project's collaboration room
        await this.sdk.connect({
            projectId: projectId,
            branch: normalizedBranch,
            pro: pro
        });
    } catch (error) {
        console.error('[switchCanvasProject] Failed to switch collaboration room:', error);
    }
}

});

parcelRegister("cgtjK", function(module, exports) {

$parcel$export(module.exports, "handleSBMouseDown", () => $8eddb885c737e63d$export$7dd31147432f4d28);
$parcel$export(module.exports, "handleHueMouseDown", () => $8eddb885c737e63d$export$d7854c22ae65bc2e);
$parcel$export(module.exports, "updateSBFromEvent", () => $8eddb885c737e63d$export$8fe649e59545fd85);
$parcel$export(module.exports, "updateHueFromEvent", () => $8eddb885c737e63d$export$227e3b352766cd38);
$parcel$export(module.exports, "hsbToRgb", () => $8eddb885c737e63d$export$6c9c93e2ff982b3b);
$parcel$export(module.exports, "rgbToHsb", () => $8eddb885c737e63d$export$cbdf8703a5855945);
$parcel$export(module.exports, "rgbToHex", () => $8eddb885c737e63d$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $8eddb885c737e63d$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHsb", () => $8eddb885c737e63d$export$8a52e3f13a462b8);
$parcel$export(module.exports, "hsbToHex", () => $8eddb885c737e63d$export$fec042be06d2e393);
$parcel$export(module.exports, "hsbToHsl", () => $8eddb885c737e63d$export$7badd6b38be6ae00);
$parcel$export(module.exports, "hslToHsb", () => $8eddb885c737e63d$export$2970e1a20d040f75);
$parcel$export(module.exports, "isValidColor", () => $8eddb885c737e63d$export$35fa9d266cdb6f09);
$parcel$export(module.exports, "isEyeDropperSupported", () => $8eddb885c737e63d$export$c58b654089cdea5a);
$parcel$export(module.exports, "handleEyeDropper", () => $8eddb885c737e63d$export$ff47fae1e2a80c25);
$parcel$export(module.exports, "adjustShade", () => $8eddb885c737e63d$export$19e19be604a8d03d);
$parcel$export(module.exports, "deepCompareObjects", () => $8eddb885c737e63d$export$76775c78e51bf19f);
/**
 * Handles the saturation and brightness area mouse down event.
 *
 * @param {MouseEvent} e - The mouse event.
 */ function $8eddb885c737e63d$export$7dd31147432f4d28(e) {
    e.preventDefault();
    const handleMouseMove = (e)=>this.call('updateSBFromEvent', e);
    const handleMouseUp = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
}
function $8eddb885c737e63d$export$d7854c22ae65bc2e(e) {
    e.preventDefault();
    const handleMouseMove = (e)=>this.call('updateHueFromEvent', e);
    const handleMouseUp = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
}
function $8eddb885c737e63d$export$8fe649e59545fd85(e) {
    const rect = this.node.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    const y = Math.max(0, Math.min(rect.height, e.clientY - rect.top));
    const saturation = x / rect.width;
    const brightness = 1 - y / rect.height;
    this.state.update({
        saturation: saturation,
        brightness: brightness
    });
}
function $8eddb885c737e63d$export$227e3b352766cd38(e) {
    const rect = this.node.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    const hue = x / rect.width * 360;
    this.state.update({
        hue: hue
    });
}
function $8eddb885c737e63d$export$6c9c93e2ff982b3b(h, s, b) {
    h = h / 360;
    const i = Math.floor(h * 6);
    const f = h * 6 - i;
    const p = b * (1 - s);
    const q = b * (1 - f * s);
    const t = b * (1 - (1 - f) * s);
    let r, g, blue;
    switch(i % 6){
        case 0:
            r = b;
            g = t;
            blue = p;
            break;
        case 1:
            r = q;
            g = b;
            blue = p;
            break;
        case 2:
            r = p;
            g = b;
            blue = t;
            break;
        case 3:
            r = p;
            g = q;
            blue = b;
            break;
        case 4:
            r = t;
            g = p;
            blue = b;
            break;
        case 5:
            r = b;
            g = p;
            blue = q;
            break;
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(blue * 255)
    };
}
function $8eddb885c737e63d$export$cbdf8703a5855945(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const diff = max - min;
    let h = 0;
    let s = max === 0 ? 0 : diff / max;
    let brightness = max;
    if (diff !== 0) switch(max){
        case r:
            h = ((g - b) / diff + (g < b ? 6 : 0)) / 6;
            break;
        case g:
            h = ((b - r) / diff + 2) / 6;
            break;
        case b:
            h = ((r - g) / diff + 4) / 6;
            break;
    }
    return {
        h: h * 360,
        s: s,
        b: brightness
    };
}
function $8eddb885c737e63d$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}
function $8eddb885c737e63d$export$5a544e13ad4e1fa5(hex) {
    // Remove # if present
    hex = hex.replace('#', '');
    // Handle 3-digit hex (expand to 6-digit)
    if (hex.length === 3) hex = hex.split('').map((char)=>char + char).join('');
    // Handle 6-digit hex
    if (hex.length === 6) {
        const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    return null;
}
function $8eddb885c737e63d$export$8a52e3f13a462b8(hex) {
    // FA204 / frank trap — self-contained inline copies of hexToRgb/rgbToHsb
    // (a bare sibling-export read is exactly as unresolvable post-frank as a
    // module-local read); the exports above stay for anyone importing them
    // directly.
    const toRgb = (h0)=>{
        h0 = h0.replace('#', '');
        if (h0.length === 3) h0 = h0.split('').map((char)=>char + char).join('');
        if (h0.length === 6) {
            const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(h0);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }
        return null;
    };
    const toHsb = (r, g, b)=>{
        r /= 255;
        g /= 255;
        b /= 255;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const diff = max - min;
        let h = 0;
        const s = max === 0 ? 0 : diff / max;
        const brightness = max;
        if (diff !== 0) switch(max){
            case r:
                h = ((g - b) / diff + (g < b ? 6 : 0)) / 6;
                break;
            case g:
                h = ((b - r) / diff + 2) / 6;
                break;
            case b:
                h = ((r - g) / diff + 4) / 6;
                break;
        }
        return {
            h: h * 360,
            s: s,
            b: brightness
        };
    };
    // First convert hex to RGB
    const rgb = toRgb(hex);
    if (!rgb) return null;
    // Then convert RGB to HSB
    return toHsb(rgb.r, rgb.g, rgb.b);
}
function $8eddb885c737e63d$export$fec042be06d2e393(h, s, b) {
    // FA204 / frank trap — self-contained inline copies of hsbToRgb/rgbToHex
    // (a bare sibling-export read is exactly as unresolvable post-frank as a
    // module-local read); the exports above stay for anyone importing them
    // directly.
    const toRgb = (h0, s0, b0)=>{
        h0 = h0 / 360;
        const i = Math.floor(h0 * 6);
        const f = h0 * 6 - i;
        const p = b0 * (1 - s0);
        const q = b0 * (1 - f * s0);
        const t = b0 * (1 - (1 - f) * s0);
        let r, g, blue;
        switch(i % 6){
            case 0:
                r = b0;
                g = t;
                blue = p;
                break;
            case 1:
                r = q;
                g = b0;
                blue = p;
                break;
            case 2:
                r = p;
                g = b0;
                blue = t;
                break;
            case 3:
                r = p;
                g = q;
                blue = b0;
                break;
            case 4:
                r = t;
                g = p;
                blue = b0;
                break;
            case 5:
                r = b0;
                g = p;
                blue = q;
                break;
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(blue * 255)
        };
    };
    const toHex = (r, g, b0)=>'#' + (16777216 + (r << 16) + (g << 8) + b0).toString(16).slice(1).toUpperCase();
    // First convert HSB to RGB
    const rgb = toRgb(h, s, b);
    if (!rgb) return null;
    // Then convert RGB to hex
    return toHex(rgb.r, rgb.g, rgb.b);
}
function $8eddb885c737e63d$export$7badd6b38be6ae00(h, s, b) {
    const l = b * (2 - s) / 2;
    const sl = l !== 0 && l !== 1 ? (b - l) / Math.min(l, 1 - l) : 0;
    return {
        h: h,
        s: sl * 100,
        l: l * 100
    };
}
function $8eddb885c737e63d$export$2970e1a20d040f75(h, s, l) {
    // Convert percentage values to decimals (0-1)
    const sDecimal = s / 100;
    const lDecimal = l / 100;
    const b = lDecimal + sDecimal * Math.min(lDecimal, 1 - lDecimal);
    const sb = b === 0 ? 0 : 2 * (1 - lDecimal / b);
    return {
        h: h,
        s: sb,
        b: b
    };
}
function $8eddb885c737e63d$export$35fa9d266cdb6f09(value) {
    const isValidHex = (hex)=>/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
    const isValidRgbNumber = (v)=>{
        if (typeof v !== 'string' && typeof v !== 'number') return false;
        const num = Number(v);
        return !isNaN(num) && Number.isInteger(num) && num >= 0 && num <= 255;
    };
    // Check if it's a valid hex color
    if (typeof value === 'string' && value.startsWith('#')) return isValidHex(value);
    // Check if it's a valid RGB number
    return isValidRgbNumber(value);
}
function $8eddb885c737e63d$export$c58b654089cdea5a() {
    return 'EyeDropper' in window;
}
async function $8eddb885c737e63d$export$ff47fae1e2a80c25() {
    // FA204 / frank trap — self-contained inline copy of hexToHsb (a bare
    // sibling-export read is exactly as unresolvable post-frank as a
    // module-local read); the export above stays for anyone importing it
    // directly.
    const toHexToHsb = (hex)=>{
        const toRgb = (h0)=>{
            h0 = h0.replace('#', '');
            if (h0.length === 3) h0 = h0.split('').map((char)=>char + char).join('');
            if (h0.length === 6) {
                const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(h0);
                return result ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16)
                } : null;
            }
            return null;
        };
        const toHsb = (r, g, b)=>{
            r /= 255;
            g /= 255;
            b /= 255;
            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            const diff = max - min;
            let h = 0;
            const s = max === 0 ? 0 : diff / max;
            const brightness = max;
            if (diff !== 0) switch(max){
                case r:
                    h = ((g - b) / diff + (g < b ? 6 : 0)) / 6;
                    break;
                case g:
                    h = ((b - r) / diff + 2) / 6;
                    break;
                case b:
                    h = ((r - g) / diff + 4) / 6;
                    break;
            }
            return {
                h: h * 360,
                s: s,
                b: brightness
            };
        };
        const rgb = toRgb(hex);
        if (!rgb) return null;
        return toHsb(rgb.r, rgb.g, rgb.b);
    };
    if (!('EyeDropper' in window)) {
        alert('Eye dropper is not supported in this browser. Please use Chrome 95+ or Edge 95+.');
        return null;
    }
    try {
        const eyeDropper = new EyeDropper();
        const result = await eyeDropper.open();
        if (result && result.sRGBHex) // Convert hex to HSB
        return toHexToHsb(result.sRGBHex);
    } catch (error) {
        if (error.name !== 'AbortError') alert('Error using eye dropper: ' + error.message);
        return null;
    }
}
function $8eddb885c737e63d$export$19e19be604a8d03d(rgb, shade) {
    const shadeString = shade > 0 ? '+' + shade : shade;
    const rgbString = this.call('getRgbTone', [
        rgb.r,
        rgb.g,
        rgb.b,
        1
    ], shadeString);
    const newRgb = rgbString.split(', ');
    return {
        r: newRgb[0],
        g: newRgb[1],
        b: newRgb[2]
    };
}
function $8eddb885c737e63d$export$76775c78e51bf19f(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);
    if (obj1Keys.length !== obj2Keys.length) return false;
    for (const key of obj1Keys){
        if (!obj2.hasOwnProperty(key) || !$8eddb885c737e63d$export$76775c78e51bf19f(obj1[key], obj2[key])) return false;
    }
    return true;
}

});

parcelRegister("fOdRG", function(module, exports) {

$parcel$export(module.exports, "getComponentList", () => $b82647ce7aed5d78$export$bc86d3bf8d4f33ed);
$parcel$export(module.exports, "getComponentsList", () => $b82647ce7aed5d78$export$c02ba41b11a67d02);
$parcel$export(module.exports, "getDomqlList", () => $b82647ce7aed5d78$export$d5e3ca8a213b95b3);
$parcel$export(module.exports, "getEventsList", () => $b82647ce7aed5d78$export$b284d53355bac59b);
$parcel$export(module.exports, "getCssPropsList", () => $b82647ce7aed5d78$export$98a77d5ae19c6290);
$parcel$export(module.exports, "getHTMLAttrsList", () => $b82647ce7aed5d78$export$9711e2c49c469cff);
$parcel$export(module.exports, "getCategoriesList", () => $b82647ce7aed5d78$export$90fcb8fa0d4ee4fc);
$parcel$export(module.exports, "moveSelectionInList", () => $b82647ce7aed5d78$export$a99a881729d4d748);
$parcel$export(module.exports, "addPropKey", () => $b82647ce7aed5d78$export$aa7781387220aa73);
// The raw typed list `getComponentsList` filters below. Same
// project-components + built-in-smbls-components union as
// prefill-values.js's `prefillComponentValue` (Rule 63 reuse) — every
// insertable component for the canvas properties/children dropdown,
// shaped like the sibling category lists here (`{ key, value }`, `value`
// a string so `getCategoriesList`'s `item.value.toLowerCase()` filter
// works the same way it does for domqlList/eventsList/etc.).
async function $b82647ce7aed5d78$export$bc86d3bf8d4f33ed(type) {
    if (type !== 'components') return [];
    const projectComponents = Object.keys(this.getRootState('components') || {});
    const smblsComponents = Object.keys(this.getRootContext('components') || {}).filter((key)=>key.startsWith('smbls.')).map((key)=>key.replace('smbls.', ''));
    const keys = [
        ...new Set([
            ...projectComponents,
            ...smblsComponents
        ])
    ].sort();
    return keys.map((key)=>({
            key: key,
            value: key
        }));
}
async function $b82647ce7aed5d78$export$c02ba41b11a67d02() {
    const list = await this.call('getComponentList', 'components');
    const compList = list.filter(({ isDivider: isDivider, isSharedLib: isSharedLib, isLabel: isLabel })=>!isDivider && !isSharedLib && !isLabel);
    return {
        title: 'Components',
        items: compList
    };
}
async function $b82647ce7aed5d78$export$d5e3ca8a213b95b3() {
    // FA204 / frank trap — moved from module scope into this function (sole
    // consumer, pure literal — see longPress.js for the identical shape).
    const DOMQL_ELEMENTS = [
        'extends',
        'childExtends',
        'children',
        'childProps',
        'childrenAs',
        'state',
        'tag',
        'key',
        'childExtendsRecursive',
        'query',
        'data',
        'scope'
    ];
    let domElements = DOMQL_ELEMENTS.map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Domql',
        items: domElements.sort()
    };
}
async function $b82647ce7aed5d78$export$b284d53355bac59b() {
    // FA204 / frank trap — was `export const DOM_EVENTS` at module scope, but
    // the export was never load-bearing anywhere in this checkout (grep
    // confirms this function was the ONLY reader) — a sibling-export bare
    // read is exactly as unresolvable post-frank as a module-local read
    // (navbarTabMenu.js precedent) — moved inline as a self-contained local.
    const DOM_EVENTS = [
        'onAnimationcancel',
        'onAnimationend',
        'onAnimationiteration',
        'onAnimationstart',
        'onAuxclick',
        'onBeforeinput',
        'onBeforematchExperimental',
        'onBeforexrselectExperimental',
        'onBlur',
        'onClick',
        'onCompositionend',
        'onCompositionstart',
        'onCompositionupdate',
        'onContentvisibilityautostatechange',
        'onContextmenu',
        'onCopy',
        'onCut',
        'onDblclick',
        'onDOMActivateDeprecated',
        'onFocus',
        'onFocusin',
        'onFocusout',
        'onFullscreenchange',
        'onFullscreenerror',
        'onGotpointercapture',
        'onInput',
        'onKeydown',
        'onKeypressDeprecated',
        'onKeyup',
        'onLostpointercapture',
        'onMousedown',
        'onMouseenter',
        'onMouseleave',
        'onMousemove',
        'onMouseout',
        'onMouseover',
        'onMouseup',
        'onPaste',
        'onPointercancel',
        'onPointerdown',
        'onPointerenter',
        'onPointerleave',
        'onPointermove',
        'onPointerout',
        'onPointerover',
        'onPointerrawupdateExperimental',
        'onPointerup',
        'onScroll',
        'onScrollend',
        'onScrollsnapchangeExperimental',
        'onScrollsnapchangingExperimental',
        'onSecuritypolicyviolation',
        'onTouchcancel',
        'onTouchend',
        'onTouchmove',
        'onTouchstart',
        'onTransitioncancel',
        'onTransitionend',
        'onTransitionrun',
        'onTransitionstart',
        'onWheel'
    ];
    let domEventsList = DOM_EVENTS.map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Events',
        items: domEventsList.sort()
    };
}

async function $b82647ce7aed5d78$export$98a77d5ae19c6290() {
    const { DEFAULT_CSS_PROPERTIES_LIST: DEFAULT_CSS_PROPERTIES_LIST } = await (parcelRequire("9FLdw"));
    // `DEFAULT_CSS_PROPERTIES_LIST` is a `Set` (css-in-props
    // src/props/defaults.js:1 — `export const DEFAULT_CSS_PROPERTIES_LIST = new
    // Set([…])`, 321 entries), and `Set.prototype.map` does not exist. Calling
    // `.map` on it directly threw `DEFAULT_CSS_PROPERTIES_LIST.map is not a
    // function` — i.e. the canvas properties dropdown's whole "Css" category
    // failed, in the normal Parcel bundle, independent of frank. Spread first.
    let cssProperties = [
        ...DEFAULT_CSS_PROPERTIES_LIST
    ].map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Css',
        items: cssProperties.sort()
    };
}

async function $b82647ce7aed5d78$export$9711e2c49c469cff() {
    const { HTML_ATTRIBUTES: HTML_ATTRIBUTES } = await Promise.resolve((parcelRequire("gBDdH")));
    let htmlAttributes = HTML_ATTRIBUTES['default'].map((item)=>({
            key: item,
            value: item
        }));
    return {
        title: 'Html',
        items: htmlAttributes.sort()
    };
}
async function $b82647ce7aed5d78$export$90fcb8fa0d4ee4fc() {
    const state = this.state;
    const filter = state.filterText?.toLowerCase() || '';
    const components = await this.call('getComponentsList');
    const domqlList = await this.call('getDomqlList');
    const eventsList = await this.call('getEventsList');
    const cssPropsList = await this.call('getCssPropsList');
    const htmlAttrsList = await this.call('getHTMLAttrsList');
    let categories;
    if (state.parent.listType === 'OnlyProperties') categories = [
        domqlList,
        eventsList,
        cssPropsList,
        htmlAttrsList
    ];
    else if (state.parent.listType === 'OnlyChildren') categories = [
        components
    ];
    else categories = [
        components,
        domqlList,
        eventsList,
        cssPropsList,
        htmlAttrsList
    ];
    // Apply filter to each category
    return categories.map((cat)=>({
            title: cat.title,
            items: cat.items.filter((item)=>item.value.toLowerCase().includes(filter))
        })).filter((cat)=>cat.items.length > 0);
}
function $b82647ce7aed5d78$export$a99a881729d4d748(dir) {
    const root = this.state.parent;
    const title = this.state.title;
    const items = this.state.expanded ? this.state.items : [
        ...this.state.items.slice(0, 5),
        {
            value: null,
            isMore: true
        }
    ];
    const total = items.length;
    let index = items.findIndex((item)=>item.isMore ? root.isMoreSelected : item.value === root.selectedItem);
    if (dir === 'down') index = index < total - 1 ? index + 1 : 0;
    else if (dir === 'up') index = index > 0 ? index - 1 : total - 1;
    const newItem = items[index];
    root.update({
        selectedItem: newItem.value,
        selectedTitle: title,
        isMoreSelected: !!newItem.isMore
    });
    const moreEl = this.parent.lookdown('More');
    if (newItem.isMore) {
        moreEl?.set({
            background: 'gray3.5',
            round: 'Z'
        });
        this.call('addPropKey', '');
    } else {
        moreEl?.set({
            background: 'transparent'
        });
        this.call('addPropKey', newItem.value);
    }
}
function $b82647ce7aed5d78$export$aa7781387220aa73(key) {
    const panel = this.getFloatingPanelElement();
    const inputEl = panel.inputElement;
    if (!inputEl?.node) throw new Error(`Input element ${inputEl} not found`);
    inputEl.node.value = key;
}

});
parcelRegister("9FLdw", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9gAYy"))) : import("9gAYy")).then(()=>parcelRequire('97g9O'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("gBDdH", function(module, exports) {

$parcel$export(module.exports, "HTML_ATTRIBUTES", () => $c16e8650e6e35f52$export$a073516cf3506ae6);
$parcel$export(module.exports, "camelToAttr", () => $c16e8650e6e35f52$export$60f07ef5f5f88ae7);
$parcel$export(module.exports, "isEnumeratedTrueFalseAttr", () => $c16e8650e6e35f52$export$59fe1dfa58aed0dc);
$parcel$export(module.exports, "serializeAttrValue", () => $c16e8650e6e35f52$export$ea7d2be54d49e0a9);
$parcel$export(module.exports, "checkAttributeByTagName", () => $c16e8650e6e35f52$export$3c670b34323f5417);
$parcel$export(module.exports, "ATTR_TRANSFORMS", () => $c16e8650e6e35f52$export$a73e91daa9bedc56);
$parcel$export(module.exports, "applyAttrTransforms", () => $c16e8650e6e35f52$export$5ff0ab856938124a);
$parcel$export(module.exports, "extractConditionalAttrs", () => $c16e8650e6e35f52$export$b4ae0fde1522e964);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
const $c16e8650e6e35f52$export$147ca7d289c2f7de = [
    "alert",
    "alertdialog",
    "application",
    "article",
    "banner",
    "button",
    "cell",
    "checkbox",
    "columnheader",
    "combobox",
    "complementary",
    "contentinfo",
    "definition",
    "dialog",
    "directory",
    "document",
    "feed",
    "figure",
    "form",
    "grid",
    "gridcell",
    "group",
    "heading",
    "img",
    "link",
    "list",
    "listbox",
    "listitem",
    "log",
    "main",
    "marquee",
    "math",
    "menu",
    "menubar",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "navigation",
    "none",
    "note",
    "option",
    "presentation",
    "progressbar",
    "radio",
    "radiogroup",
    "region",
    "row",
    "rowgroup",
    "rowheader",
    "scrollbar",
    "search",
    "searchbox",
    "separator",
    "slider",
    "spinbutton",
    "status",
    "switch",
    "tab",
    "table",
    "tablist",
    "tabpanel",
    "term",
    "textbox",
    "timer",
    "toolbar",
    "tooltip",
    "tree",
    "treegrid",
    "treeitem"
], $c16e8650e6e35f52$var$M = [
    "alignment-baseline",
    "baseline-shift",
    "clip",
    "clip-path",
    "clip-rule",
    "color",
    "color-interpolation",
    "color-interpolation-filters",
    "color-rendering",
    "cursor",
    "direction",
    "display",
    "dominant-baseline",
    "fill-opacity",
    "fill-rule",
    "filter",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "mask",
    "mask-type",
    "opacity",
    "overflow",
    "paint-order",
    "pointer-events",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-overflow",
    "text-rendering",
    "transform",
    "transform-origin",
    "unicode-bidi",
    "vector-effect",
    "visibility",
    "white-space",
    "word-spacing",
    "writing-mode"
], $c16e8650e6e35f52$var$I = [
    "requiredExtensions",
    "systemLanguage"
], $c16e8650e6e35f52$var$w = {
    circle: [
        "cx",
        "cy",
        "r",
        "pathLength"
    ],
    ellipse: [
        "cx",
        "cy",
        "rx",
        "ry",
        "pathLength"
    ],
    line: [
        "x1",
        "y1",
        "x2",
        "y2",
        "pathLength"
    ],
    path: [
        "d",
        "pathLength"
    ],
    polygon: [
        "points",
        "pathLength"
    ],
    polyline: [
        "points",
        "pathLength"
    ],
    rect: [
        "x",
        "y",
        "width",
        "height",
        "rx",
        "ry",
        "pathLength"
    ],
    g: [],
    defs: [],
    switch: [],
    symbol: [
        "viewBox",
        "preserveAspectRatio",
        "refX",
        "refY",
        "x",
        "y",
        "width",
        "height"
    ],
    use: [
        "href",
        "xlink:href",
        "x",
        "y",
        "width",
        "height"
    ],
    image: [
        "href",
        "xlink:href",
        "x",
        "y",
        "width",
        "height",
        "preserveAspectRatio",
        "crossorigin"
    ],
    foreignObject: [
        "x",
        "y",
        "width",
        "height"
    ],
    text: [
        "x",
        "y",
        "dx",
        "dy",
        "rotate",
        "textLength",
        "lengthAdjust"
    ],
    tspan: [
        "x",
        "y",
        "dx",
        "dy",
        "rotate",
        "textLength",
        "lengthAdjust"
    ],
    textPath: [
        "href",
        "xlink:href",
        "path",
        "startOffset",
        "method",
        "spacing",
        "side",
        "textLength",
        "lengthAdjust"
    ],
    linearGradient: [
        "x1",
        "y1",
        "x2",
        "y2",
        "gradientUnits",
        "gradientTransform",
        "spreadMethod",
        "href",
        "xlink:href"
    ],
    radialGradient: [
        "cx",
        "cy",
        "r",
        "fx",
        "fy",
        "fr",
        "gradientUnits",
        "gradientTransform",
        "spreadMethod",
        "href",
        "xlink:href"
    ],
    stop: [
        "offset"
    ],
    pattern: [
        "x",
        "y",
        "width",
        "height",
        "patternUnits",
        "patternContentUnits",
        "patternTransform",
        "viewBox",
        "preserveAspectRatio",
        "href",
        "xlink:href"
    ],
    clipPath: [
        "clipPathUnits"
    ],
    mask: [
        "x",
        "y",
        "width",
        "height",
        "maskUnits",
        "maskContentUnits"
    ],
    marker: [
        "viewBox",
        "preserveAspectRatio",
        "refX",
        "refY",
        "markerUnits",
        "markerWidth",
        "markerHeight",
        "orient"
    ],
    filter: [
        "x",
        "y",
        "width",
        "height",
        "filterUnits",
        "primitiveUnits"
    ]
}, $c16e8650e6e35f52$var$P = new Set([
    "linearGradient",
    "radialGradient",
    "stop",
    "clipPath",
    "mask",
    "marker",
    "pattern",
    "filter",
    "symbol"
]), $c16e8650e6e35f52$var$q = ()=>{
    const e = {};
    for(const t in $c16e8650e6e35f52$var$w)e[t] = [
        ...$c16e8650e6e35f52$var$w[t],
        ...$c16e8650e6e35f52$var$P.has(t) ? [] : $c16e8650e6e35f52$var$I,
        ...$c16e8650e6e35f52$var$M
    ];
    return e;
}, $c16e8650e6e35f52$export$a073516cf3506ae6 = {
    default: [
        "accesskey",
        "autofocus",
        "class",
        "contenteditable",
        "contextmenu",
        "dir",
        "draggable",
        "enterkeyhint",
        "exportparts",
        "headingoffset",
        "headingreset",
        "hidden",
        "id",
        "inputmode",
        "lang",
        "nonce",
        "part",
        "popover",
        "slot",
        "spellcheck",
        "style",
        "tabindex",
        "title",
        "translate",
        "writingsuggestions",
        "inert",
        "radiogroup",
        "role",
        "about",
        "datatype",
        "inlist",
        "prefix",
        "property",
        "resource",
        "typeof",
        "vocab",
        "autocapitalize",
        "autocorrect",
        "autosave",
        "color",
        "itemprop",
        "itemscope",
        "itemtype",
        "itemid",
        "itemref",
        "results",
        "security",
        "unselectable",
        "is"
    ],
    a: [
        "accesskey",
        "charset",
        "coords",
        "download",
        "href",
        "hreflang",
        "name",
        "ping",
        "referrerpolicy",
        "rel",
        "rev",
        "shape",
        "target",
        "type"
    ],
    aria: [
        "aria-activedescendant",
        "aria-atomic",
        "aria-autocomplete",
        "aria-checked",
        "aria-colcount",
        "aria-colindex",
        "aria-colspan",
        "aria-controls",
        "aria-current",
        "aria-describedby",
        "aria-details",
        "aria-dropeffect",
        "aria-errormessage",
        "aria-expanded",
        "aria-flowto",
        "aria-grabbed",
        "aria-haspopup",
        "aria-hidden",
        "aria-invalid",
        "aria-keyshortcuts",
        "aria-label",
        "aria-labelledby",
        "aria-level",
        "aria-live",
        "aria-modal",
        "aria-multiline",
        "aria-multiselectable",
        "aria-orientation",
        "aria-owns",
        "aria-placeholder",
        "aria-posinset",
        "aria-pressed",
        "aria-readonly",
        "aria-relevant",
        "aria-required",
        "aria-roledescription",
        "aria-rowcount",
        "aria-rowindex",
        "aria-rowspan",
        "aria-selected",
        "aria-setsize",
        "aria-sort",
        "aria-valuemax",
        "aria-valuemin",
        "aria-valuenow",
        "aria-valuetext"
    ],
    anchor: [
        "download",
        "href",
        "hreflang",
        "media",
        "ping",
        "rel",
        "target",
        "type",
        "referrerpolicy"
    ],
    audio: [
        "autoplay",
        "controls",
        "crossorigin",
        "loading",
        "loop",
        "muted",
        "preload",
        "src"
    ],
    area: [
        "alt",
        "coords",
        "download",
        "href",
        "hreflang",
        "media",
        "referrerpolicy",
        "rel",
        "shape",
        "target",
        "ping"
    ],
    base: [
        "href",
        "target"
    ],
    blockquote: [
        "cite"
    ],
    button: [
        "command",
        "commandfor",
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "name",
        "popovertarget",
        "popovertargetaction",
        "type",
        "value"
    ],
    canvas: [
        "height",
        "width"
    ],
    col: [
        "span",
        "width"
    ],
    colgroup: [
        "span"
    ],
    data: [
        "value"
    ],
    details: [
        "name",
        "open"
    ],
    del: [
        "cite",
        "datetime"
    ],
    dialog: [
        "closedby",
        "open"
    ],
    embed: [
        "height",
        "src",
        "type",
        "width"
    ],
    fieldset: [
        "disabled",
        "form",
        "name"
    ],
    form: [
        "accept-charset",
        "acceptcharset",
        "action",
        "autocomplete",
        "enctype",
        "method",
        "name",
        "novalidate",
        "target",
        "rel"
    ],
    html: [
        "manifest"
    ],
    iframe: [
        "allow",
        "allowfullscreen",
        "allowtransparency",
        "frameborder",
        "height",
        "loading",
        "marginheight",
        "marginwidth",
        "mozallowfullscreen",
        "name",
        "referrerpolicy",
        "sandbox",
        "scrolling",
        "seamless",
        "src",
        "srcdoc",
        "webkitallowfullscreen",
        "width"
    ],
    img: [
        "alt",
        "controls",
        "crossorigin",
        "decoding",
        "fetchpriority",
        "height",
        "ismap",
        "loading",
        "referrerpolicy",
        "sizes",
        "src",
        "srcset",
        "usemap",
        "width"
    ],
    ins: [
        "cite",
        "datetime"
    ],
    input: [
        "accept",
        "alpha",
        "alt",
        "autocomplete",
        "capture",
        "checked",
        "colorspace",
        "crossorigin",
        "dirname",
        "disabled",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formnovalidate",
        "formtarget",
        "height",
        "indeterminate",
        "list",
        "max",
        "maxlength",
        "min",
        "minlength",
        "multiple",
        "name",
        "pattern",
        "placeholder",
        "popovertarget",
        "popovertargetaction",
        "readonly",
        "required",
        "size",
        "src",
        "step",
        "type",
        "value",
        "width"
    ],
    keygen: [
        "challenge",
        "disabled",
        "form",
        "keytype",
        "keyparams",
        "name"
    ],
    label: [
        "form",
        "for"
    ],
    li: [
        "value"
    ],
    link: [
        "as",
        "blocking",
        "crossorigin",
        "disabled",
        "fetchpriority",
        "href",
        "hreflang",
        "integrity",
        "media",
        "imagesrcset",
        "imagesizes",
        "referrerpolicy",
        "rel",
        "sizes",
        "type",
        "charset"
    ],
    map: [
        "name"
    ],
    menu: [
        "type"
    ],
    media: [
        "autoplay",
        "controls",
        "currenttime",
        "defaultmuted",
        "defaultplaybackrate",
        "loop",
        "mediagroup",
        "muted",
        "playsinline",
        "preload",
        "src",
        "volume"
    ],
    meta: [
        "charset",
        "content",
        "http-equiv",
        "name",
        "media"
    ],
    meter: [
        "form",
        "high",
        "low",
        "max",
        "min",
        "optimum",
        "value"
    ],
    quote: [
        "cite"
    ],
    object: [
        "classid",
        "data",
        "form",
        "height",
        "name",
        "type",
        "usemap",
        "width",
        "wmode"
    ],
    ol: [
        "reversed",
        "start",
        "type"
    ],
    optgroup: [
        "disabled",
        "label"
    ],
    option: [
        "disabled",
        "label",
        "selected",
        "value"
    ],
    output: [
        "form",
        "for",
        "name"
    ],
    param: [
        "name",
        "value"
    ],
    progress: [
        "max",
        "value"
    ],
    q: [
        "cite"
    ],
    slot: [
        "name"
    ],
    script: [
        "async",
        "blocking",
        "charset",
        "crossorigin",
        "defer",
        "fetchpriority",
        "integrity",
        "nomodule",
        "nonce",
        "referrerpolicy",
        "src",
        "type"
    ],
    select: [
        "autocomplete",
        "disabled",
        "form",
        "multiple",
        "name",
        "required",
        "size",
        "value",
        "onchange"
    ],
    source: [
        "height",
        "media",
        "sizes",
        "src",
        "srcset",
        "type",
        "width"
    ],
    style: [
        "blocking",
        "media",
        "nonce",
        "scoped",
        "type"
    ],
    table: [
        "align",
        "bgcolor",
        "border",
        "cellpadding",
        "cellspacing",
        "frame",
        "rules",
        "summary",
        "width"
    ],
    template: [
        "for",
        "shadowrootclonable",
        "shadowrootcustomelementregistry",
        "shadowrootdelegatesfocus",
        "shadowrootmode",
        "shadowrootserializable",
        "shadowrootslotassignment"
    ],
    textarea: [
        "autocomplete",
        "cols",
        "dirname",
        "disabled",
        "form",
        "maxlength",
        "minlength",
        "name",
        "placeholder",
        "readonly",
        "required",
        "rows",
        "value",
        "wrap"
    ],
    td: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr",
        "height",
        "width",
        "valign"
    ],
    th: [
        "align",
        "colspan",
        "headers",
        "rowspan",
        "scope",
        "abbr"
    ],
    time: [
        "datetime"
    ],
    track: [
        "default",
        "kind",
        "label",
        "src",
        "srclang"
    ],
    video: [
        "autoplay",
        "controls",
        "crossorigin",
        "disablepictureinpicture",
        "disableremoteplayback",
        "height",
        "loading",
        "loop",
        "muted",
        "playsinline",
        "poster",
        "preload",
        "src",
        "width"
    ],
    svg: [
        "className",
        "class",
        "color",
        "height",
        "id",
        "lang",
        "max",
        "media",
        "method",
        "min",
        "name",
        "style",
        "target",
        "type",
        "width",
        "role",
        "tabindex",
        "crossorigin",
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "allowReorder",
        "alphabetic",
        "amplitude",
        "arabic-form",
        "ascent",
        "attributeName",
        "attributeType",
        "autoReverse",
        "azimuth",
        "baseFrequency",
        "baseline-shift",
        "baseProfile",
        "bbox",
        "begin",
        "bias",
        "by",
        "calcMode",
        "cap-height",
        "clip",
        "clip-path",
        "clipPathUnits",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "contentScriptType",
        "contentStyleType",
        "cursor",
        "cx",
        "cy",
        "d",
        "decelerate",
        "descent",
        "diffuseConstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "dx",
        "dy",
        "edgeMode",
        "elevation",
        "enable-background",
        "end",
        "exponent",
        "externalResourcesRequired",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterRes",
        "filterUnits",
        "flood-color",
        "flood-opacity",
        "focusable",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "format",
        "from",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "glyphRef",
        "gradientTransform",
        "gradientUnits",
        "hanging",
        "href",
        "horiz-adv-x",
        "horiz-origin-x",
        "ideographic",
        "image-rendering",
        "in2",
        "in",
        "intercept",
        "k1",
        "k2",
        "k3",
        "k4",
        "k",
        "kernelMatrix",
        "kernelUnitLength",
        "kerning",
        "keyPoints",
        "keySplines",
        "keyTimes",
        "lengthAdjust",
        "letter-spacing",
        "lighting-color",
        "limitingConeAngle",
        "local",
        "marker-end",
        "markerHeight",
        "marker-mid",
        "marker-start",
        "markerUnits",
        "markerWidth",
        "mask",
        "maskContentUnits",
        "maskUnits",
        "mathematical",
        "mode",
        "numOctaves",
        "opacity",
        "operator",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "path",
        "pathLength",
        "patternContentUnits",
        "patternTransform",
        "patternUnits",
        "pointer-events",
        "points",
        "pointsAtX",
        "pointsAtY",
        "pointsAtZ",
        "preserveAlpha",
        "preserveAspectRatio",
        "primitiveUnits",
        "r",
        "radius",
        "refX",
        "refY",
        "rendering-intent",
        "repeatCount",
        "repeatDur",
        "requiredExtensions",
        "requiredFeatures",
        "restart",
        "result",
        "rotate",
        "rx",
        "ry",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "spacing",
        "specularConstant",
        "specularExponent",
        "speed",
        "spreadMethod",
        "startOffset",
        "stdDeviation",
        "stemh",
        "stemv",
        "stitchTiles",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "string",
        "stroke",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "surfaceScale",
        "systemLanguage",
        "tableValues",
        "targetX",
        "targetY",
        "text-anchor",
        "text-decoration",
        "textLength",
        "text-rendering",
        "to",
        "transform",
        "u1",
        "u2",
        "underline-position",
        "underline-thickness",
        "unicode",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "values",
        "vector-effect",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "v-hanging",
        "v-ideographic",
        "viewBox",
        "viewTarget",
        "visibility",
        "v-mathematical",
        "widths",
        "word-spacing",
        "writing-mode",
        "x1",
        "x2",
        "x",
        "xChannelSelector",
        "x-height",
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:href",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type",
        "xml:base",
        "xml:lang",
        "xmlns",
        "xmlns:xlink",
        "xml:space",
        "y1",
        "y2",
        "y",
        "yChannelSelector",
        "z",
        "zoomAndPan"
    ],
    ...$c16e8650e6e35f52$var$q()
}, $c16e8650e6e35f52$export$f552dbb36ef6b3dd = [
    "oncopy",
    "oncut",
    "onpaste",
    "oncompositionend",
    "oncompositionstart",
    "oncompositionupdate",
    "onfocus",
    "onfocusin",
    "onfocusout",
    "onblur",
    "onchange",
    "onbeforeinput",
    "oninput",
    "onreset",
    "onsubmit",
    "oninvalid",
    "onformdata",
    "onload",
    "onerror",
    "ontoggle",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onabort",
    "oncanplay",
    "oncanplaythrough",
    "oncuechange",
    "ondurationchange",
    "onemptied",
    "onencrypted",
    "onended",
    "onloadeddata",
    "onloadedmetadata",
    "onloadstart",
    "onpause",
    "onplay",
    "onplaying",
    "onprogress",
    "onratechange",
    "onseeked",
    "onseeking",
    "onstalled",
    "onsuspend",
    "ontimeupdate",
    "onvolumechange",
    "onwaiting",
    "onauxclick",
    "onclick",
    "oncontextmenu",
    "ondblclick",
    "ondrag",
    "ondragend",
    "ondragenter",
    "ondragexit",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onselect",
    "onselectionchange",
    "onselectstart",
    "ontouchcancel",
    "ontouchend",
    "ontouchmove",
    "ontouchstart",
    "ongotpointercapture",
    "onpointercancel",
    "onpointerdown",
    "onpointerenter",
    "onpointerleave",
    "onpointermove",
    "onpointerout",
    "onpointerover",
    "onpointerup",
    "onlostpointercapture",
    "onscroll",
    "onresize",
    "onwheel",
    "onanimationstart",
    "onanimationend",
    "onanimationiteration",
    "ontransitionstart",
    "ontransitionrun",
    "ontransitionend",
    "ontransitioncancel",
    "onoutrostart",
    "onoutroend",
    "onintrostart",
    "onintroend",
    "onmessage",
    "onmessageerror",
    "onvisibilitychange",
    "oncancel",
    "onclose",
    "onfullscreenchange",
    "onfullscreenerror"
], $c16e8650e6e35f52$var$v = (e)=>e.startsWith("aria") && e.length > 4 && e.charCodeAt(4) >= 65 && e.charCodeAt(4) <= 90 ? "aria-" + e.charAt(4).toLowerCase() + e.slice(5).replace(/([A-Z])/g, (t)=>"-" + t.toLowerCase()) : e.startsWith("data") && e.length > 4 && e.charCodeAt(4) >= 65 && e.charCodeAt(4) <= 90 ? "data-" + e.charAt(4).toLowerCase() + e.slice(5).replace(/([A-Z])/g, (t)=>"-" + t.toLowerCase()) : null, $c16e8650e6e35f52$var$k = new Map, $c16e8650e6e35f52$export$60f07ef5f5f88ae7 = (e)=>{
    let t = $c16e8650e6e35f52$var$k.get(e);
    return t === void 0 && (t = $c16e8650e6e35f52$var$v(e) || $c16e8650e6e35f52$export$80a0bf1af7da20ba(e), $c16e8650e6e35f52$var$k.set(e, t)), t;
}, $c16e8650e6e35f52$var$T = new Set([
    "tabIndex",
    "readOnly",
    "maxLength",
    "minLength",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "contentEditable",
    "spellCheck",
    "colSpan",
    "rowSpan",
    "srcSet",
    "crossOrigin",
    "accessKey",
    "inputMode",
    "enterKeyHint",
    "formAction",
    "noValidate",
    "autoCapitalize",
    "autoCorrect",
    "writingSuggestions",
    "headingOffset",
    "headingReset",
    "exportParts"
]), $c16e8650e6e35f52$var$x = new Set;
for(const e in $c16e8650e6e35f52$export$a073516cf3506ae6)e === "default" || e === "aria" || e === "svg" || $c16e8650e6e35f52$export$a073516cf3506ae6[e].forEach((t)=>{
    t.startsWith("on") || $c16e8650e6e35f52$var$x.add(t);
});
const $c16e8650e6e35f52$var$L = (e)=>{
    const t = e.charCodeAt(0);
    if (t < 97 || t > 122 || !/[A-Z]/.test(e)) return null;
    const r = e.replace(/[A-Z]/g, (o)=>"-" + o.toLowerCase());
    if ($c16e8650e6e35f52$var$x.has(r)) return r;
    const n = e.toLowerCase();
    return $c16e8650e6e35f52$var$x.has(n) ? n : null;
}, $c16e8650e6e35f52$export$80a0bf1af7da20ba = (e)=>$c16e8650e6e35f52$var$T.has(e) ? e.toLowerCase() : $c16e8650e6e35f52$var$L(e), $c16e8650e6e35f52$var$F = new Set([
    "draggable",
    "contenteditable",
    "spellcheck",
    "autocorrect",
    "writingsuggestions",
    "translate"
]), $c16e8650e6e35f52$var$H = new Map([
    [
        "autocorrect",
        [
            "on",
            "off"
        ]
    ],
    [
        "translate",
        [
            "yes",
            "no"
        ]
    ]
]), $c16e8650e6e35f52$export$59fe1dfa58aed0dc = (e)=>typeof e == "string" && ($c16e8650e6e35f52$var$F.has(e) || e.startsWith("aria-")), $c16e8650e6e35f52$export$ea7d2be54d49e0a9 = (e, t)=>{
    if (t !== !0 && t !== !1) return t;
    if ($c16e8650e6e35f52$export$59fe1dfa58aed0dc(e)) {
        const r = $c16e8650e6e35f52$var$H.get(e);
        return r ? t ? r[0] : r[1] : t ? "true" : "false";
    }
    return t === !0 ? "" : t;
}, $c16e8650e6e35f52$var$E = new Map, $c16e8650e6e35f52$export$3c670b34323f5417 = (e, t)=>{
    const r = $c16e8650e6e35f52$export$a073516cf3506ae6.default, n = Object.prototype.hasOwnProperty.call($c16e8650e6e35f52$export$a073516cf3506ae6, e) ? $c16e8650e6e35f52$export$a073516cf3506ae6[e] : null, o = n ? n.length : -1;
    let a = $c16e8650e6e35f52$var$E.get(e);
    (!a || a.def !== r || a.defLen !== r.length || a.own !== n || a.ownLen !== o) && (a = {
        def: r,
        defLen: r.length,
        own: n,
        ownLen: o,
        answers: new Map
    }, $c16e8650e6e35f52$var$E.set(e, a));
    let l = a.answers.get(t);
    return l === void 0 && (l = $c16e8650e6e35f52$var$V(e, t), a.answers.set(t, l)), l;
}, $c16e8650e6e35f52$var$V = (e, t)=>{
    if (t.startsWith("aria-") || t.startsWith("data-") || $c16e8650e6e35f52$var$v(t) || $c16e8650e6e35f52$var$T.has(t) || $c16e8650e6e35f52$export$a073516cf3506ae6.default.includes(t)) return !0;
    if (Object.prototype.hasOwnProperty.call($c16e8650e6e35f52$export$a073516cf3506ae6, e)) {
        const r = $c16e8650e6e35f52$export$a073516cf3506ae6[e];
        if (r.includes(t)) return !0;
        const n = $c16e8650e6e35f52$var$L(t);
        return n !== null && r.includes(n);
    }
    return !1;
}, $c16e8650e6e35f52$export$12ab4f1a89970119 = (e)=>{
    if (!(0, $czfS0.isString)(e)) return !1;
    const t = e.toLowerCase();
    return $c16e8650e6e35f52$export$f552dbb36ef6b3dd.includes(t);
}, $c16e8650e6e35f52$export$a3d5d5e1a17535c6 = (e, t, r)=>{
    const n = {};
    for(const o in t)if (Object.prototype.hasOwnProperty.call(t, o)) {
        if (r && o in r) continue;
        if (o === "aria" && t[o] && typeof t[o] == "object") {
            for(const s in t[o])(0, $czfS0.isDefined)(t[o][s]) && (n["aria-" + s] = t[o][s]);
            continue;
        }
        if (o === "data" && t[o] && typeof t[o] == "object") {
            for(const s in t[o])if ((0, $czfS0.isDefined)(t[o][s])) {
                const i = s.replace(/([A-Z])/g, (p)=>"-" + p.toLowerCase());
                n["data-" + i] = t[o][s];
            }
            continue;
        }
        const a = $c16e8650e6e35f52$export$3c670b34323f5417(e, o), l = $c16e8650e6e35f52$export$12ab4f1a89970119(o);
        if ((0, $czfS0.isDefined)(t[o]) && (a || l)) {
            const s = $c16e8650e6e35f52$export$60f07ef5f5f88ae7(o) || o;
            n[s] = t[o];
        }
    }
    return n;
}, $c16e8650e6e35f52$export$a420285f97b772db = (e, t)=>{
    const r = {};
    if (e.attr) for(const n in e.attr)r[n] = e.attr[n](t, t.state, t.context);
    if (e.aria && typeof e.aria == "object") for(const n in e.aria){
        const o = e.aria[n];
        typeof o == "function" && (r["aria-" + n] = o(t, t.state, t.context));
    }
    if (e.data && typeof e.data == "object") for(const n in e.data){
        const o = e.data[n];
        if (typeof o == "function") {
            const a = n.replace(/([A-Z])/g, (l)=>"-" + l.toLowerCase());
            r["data-" + a] = o(t, t.state, t.context);
        }
    }
    return r;
}, $c16e8650e6e35f52$export$ba06f8f07b4aa3a7 = (e, t)=>{
    let r = e.call("exec", t, e);
    if (r) return (0, $czfS0.isString)(r) && r.includes("{{") && (r = e.call("replaceLiteralsWithObjectFields", r)), r;
}, $c16e8650e6e35f52$export$23bb89b45c65692a = (e, t)=>{
    let r = (e.preSrc || "") + ($c16e8650e6e35f52$export$ba06f8f07b4aa3a7(e, t) || "");
    if (!r) return;
    try {
        return new URL(r), r;
    } catch  {}
    const { context: n } = e;
    if (!n.files && !n.assets) return r;
    if (r.startsWith("/assets/")) {
        const o = r.slice(8), a = n.assets && (n.assets[r] || n.assets[o]);
        return a && a.content ? a.content.src : r;
    }
    if (r.startsWith("/files/")) {
        const o = r.slice(7), a = n.files && (n.files[r] || n.files[o]);
        return a && a.content ? a.content.src : r;
    }
    if (n.assets) {
        const o = n.assets[r];
        if (o && o.content) return o.content.src;
    }
    if (n.files) {
        const o = n.files[r];
        if (o && o.content) return o.content.src;
    }
    return r;
}, $c16e8650e6e35f52$var$R = new WeakSet, $c16e8650e6e35f52$export$9a520364ebd65a53 = (e, t)=>{
    if (!(0, $czfS0.isString)(t) || t.charAt(0) !== "/") return t;
    const r = t.charAt(1);
    if (r === "/" || r === "\\") return t;
    const n = e && e.context;
    if (!n) return t;
    const { functions: o, snippets: a, utils: l } = n, s = o && o.routerHref || a && a.routerHref || l && l.routerHref;
    if (!(0, $czfS0.isFunction)(s)) return t;
    try {
        const i = s.call(e, t, e);
        return (0, $czfS0.isString)(i) && i ? i : t;
    } catch (i) {
        return $c16e8650e6e35f52$var$R.has(s) || ($c16e8650e6e35f52$var$R.add(s), typeof console < "u" && console.warn("[smbls] routerHref threw; links keep the href as written", i)), t;
    }
}, $c16e8650e6e35f52$var$K = {
    a: !0,
    area: !0
}, $c16e8650e6e35f52$export$a73e91daa9bedc56 = {
    src: (e)=>$c16e8650e6e35f52$export$23bb89b45c65692a(e, e.src),
    href: (e)=>{
        const t = $c16e8650e6e35f52$export$ba06f8f07b4aa3a7(e, e.href);
        return $c16e8650e6e35f52$var$K[e.tag] ? $c16e8650e6e35f52$export$9a520364ebd65a53(e, t) : t;
    },
    action: (e)=>$c16e8650e6e35f52$export$ba06f8f07b4aa3a7(e, e.action),
    poster: (e)=>$c16e8650e6e35f52$export$23bb89b45c65692a(e, e.poster),
    data: (e)=>$c16e8650e6e35f52$export$ba06f8f07b4aa3a7(e, e.data)
}, $c16e8650e6e35f52$export$5ff0ab856938124a = (e)=>{
    const t = e.tag || "div", r = {};
    for(const n in $c16e8650e6e35f52$export$a73e91daa9bedc56)if (e[n] !== void 0 && $c16e8650e6e35f52$export$3c670b34323f5417(t, n)) {
        const o = $c16e8650e6e35f52$export$a73e91daa9bedc56[n](e);
        o !== void 0 && (r[n] = o);
    }
    return r;
}, $c16e8650e6e35f52$var$U = (e, t)=>{
    const r = t.context?.cases?.[e];
    if (r !== void 0) return (0, $czfS0.isFunction)(r) ? r.call(t, t) : !!r;
}, $c16e8650e6e35f52$var$Z = (e, t, r)=>{
    if (e === "$") {
        let o = $c16e8650e6e35f52$var$U(t, r);
        return o === void 0 && (o = !!r[t]), o;
    }
    let n = r[t] === !0 || r.state[t];
    if (!n) {
        const o = $c16e8650e6e35f52$var$U(t, r);
        o !== void 0 && (n = o);
    }
    return e === "." ? !!n : !n;
}, $c16e8650e6e35f52$var$Y = new Set([
    "$",
    ".",
    "!"
]), $c16e8650e6e35f52$export$b4ae0fde1522e964 = (e, t, r, n = $c16e8650e6e35f52$var$Z)=>{
    const o = {}, a = (l, s, i, p)=>{
        const c = s;
        o[l] = (u)=>{
            if (n(i, p, u)) return (0, $czfS0.isFunction)(c) ? c(u, u.state, u.context) : c;
        };
    };
    for(const l in e){
        const s = l.charAt(0);
        if (!$c16e8650e6e35f52$var$Y.has(s)) continue;
        const i = e[l];
        if (!i || typeof i != "object") continue;
        const p = l.slice(1);
        for(const c in i){
            if (r && c in r) continue;
            if (c === "aria" && i[c] && typeof i[c] == "object") {
                for(const f in i[c])a("aria-" + f, i[c][f], s, p);
                continue;
            }
            if (c === "data" && i[c] && typeof i[c] == "object") {
                for(const f in i[c]){
                    const _ = f.replace(/([A-Z])/g, (j)=>"-" + j.toLowerCase());
                    a("data-" + _, i[c][f], s, p);
                }
                continue;
            }
            const u = $c16e8650e6e35f52$export$3c670b34323f5417(t, c), z = $c16e8650e6e35f52$export$12ab4f1a89970119(c);
            if (!u && !z) continue;
            const N = $c16e8650e6e35f52$export$60f07ef5f5f88ae7(c) || c;
            a(N, i[c], s, p);
        }
    }
    return o;
};

});


parcelRegister("kjygi", function(module, exports) {

$parcel$export(module.exports, "policyStatus", () => $eca028b3f9cb293f$export$feec5eeb4c793803);
$parcel$export(module.exports, "policyInitials", () => $eca028b3f9cb293f$export$71eb08ccbc5451f);
$parcel$export(module.exports, "formatPolicyMoney", () => $eca028b3f9cb293f$export$c0477bbb803b425e);
// Backing functions for the `POLICY_CARD` chat card
// (shared/components/_simone/ChatCard.js `type: 'policies'`) — never
// registered, so `el.call('policyStatus' | 'policyInitials' |
// 'formatPolicyMoney', …)` returned `undefined` and crashed the render
// factories that dereference `.theme`/`.label` on the result (TypeError,
// took down the whole Simone answer subtree for any card with a policy).
// Policy status → design-system theme name for the status pill + a
// human-readable label. Theme drives the pill colour per the comment above
// POLICY_CARD (success=green, warning=orange, alert=red) — same
// normalize-then-map shape as this file's sibling `stateColor`/STATE_COLOR
// (ticket state → dot colour) in ChatCard.js.
function $eca028b3f9cb293f$export$feec5eeb4c793803(item) {
    // FA204 / frank trap — moved from module scope into this function (sole
    // consumer, pure lookup table — see longPress.js for the identical shape).
    const POLICY_STATUS = {
        active: {
            theme: 'success',
            label: 'ai.policy.status.active'
        },
        in_force: {
            theme: 'success',
            label: 'ai.policy.status.active'
        },
        current: {
            theme: 'success',
            label: 'ai.policy.status.active'
        },
        renewed: {
            theme: 'success',
            label: 'ai.policy.status.renewed'
        },
        pending: {
            theme: 'warning',
            label: 'ai.policy.status.pending'
        },
        pending_renewal: {
            theme: 'warning',
            label: 'ai.policy.status.pendingRenewal'
        },
        due: {
            theme: 'warning',
            label: 'ai.policy.status.due'
        },
        past_due: {
            theme: 'warning',
            label: 'ai.policy.status.pastDue'
        },
        expiring: {
            theme: 'warning',
            label: 'ai.policy.status.expiring'
        },
        expired: {
            theme: 'alert',
            label: 'ai.policy.status.expired'
        },
        cancelled: {
            theme: 'alert',
            label: 'ai.policy.status.cancelled'
        },
        canceled: {
            theme: 'alert',
            label: 'ai.policy.status.cancelled'
        },
        lapsed: {
            theme: 'alert',
            label: 'ai.policy.status.lapsed'
        },
        declined: {
            theme: 'alert',
            label: 'ai.policy.status.declined'
        }
    };
    const key = String(item?.status || '').toLowerCase().replace(/[\s-]+/g, '_');
    return POLICY_STATUS[key] || {
        theme: 'tertiary',
        label: key ? key.replace(/_/g, ' ') : 'ai.policy.status.unknown'
    };
}
function $eca028b3f9cb293f$export$71eb08ccbc5451f(name) {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    const first = parts[0][0];
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return (first + last).toUpperCase();
}
function $eca028b3f9cb293f$export$c0477bbb803b425e(amount, currency) {
    const value = Number(amount);
    if (!Number.isFinite(value)) return '';
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'USD',
            maximumFractionDigits: 2
        }).format(value);
    } catch (_) {
        // Unrecognized/malformed currency code — Intl.NumberFormat throws
        // rather than falling back.
        return `${currency ? currency + ' ' : '$'}${value.toFixed(2)}`;
    }
}

});

parcelRegister("lykMl", function(module, exports) {

$parcel$export(module.exports, "useOnlinePresence", () => $fb0ce433e21b66de$export$90653880a65d6508);
// useOnlinePresence — register as a project function so pages can call it
// via el.call('useOnlinePresence') from onCreate. Returns a cleanup
// function to call from onRemove.
//
// Every caller subscribes to a single shared channel (`presence:symbols`)
// so the CalOnlineUsersBar surface reflects presence across the entire
// editor and governance suite — calendar, tickets, documents, canvas,
// workspaces. The optional `app` tag is tracked as presence metadata for
// per-app breakdowns later; it no longer scopes the channel itself.
//
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.presence`
// dispatches through the SDK's transport-agnostic API. The transport is the
// SDK /user-socket presence registry (`sdk.subscribePresence`), selected by
// `sdkRealtimeProvider._openPresenceSocket` and installed in bootShell. The
// Supabase `postgres_changes` provider that used to serve this op was removed
// with the governance project — swapping transports again is a provider-only
// change; this file doesn't move.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
function $fb0ce433e21b66de$export$90653880a65d6508({ app: app = 'symbols' } = {}) {
    const el = this;
    const root = el.state.root;
    const w = typeof window !== 'undefined' ? window : globalThis;
    // Ref-counted shared subscription per browser tab. The workspace shell
    // subscribes once on mount so presence is available on every route
    // (CalOnlineUsersBar in AppHeader renders globally). Page-level
    // subscribes (canvas/app.js, calendar.js, tickets/board.js, etc.) add
    // themselves to the ref count without re-subscribing — and their
    // unmount cleanups only tear down the channel when the last subscriber
    // goes away. Previously cleanup was a singleton shared across callers,
    // so the first unmount nuked everyone else's presence stream.
    const state = w.__presenceState || {
        refCount: 0,
        unsub: null,
        cancelled: false,
        // Set synchronously the moment a boot commits to subscribing (the
        // unsub itself lands async through the SDK init-gate promise) so retry
        // ticks and later subscribers can't double-subscribe the channel.
        booted: false
    };
    w.__presenceState = state;
    // Reconcile `root.presenceById` — a per-id reactive map (lowercased
    // email → 'online' | 'idle') maintained ALONGSIDE the canonical
    // `onlineUsers` array.
    //
    // Why a second structure: the team-and-agents board renders ~508
    // person/agent nodes, each with an online/idle dot. When presence lived
    // only on the flat `onlineUsers` array, every dot read (scanned) that
    // shared array — so ANY user's join/leave/idle change replaced the array
    // and re-ran EVERY dot's `hide` factory (a full-board tick that janks on
    // iPad). Keying presence per id lets each dot subscribe to
    // `presenceById[email]` — its OWN signal — so a status change fires only
    // the one node whose value actually changed.
    //
    // Each write goes through the nested signal store's per-key signal; the
    // signal's `===` dedupe no-ops unchanged statuses, so a sync where one
    // peer flips idle touches exactly one dot. Departed peers are set to
    // `undefined` (→ offline) rather than replacing the whole map (which
    // would re-fire every dot). The canonical `onlineUsers` array is written
    // separately for every off-board reader (AppHeader OnlineMembers,
    // PersonCard, chat mentions, analytics) — its shape is unchanged.
    const syncPresenceById = (r, nextById)=>{
        // First sync lazily creates the nested store. Reading
        // `root.presenceById` outside a reactive effect is side-effect-free
        // (no observer to subscribe), so this guard is free.
        if (!r.presenceById) r.update({
            presenceById: {}
        });
        const byId = r.presenceById;
        if (!byId) return;
        // Present peers — unchanged statuses are no-op'd by the signal's ===
        // guard.
        for(const email in nextById)byId[email] = nextById[email];
        // Departed peers — clear to offline without replacing the map.
        // Iterate a snapshot of the current keys so writing back is safe.
        for (const email of Object.keys(byId))if (!(email in nextById)) byId[email] = undefined;
    };
    // Boot (or retry-boot) the shared channel. Subscribes through the SDK's
    // flat `subscribePresence` (the /user-socket transport) DIRECTLY — the
    // old wp.realtime provider indirection added nothing except an ordering
    // dependency: when the shell's first `useOnlinePresence` ran before
    // bootShell installed the realtime provider (or before auth populated
    // currentUserEmail), the one-shot boot silently no-op'd and presence
    // stayed DEAD for the whole session — the original "online members never
    // show" flow bug. Now the boot RETRIES (bounded, 1s steps) until the SDK
    // + auth email are ready, so whichever order boot lands in, the channel
    // comes up.
    const bootChannel = (r, a, attempt = 0)=>{
        if (state.cancelled || state.booted) return;
        const me = r?.currentUserEmail;
        const sdk = (0, $1NxyO.getSDK)();
        if (!me || typeof sdk?.subscribePresence !== 'function') {
            if (attempt < 60) setTimeout(()=>bootChannel(r, a, attempt + 1), 1000);
            else console.warn("[useOnlinePresence] gave up \u2014 sdk/auth never became ready");
            return;
        }
        state.booted = true;
        // Signature of the last onlineUsers set we actually wrote — lets the
        // sync handler skip redundant writes when a re-sync carries an
        // unchanged set (see the change-guard below).
        let lastOnlineSig = null;
        // The shell's SDK bootstrap wraps every method in an init gate
        // returning a PROMISE of the real return — resolve it so unsub is the
        // actual unsubscribe function (a stored Promise made session teardown
        // leak the socket: the `typeof === 'function'` cleanup guard skipped
        // it).
        const pending = sdk.subscribePresence({
            scope: 'symbols',
            userKey: me,
            meta: {
                app: a
            }
        }, (s)=>{
            // `s` is the presenceState-shaped roster { [key]: [{ online_at,
            // ...meta }] }. Re-derive the full online list on each sync so
            // root.onlineUsers stays the canonical view.
            const seen = new Set();
            const list = [];
            // Per-id presence map built in the same pass — see syncPresenceById.
            const nextById = {};
            for (const key of Object.keys(s || {})){
                if (seen.has(key)) continue;
                seen.add(key);
                const meta = s[key]?.[0] || {};
                // Activity status from the peer's tracked meta. Defaults to
                // 'online' so any peer missing the field still counts as online —
                // the binary "present === online" semantics are preserved.
                const status = meta.status || 'online';
                list.push({
                    email: key,
                    since: meta.online_at || Date.now(),
                    app: meta.app || null,
                    status: status
                });
                nextById[String(key).toLowerCase()] = status;
            }
            // Canonical array for every off-board reader (shape unchanged).
            // Change-guard: re-syncs often carry an UNCHANGED online set.
            // Writing unconditionally re-runs EVERY onlineUsers subscriber (the
            // presence widget + every /people card) for nothing, on a global
            // signal. Only write when the emails/statuses actually changed.
            const sig = list.map((u)=>`${u.email}:${u.status}`).sort().join('|');
            if (sig !== lastOnlineSig) {
                lastOnlineSig = sig;
                r.update({
                    onlineUsers: list
                });
            }
            // Per-id fan-out so the team-and-agents board repaints only the
            // dots whose status changed, not all ~508 on every tick.
            syncPresenceById(r, nextById);
        });
        Promise.resolve(pending).then((u)=>{
            if (state.cancelled) {
                try {
                    if (typeof u === 'function') u();
                } catch (_) {}
                state.booted = false;
                return;
            }
            state.unsub = typeof u === 'function' ? u : null;
        }).catch((err)=>{
            state.booted = false;
            console.warn('[useOnlinePresence] subscribe failed:', err?.message || err);
        });
    };
    state.refCount++;
    // First subscriber boots the channel (with readiness retries — see
    // bootChannel). Later subscribers just ride the ref count.
    if (state.refCount === 1) {
        state.cancelled = false;
        try {
            bootChannel(root, app);
        } catch (err) {
            console.warn('[useOnlinePresence] subscribe failed:', err?.message || err);
        }
    }
    // Per-caller cleanup: decrements the ref count; tears down the channel
    // (and clears `root.onlineUsers`) when the last subscriber leaves.
    let called = false;
    return ()=>{
        if (called) return;
        called = true;
        state.refCount = Math.max(0, state.refCount - 1);
        if (state.refCount === 0) {
            state.cancelled = true;
            state.booted = false;
            if (typeof state.unsub === 'function') try {
                state.unsub();
            } catch (_) {}
            state.unsub = null;
        }
    };
}

});

parcelRegister("kUTqn", function(module, exports) {

$parcel$export(module.exports, "liveCursorsScope", () => $f3a407c34ad53e7d$export$c9db5f840c6fcbf9);
$parcel$export(module.exports, "liveCursorsJoin", () => $f3a407c34ad53e7d$export$978bdeb64780fd7f);
// Live cursors for panzoom canvas surfaces (tickets board/epics, /studios,
// /team-and-agents, /files, /infra, analytics map — everything that boots
// through initPanzoomBoard). The PROJECT canvas keeps its original
// CollabService flow (sdk.sendCursor → root.clients → ViewSvitcher
// OverlayPeers); this module gives every OTHER canvas page the same
// functionality over the /user-socket presence relay (server
// packages/socket/user.js `presence:cursor` — volatile, room-gated).
//
// Channel model: one presence subscription per SURFACE scope
// (`cursor:<workspaceId>:<path>`), ref-counted across subscribers the same
// way presence.js ref-counts the shell channel. Peers are keyed by peerId
// (socket id) — two tabs of one user are two cursors, matching the collab
// canvas. High-frequency by design: peer positions NEVER touch root state —
// subscribers get direct (peerId, peer|null) callbacks and paint nodes
// imperatively (the same altitude as the panzoom/dots layer itself).
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
function $f3a407c34ad53e7d$export$c9db5f840c6fcbf9() {
    const wsIdFor = (root)=>root?.jwtClaims?.active_workspace_id || root?.workspace?.id || 'default';
    const surfaceScopeFor = (root)=>`cursor:${wsIdFor(root)}:${root?.currentPath || '/'}`;
    const root = this?.state?.root;
    if (!root || !root.currentUserEmail) return null;
    return surfaceScopeFor(root);
}
function $f3a407c34ad53e7d$export$978bdeb64780fd7f(onPeer) {
    const wsIdFor = (root)=>root?.jwtClaims?.active_workspace_id || root?.workspace?.id || 'default';
    const surfaceScopeFor = (root)=>`cursor:${wsIdFor(root)}:${root?.currentPath || '/'}`;
    const notify = (ch, peerId, peer)=>{
        for (const fn of ch.subs)try {
            fn(peerId, peer);
        } catch (_) {
        /* one bad painter must not break the rest */ }
    };
    const STALE_PEER_MS = 6000;
    const SWEEP_MS = 3000;
    const SEND_THROTTLE_MS = 45;
    const el = this;
    const root = el?.state?.root;
    const me = root?.currentUserEmail;
    if (!root || !me || typeof onPeer !== 'function') return {
        scope: null,
        send: ()=>{},
        leave: ()=>{}
    };
    const scope = surfaceScopeFor(root);
    // scope -> { refs, unsub, peers: Map<peerId, peer>, subs: Set<fn>, sweep }
    const w = typeof window !== 'undefined' ? window : globalThis;
    if (!w.__liveCursorsChannels) w.__liveCursorsChannels = new Map();
    const channels = w.__liveCursorsChannels;
    let ch = channels.get(scope);
    if (!ch) {
        ch = {
            refs: 0,
            unsub: null,
            closed: false,
            peers: new Map(),
            subs: new Set(),
            sweep: null
        };
        channels.set(scope, ch);
        const myName = (()=>{
            const person = (root.people || []).find((p)=>p?.email && String(p.email).toLowerCase() === String(me).toLowerCase());
            return person?.name || String(me).split('@')[0];
        })();
        try {
            const sdk = (0, $1NxyO.getSDK)();
            // The shell's SDK bootstrap wraps every method in an init gate that
            // returns a PROMISE of the real return value — storing it directly left
            // ch.unsub as a Promise, so `.sendCursor` was undefined and every send
            // silently no-op'd (cursors never left the tab). Resolve it, then bind.
            const pending = sdk?.subscribePresence?.({
                scope: scope,
                userKey: me,
                meta: {
                    app: 'cursor'
                },
                onCursor: (payload)=>{
                    const peerId = payload?.peerId;
                    if (!peerId) return;
                    if (payload.gone) {
                        if (ch.peers.delete(peerId)) notify(ch, peerId, null);
                        return;
                    }
                    const peer = {
                        x: +payload.x || 0,
                        y: +payload.y || 0,
                        userKey: payload.userKey || payload.userId || 'peer',
                        name: payload.name || null,
                        userId: payload.userId || null,
                        at: Date.now()
                    };
                    ch.peers.set(peerId, peer);
                    notify(ch, peerId, peer);
                }
            }, ()=>{
            /* roster sync unused here — cursor lifecycle is event + sweep driven */ });
            Promise.resolve(pending).then((u)=>{
                if (ch.closed) {
                    try {
                        if (typeof u === 'function') u();
                    } catch (_) {}
                    return;
                }
                ch.unsub = typeof u === 'function' ? u : null;
            }).catch((err)=>console.warn('[liveCursors] subscribe failed:', err?.message || err));
            ch.myName = myName;
        } catch (err) {
            console.warn('[liveCursors] subscribe failed:', err?.message || err);
        }
        // Stale sweep: a peer that stopped moving (tab hidden, network drop the
        // server's gone-event missed) fades out instead of freezing forever.
        ch.sweep = setInterval(()=>{
            const now = Date.now();
            for (const [peerId, peer] of ch.peers)if (now - peer.at > STALE_PEER_MS) {
                ch.peers.delete(peerId);
                notify(ch, peerId, null);
            }
        }, SWEEP_MS);
    }
    ch.refs++;
    ch.subs.add(onPeer);
    // Late joiner sees peers already in flight.
    for (const [peerId, peer] of ch.peers)try {
        onPeer(peerId, peer);
    } catch (_) {}
    let lastSent = 0;
    let trailing = null;
    const send = (data = {})=>{
        const fire = ()=>{
            lastSent = Date.now();
            try {
                ch.unsub?.sendCursor?.({
                    ...data,
                    name: ch.myName
                });
            } catch (_) {
            /* socket mid-reconnect — next move resends */ }
        };
        const wait = SEND_THROTTLE_MS - (Date.now() - lastSent);
        if (wait <= 0) {
            if (trailing) {
                clearTimeout(trailing);
                trailing = null;
            }
            fire();
        } else {
            // Trailing send so the FINAL resting position always lands.
            if (trailing) clearTimeout(trailing);
            trailing = setTimeout(fire, wait);
        }
    };
    let left = false;
    const leave = ()=>{
        if (left) return;
        left = true;
        if (trailing) clearTimeout(trailing);
        ch.subs.delete(onPeer);
        ch.refs = Math.max(0, ch.refs - 1);
        if (ch.refs === 0) {
            clearInterval(ch.sweep);
            // `closed` covers the still-resolving init-gate promise: its .then sees
            // the flag and disconnects the socket the moment it lands.
            ch.closed = true;
            try {
                ch.unsub?.sendCursor?.({
                    gone: true
                });
            } catch (_) {}
            try {
                ch.unsub?.();
            } catch (_) {}
            channels.delete(scope);
        }
    };
    return {
        scope: scope,
        send: send,
        leave: leave
    };
}

});

parcelRegister("4xYPy", function(module, exports) {

$parcel$export(module.exports, "checkCatalogFilter", () => $34f96e302a50f1b0$export$4dd18f814875ad2d);
$parcel$export(module.exports, "openInstallableModal", () => $34f96e302a50f1b0$export$3f6180825f28be87);
// openInstallableModal — Phase 4 real implementation.
//
// Registered as a shared function so el.call('openInstallableModal', opts)
// resolves from InstallableRail.js, InstallableRailItem.js, canvas tiles,
// dashboard, admin, and any other surface that needs to trigger the
// MarketplaceInstallModal without owning a marketplace island.
//
// Replaces the Phase 3 stub (which only console.warn'd + set root.state._installableModal).
//
// Delegation strategy:
//   1. Try to find a marketplace host via the marketplaceHostOf walk
//      (works when called from inside or adjacent to a MarketplaceIsland).
//   2. Fall back to root.state when outside a marketplace island — the
//      InstallableModalStub mounted at the app root also listens to
//      root.state._installableModal so it can show a fallback modal.
//   3. When a marketplace host IS found, delegate directly to the full
//      MarketplaceInstallModal via host.update({ installModal: ... }).
//
// Args:
//   domain        – 'integration'|'library'|'mcp'|'plugin'|'template'
//   kind          – kind key string (= preselectedKind), e.g. 'github'
//   installed     – boolean (true = manage flow, false = install flow)
//   defaultScope  – { type: 'org'|'workspace'|'project', id: string }
//   catalogFilter – filter object (category, applicable_to_types, applicable_to_scopes)
//   onInstalled   – (instance) => void callback
//
// Contract is the same as marketplace's openInstallableModal — this module
// is the single shared registration point; the marketplace package contains
// the full logic.
// checkCatalogFilter — the ONE catalogue-filter check.
//
// Registered as a shared function so `el.call('checkCatalogFilter', item,
// filter)` resolves from openInstallableModal below (the moment the modal
// OPENS) and from the marketplace's submitInstallModal (the moment the user
// presses Install — a defensive second look, because the catalogue can change
// in between). It used to be two copies: this file's held English sentences,
// the marketplace's read `marketplace.install.*`, so a Georgian workspace saw a
// different language depending on WHICH of the two refused. It is one function
// now, and the wording is the bundle's alone
// (DESIGN-SHARED-AICONTEXTBAR-AND-INSTALLABLE-ENGLISH-COPY-1).
//
// The filter is an object with optional keys:
//   category             – string; item.category must match
//   applicable_to_types  – string[]; item._liveKind?.applicable_to_types must overlap
//   applicable_to_scopes – string[]; item._liveKind?.applicable_to_scopes must overlap
//
// Returns null when the item passes, or the message — resolved through
// polyglot on the calling element, in the session language — when it fails.
// Each refusal is its own written-out key; the values it names (a category
// slug, type and scope ids) fill placeholders, never a concatenation.
//
// FA204: nothing here reads a module-scope name — the element arrives as `this`.
function $34f96e302a50f1b0$export$4dd18f814875ad2d(item, catalogFilter) {
    if (!catalogFilter || !item) return null;
    const el = this;
    if (catalogFilter.category && item.category !== catalogFilter.category) return el.call('polyglot', 'marketplace.install.wrongCategory').replace('{category}', item.category || '').replace('{required}', catalogFilter.category);
    if (Array.isArray(catalogFilter.applicable_to_types) && catalogFilter.applicable_to_types.length > 0) {
        const itemTypes = item._liveKind?.applicable_to_types || [];
        const overlap = catalogFilter.applicable_to_types.some((t)=>itemTypes.includes(t));
        if (!overlap) return el.call('polyglot', 'marketplace.install.wrongTypes').replace('{types}', catalogFilter.applicable_to_types.join(', '));
    }
    if (Array.isArray(catalogFilter.applicable_to_scopes) && catalogFilter.applicable_to_scopes.length > 0) {
        const itemScopes = item._liveKind?.applicable_to_scopes || [];
        const overlap = catalogFilter.applicable_to_scopes.some((s)=>itemScopes.includes(s));
        if (!overlap) return el.call('polyglot', 'marketplace.install.wrongScopes').replace('{scopes}', catalogFilter.applicable_to_scopes.join(', '));
    }
    return null;
}
function $34f96e302a50f1b0$export$3f6180825f28be87(opts) {
    // Walk up to find a marketplace host element (same algorithm as
    // marketplaceHostOf in marketplace/functions/index.js, duplicated
    // here to avoid cross-package imports).
    function _findMarketplaceHost(el) {
        let cur = el;
        let lastWithState = null;
        while(cur){
            if (cur._marketplaceHost && cur.state) return cur.state;
            if (cur.state) lastWithState = cur;
            if (!cur.parent) break;
            cur = cur.parent;
        }
        return lastWithState?.state || el?.state || null;
    }
    // Resolve item from catalogue by kind slug.
    // Mirrors the slug-matching logic in marketplace/functions/index.js
    // so the lookup works regardless of which package this is called from.
    function _slugForId(id) {
        return String(id || '').replace(/^(int|reg|plg|tpl|lib)\./, '').replace(/-/g, '_');
    }
    function _findItemByKind(catalog, kind) {
        if (!Array.isArray(catalog) || !kind) return null;
        return catalog.find((i)=>{
            const s = _slugForId(i.id);
            return s === kind || i.id === kind || i.id === `int.${kind}` || i.id === `plg.${kind}` || i.id === `lib.${kind}` || i.id === `tpl.${kind}`;
        }) || null;
    }
    // Domains whose `kind` is an opaque PER-TENANT INSTANCE id, never a slug
    // that could appear in `host.catalog` (the marketplace's own browse
    // catalogue of static + SDK-project-backed entries — github/slack/notion/
    // templates/libraries/apps). `host.catalog` genuinely DOES carry entries
    // for library/template/plugin/app (prefixed `lib.`/`tpl.`/`plg.` ids,
    // matched by `_findItemByKind` above) — those domains keep the catalogue
    // lookup. `mcp` is different: McpConnector rows are free-form name+url
    // Mongo docs with no enum/catalogue at all (see
    // shared/components/InstallableRail.js's `_deriveSelfKinds` — each
    // installed connector self-derives its own tile, `kind: <connector's real
    // id>`). Matching that opaque id against host.catalog can never succeed —
    // this was tickets/workspace.md "installed-tile manage click resolves
    // against the wrong catalog for every non-integration domain": every
    // domain OTHER than integration hit the same miss in theory, but mcp is
    // the first to actually reach a browser with real self-derived data.
    //
    // NOTE: this is intentionally a DIFFERENT (narrower) set than
    // InstallableRail.js's own `_KIND_CATALOG_DOMAINS` — that constant answers
    // "does this domain have a kinds-ENUMERATION endpoint to poll?" (only
    // `integration` does, via `listIntegrationKinds`), a different question
    // from "does host.catalog carry entries for this domain at all?" (it does,
    // for library/template/plugin/app — those are browsable in the main
    // marketplace grid even though InstallableRail has no live kinds feed for
    // them yet). Reusing InstallableRail's set here would have wrongly routed
    // template/library/plugin/app manage-clicks (see canvas/pages/dashboard.js
    // `OpenInstallable`/`Details`) away from their real, working catalogue hit.
    const _NO_CATALOG_DOMAINS = new Set([
        'mcp'
    ]);
    // Generic config-schema for domains in `_NO_CATALOG_DOMAINS` that also need
    // a real form to CREATE a brand new instance (the "Add" button — no `kind`
    // yet, nothing to resolve). There is no catalogue to browse, so the "item"
    // IS the form itself. Field set mirrors
    // canvas/components/MCPConnectorPickerOverlay.js 1:1 (url, transport,
    // authKind, authToken; `displayName` reuses the modal's existing built-in
    // DisplayNameField, gated on `allows_multiple`) so both entry points to the
    // same backend collect the identical shape
    // `_submitMcpDomain`/`saveMcpConnector` expect. Rendered by the marketplace
    // modal's existing generic `DynamicConfigFields` — no changes needed there.
    const _NO_CATALOG_ADD_SCHEMAS = {
        mcp: {
            allows_multiple: true,
            auth_model: 'none',
            config_schema: {
                fields: [
                    {
                        key: 'url',
                        label: 'apps.mcp.field.url',
                        required: true,
                        placeholder: 'https://mcp.example.com'
                    },
                    {
                        key: 'transport',
                        label: 'apps.mcp.field.transport',
                        required: false,
                        placeholder: 'sse'
                    },
                    {
                        key: 'authKind',
                        label: 'apps.mcp.field.authKind',
                        required: false,
                        placeholder: 'none'
                    },
                    {
                        key: 'authToken',
                        label: 'apps.mcp.field.authToken',
                        required: false,
                        placeholder: ''
                    }
                ]
            }
        }
    };
    const el = this;
    const domain = opts?.domain || null;
    const kind = opts?.kind || opts?.preselectedKind || null;
    const installed = !!opts?.installed;
    const defaultScope = opts?.defaultScope || null;
    const catalogFilter = opts?.catalogFilter || null;
    const onInstalled = typeof opts?.onInstalled === 'function' ? opts.onInstalled : null;
    // Self-describing display info the CLICK SITE already has (InstallableRailItem
    // forwards its own tile state — see InstallableRail.js's self-derived kinds).
    // Only consumed below for domains in `_NO_CATALOG_DOMAINS`, where there is no
    // catalogue to enrich the item from.
    const selfDisplay = opts?.display || null;
    // 1. Walk element tree to find a MarketplaceIsland host.
    let host = null;
    try {
        host = _findMarketplaceHost(el);
    } catch  {}
    // 2. Fall back to root.state when outside a marketplace island.
    if (!host) try {
        const root = el.getRoot?.();
        if (root?.state) host = root.state;
    } catch  {}
    if (!host) {
        console.warn('[openInstallableModal] Could not resolve host state. opts:', opts);
        return;
    }
    const catalog = host.catalog || [];
    // 3. Resolve the item — per domain, against the source that actually owns
    // it (tickets/workspace.md "installed-tile manage click resolves against
    // the wrong catalog for every non-integration domain"). Domains in
    // `_NO_CATALOG_DOMAINS` (today: mcp) have no catalogue at all — matching
    // their opaque per-tenant instance id against `host.catalog` can never
    // succeed, so skip that lookup entirely rather than surfacing a false
    // "not available in the current catalogue" error for a perfectly real,
    // installed instance.
    let item = null;
    if (kind && _NO_CATALOG_DOMAINS.has(domain)) {
        // The click site (InstallableRailItem) already has everything needed —
        // it forwarded its own tile state (`display`), which was itself
        // self-derived from the real instance (InstallableRail.js
        // `_deriveSelfKinds`). No network round-trip, no catalogue guess.
        item = {
            id: kind,
            kind: kind,
            name: selfDisplay?.label || kind,
            domain: domain,
            display: selfDisplay || undefined
        };
        const filterError = el.call('checkCatalogFilter', item, catalogFilter);
        if (filterError) {
            host.update?.({
                installModal: {
                    item: item,
                    step: 'config',
                    draft: {},
                    domain: domain,
                    defaultScope: defaultScope,
                    catalogFilter: catalogFilter,
                    onInstalled: onInstalled,
                    _catalogError: filterError
                },
                _installModalError: null
            });
            return;
        }
    } else if (kind) {
        item = _findItemByKind(catalog, kind);
        if (!item) {
            // Kind not found in catalogue — open modal with catalogError.
            host.update?.({
                installModal: {
                    item: {
                        name: kind,
                        id: kind,
                        kind: domain || 'integration'
                    },
                    step: 'config',
                    draft: {},
                    domain: domain,
                    defaultScope: defaultScope,
                    catalogFilter: catalogFilter,
                    onInstalled: onInstalled,
                    _catalogError: el.call('polyglot', 'marketplace.install.kindNotInCatalogue').replace('{kind}', ()=>kind)
                },
                _installModalError: null
            });
            return;
        }
        // 4. Validate catalogFilter against the found item.
        const filterError = el.call('checkCatalogFilter', item, catalogFilter);
        if (filterError) {
            host.update?.({
                installModal: {
                    item: item,
                    step: 'config',
                    draft: {},
                    domain: domain,
                    defaultScope: defaultScope,
                    catalogFilter: catalogFilter,
                    onInstalled: onInstalled,
                    _catalogError: filterError
                },
                _installModalError: null
            });
            return;
        }
    } else if (domain && _NO_CATALOG_DOMAINS.has(domain) && _NO_CATALOG_ADD_SCHEMAS[domain]) // No kind AND no catalogue — the "Add <domain>" entry point (see
    // InstallableRailAddButton.onClick). There's nothing to pick from a
    // catalogue; the item IS the config form (tickets/workspace.md
    // "`_submitMcpDomain` install-modal write path is a stale stub" —
    // without a real item here, `submitInstallModal` bails out on its
    // `if (!modal?.item) return` guard before ever reaching the domain
    // dispatcher, so the write path could never even be exercised through
    // this modal).
    item = {
        id: domain,
        kind: domain,
        name: domain === 'mcp' ? el.call('polyglot', 'marketplace.install.mcpConnector') : domain,
        domain: domain,
        _liveKind: _NO_CATALOG_ADD_SCHEMAS[domain]
    };
    // 5. Build initial draft — apply defaultScope if provided.
    const draft = {};
    if (defaultScope?.type) {
        draft.scopeType = defaultScope.type;
        if (defaultScope.id) draft.scopeId = defaultScope.id;
    } else if (item?._liveKind?.default_scope) draft.scopeType = item._liveKind.default_scope;
    // 6. Determine opening step.
    const openStep = defaultScope || installed ? 'config' : 'scope';
    host.update?.({
        installModal: {
            item: item || null,
            step: openStep,
            draft: draft,
            domain: domain,
            defaultScope: defaultScope,
            catalogFilter: catalogFilter,
            onInstalled: onInstalled,
            _catalogError: null
        },
        _installModalError: null
    });
}

});

parcelRegister("7hbEo", function(module, exports) {

$parcel$export(module.exports, "isCoarsePointer", () => $54c32877ee5becda$export$19f40a8263c07ba7);
$parcel$export(module.exports, "refreshPointerCapability", () => $54c32877ee5becda$export$d2468d80ea3fd365);
$parcel$export(module.exports, "panZoomHint", () => $54c32877ee5becda$export$486e18030e0ab3f8);
$parcel$export(module.exports, "syncPointerCapability", () => $54c32877ee5becda$export$977d1dafc8984624);
// Device-capability layer for touch / coarse-pointer adaptation.
//
// The workspace had NO coarse-pointer detection anywhere, so every canvas
// board kept its mouse-only interaction model on touchscreens. This module is
// the single switch the iPad touch-parity fixes read — panzoom drag gates,
// long-press context menus, 44px touch targets, keyboard avoidance — exposed
// two ways:
//   • JS:  el.call('isCoarsePointer') inside any DOMQL factory
//   • CSS: <html data-pointer="coarse|fine"> (mirrors data-shell-route/data-theme)
//
// FA204/FA207 / frank trap — the memoized `_coarse` flag and the `_synced`
// one-time listener guard used to be plain module-scope `let`s, read/written
// across FOUR exported functions with no `el`/`root` argument anywhere in
// this file to hoist that state onto
// (project_frank_drops_module_local_helpers). Unlike a pure performance
// cache, losing this state actually changes behavior (isCoarsePointer would
// silently return the wrong value once `_coarse` reads as `undefined`
// post-frank — `undefined !== null` is true, so the memo branch would
// short-circuit and return `undefined` instead of ever computing the real
// value; `_synced` reset to false on every call would re-register the
// media-query listener every time). Re-homed onto
// `window.__pointerCapabilityState` (lazily created, inlined identically in
// each export below — a shared getter function would just relocate the same
// bare-sibling-call hazard) — the same always-reachable-global escape hatch
// the shell's own `window.__smblsPathPatched` sentinel uses, since there's
// no `el`/`root` argument here to use `el.context`/`root.__x` the way other
// files in this sweep do.
// True on touch-primary devices (iPad, phones). Uses the primary-pointer media
// query OR maxTouchPoints, so a hybrid device with a touchscreen still opts in.
// Memoized; call refreshPointerCapability() to re-evaluate after a pointer
// change (e.g. an iPad Magic Keyboard trackpad attaching/detaching).
const $54c32877ee5becda$export$19f40a8263c07ba7 = ()=>{
    if (typeof window === 'undefined') return false;
    if (!window.__pointerCapabilityState) window.__pointerCapabilityState = {
        coarse: null,
        synced: false
    };
    const state = window.__pointerCapabilityState;
    if (state.coarse !== null) return state.coarse;
    const coarseMq = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    const touch = typeof navigator !== 'undefined' && (navigator.maxTouchPoints || 0) > 0;
    state.coarse = coarseMq || touch;
    return state.coarse;
};
const $54c32877ee5becda$export$d2468d80ea3fd365 = ()=>{
    if (typeof window === 'undefined') return false;
    if (!window.__pointerCapabilityState) window.__pointerCapabilityState = {
        coarse: null,
        synced: false
    };
    const state = window.__pointerCapabilityState;
    state.coarse = null;
    const coarseMq = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    const touch = typeof navigator !== 'undefined' && (navigator.maxTouchPoints || 0) > 0;
    state.coarse = coarseMq || touch;
    return state.coarse;
};
function $54c32877ee5becda$export$486e18030e0ab3f8() {
    const el = this && typeof this.call === 'function' ? this : null;
    const sentence = (key, fallback)=>{
        const text = el ? el.call('polyglot', key) : null;
        return text && text !== key ? text : fallback;
    };
    let coarse = false;
    if (typeof window !== 'undefined') {
        if (!window.__pointerCapabilityState) window.__pointerCapabilityState = {
            coarse: null,
            synced: false
        };
        const state = window.__pointerCapabilityState;
        if (state.coarse !== null) coarse = state.coarse;
        else {
            const coarseMq = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
            const touch = typeof navigator !== 'undefined' && (navigator.maxTouchPoints || 0) > 0;
            coarse = coarseMq || touch;
            state.coarse = coarse;
        }
    }
    return coarse ? sentence('common.hint.panTouch', 'Drag to pan, pinch to zoom.') : sentence('common.hint.panWheel', "Wheel to pan, \u2318/Ctrl + wheel to zoom.");
}
const $54c32877ee5becda$export$977d1dafc8984624 = ()=>{
    if (typeof document === 'undefined') return;
    if (!window.__pointerCapabilityState) window.__pointerCapabilityState = {
        coarse: null,
        synced: false
    };
    const state = window.__pointerCapabilityState;
    const apply = ()=>{
        state.coarse = null;
        const coarseMq = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
        const touch = typeof navigator !== 'undefined' && (navigator.maxTouchPoints || 0) > 0;
        state.coarse = coarseMq || touch;
        document.documentElement.setAttribute('data-pointer', state.coarse ? 'coarse' : 'fine');
    };
    apply();
    if (state.synced) return;
    state.synced = true;
    try {
        const mq = window.matchMedia && window.matchMedia('(pointer: coarse)');
        if (mq && mq.addEventListener) mq.addEventListener('change', apply);
    } catch (err) {
        console.warn('[pointerCapability] media listener failed', err);
    }
};

});

parcelRegister("amN0s", function(module, exports) {

$parcel$export(module.exports, "armLongPress", () => $78c1f91f93db3a16$export$80e2bc7b45f6e6af);
// Long-press → synthetic `contextmenu` shim (coarse-pointer only).
//
// iPad Safari fires the native `contextmenu` event inconsistently on a long
// touch and NEVER for Apple Pencil, so every per-item action menu wired through
// `onContextmenu` / `addEventListener('contextmenu')` (files rename/delete/move,
// canvas node ops, ticket ops) is unreachable by touch. This detector watches
// for a ~500ms stationary finger/pen press and, on fire, dispatches a synthetic
// `contextmenu` MouseEvent at the touch point on the REAL touched target.
//
// Because that synthetic event bubbles (`bubbles: true`) and is otherwise
// indistinguishable from a real right-click, it drives BOTH transports already
// present in this repo:
//   • DOMQL `onContextmenu` flat handlers (canvas surface/item)
//   • native `addEventListener('contextmenu', …)` listeners (files/tickets stage)
// and it honours whatever `stopPropagation` those handlers already do (e.g.
// CanvasItem stops the bubble so the item menu wins over the empty-canvas menu).
// That faithfulness is why arming ONCE at a surface's stage/root element covers
// every child — the event bubbles up from the touched descendant exactly as a
// real right-click would.
//
// `this`-bound: `this` = the element. Wire via `el.call('armLongPress')` /
// `this.call('armLongPress')` inside a surface's existing onCreate/onRender,
// beside its contextmenu setup. Idempotent per node.
function $78c1f91f93db3a16$export$80e2bc7b45f6e6af() {
    // FA204 / frank trap — inlined as self-contained locals (this file's sole
    // export is a `this`-bound function with no `el`/`root` shared-state
    // argument; these are pure constants, not cross-call state, so they get
    // no window/globalThis re-home — just moved inside the one function that
    // reads them, per project_frank_drops_module_local_helpers).
    const LONG_PRESS_MS = 500 // iOS system long-press threshold
    ;
    const MOVE_TOLERANCE = 10 // px of finger travel that cancels the press
    ;
    const el = this;
    const node = el && el.node;
    // Reading el.node + attaching native listeners is the established pattern for
    // contextmenu on these surfaces (DOMQL doesn't delegate `onContextmenu` in the
    // shell). Idempotent per node — a re-render swaps in a fresh unflagged node.
    if (!node || node.__longPressArmed) return;
    // Fine-pointer devices already get a real `contextmenu` on right-click, so the
    // shim only attaches on touch surfaces. Gate on the shared capability layer
    // (memoized) — zero listener overhead on desktop.
    if (typeof el.call === 'function' && !el.call('isCoarsePointer')) return;
    node.__longPressArmed = true;
    // Transient press-tracking state lives in this closure (per-arm, non-reactive):
    // a 500ms timer + the press-start coordinates. It is deliberately NOT on
    // el.scope — that is a reactive signal store, and a rapidly-cleared timer id
    // has no business creating signals or triggering effects.
    let timer = null;
    let startX = 0;
    let startY = 0;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    const onPointerdown = (e)=>{
        // Only synthesize for touch / pen. A mouse or trackpad — even on a hybrid
        // coarse device (iPad + Magic Keyboard) — keeps its native right-click menu,
        // so guard against a phantom long-press there too.
        if (e.pointerType !== 'touch' && e.pointerType !== 'pen') return;
        clear();
        startX = e.clientX;
        startY = e.clientY;
        const target = e.target;
        timer = setTimeout(()=>{
            timer = null;
            if (!target) return;
            // Dispatch on the actual touched descendant so the event bubbles through
            // every ancestor handler (item → surface) — clientX/Y at the stationary
            // press point feed the menu's anchor + `target.closest()` item resolution.
            target.dispatchEvent(new MouseEvent('contextmenu', {
                bubbles: true,
                cancelable: true,
                clientX: startX,
                clientY: startY,
                view: window
            }));
        }, LONG_PRESS_MS);
    };
    const onPointermove = (e)=>{
        if (!timer) return;
        // A finger that travels past the tolerance is a scroll/pan/drag, not a press.
        if (Math.abs(e.clientX - startX) > MOVE_TOLERANCE || Math.abs(e.clientY - startY) > MOVE_TOLERANCE) clear();
    };
    // Passive: these handlers never call preventDefault synchronously (the only
    // side effect is a deferred synthetic dispatch), so they can't block scroll
    // and coexist with the surface's own pan/marquee/drag pointer handlers.
    node.addEventListener('pointerdown', onPointerdown, {
        passive: true
    });
    node.addEventListener('pointermove', onPointermove, {
        passive: true
    });
    node.addEventListener('pointerup', clear, {
        passive: true
    });
    node.addEventListener('pointercancel', clear, {
        passive: true
    });
}

});

parcelRegister("ipW4B", function(module, exports) {

$parcel$export(module.exports, "armEdgeSwipe", () => $d6879bf18bdf0d41$export$3209e0a8ae7badf9);
// Left-edge pull → open the app's rail sheet; left-swipe on the sheet (or
// scrim tap, handled by the sheet component) → close. The PHONE gesture
// vocabulary's first verb (2026-08-02 per Nika "off canvas menus, swipes,
// gestures … efficient, productive and cool"): every app teaches the same
// motion, so the hand learns it once — tickets filters, calendar controls,
// chat conversations, documents browse all answer to the same pull.
//
// Design constraints (deliberate):
// • The OPEN gesture arms only within EDGE_ZONE px of the viewport's left
//   edge — it can never fight panzoom boards, horizontal scrollers or the
//   tab strip, all of which start further in.
// • The sheet follows the finger (interruptible, transform-only writes on
//   the sheet node), commits past 35% width or a quick flick, and settles
//   with a WAAPI ease that collapses to instant under prefers-reduced-motion.
// • Coarse pointers only — desktop keeps its persistent rails.
//
// Wiring (an app's stage root, beside its other arm calls):
//   onRender: (el, s) => el.call('armEdgeSwipe', { stateKey: '_ticketsRailOpen' })
// The sheet component itself reads/writes the same root state key — see
// shared/components/MobileRailSheet.js.
function $d6879bf18bdf0d41$export$3209e0a8ae7badf9(opts) {
    // FA204 / frank trap — inlined as self-contained locals (single
    // `this`-bound export, pure constants, not cross-call state — see
    // longPress.js for the identical shape).
    const EDGE_ZONE = 24;
    const COMMIT_FRACTION = 0.35;
    const FLICK_PX_PER_MS = 0.35;
    const el = this;
    const node = el && el.node;
    if (!node || node.__edgeSwipeArmed) return;
    if (typeof el.call === 'function' && !el.call('isCoarsePointer')) return;
    const stateKey = opts && opts.stateKey;
    if (!stateKey) return;
    node.__edgeSwipeArmed = true;
    // Transient gesture state — closure-local, never reactive (mirrors the
    // armLongPress idiom; a mid-gesture x coordinate has no business in
    // signals).
    let tracking = false;
    let startX = 0;
    let startY = 0;
    let startTs = 0;
    let lastX = 0;
    let axisLock = null // 'x' once horizontal intent is clear, 'veto' if vertical
    ;
    const root = ()=>typeof el.getRootState === 'function' ? el.getRootState() : el.state?.root;
    const sheetNode = ()=>node.ownerDocument.querySelector(`[data-mobile-rail="${stateKey}"] [data-rail-card]`);
    const setDrag = (px)=>{
        const sheet = sheetNode();
        if (!sheet) return;
        // Follow the finger from the closed position (-105%) toward 0.
        const w = sheet.getBoundingClientRect().width || 300;
        const progress = Math.max(0, Math.min(1, px / w));
        sheet.style.transition = 'none';
        sheet.style.transform = `translateX(${(-1.05 + 1.05 * progress) * 100}%)`;
    };
    const settle = (open)=>{
        const sheet = sheetNode();
        if (sheet) {
            sheet.style.transition = '';
            sheet.style.transform = '';
        }
        const r = root();
        if (r && !!r[stateKey] !== open) r.update({
            [stateKey]: open
        }, {
            preventFetch: true
        });
    };
    const onDown = (e)=>{
        if (e.pointerType === 'mouse') return;
        const r = root();
        if (r && r[stateKey]) return; // open-state gestures belong to the sheet
        if (e.clientX > EDGE_ZONE) return;
        tracking = true;
        axisLock = null;
        startX = lastX = e.clientX;
        startY = e.clientY;
        startTs = e.timeStamp;
    };
    const onMove = (e)=>{
        if (!tracking) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (!axisLock) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            axisLock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'veto';
        }
        if (axisLock === 'veto') {
            tracking = false;
            return;
        }
        lastX = e.clientX;
        setDrag(dx);
    };
    const onUp = (e)=>{
        if (!tracking) return;
        tracking = false;
        if (axisLock !== 'x') return;
        const sheet = sheetNode();
        const w = sheet && sheet.getBoundingClientRect().width || 300;
        const dx = lastX - startX;
        const dt = Math.max(1, e.timeStamp - startTs);
        const commit = dx > w * COMMIT_FRACTION || dx / dt > FLICK_PX_PER_MS;
        settle(commit);
    };
    // Passive — the drag writes transforms, never preventDefault; vertical
    // scrolling stays native (the axis veto drops the gesture instead).
    node.addEventListener('pointerdown', onDown, {
        passive: true
    });
    node.addEventListener('pointermove', onMove, {
        passive: true
    });
    node.addEventListener('pointerup', onUp, {
        passive: true
    });
    node.addEventListener('pointercancel', onUp, {
        passive: true
    });
}

});

parcelRegister("6cUG1", function(module, exports) {

$parcel$export(module.exports, "armNavCondense", () => $484fd3e0335a73df$export$7e17d8d7cd9c9939);
// Scroll-condense for the merged mobile "one deck" header (2026-08-02, per
// Nika "make navbars on mobile smarter … native-like ux and performance").
// A capture-phase 'scroll' listener on `document` sees every scrollport in
// the page — a plain bubble-phase listener can't, because 'scroll' does not
// bubble — so this is the ONE place that needs to know about scrolling; no
// page wires its own listener (mirrors the edgeSwipe.js one-shot-arm idiom,
// but armed ONCE for the whole document rather than once per page root: the
// deck it drives is a single shell-mounted element, not a per-app rail).
//
// Perf contract: rAF-throttled, passive, and writes NOTHING to signals/state
// — only a `data-nav-condensed` attribute on <html> that the deck's own CSS
// (packages/workspace/app.js injected shell stylesheet) reacts to with a
// transform. Same `html[data-X]` attribute + CSS-reacts idiom as
// data-chat-drawer.
//
// prefers-reduced-motion needs no special-casing here: app.js's global
// reduced-motion floor (`*,*::before,*::after{transition-duration:.01ms
// !important}`) already collapses the deck's transform transition to an
// instant swap — a second override here would be redundant.

var $7hbEo = parcelRequire("7hbEo");
const $484fd3e0335a73df$export$7e17d8d7cd9c9939 = (mobileQuery)=>{
    if (typeof document === 'undefined' || typeof window === 'undefined') return;
    const state = window.__navCondenseState || {
        armed: false,
        scheduled: false,
        pendingTarget: null,
        // Per-scrollport last-known position. Never reactive: a mid-scroll
        // pixel offset has no business on a signal. Keyed by the scroll NODE
        // (not the deck), so a tickets board and a chat list each track their
        // own delta correctly.
        lastY: new WeakMap()
    };
    window.__navCondenseState = state;
    if (state.armed) return;
    state.armed = true;
    const HYSTERESIS_PX = 12;
    const ALWAYS_VISIBLE_PX = 24;
    const gateActive = ()=>typeof window !== 'undefined' && (0, $7hbEo.isCoarsePointer)() && !!mobileQuery && !!window.matchMedia?.(mobileQuery)?.matches;
    // 'scroll' fires with `document`/`window` as the target for the root
    // scroller — normalize both to documentElement, the node whose scrollTop
    // is actually meaningful.
    const resolveNode = (target)=>target === document || target === window ? document.documentElement : target;
    const resolveY = (target)=>{
        if (target === document || target === window) return window.scrollY || document.documentElement.scrollTop || 0;
        return target && typeof target.scrollTop === 'number' ? target.scrollTop : null;
    };
    const condense = ()=>{
        const html = document.documentElement;
        if (html.dataset.navCondensed === 'true') return;
        html.dataset.navCondensed = 'true';
    };
    const reveal = ()=>{
        const html = document.documentElement;
        if (!('navCondensed' in html.dataset)) return;
        delete html.dataset.navCondensed;
    };
    const processScroll = (target)=>{
        if (!gateActive()) {
            // Width/pointer no longer qualifies (e.g. a resize crossed @mobileL)
            // — never leave the deck stuck hidden outside the context that's
            // allowed to hide it.
            reveal();
            return;
        }
        const y = resolveY(target);
        if (y == null) return;
        const node = resolveNode(target);
        const last = state.lastY.get(node);
        state.lastY.set(node, y);
        // Always visible near the top — a user who scrolls back up to the
        // very start of the content shouldn't have to also out-scroll the
        // hysteresis band to get the deck back.
        if (y < ALWAYS_VISIBLE_PX) {
            reveal();
            return;
        }
        // First sample for this scrollport — record the baseline, no
        // direction to act on yet (a fresh scrollport must never condense on
        // its very first tick).
        if (last == null) return;
        const dy = y - last;
        if (dy > HYSTERESIS_PX) condense();
        else if (dy < -HYSTERESIS_PX) reveal();
    };
    const onScroll = (e)=>{
        state.pendingTarget = e.target;
        if (state.scheduled) return;
        state.scheduled = true;
        requestAnimationFrame(()=>{
            state.scheduled = false;
            processScroll(state.pendingTarget);
        });
    };
    // Focus must never be trapped behind a condensed deck — reveal the
    // instant focus lands on anything inside it (tab-key navigation, a
    // screen reader's virtual cursor, an autofocused field).
    const onFocusIn = (e)=>{
        const deck = document.querySelector('[data-key="AppHeader"]');
        if (deck && e.target && deck.contains(e.target)) reveal();
    };
    // A fresh route/sheet is a fresh screen — same expectation as a native
    // app, which always shows its own nav bar on arrival regardless of where
    // the previous screen's scroll position left off. Reuses the same
    // pushState-patch events HeaderTabs.onCreate's syncActive already
    // listens for, so this adds no new instrumentation to the shell.
    const onNav = ()=>reveal();
    // Width/pointer can change without a scroll (an iPad rotating, a resized
    // browser window) — re-validate the gate so a stale condensed deck can
    // never survive outside the phone+coarse context that's allowed to hide
    // it.
    const onResize = ()=>{
        if (!gateActive()) reveal();
    };
    // capture:true — 'scroll' does not bubble, so this is the only phase
    // that sees a nested scrollport (a tickets board, a chat list, …) fire
    // at all.
    document.addEventListener('scroll', onScroll, {
        capture: true,
        passive: true
    });
    document.addEventListener('focusin', onFocusIn);
    window.addEventListener('popstate', onNav);
    window.addEventListener('locationchange', onNav);
    window.addEventListener('resize', onResize, {
        passive: true
    });
};

});

parcelRegister("k2xRl", function(module, exports) {

$parcel$export(module.exports, "isNativeShell", () => $e96e4251cf8e9085$export$e9ef618ee967d8ff);
$parcel$export(module.exports, "NATIVE_AUTH_SCHEMES", () => $e96e4251cf8e9085$export$6505b00b5ecb4925);
$parcel$export(module.exports, "nativeShellScheme", () => $e96e4251cf8e9085$export$8f43ca4f3bb44da3);
// Native device-shell detection — true ONLY inside the Symbols shell (the
// Tauri WKWebView wrapping my.symbols.app), false in every real browser
// including iOS Safari itself. Two independent signals, either suffices:
// 1. UA token — the shell appends `SymbolsShell` to the WebView user agent
//    (the shell's tauri.conf.json owns that config; this helper is written
//    against that contract).
// 2. Tauri runtime marker — `window.__TAURI_INTERNALS__` is injected by the
//    Tauri webview bootstrap, so detection holds even on a device build
//    where the UA config hasn't landed yet.
// Gates auth affordances that cannot work inside an embedded webview
// (Google OAuth — see shared/components/LoginWindow.js). Available anywhere
// via el.call('isNativeShell').
const $e96e4251cf8e9085$export$e9ef618ee967d8ff = ()=>{
    if (typeof window === 'undefined') return false;
    if (typeof navigator !== 'undefined' && navigator.userAgent?.includes('SymbolsShell')) return true;
    return !!window.__TAURI_INTERNALS__;
};
const $e96e4251cf8e9085$export$6505b00b5ecb4925 = [
    'symbols',
    'symbols-canary',
    'symbols-staging'
];
// UA token → scheme. Tokens are checked most-specific-first and are mutually
// exclusive by construction (each variant's conf.json sets exactly one).
const $e96e4251cf8e9085$var$SCHEME_BY_UA_TOKEN = [
    [
        'SymbolsCanary',
        'symbols-canary'
    ],
    [
        'SymbolsStaging',
        'symbols-staging'
    ]
];
const $e96e4251cf8e9085$export$8f43ca4f3bb44da3 = ()=>{
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const hit = $e96e4251cf8e9085$var$SCHEME_BY_UA_TOKEN.find((pair)=>ua?.includes(pair[0]));
    return hit ? hit[1] : 'symbols';
};

});

parcelRegister("rm3Ji", function(module, exports) {

$parcel$export(module.exports, "bootShell", () => $0523a2384472c61c$export$32c1b9ba1bdf9c70);
/**
 * bootShell — universal boot used by runner + standalones.
 *
 * Phase 7: dispatchUrl and wireGlobalListeners stubs removed.
 * The caller (workspace/packages/workspace/index.js or a standalone
 * app's index.js) is responsible for calling dispatchUrl + wireGlobalListeners
 * AFTER bootShell returns the shell element.
 *
 * Pattern A (single-app standalones): when `apps` has exactly one entry and
 * no pre-built `context` is supplied, bootShell resolves the manifest's `app`
 * and `context` factories, mounts the shell, then auto-dispatches the current
 * URL and wires popstate. Standalone wrappers stay tiny — one bootShell call,
 * no extra imports. Multi-app shells (workspace/index.js) continue to call
 * dispatchUrl + wireGlobalListeners explicitly after bootShell returns.
 *
 * Sequence handled here:
 *  1. Early lang/theme from localStorage
 *  2. (Polyglot init — caller responsibility before bootShell)
 *  3. (ensureSDKInit — caller responsibility, or pass pre-init sdk)
 *  4. registerSdkAdapter({ sdk })
 *  5. Build/merge context state
 *  6. Auth gate via sdk.auth.getMe() — unauthed → /login, returns null
 *  7. Eager USER + ORG + WORKSPACE + WORKSPACE_PROJECT scope fetch
 *  8. Mount shell via create(app, context) — returns shell element
 *  9. [single-app only] dispatchUrl(shell, path) — initial route
 * 10. [single-app only] wireGlobalListeners(shell, ...) — popstate + storage
 *
 * Multi-app callers then:
 *  9. dispatchUrl(shell, path) — initial route (workspace/dispatch.js)
 * 10. wireGlobalListeners(shell, ...) — popstate + storage (workspace/wireGlobalListeners.js)
 */ // Side-effect import — pins globalThis.WebSocket + scrubs Parcel's
// process.versions.node polyfill so a USER project's own supabase-js client
// (the bring-your-own-backend fetch adapter — a framework feature; the
// PLATFORM has no Supabase) constructs correctly inside the canvas. See
// bootShim.js for the Parcel Node-detection rationale.
parcelRequire("4BW22");

var $4skhB = parcelRequire("4skhB");

var $8NTf1 = parcelRequire("8NTf1");

var $cRTCE = parcelRequire("cRTCE");

var $grPR9 = parcelRequire("grPR9");

var $jH1GV = parcelRequire("jH1GV");

var $eANbz = parcelRequire("eANbz");

var $9IIym = parcelRequire("9IIym");
const $0523a2384472c61c$export$841ff13fd92b3904 = (err, maxDepth = 4)=>{
    const chain = [];
    let cur = err;
    for(let i = 0; cur && i < maxDepth; i++){
        chain.push(cur);
        cur = cur.cause;
    }
    return chain;
};
const $0523a2384472c61c$export$dd001fc7efb795c9 = (err)=>{
    // FA204 / frank trap — self-contained inline copy of _causeChain (a bare
    // sibling-export call is exactly as unresolvable post-frank.toJSON as a
    // module-local read); the export above stays live for its own unit tests.
    const _causeChainInline = (err, maxDepth = 4)=>{
        const chain = [];
        let cur = err;
        for(let i = 0; cur && i < maxDepth; i++){
            chain.push(cur);
            cur = cur.cause;
        }
        return chain;
    };
    if (!err) return false;
    // A numeric status anywhere in the chain is the server's own answer: only
    // 401 (or the explicit `invalid_token` code) means the token was refused.
    // Any other status — a 500 whose message happens to read "No workspace…" /
    // "unauthorized" — is NOT a rejection, so the prose fallback below runs
    // only when no status exists at all (a session must never be purged on a
    // server error).
    let sawStatus = false;
    for (const e of _causeChainInline(err)){
        const code = e?.code || e?.body?.code || e?.response?.body?.code;
        if (code === 'invalid_token') return true;
        const status = e?.status || e?.statusCode || e?.response?.status;
        if (status === 401) return true;
        if (typeof status === 'number') sawStatus = true;
    }
    if (sawStatus) return false;
    const s = String(err?.message || err || '');
    if (!s) return false;
    return /\binvalid (?:or expired )?(?:access )?token\b|\btoken (?:signature is invalid|has expired|is malformed|has been revoked)\b|\bno bearer token\b|\binvalid signature\b|signature[_\s]+mismatch|\bjwt (?:malformed|expired)\b|missing\s+(?:workspace|user|active[\s_]?workspace)?[\s_]*claim|no\s+(?:workspace|active workspace)|\bunauthor(?:i[sz]ed)?\b|HTTP 401\b|Request failed:.*401/i.test(s);
};
const $0523a2384472c61c$export$7bae9eea25b25142 = (err)=>{
    if ((0, $grPR9.currentChannelFromHost)() !== 'local') return false;
    const reasons = [];
    const codes = [];
    const parts = [];
    let cur = err;
    for(let i = 0; cur && i < 4; i++){
        reasons.push(String(cur.reason || cur.body?.reason || cur.response?.body?.reason || ''));
        codes.push(String(cur.code || cur.body?.code || cur.response?.body?.code || ''));
        parts.push(String(cur.message || cur.body?.message || ''));
        cur = cur.cause;
    }
    // A KNOWN reason of any other class is decisive and fail-closed —
    // expired / revoked / malformed / missing still purge, even on local.
    // This is what makes "signature-class ONLY" true by CONSTRUCTION rather
    // than by prose matching.
    if (reasons.some((r)=>r && r !== 'signature_mismatch')) return false;
    if (reasons.includes('signature_mismatch')) return true;
    if (codes.includes('invalid_signature')) return true;
    // Prose fallback ONLY. Note `token signature is invalid` — the wording
    // authError.js actually sends. The bare `invalid signature` alternative
    // is jsonwebtoken's INTERNAL string, which the server consumes and
    // replaces; it is kept only for a raw/unenveloped path.
    return /\btoken signature is invalid\b|\binvalid signature\b|signature[_\s]+mismatch/i.test(parts.join(' '));
};
// Module-side-effect: eagerly register the 'sdk' fetch adapter with a
// sdk-less loader at the TOP of the universal boot file. Lives here
// instead of inside sdkAdapter.js because Parcel was tree-shaking the
// trailing `registerAdapter('sdk', …)` from that file despite
// `"sideEffects": true` in packages/shared/package.json.
//
// Why eager: workspace-project/config.js declares
// `fetch: { adapter: 'sdk', sdk: getSDK() }` at module-load time, and
// any DOMQL element that consumes that decl fires `resolveDb` during
// create() — which throws "Unknown db adapter: 'sdk'" until something
// registers the adapter. bootShell's step-4 `registerSdkAdapter({ sdk })`
// runs LATER (after the auth gate), so element-init before that point
// crashes. Eager registration closes the race; the explicit-bound-sdk
// call still runs later and harmlessly overrides — both paths produce
// identical adapters because `buildSdkAdapter` resolves `sdk` from
// boundOptions OR the per-decl config (decl wins on key collision).
(0, $4skhB.registerAdapter)('sdk', ()=>Promise.resolve({
        setup: (decl = {})=>(0, $8NTf1.buildSdkAdapter)(decl)
    }));




const $0523a2384472c61c$export$32c1b9ba1bdf9c70 = async ({ apps: apps, defaultApp: defaultApp, fallbackRoute: fallbackRoute, sdk: sdk, context: context, publicSurface: publicSurface = false, getWorkspaceCached: // Optional dependency-injected getWorkspace coalescer (#17). The workspace
// passes its `getWorkspaceCached` so bootShell's eager scope-fetch shares the
// in-flight-dedup + short-TTL cache with loadWorkspaceProject / onWorkspaceChange
// — collapsing the duplicate boot getWorkspace round-trip. bootShell lives in
// `packages/shared` and can't import `packages/workspace`, hence injection.
// Consumers that don't pass it (preview) fall back to the raw sdk.getWorkspace.
getWorkspaceCached = null, primeWorkspaceCache: // Optional DI (the workspace's `primeWorkspaceCache`): seeds that cache with
// the boot's full-projection workspace rows, so the record is never read a
// second time on a cold load (see the prime call after sdk.boot()).
primeWorkspaceCache = null, warmSnapshot: warmSnapshot = null, steps: // The three boot steps (bootPrepare / bootResolve / bootApply), reached
// through the caller's functions registry — every entry passes
// `steps: _wsShared.functions`. bootShell imports none of them (FA001):
// the published shell runs the SAME three from its boot plugin.
steps = null })=>{
    // Opt-in boot breadcrumbs (`?trail=1`), inert otherwise — the only way to
    // see inside a boot that wedges the renderer. See bootTrail.js.
    /**
   * Minimal single-app dispatch + popstate wiring used when bootShell
   * auto-boots a standalone (single-entry apps map).
   *
   * Routes are sourced from the manifest's `routes` array (RegExp or string).
   * If the current path matches, the manifest's `app` factory is invoked and
   * the result is set into shell.Slot (if present) or rendered as the root.
   * Falls back to fallbackRoute when no match is found.
   *
   * This is intentionally simpler than workspace/dispatch.js — standalones
   * mount a single app and don't need a multi-app dispatch table.
   */ // URL-fallback half of the single-app dispatch, on its own so the cold
    // mount below can run it BEFORE awaiting `create()` — the DOMQL router
    // reads window.location on its first dispatch, which happens inside the
    // awaited mount; this rewrite has to land ahead of it (see the comment
    // in the body). `singleAppDispatch` still calls it, so the popstate
    // re-dispatch path is unchanged.
    function singleAppUrlFallback(manifest, path, fallbackRoute) {
        const routes = manifest.routes || [];
        // Route regexps anchor on the pathname segment only (e.g.
        // `^\/marketplace(\/|$)`). Query strings would push the `$` boundary
        // out of range and turn a deep-link like `/marketplace?item=X` into
        // an unmatched route — bootShell would then rewrite to fallbackRoute
        // and strip the query. Strip the query before testing so deep links
        // survive the dispatch.
        const pathOnly = path.split('?')[0];
        const matched = routes.some((r)=>{
            if (r instanceof RegExp) return r.test(pathOnly);
            if (typeof r === 'string') return r === pathOnly;
            return false;
        });
        // When no manifest route matches and a fallbackRoute is configured,
        // rewrite the URL bar to the fallback BEFORE mounting so the DOMQL
        // router has a path it can resolve. Without this, the router warns
        // "no content matched for path X" and renders nothing — visible as a
        // blank page on any unmapped URL (e.g. /login on the preview origin,
        // see https://silverbreeze-labs--hotcard.dev.preview.symbols.app/login
        // bug). The router reads window.location itself on init, so a
        // replaceState here is enough — no explicit dispatch call needed.
        if (!matched && typeof fallbackRoute === 'string' && fallbackRoute && typeof window !== 'undefined') try {
            window.history.replaceState(null, '', fallbackRoute);
        } catch (_) {}
    }
    async function singleAppDispatch(shell, manifest, path, fallbackRoute) {
        singleAppUrlFallback(manifest, path, fallbackRoute);
        if (shell && shell.Slot && typeof shell.Slot.set === 'function') {
            // Multi-slot shell: set the app into the Slot
            const appDef = await manifest.app?.().catch(()=>null);
            if (appDef) shell.Slot.set(appDef);
        }
    // If there is no Slot, the app is already mounted as the root (create()
    // used context.app directly). Nothing more to do for dispatch.
    }
    /**
   * Minimal popstate wiring for single-app standalones.
   * Re-dispatches on browser back/forward.
   */ function singleAppWireListeners(shell, manifest, fallbackRoute) {
        window.addEventListener('popstate', ()=>{
            const path = window.location.pathname + window.location.search;
            singleAppDispatch(shell, manifest, path, fallbackRoute);
        });
    }
    // Cross-origin auth bounce — public surfaces (preview) don't host a
    // login UI; auth lives on the workspace shell. If a user lands on
    // `<project>.<tier>.preview.symbols.app/login?next=…` (stale link or
    // direct paste), redirect to `<tier>.my.symbols.app/login?next=…`
    // before doing any other work. Without this, the preview app mounts
    // with no matching route and renders a blank screen — see the bug
    // report at /login?next=%2F on the dev preview origin.
    //
    // Restricted to `*.preview.symbols.app` so localhost / canvas dev
    // workflows are untouched. The auth-path regex matches the same set
    // PUBLIC_AUTH_ROUTE accepts on the shell side (login/signin/signup/
    // reset-password/forgot-password), so anything the shell treats as a
    // login surface is bounced consistently.
    if (publicSurface && typeof window !== 'undefined') {
        const _host = window.location.hostname;
        const _isAuthPath = /^\/(login|signin|signup|reset-password|forgot-password)(\/|$)/.test(window.location.pathname);
        const _previewMatch = _host.match(/(?:^|\.)((?:dev|next|test|upcoming|staging)\.)?preview\.symbols\.app$/);
        if (_isAuthPath && _previewMatch) {
            const tierPrefix = _previewMatch[1] || '';
            const shellHost = `${tierPrefix}my.symbols.app`;
            // LOGINLOOP-RELEASE-1: resolve through resolveAuthNext so a carried
            // `next` is reused, never re-wrapped (fifth bounce site).
            const _dest = (0, $cRTCE.resolveAuthNext)(window.location.pathname, window.location.search);
            const next = _dest ? `?next=${encodeURIComponent(_dest)}` : '';
            window.location.replace(`https://${shellHost}/login${next}`);
            return null;
        }
    }
    // Pattern A: single-app standalone — resolve manifest factories eagerly
    // so the shell is created with a real app + context instead of an empty
    // placeholder. Multi-app callers always supply a pre-built context, so
    // this branch is only entered for standalones.
    const appKeys = Object.keys(apps || {});
    const isSingleApp = appKeys.length === 1 && !context;
    let resolvedManifest = null;
    if (isSingleApp) {
        resolvedManifest = apps[appKeys[0]];
        // Resolve context factory if the manifest provides one
        const manifestContext = typeof resolvedManifest.context === 'function' ? await resolvedManifest.context().catch(()=>({})) : resolvedManifest.context || {};
        // Resolve app factory if context.app is not already set
        if (!manifestContext.app && typeof resolvedManifest.app === 'function') manifestContext.app = await resolvedManifest.app().catch(()=>({}));
        context = manifestContext;
    }
    // Default to empty context when neither caller nor manifest provides one
    if (!context) context = {};
    // ── THE ONE BOOT SEQUENCE ──────────────────────────────────────────────
    // bootPrepare → bootResolve → create() → bootApply. The published shell
    // runs the same three steps (packages/workspace/context.js boot plugin);
    // this composer adds only what a parcel entry has and a published page
    // does not: the host-package tier (4b — mermaid's page registers it
    // itself), the warm-start early mount and the cold create().
    const _steps = steps || context && context.functions || {};
    if (typeof _steps.bootPrepare !== 'function' || typeof _steps.bootResolve !== 'function' || typeof _steps.bootApply !== 'function') throw new Error("[bootShell] the boot steps are missing \u2014 pass `steps: _wsShared.functions` (bootPrepare / bootResolve / bootApply)");
    // Tells the published-shell boot plugin (beforeCreate) that this boot
    // already ran: nothing runs twice.
    context.bootMode = 'parcel';
    const _prep = _steps.bootPrepare(context, {
        sdk: sdk,
        publicSurface: publicSurface,
        warmSnapshot: warmSnapshot,
        forceSdk: isSingleApp
    });
    sdk = _prep.sdk;
    const lang = _prep.lang;
    // 4b. HOST-REGISTERED PACKAGE TIER — WS-HOST-REGISTER-SDK-1 (Nika answer B,
    // 2026-08-21). `@symbo.ls/sdk` is deliberately NOT in the public smbls
    // framework bundle (FRAMEWORK-REGISTRY-RESTRICTED-IMPORTS-1 answer B: the
    // platform, not smbls, owns the platform client). frank therefore emits, for
    // every serialized project function that reads an sdk export, a SYNCHRONOUS
    // `globalThis.__SMBLS_PKGS__['@symbo.ls/sdk']` read plus a NAMED throw on a
    // miss — there is no `await import()` fallback on purpose, because the
    // package returns npm E404 on the public registry.
    //
    // Every host that bundles smbls must therefore hand smbls its OWN sdk copy
    // before the first render. This is the single funnel: canvas, preview, the
    // shell and marketplace all `await bootShell(...)`, and it runs before BOTH
    // create() paths below (the warm-start early mount and the cold mount).
    //
    // ⚠️ The value MUST be the sdk MODULE NAMESPACE, never the `getSDK()`
    // INSTANCE. frank emits `__mod.environment`,
    // `__mod.PROJECT_ROLE_PERMISSIONS`, `__mod.readCookie`, `__mod.writeCookie`,
    // `__mod.createCrossAppAuth` — all module-level exports. Registering the
    // instance satisfies the registry read and then fails one step later with
    // the cause gone.
    //
    // Registration is ADDITIVE: it never swaps a namespace already on the store,
    // so two boot paths in one realm cannot fight. Safe since sdk 295efd2 parks
    // the default TokenManager on globalThis — a second evaluated sdk copy no
    // longer means two TokenManagers rotating one refresh token in one
    // localStorage.
    //
    // Guarded because an older `smbls` (< 3.14.786) has no such export; there the
    // sites keep exactly today's named throw instead of taking the whole app down
    // with a TypeError at boot.
    try {
        const smblsModule = await Promise.resolve((parcelRequire("eY4Ct")));
        if (typeof smblsModule.registerHostPackages === 'function') {
            // The sdk MODULE NAMESPACE (not the instance), imported at call time: a
            // module-scope `import * as` read here is unresolvable in frank's
            // emission. No added bundle weight — `./sdk.js` already pulls
            // @symbo.ls/sdk into every host that calls bootShell.
            const sdkModule = await Promise.resolve((parcelRequire("S1wNg")));
            smblsModule.registerHostPackages({
                '@symbo.ls/sdk': sdkModule
            });
            (0, $jH1GV.bootTrail)('bootShell:hostPackages');
        } else console.warn("[bootShell] this smbls build has no registerHostPackages \u2014 serialized project functions that read @symbo.ls/sdk keep throwing their named host-package error (needs smbls >= 3.14.786)");
    } catch (err) {
        console.warn('[bootShell] host package registration failed:', err?.message || err);
    }
    // The warm-start early mount (a parcel speed path): bootResolve calls it
    // after seeding the cached auth snapshot, and owns its disposal.
    const _mountEarly = async (themeModeNow)=>{
        const { create: _createEarly } = await Promise.resolve((parcelRequire("eY4Ct")));
        const shellApp = context.app || {};
        await (0, $eANbz.yieldToPaint)();
        return _createEarly(shellApp, {
            ...context,
            globalTheme: themeModeNow,
            themeStorageKey: 'themeMode',
            domqlOptions: {
                ...context.domqlOptions,
                mountYield: true
            }
        });
    };
    const _res = await _steps.bootResolve(context, _prep, {
        publicSurface: publicSurface,
        warmSnapshot: warmSnapshot,
        getWorkspaceCached: getWorkspaceCached,
        primeWorkspaceCache: primeWorkspaceCache,
        apps: apps,
        defaultApp: defaultApp,
        resolvedManifest: resolvedManifest,
        fallbackRoute: fallbackRoute,
        mountEarly: _mountEarly
    });
    if (!_res || _res.aborted) return null;
    const themeMode = _res.themeMode;
    const _earlyShell = _res.earlyShell;
    // Read by the shell root's own lifecycle: the boot has settled.
    context.bootReady = Promise.resolve(_res);
    // 8. Mount shell
    // The context.app is the shell DOMQL root component (app.js default export).
    // If context.app is not set, fall back to a minimal empty object so
    // bootShell is still usable in tests without a full app definition.
    // Pass the project's themeMode so smbls uses the same mode the workspace
    // chrome shows. `auto` remains `auto`; scratch resolves it and owns the
    // document-level data-theme updates.
    const { create: create } = await Promise.resolve((parcelRequire("eY4Ct")));
    const shellApp = context.app || {};
    let shell;
    if (_earlyShell) {
        // Warm-start: already mounted (and already painting) from the cached
        // snapshot before this function's own auth-gate/scope-fetch network
        // calls above even started. Reconcile the live root with whatever those
        // UNCHANGED calls actually resolved to — `context.preResolvedAuth` /
        // `context.state` here are the exact same values the cold path just
        // below would otherwise feed into `create()` for a first-ever mount.
        shell = _earlyShell;
        if (context.preResolvedAuth) {
            // `workspace` is deliberately excluded from this bare update and
            // handled by `setActiveWorkspaceRecord` instead, below — the ONE
            // setter allowed to write `root.workspace` post-mount (see
            // activeWorkspaceRecord.js: a bare `state.update({ workspace })` here
            // risks exactly the list-over-full downgrade race
            // tickets/spec-workspace-record-shape.md closed). The cache seeded a
            // 'list'-shaped placeholder; by this point `context.state.workspace`
            // is 'full'-shaped whenever the eager fetch above succeeded (the
            // common case), so the setter's own "full replacing anything →
            // accept" rule takes it — an ordinary upgrade, not a special case.
            const { workspace: _workspaceHandledBelow, ...restAuth } = context.preResolvedAuth;
            shell.state.update({
                ...restAuth,
                _bootFromCache: false
            });
            // Only call the setter when the cold path actually resolved SOMETHING
            // (the composite-boot fast path or the eager sdk.getWorkspace fetch,
            // a few hundred lines up — both gated on `activeWorkspaceId` being
            // truthy, which it always is for a scope that just produced a cache
            // hit). `setActiveWorkspaceRecord(root, null, …)` is an EXPLICIT clear
            // (sign-out / no active workspace) — passing it a merely-unresolved
            // `context.state.workspace` on some degenerate structural path (e.g.
            // `sdk.getWorkspace` not a function) would wipe the cache-painted
            // workspace instead of just leaving an unconfirmed-but-plausible guess
            // in place. Leaving it untouched here is strictly safer: the ticket's
            // own bar is "never paint wrong-scope," not "always resolve every
            // field" — an un-upgraded 'list' placeholder the user already sees is
            // not a regression from today's cold-boot experience.
            if (context.state.workspace) (0, $9IIym.setActiveWorkspaceRecord)(shell.state, context.state.workspace, {
                reason: 'boot-warm-reconcile',
                sdk: sdk,
                getWorkspaceCached: getWorkspaceCached
            });
        } else // The real auth gate never resolved a user on this pass — shouldn't
        // happen for a cache hit (the token that keyed the cache was live
        // moments ago), but never leave the cache flag stuck true regardless.
        shell.state.update({
            _bootFromCache: false
        });
    } else {
        // `create()` returns a PROMISE of the root element (smbls/src/index.js:
        // `createDomqlElement(...).then(...)`). It MUST be awaited here: the
        // watcher below reads `shell.state`, and `.state` of a Promise is
        // `undefined` — the un-awaited version silently skipped
        // `watchThemeResolved` on EVERY cold boot, so `root.themeResolved` froze
        // at its boot seed while `data-theme` kept moving (WS-THEME-BOOT-WRONG-
        // MODE-1: rail/widget-ink JS readers disagreeing with CSS — the "partly
        // light" report; measured live on staging 2026-08-19:
        // `document.__themeResolvedWatcher` absent). The caller awaits
        // bootShell's return regardless, so awaiting here changes nothing for
        // it; the warm-start branch above already awaited its own mount.
        //
        // Single-app standalones (canvas/preview/marketplace/analytics): the
        // URL-fallback rewrite used to ride `singleAppDispatch` right after the
        // un-awaited `create()` call, i.e. synchronously BEFORE the router's
        // first dispatch inside the mount. Awaiting the mount would flip that
        // order and bring back the blank page on an unmapped URL, so the
        // rewrite runs here first, explicitly, with the same inputs.
        if (isSingleApp && resolvedManifest && typeof window !== 'undefined') singleAppUrlFallback(resolvedManifest, window.location.pathname + window.location.search, fallbackRoute);
        (0, $jH1GV.bootTrail)('bootShell:create:start');
        // Same frame yield as the warm-start mount above. Here the boot is
        // resuming inside the SDK response continuation, so the tree build was
        // absorbed into that task — LoAF measured it as a single 1726 ms
        // `resolve-promise` frame on my.symbols.app (2026-08-22). Yielding
        // closes that task first, so pending input and the spiral's own
        // animation get served before the build starts.
        await (0, $eANbz.yieldToPaint)();
        // Same mount-scheduler opt-in as the warm-start mount above — see the
        // full rationale there. This is the path that matters most for the
        // number: a cold boot builds the whole chrome AND the entry route in one
        // recursion, which is the 594 ms task the yield alone could only move.
        shell = await create(shellApp, {
            ...context,
            globalTheme: themeMode,
            themeStorageKey: 'themeMode',
            domqlOptions: {
                ...context.domqlOptions,
                mountYield: true
            }
        });
    }
    await _steps.bootApply(shell, _res, {
        themeApplied: true
    });
    if (isSingleApp && resolvedManifest) {
        const path = window.location.pathname + window.location.search;
        await singleAppDispatch(shell, resolvedManifest, path, fallbackRoute);
        singleAppWireListeners(shell, resolvedManifest, fallbackRoute);
    }
    return shell;
};

});
parcelRegister("4BW22", function(module, exports) {
// Defensive shim — runs as a side-effect import from bootShell.js so it
// fires BEFORE any other module in any surface (canvas, workspace,
// preview, marketplace) gets a chance to construct a Supabase client.
//
// Problem: @supabase/realtime-js v2 ships a `WebSocketFactory.detectEnvironment`
// that reads `globalThis.process.versions.node` to decide whether it's
// running in Node. Parcel bundles MULTIPLE realtime-js copies (one per
// transitive consumer), and at least one copy's detection mis-fires —
// the detector resolves the runtime as Node and throws "Node.js 20
// detected without native WebSocket support" the first time anything
// constructs a SupabaseClient. The crash cascades through every
// `_requestExternal` call — workspaceProject.people, announcements,
// stories, user_documents, user_preferences — so the governance JWT
// never lands, `root.jwtClaims` stays empty, and `AppWorkspaceSwitcher`
// (which reads `root.jwtClaims.orgs`) has nothing to render.
//
// Three-prong defense:
//   1. Pin a real browser `WebSocket` on `globalThis` so the detector's
//      EARLIEST `typeof WebSocket !== 'undefined'` check catches and
//      returns native before any of the runtime-sniffing branches fire.
//   2. AFFIRMATIVELY define `globalThis.process = { versions: {} }` when
//      undefined — every bundled realtime-js copy's `let i =
//      globalThis.process; if (i) { let e = i.versions; if (e && e.node) }`
//      now sees an empty `versions` object and skips the Node branch.
//      Cheaper + more reliable than chasing every createClient site to
//      inject `transport`.
//   3. If something previously polyfilled `process.versions.node`,
//      scrub it. Belt-and-suspenders.
//
// Idempotent — multiple imports / hot reloads / repeat boots are no-ops.
if (typeof window !== 'undefined') {
    // 1. Pin WebSocket.
    if (typeof window.WebSocket !== 'undefined' && !globalThis.WebSocket) globalThis.WebSocket = window.WebSocket;
    // 2 + 3. Stub or scrub globalThis.process.
    try {
        if (typeof globalThis.process === 'undefined') Object.defineProperty(globalThis, 'process', {
            value: {
                versions: {}
            },
            writable: true,
            configurable: true,
            enumerable: false
        });
        else if (globalThis.process.versions && globalThis.process.versions.node) try {
            globalThis.process.versions.node = undefined;
        } catch (_) {
            try {
                delete globalThis.process.versions.node;
            } catch (__) {}
        }
    } catch (_) {}
}

});

parcelRegister("8NTf1", function(module, exports) {

$parcel$export(module.exports, "buildSdkAdapter", () => $668dc020a0747976$export$fa32832e16ed797d);
$parcel$export(module.exports, "registerSdkAdapter", () => $668dc020a0747976$export$6084c72ef9d6e870);
/**
 * @symbo.ls/fetch sdk adapter (registered, not built-in).
 *
 * Routes DOMQL `fetch:` declarations through @symbo.ls/sdk's EntityDispatcher
 * so workspace UI never speaks to a backend other than the SDK. Follows the
 * same `setup(options) → adapterObject` contract as the supabase / rest /
 * local builtin adapters, but ships from the workspace package because the
 * SDK is a peer concern (not a transport).
 *
 * Registration: call `registerSdkAdapter()` once at boot — it adds the
 * factory to @symbo.ls/fetch's runtime adapter registry. Then any project
 * config can opt in with:
 *
 *   fetch: { adapter: 'sdk', sdk: getSDK() }
 *   // or, if you'd rather hand over just the dispatcher:
 *   fetch: { adapter: 'sdk', executor: (from, op, args, cb) => sdk.execute(from, op, args, cb) }
 *
 * Argument shape — adapter packs every call into a single object whose
 * fields the EntityDispatcher's per-route `argMap` extracts into the
 * positional shape the underlying service method expects. Aliases are
 * provided so argMaps written for either `params`/`filter` or
 * `data`/`payload` work uniformly:
 *
 *   - select  → { filter, params, single, limit, offset, order, options, ...params }
 *   - insert  → { payload, data, ...params }
 *   - update  → { id, number, payload, data, ...params }
 *   - delete  → { id, number, ...params }
 *   - rpc     → params forwarded as-is
 *   - sub     → { ...params, filter }
 *
 * SDK init wait — the SDK proxy in shared/functions/sdk.js auto-awaits
 * SDK init for every method call, so `sdk.execute(...)` returns a Promise.
 * Subscribe handles this with a cancel-token shim: a sync unsubscribe fn
 * is returned immediately and the real teardown is wired up when the
 * dispatcher's promise resolves.
 *
 * FA204 / frank trap — _settle/_packSelect/_packCreate/_packUpdate/
 * _packDelete used to live at module scope, referenced bare from
 * buildSdkAdapter; registerSdkAdapter called buildSdkAdapter
 * bare too. Unresolvable once each export is individually frank.toJSON'd for
 * platform delivery (project_frank_drops_module_local_helpers).
 * buildSdkAdapter now nests its own helpers; registerSdkAdapter carries a
 * full self-contained inline copy of buildSdkAdapter instead of a bare
 * sibling call.
 */ 
var $4skhB = parcelRequire("4skhB");
const $668dc020a0747976$export$fa32832e16ed797d = (options = {})=>{
    const _settle = (p)=>Promise.resolve(p).then((d)=>({
                data: d,
                error: null
            })).catch((error)=>({
                data: null,
                error: error
            }));
    const _packSelect = ({ params: params, single: single, limit: limit, offset: offset, order: order, options: options })=>({
            filter: params,
            params: params,
            single: single,
            limit: limit,
            offset: offset,
            order: order,
            options: options,
            ...params || {}
        });
    const _packCreate = ({ data: data, params: params })=>({
            payload: data,
            data: data,
            ...params || {}
        });
    const _packUpdate = ({ params: params, data: data })=>({
            id: params?.id ?? params?.number,
            number: params?.number ?? params?.id,
            payload: data,
            data: data,
            ...params || {}
        });
    const _packDelete = ({ params: params })=>({
            id: params?.id ?? params?.number,
            number: params?.number ?? params?.id,
            ...params || {}
        });
    const executor = typeof options.executor === 'function' ? options.executor : options.sdk && typeof options.sdk.execute === 'function' ? options.sdk.execute.bind(options.sdk) : null;
    if (!executor) throw new Error("@symbo.ls/fetch sdk adapter: pass { sdk } (an SDK instance with .execute) or { executor } (a function with the same signature) in your fetch config.");
    const exec = (from, op, args, cb)=>executor(from, op, args, cb);
    return {
        name: 'sdk',
        select: (cfg)=>_settle(exec(cfg.from, 'list', _packSelect(cfg))).then(({ data: data, error: error })=>({
                    data: cfg.single ? Array.isArray(data) ? data[0] : data : data,
                    error: error
                })),
        rpc: (cfg)=>_settle(exec(cfg.from, 'rpc', cfg.params)),
        insert: (cfg)=>_settle(exec(cfg.from, 'create', _packCreate(cfg))),
        update: (cfg)=>_settle(exec(cfg.from, 'update', _packUpdate(cfg))),
        // Upsert maps to the entity's `upsert` op. Entities that haven't
        // declared one will reject with `does not support op 'upsert'` from
        // the dispatcher — callers should branch on insert/update or wait
        // until the entity registers an `upsert` route. See
        // tickets/sdk.md SDK-FETCH-ADAPTER-1.
        upsert: (cfg)=>_settle(exec(cfg.from, 'upsert', {
                ..._packCreate(cfg),
                onConflict: cfg.onConflict
            })),
        delete: (cfg)=>_settle(exec(cfg.from, 'remove', _packDelete(cfg))),
        // Subscribe must return a sync unsubscribe — fetch plugin assigns it
        // to ref.__unsubscribe immediately. SDK proxy may make exec() async;
        // cancel-token shim resolves both cases.
        subscribe: (cfg, cb)=>{
            let unsub = null;
            let cancelled = false;
            Promise.resolve(exec(cfg.from, 'subscribe', {
                ...cfg.params || {},
                filter: cfg.params
            }, cb)).then((sub)=>{
                if (cancelled) {
                    if (typeof sub === 'function') try {
                        sub();
                    } catch (_) {}
                    else if (sub?.unsubscribe) try {
                        sub.unsubscribe();
                    } catch (_) {}
                    return;
                }
                unsub = typeof sub === 'function' ? sub : sub?.unsubscribe ? ()=>sub.unsubscribe() : null;
            }).catch(()=>{});
            return ()=>{
                cancelled = true;
                if (typeof unsub === 'function') try {
                    unsub();
                } catch (_) {}
            };
        },
        // Auth bridges — `fetch: { from: 'auth.session', method: 'subscribe' }`
        // routes through SDK's onAuthStateChange via the dispatcher.
        getSession: ()=>Promise.resolve(exec('auth.session', 'list')).catch(()=>null),
        onAuthStateChange: (cb)=>{
            let unsub = null;
            let cancelled = false;
            Promise.resolve(exec('auth.session', 'subscribe', null, cb)).then((sub)=>{
                if (cancelled) {
                    if (typeof sub === 'function') try {
                        sub();
                    } catch (_) {}
                    return;
                }
                unsub = typeof sub === 'function' ? sub : null;
            }).catch(()=>{});
            return ()=>{
                cancelled = true;
                if (typeof unsub === 'function') try {
                    unsub();
                } catch (_) {}
            };
        }
    };
};
const $668dc020a0747976$export$6084c72ef9d6e870 = (boundOptions = {})=>{
    // FA204 / frank trap — self-contained inline copy of buildSdkAdapter, see
    // the file header. Kept identical to the export above.
    function _buildSdkAdapter(options = {}) {
        const _settle = (p)=>Promise.resolve(p).then((d)=>({
                    data: d,
                    error: null
                })).catch((error)=>({
                    data: null,
                    error: error
                }));
        const _packSelect = ({ params: params, single: single, limit: limit, offset: offset, order: order, options: options })=>({
                filter: params,
                params: params,
                single: single,
                limit: limit,
                offset: offset,
                order: order,
                options: options,
                ...params || {}
            });
        const _packCreate = ({ data: data, params: params })=>({
                payload: data,
                data: data,
                ...params || {}
            });
        const _packUpdate = ({ params: params, data: data })=>({
                id: params?.id ?? params?.number,
                number: params?.number ?? params?.id,
                payload: data,
                data: data,
                ...params || {}
            });
        const _packDelete = ({ params: params })=>({
                id: params?.id ?? params?.number,
                number: params?.number ?? params?.id,
                ...params || {}
            });
        const executor = typeof options.executor === 'function' ? options.executor : options.sdk && typeof options.sdk.execute === 'function' ? options.sdk.execute.bind(options.sdk) : null;
        if (!executor) throw new Error("@symbo.ls/fetch sdk adapter: pass { sdk } (an SDK instance with .execute) or { executor } (a function with the same signature) in your fetch config.");
        const exec = (from, op, args, cb)=>executor(from, op, args, cb);
        return {
            name: 'sdk',
            select: (cfg)=>_settle(exec(cfg.from, 'list', _packSelect(cfg))).then(({ data: data, error: error })=>({
                        data: cfg.single ? Array.isArray(data) ? data[0] : data : data,
                        error: error
                    })),
            rpc: (cfg)=>_settle(exec(cfg.from, 'rpc', cfg.params)),
            insert: (cfg)=>_settle(exec(cfg.from, 'create', _packCreate(cfg))),
            update: (cfg)=>_settle(exec(cfg.from, 'update', _packUpdate(cfg))),
            upsert: (cfg)=>_settle(exec(cfg.from, 'upsert', {
                    ..._packCreate(cfg),
                    onConflict: cfg.onConflict
                })),
            delete: (cfg)=>_settle(exec(cfg.from, 'remove', _packDelete(cfg))),
            subscribe: (cfg, cb)=>{
                let unsub = null;
                let cancelled = false;
                Promise.resolve(exec(cfg.from, 'subscribe', {
                    ...cfg.params || {},
                    filter: cfg.params
                }, cb)).then((sub)=>{
                    if (cancelled) {
                        if (typeof sub === 'function') try {
                            sub();
                        } catch (_) {}
                        else if (sub?.unsubscribe) try {
                            sub.unsubscribe();
                        } catch (_) {}
                        return;
                    }
                    unsub = typeof sub === 'function' ? sub : sub?.unsubscribe ? ()=>sub.unsubscribe() : null;
                }).catch(()=>{});
                return ()=>{
                    cancelled = true;
                    if (typeof unsub === 'function') try {
                        unsub();
                    } catch (_) {}
                };
            },
            getSession: ()=>Promise.resolve(exec('auth.session', 'list')).catch(()=>null),
            onAuthStateChange: (cb)=>{
                let unsub = null;
                let cancelled = false;
                Promise.resolve(exec('auth.session', 'subscribe', null, cb)).then((sub)=>{
                    if (cancelled) {
                        if (typeof sub === 'function') try {
                            sub();
                        } catch (_) {}
                        return;
                    }
                    unsub = typeof sub === 'function' ? sub : null;
                }).catch(()=>{});
                return ()=>{
                    cancelled = true;
                    if (typeof unsub === 'function') try {
                        unsub();
                    } catch (_) {}
                };
            }
        };
    }
    (0, $4skhB.registerAdapter)('sdk', ()=>Promise.resolve({
            setup: (decl = {})=>_buildSdkAdapter({
                    ...boundOptions,
                    ...decl
                })
        }));
} // The eager `registerAdapter('sdk', …)` lives in `bootShell.js` (the
 // universal boot file, top-level) rather than here — Parcel was
 // tree-shaking the trailing module-side-effect statement from this
 // file despite `sideEffects: true` in package.json, leaving the
 // deployed bundle without an early-registered sdk adapter.
;

});

parcelRegister("cRTCE", function(module, exports) {

$parcel$export(module.exports, "resolveAuthNext", () => $95e594ba12ecd694$export$296ac6cabbebdb09);
// LOGINLOOP-1 — the `next` search-param a /login bounce carries must REUSE
// an existing `next` from the current URL, never re-wrap it: wrapping nests
// one level deeper on every bounce (`/?next=%2F` -> `/login?next=%2F%3Fnext
// %3D%252F` -> ... byte-for-byte the reported URL). Extracted from
// packages/workspace/app.js's `_authRouteGuard` — the one call site that
// already got this right and is unit-tested for it
// (authGuardNextNesting.test.js) — so a SECOND site (bootShell.js's
// `_forceLogoutAndReauth`, which built `next` from
// `window.location.search` verbatim with no unwrap at all) has one proven
// implementation to converge on instead of drifting its own copy.
//
// app.js's guard CALLS this too now (2026-09-20) — it kept the last inline
// copy for a while, because that guard's TIMING (`_authReady`/`signedIn`
// checks, when it fires) has its own reverted-loop precedent (2026-07-20,
// iPad). Only the URL arithmetic moved here; the timing stayed where it was.
// packages/workspace/functions/authGuardNextNesting.test.js drives this
// function composed exactly as app.js composes it.
//
// Returns the RAW (un-encoded) next value, or null when the resolved
// bounce target is bare `/` with no meaningful query — a plain `/login` is
// correct there, not `/login?next=%2F`. Callers encode at the point of
// URL insertion, matching the existing convention in every caller this
// was extracted from.
const $95e594ba12ecd694$export$296ac6cabbebdb09 = (pathname, search)=>{
    const params = new URLSearchParams(search || '');
    let carried = params.get('next');
    if (carried) {
        // Unwrap REPEATEDLY, not once — a URL nested two deep still contains a
        // `next` after a single unwrap, and the loop survives (this is what
        // caught the first attempt at this fix in app.js: see
        // authGuardNextNesting.test.js's fixed-point test). Bounded to avoid
        // spinning on a hand-crafted URL.
        for(let i = 0; i < 8; i++){
            const q = carried.split('?')[1];
            if (!q) break;
            const inner = new URLSearchParams(q).get('next');
            if (!inner) break;
            carried = inner;
        }
        return carried;
    }
    params.delete('next');
    const query = params.toString();
    const dest = pathname + (query ? `?${query}` : '');
    return dest === '/' ? null : dest;
};

});

parcelRegister("jH1GV", function(module, exports) {

$parcel$export(module.exports, "bootTrailArmed", () => $e5635853e2f41b16$export$d0473198974f45b5);
$parcel$export(module.exports, "shouldFlushBootTrail", () => $e5635853e2f41b16$export$ce5812044e86c414);
$parcel$export(module.exports, "bootTrail", () => $e5635853e2f41b16$export$a10accc52659b342);
$parcel$export(module.exports, "readBootTrail", () => $e5635853e2f41b16$export$f423ef1244afb831);
$parcel$export(module.exports, "clearBootTrail", () => $e5635853e2f41b16$export$4a64c9b915d96f09);
$parcel$export(module.exports, "summarizeBootTrail", () => $e5635853e2f41b16$export$b09e2946a4b3aea9);
// Boot breadcrumbs that survive a wedged renderer.
//
// ── The problem this exists for ──────────────────────────────────────────
// When the main thread locks, EVERY read path dies with it: CDP evaluate
// times out, screenshots time out, console reads return nothing, and a
// post-hoc probe cannot run because there is no post. Measured on
// app.bellforge.eu after a persona sign-in — a bare `1+1` failed to return
// inside 45s across three reproductions. So the trail has to be written
// BEFORE the wedge and read AFTER a reload, which means synchronously, to
// sessionStorage, from inside the boot path itself.
//
// ── The two signatures it separates ──────────────────────────────────────
// This is the whole point; a plain log would not do it.
//   • A LOOP shows as one label with a huge `n`. Something re-entered.
//   • A LONG SYNCHRONOUS BLOCK shows as a trail that simply STOPS at one
//     label with `n: 1` and never reaches the next. Something is slow, not
//     circular. (smbls element preparation is super-linear in component
//     size, and a big enough tree locks for tens of seconds while looking
//     exactly like an infinite loop.)
// Guessing between those two costs hours. The trail answers it in one read.
//
// ── Why it cannot blow up under the very loop it is diagnosing ───────────
// A naive `setItem(JSON.stringify(...))` per call would add a serialize +
// storage write to every iteration of a hot loop and become a second
// performance bug on top of the one under investigation. So the counts live
// in memory and only a THINNING schedule of occurrences is flushed
// (1,2,3, then powers of two). The last flush therefore always reflects a loop in
// progress, at a cost that falls away as the loop grows.
//
// OFF unless asked for: `?trail=1` arms it for the session (surviving the
// full-page reload the persona sign-in does), `?trail=0` disarms.
const $e5635853e2f41b16$var$KEY = 'bootTrail';
const $e5635853e2f41b16$var$ARMED = 'bootTrailArmed';
// In-memory; sessionStorage carries only the flushed snapshot.
const $e5635853e2f41b16$var$_counts = new Map();
const $e5635853e2f41b16$var$_order = [];
// FA201 / frank trap (WS-SHARED-MODULE-LET-BLOCKS-EVERY-PUSH-1) — the armed
// memo used to be a module-scope `let _armed = null`, read and written by
// `bootTrailArmed` below. frank hoists that export into the emitted
// `globalScope` and revives it with a bare indirect eval, where nothing
// module-level is in scope, so the read emitted a guaranteed ReferenceError
// and frank's emission gate refused the whole publish
// (`PUBLISH BLOCKED — [unresolvable-identifier]`) for EVERY project that
// inlines this package.
//
// Re-homed onto `globalThis.__bootTrailState`, per the pointerCapability.js
// template. `globalThis` rather than `window` because `bootTrailArmed` has a
// real no-window path (it accepts `win` as an argument and still reads
// sessionStorage), and `globalThis` is defined in every runtime this package
// loads in; in a browser it IS `window`. The lazy create is INLINED at the
// one read site on purpose — a shared module-scope getter would just relocate
// the same bare-sibling-call hazard this fix removes.
//
// Tri-state, unchanged: `null` = not yet resolved, `true`/`false` = resolved.
const $e5635853e2f41b16$var$_session = ()=>{
    try {
        return typeof sessionStorage !== 'undefined' ? sessionStorage : null;
    } catch (_) {
        return null;
    }
};
const $e5635853e2f41b16$export$d0473198974f45b5 = (win = typeof window !== 'undefined' ? window : null)=>{
    if (!globalThis.__bootTrailState) globalThis.__bootTrailState = {
        armed: null
    };
    const state = globalThis.__bootTrailState;
    if (state.armed !== null) return state.armed;
    const ss = $e5635853e2f41b16$var$_session();
    try {
        const q = win && win.location ? String(win.location.search || '') : '';
        if (/[?&]trail=1\b/.test(q)) {
            ss?.setItem?.($e5635853e2f41b16$var$ARMED, '1');
            state.armed = true;
            return state.armed;
        }
        if (/[?&]trail=0\b/.test(q)) {
            ss?.removeItem?.($e5635853e2f41b16$var$ARMED);
            state.armed = false;
            return state.armed;
        }
        state.armed = ss?.getItem?.($e5635853e2f41b16$var$ARMED) === '1';
    } catch (_) {
        state.armed = false;
    }
    return state.armed;
};
const $e5635853e2f41b16$export$ce5812044e86c414 = (n)=>n <= 3 || (n & n - 1) === 0;
const $e5635853e2f41b16$export$a10accc52659b342 = (label, detail)=>{
    try {
        if (!$e5635853e2f41b16$export$d0473198974f45b5()) return;
        const key = String(label || '?');
        const prev = $e5635853e2f41b16$var$_counts.get(key);
        const n = (prev ? prev.n : 0) + 1;
        const at = typeof performance !== 'undefined' ? Math.round(performance.now()) : 0;
        if (!prev) $e5635853e2f41b16$var$_order.push(key);
        $e5635853e2f41b16$var$_counts.set(key, {
            n: n,
            firstAt: prev ? prev.firstAt : at,
            lastAt: at,
            // Last detail wins: in a loop the newest iteration is the informative
            // one, and keeping every value would reintroduce unbounded growth.
            detail: detail === undefined ? prev ? prev.detail : undefined : detail
        });
        if (!$e5635853e2f41b16$export$ce5812044e86c414(n)) return;
        const ss = $e5635853e2f41b16$var$_session();
        if (!ss) return;
        ss.setItem($e5635853e2f41b16$var$KEY, JSON.stringify($e5635853e2f41b16$var$_order.map((k)=>({
                label: k,
                ...$e5635853e2f41b16$var$_counts.get(k)
            }))));
    } catch (_) {}
};
const $e5635853e2f41b16$export$f423ef1244afb831 = ()=>{
    try {
        const raw = $e5635853e2f41b16$var$_session()?.getItem?.($e5635853e2f41b16$var$KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
        return [];
    }
};
const $e5635853e2f41b16$export$4a64c9b915d96f09 = ()=>{
    try {
        $e5635853e2f41b16$var$_counts.clear();
        $e5635853e2f41b16$var$_order.length = 0;
        $e5635853e2f41b16$var$_session()?.removeItem?.($e5635853e2f41b16$var$KEY);
    } catch (_) {}
};
const $e5635853e2f41b16$export$b09e2946a4b3aea9 = (trail = $e5635853e2f41b16$export$f423ef1244afb831(), loopThreshold = 25)=>{
    if (!trail.length) return "no breadcrumbs \u2014 the trail was not armed, or the boot never started";
    const worst = trail.reduce((a, b)=>b.n > a.n ? b : a, trail[0]);
    const last = trail[trail.length - 1];
    if (worst.n >= loopThreshold) return `LOOP: "${worst.label}" ran ${worst.n}x (first ${worst.firstAt}ms, last ${worst.lastAt}ms) \u{2014} re-entered, not slow`;
    return `STOPPED AT: "${last.label}" (n=${last.n}, ${last.lastAt}ms) \u{2014} reached it and never left; suspect one long synchronous block, not a loop`;
};

});

parcelRegister("eANbz", function(module, exports) {

$parcel$export(module.exports, "yieldToPaint", () => $a9fa94bf34601f33$export$dec79d4fd91eb424);
// Hand the main thread back to the compositor for exactly one frame.
//
// ── Why boot needs this (WS-PROD-BOOT-ONE-1619MS-BLOCKING-TASK-1) ────────
// `bootShell` mounts the shell with smbls `create()`, and building that
// element tree is one long SYNCHRONOUS block (measured 1.6–1.9 s on a
// warm box). Whatever task the boot happens to be running in when it
// reaches the mount therefore absorbs the whole build:
//   • warm-start snapshot path — the mount is reached with no network await
//     in between, so it lands inside the ENTRY MODULE'S OWN evaluation task:
//     one 1846 ms task, nothing painted, FCP 2152 ms (dev.my.symbols.app,
//     3 loads, visible tab, 2026-08-22).
//   • cold path — the mount lands inside the SDK response continuation:
//     a 1726 ms `resolve-promise` task (my.symbols.app, same pass).
// index.html already carries a themed boot spiral that is in the DOM from
// the first byte; the browser simply never gets a frame to draw it.
//
// One bounded yield before each mount site restores that frame. It does NOT
// make the tree build cheaper — that cost is tracked separately — it stops
// the build from eating first paint too.
//
// ── Why it can never wedge a boot ────────────────────────────────────────
// `requestAnimationFrame` DOES NOT FIRE in a background tab. A bare
// `await rAF` before the mount would leave a backgrounded boot unmounted
// forever (and every prerender/bfcache-restore boot with it). So the frame
// wait always races a hard `maxWaitMs` bound and resolves at most once.
// The resolved value reports which arm won: `true` = a frame really
// happened, `false` = the bound fired (or there is no window to paint in).
//
// Frank note: fully self-contained — no bare sibling-export reads, so it
// survives being frank.toJSON'd on its own (same rule as themeMode.js).
const $a9fa94bf34601f33$export$dec79d4fd91eb424 = (win = typeof window !== 'undefined' ? window : null, maxWaitMs = 50)=>{
    const timer = win && typeof win.setTimeout === 'function' ? (cb, ms)=>win.setTimeout(cb, ms) : typeof setTimeout === 'function' ? (cb, ms)=>setTimeout(cb, ms) : null;
    // No window and no timer means no compositor to yield to — a node/SSR
    // render. Resolve now rather than costing the caller a tick for nothing.
    if (!win || !timer) return Promise.resolve(false);
    // A HIDDEN tab draws no frame and clamps its timers (the 50 ms bound fired
    // 0.76-1 s late on dev, three times per boot): nothing can paint, so there
    // is nothing to wait for. Visible tabs are unchanged.
    if (win.document && win.document.hidden === true) return Promise.resolve(false);
    const raf = typeof win.requestAnimationFrame === 'function' ? win.requestAnimationFrame : null;
    return new Promise((resolve)=>{
        let settled = false;
        const finish = (painted)=>{
            if (settled) return;
            settled = true;
            resolve(painted);
        };
        timer(()=>finish(false), maxWaitMs > 0 ? maxWaitMs : 0);
        if (!raf) return;
        try {
            // rAF runs BEFORE the frame is drawn; the 0 ms timer after it lands
            // AFTER, so resuming here means the paint has actually happened.
            raf.call(win, ()=>timer(()=>finish(true), 0));
        } catch (_) {
            finish(false);
        }
    });
};

});


parcelRegister("7fShD", function(module, exports) {

$parcel$export(module.exports, "bootPrepare", () => $54840aa8535c0f5c$export$3414b6a408dd78b1);
// bootPrepare — boot step 1 of 3, SYNCHRONOUS, before the shell mounts.
//
// ONE boot sequence for both builds (design approved 2026-10-07):
//   • parcel: bootShell (the parcel composer) runs bootPrepare → bootResolve →
//     create() → bootApply, reaching the three through the functions registry
//     its caller hands in (FA001: bootShell imports none of them);
//   • published (mermaid runs Smbls.create(app, context), never index.js): the
//     shell's boot plugin (packages/workspace/context.js) runs bootPrepare in
//     its beforeCreate — before the first element exists — then bootResolve;
//     the root's onCreate runs bootApply when `context.bootReady` settles.
//
// This step: the deployment's API base (context.workspaceApiUrl, resolved at
// RUN time from the injected identity — a module-scope value publishes as
// ""), the early language from storage, the polyglot config every mount
// needs, the SDK + its 'sdk' fetch adapter, and `context.methods.sdk` (el.sdk).
//
// Inputs: the context, { sdk, publicSurface, warmSnapshot, forceSdk }.
// Returns { sdk, lang, themeMode, storage, cachedWsLanguage, poly }.
// `cachedWsLanguage` is the warm row's language pair, or, for a row with none,
// the loader's language as a pair that is never enforced (`loaderLang`, below).

var $8NTf1 = parcelRequire("8NTf1");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $29wU0 = parcelRequire("29wU0");

var $3gQso = parcelRequire("3gQso");

var $jH1GV = parcelRequire("jH1GV");

var $cvFPD = parcelRequire("cvFPD");

var $j7gGM = parcelRequire("j7gGM");
function $54840aa8535c0f5c$export$3414b6a408dd78b1(context, { sdk: sdk = null, publicSurface: publicSurface = false, warmSnapshot: warmSnapshot = null, forceSdk: forceSdk = false } = {}) {
    if (!context) return null;
    // The API base is the DEPLOYMENT's identity, read when the page runs
    // (workspaceApiBase: host rule → injected channel → fail closed).
    if (!context.workspaceApiUrl) context.workspaceApiUrl = (0, $29wU0.workspaceApiBase)();
    // 1. Early lang/theme from localStorage. `themeMode` is the user's stored
    // preference (`auto` | `light` | `dark`); keeping `auto` intact lets scratch
    // attach its prefers-color-scheme listener instead of freezing the current
    // OS value at boot.
    const storage = typeof localStorage !== 'undefined' ? localStorage : null;
    // FIRST PAINT, synchronous, before auth: this device's stored choice, or
    // English. `localStorage.lang` is VALIDATED against the shipped set — it is
    // written by `setLang` alone, but an old build could have left `de`/`fr`/`es`
    // there, and an unshipped code would strand the session in a language whose
    // bundles do not exist (every key falls through, nothing says why). The
    // full user > device > workspace > English resolution runs at step 7b, once
    // the user and workspace scopes are actually known.
    // First paint knows no workspace yet, so it has exactly one signal: on a
    // branded host the entry has already seeded `whitelabelBrand` (its 600ms
    // race won), and the org's `branding.lang` is known HERE — first paint is
    // Georgian on a `ka` host instead of English until a later step. When the
    // seed lost, `whitelabelBrand` is null and first paint is English.
    //
    // `localStorage.lang` is NOT read any more (Nika 2026-09-10: "default
    // language is english. only workspaces that are specifically set as
    // Georgian should render in georgian"): a device's stored choice used to
    // paint every workspace it had never been chosen for — see resolveLang.
    //
    // The ONE workspace signal first paint can have: the workspace's own
    // language pair (`{ language, languagePolicy }`), cached in the warm boot
    // snapshot by loadPrivateData from the FULL record of the last settled boot
    // (packages/workspace/functions/bootSnapshot.js). `warmSnapshot` is already
    // validated by the caller for THIS user + workspace + URL scope. Without it
    // the warm mount painted English and 8b / applyWorkspaceLangPolicy then
    // painted the workspace language — measured on my.symbols.app 2026-09-23:
    // the tab read "Home" on the splash, then "მთავარი". Resolved through the
    // SAME `resolveLang` + `enforcedWorkspaceLang` pair as step 7b and the
    // policy, so the three cannot disagree. A public surface binds no workspace
    // rule (see the /login note in 7b): it paints exactly as before. A row with
    // no pair: the loader's language, below.
    const _snapWsLanguage = warmSnapshot && !publicSurface && warmSnapshot.workspaceLanguage && typeof warmSnapshot.workspaceLanguage === 'object' ? warmSnapshot.workspaceLanguage : null;
    // A warm row with NO pair (written before the pair existed, or from a
    // record with no `settings`) painted English under the loader's Georgian,
    // and step 7b turned it Georgian later (aa33, dev, 2026-10-30, a `ka`
    // session on /user/<slug>: `<html lang>` en at 856 ms, the tab "Profile" at
    // 1494 ms, "პროფილი" at 2622 ms). Such a row now paints the language the
    // pre-bundle loader painted for THIS arrival's workspace scope: the
    // `wsBootLang:<host>` entry, keyed per host AND per scope, which the
    // workspace entry hands in on the row as `loaderLang` (packages/workspace/
    // functions/bootLang.js withBootLangHint). It is the language the scope
    // RESOLVED to last time, the brand level included, so it ranks where the
    // workspace's own language does. Never enforced. A row WITH a pair keeps
    // the pair, even an older one. A shipped code only.
    const _loaderCode = warmSnapshot && !publicSurface && !_snapWsLanguage ? warmSnapshot.loaderLang : null;
    const _loaderLang = (0, $cvFPD.PLATFORM_LANGUAGES).some((l)=>l.code === _loaderCode) ? _loaderCode : null;
    // Step 7b falls back to this pair when the live record has no `settings`
    // for the same workspace (bootResolve.js): it keeps the loader's language
    // too, rather than English between two Georgian paints.
    const _cachedWsLanguage = _snapWsLanguage || (_loaderLang ? {
        language: _loaderLang,
        languagePolicy: null
    } : null);
    const lang = (0, $cvFPD.resolveLang)({
        workspaceEnforced: (0, $cvFPD.enforcedWorkspaceLang)(_cachedWsLanguage),
        workspaceDefault: _cachedWsLanguage?.language || null,
        brandDefault: context.state?.whitelabelBrand?.lang || null
    });
    let themeMode = (0, $3gQso.readStoredThemeMode)(storage);
    // NO THEME FLASH: the stored choice is the first paint, in both builds.
    // create() reads `context.themeStorageKey` (config.js) for the same key;
    // this write covers a host page whose own inline script did not (and a
    // parcel boot, whose first frame precedes create()). 'auto' keeps whatever
    // the page resolved from the OS. bootApply only corrects it later, to a
    // tenant default the person never overrode.
    if (!context.themeStorageKey) context.themeStorageKey = 'themeMode';
    if ((themeMode === 'light' || themeMode === 'dark') && typeof document !== 'undefined' && document.documentElement && typeof document.documentElement.setAttribute === 'function') document.documentElement.setAttribute('data-theme', themeMode);
    // WCAG 3.1.1 — `<html lang="...">` is required for screen readers.
    // Set as early as possible so any pre-render announce uses the right
    // pronunciation. Re-applied later when `state.lang` changes via the
    // context language-watch effect. `dir` rides with it: the two must never
    // disagree, and an RTL language set without it lays the whole shell out
    // backwards-correct but text-wrong.
    if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.lang = lang;
        document.documentElement.dir = (0, $cvFPD.langDir)(lang);
    }
    if (context.state) {
        context.state.lang = lang;
        // Ensure auxiliary state fields that shared helpers depend on are
        // initialized. openNotification pushes into `notifications`; guard
        // in case the standalone state factory didn't include the field.
        if (!Array.isArray(context.state.notifications)) context.state.notifications = [];
    }
    // 1b. POLYGLOT — MINTED ONCE, BEFORE ANY MOUNT.
    //
    // `context.polyglot` is what smbls's `createDomql` reads to auto-register the
    // polyglot plugin and its functions (`polyglot`, `getLang`, `setLang`, …). It
    // must exist before the FIRST `create()` call, and there are TWO of them
    // below: the warm-start early mount (from a cached boot snapshot, a few
    // hundred lines down) and the cold mount in step 8.
    //
    // This block used to live inside step 7b — i.e. AFTER the warm mount. On that
    // path `context.polyglot` was still undefined when the shell mounted, so
    // `mergeSharedLibraries` handed the live element the shared library's own
    // polyglot object, and 7b then minted a SECOND object and loaded Georgian
    // into it. The running app never held the object the translations landed in:
    // `context.polyglot.translations.ka` read 0 keys, the interface stayed
    // English, and `<html lang>` was correct because line ~2161 writes the
    // DOCUMENT, which is global. Minting here is what makes both mount paths
    // deliver the same object. Two polyglot objects was the underlying bug.
    //
    // `mergeOneLibrary` (smbls/packages/utils/sharedLibraries.js) fills only the
    // keys a consumer does NOT define, so every field declared here must match
    // what `@symbo-ls/workspace-shared` declares in its own `context.js` — the
    // pinning test is `__tests__/i18nBootLanguage.test.js`.
    //
    // FA204 / frank trap — `BOOT_NAMESPACES` is an INLINED local, not a read of a
    // module-scope constant, for the same reason `setLang.js` inlines `SUPPORTED`
    // and `languages.js` inlines its own lists: `functions/` is a frank section
    // barrel, so a module-scope binding read from inside an exported function is
    // unresolvable in the revived runtime.
    const BOOT_NAMESPACES = [
        'common',
        'auth',
        'account',
        'settings',
        // Added with the shared-package extraction (2026-09-02). Every one of
        // these has real en+ka bundles on disk; a namespace listed here but not
        // shipped is dropped by the loader's own intersection, and one SHIPPED but
        // not listed here resolves English only — the switch simply never reaches
        // it, silently, because English is bundled.
        'shell',
        'editor',
        'members',
        'learn',
        'ai',
        'publish',
        'apps',
        'workspace',
        'admin',
        'data',
        // Store copy is SHELL CHROME (2026-09-03). Every installed app's navbar tab
        // and launcher tile resolves its label through the one store-copy resolver
        // (`functions/storeItemText.js` → `marketplace.app.<slug>.name`), so an app
        // reads the same name here as in the store it came from. That chrome paints
        // on the FIRST route, before the per-route widening in step 7b runs, so the
        // shell manifest's own `i18nNamespaces` entry is not enough on its own — an
        // undeclared namespace here means a Georgian boot flashes (or keeps) the
        // app manifest's English literal.
        'marketplace'
    ];
    if (!context.polyglot) context.polyglot = {
        defaultLang: (0, $cvFPD.DEFAULT_LANG),
        languages: (0, $cvFPD.PLATFORM_LANGUAGES).map((l)=>l.code),
        // Polyglot's own default is `smbls_lang`. The platform key is `lang`, and
        // `initPolyglot` reads this key on render to decide the active language —
        // left at the default it would read an unset key, fall back to
        // `defaultLang`, and `root.update({ lang: 'en' })` straight over whatever
        // was just resolved.
        storageLangKey: 'lang',
        namespaces: BOOT_NAMESPACES.slice(),
        translations: {}
    };
    const _poly = context.polyglot;
    if (!_poly.translations) _poly.translations = {};
    if (!_poly.storageLangKey) _poly.storageLangKey = 'lang';
    // The BASELINE load list. Step 7b widens it per route from the running app's
    // manifest; `setLang` re-loads exactly the resulting set on a switch. It has
    // to be non-empty HERE, on both mount paths, or a cold boot would hand 7b an
    // empty set and load `common` alone — which is how a correctly-resolved
    // Georgian boot still rendered English on a page with almost nothing in
    // `common` (50 keys) to translate.
    if (!Array.isArray(_poly.namespaces) || !_poly.namespaces.length) _poly.namespaces = BOOT_NAMESPACES.slice();
    // ENGLISH IS BUNDLED; EVERY OTHER LANGUAGE IS A LAZY, PER-NAMESPACE CHUNK —
    // `functions/i18nLoader.js` owns the split and the measurements behind it.
    //
    // `deepDefaults`-style fill, not a replace: whatever already sits in
    // `translations` (the library's own copy, or a frank payload's serialized
    // one) stays, and a language it lacks is added. It has to run HERE rather
    // than in 7b because `prepareState` seeds the active language's keys into the
    // root state DURING the mount — an empty `translations` at the warm mount is
    // a root state with no seeded strings at all.
    try {
        const _bootStaticTranslations = (0, $j7gGM.i18nStaticTranslations)();
        for (const code of Object.keys(_bootStaticTranslations)){
            const existing = _poly.translations[code];
            _poly.translations[code] = existing && Object.keys(existing).length ? {
                ..._bootStaticTranslations[code],
                ...existing
            } : _bootStaticTranslations[code];
        }
    } catch (err) {
        console.warn('[bootShell] static i18n seed failed:', err?.message || err);
    }
    // `themeMode` / `themeResolved` are seeded further down, AFTER the SDK
    // exists — see "WS-THEME-BOOT-WRONG-MODE-1" below the adapter registration.
    // Pattern B: auto-SDK instantiation.
    // Fires when no explicit `sdk` is passed AND either:
    //   (a) isSingleApp — standalone wrapper (one-entry apps map, no pre-built context), OR
    //   (b) the resolved context carries workspaceApiUrl — multi-app shell that
    //       explicitly opts into SDK wiring via its context.js export.
    //
    // This covers the workspace shell (workspace/packages/workspace/) which passes
    // 5 apps + a pre-built context, so isSingleApp=false, but still needs the SDK
    // to authenticate, fetch scopes, and expose el.sdk to sub-app components.
    // The multi-app explicit-sdk path is preserved: pass `sdk` param explicitly to
    // skip this block entirely (e.g. tests, custom shells).
    const needsSdkInit = forceSdk || !sdk && context?.workspaceApiUrl;
    if (!sdk && needsSdkInit) try {
        sdk = (0, $1NxyO.getSDK)();
        (0, $jH1GV.bootTrail)('bootShell:sdk');
    } catch (err) {
        console.warn('[bootShell] SDK init failed:', err?.message || err);
    }
    // 4. Register sdk fetch adapter (proxy passes calls through; safe pre-init).
    if (sdk) {
        (0, $8NTf1.registerSdkAdapter)({
            sdk: sdk
        });
        // el.sdk for every element: DOMQL builds each context's element prototype
        // from `context.methods` once, at the FIRST element. Both boots run this
        // step before that (parcel: before create(); published: the boot
        // plugin's beforeCreate). Every SDK method awaits the SDK's own init
        // (getSDK's init-await proxy), so exposing it before init is safe for
        // calls; the four synchronous reads (getAuthToken / isReady / getToken /
        // logout) are read by code that runs after `context.bootReady`.
        if (!context.methods || typeof context.methods !== 'object') context.methods = {};
        context.methods.sdk = sdk;
    }
    return {
        sdk: sdk,
        lang: lang,
        themeMode: themeMode,
        storage: storage,
        cachedWsLanguage: _cachedWsLanguage,
        poly: _poly
    };
}

});
parcelRegister("j7gGM", function(module, exports) {

$parcel$export(module.exports, "i18nStaticTranslations", () => $deab9ddcd0265210$export$a855a4143c1fadf2);
$parcel$export(module.exports, "i18nStaticEnglish", () => $deab9ddcd0265210$export$9020faba9d963840);
$parcel$export(module.exports, "hasI18nBundle", () => $deab9ddcd0265210$export$4d0e61e02659847b);
$parcel$export(module.exports, "loadI18nNamespace", () => $deab9ddcd0265210$export$d7e7635cdba56b8f);
$parcel$export(module.exports, "loadI18nNamespaces", () => $deab9ddcd0265210$export$180cebc34b09d5f4);
$parcel$export(module.exports, "dropNonEnglishCache", () => $deab9ddcd0265210$export$20e078bbaa6a7e60);
$parcel$export(module.exports, "getLoadedNamespaces", () => $deab9ddcd0265210$export$c3e88959bcdae366);
$parcel$export(module.exports, "mergeAllNamespaces", () => $deab9ddcd0265210$export$fde487a3028333bc);
/**
 * i18nLoader — the platform's translation bundles, and the ONE place that
 * decides what is bundled and what is loaded on demand.
 *
 * ── The rule ───────────────────────────────────────────────────────────────
 * ENGLISH IS BUNDLED. EVERY OTHER LANGUAGE IS A LAZY CHUNK, PER NAMESPACE.
 *
 * English is the fallback for every miss. Polyglot's `translate()` returns THE
 * KEY ITSELF when no lookup step resolves, so a base language that needed a
 * round trip would put a raw `common.action.save` on screen the first time a
 * network hiccuped. It ships inside the bundle and touches nothing.
 *
 * Every other language is `() => import('../i18n/<lang>/<ns>.json')` — a
 * static specifier inside a thunk. Parcel code-splits each one into its own
 * content-hashed chunk, so a visitor who never switches language downloads not
 * one byte of it, and a visitor who does downloads exactly the namespaces the
 * running surface declared.
 *
 * ── Why this shape and not the two obvious alternatives ────────────────────
 * Measured on Parcel 2.16.4 with a real build (the bundler every app in this
 * repo runs; evidence recorded on LANE POLYGLOT-ARCH, 2026-09-02):
 *
 *  1. BUNDLE EVERY LANGUAGE (what this file used to do). Correct at 77 keys,
 *     wrong at the platform's target size: English alone is ~100 KB at ~2900
 *     keys and each further language adds ~120 KB to the FIRST paint of every
 *     visitor, in a language almost none of them will pick. A build proved the
 *     failure mode is invisible to a functional test: with every language
 *     statically imported a switch still returns Georgian, so a test that only
 *     asserts "the switch works" passes while nothing is lazy.
 *
 *  2. A VARIABLE-PATH DYNAMIC IMPORT — import with a template-literal path.
 *     Parcel emits NO chunk, NO importmap entry and NO WARNING; it copies the
 *     template literal into the bundle verbatim. The browser then resolves it
 *     against the bundle URL, i.e. `/i18n/ka/common.json` — and the dev server
 *     answers an unknown path with 200 + SPA-fallback HTML, which `res.ok`
 *     happily accepts. That is the same silent 200-that-is-not-JSON this file
 *     was already burned by once (see "the fetch path that never worked"
 *     below); a template literal walks straight back into it.
 *
 *  3. A STATIC-SPECIFIER THUNK MAP — what is generated below. Parcel emits one
 *     content-hashed chunk per entry plus an importmap entry. Booting in
 *     English loads ZERO chunks; a switch to ka/common loads exactly one.
 *     There is no runtime path to 404 and no content type to sniff, because
 *     the bundler resolved the specifier at build time.
 *
 * ── The fetch path that never worked, and is gone ──────────────────────────
 * This file used to fetch `/i18n/<lang>/<ns>.json` at runtime. Measured live on
 * the running shell: `new URL('../i18n/ka/common.json', import.meta.url)`
 * resolved to `/common.f873341d.js` — a JAVASCRIPT MODULE, because Parcel runs
 * its JSON transformer on a `.json` asset. `res.json()` threw on 31 KB of JS.
 * The literal runtime path was worse: 200, 30 KB of SPA-fallback HTML, and only
 * the parse error to tell you. Nothing on the load path touches the network any
 * more, so neither trap can return.
 *
 * ── The three planes, and what each one gets ───────────────────────────────
 *  • BUNDLER plane (local dev, and every deployed app build): English static,
 *    everything else a chunk. This is the plane the design targets.
 *  • PUBLISHED plane (a frank record — module bodies never run, the code is
 *    revived from JSON): `context.polyglot.translations` is serialized DATA, so
 *    whatever `i18nStaticTranslations()` returned when frank ran its Node pass
 *    is baked into the payload. English therefore works with no module body at
 *    all. A language with no baked bundle stays English and says so once — a
 *    published record has no chunk to import.
 *  • NODE plane (frank's own build pass, and the bun test runner): module
 *    bodies run, so both registries are real; `with { type: 'json' }` is what
 *    makes the specifiers legal there (Node 24 throws
 *    ERR_IMPORT_ATTRIBUTE_MISSING without it, Bun and Parcel both accept it).
 *
 * ── Adding a language or a namespace ───────────────────────────────────────
 * Drop the file in `packages/shared/i18n/<lang>/<namespace>.json` and run
 * `node scripts/gen-i18n-registry.mjs`. Nothing else. The generated block
 * below is the single writer of the registry, `__tests__/i18nRegistry.test.js`
 * fails when it drifts from disk, and `NAMESPACES` — which bootShell
 * intersects app manifests against — is derived from the same scan, so a
 * manifest's `i18nNamespaces: ['canvas']` goes live the moment
 * `i18n/en/canvas.json` exists.
 *
 * Key naming, and what belongs in `common` versus a surface namespace:
 * `docs/I18N-CONVENTION.md`. Read it before you name a key.
 *
 * ── FA204 / frank section-barrel trap ──────────────────────────────────────
 * `functions/` is a frank SECTION BARREL: every export becomes its own emitted
 * entry, and a module-scope binding read from inside an exported function is
 * unresolvable in the revived runtime. So the registries and the cross-call
 * cache are stashed on `(window||globalThis)` by the module body, and every
 * export below carries its own self-contained lazy read of that holder rather
 * than sharing a module-scope helper (which would be the same trap one level
 * down). The stash is try-guarded because frank runs this module in Node while
 * building `globalScope`; a throw there would take the whole package's
 * emission down.
 */ // ─── i18n:registry BEGIN — generated by scripts/gen-i18n-registry.mjs, do not hand-edit ───
// The BASE language is bundled: it is the fallback for every miss, and
// polyglot's translate() returns the KEY ITSELF when no step resolves — so a
// base that needed a round trip would put `common.action.save` on screen.

var $hEoqE = parcelRequire("hEoqE");

var $6i63J = parcelRequire("6i63J");

var $6cYgA = parcelRequire("6cYgA");

var $6KVwS = parcelRequire("6KVwS");

var $5665D = parcelRequire("5665D");

var $dqEyJ = parcelRequire("dqEyJ");

var $kNsK2 = parcelRequire("kNsK2");

var $9nKSP = parcelRequire("9nKSP");

var $5utM4 = parcelRequire("5utM4");

var $9i81O = parcelRequire("9i81O");

var $9FUgo = parcelRequire("9FUgo");

var $3MQMW = parcelRequire("3MQMW");

var $zmIil = parcelRequire("zmIil");

var $SIxy5 = parcelRequire("SIxy5");

var $b92ei = parcelRequire("b92ei");

var $9dEvE = parcelRequire("9dEvE");

var $juKcz = parcelRequire("juKcz");

var $bjLXr = parcelRequire("bjLXr");

var $cfuO0 = parcelRequire("cfuO0");

var $6tyYq = parcelRequire("6tyYq");

var $7Zvah = parcelRequire("7Zvah");

var $dtJ5d = parcelRequire("dtJ5d");

var $1xkEU = parcelRequire("1xkEU");

var $9sHa1 = parcelRequire("9sHa1");

var $92t7q = parcelRequire("92t7q");

var $79W0z = parcelRequire("79W0z");

var $lJulY = parcelRequire("lJulY");
const $deab9ddcd0265210$var$BASE_BUNDLES = {
    'account': (0, (/*@__PURE__*/$parcel$interopDefault($hEoqE))),
    'admin': (0, (/*@__PURE__*/$parcel$interopDefault($6i63J))),
    'ai': (0, (/*@__PURE__*/$parcel$interopDefault($6cYgA))),
    'analytics': (0, (/*@__PURE__*/$parcel$interopDefault($6KVwS))),
    'apps': (0, (/*@__PURE__*/$parcel$interopDefault($5665D))),
    'auth': (0, (/*@__PURE__*/$parcel$interopDefault($dqEyJ))),
    'calendar': (0, (/*@__PURE__*/$parcel$interopDefault($kNsK2))),
    'canvas': (0, (/*@__PURE__*/$parcel$interopDefault($9nKSP))),
    'chat': (0, (/*@__PURE__*/$parcel$interopDefault($5utM4))),
    'common': (0, (/*@__PURE__*/$parcel$interopDefault($9i81O))),
    'data': (0, (/*@__PURE__*/$parcel$interopDefault($9FUgo))),
    'documents': (0, (/*@__PURE__*/$parcel$interopDefault($3MQMW))),
    'editor': (0, (/*@__PURE__*/$parcel$interopDefault($zmIil))),
    'files': (0, (/*@__PURE__*/$parcel$interopDefault($SIxy5))),
    'flags': (0, (/*@__PURE__*/$parcel$interopDefault($b92ei))),
    'infra': (0, (/*@__PURE__*/$parcel$interopDefault($9dEvE))),
    'learn': (0, (/*@__PURE__*/$parcel$interopDefault($juKcz))),
    'mail': (0, (/*@__PURE__*/$parcel$interopDefault($bjLXr))),
    'marketplace': (0, (/*@__PURE__*/$parcel$interopDefault($cfuO0))),
    'meet': (0, (/*@__PURE__*/$parcel$interopDefault($6tyYq))),
    'members': (0, (/*@__PURE__*/$parcel$interopDefault($7Zvah))),
    'preview': (0, (/*@__PURE__*/$parcel$interopDefault($dtJ5d))),
    'publish': (0, (/*@__PURE__*/$parcel$interopDefault($1xkEU))),
    'settings': (0, (/*@__PURE__*/$parcel$interopDefault($9sHa1))),
    'shell': (0, (/*@__PURE__*/$parcel$interopDefault($92t7q))),
    'tickets': (0, (/*@__PURE__*/$parcel$interopDefault($79W0z))),
    'workspace': (0, (/*@__PURE__*/$parcel$interopDefault($lJulY)))
};



























// Every other language, one lazily-fetched content-hashed chunk per
// namespace. Static specifiers on purpose — a template literal produces no
// chunk at all under Parcel (see scripts/gen-i18n-registry.mjs header).
const $deab9ddcd0265210$var$LAZY_BUNDLES = {
    'ka/account': ()=>(parcelRequire("fPi8I")),
    'ka/admin': ()=>(parcelRequire("OeC5r")),
    'ka/ai': ()=>(parcelRequire("lVzOA")),
    'ka/analytics': ()=>(parcelRequire("bnQr0")),
    'ka/apps': ()=>(parcelRequire("7rxbI")),
    'ka/auth': ()=>(parcelRequire("h7ItO")),
    'ka/calendar': ()=>(parcelRequire("626SV")),
    'ka/canvas': ()=>(parcelRequire("4CBiU")),
    'ka/chat': ()=>(parcelRequire("eIAj4")),
    'ka/common': ()=>(parcelRequire("8Zrav")),
    'ka/data': ()=>(parcelRequire("cXRla")),
    'ka/documents': ()=>(parcelRequire("7RyXw")),
    'ka/editor': ()=>(parcelRequire("bKgxq")),
    'ka/files': ()=>(parcelRequire("gSx0s")),
    'ka/flags': ()=>(parcelRequire("aaeFI")),
    'ka/infra': ()=>(parcelRequire("1vPnD")),
    'ka/learn': ()=>(parcelRequire("3lJbd")),
    'ka/mail': ()=>(parcelRequire("iRcu3")),
    'ka/marketplace': ()=>(parcelRequire("lgumd")),
    'ka/meet': ()=>(parcelRequire("kDBAM")),
    'ka/members': ()=>(parcelRequire("dbpzZ")),
    'ka/preview': ()=>(parcelRequire("1VxMM")),
    'ka/publish': ()=>(parcelRequire("hUqGe")),
    'ka/settings': ()=>(parcelRequire("iM2jc")),
    'ka/shell': ()=>(parcelRequire("kal9z")),
    'ka/tickets': ()=>(parcelRequire("9tA7b")),
    'ka/workspace': ()=>(parcelRequire("g6mhP"))
};
const $deab9ddcd0265210$export$c938e1d37e181f02 = 'en';
const $deab9ddcd0265210$export$b4b5a31092c79bca = [
    'en',
    'ka'
];
const $deab9ddcd0265210$export$4d2fb7344096e022 = [
    'account',
    'admin',
    'ai',
    'analytics',
    'apps',
    'auth',
    'calendar',
    'canvas',
    'chat',
    'common',
    'data',
    'documents',
    'editor',
    'files',
    'flags',
    'infra',
    'learn',
    'mail',
    'marketplace',
    'meet',
    'members',
    'preview',
    'publish',
    'settings',
    'shell',
    'tickets',
    'workspace'
];
// ─── i18n:registry END ───
// The module body's one job: hand both registries and an empty cache to the
// holder every export reads. See the FA204 note in the header.
try {
    const w = typeof window !== 'undefined' ? window : globalThis;
    w.__i18nRegistry = {
        baseLang: $deab9ddcd0265210$export$c938e1d37e181f02,
        base: $deab9ddcd0265210$var$BASE_BUNDLES,
        lazy: $deab9ddcd0265210$var$LAZY_BUNDLES,
        langs: $deab9ddcd0265210$export$b4b5a31092c79bca,
        namespaces: $deab9ddcd0265210$export$4d2fb7344096e022
    };
    if (!w.__i18nLoaderState) w.__i18nLoaderState = {
        // 'lang/ns' -> resolved bundle object
        cache: new Map(),
        // namespace names this session has asked for, in any language. setLang
        // re-loads exactly this set into the target language.
        loadedNamespaces: new Set(),
        // 'lang/ns' -> in-flight promise, so N elements asking at once produce
        // ONE chunk request.
        inflight: new Map(),
        // languages we have already told the console about, so a published
        // record with no chunks warns once, not once per namespace.
        warned: new Set()
    };
} catch (_) {
// No module context (frank's revived runtime). Every export below degrades
// to the base language, which the payload already carries.
}
const $deab9ddcd0265210$export$a855a4143c1fadf2 = ()=>{
    const w = typeof window !== 'undefined' ? window : globalThis;
    // Read BOTH holders. In a browser `window === globalThis`, so this is one
    // lookup — but a non-browser host (bun/node test runs, SSR) can acquire a
    // `window` shim AFTER this module's body ran, which would leave the registry
    // on `globalThis` while every later read looked at `window` and found
    // nothing. Returning `{}` there would silently make English absent.
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    if (!reg) return {};
    const merged = {};
    for (const ns of Object.keys(reg.base))Object.assign(merged, reg.base[ns]);
    return {
        [reg.baseLang]: merged
    };
};
const $deab9ddcd0265210$export$9020faba9d963840 = ()=>{
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    if (!reg) return {};
    const merged = {};
    for (const ns of Object.keys(reg.base))Object.assign(merged, reg.base[ns]);
    return merged;
};
const $deab9ddcd0265210$export$4d0e61e02659847b = (lang, namespace)=>{
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    if (!reg) return false;
    if (lang === reg.baseLang) return !!reg.base[namespace];
    return !!reg.lazy[`${lang}/${namespace}`];
};
const $deab9ddcd0265210$export$d7e7635cdba56b8f = async (lang, namespace)=>{
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    // Normalize the shape rather than trusting it. The state lives on a GLOBAL,
    // so a warm page, an older bundle or a test harness can hand us an object
    // that predates one of these fields — and reading `.has` off an undefined
    // Map is a hard TypeError in the middle of a language switch.
    const _st = w.__i18nLoaderState || (w.__i18nLoaderState = {});
    if (!_st.cache) _st.cache = new Map();
    if (!_st.loadedNamespaces) _st.loadedNamespaces = new Set();
    if (!_st.inflight) _st.inflight = new Map();
    if (!_st.warned) _st.warned = new Set();
    const state = _st;
    if (!reg) return {};
    const key = `${lang}/${namespace}`;
    state.loadedNamespaces.add(namespace);
    if (lang === reg.baseLang) return reg.base[namespace] || {};
    if (state.cache.has(key)) return state.cache.get(key);
    if (state.inflight.has(key)) return state.inflight.get(key);
    const thunk = reg.lazy[key];
    if (!thunk) {
        if (!state.warned.has(lang)) {
            state.warned.add(lang);
            console.warn(`[i18n] no bundle for '${lang}' \u{2014} falling back to '${reg.baseLang}'. Add ` + `packages/shared/i18n/${lang}/${namespace}.json and run ` + 'scripts/gen-i18n-registry.mjs, ' + 'or (on a published record) bake the language into context.polyglot.translations.');
        }
        return reg.base[namespace] || {};
    }
    const p = thunk().then((mod)=>{
        // Parcel/Node/Bun all hand back a module namespace; the JSON object is
        // its default export. `mod` itself is the object under some CJS interop
        // shapes, so accept both (FA206's defensive-destructure rule).
        const data = mod?.default || mod;
        // A bundle that arrives as anything but a plain object is a build fault,
        // not a translation. Refuse it rather than caching a module namespace
        // and rendering "[object Module]" into the UI.
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            console.warn(`[i18n] '${key}' did not resolve to an object \u{2014} using '${reg.baseLang}'`);
            return reg.base[namespace] || {};
        }
        state.cache.set(key, data);
        return data;
    }).catch((err)=>{
        console.warn(`[i18n] '${key}' failed to load (${err?.message || err}) \u{2014} using '${reg.baseLang}'`);
        return reg.base[namespace] || {};
    }).finally(()=>{
        state.inflight.delete(key);
    });
    state.inflight.set(key, p);
    return p;
};
const $deab9ddcd0265210$export$180cebc34b09d5f4 = async (lang, namespaces)=>{
    const list = Array.from(new Set(namespaces || []));
    const parts = await Promise.all(list.map((ns)=>$deab9ddcd0265210$export$d7e7635cdba56b8f(lang, ns)));
    const merged = {};
    for (const part of parts)Object.assign(merged, part);
    return merged;
};
const $deab9ddcd0265210$export$20e078bbaa6a7e60 = ()=>{
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    const base = reg?.baseLang || 'en';
    // Normalize the shape rather than trusting it. The state lives on a GLOBAL,
    // so a warm page, an older bundle or a test harness can hand us an object
    // that predates one of these fields — and reading `.has` off an undefined
    // Map is a hard TypeError in the middle of a language switch.
    const _st = w.__i18nLoaderState || (w.__i18nLoaderState = {});
    if (!_st.cache) _st.cache = new Map();
    if (!_st.loadedNamespaces) _st.loadedNamespaces = new Set();
    if (!_st.inflight) _st.inflight = new Map();
    if (!_st.warned) _st.warned = new Set();
    for (const k of Array.from(_st.cache.keys()))if (!k.startsWith(`${base}/`)) _st.cache.delete(k);
};
const $deab9ddcd0265210$export$c3e88959bcdae366 = ()=>{
    const w = typeof window !== 'undefined' ? window : globalThis;
    // Normalize the shape rather than trusting it. The state lives on a GLOBAL,
    // so a warm page, an older bundle or a test harness can hand us an object
    // that predates one of these fields — and reading `.has` off an undefined
    // Map is a hard TypeError in the middle of a language switch.
    const _st = w.__i18nLoaderState || (w.__i18nLoaderState = {});
    if (!_st.cache) _st.cache = new Map();
    if (!_st.loadedNamespaces) _st.loadedNamespaces = new Set();
    if (!_st.inflight) _st.inflight = new Map();
    if (!_st.warned) _st.warned = new Set();
    return Array.from(_st.loadedNamespaces);
};
const $deab9ddcd0265210$export$fde487a3028333bc = (lang)=>{
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    // Normalize the shape rather than trusting it. The state lives on a GLOBAL,
    // so a warm page, an older bundle or a test harness can hand us an object
    // that predates one of these fields — and reading `.has` off an undefined
    // Map is a hard TypeError in the middle of a language switch.
    const _st = w.__i18nLoaderState || (w.__i18nLoaderState = {});
    if (!_st.cache) _st.cache = new Map();
    if (!_st.loadedNamespaces) _st.loadedNamespaces = new Set();
    if (!_st.inflight) _st.inflight = new Map();
    if (!_st.warned) _st.warned = new Set();
    const state = _st;
    const base = reg?.baseLang || 'en';
    const merged = {};
    for (const ns of state.loadedNamespaces){
        if (lang === base) {
            Object.assign(merged, reg?.base?.[ns] || {});
            continue;
        }
        Object.assign(merged, state.cache.get(`${lang}/${ns}`) || reg?.base?.[ns] || {});
    }
    return merged;
};

});
parcelRegister("hEoqE", function(module, exports) {
module.exports = JSON.parse('{"account.availability.day.fri":"Fri","account.availability.day.mon":"Mon","account.availability.day.sat":"Sat","account.availability.day.sun":"Sun","account.availability.day.thu":"Thu","account.availability.day.tue":"Tue","account.availability.day.wed":"Wed","account.member.a11y.contrast":"High contrast","account.member.a11y.contrastHint":"Quiet text becomes full-strength ink.","account.member.a11y.fontSize":"Text size","account.member.a11y.fontSizeHint":"Scales every text in the app.","account.member.a11y.fontSizeLarge":"Text size: large","account.member.a11y.fontSizeNormal":"Text size: normal","account.member.a11y.fontSizeSmall":"Text size: small","account.member.a11y.hint":"These choices apply on this device and stay on it.","account.member.a11y.links":"Underline links","account.member.a11y.linksHint":"Marks links with more than colour.","account.member.a11y.motion":"Reduced motion","account.member.a11y.motionHint":"Stops animations and transitions.","account.member.a11y.reset":"Reset to defaults","account.member.a11y.singleKeys":"Single-key shortcuts","account.member.a11y.singleKeysHint":"Keys like / and ? run commands when you are not typing. Turn this off if you use speech or a switch device. Shortcuts with \u2318 or Ctrl stay on.","account.member.a11y.title":"Accessibility","account.member.access.active":"Full access (active)","account.member.access.fullHint":"Currently has full edit access across the workspace.","account.member.access.hint":"Inactive members keep read-only access. They can view the workspace but cannot make changes. They are hidden from active team rosters, calendars and channels.","account.member.access.inactive":"Read-only (inactive)","account.member.access.left":"Deactivated (left)","account.member.access.readOnlyHint":"Currently read-only. Restore to give full edit access.","account.member.access.restore":"Restore full access","account.member.access.saving":"Saving\u2026","account.member.access.setReadOnly":"Set read-only","account.member.access.title":"Member access","account.member.action.cancel":"Cancel","account.member.action.edit":"Edit","account.member.action.message":"Message","account.member.action.settings":"Settings","account.member.action.viewProfile":"View profile","account.member.availability.readOnly":"Read only","account.member.availability.title":"Availability","account.member.availability.toggle":"Click to toggle cells. Shift+Click to multi-select cells.","account.member.availability.toggleAdmin":"Click to toggle cells. Shift+Click to multi-select cells. (admin)","account.member.avatar.change":"Change","account.member.avatar.upload":"Upload photo","account.member.checklist.availability":"Availability configured","account.member.checklist.done":"Done","account.member.checklist.location":"Location & Timezone set","account.member.checklist.pending":"Pending","account.member.danger.deactivate":"Deactivate account","account.member.danger.deactivateBtn":"Deactivate","account.member.danger.deactivateConfirm":"Confirm deactivation?","account.member.danger.deactivateHint":"Hides your profile and revokes access. Contact admin to reactivate.","account.member.danger.hint":"These actions are irreversible. Please be sure before proceeding.","account.member.danger.personalOrgUndeletable":"You cannot delete a personal organization. It belongs to your account.","account.member.danger.signOut":"Sign out","account.member.danger.signOutBtn":"Sign out","account.member.danger.signOutConfirm":"Confirm sign out?","account.member.danger.signOutHint":"End your current session.","account.member.danger.title":"Danger zone","account.member.documents.empty":"No documents yet","account.member.documents.open":"Open","account.member.documents.title":"Documents","account.member.field.city":"City","account.member.field.country":"Country","account.member.field.fullName":"Full name","account.member.field.github":"GitHub","account.member.field.position":"Position","account.member.field.role":"Role","account.member.field.team":"Team","account.member.field.tenure":"Tenure","account.member.field.timezone":"Timezone","account.member.field.username":"Username","account.member.notifications.birthdays":"Birthday reminders","account.member.notifications.digest":"Email digest","account.member.notifications.digestAria":"Email digest frequency","account.member.notifications.digestHint":"Summary of announcements and meetings.","account.member.notifications.mentions":"Mentions","account.member.notifications.mentionsAria":"Mention notifications","account.member.notifications.mentionsHint":"How you receive mention notifications.","account.member.notifications.sound":"Notification sound","account.member.notifications.title":"Notifications","account.member.permissionDenied.message":"You don\'t have permission to update team membership. Please contact your administrator.","account.member.permissionDenied.title":"Permission denied","account.member.placeholder.city":"City","account.member.placeholder.github":"username","account.member.placeholder.name":"Your name","account.member.placeholder.newPassword":"New password","account.member.placeholder.position":"e.g. Frontend Engineer","account.member.role.admin":"Admin","account.member.role.coOwner":"Co-owner","account.member.role.editor":"Member","account.member.role.guest":"Guest","account.member.role.manager":"Manager","account.member.role.member":"Member","account.member.role.owner":"Owner","account.member.role.superadmin":"Superadmin","account.member.role.viewer":"Contributor","account.member.security.backupCodes":"Backup codes","account.member.security.password":"Password","account.member.security.passwordHint":"Change your login password.","account.member.security.title":"Security","account.member.security.twoFa":"Two-factor auth","account.member.security.twoFaHint":"TOTP authenticator support planned.","account.member.security.update":"Update","account.member.security.updateFailed":"Failed","account.member.security.updated":"Updated!","account.member.select.none":"None","account.member.session.activeNow":"Active now","account.member.session.browser":"Browser","account.member.session.platform":"Platform","account.member.session.status":"Status","account.member.session.title":"Current session","account.member.team.create":"+ Create team\u2026","account.member.team.newPrompt":"New team name","account.member.team.save":"Save","account.member.team.saving":"Saving\u2026","account.member.toggle.off":"Off","account.member.toggle.on":"On","account.member.upload.failed":"Avatar upload failed","account.member.uploadUnavailable.message":"SDK does not expose uploadFile in this build.","account.member.uploadUnavailable.title":"Upload unavailable","account.my.title":"My profile","account.page.userProfile.title":"Profile","account.profile.eyebrow":"Account","account.profile.section":"People","account.profile.sections.access":"Member access","account.profile.sections.accessibility":"Accessibility","account.profile.sections.availability":"Availability","account.profile.sections.checklist":"Checklist","account.profile.sections.danger_zone":"Danger zone","account.profile.sections.details":"Details","account.profile.sections.documents":"Documents","account.profile.sections.mail":"Mail","account.profile.sections.notifications":"Notifications","account.profile.sections.profile":"Profile","account.profile.sections.security":"Security","account.profile.sections.sessions":"Sessions","account.profile.title":"Profile","account.userProfile.activity.less":"Less","account.userProfile.activity.more":"More","account.userProfile.activity.title":"ACTIVITY \xb7 LAST YEAR","account.userProfile.browseAll":"Browse all people \u2192","account.userProfile.edit":"Edit profile","account.userProfile.editDone":"Done","account.userProfile.empty.agents":"No public agents.","account.userProfile.empty.followers":"No followers yet.","account.userProfile.empty.following":"Not following anyone yet.","account.userProfile.empty.integrations":"No public integrations.","account.userProfile.empty.projects":"No public projects yet.","account.userProfile.fallbackName":"Profile","account.userProfile.follow":"Follow","account.userProfile.following":"Following","account.userProfile.placeholder.bio":"Tell people what you build\u2026","account.userProfile.placeholder.location":"Where are you?","account.userProfile.placeholder.name":"Your name","account.userProfile.saveFailed":"Save failed","account.userProfile.saved":"Saved","account.userProfile.saving":"Saving\u2026","account.userProfile.tab.agents":"Agents","account.userProfile.tab.followers":"Followers","account.userProfile.tab.following":"Following","account.userProfile.tab.integrations":"Integrations","account.userProfile.tab.projects":"Projects","account.userProfile.you":"You","account.member.availability.reset":"Reset","account.member.availability.selectAll":"Select all","account.userProfile.joined":"Joined {date}","account.member.assistant.title":"Assistant","account.member.assistant.answers":"Answers","account.member.assistant.answersHint":"Where the assistant\'s answers appear. Page builds a board on the home.","account.profile.sections.assistant":"Assistant","account.profile.settingsTitle":"Settings","account.member.notSet":"Not set","account.member.documents.sizeKb":"{size} KB","account.member.documents.signedOn":"Signed {date}"}');

});

parcelRegister("6i63J", function(module, exports) {
module.exports = JSON.parse('{"admin.activity.type.kbEdit":"KB edit","admin.activity.type.meetCall":"Meet call","admin.activity.type.noteEdit":"Note edit","admin.activity.type.standup":"Standup","admin.activity.type.ticketUpdate":"Ticket update","admin.activityScoring.allSaved":"All changes saved.","admin.activityScoring.col.activity":"Activity","admin.activityScoring.col.description":"Description","admin.activityScoring.col.enabled":"Enabled","admin.activityScoring.col.score":"Score (pts)","admin.activityScoring.dirty":"Unsaved changes","admin.activityScoring.error.noneSaved":"Changes were not saved.","admin.activityScoring.error.someSaved":"{rejected} of {total} changes were not saved.","admin.activityScoring.reason.network":"network or server error","admin.activityScoring.reason.rejected":"save was rejected","admin.activityScoring.intro":"Each event below is scored when the underlying action happens (standup saved, task moved, note edited, KB doc updated, call analyzed). Scores are snapshot-per-event \u2014 editing a score changes future events only, never rewrites history. Disabling an activity stops emitting new events of that type.","admin.activityScoring.page.title":"Activity scoring / Admin","admin.activityScoring.reset":"Reset","admin.activityScoring.save":"Save changes","admin.activityScoring.saved":"Saved.","admin.activityScoring.saving":"Saving\u2026","admin.activityScoring.title":"Activity Scoring","admin.activityScoring.toast.noneSaved":"Changes were not saved","admin.activityScoring.toast.someSaved":"{rejected} of {total} changes were not saved","admin.analytics.disabled":"Disabled","admin.analytics.enabled":"Enabled","admin.analytics.error.loadOrg":"Could not read the organization\'s analytics setting.","admin.analytics.error.loadProjects":"Failed to load projects","admin.analytics.error.updateOrg":"Failed to update org analytics: {error}","admin.analytics.error.updateProject":"Failed to update {name}: {error}","admin.analytics.how.defaultOn":"Analytics defaults to enabled (opt-in model).","admin.analytics.how.injector":"The tracker is injected by the mermaid CDN worker via HTMLRewriter.","admin.analytics.how.orgOff":"Disabling org-level analytics prevents injection across ALL projects.","admin.analytics.how.perProject":"Per-project toggles only apply when org-level analytics is on.","admin.analytics.how.timing":"Changes take effect on the next preview page load.","admin.analytics.how.title":"How it works","admin.analytics.loadingProjects":"Loading projects","admin.analytics.noOrg":"No active org in JWT claims","admin.analytics.org.desc":"When disabled, the analytics tracking snippet is NOT injected on any project preview for this organization, regardless of per-project settings.","admin.analytics.org.label":"Org-level analytics","admin.analytics.org.title":"Organization-Wide Analytics","admin.analytics.orgId":"Org ID: {id}","admin.analytics.page.title":"Analytics / Admin","admin.analytics.projectOff":"Analytics off","admin.analytics.projectOn":"Analytics on","admin.analytics.projectToggleAria":"Analytics for {name}","admin.analytics.projects.desc":"Toggle analytics tracking per project. Takes effect on next preview load. Org-level opt-out overrides all per-project settings.","admin.analytics.projects.empty":"No projects found for this organization.","admin.analytics.projects.title":"Per-Project Analytics","admin.analytics.refresh":"Refresh","admin.analytics.title":"Analytics Opt-Out","admin.app.analytics":"Analytics","admin.app.announcements":"Announcements","admin.app.calendar":"Calendar","admin.app.chat":"Chat","admin.app.company":"Company","admin.app.data":"Data","admin.app.documents":"Documents","admin.app.files":"Files","admin.app.meet":"Meet","admin.app.reminders":"Reminders","admin.app.resolutions":"Resolutions","admin.app.tickets":"Tasks","admin.branding.colors.desc":"Hex values only. The server refuses anything else, because these colours are written into a public page.","admin.branding.colors.title":"Colours","admin.branding.error.adminOnly":"Your role in this organization does not allow a branding change.","admin.branding.error.fileRead":"Could not read that file.","admin.branding.error.generic":"Could not save the branding.","admin.branding.error.invalidColor":"{field} must be a hex colour, for example #3366ff.","admin.branding.error.noOrg":"No active organization.","admin.branding.error.notReady":"The connection to the server is not ready yet. Try again in a moment.","admin.branding.error.saveFailed":"Could not save the branding","admin.branding.field.accent":"Accent","admin.branding.field.background":"Background \u2014 dark","admin.branding.field.backgroundLight":"Background \u2014 light","admin.branding.field.lang":"Sign-in language","admin.branding.field.loaderLogoSvg":"Loader mark","admin.branding.field.logoSvg":"Logo","admin.branding.field.name":"Brand name","admin.branding.field.tagline":"Tagline","admin.branding.field.theme":"Theme","admin.branding.hint.background":"The ground the branded surfaces use in the dark scheme.","admin.branding.hint.backgroundLight":"The ground for the light scheme. Empty means a neutral ground.","admin.branding.hint.marks":"The logo paints the branded sign-in page. The loader mark paints the boot screen; without it the logo is used.","admin.branding.identity.desc":"The name and the line shown on your branded sign-in page.","admin.branding.identity.title":"Identity","admin.branding.marks.desc":"Paste the SVG markup, or load an .svg file into the box. The server removes scripts and event handlers before it stores a mark.","admin.branding.marks.title":"Marks","admin.branding.option.unset":"Not set","admin.branding.presentation.desc":"How the branded sign-in page and the boot loader open. Neither value changes the app after sign-in.","admin.branding.presentation.title":"Presentation","admin.branding.save":"Save branding","admin.branding.savedBody":"The branded sign-in page and the loader use the new values on the next load.","admin.branding.savedTitle":"Branding saved","admin.branding.saving":"Saving\u2026","admin.branding.theme.auto":"Follow the device","admin.branding.theme.dark":"Dark","admin.branding.theme.light":"Light","admin.branding.title":"Branding","admin.branding.unsaved":"You have unsaved changes.","admin.branding.upload.loaderLogoSvg":"Load an .svg file for the loader mark","admin.branding.upload.logoSvg":"Load an .svg file for the logo","admin.danger.btn.done":"Done","admin.danger.btn.failed":"Failed","admin.danger.btn.working":"Working\u2026","admin.danger.deactivate.button":"Deactivate","admin.danger.deactivate.confirmMessage":"Everyone in this workspace without a core role gets the status \u201Cleft\u201D. Admins, managers and members keep theirs. This cannot be undone in one step.","admin.danger.deactivate.hint":"Set status to \\"left\\" for everyone without a core role","admin.danger.deactivate.label":"Deactivate all non-core members","admin.danger.deactivate.noRoster":"The member list is not loaded yet. Try again in a moment.","admin.danger.deactivate.none":"No member to deactivate: everyone has a core role or has already left.","admin.danger.deactivate.notAllowed":"Only a platform superuser can deactivate members.","admin.danger.deactivate.titleMany":"Deactivate {count} members?","admin.danger.deactivate.titleOne":"Deactivate 1 member?","admin.danger.destructive":"Destructive Actions","admin.danger.domain.notAllowed":"This action is not available on this domain.","admin.danger.export.button":"Export JSON","admin.danger.export.confirmMessage":"The JSON file holds all users, their roles and equity data. Anyone who has the file can read it.","admin.danger.export.confirmTitle":"Export all user data?","admin.danger.export.download":"Download JSON","admin.danger.export.hint":"Download all users, roles, and equity data as JSON","admin.danger.export.label":"Export all user data","admin.danger.hint":"These actions are irreversible.","admin.danger.page.title":"Danger zone / Admin","admin.danger.purgeChat.button":"Purge messages","admin.danger.purgeChat.confirmMessage":"Every message in every channel is deleted for everyone, with its reactions and mentions. The channels and their members stay. This cannot be undone.","admin.danger.purgeChat.confirmTitle":"Delete all chat messages in \u201C{workspace}\u201D?","admin.danger.purgeChat.confirmTitleAll":"Delete all chat messages in this workspace?","admin.danger.purgeChat.hint":"Delete every message in THIS workspace across all channels \u2014 channel structure is preserved","admin.danger.purgeChat.label":"Purge all chat messages","admin.danger.purgeChat.notAllowed":"Only a platform admin can purge chat messages.","admin.danger.title":"Danger Zone","admin.data.nav":"Data export","admin.data.page.title":"Data export / Admin","admin.data.title":"Data export","admin.data.card.title":"Export all workspace data","admin.data.card.desc":"One ZIP file. It holds the records of each app as JSON and CSV, the members and their roles, the settings, the payment records and a list of files with download links.","admin.data.card.scope":"You get the shared data and your own private records. Card numbers are never in the file.","admin.data.card.access":"Only a workspace owner or admin can export.","admin.data.start":"Start export","admin.data.startTitle":"Export all workspace data?","admin.data.startMessage":"The ZIP file holds the records of every app, the members and their roles, the settings and the payment records. Anyone who has the file can read them.","admin.data.starting":"Starting\u2026","admin.data.opening":"Opening\u2026","admin.data.deleteTitle":"Delete this export?","admin.data.deleteMessage":"Requested: {date}. The export and its file are deleted for good. To get the data again, start a new export.","admin.data.list.title":"Your exports","admin.data.list.empty":"No exports yet.","admin.data.list.loading":"Loading exports","admin.data.status.queued":"Queued","admin.data.status.running":"Running","admin.data.status.ready":"Ready","admin.data.status.expired":"Expired","admin.data.status.failed":"Failed","admin.data.row.requested":"Requested: {date}","admin.data.row.until":"Available until: {date}","admin.data.row.size":"{size} \xb7 {rows} records","admin.data.row.progress":"Step {done} of {total}","admin.data.row.queued":"Waiting to start.","admin.data.row.expired":"The file is no longer available.","admin.data.fail.roleRevoked":"Your role changed, so the export stopped.","admin.data.fail.tooLarge":"The data is too large for one file. Contact support.","admin.data.fail.workerLost":"The export stopped. Start a new one.","admin.data.fail.other":"The export failed. Start a new one.","admin.data.error.inProgress":"An export is already running. Wait until it ends.","admin.data.error.rateLimited":"Limit reached: {limit} exports in 24 hours. Try again after: {time}","admin.data.error.notReady":"Not ready yet. Try again.","admin.data.error.expired":"This export expired. Start a new one.","admin.data.error.notFound":"This export is not found.","admin.data.error.unavailable":"The export service is not available now. Try again later.","admin.data.error.generic":"Something went wrong. Try again.","admin.data.error.load":"Could not load your exports.","admin.dashboardDefaults.card.desc":"Panels new members see by default on their home dashboard. Everyone can still personalize their own \u2014 these are only the starting defaults. The greeting card is always shown.","admin.dashboardDefaults.card.title":"Default home panels","admin.dashboardDefaults.hidden":"Hidden by default","admin.dashboardDefaults.needsAdmin":"Saving requires a workspace-admin role.","admin.dashboardDefaults.noWorkspace":"No active workspace.","admin.dashboardDefaults.page.title":"Dashboard Defaults / Admin","admin.dashboardDefaults.saveFailed":"Couldn\'t save dashboard default","admin.dashboardDefaults.sdkNotReady":"SDK not ready.","admin.dashboardDefaults.shown":"Shown by default","admin.dashboardDefaults.title":"Dashboard Defaults","admin.domains.addCta":"Add domain","admin.domains.added":"Domain added","admin.domains.addedBody":"{domain} is attached. It starts serving once DNS and TLS verify.","admin.domains.adding":"Adding\u2026","admin.domains.card.desc":"Serve this workspace on your own hostname. Point a CNAME at the Symbols edge first \u2014 the domain stays inactive until the DNS and the certificate verify.","admin.domains.card.title":"Add a domain","admin.domains.error.add":"Could not add the domain.","admin.domains.error.load":"Could not load the domains.","admin.domains.error.noOrg":"No active organization or workspace.","admin.domains.error.notReady":"The connection is not ready yet. Try again.","admin.domains.field.hostname":"Hostname","admin.domains.list.empty":"No domains attached yet.","admin.domains.list.title":"Attached domains","admin.domains.loading":"Loading domains","admin.domains.page.title":"White-label Domains / Admin","admin.domains.pending":"Pending DNS + certificate verification","admin.domains.placeholder.hostname":"e.g. app.example.com","admin.domains.title":"White-label Domains","admin.domains.upsell.currentPlan":"This organization is currently on the {tier} plan.","admin.domains.upsell.seePlans":"See plans","admin.domains.upsell.title":"White-label domains need a higher plan","admin.domains.upsell.titleNamed":"White-label domains are a {tier} feature","admin.domains.verified":"Verified \u2014 serving","admin.flags.alwaysOn":"Always on","admin.flags.coreTitle":"Core feature \u2014 always on","admin.flags.disclosureAria":"Show {flag} sub-features","admin.flags.intro":"Everything the workspace ships, in one place. Switch features on or off for this workspace \u2014 Basics are the foundation and stay always on. Click a feature to open its sub-features. Changes save to the workspace and apply to everyone in it.","admin.flags.page.title":"Feature flags / Admin","admin.flags.subCount":"{count} sub-features","admin.flags.subCountOne":"1 sub-feature","admin.flags.title":"Feature flags","admin.flags.toggleAria":"Toggle {flag}","admin.flags.turnOff":"Turn off","admin.flags.turnOn":"Turn on","admin.gh.addBoard":"+ Add a Projects board","admin.gh.auth.hint":"No PAT required. Server auths every call as the org-installed App; tokens auto-rotate hourly. Install/uninstall via github.com/organizations/<org>/settings/installations.","admin.gh.auth.link":"Install or manage the GitHub App \u2192","admin.gh.auth.title":"Auth: the org-installed GitHub App","admin.gh.back":"\u2190 Integrations","admin.gh.cancel":"Cancel","admin.gh.connect":"Connect","admin.gh.connectFailed":"Connect failed","admin.gh.connected":"Connected","admin.gh.disconnected":"Disconnected","admin.gh.emptyHint":"Add a GitHub Projects v2 board to keep its tasks in sync with this workspace.","admin.gh.emptyTitle":"No boards connected yet","admin.gh.field.displayName":"Display name","admin.gh.field.owner":"Repo owner / org (required)","admin.gh.field.projectId":"Projects v2 ID (required)","admin.gh.field.slug":"Slug","admin.gh.form.title":"Add a GitHub Projects v2 board","admin.gh.intro":"Tasks in governance stay in sync with GitHub Projects v2. Every board below is a separate slot \u2014 add one per team, per product, or per org you want to mirror.","admin.gh.meta":"Slug: {slug} \xb7 Owner: {owner} \xb7 Project: {project}","admin.gh.missingFields":"Missing required fields","admin.gh.missingFieldsBody":"Owner and project ID are required. (Auth is the org-installed GitHub App \u2014 no PAT.)","admin.gh.noWorkspace":"No active workspace","admin.gh.page.title":"GitHub / Integrations","admin.gh.placeholder.displayName":"Product board","admin.gh.placeholder.owner":"e.g. acme","admin.gh.placeholder.slug":"e.g. acme-main","admin.gh.pullNow":"Pull now","admin.gh.remove":"Remove","admin.gh.removeTitle":"Remove \u201C{board}\u201D?","admin.gh.removeMessage":"The connection is deleted and new sync stops. Tickets already synced stay in governance.","admin.gh.removeFailed":"Remove failed","admin.gh.saving":"Saving\u2026","admin.gh.scopeRequired":"Scope target required","admin.gh.scopeRequiredBody":"Select a {scope} or switch scope to Org.","admin.gh.serverError":"Server error","admin.gh.syncFailed":"Sync failed","admin.gh.syncStarted":"Sync started","admin.gh.syncing":"Syncing\u2026","admin.gh.title":"GitHub","admin.google.back":"\u2190 Integrations","admin.google.configOnly":"Config only (no service account key)","admin.google.configuredDisabled":"Configured \xb7 disabled","admin.google.configuredEnabled":"Configured \xb7 enabled","admin.google.domainRequired":"Domain required","admin.google.field.adminEmail":"Admin email (DWD subject)","admin.google.field.domain":"Workspace domain","admin.google.intro":"Domain-wide delegation authorizes governance to sync calendars on behalf of every user in the workspace. Rotate the service account JSON to revoke access.","admin.google.noWorkspace":"No active workspace","admin.google.notConfigured":"Not configured","admin.google.page.title":"Google Workspace / Integrations","admin.google.placeholder.adminEmail":"e.g. admin@example.com","admin.google.placeholder.domain":"e.g. example.com","admin.google.pullCalendar":"Pull calendar","admin.google.remove":"Remove integration","admin.google.removeTitle":"Remove the Google Workspace integration?","admin.google.removeMessage":"Its stored credentials are deleted and calendar sync stops.","admin.google.removeFailed":"Remove failed","admin.google.removed":"Removed","admin.google.save":"Save","admin.google.saveFailed":"Save failed","admin.google.saved":"Saved","admin.google.saving":"Saving\u2026","admin.google.secret.hint":"Must have domain-wide delegation and the calendar read/write scopes authorized in Google Admin.","admin.google.secret.label":"Service account JSON (paste new to rotate \u2014 leave empty to keep)","admin.google.serverError":"Server error","admin.google.syncFailed":"Sync failed","admin.google.syncStarted":"Sync started","admin.google.syncing":"Syncing\u2026","admin.google.title":"Google Workspace","admin.integrations.addAnother":"+ Add another","admin.integrations.back":"\u2190 Integrations","admin.integrations.browse":"Browse integrations \u2192","admin.integrations.cap.imageGenerate":"Image generation","admin.integrations.cap.textEmbed":"Text embeddings","admin.integrations.cap.textGenerate":"Text generation","admin.integrations.card.configured":"Configured","admin.integrations.card.connected":"{count} connected","admin.integrations.category.ai":"AI providers","admin.integrations.category.analytics":"Analytics","admin.integrations.category.automation":"Automation","admin.integrations.category.custom":"Custom","admin.integrations.category.data":"Data sources","admin.integrations.category.dev":"Developer tools","admin.integrations.category.messaging":"Real-time & messaging","admin.integrations.category.other":"Other","admin.integrations.category.workspace":"Workspace","admin.integrations.configure":"+ Configure","admin.integrations.empty.body":"Connect data sources, AI providers, dev tools and messaging from the marketplace \u2014 they show up here once configured.","admin.integrations.empty.cta":"Open marketplace \u2192","admin.integrations.empty.title":"No integrations configured yet","admin.integrations.generic.emptyHint":"Connect it with the button above. Credentials are stored in the server-side vault.","admin.integrations.generic.emptyTitle":"Not connected yet","admin.integrations.generic.unknownHint":"This integration is not in the catalogue. Go back to Integrations or browse the marketplace.","admin.integrations.generic.unknownTitle":"Unknown integration","admin.integrations.genericPage.title":"{name} / Integrations","admin.integrations.genericTitle":"Integration","admin.integrations.hint":"Active integrations for {org}. Credentials live in the server-side vault; every surface reads from the same registry.","admin.integrations.loading":"Loading integrations","admin.integrations.page.title":"Integrations / Admin","admin.integrations.thisOrg":"this org","admin.integrations.title":"Integrations","admin.logs.author.stats":"{count} events \xb7 {score} pts","admin.logs.author.statsOne":"1 event \xb7 {score} pts","admin.logs.clearDate":"\xd7 Clear date filter","admin.logs.day.eventCount":"{count} events","admin.logs.day.eventCountOne":"1 event","admin.logs.empty":"No activity events for this filter.","admin.logs.error.load":"The activity log could not be read.","admin.logs.filterByDate":"Filter by date","admin.logs.intro.peopleCount":"{count} people","admin.logs.intro.personCount":"{count} person","admin.logs.intro.text":"{count} events {scope} from {people}.","admin.logs.page.title":"Logs / Admin","admin.logs.scope.allDates":"across all dates","admin.logs.scope.onDate":"on {date}","admin.logs.title":"Activity Logs","admin.mail.accounts.desc":"Health only \u2014 the workspace never shows an admin the content of a member\'s mailbox.","admin.mail.accounts.empty":"No connected accounts yet.","admin.mail.accounts.title":"Connected accounts","admin.mail.audit.empty":"No mail admin actions yet.","admin.mail.audit.openLogs":"Open activity logs","admin.mail.audit.title":"Audit","admin.mail.loading":"Loading\u2026","admin.mail.page.title":"Mail / Admin","admin.mail.policy.aiDraft":"Assistant may draft replies","admin.mail.policy.aiDraftDesc":"Drafts only \u2014 sending stays a member action.","admin.mail.policy.aiRead":"Assistant may read mail","admin.mail.policy.aiReadDesc":"Summaries and triage over messages the member can already read.","admin.mail.policy.allowPersonal":"Who may connect personal accounts","admin.mail.policy.allowPersonalDesc":"Personal Gmail or Outlook mailboxes connected by the member.","admin.mail.policy.attachments":"Save attachments to Files","admin.mail.policy.attachmentsDesc":"Members may copy attachments into workspace Files.","admin.mail.policy.autoProvision":"Auto-provision tenant mailboxes","admin.mail.policy.autoProvisionDesc":"Create a mailbox for every new member the directory matches.","admin.mail.policy.bodyCache":"Body cache","admin.mail.policy.bodyCacheDesc":"How long fetched message bodies stay stored.","admin.mail.policy.cache30":"30 days","admin.mail.policy.cache7":"7 days","admin.mail.policy.cache90":"90 days","admin.mail.policy.desc":"Workspace mail rules. Each change saves on its own.","admin.mail.policy.deskAssignee":"Default assignee","admin.mail.policy.deskAssigneeDesc":"New service-desk tickets assign to this member.","admin.mail.policy.deskAutoTicket":"Auto-create a ticket per new thread","admin.mail.policy.deskAutoTicketDesc":"One ticket per new shared-inbox thread.","admin.mail.policy.deskConversations":"Shared-inbox threads create Conversations","admin.mail.policy.deskConversationsDesc":"Every shared-inbox thread lands in the service desk.","admin.mail.policy.deskTeam":"Default team","admin.mail.policy.deskTeamDesc":"New service-desk tickets route to this team.","admin.mail.policy.disable":"Turn off","admin.mail.policy.disableMessage":"Members stop seeing Mail, and no one can connect a mailbox until you turn it back on. Nothing is deleted.","admin.mail.policy.disableTitle":"Turn off Mail for this workspace?","admin.mail.policy.domains":"Allowed sign-in domains","admin.mail.policy.domainsDesc":"Personal addresses must be on one of these domains. Empty means no restriction.","admin.mail.policy.domainsPlaceholder":"acme.com \u2014 press Enter","admin.mail.policy.enabled":"Mail enabled for this workspace","admin.mail.policy.enabledDesc":"The admin\'s copy of the product switch \u2014 members see Mail only while this is on.","admin.mail.policy.imagesAsk":"Ask","admin.mail.policy.imagesBlock":"Block","admin.mail.policy.none":"None","admin.mail.policy.personalEveryone":"Everyone","admin.mail.policy.personalNobody":"Nobody","admin.mail.policy.personalOrg":"Only org domains","admin.mail.policy.remoteImages":"Remote images default","admin.mail.policy.remoteImagesDesc":"How messages load remote images before the member decides.","admin.mail.policy.title":"Policy","admin.mail.policy.window":"Mirror window","admin.mail.policy.window30":"30 days","admin.mail.policy.window365":"365 days","admin.mail.policy.window90":"90 days","admin.mail.policy.windowAll":"All mail","admin.mail.policy.windowDesc":"How far back message metadata syncs.","admin.mail.providers.desc":"Connect Google Workspace or Microsoft 365 so member mailboxes are provisioned without a per-user sign-in. The steps below carry your organization\'s own values.","admin.mail.providers.title":"Organization mail providers","admin.mail.shared.add":"Add shared inbox","admin.mail.shared.desc":"support@, sales@ \u2014 one mailbox, granted to people and teams.","admin.mail.shared.empty":"No shared inboxes yet.","admin.mail.shared.title":"Shared inboxes","admin.mail.title":"Mail","admin.mcp.add":"+ New MCP connector","admin.mcp.back":"\u2190 Integrations","admin.mcp.capabilities":"Capabilities","admin.mcp.capsRefreshed":"Capabilities refreshed","admin.mcp.connectSymbols":"Connect Symbols MCP","admin.mcp.deleteFailed":"Delete failed","admin.mcp.deleteMessage":"The connector is deleted, and the AI can no longer use its tools.","admin.mcp.deleteTitle":"Disconnect \u201C{name}\u201D?","admin.mcp.disable":"Disable","admin.mcp.disabled":"Disabled","admin.mcp.disconnect":"Disconnect","admin.mcp.disconnected":"Disconnected","admin.mcp.discoveryFailed":"Discovery failed","admin.mcp.empty.hint":"Connect the Symbols MCP server or any other MCP-compatible server to give canvas AI agents access to tools and resources.","admin.mcp.empty.title":"No MCP connectors yet","admin.mcp.enable":"Enable","admin.mcp.enabled":"Enabled","admin.mcp.live":"Live","admin.mcp.loadError":"Couldn\'t load connectors: {error}","admin.mcp.page.title":"MCP Connectors / Integrations","admin.mcp.rediscover":"Re-discover","admin.mcp.rediscoverTitle":"Re-run tools/list + resources/list","admin.mcp.row.auth":"Auth","admin.mcp.row.transport":"Transport","admin.mcp.row.url":"URL","admin.mcp.subtitle":"Remote MCP servers available to canvas AI agents as tool providers.","admin.mcp.title":"MCP Connectors","admin.mcp.updateFailed":"Update failed","admin.module.apps.add":"+ Add app","admin.module.apps.desc":"App-launcher entries \u2014 title, caption, icon, icon background token, and route.","admin.module.apps.remove":"Remove app","admin.module.apps.save":"Save apps","admin.module.apps.title":"Apps","admin.module.appsField.caption":"Caption","admin.module.appsField.icon":"Icon","admin.module.appsField.iconBg":"Icon bg (token)","admin.module.appsField.route":"Route","admin.module.appsField.title":"Title","admin.module.assign.desc":"Point this workspace at a published module project. Owner defaults to your organization slug (Tier-1 self-serve). The server validates the reference and clamps the tier before it takes effect.","admin.module.assign.confirmMessage":"Everyone in this workspace gets this module. It replaces the module that is assigned now.","admin.module.assign.confirmTitle":"Assign \u201C{module}\u201D to this workspace?","admin.module.assign.save":"Save module","admin.module.assign.saving":"Saving\u2026","admin.module.assign.title":"Assign module","admin.module.danger.desc":"Detach the module from this workspace and reset navbar, apps, and home panels to defaults.","admin.module.danger.title":"Danger zone","admin.module.danger.uninstall":"Uninstall module","admin.module.danger.uninstalling":"Uninstalling\u2026","admin.module.design.apply":"Apply design system","admin.module.design.applying":"Applying\u2026","admin.module.design.canvasBg":"canvas background","admin.module.design.desc":"A guarded skin \u2014 { \\"canvasBg\\": \u2026, \\"vars\\": { \u2026 } }. Validate to preview below, then Apply. Invalid JSON is never saved.","admin.module.design.placeholder":"e.g. { \\"canvasBg\\": \\"\u2026\\", \\"vars\\": { } }","admin.module.design.preview":"Preview (not yet applied)","admin.module.design.title":"Design system","admin.module.design.validate":"Validate","admin.module.field.channel":"Channel","admin.module.field.channelPlaceholder":"e.g. production","admin.module.field.key":"Key","admin.module.field.keyPlaceholder":"e.g. workspace-module","admin.module.field.owner":"Owner (org slug)","admin.module.field.ownerPlaceholder":"e.g. your-org","admin.module.field.tier":"Tier (requested)","admin.module.field.version":"Version (pin)","admin.module.integrations.desc":"The OrgIntegration kinds + capability calls this app may reach through the moduleData bridge. Operator-granted only \u2014 no app can request this by publishing a manifest.","admin.module.integrations.title":"Integrations grant","admin.module.kv.capabilities":"Capabilities","admin.module.kv.channel":"Channel","admin.module.kv.kinds":"Kinds","admin.module.kv.ownerKey":"Owner / key","admin.module.kv.tier":"Tier","admin.module.kv.version":"Version","admin.module.level.acl":"Rows shared with them","admin.module.level.member":"Everyone in the workspace","admin.module.level.own":"Own rows only","admin.module.level.scoped":"Rows by {field}","admin.module.migrate.desc":"This app is still installed in the older single-slot format. Moving it into the app list lets you manage it the same way as every app installed since \u2014 remove just this one, pick it in the app picker above \u2014 without changing anything it does.","admin.module.migrate.move":"Move to app list","admin.module.migrate.moving":"Moving\u2026","admin.module.migrate.title":"Move to the app list","admin.module.nav.dragToReorder":"Drag to reorder","admin.module.nav.labelPlaceholder":"Label","admin.module.nav.moveDown":"Move down","admin.module.nav.moveUp":"Move up","admin.module.nav.pathAria":"Path","admin.module.nav.pathPlaceholder":"e.g. /crm","admin.module.navbar.addTab":"+ Add tab","admin.module.navbar.desc":"Top navigation tabs for this workspace \u2014 each is a label + route.","admin.module.navbar.reset":"Reset to defaults","admin.module.navbar.resetConfirmMessage":"The navbar and the home page widgets go back to their defaults for everyone in this workspace, and your own home layout is cleared. Custom tabs and widget choices are lost.","admin.module.navbar.resetConfirmTitle":"Reset the navbar and the home page to defaults?","admin.module.navbar.resetTitle":"Reset navbar AND the / page widgets to defaults","admin.module.navbar.save":"Save navbar","admin.module.navbar.title":"Navbar","admin.module.notify.appGone":"App no longer installed","admin.module.notify.appsChanged":"Installed apps changed while you were editing","admin.module.notify.appsChangedBody":"Someone installed or uninstalled an app in this workspace. The list has been reloaded \u2014 nothing was written. Re-apply your grant change on top of it.","admin.module.notify.assignFailed":"Assign failed","admin.module.notify.assignFailedBody":"The server rejected the module reference.","admin.module.notify.assigned":"Module set to {module}","admin.module.notify.cantRevokeAll":"Can\'t revoke every operation","admin.module.notify.cantRevokeAllBody":"An empty grant means \\"all operations\\" to the module bridge \u2014 revoke the collection instead.","admin.module.notify.checkFirst":"Check for updates first","admin.module.notify.dsValid":"Design system JSON is valid","admin.module.notify.dsValidBody":"Preview below, then Apply.","admin.module.notify.grantSynced":"Grant synced","admin.module.notify.levelStale":"The app\'s access changed again","admin.module.notify.levelStaleBody":"Nothing was written. Check for updates again, then approve what the app asks for now.","admin.module.notify.migrated":"Moved to the app list","admin.module.notify.migratedBody":"{module} now manages the same as any other installed app.","admin.module.notify.migrationFailed":"Migration failed","admin.module.notify.missingRef":"Missing module reference","admin.module.notify.missingRefBody":"Owner and key are required.","admin.module.notify.noAppSelected":"No installed app selected","admin.module.notify.noAppToCheck":"No installed app to check","admin.module.notify.noModule":"No module assigned","admin.module.notify.nothingSelected":"Nothing selected","admin.module.notify.nothingSelectedBody":"Check an added or stale collection to sync it.","admin.module.notify.nothingToMigrate":"Nothing to migrate","admin.module.notify.nothingToMigrateBody":"No legacy single-slot app install found on this workspace.","admin.module.notify.pinned":"Pinned version {version}","admin.module.notify.resetAll":"Navbar + home widgets reset to defaults","admin.module.notify.resetFailed":"Reset failed","admin.module.notify.resetNavbar":"Navbar reset to defaults","admin.module.notify.rollbackFailed":"Rollback failed","admin.module.notify.saveFailed":"Save failed","admin.module.notify.saved":"Saved","admin.module.notify.sdkNotReady":"SDK not ready","admin.module.notify.sdkNotReadyBody":"updateWorkspaceSettings unavailable.","admin.module.notify.syncFailed":"Sync failed","admin.module.notify.uninstallConfirm":"Uninstall module?","admin.module.notify.uninstallConfirmBody":"Detaches {module} from this workspace and resets navbar, apps, and home panels to defaults.","admin.module.notify.uninstallCta":"Uninstall module","admin.module.notify.uninstallFailed":"Uninstall failed","admin.module.notify.uninstallFailedBody":"The server rejected the request.","admin.module.notify.uninstalled":"{module} uninstalled","admin.module.notify.unpinned":"Unpinned (channel-tracking)","admin.module.notify.unsupportedSetting":"Unsupported setting","admin.module.notify.grantedCount":"+{count} granted","admin.module.notify.revokedCount":"\u2212{count} revoked","admin.module.notify.approvedCount":"Access changes approved: {count}","admin.module.onboard.cta":"Start \u2014 Module \u2192","admin.module.onboard.steps":"Three steps, in order: 1) Assign the module + version (its records grant is written automatically) \xb7 2) Review the records grant \xb7 3) Personalize the navbar, apps, panels, and skin.","admin.module.onboard.title":"Set up this workspace\u2019s module","admin.module.overview.assignCta":"Assign a module \u2192","admin.module.overview.currentTitle":"Current module","admin.module.overview.empty":"No module assigned. Use the Module tab to point this workspace at a published module project.","admin.module.overview.quickLinks":"Quick links","admin.module.page.title":"Client Module / Admin","admin.module.panels.desc":"Panels new members see by default on their home dashboard \u2014 including this module\u2019s own widgets.","admin.module.panels.save":"Save panels","admin.module.panels.title":"Home default panels","admin.module.quick.grant":"Records grant","admin.module.quick.personalize":"Personalize","admin.module.quick.versions":"Versions","admin.module.records.appPickerAria":"Installed app","admin.module.records.desc":"The generic-record collections this module may read/write, granted automatically when it was assigned. View and revoke here \u2014 no reassign needed.","admin.module.records.empty":"No records grant yet \u2014 assigning a module with declared collections (Module tab) auto-grants one.","admin.module.records.levels":"Read: {read} \xb7 write: {write}","admin.module.records.opAria":"Operation {op} on {collection}","admin.module.records.revoke":"Revoke","admin.module.records.revokeMessage":"The module loses read and write access to this collection once you save the records grant.","admin.module.records.revokeTitle":"Revoke access to \u201C{collection}\u201D?","admin.module.records.save":"Save records grant","admin.module.records.saving":"Saving\u2026","admin.module.records.teamLevels":"Team {team} \u2014 read: {read} \xb7 write: {write}","admin.module.records.title":"Records grant","admin.module.sync.addedHeading":"Added \u2014 declared now, not yet granted","admin.module.sync.apply":"Apply sync","admin.module.sync.applying":"Syncing\u2026","admin.module.sync.approveAria":"Approve the access change for {collection}","admin.module.sync.changedHeading":"Changed access \u2014 the app asks for a different level","admin.module.sync.check":"Check for updates","admin.module.sync.checking":"Checking\u2026","admin.module.sync.desc":"Reads the app\'s CURRENT manifest and compares it against what this workspace already granted. Nothing is written until you approve below \u2014 the app can never grant itself a collection just by publishing a new version.","admin.module.sync.levelAsks":"The app asks for \u2014 read: {read} \xb7 write: {write}","admin.module.sync.levelNow":"Now \u2014 read: {read} \xb7 write: {write}","admin.module.sync.levelRules":"Team or field rules change too.","admin.module.sync.notChecked":"Not checked yet this session.","admin.module.sync.staleHeading":"Stale \u2014 granted, no longer declared","admin.module.sync.title":"Grant sync","admin.module.sync.upToDate":"Up to date \u2014 the granted collections match what the app currently declares.","admin.module.tab.grant":"Grant","admin.module.tab.module":"Module","admin.module.tab.overview":"Overview","admin.module.tab.personalize":"Personalize","admin.module.tab.versions":"Versions","admin.module.tabsAria":"Client module sections","admin.module.tier.sandboxed":"Sandboxed (not executable yet \u2014 loader refuses)","admin.module.tier.trusted":"Trusted (first-party, in-realm)","admin.module.tierShort.sandboxed":"Sandboxed","admin.module.tierShort.trusted":"Trusted","admin.module.title":"Client Module","admin.module.version.latest":"Latest (channel-tracked)","admin.module.versions.desc":"Re-pin the workspace to any published version for an instant per-workspace rollback (no project mutation). Unpin to track the channel again.","admin.module.versions.empty":"No versions loaded yet \u2014 set the module owner/key on the Module tab, then Refresh versions.","admin.module.versions.lookUp":"Look up versions","admin.module.versions.lookingUp":"Looking up\u2026","admin.module.versions.pin":"Pin this","admin.module.versions.pinCta":"Pin","admin.module.versions.pinMessage":"Everyone in this workspace runs this version of the module until you unpin it. New releases do not reach the workspace while it is pinned.","admin.module.versions.pinTitle":"Pin version {version}?","admin.module.versions.pinned":"Pinned","admin.module.versions.pinnedHint":"Currently pinned \u2014 click to track the channel again","admin.module.versions.refresh":"Refresh versions","admin.module.versions.repin":"Re-pin","admin.module.versions.title":"Module versions","admin.module.versions.unnamed":"(unnamed)","admin.module.versions.unpin":"Unpin","admin.module.versions.unpinMessage":"Everyone in this workspace gets the latest version of the module\u2019s channel again.","admin.module.versions.unpinTitle":"Unpin the module version?","admin.module.error.checkFailed":"Check failed.","admin.module.error.dsCanvasBg":"\\"canvasBg\\" must be a string (a design-system color token or CSS value).","admin.module.error.dsEmpty":"Design system JSON is empty.","admin.module.error.dsInvalidJson":"Invalid JSON: {detail}","admin.module.error.dsNotObject":"Design system must be a JSON object, e.g. { \\"canvasBg\\": \\"\u2026\\", \\"vars\\": { \u2026 } }.","admin.module.error.dsVarType":"\\"vars.{name}\\" must be a string or number.","admin.module.error.dsVars":"\\"vars\\" must be an object of name \u2192 value pairs.","admin.module.error.loadFailed":"Failed to load workspace.","admin.module.error.lookupFailed":"Lookup failed.","admin.module.error.noWorkspace":"No active workspace.","admin.module.error.pickRef":"Pick an owner and key first.","admin.module.error.projectNotFound":"Project {ref} not found.","admin.nav.activityLogs":"Activity Logs","admin.nav.activityScoring":"Activity Scoring","admin.nav.analytics":"Analytics","admin.nav.ariaLabel":"Admin navigation","admin.nav.branding":"Branding","admin.nav.danger":"Danger Zone","admin.nav.dashboardDefaults":"Dashboard Defaults","admin.nav.domains":"White-label Domains","admin.nav.externalData":"External data","admin.nav.flags":"Feature Flags","admin.nav.groupConnections":"Connections","admin.nav.groupDeveloper":"Developer tools","admin.nav.groupUsage":"Usage and activity","admin.nav.groupWorkspace":"Workspace","admin.nav.integrations":"Integrations","admin.nav.mail":"Mail","admin.nav.module":"Client Module","admin.nav.permissions":"Permissions Overview","admin.nav.status":"Status","admin.nav.systemHealth":"System Health","admin.nav.teams":"Teams & Permissions","admin.nav.usage":"Usage & billing","admin.nav.usersRoles":"Users & Roles","admin.nav.workspaceSettings":"Workspace Settings","admin.npm.addScope":"+ Add scope","admin.npm.back":"\u2190 Integrations","admin.npm.cancel":"Cancel","admin.npm.emptyHint":"Add a scope and its publish token to unlock publishing from the editor and CI.","admin.npm.emptyTitle":"No npm scopes yet","admin.npm.field.displayName":"Display name","admin.npm.field.registry":"Registry URL","admin.npm.field.scope":"Scope (@org \u2014 required)","admin.npm.field.slug":"Slug","admin.npm.form.title":"Add npm scope","admin.npm.intro":"Store one publish token per scope. Editor CMS reads these when exporting/publishing projects; CI reads them when running `npm publish`.","admin.npm.meta":"Scope: {scope} \xb7 Registry: {registry}","admin.npm.page.title":"npm / Integrations","admin.npm.placeholder.displayName":"Publish token","admin.npm.placeholder.scope":"e.g. @acme","admin.npm.placeholder.slug":"e.g. acme-prod","admin.npm.registryDefault":"default","admin.npm.remove":"Remove","admin.npm.removeTitle":"Remove \u201C{scope}\u201D?","admin.npm.removeMessage":"Publishing from this scope fails until you add it again.","admin.npm.removeFailed":"Remove failed","admin.npm.removed":"Removed","admin.npm.save":"Save","admin.npm.saveFailed":"Save failed","admin.npm.saving":"Saving\u2026","admin.npm.scopeAdded":"Scope added","admin.npm.scopeRequired":"Scope target required","admin.npm.scopeRequiredBody":"Select a {scope} or switch scope to Org.","admin.npm.scopeTokenRequired":"Scope and token required","admin.npm.serverError":"Server error","admin.npm.title":"npm registry","admin.npm.token.hint":"Create with `npm token create --type=automation --cidr=0.0.0.0/0`. Scope tokens allow publishing to a specific org.","admin.npm.token.label":"npm token (required \u2014 written to Vault)","admin.page.activityScoring":"Activity Scoring / Admin","admin.page.analytics":"Analytics / Admin","admin.page.branding":"Branding / Admin","admin.page.danger":"Danger Zone / Admin","admin.page.dashboardDefaults":"Dashboard Defaults / Admin","admin.page.domains":"White-label Domains / Admin","admin.page.integrations":"Integrations / Admin","admin.page.integrationsGeneric":"Integration / Admin","admin.page.integrationsGithub":"GitHub / Admin","admin.page.integrationsGoogle":"Google / Admin","admin.page.integrationsMcp":"MCP / Admin","admin.page.integrationsNpm":"npm / Admin","admin.page.logs":"Logs / Admin","admin.page.module":"Client Module / Admin","admin.page.permissions":"Permissions / Admin","admin.page.status":"Status / Admin","admin.page.teams":"Teams / Admin","admin.page.title":"Admin","admin.page.usage":"Usage & billing / Admin","admin.page.workspaceSettings":"Workspace Settings / Admin","admin.perm.adminBilling.description":"Subscription tier, payment methods, plan changes","admin.perm.adminBilling.label":"Manage billing","admin.perm.adminCapTable.description":"View + edit cap table, grants, vesting","admin.perm.adminCapTable.label":"Manage cap table","admin.perm.adminCommercials.description":"Edit public-facing services, packages, pricing","admin.perm.adminCommercials.label":"Manage commercials","admin.perm.adminCompany.description":"Edit /company content","admin.perm.adminCompany.label":"Edit company page","admin.perm.adminHr.description":"Title, start date, position on other users\' profiles","admin.perm.adminHr.label":"Edit HR fields","admin.perm.adminIntegrations.description":"Connect and configure external services","admin.perm.adminIntegrations.label":"Manage integrations","admin.perm.adminLogs.description":"Audit trail + security logs","admin.perm.adminLogs.label":"View activity logs","admin.perm.adminPagesRead.description":"Read-level access to any /admin page (blanket gate; specific write perms layered on top)","admin.perm.adminPagesRead.label":"Access /admin surfaces","admin.perm.adminSystem.description":"System status, danger zone, data export","admin.perm.adminSystem.label":"System administration","admin.perm.adminTeamPermissions.description":"Change the permission matrix on any team (separate from membership to prevent self-escalation)","admin.perm.adminTeamPermissions.label":"Edit team permissions","admin.perm.adminTeams.description":"Create, rename, delete teams; add/remove members","admin.perm.adminTeams.label":"Manage teams","admin.perm.adminUsers.description":"Invite, deactivate, reset password, view all accounts","admin.perm.adminUsers.label":"Manage users","admin.perm.appDescription":"{verb} access to the {app} app","admin.perm.appLabel":"{app} \u2014 {verb}","admin.perm.calendarCreateOrgEvents.description":"Create events visible to the whole org","admin.perm.calendarCreateOrgEvents.label":"Create org events","admin.perm.calendarEditOthers.description":"Modify events organized by other people","admin.perm.calendarEditOthers.label":"Edit others\' events","admin.perm.chatArchiveChannels.description":"Archive chat channels","admin.perm.chatArchiveChannels.label":"Archive channels","admin.perm.chatCreateChannels.description":"Add new chat channels","admin.perm.chatCreateChannels.label":"Create channels","admin.perm.chatDeleteOthers.description":"Remove chat messages from other people","admin.perm.chatDeleteOthers.label":"Delete others\' messages","admin.perm.docsDeleteOthers.description":"Remove docs authored by other people","admin.perm.docsDeleteOthers.label":"Delete others\' docs","admin.perm.docsEditOthers.description":"Modify docs authored by other people","admin.perm.docsEditOthers.label":"Edit others\' docs","admin.perm.docsReadPrivate.description":"View docs not explicitly shared with you","admin.perm.docsReadPrivate.label":"Read private docs","admin.perm.grantsViewOthers.description":"See cap-table detail for grants belonging to other people","admin.perm.grantsViewOthers.label":"View others\' grants","admin.perm.kbDeleteOthers.description":"Remove wiki pages authored by other people","admin.perm.kbDeleteOthers.label":"Delete others\' KB pages","admin.perm.kbEditOthers.description":"Modify wiki pages authored by other people","admin.perm.kbEditOthers.label":"Edit others\' KB pages","admin.perm.storiesDeleteOthers.description":"Remove stories authored by other people","admin.perm.storiesDeleteOthers.label":"Delete others\' stories","admin.perm.storiesEditOthers.description":"Modify stories authored by other people","admin.perm.storiesEditOthers.label":"Edit others\' stories","admin.perm.storiesPin.description":"Promote stories to the top of the feed","admin.perm.storiesPin.label":"Pin stories","admin.perm.storiesPost.description":"Publish org-wide stories and announcements","admin.perm.storiesPost.label":"Post announcements","admin.perm.ticketsAssign.description":"Set assignee on tasks","admin.perm.ticketsAssign.label":"Assign tasks","admin.perm.ticketsCloseOthers.description":"Mark as done tasks you don\'t own","admin.perm.ticketsCloseOthers.label":"Close others\' tasks","admin.perm.ticketsDeleteOthers.description":"Remove tasks you don\'t own","admin.perm.ticketsDeleteOthers.label":"Delete others\' tasks","admin.perm.ticketsManageColumns.description":"Edit board columns, statuses, order","admin.perm.ticketsManageColumns.label":"Manage task workflow","admin.perm.verb.create":"Create","admin.perm.verb.delete":"Delete","admin.perm.verb.read":"Read","admin.perm.verb.update":"Update","admin.permGroup.admin":"Admin","admin.permGroup.apps":"Apps","admin.permGroup.calendar":"Calendar","admin.permGroup.chat":"Chat","admin.permGroup.docs":"Docs","admin.permGroup.grants":"Grants","admin.permGroup.kb":"KB","admin.permGroup.other":"Other","admin.permGroup.stories":"Stories","admin.permGroup.tasks":"Tasks","admin.permissions.category.active":"Active","admin.permissions.category.archived":"Archived","admin.permissions.category.external":"External","admin.permissions.category.manager":"Manager","admin.permissions.category.passive":"Passive","admin.permissions.editTeams":"\u2192 Teams","admin.permissions.editTeamsTitle":"Open in Teams & Permissions editor","admin.permissions.effective.colPermissions":"Permissions","admin.permissions.effective.colTeam":"Team","admin.permissions.effective.hint":"Every team in this organization, by category, with the permissions it has. A person can do what any of their teams can do, plus what their role allows; a passive member keeps only the passive defaults. The owner can do everything. Press \u201C\u2192 Teams\u201D to change a team.","admin.permissions.effective.title":"Effective permissions by team","admin.permissions.elevations":"{count} permissions","admin.permissions.elevationsOne":"1 permission","admin.permissions.empty.active":"No active teams yet.","admin.permissions.empty.external":"No external teams yet.","admin.permissions.empty.manager":"No manager teams yet.","admin.permissions.empty.passive":"No passive teams yet.","admin.permissions.intro":"What each team can do in this organization. Each team category starts from a default set of permissions (top). Below, every team with the permissions it has now. Open a team to change them.","admin.permissions.more":"+{count} more","admin.permissions.moreTitle":"+{count} more permissions","admin.permissions.moreTitleOne":"+1 more permission","admin.permissions.noElevations":"no extra permissions","admin.permissions.noPermissions":"no permissions","admin.permissions.page.title":"Permissions / Admin","admin.permissions.teamMetaSystem":"{category} \xb7 system","admin.permissions.templates.colCategory":"Category","admin.permissions.templates.colElevations":"Default permissions","admin.permissions.templates.hint":"The permissions a new team gets from its category. These defaults come with the platform. In Teams & Permissions a team can then get more or fewer permissions; it shows \u201CCustomized\u201D there when it differs from its category.","admin.permissions.templates.title":"Category templates","admin.permissions.title":"Permissions Overview","admin.section.untitled":"Section","admin.status.copied":"Copied","admin.status.copyRow":"Copy {label}","admin.status.count.entries":"{count} entries","admin.status.count.rows":"{count} rows","admin.status.disabled":"Disabled","admin.status.flag.dualWriteFinancials":"mirrors grant writes to financials","admin.status.flag.financialsProject":"reads grants from financials","admin.status.flag.multitenant":"Phase 3 migrations + workspace RLS","admin.status.flag.off":"off","admin.status.flag.on":"on","admin.status.flag.onboardingGate":"no-team-org users see onboarding CTA","admin.status.flag.profilesOverlay":"profile writes mirror to public.profiles","admin.status.hint.noOrg":"No active organization","admin.status.hint.orgIntegrations":"Integration rows of the current organization","admin.status.hint.orgs":"Server \xa7A populates this","admin.status.hint.profiles":"HR overlay (migration 0052)","admin.status.hint.workspaceTier":"Billing display only \u2014 no access gates read this","admin.status.hint.workspaces":"Drives workspace switcher","admin.status.live":"Live","admin.status.missingToken":"Missing token","admin.status.page.title":"Status / Admin","admin.status.probeError":"Probe error","admin.status.probing":"Probing\u2026","admin.status.section.claims":"Session claims","admin.status.section.flags":"Feature flags","admin.status.section.schema":"Schema / data","admin.status.title":"Status","admin.teams.backToAll":"\u2190 All teams","admin.teams.category.active":"Active","admin.teams.category.archived":"Archived","admin.teams.category.external":"External","admin.teams.category.manager":"Manager","admin.teams.category.passive":"Passive","admin.teams.create.button":"+ Create team","admin.teams.create.dialogTitle":"Create a team","admin.teams.create.failed":"Could not create the team: {error}","admin.teams.create.hint":"Create a new team for this org. System teams are seeded automatically.","admin.teams.create.prompt":"Team name","admin.teams.delete.failed":"Could not delete the team: {error}","admin.teams.delete.message":"The team and its member list are deleted for good. Its members lose the permissions and access it gave them, and stay in the workspace.","admin.teams.delete.messageSelf":"The team and its member list are deleted for good. You are in this team: you and its other members lose the permissions and access it gave, unless your role or another team gives them too. Everyone stays in the workspace.","admin.teams.delete.title":"Delete the team \u201C{team}\u201D?","admin.teams.detail.applyTemplate":"Apply the template","admin.teams.detail.category":"Category","admin.teams.detail.categoryChange":"Change category","admin.teams.detail.categoryConfirmBody":"The team moves to this category. Next, you choose whether its permissions follow the category template.","admin.teams.detail.categoryConfirmTitle":"Change the category to \u201C{category}\u201D?","admin.teams.detail.categoryFailed":"Could not change the category: {error}","admin.teams.detail.fallback":"Team","admin.teams.detail.hintOwner":"Owners bypass all permission checks. Toggles below affect non-owner members only.","admin.teams.detail.hintReadOnly":"Read-only \u2014 requires admin.team_permissions.","admin.teams.detail.hintWrite":"Changes save on toggle.","admin.teams.detail.keepPermissions":"Keep the permissions","admin.teams.detail.loadingMembers":"Loading members","admin.teams.detail.members":"Members","admin.teams.detail.noMembers":"No members yet. Click + Invite to add someone.","admin.teams.detail.permissions":"Permissions","admin.teams.detail.resetConfirmTitle":"Reset the permissions to the \u201C{category}\u201D template?","admin.teams.detail.resetMessage":"The template replaces this team\u2019s current permissions.","admin.teams.detail.resetToTemplate":"Reset to template","admin.teams.detail.selfNote":"You are in this team: your own permissions change too.","admin.teams.detail.templateMessage":"The template replaces this team\u2019s permissions. Keep the permissions to mark the team customized.","admin.teams.detail.templateTitle":"Apply the \u201C{category}\u201D template?","admin.teams.enforce.caption":"When on, members only see and use the apps their teams grant. Owners and admins always have full access.","admin.teams.enforce.label":"Enforce app access","admin.teams.enforce.loading":"Loading workspace settings...","admin.teams.enforce.unavailable":"Workspace settings unavailable - enforcement cannot be changed right now","admin.teams.invite.copied":"Copied","admin.teams.invite.copyLink":"Copy link","admin.teams.invite.failed":"Invite failed: {error}","admin.teams.invite.inviting":"Inviting {email}\u2026","admin.teams.invite.noEmail":"Invite created for {email} \u2014 email delivery is unavailable, share the link below.","admin.teams.invite.reinviteFailed":"Reinvite failed: {error}","admin.teams.invite.reinvited":"Invitation re-sent to {email}.","admin.teams.invite.reinviting":"Re-inviting {email}\u2026","admin.teams.invite.send":"Send invite","admin.teams.invite.sent":"Invitation sent to {email}.","admin.teams.invite.sentWithTeams":"Invitation sent to {email} (teams: {teams}).","admin.teams.member.reinvite":"Reinvite","admin.teams.member.reinviteTitle":"Send a fresh invitation email so the user can activate / sign in","admin.teams.member.removeFailed":"Could not remove {email}: {error}","admin.teams.member.removeMessage":"They lose the permissions and access this team gives them, and stay in the workspace.","admin.teams.member.removeSelfMessage":"You lose the permissions and access this team gives you, unless your role or another team gives them too. You stay in the workspace.","admin.teams.member.removeSelfTitle":"Remove yourself from \u201C{team}\u201D?","admin.teams.member.removeTitle":"Remove {email} from \u201C{team}\u201D?","admin.teams.members.count":"{count} members","admin.teams.members.countOne":"1 member","admin.teams.members.none":"No members assigned yet","admin.teams.members.unknown":"\u2014 members","admin.teams.meta.customized":" \u2022 customized","admin.teams.meta.perms":" \u2022 {count} perms","admin.teams.meta.permsOne":" \u2022 1 perm","admin.teams.meta.slug":" \u2022 slug: {slug}","admin.teams.meta.system":" \u2022 system","admin.teams.meta.template":" \u2022 template","admin.teams.page.title":"Teams / Admin","admin.teams.perm.selfMessage":"You are in this team. Unless your role or another of your teams gives this permission, you lose it as soon as you confirm, and you may not be able to turn it back on.","admin.teams.perm.selfTitle":"Turn off \u201C{permission}\u201D for your own team?","admin.teams.perm.turnOff":"Turn off","admin.teams.refreshPerms":"\u21BB Refresh perms","admin.teams.rename.failed":"Could not rename the team: {error}","admin.teams.rename.title":"Rename the team","admin.teams.role.admin":"Admin","admin.teams.role.editor":"Member","admin.teams.role.guest":"Guest","admin.teams.role.manager":"Manager","admin.teams.role.member":"Member","admin.teams.role.owner":"Owner","admin.teams.role.superadmin":"Superadmin","admin.teams.role.viewer":"Contributor","admin.teams.section.active":"Active teams","admin.teams.section.activeEmpty":"No active teams yet.","admin.teams.section.external":"External","admin.teams.section.externalEmpty":"No external teams yet.","admin.teams.section.manager":"Manager teams","admin.teams.section.managerEmpty":"No manager teams yet.","admin.teams.section.passive":"Passive teams","admin.teams.section.passiveEmpty":"No passive teams yet.","admin.teams.title":"Teams & Permissions","admin.teams.wsInvite.hint":"Sends a workspace invitation. Picked teams are attached on accept \u2014 they drive the member\'s role view.","admin.teams.wsInvite.hintNamed":"Sends a workspace invitation to {workspace}. Picked teams are attached on accept \u2014 they drive the member\'s role view.","admin.teams.wsInvite.teamsAria":"Attach teams","admin.teams.wsInvite.teamsLabel":"Teams","admin.teams.wsInvite.title":"Invite to this workspace","admin.usage.amountOf":"{remaining} / {total} credits left","admin.usage.attr.before":"Before attribution was recorded","admin.usage.attr.beforeDated":"Before attribution was recorded (pre-{date})","admin.usage.attr.beforeHint":"Real historical usage this workspace can no longer be tied to who or what caused it \u2014 not a member, and not zero.","admin.usage.attr.eventOne":"1 event","admin.usage.attr.events":"{count} events","admin.usage.attr.loading":"Loading attribution\u2026","admin.usage.attr.machines":"Machines","admin.usage.attr.machinesEmpty":"No machine-attributed usage in this window.","admin.usage.attr.machinesSub":"API tokens, integrations, agents \u2014 a real identity that is not a person, and a configuration you can change.","admin.usage.attr.members":"Members","admin.usage.attr.membersEmpty":"No attributed member usage in this window.","admin.usage.attr.membersSub":"A person did a thing \u2014 credits the workspace spent because they caused it, never a personal balance.","admin.usage.attr.subtitle":"This month \u2014 every credit this workspace has spent, attributed to who or what caused it.","admin.usage.attr.system":"System","admin.usage.attr.systemEmpty":"No automatic system usage in this window.","admin.usage.attr.systemSub":"Automatic \u2014 deploys, builds, scheduled jobs. No person chose this, one at a time.","admin.usage.attr.title":"Where credits went","admin.usage.attr.total":"Total attributed this month","admin.usage.attr.unavailable":"Usage attribution isn\'t available for this workspace yet.","admin.usage.balance.fromGrant":"Monthly credits left","admin.usage.balance.fromTopups":"Top-up credits left","admin.usage.balance.nextReset":"Reported reset date \xb7 {date}","admin.usage.balance.poolOrgHint":"Credits shared across your organization","admin.usage.balance.total":"Available credits","admin.usage.burn.burned":"{credits} cr burned","admin.usage.burn.none":"no burn","admin.usage.burn.recent":"Recent burn","admin.usage.burn.recentAvg":"Recent burn \u2014 averaging {credits} cr/day","admin.usage.cause.adminAdjustment":"Admin adjustments","admin.usage.cause.cdnEgress":"CDN egress","admin.usage.cause.githubWorkflow":"GitHub workflow runs","admin.usage.cause.other":"Other automated usage","admin.usage.cause.policyEval":"Policy evaluation","admin.usage.cause.retentionSweep":"Retention sweeps","admin.usage.cause.scheduledReindex":"Scheduled reindex","admin.usage.cause.scimSync":"SCIM sync","admin.usage.cause.storageSnapshot":"Storage snapshots","admin.usage.cause.templateInstall":"Template installs","admin.usage.cause.webhookDelivery":"Webhook delivery","admin.usage.claim.added":"100 credits added","admin.usage.claim.addedBody":"Your workspace now has {count} credits.","admin.usage.claim.already":"You already have credits","admin.usage.claim.alreadyBody":"Your workspace has {count} credits.","admin.usage.claim.available":"You have 100 free credits waiting to be claimed.","admin.usage.claim.busy":"Claiming\u2026","admin.usage.claim.cta":"Claim 100 free credits","admin.usage.claim.done":"\u2713 Your 100 free signup credits are already claimed.","admin.usage.claim.failed":"Claim failed","admin.usage.claim.failedBody":"Could not claim your credits.","admin.usage.claim.unavailable":"Claim unavailable","admin.usage.depleted.body":"This workspace has no credits left \u2014 AI calls, builds, and metered actions will fail until you top up or the monthly grant resets.","admin.usage.depleted.title":"Out of credits","admin.usage.error.attribution":"Attribution unavailable","admin.usage.error.balance":"Balance unavailable","admin.usage.error.claim":"Claim status unavailable","admin.usage.error.missingRedirect":"Checkout response was missing a redirect URL.","admin.usage.error.noWorkspace":"No active workspace.","admin.usage.error.planUnresolved":"Couldn\'t resolve a plan for {tier} \u2014 refresh and try again, or talk to sales.","admin.usage.error.plans":"Plans unavailable","admin.usage.error.rates":"Rate card unavailable","admin.usage.error.request":"request failed","admin.usage.error.row":"Error","admin.usage.error.sdkMissingClaim":"SDK is missing claimSignupCredits \u2014 bump @symbo.ls/sdk.","admin.usage.error.sdkMissingTopup":"SDK is missing createCreditTopupCheckout \u2014 bump @symbo.ls/sdk.","admin.usage.error.sdkMissingUpgrade":"SDK is missing createWorkspaceSubscriptionCheckout \u2014 bump @symbo.ls/sdk.","admin.usage.error.turnStats":"Turn stats unavailable","admin.usage.ledger.empty":"No activity yet","admin.usage.ledgerReason.adminCredit":"Credits added by an administrator","admin.usage.ledgerReason.adminDebit":"Credits removed by an administrator","admin.usage.ledgerReason.aiCall":"AI request","admin.usage.ledgerReason.aiSummary":"AI summary","admin.usage.ledgerReason.animationExport":"Animation export","admin.usage.ledgerReason.auditRetention":"Audit log retention","admin.usage.ledgerReason.automationRun":"Automation run","admin.usage.ledgerReason.brandbookPdf":"Brand book PDF","admin.usage.ledgerReason.build":"App build","admin.usage.ledgerReason.callRelay":"Call","admin.usage.ledgerReason.dataTransfer":"Data transfer","admin.usage.ledgerReason.deploy":"Deployment","admin.usage.ledgerReason.esignature":"E-signature","admin.usage.ledgerReason.failedBuildRefund":"Refund: the build did not finish","admin.usage.ledgerReason.firstBuildFree":"First app build (free)","admin.usage.ledgerReason.held":"Credits held for a request","admin.usage.ledgerReason.heldReturned":"Held credits returned","admin.usage.ledgerReason.liveCaptions":"Live call captions","admin.usage.ledgerReason.mediaProcessing":"Media processing","admin.usage.ledgerReason.meetingIndex":"Meeting search index","admin.usage.ledgerReason.monthlyGrant":"Monthly credits","admin.usage.ledgerReason.orgPool":"Organization credits","admin.usage.ledgerReason.other":"Other credit activity","admin.usage.ledgerReason.policyCheck":"Policy check","admin.usage.ledgerReason.recordingProcessing":"Call recording processing","admin.usage.ledgerReason.recordingStorage":"Call recording storage","admin.usage.ledgerReason.refund":"Credits refunded","admin.usage.ledgerReason.scimSync":"SCIM sync","admin.usage.ledgerReason.signupClaim":"Free sign-up credits","admin.usage.ledgerReason.storage":"Storage","admin.usage.ledgerReason.templateInstall":"Template install","admin.usage.ledgerReason.topup":"Credit top-up","admin.usage.ledgerReason.transcript":"Call transcript","admin.usage.ledgerReason.translation":"Translation","admin.usage.ledgerReason.voiceAgent":"Voice assistant call","admin.usage.ledgerReason.webhookDelivery":"Webhook delivery","admin.usage.mailto.enterpriseSubject":"Enterprise plan \u2014 Symbols","admin.usage.mailto.requestedTier":"Requested tier: {tier}","admin.usage.mailto.unknown":"(unknown)","admin.usage.mailto.upgradeSubject":"Upgrade to {tier} \u2014 Symbols","admin.usage.mailto.workspace":"Workspace: {name}","admin.usage.mailto.workspaceId":"Workspace ID: {id}","admin.usage.noRecordedUsage":"No recorded usage.","admin.usage.okOfTotal":"{ok} of {total} ({rate}%)","admin.usage.page.title":"Usage & billing / Admin","admin.usage.period.events":"Metered events","admin.usage.period.label":"Period","admin.usage.period.quantity":"Metered quantity","admin.usage.period.quantityHint":"Sum across all reasons (tokens / GB / minutes / calls)","admin.usage.period.thisMonth":"This month","admin.usage.period.today":"Today","admin.usage.perk.capabilities":"{count} platform capabilities","admin.usage.perk.capabilityOne":"1 platform capability","admin.usage.perk.customEnvs":"{label} \xb7 custom envs","admin.usage.perk.customRateLimit":"Custom rate limit","admin.usage.perk.environmentOne":"1 environment","admin.usage.perk.environments":"{count} environments","admin.usage.perk.projectOne":"1 project","admin.usage.perk.projects":"{count} projects","admin.usage.perk.rateLimit":"{count} req/min","admin.usage.perk.storageIncluded":"{gb} GB storage included","admin.usage.perk.support":"{name} support","admin.usage.perk.unlimitedProjects":"Unlimited projects","admin.usage.perk.unlimitedWorkspaces":"Unlimited workspaces","admin.usage.perk.workspaceOne":"1 workspace","admin.usage.perk.workspaces":"{count} workspaces","admin.usage.rate.flat":"a flat rate","admin.usage.rate.perCredit":"{price}/credit","admin.usage.rateUnit.flat":"Flat price \u2014 credits per unit","admin.usage.rateUnit.multiplier":"Relative multiplier (\xd7 base rate)","admin.usage.rates.comms":"Communications","admin.usage.rates.governance":"Governance & workflow","admin.usage.rates.infra":"Infrastructure","admin.usage.rates.modelMultipliers":"AI model multipliers (per 1K tokens)","admin.usage.rates.basePrice":"Base price","admin.usage.rates.basePriceHint":"AI models are priced in credits for every 1K tokens.","admin.usage.rates.perThousand":"{amount} per 1K tokens","admin.usage.reason.empty":"No metered events yet","admin.usage.reason.emptyHint":"Credit charges appear in Recent activity.","admin.usage.refresh":"Refresh","admin.usage.section.byReason":"Credit use this month","admin.usage.section.recent":"Recent activity (last 25)","admin.usage.section.thisPeriod":"Service metering this period","admin.usage.section.toolTurns":"AI tool-turn reliability","admin.usage.tier.creditsFloorPerMonth":"{credits}+ credits / mo","admin.usage.tier.creditsPerMonth":"{credits} credits / mo","admin.usage.tier.custom":"Custom","admin.usage.tier.free":"Free","admin.usage.tier.priceFrom":"From {price}/mo","admin.usage.tier.priceMonthly":"{price}/mo","admin.usage.tiers.current":"Current plan","admin.usage.tiers.note":"Review your plan in checkout before payment. For a one-time purchase, select Add credits.","admin.usage.tiers.opening":"Opening Stripe\u2026","admin.usage.tiers.pooled":"Pooled across workspaces","admin.usage.tiers.subtitle":"Compare monthly credits and included features. Prices are in USD.","admin.usage.tiers.talkToSales":"Talk to sales \u2192","admin.usage.tiers.title":"Monthly plans","admin.usage.tiers.upgrade":"Choose {plan}","admin.usage.title":"Usage & billing","admin.usage.topup.amount":"Amount (USD)","admin.usage.topup.enterAmount":"Enter an amount.","admin.usage.topup.failed":"Top-up failed.","admin.usage.topup.max":"Maximum top-up is {amount}. Contact sales for larger amounts.","admin.usage.topup.maximum":"Maximum","admin.usage.topup.min":"Minimum top-up is {amount}.","admin.usage.topup.minMax":"Minimum top-up {min}, maximum {max}.","admin.usage.topup.minOnly":"Minimum top-up {min}.","admin.usage.topup.minimum":"Minimum","admin.usage.topup.missingUrl":"Checkout response missing url.","admin.usage.topup.opening":"Opening Stripe\u2026","admin.usage.topup.quickCta":"Top up {amount}","admin.usage.topup.rate":"Rate","admin.usage.topup.stale":"This page is out of date \u2014 refresh to pick up the new top-up flow.","admin.usage.topup.submit":"Top up","admin.usage.topup.subtitle":"Buy extra credits at a flat rate. One-time payment, no subscription.","admin.usage.topup.title":"Top up credits","admin.usage.topup.unavailable":"Top-up unavailable","admin.usage.topup.youGet":"You get","admin.usage.turns.caption":"Shown to Symbols operators. The last 14 days of this workspace\u2019s AI turns that used a tool, and how many ended with an answer \u2014 even when a tool inside the turn failed.","admin.usage.turns.dedupedWrite":"{count} duplicate write prevented","admin.usage.turns.dedupedWrites":"{count} duplicate writes prevented","admin.usage.turns.empty":"No AI tool turns recorded in the last 14 days","admin.usage.turns.label":"AI tool turns","admin.usage.turns.ok":"Tool turns ok","admin.usage.turns.textLeak":"{count} text leak","admin.usage.turns.textLeaks":"{count} text leaks","admin.usage.unit.credits":"{credits} cr","admin.usage.unknownMember":"Unknown member","admin.usage.unlabeledMachine":"Unlabeled machine","admin.usage.upgrade.soon":"Checkout unavailable","admin.usage.upgrade.soonBody":"Try again shortly, or contact sales for help.","admin.usage.upgrade.unavailable":"Upgrade unavailable","admin.usage.upgrade.updated":"Plan updated","admin.usage.upgrade.updatedBody":"This workspace is now on {tier}.","admin.users.col.name":"Name","admin.users.col.role":"Role","admin.users.editAria":"Edit {name}\'s profile","admin.users.loadingTeamAssignments":"Loading team assignments","admin.workspaceSettings.nameEmpty":"Enter a name.","admin.workspaceSettings.nameFailed":"The name was not saved. Try again.","admin.workspaceSettings.nameHint":"Every member of this workspace sees this name.","admin.workspaceSettings.nameLabel":"Workspace name","admin.workspaceSettings.nameSection":"Name","admin.workspaceSettings.page.title":"Workspace Settings / Admin","admin.workspaceSettings.title":"Workspace Settings","admin.usage.summary.loading":"Loading balance","admin.usage.summary.priceUnavailable":"Price unavailable","admin.usage.summary.customPrice":"Custom pricing","admin.usage.summary.free":"Free plan","admin.usage.summary.catalogPrice":"{price} \xb7 catalog price","admin.usage.summary.noReset":"Reset date unavailable","admin.usage.summary.saved":"Your saved monthly allowance still applies.","admin.usage.summary.compare":"Compare plans","admin.usage.nav.label":"Usage views","admin.usage.nav.overview":"Overview","admin.usage.nav.plans":"Plans","admin.usage.nav.topup":"Add credits","admin.usage.nav.activity":"Activity","admin.usage.nav.rates":"Rates","admin.usage.overview.unavailable":"Usage unavailable","admin.usage.overview.loading":"Loading usage","admin.usage.overview.unattributed":"Unattributed","admin.usage.overview.share":"{percent}% of monthly use","admin.usage.overview.empty":"No recorded use this month","admin.usage.overview.activity":"View activity","admin.usage.metered.title":"Metered services this month","admin.usage.metered.units":"{credits} credits","admin.usage.health.healthy":"Healthy balance","admin.usage.health.low":"Top up soon","admin.usage.health.critical":"Top up now","admin.usage.health.empty":"Out of credits","admin.usage.health.available":"Credits available","admin.usage.health.short":"Not enough for your last AI request (needs {needed}, has {available})","admin.usage.graph.grant":"Monthly allowance","admin.usage.graph.balance":"Credit balance","admin.usage.graph.allocation":"Where your credits come from","admin.usage.graph.percentLeft":"{percent}% left","admin.usage.graph.available":"{credits} available","admin.usage.graph.left":"Available","admin.usage.graph.used":"Used from allowance","admin.usage.graph.spent":"Used this month","admin.usage.graph.comparisonHint":"This month\u2019s spend compared with credits available now. This is not a plan limit.","admin.usage.graph.allocationHint":"Monthly credits and purchased credits make up your available balance.","admin.usage.guide.cover":"Estimated time left","admin.usage.guide.daily":"Credits / day \xb7 average","admin.usage.guide.refillAt":"Suggested refill balance","admin.usage.guide.days30":"30+ days","admin.usage.guide.lessDay":"Less than 1 day","admin.usage.guide.days":"~{days} days","admin.usage.guide.healthy":"No top-up needed now","admin.usage.guide.low":"Plan your next top-up","admin.usage.guide.critical":"Add credits to keep work running","admin.usage.guide.empty":"Add credits to resume work","admin.usage.guide.available":"Keep a reserve for your next task","admin.usage.guide.short":"Add credits to run your last AI request","admin.usage.guide.shortHint":"It needs about {needed} credits and the workspace has {available}. Credits you add count toward this balance.","admin.usage.guide.forecastHint":"Top up at the suggested balance to keep about 7 days in reserve. Estimates use this month\u2019s average; new usage and resets can change them.","admin.usage.guide.allowanceHint":"Consider a top-up below 30% of your monthly allowance. Purchased credits count toward your reserve.","admin.usage.guide.unavailableHint":"Add credits before the balance reaches zero. More usage history is needed for a time estimate.","admin.usage.summary.topupPrice":"From {price} \xb7 {credits} credits","admin.usage.summary.topupNote":"One-time payment. Your plan stays the same.","admin.usage.guide.resetHint":"Your monthly credits reset before the estimated balance runs out. Check again if usage rises.","admin.usage.tiers.billing":"per month \xb7 USD","admin.overview.members":"Members","admin.overview.teams":"Teams","admin.overview.activeTeams":"Active teams","admin.overview.archivedTeams":"Archived teams","admin.overview.activities":"Activity types","admin.overview.enabled":"Enabled","admin.overview.projects":"Projects","admin.overview.analyticsOn":"Analytics enabled","admin.overview.analyticsOff":"Analytics disabled","admin.overview.connections":"Connections","admin.overview.mailAccounts":"Mail accounts","admin.overview.auditEntries":"Recent audit entries","admin.overview.domains":"Custom domains","admin.overview.widgets":"Available widgets","admin.overview.visibleWidgets":"Visible by default","admin.overview.checks":"Checks","admin.overview.passed":"Passed","admin.overview.probeErrors":"Probe errors","admin.overview.templates":"Category templates","admin.overview.events":"Events in view","admin.overview.contributors":"Contributors","admin.usage.auto.title":"Auto-top-up","admin.usage.auto.description":"Keep credits available with automatic top-ups. You control the amount and monthly limit.","admin.usage.auto.statusLoading":"Loading","admin.usage.auto.statusUnavailable":"Unavailable","admin.usage.auto.statusOff":"Off","admin.usage.auto.statusActive":"Active","admin.usage.auto.statusSetupRequired":"Finish card setup","admin.usage.auto.statusProcessing":"Payment in progress","admin.usage.auto.statusLimitReached":"Monthly limit reached","admin.usage.auto.statusPaymentFailed":"Payment failed","admin.usage.auto.statusAuthenticationRequired":"Card verification required","admin.usage.auto.statusReconcileRequired":"Payment needs review","admin.usage.auto.statusUnsupported":"Shared credit pool","admin.usage.auto.noticeLoading":"Wait for your workspace settings.","admin.usage.auto.noticeUnavailable":"Auto-top-up settings could not load. Owners and admins can retry.","admin.usage.auto.noticeOff":"Set a balance threshold and a refill amount. Auto-top-up stays off until you complete card setup.","admin.usage.auto.noticeActive":"Your saved card will pay for each top-up below the threshold. Pause at any time.","admin.usage.auto.noticeSetupRequired":"Auto-top-up is off. Complete secure card setup, then refresh this status. You can also cancel or start setup again.","admin.usage.auto.noticeProcessing":"A payment is in progress. Credits appear after payment succeeds. Pause stops future charges; this payment may still complete.","admin.usage.auto.noticeLimitReached":"The next top-up would exceed your limit. Auto-top-up resumes next calendar month (UTC), or you can increase the limit.","admin.usage.auto.noticePaymentFailed":"Auto-top-up has paused. Check your card, then complete setup again. You can also buy credits manually.","admin.usage.auto.noticeAuthenticationRequired":"Auto-top-up has paused. Complete card setup again to verify your card. You can also buy credits manually.","admin.usage.auto.noticeReconcileRequired":"A payment result is unknown. Auto-top-up has paused to prevent a duplicate charge. Contact support before you retry.","admin.usage.auto.noticeUnsupported":"This workspace uses an organization credit pool. Manage its balance through organization billing.","admin.usage.auto.metricThreshold":"When balance is below","admin.usage.auto.metricRefill":"Add credits for","admin.usage.auto.metricCap":"Stop at","admin.usage.auto.below":"credits remaining","admin.usage.auto.credits":"{credits} credits per top-up","admin.usage.auto.perMonth":"per calendar month (UTC)","admin.usage.auto.spent":"{spent} of {limit} used this month","admin.usage.auto.budget":"Monthly auto-top-up budget in USD","admin.usage.auto.card":"{brand} ending in {last4}","admin.usage.auto.triggerLabel":"Balance threshold (credits)","admin.usage.auto.amountLabel":"Each top-up (USD)","admin.usage.auto.limitLabel":"Monthly limit (USD)","admin.usage.auto.rateHint":"{rate} per credit. Each top-up: {min} to {max}. The monthly limit excludes manual top-ups and subscriptions.","admin.usage.auto.validationRates":"Prices are unavailable. Refresh usage before you continue.","admin.usage.auto.validationAmount":"Enter an amount within the stated limits, with at most two decimal places.","admin.usage.auto.validationThreshold":"Enter a whole credit threshold above zero and below the credits in one top-up.","admin.usage.auto.validationLimit":"Set a monthly limit at least equal to one top-up, within the stated maximum.","admin.usage.auto.review":"Review rule","admin.usage.auto.cancel":"Cancel","admin.usage.auto.reviewTitle":"Review automatic payments","admin.usage.auto.reviewDescription":"Stripe will save your card. A top-up can charge immediately after setup if your balance is already below the threshold.","admin.usage.auto.consent":"I authorize recurring card charges under this rule, up to the monthly limit. I can pause auto-top-up in Usage at any time.","admin.usage.auto.wait":"Please wait\u2026","admin.usage.auto.prepare":"Set up payment","admin.usage.auto.back":"Edit rule","admin.usage.auto.secureHint":"Your rule is ready. Complete card setup in Stripe to activate it. Symbols does not store your card number.","admin.usage.auto.continue":"Continue to Stripe","admin.usage.auto.edit":"Edit auto-top-up","admin.usage.auto.setup":"Set up auto-top-up","admin.usage.auto.pause":"Pause auto-top-up","admin.usage.auto.refresh":"Refresh status","admin.usage.auto.errorUnavailable":"Auto-top-up is unavailable in this version. Refresh the app and try again.","admin.usage.auto.errorForbidden":"Only workspace owners and admins can manage auto-top-up.","admin.usage.auto.errorInProgress":"A payment is still in progress. Refresh its status before you change the rule.","admin.usage.auto.errorFailed":"The request failed. Check the status, then try again. Auto-top-up activates only after successful card setup.","admin.usage.topup.returnCancelled":"No payment was made.","admin.usage.topup.returnConfirming":"Confirming your payment\u2026","admin.usage.topup.returnFailed":"We could not confirm the payment yet.","admin.usage.topup.returnPaid":"Payment received. {credits} credits added.","admin.usage.topup.returnPaidNoCount":"Payment received. Credits added.","admin.usage.topup.returnRetry":"Try again"}');

});

parcelRegister("6cYgA", function(module, exports) {
module.exports = JSON.parse('{"ai.answers.label":"Answers","ai.answers.minimized":"Minimized","ai.answers.note":"Page shows the conversation in the home\'s main column. Sidebar keeps it beside you.","ai.answers.page":"Page","ai.answers.sidebar":"Sidebar","ai.assistantMode.apps":"Apps","ai.assistantMode.assistant":"Assistant","ai.assistantMode.dashboard":"Dashboard","ai.assistantMode.desc.apps":"Builds a small app","ai.assistantMode.desc.assistant":"Answers with text and live blocks","ai.assistantMode.desc.dashboard":"Builds a board of widgets","ai.assistantMode.desc.fly":"Composes a page for every ask","ai.assistantMode.desc.presentation":"Makes a live deck","ai.assistantMode.desc.tools":"Works inside your apps","ai.assistantMode.fly":"Fly","ai.assistantMode.label":"Mode","ai.assistantMode.labelWithContext":"Mode: {mode} \xb7 Context: {context}","ai.assistantMode.menuWithContext":"Context and mode","ai.assistantMode.presentation":"Presentation","ai.assistantMode.tools":"Tools","ai.bridge.done":"Done","ai.bridge.step1":"Start your local Simone bridge (Claude Code) on this machine.","ai.bridge.step3":"Once it reports Connected above, your chats run on your local agent.","ai.bridge.title":"Connect your local AI","ai.bridge.urlLabel":"Bridge URL","ai.chat.addComponentError":"Error adding component: {error}","ai.chat.assistant":"Symbols AI","ai.chat.cannotProcess":"Sorry, I could not process that request.","ai.chat.clear":"Clear","ai.chat.codeLine":"{count} line","ai.chat.codeLines":"{count} lines","ai.chat.actionDone":"\xb7 {count} action completed","ai.chat.actionsDone":"\xb7 {count} actions completed","ai.chat.hint":"Ask anything about Symbols","ai.chat.hintWorkspace":"Ask anything about {workspace}","ai.chat.history":"Chat history","ai.chat.historyHeading":"History","ai.chat.invalidCode":"Invalid code response format.","ai.chat.messagesLabel":"Conversation","ai.chat.newChat":"New chat","ai.chat.noPrevious":"No previous chats.","ai.chat.noResponse":"Received no response from the assistant.","ai.chat.placeholder":"Describe a change or ask a question\u2026","ai.chat.placeholderInspector":"Describe a change, ask a question, or reference $0 from the inspector\u2026","ai.chat.renderError":"Error rendering component: {error}","ai.chat.sendMessage":"Send message","ai.chat.starter.help":"What can you help me with?","ai.chat.starter.symbols":"What is Symbols?","ai.chat.startersLabel":"Try asking","ai.chat.subGenerating":"Looking at what {workspace} is working on\u2026","ai.chat.needsOk":"Needs your OK","ai.chat.switchModel":"\u2726 Switch model","ai.chat.system":"System","ai.chat.thinking":"Thinking","ai.chat.tool":"Tool","ai.chat.unreachable":"Failed to reach Simone: {error}","ai.chat.uploadImage":"Upload image","ai.chat.voiceTooltip":"Voice \u2014 click to toggle, hold to talk","ai.chat.working":"Working","ai.chat.you":"You","ai.chatCard.agentRole":"AI agent","ai.chatCard.applyChange":"Apply this change?","ai.chatCard.approve":"Approve","ai.chatCard.cancel":"Cancel","ai.chatCard.confirm":"Confirm","ai.chatCard.handled":"\u2713 Handled","ai.chatCard.memberFallback":"Member","ai.chatCard.notApplied":"\u2717 Not applied","ai.chatCard.rejected":"Rejected","ai.chatCard.ticketFallback":"Task","ai.chatCard.ask.change":"Change","ai.chatCard.ask.changeMessage":"Change my answer for \u201C{question}\u201D to: {answer}","ai.chatCard.ask.changeMessageShort":"Change my answer: {answer}","ai.chatCard.ask.closedEnd":"Not answered \u2014 the conversation stopped before your answer","ai.chatCard.ask.closedStop":"Not answered \u2014 you stopped the reply","ai.chatCard.ask.editAnswer":"Asked for a change: {words}","ai.chatCard.ask.editPlaceholder":"What should change?","ai.chatCard.ask.keepAnswer":"Keep my answer","ai.chatCard.ask.ownPlaceholder":"Your answer\u2026","ai.chatCard.ask.writeOwn":"Write my own","ai.composer.placeholderAppsBuild":"Describe an app to build\u2026","ai.composer.placeholderAppsBuildShort":"Build an app\u2026","ai.composer.placeholderAppsBuildTiny":"Build\u2026","ai.composer.placeholderAssistant":"Ask anything\u2026","ai.composer.placeholderAssistantShort":"Ask anything\u2026","ai.composer.placeholderAssistantTiny":"Ask\u2026","ai.composer.placeholderDashboard":"Describe a dashboard\u2026","ai.composer.placeholderDashboardCall":"Ask for a dashboard \u2014 everyone in the call sees it\u2026","ai.composer.placeholderDashboardShort":"New dashboard\u2026","ai.composer.placeholderDashboardCallShort":"A dashboard for the call\u2026","ai.composer.placeholderDashboardTiny":"Dashboard\u2026","ai.composer.placeholderFly":"Ask anything \u2014 get a page\u2026","ai.composer.placeholderFlyCall":"Ask for a page \u2014 everyone in the call sees it\u2026","ai.composer.placeholderFlyCallShort":"Ask for the call\u2026","ai.composer.placeholderFlyShort":"Ask for a page\u2026","ai.composer.placeholderFlyTiny":"Ask\u2026","ai.composer.placeholderPresentation":"Describe a presentation\u2026","ai.composer.placeholderPresentationCall":"Ask for slides \u2014 everyone in the call sees them\u2026","ai.composer.placeholderPresentationShort":"New presentation\u2026","ai.composer.placeholderPresentationCallShort":"Slides for the call\u2026","ai.composer.placeholderPresentationTiny":"Slides\u2026","ai.composer.placeholderTools":"Work in your apps\u2026","ai.composer.placeholderToolsShort":"Use your apps\u2026","ai.composer.placeholderToolsTiny":"Apps\u2026","ai.confidence.band.high":"High","ai.confidence.band.insufficient":"Insufficient","ai.confidence.band.low":"Low","ai.confidence.band.moderate":"Moderate","ai.confidence.capsTitle":"Limits applied","ai.confidence.factor.authority":"Authority","ai.confidence.factor.consistency":"Consistency","ai.confidence.factor.coverage":"Coverage","ai.confidence.factor.freshness":"Freshness","ai.confidence.factor.precedent":"Precedent","ai.confidence.factor.self":"Self-reported","ai.confidence.noScore":"This answer carries no confidence score.","ai.confidence.toggle":"Show how this score was computed","ai.confidence.unscored":"Unscored","ai.confirm.kind.docCreate":"Create document","ai.confirm.kind.eventCreate":"Create event","ai.confirm.kind.kbCreate":"Create KB article","ai.confirm.kind.noteCreate":"Create note","ai.confirm.kind.ticketCreate":"Create task","ai.confirm.kind.ticketMove":"Move task","ai.confirm.kind.ticketUpdate":"Update task","ai.confirm.reject":"Reject","ai.confirm.title":"AI proposes these actions","ai.contextBar.chip.mutedTitle":"{name} \u2014 excluded from the prompt; click to include","ai.contextBar.chip.refTitle":"{name} \u2014 the AI\'s reference; click to ask about something else","ai.contextBar.chip.remove":"Remove {name}","ai.contextBar.scopeLine":"AI can reach: {scope}","ai.contextBar.tag.dropped":"not sent","ai.contextBar.tag.textOnly":"as text","ai.contextBar.tag.truncated":"partial","ai.level.band.commercialDecision":"Commercial decision","ai.level.band.commercialNote":"Commercial note","ai.level.band.commercialRecommendation":"Commercial recommendation","ai.level.band.legalDecision":"Legal decision","ai.level.band.legalNote":"Legal note","ai.level.band.legalRecommendation":"Legal recommendation","ai.level.ceilingsTitle":"Ceilings that applied","ai.level.emitted":"Emitted level","ai.level.outOfScope":"Out of scope","ai.level.requested":"Requested level","ai.level.retreat":"Retreat","ai.level.toggle":"Show how this level was set","ai.menu.playground":"AI Playground","ai.menu.title":"AI Tools:","ai.mode.permAsk.label":"Ask permissions","ai.mode.permAsk.sub":"Confirm SDK actions before they fire","ai.mode.permAuto.label":"Auto","ai.mode.permAuto.sub":"AI executes actions immediately","ai.mode.providerCloud.label":"Symbols Cloud","ai.mode.providerCloud.sub":"Managed keys, zero setup","ai.mode.providerLocal.label":"Local agent","ai.mode.providerLocal.sub":"Requires simone-bridge","ai.mode.providerOrg.label":"Org providers","ai.mode.providerOrg.sub":"Your org\'s keys (Vault)","ai.model.anthropic.sub":"Claude models","ai.model.auto":"Auto","ai.model.auto.sub":"Best model per task","ai.model.cheap":"Cheap","ai.model.cheap.sub":"Lowest-cost models","ai.model.gemini.sub":"Google models","ai.model.openai.sub":"GPT models","ai.model.openrouter.sub":"Routed providers","ai.model.research":"Research","ai.model.research.sub":"Deep research mode","ai.model.simone.sub":"Symbols-managed assistant","ai.modelSwitcher.ariaLabel":"AI model and provider","ai.modelSwitcher.model":"Model","ai.modelSwitcher.provider":"Provider","ai.modelSwitcher.someOff":"{count} more are off on this server","ai.panel.actions":"Actions","ai.panel.fieldHint":"Up arrow opens the context and suggestions","ai.panel.label":"Assistant context and suggestions","ai.panel.suggestions":"Suggestions","ai.pill.agentWorking":"{count} agent working","ai.pill.agentsWorking":"{count} agents working","ai.pill.answerReady":"Answer ready","ai.pill.dismiss":"Dismiss","ai.pill.dismissLabel":"Dismiss the assistant pill","ai.pill.idle":"Assistant","ai.pill.open":"Open the assistant","ai.pill.openInMain":"Open in main","ai.pill.openInSidebar":"Open in sidebar","ai.policy.status.active":"Active","ai.policy.status.cancelled":"Cancelled","ai.policy.status.declined":"Declined","ai.policy.status.due":"Payment due","ai.policy.status.expired":"Expired","ai.policy.status.expiring":"Expiring soon","ai.policy.status.lapsed":"Lapsed","ai.policy.status.pastDue":"Past due","ai.policy.status.pending":"Pending","ai.policy.status.pendingRenewal":"Pending renewal","ai.policy.status.renewed":"Renewed","ai.policy.status.unknown":"Unknown","ai.scope.kind.app":"App","ai.scope.kind.page":"Page","ai.scope.kind.record":"Open item","ai.scope.kind.workspace":"Workspace","ai.scope.label":"Context","ai.sessions.delete":"Delete session","ai.sessions.empty":"No sessions yet.","ai.sessions.new":"+ New","ai.sessions.title":"Sessions","ai.settings.appliesTo":"Applies to","ai.settings.authAsk.label":"Ask first","ai.settings.authAsk.sub":"Confirm actions before they run","ai.settings.authAuto.label":"Auto","ai.settings.authAuto.sub":"Run actions immediately","ai.settings.authorization":"Authorization","ai.settings.localAgent":"Local agent","ai.settings.localAgentSub":"Your machine via simone-bridge","ai.settings.localAgentSubActive":"Your machine via simone-bridge \u2014 tap to switch back","ai.settings.panelLabel":"AI settings","ai.settings.pin.activeSuffix":"{model} \u2014 every member\'s turns use it","ai.settings.pin.off":"Off \u2014 each member picks their own model","ai.settings.pin.saveFailed":"Couldn\'t save the workspace setting","ai.settings.pinModel":"Pin a model","ai.settings.pinNone.label":"No pin","ai.settings.pinNone.sub":"Each member picks their own model","ai.settings.pinnedModel":"Pinned model","ai.settings.provider":"AI provider","ai.settings.reliability.empty":"No AI tool turns recorded yet","ai.settings.reliability.label":"Tool turns: {pct}% ok ({ok} of {total}, {days} days)","ai.settings.reliability.leak":"{count} text leak","ai.settings.reliability.leaks":"{count} text leaks","ai.settings.reliability.noLeaks":"No text leaks in this window","ai.settings.reliability.window":"Last {days} days","ai.settings.reliabilityGroup":"AI reliability","ai.settings.scope.me":"Just me","ai.settings.scope.workspace":"Workspace","ai.settings.scopeAdminOnly":"Requires an admin or owner workspace role","ai.settings.scopeNote.me":"Changes here apply only to your own chats.","ai.settings.scopeNote.workspace":"Sets assistant authorization and the pinned model for everyone in this workspace.","ai.settings.switchModel":"Switch AI model","ai.settings.voiceGroup":"Voice","ai.settings.voiceOff.label":"Text only","ai.settings.voiceOff.sub":"Never speak replies","ai.settings.voiceOn.label":"Speak replies","ai.settings.voiceOn.sub":"Simone reads answers aloud","ai.settings.workspaceModel":"Workspace model","ai.sources.kind.canvas":"Canvas","ai.sources.kind.channel":"Channel","ai.sources.kind.doc":"Document","ai.sources.kind.event":"Event","ai.sources.kind.file":"File","ai.sources.kind.mail":"Thread","ai.sources.kind.record":"Record","ai.sources.kind.ticket":"Task","ai.sources.kind.unknown":"Item","ai.sources.open":"Open {name}","ai.sources.unreadable":"not readable in this workspace","ai.sources.unreadableTitle":"{name} \u2014 not readable in this workspace","ai.sources.unverified":"unverified","ai.tool.input":"Details","ai.tool.items":"{count} items","ai.tool.output":"output","ai.tool.result":"Result","ai.tool.run":"Run","ai.tool.runAll":"Run all","ai.tool.runAllTooltip":"Run this and every remaining action in this run \u2014 this turn only","ai.tool.skip":"Skip","ai.tool.skipped":"skipped","ai.tool.undo":"Undo","ai.tool.undone":"undone","ai.tool.undoWhy.gone":"It could not be found here.","ai.tool.undoWhy.denied":"You do not have permission to delete it.","ai.tool.undoWhy.unavailable":"This page cannot undo it.","ai.tool.undoWhy.network":"Could not reach the server. Check your connection.","ai.tool.undoWhy.failed":"An unexpected error occurred.","ai.toolStep.search":"Searching the workspace","ai.toolStep.searchFor":"Searching \u201C{query}\u201D","ai.toolStep.navigate":"Navigating","ai.toolStep.openRoute":"Opening {route}","ai.toolStep.openBeside":"Opening {route} beside the chat","ai.toolStep.closeSplit":"Closing the split pane","ai.toolStep.drawAnswer":"Drawing an answer view","ai.toolStep.drawAnswerNamed":"Drawing \u201C{title}\u201D","ai.toolStep.openItem":"Opening an item","ai.toolStep.openType":"Opening the {type}","ai.toolStep.switchTheme":"Switching theme","ai.toolStep.switchThemeTo":"Switching to {theme} theme","ai.toolStep.confirm":"Waiting for your confirmation","ai.toolStep.choose":"Waiting for your choice","ai.toolStep.chose":"You chose \u201C{choice}\u201D","ai.toolStep.answered":"You answered","ai.toolStep.askUnanswered":"Unanswered question","ai.toolStep.closeDialogs":"Closing dialogs","ai.toolStep.showCards":"Showing cards","ai.toolStep.readProjects":"Reading projects","ai.toolStep.readRecords":"Reading \u201C{collection}\u201D records","ai.toolStep.listCollections":"Listing record collections","ai.toolStep.checkDeployments":"Checking deployments","ai.toolStep.readBuildLog":"Reading a build log","ai.toolStep.readBuilds":"Reading builds","ai.toolStep.readEnvironments":"Reading environments","ai.toolStep.readProject":"Reading a project","ai.toolStep.createProject":"Creating a project","ai.toolStep.createProjectNamed":"Creating project \u201C{name}\u201D","ai.toolStep.updateProject":"Updating a project","ai.toolStep.commitChanges":"Writing project changes","ai.toolStep.buildExtension":"Building the app","ai.toolStep.buildExtensionNamed":"Building \u201C{name}\u201D","ai.toolStep.createApp":"Building an app","ai.toolStep.updateApp":"Updating the app","ai.toolStep.readMembers":"Reading members","ai.toolStep.inviteMember":"Inviting a member","ai.toolStep.inviteEmail":"Inviting {email}","ai.toolStep.readInvitations":"Reading invitations","ai.toolStep.cancelInvitation":"Cancelling an invitation","ai.toolStep.updateRole":"Updating a member role","ai.toolStep.removeMember":"Removing a member","ai.toolStep.renameWorkspace":"Renaming the workspace","ai.toolStep.readAgents":"Reading agents","ai.toolStep.createAgent":"Creating an agent","ai.toolStep.createAgentNamed":"Creating agent \u201C{name}\u201D","ai.toolStep.updateAgent":"Updating an agent","ai.toolStep.delegate":"Delegating to agents","ai.toolStep.chainAgents":"Running an agent chain","ai.toolStep.createTicket":"Creating a task","ai.toolStep.createTicketNamed":"Creating the task \u201C{title}\u201D","ai.toolStep.updateTicket":"Updating a task","ai.toolStep.assignTo":"Assigning to {email}","ai.toolStep.clearAssignee":"Clearing the assignee","ai.toolStep.moveTicket":"Moving a task","ai.toolStep.deleteTicket":"Deleting a task","ai.toolStep.propose":"Proposing an action for approval","ai.toolStep.proposeSummary":"Proposing for approval: {summary}","ai.toolStep.createFolder":"Creating a folder","ai.toolStep.createNote":"Creating a note","ai.toolStep.createNoteNamed":"Creating note \u201C{title}\u201D","ai.toolStep.createChannel":"Creating a channel","ai.toolStep.sendMessage":"Sending a message","ai.toolStep.readDrawing":"Reading the canvas","ai.toolStep.addDrawing":"Drawing on the canvas","ai.toolStep.editDrawing":"Editing the drawing","ai.toolStep.eraseDrawing":"Erasing from the canvas","ai.toolStep.clearDrawing":"Clearing the canvas","ai.toolStep.created":"Created a {kind}","ai.toolStep.createdNamed":"Created {kind} \u201C{title}\u201D","ai.toolStep.generic":"Running a step","ai.toolStep.oneItem":"1 item","ai.toolKind.note":"note","ai.toolKind.document":"document","ai.toolKind.ticket":"task","ai.toolKind.channel":"channel","ai.toolKind.folder":"folder","ai.toolKind.project":"project","ai.toolKind.agent":"agent","ai.toolKind.event":"event","ai.toolKind.item":"item","ai.toolArg.task":"Task","ai.toolArg.title":"Title","ai.toolArg.name":"Name","ai.toolArg.description":"Description","ai.toolArg.text":"Text","ai.toolArg.message":"Message","ai.toolArg.status":"Status","ai.toolArg.priority":"Priority","ai.toolArg.assignee":"Assignee","ai.toolArg.dueDate":"Due date","ai.toolArg.type":"Type","ai.toolArg.column":"Column","ai.toolArg.event":"Event","ai.toolArg.date":"Date","ai.toolArg.start":"Starts","ai.toolArg.end":"Ends","ai.toolArg.timeZone":"Time zone","ai.toolArg.invitees":"Invitees","ai.toolArg.project":"Project","ai.toolArg.page":"Page","ai.toolArg.note":"Note","ai.toolArg.folder":"Folder","ai.toolArg.file":"File","ai.toolArg.channel":"Channel","ai.toolArg.email":"Email","ai.toolArg.role":"Role","ai.toolArg.search":"Search","ai.toolArg.newName":"New name","ai.toolArg.newTitle":"New title","ai.toolArg.agent":"Agent","ai.toolArg.theme":"Theme","ai.toolArg.summary":"Summary","ai.tool.superseded":"Skipped \u2014 you sent a new message","ai.tool.runNow":"Run it now","ai.tool.undoFailed":"Undo did not work.","ai.tool.undoRetry":"Try again","ai.tool.widgetHint":"This widget will be added to your home board","ai.voice.askNotice":"Needs your OK: {step}. Choose Run or Skip on the screen.","ai.voice.askNoticeBare":"A step needs your OK. Choose Run or Skip on the screen.","ai.voice.choiceNotice":"{prompt} Choose your answer on the screen.","ai.voice.choiceNoticeBare":"A question waits for your answer. Choose it on the screen."}');

});

parcelRegister("6KVwS", function(module, exports) {
module.exports = JSON.parse('{"analytics.bugs.empty":"No bugs reported","analytics.bugs.emptyHint":"Errors and rejections will cluster here as they happen.","analytics.bugs.fallbackMessage":"Error","analytics.bugs.title":"Bugs","analytics.campaigns.byCampaign":"Campaign","analytics.campaigns.byContent":"Content","analytics.campaigns.byMedium":"Medium","analytics.campaigns.bySource":"Source","analytics.campaigns.byTerm":"Term","analytics.campaigns.direct":"Direct: {count}","analytics.campaigns.empty":"No campaign traffic in this interval \u2014 add ?utm_source=\u2026&utm_campaign=\u2026 to your links.","analytics.campaigns.groupBy":"Group campaigns by","analytics.campaigns.needsServer":"Campaigns need the new analytics server \u2014 not available on this deployment yet.","analytics.campaigns.none":"(none)","analytics.campaigns.openSessionsFor":"Open sessions for {label}","analytics.campaigns.reading":"Reading campaigns\u2026","analytics.campaigns.title":"Campaigns","analytics.count.bugMany":"{count} bugs","analytics.count.bugOne":"{count} bug","analytics.count.clusterMany":"{count} clusters","analytics.count.clusterOne":"{count} cluster","analytics.count.entryMany":"{count} entries","analytics.count.entryOne":"{count} entry","analytics.count.errorMany":"{count} errors","analytics.count.errorOne":"{count} error","analytics.count.eventMany":"{count} events","analytics.count.eventOne":"{count} event","analytics.count.locationMany":"{count} locations","analytics.count.locationOne":"{count} location","analytics.count.logMany":"{count} logs","analytics.count.logOne":"{count} log","analytics.count.pageViewMany":"{count} page views","analytics.count.pageViewOne":"{count} page view","analytics.count.requestMany":"{count} requests","analytics.count.requestOne":"{count} request","analytics.count.sessionMany":"{count} sessions","analytics.count.sessionOne":"{count} session","analytics.count.updateMany":"{count} updates","analytics.count.updateOne":"{count} update","analytics.count.userMany":"{count} users","analytics.count.userOne":"{count} user","analytics.count.viewMany":"{count} views","analytics.count.viewOne":"{count} view","analytics.count.visitorMany":"{count} visitors","analytics.count.visitorOne":"{count} visitor","analytics.dailyBand.caption":"{parts} over 12 days","analytics.dailyBand.needsServer":"Daily history needs the new analytics server \u2014 not available on this deployment yet.","analytics.dailyBand.title":"Last 12 days","analytics.demographics.empty":"No demographic data yet \u2014 sessions need to land first.","analytics.demographics.title":"Demographics","analytics.demographics.unknownOrigin":"{sessions} without an origin (local dev / anonymized exits)","analytics.duration.days":"{d}d {h}h","analytics.duration.hours":"{h}h {m}m","analytics.duration.minutes":"{m}m {s}s","analytics.duration.seconds":"{s}s","analytics.events.empty":"No events yet","analytics.events.emptyHint":"App and log events will appear here as they happen.","analytics.events.title":"Events","analytics.header.allProjects":"All projects","analytics.header.approximate":"Approximate values derived client-side from the {count} most recent sessions \u2014 the server rollup endpoints didn\'t respond.","analytics.header.interval":"Interval","analytics.header.projectScope":"Project","analytics.identity.anonymous":"Anonymous","analytics.identity.session":"Session","analytics.identity.someone":"Someone","analytics.identity.user":"User {id}","analytics.identity.userFallback":"User","analytics.identity.visitor":"Visitor {id}","analytics.identity.visitorFallback":"Visitor","analytics.interval.all":"All","analytics.interval.day":"24h","analytics.interval.month":"30d","analytics.interval.week":"7d","analytics.kpi.activeNow":"active right now","analytics.kpi.attributed":"{count} attributed","analytics.kpi.avgSession":"Avg session","analytics.kpi.bugs":"Bugs","analytics.kpi.countries":"Countries","analytics.kpi.events":"Events","analytics.kpi.inWorkspace":"in this workspace","analytics.kpi.members":"Members","analytics.kpi.newReturning":"{new} new \xb7 {returning} returning","analytics.kpi.nobodyActive":"nobody active","analytics.kpi.onlineNow":"Online now","analytics.kpi.openTasks":"Open tasks","analytics.kpi.pageViews":"Page views","analytics.kpi.projects":"Projects","analytics.kpi.sessions":"Sessions","analytics.kpi.visitors":"Visitors","analytics.logs.bugs":"Bugs","analytics.logs.collapseDetail":"Collapse detail","analytics.logs.events":"Events","analytics.logs.expandDetail":"Expand detail","analytics.logs.loadError":"Couldn\'t load logs \u2014 {error}","analytics.logs.network":"Network","analytics.logs.requestFailed":"request failed","analytics.logs.sectionsLabel":"Logs sections","analytics.logs.sessions":"Sessions","analytics.logs.title":"Logs","analytics.logs.users":"Users","analytics.logs.verbose":"Verbose","analytics.map.empty":"No geo-tagged sessions in this window yet","analytics.map.hoverEmpty":"\xb7 no sessions yet","analytics.map.label":"World map of sessions by country","analytics.map.modeSessions":"Sessions","analytics.map.modeUsers":"Users","analytics.map.unknown":"Unknown","analytics.meta.activity":"Activity","analytics.meta.app":"App","analytics.meta.bugs":"Bugs","analytics.meta.campaign":"Campaign","analytics.meta.context":"Context","analytics.meta.count":"Count","analytics.meta.country":"Country","analytics.meta.detail":"Detail","analytics.meta.device":"Device","analytics.meta.domain":"Domain","analytics.meta.duration":"Duration","analytics.meta.env":"Env","analytics.meta.environment":"Environment","analytics.meta.firstSeen":"First seen","analytics.meta.health":"Health","analytics.meta.hook":"Hook","analytics.meta.kind":"Kind","analytics.meta.landingPath":"Landing path","analytics.meta.landingReferrer":"Landing referrer","analytics.meta.lastSeen":"Last seen","analytics.meta.level":"Level","analytics.meta.location":"Location","analytics.meta.medium":"Medium","analytics.meta.metric":"Metric","analytics.meta.new":"New","analytics.meta.pageViews":"Page views","analytics.meta.payload":"Payload","analytics.meta.release":"Release","analytics.meta.returning":"Returning","analytics.meta.route":"Route","analytics.meta.sample":"Sample","analytics.meta.samplePayload":"Sample payload","analytics.meta.screen":"Screen","analytics.meta.sessions":"Sessions","analytics.meta.source":"Source","analytics.meta.started":"Started","analytics.meta.time":"Time","analytics.meta.timezone":"Timezone","analytics.meta.type":"Type","analytics.meta.url":"URL","analytics.meta.userAgent":"User agent","analytics.meta.utmCampaign":"UTM campaign","analytics.meta.utmContent":"UTM content","analytics.meta.utmMedium":"UTM medium","analytics.meta.utmSource":"UTM source","analytics.meta.utmTerm":"UTM term","analytics.meta.verbose":"Verbose","analytics.meta.visitor":"Visitor","analytics.meta.zone":"Zone","analytics.network.empty":"No network requests yet","analytics.network.emptyHint":"Fetch and XHR calls will appear here as sessions make them.","analytics.network.title":"Network","analytics.onChanges.title":"Analytics on changes","analytics.page.bugs":"Bugs \xb7 Analytics","analytics.page.events":"Events \xb7 Analytics","analytics.page.logs":"Logs","analytics.page.logsBugs":"Bugs / Logs","analytics.page.logsEvents":"Events / Logs","analytics.page.logsNetwork":"Network / Logs","analytics.page.logsSession":"Session / Logs","analytics.page.logsSessions":"Sessions / Logs","analytics.page.logsUsers":"Users / Logs","analytics.page.logsVerbose":"Verbose / Logs","analytics.page.map":"Analytics \xb7 Map","analytics.page.projects":"Analytics","analytics.page.session":"Session \xb7 Analytics","analytics.page.sessions":"Sessions \xb7 Analytics","analytics.page.visitors":"Visitors \xb7 Analytics","analytics.page.workspace":"Workspace Analytics","analytics.session.back":"\u2190 Back to sessions","analytics.session.empty":"No events recorded","analytics.session.emptyHint":"Nothing was captured for this session yet.","analytics.session.familyProject":"Project \xb7 {project}","analytics.session.familyWorkspace":"Workspace","analytics.session.openVisitor":"Open this visitor\u2019s sessions","analytics.session.sequence":"session #{number}","analytics.session.unknownProject":"unknown","analytics.sessions.clearFilter":"Clear filter","analytics.sessions.empty":"No sessions yet","analytics.sessions.emptyHint":"Sessions will appear here as people use your projects.","analytics.sessions.title":"Sessions","analytics.topPages.empty":"No page views in this interval yet.","analytics.topPages.title":"Top pages","analytics.topReferrers.direct":"Direct: {count}","analytics.topReferrers.empty":"No referrers in this interval yet.","analytics.topReferrers.title":"Top referrers","analytics.topReferrers.unknownHost":"unknown","analytics.totals.allTime":"All time: {parts}","analytics.totals.allTimeMissing":"All-time totals not reported by the server.","analytics.totals.missingPageViews":"\u2014 page views","analytics.totals.missingSessions":"\u2014 sessions","analytics.totals.missingVisitors":"\u2014 visitors","analytics.totals.needsServer":"Totals need the new analytics server \u2014 not available on this deployment yet.","analytics.totals.reading":"Reading totals\u2026","analytics.totals.title":"Overall","analytics.users.emptyHintUsers":"Users appear here once sessions land.","analytics.users.emptyHintVisitors":"Visitors appear here as people open your projects.","analytics.users.emptyUsers":"No users yet","analytics.users.emptyVisitors":"No visitors yet","analytics.users.titleUsers":"Users","analytics.users.titleVisitors":"Visitors","analytics.usersToday.noHourly":"{users} today \u2014 no hourly breakdown was reported for the last 24 hours.","analytics.usersToday.now":"now","analytics.usersToday.titleUsers":"Users today","analytics.usersToday.titleVisitors":"Visitors today","analytics.verbose.empty":"No verbose entries","analytics.verbose.emptyHint":"Verbose console output will appear here as sessions produce it.","analytics.verbose.title":"Verbose","analytics.view.bugs":"Bugs","analytics.view.events":"Events","analytics.view.logs":"Logs","analytics.view.map":"Map","analytics.view.overview":"Overview","analytics.view.sessions":"Sessions","analytics.view.visitors":"Visitors","analytics.weekly.pastWeek":"Past week","analytics.weekly.thisWeek":"This week","analytics.whosActive.empty":"No sessions in this workspace yet.","analytics.whosActive.fallbackNotice":"No sessions in the last 5 min \u2014 showing the 20 most-recent visitors instead.","analytics.whosActive.openSession":"Open session","analytics.whosActive.title":"Who\'s active","analytics.whosActive.toggleDetails":"Toggle session details","analytics.window.allTime":"All time","analytics.window.last24h":"Last 24 hours","analytics.window.last30d":"Last 30 days","analytics.window.last7d":"Last 7 days","analytics.workspace.activeNow":"Active right now","analytics.workspace.appHealth":"App health \xb7 7 days","analytics.workspace.comingUp":"Coming up","analytics.workspace.eventFallback":"Event","analytics.workspace.healthClear":"No errors in the last 7 days.","analytics.workspace.healthError":"Couldn\u2019t load error data \u2014 this is not an all-clear.","analytics.workspace.healthPending":"Checking for errors\u2026","analytics.workspace.hintLast7d":"last 7 days","analytics.workspace.hintNeedsServer":"needs the new analytics server","analytics.workspace.hintReading":"reading\u2026","analytics.workspace.noActivity":"No app activity recorded yet.","analytics.workspace.noLocations":"No member locations yet.","analytics.workspace.openErrorLogs":"Open error logs \u2192","analytics.workspace.presenceEmpty":"Nobody active in the last 5 minutes.","analytics.workspace.presenceError":"Couldn\u2019t load presence data.","analytics.workspace.presencePending":"Checking who\u2019s active\u2026","analytics.workspace.remote":"Remote","analytics.workspace.teamActivity":"Team activity this week","analytics.workspace.unknownError":"Unknown error","analytics.workspace.whereTeam":"Where the team is"}');

});

parcelRegister("5665D", function(module, exports) {
module.exports = JSON.parse('{"apps.bi.barChart.empty":"No stores registered yet","apps.bi.funnel.lost":"Lost: {count} deals \xb7 {value}","apps.bi.funnel.lostOne":"Lost: 1 deal \xb7 {value}","apps.bi.stage.lead":"Lead","apps.bi.stage.lost":"Lost","apps.bi.stage.proposal":"Proposal","apps.bi.stage.qualified":"Qualified","apps.bi.stage.won":"Won","apps.catalog.agtCodeReviewer.descr":"Independent reviewer agent with read-only access.","apps.catalog.agtCodeReviewer.name":"Code Reviewer","apps.catalog.agtDocsWriter.descr":"Drafts API + README docs from real code, not vibes.","apps.catalog.agtDocsWriter.name":"Docs Writer","apps.catalog.agtRefactor.descr":"Plans a multi-file refactor before touching anything.","apps.catalog.agtRefactor.name":"Refactor Agent","apps.catalog.agtSecurityAuditor.descr":"Hunts OWASP Top-10 + auth/authz bugs in the diff.","apps.catalog.agtSecurityAuditor.name":"Security Auditor","apps.catalog.agtTestWriter.descr":"Writes failing tests first, then watches them turn green.","apps.catalog.agtTestWriter.name":"Test Writer","apps.catalog.mcpSymbols.descr":"Symbols\' own MCP server \u2014 projects, tickets, workspace tools.","apps.catalog.plgA11y.descr":"WCAG checks in editor.","apps.catalog.plgA11y.name":"Accessibility Audit","apps.catalog.plgGridstack.descr":"Drag-and-drop grid layouts.","apps.catalog.plgGridstack.name":"Gridstack Layout","apps.catalog.plgI18n.descr":"Multi-language content.","apps.catalog.plgMonaco.descr":"In-browser code editing.","apps.catalog.plgSeo.descr":"Meta tags, sitemaps, OG images.","apps.catalog.plgSeo.name":"SEO Tools","apps.catalog.prmApiDesign.descr":"Critique an API surface for consistency and longevity.","apps.catalog.prmApiDesign.name":"API Design Review","apps.catalog.prmBugRca.descr":"Investigate a bug report and propose a minimal fix + test.","apps.catalog.prmBugRca.name":"Bug Root-Cause","apps.catalog.prmCodeReview.descr":"Walk a diff for correctness, style, security, and tests.","apps.catalog.prmCodeReview.name":"Code Review","apps.catalog.prmCommitMsg.descr":"Compose a focused commit message from a staged diff.","apps.catalog.prmCommitMsg.name":"Commit Message","apps.catalog.prmPrdDraft.descr":"Turn raw notes into a tight one-page PRD.","apps.catalog.prmPrdDraft.name":"PRD Draft","apps.catalog.regCloudflareRegistrar.descr":"At-cost domain registration with built-in DNS.","apps.catalog.regGandi.descr":"Domains, DNS, and mailbox hosting.","apps.catalog.regGodaddy.descr":"Domain search, registration, transfers, DNS.","apps.catalog.regHover.descr":"Domains, email forwarding, and DNS without upsells.","apps.catalog.regName.descr":"Domains, DNS, and SSL with a developer API.","apps.catalog.regNamecheap.descr":"Register and manage domains with WHOIS privacy.","apps.catalog.regNamesilo.descr":"Low-cost domains with free privacy and API access.","apps.catalog.regPorkbun.descr":"Developer-friendly registrar with free WHOIS privacy.","apps.catalog.regSquarespaceDomains.descr":"Domains, DNS, and forwarding (formerly Google Domains).","apps.catalog.sklInit.descr":"Generate a CLAUDE.md from the codebase.","apps.catalog.sklLoop.descr":"Re-run a prompt on a recurring interval.","apps.catalog.sklReview.descr":"Review a PR or branch end-to-end.","apps.catalog.sklSchedule.descr":"Schedule remote agents on cron.","apps.catalog.sklSecurityReview.descr":"Run a security pass on pending changes.","apps.catalog.sklSimplify.descr":"Audit pending changes for over-engineering.","apps.catalog.trigger.onRequest":"On request \u2014 {cmd}","apps.cms.status.draft":"draft","apps.cms.status.published":"published","apps.commerce.invoiceStatus.draft":"Draft","apps.commerce.invoiceStatus.overdue":"Overdue","apps.commerce.invoiceStatus.paid":"Paid","apps.commerce.invoiceStatus.partiallyPaid":"Partially Paid","apps.commerce.invoiceStatus.sent":"Sent","apps.commerce.invoiceStatus.unpaid":"Unpaid","apps.commerce.invoiceStatus.void":"Void","apps.commerce.party.none":"No customer","apps.commerce.party.unknown":"Customer","apps.crm.contact.unnamed":"Contact","apps.crm.followup.untitled":"Follow-up","apps.crm.kind.call":"Call","apps.crm.kind.email":"Email","apps.crm.kind.meeting":"Meeting","apps.crm.kind.note":"Note","apps.crm.kind.task":"Task","apps.crm.stage.lead":"Lead","apps.crm.stage.lost":"Lost","apps.crm.stage.proposal":"Proposal","apps.crm.stage.qualified":"Qualified","apps.crm.stage.won":"Won","apps.crm.when.dueToday":"Due today","apps.crm.when.dueTomorrow":"Due tomorrow","apps.crm.when.inDays":"In {count}d","apps.crm.when.overdue":"{count}d overdue","apps.helmet.stat.ai":"AI-ready","apps.helmet.stat.issues":"Issues","apps.helmet.stat.pages":"Pages","apps.helmet.stat.score":"Avg score","apps.hr.leaveKind.sick":"Sick","apps.hr.leaveKind.unpaid":"Unpaid","apps.hr.leaveKind.vacation":"Vacation","apps.hr.person.unnamed":"Someone","apps.hr.role.cashier":"Cashier","apps.hr.role.ceo":"CEO","apps.hr.role.manager":"Manager","apps.hr.role.other":"Other","apps.hr.role.warehouseManager":"Warehouse manager","apps.installModal.domain":"Domain: {domain}","apps.installModal.install":"Install","apps.installModal.installItem":"Install {item}","apps.installModal.manageItem":"Manage {item}","apps.installModal.scope":"Scope: {scope}","apps.installStub.comingSoon":"Phase 4 \u2014 MarketplaceInstallModal coming soon","apps.installStub.dismiss":"Dismiss","apps.installStub.receivedArgs":"RECEIVED ARGS","apps.integration.amplitude.descr":"Add Amplitude analytics to your website","apps.integration.auth0.descr":"Connect authorisation to your app","apps.integration.connect":"Connect","apps.integration.connectFailed":"Connect failed","apps.integration.connectKind":"Connect {kind}","apps.integration.connected":"Connected {name}","apps.integration.connecting":"Connecting\u2026","apps.integration.custom.descr":"Add custom endpoint as data source","apps.integration.custom.title":"Custom","apps.integration.disconnected":"Disconnected","apps.integration.displayName":"Display name","apps.integration.displayNamePlaceholder":"My integration","apps.integration.firebase.descr":"Connect to Firebase endpoint","apps.integration.github.descr":"Connect repository and sync changes","apps.integration.googleAnalytics.descr":"Collect data to your Google Tag dashboard","apps.integration.googleSheets.descr":"Connect sheets as data source","apps.integration.instagram.descr":"Import instagram feed as data","apps.integration.intercom.descr":"Add live support on your website","apps.integration.missingField.message":"\\"{field}\\" is required.","apps.integration.missingField.title":"Missing required field","apps.integration.noWorkspace":"No active workspace","apps.integration.npm.descr":"Publish your project as NPM package","apps.integration.removeFailed":"Remove failed","apps.integration.reorderFailed":"Reorder save failed","apps.integration.scopeRequired.message":"Select or enter a {scope} ID.","apps.integration.scopeRequired.title":"Scope ID required","apps.integration.secretLabel":"API key / Secret","apps.integration.serverError":"Server error","apps.integration.slack.descr":"Get notifications on important events","apps.integration.status.disabled":"Disabled","apps.integration.status.live":"Live","apps.integration.stripe.descr":"Connect your Stripe payments to your app","apps.integration.test":"Test","apps.integration.testFailed":"Test failed","apps.integration.testPassed":"Test passed \u2713","apps.integration.testing":"Testing\u2026","apps.integration.unknownError":"Unknown error","apps.integrations.title":"INTEGRATIONS","apps.jobs.stage.hired":"Hired","apps.jobs.stage.interview":"Interview","apps.jobs.stage.new":"New","apps.jobs.stage.offer":"Offer","apps.jobs.stage.rejected":"Rejected","apps.jobs.stage.screening":"Screening","apps.jobs.stage.withdrawn":"Withdrawn","apps.mcp.field.authKind":"Auth kind (none, bearer, api-key, oauth)","apps.mcp.field.authToken":"Auth token (bearer / api-key only)","apps.mcp.field.transport":"Transport (sse, websocket, http)","apps.mcp.field.url":"Server URL","apps.policies.holder.unnamed":"Unnamed holder","apps.policies.renewal.inDays":"in {count}d","apps.policies.renewal.overdue":"{count}d overdue","apps.policies.renewal.today":"Today","apps.rail.add":"Add {domain}","apps.rail.available":"Available","apps.rail.empty.title":"Add your first {domain}","apps.rail.emptyHint.org":"No {domain} installed for this organization yet.","apps.rail.emptyHint.project":"No {domain} installed for this project yet.","apps.rail.emptyHint.workspace":"No {domain} installed for this workspace yet.","apps.rail.error.load":"Load failed","apps.rail.error.loadInstalled":"Failed to load installed items","apps.rail.installed":"Installed","apps.scheduling.kind.booking":"Booking","apps.scheduling.role.cashier":"Cashier","apps.scheduling.role.manager":"Manager","apps.scheduling.role.warehouse":"Warehouse","apps.scheduling.staff.unnamed":"Staff","apps.scheduling.status.booked":"Booked","apps.scheduling.status.cancelled":"Cancelled","apps.scheduling.status.completed":"Completed","apps.scheduling.status.confirmed":"Confirmed","apps.scheduling.status.delivered":"Delivered","apps.scheduling.status.noShow":"No Show","apps.scheduling.status.pending":"Pending","apps.scheduling.time.none":"No time","apps.scheduling.time.notSet":"No time set","apps.scope.error.fetchFailed":"Fetch failed","apps.scope.error.rateLimited":"Rate limited","apps.scope.error.sessionNotLoaded":"Session not loaded","apps.scope.hint":"Org-wide infra (SSO, code) should stay at org scope. Per-product integrations (databases, analytics) are best scoped to a project so the editor only surfaces them inside that project.","apps.scope.loadingProjects":"Loading projects\u2026","apps.scope.mode.org":"Org","apps.scope.mode.project":"Project","apps.scope.mode.workspace":"Workspace","apps.scope.noMatches":"No matches for \\"{query}\\".","apps.scope.proj.backToList":"\u2190 Back to list","apps.scope.proj.empty":"No projects found.","apps.scope.proj.emptyOrg":"No projects in this org.","apps.scope.proj.loadFailed":"Could not load projects: {error}","apps.scope.proj.manualEntry":"+ Enter project ID manually","apps.scope.projectId":"Project ID","apps.scope.searchProjects":"Search projects\u2026","apps.scope.searchWorkspaces":"Search workspaces\u2026","apps.scope.selected":"Selected: {name}","apps.scope.title":"Scope","apps.scope.ws.empty":"No workspaces found.","apps.scope.ws.emptyOrg":"No workspaces in this org.","apps.warehouse.moveType.adjustment":"adjustment","apps.warehouse.moveType.count":"count","apps.warehouse.moveType.receipt":"receipt","apps.warehouse.moveType.return":"return","apps.warehouse.moveType.sale":"sale","apps.warehouse.moveType.transferIn":"transfer in","apps.warehouse.moveType.transferOut":"transfer out","apps.warehouse.moveType.writeOff":"write off","apps.warehouse.product.unknown":"(unknown product)","apps.warehouse.timeAgo.days":"{count}d ago","apps.warehouse.timeAgo.hours":"{count}h ago","apps.warehouse.timeAgo.minutes":"{count}m ago","apps.warehouse.timeAgo.now":"now","apps.widget.biPipeline.caption":"Open pipeline \xb7 lead + qualified + proposal","apps.widget.biPipeline.captionMini":"open pipeline","apps.widget.biPipeline.empty":"No deals yet","apps.widget.biPipeline.title":"Pipeline","apps.widget.biPipeline.unit":"open","apps.widget.biPipeline.wonRate":"{rate}% won","apps.widget.biRevenue.caption":"Today across stores \xb7 7-day trend","apps.widget.biRevenue.captionMini":"today\'s revenue","apps.widget.biRevenue.empty":"No sales recorded yet","apps.widget.biRevenue.footer":"All stores","apps.widget.biRevenue.title":"Revenue","apps.widget.biRevenue.window":"\xb7 {count}d","apps.widget.biStock.caption":"stock health","apps.widget.biStock.empty":"No stock on shelf yet","apps.widget.biStock.lowAlerts":"{count} low-stock alerts","apps.widget.biStock.lowAlertsOne":"1 low-stock alert","apps.widget.biStock.nothingBelow":"Nothing below threshold","apps.widget.biStock.title":"Stock","apps.widget.biStock.unit":"healthy","apps.widget.biStores.caption":"Revenue by store \xb7 last {count} days","apps.widget.biStores.captionMini":"stores reporting","apps.widget.biStores.empty":"No store sales in this period","apps.widget.biStores.footer":"Last {count} days","apps.widget.biStores.title":"Stores","apps.widget.bookmarksRecent.empty":"No saved bookmarks yet","apps.widget.bookmarksRecent.title":"Recent bookmarks","apps.widget.bookmarksRecent.unit":"bookmarks saved","apps.widget.bookmarksRecent.unitOne":"bookmark saved","apps.widget.capTable.captionMini":"cap table holders","apps.widget.capTable.empty":"No grants yet","apps.widget.capTable.title":"Cap table","apps.widget.cmsRecent.empty":"No entries yet","apps.widget.cmsRecent.title":"Content","apps.widget.cmsRecent.unit":"entries","apps.widget.cmsRecent.unitOne":"entry","apps.widget.crmFollowups.error":"Couldn\'t load follow-ups","apps.widget.crmFollowups.title":"Follow-ups","apps.widget.crmPipeline.error":"Couldn\'t load the pipeline","apps.widget.crmPipeline.title":"Pipeline","apps.widget.crmRecent.empty":"No contacts yet","apps.widget.crmRecent.error":"Couldn\'t load contacts","apps.widget.crmRecent.title":"Recent contacts","apps.widget.crmRecent.unit":"contacts","apps.widget.crmRecent.unitOne":"contact","apps.widget.helmetHealth.caption":"avg score","apps.widget.helmetHealth.captionMini":"avg SEO score","apps.widget.helmetHealth.empty":"No pages yet","apps.widget.helmetHealth.title":"SEO health","apps.widget.hrHeadcount.empty":"No team members yet","apps.widget.hrHeadcount.title":"Headcount","apps.widget.hrHeadcount.unit":"people","apps.widget.hrHeadcount.unitOne":"person","apps.widget.hrLeaveToday.caption":"out this week","apps.widget.hrLeaveToday.empty":"Nobody is out this week","apps.widget.hrLeaveToday.title":"Out of office","apps.widget.hrLeaveToday.unit":"out","apps.widget.hrOnboarding.caption":"in progress","apps.widget.hrOnboarding.captionMini":"onboarding in progress","apps.widget.hrOnboarding.empty":"No onboardings in progress","apps.widget.hrOnboarding.title":"Onboarding","apps.widget.hrRecent.captionMini":"on the team","apps.widget.hrRecent.empty":"No team members yet","apps.widget.hrRecent.title":"Team","apps.widget.hrRecent.unit":"team members","apps.widget.hrRecent.unitOne":"team member","apps.widget.jobsPipeline.caption":"open applications","apps.widget.jobsPipeline.empty":"No applications yet \u2014 open Hiring to review the pipeline","apps.widget.jobsPipeline.error":"Couldn\'t load the pipeline","apps.widget.jobsPipeline.title":"Hiring pipeline","apps.widget.policiesRenewals.captionMini":"renewals need attention","apps.widget.policiesRenewals.empty":"No upcoming renewals","apps.widget.policiesRenewals.title":"Upcoming renewals","apps.widget.polyglotCoverage.captionMini":"avg coverage","apps.widget.polyglotCoverage.complete":"Complete","apps.widget.polyglotCoverage.empty":"No locales yet","apps.widget.polyglotCoverage.missing":"{count} missing","apps.widget.polyglotCoverage.title":"Translations","apps.widget.schUpcoming.caption":"bookings ahead","apps.widget.schUpcoming.empty":"No upcoming bookings","apps.widget.schUpcoming.title":"Upcoming bookings","apps.widget.schedToday.caption":"on the schedule","apps.widget.schedToday.empty":"Nothing scheduled today","apps.widget.schedToday.title":"Today","apps.widget.schedWeek.caption":"entries this week","apps.widget.schedWeek.dayTooltip":"{bookings} bookings \xb7 {shifts} shifts","apps.widget.schedWeek.empty":"A quiet week","apps.widget.schedWeek.legendBookings":"Bookings","apps.widget.schedWeek.legendShifts":"Shifts","apps.widget.schedWeek.title":"This week","apps.widget.schedWeek.unit":"bookings","apps.widget.storeRevenueToday.captionMini":"today\'s revenue","apps.widget.storeRevenueToday.empty":"Add store locations to see per-store revenue.","apps.widget.storeRevenueToday.entriesToday":"{count} entries today","apps.widget.storeRevenueToday.entriesTodayOne":"1 entry today","apps.widget.storeRevenueToday.noSales":"No sales recorded today","apps.widget.storeRevenueToday.title":"Today\'s revenue","apps.widget.storeRevenueToday.txCount":"{count} tx","apps.widget.storeRevenueToday.unit":"today","apps.widget.storeUnpaid.empty":"Nothing unpaid \u2014 all settled.","apps.widget.storeUnpaid.stillDue":"still due across {count} invoices","apps.widget.storeUnpaid.stillDueOne":"still due across 1 invoice","apps.widget.storeUnpaid.title":"Unpaid invoices","apps.widget.storeUnpaid.unit":"unpaid invoices","apps.widget.storeUnpaid.unitOne":"unpaid invoice","apps.widget.storeUnpaid.unitShort":"unpaid","apps.widget.whLowstock.avail":"{count} avail","apps.widget.whLowstock.caption":"products low or out","apps.widget.whLowstock.captionMini":"low or out","apps.widget.whLowstock.empty":"All stocked up \u2014 nothing low or out.","apps.widget.whLowstock.outCount":"{count} out","apps.widget.whLowstock.title":"Low stock","apps.widget.whMoves.caption":"movements logged","apps.widget.whMoves.empty":"No movements yet","apps.widget.whMoves.footer":"Last move {when}","apps.widget.whMoves.title":"Movements","apps.widget.whMoves.unitToday":"today","apps.widget.whStock.availableOf":"available of {count} on shelf","apps.widget.whStock.captionMini":"units available","apps.widget.whStock.empty":"No warehouses yet","apps.widget.whStock.footer":"{count} warehouses","apps.widget.whStock.footerOne":"1 warehouse","apps.widget.whStock.lowProducts":"{count} products low or out","apps.widget.whStock.lowProductsOne":"1 product low or out","apps.widget.whStock.title":"Warehouse stock"}');

});

parcelRegister("dqEyJ", function(module, exports) {
module.exports = JSON.parse('{"auth.acceptInvite.alreadyMember":"You are already a member of this {kind}.","auth.acceptInvite.createAccount":"Create account and join","auth.acceptInvite.expired":"This invitation has expired. Ask the sender for a new invite.","auth.acceptInvite.generic":"Something went wrong while accepting the invitation.","auth.acceptInvite.goToWorkspace":"Go to workspace","auth.acceptInvite.h.error":"Invitation problem","auth.acceptInvite.h.joining":"Accepting invitation","auth.acceptInvite.h.joiningNamed":"Joining {name}","auth.acceptInvite.h.mismatch":"Wrong account","auth.acceptInvite.h.redirect":"Sign in to continue","auth.acceptInvite.h.success":"Invitation accepted","auth.acceptInvite.h.welcome":"You are invited","auth.acceptInvite.h.welcomeNamed":"Join {name}","auth.acceptInvite.haveAccount":"I already have an account","auth.acceptInvite.inactive":"This invitation is no longer active. Ask the sender for a new invite.","auth.acceptInvite.invalid":"This invitation link is invalid. The link may be incomplete or superseded.","auth.acceptInvite.invalidOrExpired":"This invitation link is invalid or has expired. Ask the sender for a new invite.","auth.acceptInvite.joined":"You have joined the {kind}.","auth.acceptInvite.kind.invitation":"invitation","auth.acceptInvite.kind.organization":"organization","auth.acceptInvite.kind.project":"project","auth.acceptInvite.kind.team":"team","auth.acceptInvite.kind.workspace":"workspace","auth.acceptInvite.kindIn.invitation":"an invitation","auth.acceptInvite.kindIn.organization":"an organization","auth.acceptInvite.kindIn.project":"a project","auth.acceptInvite.kindIn.team":"a team","auth.acceptInvite.kindIn.workspace":"a workspace","auth.acceptInvite.kindOf.invitation":"invitation","auth.acceptInvite.kindOf.organization":"organization","auth.acceptInvite.kindOf.project":"project","auth.acceptInvite.kindOf.team":"team","auth.acceptInvite.kindOf.workspace":"workspace","auth.acceptInvite.kindTo.invitation":"invitation","auth.acceptInvite.kindTo.organization":"organization","auth.acceptInvite.kindTo.project":"project","auth.acceptInvite.kindTo.team":"team","auth.acceptInvite.kindTo.workspace":"workspace","auth.acceptInvite.linkUsed":"This invite link no longer works: someone already used it, or it was turned off. Ask the person who shared it for a new link.","auth.acceptInvite.mismatch":"This invitation was sent to {invited}. You are signed in as {current}. Sign out, then open the invite link again.","auth.acceptInvite.missingToken":"Open the invitation link again to join. For your safety, this page does not keep the link after a reload.","auth.acceptInvite.notFound":"This invitation could not be found. The link may be incomplete.","auth.acceptInvite.openWorkspace":"Open workspace","auth.acceptInvite.p.as":" ({email})","auth.acceptInvite.p.checking":"Checking your {kind} invitation\u2026","auth.acceptInvite.p.redirect":"Taking you to sign-in \u2014 the invitation stays attached.","auth.acceptInvite.p.welcome":"{who}{where}{as}. Create an account to join, or sign in if you already have one.","auth.acceptInvite.p.whereKind":" to {kind}","auth.acceptInvite.p.whereNamed":" to {name}","auth.acceptInvite.p.whereNamedOrg":" to {name} at {org}","auth.acceptInvite.p.who":"You have been invited","auth.acceptInvite.p.whoNamed":"{name} invited you","auth.acceptInvite.switchAccount":"Switch account","auth.acceptInvite.verifyFirst":"Verify your email to join. Open the link we sent to your inbox, then open this invitation link again.","auth.acceptInvite.wrongEmail":"This invitation was sent to a different email address. Sign out and sign back in with the invited email.","auth.callback.backToSignIn":"Back to sign in","auth.callback.error.accessDenied":"You cancelled the sign-in, or access was not granted. Try again.","auth.callback.error.expired":"This sign-in link is no longer valid. Start again from the sign-in page.","auth.callback.error.generic":"Sign-in failed. Please try again.","auth.callback.error.linkMalformed":"Sign-in link is missing or malformed. Open the link from your email again.","auth.callback.error.missingCode":"Missing OAuth code in callback URL.","auth.callback.error.network":"Network error. Please try again.","auth.callback.error.unavailable":"Sign-in is unavailable right now. Please try again in a moment.","auth.callback.error.unverifiedEmail":"Your email is not verified yet. Verify it with your sign-in provider, then try again.","auth.callback.hydrating":"Hydrating session\u2026","auth.callback.loadingAccount":"Loading your account\u2026","auth.callback.persisting":"Persisting session\u2026","auth.callback.redirecting":"Done. Redirecting\u2026","auth.callback.signingIn":"Signing you in\u2026","auth.callback.verifyingGithub":"Verifying with GitHub\u2026","auth.callback.verifyingLink":"Verifying your sign-in link\u2026","auth.confirm.eyebrow":"Email confirmation","auth.confirm.heading":"Verifying your email","auth.confirm.loading":"Confirming your email...","auth.emailConfirmFailed.body":"Unable to confirm your email. Please try again or contact support.","auth.emailConfirmFailed.title":"Confirmation Failed","auth.emailConfirmed.action":"Go to Sign In","auth.emailConfirmed.body":"Your email has been successfully confirmed. You can now sign in to your account.","auth.emailConfirmed.title":"Email Confirmed!","auth.emailTaken.title":"This email is already in use","auth.emailTaken.body":"Another Symbols account already uses this email, so we did not change your email. If that account is yours, sign in to it.","auth.confirm.continueBody":"Press Continue to confirm this email address and sign in to its account:","auth.confirm.continue":"Continue","auth.confirm.otherAccount":"You are signed in as {email}. Continue signs you out of that account.","auth.confirm.otherAccountUnnamed":"You are signed in as {email}. Continue can sign you in to a different account.","auth.confirm.switchContinue":"Sign out and continue","auth.confirm.invalidLink":"This confirmation link is not valid.","auth.setPassword.title":"Set a password","auth.setPassword.body":"Your email is confirmed and you are signed in. Set a password to sign in with it next time, or skip and sign in with an email link.","auth.setPassword.label":"New password","auth.setPassword.placeholder":"Choose a password","auth.setPassword.save":"Save password","auth.setPassword.skip":"Skip","auth.setPassword.error":"The password was not saved. Try again, or skip.","auth.google.authFailed.message":"Google authentication was cancelled or failed.","auth.google.authFailed.title":"Authentication failed","auth.google.incomplete":"Sign-in did not complete ({error}). Please try again.","auth.google.incompleteGeneric":"Failed to complete Google sign-in.","auth.google.securityError.message":"Authentication failed due to security check.","auth.google.securityError.title":"Security error","auth.google.stateMismatch.message":"Sign-in session did not match \u2014 please try again.","auth.google.stateMismatch.title":"Security check failed","auth.google.unreachable":"Unable to connect to Google. Please try again.","auth.login.alternativeBody":"Use your Google or GitHub account.","auth.login.alternativeHeading":"Another way to sign in","auth.login.devApi.message":"The local API rejected every token with a signature mismatch \u2014 it is running without its JWT secret. Your session was NOT cleared. Restart the dev API (~/www/deploy/bin/dev.sh) and reload; signing in again will not help.","auth.login.devApi.title":"Dev API is misconfigured","auth.login.email":"Email","auth.login.emailOrUsername":"Email or username","auth.login.emailOrUsernamePlaceholder":"e.g. hello@symbo.ls or username","auth.login.forgot":"Forgot your password?","auth.login.github":"Sign in with Github","auth.login.githubStartFailed":"Failed to start GitHub sign-in","auth.login.githubUnavailable.message":"githubClientId is not configured for this environment.","auth.login.githubUnavailable.title":"GitHub sign-in unavailable","auth.login.google":"Sign in with Google","auth.login.googleFailed":"Failed to sign in with Google","auth.login.googleNativeHint":"Google sign-in opens in your browser soon \u2014 use email for now","auth.login.googleNotInApp.message":"Google sign-in opens in your browser soon \u2014 use email for now.","auth.login.googleNotInApp.title":"Google sign-in is not available in the app yet","auth.login.googleSignInFailed":"Google sign-in failed","auth.login.googleUnavailable.message":"Google identity script did not load.","auth.login.googleUnavailable.title":"Google sign-in unavailable","auth.login.heading":"Sign in to Symbols","auth.login.password":"Password","auth.login.sub":"Use your work email and password.","auth.login.submit":"Sign in","auth.login.title":"Sign in","auth.login.tryAgain":"Please try again.","auth.login.welcome":"Welcome","auth.page.acceptInvite.title":"Accept invitation","auth.page.callback.title":"Signing you in / Symbols","auth.page.resetPassword.title":"Reset password / Symbols","auth.page.signin.title":"Sign in / Symbols","auth.page.signin.titlePlain":"Sign in","auth.page.signup.title":"Create account","auth.page.signupConfirmation.title":"Confirm email / Symbols","auth.page.waitlistInvite.title":"Join Symbols / Symbols","auth.resetEmail.label":"Email","auth.resetEmail.placeholder":"e.g. hello@symbo.ls","auth.resetEmail.required":"Email field is required","auth.resetEmail.sending":"Sending\u2026","auth.resetEmail.submit":"Reset password","auth.resetPassword.emailRequired.message":"Enter the email associated with your account.","auth.resetPassword.emailRequired.title":"Email required","auth.resetPassword.heading.request":"Reset your password","auth.resetPassword.heading.set":"Set a new password","auth.resetPassword.linkSent.message":"Check your inbox at {email}.","auth.resetPassword.linkSent.title":"Reset link sent","auth.resetPassword.mismatch":"Passwords do not match","auth.resetPassword.mismatchMessage":"Make sure both fields are identical.","auth.resetPassword.mismatchTitle":"Passwords do not match","auth.resetPassword.missingFields.message":"Both password fields are required.","auth.resetPassword.missingFields.title":"Missing fields","auth.resetPassword.newLabel":"Type in new password","auth.resetPassword.placeholder":"Password","auth.resetPassword.repeatLabel":"Repeat new password","auth.resetPassword.repeatRequired":"Repeat password field is required","auth.resetPassword.required":"Password field is required","auth.resetPassword.sendFailed":"Failed to send reset link","auth.resetPassword.sentNotice":"Check your inbox at {email}. Follow the link to set a new password.","auth.resetPassword.sentNoticeNoEmail":"Check your inbox. Follow the link to set a new password.","auth.resetPassword.submit":"Confirm","auth.resetPassword.updateFailed":"Failed to update password","auth.resetPassword.updated.message":"You can sign in with your new password now.","auth.resetPassword.updated.title":"Password updated","auth.resetPassword.updating":"Updating\u2026","auth.signin.failed":"Failed to sign in","auth.signin.failedMessage":"Please check your credentials and try again.","auth.signin.missingFields.message":"Email/username and password are required.","auth.signin.missingFields.title":"Missing fields","auth.signup.accountType":"Account type","auth.signup.accountTypePlaceholder":"Select account type\u2026","auth.signup.alreadyCredits.message":"Check your email to confirm your account.","auth.signup.alreadyCredits.title":"You already have credits","auth.signup.alternativeHeading":"Another way to sign up","auth.signup.checkEmail.hint":"It can take a few minutes. Check your spam folder too.","auth.signup.checkEmail.sent":"We sent a confirmation link to {email}.","auth.signup.checkEmail.title":"Check your email","auth.signup.creating":"Creating account\u2026","auth.signup.creditsAdded.message":"Check your email to confirm your account \u2014 your workspace already has {credits} credits ready to use.","auth.signup.creditsAdded.title":"100 free credits added","auth.signup.done.continue":"Continue to sign in","auth.signup.email":"Email","auth.signup.emailPlaceholder":"e.g. hello@symbo.ls","auth.signup.failed":"Failed to create account","auth.signup.github":"Continue with GitHub","auth.signup.google":"Continue with Google","auth.signup.haveAccount.link":"Sign in","auth.signup.haveAccount.prompt":"Already have an account?","auth.signup.heading":"Create your Symbols account","auth.signup.headingNamed":"Create your {name} account","auth.signup.headingNeutral":"Create your account","auth.signup.invite.bound":"Create your account to join. The invited email is already set.","auth.signup.invite.boundNamed":"{name} invited you. Create your account to join. The invited email is already set.","auth.signup.invite.link":"Create your account with any email to join.","auth.signup.invite.linkNamed":"{name} invited you. Create your account with any email to join.","auth.signup.inviteReady.message":"Sign in to open your invitation.","auth.signup.inviteReady.messageSignedIn":"Continue to open your invitation.","auth.signup.inviteReady.title":"Your account is ready","auth.signup.inviteReady.verify":"We sent a link to verify your email. Verify it, then sign in to join.","auth.signup.inviteReady.verifySignedIn":"We sent a link to verify your email. Verify it, then join.","auth.signup.legal.newTab":"opens in a new tab","auth.signup.legal.privacy":"Privacy policy","auth.signup.legal.privacyHref":"https://symbols.app/privacy","auth.signup.legal.terms":"Terms of Service","auth.signup.legal.termsHref":"https://symbols.app/terms","auth.signup.missingFields.message":"Name, email, and password are all required.","auth.signup.missingFields.title":"Missing fields","auth.signup.name":"Full name","auth.signup.namePlaceholder":"e.g. Mike","auth.signup.notSent.message":"We could not send the confirmation email to {email}. Your account is ready: continue to sign in.","auth.signup.notSent.messageSignedIn":"We could not send the confirmation email to {email}. Your account is ready.","auth.signup.notSent.title":"Your account is ready","auth.signup.password":"Password","auth.signup.passwordRule.digit":"A number","auth.signup.passwordRule.failed":"That password does not meet the rule. Change it and try again.","auth.signup.passwordRule.length":"At least {count} characters","auth.signup.passwordRule.lower":"A lowercase letter","auth.signup.passwordRule.met":"met","auth.signup.passwordRule.special":"One of {chars}","auth.signup.passwordRule.text":"Use at least 8 characters, with a lowercase letter, an uppercase letter, a number and one of @ $ ! % * ? &.","auth.signup.passwordRule.unmet":"not met","auth.signup.passwordRule.upper":"An uppercase letter","auth.signup.resend.action":"Send the email again","auth.signup.resend.failed":"We could not send it again. Try again in a minute.","auth.signup.resend.sent":"Sent again to {email}.","auth.signup.resend.wait":"Send again in {seconds} s","auth.signup.submit":"Sign up","auth.waitlist.body":"You\'re joining the waitlist. Knowing your preferences helps us customize your invitation.","auth.waitlist.emailPlaceholder":"Email","auth.waitlist.heading":"Get early access","auth.waitlist.namePlaceholder":"Name","auth.waitlist.submit":"Sign up to waitlist","auth.waitlistInvite.opening":"Opening signup\u2026","auth.whitelabel.alreadyInvited":"You already have an invitation \u2014 check your inbox, including spam.","auth.whitelabel.captchaDown":"Verification is temporarily unavailable. Please try again shortly.","auth.whitelabel.demo.hint":"Jump into a seeded workspace \u2014 no password needed.","auth.whitelabel.demo.note":"Demo logins are seeded accounts for evaluation.","auth.whitelabel.demo.title":"Quick access (demo)","auth.whitelabel.email":"Email","auth.whitelabel.emailPlaceholder":"e.g. you@example.com","auth.whitelabel.genericError":"Something went wrong. Please try again.","auth.whitelabel.google":"Continue with Google","auth.whitelabel.googleFailed":"Google sign-in failed.","auth.whitelabel.googleUnavailable":"Google sign-in is unavailable right now.","auth.whitelabel.head.login":"Log in","auth.whitelabel.head.signup":"Create your account","auth.whitelabel.head.signupBranded":"Create your {brand} account","auth.whitelabel.inbox":"Check your inbox \u2014 we have sent you your workspace invitation.","auth.whitelabel.inboxBranded":"Check your inbox \u2014 we have sent you an invitation to the {brand} workspace.","auth.whitelabel.needCaptcha":"Please complete the verification below and try again.","auth.whitelabel.needCredentials":"Enter your email and password.","auth.whitelabel.needEmail":"Please enter a valid email address.","auth.whitelabel.needName":"Please enter your name.","auth.whitelabel.needRole":"Please choose how you work with the team.","auth.whitelabel.needValidOption":"Please choose a valid option.","auth.whitelabel.networkError":"Network error. Please try again.","auth.whitelabel.or":"or","auth.whitelabel.password":"Password","auth.whitelabel.persona.aria":"Sign in as {name}","auth.whitelabel.request.email":"Work email","auth.whitelabel.request.name":"Your name","auth.whitelabel.request.namePlaceholder":"Jane Dupont","auth.whitelabel.request.note":"We review every request. If it is a fit you will receive an invitation by email.","auth.whitelabel.request.role":"How do you work with the team?","auth.whitelabel.request.sending":"Sending\u2026","auth.whitelabel.request.submit":"Request an invitation","auth.whitelabel.requestReceived":"Request received. The team will be in touch by email.","auth.whitelabel.role.aria":"Account type: {name}","auth.whitelabel.signinFailed":"Sign in failed. Check your details.","auth.whitelabel.signinUnavailable":"That sign-in is not available.","auth.whitelabel.signingIn":"Signing in\u2026","auth.whitelabel.signupSoon":"Sign-up opens shortly \u2014 in the meantime, reach the team and they will set you up.","auth.whitelabel.signupUnavailable":"Sign-up is not available right now.","auth.whitelabel.sub.login":"Use your account to continue.","auth.whitelabel.sub.signup":"Start by choosing what kind of account this is \u2014 it decides which part of the programme opens for you.","auth.whitelabel.submit":"Log in","auth.whitelabel.switchToLogin":"Already have an account? Log in","auth.whitelabel.switchToSignup":"New here? Create an account","auth.whitelabel.tooMany":"Too many requests. Please try again shortly.","auth.whitelabel.unavailable":"Unavailable.","auth.whitelabel.wordmarkFallback":"Sign in"}');

});

parcelRegister("kNsK2", function(module, exports) {
module.exports = JSON.parse('{"calendar.addTeammates.alreadyIn":"{name} is already in Team","calendar.addTeammates.cancel":"Cancel","calendar.addTeammates.close":"Close add teammates","calendar.addTeammates.enterQuery":"Enter a nickname or email","calendar.addTeammates.heading":"Add teammates","calendar.addTeammates.label":"Teammate","calendar.addTeammates.noMatch":"No matching teammate found","calendar.addTeammates.pickMatch":"Select a teammate from the matches","calendar.addTeammates.placeholder":"Nickname or email","calendar.addTeammates.submit":"Add teammate","calendar.addTeammates.subtitle":"Search the workspace directory by nickname or email","calendar.addTeammates.thisTeammate":"This teammate","calendar.addTeammates.unnamed":"Unnamed teammate","calendar.agenda.allDay":"All day","calendar.agenda.empty":"No events in these days.","calendar.agenda.title":"Agenda","calendar.agenda.untitled":"Untitled event","calendar.agenda.who.me":"my events","calendar.agenda.who.team":"the team","calendar.aiForm.field.date":"Date","calendar.aiForm.field.description":"Description","calendar.aiForm.field.end":"Ends","calendar.aiForm.field.invitees":"Invitees","calendar.aiForm.field.start":"Starts","calendar.aiForm.field.title":"Title","calendar.aiForm.title":"Event","calendar.booking.close":"Close","calendar.booking.defaultTitle":"New event","calendar.booking.deleteEvent":"Delete event","calendar.booking.descriptionPlaceholder":"Optional notes","calendar.booking.endRepeat":"End repeat","calendar.booking.fieldStartDate":"Start Date","calendar.booking.fieldEndDate":"End Date","calendar.booking.fieldDescription":"Description","calendar.booking.fieldEnd":"End","calendar.booking.fieldInvitees":"Invitees","calendar.booking.fieldMeetingUrl":"Meeting URL","calendar.booking.fieldReminder":"Reminder","calendar.booking.fieldRepeat":"Repeat","calendar.booking.fieldStart":"Start","calendar.booking.fieldTitle":"Title","calendar.booking.headingEdit":"Edit Booking","calendar.booking.headingNew":"New Booking","calendar.booking.inviteesPlaceholder":"Type a name\u2026","calendar.booking.moveBody":"Update the time directly, or propose the change and wait for participants to confirm.","calendar.booking.moveCancel":"Cancel","calendar.booking.moveHeading":"This event has participants","calendar.booking.moveOrganizerOnly":"Only the organizer can move this event.","calendar.booking.movePropose":"Propose","calendar.booking.moveUpdate":"Update","calendar.booking.save":"Save","calendar.booking.scopeAll":"All events in series","calendar.booking.scopeCancel":"Cancel","calendar.booking.scopeFuture":"This and future events","calendar.booking.scopeHeading":"Edit recurring event","calendar.booking.scopeSubtitle":"Apply changes to:","calendar.booking.scopeThis":"This event only","calendar.booking.subtitleEdit":"Update the meeting time, attendees, or description","calendar.booking.subtitleNew":"Schedule a meeting and invite teammates","calendar.booking.titlePlaceholder":"Add a title","calendar.booking.unavailable":"Unavailable","calendar.booking.update":"Update","calendar.booking.urlPlaceholder":"Paste Zoom, Google Meet, or other link","calendar.day.fri":"Fri","calendar.day.mon":"Mon","calendar.day.sat":"Sat","calendar.day.sun":"Sun","calendar.day.thu":"Thu","calendar.day.tue":"Tue","calendar.day.wed":"Wed","calendar.dayInitial.fri":"F","calendar.dayInitial.mon":"M","calendar.dayInitial.sat":"S","calendar.dayInitial.sun":"S","calendar.dayInitial.thu":"T","calendar.dayInitial.tue":"T","calendar.dayInitial.wed":"W","calendar.delete.allFuture":"Delete all future events","calendar.delete.bodyRecurring":"Choose which occurrences to delete. Deleted occurrences cannot be restored.","calendar.delete.bodySeries":"This permanently removes the event and all its occurrences","calendar.delete.bodySingle":"This permanently removes the event from the calendar","calendar.delete.confirm":"Delete","calendar.delete.confirmTitle":"Delete \u201C{title}\u201D?","calendar.delete.eventFallback":"event","calendar.delete.failedMessage":"The event could not be deleted \u2014 reopen it and try again.","calendar.delete.failedTitle":"Event not deleted","calendar.delete.onlyThis":"Delete only this event","calendar.delete.recurringTitle":"Delete the recurring event \u201C{title}\u201D?","calendar.detail.accept":"Accept","calendar.detail.askAi":"Ask AI","calendar.detail.callFailedMessage":"Meet room creation failed. Check your connection or try again.","calendar.detail.callFailedTitle":"Could not start call","calendar.detail.callName":"Calendar call","calendar.detail.createdBy":"Created by {name}","calendar.detail.decline":"Decline","calendar.detail.delete":"Delete event","calendar.detail.edit":"Edit event","calendar.detail.eventFallback":"Event","calendar.detail.going":"Going?","calendar.detail.joinCall":"Join call","calendar.detail.notFoundMessage":"The event was deleted, or you do not have access to it.","calendar.detail.notFoundTitle":"Event not found","calendar.detail.privateTitle":"Meeting","calendar.detail.proposedBy":"Proposed by {name} \u2014 awaiting confirmation","calendar.detail.proposedByFallback":"a participant","calendar.detail.rsvpMaybe":"Maybe","calendar.detail.rsvpNo":"No","calendar.detail.rsvpYes":"Yes","calendar.detail.restoreFailedMessage":"The event details could not be restored. Close the dialog and open the event again.","calendar.detail.restoreFailedTitle":"Event details unavailable","calendar.event.untitled":"Untitled event","calendar.header.addTeammates":"Add teammates","calendar.header.calendar":"Calendar","calendar.header.newBooking":"New booking","calendar.header.nextDay":"Next day","calendar.header.nextMonth":"Next month","calendar.header.nextWeek":"Next week","calendar.header.prevDay":"Previous day","calendar.header.prevMonth":"Previous month","calendar.header.prevWeek":"Previous week","calendar.header.railAria":"Open the calendar rail","calendar.header.railTooltip":"Mini month and people","calendar.header.resync":"Resync from Google","calendar.header.today":"Today","calendar.mini.nextMonth":"Next month","calendar.mini.prevMonth":"Previous month","calendar.mode.externalUrl":"External URL","calendar.mode.offline":"Offline","calendar.mode.symbolsMeet":"Symbols Meet","calendar.month.april":"April","calendar.month.august":"August","calendar.month.december":"December","calendar.month.february":"February","calendar.month.january":"January","calendar.month.july":"July","calendar.month.june":"June","calendar.month.march":"March","calendar.month.may":"May","calendar.month.november":"November","calendar.month.october":"October","calendar.month.september":"September","calendar.monthView.days":"Days","calendar.monthView.events":"Events","calendar.page.calendar.title":"Calendar","calendar.profile.availabilityHeading":"General availability","calendar.profile.displayNameLabel":"Display name","calendar.profile.displayNamePlaceholder":"Your name","calendar.profile.fieldGithub":"GitHub","calendar.profile.fieldLocalTime":"Local time","calendar.profile.fieldLocation":"Location","calendar.profile.fieldPosition":"Position","calendar.profile.fieldRole":"Role","calendar.profile.fieldTeam":"Team","calendar.profile.fieldTenure":"Tenure","calendar.profile.githubLabel":"GitHub username","calendar.profile.githubPlaceholder":"e.g. nikoloza","calendar.profile.heading":"Profile","calendar.profile.hintReadOnly":"Read only","calendar.profile.hintToggle":"Click to toggle","calendar.profile.hintToggleAdmin":"Click to toggle (admin)","calendar.profile.locationLabel":"Location","calendar.profile.locationPlaceholder":"City, Country","calendar.profile.message":"Message","calendar.profile.noAvailability":"No availability set","calendar.profile.noTitle":"(no title)","calendar.profile.openProfile":"Open profile","calendar.profile.positionLabel":"Position / Title","calendar.profile.positionPlaceholder":"e.g. Frontend Engineer","calendar.profile.summary.availableNow":"Available now","calendar.profile.summary.nextAvailable":"Next available {day} {time}","calendar.profile.summary.noHours":"No available hours set","calendar.profile.summary.until":"until {time}","calendar.profile.summary.weeklyHours":"{hours} hr/w","calendar.profile.tabAvailability":"Availability","calendar.profile.tabProfile":"Profile","calendar.profile.tabSettings":"Settings","calendar.profile.teamLabel":"Team","calendar.profile.tenureNew":"New","calendar.profile.timezoneLabel":"Timezone (IANA)","calendar.profile.timezonePlaceholder":"Select timezone\u2026","calendar.profile.weeklyHoursLabel":"Weekly hours (auto from grid)","calendar.proposal.acceptMessage":"\u201C{title}\u201D moves to the new time for everyone invited. Connected calendars update too.","calendar.proposal.acceptTitle":"Accept the proposed time?","calendar.proposal.declineMessage":"The proposal is deleted. \u201C{title}\u201D keeps its current time.","calendar.proposal.declineTitle":"Decline the proposed time?","calendar.quick.fieldTitle":"Title","calendar.quick.moreOptions":"More options","calendar.quick.save":"Save","calendar.quick.titlePlaceholder":"Add a title","calendar.reminder.day1":"1 day before","calendar.reminder.hour1":"1 hour before","calendar.reminder.hour12":"12 hours before","calendar.reminder.hour4":"4 hours before","calendar.reminder.hour8":"8 hours before","calendar.reminder.min10":"10 minutes before","calendar.reminder.min15":"15 minutes before","calendar.reminder.min30":"30 minutes before","calendar.reminder.min5":"5 minutes before","calendar.reminder.none":"No reminder","calendar.rsvp.scopeCancel":"Cancel","calendar.rsvp.scopeFuture":"All future occurrences","calendar.rsvp.scopeHeading":"Apply RSVP response","calendar.rsvp.scopeSubtitle":"Choose which occurrences this response applies to.","calendar.rsvp.scopeThis":"This occurrence","calendar.repeat.biweekly":"Every 2 weeks","calendar.repeat.daily":"Daily","calendar.repeat.endAfter":"After","calendar.repeat.endOn":"On date","calendar.repeat.monthly":"Monthly","calendar.repeat.never":"Never","calendar.repeat.occurrenceMany":"occurrences","calendar.repeat.occurrenceOne":"occurrence","calendar.repeat.weekly":"Weekly","calendar.repeat.yearly":"Yearly","calendar.save.failedMessage":"The change could not be saved \u2014 reopen the event and try again.","calendar.save.failedTitle":"Event not saved","calendar.save.invalidRangeMessage":"Choose an end date and time after the event starts.","calendar.save.invalidRangeTitle":"End must be after start","calendar.save.pastMessage":"Choose a time from now onward and try again.","calendar.save.pastTitle":"Booking starts in the past","calendar.sidebar.advisors":"ADVISORS","calendar.sidebar.investors":"INVESTORS","calendar.sidebar.navLabel":"Calendar","calendar.sidebar.railLabel":"Calendar","calendar.sidebar.team":"TEAM","calendar.team.hideColumn":"Hide column","calendar.type.busy":"Unavailable","calendar.type.general":"Company event","calendar.type.meeting":"Meeting","calendar.view.day":"Day","calendar.view.month":"Month","calendar.view.team":"Team","calendar.view.teamNow":"Team Now","calendar.view.week":"Week","calendar.week.backToMine":"Back to my week","calendar.week.viewingOther":"Viewing {name}\'s week"}');

});

parcelRegister("9nKSP", function(module, exports) {
module.exports = JSON.parse('{"canvas.a11y.skipToMain":"Skip to main content","canvas.account.backToDashboard":"\u2190 Dashboard","canvas.account.changesSaved":"Changes saved.","canvas.account.currentPassword":"Current password","canvas.account.emailAddress":"Email address","canvas.account.fullName":"Full name","canvas.account.fullNamePlaceholder":"Your name","canvas.account.heading":"Account","canvas.account.newPassword":"New password","canvas.account.passwordFailed":"Failed to change password","canvas.account.passwordSection":"Change password","canvas.account.passwordUpdated":"Password updated.","canvas.account.profileSection":"Profile","canvas.account.saveChanges":"Save changes","canvas.account.saveFailed":"Failed to save changes","canvas.account.saving":"Saving\u2026","canvas.account.signOut":"Sign out","canvas.account.signOutHint":"Sign out of your account on this device.","canvas.account.signOutSection":"Sign out","canvas.account.subtitle":"Manage your profile and account settings.","canvas.account.updatePassword":"Update password","canvas.account.updating":"Updating\u2026","canvas.addPagePicker.cancel":"Cancel","canvas.addPagePicker.componentHint":"A reusable component key is derived from the name.","canvas.addPagePicker.componentKey":"Component key: {key}","canvas.addPagePicker.route":"Route: /{route}","canvas.addPagePicker.routeHint":"Route is derived from the name (e.g. About \u2192 /about).","canvas.answer.title":"Websites","canvas.answer.empty":"No websites match.","canvas.answer.failed":"Could not load the projects.","canvas.answer.more":"{n} of {total} projects, newest first","canvas.answer.action.preview":"Preview {name}","canvas.answer.action.previewOf":"Preview {name} live","canvas.answer.action.canvas":"Open the canvas of {name}","canvas.answer.action.analytics":"Analytics of {name}","canvas.status.title":"Website status","canvas.status.none":"This workspace has no website yet.","canvas.status.missing":"No website in this workspace matches.","canvas.status.notWebsite":"{name} is not a website. This card shows websites.","canvas.status.storeApp":"{name} is an app from the App Store, not a project of this workspace. This card shows websites.","canvas.status.more":"{n} of {total} websites","canvas.status.openSite":"{name}: environments and versions","canvas.status.back":"All websites","canvas.status.versions":"Recent versions","canvas.status.live.checking":"Checking\u2026","canvas.status.live.live":"Live","canvas.status.live.unavailable":"Not available","canvas.status.live.unknown":"Could not check","canvas.status.live.never":"Never published","canvas.status.env.off":"Off","canvas.status.env.published":"Published release","canvas.status.env.version":"Version {value}","canvas.status.env.branch":"Branch {value}","canvas.status.env.latest":"Latest of {value}","canvas.status.env.never":"Never published","canvas.studioEdge.library.title":"Disconnect \u201C{library}\u201D?","canvas.studioEdge.library.message":"\u201C{project}\u201D will stop using this library. The components it takes from \u201C{library}\u201D will stop resolving.","canvas.studioEdge.library.confirm":"Disconnect","canvas.studioEdge.integration.title":"Remove \u201C{integration}\u201D from \u201C{project}\u201D?","canvas.studioEdge.integration.message":"The integration moves to organization scope and stops being specific to \u201C{project}\u201D.","canvas.studioEdge.integration.confirm":"Remove","canvas.boardMenu.new.aria":"New \u2014 create a project, library, integration and more","canvas.boardMenu.new.label":"New","canvas.boardPage.contextMenu.delete":"Delete","canvas.boardPage.contextMenu.rename":"Rename","canvas.boardPage.defaultName":"Page {n}","canvas.boardPage.delete.title":"Delete page \u201C{name}\u201D?","canvas.boardPage.delete.untitled":"Untitled","canvas.boardPage.delete.messageEmpty":"The page will be deleted. This can\u2019t be undone.","canvas.boardPage.delete.messageOne":"The page and the 1 tile on it will be deleted. This can\u2019t be undone.","canvas.boardPage.delete.messageMany":"The page and the {count} tiles on it will be deleted. This can\u2019t be undone.","canvas.codeEditor.close":"Close code editor","canvas.contextMenu.autoLayout":"Auto-layout","canvas.contextMenu.delete":"Delete","canvas.contextMenu.deletePage":"Delete page","canvas.contextMenu.deleteComponent":"Delete component","canvas.contextMenu.deleteVariation":"Delete variation","canvas.contextMenu.duplicate":"Duplicate","canvas.contextMenu.group":"Group","canvas.contextMenu.new":"New","canvas.contextMenu.newComponent":"Component","canvas.contextMenu.newIntegration":"Integration","canvas.contextMenu.newPage":"Page","canvas.contextMenu.newSharedLibrary":"Shared library","canvas.contextMenu.resetView":"Reset view","canvas.contextMenu.selectAll":"Select all","canvas.contextMenu.ungroup":"Ungroup","canvas.contextMenu.versionHistory":"Version history","canvas.dashboard.allWorkspaces":"All workspaces","canvas.dashboard.deselect":"Deselect","canvas.dashboard.help.clickCard":"Click a project card to open it.","canvas.dashboard.help.rightClick":"Right-click the canvas for options.","canvas.dashboard.kind.all":"Browse all","canvas.dashboard.kind.integration":"Integrations","canvas.dashboard.kind.library":"Libraries","canvas.dashboard.kind.plugin":"Plugins","canvas.dashboard.kind.registrar":"Domain Registrars","canvas.dashboard.kind.template":"Templates","canvas.dashboard.marketplace":"Marketplace","canvas.dashboard.newOrganization":"New organization","canvas.dashboard.noMembers":"No members yet","canvas.dashboard.openWorkspace":"Open workspace \u2192","canvas.dashboard.rail.featuredTemplates":"Featured templates","canvas.dashboard.rail.integrationsEmpty":"Add an integration available to your whole organization","canvas.dashboard.rail.templatesEmpty":"Browse and pin templates for quick access","canvas.dashboard.toggleWorkspaces":"Toggle workspaces","canvas.dashboard.workspaceDefault":"default","canvas.dashboard.workspaces":"Workspaces","canvas.deleteProject.body":"This action cannot be undone. Type the project key below to confirm deletion.","canvas.deleteProject.cancel":"Cancel","canvas.deleteProject.confirm":"Delete project","canvas.deleteProject.confirmLabel":"Type \\"{key}\\" to confirm:","canvas.deleteProject.failed":"The project was not deleted. Try again.","canvas.deleteProject.inputAria":"Confirm project key","canvas.deleteProject.title":"Delete \\"{name}\\"?","canvas.duplicateProject.body":"Pick a name and key for the copy.","canvas.duplicateProject.cancel":"Cancel","canvas.duplicateProject.error.failed":"Duplicate failed.","canvas.duplicateProject.error.keyRequired":"Key is required.","canvas.duplicateProject.error.unsupported":"Duplicate not supported by this SDK version.","canvas.duplicateProject.fallbackName":"project","canvas.duplicateProject.keyAria":"New project key","canvas.duplicateProject.keyLabel":"New project key (slug)","canvas.duplicateProject.nameLabel":"New project name","canvas.duplicateProject.namePlaceholder":"Copy of {name}","canvas.duplicateProject.submit":"Duplicate","canvas.duplicateProject.submitBusy":"Duplicating\u2026","canvas.duplicateProject.title":"Duplicate \\"{name}\\"","canvas.editMetadata.body":"Rename the project or change its key.","canvas.editMetadata.cancel":"Cancel","canvas.editMetadata.error.failed":"Save failed.","canvas.editMetadata.error.required":"Name and key are required.","canvas.editMetadata.error.unsupported":"Update not supported by this SDK version.","canvas.editMetadata.keyAria":"Project key","canvas.editMetadata.keyLabel":"Project key (slug)","canvas.editMetadata.nameLabel":"Project name","canvas.editMetadata.namePlaceholder":"My project","canvas.editMetadata.save":"Save","canvas.editMetadata.saveBusy":"Saving\u2026","canvas.editMetadata.title":"Edit project metadata","canvas.entity.comments":"Comments","canvas.entity.dataItem.hint":"Put a record, document, email or ticket on this board.","canvas.entity.dataItem.label":"Data item","canvas.entity.expand":"Expand","canvas.entity.group.items":"Items","canvas.entity.loadFailed":"This item could not be loaded.","canvas.entity.makeVariation":"Make variation","canvas.entity.picker.empty":"Nothing matched that search.","canvas.entity.picker.placeholder":"Search records, documents, email\u2026","canvas.entity.picker.subtitle":"Search the workspace and place the result on this board.","canvas.entity.picker.title":"Add data item","canvas.entity.sample":"Sample","canvas.entity.untitled":"Untitled","canvas.entity.variation.bodyLabel":"Body","canvas.entity.variation.deleteMessage":"The variation record is deleted for everyone in this workspace, together with its tile on every board page. This can\u2019t be undone.","canvas.entity.variation.deleteTitle":"Delete variation \u201C{name}\u201D?","canvas.entity.variation.rationaleLabel":"Rationale","canvas.entity.variation.title":"{title} (variation)","canvas.entity.variation.titleLabel":"Title","canvas.groupLabel.renameTitle":"Double-click to rename \u2014 saves on blur or Enter","canvas.header.account":"Account","canvas.header.marketplace":"Marketplace","canvas.integrationPicker.cancel":"Cancel","canvas.integrationPicker.error.noOrgId":"No org id for {slug}","canvas.integrationPicker.error.pickProject":"Pick a project for project scope","canvas.integrationPicker.field.displayName":"Display name","canvas.integrationPicker.field.displayNamePlaceholder":"Human-readable label","canvas.integrationPicker.field.secret":"Secret","canvas.integrationPicker.field.slug":"Slug","canvas.integrationPicker.field.slugHint":"Unique within scope.","canvas.integrationPicker.field.slugPlaceholder":"default","canvas.integrationPicker.scope":"Scope","canvas.integrationPicker.scopeOrg":"Org","canvas.integrationPicker.scopeProject":"Project","canvas.integrationPicker.scopeWorkspace":"Workspace","canvas.integrationPicker.searchPlaceholder":"Search integrations\u2026","canvas.lab.welcome.body":"Start by creating a new app \u2014 or pin an existing project from your dashboard. You can also install integrations, MCP connectors, libraries, and plugins as draggable tiles.","canvas.lab.welcome.cta":"+ Create your new app","canvas.lab.welcome.secondary":"or install an integration","canvas.lab.welcome.title":"Welcome to your lab","canvas.lazyPage.loadFailed":"Couldn\u2019t load this page. Refresh to try again.","canvas.libraryPicker.empty":"No libraries found.","canvas.libraryPicker.searchPlaceholder":"Search libraries\u2026","canvas.libraryPicker.subtitle":"Search public libraries or projects in your orgs.","canvas.libraryPicker.title":"Import library","canvas.marketplace.installIncompleteMessage":"The \\"{name}\\" tile was placed on the canvas, but the install dispatch did not complete ({error}). Reopen the marketplace card to retry.","canvas.marketplace.installIncompleteTitle":"Marketplace install incomplete","canvas.marketplace.unknownError":"unknown error","canvas.mcp.cancel":"Cancel","canvas.mcp.connect":"Connect","canvas.mcp.connected":"Connected {name}","canvas.mcp.connecting":"Connecting\u2026","canvas.mcp.error.connectFailedTitle":"Connect failed","canvas.mcp.error.unknown":"Unknown error","canvas.mcp.error.urlRequiredMessage":"Enter the MCP server URL.","canvas.mcp.error.urlRequiredTitle":"URL required","canvas.mcp.field.auth":"Authentication","canvas.mcp.field.name":"Name","canvas.mcp.field.namePlaceholder":"e.g. Symbols MCP","canvas.mcp.field.transport":"Transport","canvas.mcp.field.url":"Server URL","canvas.mcp.subtitle":"Connect an MCP server (tools, resources).","canvas.mcp.suggest.label":"Connect Symbols MCP","canvas.mcp.suggest.title":"Connect Symbols MCP \u2014 pre-fills URL and name","canvas.mcp.title":"New MCP connector","canvas.mcpChip.title":"MCP connector: {name}","canvas.mcpChip.disabled":"Disabled","canvas.mcpChip.live":"Live","canvas.minimizedDock.close":"Close","canvas.minimizedDock.closeAria":"Close minimized app","canvas.mode.inspect":"Inspect","canvas.mode.interact":"Interact","canvas.mode.move":"Move","canvas.mode.pan":"Pan","canvas.navbar.actions.aria":"Canvas actions menu","canvas.navbar.actions.title":"Canvas actions","canvas.navbar.env.devAria":"Development environment","canvas.navbar.env.devTitle":"Switch to development environment","canvas.navbar.env.eyebrow":"ENV","canvas.navbar.env.prodAria":"Production environment","canvas.navbar.env.prodTitle":"Switch to production environment","canvas.navbar.env.stagingAria":"Staging environment","canvas.navbar.env.stagingTitle":"Switch to staging environment","canvas.navbar.members.aria":"Project members","canvas.navbar.members.empty":"No members loaded.","canvas.navbar.members.invite":"+ Invite","canvas.navbar.members.panelTitle":"Members","canvas.navbar.members.title":"Members","canvas.navbar.mode.default":"Default mode","canvas.navbar.mode.eyebrow":"MODE","canvas.navbar.mode.inspect":"Inspect mode","canvas.navbar.mode.pan":"Pan mode","canvas.navbar.pages.close":"Close","canvas.navbar.pages.default":"Default","canvas.navbar.pages.eyebrow":"PAGE","canvas.navbar.pages.panelTitle":"Pages","canvas.navbar.pages.title":"Switch canvas page","canvas.navbar.redo":"Redo  \u2318\u21E7Z","canvas.navbar.search":"Search  \u2318K","canvas.navbar.share.copied":"Copied!","canvas.navbar.share.copy":"Copy","canvas.navbar.share.copyFailedMessage":"Please copy the URL manually.","canvas.navbar.share.copyFailedTitle":"Copy failed","canvas.navbar.share.panelTitle":"Share","canvas.navbar.share.title":"Share project","canvas.navbar.undo":"Undo  \u2318Z","canvas.navbar.versionHistory":"Version history","canvas.newProject.cancel":"Cancel","canvas.newProject.error.nameRequired":"Please enter a project name.","canvas.newProject.error.noOrg":"Could not resolve org for this workspace.","canvas.newProject.error.noSdk":"SDK not available.","canvas.newProject.error.pickSource":"Select a project to scaffold from.","canvas.newProject.nameLabel":"Project name","canvas.newProject.namePlaceholder":"My project\u2026","canvas.newProject.subtitle":"Pick a template and name your project. You publish it to the web.","canvas.newProject.templateApp.hint":"Web app scaffold \u2014 dashboard, settings, auth","canvas.newProject.templateApp.label":"Desktop & Web app","canvas.newProject.templateBlank.hint":"A simple Hello world component","canvas.newProject.templateBlank.label":"Blank","canvas.newProject.templateDeck.hint":"Slide deck sourced from commercials/deck","canvas.newProject.templateDeck.label":"Presentation","canvas.newProject.templateLibrary.hint":"Shared component library for your workspace","canvas.newProject.templateLibrary.label":"Library","canvas.newProject.templateMobile.hint":"Native mobile app scaffold \u2014 home, settings","canvas.newProject.templateMobile.label":"Mobile App","canvas.newProject.templateService.hint":"Backend service scaffold \u2014 API endpoints + health","canvas.newProject.templateService.label":"Service","canvas.newProject.title":"New project","canvas.notFound.backToDashboard":"Back to dashboard","canvas.notFound.retry":"Retry","canvas.notFound.signIn":"Sign in","canvas.page.account.title":"Account / Symbols.app","canvas.page.agents.title":"Agents","canvas.page.dashboard.title":"Dashboard / Symbols.app","canvas.page.marketplace.title":"Marketplace / Symbols.app","canvas.page.myAgents.title":"My agents","canvas.page.notFound.title":"Not found / Symbols.app","canvas.page.resetPassword.title":"Reset password / Symbols.app","canvas.page.sessionBridge.title":"Session bridge \xb7 Symbols","canvas.page.signin.title":"Sign in / Symbols.app","canvas.page.signup.title":"Sign up / Symbols.app","canvas.page.signupConfirmation.title":"Confirm email / Symbols.app","canvas.page.teamAndAgents.title":"Team & agents","canvas.page.waitlist.title":"Waitlist / Symbols.app","canvas.page.workspaces.fallbackName":"Workspace","canvas.page.workspaces.fallbackTitle":"Workspaces / Symbols.app","canvas.page.workspaces.title":"{name} \xb7 Workspaces / Symbols.app","canvas.pageSlot.addToWorkspace":"Add to Workspace","canvas.pageSlot.apps":"Apps","canvas.pageSlot.appsSidebar":"Apps sidebar","canvas.pageSlot.appsSidebarAria":"Toggle apps sidebar","canvas.pageSlot.back":"Back","canvas.pageSlot.close":"Close","canvas.pageSlot.forward":"Forward","canvas.pageSlot.keepPane":"Keep this pane open","canvas.pageSlot.minimize":"Minimize","canvas.pageSlot.newPane":"New pane","canvas.pageSlot.openAsFullPage":"Open as full page","canvas.pageSlot.placeholder.heading":"Choose an app for this pane","canvas.pageSlot.placeholder.hint":"Pick any app from the launcher to open it here, beside the current one.","canvas.pageSlot.saveAsApp":"Save as app","canvas.pageSlot.sidebarHide":"Hide sidebar","canvas.pageSlot.sidebarShow":"Show sidebar","canvas.pageSlot.toggleFullscreen":"Toggle fullscreen","canvas.pageSlot.resizeWindow":"Resize window","canvas.pageSlot.fullscreenEnter":"Full screen","canvas.pageSlot.fullscreenExit":"Exit full screen","canvas.projectMenu.aria":"Project options","canvas.projectMenu.copyUrl.label":"Copy URL","canvas.projectMenu.delete.label":"Delete project","canvas.projectMenu.directDev.label":"Direct (dev)","canvas.projectMenu.directDev.title":"Opens the dev subdomain URL","canvas.projectMenu.directProd.label":"Direct (prod)","canvas.projectMenu.directProd.title":"Opens the production subdomain URL","canvas.projectMenu.duplicate.label":"Duplicate\u2026","canvas.projectMenu.editMetadata.label":"Edit metadata\u2026","canvas.projectMenu.importLibrary.aria":"Import Library \u2014 link a shared component library","canvas.projectMenu.importLibrary.label":"Import Library\u2026","canvas.projectMenu.importLibrary.title":"Link a shared library to this project","canvas.projectMenu.openInApp.label":"Open in App","canvas.projectMenu.openInAppEnv.label":"Open in App (env)","canvas.projectMenu.openInAppEnv.title":"Open in the canvas editor pinned to this environment","canvas.projectMenu.openPreview.label":"Open Preview","canvas.projectMenu.openPreview.title":"Opens the preview URL for this project","canvas.projectMenu.publish.label":"Publish","canvas.projectMenu.refetchScreenshot.aria":"Refetch screenshot \u2014 recapture this project and reload the tile","canvas.projectMenu.refetchScreenshot.label":"Refetch screenshot","canvas.projectMenu.refetchScreenshot.title":"Recapture on the server, then reload the tile in place","canvas.projectMenu.section.danger":"Danger","canvas.projectMenu.section.integrations":"Integrations","canvas.projectMenu.section.manage":"Manage","canvas.projectMenu.section.open":"Open","canvas.projectMenu.settings.label":"Settings\u2026","canvas.projectMenu.versionHistory.label":"Version history","canvas.projectNavbar.addComponent.hint":"Create a new reusable component.","canvas.projectNavbar.addComponent.label":"Component","canvas.projectNavbar.addIntegration.hint":"Connect a service (Supabase, GitHub, \u2026).","canvas.projectNavbar.addIntegration.label":"Integration","canvas.projectNavbar.addPage.hint":"Create a new page in this project.","canvas.projectNavbar.addPage.label":"Page","canvas.projectNavbar.addSharedLibrary.hint":"Import an existing project as a shared library.","canvas.projectNavbar.addSharedLibrary.label":"Shared library","canvas.projectNavbar.createAria":"Add to this project","canvas.projectNavbar.createTitle":"Create","canvas.projectNavbar.menuAria":"Add to this project\u2026","canvas.projectTile.moreOptions":"More options","canvas.projectTile.updated":"Edited {time}","canvas.prompt.aria":"AI assistant","canvas.prompt.attach.aria":"Add content","canvas.prompt.attach.armedTitle":"Build mode armed \u2014 open the menu to disarm","canvas.prompt.attach.buildApp":"Build app","canvas.prompt.attach.buildAppArmed":"Armed \u2014 sends build instead of answering","canvas.prompt.attach.buildAppHint":"Sends build or improve an app","canvas.prompt.attach.event":"Event","canvas.prompt.attach.heading":"Add content","canvas.prompt.attach.member":"Member","canvas.prompt.attach.note":"Note or doc","canvas.prompt.attach.photoOrFile":"Photo or file","canvas.prompt.attach.section":"Add section","canvas.prompt.attach.ticket":"Ticket","canvas.prompt.bridgeDown":"Run `smbls claude` in your project to build live.","canvas.prompt.collapseComposer":"Collapse composer","canvas.prompt.expandBar":"Expand prompt bar","canvas.prompt.expandComposer":"Expand composer","canvas.prompt.inspect":"Inspect mode","canvas.prompt.mention.channel":"Channels","canvas.prompt.mention.event":"Events","canvas.prompt.mention.person":"People","canvas.prompt.mention.reference":"Notes & docs","canvas.prompt.mention.ticket":"Tickets","canvas.prompt.mentionSuggestions":"Mention suggestions","canvas.prompt.minimizeBar":"Minimize prompt bar","canvas.prompt.openInSidebar":"Open in sidebar","canvas.prompt.reasoningAria":"Assistant reasoning","canvas.prompt.send":"Send prompt","canvas.prompt.thinking":"Thinking\u2026","canvas.prompt.uploadImage":"Upload image","canvas.prompt.voice":"Talk to the assistant \u2014 hold for a one-shot command","canvas.publish.changesTitle":"Changes to release","canvas.publish.checking":"Checking for changes\u2026","canvas.publish.noChanges":"No new changes to release.","canvas.publish.subtitle":"Release your latest changes to a live environment.","canvas.publish.title":"Publish project","canvas.publish.toStaging":"Publish to Staging","canvas.publish.toProduction":"Publish to Production","canvas.publish.publishing":"Publishing\u2026","canvas.publish.unavailable":"Publishing is not available here.","canvas.publish.failed":"Publish failed.","canvas.publish.confirm.title":"Publish \u201C{name}\u201D to Production?","canvas.publish.confirm.titlePlain":"Publish to Production?","canvas.publish.confirm.message":"Your latest changes go live on the production site, for every visitor.","canvas.publish.confirm.button":"Publish","canvas.record.page.deleteTitle":"Delete page \u201C{name}\u201D from the project?","canvas.record.page.deleteMessage":"The page is deleted for everyone, together with its tile on every board page. Earlier versions in Version history still include it.","canvas.record.component.deleteTitle":"Delete component \u201C{name}\u201D from the project?","canvas.record.component.deleteMessage":"The component is deleted for everyone, together with its tile on every board page. Pages that use it no longer show it. Earlier versions in Version history still include it.","canvas.record.deleteFailed":"Could not delete \u201C{name}\u201D.","canvas.remoteUpdate.dismiss":"Dismiss","canvas.remoteUpdate.message":"This project was updated \u2014 reload to see the latest.","canvas.remoteUpdate.reload":"Reload","canvas.repoPicker.add":"Add to canvas","canvas.repoPicker.error.invalidInput":"Enter owner/repo \u2014 e.g. symbo-ls/example","canvas.repoPicker.error.listFailed":"Could not list org repos","canvas.repoPicker.error.noOrg":"No active organization to list repos from","canvas.repoPicker.error.notFound":"Repository not found","canvas.repoPicker.find":"Find","canvas.repoPicker.inputPlaceholder":"owner/repo  \xb7  e.g. symbo-ls/example","canvas.repoPicker.orgEmpty":"No repos from the connected org (the GitHub App may not be installed yet). Use the Public tab to add any repo.","canvas.repoPicker.tab.org":"My org","canvas.repoPicker.tab.public":"Public repo","canvas.repoPicker.title":"Add a GitHub repository","canvas.repoTile.fallbackName":"repository","canvas.repoTile.private":"Private","canvas.repoTile.removeAria":"Remove {name} from board","canvas.repoTile.removeTitle":"Remove from board","canvas.scopeRail.addMcpConnector":"+ Add MCP connector","canvas.scopeRail.addWorkspaceIntegration":"+ Add workspace integration","canvas.scopeRail.org":"Org integrations","canvas.scopeRail.orgEmpty":"No org-wide integrations installed.","canvas.scopeRail.workspace":"Workspace","canvas.sessionBridge.body":"Session bridge. Hands off the canvas session to other Symbols subdomains.","canvas.settings.autoLayout.confirmButton":"Rearrange","canvas.settings.autoLayout.confirmMessage":"Every card on the board moves into a grid. Positions placed by hand change for everyone in this workspace. This can\u2019t be undone.","canvas.settings.autoLayout.confirmTitle":"Rearrange all cards?","canvas.settings.autoLayout.hint":"Rearranges all cards into a tidy grid and persists positions.","canvas.settings.autoLayout.label":"Auto layout","canvas.settings.autoLayout.run":"Run now","canvas.settings.cardPlacement.freeform":"Freeform","canvas.settings.cardPlacement.hint":"Freeform lets you drag cards out of columns and place them anywhere on the canvas.","canvas.settings.cardPlacement.inColumns":"In columns","canvas.settings.cardPlacement.label":"Card placement","canvas.settings.cardsPerRow.hint":"How many cards sit side-by-side in every board column.","canvas.settings.cardsPerRow.label":"Cards per row","canvas.settings.dragMode.free":"Free","canvas.settings.dragMode.grid":"Grid","canvas.settings.dragMode.hint":"Free lets you drop cards anywhere; Grid snaps to 24px increments.","canvas.settings.dragMode.label":"Drag mode","canvas.settings.excludedCols.hint":"Tickets in selected columns will not be included in the sidebar totals.","canvas.settings.excludedCols.label":"Exclude from counts","canvas.settings.hiddenCols.empty":"No hidden columns.","canvas.settings.hiddenCols.hint":"Columns hidden via the column \\"\u22EF\\" menu; bring them back here.","canvas.settings.hiddenCols.label":"Hidden columns","canvas.settings.hiddenCols.show":"Show","canvas.settings.projectScopeNote":"These apply to the project canvas \u2014 open a project to change them.","canvas.settings.showComponents.hint":"Seed the project\u2019s component frames onto the board. Off by default.","canvas.settings.showComponents.label":"Show components","canvas.settings.showDesignSystem.hint":"Seed the design-system frames onto the board. Off by default.","canvas.settings.showDesignSystem.label":"Show design system","canvas.settings.showMinimap.hint":"Miniature overview at the bottom-right of the canvas.","canvas.settings.showMinimap.label":"Show minimap","canvas.settings.showRulers.hint":"Screen-space rulers along the top and left edges.","canvas.settings.showRulers.label":"Show rulers","canvas.settings.snap.hint":"Master toggle for all snapping behaviours.","canvas.settings.snap.label":"Snap","canvas.settings.snapGrid.hint":"Pins drags to the canvas grid step.","canvas.settings.snapGrid.label":"Snap to grid","canvas.settings.snapGuides.hint":"Snaps drags onto user-placed rulers and guides.","canvas.settings.snapGuides.label":"Snap to guides","canvas.settings.snapItems.hint":"Pulls drags to other cards as they align.","canvas.settings.snapItems.label":"Snap to items","canvas.settings.subtitle":"Workspace and project canvas preferences.","canvas.settings.switchTitle":"Applies to the open project canvas","canvas.settings.tabProject.hint":"Canvas viewport, snap, grid and selection tools.","canvas.settings.tabProject.label":"Project","canvas.settings.tabTasks.hint":"Board columns, cards and layout.","canvas.settings.tabTasks.label":"Tasks","canvas.settings.tabWorkspace.hint":"Workspace-wide drag, layout and picker settings.","canvas.settings.tabWorkspace.label":"Workspace","canvas.settings.title":"Settings","canvas.shortcuts.autoLayout":"Auto-layout","canvas.shortcuts.clearClose":"Clear / close","canvas.shortcuts.close":"Close","canvas.shortcuts.delete":"Delete","canvas.shortcuts.duplicate":"Duplicate","canvas.shortcuts.fitSelection":"Fit selection","canvas.shortcuts.group":"Group","canvas.shortcuts.inspectTool":"Inspect tool","canvas.shortcuts.interactTool":"Interact tool","canvas.shortcuts.moveTool":"Move tool","canvas.shortcuts.nudge1":"Nudge 1px","canvas.shortcuts.nudge10":"Nudge 10px","canvas.shortcuts.pan":"Pan","canvas.shortcuts.panTool":"Pan tool","canvas.shortcuts.redo":"Redo","canvas.shortcuts.resetView":"Reset view","canvas.shortcuts.selectAll":"Select all","canvas.shortcuts.settings":"Settings","canvas.shortcuts.temporaryPan":"Temporary pan","canvas.shortcuts.thisDialog":"This dialog","canvas.shortcuts.title":"Keyboard shortcuts","canvas.shortcuts.undo":"Undo","canvas.shortcuts.ungroup":"Ungroup","canvas.shortcuts.zoomAroundCursor":"Zoom around cursor","canvas.sidebar.action.preview":"Preview","canvas.sidebar.action.projectSettings":"Project settings","canvas.sidebar.action.publish":"Publish","canvas.sidebar.action.versionHistory":"Version history","canvas.sidebar.env.current":"current","canvas.sidebar.env.development":"Development","canvas.sidebar.env.group":"Environment","canvas.sidebar.env.production":"Production","canvas.sidebar.env.staging":"Staging","canvas.sidebar.env.switchTo":"switch to","canvas.sidebar.filter.all":"Everything","canvas.sidebar.filter.components":"Components","canvas.sidebar.filter.designSystem":"Design system","canvas.sidebar.filter.pages":"Pages","canvas.sidebar.group.environment":"ENVIRONMENT","canvas.sidebar.group.filter":"FILTER","canvas.sidebar.group.pages":"PAGES","canvas.sidebar.group.project":"PROJECT","canvas.sidebar.pages.add":"Add page","canvas.sidebar.sections":"SECTIONS","canvas.slot.openApp":"Open {name}","canvas.slot.openAppGeneric":"Open app","canvas.splitView.close":"Close split view","canvas.splitView.open":"Open split view","canvas.studioNavbar.createAria":"Create project or library","canvas.studioSidebar.analytics":"Analytics","canvas.studioSidebar.configure":"Configure","canvas.studioSidebar.copyUrl":"Copy URL","canvas.studioSidebar.details":"Details","canvas.studioSidebar.env.development":"Development","canvas.studioSidebar.env.production":"Production","canvas.studioSidebar.env.staging":"Staging","canvas.studioSidebar.envAria":"Open directly \u2014 choose environment","canvas.studioSidebar.envTitle":"Choose environment","canvas.studioSidebar.open":"Open","canvas.studioSidebar.openCanvas":"Open canvas","canvas.studioSidebar.openDirectly":"Open directly","canvas.studioSidebar.openGithub":"Open GitHub","canvas.studioSidebar.openNpm":"Open npm","canvas.studioSidebar.openOnGithub":"Open on GitHub","canvas.studioSidebar.openService":"Open service","canvas.studioSidebar.preview":"Preview","canvas.surface.empty.heading":"Nothing to render here yet","canvas.surface.empty.hint":"This project has no pages yet. Add one from the \\"+ New\\" menu, or publish content via the CLI.","canvas.team.agent.fallback":"Agent","canvas.team.agentAccess.adminHint":"Full control \u2014 content plus team + assignment management.","canvas.team.agentAccess.adminLabel":"Admin","canvas.team.agentAccess.editorHint":"Views and creates content \u2014 tickets, docs, messages.","canvas.team.agentAccess.editorLabel":"Editor","canvas.team.agentAccess.guestHint":"Read-only \u2014 views workspace content, never writes.","canvas.team.agentAccess.guestLabel":"Guest","canvas.team.agentCaption.brain":"Operational orchestrator","canvas.team.agentCaption.custom":"Agent \xb7 {name}","canvas.team.agentCaption.epicCompany":"Epic agent \xb7 company","canvas.team.agentCaption.epicDesign":"Epic agent \xb7 design system","canvas.team.agentCaption.epicDompiler":"Epic agent \xb7 dompiler","canvas.team.agentCaption.epicExtensions":"Epic agent \xb7 extensions","canvas.team.agentCaption.epicPapuna":"Epic agent \xb7 papuna","canvas.team.agentCaption.epicSdk":"Epic agent \xb7 @symbo.ls/sdk","canvas.team.agentCaption.epicServer":"Epic agent \xb7 server","canvas.team.agentCaption.epicSmbls":"Epic agent \xb7 smbls core","canvas.team.agentCaption.epicSymbolize":"Epic agent \xb7 symbolize","canvas.team.agentCaption.helper":"Cross-epic helper","canvas.team.agentCaption.infra":"Infrastructure","canvas.team.agentCaption.observer":"Analytics / observer","canvas.team.agentCaption.platform":"Platform \xb7 global","canvas.team.platformNote":"Symbols\' built-in assistants, available to every workspace.","canvas.team.agentCaption.router":"PM / router","canvas.team.agentCaption.studio":"Apps","canvas.team.agentModal.accessLabel":"Access level","canvas.team.agentModal.addEmpty":"Everyone is already assigned.","canvas.team.agentModal.addLabel":"Assign to a person","canvas.team.agentModal.assignedEmpty":"Not assigned to anyone yet.","canvas.team.agentModal.assignedLabel":"Assigned to","canvas.team.agentModal.errorBuiltIn":"This is a built-in agent \u2014 provision it before saving changes.","canvas.team.agentModal.errorSaveFailed":"Failed to save agent","canvas.team.agentModal.instructionsLabel":"System instructions","canvas.team.agentModal.instructionsPlaceholder":"Describe how this agent should behave \u2014 its goals, tone, and boundaries\u2026","canvas.team.agentModal.permsLabel":"Granted permissions","canvas.team.agentModal.restrictDescOff":"This agent can use every tool. Turn on to limit it to a selection.","canvas.team.agentModal.restrictDescOn":"This agent can use only the capabilities enabled below.","canvas.team.agentModal.restrictTitle":"Restrict to selected tools","canvas.team.agentModal.saveChanges":"Save changes","canvas.team.agentModal.saved":"Saved \u2713","canvas.team.agentModal.saving":"Saving\u2026","canvas.team.agentModal.toggleOff":"Off","canvas.team.agentModal.toggleOn":"On","canvas.team.agentModal.toolsIntroOff":"Pre-select capabilities here, then turn on \u201CRestrict\u201D above to enforce them.","canvas.team.agentModal.toolsIntroOn":"Enabled capabilities \u2014 each unlocks the tools listed. The agent is capped to these.","canvas.team.agentModal.toolsList":"Tools: {tools}","canvas.team.assignee.fallback":"Member","canvas.team.assignee.remove":"Remove","canvas.team.contextMenu.connect":"Connect\u2026","canvas.team.contextMenu.copyEmail":"Copy email","canvas.team.contextMenu.openProfile":"Open profile","canvas.team.create.activateHint":"Provision the seed roster as real agents.","canvas.team.create.activateLabel":"Activate agents","canvas.team.create.addTitle":"Add","canvas.team.create.agentHint":"Create an AI agent.","canvas.team.create.agentLabel":"Agent","canvas.team.create.aria":"Add human or agent","canvas.team.create.humanHint":"Invite a teammate by email.","canvas.team.create.humanLabel":"Human","canvas.team.create.menuAria":"Add new\u2026","canvas.team.create.runChainHint":"Run the connected agents as a chain.","canvas.team.create.runChainLabel":"Run chain","canvas.team.filter.assignAll":"All","canvas.team.filter.assignAssigned":"Assigned","canvas.team.filter.assignUnassigned":"Unassigned","canvas.team.filter.statusActive":"Active","canvas.team.filter.statusAll":"All","canvas.team.filter.statusIdle":"Idle","canvas.team.filter.titleAssignment":"Assignment","canvas.team.filter.titleStatus":"Status","canvas.team.filter.titleType":"Type","canvas.team.filter.typeAll":"All","canvas.team.group.renameTitle":"Double-click to rename \u2014 commits on blur or Enter","canvas.team.help.click":"Click a card to view details.","canvas.team.help.drag":"Drag cards to rearrange.","canvas.team.leave.title":"Remove \u201C{name}\u201D from \u201C{team}\u201D?","canvas.team.leave.message":"\u201C{name}\u201D will no longer be a member of \u201C{team}\u201D. This changes the team itself, not only the board layout.","canvas.team.leave.confirm":"Remove","canvas.team.linkHandle.title":"Drag to connect","canvas.team.member.email":"Email: {value}","canvas.team.member.location":"Location: {value}","canvas.team.member.timezone":"Timezone: {value}","canvas.team.node.agentFallback":"agent","canvas.team.node.openAria":"Open {name}","canvas.team.node.personFallback":"person","canvas.team.rail.agents":"AGENTS","canvas.team.scope.all":"All agents","canvas.team.scope.mine":"My agents","canvas.team.toast.activatedMany":"Activated {count} agents","canvas.team.toast.activatedOne":"Activated {count} agent","canvas.team.toast.activationFailed":"Activation failed","canvas.team.toast.allActive":"All agents already active","canvas.team.toast.assignFailed":"Assignment failed","canvas.team.toast.assigned":"Assigned {agent} \u2192 {person}","canvas.team.toast.assignmentRemoved":"Assignment removed","canvas.team.toast.chainCycle":"That link has a cycle \u2014 chains must be linear.","canvas.team.toast.chainFailed":"Could not start the chain.","canvas.team.toast.chainNeedsTwo":"Connect two or more agents (draw a link), then Run chain.","canvas.team.toast.chainRunning":"Running chain: {names}","canvas.team.toast.leaveFailed":"Could not remove \u201C{name}\u201D from \u201C{team}\u201D.","canvas.team.toast.memberFallback":"member","canvas.team.toast.removeFailed":"Failed to remove","canvas.team.unassign.title":"Unassign \u201C{agent}\u201D from \u201C{person}\u201D?","canvas.team.unassign.message":"\u201C{person}\u201D will no longer have \u201C{agent}\u201D among their agents. You can assign it again later.","canvas.team.unassign.confirm":"Unassign","canvas.tileFrame.desktopApp":"Desktop app","canvas.tileFrame.firstSlide":"First slide","canvas.tileFrame.library":"LIBRARY","canvas.tileFrame.platform":"Platform","canvas.tileFrame.platformProject":"Platform project","canvas.tileFrame.tapToDesign":"Tap to design","canvas.tileFrame.tvApp":"TV app","canvas.tileFrame.webApp":"Web app","canvas.tutorial.codeExplained.descr":"Symbols unifies HTML, CSS, and JavaScript into a single JavaScript object, giving you full control over structure, style, and behavior with elegant, expressive code.","canvas.tutorial.codeExplained.title":"HTML, CSS, and JavaScript unified!","canvas.typeFilter.all":"All types","canvas.typeFilter.app":"Web apps","canvas.typeFilter.desktop":"Desktop","canvas.typeFilter.library":"Libraries","canvas.typeFilter.mobile":"Mobile","canvas.typeFilter.platform":"Platform","canvas.typeFilter.presentation":"Presentations","canvas.typeFilter.tv":"TV","canvas.typeFilter.website":"Websites","canvas.versions.closeDetails":"Close version details","canvas.versions.closeHistory":"Close version history","canvas.versions.computingDiff":"Computing diff\u2026","canvas.versions.diff.close":"Close","canvas.versions.diff.empty":"No content differences between these versions.","canvas.versions.diff.subtitle":"Key-level changes per content namespace \u2014 added, removed and modified entries between the two versions.","canvas.versions.empty":"No versions yet. Every push and publish creates one.","canvas.versions.label.autosave":"Autosave","canvas.versions.label.helloWorld":"Hello world","canvas.versions.label.published":"Published release","canvas.versions.latest":"Latest","canvas.versions.loadingChanges":"Loading changes\u2026","canvas.versions.loadingVersions":"Loading versions\u2026","canvas.versions.openDiff":"Open diff","canvas.versions.panelTitle":"Version history","canvas.versions.previewThis":"Preview this version","canvas.versions.published":"Published","canvas.versions.restore.body":"The project will be rolled forward to this version\u2019s state. A new version is created \u2014 nothing in the history is lost.","canvas.versions.restore.cancel":"Cancel","canvas.versions.restore.busy":"Restoring\u2026","canvas.versions.restore.title":"Restore version {version}?","canvas.versions.restore.titlePlain":"Restore this version?","canvas.versions.restoreThis":"Restore this version","canvas.versions.snapshot":"Snapshot","canvas.voice.addedPage":"Added a page","canvas.voice.addedPageNamed":"Added page \\"{name}\\"","canvas.voice.alreadyMode":"Already {mode}","canvas.voice.canvasSettings":"Canvas settings","canvas.voice.components":"Components","canvas.voice.darkMode":"Dark mode","canvas.voice.deleted":"Deleted","canvas.voice.designSystem":"Design system","canvas.voice.duplicated":"Duplicated","canvas.voice.fitToView":"Fit to view","canvas.voice.lightMode":"Light mode","canvas.voice.noPageCalled":"No page called \\"{name}\\"","canvas.voice.opened":"Opened \\"{name}\\"","canvas.voice.redone":"Redone","canvas.voice.selectionCleared":"Selection cleared","canvas.voice.shortcuts":"Shortcuts","canvas.voice.sidebars":"Sidebars","canvas.voice.undone":"Undone","canvas.voice.viewReset":"View reset","canvas.voice.zoomedIn":"Zoomed in","canvas.voice.zoomedOut":"Zoomed out","canvas.tile.reloadLoop":"This page reloads itself in a loop, so the board stopped it.","canvas.newProject.templateWebsite.label":"Website","canvas.newProject.templateWebsite.hint":"Home, about and contact pages, ready to publish","canvas.newProject.toWorkspaceApps":"Building a tool for your team? Create a workspace app","canvas.workspaceAppGuard.title":"This is a workspace app","canvas.workspaceAppGuard.body":"Workspace apps run inside a workspace. You build and change them in Workspace apps, not in the website editor.","canvas.workspaceAppGuard.open":"Open Workspace apps","canvas.workspaceAppGuard.edit":"Edit the app","canvas.newProject.create":"Create project","canvas.newProject.creating":"Creating\u2026","canvas.pageSlot.resizeSplit":"Resize split panes","canvas.pageSlot.resizeSplitHint":"Drag to resize \xb7 Double-click or Enter to balance","canvas.minimizedDock.restore":"Restore"}');

});

parcelRegister("5utM4", function(module, exports) {
module.exports = JSON.parse('{"chat.add.adding":"Adding\u2026","chat.add.doneMany":"Added {count} people to #{name}","chat.add.doneOne":"Added {person} to #{name}","chat.add.heading":"Add people to #{name}","chat.add.label":"People","chat.add.subtitle":"Pick the people from this workspace who should join.","chat.answer.attachment":"Attachment","chat.answer.failed":"Could not load the chat.","chat.answer.noChannel":"No conversation matches.","chat.answer.noMessages":"No messages here yet.","chat.answer.noUnread":"No unread messages.","chat.answer.unreadCount":"{count} unread","chat.call.channelCallName":"{name} \xb7 call","chat.call.channelName":"Channel call","chat.call.directName":"Direct call","chat.channel.channelFallback":"channel","chat.channel.directMessage":"Direct message","chat.channel.fallback":"Chat","chat.channel.groupDm":"Group DM","chat.composer.attachFile":"Attach file","chat.composer.broadcastCaption":"Notify everyone in this channel","chat.composer.cancelEdit":"Cancel edit","chat.composer.cancelReply":"Cancel reply","chat.composer.editing":"Editing message","chat.composer.emoji":"Emoji","chat.composer.formatBold":"Bold","chat.composer.formatBulleted":"Bulleted list","chat.composer.formatCode":"Code","chat.composer.formatHeading":"Heading \u2014 click for H1","chat.composer.formatHeading1":"Heading 1 \u2014 click for H2","chat.composer.formatHeading2":"Heading 2 \u2014 click for H3","chat.composer.formatHeading3":"Heading 3 \u2014 click to clear","chat.composer.formatItalic":"Italic","chat.composer.formatLink":"Link","chat.composer.formatNumbered":"Numbered list","chat.composer.formatQuote":"Blockquote","chat.composer.formatRule":"Horizontal rule","chat.composer.formatStrike":"Strikethrough","chat.composer.formatUnderline":"Underline","chat.composer.mention":"Mention someone","chat.composer.messageAria":"Message","chat.composer.messageChannel":"Message #{name}","chat.composer.notifyAllConfirm":"Send","chat.composer.notifyAllMessage":"Everyone in this channel will get a mention notification.","chat.composer.notifyAllTitle":"Notify all {count} members?","chat.composer.retry":"Retry","chat.composer.send":"Send message","chat.drawer.channels":"Channels","chat.drawer.close":"Close","chat.drawer.noChannels":"No channels available.","chat.empty.heading":"Welcome to Chat","chat.empty.hint":"Select a channel from the sidebar to read the latest updates, or click a teammate to start a direct message.","chat.empty.noMessages":"No messages yet \u2014 say something.","chat.error.addMembersTitle":"Could not add members","chat.error.alreadyMemberMessage":"#{name} already exists \u2014 you\'re already a member instead of a new, separate channel.","chat.error.alreadyMemberTitle":"Already in this channel","chat.error.deleteMessageTitle":"Could not delete message","chat.error.editMessageTitle":"Could not save the edit","chat.error.joinedExistingMessage":"#{name} already exists \u2014 you\'re now a member instead of a new, separate channel.","chat.error.joinedExistingTitle":"Joined existing channel","chat.error.nameTakenMessage":"A private channel named #{name} already exists. Ask its owner to add you, or pick a different name.","chat.error.nameTakenTitle":"Channel name already taken","chat.error.networkMessage":"Network or server error \u2014 try again.","chat.error.networkShort":"Network or server error","chat.error.openChatTitle":"Could not open chat","chat.error.reactionTitle":"Could not update reaction","chat.error.removeMemberTitle":"Could not remove the member","chat.error.sendTitle":"Message failed to send","chat.error.stillSending":"This message is still sending \u2014 wait a moment, then try again.","chat.error.ticketNotFoundMessage":"#{ref} may have been deleted, or is not in this workspace.","chat.error.ticketNotFoundTitle":"Ticket not found","chat.error.tryAgain":"Please try again","chat.error.uploadMessage":"Could not upload the file","chat.error.uploadShort":"Upload failed","chat.error.uploadTitle":"Attachment upload failed","chat.header.activeNow":"Active now","chat.header.callAll":"Call all participants","chat.header.callFailedMessage":"Could not load the call surface. Refresh and try again.","chat.header.callFailedTitle":"Call failed","chat.header.closeCall":"Close call","chat.header.memberMany":"{count} members","chat.header.memberOne":"1 member","chat.header.more":"More options","chat.header.peopleCount":"{count} people","chat.header.search":"Search in this conversation","chat.header.selectChannel":"Select a channel","chat.header.viewMembers":"View members","chat.intro.addPeople":"Add people","chat.intro.channelPrivate":"This is the very beginning of {name}. Only its members can read it.","chat.intro.channelPublic":"This is the very beginning of #{name}. Everyone in the workspace can read it.","chat.intro.dm":"This is the beginning of your conversation with {name}.","chat.intro.groupDm":"This is the beginning of your group conversation.","chat.intro.viewProfile":"View profile","chat.list.jumpToLatest":"Jump to latest","chat.list.newDivider":"New","chat.list.newMessages":"New messages","chat.mention.suggestions":"Mention suggestions","chat.menu.createChannel":"Create channel","chat.menu.hide":"Hide","chat.menu.invite":"Invite","chat.menu.leave":"Leave","chat.menu.message":"Message","chat.menu.mute":"Mute","chat.menu.pinToTop":"Pin to top","chat.menu.rename":"Rename","chat.menu.scheduleMeeting":"Schedule meeting","chat.menu.settings":"Settings","chat.menu.startGroupChat":"Start group chat","chat.menu.unmute":"Unmute","chat.menu.unpin":"Unpin","chat.menu.viewProfile":"View profile","chat.message.actions":"Message actions","chat.message.addReaction":"Add a reaction","chat.message.bookmark":"Bookmark","chat.message.copyUrl":"Copy URL","chat.message.createEvent":"Create event","chat.message.createKb":"Create knowledge base","chat.message.createNote":"Create note","chat.message.createTask":"Create task","chat.message.delete":"Delete message","chat.message.deleteConfirm":"Delete","chat.message.deleteConfirmMessage":"The message is removed for everyone in this conversation.","chat.message.deleteConfirmTitle":"Delete this message?","chat.message.edit":"Edit message","chat.message.edited":"edited","chat.message.forward":"Forward","chat.message.jumpToReplied":"Jump to replied message","chat.message.moreActions":"More actions","chat.message.moreReactions":"More reactions","chat.message.originalUnavailable":"Original message unavailable","chat.message.pin":"Pin","chat.message.reply":"Reply","chat.message.replyInThread":"Reply in thread","chat.message.untitledArticle":"Untitled article","chat.message.untitledEvent":"Untitled event","chat.message.untitledNote":"Untitled note","chat.new.cancel":"Cancel","chat.new.headingChannel":"Create channel","chat.new.headingDm":"New direct message","chat.new.kindChannel":"# Channel","chat.new.kindDm":"Direct message","chat.new.kindLabel":"Conversation type","chat.new.members":"Members","chat.new.name":"Name","chat.new.namePlaceholder":"e.g. design-reviews","chat.new.searchPlaceholder":"Search teammates\u2026","chat.new.submitChannel":"Create channel","chat.new.submitDm":"Open DM","chat.new.subtitleChannel":"Pick a name and add the people who should join","chat.new.subtitleDm":"Pick one or more people to message","chat.new.topic":"Topic (optional)","chat.new.topicPlaceholder":"What is this channel about?","chat.notify.mentionedEveryone":"{sender} mentioned everyone in #{channel}","chat.notify.mentionedYou":"{sender} mentioned you in #{channel}","chat.overlay.chats":"Chats","chat.overlay.closeChats":"Close chats","chat.overlay.closeConversation":"Close conversation","chat.overlay.switchView":"Switch view","chat.page.chat.title":"Chat","chat.picker.clearSelection":"Clear selection","chat.picker.everyoneIn":"Everyone in this workspace is already in this channel.","chat.picker.noMatches":"No matches","chat.picker.noPeople":"No teammates to pick yet.","chat.picker.noneSelected":"No one selected yet","chat.picker.removePerson":"Remove {name}","chat.picker.selectAll":"Select all","chat.picker.selectedCount":"{count} selected","chat.rename.cancel":"Cancel","chat.rename.heading":"Rename channel","chat.rename.placeholder":"Channel name","chat.rename.save":"Save","chat.rename.subtitle":"Give this conversation a clearer name","chat.search.heading":"Search messages","chat.search.hint":"Type to search messages across every channel you belong to.","chat.search.noMatches":"No matches for \\"{query}\\"","chat.search.placeholder":"Search all messages\u2026","chat.search.subtitle":"Search across every channel you belong to.","chat.settings.archive":"Archive","chat.settings.archiveChannel":"Archive channel","chat.settings.archiveConfirmTitle":"Archive {target}?","chat.settings.archiveMessage":"Archived channels are hidden from the sidebar. Members can unarchive later.","chat.settings.channelFallback":"channel","chat.settings.conversationFallback":"conversation","chat.settings.delete":"Delete","chat.settings.deleteChannel":"Delete channel","chat.settings.deleteConfirmMessage":"This permanently removes the channel and all of its messages for every member. This cannot be undone.","chat.settings.deleteConfirmTitle":"Delete #{name}?","chat.settings.eventFallback":"Event","chat.settings.linkEventNone":"Link to calendar event\u2026","chat.settings.linkedEvent":"Linked event / call","chat.settings.members":"Members","chat.settings.muteHint":"Mute notifications \u2014 no bell, dimmed unread badge.","chat.settings.name":"Name","chat.settings.namePlaceholder":"e.g. design-reviews","chat.settings.noMembers":"No members loaded yet.","chat.settings.privateHint":"Private channel \u2014 only invited members can see messages.","chat.settings.removeConfirmMessage":"They lose access to this channel. You can add them again later.","chat.settings.removeConfirmTitle":"Remove {name} from #{channel}?","chat.settings.removeMember":"Remove from channel","chat.settings.save":"Save","chat.settings.searchPlaceholder":"Search teammates to add\u2026","chat.settings.subtitleChannel":"Manage the name, topic, privacy, and members.","chat.settings.subtitleConversation":"Manage notifications, linked events, and members.","chat.settings.titleChannel":"#{name} settings","chat.settings.titleConversation":"{name} settings","chat.settings.titleDm":"Conversation settings","chat.settings.titleFallback":"Settings","chat.settings.topic":"Topic","chat.settings.topicPlaceholder":"What is this channel about?","chat.settings.unarchive":"Unarchive","chat.settings.unarchiveChannel":"Unarchive channel","chat.settings.unarchiveConfirmTitle":"Unarchive {target}?","chat.settings.unarchiveMessage":"The channel will appear in the sidebar again.","chat.settings.youName":"{name} (you)","chat.sidebar.add":"Add","chat.sidebar.channels":"CHANNELS","chat.sidebar.conversations":"Conversations","chat.sidebar.directMessages":"DIRECT MESSAGES","chat.sidebar.externalPeople":"EXTERNAL PEOPLE","chat.sidebar.groups":"GROUPS","chat.sidebar.newChannel":"New channel","chat.sidebar.newExternalMessage":"New external message","chat.sidebar.newGroup":"New group","chat.sidebar.newMessage":"New message","chat.sidebar.pinned":"PINNED","chat.sidebar.resize":"Resize sidebar","chat.tab.allAuthors":"All authors","chat.tab.attachments":"\uD83D\uDCCE Attachments","chat.tab.clear":"Clear","chat.tab.conversation":"Conversation","chat.tab.files":"Files","chat.tab.filterPlaceholder":"Filter messages in this channel\u2026","chat.tab.goToMessage":"Go to message","chat.tab.links":"Links","chat.tab.mentions":"@ Mentions","chat.tab.noFiles":"No files shared in this channel yet.","chat.tab.noLinks":"No links shared in this channel yet.","chat.tab.noTasks":"No tasks referenced in this channel yet. Use #PROJECT-123 syntax to link tasks.","chat.tab.tickets":"Tasks","chat.thread.close":"Close thread","chat.thread.heading":"Thread","chat.thread.noReplies":"No replies yet","chat.thread.placeholder":"Reply to thread\u2026","chat.thread.replyMany":"{count} replies","chat.thread.replyOne":"1 reply","chat.typing.many":"Several people are typing","chat.typing.one":"{name} is typing","chat.typing.two":"{a} and {b} are typing"}');

});

parcelRegister("9i81O", function(module, exports) {
module.exports = JSON.parse('{"common.action.add":"Add","common.action.apply":"Apply","common.action.back":"Back","common.action.cancel":"Cancel","common.action.clear":"Clear","common.action.close":"Close","common.action.confirm":"Confirm","common.action.continue":"Continue","common.action.copy":"Copy","common.action.create":"Create","common.action.delete":"Delete","common.action.details":"Details","common.action.download":"Download","common.action.duplicate":"Duplicate","common.action.edit":"Edit","common.action.filter":"Filter","common.action.forward":"Forward","common.action.get_started":"Get started","common.action.invite":"Invite","common.action.learn_more":"Learn more","common.action.moreActions":"More actions","common.action.new":"New","common.action.next":"Next","common.action.okay":"Okay","common.action.open":"Open","common.action.paste":"Paste","common.action.previous":"Previous","common.action.refresh":"Refresh","common.action.remove":"Remove","common.action.rename":"Rename","common.action.reset":"Reset","common.action.save":"Save","common.action.search":"Search","common.action.send":"Send","common.action.share":"Share","common.action.show_less":"Show less","common.action.show_more":"Show more","common.action.sort":"Sort","common.action.try_again":"Try again","common.action.upload":"Upload","common.board.deleteFailed":"Couldn\'t delete the card","common.board.deleteMessage":"The card is deleted for everyone who uses this board.","common.board.deleteNeedsWorkspace":"Open this board in the workspace to delete cards.","common.board.deleteTitle":"Delete \u201C{name}\u201D?","common.board.empty":"Nothing on the board yet","common.board.loadError":"Couldn\'t load the board \u2014 {error}","common.hint.keepTyping":"{count} more \u2014 keep typing to narrow","common.hint.panTouch":"Drag to pan, pinch to zoom.","common.hint.panWheel":"Wheel to pan, \u2318/Ctrl + wheel to zoom.","common.language.change":"Change language","common.language.lockedByWorkspace":"Interface language is set by the workspace","common.language.setByWorkspace":"Set by the workspace","common.monthLong.apr":"April","common.monthLong.aug":"August","common.monthLong.dec":"December","common.monthLong.feb":"February","common.monthLong.jan":"January","common.monthLong.jul":"July","common.monthLong.jun":"June","common.monthLong.mar":"March","common.monthLong.may":"May","common.monthLong.nov":"November","common.monthLong.oct":"October","common.monthLong.sep":"September","common.monthShort.apr":"Apr","common.monthShort.aug":"Aug","common.monthShort.dec":"Dec","common.monthShort.feb":"Feb","common.monthShort.jan":"Jan","common.monthShort.jul":"Jul","common.monthShort.jun":"Jun","common.monthShort.mar":"Mar","common.monthShort.may":"May","common.monthShort.nov":"Nov","common.monthShort.oct":"Oct","common.monthShort.sep":"Sep","common.pagination.label":"Pagination","common.party.addAnyway":"Add anyway","common.party.addFailed":"Could not add the client. Try again.","common.party.addNew":"New client","common.party.email":"Email","common.party.idExists":"{name} already has this ID number. The existing client is chosen.","common.party.kind":"Type","common.party.kindCompany":"Company","common.party.kindPerson":"Person","common.party.label":"Client","common.party.legalName":"Legal name","common.party.loadFailed":"Could not load the list. Try again.","common.party.name":"Name","common.party.nameRequired":"Enter a name.","common.party.personalId":"Personal ID","common.party.phone":"Phone","common.party.placeholder":"Choose a client","common.party.searching":"Searching\u2026","common.party.similarName":"A client with a similar name exists: {name}.","common.party.taxId":"Tax ID","common.party.useExisting":"Use {name}","common.state.active":"Active","common.state.coming_soon":"Coming soon","common.state.disabled":"Disabled","common.state.draft":"Draft","common.state.empty":"Empty","common.state.enabled":"Enabled","common.state.error":"Error","common.state.loading":"Loading","common.state.noMatches":"No matches","common.state.optional":"Optional","common.state.published":"Published","common.state.required":"Required","common.state.saved":"Saved","common.state.saving":"Saving","common.state.success":"Success","common.state.warning":"Warning","common.time.daysAgo":"{count} days ago","common.time.hoursAgo":"{count} hours ago","common.time.justNow":"just now","common.time.minutesAgo":"{count} mins ago","common.time.monthsAgo":"{count} months ago","common.time.today":"Today","common.time.weeksAgo":"{count} weeks ago","common.time.yearsAgo":"{count} years ago","common.time.yesterday":"Yesterday","common.timeShort.days":"{count}d","common.timeShort.hours":"{count}h","common.timeShort.minutes":"{count}m","common.timeShort.now":"now","common.timeShort.weeks":"{count}w","common.timeShortAgo.days":"{count}d ago","common.timeShortAgo.hours":"{count}h ago","common.timeShortAgo.minutes":"{count}m ago","common.timeShortAgo.seconds":"{count}s ago","common.timeShortAgo.weeks":"{count}w ago","common.weekdayLong.fri":"Friday","common.weekdayLong.mon":"Monday","common.weekdayLong.sat":"Saturday","common.weekdayLong.sun":"Sunday","common.weekdayLong.thu":"Thursday","common.weekdayLong.tue":"Tuesday","common.weekdayLong.wed":"Wednesday","common.weekdayShort.fri":"Fri","common.weekdayShort.mon":"Mon","common.weekdayShort.sat":"Sat","common.weekdayShort.sun":"Sun","common.weekdayShort.thu":"Thu","common.weekdayShort.tue":"Tue","common.weekdayShort.wed":"Wed"}');

});

parcelRegister("9FUgo", function(module, exports) {
module.exports = JSON.parse('{"data.page.title":"{section} / Data","data.section.projects":"Projects","data.section.users":"Users","data.section.organizations":"Organizations","data.section.subscriptions":"Subscriptions","data.section.plans":"Plans","data.filter.all":"All","data.filter.team":"Team \xb7 {count}","data.filter.external":"External \xb7 {count}","data.search.placeholder":"Search\u2026","data.action.reload":"Reload","data.state.loadingAria":"Loading {section}\u2026","data.pagination.pageOf":"Page {page} of {total}","data.pagination.page":"Page {page}","data.pagination.prev":"\u2190 Prev","data.pagination.next":"Next \u2192","data.empty.noMatches":"No matches","data.empty.noData":"No data","data.projects.col.name":"Name / Key","data.projects.col.owner":"Owner","data.projects.col.access":"Access","data.projects.col.members":"Members","data.projects.userCount":"{count} users","data.projects.userCountOne":"1 user","data.users.col.name":"Name","data.users.col.email":"Email","data.users.col.status":"Status","data.users.col.provider":"Provider","data.users.col.role":"Role","data.users.badge.verified":"Verified","data.users.badge.demoTitle":"Demo account","data.users.badge.demo":"Demo","data.organizations.col.name":"Name","data.organizations.col.slug":"Slug","data.organizations.col.owner":"Owner","data.organizations.col.plans":"Plans","data.organizations.col.projects":"Projects","data.organizations.col.members":"Members","data.organizations.memberCount":"{count} members","data.organizations.memberCountOne":"1 member","data.subscriptions.col.workspace":"Workspace","data.subscriptions.col.organization":"Organization","data.subscriptions.col.tier":"Tier","data.subscriptions.col.credits":"Credits","data.subscriptions.col.status":"Status","data.plans.intro.live":"Live credit-tier model \u2014 api.symbols.app/core/credits/rates","data.plans.intro.public":"Public plans & pricing from api.symbols.app","data.plans.meter.heading":"How we charge","data.plans.meter.modelMultipliers":"AI model multipliers","data.plans.meter.infra":"Infrastructure","data.plans.meter.comms":"Communications","data.plans.meter.governance":"Governance & workflow","data.plans.meter.empty":"No rates published","data.plans.charging.title":"Charging model","data.plans.charging.body":"Each workspace tier ships a monthly credit grant. Usage above the grant meters against the rate card below. Top up any amount from {min} at a flat {rate}/credit \u2014 no packs, no volume discount. Billing is per workspace \u2014 tier and grant attach to the workspace, not to individual projects.","data.plans.charging.retail":"Retail price","data.plans.charging.retailValue":"{rate} / credit","data.plans.charging.topup":"Top-up","data.plans.charging.topupValue":"From {min} \xb7 {rate}/credit flat","data.plans.charging.topupValueMin":"From {min}","data.plans.charging.topupHint":"Freeform amount, no packs","data.plans.charging.scope":"Billing scope","data.plans.charging.scopeValue":"Per workspace","data.plans.charging.scopeHint":"Tier + grant per workspace, not per project","data.plans.card.custom":"Custom","data.plans.card.free":"Free","data.plans.card.perMonth":"/ month","data.plans.card.annualNote":"{price}/mo billed annually","data.plans.card.trial":"{days}-day free trial","data.plans.card.creditsCustom":"Custom credits","data.plans.card.credits":"{credits} credits / mo","data.plans.tier.rateLimit":"Rate limit","data.plans.tier.rateLimitValue":"{count} req / min","data.plans.tier.workspaces":"Workspaces","data.plans.tier.projects":"Projects","data.plans.tier.unlimited":"Unlimited","data.plans.tier.environments":"Environments","data.plans.tier.environmentsCustom":"{envs} + custom envs","data.plans.tier.capabilities":"Capabilities","data.plans.tier.capabilitiesValue":"{count} included","data.plans.tier.support":"Support","data.plans.option.popular":"Popular","data.plans.limits.title":"Limits","data.plans.limits.yes":"Yes","data.plans.limits.no":"No","data.plans.features.title":"Features ({count})","data.plans.pricingOptions.title":"Pricing options ({count})","data.rate.egressGb":"Egress / GB","data.rate.storageGbMonth":"Storage / GB\xb7mo","data.rate.buildMinute":"Build / min","data.rate.transcodeGb":"Transcode / GB","data.rate.deploy":"Deploy","data.rate.animationExport":"Animation export","data.rate.templateInstallPremium":"Premium template install","data.rate.brandbookPdf":"Brandbook PDF","data.rate.callRelayPerParticipantMin":"Call relay / participant\xb7min","data.rate.liveCaptionsMin":"Live captions / min","data.rate.postCallTranscriptMin":"Post-call transcript / min","data.rate.recordingStorageGbMonth":"Recording storage / GB\xb7mo","data.rate.recordingTranscodeGb":"Recording transcode / GB","data.rate.meetingSearchIndexingMin":"Meeting search indexing / min","data.rate.esignature":"E-signature","data.rate.voiceAgentMin":"Voice assistant call / min","data.rate.policyEvalAboveFloor":"Policy eval (above floor)","data.rate.policyEvalFreeFloorPerMo":"Policy eval free floor / mo","data.rate.workflowRun":"Workflow run","data.rate.auditRetentionGbMonthAboveFloor":"Audit retention / GB\xb7mo (above floor)","data.rate.auditRetentionFreeDays":"Audit retention free window","data.rate.scimSyncPerUserMonthAboveFloor":"SCIM sync / user\xb7mo (above floor)","data.rate.scimSyncFreeUsers":"SCIM sync free users","data.rate.webhookDeliveryPer1k":"Webhook delivery / 1K","data.detail.kind.user":"USER","data.detail.kind.plan":"PLAN","data.detail.kind.organization":"ORGANIZATION","data.detail.kind.subscription":"SUBSCRIPTION","data.detail.kind.project":"PROJECT","data.detail.saving":"Saving\u2026","data.detail.members.title":"Members ({count})","data.detail.domains.title":"Domains ({count})","data.detail.permissions.title":"Permissions","data.detail.localProfile.title":"Local profile","data.detail.localProfile.open":"Open profile \u2192","data.detail.openDirect":"Open direct","data.detail.openPreview":"Open preview","data.detail.openCanvas":"Open canvas","data.detail.transfer.owner":"Owner: {owner}","data.detail.transfer.confirmTitle":"Move \u201C{project}\u201D to \u201C{org}\u201D?","data.detail.transfer.confirmMessage":"The project moves into this organization\u2019s workspace. People who reach it only through its current owner, \u201C{owner}\u201D, lose access.","data.detail.transfer.confirm":"Move project","data.detail.transfer.failed":"Could not move the project: {error}","data.external.page.title":"External data","data.external.header.default":"External data","data.external.header.workspaceData":"Workspace data","data.external.header.rows":"{count} rows","data.external.header.rowsCapped":"{count} rows \xb7 capped","data.external.backToAdmin":"\u2190 Admin","data.external.newRow":"+ New row","data.external.refreshing":"Refreshing\u2026","data.external.retry":"Retry","data.external.rail.loadingAria":"Loading sources","data.external.rail.workspaceData":"Workspace data","data.external.rail.collectionsEmpty":"No record collections yet \u2014 workspace apps create them as they store data.","data.external.rail.backends":"Connected backends","data.external.rail.backendsEmpty":"No backends connected to this workspace yet.","data.external.rail.connectBackend":"+ Connect backend","data.external.off.title":"External data is turned off","data.external.off.hint":"Turn on the \\"External sources\\" flag (data.externalSources) to browse connected backends, workspace datasets, and their fetch wiring.","data.external.off.cta":"Open feature flags \u2192","data.external.empty.title":"Pick a data source","data.external.empty.collections":"{count} workspace collections","data.external.empty.collectionsOne":"1 workspace collection","data.external.empty.backends":"{count} connected backends","data.external.empty.backendsOne":"1 connected backend","data.external.empty.hint":"{collections} and {backends} in scope. Select one on the left to inspect its schema, browse rows, and copy its fetch wiring.","data.external.empty.connectHint":"Configure backends in Admin \u2192 Integrations \u2192","data.external.dot.live":"Live \u2014 capability calls enabled","data.external.dot.connected":"Connected","data.external.integration.credentials":"credentials in vault","data.external.integration.noCredentials":"no credentials","data.external.caps.title":"Declared capabilities","data.external.notice.comingSoon":"Connected \u2014 query engine coming soon. This backend declares data capabilities, but the server-side dispatcher for its kind is not implemented yet.","data.external.notice.noDataset":"This integration does not expose a browsable dataset here \u2014 use its capabilities from your app via sdk.execute.","data.external.runner.title":"Request runner","data.external.runner.bodyPlaceholder":"{ \\"json\\": \\"body\\" } \u2014 sent as-is when not valid JSON","data.external.runner.running":"Running\u2026","data.external.runner.run":"Run request","data.external.runner.response":"Response \xb7 HTTP {status}","data.external.rows.backToNamespaces":"\u2190 Namespaces","data.external.rows.count":"{count} rows","data.external.rows.countOne":"1 row","data.external.rows.countMore":"{count} rows (showing the first pages)","data.external.rows.countOneMore":"1 row (showing the first pages)","data.external.schema.derived":"Schema \xb7 derived from rows","data.external.schema.title":"Schema","data.external.rows.emptyEditable":"No rows yet \u2014 create the first one with \\"+ New row\\".","data.external.rows.empty":"No rows in this table.","data.external.fetch.title":"Fetch wiring","data.external.copy.done":"Snippet copied","data.external.copy.failed":"Copy failed","data.external.error.noResponse":"no response","data.external.error.notSignedIn":"Not signed in \u2014 the session expired. Sign in again.","data.external.error.notAllowed":"Not allowed \u2014 this capability needs an org owner/admin role (or a granted write role).","data.external.error.notFound":"Integration not found \u2014 it may have been removed.","data.external.error.httpStatus":"{error} (HTTP {status})","data.external.error.unknownStatus":"with an error","data.external.error.upstream":"Upstream responded {status}","data.external.error.upstreamWithDetail":"Upstream responded {status} \u2014 {detail}","data.external.error.integrationNotFound":"integration \\"{slug}\\" not found","data.external.error.readOnly":"{kind} rows are read-only here","data.external.error.notBrowsable":"{kind} rows are not browsable yet","data.external.error.notANumber":"{field}: \\"{value}\\" is not a number","data.external.error.invalidJson":"{field}: invalid JSON \u2014 {message}","data.external.error.rowIdMissing":"row id missing","data.external.error.noRoot":"no root state","data.external.error.nothingToSave":"nothing to save","data.external.error.saveInFlight":"save already in flight","data.external.error.nothingToDelete":"nothing to delete","data.external.snippet.recordsLabel":"Bind these rows declaratively","data.external.snippet.recordsCaption":"Declare on any element \u2014 the @symbo.ls/fetch plugin routes it through the SDK adapter. Writes go through sdk.execute(\'workspaceProject.records\', \'create\' | \'update\' | \'remove\', { id, collection, data }).","data.external.snippet.readTable":"Read {table} from your app","data.external.snippet.callBackend":"Call this backend from your app","data.external.snippet.listLabel":"List connected backends declaratively","data.external.snippet.listCaption":"Declare on any element to bind the integration registry. {imperative}","data.external.snippet.imperative":"Capability calls are imperative \u2014 route them through sdk.execute(\'orgIntegration\', \'call\', \u2026) in a registered function; there is no declarative fetch for them.","data.external.badge.live":"Live","data.external.badge.connected":"Connected"}');

});

parcelRegister("3MQMW", function(module, exports) {
module.exports = JSON.parse('{"documents.answer.empty":"No note matches.","documents.answer.failed":"Could not load the notes.","documents.answer.space.all":"Notes and articles","documents.answer.space.kb":"Knowledge base","documents.answer.space.notes":"Notes","documents.answer.title":"Note","documents.cardMenu.delete":"Delete","documents.cardMenu.edit":"Edit","documents.cardMenu.makePrivate":"Make private","documents.cardMenu.makeShared":"Make shared","documents.cardMenu.moveToFiles":"Move to Files","documents.cardMenu.open":"Open","documents.cardMenu.sharePublic":"Share public link\u2026","documents.cardMenu.shareChat":"Share to chat\u2026","documents.editor.delete":"Delete","documents.editor.edit":"Edit","documents.editor.emptyNote":"Empty note","documents.editor.export":"Export","documents.editor.exportMarkdown":"Markdown (.md)","documents.editor.exportPdf":"PDF (.pdf)","documents.editor.fontSize":"Aa","documents.editor.listen":"Listen","documents.editor.listening":"Listening\u2026","documents.editor.playbackSpeed":"Playback speed","documents.editor.save":"Save","documents.editor.share":"Share","documents.editor.saved":"Saved \u2713","documents.editor.saving":"Saving...","documents.editor.stopListening":"Stop listening","documents.editor.textSize":"Text size","documents.editor.titlePlaceholder":"Note title...","documents.editor.untitled":"Untitled","documents.editor.updatedOn":"Updated {date}","documents.filter.ai":"AI notes","documents.filter.all":"All notes","documents.filter.private":"Private","documents.filter.shared":"Shared","documents.folder.company":"Company","documents.folder.design":"Design","documents.folder.engineering":"Engineering","documents.folder.finance":"Finance","documents.folder.legal":"Legal","documents.folder.notes":"All notes","documents.folder.people":"People & HR","documents.folderMenu.delete":"Delete folder","documents.folderMenu.rename":"Rename folder","documents.folderMenu.unfile":"Unfile {count} notes","documents.folderMenu.unfileOne":"Unfile 1 note","documents.kb.articleCount":"{count} articles","documents.kb.articleCountOne":"1 article","documents.kb.newArticle":"+ New article","documents.kb.noDescription":"No description","documents.kb.searchPlaceholder":"Search knowledge base...","documents.kb.untitled":"Untitled","documents.kb.untitledArticle":"Untitled article","documents.kbCategory.all":"All articles","documents.kbCategory.design":"Design System","documents.kbCategory.engineering":"Engineering","documents.kbCategory.gettingStarted":"Getting Started","documents.kbCategory.policies":"Policies","documents.kbCategory.tools":"Tools & Infra","documents.notes.count":"{count} notes","documents.notes.countAi":"{count} AI notes","documents.notes.countAiOne":"1 AI note","documents.notes.countMember":"{count} member notes","documents.notes.countMemberOne":"1 member note","documents.notes.countOne":"1 note","documents.notes.dropHint":"Drop .md files to add notes","documents.notes.emptyBody":"Empty note","documents.notes.emptyHeading":"Write your first note","documents.notes.emptyHint":"Capture ideas, decisions and meeting minutes your team can find later.","documents.notes.heading":"Notes","documents.notes.headingAi":"AI notes","documents.notes.headingAll":"All notes","documents.notes.headingPrivate":"Private notes","documents.notes.headingShared":"Shared notes","documents.notes.newNote":"+ New note","documents.notes.noMatchHeading":"No matching notes","documents.notes.noMatchHint":"Try a different search, or switch scope in the sidebar.","documents.notes.searchNotesPlaceholder":"Search notes...","documents.notes.searchPlaceholder":"Search...","documents.notes.untitled":"Untitled note","documents.notes.untitledShort":"Untitled","documents.notes.upload":"Upload note","documents.page.knowledgeBase.title":"Knowledge base / Notes","documents.page.notes.title":"Notes","documents.page.notesAlt.title":"Notes / Documents","documents.section.knowledgeBase":"Knowledge Base","documents.section.editor":"Editor","documents.section.notes":"Notes","documents.sidebar.browse":"Browse","documents.sidebar.navLabel":"Notes","documents.delete.confirmTitle":"Delete \u201C{name}\u201D?","documents.delete.failedMessage":"\u201C{name}\u201D was not deleted. Try again.","documents.delete.failedTitle":"Delete failed","documents.delete.messageNote":"This removes the note from Notes for everyone who has access.","documents.delete.messageArticle":"This removes the article from the Knowledge Base for everyone who has access.","documents.folderDelete.message":"Its {count} notes stay without a folder. No note is deleted.","documents.folderDelete.messageEmpty":"The folder holds no notes.","documents.folderDelete.messageOne":"Its one note stays without a folder. The note is not deleted.","documents.folderDelete.title":"Delete folder \u201C{name}\u201D?","documents.folderMove.failedMessage":"{failed} of {total} notes stayed in \u201C{name}\u201D. Try again.","documents.folderMove.failedTitle":"Couldn\u2019t move every note","documents.folderNew.label":"New folder","documents.folderNew.message":"Notes you start while the folder is open go into it. A folder with no notes is not kept.","documents.folderNew.placeholder":"Folder name","documents.folderUnfile.confirm":"Unfile","documents.folderUnfile.message":"The notes stay without a folder. No note is deleted.","documents.folderUnfile.messageOne":"The note stays without a folder. It is not deleted.","documents.folderUnfile.title":"Unfile {count} notes from \u201C{name}\u201D?","documents.folderUnfile.titleOne":"Unfile 1 note from \u201C{name}\u201D?","documents.privacy.confirmMessage":"Only its author will see it. The rest of the team loses access until the author shares it again.","documents.privacy.confirmTitle":"Make \u201C{name}\u201D private?","documents.privacy.failed":"Couldn\u2019t change who sees the note","documents.reader.title":"Reading settings","documents.reader.size":"Text size","documents.reader.sizeSmall":"Small","documents.reader.sizeMedium":"Medium","documents.reader.sizeLarge":"Large","documents.reader.sizeXLarge":"Extra large","documents.reader.leading":"Line spacing","documents.reader.leadingCompact":"Compact","documents.reader.leadingStandard":"Standard","documents.reader.leadingRelaxed":"Comfortable","documents.reader.measure":"Width","documents.reader.measureNarrow":"Narrow","documents.reader.measureStandard":"Standard","documents.reader.measureWide":"Wide","documents.reader.reset":"Reset","documents.share.heading":"Share to chat","documents.share.subtitle":"Pick the conversation for a link to \u201C{name}\u201D.","documents.share.search":"Search channels and people","documents.share.empty":"No conversation matches.","documents.share.privateNotice":"This note is private. Sharing it makes it visible to your team.","documents.share.publicLink":"Public link\u2026","documents.share.sending":"Sending\u2026","documents.share.sent":"Shared to chat","documents.share.failed":"Could not share to chat","documents.share.confirmTitle":"Share \u201C{name}\u201D?","documents.share.confirmMessage":"A link to it goes to {channel}.","documents.share.confirm":"Share","documents.ref.pane":"Linked note","documents.ref.open":"Open note","documents.ref.close":"Close","documents.ref.openBeside":"Open in side view","documents.ref.loading":"Loading note\u2026","documents.ref.missing":"This note is unavailable. It may be deleted, or you may have no access to it."}');

});

parcelRegister("zmIil", function(module, exports) {
module.exports = JSON.parse('{"editor.addBranch.createFailed":"Could not create branch {branch}","editor.addBranch.name":"Branch name","editor.addBranch.namePlaceholder":"My notes","editor.addCanvas.freeform":"Freeform","editor.addCanvas.gravity":"Gravity","editor.addCanvas.title":"Title","editor.addCanvas.titlePlaceholder":"My notes","editor.addCase.value":"Case value","editor.addColor.code":"Type the HEX or RGBA","editor.addColor.name":"Name the color","editor.addComponent.description":"Description","editor.addComponent.descriptionPlaceholder":"Component Description","editor.addComponent.draft":"Draft","editor.addComponent.error.message":"Could not create {type} {title}","editor.addComponent.error.title":"Error message","editor.addComponent.exists.message":"\\"{key}\\" {kind} already exists","editor.addComponent.exists.title":"{kind} already exists","editor.addComponent.figmaUrl":"Figma embed URL:","editor.addComponent.frameProperties":"Frame properties:","editor.addComponent.initialCode":"Initial code","editor.addComponent.interactivityTypes":"Select interactivity types","editor.addComponent.isDraft":"Is a  draft?","editor.addComponent.key":"Key","editor.addComponent.keyRequired":"Key is required","editor.addComponent.mockupState":"Mockup state:","editor.addComponent.statePath":"Path in state","editor.addComponent.tags":"Tags","editor.addComponent.tagsHint":"For multiple tags divide by comma (,)","editor.addComponent.title":"Descriptive title","editor.addComponent.validation.title":"Validation message","editor.addComponent.valueTypes":"Select types of values","editor.addDependency.noResults":"No packages with that name found","editor.addDependency.package":"Package","editor.addDependency.packagePlaceholder":"Field in my content","editor.addDependency.version":"Version","editor.addDependency.versionPlaceholder":"Field in my content","editor.addFile.keyRequired":"Key can not be empty","editor.addFile.name":"File name","editor.addFile.publicUrl":"Public URL:","editor.addFile.upload":"Upload the file","editor.addFile.usingAsProperty":"Using as property:","editor.addFontFamily.allCategories":"All Categories","editor.addFontFamily.name":"Family name","editor.addFontFamily.namePlaceholder":"Name the family","editor.addFontFamily.ordering":"Define ordering","editor.addFontFamily.type":"Family type","editor.addFunction.code":"Function code","editor.addFunction.codeError":"There might be an error with the function code. Please check the code and try again.","editor.addFunction.createFailed":"Could not create function {key}","editor.addFunction.descriptionPlaceholder":"Function Description","editor.addFunction.name":"Function","editor.addFunction.title":"Function title","editor.addFunction.titlePlaceholder":"e.g. Fetching example data","editor.addGlobalTheme.background":"Background color","editor.addGlobalTheme.name":"Name the theme","editor.addGlobalTheme.namePlaceholder":"Name the theme","editor.addGlobalTheme.textColor":"Text color","editor.addIcon.name":"Icon name","editor.addIcon.upload":"Upload the icon","editor.addIcon.uploadHint":"Upload SVG file from your computer","editor.addMethod.code":"Method code","editor.addMethod.descriptionPlaceholder":"Method Description","editor.addMethod.hideAdvanced":"Hide advanced settings","editor.addMethod.showAdvanced":"Show advanced settings","editor.addMethod.title":"Method title","editor.addMethod.titlePlaceholder":"Fetching example data","editor.addPage.path":"Path","editor.addPage.title":"Page title","editor.addSecret.value":"Value","editor.addSecret.valuePlaceholder":"Secret value (xxx)","editor.addSnippet.code":"Snippet code","editor.addSnippet.descriptionPlaceholder":"Snippet Description","editor.addSnippet.hideAdvanced":"Hide advanced settings","editor.addSnippet.showAdvanced":"Show advanced settings","editor.addSnippet.title":"Snippet title","editor.addSnippet.titlePlaceholder":"Fetching example data","editor.addressBar.searchPlaceholder":"Search pages and components","editor.advanced.hide":"Hide advanced settings","editor.advanced.show":"Show advanced settings","editor.analyticsNavbar.projects":"Projects","editor.analyticsNavbar.workspace":"Workspace","editor.boxSize.max":"Max","editor.boxSize.min":"Min","editor.canvasBg.coolGray":"Cool gray","editor.canvasBg.custom":"Custom","editor.canvasBg.darkGray":"Dark gray","editor.canvasBg.deepBlue":"Deep blue","editor.canvasBg.deepGreen":"Deep green","editor.canvasBg.graphite":"Graphite (default)","editor.canvasBg.lavender":"Lavender","editor.canvasBg.lightBg":"Light","editor.canvasBg.mist":"Mist","editor.canvasBg.nearBlack":"Near black","editor.canvasBg.paper":"Paper (default)","editor.canvasBg.reset":"Reset to page default","editor.canvasBg.sage":"Sage","editor.canvasBg.sand":"Sand","editor.canvasBg.slate":"Slate","editor.canvasBg.softBlue":"Soft blue","editor.canvasBg.title":"Canvas background","editor.canvasBg.warmDark":"Warm dark","editor.canvasBg.white":"White","editor.canvasCreate.new":"Create new\u2026","editor.canvasMessage.dismiss":"Dismiss","editor.canvasPage.defaultRemove.message":"Default canvas page is built-in and can\'t be removed","editor.canvasPage.defaultRemove.title":"Default can\'t be removed","editor.canvasPage.defaultRename.message":"Default canvas page is built-in and can\'t be renamed","editor.canvasPage.defaultRename.title":"Default can\'t be renamed","editor.canvasPage.exists.message":"Canvas page with name \\"{title}\\" already exists. Please use different name","editor.canvasPage.exists.title":"Such canvas page already exists.","editor.canvasPage.move.confirm":"Move","editor.canvasPage.move.message":"Choose a destination page for the removed page\'s items.","editor.canvasPage.move.title":"Where to move the data?","editor.canvasPage.remove.message":"Do you want to remove \\"{page}\\" page?","editor.canvasPage.remove.title":"Remove page?","editor.canvasPage.rename.title":"Rename canvas page","editor.canvasPage.titleRequired":"Title is required.","editor.canvasSearch.locateInFiles":"Locate in files","editor.canvasSearch.locateOnCanvas":"Locate on canvas","editor.canvasSearch.openCode":"Open code","editor.canvasSearch.recent":"Recent searches","editor.canvasSearch.results":"Search results","editor.checkpoint.commit":"Commit","editor.checkpoint.saved":"Save success","editor.chooseCanvas.addCanvas":"Add canvas","editor.chooseCanvas.default":"Default","editor.chooseCanvas.select":"Select Canvas","editor.chooseCanvas.selected":"Selected Canvas","editor.code.evalError.message":"Please check the console to verbose","editor.color.select":"Select color","editor.command.align.description":"Align selection","editor.command.autoLayout.description":"Cluster items by route + tile","editor.command.category.components":"Components","editor.command.category.functions":"Functions","editor.command.category.pages":"Pages","editor.command.delete.description":"Delete selection","editor.command.distribute.description":"Distribute selection equally","editor.command.docs.description":"Open documentation","editor.command.duplicate.description":"Duplicate selection","editor.command.editor.description":"Toggle QuickEditor","editor.command.fit.description":"Fit selection (or all) to view","editor.command.frameMode.description":"Toggle live iframe previews","editor.command.go.description":"Navigate to route","editor.command.gridStep.description":"Set snap-grid step (canvas px)","editor.command.group.description":"Group selection","editor.command.guides.description":"Manage guides","editor.command.help.description":"Show shortcuts overlay","editor.command.mode.description":"Switch canvas mode","editor.command.open.description":"Open in explorer","editor.command.placeholder":"Search or /command","editor.command.redo.description":"Redo","editor.command.reset.description":"Reset viewport to 35%","editor.command.result.alignedBottom":"Aligned bottom","editor.command.result.alignedCenter":"Aligned center","editor.command.result.alignedLeft":"Aligned left","editor.command.result.alignedMiddle":"Aligned middle","editor.command.result.alignedRight":"Aligned right","editor.command.result.alignedTop":"Aligned top","editor.command.result.autoLaidOut":"Auto-laid out","editor.command.result.deleted":"Deleted","editor.command.result.distributedH":"Distributed horizontally","editor.command.result.distributedV":"Distributed vertically","editor.command.result.docsOpened":"Docs opened","editor.command.result.duplicated":"Duplicated","editor.command.result.editorClosed":"Editor closed","editor.command.result.editorOpened":"Editor opened","editor.command.result.fitToSelection":"Fit to selection","editor.command.result.gridSnapOff":"Grid snap off","editor.command.result.gridSnapOn":"Grid snap on","editor.command.result.gridStep":"Grid step: {n}","editor.command.result.grouped":"Grouped","editor.command.result.guideSnapOff":"Guide snap off","editor.command.result.guideSnapOn":"Guide snap on","editor.command.result.guidesCleared":"Guides cleared","editor.command.result.itemSnapOff":"Item snap off","editor.command.result.itemSnapOn":"Item snap on","editor.command.result.modeSwitched":"Switched to {mode}","editor.command.result.navigated":"Navigated to {path}","editor.command.result.needThree":"Select 3+ items first","editor.command.result.needTwo":"Select 2+ items first","editor.command.result.noCanvas":"No canvas","editor.command.result.noCanvasInstance":"No canvas instance","editor.command.result.opened":"Opened {key}","editor.command.result.redone":"Redone","editor.command.result.searching":"Searching: {query}","editor.command.result.selected":"Selected {key}","editor.command.result.settingsOpened":"Settings opened","editor.command.result.shortcutsOverlay":"Shortcuts overlay","editor.command.result.snapOff":"Snap off","editor.command.result.snapOn":"Snap on","editor.command.result.themeToggled":"Theme toggled","editor.command.result.undone":"Undone","editor.command.result.ungrouped":"Ungrouped","editor.command.result.unknown":"Unknown: /{cmd}","editor.command.result.unknownMode":"Unknown mode","editor.command.result.versionHistory":"Version history","editor.command.result.viewReset":"View reset","editor.command.result.zoomSet":"Zoom set to {value}%","editor.command.runPrefix":"Run {command}","editor.command.search.description":"Search canvas","editor.command.select.description":"Select on canvas","editor.command.settings.description":"Open settings","editor.command.shortcuts.description":"Show shortcuts overlay","editor.command.snap.description":"Toggle snap","editor.command.theme.description":"Toggle theme","editor.command.undo.description":"Undo last canvas change","editor.command.ungroup.description":"Ungroup selection","editor.command.usage.align":"Usage: /align [left|right|top|bottom|center|middle]","editor.command.usage.distribute":"Usage: /distribute [horizontal|vertical]","editor.command.usage.go":"Usage: /go [path]","editor.command.usage.gridStep":"Usage: /grid-step [N]","editor.command.usage.guides":"Usage: /guides clear","editor.command.usage.mode":"Usage: /mode [default|inspect|panning|interact]","editor.command.usage.open":"Usage: /open [key]","editor.command.usage.search":"Usage: /search [query]","editor.command.usage.select":"Usage: /select [key]","editor.command.usage.snap":"Usage: /snap [on|off|grid|items|guides]","editor.command.usage.theme":"Usage: /theme [dark|light]","editor.command.usage.zoom":"Usage: /zoom [percentage]","editor.command.versions.description":"Version history","editor.command.zoom.description":"Set zoom level","editor.compile.markdownToSymbols":"Markdown \u2192 Symbols","editor.compile.previewError":"Preview Error: {error}","editor.compile.source":"Source Code","editor.compile.subtitle":"Choose source and target to use compiler tools","editor.compile.symbolsToReact":"Symbols \u2192 React","editor.compile.symbolsToTailwind":"Symbols \u2192 Tailwind","editor.compile.tailwindToSymbols":"Tailwind \u2192 Symbols","editor.compile.target":"Target Code","editor.compile.title":"Symbols compiler tools","editor.compile.working":"Compiling...","editor.component.duplicateFailed.title":"Component was not duplicated","editor.connection.ci":"CI","editor.connection.cli":"CLI","editor.connection.connected":"Connected","editor.connection.lastPublish":"Last publish","editor.connection.noStaged":"You have no staged changes","editor.connection.published":"Published","editor.connection.publishingVersions":"Publishing and Versions","editor.connection.refresh":"Refresh connection","editor.connection.title":"Connection","editor.connection.unpublished":"Not published","editor.crud.duplicateFailed.message":"We could not rename {key} to {altKey}","editor.crud.duplicateFailed.title":"Could not duplicate","editor.crud.notFound.message":"We could not find {key} in {type}","editor.crud.notFound.title":"Could not find target element","editor.crud.projectIdRequired.message":"projectId is required for CollabService connection","editor.crud.projectIdRequired.title":"projectId is required","editor.crud.renameFailed.message":"We could not rename to {newKey} as it already exists","editor.crud.renameFailed.title":"Could not rename","editor.dangerZone.action":"Delete Project","editor.dangerZone.deleted.message":"The project has been successfully removed.","editor.dangerZone.deleted.title":"Success message","editor.dangerZone.failed.message":"Error: {error}","editor.dangerZone.failed.title":"Error message","editor.dangerZone.failedFallback":"Failed to delete project.","editor.dangerZone.hint":"Once you delete a project, there is no going back. Please be certain.","editor.dangerZone.title":"Delete Project","editor.dashboard.filter.all":"All","editor.dashboard.filter.favorites":"Favorites","editor.dashboard.filter.recents":"Recents","editor.dashboard.gettingStarted":"Getting Started","editor.dashboard.intro":"Welcome to your development dashboard where you can customize your branding, build components, pages and add functions and files.","editor.dashboard.newProject":"New Project","editor.dashboard.title":"Dashboard","editor.db.cacheCleared.message":"Cleared {count} cached items from database","editor.db.cacheCleared.title":"Cache is cleared","editor.db.componentKeyCapital":"Key \\"{key}\\" should start with a capital letter.","editor.db.componentKeyChars":"Key \\"{key}\\" contains a disallowed character. Use letters, numbers, dot, or underscore.","editor.db.convertedDomql3.message":"Converted {count} to domql3 format","editor.db.convertedDomql3.title":"Converted to domql3","editor.db.fileFormatInvalid":"File \\"{key}\\" does not have a valid format.","editor.db.fileSourceInvalid":"File \\"{key}\\" does not have a valid source.","editor.db.formatNotSupported":"File format \\"{format}\\" is not supported.","editor.db.invalidComponentKey":"Invalid component key","editor.db.invalidFile":"Invalid file","editor.db.invalidFunction":"Invalid function","editor.db.invalidPageKey":"Invalid page key","editor.db.notAFunction":"\\"{key}\\" is not a function type.","editor.db.pageKeySlash":"Page key \\"{key}\\" should start with \\"/\\".","editor.db.restoredComponents.message":"Restored {count} components","editor.db.restoredComponents.title":"Restored components","editor.db.restoredTypes.message":"Restored {count} types","editor.db.restoredTypes.title":"Restored types","editor.db.unsupportedFormat":"Unsupported file format","editor.dropdown.moreOptions":"More options","editor.ds.cssVars":"Use CSS variables:","editor.ds.defaultConfig":"Use default config:","editor.ds.globalThemes":"Apply Global Themes:","editor.ds.importFonts":"Import Fonts:","editor.ds.normalize":"Apply Symbols normalizing:","editor.ds.settingsTitle":"Design System Settings","editor.ds.spriteIcons":"Use Sprite for Icons:","editor.ds.spriteSvg":"Use Sprite for SVG:","editor.ds.title":"Design System","editor.ds.verbose":"Verbose mode:","editor.dsCard.breakpoints":"The devices and the breakpoints","editor.dsCard.colors":"Colorize styles manually","editor.dsCard.icons":"Label a role of subject with glyphs","editor.dsCard.sequence":"The mapping system of generative sizing units","editor.dsCard.shapes":"Design an outline to a chosen component","editor.dsCard.spacing":"Manage properties of a size","editor.dsCard.timing":"Tokens for transitions and animations","editor.dsCard.typography":"Style a typed material","editor.editDependency.cdnFile":"The CDN file for your dependencies:","editor.editDependency.cdnUrl":"Your dependencies file CDN URL:","editor.editIn.editCode":"Edit in Code","editor.editIn.label":"Edit in\u2026","editor.editIn.openEditor":"Open in Editor","editor.editIn.openSidebar":"Open in Sidebar","editor.editNavbar.copyTitle":"Copy title","editor.editNavbar.openDocs":"Open docs","editor.ext.addToCanvas":"Add to canvas","editor.ext.edit":"Edit","editor.ext.help":"Help","editor.ext.history":"History","editor.ext.inspect":"Inspect element","editor.ext.redo":"Redo","editor.ext.replace":"Replace","editor.ext.undo":"Undo","editor.ext.urlHint":"Type URL to start inspecting","editor.ext.urlPlaceholder":"Type URL to inspect","editor.fetch.addAuth":"Add auth","editor.fetch.addBody":"Add body","editor.fetch.addHeaders":"Add headers","editor.fetch.addParams":"Add params","editor.fetch.auth":"Auth","editor.fetch.authKey":"Auth key","editor.fetch.authValue":"Auth value","editor.fetch.body":"Body","editor.fetch.endpointUrl":"Endpoint URL:","editor.fetch.error":"Error with fetching","editor.fetch.headerKey":"Header key","editor.fetch.headerValue":"Header value","editor.fetch.headers":"Headers","editor.fetch.keyRequired.message":"Name the fetch entry before saving it.","editor.fetch.keyRequired.title":"Key is required","editor.fetch.paramKey":"Param key","editor.fetch.paramValue":"Param value","editor.fetch.params":"Params","editor.fetch.previewRequest":"Preview Request","editor.fetch.removeBody":"Remove body","editor.fetch.routePlaceholder":"Type the API route","editor.fetch.runtime":"Runtime","editor.fetch.stateKey":"Key","editor.fetch.stateKeyPlaceholder":"Key of the state","editor.fetch.stateTitle":"Title","editor.fetch.stateTitlePlaceholder":"Title of the state","editor.fetch.valueRequired.message":"Give the fetch entry a value before saving it.","editor.fetch.valueRequired.title":"Value is not assigned","editor.grid.options":"Grid options","editor.icons.add":"Add icon","editor.icons.filled":"Filled","editor.icons.multicolor":"Multicolor","editor.icons.outline":"Outline","editor.icons.type":"Icon type","editor.import.liveWebsite":"Live website","editor.import.liveWebsiteDescr":"Open any website and select what to import","editor.import.localFiles":"Local files","editor.import.localFilesDescr":"Import your local starter-kit using CLI","editor.insert.customDataSourceDescr":"Add custom endpoint as data source","editor.insert.dataSources":"Data sources","editor.insert.dragHint":"Drag and drop these components to your canvas","editor.insert.expandIcons":"Expand icons","editor.insert.expandLibrary":"Expand library","editor.insert.from":"Insert from","editor.insert.fromLibrary":"Insert From Library","editor.insert.import":"Import","editor.insert.searchIcons":"Search icons","editor.insert.searchLibrary":"Search library","editor.insert.title":"Insert","editor.layerNavbar.addChildren":"Add children","editor.layerNavbar.options":"Options","editor.library.howItWorks":"How it works?","editor.library.searchPlaceholder":"Search library...","editor.logoMenu.about":"About Symbols","editor.logoMenu.activeProject":"Active Project","editor.logoMenu.ariaLabel":"Symbols menu","editor.logoMenu.backToWorkspace":"Back to workspace","editor.logoMenu.freePlan":"Free plan","editor.logoMenu.general":"General","editor.logoMenu.project":"Project","editor.logoMenu.projectSettings":"Project Settings","editor.logoMenu.soon":"(soon)","editor.logoMenu.support":"Support","editor.logoMenu.switchProject":"Switch project","editor.logoMenu.upgradeTeam":"Upgrade to team","editor.logoMenu.user":"User","editor.logoMenu.whatsNew":"Whats New?","editor.mode.code":"Code mode","editor.mode.comment":"Comment mode","editor.mode.comments":"Comments mode","editor.mode.default":"Default mode","editor.mode.inspect":"Inspect mode","editor.mode.more":"More modes","editor.mode.moreCanvas":"More canvas modes","editor.mode.pan":"Pan mode","editor.mode.preview":"Preview mode","editor.mode.view":"View mode","editor.overlay.openAnyway":"Open anyway","editor.overlay.smallView":"Small view is temporarily disabled, please check from larger screens","editor.overlay.unlockAll":"Unlock all features...","editor.overlay.unlockAllDescr":"Work with team and AI, remove limits, unlock custom domains with SEO and more...","editor.overlay.unlockEditing":"Unlock editing!","editor.overlay.unlockEditingDescr":"Sign up to unlock more features, use templates, 5000+ components and more...","editor.panel.aiAssistant":"AI Assistant","editor.panel.animation":"Animation","editor.panel.animations":"Animations","editor.panel.artboards":"Artboards","editor.panel.assets":"Assets","editor.panel.breakpoints":"Breakpoints","editor.panel.cases":"Cases","editor.panel.colors":"Colors","editor.panel.dependencies":"Dependencies","editor.panel.fonts":"Fonts","editor.panel.functions":"Functions","editor.panel.grids":"Grids","editor.panel.icons":"Icons","editor.panel.integrations":"Integrations","editor.panel.responsive":"Responsive","editor.panel.sequence":"Sequence","editor.panel.shapes":"Shapes","editor.panel.spacing":"Spacing","editor.panel.state":"State","editor.panel.timing":"Timing","editor.panel.typography":"Typography","editor.position.alignLeft":"Align to left","editor.position.alignRight":"Align to right","editor.position.expand":"Expand","editor.position.minimize":"Minimize","editor.previewModes.localRender":"Local render","editor.previewModes.newTab":"Open in new tab","editor.previewModes.remotePreview":"Remote preview","editor.previewModes.selectHint":"Select the component or page to preview","editor.project.ambiguousKey.message":"The key \\"{key}\\" names more than one project: {candidates}. Open the project by its owner and key.","editor.project.ambiguousKey.title":"Choose the project\'s owner","editor.project.branchSwitchFailed":"Failed to switch to branch \\"{branch}\\": {error}","editor.project.company":"Company","editor.project.createFirst":"Create your first project","editor.project.inThisWorkspace":"in this workspace","editor.project.inviteLeft":"You can invite {count} more users","editor.project.notFound.message":"Project with key \\"{key}\\" not found or you don\'t have access to it.","editor.project.notFound.title":"Project Not Found","editor.project.openInWebsites":"Open in Websites","editor.project.packageLabel":"Package","editor.project.premium":"Premium","editor.project.publishes":"Publishes","editor.project.starter":"Starter","editor.project.untitled":"Project","editor.project.userSince":"User since","editor.project.versionSwitchFailed":"Failed to switch to version \\"{version}\\": {error}","editor.quick.addElement":"Add element","editor.quick.deleteConfirm":"Delete layer?","editor.quick.deleteLayer":"Delete {layer}","editor.quick.dragLayer":"Drag {layer} to reorder","editor.quick.dragToReorder":"Drag to reorder","editor.quick.el.button":"Button","editor.quick.el.container":"Container","editor.quick.el.heading":"Heading","editor.quick.el.text":"Text","editor.quick.field.background":"Background","editor.quick.field.color":"Color","editor.quick.field.flow":"Flow","editor.quick.field.fontSize":"Font size","editor.quick.field.padding":"Padding","editor.quick.field.text":"Text","editor.quick.field.textPlaceholder":"Element text","editor.quick.hideProperties":"Hide properties","editor.quick.properties":"Element properties","editor.quick.root":"Root","editor.quickAdd.addBlank":"Add blank","editor.quickAdd.applyAction":"apply action","editor.quickAdd.component":"Component","editor.quickAdd.component2":"Components","editor.quickAdd.dependency":"Dependency","editor.quickAdd.file":"File","editor.quickAdd.method":"Method","editor.quickAdd.page":"Page","editor.quickAdd.reuse":"Reuse","editor.quickAdd.title":"Quick add","editor.quickAdd.typePlaceholder":"Type {example}...","editor.quickEditor.deleteConfirm":"Delete {name}?","editor.remote.confirmDelete":"Delete this row? This cannot be undone.","editor.remote.deleteFailed":"Delete failed","editor.remote.deleteRow":"Delete row","editor.remote.editRow":"Edit row","editor.remote.introspecting":"Introspecting schema\u2026","editor.remote.newRow":"New row","editor.remote.rowDeleted":"Row deleted","editor.remote.saveFailed":"Save failed","editor.resetModal.reverting":"Reverting to v1.{version}","editor.selectedNavbar.componentPlaceholder":"Type ComponentName","editor.selectedNavbar.dsTitle":"Design system \xb7 {route}","editor.selectedNavbar.pathPlaceholder":"Type /page-path","editor.selectedNavbar.preview":"Preview","editor.sidebar.addNew":"Add new","editor.sidebar.clearSearch":"Clear search","editor.sidebar.collapseSection":"Collapse section","editor.sidebar.editCode":"Edit code","editor.sidebar.expandSection":"Expand section","editor.sidebar.fontFamilies":"Font Families","editor.sidebar.learningCentre":"Learning centre","editor.sidebar.methods":"Methods","editor.sidebar.secrets":"Secrets","editor.sidebar.snippets":"Snippets","editor.sidebar.sortAz":"Sort A/Z","editor.sidebar.textStyles":"Text Styles","editor.sidebar.themes":"themes","editor.subdomain.error":"Error creating subdomain","editor.subdomain.registered":"\\"{key}\\" subdomain has been registered","editor.test.didNotPass":"Did not pass, was not applied. Please check console for more details.","editor.test.failed":"{key} failed:","editor.textNavbar.assistant":"Assistant","editor.textNavbar.learn":"Learn","editor.theming.darkMode":"Dark mode","editor.theming.darkTheme":"Dark theme","editor.theming.lightMode":"Light mode","editor.theming.lightTheme":"Light theme","editor.tools.editOptions":"Edit options","editor.tutorialModal.descr":"Watch youtube video.","editor.tutorialModal.title":"Tutorial","editor.uploadFont.name":"Font name","editor.uploadFont.namePlaceholder":"Name the font","editor.uploadFont.weights":"Weights","editor.welcomeModal.descr":"Watch youtube video.","editor.welcomeModal.title":"Tutorial","editor.zoombar.docs":"Docs","editor.zoombar.fitToContent":"Fit to content","editor.zoombar.fitUnavailable":"Fit is available on a project canvas","editor.zoombar.loading":"Zoom controls are loading\u2026","editor.zoombar.presets":"Zoom presets","editor.zoombar.settings":"Settings","editor.zoombar.shortcuts":"Keyboard shortcuts","editor.zoombar.shortcutsTooltip":"Keyboard shortcuts (\u2318/)"}');

});

parcelRegister("SIxy5", function(module, exports) {
module.exports = JSON.parse('{"files.answer.empty":"No files match.","files.answer.failed":"Could not load the files.","files.answer.kind.all":"All","files.answer.kind.document":"Document","files.answer.kind.folder":"Folder","files.answer.kind.image":"Image","files.answer.kind.media":"Media","files.answer.kind.note":"Note","files.answer.kind.other":"File","files.answer.title":"Files","files.answer.untitled":"Untitled","files.contextMenu.cleanUpGrid":"Clean up grid","files.contextMenu.copyLink":"Copy link","files.contextMenu.delete":"Delete","files.contextMenu.deleteMany":"Delete {count} items","files.contextMenu.download":"Download","files.contextMenu.getInfo":"Get info","files.contextMenu.moveToFolder":"Move to folder\u2026","files.contextMenu.moveToNotes":"Move to Notes","files.contextMenu.moveToPrivate":"Move to private","files.contextMenu.moveToPrivateDenied":"Move to private \u2014 creator only","files.contextMenu.moveToShared":"Move to shared","files.contextMenu.newFolder":"New folder","files.contextMenu.newTab":"Open in new tab","files.contextMenu.open":"Open","files.contextMenu.openIn":"Open in {app}","files.contextMenu.openInInstall":"Open in {app}\u2026","files.contextMenu.openWith":"Open with","files.contextMenu.rename":"Rename","files.contextMenu.selectAll":"Select all","files.contextMenu.sharePublic":"Share public link\u2026","files.contextMenu.uploadFiles":"Upload files","files.delete.confirmTitle":"Delete \u201C{name}\u201D?","files.delete.confirmTitleMany":"Delete {count} items?","files.delete.failedMessage":"\u201C{name}\u201D was not deleted. It is still here.","files.delete.failedTitle":"Delete failed","files.delete.itemFallback":"item","files.delete.messageMany":"This permanently removes these items and any stored file. This can\u2019t be undone.","files.delete.messageManyFolder":"This permanently removes these items \u2014 folders delete everything inside them \u2014 and any stored file. This can\u2019t be undone.","files.delete.messageOne":"This permanently removes this item and any stored file. This can\u2019t be undone.","files.delete.messageOneFolder":"This permanently removes this item \u2014 folders delete everything inside them \u2014 and any stored file. This can\u2019t be undone.","files.desktop.dragHandle":"Drag to chat or canvas","files.desktop.dropHint":"Drop files to upload","files.download.failedTitle":"Download failed","files.folderPicker.desktop":"Desktop","files.folderPicker.empty":"No folders yet","files.folderPicker.folder":"Folder","files.handler.notes":"Notes","files.info.created":"Created","files.info.createdBy":"Created by","files.info.dimensions":"Dimensions","files.info.duration":"Duration","files.info.format":"Format","files.info.itemCount":"{count} items","files.info.itemOne":"1 item","files.info.items":"Items","files.info.kind":"Kind","files.info.measuring":"Measuring\u2026","files.info.modified":"Modified","files.info.sharing":"Sharing","files.info.sharingPrivate":"Private (only you)","files.info.sharingShared":"Shared (workspace)","files.info.size":"Size","files.info.storagePath":"Storage path","files.info.where":"Where","files.infoType.doc":"Document","files.infoType.folder":"Folder","files.infoType.html":"Html","files.infoType.image":"Image","files.infoType.md":"Md","files.infoType.other":"Other","files.infoType.pdf":"Pdf","files.infoType.text":"Text","files.infoType.video":"Video","files.link.copiedMessage":"{name} \u2014 universal link copied to clipboard","files.link.copiedTitle":"Link copied","files.link.copyFailedTitle":"Copy failed","files.link.fallbackName":"Link","files.node.untitled":"Untitled","files.openWith.icloudMessage":"iCloud can\u2019t open a file from a link, so a copy of \u201C{name}\u201D was downloaded \u2014 drop it into the {app} tab that just opened.","files.openWith.icloudTitle":"Opening {app}","files.openWith.thisFile":"this file","files.page.files.title":"Files","files.rename.failedMessage":"Couldn\'t rename \u2014 the previous name was restored.","files.rename.failedTitle":"Rename failed","files.scope.moveFailedMessage":"Nothing was moved \u2014 the previous location was restored.","files.scope.moveFailedPrivateTitle":"Couldn\u2019t move everything to private","files.scope.moveFailedSharedTitle":"Couldn\u2019t move everything to shared","files.scope.movePartialFromPrivate":"{failed} of {total} items stayed in Private \u2014 they are still visible there.","files.scope.movePartialFromShared":"{failed} of {total} items stayed in Shared \u2014 they are still visible there.","files.scope.privateDeniedMany":"{count} of the selected items were created by somebody else. A private item is visible to its creator only, so moving them would hide them from everybody.","files.scope.privateDeniedOne":"\u201C{name}\u201D was created by {who}. A private item is visible to its creator only, so this move would hide it from everybody \u2014 including {who}.","files.scope.privateDeniedThisItem":"This item","files.scope.privateDeniedTitle":"Only the creator can make this private","files.sidebar.actionsGroup":"ACTIONS","files.sidebar.canvasGroup":"CANVAS","files.sidebar.filterAll":"All","files.sidebar.filterDocs":"Documents","files.sidebar.filterFolders":"Folders","files.sidebar.filterGroup":"FILTER","files.sidebar.filterImages":"Images","files.sidebar.filterVideos":"Videos","files.sidebar.locationGroup":"LOCATION","files.sidebar.navLabel":"Files navigation","files.sidebar.newFolder":"New folder","files.sidebar.scopePrivate":"Private","files.sidebar.scopeShared":"Shared","files.sidebar.upload":"Upload","files.upload.failedTitle":"Upload failed","files.viewer.download":"Download","files.viewer.moreActions":"More actions","files.viewer.openInDrive":"Open in Google Drive","files.empty.title":"A place for your team\u2019s work","files.empty.hint":"Drop files anywhere on the canvas, or add a folder to get organized.","files.empty.filtered":"No files match this view","files.empty.error":"Files could not be loaded","files.empty.errorHint":"Check your connection and reopen Files to try again."}');

});

parcelRegister("b92ei", function(module, exports) {
module.exports = JSON.parse('{"flags.agents.descr":"The people + agents panzoom canvas at /agents and /team-and-agents.","flags.agents.label":"Team & agents canvas","flags.agentsAssignments.descr":"Assigning agents to people and tasks.","flags.agentsAssignments.label":"Agent assignments","flags.agentsMyAgents.descr":"The agents-only canvas filtered to yours.","flags.agentsMyAgents.label":"My agents view","flags.agentsPermissions.descr":"Per-agent permission chips and scopes.","flags.agentsPermissions.label":"Agent permissions","flags.agentsTools.descr":"Tool grants on each agent profile.","flags.agentsTools.label":"Agent tools","flags.aiAssistant.descr":"The \\"Whats up?\\" composer, AI answer views, and in-app build flows.","flags.aiAssistant.label":"AI assistant","flags.aiAssistantAnswerViews.descr":"Transient AI-drawn pages you can save as apps.","flags.aiAssistantAnswerViews.label":"AI answer views","flags.aiAssistantBuildApps.descr":"Prompt-to-app builds that land in /add-app.","flags.aiAssistantBuildApps.label":"Build apps with AI","flags.aiAssistantComposer.descr":"The \\"Whats up?\\" bar docked to every surface.","flags.aiAssistantComposer.label":"Composer bar","flags.aiAssistantModuleAi.descr":"AI operating installed apps (CRM contacts, CMS entries, \u2026).","flags.aiAssistantModuleAi.label":"Module AI actions","flags.aiAssistantPageAwareness.descr":"The assistant sees your current page and data scope.","flags.aiAssistantPageAwareness.label":"Page & data awareness","flags.aiAssistantReasoningTimeline.descr":"The live thinking pill and tool steps above the composer.","flags.aiAssistantReasoningTimeline.label":"Reasoning timeline","flags.aiAssistantSuggestionChips.descr":"Contextual apply-changes chips when idle.","flags.aiAssistantSuggestionChips.label":"Suggestion chips","flags.analytics.descr":"Project + workspace analytics, the live map, and the logs explorer.","flags.analytics.label":"Analytics & logs","flags.analyticsBugsFeed.descr":"AI-analyzed bug events at /logs/bugs.","flags.analyticsBugsFeed.label":"Bugs feed","flags.analyticsLiveMap.descr":"The realtime visitor map.","flags.analyticsLiveMap.label":"Live map","flags.analyticsLogs.descr":"Sessions, events, network, and verbose logs.","flags.analyticsLogs.label":"Logs explorer","flags.analyticsProjectAnalytics.descr":"Per-project traffic and usage dashboards.","flags.analyticsProjectAnalytics.label":"Project analytics","flags.analyticsSessionsExplorer.descr":"Per-session replays and timelines.","flags.analyticsSessionsExplorer.label":"Sessions explorer","flags.analyticsWorkspaceUsage.descr":"Org-level usage rollups.","flags.analyticsWorkspaceUsage.label":"Workspace usage","flags.announcements.descr":"The company blog and posts feed at /announcements.","flags.announcements.label":"Announcements","flags.announcementsPolls.descr":"Polls inside announcement posts.","flags.announcementsPolls.label":"Polls","flags.announcementsTagFilters.descr":"The Product / People / Ops post filters.","flags.announcementsTagFilters.label":"Tag filters","flags.appsSandbox.descr":"Apps built by AI run in an isolated frame that cannot reach your account, storage or the workspace.","flags.appsSandbox.label":"Isolated AI apps","flags.calendar.descr":"Events, bookings, and the mini-calendar rail at /calendar.","flags.calendar.label":"Calendar","flags.calendarAvailability.descr":"Free/busy overlays for teammates.","flags.calendarAvailability.label":"Team availability","flags.calendarBookings.descr":"Bookable slots and scheduling links.","flags.calendarBookings.label":"Bookings","flags.calendarLinkedResources.descr":"Tasks and docs linked onto event cells.","flags.calendarLinkedResources.label":"Linked resources","flags.calendarMiniCalendar.descr":"The month mini-map in the calendar sidebar.","flags.calendarMiniCalendar.label":"Mini calendar rail","flags.calendarMonthWeekViews.descr":"The Month / Week view switcher.","flags.calendarMonthWeekViews.label":"Month & week views","flags.calendarReminders.descr":"Event reminders and nudges.","flags.calendarReminders.label":"Reminders","flags.calendarTeamView.descr":"The cross-member team lane view.","flags.calendarTeamView.label":"Team view","flags.chat.descr":"Channels, DMs, threads, and the floating messenger overlay.","flags.chat.label":"Chat & messenger","flags.chatChannels.descr":"Team channels and their message history.","flags.chatChannels.label":"Channels","flags.chatChatDrawer.descr":"The docked drawer beside the home rail.","flags.chatChatDrawer.label":"Chat drawer","flags.chatDirectMessages.descr":"One-to-one and group DMs.","flags.chatDirectMessages.label":"Direct messages","flags.chatMessengerOverlay.descr":"The floating conversations window on canvas pages.","flags.chatMessengerOverlay.label":"Messenger overlay","flags.chatThreads.descr":"Threaded replies on channel messages.","flags.chatThreads.label":"Threads","flags.communityFeed.descr":"Shared projects, follows, and comments at /feed.","flags.communityFeed.label":"Community feed","flags.communityFeedComments.descr":"Inline comment threads on shared projects.","flags.communityFeedComments.label":"Post comments","flags.communityFeedFollows.descr":"Following creators and the Following filter.","flags.communityFeedFollows.label":"Follows","flags.communityFeedShareComposer.descr":"Posting your public projects to the feed.","flags.communityFeedShareComposer.label":"Share composer","flags.company.descr":"The org overview page at /company.","flags.company.label":"Company page","flags.companyProfileEditing.descr":"Editing the org profile shown at /company.","flags.companyProfileEditing.label":"Company profile editing","flags.customApps.descr":"Your own installed extensions and AI-built apps at /add-app.","flags.customApps.label":"Custom apps","flags.customAppsAiBuilt.descr":"Apps promoted from AI answer views.","flags.customAppsAiBuilt.label":"AI-built apps","flags.customAppsSharing.descr":"Sharing installed apps workspace-wide.","flags.customAppsSharing.label":"App sharing","flags.data.descr":"The admin data surface at /data \u2014 users, orgs, projects, plans.","flags.data.label":"Data browser","flags.dataExternalSources.descr":"Connected external datasets at /data/external.","flags.dataExternalSources.label":"External sources","flags.dataOrganizations.descr":"The /data/organizations browser.","flags.dataOrganizations.label":"Organizations table","flags.dataPlans.descr":"The /data/plans and /data/subscriptions browsers.","flags.dataPlans.label":"Plans & subscriptions","flags.dataProjects.descr":"The /data/projects browser.","flags.dataProjects.label":"Projects table","flags.dataTeams.descr":"The /data/teams browser.","flags.dataTeams.label":"Teams table","flags.dataUsers.descr":"The /data/users browser.","flags.dataUsers.label":"Users table","flags.documents.descr":"Docs, notes, and the KB at /notes.","flags.documents.label":"Notes & knowledge base","flags.documentsCollabEditing.descr":"Multiplayer editing on documents.","flags.documentsCollabEditing.label":"Collaborative editing","flags.documentsEditor.descr":"The block editor at /notes/editor.","flags.documentsEditor.label":"Note editor","flags.documentsExportTools.descr":"Exporting docs from the sidebar.","flags.documentsExportTools.label":"Export tools","flags.documentsKnowledgeBase.descr":"The structured KB at /notes/knowledge-base.","flags.documentsKnowledgeBase.label":"Knowledge base","flags.documentsNotes.descr":"Personal and shared notes.","flags.documentsNotes.label":"Notes","flags.files.descr":"The file desktop and folder navigation at /files.","flags.files.label":"Files desktop","flags.filesDesktopGrid.descr":"The icon desktop with drag arrangement.","flags.filesDesktopGrid.label":"Desktop grid","flags.filesFolders.descr":"Folder navigation and the location breadcrumb.","flags.filesFolders.label":"Folders","flags.group.ai.descr":"The assistant, realtime presence, and multitasking chrome.","flags.group.ai.label":"AI & collaboration","flags.group.apps.descr":"Discovering, installing, and building apps on the platform.","flags.group.apps.label":"Marketplace & apps","flags.group.basics.descr":"The foundation every workspace runs on \u2014 always on, not switchable.","flags.group.basics.label":"Basics","flags.group.modules.descr":"The built-in apps mounted on workspace routes and navbar tabs.","flags.group.modules.label":"Workspace modules","flags.group.views.descr":"The four org-level lenses the sidebar VIEWS switcher jumps between.","flags.group.views.label":"Canvas views","flags.history.descr":"The workspace activity log as a timeline.","flags.history.label":"History","flags.home.descr":"The signed-in landing at / with its widget grid and app icons.","flags.home.label":"Home dashboard","flags.homeAgentsWidget.descr":"The team-and-agents canvas embedded on the dashboard.","flags.homeAgentsWidget.label":"Agents widget","flags.homeAnalyticsWidget.descr":"Users-today traction card on the dashboard.","flags.homeAnalyticsWidget.label":"Analytics widget","flags.homeAppIcons.descr":"iPad-style app icons that open modules in a window.","flags.homeAppIcons.label":"App icon grid","flags.homeChatRail.descr":"The chat shortcuts column beside the dashboard.","flags.homeChatRail.label":"Channels & DMs rail","flags.homeEventsWidget.descr":"Upcoming calendar events on the dashboard.","flags.homeEventsWidget.label":"Events widget","flags.homeWidgets.descr":"The widget grid and customize mode on the home canvas.","flags.homeWidgets.label":"Dashboard widgets","flags.infra.descr":"Services, environments, and deploy status at /infra.","flags.infra.label":"Infra","flags.infraEnvironments.descr":"Dev / staging / production environment lanes.","flags.infraEnvironments.label":"Environments","flags.infraServicesList.descr":"The services rail with health per service.","flags.infraServicesList.label":"Services list","flags.infraStatusPage.descr":"The service status panel at /infra/status.","flags.infraStatusPage.label":"Status page","flags.mail.descr":"The built-in email client \u2014 personal and shared mailboxes from Google Workspace, Gmail, Microsoft 365 and Outlook.","flags.mail.label":"Mail","flags.marketplace.descr":"The catalog of templates, libraries, integrations, and workspace apps.","flags.marketplace.label":"Marketplace","flags.marketplaceDetailGallery.descr":"The App-Store screenshot gallery in item details.","flags.marketplaceDetailGallery.label":"Detail gallery","flags.marketplaceFeatured.descr":"The editorial Featured strips on the catalog.","flags.marketplaceFeatured.label":"Featured rails","flags.marketplaceLivePreviews.descr":"The in-modal live iframe preview of projects.","flags.marketplaceLivePreviews.label":"Live previews","flags.meet.descr":"Calls, rooms, transcripts, and guest invites at /meet.","flags.meet.label":"Meet","flags.meetGuestLinks.descr":"Unauthenticated guests joining via invite URL.","flags.meetGuestLinks.label":"Guest invite links","flags.meetLiveCaptions.descr":"On-screen captions during calls.","flags.meetLiveCaptions.label":"Live captions","flags.meetRooms.descr":"Persistent rooms with in-progress indicators.","flags.meetRooms.label":"Rooms","flags.meetTranscripts.descr":"Live transcription and post-call transcripts.","flags.meetTranscripts.label":"Transcripts","flags.multiWorkspace.descr":"Working across several workspaces via /w/<org> prefixed routes.","flags.multiWorkspace.label":"Multi-workspace tabs","flags.multiWorkspaceOrgSwitcher.descr":"Switching organizations from the header menu.","flags.multiWorkspaceOrgSwitcher.label":"Org switcher","flags.multiWorkspaceWorkspaceUrls.descr":"The /w/<org> prefix that scopes routes per workspace.","flags.multiWorkspaceWorkspaceUrls.label":"Workspace URLs","flags.notifications.descr":"Cross-app notification feed and unread indicators.","flags.notifications.label":"Notifications","flags.notificationsFeed.descr":"The bell dropdown with cross-app notifications.","flags.notificationsFeed.label":"Notification feed","flags.notificationsUnreadBadges.descr":"Unread counters on navbar icons and module tabs.","flags.notificationsUnreadBadges.label":"Unread badges","flags.people.descr":"Team roster at /people \u2014 members, roles, and profiles.","flags.people.label":"People directory","flags.peopleInvites.descr":"Inviting new members from the header and people page.","flags.peopleInvites.label":"Invites","flags.peopleMemberProfiles.descr":"Rich profile overlay with HR fields and working hours.","flags.peopleMemberProfiles.label":"Member profiles","flags.peopleRoleManagement.descr":"Changing member roles from person cards.","flags.peopleRoleManagement.label":"Role management","flags.profile.descr":"Your own profile, account settings, and session management.","flags.profile.label":"Profile & account","flags.promptGallery.descr":"Curated prompt collection at /marketplace/prompt-gallery.","flags.promptGallery.label":"Prompt gallery","flags.promptGalleryCopyActions.descr":"One-click copy on prompt cards.","flags.promptGalleryCopyActions.label":"Copy actions","flags.realtime.descr":"Live cursors, presence dots, and collaborative editing sessions.","flags.realtime.label":"Realtime presence & collab","flags.realtimeCollabSessions.descr":"Shared cursors and co-editing sessions.","flags.realtimeCollabSessions.label":"Live collab sessions","flags.realtimeOnlineDock.descr":"The bottom-left dock of members currently online.","flags.realtimeOnlineDock.label":"Online members dock","flags.realtimePresence.descr":"Online dots and live member status.","flags.realtimePresence.label":"Presence indicators","flags.reminders.descr":"Personal reminders and follow-ups.","flags.reminders.label":"Reminders","flags.resolutions.descr":"Customer requests and PR-like resolutions at /resolutions.","flags.resolutions.label":"Resolutions & requests","flags.resolutionsAudit.descr":"The audit trail across requests.","flags.resolutionsAudit.label":"Requests audit","flags.resolutionsEditRequests.descr":"Proposed edits awaiting review.","flags.resolutionsEditRequests.label":"Edit requests","flags.resolutionsImprovements.descr":"The improvements queue.","flags.resolutionsImprovements.label":"Improvements","flags.resolutionsRequests.descr":"Inbound/outbound request queues.","flags.resolutionsRequests.label":"Customer requests","flags.search.descr":"Global search across everything plus the apps launcher dropdown.","flags.search.label":"Search & app launcher","flags.searchAppsLauncher.descr":"The app-picker dropdown on the navbar search.","flags.searchAppsLauncher.label":"Apps launcher","flags.searchCommandSearch.descr":"Search across projects, people, tasks, and docs.","flags.searchCommandSearch.label":"Global search","flags.searchHeaderMorph.descr":"The tabs-to-searchbar morph in the header pill.","flags.searchHeaderMorph.label":"Header search morph","flags.shell.descr":"App navbar, routing, the workspace/org switcher, and page chrome.","flags.shell.label":"Workspace shell & navigation","flags.shellContextMenus.descr":"The global context menu on files, chat, and canvas surfaces.","flags.shellContextMenus.label":"Right-click menus","flags.shellKeyboardShortcuts.descr":"Keyflows and shortcut chords across the shell.","flags.shellKeyboardShortcuts.label":"Keyboard shortcuts","flags.shellModuleTabs.descr":"Installed module tabs (Tasks, Files, CMS, \u2026) in the top navbar.","flags.shellModuleTabs.label":"Navbar module tabs","flags.splitView.descr":"Opening pages in the PageSlot sheet, iPad-style split panes, fullscreen.","flags.splitView.label":"Split view & app windows","flags.splitViewAppWindows.descr":"Opening pages as sheets in the PageSlot.","flags.splitViewAppWindows.label":"App windows","flags.splitViewFullscreenMode.descr":"Edge-to-edge expansion of the open pane.","flags.splitViewFullscreenMode.label":"Fullscreen mode","flags.splitViewPageRestore.descr":"Reopening the last app window after reload (?page=).","flags.splitViewPageRestore.label":"Reload restore","flags.splitViewSplitPane.descr":"iPad-style side-by-side app panes.","flags.splitViewSplitPane.label":"Split panes","flags.studio.descr":"The project canvas at /studio: boards, project tiles, and the editor.","flags.studio.label":"Apps \u2014 frontend canvas","flags.studioCanvasSidebars.descr":"The floating left rails on canvas pages.","flags.studioCanvasSidebars.label":"Canvas sidebars","flags.studioProjectCreation.descr":"Creating new projects from the Apps canvas.","flags.studioProjectCreation.label":"Project creation","flags.studioProjectThumbnails.descr":"Screenshot covers on project tiles.","flags.studioProjectThumbnails.label":"Project thumbnails","flags.studioStudiosBoards.descr":"Multi-project canvas boards at /studio/<board>.","flags.studioStudiosBoards.label":"Apps boards","flags.tasks.descr":"The tasks kanban at /tasks \u2014 planning, filters, releases, roadmap.","flags.tasks.label":"Tasks board","flags.tasksFeatures.descr":"Feature epics at /tasks/epics.","flags.tasksFeatures.label":"Features","flags.tasksFeed.descr":"The activity stream at /tasks/feed.","flags.tasksFeed.label":"Tasks feed","flags.tasksGeneralTriage.descr":"The cross-workspace triage queue at /tasks/general.","flags.tasksGeneralTriage.label":"General triage","flags.tasksGithubSync.descr":"Two-way issue sync with GitHub repositories.","flags.tasksGithubSync.label":"GitHub sync","flags.tasksMyView.descr":"The Me filter \u2014 only tasks assigned to you.","flags.tasksMyView.label":"My view","flags.tasksPlanning.descr":"Status, Release, and Roadmap under PLANNING.","flags.tasksPlanning.label":"Planning pages","flags.tasksStandups.descr":"Daily standup entries alongside the board.","flags.tasksStandups.label":"Standups","flags.tasksTeamAgentLenses.descr":"The All / Team / Agents board lenses.","flags.tasksTeamAgentLenses.label":"Team & agent lenses","flags.tasksTypeFilters.descr":"Sidebar filters by issue type, assignee, and issuer.","flags.tasksTypeFilters.label":"Type & assignee filters","flags.theme.descr":"Theme switching, synced with your system preference.","flags.theme.label":"Dark & light theme","flags.themeSystemSync.descr":"Follow the OS light/dark preference automatically.","flags.themeSystemSync.label":"Sync with system","flags.themeWorkspaceSkins.descr":"Per-workspace design-system overrides from modules.","flags.themeWorkspaceSkins.label":"Workspace skins","flags.workspaceApps.descr":"Installable full apps \u2014 CRM, HR, Commerce, Scheduling, CMS, Financials.","flags.workspaceApps.label":"Workspace apps","flags.workspaceAppsCms.descr":"Content collections and publishing.","flags.workspaceAppsCms.label":"CMS","flags.workspaceAppsCommerce.descr":"Invoices and payments.","flags.workspaceAppsCommerce.label":"Commerce","flags.workspaceAppsCrm.descr":"Contacts and companies over the workspace directory.","flags.workspaceAppsCrm.label":"CRM","flags.workspaceAppsFinancials.descr":"Cap table, grants, and valuations.","flags.workspaceAppsFinancials.label":"Financials","flags.workspaceAppsHr.descr":"Team roster, roles, and reporting lines.","flags.workspaceAppsHr.label":"HR","flags.workspaceAppsScheduling.descr":"Bookings and appointments.","flags.workspaceAppsScheduling.label":"Scheduling"}');

});

parcelRegister("9dEvE", function(module, exports) {
module.exports = JSON.parse('{"infra.action.addDomain":"Add custom domain","infra.action.connectDomain":"Connect a domain","infra.action.deploy":"Deploy","infra.action.deployGithub":"Deploy from GitHub","infra.action.deployLatest":"Deploy latest","infra.action.recheck":"Recheck status","infra.action.removeDomain":"Remove domain","infra.action.removeImport":"Remove import","infra.action.removeService":"Remove service","infra.action.rollback":"Roll back","infra.api.apiRef":"API reference","infra.api.cliDesc":"Scaffold, run, and ship projects straight from your terminal \u2014 auth is shared with this session.","infra.api.connectHead":"CONNECT","infra.api.docs":"Documentation","infra.api.docsLink":"Docs \u2197","infra.api.intro":"The managed Symbols platform API. Every project, workspace, build, and domain in this workspace is created and served through it \u2014 there is no server to run. Reach it three ways:","infra.api.mcpDesc":"Model Context Protocol server \u2014 lets AI agents (Claude, Cursor) read framework rules and generate/audit components against this API.","infra.api.resourcesHead":"RESOURCES","infra.api.sdkDesc":"Typed client for every endpoint \u2014 sdk.execute(entity, op, args) or the flat methods used across this app.","infra.api.test":"Test connection","infra.api.unreachable":"unreachable","infra.banner.demoLead":"Demo topology \u2014 deploy your first real service to replace it.","infra.banner.emptyLead":"No services deployed yet \u2014 deploy your first one.","infra.confirm.deployMessage":"A new build starts from the latest commit. When it succeeds, it replaces the running version.","infra.confirm.deployTitle":"Deploy \u201C{name}\u201D?","infra.confirm.removeDomainMessage":"The project stops serving on this hostname. You can connect the domain again later.","infra.confirm.removeDomainTitle":"Remove the domain \u201C{host}\u201D?","infra.confirm.removeImportMessage":"The import leaves this workspace. Its build and deployment history stays, and a deployed service keeps running.","infra.confirm.removeImportTitle":"Remove the import \u201C{name}\u201D?","infra.confirm.removeServiceMessage":"The service and its connections are removed from the demo.","infra.confirm.removeServiceTitle":"Remove the service \u201C{name}\u201D?","infra.confirm.removeVarMessage":"The next build runs without it. Until then, the running service keeps the current value.","infra.confirm.removeVarTitle":"Remove the variable {key}?","infra.confirm.rollbackMessage":"The service runs the build of this deployment again. A new deployment is added to the history.","infra.confirm.rollbackTitle":"Roll back \u201C{name}\u201D to {version}?","infra.contextMenu.fitView":"Fit to view","infra.contextMenu.newAria":"New service","infra.contextMenu.palette":"Command palette","infra.contextMenu.resetView":"Reset view","infra.contextMenu.status":"System status","infra.copy.baseUrl":"Copy base URL","infra.copy.installCmd":"Copy install command","infra.copy.workspaceId":"Copy workspace ID","infra.count.replicaMany":"{count} replicas","infra.count.replicaOne":"{count} replica","infra.count.serviceMany":"{count} services","infra.count.serviceOne":"{count} service","infra.create.cronHint":"Scheduled job.","infra.create.domainHint":"Connect a custom domain.","infra.create.image":"Docker Image","infra.create.imageHint":"Deploy a container image.","infra.create.island":"Create service","infra.create.mongoHint":"Managed Mongo database.","infra.create.mysqlHint":"Managed MySQL database.","infra.create.postgresHint":"Managed Postgres database.","infra.create.redisHint":"In-memory data store.","infra.create.repo":"GitHub Repo","infra.create.repoHint":"Deploy from a repository.","infra.create.volumeHint":"Persistent storage.","infra.create.workerHint":"Background worker.","infra.deploy.buildFailedShort":"Build failed.","infra.deploy.buildTimedOut":"The build timed out.","infra.deploy.empty":"No deployments yet.","infra.deploy.liveTag":"live","infra.deploy.rowFallback":"Deployment","infra.dns.addRecords":"Add these records at your DNS provider:","infra.dns.checking":"Checking your domain\u2026","infra.dns.configured":"This hostname is already configured on the project \u2014 connecting refreshes provisioning.","infra.dns.copyName":"Copy Name","infra.dns.copyType":"Copy Type","infra.dns.copyValue":"Copy Value","infra.dns.head":"DNS records to set","infra.dns.name":"Name","infra.dns.note":"Root/apex domains use the A records shown (or ALIAS/ANAME where supported). TLS is issued automatically once the records resolve.","infra.dns.redirect":"Redirect: {value}","infra.dns.redirectPair":"Redirect: {from} \u2192 {to}","infra.dns.routingMode":"Routing mode: {mode}","infra.dns.runCheck":"Run \u201CCheck DNS\u201D to get the exact records for this hostname.","infra.dns.type":"Type","infra.dns.value":"Value","infra.domain.alreadyConfigured":"Already configured on this project","infra.domain.deployFirstBody":"Custom domains attach to real projects. Deploy from GitHub first, then return here to check DNS and connect the hostname.","infra.domain.deployFirstTitle":"Deploy a project first","infra.domain.enterHost":"Enter a hostname first.","infra.domain.envLine":"Environment: {env}","infra.domain.linkCaption":"Connect a domain you already own \u2014 check DNS, add the records, and the edge verifies + issues TLS.","infra.domain.linkTitle":"Link existing domain","infra.domain.newCaption":"Search for and register a brand-new domain through Symbols.","infra.domain.newTitle":"New domain","infra.domain.noProjects":"No projects in this workspace yet","infra.domain.notAvailable":"Custom domains are not available on this server.","infra.domain.phaseCheck":"Check DNS","infra.domain.phaseChecking":"Checking\u2026","infra.domain.phaseConnect":"Connect domain","infra.domain.phaseConnecting":"Connecting\u2026","infra.domain.phaseDone":"Done","infra.domain.pickProject":"Pick a project first.","infra.domain.projectLine":"Project: {name}","infra.domain.projectNone":"none","infra.domain.routingLine":"Routing: {mode}","infra.domain.soonBody":"Searching and registering domains directly through Symbols is on the way. Until then, register with any provider and link it here \u2014 DNS verification and TLS are already fully automated.","infra.domain.soonTitle":"Registration is coming soon","infra.domain.stateLine":"State: {state}","infra.domain.stateReady":"State: ready to connect","infra.domain.statusHead":"Connection status","infra.domain.subChoose":"Connect a custom domain to a project in this workspace.","infra.domain.subLink":"Point a domain you own at a project \u2014 the edge and TLS are provisioned for you.","infra.domain.subNew":"Find and register a brand-new domain through Symbols.","infra.domain.switchToLink":"Link an existing domain instead","infra.domain.title":"Add a domain","infra.domain.untitled":"(untitled)","infra.domain.warningFallback":"Domain warning","infra.domain.warnings":"Warnings","infra.domainError.alreadyClaimed":"This hostname is already connected to another project.","infra.domainError.invalidDomain":"That does not look like a valid hostname.","infra.domainError.invalidMap":"The server rejected the domain payload.","infra.domainError.network":"Could not reach the server \u2014 check your connection and try again.","infra.domainError.provisioningFailed":"Cloudflare provisioning failed \u2014 try again in a moment.","infra.domainError.provisioningUnavailable":"Edge provisioning is not configured on this server yet \u2014 the domain was not saved.","infra.domainHint.active":"Connected. Traffic on this domain now routes to your project.","infra.domainHint.failed":"Provisioning failed \u2014 recheck, or remove and try again.","infra.domainHint.needsDns":"Add the records below at your DNS provider \u2014 we recheck automatically.","infra.domainHint.orphaned":"The edge lost this hostname \u2014 remove and connect it again.","infra.domainHint.pendingSsl":"Hostname verified \u2014 issuing the TLS certificate.","infra.domainHint.pendingValidation":"Records found \u2014 the edge is verifying your hostname.","infra.domainState.active":"Active","infra.domainState.failed":"Failed","infra.domainState.needsDns":"Waiting for DNS","infra.domainState.orphaned":"Orphaned","infra.domainState.pendingSsl":"Issuing certificate","infra.domainState.pendingValidation":"Verifying hostname","infra.env.current":"current","infra.env.switchTo":"switch to","infra.error.deploy":"Couldn\'t start the deploy","infra.error.forbidden":"You don\'t have permission to do this. Ask a workspace owner or admin.","infra.error.removeDomain":"Couldn\'t remove the domain","infra.error.removeImport":"Couldn\'t remove the import","infra.error.rollback":"Couldn\'t roll back","infra.error.saveImport":"Couldn\'t save the import","infra.field.domain":"Domain","infra.field.environment":"Environment","infra.field.private":"Private","infra.field.project":"Project","infra.field.publicUrl":"Public URL","infra.field.region":"Region","infra.field.replicas":"Replicas","infra.field.source":"Source","infra.field.verification":"Verification","infra.filter.all":"All services","infra.filter.apps":"Apps & workers","infra.filter.databases":"Databases","infra.filter.networking":"Networking","infra.filter.storage":"Storage","infra.import.autoDetect":"auto-detect","infra.import.branch":"Branch","infra.import.builder":"Builder","infra.import.head":"IMPORT SETTINGS","infra.import.root":"Service root","infra.import.save":"Save import settings","infra.logs.buildFailedHead":"LAST BUILD FAILED","infra.logs.external":"Open build logs \u2197","infra.logs.load":"Load build logs","infra.logs.loading":"Loading build logs\u2026","infra.logs.noBuildsYet":"No builds yet.","infra.logs.reload":"Reload build logs","infra.logs.simulated":"Runtime tail is simulated \u2014 log streaming needs the Cloud Logging pipe.","infra.logs.unavailable":"No build logs available yet.","infra.metric.latency":"{count} ms","infra.metric.live":"live","infra.metrics.memory":"MEMORY","infra.metrics.noteLive":"Simulated values \u2014 the live metrics collector is not built yet.","infra.metrics.noteMock":"Last 1h average \xb7 mocked","infra.node.demo":"DEMO","infra.page.canvas":"Infra","infra.palette.connectDomain":"Connect custom domain","infra.palette.create":"Create {name}","infra.palette.createHint":"New service","infra.palette.deployGithubHint":"Connect \xb7 import \xb7 build","infra.palette.goto":"Go to {name}","infra.palette.placeholder":"Search actions, services, environments\u2026","infra.palette.switchEnv":"Switch to {name}","infra.repo.alreadyImported":"{name} is already imported.","infra.repo.deploys":"deploys {branch}","infra.repo.importingAny":"Importing the repository \u2014 the first build starts right after.","infra.repo.importingLine":"Importing {name} \u2014 the first build starts right after.","infra.repo.install":"Install the GitHub App","infra.repo.installBody":"Install the Symbols build app for this workspace and grant it the repositories you want to deploy. You land back here when it finishes.","infra.repo.noInstallUrl":"This server has no GitHub App install URL configured yet \u2014 ask an admin to set the build app slug, then recheck.","infra.repo.noMatch":"No repositories match that search.","infra.repo.noRepos":"The installation has no repositories \u2014 grant some on GitHub, then recheck.","infra.repo.noWorkspace":"No active workspace resolved yet.","infra.repo.notConnected":"GitHub is not connected yet","infra.repo.private":"private","infra.repo.recheck":"I installed it \u2014 recheck","infra.repo.searchAria":"Search repositories","infra.repo.searchPlaceholder":"Search repositories\u2026","infra.repo.stepConnect":"Install the Symbols build app on the repos you want to deploy.","infra.repo.stepError":"Something went wrong talking to the build service.","infra.repo.stepImporting":"Importing the repository\u2026","infra.repo.stepLoading":"Checking your GitHub connection\u2026","infra.repo.stepPick":"Pick a repository \u2014 it builds with Cloud Native Buildpacks and deploys to a managed HTTPS URL.","infra.repo.talking":"Talking to the build service\u2026","infra.repo.unknownError":"Unknown error.","infra.role.readOnly":"Contributors and guests can\'t change the infrastructure. Ask an owner, admin or member.","infra.scale.hintApplied":"Applied to the latest deployment.","infra.scale.hintPending":"Scaling applies after the first deployment.","infra.scale.max":"Max instances","infra.scale.min":"Min instances","infra.sidebar.activity":"Activity","infra.sidebar.activityEmpty":"No live activity yet \u2014 deploy something.","infra.sidebar.deployments":"Deployments","infra.sidebar.environment":"ENVIRONMENT","infra.sidebar.project":"PROJECT","infra.sidebar.services":"SERVICES","infra.sidebar.status":"Status","infra.sidebar.templates":"Templates","infra.status.active":"Active","infra.status.building":"Building","infra.status.crashed":"Crashed","infra.status.demoTag":"demo","infra.status.deploying":"Deploying","infra.status.liveTag":"live","infra.status.operational":"{count} operational","infra.status.overallDeploying":"{count} deploying","infra.status.overallDownMany":"{count} services down","infra.status.overallDownOne":"{count} service down","infra.status.overallOk":"All systems operational","infra.status.pageTitle":"System status","infra.status.pending":"Pending","infra.status.removed":"Removed","infra.status.sleeping":"Sleeping","infra.status.unknown":"Unknown","infra.tab.deployments":"Deployments","infra.tab.logs":"Logs","infra.tab.metrics":"Metrics","infra.tab.networking":"Networking","infra.tab.settings":"Settings","infra.tab.variables":"Variables","infra.tls.issued":"issued","infra.tls.issuing":"issuing","infra.tls.pending":"pending","infra.type.api":"Managed API","infra.type.cron":"Cron Job","infra.type.domain":"Domain","infra.type.fallback":"Service","infra.type.image":"Image","infra.type.loadbalancer":"Load Balancer","infra.type.volume":"Volume","infra.type.web":"Web Service","infra.type.worker":"Worker","infra.vars.empty":"No variables set.","infra.vars.liveNote":"Changes PATCH the import \u2014 new values apply on the next build.","infra.vars.nameAria":"Variable name","infra.vars.namePlaceholder":"KEY","infra.vars.remove":"Remove variable","infra.vars.valueAria":"Variable value","infra.vars.valuePlaceholder":"value"}');

});

parcelRegister("juKcz", function(module, exports) {
module.exports = JSON.parse('{"learn.articles.branching":"Branching (TBA)","learn.articles.customProps":"Custom properties","learn.articles.dsReference":"Design System reference","learn.articles.elementApi":"The element API","learn.articles.firstComponents":"Creating your first components","learn.articles.functions":"Functions reference","learn.articles.howToCode":"How to code","learn.articles.importExport":"Import & export (TBA)","learn.articles.intro":"Let\'s run through a few tutorials...","learn.articles.intro2":"Intro","learn.articles.publishing":"Publishing & domains (TBA)","learn.articles.routing":"Routing and pages","learn.articles.versioning":"Versioning (TBA)","learn.checklist.addColor":"Add a color","learn.checklist.createComponent":"Create a component","learn.checklist.createPage":"Create a main page","learn.checklist.importLibrary":"Import from Library","learn.checklist.noComponent.message":"Please add a component first","learn.checklist.noComponent.title":"No component to reuse","learn.checklist.noPage.message":"Please add a page first","learn.checklist.noPage.title":"No page to open","learn.checklist.openPage":"Open your page","learn.checklist.publish":"Publish","learn.checklist.reuseComponent":"Reuse a component","learn.checklist.title":"Quick checklist","learn.checklist.uploadLogo":"Upload a logo","learn.coach.canvas.descr":"Dive into your interactive canvas. Pan, zoom, and explore freely as you build.","learn.coach.canvas.title":"Enjoy the canvas","learn.coach.canvasAlt.descr":"You are about to experience the canvas experience. Pan and zoom around as you build.","learn.coach.edit.descr":"Double-click to open any element. Right-click for contextual actions. Topbar for navigation.","learn.coach.edit.title":"Edit your app","learn.coach.previous":"Previous","learn.coach.realtime.descr":"You get a free domain for instant sharing, previews, and seamless cross-device testing.","learn.coach.realtime.title":"Realtime experience","learn.coach.zoom.title":"Move around and zoom canvas","learn.codeExample.openInDashboard":"Open in dashboard","learn.codeExample.title":"Code Example","learn.docs.title":"Docs and articles","learn.drag.step1":"1. Add this component first","learn.drag.step2":"2. Add this next","learn.drag.step3":"3. Now, lets add the page","learn.example.accordion.descr":"Expand and collapse sections.","learn.example.accordion.title":"Accordion","learn.example.clock.descr":"Auto update every second.","learn.example.clock.title":"Clock","learn.example.conditional.descr":"Show or hide based on state.","learn.example.conditional.title":"Conditional Rendering","learn.example.counter.descr":"Increment and decrement a number.","learn.example.counter.title":"Counter","learn.example.dynamicList.descr":"Add and remove list items dynamically.","learn.example.dynamicList.title":"Dynamic List","learn.example.fetch.descr":"Fetch data and update state.","learn.example.fetch.title":"Async Fetch","learn.example.formInput.descr":"Capture input and reflect in UI.","learn.example.formInput.title":"Form Input","learn.example.progress.descr":"Fill dynamically with state.","learn.example.progress.title":"Progress Bar","learn.example.tabs.descr":"Switch content via active state.","learn.example.tabs.title":"Tabs","learn.example.toggling.descr":"Switch a boolean and update UI.","learn.example.toggling.title":"Toggling State","learn.examples.less":"Less examples","learn.examples.more":"More examples","learn.examples.open":"Open examples","learn.examples.title":"Quick examples","learn.gettingStarted.hide":"Hide","learn.gettingStarted.title":"Getting Started","learn.gifSlider.next":"Next","learn.gifSlider.okay":"Okay","learn.install.addScript":"Add this script to the top of your HTML:","learn.install.chromeExt":"Optionally you can install the Chrome extension to have realtime preview of your Symbols:","learn.install.docsPage":"Documentations page","learn.install.domain":"Domain","learn.install.extDescr":"Extension is required to gain access to website content","learn.install.extTitle":"Install Chrome extension to allow inspecting","learn.install.footer":"Learn more on how to get started at ","learn.install.install":"Install","learn.install.listenChanges":"Listening changes:","learn.install.oneTimeFetch":"One-time fetch:","learn.install.subtitle":"The short block to get your Symbols integrated:","learn.install.syncStep":"3. Run CLI tool to synchronize:","learn.install.title":"Install Symbols","learn.intro.chatAi":"Chat with AI","learn.intro.continue":"Let\'s continue your journey using Symbols","learn.intro.dismiss":"Dismiss onboarding","learn.intro.documentation":"Documentation","learn.intro.greeting":"Hi {name} \uD83D\uDC4B","learn.intro.howToExport":"How to export","learn.intro.libraryComponents":"Library components","learn.intro.moreExamples":"More examples","learn.intro.moreTutorials":"More tutorials","learn.intro.myCode":"My code","learn.intro.myContent":"My content","learn.intro.support":"Support & Resources","learn.intro.symbols":"Intro to Symbols","learn.intro.welcome":"Welcome to your Symbols canvas! This quick guide will walk you through the basics of your workspace.","learn.libraries.less":"Less libraries","learn.libraries.more":"More libraries","learn.libraries.resources":"{amount} resources","learn.libraries.title":"Open source libraries","learn.menu.contribution":"Contribution","learn.menu.onboarding":"Onboarding","learn.menu.properties":"Properties","learn.tutorial.symbolsCodeExplained.descr":"Symbols unifies HTML, CSS, and JavaScript into a single JavaScript object, giving you full control over structure, style, and behavior with elegant, expressive code.","learn.tutorial.symbolsCodeExplained.title":"Enjoy coding!","learn.tutorials.title":"Video Playlist","learn.video.calculator.descr":"Semi-advanced tutorial to show more functionalities","learn.video.calculator.title":"Calculator Tutorial","learn.video.codeEditor.descr":"Changing components and seeing code editor","learn.video.codeEditor.title":"Code editor","learn.video.colors.descr":"How to use colors, shades and variables","learn.video.colors.title":"Using Colors","learn.video.components.descr":"Learn how to create components and use properties","learn.video.components.title":"Building components","learn.video.files.descr":"How to upload and use files","learn.video.files.title":"Using Files","learn.video.gettingStarted.descr":"Getting started with basic landing page","learn.video.gettingStarted.title":"Getting started","learn.video.icons.descr":"How to upload, insert and use icons","learn.video.icons.title":"Using Icons","learn.video.less":"Less videos","learn.video.more":"More videos","learn.video.navigation.descr":"Navigating around Symbols","learn.video.navigation.title":"Navigation","learn.video.pages.descr":"Learn how to create page and relevant properties","learn.video.pages.title":"Building pages","learn.video.spacing.descr":"How to use spacing and variables","learn.video.spacing.title":"Using Spacing","learn.video.symbolsLibrary.descr":"Build using Symbols library","learn.video.symbolsLibrary.title":"Symbols library","learn.video.whatIsSymbols.descr":"What and how you can use Symbols","learn.video.whatIsSymbols.title":"What is Symbols","learn.videoRow.calculator":"Semi Advanced Tutorial Calculator","learn.videoRow.codeEditor":"Changing components and seeing code editor","learn.videoRow.colors":"How to use color","learn.videoRow.components":"Building components","learn.videoRow.files":"How to use files","learn.videoRow.gettingStarted":"Getting started with basic landing page","learn.videoRow.icons":"How to use icon","learn.videoRow.navigation":"Navigating around Symbols","learn.videoRow.pages":"Building pages","learn.videoRow.spacing":"How to use spacing","learn.videoRow.symbolsLibrary":"Build using Symbols library","learn.videoRow.whatIsSymbols":"What is Symbols"}');

});

parcelRegister("bjLXr", function(module, exports) {
module.exports = JSON.parse('{"mail.action.archive":"Archive","mail.action.failed":"Mail action failed","mail.action.moveToInbox":"Move to Inbox","mail.action.notSpam":"Not spam","mail.action.read":"Mark read","mail.action.restore":"Restore","mail.action.restoredMany":"{count} conversations moved to the Inbox","mail.action.spam":"Spam","mail.action.star":"Star","mail.action.trash":"Delete","mail.action.unread":"Mark unread","mail.admin.connect":"Connect","mail.admin.connected":"Connected","mail.admin.desk":"Service desk","mail.admin.deskAssignee":"Default assignee","mail.admin.deskAutoTicket":"Auto-ticket","mail.admin.deskTeam":"Default team","mail.admin.disconnect":"Disconnect","mail.admin.disconnectMail":"Disconnect mail","mail.admin.domainRemove":"Remove {domain}","mail.admin.grants":"grants","mail.admin.kind.personal":"Personal","mail.admin.kind.shared":"Shared","mail.admin.kind.tenant":"Tenant","mail.admin.notConnected":"Not connected","mail.admin.openGoogle":"Open Google Workspace integration","mail.admin.provision":"Provision members","mail.admin.provisionApply":"Apply provisioning?","mail.admin.remove":"Remove","mail.admin.sharedPending":"Adding shared inboxes arrives with the mail server update.","mail.admin.simulated":"Simulated","mail.admin.simulatedHint":"Demo tenant. No provider is contacted and every mailbox holds seeded sample data.","mail.admin.status.active":"Live","mail.admin.status.connecting":"Connecting","mail.admin.status.disabled":"Disabled","mail.admin.status.error":"Error","mail.admin.status.reauth":"Needs reconnect","mail.admin.status.unknown":"Unknown","mail.admin.tenant.done":"Done","mail.admin.tenant.failed":"Action failed","mail.admin.tenant.pending":"This action needs the mail server update. Use the steps above for now.","mail.admin.tenant.provisionDone":"Members provisioned","mail.admin.tenant.provisionDryDone":"Provisioning dry run finished","mail.admin.tenant.testFailed":"Mailbox access test failed","mail.admin.tenant.testOk":"Mailbox access verified","mail.admin.test":"Test mailbox access","mail.admin.toast.disconnectFailed":"Couldn\'t disconnect the account","mail.admin.toast.disconnected":"Account disconnected","mail.admin.toast.notReady":"The workspace is not ready yet","mail.admin.toast.saveFailed":"Couldn\'t save mail policy","mail.answer.earlier":"Earlier","mail.answer.noMatch":"No mail matches.","mail.answer.unread":"Unread \xb7 {count}","mail.attachment.downloadFailed":"Could not download the attachment","mail.attachment.one":"Attachment","mail.attachment.save":"Save to Files","mail.attachment.saveFailed":"Could not save to Files","mail.attachment.saved":"Saved to Files","mail.attachment.unavailable":"Attachment download is not available yet","mail.banner.backfill":"Syncing your mail \xb7 {p}","mail.banner.reconnect":"Reconnect {address} to keep mail in sync","mail.banner.reconnectAction":"Reconnect","mail.body.frameTitle":"Email message","mail.body.hideQuoted":"Hide quoted text","mail.body.imagesBlocked":"Remote images are blocked ({n})","mail.body.loadFailed":"Could not load this message","mail.body.loadImages":"Load images","mail.body.loading":"Loading message\u2026","mail.body.showQuoted":"Show quoted text","mail.compose.attach":"Attach files","mail.compose.attachFailed":"Could not attach","mail.compose.attachTooLarge":"File is too large","mail.compose.attachTooMany":"Too many attachments","mail.compose.bcc":"Bcc","mail.compose.bodyAria":"Message body","mail.compose.cc":"Cc","mail.compose.ccToggle":"Cc/Bcc","mail.compose.discard":"Discard draft","mail.compose.from":"From","mail.compose.fwdIntro":"---------- Forwarded message ----------","mail.compose.mondayAm":"Monday morning","mail.compose.new":"Compose","mail.compose.noRecipients":"Add at least one recipient","mail.compose.quoteIntro":"On {date}, {who} wrote:","mail.compose.saved":"Saved","mail.compose.saving":"Saving\u2026","mail.compose.schedule":"Schedule send","mail.compose.scheduleCustom":"Custom time","mail.compose.scheduleGo":"Schedule","mail.compose.scheduleTitle":"Pick a time","mail.compose.scheduled":"Send scheduled","mail.compose.send":"Send","mail.compose.sendFailed":"Could not send","mail.compose.sending":"Sending\u2026","mail.compose.subject":"Subject","mail.compose.title":"New message","mail.compose.to":"To","mail.compose.tomorrowAm":"Tomorrow morning","mail.compose.tomorrowPm":"Tomorrow afternoon","mail.compose.undoFailed":"Could not undo","mail.compose.undoHint":"Click to undo","mail.compose.undoLate":"Already sent","mail.confirm.archiveMany.button":"Archive","mail.confirm.archiveMany.message":"The selected conversations leave this list and move to Archive.","mail.confirm.archiveMany.title":"Archive {count} conversations?","mail.confirm.discard.button":"Discard","mail.confirm.discard.message":"The draft and its attachments are deleted. This can\u2019t be undone.","mail.confirm.discard.title":"Discard the draft \u201C{subject}\u201D?","mail.confirm.discard.titleUntitled":"Discard this draft?","mail.confirm.disconnect.message":"Your mail stays with your mail provider. Drafts and scheduled sends saved here are deleted. You can connect the mailbox again later.","mail.confirm.disconnect.title":"Disconnect {address}?","mail.confirm.disconnectDemo.message":"Its demo mail and attachments are deleted for good. This can\u2019t be undone.","mail.confirm.disconnectDemo.title":"Delete the demo mailbox {address}?","mail.confirm.domain.message":"People can no longer connect a new personal mailbox with an address on {domain}. Mailboxes already connected stay connected.","mail.confirm.domain.openMessage":"It is the last domain on the list, and an empty list means no restriction: a personal mailbox on any domain can connect.","mail.confirm.domain.title":"Remove {domain} from allowed domains?","mail.confirm.member.message":"The mailbox stops syncing here, and the drafts and scheduled sends saved here are deleted. Mail stays with the mail provider, and the mailbox can be connected again.","mail.confirm.shared.message":"Everyone loses access to it here, and the drafts and scheduled sends saved here are deleted. Mail stays with the mail provider.","mail.confirm.shared.title":"Remove the shared mailbox {address}?","mail.confirm.spamMany.button":"Move to Spam","mail.confirm.spamMany.message":"The selected conversations leave this list and move to Spam.","mail.confirm.spamMany.title":"Move {count} conversations to Spam?","mail.confirm.tenant.message":"Members\u2019 company mailboxes stop syncing here. Mail stays with {provider}, and the calendar connection stays. You can connect mail again later.","mail.confirm.tenant.title":"Disconnect {provider} mail for the whole workspace?","mail.confirm.tenantDemo.message":"Every demo mailbox, with its mail and attachments, is deleted for good. This can\u2019t be undone.","mail.confirm.tenantDemo.title":"Delete the demo {provider} mail?","mail.confirm.trash.message":"The conversation moves to Trash. Your mail provider keeps it there until it empties Trash.","mail.confirm.trash.title":"Delete \u201C{subject}\u201D?","mail.confirm.trashMany.message":"The selected conversations move to Trash. Your mail provider keeps them there until it empties Trash.","mail.confirm.trashMany.title":"Delete {count} conversations?","mail.drawer.open":"Open Mail","mail.drawer.title":"Mail","mail.empty.body":"Connect a Google or Microsoft mailbox to read and send email here. A workspace admin can also connect a Google Workspace or Microsoft 365 tenant for everyone.","mail.empty.heading":"Mail is not connected yet","mail.error.providerNotConfigured":"{provider} mail is not available yet. Contact support.","mail.error.providerNotConfiguredGeneric":"This mail provider is not available yet. Contact support.","mail.error.pushNotConfigured":"Instant mail updates are not available. Mail still syncs on a schedule.","mail.error.signingNotConfigured":"Mail cannot create a secure link right now. Contact support.","mail.error.tokenVaultNotConfigured":"Mail cannot open or save mailbox sign-ins right now. Contact support.","mail.filter.attachments":"Has files","mail.filter.starred":"Starred","mail.filter.unread":"Unread","mail.folder.archive":"Archive","mail.folder.drafts":"Drafts","mail.folder.inbox":"Inbox","mail.folder.sent":"Sent","mail.folder.spam":"Spam","mail.folder.starred":"Starred","mail.folder.trash":"Trash","mail.integrate.calendar":"Add to calendar","mail.integrate.eventCreated":"Added to calendar","mail.integrate.eventFailed":"Could not add to calendar","mail.integrate.menu":"More actions","mail.integrate.noChannels":"No channels yet \u2014 open Chat first","mail.integrate.searchChannels":"Search channels","mail.integrate.share":"Share to chat","mail.integrate.shareFailed":"Could not share to chat","mail.integrate.shared":"Shared to chat","mail.integrate.ticket":"Create ticket","mail.integrate.ticketCreated":"Ticket created","mail.integrate.ticketFailed":"Could not create the ticket","mail.invite.accept":"Accept","mail.invite.cancelled":"Event cancelled","mail.invite.decline":"Decline","mail.invite.invitation":"Calendar invitation","mail.invite.organizer":"Organized by {name}","mail.invite.replied":"Invitation response","mail.invite.rsvpFailed":"RSVP failed","mail.invite.status.accepted":"You accepted this invitation","mail.invite.status.declined":"You declined this invitation","mail.invite.status.tentative":"You responded maybe","mail.invite.tentative":"Maybe","mail.list.emptyFolder":"Nothing here","mail.list.loadFailed":"Could not load this folder","mail.list.loadOlder":"Load older","mail.list.loading":"Loading\u2026","mail.list.me":"me","mail.list.noSubject":"(no subject)","mail.list.retry":"Retry","mail.list.searchPlaceholder":"Search mail","mail.list.select":"Select","mail.page.title":"Mail","mail.settings.action.disconnect":"Disconnect","mail.settings.action.reconnect":"Reconnect","mail.settings.action.save":"Save","mail.settings.description":"Mailboxes connected to this workspace.","mail.settings.disconnected":"Mailbox disconnected","mail.settings.field.sendAs":"Default send-as","mail.settings.field.signature":"Signature","mail.settings.kind.personal":"Personal","mail.settings.kind.shared":"Shared","mail.settings.kind.tenant":"Company","mail.settings.listFailed":"Your mailboxes could not be loaded.","mail.settings.saved":"Mail settings saved","mail.settings.simulated":"Simulated","mail.settings.status.active":"Live","mail.settings.status.disabled":"Disabled","mail.settings.status.reauth":"Needs reconnect","mail.settings.status.syncing":"Syncing","mail.settings.title":"Mail","mail.setup.admin.action":"Set up mail","mail.setup.admin.steps":"Admin setup","mail.setup.askAdmin.action":"Notify an admin","mail.setup.askAdmin.already":"An admin was notified in the last 24 hours.","mail.setup.askAdmin.body":"An admin connects Google Workspace or Microsoft 365 once, and every member gets a mailbox.","mail.setup.askAdmin.failed":"The admins could not be notified.","mail.setup.askAdmin.notified":"An admin was notified.","mail.setup.askAdmin.title":"Mail is not set up for this workspace","mail.setup.askAdmin.youAreAdmin":"You administer mail for this organisation. Open the admin page to set it up.","mail.setup.connect.action":"Continue with {provider}","mail.setup.connect.blockedPlatform":"This provider is not configured on this server yet.","mail.setup.connect.body":"Sign in with Google or Microsoft. Symbols reads and sends on your own account and never stores your password.","mail.setup.connect.pending":"Mailbox sign-in is not available in this build yet. An admin can connect Google Workspace or Microsoft 365 for everyone.","mail.setup.connect.title":"Connect a mailbox to send email","mail.setup.error.retry":"Try again","mail.setup.error.title":"Mail setup could not be read","mail.setup.googleConnect.connected":"Google Workspace is connected. The service-account key on the integration is what Mail impersonates members with.","mail.setup.googleConnect.connectedDomain":"Google Workspace is connected for {domain}. The service-account key on the integration is what Mail impersonates members with.","mail.setup.googleConnect.instructions":"Open Admin \u2192 Integrations \u2192 Google Workspace and add the service-account key JSON for your domain. Set the admin impersonation email so Mail can test access.","mail.setup.googleConnect.title":"Connect Google Workspace","mail.setup.googleDelegation.instructions":"In Google Admin go to Security \u2192 Access and data control \u2192 API controls \u2192 Manage domain-wide delegation. Add a new client with the client ID of your service account (the client_id field in the key file you added to the Google Workspace integration) and paste the scope list below as one comma-separated line. If that client is already listed, edit it and add these scopes to the ones it has.","mail.setup.googleDelegation.scopesMissing":"In Google Admin go to Security \u2192 Access and data control \u2192 API controls \u2192 Manage domain-wide delegation. Contact support to get the mail scope list. Then add a new client with the client ID of your service account (the client_id field in the key file you added to the Google Workspace integration) and that scope list.","mail.setup.googleDelegation.title":"Authorise domain-wide delegation for mail","mail.setup.googleTest.instructions":"Back in Admin \u2192 Mail, run \\"Test mailbox access\\" (reads the admin mailbox and one directory user), then \\"Provision members\\" to create a mailbox for every member the directory matches.","mail.setup.googleTest.title":"Test and provision mailboxes","mail.setup.link.action":"Link my mailbox","mail.setup.link.body":"Your organisation connected a mail provider, but no mailbox is linked to you yet. Link it, or ask an admin to check the directory match.","mail.setup.link.failed":"Your mailbox could not be linked.","mail.setup.link.linked":"Your mailbox is linked.","mail.setup.link.pending":"Mailbox linking is not switched on yet.","mail.setup.link.title":"Your mailbox is not linked yet","mail.setup.loading":"Checking your mail setup\u2026","mail.setup.microsoftConsent.appMissing":"Sign in as a Microsoft 365 global administrator and approve the Symbols Mail application for your tenant. The callback records your tenant id on the integration. The Symbols Mail application is not available for your workspace yet. Contact support to enable it before you grant consent.","mail.setup.microsoftConsent.connected":"Microsoft 365 is connected (tenant {tenantId}). Re-run consent only if the application permissions change.","mail.setup.microsoftConsent.instructions":"Sign in as a Microsoft 365 global administrator and approve the Symbols Mail application for your tenant. The callback records your tenant id on the integration.","mail.setup.microsoftConsent.title":"Grant admin consent","mail.setup.microsoftPolicy.appMissing":"Application permissions cover every mailbox in the tenant. In Exchange Online PowerShell, scope the application to a mail-enabled security group that holds the members who use Mail. The command appears here once the Symbols Mail application is available for your workspace.","mail.setup.microsoftPolicy.instructions":"Application permissions cover every mailbox in the tenant. In Exchange Online PowerShell, scope the application to a mail-enabled security group that holds the members who use Mail.","mail.setup.microsoftPolicy.title":"Limit mailbox access (recommended)","mail.setup.microsoftTest.instructions":"Back in Admin \u2192 Mail, run \\"Test\\" (acquires a tenant token and reads one user plus the admin inbox), then \\"Provision members\\".","mail.setup.microsoftTest.title":"Test and provision mailboxes","mail.setup.ready.action":"Write a message","mail.setup.ready.body":"You can write and send email from this workspace.","mail.setup.ready.title":"Mail is ready","mail.setup.reauth.action":"Reconnect","mail.setup.reauth.body":"The connection to this mailbox expired. Reconnect it to read and send again.","mail.setup.reauth.title":"Reconnect your mailbox to send","mail.setup.step.copied":"Copied","mail.setup.step.copy":"Copy","mail.setup.step.copyFailed":"Copy failed","mail.sidebar.accounts":"Accounts","mail.sidebar.allInboxes":"All inboxes","mail.sidebar.folders":"Folders","mail.sidebar.labels":"Labels","mail.sidebar.needsAttention":"Needs attention","mail.thread.forward":"Forward","mail.thread.loadFailed":"Could not open this conversation","mail.thread.loading":"Opening\u2026","mail.thread.pickOne":"Pick a conversation to read it here","mail.thread.reply":"Reply","mail.thread.replyAll":"Reply all","mail.thread.to":"to"}');

});

parcelRegister("cfuO0", function(module, exports) {
module.exports = JSON.parse('{"marketplace.action.addAnother":"Add another","marketplace.action.install":"Install","marketplace.action.installing":"Installing\u2026","marketplace.action.manage":"Manage","marketplace.action.purchase":"Purchase","marketplace.action.purchaseAndInstall":"Purchase & Install","marketplace.action.remove":"Remove","marketplace.action.subscribe":"Subscribe","marketplace.action.uninstall":"Uninstall","marketplace.action.use":"Use","marketplace.app.assistantsApp.name":"Assistants","marketplace.app.biApp.name":"Insights","marketplace.app.bookmarksApp.name":"Bookmarks","marketplace.app.capTableApp.name":"Cap Table","marketplace.app.catalogApp.name":"Products","marketplace.app.cmsApp.name":"Content","marketplace.app.commerceApp.name":"Commerce","marketplace.app.crmApp.name":"CRM","marketplace.app.excalidraw.name":"Excalidraw","marketplace.app.gazerApp.name":"Gazer","marketplace.app.helmetApp.name":"SEO","marketplace.app.hrApp.name":"People","marketplace.app.insuranceApp.name":"Insurance","marketplace.app.invoicesApp.name":"Invoices","marketplace.app.jobsApp.name":"Hiring","marketplace.app.ordersApp.name":"Orders","marketplace.app.payrollApp.name":"Payroll","marketplace.app.policiesManagementApp.name":"Insurance Policy Dashboard","marketplace.app.polyglotApp.name":"Translations","marketplace.app.productionApp.name":"Production","marketplace.app.realestateApp.name":"Real estate","marketplace.app.schedulingApp.name":"Scheduling","marketplace.app.socialsApp.name":"Socials","marketplace.app.terminalApp.name":"Terminal","marketplace.app.warehouseApp.name":"Inventory","marketplace.appStore.categoryAll":"All","marketplace.appStore.overview":"Overview","marketplace.appStore.features":"Features","marketplace.appStore.access":"What it can access","marketplace.appStore.accessLoading":"Reading the app\'s permissions\u2026","marketplace.appStore.accessNone":"This app reads and writes no workspace records.","marketplace.appStore.accessOwns":"Reads and writes","marketplace.appStore.accessReads":"Reads only","marketplace.appStore.accessActions":"Adds assistant actions","marketplace.appStore.accessNav":"Adds to navigation","marketplace.appStore.accessNotifyRoles":"Notifies members by role","marketplace.appStore.accessNotifyPermissions":"Notifies members by permission","marketplace.appStore.accessNotifyTeams":"Notifies teams","marketplace.appStore.details":"Details","marketplace.appStore.detailVersion":"Version","marketplace.appStore.detailUpdated":"Updated","marketplace.appStore.detailCategory":"Category","marketplace.appStore.detailInstalls":"Installs","marketplace.appStore.detailPublisher":"Publisher","marketplace.appStore.detailLanguages":"Languages","marketplace.appStore.detailWebsite":"Website","marketplace.appStore.detailSupport":"Support","marketplace.appStore.sortBy":"Sort by","marketplace.appStore.sortPopular":"Popular","marketplace.appStore.sortNewest":"Newest","marketplace.appStore.sortName":"Name A\u2013Z","marketplace.appStore.pin":"Pin this app","marketplace.appStore.unpin":"Unpin this app","marketplace.appStore.widgets":"Widgets","marketplace.appStore.widgetSizeS":"S","marketplace.appStore.widgetSizeM":"M","marketplace.appStore.widgetSizeL":"L","marketplace.appStore.widgetSizeXL":"XL","marketplace.card.byAuthor":"by {owner}","marketplace.card.pin":"Pin to sidebar","marketplace.card.pinAria":"Toggle pin","marketplace.card.tools":"{count} tools","marketplace.card.toolsOne":"{count} tool","marketplace.card.forks":"{count} forks","marketplace.card.forksOne":"{count} fork","marketplace.category.ai":"AI","marketplace.category.analytics":"Analytics","marketplace.category.auth":"Auth","marketplace.category.automation":"Automation","marketplace.category.backend":"Backend","marketplace.category.catalog":"Catalog","marketplace.category.cms":"CMS","marketplace.category.commerce":"Commerce","marketplace.category.content":"Content","marketplace.category.crm":"CRM","marketplace.category.database":"Database","marketplace.category.docs":"Docs","marketplace.category.domains":"Domains","marketplace.category.editor":"Editor","marketplace.category.finance":"Finance","marketplace.category.hr":"HR","marketplace.category.i18n":"i18n","marketplace.category.insurance":"Insurance","marketplace.category.inventory":"Inventory","marketplace.category.jobs":"Jobs","marketplace.category.marketing":"Marketing","marketplace.category.messaging":"Messaging","marketplace.category.observability":"Observability","marketplace.category.payments":"Payments","marketplace.category.quality":"Quality","marketplace.category.scheduling":"Scheduling","marketplace.category.seo":"SEO","marketplace.category.starter":"Starter","marketplace.category.storage":"Storage","marketplace.category.system":"System","marketplace.category.ui":"UI","marketplace.chip.kind":"Kind: {kind}","marketplace.chip.removeAria":"Remove filter {label}","marketplace.composer.cancel":"Cancel","marketplace.composer.messageLabel":"MESSAGE (OPTIONAL)","marketplace.composer.messagePlaceholder":"Tell the community what you built\u2026","marketplace.composer.pickProject":"Select a public project\u2026","marketplace.composer.projectLabel":"PROJECT","marketplace.composer.title":"Share a project","marketplace.composer.post":"Post","marketplace.composer.posting":"Posting\u2026","marketplace.composer.selectProject":"Select a project to share.","marketplace.composer.shareFailed":"Failed to share post.","marketplace.copyLink.copied":"Copied!","marketplace.copyLink.label":"Copy link","marketplace.copyLink.tooltip":"Copy a link that reproduces this filtered view","marketplace.detail.closeAria":"Close detail","marketplace.detail.ctaAttachLibrary":"Attach library","marketplace.detail.ctaConnect":"Connect","marketplace.detail.ctaConnectMcp":"Connect MCP","marketplace.detail.ctaConnectRegistrar":"Connect registrar","marketplace.detail.ctaCopyAgent":"Copy agent","marketplace.detail.ctaCopyPrompt":"Copy prompt","marketplace.detail.ctaCopySkill":"Copy skill","marketplace.detail.ctaInstallAgent":"Install agent","marketplace.detail.ctaInstallPlugin":"Install plugin","marketplace.detail.ctaInstallSkill":"Install skill","marketplace.detail.ctaUseTemplate":"Use as template","marketplace.detail.fork":"Fork","marketplace.detail.forkedAs":"Forked as \u201C{name}\u201D \u2014 private to your workspace.","marketplace.detail.forking":"Forking\u2026","marketplace.detail.forks":"{count} forks","marketplace.detail.forksOne":"1 fork","marketplace.detail.installs":"{count} installs","marketplace.detail.installsOne":"1 install","marketplace.detail.metaAuth":"Auth","marketplace.detail.metaAuthor":"Author","marketplace.detail.metaBestWith":"Best with","marketplace.detail.metaCategory":"Category","marketplace.detail.metaDefaultScope":"Default scope","marketplace.detail.metaInstalls":"Installs","marketplace.detail.metaInstallsInto":"Installs into","marketplace.detail.metaModel":"Model","marketplace.detail.metaMultiInstance":"Multi-instance","marketplace.detail.metaPrice":"Price","marketplace.detail.metaTokens":"Tokens","marketplace.detail.metaTools":"Tools","marketplace.detail.metaTransport":"Transport","marketplace.detail.metaTrigger":"Trigger","marketplace.detail.metaUpdated":"Updated","marketplace.detail.metaVersion":"Version","marketplace.detail.noDescription":"No description.","marketplace.detail.openFork":"Open the fork","marketplace.detail.reuses":"{count} reuses","marketplace.detail.reusesOne":"1 reuse","marketplace.detail.tabGallery":"Gallery","marketplace.detail.tabLive":"Live","marketplace.detail.uses":"{count} uses","marketplace.detail.usesOne":"1 use","marketplace.detail.valueFree":"Free","marketplace.detail.valueWorkspace":"Workspace","marketplace.detail.valueYes":"Yes","marketplace.detail.forkFailed":"Fork failed \u2014 please try again.","marketplace.detail.forkUnsupported":"Fork is not supported by this SDK version \u2014 please reload.","marketplace.detail.forkNoSource":"This listing has no source project to fork.","marketplace.detail.skillInstall":"**Install:** save the markdown above as {path}.","marketplace.dialog.installMessage":"Adds its pages, widgets and navbar entries to this workspace \u2014 visible to everyone with access to it.","marketplace.dialog.installMessageNamed":"Adds its pages, widgets and navbar entries to \\"{workspace}\\" \u2014 visible to everyone with access to that workspace.","marketplace.dialog.installTitle":"Install {name}?","marketplace.dialog.removeMessage":"This removes its pages, widgets and navbar entries from your workspace. Your content stays and reappears if you reinstall.","marketplace.dialog.removeTitle":"Remove {name}?","marketplace.empty.hint":"Try a different search, choose another category, or reset your filters to browse everything here.","marketplace.empty.installedHint":"No installed items match this view. Reset your filters to discover items you can add.","marketplace.empty.installedTitle":"Nothing installed yet","marketplace.empty.queryTitle":"No matches for \\"{query}\\"","marketplace.empty.reset":"Reset filters","marketplace.empty.title":"No items match your filters","marketplace.empty.loadingTitle":"Loading apps\u2026","marketplace.empty.loadingHint":"Your workspace app catalog is on its way.","marketplace.empty.errorTitle":"Apps couldn\u2019t load","marketplace.empty.errorHint":"Try loading the catalog again. Your filters will stay in place.","marketplace.empty.retry":"Try again","marketplace.error.forceRemoveRetry":"Failed to force-remove \u2014 please try again.","marketplace.error.installFailed":"Install failed","marketplace.error.installFailedRetry":"Install failed. Please try again.","marketplace.error.installRetry":"Install failed \u2014 please try again.","marketplace.error.removeFailed":"Failed to remove app","marketplace.error.tryAgain":"Please try again.","marketplace.error.unexpected":"Unexpected error.","marketplace.error.connectorUrlRequired":"Server URL is required.","marketplace.error.connectorNoWorkspace":"No active workspace to install the connector into.","marketplace.error.connectorCreateFailed":"Failed to create connector.","marketplace.error.capabilityNoOrg":"Not signed in to an organization.","marketplace.error.capabilityFailed":"The action failed. Please try again.","marketplace.featuredToday.eyebrow":"Featured today","marketplace.featuredToday.kindFallback":"Featured","marketplace.feed.emptyHint":"Be the first to share a project. Click \\"Share a project\\" to post one of your public projects to the feed.","marketplace.feed.emptyTitle":"No posts yet","marketplace.feed.eyebrow":"Community","marketplace.feed.loadError":"Could not load the feed. Your posts are safe \u2014 try again.","marketplace.feed.retry":"Retry","marketplace.feed.share":"Share a project","marketplace.feed.title":"Feed","marketplace.feedPost.comment":"Comment","marketplace.feedPost.commentPlaceholder":"Add a comment\u2026","marketplace.feedPost.like":"Like","marketplace.feedPost.noComments":"No comments yet \u2014 be the first.","marketplace.feedPost.reply":"Reply","marketplace.feedPost.viewProject":"View project \u2192","marketplace.feedPost.untitledProject":"Untitled project","marketplace.feedSeed.communityAuthorTitle":"From the team","marketplace.feedSeed.communityDescr":"A landing-page template the community helps maintain.","marketplace.feedSeed.communityMessage":"Welcome to the marketplace feed. Share what you build and follow people whose work you want to see more of.","marketplace.feedSeed.starterAuthorTitle":"Building Symbols","marketplace.feedSeed.starterDescr":"Tokens, typography, and a 12-column scale.","marketplace.feedSeed.starterMessage":"Just shipped a starter that wires Symbols design tokens into a clean component scale. Drop in and customize.","marketplace.feedSidebar.aria":"Feed","marketplace.feedSidebar.feedHead":"FEED","marketplace.feedSidebar.filterAll":"All","marketplace.feedSidebar.filterFollowing":"Following","marketplace.feedSidebar.filterRecent":"Recent","marketplace.feedSidebar.followHead":"WHO TO FOLLOW","marketplace.feedSidebar.noSuggestions":"No suggestions yet","marketplace.feedSidebar.templateAuthor":"Template author","marketplace.filters.allKinds":"All kinds","marketplace.filters.anyCategory":"Any category","marketplace.filters.clear":"Clear","marketplace.filters.done":"Done","marketplace.filters.groupCategories":"Categories","marketplace.filters.groupKind":"Kind","marketplace.filters.groupPricing":"Pricing","marketplace.filters.groupSort":"Sort","marketplace.filters.sortName":"Name (A\u2013Z)","marketplace.filters.sortPopular":"Most popular","marketplace.filters.sortRecent":"Recently added","marketplace.gallery.comingSoon":"Screenshots coming soon","marketplace.gallery.next":"Next","marketplace.gallery.nextAria":"Next screenshot","marketplace.gallery.prev":"Previous","marketplace.gallery.prevAria":"Previous screenshot","marketplace.gallery.thumb":"Screenshot {n}","marketplace.hero.appStoreSubtitle":"Apps that install into your workspace \u2014 data, content, and operations in one place.","marketplace.hero.appStoreTitle":"App Store","marketplace.hero.integrationsSubtitle":"Service connectors \u2014 the accounts and APIs your workspace can talk to.","marketplace.hero.integrationsTitle":"Integrations","marketplace.install.back":"\u2190 Back","marketplace.install.cancel":"Cancel","marketplace.install.closeAria":"Close install modal","marketplace.install.configureTitle":"Configure {name}","marketplace.install.displayName":"Display name","marketplace.install.displayNamePlaceholder":"My integration","marketplace.install.genericIntegration":"integration","marketplace.install.next":"Next: Configure \u2192","marketplace.install.noConfig":"No configuration required. Click Install to complete the setup.","marketplace.install.noOrg":"You need an organisation before installing integrations. Create one in your account settings.","marketplace.install.noProjects":"No projects found. You can install at workspace level.","marketplace.install.noWorkspaces":"No workspaces found in this org.","marketplace.install.preview":"\uD83D\uDC41 Preview","marketplace.install.previewAria":"Open preview","marketplace.install.previewTooltip":"Preview","marketplace.install.scopeHint":"Choose the org, workspace, and optionally a project to scope this integration.","marketplace.install.scopeHintApp":"Workspace apps install directly into a workspace \u2014 pick which one below.","marketplace.install.scopeOrg":"Org","marketplace.install.scopeProject":"Project (optional)","marketplace.install.scopeTitle":"Where should this integration be installed?","marketplace.install.scopeTitleApp":"Which workspace should this app install into?","marketplace.install.scopeWorkspace":"Workspace","marketplace.install.secretLabel":"API key / Secret","marketplace.install.selectProject":"Select project (optional)","marketplace.install.selectWorkspace":"Select workspace","marketplace.install.selectWorkspaceFirst":"Select a workspace before installing a paid integration.","marketplace.install.stepChooseWorkspace":"Choose workspace","marketplace.install.stepConfigure":"Configure","marketplace.install.stepError":"Catalog error","marketplace.install.stepOneOfTwo":"Step 1 of 2: Select scope","marketplace.install.stepTwoOfTwo":"Step 2 of 2: Configure","marketplace.install.title":"Install {name}","marketplace.install.errorNoOrg":"No active organisation. Please sign in.","marketplace.install.fieldRequired":"\\"{field}\\" is required.","marketplace.install.workspaceIdRequired":"Select or enter a workspace ID.","marketplace.install.projectIdRequired":"Select or enter a project ID.","marketplace.install.wrongCategory":"This item is in the \\"{category}\\" category, not \\"{required}\\".","marketplace.install.wrongTypes":"This item does not apply to the required type(s): {types}.","marketplace.install.wrongScopes":"This item does not apply to the required scope(s): {scopes}.","marketplace.install.kindNotInCatalogue":"\\"{kind}\\" is not available in the current catalogue. See /admin-integration-kinds if you need to add it.","marketplace.install.mcpConnector":"MCP connector","marketplace.installDeps.cancel":"Cancel","marketplace.installDeps.checkAria":"Install {name} alongside this app","marketplace.installDeps.hint":"{name} works with {count} other apps already in the App Store. Choose what to install alongside it.","marketplace.installDeps.hintOne":"{name} works with 1 other app already in the App Store. Choose what to install alongside it.","marketplace.installDeps.optional":"Optional","marketplace.installDeps.required":"Required","marketplace.installDeps.requiredTooltip":"Required \u2014 always installed with this app","marketplace.installDeps.submit":"Install {count} apps","marketplace.installDeps.submitOne":"Install 1 app","marketplace.installDeps.thisApp":"this app","marketplace.installDeps.thisAppCap":"This app","marketplace.installDeps.title":"Install {name}?","marketplace.integrations.count":"{count} integrations","marketplace.integrations.countOne":"1 integration","marketplace.integrations.installs":"{count} installs","marketplace.integrations.installsOne":"1 install","marketplace.integrations.title":"Integrations","marketplace.island.searchPlaceholder":"Search apps, templates, integrations\u2026","marketplace.kind.agent.many":"Agents","marketplace.kind.agent.noun":"agent","marketplace.kind.agent.nouns":"agents","marketplace.kind.agent.one":"Agent","marketplace.kind.app.many":"Workspace apps","marketplace.kind.app.noun":"app","marketplace.kind.app.nouns":"apps","marketplace.kind.app.one":"Workspace app","marketplace.kind.integration.many":"Integrations","marketplace.kind.integration.noun":"integration","marketplace.kind.integration.nouns":"integrations","marketplace.kind.integration.one":"Integration","marketplace.kind.library.many":"Libraries","marketplace.kind.library.noun":"library","marketplace.kind.library.nouns":"libraries","marketplace.kind.library.one":"Library","marketplace.kind.mcp.many":"MCP servers","marketplace.kind.mcp.noun":"MCP server","marketplace.kind.mcp.nouns":"MCP servers","marketplace.kind.mcp.one":"MCP server","marketplace.kind.plugin.many":"Plugins","marketplace.kind.plugin.noun":"plugin","marketplace.kind.plugin.nouns":"plugins","marketplace.kind.plugin.one":"Plugin","marketplace.kind.prompt.many":"Prompts","marketplace.kind.prompt.noun":"prompt","marketplace.kind.prompt.nouns":"prompts","marketplace.kind.prompt.one":"Prompt","marketplace.kind.registrar.many":"Domain registrars","marketplace.kind.registrar.noun":"registrar","marketplace.kind.registrar.nouns":"registrars","marketplace.kind.registrar.one":"Domain registrar","marketplace.kind.skill.many":"Skills","marketplace.kind.skill.noun":"skill","marketplace.kind.skill.nouns":"skills","marketplace.kind.skill.one":"Skill","marketplace.kind.template.many":"Templates","marketplace.kind.template.noun":"template","marketplace.kind.template.nouns":"templates","marketplace.kind.template.one":"Template","marketplace.kindRail.countLibraries":"{count} libraries","marketplace.kindRail.countLibrariesOne":"1 library","marketplace.kindRail.countTemplates":"{count} templates","marketplace.kindRail.countTemplatesOne":"1 template","marketplace.kindRail.featuredTemplates":"Featured templates","marketplace.kindRail.librariesTitle":"Libraries","marketplace.kindRail.seeAll":"See All \u203A","marketplace.kindRail.showLess":"Show less","marketplace.kindRail.templatesTitle":"Browse templates","marketplace.lazyPage.error":"Couldn\u2019t load this page. Refresh to try again.","marketplace.liveView.devNotice":"Local dev preview \u2014 requires a running dev server for this project (portless). A blank or \\"Not Found\\" page here means the target isn\'t running locally right now.","marketplace.liveView.linkDirect":"\u2197 Direct","marketplace.liveView.linkDirectTitle":"Open the published site in a new tab","marketplace.liveView.linkPreview":"\u2197 Preview","marketplace.liveView.linkPreviewTitle":"Open in preview.symbols.app","marketplace.liveView.linkWorkspace":"\u2197 Workspace","marketplace.liveView.linkWorkspaceTitle":"Open in my.symbols.app","marketplace.navbar.browse":"Browse","marketplace.navbar.feed":"Feed","marketplace.navbar.searchPlaceholder":"Search posts, authors, projects\u2026","marketplace.navbar.title":"Marketplace","marketplace.page.feedTitle":"Community feed / Marketplace","marketplace.page.storeTitle":"App Store & Marketplace","marketplace.preset.rowTitle":"Workspace presets","marketplace.preset.rowHint":"Start from your industry. A preset adds the apps, channels and folders your work needs.","marketplace.preset.cardAction":"Open the {name} preset","marketplace.preset.cardApply":"Apply","marketplace.preset.cardView":"View","marketplace.preset.appliedMark":"Applied","marketplace.preset.eyebrow":"Workspace preset","marketplace.preset.appsLabel":"Apps","marketplace.preset.setupLabel":"Also sets up","marketplace.preset.setupChannels":"Channels: {list}","marketplace.preset.setupFolders":"Folders: {list}","marketplace.preset.appInstalled":"Installed","marketplace.preset.appSuggested":"Suggested","marketplace.preset.appCheckAria":"Add {name}","marketplace.preset.comingSoon":"{count} more apps are coming soon","marketplace.preset.comingSoonOne":"One more app is coming soon","marketplace.preset.apply":"Apply to {workspace}","marketplace.preset.applyNoName":"Apply to this workspace","marketplace.preset.applyAgain":"Add what is missing","marketplace.preset.applying":"Applying\u2026","marketplace.preset.notNow":"Not now","marketplace.preset.openApp":"Open {name}","marketplace.preset.appliedOn":"Applied {date}","marketplace.preset.askAdmin":"Ask an admin of {workspace} to apply it.","marketplace.preset.askAdminNoName":"Ask an admin of this workspace to apply it.","marketplace.preset.noWorkspace":"Open your workspace to apply this preset.","marketplace.preset.unavailable":"This preset is not available right now.","marketplace.preset.loadFailed":"The presets could not load.","marketplace.preset.progressTitle":"Setting up","marketplace.preset.linePending":"Installing\u2026","marketplace.preset.lineInstalled":"Installed","marketplace.preset.lineSkipped":"Already there","marketplace.preset.lineComingSoon":"Coming soon","marketplace.preset.lineFailed":"Could not install","marketplace.preset.setupReady":"Channels and folders are ready","marketplace.preset.doneLine":"Your workspace is set up for {name}.","marketplace.preset.errorForbidden":"Only a workspace owner or admin can apply a preset.","marketplace.preset.errorFailed":"The preset could not be applied.","marketplace.preset.errorOffline":"Your connection dropped. The preset could not be applied.","marketplace.preset.errorServer":"The server did not answer. The preset could not be applied.","marketplace.preset.busy":"Another preset is being applied. You can apply this one when it finishes.","marketplace.preset.close":"Close","marketplace.preset.tryAgain":"Try again","marketplace.preset.donePartial":"Part of {name} is set up. Try again to add the rest.","marketplace.preset.setupFailed":"{count} channels or folders could not be set up","marketplace.preset.setupFailedOne":"One channel or folder could not be set up","marketplace.preset.virtualAssistance.name":"Virtual assistance (VA)","marketplace.preset.virtualAssistance.line":"Track client work, send invoices and run payroll for your assistants.","marketplace.preset.virtualAssistance.summary":"Everything a virtual assistance team runs on: a board for each client\'s work, invoices, payroll for your assistants, scheduling and insights.","marketplace.preset.realEstate.name":"Real estate","marketplace.preset.realEstate.line":"Publish listings, book viewings and keep every client and deal in one place.","marketplace.preset.realEstate.summary":"List your properties, book viewings, follow every buyer and deal in the CRM, run your website\'s content and see how sales are going.","marketplace.preset.ecommerce.name":"E-commerce","marketplace.preset.ecommerce.line":"Sell online, with products, orders, stock and customers in one workspace.","marketplace.preset.ecommerce.summary":"Put your products online, take orders and payments, keep stock in check, know your customers and see what sells.","marketplace.preset.hospitality.name":"Hospitality","marketplace.preset.hospitality.line":"Take bookings, know your guests and run your team and website.","marketplace.preset.medical.name":"Medical","marketplace.preset.medical.line":"Book patient visits and keep every patient record in one place.","marketplace.preset.finance.name":"Finance","marketplace.preset.finance.line":"Follow clients and investors, keep your cap table and see the numbers.","marketplace.preset.education.name":"Education","marketplace.preset.education.line":"Schedule classes, follow every student and run your school website.","marketplace.preset.logistics.name":"Logistics","marketplace.preset.logistics.line":"Book dock slots, keep stock in check and follow every carrier.","marketplace.preset.manufacturing.name":"Manufacturing","marketplace.preset.manufacturing.line":"Keep stock in check, run your team and follow every client.","marketplace.preset.media.name":"Media & creative","marketplace.preset.media.line":"Publish content, follow every client and book client meetings.","marketplace.preset.services.name":"Services","marketplace.preset.services.line":"Follow every client, book meetings and see how the business goes.","marketplace.preset.agro.name":"Agro","marketplace.preset.agro.line":"Keep harvest and stock in check, run your crews and follow every buyer.","marketplace.preset.aerial.name":"Aerial","marketplace.preset.aerial.line":"Schedule missions, run your pilots and keep equipment in check.","marketplace.pricing.all":"Any pricing","marketplace.pricing.free":"Free","marketplace.pricing.installed":"Installed","marketplace.pricing.paid":"Paid","marketplace.pricing.pinned":"Pinned","marketplace.promptCard.chars":"{count} chars","marketplace.promptCard.charsOne":"1 char","marketplace.promptCard.copied":"Copied!","marketplace.promptCard.copy":"Copy prompt","marketplace.promptCard.copyTooltip":"Copy prompt to clipboard","marketplace.prompts.catAll":"All","marketplace.prompts.catComponents":"Components","marketplace.prompts.catDebugging":"Debugging","marketplace.prompts.catDesignSystem":"Design System","marketplace.prompts.catIntegrations":"Integrations","marketplace.prompts.catMigration":"Migration","marketplace.prompts.catPages":"Pages","marketplace.prompts.catRefactoring":"Refactoring","marketplace.prompts.cmpButtonVariants.tagline":"Primary / secondary / ghost variants in v3.14 syntax.","marketplace.prompts.cmpButtonVariants.title":"Button with variants","marketplace.prompts.cmpCardCollection.tagline":"children + childExtends pattern (no $collection).","marketplace.prompts.cmpCardCollection.title":"Card grid from data","marketplace.prompts.cmpModal.tagline":"Esc-to-close, focus trap, design tokens only.","marketplace.prompts.cmpModal.title":"Modal with backdrop","marketplace.prompts.dbgBlankRender.tagline":"Most common cause: leftover el.props / el.on access after migration.","marketplace.prompts.dbgBlankRender.title":"Component renders blank in v3.14","marketplace.prompts.dbgIframeLeak.tagline":"Scratch singleton bleed \u2014 isolate via context.designSystem.","marketplace.prompts.dbgIframeLeak.title":"Canvas iframe sharing design system with parent","marketplace.prompts.dsAudit.tagline":"Strip raw px / hex / Tailwind palettes; report violations.","marketplace.prompts.dsAudit.title":"Audit a component for token compliance","marketplace.prompts.dsDarkMode.tagline":"Per-component @dark variants without raw selectors.","marketplace.prompts.dsDarkMode.title":"Dark / light theme switch","marketplace.prompts.dsThemeExtend.tagline":"Add a new color, type ramp step, or spacing token cleanly.","marketplace.prompts.dsThemeExtend.title":"Extend the design system","marketplace.prompts.emptyHint":"Switch to All to see every prompt.","marketplace.prompts.emptyTitle":"No prompts in this category yet","marketplace.prompts.eyebrow":"Prompt Gallery","marketplace.prompts.intInstallRail.tagline":"Drop a workspace integration rail into any page.","marketplace.prompts.intInstallRail.title":"Mount InstallableRail in a project","marketplace.prompts.intOpenid.tagline":"Register a kind, add post-install hook, expose to MarketplaceCard.","marketplace.prompts.intOpenid.title":"Wire an OAuth integration","marketplace.prompts.migReactToDomql.tagline":"JSX, useState, hooks \u2192 plain object component + state model.","marketplace.prompts.migReactToDomql.title":"Convert React \u2192 DOMQL","marketplace.prompts.migV3V314.tagline":"el.props.X \u2192 el.X, on.click \u2192 onClick, attr \u2192 flat props.","marketplace.prompts.migV3V314.title":"Migrate v3 \u2192 v3.14 syntax","marketplace.prompts.pgDashboard.tagline":"AppShell + AppSidebar + AppMain composition.","marketplace.prompts.pgDashboard.title":"Dashboard page scaffold","marketplace.prompts.pgEmptyState.tagline":"Onboarding-grade empty page with illustration and primary action.","marketplace.prompts.pgEmptyState.title":"Empty state with CTA","marketplace.prompts.pgSettings.tagline":"Tabbed sub-routes, form fields, save bar.","marketplace.prompts.pgSettings.title":"Settings page with sections","marketplace.prompts.rfExtractComponent.tagline":"Promote inline keys to a project-level component with PascalCase.","marketplace.prompts.rfExtractComponent.title":"Extract a sub-tree into a registered component","marketplace.prompts.rfSharedLibrary.tagline":"Move a duplicated component into shared/ with the right export shape.","marketplace.prompts.rfSharedLibrary.title":"Promote a component to shared library","marketplace.prompts.subtitle":"Curated, copy-ready prompts for building, migrating, and debugging DOMQL v3.14 components, pages, and design systems. Tap any card to copy the full prompt \u2014 paste it into Claude, the Symbols MCP, or the editor\u2019s AI tab.","marketplace.prompts.title":"Prompts that work for Symbols projects","marketplace.prompts.resultsAll":"{count} prompts \xb7 all categories","marketplace.prompts.resultsAllOne":"1 prompt \xb7 all categories","marketplace.prompts.resultsFiltered":"{shown} of {total} prompts \xb7 {category}","marketplace.railDemo.emptyHint":"A \\"library\\" domain with no data pre-populated \u2014 shows InstallableRailEmpty.","marketplace.railDemo.emptyTitle":"Empty state (no kinds)","marketplace.railDemo.gridHint":"Responsive auto-fill card grid. Same data source as the rail above.","marketplace.railDemo.integrationsHeading":"Integrations","marketplace.railDemo.librariesHeading":"Libraries","marketplace.railDemo.listHint":"Bordered vertical management list with chevron + status badges.","marketplace.railDemo.mcpHeading":"MCP Connectors","marketplace.railDemo.mcpHint":"MCP connectors \u2014 none installed. Shows \\"Available\\" badge on all.","marketplace.railDemo.railHint":"Horizontal scrolling chip row. Two items pre-installed (GitHub, Slack).","marketplace.railDemo.subtitle":"Exercises all three layout variants (rail / grid / list). Clicks open the Phase 3 InstallableModalStub stub modal \u2014 Phase 4 MarketplaceInstallModal will replace it.","marketplace.railDemo.taglineFigma":"Import design tokens automatically.","marketplace.railDemo.taglineFilesystem":"Read and write local files via MCP.","marketplace.railDemo.taglineGithub":"Connect your repositories.","marketplace.railDemo.taglineGithubMcp":"Manage repos and PRs via MCP.","marketplace.railDemo.taglineLinear":"Sync issues and milestones.","marketplace.railDemo.taglineNotion":"Publish docs from your workspace.","marketplace.railDemo.taglinePostgres":"Query Postgres databases via MCP.","marketplace.railDemo.taglineSlack":"Send notifications to channels.","marketplace.railDemo.title":"InstallableRail Demo","marketplace.railNav.next":"Scroll forward","marketplace.railNav.nextAria":"Next","marketplace.railNav.prev":"Scroll back","marketplace.railNav.prevAria":"Previous","marketplace.resources.actionCopy":"Copy","marketplace.resources.actionInstall":"Install","marketplace.resources.actionUse":"Use","marketplace.resources.agentsTitle":"Agents","marketplace.resources.copiedPrompt":"Copied \\"{name}\\" prompt","marketplace.resources.countAgents":"{count} agents","marketplace.resources.countAgentsOne":"1 agent","marketplace.resources.countPrompts":"{count} prompts","marketplace.resources.countPromptsOne":"1 prompt","marketplace.resources.countSkills":"{count} skills","marketplace.resources.countSkillsOne":"1 skill","marketplace.resources.promptsTitle":"Prompts","marketplace.resources.seeAll":"See All \u203A","marketplace.resources.skillsTitle":"Skills","marketplace.results.filtered":"{visible} of {total} items","marketplace.results.filteredOne":"{visible} of 1 item","marketplace.results.items":"{count} items","marketplace.results.itemsOne":"1 item","marketplace.resultsBar.title":"All results","marketplace.scope.attachToOrg":"Attach to organization","marketplace.scope.attachToProject":"Attach to project","marketplace.scope.attachToWorkspace":"Attach to workspace","marketplace.scope.connectAt":"Connect at {scope}","marketplace.scope.connectAtOrg":"Connect at organization","marketplace.scope.connectAtProject":"Connect at project","marketplace.scope.connectAtWorkspace":"Connect at workspace","marketplace.scope.forkIntoProject":"Fork into a new project","marketplace.scope.installToWorkspace":"Install to workspace","marketplace.search.clear":"Clear search","marketplace.search.placeholder":"Search\u2026","marketplace.shortcuts.close":"Close this help, then detail pane","marketplace.shortcuts.closeHint":"Press Esc or ? to close.","marketplace.shortcuts.copyUrl":"Copy shareable URL to clipboard","marketplace.shortcuts.focusSearch":"Focus search","marketplace.shortcuts.installItem":"Install / Configure open item","marketplace.shortcuts.moveCards":"Move between cards","marketplace.shortcuts.openItem":"Open focused item","marketplace.shortcuts.random":"Surprise me \u2014 open a random visible item","marketplace.shortcuts.title":"Keyboard shortcuts","marketplace.shortcuts.toggleHelp":"Toggle this help","marketplace.shortcuts.togglePin":"Toggle pin on open detail","marketplace.signin.checkCredentials":"Please check your credentials and try again.","marketplace.signin.failed":"Sign-in failed.","marketplace.signin.failedTitle":"Failed to sign in","marketplace.signin.missingMessage":"Email/username and password are required.","marketplace.signin.missingTitle":"Missing fields","marketplace.tabs.appStore":"App Store","marketplace.tabs.aria":"Marketplace surface","marketplace.tabs.integrations":"Integrations","marketplace.tabs.market":"Marketplace","marketplace.tile.pin":"Pin to sidebar","marketplace.tile.pinAria":"Toggle pin","marketplace.toast.installed":"Installed {name}","marketplace.toast.installedPlus":"Installed {name} + {count} apps","marketplace.toast.installedPlusOne":"Installed {name} + 1 app","marketplace.toast.removed":"Removed {name}","marketplace.toast.undo":"Undo","marketplace.toast.appInstalled":"App installed \u2014 live on the workspace","marketplace.uninstallDeps.cancel":"Cancel","marketplace.uninstallDeps.forceRemove":"Force remove \u2014 may break {count} apps","marketplace.uninstallDeps.forceRemoveOne":"Force remove \u2014 may break 1 app","marketplace.uninstallDeps.hint":"{count} installed apps still require {name} to work.","marketplace.uninstallDeps.hintOne":"1 installed app still requires {name} to work.","marketplace.uninstallDeps.hintPlain":"{name} still has installed apps depending on it.","marketplace.uninstallDeps.optionalSection":"Uses this app optionally \u2014 would just lose a feature","marketplace.uninstallDeps.removing":"Removing\u2026","marketplace.uninstallDeps.requiredSection":"Requires this app \u2014 blocks removal","marketplace.uninstallDeps.thisApp":"this app","marketplace.uninstallDeps.title":"Can\'t remove {name}","marketplace.follow.follow":"Follow","marketplace.follow.following":"Following","marketplace.feedSeed.communityAuthorName":"Community","marketplace.feed.anonymous":"Anonymous"}');

});

parcelRegister("6tyYq", function(module, exports) {
module.exports = JSON.parse('{"meet.answer.empty":"No calls match.","meet.answer.failed":"Could not load the calls.","meet.answer.group.live":"Live now","meet.answer.group.recent":"Recent","meet.answer.group.upcoming":"Upcoming","meet.answer.rooms.title":"Calls","meet.answer.show.all":"All calls","meet.answer.show.recent":"Recent","meet.answer.show.upcoming":"Upcoming","meet.answer.transcript.failed":"Could not load the transcript.","meet.answer.transcript.none":"No call has a transcript yet.","meet.bucket.calendar":"Calendar","meet.bucket.calendarView":"View event","meet.bucket.chat":"Chat","meet.bucket.chatView":"Open chat","meet.bucket.knowledgeBase":"Knowledge base","meet.bucket.knowledgeBaseView":"View article","meet.bucket.notes":"Notes","meet.bucket.notesView":"View note","meet.bucket.tickets":"Tasks","meet.bucket.ticketsView":"View task","meet.captions.listening":"Listening for speech\u2026","meet.chat.close":"Close chat","meet.chat.empty":"No messages yet. Say hello!","meet.chat.heading":"In-call chat","meet.chat.participant":"Participant","meet.chat.send":"Send message","meet.confirm.createArticle":"Create article","meet.confirm.createArticleHint":"Create a new article from this transcript suggestion.","meet.confirm.createEvent":"Create event","meet.confirm.createEventHint":"Create a new event from this transcript suggestion.","meet.confirm.createMessage":"Create message","meet.confirm.createMessageHint":"Create a new message from this transcript suggestion.","meet.confirm.createNote":"Create note","meet.confirm.createNoteHint":"Create a new note from this transcript suggestion.","meet.confirm.createTicket":"Create ticket","meet.confirm.createTicketHint":"Create a new ticket from this transcript suggestion.","meet.confirm.updateArticle":"Update article","meet.confirm.updateArticleHint":"Update the existing article with this transcript suggestion.","meet.confirm.updateEvent":"Update event","meet.confirm.updateEventHint":"Update the existing event with this transcript suggestion.","meet.confirm.updateMessage":"Update message","meet.confirm.updateMessageHint":"Update the existing message with this transcript suggestion.","meet.confirm.updateNote":"Update note","meet.confirm.updateNoteHint":"Update the existing note with this transcript suggestion.","meet.confirm.updateTicket":"Update ticket","meet.confirm.updateTicketHint":"Update the existing ticket with this transcript suggestion.","meet.control.clearSelection":"Clear selection","meet.control.endRoom":"End room","meet.control.endRoomHint":"Mark the room as ended (owner only)","meet.control.hideSidebar":"Hide sidebar","meet.control.layout":"Layout","meet.control.leave":"Leave","meet.control.muteAll":"Mute all","meet.control.muteAllHint":"Mute all non-host participants (owner only)","meet.control.muteCheckedHint":"Mute the checked participants (owner only)","meet.control.muteSelected":"Mute selected ({count})","meet.control.roomSettings":"Room settings","meet.control.selectAll":"Select all","meet.control.selectAllHint":"Select every mutable participant for a batch mute (owner only)","meet.control.shareScreen":"Share screen","meet.control.showSidebar":"Show sidebar","meet.control.tileCount":"Number of tiles shown per screen","meet.control.tiles":"Tiles: {value}","meet.control.toggleCamera":"Toggle camera","meet.control.toggleCaptions":"Toggle captions","meet.control.toggleChat":"Toggle chat","meet.control.toggleMic":"Toggle mic","meet.control.toggleSidebar":"Toggle sidebar","meet.control.toggleTranscript":"Toggle transcript panel","meet.control.viewTranscript":"View full transcript","meet.error.capacityHint":"The call service refused the join (HTTP 429 \u2014 its capacity limit is reached). Retry will not clear this. Contact support.","meet.error.capacityTitle":"Calls are unavailable right now.","meet.error.configHint":"The server has no call-service configuration. Retry will not clear this.","meet.error.configTitle":"Call service not configured.","meet.error.forbiddenHint":"The call service refused the credential (HTTP {status}). Retry will not clear this. Contact support.","meet.error.forbiddenTitle":"You can\'t join this call.","meet.error.missingHint":"The call service does not have this room (HTTP {status}).","meet.error.missingTitle":"This call is no longer available.","meet.error.networkHint":"Couldn\'t reach the call service. Try Retry. Contact support if it keeps happening.","meet.error.networkTitle":"Connection hiccup \u2014 couldn\'t reach the call server.","meet.error.unknownTitle":"Couldn\'t join: {message}","meet.fly.aiName":"Symbols AI","meet.fly.backToCall":"Back to call","meet.fly.confirmCancel":"Cancel","meet.fly.confirmHeard":"I heard:","meet.fly.confirmHint":"Say \u201Cyes\u201D or \u201Cno\u201D","meet.fly.confirmLabel":"Confirm the request","meet.fly.confirmQuote":"\u201C{prompt}\u201D","meet.fly.confirmShow":"Show","meet.fly.mentionLabel":"Agents to ask","meet.fly.modeNoVoice":"Fly is on \u2014 this room has no transcript, so ask with @ai in the chat","meet.fly.modeOff":"Fly is on \u2014 turn it off","meet.fly.modeOn":"Turn Fly on \u2014 anyone in the call can ask Symbols AI for a page: say \u201CSymbols AI, \u2026\u201D or type @ai","meet.fly.pages":"The call\'s pages ({n})","meet.fly.placeholder":"Message \u2014 type @ to ask an agent","meet.guest.admitted":"Admitted \u2014 connecting\u2026","meet.guest.back":"Back","meet.guest.callEnded":"This call has ended.","meet.guest.connectionLost":"Connection lost \u2014 check your network.","meet.guest.connectionLostHint":"We couldn\'t reach the server to check your admission status.","meet.guest.declined":"The host declined your request","meet.guest.email":"EMAIL","meet.guest.emailPlaceholder":"jane@example.com","meet.guest.heading":"Join call as guest","meet.guest.joinCall":"Join call","meet.guest.leaveCall":"Leave call","meet.guest.lookupFailed":"Room lookup failed.","meet.guest.missingRoom":"Missing room id \u2014 check the share link.","meet.guest.name":"YOUR NAME","meet.guest.namePlaceholder":"e.g. Jane Doe","meet.guest.password":"PASSWORD","meet.guest.passwordPlaceholder":"Room password","meet.guest.requestToJoin":"Request to join","meet.guest.retry":"Retry","meet.guest.roomNotFound":"Room not found or not public.","meet.guest.subtitleAdmit":"Fill in your details. The host will need to admit you.","meet.guest.subtitleAuto":"Fill in your details to join directly.","meet.guest.tryAgain":"Try again","meet.guest.waitHint":"This usually takes a few seconds. Leave this tab open.","meet.guest.waitingForHost":"Waiting for the host to let you in","meet.join.camera":"Camera","meet.join.cameraHint":"Others can see you while it is on","meet.join.cancel":"Cancel","meet.join.heading":"Join call","meet.join.hint":"Choose your devices first. Nothing turns on until you join.","meet.join.joinNow":"Join now","meet.join.mic":"Microphone","meet.join.micHint":"Others can hear you while it is on","meet.layout.grid":"Grid","meet.layout.gridHint":"Everyone equal \u2014 pin or share to feature","meet.layout.speaker":"Speaker","meet.layout.speakerHint":"Spotlight whoever\'s talking","meet.link.copiedGuestTitle":"Guest link copied","meet.link.copiedMessage":"Pasteable URL is in your clipboard.","meet.link.copiedWorkspaceTitle":"Workspace link copied","meet.link.copyGuest":"Copy guest link","meet.link.copyWorkspace":"Copy workspace link","meet.link.manualMessage":"Clipboard access was blocked \u2014 copy from the prompt.","meet.link.manualTitle":"Copy this link manually","meet.link.promptLabel":"Copy this link:","meet.main.backToCalls":"Back to calls","meet.main.callCount":"{count} calls","meet.main.callCountOne":"1 call","meet.main.calls":"Calls","meet.main.endRoom":"End room","meet.main.guestWaitingOne":"1 guest waiting","meet.main.guestsWaitingCount":"{count} guests waiting","meet.main.joinCall":"Join call","meet.main.newCall":"New call","meet.main.noCalls":"No calls yet","meet.main.noCallsHint":"Start your first room with \\"New call\\".","meet.main.oneParticipantLive":"1 participant live","meet.main.participantsLive":"{count} participants live","meet.main.reopen":"Reopen","meet.main.roomEnded":"This room has ended","meet.main.settings":"Settings","meet.main.transcript":"Transcript","meet.main.transcriptionOn":"AI transcription on","meet.main.viewTranscript":"View transcript","meet.newRoom.cancel":"Cancel","meet.newRoom.derivedName":"Call \u2014 {date}, {time}","meet.newRoom.heading":"New call","meet.newRoom.hint":"Optionally turn on AI transcription \u2014 you get a summary with suggested follow-ups when the call ends.","meet.newRoom.nameAria":"Call name","meet.newRoom.namePlaceholder":"Unnamed call \u2014 type to name it","meet.newRoom.start":"Start call","meet.newRoom.transcription":"AI transcription","meet.newRoom.transcriptionHint":"Text only, never raw audio. Set at creation.","meet.newRoom.whoCanJoin":"Who can join","meet.page.guest.title":"Join meet","meet.page.meet.title":"Meet","meet.panel.close":"Close transcript","meet.panel.liveTranscript":"Live transcript","meet.panel.waiting":"Waiting for speech\u2026","meet.panel.waitingHint":"Utterances will appear here as soon as someone starts talking.","meet.recap.added":"{count} added","meet.recap.changes":"Changed during the call","meet.recap.updated":"{count} updated","meet.room.backToCalls":"Back to calls","meet.room.ended":"This room has ended","meet.room.endedHint":"The call has been closed by the host.","meet.room.fallbackName":"Call","meet.room.micBlocked":"Mic is blocked","meet.room.micBlockedHint":"Your audio won\'t be transcribed. Click the lock icon in your browser address bar and allow microphone, then click Retry.","meet.room.retry":"Retry","meet.room.transcribing":"Transcribing","meet.room.untitled":"Untitled call","meet.room.viewTranscript":"View transcript","meet.roomList.createdByYou":"Created by you","meet.roomList.ended":"Ended","meet.roomList.guestsWaiting":"Guests waiting to join","meet.roomList.kindDm":"Direct call","meet.roomList.live":"Live","meet.roomList.onePerson":"1 person in call","meet.roomList.people":"{count} people in call","meet.roomList.transcribed":"Transcribed","meet.roomList.untitled":"Untitled","meet.roomList.waitingCount":"{count} waiting","meet.settings.addMany":"Add {count} members","meet.settings.addMembers":"ADD MEMBERS","meet.settings.addOne":"Add 1 member","meet.settings.autoAdmit":"Auto-admit","meet.settings.autoAdmitHint":"Skip the waiting room \u2014 anyone who fills the form joins immediately. Use for low-sensitivity public calls.","meet.settings.copied":"Copied","meet.settings.copy":"Copy","meet.settings.guestJoin":"GUEST JOIN","meet.settings.guestLink":"GUEST LINK","meet.settings.guestLinkHint":"For people outside your workspace \u2014 they fill the join form on /meet-guest.","meet.settings.heading":"Room settings","meet.settings.hint":"Configure who can join, AI transcription, and guest requirements. Changes apply immediately for new joiners.","meet.settings.members":"MEMBERS","meet.settings.name":"NAME","meet.settings.namePlaceholder":"e.g. Weekly product sync","meet.settings.password":"PASSWORD (optional)","meet.settings.passwordHint":"Guests must type this before the waiting-room request is accepted.","meet.settings.passwordPlaceholder":"Leave blank for no password","meet.settings.publicCaption":"Anyone with the guest link can join. Guest requirements (name, email, password) apply.","meet.settings.requireEmail":"Require email","meet.settings.requireEmailHint":"Ask guests to enter an email too. Stored with the waiting-room request.","meet.settings.requireName":"Require name","meet.settings.requireNameHint":"Ask guests to enter a name before they can request to join.","meet.settings.save":"Save","meet.settings.searchPlaceholder":"Search teammates to add\u2026","meet.settings.selectPeople":"Select people to add","meet.settings.transcription":"AI transcription","meet.settings.transcriptionHint":"Records text only \u2014 never raw audio. The call ends with a transcript page proposing calendar events, tickets, notes.","meet.settings.unnamed":"Unnamed","meet.settings.whoCanJoin":"WHO CAN JOIN","meet.settings.workspaceCaption":"Any teammate in your workspace can join via the workspace link. No guest link.","meet.settings.workspaceLink":"WORKSPACE LINK","meet.settings.workspaceLinkHint":"Share with teammates \u2014 they sign in with their workspace account.","meet.sidebar.archive":"Archive","meet.sidebar.archived":"Archived calls","meet.sidebar.calls":"CALLS","meet.sidebar.callsAria":"Calls","meet.sidebar.done":"Done","meet.sidebar.newCall":"New call","meet.sidebar.unarchive":"Unarchive","meet.state.off":"Off","meet.state.on":"On","meet.suggestion.addToKb":"Add to KB","meet.suggestion.confirm":"Confirm","meet.suggestion.create":"Create","meet.suggestion.createEvent":"Create event","meet.suggestion.createHint":"Create a new item from this transcript suggestion.","meet.suggestion.createNote":"Create note","meet.suggestion.createTicket":"Create ticket","meet.suggestion.created":"Created","meet.suggestion.details":"Details","meet.suggestion.messageLabel":"Message","meet.suggestion.metaTo":"To: {email}","meet.suggestion.reviewHeading":"Review suggestion","meet.suggestion.titleLabel":"Title","meet.suggestion.untitled":"Untitled","meet.suggestion.update":"Update","meet.suggestion.updateHint":"Update the existing item with this transcript suggestion.","meet.suggestion.view":"View","meet.suggestion.willUpdate":"Will update existing","meet.tile.backToGrid":"Back to grid","meet.tile.expand":"Expand","meet.tile.mute":"Mute","meet.tile.muteParticipant":"Mute participant (admin)","meet.tile.next":"Next tiles","meet.tile.previous":"Previous tiles","meet.tile.screen":"Screen","meet.tile.selectForBatchMute":"Select for batch mute","meet.tile.speaking":"Speaking","meet.tile.youName":"{name} (you)","meet.tiles.auto":"Auto","meet.transcript.analyze":"Analyze","meet.transcript.applyToFeatures":"Apply to other features","meet.transcript.empty":"No speech captured yet \u2014 the transcript fills in as people talk.","meet.transcript.heading":"Transcript","meet.transcript.noAnalysis":"No analysis yet.","meet.transcript.noteTitle":"{room} \u2014 summary","meet.transcript.preparing":"Preparing summary\u2026","meet.transcript.processing":"Transcription still processing \u2014 check back in a moment.","meet.transcript.regenerate":"Regenerate","meet.transcript.saveToNotes":"Save to notes","meet.transcript.suggestionCount":"{n} suggestions","meet.transcript.suggestionCountOne":"1 suggestion","meet.transcript.summary":"Summary","meet.transcript.unknownSpeaker":"Unknown","meet.transcript.viewNote":"View note","meet.visibility.private":"Private","meet.visibility.privateCaption":"Only members you add explicitly can join or read the transcript.","meet.visibility.privateHint":"Only members you add explicitly","meet.visibility.public":"Public","meet.visibility.publicCaption":"Anyone with the guest link can join \u2014 the name, email and password requirements are in the room settings.","meet.visibility.publicHint":"Anyone with the guest link","meet.visibility.workspace":"Workspace","meet.visibility.workspaceCaption":"Any teammate in your workspace can join via the workspace link.","meet.visibility.workspaceHint":"Any teammate in this workspace","meet.waiting.admit":"Admit","meet.waiting.guest":"Guest","meet.waiting.reject":"Reject","meet.widget.inCall":"In call","meet.widget.leaveCall":"Leave call","meet.widget.micOff":"mic off","meet.widget.micOn":"mic on","meet.widget.participantLine":"{count} in call \xb7 {mic}","meet.widget.returnToCall":"Return to call","meet.widget.showPages":"Show the call\'s pages","meet.widget.toggleMic":"Toggle mic"}');

});

parcelRegister("7Zvah", function(module, exports) {
module.exports = JSON.parse('{"members.invite.allMembers":"All members","members.invite.body":"Invite your team members and assign permissions and roles.","members.invite.error.title":"Error message","members.invite.failed":"Invite failed","members.invite.heading":"Invite team members","members.invite.loadFailed":"Could not load members.","members.invite.members":"Members","members.invite.membersCount":"Members \xb7 {count}","members.invite.offline":"Could not reach the server. Check your connection and try again.","members.invite.onlyYou":"Only you so far.","members.invite.retry":"Try again","members.invite.success.message":"User \'{name}\' has been successfully invited","members.invite.success.title":"Success message","members.invite.validation.message":"Please fill in all fields","members.invite.validation.title":"Validation message","members.inviteDropdown.copyLink":"Copy invite link","members.inviteDropdown.linkCopied.title":"Link copied","members.inviteDropdown.magicLink.active":"Active links","members.inviteDropdown.magicLink.copy":"Copy magic link","members.inviteDropdown.magicLink.created":"Link copied \u2014 the first person who opens it joins as {role}. Ends {date}.","members.inviteDropdown.magicLink.creating":"Creating\u2026","members.inviteDropdown.magicLink.failed":"Could not create the link","members.inviteDropdown.magicLink.hint":"The first person who opens it joins as {role}. It works once.","members.inviteDropdown.magicLink.hintDays":"The first person who opens it joins as {role}. It works once. It ends in {days} days.","members.inviteDropdown.magicLink.hintOneDay":"The first person who opens it joins as {role}. It works once. It ends in 1 day.","members.inviteDropdown.magicLink.loadFailed":"Could not load the active links.","members.inviteDropdown.magicLink.notCopied":"Link created, but it could not be copied. Revoke it and try again.","members.inviteDropdown.magicLink.revoke":"Revoke","members.inviteDropdown.magicLink.revokeFailed":"Could not revoke the link","members.inviteDropdown.magicLink.revokeLabel":"Revoke the {role} link that ends {date}","members.inviteDropdown.magicLink.revoked":"Link revoked. Nobody can join with it now.","members.inviteDropdown.magicLink.revoking":"Revoking\u2026","members.inviteDropdown.magicLink.row":"{role} \xb7 Ends {date}","members.inviteDropdown.magicLink.title":"Share by magic link","members.inviteDropdown.magicLink.tooMany":"Revoke an open link first.","members.inviteDropdown.noPermission":"Only admins can invite people here. Ask an admin to send the invite.","members.inviteDropdown.personalOrg":"A personal organization holds only you. Invite people to a team organization.","members.inviteDropdown.sentNoEmail":"Invite created for {email}, but the email did not go out. Copy the link and send it yourself.","members.inviteDropdown.title":"Invite members","members.inviteForm.emailLabel":"Email","members.inviteForm.emailOfMember":"Email of member","members.inviteForm.fullName":"Full name","members.inviteForm.invalidEmail":"Enter a valid email address.","members.inviteForm.needEmail.message":"Type an email address to invite.","members.inviteForm.placeholder":"Type email to invite","members.inviteForm.roleOfMember":"Role of member","members.inviteForm.send":"Send invite","members.inviteForm.sending":"Sending\u2026","members.inviteSent.person":"Invited {who}","members.navbar.invite":"Invite Members","members.notify.error.title":"Error message","members.notify.success.title":"Success message","members.persona.exit":"Exit","members.persona.exiting":"Exiting\u2026","members.persona.role.admin":"Admin","members.persona.role.guest":"Guest","members.persona.role.teamMember":"Team member","members.persona.viewAs":"View as","members.persona.viewAsRole":"View as {role}","members.requestAccess.body":"We\'re kicking off invite-only. Get early signup to make it to the top.","members.requestAccess.continueEmail":"Continue with email","members.requestAccess.title":"Get early access","members.role.admin":"Admin","members.role.changeFailed":"Role change failed","members.role.coOwner":"Co-owner","members.role.contributor":"Contributor","members.role.editor":"Member","members.role.guest":"Guest","members.role.maintainer":"Maintainer","members.role.member":"Member","members.role.owner":"Owner","members.role.viewer":"Contributor","members.roleUpdated.fallbackName":"Member","members.roleUpdated.message":"{name} is now {role}","members.roleUpdated.title":"Role updated","members.share.canvasLink":"Canvas link","members.share.copyUrl":"Copy URL","members.share.env.current":"Current","members.share.env.development":"Development","members.share.env.production":"Production","members.share.env.staging":"Staging","members.share.environment":"Environment","members.share.environmentHint":"Inherint or switch while sharing","members.share.openNewTab":"Open in new tab","members.share.previewLink":"Preview link","members.share.selection":"Selection share","members.share.selectionHint":"Link to selected element on canvas","members.share.title":"Share","members.sharing.canvasAccess":"Canvas access","members.sharing.canvasHint":"Control access to the canvas","members.sharing.passwordProtected":"Password protected","members.sharing.previewHint":"Control access to the preview links","members.sharing.previewVisibility":"Preview visibility","members.sharing.private":"Private","members.sharing.public":"Public","members.sharing.title":"Access Permissions","members.sharing.unlisted":"Unlisted","members.sharingNavbar.newTab":"In new tab","members.sharingNavbar.share":"Share","members.table.actions":"Actions","members.table.confirmRole":"Confirm role change","members.table.editRole":"Edit role","members.table.email":"Email","members.table.empty":"No team members found.","members.table.name":"Name","members.table.removeMember":"Remove member","members.table.role":"Role","members.usersTable.heading":"Team Members","members.usersTable.invite":"Invite new member","members.usersTable.title":"Team Members:"}');

});

parcelRegister("dtJ5d", function(module, exports) {
module.exports = JSON.parse('{"preview.answer.device.desktop":"Desktop","preview.answer.device.mobile":"Mobile","preview.answer.device.tablet":"Tablet","preview.answer.deviceLabel":"Device","preview.answer.envOff":"{name} is switched off on {env}. Its address shows nothing.","preview.answer.envs":"Environment","preview.answer.frameTitle":"Preview of {name}","preview.answer.inspect":"Inspect elements","preview.answer.inspectFailed":"{name} could not open for inspection.","preview.answer.inspectFrameTitle":"Inspect {name}","preview.answer.inspectLoading":"Opening {name} for inspection\u2026","preview.answer.inspectReady":"Inspect is on. Pick an element to ask about it.","preview.answer.loading":"Loading {name}\u2026","preview.answer.loadingPart":"Loading\u2026","preview.answer.missing":"No website in this workspace matches.","preview.answer.neverPublished":"{name} was never published on {env}. Its address shows the latest saved version.","preview.answer.noContent":"{name} has no pages on {env} yet.","preview.answer.none":"This workspace has no website to preview yet.","preview.answer.notWebsite":"{name} is not a website. This card shows websites.","preview.answer.open":"Open the site in a new tab","preview.answer.openInPreview":"Open in Preview","preview.answer.page":"Page","preview.answer.pick":"Pick an element","preview.answer.picking":"Click an element of the page. Esc stops.","preview.answer.reload":"Reload","preview.answer.slow":"{name} is still loading. The site is slow to answer.","preview.answer.storeApp":"{name} is an app from the App Store, not a project of this workspace. This card shows websites.","preview.answer.title":"Website","preview.assistant.close":"Close assistant","preview.assistant.requestFailed":"Sorry \u2014 that request failed ({message}).","preview.assistant.transportNotReady":"Assistant transport not ready \u2014 please retry in a moment.","preview.builder.draft":"Draft \xb7 not published","preview.builder.page":"Page","preview.builder.publish":"Publish","preview.builder.setup":"Setting up your site\u2026","preview.builder.updating":"Updating preview\u2026","preview.builder.working":"Working on the site\u2026","preview.dsView.empty":"{name} has no design system yet.","preview.dsView.failed":"The design system of {name} could not be shown.","preview.dsView.frameTitle":"Design system of {name}","preview.dsView.section":"Section","preview.dsView.title":"Design system","preview.envBanner.fallback":"Showing {resolved} env \u2014 {requested} not published yet.","preview.errorBoundary.code.unknown":"Unknown error","preview.errorBoundary.openInEditor":"Open in editor","preview.errorBoundary.openInSymbols":"Open in Symbols","preview.errorBoundary.password.failed":"Failed to unlock.","preview.errorBoundary.password.incorrect":"Incorrect password. Try again.","preview.errorBoundary.password.label":"Password","preview.errorBoundary.password.placeholder":"Enter project password","preview.errorBoundary.password.required":"Password is required.","preview.errorBoundary.password.unlock":"Unlock","preview.errorBoundary.password.unlocking":"Unlocking\u2026","preview.errorBoundary.retry.busy":"Retrying\u2026","preview.errorBoundary.retry.idle":"Retry","preview.errorBoundary.subtitle.bootFailed":"Could not create {slug}{env}. The published snapshot has a malformed design system or page.","preview.errorBoundary.subtitle.noData":"Unable to load project data.","preview.errorBoundary.subtitle.notAvailable":"{slug} isn\'t shared publicly. If you have access, open it in Symbols.","preview.errorBoundary.subtitle.passwordRequired":"{slug} is password-protected. Enter the password to view.","preview.errorBoundary.subtitle.thisProject":"this project","preview.errorBoundary.subtitle.unexpected":"An unexpected error occurred.","preview.errorBoundary.title.bootFailed":"Preview failed to start","preview.errorBoundary.title.loadFailed":"Preview failed to load","preview.errorBoundary.title.notAvailable":"Project not available","preview.errorBoundary.title.passwordRequired":"Password required","preview.errorBoundary.title.unavailable":"Preview unavailable","preview.errorBoundary.triedEnvs.label":"Tried:","preview.navbar.a11yFilter":"Accessibility simulation","preview.navbar.assistantHide":"Hide AI assistant","preview.navbar.assistantShow":"Ask the AI assistant","preview.navbar.canvasLink":"Open in Canvas editor","preview.navbar.device.mobileXS":"Mobile (375\xd7768)","preview.navbar.device.resizable":"Resizable","preview.navbar.device.screenL":"Large Screen (1920\xd71024)","preview.navbar.device.screenM":"Medium Screen (1680\xd71024)","preview.navbar.device.tabletL":"Tablet Landscape (1366\xd7926)","preview.navbar.device.tabletS":"Tablet Portrait (1024\xd7768)","preview.navbar.env.development":"Development","preview.navbar.env.loading":"{env} \xb7 loading\u2026","preview.navbar.env.production":"Production","preview.navbar.env.staging":"Staging","preview.navbar.openInNewTab":"Open in new tab","preview.navbar.refresh":"Refresh preview","preview.navbar.settings":"Settings","preview.navbar.settingsPanel.showInherited":"Show inherited from shared libraries","preview.navbar.settingsPanel.showInheritedHint":"Includes pages and components contributed by linked shared libraries.","preview.navbar.settingsPanel.title":"Display options","preview.navbar.sidebarHide":"Hide sidebar","preview.navbar.sidebarShow":"Show sidebar","preview.navbar.theme.dark":"Dark mode","preview.navbar.theme.light":"Light mode","preview.navbar.urlCopied":"Copied","preview.pagesView.back":"Back to all","preview.pagesView.componentFailed":"{name} could not be shown.","preview.pagesView.more":"{n} of {total}","preview.pagesView.noComponents":"{name} has no components yet.","preview.pagesView.noPages":"{name} has no pages yet.","preview.pagesView.openTile":"Open {name} live","preview.pagesView.show":"Show","preview.pagesView.title":"Website pages","preview.pagesView.unread":"The pages of {name} could not be read.","preview.sceneNavbar.fullscreen":"Fullscreen","preview.sceneNavbar.minimize":"Minimize","preview.sidebar.category.components":"Components","preview.sidebar.category.designSystem":"Design System","preview.sidebar.category.pages":"Pages","preview.sidebar.ds.colors":"Colors","preview.sidebar.ds.icons":"Icons","preview.sidebar.ds.layout":"Layout","preview.sidebar.ds.misc":"Misc","preview.sidebar.ds.spacing":"Spacing","preview.sidebar.ds.transitions":"Transitions","preview.sidebar.ds.typography":"Typography"}');

});

parcelRegister("1xkEU", function(module, exports) {
module.exports = JSON.parse('{"publish.action.export":"Export","publish.action.publish":"Publish","publish.action.sync":"Sync","publish.action.upgrade":"Upgrade","publish.dns.cname":"CNAME","publish.dns.step1":"1. Go to your DNS manager for ","publish.dns.step2":"2. Create A records:","publish.dns.step3":"3. Create TXT record:","publish.domains.custom":"Custom domain","publish.domains.customHint":"Connect any domain to your app","publish.domains.find":"Find your domain","publish.domains.findHint":"Connect to a new domain","publish.domains.management":"Domain management","publish.domains.name":"Domain name","publish.domains.needApiKey":"Enter your API key above to enable domain search.","publish.domains.noResults":"No results. Try a different query.","publish.domains.register":"Register","publish.domains.renews":"renews {date}","publish.domains.searching":"Searching\u2026","publish.domains.taken":"taken","publish.domains.title":"Domains","publish.domains.yours":"Your domains","publish.envs.development":"Development","publish.envs.developmentHint":"Default - set to latest","publish.envs.local":"Local","publish.envs.production":"Production","publish.envs.productionHint":"Specify production channel","publish.envs.staging":"Staging","publish.envs.test":"Test","publish.envs.testHint":"Specify staging channel","publish.envs.title":"Environments","publish.exports.download":"Download export","publish.exports.html.descr":"Download pre-rendered HTML","publish.exports.jquery.descr":"Download files with jQuery runner","publish.exports.local.descr":"Download as local Javascript files","publish.exports.local.title":"Local files","publish.exports.react.descr":"Download files with React runner","publish.exports.svg.descr":"Download files with React runner","publish.exports.webp.descr":"Download files with jQuery runner","publish.modal.confirm":"Confirm publish","publish.modal.confirmAgain":"Click \\"Publish\\" again to confirm.","publish.modal.otherPaths":"Other changed paths:","publish.sync.autosync":"Autosync","publish.sync.autosyncHint":"Enable auto syncing during publishing","publish.sync.connect":"Connect","publish.sync.figma.descr":"Import tokens, layers and artboards","publish.sync.github.descr":"Sync with your repository","publish.sync.website.descr":"Import tokens, layers and artboards","publish.sync.website.title":"Your website","publish.sync.wordpress.descr":"Sync Symbols components","publish.tools.autosaved":"Autosaved","publish.tools.latest":"Latest","publish.tools.showVersions":"Show versions","publish.tools.updateMajor":"Update Major","publish.tools.updateMinor":"Update Minor"}');

});

parcelRegister("9sHa1", function(module, exports) {
module.exports = JSON.parse('{"settings.appearance.adminOnly":"Only a workspace owner or admin can change this.","settings.appearance.conflict":"Another admin changed the skin a moment ago. The card now shows their choice.","settings.appearance.notSaved":"The skin was not saved. Try again later.","settings.appearance.saveError":"Couldn\'t save the workspace skin","settings.appearance.section":"Appearance","settings.appearance.skin.ambient":"Ambient","settings.appearance.skin.solid":"Solid","settings.appearance.skinCaption":"Ambient puts a quiet sky behind the home page and frosts the cards. Solid keeps one flat ground, for a branded workspace.","settings.appearance.skinTitle":"Skin","settings.canvas.animations":"Enable animations:","settings.canvas.artboardTitles":"Allow titles on artboard:","settings.canvas.autoCleanConsole":"Auto clean console:","settings.canvas.autoInitialSelection":"Auto initial selection:","settings.canvas.autoPositioning":"Auto positioning:","settings.canvas.autoSelectSidebar":"Auto-select sidebar on selection:","settings.canvas.componentReferences":"Show component references:","settings.canvas.doubleClickOpen":"Double click to open:","settings.canvas.imagePreviews":"Use image previews:","settings.canvas.linkScroll":"Allow links to scroll to pages:","settings.canvas.showGrid":"Show canvas grid:","settings.canvas.teamCursors":"Show team cursors:","settings.canvas.title":"Canvas","settings.canvas.zoomBar":"Enable zoom bar:","settings.codeEditor.debounce":"Editor debounce","settings.codeEditor.folding":"Folding:","settings.codeEditor.fontFamily":"Font family","settings.codeEditor.fontFamilyPlaceholder":"default","settings.codeEditor.fontLigature":"Font ligature:","settings.codeEditor.fontSize":"Font size","settings.codeEditor.lineHeight":"Line height","settings.codeEditor.minimap":"Minimap:","settings.codeEditor.monacoOptions":"Monaco options","settings.codeEditor.tabSize":"Tab size","settings.codeEditor.title":"Code Editor","settings.codeEditor.wordWrap":"Word wrap","settings.footer.autoUpdate":"Auto update canvas","settings.footer.cleanCache":"Clean project cache","settings.footer.cleanCookies":"Clean settings cookies","settings.footer.convertDomql3":"Convert to DOMQL3","settings.footer.cookiesCleared.message":"Cleared all project related cookies from browser","settings.footer.cookiesCleared.title":"Cookies are cleared","settings.footer.resetSettings":"Reset settings","settings.footer.restoreComponents":"Restore missing components","settings.footer.restoreTypes":"Restore missing types","settings.footer.saved.message":"Project settings are updated","settings.footer.saved.title":"Settings are saved","settings.footer.update":"Update","settings.governance.env.development":"Development","settings.governance.env.production":"Production","settings.governance.env.staging":"Staging","settings.governance.link.code":"Code","settings.governance.link.commit":"Commit","settings.governance.link.releaseNotes":"Release notes","settings.governance.link.workflow":"Github workflow","settings.language.adminOnly":"Only a workspace owner or admin can change this.","settings.language.noWorkspace":"No active workspace.","settings.language.notReady":"Not ready yet. Try again.","settings.language.saveError":"Couldn\'t save the workspace default language","settings.language.section":"Language","settings.language.title":"Interface language","settings.language.workspaceCaption":"Every member sees this language in this workspace.","settings.language.workspaceTitle":"Workspace default language","settings.platform.debugging":"Debugging mode:","settings.platform.defaultTheme":"Default global theme","settings.platform.domql3":"DOMQL3:","settings.platform.enableExplorer":"Enable explorer:","settings.platform.filePreviews":"Enable file sidebar previews:","settings.platform.glassSidebars":"Glass effect on sidebars:","settings.platform.globalTheme":"Global theme","settings.platform.lowPerformance":"Low performance mode:","settings.platform.scrollFilesSidebar":"Scroll files sidebar on active item:","settings.platform.theme.auto":"Auto","settings.platform.theme.dark":"Dark","settings.platform.theme.light":"Light","settings.platform.title":"Platform Options","settings.section.platform":"Platform settings","settings.section.resetTooltip":"Reset to default","settings.sync.forceNavigate":"Force navigate:","settings.sync.forceNavigatePrompt":"Force navigate","settings.sync.forceReload":"Force reload:","settings.sync.forceReloadConfirm":"Do you want to force reload all connected devices?","settings.sync.navigation":"Allow navigation sync:","settings.sync.teamNavigation":"Allow team navigation sync:","settings.sync.title":"Syncing options","settings.tabs.billing":"Billing","settings.tabs.connect":"Connect","settings.tabs.data":"Data","settings.tabs.install":"Install","settings.tabs.settings":"Settings","settings.tabs.sharedLibraries":"Shared Libraries","settings.tabs.versions":"Versions","settings.tip.allowInspecting":"Allow users to inspect elements on the website","settings.tip.animations":"Enable animations during navigating on canvas","settings.tip.artboardTitles":"Allow showing titles when hovering artboards","settings.tip.asyncLoading":"Load data asynchronically during app creation","settings.tip.autoCleanConsole":"Auto clean console on platform updates","settings.tip.autoInitialSelection":"Enable canvas load previously selected component after initial load","settings.tip.autoPositioning":"Enable canvas windows auto positioning","settings.tip.autoSelectSidebar":"Auto switch sidebar when artboard is selected","settings.tip.componentReferences":"Show other places where component is reused","settings.tip.debugging":"Logs and sends notifications on tested actions","settings.tip.domql3":"Use DOMQL3 syntax","settings.tip.doubleClickOpen":"Enable double click to open components from canvas and sidebar","settings.tip.enableExplorer":"Toggle enable file sidebar","settings.tip.fetchData":"Allow symbols server fetching while app is loaded","settings.tip.filePreviews":"Enable preview of components when you mouse over on file sidebar","settings.tip.glassSidebars":"Whether to use glass blurry effect on sidebar items","settings.tip.imagePreviews":"Use thumbnail image previews on components when available to save rendering performance","settings.tip.linkScroll":"Allow canvas to scroll to links with URLs to pages","settings.tip.liveSync":"Allow users to sync platform updates to the website","settings.tip.lowPerformance":"Allow Symbols to optimize canvas for low performance devices","settings.tip.scrollFilesSidebar":"Scroll sidebar when a new component is selected","settings.tip.showGrid":"Enable movable dotted background on the Canvas","settings.tip.syncNavigation":"Sync platform navigation across the devices","settings.tip.syncTeamNavigation":"Sync platform navigation across project members","settings.tip.teamCursors":"Enable showing up team members cursors","settings.tip.zoomBar":"Enable zoom bar on Canvas","settings.voice.adminOnly":"Only a workspace owner or admin can change this.","settings.voice.caption":"The voice the assistant speaks in for every member of this workspace.","settings.voice.current":"Current voice","settings.voice.default":"Default voice","settings.voice.invalid":"This voice is no longer on the voice list. Pick another one.","settings.voice.loadFailed":"The voice list did not load.","settings.voice.loading":"Loading voices\u2026","settings.voice.notSaved":"The voice was not saved. Try again later.","settings.voice.play":"Play sample","settings.voice.retry":"Try again","settings.voice.sampleFailed":"The sample did not play","settings.voice.sampleText":"Hello. This is how the assistant of your workspace sounds.","settings.voice.saveError":"Couldn\'t save the assistant voice","settings.voice.section":"Voice","settings.voice.stop":"Stop","settings.voice.unprovisioned":"Voice is not set up for this workspace yet.","settings.voice.voiceTitle":"Assistant voice","settings.website.allowInspecting":"Allow inspecting:","settings.website.asyncLoading":"Use async loading:","settings.website.fetchData":"Fetch symbols data:","settings.website.liveSync":"Allow website live sync:","settings.website.title":"Website controls"}');

});

parcelRegister("92t7q", function(module, exports) {
module.exports = JSON.parse('{"shell.accountMenu.admin":"Admin","shell.accountMenu.customizeDashboard":"Customize dashboard","shell.accountMenu.open":"Account menu","shell.accountMenu.profile":"Profile","shell.accountMenu.settings":"Settings","shell.accountMenu.signOut":"Sign out","shell.actionNotification.done":"Done","shell.actionNotification.goTo":"Go to","shell.app.addApp":"Add app","shell.app.agents":"Agents","shell.app.analytics":"Analytics","shell.app.announcements":"Announcements","shell.app.calendar":"Calendar","shell.app.chat":"Team chat","shell.app.company":"Company","shell.app.data":"Data","shell.app.files":"Files","shell.app.home":"Home","shell.app.inbox":"Inbox","shell.app.people":"People","shell.comm.brand":"Symbols Chat","shell.comm.askAi":"Ask AI","shell.app.mail":"Mail","shell.app.marketplace":"Marketplace","shell.app.meet":"Meet","shell.app.more":"More","shell.app.myProfile":"My profile","shell.app.notes":"Notes","shell.app.reminders":"Reminders","shell.app.history":"History","shell.app.studio":"Apps","shell.app.tasks":"Tasks","shell.app.team":"Team","shell.app.teamAndAgents":"Team & agents","shell.app.teamMembers":"Team members","shell.app.terminal":"Terminal","shell.app.workspace":"Workspace","shell.assistantToggle.ariaLabel":"Toggle AI Assistant","shell.assistantToggle.tooltip":"AI Assistant","shell.clipboard.pasteFailed.title":"Can not paste","shell.commandPalette.error":"Error: {error}","shell.commandPalette.inputAria":"Canvas command or search","shell.commandPalette.placeholder":"Type / for command, or search","shell.commandPalette.ran":"Ran /{name}","shell.commandPalette.unknown":"Unknown: /{name}","shell.comments.cancelReply":"Cancel reply","shell.comments.edited":"edited","shell.comments.empty":"No comments yet.","shell.comments.error":"Comments could not be loaded.","shell.comments.loading":"Loading comments\u2026","shell.comments.placeholder":"Write a comment\u2026","shell.comments.post":"Post","shell.comments.remove":"Delete","shell.comments.removed":"Comment deleted","shell.comments.reply":"Reply","shell.comments.replyingTo":"Replying to {name}","shell.comments.title":"Comments","shell.comments.unknown":"Unknown","shell.comments.postError":"Your comment was not posted. Nothing was lost \u2014 try again.","shell.comments.removeError":"The comment could not be deleted.","shell.errorState.forbidden.heading":"You don\'t have access","shell.errorState.forbidden.hint":"Ask an admin to grant the right permission.","shell.errorState.generic.heading":"Couldn\'t load","shell.errorState.generic.hint":"Refresh the page to try again.","shell.errorState.lazyPage":"Couldn\u2019t load this page. Refresh to try again.","shell.errorState.notFound.heading":"Not found","shell.errorState.notFound.hint":"The page you\'re looking for doesn\'t exist.","shell.errorState.offline.heading":"You\'re offline","shell.errorState.offline.hint":"Reconnect to the internet to load this page.","shell.errorState.serverError.heading":"Something went wrong","shell.errorState.serverError.hint":"A server error broke the page. Try again in a moment.","shell.header.logo.ariaLabel":"Symbols home","shell.header.mail.tooltip":"Mail","shell.header.newCall.tooltip":"Start a call","shell.headerSearch.close":"Close search","shell.headerSearch.loading":"Searching\u2026","shell.headerSearch.noResults":"No results for \u201C{query}\u201D","shell.headerSearch.openDropdown":"Open search dropdown","shell.headerSearch.placeholder":"Search across everything\u2026","shell.headerTabs.apps":"Apps","shell.headerTabs.dashboard":"Dashboard","shell.headerTabs.dashboardAriaLabel":"Go to dashboard","shell.headerTabs.openApps":"Open apps","shell.headerTabs.openWorkspace":"Open workspace","shell.headerTabs.primaryNav":"Primary","shell.launcher.adminConsole.caption":"Workspace administration","shell.launcher.adminConsole.title":"Admin console","shell.launcher.adminLogs.caption":"Administrative activity trail","shell.launcher.adminLogs.title":"Admin logs","shell.launcher.agents.caption":"All agents \u2014 filter by yours, status, type or assignment","shell.launcher.agents.title":"Agents","shell.launcher.analytics.caption":"Full traction on what you\'re building","shell.launcher.analytics.title":"Analytics","shell.launcher.appStore":"App Store","shell.launcher.appStoreTooltip":"Browse the App Store","shell.launcher.filterPlaceholder":"Filter apps and results","shell.launcher.history.caption":"Everyone\'s activity on one timeline","shell.launcher.history.title":"Workspace History","shell.launcher.broadcast.caption":"Announcements, polls and the workspace feed","shell.launcher.broadcast.title":"Broadcast","shell.launcher.calendar.caption":"Schedule meetings with team and agents","shell.launcher.calendar.title":"Calendar","shell.launcher.chat.caption":"Team and agent conversations","shell.launcher.chat.title":"Chat","shell.launcher.data.caption":"Users, orgs, projects, plans","shell.launcher.data.title":"Data","shell.launcher.dragToHomeAria":"Drag to Home or press Alt+Enter to add it.","shell.launcher.dragToHomeHint":"drag to Home or press Alt+Enter to add.","shell.launcher.featureFlags.caption":"Toggle workspace features on and off","shell.launcher.featureFlags.title":"Feature flags","shell.launcher.files.caption":"Shared files and folders on the workspace desktop","shell.launcher.files.title":"Files","shell.launcher.following":"Following","shell.launcher.followingTooltip":"Posts from people you follow","shell.launcher.groupAdmin":"Admin","shell.launcher.groupInsights":"Insights","shell.launcher.groupTeam":"Team","shell.launcher.groupViews":"Views","shell.launcher.groupWork":"Work","shell.launcher.heading":"Apps","shell.launcher.mail.caption":"Workspace email and conversations","shell.launcher.mail.title":"Mail","shell.launcher.meet.caption":"Transcriptive meetings that apply edits on your workspace","shell.launcher.meet.title":"Meet","shell.launcher.moduleConsole.caption":"Assign + personalize the workspace module","shell.launcher.moduleConsole.title":"Module console","shell.launcher.newApp":"New app","shell.launcher.newAppTooltip":"Create a new app","shell.launcher.notes.caption":"Notes and the knowledge base","shell.launcher.notes.title":"Notes","shell.launcher.permissions.caption":"Roles, access and freebusy","shell.launcher.permissions.title":"Permissions","shell.launcher.reminders.caption":"Personal reminders and follow-ups","shell.launcher.reminders.title":"Reminders","shell.launcher.studio.caption":"Workspace apps and websites","shell.launcher.systemHealth.caption":"Services, packages and uptime","shell.launcher.systemHealth.title":"System Health","shell.launcher.tasks.caption":"Tasks for humans and agents","shell.launcher.tasks.title":"Tasks","shell.launcher.teamAndAgents.caption":"Manage team and delegate responsibilities","shell.launcher.teamAndAgents.title":"Team and agents","shell.launcher.teamMembers.caption":"Your team and contributors directory","shell.launcher.teamMembers.title":"Team members","shell.launcher.teams.caption":"Team structure and membership","shell.launcher.teams.title":"Teams","shell.launcher.terminal.caption":"A command line in your browser","shell.launcher.terminal.title":"Terminal","shell.launcher.usage.caption":"Credits, metering and billing","shell.launcher.usage.title":"Usage & billing","shell.launcher.users.caption":"Meet, manage and reach your customers","shell.launcher.users.title":"Users","shell.launcher.workspaceUsage.caption":"Sessions, active users and usage across the whole workspace","shell.launcher.workspaceUsage.title":"Workspace usage","shell.launcherTileMenu.addToDashboard":"Add to dashboard","shell.launcherTileMenu.alreadyOnHome":"Already on Home","shell.launcherTileMenu.alreadyOnHomeBody":"This app is already on your dashboard.","shell.launcherTileMenu.edit":"Edit","shell.launcherTileMenu.notOnHome":"Not available on Home","shell.launcherTileMenu.notOnHomeBody":"This app does not have a Home shortcut yet.","shell.launcherTileMenu.open":"Open","shell.launcherTileMenu.pin":"Pin to navbar","shell.launcherTileMenu.sideView":"Open in side view","shell.launcherTileMenu.unpin":"Unpin from navbar","shell.messenger.loadFailed":"Couldn\u2019t load chat. Check your connection and try again.","shell.messenger.tooltip":"Direct messages","shell.navSearchMenu.pin":"Pin to navbar","shell.navSearchMenu.unpin":"Unpin","shell.navbar.collapse":"Collapse navbar","shell.navbar.expand":"Expand navbar","shell.navbar.label":"Navbar: {position}","shell.navbar.position.bottom":"bottom","shell.navbar.position.left":"left","shell.navbar.position.right":"right","shell.navbar.position.top":"top","shell.navbarTabMenu.remove":"Remove from navbar","shell.navbarTabMenu.reset":"Reset navbar items","shell.navbarTabMenu.sideView":"Open in side view","shell.notificationBell.tooltip":"Notifications","shell.notifications.close":"Close notifications","shell.notifications.empty.all":"You\'re all caught up","shell.notifications.empty.unread":"No unread notifications","shell.notifications.empty.workspace":"Nothing from this workspace","shell.notifications.markAllRead":"Mark all read","shell.notifications.otherOrg.confirm":"Switch & open","shell.notifications.otherOrg.message":"This notification lives in the \\"{org}\\" organization \u2014 opening it switches this tab there.","shell.notifications.otherOrg.title":"Open in another organization?","shell.notifications.panel.title":"Notifications","shell.notifications.tab.all":"All","shell.notifications.tab.unread":"Unread","shell.notifications.tab.unreadCount":"Unread \xb7 {count}","shell.notifications.tab.workspace":"Workspace","shell.notifications.tab.workspaceTooltip":"Only notifications from the workspace you\u2019re in","shell.notifications.viewAll":"View all notifications","shell.orgSwitcher.admin":"Admin","shell.orgSwitcher.ariaDemo":"Demo organization","shell.orgSwitcher.ariaForeign":"Viewing an external project \u2014 organization switcher unavailable","shell.orgSwitcher.createFailed":"Create failed","shell.orgSwitcher.createOrg":"+ Create organization","shell.orgSwitcher.deleteConfirm":"Confirm delete?","shell.orgSwitcher.deleteFailed":"Delete failed","shell.orgSwitcher.deleteOrg":"Delete organization","shell.orgSwitcher.deleting":"Deleting\u2026","shell.orgSwitcher.invite":"Invite members","shell.orgSwitcher.networkError":"Couldn\'t reach the server \u2014 check your connection and try again.","shell.orgSwitcher.newWorkspace":"New workspace","shell.orgSwitcher.newWorkspaceAria":"Create a new workspace in this organization","shell.orgSwitcher.newWorkspacePlaceholder":"e.g. Marketing","shell.orgSwitcher.newWorkspacePrompt":"Name for the new workspace in {org}.","shell.orgSwitcher.noWorkspaces":"No workspaces in this organization.","shell.orgSwitcher.orgFallback":"this organization","shell.orgSwitcher.orgLabel":"Organization","shell.orgSwitcher.switchAria":"Switch organization","shell.orgSwitcher.switchFailed":"Couldn\'t switch to {name}","shell.orgSwitcher.workspaceFallback":"workspace","shell.orgSwitcher.workspaceNotCreated":"Workspace not created","shell.orgSwitcher.workspaces":"Workspaces","shell.pageTitle.admin":"Admin","shell.pageTitle.board":"Board","shell.pageTitle.call":"Call","shell.pageTitle.canvas":"Canvas","shell.pageTitle.epics":"Epics","shell.pageTitle.feed":"Feed","shell.pageTitle.general":"General","shell.pageTitle.inbox":"Inbox","shell.pageTitle.myView":"My view","shell.pageTitle.requests":"Requests","shell.pageTitle.resolutions":"Resolutions","shell.pageTitle.standups":"Standups","shell.pageTitle.stories":"Stories","shell.pageTitle.systemStatus":"System Status","shell.pageTitle.transcript":"Transcript","shell.searchBar.placeholder":"Search on Canvas","shell.shortcuts.group.general":"General","shell.shortcuts.group.goTo":"Go to","shell.shortcuts.row.composer":"Write a prompt","shell.shortcuts.row.escape":"Close, or stop customizing","shell.shortcuts.row.nextWidget":"Next widget","shell.shortcuts.row.openApp":"Open a dashboard app","shell.shortcuts.row.openWidget":"Open the selected widget","shell.shortcuts.row.prevWidget":"Previous widget","shell.shortcuts.row.resizeWidget":"Resize the selected widget","shell.shortcuts.row.sheet":"Keyboard shortcuts","shell.shortcuts.row.widgetAction":"Run the selected widget\u2019s action","shell.shortcuts.then":"then","shell.shortcuts.title":"Keyboard","shell.theme.label":"Theme: {mode}","shell.theme.mode.auto":"auto","shell.theme.mode.dark":"dark","shell.theme.mode.light":"light","shell.viewNav.agents":"Agents","shell.viewNav.workspaceApps":"Workspace apps","shell.viewNav.websites":"Websites","shell.viewNav.groupLabel":"VIEWS","shell.viewNav.infra":"Infra","shell.voice.agent.greeting":"Hi {name}, I\u2019m Simone. How can I help?","shell.voice.agent.greetingNoName":"Hi, I\u2019m Simone. How can I help?","shell.voice.backToTyping":"Back to typing","shell.voice.call.commandTitle":"Voice command","shell.voice.call.controls":"Call controls","shell.voice.call.duration":"Call duration","shell.voice.call.end":"End call","shell.voice.call.endShort":"End","shell.voice.call.listening":"Listening","shell.voice.call.minimize":"Minimize \u2014 the call stays on","shell.voice.call.mute":"Mute","shell.voice.call.muted":"Muted","shell.voice.call.speakNaturally":"Speak naturally \u2014 replies are read aloud.","shell.voice.call.title":"Voice call","shell.voice.call.transcript":"Call transcript","shell.voice.call.type":"Type","shell.voice.call.typeInstead":"Type a message \u2014 the call stays on","shell.voice.engine.voice":"Voice","shell.voice.engine.whyCommand":"Command mode \u2014 one-off: transcribed on the server, answered in the ElevenLabs voice.","shell.voice.engine.whyTalk":"Talk with Simone \u2014 live conversation, spoken in the ElevenLabs voice.","shell.voice.error.agentAllocation":"This workspace used its share of the organization\'s AI credits: a voice call cannot start.","shell.voice.error.agentAllocationEnded":"The voice call ended: this workspace used its share of the organization\'s AI credits.","shell.voice.error.agentBusy":"Too many calls in a short time \u2014 wait a few minutes, then try again.","shell.voice.error.agentCreditsEnded":"The voice call ended: this workspace ran out of AI credits.","shell.voice.error.agentDisconnected":"The ElevenLabs agent disconnected \u2014 retry to reconnect.","shell.voice.error.agentNoCredits":"This workspace does not have enough AI credits for a voice call.","shell.voice.error.agentSpendCap":"This workspace reached its AI spending limit: a voice call cannot start.","shell.voice.error.agentSpendCapEnded":"The voice call ended: this workspace reached its AI spending limit.","shell.voice.error.agentStartFailed":"The voice call could not start \u2014 try again.","shell.voice.error.assistantOffline":"The assistant is offline on this surface \u2014 open it from the workspace shell to talk.","shell.voice.error.micDenied":"Microphone access was denied \u2014 allow it in the address bar and try again.","shell.voice.error.micOpenFailed":"Could not open the microphone.","shell.voice.error.micUnsupported":"Microphone is unavailable in this browser.","shell.voice.error.noSpeech":"Didn\u2019t catch that \u2014 try again.","shell.voice.error.notProvisioned":"Voice backend not provisioned","shell.voice.error.recorderStartFailed":"Could not start the audio recorder.","shell.voice.error.recorderUnsupported":"Audio recording is unavailable in this browser.","shell.voice.error.transcribeFailed":"Transcription failed \u2014 try again.","shell.voice.error.unavailableHere":"Voice is unavailable on this surface.","shell.voice.expand":"Expand","shell.voice.hint.command":"Try \\"zoom to fit\\", \\"create a page called pricing\\", or describe what to build.","shell.voice.hint.talk":"Speak naturally \u2014 replies are read aloud. Esc minimizes the call.","shell.voice.log.assistant":"Assistant","shell.voice.log.done":"Done","shell.voice.log.you":"You","shell.voice.mic.mute":"Mute microphone","shell.voice.mic.unmute":"Unmute microphone","shell.voice.retry":"Try again","shell.voice.status.connecting":"Connecting\u2026","shell.voice.status.done":"Done","shell.voice.status.error":"Something went wrong.","shell.voice.status.listening":"Listening\u2026","shell.voice.status.speaking":"Speaking\u2026","shell.voice.status.thinking":"Thinking\u2026","shell.voice.stopSpeaking":"Stop speaking","shell.app.infra":"Infrastructure","shell.launcher.infra.title":"Infrastructure","shell.launcher.infra.caption":"Services, environments and deployments","shell.overlay.brandHome":"Symbols home","shell.invite.sub":"Send an email invite, or share a link that works once.","shell.invite.subEmail":"Send an email invite at the role you choose.","shell.invite.mode.label":"How to invite","shell.invite.mode.email":"Email","shell.invite.mode.link":"Magic link","shell.invite.link.create":"Create and copy link","shell.invite.link.ends":"Ends {date}","shell.invite.link.singleUse":"Single use","shell.invite.link.empty":"No open links. A link you create shows here.","shell.invite.link.revokeAsk":"Revoke this link?","shell.invite.link.keep":"Keep","shell.invite.link.revokeConfirmLabel":"Confirm: revoke the {role} link that ends {date}","shell.flyWorkspace.section":"Add section","shell.flyWorkspace.remove":"Remove section","shell.flyWorkspace.return":"Return to Fly","shell.flyWorkspace.search":"Search workspace","shell.flyWorkspace.sectionHint":"Add a live widget or a read-only view to this Fly page.","shell.flyWorkspace.added":"Section added","shell.flyWorkspace.emptySections":"This workspace has no available sections. Open a workspace page to use its full tools.","shell.flyWorkspace.error.unavailable":"This item is no longer available. Choose another item.","shell.flyWorkspace.error.limit":"This Fly page has reached its section limit. Remove a section before you add another.","shell.flyWorkspace.error.duplicate":"This section is already on your Fly page.","shell.flyWorkspace.error.navigation":"The page did not open. Try again.","shell.flyWorkspace.error.changed":"The workspace changed. Open the picker again.","shell.flyWorkspace.error.saving":"Wait for this page to save before you add a section.","shell.flyWorkspace.localTitle":"My workspace","shell.phoneNav.apps":"Apps","shell.phoneNav.assistant":"AI","shell.phoneNav.menu":"Menu","shell.phoneNav.pageMenu":"Page menu","shell.phoneNav.account":"Account and appearance","shell.phoneNav.page":"Page","shell.accountMenu.replayOnboarding":"Replay onboarding","shell.phoneNav.appsTitle":"Your apps","shell.phoneNav.appsHint":"Everything you need, one tap away.","shell.phoneNav.menuTitle":"Your workspace","shell.phoneNav.menuHint":"Search, switch spaces, and make it yours.","shell.phoneNav.assistantAction":"Open or close AI assistant","shell.viewNav.switchView":"Switch workspace view","shell.launcher.categories":"App categories","shell.launcher.allApps":"All apps","shell.launcher.workspaceApps.caption":"Apps installed and built for this workspace"}');

});

parcelRegister("79W0z", function(module, exports) {
module.exports = JSON.parse('{"tickets.aiForm.field.assignee":"Assignee","tickets.aiForm.field.body":"Description","tickets.aiForm.field.due":"Due date","tickets.aiForm.field.priority":"Priority","tickets.aiForm.field.status":"Status","tickets.aiForm.field.title":"Title","tickets.aiForm.field.type":"Type","tickets.aiForm.title":"Task","tickets.answer.columnMore":"+{n} more","tickets.answer.due.nextWeek":"Due next week","tickets.answer.due.none":"No due date","tickets.answer.due.overdue":"Overdue","tickets.answer.due.thisWeek":"Due this week","tickets.answer.due.today":"Due today","tickets.answer.empty":"No tasks match.","tickets.answer.failed":"Could not load the tasks.","tickets.answer.more":"The {n} most recently updated \u2014 the rest are in Tasks","tickets.answer.moreOf":"{n} of {total} shown \u2014 the rest are in Tasks","tickets.answer.shownCount":"{n} shown","tickets.answer.title":"Tasks","tickets.answer.untitled":"Untitled task","tickets.approval.approvedAt":"APPROVED \xb7 {time}","tickets.approval.noteLabel":"Approval note","tickets.approval.rejectedAt":"REJECTED \xb7 {time}","tickets.attachTask.description":"Paste the human task id (e.g. TICKET-42). The task\u2019s cycleId will be set; one cycle per task.","tickets.attachTask.field.id":"Task id","tickets.attachTask.field.idPlaceholder":"TICKET-42","tickets.attachTask.title":"Add task to cycle","tickets.audit.hero.eyebrow":"REQUESTS \xb7 AUDIT","tickets.audit.hero.headline":"Audit / Reports","tickets.audit.hero.ledeMany":"{count} audits and reports.","tickets.audit.hero.ledeOne":"{count} audit and report.","tickets.audit.unavailable.body":"Audits and reports will appear here.","tickets.board.card.assignFailedTitle":"Assign failed","tickets.board.card.assignMe":"Assign to me","tickets.board.card.copyFailedTitle":"Copy failed","tickets.board.card.copyLink":"Copy link","tickets.board.card.deleteMessage":"This permanently removes the task.","tickets.board.card.deleteTitle":"Delete \\"{name}\\"?","tickets.board.card.linkCopiedBody":"Task link copied to clipboard","tickets.board.card.linkCopiedTitle":"Link copied","tickets.board.card.taskFallback":"task","tickets.board.create.aria":"New task or column","tickets.board.create.columnHint":"Add a kanban column.","tickets.board.create.columnLabel":"New Column","tickets.board.create.epicsHint":"Create, rename or remove epics.","tickets.board.create.epicsLabel":"Manage epics","tickets.board.create.taskHint":"Create a task on this board.","tickets.board.create.taskLabel":"New Task","tickets.board.filters.show":"Show filters","tickets.board.filters.title":"Filters","tickets.board.help.click":"Click a card to open it.","tickets.board.help.drag":"Drag cards between columns.","tickets.board.moreCount":"More \xb7 {loaded} / {total}","tickets.board.newColumn.failedBody":"Create failed","tickets.board.newColumn.failedTitle":"Column not created","tickets.board.newColumn.message":"Name for the new column.","tickets.board.newColumn.placeholder":"e.g. Blocked","tickets.board.newColumn.title":"New column","tickets.card.epicBadge":"EPIC","tickets.card.parent":"parent","tickets.card.parentTooltip":"Parent: {url}","tickets.cycleEdit.create":"Create cycle","tickets.cycleEdit.description":"Group a set of tasks ahead of a release. Name + optional dates.","tickets.cycleEdit.field.description":"Description (optional)","tickets.cycleEdit.field.descriptionPlaceholder":"What\u2019s the focus of this cycle?","tickets.cycleEdit.field.ends":"Ends","tickets.cycleEdit.field.name":"Name","tickets.cycleEdit.field.namePlaceholder":"e.g. Sprint 42, Q3 release, \u2026","tickets.cycleEdit.field.starts":"Starts","tickets.cycleEdit.nameRequired":"Give the cycle a name.","tickets.cycleEdit.saving":"Saving\u2026","tickets.cycleEdit.titleEdit":"Edit cycle","tickets.cycleEdit.titleNew":"New cycle","tickets.delete.failedMany":"{count} of {total} tasks not deleted","tickets.delete.failedMessage":"The server refused. What was not deleted is back in the list.","tickets.delete.failedOne":"Task not deleted","tickets.deps.kind.blockedBy":"blocked by","tickets.deps.kind.blocks":"blocks","tickets.deps.kind.related":"related","tickets.deps.kind.waitsOnShip":"waits on ship","tickets.detail.action.askAi":"Ask AI about this task","tickets.detail.action.attachFile":"Attach a file","tickets.detail.action.copied":"Copied!","tickets.detail.action.copyUrl":"Copy task URL","tickets.detail.action.createTask":"Create task","tickets.detail.action.delete":"Delete task","tickets.detail.action.dismiss":"Dismiss","tickets.detail.action.edit":"Edit task","tickets.detail.action.openFullView":"Open in full view","tickets.detail.action.saveChanges":"Save changes","tickets.detail.action.sendToAi":"Send to AI","tickets.detail.aiPrompt.placeholder":"Ask AI to fill fields, improve the description, add acceptance criteria\u2026","tickets.detail.aiUpdate.actionAssignee":"Assignee \u2192 {value}","tickets.detail.aiUpdate.actionBody":"New description","tickets.detail.aiUpdate.actionColumn":"Status \u2192 {value}","tickets.detail.aiUpdate.actionPriority":"Priority \u2192 {value}","tickets.detail.aiUpdate.actionTitle":"Title \u2192 \u201C{value}\u201D","tickets.detail.aiUpdate.confirmTitle":"Apply the AI changes to \u201C{name}\u201D?","tickets.detail.aiUpdate.done":"Done.","tickets.detail.aiUpdate.failed":"AI changes not saved","tickets.detail.aiUpdate.failedMessage":"The server refused them. The task keeps its earlier values.","tickets.detail.aiUpdate.notApplied":"Not applied.","tickets.detail.aiUpdate.notSaved":"Not saved. The task keeps its earlier values.","tickets.detail.aiUpdate.nothing":"The AI found nothing to change.","tickets.detail.aiUpdate.proposed":"Suggested changes:","tickets.detail.aiUpdate.requestFailed":"The AI request failed: {error}","tickets.detail.aiUpdate.thinking":"Thinking\u2026","tickets.detail.aiUpdate.unknownError":"unknown error","tickets.detail.aiUpdate.unreadable":"Could not read the AI answer.","tickets.detail.approval.approve":"Approve","tickets.detail.approval.approveFailed":"Approval failed","tickets.detail.approval.approveMessage":"Agents can then start work on it. The note \u201C{note}\u201D goes into the comments.","tickets.detail.approval.approveTitle":"Approve \u201C{name}\u201D?","tickets.detail.approval.approving":"Approving\u2026","tickets.detail.approval.awaiting":"Awaiting your approval","tickets.detail.approval.defaultApproveNote":"Approved.","tickets.detail.approval.defaultRejectNote":"Needs changes.","tickets.detail.approval.notePlaceholder":"Approval note (default: Approved.)","tickets.detail.approval.reject":"Reject","tickets.detail.approval.rejectFailed":"Rejection failed","tickets.detail.approval.rejectMessage":"The task goes back for changes and waits for approval again. The note \u201C{note}\u201D goes into the comments.","tickets.detail.approval.rejectTitle":"Reject \u201C{name}\u201D?","tickets.detail.approval.rejecting":"Rejecting\u2026","tickets.detail.attachment.fileFallback":"file","tickets.detail.attachment.removeFailed":"File not removed","tickets.detail.attachment.removeMessage":"It leaves this task for everyone.","tickets.detail.attachment.removeTitle":"Remove \u201C{name}\u201D?","tickets.detail.attachment.title":"Attachments","tickets.detail.attachment.uploadFailed":"Upload failed","tickets.detail.attachment.uploading":"Uploading\u2026","tickets.detail.autoTest":"Auto-test by QA agent","tickets.detail.comments.loadMore":"Load more comments","tickets.detail.comments.loadingMore":"Loading\u2026","tickets.detail.comments.edited":"edited","tickets.detail.comments.editLabel":"Edit comment","tickets.detail.comments.deleteTitle":"Delete this comment?","tickets.detail.comments.deleteMessage":"The comment is removed from this task for everyone. This can\u2019t be undone.","tickets.detail.comments.deleteFailed":"Couldn\u2019t delete the comment","tickets.detail.comments.editFailed":"Couldn\u2019t save the comment","tickets.detail.comments.writeFailedMessage":"Nothing was changed. Try again.","tickets.detail.composer.commentPh":"Add a comment\u2026","tickets.detail.composer.mailReplyPh":"Write the email reply\u2026","tickets.detail.composer.updatePh":"Describe what changed (AI will summarize)\u2026","tickets.detail.delete.confirmMessage":"This permanently removes the task. This cannot be undone.","tickets.detail.delete.confirmTitle":"Delete \\"{name}\\"?","tickets.detail.deps.blockedBy":"Blocked by","tickets.detail.deps.blocks":"Blocks","tickets.detail.deps.empty":"No matching tasks","tickets.detail.deps.loadError":"Could not load tasks to search.","tickets.detail.deps.remove":"Remove dependency","tickets.detail.deps.retry":"Retry","tickets.detail.deps.searchPlaceholder":"Add \u201CBlocked by\u201D \u2014 search tasks\u2026","tickets.detail.deps.searching":"Searching tasks\u2026","tickets.detail.epic.none":"No epic","tickets.detail.field.acceptance":"Acceptance criteria","tickets.detail.field.acceptancePh":"Checklist of conditions that must be met","tickets.detail.field.assignees":"Assignees","tickets.detail.field.created":"Created","tickets.detail.field.description":"Description","tickets.detail.field.descriptionPh":"Add a description\u2026","tickets.detail.field.epic":"Epic","tickets.detail.field.expected":"Expected result","tickets.detail.field.expectedPh":"What should have happened?","tickets.detail.field.lastUpdated":"Last updated","tickets.detail.field.peoplePlaceholder":"Type a name\u2026","tickets.detail.field.priority":"Priority","tickets.detail.field.reporter":"Reporter","tickets.detail.field.severity":"Severity","tickets.detail.field.status":"Status","tickets.detail.field.steps":"Steps to reproduce","tickets.detail.field.stepsPh":"1. Go to page X\\n2. Click here\\n3. See the error","tickets.detail.field.titlePlaceholder":"Task title","tickets.detail.field.titleRequired":"Task title is required.","tickets.detail.field.type":"Type","tickets.detail.mailReply.accountNotReady":"The shared inbox is not connected yet","tickets.detail.mailReply.confirmMessage":"It goes out by email from {address} to the person who wrote in. A sent email cannot be taken back.","tickets.detail.mailReply.confirmPlain":"It goes out by email to the person who wrote in. A sent email cannot be taken back.","tickets.detail.mailReply.confirmTitle":"Send the reply on \u201C{name}\u201D?","tickets.detail.mailReply.failed":"Reply not sent","tickets.detail.mailReply.hint":"Sends by email from","tickets.detail.mailReply.noAccess":"You cannot answer from this inbox","tickets.detail.mailReply.notDesk":"This inbox is not a service desk","tickets.detail.mailReply.nothingToAnswer":"There is no inbound email to answer","tickets.detail.mailReply.rateLimited":"Sending is rate-limited \u2014 try again soon","tickets.detail.mailReply.sent":"Reply sent by email","tickets.detail.removeItem":"Remove {name}","tickets.detail.resolved":"resolved","tickets.detail.section.aiAssistant":"AI Assistant","tickets.detail.section.dependencies":"Dependencies","tickets.detail.section.otherFields":"OTHER FIELDS","tickets.detail.sendComment":"Send comment","tickets.detail.sessionNotReady":"Session not ready. Wait a moment and try again.","tickets.detail.severity.blocker":"Blocker","tickets.detail.severity.critical":"Critical","tickets.detail.severity.major":"Major","tickets.detail.severity.minor":"Minor","tickets.detail.severity.none":"No severity","tickets.detail.severity.normal":"Normal","tickets.detail.severity.trivial":"Trivial","tickets.detail.status.backlog":"Backlog","tickets.detail.status.done":"Done","tickets.detail.status.todo":"To do","tickets.detail.tab.comment":"Comment","tickets.detail.tab.mailReply":"Reply by email","tickets.detail.tab.update":"Update","tickets.detail.taskFallback":"task","tickets.detail.toast.circularMessage":"That task already depends on this one.","tickets.detail.toast.circularTitle":"Circular dependency","tickets.detail.toast.copyFailedTitle":"Copy failed","tickets.detail.toast.depAttachFallbackMany":"Task saved, but {count} dependencies failed to attach.","tickets.detail.toast.depAttachFallbackOne":"Task saved, but {count} dependency failed to attach.","tickets.detail.toast.depNotAttachedMany":"Could not attach {count} dependencies: {titles}. Add them again from the task.","tickets.detail.toast.depNotAttachedOne":"Could not attach {count} dependency: {titles}. Add it again from the task.","tickets.detail.toast.depNotAttachedTitle":"Task saved \u2014 dependency not attached","tickets.detail.toast.leftBoardMessage":"This ticket no longer matches the board filters, so its card was removed from the board.","tickets.detail.toast.leftBoardTitle":"Saved, but off the board","tickets.detail.toast.movedToStoriesMessage":"User stories and epics are planning items, so this card is no longer on the board. Open Stories to find it.","tickets.detail.toast.movedToStoriesTitle":"Saved as a user story","tickets.detail.toast.notFound":"Task not found in this organization.","tickets.detail.toast.saveFailedMessage":"The task was not updated (the server rejected the change \u2014 an invalid status transition is the usual cause). Your edits were reverted.","tickets.detail.toast.saveFailedTitle":"Couldn\u2019t save changes","tickets.detail.toast.unavailableTitle":"Task unavailable","tickets.detail.toast.wrongOrg":"This task isn\u2019t in your current organization.","tickets.detail.type.bug":"BUG","tickets.detail.type.none":"Type\u2026","tickets.detail.type.task":"TASK","tickets.detail.type.userStory":"USER STORY","tickets.detail.updatedAgo":"updated {time}","tickets.editRequests.hero.eyebrow":"RESOLUTIONS \xb7 EDIT REQUESTS","tickets.editRequests.hero.headline":"Edit Requests","tickets.editRequests.hero.ledeMany":"{count} pull requests{open}.","tickets.editRequests.hero.ledeOne":"{count} pull request{open}.","tickets.editRequests.hero.ledeOpen":" \xb7 {count} open","tickets.editRequests.unavailable.body":"Proposed edits will appear here as pull requests.","tickets.epics.card.bugs":"{done}/{total} bugs","tickets.epics.card.noStories":"no stories yet","tickets.epics.card.stories":"{done}/{total} stories","tickets.epics.card.tasks":"{done}/{total} tasks","tickets.epics.empty":"No epics found.","tickets.epics.hero.eyebrow":"ROADMAP \xb7 PRODUCT EPICS \xb7 12 OF 13","tickets.epics.hero.headline":"Epics","tickets.epics.hero.lede":"{total} product epics \xb7 {active} active \xb7 rolling up {leaves} tasks + bugs. (1 system epic hidden \u2014 simona is an AI-assistant role, not a product category.)","tickets.epics.manage.createFailed":"Failed to create epic \u2014 please try again.","tickets.epics.manage.deleteConfirmMessage":"This permanently removes the epic. This cannot be undone.","tickets.epics.manage.deleteConfirmTitle":"Delete \\"{name}\\"?","tickets.epics.manage.deleteConsequenceMany":"{count} tasks are still tagged \\"{name}\\" \u2014 deleting the epic does NOT remove that label from them; they\'ll keep showing \\"{name}\\" until reassigned. This cannot be undone.","tickets.epics.manage.deleteConsequenceOne":"{count} task is still tagged \\"{name}\\" \u2014 deleting the epic does NOT remove that label from it; it will keep showing \\"{name}\\" until reassigned. This cannot be undone.","tickets.epics.manage.deleteFailed":"Failed to delete \u2014 please try again.","tickets.epics.manage.deleteTooltip":"Delete epic","tickets.epics.manage.description":"Epics are tasks (type: epic) that other tasks reference by name. Renaming or deleting one only changes the epic itself \u2014 tasks already tagged with the old name keep that label until reassigned.","tickets.epics.manage.done":"Done","tickets.epics.manage.duplicate":"\\"{name}\\" already exists.","tickets.epics.manage.empty":"No epics yet. Add one above to start grouping tasks.","tickets.epics.manage.nameRequired":"Name is required.","tickets.epics.manage.newPlaceholder":"New epic name\u2026","tickets.epics.manage.renameFailed":"Failed to rename \u2014 please try again.","tickets.epics.manage.renameTooltip":"Rename epic","tickets.epics.manage.title":"Manage epics","tickets.epics.stat.bugs":"bugs","tickets.epics.stat.epics":"epics","tickets.epics.stat.percentDone":"% done","tickets.epics.stat.stories":"stories","tickets.epics.stat.tasks":"tasks","tickets.features.empty":"No features found.","tickets.feed.activity.empty":"No recent activity yet.","tickets.feed.activity.title":"Recent activity","tickets.feed.hero.eyebrow":"WORKSPACE \xb7 FEED","tickets.feed.hero.headline":"Feed","tickets.feed.hero.lede":"{events} recent activity events \xb7 {standups} recent standups \xb7 digest of logs and standups.","tickets.feed.seeAllFallback":"View all","tickets.feed.standupFallback":"Standup","tickets.feed.standups.empty":"No standup history yet.","tickets.feed.standups.seeAll":"View all standups","tickets.feed.standups.title":"Latest standups","tickets.filter.anyEpic":"Any epic","tickets.filter.anyone":"Anyone","tickets.general.approvals.approve":"Approve","tickets.general.approvals.confirmMessage":"Agents can then start work on it.","tickets.general.approvals.confirmTitle":"Approve \u201C{name}\u201D?","tickets.general.approvals.failed":"Approval failed","tickets.general.approvals.failedMessage":"The server refused it. The task is back in the list.","tickets.general.approvals.glyphTooltip":"Requires human approval before agents can proceed","tickets.general.approvals.hint":"Waiting for human approval before agents can proceed","tickets.general.approvals.title":"Pending approvals","tickets.general.blocked.hint":"Waiting on external dependency or approval before work can resume","tickets.general.blocked.title":"Blocked","tickets.general.blockedBy.chipTitled":"Blocked by: {title}","tickets.general.blockedBy.chipUntitled":"Blocked by task #{id}","tickets.general.blockedBy.label":"blocked by","tickets.general.blockedBy.tooltip":"Blocked by","tickets.general.decisions.glyphTooltip":"Decision task \u2014 awaiting user input","tickets.general.decisions.hint":"ASK-USER tasks awaiting a decision before agents can proceed","tickets.general.decisions.title":"Decisions needed","tickets.general.density.comfortable":"Comfortable","tickets.general.density.comfortableTooltip":"Comfortable view \u2014 standard card padding","tickets.general.density.compact":"Compact","tickets.general.density.compactTooltip":"Compact view \u2014 tighter card padding","tickets.general.density.label":"View","tickets.general.epicChip.clear":"clear","tickets.general.group.allTasks":"All tasks","tickets.general.group.noEpic":"Unassigned to epic","tickets.general.group.noStory":"Unassigned to story","tickets.general.groupBy.assignee":"Assignee","tickets.general.groupBy.epic":"Epic","tickets.general.groupBy.label":"Group by","tickets.general.groupBy.none":"None","tickets.general.groupBy.priority":"Priority","tickets.general.groupBy.state":"State","tickets.general.groupBy.story":"Story","tickets.general.groupBy.tooltip":"Group by {label} (press {index})","tickets.general.hero.eyebrow":"WORKSPACE \xb7 LIVE TRIAGE","tickets.general.hero.failed":"Failed to load triage \u2014 see retry below","tickets.general.hero.headline":"General","tickets.general.hero.lede":"{now} now \xb7 {ongoing} ongoing{blocked} \xb7 {upcoming} upcoming \xb7 {ready} ready-to-test{pending}{decisions} (scope: {scope})","tickets.general.hero.ledeBlocked":"{count} blocked","tickets.general.hero.ledeDecisions":"{count} decisions","tickets.general.hero.ledePending":"{count} pending approval","tickets.general.hero.loading":"Loading triage\u2026","tickets.general.hero.scopeAll":"all","tickets.general.live":"LIVE","tickets.general.liveBadge":"live","tickets.general.loadError.hint":"The request timed out. Check your connection and try again.","tickets.general.loadError.retry":"Retry","tickets.general.loadError.title":"Couldn\u2019t load tasks","tickets.general.pulse.empty":"No agents pulsing in the last 5 minutes","tickets.general.pulse.title":"Agents pulsing now","tickets.general.quickCreate.hint":"Press c to focus","tickets.general.quickCreate.placeholder":"Quick-create task in active bucket\u2026 (press c)","tickets.general.readyToTest.badge":"ready to test","tickets.general.readyToTest.empty":"No tasks ready to test","tickets.general.readyToTest.title":"Ready to test","tickets.general.searchPlaceholder":"Search tasks\u2026","tickets.general.section.now":"Now","tickets.general.section.nowHint":"Agents actively working right now \xb7 live heartbeat < 10m","tickets.general.section.ongoing":"Ongoing","tickets.general.section.ongoingHint":"Picked up but no live heartbeat \xb7 agent paused or between ticks","tickets.general.section.upcoming":"Upcoming","tickets.general.section.upcomingHint":"Assigned but not yet picked up \xb7 ranked by priority","tickets.general.selection.assign":"Assign\u2026","tickets.general.selection.assignAction":"Assign","tickets.general.selection.assignFailed":"{count} of {total} tasks not assigned","tickets.general.selection.assignMessage":"Each selected task gets this assignee.","tickets.general.selection.assignTitleMany":"Assign {count} tasks to {name}?","tickets.general.selection.assignTitleOne":"Assign this task to {name}?","tickets.general.selection.clear":"Clear selection","tickets.general.selection.count":"{count} selected","tickets.general.selection.deleteMessage":"Deleted tasks leave the board for everyone. This cannot be undone.","tickets.general.selection.deleteTitleMany":"Delete {count} tasks?","tickets.general.selection.deleteTitleOne":"Delete this task?","tickets.general.selection.failedMessage":"They stay selected, so you can try again.","tickets.general.selection.move":"Move","tickets.general.selection.moveFailed":"{count} of {total} tasks not moved","tickets.general.selection.moveMessage":"Their status follows the column.","tickets.general.selection.moveTitleMany":"Move {count} tasks to \u201C{column}\u201D?","tickets.general.selection.moveTitleOne":"Move this task to \u201C{column}\u201D?","tickets.general.selection.moveTo":"Move to\u2026","tickets.general.selection.noTargets":"Nothing to choose from yet.","tickets.general.unassigned":"Unassigned","tickets.header.audit":"Audit / Reports","tickets.header.board":"Board","tickets.header.canvas":"Canvas","tickets.header.editRequests":"Edit Requests","tickets.header.epics":"Epics & Stories","tickets.header.feed":"Feed","tickets.header.general":"General","tickets.header.improvements":"Improvement Requests","tickets.header.inbound":"Inbound","tickets.header.myView":"My view","tickets.header.outbound":"Outbound","tickets.header.release":"Release","tickets.header.requests":"Requests","tickets.header.resolutions":"Resolutions","tickets.header.roadmap":"Roadmap","tickets.header.standups":"Standups","tickets.header.tasks":"Tasks","tickets.heatmap.count.kbEditMany":"{count} KB edits","tickets.heatmap.count.kbEditOne":"{count} KB edit","tickets.heatmap.count.meetCallMany":"{count} meet calls","tickets.heatmap.count.meetCallOne":"{count} meet call","tickets.heatmap.count.noteEditMany":"{count} note edits","tickets.heatmap.count.noteEditOne":"{count} note edit","tickets.heatmap.count.pointMany":"{count} pts","tickets.heatmap.count.pointOne":"{count} pt","tickets.heatmap.count.ticketUpdateMany":"{count} task updates","tickets.heatmap.count.ticketUpdateOne":"{count} task update","tickets.heatmap.empty":"No activity recorded for this day.","tickets.heatmap.legendLess":"Less","tickets.heatmap.legendMore":"More","tickets.heatmap.title":"ACTIVITY \xb7 LAST YEAR","tickets.heatmap.tooltip.standup":"\u2726 standup","tickets.heatmap.type.kbEdit":"KB edit","tickets.heatmap.type.meetCall":"meet call","tickets.heatmap.type.noteEdit":"note edit","tickets.heatmap.type.standup":"standup","tickets.heatmap.type.ticketUpdate":"task update","tickets.improvements.hero.eyebrow":"RESOLUTIONS \xb7 IMPROVEMENTS","tickets.improvements.hero.headline":"Improvement Requests","tickets.improvements.hero.ledeMany":"{count} AI-generated pages from Freestyler awaiting review.","tickets.improvements.hero.ledeOne":"{count} AI-generated page from Freestyler awaiting review.","tickets.improvements.unavailable.body":"AI-generated pages from Freestyler will appear here for review.","tickets.inbound.hero.eyebrow":"REQUESTS \xb7 INBOUND","tickets.inbound.hero.headline":"Inbound","tickets.inbound.hero.ledeMany":"{count} incoming requests from customers, partners, and prospects.","tickets.inbound.hero.ledeOne":"{count} incoming request from customers, partners, and prospects.","tickets.inbound.unavailable.body":"Incoming requests from customers, partners, and prospects will appear here.","tickets.kanban.column.review":"Review","tickets.kanban.columnFallback":"Column","tickets.kanban.columnOptions":"Column options","tickets.kanban.draftsColumn":"Drafts","tickets.kanban.empty.hint":"Drag a card here or create one with +","tickets.kanban.empty.title":"No tasks yet","tickets.kanban.menu.hide":"Hide","tickets.kanban.menu.makeShorter":"Make shorter (1 column)","tickets.kanban.menu.makeWider":"Make wider (2 columns)","tickets.kanban.menu.settings":"Settings","tickets.kanban.newInColumn":"New task in this column","tickets.kanban.rename.failedMessage":"The server refused the new name. The column keeps its old one.","tickets.kanban.rename.failedTitle":"Column not renamed","tickets.kanban.rename.message":"New name for this column.","tickets.kanban.rename.title":"Rename column","tickets.logs.empty.hint":"Ship events and task updates will stream here in real time.","tickets.logs.empty.title":"No activity yet","tickets.logs.hero.eyebrow":"WORKSPACE \xb7 ACTIVITY LOG","tickets.logs.hero.headline":"Logs","tickets.logs.hero.lede":"{count} recent events","tickets.main.githubSync":"Refresh from GitHub Projects","tickets.main.lens.agents":"Agents","tickets.main.lens.all":"All","tickets.main.lens.me":"Me","tickets.main.lens.team":"Team","tickets.myView.action.later":"Later","tickets.myView.action.readyToReview":"Ready to Review","tickets.myView.action.startOn":"Start on","tickets.myView.askUserBadge":"ASK USER","tickets.myView.asked.emphasis":"asked you","tickets.myView.asked.lead":"Others ","tickets.myView.countMany":" \xb7 {count} tasks","tickets.myView.countOne":" \xb7 {count} task","tickets.myView.hero.eyebrow":"YOUR WORK \xb7 TODAY","tickets.myView.hero.headline":"Hi {name}.","tickets.myView.hero.headlineNoName":"Hi there.","tickets.myView.hero.ledeEmpty":"No open tasks assigned to you. Nice!","tickets.myView.hero.ledeMany":"You have {count} tasks on your plate.","tickets.myView.hero.ledeOne":"You have {count} task on your plate.","tickets.myView.working.dropHint":"Drag a task here to start working","tickets.myView.working.emphasis":"working on","tickets.myView.working.lead":"Currently ","tickets.outbound.hero.eyebrow":"REQUESTS \xb7 OUTBOUND","tickets.outbound.hero.headline":"Outbound","tickets.outbound.hero.ledeMany":"{count} outreach items \u2014 proposals, follow-ups, and communications.","tickets.outbound.hero.ledeOne":"{count} outreach item \u2014 proposals, follow-ups, and communications.","tickets.outbound.unavailable.body":"Outreach items \u2014 proposals, follow-ups, and communications \u2014 will appear here.","tickets.page.board.title":"Board / Tasks","tickets.page.epics.title":"Features / Tasks","tickets.page.feed.title":"Feed / Tasks","tickets.page.general.title":"General / Tasks","tickets.page.logs.title":"Logs / Tasks","tickets.page.myView.title":"My view / Tasks","tickets.page.release.title":"Release / Tasks","tickets.page.requests.title":"Customer requests / Resolutions","tickets.page.requestsAudit.title":"Audit / Reports / Resolutions","tickets.page.requestsInbound.title":"Inbound / Resolutions","tickets.page.requestsOutbound.title":"Outbound / Resolutions","tickets.page.resolutions.title":"Resolutions","tickets.page.resolutionsEditRequests.title":"Edit requests / Resolutions","tickets.page.resolutionsImprovements.title":"Improvements / Resolutions","tickets.page.roadmap.title":"Roadmap / Tasks","tickets.page.standups.title":"Standups / Tasks","tickets.page.stories.title":"Stories / Tasks","tickets.page.view.title":"Task","tickets.priority.option.none":"No priority","tickets.priority.option.p0":"P0 \xb7 Critical","tickets.priority.option.p1":"P1 \xb7 High","tickets.priority.option.p2":"P2 \xb7 Medium","tickets.priority.option.p3":"P3 \xb7 Low","tickets.release.changelog":"Changelog","tickets.release.hero.eyebrow":"TICKETS \xb7 RELEASE PIPELINE","tickets.release.hero.headline":"Release","tickets.release.hero.lede":"{count} task(s) queued for staging. {matrixNote}","tickets.release.hero.matrixPending":"Version matrix pending.","tickets.release.hero.matrixReady":"Versions sourced from system-status.","tickets.release.history.empty":"No releases on record yet.","tickets.release.history.eyebrow":"HISTORY","tickets.release.history.title":"Past releases","tickets.release.pipeline.description":"Current dev / staging / prod versions per repo. Sourced from the same system-status edge function used by /system-status, so this view always reflects the live release cycle.","tickets.release.pipeline.eyebrow":"PIPELINE \xb7 LIVE VERSIONS","tickets.release.pipeline.loadError":"Couldn\u2019t load live versions. Refresh to try again.","tickets.release.pipeline.repoColumn":"Repo","tickets.release.pipeline.title":"Versions","tickets.release.promote.buttonTooltip":"Open main \u2192 release PRs across workspace, server, sdk via the github-sync App","tickets.release.promote.confirmAction":"Open release PRs","tickets.release.promote.confirmMessage":"Opens \\"{repos}\\" PRs from `main` \u2192 `release` via the github-sync App. {count} task(s) currently queued for staging will ride along once each PR merges. Idempotent \u2014 already-open PRs are reused, not duplicated.","tickets.release.promote.confirmTitle":"Open main \u2192 release PRs across {count} repos?","tickets.release.promote.done":"Release PRs opened","tickets.release.promote.doneMessage":"The links are under the button.","tickets.release.promote.failed":"Release PRs not opened","tickets.release.promote.forbidden":"Only a manager can open release PRs.","tickets.release.promote.notOpenedIn":"Not opened in: {repos}","tickets.release.promote.openedLabel":"Opened PRs","tickets.release.promote.pending":"Opening PRs\u2026","tickets.release.showMoreMany":"Show {count} more","tickets.release.showMoreOne":"Show {count} more","tickets.release.stage1.description":"Tasks merged to main, awaiting QA confirmation on the main\u2192release preview. Opens GitHub compare-PR forms for workspace + server + sdk so you can promote in one click each.","tickets.release.stage1.empty":"Nothing waiting for staging. Mark a task as Ready to Test once its PR merges to main.","tickets.release.stage1.eyebrow":"STAGE 1 \xb7 MAIN \u2192 RELEASE","tickets.release.stage1.queued":"Queued for staging \xb7 {count}","tickets.requests.hero.eyebrow":"REQUESTS","tickets.requests.hero.headline":"Customer Requests","tickets.requests.hero.ledeMany":"{count} requests from customers, partners, and community.","tickets.requests.hero.ledeOne":"{count} request from customers, partners, and community.","tickets.requests.unavailable.body":"Requests from customers, partners, and the community will appear here.","tickets.resolutions.clearFilters":"\xd7 Clear filters","tickets.resolutions.date.today":"Today","tickets.resolutions.date.unknown":"Unknown date","tickets.resolutions.date.yesterday":"Yesterday","tickets.resolutions.dateFilterTooltip":"Show resolutions from this date onwards","tickets.resolutions.group.requests":"REQUESTS","tickets.resolutions.group.resolutions":"RESOLUTIONS","tickets.resolutions.groupBy.agent":"Agent","tickets.resolutions.groupBy.date":"Date","tickets.resolutions.groupBy.label":"GROUP BY","tickets.resolutions.groupBy.story":"Story","tickets.resolutions.hero.eyebrow":"AGENT MEMORY \xb7 RESOLUTIONS","tickets.resolutions.hero.headline":"Resolutions","tickets.resolutions.hero.lede":"{count} agent resolutions \xb7 newest first.","tickets.resolutions.hero.ledeEmpty":"No resolution tasks yet. Agents will populate this as they ship fixes.","tickets.resolutions.hero.ledeFiltered":"{shown} of {total} resolutions \xb7 filtered.","tickets.resolutions.nav.aria":"Resolutions navigation","tickets.resolutions.nav.audit":"Audit / Reports","tickets.resolutions.nav.customerRequests":"Customer requests","tickets.resolutions.nav.editRequests":"Edit requests","tickets.resolutions.nav.improvements":"Improvement requests","tickets.resolutions.nav.inbound":"Inbound","tickets.resolutions.nav.outbound":"Outbound","tickets.resolutions.nav.resolutions":"Resolutions","tickets.resolutions.noLinkedTask":"No linked task","tickets.resolutions.panelFallback":"Resolution","tickets.resolutions.searchPlaceholder":"Search resolutions\u2026","tickets.resolutions.section.filesTouched":"Files Touched","tickets.resolutions.section.fix":"Fix","tickets.resolutions.section.prevention":"Prevention","tickets.resolutions.section.rootCause":"Root Cause","tickets.resolutions.section.summary":"Summary","tickets.roadmap.action.activate":"Activate","tickets.roadmap.action.activateTooltip":"Mark this as the current active cycle","tickets.roadmap.action.addTask":"Add task","tickets.roadmap.action.archive":"Archive cycle","tickets.roadmap.action.board":"Board","tickets.roadmap.action.boardTooltip":"Open this cycle on the board","tickets.roadmap.action.edit":"Edit cycle","tickets.roadmap.action.hideTasks":"Hide tasks","tickets.roadmap.action.release":"Release","tickets.roadmap.action.releaseTooltip":"Open the release pipeline page","tickets.roadmap.action.removeFromCycle":"Remove from cycle","tickets.roadmap.action.showTasks":"Show tasks","tickets.roadmap.activate.confirmMessage":"It becomes the current cycle.","tickets.roadmap.activate.confirmSwitch":"It becomes the current cycle in place of \u201C{current}\u201D.","tickets.roadmap.activate.confirmTitle":"Activate \u201C{name}\u201D?","tickets.roadmap.activate.failed":"Cycle not activated","tickets.roadmap.archive.confirmAction":"Archive","tickets.roadmap.archive.confirmMessage":"Archived cycles hide from the active roadmap but tasks keep their cycleId for history.","tickets.roadmap.archive.confirmTitle":"Archive \\"{name}\\"?","tickets.roadmap.archive.failed":"Cycle not archived","tickets.roadmap.detach.confirmMessage":"The task stays on the board. Only its link to the cycle goes.","tickets.roadmap.detach.confirmTitle":"Remove \u201C{name}\u201D from \u201C{cycle}\u201D?","tickets.roadmap.detach.failed":"Task not removed from the cycle","tickets.roadmap.due":"due {date}","tickets.roadmap.empty":"No tasks attached yet.","tickets.roadmap.emptyManager":"No cycles yet. Press \u201CNew cycle\u201D to make your first planning window.","tickets.roadmap.emptyMember":"No cycles yet. Ask a manager to make one.","tickets.roadmap.from":"from {date}","tickets.roadmap.hero.eyebrow":"TICKETS \xb7 ROADMAP","tickets.roadmap.hero.headline":"Roadmap","tickets.roadmap.hero.ledeActive":"Active cycle \\"{name}\\" \xb7 {pct}% complete ({done}/{total}).","tickets.roadmap.hero.ledeEmpty":"No cycles yet. Managers can create one to start grouping tasks toward a release.","tickets.roadmap.hero.ledeInactive":"{count} cycle(s). No active cycle \u2014 activate one to flag it as current.","tickets.roadmap.stats":"{pct}% \xb7 {done}/{total} tasks","tickets.roadmap.untitled":"Untitled cycle","tickets.roadmap.writeFailedMessage":"The server refused the change. Nothing changed.","tickets.roadmapAnswer.cyclesFailed":"Could not load the cycles.","tickets.roadmapAnswer.empty":"Nothing on the roadmap matches.","tickets.roadmapAnswer.failed":"Could not load the roadmap.","tickets.roadmapAnswer.more":"{n} of {total} shown \u2014 the rest are on the roadmap","tickets.roadmapAnswer.show.all":"Cycles and epics","tickets.roadmapAnswer.show.cycles":"Cycles","tickets.roadmapAnswer.show.epics":"Epics","tickets.roadmapAnswer.status.active":"Active","tickets.roadmapAnswer.status.archived":"Archived","tickets.roadmapAnswer.status.planned":"Planned","tickets.roadmapAnswer.status.released":"Released","tickets.roadmapAnswer.title":"Roadmap","tickets.sidebar.drafts.aria":"Show drafts","tickets.sidebar.drafts.label":"Drafts","tickets.sidebar.group.assignee":"ASSIGNEE","tickets.sidebar.group.drafts":"DRAFTS","tickets.sidebar.group.epic":"EPIC","tickets.sidebar.group.filterType":"FILTER TYPE","tickets.sidebar.group.issuer":"ISSUER","tickets.sidebar.navLabel":"Tasks filters","tickets.sidebar.type.all":"All Types","tickets.sidebar.type.bugs":"Bugs","tickets.sidebar.type.featuresAndStories":"Features & Stories","tickets.sidebar.type.tasks":"Tasks","tickets.standup.action.applied":"Applied","tickets.standup.action.applying":"Applying\u2026","tickets.standup.action.createTicket":"+ New task","tickets.standup.action.moveTicket":"Move","tickets.standup.action.newTaskFallback":"New task","tickets.standup.action.skip":"Skip","tickets.standup.action.skipped":"Skipped","tickets.standup.action.updateTicket":"Update","tickets.standup.actions.allAddressed":"All actions addressed","tickets.standup.actions.pendingMany":"{count} suggested actions \u2014 confirm or skip each:","tickets.standup.actions.pendingOne":"{count} suggested action \u2014 confirm or skip each:","tickets.standup.aiSummary":"AI-generated summary","tickets.standup.analyzing":"Analyzing your update\u2026","tickets.standup.appliedChanges":"Applied changes:","tickets.standup.complete":"Standup complete \u2014 thank you for today\'s update!","tickets.standup.confirmAll":"Confirm All & Save","tickets.standup.inputPlaceholder":"What did you work on today?","tickets.standup.previousLink":"Previous standups \u2192","tickets.standup.quickfill.blocked":"Blocked","tickets.standup.quickfill.blockedText":"Blocked on ","tickets.standup.quickfill.codeReview":"Code review","tickets.standup.quickfill.codeReviewText":"Reviewed PRs and gave feedback. ","tickets.standup.quickfill.done":"{name} \xb7 done","tickets.standup.quickfill.doneText":"Finished {mention}, ready to close. ","tickets.standup.quickfill.meetings":"Meetings","tickets.standup.quickfill.meetingsText":"Attended meetings about ","tickets.standup.quickfill.progress":"{name} \xb7 progress","tickets.standup.quickfill.progressText":"Made progress on {mention}. ","tickets.standup.quickfill.started":"Started: {name}","tickets.standup.quickfill.startedText":"Started working on {mention}. ","tickets.standup.reanalyze":"Re-analyze update","tickets.standup.skipAll":"Skip all","tickets.standup.untitled":"Untitled","tickets.standups.editFailed":"Standup not saved","tickets.standups.editLabel":"Edit your standup update","tickets.standups.empty":"No standup history yet. Submit your first daily update!","tickets.standups.hero.eyebrow":"STANDUPS","tickets.standups.hero.headline":"Daily Standup History","tickets.standups.hero.lede":"Your past standup summaries and action items.","tickets.standups.section.actions":"ACTIONS","tickets.standups.section.aiSummary":"AI SUMMARY","tickets.standups.section.yourUpdate":"YOUR UPDATE","tickets.state.awaitingApproval":"Awaiting Approval","tickets.state.blocked":"Blocked","tickets.state.cancelled":"Cancelled","tickets.state.done":"Done","tickets.state.inProgress":"In Progress","tickets.state.notStarted":"Not Started","tickets.state.readyToReview":"Ready to Review","tickets.state.readyToTest":"Ready to Test","tickets.state.released":"Released","tickets.stories.empty":"No stories found.","tickets.stories.hero.eyebrow":"ROADMAP \xb7 USER STORIES","tickets.stories.hero.headline":"Stories","tickets.stories.hero.lede":"{stories} stories across {epics} epics \xb7 {tasks} tasks + {bugs} bugs.","tickets.story.action.openAsTask":"Open as task","tickets.story.badge":"USER STORY","tickets.story.empty":"No tasks or bugs linked to this story yet.","tickets.story.field.acceptance":"Acceptance criteria","tickets.story.field.bugs":"Bugs","tickets.story.field.description":"Description","tickets.story.field.progress":"Progress","tickets.story.field.tasks":"Tasks","tickets.story.group.bugs":"Bugs","tickets.story.group.doneCount":"{done} of {total} done","tickets.story.group.tasks":"Tasks","tickets.unavailable.lede":"This feature is not available yet.","tickets.view.backToBoard":"Back to tasks","tickets.view.unavailable.title":"Task unavailable","tickets.view.unavailable.failed":"Failed to load task."}');

});

parcelRegister("lJulY", function(module, exports) {
module.exports = JSON.parse('{"workspace.a11y.skipToMain":"Skip to main content","workspace.activation.blockedBody":"{loaded} of {total} apps are ready. {blocked} cannot load in this workspace. Republish the app or remove it \u2014 a retry gives the same result.","workspace.activation.blockedTitle":"Some apps cannot load","workspace.activation.errorBody":"Retry to load what is missing. Your loaded content will be kept.","workspace.activation.errorTitle":"Some workspace content couldn\u2019t load","workspace.activation.partialBody":"{loaded} of {total} apps are ready. Retry to load the rest.","workspace.activation.partialTitle":"Some apps couldn\u2019t load","workspace.activation.retry":"Retry loading","workspace.activation.retrying":"Retrying\u2026","workspace.activation.retryingBody":"Keeping your loaded content while we try again.","workspace.activation.retryingTitle":"Retrying workspace loading","workspace.activation.slowBody":"Apps and saved preferences are still loading. You can use available content or retry.","workspace.activation.slowTitle":"Workspace is still loading","workspace.addApp.apps.yours":"Your apps","workspace.addApp.balance.available":"{count} credits available","workspace.addApp.balance.allowance":"Monthly allowance: {remaining} of {total} left.","workspace.addApp.balance.purchased":"Purchased credits: {count}.","workspace.addApp.crmLeads.toggle":"Send sign-ups to CRM","workspace.addApp.crmLeads.on":"New sign-ups go to your CRM","workspace.addApp.crmLeads.noCrm":"Install the CRM app to receive sign-ups as leads","workspace.addApp.crmLeads.noForm":"This app has no sign-up form","workspace.addApp.crmLeads.saveError":"Could not change the CRM setting. Try again.","workspace.addApp.estimate.free":"Your first build is free.","workspace.addApp.estimate.step":"This first step costs about {count} credits.","workspace.addApp.apps.emptyPrivate":"No private apps yet","workspace.addApp.apps.emptyPrivateLine":"Describe one in the chat. Once you save it, it shows up here.","workspace.addApp.apps.emptyShared":"Nothing shared yet","workspace.addApp.apps.emptySharedLine":"Share an app and everyone in this workspace can use it.","workspace.addApp.chat.newApp":"New app","workspace.addApp.canvas.failedHint":"The build stopped before there was an app to show. The conversation says what went wrong \u2014 ask there to try again.","workspace.addApp.canvas.failedTitle":"This app could not be built","workspace.addApp.canvas.hint":"Your app will appear here as you build. Keep the conversation going to refine it.","workspace.addApp.canvas.title":"Your idea is taking shape","workspace.addApp.catalog.title":"Ready-made apps","workspace.addApp.chat.hint":"What would you like to build?","workspace.addApp.chat.sub":"Turn an idea into an app for your workspace. Describe what you need, and build it together.","workspace.addApp.chat.starter1":"Build a kanban board for my tasks grouped by assignee","workspace.addApp.chat.starter2":"Add a dashboard of this week\u2019s meetings","workspace.addApp.chat.starter3":"Make a directory of everyone on the workspace","workspace.addApp.chat.starter4":"Create a notes board wired to my documents","workspace.addApp.install.add":"Add to Workspace","workspace.addApp.install.added":"Added to workspace","workspace.addApp.install.checking":"Checking workspace...","workspace.addApp.installed.remove":"Remove","workspace.addApp.installed.title":"Installed apps","workspace.addApp.installed.appFallback":"App","workspace.addApp.link.docs":"Build a custom app \u2014 docs","workspace.addApp.link.manage":"Manage installed app","workspace.addApp.link.marketplace":"Browse all in the App Store","workspace.addApp.page.title":"Add app \xb7 Symbols.app","workspace.addApp.removeApp":"Remove app","workspace.addApp.resetNavbar":"Reset navbar","workspace.addApp.save":"Save","workspace.addApp.scope.private":"Private","workspace.addApp.scope.shared":"Shared","workspace.addApp.scope.title":"Visibility","workspace.addApp.share":"Share","workspace.addApp.share.body":"\u201C{name}\u201D will become visible and installable to everyone in this workspace. You can keep it private instead.","workspace.addApp.share.confirm":"Share with everyone","workspace.addApp.share.keepPrivate":"Keep private","workspace.addApp.share.thisExtension":"This app","workspace.addApp.share.title":"Share with the workspace?","workspace.addApp.save.buildFirst":"Build an app first.","workspace.addApp.saveError.cannotCreate":"Cannot create a new app here.","workspace.addApp.saveError.noWorkspace":"No active workspace.","workspace.addApp.saveError.nothingToSave":"Nothing to save \u2014 build an app first.","workspace.addApp.saveError.storeUnavailable":"Saving apps is not available right now.","workspace.addApp.save.failed":"Save failed: {reason}","workspace.addApp.save.nothingHere":"Nothing to save here.","workspace.addApp.save.savedAsApp":"Saved \u201C{name}\u201D as an app.","workspace.addApp.save.savedPrivate":"Saved to your private apps.","workspace.addApp.save.savedShared":"Saved. Everyone in this workspace can still open it.","workspace.addApp.save.openApp":"Open {name}","workspace.addApp.save.sharedAll":"Shared with everyone in this workspace.","workspace.addApp.unbackedNotice":"Preview only \u2014 \u201C{names}\u201D has no data store yet, so records won\u2019t save until one is added.","workspace.addApp.extensionFallback":"Untitled app","workspace.addApp.installOwn":"Install your own","workspace.addApp.installingOwn":"Installing\u2026","workspace.addApp.error.buildFailed":"build failed","workspace.agents.assignedToYou":"{count} agents assigned to you","workspace.agents.assignedToYouOne":"1 agent assigned to you","workspace.agents.available":"Available","workspace.agents.caption":"Agent","workspace.agents.checking":"Checking your agents\u2026","workspace.agents.countInWorkspace":"{count} agents in this workspace","workspace.agents.countInWorkspaceOne":"1 agent in this workspace","workspace.agents.createCaption":"Spin up a new AI agent","workspace.agents.createFirst":"Create your first agent","workspace.agents.createTitle":"Create agent","workspace.agents.fallbackName":"Agent","workspace.agents.loadFailed":"Couldn\'t load your agents","workspace.agents.loadFailedShort":"Couldn\u2019t load agents","workspace.agents.membersLoadFailed":"Couldn\u2019t load members","workspace.agents.none":"No agents yet","workspace.agents.role.admin":"Admin","workspace.agents.role.adminHint":"Full control \u2014 content plus team + assignment management.","workspace.agents.role.editor":"Editor","workspace.agents.role.editorHint":"Can view and create content \u2014 tickets, docs, messages.","workspace.agents.role.guest":"Guest","workspace.agents.role.guestHint":"Read-only \u2014 can view workspace content, never writes.","workspace.agents.scope.wholeWorkspace":"Whole workspace","workspace.agents.untitledProject":"Untitled project","workspace.ai.action.createEvent":"Create Event","workspace.ai.action.createKb":"Create KB Article","workspace.ai.action.createNote":"Create Note","workspace.ai.action.createTicket":"Create Task","workspace.ai.action.moveTicket":"Move Task","workspace.ai.action.updateTicket":"Update Task","workspace.ai.approvalPrompt":"I need your approval before I make this change:","workspace.ai.awaitingApproval":"Awaiting human approval.","workspace.ai.emptyHint":"Ask me about documents, team, calendar, or tickets.","workspace.ai.newRecord.article":"New article","workspace.ai.newRecord.event":"New event","workspace.ai.newRecord.note":"New note","workspace.ai.newRecord.ticket":"New ticket","workspace.ai.newRecord.category":"General","workspace.ai.suggest.approvals":"What is pending approval?","workspace.ai.suggest.documents":"Show me company documents","workspace.ai.suggest.events":"What events are coming up?","workspace.ai.suggest.tasks":"What tasks are open?","workspace.ai.suggest.team":"Who is on the team?","workspace.ai.actionCancelled":"No problem \u2014 I\u2019ve cancelled that. Nothing was changed.","workspace.ai.actionDone":"Done.","workspace.ai.actionFailed":"Action failed.","workspace.ai.actionNotApplied":"That change could not be applied \u2014 nothing was modified.","workspace.ai.noWorkspaceUi":"No workspace UI available.","workspace.ai.nothingToApprove":"Nothing to approve.","workspace.ai.reply.connectionError":"Connection error \u2014 please try again.","workspace.ai.reply.empty":"Sorry, I could not generate a response.","workspace.ai.unknownAction":"Unknown action \\"{action}\\".","workspace.aiDecisions.untitled":"(untitled decision)","workspace.aiDecisions.needed":"{count} decisions needed","workspace.aiDecisions.neededOne":"1 decision needed","workspace.aiStarter.app.whatsNew":"{app}: what is new?","workspace.aiStarter.app.whatsNewPrompt":"{app}: summarize the recent activity and changes.","workspace.aiStarter.apps.installed":"Which apps does {workspace} use?","workspace.aiStarter.apps.installedPrompt":"List the apps installed in this workspace and what each one is for.","workspace.aiStarter.chat.missed":"What did I miss in Chat?","workspace.aiStarter.chat.missedPrompt":"Summarize the unread messages across our chat channels.","workspace.aiStarter.files.recent":"What was added to Files this week?","workspace.aiStarter.files.recentPrompt":"List the files added or changed this week.","workspace.aiStarter.infra.status":"How are our services doing?","workspace.aiStarter.infra.statusPrompt":"Report the status of our infrastructure and any open incidents.","workspace.aiStarter.mail.unread":"Summarize my unread mail","workspace.aiStarter.mail.unreadPrompt":"Summarize my unread mail and point out anything urgent.","workspace.aiStarter.meet.last":"Summarize our last meeting","workspace.aiStarter.meet.lastPrompt":"Summarize our last meeting and its action items.","workspace.aiStarter.notes.recent":"What changed in Notes this week?","workspace.aiStarter.notes.recentPrompt":"Summarize the notes created or changed this week.","workspace.aiStarter.people.who":"Who is on {workspace}?","workspace.aiStarter.people.whoPrompt":"List the members of this workspace and their roles.","workspace.aiSuggest.agent.access":"Review access","workspace.aiSuggest.agent.accessPrompt":"Review this agent\'s capabilities and access.","workspace.aiSuggest.agent.refine":"Refine instructions","workspace.aiSuggest.agent.refinePrompt":"Suggest improvements to this agent\'s instructions.","workspace.aiSuggest.announcement.draftReply":"Draft a reply","workspace.aiSuggest.announcement.draftReplyPrompt":"Help me draft a reply to this announcement.","workspace.aiSuggest.announcement.summarize":"Summarize","workspace.aiSuggest.announcement.summarizePrompt":"Summarize this announcement.","workspace.aiSuggest.calendar.agenda":"Today\'s agenda","workspace.aiSuggest.calendar.agendaPrompt":"Summarize what\'s on my calendar today.","workspace.aiSuggest.calendar.schedule":"Schedule an event","workspace.aiSuggest.calendar.schedulePrompt":"Schedule a new event.","workspace.aiSuggest.chat.catchUp":"Catch me up","workspace.aiSuggest.chat.catchUpPrompt":"Summarize the unread messages in this channel.","workspace.aiSuggest.createAgent.setup":"Suggest a setup","workspace.aiSuggest.createAgent.setupPrompt":"Suggest a name, role, and instructions for this new agent.","workspace.aiSuggest.createMember.who":"Who to invite?","workspace.aiSuggest.createMember.whoPrompt":"Suggest who to invite and with what role.","workspace.aiSuggest.document.grammar":"Fix grammar","workspace.aiSuggest.document.grammarPrompt":"Fix the grammar and spelling in this document.","workspace.aiSuggest.document.improve":"Improve writing","workspace.aiSuggest.document.improvePrompt":"Improve the clarity and flow of this document.","workspace.aiSuggest.document.summarize":"Summarize","workspace.aiSuggest.document.summarizePrompt":"Summarize this document.","workspace.aiSuggest.event.reschedule":"Reschedule","workspace.aiSuggest.event.reschedulePrompt":"Reschedule this event to a new time.","workspace.aiSuggest.event.summarize":"Summarize","workspace.aiSuggest.event.summarizePrompt":"Summarize this event and its details.","workspace.aiSuggest.generic.myPlate":"What\'s on my plate?","workspace.aiSuggest.generic.myPlatePrompt":"List my open tasks, upcoming events and recent mentions.","workspace.aiSuggest.generic.whatCanYouDo":"What can you do here?","workspace.aiSuggest.generic.whatCanYouDoPrompt":"What can you help me with on this page?","workspace.aiSuggest.notes.create":"New note","workspace.aiSuggest.notes.createPrompt":"Create a new note.","workspace.aiSuggest.person.draftMessage":"Draft a message","workspace.aiSuggest.person.draftMessagePrompt":"Help me draft a message to this person.","workspace.aiSuggest.person.summarize":"Summarize","workspace.aiSuggest.person.summarizePrompt":"Summarize this person\'s role and recent activity.","workspace.aiSuggest.record.inviteMember":"Invite member","workspace.aiSuggest.record.newAgent":"New agent","workspace.aiSuggest.record.untitledNote":"Untitled note","workspace.aiSuggest.tasks.blocked":"What\'s blocked?","workspace.aiSuggest.tasks.blockedPrompt":"Which tasks are blocked or overdue?","workspace.aiSuggest.tasks.board":"Summarize the board","workspace.aiSuggest.tasks.boardPrompt":"Summarize the current state of the board.","workspace.aiSuggest.tasks.create":"Create a task","workspace.aiSuggest.tasks.createPrompt":"Create a new task.","workspace.aiSuggest.teamMember.summarize":"Summarize","workspace.aiSuggest.teamMember.summarizePrompt":"Summarize this team member\'s role and work.","workspace.aiSuggest.ticket.reassign":"Reassign","workspace.aiSuggest.ticket.reassignPrompt":"Reassign this ticket to a teammate.","workspace.aiSuggest.ticket.status":"Change status","workspace.aiSuggest.ticket.statusPrompt":"Move this ticket to a different status.","workspace.aiSuggest.ticket.subtasks":"Break into subtasks","workspace.aiSuggest.ticket.subtasksPrompt":"Break this ticket down into subtasks.","workspace.aiSuggest.ticket.summarize":"Summarize","workspace.aiSuggest.ticket.summarizePrompt":"Summarize this ticket and its discussion.","workspace.aiWidget.empty":"Nothing to show yet","workspace.announcements.addReaction":"Add reaction","workspace.announcements.audience":"Audience","workspace.announcements.audienceAria":"News audience","workspace.announcements.clearFilters":"Clear search and topic","workspace.announcements.closeLabel":"Close announcement","workspace.announcements.description":"Write a clear update once, then keep team news and public releases in their own lanes.","workspace.announcements.empty.allTitle":"No announcements yet","workspace.announcements.empty.filteredCopy":"Try a different search or clear the topic filter.","workspace.announcements.empty.filteredTitle":"No matching updates","workspace.announcements.empty.publicTitle":"No public releases yet","workspace.announcements.empty.publisherCopy":"Share a clear update with your audience.","workspace.announcements.empty.readerCopy":"When your team publishes, new updates will appear here.","workspace.announcements.empty.teamTitle":"No team updates yet","workspace.announcements.eyebrow":"Newsroom","workspace.announcements.loadFailed":"Announcements could not be loaded","workspace.announcements.navAria":"Announcements filters","workspace.announcements.page.title":"Announcements","workspace.announcements.scope.all":"All","workspace.announcements.scope.public":"Public","workspace.announcements.scope.team":"Team","workspace.announcements.search":"Search news\u2026","workspace.announcements.searchAria":"Search announcements","workspace.announcements.showMore":"Show more","workspace.announcements.title":"Announcements","workspace.announcements.topics":"Topics","workspace.announcements.tryAgain":"Try again to load the latest updates.","workspace.announcements.updateCount":"{count} updates","workspace.announcements.writeRelease":"Write release","workspace.answer.more":"{n} of {total} shown","workspace.answer.moreOpen":"The first {n} \u2014 the rest are in the app","workspace.apps.addConfirm":"Add to workspace?","workspace.apps.addConfirmBody":"\u201C{app}\u201D becomes available to everyone in this workspace \u2014 shared, with its own tab in the navbar and launcher.","workspace.apps.addCta":"Add to workspace","workspace.apps.addFailed":"Add to workspace failed","workspace.apps.added":"{app} added to the workspace","workspace.apps.addedBody":"Everyone here can open it from the navbar.","workspace.apps.alreadyAdded":"{app} is already in this workspace","workspace.apps.cantAddYet":"Can\u2019t add to the workspace yet","workspace.apps.cantInstallYet":"Can\u2019t install yet","workspace.apps.cantRemoveYet":"Can\u2019t remove the app yet","workspace.apps.cantResetYet":"Can\u2019t reset the navbar yet","workspace.apps.crmLeads.visitorLine":"Your details go to our team so we can contact you.","workspace.apps.installFailed":"Install failed","workspace.apps.installFailedBody":"The server rejected the app reference.","workspace.apps.installed":"{app} installed \u2014 Open","workspace.apps.installedBody":"Its pages and widgets are live for this workspace.","workspace.apps.loadFailed":"App couldn\u2019t load","workspace.apps.opening":"Opening {app}\u2026","workspace.apps.missingRef":"Missing app reference","workspace.apps.missingRefBody":"Owner and key are required.","workspace.apps.navbarReset":"Navbar reset","workspace.apps.noAppInstalled":"No app installed","workspace.apps.noAppSelected":"No app selected","workspace.apps.noWorkspace":"No active workspace","workspace.apps.pageMissing":"Page not available","workspace.apps.pageMissingBody":"\\"{page}\\" isn\u2019t installed in this workspace.","workspace.apps.removeConfirm":"Remove app?","workspace.apps.removeConfirmBody":"This removes {app}\'s pages, widgets and navbar entries from this workspace. Your content stays and reappears if you reinstall.","workspace.apps.removeCta":"Remove app","workspace.apps.removeFailed":"Remove failed","workspace.apps.removed":"{app} removed","workspace.apps.removedBody":"Your content stays and reappears if you reinstall.","workspace.apps.resetFailed":"Reset failed","workspace.apps.resetNavbarConfirm":"Reset navbar?","workspace.apps.resetNavbarConfirmBody":"Restores the default Apps \xb7 Tasks \xb7 Files tabs and drops any customization or app-added entries.","workspace.apps.resetNavbarCta":"Reset navbar","workspace.apps.saveFirst":"Save the app first","workspace.apps.saveFirstBody":"Only saved apps can be added to the workspace.","workspace.apps.serverRejected":"The server rejected the request.","workspace.apps.stillLoading":"Workspace still loading","workspace.apps.stillLoadingBody":"This workspace\u2019s settings haven\u2019t finished loading yet \u2014 try again in a moment.","workspace.apps.nameFallback":"App","workspace.launcher.filterPlaceholder":"Filter apps","workspace.launcher.noMatches":"No matches","workspace.appBlocked.heading":"This app uses a blocked feature","workspace.appBlocked.hint":"For your safety, this app does not run. Ask the AI to rebuild it with the allowed features.","workspace.appBlocked.rebuild":"Ask AI to rebuild","workspace.appBlocked.rebuildPrompt":"Rebuild the app {name} so it uses only the allowed app features. The workspace blocked it for: {reasons}","workspace.assistant.close":"Close assistant","workspace.assistant.dock.left":"Dock left","workspace.assistant.dock.right":"Dock right","workspace.assistant.minimize":"Minimize to a chip above the composer","workspace.assistant.ticketNotice.done":"{ticket} just **shipped**{commit}. [View ticket \u2192]({href})","workspace.assistant.ticketNotice.awaitingApproval":"{ticket} is **awaiting your approval**{commit}. [View ticket \u2192]({href})","workspace.assistant.ticketNotice.started":"{ticket} just **started**{commit}. [View ticket \u2192]({href})","workspace.assistant.ticketNotice.titled":"Your ticket \\"{title}\\"","workspace.assistant.ticketNotice.numbered":"Your ticket #{id}","workspace.assistant.ticketNotice.commit":" (commit `{sha}`)","workspace.assistant.threadFallback":"Thread","workspace.assistant.openInMain":"Open in main","workspace.assistant.resize":"Resize the assistant","workspace.askRoute.toPages":"Making a page for this","workspace.askRoute.toSlides":"Making slides for this","workspace.askRoute.toApp":"Building an app for this","workspace.askRoute.toSite":"Building a website for this","workspace.askRoute.toChat":"Answering in chat","workspace.askRoute.backToChat":"Back to chat","workspace.askRoute.backToPages":"Back to pages","workspace.askRoute.backToHome":"Back to home","workspace.askRoute.pagesUnavailable":"Pages are not available here yet \u2014 I\u2019ll answer in this chat.","workspace.askRoute.slidesUnavailable":"Slides are not available here yet \u2014 I\u2019ll answer in this chat.","workspace.assistantBoard.region":"Generated board","workspace.assistantBoard.micro":"Generated \xb7 {count} widgets \xb7 {when}","workspace.assistantBoard.microOne":"Generated \xb7 1 widget \xb7 {when}","workspace.assistantBoard.microPartial":"Generated \xb7 {shown} of {total} widgets \xb7 {when}","workspace.assistantBoard.microLoading":"Generating","workspace.assistantBoard.building":"Building your board\u2026","workspace.assistantBoard.pinAll":"Pin all","workspace.assistantBoard.pinning":"Pinning\u2026","workspace.assistantBoard.pinnedAll":"Pinned","workspace.assistantBoard.saveAsBoard":"Save as board","workspace.assistantBoard.saving":"Saving\u2026","workspace.assistantBoard.saved":"Saved","workspace.assistantBoard.dismiss":"Dismiss","workspace.assistantBoard.refine":"Refine this board","workspace.assistantBoard.pinItem":"Pin to home: {title}","workspace.assistantBoard.pinnedItem":"Pinned to home: {title}","workspace.assistantBoard.blockFooter":"AI \xb7 from {app} {dataset}","workspace.assistantBoard.blockFooterBare":"AI \xb7 generated","workspace.assistantBoard.emptyItem":"Nothing for {params}","workspace.assistantBoard.empty":"No widget fits this question.","workspace.assistantBoard.noneInstalled":"The widgets for this question are not installed.","workspace.assistantBoard.failed":"The board could not be built.","workspace.assistantBoard.timeout":"Building the board took too long.","workspace.assistantBoard.unavailable":"Generated boards are not available yet.","workspace.assistantBoard.tryAgain":"Try again","workspace.assistantBoard.pinFailed":"The widget could not be pinned.","workspace.assistantBoard.pinDuplicate":"This widget is already on your home.","workspace.assistantBoard.saveFailed":"The board could not be saved.","workspace.assistantBoard.threads":"Recent prompts","workspace.assistantBoard.homeBoard":"Home","workspace.assistantBoard.boards":"Boards","workspace.assistantBoard.shortcutDismiss":"Close the generated board","workspace.assistantBoard.shortcutPin":"Pin the selected widget to home","workspace.assistantBoard.share":"Share","workspace.assistantBoard.sharing":"Sharing\u2026","workspace.assistantBoard.shared":"Link copied","workspace.assistantBoard.linkCopied":"Board link copied","workspace.assistantBoard.linkCopiedHint":"Members of this workspace can open it.","workspace.assistantBoard.period":"Period","workspace.assistantBoard.refresh":"Refresh data","workspace.assistantBoard.renameField":"Board name","workspace.assistantBoard.copyTitle":"{title} (copy)","workspace.assistantBoard.deleteTitle":"Delete \u201C{title}\u201D?","workspace.assistantBoard.deleteMessage":"This permanently removes the board for everyone who can open it. This cannot be undone.","workspace.assistantBoard.renameFailed":"The name could not be saved.","workspace.assistantBoard.duplicateFailed":"The board could not be copied.","workspace.assistantBoard.deleteFailed":"The board could not be deleted.","workspace.assistantDeck.region":"Presentation","workspace.assistantDeck.roleDescription":"slide deck","workspace.assistantDeck.presenterLabel":"Presentation on the full screen","workspace.assistantDeck.micro":"Presentation \xb7 {count} slides \xb7 {when}","workspace.assistantDeck.microLoading":"Building the presentation","workspace.assistantDeck.counter":"{index} of {count}","workspace.assistantDeck.previous":"Previous","workspace.assistantDeck.next":"Next","workspace.assistantDeck.present":"Present","workspace.assistantDeck.exitPresent":"Exit","workspace.assistantDeck.save":"Save presentation","workspace.assistantDeck.saving":"Saving\u2026","workspace.assistantDeck.saved":"Saved","workspace.assistantDeck.dismiss":"Close the presentation","workspace.assistantDeck.notes":"Speaker notes","workspace.assistantDeck.emptySlide":"This slide has no data in this workspace.","workspace.assistantDeck.failed":"The presentation could not be built.","workspace.assistantDeck.timeout":"Building the presentation took too long.","workspace.assistantDeck.unavailable":"Presentations are not available here yet.","workspace.assistantDeck.empty":"No slide could be built from this workspace\'s data.","workspace.assistantDeck.saveFailed":"The presentation could not be saved.","workspace.assistantDeck.shortcutDismiss":"Close the presentation","workspace.assistantDeck.shortcutPrevious":"Previous slide","workspace.assistantDeck.shortcutNext":"Next slide","workspace.assistantFly.region":"Fly","workspace.assistantFly.pageCount":"{n} pages","workspace.assistantFly.new":"New","workspace.assistantFly.close":"Close Fly","workspace.assistantFly.shortcutClose":"Close Fly","workspace.assistantFly.composedBy":"Composed by the AI","workspace.assistantFly.composedByAgent":"Composed by {name}","workspace.assistantFly.justNow":"just now","workspace.assistantFly.minutesAgo":"{n} min ago","workspace.assistantFly.statusCompose":"Composing the page\u2026","workspace.assistantFly.statusData":"Reading the data\u2026","workspace.assistantFly.statusWrite":"Writing\u2026","workspace.assistantFly.failed":"This page could not be made.","workspace.assistantFly.failedTimeout":"That took too long.","workspace.assistantFly.failedEmpty":"No app in this workspace can show this yet.","workspace.assistantFly.failedCredits":"This workspace does not have enough AI credits for this page.","workspace.assistantFly.stopped":"This page was stopped.","workspace.assistantFly.failedModel":"The AI could not draft this page. Try again: a second try usually works.","workspace.assistantFly.failedBusy":"The AI is busy right now. Try again in a minute.","workspace.assistantFly.failedAccess":"You do not have access to some of the data this page needs.","workspace.assistantFly.unavailable":"Fly is not available in this workspace yet.","workspace.assistantFly.retry":"Try again","workspace.assistantFly.again":"Ask again","workspace.assistantFly.share":"Copy link","workspace.assistantFly.save":"Save as board","workspace.assistantFly.saved":"Saved","workspace.assistantFly.savedHint":"The page is with your saved boards.","workspace.assistantFly.openBoard":"Open board","workspace.assistantFly.linkCopied":"Link copied","workspace.assistantFly.linkCopiedHint":"It asks the same question for whoever opens it.","workspace.assistantFly.next":"Ask next","workspace.assistantFly.showPage":"Show page","workspace.assistantFly.fold":"Fold page","workspace.assistantFly.earlier":"Earlier pages ({n})","workspace.assistantFly.fewer":"Show fewer","workspace.assistantFly.sectionCount":"{n} sections","workspace.assistantFly.sectionCountOne":"1 section","workspace.assistantFly.took":"{s} s","workspace.assistantFly.doIt":"Do it","workspace.assistantFly.actionLabel":"The change this request asks for","workspace.assistantFly.askedBy":"asked by {name}","workspace.assistantFly.callHide":"Hide for me","workspace.assistantFly.callLabel":"The call\'s pages","workspace.assistantFly.callStop":"Stop showing for everyone","workspace.assistantFly.callTitle":"{room} \xb7 pages","workspace.assistantFly.callTitleBare":"Call pages","workspace.assistantFly.ui.reading":"Reading {what}\u2026","workspace.assistantFly.ui.empty":"Nothing to show here.","workspace.assistantFly.ui.timeout":"This took too long to read.","workspace.assistantFly.ui.aborted":"This read stopped.","workspace.assistantFly.ui.roleRequired":"Your role cannot see this.","workspace.assistantFly.ui.toolUnavailable":"This cannot be read here.","workspace.assistantFly.ui.notFound":"Nothing matches what this section looked for.","workspace.assistantFly.ui.sourceFailed":"The read this section needed did not come back.","workspace.assistantFly.ui.failed":"This could not be read.","workspace.assistantFly.ui.invalid":"This result cannot be shown here.","workspace.homeView.label":"Home view","workspace.homeView.main":"Main","workspace.homeView.chat":"Chat","workspace.homeView.present":"Present","workspace.homeView.build":"Build","workspace.homeTab.chat.titleLead":"Ask {workspace}","workspace.homeTab.chat.titleRest":"anything, with live data from its apps.","workspace.homeTab.present.titleLead":"Present {workspace}","workspace.homeTab.present.titleRest":"as a live deck.","workspace.homeTab.present.lead":"Each slide holds live cards from its apps. Show it full screen, or save it beside your boards.","workspace.homeTab.present.week":"Present this week\'s highlights","workspace.homeTab.present.attention":"Present what needs attention","workspace.homeTab.present.app":"Present {app}: where we stand","workspace.homeTab.present.kept":"Your decks","workspace.homeTab.present.unsaved":"Not saved","workspace.flyStart.titleLead":"Ask {workspace}","workspace.flyStart.titleRest":"for the page you need.","workspace.flyStart.lead":"Fly composes each page from this workspace\'s apps \u2014 live data, your own access.","workspace.flyStart.tilesLabel":"Start from","workspace.flyStart.more":"+{n} more","workspace.flyStart.ask.overdue":"{app}: what is overdue?","workspace.flyStart.ask.dueToday":"{app}: what is due today?","workspace.flyStart.ask.upcoming":"{app}: what is coming up?","workspace.flyStart.ask.waiting":"{app}: what is waiting on me?","workspace.flyStart.ask.risk":"{app}: what needs attention?","workspace.firstRun.title":"Get started","workspace.firstRun.titleDone":"You\'re all set","workspace.firstRun.lead":"Four ways to start working in {workspace}.","workspace.firstRun.leadFly":"Fly, the Symbols setup assistant, set up {workspace} with you. These steps come next.","workspace.firstRun.leadDone":"{workspace} is up and running.","workspace.firstRun.hide":"Hide these steps","workspace.firstRun.progress":"{n} of {total}","workspace.firstRun.stepDone":"Done","workspace.firstRun.invite.title":"Invite your team","workspace.firstRun.invite.hint":"Work in {workspace} together.","workspace.firstRun.invite.action":"Invite","workspace.firstRun.records.title":"Add your first records","workspace.firstRun.records.hint":"Add what you work on to an app.","workspace.firstRun.records.hintReady":"Your apps are ready \u2014 fill them with your work.","workspace.firstRun.records.action":"Open {app}","workspace.firstRun.records.actionApps":"Open apps","workspace.firstRun.publish.title":"Publish your website","workspace.firstRun.publish.hint":"Make a website and put it online.","workspace.firstRun.publish.hintReady":"Your website project is ready \u2014 publish it.","workspace.firstRun.publish.action":"Open website","workspace.firstRun.publish.actionList":"See websites","workspace.firstRun.ask.title":"Ask your workspace","workspace.firstRun.ask.hint":"Ask what is due, what is new and who is on the team.","workspace.firstRun.ask.action":"Ask","workspace.firstRun.presetLine":"Set up for your work \u2014 start from a preset","workspace.setup.title":"Setting up {workspace}\u2026","workspace.setup.titleNoName":"Getting your workspace ready\u2026","workspace.setup.titleDone":"{workspace} is ready","workspace.setup.titleDoneNoName":"Your workspace is ready","workspace.setup.titleFailed":"The setup of {workspace} stopped","workspace.setup.titleFailedNoName":"The setup stopped","workspace.setup.stepName":"Workspace name","workspace.setup.stepLanguage":"Workspace language","workspace.setup.stepTheme":"Theme","workspace.setup.stepPreset":"Channels and folders","workspace.setup.stepWebsite":"Website","workspace.setup.lineWorking":"Working\u2026","workspace.setup.lineReady":"Ready","workspace.setup.lineFailed":"Could not finish","workspace.setup.needsApps":"Needs other apps first","workspace.setup.refused":"Not allowed in this workspace","workspace.setup.siteCap":"Free plan limit reached","workspace.setup.noApps":"No app could install","workspace.setup.failedStart":"The setup could not start.","workspace.setup.threadFailed":"The first thread could not be made.","workspace.setup.creditsFree":"Your first build is free.","workspace.setup.credits":"{count} credits left","workspace.setup.creditsOne":"{count} credit left","workspace.setup.back":"Back to {site}","workspace.setup.buildAfter":"Your first build starts when the setup is done.","workspace.setup.buildStarting":"Starting your first build\u2026","workspace.setup.buildAsk":"Your idea is ready to build.","workspace.setup.buildAction":"Build","workspace.setup.buildCredits":"This workspace has no credits. Get credits to start the build.","workspace.setup.buildCreditsMember":"This workspace has no credits. Ask an admin to add credits.","workspace.setup.claim":"Get credits","workspace.setup.buildFromPlan":"Build the first app for my company, {company}: {tagline}","workspace.setup.buildFromName":"Build the first app for my company, {company}.","workspace.setup.buildPlain":"Build the first app for my workspace.","workspace.setup.planTitle":"Your plan","workspace.setup.planTeam":"Team of {count}","workspace.setup.planTeamOne":"Just you","workspace.setup.planApps":"Apps","workspace.setup.planSite":"Website: {site}","workspace.setup.planIdea":"Your idea","workspace.assistantThread.region":"Assistant thread","workspace.assistantThread.openInSidebar":"Open in sidebar","workspace.assistantThread.close":"Back to home","workspace.assistantThread.closeToPage":"Back to the page","workspace.assistantThread.emptyHint":"Ask anything below \u2014 the answer shows here.","workspace.assistantThread.modeAssistant":"Assistant","workspace.assistantThread.modeDashboard":"Dashboard","workspace.assistantThread.modeApps":"Apps","workspace.assistantThread.modeTools":"Tools","workspace.assistantThread.modePresentation":"Presentation","workspace.assistantThread.micro":"{mode} \xb7 {count} questions","workspace.assistantThread.microOne":"{mode} \xb7 1 question","workspace.assistantThread.shortcutClose":"Close the assistant thread","workspace.assistantRecords.periodToday":"Today","workspace.assistantRecords.periodThisWeek":"This week","workspace.assistantRecords.periodThisMonth":"This month","workspace.assistantRecords.periodThisQuarter":"This quarter","workspace.assistantRecords.periodLastQuarter":"Last quarter","workspace.assistantRecords.periodThisYear":"This year","workspace.assistantRecords.total":"{count} records","workspace.assistantRecords.totalOne":"1 record","workspace.assistantRecords.shown":"{n} of {total} shown","workspace.assistantRecords.empty":"No records: {title}","workspace.assistantRecords.unavailable":"Record answers are not available yet.","workspace.assistantRecords.denied":"You cannot read these records.","workspace.assistantRecords.failed":"The records could not be read.","workspace.assistantRecords.openRow":"Open {title}","workspace.assistantRecords.other":"Other","workspace.assistantRecords.yes":"Yes","workspace.assistantRecords.no":"No","workspace.assistantRecords.deltaVsPrevious":"{delta} vs the previous period","workspace.assistantRecords.sortedPerCurrency":"Sorted within each currency","workspace.assistantRecords.emptyWithoutFilter":"{count} match without the {field} filter","workspace.assistantRecords.emptyOutsidePeriod":"{count} match outside this period","workspace.assistantRecords.snapped":"Read \u201C{from}\u201D as \u201C{to}\u201D","workspace.assistantRecords.drillOpen":"Show the {value} records","workspace.assistantRecords.drillFilter":"{field}: {value} \xb7 from {source}","workspace.assistantRecords.drillClose":"Close {title}","workspace.assistantBlock.openInSplit":"Open in split","workspace.assistantBlock.saveAsApp":"Save as app","workspace.assistantBlock.refine":"Refine","workspace.assistantBlock.refinePrefix":"Refine \u201C{title}\u201D: ","workspace.assistantBlock.sourceView":"Answer view","workspace.assistantBlock.sourceRecords":"From {app} \xb7 {collection}","workspace.assistantBlock.sourceBoard":"Board \xb7 {count} widgets","workspace.assistantBlock.sourceWidget":"From {app} \xb7 widget","workspace.assistantBlock.widgetGone":"This widget is not installed in this workspace.","workspace.assistantBlock.widgetFailed":"This widget\'s app did not load in this workspace.","workspace.assistantBlock.viewDenied":"You do not have access to this view.","workspace.assistantBlock.viewFailed":"This view could not load here.","workspace.assistantBlock.formReview":"Review and save","workspace.assistantBlock.formReopen":"Open the form again","workspace.assistantBlock.formHint":"Nothing changes until you save it in the form.","workspace.assistantBlock.formSaved":"Saved.","workspace.assistantBlock.formDenied":"You cannot make this change in this workspace.","workspace.assistantBlock.formGone":"This form is not available in this workspace.","workspace.assistantBlock.sourceForm":"From {app} \xb7 form","workspace.assistantBlock.sourceAppView":"From {app}","workspace.assistantBlock.sourcesTitle":"Sources","workspace.assistantBlock.sourcesQuery":"Web results: {query}","workspace.assistantBlock.sourcesPage":"From {domain}","workspace.assistantBlock.sourcesFoot":"From the web \xb7 {count} sources","workspace.assistantBlock.sourcesFootOne":"From the web \xb7 1 source","workspace.assistantBlock.viewGone":"This view is no longer on this page. Ask again to draw it.","workspace.assistantPopover.close":"Dismiss the answer notice","workspace.history.title":"Workspace History","workspace.history.rail.aria":"History filters","workspace.history.rail.people":"People","workspace.history.rail.everyone":"Everyone","workspace.history.rail.activity":"Activity","workspace.history.rail.allTypes":"All activity","workspace.history.stage.aria":"Activity timeline \u2014 the arrow keys move between days","workspace.history.step.newer":"Newer days","workspace.history.step.older":"Older days","workspace.history.count.events":"{count} events","workspace.history.count.eventsOne":"1 event","workspace.history.count.people":"{count} people","workspace.history.count.peopleOne":"1 person","workspace.history.count.days":"{count} days","workspace.history.count.daysOne":"1 day","workspace.history.group.stats":"{count} events \xb7 {score} pts","workspace.history.group.statsOne":"1 event \xb7 {score} pts","workspace.history.group.more":"Show all {count}","workspace.history.group.less":"Show less","workspace.history.type.standup":"Standup","workspace.history.type.ticketUpdate":"Task update","workspace.history.type.noteEdit":"Note edit","workspace.history.type.kbEdit":"KB edit","workspace.history.type.meetCall":"Meet call","workspace.history.state.loading":"Loading the activity log\u2026","workspace.history.state.error":"The activity log could not be read.","workspace.history.state.empty":"No activity yet. Events appear here as people work in this workspace.","workspace.history.state.emptyFiltered":"Nothing matches this filter.","workspace.broadcast.empty":"Share an announcement, poll, or update with the whole workspace.","workspace.broadcast.readTime":"{count} min read","workspace.broadcastStudio.audience.external":"External","workspace.broadcastStudio.audience.workspace":"Workspace","workspace.broadcastStudio.card.deleteAria":"Delete update","workspace.broadcastStudio.card.edit":"Edit","workspace.broadcastStudio.card.moreAria":"More update actions","workspace.broadcastStudio.card.openExternal":"Open external release \u2192","workspace.broadcastStudio.composer.audienceAria":"Release audience","workspace.broadcastStudio.composer.caption":"Choose the audience first. The publishing queue stays focused from there.","workspace.broadcastStudio.composer.closeAria":"Close release editor","workspace.broadcastStudio.composer.externalHint":"External releases can link to a public destination.","workspace.broadcastStudio.composer.publish":"Publish update","workspace.broadcastStudio.composer.publishing":"Publishing\u2026","workspace.broadcastStudio.publish.titleWorkspace":"Publish \u201C{title}\u201D to the workspace?","workspace.broadcastStudio.publish.titleExternal":"Publish \u201C{title}\u201D as an external release?","workspace.broadcastStudio.composer.saveChanges":"Save changes","workspace.broadcastStudio.composer.titleEdit":"Edit release","workspace.broadcastStudio.composer.titleNew":"Write a release","workspace.broadcastStudio.composer.workspaceHint":"Workspace updates are visible to your team.","workspace.broadcastStudio.delete.confirm":"Delete update","workspace.broadcastStudio.delete.message":"This removes the announcement for everyone in the workspace.","workspace.broadcastStudio.delete.title":"Delete this update?","workspace.broadcastStudio.field.destination":"PUBLIC DESTINATION","workspace.broadcastStudio.field.headline":"HEADLINE","workspace.broadcastStudio.field.headlinePlaceholder":"What should people know?","workspace.broadcastStudio.field.summary":"SUMMARY","workspace.broadcastStudio.field.summaryPlaceholder":"One clear sentence for the feed\u2026","workspace.broadcastStudio.field.topic":"TOPIC","workspace.broadcastStudio.field.topicPlaceholder":"News","workspace.broadcastStudio.field.update":"UPDATE","workspace.broadcastStudio.field.updatePlaceholder":"Write the update. Separate paragraphs with a blank line\u2026","workspace.broadcastStudio.preview.audienceExternal":"External release","workspace.broadcastStudio.preview.audienceWorkspace":"Workspace update","workspace.broadcastStudio.preview.tagDefault":"News","workspace.broadcastStudio.preview.untitled":"Untitled update","workspace.broadcastStudio.tag.all":"All news","workspace.broadcastStudio.authorFallback":"Workspace","workspace.broadcastStudio.error.badUrl":"Use a valid external URL, or leave it blank.","workspace.broadcastStudio.error.deleteFailed":"Update could not be deleted.","workspace.broadcastStudio.error.noBody":"Write the update before publishing.","workspace.broadcastStudio.error.noId":"The saved announcement did not include an id.","workspace.broadcastStudio.error.noTitle":"Add a clear headline before publishing.","workspace.broadcastStudio.error.publishFailed":"The update could not be published. Try again.","workspace.broadcastStudio.error.reactionFailed":"Reaction could not be saved.","workspace.broadcastStudio.reactionYou":"You","workspace.callInvite.aria":"Call invitation","workspace.callInvite.dismiss":"Dismiss","workspace.callInvite.dismissAria":"Dismiss call invitation","workspace.callInvite.eyebrow":"Call invitation","workspace.callInvite.join":"Join call","workspace.callInvite.startingNow":"Starting now","workspace.callInvite.startsIn":"Starts in {count} min","workspace.callInvite.untitled":"Meeting","workspace.callPanel.action.accept":"Accept","workspace.callPanel.action.decline":"Decline","workspace.callPanel.action.dismiss":"Dismiss","workspace.callPanel.action.hangUp":"Hang up","workspace.callPanel.action.hold":"Hold","workspace.callPanel.action.keypad":"Keypad","workspace.callPanel.action.mute":"Mute","workspace.callPanel.aria":"Call","workspace.callPanel.calling":"Calling","workspace.callPanel.confirm.decline":"Decline this call?","workspace.callPanel.confirm.end":"End this call?","workspace.callPanel.confirm.keep":"Keep","workspace.callPanel.confirm.yes":"End call","workspace.callPanel.duration":"Duration {duration}","workspace.callPanel.ended.busy":"Line busy","workspace.callPanel.ended.canceled":"Call canceled","workspace.callPanel.ended.completed":"Call ended","workspace.callPanel.ended.failed":"Call failed","workspace.callPanel.ended.missed":"Missed call","workspace.callPanel.ended.noAnswer":"No answer","workspace.callPanel.error.accept":"The call could not be answered","workspace.callPanel.error.hangUp":"The call could not be ended. Try again","workspace.callPanel.error.hold":"The call could not be put on hold","workspace.callPanel.error.microphone":"Allow the microphone to make calls from the workspace","workspace.callPanel.error.start":"The call did not start","workspace.callPanel.error.callError":"The call had a problem. Try again","workspace.callPanel.error.device":"Calling from this browser is not available now","workspace.callPanel.error.notConnected":"The call could not connect","workspace.callPanel.error.role":"Only a workspace owner, admin or member can answer and make calls","workspace.callPanel.incoming":"Incoming call","workspace.callPanel.keypad":"Dial pad","workspace.callPanel.onCall":"On call","workspace.callPanel.onHold":"On hold","workspace.callPanel.ringing":"Ringing","workspace.callPanel.unknownCaller":"Unknown number","workspace.caption.activeNow":"active now","workspace.caption.aiAgents":"AI agents","workspace.caption.delegated":"delegated","workspace.caption.next7Days":"next 7 days","workspace.caption.notes":"notes","workspace.caption.openTasks":"open tasks","workspace.caption.openTickets":"open tickets","workspace.caption.teamMembers":"team members","workspace.caption.timeZones":"time zones","workspace.caption.today":"today","workspace.caption.unread":"unread","workspace.caption.urgentOrHigh":"urgent or high","workspace.catalog.activity":"Your activity","workspace.catalog.agents":"Team & agents","workspace.catalog.analytics":"Active right now","workspace.catalog.appAgents":"Agents","workspace.catalog.appAnalytics":"Analytics","workspace.catalog.appBroadcast":"Broadcast","workspace.catalog.appCalendar":"Calendar","workspace.catalog.appChat":"Chat","workspace.catalog.appDocuments":"Notes","workspace.catalog.appHealth":"System Health","workspace.catalog.appInfra":"Infrastructure","workspace.catalog.appMeet":"Meet","workspace.catalog.appPeople":"People","workspace.catalog.appReminders":"Reminders","workspace.catalog.appStudio":"Apps","workspace.catalog.appTeam":"Team","workspace.catalog.appTickets":"Tasks","workspace.catalog.assets":"Notes","workspace.catalog.broadcast":"Broadcast","workspace.catalog.events":"Coming up","workspace.catalog.given":"Given tasks","workspace.catalog.greeting":"Greeting","workspace.catalog.mailInbox":"Inbox","workspace.catalog.nextUp":"Next up","workspace.catalog.prioritymix":"Priority mix","workspace.catalog.projects":"Projects","workspace.catalog.received":"Received tasks","workspace.catalog.teampulse":"Team pulse","workspace.catalog.teamtime":"Team timezones","workspace.catalog.workload":"Workload","workspace.catalog.youragents":"Your agents","workspace.catalogCard.active":"Active","workspace.catalogCard.details":"Details","workspace.catalogCard.install":"Install","workspace.catalogCard.installing":"Installing\u2026","workspace.company.page.eyebrow":"About","workspace.company.page.heading":"Company","workspace.company.page.title":"Company","workspace.company.res.figma":"Figma UI Library","workspace.company.res.github":"GitHub Organization","workspace.company.res.landing":"Landing Page","workspace.company.res.npm":"npm Packages","workspace.company.res.pitchDeck":"Pitch Deck","workspace.company.res.platformDocs":"Platform Docs","workspace.company.res.sdkDocs":"SDK Docs","workspace.company.section.address":"Address","workspace.company.section.overview":"Overview","workspace.company.section.registration":"Registration","workspace.company.section.resources":"Resources","workspace.createAgent.access":"Access","workspace.createAgent.cancel":"Cancel","workspace.createAgent.failed":"Failed to create agent","workspace.createAgent.name":"Name","workspace.createAgent.namePlaceholder":"e.g. Atlas","workspace.createAgent.role":"Role (optional)","workspace.createAgent.rolePlaceholder":"e.g. Research assistant","workspace.createAgent.runsIn":"Runs in","workspace.createAgent.runsInProjectHint":"The agent only sees and acts inside this project.","workspace.createAgent.runsInWorkspaceHint":"The agent operates across the whole workspace.","workspace.createAgent.submit":"Create agent","workspace.createAgent.submitting":"Creating\u2026","workspace.createAgent.subtitle":"Name your agent, choose what it may do and where it runs. It joins your Team & agents canvas, assigned to you.","workspace.createAgent.title":"Create agent","workspace.createAgent.unavailable":"Agent creation is rolling out \u2014 the create API isn\u2019t available on this build yet.","workspace.createMember.cancel":"Cancel","workspace.createMember.email":"Email","workspace.createMember.emailPlaceholder":"e.g. teammate@company.com","workspace.createMember.inviteFailed":"Invite failed","workspace.createMember.noOrg":"No active organization to invite into.","workspace.createMember.role":"Role","workspace.createMember.roleAdmin":"Admin","workspace.createMember.roleMember":"Member","workspace.createMember.sent":"Invite sent","workspace.createMember.sentBody":"Invited {email} to the team.","workspace.createMember.submit":"Send invite","workspace.createMember.submitting":"Inviting\u2026","workspace.createMember.subtitle":"Send an invite by email. They join your organization and show up on the Team & agents canvas.","workspace.createMember.title":"Invite team member","workspace.createOrg.cancel":"Cancel","workspace.createOrg.nameLabel":"Workspace name","workspace.createOrg.namePlaceholder":"Acme","workspace.createOrg.slugAdjusted":"Slug auto-adjusted to \\"{suggestion}\\" \u2014 available and ready.","workspace.createOrg.slugAria":"Workspace URL slug","workspace.createOrg.slugTaken":"This slug is taken. Edit it above.","workspace.createOrg.slugTakenEdit":"\\"{slug}\\" is taken. Edit the slug above to pick a different one.","workspace.createOrg.slugTakenTry":"\\"{slug}\\" was just taken \u2014 try \\"{suggestion}\\" instead.","workspace.createOrg.submit":"Create workspace","workspace.createOrg.submitting":"Creating\u2026","workspace.createOrg.subtitle":"A workspace is your team\u2019s shared space \u2014 invite teammates and add projects right after.","workspace.createOrg.title":"Create team\'s workspace","workspace.createOrg.urlLabel":"Workspace URL","workspace.createOrg.usePersonal":"Use personal workspace","workspace.createOrg.errorFailed":"Failed to create workspace","workspace.createOrg.errorRequired":"Name and slug are required","workspace.createOrg.errorSlugTaken":"Slug \\"{slug}\\" was just taken.","workspace.createOrg.slugStatusAdjusted":"auto-adjusted","workspace.createOrg.slugStatusAvailable":"available","workspace.createOrg.slugStatusChecking":"checking\u2026","workspace.createOrg.slugStatusTaken":"taken","workspace.createOrg.useSlug":"Use \\"{slug}\\"","workspace.creditBanner.addCredits":"Add credits","workspace.creditBanner.askAdmin":"Ask an admin","workspace.creditBanner.askAdminTitle":"Tell your workspace admins you need credits","workspace.creditBanner.asked":"Admins told","workspace.creditBanner.critical":"Credits almost gone \u2014 {count} left","workspace.creditBanner.dismissAria":"Dismiss credit warning","workspace.creditBanner.dismissTitle":"Dismiss until it escalates","workspace.creditBanner.exhausted":"Out of credits \u2014 metered actions paused","workspace.creditBanner.low":"Credits running low \u2014 {count} left","workspace.creditBanner.short":"Your last AI request needs about {needed} credits \u2014 this workspace has {available}","workspace.creditBanner.topUp":"Top up","workspace.creditBanner.topUpTitle":"Open the credit usage page","workspace.creditBlocker.aria":"Workspace is out of credits","workspace.creditBlocker.askAdmin":"Ask a workspace admin to top up \u2014 they will see it under Credits.","workspace.creditBlocker.body":"AI, builds and metered actions are paused \u2014 everything else stays readable. The monthly grant resets on your billing date, or top up now and keep going.","workspace.creditBlocker.dismissAria":"Dismiss","workspace.creditBlocker.dismissTitle":"Dismiss (Esc)","workspace.creditBlocker.eyebrow":"Workspace credits","workspace.creditBlocker.grantNote":"monthly grant \xb7 {count} credits","workspace.creditBlocker.grantNoteOne":"monthly grant \xb7 1 credit","workspace.creditBlocker.headline":"out of credits","workspace.creditBlocker.lead":"{name} is ","workspace.creditBlocker.thisWorkspace":"This workspace","workspace.creditBlocker.topUp":"Top up credits","workspace.credits.allocation.message":"This workspace used its share of the org credit pool \u2014 raise its allocation under Usage & billing.","workspace.credits.allocation.title":"Workspace allocation exhausted","workspace.credits.ask.body":"{name} asked for AI credits in {workspace}: the last AI request needs about {needed} and the workspace has {available}.","workspace.credits.ask.failedMessage":"Ask a workspace admin to add credits.","workspace.credits.ask.failedTitle":"Could not send the request","workspace.credits.ask.sentMessage":"Your workspace admins will see it in their notifications.","workspace.credits.ask.sentTitle":"Request sent","workspace.credits.ask.title":"AI credits requested","workspace.credits.ask.whoMessage":"Ask {names} to add credits.","workspace.credits.blocked.message":"AI calls are paused until you top up or upgrade under Usage & billing.","workspace.credits.blocked.title":"Workspace is out of credits","workspace.credits.chat.addLink":"Add credits","workspace.credits.chat.allocation":"This workspace used its share of the organization\'s AI credits.","workspace.credits.chat.balanceAdmin":"{link} to keep going.","workspace.credits.chat.balanceMember":"Ask a workspace admin to add credits.","workspace.credits.chat.limitAdmin":"{link}, or wait for it to reset next billing cycle.","workspace.credits.chat.limitLink":"Raise the limit","workspace.credits.chat.limitMember":"Ask a workspace admin to raise the limit.","workspace.credits.chat.notEnough":"This workspace does not have enough AI credits for that.","workspace.credits.chat.short":"This needs about {needed} AI credits and the workspace has {available}.","workspace.credits.chat.spendCap":"This workspace reached its AI spending limit.","workspace.credits.critical.message":"{workspace} has {count} credits left.","workspace.credits.critical.title":"Credits almost gone","workspace.credits.exhausted.message":"{workspace} has 0 credits left \u2014 AI and metered actions are paused until a top-up.","workspace.credits.exhausted.title":"Workspace is out of credits","workspace.credits.low.message":"{workspace} has {count} credits left this month.","workspace.credits.low.title":"Credits running low","workspace.credits.member.message":"Contact your workspace administrator to top up or upgrade.","workspace.credits.member.title":"This workspace is out of AI credits","workspace.credits.spendCap.message":"Raise the cap under Usage & billing, or it resets next billing cycle.","workspace.credits.spendCap.title":"Workspace hit its spend cap","workspace.credits.thisWorkspace":"This workspace","workspace.ctxMenu.broadcast.delete":"Delete update\u2026","workspace.ctxMenu.broadcast.edit":"Edit update\u2026","workspace.ctxMenu.broadcast.open":"Open update","workspace.ctxMenu.reminder.delete":"Delete reminder\u2026","workspace.ctxMenu.reminder.deleteBody":"This reminder will be removed from your list.","workspace.ctxMenu.reminder.deleteConfirm":"Delete this reminder?","workspace.ctxMenu.reminder.deleteCta":"Delete reminder","workspace.ctxMenu.reminder.markDone":"Mark as done","workspace.ctxMenu.reminder.markOpen":"Mark as open","workspace.ctxMenu.reminder.toEvent":"Create calendar event\u2026","workspace.ctxMenu.reminder.toTicket":"Convert to ticket\u2026","workspace.ctxMenu.reminder.toTicketBody":"A ticket will be created and this reminder will be removed.","workspace.ctxMenu.reminder.toTicketConfirm":"Convert this reminder to a ticket?","workspace.ctxMenu.reminder.toTicketCta":"Convert to ticket","workspace.ctxMenu.system.copied":"Status summary copied","workspace.ctxMenu.system.copyFailed":"Could not copy status summary","workspace.ctxMenu.system.copyFailedBody":"Select the status details manually and try again.","workspace.ctxMenu.system.copySummary":"Copy status summary","workspace.ctxMenu.system.refresh":"Refresh checks","workspace.ctxMenu.system.summary":"System Health: {details}","workspace.ctxMenu.system.summaryEmpty":"no status data yet","workspace.customize.close":"Close customize drawer","workspace.customize.hidden":"Hidden widgets","workspace.customize.hintNoneHidden":"Click \xd7 on any card to hide it. Hidden widgets reappear here \u2014 click to bring them back.","workspace.customize.hintSomeHidden":"Click any widget below to restore it.","workspace.customize.reset":"Reset layout to defaults","workspace.customize.resetConfirmMessage":"Every widget returns to its default size, position and visibility. Any custom arrangement you made is lost.","workspace.customize.resetConfirmTitle":"Reset layout to defaults?","workspace.customize.resetFailed":"Couldn\'t reset your layout","workspace.customize.resetFailedMessage":"Your dashboard could not be reset \u2014 the change was not saved. Nothing has been changed on the server. Please try again.","workspace.customize.showPanel":"Show customize panel","workspace.customize.slideAway":"Slide customize panel away","workspace.customize.title":"Customize dashboard","workspace.notificationsAnswer.empty":"No notifications.","workspace.notificationsAnswer.failed":"Could not load the notifications.","workspace.notificationsAnswer.group.earlier":"Earlier","workspace.notificationsAnswer.group.unread":"Unread \xb7 {count}","workspace.notificationsAnswer.noUnread":"No unread notifications.","workspace.notificationsAnswer.show.all":"All","workspace.notificationsAnswer.show.unread":"Unread","workspace.notificationsAnswer.show.workspace":"This workspace","workspace.notificationsAnswer.title":"Notifications","workspace.notificationsAnswer.untitled":"Notification","workspace.personalize.appStrip":"App strip","workspace.personalize.navbarIcons":"Navbar icons","workspace.personalize.showStrip":"Show the app strip","workspace.personalize.skyLayout":"Sky layout","workspace.personalize.skyLayoutBottom":"Clouds below","workspace.personalize.skyLayoutTop":"Sky and mountains","workspace.personalize.style":"Style","workspace.personalize.styleDock":"Dock","workspace.personalize.styleRail":"Rail","workspace.personalize.showLabels":"Show app names","workspace.personalize.appsHint":"Drag an app to reorder the strip, or use the arrows.","workspace.personalize.moveUp":"Move {app} up","workspace.personalize.moveDown":"Move {app} down","workspace.personalize.theme":"Theme","workspace.personalize.themeAuto":"Auto","workspace.personalize.themeLight":"Light","workspace.personalize.themeDark":"Dark","workspace.personalize.background":"Background","workspace.personalize.skyClouds":"Clouds","workspace.personalize.skyDunes":"Dunes","workspace.personalize.skyHills":"Hills","workspace.personalize.skyLake":"Lake","workspace.personalize.skyWindow":"Window","workspace.personalize.skyMountains":"Mountains","workspace.personalize.skyNone":"None","workspace.personalize.skyFollow":"Use the workspace background","workspace.personalize.summary":"Summary style","workspace.personalize.summaryBrief":"Brief","workspace.personalize.summarySignals":"Signals","workspace.personalize.widgets":"Widgets","workspace.decision.approve":"Approve","workspace.decision.badge":"Decision needed","workspace.decision.cancel":"Cancel","workspace.decision.clarify":"Clarify","workspace.decision.clarifyLabel":"Your clarification:","workspace.decision.clarifyPlaceholder":"Type your clarification\u2026","workspace.decision.confirmReject":"Confirm reject","workspace.decision.options":"Options:","workspace.decision.reject":"Reject","workspace.decision.rejectLabel":"Reason for rejection (optional):","workspace.decision.rejectPlaceholder":"Explain why this was rejected\u2026","workspace.decision.sendClarification":"Send clarification","workspace.demo.cta":"Try Symbols","workspace.demo.lede":"Enter your email to spin up a personal demo workspace \u2014 no password, no credit card.","workspace.demo.page.description":"Enter your email to spin up a personal Symbols demo workspace.","workspace.demo.page.title":"Symbols \u2014 Try the live demo workspace","workspace.demo.title":"Try Symbols","workspace.demo.error.hasAccount":"You already have an account \u2014 log in at my.symbols.app.","workspace.demo.error.invalidEmail":"Please enter a valid email address.","workspace.demo.error.startFailed":"Could not start your demo \u2014 please try again.","workspace.demo.linkSent.title":"Check your inbox","workspace.demo.linkSent.body":"We sent a sign-in link to {email}. Open the link to continue.","workspace.demo.linkSent.useAnother":"Use another email","workspace.demoClaim.banner":"Claim this workspace to keep it \u2014 your demo changes reset hourly.","workspace.demoClaim.createPassword":"Create a password","workspace.demoClaim.cta":"Claim this workspace","workspace.demoClaim.email":"Email","workspace.demoClaim.emailPlaceholder":"you@company.com","workspace.demoClaim.error.badCredentials":"Email or password is incorrect.","workspace.demoClaim.error.emailRequired":"Email is required.","workspace.demoClaim.error.logInFailed":"Could not log in. Please try again.","workspace.demoClaim.error.logInHandoff":"Logged in, but the handoff failed. Open my.symbols.app to continue.","workspace.demoClaim.error.noDemoWorkspace":"Could not resolve the demo workspace to copy. Please reload and try again.","workspace.demoClaim.error.passwordRequired":"Password is required.","workspace.demoClaim.error.passwordShort":"Password must be at least 8 characters.","workspace.demoClaim.error.signUpFailed":"Could not sign up. Please try again.","workspace.demoClaim.error.signUpHandoff":"Signed up, but the handoff failed. Open my.symbols.app and log in.","workspace.demoClaim.haveAccount":"Already have an account? Log in","workspace.demoClaim.ledeLogIn":"Log in to your existing Symbols account \u2014 we copy this demo workspace into it.","workspace.demoClaim.ledeSignUp":"Enter your email and set a password. Your demo data stops resetting and becomes your real account.","workspace.demoClaim.logIn":"Log in & copy workspace","workspace.demoClaim.loggingIn":"Logging in\u2026","workspace.demoClaim.newHere":"New here? Sign up instead","workspace.demoClaim.signUp":"Sign up","workspace.demoClaim.signingUp":"Signing up\u2026","workspace.demoClaim.titleLogIn":"Log in to keep your workspace","workspace.demoClaim.titleSignUp":"Sign up to keep your workspace","workspace.demoClaim.yourPassword":"Your password","workspace.demoClaim.pending.title":"Confirm your new email","workspace.demoClaim.pending.body":"The workspace is yours. We sent a verification link to {email}. The new email stays pending until you click that link.","workspace.demoClaim.pending.notSent":"The workspace is yours, but we could not send the verification link to {email}. The new email stays pending until it is confirmed.","workspace.demoClaim.pending.signInNote":"Until then, you cannot sign in with this email.","workspace.demoClaim.pending.continue":"Go to workspace","workspace.events.empty":"Nothing on the calendar this week.","workspace.extend.caption":"Build your own app or widget \u2014 Symbols is the OS underneath.","workspace.extend.title":"Extend Symbols","workspace.features.col.feature":"Feature","workspace.features.epic.calendar":"Calendar","workspace.features.epic.canvas":"Canvas","workspace.features.epic.chat":"Chat","workspace.features.epic.documents":"Documents","workspace.features.epic.files":"Files","workspace.features.epic.infra":"Infra","workspace.features.epic.marketplace":"Marketplace","workspace.features.epic.meet":"Meet","workspace.features.epic.shell":"Home / Shell","workspace.features.epic.tickets":"Tasks","workspace.features.epicSub.calendar":"Scheduling across week / month / team views","workspace.features.epicSub.canvas":"The DOMQL design editor & project surfaces","workspace.features.epicSub.chat":"Team messaging, threads & the agent bridge","workspace.features.epicSub.documents":"Library, notes & the knowledge base","workspace.features.epicSub.files":"Shared pan/zoom desktop & documents","workspace.features.epicSub.infra":"Service graph, status & deploy management","workspace.features.epicSub.marketplace":"Catalog, feed & install flow","workspace.features.epicSub.meet":"Live calls powered by LiveKit","workspace.features.epicSub.shell":"The dashboard, navigation & admin suite","workspace.features.epicSub.tickets":"Issue tracking, planning & the release pipeline","workspace.features.eyebrow":"QA & release tracking","workspace.features.filter.all":"All","workspace.features.menu.clearStatus":"Clear status","workspace.features.menu.createTask":"Create a task","workspace.features.menu.linked":"Linked: {id}","workspace.features.menu.reportBug":"Report a bug","workspace.features.menu.unlink":"Unlink ticket","workspace.features.page.title":"Feature matrix","workspace.features.qa.body":"{feature} ({epic}) reported on the {env} environment from the Feature Matrix for {workspace}.","workspace.features.qa.title":"[QA] {feature} \u2014 {env}","workspace.features.reset":"Reset this workspace","workspace.features.stat.fail":"Failing","workspace.features.stat.pass":"Passing","workspace.features.stat.total":"Total","workspace.features.stat.unchecked":"Unchecked","workspace.features.status.fail":"Failure","workspace.features.status.pass":"Working","workspace.features.status.unchecked":"Not checked","workspace.features.subtitle":"End-to-end functionality shipped by {workspace}, scoped to this workspace. Click a dot to cycle status; failing or right-click opens the bug / link-ticket menu.","workspace.features.title":"Feature matrix","workspace.features.thisWorkspace":"this workspace","workspace.header.mail.unread":"Unread mail","workspace.header.primaryNav":"Primary","workspace.home.allApps":"All apps","workspace.home.appStrip":"Apps","workspace.home.drop.added":"Added to Home","workspace.home.drop.addedMessage":"{app} was added to your dashboard.","workspace.home.drop.already":"Already on Home","workspace.home.drop.alreadyMessage":"{app} is already on your dashboard.","workspace.home.drop.thisApp":"This app","workspace.home.error.agents":"Failed to load agents","workspace.home.error.members":"Failed to load members","workspace.home.error.tickets":"Failed to load tickets","workspace.home.error.workspaceActivity":"Failed to load workspace activity","workspace.home.error.workspaceActivityEmpty":"Empty workspace-activity response","workspace.home.loadState.activity":"Couldn\u2019t load workspace activity","workspace.home.loadState.reminders":"Couldn\u2019t load reminders","workspace.home.loadState.remindersDescriptor":"Personal follow-ups","workspace.home.loadState.remindersDueToday":"{count} due today","workspace.home.loadState.remindersEmpty":"Nothing on your list \u2014 add one above.","workspace.home.greet.afternoon":"Good afternoon, ","workspace.home.greet.evening":"Good evening, ","workspace.home.greet.morning":"Good morning, ","workspace.home.greet.afternoonNoName":"Good afternoon","workspace.home.greet.eveningNoName":"Good evening","workspace.home.greet.morningNoName":"Good morning","workspace.home.greet.night":"Hello, ","workspace.home.greet.nightNoName":"Hello","workspace.home.prefs.notSavedMessage":"Your last dashboard change did not reach the server, so it will not appear on your other devices. Check your connection and try again.","workspace.home.prefs.notSavedTitle":"Dashboard change not saved","workspace.home.quickAdd.addAria":"Add a task","workspace.home.quickAdd.addPlaceholder":"Add a task\u2026","workspace.home.quickAdd.delegateAria":"Delegate a new task","workspace.home.quickAdd.delegatePlaceholder":"Delegate a task\u2026","workspace.home.quickAdd.noteFailed":"Could not add note","workspace.home.quickAdd.taskFailed":"Could not add task","workspace.home.quickAdd.add":"Add","workspace.home.quickAdd.delegate":"Delegate","workspace.home.tip1":"Empty space \u2192 Refresh \xb7 Customize","workspace.home.tip2":"A widget \u2192 its own actions","workspace.home.tipMouse":"Right-click, or press Shift+F10, for options","workspace.home.tipTouch":"Touch and hold for options","workspace.home.tryAgain":"Please try again.","workspace.hub.choose":"Choose a workspace","workspace.hub.oneMoment":"One moment \u2014 taking you to your team.","workspace.hub.opening":"Opening your workspace\u2026","workspace.hub.page.title":"Workspaces","workspace.hub.pickToday":"Pick where you want to work today.","workspace.hub.stalledNoOrgs":"We found no workspace for this account. Try again in a moment.","workspace.hub.stalledTitle":"We could not open your workspace","workspace.hub.stalledWithOrgs":"Pick one below, or try again.","workspace.hub.tryAgain":"Try again","workspace.inbox.markAllRead":"Mark all read","workspace.inbox.page.title":"Inbox","workspace.inbox.tab.all":"All","workspace.inbox.tab.unread":"Unread","workspace.inbox.tab.unreadCount":"Unread \xb7 {count}","workspace.inbox.tab.workspace":"Workspace","workspace.inbox.tab.workspaceTitle":"Only notifications from the workspace you\u2019re in","workspace.inbox.title":"Inbox","workspace.inbox.empty.all":"You\'re all caught up","workspace.inbox.empty.unread":"No unread notifications","workspace.inbox.empty.workspace":"Nothing from this workspace","workspace.linked.call":"Call","workspace.linked.conversation":"Conversation","workspace.linked.dm":"DM","workspace.linked.event":"Event","workspace.linked.group":"Group","workspace.linked.label":"Linked:","workspace.meet.startFailed":"Could not start call","workspace.meet.startFailedBody":"Meet room creation failed. Check your connection or try again.","workspace.meet.calendarCall":"Calendar call","workspace.menu.addColor":"Add color","workspace.menu.changeColor":"Change color","workspace.menu.changeWithAi":"Change with AI\u2026","workspace.menu.customize":"Customize dashboard","workspace.menu.deleteWidget":"Delete \u201C{title}\u201D","workspace.menu.hideWidget":"Hide \u201C{title}\u201D","workspace.menu.language":"Language: {language}","workspace.menu.makePersonal":"Make personal","workspace.menu.openApp":"Open {app}","workspace.menu.shareToWorkspace":"Share to workspace","workspace.menu.thisWidget":"this widget","workspace.my.page.title":"My profile","workspace.nav.announcements":"Announcements","workspace.nav.company":"Company","workspace.nav.main":"Main","workspace.nav.my":"My","workspace.nav.searchPlaceholder":"Search across everything\u2026","workspace.nav.teamMembers":"Team members","workspace.navbar.sidebars.hide":"Hide sidebar","workspace.navbar.sidebars.show":"Show sidebar","workspace.navbar.sidebars.toggle":"Toggle sidebar","workspace.newsRow.toggleFavorite":"Toggle favorite","workspace.notFound.caption":"This page doesn\'t exist.","workspace.notFound.goHome":"Go home","workspace.notFound.title":"Not found","workspace.notes.add":"Add","workspace.notes.empty":"No documents yet \u2014 start with a workspace note or knowledge base article.","workspace.notes.newAria":"New note title","workspace.notes.newPlaceholder":"New note\u2026","workspace.notification.fallbackTitle":"Notification","workspace.onlineMembers.more":"{count} more online","workspace.orgChart.empty":"No team members yet.","workspace.orgChart.loadFailed":"Could not load the org chart.","workspace.orgChart.saveFailed":"Save failed.","workspace.orgChart.noManager":"No manager","workspace.orgChart.save":"Save changes","workspace.orgChart.saved":"Org chart updated","workspace.orgChart.savedBody":"Manager changes saved.","workspace.orgChart.saving":"Saving\u2026","workspace.orgChart.subtitle":"See how the team reports, and set managers for the whole team in one place.","workspace.orgChart.tabChart":"Chart","workspace.orgChart.tabEdit":"Edit managers","workspace.orgChart.title":"Org chart","workspace.page.acceptInvite":"Accept invitation / Symbols","workspace.page.addApp":"Add App","workspace.page.apps":"Workspace apps","workspace.page.admin":"Admin","workspace.page.agents":"Agents","workspace.page.analytics":"Analytics","workspace.page.analyticsBugs":"Bugs \xb7 Analytics","workspace.page.analyticsEvents":"Events \xb7 Analytics","workspace.page.analyticsMap":"Analytics \xb7 Map","workspace.page.analyticsSessions":"Sessions \xb7 Analytics","workspace.page.analyticsVisitors":"Visitors \xb7 Analytics","workspace.page.authCallback":"Signing in\u2026 / Symbols","workspace.page.history":"Workspace History","workspace.page.calendar":"Calendar","workspace.page.canvas":"Canvas / Symbols.app","workspace.page.chat":"Chat","workspace.page.dashboard":"Dashboard / Symbols.app","workspace.page.data":"Data","workspace.page.dataExternal":"External data","workspace.page.demo":"Symbols Demo","workspace.page.editor":"Editor","workspace.page.features":"Features","workspace.page.files":"Files","workspace.page.inbox":"Inbox","workspace.page.infra":"Infra","workspace.page.infraStatus":"Status / Infra","workspace.page.kb":"Knowledge Base","workspace.page.login":"Log in / Symbols","workspace.page.logs":"Logs","workspace.page.logsBugs":"Bugs / Logs","workspace.page.logsEvents":"Events / Logs","workspace.page.logsNetwork":"Network / Logs","workspace.page.logsSession":"Session / Logs","workspace.page.logsSessions":"Sessions / Logs","workspace.page.logsUsers":"Users / Logs","workspace.page.logsVerbose":"Verbose / Logs","workspace.page.mail":"Mail","workspace.page.marketplace":"Marketplace","workspace.page.marketplaceCommunity":"Community feed / Marketplace","workspace.page.marketplacePrompts":"Prompt Gallery / Marketplace","workspace.page.marketplaceRailDemo":"InstallableRail Demo / Marketplace","workspace.page.meet":"Meet","workspace.page.myTasks":"My view / Tasks","workspace.page.notFound":"Not found / Symbols.app","workspace.page.notes":"Notes","workspace.page.preview":"Preview","workspace.page.reminders":"Reminders","workspace.page.resetPassword":"Reset password / Symbols","workspace.page.resolutions":"Resolutions","workspace.page.resolutionsAudit":"Audit / Reports / Resolutions","workspace.page.resolutionsEditRequests":"Edit requests / Resolutions","workspace.page.resolutionsImprovements":"Improvements / Resolutions","workspace.page.resolutionsInbound":"Inbound / Resolutions","workspace.page.resolutionsOutbound":"Outbound / Resolutions","workspace.page.resolutionsRequests":"Customer requests / Resolutions","workspace.page.sharedResource":"Shared / Symbols","workspace.page.signin":"Sign in / Symbols","workspace.page.signup":"Sign up / Symbols","workspace.page.signupConfirmation":"Confirm your email / Symbols","workspace.page.systemHealth":"System Health","workspace.page.teamAndAgents":"Team & agents","workspace.page.ticket":"Task","workspace.page.ticketsBoard":"Board / Tasks","workspace.page.ticketsEpics":"Epics & Stories / Tasks","workspace.page.ticketsFeed":"Feed / Tasks","workspace.page.ticketsGeneral":"General / Tasks","workspace.page.ticketsRelease":"Release / Tasks","workspace.page.ticketsRoadmap":"Roadmap / Tasks","workspace.page.ticketsStandups":"Standups / Tasks","workspace.page.ticketsStatus":"Status / Tasks","workspace.page.waitlistInvite":"Join Symbols / Symbols","workspace.page.workspaceAnalytics":"Workspace Analytics","workspace.pageTitle.admin":"Admin","workspace.pageTitle.audit":"Audit / Reports","workspace.pageTitle.board":"Board","workspace.pageTitle.calendar":"Calendar","workspace.pageTitle.call":"Call","workspace.pageTitle.canvas":"Canvas","workspace.pageTitle.chat":"Chat","workspace.pageTitle.epics":"Epics","workspace.pageTitle.feed":"Feed","workspace.pageTitle.general":"General","workspace.pageTitle.inbound":"Inbound","workspace.pageTitle.meet":"Meet","workspace.pageTitle.myView":"My view","workspace.pageTitle.notes":"Notes","workspace.pageTitle.outbound":"Outbound","workspace.pageTitle.release":"Release","workspace.pageTitle.requests":"Requests","workspace.pageTitle.resolutions":"Resolutions","workspace.pageTitle.roadmap":"Roadmap","workspace.pageTitle.standups":"Standups","workspace.pageTitle.stories":"Stories","workspace.pageTitle.systemHealth":"System Health","workspace.pageTitle.tasks":"Tasks","workspace.pageTitle.transcript":"Transcript","workspace.pageTitle.workspaces":"Workspaces","workspace.pageItem.noUi":"No workspace UI available to open this item.","workspace.pageItem.ticketNotFound":"Ticket {id} not found.","workspace.pageItem.channelNotFound":"Channel {id} not found.","workspace.pageItem.documentNotFound":"Document {id} not found.","workspace.pageItem.noteNotFound":"Note {id} not found.","workspace.pageItem.articleNotFound":"Article {id} not found.","workspace.pageItem.eventNotFound":"Event {id} not found.","workspace.pageItem.roomNotFound":"Room {id} not found.","workspace.pageItem.recordNoCollection":"Record {id} can\'t open: the request named no collection.","workspace.pageItem.recordNoRoute":"No app in this workspace opens records of {collection}, so record {id} can\'t open here.","workspace.pageItem.recordNotFound":"Record {id} was not found in {collection}, or you don\'t have access to it.","workspace.pageItem.unknownType":"Unknown page item type \\"{type}\\".","workspace.people.category.archived":"Archived","workspace.people.category.external":"External","workspace.people.category.manager":"Manager","workspace.people.category.passive":"Passive","workspace.people.category.unassigned":"Unassigned","workspace.people.emptyFilter":"No members match this filter.","workspace.people.emptyGroup":"No members of \\"{group}\\" are in this organization\'s roster.","workspace.people.emptyQuery":"No members found for \\"{query}\\"","workspace.people.eyebrow":"The team","workspace.people.filter.active":"Active","workspace.people.filter.everyone":"Everyone","workspace.people.filter.inactive":"Inactive","workspace.people.filter.other":"Other","workspace.people.group.noTeam":"No team","workspace.people.navAria":"Team members","workspace.people.orgChart":"Org chart","workspace.people.page.title":"Team members","workspace.people.rail.inactive":"Inactive","workspace.people.rail.members":"Members","workspace.people.rail.teams":"Teams","workspace.people.state.emptyBody":"Invite your team to see them here.","workspace.people.state.emptyTitle":"No team members yet","workspace.people.state.errorBody":"Check your connection, then try again.","workspace.people.state.errorTitle":"Team members couldn\u2019t load","workspace.people.state.loading":"Loading team members\u2026","workspace.people.state.reduced":"You can see only your own profile. Your access does not cover the full member list.","workspace.people.title":"Team members","workspace.person.action.assign":"Assign","workspace.person.action.call":"Call","workspace.person.action.chat":"Chat","workspace.person.action.email":"Email","workspace.person.action.meet":"Meet","workspace.person.action.ping":"Ping","workspace.person.action.profile":"Profile","workspace.person.addDirectory":"Add to directory","workspace.person.addDirectoryFailed":"Could not add to directory","workspace.person.addedDirectory":"Added to directory","workspace.person.callFailed":"Could not start the call","workspace.person.callInviteBody":"Join my call: {url}","workspace.person.callRoomName":"Call with {name}","workspace.person.categoryUnassigned":"Unassigned","workspace.person.chatFailed":"Could not open chat","workspace.person.fallbackName":"Person","workspace.person.inDirectory":"In directory","workspace.person.invitedAs":"Invited as {role}","workspace.person.meetingWith":"Meeting with {name}","workspace.person.member":"Member","workspace.person.online":"Online","workspace.person.open":"Open","workspace.person.orgRole":"Org role: {role}","workspace.person.pending":"Pending","workspace.person.pendingInvites":"Pending invitations","workspace.person.pingFailed":"Ping failed","workspace.person.pingFailedSend":"Could not send ping","workspace.person.pingSent":"Ping sent","workspace.person.pingSentBody":"{name} will be notified.","workspace.person.pingedYou":"{name} pinged you","workspace.person.revoke":"Revoke","workspace.person.revokeConfirm":"Revoke invitation?","workspace.person.revokeConfirmBody":"{email} won\'t be able to join with this invite link anymore.","workspace.person.revokeCta":"Revoke invite","workspace.person.revokeFailed":"Revoke failed","workspace.person.revoked":"Invitation revoked","workspace.person.revokedBody":"{email} is no longer invited.","workspace.person.role":"Role","workspace.person.roleChange.title":"Give {name} the role \u201C{role}\u201D?","workspace.person.roleChange.message":"Their access in this organization changes at once.","workspace.person.roleChange.confirm":"Change role","workspace.person.roleChange.self":"You cannot change your own role. Ask another owner or admin.","workspace.person.tryAgain":"Please try again.","workspace.person.unknown":"Unknown","workspace.person.pingedYouAnon":"Someone pinged you","workspace.personModal.close":"Close","workspace.personModal.noTeams":"No team memberships.","workspace.personModal.openProfile":"Open profile","workspace.personModal.teams":"Teams ({count})","workspace.priority.high":"High","workspace.priority.low":"Low","workspace.priority.medium":"Medium","workspace.priority.urgent":"Urgent","workspace.projects.addToWorkspace":"Add to this workspace","workspace.projects.new":"New project","workspace.pulse.active":"In progress","workspace.pulse.blocked":"Blocked","workspace.pulse.needsYou":"{count} need you","workspace.pulse.needsYouOne":"1 needs you","workspace.pulse.review":"In review","workspace.pulse.todo":"To do","workspace.reaction.all":"All","workspace.reaction.popular":"Popular","workspace.redirect.openingLogs":"Opening Analytics \u2192 Logs\u2026","workspace.redirect.openingNotes":"Opening Notes\u2026","workspace.redirect.openingTasks":"Opening Tasks\u2026","workspace.redirect.page.title":"Redirecting","workspace.reminders.addAria":"Add a reminder","workspace.reminders.addFailed":"Could not add reminder","workspace.reminders.composer.add":"Add","workspace.reminders.composer.nextWeek":"Next week","workspace.reminders.composer.pickDate":"Pick a date & time","workspace.reminders.composer.placeholder":"Add a reminder\u2026 (@name to mention)","workspace.reminders.composer.today":"Today","workspace.reminders.composer.tomorrow":"Tomorrow","workspace.reminders.convertFailed":"Could not convert to task","workspace.reminders.convertToEvent":"Convert to event","workspace.reminders.convertToTask":"Convert to task","workspace.reminders.converted":"Converted to task","workspace.reminders.delete":"Delete reminder","workspace.reminders.deleteFailed":"Could not delete reminder","workspace.reminders.due":"Reminder due","workspace.reminders.due.overdue":"Overdue \xb7 {count}d","workspace.reminders.due.today":"Today {time}","workspace.reminders.due.tomorrow":"Tomorrow","workspace.reminders.empty.completed":"Nothing completed yet.","workspace.reminders.empty.notEnabled":"Reminders isn\'t enabled for this workspace","workspace.reminders.empty.private":"No private reminders yet \u2014 add one above.","workspace.reminders.empty.shared":"No shared reminders yet \u2014 add one above.","workspace.reminders.empty.today":"Nothing due today \u2014 enjoy the quiet.","workspace.reminders.empty.upcoming":"Nothing on the horizon yet.","workspace.reminders.filter.all":"All","workspace.reminders.filter.completed":"Completed","workspace.reminders.filter.today":"Today","workspace.reminders.filter.upcoming":"Upcoming","workspace.reminders.group.completed":"Completed","workspace.reminders.group.noDate":"No date","workspace.reminders.group.overdue":"Overdue","workspace.reminders.group.today":"Today","workspace.reminders.group.tomorrow":"Tomorrow","workspace.reminders.group.upcoming":"Upcoming","workspace.reminders.listTitle":"Reminders","workspace.reminders.loadFailed":"Failed to load reminders","workspace.reminders.mentionTitle":"{name} mentioned you in a reminder","workspace.reminders.moreAria":"More reminder actions","workspace.reminders.navAria":"Reminders","workspace.reminders.page.title":"Reminders","workspace.reminders.removeDueAria":"Remove due date","workspace.reminders.scope.private":"Private","workspace.reminders.scope.shared":"Shared","workspace.reminders.scopeAria":"Reminder visibility scope","workspace.reminders.scopeTitle":"Scope","workspace.reminders.sharedChip":"Shared with the workspace","workspace.reminders.toggleAria2":"Toggle reminder done","workspace.reminders.tryAgain":"Please try again.","workspace.reminders.untitled":"Untitled","workspace.reminders.updateFailed":"Could not update reminder","workspace.reminders.visibility.private":"Private","workspace.reminders.visibility.shared":"Shared","workspace.reminders.deleteTitle":"Delete \u201C{name}\u201D?","workspace.reminders.deleteSharedBody":"It is shared, so it goes for everyone who sees it.","workspace.remindersAnswer.empty":"No reminders here.","workspace.requestAccess.closed":"Self-serve requests are not open right now. Ask the team for an invitation to this workspace.","workspace.requestAccess.question":"How do you work with the team?","workspace.requestAccess.reviewNote":"We review every request. If it is a fit you will receive an invitation by email.","workspace.requestAccess.sending":"Sending\u2026","workspace.requestAccess.sent":"Request sent","workspace.requestAccess.sentBody":"The team reviews every request and answers by email.","workspace.requestAccess.signOut":"Sign out","workspace.requestAccess.submit":"Request an invitation","workspace.requestAccess.title":"Request access","workspace.requestAccess.yourName":"Your name","workspace.requestAccess.intro":"{who} is not a member of {workspace} yet. Request an invitation \u2014 the team reviews every request.","workspace.requestAccess.introNoName":"{who} is not a member of this workspace yet. Request an invitation \u2014 the team reviews every request.","workspace.requestAccess.signedInAs":"Signed in as {email}","workspace.requestAccess.yourAccount":"Your account","workspace.rows.join":"Join","workspace.rows.joinCall":"Join call","workspace.rows.openExternal":"Open external release \u2192","workspace.sandbox.frameTitle":"App","workspace.sandbox.marker":"App content \u2014 runs isolated from your account","workspace.sandbox.stopped":"This app stopped. Reload the page to start it again.","workspace.search.action.ask":"Ask the assistant about these results","workspace.search.action.askContext":"\u2318K search \u2014 {filters}","workspace.search.action.askPrompt":"Tell me about the results filtered by {filters}.","workspace.search.action.clear":"Clear filters","workspace.search.action.openIn":"Open in {app}","workspace.search.action.rows":"{count} found","workspace.search.category.actions":"With these results","workspace.search.category.appStore":"Not installed \u2014 from the App Store","workspace.search.category.apps":"Apps","workspace.search.category.channels":"Channels","workspace.search.category.chips":"Filtered by","workspace.search.category.commands":"Commands","workspace.search.category.discover":"Nothing found in this workspace","workspace.search.category.events":"Events","workspace.search.category.files":"Files","workspace.search.category.filters":"Filter by","workspace.search.category.integrations":"Not connected \u2014 Integrations","workspace.search.category.kb":"Knowledge Base","workspace.search.category.mail":"Mail","workspace.search.category.messages":"Messages","workspace.search.category.notes":"Notes","workspace.search.category.people":"People","workspace.search.category.tickets":"Tasks","workspace.search.chip.remove":"Remove","workspace.search.folder":"Folder","workspace.search.suggest.appStoreCaption":"Browse apps you can install","workspace.search.suggest.appStoreRow":"Install into this workspace","workspace.search.suggest.integrationRow":"Connect this service","workspace.search.suggest.integrations":"Integrations","workspace.search.suggest.integrationsCaption":"Connect an external service","workspace.search.suggest.marketplace":"Marketplace","workspace.search.suggest.marketplaceCaption":"Templates, components and plugins","workspace.search.untitled":"Untitled","workspace.search.untitledDocument":"Untitled document","workspace.sessionBridge.body":"Session bridge. Hands off the SDK session to other Symbols subdomains.","workspace.sessionBridge.page.title":"Session bridge \xb7 Symbols","workspace.signInSession.page.title":"Approve a sign-in \xb7 Symbols","workspace.signInSession.title":"Approve a sign-in","workspace.signInSession.lead":"A device asks to sign in to your Symbols account. It gets a session to your account.","workspace.signInSession.started":"Started","workspace.signInSession.from":"From","workspace.signInSession.client":"Client","workspace.signInSession.clientCli":"Symbols CLI","workspace.signInSession.clientUnknown":"Unknown client","workspace.signInSession.warning":"Continue ONLY if you started this sign-in yourself, on your own device. If you did not, press Cancel.","workspace.signInSession.codeLabel":"Enter the code your device shows","workspace.signInSession.codeError.missing":"Enter the code your device shows.","workspace.signInSession.codeError.wrong":"That code does not match. Check the code on your device.","workspace.signInSession.continue":"Continue","workspace.signInSession.cancel":"Cancel","workspace.signInSession.done":"Done. Return to your device.","workspace.signInSession.error.expired":"This sign-in link has expired or was already used. Start the sign-in again on your device.","workspace.signInSession.error.locked":"Too many wrong codes. Start the sign-in again on your device.","workspace.signInSession.error.failed":"Could not approve the sign-in. Try again.","workspace.share.copied.message":"Anyone with this link can open it until it expires or you revoke it.","workspace.share.copied.title":"Public link copied","workspace.share.copyFailed.message":"The link was created. Copy it from the field above.","workspace.share.copyFailed.title":"Could not copy","workspace.share.expiry.d30":"30 days","workspace.share.expiry.d7":"7 days","workspace.share.expiry.d90":"90 days","workspace.share.expiry.never":"Never","workspace.share.modal.copy":"Copy","workspace.share.modal.copyOnce":"Copy it now \u2014 this link is shown only once","workspace.share.modal.empty":"No links yet. Nothing is public until you create one.","workspace.share.modal.existing":"Links for this item","workspace.share.modal.expiryLabel":"Link expires","workspace.share.modal.liveNotice":"The link always shows the latest version \u2014 edits you make later are published too. It stops working when it expires or when you revoke it.","workspace.share.modal.opt30":"30 days (default)","workspace.share.modal.opt7":"7 days","workspace.share.modal.opt90":"90 days","workspace.share.modal.optNever":"Never \u2014 stays open until revoked","workspace.share.modal.revoke":"Revoke","workspace.share.modal.subtitle":"Anyone with the link can open {what} \u2014 no account needed.","workspace.share.modal.thisFile":"this file","workspace.share.modal.thisNote":"this note","workspace.share.modal.title":"Share publicly","workspace.share.revoked.message":"The link stops working immediately, for everyone who has it.","workspace.share.revoked.title":"Link revoked","workspace.share.revoke.title":"Revoke the public link to \u201C{name}\u201D?","workspace.share.status.days":"Live \xb7 expires in {count} days","workspace.share.status.expired":"Expired","workspace.share.status.never":"Live \xb7 never expires","workspace.share.status.revoked":"Revoked","workspace.share.status.today":"Live \xb7 expires today","workspace.share.error.createFailed":"Could not create the link","workspace.share.error.loadFailed":"Could not load the existing links","workspace.share.error.revokeFailed":"Could not revoke the link","workspace.share.uses.many":"opened {count} times","workspace.share.uses.never":"never opened","workspace.share.uses.once":"opened once","workspace.shareLink.create":"Create link","workspace.shareLink.creating":"Working\u2026","workspace.shareLink.expiryLabel":"Link expiry","workspace.shareLink.publicLinkLabel":"Public link","workspace.shared.footer":"Shared with a public link.","workspace.shared.footerExpires":"Shared with a public link \xb7 expires {date}","workspace.shared.goneHint":"It may have expired, or the person who shared it may have revoked it. Ask them for a new link.","workspace.shared.goneTitle":"This link is not available","workspace.shared.openFile":"Open file","workspace.shared.opening":"Opening\u2026","workspace.shared.updated":"updated {date}","workspace.sidebar.agent.caesar":"Operations","workspace.sidebar.agent.simone":"Builds your product","workspace.sidebar.agent.temo":"Resolves your tasks","workspace.sidebar.agent.watcher":"Analyzes usage","workspace.sidebar.channels":"CHANNELS","workspace.sidebar.directMessages":"DIRECT MESSAGES","workspace.sidebar.event.untitled":"Event","workspace.sidebar.moreActions":"More actions","workspace.sidebar.moreOptions":"More options","workspace.simone.copyFailed":"Copy failed","workspace.simone.error.failed":"Sorry \u2014 that request failed.","workspace.simone.turn.stopped":"You stopped this answer.","workspace.simone.turn.reconnecting":"The connection dropped, but the work goes on. The answer will show here when it is ready.","workspace.simone.turn.waitingForYou":"The connection dropped. A step above is waiting for your answer.","workspace.simone.approval.expired":"This step did not run: the wait for your answer ended. Ask again to run it.","workspace.simone.approval.notRun":"This step did not run: the conversation stopped before your answer. Ask again to run it.","workspace.simone.approval.runAgain":"Run that step again","workspace.simone.approval.runNowPrompt":"Please run this step now: {step}","workspace.simone.error.failedWithMessage":"Sorry \u2014 that request failed ({message}).","workspace.simone.error.localBridge":"Local bridge not connected ({url}) \u2014 start simone-bridge locally, or switch the target back to Workspace.","workspace.simone.error.network":"Sorry \u2014 I couldn\'t reach the server. Check your connection and try again.","workspace.simone.error.noWorkspace":"No active workspace \u2014 open or switch to a workspace to use AI here.","workspace.simone.error.notReady":"AI service not ready \u2014 please retry in a moment.","workspace.simone.error.stream":"The AI service didn\'t respond cleanly. Try again \u2014 if it keeps happening, switching models often helps.","workspace.simone.error.agentInactive":"This agent is inactive.","workspace.simone.images.defaultName":"image","workspace.simone.images.empty":"empty","workspace.simone.images.notAccepted":"not accepted","workspace.simone.images.notReadable":"not a readable image","workspace.simone.images.notSent":"Not sent: {list}.","workspace.simone.images.tooLarge":"larger than {size}","workspace.simone.images.tooMany":"more than {max} images in one message","workspace.simone.images.totalTooLarge":"over the {size} total","workspace.simone.images.unsupported":"an unsupported format ({type})","workspace.simone.linkCopied":"Link copied","workspace.simone.linkCopiedBody":"Workspace members can open this conversation from the link.","workspace.simone.menu.remove":"Remove","workspace.simone.menu.shareLink":"Share link","workspace.simone.menu.star":"Star","workspace.simone.menu.unstar":"Unstar","workspace.simone.newChat":"New chat","workspace.simone.newThread":"New thread","workspace.simone.noBridge":"No bridge transport \u2014 initBridge has not been called yet.","workspace.simone.notShareable":"Not shareable yet","workspace.simone.notShareableBody":"Send a message first \u2014 the thread gets its link once it exists on the server.","workspace.simone.shareFailed":"Share failed","workspace.simone.shareFailedBody":"Could not share the conversation.","workspace.simone.threadUnavailable":"This conversation is not available to you. It may be private, deleted or in another workspace. Ask its owner to share it.","workspace.simone.threadUnavailableTitle":"Conversation not available","workspace.simone.removeTitle":"Remove \u201C{name}\u201D?","workspace.simone.removeFailed":"Could not remove the conversation","workspace.story.joined":"{count} people joined","workspace.story.meetingAt":"\xb7 at {time}","workspace.story.plannedFor":"Planned for","workspace.story.tickets":"TICKETS","workspace.switch.slow":"Switch is taking too long","workspace.switch.slowBody":"The workspace switch didn\u2019t complete in time \u2014 some data may be stale. Try again or reload.","workspace.system.corner.package":"Package","workspace.system.corner.service":"Service","workspace.system.error.detail":"Verify the GitHub status integration, then use Refresh to try again.","workspace.system.error.title":"Status checks need attention","workspace.system.grid.packages":"Packages","workspace.system.grid.services":"Services","workspace.system.infra.empty":"No uptime history has been reported yet.","workspace.system.infra.period":"Last 120 days","workspace.system.infra.title":"Infrastructure","workspace.system.latency":"{ms} ms","workspace.system.moreHealthActions":"More System Health actions","workspace.system.noCheck":"No check recorded","workspace.system.openDeployment":"Open the {repo} deployment on {env}","workspace.system.page.title":"System Health / Admin","workspace.system.refresh":"Refresh","workspace.system.refreshAria":"Refresh System Health","workspace.system.status.building":"Building","workspace.system.status.degraded":"Degraded","workspace.system.status.failed":"Failed","workspace.system.status.healthy":"Healthy","workspace.system.status.noData":"No data","workspace.system.status.pending":"Pending","workspace.system.status.probeError":"Probe error","workspace.system.title":"System Health","workspace.system.tone.allFailed":"Status service returned errors \u2014 every probe failed","workspace.system.tone.empty":"No status data yet","workspace.system.tone.error":"Status checks need attention","workspace.system.tone.loading":"Fetching status...","workspace.system.tone.ok":"All systems operational","workspace.system.tone.partial":"Some probes failed \u2014 see details below","workspace.teamAnswer.agent":"AI agent","workspace.teamAnswer.empty":"No one matches.","workspace.teamAnswer.failed":"Could not load the team.","workspace.teamAnswer.group.agents":"AI agents \xb7 {count}","workspace.teamAnswer.group.members":"Members \xb7 {count}","workspace.teamAnswer.group.online":"Online now \xb7 {count}","workspace.teamAnswer.noneOnline":"No one else is online right now.","workspace.teamAnswer.online":"Online","workspace.teamAnswer.show.agents":"AI agents","workspace.teamAnswer.show.all":"Everyone","workspace.teamAnswer.show.members":"Members","workspace.teamAnswer.show.online":"Online now","workspace.teamAnswer.title":"Team","workspace.teamAnswer.you":"You","workspace.teamTime.offHours":"Off hours","workspace.teamTime.openAria":"Open {name}","workspace.teamTime.profile":"profile","workspace.teamTime.remote":"Remote","workspace.teamTime.workingHours":"Working hours","workspace.teamtime.empty":"No other teammates yet \u2014 invite your team to see their local time here.","workspace.threadPicker.empty":"No saved threads yet","workspace.threadPicker.new":"+ New thread","workspace.threadPicker.switch":"Switch thread","workspace.threadPicker.thread":"Thread","workspace.ticket.untitled":"Untitled","workspace.ticketState.awaitingApproval":"Awaiting approval","workspace.ticketState.backlog":"Backlog","workspace.ticketState.blocked":"Blocked","workspace.ticketState.cancelled":"Cancelled","workspace.ticketState.done":"Done","workspace.ticketState.draft":"Draft","workspace.ticketState.inProgress":"In progress","workspace.ticketState.inReview":"In review","workspace.ticketState.readyToTest":"Ready to test","workspace.ticketState.released":"Released","workspace.ticketState.todo":"To do","workspace.unsaved.discardTitle":"Discard changes?","workspace.unsaved.discardMessage":"A page you left open has changes that are not saved. If you discard them, the page closes.","workspace.unsaved.discard":"Discard","workspace.unsaved.keep":"Keep","workspace.username.available":"Available.","workspace.username.error.required":"Pick a username first.","workspace.username.error.saveFailed":"Could not save the username. Try again.","workspace.username.keepCurrent":"Keep current","workspace.username.label":"Username","workspace.username.rules":"Lowercase letters, numbers and dashes.","workspace.username.subtitle":"It names you on your profile and in mentions. Keep the suggested one or make it yours.","workspace.username.taken":"That username is taken.","workspace.username.title":"Pick your username","workspace.usernamePrompt.fieldLabel":"Username","workspace.usernamePrompt.save":"Save username","workspace.usernamePrompt.saving":"Saving\u2026","workspace.widget.action.createAgent":"Create agent","workspace.widget.action.hide":"Hide this widget","workspace.widget.activity.subtitle":"Standups, tasks, notes and calls \u2014 last 365 days","workspace.widget.activity.title":"Your activity","workspace.widget.agents.subtitle":"People + AI agents working alongside you","workspace.widget.agents.title":"Team and agents","workspace.widget.analytics.subtitle":"Who\'s on the workspace today","workspace.widget.analytics.title":"Active right now","workspace.widget.appAgents.subtitle":"AI agents","workspace.widget.appAgents.title":"Agents","workspace.widget.appAnalytics.subtitle":"Insights","workspace.widget.appAnalytics.title":"Analytics","workspace.widget.appBroadcast.subtitle":"Announcements","workspace.widget.appBroadcast.title":"Broadcast","workspace.widget.appCalendar.subtitle":"Schedule","workspace.widget.appCalendar.title":"Calendar","workspace.widget.appChat.subtitle":"Team messages","workspace.widget.appChat.title":"Chat","workspace.widget.appDocuments.subtitle":"Notes & knowledge","workspace.widget.appDocuments.title":"Notes","workspace.widget.appHealth.subtitle":"Operations","workspace.widget.appHealth.title":"System Health","workspace.widget.appInfra.subtitle":"Services and status","workspace.widget.appInfra.title":"Infrastructure","workspace.widget.appMeet.subtitle":"Video rooms","workspace.widget.appMeet.title":"Meet","workspace.widget.appPeople.subtitle":"Members","workspace.widget.appPeople.title":"People","workspace.widget.appReminders.title":"Reminders","workspace.widget.appStudio.subtitle":"Design canvas","workspace.widget.appStudio.title":"Apps","workspace.widget.appTeam.subtitle":"Team & agents","workspace.widget.appTeam.title":"Team","workspace.widget.appTickets.subtitle":"Tasks & board","workspace.widget.appTickets.title":"Tasks","workspace.widget.assets.subtitle":"Files and documents in this workspace","workspace.widget.assets.title":"Notes","workspace.widget.broadcast.subtitle":"Messages to the whole workspace","workspace.widget.broadcast.title":"Broadcast","workspace.widget.deleteFailed":"Could not delete widget","workspace.widget.deleted":"\u201C{title}\u201D deleted","workspace.widget.events.title":"Coming up","workspace.widget.genericError":"Something went wrong \u2014 try again.","workspace.widget.given.bodyEmpty":"You haven\'t delegated any open tasks.","workspace.widget.given.bodyError":"Couldn\u2019t load delegated tasks \u2014 reload to try again.","workspace.widget.given.subtitleError":"Couldn\u2019t load delegated tasks","workspace.widget.given.title":"Given tasks","workspace.widget.madePersonal":"\u201C{title}\u201D made personal","workspace.widget.mailInbox.compose":"Compose","workspace.widget.mailInbox.empty":"No mail in your inbox.","workspace.widget.mailInbox.noSubject":"(no subject)","workspace.widget.mailInbox.title":"Inbox","workspace.widget.nextUp.empty":"Nothing coming up","workspace.widget.nextUp.error":"Couldn\'t load the calendar.","workspace.widget.nextUp.inHours":"in {n} h","workspace.widget.nextUp.inMinutes":"in {n} min","workspace.widget.nextUp.newBooking":"New booking","workspace.widget.nextUp.title":"Next up","workspace.widget.personalMessage":"Only you can see it now.","workspace.widget.prioritymix.title":"Priority mix","workspace.widget.prioritymix.toTriage":"{count} to triage","workspace.widget.received.bodyEmpty":"Nothing assigned to you right now.","workspace.widget.received.bodyError":"Couldn\u2019t load your tasks \u2014 reload to try again.","workspace.widget.received.subtitleError":"Couldn\u2019t load your tasks","workspace.widget.received.title":"Received tasks","workspace.widget.shared":"\u201C{title}\u201D shared","workspace.widget.sharedMessage":"Every workspace member with data access can now see it.","workspace.widget.teampulse.title":"Team pulse","workspace.widget.teamtime.subtitle":"Where everyone is right now","workspace.widget.teamtime.title":"Team timezones","workspace.widget.untitled":"Widget","workspace.widget.changeWithAiPrefix":"Change \u201C{title}\u201D: ","workspace.widget.changeWithAiKey":"Home widget \u201C{title}\u201D","workspace.widget.updateFailed":"Could not update widget","workspace.widget.workload.title":"Workload","workspace.widget.youragents.title":"Your agents","workspace.widgetColor.appColor":"App color","workspace.widgetColor.default":"Default (no color)","workspace.widgetColor.pickerAria":"Widget color","workspace.widgetColor.suggested":"Suggested colors","workspace.workload.captionEmpty":"nothing assigned","workspace.workload.captionTop":"on {name}","workspace.workload.more":"{count} more","workspace.workload.unassignedCount":"{count} unassigned","workspace.wysiwyg.blockquote":"Blockquote","workspace.wysiwyg.bold":"Bold","workspace.wysiwyg.bulletList":"Bullet list","workspace.wysiwyg.code":"Code","workspace.wysiwyg.divider":"Divider","workspace.wysiwyg.italic":"Italic","workspace.wysiwyg.link":"Link","workspace.wysiwyg.numberedList":"Numbered list","workspace.wysiwyg.strikethrough":"Strikethrough","workspace.wysiwyg.underline":"Underline","workspace.aiAware.canvasBoard":"Canvas board","workspace.aiAware.canvasItems":"{name} \xb7 {count} items","workspace.aiAware.canvasItemsOne":"{name} \xb7 1 item","workspace.aiAware.designSystem":"Design system \xb7 {name}","workspace.aiAware.element":"element","workspace.aiAware.home":"Home","workspace.aiAware.image":"Image","workspace.aiAware.page.calendar":"Calendar","workspace.aiAware.page.chat":"Chat","workspace.aiAware.page.files":"Files","workspace.aiAware.page.history":"History","workspace.aiAware.page.meet":"Meet","workspace.aiAware.page.notes":"Notes","workspace.aiAware.page.tasks":"Tasks","workspace.aiAware.page.terminal":"Terminal","workspace.aiAware.rows.activityOne":"1 activity event","workspace.aiAware.rows.activity":"{count} activity events","workspace.aiAware.rows.activityOfTotal":"{count} of {total} activity events","workspace.aiAware.rows.channels":"{count} channels","workspace.aiAware.rows.channelsOfTotal":"{count} of {total} channels","workspace.aiAware.rows.channelsOne":"1 channel","workspace.aiAware.rows.columns":"{count} columns","workspace.aiAware.rows.columnsOfTotal":"{count} of {total} columns","workspace.aiAware.rows.columnsOne":"1 column","workspace.aiAware.rows.documents":"{count} documents","workspace.aiAware.rows.documentsOfTotal":"{count} of {total} documents","workspace.aiAware.rows.documentsOne":"1 document","workspace.aiAware.rows.events":"{count} events","workspace.aiAware.rows.eventsOfTotal":"{count} of {total} events","workspace.aiAware.rows.eventsOne":"1 event","workspace.aiAware.rows.files":"{count} files","workspace.aiAware.rows.filesOfTotal":"{count} of {total} files","workspace.aiAware.rows.filesOne":"1 file","workspace.aiAware.rows.notes":"{count} notes","workspace.aiAware.rows.notesOfTotal":"{count} of {total} notes","workspace.aiAware.rows.notesOne":"1 note","workspace.aiAware.rows.rooms":"{count} rooms","workspace.aiAware.rows.roomsOfTotal":"{count} of {total} rooms","workspace.aiAware.rows.roomsOne":"1 room","workspace.aiAware.rows.tickets":"{count} tickets","workspace.aiAware.rows.ticketsOfTotal":"{count} of {total} tickets","workspace.aiAware.rows.ticketsOne":"1 ticket","workspace.aiAware.scopeOrg":"org \u201C{name}\u201D","workspace.aiAware.scopeTools":"workspace tools","workspace.aiAware.scopeWorkspace":"Workspace \u201C{name}\u201D","workspace.sharedResource.untitled":"Shared item","workspace.aiWidget.notice.noAccess":"You do not have access to the data this widget shows.","workspace.aiWidget.notice.sourceGone":"This widget reads a source that is no longer available.","workspace.home.summary.eventOne":"1 event today","workspace.home.summary.eventOther":"{count} events today","workspace.home.summary.mailOne":"1 unread email","workspace.home.summary.mailOther":"{count} unread emails","workspace.home.summary.notifOne":"1 unread notification in this workspace","workspace.home.summary.notifOther":"{count} unread notifications in this workspace","workspace.home.summary.none":"Nothing needs you right now.","workspace.home.summary.sentence":"You have {facts}.","workspace.home.summary.two":"{a} and {b}","workspace.home.summary.three":"{a}, {b} and {c}","workspace.home.summary.taskOne":"1 open task","workspace.home.summary.taskOther":"{count} open tasks","workspace.home.signals.taskOverdueOne":"1 overdue task","workspace.home.signals.taskOverdueOther":"{count} overdue tasks","workspace.home.signals.urgent":"Urgent","workspace.home.signals.attention":"Needs attention","workspace.home.brief.label":"Summary","workspace.home.brief.waiting":"Waiting on you: {facts}.","workspace.home.brief.also":"You also have {facts}.","workspace.home.brief.from":"from {time}","workspace.home.brief.updated":"Updated {time}","workspace.home.brief.openAsBoard":"Open as board","workspace.home.brief.boardPrompt":"Make a board of what needs me today: {facts}.","workspace.widget.action.add":"Add","workspace.widget.size.label":"Widget size","workspace.aiScope.overview":"Overview","workspace.aiScope.kindWorkspace":"Workspace","workspace.aiScope.group.suggested":"Suggested","workspace.aiScope.group.suggestedFor":"Suggested for {name}","workspace.aiScope.group.recent":"Recent","workspace.aiScope.intent.attention":"What needs attention here?","workspace.aiScope.intent.attentionPrompt":"What needs attention here ({name})? List what needs action first, and say why.","workspace.aiScope.intent.attentionApp":"What needs attention in {name}?","workspace.aiScope.intent.attentionAppPrompt":"What needs attention in {name} right now? List what needs action first, and say why.","workspace.aiScope.action.inspect":"Inspect & ask","workspace.aiScope.action.inspectHint":"Point at a widget or a section and ask about it","workspace.aiScope.action.summarize":"Summarize","workspace.aiScope.action.summarizeHint":"Summarize {name}","workspace.aiScope.action.board":"Build a board","workspace.aiScope.action.boardHint":"Build a board for {name}","workspace.aiScope.action.summarizePromptRecord":"Summarize {name}: what it is, where it stands and what comes next.","workspace.aiScope.action.summarizePromptPage":"Summarize this page ({name}): the key figures, what changed and what needs attention.","workspace.aiScope.action.summarizePromptApp":"Summarize {name}: the key figures, what changed and what needs attention.","workspace.aiScope.action.summarizePromptWorkspace":"Summarize the {name} workspace: the key figures across its apps, what changed and what needs attention.","workspace.aiScope.action.boardPromptRecord":"Build a board about {name}.","workspace.aiScope.action.boardPromptPage":"Build a board from this page ({name}).","workspace.aiScope.action.boardPromptApp":"Build a board for {name}.","workspace.aiScope.action.boardPromptWorkspace":"Build a board for the {name} workspace.","workspace.aiInspect.hint":"Point at a widget or a section, then click to ask about it.","workspace.aiInspect.pick":"Ask about this","workspace.aiInspect.untitled":"Selected part","workspace.aiCap.title":"What I can do for {name}","workspace.aiCap.intro":"Here is what I can do for {name}. Tap any line.","workspace.aiCap.ask":"Ask","workspace.aiCap.askExplain":"Questions I answer from the live data here","workspace.aiCap.askFallback":"What is going on here?","workspace.aiCap.askFallbackPrompt":"What is going on in {name}? Give me the key figures and what changed.","workspace.aiCap.do":"Do","workspace.aiCap.doExplain":"Changes I prepare for you. Nothing runs until you approve it.","workspace.aiCap.doPrompt":"Help me with this: {action}. Ask me for what you need, then propose it for my approval.","workspace.aiCap.build":"Build","workspace.aiCap.buildExplain":"Boards and widgets I can make from this data","workspace.aiCap.buildBoard":"A board for {name}","workspace.aiCap.buildBoardPrompt":"Build a board for {name}.","workspace.aiCap.buildWidgetPrompt":"Build a board with the {widget} widget.","workspace.aiCap.inspect":"Inspect","workspace.aiCap.inspectExplain":"Point at any widget or section and ask about it","workspace.aiCap.inspectStart":"Start inspecting","workspace.onboarding.welcomeTitle":"Welcome, {name}","workspace.onboarding.welcomeTitleNoName":"Welcome","workspace.onboarding.welcomeLead":"Let\u2019s make {workspace} feel like home. A few simple choices, and you\u2019re ready to go.","workspace.onboarding.wayAssistant":"Set up with the assistant","workspace.onboarding.wayAssistantHint":"Answer a few quick questions. Each answer applies right away.","workspace.onboarding.wayTour":"Take a quick tour","workspace.onboarding.wayTourHint":"A one-minute look at where everything is.","workspace.onboarding.replayHint":"Come back anytime: avatar menu \u2192 Replay onboarding.","workspace.onboarding.replayCaption":"Getting started","workspace.onboarding.replayAssistant":"Set up with the assistant","workspace.onboarding.replayTour":"Take the tour","workspace.onboarding.chat.title":"Set up your workspace","workspace.onboarding.chat.progress":"Question {n} of {total}","workspace.onboarding.chat.hello":"Hi {name}! I\'ll help you set up your workspace. Each answer applies right away, and you can skip any question.","workspace.onboarding.chat.helloNoName":"Hi! I\'ll help you set up your workspace. Each answer applies right away, and you can skip any question.","workspace.onboarding.chat.languageSet":"This workspace uses {language}. Your workspace admin chooses its language.","workspace.onboarding.chat.keepThis":"Keep it as it is","workspace.onboarding.chat.askTheme":"Do you like light or dark? Auto follows your device.","workspace.onboarding.chat.askSky":"Pick a background for your home.","workspace.onboarding.chat.askSummary":"How should your home sum up your day?","workspace.onboarding.chat.summaryBriefHint":"Two calm sentences about what needs you.","workspace.onboarding.chat.summarySignalsHint":"Four tiles with the numbers that matter.","workspace.onboarding.chat.askStrip":"Where should your app shortcuts go?","workspace.onboarding.chat.stripDock":"Above the widgets","workspace.onboarding.chat.stripDockHint":"One row of apps under the greeting.","workspace.onboarding.chat.stripRail":"Beside the widgets","workspace.onboarding.chat.stripRailHint":"A slim column of apps at the side.","workspace.onboarding.chat.stripOff":"Hide them","workspace.onboarding.chat.stripOffHint":"Open apps from the navbar only.","workspace.onboarding.chat.askTour":"All set! Do you want a quick tour of where everything is?","workspace.onboarding.chat.tourYes":"Start the tour","workspace.onboarding.chat.tourNo":"No, thanks","workspace.onboarding.chat.bye":"You are all set. Change any of this in Customize dashboard, or just ask me.","workspace.onboarding.chat.notSaved":"That one did not save. You can change it later in the settings.","workspace.onboarding.chat.skipQuestion":"Skip","workspace.onboarding.chat.skipSetup":"Skip setup","workspace.onboarding.chat.finish":"Start working","workspace.onboarding.chat.askLabel":"Ask the assistant","workspace.onboarding.chat.askPlaceholder":"Ask the assistant anything\u2026","workspace.onboarding.chat.askSend":"Send to the assistant","workspace.onboarding.tour.counter":"Step {n} of {total}","workspace.onboarding.tour.close":"Close the tour","workspace.onboarding.tour.skip":"Skip tour","workspace.onboarding.tour.done":"Done","workspace.onboarding.tour.appsTitle":"Your apps","workspace.onboarding.tour.appsText":"Every app of this workspace is one click away. The arrow opens the rest.","workspace.onboarding.tour.searchTitle":"Search everything","workspace.onboarding.tour.searchText":"Find people, tasks, files and messages from anywhere.","workspace.onboarding.tour.inboxTitle":"Stay in touch","workspace.onboarding.tour.inboxText":"Your direct messages, calls and notifications are here.","workspace.onboarding.tour.accountTitle":"Your account","workspace.onboarding.tour.accountText":"Your profile, settings, theme and dashboard controls live here. Choose Replay onboarding whenever you want another walkthrough.","workspace.onboarding.tour.stripTitle":"Quick launch","workspace.onboarding.tour.stripText":"Your apps, one press away. Reorder them in Customize dashboard.","workspace.onboarding.tour.composerTitle":"Ask the assistant","workspace.onboarding.tour.composerText":"Ask a question, or ask it to do something: find a file, create a task, build a page.","workspace.onboarding.tour.endEyebrow":"Tour","workspace.onboarding.tour.endTitle":"That\'s the tour","workspace.onboarding.tour.endText":"Explore at your own pace. Come back anytime: avatar menu \u2192 Replay onboarding.","workspace.onboarding.tour.appsTextPhone":"The Apps button opens every app of this workspace.","workspace.onboarding.tour.accountTextPhone":"Your account, search and your workspaces are in this menu.","workspace.onboarding.tour.composerTextPhone":"This button opens the assistant. Ask a question, or ask it to do something.","workspace.onboarding.replayWizard":"Run the setup again","workspace.onboarding.wizard.start":"Get started","workspace.onboarding.wizard.next":"Continue","workspace.onboarding.wizard.back":"Back","workspace.onboarding.wizard.progress":"Step {n} of {total}","workspace.onboarding.wizard.preparing":"Loading your preferences\u2026","workspace.onboarding.wizard.otherWays":"Or start another way","workspace.onboarding.wizard.appsTitle":"What belongs in your day?","workspace.onboarding.wizard.appsLead":"Keep your everyday tools close.","workspace.onboarding.wizard.appsAll":"Select all","workspace.onboarding.wizard.appsNone":"Clear","workspace.onboarding.wizard.appsCount":"{n} of {total} picked","workspace.onboarding.wizard.lookTitle":"Find your kind of calm.","workspace.onboarding.wizard.lookLead":"A theme for your screen and a background for your home.","workspace.onboarding.wizard.themeAutoHint":"Follows your device","workspace.onboarding.wizard.homeTitle":"A home that works for you.","workspace.onboarding.wizard.homeLead":"Start with a style, then choose where your shortcuts live.","workspace.onboarding.wizard.doneTitle":"Make yourself at home.","workspace.onboarding.wizard.doneLead":"Your choices are in place. Start exploring \u2014 you can keep shaping your space as you go.","workspace.onboarding.wizard.workTitle":"Your work","workspace.onboarding.wizard.workLead":"What does your business do? A preset adds the apps, channels and folders it needs. It only adds; nothing is removed.","workspace.onboarding.wizard.stackTitle":"Your apps","workspace.onboarding.wizard.stackLead":"These apps come with {preset}. Untick the ones you do not need, and tick any suggested app you want.","workspace.onboarding.wizard.stackLeadCustom":"Tick the apps your workspace needs.","workspace.onboarding.wizard.ideaTitle":"Your idea","workspace.onboarding.wizard.ideaLead":"Need an app we don\'t have? Describe it in one sentence.","workspace.onboarding.wizard.buildIdea":"Build my app","workspace.onboarding.wizard.doneIdea":"Your idea: {idea}","workspace.onboarding.work.custom":"Something else","workspace.onboarding.work.customHint":"Pick your own apps from the App Store.","workspace.onboarding.work.more":"More kinds of work","workspace.onboarding.work.moreHint":"See every industry that has a preset.","workspace.onboarding.work.applied":"Set up for {preset}","workspace.onboarding.work.appliedCustom":"Set up as a custom workspace","workspace.onboarding.work.appliedOther":"Set up from a preset","workspace.onboarding.work.applying":"Setting up {preset}\u2026","workspace.onboarding.work.applyingCustom":"Setting up your apps\u2026","workspace.onboarding.work.loading":"Loading the presets\u2026","workspace.onboarding.stack.loading":"Loading the apps\u2026","workspace.onboarding.stack.none":"There are no apps to pick here yet.","workspace.onboarding.stack.browse":"Find more in the App Store","workspace.onboarding.idea.label":"Your app idea","workspace.onboarding.idea.placeholder":"An app that\u2026","workspace.onboarding.idea.examples":"Examples","workspace.onboarding.idea.example1":"A form where clients book a call and pay a deposit","workspace.onboarding.idea.example2":"A list of the equipment we lend out, and when each piece comes back","workspace.onboarding.idea.example3":"A weekly report of the hours my team spends on each client","workspace.onboarding.idea.note":"Building starts when you finish and uses AI credits.","workspace.onboarding.setup.doneCustom":"Your apps are ready.","workspace.onboarding.setup.partialCustom":"Some apps could not install. Try again to add them.","workspace.onboarding.chat.askWork":"First: what does your business do? A preset sets up the apps, channels and folders it needs.","workspace.onboarding.chat.askIdea":"Need an app we don\'t have? Describe it in one sentence, or skip this.","workspace.onboarding.chat.ideaNext":"Got it. We start building it when you finish.","workspace.onboarding.chat.workSet":"This workspace is already set up for {preset}.","workspace.onboarding.chat.workSetCustom":"This workspace is already set up with the apps you picked.","workspace.onboarding.chat.workSetOther":"This workspace is already set up for your work.","workspace.appsHub.title":"Workspace apps","workspace.appsHub.lede":"Add-ons that run inside this workspace. Your team opens them from the apps menu.","workspace.appsHub.buildWithAi":"Build with AI","workspace.appsHub.browseStore":"Browse App Store","workspace.appsHub.section.installed":"Installed","workspace.appsHub.section.team":"Built by your team","workspace.appsHub.section.store":"From the App Store","workspace.appsHub.source.store":"App Store","workspace.appsHub.source.ai":"Built with AI","workspace.appsHub.source.custom":"Custom","workspace.appsHub.state.notInstalled":"Not installed","workspace.appsHub.channel.production":"Production","workspace.appsHub.channel.development":"Development","workspace.appsHub.action.open":"Open","workspace.appsHub.action.edit":"Edit","workspace.appsHub.action.manage":"Manage","workspace.appsHub.empty.title":"No workspace apps yet","workspace.appsHub.empty.body":"Install an app from the App Store or build one with AI.","workspace.appsHub.toWebsites":"Building a public website? Open Websites","workspace.widget.websites.title":"Websites","workspace.widget.deleteTitle":"Delete \u201C{title}\u201D?","workspace.widget.deleteSharedMessage":"It is shared to the workspace: it goes for everyone who sees it. You cannot bring it back.","workspace.agentMode.frameLabel":"Agent mode","workspace.agentMode.leave":"Leave Agent mode","workspace.agentMode.leaveShort":"Leave","workspace.agentMode.ui":"Human","workspace.agentMode.cli":"Agent","workspace.agentMode.switchLabel":"Human / Agent","workspace.agentMode.toggle":"Switch between Human and Agent (Ctrl+`)","workspace.agentMode.views":"Views","workspace.agentMode.apps":"Apps","workspace.agentMode.askAi":"Ask AI","workspace.agentMode.filter":"Filter","workspace.agentMode.loading":"Loading {view}\u2026","workspace.agentMode.retryKeys":"r retry  esc back","workspace.agentMode.nothingHere":"Nothing here yet.","workspace.agentMode.nothingMatches":"Nothing matches \\"{query}\\".","workspace.agentMode.nothingYet":"Nothing yet.","workspace.agentMode.partsFailed":"{count} part(s) could not load. Press r to retry.","workspace.agentMode.channels":"Channels","workspace.agentMode.pickChannel":"Pick a channel.","workspace.agentMode.noChannels":"No channels yet.","workspace.agentMode.noMessages":"No messages yet. Say hello.","workspace.agentMode.writeIn":"Press \u23CE to write in {channel}","workspace.agentMode.writeMessage":"Write a message","workspace.agentMode.assistantTitle":"Ask the workspace assistant","workspace.agentMode.assistantHint":"Type in the ASK AI bar below. Press a from any app to start.","workspace.agentMode.you":"You","workspace.agentMode.ai":"AI","workspace.agentMode.stopped":"Stopped.","workspace.agentMode.assistantFailed":"The assistant failed.","workspace.agentMode.noMatches":"No matches.","workspace.agentMode.hintPicker":"\u2191\u2193 \u23CE esc","workspace.agentMode.hintForm":"tab next  ^S save  esc cancel","workspace.agentMode.hintConfirm":"y / n","workspace.agentMode.hintHelp":"esc close","workspace.agentMode.startFailed":"Agent mode could not start. Choose Human above to return.","workspace.onboarding.learn.welcomeTitle":"A familiar place for a fresh start.","workspace.onboarding.learn.welcomeText":"Your apps, your daily overview, and a helpful assistant \u2014 together in one workspace.","workspace.onboarding.learn.appsTitle":"Your everyday essentials, within reach.","workspace.onboarding.learn.appsText":"Choose the apps you use most. You can find every available app in All apps whenever you need it.","workspace.onboarding.learn.lookTitle":"Make room for a little personality.","workspace.onboarding.learn.lookText":"These choices are just for you. Auto follows your device\u2019s light or dark appearance.","workspace.onboarding.learn.homeTitle":"A calmer start to every day.","workspace.onboarding.learn.homeText":"Widgets give you a quick view of your work. Open one to go deeper, and use Customize dashboard to arrange them.","workspace.onboarding.learn.doneTitle":"Ready when you are.","workspace.onboarding.learn.doneText":"Try the quick tour to find your way around, or open an app and make your first move.","workspace.onboarding.learn.assistantTitle":"A little help goes a long way.","workspace.onboarding.learn.assistantText":"Pick an answer to personalize your space, or ask the assistant a question in your own words.","workspace.onboarding.learn.workTitle":"This part is for the whole workspace.","workspace.onboarding.learn.stackTitle":"Apps for the whole team.","workspace.onboarding.learn.ideaTitle":"An app made for your work.","workspace.onboarding.journey.label":"Your setup journey","workspace.onboarding.journey.apps":"Essentials","workspace.onboarding.journey.look":"Your look","workspace.onboarding.journey.home":"Your home","workspace.onboarding.journey.work":"Your work","workspace.onboarding.journey.stack":"Your apps","workspace.onboarding.journey.idea":"Your idea","workspace.onboarding.journey.sideWorkspace":"For the workspace","workspace.onboarding.journey.sidePersonal":"For you","workspace.onboarding.ready.title":"Your workspace is ready","workspace.onboarding.ready.lead":"Fly, the Symbols setup assistant, set up {workspace} with you.","workspace.onboarding.ready.leadNoName":"Fly, the Symbols setup assistant, set up your workspace with you.","workspace.onboarding.ready.made":"What is ready","workspace.onboarding.ready.more":"{count} more apps","workspace.onboarding.ready.moreOne":"1 more app","workspace.onboarding.ready.siteDefault":"Website","workspace.onboarding.ready.ideaBuilding":"Building now","workspace.onboarding.preset.caption":"How do you like to start your day?","workspace.onboarding.preset.focus":"Keep me focused","workspace.onboarding.preset.focusHint":"A calm written brief, with your apps close by.","workspace.onboarding.preset.overview":"Give me the overview","workspace.onboarding.preset.overviewHint":"Key numbers at a glance, with your apps close by.","workspace.onboarding.studio.eyebrow":"A space for you","workspace.onboarding.studio.title":"Your work.\\nYour rhythm.","workspace.onboarding.studio.prompt":"Ask, find, or start something\u2026","workspace.onboarding.studio.caption":"A preview of your home. Your choices bring it to life.","workspace.addApp.chat.placeholder":"Describe your app, a workflow, or an idea\u2026","workspace.addApp.chat.idea1":"Task board","workspace.addApp.chat.idea2":"Meeting dashboard","workspace.addApp.chat.idea3":"Team directory","workspace.addApp.chat.idea4":"Notes hub","workspace.addApp.catalog.browse":"Browse apps","workspace.addApp.catalog.back":"Back to build","workspace.pobBuild.title":"Setting up {workspace}","workspace.pobBuild.titleNoName":"Setting up your workspace","workspace.pobBuild.lead":"Each card is a step we really did. It ticks when the step is done.","workspace.pobBuild.stepWorkspace":"Your workspace","workspace.pobBuild.stepProfile":"Your company profile","workspace.pobBuild.stepApps":"Your apps","workspace.pobBuild.stepRecords":"Your first records","workspace.pobBuild.stepSite":"Your website","workspace.pobBuild.workspaceDone":"Workspace created","workspace.pobBuild.profileDone":"We filled {count} profile fields from your website.","workspace.pobBuild.profileDoneOne":"We filled 1 profile field from your website.","workspace.pobBuild.appsDone":"Installed {count} apps","workspace.pobBuild.appsDoneOne":"Installed 1 app","workspace.pobBuild.appsSomeFailed":"Some apps did not install.","workspace.pobBuild.recordsDone":"Added {count} records","workspace.pobBuild.recordsDoneOne":"Added 1 record","workspace.pobBuild.siteDone":"Your site draft is ready","workspace.pobBuild.done":"Done","workspace.pobBuild.notDone":"Not done","workspace.pobBuild.running":"Working\u2026","workspace.pobBuild.pending":"Waiting\u2026","workspace.pobBuild.skipped":"Skipped","workspace.pobBuild.offered":"We found {count} products and services. You can import them next.","workspace.pobBuild.offeredOne":"We found 1 product or service. You can import it next.","workspace.pobBuild.offeredNone":"What we found waits for you as an import.","workspace.pobBuild.noOfferings":"We found no products or services on your website.","workspace.pobBuild.sitePending":"Your website offer waits for you in the assistant.","workspace.pobBuild.noSite":"We found no website to read.","workspace.pobBuild.noPreset":"No apps to install.","workspace.pobBuild.researchDeleted":"You deleted the research.","workspace.pobBuild.researchExpired":"The read of your website expired before sign-up.","workspace.pobBuild.researchNotDone":"The read of your website did not finish.","workspace.pobBuild.noResearch":"We did not read a website for this workspace.","workspace.pobBuild.see":"Open","workspace.pobBuild.seeApps":"See your apps","workspace.pobBuild.retryRefused":"This step cannot run again.","workspace.pobBuild.retryFailed":"Could not try again. Try again later.","workspace.pobBuild.timedOut":"Some steps still run. They go on while you work.","workspace.pobBuild.ready":"Your workspace is ready","workspace.pobBuild.open":"Open my workspace","workspace.pobThread.read":"What I read on {domain}","workspace.pobThread.readNoDomain":"What I read on your website","workspace.pobThread.profile":"Filled {count} fields of your company profile","workspace.pobThread.profileOne":"Filled 1 field of your company profile","workspace.pobThread.from":"from {place}","workspace.pobThread.review":"Review what I read","workspace.pobThread.reviewHide":"Hide what I read","workspace.pobThread.reviewDone":"Done","workspace.pobThread.reviewFailed":"Your review was not saved. Try again.","workspace.pobThread.delete":"Delete all research","workspace.pobThread.deleteTitle":"Delete all research?","workspace.pobThread.deleteMessage":"This deletes what research added: the profile values you did not change, the records it added and the people it found. Your workspace and your apps stay.","workspace.pobThread.deleted":"Research deleted: {fields} profile fields, {records} records, {people} people.","workspace.pobThread.deleteFailed":"The research was not deleted. Try again.","workspace.pobThread.deleteLine":"Delete: {line}","workspace.pobThread.deleteLineTitle":"Delete this part of the research?","workspace.pobThread.deleteLineMessage":"This deletes one part of what research added: {line}. The rest of the research, your workspace and your apps stay.","workspace.pobThread.lineDeleted":"Deleted: {line}.","workspace.pobThread.offers":"Three things wait for you. Nothing starts until you start it.","workspace.pobThread.soon":"Soon","workspace.pobThread.website":"Website","workspace.pobThread.websiteLead":"A website plan from what I read on {domain}.","workspace.pobThread.websiteLeadNone":"A website plan for your business.","workspace.pobThread.team":"Team","workspace.pobThread.teamLead":"I found {count} people on {page}.","workspace.pobThread.teamLeadOne":"I found 1 person on {page}.","workspace.pobThread.teamLeadNone":"Invite the people you work with.","workspace.pobThread.teamAction":"Invite your team","workspace.pobThread.imports":"Imports","workspace.pobThread.importsLeadNone":"Bring in a file or a table you already have.","workspace.pobThread.importsAction":"Start an import","workspace.pobThread.checklist":"Getting started","workspace.pobThread.checkProfile":"Review your profile","workspace.pobThread.checkWebsite":"Plan your website","workspace.pobThread.checkTeam":"Invite your team","workspace.pobThread.checkImport":"Import your data","workspace.pobThread.itemDone":"Done","workspace.pobThread.itemOpen":"Not done yet","workspace.pobThread.progress":"{n} of {total} done","workspace.gettingStarted.team.title":"Invite your team","workspace.gettingStarted.team.foundOn":"Found on","workspace.gettingStarted.team.why":"Why do I see this?","workspace.gettingStarted.team.whyText":"We read the names and roles on {page}. We did not look anywhere else. Rows you do not use are deleted after 30 days.","workspace.gettingStarted.team.listAria":"People found on your site","workspace.gettingStarted.team.switchAria":"Invite {name}","workspace.gettingStarted.team.emailPlaceholder":"Type their e-mail","workspace.gettingStarted.team.emailAria":"E-mail of {name}","workspace.gettingStarted.team.company":"Company e-mail","workspace.gettingStarted.team.remove":"Remove","workspace.gettingStarted.team.removeAria":"Remove {name} from this list","workspace.gettingStarted.team.invited":"Invited","workspace.gettingStarted.team.sent":"Invite sent","workspace.gettingStarted.team.failed":"This invite did not go out. Try again.","workspace.gettingStarted.team.invalidEmail":"This e-mail address is not valid.","workspace.gettingStarted.team.removeFailed":"We could not remove this row. Try again.","workspace.gettingStarted.team.other":"Invite someone else by e-mail","workspace.gettingStarted.team.otherPlaceholder":"Type an e-mail","workspace.gettingStarted.team.domainJoin":"Anyone with an @{domain} e-mail can join (they ask, you approve)","workspace.gettingStarted.team.domainJoinFailed":"The setting did not save. Try again.","workspace.gettingStarted.team.domainNotEligible":"Only an owner with a verified @{domain} e-mail can turn this on.","workspace.gettingStarted.team.send":"Send invites ({count})","workspace.gettingStarted.team.sending":"Sending\u2026","workspace.gettingStarted.team.result":"Invites sent: {sent}. Not sent: {failed}.","workspace.gettingStarted.team.resultAll":"Invites sent: {sent}.","workspace.gettingStarted.team.soonTitle":"Coming soon","workspace.gettingStarted.team.soonHint":"Here you will invite the people from your site\'s team page.","workspace.gettingStarted.team.deniedTitle":"Only workspace managers can see this","workspace.gettingStarted.team.deniedHint":"Ask a manager of this workspace to invite your team.","workspace.gettingStarted.team.errorTitle":"We could not load your team page","workspace.gettingStarted.team.emptyTitle":"We found no names on your site","workspace.gettingStarted.team.emptyHint":"Invite people by e-mail below.","workspace.gettingStarted.errorHint":"Check your connection, then try again.","workspace.gettingStarted.imports.title":"Import your data","workspace.gettingStarted.imports.intro":"Bring rows from a file or another source into your apps. Every row keeps its source.","workspace.gettingStarted.imports.sourcesTitle":"Other sources","workspace.gettingStarted.imports.preview":"Preview","workspace.gettingStarted.imports.previewAria":"Preview {name}","workspace.gettingStarted.imports.uploadTitle":"Upload a file","workspace.gettingStarted.imports.uploadHint":"CSV or Excel, up to 10 MB and 5,000 rows","workspace.gettingStarted.imports.reading":"Reading the file\u2026","workspace.gettingStarted.imports.errUnsupported":"Only CSV and Excel files can be imported.","workspace.gettingStarted.imports.errTooLarge":"This file is too large. The limit is 10 MB and 5,000 rows.","workspace.gettingStarted.imports.errNoTable":"We found no table in this file.","workspace.gettingStarted.imports.errPdfNotRead":"PDF tables are not read yet. Try a CSV or Excel file.","workspace.gettingStarted.imports.errExpired":"This file expired. Upload it again.","workspace.gettingStarted.imports.errSourceSoon":"This source is coming soon.","workspace.gettingStarted.imports.errUnavailable":"Imports are not ready yet. Try again later.","workspace.gettingStarted.imports.errFailed":"Something went wrong. Try again.","workspace.gettingStarted.imports.soonTitle":"Coming soon","workspace.gettingStarted.imports.soonHint":"Here you will bring rows from your files and other sources into your apps.","workspace.gettingStarted.imports.deniedTitle":"Only workspace managers can see this","workspace.gettingStarted.imports.deniedHint":"Ask a manager of this workspace to import your data.","workspace.gettingStarted.imports.errorTitle":"We could not load this page","workspace.gettingStarted.imports.rowCount":"Rows: {count}","workspace.gettingStarted.imports.importInto":"Import into","workspace.gettingStarted.imports.pickTarget":"Choose an app","workspace.gettingStarted.imports.noTargets":"First install an app that can keep these rows.","workspace.gettingStarted.imports.columnsAria":"Columns of this file","workspace.gettingStarted.imports.fieldAria":"Field for the column {column}","workspace.gettingStarted.imports.skip":"Skip this column","workspace.gettingStarted.imports.required":"(required)","workspace.gettingStarted.imports.newField":"Add as a new field","workspace.gettingStarted.imports.needRequired":"Pick a column for every required field.","workspace.gettingStarted.imports.needColumn":"Pick at least one column to import.","workspace.gettingStarted.imports.run":"Import rows ({count})","workspace.gettingStarted.imports.running":"Importing\u2026","workspace.gettingStarted.imports.done":"Added: {created}. Skipped: {skipped}. Failed: {failed}.","workspace.gettingStarted.imports.pending":"The import goes on in the background. Its result shows here later.","workspace.gettingStarted.imports.runFailed":"The import did not finish. Try again.","workspace.gettingStarted.imports.undo":"Undo","workspace.gettingStarted.imports.undoHint":"You can undo this import for 7 days.","workspace.gettingStarted.imports.undoTitle":"Undo this import?","workspace.gettingStarted.imports.undoMessage":"The rows it added are deleted from the app. Rows to delete: {created}. To bring them back, run the import again.","workspace.gettingStarted.imports.undoConfirm":"Undo import","workspace.gettingStarted.imports.undone":"The imported rows were removed.","workspace.gettingStarted.imports.undoFailed":"We could not undo this import. Try again."}');

});

parcelRegister("fPi8I", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("eiN62"))) : import("eiN62")).then(()=>parcelRequire('c5e9j'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("OeC5r", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("5SnfY"))) : import("5SnfY")).then(()=>parcelRequire('btKEx'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("lVzOA", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("i3q0o"))) : import("i3q0o")).then(()=>parcelRequire('ShDA6'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("bnQr0", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("iQtSI"))) : import("iQtSI")).then(()=>parcelRequire('8uovF'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7rxbI", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("eMrbA"))) : import("eMrbA")).then(()=>parcelRequire('dTAjx'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("h7ItO", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hGwbJ"))) : import("hGwbJ")).then(()=>parcelRequire('l5obg'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("626SV", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("4FI23"))) : import("4FI23")).then(()=>parcelRequire('lD6VI'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("4CBiU", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("datdi"))) : import("datdi")).then(()=>parcelRequire('bb2VH'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("eIAj4", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hb9K5"))) : import("hb9K5")).then(()=>parcelRequire('h5vb8'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("8Zrav", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9Ert3"))) : import("9Ert3")).then(()=>parcelRequire('ioxlu'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("cXRla", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("3BQXj"))) : import("3BQXj")).then(()=>parcelRequire('9F2CJ'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7RyXw", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9zOoF"))) : import("9zOoF")).then(()=>parcelRequire('78uaT'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("bKgxq", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("iTXfl"))) : import("iTXfl")).then(()=>parcelRequire('2rnZO'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("gSx0s", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("enfC8"))) : import("enfC8")).then(()=>parcelRequire('7byt9'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("aaeFI", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("3Nilm"))) : import("3Nilm")).then(()=>parcelRequire('1RjmD'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1vPnD", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("lceAU"))) : import("lceAU")).then(()=>parcelRequire('aty5v'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("3lJbd", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("erOub"))) : import("erOub")).then(()=>parcelRequire('f7KMh'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("iRcu3", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("b87oV"))) : import("b87oV")).then(()=>parcelRequire('l9hzg'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("lgumd", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("615Ul"))) : import("615Ul")).then(()=>parcelRequire('aHYiU'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("kDBAM", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6oDm6"))) : import("6oDm6")).then(()=>parcelRequire('f2J1g'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("dbpzZ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("16sVw"))) : import("16sVw")).then(()=>parcelRequire('2agcp'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1VxMM", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("947oQ"))) : import("947oQ")).then(()=>parcelRequire('lb1zc'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hUqGe", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("4tRQY"))) : import("4tRQY")).then(()=>parcelRequire('4AIcK'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("iM2jc", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("7kIUm"))) : import("7kIUm")).then(()=>parcelRequire('kAvj5'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("kal9z", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("2AiTo"))) : import("2AiTo")).then(()=>parcelRequire('dNM3g'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("9tA7b", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("96IrQ"))) : import("96IrQ")).then(()=>parcelRequire('kuTgr'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("g6mhP", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("k0gvl"))) : import("k0gvl")).then(()=>parcelRequire('8OhcJ'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});



parcelRegister("9TBFw", function(module, exports) {

$parcel$export(module.exports, "bootResolve", () => $7346785932273b76$export$cf29460a63543d47);
// bootResolve — boot step 2 of 3, ASYNC, mounts nothing.
//
// See bootPrepare.js for the one-boot design. This step waits for the SDK
// init, decides the theme mode (stored → user record → tenant default), runs
// the AUTH GATE (composite /core/boot or getMe; a rejected token logs out and
// bounces to /login), builds the auth snapshot (context.preResolvedAuth),
// reads the active org + workspace, and resolves + loads the interface
// language (step 7b).
//
// `state` is the object the boot writes its seed into: the parcel boot hands
// `context.state` (create() turns it into the root state); the published boot
// hands a fresh seed — the root state already exists there — and bootApply
// writes it onto the live root.
//
// Inputs: the context, bootPrepare's result, { state, publicSurface,
//   warmSnapshot, getWorkspaceCached, primeWorkspaceCache, apps, defaultApp,
//   resolvedManifest, fallbackRoute, mountEarly } — `mountEarly(themeMode)`
//   is the parcel composer's warm-start mount (null on the published shell).
// Returns { aborted, themeMode, lang, earlyShell, state, storage, completeWorkspaceAccess }:
//   aborted = the boot reached no session (a signed-out visitor, or a rejected one);
//   navigated = it also left the page (logout + /login, or the fresh-token reload);
//   completeWorkspaceAccess = null, or `(liveRoot) => Promise<boolean>` while the
//     boot's workspace record still owes the caller's `access` (step 7): hand it
//     the mounted root and the background read's answer reaches that root's
//     record through the record owner (true = merged).
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $h1nln = parcelRequire("h1nln");

var $iA4IC = parcelRequire("iA4IC");

var $fnRiS = parcelRequire("fnRiS");

var $kkyxm = parcelRequire("kkyxm");

var $3xVCk = parcelRequire("3xVCk");

var $cRTCE = parcelRequire("cRTCE");

var $grPR9 = parcelRequire("grPR9");

var $3gQso = parcelRequire("3gQso");

var $jH1GV = parcelRequire("jH1GV");

var $dEMgh = parcelRequire("dEMgh");

var $hGAnX = parcelRequire("hGAnX");

var $cvFPD = parcelRequire("cvFPD");

var $j7gGM = parcelRequire("j7gGM");

var $aNuMw = parcelRequire("aNuMw");

var $1tihf = parcelRequire("1tihf");

var $fDBlu = parcelRequire("fDBlu");

var $dot7l = parcelRequire("dot7l");

var $jhJrJ = parcelRequire("jhJrJ");

var $1Xpun = parcelRequire("1Xpun");

var $9juhh = parcelRequire("9juhh");

var $g3Ned = parcelRequire("g3Ned");

var $9IIym = parcelRequire("9IIym");
async function $7346785932273b76$export$cf29460a63543d47(context, prep, opts = {}) {
    const { publicSurface: publicSurface = false, warmSnapshot: warmSnapshot = null, getWorkspaceCached: getWorkspaceCached = null, primeWorkspaceCache: primeWorkspaceCache = null, apps: apps = null, defaultApp: defaultApp = null, resolvedManifest: resolvedManifest = null, fallbackRoute: fallbackRoute = '/', mountEarly: mountEarly = null, callDeadlineMs: // every network await of the gate is bounded (bootDeadline.js); a
    // caller (a test) may shorten it through `context.bootDeadlineMs`
    callDeadlineMs = context && context.bootDeadlineMs || (0, $1tihf.BOOT_CALL_DEADLINE_MS) } = opts;
    const state = opts.state || context.state;
    // WHITELABEL-STRICT-TENANT-SCOPE-1 — the TENANT a white-label host binds
    // this boot to, independent of its branding: `state.whitelabelHostScope`
    // (the scope object, or `false` = a customer host whose tenant could not be
    // established → no tenant renders), seeded by the workspace entry before
    // bootShell runs. The brand's ids stay the fallback for an entry that
    // predates that seed. `null` on platform hosts — every caller below is then
    // byte-identical to before. Inline (not module scope) for the same frank
    // reason as isTokenRejection below.
    const whitelabelHostScopeOf = ()=>{
        if (!state) return null;
        const scope = state.whitelabelHostScope;
        if (scope === false) return false;
        if (scope && scope.organizationId) return scope;
        const brand = state.whitelabelBrand;
        return brand && brand.organizationId ? brand : null;
    };
    const sdk = prep && prep.sdk;
    const lang = prep && prep.lang;
    const storage = prep && prep.storage;
    const _cachedWsLanguage = prep && prep.cachedWsLanguage;
    const _poly = prep && prep.poly || context.polyglot;
    let themeMode = prep && prep.themeMode;
    // THE SESSION'S TEXT SETS — the i18n namespaces a boot declares into
    // `_poly.namespaces`, the set `setLang` loads on every later language
    // switch. ONE computation for the TWO places that declare it:
    //   • step 7b, on every boot that reaches a session or a public surface;
    //   • the soft /login bounce of the auth gate, for a signed-out visitor.
    // That bounce returns before 7b. It used to leave bootPrepare's baseline
    // declared, so a sign-in on the login form (no reload) into a Georgian
    // workspace switched to ka and loaded the baseline only: twelve of the
    // shell's sets (canvas, chat, mail, meet, …) stayed English until a reload
    // (AI overhaul, sidebar finding 3 — Nika 2026-10-28, "fix in shared").
    //
    // It reads the CURRENT `window.location.pathname`, as 7b always did. The
    // bounce calls it BEFORE its replaceState, so it reads the page the visitor
    // asked for — the page `?next=` returns to after the sign-in.
    //
    // An inline const arrow, not a module-scope helper: the same frank reason
    // (FA204) as whitelabelHostScopeOf above.
    const sessionI18nNamespaces = ()=>{
        // Which namespaces this session needs. `common` always; then the running
        // app's own, from its manifest's `i18nNamespaces`; then `auth` on the
        // logged-out/login surfaces and `account` + `settings` where the account
        // pages boot.
        //
        // THIS IS THE MECHANISM, not a stub: the set computed here is what boot
        // loads and what a later `setLang` re-loads. Manifest namespaces are
        // INTERSECTED with the loader's registry (hasI18nBundle on the English base, derived by
        // `scripts/gen-i18n-registry.mjs` from what is on disk) so a manifest can
        // never ask for a bundle nobody has written. Adding `i18n/en/<ns>.json` and
        // running the generator is the whole of what makes a manifest's declaration
        // go live — there is no second list to update.
        //
        // ⚠️ THE INTERSECTION MUST BE LOUD. It used to drop an unknown namespace
        // in silence, which is exactly what hid the workspace shell declaring
        // `i18nNamespaces: ['workspace-project']` — a bundle nobody has written.
        // The shell therefore loaded `common` alone in every non-English language,
        // and a correctly-resolved Georgian boot still rendered an English page
        // because almost nothing on it was in `common`. A namespace a surface
        // declares must either LOAD or SAY SO. Warned once per (manifest,
        // namespace) per session, not per boot step, so it reads as one actionable
        // line rather than noise.
        //
        // Seeded from whatever the context already carries — the shared library
        // declares the shipped set, so a context bootShell never ran for still has
        // one. Route matching then NARROWS it, inside its own guard: it reads
        // manifests supplied by the caller, so a malformed `routes` entry is the
        // one thing here that could throw on input this function does not control,
        // and losing all of 7b to it would take the language config down with it.
        const _namespaces = new Set([
            'common',
            ..._poly.namespaces || []
        ]);
        try {
            const _path = typeof window !== 'undefined' ? window.location.pathname : fallbackRoute || '/';
            // ⚠️ MATCH THE APP PATH, NOT THE BROWSER PATH.
            //
            // A manifest's `routes` are written against the APP path
            // (`/^\/(tickets|chat|…)/`), while the browser URL carries the
            // `/w/<org>[/<ws-handle>]` tenancy prefix. Matched raw, NO manifest route
            // ever matched under `/w/…` — in silence — so the namespace set stayed at
            // its seed and a Georgian tickets board rendered its own strings in
            // English inside a translated shell. `routePathCandidates` offers the
            // readings, most specific first; the FIRST that hits any manifest wins,
            // so a stripped candidate can never eat a real first segment.
            const _candidates = (0, $9juhh.routePathCandidates)(_path);
            const _all = resolvedManifest ? [
                resolvedManifest
            ] : Object.values(apps || {});
            const _hits = (p)=>_all.filter((m)=>(m && m.routes || []).some((r)=>{
                        if (r instanceof RegExp) return r.test(p);
                        if (typeof r === 'string') return r === p;
                        return false;
                    }));
            // The DEFAULT app always counts, and a matched app is ADDED to it.
            //
            // Not an exclusive pick: the shell renders on every page — its navbar,
            // sidebar and dialogs sit behind whatever app owns the route — so its
            // strings are needed everywhere. And route claims overlap by design:
            // canvas declares `/^\/[^/]+\/[^/]+/` for its `/owner/project` editor
            // URL, which also matches `/tasks/epics`, so an exclusive first-match
            // handed the tickets board the canvas namespace ALONE and left it
            // English inside a Georgian shell (measured live, 2026-09-02).
            //
            // Route matching still earns its keep: it adds the namespaces of an app
            // that genuinely claims this path, on top of the shell's own.
            // UNION over every candidate, not the first that hits. A greedy route
            // otherwise steals an intermediate reading: on
            // `/w/natali/<ws>/marketplace` the candidate `/<ws>/marketplace` matches
            // canvas's two-segment editor route, so a first-match loop stopped there
            // and the App Store — whose own manifest claims `/marketplace` on the
            // NEXT candidate — never contributed its namespace, and the store stayed
            // English (measured live, 2026-09-03). Route claims are not exclusive,
            // and loading one namespace too many costs a small chunk, while loading
            // one too few is a surface in the wrong language.
            const _matched = [];
            for (const p of _candidates){
                for (const m of _hits(p))if (_matched.indexOf(m) === -1) _matched.push(m);
            }
            const _default = typeof defaultApp === 'string' ? (apps || {})[defaultApp] : defaultApp;
            const _manifests = _default ? [
                _default,
                ..._matched.filter((m)=>m !== _default)
            ] : _matched;
            for (const m of _manifests)for (const ns of m.i18nNamespaces || []){
                // a registered namespace has its English base bundle
                if ((0, $j7gGM.hasI18nBundle)((0, $cvFPD.DEFAULT_LANG), ns)) {
                    _namespaces.add(ns);
                    continue;
                }
                // Dropped — no such bundle on disk. Say it, once.
                const _seen = (typeof window !== 'undefined' ? window : globalThis).__i18nNsWarned || {};
                const _mark = `${m && m.key || '?'}/${ns}`;
                if (!_seen[_mark]) {
                    _seen[_mark] = true;
                    (typeof window !== 'undefined' ? window : globalThis).__i18nNsWarned = _seen;
                    console.warn(`[bootShell] manifest '${m && m.key || '?'}' declares i18n namespace ` + `'${ns}', which the loader registry does not have \u{2014} it is NOT loaded, ` + `so that surface stays English in every other language. Add ` + `packages/shared/i18n/en/${ns}.json (and the translated ones) and run ` + `node scripts/gen-i18n-registry.mjs, or declare a namespace that exists ` + `(packages/shared/i18n/en has the shipped set).`);
                }
            }
            // The auth chrome renders for a visitor with no user at all, so it cannot
            // wait for a scope fetch to tell it which strings it needs. This is a
            // STATE condition (`no user resolved`), not a guess about a path — and
            // `GUEST_ROUTE_RE` is the shared constant the guest surfaces already
            // share, not a list maintained here.
            const _isGuestPath = _candidates.some((p)=>(0, $hGAnX.GUEST_ROUTE_RE).test(p));
            if (!state?.user || _isGuestPath) _namespaces.add('auth');
        // ⚠️ THE PATH-PREFIX BRANCH IS GONE, ON PURPOSE.
        //
        // It read `/^\/(settings|profile|orgs|account)(\/|$)/` and added `account`
        // + `settings`. A hand-maintained regex over route prefixes was wrong
        // TWICE in one week: `/admin/…` does not match it, so a Georgian admin
        // read raw dotted keys (`settings.language.workspaceTitle`) across the
        // whole admin surface — which is why the new /admin/workspace-settings
        // page had to be written in plain English strings instead of keys. A
        // third route would have been wrong the same way, silently, because
        // English is bundled and resolves everywhere.
        //
        // A SURFACE DECLARES ITS NAMESPACES; NOTHING INFERS THEM FROM A URL.
        // There are exactly two declaration points now, and both are read above:
        //   • the app manifest's `i18nNamespaces` (packages/<app>/manifest.js) —
        //     the workspace manifest's own route list already covers `/admin/…`,
        //     so a page under it needs no separate declaration; and
        //   • `context.polyglot.namespaces` — the shared library's baseline
        //     (`common, auth, account, settings`), mirrored by `BOOT_NAMESPACES`
        //     in step 1b so it is present on BOTH mount paths.
        // A declared namespace that has no bundle now WARNS (above) instead of
        // vanishing. Admin pages have no manifest of their own and need none:
        // they are routes of the workspace-project app, whose manifest declares
        // them. A surface that ever DOES need its own set adds a manifest entry —
        // one declaration, in the package that owns the strings.
        } catch (err) {
            console.warn('[bootShell] i18n namespace routing failed:', err?.message || err);
        }
        return Array.from(_namespaces);
    };
    // FA204 / frank trap — self-contained inline copy of _isTokenRejection
    // (which itself inlines _causeChain), see the module-scope exports above
    // for the canonical shape kept alive for their own unit tests.
    function isTokenRejection(err) {
        function causeChain(err, maxDepth = 4) {
            const chain = [];
            let cur = err;
            for(let i = 0; cur && i < maxDepth; i++){
                chain.push(cur);
                cur = cur.cause;
            }
            return chain;
        }
        if (!err) return false;
        // A numeric status anywhere in the chain is the server's own answer: only
        // 401 (or the explicit `invalid_token` code) means the token was refused.
        // Any other status — a 500 whose message happens to read "No workspace…" /
        // "unauthorized" — is NOT a rejection, so the prose fallback below runs
        // only when no status exists at all (a session must never be purged on a
        // server error).
        let sawStatus = false;
        for (const e of causeChain(err)){
            const code = e?.code || e?.body?.code || e?.response?.body?.code;
            if (code === 'invalid_token') return true;
            const status = e?.status || e?.statusCode || e?.response?.status;
            if (status === 401) return true;
            if (typeof status === 'number') sawStatus = true;
        }
        if (sawStatus) return false;
        const s = String(err?.message || err || '');
        if (!s) return false;
        return /\binvalid (?:or expired )?(?:access )?token\b|\btoken (?:signature is invalid|has expired|is malformed|has been revoked)\b|\bno bearer token\b|\binvalid signature\b|signature[_\s]+mismatch|\bjwt (?:malformed|expired)\b|missing\s+(?:workspace|user|active[\s_]?workspace)?[\s_]*claim|no\s+(?:workspace|active workspace)|\bunauthor(?:i[sz]ed)?\b|HTTP 401\b|Request failed:.*401/i.test(s);
    }
    // AUTH-WIPE-1 (c): on the LOCAL channel only, a signature-class 401 is
    // indistinguishable from a mis-restarted dev API verifying with the
    // wrong JWT secret (every token classifies as `signature_mismatch`).
    // Treat it as INFRA — the server could not JUDGE the token — and fall
    // through to the existing _getMeUnresolved soft path: no purge, no
    // redirect, no retry loop. Signature-class ONLY: expired / revoked /
    // malformed / invalid_token 401s purge on every host, and every
    // non-'local' channel (development, next, staging, production, and
    // unknown/null) purges for everything, unchanged — fail-closed.
    // FA204 / frank trap — self-contained inline copy of the module-scope
    // `_isDevInfraSignatureWindow` export above (kept alive for its own
    // unit tests).
    function isDevInfraSignatureWindow(err) {
        if ((0, $grPR9.currentChannelFromHost)() !== 'local') return false;
        const reasons = [];
        const codes = [];
        const parts = [];
        let cur = err;
        for(let i = 0; cur && i < 4; i++){
            reasons.push(String(cur.reason || cur.body?.reason || cur.response?.body?.reason || ''));
            codes.push(String(cur.code || cur.body?.code || cur.response?.body?.code || ''));
            parts.push(String(cur.message || cur.body?.message || ''));
            cur = cur.cause;
        }
        // A KNOWN reason of any other class is decisive and fail-closed —
        // expired / revoked / malformed / missing still purge, even on local.
        // This is what makes "signature-class ONLY" true by CONSTRUCTION rather
        // than by prose matching.
        if (reasons.some((r)=>r && r !== 'signature_mismatch')) return false;
        if (reasons.includes('signature_mismatch')) return true;
        if (codes.includes('invalid_signature')) return true;
        // Prose fallback ONLY. Note `token signature is invalid` — the wording
        // authError.js actually sends. The bare `invalid signature` alternative
        // is jsonwebtoken's INTERNAL string, which the server consumes and
        // replaces; it is kept only for a raw/unenveloped path.
        return /\btoken signature is invalid\b|\binvalid signature\b|signature[_\s]+mismatch/i.test(parts.join(' '));
    }
    // Pre-resolve the full auth snapshot used to seed the shell's root state
    // synchronously inside `onCreate` BEFORE `subscribeAuthSession` registers
    // its async listener. Without this seed, the shell mounts with schema
    // defaults (signedIn=false, jwtClaims=null, orgs=[]) and any consumer
    // gated on those values flashes between mount and the first auth fire —
    // NoOrgOverlay was the most visible case (empty "create team" modal
    // appearing for a frame before orgs landed). Computation mirrors the
    // merge + drift-filter logic in subscribeAuthSession so the post-mount
    // auth subscription's first INITIAL_SESSION fire is a no-op diff.
    function resolveAuthSnapshot(me, opts = {}) {
        if (!me) return null;
        const mongoOrgs = Array.isArray(me.organizations) ? me.organizations : null;
        const claims = {
            ...me.app_metadata || {}
        };
        const claimsHasOrgs = Array.isArray(claims.orgs) && claims.orgs.length > 0;
        // Same fallback + drift-filter as subscribeAuthSession in
        // workspace/functions/auth.js (kept in sync — every change there
        // applies here too).
        if (!claimsHasOrgs && Array.isArray(mongoOrgs) && mongoOrgs.length > 0) claims.orgs = mongoOrgs;
        else if (claimsHasOrgs && Array.isArray(mongoOrgs)) {
            const mongoIds = new Set(mongoOrgs.map((o)=>String(o?.id || o?._id || '')).filter(Boolean));
            const filtered = claims.orgs.filter((o)=>mongoIds.has(String(o?.id || o?._id || '')));
            // Backfill Mongo-only orgs the governance bridge stripped (personal
            // orgs are dropped from app_metadata.orgs at mint time). Mongo's
            // OrgMember is canonical so anything there is a real membership.
            // Matches the union in subscribeAuthSession — keep these two in sync.
            const jwtIds = new Set(filtered.map((o)=>String(o?.id || o?._id || '')).filter(Boolean));
            const mongoOnly = mongoOrgs.filter((o)=>!jwtIds.has(String(o?.id || o?._id || '')));
            claims.orgs = mongoOnly.length ? [
                ...filtered,
                ...mongoOnly
            ] : filtered;
        }
        const orgsList = Array.isArray(claims.orgs) ? claims.orgs : [];
        let workspacesAll = Array.isArray(claims.workspaces) ? claims.workspaces : [];
        // URL-org pin (BOOT-RESHUFFLE F1). Mirror of auth.js resolveActiveOrgId's
        // MWT branch — "a tab's URL /w/<org-slug> PINS its org" — which this
        // snapshot never carried despite the kept-in-sync contract above. Without
        // it a cross-org /w/<slug> landing painted the PERSISTED org first and a
        // post-render switchOrg redid the whole boot in front of the user. The
        // caller passes the URL org's id only when it resolved to a MEMBER org,
        // plus that org's freshly-fetched workspace list (authoritative — the JWT
        // may carry none of them) so workspace/claims resolve INSIDE the URL org.
        const _urlPinRaw = opts.urlOrgId ? String(opts.urlOrgId) : null;
        const urlPinOrgId = _urlPinRaw && orgsList.some((o)=>String(o.id ?? o._id ?? '') === _urlPinRaw) ? _urlPinRaw : null;
        if (urlPinOrgId && Array.isArray(opts.urlOrgWorkspaces) && opts.urlOrgWorkspaces.length) {
            const fetchedIds = new Set(opts.urlOrgWorkspaces.map((w)=>String(w.id)));
            workspacesAll = [
                ...opts.urlOrgWorkspaces,
                ...workspacesAll.filter((w)=>!fetchedIds.has(String(w.id)))
            ];
        }
        const activeWs = claims?.active_workspace_id || '';
        // List-shaped (JWT claims row — no `settings`). Stamped so downstream
        // `setActiveWorkspaceRecord` never mistakes it for a complete record; the
        // `_bootWsMatches` / eager-`getWorkspace` blocks below correct `snap.workspace`
        // to the full record when they resolve (see tickets/spec-workspace-record-shape.md).
        let workspace = (0, $9IIym.stampWorkspaceShape)(workspacesAll.find((w)=>w.id === activeWs) || null, 'list');
        // Active-org resolution: URL pin wins (see above), then Mongo
        // source-of-truth (User.activeOrganization), then the app_metadata claims,
        // then orgs[0]. Validates membership against orgsList.
        const has = (id)=>!!id && orgsList.some((o)=>o.id === id);
        const mongoActiveOrgId = me.activeOrganization ? String(me.activeOrganization) : null;
        const govActiveOrgId = workspace?.org_id || claims.workspace_org_id || null;
        let activeOrgId = null;
        if (urlPinOrgId) activeOrgId = urlPinOrgId;
        else if (has(mongoActiveOrgId)) activeOrgId = mongoActiveOrgId;
        else if (has(govActiveOrgId)) activeOrgId = govActiveOrgId;
        else activeOrgId = (0, $dot7l.visibleOrgs)(orgsList)[0]?.id || null;
        if (activeOrgId) claims.workspace_org_id = activeOrgId;
        const org = activeOrgId ? orgsList.find((o)=>o.id === activeOrgId) || null : null;
        // Cross-org workspace drift defense. `claims.active_workspace_id` and
        // `claims.workspaces` are JWT-scoped — neither is re-minted on every
        // `sdk.setActiveOrganization`. When the user switches orgs, Mongo's
        // `User.activeOrganization` updates first; the JWT lags until next refresh.
        // In that window `active_workspace_id` can point at a workspace IN THE
        // PREVIOUS ORG, and `claims.workspaces` can carry workspaces from every
        // org the user has ever touched. Surfacing either under the resolved
        // active org leaks the wrong org's data into every downstream consumer
        // that scopes by `workspace.id` — loadPrivateData, _activeWorkspaceProjects,
        // workspace switcher dropdowns, anything reading state.workspace.*.
        // Scope to the active org and re-resolve activeWorkspace against the
        // scoped list, falling back to its first entry if the JWT's pointer is
        // stale.
        const inActiveOrg = (w)=>!activeOrgId || w && String(w.org_id || w.organization_id || w.organization) === String(activeOrgId);
        const workspacesList = activeOrgId ? workspacesAll.filter(inActiveOrg) : workspacesAll;
        if (workspace && !inActiveOrg(workspace)) {
            workspace = workspacesList[0] || null;
            // ONE identity — mirror of the auth tick's drift correction (auth.js
            // nextClaims.active_workspace_id re-stamp): when the claim's workspace was
            // foreign-org and got re-picked in-org, the claim mirror MUST follow, or
            // every claim-reading consumer (fetch scope, dashboard-prefs pinning,
            // chat scoping) stays keyed to the OTHER org's workspace from first paint.
            if (workspace?.id) claims.active_workspace_id = String(workspace.id);
        }
        // localStorage.activeWorkspace is the canonical client pointer for the chosen
        // workspace. The JWT's `active_workspace_id` is NOT re-minted on an in-org
        // workspace switch — sdk.switchWorkspace only invalidates the claims cache and
        // writes localStorage — so after a switch + refresh the JWT (via getMe) still
        // names the PREVIOUS workspace. Without this, that stale-but-present claim wins
        // and the switch silently reverts on refresh. Prefer the LS pointer whenever
        // it resolves to a workspace in the active org's scoped list; otherwise keep
        // the JWT-resolved workspace and let the normalize block below backfill an
        // empty claim (the OAuth path, where the claim is genuinely absent).
        try {
            const lsActiveWs = (0, $jhJrJ.getActiveWorkspacePointer)() || '';
            if (lsActiveWs && String(lsActiveWs) !== String(claims.active_workspace_id)) {
                const lsWorkspace = workspacesList.find((w)=>String(w.id) === String(lsActiveWs));
                if (lsWorkspace) {
                    workspace = lsWorkspace;
                    claims.active_workspace_id = lsActiveWs;
                }
            }
        } catch (_) {}
        // Normalize `active_workspace_id` across auth providers. The claim may be
        // absent from `app_metadata` (Google/OAuth sign-ins, fresh accounts), so
        // `activeWs` can be ''.
        // Downstream surfaces key off `jwtClaims.active_workspace_id` (home's
        // _wsScope dashboard cache, _activeWorkspaceProjects, loadPrivateData),
        // so when it's empty the home falls back to a DIFFERENT scope ('default'
        // vs the real ws id) and renders a different saved layout per provider
        // (#auth-provider-home-diff). Backfill from the resolved workspace, the
        // canonical localStorage pointer, or the first scoped workspace so both
        // providers resolve the SAME scope from first paint.
        if (!claims.active_workspace_id) {
            let lsActiveWs = '';
            try {
                lsActiveWs = (0, $jhJrJ.getActiveWorkspacePointer)() || '';
            } catch (_) {
                lsActiveWs = '';
            }
            // localStorage.activeWorkspace is the canonical client pointer (the JWT
            // claim goes stale on org switch — see org-switcher notes). Prefer a
            // resolved workspace, then the LS pointer (trusted even when the scoped
            // list hasn't hydrated yet, the OAuth worst case), then the first scoped
            // workspace.
            //
            // P0 tenant isolation (tickets/fable.md 2026-08-14): on a URL-PINNED
            // cross-org boot (`urlPinOrgId` set — the address bar names a different
            // member org than the pointer's), the un-validated pointer is KNOWN to
            // be suspect: it names the PREVIOUS tenant's workspace. Blind-trusting
            // it here stamped that foreign workspace id into
            // `claims.active_workspace_id` — the exact claim mirror every
            // downstream scope consumer (loadPrivateData, fetch scoping, dashboard
            // prefs) keys off — while `org` said the URL org. Trust the pointer on
            // a pinned boot only when it resolves INSIDE the pinned org's list;
            // otherwise leave the claim for the scoped list / auth tick to fill.
            const lsTrusted = !!lsActiveWs && (!urlPinOrgId || workspacesList.some((w)=>String(w.id) === String(lsActiveWs)));
            // CROSS-DEVICE POINTER (WS-ACTIVE-WS-NOT-PORTABLE-1) — `me.activeWorkspace`
            // is the SERVER-persisted choice on the User doc, written by
            // `sdk.switchWorkspace` -> `sdk.setActiveWorkspace` ->
            // `PATCH /auth/me/active-workspace` on every switch (that write is
            // unconditional and throws on failure, so the field is kept current).
            // It was already returned in the `/auth/me` payload and simply never
            // read here, so a browser with no `localStorage.activeWorkspace` — a
            // DIFFERENT ORIGIN (workspace.localhost vs dev.my.symbols.app), a
            // second machine, a new profile, a cleared cache — silently fell
            // through to `workspacesList[0]`, an ARBITRARY workspace. Measured:
            // a user whose list is [Company, personal, Symbols Intranet] landed in
            // Company (4 chat channels) instead of Symbols Intranet (67), which
            // reads to the user as "my channels are gone".
            //
            // Ordered AFTER the localStorage pointer deliberately: the local
            // pointer is this device's most recent explicit intent, so behaviour
            // is byte-identical whenever it is present. This only replaces the
            // arbitrary first-in-list fallback.
            //
            // ALWAYS validated against the scoped list — stricter than `lsTrusted`,
            // which only validates on a URL-pinned boot. A server id can name a
            // workspace whose membership was since revoked; an unvalidated one
            // would pin the boot to a workspace the user can no longer read.
            const serverActiveWs = String(me.activeWorkspace || '');
            const serverTrusted = !!serverActiveWs && workspacesList.some((w)=>String(w.id) === String(serverActiveWs));
            const normalizedWs = workspace && workspace.id || (lsTrusted ? lsActiveWs : '') || (serverTrusted ? serverActiveWs : '') || workspacesList[0] && workspacesList[0].id || '';
            if (normalizedWs) {
                claims.active_workspace_id = normalizedWs;
                if (!workspace) workspace = workspacesList.find((w)=>String(w.id) === String(normalizedWs)) || workspace;
            }
        }
        return {
            signedIn: true,
            jwtClaims: claims,
            orgs: orgsList,
            // List-shaped rows (JWT claims — no `settings`). See
            // tickets/spec-workspace-record-shape.md §4a.
            workspaces: (0, $9IIym.stampWorkspaceListShape)(workspacesList),
            org: org,
            workspace: workspace,
            currentUserEmail: me.email || '',
            currentUserId: me._id || me.id || '',
            currentUserUsername: me.username || '',
            // Legacy external auth UUID. Pre-resolving on the boot snapshot
            // means host-only gates that compare `room.created_by` against the
            // legacy id (meet rooms, canvas pages, migrated rows) match
            // correctly from the first paint — no flash where the host's own
            // SettingsBtn / EndRoomBtn render hidden because root state only
            // had the Mongo _id loaded.
            currentUserSupabaseId: me.supabaseUserId || '',
            // Demo-session flag. `getMe()` returns `isDemo: true` for sandbox
            // demo accounts (the server clears it once the user claims the
            // workspace via /demo/claim). Seeded here so DemoClaimBanner can
            // gate its visibility on `root.isDemo` from the first paint — the
            // banner is invisible to every real user and only appears for an
            // unclaimed demo session.
            isDemo: !!me.isDemo
        };
    }
    // Warm-start PAINT half (tickets/opus.md "boot: the scope-keyed warm-start
    // snapshot's PAINT half was never built"; storage half + full design:
    // packages/workspace/functions/bootSnapshot.js). Nika granted permission to
    // edit this file for this change, 2026-08-09 — conditions: test in a real
    // cold browser, clean the file while in here, re-measure (tickets/workspace.md
    // "boot: scope-keyed warm-start snapshot"). Scope of the grant is THIS
    // change, not a standing license on packages/shared/.
    //
    // Builds the SAME shape `resolveAuthSnapshot` returns, but from an
    // ALREADY-VALIDATED cached row (`warmSnapshot`, resolved by the caller via
    // bootSnapshot.js's `resolveWarmBootSnapshot()` — this function does no
    // scope judgment of its own; that lives in the package that owns the
    // isolation contract + its own test suite). Deliberately narrower than the
    // live snapshot: the cache is chrome-only (org, workspace, sibling lists,
    // current-user identity — see bootSnapshot.js's own "CONTENT" note), so
    // `currentUserSupabaseId` / `isDemo` default to their safe values here and
    // get corrected the moment the REAL `getMe()`/`boot()` response lands and
    // reconciles over this seed (see the warm-start block below, and the
    // reconcile at "8. Mount shell").
    //
    // `workspace` is stamped 'list'-shaped, NEVER 'full' — the cache never
    // stores `settings`, so treating it as complete would let an unconfirmed
    // guess paint as authoritative (the constraint `MAX_SNAPSHOT_ENTRIES`'s
    // sibling comments call out repeatedly). Stamping it 'list' means the
    // EXISTING full-record upgrade machinery (setActiveWorkspaceRecord, the
    // composite-boot / eager-getWorkspace branches a few hundred lines down)
    // treats this exactly like an ordinary claims-derived workspace mid-upgrade
    // — no new upgrade path needed, just the existing one doing its job.
    function authSnapshotFromCache(snap) {
        if (!snap || !snap.userId || !snap.orgId || !snap.workspaceId) return null;
        const orgs = Array.isArray(snap.orgs) ? snap.orgs : [];
        const workspaces = (0, $9IIym.stampWorkspaceListShape)(Array.isArray(snap.workspaces) ? snap.workspaces : []);
        return {
            signedIn: true,
            jwtClaims: {
                orgs: orgs,
                workspaces: workspaces,
                active_workspace_id: String(snap.workspaceId),
                workspace_org_id: String(snap.orgId)
            },
            orgs: orgs,
            workspaces: workspaces,
            org: snap.org || null,
            workspace: snap.workspace ? (0, $9IIym.stampWorkspaceShape)((0, $9IIym.normalizeWorkspaceRecord)({
                ...snap.workspace
            }), 'list') : null,
            currentUserEmail: snap.currentUserEmail || '',
            currentUserId: String(snap.userId),
            currentUserUsername: snap.currentUserUsername || '',
            currentUserSupabaseId: '',
            isDemo: false
        };
    }
    // 5. Theme mode — WS-THEME-BOOT-WRONG-MODE-1. Full mechanism + why the
    // pre-flight must stay bounded: themeMode.js (`resolveBootThemeMode`).
    // `let themeMode` above (not `const`) so this reassignment is the ONLY
    // place that needs to change: every later read of `themeMode` in this
    // function (both `globalTheme` seeds passed to smbls — the warm-start
    // early mount and the cold mount) picks up the correction automatically.
    //
    // ⚠️ This block sits HERE, after Pattern-B SDK instantiation, on purpose.
    // The workspace shell never passes `sdk` into bootShell — `sdk` is only
    // assigned a few lines up (`sdk = getSDK()`). The first version of this
    // pre-flight ran before that assignment, so `sdk` was `undefined` for the
    // exact consumer it was written for and `resolveBootThemeMode` returned
    // on its `!sdk` guard every time — dead code that shipped green
    // (measured on the deployed shell, 2026-08-19). The SDK proxy awaits its
    // own init before dispatching, so `sdk.execute` is safe this early; the
    // 300ms race bounds the whole thing. Pinned by
    // bootShell.themeBootWiring.test.js — keep it after `sdk = getSDK()`.
    const rawThemeModeAbsent = (0, $3gQso.hasNoStoredThemeMode)(storage) === true;
    // ⚠️ SIGNED-OUT BOOT pays nothing. `/core/prefs/user` is an AUTHED endpoint,
    // and the /login screen has no session: measured on app.bellforge.eu
    // 2026-09-01, the pre-flight fired GET /core/prefs/user → 401 on the login
    // page, before any seat click, and then sat on the 300 ms race for an answer
    // that could never arrive. A visitor with no session also has no stored
    // preference to fetch, so the whole pre-flight is dead work there. Same
    // credential pair the auth snapshot reads further down (`_hasSdkToken`);
    // read defensively, because a storage-blocked context must boot, and a
    // false negative only costs the OS guess the timeout arm already returns.
    let _hasBootSession = false;
    try {
        _hasBootSession = typeof window !== 'undefined' && !!(window.localStorage.getItem('symbols_access_token') || window.localStorage.getItem('symbols_bridge_access_token'));
    } catch (_) {
        _hasBootSession = false;
    }
    const themeModeDecision = await (0, $3gQso.resolveBootThemeMode)({
        themeMode: themeMode,
        rawKeyAbsent: rawThemeModeAbsent,
        sdk: sdk,
        signedIn: _hasBootSession
    });
    themeMode = themeModeDecision.mode;
    if (themeModeDecision.applied) (0, $3gQso.writeStoredThemeMode)(themeMode);
    // 5b. TENANT DEFAULT THEME — "make bellforge workspace light by default,
    // overriding the user's system preference" (Nika); GreenIG "Dark theme by
    // default" (Nika 2026-10-18). Precedence, highest first: the user's OWN
    // choice → the workspace record's default → this tenant's brand default →
    // the OS.
    //
    // ⚠️ APPLIED AT THE BOOT SEED, deliberately NOT on the mounted app. The
    // first attempt lived in applyWorkspaceConfig and called
    // `changeGlobalTheme` after mount; it is parked there
    // (WORKSPACE_DEFAULT_THEME_ENABLED) because re-theming a mounted app
    // re-applies the design system across the whole tree. Seeding `themeMode`
    // here costs nothing — the value flows straight into the `globalTheme`
    // handed to smbls at create(), and into `themeResolved` just below, so
    // the FIRST paint is already correct and there is no flip to watch.
    //
    // ⚠️ Reads the BRAND and the workspace RECORD's own `settings.theme` —
    // never through `resolveWorkspaceConfig`: for a full-takeover client
    // module (bellforge, greenig) that returns early from
    // `{ ...DEFAULT_CONFIG, ...project.config }` and never reaches the branch
    // that carries `settings.theme`, so the record is read raw (the warm
    // snapshot's cached copy below, the full record at 7c). The brand is
    // already here: the workspace entry awaits
    // `seedWhitelabelBrand(state)` BEFORE calling bootShell, and the
    // branded login already treats `branding.theme` as the tenant's scheme —
    // so this makes the signed-in app agree with the login screen instead of
    // disagreeing with it.
    //
    // NEVER persisted — a tenant default is not a choice the user made, so
    // `writeStoredThemeMode` is not called here. Deciding again on every boot
    // is exactly what lets a later explicit user choice win permanently, and
    // what lets the default disappear if the tenant drops it.
    // Two sources, in this order, and the SECOND is the one that usually wins.
    //
    // `seedWhitelabelBrand` is bounded at 600ms so a slow lookup can never delay
    // the mount — which means on a slow resolve `state.whitelabelBrand`
    // is simply ABSENT here and the brand only lands later via
    // `applyWhitelabelBrandLate`. Measured on the deployed app: the surface
    // painted light (the module's own surfaces) while `data-theme` still read
    // `dark`, because this seed had nothing to read. The fix is not a longer
    // timeout — that would trade a wrong colour for a slower boot.
    //
    // So fall back to the host-keyed boot identity the brand resolver persisted
    // on the previous visit (whitelabelBrand.js `cacheWhitelabelBootIdentity`).
    // It is synchronous, needs no network, and is the same value index.html's
    // head script already used to stamp `data-theme` before first paint — so the
    // attribute and the framework's globalTheme now agree instead of disagreeing.
    // Normalised BEFORE the fallback: `brand.theme` can legitimately be a value
    // this seed cannot use (a theme NAME, or 'auto'), and a truthy-but-unusable
    // value would short-circuit the `||` and silently skip the cache.
    const seededBrandTheme = state && state.whitelabelBrand ? state.whitelabelBrand.theme : null;
    const brandThemeMode = seededBrandTheme === 'light' || seededBrandTheme === 'dark' ? seededBrandTheme : (0, $3gQso.readTenantBootThemeMode)();
    const userChoseTheme = (0, $3gQso.userHasOwnThemeChoice)({
        rawStoredKeyAbsent: rawThemeModeAbsent,
        // `applied` means resolveBootThemeMode took the value off the USER
        // record, which is itself an explicit choice made on some device.
        userRecordMode: themeModeDecision.applied ? themeMode : null
    });
    // The user's / the OS's answer — the base every tenant layer falls back to,
    // kept for the cold seed (7c) to decide again from the full record.
    const themeBase = themeMode;
    // THE WORKSPACE'S OWN DEFAULT (`workspace.settings.theme = { mode }` —
    // GreenIG's dark, Nika 2026-10-18) outranks the brand: the more specific
    // tenant layer. Here, for the WARM mount, from its snapshot (bootSnapshot.js
    // `workspaceTheme`, cached off the full record of this scope's last settled
    // boot); the cold mount decides again from the full record at 7c.
    themeMode = (0, $3gQso.bootTenantThemeMode)({
        baseMode: themeBase,
        userChoseExplicitly: userChoseTheme,
        workspaceMode: warmSnapshot ? warmSnapshot.workspaceTheme : null,
        brandMode: brandThemeMode
    });
    if (state) {
        state.themeMode = themeMode;
        // Reactive RESOLUTION carrier (themeResolved.js, tickets/opus.md
        // "DECIDED: themeResolved") — `themeMode` above is the MODE, never the
        // resolved 'dark'|'light'. Seeds the schema default here (mirrors the
        // themeMode seed one line up); `watchThemeResolved` (wired on the
        // RESOLVED shell element, step 8 below) keeps it live for the rest of
        // the session, including 'auto' OS flips scratch's own listener applies
        // with no other trigger.
        if (typeof document !== 'undefined') state.themeResolved = (0, $dEMgh.resolveThemeResolvedNow)(document, themeMode);
    }
    // 6. Auth gate — public auth routes must render to unauthed users
    // MUST await SDK init before reading service-proxied methods: the SDK
    // populates flat method proxies (sdk.getMe, sdk.login, …) inside
    // _createServiceProxies which only runs during initialize(). Without
    // this await, sdk.getMe() can be undefined → TypeError → bounce to
    // /login even though localStorage tokens are valid. (Cookies are
    // dropped on .localhost by Chrome — localStorage is the source of
    // truth in dev.)
    // `auth/magic-callback`, `auth/callback`, `github-auth-callback` all land
    // BEFORE the user has tokens in localStorage — the callback page is the
    // one that PERSISTS them. Treat as public so bootShell doesn't pre-empt
    // it with a /login redirect (which would also strip the URL hash that
    // carries the tokens).
    // `/user/:slug` and `/u/:slug` are public-facing community profile
    // pages — visitors browsing the marketplace feed land here when they
    // click an author. Bouncing to /login would break the shareable link.
    // `/marketplace` (+ subpaths) and `/feed` are publicly browsable —
    // anonymous visitors can view the catalog and editorial feed. The
    // Install / Use flow opens MarketplaceSigninModal (gated on
    // host.signinModal); a successful sign-in re-dispatches the pending
    // install via host._pendingInstall (see MarketplaceIsland's state
    // shape). Without that public access, the only way to discover the
    // marketplace before signup was a deep-link share — which then
    // redirected away before render.
    // meet-guest + _session-bridge are anonymous-by-design surfaces (the
    // waiting-room join form / the cross-app token hop). Without them here
    // bootShell's `!me` branch replaceState'd anonymous guests to /login —
    // the exact "guest link asks for signup" report (2026-06-10): the
    // route-level redirectIfUnauthed allowlists them, but this regex is
    // the SECOND gate and it bounced anyway.
    // Canonical guest-route allowlist (shared with workspace/app.js's SPA
    // route-change guard so the load-gate + nav-guard can't drift) — see
    // ./guestRoutes.js.
    const PUBLIC_AUTH_ROUTE = (0, $hGAnX.GUEST_ROUTE_RE);
    // Warm-start PAINT half — the shell element mounted early from
    // `warmSnapshot`, if any (see the block below, right after
    // `_forceLogoutAndReauth`, for the actual attempt). Declared here (ahead
    // of that function) so it can dispose an abandoned early mount before
    // hard-redirecting — an early-mounted root left behind in `document.body`
    // when the REAL auth gate then bounces to /login would double-mount
    // alongside whatever the caller mounts next (workspace/index.js's own
    // `!shell` fallback).
    let _earlyShell = null;
    const _disposeEarlyShell = ()=>{
        if (!_earlyShell) return;
        try {
            _earlyShell.remove();
        } catch (err) {
            console.warn('[bootShell] failed to dispose abandoned warm-start shell:', err?.message || err);
        }
        _earlyShell = null;
    };
    // Auth recovery: server-rejected tokens must be wiped before /login,
    // otherwise the next page boot re-uses the poisoned credential and the
    // user is trapped in a refresh-loop on /login. `_isTokenRejection` /
    // `_causeChain` are module-scope pure helpers (see above `bootShell`) —
    // hoisted out of this closure so they're independently unit-testable.
    // Hard-reload to /login after wiping sdk state + auth storage. Uses
    // the shared purgeAuthStorage() helper so the pre-mount logout path
    // here and the post-mount switchers/logout.js clear the same set of
    // keys (sb-*, symbols_*, sdk_only retry flag).
    //
    // BRIDGE PEER FIRST (2026-10-09): the server REJECTED this origin's token.
    // On a shell <-> canvas pair the session may be borrowed from the peer
    // (`/_session-bridge` hands over the ACCESS token only; the owner keeps the
    // refresh token and rotates it). Before purging and sending the user to
    // /login, ask the peer's bridge ONCE (sessionBridgeReacquire.js). The token
    // the server just refused is passed as `rejectedToken`: a reply with that
    // same token is no session, however fresh its local expiry looks. A new
    // token is written to storage and THIS tab reloads once, so the SDK re-inits
    // from it. The 60 s latch (`symbols_bridge_reask_at`, per tab) stops a
    // reload loop when the peer's token is rejected too.
    const _forceLogoutAndReauth = async (reason)=>{
        context.bootSignedIn = false;
        if (typeof window === 'undefined') return {
            aborted: true,
            navigated: true,
            signedIn: false
        };
        try {
            const _bk = 'symbols_bridge_reask_at';
            const _lastAsk = Number(window.sessionStorage.getItem(_bk) || 0);
            // ONLY a session adopted from the bridge asks it again (review M2): the
            // origin that owns its login (its own refresh token, no
            // `symbols_session_source: 'bridge'` marker) signs out when the server
            // refuses it — revoked, suspended, sign-out-everywhere — and never
            // borrows the peer's token.
            // Review D1 (Nika: "No, avoid the sign-out"): a refresh token without
            // the 'own' mark on the BORROWING origin (the canvas) is a copy an older
            // bridge build handed over — it asks the bridge too, instead of signing
            // the user out. A session with no refresh token AND no mark never asks
            // (review T1 / D4).
            const _src = window.localStorage.getItem('symbols_session_source');
            const _refresh = window.localStorage.getItem('symbols_refresh_token');
            const _adoptedFromBridge = _src === 'bridge' && !_refresh || !!_refresh && _src !== 'own' && typeof (0, $3xVCk.isSessionBridgeBorrower) === 'function' && (0, $3xVCk.isSessionBridgeBorrower)();
            if (_adoptedFromBridge && typeof (0, $kkyxm.reacquireBridgeSession) === 'function' && Date.now() - _lastAsk > 60000) {
                window.sessionStorage.setItem(_bk, String(Date.now()));
                const _borrowed = await (0, $kkyxm.reacquireBridgeSession)({
                    rejectedToken: window.localStorage.getItem('symbols_access_token')
                });
                if (_borrowed) {
                    console.warn("[bootShell] token rejected; the session bridge handed a new one \u2014 reloading once");
                    _disposeEarlyShell();
                    window.location.reload();
                    return {
                        aborted: true,
                        navigated: true,
                        signedIn: false
                    };
                }
            }
        } catch (_) {
        /* storage or bridge unavailable — keep the purge path */ }
        _disposeEarlyShell();
        try {
            sdk?.logout?.();
        } catch (_) {}
        (0, $fnRiS.purgeAuthStorage)();
        // LOGINLOOP-1: was `encodeURIComponent(pathname + search)` — re-encoded
        // the WHOLE existing query verbatim, including any existing `next`,
        // nesting one level deeper on every bounce through this exact path
        // (byte-for-byte the reported URL). resolveAuthNext reuses an existing
        // next instead of re-wrapping it — see that file's own header for the
        // full mechanism and why it's not also wired into app.js in this pass.
        const dest = (0, $cRTCE.resolveAuthNext)(window.location.pathname, window.location.search);
        const r = reason ? `${dest ? '&' : '?'}reason=${encodeURIComponent(reason)}` : '';
        window.location.replace(dest ? `/login?next=${encodeURIComponent(dest)}${r}` : `/login${r}`);
        return {
            aborted: true,
            navigated: true,
            signedIn: false
        };
    };
    // Warm-start PAINT half, the actual attempt (tickets/opus.md; design +
    // acceptance spec'd in tickets/workspace.md "boot: scope-keyed warm-start
    // snapshot"; storage half + the "is this snapshot safe for THIS URL"
    // judgment: packages/workspace/functions/bootSnapshot.js).
    //
    // `warmSnapshot` was resolved by the CALLER (workspace/index.js, via
    // bootSnapshot.js's `resolveWarmBootSnapshot()`) BEFORE this function was
    // even invoked — bootShell itself never touches localStorage or the URL
    // to decide whether a cached scope applies; it only ever trusts an
    // ALREADY-VALIDATED row. That keeps the isolation/scope-matching judgment
    // call inside the package that owns it (and its own test suite), not
    // duplicated here.
    //
    // When it validates, mount the shell IMMEDIATELY from the cached chrome —
    // strictly before the auth-gate's `sdk.boot()`/`getMe()` network round
    // trip a few lines down even starts. Every line of this function's
    // EXISTING auth-gate + eager scope-fetch logic below then runs completely
    // UNCHANGED, in the background relative to that already-painted shell —
    // this is deliberately NOT a second/parallel boot path (that is exactly
    // how the `/w/<org>` boot-reshuffle bug happened the first time: two
    // uncoordinated things deciding scope). Step 8 ("Mount shell", a few
    // hundred lines down) detects the early mount and reconciles the live
    // root with whatever that unchanged logic actually resolved to, instead
    // of mounting a second time. Cold boots / first-ever visits / explicit
    // tenant switches are unaffected — `resolveWarmBootSnapshot()` returns
    // null on all of those (no entry exists yet, or the switch's PHASE-1
    // purge already removed the outgoing one — see bootSnapshot.js) — so
    // every caller that doesn't resolve a warm snapshot, and every caller
    // that never passes this option at all (preview/canvas/marketplace/
    // analytics — the other 4 apps this shared file boots), is completely
    // unaffected: byte-identical to today.
    // A white-label host whose tenant could not be established paints NO cached
    // chrome: the cached row is keyed by a pointer the host never confirmed, so
    // its roster and records may be another tenant's (WHITELABEL-STRICT-TENANT-
    // SCOPE-1). The live answer below still boots — into an empty tenant.
    if (warmSnapshot && mountEarly && !publicSurface && sdk && state && whitelabelHostScopeOf() !== false) {
        const _cachedAuth = authSnapshotFromCache(warmSnapshot);
        if (_cachedAuth) try {
            if (!context.methods) context.methods = {};
            if (typeof context.methods !== 'object') context.methods = {};
            context.methods.sdk = sdk;
            context.preResolvedAuth = (0, $1Xpun.scopeSnapshotToWhitelabelHost)(_cachedAuth, whitelabelHostScopeOf());
            // Roster — the ticket's own 4th named chrome field ("member
            // roster"), alongside org/workspace/identity which preResolvedAuth
            // already covers. `loadPrivateData`'s own early kick (fired by
            // onCreate's existing `_preAuth` branch below, unchanged) refreshes
            // this from a real fetch moments later regardless.
            state.peopleAll = Array.isArray(warmSnapshot.members) ? warmSnapshot.members : [];
            // NEW flag — deliberately NOT `workspaceReady` (that means
            // "confirmed complete record"; overloading it would let an
            // unconfirmed cache paint as authoritative). Declared in state.js
            // so smbls 3.14's typed-bag `state.update()` doesn't drop it on the
            // reconcile write in step 8.
            state._bootFromCache = true;
            // FIRST PAINT IN THE WORKSPACE'S LANGUAGE — the strings too, not only
            // `lang`. Step 1 resolved `lang` from the snapshot's cached language
            // pair; `prepareState` seeds the active language's keys into the root
            // state DURING the mount, so a non-English `lang` over an English-only
            // `translations` would paint English strings under a Georgian `lang`.
            // Load the session's WHOLE text set (`sessionI18nNamespaces`, the set
            // step 7b declares), with 7b's collision rule, BEFORE the mount. It
            // used to load bootPrepare's baseline only: the shell's other sets
            // (canvas, chat, mail, …) painted English under a Georgian `lang`
            // until 7b + step 8 redelivered — the composer's "Thinking…" read
            // English for ~0.4 s after every reload (KA-1 race, 2026-10-30). 7b
            // and 8b still run, in the SAME language: cache hits, no second
            // language paint.
            if (lang !== (0, $cvFPD.DEFAULT_LANG)) try {
                const _earlyNs = sessionI18nNamespaces();
                const _earlyMerged = await (0, $j7gGM.loadI18nNamespaces)(lang, _earlyNs);
                if (Object.keys(_earlyMerged).length) {
                    const _earlyExisting = _poly.translations[lang] || {};
                    _poly.translations[lang] = _earlyNs.some((ns)=>(0, $j7gGM.hasI18nBundle)(lang, ns)) ? {
                        ..._earlyExisting,
                        ..._earlyMerged
                    } : {
                        ..._earlyMerged,
                        ..._earlyExisting
                    };
                }
            } catch (err) {
                console.warn('[bootShell] early i18n load for the warm mount failed:', err?.message || err);
            }
            // The early mount itself is the composer's (parcel bootShell): a boot step
            // never calls create().
            _earlyShell = await mountEarly(themeMode);
        } catch (err) {
            console.warn('[bootShell] warm-start early mount failed, falling back to the cold path:', err?.message || err);
            _disposeEarlyShell();
            // The code below computes context.preResolvedAuth fresh from the
            // REAL getMe()/boot() response regardless of this branch — but
            // peopleAll/_bootFromCache were only ever meant for the (now
            // abandoned) early element, and must not leak into whatever mounts
            // next.
            state.peopleAll = [];
            state._bootFromCache = false;
            context.preResolvedAuth = null;
        }
    }
    // Sections from the composite /core/boot payload (set only when the
    // endpoint exists and answered inside the auth gate below) — consumed by
    // the scope-fetch stage AFTER the auth gate's block closes, so it MUST
    // live at this function scope, not inside `if (sdk)`.
    let _bootSections = null;
    if (sdk) {
        // BOOT DEADLINE: SDK init can refresh the stored session over the network.
        // An init that never settles ends in the loader's error + reload state
        // (a public surface carries on signed out, as for any failed session).
        try {
            await (0, $1tihf.withBootDeadline)(()=>(0, $1NxyO.awaitSDKInit)(), callDeadlineMs, 'sdk-init');
        } catch (initErr) {
            if (!(0, $1tihf.isBootDeadline)(initErr)) throw initErr;
            console.warn('[bootShell] ' + initErr.message);
            if (!publicSurface) {
                context.bootSignedIn = false;
                context.bootFailed = 'deadline';
                (0, $1tihf.publishBootFailure)('sdk_init_deadline');
                _disposeEarlyShell();
                return {
                    aborted: true,
                    failed: 'deadline',
                    signedIn: false
                };
            }
        }
        // Attach SDK to context.methods AFTER init so DOMQL exposes el.sdk only
        // when service proxies (sdk.getMe, sdk.login, …) are populated. Reactive
        // factories that read el.sdk on first render won't see a half-built proxy.
        if (!context.methods) context.methods = {};
        if (typeof context.methods !== 'object') context.methods = {};
        context.methods.sdk = sdk;
        // Wire realtime provider — SDK exposes a transport-agnostic
        // `workspaceProject.realtime.*` API; the provider plugs in server SSE +
        // the SDK user-socket as the actual wire (see sdkRealtimeProvider.js —
        // the transport it replaced was retired with the
        // governance project).
        // `sdk` is the init-await proxy (sdkClient.js wrapWithInitAwait), so
        // getService answers a PROMISE. Read synchronously, `wp` was that promise,
        // the guard was false and the provider was never installed: every meet,
        // presence and notifications subscription was a silent no-op (no live
        // captions, no live transcript panel, no spoken Fly asks — measured on
        // dev 2026-10-23). Init has settled here, so the await costs a microtask.
        try {
            const wp = await sdk.getService?.('workspaceProject');
            if (wp && typeof wp.setRealtimeProvider === 'function') wp.setRealtimeProvider((0, $h1nln.realtimeProvider));
            else console.warn("[bootShell] realtime provider not wired \u2014 no workspaceProject.setRealtimeProvider");
        } catch (err) {
            console.warn('[bootShell] could not wire realtime provider:', err?.message || err);
        }
        // Auth diagnostic — one snapshot on boot so the cause of any /workspace/… route
        // 401s is obvious in the console without paste-and-decode gymnastics.
        // Also exposed as window.__auth.diagnose() for on-demand re-checks.
        try {
            const dx = (0, $iA4IC.diagnoseAuth)();
            if (typeof window !== 'undefined') {
                window.__auth = window.__auth || {};
                window.__auth.diagnose = (0, $iA4IC.runAuthDiagnostic);
                window.__auth.snapshot = dx;
            }
            // `all_missing` on cold load is a false positive on public auth routes
            // (login, signin, signup, reset-password) — the user is intentionally
            // unauthenticated there and no tokens is the correct, expected state.
            // On protected routes, token hydration (cookie/iframe handoff) lands
            // asynchronously after bootstrap, so defer and re-check before logging.
            // The `sdk_only` diagnosis is logged immediately on any route. (#2263)
            const _isPublicAuthPath = typeof window !== 'undefined' && /^\/(login|signin|signup|signup-confirmation|reset-password|forgot-password|verify-email|auth\/magic-callback|auth\/callback|github-auth-callback)(\/|\?|#|$)/.test(window.location.pathname);
            if (dx.diagnosis === 'all_missing') {
                if (!_isPublicAuthPath) setTimeout(()=>{
                    const dx2 = (0, $iA4IC.diagnoseAuth)();
                    if (typeof window !== 'undefined') window.__auth.snapshot = dx2;
                    if (dx2.diagnosis !== 'ok' && dx2.diagnosis !== 'all_missing') console.warn(`[bootShell] auth diagnostic: ${dx2.diagnosis} \u{2014} ${dx2.suggestedAction}`);
                    else if (dx2.diagnosis === 'all_missing') console.warn(`[bootShell] auth diagnostic: ${dx2.diagnosis} \u{2014} ${dx2.suggestedAction}`);
                }, 250);
            } else if (dx.diagnosis !== 'ok') console.warn(`[bootShell] auth diagnostic: ${dx.diagnosis} \u{2014} ${dx.suggestedAction}`);
        } catch (err) {
            console.warn('[bootShell] auth diagnostic failed:', err?.message || err);
        }
        // SDK proxies service methods directly onto the SDK instance via
        // _createServiceProxies — there is no `sdk.auth` namespace. AuthService
        // method `getMe` is exposed as flat `sdk.getMe()`. (See
        // sdk/src/utils/services.js SERVICE_METHODS map: getMe → 'auth'.)
        //
        // Skip the network round-trip when no token exists in localStorage —
        // we already know the answer is "not authed", and firing the request
        // surfaces a misleading 401 (Unauthorized) on the landing page for
        // logged-out users.
        // Named `_me` (not `me`) — a bare `me` binding here collides with
        // Parcel/SWC's scope-hoisting renamer (see tickets/workspace.md
        // "bootShell: `me is not defined`"): the renamer correctly rewrote
        // the declaration + most reads to `me1` but silently dropped the
        // rewrite for the two references inside the nested
        // try→if→if(crossOrg)→try/catch block (the URL-org pre-render-switch
        // path), leaving a bare `me` identifier in the emitted bundle that
        // throws `ReferenceError: me is not defined` at runtime — 100%
        // reproducible on a cold deep-link that lands on a URL naming a
        // DIFFERENT org than the user's persisted `activeOrganization`. A
        // more unique local name sidesteps the collision entirely.
        let _me = null;
        // Set whenever getMe() failed WITHOUT `_isTokenRejection` positively
        // identifying the failure as a server-confirmed bad token — a raw
        // transport failure (TypeError, server unreachable), an HTTP 5xx (dev
        // nodemon restart window, a rolling deploy's brief gap), a timeout, or
        // any other error shape. The `!_me` fallthrough must NOT wipe the
        // credential in that case (see the note in the catch block below).
        // Named `_getMeUnresolved` rather than `_getMeNetworkFailed`: it used to
        // be set ONLY for a narrow network-TypeError regex match, which meant
        // every OTHER kind of ambiguous failure (5xx, unexpected error shapes)
        // fell through to the destructive force-logout path by DEFAULT — the
        // actual mechanism behind the hard-reload session-drop bug (#724, see
        // tickets/workspace.md). The safe default is now "preserve the
        // credential unless the rejection is proven", not the reverse.
        let _getMeUnresolved = false;
        // AUTH-WIPE-1 (c): carries the dev-infra verdict from the catch block
        // down to the soft bounce, so the visible stop can name the real cause.
        let _devInfraSignature = false;
        // BOOT DEADLINE: the session check itself never answered (bootDeadline.js).
        let _gateDeadline = false;
        const _hasSdkToken = typeof window !== 'undefined' && !!(window.localStorage.getItem('symbols_access_token') || window.localStorage.getItem('symbols_bridge_access_token'));
        if (_hasSdkToken) try {
            // `sdk.getMe()` returns the server's `response.data` shape
            // (`{ user: {...} }`), NOT the user object directly. Unwrap so
            // downstream code (`_me.email`, `_me._id`, `_me.organizations`,
            // `_me.activeOrganization` — all read by `_resolveAuthSnapshot`
            // and the eager scope fetch) sees the user fields at the top
            // level. Without this unwrap, `resolveAuthSnapshot(_me)` reads
            // every field as undefined → preResolvedAuth has empty
            // `currentUserEmail` → WeekView's filter
            // `ev.googleCalendarId === currentUserEmail` rejects every
            // event → calendar renders 0 cards despite the underlying
            // table holding hundreds of rows. (Repro: /calendar on a
            // freshly-boot tab; SDK execute returned 139 events, page
            // showed none.)
            // Composite boot (one round trip, server d50d003b): /core/boot
            // returns me + org + workspaces + workspace + members + prefs
            // together. `me` keeps getMe's exact semantics (byte-equivalent
            // payload, same auth middleware, same rejection contract); the other
            // sections replace the eager scope fetches below and prime
            // loadPrivateData via context.bootPayload. Feature-detected — older
            // SDKs/servers fall back to plain getMe(); any null section falls
            // back to its individual fetch at its consumption site.
            // Snapshot the stored access token BEFORE the gate's network round
            // trip — the fuel-cut check in the rejection branch below compares
            // against it to detect a cross-tab rotation that landed mid-flight.
            let _gateStartAccessToken = null;
            try {
                _gateStartAccessToken = window.localStorage.getItem('symbols_access_token');
            } catch (_) {}
            if (typeof sdk.boot === 'function') try {
                const bootRes = await (0, $1tihf.withBootDeadline)(()=>sdk.boot({
                        workspaceId: (0, $jhJrJ.getActiveWorkspacePointer)() || undefined
                    }), callDeadlineMs, 'boot');
                const bd = bootRes?.data || bootRes || null;
                if (bd && (bd.me || bd.org || bd.workspaces)) {
                    _bootSections = bd;
                    _me = bd.me?.user || bd.me || null;
                    // Prime the shared record cache with every COMPLETE read the boot
                    // carries, BEFORE anything can ask for one - the eager scope read
                    // below and the first auth tick's list-row upgrade
                    // (setActiveWorkspaceRecord) then make no request. Complete =
                    // carries the caller's `access`: the server adds it only on a
                    // single workspace read (WorkspaceController.getWorkspace ->
                    // callerAccess), so the `workspace` section has it and a
                    // `workspaces` list row never does (same projection otherwise).
                    // A row primed as THE record was served back as a full record
                    // without `access` for the cache's TTL - moduleRole unknown on
                    // every later adoption. Unprimed, a later reader joins the one
                    // read step 7 makes for it ("the caller's access").
                    if (typeof primeWorkspaceCache === 'function') {
                        const _rows = [
                            ...bd.workspaces && (bd.workspaces.items || (Array.isArray(bd.workspaces) ? bd.workspaces : [])) || [],
                            ...bd.workspace ? [
                                bd.workspace
                            ] : []
                        ];
                        for (const w of _rows){
                            const id = w && (w._id ?? w.id);
                            if (id && w.access && typeof w.access === 'object') try {
                                primeWorkspaceCache(String(id), w);
                            } catch (_) {}
                        }
                    }
                }
            } catch (bootErr) {
                // Same disambiguation contract as getMe: a server-proven token
                // rejection logs out here; anything else falls through to the
                // legacy getMe below, which owns the unresolved semantics.
                // AUTH-WIPE-1 (c): a dev-host signature-class 401 skips this
                // branch too — it falls through to the getMe retry below,
                // which fails the same way and lands in getMe's own catch,
                // where the soft (non-destructive) path already lives. One
                // soft path, not two — see isDevInfraSignatureWindow above.
                if (!publicSurface && isTokenRejection(bootErr) && !isDevInfraSignatureWindow(bootErr) && !PUBLIC_AUTH_ROUTE.test(window.location.pathname)) {
                    // LOGIN-BOUNCE FUEL CUT (2026-09-02, Nika "sometimes still
                    // goes 'Aw, snap'"): the rejection this branch sees is very
                    // often the CROSS-TAB ROTATION RACE, not a dead session —
                    // another same-origin tab consumed the single-use refresh
                    // first and has ALREADY re-written fresh tokens to
                    // localStorage by the time this rejection lands. Purging +
                    // bouncing here is what fuels the login<->app loop the
                    // /login circuit breaker exists for (each cycle re-evaluates
                    // the full dev bundle twice; enough cycles OOM the renderer).
                    // So: if the stored access token CHANGED since this boot's
                    // gate started, a healthy rotation happened elsewhere —
                    // reload THIS tab once so the SDK re-inits from the fresh
                    // pair, with a 60s one-shot latch so a genuinely dead
                    // session (tokens unchanged, or the retry fails the same
                    // way) still falls through to the purge+reauth below.
                    try {
                        const _freshTok = window.localStorage.getItem('symbols_access_token');
                        const _rk = 'symbols_boot_retry_at';
                        const _last = Number(window.sessionStorage.getItem(_rk) || 0);
                        if (_freshTok && _freshTok !== _gateStartAccessToken && Date.now() - _last > 60000) {
                            window.sessionStorage.setItem(_rk, String(Date.now()));
                            console.warn("[bootShell] token rejected but another tab rotated a fresh pair \u2014 reloading once instead of purging");
                            window.location.reload();
                            return {
                                aborted: true,
                                navigated: true
                            };
                        }
                    } catch (_) {
                    /* storage unavailable — keep the purge path */ }
                    console.warn('[bootShell] auth gate boot() rejected token; forcing logout:', String(bootErr?.message || ''));
                    return _forceLogoutAndReauth('session_invalid');
                }
                console.warn('[bootShell] composite boot failed; falling back to getMe:', bootErr?.message || bootErr);
            }
            if (!_me) {
                const raw = await (0, $1tihf.withBootDeadline)(()=>sdk.getMe(), callDeadlineMs, 'getMe');
                _me = raw?.user || raw || null;
            }
        } catch (e) {
            const errMsg = String(e?.message || '');
            // Server-rejected token → wipe + hard reload so the same poisoned
            // credential doesn't re-fail on the next boot.
            // AUTH-WIPE-1 (c): EXCEPT on the local dev channel, where a
            // signature-class 401 is infra (mis-restarted API, wrong JWT
            // secret), not a proven-dead credential — see
            // isDevInfraSignatureWindow above. Every other channel is
            // unaffected: isDevInfraSignatureWindow always returns false off
            // the 'local' channel, so this condition is byte-identical to
            // today there.
            if (!publicSurface && isTokenRejection(e) && !isDevInfraSignatureWindow(e) && !PUBLIC_AUTH_ROUTE.test(window.location.pathname)) {
                console.warn('[bootShell] auth gate getMe rejected token; forcing logout:', errMsg);
                return _forceLogoutAndReauth('session_invalid');
            }
            // Anything that reaches this line was NOT a proven rejection —
            // `_isTokenRejection` already early-returned above for the
            // server-confirmed case. This covers a raw transport failure
            // (TypeError — server mid-restart under the dev nodemon window
            // after every server commit, VPN blip, DNS), an HTTP 5xx (a
            // rolling-deploy gap, a dev proxy answering while the backend is
            // still coming up), a timeout, or any other error shape this
            // classifier doesn't recognize. The token was never actually judged
            // by the server, so don't let the `!_me` fallthrough below wipe it —
            // bounce softly (if at all) and let the stored credential sign the
            // user straight back in on the next boot. This was the root cause
            // of both the "every rebuild logs me out" cycle (2026-06-10) and
            // the intermittent hard-reload session-drop (#724): an unrecognized
            // error used to fall through to the SAME forced-logout branch as a
            // genuine rejection, defaulting "ambiguous" to "guilty" instead of
            // "innocent".
            _getMeUnresolved = true;
            if ((0, $1tihf.isBootDeadline)(e)) _gateDeadline = true;
            // AUTH-WIPE-1 (c): name the dev-infra case explicitly so the
            // console reads as an actionable stop, not a silent swallow — the
            // credential is being KEPT (not purged), and the fix is an
            // operational restart, not a re-login. Unconditional on
            // publicSurface: isDevInfraSignatureWindow only ever returns true
            // on the 'local' channel, which every preview/canvas/workspace
            // consumer can hit alike.
            if (isDevInfraSignatureWindow(e)) {
                _devInfraSignature = true;
                console.warn("[bootShell] dev API JWT-secret mismatch (signature-class 401 on the local channel) \u2014 auth storage KEPT. Restart the dev API via ~/www/deploy/bin/dev.sh (or with the infisical env), then reload.");
            }
            // publicSurface (preview): visitors are usually anonymous or
            // carrying a stale cross-env token; getMe failing is expected and
            // the `!_me && publicSurface` branch below handles it. WARN level
            // is reserved for the shell where a failure is actionable.
            if (publicSurface) console.debug('[bootShell] preview auth gate getMe skipped:', errMsg);
            else console.warn('[bootShell] auth gate getMe failed:', errMsg);
        }
        // THE GATE'S VERDICT. A stored token is not a session (it can be expired
        // or revoked): only a user the server returned here signs the shell in.
        // Every "signed in" decision reads this (context.bootSignedIn, the
        // `signedIn` of the result), never the raw token; a decision made before
        // it exists waits for context.bootReady.
        context.bootSignedIn = !!_me;
        if (!_me) {
            // `publicSurface: true` opts out of the auth bounce — used by the
            // preview app, which serves visibility-gated PUBLIC snapshots and
            // must render for logged-out users. The fetch path inside preview
            // surfaces its own "not public" UI when the project gate denies.
            if (publicSurface) {
                if (state) state.user = null;
            } else {
                // _hasSdkToken means we tried with a stored credential and got
                // no user back — wipe before /login so the next attempt is
                // clean. Without a token there's nothing to clear; soft
                // replaceState is fine. EXCEPTION: when getMe() failed WITHOUT a
                // proven rejection (`_getMeUnresolved` — transport failure, 5xx,
                // timeout, or any other ambiguous shape — see the catch block
                // above), the credential was never actually rejected — keep it and
                // bounce softly so the next boot signs straight back in instead of
                // forcing a re-login.
                if (_hasSdkToken && !_getMeUnresolved && !PUBLIC_AUTH_ROUTE.test(window.location.pathname)) return _forceLogoutAndReauth('session_invalid');
                // BOOT DEADLINE: the session check never answered. Nobody judged the
                // stored session, so it is KEPT and the page is NOT sent to /login (a
                // signed-in user would only bounce back and wait again). The loader
                // shows its error line + reload button instead; the composer and the
                // published root mount nothing (context.bootFailed).
                if (_gateDeadline && !PUBLIC_AUTH_ROUTE.test(window.location.pathname)) {
                    console.warn("[bootShell] the session check did not answer \u2014 boot stopped, reload offered");
                    context.bootFailed = 'deadline';
                    (0, $1tihf.publishBootFailure)('session_deadline');
                    _disposeEarlyShell();
                    return {
                        aborted: true,
                        failed: 'deadline',
                        signedIn: false
                    };
                }
                // DECLARE THE SESSION'S TEXT SETS — declare only, load nothing. This
                // exit returns before step 7b, the place that declares them on every
                // other boot, so the next `setLang` here (the workspace language
                // policy after an in-page sign-in) loaded bootPrepare's baseline only.
                // Read BEFORE the bounce below rewrites the URL (see
                // sessionI18nNamespaces). The login page's own text (`common` +
                // `auth`) still loads in applyPublicBootLang below, and nothing else
                // loads here. A language switch ON the login page now loads this set
                // too: the session the visitor signs in to, as on the signed-in path.
                if (_poly) _poly.namespaces = sessionI18nNamespaces();
                if (!PUBLIC_AUTH_ROUTE.test(window.location.pathname)) {
                    // Preserve the inbound destination (path + query) as `?next=` —
                    // same convention as _forceLogoutAndReauth above. A bare
                    // replaceState('/login') silently discarded every deep link,
                    // invitation ?token= links above all (P0 invite-flow fix,
                    // 2026-08-06). Bare `/` stays a plain /login.
                    // LOGINLOOP-RELEASE-1: was `pathname + search` verbatim — the
                    // FOURTH bounce site, and the one that fires when a stale SDK
                    // token is present and /auth/me fails (measured on production
                    // 2026-08-27). resolveAuthNext reuses an existing `next` instead
                    // of re-wrapping it, and returns null for bare `/`.
                    const dest = (0, $cRTCE.resolveAuthNext)(window.location.pathname, window.location.search);
                    const params = new URLSearchParams();
                    // KA-1 — an explicit `?lang=` on the inbound link survives the
                    // bounce as /login's own `lang`, so the login renders in it and a
                    // reload of /login keeps it. Shipped codes only, region dropped
                    // (the same reading applyPublicBootLang makes; read here because
                    // this boot step has no element to el.call through yet).
                    const inboundLang = String(new URLSearchParams(window.location.search).get('lang') || '').trim().toLowerCase().split(/[-_]/)[0];
                    if ([
                        'en',
                        'ka'
                    ].indexOf(inboundLang) !== -1) params.set('lang', inboundLang);
                    if (dest) params.set('next', dest);
                    // AUTH-WIPE-1 (c) — Nika's third condition, the VISIBLE STOP. Without
                    // this the dev-infra case is indistinguishable from an ordinary
                    // sign-out: storage is kept, but the user still lands on /login with
                    // no explanation and re-enters credentials that were never the
                    // problem. Naming it in the URL lets the login surface say the dev
                    // API is misconfigured and that a restart — not a re-login — is the
                    // fix. Only ever set on the 'local' channel (see
                    // isDevInfraSignatureWindow); every other channel is unchanged.
                    if (_devInfraSignature) params.set('authInfra', 'dev_signature');
                    const qs = params.toString();
                    window.history.replaceState(null, '', `/login${qs ? `?${qs}` : ''}`);
                }
                // This is a SOFT bounce (replaceState, no reload) — unlike
                // _forceLogoutAndReauth's hard `window.location.replace`, execution
                // continues on THIS page after returning. An early-mounted warm
                // shell left behind here would double-mount alongside whatever the
                // caller mounts next for the null return (workspace/index.js's own
                // `!shell` fallback creates its own fresh root).
                // WHITELABEL-BRAND-LANG-2 — the branded LOGIN is this exit. Step 7b
                // never runs on the bounce, so the auth shell would mount with first
                // paint's `stored || en`, and `branding.lang` would reach the marks
                // but never the copy. Resolve, load and stamp it here (see
                // publicBootLang.js).
                // KA-1 (2026-10-25) — EVERY signed-out exit, not only a branded host:
                // the platform's own login read no signal at all, so a Georgian
                // browser got English. `?lang=` → brand → browser → English.
                try {
                    await (0, $aNuMw.applyPublicBootLang)({
                        context: context
                    });
                } catch (err) {
                    console.warn('[bootShell] signed-out page language failed:', err?.message || err);
                }
                _disposeEarlyShell();
                return {
                    aborted: true,
                    signedIn: false
                };
            }
        } else if (state) state.user = _me;
        // Stash the full pre-resolved auth snapshot on context so the
        // shell's onCreate can synchronously seed `s.root` BEFORE the
        // async `subscribeAuthSession` listener registers. This eliminates
        // the empty-state flash window where reactive consumers (e.g.
        // NoOrgOverlay) evaluated against schema defaults (signedIn=false
        // → orgs=[]) for the frame between mount and the first auth fire.
        // Null when no user is resolved (publicSurface or anonymous boot).
        // WS-WHITELABEL-TENANT-SCOPE-1 — a branded host sees ONE tenant.
        //
        // Applied where the snapshot is ADOPTED, never inside the builders. Both
        // builders' `return { signedIn: true, … }` literals are a CLOSED,
        // classified shape that __tests__/bootAuthSnapshotClosedShape.test.js
        // anchors on textually; scoping inside one would have made that guard
        // silently measure a single builder instead of two. Wrapping every
        // adoption site instead keeps the literals byte-identical, adds no key,
        // and covers the WARM-START builder on the same line of defence — a warm
        // boot must not render the wrong tenant either.
        //
        // The scope is `state.whitelabelHostScope` (whitelabelHostScopeOf above),
        // already awaited by seedWhitelabelHostScope before bootShell runs
        // (packages/workspace/index.js): no new fetch, no new await, nothing to
        // race. A platform host has no scope, so the snapshot is returned BY
        // IDENTITY.
        //
        // WHITELABEL-STRICT-TENANT-SCOPE-1 — and BEFORE the snapshot is built, the
        // host names this boot's org and workspace. `me.activeOrganization` /
        // `me.activeWorkspace` are the inputs every rung below resolves from (the
        // snapshot's active-org pick, step 7's eager org + workspace fetch), so
        // stating the host's tenant there makes the existing ladder resolve
        // INSIDE it, instead of resolving the account's stored choice (the org
        // last used on my.symbols — measured: Keepz on unreal.pr.symbols.app) and
        // narrowing afterwards. In memory, for this boot, never written back: the
        // stored choice belongs to the platform host. Only for a MEMBER of the
        // host's org; a non-member keeps their record and the scoping hands them
        // an empty tenant.
        const _bootHostScope = whitelabelHostScopeOf();
        if (_me && _bootHostScope && _bootHostScope.organizationId) {
            const _hostOrgId = String(_bootHostScope.organizationId);
            const _memberRows = [
                ...Array.isArray(_me.organizations) ? _me.organizations : [],
                ...Array.isArray(_me.app_metadata && _me.app_metadata.orgs) ? _me.app_metadata.orgs : []
            ];
            const _isHostMember = _memberRows.some((o)=>String((o && typeof o === 'object' ? o.id || o._id : o) || '') === _hostOrgId);
            if (_isHostMember) {
                _me.activeOrganization = _hostOrgId;
                if (_bootHostScope.workspaceId) _me.activeWorkspace = String(_bootHostScope.workspaceId);
            }
        }
        context.preResolvedAuth = (0, $1Xpun.scopeSnapshotToWhitelabelHost)(resolveAuthSnapshot(_me), _bootHostScope);
        // Warm-start: the live getMe()/boot() answer just landed (signed-in or
        // not) — clear the cache flag HERE, not only in the "8. Mount shell"
        // reconcile below. Measured live (headless probe, tickets/opus.md): for
        // an early-mounted shell, `state` IS the live root's backing
        // store (direct writes below — `state.workspace = ws`,
        // `state.workspaceReady = true` in the eager scope-fetch step
        // that follows — are visible on the mounted element immediately, not
        // just a pre-mount seed), so those direct writes were observed flipping
        // `workspaceReady` true up to ~200ms BEFORE the explicit
        // `_bootFromCache: false` reconcile ran, since that reconcile only runs
        // once every downstream scope-fetch has also settled. No consumer reads
        // `_bootFromCache` yet, so that gap was never user-visible, but the
        // flag's own contract ("true ONLY while the painted chrome is
        // cache-derived", state.js) should not lag the live answer it exists to
        // track. No-op on the cold path (never set true) and on the
        // early-mount-failed path (already reset in its own catch block).
        if (state) state._bootFromCache = false;
    }
    // 7. Eager scope fetch — ORG + WORKSPACE.
    // SDK exposes service methods FLAT (sdk.getOrganization, sdk.getWorkspace);
    // the previous sdk.organization?.get?.() chain was dead code — optional
    // chaining short-circuited on the missing namespace, returning undefined
    // and silently leaving state.org/workspace null. That null forced sub-apps
    // to refetch on render, which is one of the storm root causes.
    // workspaceProject has no get-by-id flat method (the service exposes
    // nested namespaces — tickets, chat, etc.) so we no longer attempt to
    // hydrate state.workspaceProject here.
    // Skip the eager scope fetch when running as a public surface (no
    // user) — the org/workspace lookups would 401 and waste a round-trip.
    // `_completeWorkspaceAccess` — set by "the caller's access" below when the
    // boot's record still owes its `access`; returned on the result.
    let _completeWorkspaceAccess = null;
    if (sdk && state && state.user) {
        // Active org now lives on `user.activeOrganization` (Mongo). The
        // legacy `localStorage.activeOrg` key was replaced by the
        // `PATCH /auth/me/active-org` flow + socket.io cross-session sync.
        // Falls back to null when the user hasn't picked one yet — sub-apps
        // then default to `orgs[0]` via their own resolvers.
        const activeOrgId = state.user.activeOrganization ? String(state.user.activeOrganization) : null;
        // The org's workspace list. `claims.workspaces` comes ONLY from the
        // governance JWT, so an SDK-only session (Google/OAuth, or any session
        // before federation lands) arrives here with an EMPTY list — which breaks
        // two things at once: the URL's `?ws=` handle has nothing to resolve
        // against, so a deep link silently falls back to the org's HQ workspace,
        // and the workspace switcher renders "no workspaces to load". One list
        // fetch, only when the claims list is actually empty, fixes both and then
        // seeds the snapshot so every downstream consumer sees the real list.
        const _mapWsRows = (rows, orgId)=>(Array.isArray(rows) ? rows : []).map((w)=>({
                    id: String(w._id || w.id || ''),
                    // `displayName` FIRST — the legacy `name` field is frozen at
                    // "Default" on older records and hid every rename. THE rule lives in
                    // activeWorkspaceRecord.js; do not re-derive it here.
                    name: (0, $9IIym.workspaceDisplayName)(w),
                    slug: w.slug,
                    key: w.key,
                    type: w.type,
                    org_id: String(w.organization || w.org_id || orgId),
                    role: w.role || 'member',
                    // List row — no `settings`. See tickets/spec-workspace-record-shape.md.
                    _shape: 'list'
                })).filter((w)=>w.id);
        // WHITELABEL-STRICT-TENANT-SCOPE-1 — every list below is narrowed to the
        // bound host's ONE workspace AS IT IS BUILT. The composite boot computes
        // its list SERVER-side for the account's stored active org, which on a
        // white-label host is whatever org my.symbols last used — adopting it raw
        // seeded another tenant's workspaces into the switcher, and a non-empty
        // foreign list also skipped the fetch of the host org's own list. Scoped
        // here, a foreign list comes out empty and the fetch below runs for the
        // host org (`activeOrgId` is the host's: the boot stated it above).
        // Identity on platform hosts (no scope).
        const _listHostScope = whitelabelHostScopeOf();
        const _hostScopedList = (list)=>(0, $1Xpun.scopeWorkspaceListToWhitelabelHost)(list, _listHostScope);
        let _wsList = context.preResolvedAuth?.workspaces;
        // Composite-boot fast path: the org's workspace list already rode the
        // one-RTT payload — no second fetch. (Boot's list is the ACTIVE org's,
        // same as this fetch would target.)
        if (!(Array.isArray(_wsList) && _wsList.length) && _bootSections?.workspaces) {
            const bootRows = _bootSections.workspaces.items || (Array.isArray(_bootSections.workspaces) ? _bootSections.workspaces : []);
            const bootList = _hostScopedList(_mapWsRows(bootRows, activeOrgId));
            if (bootList.length) {
                _wsList = bootList;
                if (context.preResolvedAuth) context.preResolvedAuth.workspaces = bootList;
            }
        }
        if (activeOrgId && !(Array.isArray(_wsList) && _wsList.length)) try {
            const res = await (0, $1tihf.withBootDeadline)(()=>sdk.listWorkspaces?.({
                    organization: activeOrgId
                }), callDeadlineMs, 'listWorkspaces');
            const rows = res && (res.items || res.data?.items || res.data || res.workspaces) || [];
            const list = _hostScopedList(_mapWsRows(rows, activeOrgId));
            if (list.length) {
                _wsList = list;
                if (context.preResolvedAuth) context.preResolvedAuth.workspaces = list;
            }
        } catch (err) {
            console.warn('[bootShell] workspaces list fetch failed:', err?.message || err);
        }
        // The snapshot's `workspace` was resolved before the host's row was in
        // any list; re-scope it against the list now held, so the host's own row
        // (never a sibling's) is the boot's workspace.
        if (_listHostScope !== null && context.preResolvedAuth && Array.isArray(_wsList)) context.preResolvedAuth = (0, $1Xpun.scopeSnapshotToWhitelabelHost)({
            ...context.preResolvedAuth,
            workspaces: _hostScopedList(_wsList)
        }, _listHostScope);
        // Persist what boot fetched onto the state seed: the shell's handle
        // resolver (registerWorkspaceHandleResolver) and the scheme-A route heal
        // both read root.workspaces / root.orgWorkspaces at runtime — in
        // SDK-only sessions the claims tick never fills these (no governance
        // JWT), so without this seed the resolver stays blind and a 2-segment
        // URL's route re-dispatch never fires.
        if (Array.isArray(_wsList) && _wsList.length && state) {
            state.workspaces = _wsList;
            const byOrg = {};
            for (const w of _wsList){
                if (!w?.org_id) continue;
                (byOrg[w.org_id] = byOrg[w.org_id] || []).push(w);
            }
            state.orgWorkspaces = {
                ...state.orgWorkspaces || {},
                ...byOrg
            };
        }
        // Scheme A URL-org scope (BOOT-RESHUFFLE F1 — the "Phase 3 refinement"
        // resolveActiveWorkspace's cross-org fallthrough comment promised). The
        // URL names the org scope: when `/w/<slug>` resolves to a MEMBER org
        // different from the server-active one, boot must scope to the URL's org
        // BEFORE first render. This fetch used to be gated on the URL also naming
        // a workspace handle (seg2 / legacy `?ws=`), so a bare `/w/<org>` booted
        // the PERSISTED org's chrome + module + dashboard under the URL's org, and
        // a post-render reconcile (switchOrg → ~110-key root.replace → refetch)
        // redid the whole boot in front of the user — the "few refreshes and
        // widgets never settle" landing (tickets/workspace.md BOOT-RESHUFFLE).
        // The handle-resolution case (same-org deep link naming a workspace) keeps
        // its fetch too — one list read serves both.
        let _urlOrgWs = null;
        try {
            const loc = typeof window !== 'undefined' ? window.location : null;
            const rawSeg = (0, $9juhh.getWorkspaceRawSegments)(loc?.pathname || '');
            const wantHandle = rawSeg.seg2 || (0, $9juhh.getWorkspaceQueryParam)(loc?.search || '');
            if (rawSeg.orgSlug && typeof sdk.listWorkspaces === 'function') {
                const urlOrg = (context.preResolvedAuth?.orgs || []).find((o)=>o && (o.slug === rawSeg.orgSlug || o.username === rawSeg.orgSlug));
                const urlOrgId = urlOrg ? String(urlOrg.id ?? urlOrg._id ?? '') : null;
                const crossOrg = !!urlOrgId && urlOrgId !== String(activeOrgId || '');
                // A deep link INTO the active org reuses the list boot already holds
                // (the boot report's E: it re-listed the same org, ~0.24 s).
                if (urlOrgId && !crossOrg && wantHandle && Array.isArray(_wsList) && _wsList.length) {
                    _urlOrgWs = {
                        [urlOrgId]: _wsList
                    };
                    if (state) state.orgWorkspaces = {
                        ...state.orgWorkspaces || {},
                        ..._urlOrgWs
                    };
                } else if (urlOrgId && (crossOrg || wantHandle)) {
                    const res2 = await (0, $1tihf.withBootDeadline)(()=>sdk.listWorkspaces({
                            organization: urlOrgId
                        }), callDeadlineMs, 'listWorkspaces:urlOrg');
                    const rows2 = res2 && (res2.items || res2.data?.items || res2.data || res2.workspaces) || [];
                    const list2 = _mapWsRows(rows2, urlOrgId);
                    if (list2.length) {
                        _urlOrgWs = {
                            [urlOrgId]: list2
                        };
                        // Same persistence rationale as the active-org list above.
                        if (state) state.orgWorkspaces = {
                            ...state.orgWorkspaces || {},
                            ..._urlOrgWs
                        };
                    }
                }
                if (crossOrg && (0, $fDBlu.isMwtEnabled)()) {
                    // Resolve the landing workspace INSIDE the URL org (URL handle →
                    // tab pointer-in-org → HQ) so the canonical switch below can hop
                    // the active workspace in the same move.
                    const _landing = (0, $jhJrJ.resolveActiveWorkspace)({
                        url: loc?.pathname || '',
                        search: loc?.search || '',
                        orgs: context.preResolvedAuth?.orgs,
                        workspaces: _urlOrgWs && _urlOrgWs[urlOrgId] || [],
                        orgWorkspaces: _urlOrgWs || undefined
                    });
                    const _landingWsId = _landing && String(_landing.orgId || '') === urlOrgId ? _landing.workspaceId : null;
                    // Align org identity PRE-RENDER through the canonical entry point.
                    // sdk.switchOrg persists Mongo User.activeOrganization (the landing
                    // is a deliberate org activation — the next login lands here
                    // directly instead of replaying the cross-org dance every time,
                    // which is how this bug kept "coming back"), sets
                    // sdk._context.activeOrgId (so reconcileMwtOrgFromUrl finds nothing
                    // to reconcile), invalidates cached token claims (server-side
                    // token-scoped reads — users.members.list et al — re-mint onto this
                    // org), and hops the active workspace when the landing target is
                    // known. No rootBus listeners are registered yet (create() runs
                    // later), so no teardown pipeline fires — this is pre-render scope
                    // setting, not a live switch.
                    try {
                        await (0, $1tihf.withBootDeadline)(()=>sdk.switchOrg(urlOrgId, _landingWsId ? {
                                homeWorkspaceId: _landingWsId
                            } : {
                                skipWorkspaceHop: true
                            }), callDeadlineMs, 'switchOrg');
                    } catch (err) {
                        console.warn('[bootShell] url-org pre-render switch failed (post-render reconcile heals):', err?.message || err);
                    }
                    // Recompute the snapshot URL-pinned — _resolveAuthSnapshot mirrors
                    // auth.js resolveActiveOrgId's URL pin, so the first auth tick
                    // agrees with this scope instead of reverting it.
                    //
                    // Reads/writes `state.user` here — NOT the `_me` closure
                    // binding — even though they're the same object (`state.user
                    // = _me` ran earlier in this function, guarded by the same
                    // `state.user` truthiness this whole block is gated on, see
                    // the `if (sdk && state && state.user)` guard
                    // above). A direct reference to `_me` this deep in nested
                    // try/if/if/await control flow tripped a Parcel/SWC scope-hoisting
                    // rename bug: the renamer correctly rewrote the `_me` declaration
                    // and every EARLIER read, but silently left these two later reads
                    // at their pre-rename name, producing a live `ReferenceError: me
                    // is not defined` on cold-boot deep links that name a different
                    // org than the user's persisted `activeOrganization` (tickets/
                    // workspace.md "bootShell: `me is not defined`", 2026-08-08;
                    // confirmed via bundle inspection — the renamer's declaration
                    // became `_me1` while these two sites stayed literally `_me`, i.e.
                    // whatever local name is chosen, NOT a naming collision). Routing
                    // through `state.user` — already used for `activeOrgId`
                    // a few lines up in this same block — sidesteps the bug: it's a
                    // plain property path off `context`, which every other line in
                    // this 170-line async function already threads through cleanly,
                    // rather than a value carried purely by closure across many nested
                    // blocks and `await` boundaries.
                    state.user.activeOrganization = urlOrgId;
                    context.preResolvedAuth = (0, $1Xpun.scopeSnapshotToWhitelabelHost)(resolveAuthSnapshot(state.user, {
                        urlOrgId: urlOrgId,
                        urlOrgWorkspaces: _urlOrgWs && _urlOrgWs[urlOrgId] || []
                    }), whitelabelHostScopeOf());
                    // Re-point the pre-create seeds at the URL org's list — the seed
                    // block above ran with the persisted org's.
                    const _snapWs = context.preResolvedAuth?.workspaces;
                    if (Array.isArray(_snapWs) && _snapWs.length) {
                        _wsList = _snapWs;
                        if (state) state.workspaces = _snapWs;
                    }
                }
            }
        } catch (err) {
            console.warn('[bootShell] url-org workspaces fetch failed:', err?.message || err);
        }
        // Multi-workspace-tabs (§6e/§6h): resolve THIS tab's workspace — URL
        // `/w/<org>/<ws-handle>` (or legacy `?ws=`) wins, then the per-tab
        // pointer (sessionStorage when MWT on), then the pre-resolved claim.
        // Byte-identical to the old `localStorage.getItem('activeWorkspace')`
        // when the flag is off.
        const _wsResolved = (0, $jhJrJ.resolveActiveWorkspace)({
            url: typeof window !== 'undefined' && window.location && window.location.pathname || '',
            // The workspace handle is what makes the URL name a WORKSPACE and not
            // just an org — required for orgs holding more than one, where the
            // prefix alone resolves to HQ and silently drops the user into the
            // wrong workspace.
            search: typeof window !== 'undefined' && window.location && window.location.search || '',
            orgs: context.preResolvedAuth?.orgs,
            workspaces: _wsList,
            orgWorkspaces: _urlOrgWs || undefined,
            // The precedence's last rung, named in the comment above and never
            // passed: with no URL pin and no pointer (a fresh browser, a cleared
            // store, another origin) the snapshot's workspace IS this boot's
            // workspace — root.workspace is seeded from it after mount — so the SDK
            // scope below must be it too, or every scope-derived ticket call (get,
            // update, the attachment upload) goes out unscoped until the first auth
            // tick.
            claim: context.preResolvedAuth?.jwtClaims?.active_workspace_id || null
        });
        // WHITELABEL-STRICT-TENANT-SCOPE-1 — on a white-label host the boot's
        // workspace can only be the HOST's (whatever the pointer, claim or URL
        // handle said), and only for a MEMBER of the host's org — the scoped
        // snapshot's org list is that membership test (whitelabelScope.js empties
        // it for a non-member). `false` (tenant not established) resolves none.
        // Identity on platform hosts.
        const _hostMember = !!_listHostScope && (context.preResolvedAuth?.orgs || []).some((o)=>String(o?.id ?? o?._id ?? '') === String(_listHostScope.organizationId));
        const _resolvedWsId = _wsResolved.workspaceId;
        const activeWorkspaceId = _listHostScope === null ? _resolvedWsId : _hostMember && _resolvedWsId && (!_listHostScope.workspaceId || String(_resolvedWsId) === String(_listHostScope.workspaceId)) ? _resolvedWsId : null;
        // The session's OWN org, for a boot that resolved nothing at all: no URL
        // member org, no tab pointer, no claim (`source: 'none'` — a fresh tab on a
        // foreign `/w/<slug>` in a session with no governance workspace list, dev.my
        // 2026-10-30). No other writer seeds the SDK's org there, so every
        // org-scoped read of that session went out with none, and
        // reconcileMwtOrgFromUrl waited out its ladder for a comparand. It is the
        // value the pointer and claim boots write in the first branch below
        // (`activeOrgId`), and only on a platform host (a white-label non-member
        // keeps the empty tenant WHITELABEL-STRICT-TENANT-SCOPE-1 hands them) and
        // only for an org in this session's own list (a stored org the user has
        // left is never seeded).
        const _ownOrgSeedId = _listHostScope === null && activeOrgId && (context.preResolvedAuth?.orgs || []).some((o)=>String(o?.id ?? o?._id ?? '') === activeOrgId) ? activeOrgId : null;
        if ((0, $fDBlu.isMwtEnabled)() && activeWorkspaceId) {
            // Scope THIS tab's SDK calls to its workspace via the CLIENT-only
            // updateContext (no server mutation, no cross-tab broadcast — services read
            // `_context.activeWorkspaceId` + thread it as the Phase-0 `?workspaceId=`
            // param), and pin the per-tab pointer (sessionStorage only).
            // Also pin the SDK's ORG context: reconcileMwtOrgFromUrl compares the URL
            // slug against sdk._context.activeOrgId, which nothing seeded on a
            // matched-org landing — the reconcile then burned a 25×200ms retry
            // ladder waiting for a comparand before silently giving up. (On the
            // cross-org path the pre-render switchOrg above already set it — this
            // write is idempotent there.)
            try {
                const _ctxOrgId = String(_wsResolved.orgId || activeOrgId || '') || null;
                sdk.updateContext?.(_ctxOrgId ? {
                    activeWorkspaceId: activeWorkspaceId,
                    activeOrgId: _ctxOrgId
                } : {
                    activeWorkspaceId: activeWorkspaceId
                });
            } catch (err) {
                console.warn('[bootShell] mwt updateContext failed:', err?.message || err);
            }
            (0, $jhJrJ.setActiveWorkspacePointer)(activeWorkspaceId);
        } else if (!(0, $fDBlu.isMwtEnabled)() && activeWorkspaceId) // Tabs OFF: the same client-only scope write, for the same reason —
        // `_workspaceScope()` reads `_context.activeWorkspaceId` first, so the
        // SDK and root.workspace name one workspace from the first call. No
        // pointer write here: with tabs off that pointer is SHARED, a write
        // would switch every other open tab, and the auth tick already mirrors
        // it.
        try {
            sdk.updateContext?.({
                activeWorkspaceId: activeWorkspaceId
            });
        } catch (err) {
            console.warn('[bootShell] updateContext failed:', err?.message || err);
        }
        else if ((0, $fDBlu.isMwtEnabled)() && (_wsResolved.orgId || _ownOrgSeedId)) // P0 tenant isolation — `source: 'url-org-unresolved'`: the URL named a
        // member org but no workspace in it is resolvable yet (see
        // resolveActiveWorkspace). Pin the SDK's ORG context to the URL org
        // anyway so org-scoped reads (docs/notes, announcements, roster) follow
        // the TAB's org from the first fetch instead of the caller's global
        // active-claim — and so a failed pre-render switchOrg can't leave the
        // context on the previous tenant. The per-tab pointer is deliberately
        // NOT written (there is no workspace to point at); the auth tick's
        // listWorkspaces fallback resolves one within this boot. With no URL
        // org (`source: 'none'`) the same write pins the session's own org
        // (`_ownOrgSeedId` above); the URL org always wins.
        try {
            sdk.updateContext?.({
                activeOrgId: String(_wsResolved.orgId || _ownOrgSeedId)
            });
        } catch (err) {
            console.warn('[bootShell] mwt org-only updateContext failed:', err?.message || err);
        }
        const scopeFetches = [];
        // When a URL slug drove the workspace pick (`_wsResolved.orgId` is set
        // only then), THAT org is this tab's org — seed state.org from it so a
        // cross-org deep link doesn't paint the server-active org's chrome for a
        // beat before reconcileMwtOrgFromUrl converges.
        //
        // WHITELABEL-STRICT-TENANT-SCOPE-1 — on a white-label host the org this
        // seeds is the HOST's, or none: a member's `activeOrgId` already IS the
        // host org (the boot stated it), and for a NON-member it is their stored
        // org — fetching that would paint another tenant's identity under this
        // customer's domain. Identity on platform hosts.
        const _scopeOrgCandidate = _wsResolved.orgId || activeOrgId;
        const scopeOrgId = _listHostScope === null ? _scopeOrgCandidate : _hostMember && _scopeOrgCandidate && String(_scopeOrgCandidate) === String(_listHostScope.organizationId) ? _scopeOrgCandidate : null;
        // Composite-boot fast path: boot's `org` section IS the active org — use
        // it without a fetch when the scope didn't get URL-redirected to a
        // different org (cross-org deep links keep the legacy fetch).
        const _bootOrg = _bootSections?.org || null;
        const _bootOrgId = _bootOrg ? String(_bootOrg.id ?? _bootOrg._id ?? '') : null;
        if (_bootOrg && scopeOrgId && _bootOrgId === String(scopeOrgId)) state.org = _bootOrg;
        else if (scopeOrgId && typeof sdk.getOrganization === 'function') scopeFetches.push((0, $1tihf.withBootDeadline)(()=>sdk.getOrganization(scopeOrgId), callDeadlineMs, 'getOrganization').then((res)=>{
            state.org = res?.data || res || null;
        }).catch(()=>null));
        // Composite-boot fast path: boot's `workspace` section is the record for
        // the SERVER-resolved scope (the pointer we sent). Adopt it without a
        // fetch only when the CLIENT resolution (URL handle > legacy ?ws >
        // pointer) landed on the same workspace — deep links to a different
        // workspace keep the legacy fetch below.
        const _bootWs = _bootSections?.workspace || null;
        const _bootWsId = _bootWs ? String(_bootWs._id ?? _bootWs.id ?? '') : null;
        const _bootWsMatches = !!(_bootWsId && activeWorkspaceId && _bootWsId === String(activeWorkspaceId));
        if (_bootWsMatches) {
            // Same normalization the fetch path applies (server uses _id /
            // displayName / organization; consumers read id / name / org_id), plus
            // the FULL-shape provenance stamp — see activeWorkspaceRecord.js /
            // tickets/spec-workspace-record-shape.md. This is the pre-mount seed
            // path (no live `root` yet to run through `setActiveWorkspaceRecord`);
            // the stamp is what lets the post-mount auth tick's guarded setter
            // recognize this as a complete record and refuse to downgrade it.
            const ws = (0, $9IIym.stampWorkspaceShape)((0, $9IIym.normalizeWorkspaceRecord)(_bootWs), 'full', {
                clone: false
            });
            state.workspace = ws;
            state.workspaceReady = true;
            const snap = context.preResolvedAuth;
            if (snap) {
                snap.workspace = ws;
                if (snap.jwtClaims) snap.jwtClaims.active_workspace_id = activeWorkspaceId;
            }
        }
        // The boot resolved ANOTHER workspace (a pointer-less boot falls back to
        // the user's stored active workspace) but the URL's workspace is a row of
        // the boot's own list: adopt that row — it is the full read projection —
        // so first paint does not wait for a second read (the boot report's F,
        // ~0.22 s). Members / prefs stay unprimed below: they describe the boot's
        // workspace.
        // The RAW boot list rows: the server lists with the SAME projection as a
        // single getWorkspace read (WORKSPACE_READ_PROJECTION + platform defaults
        // + resolvedAppearance) — everything but the caller's `access`, which
        // only the single read adds. The row is complete for the chrome; its
        // `access` is completed in the background right after this step ("the
        // caller's access" below).
        const _bootListRows = _bootSections?.workspaces ? _bootSections.workspaces.items || (Array.isArray(_bootSections.workspaces) ? _bootSections.workspaces : []) : [];
        const _bootRow = !_bootWsMatches && activeWorkspaceId ? _bootListRows.find((w)=>w && String(w._id ?? w.id ?? '') === String(activeWorkspaceId)) : null;
        if (_bootRow) {
            const ws = (0, $9IIym.stampWorkspaceShape)((0, $9IIym.normalizeWorkspaceRecord)({
                ..._bootRow
            }), 'full', {
                clone: false
            });
            state.workspace = ws;
            state.workspaceReady = true;
            const snap = context.preResolvedAuth;
            if (snap) {
                snap.workspace = ws;
                if (snap.jwtClaims) snap.jwtClaims.active_workspace_id = activeWorkspaceId;
            }
        } else if (!_bootWsMatches && activeWorkspaceId && typeof sdk.getWorkspace === 'function') // localStorage.activeWorkspace is the user's explicit choice and the
        // canonical pointer. The previous code gated on the user's claims/
        // app_metadata workspace list and CLEARED the pointer when the chosen
        // workspace wasn't in it — but that list is incomplete/stale (it omits a
        // freshly-created workspace, and the JWT isn't re-minted on switch), so a
        // valid switch to such a workspace was silently wiped on refresh. The SDK
        // is the real accessibility authority: fetch the chosen workspace and let
        // the server resolve it. On success → seed state AND correct
        // preResolvedAuth (which onCreate seeds into the live root after mount) so
        // jwtClaims.active_workspace_id + workspace agree on the chosen workspace
        // from first paint.
        //
        // Do NOT clear localStorage.activeWorkspace on error here. A boot-time
        // failure is frequently transient (token / governance federation not
        // ready yet, esp. for a workspace not in the JWT scope), and wiping a
        // VALID pointer silently reverts the user's selection on refresh — the
        // exact bug this fixes. The auth.js listWorkspaces fallback validates the
        // pointer against the org's real workspace list and self-corrects it when
        // it is genuinely gone, so a stale pointer still heals within one boot.
        scopeFetches.push((0, $1tihf.withBootDeadline)(()=>getWorkspaceCached ? getWorkspaceCached(sdk, activeWorkspaceId) : sdk.getWorkspace(activeWorkspaceId), callDeadlineMs, 'getWorkspace').then((res)=>{
            const raw = res?.data || res || null;
            if (!raw) return;
            // Normalize the server record (it uses `_id` / `displayName`) so
            // every consumer that reads `workspace.id` / `workspace.name` — and
            // the auth-tick preserve guard in subscribeAuthSession — sees a
            // consistent shape and keeps this full record. `_shape:'full'` is
            // the provenance stamp `setActiveWorkspaceRecord` (post-mount) and
            // the pre-mount seed below both key off — see
            // tickets/spec-workspace-record-shape.md.
            const ws = (0, $9IIym.stampWorkspaceShape)((0, $9IIym.normalizeWorkspaceRecord)(raw), 'full', {
                clone: false
            });
            state.workspace = ws;
            state.workspaceReady = true;
            const snap = context.preResolvedAuth;
            if (snap) {
                snap.workspace = ws;
                if (snap.jwtClaims) snap.jwtClaims.active_workspace_id = activeWorkspaceId;
            }
        }).catch((err)=>{
            console.warn('[bootShell] eager getWorkspace failed:', err?.message || err);
            return null;
        }));
        // Hand the remaining composite-boot sections to loadPrivateData through
        // the context (shared→workspace layering: the workspace layer reads
        // context, never the reverse). SCOPE GUARD: members/prefs were scoped
        // server-side by the workspace id the boot REQUEST carried (the
        // pointer); only prime them when the client resolution landed on that
        // same workspace — a URL deep link to a different workspace/org must
        // fall back to its own explicitly-scoped fetches.
        if (_bootSections && _bootWsMatches) context.bootPayload = {
            workspaceId: String(activeWorkspaceId),
            members: Array.isArray(_bootSections.members) ? _bootSections.members : null,
            prefs: _bootSections.prefs || null
        };
        await Promise.all(scopeFetches);
        // THE CALLER'S ACCESS (MODULE-ROLE-CAN-BRIDGES-1). The shell's moduleRole /
        // moduleCan bridges answer from the record's `access` (the role the read
        // was gated on + the member's effective permission keys), and the server
        // adds it ONLY on a single workspace read (WorkspaceController.getWorkspace
        // -> callerAccess). A record adopted above without it — the list row of a
        // deep link to a workspace that is not the account's active one, the row
        // a failed `workspace` section falls back to, a section from a server
        // without it — left moduleRole unknown and moduleCan false for the whole
        // visit for every member who is not an org owner or admin (measured on dev
        // 2026-10-28: role-gated apps sat on their skeleton, with and without the
        // switcher's pointer). ONE rule for every branch above: the boot's record
        // lacks `access` -> read the workspace ONCE, in the BACKGROUND (never
        // awaited: first paint keeps the row's gain) and merge `access` in when it
        // lands. `force` skips the cache, which may hold this very row, and stores
        // the complete record for every later reader; a reader that asks while it
        // flies joins it.
        //
        // Where the answer lands:
        //   • the SEED — `state.workspace` and the snapshot the shell's create pass
        //     seeds into the live root — for any landing before the mount takes it;
        //   • the warm start's already-mounted shell, through the record owner;
        //   • any live root handed to the result's `completeWorkspaceAccess(root)`
        //     (the post-mount step hands the root it mounted), through the owner.
        // Only while the record still names THIS workspace (the person may have
        // moved on), is still full and still lacks `access`; the merge is a copy
        // that keeps every field the record had.
        const _accessWsId = activeWorkspaceId ? String(activeWorkspaceId) : '';
        const _seedWs = state.workspace;
        if (_accessWsId && _seedWs && _seedWs._shape === 'full' && String(_seedWs.id || _seedWs._id || '') === _accessWsId && !(_seedWs.access && typeof _seedWs.access === 'object') && typeof sdk.getWorkspace === 'function') {
            const _withAccess = (rec, access)=>access && rec && typeof rec === 'object' && rec._shape === 'full' && String(rec.id || rec._id || '') === _accessWsId && !(rec.access && typeof rec.access === 'object') ? {
                    ...rec,
                    access: access
                } : null;
            // A consumer that throws inside the root's update must not turn this
            // background step into an unhandled rejection: warn, answer false.
            const _toLiveRoot = (root, access)=>{
                const next = root && _withAccess(root.workspace, access);
                if (!next) return false;
                try {
                    (0, $9IIym.setActiveWorkspaceRecord)(root, next, {
                        reason: 'boot-access'
                    });
                } catch (err) {
                    console.warn('[bootShell] workspace access merge failed:', err?.message || err);
                    return false;
                }
                return true;
            };
            const _accessRead = Promise.resolve().then(()=>getWorkspaceCached ? getWorkspaceCached(sdk, _accessWsId, {
                    force: true
                }) : sdk.getWorkspace(_accessWsId)).then((res)=>{
                const raw = res?.data || res || null;
                return raw && String(raw._id ?? raw.id ?? '') === _accessWsId && raw.access && typeof raw.access === 'object' ? raw.access : null;
            }).catch((err)=>{
                console.warn('[bootShell] workspace access read failed:', err?.message || err);
                return null;
            });
            _accessRead.then((access)=>{
                if (!access) return;
                const _seeded = _withAccess(state.workspace, access);
                if (_seeded) state.workspace = _seeded;
                const _snap = context.preResolvedAuth;
                if (_snap) {
                    const _snapNext = _seeded && _snap.workspace === _seedWs ? _seeded : _withAccess(_snap.workspace, access);
                    if (_snapNext) _snap.workspace = _snapNext;
                }
                if (_earlyShell && _earlyShell.state) _toLiveRoot(_earlyShell.state.root || _earlyShell.state, access);
            });
            _completeWorkspaceAccess = (root)=>_accessRead.then((access)=>_toLiveRoot(root, access));
        }
        // Canonicalize the address bar (scheme A path form — legacy `?ws=` is
        // rewritten to `/w/<org>/<handle>/…`) once the workspace is resolved, so
        // the URL is shareable + reload-stable from FIRST paint rather than only
        // after the first in-app navigation. No-op for single-workspace orgs (the
        // `/w/<slug>` prefix already names those unambiguously), when MWT is off,
        // and for foreign-org URLs (reconcileMwtOrgFromUrl owns those). Siblings
        // come from the URL org's list when that org drove the pick.
        (0, $g3Ned.syncWorkspaceUrl)({
            workspace: state.workspace,
            org: state.org,
            workspaces: _urlOrgWs && _wsResolved.orgId && _urlOrgWs[_wsResolved.orgId] || _wsList
        });
    }
    // 7c. THE WORKSPACE'S DEFAULT THEME at the COLD seed (Nika 2026-10-18,
    // GreenIG: "Dark theme by default"). The full record has landed (7 above)
    // and nothing is mounted yet, so `workspace.settings.theme` joins the seed
    // the cold create() reads (`globalTheme: themeMode`, bootShell step 8) —
    // the first paint is already right, no flip. Same precedence as 5b, decided
    // again from the base: the user's own choice → the workspace → the brand →
    // the OS (a stale warm-snapshot default never survives a cold boot).
    // ⚠️ NEVER on a mounted app: with a warm early shell the theme was seeded
    // from that scope's snapshot and stays — re-theming a mounted app is what
    // parked workspaceConfigs.js `WORKSPACE_DEFAULT_THEME_ENABLED` (bellforge
    // freeze). A changed record is right on the next load (the snapshot is
    // rewritten when the boot settles). Only a FULL record decides: a
    // list-shaped placeholder (the eager fetch missed its deadline) carries no
    // `settings`, and must not erase a default the snapshot seeded.
    if (!_earlyShell && state && state.workspace && state.workspace._shape === 'full') {
        const _coldThemeMode = (0, $3gQso.bootTenantThemeMode)({
            baseMode: themeBase,
            userChoseExplicitly: userChoseTheme,
            workspaceMode: (0, $3gQso.workspaceThemeModeOf)(state.workspace),
            brandMode: brandThemeMode
        });
        if (_coldThemeMode !== themeMode) {
            themeMode = _coldThemeMode;
            state.themeMode = themeMode;
            if (typeof document !== 'undefined') state.themeResolved = (0, $dEMgh.resolveThemeResolvedNow)(document, themeMode);
            (0, $jH1GV.bootTrail)('bootShell:theme:workspace');
        }
    }
    // 7b. INTERFACE LANGUAGE — resolve it, apply it, and load the bundles.
    //
    // This is the step that never existed. Nothing in the tree ever called
    // `loadI18nNamespace`: the only caller was `setLang`, which loops over
    // `getLoadedNamespaces()` — a set that is populated BY a load. Empty set →
    // `mergeAllNamespaces` returns `{}` → no translation had ever reached the UI
    // in any language. Everything else in the i18n stack was correct and inert.
    //
    // Resolution runs HERE, after the workspace scope resolved, because first
    // paint had no workspace. Precedence (functions/languages.js, THE LAW —
    // Nika 2026-09-10 "default language is english. only workspaces that are
    // specifically set as Georgian should render in georgian"):
    //   workspace enforced > workspace.settings.language > branding.lang > en
    //
    // The member's account preference (`user.preferences.lang`) and this
    // device's `localStorage.lang` used to sit between the enforced level and
    // the workspace default; they no longer decide a workspace's interface
    // language at all. Measured on dev 2026-09-10: the Symbols HQ workspace,
    // which sets no language, rendered Georgian off exactly those two values.
    //
    // The resolved value is applied DIRECTLY rather than through `setLang`.
    // `setLang` is the USER-INITIATED path and it persists — a language the
    // system merely resolved is persisted nowhere: not to the device, not to the
    // account. Nothing in boot writes `localStorage.lang` any more, except the
    // step-8b RESTORE of whatever was there before the warm-mount delivery.
    //
    // Whole block is try-guarded: a language is chrome, and no failure in it may
    // stop the shell from mounting. `_resolvedLang` is declared OUTSIDE the try
    // so step 8 can deliver it to the live element on both mount paths — see
    // "the resolved language must reach the MOUNTED app" there. It falls back to
    // the early value, so a throw in here leaves step 8 with exactly the language
    // first paint already had, never `undefined`.
    let _resolvedLang = lang;
    try {
        // The workspace's language pair: the live record's `settings` when the
        // scope fetch produced them, else the warm snapshot's cached pair for the
        // SAME workspace. The fallback matters when the eager fetch failed or
        // returned a record with no `settings`: resolving "set to nothing" there
        // would paint English over the Georgian first paint step 1 already made,
        // and the full record would then paint Georgian a third time.
        const _liveWs = state?.workspace || null;
        const _liveWsSettings = _liveWs && _liveWs.settings && typeof _liveWs.settings === 'object' ? _liveWs.settings : null;
        const _wsLangBag = _liveWsSettings || (_cachedWsLanguage && (!_liveWs || String(_liveWs.id || _liveWs._id || '') === String(warmSnapshot.workspaceId || '')) ? _cachedWsLanguage : null);
        const _wsDefaultLang = _wsLangBag?.language || null;
        // The white-label host's own language, the weakest signal in the chain and
        // the only one that exists BEFORE sign-in. `whitelabelBrand` is the public
        // branding projection already awaited above for the theme and the mark, so
        // this costs no extra request. Without it a first-time visitor to a branded
        // login had no signal at all above `en`: the Georgian bundles were shipped
        // and complete, and nothing on the page could ask for them.
        // The seed is bounded at 600ms (a slow lookup must never delay the
        // mount), so on a cold API the brand can still be IN FLIGHT here — and
        // then `whitelabelBrand` is null, the language resolves to `en`, and the
        // late brand re-render restores the mark but never the language.
        // Measured on gita.pr.symbols.app (staging, 2026-09-08): scope said
        // `lang: 'ka'`, hydrated `<html lang="en">`. The language is the one
        // thing a branded host must not boot without, so wait for the SAME
        // lookup to settle, bounded once more so an unreachable API still
        // cannot hold the shell.
        // ONE settle, TWO readings of the result. `settleWhitelabelBrand`
        // (publicBootLang.js) is the shared helper the branded /login bounce also
        // calls, so the record is bound here rather than inlined into the
        // `_brandLang` expression — the enforced level below needs the SAME
        // record, and settling it twice would be a second await on a boot path.
        const _brandRecord = await (0, $aNuMw.settleWhitelabelBrand)(state);
        const _brandLang = _brandRecord?.lang || null;
        // THE ENFORCED LEVEL. Two sources, same shape, same reader
        // (`enforcedWorkspaceLang` — the one place that decides whether the
        // `language` + `languagePolicy` pair is live), tried strongest first:
        //
        //   1. the live workspace record, once the scope has resolved. This is
        //      the authoritative one and the one that matters after sign-in.
        //   2. the branded host's `workspaceLanguage`, carried on the SAME public
        //      custom-domain scope lookup settled just above for the mark and the
        //      theme. It exists so a branded host enforces from FIRST PAINT
        //      instead of booting into the visitor's own language and re-languaging
        //      the page once the workspace record lands. Distinct from
        //      `_brandLang` above, which is the ORG's language and the weakest
        //      signal there is.
        //
        // ⚠️ THE BRANDED /login BOUNCE DELIBERATELY HAS NO ENFORCED LEVEL.
        // That exit never reaches 7b — it resolves through `applyPublicBootLang`,
        // which asks the page's `?lang=`, the brand and the browser, and
        // nothing more. The reason is not that the pair is unavailable there (the
        // same scope carries it): a visitor on a login form is not INSIDE the
        // workspace yet, so a workspace rule has no one to bind. The page's own
        // `?lang=`, the host's `branding.lang` and the visitor's browser are the
        // right signals for that page (KA-1). The enforced level starts at the
        // first authenticated boot, which is this one.
        //
        // Both sources are `null` for every workspace that did not enforce, and
        // then this level does not exist and the four below decide exactly as they
        // always have.
        const _enforcedLang = (0, $cvFPD.enforcedWorkspaceLang)(_wsLangBag) || (0, $cvFPD.enforcedWorkspaceLang)(_brandRecord?.workspaceLanguage);
        _resolvedLang = (0, $cvFPD.resolveLang)({
            workspaceEnforced: _enforcedLang,
            workspaceDefault: _wsDefaultLang,
            brandDefault: _brandLang
        });
        // `context.polyglot` is minted in step 1b, BEFORE either mount — `_poly`
        // below is that same object. Nothing here may mint a second one: the app
        // binds whatever `context.polyglot` was at `create()` time, and a later
        // object is written into by boot and read by nobody.
        // Which namespaces this session needs — `sessionI18nNamespaces` (top of
        // this step) computes it: the ONE computation the signed-out /login bounce
        // reads too, so the two exits can never declare different sets.
        const _namespaces = new Set(sessionI18nNamespaces());
        // `setLang` reads this to know which namespaces to load when the language
        // changes. It is the session's declared set, so a switch reloads exactly
        // what this surface uses — not everything the platform ships.
        _poly.namespaces = Array.from(_namespaces);
        // ENGLISH IS BUNDLED; EVERY OTHER LANGUAGE IS A LAZY, PER-NAMESPACE CHUNK.
        //
        // The static English seed moved UP to step 1b — it must land before the
        // first `create()`, because `prepareState` seeds the active language's keys
        // into the root state DURING the mount. `_poly.translations` already
        // carries it by the time this runs.
        //
        // This used to seed English statically and FETCH the rest. Measured live on
        // the running shell, that fetch could never have worked: Parcel compiles a
        // `.json` asset into a `.js` module, so the asset URL for `ka/common`
        // resolved to `/common.f873341d.js`; `res.json()` threw on 31 KB of
        // JavaScript and every `ka` namespace fell back to English. The runtime
        // path `/i18n/ka/common.json` answered 200 with the dev server's SPA
        // fallback HTML — a 200 that is not JSON, which `res.ok` accepts. The
        // language flipped, `translations.ka` stayed at 0 keys, and the UI stayed
        // English with nothing reported. The loader has no network path at all
        // now; the non-English bundles arrive as bundler-resolved chunks.
        // Register the session's namespace set with the loader even on an English
        // boot. `loadI18nNamespace` records every namespace it is asked for, and
        // that record is what a later switch re-loads — without this call an
        // English boot would hand `setLang` an empty set and a switch would fetch
        // `common` alone.
        await (0, $j7gGM.loadI18nNamespaces)((0, $cvFPD.DEFAULT_LANG), Array.from(_namespaces));
        // The English rescue: when the static map is empty (frank's revived
        // runtime never runs a module body), whatever the payload carries is all
        // there is — `mergeAllNamespaces` reads exactly that.
        if (!Object.keys(_poly.translations[0, $cvFPD.DEFAULT_LANG] || {}).length) _poly.translations[0, $cvFPD.DEFAULT_LANG] = (0, $j7gGM.mergeAllNamespaces)((0, $cvFPD.DEFAULT_LANG));
        // A non-English boot loads its chunks HERE, in parallel, before the mount —
        // so first paint is already translated instead of flashing English. Only
        // the namespaces this surface declared, never the whole platform.
        if (_resolvedLang !== (0, $cvFPD.DEFAULT_LANG)) {
            const _merged = await (0, $j7gGM.loadI18nNamespaces)(_resolvedLang, Array.from(_namespaces));
            if (Object.keys(_merged).length) {
                const _existing = _poly.translations[_resolvedLang] || {};
                // Same collision rule as setLang: a chunk the registry really served is
                // the newer truth; a fallback must never erase a baked translation.
                _poly.translations[_resolvedLang] = _namespaces.size ? Array.from(_namespaces).some((ns)=>(0, $j7gGM.hasI18nBundle)(_resolvedLang, ns)) ? {
                    ..._existing,
                    ..._merged
                } : {
                    ..._merged,
                    ..._existing
                } : _existing;
            }
        }
        if (state) state.lang = _resolvedLang;
        if (_resolvedLang !== lang && typeof document !== 'undefined' && document.documentElement) {
            document.documentElement.lang = _resolvedLang;
            document.documentElement.dir = (0, $cvFPD.langDir)(_resolvedLang);
        }
        (0, $jH1GV.bootTrail)('bootShell:i18n');
    } catch (err) {
        console.warn('[bootShell] i18n boot failed:', err?.message || err);
    }
    // no SDK at all (a fail-closed API plane): nobody is signed in
    if (typeof context.bootSignedIn !== 'boolean') context.bootSignedIn = false;
    return {
        aborted: false,
        signedIn: context.bootSignedIn,
        themeMode: themeMode,
        storedThemeMode: prep && prep.themeMode,
        lang: _resolvedLang,
        earlyShell: _earlyShell,
        state: state,
        storage: storage,
        completeWorkspaceAccess: _completeWorkspaceAccess
    };
}

});
parcelRegister("h1nln", function(module, exports) {

$parcel$export(module.exports, "realtimeProvider", () => $c644a3441d7bdc50$export$a47f7195108eb10a);
/**
 * sdkRealtimeProvider — realtime backend for the SDK's
 * `workspaceProject.realtime.*` API surface.
 *
 * Wired into the SDK at boot via
 * `(await sdk.getService('workspaceProject')).setRealtimeProvider(realtimeProvider)`.
 * Once installed, every consumer using
 *   `sdk.execute('workspaceProject.realtime.<entity>', 'subscribe', filter, cb)`
 * gets live events through the transport this provider selects per op.
 *
 * ── Live transports ──────────────────────────────────────────────────────────
 *   'meet'          → server SSE stream (GET /core/meet/stream) via the SDK's
 *                     `workspaceProject.realtime.subscribeMeetSse` (_openMeetSse).
 *                     Emits the (kind, payload) + snake_case `{eventType,new,old}`
 *                     envelope meet consumers expect.
 *   'presence'      → SDK /user-socket presence registry (sdk.subscribePresence,
 *                     _openPresenceSocket).
 *   'notifications' → SDK /user-socket: the server emits `notification-created`
 *                     to the recipient's `user:<id>` room at the notifications
 *                     store write choke point, reframed here into the
 *                     `{eventType:'INSERT', new, old}` envelope
 *                     (_openNotificationsSocket).
 *
 * ── Retired backend ─────────────────────────────────────────────────────────
 * Supabase (the governance project) is fully retired. It formerly served
 * chat.messages / chat.channels / chat.mentions and the presence channel via
 * postgres_changes; those ops no longer have a backend, so the provider no
 * longer handles them: they fall through (no return) and the SDK's
 * `_realtimeSubscribe` coerces the absent unsubscribe to a no-op. Chat
 * realtime is owned by the /chat page's own `subscribeRealtime.js` (server
 * SSE), never this provider.
 *
 * Provider contract (from WorkspaceProjectService):
 *   ({ op, filter, callback }) → unsubscribe fn
 */ parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $c644a3441d7bdc50$export$a47f7195108eb10a = ({ op: op, filter: filter = {}, callback: callback })=>{
    if (typeof callback !== 'function') return ()=>{};
    // presence: socket transport (the cutover end-state). Routes through the
    // SDK's /user-socket presence (sdk.subscribePresence) and reframes its
    // `presence:sync` state into the consumer callback('sync', { state }).
    // `state` is byte-compatible with Supabase channel.presenceState(), so
    // presence.js needs no change. Returns the SDK subscription's unsub
    // (disconnects the socket → server drops the user).
    const openPresenceSocket = ({ filter: f, callback: cb })=>{
        const scope = f.scope || 'symbols';
        try {
            const sdk = (0, $1NxyO.getSDK)();
            if (!sdk || typeof sdk.subscribePresence !== 'function') return ()=>{};
            const sub = sdk.subscribePresence({
                scope: scope,
                userKey: f.userKey,
                meta: f.meta || {}
            }, (state)=>{
                try {
                    cb('sync', {
                        state: state
                    });
                } catch (_) {}
            });
            // Through the init-await proxy the subscription arrives as a PROMISE of
            // the unsub; returned bare, the SDK coerced it to a no-op and an
            // unsubscribe never disconnected the socket.
            return ()=>{
                Promise.resolve(sub).then((unsub)=>{
                    if (typeof unsub === 'function') unsub();
                }).catch(()=>{});
            };
        } catch (err) {
            console.warn('[realtimeProvider] presence socket subscribe failed:', err?.message || err);
            return ()=>{};
        }
    };
    // notifications: user-socket transport (the cutover end-state). The server
    // emits `notification-created` (the wire-shaped row, same shape the REST
    // list returns) to the recipient's `user:<id>` room from the
    // notifications-store write choke point (server
    // src/domains/notifications/store/index.js) — re-frame it into the
    // postgres_changes INSERT envelope so the consumer
    // (subscribeNotifications.js reads payload.new) is byte-unchanged. The
    // room is per-recipient, so no client-side user_email filter is needed —
    // the server only emits to the notification's recipient.
    const openNotificationsSocket = ({ callback: cb })=>{
        try {
            const sdk = (0, $1NxyO.getSDK)();
            if (!sdk || typeof sdk.subscribeUserEvents !== 'function') return ()=>{};
            return sdk.subscribeUserEvents({
                'notification-created': (row)=>{
                    if (!row) return;
                    try {
                        cb('INSERT', {
                            eventType: 'INSERT',
                            new: row,
                            old: null
                        });
                    } catch (_) {}
                }
            });
        } catch (err) {
            console.warn('[realtimeProvider] notifications socket subscribe failed:', err?.message || err);
            return ()=>{};
        }
    };
    // ── meet realtime: table-name normalization ───────────────────────────
    // Accept BOTH short keys (`rooms`, `participants`, `waiting`,
    // `transcripts`, `analyses`) and the full table names. Several call sites
    // pass the full names; without this every subscription fell through (the
    // old captions bug).
    const MEET_TABLE_ALIASES = {
        meet_rooms: 'rooms',
        meet_participants: 'participants',
        meet_waiting_room: 'waiting',
        meet_transcripts: 'transcripts',
        meet_transcript_analyses: 'analyses'
    };
    const normalizeMeetTable = (t)=>MEET_TABLE_ALIASES[t] || t;
    // ── meet realtime: server-SSE transport ────────────────────────────────
    // Delegates to the SDK's `workspaceProject.realtime.subscribeMeetSse`,
    // which owns the EventSource client + the SSE→(kind,payload) re-framing.
    // The SDK preserves the SAME (kind, payload) + snake_case
    // `{eventType,new,old}` contract, so the consumer is unchanged.
    //
    // getService('workspaceProject') is a promise on the shell's SDK proxy
    // (and may also be asked before the SDK is ready). Resolve it and return a
    // deferred unsub — the same pattern subscribeMeetRealtime.js uses.
    const openMeetSse = ({ filter: f, callback: cb })=>{
        let resolvedUnsub = null;
        let cancelled = false;
        const tables = Array.isArray(f.tables) && f.tables.length ? [
            ...f.tables
        ].map(normalizeMeetTable) : undefined;
        // getService answers a PROMISE through the shell's init-await proxy
        // (sdkClient.js wrapWithInitAwait). Read synchronously, `wp` was that
        // promise, `wp.realtime` was undefined and no stream ever opened.
        const open = (wp)=>{
            if (cancelled) return;
            const sub = wp?.realtime?.subscribeMeetSse;
            if (typeof sub !== 'function') {
                console.warn("[meet-rt] SSE subscribe unavailable \u2014 no realtime.subscribeMeetSse");
                return;
            }
            const unsub = sub.call(wp.realtime, {
                roomId: f.roomId || undefined,
                workspaceId: f.workspaceId || undefined,
                tables: tables
            }, cb);
            resolvedUnsub = typeof unsub === 'function' ? unsub : null;
        };
        try {
            Promise.resolve((0, $1NxyO.getSDK)()?.getService?.('workspaceProject')).then(open).catch((err)=>{
                console.warn('[meet-rt] SSE subscribe failed:', err?.message || err);
            });
        } catch (err) {
            console.warn('[meet-rt] SSE subscribe failed:', err?.message || err);
        }
        return ()=>{
            cancelled = true;
            if (typeof resolvedUnsub === 'function') try {
                resolvedUnsub();
            } catch (_) {}
            resolvedUnsub = null;
        };
    };
    // meet → server SSE.
    if (op === 'meet') return openMeetSse({
        filter: filter,
        callback: callback
    });
    // presence → SDK /user-socket presence registry.
    if (op === 'presence') return openPresenceSocket({
        filter: filter,
        callback: callback
    });
    // notifications → SDK /user-socket (`notification-created` emitted server-side
    // at the store write path).
    if (op === 'notifications') return openNotificationsSocket({
        callback: callback
    });
// Any other op has no realtime backend — the chat/presence ops formerly
// served by the retired governance Supabase project. Fall through: the
// SDK's `_realtimeSubscribe` normalizes the absent unsubscribe return to a
// no-op.
};

});

parcelRegister("iA4IC", function(module, exports) {

$parcel$export(module.exports, "diagnoseAuth", () => $d86f3fcc3acb3cc5$export$dbc2ee77fc19789e);
$parcel$export(module.exports, "runAuthDiagnostic", () => $d86f3fcc3acb3cc5$export$5cea61f51fe21dfa);
// Auth diagnostics — decodes the local auth state without hitting the
// network so callers can tell at a glance whether the SDK Mongo token
// (`symbols_access_token`) is present and unexpired. The federated
// governance JWT this file used to inspect was retired with the
// governance Supabase project — the SDK token is the only session.
//
// Use:
//   import { diagnoseAuth } from '<shared>/functions/diagnoseAuth.js'
//   console.table(diagnoseAuth())
// Or call `window.__auth.diagnose()` in the browser console (wired by
// bootShell at boot).
/**
 * Returns a structured snapshot of the local auth state. No network calls.
 *
 * Shape:
 *   {
 *     sdk: { present, expiresInSec, expired },
 *     diagnosis: 'all_missing' | 'sdk_only',
 *     suggestedAction: string
 *   }
 */ const $d86f3fcc3acb3cc5$export$dbc2ee77fc19789e = ()=>{
    // FA204 / frank trap — inlined (self-contained local) instead of the bare
    // module-scope reads; this is the export's own copy so it stays correct
    // once frank.toJSON'd individually for platform delivery.
    const _readSdkToken = ()=>{
        if (typeof window === 'undefined') return null;
        try {
            return window.localStorage.getItem('symbols_access_token');
        } catch  {
            return null;
        }
    };
    const _decodeJwt = (token)=>{
        if (!token || typeof token !== 'string') return null;
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        try {
            const padded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
            const json = atob(padded + '='.repeat((4 - padded.length % 4) % 4));
            return JSON.parse(json);
        } catch  {
            return null;
        }
    };
    const _expiryStatus = (epochSec)=>{
        if (!epochSec) return {
            expired: null,
            secondsLeft: null
        };
        const now = Date.now() / 1000;
        const left = epochSec - now;
        return {
            expired: left <= 0,
            secondsLeft: Math.floor(left)
        };
    };
    const sdkToken = _readSdkToken();
    const sdkClaims = _decodeJwt(sdkToken);
    const sdkExp = _expiryStatus(sdkClaims?.exp);
    const sdk = {
        present: !!sdkToken,
        expiresInSec: sdkExp.secondsLeft,
        expired: sdkExp.expired
    };
    let diagnosis;
    let suggestedAction;
    if (!sdk.present) {
        diagnosis = 'all_missing';
        suggestedAction = 'No tokens in localStorage. Sign in.';
    } else {
        diagnosis = 'sdk_only';
        suggestedAction = "SDK token present; the legacy governance JWT is absent \u2014 which is the NORMAL state since the federation plane was removed. No action needed.";
    }
    return {
        sdk: sdk,
        diagnosis: diagnosis,
        suggestedAction: suggestedAction
    };
};
const $d86f3fcc3acb3cc5$export$5cea61f51fe21dfa = ()=>{
    // FA204 / frank trap — self-contained inline copy of diagnoseAuth (a bare
    // sibling-export call is exactly as unresolvable post-frank.toJSON as a
    // module-local read; the export above stays live for its real consumer,
    // bootShell.js's plain ESM import — cross-file imports resolve fine via
    // frank's globalScope fallback, only bare same-file sibling reads break).
    const _diagnoseAuth = ()=>{
        const _readSdkToken = ()=>{
            if (typeof window === 'undefined') return null;
            try {
                return window.localStorage.getItem('symbols_access_token');
            } catch  {
                return null;
            }
        };
        const _decodeJwt = (token)=>{
            if (!token || typeof token !== 'string') return null;
            const parts = token.split('.');
            if (parts.length !== 3) return null;
            try {
                const padded = parts[1].replace(/-/g, '+').replace(/_/g, '/');
                const json = atob(padded + '='.repeat((4 - padded.length % 4) % 4));
                return JSON.parse(json);
            } catch  {
                return null;
            }
        };
        const _expiryStatus = (epochSec)=>{
            if (!epochSec) return {
                expired: null,
                secondsLeft: null
            };
            const now = Date.now() / 1000;
            const left = epochSec - now;
            return {
                expired: left <= 0,
                secondsLeft: Math.floor(left)
            };
        };
        const sdkToken = _readSdkToken();
        const sdkClaims = _decodeJwt(sdkToken);
        const sdkExp = _expiryStatus(sdkClaims?.exp);
        const sdk = {
            present: !!sdkToken,
            expiresInSec: sdkExp.secondsLeft,
            expired: sdkExp.expired
        };
        let diagnosis;
        let suggestedAction;
        if (!sdk.present) {
            diagnosis = 'all_missing';
            suggestedAction = 'No tokens in localStorage. Sign in.';
        } else {
            diagnosis = 'sdk_only';
            suggestedAction = "SDK token present; the legacy governance JWT is absent \u2014 which is the NORMAL state since the federation plane was removed. No action needed.";
        }
        return {
            sdk: sdk,
            diagnosis: diagnosis,
            suggestedAction: suggestedAction
        };
    };
    const result = _diagnoseAuth();
    console.group('[auth-diagnostic]');
    console.log('diagnosis:', result.diagnosis);
    console.log('suggestion:', result.suggestedAction);
    console.log('sdk:', result.sdk);
    console.groupEnd();
    return result;
};

});

parcelRegister("dEMgh", function(module, exports) {

$parcel$export(module.exports, "resolveThemeResolvedNow", () => $9f1472857792ad56$export$c458783f43621ff0);
$parcel$export(module.exports, "watchThemeResolved", () => $9f1472857792ad56$export$89fd9d28afaed26d);
// themeResolved.js — the reactive carrier for the RESOLVED global theme
// (`'dark' | 'light'`), decided in tickets/opus.md ("DECIDED: `themeResolved`
// — the workspace-shell half (`shared/` is approved)", Nika 2026-08-11:
// "shared/ proceeds, split the work").
//
// ── The gap this closes ──────────────────────────────────────────────────
// `root.themeMode` is the user's MODE (`auto|light|dark`); `context.globalTheme`
// is the boot-time mode and is never rewritten. Neither ever carries what
// `'auto'` resolved TO. Under `'auto'`, scratch's own prefers-color-scheme
// listener flips the document's `data-theme` attribute directly — no
// `subscribeTo`/factory anywhere re-fires, so an OS scheme change is
// invisible to the whole tree until something unrelated triggers a repaint
// (`moduleImportBridge.js`'s `moduleTheme()` bridge is the non-reactive
// workaround this gap forced; it stays exactly as-is — this file is
// additive, not a replacement).
//
// ── Why this does NOT duplicate matchMedia ──────────────────────────────
// The rejected shape (see the ticket) is the shell re-deriving the OS
// preference itself — that duplicates logic that belongs a layer down in
// scratch, and only covers whichever surfaces the shell drives directly.
// Instead this watches the EFFECT both causes already produce on `<html>`:
// a `data-theme` attribute mutation. A user-driven `changeGlobalTheme` call
// and scratch's own OS-driven 'auto' flip both write that attribute, so one
// MutationObserver singleton, filtered to `attributeFilter: ['data-theme']`,
// catches every cause with zero framework hook and zero matchMedia
// duplication — the exact pattern `watchCanvasBackgroundTheme` (below,
// canvasBackground.js) already proved out for the canvas-bg cookie var.

var $jlzPZ = parcelRequire("jlzPZ");
const $9f1472857792ad56$export$c458783f43621ff0 = (doc = globalThis.document, mode)=>(0, $jlzPZ.resolveCanvasBackgroundTheme)(mode, doc);
const $9f1472857792ad56$export$89fd9d28afaed26d = (root, doc = globalThis.document, mode)=>{
    const rootEl = doc?.documentElement;
    if (!rootEl || !root) return null;
    // Inlined resolveThemeResolvedNow's own body rather than calling it bare —
    // a bare sibling-export call is the same frank-trap class this sweep
    // exists to fix (project_frank_drops_module_local_helpers).
    // resolveCanvasBackgroundTheme stays a bare reference: it is an IMPORT
    // (canvasBackground.js), not a module-local/sibling-export binding, and
    // imports resolve fine post-frank.toJSON. resolveThemeResolvedNow itself
    // stays exported — bootShell.js imports and calls it directly.
    root.themeResolved = (0, $jlzPZ.resolveCanvasBackgroundTheme)(mode, doc);
    if (doc.__themeResolvedWatcher) return doc.__themeResolvedWatcher;
    const Observer = doc.defaultView?.MutationObserver || globalThis.MutationObserver;
    if (!Observer) return null;
    const observer = new Observer(()=>{
        root.themeResolved = (0, $jlzPZ.resolveCanvasBackgroundTheme)(undefined, doc);
    });
    observer.observe(rootEl, {
        attributes: true,
        attributeFilter: [
            'data-theme'
        ]
    });
    doc.__themeResolvedWatcher = observer;
    return observer;
};

});

parcelRegister("hGAnX", function(module, exports) {

$parcel$export(module.exports, "GUEST_ROUTE_RE", () => $ce0295464e8e5449$export$50fb7241f9a1a59b);
$parcel$export(module.exports, "isGuestAllowedPath", () => $ce0295464e8e5449$export$1e111fd9100a21a0);
// Canonical "renders for guests" route allowlist — the SINGLE source of truth
// shared by the bootShell load-gate AND the SPA route-change guard
// (workspace/app.js _authRouteGuard). Any path NOT matching this is a
// PROTECTED workspace page: an unauthenticated visit — whether a hard page
// load OR a client-side router navigation — is bounced to /login.
//
// SECURITY: keeping ONE regex here means the load-gate and the nav-guard can
// never drift. That invariant is load-bearing — before this, the gate only
// ran at hard page-load (bootShell getMe → /login), so a client-side
// `el.router('/')` (e.g. the old /login "X" close button) walked straight into
// the authed app with no credentials (platform#2278). The nav-guard closes
// that hole; this list is what both gates agree on.
//
// Members:
//   - auth chrome: login / signin / signup / signup-confirmation /
//     reset-password / forgot-password / verify-email, plus the OAuth +
//     magic-link callbacks (auth/callback, auth/magic-callback,
//     github-auth-callback)
//   - anonymous-by-design surfaces: meet-guest (waiting-room join form),
//     _session-bridge (cross-app token hop)
//   - public read surfaces: /user/:slug + /u/:slug (public profiles),
//     /marketplace[/…] (public catalogue), /feed[/…]
//   - demo gate: /demo — the demo.symbols.app email gate (isDemoHost), an
//     anonymous-by-design surface where unauthed is the expected state; without
//     it bootShell's load-gate rewrites /demo → /login and the gate never shows.
//   - invitation landings: /accept-invite, /accept-org-invite,
//     /accept-team-invite, /accept-workspace-invite, /waitlist-invite — the
//     server's emailed buildInviteUrl targets. They must render PRE-AUTH so the
//     accept page itself can bounce unauthed recipients to /login?next=<self>
//     with the ?token= intact (waitlist forwards to /signup?token=…). A gate
//     that rewrote them to bare /login is exactly the P0 invite dead-end
//     (2026-08-06).
// THE ONE public-path list: the boot gate (bootResolve) AND the shell's router
// guard / cold-boot bounce (workspace auth.js authRedirectTarget, through
// isGuestAllowedPath) read it. `s/<token>` is the public share-link viewer
// (PUBLIC-SHARE-LINKS-1): its token IS the credential.
const $ce0295464e8e5449$export$50fb7241f9a1a59b = /^\/(demo|login|signin|signup|signup-confirmation|reset-password|forgot-password|verify-email|auth\/magic-callback|auth\/callback|github-auth-callback|meet-guest|_session-bridge|accept-invite|accept-org-invite|accept-team-invite|accept-workspace-invite|waitlist-invite|user\/[^/]+|u\/[^/]+|s\/[^/?#]+)(\/|\?|#|$)|^\/(?:marketplace(?:\/(?:feed|installable-rail-demo|prompt-gallery))?|feed)\/?(?:[?#]|$)/;
const $ce0295464e8e5449$export$1e111fd9100a21a0 = (path)=>$ce0295464e8e5449$export$50fb7241f9a1a59b.test(typeof path === 'string' && path ? path : '/');

});

parcelRegister("aNuMw", function(module, exports) {

$parcel$export(module.exports, "settleWhitelabelBrand", () => $7dc65b963316add0$export$5de26e6e96d02a02);
$parcel$export(module.exports, "applyPublicBootLang", () => $7dc65b963316add0$export$dc6af9408755ca4d);
// WHITELABEL-BRAND-LANG-2 — the language of a LOGGED-OUT visitor on a
// branded host, and the one place that settles the brand record for boot.
//
// bootShell resolves the interface language at step 7b, AFTER the auth gate,
// because the strongest signals (the account preference, the workspace
// default) need a session. The branded LOGIN never reaches 7b: the gate
// bounces the anonymous visitor to /login and returns before it. So the auth
// shell mounted with first paint's `localStorage.lang || en`, and the org's
// `branding.lang` — the only signal that exists BEFORE sign-in — reached the
// marks and the tagline but never the copy. Measured twice on
// gita.pr.symbols.app (2026-09-08): scope `lang: 'ka'`, hydrated
// `<html lang="en">`, English login, no stored preference.

var $cvFPD = parcelRequire("cvFPD");

var $j7gGM = parcelRequire("j7gGM");
const $7dc65b963316add0$export$5de26e6e96d02a02 = async (state, timeoutMs = 2000)=>{
    if (!state) return null;
    if (state.whitelabelBrand) return state.whitelabelBrand;
    if (!state.whitelabelBrandLookup) return null;
    const TIMED_OUT = Symbol('whitelabelBrandLookupTimeout');
    const settled = await Promise.race([
        Promise.resolve(state.whitelabelBrandLookup).catch(()=>null),
        new Promise((resolve)=>setTimeout(()=>resolve(TIMED_OUT), timeoutMs))
    ]);
    if (!settled || settled === TIMED_OUT) return null;
    if (!state.whitelabelBrand) state.whitelabelBrand = settled;
    return settled;
};
const $7dc65b963316add0$export$dc6af9408755ca4d = async ({ context: context, namespaces: namespaces, query: query, browserLanguages: browserLanguages } = {})=>{
    const state = context && context.state;
    const brand = await $7dc65b963316add0$export$5de26e6e96d02a02(state);
    const search = typeof query === 'string' ? query : typeof window !== 'undefined' && window.location ? window.location.search : '';
    const nav = typeof navigator !== 'undefined' ? navigator : null;
    const browser = Array.isArray(browserLanguages) ? browserLanguages : nav && Array.isArray(nav.languages) && nav.languages.length ? nav.languages : nav && typeof nav.language === 'string' ? [
        nav.language
    ] : [];
    const SUPPORTED = [
        'en',
        'ka'
    ];
    const primary = (c)=>typeof c === 'string' ? c.trim().toLowerCase().split(/[-_]/)[0] : '';
    const ok = (c)=>SUPPORTED.indexOf(c) !== -1;
    const fromParams = (params)=>{
        const code = primary(params.get('lang'));
        return ok(code) ? code : null;
    };
    let fromQuery = null;
    try {
        const params = new URLSearchParams(search || '');
        fromQuery = fromParams(params);
        const next = params.get('next');
        const q = !fromQuery && typeof next === 'string' ? next.indexOf('?') : -1;
        if (q !== -1) fromQuery = fromParams(new URLSearchParams(next.slice(q).split('#')[0]));
    } catch (_) {
        fromQuery = null;
    }
    const fromBrand = primary(brand && brand.lang);
    const lang = fromQuery || (ok(fromBrand) ? fromBrand : null) || browser.map(primary).find(ok) || 'en';
    const poly = context && context.polyglot;
    if (poly && poly.translations) {
        const ns = Array.from(new Set([
            'common',
            'auth',
            ...namespaces || []
        ]));
        await (0, $j7gGM.loadI18nNamespaces)((0, $cvFPD.DEFAULT_LANG), ns);
        if (!Object.keys(poly.translations[0, $cvFPD.DEFAULT_LANG] || {}).length) poly.translations[0, $cvFPD.DEFAULT_LANG] = (0, $j7gGM.mergeAllNamespaces)((0, $cvFPD.DEFAULT_LANG));
        if (lang !== (0, $cvFPD.DEFAULT_LANG)) {
            const merged = await (0, $j7gGM.loadI18nNamespaces)(lang, ns);
            if (Object.keys(merged).length) {
                const existing = poly.translations[lang] || {};
                poly.translations[lang] = ns.some((n)=>(0, $j7gGM.hasI18nBundle)(lang, n)) ? {
                    ...existing,
                    ...merged
                } : {
                    ...merged,
                    ...existing
                };
            }
        }
    }
    if (state) state.lang = lang;
    if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.lang = lang;
        document.documentElement.dir = (0, $cvFPD.langDir)(lang);
    }
    return lang;
};

});

parcelRegister("1tihf", function(module, exports) {

$parcel$export(module.exports, "BOOT_CALL_DEADLINE_MS", () => $1126ad5aec9bb14f$export$23058d7d9678736a);
$parcel$export(module.exports, "withBootDeadline", () => $1126ad5aec9bb14f$export$6ef80fc8310dc73b);
$parcel$export(module.exports, "isBootDeadline", () => $1126ad5aec9bb14f$export$bbb1e9c5a45a3839);
$parcel$export(module.exports, "publishBootFailure", () => $1126ad5aec9bb14f$export$4381fe4efdbabd77);
// THE BOOT DEADLINE (2026-10-08, work.astio.ai "stuck on the loader when
// signed in"). The SDK's REST client has no request timeout, and the boot gate
// awaits its calls one after another (composite boot, getMe, the workspace
// list, the org switch, the scope reads). One request that never answers kept
// the shell on the loader for ever. Every network await of the boot gate now
// races this deadline: a lost request rejects with a BOOT_DEADLINE error, so
// the caller's own catch takes over (a scope read falls back to null, the
// session check shows the loader's error + reload state). The request itself
// is not cancelled; its late answer is ignored.
const $1126ad5aec9bb14f$export$23058d7d9678736a = 10000;
function $1126ad5aec9bb14f$export$6ef80fc8310dc73b(work, ms, label) {
    const limit = Number(ms) > 0 ? Number(ms) : 10000;
    return new Promise((resolve, reject)=>{
        let done = false;
        const timer = setTimeout(()=>{
            if (done) return;
            done = true;
            const err = new Error(`boot request "${label || 'call'}" did not answer in ${limit} ms`);
            err.code = 'BOOT_DEADLINE';
            err.name = 'TimeoutError';
            err.label = label || 'call';
            reject(err);
        }, limit);
        let p;
        try {
            p = typeof work === 'function' ? work() : work;
        } catch (err) {
            p = Promise.reject(err);
        }
        Promise.resolve(p).then((value)=>{
            if (done) return;
            done = true;
            clearTimeout(timer);
            resolve(value);
        }, (err)=>{
            if (done) return;
            done = true;
            clearTimeout(timer);
            reject(err);
        });
    });
}
function $1126ad5aec9bb14f$export$bbb1e9c5a45a3839(err) {
    return !!err && err.code === 'BOOT_DEADLINE';
}
function $1126ad5aec9bb14f$export$4381fe4efdbabd77(reason) {
    if (typeof window === 'undefined') return;
    const status = {
        phase: 'error',
        step: 1,
        reason: reason || 'boot_failed'
    };
    try {
        window.__smblsBootStatus = status;
    } catch (_) {
    /* a frozen window object keeps the event path below */ }
    try {
        if (typeof window.dispatchEvent === 'function' && typeof CustomEvent === 'function') window.dispatchEvent(new CustomEvent('smbls:boot-status', {
            detail: status
        }));
    } catch (_) {
    /* no event support: the cached status still reaches a late listener */ }
}

});


parcelRegister("de89x", function(module, exports) {

$parcel$export(module.exports, "bootApply", () => $9a12e828eb43acd3$export$2087e886b3115562);
// bootApply — boot step 3 of 3, after the shell is mounted.
//
// See bootPrepare.js for the one-boot design. This step hands the resolved
// boot to the LIVE shell: the resolved interface language (setLang — loads
// nothing new, the bundles are in context.polyglot already), the
// theme-resolved watcher and the modal-host arm.
//
// Published shell only (`seed` given): the root state already existed when
// bootResolve ran, so its writes went into a seed object — they land on the
// live root here, BEFORE the shell's own auth pass reads
// `context.preResolvedAuth`; and the theme is corrected to the resolved mode
// when it differs from the stored one create() painted (the tenant default —
// the parcel boot passes the resolved mode to create() itself:
// `themeApplied: true`).
//
// Inputs: the shell element, bootResolve's result, { seed, themeApplied }.

var $cvFPD = parcelRequire("cvFPD");

var $eANbz = parcelRequire("eANbz");

var $dEMgh = parcelRequire("dEMgh");
async function $9a12e828eb43acd3$export$2087e886b3115562(shell, res, { seed: seed = null, themeApplied: themeApplied = false } = {}) {
    if (!shell || !res || res.aborted) return shell;
    // THE VERDICT REACHES THE LIVE SHELL (one-boot review D3). A mount receives
    // a COPY of the boot context — the warm-start early mount's copy is taken
    // before the gate even ran — so the gate's verdict is written onto the
    // context the mounted elements actually hold.
    if (shell.context && typeof shell.context === 'object') {
        if (typeof res.signedIn === 'boolean') shell.context.bootSignedIn = res.signedIn;
        if (!shell.context.bootReady) shell.context.bootReady = Promise.resolve(res);
    }
    const _resolvedLang = res.lang;
    const storage = res.storage;
    if (seed && shell.state) {
        const _root = shell.state.root || shell.state;
        const _keys = Object.keys(seed);
        if (_keys.length && typeof _root.update === 'function') try {
            _root.update({
                ...seed
            }, {
                preventFetch: true
            });
        } catch (err) {
            console.warn('[bootApply] could not seed the live root:', err?.message || err);
        }
    }
    // The boot's workspace record may still owe the caller's `access` (bootResolve
    // reads it in the background): hand that read the LIVE root, so a landing after
    // the mount reaches it through the record owner. Not awaited; it never rejects.
    if (typeof res.completeWorkspaceAccess === 'function' && shell.state) res.completeWorkspaceAccess(shell.state.root || shell.state);
    if (!themeApplied && res.themeMode && res.themeMode !== res.storedThemeMode) try {
        shell.call('changeGlobalTheme', res.themeMode);
    } catch (err) {
        console.warn('[bootApply] could not apply the resolved theme:', err?.message || err);
    }
    // 8b. THE RESOLVED LANGUAGE MUST REACH THE **MOUNTED** APP.
    //
    // Step 7b writes `context.state.lang`. On the COLD path that write lands
    // before `create()`, so `prepareState` copies it into the root state and the
    // mount is already correct. On the WARM path the mount happened ~800 lines
    // ABOVE 7b, and the app DETACHED from the object 7b writes into: `create()`
    // spreads its options into a new object (smbls/packages/smbls/src/index.js),
    // `createDomql` then assigns `context.state = prepareState(app, context)`,
    // which `deepMerge`s into a FRESH object, and `element/create.js` takes a
    // further copy for the element's own state. Nothing overwrites `ka` with
    // `en`; the running app simply never held the object `ka` was written into.
    // That is why a returning member booted English while `<html lang>` — a
    // DOCUMENT write, and therefore global — read `ka` in the same boot.
    //
    // `setLang` is the one primitive that switches a LIVE element: it loads the
    // bundles, writes them into `context.polyglot`, calls the framework switch
    // (root state update + `[data-key]` re-render) and updates `<html lang>`.
    // `transient: true` is load-bearing: this language was RESOLVED, not chosen,
    // so it must persist nowhere — otherwise a workspace default stamps itself
    // into `localStorage.lang`, outranks `workspaceDefault` on the next boot, and
    // has impersonated a choice the member never made.
    //
    // Deliberately ONE path for both mounts rather than a branch inside the
    // warm-only block: the guard below is false on a correct cold boot (the root
    // already holds the resolved language), so this costs a comparison there, and
    // "after the mount, the live element holds the resolved language" is a single
    // statement instead of two that can drift apart. Guarded like the rest of the
    // language work — chrome must never stop a shell from mounting.
    //
    // ⚠️ THE `transient` GUARANTEE IS ENFORCED HERE, NOT ONLY ASKED FOR.
    // `el.call('setLang', …)` resolves through `context.functions`, and only a
    // consumer that merged @symbo-ls/workspace-shared has the platform's
    // three-argument `setLang` there. Everything else — a standalone, a context
    // assembled by hand — gets the FRAMEWORK's one-argument
    // `smbls/plugins/polyglot setLang(lang)`, which ignores the options bag and
    // writes `localStorage[storageLangKey]` unconditionally. That single write is
    // the impersonation bug in full: a workspace default lands in `lang`, comes
    // back on the next boot as `stored`, outranks `workspaceDefault` forever, and
    // no member can explain why their language changed. So bootShell snapshots
    // and restores the key around the call itself. Idempotent when the platform
    // `setLang` is the one that ran — it restores the same value first.
    if (shell && _resolvedLang) try {
        const _liveState = shell.state?.root || shell.state;
        // Deliver whenever the resolved language is not the base — NOT only when
        // the live state disagrees. On a warm mount the state already says `ka`
        // (it came from storage in step 1b) while the tree was rendered before
        // 7b merged a single Georgian bundle, so the "already correct" reading
        // was exactly the case that shipped an English page. `redeliver` pushes
        // the now-complete bundles through the mounted tree.
        if (_liveState && (_liveState.lang !== _resolvedLang || _resolvedLang !== (0, $cvFPD.DEFAULT_LANG))) {
            const _langBefore = storage?.getItem?.('lang') ?? null;
            try {
                await shell.call('setLang', _resolvedLang, {
                    transient: true,
                    redeliver: _liveState.lang === _resolvedLang
                });
            } finally{
                try {
                    if (_langBefore === null) storage?.removeItem?.('lang');
                    else storage?.setItem?.('lang', _langBefore);
                } catch (_) {}
            }
        }
    } catch (err) {
        console.warn('[bootShell] could not apply the resolved language:', err?.message || err);
    }
    // Wire the live `themeResolved` watcher onto the now-created root — one
    // singleton MutationObserver per document (see themeResolved.js), so
    // every future `data-theme` flip (a `changeGlobalTheme` call OR scratch's
    // own OS-driven 'auto' listener) keeps `root.themeResolved` correct for
    // the rest of the session with zero framework hook and zero duplicated
    // matchMedia logic. Runs for BOTH branches above (warm-start reconcile
    // and cold create()) — both are awaited ELEMENTS past this point, never a
    // pending Promise (see the cold-branch comment). Pinned by
    // bootShell.themeBootWiring.test.js.
    if (typeof document !== 'undefined' && shell?.state) (0, $dEMgh.watchThemeResolved)(shell.state.root || shell.state, document);
    // WS-SHELL-MOUNT-TREE-BUILD-2700MS-1 — arm the deferred modal host.
    //
    // The shell mounts `ModalRoot` behind an `if: s.root._modalHostReady`
    // latch, so its 246 elements (measured 468 ms) stay OUT of the boot task.
    // `openModal` is a call, not a state carrier, and smbls flushes effects on
    // a microtask, so a first-open latch could not build the host in time for
    // the `resolveModalRoot` that the same call makes. Instead the latch flips
    // on ONE bounded yield right here: the shell is mounted, first paint has
    // happened, and nothing has been able to push a layer yet — every opener
    // stays untouched.
    //
    // Deliberately NOT awaited: the boot continues into its own continuation
    // while the host builds in the following frame. Apps that still mount
    // `ModalRoot` eagerly (canvas, preview) simply write a key nothing gates on.
    if (shell?.state) {
        const _shellRootState = shell.state.root || shell.state;
        if (_shellRootState && !_shellRootState._modalHostReady) {
            const armModalHost = ()=>_shellRootState.update({
                    _modalHostReady: true
                }, {
                    preventFetch: true
                });
            // A HIDDEN document has no paint to yield to, and its timers are
            // throttled (1 s, then 1/min past ~5 minutes hidden) — measured live
            // 2026-08-22: a background-tab boot still had no modal host 18 s in,
            // which would make an `openModal` from a socket event in that tab warn
            // and no-op. That is a regression the eager mount never had, so a
            // hidden boot arms on a MessageChannel tick instead: a macrotask, so
            // the host still lands OUTSIDE the boot task, but an unthrottled one.
            const hidden = typeof document !== 'undefined' && document.visibilityState === 'hidden';
            if (hidden && typeof MessageChannel === 'function') {
                const ch = new MessageChannel();
                ch.port1.onmessage = ()=>{
                    ch.port1.close();
                    armModalHost();
                };
                ch.port2.postMessage(0);
            } else (0, $eANbz.yieldToPaint)().then(armModalHost);
        }
    }
    // Seed Mongo-only user fields into the live root state. Schema
    // declarations on `context.state` only define the runtime DEFAULTS;
    // pre-create mutations on `context.state.user` / `currentUserUsername`
    // don't propagate to the reactive root in smbls 3.14 (the framework
    // re-initialises from the schema).
    // CORRECTED 2026-08-09 (found while wiring the warm-start reconcile
    // above, which relies on the SAME primitive): the earlier note here
    // claimed "create()'s return value doesn't expose an enumerable .update /
    // .state surface" — that is not what's actually going on. `shell` DOES
    // have both (`@symbo.ls/element`'s `addMethods` puts `.update` on every
    // element's prototype, including the root, and `.state` is set directly
    // in `createElementState`). What silently no-ops is calling the
    // ELEMENT-level `shell.update({ currentUserUsername, user })` directly:
    // `update.js`'s per-param loop only recurses into EXISTING CHILD elements
    // or creates NEW ones for uppercase keys — a lowercase, non-child key
    // like `currentUserUsername` falls through to "set it as a plain element
    // property," which is invisible to any `s.currentUserUsername` reactive
    // read. The primitive that DOES reach the reactive store — proven by the
    // warm-start reconcile a few lines up, and by the existing
    // `s.root.update(...)` calls in app.js's onCreate and throughout
    // auth.js/loadPrivateData.js — is `shell.state.update({...})` (or the
    // element-level `shell.update({ state: {...} })`, which routes to the
    // same place). Not fixed here — out of this ticket's scope, and
    // AppHeader.ProfileItem.onClick's lazy `el.sdk.getMe()` fetch already
    // covers the gap — but corrected so the note stops pointing the next
    // reader at a "framework limitation" that isn't one. Flagged per Nika's
    // "clean the file while you're in there" condition on this edit.
    // 9-10. Pattern A: single-app auto-dispatch + listener wiring.
    // Multi-app callers (workspace/index.js) handle steps 9-10 themselves
    // by calling dispatchUrl + wireGlobalListeners after bootShell returns.
    return shell;
}

});

parcelRegister("UyBCS", function(module, exports) {

$parcel$export(module.exports, "setLang", () => $0aa0131529a51e15$export$a3665b844fbc095d);
/**
 * setLang — the ONE interface-language switch primitive.
 *
 * Updates `<html lang>` + `<html dir>`, evicts the stale fetch cache, loads the
 * i18n namespaces for the target language, hands them to smbls polyglot so
 * `{{ key | polyglot }}` resolves, updates the root state so every reactive
 * prop re-evaluates, persists the choice to this device, and (for a real user
 * choice) to the account.
 *
 * ── Why this is a `function` and not an arrow ──────────────────────────────
 * `el.call('setLang', code)` resolves through `context.functions` and invokes
 * `method.call(element, ...args)` (smbls element/src/methods.js). An ARROW
 * function cannot receive that binding — `this` stays the module scope — so the
 * old arrow form threw away the only handle it had on the app. `LangSwitcher`
 * passes no `opts`, so `opts.context` was undefined too: `sdk`, `shellState`
 * and the polyglot bridge below were ALL dead on the switcher path, and a click
 * changed nothing but `<html lang>` and `localStorage`. The framework's own
 * polyglot functions are plain `export function` declarations for exactly this
 * reason. FA207 governs helpers NESTED inside a handler, not an exported
 * context function, so a declaration is correct here.
 *
 * Both call shapes are supported and both exist in the tree:
 *   el.call('setLang', 'ka')                        → `this` is the element
 *   setLang('ka', { context, skipPersist: true })   → cross-tab storage sync
 * If neither yields a context the function WARNS instead of silently doing
 * half the work — a silent half-switch is what produced this whole defect.
 *
 * ── Persistence, and the one rule that must hold ───────────────────────────
 * `localStorage.lang` and `user.preferences.lang` are written ONLY by a real,
 * user-initiated choice. A language the system merely RESOLVED at boot (a
 * workspace default, most of all) is applied to the session and persisted
 * NOWHERE. Otherwise the workspace default stamps itself into `localStorage`,
 * `resolveLang` reads it back as `stored` on the next boot — which outranks
 * `workspaceDefault` — and the admin default has impersonated a user choice
 * that nobody can change back. `transient: true` is that guarantee; it
 * suppresses BOTH persistence sites. `skipPersist` keeps its older, narrower
 * meaning (skip the account write only) because the cross-tab echo in
 * `packages/workspace/wireGlobalListeners.js` relies on it and re-writing
 * `localStorage` there is harmless.
 *
 * ── The workspace-language refusal ─────────────────────────────────────────
 * Inside an active workspace the WORKSPACE's resolved language rules (THE LAW,
 * functions/languages.js `resolveLang`), under 'default' and 'enforced' alike.
 * A non-`transient` switch to any other language is REFUSED and returns
 * `false` — before the document, the bundles, `localStorage` and
 * `sdk.updateMe` — because `applyWorkspaceLangPolicy` would revert it on the
 * next active-workspace event. The visible switchers render locked on the
 * same answer. See the block in the body.
 */ // `smbls` bundles and re-exports these polyglot helpers. Importing them from
// the framework barrel keeps local builds working when the standalone private
// polyglot package is unavailable from the configured registry.
//
// `loadTranslations` is NOT imported any more. Its real signature is
// `loadTranslations(lang)` bound to an element, and it returns immediately
// unless `context.polyglot.fetch` is configured — the shell serves static
// bundles, so it was always a no-op. The old call passed a SECOND argument
// (`mergeAllNamespaces(newLang)`) that the function does not accept, from an
// UNBOUND import whose `this` was undefined, so it exited at its first guard
// (`if (!poly || !root) return`) every single time. The merged strings are
// written straight into `context.polyglot.translations[lang]` below instead —
// lookup step 2 of `translate()`, which needs no binding at all.

var $eY4Ct = parcelRequire("eY4Ct");

var $j7gGM = parcelRequire("j7gGM");

async function $0aa0131529a51e15$export$a3665b844fbc095d(newLang, opts) {
    const SUPPORTED = [
        'en',
        'ka'
    ];
    const RTL_LANGS = new Set([
        'ar',
        'he',
        'fa',
        'ur'
    ]);
    const o = opts || {};
    // An unshipped code is a NO-OP, never a switch. Honouring one would put the
    // session into a language with no bundles: every key falls through to the
    // English base, the switcher shows a code nothing can render, and nothing
    // says why. Warn and leave the session where it is.
    if (typeof newLang !== 'string' || SUPPORTED.indexOf(newLang) === -1) {
        console.warn(`[setLang] '${newLang}' is not a shipped language (${SUPPORTED.join(', ')}) \u{2014} ignored`);
        return false;
    }
    // `this` is the element on the `el.call('setLang', code)` path; `opts.context`
    // is the only source on the direct-call path (cross-tab sync, boot).
    const el = this && typeof this.call === 'function' ? this : null;
    const context = o.context || el?.context || null;
    const shellState = o.shellState || el?.state?.root || context?.state || null;
    if (!context) console.warn("[setLang] no DOMQL context \u2014 call it as el.call('setLang', code) or pass { context }. The document language is updated but polyglot is not.");
    // ── THE WORKSPACE-LANGUAGE GATE ──────────────────────────────────────────
    // THE LAW (Nika, 2026-09-10; functions/languages.js `resolveLang`): inside
    // the workspace shell the WORKSPACE's resolved language rules — enforced
    // pair → `settings.language` → the white-label brand → English. The member's
    // account preference and this device's stored choice decide nothing there.
    //
    // `applyWorkspaceLangPolicy` re-applies that answer on EVERY active-workspace
    // event (boot, loadPrivateData, a switch, the full-record follow-up). So a
    // switch it does not honour cannot stick: measured live on
    // my.symbols.app/w/aihouse (2026-09-23) — `setLang('en')` painted English,
    // then the policy's `setLang('ka', {transient, redeliver})` painted Georgian
    // again. The page switched and switched back, and the refused choice had
    // already been written to `localStorage` and the account.
    //
    // This gate used to refuse ONLY under `languagePolicy: 'enforced'`. It now
    // refuses a non-transient switch EXACTLY when the policy would revert it:
    // there is an active workspace (`root.workspace`) and the language the
    // policy resolves for it is not `newLang`. Nothing downstream runs — no
    // document write, no bundle load, no `localStorage`, no `sdk.updateMe`.
    //
    //   · No active workspace → no policy runs → no gate. The standalone and
    //     public surfaces (landing, docs, a logged-out page) keep their switch.
    //   · A record still IN FLIGHT (an id, no `settings`, not stamped full, not
    //     marked unreachable — the `pending` state of workspaceSettings.js)
    //     holds the ACTIVE language: the policy skips that record and re-runs on
    //     the full one, so any switch now would be decided by settings nobody has
    //     read yet.
    //
    // The visible switchers lock on the SAME answer (LangSwitcher and
    // InterfaceLanguageField `lockedLang`), so a person does not meet this
    // refusal by clicking. It still matters for the callers that reach no
    // control: the cross-tab `storage` echo in workspace/wireGlobalListeners.js
    // and a module's own switcher that calls `el.call('setLang', …)`.
    //
    // `transient: true` is exempt. That flag means "the system RESOLVED this,
    // it is persisted nowhere" — it is how the policy itself applies the
    // workspace language. Gating it would make the policy unable to apply.
    //
    // FA204 / frank trap — the resolution is INLINED here rather than read off
    // `functions/languages.js`'s `resolveLang` / `enforcedWorkspaceLang`, for
    // exactly the reason `SUPPORTED` and `RTL_LANGS` are inlined above:
    // `functions/` is a frank section barrel and a bare cross-barrel read from
    // inside a serialized export is unresolvable in the eval-revived runtime.
    // Pinned to the policy by __tests__/i18nBootLanguage.test.js, which runs
    // the real `applyWorkspaceLangPolicy` beside this gate and fails on any
    // case where the two disagree.
    const _wsRoot = shellState || null;
    const _ws = _wsRoot && _wsRoot.workspace && typeof _wsRoot.workspace === 'object' ? _wsRoot.workspace : null;
    let _workspaceLang = null;
    if (_ws) {
        const _ok = (c)=>typeof c === 'string' && SUPPORTED.indexOf(c) !== -1;
        const _settings = _ws.settings && typeof _ws.settings === 'object' ? _ws.settings : null;
        const _pending = !_settings && _ws._shape !== 'full' && !!(_ws.id || _ws._id) && !_ws._completionUnreachable;
        if (_pending) {
            const _active = _wsRoot.lang || context?.state?.lang || null;
            _workspaceLang = _ok(_active) ? _active : 'en';
        } else {
            const _brand = _wsRoot.whitelabelBrand && _wsRoot.whitelabelBrand.lang;
            _workspaceLang = (_settings && _settings.languagePolicy === 'enforced' && _ok(_settings.language) ? _settings.language : null) || (_settings && _ok(_settings.language) ? _settings.language : null) || (_ok(_brand) ? _brand : null) || 'en';
        }
    }
    if (!o.transient && _workspaceLang && _workspaceLang !== newLang) {
        console.warn(`[setLang] '${newLang}' refused \u{2014} this workspace renders in '${_workspaceLang}'. ` + 'The account preference was NOT changed.');
        return false;
    }
    // A lazy translation chunk can finish after another choice or a workspace
    // switch. Only the latest request in the same scope may repaint or persist.
    // Keep coordination on the context, outside the user-visible reactive state.
    const requestOwner = context?.polyglot || context || shellState;
    const request = {};
    if (requestOwner) requestOwner._languageSwitchRequest = request;
    const scopeKey = ()=>JSON.stringify([
            shellState?.org?.id || shellState?.jwtClaims?.workspace_org_id || '',
            shellState?.workspace?.id || shellState?.workspace?._id || '',
            shellState?.jwtClaims?.active_workspace_id || '',
            shellState?.workspace?.settings?.language || '',
            shellState?.workspace?.settings?.languagePolicy || '',
            shellState?.currentUserId || shellState?.user?.id || shellState?.user?._id || ''
        ]);
    const startedIn = scopeKey();
    const isCurrent = ()=>(!requestOwner || requestOwner._languageSwitchRequest === request) && scopeKey() === startedIn;
    // ── Bundles ───────────────────────────────────────────────────────────────
    // ENGLISH IS BUNDLED; EVERY OTHER LANGUAGE IS A LAZY, PER-NAMESPACE CHUNK.
    // Nothing here touches the network on any plane — see i18nLoader.js's header
    // for why (a `.json` asset compiles to a `.js` module under Parcel, and the
    // dev server answers an unknown path with 200 + SPA-fallback HTML, so a
    // runtime fetch of a bundle can only fail silently).
    //
    // The namespace SET is the union of: `common` (always), what bootShell
    // declared for this session from the running app's manifest
    // (`context.polyglot.namespaces`), and every namespace anything has already
    // asked for (`getLoadedNamespaces()`). The chunks load in PARALLEL, so a
    // five-namespace surface is one round of imports, not five serial ones.
    const _static = (0, $j7gGM.i18nStaticTranslations)();
    const _bundled = _static[newLang];
    const _namespaces = Array.from(new Set([
        'common',
        ...context?.polyglot?.namespaces || [],
        ...(0, $j7gGM.getLoadedNamespaces)()
    ]));
    // Did the registry actually SERVE this language, or is every namespace about
    // to fall back to English? A frank-published record has no chunks to import,
    // and on that plane a baked `translations[lang]` in the payload is the only
    // real translation there is — so a fallback result must never overwrite it.
    const _served = !!_bundled || _namespaces.some((ns)=>(0, $j7gGM.hasI18nBundle)(newLang, ns));
    let _resolved = _bundled;
    if (!_bundled) {
        (0, $j7gGM.dropNonEnglishCache)();
        _resolved = await (0, $j7gGM.loadI18nNamespaces)(newLang, _namespaces);
    }
    if (!isCurrent()) return false;
    if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.setAttribute('lang', newLang);
        document.documentElement.setAttribute('dir', RTL_LANGS.has(newLang) ? 'rtl' : 'ltr');
    }
    if (context) {
        if (!context.polyglot) console.warn("[setLang] context.polyglot is not configured \u2014 translations cannot be applied. It is declared by @symbo-ls/workspace-shared and merges in through sharedLibraries; bootShell seeds it for a standalone boot.");
        else {
            const poly = context.polyglot;
            if (!poly.translations) poly.translations = {};
            // A non-default language OVERRIDES the English base key by key; anything
            // it is missing still resolves through `translate()`'s default-language
            // fallback, so a partial bundle degrades to English, never to a raw key.
            //
            // The bundle is re-applied on EVERY switch rather than trusted to be
            // there already: a published payload, a standalone boot and a warm shell
            // each seed `translations` from a different place, and a switch that
            // silently depended on one of them is exactly the defect being fixed.
            //
            // WHO WINS ON A COLLISION depends on whether the registry served the
            // language. When it did, the freshly-loaded chunk is the newer truth and
            // goes last. When it did NOT — a published record, where `loadI18nNamespaces`
            // can only hand back the English base — whatever the payload already
            // carries goes last, or a fallback would erase a baked translation.
            const _existing = poly.translations[newLang] || {};
            if (_resolved && Object.keys(_resolved).length) poly.translations[newLang] = _served ? {
                ..._existing,
                ..._resolved
            } : {
                ..._resolved,
                ..._existing
            };
        }
    }
    // ── Apply ────────────────────────────────────────────────────────────────
    // The framework's own switch, invoked WITH an element so `this.context` and
    // `this.state.root` resolve: it writes `context.state.lang`, updates the root
    // state (which is what makes every reactive prop re-evaluate) and seeds the
    // language's keys into root state. Bare, as it used to be called, it returns
    // at `if (!root) return` and does nothing.
    //
    // It also writes `localStorage[storageLangKey]` unconditionally, which a
    // `transient` switch must not do — hence the snapshot/restore. A transient
    // switch runs pre-mount today (bootShell, no element yet) so the branch is
    // belt-and-braces, not the live path.
    if (el && context?.polyglot) {
        const store = typeof localStorage !== 'undefined' ? localStorage : null;
        const before = o.transient ? store?.getItem?.('lang') ?? null : null;
        // `redeliver` — push the CURRENT bundles into an already-mounted tree.
        //
        // The plugin's `setLang` returns immediately when `getActiveLang()` already
        // equals the target, and at boot it always does: the shell mints polyglot
        // with the stored language BEFORE the bundles for that language exist, then
        // loads and merges them a step later. Nothing then pushes the merged
        // strings into the mounted tree, so whichever surface rendered first keeps
        // the English it was born with. Measured live on 2026-09-03: the same
        // tickets board came up Georgian on one boot and English on the next, and
        // the App Store came up English with all 458 of its Georgian keys sitting
        // in the context — decided purely by render order.
        //
        // `getActiveLang` reads `root.lang` then `context.state.lang`. Blanking
        // both, synchronously and with no update between, makes the plugin run its
        // full pass: it writes every translation into root state and calls
        // `root.update`, and that is what re-evaluates a function-form prop.
        if (o.redeliver) {
            const _root = el.state?.root || el.state;
            if (_root && _root.lang) _root.lang = '';
            if (context.state && context.state.lang) context.state.lang = '';
        }
        const applied = (0, $eY4Ct.setLang).call(el, newLang);
        // The framework writes storage synchronously. Restore a transient choice
        // before yielding, so its continuation cannot overwrite a newer choice.
        if (o.transient && store) {
            if (before === null) store.removeItem('lang');
            else store.setItem('lang', before);
        }
        await applied;
        if (!isCurrent()) return false;
    } else if (shellState) {
        // No element (boot, cross-tab sync): seed the state the mount will adopt.
        if (typeof shellState.update === 'function') shellState.update({
            lang: newLang
        });
        else shellState.lang = newLang;
    }
    if (context?.state && context.state.lang !== newLang) context.state.lang = newLang;
    // ── Re-title the routed page ─────────────────────────────────────────────
    // `<title>` is written by the helmet plugin from the routed page's
    // `metadata` (`pageTitle` → `polyglot`). Its re-apply on a language change
    // rides a signal effect inside `@symbo.ls/helmet`, and that package imports
    // `@symbo.ls/signal` without declaring it — so whether the effect re-fires
    // depends on which signal copy the served bundle resolves. Measured live on
    // my.symbols.app (2026-09-23): after the policy's
    // `setLang('ka', { transient, redeliver })` the tree and `<html lang>` were
    // Georgian and `<title>` still read "Home".
    //
    // So the switch re-titles the routed page itself, through the plugin's own
    // `update` hook — the framework's documented explicit re-apply (resolve the
    // element's `metadata`, apply it to the document), with no import and no
    // re-render. Idempotent where the effect does fire: it writes the same
    // title again.
    //
    // Skipped while a canvas PageSlot pane is open (`root._canvasSlot`): the
    // slot's primary pane owns the title then (canvas PageSlot
    // `_syncSlotTitle`), and re-titling the page behind it would clobber that.
    if (el && context) try {
        const _appRoot = typeof el.getRoot === 'function' ? el.getRoot() : null;
        const _appState = _appRoot?.state?.root || _appRoot?.state || null;
        const _page = _appRoot ? _appRoot[_appRoot.__ref?.contentElementKey || 'content'] : null;
        const _plugins = _appRoot?.context?.plugins || context.plugins || [];
        const _helmet = _plugins.find((p)=>p && p.name === 'helmet');
        if (_page && _page.metadata && _helmet && typeof _helmet.update === 'function' && !(_appState && _appState._canvasSlot)) _helmet.update(_page);
    } catch (err) {
        console.warn(`[setLang] could not re-title the page: ${err?.message || err}`);
    }
    if (!o.transient && typeof localStorage !== 'undefined') localStorage.setItem('lang', newLang);
    // FA206 — dynamic import, NOT a module-scope `import { queryClient }`.
    // `@symbo.ls/fetch` matches frank's `EXTERNAL_PACKAGES` (`'@symbo.ls/*'`),
    // so `stubExternalsPlugin` replaces it with a `stub-external:` shim at
    // serialization. `setLang` is an exported runtime primitive — a language
    // switcher calls it long after boot — so a module-scope binding resolves to
    // the stub and `dropNonLang` silently does nothing at any frank-served
    // runtime: stale non-`en` query cache survives the switch, with no error.
    // Importing at call time gets the real module in both local dev and prod.
    // Destructure defensively for ESM/CJS shape variance (FA206), but call
    // UNGUARDED: a genuinely missing export must still throw, exactly as the
    // old module-scope binding did. This whole ticket is about breakage that
    // was silent — swallowing it behind `?.` would reintroduce the defect in
    // a new place.
    // The IMPORT ITSELF has to be guarded, not just the value it yields. The
    // landing site and the docs site both declare `system/shared` as a shared
    // library and define no `setLang` of their own, so `mergeSharedLibraries`
    // hands them THIS function and `el.call('setLang', …)` runs it — on a site
    // that has no `@symbo.ls/fetch` in its import map at all. Measured live on
    // the landing at 13:02 by the landing session: "TypeError: Failed to resolve
    // module specifier '@symbo.ls/fetch' at Object.setLang". The rejection came
    // from the `await import(...)` on the line below, BEFORE the guard beneath
    // it could do anything, so guarding only the value left the throw in place.
    let fetchMod = null;
    try {
        fetchMod = await Promise.resolve((parcelRequire("4skhB")));
    } catch (err) {
        console.warn(`[setLang] '@symbo.ls/fetch' did not resolve (${err?.message || err}) \u{2014} no ` + 'query cache to evict on this surface. Language switched anyway.');
    }
    if (!isCurrent()) return false;
    const queryClient = fetchMod?.queryClient || fetchMod?.default?.queryClient;
    // Loud, but not fatal. The original rule here was to call UNGUARDED so a
    // genuinely missing export still throws — the whole point of that ticket was
    // that the breakage had been SILENT. A warning is not silent, and a throw at
    // THIS point is actively worse for the reader: every earlier step has already
    // run, so the document language, the bundles, the root state and the stored
    // preference are all switched and only the stale query cache is left — the
    // UI would be in the new language with an uncaught error in the console.
    // It also has to survive off-shell: a frank-published consumer gets a stub
    // for `@symbo.ls/*`, and a project with no fetch plugin has no query cache to
    // evict in the first place.
    if (queryClient && typeof queryClient.dropNonLang === 'function') queryClient.dropNonLang('en');
    else console.warn("[setLang] @symbo.ls/fetch exposed no usable queryClient \u2014 the stale non-English query cache was NOT evicted. Language switched anyway.");
    // The account write — a cross-device record of a REAL choice. Skipped for a
    // resolved language (`transient`) and for the cross-tab echo (`skipPersist`),
    // where the originating tab already wrote it.
    // `el.sdk` is the established element-level accessor in this package
    // (AppOrgSwitcher, AiSettingsPanel); nothing ever sets `context.sdk`, so the
    // switcher path would have no SDK at all without it.
    const sdk = o.sdk || context?.sdk || el?.sdk || null;
    const user = shellState?.user || context?.state?.user || null;
    if (!o.transient && !o.skipPersist && sdk && user) // SDK proxies AuthService methods flat (sdk.updateMe). There is no
    // sdk.auth namespace — see sdk/src/utils/services.js SERVICE_METHODS.
    {
        if (typeof sdk.updateMe === 'function') {
            // Guarded on purpose. By the time this runs the switch has ALREADY
            // succeeded locally — document, bundles, root state and this device's
            // stored preference are all on the new language. An unguarded await
            // rejects into an onClick handler that has no catch, so a dropped
            // connection or an expired session would surface as an unhandled
            // rejection while the interface sits happily in the new language.
            //
            // Reverting would be worse than failing to persist: the person asked for
            // this language, they got it, and the only thing lost is that the choice
            // does not follow them to another device. So keep the switch, and say so
            // loudly rather than silently.
            //
            // The server's `400 invalid_language` cannot reach here through the UI —
            // the shipped-language guard at the top of this function refuses an
            // unshipped code before anything happens. Any rejection here is a real
            // transport or auth failure, not a bad value.
            // Serialize account writes, not UI updates: an older slow save must not
            // arrive after the latest selection and become the next device's choice.
            const previous = requestOwner?._languagePersistTask || Promise.resolve();
            const persist = previous.catch(()=>{}).then(async ()=>{
                if (!isCurrent()) return;
                try {
                    await sdk.updateMe({
                        preferences: {
                            lang: newLang
                        }
                    });
                } catch (err) {
                    console.warn(`[setLang] switched to '${newLang}' on this device, but saving it to ` + "the account failed \u2014 the choice will not follow you to another " + `device: ${err?.message || err}`);
                }
            });
            if (requestOwner) requestOwner._languagePersistTask = persist;
            await persist;
            if (requestOwner?._languagePersistTask === persist) delete requestOwner._languagePersistTask;
        }
    }
    return true;
}

});

parcelRegister("1axdt", function(module, exports) {

$parcel$export(module.exports, "applyWorkspaceLangPolicy", () => $0da07db5257729b3$export$d181c8b7e7202235);
/**
 * applyWorkspaceLangPolicy — re-resolve the session language for the workspace
 * that is active NOW.
 *
 * ── Why a second resolution point exists ──────────────────────────────────
 * bootShell resolves the language ONCE, at boot, for the workspace that was
 * active then (step 7b). A workspace-enforced language
 * (`settings.languagePolicy: 'enforced'`) is the first level of that
 * precedence that can CHANGE WITHOUT A RELOAD: it belongs to a workspace, not
 * to the person, so switching workspaces changes the answer. Without this,
 * enforcement only ever applied to whichever workspace happened to be active
 * at boot — a member who switched INTO an enforced workspace kept their own
 * language, and one who switched OUT of it stayed stuck in the workspace's.
 *
 * ── Idempotent, and safe to call on any workspace event ───────────────────
 * It recomputes the WHOLE precedence (not just the enforced level) and does
 * nothing when the answer has not changed. So it is correct on a switch, on a
 * late-arriving workspace record, and on a redundant re-fire — which is why
 * its caller can subscribe to `onActiveWorkspaceFull` and stop reasoning about
 * which switch path it came through. There are four of them (the shell's
 * `sdk.workspaceSwitched` handler, `switchOrg`, the cross-tab storage echo,
 * and the boot chain's own completion), and they all funnel through
 * `setActiveWorkspaceRecord`, which is what publishes that event.
 *
 * ── LEAVING a workspace restores that workspace's own answer ──────────────
 * That falls out of recomputing the whole chain rather than being a special
 * case: the next workspace's own `settings.language` (else the brand's, else
 * English) decides. Nothing was written to the account while the member was inside, so
 * there is nothing to undo — see `setLang`'s `transient` contract, which this
 * function always uses.
 *
 * ── The SAME language can still owe its text sets (KA-1) ──────────────────
 * After an in-page sign-in the language may not change at all (a Georgian
 * browser, a Georgian workspace), while the signed-out boot only DECLARED the
 * shell's namespaces and loaded none of them. Then this calls `setLang` once
 * for the same language — only for a lazily-loaded language, and only while a
 * declared namespace is still missing. See the body.
 *
 * ── FA204 / frank trap ───────────────────────────────────────────────────
 * `functions/` is a frank section barrel: every export becomes its own emitted
 * entry, and a bare module-scope or cross-barrel read from inside a serialized
 * export is unresolvable in the eval-revived runtime. So the enforced-pair
 * test is INLINED here (the same shape `setLang.js` and `languages.js` use for
 * their own lists), and the two siblings this needs at runtime — `resolveLang`
 * and `setLang` — are reached through `el.call`, the sanctioned resolver
 * (Rule 8 / FA001), never an import.
 *
 * A `function` declaration, not an arrow, for the same reason `setLang` is
 * one: `el.call('applyWorkspaceLangPolicy')` invokes it with `this` bound to
 * the element, and an arrow cannot receive that binding.
 *
 * @param {object} [el] - the element; omitted on the `el.call(...)` path,
 *                        where `this` is the element already
 * @returns {Promise<boolean>} true when `setLang` ran: the session language
 *                             changed, or the same language loaded the text
 *                             sets it still owed
 */ async function $0da07db5257729b3$export$d181c8b7e7202235(el) {
    const element = el && typeof el.call === 'function' ? el : this && typeof this.call === 'function' ? this : null;
    if (!element) {
        console.warn("[applyWorkspaceLangPolicy] no element \u2014 call it as el.call('applyWorkspaceLangPolicy') or pass the element. The workspace language policy was NOT applied.");
        return false;
    }
    const root = element.state?.root || element.state || element.context?.state || null;
    if (!root) return false;
    // A record still IN FLIGHT is not an answer. A list/claims-shaped workspace
    // (an id, no `settings`, not stamped full, completion not marked
    // unreachable — the `pending` state of workspaceSettings.js) carries no
    // language at all, so resolving it reads "set to nothing" and paints
    // English; then the full record lands and paints the workspace's real
    // language. That is a second language paint on every warm boot and on every
    // switch into a Georgian workspace. `onActiveWorkspaceFull` re-runs this
    // function on the full record, so skipping here loses nothing. `setLang`'s
    // gate holds the active language for the same window (see its body).
    // Inlined, not read off workspaceSettings.js — same FA204 trap as below.
    const _ws = root.workspace && typeof root.workspace === 'object' ? root.workspace : null;
    if (_ws && !(_ws.settings && typeof _ws.settings === 'object') && _ws._shape !== 'full' && !!(_ws.id || _ws._id) && !_ws._completionUnreachable) return false;
    const settings = root.workspace?.settings || null;
    const SUPPORTED = [
        'en',
        'ka'
    ];
    const enforced = settings && settings.languagePolicy === 'enforced' && typeof settings.language === 'string' && SUPPORTED.indexOf(settings.language) !== -1 ? settings.language : null;
    // The SAME precedence bootShell applies, from the SAME function, so the two
    // resolution points cannot drift. Anything absent is simply skipped. The
    // member's account preference and this device's `localStorage.lang` are no
    // longer inputs (Nika 2026-09-10: the workspace's own language decides, a
    // workspace set to nothing reads English) — see resolveLang.
    const next = element.call('resolveLang', {
        workspaceEnforced: enforced,
        workspaceDefault: settings?.language || null,
        brandDefault: root.whitelabelBrand?.lang || null
    });
    const active = root.lang || element.context?.state?.lang || null;
    if (!next) return false;
    if (next === active) {
        // THE SAME LANGUAGE, BUT ITS TEXT SETS ARE NOT LOADED YET (KA-1). A
        // signed-out boot loads only `common` + `auth` and DECLARES the shell's
        // namespaces without loading them (bootResolve, "declare only"). A person
        // who then signs in on the page, into a workspace in the language already
        // active, changes no language — so without this nothing ever loads
        // `ka/shell`, `ka/canvas`, … and most of the shell stays English until a
        // reload. One `setLang` loads every declared namespace (its "Bundles"
        // union) and records each as asked for, so the next fire finds nothing
        // missing and costs nothing.
        //
        // Missing = declared, not yet asked for, and served for this language. A
        // namespace with no bundle for it would only fall back to English. A host
        // with no registry (frank's revived runtime) serves nothing, so it never
        // loops. `getLoadedNamespaces` not reachable -> no answer, nothing forced.
        const _loaded = element.call('getLoadedNamespaces');
        if (!Array.isArray(_loaded)) return false;
        const _declared = [
            'common',
            ...element.context?.polyglot?.namespaces || []
        ];
        const _missing = _declared.some((ns)=>_loaded.indexOf(ns) === -1 && element.call('hasI18nBundle', next, ns) === true);
        if (!_missing) return false;
        // A BUNDLED language (English) carries every namespace already: there is
        // nothing to load, and its `setLang` records nothing, so forcing one here
        // would repeat on every workspace event. Read last: it merges the base.
        const _static = element.call('i18nStaticTranslations');
        if (_static && _static[next]) return false;
    }
    // `transient` — this language was RESOLVED, never chosen. It is persisted
    // NOWHERE: not to `localStorage`, not to the account. Persisting it would
    // let a workspace's rule impersonate the member's own choice and follow them
    // out of the workspace that made it (see setLang's header).
    //
    // `redeliver` — the tree is already mounted here, unlike at boot. Without it
    // the bundles land but nothing re-pushes them, so already-rendered props
    // keep the language they were born with.
    return element.call('setLang', next, {
        transient: true,
        redeliver: true
    });
}

});

parcelRegister("drkt6", function(module, exports) {

$parcel$export(module.exports, "brandName", () => $9c8dac906c8013a2$export$63a39fc1c580d092);
$parcel$export(module.exports, "pageTitle", () => $9c8dac906c8013a2$export$cf9644ba8d6cd7c3);
$parcel$export(module.exports, "resolvePageMetadataTitle", () => $9c8dac906c8013a2$export$dadede1b48e5eb92);
/**
 * brandName — the current host's white-label name, or the 'Symbols
 * Workspace' default. The ONE place that reads `root.whitelabelBrand`
 * for a document title (WS-DOCUMENT-TITLE-SUFFIX-BAKED-INTO-I18N-1); a
 * handful of pages compose their own title string around a runtime value
 * (a person's name, a document's own title) and call this directly instead
 * of `pageTitle`, which assumes an i18n key.
 *
 * `function`, not an arrow — see `pageTitle` below for why.
 */ function $9c8dac906c8013a2$export$63a39fc1c580d092() {
    const el = this && typeof this.call === 'function' ? this : null;
    const branded = el?.state?.root?.whitelabelBrand?.name;
    if (branded) return branded;
    // The comm host (workspace docs/COMM_HOST.md) carries its own product name
    // (`shell.comm.brand`). Host test restated — every export is serialized alone.
    let comm = false;
    try {
        const host = String(window.location && window.location.hostname || '').toLowerCase();
        comm = /(^|\.)comm?\.symbols\.app$/.test(host) || window.localStorage.getItem('symbols_force_comm') === '1' || (window.location.search || '').includes('comm=1');
    } catch (_) {
        comm = false;
    }
    if (comm && el) {
        const name = el.call('polyglot', 'shell.comm.brand');
        if (typeof name === 'string' && name && name !== 'shell.comm.brand') return name;
    }
    return 'Symbols Workspace';
}
function $9c8dac906c8013a2$export$cf9644ba8d6cd7c3(key) {
    const el = this && typeof this.call === 'function' ? this : null;
    const base = el ? el.call('polyglot', key) : key;
    const brand = $9c8dac906c8013a2$export$63a39fc1c580d092.call(el);
    return base ? `${base} / ${brand}` : brand;
}
function $9c8dac906c8013a2$export$dadede1b48e5eb92(metadata) {
    const el = this;
    try {
        const resolved = typeof metadata === 'function' ? metadata(el, el?.state) : metadata;
        const title = resolved?.title;
        const value = typeof title === 'function' ? title(el, el?.state) : title;
        return typeof value === 'string' ? value : null;
    } catch  {
        return null;
    }
}

});

parcelRegister("aR6hx", function(module, exports) {

$parcel$export(module.exports, "switchOrg", () => (parcelRequire("76lRN")).switchOrg);
$parcel$export(module.exports, "switchWorkspace", () => (parcelRequire("6Xugm")).switchWorkspace);
$parcel$export(module.exports, "switchWorkspaceProject", () => (parcelRequire("aeYgK")).switchWorkspaceProject);
$parcel$export(module.exports, "logout", () => (parcelRequire("hKf32")).logout);

var $76lRN = parcelRequire("76lRN");

var $6Xugm = parcelRequire("6Xugm");

var $aeYgK = parcelRequire("aeYgK");

var $hKf32 = parcelRequire("hKf32");

});
parcelRegister("76lRN", function(module, exports) {

$parcel$export(module.exports, "switchOrg", () => $52ba0e2f726241b8$export$f28399983e86882c);
/**
 * switchOrg — clears all scope state, re-authenticates to the new org,
 * re-fetches org data, then delegates to switchWorkspace for the default workspace.
 */ /**
 * @param {object} state        - DOMQL root state
 * @param {object} sdk          - SDK instance (must have switchOrg + organization + workspace)
 * @param {object} queryClient  - @symbo.ls/fetch queryClient
 * @param {string} newOrgId     - target organisation ID
 */ 

const $52ba0e2f726241b8$export$f28399983e86882c = async (state, sdk, queryClient, newOrgId)=>{
    if (!sdk) {
        // Without an SDK ref the rest is a fake switch — clearing state would
        // race with the auth subscriber and look like a partial success. Bail
        // loudly so the caller's wiring bug surfaces in the console.
        console.warn("[switchOrg] aborted \u2014 SDK reference missing on element context");
        return;
    }
    // Abort-before-mutate: `sdk.switchOrg` persists to Mongo FIRST (it awaits
    // its own internal `setActiveOrganization`) and only mutates its local
    // context after that succeeds — see sdk/src/index.js `switchOrg`. Mirror
    // that contract here by calling it BEFORE wiping any local DOMQL state.
    // A transient failure (network blip, 403, …) now throws out of this
    // function with ZERO state mutated, so the caller's try/catch can surface
    // an error while the UI stays pointed at the previous org. Previously the
    // wipe ran first, so a failed `sdk.switchOrg` left the app with every
    // org/workspace/project key nulled out and no way back.
    await sdk.switchOrg(newOrgId);
    // Self-contained locals — frank.toJSON serializes each functions-file
    // export independently, so a bare reference to a module-scope binding
    // reads as undefined once this file is served to a consuming app
    // (project_frank_drops_module_local_helpers). Inlining also sidesteps the
    // cross-file WORKSPACE_KEYS/WORKSPACE_PROJECT_KEYS/PROJECT_KEYS name
    // collision with switchWorkspace.js/switchWorkspaceProject.js's own
    // module-scope copies — frank's esbuild dedup would otherwise rename one
    // to a suffixed twin and silently pick a winner across files.
    for (const k of [
        'workspace',
        'workspaceMembers',
        'workspaceIntegrations',
        'workspaceBilling'
    ])state[k] = null;
    for (const k of [
        'workspaceProject'
    ])state[k] = null;
    for (const k of [
        'project',
        'projectComponents',
        'projectPages',
        'projectState'
    ])state[k] = null;
    for (const k of [
        'org',
        'permissions',
        'orgMembers',
        'orgRoles',
        'orgTeams'
    ])state[k] = null;
    // queryClient is optional — shells that haven't wired @symbo.ls/fetch
    // yet (workspace shell on the `next` branch) won't have one.
    if (queryClient && typeof queryClient.clear === 'function') queryClient.clear();
    // SDK methods are flat — sdk.organization / sdk.auth / sdk.workspace
    // namespaces don't exist. Service routing is via the SERVICE_METHODS map
    // in sdk/src/utils/services.js, which exposes:
    //   sdk.getOrganization(id)         (organization service)
    //   sdk.getPermissions(...)         (auth service — only via dispatcher)
    //   sdk.listWorkspaces({ org })     (workspace service)
    // Permissions endpoint isn't shipped on every backend yet — failure
    // there shouldn't abort the switch (we only need org + workspaces to
    // bring the UI up). Fall back to null and let the auth subscriber's
    // jwt-claims-derived role gates run instead.
    const [org, permissions] = await Promise.all([
        sdk.getOrganization(newOrgId),
        Promise.resolve(typeof sdk.getPermissions === 'function' ? sdk.getPermissions(newOrgId) : sdk.execute?.('auth.permissions', 'list', [
            newOrgId
        ])).catch((err)=>{
            console.warn('[switchOrg] permissions fetch failed (continuing):', err?.message || err);
            return null;
        })
    ]);
    state.org = org;
    state.permissions = permissions;
    const workspaces = await sdk.listWorkspaces({
        organization: newOrgId
    }).catch((err)=>{
        console.warn('[switchOrg] listWorkspaces failed:', err?.message || err);
        return [];
    });
    state.workspaces = Array.isArray(workspaces) ? workspaces : workspaces?.data || [];
    // Prefer the workspace the user last chose, when it belongs to the org being
    // entered. `workspaces[0]` unconditionally was wrong: entering an org via
    // `/w/<org-slug>` (a reload, or any cross-org reconcile) discarded the
    // persisted `localStorage.activeWorkspace` pointer and dropped the user back
    // onto the org's first workspace. auth.js already treats that pointer as "the
    // user's explicit choice + the canonical pointer" and lets it override even a
    // stale JWT claim — this path was the one place that ignored it, so a refresh
    // silently reverted the selection.
    //
    // Only honoured when the pointer resolves INSIDE this org's list; switching
    // orgs must never leave the user pointed at a foreign workspace.
    const wsId = (w)=>String(w && (w.id || w._id) || '');
    let target = state.workspaces[0] || null;
    try {
        const { getActiveWorkspacePointer: getActiveWorkspacePointer } = await Promise.resolve((parcelRequire("jhJrJ")));
        const pinned = getActiveWorkspacePointer();
        if (pinned) {
            const match = state.workspaces.find((w)=>wsId(w) === String(pinned));
            if (match) target = match;
        }
    } catch (err) {
        console.warn('[switchOrg] active-workspace pointer unavailable:', err?.message || err);
    }
    if (target) {
        const { switchWorkspace: switchWorkspace } = await Promise.resolve((parcelRequire("6Xugm")));
        await switchWorkspace(state, sdk, queryClient, wsId(target));
    }
// No separate persist step here — `sdk.switchOrg` above already awaited
// its own `setActiveOrganization` PATCH (Mongo + socket.io fan-out to
// other sessions) BEFORE this function touched any local state. Calling
// `sdk.setActiveOrganization` again here would be a redundant duplicate
// write on every single org switch.
};

});
parcelRegister("6Xugm", function(module, exports) {

$parcel$export(module.exports, "switchWorkspace", () => $014eb48dc94d57d4$export$c3cb4d92231617a0);
/**
 * switchWorkspace — clears workspace + project state, invalidates all
 * fetch cache queries (stale on next read), loads the new workspace.
 */ 
var $jhJrJ = parcelRequire("jhJrJ");

var $g3Ned = parcelRequire("g3Ned");

var $9IIym = parcelRequire("9IIym");
const $014eb48dc94d57d4$export$c3cb4d92231617a0 = async (state, sdk, queryClient, newWorkspaceId)=>{
    // Self-contained locals — see switchOrg.js's identical note (same fix,
    // same collision class: WORKSPACE_KEYS/PROJECT_KEYS were separately
    // module-scope in both files with matching values, a latent frank-rename
    // collision waiting to diverge).
    //
    // Scope THIS tab's SDK to the new workspace first — the client-only
    // `updateContext` bootShell and the auth tick use (no Mongo write: the tab
    // that made the switch already persisted it). `_workspaceScope()` reads
    // `_context.activeWorkspaceId` BEFORE the storage pointer, so without this
    // every scope-derived call — ticket get / create / update / comments and,
    // since sdk 3.14.794, the attachment upload — kept targeting the OLD
    // workspace until the next auth tick, while the state below already showed
    // the new one. Before the query invalidation too, so the refetches it
    // triggers read the new workspace.
    sdk.updateContext?.({
        activeWorkspaceId: newWorkspaceId
    });
    for (const k of [
        'workspace',
        'workspaceMembers',
        'workspaceIntegrations',
        'workspaceBilling'
    ])state[k] = null;
    for (const k of [
        'project',
        'projectComponents',
        'projectPages',
        'projectState'
    ])state[k] = null;
    // Invalidate all workspace-scoped fetch cache entries.
    // Cache keys include workspace ids in params; nuking by 'workspace' prefix
    // would over-evict, so we use queryClient.invalidateQueries() to mark all
    // queries stale — they'll refetch on next read.
    queryClient.invalidateQueries();
    // FLAT SDK method — `sdk.workspace` is NOT a property (services live in
    // the internal Map behind getService; SERVICE_METHODS proxies expose
    // sdk.getWorkspace). The old nested `sdk.workspace.getWorkspace(...)`
    // threw a TypeError mid-function on EVERY call, so the pointer write and
    // the URL sync below never ran — the cross-tab workspace-switch
    // convergence path was dead outright, and reloads snapped back to the
    // org HQ (2026-07-30, part of the GreenIG "widgets rearranged /
    // data not loading" investigation).
    const res = await sdk.getWorkspace(newWorkspaceId);
    // Same envelope unwrap every other getWorkspace consumer uses
    // (getWorkspaceCached / moduleConsole): the SDK may return {data}.
    const ws = res && res.data || res || null;
    // sdk.getWorkspace always returns the full record — stamp it so a racing
    // claims tick (auth.js's subscribeAuthSession) can never downgrade it back
    // to a list entry for this id. See tickets/spec-workspace-record-shape.md.
    (0, $9IIym.setActiveWorkspaceRecord)(state, ws ? (0, $9IIym.stampWorkspaceShape)(ws, 'full', {
        clone: false
    }) : null, {
        reason: 'switchWorkspace',
        sdk: sdk
    });
    (0, $jhJrJ.setActiveWorkspacePointer)(newWorkspaceId);
    // Name the new workspace in the URL. Without this the address bar still reads
    // `/w/<org-slug>`, which resolves to the org's HQ on reload — so switching to
    // a second workspace looked like it worked until you refreshed.
    (0, $g3Ned.syncWorkspaceUrl)(state);
};

});


parcelRegister("aeYgK", function(module, exports) {

$parcel$export(module.exports, "switchWorkspaceProject", () => $7749f65d273489c0$export$a219538d8abadb93);
/**
 * switchWorkspaceProject — clears workspace-project state, invalidates
 * stale fetch cache entries, loads the new workspace project.
 *
 * NOTE: sdk.workspaceProject.getWorkspaceProject may not exist yet
 * (Phase 1.5 / Phase 8 addition). The absence is handled gracefully.
 */ /**
 * @param {object} state    - DOMQL root state
 * @param {object} sdk      - SDK instance
 * @param {object} queryClient - @symbo.ls/fetch queryClient
 * @param {string} newWPId  - target workspace project ID
 */ const $7749f65d273489c0$export$a219538d8abadb93 = async (state, sdk, queryClient, newWPId)=>{
    // Self-contained local — see switchOrg.js's note (same collision class).
    for (const k of [
        'workspaceProject'
    ])state[k] = null;
    // Workspace Project cache is mostly tickets/chats with WP id in params.
    // Mark all stale; refetch lazily.
    queryClient.invalidateQueries();
    state.workspaceProject = await sdk.workspaceProject?.getWorkspaceProject?.(newWPId) || null;
    localStorage.setItem('activeWorkspaceProject', newWPId);
};

});

parcelRegister("hKf32", function(module, exports) {

$parcel$export(module.exports, "logout", () => $ceb267c68ff947c9$export$a0973bcfe11b05c9);
/**
 * logout — signs the user out, clears all state, nukes the fetch cache,
 * signals other tabs via localStorage, and redirects to /login.
 */ 
var $lUr30 = parcelRequire("lUr30");

var $fnRiS = parcelRequire("fnRiS");

var $jhJrJ = parcelRequire("jhJrJ");
const $ceb267c68ff947c9$export$a0973bcfe11b05c9 = async (state, sdk, queryClient)=>{
    await sdk.logout?.();
    for (const k of Object.keys(state))state[k] = null;
    state.preferences = {};
    state.themeMode = 'auto';
    state.lang = 'en';
    queryClient.clear();
    // Wipe profile, orgs, project list, and any other `__canvas_*`
    // localStorage entries so the next signed-in user can't see the
    // previous user's cached data on their first dashboard render.
    (0, $lUr30.invalidateUserDataCache)();
    // Purge stored auth credentials — sb-* (governance Supabase JWT),
    // symbols_* (SDK tokens), and the sdk_only-retry session flag. Shared
    // with bootShell._forceLogoutAndReauth so both logout paths leave the
    // same clean slate. Without this, post-mount logout left governance
    // tokens behind; the next sign-in could resurrect a stale session.
    (0, $fnRiS.purgeAuthStorage)();
    localStorage.setItem('logout', String(Date.now()));
    // `activeOrg` migrated to `User.activeOrganization` (Mongo) — no
    // localStorage entry to clear. Kept the cleanup for `activeWorkspace`
    // and `activeWorkspaceProject` until those follow the same migration.
    (0, $jhJrJ.clearActiveWorkspacePointer)();
    localStorage.removeItem('activeWorkspaceProject');
    window.history.replaceState(null, '', '/login');
};

});


parcelRegister("kHrku", function(module, exports) {

$parcel$export(module.exports, "timeAgo", () => $f11d05db79d9ae0d$export$9b9f695373d1284f);
// timeAgo — compact relative-time formatter ("just now", "5 mins ago",
// "3 hours ago", "2 days ago", "3 weeks ago", "4 months ago", "2 years
// ago"). ALWAYS relative — the old past-a-week raw-date fallback read as
// noise on ticket cards (2026-07-25 per Nika "instead of dates use 'day
// ago'"). The house relative-time helper (per Nika 2026-06-12, ticket
// card Updated) — registered on shared so any component can
// `el.call('timeAgo', ts)`.
//
// IT FOLLOWS THE SESSION LANGUAGE. Its sentences were English literals, so a
// Georgian page read `2 weeks ago` on every ticket card and every note
// (measured live, 2026-09-20).
//   • English stays BYTE-IDENTICAL — `5 mins ago` is the wording that was
//     asked for, singular and plural by hand.
//   • Every other language reads the BUNDLE first (`common.time.*`, one
//     `{count}` sentence per unit). Georgian keeps the noun in one form after
//     any number (`1 წუთის წინ`, `5 წუთის წინ`), so one sentence per unit is
//     exact for it.
//   • `Intl.RelativeTimeFormat` is only the fallback for a language with no
//     bundle sentences, and only when the BROWSER knows the language.
// ⛔ Intl alone was the first version of this fix, and it was WRONG in the
// product: Chrome ships no Georgian locale data —
// `Intl.RelativeTimeFormat.supportedLocalesOf(['ka'])` answers `[]` and the
// formatter silently resolves to `en-GB`. Node and bun carry full ICU, so the
// unit test read perfect Georgian while the running board still said
// `2 weeks ago`. The live check caught it; the test simulates that browser now.
//
// The language is read off the ELEMENT (`this`, the `el.call` binding). With no
// element, or a host with no polyglot, it answers English and never throws.
//
// FA204 — self-contained: every helper value lives inside the function.
const $f11d05db79d9ae0d$export$9b9f695373d1284f = function(input) {
    if (!input) return '';
    const then = new Date(input).getTime();
    if (!Number.isFinite(then)) return '';
    const canCall = this && typeof this.call === 'function';
    const lang = canCall && this.call('getActiveLang') || 'en';
    const english = lang === 'en';
    // Literal keys, never concatenated (docs/I18N-CONVENTION.md §1.3).
    const KEYS = {
        minute: 'common.time.minutesAgo',
        hour: 'common.time.hoursAgo',
        day: 'common.time.daysAgo',
        week: 'common.time.weeksAgo',
        month: 'common.time.monthsAgo',
        year: 'common.time.yearsAgo'
    };
    // `translate` answers the key itself for a string no bundle carries.
    const fromBundle = (key)=>{
        if (!canCall) return null;
        const word = this.call('polyglot', key);
        return typeof word === 'string' && word && word !== key ? word : null;
    };
    const justNow = ()=>(english ? null : fromBundle('common.time.justNow')) || 'just now';
    // `unit` is the Intl unit; `one` / `many` are the English words.
    const say = (count, unit, one, many)=>{
        const inEnglish = count === 1 ? `1 ${one} ago` : `${count} ${many} ago`;
        if (english) return inEnglish;
        const sentence = fromBundle(KEYS[unit]);
        if (sentence) return sentence.replace('{count}', count);
        try {
            const Rtf = typeof Intl !== 'undefined' && Intl.RelativeTimeFormat;
            if (Rtf && Rtf.supportedLocalesOf([
                lang
            ]).length) return new Rtf(lang, {
                numeric: 'always'
            }).format(-count, unit);
        } catch (_) {}
        return inEnglish;
    };
    const diff = Date.now() - then;
    if (diff < 0) return justNow();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return justNow();
    if (mins < 60) return say(mins, 'minute', 'min', 'mins');
    const hours = Math.floor(mins / 60);
    if (hours < 24) return say(hours, 'hour', 'hour', 'hours');
    const days = Math.floor(hours / 24);
    if (days < 7) return say(days, 'day', 'day', 'days');
    const weeks = Math.floor(days / 7);
    if (days < 31) return say(weeks, 'week', 'week', 'weeks');
    const months = Math.floor(days / 30.44);
    if (months < 12) return say(Math.max(months, 1), 'month', 'month', 'months');
    const years = Math.floor(days / 365.25);
    return say(Math.max(years, 1), 'year', 'year', 'years');
};

});

parcelRegister("1ty3Y", function(module, exports) {

$parcel$export(module.exports, "zoneLabel", () => $1132ec15e1c1e365$export$52e3df95aa8d0bdf);
// Canonical IANA-timezone → human label formatter — el.call('zoneLabel', tz).
// TZ-LABELS-1: `analytics/pages/main.js`'s "Where the team is" TeamGrid
// rendered raw IANA identifiers straight to the DOM (`America/Denver`)
// while the Home dashboard's "Team timezones" widget already had its own
// copy of this logic in `workspace/components/IntranetRows.js`
// (`TzCluster.scope.zoneLabel`). Hoisted here (Rule 63 — extract the 3rd
// near-duplicate) so BOTH packages share ONE implementation.
//
// Output (DESIGN-ZONELABEL-DROP-UTC-WORDING-1, Nika 2026-09-14): the place
// plus a bare offset, in the SAME '±HH:MM' form analytics prints
// (analyticsOffsetLabel, WS-ANALYTICS-REMOVE-UTC-DISPLAY-TOGGLE-1). No "UTC"
// or "GMT" wording anywhere:
//   'America/Denver' → 'Denver · -06:00' (DST-correct for now)
//   'Asia/Kolkata'   → 'Kolkata · +05:30'
//   'Etc/UTC'        → '+00:00'  (a UTC-family / Etc zone is not a place)
//   'Remote'         → 'Remote'  (not a resolvable zone: pass-through)
//
// The offset for "now" still comes from Intl `timeZoneName: 'shortOffset'`
// ('GMT-6', 'GMT+5:30', 'GMT'), parsed into minutes and re-printed.
// Self-contained on purpose (FA204): frank serialises this body alone, so it
// reads no module-scope sibling.
const $1132ec15e1c1e365$export$52e3df95aa8d0bdf = (timezone)=>{
    if (!timezone) return 'No timezone set';
    const raw = String(timezone).trim();
    let offsetText = '';
    try {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: raw,
            timeZoneName: 'shortOffset'
        }).formatToParts(new Date());
        offsetText = parts.find((p)=>p.type === 'timeZoneName')?.value || '';
    } catch  {
        return raw;
    }
    const match = /^(?:GMT|UTC)(?:([+-])(\d{1,2})(?::(\d{2}))?)?$/.exec(offsetText);
    const notPlace = /^(etc\/.+|(utc|gmt|uct|universal|zulu|greenwich)([+-]?0)?)$/i.test(raw);
    const city = notPlace ? '' : raw.split('/').pop().replace(/_/g, ' ');
    if (!match) return city || raw;
    const minutes = (match[1] === '-' ? -1 : 1) * (Number(match[2] || 0) * 60 + Number(match[3] || 0));
    const abs = Math.abs(minutes);
    const offset = `${minutes < 0 ? '-' : '+'}${String(Math.floor(abs / 60)).padStart(2, '0')}:${String(abs % 60).padStart(2, '0')}`;
    return city ? `${city} \xb7 ${offset}` : offset;
};

});

parcelRegister("dfJUb", function(module, exports) {

$parcel$export(module.exports, "playNotifySound", () => $9a6048e72bc02a89$export$26636ac78361d318);
// playNotifySound — a short, synthesized "ding-dong" chime for new-message /
// new-notification toasts. WebAudio only (no binary asset ships): a lazily-
// created, module-level AudioContext plays two overlapping sine tones so it
// reads as one connected chime rather than two separate beeps.
//
// el.call('playNotifySound') — no arguments. Reads the caller's root state
// via `this` (the standard el.call binding — same convention
// shared/methods/notification.js's openNotification already uses) so it can
// honor the user's `userPrefs.notification_sound` preference (default ON;
// MemberProfile's ProfileNotifications "Notification sound" toggle writes
// it — see workspace/components/MemberProfile.js).
//
// Never throws: a missing WebAudio implementation, a suspended/blocked
// context (browser autoplay policy), or any synthesis error is swallowed so
// a chime failure can never break the toast it's attached to.
// FA204 / frank trap — `_ctx`/`_lastPlayedAt`/`_resumeListenerInstalled` are
// genuine cross-call state (no el/root argument to hang them on; must
// survive across every independent `el.call('playNotifySound')` firing) —
// re-homed onto `window.__notifySoundState` per the pointerCapability.js
// template. `_DEBOUNCE_MS`/`_getContext`/`_armResumeOnGesture`/`_tone` were
// pure/stateless-once-given-the-state-bag helpers with exactly one caller
// (this is the file's only export) — inlined below alongside it.
function $9a6048e72bc02a89$export$26636ac78361d318() {
    try {
        const root = this?.state?.root || (typeof this?.getRootState === 'function' ? this.getRootState() : null);
        if (root?.userPrefs?.notification_sound === false) return;
        const state = (typeof window !== 'undefined' ? window : globalThis).__notifySoundState || {
            ctx: null,
            lastPlayedAt: 0,
            resumeListenerInstalled: false
        };
        (typeof window !== 'undefined' ? window : globalThis).__notifySoundState = state;
        // Debounce a burst of realtime events (catching up on several queued
        // messages/notifications at once) down to a single chime.
        const DEBOUNCE_MS = 1500;
        const now = Date.now();
        if (now - state.lastPlayedAt < DEBOUNCE_MS) return;
        state.lastPlayedAt = now;
        const getContext = ()=>{
            if (state.ctx) return state.ctx;
            const Ctor = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
            if (!Ctor) return null;
            try {
                state.ctx = new Ctor();
            } catch (_) {
                state.ctx = null;
            }
            return state.ctx;
        };
        // Browsers suspend a freshly-created (or backgrounded) AudioContext until
        // a user gesture resumes it. Install a ONE-TIME listener that resumes it
        // on the next pointerdown/keydown so the very first chime after
        // page-load isn't silently dropped by the autoplay policy.
        const armResumeOnGesture = (ctx)=>{
            if (state.resumeListenerInstalled || typeof document === 'undefined') return;
            state.resumeListenerInstalled = true;
            const resume = ()=>{
                try {
                    ctx.resume?.();
                } catch (_) {
                /* noop */ }
            };
            document.addEventListener('pointerdown', resume, {
                once: true,
                passive: true
            });
            document.addEventListener('keydown', resume, {
                once: true
            });
        };
        // One tone: exponential gain envelope (fast attack, gentle decay) so it
        // reads as a soft "ding", not a harsh beep.
        const tone = (ctx, dest, freq, startAt, duration, peakGain)=>{
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.setValueAtTime(freq, startAt);
            gain.gain.setValueAtTime(0.0001, startAt);
            gain.gain.exponentialRampToValueAtTime(peakGain, startAt + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
            osc.connect(gain);
            gain.connect(dest);
            osc.start(startAt);
            osc.stop(startAt + duration + 0.02);
        };
        const ctx = getContext();
        if (!ctx) return;
        if (ctx.state === 'suspended') {
            armResumeOnGesture(ctx);
            try {
                ctx.resume?.();
            } catch (_) {
            /* noop */ }
        }
        const dest = ctx.destination;
        const t0 = ctx.currentTime;
        // "ding-dong": A5 (880Hz) then D6 (1174.66Hz), the second tone starting
        // while the first is still decaying so the two read as one chime.
        tone(ctx, dest, 880, t0, 0.2, 0.12);
        tone(ctx, dest, 1174.66, t0 + 0.12, 0.2, 0.1);
    } catch (_) {
    /* a chime failure must never break the toast it's attached to */ }
}

});

parcelRegister("3cqmC", function(module, exports) {

$parcel$export(module.exports, "htmlToPlainText", () => $2546f15ff53a6ff1$export$1a50aace4e4c63c);
// el.call('htmlToPlainText', str) — a one-line plain-text reading of a string
// that may carry HTML.
//
// A notification showed its markup: `<p>Global Tech Weekend is an
// international…` (measured live on /inbox and in the bell, 2026-09-21). A
// calendar invitation carries the event description, and a Google Calendar
// description is HTML. Every site prints it through `text:`, so it is safe —
// and wrong: the reader sees the tags.
//
// THE OUTPUT IS TEXT, ALWAYS. Never hand it to `html:`. That is what makes
// decoding an entity safe here: `&lt;script&gt;` becomes the four characters a
// person typed, painted as characters.
//
// A tag starts with a LETTER right after `<` (or `</`), so a bare comparison
// in prose (`a < b and c > d`) is left alone. A block end and a <br> become one
// space, so two paragraphs never glue into one word.
//
// FA204 — self-contained on purpose: the entity table lives inside the
// function, the same discipline longPress.js and openInSlot.js follow.
//
// `{ breaks: true }` keeps the PARAGRAPHS for a detail view: a block end and a
// <br> become a newline instead of a space (pair it with `whiteSpace:
// 'pre-line'`). The default is the one-line preview a list row needs.
const $2546f15ff53a6ff1$export$1a50aace4e4c63c = function(input, opts) {
    if (typeof input !== 'string' || !input) return '';
    if (input.indexOf('<') === -1 && input.indexOf('&') === -1) return input.trim();
    const breaks = !!(opts && opts.breaks);
    const ENTITIES = {
        nbsp: ' ',
        amp: '&',
        lt: '<',
        gt: '>',
        quot: '"',
        apos: "'",
        mdash: "\u2014",
        ndash: "\u2013",
        hellip: "\u2026",
        rsquo: "\u2019",
        lsquo: "\u2018",
        rdquo: "\u201D",
        ldquo: "\u201C"
    };
    return input.replace(/<\s*br\s*\/?\s*>|<\/\s*(p|div|li|tr|h[1-6]|blockquote)\s*>/gi, breaks ? '\n' : ' ').replace(/<\/?[a-zA-Z][^>]*>/g, '').replace(/&#(\d+);/g, (m, code)=>String.fromCodePoint(Number(code))).replace(/&([a-zA-Z]+);/g, (m, name)=>Object.prototype.hasOwnProperty.call(ENTITIES, name.toLowerCase()) ? ENTITIES[name.toLowerCase()] : m).replace(breaks ? /[^\S\n]+/g : /\s+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n').trim();
};

});

parcelRegister("50gPy", function(module, exports) {

$parcel$export(module.exports, "localizedDate", () => $3a4a020c910dd2e8$export$6d4179e18c1f8c49);
// localizedDate — a date or a time, in the session language:
// `el.call('localizedDate', value, options)`. `options` are the ordinary
// `Intl.DateTimeFormat` options (`{ month: 'short', day: 'numeric' }`,
// `{ hour: 'numeric', minute: '2-digit' }`, `timeZone`, …).
//
// Why a helper and not `toLocaleDateString` (measured live 2026-09-21, Georgian
// session): every date with a month or weekday NAME read English. Two causes:
//
//   1. about 100 call sites format with `'en-US'` or `undefined`, so the app
//      language never reaches them;
//   2. Chrome ships NO Georgian locale data. `Intl.DateTimeFormat
//      .supportedLocalesOf(['ka'])` answers `[]` and the formatter silently
//      resolves to `en-GB` — a call site that DOES pass the app language still
//      prints English. node and bun carry full ICU, so a test that only asks
//      Intl reads perfect Georgian. Same trap as `timeAgo`.
//
// So: where the runtime has the language, Intl does all the work. Where it has
// not, this keeps the numeric parts and the ORDER of `en-GB` — day, month, year,
// 24 h, which is Georgian's own order — and takes only the month and weekday
// NAMES from the bundle (`common.monthLong.*`, `common.monthShort.*`,
// `common.weekdayLong.*`, `common.weekdayShort.*`; the Georgian values are
// ICU's own, held to that by the test). A language with neither locale data
// nor bundle names degrades to the English part, never to a key string.
//
// The month and weekday INDEX are read in the requested `timeZone`: 22:30 UTC
// on 31 August is already Tuesday 1 September in Tbilisi.
//
// Self-contained on purpose (no module-scope tables or helpers): an exported
// function is serialized alone for platform delivery, and a free variable that
// is not its own would resolve to nothing there.
function $3a4a020c910dd2e8$export$6d4179e18c1f8c49(value, options) {
    if (value === null || value === undefined || value === '') return '';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) return date.toISOString();
    const opts = options || {};
    const lang = this && this.call && this.call('getActiveLang') || 'en';
    let supported = false;
    try {
        supported = Intl.DateTimeFormat.supportedLocalesOf([
            lang
        ]).length > 0;
    } catch (_) {
        supported = false;
    }
    if (supported) {
        // The LANGUAGE comes from the session, the REGION from the browser when
        // the two agree on the language. A bare `en` formats as en-US, so a
        // British reader of an English session got `Aug 19` and a 12-hour clock
        // where the browser's own `en-GB` says `19 Aug` and 16:05. A session
        // language that already names a region (`pt-BR`) is taken as written.
        let locale = lang;
        try {
            const prefs = typeof navigator !== 'undefined' && navigator ? navigator.languages || (navigator.language ? [
                navigator.language
            ] : []) : [];
            const base = String(lang).toLowerCase();
            if (base.indexOf('-') === -1) for (const pref of prefs){
                if (typeof pref !== 'string') continue;
                if (pref.toLowerCase().split('-')[0] !== base) continue;
                if (Intl.DateTimeFormat.supportedLocalesOf([
                    pref
                ]).length > 0) locale = pref;
                break;
            }
        } catch (_) {
            locale = lang;
        }
        return new Intl.DateTimeFormat(locale, opts).format(date);
    }
    // No locale data for this language in this runtime.
    // LITERAL keys, written out (docs/I18N-CONVENTION §1.3: a key assembled at
    // run time is invisible to grep, to the parity test and to every extraction
    // tool — an "unused key" sweep would delete the month names).
    const MONTH_LONG = [
        'common.monthLong.jan',
        'common.monthLong.feb',
        'common.monthLong.mar',
        'common.monthLong.apr',
        'common.monthLong.may',
        'common.monthLong.jun',
        'common.monthLong.jul',
        'common.monthLong.aug',
        'common.monthLong.sep',
        'common.monthLong.oct',
        'common.monthLong.nov',
        'common.monthLong.dec'
    ];
    const MONTH_SHORT = [
        'common.monthShort.jan',
        'common.monthShort.feb',
        'common.monthShort.mar',
        'common.monthShort.apr',
        'common.monthShort.may',
        'common.monthShort.jun',
        'common.monthShort.jul',
        'common.monthShort.aug',
        'common.monthShort.sep',
        'common.monthShort.oct',
        'common.monthShort.nov',
        'common.monthShort.dec'
    ];
    const DAY_LONG = [
        'common.weekdayLong.sun',
        'common.weekdayLong.mon',
        'common.weekdayLong.tue',
        'common.weekdayLong.wed',
        'common.weekdayLong.thu',
        'common.weekdayLong.fri',
        'common.weekdayLong.sat'
    ];
    const DAY_SHORT = [
        'common.weekdayShort.sun',
        'common.weekdayShort.mon',
        'common.weekdayShort.tue',
        'common.weekdayShort.wed',
        'common.weekdayShort.thu',
        'common.weekdayShort.fri',
        'common.weekdayShort.sat'
    ];
    const zone = opts.timeZone ? {
        timeZone: opts.timeZone
    } : {};
    const named = (key, fallback)=>{
        const text = this && this.call ? this.call('polyglot', key) : null;
        return text && text !== key ? text : fallback;
    };
    const parts = new Intl.DateTimeFormat('en-GB', opts).formatToParts(date);
    return parts.map((part, index)=>{
        if (part.type === 'month' && /^(long|short|narrow)$/.test(opts.month || '')) {
            const at = Number(new Intl.DateTimeFormat('en-GB', {
                ...zone,
                month: 'numeric'
            }).format(date));
            return named((opts.month === 'long' ? MONTH_LONG : MONTH_SHORT)[at - 1], part.value);
        }
        if (part.type === 'weekday') {
            const en = new Intl.DateTimeFormat('en-GB', {
                ...zone,
                weekday: 'short'
            }).format(date);
            const at = [
                'Sun',
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat'
            ].indexOf(en);
            return at < 0 ? part.value : named((opts.weekday === 'long' ? DAY_LONG : DAY_SHORT)[at], part.value);
        }
        if (part.type === 'literal') {
            // en-GB writes `Wed 19 Aug`; most languages, Georgian among them, put a
            // comma after the weekday.
            if (part.value === ' ' && index > 0 && parts[index - 1].type === 'weekday') return ', ';
            // Newer CLDR joins a date and a time with the WORD ` at ` (`19 Aug at
            // 16:05`; measured in bun, not in node 22). A word in a separator is
            // English too — Georgian writes a comma there.
            if (/[A-Za-z]/.test(part.value)) return ', ';
        }
        return part.value;
    }).join('');
}

});

parcelRegister("8k31d", function(module, exports) {

$parcel$export(module.exports, "inkOnPlate", () => $60f288677720ec29$export$adf7715292ff382a);
// inkOnPlate — the ink for a plate whose HUE comes from data:
// `color: (el, s) => el.call('inkOnPlate', s.color || 'blue')`.
//
// A fixed plate has a fixed, measured ink (`fillInk` on the brand hues — see
// design-direction.md §6). A plate painted from data (`s.color`: an agent's or
// a person's colour) cannot: white holds on purple (6.9:1) and fails on blue
// (3.62), orange (2.9) and green (2.81); near-black fixes those and fails on
// purple (3.0). So the ink is CHOSEN per plate: whichever of the brand's two
// plate inks — `fillInk` (near-black) or `white` — reads with more contrast.
//
// The colour is read off the RUNNING design system
// (`context.designSystem.color.<token>.rgb`, e.g. '0, 133, 255'), so a project
// that re-tones a hue gets the right ink with no table to keep in step. A shade
// or alpha modifier (`blue.85`, `purple+20`) reads its base hue. A plate that
// cannot be measured (an unknown token, a scheme PAIR, no design system) keeps
// `white`, the ink these tiles always had.
//
// Self-contained on purpose: an exported function is serialized alone for
// platform delivery, so it may not lean on a module-scope helper.
function $60f288677720ec29$export$adf7715292ff382a(token) {
    const name = String(token || '').split(/[.+=-]/)[0];
    const palette = this && this.context && this.context.designSystem && this.context.designSystem.color;
    const entry = palette && name ? palette[name] : null;
    const rgb = entry && typeof entry.rgb === 'string' ? entry.rgb.split(',').map((part)=>Number(part)) : null;
    if (!rgb || rgb.length < 3 || rgb.some((value)=>Number.isNaN(value))) return 'white';
    const lin = (channel)=>{
        const c = channel / 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    };
    const lum = (c)=>0.2126 * lin(c[0]) + 0.7152 * lin(c[1]) + 0.0722 * lin(c[2]);
    const plate = lum(rgb);
    const onWhite = 1.05 / (plate + 0.05);
    const onNearBlack = (plate + 0.05) / (lum([
        4,
        4,
        4
    ]) + 0.05);
    return onNearBlack >= onWhite ? 'fillInk' : 'white';
}

});

parcelRegister("lO82q", function(module, exports) {

$parcel$export(module.exports, "notificationHrefOf", () => $fe0480b084737428$export$596d62a33882fa70);
// WHERE A NOTIFICATION OPENS — one rule for the bell rows, the /inbox page and
// the toast (NotificationRow, GlobalNotification), handed to
// openNotificationTarget. A server row carries its own `href`, which wins.
// The comms-phone pipeline's channel types carry none (server
// channelInbound.js _notify: 'channel_message', 'channel_missed_call' with
// metadata.partyId — the sender's CRM party, null for an unknown sender):
// those open the sender's contact in the CRM, /crm?contact=<partyId>, or the
// CRM inbox, /crm?view=inbox, for an unknown sender (comms-ui, 2026-09-30).
// Any other type without an href opens nothing (''). Self-contained (frank).
const $fe0480b084737428$export$596d62a33882fa70 = (notif)=>{
    const n = notif && typeof notif === 'object' ? notif : {};
    const own = n.href == null ? '' : String(n.href);
    if (own) return own;
    const meta = n.metadata && typeof n.metadata === 'object' ? n.metadata : {};
    if (meta.kind === 'meeting_starting' && meta.calendarEventId != null) return '/calendar';
    if (n.type === 'channel_message' || n.type === 'channel_missed_call') {
        const party = meta.partyId == null ? '' : String(meta.partyId).trim();
        return party ? '/crm?contact=' + encodeURIComponent(party) : '/crm?view=inbox';
    }
    return '';
};

});

parcelRegister("6zKVW", function(module, exports) {

$parcel$export(module.exports, "DRAG_REF_MIME", () => $4c9a6afea9e74bac$export$7308f8a26406fe40);
$parcel$export(module.exports, "DRAG_REF_KINDS", () => $4c9a6afea9e74bac$export$604e81f87826dd8e);
$parcel$export(module.exports, "setDragRef", () => $4c9a6afea9e74bac$export$a844a6c0e53f7bed);
$parcel$export(module.exports, "hasDragRef", () => $4c9a6afea9e74bac$export$ee3c57f0bfb478a3);
$parcel$export(module.exports, "hasDragFiles", () => $4c9a6afea9e74bac$export$4aeece5b505a9241);
$parcel$export(module.exports, "readDragRef", () => $4c9a6afea9e74bac$export$563c31fd4957bff8);
$parcel$export(module.exports, "dragRefLabel", () => $4c9a6afea9e74bac$export$4169d18f2708549a);
$parcel$export(module.exports, "dragRefIcon", () => $4c9a6afea9e74bac$export$4244f0195f548472);
$parcel$export(module.exports, "dragRefToText", () => $4c9a6afea9e74bac$export$e61696cd44ca69da);
$parcel$export(module.exports, "REF_DROP_ATTR", () => $4c9a6afea9e74bac$export$4de6e427d7be2c15);
$parcel$export(module.exports, "refDropTargetFrom", () => $4c9a6afea9e74bac$export$1b30f4f9897b3baf);
$parcel$export(module.exports, "dispatchRefDrop", () => $4c9a6afea9e74bac$export$79b3cebae6cd5515);
// dragRef — the ONE wire format for dragging a Symbols entity (ticket,
// project, project page, file, note, …) from any surface into any drop
// target (2026-08-02 per Nika "make it possible to drag and drop tickets,
// projects, project pages, files (generic canvases contents) into chat and
// canvas promptarea").
//
// Lives in shared/ because BOTH ends cross package boundaries: sources are
// in tickets/ canvas/ files/ documents/, targets are in chat/ and canvas/.
// Packages must never import from each other (FA001) — every consumer goes
// through el.call('setDragRef', …) / el.call('readDragRef', …).
//
// WIRE FORMAT
// A drag carries the ref twice, on purpose:
//
//   application/x-symbols-ref  JSON {kind, id, title, href, meta?}
//     The rich payload. A custom MIME type is invisible to other apps and
//     is NOT readable during dragover (the DataTransfer protected mode
//     exposes only `types` until drop) — which is exactly why `types` is
//     what _hasDragRef tests.
//
//   text/plain                 the href (or title when there's no href)
//     The graceful degradation leg. Dropping onto a plain textarea, another
//     browser tab, or an external app yields a useful link instead of
//     nothing. Targets that understand the rich type ignore this.
//
// Deliberately NOT text/uri-list: Chrome treats a uri-list drop over an
// editable region as a navigation-ish paste and some targets then insert a
// duplicate link next to our own chip.
const $4c9a6afea9e74bac$export$7308f8a26406fe40 = 'application/x-symbols-ref';
const $4c9a6afea9e74bac$export$604e81f87826dd8e = [
    'ticket',
    'project',
    'page',
    'file',
    'note',
    'kb',
    'event',
    'record',
    'doc',
    'mail',
    'canvas'
];
const $4c9a6afea9e74bac$export$a844a6c0e53f7bed = (e, ref)=>{
    // FA204 / frank trap — inlined (self-contained local) instead of the bare
    // module-scope `DRAG_REF_MIME` read; the export above stays live for
    // genuine external consumers (Composer.js, CanvasPromptTextarea.js).
    const DRAG_REF_MIME = 'application/x-symbols-ref';
    const dt = e && e.dataTransfer;
    if (!dt || !ref || !ref.kind) return;
    const payload = {
        kind: ref.kind,
        id: ref.id != null ? String(ref.id) : '',
        title: ref.title || '',
        href: ref.href || '',
        ...ref.meta ? {
            meta: ref.meta
        } : {}
    };
    try {
        dt.setData(DRAG_REF_MIME, JSON.stringify(payload));
        dt.setData('text/plain', payload.href || payload.title);
    } catch (_) {
    // Some platforms reject setData outside a real dragstart — degrade to
    // no-drag rather than throwing out of the handler.
    }
    // NEVER clobber an effectAllowed the source already set. A card can be
    // draggable for two different reasons at once — TicketCard sets 'move'
    // for its own kanban column drop, and overwriting that with 'copyLink'
    // makes the browser REJECT the column drop entirely (a target whose
    // dropEffect is 'move' can't accept a copyLink-only drag). Widening to
    // 'all' keeps both the existing move target and our copy/link targets
    // working off one drag.
    dt.effectAllowed = !dt.effectAllowed || dt.effectAllowed === 'uninitialized' ? 'copyLink' : 'all';
};
const $4c9a6afea9e74bac$export$ee3c57f0bfb478a3 = (e)=>{
    // FA204 / frank trap — inlined, see setDragRef above.
    const DRAG_REF_MIME = 'application/x-symbols-ref';
    const types = e && e.dataTransfer && e.dataTransfer.types;
    return !!types && Array.prototype.indexOf.call(types, DRAG_REF_MIME) !== -1;
};
const $4c9a6afea9e74bac$export$4aeece5b505a9241 = (e)=>{
    const types = e && e.dataTransfer && e.dataTransfer.types;
    return !!types && Array.prototype.indexOf.call(types, 'Files') !== -1;
};
const $4c9a6afea9e74bac$export$563c31fd4957bff8 = (e)=>{
    // FA204 / frank trap — inlined, see setDragRef above.
    const DRAG_REF_MIME = 'application/x-symbols-ref';
    const dt = e && e.dataTransfer;
    if (!dt) return null;
    let raw;
    try {
        raw = dt.getData(DRAG_REF_MIME);
    } catch (_) {
        return null;
    }
    if (!raw) return null;
    try {
        const ref = JSON.parse(raw);
        return ref && ref.kind ? ref : null;
    } catch (_) {
        return null;
    }
};
const $4c9a6afea9e74bac$export$4169d18f2708549a = (ref)=>ref && (ref.title || ref.href || ref.kind) || 'Reference';
const $4c9a6afea9e74bac$export$4244f0195f548472 = (ref)=>{
    // FA204 / frank trap — inlined (self-contained local), see setDragRef above.
    const KIND_ICONS = {
        ticket: 'checkOval',
        project: 'grid',
        page: 'document',
        file: 'document',
        note: 'edit',
        kb: 'star',
        event: 'dateOutline'
    };
    return KIND_ICONS[ref && ref.kind] || 'document';
};
const $4c9a6afea9e74bac$export$e61696cd44ca69da = (ref)=>{
    if (!ref) return '';
    // FA204 / frank trap — self-contained inline copy of dragRefLabel (a bare
    // sibling-export read is exactly as unresolvable post-frank as a
    // module-local read — see notificationScope.js for the identical shape).
    const label = ref && (ref.title || ref.href || ref.kind) || 'Reference';
    return ref.href ? `[${label}](${ref.href})` : label;
};
const $4c9a6afea9e74bac$export$4de6e427d7be2c15 = 'data-ref-drop';
const $4c9a6afea9e74bac$export$1b30f4f9897b3baf = (node)=>{
    // FA204 / frank trap — inlined, see setDragRef above.
    const REF_DROP_ATTR = 'data-ref-drop';
    return node && node.closest ? node.closest('[' + REF_DROP_ATTR + ']') : null;
};
const $4c9a6afea9e74bac$export$79b3cebae6cd5515 = (targetNode, ref, pos)=>{
    if (!targetNode || !ref || !ref.kind) return false;
    // FA204 / frank trap — inlined, see setDragRef above.
    const DRAG_REF_MIME = 'application/x-symbols-ref';
    try {
        // `globalThis.DataTransfer` (not the bare global) — frank's known-globals
        // allowlist doesn't recognize `DataTransfer` by name (`DragEvent` right
        // below it is recognized), so the bare reference was an
        // `unresolvable-scope-read` `frank to-json` finding. Same runtime
        // behavior: throws (caught below, returns false) in any environment
        // without a real DataTransfer constructor, browser or not.
        const dt = new globalThis.DataTransfer();
        dt.setData(DRAG_REF_MIME, JSON.stringify({
            kind: ref.kind,
            id: ref.id != null ? String(ref.id) : '',
            title: ref.title || '',
            href: ref.href || '',
            ...ref.meta ? {
                meta: ref.meta
            } : {}
        }));
        dt.setData('text/plain', ref.href || ref.title || '');
        const ev = new DragEvent('drop', {
            bubbles: true,
            cancelable: true,
            dataTransfer: dt,
            clientX: pos && pos.clientX || 0,
            clientY: pos && pos.clientY || 0
        });
        targetNode.dispatchEvent(ev);
        return true;
    } catch (_) {
        return false;
    }
};

});

parcelRegister("drrN1", function(module, exports) {

$parcel$export(module.exports, "ENTITY_REF_TYPES", () => $9c935a6c805d39d1$export$e8d46b2ea831f271);
$parcel$export(module.exports, "parseEntityRef", () => $9c935a6c805d39d1$export$cb2f8da583ac4d09);
$parcel$export(module.exports, "formatEntityRef", () => $9c935a6c805d39d1$export$fef6dc566191dbdc);
$parcel$export(module.exports, "isEntityRef", () => $9c935a6c805d39d1$export$c869f081fb6fc2ed);
$parcel$export(module.exports, "entityRefHref", () => $9c935a6c805d39d1$export$20332491b7ba25ed);
$parcel$export(module.exports, "entityRefIcon", () => $9c935a6c805d39d1$export$6e79b385be7cc1d8);
$parcel$export(module.exports, "entityRefKindKey", () => $9c935a6c805d39d1$export$18f62dc28117395c);
// entityRef — THE one shared contract for "a pointer at a workspace entity"
// (VaultOS v2 design §2). Every surface that has to name a record, document,
// mail thread, ticket, file, event, chat channel or canvas board keys on this
// shape, and on ONE string form:
//
//   EntityRef  = { type, id, title?, kind?, collection?, meta? }
//   type       ∈ record | doc | mail | ticket | file | event | channel | canvas
//   string     = 'ref:<type>:<id>'
//
// Per-type `id` grammar (the parser does NOT enforce it — it only splits the
// string form; a malformed id degrades to a ref whose href is null):
//   record → '<collectionKey>/<recordId>'   'vault.items/i-lb-contract-1'
//   mail   → '<threadId>' or '<threadId>#<messageId>' for a single message
//   canvas → '<projectId>/<boardPageId>'
//
// It lives in shared/functions for the same reason dragRef.js does: BOTH ends
// cross package boundaries. Producers are canvas items, AI source trailers,
// comment threads and module pages; consumers are the assistant renderer, the
// canvas entity card and the comment thread. Packages must never import from
// each other (FA001) — every consumer goes through
// `el.call('parseEntityRef' | 'formatEntityRef' | 'entityRefHref' |
// 'entityRefIcon' | 'isEntityRef', …)`.
//
// The server carries a mirror of the PARSE/FORMAT half at
// `server/src/core/utils/entityRef.js` under the same names. Hrefs are a
// client-route concern and live only here.
//
// ── FA204 / frank trap ──────────────────────────────────────────────────────
// Every function below is SELF-CONTAINED: it inlines its own constants and
// never reads a module-scope const or calls a sibling export by its bare name.
// frank.toJSON serializes each exported function on its own and does NOT
// rewrite free vars inside hoisted helper bodies, so a bare sibling read is
// `undefined` at runtime in a published consumer. dragRef.js in this same
// folder is organised the identical way — keep both that way.
// The eight types this contract defines. Exported for producers that want to
// validate before minting (the canvas picker, the server allowlist mirror).
// Anything outside the list still PARSES — unknown types degrade to a null
// href and the generic glyph rather than throwing, exactly like
// DRAG_REF_KINDS' unknown-kind rule.
const $9c935a6c805d39d1$export$e8d46b2ea831f271 = [
    'record',
    'doc',
    'mail',
    'ticket',
    'file',
    'event',
    'channel',
    'canvas'
];
const $9c935a6c805d39d1$export$cb2f8da583ac4d09 = (value)=>{
    if (!value) return null;
    if (typeof value === 'string') {
        const raw = value.trim();
        if (raw.slice(0, 4) !== 'ref:') return null;
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return null;
        const type = rest.slice(0, cut).trim();
        let id = rest.slice(cut + 1).trim();
        if (!type || !id) return null;
        // Inlined, not a shared helper — see the FA204 note in the file header.
        if (type === 'record') {
            const slash = id.indexOf('/');
            if (slash > 0) id = id.slice(0, slash).toLowerCase() + id.slice(slash);
        }
        return {
            type: type,
            id: id
        };
    }
    if (typeof value !== 'object') return null;
    // `{ ref: 'ref:…' }` — the trailer/source shape. Parse the string leg first,
    // then let the object's own fields ride along (title/use/meta/verified…).
    if (!value.type && typeof value.ref === 'string') {
        const raw = value.ref.trim();
        if (raw.slice(0, 4) !== 'ref:') return null;
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return null;
        const type = rest.slice(0, cut).trim();
        let id = rest.slice(cut + 1).trim();
        if (!type || !id) return null;
        if (type === 'record') {
            const slash = id.indexOf('/');
            if (slash > 0) id = id.slice(0, slash).toLowerCase() + id.slice(slash);
        }
        const out = {
            ...value,
            type: type,
            id: id
        };
        delete out.ref;
        return out;
    }
    const type = value.type == null ? '' : String(value.type).trim();
    let id = value.id == null ? '' : String(value.id).trim();
    if (!type || !id) return null;
    if (type === 'record') {
        const slash = id.indexOf('/');
        if (slash > 0) id = id.slice(0, slash).toLowerCase() + id.slice(slash);
    }
    return {
        ...value,
        type: type,
        id: id
    };
};
const $9c935a6c805d39d1$export$fef6dc566191dbdc = (ref)=>{
    if (!ref) return '';
    // Self-contained parse (does NOT call the sibling parseEntityRef — see the
    // FA204 note in the file header).
    let type = '';
    let id = '';
    if (typeof ref === 'string') {
        const raw = ref.trim();
        if (raw.slice(0, 4) !== 'ref:') return '';
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return '';
        type = rest.slice(0, cut).trim();
        id = rest.slice(cut + 1).trim();
    } else if (typeof ref === 'object') {
        if (!ref.type && typeof ref.ref === 'string') {
            // Inlined, NOT a recursive `formatEntityRef(ref.ref)` call — a
            // module-scope const read from inside its own body is the same FA204
            // trap as any other sibling read (see the file header).
            const raw = ref.ref.trim();
            if (raw.slice(0, 4) !== 'ref:') return '';
            const rest = raw.slice(4);
            const cut = rest.indexOf(':');
            if (cut < 1) return '';
            type = rest.slice(0, cut).trim();
            id = rest.slice(cut + 1).trim();
        } else {
            type = ref.type == null ? '' : String(ref.type).trim();
            id = ref.id == null ? '' : String(ref.id).trim();
        }
    } else return '';
    if (!type || !id) return '';
    // Same single normalisation as parseEntityRef, inlined for the same FA204
    // reason: the string form is what travels, so it is what has to agree with
    // the server byte for byte.
    if (type === 'record') {
        const slash = id.indexOf('/');
        if (slash > 0) id = id.slice(0, slash).toLowerCase() + id.slice(slash);
    }
    return 'ref:' + type + ':' + id;
};
const $9c935a6c805d39d1$export$c869f081fb6fc2ed = (value)=>{
    if (!value) return false;
    if (typeof value === 'string') {
        const raw = value.trim();
        if (raw.slice(0, 4) !== 'ref:') return false;
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return false;
        return !!rest.slice(0, cut).trim() && !!rest.slice(cut + 1).trim();
    }
    if (typeof value !== 'object') return false;
    if (!value.type && typeof value.ref === 'string') {
        const raw = value.ref.trim();
        if (raw.slice(0, 4) !== 'ref:') return false;
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return false;
        return !!rest.slice(0, cut).trim() && !!rest.slice(cut + 1).trim();
    }
    const type = value.type == null ? '' : String(value.type).trim();
    const id = value.id == null ? '' : String(value.id).trim();
    return !!type && !!id;
};
function $9c935a6c805d39d1$export$20332491b7ba25ed(ref, root) {
    if (!ref) return null;
    // Self-contained parse — see the FA204 note in the file header.
    let type = '';
    let id = '';
    let meta = null;
    if (typeof ref === 'string') {
        const raw = ref.trim();
        if (raw.slice(0, 4) !== 'ref:') return null;
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return null;
        type = rest.slice(0, cut).trim();
        id = rest.slice(cut + 1).trim();
    } else if (typeof ref === 'object') {
        if (!ref.type && typeof ref.ref === 'string') {
            const raw = ref.ref.trim();
            if (raw.slice(0, 4) !== 'ref:') return null;
            const rest = raw.slice(4);
            const cut = rest.indexOf(':');
            if (cut < 1) return null;
            type = rest.slice(0, cut).trim();
            id = rest.slice(cut + 1).trim();
        } else {
            type = ref.type == null ? '' : String(ref.type).trim();
            id = ref.id == null ? '' : String(ref.id).trim();
        }
        meta = ref.meta && typeof ref.meta === 'object' ? ref.meta : null;
    } else return null;
    if (!type || !id) return null;
    if (meta && typeof meta.href === 'string' && meta.href) return meta.href;
    const enc = (v)=>encodeURIComponent(String(v));
    if (type === 'record') {
        // '<collectionKey>/<recordId>' — the collection segment is already
        // lower-cased by the parse above, and the record id keeps its case.
        const slash = id.indexOf('/');
        if (slash < 1) return null;
        const collection = id.slice(0, slash).toLowerCase();
        const recordId = id.slice(slash + 1);
        if (!collection || !recordId) return null;
        let src = root && typeof root === 'object' ? root : null;
        if (!src && this && typeof this === 'object' && typeof this.getRootState === 'function') try {
            src = this.getRootState();
        } catch (_) {
            src = null;
        }
        if (!src || typeof src !== 'object') return null;
        // The takeover module's rows first, then every additive app's — first
        // declaration of a key wins, exactly the order `liveFileHandlers` uses so
        // an installed app can never shadow the workspace's own module.
        const lists = [];
        const proj = src.workspaceProject;
        if (proj && typeof proj === 'object' && Array.isArray(proj.recordRoutes)) lists.push(proj.recordRoutes);
        if (Array.isArray(src.workspaceApps)) {
            for (const app of src.workspaceApps)if (app && typeof app === 'object' && Array.isArray(app.recordRoutes)) lists.push(app.recordRoutes);
        }
        for (const rows of lists)for (const row of rows){
            if (!row || typeof row !== 'object') continue;
            const rowKey = row.key == null ? '' : String(row.key).trim().toLowerCase();
            if (rowKey !== collection) continue;
            const route = row.route == null ? '' : String(row.route).trim();
            const param = row.param == null ? '' : String(row.param).trim();
            // A half-declared row can never mint a href — the shell would
            // otherwise navigate somewhere blank and wait for a page that is
            // never coming (same rule `_normalizeOpens` applies to ext + entry).
            if (!route || route.charAt(0) !== '/' || !param) continue;
            return route + '?' + param + '=' + enc(recordId);
        }
        return null;
    }
    if (type === 'doc') return '/notes?id=' + enc(id);
    if (type === 'mail') {
        const hash = id.indexOf('#');
        return '/mail?thread=' + enc(hash === -1 ? id : id.slice(0, hash));
    }
    if (type === 'ticket') return '/tasks?ticket=' + enc(id);
    if (type === 'file') return '/files?node=' + enc(id);
    if (type === 'event') return '/calendar?event=' + enc(id);
    if (type === 'channel') return '/chat?channel=' + enc(id);
    if (type === 'canvas') {
        const owner = meta && meta.owner ? String(meta.owner) : '';
        const key = meta && meta.key ? String(meta.key) : '';
        if (!owner || !key) return null;
        const slash = id.indexOf('/');
        const boardPageId = slash === -1 ? '' : id.slice(slash + 1);
        return '/' + enc(owner) + '/' + enc(key) + (boardPageId ? '?board=' + enc(boardPageId) : '');
    }
    return null;
}
const $9c935a6c805d39d1$export$6e79b385be7cc1d8 = (ref)=>{
    // FA204 / frank trap — inlined (self-contained local), see the file header.
    const TYPE_ICONS = {
        record: 'database',
        doc: 'document',
        mail: 'email',
        ticket: 'checkOval',
        file: 'document',
        event: 'dateOutline',
        channel: 'chat',
        canvas: 'grid'
    };
    let type = '';
    if (typeof ref === 'string') {
        const raw = ref.trim();
        if (raw.slice(0, 4) === 'ref:') {
            const rest = raw.slice(4);
            const cut = rest.indexOf(':');
            if (cut > 0) type = rest.slice(0, cut).trim();
        }
    } else if (ref && typeof ref === 'object') {
        if (!ref.type && typeof ref.ref === 'string') {
            const raw = ref.ref.trim();
            if (raw.slice(0, 4) === 'ref:') {
                const rest = raw.slice(4);
                const cut = rest.indexOf(':');
                if (cut > 0) type = rest.slice(0, cut).trim();
            }
        } else if (ref.type != null) type = String(ref.type).trim();
    }
    return TYPE_ICONS[type] || 'document';
};
const $9c935a6c805d39d1$export$18f62dc28117395c = (ref)=>{
    // FA204 / frank trap — inlined (self-contained local), see the file header.
    const TYPE_KEYS = {
        record: 'ai.sources.kind.record',
        doc: 'ai.sources.kind.doc',
        mail: 'ai.sources.kind.mail',
        ticket: 'ai.sources.kind.ticket',
        file: 'ai.sources.kind.file',
        event: 'ai.sources.kind.event',
        channel: 'ai.sources.kind.channel',
        canvas: 'ai.sources.kind.canvas'
    };
    let type = '';
    if (typeof ref === 'string') {
        const raw = ref.trim();
        if (raw.slice(0, 4) === 'ref:') {
            const rest = raw.slice(4);
            const cut = rest.indexOf(':');
            if (cut > 0) type = rest.slice(0, cut).trim();
        }
    } else if (ref && typeof ref === 'object') {
        if (!ref.type && typeof ref.ref === 'string') {
            const raw = ref.ref.trim();
            if (raw.slice(0, 4) === 'ref:') {
                const rest = raw.slice(4);
                const cut = rest.indexOf(':');
                if (cut > 0) type = rest.slice(0, cut).trim();
            }
        } else if (ref.type != null) type = String(ref.type).trim();
    }
    return TYPE_KEYS[type] || 'ai.sources.kind.unknown';
};

});

parcelRegister("8YjBp", function(module, exports) {

$parcel$export(module.exports, "commentRowsFrom", () => $688321f6a32ef0f2$export$d4d0f57bcfe81c33);
$parcel$export(module.exports, "commentAuthorLabel", () => $688321f6a32ef0f2$export$6e29e379a5b99e3b);
$parcel$export(module.exports, "commentTimeLabel", () => $688321f6a32ef0f2$export$f4c2cf3b89221554);
$parcel$export(module.exports, "canManageComment", () => $688321f6a32ef0f2$export$73b3ab90f804f268);
$parcel$export(module.exports, "commentThreadRows", () => $688321f6a32ef0f2$export$45ec821cea32afba);
$parcel$export(module.exports, "commentCreatePayload", () => $688321f6a32ef0f2$export$eb414efb6e8bfff);
$parcel$export(module.exports, "commentListFilter", () => $688321f6a32ef0f2$export$630254e9173f3b2);
// commentThread — the PURE half of the shared CommentThread component
// (VaultOS v2 design §3.5).
//
// Everything here is a function of its arguments: no DOM, no SDK, no state.
// The component (components/CommentThread.js) owns the four
// `sdk.execute('comments', …)` calls and the rendering; this file owns the
// shape of a thread, so the ordering, the tombstone rule and the permission
// rule are unit-testable without a browser or a server.
//
// The row shape it produces:
//   { id, body, authorEmail, author, createdAt, editedAt, replyTo, deleted,
//     depth, ownedByMe, canRemove, replyCount }
//
// ── FA204 / frank trap ──────────────────────────────────────────────────────
// Every export is SELF-CONTAINED: it inlines its constants and never reads a
// module-scope const or calls a sibling export by its bare name. Same rule as
// dragRef.js / entityRef.js in this folder — see their headers for why.
// Normalize whatever the SDK handed back into a plain array of rows.
//
// `sdk.execute('comments', 'list', …)` resolves through BaseService._call,
// which already unwraps `{ success, data }` → `data`. But the dispatcher and
// the declarative fetch adapter both have shapes that wrap once more, and a
// caller that passes the raw response straight through is the common mistake —
// so accept the bare array, `{ data }`, `{ rows }` and `{ items }` and return
// [] for anything else. Never throws.
const $688321f6a32ef0f2$export$d4d0f57bcfe81c33 = (raw)=>{
    if (Array.isArray(raw)) return raw;
    if (!raw || typeof raw !== 'object') return [];
    if (Array.isArray(raw.data)) return raw.data;
    if (Array.isArray(raw.rows)) return raw.rows;
    if (Array.isArray(raw.items)) return raw.items;
    return [];
};
const $688321f6a32ef0f2$export$6e29e379a5b99e3b = (comment)=>{
    const email = comment && comment.authorEmail ? String(comment.authorEmail) : '';
    if (!email) return '';
    const at = email.indexOf('@');
    const local = at === -1 ? email : email.slice(0, at);
    if (!local) return email;
    return local.charAt(0).toUpperCase() + local.slice(1);
};
function $688321f6a32ef0f2$export$f4c2cf3b89221554(value) {
    if (value == null || value === '') return '';
    const d = new Date(value);
    const t = d.getTime();
    if (Number.isNaN(t)) return '';
    const opts = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    };
    const out = this && typeof this.call === 'function' ? this.call('localizedDate', d, opts) : '';
    return typeof out === 'string' && out ? out : d.toLocaleString([], opts);
}
const $688321f6a32ef0f2$export$73b3ab90f804f268 = (comment, viewer)=>{
    if (!comment || comment.deleted) return false;
    const email = viewer && viewer.email ? String(viewer.email).toLowerCase() : '';
    const author = comment.authorEmail ? String(comment.authorEmail).toLowerCase() : '';
    if (email && author && email === author) return true;
    return !!(viewer && viewer.canManageOthers);
};
const $688321f6a32ef0f2$export$45ec821cea32afba = (raw, viewer)=>{
    // Self-contained unwrap (does NOT call the sibling commentRowsFrom — see the
    // FA204 note in the file header).
    let list = [];
    if (Array.isArray(raw)) list = raw;
    else if (raw && typeof raw === 'object') {
        if (Array.isArray(raw.data)) list = raw.data;
        else if (Array.isArray(raw.rows)) list = raw.rows;
        else if (Array.isArray(raw.items)) list = raw.items;
    }
    const email = viewer && viewer.email ? String(viewer.email).toLowerCase() : '';
    const canManageOthers = !!(viewer && viewer.canManageOthers);
    const norm = [];
    for (const c of list){
        if (!c || typeof c !== 'object') continue;
        const id = c._id != null ? String(c._id) : c.id != null ? String(c.id) : '';
        if (!id) continue;
        const authorEmail = c.authorEmail ? String(c.authorEmail) : '';
        const author = (()=>{
            if (!authorEmail) return '';
            const at = authorEmail.indexOf('@');
            const local = at === -1 ? authorEmail : authorEmail.slice(0, at);
            if (!local) return authorEmail;
            return local.charAt(0).toUpperCase() + local.slice(1);
        })();
        const deleted = !!c.deleted;
        const mine = !!(email && authorEmail && email === authorEmail.toLowerCase());
        norm.push({
            id: id,
            body: deleted ? '' : String(c.body == null ? '' : c.body),
            authorEmail: authorEmail,
            author: author,
            createdAt: c.createdAt || c.created_at || null,
            editedAt: c.editedAt || null,
            replyTo: c.replyTo != null ? String(c.replyTo) : null,
            deleted: deleted,
            depth: 0,
            ownedByMe: mine,
            canRemove: !deleted && (mine || canManageOthers),
            replyCount: 0
        });
    }
    // Chronological. A row with no stamp sorts last but keeps its arrival order
    // (a stable sort), so an optimistic row appended before the server answers
    // stays where the user saw it appear.
    const stamp = (r)=>{
        const t = r.createdAt ? new Date(r.createdAt).getTime() : NaN;
        return Number.isNaN(t) ? Infinity : t;
    };
    norm.sort((a, b)=>stamp(a) - stamp(b));
    const byId = new Map();
    for (const r of norm)byId.set(r.id, r);
    // Resolve each row to its ROOT ancestor and count replies on the way. A
    // reply whose parent is not in this thread (deleted hard, or paginated out)
    // is promoted to a root rather than dropped.
    const rootOf = new Map();
    for (const r of norm){
        let cur = r;
        let hops = 0;
        while(cur.replyTo && byId.has(cur.replyTo) && hops < 64){
            cur = byId.get(cur.replyTo);
            hops++;
        }
        rootOf.set(r.id, cur.id);
        if (cur.id !== r.id) {
            r.depth = 1;
            cur.replyCount++;
        }
    }
    const roots = norm.filter((r)=>rootOf.get(r.id) === r.id);
    const out = [];
    for (const root of roots){
        // A tombstone with no surviving replies is noise, not history.
        if (root.deleted && root.replyCount === 0) continue;
        out.push(root);
        for (const r of norm){
            if (r.id === root.id) continue;
            if (rootOf.get(r.id) !== root.id) continue;
            if (r.deleted) continue;
            out.push(r);
        }
    }
    return out;
};
const $688321f6a32ef0f2$export$eb414efb6e8bfff = (entityRef, body, replyTo)=>{
    const text = body == null ? '' : String(body).trim();
    if (!text) return null;
    let type = '';
    let id = '';
    if (typeof entityRef === 'string') {
        const raw = entityRef.trim();
        if (raw.slice(0, 4) !== 'ref:') return null;
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return null;
        type = rest.slice(0, cut).trim();
        id = rest.slice(cut + 1).trim();
    } else if (entityRef && typeof entityRef === 'object') {
        if (!entityRef.type && typeof entityRef.ref === 'string') {
            const raw = entityRef.ref.trim();
            if (raw.slice(0, 4) !== 'ref:') return null;
            const rest = raw.slice(4);
            const cut = rest.indexOf(':');
            if (cut < 1) return null;
            type = rest.slice(0, cut).trim();
            id = rest.slice(cut + 1).trim();
        } else {
            type = entityRef.type == null ? '' : String(entityRef.type).trim();
            id = entityRef.id == null ? '' : String(entityRef.id).trim();
        }
    } else return null;
    if (!type || !id) return null;
    const parent = replyTo == null || replyTo === '' ? null : String(replyTo);
    return {
        entityRef: {
            type: type,
            id: id
        },
        body: text,
        ...parent ? {
            replyTo: parent
        } : {}
    };
};
const $688321f6a32ef0f2$export$630254e9173f3b2 = (entityRef)=>{
    let type = '';
    let id = '';
    if (typeof entityRef === 'string') {
        const raw = entityRef.trim();
        if (raw.slice(0, 4) !== 'ref:') return null;
        const rest = raw.slice(4);
        const cut = rest.indexOf(':');
        if (cut < 1) return null;
        type = rest.slice(0, cut).trim();
        id = rest.slice(cut + 1).trim();
    } else if (entityRef && typeof entityRef === 'object') {
        if (!entityRef.type && typeof entityRef.ref === 'string') {
            const raw = entityRef.ref.trim();
            if (raw.slice(0, 4) !== 'ref:') return null;
            const rest = raw.slice(4);
            const cut = rest.indexOf(':');
            if (cut < 1) return null;
            type = rest.slice(0, cut).trim();
            id = rest.slice(cut + 1).trim();
        } else {
            type = entityRef.type == null ? '' : String(entityRef.type).trim();
            id = entityRef.id == null ? '' : String(entityRef.id).trim();
        }
    } else return null;
    if (!type || !id) return null;
    return {
        entityType: type,
        entityId: id
    };
};

});

parcelRegister("g6SPq", function(module, exports) {

$parcel$export(module.exports, "buildPromptPayload", () => $bba7bca61bde64cc$export$2286b31c04e6c3f1);
$parcel$export(module.exports, "clearedPromptState", () => $bba7bca61bde64cc$export$9268c013defef4e6);
$parcel$export(module.exports, "removePromptAttachment", () => $bba7bca61bde64cc$export$8532b0522d67354);
$parcel$export(module.exports, "removePickedElement", () => $bba7bca61bde64cc$export$7bc085aeed352254);
// promptAttachments — the ONE way a prompt composer turns its dropped
// attachments into something the AI actually receives.
//
// Why this exists in shared/ rather than inside the composer: the composer
// component lives in packages/canvas (CanvasPromptTextarea._sendPrompt), but
// the only LIVE mount of it is the workspace shell's override in
// packages/workspace/app.js, which replaces the send handlers to route through
// `homeAiSend` instead. That override read `state.draft` and nothing else — so
// a dropped file/ref/image rendered a chip, was ignored on send, and was never
// even cleared afterwards (it stayed in the gallery looking sent). Two send
// paths, two different ideas of what a prompt body is, and the one users
// actually touch was the broken one. Packages can't import from each other
// (FA001), so the single source has to live here and be reached via el.call.
//
// TRANSMISSION REALITY — do not overstate this. The local-agent bridge ships
// `{type:'user_message', text, context, attachments}`, but its receiving
// handler currently reads only `text`/`context`. So the CONTEXT LINES below
// are the only part guaranteed to reach the agent today; `attachments` (which
// carries real image bytes) leaves the browser intact but is dropped on the
// far side until the bridge forwards it. That's why images get a text line
// too, rather than relying on the byte payload alone.
// Build the outgoing prompt body + attachment payload from a composer's own
// state. Returns { body, attachments, isEmpty }.
//
// `isEmpty` is the guard the caller should use INSTEAD of testing the draft
// alone: a drop containing only an image and no typed text is a real prompt,
// and testing `!draft` alone silently submitted nothing.
//
// `el` is needed only to resolve dragRefToText through el.call (refs render as
// markdown links so the agent gets a working deep link back to the entity).
const $bba7bca61bde64cc$export$2286b31c04e6c3f1 = function(el, st) {
    // FA204 / frank trap — moved from module scope into this function (sole
    // consumer, pure helper — see longPress.js for the identical shape).
    const _fmtBytes = (n)=>{
        if (n == null || Number.isNaN(n)) return '';
        if (n < 1024) return `${n} B`;
        if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
        return `${(n / 1048576).toFixed(1)} MB`;
    };
    const draft = (st && st.draft || '').trim();
    const files = st && st.files || [];
    const refs = st && st.refs || [];
    const images = st && st.images || [];
    const contextLines = [
        ...refs.map((ref)=>{
            try {
                return el.call('dragRefToText', ref);
            } catch (_) {
                // Unregistered el.call returns undefined silently; fall back to
                // something readable rather than emitting "undefined" into the prompt.
                return ref && (ref.title || ref.href) || '';
            }
        }),
        ...files.map((f)=>`[Attached file: ${f.name} (${f.mime}, ${_fmtBytes(f.size)})]`),
        // Images may be legacy bare data-URL strings from an older composer state
        // shape; those carry no metadata, so describe them generically instead of
        // emitting "[Attached image: undefined (undefined, )]".
        ...images.map((img)=>img && typeof img === 'object' && img.name ? `[Attached image: ${img.name} (${img.mime}, ${_fmtBytes(img.size)})]` : '[Attached image]')
    ].filter(Boolean);
    const body = contextLines.length ? [
        draft,
        ...contextLines
    ].filter(Boolean).join('\n') : draft;
    // Only real image objects carry bytes worth forwarding.
    const attachments = images.filter((img)=>img && typeof img === 'object' && img.dataUrl).map((img)=>({
            name: img.name,
            mime: img.mime,
            size: img.size,
            dataUrl: img.dataUrl
        }));
    return {
        body: body,
        attachments: attachments,
        isEmpty: !draft && !files.length && !refs.length && !images.length
    };
};
const $bba7bca61bde64cc$export$9268c013defef4e6 = ()=>({
        draft: '',
        files: [],
        refs: [],
        images: []
    });
const $bba7bca61bde64cc$export$8532b0522d67354 = function(desc) {
    if (!desc || !desc.kind || desc.key == null) return false;
    let host = this;
    while(host && host.parent && !(host.state && host.state.images))host = host.parent;
    const st = host && host.state;
    if (!st || typeof st.update !== 'function') return false;
    const listKey = desc.kind === 'ref' ? 'refs' : desc.kind === 'file' ? 'files' : 'images';
    const list = Array.isArray(st[listKey]) ? st[listKey] : [];
    st.update({
        [listKey]: list.filter((x)=>!x || x.key !== desc.key)
    });
    return true;
};
const $bba7bca61bde64cc$export$7bc085aeed352254 = function(pickedAt) {
    const el = this;
    const root = el && el.state && el.state.root || el && el.getRoot && el.getRoot()?.state || null;
    if (!root || typeof root.update !== 'function') return false;
    const list = Array.isArray(root.pickedElements) ? root.pickedElements : [];
    root.update({
        pickedElements: pickedAt == null ? [] : list.filter((p)=>p && p.pickedAt !== pickedAt)
    });
    return true;
};

});

parcelRegister("9XFqh", function(module, exports) {

$parcel$export(module.exports, "accountMenuItems", () => $7409c17cfc1e92d2$export$bd3c94073eb9a335);
$parcel$export(module.exports, "openAccountPage", () => $7409c17cfc1e92d2$export$5b23a9da7f5a707d);
$parcel$export(module.exports, "accountMenuAction", () => $7409c17cfc1e92d2$export$b3a4a7187be7a306);
$parcel$export(module.exports, "openAccountMenu", () => $7409c17cfc1e92d2$export$3e81f647febb1cec);
// Account (avatar) menu — the header avatar opens the shared house
// ContextDropdown (`root.contextDropdown`) instead of a bespoke dropdown, so it
// reuses the EXACT /files context-menu shape + styles (MenuPanel /
// MenuPanelItem). `accountMenuItems` builds the rows; `accountMenuAction`
// dispatches. Mirror of filesContextItems / filesContextAction.

var $e0RDd = parcelRequire("e0RDd");

var $9juhh = parcelRequire("9juhh");
// The home dashboard's path, with or without the workspace prefix.
const $7409c17cfc1e92d2$var$_isHomePath = (path)=>{
    if (path === '/') return true;
    if (typeof path !== 'string' || !path.startsWith('/w/')) return false;
    const rest = (0, $9juhh.stripWorkspacePrefix)(path);
    return rest === '/' || rest === '';
};
const $7409c17cfc1e92d2$export$bd3c94073eb9a335 = function(root) {
    const cm = root && root.contextDropdown;
    if (!cm || !cm.open) return [];
    const items = [];
    // Admin gate evaluated AT OPEN. The shell's /admin pages (and the
    // launcher's Admin group) open for every workspace owner and admin
    // (`currentUserIsAdmin`), so the row does too — and for a superadmin
    // (persona round 5, tomas: Admin had no normal entry). Both functions are
    // absent outside the workspace shell (el.call answers undefined) or may
    // throw; each check is guarded on its own and reads false then. One row.
    // The root state goes in as the argument (roleHelpers.js reads it first).
    const asks = (name)=>{
        try {
            return !!this.call(name, root);
        } catch (_) {
            return false;
        }
    };
    if (asks('currentUserIsAdmin') || asks('currentUserIsSuperadmin')) items.push({
        key: 'admin',
        action: 'admin',
        label: 'shell.accountMenu.admin'
    });
    items.push({
        key: 'profile',
        action: 'profile',
        label: 'shell.accountMenu.profile'
    });
    items.push({
        key: 'settings',
        action: 'settings',
        label: 'shell.accountMenu.settings'
    });
    // Setup belongs to the workspace shell. Other shared-header hosts do not
    // register the replay flow and must not offer an inert menu entry.
    if (typeof this.context?.functions?.onboardingReplay === 'function') items.push({
        key: 'onboarding',
        action: 'onboarding',
        label: 'shell.accountMenu.replayOnboarding'
    });
    // "Customize dashboard" - only on the home dashboard (its action toggles the
    // home customize mode). Moved here from the floating on-page button (2026-06-22
    // per Nika "move FloatingCustomizeBtn into navbar dropdown").
    // The home is `/` once the workspace prefix is off: in the workspace shell
    // the address is `/w/<org>/<workspace>`, and the bare `=== '/'` test never
    // matched it — measured on dev 586122071 (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1):
    // the avatar menu at /w/dfli/dfi listed profile, settings, theme and sign
    // out, no "Customize dashboard", so a touch screen's one visible way into
    // edit mode was gone.
    if (root && $7409c17cfc1e92d2$var$_isHomePath(root.currentPath)) items.push({
        key: 'customize',
        action: 'customize',
        label: 'shell.accountMenu.customizeDashboard'
    });
    // Theme — ONE explicit choice, never a blind cycle (white-label redesign,
    // DESIGN_SPEC §9 "Avatar menu"): the row names the current mode ("Theme:
    // dark") and opens the three modes, the current one checked. A pick is
    // terminal — see accountMenuAction's `themeMode` branch.
    //
    // The mode words are lowercase in the bundle because they sit inside
    // "Theme: {mode}"; as rows they take sentence case the way CSS
    // `text-transform` would — never for Georgian Mkhedruli, which
    // `toUpperCase()` turns into Mtavruli capitals (AppMicroLabel's note,
    // georgianEyebrowsStayMkhedruli.test.js). The three keys are written out,
    // never concatenated (docs/I18N-CONVENTION.md §1.3).
    const current = root && root.themeMode || 'auto';
    const rowCase = (word)=>{
        const w = String(word || '');
        return /^[\u10D0-\u10FF]/.test(w) ? w : w.charAt(0).toUpperCase() + w.slice(1);
    };
    const modes = [
        {
            mode: 'auto',
            key: 'shell.theme.mode.auto'
        },
        {
            mode: 'light',
            key: 'shell.theme.mode.light'
        },
        {
            mode: 'dark',
            key: 'shell.theme.mode.dark'
        }
    ];
    items.push({
        key: 'theme',
        label: this.call('labelForTheme', current),
        children: modes.map((m)=>({
                key: `theme-${m.mode}`,
                action: 'themeMode',
                mode: m.mode,
                label: rowCase(this.call('polyglot', m.key)),
                checked: current === m.mode
            }))
    });
    // Language — the WORKSPACE's language, where a person looks for it
    // (persona audit WL-2: it sat four taps deep, name → Admin → Workspace
    // Settings → Language). The workspace shell builds the row
    // (`workspaceLanguageMenuRow`: owner/admin only, the shipped languages by
    // endonym, the current one checked — the Theme row's shape) and applies a
    // pick at once (`workspaceLanguageSelect`, accountMenuAction below); a host
    // that registers neither shows no row, and the shell answers null for a
    // member (the workspace's language is its admins' choice).
    const langFns = this.context?.functions;
    if (typeof langFns?.workspaceLanguageMenuRow === 'function' && typeof langFns?.workspaceLanguageSelect === 'function') {
        const langRow = this.call('workspaceLanguageMenuRow', root);
        if (langRow && Array.isArray(langRow.children) && langRow.children.length) items.push(langRow);
    }
    // Human / Agent is a workspace-shell preference. Keep it in the avatar
    // menu on every route, including phones; other shared-header hosts omit it.
    const modeFns = this.context?.functions;
    if (typeof modeFns?.workspaceModeShown === 'function' && typeof modeFns?.workspaceModeOf === 'function' && typeof modeFns?.workspaceModeSelect === 'function' && this.call('workspaceModeShown', root)) {
        const mode = this.call('workspaceModeOf', root);
        items.push({
            key: 'workspace-mode',
            label: 'workspace.agentMode.switchLabel',
            children: [
                {
                    key: 'mode-human',
                    action: 'workspaceMode',
                    mode: 'ui',
                    label: 'workspace.agentMode.ui',
                    checked: mode === 'ui'
                },
                {
                    key: 'mode-agent',
                    action: 'workspaceMode',
                    mode: 'cli',
                    label: 'workspace.agentMode.cli',
                    checked: mode === 'cli'
                }
            ]
        });
    }
    // Navbar — where the navbar sits (Nika 2026-10-24: "make sidebar optional to
    // be positioned at the top left right or bottom"; navbarLayout.js beside
    // this file): the Theme row's shape — the row names the
    // person's place ("Navbar: left") and opens the four, theirs checked. A
    // phone keeps its own header whatever the choice, so it shows no row; nor
    // does a host whose frame cannot place the navbar yet (`placeable`).
    const fns = this.context && this.context.functions;
    const nav = fns && typeof fns.navbarLayoutRead === 'function' ? this.call('navbarLayoutRead', root) : null;
    if (nav && nav.placeable && !nav.phone) {
        const places = [
            {
                position: 'top',
                key: 'shell.navbar.position.top'
            },
            {
                position: 'left',
                key: 'shell.navbar.position.left'
            },
            {
                position: 'right',
                key: 'shell.navbar.position.right'
            },
            {
                position: 'bottom',
                key: 'shell.navbar.position.bottom'
            }
        ];
        const mine = places.find((p)=>p.position === nav.position) || places[0];
        items.push({
            key: 'navbar',
            label: this.call('polyglot', 'shell.navbar.label').replace('{position}', this.call('polyglot', mine.key)),
            children: places.map((p)=>({
                    key: `navbar-${p.position}`,
                    action: 'navbarPosition',
                    position: p.position,
                    label: rowCase(this.call('polyglot', p.key)),
                    checked: nav.position === p.position
                }))
        });
    }
    items.push({
        key: 'signout',
        action: 'signout',
        label: 'shell.accountMenu.signOut',
        danger: true
    });
    return items;
};
function $7409c17cfc1e92d2$export$5b23a9da7f5a707d(path) {
    const fns = this && this.context && this.context.functions;
    if (fns && typeof fns.openAppPage === 'function') {
        this.call('openAppPage', path, {
            preferSlot: true
        });
        return;
    }
    this.router(path, this.getRoot());
}
const $7409c17cfc1e92d2$export$b3a4a7187be7a306 = async function(action, item) {
    const root = this.state.root;
    // Theme — a mode picked from the Theme submenu (accountMenuItems): apply it
    // through the framework (`changeGlobalTheme` — never a data-theme write),
    // remember it on this device and on the user record, and close the menu.
    if (action === 'themeMode') {
        const next = this.call('normalizeThemeMode', item && item.mode);
        root.update({
            themeMode: next,
            contextDropdown: null
        }, {
            preventFetch: true
        });
        this.call('writeStoredThemeMode', next);
        this.call('changeGlobalTheme', next);
        // Explicit choice → user record too (see ThemeToggle.js / themeMode.js).
        this.call('persistThemeModeToUser', root, this.sdk, next);
        return;
    }
    // Navbar — a place picked from the Navbar submenu (accountMenuItems): the
    // person's own look, this host's key (navbarLayout.js beside this file).
    if (action === 'navbarPosition') {
        root.update({
            contextDropdown: null
        }, {
            preventFetch: true
        });
        this.call('navbarLayoutSet', {
            position: item && item.position
        });
        return;
    }
    // Language — a pick from the Language submenu (accountMenuItems): the menu
    // closes, then the workspace shell writes the workspace's language and the
    // session repaints in it at once (persona audit WL-2).
    if (action === 'workspaceLanguage') {
        const fns = this.context?.functions;
        if (typeof fns?.workspaceLanguageSelect !== 'function' || !item?.code) return;
        root.update({
            contextDropdown: null
        }, {
            preventFetch: true
        });
        this.call('workspaceLanguageSelect', item.code);
        return;
    }
    if (action === 'workspaceMode') {
        const fns = this.context?.functions;
        if (typeof fns?.workspaceModeShown !== 'function' || typeof fns?.workspaceModeSelect !== 'function' || !this.call('workspaceModeShown', root) || ![
            'ui',
            'cli'
        ].includes(item?.mode)) return;
        root.update({
            contextDropdown: null
        }, {
            preventFetch: true
        });
        this.call('workspaceModeSelect', item.mode);
        return;
    }
    // Terminal actions — close first, then navigate.
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    if (action === 'onboarding') this.call('onboardingReplay', 'welcome');
    else if (action === 'admin') // Open Admin inside the home AppWindow (PageSlot) when on the home
    // dashboard, falling back to a full route elsewhere — same behaviour as
    // every other app launcher (per Nika "admin button in user dropdown should
    // open admin in PageSlot"). openAppPage owns the on-home-vs-route decision;
    // guard for shells that don't register it.
    try {
        this.call('openAppPage', '/admin');
    } catch (_) {
        this.router('/admin', this.getRoot());
    }
    else if (action === 'customize') // Enter the home dashboard customize mode (slides in the CustomizeDrawer).
    // The menu already closed above. (2026-06-22 per Nika)
    root.update({
        _homeCustomizeMode: true
    }, {
        preventFetch: true
    });
    else if (action === 'settings') // Open Settings inside the PageSlot pane (2026-09-02 per Nika "settings
    // should open in pageslot from top right menu") — same launcher gesture
    // as every other app row. preferSlot: /settings is not in
    // APP_WINDOW_ROUTES (it is a shell page, not a launcher app), and
    // unlike /admin it carries no full-page sidebar nav, so the full-page
    // gate (isFullPageRoute) does not apply. Shells without openAppPage
    // (canvas, preview) keep the plain route — openAccountPage asks the host.
    this.call('openAccountPage', '/settings');
    else if (action === 'profile') {
        // The workspace's OWN member profile (Nika 2026-10-29: "Own profile /my"):
        // where the host serves /my, the item opens it the way Settings opens
        // /settings (the shell's pane opener, else the plain route). Hosts
        // without /my keep the public profile page, by username, below.
        const hostPages = this.context && this.context.pages;
        if (hostPages && hostPages['/my']) {
            this.call('openAccountPage', '/my');
            return;
        }
        // FA204 / frank trap — the module-scoped profile-slug cache is genuine
        // cross-call mutable state (the dropdown content can't reliably read
        // page state and getMe is a round-trip, so the second open is
        // instant); re-homed onto `root.__accountMenuProfileSlugCache`
        // (every invocation of this `this`-bound action receives a fresh
        // `this`, but `root` — `this.state.root` — is the stable state
        // object every call shares), same escape hatch as navbarTabMenu.js's
        // `root.__navbarSaveQueue`.
        //
        // Slug must be the Mongo `username` (e.g. `nikoloza`), not the email
        // local-part. Try the schema key, then root.user, then a live getMe.
        let username = root && (root.currentUserUsername || root.user && root.user.username) || root && root.__accountMenuProfileSlugCache || '';
        if (!username) try {
            const me = await (this.sdk && this.sdk.getMe && this.sdk.getMe());
            const u = me && (me.data?.user || me.user) || me || {};
            username = u.username || '';
            if (username && root) root.__accountMenuProfileSlugCache = username;
        } catch (err) {
            console.warn('[accountMenu] profile slug getMe failed:', err && err.message);
        }
        // No username yet: the person's own profile where the host serves it.
        // /settings is the person's SETTINGS since the member-profile split;
        // canvas serves /settings only.
        const pages = this.context && this.context.pages;
        const own = pages && pages['/profile'] ? '/profile' : '/settings';
        this.router(username ? `/user/${encodeURIComponent(username)}` : own, this.getRoot());
    } else if (action === 'signout') await (0, $e0RDd.signoutAndRedirect)({
        sdk: this.sdk
    });
};
const $7409c17cfc1e92d2$export$3e81f647febb1cec = function(anchorEl) {
    const el = anchorEl || this;
    const node = el && el.node;
    if (!node || typeof node.getBoundingClientRect !== 'function') return false;
    const r = node.getBoundingClientRect();
    const root = this.state?.root || this.state;
    if (!root || typeof root.update !== 'function') return false;
    // Where the navbar sits (navbarLayout.js beside this file) decides the
    // side the menu opens to: under the avatar at the top (as ever), beside it on
    // a rail, above it at the bottom — the avatar sits at the screen's edge
    // there. A shell without the layout function keeps the top navbar's.
    const fns = this.context && this.context.functions;
    const nav = fns && typeof fns.navbarLayoutRead === 'function' ? this.call('navbarLayoutRead', root) : null;
    const place = nav && nav.position || 'top';
    // On a rail the menu starts past the rail's OUTER edge (navbarLayout.js
    // navbarRailRect), not 8px past the avatar: the rail is wider than the
    // avatar, and the menu covered its edge (5px on a narrow rail, measured on
    // dev 579269d80).
    const rail = fns && typeof fns.navbarRailRect === 'function' ? this.call('navbarRailRect', el) : null;
    const edge = rail || r;
    const at = place === 'left' ? {
        x: Math.round(edge.right + 8),
        y: Math.round(r.bottom),
        fromBottom: true
    } : place === 'right' ? {
        x: Math.round(edge.left - 8),
        y: Math.round(r.bottom),
        fromRight: true,
        fromBottom: true
    } : place === 'bottom' ? {
        x: Math.round(r.right),
        y: Math.round(r.top - 8),
        fromRight: true,
        fromBottom: true
    } : {
        x: Math.round(r.right - 200),
        y: Math.round(r.bottom + 8)
    };
    root.update({
        contextDropdown: {
            open: true,
            ...at,
            itemsFn: 'accountMenuItems',
            actionFn: 'accountMenuAction'
        }
    }, {
        preventFetch: true
    });
    return true;
};

});

parcelRegister("7UbLZ", function(module, exports) {

$parcel$export(module.exports, "renderAssistantMarkdown", () => $5c16e53e186b6f1f$export$6791d40ce6afceb0);
// Markdown → DOMQL children for the simone assistant.
//
// Registered as a project FUNCTION so the Chat message bubble renders markdown via
// `el.call('renderAssistantMarkdown', text)`. Shared via functions/index.js so docs,
// preview and workspace all render assistant markdown through ONE function.
//
// ── Why this looks the way it does (READ before refactoring) ──────────────────
// On the brender (docs.symbols.app) frank SERIALIZES this function and re-evals it
// in an isolated scope. In that runtime:
//   • MODULE-LEVEL code never runs — no top-level side effects, no module consts,
//     no hoisted helpers survive (they become undefined free vars → ReferenceError).
//     That's why every helper + the component map is INLINED in the body, and why a
//     module-init `window.X = …` assignment does NOT work here.
//   • An npm-import CALL can't be bundled into the serialized scope — frank rewrites
//     `transformMarkdown(…)` to `__scope.M(…)` and `__scope.M` is undefined → it is
//     NOT callable. (@symbo.ls/symbolize-markdown is an internal pkg, so it isn't
//     CDN-loadable at runtime either.)
// Net: symbolize-markdown's transformMarkdown is reachable in NORMAL bundles
// (workspace, preview) but NOT inside the serialized brender runtime.
//
// So this function is dual-mode and self-healing:
//   1. a runtime global window.__symbolizeMarkdown, if some host pre-warmed one;
//   2. else the bundled `transformMarkdown` import IF it's actually a function
//      (true in workspace/preview; on the brender `typeof` is 'undefined');
//   3. else a SELF-CONTAINED inline parser (no imports) so the brender still renders
//      real markdown.
// Same function everywhere, best renderer per environment. Framework fix to bundle
// npm scope refs into serialized fns is ticketed in tickets/smbls.md.

var $3Rzdu = parcelRequire("3Rzdu");
const $5c16e53e186b6f1f$export$6791d40ce6afceb0 = (body)=>{
    let text = (body || '') + '';
    if (!text) return [];
    // Defense-in-depth for a model that ignored the no-raw-JSON rule and
    // answered with a bare object/array (observed live 2026-08-11: a member
    // list and an architecture explanation rendered as walls of JSON prose).
    // Render it as a proper code block instead of paragraph soup — the
    // prompt-side rule is the real fix; this keeps the bubble legible when it
    // happens anyway.
    const trimmed = text.trim();
    if (/^[[{]/.test(trimmed)) try {
        const parsed = JSON.parse(trimmed);
        if (parsed && typeof parsed === 'object') return [
            {
                tag: 'pre',
                text: JSON.stringify(parsed, null, 2),
                whiteSpace: 'pre-wrap',
                overflow: 'auto',
                maxHeight: 'G',
                padding: 'Z A',
                round: 'radiusControl',
                theme: 'document',
                fontSize: '.9em'
            }
        ];
    } catch (_) {
    /* not JSON — render as markdown */ }
    // Autolink bare URLs into markdown links BEFORE any renderer — neither the
    // transpiler nor the inline fallback tokenizes a bare https://…, so pasted
    // links rendered as dead text. Skipped whenever the text carries backticks
    // (a URL inside a code sample must stay verbatim).
    if (!text.includes('`')) text = text.replace(/(^|\s)(https?:\/\/[^\s<>)]+[^\s<>).,;:!?'"])/g, (mm, pre, url)=>`${pre}[${url}](${url})`);
    // markdown node type → registered component key (symbolize path). Headings demote
    // to H6 so a chat bubble never claims page-level heading slots.
    const COMPONENTS = {
        em: 'Em',
        h1: 'H6',
        h2: 'H6',
        h3: 'H6',
        h4: 'H6',
        h5: 'H6',
        h6: 'H6',
        hr: 'Hr',
        li: 'LI',
        ol: 'OL',
        ul: 'UL',
        del: 'Del',
        img: 'Img',
        pre: 'Pre',
        code: 'InlineCode',
        link: 'Link',
        strong: 'Strong',
        codeBlock: 'CodeBlock',
        paragraph: 'P',
        blockquote: 'Blockquote'
    };
    // Pull assistant lists inside the bubble (no hanging bullets); recurse nested.
    const inset = (node)=>{
        if (!node || typeof node !== 'object') return node;
        const out = {
            ...node
        };
        const kind = out.extends || out.tag;
        if (kind === 'UL' || kind === 'ul' || kind === 'OL' || kind === 'ol') Object.assign(out, {
            listStylePosition: 'inside',
            padding: 'V 0',
            paddingLeft: '0',
            margin: 'V 0'
        });
        if (Array.isArray(out.children)) out.children = out.children.map(inset);
        return out;
    };
    // A node that renders child nodes has no text of its own, and says so. The
    // component keys above are BARE keys, so they resolve through the linked
    // libraries too, and a library's component may carry demo text: in
    // system/default `P`, `Caption` and `H1`–`H6` read "It was the last day for
    // our tribe, the year ends", `Link` reads "Link", `Strong` "Strong text".
    // A paragraph with inline marks has keyed children and no `text`, so it
    // showed that sentence before its own words (dev, system/hq, a note in CLI
    // mode, 2026-10-23); a link with bold text would show "Link". `text: null`
    // cancels an inherited text (measured with smbls create in jsdom).
    const ownTextOnly = (node)=>{
        if (!node || typeof node !== 'object' || Array.isArray(node)) return node;
        const out = {
            ...node
        };
        let hasKids = false;
        for (const k of Object.keys(out)){
            const v = out[k];
            if (/^[A-Z]/.test(k) && v && typeof v === 'object' && !Array.isArray(v)) {
                hasKids = true;
                out[k] = ownTextOnly(v);
            }
        }
        if (Array.isArray(out.children) && out.children.length) {
            hasKids = true;
            out.children = out.children.map(ownTextOnly);
        }
        if (hasKids && out.text === undefined) out.text = null;
        return out;
    };
    // Resolve the real symbolize-markdown transform if it's reachable here.
    let tm = null;
    if (typeof window !== 'undefined' && typeof window.__symbolizeMarkdown === 'function') tm = window.__symbolizeMarkdown;
    else // In the serialized brender runtime `transformMarkdown` is rewritten to an
    // undefined __scope ref — guard so the typeof check can't throw.
    try {
        if (typeof (0, $3Rzdu.transformMarkdown) === 'function') tm = (0, $3Rzdu.transformMarkdown);
    } catch (_) {
        tm = null;
    }
    if (tm) try {
        const spec = tm(text, {
            components: COMPONENTS
        });
        if (spec && typeof spec === 'object') {
            // single node ({tag|extends|text|children}) vs keyed object → children array
            const arr = 'extends' in spec || 'tag' in spec || 'text' in spec || 'children' in spec ? [
                spec
            ] : Object.keys(spec).filter((k)=>!k.startsWith('__')).map((k)=>spec[k]).filter((v)=>v && typeof v === 'object');
            if (arr.length) return arr.map((node)=>ownTextOnly(inset(node)));
        }
    } catch (_) {
    /* fall through to the inline parser */ }
    // ── Self-contained inline parser (no imports → brender-safe) ──
    // Handles **bold**, *italic*, `code`, [links](…); # headings, ``` fences,
    // - / * bullet lists, > blockquotes, and paragraphs. Styling via literal
    // var(--color-X) (raw vars are brender-safe; bare color tokens are not).
    // A backslash before ASCII punctuation is that character, literally
    // (CommonMark backslash escapes): `\*` prints `*` and opens no emphasis,
    // `\#` at a line start is no heading. A code span keeps its backslashes.
    const unescapeMd = (s)=>s.replace(/\\([!-/:-@[-`{-~])/g, '$1');
    const inline = (txt)=>{
        const parts = [];
        let plain = '';
        const flush = ()=>{
            if (plain) parts.push({
                tag: 'span',
                text: plain
            });
            plain = '';
        };
        // Link hrefs accept ANY non-space target — the old https?:|/-rooted gate
        // left relative/anchor links (`[here](tickets/123)`) as literal text.
        const re = /\\([!-/:-@[-`{-~])|\*\*((?:\\.|[^*\\])+)\*\*|\*((?:\\.|[^*\\])+)\*|`([^`]+)`|\[((?:\\.|[^\]\\])+)\]\(((?:\\.|[^)\s\\])+)\)/g;
        let last = 0;
        let m;
        while(m = re.exec(txt)){
            plain += txt.slice(last, m.index);
            last = re.lastIndex;
            if (m[1] != null) {
                plain += m[1];
                continue;
            }
            flush();
            if (m[2] != null) parts.push({
                tag: 'strong',
                text: unescapeMd(m[2])
            });
            else if (m[3] != null) parts.push({
                tag: 'em',
                text: unescapeMd(m[3])
            });
            else if (m[4] != null) parts.push({
                tag: 'code',
                text: m[4],
                padding: 'Y Z',
                round: 'radiusControl',
                theme: 'document',
                fontSize: '.92em'
            });
            else {
                const href = unescapeMd(m[6]);
                const external = /^https?:\/\//i.test(href);
                parts.push({
                    tag: 'a',
                    text: unescapeMd(m[5]),
                    href: href,
                    ...external ? {
                        target: '_blank'
                    } : {},
                    color: 'var(--color-blue)',
                    textDecoration: 'underline'
                });
            }
        }
        plain += txt.slice(last);
        flush();
        return parts.length ? parts : [
            {
                tag: 'span',
                text: txt
            }
        ];
    };
    // GFM table row split — trims one optional leading/trailing pipe, then
    // splits on interior `|`. Shared by the header/separator/body detection
    // below (AIUX-MD-RENDER, tickets/sonnet.md — this self-contained parser
    // is the ONLY renderer on the brender, per the module note above, and was
    // silently missing table/hr support even though ChatMessage.js's `& table`
    // / `& th` / `& hr` descendant CSS already assumed both renderer paths
    // produced them — see the comment there).
    const splitTableRow = (line)=>{
        let s = line.trim();
        if (s.startsWith('|')) s = s.slice(1);
        if (s.endsWith('|') && s.length) s = s.slice(0, -1);
        return s.split('|').map((c)=>c.trim());
    };
    const isTableSeparator = (line)=>{
        const cells = splitTableRow(line);
        return cells.length > 0 && cells.every((c)=>/^:?-{1,}:?$/.test(c));
    };
    try {
        const lines = text.split('\n');
        const out = [];
        let i = 0;
        while(i < lines.length){
            const ln = lines[i];
            if (/^\s*```/.test(ln)) {
                const code = [];
                i++;
                while(i < lines.length && !/^\s*```/.test(lines[i])){
                    code.push(lines[i]);
                    i++;
                }
                i++;
                out.push({
                    tag: 'pre',
                    text: code.join('\n'),
                    whiteSpace: 'pre-wrap',
                    overflow: 'auto',
                    padding: 'Z A',
                    round: 'radiusControl',
                    theme: 'document',
                    fontSize: '.9em'
                });
                continue;
            }
            // GFM table — a header row immediately followed by a `---`/`:---:`
            // separator row of the SAME cell count. Checked before the generic
            // paragraph fallthrough (and before the `---`-only hr check below, so
            // a real separator row is never itself mistaken for a standalone hr —
            // it's consumed as part of the table).
            if (ln.includes('|') && i + 1 < lines.length && isTableSeparator(lines[i + 1])) {
                const header = splitTableRow(ln);
                const sepCells = splitTableRow(lines[i + 1]);
                if (header.length && sepCells.length === header.length) {
                    i += 2;
                    const rows = [];
                    while(i < lines.length && lines[i].trim() !== '' && lines[i].includes('|')){
                        rows.push(splitTableRow(lines[i]));
                        i++;
                    }
                    out.push({
                        tag: 'table',
                        children: [
                            {
                                tag: 'thead',
                                children: [
                                    {
                                        tag: 'tr',
                                        children: header.map((c)=>({
                                                tag: 'th',
                                                children: inline(c)
                                            }))
                                    }
                                ]
                            },
                            {
                                tag: 'tbody',
                                children: rows.map((r)=>({
                                        tag: 'tr',
                                        children: r.map((c)=>({
                                                tag: 'td',
                                                children: inline(c)
                                            }))
                                    }))
                            }
                        ]
                    });
                    continue;
                }
            }
            // Horizontal rule — a line of 3+ `-`/`*`/`_` and nothing else. Table
            // separator rows are already consumed above, so this only ever matches
            // a genuine standalone `---`.
            if (/^\s*(-{3,}|\*{3,}|_{3,})\s*$/.test(ln)) {
                out.push({
                    tag: 'hr'
                });
                i++;
                continue;
            }
            const h = ln.match(/^\s*(#{1,6})\s+(.*)/);
            if (h) {
                out.push({
                    tag: 'h4',
                    margin: 'Z 0 Y',
                    children: inline(h[2])
                });
                i++;
                continue;
            }
            if (/^\s*>\s?/.test(ln)) {
                const quote = [];
                while(i < lines.length && /^\s*>\s?/.test(lines[i])){
                    quote.push(lines[i].replace(/^\s*>\s?/, ''));
                    i++;
                }
                out.push({
                    tag: 'blockquote',
                    margin: 'Y 0',
                    paddingLeft: 'A',
                    borderLeft: '2px solid var(--color-line)',
                    color: 'var(--color-caption)',
                    children: inline(quote.join(' '))
                });
                continue;
            }
            if (/^\s*[-*]\s+/.test(ln)) {
                const items = [];
                while(i < lines.length && /^\s*[-*]\s+/.test(lines[i])){
                    items.push({
                        tag: 'li',
                        margin: '0 0 Y',
                        children: inline(lines[i].replace(/^\s*[-*]\s+/, ''))
                    });
                    i++;
                }
                out.push({
                    tag: 'ul',
                    listStylePosition: 'inside',
                    padding: '0',
                    margin: '0',
                    children: items
                });
                continue;
            }
            if (ln.trim() === '') {
                i++;
                continue;
            }
            const para = [];
            while(i < lines.length && lines[i].trim() !== '' && !/^\s*(#{1,6})\s|^\s*```|^\s*[-*]\s|^\s*>\s?/.test(lines[i])){
                para.push(lines[i]);
                i++;
            }
            out.push({
                tag: 'p',
                margin: '0 0 Z',
                lineHeight: '1.55',
                children: inline(para.join(' '))
            });
        }
        return out.length ? out : [
            {
                whiteSpace: 'pre-wrap',
                text: text
            }
        ];
    } catch (_) {
        return [
            {
                whiteSpace: 'pre-wrap',
                text: text
            }
        ];
    }
};

});

parcelRegister("8aWPx", function(module, exports) {

$parcel$export(module.exports, "createIframeApp", () => (parcelRequire("gyjjS")).createIframeApp);
$parcel$export(module.exports, "injectSprites", () => (parcelRequire("gyjjS")).injectSprites);
$parcel$export(module.exports, "embedComponent", () => (parcelRequire("ev6YB")).embedComponent);
$parcel$export(module.exports, "embedDesignSystem", () => (parcelRequire("bUsGn")).embedDesignSystem);
$parcel$export(module.exports, "mountUserCode", () => (parcelRequire("lLBGE")).mountUserCode);
$parcel$export(module.exports, "prewarmUserCode", () => (parcelRequire("lLBGE")).prewarmUserCode);
$parcel$export(module.exports, "getUserCodeHandle", () => (parcelRequire("lLBGE")).getUserCodeHandle);
$parcel$export(module.exports, "findScopeKey", () => (parcelRequire("lLBGE")).findScopeKey);
$parcel$export(module.exports, "userCodeSandbox", () => (parcelRequire("lLBGE")).userCodeSandbox);

var $gyjjS = parcelRequire("gyjjS");

var $ev6YB = parcelRequire("ev6YB");

var $bUsGn = parcelRequire("bUsGn");

var $lLBGE = parcelRequire("lLBGE");

});
parcelRegister("gyjjS", function(module, exports) {

$parcel$export(module.exports, "spriteHtmlFor", () => $c0cececff51558c6$export$2ad36007af74bad5);
$parcel$export(module.exports, "normalizeDesignSystemCase", () => $c0cececff51558c6$export$a36d347ac8321741);
$parcel$export(module.exports, "injectSprites", () => $c0cececff51558c6$export$4cdd3228a542c759);
$parcel$export(module.exports, "CREATE_CONTEXT_KEYS", () => $c0cececff51558c6$export$67da915ad17714f4);
$parcel$export(module.exports, "createIframeApp", () => $c0cececff51558c6$export$7d37ad3c60bb445b);
// `deepClone` sourced from @symbo.ls/utils (a zero-dep, per-file-tree-shaken
// package), NOT the monolithic 'smbls' barrel — same fix as
// workspace/functions/workspaceProjects.js. `create` genuinely needs the
// framework's DOMQL mount pipeline (not swappable), so it's dynamic-imported
// at its one call site in createIframeApp() below — that function only runs
// when an embed/extension/preview iframe actually mounts, never on the shell
// boot path, so a static top-level `import { create } from 'smbls'` here was
// forcing the whole framework bundle into every entry that reaches this file.
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
parcelRequire("67GC6");
var $bbBIp = parcelRequire("bbBIp");

var $hVZUs = parcelRequire("hVZUs");

var $aAzQ3 = parcelRequire("aAzQ3");

var $d5UPr = parcelRequire("d5UPr");
const $c0cececff51558c6$var$NATIVE_RE = /\{\s*\[native code\]\s*\}/;
// EMBED-RERALM-SOURCE-TEXT-GATE-1: an error crossing OUT of the frame realm is
// an instance of the FRAME's `ReferenceError`, never the parent's — so the
// `e instanceof ReferenceError` this used to test was ALWAYS false and the
// fallback below never ran. `.name` is the only realm-agnostic reading.
const $c0cececff51558c6$var$isReferenceError = (e)=>!!e && (e.name === 'ReferenceError' || e instanceof ReferenceError);
function $c0cececff51558c6$export$dd44eb2b526e2bbf(root, frameWindow) {
    if (!root || typeof root !== 'object') return;
    const seen = new WeakSet();
    const stack = [
        root
    ];
    while(stack.length){
        const node = stack.pop();
        if (!node || typeof node !== 'object' || seen.has(node)) continue;
        seen.add(node);
        for(const key in node){
            if (!Object.prototype.hasOwnProperty.call(node, key)) continue;
            const v = node[key];
            if (typeof v === 'function') {
                if (v.__rerealmed) continue;
                let src;
                try {
                    src = Function.prototype.toString.call(v);
                } catch  {
                    continue;
                }
                if ($c0cececff51558c6$var$NATIVE_RE.test(src) || !(0, $d5UPr.usesRealmBoundGlobal)(src)) continue;
                let reFn;
                try {
                    reFn = frameWindow.eval('(' + src + ')');
                } catch  {
                    continue;
                }
                const wrapped = function(...args) {
                    try {
                        return reFn.apply(this, args);
                    } catch (e) {
                        if ($c0cececff51558c6$var$isReferenceError(e)) return v.apply(this, args);
                        throw e;
                    }
                };
                wrapped.__rerealmed = true;
                node[key] = wrapped;
            } else if (v && typeof v === 'object') stack.push(v);
        }
    }
}
// Bug #2050: keys that the legacy `updateDesignSystem` path wrote in
// UPPERCASE. The runtime (Icon.js, scratch CONFIG) reads lowercase.
// We mirror so the runtime finds icons that landed at the wrong key.
const $c0cececff51558c6$var$_DS_LEGACY_UPPERCASE_KEYS = [
    'icons',
    'svg',
    'color',
    'typography',
    'spacing',
    'theme',
    'fontFamily',
    'cases',
    'media',
    'semanticIcons',
    'animation',
    'gradient',
    'shape',
    'shadow',
    'fontWeight',
    'lineHeight',
    'letterSpacing',
    'transition'
];
function $c0cececff51558c6$var$_normalizeDsCaseInPlace(ds) {
    if (!ds || typeof ds !== 'object') return;
    for (const cat of $c0cececff51558c6$var$_DS_LEGACY_UPPERCASE_KEYS){
        const upper = cat.toUpperCase();
        const upperVal = ds[upper];
        if (upperVal && typeof upperVal === 'object' && !Array.isArray(upperVal)) {
            if (!ds[cat] || typeof ds[cat] !== 'object') ds[cat] = {};
            Object.assign(ds[cat], upperVal);
        }
    }
}
// Memoize sprite HTML per `designSystem` identity. A canvas page that mounts
// N artboards from the same project would otherwise re-iterate every icon
// key + re-run `convertSvgToSymbol` N times for an identical output — the
// transform is deterministic (key + body → same `<symbol>`), so caching by
// reference is safe. WeakMap keeps the entry alive only as long as the
// designSystem object itself is reachable.
const $c0cececff51558c6$var$_spriteHtmlCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
function $c0cececff51558c6$var$_buildSpriteHtml(designSystem) {
    let spriteHtml = '';
    // Bug #2050: read BOTH `icons` (canonical, lowercase) AND `ICONS`
    // (legacy — old `updateDesignSystem` uppercased the category key
    // before saving to MongoDB). Same for `svg` / `SVG`. Without this
    // tolerance, projects that uploaded icons via the broken modal
    // wouldn't see their icons in the preview iframe even after the
    // save path was fixed, because the data already in DB sits at the
    // wrong key.
    for (const lib of [
        designSystem.icons,
        designSystem.ICONS,
        designSystem.svg,
        designSystem.SVG
    ]){
        if (!lib) continue;
        for(const key in lib)spriteHtml += (0, $bbBIp.convertSvgToSymbol)(key, lib[key]);
    }
    return spriteHtml;
}
function $c0cececff51558c6$export$2ad36007af74bad5(designSystem) {
    if (!designSystem) return '';
    let spriteHtml = $c0cececff51558c6$var$_spriteHtmlCache?.get(designSystem);
    if (spriteHtml == null) {
        spriteHtml = $c0cececff51558c6$var$_buildSpriteHtml(designSystem);
        $c0cececff51558c6$var$_spriteHtmlCache?.set(designSystem, spriteHtml);
    }
    return spriteHtml;
}
function $c0cececff51558c6$export$a36d347ac8321741(ds) {
    $c0cececff51558c6$var$_normalizeDsCaseInPlace(ds);
    return ds;
}
function $c0cececff51558c6$export$4cdd3228a542c759(doc, designSystem) {
    if (!doc?.body || !designSystem) return;
    const spriteHtml = $c0cececff51558c6$export$2ad36007af74bad5(designSystem);
    if (spriteHtml) doc.body.insertAdjacentHTML('afterbegin', `<svg aria-hidden="true" width="0" height="0" style="position:absolute" id="svgSprite">${spriteHtml}</svg>`);
}
function $c0cececff51558c6$export$1ceeb94dd3747d43(d) {
    const head = d.head || d.documentElement.appendChild(d.createElement('head'));
    if (!d.body) d.documentElement.appendChild(d.createElement('body'));
    head.textContent = '';
    const im = (0, $aAzQ3.buildEmbedImportMap)().match(/^<script type="importmap">([\s\S]*)<\/script>$/);
    if (im) {
        const s = d.createElement('script');
        s.type = 'importmap';
        s.textContent = im[1];
        head.appendChild(s);
    }
    const meta = d.createElement('meta');
    meta.setAttribute('name', 'color-scheme');
    meta.setAttribute('content', 'light dark');
    head.appendChild(meta);
    const style = d.createElement('style');
    style.textContent = '*{margin:0;padding:0;box-sizing:border-box}html,body{width:100%;height:100%;overflow:auto}';
    head.appendChild(style);
    d.body.textContent = '';
}
async function $c0cececff51558c6$export$dbc8bcae50ddde2e(iframeNode) {
    // A freshly-mounted iframe (no explicit `src` OR still on about:blank)
    // already has its contentDocument ready and `readyState: 'complete'`.
    // Listening for a `load` event after that point hangs forever —
    // canvas-side tile frames hit this because DOMQL creates the <iframe>
    // synchronously before our handler attaches. Only do the reload dance
    // when the iframe is currently pointed somewhere else.
    const currentSrc = iframeNode.getAttribute('src') || '';
    const needsReload = currentSrc && currentSrc !== 'about:blank';
    if (needsReload) {
        iframeNode.src = 'about:blank';
        await new Promise((resolve)=>{
            iframeNode.addEventListener('load', resolve, {
                once: true
            });
        });
        iframeNode.__smblsEmbedImportMapInstalled = false;
    }
    let frameWindow = iframeNode.contentWindow;
    let doc = iframeNode.contentDocument || frameWindow?.document;
    if (!doc) return {
        frameWindow: frameWindow,
        doc: null
    };
    // ── Late initial-commit guard (Chrome ≥150) ────────────────────────────────
    // The iframe's INITIAL about:blank navigation commits asynchronously, and in
    // newer Chrome it can land AFTER a document.write — silently REPLACING the
    // written document with a virgin one. Downstream that produced a permanent
    // ~1Hz re-embed loop on every canvas tile (CanvasItem's load listener sees a
    // marker-less doc → remounts → open/write re-arms the same race → …):
    // live-measured 2026-08-08 on natali/shop, 234 document replacements across
    // 8 tiles in 30s, tiles visibly flickering between the boot spiral and the
    // rendered page. Strategy:
    //   • FIRST embed on a frame: document.write (fast, atomic, importmap-first)
    //     then settle one tick and, if the frame's committed document is NOT the
    //     one we wrote, rebuild into the COMMITTED doc with DOM APIs.
    //   • RE-embeds (__smblsEmbedWroteOnce): skip document.open() entirely and
    //     DOM-build straight into the live document — DOM mutation causes no
    //     navigation, so the remount cycle physically cannot sustain.
    if (iframeNode.__smblsEmbedWroteOnce) try {
        $c0cececff51558c6$export$1ceeb94dd3747d43(doc);
        iframeNode.__smblsEmbedImportMapInstalled = true;
        return {
            frameWindow: frameWindow,
            doc: doc
        };
    } catch  {
    // fall through to the write path below
    }
    doc.open();
    // The import-map MUST be the first thing in <head> — it has to precede any
    // module import for the browser to honor it. Resolves legacy `await
    // import('prismjs')` / `'fuse.js'` (bare specifiers from pre-registry-first
    // frank serialization) to embed stub modules instead of failing native ESM
    // resolution. See embedModuleStubs.buildEmbedImportMap.
    const importMap = iframeNode.__smblsEmbedImportMapInstalled ? '' : (0, $aAzQ3.buildEmbedImportMap)();
    doc.write(`<!DOCTYPE html><html><head>${importMap}<meta name="color-scheme" content="light dark"><style>*{margin:0;padding:0;box-sizing:border-box}html,body{width:100%;height:100%;overflow:auto}</style></head><body></body></html>`);
    doc.close();
    iframeNode.__smblsEmbedImportMapInstalled = true;
    iframeNode.__smblsEmbedWroteOnce = true;
    await new Promise((resolve)=>setTimeout(resolve, 30));
    const committed = iframeNode.contentDocument;
    if (committed && committed !== doc) try {
        $c0cececff51558c6$export$1ceeb94dd3747d43(committed);
        doc = committed;
        frameWindow = iframeNode.contentWindow;
    } catch  {
    // Fall through with the originally-written doc — the caller's own
    // load-listener retry remains the outer safety net.
    }
    return {
        frameWindow: frameWindow,
        doc: doc
    };
}
const $c0cececff51558c6$export$67da915ad17714f4 = [
    // Project payload buckets
    'app',
    'pages',
    'components',
    'functions',
    'methods',
    'snippets',
    'utils',
    'files',
    'assets',
    'state',
    'designSystem',
    'globalScope',
    'cases',
    'dependencies',
    'sharedLibraries',
    'symbolsConfig',
    'js',
    'svg',
    // Framework config
    'router',
    'define',
    'defaultExtends',
    'domqlOptions',
    'plugins',
    'key',
    'packageManager',
    'cdnProvider',
    'cssPrefix',
    'cssEngine',
    'scopeSelector',
    'skipDesignSystemInit',
    'verbose',
    'initOptions',
    'preventInject',
    'isDevelopment',
    'localFile',
    'endpoint',
    'serviceRoute',
    'onError',
    'events',
    'renderEvents',
    'root',
    'config',
    'newConfig',
    'editor',
    // Design-system flags
    'globalTheme',
    'themeStorageKey',
    'useReset',
    'useVariable',
    'useFontImport',
    'useIconSprite',
    'useSvgSprite',
    'useDocumentTheme',
    'useDefaultConfig',
    'useDefaultIcons',
    // Plugin opt-ins (prepareContext auto-registers off these)
    'polyglot',
    'fetch',
    'db',
    'shorthand',
    'analyze',
    'sync',
    'inspect',
    'notifications',
    'windows',
    'dropdown',
    'tooltip',
    'emotion'
];
// Own-key pick, so an absent key stays absent rather than arriving as an
// explicit `undefined` — that is what the `{ ...project }` spread did, and
// `prepareContext` distinguishes the two for several options.
const $c0cececff51558c6$var$pickCreateContext = (project)=>{
    const picked = {};
    for (const key of $c0cececff51558c6$export$67da915ad17714f4)if (Object.hasOwn(project, key)) picked[key] = project[key];
    return picked;
};

async function $c0cececff51558c6$export$7d37ad3c60bb445b(iframeNode, data, shell, { path: path = '/', contextOverrides: contextOverrides = {}, resetDocument: resetDocument = true, hostContext: hostContext = null } = {}) {
    if (!iframeNode || !data) return null;
    // Kicked off now so it resolves in parallel with resetIframeDocument +
    // the clone/re-realm/sprite-injection work below (needed only at the
    // `create(shell, …)` call near the end of this function). index.js warms
    // this exact chunk at shell entry (`void import('smbls')`), so by the
    // time any embed surface reaches here it typically resolves instantly
    // from the module cache.
    const smblsPromise = Promise.resolve((parcelRequire("eY4Ct")));
    // Two early-return guards below can bail BEFORE the real `await
    // smblsPromise` further down — mark the promise handled now (same
    // `.catch(() => {})` idiom as index.js's own entry warm-up) so a bail
    // never produces an unhandled-rejection console warning. The later
    // `await smblsPromise` still throws normally on a genuine failure.
    smblsPromise.catch(()=>{});
    let frameWindow, doc;
    if (resetDocument) ({ frameWindow: frameWindow, doc: doc } = await $c0cececff51558c6$export$dbc8bcae50ddde2e(iframeNode));
    else {
        frameWindow = iframeNode.contentWindow;
        doc = iframeNode.contentDocument || frameWindow?.document || null;
    }
    if (!frameWindow || !doc) return null;
    // CANVAS-ROUTEMODE-URL-1 (2026-08-08): stamp the tile's own path onto the
    // iframe's `history` as EARLY as possible so anything that reads it before
    // `create()` sees a sane value, but this alone is not sufficient — see the
    // second application right before `create()` below.
    const applyPath = (win)=>{
        try {
            win.history.replaceState(null, '', path);
            return true;
        } catch  {
            return false;
        }
    };
    applyPath(frameWindow);
    const hasRealFunctions = typeof data.app?.onRender === 'function';
    const project = hasRealFunctions ? data : (0, $2C0hZ.deepClone)(data, {
        window: frameWindow
    });
    // smbls's deepClone skips dunder keys (__resolved, __adapterAttached, …).
    // Without this re-attach, the pre-resolved Supabase adapter we put on
    // `data.fetch.__resolved` / `data.db.__resolved` in workspace
    // shared/functions/attachDbAdapters.js gets dropped here, and the in-
    // iframe resolveAdapter falls through to a fresh `setup()` cross-realm
    // (which silently produces an empty `{}` shape on the published bundle's
    // race path — visible as the "Loading venues…" stall before this fix).
    if (project !== data) {
        if (data.fetch?.__resolved && project.fetch) project.fetch.__resolved = data.fetch.__resolved;
        if (data.db?.__resolved && project.db) project.db.__resolved = data.db.__resolved;
    }
    $c0cececff51558c6$export$dd44eb2b526e2bbf(project, frameWindow);
    // Resolve bare npm specifiers the legacy platform pages import at runtime
    // (prismjs / fuse.js) to embed no-op stubs via the __SMBLS_PKGS__ registry,
    // so frank's `await import('prismjs')` preamble resolves registry-first
    // instead of hitting native ESM resolution → "Failed to resolve module
    // specifier" (console-spam ticket: smbls.md "Embed runtime parity"). Both
    // realms: rerealmed methods run in the iframe, plain methods in the parent.
    (0, $aAzQ3.registerEmbedModuleStubs)(frameWindow, typeof globalThis !== 'undefined' ? globalThis : null);
    // Bug #2050: mirror legacy UPPERCASE category keys (`ICONS`, `SVG`,
    // `COLOR`, …) onto their lowercase twins so the runtime Icon
    // component / scratch CONFIG find user-uploaded icons even when
    // they were saved by the pre-fix `updateDesignSystem` path. New
    // writes go to lowercase; this only matters for legacy data.
    $c0cececff51558c6$var$_normalizeDsCaseInPlace(project.designSystem);
    $c0cececff51558c6$export$4cdd3228a542c759(doc, project.designSystem);
    // CANVAS-ROUTEMODE-URL-1 (2026-08-08): the clone/rerealm/sprite work above
    // is enough real wall-clock time for the iframe's own initial about:blank
    // navigation to commit LATE (the same Chrome≥150 race resetIframeDocument
    // guards against right after document.write — see its "Late initial-commit
    // guard" comment) — measured live: `frame.contentWindow.location.pathname`
    // reading back as `"blank"` well after a `doc.__smblsEmbedApp` mount had
    // already succeeded (natali/shop, 4 route-mode tiles, 2026-08-08 puppeteer
    // repro). When that lands AFTER `applyPath` above, the wiped history
    // silently falls through to smbls's own `prepareWindow` stub-detection
    // (`context.window.URL` looking unusable on a torn-down realm) — the
    // router then resolves the PARENT canvas page's real address-bar path
    // instead of this tile's page key, warns "no content matched for path
    // <parent path>", and route-driven state (e.g. `activeSection`) never
    // initializes. Re-verify RIGHT BEFORE `create()` — the last checkpoint
    // before the router's first read — and recover exactly like
    // `resetIframeDocument` does: if the committed document changed under us,
    // rebuild into it and re-stamp the path on ITS window before proceeding.
    if (iframeNode.contentDocument && iframeNode.contentDocument !== doc) {
        const committed = iframeNode.contentDocument;
        try {
            $c0cececff51558c6$export$1ceeb94dd3747d43(committed);
            iframeNode.__smblsEmbedImportMapInstalled = true;
            doc = committed;
            frameWindow = iframeNode.contentWindow;
            applyPath(frameWindow);
            $c0cececff51558c6$export$4cdd3228a542c759(doc, project.designSystem);
        } catch  {
        // Fall through with the pre-existing doc/frameWindow — the caller's
        // own load-listener remount (CanvasItem) remains the outer safety net.
        }
    } else // No document swap — still worth a second stamp: a late commit can also
    // land WITHOUT replacing `contentDocument` identity (some Chrome builds
    // reset `history`/`location` state on the SAME document object during
    // the initial-navigation settle). Cheap to reapply, no-op if unneeded.
    applyPath(frameWindow);
    // Register the legacy-platform compat method-set as the LOWEST-priority
    // layer so embedded `system/platform` pages find `el.getDesignSystem()` /
    // `el.isCanvas()` / … instead of throwing "is not a function" (console-spam
    // ticket: smbls.md "Embed runtime parity"). A project's own method of the
    // same name still wins, and explicit contextOverrides win over both.
    const mergedMethods = {
        ...(0, $hVZUs.embedCompatMethods),
        ...project.methods || {},
        ...contextOverrides.methods || {}
    };
    // The functions twin of `mergedMethods` — see the EMBED-REALM-FN-FOLD-1 note
    // on this function for why the host layer exists and why it sits lowest.
    //
    // The host layer is the PROTOTYPE, never a spread copy. A spread snapshots
    // the shell registry at the instant this frame boots, and the shell registry
    // keeps GROWING after that: `workspaceProjects.js` accumulates its capability
    // bridges over several passes (the `mergedDependencies.size` branch mints
    // moduleImport/AssetUrl/Mount/Unmount/Api/Token/Theme only once some app has
    // declared dependencies), and the module loader folds a module's shared
    // libraries in later still. Measured live on the bellforge board: every tile
    // froze at 1976 names while the shell had reached 2162 — 186 missing,
    // including 8 `module*` bridges and the whole `crm*` library. That is the
    // SAME defect one axis along: it was fixed by NAME, then by REALM, and it
    // came back by TIME. `moduleData` survived every earlier check only because
    // it lands on the FIRST pass, before any tile boots.
    //
    // `Object.create(host)` resolves live — `el.call` reads
    // `ctx.functions[name]` (smbls element/methods.js `call`), a plain property
    // read that walks the prototype chain — so a bridge registered on the shell
    // one second from now is callable in a frame that booted a minute ago.
    // Precedence is unchanged and still lowest → highest (host → project →
    // contextOverrides), because own properties shadow the prototype.
    // It also keeps the isolation the spread was written for: everything written
    // into this object lands as an OWN property, so `prepareContext`'s
    // `rehydrate(context, 'functions')` — which `Object.assign`s onto the bucket
    // it is handed — can never write into the shell's own registry. Rehydrate
    // walks own properties only (`deepDestringifyFunctions` guards with
    // `hasOwnProperty`), so it does not flatten the prototype back into a copy.
    const hostFunctions = hostContext && hostContext.functions ? hostContext.functions : null;
    const mergedFunctions = Object.assign(hostFunctions ? Object.create(hostFunctions) : {}, {
        ...project.functions || {},
        ...contextOverrides.functions || {}
    });
    // CANVAS-TILE-ROUTER-BOOTS-FIRST-ROUTE-1 — hand the router its initial route
    // as DATA, because this realm has no URL it is allowed to write.
    // `applyPath` above is a best-effort stamp only: `history.replaceState` on an
    // `about:blank` document throws `SecurityError` in Chrome (measured live on
    // the 23-tile bellforge board, 2026-08-21 — every frame reads
    // `location.href === 'about:blank'`, `location.pathname === 'blank'`), and the
    // throw is swallowed by design. smbls's `initRouter` then resolved the initial
    // route from `context.window.location` — its only source — so `normalizePath`
    // turned `'blank'` into `'/'` and `matchRoute('/')` returned the FIRST key of
    // the route table for EVERY tile. All 23 tiles booted `/overview`; the 22
    // whose page was anything else mounted a route their frame was never asked
    // for and painted nothing.
    //
    // `context.router.initialPath` is the channel that carries what the embedder
    // already knows. It does not replace the location read — an app with a real
    // URL is untouched — it only supplies the route where no URL can exist.
    // `router: false` (the single-component branch of embedComponent) stays off:
    // a component tile is not a route and must not gain one here.
    const resolvedRouter = contextOverrides.router !== undefined ? contextOverrides.router : project.router;
    const routerOption = resolvedRouter === false ? false : {
        ...resolvedRouter && typeof resolvedRouter === 'object' ? resolvedRouter : {},
        initialPath: path
    };
    const { create: create } = await smblsPromise;
    const result = await create(shell, {
        // Narrowed to the create() option surface — see CREATE_CONTEXT_KEYS above.
        ...$c0cececff51558c6$var$pickCreateContext(project),
        ...contextOverrides,
        // After the spreads: `contextOverrides.router` is already folded into
        // `routerOption` above, so this never drops a caller's `router: false`.
        router: routerOption,
        methods: mergedMethods,
        // `create(App, options)` passes `options` through as the context itself
        // (smbls createDomql.js: `prepareContext(app, ctx)` then `app.context =
        // ctx`), so this TOP-LEVEL key is the one `el.call` reads as
        // `context.functions`. It must come after the `...contextOverrides` spread
        // — that spread would otherwise REPLACE the fold with the overrides alone.
        functions: mergedFunctions,
        // smbls attaches methods to elements via `addMethods(el)` reading
        // `el.context.methods` (packages/element/src/methods.js). A direct
        // `create()` call (this embed path bypasses the full createDomql boot)
        // does NOT lift a TOP-LEVEL `methods` option into `context.methods`, so
        // top-level `methods` alone never reaches embed elements — that's why
        // `el.getDesignSystem()` was undefined on platform tiles (smbls.md →
        // workspace.md "Embed runtime parity" sub-item b). Nest under
        // `context.methods` (the channel addMethods actually reads).
        context: {
            ...project.context || {},
            ...contextOverrides.context || {},
            methods: mergedMethods,
            functions: mergedFunctions,
            window: frameWindow,
            document: doc
        },
        themeRoot: doc.documentElement,
        document: doc,
        window: frameWindow,
        parent: doc.body
    });
    // `data-theme` is FRAMEWORK-OWNED (RULES.md Rule 50 / DESIGN_SYSTEM.md):
    // `create()` runs `resolveAndApplyTheme(options)` (smbls/src/index.js), which
    // resolves the theme through the full precedence chain — URL `?globalTheme` >
    // `localStorage[themeStorageKey]` > `options.globalTheme` (`data.globalTheme`,
    // spread into the options above), with `'auto'` resolved from
    // `prefers-color-scheme` — and stamps the concrete value onto the `themeRoot`
    // passed above. A manual `matchMedia` + `setAttribute('data-theme', …)`
    // reapply used to live here; it only re-derived a WORSE value (it saw none of
    // the URL/localStorage tiers) and raced the framework's own write — the exact
    // "theme flashes wrong color on first paint" failure the design-system
    // troubleshooting table names. Verified in a live iframe (2026-07-27, after
    // the smbls per-document design-system fix 6eb671bc8 + 5acd20774):
    // `create()` alone sets `data-theme` to `dark` for `globalTheme: 'auto'` on a
    // dark-preference OS and to `light` for `globalTheme: 'light'`, with
    // `--theme-document-background` resolving to the matching value in both.
    //
    // What `create()` does NOT do is publish the resolved root back onto the
    // config, so `changeGlobalTheme` — which writes `data-theme` to
    // `CONFIG.themeRoot` — would have no target (verified: after `create()`,
    // `result.context.designSystem.themeRoot` is unset). Point it at THIS app's
    // own root: the `[data-smbls-app="<key>"]` element when the framework scoped
    // this app as secondary (a re-mount into an already-claimed document — see
    // `isSecondary` in smbls/src/prepare.js), else the iframe's documentElement,
    // which is what a fresh-document mount scopes to (`:root`).
    const appEl = doc.querySelector('[data-smbls-app]') || doc.documentElement;
    if (result?.context?.designSystem) {
        result.context.designSystem.themeRoot = appEl;
        iframeNode.__projectConfig = result.context.designSystem;
    }
    // Ownership marker for the CURRENT document. A freshly inserted iframe can
    // fire its initial about:blank navigation AFTER a successful mount, silently
    // replacing the rendered document with a virgin one — the flags on the
    // iframe NODE (`__projectConfig`, importmap latch) survive, so everything
    // upstream believes the tile rendered while its body is empty. Consumers'
    // `load` listeners (canvas CanvasItem) use this marker to tell "our own
    // document.close() load" (marker present → ignore) from "the document was
    // replaced" (marker gone → remount). Lives on the document, not the node,
    // precisely BECAUSE a replacement wipes it.
    try {
        doc.__smblsEmbedApp = true;
    } catch  {}
    return result;
}

});
parcelRegister("67GC6", function(module, exports) {
$parcel$export(module.exports, "BARE_SEQUENCE_TOKEN_RE", () => (parcelRequire("d52u8")).BARE_SEQUENCE_TOKEN_RE);
$parcel$export(module.exports, "compositeOverBackdrop", () => (parcelRequire("hzNzB")).compositeOverBackdrop);
$parcel$export(module.exports, "contrastRatio", () => (parcelRequire("hzNzB")).contrastRatio);
$parcel$export(module.exports, "convertSvgToSymbol", () => (parcelRequire("bbBIp")).convertSvgToSymbol);
$parcel$export(module.exports, "CSS_NAMED_COLOR_HEX", () => (parcelRequire("hzNzB")).CSS_NAMED_COLOR_HEX);
$parcel$export(module.exports, "getActiveConfig", () => (parcelRequire("521xJ")).getActiveConfig);
$parcel$export(module.exports, "getFontFamily", () => (parcelRequire("amQH3")).getFontFamily);
$parcel$export(module.exports, "getFontSizeByKey", () => (parcelRequire("13hKf")).getFontSizeByKey);
$parcel$export(module.exports, "getMediaColor", () => (parcelRequire("5koEk")).getMediaColor);
$parcel$export(module.exports, "getMediaTheme", () => (parcelRequire("habKp")).getMediaTheme);
$parcel$export(module.exports, "getSafeInkInfo", () => (parcelRequire("9z5MX")).getSafeInkInfo);
$parcel$export(module.exports, "getSizeValue", () => (parcelRequire("d52u8")).getSizeValue);
$parcel$export(module.exports, "getSpacingBasedOnRatio", () => (parcelRequire("amsMb")).getSpacingBasedOnRatio);
$parcel$export(module.exports, "getSpacingByKey", () => (parcelRequire("amsMb")).getSpacingByKey);
$parcel$export(module.exports, "getTimingByKey", () => (parcelRequire("ZN2Fd")).getTimingByKey);
$parcel$export(module.exports, "getTimingFunction", () => (parcelRequire("ZN2Fd")).getTimingFunction);
$parcel$export(module.exports, "inForcedColors", () => (parcelRequire("5koEk")).inForcedColors);
$parcel$export(module.exports, "isForcedColorsQuery", () => (parcelRequire("5koEk")).isForcedColorsQuery);
$parcel$export(module.exports, "isNativeColorToken", () => (parcelRequire("hzNzB")).isNativeColorToken);
$parcel$export(module.exports, "popConfig", () => (parcelRequire("521xJ")).popConfig);
$parcel$export(module.exports, "pushConfig", () => (parcelRequire("521xJ")).pushConfig);
$parcel$export(module.exports, "resolveColorRgb", () => (parcelRequire("5koEk")).resolveColorRgb);
$parcel$export(module.exports, "resolveColorsInGradient", () => (parcelRequire("5koEk")).resolveColorsInGradient);
$parcel$export(module.exports, "splitTopLevelCommas", () => (parcelRequire("hzNzB")).splitTopLevelCommas);
$parcel$export(module.exports, "splitTopLevelSpaces", () => (parcelRequire("hzNzB")).splitTopLevelSpaces);
$parcel$export(module.exports, "splitTransition", () => (parcelRequire("2iwMe")).splitTransition);
$parcel$export(module.exports, "TILING_POSITION_KEYWORDS", () => (parcelRequire("2iwMe")).TILING_POSITION_KEYWORDS);
$parcel$export(module.exports, "TILING_SIZE_KEYWORDS", () => (parcelRequire("2iwMe")).TILING_SIZE_KEYWORDS);
$parcel$export(module.exports, "transformBackgroundImage", () => (parcelRequire("2iwMe")).transformBackgroundImage);
$parcel$export(module.exports, "transformBorder", () => (parcelRequire("2iwMe")).transformBorder);
$parcel$export(module.exports, "transformBorderRadius", () => (parcelRequire("2iwMe")).transformBorderRadius);
$parcel$export(module.exports, "transformBoxShadow", () => (parcelRequire("2iwMe")).transformBoxShadow);
$parcel$export(module.exports, "transformDuration", () => (parcelRequire("2iwMe")).transformDuration);
$parcel$export(module.exports, "transformGridTemplate", () => (parcelRequire("2iwMe")).transformGridTemplate);
$parcel$export(module.exports, "transformShadow", () => (parcelRequire("2iwMe")).transformShadow);
$parcel$export(module.exports, "transformSize", () => (parcelRequire("2iwMe")).transformSize);
$parcel$export(module.exports, "transformSizeRatio", () => (parcelRequire("2iwMe")).transformSizeRatio);
$parcel$export(module.exports, "transformTextStroke", () => (parcelRequire("2iwMe")).transformTextStroke);
$parcel$export(module.exports, "transformTilingValue", () => (parcelRequire("2iwMe")).transformTilingValue);
$parcel$export(module.exports, "transfromGap", () => (parcelRequire("2iwMe")).transfromGap);
parcelRequire("7z95D");

});
parcelRegister("7z95D", function(module, exports) {
$parcel$export(module.exports, "BARE_SEQUENCE_TOKEN_RE", () => (parcelRequire("d52u8")).BARE_SEQUENCE_TOKEN_RE);
$parcel$export(module.exports, "compositeOverBackdrop", () => (parcelRequire("hzNzB")).compositeOverBackdrop);
$parcel$export(module.exports, "contrastRatio", () => (parcelRequire("hzNzB")).contrastRatio);
$parcel$export(module.exports, "convertSvgToSymbol", () => (parcelRequire("bbBIp")).convertSvgToSymbol);
$parcel$export(module.exports, "CSS_NAMED_COLOR_HEX", () => (parcelRequire("hzNzB")).CSS_NAMED_COLOR_HEX);
$parcel$export(module.exports, "getSizeValue", () => (parcelRequire("d52u8")).getSizeValue);
$parcel$export(module.exports, "isNativeColorToken", () => (parcelRequire("hzNzB")).isNativeColorToken);
$parcel$export(module.exports, "splitTopLevelCommas", () => (parcelRequire("hzNzB")).splitTopLevelCommas);
$parcel$export(module.exports, "splitTopLevelSpaces", () => (parcelRequire("hzNzB")).splitTopLevelSpaces);
$parcel$export(module.exports, "getFontFamily", () => (parcelRequire("amQH3")).getFontFamily);
$parcel$export(module.exports, "getFontSizeByKey", () => (parcelRequire("13hKf")).getFontSizeByKey);
$parcel$export(module.exports, "getMediaColor", () => (parcelRequire("5koEk")).getMediaColor);
$parcel$export(module.exports, "getMediaTheme", () => (parcelRequire("habKp")).getMediaTheme);
$parcel$export(module.exports, "getSafeInkInfo", () => (parcelRequire("9z5MX")).getSafeInkInfo);
$parcel$export(module.exports, "getSpacingBasedOnRatio", () => (parcelRequire("amsMb")).getSpacingBasedOnRatio);
$parcel$export(module.exports, "getSpacingByKey", () => (parcelRequire("amsMb")).getSpacingByKey);
$parcel$export(module.exports, "getTimingByKey", () => (parcelRequire("ZN2Fd")).getTimingByKey);
$parcel$export(module.exports, "getTimingFunction", () => (parcelRequire("ZN2Fd")).getTimingFunction);
$parcel$export(module.exports, "inForcedColors", () => (parcelRequire("5koEk")).inForcedColors);
$parcel$export(module.exports, "isForcedColorsQuery", () => (parcelRequire("5koEk")).isForcedColorsQuery);
$parcel$export(module.exports, "resolveColorRgb", () => (parcelRequire("5koEk")).resolveColorRgb);
$parcel$export(module.exports, "resolveColorsInGradient", () => (parcelRequire("5koEk")).resolveColorsInGradient);
$parcel$export(module.exports, "getActiveConfig", () => (parcelRequire("521xJ")).getActiveConfig);
$parcel$export(module.exports, "popConfig", () => (parcelRequire("521xJ")).popConfig);
$parcel$export(module.exports, "pushConfig", () => (parcelRequire("521xJ")).pushConfig);
$parcel$export(module.exports, "splitTransition", () => (parcelRequire("2iwMe")).splitTransition);
$parcel$export(module.exports, "TILING_POSITION_KEYWORDS", () => (parcelRequire("2iwMe")).TILING_POSITION_KEYWORDS);
$parcel$export(module.exports, "TILING_SIZE_KEYWORDS", () => (parcelRequire("2iwMe")).TILING_SIZE_KEYWORDS);
$parcel$export(module.exports, "transformBackgroundImage", () => (parcelRequire("2iwMe")).transformBackgroundImage);
$parcel$export(module.exports, "transformBorder", () => (parcelRequire("2iwMe")).transformBorder);
$parcel$export(module.exports, "transformBorderRadius", () => (parcelRequire("2iwMe")).transformBorderRadius);
$parcel$export(module.exports, "transformBoxShadow", () => (parcelRequire("2iwMe")).transformBoxShadow);
$parcel$export(module.exports, "transformDuration", () => (parcelRequire("2iwMe")).transformDuration);
$parcel$export(module.exports, "transformGridTemplate", () => (parcelRequire("2iwMe")).transformGridTemplate);
$parcel$export(module.exports, "transformShadow", () => (parcelRequire("2iwMe")).transformShadow);
$parcel$export(module.exports, "transformSize", () => (parcelRequire("2iwMe")).transformSize);
$parcel$export(module.exports, "transformSizeRatio", () => (parcelRequire("2iwMe")).transformSizeRatio);
$parcel$export(module.exports, "transformTextStroke", () => (parcelRequire("2iwMe")).transformTextStroke);
$parcel$export(module.exports, "transformTilingValue", () => (parcelRequire("2iwMe")).transformTilingValue);
$parcel$export(module.exports, "transfromGap", () => (parcelRequire("2iwMe")).transfromGap);
parcelRequire("aV26F");
parcelRequire("jPKwi");

var $i2LhC = parcelRequire("i2LhC");
parcelRequire("521xJ");
parcelRequire("2iwMe");
parcelRequire("7o2OS");
parcelRequire("65xUz");
$parcel$exportWildcard(module.exports, $i2LhC);

});
parcelRegister("aV26F", function(module, exports) {
$parcel$export(module.exports, "CSS_UNITS", () => (parcelRequire("kjAAS")).CSS_UNITS);
$parcel$export(module.exports, "colorStringToRgbaArray", () => (parcelRequire("hzNzB")).colorStringToRgbaArray);
$parcel$export(module.exports, "compositeOverBackdrop", () => (parcelRequire("hzNzB")).compositeOverBackdrop);
$parcel$export(module.exports, "compoundLayers", () => (parcelRequire("hzNzB")).compoundLayers);
$parcel$export(module.exports, "contrastRatio", () => (parcelRequire("hzNzB")).contrastRatio);
$parcel$export(module.exports, "CSS_NAMED_COLOR_HEX", () => (parcelRequire("hzNzB")).CSS_NAMED_COLOR_HEX);
$parcel$export(module.exports, "CSS_NATIVE_COLOR_REGEX", () => (parcelRequire("hzNzB")).CSS_NATIVE_COLOR_REGEX);
$parcel$export(module.exports, "getRgbTone", () => (parcelRequire("hzNzB")).getRgbTone);
$parcel$export(module.exports, "isCSSVar", () => (parcelRequire("hzNzB")).isCSSVar);
$parcel$export(module.exports, "isNativeColorToken", () => (parcelRequire("hzNzB")).isNativeColorToken);
$parcel$export(module.exports, "isResolvedColor", () => (parcelRequire("hzNzB")).isResolvedColor);
$parcel$export(module.exports, "joinCompoundLayers", () => (parcelRequire("hzNzB")).joinCompoundLayers);
$parcel$export(module.exports, "oklabToOklch", () => (parcelRequire("hzNzB")).oklabToOklch);
$parcel$export(module.exports, "oklchToGamutSafeSrgb", () => (parcelRequire("hzNzB")).oklchToGamutSafeSrgb);
$parcel$export(module.exports, "parseColorToken", () => (parcelRequire("hzNzB")).parseColorToken);
$parcel$export(module.exports, "relativeLuminance", () => (parcelRequire("hzNzB")).relativeLuminance);
$parcel$export(module.exports, "resolveCompoundWords", () => (parcelRequire("hzNzB")).resolveCompoundWords);
$parcel$export(module.exports, "splitTopLevelCommas", () => (parcelRequire("hzNzB")).splitTopLevelCommas);
$parcel$export(module.exports, "splitTopLevelSpaces", () => (parcelRequire("hzNzB")).splitTopLevelSpaces);
$parcel$export(module.exports, "srgbToOklab", () => (parcelRequire("hzNzB")).srgbToOklab);
$parcel$export(module.exports, "getDefaultOrFirstKey", () => (parcelRequire("jGZk7")).getDefaultOrFirstKey);
$parcel$export(module.exports, "getFontFaceEach", () => (parcelRequire("jGZk7")).getFontFaceEach);
$parcel$export(module.exports, "isGoogleFontsUrl", () => (parcelRequire("jGZk7")).isGoogleFontsUrl);
$parcel$export(module.exports, "resolveFileUrl", () => (parcelRequire("jGZk7")).resolveFileUrl);
$parcel$export(module.exports, "setCustomFontMedia", () => (parcelRequire("jGZk7")).setCustomFontMedia);
$parcel$export(module.exports, "setFontImport", () => (parcelRequire("jGZk7")).setFontImport);
$parcel$export(module.exports, "BARE_SEQUENCE_TOKEN_RE", () => (parcelRequire("d52u8")).BARE_SEQUENCE_TOKEN_RE);
$parcel$export(module.exports, "findHeadings", () => (parcelRequire("d52u8")).findHeadings);
$parcel$export(module.exports, "generateSequence", () => (parcelRequire("d52u8")).generateSequence);
$parcel$export(module.exports, "getFnPrefixAndValue", () => (parcelRequire("d52u8")).getFnPrefixAndValue);
$parcel$export(module.exports, "getSequenceValue", () => (parcelRequire("d52u8")).getSequenceValue);
$parcel$export(module.exports, "getSequenceValuePropertyPair", () => (parcelRequire("d52u8")).getSequenceValuePropertyPair);
$parcel$export(module.exports, "getSizeValue", () => (parcelRequire("d52u8")).getSizeValue);
$parcel$export(module.exports, "quietSequenceProbe", () => (parcelRequire("d52u8")).quietSequenceProbe);
$parcel$export(module.exports, "applyMediaSequenceVars", () => (parcelRequire("2CJN9")).applyMediaSequenceVars);
$parcel$export(module.exports, "applySequenceVars", () => (parcelRequire("2CJN9")).applySequenceVars);
$parcel$export(module.exports, "convertSvgToSymbol", () => (parcelRequire("bbBIp")).convertSvgToSymbol);
$parcel$export(module.exports, "generateSprite", () => (parcelRequire("bbBIp")).generateSprite);
parcelRequire("dCzXU");
parcelRequire("kjAAS");
parcelRequire("hzNzB");
parcelRequire("lJU31");
parcelRequire("jGZk7");
parcelRequire("d52u8");
parcelRequire("2CJN9");
parcelRequire("bbBIp");

});
parcelRegister("dCzXU", function(module, exports) {

$parcel$export(module.exports, "isDomDocument", () => $9eaab8edf4e381d4$export$b55b6fa75aaf001e);
$parcel$export(module.exports, "isHostObject", () => $9eaab8edf4e381d4$export$cb9e9d4ab92f6164);
$parcel$export(module.exports, "parkHostObject", () => $9eaab8edf4e381d4$export$76654258d6ce9ae9);
$parcel$export(module.exports, "resolveConfigDocument", () => $9eaab8edf4e381d4$export$f568e6f31de38af4);
const $9eaab8edf4e381d4$export$b55b6fa75aaf001e = (e)=>!!(e && e.documentElement && typeof e.createElement == "function" && e.head !== void 0), $9eaab8edf4e381d4$export$cb9e9d4ab92f6164 = (e)=>{
    if (e === null || typeof e != "object") return !1;
    const t = Object.prototype.toString.call(e);
    return !!(t !== "[object Object]" && t !== "[object Array]" || typeof e.nodeType == "number" || e.defaultView || e.window === e || e.self === e);
}, $9eaab8edf4e381d4$export$18a1663fdc1f1d58 = (e)=>e !== null && typeof e == "object" && !$9eaab8edf4e381d4$export$cb9e9d4ab92f6164(e), $9eaab8edf4e381d4$export$76654258d6ce9ae9 = (e, t, o)=>{
    if (!e) return;
    if ($9eaab8edf4e381d4$export$b55b6fa75aaf001e(o)) {
        e.__domDocument || (e.__domDocument = o);
        return;
    }
    const r = `__host_${t}`;
    e[r] || (e[r] = o);
}, $9eaab8edf4e381d4$export$f568e6f31de38af4 = (e)=>e ? $9eaab8edf4e381d4$export$b55b6fa75aaf001e(e.__domDocument) ? e.__domDocument : $9eaab8edf4e381d4$export$b55b6fa75aaf001e(e.document) ? e.document : null : null;

});

parcelRegister("kjAAS", function(module, exports) {

$parcel$export(module.exports, "isScalingUnit", () => $eca1f7c8873c1443$export$6a836bb704f10b75);
$parcel$export(module.exports, "CSS_UNITS", () => $eca1f7c8873c1443$export$7263016d8c64b932);
$parcel$export(module.exports, "isRawUnitValue", () => $eca1f7c8873c1443$export$1f3a78e69def3ab7);
const $eca1f7c8873c1443$export$6a836bb704f10b75 = (c)=>c === "em" || c === "rem" || c === "vw" || c === "vh" || c === "vmax" || c === "vmin", $eca1f7c8873c1443$export$7263016d8c64b932 = [
    "px",
    "cm",
    "mm",
    "in",
    "pt",
    "pc",
    "em",
    "rem",
    "ex",
    "cap",
    "ch",
    "ic",
    "lh",
    "rlh",
    "%",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax",
    "deg",
    "rad",
    "grad",
    "turn",
    "s",
    "ms",
    "dpi",
    "dpcm",
    "dppx",
    "fr",
    "auto"
], $eca1f7c8873c1443$var$m = (c)=>c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), $eca1f7c8873c1443$var$r = new RegExp(`^-?(?:\\d+\\.?\\d*|\\.\\d+)(?:${$eca1f7c8873c1443$export$7263016d8c64b932.filter((c)=>c !== "auto").map($eca1f7c8873c1443$var$m).join("|")})$`), $eca1f7c8873c1443$export$1f3a78e69def3ab7 = (c)=>$eca1f7c8873c1443$var$r.test(String(c).trim());

});

parcelRegister("hzNzB", function(module, exports) {

$parcel$export(module.exports, "CSS_NAMED_COLOR_HEX", () => $ccbc28c5febbced6$export$1d9419cce2733097);
$parcel$export(module.exports, "colorStringToRgbaArray", () => $ccbc28c5febbced6$export$fa32e9c99a43479e);
$parcel$export(module.exports, "isCSSVar", () => $ccbc28c5febbced6$export$c9f584638d388483);
$parcel$export(module.exports, "COMPOUND_CSS_KEYWORDS", () => $ccbc28c5febbced6$export$32ed7bf6da24a242);
$parcel$export(module.exports, "CSS_NATIVE_COLOR_REGEX", () => $ccbc28c5febbced6$export$cc26ca941513e971);
$parcel$export(module.exports, "isNativeColorToken", () => $ccbc28c5febbced6$export$faa69969d00fbbe7);
$parcel$export(module.exports, "splitTopLevelSpaces", () => $ccbc28c5febbced6$export$fdd82b4f8f8c05e7);
$parcel$export(module.exports, "compoundLayers", () => $ccbc28c5febbced6$export$4c92217ea6d735bd);
$parcel$export(module.exports, "splitTopLevelCommas", () => $ccbc28c5febbced6$export$ef7a598b406793c);
$parcel$export(module.exports, "joinCompoundLayers", () => $ccbc28c5febbced6$export$71e1a1adb007c5f);
$parcel$export(module.exports, "resolveCompoundWords", () => $ccbc28c5febbced6$export$fb8c3e2de09d2d1e);
$parcel$export(module.exports, "parseColorToken", () => $ccbc28c5febbced6$export$4ea2ee5b33c12815);
$parcel$export(module.exports, "isResolvedColor", () => $ccbc28c5febbced6$export$962b4432982d3252);
$parcel$export(module.exports, "relativeLuminance", () => $ccbc28c5febbced6$export$d1b97a5b9a804090);
$parcel$export(module.exports, "contrastRatio", () => $ccbc28c5febbced6$export$e73df0c08bfd3ec3);
$parcel$export(module.exports, "srgbToOklab", () => $ccbc28c5febbced6$export$984e352e44971146);
$parcel$export(module.exports, "oklabToOklch", () => $ccbc28c5febbced6$export$a24be2de586f5b08);
$parcel$export(module.exports, "oklchToGamutSafeSrgb", () => $ccbc28c5febbced6$export$d41e66f6c4225707);
$parcel$export(module.exports, "compositeOverBackdrop", () => $ccbc28c5febbced6$export$73f20cdc774a086b);
$parcel$export(module.exports, "getRgbTone", () => $ccbc28c5febbced6$export$2d78fefdcfb7f222);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");
var $dSdIt = parcelRequire("dSdIt");
var $czfS0 = parcelRequire("czfS0");
const $ccbc28c5febbced6$export$1d9419cce2733097 = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
}, $ccbc28c5febbced6$export$fa32e9c99a43479e = (e)=>{
    if (e === "") return [
        0,
        0,
        0,
        0
    ];
    if (e.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    const r = $ccbc28c5febbced6$export$1d9419cce2733097[e.toLowerCase()];
    if (r && (e = r), e[0] === "#") return e.length < 7 && (e = "#" + e[1] + e[1] + e[2] + e[2] + e[3] + e[3] + (e.length > 4 ? e[4] + e[4] : "")), [
        parseInt(e.substr(1, 2), 16),
        parseInt(e.substr(3, 2), 16),
        parseInt(e.substr(5, 2), 16),
        e.length > 7 ? parseInt(e.substr(7, 2), 16) / 255 : 1
    ];
    if (e.indexOf("rgb") === -1 && (0, $fXgyh.document) && (0, $fXgyh.window)) {
        const t = (0, $fXgyh.document).body.appendChild((0, $fXgyh.document).createElement("fictum")), o = "rgb(1, 2, 3)";
        if (t.style.color = o, t.style.color !== o) {
            (0, $fXgyh.document).body.removeChild(t);
            return;
        }
        if (t.style.color = e, t.style.color === o || t.style.color === "") return (0, $fXgyh.document).body.removeChild(t), [
            0,
            0,
            0,
            0
        ];
        e = (0, $fXgyh.window).getComputedStyle(t).color, (0, $fXgyh.document).body.removeChild(t);
    }
    return e.indexOf("rgb") === 0 ? (e.indexOf("rgba") === -1 && (e = `${e}, 1`), e.match(/[\.\d]+/g).map((t)=>+t)) : [
        0,
        0,
        0,
        0
    ];
}, $ccbc28c5febbced6$export$fc81362b978df912 = (e, r, t = .5)=>(e = $ccbc28c5febbced6$export$fa32e9c99a43479e(e), r = $ccbc28c5febbced6$export$fa32e9c99a43479e(r), $ccbc28c5febbced6$export$7aaa71d8fa03e6fa(e, r, t)), $ccbc28c5febbced6$export$5a544e13ad4e1fa5 = (e, r = 1)=>{
    const [t, o, n] = e.match(/\w\w/g).map((a)=>parseInt(a, 16));
    return `rgb(${t},${o},${n})`;
}, $ccbc28c5febbced6$export$fc66327a54d8eee6 = (e, r = 1)=>{
    const [t, o, n] = e.match(/\w\w/g).map((a)=>parseInt(a, 16));
    return [
        t,
        o,
        n
    ];
}, $ccbc28c5febbced6$export$34d09c4a771c46ef = (e, r, t)=>"#" + (16777216 | e << 16 | r << 8 | t).toString(16).slice(1), $ccbc28c5febbced6$export$becee3e8de1b8d23 = ([e, r, t])=>(16777216 + (e << 16) + (r << 8) + t).toString(16).slice(1), $ccbc28c5febbced6$export$9665a07d9187b414 = (e, r = 1)=>{
    const [t, o, n] = e.match(/\w\w/g).map((a)=>parseInt(a, 16));
    return `rgba(${t},${o},${n},${r})`;
}, $ccbc28c5febbced6$export$7d1bd62512294b2f = (e, r, t = .5)=>{
    const o = [];
    for(let n = 0; n < 3; n++)o[n] = ~~(e[n] + (r[n] - e[n]) * t);
    return `rgb(${o})`;
}, $ccbc28c5febbced6$export$784aaa753604ca97 = (e, r)=>{
    const [t, o, n] = r, a = Math.max(0, Math.min(100, n + parseFloat(e)));
    return [
        t,
        o,
        a
    ];
}, $ccbc28c5febbced6$export$ac60e367bcb68b = (e, r, t)=>{
    const o = Math.max(e, r, t), n = o - Math.min(e, r, t), a = 1 - Math.abs(o + o - n - 1), s = n && (o == e ? (r - t) / n : o == r ? 2 + (t - e) / n : 4 + (e - r) / n);
    return [
        60 * (s < 0 ? s + 6 : s),
        a ? n / a : 0,
        (o + o - n) / 2
    ];
}, $ccbc28c5febbced6$export$29fb7152bd3f781a = (e, r, t, o = r * Math.min(t, 1 - t), n = (a, s = (a + e / 30) % 12)=>t - o * Math.max(Math.min(s - 3, 9 - s, 1), -1))=>[
        n(0),
        n(8),
        n(4)
    ], $ccbc28c5febbced6$export$e1d0a0f5f1f4ce36 = (e, r)=>{
    const t = parseInt(e, 16);
    let o = (t >> 16) + r;
    o > 255 ? o = 255 : o < 0 && (o = 0);
    let n = (t >> 8 & 255) + r;
    n > 255 ? n = 255 : n < 0 && (n = 0);
    let a = (t & 255) + r;
    return a > 255 ? a = 255 : a < 0 && (a = 0), ((a | n << 8 | o << 16) + 16777216).toString(16).slice(1);
}, $ccbc28c5febbced6$export$7aaa71d8fa03e6fa = (e, r, t = .5)=>{
    const o = [];
    for(let n = 0; n < 4; n++){
        const a = n === 3 ? (s)=>s : Math.round;
        o[n] = a(e[n] + (r[n] - e[n]) * t);
    }
    return `rgba(${o})`;
}, $ccbc28c5febbced6$export$f4f50e3877dd0530 = (e, r)=>{
    const t = $ccbc28c5febbced6$export$fa32e9c99a43479e(e);
    if (!t) {
        (0, $dSdIt.isNotProduction)();
        return;
    }
    return t[3] = r, `rgba(${t})`;
}, $ccbc28c5febbced6$export$c9f584638d388483 = (e)=>e.charCodeAt(0) === 45 && e.charCodeAt(1) === 45, $ccbc28c5febbced6$export$32ed7bf6da24a242 = new Set([
    "currentcolor",
    "transparent",
    "thin",
    "medium",
    "thick"
]), $ccbc28c5febbced6$export$cc26ca941513e971 = /(?:rgba?\(|hsla?\(|#[0-9a-fA-F]{3,8}\b)/, $ccbc28c5febbced6$var$$ = /^(?:#[0-9a-f]{3,8}|(?:rgba?|hsla?|hwb|lab|lch|oklab|oklch|color|color-mix|light-dark)\([\s\S]*\))$/i, $ccbc28c5febbced6$export$faa69969d00fbbe7 = (e)=>$ccbc28c5febbced6$var$$.test(e), $ccbc28c5febbced6$export$10ae5a5d215f5faf = (e)=>e.indexOf("(") === -1 ? e.split(/\s+/) : $ccbc28c5febbced6$export$fdd82b4f8f8c05e7(e), $ccbc28c5febbced6$export$61c6ab591e7a0a60 = (e, r)=>{
    const t = e.length;
    let o = 0, n = 0;
    for(let a = 0; a <= t; a++){
        const s = a < t ? e.charCodeAt(a) : 32;
        if (s === 40) {
            o++;
            continue;
        }
        if (s === 41) {
            o > 0 && o--;
            continue;
        }
        if (!(o > 0 || !(s <= 32 || s === 44 || s > 127 && /\s/.test(e[a])))) {
            if (a > n && !$ccbc28c5febbced6$var$q(e, n, a, r)) return !1;
            n = a + 1;
        }
    }
    return !0;
}, $ccbc28c5febbced6$var$q = (e, r, t, o)=>{
    const n = e.charCodeAt(r);
    if (n >= 48 && n <= 57) return !0;
    const a = e.slice(r, t);
    return $ccbc28c5febbced6$export$faa69969d00fbbe7(a) || o !== void 0 && o.has(a);
}, $ccbc28c5febbced6$export$4c92217ea6d735bd = (e, r)=>r ? $ccbc28c5febbced6$export$ef7a598b406793c(e).map((t)=>$ccbc28c5febbced6$export$10ae5a5d215f5faf(t.trim())) : [
        $ccbc28c5febbced6$export$10ae5a5d215f5faf(e)
    ], $ccbc28c5febbced6$export$71e1a1adb007c5f = (e)=>{
    let r = e[0].join(" ");
    for(let t = 1; t < e.length; t++)r += ", " + e[t].join(" ");
    return r;
}, $ccbc28c5febbced6$export$fb8c3e2de09d2d1e = (e, r, { commas: t, keywords: o }, n, a)=>{
    const s = $ccbc28c5febbced6$export$cc26ca941513e971.test(e);
    if (s && $ccbc28c5febbced6$export$61c6ab591e7a0a60(e, o)) return e;
    const f = $ccbc28c5febbced6$export$4c92217ea6d735bd(e, t);
    let i = !1;
    try {
        for (const c of f)for(let l = 0; l < c.length; l++){
            const d = c[l], g = $ccbc28c5febbced6$var$j(d, r, o, n, a);
            g !== d && (c[l] = g, i = !0);
        }
    } catch (c) {
        if (s) return e;
        throw c;
    }
    return s && !i ? e : $ccbc28c5febbced6$export$71e1a1adb007c5f(f);
}, $ccbc28c5febbced6$var$j = (e, r, t, o, n)=>e ? $ccbc28c5febbced6$export$c9f584638d388483(e) ? `var(${e})` : $ccbc28c5febbced6$export$faa69969d00fbbe7(e) || t !== void 0 && t.has(e) ? e : r(e, o, n) : "", $ccbc28c5febbced6$var$D = /^([a-zA-Z]\w*(?:-[a-zA-Z]\w*)*)(?:\.(\d+))?(?:([+-]\d+|=\d+))?$/, $ccbc28c5febbced6$export$4ea2ee5b33c12815 = (e)=>{
    if (!(0, $czfS0.isString)(e)) return null;
    if ($ccbc28c5febbced6$export$cc26ca941513e971.test(e)) return {
        passthrough: e
    };
    if ($ccbc28c5febbced6$export$c9f584638d388483(e)) return {
        cssVar: e
    };
    const r = e.match($ccbc28c5febbced6$var$D);
    if (!r) return null;
    const [, t, o, n] = r, a = o !== void 0 ? `0.${o}` : void 0, s = n && n[0] === "=" ? n.slice(1) : n;
    return {
        name: t,
        alpha: a,
        tone: s
    };
}, $ccbc28c5febbced6$export$962b4432982d3252 = (e)=>(0, $czfS0.isString)(e) && (e.includes("rgb") || e.includes("var(") || e.includes("#")), $ccbc28c5febbced6$export$ef7a598b406793c = (e)=>{
    const r = [];
    let t = "", o = 0;
    for (const n of e){
        if (n === "(" ? o += 1 : n === ")" && o > 0 && (o -= 1), n === "," && o === 0) {
            r.push(t), t = "";
            continue;
        }
        t += n;
    }
    return (t.length || !r.length) && r.push(t), r;
}, $ccbc28c5febbced6$export$fdd82b4f8f8c05e7 = (e)=>{
    const r = [];
    let t = "", o = 0;
    for (const n of e){
        if (n === "(" ? o += 1 : n === ")" && o > 0 && (o -= 1), o === 0 && /\s/.test(n)) {
            t.length && r.push(t), t = "";
            continue;
        }
        t += n;
    }
    return t.length && r.push(t), r;
}, $ccbc28c5febbced6$export$3123c9d885ccffbe = (e)=>(e /= 255, e <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)), $ccbc28c5febbced6$export$d1b97a5b9a804090 = (e)=>.2126 * $ccbc28c5febbced6$export$3123c9d885ccffbe(e[0]) + .7152 * $ccbc28c5febbced6$export$3123c9d885ccffbe(e[1]) + .0722 * $ccbc28c5febbced6$export$3123c9d885ccffbe(e[2]), $ccbc28c5febbced6$export$e73df0c08bfd3ec3 = (e, r)=>{
    const t = $ccbc28c5febbced6$export$d1b97a5b9a804090(e) + .05, o = $ccbc28c5febbced6$export$d1b97a5b9a804090(r) + .05;
    return t > o ? t / o : o / t;
}, $ccbc28c5febbced6$export$8e44ee20f86c751b = (e)=>(e /= 255, e <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4)), $ccbc28c5febbced6$export$d30afa00cb499ab2 = (e)=>(e <= .0031308 ? e * 12.92 : 1.055 * Math.pow(e, 1 / 2.4) - .055) * 255, $ccbc28c5febbced6$export$984e352e44971146 = ([e, r, t])=>{
    const [o, n, a] = [
        e,
        r,
        t
    ].map($ccbc28c5febbced6$export$8e44ee20f86c751b), s = .4122214708 * o + .5363325363 * n + .0514459929 * a, f = .2119034982 * o + .6806995451 * n + .1073969566 * a, i = .0883024619 * o + .2817188376 * n + .6299787005 * a, c = Math.cbrt(s), l = Math.cbrt(f), d = Math.cbrt(i);
    return [
        .2104542553 * c + .793617785 * l - .0040720468 * d,
        1.9779984951 * c - 2.428592205 * l + .4505937099 * d,
        .0259040371 * c + .7827717662 * l - .808675766 * d
    ];
}, $ccbc28c5febbced6$export$9662bbd51984ea0c = ([e, r, t])=>{
    const o = e + .3963377774 * r + .2158037573 * t, n = e - .1055613458 * r - .0638541728 * t, a = e - .0894841775 * r - 1.291485548 * t, s = o ** 3, f = n ** 3, i = a ** 3;
    return [
        4.0767416621 * s - 3.3077115913 * f + .2309699292 * i,
        -1.2684380046 * s + 2.6097574011 * f - .3413193965 * i,
        -0.0041960863 * s - .7034186147 * f + 1.707614701 * i
    ];
}, $ccbc28c5febbced6$export$a24be2de586f5b08 = ([e, r, t])=>{
    let o = Math.atan2(t, r) * 180 / Math.PI;
    return o < 0 && (o += 360), [
        e,
        Math.sqrt(r * r + t * t),
        o
    ];
}, $ccbc28c5febbced6$export$82eae7b3b3e00d56 = ([e, r, t])=>{
    const o = t * Math.PI / 180;
    return [
        e,
        r * Math.cos(o),
        r * Math.sin(o)
    ];
}, $ccbc28c5febbced6$export$d41e66f6c4225707 = (e, r, t, o = 24)=>{
    const n = (f)=>$ccbc28c5febbced6$export$9662bbd51984ea0c($ccbc28c5febbced6$export$82eae7b3b3e00d56([
            e,
            f,
            t
        ])), a = (f)=>f.every((i)=>i >= -0.0001 && i <= 1.0001);
    let s = n(r);
    if (!a(s)) {
        let f = 0, i = r;
        for(let c = 0; c < o; c++){
            const l = (f + i) / 2;
            a(n(l)) ? f = l : i = l;
        }
        s = n(f);
    }
    return s.map((f)=>$ccbc28c5febbced6$export$d30afa00cb499ab2(Math.max(0, Math.min(1, f))));
}, $ccbc28c5febbced6$export$73f20cdc774a086b = (e, r = 1, t = [
    255,
    255,
    255
])=>r >= 1 ? e : e.map((o, n)=>o * r + t[n] * (1 - r)), $ccbc28c5febbced6$export$2d78fefdcfb7f222 = (e, r)=>{
    (0, $czfS0.isString)(e) && e.includes("rgb") && (e = $ccbc28c5febbced6$export$fa32e9c99a43479e(e).join(", ")), (0, $czfS0.isString)(e) && (e = e.split(",").map((n)=>parseFloat(n.trim()))), (0, $czfS0.isNumber)(r) && (r += "");
    const t = $ccbc28c5febbced6$export$becee3e8de1b8d23(e), o = r.slice(0, 1);
    if (o === "-" || o === "+") {
        const n = $ccbc28c5febbced6$export$e1d0a0f5f1f4ce36(t, parseFloat(r));
        return $ccbc28c5febbced6$export$fc66327a54d8eee6(n).join(", ");
    } else {
        const [n, a, s] = e, [f, i] = $ccbc28c5febbced6$export$ac60e367bcb68b(n / 255, a / 255, s / 255), c = Math.max(0, Math.min(100, parseFloat(r))) / 100;
        return $ccbc28c5febbced6$export$29fb7152bd3f781a(f, i, c).map((d)=>Math.round(Math.max(0, Math.min(1, d)) * 255)).join(", ");
    }
};

});

parcelRegister("lJU31", function(module, exports) {
const $fd3946dbd6907892$export$b653d4648867fe18 = (e, t)=>{
    if (e) return e.themes && e.themes[t] ? e.themes[t] : e[t] ? [
        e,
        e[t]
    ] : e;
};

});

parcelRegister("jGZk7", function(module, exports) {

$parcel$export(module.exports, "resolveFileUrl", () => $e5618222492790ea$export$61174294d0ed0cf1);
$parcel$export(module.exports, "getDefaultOrFirstKey", () => $e5618222492790ea$export$73aa7d12a2d2fb83);
$parcel$export(module.exports, "isGoogleFontsUrl", () => $e5618222492790ea$export$460f73444f66199c);
$parcel$export(module.exports, "setFontImport", () => $e5618222492790ea$export$3a1ea4c2338850e0);
$parcel$export(module.exports, "setCustomFontMedia", () => $e5618222492790ea$export$2593ac3417be5ed7);
$parcel$export(module.exports, "getFontFaceEach", () => $e5618222492790ea$export$198e04e3616f042a);
const $e5618222492790ea$export$61174294d0ed0cf1 = (t, e)=>{
    if (!t || !e) return null;
    try {
        return new URL(t), null;
    } catch  {}
    const r = e[t];
    return r ? r.content && r.content.src : null;
}, $e5618222492790ea$export$73aa7d12a2d2fb83 = (t, e)=>{
    if (!t) return;
    if (e != null && e !== "" && e !== "default") {
        const n = t[e];
        return n && typeof n == "object" ? n.value : void 0;
    }
    const o = ()=>Object.keys(t).find((n)=>n !== "default" && t[n] && t[n].value && !t[n].isSystemFallback && !t[n].isSharedLibrary);
    if (t.__defaultKey) {
        const n = t[t.__defaultKey];
        if (n && n.isSystemFallback) {
            const s = o();
            if (s) return t[s].value;
        }
        if (n) return n.value;
    }
    const c = o() || Object.keys(t).find((n)=>n !== "default" && t[n] && t[n].value);
    return c && t[c] && t[c].value;
}, $e5618222492790ea$var$i = {
    woff2: "woff2",
    woff: "woff",
    ttf: "truetype",
    otf: "opentype",
    eot: "embedded-opentype",
    ttc: "collection"
}, $e5618222492790ea$export$6c7bbed5530e9474 = (t)=>{
    if (typeof t != "string" || !t) return null;
    const e = t.split(/[#?]/)[0].split(".").pop().trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call($e5618222492790ea$var$i, e) ? $e5618222492790ea$var$i[e] : null;
}, $e5618222492790ea$export$460f73444f66199c = (t)=>t && (t.includes("fonts.googleapis.com") || t.includes("fonts.gstatic.com")), $e5618222492790ea$export$3a1ea4c2338850e0 = (t)=>`@import url('${t}');`, $e5618222492790ea$export$e84fe2812840a337 = (t)=>`@font-face { ${t} }`, $e5618222492790ea$export$27bb82ae7d3ac02b = (t, e, r, o = {})=>{
    const s = (Array.isArray(e) ? e : [
        e
    ]).filter((a)=>typeof a == "string" && a).map((a)=>{
        const l = $e5618222492790ea$export$6c7bbed5530e9474(a), u = l ? ` format('${l}')` : "";
        return `url('${a}')${u}`;
    }).join(`,
       `);
    return `
  font-family: '${t}';
  font-style: ${o.fontStyle || "normal"};${r ? `
  font-weight: ${r};` : ""}${o.fontStretch ? `
  font-stretch: ${o.fontStretch};` : ""}${o.fontDisplay ? `
  font-display: ${o.fontDisplay};` : ""}${o.unicodeRange ? `
  unicode-range: ${o.unicodeRange};` : ""}
  src: ${s};`;
}, $e5618222492790ea$export$2593ac3417be5ed7 = (t, e, r, o)=>`@font-face {${$e5618222492790ea$export$27bb82ae7d3ac02b(t, e, r, o)}
}`, $e5618222492790ea$export$198e04e3616f042a = (t, e, r)=>Object.keys(e).map((c)=>{
        const { url: n, fontWeight: s, fontStyle: a, fontDisplay: l, fontStretch: u, unicodeRange: F } = e[c], S = Array.isArray(n) ? n.map((y)=>$e5618222492790ea$export$61174294d0ed0cf1(y, r) || y) : $e5618222492790ea$export$61174294d0ed0cf1(n, r) || n;
        return $e5618222492790ea$export$27bb82ae7d3ac02b(t, S, s, {
            fontStyle: a,
            fontDisplay: l,
            fontStretch: u,
            unicodeRange: F
        });
    }), $e5618222492790ea$export$e9d70cd3a9044b8e = (t)=>Object.keys(t).map((r)=>$e5618222492790ea$export$198e04e3616f042a(r, t[r].value)), $e5618222492790ea$export$c26ef91aac8931ec = (t, e, r)=>{
    if (e && e.isVariable) {
        const n = $e5618222492790ea$export$61174294d0ed0cf1(e.url, r) || e.url;
        return $e5618222492790ea$export$460f73444f66199c(n) ? $e5618222492790ea$export$3a1ea4c2338850e0(n) : $e5618222492790ea$export$2593ac3417be5ed7(t, n, e.fontWeight, {
            fontStretch: e.fontStretch,
            fontDisplay: e.fontDisplay || "swap",
            unicodeRange: e.unicodeRange
        });
    }
    if (e[0]) return $e5618222492790ea$export$198e04e3616f042a(t, e, r).map($e5618222492790ea$export$e84fe2812840a337);
    const c = Array.isArray(e.url) ? e.url.map((n)=>$e5618222492790ea$export$61174294d0ed0cf1(n, r) || n) : $e5618222492790ea$export$61174294d0ed0cf1(e.url, r) || e.url;
    return $e5618222492790ea$export$2593ac3417be5ed7(t, c, e.fontWeight, {
        fontStyle: e.fontStyle,
        fontDisplay: e.fontDisplay,
        fontStretch: e.fontStretch,
        unicodeRange: e.unicodeRange
    });
}, $e5618222492790ea$export$8b73d71a1d936bc = (t, e)=>Object.keys(t).map((o)=>$e5618222492790ea$export$c26ef91aac8931ec(o, t[o].value, e));

});

parcelRegister("d52u8", function(module, exports) {

$parcel$export(module.exports, "BARE_SEQUENCE_TOKEN_RE", () => $985dab746b3a37ad$export$54ebde65db27bb7f);
$parcel$export(module.exports, "quietSequenceProbe", () => $985dab746b3a37ad$export$6239e84751e8a0e4);
$parcel$export(module.exports, "getFnPrefixAndValue", () => $985dab746b3a37ad$export$30fba622059784de);
$parcel$export(module.exports, "getSequenceValue", () => $985dab746b3a37ad$export$efde09b5692f9bd0);
$parcel$export(module.exports, "getSubratio", () => $985dab746b3a37ad$export$50db87b17b1557b4);
$parcel$export(module.exports, "generateSequence", () => $985dab746b3a37ad$export$29708af739d9b0fc);
$parcel$export(module.exports, "getSizeValue", () => $985dab746b3a37ad$export$41cf1db51dca6f1);
$parcel$export(module.exports, "getSequenceValuePropertyPair", () => $985dab746b3a37ad$export$86c0052f25dacc45);
$parcel$export(module.exports, "findHeadings", () => $985dab746b3a37ad$export$8dc77c00fe04c40a);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");
var $czfS0 = parcelRequire("czfS0");
var $6Bm4P = parcelRequire("6Bm4P");

var $521xJ = parcelRequire("521xJ");

var $kjAAS = parcelRequire("kjAAS");

var $hzNzB = parcelRequire("hzNzB");
const $985dab746b3a37ad$export$54ebde65db27bb7f = /^-?[A-Z][0-9]?$/;
let $985dab746b3a37ad$var$w = 0;
const $985dab746b3a37ad$export$6239e84751e8a0e4 = (t)=>{
    $985dab746b3a37ad$var$w++;
    try {
        return t();
    } finally{
        $985dab746b3a37ad$var$w--;
    }
}, $985dab746b3a37ad$export$81ab9dc24d52c4ba = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
}, $985dab746b3a37ad$var$B = Object.keys($985dab746b3a37ad$export$81ab9dc24d52c4ba).reduce((t, e)=>(t[$985dab746b3a37ad$export$81ab9dc24d52c4ba[e]] = Number(e), t), {}), $985dab746b3a37ad$var$k = (t, e, n, i)=>{
    if ($985dab746b3a37ad$export$54ebde65db27bb7f.test(e)) {
        if (t && Object.keys(t).length) return t[e] !== void 0;
        const r = $985dab746b3a37ad$var$B[e.slice(0, 1)];
        if (r === void 0) return !1;
        const { range: s } = n;
        return !Array.isArray(s) || s.length < 2 ? !0 : r >= Math.min(s[0], s[1]) && r <= Math.max(s[0], s[1]);
    }
    if (i && Object.keys(i).length) return !1;
}, $985dab746b3a37ad$var$A = (t, e)=>{
    const { key: n, variable: i, value: r, scaling: s, index: o, scalingVariable: l } = t;
    e.sequence[n] = {
        key: n,
        decimal: ~~(r * 100) / 100,
        val: ~~r,
        scaling: s,
        index: o,
        scalingVariable: l,
        variable: i
    }, e.scales[n] = s;
    const a = $985dab746b3a37ad$var$L.has(e.unit) ? "rem" : e.unit;
    e.vars[i] = s + a;
}, $985dab746b3a37ad$export$30fba622059784de = (t)=>{
    if (!t.includes("(")) return t;
    const e = t.trim(), n = e.indexOf("("), i = e.slice(0, n);
    let r = 0, s = -1;
    for(let o = n; o < e.length; o++){
        const l = e[o];
        if (l === "(") r++;
        else if (l === ")" && (r--, r === 0)) {
            s = o;
            break;
        }
    }
    return s === -1 || /\s/.test(i) || e.slice(s + 1).trim() !== "" ? [
        void 0,
        t
    ] : [
        i,
        e.slice(n + 1, s)
    ];
}, $985dab746b3a37ad$var$M = "\0", $985dab746b3a37ad$var$W = (t, e)=>{
    let n = "", i = 0, r = "";
    for (const s of t){
        if (i === 0 && s !== "(") {
            n += s;
            continue;
        }
        r += s, s === "(" ? i++ : s === ")" && (i--, i === 0 && (n += $985dab746b3a37ad$var$M + e.length + $985dab746b3a37ad$var$M, e.push(r), r = ""));
    }
    return n + r;
}, $985dab746b3a37ad$var$Q = (t, e)=>t.indexOf($985dab746b3a37ad$var$M) === -1 ? t : t.replace(/\u0000(\d+)\u0000/g, (n, i)=>e[Number(i)]), $985dab746b3a37ad$var$J = /^(calc|min|max|clamp)\((.*)\)$/, $985dab746b3a37ad$var$X = (t, e)=>{
    const n = $985dab746b3a37ad$var$J.exec(t);
    return n ? `${n[1]}(${$985dab746b3a37ad$export$69f332a3be1b2f36(n[2], e)})` : t.indexOf("(") !== -1 ? t : $985dab746b3a37ad$export$efde09b5692f9bd0(t, e);
}, $985dab746b3a37ad$var$L = new Set([
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh"
]), $985dab746b3a37ad$export$68dfa61d698afbde = (t, e)=>{
    const { base: n, type: i, unit: r } = e, s = $985dab746b3a37ad$var$L.has(r) ? "rem" : r, o = ((0, $kjAAS.isScalingUnit)(s) ? 1 : n) + s;
    if (t === 0) return o;
    const a = "--" + (e.varPrefix ? e.varPrefix + "-" : "") + (i && i.replace(".", "-")), u = `${a}-ratio`;
    if (t > 0) {
        const f = $985dab746b3a37ad$export$81ab9dc24d52c4ba[t - 1];
        return `calc(var(${a}-${f}) * var(${u}))`;
    }
    if (t < 0) {
        const f = $985dab746b3a37ad$export$81ab9dc24d52c4ba[t + 1], h = Math.abs(t), g = Math.pow($985dab746b3a37ad$var$D, 2 * h), m = $985dab746b3a37ad$export$81ab9dc24d52c4ba[h];
        return m ? `max(calc(var(${a}-${f}) / var(${u})), calc(var(${a}-${m}) / ${g.toFixed(4)}))` : `calc(var(${a}-${f}) / var(${u}))`;
    }
}, $985dab746b3a37ad$export$c9d5ef57eeb83fa = (t, e, n, i)=>{
    const { type: r } = i, o = t === 2 && e.length === 2 ? t + 1 : t, u = `${"--" + (i.varPrefix ? i.varPrefix + "-" : "") + (r && r.replace(".", "-"))}-sub-ratio-`;
    return `calc(var(${n}) * var(${u + o}))`;
}, $985dab746b3a37ad$export$12adf55fdaa50348 = (t, e)=>{
    const i = (t * e - t) / 1.618, r = t * e - i, s = t + i, o = (r + s) / 2;
    return [
        r,
        o,
        s
    ];
}, $985dab746b3a37ad$export$50db87b17b1557b4 = (t, e)=>$985dab746b3a37ad$export$12adf55fdaa50348(t, e).map((n)=>n / t), $985dab746b3a37ad$export$622ae6209895c34e = (t, e)=>{
    const { key: n, base: i, value: r, ratio: s, variable: o, index: l } = t, u = ~~(r * s) - ~~r;
    let f;
    const [h, g, m] = $985dab746b3a37ad$export$12adf55fdaa50348(r, s);
    u > 16 ? f = [
        h,
        g,
        m
    ] : f = [
        h,
        m
    ], f.forEach((p, c)=>{
        const x = ~~(p / i * 1e3) / 1e3, b = o + (c + 1), V = l + (c + 1) / 10, y = $985dab746b3a37ad$export$c9d5ef57eeb83fa(c + 1, f, o, e), O = {
            key: n + (c + 1),
            variable: b,
            value: p,
            scaling: x,
            scalingVariable: y,
            index: V
        };
        $985dab746b3a37ad$var$A(O, e);
    });
}, $985dab746b3a37ad$var$D = 1.618, $985dab746b3a37ad$var$Z = (t, e, n)=>{
    if (t >= 0) return e * Math.pow(n, t);
    const i = Math.abs(t), r = e * Math.pow(n, t), s = e * Math.pow(n, i) / Math.pow($985dab746b3a37ad$var$D, 2 * i);
    return Math.max(r, s);
}, $985dab746b3a37ad$export$29708af739d9b0fc = (t)=>{
    const { type: e, base: n, ratio: i, range: r, subSequence: s } = t, o = Math.abs(r[0]) + Math.abs(r[1]), a = "--" + (t.varPrefix ? t.varPrefix + "-" : "") + (e && e.replace(".", "-")) + "-";
    for(let u = 0; u <= o; u++){
        const f = r[1] - u, h = $985dab746b3a37ad$export$81ab9dc24d52c4ba[f], g = $985dab746b3a37ad$var$Z(f, n, i), m = ~~(g / n * 100) / 100, p = a + h, c = $985dab746b3a37ad$export$68dfa61d698afbde(f, t), x = {
            key: h,
            variable: p,
            value: g,
            base: n,
            scaling: m,
            scalingVariable: c,
            ratio: i,
            index: f
        };
        $985dab746b3a37ad$var$A(x, t), s && $985dab746b3a37ad$export$622ae6209895c34e(x, t);
    }
    return t;
}, $985dab746b3a37ad$export$7b7c0090b74e1e64 = (t, e = 0)=>{
    const { type: n, base: i, ratio: r, subSequence: s } = t, o = (0, $czfS0.isString)(e) ? e : $985dab746b3a37ad$export$81ab9dc24d52c4ba[e], l = (0, $czfS0.isString)(e) ? Object.entries($985dab746b3a37ad$export$81ab9dc24d52c4ba).find(([, x])=>x === e)?.[0] : e;
    if (!o) return null;
    const a = {
        sequence: {},
        scales: {},
        vars: {},
        ...t
    }, u = i * Math.pow(r, l), f = ~~(u / i * 100) / 100, m = "--" + (t.varPrefix ? t.varPrefix + "-" : "") + (n && n.replace(".", "-")) + "-" + o, p = $985dab746b3a37ad$export$68dfa61d698afbde(l, t), c = {
        key: o,
        variable: m,
        value: u,
        base: i,
        scaling: f,
        scalingVariable: p,
        ratio: r,
        index: l
    };
    return $985dab746b3a37ad$var$A(c, a), s && $985dab746b3a37ad$export$622ae6209895c34e(c, a), a;
}, $985dab746b3a37ad$export$41cf1db51dca6f1 = (t, e)=>{
    if (!t || !(0, $czfS0.isString)(e) || !e) return;
    const n = t[e] || t[e.toLowerCase()];
    if (n !== void 0) return e.charCodeAt(0) === 45 ? `calc(${n} * -1)` : n;
    if (e.charCodeAt(0) !== 45 || e.length < 2) return;
    const i = e.slice(1), r = t[i] || t[i.toLowerCase()];
    if (r !== void 0) return `calc(${r} * -1)`;
}, $985dab746b3a37ad$export$efde09b5692f9bd0 = (t = "A", e)=>{
    const n = (0, $521xJ.getActiveConfig)(), { unit: i } = n;
    if ((0, $czfS0.isString)(t) && (0, $hzNzB.isCSSVar)(t)) return `var(${t})`;
    if ((0, $czfS0.isString)(t) && /^(?:env|var|calc|min|max|clamp)\(/.test(t.trim())) return t;
    if ((0, $czfS0.isString)(t)) {
        const d = $985dab746b3a37ad$export$41cf1db51dca6f1(n.sizes, t);
        if (d !== void 0) return d;
    }
    const { sequence: r, unit: s = i.default, useVariable: o } = e, l = /^-?[a-zA-Z]/i, a = l.test(t);
    if ((0, $kjAAS.isRawUnitValue)(t) || !a || [
        "none",
        "auto",
        "max-content",
        "min-content",
        "fit-content",
        "inherit",
        "initial",
        "unset",
        "revert",
        "revert-layer"
    ].includes(t)) return t;
    const g = `--${e.varPrefix ? e.varPrefix + "-" : ""}${(0, $6Bm4P.toDashCase)(e.type.replace(".", "-"))}-`, m = t.toUpperCase(), p = m.slice(0, 1) === "-" ? "-" : "";
    let c = p ? m.slice(1) : m, x = "";
    c.includes("_") && (x = "_" + c.split("_")[1].toLowerCase(), c = c.split("_")[0]);
    const b = (d)=>l.test(d) ? `var(${g}${d}${x})` : d;
    if (c.includes("+")) {
        const [d, v] = c.split("+"), _ = `${b(d)} + ${b(v)}`;
        return p ? `calc((${_}) * -1)` : `calc(${_})`;
    } else if (c.includes("*")) {
        const [d, v] = c.split("*"), _ = `${b(d)} * ${b(v)}`;
        return p ? `calc((${_}) * -1)` : `calc(${_})`;
    } else if (c.includes("-")) {
        const [d, v] = c.split("-"), _ = `${b(d)} - ${b(v)}`;
        return p ? `calc((${_}) * -1)` : `calc(${_})`;
    }
    !r[c] && c.length === 2 && (n.verbose, c = c.slice(0, 1));
    const V = r ? r[c] : null, y = !!(o || n.useVariable);
    if ((y ? $985dab746b3a37ad$var$k(r, c, e, n.sizes) : !!V) === !1) {
        if ($985dab746b3a37ad$var$w > 0) return;
        if ((0, $dSdIt.isLoudDevRuntime)()) throw new Error(`[smbls] Unresolvable design-system token "${t}"` + (e.type ? ` for sequence "${e.type}"` : "") + " \u2014 not a registered `sizes` name and not a valid spacing/typography/timing sequence letter. The CSS property using it would silently be dropped in production. Register the token in `designSystem/sizes.js` (or the relevant sequence family) or fix the typo.");
        return;
    }
    if (y) {
        const d = `var(${g}${c}${x})`;
        return p ? `calc(${d} * -1)` : d;
    }
    return s === "ms" || s === "s" ? p + V.val + s : p + V.scaling + s;
}, $985dab746b3a37ad$export$69f332a3be1b2f36 = (t, e)=>{
    if (![
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((o)=>t.includes(o + " ")).length) return t;
    const i = /(\s+-\s+|\s*[+*/,]\s*)/, r = [];
    return $985dab746b3a37ad$var$W(t, r).split(i).map((o)=>{
        const l = $985dab746b3a37ad$var$Q(o, r), a = l.trim();
        return !a || [
            "+",
            "-",
            "*",
            "/",
            ","
        ].includes(a) ? l : $985dab746b3a37ad$var$X(a, e);
    }).join("");
}, $985dab746b3a37ad$export$86c0052f25dacc45 = (t, e, n, i)=>{
    if (typeof t != "string") return (0, $521xJ.getActiveConfig)().verbose, {
        [e]: t
    };
    if (t === "-" || t === "") return {};
    if (!i && t.includes("(")) {
        if (/^(?:env|var)\(/.test(t.trim())) return {
            [e]: t
        };
        const s = $985dab746b3a37ad$export$30fba622059784de(t);
        i = s[0], t = s[1];
    }
    return [
        "+",
        "-",
        "*",
        "/",
        ","
    ].filter((s)=>t.includes(s + " ")).length ? t = $985dab746b3a37ad$export$69f332a3be1b2f36(t, n) : t = $985dab746b3a37ad$export$efde09b5692f9bd0(t, n), {
        [e]: i ? `${i}(${t})` : t
    };
}, $985dab746b3a37ad$export$14c834a042d41297 = (t, e)=>$985dab746b3a37ad$export$81ab9dc24d52c4ba[t - e], $985dab746b3a37ad$export$8dc77c00fe04c40a = (t)=>{
    const { h1Matches: e, sequence: n } = t;
    return new Array(6).fill(null).map((i, r)=>{
        const s = $985dab746b3a37ad$export$14c834a042d41297(e, r);
        return n[s];
    });
};

});
parcelRegister("521xJ", function(module, exports) {

$parcel$export(module.exports, "CONFIG_MERGE_EXL", () => $3a9e560d3798c08a$export$14ece1099933222b);
$parcel$export(module.exports, "toCamel", () => $3a9e560d3798c08a$export$bc7802f0bef8d7aa);
$parcel$export(module.exports, "pushConfig", () => $3a9e560d3798c08a$export$5d5568bf009ee2a6);
$parcel$export(module.exports, "popConfig", () => $3a9e560d3798c08a$export$5f6e6c1471f1916c);
$parcel$export(module.exports, "getActiveConfig", () => $3a9e560d3798c08a$export$e23c3d522afb24cd);
$parcel$export(module.exports, "setActiveConfig", () => $3a9e560d3798c08a$export$5e61d1b6fff0c794);
$parcel$export(module.exports, "aliasCaseVariants", () => $3a9e560d3798c08a$export$89aab25b3e9b8cad);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
var $czfS0 = parcelRequire("czfS0");
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $i2LhC = parcelRequire("i2LhC");
const $3a9e560d3798c08a$export$fd62969fb0b7081c = {}, $3a9e560d3798c08a$export$e926ee1e7e0eae93 = {}, $3a9e560d3798c08a$export$14ece1099933222b = new Set, $3a9e560d3798c08a$var$f = $i2LhC, $3a9e560d3798c08a$var$m = {}, $3a9e560d3798c08a$export$bc7802f0bef8d7aa = (e)=>e.replace(/_([a-z])/g, (t, o)=>o.toUpperCase());
for(const e in $3a9e560d3798c08a$var$f){
    const t = e.toLowerCase();
    $3a9e560d3798c08a$var$m[t] = $3a9e560d3798c08a$var$f[e];
    const o = $3a9e560d3798c08a$export$bc7802f0bef8d7aa(t);
    o !== t && ($3a9e560d3798c08a$var$m[o] = $3a9e560d3798c08a$var$f[e]), t !== e && ($3a9e560d3798c08a$var$m[e] = $3a9e560d3798c08a$var$f[e]);
}
const $3a9e560d3798c08a$export$1630b5343357e8b5 = {
    verbose: !1,
    useVariable: !0,
    useReset: !0,
    globalTheme: "auto",
    cssVars: $3a9e560d3798c08a$export$fd62969fb0b7081c,
    cssMediaVars: $3a9e560d3798c08a$export$e926ee1e7e0eae93,
    CSS_VARS: $3a9e560d3798c08a$export$fd62969fb0b7081c,
    CSS_MEDIA_VARS: $3a9e560d3798c08a$export$e926ee1e7e0eae93,
    cssSkinVars: {},
    cssSkinFallback: {},
    _scratchConfig: !0,
    ...$3a9e560d3798c08a$var$m
}, $3a9e560d3798c08a$export$47b692c65672b1b2 = (e, t)=>{
    if (!e) return null;
    if (e.__globalThemeSignal) return (0, $czfS0.isDefined)(t) && e.__globalThemeSignal.set(t), e.__globalThemeSignal;
    const o = (0, $czfS0.isDefined)(t) ? t : e.globalTheme, s = (0, $4VQqJ.createSignal)((0, $czfS0.isDefined)(o) ? o : "auto");
    return Object.defineProperty(e, "globalTheme", {
        get () {
            return s.get();
        },
        set (r) {
            s.set(r);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(e, "__globalThemeSignal", {
        value: s,
        enumerable: !1,
        configurable: !0,
        writable: !0
    }), s;
}, $3a9e560d3798c08a$export$8c3552a8cd2b6795 = (e)=>e ? $3a9e560d3798c08a$export$47b692c65672b1b2(e) : null, $3a9e560d3798c08a$export$bbc3d706f3b9d98e = (e, t)=>{
    if (!e) return null;
    if (e.__resolvedThemeSignal) return (0, $czfS0.isDefined)(t) && e.__resolvedThemeSignal.set(t), e.__resolvedThemeSignal;
    const o = (0, $czfS0.isDefined)(t) ? t : e.resolvedTheme, s = (0, $4VQqJ.createSignal)((0, $czfS0.isDefined)(o) ? o : null);
    return Object.defineProperty(e, "resolvedTheme", {
        get () {
            return s.get();
        },
        set (r) {
            s.set(r);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e, "__resolvedThemeSignal", {
        value: s,
        enumerable: !1,
        configurable: !0,
        writable: !0
    }), s;
}, $3a9e560d3798c08a$export$a8b800a9ac3283d2 = (e)=>e ? $3a9e560d3798c08a$export$bbc3d706f3b9d98e(e) : null;
$3a9e560d3798c08a$export$47b692c65672b1b2($3a9e560d3798c08a$export$1630b5343357e8b5), $3a9e560d3798c08a$export$bbc3d706f3b9d98e($3a9e560d3798c08a$export$1630b5343357e8b5);
const $3a9e560d3798c08a$var$c = (0, $2C0hZ.deepClone)($3a9e560d3798c08a$export$1630b5343357e8b5), $3a9e560d3798c08a$export$ee513c29aad6cc62 = {
    active: "0",
    0: $3a9e560d3798c08a$export$1630b5343357e8b5
}, $3a9e560d3798c08a$export$8a278b801d0668ff = (e)=>((0, $czfS0.isDefined)(e) && ($3a9e560d3798c08a$export$ee513c29aad6cc62.active = e), $3a9e560d3798c08a$export$ee513c29aad6cc62[e || $3a9e560d3798c08a$export$ee513c29aad6cc62.active]), $3a9e560d3798c08a$var$u = [], $3a9e560d3798c08a$export$5d5568bf009ee2a6 = (e)=>{
    e && e._scratchConfig && $3a9e560d3798c08a$var$u.push(e);
}, $3a9e560d3798c08a$export$5f6e6c1471f1916c = ()=>{
    $3a9e560d3798c08a$var$u.pop();
}, $3a9e560d3798c08a$export$e23c3d522afb24cd = (e)=>$3a9e560d3798c08a$var$u.length ? $3a9e560d3798c08a$var$u[$3a9e560d3798c08a$var$u.length - 1] : $3a9e560d3798c08a$export$ee513c29aad6cc62[e || $3a9e560d3798c08a$export$ee513c29aad6cc62.active] || $3a9e560d3798c08a$export$1630b5343357e8b5, $3a9e560d3798c08a$export$5e61d1b6fff0c794 = (e)=>{
    if ((0, $czfS0.isObject)(e)) return $3a9e560d3798c08a$export$ee513c29aad6cc62.active = "1", $3a9e560d3798c08a$export$ee513c29aad6cc62[1] = (0, $2C0hZ.deepMerge)(e, (0, $2C0hZ.deepClone)($3a9e560d3798c08a$var$c), $3a9e560d3798c08a$export$14ece1099933222b), $3a9e560d3798c08a$export$89aab25b3e9b8cad($3a9e560d3798c08a$export$ee513c29aad6cc62[1]), $3a9e560d3798c08a$export$47b692c65672b1b2($3a9e560d3798c08a$export$ee513c29aad6cc62[1]), $3a9e560d3798c08a$export$bbc3d706f3b9d98e($3a9e560d3798c08a$export$ee513c29aad6cc62[1]), e;
}, $3a9e560d3798c08a$var$F = [
    "useReset",
    "useFontImport",
    "useIconSprite",
    "useSvgSprite",
    "useDocumentTheme",
    "useDefaultIcons",
    "useDefaultConfig"
], $3a9e560d3798c08a$var$P = [
    "useVariable",
    "globalTheme",
    "verbose"
], $3a9e560d3798c08a$var$R = [
    [
        "fontfamily",
        "fontFamily",
        "font_family"
    ],
    [
        "fontfamilytypes",
        "fontFamilyTypes"
    ],
    [
        "semanticicons",
        "semanticIcons"
    ],
    [
        "svgdata",
        "svgData",
        "svg_data"
    ]
], $3a9e560d3798c08a$export$89aab25b3e9b8cad = (e)=>{
    for (const t of $3a9e560d3798c08a$var$R){
        let o;
        for (const s of t){
            const r = e[s];
            (0, $czfS0.isObject)(r) && (o = o ? (0, $2C0hZ.deepMerge)(o, r, $3a9e560d3798c08a$export$14ece1099933222b) : r);
        }
        if (o) for (const s of t)(0, $czfS0.isObject)(e[s]) && (e[s] = o);
    }
}, $3a9e560d3798c08a$var$O = (e)=>(e.cssVars = {}, e.cssMediaVars = {}, e.CSS_VARS = e.cssVars, e.CSS_MEDIA_VARS = e.cssMediaVars, e.cssSkinVars = {}, e.cssSkinFallback = {}, e._scratchConfig = !0, $3a9e560d3798c08a$export$89aab25b3e9b8cad(e), $3a9e560d3798c08a$export$47b692c65672b1b2(e), $3a9e560d3798c08a$export$bbc3d706f3b9d98e(e), e), $3a9e560d3798c08a$export$bce1d468a9f30ba3 = ()=>$3a9e560d3798c08a$var$O((0, $2C0hZ.deepClone)($3a9e560d3798c08a$var$c)), $3a9e560d3798c08a$export$45a69314cf48a3eb = (e, t, { cleanBase: o = !1 } = {})=>{
    const s = o ? null : $3a9e560d3798c08a$export$e23c3d522afb24cd(), r = (0, $2C0hZ.deepClone)(!o && s && s._scratchConfig ? s : $3a9e560d3798c08a$var$c);
    for (const l of $3a9e560d3798c08a$var$F)delete r[l];
    for (const l of $3a9e560d3798c08a$var$P)Object.prototype.hasOwnProperty.call($3a9e560d3798c08a$var$c, l) ? r[l] = $3a9e560d3798c08a$var$c[l] : delete r[l];
    const v = $3a9e560d3798c08a$var$O((0, $2C0hZ.deepMerge)(t || {}, r, $3a9e560d3798c08a$export$14ece1099933222b));
    return e && ($3a9e560d3798c08a$export$ee513c29aad6cc62[e] = v), v;
};

});
parcelRegister("i2LhC", function(module, exports) {

$parcel$export(module.exports, "reset", () => $d22d175efaf1e6b1$export$aad8462122ac592b);
$parcel$export(module.exports, "vars", () => $d22d175efaf1e6b1$export$3cb96c9f6c8d16a4);
$parcel$export(module.exports, "sizes", () => $d22d175efaf1e6b1$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "shape", () => $d22d175efaf1e6b1$export$98bada23690e67eb);
$parcel$export(module.exports, "skins", () => $d22d175efaf1e6b1$export$73a62b752731330b);
$parcel$export(module.exports, "viewTransition", () => $d22d175efaf1e6b1$export$5ddfeb5596fe32a4);

var $fjXnR = parcelRequire("fjXnR");

var $5voOf = parcelRequire("5voOf");

var $dtBjt = parcelRequire("dtBjt");

var $65L9K = parcelRequire("65L9K");

var $03Lx1 = parcelRequire("03Lx1");

var $c8uhu = parcelRequire("c8uhu");

var $eVvrN = parcelRequire("eVvrN");

var $3zTHq = parcelRequire("3zTHq");

var $a0DsB = parcelRequire("a0DsB");

var $k9RcT = parcelRequire("k9RcT");

var $W769q = parcelRequire("W769q");

var $aM0uG = parcelRequire("aM0uG");

var $blaBH = parcelRequire("blaBH");

var $83BMq = parcelRequire("83BMq");

var $9PaMP = parcelRequire("9PaMP");

var $bz2O6 = parcelRequire("bz2O6");

var $dsNzb = parcelRequire("dsNzb");

var $bSdcE = parcelRequire("bSdcE");

var $4f0Mh = parcelRequire("4f0Mh");
const $d22d175efaf1e6b1$export$aad8462122ac592b = {}, $d22d175efaf1e6b1$export$3cb96c9f6c8d16a4 = {}, $d22d175efaf1e6b1$export$c647cb0ee6e282fe = {}, $d22d175efaf1e6b1$export$98bada23690e67eb = {}, $d22d175efaf1e6b1$export$73a62b752731330b = {}, $d22d175efaf1e6b1$export$5ddfeb5596fe32a4 = {};
$parcel$exportWildcard(module.exports, $fjXnR);
$parcel$exportWildcard(module.exports, $5voOf);
$parcel$exportWildcard(module.exports, $dtBjt);
$parcel$exportWildcard(module.exports, $65L9K);
$parcel$exportWildcard(module.exports, $03Lx1);
$parcel$exportWildcard(module.exports, $c8uhu);
$parcel$exportWildcard(module.exports, $eVvrN);
$parcel$exportWildcard(module.exports, $3zTHq);
$parcel$exportWildcard(module.exports, $a0DsB);
$parcel$exportWildcard(module.exports, $k9RcT);
$parcel$exportWildcard(module.exports, $W769q);
$parcel$exportWildcard(module.exports, $aM0uG);
$parcel$exportWildcard(module.exports, $blaBH);
$parcel$exportWildcard(module.exports, $83BMq);
$parcel$exportWildcard(module.exports, $9PaMP);
$parcel$exportWildcard(module.exports, $bz2O6);
$parcel$exportWildcard(module.exports, $dsNzb);
$parcel$exportWildcard(module.exports, $bSdcE);
$parcel$exportWildcard(module.exports, $4f0Mh);

});
parcelRegister("fjXnR", function(module, exports) {

$parcel$export(module.exports, "sequence", () => $b276b1bccc5eeb39$export$49bb65c2ea163039);
const $b276b1bccc5eeb39$export$49bb65c2ea163039 = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    "double-octave": 4
};

});

parcelRegister("5voOf", function(module, exports) {

$parcel$export(module.exports, "unit", () => $402317a577c596e3$export$523c0b569236b342);
const $402317a577c596e3$export$523c0b569236b342 = {
    default: "em"
};

});

parcelRegister("dtBjt", function(module, exports) {

$parcel$export(module.exports, "typography", () => $9cfaed6884722d21$export$d846a084e680d8e);

var $fjXnR = parcelRequire("fjXnR");
const $9cfaed6884722d21$var$t = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: (0, $fjXnR.sequence)["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
}, $9cfaed6884722d21$export$d846a084e680d8e = $9cfaed6884722d21$var$t;

});

parcelRegister("65L9K", function(module, exports) {

$parcel$export(module.exports, "font", () => $46f7c9eefe9a0969$export$a74e2025f5286b02);
var $46f7c9eefe9a0969$var$t = {
    name: "",
    url: "",
    fontStyle: "",
    fontWeight: 500,
    fontStretch: "normal",
    fontOpticalSizing: "auto"
};
const $46f7c9eefe9a0969$export$a74e2025f5286b02 = {};

});

parcelRegister("03Lx1", function(module, exports) {

$parcel$export(module.exports, "fontFamily", () => $00b526b5a575a410$export$a5975749f0374264);
$parcel$export(module.exports, "fontFamilyTypes", () => $00b526b5a575a410$export$963356d15a6daac);
$parcel$export(module.exports, "fontFace", () => $00b526b5a575a410$export$566c6c2ff0443c7);
var $00b526b5a575a410$var$e = {
    name: "",
    family: "",
    type: ""
};
const $00b526b5a575a410$export$a5975749f0374264 = {}, $00b526b5a575a410$export$963356d15a6daac = {
    "sans-serif": "Helvetica, Arial, sans-serif",
    serif: "Times New Roman, Georgia, serif",
    monospace: "Courier New, monospace"
}, $00b526b5a575a410$export$566c6c2ff0443c7 = {};

});

parcelRegister("c8uhu", function(module, exports) {

$parcel$export(module.exports, "media", () => $8d5db89901ef9dbf$export$987d49ffe1b0900f);
const $8d5db89901ef9dbf$export$987d49ffe1b0900f = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};

});

parcelRegister("eVvrN", function(module, exports) {

$parcel$export(module.exports, "spacing", () => $addec85a8f8f9dd4$export$5458b64234d1333c);

var $fjXnR = parcelRequire("fjXnR");

var $dtBjt = parcelRequire("dtBjt");
const $addec85a8f8f9dd4$var$t = {
    base: (0, $dtBjt.typography).base,
    type: "spacing",
    ratio: (0, $fjXnR.sequence).phi,
    range: [
        -5,
        15
    ],
    subSequence: !0,
    mediaRegenerate: !1,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
}, $addec85a8f8f9dd4$export$5458b64234d1333c = $addec85a8f8f9dd4$var$t;

});

parcelRegister("3zTHq", function(module, exports) {

$parcel$export(module.exports, "color", () => $29afd8bccaba91ea$export$35e9368ef982300f);
$parcel$export(module.exports, "gradient", () => $29afd8bccaba91ea$export$f7d09cddc76f277f);
var $29afd8bccaba91ea$var$o = {
    name: "",
    value: ""
};
const $29afd8bccaba91ea$export$35e9368ef982300f = {}, $29afd8bccaba91ea$export$f7d09cddc76f277f = {};

});

parcelRegister("a0DsB", function(module, exports) {

$parcel$export(module.exports, "theme", () => $74988374e5159664$export$bca14c5b3b88a9c9);
const $74988374e5159664$var$e = {
    text: "blue",
    background: "white",
    border: "black",
    active: {},
    helpers: [],
    themes: {},
    inverse: {}
}, $74988374e5159664$export$bca14c5b3b88a9c9 = {};

});

parcelRegister("k9RcT", function(module, exports) {

$parcel$export(module.exports, "shadow", () => $eacdebb917c17b1b$export$b8972b998723d602);
const $eacdebb917c17b1b$export$b8972b998723d602 = {};

});

parcelRegister("W769q", function(module, exports) {

$parcel$export(module.exports, "icons", () => $0aeaec735f747afd$export$df03f54e09e486fa);
$parcel$export(module.exports, "semanticIcons", () => $0aeaec735f747afd$export$76fb3c2f696fe0ef);
const $0aeaec735f747afd$export$df03f54e09e486fa = {}, $0aeaec735f747afd$export$76fb3c2f696fe0ef = {};

});

parcelRegister("aM0uG", function(module, exports) {

$parcel$export(module.exports, "timing", () => $7d7ec529e93d3092$export$edfe6c349c815521);

var $fjXnR = parcelRequire("fjXnR");
const $7d7ec529e93d3092$var$t = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: (0, $fjXnR.sequence)["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: !1,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
}, $7d7ec529e93d3092$export$edfe6c349c815521 = $7d7ec529e93d3092$var$t;

});

parcelRegister("blaBH", function(module, exports) {

$parcel$export(module.exports, "document", () => $8419e2313eddb9c9$export$5a7bfc01df82fcd1);
const $8419e2313eddb9c9$export$5a7bfc01df82fcd1 = {};

});

parcelRegister("83BMq", function(module, exports) {

$parcel$export(module.exports, "breakpoints", () => $5ddbe8e42806f115$export$d07517a676ce386f);
$parcel$export(module.exports, "devices", () => $5ddbe8e42806f115$export$2b1363e3b7173105);
const $5ddbe8e42806f115$export$d07517a676ce386f = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
}, $5ddbe8e42806f115$export$2b1363e3b7173105 = {
    screenXXL: [
        2560,
        1440
    ],
    screenXL: [
        2240,
        1260
    ],
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        720
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};

});

parcelRegister("9PaMP", function(module, exports) {

$parcel$export(module.exports, "animation", () => $72713e781be75d3e$export$ecad260a8a5fef4f);
const $72713e781be75d3e$export$ecad260a8a5fef4f = {};

});

parcelRegister("bz2O6", function(module, exports) {

$parcel$export(module.exports, "svg", () => $86b5240599b0156b$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "svgData", () => $86b5240599b0156b$export$61fab8dd8fc131ea);
$parcel$export(module.exports, "svg_data", () => $86b5240599b0156b$export$f3a54fc6c0de0399);
const $86b5240599b0156b$export$7ed1367e7fa1ad68 = {}, $86b5240599b0156b$export$61fab8dd8fc131ea = {}, $86b5240599b0156b$export$f3a54fc6c0de0399 = $86b5240599b0156b$export$61fab8dd8fc131ea;

});

parcelRegister("dsNzb", function(module, exports) {

$parcel$export(module.exports, "templates", () => $9cd456c24298e532$export$a8fc3402335b0b04);
const $9cd456c24298e532$export$a8fc3402335b0b04 = {};

});

parcelRegister("bSdcE", function(module, exports) {

$parcel$export(module.exports, "grid", () => $8a4efab8c0edc800$export$85fc379452d91af0);
const $8a4efab8c0edc800$var$t = {}, $8a4efab8c0edc800$export$85fc379452d91af0 = $8a4efab8c0edc800$var$t;

});

parcelRegister("4f0Mh", function(module, exports) {

$parcel$export(module.exports, "class", () => $31692a98cb9ed941$export$4aaf3ce7c927d34c);
const $31692a98cb9ed941$export$4aaf3ce7c927d34c = {};

});




parcelRegister("2CJN9", function(module, exports) {

$parcel$export(module.exports, "applySequenceVars", () => $1e92a6a7bb390090$export$97ab4e7d8ade5018);
$parcel$export(module.exports, "applyMediaSequenceVars", () => $1e92a6a7bb390090$export$768e417cbfe71417);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");

var $d52u8 = parcelRequire("d52u8");

var $kjAAS = parcelRequire("kjAAS");
const $1e92a6a7bb390090$export$7c38483ff47439d8 = (e, i)=>{
    const m = (0, $521xJ.getActiveConfig)(), { cssVars: u } = m;
    (0, $czfS0.isObjectLike)(e.value) || (u[e.var] = e.value);
}, $1e92a6a7bb390090$export$eba6b21fdce78bcd = (e, i, m)=>{
    const u = (0, $521xJ.getActiveConfig)(), { unit: p } = u, n = i.unit || p.default, { base: s, ratio: r, type: o } = i, t = "--" + (i.varPrefix ? i.varPrefix + "-" : "") + (o && o.replace(".", "-"));
    e[`${t}-base`] = s, e[`${t}-unit`] = n;
    const f = `${t}-ratio`;
    e[f] = r;
    const [a, l, d] = (0, $d52u8.getSubratio)(s, r);
    e[`${t}-sub-ratio-1`] = `calc(var(${t}-ratio) * ${a / r})`, e[`${t}-sub-ratio-2`] = `calc(var(${t}-ratio) * ${l / r})`, e[`${t}-sub-ratio-3`] = `calc(var(${t}-ratio) * ${d / r})`;
}, $1e92a6a7bb390090$var$N = new Set([
    "vw",
    "vh",
    "vmin",
    "vmax",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh"
]), $1e92a6a7bb390090$export$97ab4e7d8ade5018 = (e, i = {})=>{
    const m = (0, $521xJ.getActiveConfig)(), { unit: u, timing: p, cssVars: n } = m, s = e.unit || u.default, r = $1e92a6a7bb390090$var$N.has(s) ? "rem" : s, { mediaRegenerate: o, sequence: v, scales: t } = e;
    o || $1e92a6a7bb390090$export$eba6b21fdce78bcd(n, e, i);
    for(const f in v){
        const a = v[f], l = (e.type === p.type ? v[f].val : t[f]) + r;
        if (!o) {
            n[a.variable + "_default"] = l, n[a.variable] = a.scalingVariable;
            continue;
        }
        i.useDefault === !1 ? n[a.variable] = l : (n[a.variable + "_default"] = l, n[a.variable] = `var(${a.variable + "_default"})`);
    }
}, $1e92a6a7bb390090$export$768e417cbfe71417 = (e, i, m = {})=>{
    const u = (0, $521xJ.getActiveConfig)(), { unit: p, media: n, cssVars: s } = u, r = i.slice(1), o = e[i], v = o.unit || e.unit || p.default, t = $1e92a6a7bb390090$var$N.has(v) ? "rem" : v, { mediaRegenerate: f } = e, { sequence: a, scales: l } = o, d = n && n[r];
    if (d) {
        if (!f) {
            let c = s[`@media ${d}`];
            c || (c = s[`@media ${d}`] = {}), $1e92a6a7bb390090$export$eba6b21fdce78bcd(c, o, m);
            const $ = e.unit || p.default;
            if (t !== $ && a) for(const S in a){
                const b = a[S], V = l[S] + t;
                c[b.variable + "_default"] = V, c[b.variable] = V;
            }
            return;
        }
        for(const c in a){
            const $ = a[c], S = ((0, $kjAAS.isScalingUnit)(t) ? l[c] : a[c].val) + t;
            let b = s[`@media ${d}`];
            b || (b = s[`@media ${d}`] = {}), b[$.variable] = `var(${$.variable + "_" + r})`, s[$.variable + "_" + r] = S;
        }
    }
};

});

parcelRegister("bbBIp", function(module, exports) {

$parcel$export(module.exports, "generateSprite", () => $824dfa427d37e8f5$export$121b8d85aca89bf6);
$parcel$export(module.exports, "convertSvgToSymbol", () => $824dfa427d37e8f5$export$510fb280711ea968);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");
const $824dfa427d37e8f5$var$S = (0, $dSdIt.isNotProduction)(), $824dfa427d37e8f5$export$121b8d85aca89bf6 = (e)=>{
    const t = (0, $521xJ.getActiveConfig)();
    let r = "";
    for(const s in e)t.__svgCache[s] || (t.__svgCache[s] = !0, r += e[s]);
    return r;
}, $824dfa427d37e8f5$var$$ = (e)=>{
    const t = e && (e.default || e);
    if (!(0, $czfS0.isString)(t)) return $824dfa427d37e8f5$var$S, {};
    const r = t.match(/<svg\s+(.*?)>/);
    if (!r || !r[1]) return {};
    const o = r[1].match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return o ? o.reduce((n, i)=>{
        const [a, g] = i.split("=");
        return n[a] = g.replace(/['"]/g, ""), n;
    }, {}) : {};
}, $824dfa427d37e8f5$var$d = (e, t)=>{
    const r = [];
    if (e.replace(/id="([^"]*)"/g, (o, n)=>(r.push(n), o)), !r.length) return e;
    let s = e;
    for (const o of r){
        const n = o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), i = `${t}-${o}`;
        s = s.replace(new RegExp(`id="${n}"`, "g"), `id="${i}"`).replace(new RegExp(`url\\(#${n}\\)`, "g"), `url(#${i})`).replace(new RegExp(`xlink:href="#${n}"`, "g"), `xlink:href="#${i}"`).replace(new RegExp(`href="#${n}"`, "g"), `href="#${i}"`);
    }
    return s;
}, $824dfa427d37e8f5$var$_ = new Set, $824dfa427d37e8f5$var$v = /\s(?:id|xmlns|viewBox|width|height)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s"'>]+)/g, $824dfa427d37e8f5$export$510fb280711ea968 = (e, t)=>{
    const r = t && t.default ? t.default : t;
    if (!(0, $czfS0.isString)(r)) return $824dfa427d37e8f5$var$S && !$824dfa427d37e8f5$var$_.has(e) && $824dfa427d37e8f5$var$_.add(e), "";
    t = r;
    const s = t.match(/^<symbol\b[^>]*\bid="([^"]*)"/);
    if (s) {
        const c = s[1];
        return c === e ? t : t.replace(`id="${c}"`, `id="${e}"`);
    }
    const o = $824dfa427d37e8f5$var$$(t), { width: n, height: i } = o, a = o.viewBox || `0 0 ${n || 24} ${i || 24}`, g = "http://www.w3.org/2000/svg", f = $824dfa427d37e8f5$var$d(t, e), p = `<symbol id="${e}" xmlns="${g}" viewBox="${a}"`;
    let l = f.replace("<svg", p);
    return l = l.replace(/^<symbol\b[^>]*>/, (c)=>p + c.slice(p.length).replace($824dfa427d37e8f5$var$v, "")), l = l.replace("</svg", "</symbol"), l = $824dfa427d37e8f5$var$b(l), l;
}, $824dfa427d37e8f5$var$m = "line|circle|ellipse|rect|polyline|polygon|path|stop|use|image", $824dfa427d37e8f5$var$x = new RegExp(`<(${$824dfa427d37e8f5$var$m})\\b([^>]*?)\\s*/>`, "g"), $824dfa427d37e8f5$var$b = (e)=>e.replace($824dfa427d37e8f5$var$x, "<$1$2></$1>");

});


parcelRegister("jPKwi", function(module, exports) {
$parcel$export(module.exports, "getColor", () => (parcelRequire("5koEk")).getColor);
$parcel$export(module.exports, "getMediaColor", () => (parcelRequire("5koEk")).getMediaColor);
$parcel$export(module.exports, "inForcedColors", () => (parcelRequire("5koEk")).inForcedColors);
$parcel$export(module.exports, "isForcedColorsQuery", () => (parcelRequire("5koEk")).isForcedColorsQuery);
$parcel$export(module.exports, "literalPairCompound", () => (parcelRequire("5koEk")).literalPairCompound);
$parcel$export(module.exports, "resolveColorRgb", () => (parcelRequire("5koEk")).resolveColorRgb);
$parcel$export(module.exports, "resolveColorsInGradient", () => (parcelRequire("5koEk")).resolveColorsInGradient);
$parcel$export(module.exports, "setColor", () => (parcelRequire("5koEk")).setColor);
$parcel$export(module.exports, "setGradient", () => (parcelRequire("5koEk")).setGradient);
$parcel$export(module.exports, "getSafeInkInfo", () => (parcelRequire("9z5MX")).getSafeInkInfo);
$parcel$export(module.exports, "getMediaTheme", () => (parcelRequire("habKp")).getMediaTheme);
$parcel$export(module.exports, "setTheme", () => (parcelRequire("habKp")).setTheme);
$parcel$export(module.exports, "getFontFamily", () => (parcelRequire("amQH3")).getFontFamily);
$parcel$export(module.exports, "setFont", () => (parcelRequire("amQH3")).setFont);
$parcel$export(module.exports, "setFontFamily", () => (parcelRequire("amQH3")).setFontFamily);
$parcel$export(module.exports, "applyTypographySequence", () => (parcelRequire("13hKf")).applyTypographySequence);
$parcel$export(module.exports, "getFontSizeByKey", () => (parcelRequire("13hKf")).getFontSizeByKey);
$parcel$export(module.exports, "applySpacingSequence", () => (parcelRequire("amsMb")).applySpacingSequence);
$parcel$export(module.exports, "checkIfBoxSize", () => (parcelRequire("amsMb")).checkIfBoxSize);
$parcel$export(module.exports, "getSpacingBasedOnRatio", () => (parcelRequire("amsMb")).getSpacingBasedOnRatio);
$parcel$export(module.exports, "getSpacingByKey", () => (parcelRequire("amsMb")).getSpacingByKey);
$parcel$export(module.exports, "splitSpacedValue", () => (parcelRequire("amsMb")).splitSpacedValue);
$parcel$export(module.exports, "getShapeByKey", () => (parcelRequire("bvD2U")).getShapeByKey);
$parcel$export(module.exports, "getShadow", () => (parcelRequire("iSfnd")).getShadow);
$parcel$export(module.exports, "resolveShadowNonColorWord", () => (parcelRequire("iSfnd")).resolveShadowNonColorWord);
$parcel$export(module.exports, "setShadow", () => (parcelRequire("iSfnd")).setShadow);
$parcel$export(module.exports, "getMediaBorder", () => (parcelRequire("8OSGX")).getMediaBorder);
$parcel$export(module.exports, "applyTimingSequence", () => (parcelRequire("ZN2Fd")).applyTimingSequence);
$parcel$export(module.exports, "getTimingByKey", () => (parcelRequire("ZN2Fd")).getTimingByKey);
$parcel$export(module.exports, "getTimingFunction", () => (parcelRequire("ZN2Fd")).getTimingFunction);
$parcel$export(module.exports, "applyDocument", () => (parcelRequire("4MQe6")).applyDocument);
$parcel$export(module.exports, "setSVG", () => (parcelRequire("dxw8L")).setSVG);
$parcel$export(module.exports, "setSvgIcon", () => (parcelRequire("dxw8L")).setSvgIcon);
$parcel$export(module.exports, "applyReset", () => (parcelRequire("9rUXD")).applyReset);
$parcel$export(module.exports, "applySkins", () => (parcelRequire("aejgr")).applySkins);
parcelRequire("5koEk");
parcelRequire("9z5MX");
parcelRequire("habKp");
parcelRequire("amQH3");
parcelRequire("13hKf");
parcelRequire("amsMb");
parcelRequire("bvD2U");
parcelRequire("iSfnd");
parcelRequire("8OSGX");
parcelRequire("ZN2Fd");
parcelRequire("4MQe6");
parcelRequire("dxw8L");
parcelRequire("9rUXD");
parcelRequire("aejgr");

});
parcelRegister("5koEk", function(module, exports) {

$parcel$export(module.exports, "inForcedColors", () => $3e11f0e20c6282f9$export$26cb3f7e0960c23);
$parcel$export(module.exports, "isForcedColorsQuery", () => $3e11f0e20c6282f9$export$599f51e75dd49e36);
$parcel$export(module.exports, "isIntendedSystemColorWord", () => $3e11f0e20c6282f9$export$6075b420d52b275c);
$parcel$export(module.exports, "isPlainColor", () => $3e11f0e20c6282f9$export$6abc817e7600e2b);
$parcel$export(module.exports, "quietColorProbe", () => $3e11f0e20c6282f9$export$a337d6eb0a24bf94);
$parcel$export(module.exports, "getColor", () => $3e11f0e20c6282f9$export$5551a2d24ff40153);
$parcel$export(module.exports, "resolveColorRgb", () => $3e11f0e20c6282f9$export$4d6cf1e3229e7a3b);
$parcel$export(module.exports, "atSchemes", () => $3e11f0e20c6282f9$export$e25d08d9354282d3);
$parcel$export(module.exports, "literalSchemeMap", () => $3e11f0e20c6282f9$export$8ff9d4066740145c);
$parcel$export(module.exports, "forcedScheme", () => $3e11f0e20c6282f9$export$e88d67a1002afb4e);
$parcel$export(module.exports, "literalPairCompound", () => $3e11f0e20c6282f9$export$cd9ae74134f69e26);
$parcel$export(module.exports, "getMediaColor", () => $3e11f0e20c6282f9$export$dd72f6d9deea7207);
$parcel$export(module.exports, "setAdaptiveSchemeVar", () => $3e11f0e20c6282f9$export$6179fb1c49c5dc83);
$parcel$export(module.exports, "setColor", () => $3e11f0e20c6282f9$export$130a5dc1bc9cd8e1);
$parcel$export(module.exports, "resolveColorsInGradient", () => $3e11f0e20c6282f9$export$74ec263a34bf386a);
$parcel$export(module.exports, "setGradient", () => $3e11f0e20c6282f9$export$afaa8352c6a43a44);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");
parcelRequire("aV26F");
var $hzNzB = parcelRequire("hzNzB");
const $3e11f0e20c6282f9$export$3f1e8d3581622c57 = {
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)"
}, $3e11f0e20c6282f9$export$e638740829b70811 = (e, r)=>{
    const n = r.media && r.media[e] || $3e11f0e20c6282f9$export$3f1e8d3581622c57[e];
    return n ? "@media " + (n === "print" ? `${n}` : `screen and ${n}`) : null;
}, $3e11f0e20c6282f9$export$34b841a2d9d0e0b1 = (e)=>{
    const r = e.scopeSelector || ":root";
    return `${r === ":root" ? ":root:not([data-theme])" : `:root:not([data-theme]) ${r}:not([data-theme])`} &`;
}, $3e11f0e20c6282f9$var$$ = new Set, $3e11f0e20c6282f9$var$F = new Set([
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkgrey",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkslategrey",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dimgrey",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "green",
    "greenyellow",
    "grey",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightslategrey",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "slategrey",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
]), $3e11f0e20c6282f9$var$q = [
    "AccentColor",
    "AccentColorText",
    "ActiveText",
    "ButtonBorder",
    "ButtonFace",
    "ButtonText",
    "Canvas",
    "CanvasText",
    "Field",
    "FieldText",
    "GrayText",
    "Highlight",
    "HighlightText",
    "LinkText",
    "Mark",
    "MarkText",
    "SelectedItem",
    "SelectedItemText",
    "VisitedText",
    "ActiveBorder",
    "ActiveCaption",
    "AppWorkspace",
    "Background",
    "ButtonHighlight",
    "ButtonShadow",
    "CaptionText",
    "InactiveBorder",
    "InactiveCaption",
    "InactiveCaptionText",
    "InfoBackground",
    "InfoText",
    "Menu",
    "MenuText",
    "Scrollbar",
    "ThreeDDarkShadow",
    "ThreeDFace",
    "ThreeDHighlight",
    "ThreeDLightShadow",
    "ThreeDShadow",
    "Window",
    "WindowFrame",
    "WindowText"
], $3e11f0e20c6282f9$var$W = new Set($3e11f0e20c6282f9$var$q.map((e)=>e.toLowerCase())), $3e11f0e20c6282f9$var$ce = new Set($3e11f0e20c6282f9$var$q);
let $3e11f0e20c6282f9$var$P = 0;
const $3e11f0e20c6282f9$export$26cb3f7e0960c23 = (e)=>{
    $3e11f0e20c6282f9$var$P++;
    try {
        return e();
    } finally{
        $3e11f0e20c6282f9$var$P--;
    }
}, $3e11f0e20c6282f9$var$de = /(^|[^\w-])(not\s+)?\(\s*forced-colors\s*(?::\s*(active|none)\s*)?\)/i, $3e11f0e20c6282f9$export$599f51e75dd49e36 = (e)=>{
    if (!(0, $czfS0.isString)(e)) return !1;
    const r = e.match($3e11f0e20c6282f9$var$de);
    return !r || r[2] || r[3] && r[3].toLowerCase() === "none" ? !1 : !/^\s*(?:@media\s+)?not\b/i.test(e);
}, $3e11f0e20c6282f9$var$H = (e)=>$3e11f0e20c6282f9$var$P > 0 || $3e11f0e20c6282f9$var$ce.has(e), $3e11f0e20c6282f9$export$6075b420d52b275c = (e)=>(0, $czfS0.isString)(e) && $3e11f0e20c6282f9$var$W.has(e.toLowerCase()) && $3e11f0e20c6282f9$var$H(e), $3e11f0e20c6282f9$var$ue = /^(?:#[0-9a-f]{3,8}$|(?:rgba?|hsla?|hwb|lab|lch|oklab|oklch|color|color-mix)\()/i, $3e11f0e20c6282f9$var$fe = /gradient\(|url\(|image-set\(|var\(/i, $3e11f0e20c6282f9$var$he = new Set([
    "transparent",
    "currentColor",
    "currentcolor"
]), $3e11f0e20c6282f9$export$6abc817e7600e2b = (e)=>{
    if (!(0, $czfS0.isString)(e)) return !1;
    const r = e.trim();
    return $3e11f0e20c6282f9$var$fe.test(r) ? !1 : $3e11f0e20c6282f9$var$ue.test(r) ? !0 : $3e11f0e20c6282f9$var$F.has(r) || $3e11f0e20c6282f9$var$he.has(r);
}, $3e11f0e20c6282f9$var$E = new Set, $3e11f0e20c6282f9$var$Y = (e)=>{
    if (!e) return !1;
    const { color: r, gradient: n } = e;
    return !!((0, $czfS0.isObject)(r) && Object.keys(r).length || (0, $czfS0.isObject)(n) && Object.keys(n).length);
}, $3e11f0e20c6282f9$var$Q = new Set;
let $3e11f0e20c6282f9$var$B = 0;
const $3e11f0e20c6282f9$export$a337d6eb0a24bf94 = (e)=>{
    $3e11f0e20c6282f9$var$B++;
    try {
        return e();
    } finally{
        $3e11f0e20c6282f9$var$B--;
    }
}, $3e11f0e20c6282f9$var$ge = (e, r)=>{
    if (!(0, $czfS0.isString)(e) || e.indexOf(" ") === -1) return null;
    const n = e.replace(/\s+/g, ""), t = (0, $hzNzB.parseColorToken)(n);
    if (!t || t.passthrough || t.cssVar) return null;
    const { color: o, gradient: s } = r;
    return !o[t.name] && !s[t.name] ? null : n;
}, $3e11f0e20c6282f9$var$v = (e, r, n)=>{
    const t = $3e11f0e20c6282f9$var$ge(e, n);
    if (t) {
        if (!$3e11f0e20c6282f9$var$Q.has(e)) {
            $3e11f0e20c6282f9$var$Q.add(e);
            const d = n && n.name ? ` (design system \`${n.name}\`)` : "";
        }
        return;
    }
    const o = (0, $hzNzB.parseColorToken)(e);
    if (o && o.name && !o.passthrough && !o.cssVar && (o.alpha !== void 0 || o.tone !== void 0) && $3e11f0e20c6282f9$var$Y(n) && !n.color[o.name] && !n.gradient[o.name]) {
        if (!$3e11f0e20c6282f9$var$B && !$3e11f0e20c6282f9$var$E.has(e)) {
            $3e11f0e20c6282f9$var$E.add(e);
            const d = n && n.name ? ` (design system \`${n.name}\`)` : "";
        }
        return;
    }
    const s = (0, $czfS0.isString)(r) ? r.toLowerCase() : "", i = $3e11f0e20c6282f9$var$W.has(s);
    if (!$3e11f0e20c6282f9$var$F.has(s) && !i || i && $3e11f0e20c6282f9$var$H(r) || !$3e11f0e20c6282f9$var$Y(n)) return e;
    if (!$3e11f0e20c6282f9$var$E.has(s)) {
        $3e11f0e20c6282f9$var$E.add(s);
        const d = n && n.name ? ` (design system \`${n.name}\`)` : "";
    }
}, $3e11f0e20c6282f9$var$K = (e, r, n)=>{
    const t = r !== void 0 ? r : 1;
    if (!n) return `rgb(from ${e} r g b / ${t})`;
    if (n.charCodeAt(0) === 43 || n.charCodeAt(0) === 45) {
        const s = parseFloat(n), i = s < 0 ? "-" : "+", d = Math.abs(s);
        return `rgb(from ${e} calc(r ${i} ${d}) calc(g ${i} ${d}) calc(b ${i} ${d}) / ${t})`;
    }
    return `hsl(from ${e} h s ${n}% / ${t})`;
}, $3e11f0e20c6282f9$export$5551a2d24ff40153 = (e, r, n)=>{
    const t = n || (0, $521xJ.getActiveConfig)();
    if (!(0, $czfS0.isString)(e)) {
        t.verbose;
        return;
    }
    if ((0, $hzNzB.isCSSVar)(e)) return `var(${e})`;
    r && e[r] && (e = e[r]);
    let o, s, i;
    if ((0, $czfS0.isArray)(e)) [o, s, i] = e;
    else {
        const l = (0, $hzNzB.parseColorToken)(e);
        if (!l) {
            const { color: u, gradient: w } = t;
            let T = w[e] || u[e];
            return T ? (r && T[r] && (T = T[r]), t.useVariable ? `var(${T.var})` : T.value) : $3e11f0e20c6282f9$var$v(e, e, t);
        }
        if (l.passthrough) return l.passthrough;
        if (l.cssVar) return `var(${l.cssVar})`;
        o = l.name, s = l.alpha, i = l.tone;
    }
    const { color: d, gradient: c } = t;
    let a = d[o] || c[o];
    if (!a) return $3e11f0e20c6282f9$var$v(e, o, t);
    if (r) {
        if (a[r] !== void 0) a = a[r];
        else if ((0, $czfS0.isArray)(a)) {
            const l = r.charCodeAt(0) === 64 ? r.slice(1) : r;
            l === "dark" ? a = a[1] !== void 0 ? a[1] : a[0] : (l !== "light" && t.verbose, a = a[0]);
        } else t.verbose;
    }
    if ((0, $czfS0.isString)(a)) {
        if ($3e11f0e20c6282f9$var$$.has(o)) return a;
        $3e11f0e20c6282f9$var$$.add(o);
        try {
            return $3e11f0e20c6282f9$export$5551a2d24ff40153(a, null, n);
        } finally{
            $3e11f0e20c6282f9$var$$.delete(o);
        }
    }
    let f = a.rgb;
    if (!f) {
        const l = t.useVariable ? `var(${a.var})` : a.value;
        return (s || i) && l ? $3e11f0e20c6282f9$var$K(l, s, i) : l;
    }
    return i && !a[i] && (f = (0, $hzNzB.getRgbTone)(f, i), a[i] = {
        rgb: f,
        var: `${a.var}-${i}`
    }), a[i] && (f = a[i].rgb), s ? `rgba(${f}, ${s})` : i ? `rgba(${f}, ${a.alpha !== void 0 ? a.alpha : 1})` : t.useVariable ? `var(${a.var})` : a.value !== void 0 ? a.value : `rgb(${f})`;
}, $3e11f0e20c6282f9$var$U = (e)=>{
    const r = (0, $hzNzB.colorStringToRgbaArray)(e);
    return !r || r.length < 3 || r[0] === 0 && r[1] === 0 && r[2] === 0 && r[3] === 0 && e.toLowerCase() !== "transparent" ? null : {
        rgb: [
            r[0],
            r[1],
            r[2]
        ],
        alpha: r[3] !== void 0 ? r[3] : 1
    };
}, $3e11f0e20c6282f9$var$pe = (e, r)=>{
    if (!r) return e;
    let n = e.rgb;
    if (r.tone) {
        const o = (0, $hzNzB.getRgbTone)(n, r.tone);
        n = (0, $czfS0.isString)(o) ? o.split(",").map((s)=>parseFloat(s.trim())) : o;
    }
    const t = r.alpha !== void 0 ? parseFloat(r.alpha) : e.alpha;
    return {
        rgb: n,
        alpha: t
    };
}, $3e11f0e20c6282f9$export$4d6cf1e3229e7a3b = (e, r, n)=>{
    const t = r || (0, $521xJ.getActiveConfig)();
    if (!(0, $czfS0.isString)(e)) return null;
    const o = (0, $hzNzB.parseColorToken)(e);
    if (o) {
        if (o.passthrough) {
            const u = (0, $hzNzB.colorStringToRgbaArray)(o.passthrough);
            return u && u.length >= 3 ? {
                rgb: [
                    u[0],
                    u[1],
                    u[2]
                ],
                alpha: u[3] !== void 0 ? u[3] : 1
            } : null;
        }
        if (o.cssVar) return null;
    }
    const s = o ? o.name : e, { color: i, gradient: d } = t;
    let c = i[s] || d[s];
    if (!c) return $3e11f0e20c6282f9$var$U(e);
    if ((0, $czfS0.isString)(c)) {
        let u;
        if ($3e11f0e20c6282f9$var$$.has(s)) u = $3e11f0e20c6282f9$var$U(c);
        else {
            $3e11f0e20c6282f9$var$$.add(s);
            try {
                u = $3e11f0e20c6282f9$export$4d6cf1e3229e7a3b(c, t, n);
            } finally{
                $3e11f0e20c6282f9$var$$.delete(s);
            }
        }
        return u ? $3e11f0e20c6282f9$var$pe(u, o) : null;
    }
    if (c.rgb === void 0 && (0, $czfS0.isObject)(c)) {
        const u = `@${n || "light"}`;
        c = c[u] !== void 0 ? c[u] : c["@light"];
    }
    if (!c || c.rgb === void 0) return null;
    let a = c.rgb;
    o && o.tone && (a = (0, $hzNzB.getRgbTone)(a, o.tone));
    const f = (0, $czfS0.isString)(a) ? a.split(",").map((u)=>parseFloat(u.trim())) : a, l = o && o.alpha !== void 0 ? parseFloat(o.alpha) : c.alpha !== void 0 ? c.alpha : 1;
    return {
        rgb: f,
        alpha: l
    };
}, $3e11f0e20c6282f9$var$z = (e)=>(0, $czfS0.isObject)(e) && e.value !== void 0 && (e.rgb !== void 0 || e.var !== void 0), $3e11f0e20c6282f9$export$e25d08d9354282d3 = (e)=>{
    const r = [];
    for(const n in e)n.charCodeAt(0) === 64 && r.push(n.slice(1));
    return r;
}, $3e11f0e20c6282f9$var$j = (e)=>{
    if (!(0, $czfS0.isObject)(e) || e.value !== void 0) return null;
    for(const n in e)if (n !== "var" && (n.charCodeAt(0) !== 64 || !$3e11f0e20c6282f9$var$z(e[n]))) return null;
    const r = $3e11f0e20c6282f9$export$e25d08d9354282d3(e);
    return r.length ? r : null;
}, $3e11f0e20c6282f9$var$be = (e)=>(0, $czfS0.isString)(e && e.var) && $3e11f0e20c6282f9$var$j(e) !== null, $3e11f0e20c6282f9$var$Se = (e, r, n, t, o)=>{
    const s = $3e11f0e20c6282f9$var$j(r);
    if (!s) return;
    if ((0, $czfS0.isString)(r.var)) {
        const c = `var(${r.var})`;
        return n || t ? $3e11f0e20c6282f9$var$K(c, n, t) : c;
    }
    if (s.length !== 2 || !s.includes("light") || !s.includes("dark")) return;
    const i = $3e11f0e20c6282f9$export$5551a2d24ff40153(e, "@light", o), d = $3e11f0e20c6282f9$export$5551a2d24ff40153(e, "@dark", o);
    if (!(!$3e11f0e20c6282f9$export$6abc817e7600e2b(i) || !$3e11f0e20c6282f9$export$6abc817e7600e2b(d))) return i === d ? i : `light-dark(${i}, ${d})`;
}, $3e11f0e20c6282f9$export$6c67cfdb17a5c187 = (e, r)=>{
    if (!e) return null;
    const n = r || (0, $521xJ.getActiveConfig)(), t = (0, $hzNzB.parseColorToken)(e), o = t ? t.name : e, s = o && n.color && n.color[o];
    if ((0, $czfS0.isArray)(s)) return [
        "light",
        "dark"
    ];
    if (!(0, $czfS0.isObject)(s) || s.value !== void 0) return null;
    const i = $3e11f0e20c6282f9$export$e25d08d9354282d3(s);
    return i.length ? i : null;
}, $3e11f0e20c6282f9$export$8ff9d4066740145c = (e, r, n)=>{
    const t = {}, o = $3e11f0e20c6282f9$export$34b841a2d9d0e0b1(r);
    for (const s of e){
        const i = n(s);
        if (i !== void 0 && (t[`[data-theme="${s}"] &`] = i, s === "light" || s === "dark")) {
            const d = $3e11f0e20c6282f9$export$e638740829b70811(s, r);
            d && (t[d] = {
                [o]: i
            });
        }
    }
    return t;
}, $3e11f0e20c6282f9$export$e88d67a1002afb4e = (e, r)=>e || (r.globalTheme === "auto" ? null : r.globalTheme), $3e11f0e20c6282f9$export$cd9ae74134f69e26 = (e, r, n, { commas: t, resolve: o, resolveScheme: s })=>{
    const i = (0, $hzNzB.compoundLayers)(e, t);
    let d = null;
    for (const f of i)for (const l of f){
        const u = $3e11f0e20c6282f9$export$6c67cfdb17a5c187(l, n);
        if (u) for (const w of u)(d || (d = [])).includes(w) || d.push(w);
    }
    if (!d) return;
    const c = (f)=>(0, $hzNzB.joinCompoundLayers)(i.map((l)=>l.map((u)=>{
                if (!$3e11f0e20c6282f9$export$6c67cfdb17a5c187(u, n)) return u;
                const w = f(u);
                return (0, $czfS0.isString)(w) ? w : u;
            }))), a = $3e11f0e20c6282f9$export$e88d67a1002afb4e(r, n);
    return a ? o(c((f)=>$3e11f0e20c6282f9$export$dd72f6d9deea7207(f, a, n)), a) : $3e11f0e20c6282f9$export$8ff9d4066740145c(d, n, (f)=>s(f, c));
}, $3e11f0e20c6282f9$export$dd72f6d9deea7207 = (e, r, n)=>{
    const t = n || (0, $521xJ.getActiveConfig)();
    if (r = $3e11f0e20c6282f9$export$e88d67a1002afb4e(r, t), !(0, $czfS0.isString)(e)) {
        t.verbose;
        return;
    }
    if ((0, $hzNzB.isCSSVar)(e)) return `var(${e})`;
    let o, s, i;
    if ((0, $czfS0.isArray)(e)) o = e[0];
    else {
        const l = (0, $hzNzB.parseColorToken)(e);
        if (l) {
            if (l.passthrough) return l.passthrough;
            if (l.cssVar) return `var(${l.cssVar})`;
            o = l.name, s = l.alpha, i = l.tone;
        } else o = e;
    }
    const { color: d, gradient: c } = t, a = d[o] || c[o], f = (0, $czfS0.isObject)(a);
    if (f && a.value) return $3e11f0e20c6282f9$export$5551a2d24ff40153(e, `@${r}`, n);
    if (f) {
        if (t.useVariable && a.var) return s || i ? $3e11f0e20c6282f9$export$5551a2d24ff40153(e, null, n) : `var(${a.var})`;
        if (r) {
            if (!t.useVariable && d[o] === a) {
                const l = $3e11f0e20c6282f9$var$Se(e, a, s, i, n);
                if (l !== void 0) return l;
            }
            return $3e11f0e20c6282f9$export$5551a2d24ff40153(e, `@${r}`, n);
        } else return $3e11f0e20c6282f9$export$8ff9d4066740145c($3e11f0e20c6282f9$export$e25d08d9354282d3(a), t, (l)=>$3e11f0e20c6282f9$export$5551a2d24ff40153(e, "@" + l, n));
    } else return $3e11f0e20c6282f9$var$v(e, o, t);
}, $3e11f0e20c6282f9$export$6179fb1c49c5dc83 = (e, r, n, t)=>{
    const s = `--${t.varPrefix ? t.varPrefix + "-" : ""}${r}-${n}`;
    let i;
    const d = {};
    for(const c in e){
        if (c.charCodeAt(0) !== 64) continue;
        const a = c.slice(1), f = e[c], l = f && (f.value || f);
        !l || typeof l != "string" || (d[a] = l, (a === "light" || i === void 0) && (i = l));
    }
    if (i !== void 0) {
        t.cssVars[s] = i, t.cssMediaVars || (t.cssMediaVars = {});
        for(const c in d){
            const a = `[data-theme="${c}"]`;
            if (t.cssMediaVars[a] || (t.cssMediaVars[a] = {}), t.cssMediaVars[a][s] = d[c], c === "light" || c === "dark") {
                const f = `@media (prefers-color-scheme: ${c})`;
                t.cssMediaVars[f] || (t.cssMediaVars[f] = {}), t.cssMediaVars[f][s] = d[c];
            }
        }
        return e.var = s, s;
    }
}, $3e11f0e20c6282f9$export$130a5dc1bc9cd8e1 = (e, r, n)=>{
    const t = (0, $521xJ.getActiveConfig)();
    if ($3e11f0e20c6282f9$var$z(e)) return t.useVariable && e.var && (t.cssVars[e.var] = e.value), e;
    if (!t.useVariable && $3e11f0e20c6282f9$var$be(e)) return e;
    if ((0, $czfS0.isString)(e) && (0, $hzNzB.isCSSVar)(e)) {
        const h = e.slice(2), m = h.trim().indexOf(" ") !== -1;
        if (e = m ? h : $3e11f0e20c6282f9$export$5551a2d24ff40153(h), m || !(e.includes("rgb") || e.includes("var") || e.includes("#"))) {
            const g = h.trim().split(/\s+/);
            let b = t.color[g[0]];
            if (b && !b.value && !b.rgb && ((0, $czfS0.isString)(b) || (0, $czfS0.isArray)(b) || (0, $czfS0.isObject)(b)) && !$3e11f0e20c6282f9$var$$.has(g[0])) {
                $3e11f0e20c6282f9$var$$.add(g[0]);
                try {
                    t.color[g[0]] = $3e11f0e20c6282f9$export$130a5dc1bc9cd8e1(b, g[0]);
                } finally{
                    $3e11f0e20c6282f9$var$$.delete(g[0]);
                }
                b = t.color[g[0]];
            }
            if (b && b.value) {
                let S = b.rgb;
                const V = g[1] !== void 0 ? g[1] : "1", C = g[2];
                C && (S = (0, $hzNzB.getRgbTone)(S, C)), e = `rgba(${S}, ${V})`;
            } else {
                const S = g[2], V = g[1] !== void 0 ? g[1] : "1";
                if (S) try {
                    const C = (0, $hzNzB.colorStringToRgbaArray)(g[0]);
                    C && C.length >= 3 ? e = `rgba(${(0, $hzNzB.getRgbTone)(C.slice(0, 3).join(", "), S)}, ${V})` : e = g[0];
                } catch  {
                    e = g[0];
                }
                else e = g[0];
            }
        }
    }
    if ((0, $czfS0.isArray)(e) && (e = {
        "@light": e[0],
        "@dark": e[1] !== void 0 ? e[1] : e[0]
    }), (0, $czfS0.isObject)(e)) {
        const h = {};
        for(const m in e)m !== "var" && (h[m] = $3e11f0e20c6282f9$export$130a5dc1bc9cd8e1(e[m], r, m.slice(0, 1) === "@" ? m.slice(1) : m));
        return t.useVariable && $3e11f0e20c6282f9$export$6179fb1c49c5dc83(h, "color", r, t), h;
    }
    const s = `--${t.varPrefix ? t.varPrefix + "-" : ""}color-${r}` + (n ? `-${n}` : "");
    let i = e.value || e;
    if ((0, $czfS0.isString)(i) && !i.includes("(") && !i.startsWith("#")) {
        const h = (0, $hzNzB.parseColorToken)(i);
        if (h && h.name && !h.passthrough && !h.cssVar) {
            const m = t.color[h.name];
            if (m && !m.value && !m.rgb && ((0, $czfS0.isString)(m) || (0, $czfS0.isArray)(m) || (0, $czfS0.isObject)(m)) && !$3e11f0e20c6282f9$var$$.has(h.name)) {
                $3e11f0e20c6282f9$var$$.add(h.name);
                try {
                    t.color[h.name] = $3e11f0e20c6282f9$export$130a5dc1bc9cd8e1(m, h.name);
                } finally{
                    $3e11f0e20c6282f9$var$$.delete(h.name);
                }
            }
            const g = t.color[h.name], b = $3e11f0e20c6282f9$var$j(g);
            if (b) {
                if (h.alpha === void 0 && h.tone === void 0) return g;
                const S = {};
                for (const V of b){
                    const C = g["@" + V];
                    let O = C.rgb;
                    h.tone && (O = (0, $hzNzB.getRgbTone)(O, h.tone));
                    const ee = h.alpha !== void 0 ? parseFloat(h.alpha) : C.alpha !== void 0 ? C.alpha : 1;
                    S["@" + V] = `rgba(${O}, ${ee})`;
                }
                return $3e11f0e20c6282f9$export$130a5dc1bc9cd8e1(S, r, n);
            }
            if (g && g.rgb) {
                let S = g.rgb;
                h.tone && (S = (0, $hzNzB.getRgbTone)(S, h.tone));
                const V = h.alpha !== void 0 ? parseFloat(h.alpha) : g.alpha !== void 0 ? g.alpha : 1;
                i = `rgba(${S}, ${V})`;
            }
        }
    }
    const d = (0, $hzNzB.colorStringToRgbaArray)(i), [c, a, f, l = 1] = d, u = parseFloat(l.toFixed(2)), w = `${c}, ${a}, ${f}`, T = `rgba(${w}, ${u})`;
    return t.useVariable && (t.cssVars[s] = T), {
        var: s,
        rgb: w,
        alpha: u,
        value: T
    };
}, $3e11f0e20c6282f9$var$$e = new Set([
    "to",
    "top",
    "bottom",
    "left",
    "right",
    "center",
    "at",
    "circle",
    "ellipse",
    "closest-side",
    "farthest-side",
    "closest-corner",
    "farthest-corner"
]), $3e11f0e20c6282f9$export$74ec263a34bf386a = (e, r)=>{
    const n = e.indexOf("(");
    if (n === -1) return e;
    const t = e.slice(0, n + 1), o = e.slice(n + 1, e.lastIndexOf(")")), s = ")", i = (0, $hzNzB.splitTopLevelCommas)(o);
    let d = !1;
    const c = i.map((a)=>(a = a.trim(), a.split(/\s+/).map((l)=>{
            if (!l || /^\d/.test(l) || l === "0" || $3e11f0e20c6282f9$var$$e.has(l) || l === "transparent" || (0, $hzNzB.CSS_NATIVE_COLOR_REGEX).test(l)) return l;
            const u = $3e11f0e20c6282f9$export$5551a2d24ff40153(l);
            return (0, $hzNzB.isResolvedColor)(u) ? (d = !0, u) : l;
        }).join(" ")));
    return d ? t + c.join(", ") + s : e;
}, $3e11f0e20c6282f9$export$afaa8352c6a43a44 = (e, r, n)=>{
    const t = (0, $521xJ.getActiveConfig)();
    if ((0, $czfS0.isObject)(e) && e.value !== void 0 && e.var !== void 0) return t.useVariable && (t.cssVars[e.var] = e.value), e;
    if ((0, $czfS0.isString)(e) && (0, $hzNzB.isCSSVar)(e) && (e = $3e11f0e20c6282f9$export$5551a2d24ff40153(e.slice(2))), (0, $czfS0.isArray)(e) && (e = {
        "@light": e[0],
        "@dark": e[1] !== void 0 ? e[1] : e[0]
    }), (0, $czfS0.isObject)(e)) {
        const d = {};
        for(const c in e)c !== "var" && (d[c] = $3e11f0e20c6282f9$export$afaa8352c6a43a44(e[c], r, c.slice(0, 1) === "@" ? c.slice(1) : c));
        return t.useVariable && $3e11f0e20c6282f9$export$6179fb1c49c5dc83(d, "gradient", r, t), d;
    }
    const s = `--${t.varPrefix ? t.varPrefix + "-" : ""}gradient-${r}` + (n ? `-${n}` : ""), i = $3e11f0e20c6282f9$export$74ec263a34bf386a(e.value || e);
    return t.useVariable && (t.cssVars[s] = i), {
        var: s,
        value: i
    };
};

});

parcelRegister("9z5MX", function(module, exports) {

$parcel$export(module.exports, "getSafeInkInfo", () => $6f6bdf74a368bc59$export$17af7ca0cee6923b);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");


var $521xJ = parcelRequire("521xJ");
parcelRequire("aV26F");
var $hzNzB = parcelRequire("hzNzB");

var $5koEk = parcelRequire("5koEk");
const $6f6bdf74a368bc59$export$72536d38747a8aa7 = (s, a, g = {}, m)=>{
    const r = m || (0, $521xJ.getActiveConfig)(), { min: y = 4.5, large: A = !1, scheme: B, meta: G = !1, maxIterations: N = 15 } = g, b = A ? 3 : y, c = B || (r.globalTheme && r.globalTheme !== "auto" ? r.globalTheme : "light"), C = (0, $czfS0.isString)(a) ? a : String(a), f = (0, $hzNzB.parseColorToken)(s), O = f && !f.passthrough && !f.cssVar ? f.name : null, u = (e, t)=>G ? {
            value: e,
            ...t
        } : e;
    if (O) {
        const e = r.color[`${O}Safe`];
        if (e) {
            const t = `${C}@${c}`, o = e[t] !== void 0 ? e[t] : e[C];
            if (o !== void 0) {
                const I = o && o.rgb !== void 0 ? r.useVariable && o.var ? `var(${o.var})` : o.value : (0, $5koEk.getColor)(o, null, r);
                return u(I, {
                    ratio: null,
                    deviation: 0,
                    derived: !1,
                    overridden: !0
                });
            }
        }
    }
    const D = (0, $5koEk.getColor)(s, c ? `@${c}` : null, r), n = (0, $5koEk.resolveColorRgb)(s, r, c), h = (0, $5koEk.resolveColorRgb)(a, r, c);
    if (!n || !h) return r.verbose, u(D, {
        ratio: null,
        deviation: 0,
        derived: !1,
        overridden: !1,
        unresolved: !0
    });
    const d = (0, $hzNzB.compositeOverBackdrop)(h.rgb, h.alpha), T = (0, $hzNzB.compositeOverBackdrop)(n.rgb, n.alpha, d), v = (0, $hzNzB.contrastRatio)(T, d);
    if (v >= b - .02) return u(D, {
        ratio: v,
        deviation: 0,
        derived: !1,
        overridden: !1
    });
    const [i, V, j] = (0, $hzNzB.srgbToOklab)(n.rgb), [, E, K] = (0, $hzNzB.oklabToOklch)([
        i,
        V,
        j
    ]), R = (0, $hzNzB.relativeLuminance)(d) > .5, P = R ? i : 1 - i, $ = (e)=>{
        const t = R ? i - e : i + e, o = Math.max(0, Math.min(1, t));
        return {
            rgb: (0, $hzNzB.oklchToGamutSafeSrgb)(o, E, K),
            L: o
        };
    }, p = (e)=>{
        const { rgb: t } = $(e), o = (0, $hzNzB.compositeOverBackdrop)(t.map((I)=>Math.round(I)), n.alpha, d);
        return (0, $hzNzB.contrastRatio)(o, d);
    };
    let S = 0, l = P;
    const k = p(l) >= b;
    if (k) for(let e = 0; e < N; e++){
        const t = (S + l) / 2;
        p(t) >= b ? l = t : S = t;
    }
    else S = l;
    const { rgb: w, L: H } = $(l), _ = w.map((e)=>Math.round(e)), U = p(l), q = n.alpha < 1 ? `rgba(${_.join(", ")}, ${n.alpha})` : `rgb(${_.join(", ")})`, z = Math.abs(H - i) * 100;
    return u(q, {
        rgb: _,
        ratio: U,
        startRatio: v,
        deviation: z,
        derived: !0,
        overridden: !1,
        reachable: k
    });
}, $6f6bdf74a368bc59$export$17af7ca0cee6923b = (s, a, g = {}, m)=>$6f6bdf74a368bc59$export$72536d38747a8aa7(s, a, {
        ...g,
        meta: !0
    }, m);

});

parcelRegister("habKp", function(module, exports) {

$parcel$export(module.exports, "getMediaTheme", () => $c7ec7bab0bea2d28$export$b3cf7317de2f2233);
$parcel$export(module.exports, "setTheme", () => $c7ec7bab0bea2d28$export$2e49b867b7a0847c);

var $5koEk = parcelRequire("5koEk");

var $iSfnd = parcelRequire("iSfnd");

var $8OSGX = parcelRequire("8OSGX");

var $aejgr = parcelRequire("aejgr");

var $521xJ = parcelRequire("521xJ");

var $hzNzB = parcelRequire("hzNzB");
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
var $dSdIt = parcelRequire("dSdIt");
const $c7ec7bab0bea2d28$var$te = new Set([
    "black",
    "white",
    "red",
    "green",
    "blue",
    "yellow",
    "orange",
    "purple",
    "pink",
    "brown",
    "gray",
    "grey",
    "cyan",
    "magenta",
    "lime",
    "olive",
    "navy",
    "teal",
    "aqua",
    "maroon",
    "silver",
    "fuchsia",
    "transparent",
    "currentColor",
    "currentcolor",
    "inherit",
    "initial",
    "unset",
    "none",
    "aliceblue",
    "antiquewhite",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "blanchedalmond",
    "blueviolet",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkgrey",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkslategrey",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dimgrey",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightgrey",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightslategrey",
    "lightsteelblue",
    "lightyellow",
    "limegreen",
    "linen",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "oldlace",
    "olivedrab",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "plum",
    "powderblue",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "skyblue",
    "slateblue",
    "slategray",
    "slategrey",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "whitesmoke",
    "yellowgreen",
    "rebeccapurple"
]), $c7ec7bab0bea2d28$var$U = [
    "color",
    "Color",
    "background",
    "Background",
    "fill",
    "Fill",
    "stroke",
    "Stroke"
], $c7ec7bab0bea2d28$var$v = (e)=>{
    for(let n = 0; n < $c7ec7bab0bea2d28$var$U.length; n++)if (e.includes($c7ec7bab0bea2d28$var$U[n])) return !0;
    return !1;
}, $c7ec7bab0bea2d28$var$re = {
    boxShadow: (0, $iSfnd.resolveShadowValue),
    textShadow: (0, $iSfnd.resolveShadowValue),
    border: (0, $8OSGX.resolveBorderValue),
    borderTop: (0, $8OSGX.resolveBorderValue),
    borderRight: (0, $8OSGX.resolveBorderValue),
    borderBottom: (0, $8OSGX.resolveBorderValue),
    borderLeft: (0, $8OSGX.resolveBorderValue),
    outline: (0, $8OSGX.resolveBorderValue),
    columnRule: (0, $8OSGX.resolveBorderValue)
}, $c7ec7bab0bea2d28$var$ie = (e)=>{
    if (!e) return !1;
    const n = (0, $hzNzB.parseColorToken)(e);
    return !n || !n.name || n.passthrough || n.cssVar ? !1 : n.alpha !== void 0 || n.tone !== void 0;
}, $c7ec7bab0bea2d28$var$N = new Set, $c7ec7bab0bea2d28$var$se = (e, n, o, r, i, c)=>{
    if (!(0, $dSdIt.isLoudDevRuntime)()) return;
    const s = `${e}::${n}::${o || ""}::${r}`;
    $c7ec7bab0bea2d28$var$N.has(s) || ($c7ec7bab0bea2d28$var$N.add(s), console.warn(`[smbls/scratch] theme param "${n}" on "${e}"` + (o ? ` (${o})` : "") + ` did not fully resolve: "${r}" -> "${i}" still contains the unresolved token "${c}". This is not valid CSS \u2014 the browser will drop the whole declaration. Register "${c}" as a design-system color token or fix the typo.`));
}, $c7ec7bab0bea2d28$var$C = (e, n, o, r)=>{
    const i = $c7ec7bab0bea2d28$var$re[n];
    if (!i) return (0, $5koEk.getColor)(o, r);
    let c = null;
    const s = i(o, r, (g)=>{
        !c && $c7ec7bab0bea2d28$var$ie(g) && (c = g);
    });
    return c && $c7ec7bab0bea2d28$var$se(e, n, r, o, s, c), s;
}, $c7ec7bab0bea2d28$export$89cbf1a0881c8b9c = (e, n)=>$c7ec7bab0bea2d28$export$b3cf7317de2f2233(e, n), $c7ec7bab0bea2d28$var$ce = (e)=>(0, $czfS0.isObject)(e) && (0, $czfS0.isObjectLike)(e.value), $c7ec7bab0bea2d28$var$le = (e)=>{
    for(const n in e){
        const o = e[n];
        if ((0, $czfS0.isString)(o) && o.startsWith("var(--")) return !0;
    }
    return !1;
}, $c7ec7bab0bea2d28$export$2e49b867b7a0847c = (e, n)=>{
    const o = (0, $521xJ.getActiveConfig)();
    return $c7ec7bab0bea2d28$var$ce(e) ? !o.useVariable && $c7ec7bab0bea2d28$var$le(e) ? e : $c7ec7bab0bea2d28$export$c57b11cd015ce162(e.value, n) : $c7ec7bab0bea2d28$export$c57b11cd015ce162(e, n);
}, $c7ec7bab0bea2d28$var$K = (e, n)=>{
    const o = new Set;
    for (const r of n){
        const i = r.slice(0, 1);
        if (!(i === "@" || i === "." || i === ":") && $c7ec7bab0bea2d28$var$v(r)) for(const c in e){
            if (o.has(c)) continue;
            const s = e[c]?.[r];
            if (s === void 0) continue;
            const g = (0, $5koEk.getColor)(s, `@${c}`);
            g !== void 0 && (0, $czfS0.isString)(g) && /^[a-z][a-zA-Z]+$/.test(g) && !$c7ec7bab0bea2d28$var$te.has(g) && o.add(c);
        }
    }
    return o;
}, $c7ec7bab0bea2d28$var$Z = (e)=>e.startsWith("[data-theme=") || e.startsWith("[data-skin=") || e.startsWith("@media"), $c7ec7bab0bea2d28$var$V = (e, n)=>{
    for(const o in n){
        const r = n[o];
        (0, $czfS0.isObject)(r) ? $c7ec7bab0bea2d28$var$V(e[o] || (e[o] = {}), r) : e[o] = r;
    }
    return e;
}, $c7ec7bab0bea2d28$var$J = (e, n, o, r, i)=>$c7ec7bab0bea2d28$var$V(e, (0, $5koEk.literalSchemeMap)(r, i, (c)=>({
            [n]: o[c]
        }))), $c7ec7bab0bea2d28$var$Q = (e, n, o, r)=>{
    const i = {}, c = Object.keys(n).filter((l)=>n[l] !== o);
    if (!c.length) return o === void 0 ? void 0 : (i[e] = o, i);
    const s = n.light !== void 0 ? n.light : o, g = n.dark !== void 0 ? n.dark : o;
    if ($c7ec7bab0bea2d28$var$v(e) && (0, $5koEk.isPlainColor)(s) && (0, $5koEk.isPlainColor)(g)) {
        i[e] = s === g ? s : `light-dark(${s}, ${g})`;
        const l = Object.keys(n).filter((d)=>d !== "light" && d !== "dark");
        $c7ec7bab0bea2d28$var$J(i, e, n, l, r);
    } else o !== void 0 && (i[e] = o), $c7ec7bab0bea2d28$var$J(i, e, n, c, r);
    return i;
}, $c7ec7bab0bea2d28$var$ae = new Set([
    "backdropFilter",
    "WebkitBackdropFilter"
]), $c7ec7bab0bea2d28$var$X = new WeakSet, $c7ec7bab0bea2d28$var$Y = (e, n, o, r)=>{
    const i = o.globalTheme !== void 0 ? o.globalTheme : "auto", c = i && i !== "auto" ? String(i).replace(/^'|'$/g, "") : null, s = new Set(r ? Object.keys(r) : []);
    for(const d in e)if (e[d]) for (const a of Object.keys(e[d]))s.add(a);
    const g = $c7ec7bab0bea2d28$var$K(e, s), l = {};
    for (const d of s){
        const a = d.slice(0, 1);
        if (a === "@") continue;
        if (a === "." || a === ":") {
            const m = {};
            for(const E in e)(0, $czfS0.isObjectLike)(e[E]?.[d]) && (m[E] = e[E][d]);
            const u = r && (0, $czfS0.isObjectLike)(r[d]) ? r[d] : void 0;
            if (!Object.keys(m).length && !u) continue;
            const k = a === "." ? d.slice(1) : d.replace(/^:+/, "");
            l[d] = $c7ec7bab0bea2d28$var$Y(m, `${n}-${k}`, o, u);
            continue;
        }
        const t = r && !(0, $czfS0.isObjectLike)(r[d]) ? r[d] : void 0, f = new Set(Object.keys(e));
        t !== void 0 && (f.add("light"), f.add("dark"), c && f.add(c));
        const y = {};
        let S;
        for (const m of f){
            if (g.has(m)) continue;
            let u = e[m]?.[d];
            if ((u === void 0 || (0, $czfS0.isObjectLike)(u)) && (u = t), u === void 0) continue;
            const k = $c7ec7bab0bea2d28$var$C(n, d, u, `@${m}`);
            k !== void 0 && (y[m] = k, (c && m === c || !c && (m === "light" || S === void 0)) && (S = k));
        }
        const b = $c7ec7bab0bea2d28$var$Q(d, y, S, o);
        b && ($c7ec7bab0bea2d28$var$V(l, b), l[`.${d}`] = b);
    }
    return (l.background || l.color || l.backgroundColor) && (l[".inversed"] = {
        color: l.background || l.backgroundColor,
        background: l.color
    }), l;
}, $c7ec7bab0bea2d28$var$B = (e, n, o, r)=>{
    const { cssVars: i } = o;
    o.cssMediaVars || (o.cssMediaVars = {});
    const c = o.cssMediaVars, s = o.globalTheme !== void 0 ? o.globalTheme : "auto", g = s && s !== "auto" ? String(s).replace(/^'|'$/g, "") : null, l = {}, d = new Set(r ? Object.keys(r) : []);
    for(const t in e)if (e[t]) for (const f of Object.keys(e[t]))d.add(f);
    const a = $c7ec7bab0bea2d28$var$K(e, d);
    for (const t of d){
        const f = t.slice(0, 1), y = (0, $czfS0.isObjectLike)(r?.[t]) || Object.values(e).some((S)=>(0, $czfS0.isObjectLike)(S?.[t]));
        if (f === "." && y) {
            const S = t.slice(1), b = {};
            for(const u in e)(0, $czfS0.isObjectLike)(e[u]?.[t]) && (b[u] = e[u][t]);
            const m = (0, $czfS0.isObjectLike)(r?.[t]) ? r[t] : void 0;
            l[t] = $c7ec7bab0bea2d28$var$B(b, `${n}-${S}`, o, m);
        } else if (f === ":" && y) {
            const S = t.replace(/^:+/, ""), b = {};
            for(const u in e)(0, $czfS0.isObjectLike)(e[u]?.[t]) && (b[u] = e[u][t]);
            const m = (0, $czfS0.isObjectLike)(r?.[t]) ? r[t] : void 0;
            l[t] = $c7ec7bab0bea2d28$var$B(b, `${n}-${S}`, o, m);
        } else if (f !== "@" && f !== "." && f !== ":") {
            const b = `--${o.varPrefix ? o.varPrefix + "-" : ""}theme-${n}-${t}`, m = r && !(0, $czfS0.isObjectLike)(r[t]) ? r[t] : void 0, u = new Set(Object.keys(e));
            m !== void 0 && (u.add("light"), u.add("dark"), g && u.add(g));
            let k, E = !1;
            const M = {};
            for (const p of u){
                if (a.has(p)) continue;
                let w = e[p]?.[t];
                if ((w === void 0 || (0, $czfS0.isObjectLike)(w)) && (w = m), w === void 0) continue;
                const $ = $c7ec7bab0bea2d28$var$C(n, t, w, `@${p}`);
                if ($ === void 0) continue;
                E = !0, M[p] = $, (g && p === g || !g && (p === "light" || k === void 0)) && (k = $);
                const j = `[data-theme="${p}"]`;
                if (c[j] || (c[j] = {}), c[j][b] = $, p === "dark" || p === "light") {
                    const A = `@media (prefers-color-scheme: ${p})`;
                    c[A] || (c[A] = {}), c[A][b] = $;
                }
            }
            if (k !== void 0 && (i[b] = k), !E) continue;
            if ($c7ec7bab0bea2d28$var$ae.has(t)) {
                const p = $c7ec7bab0bea2d28$var$Q(t, M, k, o);
                if (p) {
                    const w = (0, $aejgr.skinLiteralBlocks)(n, t, o, Object.keys(M).some(($)=>M[$] !== k));
                    w && $c7ec7bab0bea2d28$var$V(p, w), $c7ec7bab0bea2d28$var$V(l, p), l[`.${t}`] = p;
                }
                continue;
            }
            l[t] = `var(${b})`, l[`.${t}`] = {
                [t]: l[t]
            };
        }
    }
    (l.background || l.color || l.backgroundColor) && (l[".inversed"] = {
        color: l.background || l.backgroundColor,
        background: l.color
    });
    for(const t in l)$c7ec7bab0bea2d28$var$Z(t) && (0, $czfS0.isObjectLike)(l[t]) && $c7ec7bab0bea2d28$var$X.add(l[t]);
    return l;
}, $c7ec7bab0bea2d28$export$c57b11cd015ce162 = (e, n, o, r)=>{
    const i = (0, $521xJ.getActiveConfig)(), { cssVars: c } = i, s = {
        value: e
    }, g = !o && !r;
    let l, d;
    if ((0, $czfS0.isObjectLike)(e)) {
        if (g && i.useVariable) {
            const a = {}, t = {};
            for(const f in e)f.startsWith("@") ? (0, $czfS0.isObjectLike)(e[f]) && (a[f.slice(1)] = e[f]) : t[f] = e[f];
            (Object.keys(a).length || Object.keys(t).length) && (d = $c7ec7bab0bea2d28$var$B(a, n, i, t), Object.assign(s, d));
        } else if (g) {
            const a = {}, t = {};
            for(const f in e)f.startsWith("@") ? (0, $czfS0.isObjectLike)(e[f]) && (a[f.slice(1)] = e[f]) : t[f] = e[f];
            l = $c7ec7bab0bea2d28$var$Y(a, n, i, t), Object.assign(s, l);
        }
        for(const a in e){
            const t = a.slice(0, 1), f = e[a];
            if (t === "@" || t === ":" || t === ".") {
                const y = t === "@" && a;
                s[a] = $c7ec7bab0bea2d28$export$c57b11cd015ce162(f, n, a, r || y);
            } else if (!g) {
                const y = $c7ec7bab0bea2d28$var$C(n, a, f, r), S = [
                    ...new Set([
                        r,
                        o
                    ].filter((k)=>k).map((k)=>k.slice(1)))
                ], b = S.length ? "-" + S.join("-") : "", u = `--${i.varPrefix ? i.varPrefix + "-" : ""}theme-${n}${b}-${a}`;
                i.useVariable ? (i.useThemeSuffixedVars && (c[u] = y), s[a] = `var(${u})`) : s[a] = y, s[`.${a}`] = {
                    [a]: s[a]
                };
            }
        }
        if (l) for(const a in l){
            const t = a.slice(0, 1);
            (t === "." || t === ":") && (0, $czfS0.isObjectLike)(e[a]) && (s[a] = l[a]);
        }
        if (d) for(const a in d){
            const t = a.slice(0, 1);
            (t === "." || t === ":") && (0, $czfS0.isObjectLike)(e[a]) && (s[a] = d[a]);
        }
        !s[".inversed"] && (s.background || s.color || s.backgroundColor) && (s[".inversed"] = {
            color: s.background || s.backgroundColor,
            background: s.color
        });
    }
    if ((0, $czfS0.isString)(e) && (0, $hzNzB.isCSSVar)(e)) {
        const t = i.theme[e.slice(2)];
        return $c7ec7bab0bea2d28$export$b3cf7317de2f2233(t, r);
    }
    return s;
}, $c7ec7bab0bea2d28$var$de = /(::[a-z-]+(?:\([^()]*\))?|:(?:before|after|first-line|first-letter))(?::[a-z-]+(?:\([^()]*\))?)*$/i, $c7ec7bab0bea2d28$var$fe = /^::(?:-webkit-scrollbar|part\()/i, $c7ec7bab0bea2d28$var$P = (e, n, o)=>{
    const r = {};
    for(const i in e){
        const c = i.slice(0, 1);
        if ((0, $czfS0.isObjectLike)(e[i])) {
            if ($c7ec7bab0bea2d28$var$Z(i) && (n || $c7ec7bab0bea2d28$var$X.has(e[i]))) r[i] = $c7ec7bab0bea2d28$var$V({}, e[i]);
            else {
                if (c === "@") continue;
                if (c === ":") {
                    const s = i.match($c7ec7bab0bea2d28$var$de);
                    if (o && (s || !$c7ec7bab0bea2d28$var$fe.test(o))) continue;
                    r[`&${i}`] = $c7ec7bab0bea2d28$var$P(e[i], n, o || (s ? s[1] : null));
                } else if (c === ".") {
                    if (o) continue;
                    r[`&${i}`] = $c7ec7bab0bea2d28$var$P(e[i], n);
                }
            }
        } else r[i] = e[i];
    }
    return r;
}, $c7ec7bab0bea2d28$var$F = (e, n)=>{
    const o = n.shift();
    return e[o] ? $c7ec7bab0bea2d28$var$F(e[o], n) : e;
}, $c7ec7bab0bea2d28$var$I = (e, n)=>(0, $czfS0.isArray)(n) ? $c7ec7bab0bea2d28$var$F(e, n) : (0, $czfS0.isString)(n) && e[n] ? e[n] : e, $c7ec7bab0bea2d28$var$ue = (e, n)=>(0, $czfS0.isString)(e) && (0, $hzNzB.isCSSVar)(e) ? $c7ec7bab0bea2d28$export$b3cf7317de2f2233(e.slice(2)) : e, $c7ec7bab0bea2d28$var$ge = (e)=>$c7ec7bab0bea2d28$var$ue(e, $c7ec7bab0bea2d28$var$ge), $c7ec7bab0bea2d28$export$b3cf7317de2f2233 = (e, n)=>{
    const o = (0, $521xJ.getActiveConfig)();
    if ((0, $czfS0.isString)(e) && (0, $hzNzB.isCSSVar)(e) && (e = $c7ec7bab0bea2d28$export$b3cf7317de2f2233(e.slice(2))), !e || !(0, $czfS0.isString)(e)) {
        o.verbose;
        return;
    }
    const [r, ...i] = (0, $czfS0.isArray)(e) ? e : e.split(" ");
    let c = o.theme[r];
    return c && i.length ? c = $c7ec7bab0bea2d28$var$I(c, i) : c && n && (c = $c7ec7bab0bea2d28$var$I(c, n)), $c7ec7bab0bea2d28$var$P(c, !o.useVariable);
};

});
parcelRegister("iSfnd", function(module, exports) {

$parcel$export(module.exports, "resolveShadowValue", () => $dbd931fe2e79aa1c$export$59f9b8324c0795f1);
$parcel$export(module.exports, "resolveShadowNonColorWord", () => $dbd931fe2e79aa1c$export$1fb42b280c623279);
$parcel$export(module.exports, "setShadow", () => $dbd931fe2e79aa1c$export$9cd3672191b5a46f);
$parcel$export(module.exports, "getShadow", () => $dbd931fe2e79aa1c$export$db93b77dbb14f011);

var $521xJ = parcelRequire("521xJ");

var $5koEk = parcelRequire("5koEk");

var $amsMb = parcelRequire("amsMb");

var $d52u8 = parcelRequire("d52u8");

var $hzNzB = parcelRequire("hzNzB");
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
const $dbd931fe2e79aa1c$var$g = {
    commas: !0
}, $dbd931fe2e79aa1c$export$59f9b8324c0795f1 = (r, o, t)=>(0, $czfS0.isString)(r) ? (0, $hzNzB.resolveCompoundWords)(r, $dbd931fe2e79aa1c$var$N, $dbd931fe2e79aa1c$var$g, o, t) : r, $dbd931fe2e79aa1c$var$N = (r, o, t)=>{
    const c = (0, $5koEk.quietColorProbe)(()=>(0, $5koEk.getColor)(r, o));
    return (0, $hzNzB.isResolvedColor)(c) ? c : $dbd931fe2e79aa1c$export$1fb42b280c623279(r, t);
}, $dbd931fe2e79aa1c$export$1fb42b280c623279 = (r, o)=>{
    if (/^\d/.test(r) || r.includes("px") || r.slice(-2) === "em" || r === "inset" || r === "none" || (0, $5koEk.isIntendedSystemColorWord)(r) || (0, $hzNzB.COMPOUND_CSS_KEYWORDS).has(r.toLowerCase())) return r;
    o && o(r);
    const t = (0, $d52u8.quietSequenceProbe)(()=>(0, $amsMb.getSpacingByKey)(r, "shadow"));
    return t && t.shadow ? t.shadow : r;
}, $dbd931fe2e79aa1c$export$9cd3672191b5a46f = (r, o, t, c)=>{
    const n = (0, $521xJ.getActiveConfig)();
    if ((0, $czfS0.isObject)(r) && r.value !== void 0 && r.var !== void 0) return n.useVariable && (n.cssVars[r.var] = r.value), r;
    if ((0, $czfS0.isArray)(r)) {
        const s = {
            "@light": $dbd931fe2e79aa1c$export$9cd3672191b5a46f(r[0], o, "light"),
            "@dark": $dbd931fe2e79aa1c$export$9cd3672191b5a46f(r[1], o, "dark")
        };
        return n.useVariable && (0, $5koEk.setAdaptiveSchemeVar)(s, "shadow", o, n), s;
    }
    if ((0, $czfS0.isObject)(r)) {
        const s = {};
        for(const i in r)s[i] = $dbd931fe2e79aa1c$export$9cd3672191b5a46f(r[i], o, i.startsWith("@") ? i.slice(1) : i);
        return n.useVariable && (0, $5koEk.setAdaptiveSchemeVar)(s, "shadow", o, n), s;
    }
    (0, $czfS0.isString)(r) && (r = $dbd931fe2e79aa1c$export$59f9b8324c0795f1(r));
    const f = `--${n.varPrefix ? n.varPrefix + "-" : ""}shadow-${o}` + (t ? `-${t}` : "");
    return n.useVariable && (n.cssVars[f] = r), {
        var: f,
        value: r
    };
}, $dbd931fe2e79aa1c$export$db93b77dbb14f011 = (r, o)=>{
    const t = (0, $521xJ.getActiveConfig)();
    if (o = (0, $5koEk.forcedScheme)(o, t), !(0, $czfS0.isString)(r)) {
        t.verbose;
        return;
    }
    if ((0, $hzNzB.isCSSVar)(r)) return `var(${r})`;
    const [c] = (0, $czfS0.isArray)(r) ? r : r.split(" "), e = t.shadow[c], f = (0, $czfS0.isObject)(e);
    if (!e) return t.verbose, r;
    if (f && !e.value && t.useVariable && e.var) return `var(${e.var})`;
    if (o) {
        const s = e["@" + o] || e[o];
        if (s) return s.value !== void 0 ? s.value : s;
        t.verbose;
    }
    return f && e.value ? e.value : f ? (0, $5koEk.literalSchemeMap)((0, $5koEk.atSchemes)(e), t, (s)=>{
        const i = e["@" + s];
        return i && (i.value !== void 0 ? i.value : i);
    }) : (t.verbose, r);
};

});
parcelRegister("amsMb", function(module, exports) {

$parcel$export(module.exports, "checkIfBoxSize", () => $78b247cd0186a3c8$export$80eafc63c0bb6c49);
$parcel$export(module.exports, "applySpacingSequence", () => $78b247cd0186a3c8$export$9bfe8384addafa7c);
$parcel$export(module.exports, "getSpacingByKey", () => $78b247cd0186a3c8$export$4f949d23b5dbefe6);
$parcel$export(module.exports, "getSpacingBasedOnRatio", () => $78b247cd0186a3c8$export$94679ba49f16fc2e);
$parcel$export(module.exports, "splitSpacedValue", () => $78b247cd0186a3c8$export$b5c85645d77180b6);
parcelRequire("byww3");
var $6Bm4P = parcelRequire("6Bm4P");
var $czfS0 = parcelRequire("czfS0");
var $2C0hZ = parcelRequire("2C0hZ");

var $521xJ = parcelRequire("521xJ");
parcelRequire("aV26F");
var $2CJN9 = parcelRequire("2CJN9");
var $kjAAS = parcelRequire("kjAAS");
var $d52u8 = parcelRequire("d52u8");
var $hzNzB = parcelRequire("hzNzB");

var $2O2IF = parcelRequire("2O2IF");
const $78b247cd0186a3c8$var$y = (e)=>{
    const n = (0, $521xJ.getActiveConfig)().spacing || {}, s = parseFloat(e.spacingRatio), c = {
        ...n,
        ratio: Number.isFinite(s) ? s : n.ratio,
        sequence: {},
        scales: {}
    };
    return (0, $d52u8.generateSequence)(c), c;
}, $78b247cd0186a3c8$var$A = (e)=>{
    for(const t in e){
        const n = e[t];
        if (!(t.slice(0, 1) === "@") || !(0, $2O2IF.sequenceMediaQuery)("spacing", t.slice(1))) continue;
        const { type: c, base: o, ratio: i, range: r, subSequence: p, h1Matches: a, unit: u } = e;
        (0, $2C0hZ.merge)(n, {
            type: c,
            base: o,
            ratio: i,
            range: r,
            subSequence: p,
            h1Matches: a,
            unit: u,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), (0, $d52u8.generateSequence)(n), (0, $2CJN9.applyMediaSequenceVars)(e, t);
    }
}, $78b247cd0186a3c8$export$80eafc63c0bb6c49 = (e)=>{
    const t = e.toLowerCase(), n = t.includes("width") || t.includes("height"), s = t.includes("border") || t.includes("outline");
    return n && !s;
}, $78b247cd0186a3c8$export$9bfe8384addafa7c = ()=>{
    const e = (0, $521xJ.getActiveConfig)(), { spacing: t } = e;
    (0, $d52u8.generateSequence)(t), (0, $2CJN9.applySequenceVars)(t), $78b247cd0186a3c8$var$A(t);
}, $78b247cd0186a3c8$var$V = (e)=>{
    const t = (0, $521xJ.getActiveConfig)(), { spacing: n } = t;
    return !e || !e.sequence ? n : Object.keys(e.sequence).length > 0 ? e : (0, $d52u8.generateSequence)(e);
}, $78b247cd0186a3c8$export$4f949d23b5dbefe6 = (e, t = "padding", n, s)=>{
    const c = $78b247cd0186a3c8$var$V(n);
    if ((0, $czfS0.isString)(e)) {
        if (!s && /^(?:env|var)\(/.test(e.trim())) return {
            [t]: e
        };
        if (!s && e.includes("(")) {
            const i = (0, $d52u8.getFnPrefixAndValue)(e);
            s = i[0], e = i[1];
        }
    }
    const o = s ? [
        e
    ] : (0, $czfS0.isString)(e) && e.includes("(") ? (0, $hzNzB.splitTopLevelSpaces)(e) : (0, $6Bm4P.arrayzeValue)(e);
    if ((0, $czfS0.isArray)(o)) {
        if (o.length > 1) {
            let i = "";
            t === "borderWidth" && (t = "border", i = "Width");
            const r = {
                2: [
                    "Block",
                    "Inline"
                ],
                3: [
                    "BlockStart",
                    "Inline",
                    "BlockEnd"
                ],
                4: [
                    "BlockStart",
                    "InlineEnd",
                    "BlockEnd",
                    "InlineStart"
                ]
            }, p = (a, u)=>(0, $d52u8.getSequenceValuePropertyPair)(o[u], t + a + i, c, s);
            return r[o.length].map((a, u)=>p(a, u));
        }
        return (0, $d52u8.getSequenceValuePropertyPair)(e, t, c, s);
    }
}, $78b247cd0186a3c8$export$94679ba49f16fc2e = (e, t, n, s)=>{
    const c = (0, $521xJ.getActiveConfig)(), { spacing: o } = c;
    let i = n || e[t];
    if (!s && (0, $czfS0.isString)(i) && /^(?:env|var)\(/.test(i.trim())) return {
        [t]: i
    };
    if (!s && (0, $czfS0.isString)(i) && i.includes("(")) {
        const r = (0, $d52u8.getFnPrefixAndValue)(i);
        s = r[0], i = r[1];
    }
    if (e.spacingRatio) {
        const r = $78b247cd0186a3c8$var$y(e);
        return $78b247cd0186a3c8$export$4f949d23b5dbefe6(i, t, r, s);
    }
    return $78b247cd0186a3c8$export$4f949d23b5dbefe6(i, t, o, s);
}, $78b247cd0186a3c8$export$b5c85645d77180b6 = (e)=>{
    const t = (n)=>{
        const s = [
            "+",
            "-",
            "*",
            "/"
        ].includes(n), c = (0, $kjAAS.CSS_UNITS).some((i)=>e.includes(i));
        return s || c ? n : n.length < 3 && /[A-Z]/.test(n) ? n + "_default" : n;
    };
    return e.split(",").map((n)=>n.trim()).map(t).join(",").split(" ").map(t).join(" ");
};

});
parcelRegister("2O2IF", function(module, exports) {

$parcel$export(module.exports, "sequenceMediaQuery", () => $20b25c50d10f9576$export$ddd522a489ae6d63);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");

var $521xJ = parcelRequire("521xJ");
const $20b25c50d10f9576$var$r = new Set, $20b25c50d10f9576$export$ddd522a489ae6d63 = (s, e)=>{
    const t = (0, $521xJ.getActiveConfig)().media, o = t && t[e];
    if (o) return o;
    const n = s + " @" + e;
    return $20b25c50d10f9576$var$r.has(n) || ($20b25c50d10f9576$var$r.add(n), (0, $dSdIt.isLoudDevRuntime)() && console.warn(`[smbls/scratch] ${s} "@${e}": the design-system media table has no "${e}" query, so this override is skipped. Add "${e}" to media, or set the values on ${s} itself to change the base sequence.`)), null;
};

});



parcelRegister("8OSGX", function(module, exports) {

$parcel$export(module.exports, "resolveBorderValue", () => $66bd6aeb71c218c0$export$90e7f5c19c7aad56);
$parcel$export(module.exports, "getMediaBorder", () => $66bd6aeb71c218c0$export$dae3c86e379a1761);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");

var $5koEk = parcelRequire("5koEk");

var $amsMb = parcelRequire("amsMb");

var $d52u8 = parcelRequire("d52u8");

var $hzNzB = parcelRequire("hzNzB");
const $66bd6aeb71c218c0$var$O = new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
    "initial"
]), $66bd6aeb71c218c0$var$R = {
    commas: !1,
    keywords: $66bd6aeb71c218c0$var$O
}, $66bd6aeb71c218c0$export$90e7f5c19c7aad56 = (e, i, t)=>{
    if (e == null) return;
    const o = e + "", r = o.trim();
    return r === "none" || r === "0" || r === "initial" || r === "inherit" || r === "unset" ? o : (0, $hzNzB.resolveCompoundWords)(o, $66bd6aeb71c218c0$var$B, $66bd6aeb71c218c0$var$R, i, t);
}, $66bd6aeb71c218c0$var$B = (e, i, t)=>{
    if (/^\d/.test(e)) return e;
    const o = (0, $5koEk.quietColorProbe)(()=>(0, $5koEk.getColor)(e, i));
    if ((0, $hzNzB.isResolvedColor)(o)) return o;
    if ((0, $5koEk.isIntendedSystemColorWord)(e) || (0, $hzNzB.COMPOUND_CSS_KEYWORDS).has(e.toLowerCase())) return e;
    t && t(e);
    const r = (0, $d52u8.quietSequenceProbe)(()=>(0, $amsMb.getSpacingByKey)(e, "border"));
    return r && r.border ? r.border : e;
}, $66bd6aeb71c218c0$export$dae3c86e379a1761 = (e, i, t)=>{
    const o = t || (0, $521xJ.getActiveConfig)();
    if (o.useVariable || !(0, $czfS0.isString)(e)) return $66bd6aeb71c218c0$export$90e7f5c19c7aad56(e);
    const r = (0, $5koEk.literalPairCompound)(e, i, o, {
        commas: !1,
        resolve: (s)=>$66bd6aeb71c218c0$export$90e7f5c19c7aad56(s),
        resolveScheme: (s)=>$66bd6aeb71c218c0$export$90e7f5c19c7aad56(e, "@" + s)
    });
    return r !== void 0 ? r : $66bd6aeb71c218c0$export$90e7f5c19c7aad56(e);
};

});

parcelRegister("aejgr", function(module, exports) {

$parcel$export(module.exports, "applySkins", () => $772a27adea0cc895$export$d631bb01dd57657c);
$parcel$export(module.exports, "skinLiteralBlocks", () => $772a27adea0cc895$export$98577253ae76dd9);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");
const $772a27adea0cc895$var$V = new Set([
    "fallback"
]), $772a27adea0cc895$var$b = new Set, $772a27adea0cc895$var$p = (e, t)=>{
    $772a27adea0cc895$var$b.has(e) || ($772a27adea0cc895$var$b.add(e), (0, $dSdIt.isLoudDevRuntime)() && console.warn(t));
}, $772a27adea0cc895$export$36ae4052d560b894 = ()=>{
    $772a27adea0cc895$var$b.clear();
}, $772a27adea0cc895$var$y = (e)=>{
    for(const t in e)delete e[t];
    return e;
}, $772a27adea0cc895$var$w = (e, t)=>{
    const c = t.color || {};
    return !(0, $czfS0.isString)(e) || !Object.prototype.hasOwnProperty.call(c, e) ? e : `var(--${t.varPrefix ? t.varPrefix + "-" : ""}color-${e})`;
}, $772a27adea0cc895$export$d631bb01dd57657c = ()=>{
    const e = (0, $521xJ.getActiveConfig)(), t = (0, $czfS0.isObject)(e.cssSkinVars) ? $772a27adea0cc895$var$y(e.cssSkinVars) : e.cssSkinVars = {}, c = (0, $czfS0.isObject)(e.cssSkinFallback) ? $772a27adea0cc895$var$y(e.cssSkinFallback) : e.cssSkinFallback = {}, l = e.skins;
    if (!(0, $czfS0.isObject)(l)) return t;
    const i = e.varPrefix ? e.varPrefix + "-" : "", $ = e.cssVars || {};
    for(const s in l){
        const r = l[s];
        if (!(0, $czfS0.isObject)(r)) continue;
        const h = {};
        for(const a in r){
            if ($772a27adea0cc895$var$V.has(a)) continue;
            const m = r[a];
            if ((0, $czfS0.isObject)(m)) for(const u in m){
                const k = `--${i}theme-${a}-${u}`;
                e.useVariable !== !1 && !(k in $) && $772a27adea0cc895$var$p(`${s}/${a}/${u}`, `[scratch] skin "${s}" rewrites theme "${a}" param "${u}", which the theme does not declare \u2014 no element reads ${k}, so the skin changes nothing there. Declare "${u}" on the "${a}" theme (its no-skin value).`), h[k] = $772a27adea0cc895$var$w(m[u], e);
            }
        }
        t[s] = h, (0, $czfS0.isString)(r.fallback) && (c[s] = r.fallback);
    }
    for(const s in c){
        const r = c[s];
        t[r] || ($772a27adea0cc895$var$p(`${s}/fallback/${r}`, `[scratch] skin "${s}" falls back to "${r}", which is not a declared skin \u2014 the reduced-transparency fallback is skipped.`), delete c[s]);
    }
    return t;
}, $772a27adea0cc895$export$98577253ae76dd9 = (e, t, c, l)=>{
    const i = c.skins;
    if (!(0, $czfS0.isObject)(i)) return;
    const $ = (n)=>{
        const o = i[n][e], f = (0, $czfS0.isObject)(o) ? o[t] : void 0;
        return (0, $czfS0.isString)(f) || typeof f == "number" ? $772a27adea0cc895$var$w(f, c) : void 0;
    }, s = {}, r = {};
    for(const n in i){
        if (!(0, $czfS0.isObject)(i[n])) continue;
        const o = $(n);
        o !== void 0 && (s[n] = o);
    }
    const h = Object.keys(s);
    if (!h.length) return;
    for(const n in i){
        if (!(0, $czfS0.isObject)(i[n])) continue;
        const o = i[n].fallback, f = (0, $czfS0.isString)(o) && (0, $czfS0.isObject)(i[o]) && s[o] !== void 0 ? s[o] : s[n];
        f !== void 0 && (r[n] = f);
    }
    l && $772a27adea0cc895$var$p(`${e}/${t}/scheme`, `[scratch] theme "${e}" gives "${t}" a value per scheme and a skin sets it too. "${t}" reaches the element as a literal, so the scheme's rule can tie with the skin's or win over it. Write "${t}" once on the "${e}" theme (outside the schemes).`);
    const a = (n)=>`[data-skin="${n}"]`, m = (n, o)=>n in s && o in s && s[n] !== s[o] ? s[o] : void 0, u = {};
    for (const n of h)u[`${a(n)} &`] = {
        [t]: s[n]
    };
    for (const n of h)for (const o of h){
        const f = n === o ? void 0 : m(n, o);
        f !== void 0 && (u[`${a(n)} ${a(o)} &`] = {
            [t]: f
        });
    }
    const k = {}, v = Object.keys(r);
    for (const n of v)r[n] !== s[n] && (k[`${a(n)} &`] = {
        [t]: r[n]
    });
    for (const n of v)for (const o of v){
        if (n === o) continue;
        const f = m(n, o);
        (r[n] !== r[o] || f !== void 0) && f !== r[o] && (k[`${a(n)} ${a(o)} &`] = {
            [t]: r[o]
        });
    }
    return Object.keys(k).length && (u["@media (prefers-reduced-transparency: reduce)"] = k), u;
}, $772a27adea0cc895$var$O = (e, t)=>{
    const c = `[data-skin="${e}"]`;
    return !t || t === ":root" ? `:root${c}, ${c}` : `${t}${c}, ${c} ${t}, ${t} ${c}`;
}, $772a27adea0cc895$export$2fdaa320bafdaaae = (e, t, c)=>{
    const l = {};
    if (!(0, $czfS0.isObject)(e)) return l;
    for(const $ in e)l[$772a27adea0cc895$var$O($, c)] = e[$];
    const i = {};
    for(const $ in t || {}){
        const s = e[t[$]];
        s && (i[$772a27adea0cc895$var$O($, c)] = s);
    }
    return Object.keys(i).length && (l["@media (prefers-reduced-transparency: reduce)"] = i), l;
};

});


parcelRegister("amQH3", function(module, exports) {

$parcel$export(module.exports, "setFont", () => $78c4d540968cf806$export$69e9bdef456a9c46);
$parcel$export(module.exports, "getFontFamily", () => $78c4d540968cf806$export$c4930fc256cef44f);
$parcel$export(module.exports, "setFontFamily", () => $78c4d540968cf806$export$5fae120d779aafec);
parcelRequire("byww3");
var $6Bm4P = parcelRequire("6Bm4P");
var $czfS0 = parcelRequire("czfS0");
var $dSdIt = parcelRequire("dSdIt");

var $521xJ = parcelRequire("521xJ");
parcelRequire("aV26F");
var $jGZk7 = parcelRequire("jGZk7");
const $78c4d540968cf806$export$69e9bdef456a9c46 = (t, s)=>{
    const e = (0, $521xJ.getActiveConfig)(), r = `--font-${s}`;
    if (!t || (0, $czfS0.isArray)(t) && !t[0]) return;
    let i;
    if (t.isVariable) {
        const n = (0, $jGZk7.resolveFileUrl)(t.url, e.files) || t.url;
        (0, $jGZk7.isGoogleFontsUrl)(n) ? i = (0, $jGZk7.setFontImport)(n) : i = (0, $jGZk7.setCustomFontMedia)(s, n, t.fontWeight, {
            fontStretch: t.fontStretch,
            fontDisplay: t.fontDisplay || "swap",
            unicodeRange: t.unicodeRange
        });
    } else if (t[0]) i = (0, $jGZk7.getFontFaceEach)(s, t, e.files);
    else {
        const n = Array.isArray(t.url) ? t.url.map((a)=>(0, $jGZk7.resolveFileUrl)(a, e.files) || a) : (0, $jGZk7.resolveFileUrl)(t.url, e.files) || t.url;
        i = (0, $jGZk7.setCustomFontMedia)(s, n, t.fontWeight, {
            fontStyle: t.fontStyle,
            fontDisplay: t.fontDisplay,
            fontStretch: t.fontStretch,
            unicodeRange: t.unicodeRange
        });
    }
    return {
        var: r,
        value: t,
        fontFace: i
    };
}, $78c4d540968cf806$var$N = new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "emoji",
    "math",
    "fangsong",
    "inherit",
    "initial",
    "unset",
    "revert",
    "revert-layer"
]), $78c4d540968cf806$var$w = (t)=>$78c4d540968cf806$var$N.has(t.toLowerCase()) || /[\s,'"(]/.test(t.trim()), $78c4d540968cf806$var$I = new Set, $78c4d540968cf806$export$c4930fc256cef44f = (t, s)=>{
    const e = (0, $521xJ.getActiveConfig)(), { fontFamily: r } = e, i = s || r, n = (0, $jGZk7.getDefaultOrFirstKey)(i, t);
    if (n !== void 0 || t == null || t === "" || t === "default") return n;
    if (!(0, $czfS0.isString)(t)) return (0, $jGZk7.getDefaultOrFirstKey)(i);
    if (!$78c4d540968cf806$var$w(t)) return (0, $dSdIt.isNotProduction)() && !$78c4d540968cf806$var$I.has(t) && $78c4d540968cf806$var$I.add(t), (0, $jGZk7.getDefaultOrFirstKey)(i);
}, $78c4d540968cf806$var$C = (t)=>{
    const s = t.trim(), e = s.replace(/^(['"])(.*)\1$/, "$2").trim(), r = e.replace(/\s+/g, " ").toLowerCase();
    return e !== s && $78c4d540968cf806$var$N.has(r) ? '"' + r + '"' : r;
}, $78c4d540968cf806$export$5fae120d779aafec = (t, s)=>{
    const e = (0, $521xJ.getActiveConfig)(), { fontFamily: r, fontFamilyTypes: i } = e;
    if ((0, $czfS0.isObject)(t) && (0, $czfS0.isString)(t.value) && (0, $czfS0.isString)(t.var)) return e.useVariable && (e.cssVars[t.var] = t.value), t;
    let { value: n, type: a } = t;
    t.isDefault && (!t.isSystemFallback || !r.__defaultKey) && (r.__defaultKey = s), (0, $czfS0.isObject)(n) && (n = (0, $6Bm4P.arrayzeValue)(n));
    const S = `--${e.varPrefix ? e.varPrefix + "-" : ""}font-family-${s}`, p = (o)=>o && !o.startsWith("--"), c = [
        ...n
    ].map((o)=>String(o).trim()).filter(p), u = new Set;
    for (const o of c)for (const f of o.split(","))u.add($78c4d540968cf806$var$C(f));
    for (const o of String(i[a] ?? "").split(",")){
        const f = o.trim();
        if (!p(f)) continue;
        const g = $78c4d540968cf806$var$C(f);
        u.has(g) || (u.add(g), c.push(f));
    }
    const y = c.join(", ");
    return e.useVariable && (e.cssVars[S] = y), {
        var: S,
        value: y,
        arr: n,
        type: a,
        isSystemFallback: !!t.isSystemFallback,
        isSharedLibrary: !!t.isSharedLibrary
    };
};

});

parcelRegister("13hKf", function(module, exports) {

$parcel$export(module.exports, "applyTypographySequence", () => $0c43d6091c6ae2b7$export$7c7d7b0d076fe8b5);
$parcel$export(module.exports, "getFontSizeByKey", () => $0c43d6091c6ae2b7$export$ea9b2cd64205746b);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");

var $521xJ = parcelRequire("521xJ");
parcelRequire("aV26F");
var $2CJN9 = parcelRequire("2CJN9");
var $d52u8 = parcelRequire("d52u8");

var $2O2IF = parcelRequire("2O2IF");
const $0c43d6091c6ae2b7$export$ee622839cb6e2b5d = (e)=>{
    const n = (0, $521xJ.getActiveConfig)(), { typography: o } = n;
    for(const a in e){
        const s = a.slice(0, 1) === "@", t = e[a];
        if (!s) continue;
        const { mediaRegenerate: c } = e, i = a.slice(1), r = (0, $2O2IF.sequenceMediaQuery)("typography", i);
        if (!r) continue;
        const { type: m, base: y, ratio: d, range: f, subSequence: S, h1Matches: v, unit: u } = e;
        (0, $2C0hZ.merge)(t, {
            type: m,
            base: y,
            ratio: d,
            range: f,
            subSequence: S,
            h1Matches: v,
            unit: u
        });
        const q = new Set([
            "vw",
            "vh",
            "vmin",
            "vmax",
            "svw",
            "svh",
            "lvw",
            "lvh",
            "dvw",
            "dvh"
        ]), P = t.unit || u, H = !t.unit && q.has(u) ? "rem" : P, G = "@media " + (r === "print" ? `${r}` : `screen and ${r}`);
        if (o.templates[G] = {
            fontSize: t.base / o.browserDefault + H
        }, !c) {
            (0, $2C0hZ.merge)(t, {
                sequence: {},
                scales: {},
                vars: {}
            }), (0, $d52u8.generateSequence)(t), (0, $2CJN9.applyMediaSequenceVars)(e, a);
            continue;
        }
        (0, $2C0hZ.merge)(t, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        }), (0, $d52u8.generateSequence)(t), (0, $2CJN9.applyMediaSequenceVars)(e, a);
    }
}, $0c43d6091c6ae2b7$export$7fc39a69c6299a60 = (e)=>{
    const n = (0, $521xJ.getActiveConfig)();
    if (e.h1Matches) {
        const o = e.unit, a = (0, $d52u8.findHeadings)(e), { templates: s } = e;
        for(const t in a){
            const c = `h${parseInt(t) + 1}`, i = s[c];
            s[c] = {
                fontSize: n.useVariable ? `var(${a[t]?.variable})` : `${a[t]?.scaling}${o}`,
                margin: i ? i.margin : 0,
                lineHeight: i ? i.lineHeight : e.lineHeight,
                letterSpacing: i ? i.letterSpacing : e.letterSpacing,
                fontWeight: i ? i.fontWeight : 900 - t * 100
            };
        }
    }
}, $0c43d6091c6ae2b7$export$7c7d7b0d076fe8b5 = ()=>{
    const e = (0, $521xJ.getActiveConfig)(), { typography: n } = e;
    (0, $d52u8.generateSequence)(n), $0c43d6091c6ae2b7$export$7fc39a69c6299a60(n), (0, $2CJN9.applySequenceVars)(n), $0c43d6091c6ae2b7$export$ee622839cb6e2b5d(n);
}, $0c43d6091c6ae2b7$export$ea9b2cd64205746b = (e)=>{
    const n = (0, $521xJ.getActiveConfig)(), { typography: o } = n;
    return (0, $d52u8.getSequenceValuePropertyPair)(e, "fontSize", o);
};

});

parcelRegister("bvD2U", function(module, exports) {

$parcel$export(module.exports, "getShapeByKey", () => $8610e0aacfd8a65a$export$bc589daf02ba9078);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");
const $8610e0aacfd8a65a$export$bc589daf02ba9078 = (t)=>{
    if (!(0, $czfS0.isString)(t)) return;
    const r = (0, $521xJ.getActiveConfig)().shape;
    if (r) return r[t] !== void 0 ? r[t] : r[t.toLowerCase()];
};

});

parcelRegister("ZN2Fd", function(module, exports) {

$parcel$export(module.exports, "applyTimingSequence", () => $0b9bbd5520c41bf9$export$a5be618f63a441ac);
$parcel$export(module.exports, "getTimingFunction", () => $0b9bbd5520c41bf9$export$23ba66c7c3e2e613);
$parcel$export(module.exports, "getTimingByKey", () => $0b9bbd5520c41bf9$export$3fa311edc5edd22f);
parcelRequire("byww3");
var $6Bm4P = parcelRequire("6Bm4P");

var $521xJ = parcelRequire("521xJ");
parcelRequire("aV26F");
var $2CJN9 = parcelRequire("2CJN9");
var $d52u8 = parcelRequire("d52u8");
const $0b9bbd5520c41bf9$export$a5be618f63a441ac = ()=>{
    const t = (0, $521xJ.getActiveConfig)(), { timing: e } = t;
    (0, $d52u8.generateSequence)(e), (0, $2CJN9.applySequenceVars)(e);
}, $0b9bbd5520c41bf9$export$23ba66c7c3e2e613 = (t)=>{
    const e = (0, $521xJ.getActiveConfig)(), { timing: n } = e;
    return n[t] || n[(0, $6Bm4P.toCamelCase)(t)] || t;
}, $0b9bbd5520c41bf9$export$3fa311edc5edd22f = (t, e = "timing")=>{
    const n = (0, $521xJ.getActiveConfig)(), { timing: o } = n;
    return (0, $d52u8.getSequenceValuePropertyPair)(t, e, o);
};

});

parcelRegister("4MQe6", function(module, exports) {

$parcel$export(module.exports, "applyDocument", () => $37c42836f6ef7bc8$export$25b333cdc54cc186);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");

var $521xJ = parcelRequire("521xJ");
parcelRequire("aV26F");
var $jGZk7 = parcelRequire("jGZk7");

var $dCzXU = parcelRequire("dCzXU");
const $37c42836f6ef7bc8$export$25b333cdc54cc186 = ()=>{
    const e = (0, $521xJ.getActiveConfig)(), { fontFamily: m, theme: i, typography: o } = e;
    let t = e.document;
    return (0, $dCzXU.isHostObject)(t) ? ((0, $dCzXU.parkHostObject)(e, "document", t), t = e.document = {}) : t || (t = e.document = {}), (0, $2C0hZ.merge)(t, {
        theme: i.document,
        fontFamily: (0, $jGZk7.getDefaultOrFirstKey)(m),
        fontSize: o.base,
        lineHeight: o.lineHeight
    });
};

});

parcelRegister("dxw8L", function(module, exports) {

$parcel$export(module.exports, "setSVG", () => $9db749cf307a13d3$export$694c6c574069ebf2);
$parcel$export(module.exports, "setSvgIcon", () => $9db749cf307a13d3$export$46739718ff556447);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");
parcelRequire("aV26F");
var $bbBIp = parcelRequire("bbBIp");

var $521xJ = parcelRequire("521xJ");
const $9db749cf307a13d3$var$h = {
    document: (0, $fXgyh.document)
}, $9db749cf307a13d3$var$C = new WeakMap, $9db749cf307a13d3$var$v = new WeakMap, $9db749cf307a13d3$var$I = 128, $9db749cf307a13d3$var$F = 1048576, $9db749cf307a13d3$var$m = 8192, $9db749cf307a13d3$var$y = (e)=>e.nodeType === 1 && e.localName === "symbol" && e.getAttribute("id"), $9db749cf307a13d3$var$_ = (e)=>e.nodeType === 8 || e.nodeType === 3 && !e.textContent.trim(), $9db749cf307a13d3$var$M = (e, n)=>{
    let t = 1;
    const s = e.ownerDocument;
    if (s && typeof s.createTreeWalker == "function") {
        const i = s.createTreeWalker(e, 4294967295);
        for(; i.nextNode();)if (++t > n) return t;
        return t;
    }
    const o = [
        e
    ];
    for(; o.length;){
        const i = o.pop().childNodes || [];
        for(let r = 0; r < i.length; r++){
            if (++t > n) return t;
            o.push(i[r]);
        }
    }
    return t;
}, $9db749cf307a13d3$var$N = (e, n)=>{
    if (typeof e.importNode == "function") return e.importNode(n, !0);
    const t = n.cloneNode(!0);
    return typeof e.adoptNode == "function" ? e.adoptNode(t) : t;
}, $9db749cf307a13d3$var$x = (e, n)=>{
    if (typeof e.prepend == "function") return e.prepend(n);
    const t = e.firstChild !== void 0 ? e.firstChild : e.childNodes && e.childNodes[0];
    return typeof e.insertBefore == "function" ? e.insertBefore(n, t || null) : e.appendChild(n);
}, $9db749cf307a13d3$export$694c6c574069ebf2 = (e, n)=>{
    const t = (0, $521xJ.getActiveConfig)();
    if (!e) {
        t.verbose;
        return;
    }
    return t.useSvgSprite ? (0, $bbBIp.convertSvgToSymbol)(n, e) : e;
}, $9db749cf307a13d3$export$2c4662f4a995c568 = (e, n = $9db749cf307a13d3$var$h)=>{
    const t = (0, $521xJ.getActiveConfig)(), s = Object.keys(e).length ? {} : t.svg;
    for(const o in e)s[o] = e[o];
    $9db749cf307a13d3$var$T(s, n);
}, $9db749cf307a13d3$export$46739718ff556447 = (e, n)=>{
    const t = (0, $521xJ.getActiveConfig)();
    return t.useIconSprite && !t.semanticIcons?.[n] ? $9db749cf307a13d3$export$694c6c574069ebf2(e, n) : e;
}, $9db749cf307a13d3$export$6892263c3fbefa8c = (e, n = $9db749cf307a13d3$var$h)=>{
    const t = (0, $521xJ.getActiveConfig)(), s = Object.keys(e).length ? {} : t.icons;
    for(const o in e)s[o] = e[o];
    $9db749cf307a13d3$var$T(s, n);
}, $9db749cf307a13d3$var$E = (e, n = {
    isRoot: !0
})=>{
    if (!e || !e.createElementNS) return;
    const t = e.createElementNS("http://www.w3.org/2000/svg", "svg");
    return n.isRoot && (t.setAttribute("aria-hidden", "true"), t.setAttribute("width", "0"), t.setAttribute("height", "0"), t.setAttribute("style", "position:absolute"), t.setAttribute("id", "svgSprite")), t;
}, $9db749cf307a13d3$var$D = (e)=>{
    const n = e && e.defaultView;
    return n && typeof n.DOMParser == "function" ? n.DOMParser : typeof DOMParser < "u" ? DOMParser : null;
}, $9db749cf307a13d3$var$V = (e, n)=>{
    const t = $9db749cf307a13d3$var$D(e);
    if (t) {
        const s = `<svg xmlns="http://www.w3.org/2000/svg">${n}</svg>`, i = new t().parseFromString(s, "image/svg+xml");
        return i.querySelector("parsererror") ? null : i.documentElement;
    }
    return null;
}, $9db749cf307a13d3$var$P = (e, n, t)=>{
    const s = String(t);
    let o = $9db749cf307a13d3$var$v.get(n);
    const i = o?.entries.get(s);
    if (i) return o.entries.delete(s), o.entries.set(s, i), i.root;
    let r = $9db749cf307a13d3$var$V(e, s);
    if (r || (r = $9db749cf307a13d3$var$E(e, {
        isRoot: !1
    }), r.innerHTML = s), s.length > $9db749cf307a13d3$var$F) return r;
    const l = $9db749cf307a13d3$var$M(r, $9db749cf307a13d3$var$m);
    if (l > $9db749cf307a13d3$var$m) return r;
    for(o || (o = {
        entries: new Map,
        units: 0,
        nodes: 0
    }, $9db749cf307a13d3$var$v.set(n, o)); o.entries.size >= $9db749cf307a13d3$var$I || o.units + s.length > $9db749cf307a13d3$var$F || o.nodes + l > $9db749cf307a13d3$var$m;){
        const u = o.entries.keys().next().value, f = o.entries.get(u);
        o.units -= u.length, o.nodes -= f.nodes, o.entries.delete(u);
    }
    return o.entries.set(s, {
        root: r,
        nodes: l
    }), o.units += s.length, o.nodes += l, r;
}, $9db749cf307a13d3$var$b = (e)=>{
    const n = new Map;
    for (const t of e.children){
        const s = $9db749cf307a13d3$var$y(t);
        if (!s) continue;
        const o = n.get(s) || [];
        o.push(t), n.set(s, o);
    }
    return n;
}, $9db749cf307a13d3$var$W = (e)=>e.replace(/["\\\u0000-\u001f\u007f]/g, (n)=>`\\${n.charCodeAt(0).toString(16)} `), $9db749cf307a13d3$var$O = (e, n, t, s)=>{
    let o = 0, i = n.childElementCount > 8 ? $9db749cf307a13d3$var$b(t) : null;
    const r = (l)=>{
        if (!i) try {
            return [
                ...t.querySelectorAll(`symbol[id="${$9db749cf307a13d3$var$W(l)}"]`)
            ].filter((u)=>u.parentNode === t);
        } catch  {
            i = $9db749cf307a13d3$var$b(t);
        }
        return i.get(l);
    };
    for (const l of n.childNodes){
        if ($9db749cf307a13d3$var$_(l)) continue;
        const u = $9db749cf307a13d3$var$y(l);
        if (!u && s) {
            const d = o++, c = s.nodes[d];
            if (!c && s.complete || c?.parentNode === t) continue;
            const a = $9db749cf307a13d3$var$N(e, c || l);
            t.appendChild(a), s.nodes[d] = a;
            continue;
        }
        const f = u && r(u);
        let p = f && f[0];
        if (!p) p = $9db749cf307a13d3$var$N(e, l), t.appendChild(p);
        else if (!p.isEqualNode(l)) {
            const d = $9db749cf307a13d3$var$N(e, l);
            t.replaceChild(d, p), p = d;
        }
        if (f) for(let d = 1; d < f.length; d++)f[d].remove();
        u && i && i.set(u, [
            p
        ]);
    }
}, $9db749cf307a13d3$var$T = (e, n = $9db749cf307a13d3$var$h)=>{
    const t = (0, $521xJ.getActiveConfig)(), s = n.document || (0, $fXgyh.document);
    if (!s || !s.documentElement) return t.verbose, (0, $bbBIp.generateSprite)(e);
    const o = s.querySelector("#svgSprite");
    let i = "";
    for(const c in e)i += e[c];
    const r = o || $9db749cf307a13d3$var$E(s);
    if (!r || !r.nodeType) return;
    const l = (c)=>$9db749cf307a13d3$var$P(s, r, c), u = l(i);
    let f = $9db749cf307a13d3$var$C.get(r);
    f || $9db749cf307a13d3$var$C.set(r, f = new WeakMap);
    let p = f.get(t);
    if (p || f.set(t, p = new Map), [
        ...u.childNodes
    ].some((c)=>!$9db749cf307a13d3$var$_(c) && !$9db749cf307a13d3$var$y(c))) {
        const c = [];
        for(const a in e)c.push(a);
        for (const a of c){
            let S = p.get(a);
            S || p.set(a, S = {
                nodes: [],
                complete: !1
            }), $9db749cf307a13d3$var$O(s, c.length === 1 ? u : l(e[a]), r, S), S.complete = !0;
        }
    } else {
        $9db749cf307a13d3$var$O(s, u, r);
        for(const c in e)p.has(c) || p.set(c, {
            nodes: [],
            complete: !0
        });
    }
    o || $9db749cf307a13d3$var$x(s.body, r);
    for(const c in e)t.__svgCache[c] = !0;
};

});

parcelRegister("9rUXD", function(module, exports) {

$parcel$export(module.exports, "applyReset", () => $6e12d1e420ab95bd$export$984fb5f73961424e);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");

var $habKp = parcelRequire("habKp");
const $6e12d1e420ab95bd$export$984fb5f73961424e = (l = {})=>{
    const o = (0, $521xJ.getActiveConfig)(), t = o.typography || {}, m = o.document || {}, i = (0, $czfS0.isObject)(o.reset) ? o.reset : o.reset = {};
    if (i[":root"]) {
        const e = i, n = t.templates || {};
        e.body = {
            ...o.useDocumentTheme ? (0, $habKp.getMediaTheme)("document") : {},
            ...n.body
        }, e.h1 = n.h1, e.h2 = n.h2, e.h3 = n.h3, e.h4 = n.h4, e.h5 = n.h5, e.h6 = n.h6;
    }
    const { body: h, ...a } = t.templates || {}, f = o.useDocumentTheme ? (0, $habKp.getMediaTheme)("document") : {};
    if (i.html && (0, $2C0hZ.overwriteDeep)(i.html, f), t.unit) for(const e in a){
        if (e.slice(0, 6) !== "@media") continue;
        const n = a[e];
        delete a[e], !(!n || !n.fontSize) && (i[e] || (i[e] = {}), i[e].html || (i[e].html = {}), i[e].html.fontSize === void 0 && (i[e].html.fontSize = n.fontSize));
    }
    if (t.unit) {
        const e = o.media || {};
        for(const n in t){
            if (n.charAt(0) !== "@") continue;
            const r = t[n];
            if (!r || r.unit === t.unit || !r.unit) continue;
            const d = r.unit, p = r.base || t.base, b = r.browserDefault || t.browserDefault, g = n.slice(1), c = e[g];
            if (!c) continue;
            const s = "@media " + (c === "print" ? c : "screen and " + c);
            i[s] || (i[s] = {}), i[s].html || (i[s].html = {}), i[s].html.fontSize = p / b + d;
        }
    }
    return (0, $2C0hZ.deepMerge)((0, $2C0hZ.merge)(i, l), {
        html: {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0",
            left: "0",
            margin: "0",
            WebkitFontSmoothing: "subpixel-antialiased",
            textSizeAdjust: "100%",
            WebkitTextSizeAdjust: "100%",
            ...f,
            fontSize: t.unit ? t.base / t.browserDefault + t.unit : t.browserDefault + "px",
            fontFamily: m.fontFamily,
            lineHeight: m.lineHeight
        },
        body: {
            boxSizing: "border-box",
            height: "100%",
            margin: 0,
            fontFamily: m.fontFamily,
            fontSize: t.unit ? "1" + o.unit.default : t.base / t.browserDefault + o.unit.default,
            ...a,
            ...h
        },
        a: {
            color: "currentColor"
        },
        button: {
            color: "inherit",
            font: "inherit",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            appearance: "none",
            WebkitAppearance: "none"
        },
        "input, select, textarea": {
            color: "inherit",
            font: "inherit"
        },
        fieldset: {
            border: 0,
            padding: 0,
            margin: 0
        }
    }, (0, $521xJ.CONFIG_MERGE_EXL));
};

});


parcelRegister("2iwMe", function(module, exports) {

$parcel$export(module.exports, "transformBorder", () => $1ac6b009926371d3$export$ca4ef6ca6dc743f2);
$parcel$export(module.exports, "transformTextStroke", () => $1ac6b009926371d3$export$8bcd50b221b13db);
$parcel$export(module.exports, "transformShadow", () => $1ac6b009926371d3$export$837e4beeff9ff924);
$parcel$export(module.exports, "transformBoxShadow", () => $1ac6b009926371d3$export$9c296746f296a70);
$parcel$export(module.exports, "transformBackgroundImage", () => $1ac6b009926371d3$export$15f2b9b64835b137);
$parcel$export(module.exports, "TILING_SIZE_KEYWORDS", () => $1ac6b009926371d3$export$66ec756df0e15e01);
$parcel$export(module.exports, "TILING_POSITION_KEYWORDS", () => $1ac6b009926371d3$export$39bf99e306b1fd63);
$parcel$export(module.exports, "transformTilingValue", () => $1ac6b009926371d3$export$985923acff31e705);
$parcel$export(module.exports, "transfromGap", () => $1ac6b009926371d3$export$1e420ad2d0d06436);
$parcel$export(module.exports, "transformGridTemplate", () => $1ac6b009926371d3$export$4233b8d3bf17a559);
$parcel$export(module.exports, "transformDuration", () => $1ac6b009926371d3$export$d87c1c5f4a8ec3d9);
$parcel$export(module.exports, "splitTransition", () => $1ac6b009926371d3$export$d9f7ff0c2b32d4b5);
$parcel$export(module.exports, "transformSize", () => $1ac6b009926371d3$export$f09d9444954afeda);
$parcel$export(module.exports, "transformSizeRatio", () => $1ac6b009926371d3$export$b6e34d20a288a08c);
$parcel$export(module.exports, "transformBorderRadius", () => $1ac6b009926371d3$export$7150732276d3a7a2);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
var $czfS0 = parcelRequire("czfS0");

var $521xJ = parcelRequire("521xJ");
parcelRequire("jPKwi");
var $amsMb = parcelRequire("amsMb");
var $5koEk = parcelRequire("5koEk");
var $8OSGX = parcelRequire("8OSGX");
var $iSfnd = parcelRequire("iSfnd");
var $bvD2U = parcelRequire("bvD2U");
var $ZN2Fd = parcelRequire("ZN2Fd");
parcelRequire("aV26F");
var $d52u8 = parcelRequire("d52u8");
var $hzNzB = parcelRequire("hzNzB");
const $1ac6b009926371d3$export$ca4ef6ca6dc743f2 = (r, t)=>(0, $8OSGX.getMediaBorder)(r, t), $1ac6b009926371d3$export$8bcd50b221b13db = (r)=>{
    if ((0, $czfS0.isString)(r)) return (0, $hzNzB.CSS_NATIVE_COLOR_REGEX).test(r) ? r : r.split(/\s+/).map((t)=>{
        if (t = t.trim(), !t) return "";
        if ((0, $hzNzB.isCSSVar)(t)) return `var(${t})`;
        if (/^\d/.test(t) || t.includes("px") || t === "0") return t;
        const e = (0, $5koEk.getColor)(t);
        return (0, $hzNzB.isResolvedColor)(e) ? e : t;
    }).join(" ");
}, $1ac6b009926371d3$export$837e4beeff9ff924 = (r, t)=>(0, $iSfnd.getShadow)(r, t), $1ac6b009926371d3$export$9c296746f296a70 = (r, t)=>{
    if (!(0, $czfS0.isString)(r)) return;
    const e = (0, $521xJ.getActiveConfig)();
    if (!e.useVariable) {
        const o = $1ac6b009926371d3$var$F(r, t, e);
        if (o !== void 0) return o;
    }
    return $1ac6b009926371d3$var$m(r, t);
}, $1ac6b009926371d3$var$F = (r, t, e)=>(0, $5koEk.literalPairCompound)(r, t === "auto" ? null : t, e, {
        commas: !0,
        resolve: $1ac6b009926371d3$var$m,
        resolveScheme: (o, n)=>$1ac6b009926371d3$var$m(n((i)=>(0, $5koEk.getColor)(i, "@" + o, e)), null)
    }), $1ac6b009926371d3$var$m = (r, t)=>(0, $hzNzB.resolveCompoundWords)(r, $1ac6b009926371d3$var$Y, $1ac6b009926371d3$var$$, t), $1ac6b009926371d3$var$$ = {
    commas: !0,
    keywords: new Set([
        "inset",
        "none"
    ])
}, $1ac6b009926371d3$var$Y = (r, t)=>{
    if (!(0, $hzNzB.isResolvedColor)((0, $5koEk.getColor)(r))) return (0, $iSfnd.resolveShadowNonColorWord)(r);
    const e = (0, $5koEk.getMediaColor)(r, t);
    return (0, $czfS0.isObject)(e) ? Object.values(e).filter((o)=>o.includes(": " + t))[0] : e;
}, $1ac6b009926371d3$export$15f2b9b64835b137 = (r, t)=>{
    if (!(0, $czfS0.isString)(r)) return;
    const e = (0, $521xJ.getActiveConfig)();
    return (0, $hzNzB.splitTopLevelCommas)(r).map((o)=>{
        const n = o.trim();
        if ((0, $hzNzB.isCSSVar)(n)) return `var(${n})`;
        if (/^var\(/.test(n) || n.includes("url")) return n;
        if (e.gradient?.[n]) {
            const i = (0, $5koEk.getMediaColor)(n, t);
            if ((0, $czfS0.isString)(i)) return i;
            if ((0, $czfS0.isObject)(i)) {
                for(const c in i)if ((0, $czfS0.isString)(i[c])) return i[c];
            }
            return n;
        }
        return n.includes("gradient") ? (0, $5koEk.resolveColorsInGradient)(n, t) : n.includes("/") || n.startsWith("http") || n.includes(".") && !(0, $hzNzB.parseColorToken)(n) ? `url(${n})` : n;
    }).join(", ");
}, $1ac6b009926371d3$export$66ec756df0e15e01 = new Set([
    "auto",
    "cover",
    "contain"
]), $1ac6b009926371d3$export$39bf99e306b1fd63 = new Set([
    "center",
    "top",
    "bottom",
    "left",
    "right"
]), $1ac6b009926371d3$var$M = (r, t, e, o)=>{
    if (e.has(r)) return r;
    const n = (0, $d52u8.quietSequenceProbe)(()=>(0, $amsMb.getSpacingBasedOnRatio)(o, t, r));
    return n && n[t] !== void 0 ? n[t] : r;
}, $1ac6b009926371d3$export$985923acff31e705 = (r, t, e, o)=>(0, $czfS0.isString)(r) ? (0, $hzNzB.splitTopLevelCommas)(r).map((n)=>(0, $hzNzB.splitTopLevelSpaces)(n.trim()).map((i)=>$1ac6b009926371d3$var$M(i, t, e, o)).join(" ")).join(", ") : r, $1ac6b009926371d3$export$1e420ad2d0d06436 = (r)=>(0, $czfS0.isString)(r) && (0, $hzNzB.splitTopLevelSpaces)(r).map((t)=>(0, $amsMb.getSpacingByKey)(t, "gap").gap).join(" "), $1ac6b009926371d3$export$4233b8d3bf17a559 = (r)=>{
    if (!(0, $czfS0.isString)(r)) return r;
    const t = (0, $521xJ.getActiveConfig)();
    return (0, $hzNzB.splitTopLevelSpaces)(r).map((e)=>(0, $d52u8.BARE_SEQUENCE_TOKEN_RE).test(e) ? (0, $d52u8.getSequenceValue)(e, t.spacing) : e).join(" ");
}, $1ac6b009926371d3$export$df2b736a06860be7 = (r)=>{
    if (!(0, $czfS0.isString)(r)) return;
    const t = r.split(" ");
    return t.length ? t.map((e)=>(0, $hzNzB.isCSSVar)(e) ? `var(${e})` : e.length < 3 || e.includes("ms") ? (0, $ZN2Fd.getTimingByKey)(e).timing || e : (0, $ZN2Fd.getTimingFunction)(e) ? (0, $ZN2Fd.getTimingFunction)(e) : e).join(" ") : r;
}, $1ac6b009926371d3$export$d87c1c5f4a8ec3d9 = (r, t, e)=>{
    if ((0, $czfS0.isString)(r)) return r.split(",").map((o)=>(0, $ZN2Fd.getTimingByKey)(o).timing || o).join(",");
}, $1ac6b009926371d3$export$d9f7ff0c2b32d4b5 = (r)=>{
    if (!(0, $czfS0.isString)(r)) return;
    const t = r.split(",");
    if (t.length) return t.map($1ac6b009926371d3$export$df2b736a06860be7).join(",");
};
function $1ac6b009926371d3$export$f09d9444954afeda(r, t, e = {}, o = {}) {
    let n = (0, $2C0hZ.exec).call(this, t || e[r]);
    if (n == null) return;
    let i;
    if ((0, $czfS0.isString)(n)) {
        if (/^(?:env|var)\(/.test(n.trim())) return {
            [r]: n
        };
        if (n.includes("(")) {
            const S = (0, $d52u8.getFnPrefixAndValue)(n);
            i = S[0], n = S[1];
        }
        const c = e.scaleBoxSize, E = (0, $amsMb.checkIfBoxSize)(r);
        !c && E && !o.ratio && (n = (0, $amsMb.splitSpacedValue)(n));
    }
    return o.ratio ? (0, $amsMb.getSpacingBasedOnRatio)(e, r, n, i) : (0, $amsMb.getSpacingByKey)(n, r, void 0, i);
}
const $1ac6b009926371d3$export$b6e34d20a288a08c = (r, t = null, e)=>$1ac6b009926371d3$export$f09d9444954afeda(r, t, e, {
        ratio: !0
    }), $1ac6b009926371d3$var$H = (r, t, e)=>(0, $czfS0.isString)(r) ? (0, $hzNzB.splitTopLevelSpaces)(r).map((o)=>(0, $d52u8.BARE_SEQUENCE_TOKEN_RE).test(o) ? (0, $amsMb.getSpacingBasedOnRatio)(t, e, o)[e] : o).join(" ") : r, $1ac6b009926371d3$export$7150732276d3a7a2 = (r, t, e, o = "borderRadius")=>{
    if ((0, $czfS0.isString)(r)) return {
        [o]: (0, $hzNzB.splitTopLevelSpaces)(r).map((n)=>{
            const i = (0, $bvD2U.getShapeByKey)(n);
            return i !== void 0 ? $1ac6b009926371d3$var$H(i, t, e) : (0, $amsMb.getSpacingBasedOnRatio)(t, e, n)[e];
        }).join(" ")
    };
};

});

parcelRegister("7o2OS", function(module, exports) {

var $521xJ = parcelRequire("521xJ");
parcelRequire("jPKwi");
var $4MQe6 = parcelRequire("4MQe6");
var $9rUXD = parcelRequire("9rUXD");
var $aejgr = parcelRequire("aejgr");
var $amsMb = parcelRequire("amsMb");
var $ZN2Fd = parcelRequire("ZN2Fd");
var $13hKf = parcelRequire("13hKf");
var $5koEk = parcelRequire("5koEk");
var $amQH3 = parcelRequire("amQH3");
var $iSfnd = parcelRequire("iSfnd");
var $dxw8L = parcelRequire("dxw8L");
var $habKp = parcelRequire("habKp");
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
var $czfS0 = parcelRequire("czfS0");

var $dCzXU = parcelRequire("dCzXU");
const $560cf630af0bcff2$var$p = "__smblsThemeRootOwner", $560cf630af0bcff2$var$b = (t)=>{
    const s = t && t.__prefersListener, e = t && t.__prefersMq;
    if (s && e) try {
        typeof e.removeEventListener == "function" ? e.removeEventListener("change", s) : typeof e.removeListener == "function" && e.removeListener(s);
    } catch  {
        try {
            e.removeListener(s);
        } catch  {}
    }
    t && (t.__prefersListener = null, t.__prefersMq = null);
}, $560cf630af0bcff2$var$$ = (t, s, e)=>{
    if (!(!t || !s)) {
        $560cf630af0bcff2$var$b(t), t.__prefersListener = e, t.__prefersMq = s;
        try {
            s.addEventListener("change", e);
        } catch  {
            s.addListener(e);
        }
    }
}, $560cf630af0bcff2$var$de = (t, s)=>{
    const e = (0, $521xJ.getActiveConfig)(), { cssVars: n } = e, o = s.startsWith("--") ? s : `--${s}`;
    return n[o] = t, t;
}, $560cf630af0bcff2$var$d = (t)=>t, $560cf630af0bcff2$var$he = (t, s)=>{
    if ((0, $czfS0.isString)(t) || (0, $czfS0.isNumber)(t)) {
        const e = (0, $521xJ.getActiveConfig)();
        if (e.cssVars && s) {
            const n = e.varPrefix ? e.varPrefix + "-" : "";
            e.cssVars[`--${n}size-${s}`] = t;
        }
    }
    return t;
}, $560cf630af0bcff2$export$9ae1d0dd64d4a382 = {
    color: (0, $5koEk.setColor),
    gradient: (0, $5koEk.setGradient),
    font: (0, $amQH3.setFont),
    fontFamily: (0, $amQH3.setFontFamily),
    fontfamily: (0, $amQH3.setFontFamily),
    theme: (0, $habKp.setTheme),
    icons: (0, $dxw8L.setSvgIcon),
    semanticIcons: $560cf630af0bcff2$var$d,
    semanticicons: $560cf630af0bcff2$var$d,
    svg: (0, $dxw8L.setSVG),
    svgData: $560cf630af0bcff2$var$d,
    typography: $560cf630af0bcff2$var$d,
    shadow: (0, $iSfnd.setShadow),
    spacing: $560cf630af0bcff2$var$d,
    media: $560cf630af0bcff2$var$d,
    grid: $560cf630af0bcff2$var$d,
    class: $560cf630af0bcff2$var$d,
    timing: $560cf630af0bcff2$var$d,
    reset: $560cf630af0bcff2$var$d,
    unit: $560cf630af0bcff2$var$d,
    animation: $560cf630af0bcff2$var$d,
    vars: $560cf630af0bcff2$var$de,
    sizes: $560cf630af0bcff2$var$he,
    shape: $560cf630af0bcff2$var$d,
    skins: $560cf630af0bcff2$var$d,
    viewTransition: $560cf630af0bcff2$var$d
}, $560cf630af0bcff2$var$me = new Map([
    [
        "gradient",
        [
            "color"
        ]
    ],
    [
        "theme",
        [
            "color",
            "gradient",
            "skins"
        ]
    ],
    [
        "shadow",
        [
            "color"
        ]
    ]
]), $560cf630af0bcff2$var$ue = (t, s, e, n)=>{
    (0, $dCzXU.parkHostObject)(t, e, s);
    const o = {};
    for (const r of n)t[r] === s && (t[r] = o);
    return t.verbose, o;
}, $560cf630af0bcff2$export$80746c6bc6142fc8 = (t, s, e)=>{
    const n = (0, $521xJ.getActiveConfig)(), o = (0, $521xJ.toCamel)(t), r = o.toLowerCase(), a = n[o] || n[r] || n[t], i = (0, $dCzXU.isHostObject)(a) ? $560cf630af0bcff2$var$ue(n, a, r, [
        o,
        r,
        t
    ]) : a, f = $560cf630af0bcff2$export$9ae1d0dd64d4a382[o] || $560cf630af0bcff2$export$9ae1d0dd64d4a382[r];
    if (f) try {
        const l = f(s, e);
        return i && (i[e] = l), i;
    } catch (l) {
        n.verbose;
    }
    if (!f) {
        const l = i || (n[r] = {});
        return l[e] = s, l;
    }
    n.verbose;
}, $560cf630af0bcff2$export$943920cf7e6d5f23 = (t, s)=>{
    const e = (0, $521xJ.getActiveConfig)(), n = t.toLowerCase();
    if ((0, $dCzXU.isHostObject)(s)) return (0, $dCzXU.parkHostObject)(e, n, s), e.verbose, e[n] || e[t];
    if (s == null) return e.verbose, e[n] || e[t];
    const o = Object.keys(s).sort((r, a)=>{
        const i = (0, $czfS0.isObject)(s[r]) || (0, $czfS0.isArray)(s[r]) ? 1 : 0, f = (0, $czfS0.isObject)(s[a]) || (0, $czfS0.isArray)(s[a]) ? 1 : 0;
        return i - f;
    });
    if (n === "color") {
        const r = e[n] || (e[n] = {});
        for (const a of o)a in r || (r[a] = s[a]);
    }
    return o.forEach((r)=>{
        try {
            return $560cf630af0bcff2$export$80746c6bc6142fc8(n, s[r], r);
        } catch (a) {
            e.verbose;
        }
    }), e[n] || e[t];
}, $560cf630af0bcff2$export$204c4d227c4ac61c = (t, s)=>{
    const e = s || (0, $521xJ.getActiveConfig)();
    e.globalTheme = t;
    const o = (0, $dCzXU.resolveConfigDocument)(e) || (typeof document < "u" ? document : null), r = o && o.defaultView || (typeof window < "u" ? window : null);
    if (o) {
        const i = e.themeRoot || o.documentElement, f = t && t !== "auto";
        if (i[$560cf630af0bcff2$var$p] = e, f) $560cf630af0bcff2$var$b(e), i.setAttribute("data-theme", t), e.resolvedTheme = t, t === "dark" || t === "light" ? i.style.colorScheme = t : i.style.colorScheme = "light dark";
        else if (r && r.matchMedia) {
            const l = (_)=>{
                const g = _.matches ? "dark" : "light";
                i.setAttribute("data-theme", g), e.resolvedTheme = g;
            }, u = r.matchMedia("(prefers-color-scheme: dark)");
            l(u), i.style.colorScheme = "light dark", $560cf630af0bcff2$var$$(e, u, l);
        } else $560cf630af0bcff2$var$b(e), i.setAttribute("data-theme", "light"), e.resolvedTheme = "light", i.style.colorScheme = "light";
    }
    const a = e.varPrefix ? `--${e.varPrefix}-theme-` : "--theme-";
    for(const i in e.cssVars)i.startsWith(a) && delete e.cssVars[i];
    for(const i in e.cssMediaVars)delete e.cssMediaVars[i];
    if (o && e.cssVars) {
        const i = e.scopeSelector || ":root", f = o.styleSheets;
        for(let l = 0; l < f.length; l++)try {
            const u = f[l].cssRules;
            for(let _ = 0; _ < u.length; _++)if (u[_].selectorText === i) {
                for(const g in e.cssVars)u[_].style.setProperty(g, e.cssVars[g]);
                return e;
            }
        } catch  {}
    }
    return e;
}, $560cf630af0bcff2$export$c9393dc896217e3 = (t)=>{
    const e = (0, $dCzXU.resolveConfigDocument)(t) || (typeof document < "u" ? document : null), n = e && e.defaultView || (typeof window < "u" ? window : null), o = e && (t.themeRoot || e.documentElement);
    if (o && typeof o.setAttribute == "function") {
        if (t.globalTheme && t.globalTheme !== "auto") $560cf630af0bcff2$var$b(t), o.setAttribute("data-theme", t.globalTheme), t.resolvedTheme = t.globalTheme, o[$560cf630af0bcff2$var$p] = t, t.globalTheme === "dark" || t.globalTheme === "light" ? o.style.colorScheme = t.globalTheme : o.style.colorScheme = "light dark";
        else if (o[$560cf630af0bcff2$var$p] && o[$560cf630af0bcff2$var$p] !== t && o.hasAttribute("data-theme")) $560cf630af0bcff2$var$b(t), t.resolvedTheme = o.getAttribute("data-theme");
        else if (n && n.matchMedia) {
            const a = (f)=>{
                const l = f.matches ? "dark" : "light";
                o.setAttribute("data-theme", l), t.resolvedTheme = l;
            }, i = n.matchMedia("(prefers-color-scheme: dark)");
            a(i), o.style.colorScheme = "light dark", o[$560cf630af0bcff2$var$p] = t, $560cf630af0bcff2$var$$(t, i, a);
        } else $560cf630af0bcff2$var$b(t), o.setAttribute("data-theme", "light"), t.resolvedTheme = "light", o.style.colorScheme = "light", o[$560cf630af0bcff2$var$p] = t;
    }
}, $560cf630af0bcff2$var$pe = {}, $560cf630af0bcff2$export$adaa4cf7ef1b65be = (t, s = $560cf630af0bcff2$var$pe)=>{
    let e = s.config || (0, $521xJ.getActiveConfig)();
    const { version: n, verbose: o, useVariable: r, useReset: a, useSvgSprite: i, useFontImport: f, useIconSprite: l, globalTheme: u, themeRoot: _, useDocumentTheme: g, useDefaultConfig: E, semanticIcons: w, hoverMedia: V, focusableRing: L, faceWait: A, files: M, assets: R, ...m } = t;
    s.newConfig && (e = (0, $521xJ.setActiveConfig)(s.newConfig)), (0, $dCzXU.isDomDocument)(m.document) && (e.__domDocument = m.document, delete m.document), (0, $dCzXU.isDomDocument)(e.document) && (e.__domDocument || (e.__domDocument = e.document), e.document = {}), M !== void 0 && (e.files = M), R !== void 0 && (e.assets = R), o !== void 0 && (e.verbose = o), r !== void 0 && (e.useVariable = r), a !== void 0 && (e.useReset = a), f !== void 0 && (e.useFontImport = f), i !== void 0 && (e.useSvgSprite = i), l !== void 0 && (e.useIconSprite = l), g !== void 0 && (e.useDocumentTheme = g), u !== void 0 && (e.globalTheme = u), _ !== void 0 && (e.themeRoot = _), t.useThemeSuffixedVars !== void 0 && (e.useThemeSuffixedVars = t.useThemeSuffixedVars), E !== void 0 && (e.useDefaultConfig = E), w !== void 0 && (e.semanticIcons = w), V !== void 0 && (e.hoverMedia = V), L !== void 0 && (e.focusableRing = L), A !== void 0 && (e.faceWait = A), e.verbose, $560cf630af0bcff2$export$c9393dc896217e3(e), e.__svgCache || (e.__svgCache = {}), (0, $521xJ.aliasCaseVariants)(m);
    const T = Object.keys(m).filter((c)=>!c.startsWith("__")), x = new Set(T);
    T.forEach((c)=>{
        const h = c.toLowerCase();
        h !== c && x.has(h) && (0, $2C0hZ.deepMerge)(m[h], m[c], (0, $521xJ.CONFIG_MERGE_EXL));
    });
    const D = [], k = new Set;
    T.forEach((c)=>{
        const h = c.toLowerCase(), y = h !== c && x.has(h) ? h : c;
        k.has(y) || (k.add(y), D.push(y));
    });
    const v = new Map;
    D.forEach((c)=>{
        const h = c.toLowerCase();
        v.has(h) || v.set(h, []), v.get(h).push(c);
    });
    const P = new Set, B = (c)=>{
        if (P.has(c)) return;
        P.add(c);
        const h = $560cf630af0bcff2$var$me.get(c.toLowerCase());
        h && h.forEach((y)=>(v.get(y) || []).forEach(B)), $560cf630af0bcff2$export$943920cf7e6d5f23(c, m[c]);
    };
    if (D.forEach(B), e.varPrefix && (e.typography && (e.typography.varPrefix = e.varPrefix), e.spacing && (e.spacing.varPrefix = e.varPrefix), e.timing && (e.timing.varPrefix = e.varPrefix)), m.typography) try {
        (0, $13hKf.applyTypographySequence)();
    } catch (c) {
        e.verbose;
    }
    if (m.spacing) try {
        (0, $amsMb.applySpacingSequence)();
    } catch (c) {
        e.verbose;
    }
    if (m.timing) try {
        (0, $ZN2Fd.applyTimingSequence)();
    } catch (c) {
        e.verbose;
    }
    try {
        (0, $aejgr.applySkins)();
    } catch (c) {
        e.verbose;
    }
    (0, $4MQe6.applyDocument)();
    const O = (0, $9rUXD.applyReset)();
    return O && (e.reset = O), e;
};

});

parcelRegister("65xUz", function(module, exports) {
const $46ed83d4d680828d$export$25cbd92da20f67d0 = 1, $46ed83d4d680828d$export$f3ac9ba7fe670123 = [
    "font",
    "files",
    "assets",
    "themeRoot"
], $46ed83d4d680828d$var$h = new Set($46ed83d4d680828d$export$f3ac9ba7fe670123), $46ed83d4d680828d$var$y = "$smbls", $46ed83d4d680828d$var$b = (n)=>{
    if (n === null || typeof n != "object") return !1;
    const s = Object.getPrototypeOf(n);
    return s === Object.prototype || s === null;
}, $46ed83d4d680828d$var$j = (n)=>n.startsWith("__") || $46ed83d4d680828d$var$h.has(n), $46ed83d4d680828d$export$fa8157df3262779b = (n)=>{
    if (!$46ed83d4d680828d$var$b(n)) return null;
    const s = new Map;
    let i = !1;
    const o = (t)=>{
        if (i) return;
        if (t === void 0) return {
            [$46ed83d4d680828d$var$y]: "u"
        };
        if (t === null || typeof t == "string" || typeof t == "boolean") return t;
        if (typeof t == "number") return Number.isFinite(t) && !Object.is(t, -0) ? t : {
            [$46ed83d4d680828d$var$y]: "n",
            v: Object.is(t, -0) ? "-0" : String(t)
        };
        if (typeof t != "object") {
            i = !0;
            return;
        }
        const c = s.get(t);
        if (c !== void 0) return {
            [$46ed83d4d680828d$var$y]: "r",
            i: c
        };
        if (Array.isArray(t)) {
            s.set(t, s.size);
            const r = new Array(t.length);
            for(let e = 0; e < t.length; e++){
                if (!(e in t)) {
                    i = !0;
                    return;
                }
                r[e] = o(t[e]);
            }
            return r;
        }
        if (!$46ed83d4d680828d$var$b(t) || Object.prototype.hasOwnProperty.call(t, $46ed83d4d680828d$var$y)) {
            i = !0;
            return;
        }
        s.set(t, s.size);
        const f = {};
        for (const r of Object.keys(t))f[r] = o(t[r]);
        return f;
    }, u = {};
    for (const t of Object.keys(n))if (!$46ed83d4d680828d$var$j(t) && (u[t] = o(n[t]), i)) return null;
    return u;
}, $46ed83d4d680828d$var$O = (n, s)=>{
    const i = Object.keys(s);
    let o = 0;
    for(const u in n){
        if (o === i.length) return !0;
        if (u !== i[o]) return !1;
        o++;
    }
    return o === i.length;
}, $46ed83d4d680828d$export$ecd4c005eee17d6 = (n, s)=>{
    const i = [], o = (t, c)=>{
        if (t === null || typeof t != "object") return t;
        if (Array.isArray(t)) {
            const e = new Array(t.length);
            i.push(e);
            for(let p = 0; p < t.length; p++)e[p] = o(t[p]);
            return e;
        }
        const f = t[$46ed83d4d680828d$var$y];
        if (typeof f == "string") {
            if (f === "u") return;
            if (f === "n") return t.v === "-0" ? -0 : Number(t.v);
            if (f === "r") return i[t.i];
        }
        let r = c;
        if (r && !$46ed83d4d680828d$var$O(t, r)) for (const e of Object.keys(r))delete r[e];
        else r || (r = {});
        i.push(r);
        for(const e in t)r[e] = o(t[e]);
        return r;
    }, u = new Set;
    for(const t in n){
        const c = n[t], f = s[t], r = $46ed83d4d680828d$var$b(f) && !u.has(f) && $46ed83d4d680828d$var$b(c) && typeof c[$46ed83d4d680828d$var$y] != "string" ? f : null;
        r && u.add(r);
        const e = o(c, r);
        e !== f && (s[t] = e);
    }
    return s;
};

});



parcelRegister("hVZUs", function(module, exports) {

$parcel$export(module.exports, "makeEmbedCompatMethods", () => $d0e7c881eb2b1232$export$df8f947ab43a4dfa);
$parcel$export(module.exports, "embedCompatMethods", () => $d0e7c881eb2b1232$export$dedfaa378f933b16);
// embedCompatMethods — compat method-set for the legacy `system/platform`
// project whose pages render inside canvas embed tiles (CanvasItem).
//
// Those pages were authored against the platform app-shell runtime
// (`~/www/next/platform-legacy/uikit/methods/*`) and call project-scoped
// element methods directly — `el.getDesignSystem()`, `el.getData()`,
// `el.isCanvas()`, … The embed runtime (`createIframeApp`) never registered
// those methods, so every reference threw `… is not a function`, caught
// per-element by `if:` / effect guards but flooding the console.
//
// These implementations are COPIED from platform-legacy/uikit/methods (root.js,
// db.js, design-system.js, project.js, canvas.js) and ADAPTED for the embed:
// the platform versions read the platform app-shell state
// (`window.platformState`, `root.key === 'platform'`, `DEFAULTS`, schema, …)
// which does NOT exist inside an embed iframe — a verbatim copy would throw on
// null destructure. So every base accessor here returns an empty shape instead
// of throwing, and the leaf methods degrade to `undefined`/`{}` so the platform
// pages' `if:` guards simply read false and skip those subtrees.
//
// Registered as the LOWEST-priority method layer in createIframeApp
// (`{ ...embedCompatMethods, ...project.methods, ...contextOverrides.methods }`)
// so a project's own method of the same name always wins.
// Safe root-state read. v3.14 exposes `getRootState` on the element proto; the
// embed root state is the project's `state`. Never throws.
// USER-CODE-ORIGIN: ONE self-contained factory. The opaque user-code frame
// (userCodeFrame.js) cannot share objects with the parent, so its bootstrap
// carries this factory as TEXT (`makeEmbedCompatMethods.toString()`) and calls
// it inside the frame. Everything it needs therefore lives INSIDE the function:
// no module-scope helper, no import, and ES2017 syntax only (no object spread,
// no optional catch binding) so no bundler helper is referenced by the text.
// The parent-realm export below is the same factory, called once.
function $d0e7c881eb2b1232$export$df8f947ab43a4dfa() {
    // Safe root-state read. v3.14 exposes `getRootState` on the element proto;
    // the embed root state is the project's `state`. Never throws.
    function _rootState(self, key) {
        var state;
        try {
            state = self.getRootState && self.getRootState();
        } catch (e) {
            state = null;
        }
        state = state || {};
        return key ? state[key] : state;
    }
    // Mirror platform `getData`'s shape, sourced from the embed context (where
    // designSystem/components/etc. actually live) + root state. Every field is
    // an object so downstream `key in value` / `value[key]` reads never throw.
    function _data(self, key) {
        var ctx = self && self.context || {};
        var rs = _rootState(self);
        var data = {
            designSystem: ctx.designSystem || {},
            state: rs || {},
            components: ctx.components || {},
            snippets: ctx.snippets || {},
            pages: ctx.pages || {},
            functions: ctx.functions || {},
            methods: ctx.methods || {},
            files: ctx.files || rs.files || {},
            dependencies: ctx.dependencies || rs.dependencies || {}
        };
        return key ? data[key] || {} : data;
    }
    var _noop = function() {
        return undefined;
    };
    var _falseFn = function() {
        return false;
    };
    // The realtime event bus the legacy pages subscribe to
    // (`el.sdk.rootBus.on(…)`, `.emit(…)`) — no-op in the embed (no collab
    // session).
    var _embedBus = {
        on: _noop,
        off: _noop,
        once: _noop,
        emit: _noop
    };
    // Permission/state predicates the legacy pages call INSIDE `if:` guards —
    // must return a FALSY value so the guarded editor-only subtree is skipped in
    // the read-only embed, rather than throwing `el.sdk.<x> is not a function`.
    var _SDK_FALSE = [
        'hasPermission',
        'isAuthorised',
        'isAuthorized',
        'isOwner',
        'can',
        'isReady'
    ];
    // Embed SDK shim (2026-06-16, workspace.md "Embed runtime parity" sub-item:
    // `el.sdk` undefined inside `if:` guards). The legacy `system/platform`
    // pages read `el.sdk.*` directly — permission guards
    // (`el.sdk.hasPermission('iam')`), the realtime `rootBus`,
    // undo/redo/checkpoint, getProjectByKey, … The embed has no SDK, so
    // `el.sdk` was undefined and every access threw (caught by the pages'
    // `if:`/effect guards but flooding the console). smbls exposes a
    // NON-function `context.methods` entry as the shared `el.sdk` PROPERTY
    // (element/src/methods.js getContextProto), so this Proxy degrades every
    // access safely: permission checks read false, `rootBus.on/emit` no-op,
    // every other method returns undefined (await-safe). `then` is undefined so
    // the proxy is never mistaken for a thenable (which would hang an
    // accidental `await`).
    var _embedSdkStub = new Proxy({}, {
        get: function(_t, prop) {
            if (prop === 'rootBus') return _embedBus;
            if (prop === 'then' || typeof prop === 'symbol') return undefined;
            if (_SDK_FALSE.indexOf(prop) !== -1) return _falseFn;
            return _noop;
        }
    });
    return {
        // Shared `el.sdk` property (non-function → exposed as a property, not a
        // method). A project's own `sdk` in project.methods still wins.
        sdk: _embedSdkStub,
        // --- root.js ---
        getData: function(key) {
            return _data(this, key);
        },
        getAppKey: function() {
            return _rootState(this, 'appKey');
        },
        getSecrets: function(key) {
            var secrets = _rootState(this, 'secrets') || {};
            return key ? secrets[key] : secrets;
        },
        getDependencies: function(key) {
            var dependencies = _data(this, 'dependencies');
            return key ? dependencies[key] : dependencies;
        },
        getPackages: function(key) {
            var schema = _rootState(this, 'schema') || {};
            var packages = schema.dependencies || {};
            return key ? packages[key] : packages;
        },
        getUserSettings: function(key) {
            var userSettings = _rootState(this, 'user') || {};
            return key ? userSettings[key] : userSettings;
        },
        getFiles: function(key) {
            var files = _data(this, 'files');
            return key ? files[key] : files;
        },
        // --- design-system.js ---
        // Read the prepared design system off the embed context (scratch CONFIG),
        // tolerating both lowercase (canonical) and UPPERCASE (legacy) category keys.
        getDesignSystem: function(type) {
            var ds = this.context && this.context.designSystem || {};
            if (type) {
                var lower = ds[type.toLowerCase()];
                var upper = ds[type.toUpperCase()];
                return Object.assign({}, upper || {}, lower || {});
            }
            return ds;
        },
        // --- project.js ---
        getActiveBranch: function() {
            return _rootState(this, 'branch') || 'main';
        },
        // --- db.js ---
        // Defensive embed port: find an item's value across the project data shape;
        // return its `{ value }` wrapper, or undefined when absent (no platform
        // schema in the embed). Iterates only object values so `key in v` is safe.
        getItem: function(key) {
            if (!key) return;
            var data = _data(this);
            for(var cat in data){
                var bucket = data[cat];
                if (bucket && typeof bucket === 'object' && key in bucket) return {
                    value: bucket[key]
                };
            }
        },
        // --- root.js getGlobalTheme ---
        // The theme the embedded app runs in. The platform version read the
        // EDITOR's `sceneTheme` off the platform root state; inside an embed the
        // answer is the app's own resolved theme: a root-state `sceneTheme` if the
        // project keeps one, else the `data-theme` the framework stamped on the
        // app root, else the configured `globalTheme`.
        getGlobalTheme: function() {
            var rs = _rootState(this);
            if (rs && rs.sceneTheme) return rs.sceneTheme;
            var ctx = this.context || {};
            var doc = ctx.document || (typeof document !== 'undefined' ? document : null);
            var stamped = doc && doc.documentElement && doc.documentElement.getAttribute('data-theme');
            if (stamped) return stamped;
            return ctx.designSystem && ctx.designSystem.globalTheme || 'light';
        },
        // --- canvas.js ---
        // Inside an embed iframe the app is, by definition, an embed — not the
        // platform canvas editor and not the dashboard. Static values; no window
        // location parsing (which the platform versions used against the editor URL).
        isEmbed: function() {
            return true;
        },
        isCanvas: function() {
            return false;
        },
        isDashboard: function() {
            return false;
        }
    };
}
const $d0e7c881eb2b1232$export$dedfaa378f933b16 = $d0e7c881eb2b1232$export$df8f947ab43a4dfa();
var $d0e7c881eb2b1232$export$2e2bcd8739ae039 = $d0e7c881eb2b1232$export$dedfaa378f933b16;

});

parcelRegister("aAzQ3", function(module, exports) {

$parcel$export(module.exports, "makeEmbedModuleStubs", () => $7b5910fa55d576d4$export$9ef1ac623f486f43);
$parcel$export(module.exports, "buildEmbedImportMap", () => $7b5910fa55d576d4$export$f51e0037e1d15f86);
$parcel$export(module.exports, "registerEmbedModuleStubs", () => $7b5910fa55d576d4$export$1074d5c88cdfb083);
// embedModuleStubs — embed-appropriate stubs for bare npm specifiers the legacy
// `system/platform` pages import at runtime.
//
// frank serializes project methods that `import X from 'prismjs'` / 'fuse.js'
// into a runtime `await import('prismjs')` inside the destringified function
// (scopeRewriter.js buildNpmModuleInjection), resolved registry-first via
// `globalThis.__SMBLS_PKGS__` then falling back to a bare `await import()`. In
// an embed iframe that bare specifier hits native ESM resolution with no
// import-map → `Failed to resolve module specifier 'prismjs'`.
//
// In a static embed tile, syntax highlighting (prismjs) and fuzzy search
// (fuse.js) are non-functional decorations, so a no-op stub is the correct
// degradation: the page renders (unhighlighted code, empty search) instead of
// throwing. Registered registry-first so a real module — if ever resolvable —
// still wins (additive; never overwrites an existing entry).
// --- prismjs ---------------------------------------------------------------
// Imported both as default (`import Prism from 'prismjs'`) and namespace; the
// API lives on both shapes so `__mod.default || __mod` and `Prism.highlight`
// both resolve.
// USER-CODE-ORIGIN: one self-contained factory, so the opaque user-code
// frame's bootstrap can carry it as TEXT (`makeEmbedModuleStubs.toString()`)
// and build the same registry inside the frame. No closure, no import.
function $7b5910fa55d576d4$export$9ef1ac623f486f43() {
    var noop = function() {};
    var prismApi = {
        highlight: function(code) {
            return code;
        },
        highlightElement: noop,
        highlightAll: noop,
        highlightAllUnder: noop,
        languages: {},
        hooks: {
            add: noop,
            run: noop
        },
        tokenize: function() {
            return [];
        },
        plugins: {}
    };
    var PRISM_NS = Object.assign({}, prismApi, {
        default: prismApi
    });
    class FuseStub {
        constructor(list, options){
            this._list = Array.isArray(list) ? list : [];
            this._options = options || {};
        }
        search() {
            return [];
        }
        setCollection(list) {
            this._list = Array.isArray(list) ? list : [];
        }
        add() {}
        remove() {
            return [];
        }
        removeAt() {}
        getIndex() {
            return {};
        }
        static createIndex() {
            return {};
        }
        static parseIndex() {
            return {};
        }
    }
    var FUSE_NS = {
        default: FuseStub,
        Fuse: FuseStub
    };
    return {
        prismjs: PRISM_NS,
        'fuse.js': FUSE_NS
    };
}
const $7b5910fa55d576d4$export$4082afb7c5cfd7f0 = $7b5910fa55d576d4$export$9ef1ac623f486f43();
// --- import-map fallback for LEGACY-serialized projects --------------------
// The __SMBLS_PKGS__ registry above only helps projects frank-serialized with
// the registry-first preamble. The `system/platform` project's data predates
// that change, so its methods emit a BARE `await import('prismjs')` that never
// consults __SMBLS_PKGS__ (verified in-browser: stubs registered, import still
// failed). An import-map in the iframe document resolves the bare specifier at
// the module-resolution layer regardless of serialization vintage. Each stub is
// a tiny ESM module exposed via a data: URL.
const $7b5910fa55d576d4$var$ESM_SOURCES = {
    prismjs: "const P={highlight:c=>c,highlightElement(){},highlightAll(){},highlightAllUnder(){},languages:{},hooks:{add(){},run(){}},tokenize(){return[]},plugins:{}};export default P;export const highlight=P.highlight;export const languages=P.languages;export const hooks=P.hooks;",
    'fuse.js': "class Fuse{constructor(l=[],o={}){this._list=Array.isArray(l)?l:[];this._options=o}search(){return[]}setCollection(l=[]){this._list=Array.isArray(l)?l:[]}add(){}remove(){return[]}removeAt(){}getIndex(){return{}}static createIndex(){return{}}static parseIndex(){return{}}}export default Fuse;export{Fuse};"
};
const $7b5910fa55d576d4$var$toDataUrl = (src)=>'data:text/javascript;charset=utf-8,' + encodeURIComponent(src);
function $7b5910fa55d576d4$export$f51e0037e1d15f86() {
    const imports = {};
    for(const spec in $7b5910fa55d576d4$var$ESM_SOURCES)imports[spec] = $7b5910fa55d576d4$var$toDataUrl($7b5910fa55d576d4$var$ESM_SOURCES[spec]);
    return `<script type="importmap">${JSON.stringify({
        imports: imports
    })}</script>`;
}
function $7b5910fa55d576d4$export$1074d5c88cdfb083(...targets) {
    for (const target of targets){
        if (!target) continue;
        const store = target.__SMBLS_PKGS__ || (target.__SMBLS_PKGS__ = {});
        for(const name in $7b5910fa55d576d4$export$4082afb7c5cfd7f0)if (!store[name]) store[name] = $7b5910fa55d576d4$export$4082afb7c5cfd7f0[name];
    }
}
var $7b5910fa55d576d4$export$2e2bcd8739ae039 = $7b5910fa55d576d4$export$1074d5c88cdfb083;

});

parcelRegister("d5UPr", function(module, exports) {

$parcel$export(module.exports, "usesRealmBoundGlobal", () => $9887d2f9e946d238$export$5d763f28be33232e);
// EMBED-RERALM-SOURCE-TEXT-GATE-1 — the STRUCTURAL gate for `rerealmFunctions`.
//
// WHAT THIS REPLACES. The gate used to be a substring test:
//
//     const GLOBAL_REF_RE = /\b(window|document)\s*\./
//     if (NATIVE_RE.test(src) || !GLOBAL_REF_RE.test(src)) continue
//
// A function was re-realmed into the iframe realm ONLY if its own source text
// literally contained `window.` or `document.`. Everything that reaches a
// realm-bound global another way was silently skipped: `globalThis.`, `self.`,
// `top.`/`parent.`, an alias declared inside the function (`const w = window`),
// a bare call (`requestAnimationFrame(…)`, `new Image()`), or a bare read
// (`location`, `navigator`, `localStorage`).
//
// WIDENING THE REGEX IS THE TRAP. `window|document|globalThis|self|top` makes
// the next four shapes pass and the fifth fail, one level along. The gate has
// to be derived from the function's STRUCTURE, not from a substring of it.
//
// WHAT THIS IS. A dependency-free scanner that computes the function's FREE
// IDENTIFIERS — identifiers it reads that it does not itself bind (not params,
// not `var`/`let`/`const`/`function`/`class`/`catch` bindings, not member
// property names after `.`/`?.`, not object-literal keys, not anything inside a
// string, template chunk, regex literal or comment). The gate is then exact:
//
//     re-realm  ⇔  the function has a free identifier that is realm-bound
//
// WHY NOT `acorn`. acorn is present in the tree only as a hoisted transitive
// dep, and this file is on the embed BOOT path — `createIframeApp.js` already
// refuses the `smbls` barrel and dynamic-imports `create` for exactly that
// budget reason (see its header). A ~120 KB parser to answer one boolean would
// undo that. This scanner is ~5 KB and answers the same boolean.
//
// WHY NOT "re-realm everything". Measured, and it is wrong on BOTH axes —
// see the numbers and the double-side-effect proof in `rerealmGate.test.js`.
// `frameWindow.eval('(' + src + ')')` recompiles the function in the FRAME's
// GLOBAL scope, so it DROPS THE CLOSURE. A function that closes over anything
// then throws `ReferenceError` on call and is re-run in the parent realm by the
// fallback wrapper — after any side effect it already performed. Re-realming
// unconditionally turns every closure-using function into a
// may-run-its-side-effects-twice function. The free-identifier analysis is what
// tells the two apart, so it buys correctness, not only speed.
// MEASURED, live, on the bellforge canvas board (23 embed tiles, Chrome,
// 2026-08-21) over 5550 real function sources reachable from the running
// shell context:
//   old text gate selected  252
//   this gate selected      420   (+168 net)
//   newly caught            193 — globalThis 57, setTimeout 49, window 37
//                           (free but never as `window.`), clearTimeout 33,
//                           localStorage 15, document 12, clearInterval 7,
//                           fetch 5, HTMLElement 5, navigator 5,
//                           requestAnimationFrame 4, self 4
//   no longer caught         25 — the old gate's FALSE positives: `window.` /
//                           `document.` occurring only inside a string, a
//                           comment, a regex literal, a member expression or
//                           an object key. Each of those cost a dropped
//                           closure for nothing.
// Cost on the same population, real tile `contentWindow`: scan 12.6 µs/fn
// (53.1 ms) vs unconditional frame-eval 31.5 µs/fn (132.9 ms) — the gate is
// ~2.5x cheaper per boot AND keeps the closures.
// The set is realm-BOUND, not "every global". A name belongs here only when
// resolving it in the PARENT realm from inside a frame is a bug: the parent's
// object is a different object (`document`, `location`, `localStorage`), or the
// work it schedules/creates is owned by the wrong document (timers, observers,
// `Image`, DOM constructors used with `instanceof`). Pure, realm-agnostic
// globals (`JSON`, `Math`, `Object`, `Promise`, `Date`, `Symbol`, …) are
// deliberately ABSENT — re-realming for them would cost a closure for nothing.
//
// This list is the SINGLE source of truth. `rerealmFunctions` names none of
// these; the test enumerates its cases FROM this set, so a name added here is
// covered without touching either file.
const $9887d2f9e946d238$export$734cc4f296c02d7a = new Set([
    // the realm handles themselves
    'window',
    'document',
    'globalThis',
    'self',
    'top',
    'parent',
    'frames',
    'frameElement',
    // per-document singletons
    'location',
    'navigator',
    'history',
    'screen',
    'visualViewport',
    'localStorage',
    'sessionStorage',
    'indexedDB',
    'caches',
    'customElements',
    'performance',
    'crypto',
    'speechSynthesis',
    // per-document geometry / view
    'innerWidth',
    'innerHeight',
    'outerWidth',
    'outerHeight',
    'devicePixelRatio',
    'scrollX',
    'scrollY',
    'pageXOffset',
    'pageYOffset',
    'screenX',
    'screenY',
    'matchMedia',
    'getComputedStyle',
    'getSelection',
    'scrollTo',
    'scrollBy',
    // scheduling — a parent-realm timer outlives the frame it was meant for
    'setTimeout',
    'setInterval',
    'clearTimeout',
    'clearInterval',
    'requestAnimationFrame',
    'cancelAnimationFrame',
    'requestIdleCallback',
    'cancelIdleCallback',
    'queueMicrotask',
    // network / transport bound to the document's origin + lifetime
    'fetch',
    'XMLHttpRequest',
    'WebSocket',
    'EventSource',
    'Worker',
    'SharedWorker',
    'BroadcastChannel',
    'navigatorCredentials',
    // constructors whose instances belong to a document
    'Image',
    'Audio',
    'Option',
    'FileReader',
    'DOMParser',
    'XSLTProcessor',
    'MutationObserver',
    'ResizeObserver',
    'IntersectionObserver',
    'PerformanceObserver',
    // cross-realm `instanceof` — the classic silent false
    'Node',
    'Element',
    'HTMLElement',
    'SVGElement',
    'DocumentFragment',
    'ShadowRoot',
    'Event',
    'CustomEvent',
    'MouseEvent',
    'KeyboardEvent',
    'PointerEvent',
    'Range',
    'Selection',
    'CSSStyleSheet',
    'FormData',
    // window-level verbs
    'alert',
    'confirm',
    'prompt',
    'open',
    'close',
    'print',
    'focus',
    'blur',
    'postMessage',
    'addEventListener',
    'removeEventListener',
    'dispatchEvent'
]);
// Built FROM the set above, never hand-typed — a name added there is in the
// prefilter automatically. Word-boundary only; the real decision is the scan.
const $9887d2f9e946d238$var$CHEAP_RE = new RegExp('\\b(' + [
    ...$9887d2f9e946d238$export$734cc4f296c02d7a
].join('|') + ')\\b');
// Reserved words never count as identifier references.
const $9887d2f9e946d238$var$KEYWORDS = new Set([
    'await',
    'break',
    'case',
    'catch',
    'class',
    'const',
    'continue',
    'debugger',
    'default',
    'delete',
    'do',
    'else',
    'enum',
    'export',
    'extends',
    'false',
    'finally',
    'for',
    'function',
    'if',
    'import',
    'in',
    'instanceof',
    'let',
    'new',
    'null',
    'of',
    'return',
    'super',
    'switch',
    'this',
    'throw',
    'true',
    'try',
    'typeof',
    'var',
    'void',
    'while',
    'with',
    'yield',
    'async',
    'static',
    'get',
    'set'
]);
// `(` groups that follow one of these are control-flow heads, never parameters.
const $9887d2f9e946d238$var$CONTROL_HEADS = new Set([
    'if',
    'for',
    'while',
    'switch',
    'return',
    'typeof',
    'void',
    'delete',
    'in',
    'of',
    'new',
    'do',
    'else',
    'case',
    'yield',
    'await',
    'throw'
]);
const $9887d2f9e946d238$var$isIdentStart = (c)=>c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z' || c === '_' || c === '$';
const $9887d2f9e946d238$var$isIdentPart = (c)=>$9887d2f9e946d238$var$isIdentStart(c) || c >= '0' && c <= '9';
const $9887d2f9e946d238$var$isDigit = (c)=>c >= '0' && c <= '9';
// Token shape: { t: 'ident' | 'punc' | 'num', v: string }
// Strings, template chunks, regex literals and comments produce NO token —
// their contents can never be an identifier reference. `${…}` interpolations
// DO produce tokens: `` `${document.title}` `` really does read `document`.
function $9887d2f9e946d238$var$tokenize(src) {
    const out = [];
    const tmplStack = [] // brace depth at each open `${`
    ;
    let braceDepth = 0;
    let i = 0;
    const n = src.length;
    const prev = ()=>out.length ? out[out.length - 1] : null;
    const readTemplate = ()=>{
        // positioned just after the opening backtick
        while(i < n){
            const c = src[i];
            if (c === '\\') {
                i += 2;
                continue;
            }
            if (c === '`') {
                i++;
                return;
            }
            if (c === '$' && src[i + 1] === '{') {
                i += 2;
                tmplStack.push(braceDepth);
                braceDepth++;
                out.push({
                    t: 'punc',
                    v: '{'
                });
                return;
            }
            i++;
        }
    };
    while(i < n){
        const c = src[i];
        if (c === ' ' || c === '\t' || c === '\n' || c === '\r' || c === '\f' || c === '\v' || c === "\xa0") {
            i++;
            continue;
        }
        if (c === '/' && src[i + 1] === '/') {
            while(i < n && src[i] !== '\n')i++;
            continue;
        }
        if (c === '/' && src[i + 1] === '*') {
            i += 2;
            while(i < n && !(src[i] === '*' && src[i + 1] === '/'))i++;
            i += 2;
            continue;
        }
        if (c === '"' || c === "'") {
            i++;
            while(i < n && src[i] !== c)i += src[i] === '\\' ? 2 : 1;
            i++;
            out.push({
                t: 'str',
                v: ''
            });
            continue;
        }
        if (c === '`') {
            i++;
            readTemplate();
            continue;
        }
        if (c === '/') {
            // regex vs division: a regex can only start where a VALUE can start.
            const p = prev();
            const divides = p && (p.t === 'num' || p.t === 'str' || p.t === 'ident' && !$9887d2f9e946d238$var$KEYWORDS.has(p.v) || p.t === 'punc' && (p.v === ')' || p.v === ']' || p.v === '}' || p.v === '++' || p.v === '--'));
            if (!divides) {
                i++;
                let inClass = false;
                while(i < n){
                    const d = src[i];
                    if (d === '\\') {
                        i += 2;
                        continue;
                    }
                    if (d === '[') inClass = true;
                    else if (d === ']') inClass = false;
                    else if (d === '/' && !inClass) {
                        i++;
                        break;
                    } else if (d === '\n') break;
                    i++;
                }
                while(i < n && $9887d2f9e946d238$var$isIdentPart(src[i]))i++ // flags
                ;
                out.push({
                    t: 'str',
                    v: ''
                });
                continue;
            }
            // division / `/=`
            i += src[i + 1] === '=' ? 2 : 1;
            out.push({
                t: 'punc',
                v: '/'
            });
            continue;
        }
        if ($9887d2f9e946d238$var$isDigit(c) || c === '.' && $9887d2f9e946d238$var$isDigit(src[i + 1])) {
            i++;
            while(i < n && ($9887d2f9e946d238$var$isIdentPart(src[i]) || src[i] === '.'))i++;
            out.push({
                t: 'num',
                v: ''
            });
            continue;
        }
        if ($9887d2f9e946d238$var$isIdentStart(c)) {
            const s = i;
            while(i < n && $9887d2f9e946d238$var$isIdentPart(src[i]))i++;
            out.push({
                t: 'ident',
                v: src.slice(s, i)
            });
            continue;
        }
        // punctuation
        if (c === '{') {
            braceDepth++;
            i++;
            out.push({
                t: 'punc',
                v: '{'
            });
            continue;
        }
        if (c === '}') {
            braceDepth--;
            i++;
            out.push({
                t: 'punc',
                v: '}'
            });
            if (tmplStack.length && tmplStack[tmplStack.length - 1] === braceDepth) {
                tmplStack.pop();
                readTemplate();
            }
            continue;
        }
        const three = src.slice(i, i + 3);
        const two = src.slice(i, i + 2);
        if (three === '...' || three === '**=' || three === '===' || three === '!==') {
            i += 3;
            out.push({
                t: 'punc',
                v: three
            });
            continue;
        }
        if (two === '=>' || two === '?.' || two === '++' || two === '--' || two === '==' || two === '!=' || two === '&&' || two === '||' || two === '??' || two === '+=' || two === '-=' || two === '*=' || two === '<=' || two === '>=' || two === '**') {
            i += 2;
            out.push({
                t: 'punc',
                v: two
            });
            continue;
        }
        i++;
        out.push({
            t: 'punc',
            v: c
        });
    }
    return out;
}
// Mark every identifier the function BINDS itself. Anything left is free.
function $9887d2f9e946d238$var$markBindings(tk, bound) {
    const n = tk.length;
    // 1. parameter lists: `(…)` followed by `=>`, or `(…)` that heads a function
    //    body — `function f (a) {`, `foo (a) {` (method shorthand), `catch (e) {`.
    //    Also the single-identifier arrow head `x => …`.
    const openOf = new Array(n).fill(-1);
    const stack = [];
    for(let i = 0; i < n; i++){
        if (tk[i].t !== 'punc') continue;
        if (tk[i].v === '(') stack.push(i);
        else if (tk[i].v === ')') {
            const o = stack.pop();
            if (o !== undefined) openOf[i] = o;
        }
    }
    for(let i = 0; i < n; i++){
        const t = tk[i];
        if (t.t === 'ident' && !$9887d2f9e946d238$var$KEYWORDS.has(t.v) && tk[i + 1] && tk[i + 1].t === 'punc' && tk[i + 1].v === '=>') {
            bound.add(t.v);
            continue;
        }
        if (t.t !== 'punc' || t.v !== ')' || openOf[i] < 0) continue;
        const nx = tk[i + 1];
        const before = tk[openOf[i] - 1];
        const isArrowHead = nx && nx.t === 'punc' && nx.v === '=>';
        const isFnHead = nx && nx.t === 'punc' && nx.v === '{' && (!before || before.t === 'ident' && !$9887d2f9e946d238$var$CONTROL_HEADS.has(before.v) || before.t === 'punc' && (before.v === '*' || before.v === '('));
        if (!isArrowHead && !isFnHead) continue;
        // Bind the names, skipping default-value expressions (`a = window.x`).
        let depth = 0;
        let inDefault = false;
        for(let j = openOf[i] + 1; j < i; j++){
            const p = tk[j];
            if (p.t === 'punc') {
                if (p.v === '(' || p.v === '[' || p.v === '{') depth++;
                else if (p.v === ')' || p.v === ']' || p.v === '}') depth--;
                else if (p.v === ',' && depth === 0) inDefault = false;
                else if (p.v === '=' && !inDefault) inDefault = true;
                continue;
            }
            if (p.t === 'ident' && !inDefault && !$9887d2f9e946d238$var$KEYWORDS.has(p.v)) {
                const pv = tk[j - 1];
                if (pv && pv.t === 'punc' && (pv.v === '.' || pv.v === '?.')) continue;
                // `{ a: renamed }` — only the RIGHT side is the binding
                if (tk[j + 1] && tk[j + 1].t === 'punc' && tk[j + 1].v === ':') continue;
                bound.add(p.v);
            }
        }
    }
    // 2. declarations: `var`/`let`/`const` binding names, `function f`, `class C`.
    for(let i = 0; i < n; i++){
        const t = tk[i];
        if (t.t !== 'ident') continue;
        if (t.v === 'function' || t.v === 'class') {
            const nx = tk[i + 1];
            if (nx && nx.t === 'ident' && !$9887d2f9e946d238$var$KEYWORDS.has(nx.v)) bound.add(nx.v);
            continue;
        }
        if (t.v !== 'var' && t.v !== 'let' && t.v !== 'const') continue;
        let depth = 0;
        let inValue = false;
        for(let j = i + 1; j < n; j++){
            const p = tk[j];
            if (p.t === 'punc') {
                if (p.v === '(' || p.v === '[' || p.v === '{') depth++;
                else if (p.v === ')' || p.v === ']') depth--;
                else if (p.v === '}') {
                    depth--;
                    if (depth < 0) break;
                } else if (p.v === ',' && depth === 0) inValue = false;
                else if (p.v === ',' && depth > 0 && !inValue) continue;
                else if (p.v === ';') break;
                else if (p.v === '=' && !inValue) inValue = true;
                continue;
            }
            if (p.t === 'ident') {
                if ($9887d2f9e946d238$var$KEYWORDS.has(p.v)) {
                    // `for (const x of list)` / `in` — the declarator ends here
                    if (p.v === 'of' || p.v === 'in') break;
                    continue;
                }
                if (inValue) continue;
                const pv = tk[j - 1];
                if (pv && pv.t === 'punc' && (pv.v === '.' || pv.v === '?.')) continue;
                if (tk[j + 1] && tk[j + 1].t === 'punc' && tk[j + 1].v === ':') continue;
                bound.add(p.v);
            } else if (p.t === 'num' || p.t === 'str') {
                if (!inValue && depth === 0) break;
            }
        }
    }
}
function $9887d2f9e946d238$export$f3e5014bcd8a4ee0(src) {
    const tk = $9887d2f9e946d238$var$tokenize(src);
    const bound = new Set();
    $9887d2f9e946d238$var$markBindings(tk, bound);
    const free = new Set();
    for(let i = 0; i < tk.length; i++){
        const t = tk[i];
        if (t.t !== 'ident' || $9887d2f9e946d238$var$KEYWORDS.has(t.v) || bound.has(t.v)) continue;
        const pv = tk[i - 1];
        if (pv && pv.t === 'punc' && (pv.v === '.' || pv.v === '?.')) continue;
        // object-literal / class member KEY, e.g. `{ document: … }`, `case x:`
        const nx = tk[i + 1];
        if (nx && nx.t === 'punc' && nx.v === ':' && pv && pv.t === 'punc' && (pv.v === '{' || pv.v === ',')) continue;
        free.add(t.v);
    }
    return free;
}
function $9887d2f9e946d238$export$5d763f28be33232e(src) {
    if (typeof src !== 'string' || !src) return false;
    // Cheap reject: not one realm-bound name appears anywhere in the text, so no
    // amount of scanning can find one free. Skips the tokenizer for the majority
    // of a published tree's functions (pure data/props lambdas).
    if (!$9887d2f9e946d238$var$CHEAP_RE.test(src)) return false;
    for (const id of $9887d2f9e946d238$export$f3e5014bcd8a4ee0(src)){
        if ($9887d2f9e946d238$export$734cc4f296c02d7a.has(id)) return true;
    }
    return false;
}

});


parcelRegister("ev6YB", function(module, exports) {

$parcel$export(module.exports, "embedComponent", () => $a8e95f4c52b40d71$export$670fba6793be99dd);
// USER-CODE-ORIGIN: every embed here runs a PROJECT's own code, so it mounts
// in the opaque user-code frame (userCodeFrame.js), never in this realm. The
// shell is built exactly as before; only the mount moved. No host registry
// (`hostContext`) and no shared parent objects (`shareContext`) cross: the
// frame reaches the parent only through the consumer's call table (`calls` +
// `allow`), and gets helper CODE only through a `frameKit`.

var $lLBGE = parcelRequire("lLBGE");
function $a8e95f4c52b40d71$export$b8fe76b7aa6e12e5(schema) {
    if (!schema || typeof schema !== 'object') return schema;
    return schema.props?.demoComponent || schema.value || schema;
}
async function $a8e95f4c52b40d71$export$670fba6793be99dd(iframeNode, data, opts = {}) {
    if (!iframeNode || !data) return;
    const { key: key, width: width, height: height, fullsize: fullsize = false, routeMode: // Route mode (canvas PAGE tiles): mount the project the way the published
    // site boots — full app shell, `pages` kept, router ENABLED, initial path
    // = the page's own route — instead of the synthetic single-page shell.
    // Projects routinely drive per-route content through their OWN router
    // hooks and state (natali/shop keys every section off `activeSection`,
    // set by its routing); the isolated shell mounts the structure but none
    // of that state machinery, so the tile renders a 0-height page with all
    // sections hidden. Route mode reproduces the real boot, so whatever the
    // published page does, the tile does.
    routeMode = false, calls: // The frame -> parent call table (userCodeFrame.js): `{ name: handler }`
    // plus an `allow(name, args)` policy, and the frame kit (helper code).
    calls = {}, allow: allow = null, frameKit: frameKit = null, onError: // (message, code) => void — a boot error, a project error, or the frame
    // stopped for reloading in a loop (`user_code_reload_loop`)
    onError = null, el: // the host element (its `scope` holds the frame host memo)
    el = null } = opts;
    if (!key) return;
    if (routeMode && key.startsWith('/') && data.pages && Object.hasOwn(data.pages, key)) {
        // Full-app mount at the page's route. No `pages: undefined` / `router:
        // false` overrides — the framework's auto-router matches the path set by
        // the frame's initial path (`router.initialPath`) and runs the page's real
        // lifecycle (onRenderRouter, per-route state seeding, …).
        const appShell = {
            ...data.app && typeof data.app === 'object' ? data.app : {},
            boxSize: '100dvh 100dvw',
            overflow: 'auto',
            theme: 'document'
        };
        return (0, $lLBGE.mountUserCode)(iframeNode, data, appShell, {
            path: key,
            calls: calls,
            allow: allow,
            frameKit: frameKit,
            onError: onError,
            el: el,
            logTag: key
        });
    }
    // Resolve the component/page schema off the raw project data before we
    // hand it to the frame mount (it serializes into the frame
    // realm, so resolving after would operate on a copy — equivalent but
    // needlessly indirect).
    // Pages may be keyed with OR without a leading slash ('about' as well as
    // '/about'), so detect by where the key actually lives, not just the '/'
    // prefix — otherwise a slash-less page key falls through to components and
    // renders the "not registered" fallback. (2026-06-17.)
    const schema = data.pages?.[key] || data.components?.[key];
    const factory = data.pages?.[key] ? 'pages' : 'components';
    const hasExplicitBox = width != null || height != null;
    const resolvedSchema = $a8e95f4c52b40d71$export$b8fe76b7aa6e12e5(schema);
    const inner = resolvedSchema ? fullsize ? {
        ...resolvedSchema,
        boxSize: '100dvh 100dvw'
    } : resolvedSchema : {
        tag: 'div',
        text: `No ${factory.slice(0, -1)} registered for key "${key}"`,
        style: {
            padding: '24px',
            font: '14px system-ui',
            color: '#999'
        }
    };
    // DOMQL treats `/…` child keys as router paths rather than components,
    // so a page whose key starts with `/` (e.g. `/transactions`) wouldn't
    // mount under its own key. Wrap it under a valid identifier and let
    // the page schema itself render underneath.
    const shellKey = schema ? key.startsWith('/') ? 'Page' : key : 'Fallback';
    const shell = {
        flow: 'x',
        align: 'center center',
        boxSize: hasExplicitBox ? `${height || '100dvh'} ${width || '100dvw'}` : '100dvh 100dvw',
        overflow: 'auto',
        theme: 'document',
        // Hoist `data.app.fetch` onto the root shell. The fetch plugin reads
        // `element.fetch` in its `create` hook; without this, embedded pages
        // mount but their project-level queries never fire (canvas tiles show
        // "Loading…" while preview renders real data through the same data).
        ...data.app?.fetch ? {
            fetch: data.app.fetch
        } : {},
        [shellKey]: inner
    };
    const contextOverrides = {
        pages: undefined,
        app: undefined,
        router: false
    };
    // PAGE tiles must mount at the page's OWN route. Projects routinely gate
    // sections on the current path (`hide: (el, s) => s.root.currentPath !== …`,
    // router-driven show/hide over one shared Body) — under the previous
    // hardcoded `/component/<key>` path every such gate evaluated hidden and a
    // page tile rendered as a 0-height, all-sections-display:none document:
    // structure and copy present in the DOM, nothing visible (measured live on
    // natali/shop, 2026-07-29). Components keep the synthetic /component/ path —
    // they are not routes.
    const framePath = factory === 'pages' && key.startsWith('/') ? key : '/component/' + key;
    return (0, $lLBGE.mountUserCode)(iframeNode, data, shell, {
        path: framePath,
        contextOverrides: contextOverrides,
        calls: calls,
        allow: allow,
        frameKit: frameKit,
        onError: onError,
        el: el,
        logTag: key
    });
}

});
parcelRegister("lLBGE", function(module, exports) {

$parcel$export(module.exports, "userCodeSandbox", () => $fd8b3899a9fa9281$export$4f3edceef4231349);
$parcel$export(module.exports, "prewarmUserCode", () => $fd8b3899a9fa9281$export$bbb7fa731e5cbe69);
$parcel$export(module.exports, "getUserCodeHandle", () => $fd8b3899a9fa9281$export$7c55b7a41391bd1d);
$parcel$export(module.exports, "findScopeKey", () => $fd8b3899a9fa9281$export$4eec49d12bdab6ae);
$parcel$export(module.exports, "mountUserCode", () => $fd8b3899a9fa9281$export$1615a459225c17e1);
// userCodeFrame.js — mount a project's OWN code in an opaque-origin frame
// (USER-CODE-ORIGIN, canvas H1; design: workspace/docs/user-code-origin-design.md).
//
// RULE (the same as the P0 d16ce904f): no origin that runs user code may hold
// or receive a session. The canvas and the shell hold one, so project code
// must not run on their origin. `createIframeApp` ran `create()` in the PARENT
// heap and wrote DOM into a same-origin about:blank, so a project read the
// parent's storage, DOM and JS, and asked /_session-bridge as the parent
// (canvas/__tests__/boardFrameIsUserCodeOrigin.test.js).
//
// Here the frame is `sandbox` WITHOUT `allow-same-origin`: the browser gives
// it an opaque origin (no storage, no cookie, no reach into the parent, every
// message it sends carries origin "null", which no session-bridge peer check
// accepts). The smbls runtime and the bootstrap boot INSIDE the frame from a
// static srcdoc document; the project arrives as DATA (functions as text) in
// a message; the ONLY line back is a MessageChannel port that serves a fixed,
// project-scoped call table. No host registry, no shared object crosses.
//
// `mountUserCode(frame, data, shell, { path, contextOverrides })` keeps the
// createIframeApp signature, so embedComponent / embedDesignSystem / preview
// renderProject build their shell exactly as before and only the mount moves.
//
// What a consumer may hand the frame, and nothing else:
//   • `frameKit`  — CODE for the frame: `{ functions: { name: fn },
//                   factories: [fn] }`, each SELF-CONTAINED (it crosses as
//                   text into the static bootstrap and runs in the frame realm;
//                   a factory gets `{ Smbls, window }` and returns a bag).
//                   Pure helpers only (design review D1).
//   • `calls`     — the frame -> parent call table `{ name: handler }` plus an
//                   `allow(name, args)` policy (D7). The frame gets a STUB per
//                   name that posts a port message; the handler runs HERE.
//   • the project's own db/fetch adapter (data methods), built in.
// The returned handle (also `getUserCodeHandle(node)`) posts the fixed parent
// -> frame messages (USER_CODE_MESSAGES) and runs editor tools.

var $7rnn5 = parcelRequire("7rnn5");

var $hVZUs = parcelRequire("hVZUs");

var $aAzQ3 = parcelRequire("aAzQ3");

var $gyjjS = parcelRequire("gyjjS");
const $fd8b3899a9fa9281$export$83278a975b63edea = 'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox';
function $fd8b3899a9fa9281$export$4f3edceef4231349() {
    return $fd8b3899a9fa9281$export$83278a975b63edea;
}
const $fd8b3899a9fa9281$export$d137a0ed50a760ae = Object.freeze({
    // parent -> frame (window.postMessage once, then the port)
    BOOT: 'smbls:user-code-boot',
    MOUNT: 'mount',
    THEME: 'theme',
    DIR: 'dir',
    NAVIGATE: 'navigate',
    TOOL: 'tool',
    TOOL_STOP: 'tool-stop',
    // frame -> parent notifications
    BOOTED: 'booted',
    READY: 'ready',
    BOOT_ERROR: 'boot-error',
    ERROR: 'error',
    TOOL_EVENT: 'tool-event',
    // frame -> parent built-in call: the project's own db/fetch adapter
    DB: 'db'
});
const $fd8b3899a9fa9281$export$57b2b9fda573acf6 = $fd8b3899a9fa9281$export$d137a0ed50a760ae.BOOT;
const $fd8b3899a9fa9281$var$NATIVE_RE = /\{\s*\[native code\]\s*\}/;
const $fd8b3899a9fa9281$var$UNSAFE_KEYS = new Set([
    '__proto__',
    'constructor',
    'prototype'
]);
const $fd8b3899a9fa9281$var$MAX_DEPTH = 80;
const $fd8b3899a9fa9281$var$isDomLike = (v)=>typeof Node !== 'undefined' && v instanceof Node || typeof Window !== 'undefined' && v instanceof Window || !!v && typeof v === 'object' && (v.nodeType > 0 || v.window === v);
function $fd8b3899a9fa9281$export$4529bd465906bfd8(fn) {
    let src;
    try {
        src = Function.prototype.toString.call(fn);
    } catch  {
        return undefined;
    }
    if ($fd8b3899a9fa9281$var$NATIVE_RE.test(src)) return undefined;
    const t = src.trim();
    if (/^(get|set)\s+[\w$]+\s*\(/.test(t)) return undefined;
    if (/^(async\s+)?(function\b|class\b|\(|[\w$]+\s*=>)/.test(t)) return t;
    if (/^async\s*\(/.test(t)) return t;
    const m = /^(async\s+)?(\*?\s*)([\w$]+)\s*\(/.exec(t);
    if (m) return (m[1] || '') + 'function' + (m[2] ? '*' : '') + ' ' + t.slice(m[0].length - 1 - m[3].length);
    return undefined;
}
function $fd8b3899a9fa9281$export$31c26a0b60159008(v, { fnAsText: fnAsText = true } = {}) {
    const seen = new Set();
    const walk = (x, depth)=>{
        if (x === null) return null;
        const t = typeof x;
        if (t === 'string' || t === 'boolean') return x;
        if (t === 'number') return Number.isFinite(x) ? x : undefined;
        if (t === 'function') return fnAsText ? $fd8b3899a9fa9281$export$4529bd465906bfd8(x) : undefined;
        if (t !== 'object') return undefined;
        if (x instanceof Date) return Number.isNaN(x.getTime()) ? undefined : x.toISOString();
        if ($fd8b3899a9fa9281$var$isDomLike(x) || x instanceof Map || x instanceof Set || x instanceof WeakMap || x instanceof WeakSet || x instanceof Promise || x instanceof RegExp || x instanceof Error || ArrayBuffer.isView(x) || x instanceof ArrayBuffer) return undefined;
        if (depth > $fd8b3899a9fa9281$var$MAX_DEPTH || seen.has(x)) return undefined;
        seen.add(x);
        let out;
        if (Array.isArray(x)) {
            out = [];
            for(let i = 0; i < x.length; i++){
                let d;
                try {
                    d = Object.getOwnPropertyDescriptor(x, i);
                } catch  {
                    d = null;
                }
                const y = d && 'value' in d ? walk(d.value, depth + 1) : undefined;
                out.push(y === undefined ? null : y);
            }
        } else {
            out = {};
            let keys;
            try {
                keys = Object.keys(x);
            } catch  {
                keys = [];
            }
            for (const k of keys){
                if ($fd8b3899a9fa9281$var$UNSAFE_KEYS.has(k) || k.startsWith('__')) continue;
                let d;
                try {
                    d = Object.getOwnPropertyDescriptor(x, k);
                } catch  {
                    d = null;
                }
                if (!d || !('value' in d)) continue;
                const y = walk(d.value, depth + 1);
                if (y !== undefined) out[k] = y;
            }
        }
        seen.delete(x);
        return out;
    };
    return walk(v, 0);
}
function $fd8b3899a9fa9281$export$fb2ed01373edd18c(hostname) {
    const h = String(hostname || '').toLowerCase();
    return h === 'localhost' || h === '127.0.0.1' || h === '[::1]' || h.endsWith('.localhost');
}
const $fd8b3899a9fa9281$var$DEV_SOURCES = 'http://localhost:* http://*.localhost:* http://127.0.0.1:*';
const $fd8b3899a9fa9281$export$acfcf9828edc38fd = ({ scriptSources: scriptSources = [], dev: dev = false } = {})=>{
    const d = dev ? ' ' + $fd8b3899a9fa9281$var$DEV_SOURCES : '';
    return [
        "default-src 'none'",
        `script-src ${scriptSources.join(' ')} 'unsafe-eval' https: data:${d}`,
        `style-src 'unsafe-inline' https:${d}`,
        `img-src https: data: blob:${d}`,
        `media-src https: data: blob:${d}`,
        `font-src https: data:${d}`,
        `connect-src https: wss:${dev ? ' ' + $fd8b3899a9fa9281$var$DEV_SOURCES + ' ws://localhost:* ws://*.localhost:*' : ''}`,
        `frame-src https:${d}`,
        "worker-src 'none'",
        "form-action 'none'",
        "base-uri 'none'"
    ].join('; ');
};
const $fd8b3899a9fa9281$var$escAttr = (s)=>String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
// Inside a <script> element only `</script` and `<!--` change how HTML parses
// the text; `\x3C` is `<` in every JS context they can sit in.
const $fd8b3899a9fa9281$var$escScript = (s)=>String(s).replace(/<(\/script|!--)/gi, '\\x3C$1');
function $fd8b3899a9fa9281$export$1172f282777cd97b(kit) {
    const fns = kit && kit.functions || {};
    const factories = kit && kit.factories || [];
    const parts = [];
    for (const name of Object.keys(fns).sort()){
        if (!/^[A-Za-z_$][\w$]*$/.test(name)) throw new Error('user_code_frame_kit_name');
        const text = typeof fns[name] === 'function' ? $fd8b3899a9fa9281$export$4529bd465906bfd8(fns[name]) : undefined;
        if (!text) throw new Error('user_code_frame_kit_fn:' + name);
        parts.push(JSON.stringify(name) + ': (' + text + ')');
    }
    const facs = factories.map((f, i)=>{
        const text = typeof f === 'function' ? $fd8b3899a9fa9281$export$4529bd465906bfd8(f) : undefined;
        if (!text) throw new Error('user_code_frame_kit_factory:' + i);
        return '(' + text + ')';
    });
    return '{ functions: {' + parts.join(', ') + '}, factories: [' + facs.join(', ') + '] }';
}
const $fd8b3899a9fa9281$export$b535ab5208105bb9 = (kit)=>'(' + (0, $7rnn5.userCodeFrameBoot).toString() + ')(window, (' + (0, $hVZUs.makeEmbedCompatMethods).toString() + '), (' + (0, $aAzQ3.makeEmbedModuleStubs).toString() + '), ' + $fd8b3899a9fa9281$export$1172f282777cd97b(kit) + ')';
const $fd8b3899a9fa9281$var$IMPORT_MAP_TEXT = ()=>{
    const im = (0, $aAzQ3.buildEmbedImportMap)().match(/^<script type="importmap">([\s\S]*)<\/script>$/);
    return im ? im[1] : '';
};
const $fd8b3899a9fa9281$export$430a02dff876ee4e = ({ runtime: runtime = '', bootstrap: bootstrap = '', importMap: importMap = '', nonce: nonce = null, hashes: hashes = null, dev: dev = false })=>{
    const nonceAttr = nonce ? ` nonce="${$fd8b3899a9fa9281$var$escAttr(nonce)}"` : '';
    const scriptSources = hashes ? hashes.map((h)=>`'sha256-${h}'`) : [
        `'nonce-${nonce}'`
    ];
    return '<!doctype html><html><head>' + `<meta http-equiv="Content-Security-Policy" content="${$fd8b3899a9fa9281$var$escAttr($fd8b3899a9fa9281$export$acfcf9828edc38fd({
        scriptSources: scriptSources,
        dev: dev
    }))}">` + (importMap ? `<script type="importmap"${nonceAttr}>${importMap}</script>` : '') + '<meta name="color-scheme" content="light dark">' + '<style>*{margin:0;padding:0;box-sizing:border-box}html,body{width:100%;height:100%;overflow:auto}</style>' + `<script${nonceAttr}>${runtime}</script>` + `<script${nonceAttr}>${bootstrap}</script>` + '</head><body></body></html>';
};
const $fd8b3899a9fa9281$var$randomNonce = ()=>{
    const bytes = new Uint8Array(18);
    globalThis.crypto.getRandomValues(bytes);
    let s = '';
    for (const b of bytes)s += String.fromCharCode(b);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
const $fd8b3899a9fa9281$var$sha256Base64 = async (text)=>{
    const buf = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
    let s = '';
    for (const b of new Uint8Array(buf))s += String.fromCharCode(b);
    return btoa(s);
};
// The per-page memo, on `scope` (FA409, corrected ruling of the frameworks
// session 2026-10-10; packages/shared has NO globalScope.js) — the page
// root's scope, see pageScope below. Read and written ONLY through the
// element the caller passes in (`opts.el`, or `this` under `el.call`) —
// never a module binding, never `globalThis`. No element (or no scope) = a
// fresh bag for this call only: nothing is memoized, nothing is shared.
//   userCodeRuntimeState: { promise (the smbls IIFE text, a lazy chunk the
//     shell boot path never pays for), docs: Map(bootstrap text -> srcdoc),
//     handles: frame -> live handle, adapters: the host's own Supabase
//     adapters, rates: frame -> its call-rate window (review r2 note 6) }
//   userCodeBootState: { active, waiting } (the boot slot queue)
// `el.scope` is a reactive prototype chain (smbls element/create.js): a NEW
// key written through it lands on the nearest element that declares its own
// `scope` (signal createScopeStore, set trap), so two subtrees would each
// grow a bag and one could not find the other's frame. The memo therefore
// sits on the PAGE ROOT's scope, reached through the element passed in —
// every element's chain reads through to it.
const $fd8b3899a9fa9281$var$pageScope = (el)=>{
    if (!el) return null;
    let root = null;
    try {
        root = typeof el.getRoot === 'function' ? el.getRoot() : null;
    } catch  {}
    const sc = root && root.scope || el.scope;
    return sc && typeof sc === 'object' ? sc : null;
};
const $fd8b3899a9fa9281$var$memoBag = (el)=>{
    const sc = $fd8b3899a9fa9281$var$pageScope(el);
    const fresh = ()=>({
            promise: null,
            docs: new Map(),
            handles: new WeakMap(),
            adapters: new Map(),
            rates: new WeakMap()
        });
    if (!sc || typeof sc !== 'object') return fresh();
    if (!sc.userCodeRuntimeState) sc.userCodeRuntimeState = fresh();
    return sc.userCodeRuntimeState;
};
const $fd8b3899a9fa9281$var$bootBag = (el)=>{
    const sc = $fd8b3899a9fa9281$var$pageScope(el);
    const fresh = ()=>({
            active: 0,
            waiting: []
        });
    if (!sc || typeof sc !== 'object') return fresh();
    if (!sc.userCodeBootState) sc.userCodeBootState = fresh();
    return sc.userCodeBootState;
};
const $fd8b3899a9fa9281$export$3af0fa640ac2f306 = (el)=>{
    const state = $fd8b3899a9fa9281$var$memoBag(el);
    if (!state.promise) {
        const fn = el && el.context && el.context.functions && el.context.functions.userCodeRuntimeText;
        state.promise = typeof fn === 'function' ? Promise.resolve(el.call('userCodeRuntimeText')).then((t)=>typeof t === 'string' ? t : '') : Promise.reject(new Error('user_code_runtime_unavailable'));
        state.promise.catch(()=>{
            state.promise = null;
        });
    }
    return state.promise;
};
async function $fd8b3899a9fa9281$export$e5902acf70d74557({ runtime: runtime, kit: kit, dev: dev = false, el: el = null }) {
    const bootstrap = $fd8b3899a9fa9281$var$escScript($fd8b3899a9fa9281$export$b535ab5208105bb9(kit));
    const importMap = $fd8b3899a9fa9281$var$escScript($fd8b3899a9fa9281$var$IMPORT_MAP_TEXT());
    const subtle = globalThis.crypto && globalThis.crypto.subtle;
    if (!subtle) return $fd8b3899a9fa9281$export$430a02dff876ee4e({
        runtime: $fd8b3899a9fa9281$var$escScript(runtime),
        bootstrap: bootstrap,
        importMap: importMap,
        nonce: $fd8b3899a9fa9281$var$randomNonce(),
        dev: dev
    });
    const state = $fd8b3899a9fa9281$var$memoBag(el);
    const key = (dev ? 'dev|' : '|') + bootstrap;
    let hit = state.docs.get(key);
    if (!hit || hit.runtime !== runtime) {
        const rt = $fd8b3899a9fa9281$var$escScript(runtime);
        hit = {
            runtime: runtime,
            doc: Promise.all([
                $fd8b3899a9fa9281$var$sha256Base64(importMap),
                $fd8b3899a9fa9281$var$sha256Base64(rt),
                $fd8b3899a9fa9281$var$sha256Base64(bootstrap)
            ]).then((hashes)=>$fd8b3899a9fa9281$export$430a02dff876ee4e({
                    runtime: rt,
                    bootstrap: bootstrap,
                    importMap: importMap,
                    hashes: hashes,
                    dev: dev
                }))
        };
        state.docs.set(key, hit);
    }
    return hit.doc;
}
function $fd8b3899a9fa9281$export$bbb7fa731e5cbe69({ frameKit: frameKit = null, el: el = null } = {}) {
    const dev = !!(globalThis.location && $fd8b3899a9fa9281$export$fb2ed01373edd18c(globalThis.location.hostname));
    return $fd8b3899a9fa9281$export$3af0fa640ac2f306(el).then((runtime)=>$fd8b3899a9fa9281$export$e5902acf70d74557({
            runtime: runtime,
            kit: frameKit,
            dev: dev,
            el: el
        })).then(()=>true, ()=>false);
}
function $fd8b3899a9fa9281$export$7c55b7a41391bd1d(node, el) {
    if (!node) return null;
    const host = el || this;
    const h = $fd8b3899a9fa9281$var$memoBag(host).handles.get(node);
    return h && h.alive ? h : null;
}
function $fd8b3899a9fa9281$export$684d4cdfca7d2ac2(data, shell, { path: path = '/', contextOverrides: contextOverrides = {}, callNames: callNames = [] } = {}) {
    const picked = {};
    for (const key of (0, $gyjjS.CREATE_CONTEXT_KEYS))if (Object.hasOwn(data, key)) picked[key] = data[key];
    const project = $fd8b3899a9fa9281$export$31c26a0b60159008(picked) || {};
    if (project.designSystem) (0, $gyjjS.normalizeDesignSystemCase)(project.designSystem);
    const unset = [];
    const overridesIn = {};
    for (const k of Object.keys(contextOverrides || {}))if (contextOverrides[k] === undefined) unset.push(k);
    else overridesIn[k] = contextOverrides[k];
    return {
        project: project,
        shell: $fd8b3899a9fa9281$export$31c26a0b60159008(shell || {}) || {},
        overrides: $fd8b3899a9fa9281$export$31c26a0b60159008(overridesIn) || {},
        unset: unset,
        path: typeof path === 'string' ? path : '/',
        spriteHtml: (0, $gyjjS.spriteHtmlFor)(data.designSystem) || '',
        callNames: callNames.filter((n)=>typeof n === 'string' && /^[A-Za-z_$][\w$]*$/.test(n)),
        // set by mountUserCode from the HOST-built adapters (B4); never read
        // from anything the project data carries
        adapters: {
            fetch: false,
            db: false
        }
    };
}
// ── the call table (frame → parent) ─────────────────────────────────────────
const $fd8b3899a9fa9281$var$DB_METHODS = new Set([
    'select',
    'rpc',
    'insert',
    'update',
    'upsert',
    'delete'
]);
const $fd8b3899a9fa9281$var$RATE = {
    max: 60,
    windowMs: 1000
};
const $fd8b3899a9fa9281$export$cf470f557e931bbd = 262144;
const $fd8b3899a9fa9281$export$6b69850602a7f52d = Object.freeze([
    'supabase'
]);
// Security review round 2, B4 + B5: the PARENT never calls anything the
// project's data carries (`db.select`, `db.__resolved`, `db.createClient`
// with `__adapterAttached` — a revived project made each one live parent-
// realm code), and its Supabase client never touches the shell's storage.
// The host reads ONLY the plain strings `url` + `key`, builds the client
// itself — memory-only auth (persistSession / autoRefreshToken /
// detectSessionInUrl off, a no-op storage, its own storage key: a client
// with the default storage loaded `sb-<label>-auth-token` from the SHELL's
// localStorage and sent that JWT to a project-chosen host) — and serves only
// an adapter that carries this module's private brand. The name 'supabase'
// alone is not trust.
const $fd8b3899a9fa9281$var$HOST_BUILT = Symbol('userCodeHostBuiltAdapter');
const $fd8b3899a9fa9281$var$NO_STORAGE = Object.freeze({
    getItem: ()=>null,
    setItem: ()=>{},
    removeItem: ()=>{}
});
function $fd8b3899a9fa9281$export$28ad1bc57b0e59d7(cfg, { supabaseRef: supabaseRef = null } = {}) {
    if (!cfg || typeof cfg !== 'object' || cfg.adapter !== 'supabase') return null;
    const url = cfg.url;
    const key = cfg.key;
    if (typeof url !== 'string' || typeof key !== 'string' || !key || key.length > 4096) return null;
    let u;
    try {
        u = new URL(url);
    } catch  {
        return null;
    }
    if (u.protocol !== 'https:' || u.username || u.password || u.port) return null;
    if (u.pathname !== '/' && u.pathname !== '') return null;
    if (typeof supabaseRef === 'string' && supabaseRef && u.hostname !== supabaseRef.toLowerCase() + '.supabase.co') return null;
    return {
        url: u.origin,
        key: key
    };
}

async function $fd8b3899a9fa9281$export$cfc86cd593ffb3d7(plain, memo) {
    if (!plain) return null;
    const cacheKey = plain.url + '|' + plain.key;
    const cache = memo && memo.adapters;
    if (cache && cache.has(cacheKey)) return cache.get(cacheKey);
    const mod = await Promise.resolve((parcelRequire("1zcOx")));
    const client = mod.createSupabaseClient(plain.url, plain.key, {
        auth: {
            persistSession: false,
            autoRefreshToken: false,
            detectSessionInUrl: false,
            storage: $fd8b3899a9fa9281$var$NO_STORAGE,
            storageKey: 'user-code-frame-' + Math.random().toString(36).slice(2)
        }
    });
    const full = mod.supabaseAdapter(client);
    const adapter = {
        name: 'supabase'
    };
    for (const m of $fd8b3899a9fa9281$var$DB_METHODS)if (typeof full[m] === 'function') adapter[m] = full[m].bind(full);
    Object.defineProperty(adapter, $fd8b3899a9fa9281$var$HOST_BUILT, {
        value: true
    });
    Object.freeze(adapter);
    if (cache) cache.set(cacheKey, adapter);
    return adapter;
}
// A table / function name of the project's own backend: no schema dot (no
// `auth.session`, no `auth.users`, no `storage.objects`), no path.
const $fd8b3899a9fa9281$var$OWN_TABLE_RE = /^[A-Za-z_][A-Za-z0-9_-]{0,62}$/;
const $fd8b3899a9fa9281$export$a9ba4e874821e32a = Object.freeze([
    'workspaceid',
    'workspace',
    'orgid',
    'org',
    'organizationid',
    'organization',
    'projectid',
    'project',
    'ownerid',
    'owner',
    'scope',
    'tenant',
    'tenantid',
    // snake_case twins (security review r2 note 7)
    'workspace_id',
    'org_id',
    'organization_id',
    'project_id',
    'owner_id',
    'tenant_id'
]);
function $fd8b3899a9fa9281$export$4eec49d12bdab6ae(value, keys = $fd8b3899a9fa9281$export$a9ba4e874821e32a) {
    const set = new Set(keys.map((k)=>String(k).toLowerCase()));
    const seen = new Set();
    const walk = (v, depth)=>{
        if (!v || typeof v !== 'object' || depth > 40 || seen.has(v)) return null;
        seen.add(v);
        for (const k of Object.keys(v)){
            if (set.has(k.toLowerCase())) return k;
            const hit = walk(v[k], depth + 1);
            if (hit) return hit;
        }
        return null;
    };
    return walk(value, 0);
}
const $fd8b3899a9fa9281$var$tooLarge = (v)=>{
    let n = 0;
    try {
        n = JSON.stringify(v === undefined ? null : v).length;
    } catch  {
        return true;
    }
    return n > $fd8b3899a9fa9281$export$cf470f557e931bbd;
};
const $fd8b3899a9fa9281$var$errorText = (err)=>typeof err === 'string' ? err : err && typeof err.message === 'string' && err.message || 'error';
function $fd8b3899a9fa9281$export$e32839ceef3c295c({ calls: calls = {}, allow: allow = null, adapters: adapters = {}, stamps: stamps = [], now: now = ()=>Date.now() } = {}) {
    const overRate = ()=>{
        const t = now();
        while(stamps.length && t - stamps[0] >= $fd8b3899a9fa9281$var$RATE.windowMs)stamps.shift();
        if (stamps.length >= $fd8b3899a9fa9281$var$RATE.max) return true;
        stamps.push(t);
        return false;
    };
    const allowed = (name, args)=>{
        if (typeof allow !== 'function') return false;
        try {
            return allow(name, args) === true;
        } catch  {
            return false;
        }
    };
    return async (method, args)=>{
        if (overRate()) throw new Error('user_code_rate_limited');
        if ($fd8b3899a9fa9281$var$tooLarge(args)) throw new Error('user_code_args_too_large');
        if (method === $fd8b3899a9fa9281$export$d137a0ed50a760ae.DB) {
            const a = args && typeof args === 'object' && !Array.isArray(args) ? args : {};
            const adapter = adapters[a.which === 'db' ? 'db' : a.which === 'fetch' ? 'fetch' : ''];
            if (!adapter || adapter[$fd8b3899a9fa9281$var$HOST_BUILT] !== true || !$fd8b3899a9fa9281$export$6b69850602a7f52d.includes(adapter.name) || !$fd8b3899a9fa9281$var$DB_METHODS.has(a.method) || typeof adapter[a.method] !== 'function') throw new Error('user_code_not_allowed');
            const c = a.args && typeof a.args === 'object' ? a.args : {};
            if (typeof c.from !== 'string' || !$fd8b3899a9fa9281$var$OWN_TABLE_RE.test(c.from)) throw new Error('user_code_not_allowed');
            if (c.schema !== undefined && c.schema !== 'public') throw new Error('user_code_not_allowed');
            if (!allowed($fd8b3899a9fa9281$export$d137a0ed50a760ae.DB, a)) throw new Error('user_code_refused');
            let res;
            try {
                res = await adapter[a.method]($fd8b3899a9fa9281$export$31c26a0b60159008(a.args, {
                    fnAsText: false
                }) || {});
            } catch (err) {
                return {
                    data: null,
                    error: {
                        message: $fd8b3899a9fa9281$var$errorText(err)
                    }
                };
            }
            return {
                data: $fd8b3899a9fa9281$export$31c26a0b60159008(res && res.data, {
                    fnAsText: false
                }) ?? null,
                error: res && res.error ? {
                    message: $fd8b3899a9fa9281$var$errorText(res.error)
                } : null,
                count: res && Number.isFinite(res.count) ? res.count : null
            };
        }
        if (typeof method !== 'string' || !Object.hasOwn(calls, method) || typeof calls[method] !== 'function') throw new Error('user_code_not_allowed');
        const list = Array.isArray(args) ? $fd8b3899a9fa9281$export$31c26a0b60159008(args, {
            fnAsText: false
        }) : [];
        if (!allowed(method, list)) throw new Error('user_code_refused');
        const result = await calls[method](...list);
        return $fd8b3899a9fa9281$export$31c26a0b60159008(result, {
            fnAsText: false
        }) ?? null;
    };
}
// ── the host ────────────────────────────────────────────────────────────────
const $fd8b3899a9fa9281$var$tokensOf = (frameNode)=>{
    const v = frameNode && frameNode.getAttribute && frameNode.getAttribute('sandbox');
    return typeof v === 'string' ? v.trim().split(/\s+/).filter(Boolean) : null;
};
// A frame that loads this many documents WITHOUT one good boot in between
// (the project navigates its frame in a loop) is stopped and reported. A good
// boot resets the count: moving or re-inserting an iframe reloads its srcdoc,
// which is legal (design review D2).
const $fd8b3899a9fa9281$var$MAX_LOADS_WITHOUT_BOOT = 4;
const $fd8b3899a9fa9281$export$876202ce4ad44d57 = 3;
// A boot that never reports (a frame removed mid-boot) frees its slot here.
const $fd8b3899a9fa9281$var$BOOT_SLOT_TIMEOUT_MS = 20000;
async function $fd8b3899a9fa9281$export$1615a459225c17e1(frameNode, data, shell, opts = {}) {
    if (!frameNode || !data) return null;
    const { path: path = '/', contextOverrides: contextOverrides = {}, calls: calls = {}, allow: allow = null, frameKit: frameKit = null, supabaseRef: // the project's real Supabase ref, when the host knows it (B5)
    supabaseRef = null, el: // the host element whose `scope` holds the per-page memo and the boot
    // queue (FA409 ruling)
    el = null, runtime: runtime, logTag: logTag = '', onError: onError = null } = opts;
    const callNames = Object.keys(calls || {});
    const payload = $fd8b3899a9fa9281$export$684d4cdfca7d2ac2(data, shell, {
        path: path,
        contextOverrides: contextOverrides,
        callNames: callNames
    });
    // the host's OWN adapters, built from the plain url + key strings only —
    // never anything the project data carries (B4)
    const memo = $fd8b3899a9fa9281$var$memoBag(el);
    const adapters = {
        fetch: await $fd8b3899a9fa9281$export$cfc86cd593ffb3d7($fd8b3899a9fa9281$export$28ad1bc57b0e59d7(data.fetch, {
            supabaseRef: supabaseRef
        }), memo),
        db: await $fd8b3899a9fa9281$export$cfc86cd593ffb3d7($fd8b3899a9fa9281$export$28ad1bc57b0e59d7(data.db, {
            supabaseRef: supabaseRef
        }), memo)
    };
    payload.adapters = {
        fetch: !!adapters.fetch,
        db: !!adapters.db
    };
    const table = {
        calls: calls,
        allow: allow,
        adapters: adapters
    };
    const live = $fd8b3899a9fa9281$export$7c55b7a41391bd1d(frameNode, el);
    if (live) return live.remount(payload, table);
    // The token list is set HERE, before the frame's only navigation (srcdoc),
    // so the sandbox applies whatever the caller's markup said.
    frameNode.setAttribute('sandbox', $fd8b3899a9fa9281$export$83278a975b63edea);
    const tokens = $fd8b3899a9fa9281$var$tokensOf(frameNode);
    if (!tokens || tokens.includes('allow-same-origin')) throw new Error('user_code_sandbox');
    const rt = runtime !== undefined ? runtime : await $fd8b3899a9fa9281$export$3af0fa640ac2f306(el);
    const dev = !!(globalThis.location && $fd8b3899a9fa9281$export$fb2ed01373edd18c(globalThis.location.hostname));
    const srcdoc = await $fd8b3899a9fa9281$export$e5902acf70d74557({
        runtime: rt,
        kit: frameKit,
        dev: dev,
        el: el
    });
    // Boot slot (USER_CODE_BOOT_CONCURRENCY), on the same memo bag.
    const boots = $fd8b3899a9fa9281$var$bootBag(el);
    if (boots.active >= $fd8b3899a9fa9281$export$876202ce4ad44d57) await new Promise((resolve)=>boots.waiting.push(resolve));
    else boots.active++;
    let slotHeld = true;
    const releaseSlot = ()=>{
        if (!slotHeld) return;
        slotHeld = false;
        const next = boots.waiting.shift();
        if (next) next();
        else boots.active--;
    };
    const slotTimer = setTimeout(releaseSlot, $fd8b3899a9fa9281$var$BOOT_SLOT_TIMEOUT_MS);
    // Another mount of the same frame may have finished while this one waited.
    const raced = $fd8b3899a9fa9281$export$7c55b7a41391bd1d(frameNode, el);
    if (raced) {
        clearTimeout(slotTimer);
        releaseSlot();
        return raced.remount(payload, table);
    }
    const handle = $fd8b3899a9fa9281$var$createUserCodeHandle(frameNode, {
        payload: payload,
        table: table,
        logTag: logTag,
        onError: onError,
        srcdoc: srcdoc,
        registry: memo.handles,
        stamps: $fd8b3899a9fa9281$var$frameRateWindow(memo, frameNode)
    });
    memo.handles.set(frameNode, handle);
    handle.ready.then(()=>{
        clearTimeout(slotTimer);
        releaseSlot();
    });
    frameNode.srcdoc = srcdoc;
    return handle.ready;
}
// The rate window of one iframe node, for the life of the page (note 6).
const $fd8b3899a9fa9281$var$frameRateWindow = (memo, frameNode)=>{
    let w = memo.rates.get(frameNode);
    if (!w) memo.rates.set(frameNode, w = []);
    return w;
};

function $fd8b3899a9fa9281$var$createUserCodeHandle(frameNode, { payload: payload, table: table, logTag: logTag, onError: onError, srcdoc: srcdoc, registry: registry, stamps: stamps }) {
    const M = $fd8b3899a9fa9281$export$d137a0ed50a760ae;
    let current = payload;
    let serve = $fd8b3899a9fa9281$export$e32839ceef3c295c({
        ...table,
        stamps: stamps
    });
    let port = null;
    let loadsSinceBoot = 0;
    // Only a document the HOST just set gets a port (security review 7): the
    // first load is ours (srcdoc set at mount); any other load — the project
    // navigated its frame away, or the iframe was moved / re-inserted — first
    // sets our srcdoc again, and the port goes to THAT load.
    let expectOwnDoc = true;
    let alive = true;
    let warned = false;
    let settle = null;
    let ready = new Promise((resolve)=>settle = resolve);
    const toolListeners = new Map();
    const say = (message, code)=>{
        if (typeof onError === 'function') {
            try {
                onError(message, code);
            } catch  {}
            return;
        }
        if (warned) return;
        warned = true;
        console.warn('[user-code frame]', logTag || '', message);
    };
    const resolveReady = (value)=>{
        if (settle) {
            const s = settle;
            settle = null;
            s(value);
        }
    };
    const onPortMessage = (e)=>{
        const m = e && e.data;
        if (!m || typeof m !== 'object' || typeof m.method !== 'string') return;
        if (m.id !== undefined) {
            const id = m.id;
            Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("1zcOx")));
            }).then((res)=>serve(m.method, m.args)).then((result)=>port && port.postMessage({
                    id: id,
                    ok: true,
                    result: result
                }), (err)=>port && port.postMessage({
                    id: id,
                    ok: false,
                    error: $fd8b3899a9fa9281$var$errorText(err)
                }));
            return;
        }
        if (m.method === M.BOOTED) port.postMessage({
            type: M.MOUNT,
            payload: current
        });
        else if (m.method === M.READY) {
            loadsSinceBoot = 0;
            resolveReady({
                ok: true,
                handle: handle
            });
        } else if (m.method === M.BOOT_ERROR) {
            // `message` = the thrown error's text; `code` = a bootstrap error code.
            const message = String(m.args && (m.args.message || m.args.code) || 'boot failed');
            say(message, 'project_boot_failed');
            resolveReady({
                bootError: {
                    code: 'project_boot_failed',
                    message: message
                }
            });
        } else if (m.method === M.ERROR) say(String(m.args && m.args.message || 'error'), 'project_error');
        else if (m.method === M.TOOL_EVENT) {
            const name = m.args && m.args.name;
            const listener = typeof name === 'string' ? toolListeners.get(name) : null;
            if (listener) try {
                listener(m.args.data);
            } catch  {}
        }
    };
    const boot = ()=>{
        if (port) try {
            port.onmessage = null;
            port.close();
        } catch  {}
        const channel = new MessageChannel();
        port = channel.port1;
        port.onmessage = onPortMessage;
        // The ONLY post with targetOrigin '*': an opaque frame's origin is "null".
        frameNode.contentWindow.postMessage({
            type: M.BOOT
        }, '*', [
            channel.port2
        ]);
    };
    function closePort() {
        if (!port) return;
        try {
            port.onmessage = null;
            port.close();
        } catch  {}
        port = null;
    }
    function onLoad() {
        if (!alive) return;
        if (!expectOwnDoc) {
            // not our document: never hand it the port — set ours again
            closePort();
            expectOwnDoc = true;
            frameNode.srcdoc = srcdoc;
            return;
        }
        expectOwnDoc = false;
        loadsSinceBoot++;
        if (loadsSinceBoot > $fd8b3899a9fa9281$var$MAX_LOADS_WITHOUT_BOOT) {
            const message = 'the project reloads its frame in a loop; stopped';
            say(message, 'user_code_reload_loop');
            resolveReady({
                bootError: {
                    code: 'user_code_reload_loop',
                    message: message
                }
            });
            teardown();
            return;
        }
        try {
            boot();
        } catch (err) {
            say($fd8b3899a9fa9281$var$errorText(err), 'user_code_boot');
        }
    }
    function teardown() {
        if (!alive) return;
        alive = false;
        frameNode.removeEventListener('load', onLoad);
        if (port) try {
            port.onmessage = null;
            port.close();
        } catch  {}
        port = null;
        if (registry && registry.get(frameNode) === handle) registry.delete(frameNode);
        resolveReady(null);
    }
    frameNode.addEventListener('load', onLoad);
    const handle = {
        get alive () {
            return alive;
        },
        get ready () {
            return ready;
        },
        remount (nextPayload, nextTable) {
            if (!alive) return Promise.resolve(null);
            current = nextPayload;
            if (nextTable) serve = $fd8b3899a9fa9281$export$e32839ceef3c295c({
                ...nextTable,
                stamps: stamps
            });
            // A mount still waiting for its frame keeps ITS promise: the earlier
            // caller settles with this mount's outcome instead of hanging forever.
            if (!settle) ready = new Promise((resolve)=>settle = resolve);
            if (port) port.postMessage({
                type: M.MOUNT,
                payload: current
            });
            return ready;
        },
        // Run an editor tool inside the frame: `fn` is a SELF-CONTAINED function
        // `({ win, doc, emit }) => stop` (sent as text — no closure survives);
        // `onEvent(data)` receives what it emits. Returns false when not live.
        runTool (name, fn, onEvent) {
            if (!alive || !port || typeof fn !== 'function') return false;
            toolListeners.set(name, onEvent);
            port.postMessage({
                type: M.TOOL,
                name: name,
                source: Function.prototype.toString.call(fn)
            });
            return true;
        },
        stopTool (name) {
            toolListeners.delete(name);
            if (alive && port) port.postMessage({
                type: M.TOOL_STOP,
                name: name
            });
        },
        // A fixed parent -> frame message: THEME { theme }, DIR { dir },
        // NAVIGATE { path }. Anything else is refused.
        post (type, fields = {}) {
            if (!alive || !port) return false;
            if (type !== M.THEME && type !== M.DIR && type !== M.NAVIGATE) return false;
            port.postMessage(Object.assign({}, $fd8b3899a9fa9281$export$31c26a0b60159008(fields, {
                fnAsText: false
            }), {
                type: type
            }));
            return true;
        },
        teardown: teardown
    };
    return handle;
}

});
parcelRegister("7rnn5", function(module, exports) {

$parcel$export(module.exports, "userCodeFrameBoot", () => $56ad2f1650df069e$export$136f0ae5d5104887);
// userCodeFrameBoot.js — the bootstrap that runs INSIDE the opaque user-code
// frame (USER-CODE-ORIGIN; design: workspace/docs/user-code-origin-design.md).
//
// The host (userCodeFrame.js) serializes `userCodeFrameBoot` with
// .toString() into the frame's static srcdoc document, so the function must be
// SELF-CONTAINED: no closure over this module, no imports, ES2017 syntax only
// (no object spread, no optional chaining, no async/await, no optional catch
// binding) so no bundler helper is referenced by the serialized text.
//
// What it does:
//   • gives the project an in-memory localStorage/sessionStorage and an empty
//     cookie jar (an opaque origin throws on all three; Nika 2026-10-09 Q1:
//     theme/lang inside a tile reset on each load);
//   • takes the MessageChannel port from the FIRST boot message the parent
//     sends (and never another);
//   • mounts the posted project with the smbls IIFE the document loaded first
//     (`window.Smbls.create`), exactly the create() options createIframeApp
//     builds — but in THIS realm, so project code never runs in the parent;
//   • adds the consumer's frame kit (`kit`: self-contained pure helpers as
//     CODE, design review D1) at the lowest priority;
//   • exposes to the project ONLY the parent's call table — one stub per
//     name the payload lists, plus the project's own db/fetch adapter — every
//     call is a port message the parent may refuse;
//   • answers the parent's mount / theme / dir / navigate / tool messages
//     (the literals of USER_CODE_MESSAGES in userCodeFrame.js).
//
// It holds no capability beyond the port. It never reads the parent.
function $56ad2f1650df069e$export$136f0ae5d5104887(win, makeCompat, makeStubs, kit) {
    'use strict';
    var booted = false;
    var doc = win.document;
    function memoryStorage() {
        var m = Object.create(null);
        var api = {
            getItem: function(k) {
                k = String(k);
                return Object.prototype.hasOwnProperty.call(m, k) ? m[k] : null;
            },
            setItem: function(k, v) {
                m[String(k)] = String(v);
            },
            removeItem: function(k) {
                delete m[String(k)];
            },
            clear: function() {
                for(var k in m)delete m[k];
            },
            key: function(i) {
                var ks = Object.keys(m);
                return i >= 0 && i < ks.length ? ks[i] : null;
            }
        };
        Object.defineProperty(api, 'length', {
            get: function() {
                return Object.keys(m).length;
            }
        });
        return api;
    }
    function storageWorks(k) {
        try {
            var s = win[k];
            if (!s || typeof s.getItem !== 'function') return false;
            s.getItem('__probe__');
            return true;
        } catch (e) {
            return false;
        }
    }
    function shimStorage() {
        var keys = [
            'localStorage',
            'sessionStorage'
        ];
        for(var i = 0; i < keys.length; i++){
            if (storageWorks(keys[i])) continue;
            try {
                Object.defineProperty(win, keys[i], {
                    value: memoryStorage(),
                    configurable: true
                });
            } catch (e) {}
        }
        var cookieOk = true;
        try {
            var c = doc.cookie;
            cookieOk = typeof c === 'string';
        } catch (e) {
            cookieOk = false;
        }
        if (!cookieOk) try {
            Object.defineProperty(doc, 'cookie', {
                get: function() {
                    return '';
                },
                set: function() {},
                configurable: true
            });
        } catch (e) {}
    }
    function start(port) {
        var nextId = 1;
        var pending = {};
        var app = null;
        var themeCfg = null;
        var errorsSent = 0;
        // Editor tools the PARENT runs in this realm (the preview element picker):
        // a self-contained function `(api) => stop`, sent as text. It gets this
        // frame's window/document and `emit(data)` — plain data back over the
        // port. The frame is untrusted already; parent code here grants nothing.
        var tools = {};
        function stopTool(name) {
            var stop = tools[name];
            delete tools[name];
            if (typeof stop === 'function') try {
                stop();
            } catch (e) {}
        }
        function notify(method, args) {
            try {
                port.postMessage({
                    method: method,
                    args: args || {}
                });
            } catch (e) {}
        }
        function call(method, args) {
            return new Promise(function(resolve, reject) {
                var id = nextId++;
                pending[id] = function(m) {
                    if (m.ok) resolve(m.result === undefined ? null : m.result);
                    else reject(new Error(String(m.error || 'user_code_call_refused')));
                };
                port.postMessage({
                    id: id,
                    method: method,
                    args: args
                });
            });
        }
        // The project's own db/fetch adapter, served by the parent from the
        // project's OWN public config (never a Symbols session). Data methods only.
        function adapterProxy(which) {
            function m(name) {
                return function(c) {
                    return call('db', {
                        which: which,
                        method: name,
                        args: plainArgs(c) || {}
                    }).then(function(r) {
                        return r || {
                            data: null,
                            error: null
                        };
                    }, function(err) {
                        return {
                            data: null,
                            error: {
                                message: String(err && err.message)
                            }
                        };
                    });
                };
            }
            return {
                name: 'user-code-proxy',
                select: m('select'),
                rpc: m('rpc'),
                insert: m('insert'),
                update: m('update'),
                upsert: m('upsert'),
                delete: m('delete')
            };
        }
        // The parent's call table, as context functions: one stub per name the
        // payload lists. A stub sends plain data (a value that cannot be cloned
        // rejects here, in the frame) and never holds a parent function.
        function plainArgs(list) {
            try {
                return JSON.parse(JSON.stringify(list));
            } catch (e) {
                return null;
            }
        }
        function stubsFor(names) {
            var out = {};
            for(var i = 0; i < names.length; i++)(function(name) {
                out[name] = function() {
                    var args = plainArgs(Array.prototype.slice.call(arguments));
                    if (!args) return Promise.reject(new Error('user_code_args_not_plain'));
                    return call(name, args);
                };
            })(names[i]);
            return out;
        }
        // The consumer's frame kit, built ONCE in this realm. A factory gets the
        // frame's own runtime (`{ Smbls, window }`) and returns a bag of helpers.
        var kitFunctions = {};
        function buildKit() {
            var fk = kit && kit.functions || {};
            for(var n in fk)kitFunctions[n] = fk[n];
            var facs = kit && kit.factories || [];
            for(var j = 0; j < facs.length; j++)try {
                var bag = facs[j]({
                    Smbls: win.Smbls,
                    window: win
                });
                for(var b in bag)if (typeof bag[b] === 'function') kitFunctions[b] = bag[b];
            } catch (e) {
                reportError('frame kit factory ' + j + ': ' + (e && e.message || e));
            }
        }
        function reportError(message) {
            if (errorsSent >= 20) return;
            errorsSent++;
            notify('error', {
                message: String(message).slice(0, 500)
            });
        }
        win.addEventListener('error', function(e) {
            reportError(e && e.error && e.error.message || e && e.message || 'error');
        });
        win.addEventListener('unhandledrejection', function(e) {
            reportError(e && e.reason && e.reason.message || String(e && e.reason));
        });
        function revive(v) {
            var S = win.Smbls;
            if (!v || typeof v !== 'object' || !S || typeof S.deepDestringifyFunctions !== 'function') return v;
            return S.deepDestringifyFunctions(v, Array.isArray(v) ? [] : {});
        }
        function clearBody() {
            var b = doc.body;
            if (!b) return;
            while(b.firstChild)b.removeChild(b.firstChild);
        }
        function mount(p) {
            var S = win.Smbls;
            if (!S || typeof S.create !== 'function') {
                notify('boot-error', {
                    code: 'user_code_runtime_missing'
                });
                return;
            }
            if (app && typeof app.destroy === 'function') try {
                app.destroy();
            } catch (e) {}
            app = null;
            themeCfg = null;
            clearBody();
            if (p.spriteHtml && doc.body) doc.body.insertAdjacentHTML('afterbegin', '<svg aria-hidden="true" width="0" height="0" style="position:absolute" id="svgSprite">' + p.spriteHtml + '</svg>');
            var project = revive(p.project || {}) || {};
            var shell = revive(p.shell || {}) || {};
            var ov = revive(p.overrides || {}) || {};
            var unset = Array.isArray(p.unset) ? p.unset : [];
            var adapters = p.adapters || {};
            var opts = {};
            var k;
            for(k in project)if (Object.prototype.hasOwnProperty.call(project, k)) opts[k] = project[k];
            for(k in ov)if (Object.prototype.hasOwnProperty.call(ov, k)) opts[k] = ov[k];
            for(var u = 0; u < unset.length; u++)opts[unset[u]] = undefined;
            var cfgKeys = [
                'fetch',
                'db'
            ];
            for(var a = 0; a < cfgKeys.length; a++){
                var ck = cfgKeys[a];
                if (adapters[ck] && opts[ck] && typeof opts[ck] === 'object') opts[ck] = Object.assign({}, opts[ck], {
                    __resolved: adapterProxy(ck)
                });
            }
            var methods = Object.assign({}, makeCompat(), project.methods || {}, ov.methods || {});
            // lowest -> highest: the frame kit, the parent's call stubs, the
            // project's own functions, explicit overrides
            var functions = Object.assign({}, kitFunctions, stubsFor(Array.isArray(p.callNames) ? p.callNames : []), project.functions || {}, ov.functions || {});
            var router = opts.router;
            if (router !== false) router = Object.assign({}, router && typeof router === 'object' ? router : {}, {
                initialPath: p.path || '/'
            });
            opts.router = router;
            opts.methods = methods;
            opts.functions = functions;
            opts.context = Object.assign({}, project.context || {}, ov.context || {}, {
                methods: methods,
                functions: functions,
                window: win,
                document: doc
            });
            opts.themeRoot = doc.documentElement;
            opts.document = doc;
            opts.window = win;
            opts.parent = doc.body;
            var created;
            try {
                created = S.create(shell, opts);
            } catch (err) {
                notify('boot-error', {
                    message: String(err && err.message || err)
                });
                return;
            }
            Promise.resolve(created).then(function(result) {
                app = result;
                try {
                    var ds = result && result.context && result.context.designSystem;
                    if (ds) {
                        // the app's own root element (create() returns it)
                        ds.themeRoot = result && result.node || doc.documentElement;
                        themeCfg = ds;
                    }
                } catch (e) {}
                notify('ready', {});
            }, function(err) {
                notify('boot-error', {
                    message: String(err && err.message || err)
                });
            });
        }
        buildKit();
        port.onmessage = function(e) {
            var m = e.data;
            if (!m || typeof m !== 'object') return;
            if (m.id !== undefined && pending[m.id]) {
                var done = pending[m.id];
                delete pending[m.id];
                done(m);
                return;
            }
            var S = win.Smbls;
            if (m.type === 'mount') mount(m.payload || {});
            else if (m.type === 'theme') {
                if (S && typeof S.changeGlobalTheme === 'function' && typeof m.theme === 'string') try {
                    if (themeCfg) S.changeGlobalTheme(m.theme, themeCfg);
                    else S.changeGlobalTheme(m.theme);
                } catch (err) {}
            } else if (m.type === 'dir') {
                if (m.dir === 'rtl' || m.dir === 'ltr') doc.documentElement.setAttribute('dir', m.dir);
            } else if (m.type === 'navigate') {
                if (app && typeof app.navigate === 'function' && typeof m.path === 'string') try {
                    app.navigate(m.path);
                } catch (err) {}
            } else if (m.type === 'tool' && typeof m.name === 'string' && typeof m.source === 'string') {
                stopTool(m.name);
                var toolName = m.name;
                try {
                    var toolFn = win.eval('(' + m.source + ')');
                    var stop = toolFn({
                        win: win,
                        doc: doc,
                        emit: function(data) {
                            notify('tool-event', {
                                name: toolName,
                                data: data
                            });
                        }
                    });
                    tools[toolName] = typeof stop === 'function' ? stop : null;
                } catch (err) {
                    notify('tool-event', {
                        name: toolName,
                        data: {
                            error: String(err && err.message || err)
                        }
                    });
                }
            } else if (m.type === 'tool-stop' && typeof m.name === 'string') stopTool(m.name);
        };
    }
    function onMessage(e) {
        if (booted) return;
        var d = e && e.data;
        if (!d || d.type !== 'smbls:user-code-boot') return;
        if (e.source !== win.parent) return;
        var port = e.ports && e.ports[0];
        if (!port) return;
        booted = true;
        win.removeEventListener('message', onMessage);
        start(port);
        port.postMessage({
            method: 'booted',
            args: {}
        });
    }
    shimStorage();
    try {
        var stubs = makeStubs();
        // frank-allow FA409 — frame boot: smbls runtime registry contract, runs inside the sandboxed srcdoc before any element exists
        var store = win.__SMBLS_PKGS__ || (win.__SMBLS_PKGS__ = {});
        for(var name in stubs)if (!store[name]) store[name] = stubs[name];
    } catch (e) {}
    win.addEventListener('message', onMessage);
}

});

parcelRegister("1zcOx", function(module, exports) {

$parcel$export(module.exports, "createSupabaseClient", () => $1242fff8c5404bd5$export$b4be5d92eb7c243a);
$parcel$export(module.exports, "setup", () => $1242fff8c5404bd5$export$de27182ff8187d6c);
$parcel$export(module.exports, "supabaseAdapter", () => $1242fff8c5404bd5$export$7fb94962710321b8);
// Supabase fetch-plugin adapter — owned by the workspace layer.
//
// The framework (smbls@799bf2224) removed its builtin supabase adapter from
// `@symbo.ls/fetch` (the PLATFORM has no Supabase), but customer projects
// configured with `db: { adapter: 'supabase' }` — their own bring-your-own
// Supabase backends — remain a product feature of the editor. The adapter
// therefore lives HERE, next to the `@supabase/supabase-js` dependency
// (packages/shared/package.json), and is registered into the fetch plugin's
// cross-bundle registry via `registerAdapter('supabase', …)` in
// attachDbAdapters.js. Public surface is identical to the old builtin:
// `setup(options) -> { name, client, select, rpc, insert, update, upsert,
// delete, subscribe, getSession, getUser, signIn, signUp, signOut,
// onAuthStateChange, upload, download, getPublicUrl }`.
//
// FA204 / frank trap — clientCacheKey/applyFilters/applyModifiers used to
// live at module scope, plus bare sibling-export calls (setup ->
// createSupabaseClient/supabaseAdapter) between the exports below. Each now
// carries its own self-contained inline copy of whichever locals/siblings
// it actually calls. CLIENT_CACHE is genuine cross-call state (its whole
// point is to survive across separate `setup` calls against the same
// project, so a fresh per-call Map would defeat it and reintroduce the
// "Multiple GoTrueClient instances" warning this cache exists to prevent) —
// re-homed onto `globalThis.__supabaseFetchAdapterClientCache`, the same
// argument-less escape hatch as pointerCapability.js's
// `window.__pointerCapabilityState`.

var $YHbiI = parcelRequire("YHbiI");
const $1242fff8c5404bd5$export$b4be5d92eb7c243a = (url, key, options = {})=>{
    // The browser WebSocket, read at call time (see ./browserWebSocket.js —
    // inlined so this serialized function stays self-contained).
    const webSocket = typeof globalThis !== 'undefined' && globalThis.WebSocket || typeof window !== 'undefined' && window.WebSocket || null;
    if (webSocket) options = {
        ...options,
        realtime: {
            transport: webSocket,
            ...options.realtime || {}
        }
    };
    return (0, $YHbiI.createClient)(url, key, options);
};
const $1242fff8c5404bd5$export$de27182ff8187d6c = async ({ url: url, key: key, projectId: projectId, createClient: createClient, auth: auth, retry: retry, adapter: adapter, ...supabaseOptions })=>{
    // FA204 / frank trap — self-contained inline copies, see the file header.
    const _createSupabaseClient = (url, key, options = {})=>{
        const webSocket = typeof globalThis !== 'undefined' && globalThis.WebSocket || typeof window !== 'undefined' && window.WebSocket || null;
        if (webSocket) options = {
            ...options,
            realtime: {
                transport: webSocket,
                ...options.realtime || {}
            }
        };
        return (0, $YHbiI.createClient)(url, key, options);
    };
    // Cache Supabase clients by (url, key, authMode) so every `setup` call
    // against the same project reuses a single GoTrueClient. Without this
    // cache, each fresh adapter resolution (per db/fetch config, per query)
    // spins up a new GoTrueClient on the same storage key — Supabase logs
    // "Multiple GoTrueClient instances" warnings and auth state can drift.
    const CLIENT_CACHE = globalThis.__supabaseFetchAdapterClientCache = globalThis.__supabaseFetchAdapterClientCache || new Map();
    const _clientCacheKey = (url, key, authOff)=>`${url}|${key}|${authOff ? 'off' : 'on'}`;
    const _applyFilters = (query, params)=>{
        if (!params) return query;
        for(const key in params){
            const val = params[key];
            if (val === null) query = query.is(key, null);
            else if (Array.isArray(val)) query = query.in(key, val);
            else if (typeof val === 'object') for(const op in val){
                if (op === 'gt') query = query.gt(key, val[op]);
                else if (op === 'gte') query = query.gte(key, val[op]);
                else if (op === 'lt') query = query.lt(key, val[op]);
                else if (op === 'lte') query = query.lte(key, val[op]);
                else if (op === 'neq') query = query.neq(key, val[op]);
                else if (op === 'like') query = query.like(key, val[op]);
                else if (op === 'ilike') query = query.ilike(key, val[op]);
                else if (op === 'in') query = query.in(key, val[op]);
                else if (op === 'is') query = query.is(key, val[op]);
                else if (op === 'contains') query = query.contains(key, val[op]);
                else if (op === 'containedBy') query = query.containedBy(key, val[op]);
                else if (op === 'textSearch') query = query.textSearch(key, val[op]);
            }
            else query = query.eq(key, val);
        }
        return query;
    };
    const _applyModifiers = (query, { limit: limit, offset: offset, order: order, single: single } = {})=>{
        if (order) {
            if (Array.isArray(order)) for (const o of order){
                const by = typeof o === 'string' ? o : o.by;
                query = query.order(by, {
                    ascending: o.asc !== false
                });
            }
            else {
                const orderBy = typeof order === 'string' ? order : order.by;
                query = query.order(orderBy, {
                    ascending: order.asc !== false
                });
            }
        }
        if (limit) query = query.limit(limit);
        if (offset) query = query.range(offset, offset + (limit || 20) - 1);
        if (single) query = query.single();
        return query;
    };
    const _supabaseAdapter = (client)=>({
            name: 'supabase',
            client: client,
            getSession: async ()=>{
                const { data: data } = await client.auth.getSession();
                return data?.session || null;
            },
            getUser: async ()=>{
                const { data: data } = await client.auth.getUser();
                return data?.user || null;
            },
            signIn: (credentials)=>{
                if (credentials.provider) return client.auth.signInWithOAuth({
                    provider: credentials.provider
                });
                if (credentials.token) return client.auth.signInWithIdToken(credentials);
                return client.auth.signInWithPassword(credentials);
            },
            signUp: (credentials)=>client.auth.signUp(credentials),
            signOut: ()=>client.auth.signOut(),
            onAuthStateChange: (callback)=>{
                const { data: { subscription: subscription } } = client.auth.onAuthStateChange((event, session)=>callback(event, session));
                return ()=>subscription.unsubscribe();
            },
            select: async ({ from: from, schema: schema, select: select, params: params, headers: headers, ...modifiers })=>{
                const base = schema ? client.schema(schema) : client;
                let q = base.from(from).select(select || '*');
                q = _applyFilters(q, params);
                q = _applyModifiers(q, modifiers);
                if (headers) try {
                    for(const k in headers){
                        if (q.setHeader) q = q.setHeader(k, headers[k]);
                        else if (client.rest) client.rest.headers[k] = headers[k];
                    }
                } catch (e) {
                    console.warn('[supabase] setHeader failed:', e.message);
                }
                return q;
            },
            rpc: ({ from: from, params: params })=>client.rpc(from, params),
            insert: ({ from: from, schema: schema, data: data, select: select })=>{
                const base = schema ? client.schema(schema) : client;
                return base.from(from).insert(data).select(select || '*');
            },
            update: ({ from: from, schema: schema, data: data, params: params, select: select })=>{
                const base = schema ? client.schema(schema) : client;
                let q = base.from(from).update(data);
                q = _applyFilters(q, params);
                return q.select(select || '*');
            },
            upsert: ({ from: from, schema: schema, data: data, select: select })=>{
                const base = schema ? client.schema(schema) : client;
                return base.from(from).upsert(data).select(select || '*');
            },
            delete: ({ from: from, params: params })=>{
                let q = client.from(from).delete();
                q = _applyFilters(q, params);
                return q;
            },
            subscribe: ({ from: from, params: params, on: on }, callback)=>{
                const event = on || '*';
                const channel = client.channel(`db-${from}-${Date.now()}`).on('postgres_changes', {
                    event: event,
                    schema: 'public',
                    table: from,
                    ...params?.id ? {
                        filter: `id=eq.${params.id}`
                    } : {}
                }, (payload)=>callback(payload.new, payload.old, payload)).subscribe();
                return ()=>client.removeChannel(channel);
            },
            upload: ({ bucket: bucket, path: path, file: file, options: options })=>client.storage.from(bucket).upload(path, file, options),
            download: ({ bucket: bucket, path: path })=>client.storage.from(bucket).download(path),
            getPublicUrl: ({ bucket: bucket, path: path })=>client.storage.from(bucket).getPublicUrl(path)
        });
    const supabaseUrl = url || projectId && `https://${projectId}.supabase.co`;
    if (!supabaseUrl || !key) throw new Error('supabase adapter: url (or projectId) and key are required');
    // attachDbAdapters wires `createClient` onto the config before transport
    // strips it; when a config arrives bare (direct resolveDb call, unit
    // tests) fall back to the wrapper above — same factory either way.
    if (!createClient) createClient = _createSupabaseClient;
    // Disable Supabase auto-auth when auth: false (prevents navigator.locks hang)
    if (auth === false) supabaseOptions.auth = {
        autoRefreshToken: false,
        persistSession: false,
        detectSessionInUrl: false
    };
    const cacheKey = _clientCacheKey(supabaseUrl, key, auth === false);
    let client = CLIENT_CACHE.get(cacheKey);
    if (!client) {
        // `createClient` may be sync (default supabase-js) OR async — the SDK's
        // supabasePassthrough returns a promise so it can lazy-resolve the
        // optional peer dep. Awaiting works for both.
        client = await createClient(supabaseUrl, key, supabaseOptions);
        if (client?.auth) CLIENT_CACHE.set(cacheKey, client);
    }
    if (!client || !client.auth) return null;
    return _supabaseAdapter(client);
};
const $1242fff8c5404bd5$export$7fb94962710321b8 = (client)=>{
    // FA204 / frank trap — self-contained inline copies of applyFilters/
    // applyModifiers, see the file header.
    const _applyFilters = (query, params)=>{
        if (!params) return query;
        for(const key in params){
            const val = params[key];
            if (val === null) query = query.is(key, null);
            else if (Array.isArray(val)) query = query.in(key, val);
            else if (typeof val === 'object') for(const op in val){
                if (op === 'gt') query = query.gt(key, val[op]);
                else if (op === 'gte') query = query.gte(key, val[op]);
                else if (op === 'lt') query = query.lt(key, val[op]);
                else if (op === 'lte') query = query.lte(key, val[op]);
                else if (op === 'neq') query = query.neq(key, val[op]);
                else if (op === 'like') query = query.like(key, val[op]);
                else if (op === 'ilike') query = query.ilike(key, val[op]);
                else if (op === 'in') query = query.in(key, val[op]);
                else if (op === 'is') query = query.is(key, val[op]);
                else if (op === 'contains') query = query.contains(key, val[op]);
                else if (op === 'containedBy') query = query.containedBy(key, val[op]);
                else if (op === 'textSearch') query = query.textSearch(key, val[op]);
            }
            else query = query.eq(key, val);
        }
        return query;
    };
    const _applyModifiers = (query, { limit: limit, offset: offset, order: order, single: single } = {})=>{
        if (order) {
            if (Array.isArray(order)) for (const o of order){
                const by = typeof o === 'string' ? o : o.by;
                query = query.order(by, {
                    ascending: o.asc !== false
                });
            }
            else {
                const orderBy = typeof order === 'string' ? order : order.by;
                query = query.order(orderBy, {
                    ascending: order.asc !== false
                });
            }
        }
        if (limit) query = query.limit(limit);
        if (offset) query = query.range(offset, offset + (limit || 20) - 1);
        if (single) query = query.single();
        return query;
    };
    return {
        name: 'supabase',
        client: client,
        // Auth
        getSession: async ()=>{
            const { data: data } = await client.auth.getSession();
            return data?.session || null;
        },
        getUser: async ()=>{
            const { data: data } = await client.auth.getUser();
            return data?.user || null;
        },
        signIn: (credentials)=>{
            if (credentials.provider) return client.auth.signInWithOAuth({
                provider: credentials.provider
            });
            if (credentials.token) return client.auth.signInWithIdToken(credentials);
            return client.auth.signInWithPassword(credentials);
        },
        signUp: (credentials)=>client.auth.signUp(credentials),
        signOut: ()=>client.auth.signOut(),
        onAuthStateChange: (callback)=>{
            const { data: { subscription: subscription } } = client.auth.onAuthStateChange((event, session)=>callback(event, session));
            return ()=>subscription.unsubscribe();
        },
        // CRUD
        select: async ({ from: from, schema: schema, select: select, params: params, headers: headers, ...modifiers })=>{
            const base = schema ? client.schema(schema) : client;
            let q = base.from(from).select(select || '*');
            q = _applyFilters(q, params);
            q = _applyModifiers(q, modifiers);
            if (headers) try {
                for(const k in headers){
                    if (q.setHeader) q = q.setHeader(k, headers[k]);
                    else if (client.rest) client.rest.headers[k] = headers[k];
                }
            } catch (e) {
                console.warn('[supabase] setHeader failed:', e.message);
            }
            return q;
        },
        rpc: ({ from: from, params: params })=>client.rpc(from, params),
        insert: ({ from: from, schema: schema, data: data, select: select })=>{
            const base = schema ? client.schema(schema) : client;
            return base.from(from).insert(data).select(select || '*');
        },
        update: ({ from: from, schema: schema, data: data, params: params, select: select })=>{
            const base = schema ? client.schema(schema) : client;
            let q = base.from(from).update(data);
            q = _applyFilters(q, params);
            return q.select(select || '*');
        },
        upsert: ({ from: from, schema: schema, data: data, select: select })=>{
            const base = schema ? client.schema(schema) : client;
            return base.from(from).upsert(data).select(select || '*');
        },
        delete: ({ from: from, params: params })=>{
            let q = client.from(from).delete();
            q = _applyFilters(q, params);
            return q;
        },
        // Realtime
        subscribe: ({ from: from, params: params, on: on }, callback)=>{
            const event = on || '*';
            const channel = client.channel(`db-${from}-${Date.now()}`).on('postgres_changes', {
                event: event,
                schema: 'public',
                table: from,
                ...params?.id ? {
                    filter: `id=eq.${params.id}`
                } : {}
            }, (payload)=>callback(payload.new, payload.old, payload)).subscribe();
            return ()=>client.removeChannel(channel);
        },
        // Storage
        upload: ({ bucket: bucket, path: path, file: file, options: options })=>client.storage.from(bucket).upload(path, file, options),
        download: ({ bucket: bucket, path: path })=>client.storage.from(bucket).download(path),
        getPublicUrl: ({ bucket: bucket, path: path })=>client.storage.from(bucket).getPublicUrl(path)
    };
};

});
parcelRegister("YHbiI", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $5814268fead40b45$export$5d730b7aed1a3eb0);

var $jik0H = parcelRequire("jik0H");

var $4bKEp = parcelRequire("4bKEp");

var $iUghs = parcelRequire("iUghs");
parcelRequire("1acTR");
var $7SSav = parcelRequire("7SSav");

var $5vrbO = parcelRequire("5vrbO");
parcelRequire("9zCEj");
var $dVg10 = parcelRequire("dVg10");
//#region src/lib/version.ts
const $5814268fead40b45$var$version = "2.118.0";
//#endregion
//#region src/lib/constants.ts
let $5814268fead40b45$var$JS_ENV = "";
let $5814268fead40b45$var$JS_RUNTIME_VERSION;
if (typeof Deno !== "undefined") {
    var $5814268fead40b45$var$_Deno$version;
    $5814268fead40b45$var$JS_ENV = "deno";
    $5814268fead40b45$var$JS_RUNTIME_VERSION = ($5814268fead40b45$var$_Deno$version = Deno.version) === null || $5814268fead40b45$var$_Deno$version === void 0 ? void 0 : $5814268fead40b45$var$_Deno$version.deno;
} else if (typeof document !== "undefined") $5814268fead40b45$var$JS_ENV = "web";
else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") $5814268fead40b45$var$JS_ENV = "react-native";
else {
    var $5814268fead40b45$var$_process$version;
    $5814268fead40b45$var$JS_ENV = "node";
    const _process = globalThis["process"];
    $5814268fead40b45$var$JS_RUNTIME_VERSION = _process === null || _process === void 0 || ($5814268fead40b45$var$_process$version = _process["version"]) === null || $5814268fead40b45$var$_process$version === void 0 ? void 0 : $5814268fead40b45$var$_process$version.replace(/^v/, "");
}
const $5814268fead40b45$var$_runtimeMeta = [
    `runtime=${$5814268fead40b45$var$JS_ENV}`
];
if ($5814268fead40b45$var$JS_RUNTIME_VERSION) $5814268fead40b45$var$_runtimeMeta.push(`runtime-version=${$5814268fead40b45$var$JS_RUNTIME_VERSION}`);
const $5814268fead40b45$var$DEFAULT_HEADERS = {
    "X-Client-Info": `supabase-js/${$5814268fead40b45$var$version}; ${$5814268fead40b45$var$_runtimeMeta.join("; ")}`
};
const $5814268fead40b45$var$DEFAULT_GLOBAL_OPTIONS = {
    headers: $5814268fead40b45$var$DEFAULT_HEADERS
};
const $5814268fead40b45$var$DEFAULT_DB_OPTIONS = {
    schema: "public"
};
const $5814268fead40b45$var$DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
const $5814268fead40b45$var$DEFAULT_REALTIME_OPTIONS = {};
const $5814268fead40b45$var$DEFAULT_TRACE_PROPAGATION_OPTIONS = {
    enabled: false,
    respectSamplingDecision: true
};
//#endregion
//#region ../../shared/tracing/dist/module/parse.js
/**
* Parse W3C traceparent header according to the specification.
*
* The traceparent header format is: version-traceid-parentid-traceflags
* - version: 2 hex digits (currently always "00")
* - traceid: 32 hex digits (128-bit trace identifier)
* - parentid: 16 hex digits (64-bit span/parent identifier)
* - traceflags: 2 hex digits (8-bit flags, bit 0 is sampled flag)
*
* @param traceparent - The traceparent header value
* @returns Parsed traceparent object, or null if invalid format
*
* @see https://www.w3.org/TR/trace-context/#traceparent-header
*
* @example
* ```typescript
* const parsed = parseTraceParent('00-0af7651916cd43dd8448eb211c80319c-b7ad6b7169203331-01')
*
* console.log(parsed)
* // {
* //   version: '00',
* //   traceId: '0af7651916cd43dd8448eb211c80319c',
* //   parentId: 'b7ad6b7169203331',
* //   traceFlags: '01',
* //   isSampled: true
* // }
* ```
*/ function $5814268fead40b45$var$parseTraceParent(traceparent) {
    if (!traceparent || typeof traceparent !== "string") return null;
    const parts = traceparent.split("-");
    if (parts.length !== 4) return null;
    const [version$1, traceId, parentId, traceFlags] = parts;
    if (version$1.length !== 2 || traceId.length !== 32 || parentId.length !== 16 || traceFlags.length !== 2) return null;
    const hexRegex = /^[0-9a-f]+$/i;
    if (!hexRegex.test(version$1) || !hexRegex.test(traceId) || !hexRegex.test(parentId) || !hexRegex.test(traceFlags)) return null;
    if (traceId === "00000000000000000000000000000000" || parentId === "0000000000000000") return null;
    return {
        version: version$1,
        traceId: traceId,
        parentId: parentId,
        traceFlags: traceFlags,
        isSampled: (parseInt(traceFlags, 16) & 1) === 1
    };
}
//#endregion
//#region ../../shared/tracing/dist/module/validate.js
/**
* Check if trace context should be propagated to the target URL.
*
* This function checks if the target URL matches any of the configured
* propagation targets. Targets can be:
* - String: Exact hostname match or wildcard domain (*.example.com)
* - RegExp: Pattern matching hostname
* - Function: Custom logic to determine if URL should receive trace context
*
* @param targetUrl - The URL to check
* @param targets - Array of propagation targets
* @returns True if trace context should be propagated, false otherwise
*
* @example
* ```typescript
* const targets = [
*   'myproject.supabase.co',           // Exact match
*   '*.supabase.co',                   // Wildcard domain
*   /.*\.supabase\.co$/,               // Regex pattern
*   (url) => url.hostname === 'localhost' // Custom function
* ]
*
* shouldPropagateToTarget('https://myproject.supabase.co/rest/v1/table', targets)
* // true
*
* shouldPropagateToTarget('https://evil.com/api', targets)
* // false
* ```
*/ function $5814268fead40b45$var$shouldPropagateToTarget(targetUrl, targets) {
    if (!targetUrl || !targets || targets.length === 0) return false;
    let url;
    if (targetUrl instanceof URL) url = targetUrl;
    else try {
        url = new URL(targetUrl);
    } catch (error) {
        return false;
    }
    for (const target of targets)try {
        if (typeof target === "string") {
            if ($5814268fead40b45$var$matchStringTarget(url.hostname, target)) return true;
        } else if (target instanceof RegExp) {
            if (target.test(url.hostname)) return true;
        } else if (typeof target === "function") {
            if (target(url)) return true;
        }
    } catch (error) {
        continue;
    }
    return false;
}
/**
* Match hostname against string target (exact match or wildcard)
*
* @param hostname - The hostname to check
* @param target - The target pattern (exact or wildcard)
* @returns True if hostname matches target
*/ function $5814268fead40b45$var$matchStringTarget(hostname, target) {
    if (target === hostname) return true;
    if (target.startsWith("*.")) {
        const domain = target.slice(2);
        if (hostname.endsWith(domain)) {
            if (hostname === domain || hostname.endsWith("." + domain)) return true;
        }
    }
    return false;
}
//#endregion
//#region ../../shared/tracing/dist/module/defaults.js
/**
* Generate default propagation targets based on the Supabase project URL.
*
* By default, trace context is only propagated to Supabase domains for
* security. This prevents leaking trace context to potentially malicious
* third-party services.
*
* Wildcard strings (e.g. `*.supabase.co`) are matched with linear string
* operations rather than regex, avoiding ReDoS risk.
*
* @param supabaseUrl - The Supabase project URL
* @returns Array of default propagation targets
*/ function $5814268fead40b45$var$getDefaultPropagationTargets(supabaseUrl) {
    const targets = [];
    try {
        const url = new URL(supabaseUrl);
        targets.push(url.hostname);
    } catch (error) {}
    targets.push("*.supabase.co", "*.supabase.in");
    targets.push("localhost", "127.0.0.1", "[::1]");
    return targets;
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/typeof.js
function $5814268fead40b45$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5814268fead40b45$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $5814268fead40b45$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/toPrimitive.js
function $5814268fead40b45$var$toPrimitive(t, r) {
    if ("object" != $5814268fead40b45$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5814268fead40b45$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/toPropertyKey.js
function $5814268fead40b45$var$toPropertyKey(t) {
    var i = $5814268fead40b45$var$toPrimitive(t, "string");
    return "symbol" == $5814268fead40b45$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/defineProperty.js
function $5814268fead40b45$var$_defineProperty(e, r, t) {
    return (r = $5814268fead40b45$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/objectSpread2.js
function $5814268fead40b45$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5814268fead40b45$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5814268fead40b45$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $5814268fead40b45$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5814268fead40b45$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/fetch.ts
const $5814268fead40b45$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $5814268fead40b45$var$resolveHeadersConstructor = ()=>{
    return Headers;
};
/**
* New-format Supabase API keys (`sb_publishable_…` / `sb_secret_…`) are not JWTs and
* must never be sent as a Bearer token — they belong only in the `apikey` header.
* All other keys (legacy JWT keys, `sb_temp_…` temporary keys, unrecognized `sb_`
* subtypes) keep the Bearer fallback.
*/ const $5814268fead40b45$var$isNewApiKey = (key)=>key.startsWith("sb_publishable_") || key.startsWith("sb_secret_");
const $5814268fead40b45$var$TEMP_KEY_PREFIX = "sb_temp_";
const $5814268fead40b45$var$warnedKeySubtypes = /* @__PURE__ */ new Set();
/**
* Warn (once per subtype) when an `sb_` key isn't a subtype this SDK version recognizes.
* Never throws — the server, not the SDK, decides key validity. The key value is never
* included in the message.
*/ const $5814268fead40b45$var$checkApiKeyFormat = (key)=>{
    var _key$match$, _key$match;
    if (!key.startsWith("sb_") || $5814268fead40b45$var$isNewApiKey(key) || key.startsWith($5814268fead40b45$var$TEMP_KEY_PREFIX)) return;
    const subtype = (_key$match$ = (_key$match = key.match(/^sb_[a-zA-Z0-9]+_/)) === null || _key$match === void 0 ? void 0 : _key$match[0]) !== null && _key$match$ !== void 0 ? _key$match$ : "unknown";
    if ($5814268fead40b45$var$warnedKeySubtypes.has(subtype)) return;
    $5814268fead40b45$var$warnedKeySubtypes.add(subtype);
    console.warn("@supabase/supabase-js: Unrecognized Supabase API key format. The client will proceed and send this key as-is; if you see authentication errors you may need to upgrade @supabase/supabase-js to a version that recognizes this key type.");
};
const $5814268fead40b45$var$fetchWithAuth = (supabaseKey, supabaseUrl, getAccessToken, customFetch, tracePropagationOptions, options)=>{
    const fetch$1 = $5814268fead40b45$var$resolveFetch(customFetch);
    const HeadersConstructor = $5814268fead40b45$var$resolveHeadersConstructor();
    const traceEnabled = (tracePropagationOptions === null || tracePropagationOptions === void 0 ? void 0 : tracePropagationOptions.enabled) === true;
    const respectSampling = (tracePropagationOptions === null || tracePropagationOptions === void 0 ? void 0 : tracePropagationOptions.respectSamplingDecision) !== false;
    const traceTargets = traceEnabled ? $5814268fead40b45$var$getDefaultPropagationTargets(supabaseUrl) : null;
    const allowKeyAsBearer = !((options === null || options === void 0 ? void 0 : options.omitApiKeyAsBearer) && $5814268fead40b45$var$isNewApiKey(supabaseKey));
    return async (input, init)=>{
        const realToken = await getAccessToken();
        let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
        if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
        if (!headers.has("Authorization")) {
            const bearer = realToken !== null && realToken !== void 0 ? realToken : allowKeyAsBearer ? supabaseKey : null;
            if (bearer) headers.set("Authorization", `Bearer ${bearer}`);
        }
        if (traceTargets) {
            const traceHeaders = $5814268fead40b45$var$getTraceHeaders(input, traceTargets, respectSampling);
            if (traceHeaders) {
                if (traceHeaders.traceparent && !headers.has("traceparent")) headers.set("traceparent", traceHeaders.traceparent);
                if (traceHeaders.tracestate && !headers.has("tracestate")) headers.set("tracestate", traceHeaders.tracestate);
                if (traceHeaders.baggage && !headers.has("baggage")) headers.set("baggage", traceHeaders.baggage);
            }
        }
        return fetch$1(input, $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, init), {}, {
            headers: headers
        }));
    };
};
let $5814268fead40b45$var$warnedMissingTracingRuntime = false;
let $5814268fead40b45$var$warnedNonW3CPropagator = false;
function $5814268fead40b45$var$getTraceHeaders(input, targets, respectSampling) {
    const extractTraceContext = (0, $jik0H.t)();
    if (!extractTraceContext) {
        if (!$5814268fead40b45$var$warnedMissingTracingRuntime) {
            $5814268fead40b45$var$warnedMissingTracingRuntime = true;
            console.warn("@supabase/supabase-js: tracePropagation is enabled but the tracing runtime is not loaded, so trace headers will not be attached. Add `import '@supabase/supabase-js/tracing'` at your application entry point (requires the OpenTelemetry API package to be installed). The CDN/UMD build does not support trace propagation.");
        }
        return null;
    }
    if (!$5814268fead40b45$var$shouldPropagateToTarget(typeof input === "string" ? input : input instanceof URL ? input : input.url, targets)) return null;
    const traceContext = extractTraceContext();
    if (!traceContext || !traceContext.traceparent) {
        var _traceContext$carrier;
        if ((traceContext === null || traceContext === void 0 || (_traceContext$carrier = traceContext.carrierKeys) === null || _traceContext$carrier === void 0 ? void 0 : _traceContext$carrier.length) && !$5814268fead40b45$var$warnedNonW3CPropagator) {
            $5814268fead40b45$var$warnedNonW3CPropagator = true;
            const sentryHint = traceContext.carrierKeys.includes("sentry-trace") ? " Sentry detected: set `propagateTraceparent: true` in Sentry.init() to emit it." : " Configure your tracing SDK to emit W3C trace context on outgoing requests.";
            console.warn(`@supabase/supabase-js: tracePropagation is enabled and a tracing SDK is active, but its propagator wrote [${traceContext.carrierKeys.join(", ")}] and no W3C traceparent header, so trace headers will not be attached.` + sentryHint);
        }
        return null;
    }
    if (respectSampling) {
        const parsed = $5814268fead40b45$var$parseTraceParent(traceContext.traceparent);
        if (parsed && !parsed.isSampled) return {
            traceparent: traceContext.traceparent
        };
    }
    return traceContext;
}
//#endregion
//#region src/lib/helpers.ts
function $5814268fead40b45$var$normalizeTracePropagation(value) {
    return typeof value === "boolean" ? {
        enabled: value
    } : value;
}
function $5814268fead40b45$var$ensureTrailingSlash(url) {
    return url.endsWith("/") ? url : url + "/";
}
let $5814268fead40b45$var$warnedTopLevelSchema = false;
/**
* Warn (once per process) when `schema` is passed at the top level of the client options
* instead of under `db`. A top-level `schema` is not part of the options shape and is
* ignored, so queries silently go to the default schema. Never throws.
*
* Only `undefined` counts as unset, matching `db.schema`, where any other value is sent
* as the profile header.
*/ function $5814268fead40b45$var$checkTopLevelSchemaOption(options) {
    if ($5814268fead40b45$var$warnedTopLevelSchema) return;
    if (typeof options !== "object" || options === null || !("schema" in options) || options.schema === void 0) return;
    $5814268fead40b45$var$warnedTopLevelSchema = true;
    console.warn("@supabase/supabase-js: The \"schema\" option must be nested under \"db\", e.g. createClient(url, key, { db: { schema: 'myschema' } }). A top-level \"schema\" is ignored and queries go to the default schema.");
}
function $5814268fead40b45$var$applySettingDefaults(options, defaults) {
    var _DEFAULT_GLOBAL_OPTIO, _globalOptions$header, _ref, _tracePropagationOpti, _ref2, _tracePropagationOpti2;
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS$1, auth: DEFAULT_AUTH_OPTIONS$1, realtime: DEFAULT_REALTIME_OPTIONS$1, global: DEFAULT_GLOBAL_OPTIONS$1 } = defaults;
    const tracePropagationOptions = $5814268fead40b45$var$normalizeTracePropagation(options.tracePropagation);
    const DEFAULT_TRACE_PROPAGATION_OPTIONS$1 = $5814268fead40b45$var$normalizeTracePropagation(defaults.tracePropagation);
    const result = {
        db: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, DEFAULT_DB_OPTIONS$1), dbOptions),
        auth: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, DEFAULT_AUTH_OPTIONS$1), authOptions),
        realtime: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, DEFAULT_REALTIME_OPTIONS$1), realtimeOptions),
        storage: {},
        global: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, DEFAULT_GLOBAL_OPTIONS$1), globalOptions), {}, {
            headers: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, (_DEFAULT_GLOBAL_OPTIO = DEFAULT_GLOBAL_OPTIONS$1 === null || DEFAULT_GLOBAL_OPTIONS$1 === void 0 ? void 0 : DEFAULT_GLOBAL_OPTIONS$1.headers) !== null && _DEFAULT_GLOBAL_OPTIO !== void 0 ? _DEFAULT_GLOBAL_OPTIO : {}), (_globalOptions$header = globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.headers) !== null && _globalOptions$header !== void 0 ? _globalOptions$header : {})
        }),
        tracePropagation: {
            enabled: (_ref = (_tracePropagationOpti = tracePropagationOptions === null || tracePropagationOptions === void 0 ? void 0 : tracePropagationOptions.enabled) !== null && _tracePropagationOpti !== void 0 ? _tracePropagationOpti : DEFAULT_TRACE_PROPAGATION_OPTIONS$1 === null || DEFAULT_TRACE_PROPAGATION_OPTIONS$1 === void 0 ? void 0 : DEFAULT_TRACE_PROPAGATION_OPTIONS$1.enabled) !== null && _ref !== void 0 ? _ref : false,
            respectSamplingDecision: (_ref2 = (_tracePropagationOpti2 = tracePropagationOptions === null || tracePropagationOptions === void 0 ? void 0 : tracePropagationOptions.respectSamplingDecision) !== null && _tracePropagationOpti2 !== void 0 ? _tracePropagationOpti2 : DEFAULT_TRACE_PROPAGATION_OPTIONS$1 === null || DEFAULT_TRACE_PROPAGATION_OPTIONS$1 === void 0 ? void 0 : DEFAULT_TRACE_PROPAGATION_OPTIONS$1.respectSamplingDecision) !== null && _ref2 !== void 0 ? _ref2 : true
        },
        accessToken: async ()=>""
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else delete result.accessToken;
    return result;
}
/**
* Validates a Supabase client URL
*
* @param {string} supabaseUrl - The Supabase client URL string.
* @returns {URL} - The validated base URL.
* @throws {Error}
*/ function $5814268fead40b45$var$validateSupabaseUrl(supabaseUrl) {
    const trimmedUrl = supabaseUrl === null || supabaseUrl === void 0 ? void 0 : supabaseUrl.trim();
    if (!trimmedUrl) throw new Error("supabaseUrl is required.");
    if (!trimmedUrl.match(/^https?:\/\//i)) throw new Error("Invalid supabaseUrl: Must be a valid HTTP or HTTPS URL.");
    try {
        return new URL($5814268fead40b45$var$ensureTrailingSlash(trimmedUrl));
    } catch (_unused) {
        throw Error("Invalid supabaseUrl: Provided URL is malformed.");
    }
}
//#endregion
//#region src/lib/SupabaseAuthClient.ts
var $5814268fead40b45$var$SupabaseAuthClient = class extends (0, $dVg10.default) {
    constructor(options){
        super(options);
    }
};
//#endregion
//#region src/SupabaseClient.ts
/**
* Supabase Client.
*
* An isomorphic Javascript client for interacting with Postgres.
*/ var $5814268fead40b45$export$1bfe63e045eb2ffa = class {
    /**
	* Create a new client for use in the browser.
	*
	* @category Initializing
	*
	* @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
	* @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
	* @param options Optional configuration for the client:
	* - `db.schema` — You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
	* - `auth.autoRefreshToken` — Set to `true` if you want to automatically refresh the token before expiring.
	* - `auth.persistSession` — Set to `true` if you want to automatically save the user session into local storage.
	* - `auth.detectSessionInUrl` — Set to `true` if you want to automatically detect OAuth grants in the URL and sign in the user.
	* - `realtime` — Options passed along to the realtime-js constructor.
	* - `storage` — Options passed along to the storage-js constructor.
	* - `global.fetch` — A custom fetch implementation.
	* - `global.headers` — Any additional headers to send with each network request.
	*
	* @example Creating a client
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Create a single supabase client for interacting with your database
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* ```
	*
	* @example With a custom domain
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* // Use a custom domain as the supabase URL
	* const supabase = createClient('https://my-custom-domain.com', 'your-publishable-key')
	* ```
	*
	* @example With additional parameters
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const options = {
	*   db: {
	*     schema: 'public',
	*   },
	*   auth: {
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: true
	*   },
	*   global: {
	*     headers: { 'x-my-custom-header': 'my-app-name' },
	*   },
	* }
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", options)
	* ```
	*
	* @exampleDescription With custom schemas
	* By default the API server points to the `public` schema. You can enable other database schemas within the Dashboard.
	* Go to [Settings > API > Exposed schemas](/dashboard/project/_/settings/api) and add the schema which you want to expose to the API.
	*
	* Note: each client connection can only access a single schema, so the code above can access the `other_schema` schema but cannot access the `public` schema.
	*
	* @example With custom schemas
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
	*   // Provide a custom schema. Defaults to "public".
	*   db: { schema: 'other_schema' }
	* })
	* ```
	*
	* @exampleDescription Custom fetch implementation
	* `supabase-js` uses the runtime's global `fetch` to make HTTP requests,
	* but an alternative `fetch` implementation can be provided as an option.
	* This is useful in environments where the global `fetch` is unavailable or where you want to customize request behavior.
	*
	* @example Custom fetch implementation
	* ```js
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
	*   global: { fetch: fetch.bind(globalThis) }
	* })
	* ```
	*
	* @exampleDescription React Native options with AsyncStorage
	* For React Native we recommend using `AsyncStorage` as the storage implementation for Supabase Auth.
	*
	* @example React Native options with AsyncStorage
	* ```js
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from "@react-native-async-storage/async-storage";
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
	*   auth: {
	*     storage: AsyncStorage,
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @exampleDescription React Native options with Expo SecureStore
	* If you wish to encrypt the user's session information, you can use `aes-js` and store the encryption key in Expo SecureStore.
	* The `aes-js` library, a reputable JavaScript-only implementation of the AES encryption algorithm in CTR mode.
	* A new 256-bit encryption key is generated using the `react-native-get-random-values` library.
	* This key is stored inside Expo's SecureStore, while the value is encrypted and placed inside AsyncStorage.
	*
	* Please make sure that:
	* - You keep the `expo-secure-store`, `aes-js` and `react-native-get-random-values` libraries up-to-date.
	* - Choose the correct [`SecureStoreOptions`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestoreoptions) for your app's needs.
	*   E.g. [`SecureStore.WHEN_UNLOCKED`](https://docs.expo.dev/versions/latest/sdk/securestore/#securestorewhen_unlocked) regulates when the data can be accessed.
	* - Carefully consider optimizations or other modifications to the above example, as those can lead to introducing subtle security vulnerabilities.
	*
	* @example React Native options with Expo SecureStore
	* ```ts
	* import 'react-native-url-polyfill/auto'
	* import { createClient } from '@supabase/supabase-js'
	* import AsyncStorage from '@react-native-async-storage/async-storage';
	* import * as SecureStore from 'expo-secure-store';
	* import * as aesjs from 'aes-js';
	* import 'react-native-get-random-values';
	*
	* // As Expo's SecureStore does not support values larger than 2048
	* // bytes, an AES-256 key is generated and stored in SecureStore, while
	* // it is used to encrypt/decrypt values stored in AsyncStorage.
	* class LargeSecureStore {
	*   private async _encrypt(key: string, value: string) {
	*     const encryptionKey = crypto.getRandomValues(new Uint8Array(256 / 8));
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(encryptionKey, new aesjs.Counter(1));
	*     const encryptedBytes = cipher.encrypt(aesjs.utils.utf8.toBytes(value));
	*
	*     await SecureStore.setItemAsync(key, aesjs.utils.hex.fromBytes(encryptionKey));
	*
	*     return aesjs.utils.hex.fromBytes(encryptedBytes);
	*   }
	*
	*   private async _decrypt(key: string, value: string) {
	*     const encryptionKeyHex = await SecureStore.getItemAsync(key);
	*     if (!encryptionKeyHex) {
	*       return encryptionKeyHex;
	*     }
	*
	*     const cipher = new aesjs.ModeOfOperation.ctr(aesjs.utils.hex.toBytes(encryptionKeyHex), new aesjs.Counter(1));
	*     const decryptedBytes = cipher.decrypt(aesjs.utils.hex.toBytes(value));
	*
	*     return aesjs.utils.utf8.fromBytes(decryptedBytes);
	*   }
	*
	*   async getItem(key: string) {
	*     const encrypted = await AsyncStorage.getItem(key);
	*     if (!encrypted) { return encrypted; }
	*
	*     return await this._decrypt(key, encrypted);
	*   }
	*
	*   async removeItem(key: string) {
	*     await AsyncStorage.removeItem(key);
	*     await SecureStore.deleteItemAsync(key);
	*   }
	*
	*   async setItem(key: string, value: string) {
	*     const encrypted = await this._encrypt(key, value);
	*
	*     await AsyncStorage.setItem(key, encrypted);
	*   }
	* }
	*
	* const supabase = createClient("https://xyzcompany.supabase.co", "your-publishable-key", {
	*   auth: {
	*     storage: new LargeSecureStore(),
	*     autoRefreshToken: true,
	*     persistSession: true,
	*     detectSessionInUrl: false,
	*   },
	* });
	* ```
	*
	* @example With a database query
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	*
	* const { data } = await supabase.from('profiles').select('*')
	* ```
	*
	* @exampleDescription With OpenTelemetry tracing
	* Opt in to W3C trace context propagation so the `trace_id` from your
	* client-side spans is attached to Supabase requests and appears in API
	* Gateway and Edge Function logs. Requires `@opentelemetry/api` to be
	* installed in your application and the tracing runtime to be loaded via
	* `import '@supabase/supabase-js/tracing'`. See [Tracing with the JS SDK](https://supabase.com/docs/guides/telemetry/client-side-tracing).
	*
	* @example With OpenTelemetry tracing
	* ```ts
	* import '@supabase/supabase-js/tracing'
	* import { createClient } from '@supabase/supabase-js'
	* import { trace } from '@opentelemetry/api'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key', {
	*   tracePropagation: true,
	* })
	*
	* const tracer = trace.getTracer('my-app')
	*
	* await tracer.startActiveSpan('fetch-users', async (span) => {
	*   // Outgoing request carries the active trace context.
	*   const { data, error } = await supabase.from('users').select('*')
	*   span.end()
	* })
	* ```
	*/ constructor(supabaseUrl, supabaseKey, options){
        var _settings$auth$storag, _settings$global$head;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        const baseUrl = $5814268fead40b45$var$validateSupabaseUrl(supabaseUrl);
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        $5814268fead40b45$var$checkApiKeyFormat(supabaseKey);
        $5814268fead40b45$var$checkTopLevelSchemaOption(options);
        this.realtimeUrl = new URL("realtime/v1", baseUrl);
        this.realtimeUrl.protocol = this.realtimeUrl.protocol.replace("http", "ws");
        this.authUrl = new URL("auth/v1", baseUrl);
        this.storageUrl = new URL("storage/v1", baseUrl);
        this.functionsUrl = new URL("functions/v1", baseUrl);
        const defaultStorageKey = `sb-${baseUrl.hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: $5814268fead40b45$var$DEFAULT_DB_OPTIONS,
            realtime: $5814268fead40b45$var$DEFAULT_REALTIME_OPTIONS,
            auth: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, $5814268fead40b45$var$DEFAULT_AUTH_OPTIONS), {}, {
                storageKey: defaultStorageKey
            }),
            global: $5814268fead40b45$var$DEFAULT_GLOBAL_OPTIONS,
            tracePropagation: $5814268fead40b45$var$DEFAULT_TRACE_PROPAGATION_OPTIONS
        };
        const settings = $5814268fead40b45$var$applySettingDefaults(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.settings = settings;
        this.storageKey = (_settings$auth$storag = settings.auth.storageKey) !== null && _settings$auth$storag !== void 0 ? _settings$auth$storag : "";
        this.headers = (_settings$global$head = settings.global.headers) !== null && _settings$global$head !== void 0 ? _settings$global$head : {};
        if (!settings.accessToken) {
            var _settings$auth;
            this.auth = this._initSupabaseAuthClient((_settings$auth = settings.auth) !== null && _settings$auth !== void 0 ? _settings$auth : {}, this.headers, settings.global.fetch);
        } else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = $5814268fead40b45$var$fetchWithAuth(supabaseKey, supabaseUrl, this._getSessionToken.bind(this), settings.global.fetch, settings.tracePropagation);
        this.functionsFetch = $5814268fead40b45$var$fetchWithAuth(supabaseKey, supabaseUrl, this._getSessionToken.bind(this), settings.global.fetch, settings.tracePropagation, {
            omitApiKeyAsBearer: true
        });
        this.realtime = this._initRealtimeClient($5814268fead40b45$var$_objectSpread2({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this),
            fetch: this.fetch
        }, settings.realtime));
        if (this.accessToken) Promise.resolve(this.accessToken()).then((token)=>this.realtime.setAuth(token)).catch((e)=>console.warn("Failed to set initial Realtime auth token:", e));
        this.rest = new (0, $iUghs.PostgrestClient)(new URL("rest/v1", baseUrl).href, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch,
            timeout: settings.db.timeout,
            urlLengthLimit: settings.db.urlLengthLimit,
            retry: settings.db.retry
        });
        this.storage = new (0, $5vrbO.StorageClient)(this.storageUrl.href, this.headers, this.fetch, options === null || options === void 0 ? void 0 : options.storage);
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
	* Supabase Functions allows you to deploy and invoke edge functions.
	*/ get functions() {
        return new (0, $4bKEp.FunctionsClient)(this.functionsUrl.href, {
            headers: this.headers,
            customFetch: this.functionsFetch
        });
    }
    /**
	* Perform a query on a table or a view.
	*
	* @param relation - The table or view name to query
	*/ from(relation) {
        return this.rest.from(relation);
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*/ schema(schema) {
        return this.rest.schema(schema);
    }
    /**
	* Fetch the OpenAPI description PostgREST publishes for this client's schema.
	*
	* The document lists only the tables, views and functions the caller's role
	* holds privileges on. The request carries the same `apikey` and
	* `Authorization` headers as every other query, so the description is scoped
	* to the signed-in user. Call `.schema()` first to describe a schema other
	* than the client default.
	*
	* @example
	* ```ts
	* const { data, error } = await supabase.getOpenApiSpec()
	* ```
	*/ getOpenApiSpec() {
        return this.rest.getOpenApiSpec();
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*/ rpc(fn, args = {}, options = {
        head: false,
        get: false,
        count: void 0
    }) {
        return this.rest.rpc(fn, args, options);
    }
    /**
	* Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
	*
	* @param {string} name - The name of the Realtime channel.
	* @param {Object} opts - The options to pass to the Realtime channel.
	*
	* @category Realtime
	*/ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
	* Returns all Realtime channels.
	*
	* @category Realtime
	*
	* @example Get all channels
	* ```js
	* const channels = supabase.getChannels()
	* ```
	*/ getChannels() {
        return this.realtime.getChannels();
    }
    /**
	* Unsubscribes and removes Realtime channel from Realtime client.
	*
	* @param {RealtimeChannel} channel - The name of the Realtime channel.
	*
	*
	* @category Realtime
	*
	* @remarks
	* - Removing a channel is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Removes a channel
	* ```js
	* supabase.removeChannel(myChannel)
	* ```
	*/ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
	* Unsubscribes and removes all Realtime channels from Realtime client.
	*
	* @category Realtime
	*
	* @remarks
	* - Removing channels is a great way to maintain the performance of your project's Realtime service as well as your database if you're listening to Postgres changes. Supabase will automatically handle cleanup 30 seconds after a client is disconnected, but unused channels may cause degradation as more clients are simultaneously subscribed.
	*
	* @example Remove all channels
	* ```js
	* supabase.removeAllChannels()
	* ```
	*/ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    /**
	* The raw session token — the custom `accessToken` result or the signed-in user's JWT —
	* or `null` when there is no session. Unlike {@link _getAccessToken} it does not fall back
	* to `supabaseKey`, so callers can distinguish "no session" from "has session".
	*/ async _getSessionToken() {
        var _this = this;
        var _data$session$access_, _data$session;
        if (_this.accessToken) return await _this.accessToken();
        const { data: data } = await _this.auth.getSession();
        return (_data$session$access_ = (_data$session = data.session) === null || _data$session === void 0 ? void 0 : _data$session.access_token) !== null && _data$session$access_ !== void 0 ? _data$session$access_ : null;
    }
    async _getAccessToken() {
        var _this2 = this;
        var _await$this$_getSessi;
        return (_await$this$_getSessi = await _this2._getSessionToken()) !== null && _await$this$_getSessi !== void 0 ? _await$this$_getSessi : _this2.supabaseKey;
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, userStorage: userStorage, storageKey: storageKey, flowType: flowType, lock: lock, debug: debug, throwOnError: throwOnError, experimental: experimental, lockAcquireTimeout: lockAcquireTimeout, skipAutoInitialize: skipAutoInitialize }, headers, fetch$1) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new $5814268fead40b45$var$SupabaseAuthClient({
            url: this.authUrl.href,
            headers: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            userStorage: userStorage,
            flowType: flowType,
            lock: lock,
            debug: debug,
            throwOnError: throwOnError,
            experimental: experimental,
            fetch: fetch$1,
            lockAcquireTimeout: lockAcquireTimeout,
            skipAutoInitialize: skipAutoInitialize,
            hasCustomAuthorizationHeader: Object.keys(this.headers).some((key)=>key.toLowerCase() === "authorization")
        });
    }
    _initRealtimeClient(options) {
        return new (0, $7SSav.default)(this.realtimeUrl.href, $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, options), {}, {
            params: $5814268fead40b45$var$_objectSpread2($5814268fead40b45$var$_objectSpread2({}, {
                apikey: this.supabaseKey
            }), options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        return this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN" || event === "INITIAL_SESSION") && this.changedAccessToken !== token) {
            this.changedAccessToken = token;
            this.realtime.setAuth(token);
        } else if (event === "SIGNED_OUT") {
            this.realtime.setAuth();
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = void 0;
        }
    }
};
//#endregion
//#region src/index.ts
/**
* Creates a new Supabase Client.
*
* @example Creating a Supabase client
* ```ts
* import { createClient } from '@supabase/supabase-js'
*
* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
* const { data, error } = await supabase.from('profiles').select('*')
* ```
*/ const $5814268fead40b45$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new $5814268fead40b45$export$1bfe63e045eb2ffa(supabaseUrl, supabaseKey, options);
};
function $5814268fead40b45$var$shouldShowDeprecationWarning() {
    if (typeof window !== "undefined" || globalThis["Deno"] !== void 0) return false;
    const _process = globalThis["process"];
    if (!_process) return false;
    const processVersion = _process["version"];
    if (processVersion === void 0 || processVersion === null) return false;
    const versionMatch = processVersion.match(/^v(\d+)\./);
    if (!versionMatch) return false;
    return parseInt(versionMatch[1], 10) <= 20;
}
if ($5814268fead40b45$var$shouldShowDeprecationWarning()) console.warn("\u26A0\uFE0F  Node.js 20 and below are deprecated and will no longer be supported in future versions of @supabase/supabase-js. Please upgrade to Node.js 22 or later. For more information, visit: https://github.com/orgs/supabase/discussions/45715");

});
parcelRegister("jik0H", function(module, exports) {

$parcel$export(module.exports, "t", () => $2edee8badb98b054$export$625550452a3fa3ec);
//#region src/lib/tracingRegistry.ts
const $2edee8badb98b054$var$EXTRACTOR_KEY = Symbol.for("@supabase/supabase-js.traceContextExtractor");
/**
* Register the trace context extractor used by all Supabase clients in this
* process. Called by the `@supabase/supabase-js/tracing` subpath as an import
* side effect; the last registration wins.
*/ function $2edee8badb98b054$export$7ccc53e8f1e7dfc5(extractor) {
    globalThis[$2edee8badb98b054$var$EXTRACTOR_KEY] = extractor;
}
/**
* The currently registered trace context extractor, if any.
*/ function $2edee8badb98b054$export$625550452a3fa3ec() {
    return globalThis[$2edee8badb98b054$var$EXTRACTOR_KEY];
}

});

parcelRegister("4bKEp", function(module, exports) {

$parcel$export(module.exports, "FunctionsClient", () => $30cc606402fb489a$export$1d0b400bf8a0fa55);

var $5qviX = parcelRequire("5qviX");

var $3fU9o = parcelRequire("3fU9o");

var $jUkZF = parcelRequire("jUkZF");
class $30cc606402fb489a$export$1d0b400bf8a0fa55 {
    /**
     * Creates a new Functions client bound to an Edge Functions URL.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const { data, error } = await supabase.functions.invoke('hello-world')
     * ```
     *
     * @category Edge Functions
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { FunctionsClient, FunctionRegion } from '@supabase/functions-js'
     *
     * const functions = new FunctionsClient('https://xyzcompany.supabase.co/functions/v1', {
     *   headers: { apikey: 'your-publishable-key' },
     *   region: FunctionRegion.UsEast1,
     * })
     * ```
     */ constructor(url, { headers: headers = {}, customFetch: customFetch, region: region = (0, $jUkZF.FunctionRegion).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $3fU9o.resolveFetch)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     *
     * @category Edge Functions
     *
     * @example Setting the authorization header
     * ```ts
     * functions.setAuth(session.access_token)
     * ```
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     * @example
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     *
     * @category Edge Functions
     *
     * @remarks
     * - The API key is sent in the `apikey` header. The `Authorization` header is reserved
     *   for the signed-in user's JWT (or a custom auth token) — when there is no session, a
     *   new-format API key (`sb_publishable_…` / `sb_secret_…`) is not sent as a Bearer token.
     * - Invoke params generally match the [Fetch API](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API) spec.
     * - When you pass in a body to your function, we automatically attach the Content-Type header for `Blob`, `ArrayBuffer`, `File`, `FormData` and `String`. If it doesn't match any of these types we assume the payload is `json`, serialize it and attach the `Content-Type` header as `application/json`. You can override this behavior by passing in a `Content-Type` header of your own.
     * - Responses are automatically parsed as `json`, `blob` and `form-data` depending on the `Content-Type` header sent by your function. Responses are parsed as `text` by default.
     *
     * @example Basic invocation
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Error handling
     * A `FunctionsHttpError` error is returned if your function throws an error, `FunctionsRelayError` if the Supabase Relay has an error processing your function and `FunctionsFetchError` if there is a network error in calling your function. Log the full error object so fields like `name`, `context`, and any structured body aren't hidden.
     *
     * @example Error handling
     * ```js
     * import { FunctionsHttpError, FunctionsRelayError, FunctionsFetchError } from "@supabase/supabase-js";
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     *
     * if (error instanceof FunctionsHttpError) {
     *   const errorMessage = await error.context.json()
     *   console.error('Function returned an error', errorMessage)
     * } else if (error instanceof FunctionsRelayError) {
     *   console.error('Relay error:', error)
     * } else if (error instanceof FunctionsFetchError) {
     *   console.error('Fetch error:', error)
     * }
     * ```
     *
     * @exampleDescription Passing custom headers
     * You can pass custom headers to your function. Note: supabase-js automatically passes the `Authorization` header with the signed in user's JWT.
     *
     * @example Passing custom headers
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' }
     * })
     * ```
     *
     * @exampleDescription Calling with DELETE HTTP verb
     * You can also set the HTTP verb to `DELETE` when calling your Edge Function.
     *
     * @example Calling with DELETE HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   body: { foo: 'bar' },
     *   method: 'DELETE'
     * })
     * ```
     *
     * @exampleDescription Invoking a Function in the UsEast1 region
     * Here are the available regions:
     * - `FunctionRegion.Any`
     * - `FunctionRegion.ApNortheast1`
     * - `FunctionRegion.ApNortheast2`
     * - `FunctionRegion.ApSouth1`
     * - `FunctionRegion.ApSoutheast1`
     * - `FunctionRegion.ApSoutheast2`
     * - `FunctionRegion.CaCentral1`
     * - `FunctionRegion.EuCentral1`
     * - `FunctionRegion.EuWest1`
     * - `FunctionRegion.EuWest2`
     * - `FunctionRegion.EuWest3`
     * - `FunctionRegion.SaEast1`
     * - `FunctionRegion.UsEast1`
     * - `FunctionRegion.UsWest1`
     * - `FunctionRegion.UsWest2`
     *
     * @example Invoking a Function in the UsEast1 region
     * ```js
     * import { createClient, FunctionRegion } from '@supabase/supabase-js'
     *
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   body: { foo: 'bar' },
     *   region: FunctionRegion.UsEast1
     * })
     * ```
     *
     * @exampleDescription Calling with GET HTTP verb
     * You can also set the HTTP verb to `GET` when calling your Edge Function.
     *
     * @example Calling with GET HTTP verb
     * ```js
     * const { data, error } = await supabase.functions.invoke('hello', {
     *   headers: {
     *     "my-custom-header": 'my-custom-header-value'
     *   },
     *   method: 'GET'
     * })
     * ```
     *
     * @example Standalone client invoke
     * ```ts
     * const { data, error } = await functions.invoke('hello-world', {
     *   body: { name: 'Ada' },
     * })
     * ```
     */ invoke(functionName_1) {
        return (0, $5qviX.__awaiter)(this, arguments, void 0, function*(functionName, options = {}) {
            var _a, _b;
            let timeoutId;
            let timeoutController;
            let onAbort;
            try {
                const { headers: headers, method: method, body: functionArgs, signal: signal, timeout: timeout } = options;
                let _headers = {};
                let { region: region } = options;
                if (!region) region = this.region;
                // Add region as query parameter using URL API
                const url = new URL(`${this.url}/${functionName}`);
                if (region && region !== 'any') {
                    _headers['x-region'] = region;
                    url.searchParams.set('forceFunctionRegion', region);
                }
                let body;
                // HTTP header names are case-insensitive, so detect a caller-supplied Content-Type
                // regardless of casing — otherwise the SDK injects a second, conflicting Content-Type.
                const hasContentTypeHeader = !!headers && Object.keys(headers).some((key)=>key.toLowerCase() === 'content-type');
                if (functionArgs && !hasContentTypeHeader) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = functionArgs.type || 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                } else if (functionArgs && typeof functionArgs !== 'string' && !(typeof Blob !== 'undefined' && functionArgs instanceof Blob) && !(functionArgs instanceof ArrayBuffer) && !(typeof FormData !== 'undefined' && functionArgs instanceof FormData)) body = JSON.stringify(functionArgs);
                else body = functionArgs;
                // Handle timeout by creating an AbortController
                let effectiveSignal = signal;
                if (timeout) {
                    timeoutController = new AbortController();
                    timeoutId = setTimeout(()=>timeoutController.abort(), timeout);
                    // If user provided their own signal, we need to respect both
                    if (signal) {
                        effectiveSignal = timeoutController.signal;
                        // If the user's signal is aborted, abort our timeout controller too.
                        // Store the listener so we can clean it up in finally.
                        onAbort = ()=>timeoutController.abort();
                        signal.addEventListener('abort', onAbort);
                    } else effectiveSignal = timeoutController.signal;
                }
                const response = yield this.fetch(url.toString(), {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body,
                    signal: effectiveSignal
                }).catch((fetchError)=>{
                    throw new (0, $jUkZF.FunctionsFetchError)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, $jUkZF.FunctionsRelayError)(response);
                if (!response.ok) throw new (0, $jUkZF.FunctionsHttpError)(response);
                // HTTP media types are case-insensitive (RFC 9110), so normalize before
                // matching — otherwise an "Application/JSON" response falls through to text.
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim().toLowerCase();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream' || responseType === 'application/pdf') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null,
                    response: response
                };
            } catch (error) {
                return {
                    data: null,
                    error: error,
                    response: error instanceof (0, $jUkZF.FunctionsHttpError) || error instanceof (0, $jUkZF.FunctionsRelayError) ? error.context : undefined
                };
            } finally{
                // Clear the timeout if it was set
                if (timeoutId) clearTimeout(timeoutId);
                // Remove the cross-signal listener to prevent memory leaks when the caller
                // reuses the same AbortSignal across multiple invocations.
                if (onAbort) (_b = options.signal) === null || _b === void 0 || _b.removeEventListener('abort', onAbort);
            }
        });
    }
}

});
parcelRegister("5qviX", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $e49af61767c8d373$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $e49af61767c8d373$export$1050f835b63b671e);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e49af61767c8d373$var$extendStatics = function(d, b) {
    $e49af61767c8d373$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e49af61767c8d373$var$extendStatics(d, b);
};
function $e49af61767c8d373$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e49af61767c8d373$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e49af61767c8d373$export$18ce0697a983be9b = function() {
    $e49af61767c8d373$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e49af61767c8d373$export$18ce0697a983be9b.apply(this, arguments);
};
function $e49af61767c8d373$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e49af61767c8d373$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e49af61767c8d373$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e49af61767c8d373$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e49af61767c8d373$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e49af61767c8d373$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e49af61767c8d373$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e49af61767c8d373$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e49af61767c8d373$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e49af61767c8d373$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e49af61767c8d373$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e49af61767c8d373$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e49af61767c8d373$export$45d3717a4c69092e(o, m, p);
}
function $e49af61767c8d373$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e49af61767c8d373$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e49af61767c8d373$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e49af61767c8d373$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e49af61767c8d373$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e49af61767c8d373$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e49af61767c8d373$export$10c90e4f7922046c(v) {
    return this instanceof $e49af61767c8d373$export$10c90e4f7922046c ? (this.v = v, this) : new $e49af61767c8d373$export$10c90e4f7922046c(v);
}
function $e49af61767c8d373$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e49af61767c8d373$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e49af61767c8d373$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e49af61767c8d373$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e49af61767c8d373$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e49af61767c8d373$export$19a8beecd37a4c45 === "function" ? $e49af61767c8d373$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e49af61767c8d373$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e49af61767c8d373$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e49af61767c8d373$var$ownKeys = function(o) {
    $e49af61767c8d373$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e49af61767c8d373$var$ownKeys(o);
};
function $e49af61767c8d373$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e49af61767c8d373$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e49af61767c8d373$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e49af61767c8d373$var$__setModuleDefault(result, mod);
    return result;
}
function $e49af61767c8d373$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e49af61767c8d373$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e49af61767c8d373$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e49af61767c8d373$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e49af61767c8d373$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e49af61767c8d373$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e49af61767c8d373$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e49af61767c8d373$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e49af61767c8d373$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e49af61767c8d373$export$2e2bcd8739ae039 = {
    __extends: $e49af61767c8d373$export$a8ba968b8961cb8a,
    __assign: $e49af61767c8d373$export$18ce0697a983be9b,
    __rest: $e49af61767c8d373$export$3c9a16f847548506,
    __decorate: $e49af61767c8d373$export$29e00dfd3077644b,
    __param: $e49af61767c8d373$export$d5ad3fd78186038f,
    __esDecorate: $e49af61767c8d373$export$3a84e1ae4e97e9b0,
    __runInitializers: $e49af61767c8d373$export$d831c04e792af3d,
    __propKey: $e49af61767c8d373$export$6a2a36740a146cb8,
    __setFunctionName: $e49af61767c8d373$export$d1a06452d3489bc7,
    __metadata: $e49af61767c8d373$export$f1db080c865becb9,
    __awaiter: $e49af61767c8d373$export$1050f835b63b671e,
    __generator: $e49af61767c8d373$export$67ebef60e6f28a6,
    __createBinding: $e49af61767c8d373$export$45d3717a4c69092e,
    __exportStar: $e49af61767c8d373$export$f33643c0debef087,
    __values: $e49af61767c8d373$export$19a8beecd37a4c45,
    __read: $e49af61767c8d373$export$8d051b38c9118094,
    __spread: $e49af61767c8d373$export$afc72e2116322959,
    __spreadArrays: $e49af61767c8d373$export$6388937ca91ccae8,
    __spreadArray: $e49af61767c8d373$export$1216008129fb82ed,
    __await: $e49af61767c8d373$export$10c90e4f7922046c,
    __asyncGenerator: $e49af61767c8d373$export$e427f37a30a4de9b,
    __asyncDelegator: $e49af61767c8d373$export$bbd80228419bb833,
    __asyncValues: $e49af61767c8d373$export$e3b29a3d6162315f,
    __makeTemplateObject: $e49af61767c8d373$export$4fb47efe1390b86f,
    __importStar: $e49af61767c8d373$export$c21735bcef00d192,
    __importDefault: $e49af61767c8d373$export$da59b14a69baef04,
    __classPrivateFieldGet: $e49af61767c8d373$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e49af61767c8d373$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e49af61767c8d373$export$81fdc39f203e4e04,
    __addDisposableResource: $e49af61767c8d373$export$88ac25d8e944e405,
    __disposeResources: $e49af61767c8d373$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e49af61767c8d373$export$889dfb5d17574b0b
};

});

parcelRegister("3fU9o", function(module, exports) {

$parcel$export(module.exports, "resolveFetch", () => $25ee54243d42da71$export$98d92b1aa79f8cc7);
const $25ee54243d42da71$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};

});

parcelRegister("jUkZF", function(module, exports) {

$parcel$export(module.exports, "FunctionsFetchError", () => $e7e38833d8e67646$export$14f2b6540d498ce);
$parcel$export(module.exports, "FunctionsRelayError", () => $e7e38833d8e67646$export$d08a45df86040161);
$parcel$export(module.exports, "FunctionsHttpError", () => $e7e38833d8e67646$export$761f8c0e0fa4624f);
$parcel$export(module.exports, "FunctionRegion", () => $e7e38833d8e67646$export$9b19f1a5abf91e06);
/**
 * Base error for Supabase Edge Function invocations.
 *
 * @example
 * ```ts
 * import { FunctionsError } from '@supabase/functions-js'
 *
 * throw new FunctionsError('Unexpected error invoking function', 'FunctionsError', {
 *   requestId: 'abc123',
 * })
 * ```
 */ class $e7e38833d8e67646$export$738689d52335bb3c extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            context: this.context
        };
    }
}
class $e7e38833d8e67646$export$14f2b6540d498ce extends $e7e38833d8e67646$export$738689d52335bb3c {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class $e7e38833d8e67646$export$d08a45df86040161 extends $e7e38833d8e67646$export$738689d52335bb3c {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class $e7e38833d8e67646$export$761f8c0e0fa4624f extends $e7e38833d8e67646$export$738689d52335bb3c {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var $e7e38833d8e67646$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($e7e38833d8e67646$export$9b19f1a5abf91e06 || ($e7e38833d8e67646$export$9b19f1a5abf91e06 = {}));

});


parcelRegister("iUghs", function(module, exports) {

$parcel$export(module.exports, "PostgrestClient", () => $297e3b194d2fd01a$export$796f32e2ee984aaa);
//#region src/PostgrestError.ts
/**
* Error format
*
* Returned by every PostgREST request that fails. When something fails, the
* single most useful field is usually `hint` — Postgres often returns the
* actionable fix there, not in `message`. Always log the full object (e.g.
* `console.error(error)`); logging only `error.message` hides the hint.
*
* Read the fields in roughly this order of usefulness:
*
* - `hint` — actionable guidance from the database when available. For
*   permission-denied errors (`42501`), this is the literal SQL to fix the
*   problem, e.g.
*   `"Grant the required privileges to the current role with: GRANT SELECT ON public.users TO anon;"`.
*   Missing column? `hint` suggests the column you probably meant. Whenever
*   Postgres knows the fix, it puts it in `hint`.
* - `code` — stable error code from PostgREST (e.g. `PGRST301`) or Postgres
*   (e.g. `42501`). Branch on this rather than on `message` text.
* - `details` — extra context, often the offending value, key, or row.
* - `message` — human-readable summary. Useful in UI strings; less useful
*   for debugging.
*
* {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
*/ var $297e3b194d2fd01a$export$445b7e3a323f992f = class extends Error {
    /**
	* @example
	* ```ts
	* import PostgrestError from '@supabase/postgrest-js'
	*
	* throw new PostgrestError({
	*   message: 'Row level security prevented the request',
	*   details: 'RLS denied the insert',
	*   hint: 'Check your policies',
	*   code: 'PGRST301',
	* })
	* ```
	*/ constructor(context){
        super(context.message);
        this.name = "PostgrestError";
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            details: this.details,
            hint: this.hint,
            code: this.code
        };
    }
};
//#endregion
//#region src/types/common/common.ts
/**
* Default number of retry attempts.
*/ const $297e3b194d2fd01a$var$DEFAULT_MAX_RETRIES = 3;
/**
* Default exponential backoff delay function.
* Delays: 1s, 2s, 4s, 8s, ... (max 30s)
*
* @param attemptIndex - Zero-based index of the retry attempt
* @returns Delay in milliseconds before the next retry
*/ const $297e3b194d2fd01a$var$getRetryDelay = (attemptIndex)=>Math.min(1e3 * 2 ** attemptIndex, 3e4);
/**
* Status codes that are safe to retry.
* 520 = Cloudflare timeout/connection errors (transient)
* 503 = PostgREST schema cache not yet loaded (transient, signals retry via Retry-After header)
*/ const $297e3b194d2fd01a$var$RETRYABLE_STATUS_CODES = [
    520,
    503
];
/**
* HTTP methods that are safe to retry (idempotent operations).
*/ const $297e3b194d2fd01a$var$RETRYABLE_METHODS = [
    "GET",
    "HEAD",
    "OPTIONS"
];
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/typeof.js
function $297e3b194d2fd01a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $297e3b194d2fd01a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $297e3b194d2fd01a$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/toPrimitive.js
function $297e3b194d2fd01a$var$toPrimitive(t, r) {
    if ("object" != $297e3b194d2fd01a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $297e3b194d2fd01a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/toPropertyKey.js
function $297e3b194d2fd01a$var$toPropertyKey(t) {
    var i = $297e3b194d2fd01a$var$toPrimitive(t, "string");
    return "symbol" == $297e3b194d2fd01a$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/defineProperty.js
function $297e3b194d2fd01a$var$_defineProperty(e, r, t) {
    return (r = $297e3b194d2fd01a$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/objectSpread2.js
function $297e3b194d2fd01a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $297e3b194d2fd01a$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $297e3b194d2fd01a$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $297e3b194d2fd01a$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $297e3b194d2fd01a$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/fetchWithRetry.ts
/**
* Sleep for a given number of milliseconds.
* If an AbortSignal is provided, the sleep resolves early when the signal is aborted.
*/ function $297e3b194d2fd01a$var$sleep(ms, signal) {
    return new Promise((resolve)=>{
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            resolve();
            return;
        }
        const id = setTimeout(()=>{
            signal === null || signal === void 0 || signal.removeEventListener("abort", onAbort);
            resolve();
        }, ms);
        function onAbort() {
            clearTimeout(id);
            resolve();
        }
        signal === null || signal === void 0 || signal.addEventListener("abort", onAbort);
    });
}
/**
* Check if a request should be retried based on method and status code.
*/ function $297e3b194d2fd01a$var$shouldRetry(method, status, attemptCount, retryEnabled) {
    if (!retryEnabled || attemptCount >= $297e3b194d2fd01a$var$DEFAULT_MAX_RETRIES) return false;
    if (!$297e3b194d2fd01a$var$RETRYABLE_METHODS.includes(method)) return false;
    if (!$297e3b194d2fd01a$var$RETRYABLE_STATUS_CODES.includes(status)) return false;
    return true;
}
/**
* Perform a request with the retry policy shared by every PostgREST call.
*
* Idempotent methods (GET, HEAD, OPTIONS) are retried up to
* `DEFAULT_MAX_RETRIES` times when the fetch rejects or the server answers
* with a retryable status (503, 520). The wait honours the `Retry-After`
* header when present and backs off exponentially otherwise. Retried
* attempts carry an `X-Retry-Count` header. Aborted requests (including
* `AbortSignal.timeout()`, which rejects with `TimeoutError`) and
* non-idempotent methods are never retried: their rejection propagates
* unchanged. A response body is drained before its request is retried.
*/ async function $297e3b194d2fd01a$var$fetchWithRetry(fetchImpl, url, request, retryEnabled) {
    let attemptCount = 0;
    while(true){
        const headers = $297e3b194d2fd01a$var$_objectSpread2({}, request.headers);
        if (attemptCount > 0) headers["X-Retry-Count"] = String(attemptCount);
        let res;
        try {
            res = await fetchImpl(url, {
                method: request.method,
                headers: headers,
                body: request.body,
                signal: request.signal
            });
        } catch (fetchError) {
            var _request$signal;
            if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "TimeoutError" && ((_request$signal = request.signal) === null || _request$signal === void 0 ? void 0 : _request$signal.aborted)) throw fetchError;
            if (!$297e3b194d2fd01a$var$RETRYABLE_METHODS.includes(request.method)) throw fetchError;
            if (retryEnabled && attemptCount < $297e3b194d2fd01a$var$DEFAULT_MAX_RETRIES) {
                const delay = $297e3b194d2fd01a$var$getRetryDelay(attemptCount);
                attemptCount++;
                await $297e3b194d2fd01a$var$sleep(delay, request.signal);
                continue;
            }
            throw fetchError;
        }
        if ($297e3b194d2fd01a$var$shouldRetry(request.method, res.status, attemptCount, retryEnabled)) {
            var _res$headers$get, _res$headers;
            const retryAfterHeader = (_res$headers$get = (_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : _res$headers.get("Retry-After")) !== null && _res$headers$get !== void 0 ? _res$headers$get : null;
            const delay = retryAfterHeader !== null ? Math.max(0, parseInt(retryAfterHeader, 10) || 0) * 1e3 : $297e3b194d2fd01a$var$getRetryDelay(attemptCount);
            await res.text();
            attemptCount++;
            await $297e3b194d2fd01a$var$sleep(delay, request.signal);
            continue;
        }
        return res;
    }
}
//#endregion
//#region src/PostgrestBuilder.ts
var $297e3b194d2fd01a$export$3106e21688a06353 = class {
    /**
	* Creates a builder configured for a specific PostgREST request.
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('users').select('*')
	* ```
	*
	* @category Database
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const builder = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: new Headers({ apikey: 'your-publishable-key' }) }
	* )
	* ```
	*/ constructor(builder){
        var _builder$shouldThrowO, _builder$isMaybeSingl, _builder$shouldStripN, _builder$urlLengthLim, _builder$retry;
        this.shouldThrowOnError = false;
        this.retryEnabled = true;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = new Headers(builder.headers);
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = (_builder$shouldThrowO = builder.shouldThrowOnError) !== null && _builder$shouldThrowO !== void 0 ? _builder$shouldThrowO : false;
        this.signal = builder.signal;
        this.isMaybeSingle = (_builder$isMaybeSingl = builder.isMaybeSingle) !== null && _builder$isMaybeSingl !== void 0 ? _builder$isMaybeSingl : false;
        this.shouldStripNulls = (_builder$shouldStripN = builder.shouldStripNulls) !== null && _builder$shouldStripN !== void 0 ? _builder$shouldStripN : false;
        this.urlLengthLimit = (_builder$urlLengthLim = builder.urlLengthLimit) !== null && _builder$urlLengthLim !== void 0 ? _builder$urlLengthLim : 8e3;
        this.retryEnabled = (_builder$retry = builder.retry) !== null && _builder$retry !== void 0 ? _builder$retry : true;
        if (builder.fetch) this.fetch = builder.fetch;
        else this.fetch = fetch;
    }
    /**
	* If there's an error with the query, throwOnError will reject the promise by
	* throwing the error instead of returning it as part of a successful response.
	*
	* {@link https://github.com/supabase/supabase-js/issues/92}
	*
	* @category Database
	* @subcategory Using modifiers
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Strip null values from the response data. Properties with `null` values
	* will be omitted from the returned JSON objects.
	*
	* Requires PostgREST 11.2.0+.
	*
	* {@link https://docs.postgrest.org/en/stable/references/api/resource_representation.html#stripped-nulls}
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .stripNulls()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text, bio text);
	*
	* insert into
	*   characters (id, name, bio)
	* values
	*   (1, 'Luke', null),
	*   (2, 'Leia', 'Princess of Alderaan');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia",
	*       "bio": "Princess of Alderaan"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ stripNulls() {
        if (this.headers.get("Accept") === "text/csv") throw new Error("stripNulls() cannot be used with csv()");
        this.shouldStripNulls = true;
        return this;
    }
    /**
	* Set an HTTP header on this single PostgREST request, overriding any header
	* with the same name set on the client.
	*
	* This is an advanced escape hatch for one-off needs (passing a custom
	* `Authorization` for a single query, attaching a tracing header, etc.).
	* Most callers do not need it: configure client-wide headers via the
	* `headers` option when constructing the client, and authentication via
	* Supabase Auth.
	*
	* @param name - HTTP header name
	* @param value - HTTP header value
	*
	* @category Database
	* @subcategory Using modifiers
	*/ setHeader(name, value) {
        this.headers = new Headers(this.headers);
        this.headers.set(name, value);
        return this;
    }
    /**
	* @category Database
	* @subcategory Using modifiers
	*
	* Configure retry behavior for this request.
	*
	* By default, retries are enabled for idempotent requests (GET, HEAD, OPTIONS)
	* that fail with network errors or specific HTTP status codes (503, 520).
	* Retries use exponential backoff (1s, 2s, 4s) with a maximum of 3 attempts.
	*
	* @param enabled - Whether to enable retries for this request
	*
	* @example
	* ```ts
	* // Disable retries for a specific query
	* const { data, error } = await supabase
	*   .from('users')
	*   .select()
	*   .retry(false)
	* ```
	*/ retry(enabled) {
        this.retryEnabled = enabled;
        return this;
    }
    then(onfulfilled, onrejected) {
        var _this = this;
        if (this.schema === void 0) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers.set("Accept-Profile", this.schema);
        else this.headers.set("Content-Profile", this.schema);
        if (this.method !== "GET" && this.method !== "HEAD") this.headers.set("Content-Type", "application/json");
        if (this.shouldStripNulls) {
            const currentAccept = this.headers.get("Accept");
            if (currentAccept === "application/vnd.pgrst.object+json") this.headers.set("Accept", "application/vnd.pgrst.object+json;nulls=stripped");
            else if (!currentAccept || currentAccept === "application/json") this.headers.set("Accept", "application/vnd.pgrst.array+json;nulls=stripped");
        }
        const _fetch = this.fetch;
        const executeWithRetry = async ()=>{
            const headers = {};
            _this.headers.forEach((value, key)=>{
                headers[key] = value;
            });
            const res$1 = await $297e3b194d2fd01a$var$fetchWithRetry(_fetch, _this.url.toString(), {
                method: _this.method,
                headers: headers,
                body: JSON.stringify(_this.body, (_, value)=>typeof value === "bigint" ? value.toString() : value),
                signal: _this.signal
            }, _this.retryEnabled);
            return await _this.processResponse(res$1);
        };
        let res = executeWithRetry();
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _fetchError$name2;
            let errorDetails = "";
            let hint = "";
            let code = "";
            const cause = fetchError === null || fetchError === void 0 ? void 0 : fetchError.cause;
            if (cause) {
                var _cause$message, _cause$code, _fetchError$name, _cause$name;
                const causeMessage = (_cause$message = cause === null || cause === void 0 ? void 0 : cause.message) !== null && _cause$message !== void 0 ? _cause$message : "";
                const causeCode = (_cause$code = cause === null || cause === void 0 ? void 0 : cause.code) !== null && _cause$code !== void 0 ? _cause$code : "";
                errorDetails = `${(_fetchError$name = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name !== void 0 ? _fetchError$name : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`;
                errorDetails += `\n\nCaused by: ${(_cause$name = cause === null || cause === void 0 ? void 0 : cause.name) !== null && _cause$name !== void 0 ? _cause$name : "Error"}: ${causeMessage}`;
                if (causeCode) errorDetails += ` (${causeCode})`;
                if (cause === null || cause === void 0 ? void 0 : cause.stack) errorDetails += `\n${cause.stack}`;
            } else {
                var _fetchError$stack;
                errorDetails = (_fetchError$stack = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _fetchError$stack !== void 0 ? _fetchError$stack : "";
            }
            const urlLength = this.url.toString().length;
            if ((fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) === "AbortError" || (fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) === "ABORT_ERR") {
                code = "";
                hint = "Request was aborted (timeout or manual cancellation)";
                if (urlLength > this.urlLengthLimit) hint += `. Note: Your request URL is ${urlLength} characters, which may exceed server limits. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [many IDs])), consider using an RPC function to pass values server-side.`;
            } else if ((cause === null || cause === void 0 ? void 0 : cause.name) === "HeadersOverflowError" || (cause === null || cause === void 0 ? void 0 : cause.code) === "UND_ERR_HEADERS_OVERFLOW") {
                code = "";
                hint = "HTTP headers exceeded server limits (typically 16KB)";
                if (urlLength > this.urlLengthLimit) hint += `. Your request URL is ${urlLength} characters. If selecting many fields, consider using views. If filtering with large arrays (e.g., .in('id', [200+ IDs])), consider using an RPC function instead.`;
            }
            return {
                success: false,
                error: {
                    message: `${(_fetchError$name2 = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _fetchError$name2 !== void 0 ? _fetchError$name2 : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: errorDetails,
                    hint: hint,
                    code: code
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    /**
	* Process a fetch response and return the standardized postgrest response.
	*/ async processResponse(res) {
        var _this2 = this;
        let error = null;
        let data = null;
        let count = null;
        let status = res.status;
        let statusText = res.statusText;
        if (res.ok) {
            var _this$headers$get2, _res$headers$get;
            if (_this2.method !== "HEAD") {
                var _this$headers$get;
                const body = await res.text();
                if (body === "") ;
                else if (_this2.headers.get("Accept") === "text/csv") data = body;
                else if (_this2.headers.get("Accept") && ((_this$headers$get = _this2.headers.get("Accept")) === null || _this$headers$get === void 0 ? void 0 : _this$headers$get.includes("application/vnd.pgrst.plan+text"))) data = body;
                else try {
                    data = JSON.parse(body);
                } catch (_unused) {
                    error = {
                        message: body
                    };
                    data = null;
                    if (_this2.shouldThrowOnError) throw new $297e3b194d2fd01a$export$445b7e3a323f992f({
                        message: body,
                        details: "",
                        hint: "",
                        code: ""
                    });
                }
            }
            const countHeader = (_this$headers$get2 = _this2.headers.get("Prefer")) === null || _this$headers$get2 === void 0 ? void 0 : _this$headers$get2.match(/count=(exact|planned|estimated)/);
            const contentRange = (_res$headers$get = res.headers.get("content-range")) === null || _res$headers$get === void 0 ? void 0 : _res$headers$get.split("/");
            if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
            if (_this2.isMaybeSingle && Array.isArray(data)) {
                if (data.length > 1) {
                    error = {
                        code: "PGRST116",
                        details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                        hint: null,
                        message: "JSON object requested, multiple (or no) rows returned"
                    };
                    data = null;
                    count = null;
                    status = 406;
                    statusText = "Not Acceptable";
                    if (_this2.shouldThrowOnError) {
                        var _error$hint;
                        throw new $297e3b194d2fd01a$export$445b7e3a323f992f($297e3b194d2fd01a$var$_objectSpread2($297e3b194d2fd01a$var$_objectSpread2({}, error), {}, {
                            hint: (_error$hint = error.hint) !== null && _error$hint !== void 0 ? _error$hint : ""
                        }));
                    }
                } else if (data.length === 1) data = data[0];
                else data = null;
            }
        } else {
            const body = await res.text();
            try {
                error = JSON.parse(body);
                if (Array.isArray(error) && res.status === 404) {
                    data = [];
                    error = null;
                    status = 200;
                    statusText = "OK";
                }
            } catch (_unused2) {
                if (res.status === 404 && body === "") {
                    status = 204;
                    statusText = "No Content";
                } else error = {
                    message: body
                };
            }
            if (error && _this2.shouldThrowOnError) throw new $297e3b194d2fd01a$export$445b7e3a323f992f(error);
        }
        return {
            success: error === null,
            error: error,
            data: data,
            count: count,
            status: status,
            statusText: statusText
        };
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	* @subcategory Using modifiers
	*/ returns() {
        /* istanbul ignore next */ return this;
    }
    /**
	* Override the type of the returned `data` field in the response.
	*
	* @typeParam NewResult - The new type to cast the response data to
	* @typeParam Options - Optional type configuration (defaults to { merge: true })
	* @typeParam Options.merge - When true, merges the new type with existing return type. When false, replaces the existing types entirely (defaults to true)
	* @example
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	* @returns A PostgrestBuilder instance with the new type
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example Complete Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<MyType>, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of successful response
	* ```ts
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Complete Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<MyType, { merge: false }>()
	* ```
	*
	* @exampleResponse Complete Override type of object response
	* ```ts
	* let x: typeof data // MyType | null
	* ```
	*
	* @example Partial Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .overrideTypes<Array<{ status: "A" | "B" }>>()
	* ```
	*
	* @exampleResponse Partial Override type of successful response
	* ```ts
	* let x: typeof data // Array<CountryRowProperties & { status: "A" | "B" }>
	* ```
	*
	* @example Partial Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .overrideTypes<{ status: "A" | "B" }>()
	* ```
	*
	* @exampleResponse Partial Override type of object response
	* ```ts
	* let x: typeof data // CountryRowProperties & { status: "A" | "B" } | null
	* ```
	*
	* @example Merge vs replace existing types
	* ```typescript
	* // Merge with existing types (default behavior)
	* const query = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ custom_field: string }>()
	*
	* // Replace existing types completely
	* const replaceQuery = supabase
	*   .from('users')
	*   .select()
	*   .overrideTypes<{ id: number; name: string }, { merge: false }>()
	* ```
	*/ overrideTypes() {
        return this;
    }
};
//#endregion
//#region src/PostgrestTransformBuilder.ts
var $297e3b194d2fd01a$export$7b4361bb87e3030c = class extends $297e3b194d2fd01a$export$3106e21688a06353 {
    throwOnError() {
        return super.throwOnError();
    }
    /**
	* Perform a SELECT on the query result.
	*
	* By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
	* return modified rows. By calling this method, modified rows are returned in
	* `data`.
	*
	* @param columns - The columns to retrieve, separated by commas
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `upsert()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .upsert({ id: 1, name: 'Han Solo' })
	*   .select()
	* ```
	*
	* @exampleSql With `upsert()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Han');
	* ```
	*
	* @exampleResponse With `upsert()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Han Solo"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": ""
	* }
	* ```
	*/ select(columns) {
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        this.headers.append("Prefer", "return=representation");
        return this;
    }
    /**
	* Order the query result by `column`.
	*
	* You can call this method multiple times to order by multiple columns.
	*
	* You can order referenced tables, but it only affects the ordering of the
	* parent table if you use `!inner` in the query.
	*
	* @param column - The column to order by
	* @param options - Named parameters
	* @param options.ascending - If `true`, the result will be in ascending order
	* @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
	* `null`s appear last.
	* @param options.referencedTable - Set this to order a referenced table by
	* its columns
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('id, name')
	*   .order('id', { ascending: false })
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription On a referenced table
	* Ordering with `referencedTable` doesn't affect the ordering of the
	* parent table.
	*
	* @example On a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('orchestral_sections')
	*     .select(`
	*       name,
	*       instruments (
	*         name
	*       )
	*     `)
	*     .order('name', { referencedTable: 'instruments', ascending: false })
	*
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         },
	*         {
	*           "name": "harp"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": []
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Order parent table by a referenced table
	* Ordering with `referenced_table(col)` affects the ordering of the
	* parent table.
	*
	* @example Order parent table by a referenced table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('instruments')
	*     .select(`
	*       name,
	*       section:orchestral_sections (
	*         name
	*       )
	*     `)
	*     .order('section(name)', { ascending: true })
	*
	* ```
	*
	* @exampleSql Order parent table by a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Order parent table by a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "violin",
	*       "orchestral_sections": {"name": "strings"}
	*     },
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === void 0 ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
	* Limit the query result by `rows`.
	*
	* @param rows - The maximum number of rows to return
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example On a referenced table
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	*   .limit(1, { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql On a referenced table
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 1, 'harp'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse On a referenced table
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ limit(rows, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${rows}`);
        return this;
    }
    /**
	* Limit the query result by starting at an offset `from` and ending at the offset `to`.
	* Only records within this range are returned.
	* This respects the query order and if there is no order clause the range could behave unexpectedly.
	* The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
	* and fourth rows of the query.
	*
	* @param from - The starting index from which to limit the result
	* @param to - The last index to which to limit the result
	* @param options - Named parameters
	* @param options.referencedTable - Set this to limit rows of referenced
	* tables instead of the parent table
	* @param options.foreignTable - Deprecated, use `options.referencedTable`
	* instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .range(0, 1)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     },
	*     {
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === "undefined" ? "offset" : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
	* Set the AbortSignal for the fetch request.
	*
	* @param signal - The AbortSignal to use for the fetch request
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @remarks
	* You can use this to set a timeout for the request.
	*
	* @exampleDescription Aborting requests in-flight
	* You can use an [`AbortController`](https://developer.mozilla.org/en-US/docs/Web/API/AbortController) to abort requests.
	* Note that `status` and `statusText` don't mean anything for aborted requests as the request wasn't fulfilled.
	*
	* @example Aborting requests in-flight
	* ```ts
	* const ac = new AbortController()
	*
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(ac.signal)
	*
	* // Abort the request after 100 ms
	* setTimeout(() => ac.abort(), 100)
	* ```
	*
	* @exampleResponse Aborting requests in-flight
	* ```json
	*   {
	*     "error": {
	*       "message": "AbortError: The user aborted a request.",
	*       "details": "",
	*       "hint": "The request was aborted locally via the provided AbortSignal.",
	*       "code": ""
	*     },
	*     "status": 0,
	*     "statusText": ""
	*   }
	*
	* ```
	*
	* @example Set a timeout
	* ```ts
	* const { data, error } = await supabase
	*   .from('very_big_table')
	*   .select()
	*   .abortSignal(AbortSignal.timeout(1000 /* ms *\/))
	* ```
	*
	* @exampleResponse Set a timeout
	* ```json
	*   {
	*     "error": {
	*       "message": "FetchError: The user aborted a request.",
	*       "details": "",
	*       "hint": "",
	*       "code": ""
	*     },
	*     "status": 0,
	*     "statusText": ""
	*   }
	*
	* ```
	*/ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be one row (e.g. using `.limit(1)`), otherwise this
	* returns an error.
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .limit(1)
	*   .single()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": {
	*     "name": "Luke"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ single() {
        this.headers.set("Accept", "application/vnd.pgrst.object+json");
        return this;
    }
    /**
	* Return `data` as a single object instead of an array of objects.
	*
	* Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
	* this returns an error.
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Katniss')
	*   .maybeSingle()
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ maybeSingle() {
        this.isMaybeSingle = true;
        return this;
    }
    /**
	* Return `data` as a string in CSV format.
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @exampleDescription Return data as CSV
	* By default, the data is returned in JSON format, but can also be returned as Comma Separated Values.
	*
	* @example Return data as CSV
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .csv()
	* ```
	*
	* @exampleSql Return data as CSV
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Return data as CSV
	* ```json
	* {
	*   "data": "id,name\n1,Luke\n2,Leia\n3,Han",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ csv() {
        this.headers.set("Accept", "text/csv");
        return this;
    }
    /**
	* Return `data` as an object in [GeoJSON](https://geojson.org) format.
	*
	* @category Database
	* @subcategory Using modifiers
	*/ geojson() {
        this.headers.set("Accept", "application/geo+json");
        return this;
    }
    /**
	* Return `data` as the EXPLAIN plan for the query.
	*
	* You need to enable the
	* [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
	* setting before using this method.
	*
	* @param options - Named parameters
	*
	* @param options.analyze - If `true`, the query will be executed and the
	* actual run time will be returned
	*
	* @param options.verbose - If `true`, the query identifier will be returned
	* and `data` will include the output columns of the query
	*
	* @param options.settings - If `true`, include information on configuration
	* parameters that affect query planning
	*
	* @param options.buffers - If `true`, include information on buffer usage
	*
	* @param options.wal - If `true`, include information on WAL record generation
	*
	* @param options.format - The format of the output, can be `"text"` (default)
	* or `"json"`
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @exampleDescription Get the execution plan
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain()
	* ```
	*
	* @exampleSql Get the execution plan
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40)
	*         ->  Seq Scan on characters  (cost=0.00..22.00 rows=1200 width=40)
	* ```
	*
	* @exampleDescription Get the execution plan with analyze and verbose
	* By default, the data is returned in TEXT format, but can also be returned as JSON by using the `format` parameter.
	*
	* @example Get the execution plan with analyze and verbose
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .explain({analyze:true,verbose:true})
	* ```
	*
	* @exampleSql Get the execution plan with analyze and verbose
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Get the execution plan with analyze and verbose
	* ```js
	* Aggregate  (cost=33.34..33.36 rows=1 width=112) (actual time=0.041..0.041 rows=1 loops=1)
	*   Output: NULL::bigint, count(ROW(characters.id, characters.name)), COALESCE(json_agg(ROW(characters.id, characters.name)), '[]'::json), NULLIF(current_setting('response.headers'::text, true), ''::text), NULLIF(current_setting('response.status'::text, true), ''::text)
	*   ->  Limit  (cost=0.00..18.33 rows=1000 width=40) (actual time=0.005..0.006 rows=3 loops=1)
	*         Output: characters.id, characters.name
	*         ->  Seq Scan on public.characters  (cost=0.00..22.00 rows=1200 width=40) (actual time=0.004..0.005 rows=3 loops=1)
	*               Output: characters.id, characters.name
	* Query Identifier: -4730654291623321173
	* Planning Time: 0.407 ms
	* Execution Time: 0.119 ms
	* ```
	*/ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        var _this$headers$get;
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        const forMediatype = (_this$headers$get = this.headers.get("Accept")) !== null && _this$headers$get !== void 0 ? _this$headers$get : "application/json";
        this.headers.set("Accept", `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`);
        if (format === "json") return this;
        else return this;
    }
    /**
	* Dry-run this request: execute the query but discard the changes.
	*
	* Server-side, PostgREST runs the query inside a transaction and rolls it back
	* instead of committing. The response still contains the data that *would* have
	* been returned — `RETURNING` clauses execute and RLS, triggers, and constraints
	* are all evaluated — but no row is actually inserted, updated, or deleted.
	*
	* This affects only the single request it is chained to. The JS caller has no
	* handle on the transaction: supabase-js does not group multiple queries into
	* one transaction. For multi-statement transactional logic, use a database
	* function (`supabase.rpc(...)`).
	*
	* Sets the `Prefer: tx=rollback` header. See PostgREST's docs on transaction
	* preferences for the underlying mechanism.
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @example Validate an insert without persisting
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .insert({ name: 'France' })
	*   .select()
	*   .rollback()
	* // `data` shows what would have been inserted; nothing is saved.
	* ```
	*/ rollback() {
        this.headers.append("Prefer", "tx=rollback");
        return this;
    }
    /**
	* Override the type of the returned `data`.
	*
	* @typeParam NewResult - The new result type to override with
	* @deprecated Use overrideTypes<yourType, { merge: false }>() method at the end of your call chain instead
	*
	* @category Database
	* @subcategory Using modifiers
	*
	* @remarks
	* - Deprecated: use overrideTypes method instead
	*
	* @example Override type of successful response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .returns<Array<MyType>>()
	* ```
	*
	* @exampleResponse Override type of successful response
	* ```js
	* let x: typeof data // MyType[]
	* ```
	*
	* @example Override type of object response
	* ```ts
	* const { data } = await supabase
	*   .from('countries')
	*   .select()
	*   .maybeSingle()
	*   .returns<MyType>()
	* ```
	*
	* @exampleResponse Override type of object response
	* ```js
	* let x: typeof data // MyType | null
	* ```
	*/ returns() {
        return this;
    }
    /**
	* Set the maximum number of rows that can be affected by the query.
	* Only available in PostgREST v13+ and only works with PATCH and DELETE methods.
	*
	* @param rows - The maximum number of rows that can be affected
	*
	* @category Database
	* @subcategory Using modifiers
	*/ maxAffected(rows) {
        this.headers.append("Prefer", "handling=strict");
        this.headers.append("Prefer", `max-affected=${rows}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestFilterBuilder.ts
const $297e3b194d2fd01a$var$PostgrestReservedCharsRegexp = /* @__PURE__ */ new RegExp("[,()]");
var $297e3b194d2fd01a$export$3158317c13bdc93a = class extends $297e3b194d2fd01a$export$7b4361bb87e3030c {
    throwOnError() {
        return super.throwOnError();
    }
    /**
	* Match only rows where `column` is equal to `value`.
	*
	* To check if the value of `column` is NULL, you should use `.is()` instead.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .eq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is not equal to `value`.
	*
	* This filter does not include rows where `column` is `NULL`. To match null
	* values, use `.is(column, null)` instead.
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .neq('name', 'Leia')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Luke"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    regexMatch(column, pattern) {
        this.url.searchParams.append(column, `match.${pattern}`);
        return this;
    }
    regexIMatch(column, pattern) {
        this.url.searchParams.append(column, `imatch.${pattern}`);
        return this;
    }
    is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` IS DISTINCT FROM `value`.
	*
	* Unlike `.neq()`, this treats `NULL` as a comparable value. Two `NULL` values
	* are considered equal (not distinct), and comparing `NULL` with any non-NULL
	* value returns true (distinct).
	*
	* @param column - The column to filter on
	* @param value - The value to filter with
	*/ isDistinct(column, value) {
        this.url.searchParams.append(column, `isdistinct.${value}`);
        return this;
    }
    /**
	* Match only rows where `column` is included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*
	* @category Database
	* @subcategory Using filters
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	*   .in('name', ['Leia', 'Han'])
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 2,
	*       "name": "Leia"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $297e3b194d2fd01a$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
	* Match only rows where `column` is NOT included in the `values` array.
	*
	* @param column - The column to filter on
	* @param values - The values array to filter with
	*/ notIn(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            if (typeof s === "string" && $297e3b194d2fd01a$var$PostgrestReservedCharsRegexp.test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `not.in.(${cleanedValues})`);
        return this;
    }
    contains(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cs.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    containedBy(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) this.url.searchParams.append(column, `cd.{${value.join(",")}}`);
        else this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    overlaps(column, value) {
        if (typeof value === "string") this.url.searchParams.append(column, `ov.${value}`);
        else this.url.searchParams.append(column, `ov.{${value.join(",")}}`);
        return this;
    }
    textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === void 0 ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    match(query) {
        Object.entries(query).filter(([_, value])=>value !== void 0).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
	* Match only rows which doesn't satisfy the filter.
	*
	* Unlike most filters, `opearator` and `value` are used as-is and need to
	* follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure they are properly sanitized.
	*
	* @param column - The column to filter on
	* @param operator - The operator to be negated to filter with, following
	* PostgREST syntax
	* @param value - The value to filter with, following PostgREST syntax
	*
	* @category Database
	* @subcategory Using filters
	*
	* @remarks
	* not() expects you to use the raw PostgREST syntax for the filter values.
	*
	* ```ts
	* .not('id', 'in', '(5,6,7)')  // Use `()` for `in` filter
	* .not('arraycol', 'cs', '{"a","b"}')  // Use `cs` for `contains()`, `{}` for array values
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .select()
	*   .not('name', 'is', null)
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'null'),
	*   (2, null);
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	*   {
	*     "data": [
	*       {
	*         "id": 1,
	*         "name": "null"
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*/ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
	* Match only rows which satisfy at least one of the filters.
	*
	* Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
	* syntax](https://postgrest.org/en/stable/api.html#operators). You also need
	* to make sure it's properly sanitized.
	*
	* It's currently not possible to do an `.or()` filter across multiple tables.
	*
	* @param filters - The filters to use, following PostgREST syntax
	* @param options - Named parameters
	* @param options.referencedTable - Set this to filter on referenced tables
	* instead of the parent table
	* @param options.foreignTable - Deprecated, use `referencedTable` instead
	*
	* @category Database
	* @subcategory Using filters
	*
	* @remarks
	* or() expects you to use the raw PostgREST syntax for the filter names and values.
	*
	* ```ts
	* .or('id.in.(5,6,7), arraycol.cs.{"a","b"}')  // Use `()` for `in` filter, `{}` for array values and `cs` for `contains()`.
	* .or('id.in.(5,6,7), arraycol.cd.{"a","b"}')  // Use `cd` for `containedBy()`
	* ```
	*
	* @example With `select()`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.eq.2,name.eq.Han')
	* ```
	*
	* @exampleSql With `select()`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse With `select()`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Leia"
	*     },
	*     {
	*       "name": "Han"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` with `and`
	* ```ts
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	*   .or('id.gt.3,and(id.eq.1,name.eq.Luke)')
	* ```
	*
	* @exampleSql Use `or` with `and`
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Use `or` with `and`
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Luke"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Use `or` on referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments!inner (
	*       name
	*     )
	*   `)
	*   .or('section_id.eq.1,name.eq.guzheng', { referencedTable: 'instruments' })
	* ```
	*
	* @exampleSql Use `or` on referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Use `or` on referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
};
//#endregion
//#region src/PostgrestQueryBuilder.ts
var $297e3b194d2fd01a$export$a81993b50ca081ad = class {
    /**
	* Creates a query builder scoped to a Postgres table or view.
	*
	* @category Database
	*
	* @param url - The URL for the query
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to use
	* @param options.fetch - Custom fetch implementation
	* @param options.urlLengthLimit - Maximum URL length before warning
	* @param options.retry - Enable automatic retries for transient errors (default: true)
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('users').select('*')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestQueryBuilder } from '@supabase/postgrest-js'
	*
	* const query = new PostgrestQueryBuilder(
	*   new URL('https://xyzcompany.supabase.co/rest/v1/users'),
	*   { headers: { apikey: 'your-publishable-key' }, retry: true }
	* )
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, urlLengthLimit: urlLengthLimit = 8e3, retry: retry }){
        this.url = url;
        this.headers = new Headers(headers);
        this.schema = schema;
        this.fetch = fetch$1;
        this.urlLengthLimit = urlLengthLimit;
        this.retry = retry;
    }
    /**
	* Clone URL and headers to prevent shared state between operations.
	*/ cloneRequestState() {
        return {
            url: new URL(this.url.toString()),
            headers: new Headers(this.headers)
        };
    }
    /**
	* Perform a SELECT query on the table or view.
	*
	* @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
	*
	* @param options - Named parameters
	*
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	*
	* @param options.count - Count algorithm to use to count rows in the table or view.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @remarks
	* When using `count` with `.range()` or `.limit()`, the returned `count` is the total number of rows
	* that match your filters, not the number of rows in the current page. Use this to build pagination UI.
	
	* - By default, Supabase projects return a maximum of 1,000 rows. This setting can be changed in your project's [API settings](/dashboard/project/_/settings/api). It's recommended that you keep it low to limit the payload size of accidental or malicious requests. You can use `range()` queries to paginate through your data.
	* - `select()` can be combined with [Filters](/docs/reference/javascript/using-filters)
	* - `select()` can be combined with [Modifiers](/docs/reference/javascript/using-modifiers)
	* - `apikey` is a reserved keyword if you're using the [Supabase Platform](/docs/guides/platform) and [should be avoided as a column name](https://github.com/supabase/supabase/issues/5465). *
	* @category Database
	*
	* @example Getting your data
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select()
	* ```
	*
	* @exampleSql Getting your data
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Harry'),
	*   (2, 'Frodo'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Getting your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Harry"
	*     },
	*     {
	*       "id": 2,
	*       "name": "Frodo"
	*     },
	*     {
	*       "id": 3,
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Handling errors
	* The most useful field on a Postgres error is usually `hint` — when the database knows the fix, it puts the literal SQL there. For example, a permission-denied error (`code: '42501'`) arrives with a `hint` like `"Grant the required privileges to the current role with: GRANT SELECT ON public.characters TO anon;"`. Log the full `error` object so the hint isn't hidden behind `error.message`.
	*
	* @example Handling errors
	* ```js
	* const { data, error } = await supabase.from('characters').select()
	* if (error) {
	*   // Logs the full error: message, code, details, and hint.
	*   console.error(error)
	*   return
	* }
	* ```
	*
	* @exampleResponse Handling errors
	* ```json
	* {
	*   "error": {
	*     "code": "42501",
	*     "details": null,
	*     "hint": "Grant the required privileges to the current role with: GRANT SELECT ON public.characters TO anon;",
	*     "message": "permission denied for table characters"
	*   },
	*   "status": 401,
	*   "statusText": ""
	* }
	* ```
	*
	* @example Selecting specific columns
	* ```js
	* const { data, error } = await supabase
	*   .from('characters')
	*   .select('name')
	* ```
	*
	* @exampleSql Selecting specific columns
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Frodo'),
	*   (2, 'Harry'),
	*   (3, 'Katniss');
	* ```
	*
	* @exampleResponse Selecting specific columns
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "Frodo"
	*     },
	*     {
	*       "name": "Harry"
	*     },
	*     {
	*       "name": "Katniss"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables
	* If your database has foreign key relationships, you can query related tables too.
	*
	* @example Query referenced tables
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`
	*     name,
	*     instruments (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables with spaces in their names
	* If your table name contains spaces, you must use double quotes in the `select` statement to reference the table.
	*
	* @example Query referenced tables with spaces in their names
	* ```js
	* const { data, error } = await supabase
	*   .from('orchestral sections')
	*   .select(`
	*     name,
	*     "musical instruments" (
	*       name
	*     )
	*   `)
	* ```
	*
	* @exampleSql Query referenced tables with spaces in their names
	* ```sql
	* create table
	*   "orchestral sections" (id int8 primary key, name text);
	* create table
	*   "musical instruments" (
	*     id int8 primary key,
	*     section_id int8 not null references "orchestral sections",
	*     name text
	*   );
	*
	* insert into
	*   "orchestral sections" (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   "musical instruments" (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Query referenced tables with spaces in their names
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "strings",
	*       "musical instruments": [
	*         {
	*           "name": "violin"
	*         }
	*       ]
	*     },
	*     {
	*       "name": "woodwinds",
	*       "musical instruments": [
	*         {
	*           "name": "flute"
	*         }
	*       ]
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query referenced tables through a join table
	* If you're in a situation where your tables are **NOT** directly
	* related, but instead are joined by a _join table_, you can still use
	* the `select()` method to query the related data. The join table needs
	* to have the foreign keys as part of its composite primary key.
	*
	* @example Query referenced tables through a join table
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     name,
	*     teams (
	*       name
	*     )
	*   `)
	*   
	* ```
	*
	* @exampleSql Query referenced tables through a join table
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*     -- both foreign keys must be part of a composite primary key
	*     primary key (user_id, team_id)
	*   );
	*
	* insert into
	*   users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* ```
	*
	* @exampleResponse Query referenced tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "name": "Kiran",
	*         "teams": [
	*           {
	*             "name": "Green"
	*           },
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       },
	*       {
	*         "name": "Evan",
	*         "teams": [
	*           {
	*             "name": "Blue"
	*           }
	*         ]
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Query the same referenced table multiple times
	* If you need to query the same referenced table twice, use the name of the
	* joined column to identify which join to use. You can also give each
	* column an alias.
	*
	* @example Query the same referenced table multiple times
	* ```ts
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:sender_id(name),
	*     to:receiver_id(name)
	*   `)
	*
	* // To infer types, use the name of the table (in this case `users`) and
	* // the name of the foreign key constraint.
	* const { data, error } = await supabase
	*   .from('messages')
	*   .select(`
	*     content,
	*     from:users!messages_sender_id_fkey(name),
	*     to:users!messages_receiver_id_fkey(name)
	*   `)
	* ```
	*
	* @exampleSql Query the same referenced table multiple times
	* ```sql
	*  create table
	*  users (id int8 primary key, name text);
	*
	*  create table
	*    messages (
	*      sender_id int8 not null references users,
	*      receiver_id int8 not null references users,
	*      content text
	*    );
	*
	*  insert into
	*    users (id, name)
	*  values
	*    (1, 'Kiran'),
	*    (2, 'Evan');
	*
	*  insert into
	*    messages (sender_id, receiver_id, content)
	*  values
	*    (1, 2, '👋');
	*  ```
	* ```
	*
	* @exampleResponse Query the same referenced table multiple times
	* ```json
	* {
	*   "data": [
	*     {
	*       "content": "👋",
	*       "from": {
	*         "name": "Kiran"
	*       },
	*       "to": {
	*         "name": "Evan"
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Query nested foreign tables through a join table
	* You can use the result of a joined table to gather data in
	* another foreign table. With multiple references to the same foreign
	* table you must specify the column on which to conduct the join.
	*
	* @example Query nested foreign tables through a join table
	* ```ts
	*   const { data, error } = await supabase
	*     .from('games')
	*     .select(`
	*       game_id:id,
	*       away_team:teams!games_away_team_fkey (
	*         users (
	*           id,
	*           name
	*         )
	*       )
	*     `)
	*   
	* ```
	*
	* @exampleSql Query nested foreign tables through a join table
	* ```sql
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text
	*   );
	* create table
	*   teams (
	*     id int8 primary key,
	*     name text
	*   );
	* -- join table
	* create table
	*   users_teams (
	*     user_id int8 not null references users,
	*     team_id int8 not null references teams,
	*
	*     primary key (user_id, team_id)
	*   );
	* create table
	*   games (
	*     id int8 primary key,
	*     home_team int8 not null references teams,
	*     away_team int8 not null references teams,
	*     name text
	*   );
	*
	* insert into users (id, name)
	* values
	*   (1, 'Kiran'),
	*   (2, 'Evan');
	* insert into
	*   teams (id, name)
	* values
	*   (1, 'Green'),
	*   (2, 'Blue');
	* insert into
	*   users_teams (user_id, team_id)
	* values
	*   (1, 1),
	*   (1, 2),
	*   (2, 2);
	* insert into
	*   games (id, home_team, away_team, name)
	* values
	*   (1, 1, 2, 'Green vs Blue'),
	*   (2, 2, 1, 'Blue vs Green');
	* ```
	*
	* @exampleResponse Query nested foreign tables through a join table
	* ```json
	*   {
	*     "data": [
	*       {
	*         "game_id": 1,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             },
	*             {
	*               "id": 2,
	*               "name": "Evan"
	*             }
	*           ]
	*         }
	*       },
	*       {
	*         "game_id": 2,
	*         "away_team": {
	*           "users": [
	*             {
	*               "id": 1,
	*               "name": "Kiran"
	*             }
	*           ]
	*         }
	*       }
	*     ],
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*   
	* ```
	*
	* @exampleDescription Filtering through referenced tables
	* If the filter on a referenced table's column is not satisfied, the referenced
	* table returns `[]` or `null` but the parent table is not filtered out.
	* If you want to filter out the parent table rows, use the `!inner` hint
	*
	* @example Filtering through referenced tables
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections(*)')
	*   .eq('orchestral_sections.name', 'percussion')
	* ```
	*
	* @exampleSql Filtering through referenced tables
	* ```sql
	* create table
	*   orchestral_sections (id int8 primary key, name text);
	* create table
	*   instruments (
	*     id int8 primary key,
	*     section_id int8 not null references orchestral_sections,
	*     name text
	*   );
	*
	* insert into
	*   orchestral_sections (id, name)
	* values
	*   (1, 'strings'),
	*   (2, 'woodwinds');
	* insert into
	*   instruments (id, section_id, name)
	* values
	*   (1, 2, 'flute'),
	*   (2, 1, 'violin');
	* ```
	*
	* @exampleResponse Filtering through referenced tables
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": null
	*     },
	*     {
	*       "name": "violin",
	*       "orchestral_sections": null
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with count
	* You can get the number of rows in a related table by using the
	* **count** property.
	*
	* @example Querying referenced table with count
	* ```ts
	* const { data, error } = await supabase
	*   .from('orchestral_sections')
	*   .select(`*, instruments(count)`)
	* ```
	*
	* @exampleSql Querying referenced table with count
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table characters (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('strings') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('violin', (select id from section)),
	* ('viola', (select id from section)),
	* ('cello', (select id from section)),
	* ('double bass', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with count
	* ```json
	* [
	*   {
	*     "id": "693694e7-d993-4360-a6d7-6294e325d9b6",
	*     "name": "strings",
	*     "instruments": [
	*       {
	*         "count": 4
	*       }
	*     ]
	*   }
	* ]
	* ```
	*
	* @exampleDescription Querying with count option
	* You can get the number of rows by using the
	* [count](/docs/reference/javascript/select#parameters) option.
	*
	* @example Querying with count option
	* ```ts
	* const { count, error } = await supabase
	*   .from('characters')
	*   .select('*', { count: 'exact', head: true })
	* ```
	*
	* @exampleSql Querying with count option
	* ```sql
	* create table
	*   characters (id int8 primary key, name text);
	*
	* insert into
	*   characters (id, name)
	* values
	*   (1, 'Luke'),
	*   (2, 'Leia'),
	*   (3, 'Han');
	* ```
	*
	* @exampleResponse Querying with count option
	* ```json
	* {
	*   "count": 3,
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying JSON data
	* You can select and filter data inside of
	* [JSON](/docs/guides/database/json) columns. Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* querying JSON data.
	*
	* @example Querying JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .select(`
	*     id, name,
	*     address->city
	*   `)
	* ```
	*
	* @exampleSql Querying JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Frodo', '{"city":"Hobbiton"}');
	* ```
	*
	* @exampleResponse Querying JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Frodo",
	*       "city": "Hobbiton"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Querying referenced table with inner join
	* If you don't want to return the referenced table contents, you can leave the parenthesis empty.
	* Like `.select('name, orchestral_sections!inner()')`.
	*
	* @example Querying referenced table with inner join
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .select('name, orchestral_sections!inner(name)')
	*   .eq('orchestral_sections.name', 'woodwinds')
	*   .limit(1)
	* ```
	*
	* @exampleSql Querying referenced table with inner join
	* ```sql
	* create table orchestral_sections (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text
	* );
	*
	* create table instruments (
	*   "id" "uuid" primary key default "extensions"."uuid_generate_v4"() not null,
	*   "name" text,
	*   "section_id" "uuid" references public.orchestral_sections on delete cascade
	* );
	*
	* with section as (
	*   insert into orchestral_sections (name)
	*   values ('woodwinds') returning id
	* )
	* insert into instruments (name, section_id) values
	* ('flute', (select id from section)),
	* ('clarinet', (select id from section)),
	* ('bassoon', (select id from section)),
	* ('piccolo', (select id from section));
	* ```
	*
	* @exampleResponse Querying referenced table with inner join
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "flute",
	*       "orchestral_sections": {"name": "woodwinds"}
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Switching schemas per query
	* In addition to setting the schema during initialization, you can also switch schemas on a per-query basis.
	* Make sure you've set up your [database privileges and API settings](/docs/guides/api/using-custom-schemas).
	*
	* @example Switching schemas per query
	* ```ts
	* const { data, error } = await supabase
	*   .schema('myschema')
	*   .from('mytable')
	*   .select()
	* ```
	*
	* @exampleSql Switching schemas per query
	* ```sql
	* create schema myschema;
	*
	* create table myschema.mytable (
	*   id uuid primary key default gen_random_uuid(),
	*   data text
	* );
	*
	* insert into myschema.mytable (data) values ('mydata');
	* ```
	*
	* @exampleResponse Switching schemas per query
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": "4162e008-27b0-4c0f-82dc-ccaeee9a624d",
	*       "data": "mydata"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ select(columns, options) {
        const { head: head = false, count: count } = options !== null && options !== void 0 ? options : {};
        const method = head ? "HEAD" : "GET";
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === "\"") quoted = !quoted;
            return c;
        }).join("");
        const { url: url, headers: headers } = this.cloneRequestState();
        url.searchParams.set("select", cleanedColumns);
        if (count) headers.append("Prefer", `count=${count}`);
        return new $297e3b194d2fd01a$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an INSERT into the table or view.
	*
	* By default, inserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to insert. Pass an object to insert a single row
	* or an array to insert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count inserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. Only applies for bulk
	* inserts.
	*
	* @category Database
	*
	* @example Create a record
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	* ```
	*
	* @exampleSql Create a record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record
	* ```json
	* {
	*   "status": 201,
	*   "statusText": ""
	* }
	* ```
	*
	* @exampleDescription Handling errors
	* `error.hint` from Postgres often contains the actionable fix (e.g. `"Grant the required privileges to the current role with: GRANT INSERT ON public.countries TO anon;"` for a `42501` permission-denied error). Log the full `error` object so it isn't hidden behind `error.message`.
	*
	* @example Handling errors
	* ```js
	* const { error } = await supabase.from('countries').insert({ id: 1, name: 'Mordor' })
	* if (error) console.error(error)
	* ```
	*
	* @example Create a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .insert({ id: 1, name: 'Mordor' })
	*   .select()
	* ```
	*
	* @exampleSql Create a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Create a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": ""
	* }
	* ```
	*
	* @exampleDescription Bulk create
	* A bulk create operation is handled in a single transaction.
	* If any of the inserts fail, none of the rows are inserted.
	*
	* @example Bulk create
	* ```ts
	* const { error } = await supabase
	*   .from('countries')
	*   .insert([
	*     { id: 1, name: 'Mordor' },
	*     { id: 1, name: 'The Shire' },
	*   ])
	* ```
	*
	* @exampleSql Bulk create
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	* ```
	*
	* @exampleResponse Bulk create
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (id)=(1) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"countries_pkey\""
	*   },
	*   "status": 409,
	*   "statusText": ""
	* }
	* ```
	*/ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", `missing=default`);
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $297e3b194d2fd01a$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch = this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an UPSERT on the table or view. Depending on the column(s) passed
	* to `onConflict`, `.upsert()` allows you to perform the equivalent of
	* `.insert()` if a row with the corresponding `onConflict` columns doesn't
	* exist, or if it does exist, perform an alternative action depending on
	* `ignoreDuplicates`.
	*
	* By default, upserted rows are not returned. To return it, chain the call
	* with `.select()`.
	*
	* @param values - The values to upsert with. Pass an object to upsert a
	* single row or an array to upsert multiple rows.
	*
	* @param options - Named parameters
	*
	* @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
	* duplicate rows are determined. Two rows are duplicates if all the
	* `onConflict` columns are equal.
	*
	* @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
	* `false`, duplicate rows are merged with existing rows.
	*
	* @param options.count - Count algorithm to use to count upserted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @param options.defaultToNull - Make missing fields default to `null`.
	* Otherwise, use the default value for the column. This only applies when
	* inserting new rows, not when merging with existing rows under
	* `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
	*
	* @example Upsert a single row using a unique key
	* ```ts
	* // Upserting a single row, overwriting based on the 'username' unique column
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ username: 'supabot' }, { onConflict: 'username' })
	*
	* // Example response:
	* // {
	* //   data: [
	* //     { id: 4, message: 'bar', username: 'supabot' }
	* //   ],
	* //   error: null
	* // }
	* ```
	*
	* @example Upsert with conflict resolution and exact row counting
	* ```ts
	* // Upserting and returning exact count
	* const { data, error, count } = await supabase
	*   .from('users')
	*   .upsert(
	*     {
	*       id: 3,
	*       message: 'foo',
	*       username: 'supabot'
	*     },
	*     {
	*       onConflict: 'username',
	*       count: 'exact'
	*     }
	*   )
	*
	* // Example response:
	* // {
	* //   data: [
	* //     {
	* //       id: 42,
	* //       handle: "saoirse",
	* //       display_name: "Saoirse"
	* //     }
	* //   ],
	* //   count: 1,
	* //   error: null
	* // }
	* ```
	*
	* @category Database
	*
	* @remarks
	* - Primary keys must be included in `values` to use upsert.
	*
	* @example Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert({ id: 1, name: 'piano' })
	*   .select()
	* ```
	*
	* @exampleSql Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": ""
	* }
	* ```
	*
	* @exampleDescription Handling errors
	* `error.hint` from Postgres often contains the actionable fix (e.g. `"Grant the required privileges to the current role with: GRANT INSERT, UPDATE ON public.instruments TO anon;"` for a `42501` permission-denied error). Log the full `error` object so it isn't hidden behind `error.message`.
	*
	* @example Handling errors
	* ```js
	* const { data, error } = await supabase.from('instruments').upsert({ id: 1, name: 'piano' }).select()
	* if (error) console.error(error)
	* ```
	*
	* @example Bulk Upsert your data
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .upsert([
	*     { id: 1, name: 'piano' },
	*     { id: 2, name: 'harp' },
	*   ])
	*   .select()
	* ```
	*
	* @exampleSql Bulk Upsert your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Bulk Upsert your data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     },
	*     {
	*       "id": 2,
	*       "name": "harp"
	*     }
	*   ],
	*   "status": 201,
	*   "statusText": ""
	* }
	* ```
	*
	* @exampleDescription Upserting into tables with constraints
	* In the following query, `upsert()` implicitly uses the `id`
	* (primary key) column to determine conflicts. If there is no existing
	* row with the same `id`, `upsert()` inserts a new row, which
	* will fail in this case as there is already a row with `handle` `"saoirse"`.
	* Using the `onConflict` option, you can instruct `upsert()` to use
	* another column with a unique constraint to determine conflicts.
	*
	* @example Upserting into tables with constraints
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .upsert({ id: 42, handle: 'saoirse', display_name: 'Saoirse' })
	*   .select()
	* ```
	*
	* @exampleSql Upserting into tables with constraints
	* ```sql
	* create table
	*   users (
	*     id int8 generated by default as identity primary key,
	*     handle text not null unique,
	*     display_name text
	*   );
	*
	* insert into
	*   users (id, handle, display_name)
	* values
	*   (1, 'saoirse', null);
	* ```
	*
	* @exampleResponse Upserting into tables with constraints
	* ```json
	* {
	*   "error": {
	*     "code": "23505",
	*     "details": "Key (handle)=(saoirse) already exists.",
	*     "hint": null,
	*     "message": "duplicate key value violates unique constraint \"users_handle_key\""
	*   },
	*   "status": 409,
	*   "statusText": ""
	* }
	* ```
	*/ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        var _this$fetch2;
        const method = "POST";
        const { url: url, headers: headers } = this.cloneRequestState();
        headers.append("Prefer", `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`);
        if (onConflict !== void 0) url.searchParams.set("on_conflict", onConflict);
        if (count) headers.append("Prefer", `count=${count}`);
        if (!defaultToNull) headers.append("Prefer", "missing=default");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new $297e3b194d2fd01a$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch2 = this.fetch) !== null && _this$fetch2 !== void 0 ? _this$fetch2 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform an UPDATE on the table or view.
	*
	* By default, updated rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param values - The values to update with
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count updated rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `update()` should always be combined with [Filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to update.
	*
	* @example Updating your data
	* ```ts
	* const { error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Updating your data
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Updating your data
	* ```json
	* {
	*   "status": 204,
	*   "statusText": ""
	* }
	* ```
	*
	* @exampleDescription Handling errors
	* `error.hint` from Postgres often contains the actionable fix (e.g. `"Grant the required privileges to the current role with: GRANT UPDATE ON public.instruments TO anon;"` for a `42501` permission-denied error). Log the full `error` object so it isn't hidden behind `error.message`.
	*
	* @example Handling errors
	* ```js
	* const { error } = await supabase.from('instruments').update({ name: 'piano' }).eq('id', 1)
	* if (error) console.error(error)
	* ```
	*
	* @example Update a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('instruments')
	*   .update({ name: 'piano' })
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Update a record and return it
	* ```sql
	* create table
	*   instruments (id int8 primary key, name text);
	*
	* insert into
	*   instruments (id, name)
	* values
	*   (1, 'harpsichord');
	* ```
	*
	* @exampleResponse Update a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "piano"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Updating JSON data
	* Postgres offers some
	* [operators](/docs/guides/database/json#query-the-jsonb-data) for
	* working with JSON data. Currently, it is only possible to update the entire JSON document.
	*
	* @example Updating JSON data
	* ```ts
	* const { data, error } = await supabase
	*   .from('users')
	*   .update({
	*     address: {
	*       street: 'Melrose Place',
	*       postcode: 90210
	*     }
	*   })
	*   .eq('address->postcode', 90210)
	*   .select()
	* ```
	*
	* @exampleSql Updating JSON data
	* ```sql
	* create table
	*   users (
	*     id int8 primary key,
	*     name text,
	*     address jsonb
	*   );
	*
	* insert into
	*   users (id, name, address)
	* values
	*   (1, 'Michael', '{ "postcode": 90210 }');
	* ```
	*
	* @exampleResponse Updating JSON data
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Michael",
	*       "address": {
	*         "street": "Melrose Place",
	*         "postcode": 90210
	*       }
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ update(values, { count: count } = {}) {
        var _this$fetch3;
        const method = "PATCH";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $297e3b194d2fd01a$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            body: values,
            fetch: (_this$fetch3 = this.fetch) !== null && _this$fetch3 !== void 0 ? _this$fetch3 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Perform a DELETE on the table or view.
	*
	* By default, deleted rows are not returned. To return it, chain the call
	* with `.select()` after filters.
	*
	* @param options - Named parameters
	*
	* @param options.count - Count algorithm to use to count deleted rows.
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @category Database
	*
	* @remarks
	* - `delete()` should always be combined with [filters](/docs/reference/javascript/using-filters) to target the item(s) you wish to delete.
	* - If you use `delete()` with filters and you have
	*   [RLS](/docs/learn/auth-deep-dive/auth-row-level-security) enabled, only
	*   rows visible through `SELECT` policies are deleted. Note that by default
	*   no rows are visible, so you need at least one `SELECT`/`ALL` policy that
	*   makes the rows visible.
	* - When using `delete().in()`, specify an array of values to target multiple rows with a single query. This is particularly useful for batch deleting entries that share common criteria, such as deleting users by their IDs. Ensure that the array you provide accurately represents all records you intend to delete to avoid unintended data removal.
	*
	* @example Delete a single record
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	* ```
	*
	* @exampleSql Delete a single record
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a single record
	* ```json
	* {
	*   "status": 204,
	*   "statusText": ""
	* }
	* ```
	*
	* @exampleDescription Handling errors
	* `error.hint` from Postgres often contains the actionable fix (e.g. `"Grant the required privileges to the current role with: GRANT DELETE ON public.countries TO anon;"` for a `42501` permission-denied error). Log the full `error` object so it isn't hidden behind `error.message`.
	*
	* @example Handling errors
	* ```js
	* const { error } = await supabase.from('countries').delete().eq('id', 1)
	* if (error) console.error(error)
	* ```
	*
	* @example Delete a record and return it
	* ```ts
	* const { data, error } = await supabase
	*   .from('countries')
	*   .delete()
	*   .eq('id', 1)
	*   .select()
	* ```
	*
	* @exampleSql Delete a record and return it
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Mordor');
	* ```
	*
	* @exampleResponse Delete a record and return it
	* ```json
	* {
	*   "data": [
	*     {
	*       "id": 1,
	*       "name": "Mordor"
	*     }
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Delete multiple records
	* ```ts
	* const response = await supabase
	*   .from('countries')
	*   .delete()
	*   .in('id', [1, 2, 3])
	* ```
	*
	* @exampleSql Delete multiple records
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'), (2, 'The Shire'), (3, 'Mordor');
	* ```
	*
	* @exampleResponse Delete multiple records
	* ```json
	* {
	*   "status": 204,
	*   "statusText": ""
	* }
	* ```
	*/ delete({ count: count } = {}) {
        var _this$fetch4;
        const method = "DELETE";
        const { url: url, headers: headers } = this.cloneRequestState();
        if (count) headers.append("Prefer", `count=${count}`);
        return new $297e3b194d2fd01a$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schema,
            fetch: (_this$fetch4 = this.fetch) !== null && _this$fetch4 !== void 0 ? _this$fetch4 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
//#endregion
//#region src/PostgrestClient.ts
/**
* Build the error for a failed OpenAPI request. PostgREST answers with a JSON
* error object when it produced the failure itself; proxies and disabled
* OpenAPI output answer with plain text or an empty body, in which case the
* body (or, failing that, the status text) becomes the message.
*/ function $297e3b194d2fd01a$var$toOpenApiError(body, statusText) {
    try {
        const parsed = JSON.parse(body);
        if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
            var _parsed$message, _parsed$details, _parsed$hint, _parsed$code;
            return new $297e3b194d2fd01a$export$445b7e3a323f992f({
                message: String((_parsed$message = parsed.message) !== null && _parsed$message !== void 0 ? _parsed$message : body),
                details: (_parsed$details = parsed.details) !== null && _parsed$details !== void 0 ? _parsed$details : "",
                hint: (_parsed$hint = parsed.hint) !== null && _parsed$hint !== void 0 ? _parsed$hint : "",
                code: (_parsed$code = parsed.code) !== null && _parsed$code !== void 0 ? _parsed$code : ""
            });
        }
    } catch (_unused) {}
    return new $297e3b194d2fd01a$export$445b7e3a323f992f({
        message: body || statusText,
        details: "",
        hint: "",
        code: ""
    });
}
/**
* Build the response for a request that yielded no readable body: the fetch
* itself rejected (no status is known, so it is 0), or the body stream failed
* while being read (the response status is preserved).
*/ function $297e3b194d2fd01a$var$toTransportFailure(cause, status, statusText) {
    var _err$name;
    const err = cause;
    return {
        success: false,
        error: new $297e3b194d2fd01a$export$445b7e3a323f992f({
            message: `${(_err$name = err === null || err === void 0 ? void 0 : err.name) !== null && _err$name !== void 0 ? _err$name : "FetchError"}: ${err === null || err === void 0 ? void 0 : err.message}`,
            details: "",
            hint: "",
            code: ""
        }),
        data: null,
        count: null,
        status: status,
        statusText: statusText
    };
}
/**
* PostgREST client.
*
* @typeParam Database - Types for the schema from the [type
* generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
*
* @typeParam SchemaName - Postgres schema to switch to. Must be a string
* literal, the same one passed to the constructor. If the schema is not
* `"public"`, this must be supplied manually.
*/ var $297e3b194d2fd01a$export$796f32e2ee984aaa = class PostgrestClient {
    /**
	* Creates a PostgREST client.
	*
	* @param url - URL of the PostgREST endpoint
	* @param options - Named parameters
	* @param options.headers - Custom headers
	* @param options.schema - Postgres schema to switch to
	* @param options.fetch - Custom fetch
	* @param options.timeout - Optional timeout in milliseconds for all requests. When set, requests will automatically abort after this duration to prevent indefinite hangs.
	* @param options.urlLengthLimit - Maximum URL length in characters before warnings/errors are triggered. Defaults to 8000.
	* @param options.retry - Enable or disable automatic retries for transient errors.
	*   When enabled, idempotent requests (GET, HEAD, OPTIONS) that fail with network
	*   errors or HTTP 503/520 responses will be automatically retried up to 3 times
	*   with exponential backoff (1s, 2s, 4s). Defaults to `true`.
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.from('profiles').select('*')
	* ```
	*
	* @category Database
	*
	* @remarks
	* - A `timeout` option (in milliseconds) can be set to automatically abort requests that take too long.
	* - A `urlLengthLimit` option (default: 8000) can be set to control when URL length warnings are included in error messages for aborted requests.
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { PostgrestClient } from '@supabase/postgrest-js'
	*
	* const postgrest = new PostgrestClient('https://xyzcompany.supabase.co/rest/v1', {
	*   headers: { apikey: 'your-publishable-key' },
	*   schema: 'public',
	*   timeout: 30000, // 30 second timeout
	* })
	* ```
	*/ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch$1, timeout: timeout, urlLengthLimit: urlLengthLimit = 8e3, retry: retry } = {}){
        this.url = url;
        this.headers = new Headers(headers);
        this.schemaName = schema;
        this.urlLengthLimit = urlLengthLimit;
        const originalFetch = fetch$1 !== null && fetch$1 !== void 0 ? fetch$1 : globalThis.fetch;
        if (timeout !== void 0 && timeout > 0) this.fetch = (input, init)=>{
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), timeout);
            const existingSignal = init === null || init === void 0 ? void 0 : init.signal;
            if (existingSignal) {
                if (existingSignal.aborted) {
                    clearTimeout(timeoutId);
                    return originalFetch(input, init);
                }
                const abortHandler = ()=>{
                    clearTimeout(timeoutId);
                    controller.abort();
                };
                existingSignal.addEventListener("abort", abortHandler, {
                    once: true
                });
                return originalFetch(input, $297e3b194d2fd01a$var$_objectSpread2($297e3b194d2fd01a$var$_objectSpread2({}, init), {}, {
                    signal: controller.signal
                })).finally(()=>{
                    clearTimeout(timeoutId);
                    existingSignal.removeEventListener("abort", abortHandler);
                });
            }
            return originalFetch(input, $297e3b194d2fd01a$var$_objectSpread2($297e3b194d2fd01a$var$_objectSpread2({}, init), {}, {
                signal: controller.signal
            })).finally(()=>clearTimeout(timeoutId));
        };
        else this.fetch = originalFetch;
        this.retry = retry;
    }
    from(relation) {
        if (!relation || typeof relation !== "string" || relation.trim() === "") throw new Error("Invalid relation name: relation must be a non-empty string.");
        return new $297e3b194d2fd01a$export$a81993b50ca081ad(new URL(`${this.url}/${relation}`), {
            headers: new Headers(this.headers),
            schema: this.schemaName,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Select a schema to query or perform an function (rpc) call.
	*
	* The schema needs to be on the list of exposed schemas inside Supabase.
	*
	* @param schema - The schema to query
	*
	* @category Database
	*/ schema(schema) {
        return new PostgrestClient(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
    /**
	* Fetch the OpenAPI description PostgREST publishes for this client's schema.
	*
	* The document lists only the tables, views and functions the caller's role
	* holds privileges on; PostgREST applies that filtering server-side. The
	* schema is the one this client was created with, so call `.schema()` first
	* to describe a different one. Transient failures are retried according to
	* the client's `retry` option, like any other idempotent request.
	*
	* @example
	* ```ts
	* const { data, error } = await supabase.getOpenApiSpec()
	* ```
	*
	* @example Describe a schema other than the client default
	* ```ts
	* const { data, error } = await supabase.schema('billing').getOpenApiSpec()
	* ```
	*
	* @category Database
	*/ async getOpenApiSpec() {
        var _this = this;
        var _this$fetch;
        const headers = new Headers(_this.headers);
        headers.set("Accept", "application/openapi+json");
        if (_this.schemaName) headers.set("Accept-Profile", _this.schemaName);
        const requestHeaders = {};
        headers.forEach((value, key)=>{
            requestHeaders[key] = value;
        });
        const fetchImpl = (_this$fetch = _this.fetch) !== null && _this$fetch !== void 0 ? _this$fetch : globalThis.fetch;
        let res;
        try {
            var _this$retry;
            res = await $297e3b194d2fd01a$var$fetchWithRetry(fetchImpl, `${_this.url}/`, {
                method: "GET",
                headers: requestHeaders
            }, (_this$retry = _this.retry) !== null && _this$retry !== void 0 ? _this$retry : true);
        } catch (fetchError) {
            return $297e3b194d2fd01a$var$toTransportFailure(fetchError, 0, "");
        }
        let body;
        try {
            body = await res.text();
        } catch (readError) {
            return $297e3b194d2fd01a$var$toTransportFailure(readError, res.status, res.statusText);
        }
        if (res.ok) try {
            return {
                success: true,
                error: null,
                data: JSON.parse(body),
                count: null,
                status: res.status,
                statusText: res.statusText
            };
        } catch (_unused2) {}
        return {
            success: false,
            error: $297e3b194d2fd01a$var$toOpenApiError(body, res.statusText),
            data: null,
            count: null,
            status: res.status,
            statusText: res.statusText
        };
    }
    /**
	* Perform a function call.
	*
	* @param fn - The function name to call
	* @param args - The arguments to pass to the function call
	* @param options - Named parameters
	* @param options.head - When set to `true`, `data` will not be returned.
	* Useful if you only need the count.
	* @param options.get - When set to `true`, the function will be called with
	* read-only access mode.
	* @param options.count - Count algorithm to use to count rows returned by the
	* function. Only applicable for [set-returning
	* functions](https://www.postgresql.org/docs/current/functions-srf.html).
	*
	* `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
	* hood.
	*
	* `"planned"`: Approximated but fast count algorithm. Uses the Postgres
	* statistics under the hood.
	*
	* `"estimated"`: Uses exact count for low numbers and planned count for high
	* numbers.
	*
	* @example
	* ```ts
	* // For cross-schema functions where type inference fails, use overrideTypes:
	* const { data } = await supabase
	*   .schema('schema_b')
	*   .rpc('function_a', {})
	*   .overrideTypes<{ id: string; user_id: string }[]>()
	* ```
	*
	* @category Database
	*
	* @example Call a Postgres function without arguments
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world')
	* ```
	*
	* @exampleSql Call a Postgres function without arguments
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function without arguments
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a Postgres function with arguments
	* ```ts
	* const { data, error } = await supabase.rpc('echo', { say: '👋' })
	* ```
	*
	* @exampleSql Call a Postgres function with arguments
	* ```sql
	* create function echo(say text) returns text as $$
	*   select say;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with arguments
	* ```json
	*   {
	*     "data": "👋",
	*     "status": 200,
	*     "statusText": "OK"
	*   }
	*
	* ```
	*
	* @exampleDescription Bulk processing
	* You can process large payloads by passing in an array as an argument.
	*
	* @example Bulk processing
	* ```ts
	* const { data, error } = await supabase.rpc('add_one_each', { arr: [1, 2, 3] })
	* ```
	*
	* @exampleSql Bulk processing
	* ```sql
	* create function add_one_each(arr int[]) returns int[] as $$
	*   select array_agg(n + 1) from unnest(arr) as n;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Bulk processing
	* ```json
	* {
	*   "data": [
	*     2,
	*     3,
	*     4
	*   ],
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @exampleDescription Call a Postgres function with filters
	* Postgres functions that return tables can also be combined with [Filters](/docs/reference/javascript/using-filters) and [Modifiers](/docs/reference/javascript/using-modifiers).
	*
	* @example Call a Postgres function with filters
	* ```ts
	* const { data, error } = await supabase
	*   .rpc('list_stored_countries')
	*   .eq('id', 1)
	*   .single()
	* ```
	*
	* @exampleSql Call a Postgres function with filters
	* ```sql
	* create table
	*   countries (id int8 primary key, name text);
	*
	* insert into
	*   countries (id, name)
	* values
	*   (1, 'Rohan'),
	*   (2, 'The Shire');
	*
	* create function list_stored_countries() returns setof countries as $$
	*   select * from countries;
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a Postgres function with filters
	* ```json
	* {
	*   "data": {
	*     "id": 1,
	*     "name": "Rohan"
	*   },
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*
	* @example Call a read-only Postgres function
	* ```ts
	* const { data, error } = await supabase.rpc('hello_world', undefined, { get: true })
	* ```
	*
	* @exampleSql Call a read-only Postgres function
	* ```sql
	* create function hello_world() returns text as $$
	*   select 'Hello world';
	* $$ language sql;
	* ```
	*
	* @exampleResponse Call a read-only Postgres function
	* ```json
	* {
	*   "data": "Hello world",
	*   "status": 200,
	*   "statusText": "OK"
	* }
	* ```
	*/ rpc(fn, args = {}, { head: head = false, get: get = false, count: count } = {}) {
        var _this$fetch2;
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        const _isObject = (v)=>v !== null && typeof v === "object" && (!Array.isArray(v) || v.some(_isObject));
        const _hasObjectArg = head && Object.values(args).some(_isObject);
        if (_hasObjectArg) {
            method = "POST";
            body = args;
        } else if (head || get) {
            method = head ? "HEAD" : "GET";
            Object.entries(args).filter(([_, value])=>value !== void 0).map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(",")}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = "POST";
            body = args;
        }
        const headers = new Headers(this.headers);
        if (_hasObjectArg) headers.set("Prefer", count ? `count=${count},return=minimal` : "return=minimal");
        else if (count) headers.set("Prefer", `count=${count}`);
        return new $297e3b194d2fd01a$export$3158317c13bdc93a({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: (_this$fetch2 = this.fetch) !== null && _this$fetch2 !== void 0 ? _this$fetch2 : fetch,
            urlLengthLimit: this.urlLengthLimit,
            retry: this.retry
        });
    }
};
//#endregion
//#region src/index.ts
var $297e3b194d2fd01a$export$2e2bcd8739ae039 = {
    PostgrestClient: $297e3b194d2fd01a$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $297e3b194d2fd01a$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $297e3b194d2fd01a$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $297e3b194d2fd01a$export$7b4361bb87e3030c,
    PostgrestBuilder: $297e3b194d2fd01a$export$3106e21688a06353,
    PostgrestError: $297e3b194d2fd01a$export$445b7e3a323f992f
};

});

parcelRegister("1acTR", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => (parcelRequire("7SSav")).default);

var $7SSav = parcelRequire("7SSav");

var $3FKfU = parcelRequire("3FKfU");
var $843pN = parcelRequire("843pN");

var $eIXMJ = parcelRequire("eIXMJ");

var $fkssd = parcelRequire("fkssd");

});
parcelRegister("7SSav", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bd7984a1e22c554$export$2e2bcd8739ae039);

var $fkssd = parcelRequire("fkssd");

var $5ssGf = parcelRequire("5ssGf");

var $i04Cg = parcelRequire("i04Cg");

var $abdzW = parcelRequire("abdzW");

var $3FKfU = parcelRequire("3FKfU");

var $5LfGH = parcelRequire("5LfGH");
// Connection-related constants
const $5bd7984a1e22c554$var$CONNECTION_TIMEOUTS = {
    HEARTBEAT_INTERVAL: 25000,
    RECONNECT_DELAY: 10,
    HEARTBEAT_TIMEOUT_FALLBACK: 100
};
const $5bd7984a1e22c554$var$RECONNECT_INTERVALS = [
    1000,
    2000,
    5000,
    10000
];
const $5bd7984a1e22c554$var$DEFAULT_RECONNECT_FALLBACK = 10000;
function $5bd7984a1e22c554$var$createMemorySessionStorage() {
    const store = new Map();
    return {
        get length () {
            return store.size;
        },
        clear () {
            store.clear();
        },
        getItem (key) {
            return store.has(key) ? store.get(key) : null;
        },
        key (index) {
            var _a;
            return (_a = Array.from(store.keys())[index]) !== null && _a !== void 0 ? _a : null;
        },
        removeItem (key) {
            store.delete(key);
        },
        setItem (key, value) {
            store.set(key, String(value));
        }
    };
}
function $5bd7984a1e22c554$var$resolveSessionStorage() {
    try {
        if (typeof globalThis !== 'undefined' && globalThis.sessionStorage) return globalThis.sessionStorage;
    } catch (_a) {
    // Property access on `sessionStorage` itself throws in restricted-storage browsers.
    }
    return $5bd7984a1e22c554$var$createMemorySessionStorage();
}
const $5bd7984a1e22c554$var$WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
class $5bd7984a1e22c554$export$2e2bcd8739ae039 {
    get endPoint() {
        return this.socketAdapter.endPoint;
    }
    get timeout() {
        return this.socketAdapter.timeout;
    }
    get transport() {
        return this.socketAdapter.transport;
    }
    get heartbeatCallback() {
        return this.socketAdapter.heartbeatCallback;
    }
    get heartbeatIntervalMs() {
        return this.socketAdapter.heartbeatIntervalMs;
    }
    get heartbeatTimer() {
        if (this.worker) return this._workerHeartbeatTimer;
        return this.socketAdapter.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        if (this.worker) return this._pendingWorkerHeartbeatRef;
        return this.socketAdapter.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socketAdapter.reconnectTimer;
    }
    get vsn() {
        return this.socketAdapter.vsn;
    }
    get encode() {
        return this.socketAdapter.encode;
    }
    get decode() {
        return this.socketAdapter.decode;
    }
    get reconnectAfterMs() {
        return this.socketAdapter.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socketAdapter.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socketAdapter.stateChangeCallbacks;
    }
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket. This can be a custom implementation
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers Deprecated: headers cannot be set on websocket connections and this option will be removed in the future.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.heartbeatCallback The optional function to handle heartbeat status and latency.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.logLevel Sets the log level for Realtime
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     * @param options.vsn The protocol version to use when connecting. Supported versions are "1.0.0" and "2.0.0". Defaults to "2.0.0".
     *
     * @category Realtime
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const channel = supabase.channel('room1')
     * channel
     *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
     *   .subscribe()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'your-publishable-key' },
     * })
     * client.connect()
     * ```
     */ constructor(endPoint, options){
        var _a;
        this.channels = new Array();
        this.accessTokenValue = null;
        this.accessToken = null;
        this.apiKey = null;
        this.httpEndpoint = '';
        /** @deprecated headers cannot be set on websocket connections */ this.headers = {};
        this.params = {};
        this.ref = 0;
        this.serializer = new (0, $i04Cg.default)();
        this._manuallySetToken = false;
        this._authPromise = null;
        this._authGeneration = 0;
        this._workerHeartbeatTimer = undefined;
        this._pendingWorkerHeartbeatRef = null;
        this._pendingDisconnectTimer = null;
        this._disconnectOnEmptyChannelsAfterMs = 0;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            if (customFetch) return (...args)=>customFetch(...args);
            return (...args)=>fetch(...args);
        };
        // Validate required parameters
        if (!((_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey)) throw new Error('API key is required to connect to Realtime');
        this.apiKey = options.params.apikey;
        const socketAdapterOptions = this._initializeOptions(options);
        this.socketAdapter = new (0, $5LfGH.default)(endPoint, socketAdapterOptions);
        this.httpEndpoint = (0, $abdzW.httpEndpointURL)(endPoint);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
    /**
     * Connects the socket, unless already connected.
     *
     * @category Realtime
     */ connect() {
        // Skip if already connecting, disconnecting, or connected
        if (this.isConnecting() || this.isDisconnecting() || this.isConnected()) return;
        // Trigger auth if needed and not already in progress
        // This ensures auth is called for standalone RealtimeClient usage
        // while avoiding race conditions with SupabaseClient's immediate setAuth call
        if (this.accessToken && !this._authPromise) this._setAuthSafely('connect');
        this._setupConnectionHandlers();
        try {
            this.socketAdapter.connect();
        } catch (error) {
            const errorMessage = error.message;
            throw new Error(`WebSocket not available: ${errorMessage}`);
        }
        this._handleNodeJsRaceCondition();
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     *
     * @category Realtime
     */ endpointURL() {
        return this.socketAdapter.endPointURL();
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     *
     * @category Realtime
     */ async disconnect(code, reason) {
        this._cancelPendingDisconnect();
        if (this.isDisconnecting()) return 'ok';
        return await this.socketAdapter.disconnect(()=>{
            clearInterval(this._workerHeartbeatTimer);
            this._terminateWorker();
        }, code, reason);
    }
    /**
     * Returns all created channels
     *
     * @category Realtime
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes, removes and tears down a single channel
     * @param channel A RealtimeChannel instance
     *
     * @category Realtime
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (status === 'ok') channel.teardown();
        return status;
    }
    /**
     * Unsubscribes, removes and tears down all channels
     *
     * @category Realtime
     */ async removeAllChannels() {
        const promises = this.channels.map(async (channel)=>{
            const result = await channel.unsubscribe();
            channel.teardown();
            return result;
        });
        const result = await Promise.all(promises);
        await this.disconnect();
        return result;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden in Client constructor.
     *
     * @category Realtime
     */ log(kind, msg, data) {
        this.socketAdapter.log(kind, msg, data);
    }
    /**
     * Returns true if a custom `logger` has been configured on this client.
     *
     * @category Realtime
     */ hasLogger() {
        return this.socketAdapter.hasLogger();
    }
    /**
     * Returns the current state of the socket.
     *
     * @category Realtime
     */ connectionState() {
        return this.socketAdapter.connectionState() || (0, $5ssGf.CONNECTION_STATE).closed;
    }
    /**
     * Returns `true` is the connection is open.
     *
     * @category Realtime
     */ isConnected() {
        return this.socketAdapter.isConnected();
    }
    /**
     * Returns `true` if the connection is currently connecting.
     *
     * @category Realtime
     */ isConnecting() {
        return this.socketAdapter.isConnecting();
    }
    /**
     * Returns `true` if the connection is currently disconnecting.
     *
     * @category Realtime
     */ isDisconnecting() {
        return this.socketAdapter.isDisconnecting();
    }
    /**
     * Creates (or reuses) a {@link RealtimeChannel} for the provided topic.
     *
     * Topics are automatically prefixed with `realtime:` to match the Realtime service.
     * If a channel with the same topic already exists it will be returned instead of creating
     * a duplicate connection.
     *
     * @category Realtime
     */ channel(topic, params = {
        config: {}
    }) {
        const realtimeTopic = `realtime:${topic}`;
        const exists = this.getChannels().find((c)=>c.topic === realtimeTopic);
        if (!exists) {
            const chan = new (0, $3FKfU.default)(`realtime:${topic}`, params, this);
            this._cancelPendingDisconnect();
            this.channels.push(chan);
            return chan;
        } else return exists;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     *
     * @category Realtime
     */ push(data) {
        this.socketAdapter.push(data);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * When a token is explicitly provided AND no `accessToken` callback is configured,
     * it will be preserved across channel operations (including removeChannel and
     * resubscribe) and the client stays in manual-token mode.
     *
     * When an `accessToken` callback IS configured, the callback is the source of truth:
     * the client remains in callback mode and continues to refresh from it on heartbeat,
     * even after a bootstrap/override `setAuth(token)` call.
     *
     * The callback is called on connect and on every heartbeat (`heartbeatIntervalMs`,
     * default 25000ms). Its token must stay valid past the next call, or the server closes
     * the channel at expiry with no automatic resubscribe.
     *
     * @param token A JWT string to override the token set on the client.
     *
     * @example Setting the authorization header
     * // Use a manual token (preserved across resubscribes when no accessToken callback is set)
     * client.realtime.setAuth('my-custom-jwt')
     *
     * // Switch back to using the accessToken callback
     * client.realtime.setAuth()
     *
     * @category Realtime
     */ async setAuth(token = null) {
        const authGeneration = ++this._authGeneration;
        const authPromise = this._performAuth(token, authGeneration);
        if (authGeneration === this._authGeneration) this._authPromise = authPromise;
        try {
            await authPromise;
        } finally{
            if (this._authPromise === authPromise) this._authPromise = null;
        }
    }
    /**
     * Returns true if the current access token was explicitly set via setAuth(token),
     * false if it was obtained via the accessToken callback.
     * @internal
     */ _isManualToken() {
        return this._manuallySetToken;
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     *
     * @category Realtime
     */ async sendHeartbeat() {
        this.socketAdapter.sendHeartbeat();
    }
    /**
     * Sets a callback that receives lifecycle events for internal heartbeat messages.
     * Useful for instrumenting connection health (e.g. sent/ok/timeout).
     *
     * @category Realtime
     */ onHeartbeat(callback) {
        this.socketAdapter.heartbeatCallback = this._wrapHeartbeatCallback(callback);
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        return this.socketAdapter.makeRef();
    }
    /**
     * Removes a channel from RealtimeClient
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c.topic !== channel.topic);
        if (this.channels.length === 0) {
            this.log('transport', 'no channels remaining, scheduling disconnect');
            this._schedulePendingDisconnect();
        }
    }
    /** @internal */ _schedulePendingDisconnect() {
        this._cancelPendingDisconnect();
        if (this._disconnectOnEmptyChannelsAfterMs === 0) {
            this.log('transport', 'disconnecting immediately - no channels');
            this.disconnect();
            return;
        }
        this._pendingDisconnectTimer = setTimeout(()=>{
            this._pendingDisconnectTimer = null;
            if (this.channels.length === 0) {
                this.log('transport', 'deferred disconnect fired - no channels, disconnecting');
                this.disconnect();
            }
        }, this._disconnectOnEmptyChannelsAfterMs);
        this.log('transport', `deferred disconnect scheduled in ${this._disconnectOnEmptyChannelsAfterMs}ms`);
    }
    /** @internal */ _cancelPendingDisconnect() {
        if (this._pendingDisconnectTimer !== null) {
            this.log('transport', 'pending disconnect cancelled - channel activity detected');
            clearTimeout(this._pendingDisconnectTimer);
            this._pendingDisconnectTimer = null;
        }
    }
    /**
     * Perform the actual auth operation
     * @internal
     */ async _performAuth(token, authGeneration) {
        let tokenToSend;
        let isManualToken = false;
        if (token) {
            tokenToSend = token;
            // Track if this is a manually-provided token
            isManualToken = true;
        } else if (this.accessToken) // Call the accessToken callback to get fresh token
        try {
            tokenToSend = await this.accessToken();
        } catch (e) {
            this.log('error', 'Error fetching access token from callback', e);
            // Fall back to cached value if callback fails
            tokenToSend = this.accessTokenValue;
        }
        else tokenToSend = this.accessTokenValue;
        if (authGeneration !== this._authGeneration) return;
        // Track whether this token was manually set or fetched via callback.
        // The callback is the source of truth for token refresh
        if (this.accessToken) this._manuallySetToken = false;
        else if (isManualToken) this._manuallySetToken = true;
        if (this.accessTokenValue != tokenToSend) {
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                const payload = {
                    access_token: tokenToSend,
                    version: (0, $5ssGf.DEFAULT_VERSION)
                };
                channel.updateJoinPayload(payload);
                if (channel.joinedOnce && channel.channelAdapter.isJoined()) channel.channelAdapter.push((0, $5ssGf.CHANNEL_EVENTS).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Wait for any in-flight auth operations to complete
     * @internal
     */ async _waitForAuthIfNeeded() {
        if (this._authPromise) await this._authPromise;
    }
    /**
     * Safely call setAuth with standardized error handling
     * @internal
     */ _setAuthSafely(context = 'general') {
        // Only refresh auth if using callback-based tokens
        if (!this._isManualToken()) this.setAuth().catch((e)=>{
            this.log('error', `Error setting auth in ${context}`, e);
        });
    }
    /** @internal */ _setupConnectionHandlers() {
        this.socketAdapter.onOpen(()=>{
            const authPromise = this._authPromise || (this.accessToken && !this.accessTokenValue ? this.setAuth() : Promise.resolve());
            authPromise.catch((e)=>{
                this.log('error', 'error waiting for auth on connect', e);
            });
            if (this.worker && !this.workerRef) this._startWorkerHeartbeat();
        });
        this.socketAdapter.onClose(()=>{
            if (this.worker && this.workerRef) this._terminateWorker();
        });
        this.socketAdapter.onMessage((message)=>{
            if (message.ref && message.ref === this._pendingWorkerHeartbeatRef) this._pendingWorkerHeartbeatRef = null;
        });
    }
    /** @internal */ _handleNodeJsRaceCondition() {
        if (this.socketAdapter.isConnected()) // hack: ensure onConnOpen is called
        this.socketAdapter.getSocket().onConnOpen();
    }
    /** @internal */ _wrapHeartbeatCallback(heartbeatCallback) {
        return (status, latency)=>{
            if (status === 'disconnected') return;
            if (status == 'sent') this._setAuthSafely();
            if (heartbeatCallback) heartbeatCallback(status, latency);
        };
    }
    /** @internal */ _startWorkerHeartbeat() {
        if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
        else this.log('worker', `starting default worker`);
        const objectUrl = this._workerObjectUrl(this.workerUrl);
        this.workerRef = new Worker(objectUrl);
        this.workerRef.onerror = (error)=>{
            this.log('worker', 'worker error', error.message);
            this._terminateWorker();
            this.disconnect();
        };
        this.workerRef.onmessage = (event)=>{
            if (event.data.event === 'keepAlive') this.sendHeartbeat();
        };
        this.workerRef.postMessage({
            event: 'start',
            interval: this.heartbeatIntervalMs
        });
    }
    /**
     * Terminate the Web Worker and clear the reference
     * @internal
     */ _terminateWorker() {
        if (this.workerRef) {
            this.log('worker', 'terminating worker');
            this.workerRef.terminate();
            this.workerRef = undefined;
        }
    }
    /** @internal */ _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                $5bd7984a1e22c554$var$WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
    /**
     * Initialize socket options with defaults
     * @internal
     */ _initializeOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.worker = (_a = options === null || options === void 0 ? void 0 : options.worker) !== null && _a !== void 0 ? _a : false;
        this.accessToken = (_b = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _b !== void 0 ? _b : null;
        const result = {};
        result.timeout = (_c = options === null || options === void 0 ? void 0 : options.timeout) !== null && _c !== void 0 ? _c : (0, $5ssGf.DEFAULT_TIMEOUT);
        result.heartbeatIntervalMs = (_d = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _d !== void 0 ? _d : $5bd7984a1e22c554$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL;
        this._disconnectOnEmptyChannelsAfterMs = (_e = options === null || options === void 0 ? void 0 : options.disconnectOnEmptyChannelsAfterMs) !== null && _e !== void 0 ? _e : 2 * ((_f = options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) !== null && _f !== void 0 ? _f : $5bd7984a1e22c554$var$CONNECTION_TIMEOUTS.HEARTBEAT_INTERVAL);
        // @ts-ignore - mismatch between phoenix and supabase
        result.transport = (_g = options === null || options === void 0 ? void 0 : options.transport) !== null && _g !== void 0 ? _g : (0, $fkssd.default).getWebSocketConstructor();
        result.params = options === null || options === void 0 ? void 0 : options.params;
        result.logger = options === null || options === void 0 ? void 0 : options.logger;
        result.heartbeatCallback = this._wrapHeartbeatCallback(options === null || options === void 0 ? void 0 : options.heartbeatCallback);
        result.sessionStorage = (_h = options === null || options === void 0 ? void 0 : options.sessionStorage) !== null && _h !== void 0 ? _h : $5bd7984a1e22c554$var$resolveSessionStorage();
        result.reconnectAfterMs = (_j = options === null || options === void 0 ? void 0 : options.reconnectAfterMs) !== null && _j !== void 0 ? _j : (tries)=>{
            return $5bd7984a1e22c554$var$RECONNECT_INTERVALS[tries - 1] || $5bd7984a1e22c554$var$DEFAULT_RECONNECT_FALLBACK;
        };
        let defaultEncode;
        let defaultDecode;
        const vsn = (_k = options === null || options === void 0 ? void 0 : options.vsn) !== null && _k !== void 0 ? _k : (0, $5ssGf.DEFAULT_VSN);
        switch(vsn){
            case 0, $5ssGf.VSN_1_0_0:
                defaultEncode = (payload, callback)=>{
                    return callback(JSON.stringify(payload));
                };
                defaultDecode = (payload, callback)=>{
                    return callback(JSON.parse(payload));
                };
                break;
            case 0, $5ssGf.VSN_2_0_0:
                defaultEncode = this.serializer.encode.bind(this.serializer);
                defaultDecode = this.serializer.decode.bind(this.serializer);
                break;
            default:
                throw new Error(`Unsupported serializer version: ${result.vsn}`);
        }
        result.vsn = vsn;
        result.encode = (_l = options === null || options === void 0 ? void 0 : options.encode) !== null && _l !== void 0 ? _l : defaultEncode;
        result.decode = (_m = options === null || options === void 0 ? void 0 : options.decode) !== null && _m !== void 0 ? _m : defaultDecode;
        result.beforeReconnect = this._reconnectAuth.bind(this);
        if ((options === null || options === void 0 ? void 0 : options.logLevel) || (options === null || options === void 0 ? void 0 : options.log_level)) {
            this.logLevel = options.logLevel || options.log_level;
            result.params = Object.assign(Object.assign({}, result.params), {
                log_level: this.logLevel
            });
        }
        // Handle worker setup
        if (this.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
            result.autoSendHeartbeat = !this.worker;
        }
        return result;
    }
    /** @internal */ async _reconnectAuth() {
        await this._waitForAuthIfNeeded();
        if (!this.isConnected()) this.connect();
    }
}

});
parcelRegister("fkssd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28ecba9e50ac9ee$export$2e2bcd8739ae039);
/**
 * Utilities for creating WebSocket instances across runtimes.
 */ class $b28ecba9e50ac9ee$export$67be75336dea7fb5 {
    /**
     * Static-only utility – prevent instantiation.
     */ constructor(){}
    static detectEnvironment() {
        var _a;
        if (typeof WebSocket !== 'undefined') return {
            type: 'native',
            wsConstructor: WebSocket
        };
        const gt = globalThis;
        if (typeof globalThis !== 'undefined' && typeof gt.WebSocket !== 'undefined') return {
            type: 'native',
            wsConstructor: gt.WebSocket
        };
        const gl = typeof $parcel$global !== 'undefined' ? $parcel$global : undefined;
        if (gl && typeof gl.WebSocket !== 'undefined') return {
            type: 'native',
            wsConstructor: gl.WebSocket
        };
        if (typeof globalThis !== 'undefined' && typeof gt.WebSocketPair !== 'undefined' && typeof globalThis.WebSocket === 'undefined') return {
            type: 'cloudflare',
            error: 'Cloudflare Workers detected. WebSocket clients are not supported in Cloudflare Workers.',
            workaround: 'Use Cloudflare Workers WebSocket API for server-side WebSocket handling, or deploy to a different runtime.'
        };
        if (typeof globalThis !== 'undefined' && gt.EdgeRuntime || typeof navigator !== 'undefined' && ((_a = navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('Vercel-Edge'))) return {
            type: 'unsupported',
            error: 'Edge runtime detected (Vercel Edge/Netlify Edge). WebSockets are not supported in edge functions.',
            workaround: 'Use serverless functions or a different deployment target for WebSocket functionality.'
        };
        // Use dynamic property access to avoid Next.js Edge Runtime static analysis warnings
        const _process = globalThis['process'];
        if (_process) {
            const processVersions = _process['versions'];
            if (processVersions && processVersions['node']) // Reaching here means an earlier check did not find a native WebSocket,
            // so this Node.js process is missing the global WebSocket (Node.js 22+).
            return {
                type: 'unsupported',
                error: 'Node.js detected but native WebSocket not found.',
                workaround: 'Ensure you are running Node.js 22+ or provide a WebSocket implementation via the transport option.'
            };
        }
        return {
            type: 'unsupported',
            error: 'Unknown JavaScript runtime without WebSocket support.',
            workaround: "Ensure you're running in a supported environment (browser, Node.js, Deno) or provide a custom WebSocket implementation."
        };
    }
    /**
     * Returns the best available WebSocket constructor for the current runtime.
     *
     * @category Realtime
     *
     * @example Example with error handling
     * ```ts
     * try {
     *   const WS = WebSocketFactory.getWebSocketConstructor()
     *   const socket = new WS('wss://example.com/socket')
     * } catch (error) {
     *   console.error('WebSocket not available in this environment.', error)
     * }
     * ```
     */ static getWebSocketConstructor() {
        const env = this.detectEnvironment();
        if (env.wsConstructor) return env.wsConstructor;
        let errorMessage = env.error || 'WebSocket not supported in this environment.';
        if (env.workaround) errorMessage += `\n\nSuggested solution: ${env.workaround}`;
        throw new Error(errorMessage);
    }
    /**
     * Detects whether the runtime can establish WebSocket connections.
     *
     * @category Realtime
     *
     * @example Example in a Node.js script
     * ```ts
     * if (!WebSocketFactory.isWebSocketSupported()) {
     *   console.error('WebSockets are required for this script.')
     *   process.exitCode = 1
     * }
     * ```
     */ static isWebSocketSupported() {
        try {
            const env = this.detectEnvironment();
            return env.type === 'native';
        } catch (_a) {
            return false;
        }
    }
}
var $b28ecba9e50ac9ee$export$2e2bcd8739ae039 = $b28ecba9e50ac9ee$export$67be75336dea7fb5;

});

parcelRegister("5ssGf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VERSION", () => $3f95d0992638fdfb$export$363ebe89e6e7aeef);
$parcel$export(module.exports, "VSN_1_0_0", () => $3f95d0992638fdfb$export$b8f6d7e635d6c56b);
$parcel$export(module.exports, "VSN_2_0_0", () => $3f95d0992638fdfb$export$3f251ec2d5d5cd3a);
$parcel$export(module.exports, "DEFAULT_VSN", () => $3f95d0992638fdfb$export$90c89f9664aa9117);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $3f95d0992638fdfb$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "DEFAULT_POSTGRES_CHANGES_WAIT_TIMEOUT", () => $3f95d0992638fdfb$export$dd33e3c2e7ef7503);
$parcel$export(module.exports, "POSTGRES_CHANGES_WAIT_ERROR_GRACE", () => $3f95d0992638fdfb$export$5495e5335b7347b4);
$parcel$export(module.exports, "MAX_PUSH_BUFFER_SIZE", () => $3f95d0992638fdfb$export$f227fe8351a81f4a);
$parcel$export(module.exports, "CHANNEL_STATES", () => $3f95d0992638fdfb$export$b83816118db74fe7);
$parcel$export(module.exports, "CHANNEL_EVENTS", () => $3f95d0992638fdfb$export$8db7548e65d6ea55);
$parcel$export(module.exports, "CONNECTION_STATE", () => $3f95d0992638fdfb$export$deda39003d27273);

var $6F8aK = parcelRequire("6F8aK");
const $3f95d0992638fdfb$export$363ebe89e6e7aeef = `realtime-js/${(0, $6F8aK.version)}`;
const $3f95d0992638fdfb$export$b8f6d7e635d6c56b = '1.0.0';
const $3f95d0992638fdfb$export$3f251ec2d5d5cd3a = '2.0.0';
const $3f95d0992638fdfb$export$90c89f9664aa9117 = $3f95d0992638fdfb$export$3f251ec2d5d5cd3a;
const $3f95d0992638fdfb$export$a4ad2735b021c132 = (0, $6F8aK.version);
const $3f95d0992638fdfb$export$7bd623b29ec8e1eb = 10000;
const $3f95d0992638fdfb$export$dd33e3c2e7ef7503 = 15000;
const $3f95d0992638fdfb$export$5495e5335b7347b4 = 10000;
const $3f95d0992638fdfb$export$5e80cf62e56a877b = 1000;
const $3f95d0992638fdfb$export$f227fe8351a81f4a = 100;
const $3f95d0992638fdfb$export$a6d0320a1563d49e = {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
const $3f95d0992638fdfb$export$b83816118db74fe7 = {
    closed: 'closed',
    errored: 'errored',
    joined: 'joined',
    joining: 'joining',
    leaving: 'leaving'
};
const $3f95d0992638fdfb$export$8db7548e65d6ea55 = {
    close: 'phx_close',
    error: 'phx_error',
    join: 'phx_join',
    reply: 'phx_reply',
    leave: 'phx_leave',
    access_token: 'access_token'
};
const $3f95d0992638fdfb$export$b2688bfb999f5751 = {
    websocket: 'websocket'
};
const $3f95d0992638fdfb$export$deda39003d27273 = {
    connecting: 'connecting',
    open: 'open',
    closing: 'closing',
    closed: 'closed'
};

});
parcelRegister("6F8aK", function(module, exports) {

$parcel$export(module.exports, "version", () => $4d9ce9484dc75a77$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $4d9ce9484dc75a77$export$83d89fbfd8236492 = '2.118.0';

});


parcelRegister("i04Cg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1abcec19c59b3dd$export$2e2bcd8739ae039);
class $d1abcec19c59b3dd$export$2e2bcd8739ae039 {
    constructor(allowedMetadataKeys){
        this.HEADER_LENGTH = 1;
        this.USER_BROADCAST_PUSH_META_LENGTH = 6;
        this.KINDS = {
            userBroadcastPush: 3,
            userBroadcast: 4
        };
        this.BINARY_ENCODING = 0;
        this.JSON_ENCODING = 1;
        this.BROADCAST_EVENT = 'broadcast';
        this.allowedMetadataKeys = [];
        this.allowedMetadataKeys = allowedMetadataKeys !== null && allowedMetadataKeys !== void 0 ? allowedMetadataKeys : [];
    }
    encode(msg, callback) {
        if (msg.event === this.BROADCAST_EVENT && !(msg.payload instanceof ArrayBuffer) && typeof msg.payload.event === 'string') return callback(this._binaryEncodeUserBroadcastPush(msg));
        let payload = [
            msg.join_ref,
            msg.ref,
            msg.topic,
            msg.event,
            msg.payload
        ];
        return callback(JSON.stringify(payload));
    }
    _binaryEncodeUserBroadcastPush(message) {
        var _a;
        if (this._isArrayBuffer((_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload)) return this._encodeBinaryUserBroadcastPush(message);
        else return this._encodeJsonUserBroadcastPush(message);
    }
    _encodeBinaryUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : new ArrayBuffer(0);
        return this._encodeUserBroadcastPush(message, this.BINARY_ENCODING, userPayload);
    }
    _encodeJsonUserBroadcastPush(message) {
        var _a, _b;
        const userPayload = (_b = (_a = message.payload) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : {};
        const encoder = new TextEncoder();
        const encodedUserPayload = encoder.encode(JSON.stringify(userPayload)).buffer;
        return this._encodeUserBroadcastPush(message, this.JSON_ENCODING, encodedUserPayload);
    }
    _encodeUserBroadcastPush(message, encodingType, encodedPayload) {
        var _a, _b;
        // Encode each header field as UTF-8. The length prefixes are byte counts and
        // the decode side uses TextDecoder (UTF-8), so measuring with String.length
        // and writing with charCodeAt would corrupt any multi-byte character (e.g.
        // accents or emoji) and desynchronize the buffer.
        const encoder = new TextEncoder();
        const topic = encoder.encode(message.topic);
        const ref = encoder.encode((_a = message.ref) !== null && _a !== void 0 ? _a : '');
        const joinRef = encoder.encode((_b = message.join_ref) !== null && _b !== void 0 ? _b : '');
        const userEvent = encoder.encode(message.payload.event);
        // Filter metadata based on allowed keys
        const rest = this.allowedMetadataKeys ? this._pick(message.payload, this.allowedMetadataKeys) : {};
        const metadata = encoder.encode(Object.keys(rest).length === 0 ? '' : JSON.stringify(rest));
        // Validate byte lengths don't exceed uint8 max value (255)
        if (joinRef.length > 255) throw new Error(`joinRef length ${joinRef.length} exceeds maximum of 255`);
        if (ref.length > 255) throw new Error(`ref length ${ref.length} exceeds maximum of 255`);
        if (topic.length > 255) throw new Error(`topic length ${topic.length} exceeds maximum of 255`);
        if (userEvent.length > 255) throw new Error(`userEvent length ${userEvent.length} exceeds maximum of 255`);
        if (metadata.length > 255) throw new Error(`metadata length ${metadata.length} exceeds maximum of 255`);
        const metaLength = this.USER_BROADCAST_PUSH_META_LENGTH + joinRef.length + ref.length + topic.length + userEvent.length + metadata.length;
        const header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        const view = new DataView(header);
        const bytes = new Uint8Array(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.userBroadcastPush); // kind
        view.setUint8(offset++, joinRef.length);
        view.setUint8(offset++, ref.length);
        view.setUint8(offset++, topic.length);
        view.setUint8(offset++, userEvent.length);
        view.setUint8(offset++, metadata.length);
        view.setUint8(offset++, encodingType);
        bytes.set(joinRef, offset);
        offset += joinRef.length;
        bytes.set(ref, offset);
        offset += ref.length;
        bytes.set(topic, offset);
        offset += topic.length;
        bytes.set(userEvent, offset);
        offset += userEvent.length;
        bytes.set(metadata, offset);
        offset += metadata.length;
        var combined = new Uint8Array(header.byteLength + encodedPayload.byteLength);
        combined.set(new Uint8Array(header), 0);
        combined.set(new Uint8Array(encodedPayload), header.byteLength);
        return combined.buffer;
    }
    decode(rawPayload, callback) {
        if (this._isArrayBuffer(rawPayload)) {
            let result = this._binaryDecode(rawPayload);
            return callback(result);
        }
        if (typeof rawPayload === 'string') {
            const jsonPayload = JSON.parse(rawPayload);
            const [join_ref, ref, topic, event, payload] = jsonPayload;
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const kind = view.getUint8(0);
        const decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.userBroadcast:
                return this._decodeUserBroadcast(buffer, view, decoder);
        }
    }
    _decodeUserBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const userEventSize = view.getUint8(2);
        const metadataSize = view.getUint8(3);
        const payloadEncoding = view.getUint8(4);
        let offset = this.HEADER_LENGTH + 4;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const userEvent = decoder.decode(buffer.slice(offset, offset + userEventSize));
        offset = offset + userEventSize;
        const metadata = decoder.decode(buffer.slice(offset, offset + metadataSize));
        offset = offset + metadataSize;
        const payload = buffer.slice(offset, buffer.byteLength);
        const parsedPayload = payloadEncoding === this.JSON_ENCODING ? JSON.parse(decoder.decode(payload)) : payload;
        const data = {
            type: this.BROADCAST_EVENT,
            event: userEvent,
            payload: parsedPayload
        };
        // Metadata is optional and always JSON encoded
        if (metadataSize > 0) data['meta'] = JSON.parse(metadata);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: this.BROADCAST_EVENT,
            payload: data
        };
    }
    _isArrayBuffer(buffer) {
        var _a;
        return buffer instanceof ArrayBuffer || ((_a = buffer === null || buffer === void 0 ? void 0 : buffer.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'ArrayBuffer';
    }
    _pick(obj, keys) {
        if (!obj || typeof obj !== 'object') return {};
        return Object.fromEntries(Object.entries(obj).filter(([key])=>keys.includes(key)));
    }
}

});

parcelRegister("abdzW", function(module, exports) {

$parcel$export(module.exports, "convertChangeData", () => $769576e3a5a4e398$export$20ce708a1f594c5e);
$parcel$export(module.exports, "httpEndpointURL", () => $769576e3a5a4e398$export$976fda7151b30cae);
/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $769576e3a5a4e398$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($769576e3a5a4e398$export$4d213a7d364021dc || ($769576e3a5a4e398$export$4d213a7d364021dc = {}));
const $769576e3a5a4e398$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    if (!record) return {};
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $769576e3a5a4e398$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $769576e3a5a4e398$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $769576e3a5a4e398$export$3df02a362b86a91(colType, value);
    return $769576e3a5a4e398$var$noop(value);
};
const $769576e3a5a4e398$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return $769576e3a5a4e398$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $769576e3a5a4e398$export$4d213a7d364021dc.bool:
            return $769576e3a5a4e398$export$3c2e6d1b7583eee6(value);
        case $769576e3a5a4e398$export$4d213a7d364021dc.float4:
        case $769576e3a5a4e398$export$4d213a7d364021dc.float8:
        case $769576e3a5a4e398$export$4d213a7d364021dc.int2:
        case $769576e3a5a4e398$export$4d213a7d364021dc.int4:
        case $769576e3a5a4e398$export$4d213a7d364021dc.int8:
        case $769576e3a5a4e398$export$4d213a7d364021dc.numeric:
        case $769576e3a5a4e398$export$4d213a7d364021dc.oid:
            return $769576e3a5a4e398$export$a0a81dc3380ce7d3(value);
        case $769576e3a5a4e398$export$4d213a7d364021dc.json:
        case $769576e3a5a4e398$export$4d213a7d364021dc.jsonb:
            return $769576e3a5a4e398$export$d5b7a8bf56ee1fe2(value);
        case $769576e3a5a4e398$export$4d213a7d364021dc.timestamp:
            return $769576e3a5a4e398$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $769576e3a5a4e398$export$4d213a7d364021dc.abstime:
        case $769576e3a5a4e398$export$4d213a7d364021dc.date:
        case $769576e3a5a4e398$export$4d213a7d364021dc.daterange:
        case $769576e3a5a4e398$export$4d213a7d364021dc.int4range:
        case $769576e3a5a4e398$export$4d213a7d364021dc.int8range:
        case $769576e3a5a4e398$export$4d213a7d364021dc.money:
        case $769576e3a5a4e398$export$4d213a7d364021dc.reltime:
        case $769576e3a5a4e398$export$4d213a7d364021dc.text:
        case $769576e3a5a4e398$export$4d213a7d364021dc.time:
        case $769576e3a5a4e398$export$4d213a7d364021dc.timestamptz:
        case $769576e3a5a4e398$export$4d213a7d364021dc.timetz:
        case $769576e3a5a4e398$export$4d213a7d364021dc.tsrange:
        case $769576e3a5a4e398$export$4d213a7d364021dc.tstzrange:
            return $769576e3a5a4e398$var$noop(value);
        default:
            // Return the value for remaining types
            return $769576e3a5a4e398$var$noop(value);
    }
};
const $769576e3a5a4e398$var$noop = (value)=>{
    return value;
};
const $769576e3a5a4e398$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const $769576e3a5a4e398$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $769576e3a5a4e398$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
    return value;
};
const $769576e3a5a4e398$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>$769576e3a5a4e398$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $769576e3a5a4e398$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const $769576e3a5a4e398$export$976fda7151b30cae = (socketUrl)=>{
    const wsUrl = new URL(socketUrl);
    wsUrl.protocol = wsUrl.protocol.replace(/^ws/i, 'http');
    wsUrl.pathname = wsUrl.pathname.replace(/\/+$/, '') // remove all trailing slashes
    .replace(/\/socket\/websocket$/i, '') // remove the socket/websocket path
    .replace(/\/socket$/i, '') // remove the socket path
    .replace(/\/websocket$/i, ''); // remove the websocket path
    if (wsUrl.pathname === '' || wsUrl.pathname === '/') wsUrl.pathname = '/api/broadcast';
    else wsUrl.pathname = wsUrl.pathname + '/api/broadcast';
    return wsUrl.href;
};

});

parcelRegister("3FKfU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ac914d13d1b8dc7$export$2e2bcd8739ae039);

var $5ssGf = parcelRequire("5ssGf");

var $eIXMJ = parcelRequire("eIXMJ");

var $abdzW = parcelRequire("abdzW");

var $iLaxa = parcelRequire("iLaxa");

var $jcoZi = parcelRequire("jcoZi");

var $843pN = parcelRequire("843pN");
var $2ac914d13d1b8dc7$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($2ac914d13d1b8dc7$export$bc171c571098b6c4 || ($2ac914d13d1b8dc7$export$bc171c571098b6c4 = {}));
var $2ac914d13d1b8dc7$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($2ac914d13d1b8dc7$export$9e3fe8e487ef792e || ($2ac914d13d1b8dc7$export$9e3fe8e487ef792e = {}));
var $2ac914d13d1b8dc7$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($2ac914d13d1b8dc7$export$a6885b926af646a2 || ($2ac914d13d1b8dc7$export$a6885b926af646a2 = {}));
const $2ac914d13d1b8dc7$export$154db638d9c0559e = (0, $5ssGf.CHANNEL_STATES);
class $2ac914d13d1b8dc7$export$2e2bcd8739ae039 {
    get state() {
        return this.channelAdapter.state;
    }
    set state(state) {
        this.channelAdapter.state = state;
    }
    get joinedOnce() {
        return this.channelAdapter.joinedOnce;
    }
    get timeout() {
        return this.socket.timeout;
    }
    get joinPush() {
        return this.channelAdapter.joinPush;
    }
    get rejoinTimer() {
        return this.channelAdapter.rejoinTimer;
    }
    /**
     * Creates a channel that can broadcast messages, sync presence, and listen to Postgres changes.
     *
     * The topic determines which realtime stream you are subscribing to. Config options let you
     * enable acknowledgement for broadcasts, presence tracking, or private channels.
     *
     * @category Realtime
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const channel = supabase.channel('room1')
     * channel
     *   .on('broadcast', { event: 'cursor-pos' }, (payload) => console.log(payload))
     *   .subscribe()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import RealtimeClient from '@supabase/realtime-js'
     *
     * const client = new RealtimeClient('https://xyzcompany.supabase.co/realtime/v1', {
     *   params: { apikey: 'your-publishable-key' },
     * })
     * const channel = new RealtimeChannel('realtime:public:messages', { config: {} }, client)
     * ```
     */ constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        var _a, _b;
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, params.config);
        this.channelAdapter = new (0, $jcoZi.default)(this.socket.socketAdapter, topic, this.params);
        this.presence = new (0, $eIXMJ.default)(this);
        this._onClose(()=>{
            this.socket._remove(this);
        });
        this._updateFilterTransform();
        this.broadcastEndpointURL = (0, $abdzW.httpEndpointURL)(this.socket.socketAdapter.endPointURL());
        this.private = this.params.config.private || false;
        if (!this.private && ((_b = (_a = this.params.config) === null || _a === void 0 ? void 0 : _a.broadcast) === null || _b === void 0 ? void 0 : _b.replay)) throw new Error(`tried to use replay on public channel '${this.topic}'. It must be a private channel.`);
    }
    /**
     * Subscribe registers your client with the server.
     *
     * The optional `callback` receives a `status` and, on failure, an `err` argument.
     * Log the full `err` so its `cause`, `name`, and any structured fields aren't hidden
     * behind `err.message`.
     *
     * @category Realtime
     *
     * @example Handling errors
     * ```js
     * supabase.channel('room1').subscribe((status, err) => {
     *   if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
     *     // Log the full error: its `cause` often holds the underlying reason.
     *     console.error(status, err)
     *   }
     * })
     * ```
     */ subscribe(callback, timeout = this.timeout) {
        var _a, _b, _c, _d;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.channelAdapter.isClosed()) {
            const { config: { broadcast: broadcast, presence: presence, private: isPrivate, postgres_changes_options: postgres_changes_options } } = this.params;
            const postgres_changes = (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [];
            const presence_enabled = !!this.bindings[$2ac914d13d1b8dc7$export$9e3fe8e487ef792e.PRESENCE] && this.bindings[$2ac914d13d1b8dc7$export$9e3fe8e487ef792e.PRESENCE].length > 0 || ((_c = this.params.config.presence) === null || _c === void 0 ? void 0 : _c.enabled) === true;
            const accessTokenPayload = {};
            const config = Object.assign({
                broadcast: broadcast,
                presence: Object.assign(Object.assign({}, presence), {
                    enabled: presence_enabled
                }),
                postgres_changes: postgres_changes,
                private: isPrivate
            }, postgres_changes_options ? {
                postgres_changes_options: postgres_changes_options
            } : {});
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this._onError((reason)=>{
                callback === null || callback === void 0 || callback($2ac914d13d1b8dc7$export$a6885b926af646a2.CHANNEL_ERROR, (0, $iLaxa.normalizeChannelError)(reason));
            });
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback($2ac914d13d1b8dc7$export$a6885b926af646a2.CLOSED));
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this._updateFilterMessage();
            const joinTimeout = (postgres_changes_options === null || postgres_changes_options === void 0 ? void 0 : postgres_changes_options.wait) && postgres_changes.length > 0 ? Math.max(timeout, ((_d = postgres_changes_options.timeout) !== null && _d !== void 0 ? _d : (0, $5ssGf.DEFAULT_POSTGRES_CHANGES_WAIT_TIMEOUT)) + (0, $5ssGf.POSTGRES_CHANGES_WAIT_ERROR_GRACE)) : timeout;
            this.channelAdapter.subscribe(joinTimeout).receive('ok', async ({ postgres_changes: postgres_changes })=>{
                // Only refresh auth if using callback-based tokens
                if (!this.socket._isManualToken()) this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback($2ac914d13d1b8dc7$export$a6885b926af646a2.SUBSCRIBED);
                    return;
                }
                this._updatePostgresBindings(postgres_changes, callback);
            }).receive('error', (error)=>{
                this.state = (0, $5ssGf.CHANNEL_STATES).errored;
                const message = Object.values(error).join(', ') || 'error';
                callback === null || callback === void 0 || callback($2ac914d13d1b8dc7$export$a6885b926af646a2.CHANNEL_ERROR, new Error(message, {
                    cause: error
                }));
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback($2ac914d13d1b8dc7$export$a6885b926af646a2.TIMED_OUT);
            });
        }
        return this;
    }
    _updatePostgresBindings(postgres_changes, callback) {
        var _a;
        const clientPostgresBindings = this.bindings.postgres_changes;
        const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
        const newPostgresBindings = [];
        for(let i = 0; i < bindingsLen; i++){
            const clientPostgresBinding = clientPostgresBindings[i];
            const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
            const serverPostgresFilter = postgres_changes && postgres_changes[i];
            if (serverPostgresFilter && serverPostgresFilter.event === event && $2ac914d13d1b8dc7$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.schema, schema) && $2ac914d13d1b8dc7$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.table, table) && $2ac914d13d1b8dc7$export$2e2bcd8739ae039.isFilterValueEqual(serverPostgresFilter.filter, filter)) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                id: serverPostgresFilter.id
            }));
            else {
                this.unsubscribe();
                this.state = (0, $5ssGf.CHANNEL_STATES).errored;
                callback === null || callback === void 0 || callback($2ac914d13d1b8dc7$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                return;
            }
        }
        this.bindings.postgres_changes = newPostgresBindings;
        if (this.state != (0, $5ssGf.CHANNEL_STATES).errored && callback) callback($2ac914d13d1b8dc7$export$a6885b926af646a2.SUBSCRIBED);
    }
    /**
     * Returns the current presence state for this channel.
     *
     * The shape is a map keyed by presence key (for example a user id) where each entry contains the
     * tracked metadata for that user.
     *
     * @category Realtime
     */ presenceState() {
        return this.presence.state;
    }
    /**
     * Sends the supplied payload to the presence tracker so other subscribers can see that this
     * client is online. Use `untrack` to stop broadcasting presence for the same key.
     *
     * Tracking makes this client visible to other subscribers immediately, regardless of this
     * channel's `config.presence.enabled` setting or whether it has a `presence` listener — that
     * flag only affects whether *this* client receives presence updates from others (and, on
     * RLS-protected channels, whether it's authorized to do so).
     *
     * @category Realtime
     */ async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload: payload
        }, opts);
    }
    /**
     * Removes the current presence state for this client.
     *
     * @category Realtime
     */ async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    /**
     * Listen to realtime events on this channel.
     * @category Realtime
     *
     * @remarks
     * - By default, Broadcast and Presence are enabled for all projects.
     * - By default, listening to database changes is disabled for new projects due to database performance and security concerns. You can turn it on by managing Realtime's [replication](/docs/guides/api#realtime-api-overview).
     * - You can receive the "previous" data for updates and deletes by setting the table's `REPLICA IDENTITY` to `FULL` (e.g., `ALTER TABLE your_table REPLICA IDENTITY FULL;`).
     * - Row level security is not applied to delete statements. When RLS is enabled and replica identity is set to full, only the primary key is sent to clients.
     *
     * @example Listen to broadcast messages
     * ```js
     * const channel = supabase.channel("room1")
     *
     * channel.on("broadcast", { event: "cursor-pos" }, (payload) => {
     *   console.log("Cursor position received!", payload);
     * }).subscribe((status) => {
     *   if (status === "SUBSCRIBED") {
     *     channel.send({
     *       type: "broadcast",
     *       event: "cursor-pos",
     *       payload: { x: Math.random(), y: Math.random() },
     *     });
     *   }
     * });
     * ```
     *
     * @example Listen to presence sync
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'sync' }, () => {
     *     console.log('Synced presence state: ', channel.presenceState())
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence join
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'join' }, ({ newPresences }) => {
     *     console.log('Newly joined presences: ', newPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *     }
     *   })
     * ```
     *
     * @example Listen to presence leave
     * ```js
     * const channel = supabase.channel('room1')
     * channel
     *   .on('presence', { event: 'leave' }, ({ leftPresences }) => {
     *     console.log('Newly left presences: ', leftPresences)
     *   })
     *   .subscribe(async (status) => {
     *     if (status === 'SUBSCRIBED') {
     *       await channel.track({ online_at: new Date().toISOString() })
     *       await channel.untrack()
     *     }
     *   })
     * ```
     *
     * Registering the same `postgres_changes` filter more than once on a channel is a no-op: the
     * duplicate is ignored and an error is logged, since the server only ever creates one
     * subscription per distinct filter.
     *
     * @example Listen to all database changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: '*' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to a specific table
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: '*', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @example Listen to inserts
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to updates
     * By default, Supabase will send only the updated record. If you want to receive the previous values as well you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to updates
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to deletes
     * By default, Supabase does not send deleted records. If you want to receive the deleted record you can
     * enable full replication for the table you are listening to:
     *
     * ```sql
     * alter table "your_table" replica identity full;
     * ```
     *
     * @example Listen to deletes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, payload => {
     *     console.log('Change received!', payload)
     *   })
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to multiple events
     * You can chain listeners if you want to listen to multiple events for each table.
     *
     * @example Listen to multiple events
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'countries' }, handleRecordInserted)
     *   .on('postgres_changes', { event: 'DELETE', schema: 'public', table: 'countries' }, handleRecordDeleted)
     *   .subscribe()
     * ```
     *
     * @exampleDescription Listen to row level changes
     * You can listen to individual rows using the format `{table}:{col}=eq.{val}` - where `{col}` is the column name, and `{val}` is the value which you want to match.
     *
     * @example Listen to row level changes
     * ```js
     * supabase
     *   .channel('room1')
     *   .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'countries', filter: 'id=eq.200' }, handleRecordUpdated)
     *   .subscribe()
     * ```
     */ on(type, filter, callback) {
        const stateCheck = this.channelAdapter.isJoined() || this.channelAdapter.isJoining();
        const typeCheck = type === $2ac914d13d1b8dc7$export$9e3fe8e487ef792e.PRESENCE || type === $2ac914d13d1b8dc7$export$9e3fe8e487ef792e.POSTGRES_CHANGES;
        if (stateCheck && typeCheck) {
            this.socket.log('channel', `cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
            throw new Error(`cannot add \`${type}\` callbacks for ${this.topic} after \`subscribe()\`.`);
        }
        return this._on(type, filter, callback);
    }
    /**
     * Sends a broadcast message explicitly via REST API.
     *
     * This method always uses the REST API endpoint regardless of WebSocket connection state.
     * Useful when you want to guarantee REST delivery or when gradually migrating from implicit REST fallback.
     *
     * Payloads that are `ArrayBuffer` or `ArrayBufferView` (e.g. `Uint8Array`) are sent as
     * `application/octet-stream`; all other payloads are JSON-encoded.
     *
     * @param event The name of the broadcast event
     * @param payload Payload to be sent (required)
     * @param opts Options including timeout
     * @returns Promise resolving to object with success status, and error details if failed
     *
     * @category Realtime
     */ async httpSend(event, payload, opts = {}) {
        var _a;
        if (payload === undefined || payload === null) return Promise.reject(new Error('Payload is required for httpSend()'));
        const isBinary = payload instanceof ArrayBuffer || ArrayBuffer.isView(payload);
        const headers = {
            apikey: this.socket.apiKey ? this.socket.apiKey : '',
            'Content-Type': isBinary ? 'application/octet-stream' : 'application/json'
        };
        if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
        const url = new URL(this.broadcastEndpointURL);
        url.pathname += `/${encodeURIComponent(this.subTopic)}/events/${encodeURIComponent(event)}`;
        if (this.private) url.searchParams.set('private', 'true');
        const options = {
            method: 'POST',
            headers: headers,
            body: isBinary ? payload : JSON.stringify(payload)
        };
        const response = await this._fetchWithTimeout(url.toString(), options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
        if (response.status === 202) return {
            success: true
        };
        if (response.status === 404) return Promise.reject(new Error("httpSend() requires Realtime server v2.97.0 or newer; the endpoint returned 404. Update your Supabase CLI to a recent version, or upgrade the Realtime server in your self-hosted setup. See https://github.com/supabase/supabase-js/blob/master/packages/core/realtime-js/migrations/httpsend-server-version.md"));
        let errorMessage = response.statusText;
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.error || errorBody.message || errorMessage;
        } catch (_b) {}
        return Promise.reject(new Error(errorMessage));
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     *
     * @category Realtime
     *
     * @remarks
     * - When using REST you don't need to subscribe to the channel
     * - REST calls are only available from 2.37.0 onwards
     * - If you create a channel only to send a REST broadcast, remove it from
     *   the client when the send completes
     *
     * @example Send a message via websocket
     * ```js
     * const channel = supabase.channel('room1')
     *
     * channel.subscribe((status) => {
     *   if (status === 'SUBSCRIBED') {
     *     channel.send({
     *       type: 'broadcast',
     *       event: 'cursor-pos',
     *       payload: { x: Math.random(), y: Math.random() },
     *     })
     *   }
     * })
     * ```
     *
     * @exampleResponse Send a message via websocket
     * ```js
     * ok | timed out | error
     * ```
     *
     * @example Send a message via REST
     * ```js
     * const channel = supabase.channel('room1')
     *
     * try {
     *   await channel.httpSend('cursor-pos', { x: Math.random(), y: Math.random() })
     * } finally {
     *   await supabase.removeChannel(channel)
     * }
     * ```
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this.channelAdapter.canPush() && args.type === 'broadcast') {
            const fallbackWarning = "Realtime send() is automatically falling back to REST API. This behavior will be deprecated in the future. Please use httpSend() explicitly for REST delivery.";
            if (this.socket.hasLogger()) this.socket.log('channel', fallbackWarning);
            else console.warn(fallbackWarning);
            const { event: event, payload: endpoint_payload } = args;
            const headers = {
                apikey: this.socket.apiKey ? this.socket.apiKey : '',
                'Content-Type': 'application/json'
            };
            if (this.socket.accessTokenValue) headers['Authorization'] = `Bearer ${this.socket.accessTokenValue}`;
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error instanceof Error && error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this.channelAdapter.push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    /**
     * Updates the payload that will be sent the next time the channel joins (reconnects).
     * Useful for rotating access tokens or updating config without re-creating the channel.
     *
     * @category Realtime
     */ updateJoinPayload(payload) {
        this.channelAdapter.updateJoinPayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     *
     * @category Realtime
     */ async unsubscribe(timeout = this.timeout) {
        return new Promise((resolve)=>{
            this.channelAdapter.unsubscribe(timeout).receive('ok', ()=>resolve('ok')).receive('timeout', ()=>resolve('timed out')).receive('error', ()=>resolve('error'));
        });
    }
    /**
     * Destroys and stops related timers.
     *
     * @category Realtime
     */ teardown() {
        this.channelAdapter.teardown();
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _on(type, filter, callback) {
        var _a;
        const typeLower = type.toLocaleLowerCase();
        // Serialize a postgres_changes filter builder into its string form so the
        // rest of the pipeline (join payload, server binding match) sees a string.
        // Duck-type `build()` in addition to `instanceof` so a builder constructed
        // against a duplicate copy of the package (separate module realm) still works.
        const filterValue = filter === null || filter === void 0 ? void 0 : filter.filter;
        if (filterValue instanceof (0, $843pN.RealtimePostgresFilterBuilder) || typeof filterValue === 'object' && filterValue !== null && typeof filterValue.build === 'function') filter = Object.assign(Object.assign({}, filter), {
            filter: filterValue.build()
        });
        // The server collapses identical postgres_changes filters, so keeping a duplicate here would
        // desync the client and server binding lists and make `subscribe()` fail with a mismatch.
        if (typeLower === $2ac914d13d1b8dc7$export$9e3fe8e487ef792e.POSTGRES_CHANGES) {
            const duplicate = (_a = this.bindings[typeLower]) === null || _a === void 0 ? void 0 : _a.find((bind)=>$2ac914d13d1b8dc7$export$2e2bcd8739ae039.isSamePostgresFilter(bind.filter, filter));
            if (duplicate) {
                this.socket.log('error', `duplicate \`postgres_changes\` binding for ${this.topic} ignored`, filter);
                return this;
            }
        }
        const ref = this.channelAdapter.on(type, callback);
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback,
            ref: ref
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        this._updateFilterMessage();
        return this;
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this.channelAdapter.onClose(callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this.channelAdapter.onError(callback);
    }
    /** @internal */ _updateFilterMessage() {
        this.channelAdapter.updateFilterBindings((binding, payload, ref)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            const typeLower = binding.event.toLocaleLowerCase();
            if (this._notThisChannelEvent(typeLower, ref)) return false;
            const bind = (_a = this.bindings[typeLower]) === null || _a === void 0 ? void 0 : _a.find((bind)=>bind.ref === binding.ref);
            if (!bind) return true;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event;
                    return bindId && ((_c = payload.ids) === null || _c === void 0 ? void 0 : _c.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_d = payload.data) === null || _d === void 0 ? void 0 : _d.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_f = (_e = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _e === void 0 ? void 0 : _e.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_g = payload === null || payload === void 0 ? void 0 : payload.event) === null || _g === void 0 ? void 0 : _g.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        });
    }
    /** @internal */ _notThisChannelEvent(event, ref) {
        const { close: close, error: error, leave: leave, join: join } = (0, $5ssGf.CHANNEL_EVENTS);
        const events = [
            close,
            error,
            leave,
            join
        ];
        return ref && events.includes(event) && ref !== this.joinPush.ref;
    }
    /** @internal */ _updateFilterTransform() {
        this.channelAdapter.updatePayloadTransform((event, payload, ref)=>{
            if (typeof payload === 'object' && 'ids' in payload) {
                const postgresChanges = payload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                return Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            return payload;
        });
    }
    copyBindings(other) {
        if (this.joinedOnce) throw new Error('cannot copy bindings into joined channel');
        for(const kind in other.bindings)for (const binding of other.bindings[kind])this._on(binding.type, binding.filter, binding.callback);
    }
    /**
     * Compares two optional filter values for equality.
     * Treats undefined, null, and empty string as equivalent empty values.
     * @internal
     */ static isFilterValueEqual(serverValue, clientValue) {
        const normalizedServer = serverValue !== null && serverValue !== void 0 ? serverValue : undefined;
        const normalizedClient = clientValue !== null && clientValue !== void 0 ? clientValue : undefined;
        return normalizedServer === normalizedClient;
    }
    /**
     * Two `postgres_changes` filters are the same when the server would collapse them into a single
     * subscription.
     * @internal
     */ static isSamePostgresFilter(a, b) {
        var _a, _b, _c, _d;
        const selectA = (_b = (_a = a === null || a === void 0 ? void 0 : a.select) === null || _a === void 0 ? void 0 : _a.join()) !== null && _b !== void 0 ? _b : undefined;
        const selectB = (_d = (_c = b === null || b === void 0 ? void 0 : b.select) === null || _c === void 0 ? void 0 : _c.join()) !== null && _d !== void 0 ? _d : undefined;
        return (a === null || a === void 0 ? void 0 : a.event) === (b === null || b === void 0 ? void 0 : b.event) && $2ac914d13d1b8dc7$export$2e2bcd8739ae039.isFilterValueEqual(a === null || a === void 0 ? void 0 : a.schema, b === null || b === void 0 ? void 0 : b.schema) && $2ac914d13d1b8dc7$export$2e2bcd8739ae039.isFilterValueEqual(a === null || a === void 0 ? void 0 : a.table, b === null || b === void 0 ? void 0 : b.table) && $2ac914d13d1b8dc7$export$2e2bcd8739ae039.isFilterValueEqual(a === null || a === void 0 ? void 0 : a.filter, b === null || b === void 0 ? void 0 : b.filter) && selectA === selectB;
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = $abdzW.convertChangeData(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $abdzW.convertChangeData(payload.columns, payload.old_record);
        return records;
    }
}

});
parcelRegister("eIXMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab838cca676d3975$export$2e2bcd8739ae039);
/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ 
var $4xnno = parcelRequire("4xnno");
var $ab838cca676d3975$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($ab838cca676d3975$export$f1ce049df2794fb4 || ($ab838cca676d3975$export$f1ce049df2794fb4 = {}));
class $ab838cca676d3975$export$2e2bcd8739ae039 {
    get state() {
        return this.presenceAdapter.state;
    }
    /**
     * Creates a Presence helper that keeps the local presence state in sync with the server.
     *
     * @param channel - The realtime channel to bind to.
     * @param opts - Optional custom event names, e.g. `{ events: { state: 'state', diff: 'diff' } }`.
     *
     * @category Realtime
     *
     * @example Example for a presence channel
     * ```ts
     * const presence = new RealtimePresence(channel)
     *
     * channel.on('presence', ({ event, key }) => {
     *   console.log(`Presence ${event} on ${key}`)
     * })
     * ```
     */ constructor(channel, opts){
        this.channel = channel;
        this.presenceAdapter = new (0, $4xnno.default)(this.channel.channelAdapter, opts);
    }
}

});
parcelRegister("4xnno", function(module, exports) {

$parcel$export(module.exports, "default", () => $34dc608bc29d4ee1$export$2e2bcd8739ae039);

var $bg1V2 = parcelRequire("bg1V2");
class $34dc608bc29d4ee1$export$2e2bcd8739ae039 {
    constructor(channel, opts){
        const phoenixOptions = $34dc608bc29d4ee1$var$phoenixPresenceOptions(opts);
        this.presence = new (0, $bg1V2.Presence)(channel.getChannel(), phoenixOptions);
        this.presence.onJoin((key, currentPresence, newPresence)=>{
            const onJoinPayload = $34dc608bc29d4ee1$export$2e2bcd8739ae039.onJoinPayload(key, currentPresence, newPresence);
            channel.getChannel().trigger('presence', onJoinPayload);
        });
        this.presence.onLeave((key, currentPresence, leftPresence)=>{
            const onLeavePayload = $34dc608bc29d4ee1$export$2e2bcd8739ae039.onLeavePayload(key, currentPresence, leftPresence);
            channel.getChannel().trigger('presence', onLeavePayload);
        });
        this.presence.onSync(()=>{
            channel.getChannel().trigger('presence', {
                event: 'sync'
            });
        });
    }
    get state() {
        return $34dc608bc29d4ee1$export$2e2bcd8739ae039.transformState(this.presence.state);
    }
    /**
     * @private
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example Transform state
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     */ static transformState(state) {
        state = $34dc608bc29d4ee1$var$cloneState(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            newState[key] = $34dc608bc29d4ee1$var$transformState(presences);
            return newState;
        }, {});
    }
    static onJoinPayload(key, currentPresence, newPresence) {
        const currentPresences = $34dc608bc29d4ee1$var$parseCurrentPresences(currentPresence);
        const newPresences = $34dc608bc29d4ee1$var$transformState(newPresence);
        return {
            event: 'join',
            key: key,
            currentPresences: currentPresences,
            newPresences: newPresences
        };
    }
    static onLeavePayload(key, currentPresence, leftPresence) {
        const currentPresences = $34dc608bc29d4ee1$var$parseCurrentPresences(currentPresence);
        const leftPresences = $34dc608bc29d4ee1$var$transformState(leftPresence);
        return {
            event: 'leave',
            key: key,
            currentPresences: currentPresences,
            leftPresences: leftPresences
        };
    }
}
function $34dc608bc29d4ee1$var$transformState(presences) {
    return presences.metas.map((presence)=>{
        // Object spread compiles to Object.assign for ES2017, which treats __proto__ as a setter.
        const descriptors = Object.getOwnPropertyDescriptors(presence);
        const transformedPresence = Object.defineProperties({}, descriptors);
        transformedPresence['presence_ref'] = transformedPresence['phx_ref'];
        delete transformedPresence['phx_ref'];
        delete transformedPresence['phx_ref_prev'];
        return transformedPresence;
    });
}
function $34dc608bc29d4ee1$var$cloneState(state) {
    return JSON.parse(JSON.stringify(state));
}
function $34dc608bc29d4ee1$var$phoenixPresenceOptions(opts) {
    return (opts === null || opts === void 0 ? void 0 : opts.events) && {
        events: opts.events
    };
}
function $34dc608bc29d4ee1$var$parseCurrentPresences(currentPresences) {
    return (currentPresences === null || currentPresences === void 0 ? void 0 : currentPresences.metas) ? $34dc608bc29d4ee1$var$transformState(currentPresences) : [];
}

});
parcelRegister("bg1V2", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $f25c0b408bfd3e36$export$99c2b779aa4e8b8b);
$parcel$export(module.exports, "Socket", () => $f25c0b408bfd3e36$export$4798917dbf149b79);
// js/phoenix/utils.js
var $f25c0b408bfd3e36$var$closure = (value)=>{
    if (typeof value === "function") return /** @type {() => T} */ value;
    else {
        let closure2 = function() {
            return value;
        };
        return closure2;
    }
};
// js/phoenix/constants.js
var $f25c0b408bfd3e36$var$globalSelf = typeof self !== "undefined" ? self : null;
var $f25c0b408bfd3e36$var$phxWindow = typeof window !== "undefined" ? window : null;
var $f25c0b408bfd3e36$var$global = $f25c0b408bfd3e36$var$globalSelf || $f25c0b408bfd3e36$var$phxWindow || globalThis;
var $f25c0b408bfd3e36$var$DEFAULT_VSN = "2.0.0";
var $f25c0b408bfd3e36$var$DEFAULT_TIMEOUT = 1e4;
var $f25c0b408bfd3e36$var$WS_CLOSE_NORMAL = 1e3;
var $f25c0b408bfd3e36$var$MAX_LONGPOLL_BATCH_SIZE = 100;
var $f25c0b408bfd3e36$var$SOCKET_STATES = /** @type {const} */ {
    connecting: 0,
    open: 1,
    closing: 2,
    closed: 3
};
var $f25c0b408bfd3e36$var$CHANNEL_STATES = /** @type {const} */ {
    closed: "closed",
    errored: "errored",
    joined: "joined",
    joining: "joining",
    leaving: "leaving"
};
var $f25c0b408bfd3e36$var$CHANNEL_EVENTS = /** @type {const} */ {
    close: "phx_close",
    error: "phx_error",
    join: "phx_join",
    reply: "phx_reply",
    leave: "phx_leave"
};
var $f25c0b408bfd3e36$var$TRANSPORTS = /** @type {const} */ {
    longpoll: "longpoll",
    websocket: "websocket"
};
var $f25c0b408bfd3e36$var$XHR_STATES = /** @type {const} */ {
    complete: 4
};
var $f25c0b408bfd3e36$var$AUTH_TOKEN_PREFIX = "base64url.bearer.phx.";
// js/phoenix/push.js
var $f25c0b408bfd3e36$export$fb87db22c6b0e2ba = class {
    /**
   * Initializes the Push
   * @param {Channel} channel - The Channel
   * @param {ChannelEvent} event - The event, for example `"phx_join"`
   * @param {() => Record<string, unknown>} payload - The payload, for example `{user_id: 123}`
   * @param {number} timeout - The push timeout in milliseconds
   */ constructor(channel, event, payload, timeout){
        this.channel = channel;
        this.event = event;
        this.payload = payload || function() {
            return {};
        };
        this.receivedResp = null;
        this.timeout = timeout;
        this.timeoutTimer = null;
        this.recHooks = [];
        this.sent = false;
        this.ref = void 0;
    }
    /**
   *
   * @param {number} timeout
   */ resend(timeout) {
        this.timeout = timeout;
        this.reset();
        this.send();
    }
    /**
   *
   */ send() {
        if (this.hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload(),
            ref: this.ref,
            join_ref: this.channel.joinRef()
        });
    }
    /**
   *
   * @param {string} status
   * @param {(response: any) => void} callback
   */ receive(status, callback) {
        if (this.hasReceived(status)) callback(this.receivedResp.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    reset() {
        this.cancelRefEvent();
        this.ref = null;
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
    }
    destroy() {
        this.cancelRefEvent();
        this.cancelTimeout();
    }
    /**
   * @private
   */ matchReceive({ status: status, response: response, _ref: _ref }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    /**
   * @private
   */ cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel.off(this.refEvent);
    }
    cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
    }
    startTimeout() {
        if (this.timeoutTimer) this.cancelTimeout();
        this.ref = this.channel.socket.makeRef();
        this.refEvent = this.channel.replyEventName(this.ref);
        this.channel.on(this.refEvent, (payload)=>{
            this.cancelRefEvent();
            this.cancelTimeout();
            this.receivedResp = payload;
            this.matchReceive(payload);
        });
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    /**
   * @private
   */ hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    trigger(status, response) {
        this.channel.trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
};
// js/phoenix/timer.js
var $f25c0b408bfd3e36$export$c57e9b2d8b9e4de = class {
    /**
  * @param {() => void} callback
  * @param {(tries: number) => number} timerCalc
  */ constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = void 0;
        this.tries = 0;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    /**
   * Cancels any previous scheduleTimeout and schedules callback
   */ scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
};
// js/phoenix/channel.js
var $f25c0b408bfd3e36$export$cfdacaa37f9b4dd7 = class {
    /**
   * @param {string} topic
   * @param {Params | (() => Params)} params
   * @param {Socket} socket
   */ constructor(topic, params, socket){
        this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.closed;
        this.topic = topic;
        this.params = $f25c0b408bfd3e36$var$closure(params || {});
        this.socket = socket;
        this.bindings = [];
        this.bindingRef = 0;
        this.timeout = this.socket.timeout;
        this.joinedOnce = false;
        this.joinPush = new $f25c0b408bfd3e36$export$fb87db22c6b0e2ba(this, $f25c0b408bfd3e36$var$CHANNEL_EVENTS.join, this.params, this.timeout);
        this.pushBuffer = [];
        this.stateChangeRefs = [];
        this.rejoinTimer = new $f25c0b408bfd3e36$export$c57e9b2d8b9e4de(()=>{
            if (this.socket.isConnected()) this.rejoin();
        }, this.socket.rejoinAfterMs);
        this.stateChangeRefs.push(this.socket.onError(()=>this.rejoinTimer.reset()));
        this.stateChangeRefs.push(this.socket.onOpen(()=>{
            this.rejoinTimer.reset();
            if (this.isErrored()) this.rejoin();
        }));
        this.joinPush.receive("ok", ()=>{
            this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this.joinPush.receive("error", (reason)=>{
            this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.errored;
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.onClose(()=>{
            this.rejoinTimer.reset();
            if (this.socket.hasLogger()) this.socket.log("channel", `close ${this.topic}`);
            this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.closed;
            this.socket.remove(this);
        });
        this.onError((reason)=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `error ${this.topic}`, reason);
            if (this.isJoining()) this.joinPush.reset();
            this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.errored;
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout);
            let leavePush = new $f25c0b408bfd3e36$export$fb87db22c6b0e2ba(this, $f25c0b408bfd3e36$var$CHANNEL_EVENTS.leave, $f25c0b408bfd3e36$var$closure({}), this.timeout);
            leavePush.send();
            this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.errored;
            this.joinPush.reset();
            if (this.socket.isConnected()) this.rejoinTimer.scheduleTimeout();
        });
        this.on($f25c0b408bfd3e36$var$CHANNEL_EVENTS.reply, (payload, ref)=>{
            this.trigger(this.replyEventName(ref), payload);
        });
    }
    /**
   * Join the channel
   * @param {number} timeout
   * @returns {Push}
   */ join(timeout = this.timeout) {
        if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
        else {
            this.timeout = timeout;
            this.joinedOnce = true;
            this.rejoin();
            return this.joinPush;
        }
    }
    /**
   * Teardown the channel.
   *
   * Destroys and stops related timers.
   */ teardown() {
        this.pushBuffer.forEach((push)=>push.destroy());
        this.pushBuffer = [];
        this.rejoinTimer.reset();
        this.joinPush.destroy();
        this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.closed;
        this.bindings = [];
    }
    /**
   * Hook into channel close
   * @param {ChannelBindingCallback} callback
   */ onClose(callback) {
        this.on($f25c0b408bfd3e36$var$CHANNEL_EVENTS.close, callback);
    }
    /**
   * Hook into channel errors
   * @param {ChannelOnErrorCallback} callback
   * @return {number}
   */ onError(callback) {
        return this.on($f25c0b408bfd3e36$var$CHANNEL_EVENTS.error, (reason)=>callback(reason));
    }
    /**
   * Subscribes on channel events
   *
   * Subscription returns a ref counter, which can be used later to
   * unsubscribe the exact event listener
   *
   * @example
   * const ref1 = channel.on("event", do_stuff)
   * const ref2 = channel.on("event", do_other_stuff)
   * channel.off("event", ref1)
   * // Since unsubscription, do_stuff won't fire,
   * // while do_other_stuff will keep firing on the "event"
   *
   * @param {string} event
   * @param {ChannelBindingCallback} callback
   * @returns {number} ref
   */ on(event, callback) {
        let ref = this.bindingRef++;
        this.bindings.push({
            event: event,
            ref: ref,
            callback: callback
        });
        return ref;
    }
    /**
   * Unsubscribes off of channel events
   *
   * Use the ref returned from a channel.on() to unsubscribe one
   * handler, or pass nothing for the ref to unsubscribe all
   * handlers for the given event.
   *
   * @example
   * // Unsubscribe the do_stuff handler
   * const ref1 = channel.on("event", do_stuff)
   * channel.off("event", ref1)
   *
   * // Unsubscribe all handlers from event
   * channel.off("event")
   *
   * @param {string} event
   * @param {number} [ref]
   */ off(event, ref) {
        this.bindings = this.bindings.filter((bind)=>{
            return !(bind.event === event && (typeof ref === "undefined" || ref === bind.ref));
        });
    }
    /**
   * @private
   */ canPush() {
        return this.socket.isConnected() && this.isJoined();
    }
    /**
   * Sends a message `event` to phoenix with the payload `payload`.
   * Phoenix receives this in the `handle_in(event, payload, socket)`
   * function. if phoenix replies or it times out (default 10000ms),
   * then optionally the reply can be received.
   *
   * @example
   * channel.push("event")
   *   .receive("ok", payload => console.log("phoenix replied:", payload))
   *   .receive("error", err => console.log("phoenix errored", err))
   *   .receive("timeout", () => console.log("timed out pushing"))
   * @param {string} event
   * @param {Object} payload
   * @param {number} [timeout]
   * @returns {Push}
   */ push(event, payload, timeout = this.timeout) {
        payload = payload || {};
        if (!this.joinedOnce) throw new Error(`tried to push '${event}' to '${this.topic}' before joining. Use channel.join() before pushing events`);
        let pushEvent = new $f25c0b408bfd3e36$export$fb87db22c6b0e2ba(this, event, function() {
            return payload;
        }, timeout);
        if (this.canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /** Leaves the channel
   *
   * Unsubscribes from server events, and
   * instructs channel to terminate on server
   *
   * Triggers onClose() hooks
   *
   * To receive leave acknowledgements, use the `receive`
   * hook to bind to the server ack, ie:
   *
   * @example
   * channel.leave().receive("ok", () => alert("left!") )
   *
   * @param {number} timeout
   * @returns {Push}
   */ leave(timeout = this.timeout) {
        this.rejoinTimer.reset();
        this.joinPush.cancelTimeout();
        this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.leaving;
        let onClose = ()=>{
            if (this.socket.hasLogger()) this.socket.log("channel", `leave ${this.topic}`);
            this.trigger($f25c0b408bfd3e36$var$CHANNEL_EVENTS.close, "leave");
        };
        let leavePush = new $f25c0b408bfd3e36$export$fb87db22c6b0e2ba(this, $f25c0b408bfd3e36$var$CHANNEL_EVENTS.leave, $f25c0b408bfd3e36$var$closure({}), timeout);
        leavePush.receive("ok", ()=>onClose()).receive("timeout", ()=>onClose());
        leavePush.send();
        if (!this.canPush()) leavePush.trigger("ok", {});
        return leavePush;
    }
    /**
   * Overridable message hook
   *
   * Receives all events for specialized message handling
   * before dispatching to the channel callbacks.
   *
   * Must return the payload, modified or unmodified
   * @type{ChannelOnMessage}
   */ onMessage(_event, payload, _ref) {
        return payload;
    }
    /**
   * Overridable filter hook
   *
   * If this function returns `true`, `binding`'s callback will be called.
   *
   * @type{ChannelFilterBindings}
   */ filterBindings(_binding, _payload, _ref) {
        return true;
    }
    isMember(topic, event, payload, joinRef) {
        if (this.topic !== topic) return false;
        if (joinRef && joinRef !== this.joinRef()) {
            if (this.socket.hasLogger()) this.socket.log("channel", "dropping outdated message", {
                topic: topic,
                event: event,
                payload: payload,
                joinRef: joinRef
            });
            return false;
        } else return true;
    }
    joinRef() {
        return this.joinPush.ref;
    }
    /**
   * @private
   */ rejoin(timeout = this.timeout) {
        if (this.isLeaving()) return;
        this.socket.leaveOpenTopic(this.topic);
        this.state = $f25c0b408bfd3e36$var$CHANNEL_STATES.joining;
        this.joinPush.resend(timeout);
    }
    /**
   * @param {string} event
   * @param {unknown} [payload]
   * @param {?string} [ref]
   * @param {?string} [joinRef]
   */ trigger(event, payload, ref, joinRef) {
        let handledPayload = this.onMessage(event, payload, ref, joinRef);
        if (payload && !handledPayload) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");
        let eventBindings = this.bindings.filter((bind)=>bind.event === event && this.filterBindings(bind, payload, ref));
        for(let i = 0; i < eventBindings.length; i++){
            let bind = eventBindings[i];
            bind.callback(handledPayload, ref, joinRef || this.joinRef());
        }
    }
    /**
  * @param {string} ref
  */ replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    isClosed() {
        return this.state === $f25c0b408bfd3e36$var$CHANNEL_STATES.closed;
    }
    isErrored() {
        return this.state === $f25c0b408bfd3e36$var$CHANNEL_STATES.errored;
    }
    isJoined() {
        return this.state === $f25c0b408bfd3e36$var$CHANNEL_STATES.joined;
    }
    isJoining() {
        return this.state === $f25c0b408bfd3e36$var$CHANNEL_STATES.joining;
    }
    isLeaving() {
        return this.state === $f25c0b408bfd3e36$var$CHANNEL_STATES.leaving;
    }
};
// js/phoenix/ajax.js
var $f25c0b408bfd3e36$var$Ajax = class {
    static request(method, endPoint, headers, body, timeout, ontimeout, callback) {
        if ($f25c0b408bfd3e36$var$global.XDomainRequest) {
            let req = new $f25c0b408bfd3e36$var$global.XDomainRequest();
            return this.xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback);
        } else if ($f25c0b408bfd3e36$var$global.XMLHttpRequest) {
            let req = new $f25c0b408bfd3e36$var$global.XMLHttpRequest();
            return this.xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback);
        } else if ($f25c0b408bfd3e36$var$global.fetch && $f25c0b408bfd3e36$var$global.AbortController) return this.fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback);
        else throw new Error("No suitable XMLHttpRequest implementation found");
    }
    static fetchRequest(method, endPoint, headers, body, timeout, ontimeout, callback) {
        let options = {
            method: method,
            headers: headers,
            body: body
        };
        let controller = null;
        if (timeout) {
            controller = new AbortController();
            const _timeoutId = setTimeout(()=>controller.abort(), timeout);
            options.signal = controller.signal;
        }
        $f25c0b408bfd3e36$var$global.fetch(endPoint, options).then((response)=>response.text()).then((data)=>this.parseJSON(data)).then((data)=>callback && callback(data)).catch((err)=>{
            if (err.name === "AbortError" && ontimeout) ontimeout();
            else callback && callback(null);
        });
        return controller;
    }
    static xdomainRequest(req, method, endPoint, body, timeout, ontimeout, callback) {
        req.timeout = timeout;
        req.open(method, endPoint);
        req.onload = ()=>{
            let response = this.parseJSON(req.responseText);
            callback && callback(response);
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.onprogress = ()=>{};
        req.send(body);
        return req;
    }
    static xhrRequest(req, method, endPoint, headers, body, timeout, ontimeout, callback) {
        req.open(method, endPoint, true);
        req.timeout = timeout;
        for (let [key, value] of Object.entries(headers))req.setRequestHeader(key, value);
        req.onerror = ()=>callback && callback(null);
        req.onreadystatechange = ()=>{
            if (req.readyState === $f25c0b408bfd3e36$var$XHR_STATES.complete && callback) {
                let response = this.parseJSON(req.responseText);
                callback(response);
            }
        };
        if (ontimeout) req.ontimeout = ontimeout;
        req.send(body);
        return req;
    }
    static parseJSON(resp) {
        if (!resp || resp === "") return null;
        try {
            return JSON.parse(resp);
        } catch  {
            console && console.log("failed to parse JSON response", resp);
            return null;
        }
    }
    static serialize(obj, parentKey) {
        let queryStr = [];
        for(var key in obj){
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            let paramKey = parentKey ? `${parentKey}[${key}]` : key;
            let paramVal = obj[key];
            if (typeof paramVal === "object") queryStr.push(this.serialize(paramVal, paramKey));
            else queryStr.push(encodeURIComponent(paramKey) + "=" + encodeURIComponent(paramVal));
        }
        return queryStr.join("&");
    }
    static appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        let prefix = url.match(/\?/) ? "&" : "?";
        return `${url}${prefix}${this.serialize(params)}`;
    }
};
// js/phoenix/longpoll.js
var $f25c0b408bfd3e36$var$arrayBufferToBase64 = (buffer)=>{
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for(let i = 0; i < len; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
};
var $f25c0b408bfd3e36$export$57a2cdf8ead4f893 = class {
    constructor(endPoint, protocols){
        if (protocols && protocols.length === 2 && protocols[1].startsWith($f25c0b408bfd3e36$var$AUTH_TOKEN_PREFIX)) this.authToken = atob(protocols[1].slice($f25c0b408bfd3e36$var$AUTH_TOKEN_PREFIX.length));
        this.endPoint = null;
        this.token = null;
        this.skipHeartbeat = true;
        this.reqs = /* @__PURE__ */ new Set();
        this.awaitingBatchAck = false;
        this.currentBatch = null;
        this.currentBatchTimer = null;
        this.batchBuffer = [];
        this.onopen = function() {};
        this.onerror = function() {};
        this.onmessage = function() {};
        this.onclose = function() {};
        this.pollEndpoint = this.normalizeEndpoint(endPoint);
        this.readyState = $f25c0b408bfd3e36$var$SOCKET_STATES.connecting;
        setTimeout(()=>this.poll(), 0);
    }
    normalizeEndpoint(endPoint) {
        return endPoint.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + $f25c0b408bfd3e36$var$TRANSPORTS.websocket), "$1/" + $f25c0b408bfd3e36$var$TRANSPORTS.longpoll);
    }
    endpointURL() {
        return $f25c0b408bfd3e36$var$Ajax.appendParams(this.pollEndpoint, {
            token: this.token
        });
    }
    closeAndRetry(code, reason, wasClean) {
        this.close(code, reason, wasClean);
        this.readyState = $f25c0b408bfd3e36$var$SOCKET_STATES.connecting;
    }
    ontimeout() {
        this.onerror("timeout");
        this.closeAndRetry(1005, "timeout", false);
    }
    isActive() {
        return this.readyState === $f25c0b408bfd3e36$var$SOCKET_STATES.open || this.readyState === $f25c0b408bfd3e36$var$SOCKET_STATES.connecting;
    }
    poll() {
        const headers = {
            "Accept": "application/json"
        };
        if (this.authToken) headers["X-Phoenix-AuthToken"] = this.authToken;
        this.ajax("GET", headers, null, ()=>this.ontimeout(), (resp)=>{
            if (resp) {
                var { status: status, token: token, messages: messages } = resp;
                if (status === 410 && this.token !== null) {
                    this.onerror(410);
                    this.closeAndRetry(3410, "session_gone", false);
                    return;
                }
                this.token = token;
            } else status = 0;
            switch(status){
                case 200:
                    messages.forEach((msg)=>{
                        setTimeout(()=>this.onmessage({
                                data: msg
                            }), 0);
                    });
                    this.poll();
                    break;
                case 204:
                    this.poll();
                    break;
                case 410:
                    this.readyState = $f25c0b408bfd3e36$var$SOCKET_STATES.open;
                    this.onopen({});
                    this.poll();
                    break;
                case 403:
                    this.onerror(403);
                    this.close(1008, "forbidden", false);
                    break;
                case 0:
                case 500:
                    this.onerror(500);
                    this.closeAndRetry(1011, "internal server error", 500);
                    break;
                default:
                    throw new Error(`unhandled poll status ${status}`);
            }
        });
    }
    // we collect all pushes within the current event loop by
    // setTimeout 0, which optimizes back-to-back procedural
    // pushes against an empty buffer
    send(body) {
        if (typeof body !== "string") body = $f25c0b408bfd3e36$var$arrayBufferToBase64(body);
        if (this.currentBatch) this.currentBatch.push(body);
        else if (this.awaitingBatchAck) this.batchBuffer.push(body);
        else {
            this.currentBatch = [
                body
            ];
            this.currentBatchTimer = setTimeout(()=>{
                this.batchSend(this.currentBatch);
                this.currentBatch = null;
            }, 0);
        }
    }
    batchSend(messages, offset = 0) {
        this.awaitingBatchAck = true;
        const next = offset + $f25c0b408bfd3e36$var$MAX_LONGPOLL_BATCH_SIZE;
        const batch = messages.slice(offset, next);
        this.ajax("POST", {
            "Content-Type": "application/x-ndjson"
        }, batch.join("\n"), ()=>this.onerror("timeout"), (resp)=>{
            if (!resp || resp.status !== 200) {
                this.awaitingBatchAck = false;
                this.onerror(resp && resp.status);
                this.closeAndRetry(1011, "internal server error", false);
            } else if (next < messages.length) this.batchSend(messages, next);
            else if (this.batchBuffer.length > 0) {
                this.batchSend(this.batchBuffer);
                this.batchBuffer = [];
            } else this.awaitingBatchAck = false;
        });
    }
    close(code, reason, wasClean) {
        for (let req of this.reqs)req.abort();
        this.readyState = $f25c0b408bfd3e36$var$SOCKET_STATES.closed;
        let opts = Object.assign({
            code: 1e3,
            reason: void 0,
            wasClean: true
        }, {
            code: code,
            reason: reason,
            wasClean: wasClean
        });
        this.batchBuffer = [];
        clearTimeout(this.currentBatchTimer);
        this.currentBatchTimer = null;
        if (typeof CloseEvent !== "undefined") this.onclose(new CloseEvent("close", opts));
        else this.onclose(opts);
    }
    ajax(method, headers, body, onCallerTimeout, callback) {
        let req;
        let ontimeout = ()=>{
            this.reqs.delete(req);
            onCallerTimeout();
        };
        req = $f25c0b408bfd3e36$var$Ajax.request(method, this.endpointURL(), headers, body, this.timeout, ontimeout, (resp)=>{
            this.reqs.delete(req);
            if (this.isActive()) callback(resp);
        });
        this.reqs.add(req);
    }
};
// js/phoenix/presence.js
var $f25c0b408bfd3e36$export$99c2b779aa4e8b8b = class _Presence {
    /**
   * Initializes the Presence
   * @param {Channel} channel - The Channel
   * @param {PresenceOptions} [opts] - The options, for example `{events: {state: "state", diff: "diff"}}`
   */ constructor(channel, opts = {}){
        let events = opts.events || /** @type {PresenceEvents} */ {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.state = /* @__PURE__ */ Object.create(null);
        this.pendingDiffs = [];
        this.channel = channel;
        this.joinRef = null;
        this.caller = {
            onJoin: function() {},
            onLeave: function() {},
            onSync: function() {}
        };
        this.channel.on(events.state, (newState)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel.joinRef();
            this.state = _Presence.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel.on(events.diff, (diff)=>{
            let { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = _Presence.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
    }
    /**
   * @param {PresenceOnJoin} callback
   */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /**
   * @param {PresenceOnLeave} callback
   */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /**
   * @param {PresenceOnSync} callback
   */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {((key: string, obj: PresenceState) => T)} [by]
   *
   * @returns {T[]}
   */ list(by) {
        return _Presence.list(this.state, by);
    }
    inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel.joinRef();
    }
    // lower-level public static API
    /**
   * Used to sync the list of presences on the server
   * with the client's state. An optional `onJoin` and `onLeave` callback can
   * be provided to react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   *
   * @param {Record<string, PresenceState>} currentState
   * @param {Record<string, PresenceState>} newState
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncState(currentState, newState, onJoin, onLeave) {
        let state = this.toNullProtoObj(this.clone(currentState));
        newState = this.toNullProtoObj(newState);
        let joins = /* @__PURE__ */ Object.create(null);
        let leaves = /* @__PURE__ */ Object.create(null);
        this.map(state, (key, presence)=>{
            if (!newState[key]) leaves[key] = presence;
        });
        this.map(newState, (key, newPresence)=>{
            let currentPresence = state[key];
            if (currentPresence) {
                let newRefs = newPresence.metas.map((m)=>m.phx_ref);
                let curRefs = currentPresence.metas.map((m)=>m.phx_ref);
                let joinedMetas = newPresence.metas.filter((m)=>curRefs.indexOf(m.phx_ref) < 0);
                let leftMetas = currentPresence.metas.filter((m)=>newRefs.indexOf(m.phx_ref) < 0);
                if (joinedMetas.length > 0) {
                    joins[key] = newPresence;
                    joins[key].metas = joinedMetas;
                }
                if (leftMetas.length > 0) {
                    leaves[key] = this.clone(currentPresence);
                    leaves[key].metas = leftMetas;
                }
            } else joins[key] = newPresence;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
   *
   * Used to sync a diff of presence join and leave
   * events from the server, as they happen. Like `syncState`, `syncDiff`
   * accepts optional `onJoin` and `onLeave` callbacks to react to a user
   * joining or leaving from a device.
   *
   * @param {Record<string, PresenceState>} state
   * @param {PresenceDiff} diff
   * @param {PresenceOnJoin} onJoin
   * @param {PresenceOnLeave} onLeave
   *
   * @returns {Record<string, PresenceState>}
   */ static syncDiff(state, diff, onJoin, onLeave) {
        state = this.toNullProtoObj(state);
        let { joins: joins, leaves: leaves } = this.clone(diff);
        if (!onJoin) onJoin = function() {};
        if (!onLeave) onLeave = function() {};
        this.map(joins, (key, newPresence)=>{
            let currentPresence = state[key];
            state[key] = this.clone(newPresence);
            if (currentPresence) {
                let joinedRefs = state[key].metas.map((m)=>m.phx_ref);
                let curMetas = currentPresence.metas.filter((m)=>joinedRefs.indexOf(m.phx_ref) < 0);
                state[key].metas.unshift(...curMetas);
            }
            onJoin(key, currentPresence, newPresence);
        });
        this.map(leaves, (key, leftPresence)=>{
            let currentPresence = state[key];
            if (!currentPresence) return;
            let refsToRemove = leftPresence.metas.map((m)=>m.phx_ref);
            currentPresence.metas = currentPresence.metas.filter((p)=>{
                return refsToRemove.indexOf(p.phx_ref) < 0;
            });
            onLeave(key, currentPresence, leftPresence);
            if (currentPresence.metas.length === 0) delete state[key];
        });
        return state;
    }
    /**
   * Returns the array of presences, with selected metadata.
   *
   * @template [T=PresenceState]
   * @param {Record<string, PresenceState>} presences
   * @param {((key: string, obj: PresenceState) => T)} [chooser]
   *
   * @returns {T[]}
   */ static list(presences, chooser) {
        if (!chooser) chooser = function(key, pres) {
            return pres;
        };
        return this.map(presences, (key, presence)=>{
            return chooser(key, presence);
        });
    }
    // private
    /**
  * @template T
  * @param {Record<string, PresenceState>} obj
  * @param {(key: string, obj: PresenceState) => T} func
  */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    // Presence keys are chosen on the server and may collide with
    // Object.prototype properties ("__proto__", "constructor", ...), so any
    // object indexed by presence key must not have a prototype chain
    //
    // TODO: replace the null-prototype objects with Maps in Phoenix 2.0
    // (breaking change for the lower-level static API)
    static toNullProtoObj(obj) {
        if (Object.getPrototypeOf(obj) === null) return obj;
        let cleaned = /* @__PURE__ */ Object.create(null);
        Object.getOwnPropertyNames(obj).forEach((key)=>{
            cleaned[key] = obj[key];
        });
        return cleaned;
    }
    /**
  * @template T
  * @param {T} obj
  * @returns {T}
  */ static clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
};
// js/phoenix/serializer.js
var $f25c0b408bfd3e36$export$ef852775387a0be7 = {
    HEADER_LENGTH: 1,
    META_LENGTH: 4,
    KINDS: {
        push: 0,
        reply: 1,
        broadcast: 2
    },
    /**
  * @template T
  * @param {Message<Record<string, any>>} msg
  * @param {(msg: ArrayBuffer | string) => T} callback
  * @returns {T}
  */ encode (msg, callback) {
        if (msg.payload.constructor === ArrayBuffer) return callback(this.binaryEncode(msg));
        else {
            let payload = [
                msg.join_ref,
                msg.ref,
                msg.topic,
                msg.event,
                msg.payload
            ];
            return callback(JSON.stringify(payload));
        }
    },
    /**
  * @template T
  * @param {ArrayBuffer | string} rawPayload
  * @param {(msg: Message<unknown>) => T} callback
  * @returns {T}
  */ decode (rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this.binaryDecode(rawPayload));
        else {
            let [join_ref, ref, topic, event, payload] = JSON.parse(rawPayload);
            return callback({
                join_ref: join_ref,
                ref: ref,
                topic: topic,
                event: event,
                payload: payload
            });
        }
    },
    /** @private */ binaryEncode (message) {
        let { join_ref: join_ref, ref: ref, event: event, topic: topic, payload: payload } = message;
        let encoder = new TextEncoder();
        let joinRefBytes = encoder.encode(join_ref);
        let refBytes = encoder.encode(ref);
        let topicBytes = encoder.encode(topic);
        let eventBytes = encoder.encode(event);
        this.assertFieldSize(joinRefBytes.byteLength, "join_ref");
        this.assertFieldSize(refBytes.byteLength, "ref");
        this.assertFieldSize(topicBytes.byteLength, "topic");
        this.assertFieldSize(eventBytes.byteLength, "event");
        let metaLength = this.META_LENGTH + joinRefBytes.byteLength + refBytes.byteLength + topicBytes.byteLength + eventBytes.byteLength;
        let header = new ArrayBuffer(this.HEADER_LENGTH + metaLength);
        let headerBytes = new Uint8Array(header);
        let view = new DataView(header);
        let offset = 0;
        view.setUint8(offset++, this.KINDS.push);
        view.setUint8(offset++, joinRefBytes.byteLength);
        view.setUint8(offset++, refBytes.byteLength);
        view.setUint8(offset++, topicBytes.byteLength);
        view.setUint8(offset++, eventBytes.byteLength);
        headerBytes.set(joinRefBytes, offset);
        offset += joinRefBytes.byteLength;
        headerBytes.set(refBytes, offset);
        offset += refBytes.byteLength;
        headerBytes.set(topicBytes, offset);
        offset += topicBytes.byteLength;
        headerBytes.set(eventBytes, offset);
        offset += eventBytes.byteLength;
        var combined = new Uint8Array(header.byteLength + payload.byteLength);
        combined.set(headerBytes, 0);
        combined.set(new Uint8Array(payload), header.byteLength);
        return combined.buffer;
    },
    assertFieldSize (size, name) {
        if (size > 255) throw new Error(`unable to convert ${name} to binary: must be less than or equal to 255 bytes, but is ${size} bytes`);
    },
    /**
  * @private
  */ binaryDecode (buffer) {
        let view = new DataView(buffer);
        let kind = view.getUint8(0);
        let decoder = new TextDecoder();
        switch(kind){
            case this.KINDS.push:
                return this.decodePush(buffer, view, decoder);
            case this.KINDS.reply:
                return this.decodeReply(buffer, view, decoder);
            case this.KINDS.broadcast:
                return this.decodeBroadcast(buffer, view, decoder);
        }
    },
    /** @private */ decodePush (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let topicSize = view.getUint8(2);
        let eventSize = view.getUint8(3);
        let offset = this.HEADER_LENGTH + this.META_LENGTH - 1;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: joinRef,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    },
    /** @private */ decodeReply (buffer, view, decoder) {
        let joinRefSize = view.getUint8(1);
        let refSize = view.getUint8(2);
        let topicSize = view.getUint8(3);
        let eventSize = view.getUint8(4);
        let offset = this.HEADER_LENGTH + this.META_LENGTH;
        let joinRef = decoder.decode(buffer.slice(offset, offset + joinRefSize));
        offset = offset + joinRefSize;
        let ref = decoder.decode(buffer.slice(offset, offset + refSize));
        offset = offset + refSize;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        let payload = {
            status: event,
            response: data
        };
        return {
            join_ref: joinRef,
            ref: ref,
            topic: topic,
            event: $f25c0b408bfd3e36$var$CHANNEL_EVENTS.reply,
            payload: payload
        };
    },
    /** @private */ decodeBroadcast (buffer, view, decoder) {
        let topicSize = view.getUint8(1);
        let eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        let topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        let event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        let data = buffer.slice(offset, buffer.byteLength);
        return {
            join_ref: null,
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
};
// js/phoenix/socket.js
var $f25c0b408bfd3e36$export$4798917dbf149b79 = class {
    /** Initializes the Socket *
   *
   * For IE8 support use an ES5-shim (https://github.com/es-shims/es5-shim)
   *
   * @constructor
   * @param {string} endPoint - The string WebSocket endpoint, ie, `"ws://example.com/socket"`,
   *                                               `"wss://example.com"`
   *                                               `"/socket"` (inherited host & protocol)
   * @param {SocketOptions} [opts] - Optional configuration
   */ constructor(endPoint, opts = {}){
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.channels = [];
        this.sendBuffer = [];
        this.ref = 0;
        this.fallbackRef = null;
        this.timeout = opts.timeout || $f25c0b408bfd3e36$var$DEFAULT_TIMEOUT;
        this.transport = opts.transport || $f25c0b408bfd3e36$var$global.WebSocket || $f25c0b408bfd3e36$export$57a2cdf8ead4f893;
        this.conn = void 0;
        this.primaryPassedHealthCheck = false;
        this.longPollFallbackMs = opts.longPollFallbackMs;
        this.fallbackTimer = null;
        let envSessionStorage = null;
        try {
            envSessionStorage = $f25c0b408bfd3e36$var$global && $f25c0b408bfd3e36$var$global.sessionStorage;
        } catch  {}
        this.sessionStore = opts.sessionStorage || envSessionStorage;
        this.establishedConnections = 0;
        this.defaultEncoder = $f25c0b408bfd3e36$export$ef852775387a0be7.encode.bind($f25c0b408bfd3e36$export$ef852775387a0be7);
        this.defaultDecoder = $f25c0b408bfd3e36$export$ef852775387a0be7.decode.bind($f25c0b408bfd3e36$export$ef852775387a0be7);
        this.closeWasClean = true;
        this.disconnecting = false;
        this.binaryType = opts.binaryType || "arraybuffer";
        this.connectClock = 1;
        this.pageHidden = false;
        this.encode = void 0;
        this.decode = void 0;
        if (this.transport !== $f25c0b408bfd3e36$export$57a2cdf8ead4f893) {
            this.encode = opts.encode || this.defaultEncoder;
            this.decode = opts.decode || this.defaultDecoder;
        } else {
            this.encode = this.defaultEncoder;
            this.decode = this.defaultDecoder;
        }
        let awaitingConnectionOnPageShow = null;
        if ($f25c0b408bfd3e36$var$phxWindow && $f25c0b408bfd3e36$var$phxWindow.addEventListener) {
            $f25c0b408bfd3e36$var$phxWindow.addEventListener("pagehide", (_e)=>{
                if (this.conn) {
                    this.disconnect();
                    awaitingConnectionOnPageShow = this.connectClock;
                }
            });
            $f25c0b408bfd3e36$var$phxWindow.addEventListener("pageshow", (_e)=>{
                if (awaitingConnectionOnPageShow === this.connectClock) {
                    awaitingConnectionOnPageShow = null;
                    this.connect();
                }
            });
            $f25c0b408bfd3e36$var$phxWindow.addEventListener("visibilitychange", ()=>{
                if (document.visibilityState === "hidden") this.pageHidden = true;
                else {
                    this.pageHidden = false;
                    if (!this.isConnected() && !this.closeWasClean) this.teardown(()=>this.connect());
                }
            });
        }
        this.heartbeatIntervalMs = opts.heartbeatIntervalMs || 3e4;
        this.autoSendHeartbeat = opts.autoSendHeartbeat ?? true;
        this.heartbeatCallback = opts.heartbeatCallback ?? (()=>{});
        this.rejoinAfterMs = (tries)=>{
            if (opts.rejoinAfterMs) return opts.rejoinAfterMs(tries);
            else return [
                1e3,
                2e3,
                5e3
            ][tries - 1] || 1e4;
        };
        this.reconnectAfterMs = (tries)=>{
            if (opts.reconnectAfterMs) return opts.reconnectAfterMs(tries);
            else return [
                10,
                50,
                100,
                150,
                200,
                250,
                500,
                1e3,
                2e3
            ][tries - 1] || 5e3;
        };
        this.logger = opts.logger || null;
        if (!this.logger && opts.debug) this.logger = (kind, msg, data)=>{
            console.log(`${kind}: ${msg}`, data);
        };
        this.longpollerTimeout = opts.longpollerTimeout || 2e4;
        this.params = $f25c0b408bfd3e36$var$closure(opts.params || {});
        this.endPoint = `${endPoint}/${$f25c0b408bfd3e36$var$TRANSPORTS.websocket}`;
        this.vsn = opts.vsn || $f25c0b408bfd3e36$var$DEFAULT_VSN;
        this.heartbeatTimeoutTimer = null;
        this.heartbeatTimer = null;
        this.heartbeatSentAt = null;
        this.pendingHeartbeatRef = null;
        this.reconnectTimer = new $f25c0b408bfd3e36$export$c57e9b2d8b9e4de(()=>{
            if (this.pageHidden) {
                this.log("Not reconnecting as page is hidden!");
                this.teardown();
                return;
            }
            this.teardown(async ()=>{
                if (opts.beforeReconnect) await opts.beforeReconnect();
                this.connect();
            });
        }, this.reconnectAfterMs);
        this.authToken = opts.authToken && $f25c0b408bfd3e36$var$closure(opts.authToken);
    }
    /**
   * Returns the LongPoll transport reference
   */ getLongPollTransport() {
        return $f25c0b408bfd3e36$export$57a2cdf8ead4f893;
    }
    /**
   * Disconnects and replaces the active transport
   *
   * @param {SocketTransport} newTransport - The new transport class to instantiate
   *
   */ replaceTransport(newTransport) {
        this.connectClock++;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        if (this.conn) {
            this.conn.close();
            this.conn = null;
        }
        this.transport = newTransport;
    }
    /**
   * Returns the socket protocol
   *
   * @returns {"wss" | "ws"}
   */ protocol() {
        return location.protocol.match(/^https/) ? "wss" : "ws";
    }
    /**
   * The fully qualified socket url
   *
   * @returns {string}
   */ endPointURL() {
        let uri = $f25c0b408bfd3e36$var$Ajax.appendParams($f25c0b408bfd3e36$var$Ajax.appendParams(this.endPoint, this.params()), {
            vsn: this.vsn
        });
        if (uri.charAt(0) !== "/") return uri;
        if (uri.charAt(1) === "/") return `${this.protocol()}:${uri}`;
        return `${this.protocol()}://${location.host}${uri}`;
    }
    /**
   * Disconnects the socket
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes for valid status codes.
   *
   * @param {() => void} [callback] - Optional callback which is called after socket is disconnected.
   * @param {number} [code] - A status code for disconnection (Optional).
   * @param {string} [reason] - A textual description of the reason to disconnect. (Optional)
   */ disconnect(callback, code, reason) {
        this.connectClock++;
        this.disconnecting = true;
        this.closeWasClean = true;
        clearTimeout(this.fallbackTimer);
        this.reconnectTimer.reset();
        this.teardown(()=>{
            this.disconnecting = false;
            callback && callback();
        }, code, reason);
    }
    /**
   * @param {Params} [params] - [DEPRECATED] The params to send when connecting, for example `{user_id: userToken}`
   *
   * Passing params to connect is deprecated; pass them in the Socket constructor instead:
   * `new Socket("/socket", {params: {user_id: userToken}})`.
   */ connect(params) {
        if (params) {
            console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor");
            this.params = $f25c0b408bfd3e36$var$closure(params);
        }
        if (this.conn && !this.disconnecting) return;
        if (this.longPollFallbackMs && this.transport !== $f25c0b408bfd3e36$export$57a2cdf8ead4f893) this.connectWithFallback($f25c0b408bfd3e36$export$57a2cdf8ead4f893, this.longPollFallbackMs);
        else this.transportConnect();
    }
    /**
   * Logs the message. Override `this.logger` for specialized logging. noops by default
   * @param {string} kind
   * @param {string} msg
   * @param {Object} data
   */ log(kind, msg, data) {
        this.logger && this.logger(kind, msg, data);
    }
    /**
   * Returns true if a logger has been set on this socket.
   */ hasLogger() {
        return this.logger !== null;
    }
    /**
   * Registers callbacks for connection open events
   *
   * @example socket.onOpen(function(){ console.info("the socket was opened") })
   *
   * @param {SocketOnOpen} callback
   */ onOpen(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.open.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection close events
   * @param {SocketOnClose} callback
   * @returns {string}
   */ onClose(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.close.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection error events
   *
   * @example socket.onError(function(error){ alert("An error occurred") })
   *
   * @param {SocketOnError} callback
   * @returns {string}
   */ onError(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.error.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Registers callbacks for connection message events
   * @param {SocketOnMessage} callback
   * @returns {string}
   */ onMessage(callback) {
        let ref = this.makeRef();
        this.stateChangeCallbacks.message.push([
            ref,
            callback
        ]);
        return ref;
    }
    /**
   * Sets a callback that receives lifecycle events for internal heartbeat messages.
   * Useful for instrumenting connection health (e.g. sent/ok/timeout/disconnected).
   * @param {HeartbeatCallback} callback
   */ onHeartbeat(callback) {
        this.heartbeatCallback = callback;
    }
    /**
   * Pings the server and invokes the callback with the RTT in milliseconds
   * @param {(timeDelta: number) => void} callback
   *
   * Returns true if the ping was pushed or false if unable to be pushed.
   */ ping(callback) {
        if (!this.isConnected()) return false;
        let ref = this.makeRef();
        let startTime = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: ref
        });
        let onMsgRef = this.onMessage((msg)=>{
            if (msg.ref === ref) {
                this.off([
                    onMsgRef
                ]);
                callback(Date.now() - startTime);
            }
        });
        return true;
    }
    /**
   * @private
   *
   * @param {Function}
   */ transportName(transport) {
        switch(transport){
            case $f25c0b408bfd3e36$export$57a2cdf8ead4f893:
                return "LongPoll";
            default:
                return transport.name;
        }
    }
    /**
   * @private
   */ transportConnect() {
        this.connectClock++;
        this.closeWasClean = false;
        let protocols = void 0;
        if (this.authToken) protocols = [
            "phoenix",
            `${$f25c0b408bfd3e36$var$AUTH_TOKEN_PREFIX}${btoa(this.authToken()).replace(/=/g, "")}`
        ];
        this.conn = new this.transport(this.endPointURL(), protocols);
        this.conn.binaryType = this.binaryType;
        this.conn.timeout = this.longpollerTimeout;
        this.conn.onopen = ()=>this.onConnOpen();
        this.conn.onerror = (error)=>this.onConnError(error);
        this.conn.onmessage = (event)=>this.onConnMessage(event);
        this.conn.onclose = (event)=>this.onConnClose(event);
    }
    getSession(key) {
        return this.sessionStore && this.sessionStore.getItem(key);
    }
    storeSession(key, val) {
        this.sessionStore && this.sessionStore.setItem(key, val);
    }
    connectWithFallback(fallbackTransport, fallbackThreshold = 2500) {
        clearTimeout(this.fallbackTimer);
        let established = false;
        let primaryTransport = true;
        let openRef, errorRef;
        let fallbackTransportName = this.transportName(fallbackTransport);
        let fallback = (reason)=>{
            this.log("transport", `falling back to ${fallbackTransportName}...`, reason);
            this.off([
                openRef,
                errorRef
            ]);
            primaryTransport = false;
            this.replaceTransport(fallbackTransport);
            this.transportConnect();
        };
        if (this.getSession(`phx:fallback:${fallbackTransportName}`)) return fallback("memorized");
        this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
        errorRef = this.onError((reason)=>{
            this.log("transport", "error", reason);
            if (primaryTransport && !established) {
                clearTimeout(this.fallbackTimer);
                fallback(reason);
            }
        });
        if (this.fallbackRef) this.off([
            this.fallbackRef
        ]);
        this.fallbackRef = this.onOpen(()=>{
            established = true;
            if (!primaryTransport) {
                let fallbackTransportName2 = this.transportName(fallbackTransport);
                if (!this.primaryPassedHealthCheck) this.storeSession(`phx:fallback:${fallbackTransportName2}`, "true");
                return this.log("transport", `established ${fallbackTransportName2} fallback`);
            }
            clearTimeout(this.fallbackTimer);
            this.fallbackTimer = setTimeout(fallback, fallbackThreshold);
            this.ping((rtt)=>{
                this.log("transport", "connected to primary after", rtt);
                this.primaryPassedHealthCheck = true;
                clearTimeout(this.fallbackTimer);
            });
        });
        this.transportConnect();
    }
    clearHeartbeats() {
        clearTimeout(this.heartbeatTimer);
        clearTimeout(this.heartbeatTimeoutTimer);
    }
    onConnOpen() {
        if (this.hasLogger()) this.log("transport", `connected to ${this.endPointURL()}`);
        this.closeWasClean = false;
        this.disconnecting = false;
        this.establishedConnections++;
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (this.autoSendHeartbeat) this.resetHeartbeat();
        this.triggerStateCallbacks("open");
    }
    /**
   * @private
   */ heartbeatTimeout() {
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.heartbeatSentAt = null;
            if (this.hasLogger()) this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            try {
                this.heartbeatCallback("timeout");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            this.triggerChanError(new Error("heartbeat timeout"));
            this.closeWasClean = false;
            this.teardown(()=>this.reconnectTimer.scheduleTimeout(), $f25c0b408bfd3e36$var$WS_CLOSE_NORMAL, "heartbeat timeout");
        }
    }
    resetHeartbeat() {
        if (this.conn && this.conn.skipHeartbeat) return;
        this.pendingHeartbeatRef = null;
        this.clearHeartbeats();
        this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
    }
    teardown(callback, code, reason) {
        if (!this.conn) return callback && callback();
        const connToClose = this.conn;
        this.waitForBufferDone(connToClose, ()=>{
            if (code) connToClose.close(code, reason || "");
            else connToClose.close();
            this.waitForSocketClosed(connToClose, ()=>{
                if (this.conn === connToClose) {
                    this.conn.onopen = function() {};
                    this.conn.onerror = function() {};
                    this.conn.onmessage = function() {};
                    this.conn.onclose = function() {};
                    this.conn = null;
                }
                callback && callback();
            });
        });
    }
    waitForBufferDone(conn, callback, tries = 1) {
        if (tries === 5 || !conn.bufferedAmount) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForBufferDone(conn, callback, tries + 1);
        }, 150 * tries);
    }
    waitForSocketClosed(conn, callback, tries = 1) {
        if (tries === 5 || conn.readyState === $f25c0b408bfd3e36$var$SOCKET_STATES.closed) {
            callback();
            return;
        }
        setTimeout(()=>{
            this.waitForSocketClosed(conn, callback, tries + 1);
        }, 150 * tries);
    }
    /**
  * @param {CloseEvent} event
  */ onConnClose(event) {
        if (this.conn) this.conn.onclose = ()=>{};
        if (this.hasLogger()) this.log("transport", "close", event);
        this.triggerChanError(event);
        this.clearHeartbeats();
        if (!this.closeWasClean) this.reconnectTimer.scheduleTimeout();
        this.triggerStateCallbacks("close", event);
    }
    /**
   * @private
   * @param {Event} error
   */ onConnError(error) {
        if (this.hasLogger()) this.log("transport", "error", error);
        let transportBefore = this.transport;
        let establishedBefore = this.establishedConnections;
        this.triggerStateCallbacks("error", error, transportBefore, establishedBefore);
        if (transportBefore === this.transport || establishedBefore > 0) this.triggerChanError(error);
    }
    /**
   * @private
   * @param {unknown} [reason] underlying close/error event forwarded to channel error listeners
   */ triggerChanError(reason) {
        this.channels.forEach((channel)=>{
            if (!(channel.isErrored() || channel.isLeaving() || channel.isClosed())) channel.trigger($f25c0b408bfd3e36$var$CHANNEL_EVENTS.error, reason);
        });
    }
    /**
   * @returns {string}
   */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case $f25c0b408bfd3e36$var$SOCKET_STATES.connecting:
                return "connecting";
            case $f25c0b408bfd3e36$var$SOCKET_STATES.open:
                return "open";
            case $f25c0b408bfd3e36$var$SOCKET_STATES.closing:
                return "closing";
            default:
                return "closed";
        }
    }
    /**
   * @returns {boolean}
   */ isConnected() {
        return this.connectionState() === "open";
    }
    /**
   *
   * @param {Channel} channel
   */ remove(channel) {
        this.off(channel.stateChangeRefs);
        this.channels = this.channels.filter((c)=>c !== channel);
    }
    /**
   * Removes `onOpen`, `onClose`, `onError,` and `onMessage` registrations.
   *
   * @param {string[]} refs - list of refs returned by calls to
   *                 `onOpen`, `onClose`, `onError,` and `onMessage`
   */ off(refs) {
        for(let key in this.stateChangeCallbacks)this.stateChangeCallbacks[key] = this.stateChangeCallbacks[key].filter(([ref])=>{
            return refs.indexOf(ref) === -1;
        });
    }
    /**
   * Initiates a new channel for the given topic
   *
   * @param {string} topic
   * @param {Params | (() => Params)} [chanParams]- Parameters for the channel
   * @returns {Channel}
   */ channel(topic, chanParams = {}) {
        let chan = new $f25c0b408bfd3e36$export$cfdacaa37f9b4dd7(topic, chanParams, this);
        this.channels.push(chan);
        return chan;
    }
    /**
   * @param {Message<Record<string, any>>} data
   */ push(data) {
        if (this.hasLogger()) {
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = data;
            this.log("push", `${topic} ${event} (${join_ref}, ${ref})`, payload);
        }
        if (this.isConnected()) this.encode(data, (result)=>this.conn.send(result));
        else this.sendBuffer.push(()=>this.encode(data, (result)=>this.conn.send(result)));
    }
    /**
   * Return the next message ref, accounting for overflows
   * @returns {string}
   */ makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    sendHeartbeat() {
        if (!this.isConnected()) {
            try {
                this.heartbeatCallback("disconnected");
            } catch (e) {
                this.log("error", "error in heartbeat callback", e);
            }
            return;
        }
        if (this.pendingHeartbeatRef) {
            this.heartbeatTimeout();
            return;
        }
        this.pendingHeartbeatRef = this.makeRef();
        this.heartbeatSentAt = Date.now();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        try {
            this.heartbeatCallback("sent");
        } catch (e) {
            this.log("error", "error in heartbeat callback", e);
        }
        this.heartbeatTimeoutTimer = setTimeout(()=>this.heartbeatTimeout(), this.heartbeatIntervalMs);
    }
    flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
  * @param {MessageEvent<any>} rawMessage
  */ onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref, join_ref: join_ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) {
                const latency = this.heartbeatSentAt ? Date.now() - this.heartbeatSentAt : void 0;
                this.clearHeartbeats();
                try {
                    this.heartbeatCallback(payload.status === "ok" ? "ok" : "error", latency);
                } catch (e) {
                    this.log("error", "error in heartbeat callback", e);
                }
                this.pendingHeartbeatRef = null;
                this.heartbeatSentAt = null;
                if (this.autoSendHeartbeat) this.heartbeatTimer = setTimeout(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
            }
            if (this.hasLogger()) this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref && "(" + ref + ")" || ""}`.trim(), payload);
            for(let i = 0; i < this.channels.length; i++){
                const channel = this.channels[i];
                if (!channel.isMember(topic, event, payload, join_ref)) continue;
                channel.trigger(event, payload, ref, join_ref);
            }
            this.triggerStateCallbacks("message", msg);
        });
    }
    /**
   * @private
   * @template {keyof SocketStateChangeCallbacks} K
   * @param {K} event
   * @param {...Parameters<SocketStateChangeCallbacks[K][number][1]>} args
   * @returns {void}
   */ triggerStateCallbacks(event, ...args) {
        try {
            this.stateChangeCallbacks[event].forEach(([_, callback])=>{
                try {
                    callback(...args);
                } catch (e) {
                    this.log("error", `error in ${event} callback`, e);
                }
            });
        } catch (e) {
            this.log("error", `error triggering ${event} callbacks`, e);
        }
    }
    leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c.isJoined() || c.isJoining()));
        if (dupChannel) {
            if (this.hasLogger()) this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.leave();
        }
    }
};

});



parcelRegister("iLaxa", function(module, exports) {

$parcel$export(module.exports, "normalizeChannelError", () => $da84c994a463c6ba$export$3c9468938c65e4dc);
/**
 * Normalize the various shapes a channel error reason can take into a real `Error`.
 *
 * Transport-level channel errors arrive as a `CloseEvent`, a transport `Event`, an `Error`,
 * a string, or `undefined` depending on which path in the underlying socket fired. Server-reply
 * errors arrive as a payload object. This helper produces a consistent `Error` for every case
 * and preserves the original via `cause` so callers can still inspect the raw event.
 */ function $da84c994a463c6ba$export$3c9468938c65e4dc(reason) {
    if (reason instanceof Error) return reason;
    if (typeof reason === 'string') return new Error(reason);
    if (reason && typeof reason === 'object') {
        const obj = reason;
        if (typeof obj.code === 'number') {
            const detail = typeof obj.reason === 'string' && obj.reason ? ` (${obj.reason})` : '';
            return new Error(`socket closed: ${obj.code}${detail}`, {
                cause: reason
            });
        }
        return new Error('channel error: transport failure', {
            cause: reason
        });
    }
    return new Error('channel error: connection lost');
}

});

parcelRegister("jcoZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa2855be8b77b15$export$2e2bcd8739ae039);

var $5ssGf = parcelRequire("5ssGf");
class $dfa2855be8b77b15$export$2e2bcd8739ae039 {
    constructor(socket, topic, params){
        const phoenixParams = $dfa2855be8b77b15$var$phoenixChannelParams(params);
        this.channel = socket.getSocket().channel(topic, phoenixParams);
        this.socket = socket;
    }
    get state() {
        return this.channel.state;
    }
    set state(state) {
        this.channel.state = state;
    }
    get joinedOnce() {
        return this.channel.joinedOnce;
    }
    get joinPush() {
        return this.channel.joinPush;
    }
    get rejoinTimer() {
        return this.channel.rejoinTimer;
    }
    on(event, callback) {
        return this.channel.on(event, callback);
    }
    off(event, refNumber) {
        this.channel.off(event, refNumber);
    }
    subscribe(timeout) {
        return this.channel.join(timeout);
    }
    unsubscribe(timeout) {
        return this.channel.leave(timeout);
    }
    teardown() {
        this.channel.teardown();
    }
    onClose(callback) {
        this.channel.onClose(callback);
    }
    onError(callback) {
        return this.channel.onError(callback);
    }
    push(event, payload, timeout) {
        let push;
        try {
            push = this.channel.push(event, payload, timeout);
        } catch (error) {
            throw new Error(`tried to push '${event}' to '${this.channel.topic}' before joining. Use channel.subscribe() before pushing events`);
        }
        if (this.channel.pushBuffer.length > (0, $5ssGf.MAX_PUSH_BUFFER_SIZE)) {
            const removedPush = this.channel.pushBuffer.shift();
            removedPush.cancelTimeout();
            this.socket.log('channel', `discarded push due to buffer overflow: ${removedPush.event}`, removedPush.payload());
        }
        return push;
    }
    updateJoinPayload(payload) {
        const oldPayload = this.channel.joinPush.payload();
        this.channel.joinPush.payload = ()=>Object.assign(Object.assign({}, oldPayload), payload);
    }
    canPush() {
        return this.socket.isConnected() && this.state === (0, $5ssGf.CHANNEL_STATES).joined;
    }
    isJoined() {
        return this.state === (0, $5ssGf.CHANNEL_STATES).joined;
    }
    isJoining() {
        return this.state === (0, $5ssGf.CHANNEL_STATES).joining;
    }
    isClosed() {
        return this.state === (0, $5ssGf.CHANNEL_STATES).closed;
    }
    isLeaving() {
        return this.state === (0, $5ssGf.CHANNEL_STATES).leaving;
    }
    updateFilterBindings(filterBindings) {
        this.channel.filterBindings = filterBindings;
    }
    updatePayloadTransform(callback) {
        this.channel.onMessage = callback;
    }
    /**
     * @internal
     */ getChannel() {
        return this.channel;
    }
}
function $dfa2855be8b77b15$var$phoenixChannelParams(options) {
    return {
        config: Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: '',
                enabled: false
            },
            private: false
        }, options.config)
    };
}

});

parcelRegister("843pN", function(module, exports) {

$parcel$export(module.exports, "RealtimePostgresFilterBuilder", () => $5df1589fb85aee8e$export$d9444c8f5fdca28);
// Reserved characters that force PostgREST-style quoting: `[,()]` (which the
// server reads as condition/list delimiters) plus `"`/`\` (escaped inside quotes).
const $5df1589fb85aee8e$var$PostgrestReservedCharsRegexp = /[,()"\\]/;
const $5df1589fb85aee8e$var$needsQuoting = (value)=>$5df1589fb85aee8e$var$PostgrestReservedCharsRegexp.test(value) || value !== value.trim();
const $5df1589fb85aee8e$var$quote = (value)=>`"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
const $5df1589fb85aee8e$var$serializeScalar = (value)=>{
    const serialized = value === null ? 'null' : String(value);
    return $5df1589fb85aee8e$var$needsQuoting(serialized) ? $5df1589fb85aee8e$var$quote(serialized) : serialized;
};
const $5df1589fb85aee8e$var$serializeIsValue = (value)=>value === null ? 'null' : String(value);
// Builds the `operator.value` portion of a filter (everything after `column=`).
const $5df1589fb85aee8e$var$serialize = (operator, value)=>{
    if (operator === 'in') {
        const values = Array.isArray(value) ? value : [
            value
        ];
        if (values.length === 0) throw new Error('Realtime `in` filter requires at least one value.');
        const items = Array.from(new Set(values)).map((v)=>$5df1589fb85aee8e$var$serializeScalar(v)).join(',');
        return `in.(${items})`;
    }
    if (operator === 'is') return `is.${$5df1589fb85aee8e$var$serializeIsValue(value)}`;
    return `${operator}.${$5df1589fb85aee8e$var$serializeScalar(value)}`;
};
class $5df1589fb85aee8e$export$d9444c8f5fdca28 {
    constructor(){
        this.filters = [];
    }
    add(column, operator, value, negate = false) {
        const prefix = negate ? 'not.' : '';
        this.filters.push(`${column}=${prefix}${$5df1589fb85aee8e$var$serialize(operator, value)}`);
        return this;
    }
    /** Match rows where `column` equals `value` (`column=eq.value`). */ eq(column, value) {
        return this.add(column, 'eq', value);
    }
    /** Match rows where `column` does not equal `value` (`column=neq.value`). */ neq(column, value) {
        return this.add(column, 'neq', value);
    }
    /** Match rows where `column` is greater than `value` (`column=gt.value`). */ gt(column, value) {
        return this.add(column, 'gt', value);
    }
    /** Match rows where `column` is greater than or equal to `value` (`column=gte.value`). */ gte(column, value) {
        return this.add(column, 'gte', value);
    }
    /** Match rows where `column` is less than `value` (`column=lt.value`). */ lt(column, value) {
        return this.add(column, 'lt', value);
    }
    /** Match rows where `column` is less than or equal to `value` (`column=lte.value`). */ lte(column, value) {
        return this.add(column, 'lte', value);
    }
    /**
     * Match rows where `column` is one of `values` (`column=in.(a,b,c)`).
     * Requires at least one value; duplicates are removed. An element containing a
     * reserved character is double-quoted (`in.("a,b",c)`), so commas inside an
     * element are preserved. `null` is intentionally not accepted (`IN (null)`
     * never matches in SQL) — use `is`/`not('col','is',null)` for null checks.
     */ in(column, values) {
        return this.add(column, 'in', values);
    }
    /** Match rows where `column` matches the case-sensitive `pattern` (`column=like.pattern`). */ like(column, pattern) {
        return this.add(column, 'like', pattern);
    }
    /** Match rows where `column` matches the case-insensitive `pattern` (`column=ilike.pattern`). */ ilike(column, pattern) {
        return this.add(column, 'ilike', pattern);
    }
    /** Match rows where `column` matches the POSIX regex `pattern` (`column=match.pattern`). */ match(column, pattern) {
        return this.add(column, 'match', pattern);
    }
    /** Match rows where `column` matches the case-insensitive POSIX regex `pattern` (`column=imatch.pattern`). */ imatch(column, pattern) {
        return this.add(column, 'imatch', pattern);
    }
    /**
     * Match rows where `column` `IS` the given value (`column=is.null`).
     * Accepts `null`, a boolean, or the keywords `'null' | 'true' | 'false' | 'unknown'`.
     */ is(column, value) {
        return this.add(column, 'is', value);
    }
    /** Match rows where `column` is distinct from `value` (`column=isdistinct.value`). NULL-safe inequality. */ isDistinct(column, value) {
        return this.add(column, 'isdistinct', value);
    }
    not(column, operator, value) {
        return this.add(column, operator, value, true);
    }
    /**
     * Serialize all conditions into the comma-separated (AND) filter string.
     *
     * Conditions are joined by commas, which the server applies as `AND`. A scalar
     * value (or single `in` element) that contains a reserved character — `,`,
     * `(`, `)`, `"`, `\` — or surrounding whitespace is double-quoted and escaped
     * the way PostgREST does, so commas inside a value are preserved rather than
     * read as a condition boundary.
     */ build() {
        return this.filters.join(',');
    }
    /** Alias for {@link build}; lets the builder be used wherever a string is expected. */ toString() {
        return this.build();
    }
}
const $5df1589fb85aee8e$export$5593ed1d7e2258df = ()=>new $5df1589fb85aee8e$export$d9444c8f5fdca28();

});


parcelRegister("5LfGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $431d82cf616a1085$export$2e2bcd8739ae039);

var $bg1V2 = parcelRequire("bg1V2");

var $5ssGf = parcelRequire("5ssGf");
class $431d82cf616a1085$export$2e2bcd8739ae039 {
    constructor(endPoint, options){
        this.socket = new (0, $bg1V2.Socket)(endPoint, options);
    }
    get timeout() {
        return this.socket.timeout;
    }
    get endPoint() {
        return this.socket.endPoint;
    }
    get transport() {
        return this.socket.transport;
    }
    get heartbeatIntervalMs() {
        return this.socket.heartbeatIntervalMs;
    }
    get heartbeatCallback() {
        return this.socket.heartbeatCallback;
    }
    set heartbeatCallback(callback) {
        this.socket.heartbeatCallback = callback;
    }
    get heartbeatTimer() {
        return this.socket.heartbeatTimer;
    }
    get pendingHeartbeatRef() {
        return this.socket.pendingHeartbeatRef;
    }
    get reconnectTimer() {
        return this.socket.reconnectTimer;
    }
    get vsn() {
        return this.socket.vsn;
    }
    get encode() {
        return this.socket.encode;
    }
    get decode() {
        return this.socket.decode;
    }
    get reconnectAfterMs() {
        return this.socket.reconnectAfterMs;
    }
    get sendBuffer() {
        return this.socket.sendBuffer;
    }
    get stateChangeCallbacks() {
        return this.socket.stateChangeCallbacks;
    }
    connect() {
        this.socket.connect();
    }
    disconnect(callback, code, reason, timeout = 10000) {
        return new Promise((resolve)=>{
            setTimeout(()=>resolve('timeout'), timeout);
            this.socket.disconnect(()=>{
                callback();
                resolve('ok');
            }, code, reason);
        });
    }
    push(data) {
        this.socket.push(data);
    }
    log(kind, msg, data) {
        this.socket.log(kind, msg, data);
    }
    hasLogger() {
        return this.socket.hasLogger();
    }
    makeRef() {
        return this.socket.makeRef();
    }
    onOpen(callback) {
        this.socket.onOpen(callback);
    }
    onClose(callback) {
        this.socket.onClose(callback);
    }
    onError(callback) {
        this.socket.onError(callback);
    }
    onMessage(callback) {
        this.socket.onMessage(callback);
    }
    isConnected() {
        return this.socket.isConnected();
    }
    isConnecting() {
        return this.socket.connectionState() == (0, $5ssGf.CONNECTION_STATE).connecting;
    }
    isDisconnecting() {
        return this.socket.connectionState() == (0, $5ssGf.CONNECTION_STATE).closing;
    }
    connectionState() {
        // @ts-ignore - requires better typing and exposing type in phoenix
        return this.socket.connectionState();
    }
    endPointURL() {
        return this.socket.endPointURL();
    }
    sendHeartbeat() {
        this.socket.sendHeartbeat();
    }
    /**
     * @internal
     */ getSocket() {
        return this.socket;
    }
}

});



parcelRegister("5vrbO", function(module, exports) {

$parcel$export(module.exports, "StorageClient", () => $5463fd799def149c$export$6c85f5032e75eff9);

var $8HKWF = parcelRequire("8HKWF");

var $7sTYS = parcelRequire("7sTYS");
var $5463fd799def149c$require$Buffer = $7sTYS.Buffer;
//#region \0@oxc-project+runtime@0.103.0/helpers/typeof.js
function $5463fd799def149c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5463fd799def149c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o$1) {
        return typeof o$1;
    } : function(o$1) {
        return o$1 && "function" == typeof Symbol && o$1.constructor === Symbol && o$1 !== Symbol.prototype ? "symbol" : typeof o$1;
    }, $5463fd799def149c$var$_typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/toPrimitive.js
function $5463fd799def149c$var$toPrimitive(t, r) {
    if ("object" != $5463fd799def149c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5463fd799def149c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/toPropertyKey.js
function $5463fd799def149c$var$toPropertyKey(t) {
    var i = $5463fd799def149c$var$toPrimitive(t, "string");
    return "symbol" == $5463fd799def149c$var$_typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/defineProperty.js
function $5463fd799def149c$var$_defineProperty(e, r, t) {
    return (r = $5463fd799def149c$var$toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.103.0/helpers/objectSpread2.js
function $5463fd799def149c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r$1) {
            return Object.getOwnPropertyDescriptor(e, r$1).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5463fd799def149c$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5463fd799def149c$var$ownKeys(Object(t), !0).forEach(function(r$1) {
            $5463fd799def149c$var$_defineProperty(e, r$1, t[r$1]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5463fd799def149c$var$ownKeys(Object(t)).forEach(function(r$1) {
            Object.defineProperty(e, r$1, Object.getOwnPropertyDescriptor(t, r$1));
        });
    }
    return e;
}
//#endregion
//#region src/lib/common/errors.ts
/**
* Base error class for all Storage errors
* Supports both 'storage' and 'vectors' namespaces
*/ var $5463fd799def149c$export$697502632950e9d3 = class extends Error {
    constructor(message, namespace = "storage", status, statusCode){
        super(message);
        this.__isStorageError = true;
        this.namespace = namespace;
        this.name = namespace === "vectors" ? "StorageVectorsError" : "StorageError";
        this.status = status;
        this.statusCode = statusCode;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            statusCode: this.statusCode
        };
    }
};
/**
* Type guard to check if an error is a StorageError
* @param error - The error to check
* @returns True if the error is a StorageError
*/ function $5463fd799def149c$export$5a322e77e5eb0561(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
/**
* API error returned from Storage service
* Includes HTTP status code and service-specific error code
*/ var $5463fd799def149c$export$ca9ecfd959b3871c = class extends $5463fd799def149c$export$697502632950e9d3 {
    constructor(message, status, statusCode, namespace = "storage", code){
        super(message, namespace, status, statusCode);
        this.name = namespace === "vectors" ? "StorageVectorsApiError" : "StorageApiError";
        this.status = status;
        this.statusCode = statusCode;
        this.code = code;
    }
    toJSON() {
        return $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, super.toJSON()), {}, {
            code: this.code
        });
    }
};
/**
* Unknown error that doesn't match expected error patterns
* Wraps the original error for debugging
*/ var $5463fd799def149c$export$29127ca2e1a271d = class extends $5463fd799def149c$export$697502632950e9d3 {
    constructor(message, originalError, namespace = "storage"){
        super(message, namespace);
        this.name = namespace === "vectors" ? "StorageVectorsUnknownError" : "StorageUnknownError";
        this.originalError = originalError;
    }
};
/**
* @deprecated Use StorageError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $5463fd799def149c$export$92ae90d5da46e8c0 = class extends $5463fd799def149c$export$697502632950e9d3 {
    constructor(message){
        super(message, "vectors");
    }
};
/**
* Type guard to check if an error is a StorageVectorsError
* @param error - The error to check
* @returns True if the error is a StorageVectorsError
*/ function $5463fd799def149c$export$95bc534aa9e6b2f1(error) {
    return $5463fd799def149c$export$5a322e77e5eb0561(error) && error["namespace"] === "vectors";
}
/**
* @deprecated Use StorageApiError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $5463fd799def149c$export$22e4871ee01e8e3f = class extends $5463fd799def149c$export$ca9ecfd959b3871c {
    constructor(message, status, statusCode){
        super(message, status, statusCode, "vectors");
    }
};
/**
* @deprecated Use StorageUnknownError with namespace='vectors' instead
* Alias for backward compatibility with existing vector storage code
*/ var $5463fd799def149c$export$26d7e1f64f113285 = class extends $5463fd799def149c$export$29127ca2e1a271d {
    constructor(message, originalError){
        super(message, originalError, "vectors");
    }
};
/**
* Error codes specific to S3 Vectors API
* Maps AWS service errors to application-friendly error codes
*/ let $5463fd799def149c$export$2f60cecd2e35a5da = /* @__PURE__ */ function(StorageVectorsErrorCode$1) {
    /** Internal server fault (HTTP 500) */ StorageVectorsErrorCode$1["InternalError"] = "InternalError";
    /** Resource already exists / conflict (HTTP 409) */ StorageVectorsErrorCode$1["S3VectorConflictException"] = "S3VectorConflictException";
    /** Resource not found (HTTP 404) */ StorageVectorsErrorCode$1["S3VectorNotFoundException"] = "S3VectorNotFoundException";
    /** Delete bucket while not empty (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorBucketNotEmpty"] = "S3VectorBucketNotEmpty";
    /** Exceeds bucket quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxBucketsExceeded"] = "S3VectorMaxBucketsExceeded";
    /** Exceeds index quota/limit (HTTP 400) */ StorageVectorsErrorCode$1["S3VectorMaxIndexesExceeded"] = "S3VectorMaxIndexesExceeded";
    return StorageVectorsErrorCode$1;
}({});
//#endregion
//#region src/lib/common/headers.ts
/**
* Sets a header with case-insensitive deduplication.
* Removes any existing headers whose name matches (case-insensitive),
* then sets the value under the lowercase key. Does not mutate the input object.
*
* @param headers - Existing headers object
* @param name - Header name to set (stored as lowercase)
* @param value - Header value
* @returns New headers object with the header set
*/ function $5463fd799def149c$var$setHeader(headers, name, value) {
    const result = $5463fd799def149c$var$_objectSpread2({}, headers);
    const nameLower = name.toLowerCase();
    for (const key of Object.keys(result))if (key.toLowerCase() === nameLower) delete result[key];
    result[nameLower] = value;
    return result;
}
/**
* Normalizes all header keys to lowercase with case-insensitive deduplication.
* When duplicate keys exist (differing only in case), the last value wins.
* Does not mutate the input object.
*
* @param headers - Headers object to normalize
* @returns New headers object with all keys lowercased
*/ function $5463fd799def149c$var$normalizeHeaders(headers) {
    const result = {};
    for (const [key, value] of Object.entries(headers))result[key.toLowerCase()] = value;
    return result;
}
//#endregion
//#region src/lib/common/helpers.ts
/**
* Resolves the fetch implementation to use
* Uses custom fetch if provided, otherwise uses native fetch
*
* @param customFetch - Optional custom fetch implementation
* @returns Resolved fetch function
*/ const $5463fd799def149c$var$resolveFetch = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
/**
* Determine if input is a plain object
* An object is plain if it's created by either {}, new Object(), or Object.create(null)
*
* @param value - Value to check
* @returns True if value is a plain object
* @source https://github.com/sindresorhus/is-plain-obj
*/ const $5463fd799def149c$var$isPlainObject = (value)=>{
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};
/**
* Recursively converts object keys from snake_case to camelCase
* Used for normalizing API responses
*
* @param item - Object to convert
* @returns Converted object with camelCase keys
*/ const $5463fd799def149c$var$recursiveToCamel = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>$5463fd799def149c$var$recursiveToCamel(el));
    else if (typeof item === "function" || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ""));
        result[newKey] = $5463fd799def149c$var$recursiveToCamel(value);
    });
    return result;
};
/**
* Validates if a given bucket name is valid according to Supabase Storage API rules
* Mirrors backend validation from: storage/src/storage/limits.ts:isValidBucketName()
*
* Rules:
* - Length: 1-100 characters
* - Allowed characters: alphanumeric (a-z, A-Z, 0-9), underscore (_), and safe special characters
* - Safe special characters: ! - . * ' ( ) space & $ @ = ; : + , ?
* - Forbidden: path separators (/, \), path traversal (..), leading/trailing whitespace
*
* AWS S3 Reference: https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html
*
* @param bucketName - The bucket name to validate
* @returns true if valid, false otherwise
*/ const $5463fd799def149c$var$isValidBucketName = (bucketName)=>{
    if (!bucketName || typeof bucketName !== "string") return false;
    if (bucketName.length === 0 || bucketName.length > 100) return false;
    if (bucketName.trim() !== bucketName) return false;
    if (bucketName.includes("/") || bucketName.includes("\\")) return false;
    return /^[\w!.\*'() &$@=;:+,?-]+$/.test(bucketName);
};
/**
* Percent-encodes each segment of a storage path so URL delimiters within a
* key (e.g. `?`, `#`) can't be interpreted as a querystring/fragment start.
*
* Splits on `/` so real path separators stay literal — the storage server
* routes on them and decodes each segment back to the original key.
*
* @param path - A bucket id or `bucketId/objectKey` path
* @returns The path with each `/`-delimited segment percent-encoded
*/ const $5463fd799def149c$var$encodeStoragePath = (path)=>path.split("/").map(encodeURIComponent).join("/");
//#endregion
//#region src/lib/common/fetch.ts
/**
* Extracts error message from various error response formats
* @param err - Error object from API
* @returns Human-readable error message
*/ const $5463fd799def149c$var$_getErrorMessage = (err)=>{
    if (typeof err === "object" && err !== null) {
        const e = err;
        if (typeof e.msg === "string") return e.msg;
        if (typeof e.message === "string") return e.message;
        if (typeof e.error_description === "string") return e.error_description;
        if (typeof e.error === "string") return e.error;
        if (typeof e.error === "object" && e.error !== null) {
            const nested = e.error;
            if (typeof nested.message === "string") return nested.message;
        }
    }
    return JSON.stringify(err);
};
/**
* Handles fetch errors and converts them to Storage error types
* @param error - The error caught from fetch
* @param reject - Promise rejection function
* @param options - Fetch options that may affect error handling
* @param namespace - Error namespace ('storage' or 'vectors')
*/ const $5463fd799def149c$var$handleError = async (error, reject, options, namespace)=>{
    if (error !== null && typeof error === "object" && "json" in error && typeof error.json === "function") {
        const responseError = error;
        let status = parseInt(String(responseError.status), 10);
        if (!Number.isFinite(status)) status = 500;
        responseError.json().then((err)=>{
            const statusCode = (err === null || err === void 0 ? void 0 : err.statusCode) || (err === null || err === void 0 ? void 0 : err.code) || status + "";
            reject(new $5463fd799def149c$export$ca9ecfd959b3871c($5463fd799def149c$var$_getErrorMessage(err), status, statusCode, namespace, err === null || err === void 0 ? void 0 : err.code));
        }).catch(()=>{
            const statusCode = status + "";
            reject(new $5463fd799def149c$export$ca9ecfd959b3871c(responseError.statusText || `HTTP ${status} error`, status, statusCode, namespace));
        });
    } else reject(new $5463fd799def149c$export$29127ca2e1a271d($5463fd799def149c$var$_getErrorMessage(error), error, namespace));
};
/**
* Builds request parameters for fetch calls
* @param method - HTTP method
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters like AbortSignal
* @param body - Request body (will be JSON stringified if plain object)
* @returns Complete fetch request parameters
*/ const $5463fd799def149c$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET" || method === "HEAD" || !body) return $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, params), parameters);
    if ($5463fd799def149c$var$isPlainObject(body)) {
        var _contentType;
        const headers = (options === null || options === void 0 ? void 0 : options.headers) || {};
        let contentType;
        for (const [key, value] of Object.entries(headers))if (key.toLowerCase() === "content-type") contentType = value;
        params.headers = $5463fd799def149c$var$setHeader(headers, "Content-Type", (_contentType = contentType) !== null && _contentType !== void 0 ? _contentType : "application/json");
        params.body = JSON.stringify(body);
    } else params.body = body;
    if (options === null || options === void 0 ? void 0 : options.duplex) params.duplex = options.duplex;
    return $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, params), parameters);
};
/**
* Internal request handler that wraps fetch with error handling
* @param fetcher - Fetch function to use
* @param method - HTTP method
* @param url - Request URL
* @param options - Custom fetch options
* @param parameters - Additional fetch parameters
* @param body - Request body
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Promise with parsed response or error
*/ async function $5463fd799def149c$var$_handleRequest(fetcher, method, url, options, parameters, body, namespace) {
    return new Promise((resolve, reject)=>{
        fetcher(url, $5463fd799def149c$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
            if (!result.ok) throw result;
            if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
            if (namespace === "vectors") {
                const contentType = result.headers.get("content-type");
                if (result.headers.get("content-length") === "0" || result.status === 204) return {};
                if (!contentType || !contentType.includes("application/json")) return {};
            }
            return result.json();
        }).then((data)=>resolve(data)).catch((error)=>$5463fd799def149c$var$handleError(error, reject, options, namespace));
    });
}
/**
* Creates a fetch API with the specified namespace
* @param namespace - Error namespace ('storage' or 'vectors')
* @returns Object with HTTP method functions
*/ function $5463fd799def149c$var$createFetchApi(namespace = "storage") {
    return {
        get: async (fetcher, url, options, parameters)=>{
            return $5463fd799def149c$var$_handleRequest(fetcher, "GET", url, options, parameters, void 0, namespace);
        },
        post: async (fetcher, url, body, options, parameters)=>{
            return $5463fd799def149c$var$_handleRequest(fetcher, "POST", url, options, parameters, body, namespace);
        },
        put: async (fetcher, url, body, options, parameters)=>{
            return $5463fd799def149c$var$_handleRequest(fetcher, "PUT", url, options, parameters, body, namespace);
        },
        head: async (fetcher, url, options, parameters)=>{
            return $5463fd799def149c$var$_handleRequest(fetcher, "HEAD", url, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
                noResolveJson: true
            }), parameters, void 0, namespace);
        },
        remove: async (fetcher, url, body, options, parameters)=>{
            return $5463fd799def149c$var$_handleRequest(fetcher, "DELETE", url, options, parameters, body, namespace);
        }
    };
}
const $5463fd799def149c$var$defaultApi = $5463fd799def149c$var$createFetchApi("storage");
const { get: $5463fd799def149c$var$get, post: $5463fd799def149c$var$post, put: $5463fd799def149c$var$put, head: $5463fd799def149c$var$head, remove: $5463fd799def149c$var$remove } = $5463fd799def149c$var$defaultApi;
const $5463fd799def149c$var$vectorsApi = $5463fd799def149c$var$createFetchApi("vectors");
//#endregion
//#region src/lib/common/BaseApiClient.ts
/**
* @ignore
* Base API client class for all Storage API classes
* Provides common infrastructure for error handling and configuration
*
* @typeParam TError - The error type (StorageError or subclass)
*/ var $5463fd799def149c$var$BaseApiClient = class {
    /**
	* Creates a new BaseApiClient instance
	* @param url - Base URL for API requests
	* @param headers - Default headers for API requests
	* @param fetch - Optional custom fetch implementation
	* @param namespace - Error namespace ('storage' or 'vectors')
	*/ constructor(url, headers = {}, fetch$1, namespace = "storage"){
        this.shouldThrowOnError = false;
        this.url = url;
        this.headers = $5463fd799def149c$var$normalizeHeaders(headers);
        this.fetch = $5463fd799def149c$var$resolveFetch(fetch$1);
        this.namespace = namespace;
    }
    /**
	* Enable throwing errors instead of returning them.
	* When enabled, errors are thrown instead of returned in { data, error } format.
	*
	* @returns this - For method chaining
	*/ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
	* Set an HTTP header for the request.
	* Creates a shallow copy of headers to avoid mutating shared state.
	*
	* @param name - Header name
	* @param value - Header value
	* @returns this - For method chaining
	*/ setHeader(name, value) {
        this.headers = $5463fd799def149c$var$setHeader(this.headers, name, value);
        return this;
    }
    /**
	* Handles API operation with standardized error handling
	* Eliminates repetitive try-catch blocks across all API methods
	*
	* This wrapper:
	* 1. Executes the operation
	* 2. Returns { data, error: null } on success
	* 3. Returns { data: null, error } on failure (if shouldThrowOnError is false)
	* 4. Throws error on failure (if shouldThrowOnError is true)
	*
	* @typeParam T - The expected data type from the operation
	* @param operation - Async function that performs the API call
	* @returns Promise with { data, error } tuple
	*
	* @example Handling an operation
	* ```typescript
	* async listBuckets() {
	*   return this.handleOperation(async () => {
	*     return await get(this.fetch, `${this.url}/bucket`, {
	*       headers: this.headers,
	*     })
	*   })
	* }
	* ```
	*/ async handleOperation(operation) {
        var _this = this;
        try {
            return {
                data: await operation(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($5463fd799def149c$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StreamDownloadBuilder.ts
let $5463fd799def149c$var$_Symbol$toStringTag$1;
$5463fd799def149c$var$_Symbol$toStringTag$1 = Symbol.toStringTag;
var $5463fd799def149c$var$StreamDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
        this[$5463fd799def149c$var$_Symbol$toStringTag$1] = "StreamDownloadBuilder";
        this.promise = null;
    }
    then(onfulfilled, onrejected) {
        return this.getPromise().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.getPromise().catch(onrejected);
    }
    finally(onfinally) {
        return this.getPromise().finally(onfinally);
    }
    getPromise() {
        if (!this.promise) this.promise = this.execute();
        return this.promise;
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: (await _this.downloadFn()).body,
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($5463fd799def149c$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/BlobDownloadBuilder.ts
let $5463fd799def149c$var$_Symbol$toStringTag;
$5463fd799def149c$var$_Symbol$toStringTag = Symbol.toStringTag;
var $5463fd799def149c$var$BlobDownloadBuilder = class {
    constructor(downloadFn, shouldThrowOnError){
        this.downloadFn = downloadFn;
        this.shouldThrowOnError = shouldThrowOnError;
        this[$5463fd799def149c$var$_Symbol$toStringTag] = "BlobDownloadBuilder";
        this.promise = null;
    }
    asStream() {
        return new $5463fd799def149c$var$StreamDownloadBuilder(this.downloadFn, this.shouldThrowOnError);
    }
    then(onfulfilled, onrejected) {
        return this.getPromise().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.getPromise().catch(onrejected);
    }
    finally(onfinally) {
        return this.getPromise().finally(onfinally);
    }
    getPromise() {
        if (!this.promise) this.promise = this.execute();
        return this.promise;
    }
    async execute() {
        var _this = this;
        try {
            return {
                data: await (await _this.downloadFn()).blob(),
                error: null
            };
        } catch (error) {
            if (_this.shouldThrowOnError) throw error;
            if ($5463fd799def149c$export$5a322e77e5eb0561(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
};
//#endregion
//#region src/packages/StorageFileApi.ts
const $5463fd799def149c$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
const $5463fd799def149c$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
var $5463fd799def149c$var$StorageFileApi = class extends $5463fd799def149c$var$BaseApiClient {
    constructor(url, headers = {}, bucketId, fetch$1){
        super(url, headers, fetch$1, "storage");
        this.bucketId = bucketId;
    }
    /**
	* Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
	*
	* @param method HTTP method.
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	*/ async uploadOrUpdate(method, path, fileBody, fileOptions) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            let body;
            const options = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, _this.headers), method === "POST" && {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob || typeof FormData !== "undefined" && fileBody instanceof FormData) body = _this.prepareUploadFormData(fileBody, options);
            else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (options.contentEncoding) headers["content-encoding"] = options.contentEncoding;
                if (metadata) headers["x-metadata"] = _this.toBase64(_this.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value] of Object.entries(fileOptions.headers))headers = $5463fd799def149c$var$setHeader(headers, key, value);
            const cleanPath = _this._removeEmptyFolders(path);
            const _path = _this._getFinalPath(cleanPath);
            const data = await (method == "PUT" ? $5463fd799def149c$var$put : $5463fd799def149c$var$post)(_this.fetch, `${_this.url}/object/${_path}`, body, $5463fd799def149c$var$_objectSpread2({
                headers: headers
            }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                duplex: options.duplex
            } : {}));
            return {
                path: cleanPath,
                id: data.Id,
                fullPath: data.Key
            };
        });
    }
    /**
	* Uploads a file to an existing bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, contentEncoding, upsert, and metadata.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Upload file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600',
	*     upsert: false
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Upload file using `ArrayBuffer` from base64 file data
	* ```js
	* import { decode } from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @example Handling errors
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .upload('public/avatar1.png', avatarFile)
	*
	* if (error) {
	*   // Log the full error so fields like `statusCode` and `error` (the
	*   // Storage error name, e.g. "Duplicate") aren't hidden behind `error.message`.
	*   console.error(error)
	*   return
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: only `insert` when you are uploading new files and `select`, `insert` and `update` when you are upserting files
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Upload file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async upload(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
    }
    /**
	* Upload a file with a token generated from `createSignedUploadUrl`.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
	* @param token The token generated from `createSignedUploadUrl`
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions HTTP headers (cacheControl, contentType, contentEncoding, etc.).
	* **Note:** The `upsert` option has no effect here. To enable upsert behavior,
	* pass `{ upsert: true }` when calling `createSignedUploadUrl()` instead.
	* @returns Promise with response containing file path and fullPath or error
	*
	* @example Upload to a signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .uploadToSignedUrl('folder/cat.jpg', 'token-from-createSignedUploadUrl', file)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "folder/cat.jpg",
	*     "fullPath": "avatars/folder/cat.jpg"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async uploadToSignedUrl(path, token, fileBody, fileOptions) {
        var _this3 = this;
        const cleanPath = _this3._removeEmptyFolders(path);
        const _path = _this3._getFinalPath(cleanPath);
        const url = new URL(_this3.url + `/object/upload/sign/${_path}`);
        url.searchParams.set("token", token);
        return _this3.handleOperation(async ()=>{
            let body;
            const options = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_FILE_OPTIONS), fileOptions);
            let headers = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, _this3.headers), {
                "x-upsert": String(options.upsert)
            });
            const metadata = options.metadata;
            if (typeof Blob !== "undefined" && fileBody instanceof Blob || typeof FormData !== "undefined" && fileBody instanceof FormData) body = _this3.prepareUploadFormData(fileBody, options);
            else {
                body = fileBody;
                headers["cache-control"] = `max-age=${options.cacheControl}`;
                headers["content-type"] = options.contentType;
                if (options.contentEncoding) headers["content-encoding"] = options.contentEncoding;
                if (metadata) headers["x-metadata"] = _this3.toBase64(_this3.encodeMetadata(metadata));
                if ((typeof ReadableStream !== "undefined" && body instanceof ReadableStream || body && typeof body === "object" && "pipe" in body && typeof body.pipe === "function") && !options.duplex) options.duplex = "half";
            }
            if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) for (const [key, value] of Object.entries(fileOptions.headers))headers = $5463fd799def149c$var$setHeader(headers, key, value);
            return {
                path: cleanPath,
                fullPath: (await $5463fd799def149c$var$put(_this3.fetch, url.toString(), body, $5463fd799def149c$var$_objectSpread2({
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}))).Key
            };
        });
    }
    /**
	* Creates a signed upload URL.
	* Signed upload URLs can be used to upload files to the bucket without further authentication.
	* They are valid for 2 hours.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param options.upsert If set to true, allows the file to be overwritten if it already exists.
	* @returns Promise with response containing signed upload URL, token, and path or error
	*
	* @example Create Signed Upload URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUploadUrl('folder/cat.jpg')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/upload/sign/avatars/folder/cat.jpg?token=<TOKEN>",
	*     "path": "folder/cat.jpg",
	*     "token": "<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUploadUrl(path, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            let _path = _this4._getFinalPath(path);
            const headers = $5463fd799def149c$var$_objectSpread2({}, _this4.headers);
            if (options === null || options === void 0 ? void 0 : options.upsert) headers["x-upsert"] = "true";
            const data = await $5463fd799def149c$var$post(_this4.fetch, `${_this4.url}/object/upload/sign/${_path}`, {}, {
                headers: headers
            });
            const url = new URL(_this4.url + data.url);
            const token = url.searchParams.get("token");
            if (!token) throw new $5463fd799def149c$export$697502632950e9d3("No token returned by API");
            return {
                signedUrl: url.toString(),
                path: path,
                token: token
            };
        });
    }
    /**
	* Replaces an existing file at the specified path with a new one.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
	* @param fileBody The body of the file to be stored in the bucket.
	* @param fileOptions Optional file upload options including cacheControl, contentType, contentEncoding, and metadata.
	* **Note:** The `upsert` option has no effect here. `update()` always replaces the
	* file at the given path, so the `x-upsert` header is not sent. To control upsert
	* behavior, use `upload()` instead.
	* @returns Promise with response containing file path, id, and fullPath or error
	*
	* @example Update file
	* ```js
	* const avatarFile = event.target.files[0]
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', avatarFile, {
	*     cacheControl: '3600'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "public/avatar1.png",
	*     "fullPath": "avatars/public/avatar1.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Update file using `ArrayBuffer` from base64 file data
	* ```js
	* import {decode} from 'base64-arraybuffer'
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .update('public/avatar1.png', decode('base64FileData'), {
	*     contentType: 'image/png'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - `update()` always replaces the file at the given path regardless of the `upsert` option.
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	* - For React Native, using either `Blob`, `File` or `FormData` does not work as intended. Update file using `ArrayBuffer` from base64 file data instead, see example below.
	*/ async update(path, fileBody, fileOptions) {
        return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
    }
    /**
	* Moves an existing file to a new path in the same bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
	* @param options The destination options.
	* @param options.sourceVersionId The version id of the source object to move.
	* @returns Promise with response containing success message or error
	*
	* @example Move file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .move('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully moved"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `update` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async move(fromPath, toPath, options) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $5463fd799def149c$var$post(_this6.fetch, `${_this6.url}/object/move`, {
                bucketId: _this6.bucketId,
                sourceKey: fromPath,
                destinationKey: toPath,
                destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket,
                sourceVersionId: options === null || options === void 0 ? void 0 : options.sourceVersionId
            }, {
                headers: _this6.headers
            });
        });
    }
    /**
	* Copies an existing file to a new path in the same bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param fromPath The original file path, including the current file name. For example `folder/image.png`.
	* @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
	* @param options The destination and metadata options.
	* @param options.sourceVersionId The version id of the source object to copy.
	* @param options.copyMetadata Whether to copy the source metadata. Defaults to true. Set to false to apply metadata overrides; custom user metadata is not copied when false.
	* @param options.metadata File metadata overrides, applied only when copyMetadata is false. Unspecified fields retain their source values.
	* @returns Promise with response containing copied file path or error
	*
	* @example Copy file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .copy('public/avatar1.png', 'private/avatar2.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "path": "avatars/private/avatar2.png"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Copy file with content encoding
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('documents')
	*   .copy('source.txt.gz', 'copy.txt.gz', {
	*     copyMetadata: false,
	*     metadata: { contentEncoding: 'gzip' },
	*   })
	* ```
	* The source must already contain gzip-encoded bytes. Copying changes metadata only.
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `insert` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async copy(fromPath, toPath, options) {
        var _this7 = this;
        return _this7.handleOperation(async ()=>{
            const copyOptions = options;
            return {
                path: (await $5463fd799def149c$var$post(_this7.fetch, `${_this7.url}/object/copy`, {
                    bucketId: _this7.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket,
                    sourceVersionId: options === null || options === void 0 ? void 0 : options.sourceVersionId,
                    copyMetadata: typeof (copyOptions === null || copyOptions === void 0 ? void 0 : copyOptions.copyMetadata) === "boolean" ? copyOptions.copyMetadata : void 0,
                    metadata: (copyOptions === null || copyOptions === void 0 ? void 0 : copyOptions.copyMetadata) === false ? copyOptions.metadata : void 0
                }, {
                    headers: _this7.headers
                })).Key
            };
        });
    }
    /**
	* Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the current file name. For example `folder/image.png`.
	* @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @param options.versionId Create a signed URL for a specific object version rather than the current one.
	* @returns Promise with response containing signed URL or error
	*
	* @example Create Signed URL
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @example Create a signed URL for an asset with transformations
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Create a signed URL which triggers the download of the asset
	* ```js
	* const { data } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrl('folder/avatar1.png', 60, {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrl(path, expiresIn, options) {
        var _this8 = this;
        return _this8.handleOperation(async ()=>{
            let _path = _this8._getFinalPath(path);
            const hasTransform = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0;
            let data = await $5463fd799def149c$var$post(_this8.fetch, `${_this8.url}/object/sign/${_path}`, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({
                expiresIn: expiresIn
            }, hasTransform ? {
                transform: options.transform
            } : {}), (options === null || options === void 0 ? void 0 : options.versionId) != null ? {
                versionId: options.versionId
            } : {}), {
                headers: _this8.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return {
                signedUrl: encodeURI(`${_this8.url}${data.signedURL}${queryString ? `&${queryString}` : ""}`)
            };
        });
    }
    /**
	* Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
	* @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
	* @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @returns Promise with response containing array of objects with signedUrl, path, and error or error
	*
	* @example Create Signed URLs
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .createSignedUrls(['folder/avatar1.png', 'folder/avatar2.png'], 60)
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "error": null,
	*       "path": "folder/avatar1.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar1.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar1.png?token=<TOKEN>"
	*     },
	*     {
	*       "error": null,
	*       "path": "folder/avatar2.png",
	*       "signedURL": "/object/sign/avatars/folder/avatar2.png?token=<TOKEN>",
	*       "signedUrl": "https://example.supabase.co/storage/v1/object/sign/avatars/folder/avatar2.png?token=<TOKEN>"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createSignedUrls(paths, expiresIn, options) {
        var _this9 = this;
        return _this9.handleOperation(async ()=>{
            const data = await $5463fd799def149c$var$post(_this9.fetch, `${_this9.url}/object/sign/${_this9.bucketId}`, {
                expiresIn: expiresIn,
                paths: paths
            }, {
                headers: _this9.headers
            });
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
            if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
            const queryString = query.toString();
            return data.map((datum)=>$5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, datum), {}, {
                    signedUrl: datum.signedURL ? encodeURI(`${_this9.url}${datum.signedURL}${queryString ? `&${queryString}` : ""}`) : null
                }));
        });
    }
    /**
	* Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
	* @param options Optional settings: `transform` to transform the asset before serving it to the client, `cacheNonce` to append a cache nonce parameter to the URL to invalidate the cache, and `versionId` to download a specific object version.
	* @param parameters Additional fetch parameters like signal for cancellation. Supports standard fetch options including cache control.
	* @returns BlobDownloadBuilder instance for downloading the file
	*
	* @example Download file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": <BLOB>,
	*   "error": null
	* }
	* ```
	*
	* @example Download file with transformations
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*       quality: 80
	*     }
	*   })
	* ```
	*
	* @example Download with cache control (useful in Edge Functions)
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { cache: 'no-store' })
	* ```
	*
	* @example Download with abort signal
	* ```js
	* const controller = new AbortController()
	* setTimeout(() => controller.abort(), 5000)
	*
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .download('folder/avatar1.png', {}, { signal: controller.signal })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ download(path, options, parameters) {
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image/authenticated" : "object";
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        if ((options === null || options === void 0 ? void 0 : options.versionId) != null) query.set("versionId", String(options.versionId));
        const queryString = query.toString();
        const _path = this._getFinalPath(path);
        const downloadFn = ()=>$5463fd799def149c$var$get(this.fetch, `${this.url}/${renderPath}/${_path}${queryString ? `?${queryString}` : ""}`, {
                headers: this.headers,
                noResolveJson: true
            }, parameters);
        return new $5463fd799def149c$var$BlobDownloadBuilder(downloadFn, this.shouldThrowOnError);
    }
    /**
	* Retrieves the details of an existing file.
	*
	* Returns detailed file metadata including size, content type, and timestamps.
	* Note: The API returns `last_modified` field, not `updated_at`.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @param options Optional settings, including `versionId` to retrieve a specific object version.
	* @returns Promise with response containing file metadata or error
	*
	* @example Get file info
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .info('folder/avatar1.png')
	*
	* if (data) {
	*   console.log('Last modified:', data.lastModified)
	*   console.log('Size:', data.size)
	* }
	* ```
	*/ async info(path, options) {
        var _this10 = this;
        const _path = _this10._getFinalPath(path);
        const query = new URLSearchParams();
        if ((options === null || options === void 0 ? void 0 : options.versionId) != null) query.set("versionId", String(options.versionId));
        const queryString = query.toString();
        return _this10.handleOperation(async ()=>{
            return $5463fd799def149c$var$recursiveToCamel(await $5463fd799def149c$var$get(_this10.fetch, `${_this10.url}/object/info/${_path}${queryString ? `?${queryString}` : ""}`, {
                headers: _this10.headers
            }));
        });
    }
    /**
	* Checks the existence of a file.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The file path, including the file name. For example `folder/image.png`.
	* @returns Promise with response containing boolean indicating file existence or error
	*
	* @example Check file existence
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .exists('folder/avatar1.png')
	* ```
	*/ async exists(path) {
        var _this11 = this;
        const _path = _this11._getFinalPath(path);
        try {
            await $5463fd799def149c$var$head(_this11.fetch, `${_this11.url}/object/${_path}`, {
                headers: _this11.headers
            });
            return {
                data: true,
                error: null
            };
        } catch (error) {
            if (_this11.shouldThrowOnError) throw error;
            if ($5463fd799def149c$export$5a322e77e5eb0561(error)) {
                var _error$originalError;
                const status = error instanceof $5463fd799def149c$export$ca9ecfd959b3871c ? error.status : error instanceof $5463fd799def149c$export$29127ca2e1a271d ? (_error$originalError = error.originalError) === null || _error$originalError === void 0 ? void 0 : _error$originalError.status : void 0;
                if (status !== void 0 && [
                    400,
                    404
                ].includes(status)) return {
                    data: false,
                    error: error
                };
            }
            throw error;
        }
    }
    /**
	* A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
	* This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
	* @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
	* @param options.transform Transform the asset before serving it to the client.
	* @param options.cacheNonce Append a cache nonce parameter to the URL to invalidate the cache.
	* @param options.versionId Return the URL for a specific object version rather than the current one.
	* @returns Object with public URL
	*
	* @example Returns the URL for an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "publicUrl": "https://example.supabase.co/storage/v1/object/public/public-bucket/folder/avatar1.png"
	*   }
	* }
	* ```
	*
	* @example Returns the URL for an asset in a public bucket with transformations
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     transform: {
	*       width: 100,
	*       height: 100,
	*     }
	*   })
	* ```
	*
	* @example Returns the URL which triggers the download of an asset in a public bucket
	* ```js
	* const { data } = supabase
	*   .storage
	*   .from('public-bucket')
	*   .getPublicUrl('folder/avatar1.png', {
	*     download: true,
	*   })
	* ```
	*
	* @remarks
	* - The bucket needs to be set to public, either via [updateBucket()](/docs/reference/javascript/storage-updatebucket) or by going to Storage on [supabase.com/dashboard](https://supabase.com/dashboard), clicking the overflow menu on a bucket and choosing "Make public"
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const query = new URLSearchParams();
        if (options === null || options === void 0 ? void 0 : options.download) query.set("download", options.download === true ? "" : options.download);
        if (options === null || options === void 0 ? void 0 : options.transform) this.applyTransformOptsToQuery(query, options.transform);
        if ((options === null || options === void 0 ? void 0 : options.cacheNonce) != null) query.set("cacheNonce", String(options.cacheNonce));
        if ((options === null || options === void 0 ? void 0 : options.versionId) != null) query.set("versionId", String(options.versionId));
        const queryString = query.toString();
        const renderPath = typeof (options === null || options === void 0 ? void 0 : options.transform) === "object" && options.transform !== null && Object.keys(options.transform).length > 0 ? "render/image" : "object";
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}`) + (queryString ? `?${queryString}` : "")
            }
        };
    }
    /**
	* Deletes files within the same bucket
	*
	* Returns an array of FileObject entries for the deleted files. Note that deprecated
	* fields like `bucket_id` may or may not be present in the response - do not rely on them.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param paths An array of files to delete. Each entry is either a path (deletes whichever
	* version is currently at that path, e.g. `'folder/image.png'`), or `{ path, versionId }` to
	* delete an exact version current or archived (e.g. `{ path: 'folder/image.png', versionId: '...' }`).
	* @returns Promise with response containing array of deleted file objects or error
	*
	* @example Delete file
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .remove(['folder/avatar1.png'])
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [],
	*   "error": null
	* }
	* ```
	*
	* @example Delete a specific object version
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .remove([{ path: 'folder/avatar1.png', versionId: 'noncurrent-version-id' }])
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `delete` and `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async remove(paths) {
        var _this12 = this;
        return _this12.handleOperation(async ()=>{
            return await $5463fd799def149c$var$remove(_this12.fetch, `${_this12.url}/object/${_this12.bucketId}`, {
                prefixes: paths
            }, {
                headers: _this12.headers
            });
        });
    }
    /**
	* Purges the CDN cache for a single object in this bucket.
	*
	* Maps to `DELETE /cdn/{bucket}/{path}` on the Storage API. The server
	* issues a CDN invalidation for the object and returns `{ message: 'success' }`.
	*
	* **Requires the `service_role` key.** The underlying endpoint enforces
	* `service_role` JWT — calls made with the anon key or a user JWT will be
	* rejected by the server.
	*
	* **Hosted CDN feature.** On self-hosted Supabase, the Storage service must
	* have `CDN_PURGE_ENDPOINT_URL` configured and the `purgeCache` tenant
	* feature enabled, otherwise the server returns an error.
	*
	* Operates on a single object path. There is no wildcard or recursion: pass
	* the exact path of the object you want invalidated.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The path (relative to the bucket) of the object to purge, e.g. `folder/avatar.png`.
	* @param options Optional purge cache options.
	* @param options.transformations If true, purges only transformations (resized/formatted variants), leaving the original cached file intact.
	* @param parameters Optional fetch parameters such as an `AbortController` signal.
	* @returns Promise with `{ data: { message }, error: null }` on success or `{ data: null, error }` on failure.
	*
	* @example Purge a single cached object
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .purgeCache('folder/avatar1.png')
	* ```
	*
	* @example Purge only transformations for a single object
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .purgeCache('folder/avatar1.png', { transformations: true })
	* ```
	*/ async purgeCache(path, options, parameters) {
        var _this13 = this;
        return _this13.handleOperation(async ()=>{
            const _path = $5463fd799def149c$var$encodeStoragePath(_this13._getFinalPath(path));
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.transformations) query.set("transformations", "true");
            const queryString = query.toString();
            return await $5463fd799def149c$var$remove(_this13.fetch, `${_this13.url}/cdn/${_path}${queryString ? `?${queryString}` : ""}`, {}, {
                headers: _this13.headers
            }, parameters);
        });
    }
    /**
	* Get file metadata
	* @param id the file id to retrieve metadata
	*/ /**
	* Update file metadata
	* @param id the file id to update metadata
	* @param meta the new file metadata
	*/ /**
	* Lists all the files and folders within a path of the bucket.
	*
	* **Important:** For folder entries, fields like `id`, `updated_at`, `created_at`,
	* `last_accessed_at`, and `metadata` will be `null`. Only files have these fields populated.
	* Additionally, deprecated fields like `bucket_id`, `owner`, and `buckets` are NOT returned
	* by this method.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param path The folder path.
	* @param options Search options including limit (defaults to 100), offset, sortBy, and search
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing array of files/folders or error
	*
	* @example List files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*   })
	*
	* // Handle files vs folders
	* data?.forEach(item => {
	*   if (item.id !== null) {
	*     // It's a file
	*     console.log('File:', item.name, 'Size:', item.metadata?.size)
	*   } else {
	*     // It's a folder
	*     console.log('Folder:', item.name)
	*   }
	* })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "avatar1.png",
	*       "id": "e668cf7f-821b-4a2f-9dce-7dfa5dd1cfd2",
	*       "updated_at": "2024-05-22T23:06:05.580Z",
	*       "created_at": "2024-05-22T23:04:34.443Z",
	*       "last_accessed_at": "2024-05-22T23:04:34.443Z",
	*       "metadata": {
	*         "eTag": "\"c5e8c553235d9af30ef4f6e280790b92\"",
	*         "size": 32175,
	*         "mimetype": "image/png",
	*         "cacheControl": "max-age=3600",
	*         "lastModified": "2024-05-22T23:06:05.574Z",
	*         "contentLength": 32175,
	*         "httpStatusCode": 200
	*       }
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @example Search files in a bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .list('folder', {
	*     limit: 100,
	*     offset: 0,
	*     sortBy: { column: 'name', order: 'asc' },
	*     search: 'jon'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: none
	*   - `objects` table permissions: `select`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async list(path, options, parameters) {
        var _this14 = this;
        return _this14.handleOperation(async ()=>{
            const sortBy = (options === null || options === void 0 ? void 0 : options.sortBy) ? $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_SEARCH_OPTIONS.sortBy), options.sortBy) : $5463fd799def149c$var$DEFAULT_SEARCH_OPTIONS.sortBy;
            const body = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_SEARCH_OPTIONS), options), {}, {
                sortBy: sortBy,
                prefix: path || ""
            });
            return await $5463fd799def149c$var$post(_this14.fetch, `${_this14.url}/object/list/${_this14.bucketId}`, body, {
                headers: _this14.headers
            }, parameters);
        });
    }
    /**
	* Lists all the files and folders within a bucket using the V2 API with pagination support.
	*
	* **Important:** Folder entries in the `folders` array only contain `name` and optionally `key` —
	* they have no `id`, timestamps, or `metadata` fields. Full file metadata is only available
	* on entries in the `objects` array.
	*
	* @experimental this method signature might change in the future
	*
	* @category Storage
	* @subcategory File Buckets
	* @param options Search options including prefix, cursor for pagination, limit, with_delimiter
	* @param parameters Optional fetch parameters including signal for cancellation
	* @returns Promise with response containing folders/objects arrays with pagination info or error
	*
	* @example List files with pagination
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .from('avatars')
	*   .listV2({
	*     prefix: 'folder/',
	*     limit: 100,
	*   })
	*
	* // Handle pagination
	* if (data?.hasNext) {
	*   const nextPage = await supabase
	*     .storage
	*     .from('avatars')
	*     .listV2({
	*       prefix: 'folder/',
	*       cursor: data.nextCursor,
	*     })
	* }
	*
	* // Handle files vs folders
	* data?.objects.forEach(file => {
	*   if (file.id !== null) {
	*     console.log('File:', file.name, 'Size:', file.metadata?.size)
	*   }
	* })
	* data?.folders.forEach(folder => {
	*   console.log('Folder:', folder.name)
	* })
	* ```
	*/ async listV2(options, parameters) {
        var _this15 = this;
        return _this15.handleOperation(async ()=>{
            const body = $5463fd799def149c$var$_objectSpread2({}, options);
            return await $5463fd799def149c$var$post(_this15.fetch, `${_this15.url}/object/list-v2/${_this15.bucketId}`, body, {
                headers: _this15.headers
            }, parameters);
        });
    }
    prepareUploadFormData(fileBody, options) {
        const body = new FormData();
        const files = [];
        if (fileBody instanceof FormData) fileBody.forEach((value, name)=>{
            if (typeof value === "string") body.append(name, value);
            else files.push([
                name,
                value
            ]);
        });
        else files.push([
            "",
            fileBody
        ]);
        if (!body.has("cacheControl")) body.append("cacheControl", options.cacheControl);
        if (options.metadata && !body.has("metadata")) body.append("metadata", this.encodeMetadata(options.metadata));
        if (options.contentEncoding && !body.has("contentEncoding")) body.append("contentEncoding", options.contentEncoding);
        for (const [name, file] of files)body.append(name, file);
        return body;
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof $5463fd799def149c$require$Buffer !== "undefined") return $5463fd799def149c$require$Buffer.from(data).toString("base64");
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path.replace(/^\/+/, "")}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    /** Modifies the `query`, appending values the from `transform` */ applyTransformOptsToQuery(query, transform) {
        if (transform.width) query.set("width", transform.width.toString());
        if (transform.height) query.set("height", transform.height.toString());
        if (transform.resize) query.set("resize", transform.resize);
        if (transform.format) query.set("format", transform.format);
        if (transform.quality) query.set("quality", transform.quality.toString());
        return query;
    }
};
//#endregion
//#region src/lib/version.ts
const $5463fd799def149c$var$version = "2.118.0";
//#endregion
//#region src/lib/constants.ts
const $5463fd799def149c$var$DEFAULT_HEADERS = {
    "X-Client-Info": `storage-js/${$5463fd799def149c$var$version}`
};
//#endregion
//#region src/packages/StorageBucketApi.ts
var $5463fd799def149c$var$StorageBucketApi = class extends $5463fd799def149c$var$BaseApiClient {
    constructor(url, headers = {}, fetch$1, opts){
        const baseUrl = new URL(url);
        if (opts === null || opts === void 0 ? void 0 : opts.useNewHostname) {
            if (/supabase\.(co|in|red)$/.test(baseUrl.hostname) && !baseUrl.hostname.includes("storage.supabase.")) baseUrl.hostname = baseUrl.hostname.replace("supabase.", "storage.supabase.");
        }
        const finalUrl = baseUrl.href.replace(/\/$/, "");
        const finalHeaders = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* Retrieves the details of all Storage buckets within an existing project.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('id', 'name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of buckets or error
	*
	* @example List buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets()
	* ```
	*
	* @example List buckets with options
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc',
	*     search: 'prod'
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async listBuckets(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            const queryString = _this.listBucketOptionsToQueryString(options);
            return await $5463fd799def149c$var$get(_this.fetch, `${_this.url}/bucket${queryString}`, {
                headers: _this.headers
            });
        });
    }
    /**
	* Retrieves the details of an existing Storage bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket you would like to retrieve.
	* @returns Promise with response containing bucket details or error
	*
	* @example Get bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .getBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "id": "avatars",
	*     "name": "avatars",
	*     "owner": "",
	*     "public": false,
	*     "file_size_limit": 1024,
	*     "allowed_mime_types": [
	*       "image/png"
	*     ],
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async getBucket(id) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $5463fd799def149c$var$get(_this2.fetch, `${_this2.url}/bucket/${id}`, {
                headers: _this2.headers
            });
        });
    }
    /**
	* Creates a new Storage bucket
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id A unique identifier for the bucket you are creating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @param options.type (private-beta) specifies the bucket type. see `BucketType` for more details.
	*   - default bucket type is `STANDARD`
	* @param options.versioningStatus the bucket's initial object versioning status.
	* The default value is `DISABLED`
	* @returns Promise with response containing newly created bucket name or error
	*
	* @example Create bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .createBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "avatars"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `insert`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async createBucket(id, options = {
        public: false
    }) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $5463fd799def149c$var$post(_this3.fetch, `${_this3.url}/bucket`, {
                id: id,
                name: id,
                type: options.type,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes,
                versioning_status: options.versioningStatus
            }, {
                headers: _this3.headers
            });
        });
    }
    /**
	* Updates a Storage bucket
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id A unique identifier for the bucket you are updating.
	* @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
	* @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
	* The global file size limit takes precedence over this value.
	* The default value is null, which doesn't set a per bucket file size limit.
	* @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
	* The default value is null, which allows files with all mime types to be uploaded.
	* Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
	* @param options.versioningStatus the bucket's new object versioning status. `DISABLED` is not
	* valid here, there's no transition back to it once versioning has been touched.
	* @returns Promise with response containing success message or error
	*
	* @example Update bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .updateBucket('avatars', {
	*     public: false,
	*     allowedMimeTypes: ['image/png'],
	*     fileSizeLimit: 1024
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully updated"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `update`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async updateBucket(id, options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $5463fd799def149c$var$put(_this4.fetch, `${_this4.url}/bucket/${id}`, {
                id: id,
                name: id,
                public: options.public,
                file_size_limit: options.fileSizeLimit,
                allowed_mime_types: options.allowedMimeTypes,
                versioning_status: options.versioningStatus
            }, {
                headers: _this4.headers
            });
        });
    }
    /**
	* Removes all objects inside a single bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket you would like to empty.
	* @returns Promise with success message or error
	*
	* @example Empty bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .emptyBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully emptied"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: `select` and `delete`
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async emptyBucket(id) {
        var _this5 = this;
        return _this5.handleOperation(async ()=>{
            return await $5463fd799def149c$var$post(_this5.fetch, `${_this5.url}/bucket/${id}/empty`, {}, {
                headers: _this5.headers
            });
        });
    }
    /**
	* Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
	* You must first `empty()` the bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket you would like to delete.
	* @returns Promise with success message or error
	*
	* @example Delete bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .deleteBucket('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `delete`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async deleteBucket(id) {
        var _this6 = this;
        return _this6.handleOperation(async ()=>{
            return await $5463fd799def149c$var$remove(_this6.fetch, `${_this6.url}/bucket/${id}`, {}, {
                headers: _this6.headers
            });
        });
    }
    /**
	* Returns the lifecycle policy stored on a bucket.
	*
	* Fails with `NoSuchLifecycleConfiguration` when the bucket has no policy.
	*
	* These rules expire previous versions of objects, not the current one.
	* Turn versioning on or there is nothing for the policy to act on.
	* Standard buckets only. Returns `FeatureNotEnabled` if lifecycle is off
	* for the project.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket.
	* @returns Promise with the lifecycle configuration or error
	*
	* @example Get lifecycle configuration
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .getBucketLifecycle('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "rules": [
	*       {
	*         "id": "expire-history",
	*         "status": "Enabled",
	*         "filter": {},
	*         "noncurrentVersionExpiration": {
	*           "noncurrentDays": 30,
	*           "newerNoncurrentVersions": 2
	*         }
	*       }
	*     ]
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async getBucketLifecycle(id) {
        var _this7 = this;
        return _this7.handleOperation(async ()=>{
            return await $5463fd799def149c$var$get(_this7.fetch, _this7.bucketLifecycleUrl(id), {
                headers: _this7.headers
            });
        });
    }
    /**
	* Replaces the lifecycle policy on a bucket.
	*
	* The `rules` array you send is the whole policy. Anything previously stored
	* is overwritten. Send at least one rule. Call {@link deleteBucketLifecycle}
	* to remove the policy.
	*
	* Each rule currently supports only `noncurrentVersionExpiration`. `filter`
	* is required and must be `{}`. Prefix filters, tag filters, and current-object
	* expiration are rejected. Rule IDs must be unique. Omit `id` and the
	* server generates one.
	*
	* Standard buckets only. Returns `FeatureNotEnabled` if lifecycle is off
	* for the project.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket.
	* @param configuration The full lifecycle configuration to store.
	* @returns Promise with the stored configuration or error
	*
	* @example Replace lifecycle configuration
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .updateBucketLifecycle('avatars', {
	*     rules: [
	*       {
	*         id: 'expire-history',
	*         status: 'Enabled',
	*         filter: {},
	*         noncurrentVersionExpiration: {
	*           noncurrentDays: 30,
	*           newerNoncurrentVersions: 2,
	*         },
	*       },
	*     ],
	*   })
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `update`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async updateBucketLifecycle(id, configuration) {
        var _this8 = this;
        return _this8.handleOperation(async ()=>{
            return await $5463fd799def149c$var$put(_this8.fetch, _this8.bucketLifecycleUrl(id), configuration, {
                headers: _this8.headers
            });
        });
    }
    /**
	* Removes the lifecycle policy from a bucket.
	*
	* Safe to call when no policy is stored. The response is still success.
	* Standard buckets only. Returns `FeatureNotEnabled` if lifecycle is off
	* for the project.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket.
	* @returns Promise with success message or error
	*
	* @example Delete lifecycle configuration
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .deleteBucketLifecycle('avatars')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - RLS policy permissions required:
	*   - `buckets` table permissions: `select` and `update`
	*   - `objects` table permissions: none
	* - Refer to the [Storage guide](/docs/guides/storage/security/access-control) on how access control works
	*/ async deleteBucketLifecycle(id) {
        var _this9 = this;
        return _this9.handleOperation(async ()=>{
            return await $5463fd799def149c$var$remove(_this9.fetch, _this9.bucketLifecycleUrl(id), {}, {
                headers: _this9.headers
            });
        });
    }
    /**
	* Purges the CDN cache for an entire bucket.
	*
	* Maps to `DELETE /cdn/{bucket}` on the Storage API. The server
	* issues a CDN invalidation for the bucket and returns `{ message: 'success' }`.
	*
	* **Requires the `service_role` key.** The underlying endpoint enforces
	* `service_role` JWT — calls made with the anon key or a user JWT will be
	* rejected by the server.
	*
	* **Hosted CDN feature.** On self-hosted Supabase, the Storage service must
	* have `CDN_PURGE_ENDPOINT_URL` configured and the `purgeCache` tenant
	* feature enabled, otherwise the server returns an error.
	*
	* @category Storage
	* @subcategory File Buckets
	* @param id The unique identifier of the bucket you would like to purge from cache.
	* @param options Optional purge cache options.
	* @param options.transformations If true, purges only transformations (resized/formatted variants), leaving original cached files intact.
	* @param parameters Optional fetch parameters such as an `AbortController` signal.
	* @returns Promise with `{ data: { message }, error: null }` on success or `{ data: null, error }` on failure.
	*
	* @example Purge cache for an entire bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .purgeBucketCache('avatars')
	* ```
	*
	* @example Purge only transformations for an entire bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .purgeBucketCache('avatars', { transformations: true })
	* ```
	*/ async purgeBucketCache(id, options, parameters) {
        var _this10 = this;
        return _this10.handleOperation(async ()=>{
            const query = new URLSearchParams();
            if (options === null || options === void 0 ? void 0 : options.transformations) query.set("transformations", "true");
            const queryString = query.toString();
            return await $5463fd799def149c$var$remove(_this10.fetch, `${_this10.url}/cdn/${$5463fd799def149c$var$encodeStoragePath(id)}${queryString ? `?${queryString}` : ""}`, {}, {
                headers: _this10.headers
            }, parameters);
        });
    }
    bucketLifecycleUrl(id) {
        return `${this.url}/bucket/${$5463fd799def149c$var$encodeStoragePath(id)}/lifecycle`;
    }
    listBucketOptionsToQueryString(options) {
        const params = {};
        if (options) {
            if ("limit" in options) params.limit = String(options.limit);
            if ("offset" in options) params.offset = String(options.offset);
            if (options.search) params.search = options.search;
            if (options.sortColumn) params.sortColumn = options.sortColumn;
            if (options.sortOrder) params.sortOrder = options.sortOrder;
        }
        return Object.keys(params).length > 0 ? "?" + new URLSearchParams(params).toString() : "";
    }
};
//#endregion
//#region src/packages/StorageAnalyticsClient.ts
/**
* Client class for managing Analytics Buckets using Iceberg tables
* Provides methods for creating, listing, and deleting analytics buckets
*/ var $5463fd799def149c$export$6be1752cbca4e2bf = class extends $5463fd799def149c$var$BaseApiClient {
    /**
	* @alpha
	*
	* Creates a new StorageAnalyticsClient instance
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param url - The base URL for the storage API
	* @param headers - HTTP headers to include in requests
	* @param fetch - Optional custom fetch implementation
	*
	* @example Using supabase-js (recommended)
	* ```typescript
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const { data, error } = await supabase.storage.analytics.listBuckets()
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```typescript
	* import { StorageAnalyticsClient } from '@supabase/storage-js'
	*
	* const client = new StorageAnalyticsClient(url, headers)
	* ```
	*/ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_HEADERS), headers);
        super(finalUrl, finalHeaders, fetch$1, "storage");
    }
    /**
	* @alpha
	*
	* Creates a new analytics bucket using Iceberg tables
	* Analytics buckets are optimized for analytical queries and data processing
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param name A unique name for the bucket you are creating
	* @returns Promise with response containing newly created analytics bucket or error
	*
	* @example Create analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "name": "analytics-data",
	*     "type": "ANALYTICS",
	*     "format": "iceberg",
	*     "created_at": "2024-05-22T22:26:05.100Z",
	*     "updated_at": "2024-05-22T22:26:05.100Z"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Creates a new analytics bucket using Iceberg tables
	* - Analytics buckets are optimized for analytical queries and data processing
	*/ async createBucket(name) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $5463fd799def149c$var$post(_this.fetch, `${_this.url}/bucket`, {
                name: name
            }, {
                headers: _this.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Retrieves the details of all Analytics Storage buckets within an existing project
	* Only returns buckets of type 'ANALYTICS'
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param options Query parameters for listing buckets
	* @param options.limit Maximum number of buckets to return
	* @param options.offset Number of buckets to skip
	* @param options.sortColumn Column to sort by ('name', 'created_at', 'updated_at')
	* @param options.sortOrder Sort order ('asc' or 'desc')
	* @param options.search Search term to filter bucket names
	* @returns Promise with response containing array of analytics buckets or error
	*
	* @example List analytics buckets
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .listBuckets({
	*     limit: 10,
	*     offset: 0,
	*     sortColumn: 'created_at',
	*     sortOrder: 'desc'
	*   })
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": [
	*     {
	*       "name": "analytics-data",
	*       "type": "ANALYTICS",
	*       "format": "iceberg",
	*       "created_at": "2024-05-22T22:26:05.100Z",
	*       "updated_at": "2024-05-22T22:26:05.100Z"
	*     }
	*   ],
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Retrieves the details of all Analytics Storage buckets within an existing project
	* - Only returns buckets of type 'ANALYTICS'
	*/ async listBuckets(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            const queryParams = new URLSearchParams();
            if ((options === null || options === void 0 ? void 0 : options.limit) !== void 0) queryParams.set("limit", options.limit.toString());
            if ((options === null || options === void 0 ? void 0 : options.offset) !== void 0) queryParams.set("offset", options.offset.toString());
            if (options === null || options === void 0 ? void 0 : options.sortColumn) queryParams.set("sortColumn", options.sortColumn);
            if (options === null || options === void 0 ? void 0 : options.sortOrder) queryParams.set("sortOrder", options.sortOrder);
            if (options === null || options === void 0 ? void 0 : options.search) queryParams.set("search", options.search);
            const queryString = queryParams.toString();
            const url = queryString ? `${_this2.url}/bucket?${queryString}` : `${_this2.url}/bucket`;
            return await $5463fd799def149c$var$get(_this2.fetch, url, {
                headers: _this2.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Deletes an existing analytics bucket
	* A bucket can't be deleted with existing objects inside it
	* You must first empty the bucket before deletion
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param bucketName The unique identifier of the bucket you would like to delete
	* @returns Promise with response containing success message or error
	*
	* @example Delete analytics bucket
	* ```js
	* const { data, error } = await supabase
	*   .storage
	*   .analytics
	*   .deleteBucket('analytics-data')
	* ```
	*
	* Response:
	* ```json
	* {
	*   "data": {
	*     "message": "Successfully deleted"
	*   },
	*   "error": null
	* }
	* ```
	*
	* @remarks
	* - Deletes an analytics bucket
	*/ async deleteBucket(bucketName) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $5463fd799def149c$var$remove(_this3.fetch, `${_this3.url}/bucket/${bucketName}`, {}, {
                headers: _this3.headers
            });
        });
    }
    /**
	* @alpha
	*
	* Get an Iceberg REST Catalog client configured for a specific analytics bucket
	* Use this to perform advanced table and namespace operations within the bucket
	* The returned client provides full access to the Apache Iceberg REST Catalog API
	* with the Supabase `{ data, error }` pattern for consistent error handling on all operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	* @param bucketName - The name of the analytics bucket (warehouse) to connect to
	* @returns The wrapped Iceberg catalog client
	* @throws {StorageError} If the bucket name is invalid
	*
	* @example Get catalog and create table
	* ```js
	* // First, create an analytics bucket
	* const { data: bucket, error: bucketError } = await supabase
	*   .storage
	*   .analytics
	*   .createBucket('analytics-data')
	*
	* // Get the Iceberg catalog for that bucket
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Create a namespace
	* const { error: nsError } = await catalog.createNamespace({ namespace: ['default'] })
	*
	* // Create a table with schema
	* const { data: tableMetadata, error: tableError } = await catalog.createTable(
	*   { namespace: ['default'] },
	*   {
	*     name: 'events',
	*     schema: {
	*       type: 'struct',
	*       fields: [
	*         { id: 1, name: 'id', type: 'long', required: true },
	*         { id: 2, name: 'timestamp', type: 'timestamp', required: true },
	*         { id: 3, name: 'user_id', type: 'string', required: false }
	*       ],
	*       'schema-id': 0,
	*       'identifier-field-ids': [1]
	*     },
	*     'partition-spec': {
	*       'spec-id': 0,
	*       fields: []
	*     },
	*     'write-order': {
	*       'order-id': 0,
	*       fields: []
	*     },
	*     properties: {
	*       'write.format.default': 'parquet'
	*     }
	*   }
	* )
	* ```
	*
	* @example List tables in namespace
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all tables in the default namespace
	* const { data: tables, error: listError } = await catalog.listTables({ namespace: ['default'] })
	* if (listError) {
	*   if (listError.isNotFound()) {
	*     console.log('Namespace not found')
	*   }
	*   return
	* }
	* console.log(tables) // [{ namespace: ['default'], name: 'events' }]
	* ```
	*
	* @example Working with namespaces
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // List all namespaces
	* const { data: namespaces } = await catalog.listNamespaces()
	*
	* // Create namespace with properties
	* await catalog.createNamespace(
	*   { namespace: ['production'] },
	*   { properties: { owner: 'data-team', env: 'prod' } }
	* )
	* ```
	*
	* @example Cleanup operations
	* ```js
	* const catalog = supabase.storage.analytics.from('analytics-data')
	*
	* // Drop table with purge option (removes all data)
	* const { error: dropError } = await catalog.dropTable(
	*   { namespace: ['default'], name: 'events' },
	*   { purge: true }
	* )
	*
	* if (dropError?.isNotFound()) {
	*   console.log('Table does not exist')
	* }
	*
	* // Drop namespace (must be empty)
	* await catalog.dropNamespace({ namespace: ['default'] })
	* ```
	*
	* @remarks
	* This method provides a bridge between Supabase's bucket management and the standard
	* Apache Iceberg REST Catalog API. The bucket name maps to the Iceberg warehouse parameter.
	* All authentication and configuration is handled automatically using your Supabase credentials.
	*
	* **Error Handling**: Invalid bucket names throw immediately. All catalog
	* operations return `{ data, error }` where errors are `IcebergError` instances from iceberg-js.
	* Use helper methods like `error.isNotFound()` or check `error.status` for specific error handling.
	* Use `.throwOnError()` on the analytics client if you prefer exceptions for catalog operations.
	*
	* **Cleanup Operations**: When using `dropTable`, the `purge: true` option permanently
	* deletes all table data. Without it, the table is marked as deleted but data remains.
	*
	* **Library Dependency**: The returned catalog wraps `IcebergRestCatalog` from iceberg-js.
	* For complete API documentation and advanced usage, refer to the
	* [iceberg-js documentation](https://supabase.github.io/iceberg-js/).
	*/ from(bucketName) {
        var _this4 = this;
        if (!$5463fd799def149c$var$isValidBucketName(bucketName)) throw new $5463fd799def149c$export$697502632950e9d3("Invalid bucket name: File, folder, and bucket names must follow AWS object key naming guidelines and should avoid the use of any other characters.");
        const catalog = new (0, $8HKWF.IcebergRestCatalog)({
            baseUrl: this.url,
            catalogName: bucketName,
            auth: {
                type: "custom",
                getHeaders: async ()=>_this4.headers
            },
            fetch: this.fetch
        });
        const shouldThrowOnError = this.shouldThrowOnError;
        return new Proxy(catalog, {
            get (target, prop) {
                const value = target[prop];
                if (typeof value !== "function") return value;
                return async (...args)=>{
                    try {
                        return {
                            data: await value.apply(target, args),
                            error: null
                        };
                    } catch (error) {
                        if (shouldThrowOnError) throw error;
                        return {
                            data: null,
                            error: error
                        };
                    }
                };
            }
        });
    }
};
//#endregion
//#region src/packages/VectorIndexApi.ts
/**
* @hidden
* Base implementation for vector index operations.
* Use {@link VectorBucketScope} via `supabase.storage.vectors.from('bucket')` instead.
*/ var $5463fd799def149c$export$50097ff1e36420b1 = class extends $5463fd799def149c$var$BaseApiClient {
    /** Creates a new VectorIndexApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector index within a bucket */ async createIndex(options) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateIndex`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector index */ async getIndex(vectorBucketName, indexName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector indexes within a bucket with optional filtering and pagination */ async listIndexes(options) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListIndexes`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector index and all its data */ async deleteIndex(vectorBucketName, indexName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteIndex`, {
                vectorBucketName: vectorBucketName,
                indexName: indexName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorDataApi.ts
/**
* @hidden
* Base implementation for vector data operations.
* Use {@link VectorIndexScope} via `supabase.storage.vectors.from('bucket').index('idx')` instead.
*/ var $5463fd799def149c$export$5f2a4b6b8397c039 = class extends $5463fd799def149c$var$BaseApiClient {
    /** Creates a new VectorDataApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Inserts or updates vectors in batch (1-500 per request) */ async putVectors(options) {
        var _this = this;
        if (options.vectors.length < 1 || options.vectors.length > 500) throw new Error("Vector batch size must be between 1 and 500 items");
        return _this.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this.fetch, `${_this.url}/PutVectors`, options, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves vectors by their keys in batch */ async getVectors(options) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectors`, options, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vectors in an index with pagination */ async listVectors(options) {
        var _this3 = this;
        if (options.segmentCount !== void 0) {
            if (options.segmentCount < 1 || options.segmentCount > 16) throw new Error("segmentCount must be between 1 and 16");
            if (options.segmentIndex !== void 0) {
                if (options.segmentIndex < 0 || options.segmentIndex >= options.segmentCount) throw new Error(`segmentIndex must be between 0 and ${options.segmentCount - 1}`);
            }
        }
        return _this3.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectors`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Queries for similar vectors using approximate nearest neighbor search */ async queryVectors(options) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this4.fetch, `${_this4.url}/QueryVectors`, options, {
                headers: _this4.headers
            });
        });
    }
    /** Deletes vectors by their keys in batch (1-500 per request) */ async deleteVectors(options) {
        var _this5 = this;
        if (options.keys.length < 1 || options.keys.length > 500) throw new Error("Keys batch size must be between 1 and 500 items");
        return _this5.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this5.fetch, `${_this5.url}/DeleteVectors`, options, {
                headers: _this5.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/VectorBucketApi.ts
/**
* @hidden
* Base implementation for vector bucket operations.
* Use {@link StorageVectorsClient} via `supabase.storage.vectors` instead.
*/ var $5463fd799def149c$export$e8b640c07a633e69 = class extends $5463fd799def149c$var$BaseApiClient {
    /** Creates a new VectorBucketApi instance */ constructor(url, headers = {}, fetch$1){
        const finalUrl = url.replace(/\/$/, "");
        const finalHeaders = $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, $5463fd799def149c$var$DEFAULT_HEADERS), {}, {
            "Content-Type": "application/json"
        }, headers);
        super(finalUrl, finalHeaders, fetch$1, "vectors");
    }
    /** Creates a new vector bucket */ async createBucket(vectorBucketName) {
        var _this = this;
        return _this.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this.fetch, `${_this.url}/CreateVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this.headers
            }) || {};
        });
    }
    /** Retrieves metadata for a specific vector bucket */ async getBucket(vectorBucketName) {
        var _this2 = this;
        return _this2.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this2.fetch, `${_this2.url}/GetVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this2.headers
            });
        });
    }
    /** Lists vector buckets with optional filtering and pagination */ async listBuckets(options = {}) {
        var _this3 = this;
        return _this3.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this3.fetch, `${_this3.url}/ListVectorBuckets`, options, {
                headers: _this3.headers
            });
        });
    }
    /** Deletes a vector bucket (must be empty first) */ async deleteBucket(vectorBucketName) {
        var _this4 = this;
        return _this4.handleOperation(async ()=>{
            return await $5463fd799def149c$var$vectorsApi.post(_this4.fetch, `${_this4.url}/DeleteVectorBucket`, {
                vectorBucketName: vectorBucketName
            }, {
                headers: _this4.headers
            }) || {};
        });
    }
};
//#endregion
//#region src/packages/StorageVectorsClient.ts
/**
*
* @alpha
*
* Main client for interacting with S3 Vectors API
* Provides access to bucket, index, and vector data operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*
* **Usage Patterns:**
*
* ```typescript
* const { data, error } = await supabase
*  .storage
*  .vectors
*  .createBucket('embeddings-prod')
*
* // Access index operations via buckets
* const bucket = supabase.storage.vectors.from('embeddings-prod')
* await bucket.createIndex({
*   indexName: 'documents',
*   dataType: 'float32',
*   dimension: 1536,
*   distanceMetric: 'cosine'
* })
*
* // Access vector operations via index
* const index = bucket.index('documents')
* await index.putVectors({
*   vectors: [
*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
*   ]
* })
*
* // Query similar vectors
* const { data } = await index.queryVectors({
*   queryVector: { float32: [...] },
*   topK: 5,
*   returnDistance: true
* })
* ```
*/ var $5463fd799def149c$export$f8cb34cab8a13f87 = class extends $5463fd799def149c$export$e8b640c07a633e69 {
    /**
	* @alpha
	*
	* Creates a StorageVectorsClient that can manage buckets, indexes, and vectors.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param url - Base URL of the Storage Vectors REST API.
	* @param options.headers - Optional headers (for example `Authorization`) applied to every request.
	* @param options.fetch - Optional custom `fetch` implementation for non-browser runtimes.
	*
	* @example Using supabase-js (recommended)
	* ```typescript
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```typescript
	* import { StorageVectorsClient } from '@supabase/storage-js'
	*
	* const client = new StorageVectorsClient(url, options)
	* ```
	*/ constructor(url, options = {}){
        super(url, options.headers || {}, options.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific vector bucket
	* Returns a scoped client for index and vector operations within the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Bucket-scoped client with index and vector operations
	*
	* @example Accessing a vector bucket
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ from(vectorBucketName) {
        return new $5463fd799def149c$export$5a6e64e51df41f53(this.url, this.headers, vectorBucketName, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector bucket
	* Vector buckets are containers for vector indexes and their data
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Unique name for the vector bucket
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .createBucket('embeddings-prod')
	* ```
	*/ async createBucket(vectorBucketName) {
        var _superprop_getCreateBucket = ()=>super.createBucket, _this = this;
        return _superprop_getCreateBucket().call(_this, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific vector bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Name of the vector bucket
	* @returns Promise with bucket metadata or error
	*
	* @example Get bucket metadata
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .getBucket('embeddings-prod')
	*
	* console.log('Bucket created:', data?.vectorBucket.creationTime)
	* ```
	*/ async getBucket(vectorBucketName) {
        var _superprop_getGetBucket = ()=>super.getBucket, _this2 = this;
        return _superprop_getGetBucket().call(_this2, vectorBucketName);
    }
    /**
	*
	* @alpha
	*
	* Lists all vector buckets with optional filtering and pagination
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Optional filters (prefix, maxResults, nextToken)
	* @returns Promise with list of buckets or error
	*
	* @example List vector buckets
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .listBuckets({ prefix: 'embeddings-' })
	*
	* data?.vectorBuckets.forEach(bucket => {
	*   console.log(bucket.vectorBucketName)
	* })
	* ```
	*/ async listBuckets(options = {}) {
        var _superprop_getListBuckets = ()=>super.listBuckets, _this3 = this;
        return _superprop_getListBuckets().call(_this3, options);
    }
    /**
	*
	* @alpha
	*
	* Deletes a vector bucket (bucket must be empty)
	* All indexes must be deleted before deleting the bucket
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param vectorBucketName - Name of the vector bucket to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete a vector bucket
	* ```typescript
	* const { data, error } = await supabase
	*   .storage
	*   .vectors
	*   .deleteBucket('embeddings-old')
	* ```
	*/ async deleteBucket(vectorBucketName) {
        var _superprop_getDeleteBucket = ()=>super.deleteBucket, _this4 = this;
        return _superprop_getDeleteBucket().call(_this4, vectorBucketName);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector bucket
* Provides index management and access to vector operations
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $5463fd799def149c$export$5a6e64e51df41f53 = class extends $5463fd799def149c$export$50097ff1e36420b1 {
    /**
	* @alpha
	*
	* Creates a helper that automatically scopes all index operations to the provided bucket.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @example Creating a vector bucket scope
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* ```
	*/ constructor(url, headers, vectorBucketName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
    }
    /**
	*
	* @alpha
	*
	* Creates a new vector index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Index configuration (vectorBucketName is automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Creating a vector index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.createIndex({
	*   indexName: 'documents-openai',
	*   dataType: 'float32',
	*   dimension: 1536,
	*   distanceMetric: 'cosine',
	*   metadataConfiguration: {
	*     nonFilterableMetadataKeys: ['raw_text']
	*   }
	* })
	* ```
	*/ async createIndex(options) {
        var _superprop_getCreateIndex = ()=>super.createIndex, _this5 = this;
        return _superprop_getCreateIndex().call(_this5, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this5.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists indexes in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Listing options (vectorBucketName is automatically set)
	* @returns Promise with response containing indexes array and pagination token or error
	*
	* @example List indexes
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.listIndexes({ prefix: 'documents-' })
	* ```
	*/ async listIndexes(options = {}) {
        var _superprop_getListIndexes = ()=>super.listIndexes, _this6 = this;
        return _superprop_getListIndexes().call(_this6, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this6.vectorBucketName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves metadata for a specific index in this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param indexName - Name of the index to retrieve
	* @returns Promise with index metadata or error
	*
	* @example Get index metadata
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* const { data } = await bucket.getIndex('documents-openai')
	* console.log('Dimension:', data?.index.dimension)
	* ```
	*/ async getIndex(indexName) {
        var _superprop_getGetIndex = ()=>super.getIndex, _this7 = this;
        return _superprop_getGetIndex().call(_this7, _this7.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Deletes an index from this bucket
	* Convenience method that automatically includes the bucket name
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param indexName - Name of the index to delete
	* @returns Promise with empty response on success or error
	*
	* @example Delete an index
	* ```typescript
	* const bucket = supabase.storage.vectors.from('embeddings-prod')
	* await bucket.deleteIndex('old-index')
	* ```
	*/ async deleteIndex(indexName) {
        var _superprop_getDeleteIndex = ()=>super.deleteIndex, _this8 = this;
        return _superprop_getDeleteIndex().call(_this8, _this8.vectorBucketName, indexName);
    }
    /**
	*
	* @alpha
	*
	* Access operations for a specific index within this bucket
	* Returns a scoped client for vector data operations
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param indexName - Name of the index
	* @returns Index-scoped client with vector data operations
	*
	* @example Accessing an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	*
	* // Insert vectors
	* await index.putVectors({
	*   vectors: [
	*     { key: 'doc-1', data: { float32: [...] }, metadata: { title: 'Intro' } }
	*   ]
	* })
	*
	* // Query similar vectors
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [...] },
	*   topK: 5
	* })
	* ```
	*/ index(indexName) {
        return new $5463fd799def149c$export$bb92e54e27a7dace(this.url, this.headers, this.vectorBucketName, indexName, this.fetch);
    }
};
/**
*
* @alpha
*
* Scoped client for operations within a specific vector index
* Provides vector data operations (put, get, list, query, delete)
*
* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
*/ var $5463fd799def149c$export$bb92e54e27a7dace = class extends $5463fd799def149c$export$5f2a4b6b8397c039 {
    /**
	*
	* @alpha
	*
	* Creates a helper that automatically scopes all vector operations to the provided bucket/index names.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @example Creating a vector index scope
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* ```
	*/ constructor(url, headers, vectorBucketName, indexName, fetch$1){
        super(url, headers, fetch$1);
        this.vectorBucketName = vectorBucketName;
        this.indexName = indexName;
    }
    /**
	*
	* @alpha
	*
	* Inserts or updates vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Vector insertion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Insert vectors into an index
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.putVectors({
	*   vectors: [
	*     {
	*       key: 'doc-1',
	*       data: { float32: [0.1, 0.2, ...] },
	*       metadata: { title: 'Introduction', page: 1 }
	*     }
	*   ]
	* })
	* ```
	*/ async putVectors(options) {
        var _superprop_getPutVectors = ()=>super.putVectors, _this9 = this;
        return _superprop_getPutVectors().call(_this9, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this9.vectorBucketName,
            indexName: _this9.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Retrieves vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Vector retrieval options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array or error
	*
	* @example Get vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.getVectors({
	*   keys: ['doc-1', 'doc-2'],
	*   returnMetadata: true
	* })
	* ```
	*/ async getVectors(options) {
        var _superprop_getGetVectors = ()=>super.getVectors, _this10 = this;
        return _superprop_getGetVectors().call(_this10, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this10.vectorBucketName,
            indexName: _this10.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Lists vectors in this index with pagination
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Listing options (bucket and index names automatically set)
	* @returns Promise with response containing vectors array and pagination token or error
	*
	* @example List vectors with pagination
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.listVectors({
	*   maxResults: 500,
	*   returnMetadata: true
	* })
	* ```
	*/ async listVectors(options = {}) {
        var _superprop_getListVectors = ()=>super.listVectors, _this11 = this;
        return _superprop_getListVectors().call(_this11, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this11.vectorBucketName,
            indexName: _this11.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Queries for similar vectors in this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Query options (bucket and index names automatically set)
	* @returns Promise with response containing vectors ordered by distance, an optional pagination token, or an error
	*
	* @example Query similar vectors
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* const { data } = await index.queryVectors({
	*   queryVector: { float32: [0.1, 0.2, ...] },
	*   topK: 5,
	*   filter: { category: 'technical' },
	*   returnDistance: true,
	*   returnMetadata: true
	* })
	* ```
	*/ async queryVectors(options) {
        var _superprop_getQueryVectors = ()=>super.queryVectors, _this12 = this;
        return _superprop_getQueryVectors().call(_this12, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this12.vectorBucketName,
            indexName: _this12.indexName
        }));
    }
    /**
	*
	* @alpha
	*
	* Deletes vectors by keys from this index
	* Convenience method that automatically includes bucket and index names
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	* @param options - Deletion options (bucket and index names automatically set)
	* @returns Promise with empty response on success or error
	*
	* @example Delete vectors by keys
	* ```typescript
	* const index = supabase.storage.vectors.from('embeddings-prod').index('documents-openai')
	* await index.deleteVectors({
	*   keys: ['doc-1', 'doc-2', 'doc-3']
	* })
	* ```
	*/ async deleteVectors(options) {
        var _superprop_getDeleteVectors = ()=>super.deleteVectors, _this13 = this;
        return _superprop_getDeleteVectors().call(_this13, $5463fd799def149c$var$_objectSpread2($5463fd799def149c$var$_objectSpread2({}, options), {}, {
            vectorBucketName: _this13.vectorBucketName,
            indexName: _this13.indexName
        }));
    }
};
//#endregion
//#region src/StorageClient.ts
var $5463fd799def149c$export$6c85f5032e75eff9 = class extends $5463fd799def149c$var$StorageBucketApi {
    /**
	* Creates a client for Storage buckets, files, analytics, and vectors.
	*
	* @category Storage
	* @subcategory File Buckets
	*
	* @example Using supabase-js (recommended)
	* ```ts
	* import { createClient } from '@supabase/supabase-js'
	*
	* const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
	* const avatars = supabase.storage.from('avatars')
	* ```
	*
	* @example Standalone import for bundle-sensitive environments
	* ```ts
	* import { StorageClient } from '@supabase/storage-js'
	*
	* const storage = new StorageClient('https://xyzcompany.supabase.co/storage/v1', {
	*   apikey: 'your-publishable-key',
	* })
	* const avatars = storage.from('avatars')
	* ```
	*/ constructor(url, headers = {}, fetch$1, opts){
        super(url, headers, fetch$1, opts);
    }
    /**
	* Perform file operation in a bucket.
	*
	* @category Storage
	* @subcategory File Buckets
	*
	* @param id The bucket id to operate on.
	*
	* @example Accessing a bucket
	* ```typescript
	* const avatars = supabase.storage.from('avatars')
	* ```
	*/ from(id) {
        return new $5463fd799def149c$var$StorageFileApi(this.url, this.headers, id, this.fetch);
    }
    /**
	*
	* @alpha
	*
	* Access vector storage operations.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Vector Buckets
	*
	* @returns A StorageVectorsClient instance configured with the current storage settings.
	*/ get vectors() {
        return new $5463fd799def149c$export$f8cb34cab8a13f87(this.url + "/vector", {
            headers: this.headers,
            fetch: this.fetch
        });
    }
    /**
	*
	* @alpha
	*
	* Access analytics storage operations using Iceberg tables.
	*
	* **Public alpha:** This API is part of a public alpha release and may not be available to your account type.
	*
	* @category Storage
	* @subcategory Analytics Buckets
	*
	* @returns A StorageAnalyticsClient instance configured with the current storage settings.
	*/ get analytics() {
        return new $5463fd799def149c$export$6be1752cbca4e2bf(this.url + "/iceberg", this.headers, this.fetch);
    }
};

});
parcelRegister("8HKWF", function(module, exports) {

$parcel$export(module.exports, "IcebergRestCatalog", () => $b774780d74deeca6$export$1ccb0cb30480e317);
// src/errors/IcebergError.ts
var $b774780d74deeca6$export$5625de1fddd06f76 = class extends Error {
    constructor(message, opts){
        super(message);
        this.name = "IcebergError";
        this.status = opts.status;
        this.icebergType = opts.icebergType;
        this.icebergCode = opts.icebergCode;
        this.details = opts.details;
        this.isCommitStateUnknown = opts.icebergType === "CommitStateUnknownException" || [
            500,
            502,
            504
        ].includes(opts.status) && opts.icebergType?.includes("CommitState") === true;
    }
    /**
   * Returns true if the error is a 404 Not Found error.
   */ isNotFound() {
        return this.status === 404;
    }
    /**
   * Returns true if the error is a 409 Conflict error.
   */ isConflict() {
        return this.status === 409;
    }
    /**
   * Returns true if the error is a 419 Authentication Timeout error.
   */ isAuthenticationTimeout() {
        return this.status === 419;
    }
};
// src/utils/url.ts
function $b774780d74deeca6$var$buildUrl(baseUrl, path, query) {
    const url = new URL(path, baseUrl);
    if (query) {
        for (const [key, value] of Object.entries(query))if (value !== void 0) url.searchParams.set(key, value);
    }
    return url.toString();
}
// src/http/createFetchClient.ts
async function $b774780d74deeca6$var$buildAuthHeaders(auth) {
    if (!auth || auth.type === "none") return {};
    if (auth.type === "bearer") return {
        Authorization: `Bearer ${auth.token}`
    };
    if (auth.type === "header") return {
        [auth.name]: auth.value
    };
    if (auth.type === "custom") return await auth.getHeaders();
    return {};
}
function $b774780d74deeca6$var$createFetchClient(options) {
    const fetchFn = options.fetchImpl ?? globalThis.fetch;
    return {
        async request ({ method: method, path: path, query: query, body: body, headers: headers }) {
            const url = $b774780d74deeca6$var$buildUrl(options.baseUrl, path, query);
            const authHeaders = await $b774780d74deeca6$var$buildAuthHeaders(options.auth);
            const res = await fetchFn(url, {
                method: method,
                headers: {
                    ...body ? {
                        "Content-Type": "application/json"
                    } : {},
                    ...authHeaders,
                    ...headers
                },
                body: body ? JSON.stringify(body) : void 0
            });
            const text = await res.text();
            const isJson = (res.headers.get("content-type") || "").includes("application/json");
            const data = isJson && text ? JSON.parse(text) : text;
            if (!res.ok) {
                const errBody = isJson ? data : void 0;
                const errorDetail = errBody?.error;
                throw new $b774780d74deeca6$export$5625de1fddd06f76(errorDetail?.message ?? `Request failed with status ${res.status}`, {
                    status: res.status,
                    icebergType: errorDetail?.type,
                    icebergCode: errorDetail?.code,
                    details: errBody
                });
            }
            return {
                status: res.status,
                headers: res.headers,
                data: data
            };
        }
    };
}
// src/catalog/namespaces.ts
function $b774780d74deeca6$var$namespaceToPath(namespace) {
    return namespace.join("");
}
var $b774780d74deeca6$var$NamespaceOperations = class {
    constructor(client, prefix = ""){
        this.client = client;
        this.prefix = prefix;
    }
    async listNamespaces(parent) {
        const query = parent ? {
            parent: $b774780d74deeca6$var$namespaceToPath(parent.namespace)
        } : void 0;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces`,
            query: query
        });
        return response.data.namespaces.map((ns)=>({
                namespace: ns
            }));
    }
    async createNamespace(id, metadata) {
        const request = {
            namespace: id.namespace,
            properties: metadata?.properties
        };
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces`,
            body: request
        });
        return response.data;
    }
    async dropNamespace(id) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath(id.namespace)}`
        });
    }
    async loadNamespaceMetadata(id) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath(id.namespace)}`
        });
        return {
            properties: response.data.properties
        };
    }
    async namespaceExists(id) {
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath(id.namespace)}`
            });
            return true;
        } catch (error) {
            if (error instanceof $b774780d74deeca6$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createNamespaceIfNotExists(id, metadata) {
        try {
            return await this.createNamespace(id, metadata);
        } catch (error) {
            if (error instanceof $b774780d74deeca6$export$5625de1fddd06f76 && error.status === 409) return;
            throw error;
        }
    }
};
// src/catalog/tables.ts
function $b774780d74deeca6$var$namespaceToPath2(namespace) {
    return namespace.join("");
}
var $b774780d74deeca6$var$TableOperations = class {
    constructor(client, prefix = "", accessDelegation){
        this.client = client;
        this.prefix = prefix;
        this.accessDelegation = accessDelegation;
    }
    async listTables(namespace) {
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath2(namespace.namespace)}/tables`
        });
        return response.data.identifiers;
    }
    async createTable(namespace, request) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath2(namespace.namespace)}/tables`,
            body: request,
            headers: headers
        });
        return response.data.metadata;
    }
    async updateTable(id, request) {
        const response = await this.client.request({
            method: "POST",
            path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            body: request
        });
        return {
            "metadata-location": response.data["metadata-location"],
            metadata: response.data.metadata
        };
    }
    async dropTable(id, options) {
        await this.client.request({
            method: "DELETE",
            path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            query: {
                purgeRequested: String(options?.purge ?? false)
            }
        });
    }
    async loadTable(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        const response = await this.client.request({
            method: "GET",
            path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
            headers: headers
        });
        return response.data.metadata;
    }
    async tableExists(id) {
        const headers = {};
        if (this.accessDelegation) headers["X-Iceberg-Access-Delegation"] = this.accessDelegation;
        try {
            await this.client.request({
                method: "HEAD",
                path: `${this.prefix}/namespaces/${$b774780d74deeca6$var$namespaceToPath2(id.namespace)}/tables/${id.name}`,
                headers: headers
            });
            return true;
        } catch (error) {
            if (error instanceof $b774780d74deeca6$export$5625de1fddd06f76 && error.status === 404) return false;
            throw error;
        }
    }
    async createTableIfNotExists(namespace, request) {
        try {
            return await this.createTable(namespace, request);
        } catch (error) {
            if (error instanceof $b774780d74deeca6$export$5625de1fddd06f76 && error.status === 409) return await this.loadTable({
                namespace: namespace.namespace,
                name: request.name
            });
            throw error;
        }
    }
};
// src/catalog/IcebergRestCatalog.ts
var $b774780d74deeca6$export$1ccb0cb30480e317 = class {
    /**
   * Creates a new Iceberg REST Catalog client.
   *
   * @param options - Configuration options for the catalog client
   */ constructor(options){
        let prefix = "v1";
        if (options.catalogName) prefix += `/${options.catalogName}`;
        const baseUrl = options.baseUrl.endsWith("/") ? options.baseUrl : `${options.baseUrl}/`;
        this.client = $b774780d74deeca6$var$createFetchClient({
            baseUrl: baseUrl,
            auth: options.auth,
            fetchImpl: options.fetch
        });
        this.accessDelegation = options.accessDelegation?.join(",");
        this.namespaceOps = new $b774780d74deeca6$var$NamespaceOperations(this.client, prefix);
        this.tableOps = new $b774780d74deeca6$var$TableOperations(this.client, prefix, this.accessDelegation);
    }
    /**
   * Lists all namespaces in the catalog.
   *
   * @param parent - Optional parent namespace to list children under
   * @returns Array of namespace identifiers
   *
   * @example
   * ```typescript
   * // List all top-level namespaces
   * const namespaces = await catalog.listNamespaces();
   *
   * // List namespaces under a parent
   * const children = await catalog.listNamespaces({ namespace: ['analytics'] });
   * ```
   */ async listNamespaces(parent) {
        return this.namespaceOps.listNamespaces(parent);
    }
    /**
   * Creates a new namespace in the catalog.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespace(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * console.log(response.namespace); // ['analytics']
   * console.log(response.properties); // { owner: 'data-team', ... }
   * ```
   */ async createNamespace(id, metadata) {
        return this.namespaceOps.createNamespace(id, metadata);
    }
    /**
   * Drops a namespace from the catalog.
   *
   * The namespace must be empty (contain no tables) before it can be dropped.
   *
   * @param id - Namespace identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropNamespace({ namespace: ['analytics'] });
   * ```
   */ async dropNamespace(id) {
        await this.namespaceOps.dropNamespace(id);
    }
    /**
   * Loads metadata for a namespace.
   *
   * @param id - Namespace identifier to load
   * @returns Namespace metadata including properties
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadNamespaceMetadata({ namespace: ['analytics'] });
   * console.log(metadata.properties);
   * ```
   */ async loadNamespaceMetadata(id) {
        return this.namespaceOps.loadNamespaceMetadata(id);
    }
    /**
   * Lists all tables in a namespace.
   *
   * @param namespace - Namespace identifier to list tables from
   * @returns Array of table identifiers
   *
   * @example
   * ```typescript
   * const tables = await catalog.listTables({ namespace: ['analytics'] });
   * console.log(tables); // [{ namespace: ['analytics'], name: 'events' }, ...]
   * ```
   */ async listTables(namespace) {
        return this.tableOps.listTables(namespace);
    }
    /**
   * Creates a new table in the catalog.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTable(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     },
   *     'partition-spec': {
   *       'spec-id': 0,
   *       fields: [
   *         { source_id: 2, field_id: 1000, name: 'ts_day', transform: 'day' }
   *       ]
   *     }
   *   }
   * );
   * ```
   */ async createTable(namespace, request) {
        return this.tableOps.createTable(namespace, request);
    }
    /**
   * Updates an existing table's metadata.
   *
   * Can update the schema, partition spec, or properties of a table.
   *
   * @param id - Table identifier to update
   * @param request - Update request with fields to modify
   * @returns Response containing the metadata location and updated table metadata
   *
   * @example
   * ```typescript
   * const response = await catalog.updateTable(
   *   { namespace: ['analytics'], name: 'events' },
   *   {
   *     properties: { 'read.split.target-size': '134217728' }
   *   }
   * );
   * console.log(response['metadata-location']); // s3://...
   * console.log(response.metadata); // TableMetadata object
   * ```
   */ async updateTable(id, request) {
        return this.tableOps.updateTable(id, request);
    }
    /**
   * Drops a table from the catalog.
   *
   * @param id - Table identifier to drop
   *
   * @example
   * ```typescript
   * await catalog.dropTable({ namespace: ['analytics'], name: 'events' });
   * ```
   */ async dropTable(id, options) {
        await this.tableOps.dropTable(id, options);
    }
    /**
   * Loads metadata for a table.
   *
   * @param id - Table identifier to load
   * @returns Table metadata including schema, partition spec, location, etc.
   *
   * @example
   * ```typescript
   * const metadata = await catalog.loadTable({ namespace: ['analytics'], name: 'events' });
   * console.log(metadata.schema);
   * console.log(metadata.location);
   * ```
   */ async loadTable(id) {
        return this.tableOps.loadTable(id);
    }
    /**
   * Checks if a namespace exists in the catalog.
   *
   * @param id - Namespace identifier to check
   * @returns True if the namespace exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.namespaceExists({ namespace: ['analytics'] });
   * console.log(exists); // true or false
   * ```
   */ async namespaceExists(id) {
        return this.namespaceOps.namespaceExists(id);
    }
    /**
   * Checks if a table exists in the catalog.
   *
   * @param id - Table identifier to check
   * @returns True if the table exists, false otherwise
   *
   * @example
   * ```typescript
   * const exists = await catalog.tableExists({ namespace: ['analytics'], name: 'events' });
   * console.log(exists); // true or false
   * ```
   */ async tableExists(id) {
        return this.tableOps.tableExists(id);
    }
    /**
   * Creates a namespace if it does not exist.
   *
   * If the namespace already exists, returns void. If created, returns the response.
   *
   * @param id - Namespace identifier to create
   * @param metadata - Optional metadata properties for the namespace
   * @returns Response containing the created namespace and its properties, or void if it already exists
   *
   * @example
   * ```typescript
   * const response = await catalog.createNamespaceIfNotExists(
   *   { namespace: ['analytics'] },
   *   { properties: { owner: 'data-team' } }
   * );
   * if (response) {
   *   console.log('Created:', response.namespace);
   * } else {
   *   console.log('Already exists');
   * }
   * ```
   */ async createNamespaceIfNotExists(id, metadata) {
        return this.namespaceOps.createNamespaceIfNotExists(id, metadata);
    }
    /**
   * Creates a table if it does not exist.
   *
   * If the table already exists, returns its metadata instead.
   *
   * @param namespace - Namespace to create the table in
   * @param request - Table creation request including name, schema, partition spec, etc.
   * @returns Table metadata for the created or existing table
   *
   * @example
   * ```typescript
   * const metadata = await catalog.createTableIfNotExists(
   *   { namespace: ['analytics'] },
   *   {
   *     name: 'events',
   *     schema: {
   *       type: 'struct',
   *       fields: [
   *         { id: 1, name: 'id', type: 'long', required: true },
   *         { id: 2, name: 'timestamp', type: 'timestamp', required: true }
   *       ],
   *       'schema-id': 0
   *     }
   *   }
   * );
   * ```
   */ async createTableIfNotExists(namespace, request) {
        return this.tableOps.createTableIfNotExists(namespace, request);
    }
};
// src/catalog/types.ts
var $b774780d74deeca6$var$DECIMAL_REGEX = /^decimal\s*\(\s*(\d+)\s*,\s*(\d+)\s*\)$/;
var $b774780d74deeca6$var$FIXED_REGEX = /^fixed\s*\[\s*(\d+)\s*\]$/;
function $b774780d74deeca6$export$31eb975fa3e9c1f6(type) {
    const match = type.match($b774780d74deeca6$var$DECIMAL_REGEX);
    if (!match) return null;
    return {
        precision: parseInt(match[1], 10),
        scale: parseInt(match[2], 10)
    };
}
function $b774780d74deeca6$export$43d56cf6240a0c0e(type) {
    const match = type.match($b774780d74deeca6$var$FIXED_REGEX);
    if (!match) return null;
    return {
        length: parseInt(match[1], 10)
    };
}
function $b774780d74deeca6$export$ec8cf417183662a1(type) {
    return $b774780d74deeca6$var$DECIMAL_REGEX.test(type);
}
function $b774780d74deeca6$export$9fafc1fb79bd852e(type) {
    return $b774780d74deeca6$var$FIXED_REGEX.test(type);
}
function $b774780d74deeca6$export$84255940fed2ec86(a, b) {
    const decimalA = $b774780d74deeca6$export$31eb975fa3e9c1f6(a);
    const decimalB = $b774780d74deeca6$export$31eb975fa3e9c1f6(b);
    if (decimalA && decimalB) return decimalA.precision === decimalB.precision && decimalA.scale === decimalB.scale;
    const fixedA = $b774780d74deeca6$export$43d56cf6240a0c0e(a);
    const fixedB = $b774780d74deeca6$export$43d56cf6240a0c0e(b);
    if (fixedA && fixedB) return fixedA.length === fixedB.length;
    return a === b;
}
function $b774780d74deeca6$export$d26e6db8c278e564(metadata) {
    return metadata.schemas.find((s)=>s["schema-id"] === metadata["current-schema-id"]);
}
 //# sourceMappingURL=index.mjs.map

});


parcelRegister("9zCEj", function(module, exports) {

$parcel$export(module.exports, "AuthClient", () => (parcelRequire("dVg10")).default);

var $9Errw = parcelRequire("9Errw");

var $alesa = parcelRequire("alesa");

var $3NlKP = parcelRequire("3NlKP");

var $dVg10 = parcelRequire("dVg10");
parcelRequire("3Z11r");
parcelRequire("e1qhh");

var $cqGWb = parcelRequire("cqGWb");

});
parcelRegister("9Errw", function(module, exports) {

$parcel$export(module.exports, "default", () => $706d231812e23393$export$2e2bcd8739ae039);

var $5qviX = parcelRequire("5qviX");

var $chSC8 = parcelRequire("chSC8");

var $9tGer = parcelRequire("9tGer");

var $3Z11r = parcelRequire("3Z11r");

var $e1qhh = parcelRequire("e1qhh");
class $706d231812e23393$export$2e2bcd8739ae039 {
    /**
     * Creates an admin API client that can be used to manage users and OAuth clients.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-secret-key')
     * const { data, error } = await supabase.auth.admin.listUsers()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { GoTrueAdminApi } from '@supabase/auth-js'
     *
     * const admin = new GoTrueAdminApi({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { Authorization: `Bearer ${process.env.SUPABASE_SECRET_KEY}` },
     * })
     * ```
     */ constructor({ url: url = '', headers: headers = {}, fetch: fetch, experimental: experimental }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $9tGer.resolveFetch)(fetch);
        this.experimental = experimental !== null && experimental !== void 0 ? experimental : {};
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
        this.oauth = {
            listClients: this._listOAuthClients.bind(this),
            createClient: this._createOAuthClient.bind(this),
            getClient: this._getOAuthClient.bind(this),
            updateClient: this._updateOAuthClient.bind(this),
            deleteClient: this._deleteOAuthClient.bind(this),
            regenerateClientSecret: this._regenerateOAuthClientSecret.bind(this)
        };
        this.customProviders = {
            listProviders: this._listCustomProviders.bind(this),
            createProvider: this._createCustomProvider.bind(this),
            getProvider: this._getCustomProvider.bind(this),
            updateProvider: this._updateCustomProvider.bind(this),
            deleteProvider: this._deleteCustomProvider.bind(this)
        };
        this.passkey = {
            listPasskeys: this._adminListPasskeys.bind(this),
            deletePasskey: this._adminDeletePasskey.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     *
     * @category Auth
     * @subcategory Auth Admin
     */ async signOut(jwt, scope = (0, $3Z11r.SIGN_OUT_SCOPES)[0]) {
        if ((0, $3Z11r.SIGN_OUT_SCOPES).indexOf(scope) < 0) throw new Error(`@supabase/auth-js: Parameter scope must be one of ${(0, $3Z11r.SIGN_OUT_SCOPES).join(', ')}`);
        try {
            await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - Sends an invite link to the user's email address.
     * - The `inviteUserByEmail()` method is typically used by administrators to invite users to join the application.
     * - Note that PKCE is not supported when using `inviteUserByEmail`. This is because the browser initiating the invite is often different from the browser accepting the invite which makes it difficult to provide the security guarantees required of the PKCE flow.
     *
     * @example Invite a user
     * ```js
     * const { data, error } = await supabase.auth.admin.inviteUserByEmail('email@example.com')
     * ```
     *
     * @exampleResponse Invite a user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "invited_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $chSC8._userResponse)
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param params The parameters for generating the link, including the link `type`, the user's `email`, and type-specific options such as `password`, `data`, and `redirectTo`.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - The following types can be passed into `generateLink()`: `signup`, `magiclink`, `invite`, `recovery`, `email_change_current`, `email_change_new`, `phone_change`.
     * - `generateLink()` only generates the email link for `email_change_email` if the **Secure email change** is enabled in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     * - `generateLink()` handles the creation of the user for `signup`, `invite` and `magiclink`.
     *
     * @example Generate a signup link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   password: 'secret'
     * })
     * ```
     *
     * @exampleResponse Generate a signup link
     * ```json
     * {
     *   "data": {
     *     "properties": {
     *       "action_link": "<LINK_TO_SEND_TO_USER>",
     *       "email_otp": "999999",
     *       "hashed_token": "<HASHED_TOKEN",
     *       "redirect_to": "<REDIRECT_URL>",
     *       "verification_type": "signup"
     *     },
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "email@example.com",
     *       "phone": "",
     *       "confirmation_sent_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "email@example.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Generate an invite link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'invite',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a magic link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'magiclink',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate a recovery link
     * ```js
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'recovery',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @example Generate links to change current email address
     * ```js
     * // generate an email change link to be sent to the current email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_current',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     *
     * // generate an email change link to be sent to the new email address
     * const { data, error } = await supabase.auth.admin.generateLink({
     *   type: 'email_change_new',
     *   email: 'current.email@example.com',
     *   newEmail: 'new.email@example.com'
     * })
     * ```
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = (0, $5qviX.__rest)(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $chSC8._generateLinkResponse),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - To confirm the user's email address or phone number, set `email_confirm` or `phone_confirm` to true. Both arguments default to false.
     * - `createUser()` will not send a confirmation email to the user. You can use [`inviteUserByEmail()`](/docs/reference/javascript/auth-admin-inviteuserbyemail) if you want to send them an email invite instead.
     * - If you are sure that the created user's email or phone number is legitimate and verified, you can set the `email_confirm` or `phone_confirm` param to `true`.
     *
     * @example With custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   password: 'password',
     *   user_metadata: { name: 'Yoda' }
     * })
     * ```
     *
     * @exampleResponse With custom user metadata
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     *
     * @example Auto-confirm the user's email
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   email: 'user@email.com',
     *   email_confirm: true
     * })
     * ```
     *
     * @example Auto-confirm the user's phone number
     * ```js
     * const { data, error } = await supabase.auth.admin.createUser({
     *   phone: '1234567890',
     *   phone_confirm: true
     * })
     * ```
     */ async createUser(attributes) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $chSC8._userResponse)
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - Defaults to return 50 users per page.
     *
     * @example Get a page of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers()
     * ```
     *
     * @example Paginated list of users
     * ```js
     * const { data: { users }, error } = await supabase.auth.admin.listUsers({
     *   page: 1,
     *   perPage: 1000
     * })
     * ```
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $chSC8._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - Fetches the user object from the database based on the user's id.
     * - The `getUserById()` method requires the user's id which maps to the `auth.users.id` column.
     *
     * @example Fetch the user object using the access_token jwt
     * ```js
     * const { data, error } = await supabase.auth.admin.getUserById(1)
     * ```
     *
     * @exampleResponse Fetch the user object using the access_token jwt
     * ```json
     * {
     *   data: {
     *     user: {
     *       id: '1',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {},
     *       user_metadata: {},
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "1",
     *           "user_id": "1",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "phone_verified": false,
     *             "sub": "1"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false,
     *     }
     *   }
     *   error: null
     * }
     * ```
     */ async getUserById(uid) {
        (0, $9tGer.validateUUID)(uid);
        try {
            return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $chSC8._userResponse)
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data. Changes are applied directly without confirmation flows.
     *
     * @param uid The user's unique identifier
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @remarks
     * **Important:** This is a server-side operation and does **not** trigger client-side
     * `onAuthStateChange` listeners. The admin API has no connection to client state.
     *
     * To sync changes to the client after calling this method:
     * 1. On the client, call `supabase.auth.refreshSession()` to fetch the updated user data
     * 2. This will trigger the `TOKEN_REFRESHED` event and notify all listeners
     *
     * @example
     * ```typescript
     * // Server-side (Edge Function)
     * const { data, error } = await supabase.auth.admin.updateUserById(
     *   userId,
     *   { user_metadata: { preferences: { theme: 'dark' } } }
     * )
     *
     * // Client-side (to sync the changes)
     * const { data, error } = await supabase.auth.refreshSession()
     * // onAuthStateChange listeners will now be notified with updated user
     * ```
     *
     * @see {@link GoTrueClient.refreshSession} for syncing admin changes to the client
     * @see {@link GoTrueClient.updateUser} for client-side user updates (triggers listeners automatically)
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @example Updates a user's email
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '11111111-1111-1111-1111-111111111111',
     *   { email: 'new@email.com' }
     * )
     * ```
     *
     * @exampleResponse Updates a user's email
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "new@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Updates a user's password
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { password: 'new_password' }
     * )
     * ```
     *
     * @example Updates a user's metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { user_metadata: { hello: 'world' } }
     * )
     * ```
     *
     * @example Updates a user's app_metadata
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { app_metadata: { plan: 'trial' } }
     * )
     * ```
     *
     * @example Confirms a user's email address
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { email_confirm: true }
     * )
     * ```
     *
     * @example Confirms a user's phone number
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { phone_confirm: true }
     * )
     * ```
     *
     * @example Ban a user for 100 years
     * ```js
     * const { data: user, error } = await supabase.auth.admin.updateUserById(
     *   '6aa5d0d4-2a9f-4483-b6c8-0cf4c6c98ac4',
     *   { ban_duration: '876000h' }
     * )
     * ```
     */ async updateUserById(uid, attributes) {
        (0, $9tGer.validateUUID)(uid);
        try {
            return await (0, $chSC8._request)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $chSC8._userResponse)
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     *
     * @category Auth
     * @subcategory Auth Admin
     *
     * @remarks
     * - The `deleteUser()` method requires the user's ID, which maps to the `auth.users.id` column.
     *
     * @example Removes a user
     * ```js
     * const { data, error } = await supabase.auth.admin.deleteUser(
     *   '715ed5db-f090-4b8c-a067-640ecee36aa0'
     * )
     * ```
     *
     * @exampleResponse Removes a user
     * ```json
     * {
     *   "data": {
     *     "user": {}
     *   },
     *   "error": null
     * }
     * ```
     */ async deleteUser(id, shouldSoftDelete = false) {
        (0, $9tGer.validateUUID)(id);
        try {
            return await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $chSC8._userResponse)
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        (0, $9tGer.validateUUID)(params.userId);
        try {
            const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        (0, $9tGer.validateUUID)(params.userId);
        (0, $9tGer.validateUUID)(params.id);
        try {
            const data = await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all OAuth clients with optional pagination.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listOAuthClients(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, $chSC8._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const clients = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, clients), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    clients: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createOAuthClient(params) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getOAuthClient(clientId) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateOAuthClient(clientId, params) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'PUT', `${this.url}/admin/oauth/clients/${clientId}`, {
                body: params,
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteOAuthClient(clientId) {
        try {
            await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/admin/oauth/clients/${clientId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Regenerates the secret for an OAuth client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _regenerateOAuthClientSecret(clientId) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/admin/oauth/clients/${clientId}/regenerate_secret`, {
                headers: this.headers,
                xform: (client)=>{
                    return {
                        data: client,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all custom providers with optional type filter.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _listCustomProviders(params) {
        try {
            const query = {};
            if (params === null || params === void 0 ? void 0 : params.type) query.type = params.type;
            return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers`, {
                headers: this.headers,
                query: query,
                xform: (data)=>{
                    var _a;
                    return {
                        data: {
                            providers: (_a = data === null || data === void 0 ? void 0 : data.providers) !== null && _a !== void 0 ? _a : []
                        },
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: {
                    providers: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Creates a new custom OIDC/OAuth provider.
     *
     * For OIDC providers, the server fetches and validates the OpenID Connect discovery document
     * from the issuer's well-known endpoint (or the provided `discovery_url`) at creation time.
     * This may return a validation error (`error_code: "validation_failed"`) if the discovery
     * document is unreachable, not valid JSON, missing required fields, or if the issuer
     * in the document does not match the expected issuer.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _createCustomProvider(params) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/admin/custom-providers`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets details of a specific custom provider by identifier.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _getCustomProvider(identifier) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates an existing custom provider.
     *
     * When `issuer` or `discovery_url` is changed on an OIDC provider, the server re-fetches and
     * validates the discovery document before persisting. This may return a validation error
     * (`error_code: "validation_failed"`) if the discovery document is unreachable, invalid, or
     * the issuer does not match.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _updateCustomProvider(identifier, params) {
        try {
            return await (0, $chSC8._request)(this.fetch, 'PUT', `${this.url}/admin/custom-providers/${identifier}`, {
                body: params,
                headers: this.headers,
                xform: (provider)=>{
                    return {
                        data: provider,
                        error: null
                    };
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a custom provider.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async _deleteCustomProvider(identifier) {
        try {
            await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/admin/custom-providers/${identifier}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Lists all passkeys for a user.
     *
     * This function should only be called on a server. Never expose your secret key in the browser.
     */ async _adminListPasskeys(params) {
        (0, $9tGer.validateUUID)(params.userId);
        try {
            return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/passkeys`, {
                headers: this.headers,
                xform: (data)=>({
                        data: data,
                        error: null
                    })
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Deletes a user's passkey.
     *
     * This function should only be called on a server. Never expose your secret key in the browser.
     */ async _adminDeletePasskey(params) {
        (0, $9tGer.validateUUID)(params.userId);
        (0, $9tGer.validateUUID)(params.passkeyId);
        try {
            await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/passkeys/${params.passkeyId}`, {
                headers: this.headers,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
}

});
parcelRegister("chSC8", function(module, exports) {

$parcel$export(module.exports, "_request", () => $8f216fcd0119f9bc$export$8969b3850ca2cdfd);
$parcel$export(module.exports, "_sessionResponse", () => $8f216fcd0119f9bc$export$273fe4673a018c2e);
$parcel$export(module.exports, "_sessionResponsePassword", () => $8f216fcd0119f9bc$export$db83aade1c2922c7);
$parcel$export(module.exports, "_userResponse", () => $8f216fcd0119f9bc$export$e20f488897843593);
$parcel$export(module.exports, "_ssoResponse", () => $8f216fcd0119f9bc$export$b04785c46dcd8f8b);
$parcel$export(module.exports, "_generateLinkResponse", () => $8f216fcd0119f9bc$export$f5eaa950605b2146);
$parcel$export(module.exports, "_noResolveJsonResponse", () => $8f216fcd0119f9bc$export$7aed01df6e045e31);

var $5qviX = parcelRequire("5qviX");

var $nTVnO = parcelRequire("nTVnO");

var $9tGer = parcelRequire("9tGer");

var $e1qhh = parcelRequire("e1qhh");
const $8f216fcd0119f9bc$var$_getErrorMessage = (err)=>{
    if (typeof err === 'object' && err !== null) {
        const e = err;
        if (typeof e.msg === 'string') return e.msg;
        if (typeof e.message === 'string') return e.message;
        if (typeof e.error_description === 'string') return e.error_description;
        if (typeof e.error === 'string') return e.error;
    }
    return JSON.stringify(err);
};
// 500, 501, 502, 503, 504: Standard server/gateway errors
// 520-529, 530: Cloudflare-specific error codes (web server down, connection timed out, etc.)
// These are infrastructure errors and should not cause session invalidation.
const $8f216fcd0119f9bc$var$NETWORK_ERROR_CODES = [
    500,
    501,
    502,
    503,
    504,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530
];
async function $8f216fcd0119f9bc$export$d3da1ecaf1206c58(error) {
    var _a;
    if (!(0, $9tGer.looksLikeFetchResponse)(error)) throw new (0, $e1qhh.AuthRetryableFetchError)($8f216fcd0119f9bc$var$_getErrorMessage(error), 0);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        if ($8f216fcd0119f9bc$var$NETWORK_ERROR_CODES.includes(error.status)) // statusText can be empty — HTTP/2 has no reason phrase
        throw new (0, $e1qhh.AuthRetryableFetchError)(error.statusText || `HTTP ${error.status}`, error.status);
        throw new (0, $e1qhh.AuthUnknownError)($8f216fcd0119f9bc$var$_getErrorMessage(e), e);
    }
    if ($8f216fcd0119f9bc$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $e1qhh.AuthRetryableFetchError)($8f216fcd0119f9bc$var$_getErrorMessage(data), error.status);
    let errorCode = undefined;
    const responseAPIVersion = (0, $9tGer.parseResponseAPIVersion)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $nTVnO.API_VERSIONS)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, $e1qhh.AuthWeakPasswordError)($8f216fcd0119f9bc$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, $e1qhh.AuthWeakPasswordError)($8f216fcd0119f9bc$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, $e1qhh.AuthSessionMissingError)();
    throw new (0, $e1qhh.AuthApiError)($8f216fcd0119f9bc$var$_getErrorMessage(data), error.status || 500, errorCode);
}
const $8f216fcd0119f9bc$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $8f216fcd0119f9bc$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, $nTVnO.API_VERSION_HEADER_NAME]) headers[0, $nTVnO.API_VERSION_HEADER_NAME] = (0, $nTVnO.API_VERSIONS)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await $8f216fcd0119f9bc$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $8f216fcd0119f9bc$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $8f216fcd0119f9bc$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        // fetch failed (network / CORS / aborted request) — surfaced to the
        // caller as a retryable error below. Deliberately not logged here: an
        // aborted in-flight request (e.g. a superseded page navigation) is a
        // transient condition, and logging the raw error pollutes the console.
        throw new (0, $e1qhh.AuthRetryableFetchError)($8f216fcd0119f9bc$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $8f216fcd0119f9bc$export$d3da1ecaf1206c58(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $8f216fcd0119f9bc$export$d3da1ecaf1206c58(e);
    }
}
function $8f216fcd0119f9bc$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($8f216fcd0119f9bc$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $9tGer.expiresAt)(data.expires_in);
    }
    // Some /verify responses (e.g. secure email_change first-confirmation) return
    // only `{ msg, code }` with no user and no session. Treat those as null user.
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : typeof (data === null || data === void 0 ? void 0 : data.id) === 'string' ? data : null;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $8f216fcd0119f9bc$export$db83aade1c2922c7(data) {
    const response = $8f216fcd0119f9bc$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function $8f216fcd0119f9bc$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $8f216fcd0119f9bc$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $8f216fcd0119f9bc$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = (0, $5qviX.__rest)(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $8f216fcd0119f9bc$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $8f216fcd0119f9bc$var$hasSession(data) {
    return !!data.access_token && !!data.refresh_token && !!data.expires_in;
}

});
parcelRegister("nTVnO", function(module, exports) {

$parcel$export(module.exports, "AUTO_REFRESH_TICK_DURATION_MS", () => $047d878b632800f4$export$a4558fee79d6c8ae);
$parcel$export(module.exports, "AUTO_REFRESH_TICK_THRESHOLD", () => $047d878b632800f4$export$f20a97df8f5fe223);
$parcel$export(module.exports, "EXPIRY_MARGIN_MS", () => $047d878b632800f4$export$a36ad0026e55ac00);
$parcel$export(module.exports, "REFRESH_FAILURE_COOLDOWN_MS", () => $047d878b632800f4$export$275f2a8f454f7e06);
$parcel$export(module.exports, "GOTRUE_URL", () => $047d878b632800f4$export$7fedf552187f0c3d);
$parcel$export(module.exports, "STORAGE_KEY", () => $047d878b632800f4$export$86880b4b2e1a2384);
$parcel$export(module.exports, "DEFAULT_HEADERS", () => $047d878b632800f4$export$88a84136db6a4b64);
$parcel$export(module.exports, "API_VERSION_HEADER_NAME", () => $047d878b632800f4$export$e4f5507f88977535);
$parcel$export(module.exports, "API_VERSIONS", () => $047d878b632800f4$export$1f9a66038489bdeb);
$parcel$export(module.exports, "BASE64URL_REGEX", () => $047d878b632800f4$export$7a68c9e70b9d3911);
$parcel$export(module.exports, "PKCE_FLOW_ID_PARAM", () => $047d878b632800f4$export$ac2a6f1bee955ff5);
$parcel$export(module.exports, "PKCE_MAX_CONCURRENT_FLOWS", () => $047d878b632800f4$export$5343143f8b710f50);
$parcel$export(module.exports, "JWKS_TTL", () => $047d878b632800f4$export$5bd768495200f133);

var $42vUz = parcelRequire("42vUz");
const $047d878b632800f4$export$a4558fee79d6c8ae = 30000;
const $047d878b632800f4$export$f20a97df8f5fe223 = 3;
const $047d878b632800f4$export$a36ad0026e55ac00 = $047d878b632800f4$export$f20a97df8f5fe223 * $047d878b632800f4$export$a4558fee79d6c8ae;
const $047d878b632800f4$export$275f2a8f454f7e06 = 2 * $047d878b632800f4$export$a4558fee79d6c8ae;
const $047d878b632800f4$export$7fedf552187f0c3d = 'http://localhost:9999';
const $047d878b632800f4$export$86880b4b2e1a2384 = 'supabase.auth.token';
const $047d878b632800f4$export$2f9161bad044dacb = '';
const $047d878b632800f4$export$88a84136db6a4b64 = {
    'X-Client-Info': `gotrue-js/${(0, $42vUz.version)}`
};
const $047d878b632800f4$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const $047d878b632800f4$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
const $047d878b632800f4$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};
const $047d878b632800f4$export$7a68c9e70b9d3911 = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}$|[a-z0-9_-]{2}$)$/i;
const $047d878b632800f4$export$ac2a6f1bee955ff5 = 'sb_flow_id';
const $047d878b632800f4$export$5343143f8b710f50 = 5;
const $047d878b632800f4$export$5bd768495200f133 = 600000; // 10 minutes

});
parcelRegister("42vUz", function(module, exports) {

$parcel$export(module.exports, "version", () => $2f101a46aad3b04a$export$83d89fbfd8236492);
// Generated automatically during releases by scripts/update-version-files.ts
// This file provides runtime access to the package version for:
// - HTTP request headers (e.g., X-Client-Info header for API requests)
// - Debugging and support (identifying which version is running)
// - Telemetry and logging (version reporting in errors/analytics)
// - Ensuring build artifacts match the published package version
const $2f101a46aad3b04a$export$83d89fbfd8236492 = '2.118.0';

});


parcelRegister("9tGer", function(module, exports) {

$parcel$export(module.exports, "expiresAt", () => $6e6794e1618594d6$export$e02d0a488392f690);
$parcel$export(module.exports, "generateCallbackId", () => $6e6794e1618594d6$export$16db4ce6a8dfc285);
$parcel$export(module.exports, "isBrowser", () => $6e6794e1618594d6$export$4e09c449d6c407f7);
$parcel$export(module.exports, "supportsLocalStorage", () => $6e6794e1618594d6$export$9ec034ee80211814);
$parcel$export(module.exports, "parseParametersFromURL", () => $6e6794e1618594d6$export$7a29392fb778224c);
$parcel$export(module.exports, "resolveFetch", () => $6e6794e1618594d6$export$98d92b1aa79f8cc7);
$parcel$export(module.exports, "looksLikeFetchResponse", () => $6e6794e1618594d6$export$e8ad6599be1036a7);
$parcel$export(module.exports, "setItemAsync", () => $6e6794e1618594d6$export$e82c36d29078a87f);
$parcel$export(module.exports, "getItemAsync", () => $6e6794e1618594d6$export$ba6fcb7c333d32c0);
$parcel$export(module.exports, "removeItemAsync", () => $6e6794e1618594d6$export$d35c645d585317ec);
$parcel$export(module.exports, "Deferred", () => $6e6794e1618594d6$export$85f6557964517f1a);
$parcel$export(module.exports, "decodeJWT", () => $6e6794e1618594d6$export$9a62e6c0a30e00bc);
$parcel$export(module.exports, "sleep", () => $6e6794e1618594d6$export$e772c8ff12451969);
$parcel$export(module.exports, "retryable", () => $6e6794e1618594d6$export$9e1b8e833f44ff21);
$parcel$export(module.exports, "validatePKCEFlowId", () => $6e6794e1618594d6$export$fe73814baf679182);
$parcel$export(module.exports, "pkceVerifierSlotKey", () => $6e6794e1618594d6$export$64968d4a5d254b0a);
$parcel$export(module.exports, "retrievePKCEVerifier", () => $6e6794e1618594d6$export$5d7ba5be1bd12310);
$parcel$export(module.exports, "removePKCEVerifier", () => $6e6794e1618594d6$export$9faa66cdd2bf7ef3);
$parcel$export(module.exports, "removeAllPKCEVerifiers", () => $6e6794e1618594d6$export$8f813e4ed278a615);
$parcel$export(module.exports, "appendFlowIdToRedirectTo", () => $6e6794e1618594d6$export$5a9677d281426d9b);
$parcel$export(module.exports, "getCodeChallengeAndMethod", () => $6e6794e1618594d6$export$81b177cadfcf873c);
$parcel$export(module.exports, "parseResponseAPIVersion", () => $6e6794e1618594d6$export$5f69ecf1c14d56fd);
$parcel$export(module.exports, "validateExp", () => $6e6794e1618594d6$export$a5850868adeb9253);
$parcel$export(module.exports, "getAlgorithm", () => $6e6794e1618594d6$export$fa59f625ab60cb91);
$parcel$export(module.exports, "validateUUID", () => $6e6794e1618594d6$export$a4c72ae47296db0c);
$parcel$export(module.exports, "assertRecoveryCodesExperimentalEnabled", () => $6e6794e1618594d6$export$4f240811801ddedb);
$parcel$export(module.exports, "userNotAvailableProxy", () => $6e6794e1618594d6$export$52c7f0d8a78626b);
$parcel$export(module.exports, "insecureUserWarningProxy", () => $6e6794e1618594d6$export$28f3a5de6111309a);
$parcel$export(module.exports, "deepClone", () => $6e6794e1618594d6$export$b7d58db314e0ac27);

var $nTVnO = parcelRequire("nTVnO");

var $e1qhh = parcelRequire("e1qhh");

var $PVTtI = parcelRequire("PVTtI");
function $6e6794e1618594d6$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $6e6794e1618594d6$export$16db4ce6a8dfc285() {
    return Symbol('auth-callback');
}
const $6e6794e1618594d6$export$4e09c449d6c407f7 = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const $6e6794e1618594d6$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $6e6794e1618594d6$export$9ec034ee80211814 = ()=>{
    if (!$6e6794e1618594d6$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($6e6794e1618594d6$var$localStorageWriteTests.tested) return $6e6794e1618594d6$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $6e6794e1618594d6$var$localStorageWriteTests.tested = true;
        $6e6794e1618594d6$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $6e6794e1618594d6$var$localStorageWriteTests.tested = true;
        $6e6794e1618594d6$var$localStorageWriteTests.writable = false;
    }
    return $6e6794e1618594d6$var$localStorageWriteTests.writable;
};
function $6e6794e1618594d6$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (_e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
const $6e6794e1618594d6$export$98d92b1aa79f8cc7 = (customFetch)=>{
    if (customFetch) return (...args)=>customFetch(...args);
    return (...args)=>fetch(...args);
};
const $6e6794e1618594d6$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const $6e6794e1618594d6$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $6e6794e1618594d6$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        // Storage values are always written as JSON via setItemAsync. A non-JSON
        // value means the entry is corrupted (e.g. mismatched chunked cookies in
        // SSR contexts). Treat as absent so callers do not mutate or re-save the
        // garbage, which would otherwise trigger a TypeError downstream and
        // leak the raw value into error logs.
        return null;
    }
};
const $6e6794e1618594d6$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
class $6e6794e1618594d6$export$85f6557964517f1a {
    constructor(){
        this.promise = new $6e6794e1618594d6$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$6e6794e1618594d6$export$85f6557964517f1a.promiseConstructor = Promise;
function $6e6794e1618594d6$export$9a62e6c0a30e00bc(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new (0, $e1qhh.AuthInvalidJwtError)('Invalid JWT structure');
    // Regex checks for base64url format
    for(let i = 0; i < parts.length; i++){
        if (!(0, $nTVnO.BASE64URL_REGEX).test(parts[i])) throw new (0, $e1qhh.AuthInvalidJwtError)('JWT not in base64url format');
    }
    const data = {
        // using base64url lib
        header: JSON.parse((0, $PVTtI.stringFromBase64URL)(parts[0])),
        payload: JSON.parse((0, $PVTtI.stringFromBase64URL)(parts[1])),
        signature: (0, $PVTtI.base64UrlToUint8Array)(parts[2]),
        raw: {
            header: parts[0],
            payload: parts[1]
        }
    };
    return data;
}
async function $6e6794e1618594d6$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $6e6794e1618594d6$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $6e6794e1618594d6$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $6e6794e1618594d6$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $6e6794e1618594d6$var$dec2hex).join('');
}
async function $6e6794e1618594d6$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
async function $6e6794e1618594d6$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await $6e6794e1618594d6$var$sha256(verifier);
    return btoa(hashed).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
const $6e6794e1618594d6$var$PKCE_FLOW_ID_PATTERN = /^[a-zA-Z0-9_-]{8,64}$/;
function $6e6794e1618594d6$export$fe73814baf679182(flowId) {
    return typeof flowId === 'string' && $6e6794e1618594d6$var$PKCE_FLOW_ID_PATTERN.test(flowId) ? flowId : null;
}
function $6e6794e1618594d6$export$6c42b1bfc0a93e11() {
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        return Array.from(bytes, $6e6794e1618594d6$var$dec2hex).join('');
    }
    let flowId = '';
    for(let i = 0; i < 32; i++)flowId += Math.floor(Math.random() * 16).toString(16);
    return flowId;
}
const $6e6794e1618594d6$export$64968d4a5d254b0a = (storageKey, flowId)=>`${storageKey}-flow-${flowId}-code-verifier`;
const $6e6794e1618594d6$var$pkceFlowIndexKey = (storageKey)=>`${storageKey}-flows-code-verifier`;
/**
 * Storage adapters cannot enumerate keys, so the ids of pending verifier
 * slots are tracked in an index entry, oldest first. Index entries pass
 * through the same validation as URL-provided flow ids: with cookie-based
 * storage the index contents are no more trustworthy than a URL parameter.
 */ async function $6e6794e1618594d6$var$getPKCEFlowIndex(storage, storageKey) {
    const index = await $6e6794e1618594d6$export$ba6fcb7c333d32c0(storage, $6e6794e1618594d6$var$pkceFlowIndexKey(storageKey));
    return Array.isArray(index) ? index.filter((id)=>$6e6794e1618594d6$export$fe73814baf679182(id) !== null) : [];
}
async function $6e6794e1618594d6$export$fbdf3134dd63b9a(storage, storageKey, flowId, verifier, onEvictFlow) {
    await $6e6794e1618594d6$export$e82c36d29078a87f(storage, $6e6794e1618594d6$export$64968d4a5d254b0a(storageKey, flowId), verifier);
    const index = (await $6e6794e1618594d6$var$getPKCEFlowIndex(storage, storageKey)).filter((id)=>id !== flowId);
    index.push(flowId);
    while(index.length > (0, $nTVnO.PKCE_MAX_CONCURRENT_FLOWS)){
        const evicted = index.shift();
        await $6e6794e1618594d6$export$d35c645d585317ec(storage, $6e6794e1618594d6$export$64968d4a5d254b0a(storageKey, evicted));
        onEvictFlow === null || onEvictFlow === void 0 || onEvictFlow(evicted);
    }
    await $6e6794e1618594d6$export$e82c36d29078a87f(storage, $6e6794e1618594d6$var$pkceFlowIndexKey(storageKey), index);
    // Deprecation-window dual write: exchanges that cannot identify their flow
    // (older SDK versions, redirects without the flow id parameter) read the
    // fixed key, which mirrors the most recently started flow.
    await $6e6794e1618594d6$export$e82c36d29078a87f(storage, `${storageKey}-code-verifier`, verifier);
}
async function $6e6794e1618594d6$export$5d7ba5be1bd12310(storage, storageKey, flowId) {
    if (flowId) {
        const verifier = await $6e6794e1618594d6$export$ba6fcb7c333d32c0(storage, $6e6794e1618594d6$export$64968d4a5d254b0a(storageKey, flowId));
        return {
            verifier: typeof verifier === 'string' ? verifier : null,
            flowId: flowId
        };
    }
    const verifier = await $6e6794e1618594d6$export$ba6fcb7c333d32c0(storage, `${storageKey}-code-verifier`);
    return {
        verifier: typeof verifier === 'string' ? verifier : null,
        flowId: null
    };
}
async function $6e6794e1618594d6$export$9faa66cdd2bf7ef3(storage, storageKey, flowId) {
    const legacyKey = `${storageKey}-code-verifier`;
    if (!flowId) {
        await $6e6794e1618594d6$export$d35c645d585317ec(storage, legacyKey);
        return;
    }
    const slotKey = $6e6794e1618594d6$export$64968d4a5d254b0a(storageKey, flowId);
    const slotValue = await $6e6794e1618594d6$export$ba6fcb7c333d32c0(storage, slotKey);
    await $6e6794e1618594d6$export$d35c645d585317ec(storage, slotKey);
    // Skip the index rewrite when the flow was never indexed (e.g. a failed
    // exchange for an absent slot): on cookie storage every write is a full
    // Set-Cookie cycle.
    const index = await $6e6794e1618594d6$var$getPKCEFlowIndex(storage, storageKey);
    const remaining = index.filter((id)=>id !== flowId);
    if (remaining.length !== index.length) {
        if (remaining.length > 0) await $6e6794e1618594d6$export$e82c36d29078a87f(storage, $6e6794e1618594d6$var$pkceFlowIndexKey(storageKey), remaining);
        else await $6e6794e1618594d6$export$d35c645d585317ec(storage, $6e6794e1618594d6$var$pkceFlowIndexKey(storageKey));
    }
    if (slotValue != null && slotValue === await $6e6794e1618594d6$export$ba6fcb7c333d32c0(storage, legacyKey)) await $6e6794e1618594d6$export$d35c645d585317ec(storage, legacyKey);
}
async function $6e6794e1618594d6$export$8f813e4ed278a615(storage, storageKey) {
    const index = await $6e6794e1618594d6$var$getPKCEFlowIndex(storage, storageKey);
    for (const flowId of index)await $6e6794e1618594d6$export$d35c645d585317ec(storage, $6e6794e1618594d6$export$64968d4a5d254b0a(storageKey, flowId));
    await $6e6794e1618594d6$export$d35c645d585317ec(storage, $6e6794e1618594d6$var$pkceFlowIndexKey(storageKey));
    await $6e6794e1618594d6$export$d35c645d585317ec(storage, `${storageKey}-code-verifier`);
}
function $6e6794e1618594d6$export$5a9677d281426d9b(redirectTo, flowId) {
    const hashIndex = redirectTo.indexOf('#');
    let base = hashIndex === -1 ? redirectTo : redirectTo.slice(0, hashIndex);
    const fragment = hashIndex === -1 ? '' : redirectTo.slice(hashIndex);
    const queryIndex = base.indexOf('?');
    if (queryIndex !== -1) {
        const path = base.slice(0, queryIndex);
        const remaining = base.slice(queryIndex + 1).split('&').filter((pair)=>pair !== '' && pair !== (0, $nTVnO.PKCE_FLOW_ID_PARAM) && !pair.startsWith(`${(0, $nTVnO.PKCE_FLOW_ID_PARAM)}=`));
        base = remaining.length > 0 ? `${path}?${remaining.join('&')}` : path;
    }
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}${0, $nTVnO.PKCE_FLOW_ID_PARAM}=${encodeURIComponent(flowId)}${fragment}`;
}
async function $6e6794e1618594d6$export$81b177cadfcf873c(storage, storageKey, isPasswordRecovery = false, onEvictFlow) {
    const codeVerifier = $6e6794e1618594d6$export$b6c3b8498f152f15();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/recovery';
    const flowId = $6e6794e1618594d6$export$6c42b1bfc0a93e11();
    await $6e6794e1618594d6$export$fbdf3134dd63b9a(storage, storageKey, flowId, storedCodeVerifier, onEvictFlow);
    const codeChallenge = await $6e6794e1618594d6$export$eb79e16bb8189148(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod,
        flowId
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const $6e6794e1618594d6$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $6e6794e1618594d6$export$5f69ecf1c14d56fd(response) {
    const apiVersion = response.headers.get((0, $nTVnO.API_VERSION_HEADER_NAME));
    if (!apiVersion) return null;
    if (!apiVersion.match($6e6794e1618594d6$var$API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (_e) {
        return null;
    }
}
function $6e6794e1618594d6$export$a5850868adeb9253(exp) {
    if (!exp) throw new Error('Missing exp claim');
    const timeNow = Math.floor(Date.now() / 1000);
    if (exp <= timeNow) throw new Error('JWT has expired');
}
function $6e6794e1618594d6$export$fa59f625ab60cb91(alg) {
    switch(alg){
        case 'RS256':
            return {
                name: 'RSASSA-PKCS1-v1_5',
                hash: {
                    name: 'SHA-256'
                }
            };
        case 'ES256':
            return {
                name: 'ECDSA',
                namedCurve: 'P-256',
                hash: {
                    name: 'SHA-256'
                }
            };
        default:
            throw new Error('Invalid alg claim');
    }
}
const $6e6794e1618594d6$var$UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function $6e6794e1618594d6$export$a4c72ae47296db0c(str) {
    if (!$6e6794e1618594d6$var$UUID_REGEX.test(str)) throw new Error('@supabase/auth-js: Expected parameter to be UUID but is not');
}
function $6e6794e1618594d6$export$4f240811801ddedb(experimental) {
    if (!experimental.recoveryCodes) throw new Error('@supabase/auth-js: the MFA recovery codes API is experimental and disabled by default. Enable it by passing `auth: { experimental: { recoveryCodes: true } }` to createClient (or to the GoTrueClient constructor).');
}
function $6e6794e1618594d6$export$52c7f0d8a78626b() {
    const proxyTarget = {};
    return new Proxy(proxyTarget, {
        get: (target, prop)=>{
            if (prop === '__isUserNotAvailableProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms.
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)') // Node.js util.inspect
                return undefined;
            }
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Accessing the "${prop}" property of the session object is not supported. Please use getUser() instead.`);
        },
        set: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Setting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        },
        deleteProperty: (_target, prop)=>{
            throw new Error(`@supabase/auth-js: client was created with userStorage option and there was no user stored in the user storage. Deleting the "${prop}" property of the session object is not supported. Please use getUser() to fetch a user object you can manipulate.`);
        }
    });
}
function $6e6794e1618594d6$export$28f3a5de6111309a(user, suppressWarningRef) {
    return new Proxy(user, {
        get: (target, prop, receiver)=>{
            // Allow internal checks without warning
            if (prop === '__isInsecureUserWarningProxy') return true;
            // Preventative check for common problematic symbols during cloning/inspection
            // These symbols might be accessed by structuredClone or other internal mechanisms
            if (typeof prop === 'symbol') {
                const sProp = prop.toString();
                if (sProp === 'Symbol(Symbol.toPrimitive)' || sProp === 'Symbol(Symbol.toStringTag)' || sProp === 'Symbol(util.inspect.custom)' || sProp === 'Symbol(nodejs.util.inspect.custom)') // Return the actual value for these symbols to allow proper inspection
                return Reflect.get(target, prop, receiver);
            }
            // Emit warning on first property access
            if (!suppressWarningRef.value && typeof prop === 'string') {
                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                suppressWarningRef.value = true;
            }
            return Reflect.get(target, prop, receiver);
        }
    });
}
function $6e6794e1618594d6$export$b7d58db314e0ac27(obj) {
    return JSON.parse(JSON.stringify(obj));
}

});
parcelRegister("e1qhh", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $a3558ae716fa7fb4$export$145273558d58e0ac);
$parcel$export(module.exports, "isAuthError", () => $a3558ae716fa7fb4$export$cde1786a482f9a1c);
$parcel$export(module.exports, "AuthApiError", () => $a3558ae716fa7fb4$export$45fde0b55b14f37b);
$parcel$export(module.exports, "isAuthApiError", () => $a3558ae716fa7fb4$export$4fe744aeb810d543);
$parcel$export(module.exports, "AuthUnknownError", () => $a3558ae716fa7fb4$export$f7559805d4a50078);
$parcel$export(module.exports, "AuthSessionMissingError", () => $a3558ae716fa7fb4$export$403b3fc0d3ad5f0c);
$parcel$export(module.exports, "isAuthSessionMissingError", () => $a3558ae716fa7fb4$export$3e849aa4db565c1d);
$parcel$export(module.exports, "AuthInvalidTokenResponseError", () => $a3558ae716fa7fb4$export$7e277b620449c1b4);
$parcel$export(module.exports, "AuthInvalidCredentialsError", () => $a3558ae716fa7fb4$export$9ef583f0381b4cc);
$parcel$export(module.exports, "AuthImplicitGrantRedirectError", () => $a3558ae716fa7fb4$export$bf5df8e043856ef5);
$parcel$export(module.exports, "isAuthImplicitGrantRedirectError", () => $a3558ae716fa7fb4$export$45edea3999507afd);
$parcel$export(module.exports, "AuthPKCEGrantCodeExchangeError", () => $a3558ae716fa7fb4$export$39583657eb2a7027);
$parcel$export(module.exports, "AuthPKCECodeVerifierMissingError", () => $a3558ae716fa7fb4$export$11e8e15400b7b336);
$parcel$export(module.exports, "AuthRetryableFetchError", () => $a3558ae716fa7fb4$export$2423b763f68be1b4);
$parcel$export(module.exports, "isAuthRetryableFetchError", () => $a3558ae716fa7fb4$export$a77af358da5fb874);
$parcel$export(module.exports, "AuthRefreshDiscardedError", () => $a3558ae716fa7fb4$export$9fdc7c02f78a05fd);
$parcel$export(module.exports, "isAuthRefreshDiscardedError", () => $a3558ae716fa7fb4$export$5b8ce8437166eecb);
$parcel$export(module.exports, "AuthWeakPasswordError", () => $a3558ae716fa7fb4$export$b034076aa04913a6);
$parcel$export(module.exports, "AuthInvalidJwtError", () => $a3558ae716fa7fb4$export$d04cb18528f2043e);
/**
 * Base error thrown by Supabase Auth helpers.
 *
 * @example
 * ```ts
 * import { AuthError } from '@supabase/auth-js'
 *
 * throw new AuthError('Unexpected auth error', 500, 'unexpected')
 * ```
 */ class $a3558ae716fa7fb4$export$145273558d58e0ac extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            code: this.code
        };
    }
}
function $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class $a3558ae716fa7fb4$export$45fde0b55b14f37b extends $a3558ae716fa7fb4$export$145273558d58e0ac {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function $a3558ae716fa7fb4$export$4fe744aeb810d543(error) {
    return $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
class $a3558ae716fa7fb4$export$f7559805d4a50078 extends $a3558ae716fa7fb4$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class $a3558ae716fa7fb4$export$823c745ae0673c5e extends $a3558ae716fa7fb4$export$145273558d58e0ac {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class $a3558ae716fa7fb4$export$403b3fc0d3ad5f0c extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function $a3558ae716fa7fb4$export$3e849aa4db565c1d(error) {
    return $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
class $a3558ae716fa7fb4$export$7e277b620449c1b4 extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class $a3558ae716fa7fb4$export$9ef583f0381b4cc extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class $a3558ae716fa7fb4$export$bf5df8e043856ef5 extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
}
function $a3558ae716fa7fb4$export$45edea3999507afd(error) {
    return $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class $a3558ae716fa7fb4$export$39583657eb2a7027 extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            details: this.details
        });
    }
}
class $a3558ae716fa7fb4$export$11e8e15400b7b336 extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(){
        super("PKCE code verifier not found in storage. This can happen if the auth flow was initiated in a different browser or device, or if the storage was cleared. For SSR frameworks (Next.js, SvelteKit, etc.), use @supabase/ssr on both the server and client to store the code verifier in cookies.", 'AuthPKCECodeVerifierMissingError', 400, 'pkce_code_verifier_not_found');
    }
}
function $a3558ae716fa7fb4$export$398e1f2bb2c7a92(error) {
    return $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) && error.name === 'AuthPKCECodeVerifierMissingError';
}
class $a3558ae716fa7fb4$export$2423b763f68be1b4 extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function $a3558ae716fa7fb4$export$a77af358da5fb874(error) {
    return $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
class $a3558ae716fa7fb4$export$9fdc7c02f78a05fd extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(message = 'Refresh result discarded: session state changed mid-flight (e.g., concurrent signOut)'){
        super(message, 'AuthRefreshDiscardedError', 409, undefined);
    }
}
function $a3558ae716fa7fb4$export$5b8ce8437166eecb(error) {
    return $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) && error.name === 'AuthRefreshDiscardedError';
}
class $a3558ae716fa7fb4$export$b034076aa04913a6 extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
    toJSON() {
        return Object.assign(Object.assign({}, super.toJSON()), {
            reasons: this.reasons
        });
    }
}
function $a3558ae716fa7fb4$export$dac36143fd8a46ef(error) {
    return $a3558ae716fa7fb4$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}
class $a3558ae716fa7fb4$export$d04cb18528f2043e extends $a3558ae716fa7fb4$export$823c745ae0673c5e {
    constructor(message){
        super(message, 'AuthInvalidJwtError', 400, 'invalid_jwt');
    }
}

});

parcelRegister("PVTtI", function(module, exports) {

$parcel$export(module.exports, "stringFromBase64URL", () => $09c1ac0a38542407$export$bd5d476f823ea024);
$parcel$export(module.exports, "base64UrlToUint8Array", () => $09c1ac0a38542407$export$9cae2cd6076b8fb6);
$parcel$export(module.exports, "stringToUint8Array", () => $09c1ac0a38542407$export$a098e7b533f96db3);
$parcel$export(module.exports, "bytesToBase64URL", () => $09c1ac0a38542407$export$3f156efe462a835e);
/**
 * Avoid modifying this file. It's part of
 * https://github.com/supabase-community/base64url-js.  Submit all fixes on
 * that repo!
 */ /**
 * An array of characters that encode 6 bits into a Base64-URL alphabet
 * character.
 */ const $09c1ac0a38542407$var$TO_BASE64URL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'.split('');
/**
 * An array of characters that can appear in a Base64-URL encoded string but
 * should be ignored.
 */ const $09c1ac0a38542407$var$IGNORE_BASE64URL = ' \t\n\r='.split('');
/**
 * An array of 128 numbers that map a Base64-URL character to 6 bits, or if -2
 * used to skip the character, or if -1 used to error out.
 */ const $09c1ac0a38542407$var$FROM_BASE64URL = (()=>{
    const charMap = new Array(128);
    for(let i = 0; i < charMap.length; i += 1)charMap[i] = -1;
    for(let i = 0; i < $09c1ac0a38542407$var$IGNORE_BASE64URL.length; i += 1)charMap[$09c1ac0a38542407$var$IGNORE_BASE64URL[i].charCodeAt(0)] = -2;
    for(let i = 0; i < $09c1ac0a38542407$var$TO_BASE64URL.length; i += 1)charMap[$09c1ac0a38542407$var$TO_BASE64URL[i].charCodeAt(0)] = i;
    return charMap;
})();
function $09c1ac0a38542407$export$744f452403189a3e(byte, state, emit) {
    if (byte !== null) {
        state.queue = state.queue << 8 | byte;
        state.queuedBits += 8;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($09c1ac0a38542407$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    } else if (state.queuedBits > 0) {
        state.queue = state.queue << 6 - state.queuedBits;
        state.queuedBits = 6;
        while(state.queuedBits >= 6){
            const pos = state.queue >> state.queuedBits - 6 & 63;
            emit($09c1ac0a38542407$var$TO_BASE64URL[pos]);
            state.queuedBits -= 6;
        }
    }
}
function $09c1ac0a38542407$export$403e86c86002a137(charCode, state, emit) {
    const bits = $09c1ac0a38542407$var$FROM_BASE64URL[charCode];
    if (bits > -1) {
        // valid Base64-URL character
        state.queue = state.queue << 6 | bits;
        state.queuedBits += 6;
        while(state.queuedBits >= 8){
            emit(state.queue >> state.queuedBits - 8 & 0xff);
            state.queuedBits -= 8;
        }
    } else if (bits === -2) // ignore spaces, tabs, newlines, =
    return;
    else throw new Error(`Invalid Base64-URL character "${String.fromCharCode(charCode)}"`);
}
function $09c1ac0a38542407$export$abe65c864cc3fd34(str) {
    const base64 = [];
    const emitter = (char)=>{
        base64.push(char);
    };
    const state = {
        queue: 0,
        queuedBits: 0
    };
    $09c1ac0a38542407$export$caccae6095ceb6da(str, (byte)=>{
        $09c1ac0a38542407$export$744f452403189a3e(byte, state, emitter);
    });
    $09c1ac0a38542407$export$744f452403189a3e(null, state, emitter);
    return base64.join('');
}
function $09c1ac0a38542407$export$bd5d476f823ea024(str) {
    const conv = [];
    const utf8Emit = (codepoint)=>{
        conv.push(String.fromCodePoint(codepoint));
    };
    const utf8State = {
        utf8seq: 0,
        codepoint: 0
    };
    const b64State = {
        queue: 0,
        queuedBits: 0
    };
    const byteEmit = (byte)=>{
        $09c1ac0a38542407$export$719b4117b3270757(byte, utf8State, utf8Emit);
    };
    for(let i = 0; i < str.length; i += 1)$09c1ac0a38542407$export$403e86c86002a137(str.charCodeAt(i), b64State, byteEmit);
    return conv.join('');
}
function $09c1ac0a38542407$export$d203cd9136753332(codepoint, emit) {
    if (codepoint <= 0x7f) {
        emit(codepoint);
        return;
    } else if (codepoint <= 0x7ff) {
        emit(0xc0 | codepoint >> 6);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0xffff) {
        emit(0xe0 | codepoint >> 12);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    } else if (codepoint <= 0x10ffff) {
        emit(0xf0 | codepoint >> 18);
        emit(0x80 | codepoint >> 12 & 0x3f);
        emit(0x80 | codepoint >> 6 & 0x3f);
        emit(0x80 | codepoint & 0x3f);
        return;
    }
    throw new Error(`Unrecognized Unicode codepoint: ${codepoint.toString(16)}`);
}
function $09c1ac0a38542407$export$caccae6095ceb6da(str, emit) {
    for(let i = 0; i < str.length; i += 1){
        let codepoint = str.charCodeAt(i);
        if (codepoint > 0xd7ff && codepoint <= 0xdbff) {
            // most UTF-16 codepoints are Unicode codepoints, except values in this
            // range where the next UTF-16 codepoint needs to be combined with the
            // current one to get the Unicode codepoint
            const highSurrogate = (codepoint - 0xd800) * 0x400 & 0xffff;
            const lowSurrogate = str.charCodeAt(i + 1) - 0xdc00 & 0xffff;
            codepoint = (lowSurrogate | highSurrogate) + 0x10000;
            i += 1;
        }
        $09c1ac0a38542407$export$d203cd9136753332(codepoint, emit);
    }
}
function $09c1ac0a38542407$export$719b4117b3270757(byte, state, emit) {
    if (state.utf8seq === 0) {
        if (byte <= 0x7f) {
            emit(byte);
            return;
        }
        // count the number of 1 leading bits until you reach 0
        for(let leadingBit = 1; leadingBit < 6; leadingBit += 1)if ((byte >> 7 - leadingBit & 1) === 0) {
            state.utf8seq = leadingBit;
            break;
        }
        if (state.utf8seq === 2) state.codepoint = byte & 31;
        else if (state.utf8seq === 3) state.codepoint = byte & 15;
        else if (state.utf8seq === 4) state.codepoint = byte & 7;
        else throw new Error('Invalid UTF-8 sequence');
        state.utf8seq -= 1;
    } else if (state.utf8seq > 0) {
        if (byte <= 0x7f) throw new Error('Invalid UTF-8 sequence');
        state.codepoint = state.codepoint << 6 | byte & 63;
        state.utf8seq -= 1;
        if (state.utf8seq === 0) emit(state.codepoint);
    }
}
function $09c1ac0a38542407$export$9cae2cd6076b8fb6(str) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onByte = (byte)=>{
        result.push(byte);
    };
    for(let i = 0; i < str.length; i += 1)$09c1ac0a38542407$export$403e86c86002a137(str.charCodeAt(i), state, onByte);
    return new Uint8Array(result);
}
function $09c1ac0a38542407$export$a098e7b533f96db3(str) {
    const result = [];
    $09c1ac0a38542407$export$caccae6095ceb6da(str, (byte)=>result.push(byte));
    return new Uint8Array(result);
}
function $09c1ac0a38542407$export$3f156efe462a835e(bytes) {
    const result = [];
    const state = {
        queue: 0,
        queuedBits: 0
    };
    const onChar = (char)=>{
        result.push(char);
    };
    bytes.forEach((byte)=>$09c1ac0a38542407$export$744f452403189a3e(byte, state, onChar));
    // always call with `null` after processing all bytes
    $09c1ac0a38542407$export$744f452403189a3e(null, state, onChar);
    return result.join('');
}

});



parcelRegister("3Z11r", function(module, exports) {

$parcel$export(module.exports, "SIGN_OUT_SCOPES", () => $2e67dc933d6c9391$export$9a0f1d0c97ce73ca);
const $2e67dc933d6c9391$var$WeakPasswordReasons = [
    'length',
    'characters',
    'pwned'
];
const $2e67dc933d6c9391$var$AMRMethods = [
    'password',
    'otp',
    'oauth',
    'totp',
    'mfa/totp',
    'mfa/phone',
    'mfa/webauthn',
    'mfa/recovery_code',
    'anonymous',
    'sso/saml',
    'magiclink',
    'web3',
    'oauth_provider/authorization_code'
];
const $2e67dc933d6c9391$var$FactorTypes = [
    'totp',
    'phone',
    'webauthn',
    'recovery_code'
];
const $2e67dc933d6c9391$var$FactorVerificationStatuses = [
    'verified',
    'unverified'
];
const $2e67dc933d6c9391$var$MFATOTPChannels = [
    'sms',
    'whatsapp'
];
const $2e67dc933d6c9391$export$9a0f1d0c97ce73ca = [
    'global',
    'local',
    'others'
];

});


parcelRegister("alesa", function(module, exports) {

$parcel$export(module.exports, "default", () => $787713ac43d87621$export$2e2bcd8739ae039);

var $9Errw = parcelRequire("9Errw");

var $nTVnO = parcelRequire("nTVnO");

var $e1qhh = parcelRequire("e1qhh");

var $chSC8 = parcelRequire("chSC8");

var $9tGer = parcelRequire("9tGer");

var $i5VQk = parcelRequire("i5VQk");

var $cqGWb = parcelRequire("cqGWb");

var $8uOnr = parcelRequire("8uOnr");

var $42vUz = parcelRequire("42vUz");

var $PVTtI = parcelRequire("PVTtI");

var $bJ1Vx = parcelRequire("bJ1Vx");

var $ctRCA = parcelRequire("ctRCA");
(0, $8uOnr.polyfillGlobalThis)(); // Make "globalThis" available
const $787713ac43d87621$var$DEFAULT_OPTIONS = {
    url: (0, $nTVnO.GOTRUE_URL),
    storageKey: (0, $nTVnO.STORAGE_KEY),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $nTVnO.DEFAULT_HEADERS),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false,
    throwOnError: false,
    lockAcquireTimeout: 5000,
    skipAutoInitialize: false,
    experimental: {}
};
/**
 * No-op lock used internally as a placeholder. Kept so older test setups that
 * inject this exact reference do not break; new code never sees it because
 * `this.lock` stays `null` when no custom lock is supplied (lockless path).
 * TODO(v3): remove with the legacy lock path.
 */ async function $787713ac43d87621$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
/**
 * Caches JWKS values for all clients created in the same environment. This is
 * especially useful for shared-memory execution environments such as Vercel's
 * Fluid Compute, AWS Lambda or Supabase's Edge Functions. Regardless of how
 * many clients are created, if they share the same storage key they will use
 * the same JWKS cache, significantly speeding up getClaims() with asymmetric
 * JWTs.
 */ const $787713ac43d87621$var$GLOBAL_JWKS = {};
// Warn once per JS realm, not per client instance — server-side apps can
// construct many clients per process and must not be spammed.
let $787713ac43d87621$var$deprecatedLockWarned = false;
class $787713ac43d87621$var$GoTrueClient {
    /**
     * The JWKS used for verifying asymmetric JWTs
     */ get jwks() {
        var _a, _b;
        return (_b = (_a = $787713ac43d87621$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.jwks) !== null && _b !== void 0 ? _b : {
            keys: []
        };
    }
    set jwks(value) {
        $787713ac43d87621$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $787713ac43d87621$var$GLOBAL_JWKS[this.storageKey]), {
            jwks: value
        });
    }
    get jwks_cached_at() {
        var _a, _b;
        return (_b = (_a = $787713ac43d87621$var$GLOBAL_JWKS[this.storageKey]) === null || _a === void 0 ? void 0 : _a.cachedAt) !== null && _b !== void 0 ? _b : Number.MIN_SAFE_INTEGER;
    }
    set jwks_cached_at(value) {
        $787713ac43d87621$var$GLOBAL_JWKS[this.storageKey] = Object.assign(Object.assign({}, $787713ac43d87621$var$GLOBAL_JWKS[this.storageKey]), {
            cachedAt: value
        });
    }
    /**
     * Create a new client for use in the browser.
     *
     * @example Using supabase-js (recommended)
     * ```ts
     * import { createClient } from '@supabase/supabase-js'
     *
     * const supabase = createClient('https://xyzcompany.supabase.co', 'your-publishable-key')
     * const { data, error } = await supabase.auth.getUser()
     * ```
     *
     * @example Standalone import for bundle-sensitive environments
     * ```ts
     * import { GoTrueClient } from '@supabase/auth-js'
     *
     * const auth = new GoTrueClient({
     *   url: 'https://xyzcompany.supabase.co/auth/v1',
     *   headers: { apikey: 'your-publishable-key' },
     *   storageKey: 'supabase-auth',
     * })
     * ```
     */ constructor(options){
        var _a, _b, _c;
        /**
         * @experimental
         */ this.userStorage = null;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.autoRefreshTickTimeout = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Cache of the most recent refresh failure, keyed by the refresh token
         * that failed. Serial callers passing the *same* token within
         * `REFRESH_FAILURE_COOLDOWN_MS` (including subsequent auto-refresh ticks)
         * receive this cached result instead of firing another `/token` request.
         * Callers passing a *different* token (token rotation pickup, explicit
         * `setSession`/`refreshSession({ refresh_token })`, multi-account switch)
         * bypass the cache and attempt a fresh refresh as they should.
         * Cleared on any successful refresh (locally or via BroadcastChannel from
         * another tab) and on `_removeSession`.
         *
         * Pairs with `refreshingDeferred`: concurrent callers share the in-flight
         * promise, serial callers within the cooldown share the failure result.
         */ this.lastRefreshFailure = null;
        /**
         * Monotonic counter incremented at the top of `_removeSession`, before any
         * `await`. The commit guard inside `_callRefreshToken` captures this value
         * before `_saveSession` and re-checks it after, so a `signOut` that
         * interleaves inside `_saveSession`'s storage-write awaits is still caught
         * (the post-fetch storage snapshot alone misses that window).
         */ this._sessionRemovalEpoch = 0;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the auth state is known and it's safe to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        /**
         * Non-null only while `initialize()` is running. While open,
         * `_notifyAllSubscribers` enqueues init-chain notifications (those fired with
         * `broadcast = true`, i.e. from `_recoverAndRefresh`) into this array instead
         * of firing directly, so that `initializePromise` is guaranteed to be
         * resolved before any subscriber callback runs. Callbacks that call
         * `getSession()` / `getUser()` etc. would otherwise deadlock because those
         * methods await `initializePromise`. Notifications from the incoming
         * BroadcastChannel handler (`broadcast = false`) are not enqueued — they fire
         * immediately. Flushed (in order) by `initialize()` after `initializePromise`
         * settles.
         */ this._pendingInitNotifications = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        /**
         * Custom lock function passed via `settings.lock`. When non-null, every auth
         * operation runs inside `_acquireLock`. When null (the default), the client
         * uses its lockless coordination (refresh single-flight + commit guard).
         * TODO(v3): remove along with the legacy lock path.
         */ this.lock = null;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        const settings = Object.assign(Object.assign({}, $787713ac43d87621$var$DEFAULT_OPTIONS), options);
        this.storageKey = settings.storageKey;
        this.instanceID = (_a = $787713ac43d87621$var$GoTrueClient.nextInstanceID[this.storageKey]) !== null && _a !== void 0 ? _a : 0;
        $787713ac43d87621$var$GoTrueClient.nextInstanceID[this.storageKey] = this.instanceID + 1;
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        if (this.instanceID > 0 && (0, $9tGer.isBrowser)()) {
            const message = `${this._logPrefix()} Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.`;
            console.warn(message);
            if (this.logDebugMessages) console.trace(message);
        }
        this.persistSession = settings.persistSession;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.experimental = (_b = settings.experimental) !== null && _b !== void 0 ? _b : {};
        this.admin = new (0, $9Errw.default)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch,
            experimental: this.experimental
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $9tGer.resolveFetch)(settings.fetch);
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        this.throwOnError = settings.throwOnError;
        // Always wire `lockAcquireTimeout` even on the lockless path: consumers
        // (including supabase-js tests) read it off the client to verify option
        // flow-through.
        this.lockAcquireTimeout = settings.lockAcquireTimeout;
        // TODO(v3): remove. Legacy opt-in path preserved for backwards
        // compatibility with callers passing a custom `lock` (typically React
        // Native `processLock` or Node multi-process setups). When `settings.lock`
        // is null the client uses its lockless coordination — no `navigator.locks`
        // by default, no implicit `processLock`.
        if (settings.lock != null) {
            this.lock = settings.lock;
            if (!$787713ac43d87621$var$deprecatedLockWarned) {
                $787713ac43d87621$var$deprecatedLockWarned = true;
                console.warn(`${this._logPrefix()} The "lock" option is deprecated and will be removed in v3. The client now coordinates session refreshes without a lock, so most apps can drop the option. See https://github.com/supabase/supabase-js/blob/master/packages/core/auth-js/migrations/lockless-coordination.md`);
            }
        }
        if (!this.jwks) {
            this.jwks = {
                keys: []
            };
            this.jwks_cached_at = Number.MIN_SAFE_INTEGER;
        }
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this),
            webauthn: new (0, $ctRCA.WebAuthnApi)(this),
            recoveryCodes: {
                getStatus: this._getRecoveryCodesStatus.bind(this),
                generate: this._generateRecoveryCodes.bind(this),
                verify: this._verifyRecoveryCode.bind(this),
                regenerate: this._regenerateRecoveryCodes.bind(this),
                unenroll: this._unenrollRecoveryCodes.bind(this)
            }
        };
        this.oauth = {
            getAuthorizationDetails: this._getAuthorizationDetails.bind(this),
            approveAuthorization: this._approveAuthorization.bind(this),
            denyAuthorization: this._denyAuthorization.bind(this),
            listGrants: this._listOAuthGrants.bind(this),
            revokeGrant: this._revokeOAuthGrant.bind(this)
        };
        this.passkey = {
            startRegistration: this._startPasskeyRegistration.bind(this),
            verifyRegistration: this._verifyPasskeyRegistration.bind(this),
            startAuthentication: this._startPasskeyAuthentication.bind(this),
            verifyAuthentication: this._verifyPasskeyAuthentication.bind(this),
            list: this._listPasskeys.bind(this),
            update: this._updatePasskey.bind(this),
            delete: this._deletePasskey.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $9tGer.supportsLocalStorage)()) this.storage = globalThis.localStorage;
            else {
                this.memoryStorage = {};
                this.storage = (0, $i5VQk.memoryLocalStorageAdapter)(this.memoryStorage);
            }
            if (settings.userStorage) this.userStorage = settings.userStorage;
        } else {
            this.memoryStorage = {};
            this.storage = (0, $i5VQk.memoryLocalStorageAdapter)(this.memoryStorage);
        }
        if ((0, $9tGer.isBrowser)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_c = this.broadcastChannel) === null || _c === void 0 || _c.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                // Another tab successfully refreshed or signed in — any cached
                // failure in this tab is stale and should not block the next
                // refresh attempt.
                if (event.data.event === 'TOKEN_REFRESHED' || event.data.event === 'SIGNED_IN') this.lastRefreshFailure = null;
                try {
                    await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
                } catch (error) {
                    this._debug('#broadcastChannel', 'error', error);
                }
            });
        }
        // Only auto-initialize if not explicitly disabled. Skipped in SSR contexts
        // where initialization timing must be controlled. All public methods have
        // lazy initialization, so the client remains fully functional.
        if (!settings.skipAutoInitialize) this.initialize().catch((error)=>{
            this._debug('#initialize()', 'error', error);
        });
    }
    /**
     * Returns whether error throwing mode is enabled for this client.
     */ isThrowOnErrorEnabled() {
        return this.throwOnError;
    }
    /**
     * Centralizes return handling with optional error throwing. When `throwOnError` is enabled
     * and the provided result contains a non-nullish error, the error is thrown instead of
     * being returned. This ensures consistent behavior across all public API methods.
     */ _returnResult(result) {
        if (this.throwOnError && result && result.error) throw result.error;
        return result;
    }
    _logPrefix() {
        return 'GoTrueClient@' + `${this.storageKey}:${this.instanceID} (${0, $42vUz.version}) ${new Date().toISOString()}`;
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(this._logPrefix(), ...args);
        return this;
    }
    /**
     * Initialize the auth client by loading the session from storage or
     * detecting it from the URL after an OAuth, magic-link, or password-recovery
     * redirect.
     *
     * **Most callers do not need to invoke this directly.** The client calls it
     * automatically during construction, and to react to sign-in events (including
     * post-redirect events) you should subscribe to `onAuthStateChange` rather
     * than awaiting `initialize()`.
     *
     * You only need to call it manually when you have opted out of the automatic
     * call by passing `skipAutoInitialize: true` — for example, in an SSR context
     * where you need to control initialization timing. In that case, awaiting
     * `initialize()` returns the resolved session result (or any error encountered
     * while detecting it from the URL).
     *
     * @category Auth
     */ async initialize() {
        var _a;
        if (this.initializePromise) return await this.initializePromise;
        // Open the notification queue before _initialize() runs so that every
        // _notifyAllSubscribers call inside the init chain enqueues instead of
        // firing. Without this, a callback receiving SIGNED_IN (or TOKEN_REFRESHED
        // / SIGNED_OUT) during _recoverAndRefresh would deadlock if it called
        // getSession() / getUser() — those methods await initializePromise, which
        // can only resolve after the callback returns, which can only return after
        // getSession() resolves. The queue is flushed below after initializePromise
        // has settled, so callbacks run with a fully resolved initializePromise.
        this._pendingInitNotifications = [];
        this.initializePromise = (async ()=>{
            if (this.lock != null) // TODO(v3): remove legacy lock path
            return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                return await this._initialize();
            });
            return await this._initialize();
        })();
        const result = await this.initializePromise;
        // initializePromise is now resolved — flush queued notifications in order.
        // Callbacks can safely call getSession() / getUser() / signOut() etc.
        const queue = (_a = this._pendingInitNotifications) !== null && _a !== void 0 ? _a : [];
        this._pendingInitNotifications = null;
        for (const n of queue)await this._notifyAllSubscribers(n.event, n.session, n.broadcast);
        return result;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            let params = {};
            let callbackUrlType = 'none';
            if ((0, $9tGer.isBrowser)()) {
                params = (0, $9tGer.parseParametersFromURL)(window.location.href);
                if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
                else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            }
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, $9tGer.isBrowser)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data: data, error: error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, $e1qhh.isAuthImplicitGrantRedirectError)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error: error
                        };
                    }
                    // Don't remove existing session on URL login failure.
                    // A failed attempt (e.g. reused magic link) shouldn't invalidate a valid session.
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                error: error
            });
            return this._returnResult({
                error: new (0, $e1qhh.AuthUnknownError)('Unexpected error during initialization', error)
            });
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     *
     * @category Auth
     *
     * @remarks
     * - Returns an anonymous user
     * - It is recommended to set up captcha for anonymous sign-ins to prevent abuse. You can pass in the captcha token in the `options` param.
     *
     * @example Create an anonymous user
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     captchaToken
     *   }
     * });
     * ```
     *
     * @exampleResponse Create an anonymous user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {},
     *       "user_metadata": {},
     *       "identities": [],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": true
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {},
     *         "user_metadata": {},
     *         "identities": [],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": true
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Create an anonymous user with custom user metadata
     * ```js
     * const { data, error } = await supabase.auth.signInAnonymously({
     *   options: {
     *     data
     *   }
     * })
     * ```
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, $chSC8._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error || !data) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     *
     * @category Auth
     *
     * @remarks
     * - By default, the user needs to verify their email address before logging in. To turn this off, disable **Confirm email** in [your project](/dashboard/project/_/auth/providers).
     * - **Confirm email** determines if users need to confirm their email address after signing up.
     *   - If **Confirm email** is enabled, a `user` is returned but `session` is null.
     *   - If **Confirm email** is disabled, both a `user` and a `session` are returned.
     * - When the user confirms their email address, they are redirected to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) by default. You can modify your `SITE_URL` or add additional redirect URLs in [your project](/dashboard/project/_/auth/url-configuration).
     * - If signUp() is called for an existing confirmed user:
     *   - When both **Confirm email** and **Confirm phone** (even when phone provider is disabled) are enabled in [your project](/dashboard/project/_/auth/providers), an obfuscated/fake user object is returned.
     *   - When either **Confirm email** or **Confirm phone** (even when phone provider is disabled) is disabled, the error message, `User already registered` is returned.
     * - To fetch the currently logged-in user, refer to [`getUser()`](/docs/reference/javascript/auth-getuser).
     *
     * @example Sign up with an email and password
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign up with an email and password
     * ```json
     * // Some fields may be null if "confirm email" is enabled.
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign up with a phone number and password (SMS)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'sms'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign up with a phone number and password (whatsapp)
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign up with a phone number and password (whatsapp)
     * ```js
     * const { data, error } = await supabase.auth.signUp({
     *   phone: '123456789',
     *   password: 'example-password',
     *   options: {
     *     channel: 'whatsapp'
     *   }
     * })
     * ```
     *
     * @example Sign up with additional user metadata
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       data: {
     *         first_name: 'John',
     *         age: 27,
     *       }
     *     }
     *   }
     * )
     * ```
     *
     * @exampleDescription Sign up with a redirect URL
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign up with a redirect URL
     * ```js
     * const { data, error } = await supabase.auth.signUp(
     *   {
     *     email: 'example@email.com',
     *     password: 'example-password',
     *     options: {
     *       emailRedirectTo: 'https://example.com/welcome'
     *     }
     *   }
     * )
     * ```
     */ async signUp(credentials) {
        var _a, _b, _c;
        let flowId = null;
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod, flowId] = await this._getCodeChallengeAndMethod();
                res = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: this._maybeAppendFlowIdToRedirect(options === null || options === void 0 ? void 0 : options.emailRedirectTo, flowId),
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $chSC8._sessionResponse)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $chSC8._sessionResponse)
                });
            } else throw new (0, $e1qhh.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error || !data) {
                await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email and password or a phone number and password.
     *
     * @example Sign in with email and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * ```
     *
     * @exampleResponse Sign in with email and password
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {},
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z"
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {},
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z"
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Sign in with phone and password
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   phone: '+13334445555',
     *   password: 'some-password',
     * })
     * ```
     *
     * @exampleDescription Handling errors
     * Log the full `error` object so fields like `code`, `status`, and `name` aren't hidden. The `error.code` (e.g. `'invalid_credentials'`, `'email_not_confirmed'`) is often more useful for branching than `error.message`, and the full object surfaces both.
     *
     * @example Handling errors
     * ```js
     * const { data, error } = await supabase.auth.signInWithPassword({
     *   email: 'example@email.com',
     *   password: 'example-password',
     * })
     * if (error) {
     *   console.error(error)
     *   return
     * }
     * ```
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $chSC8._sessionResponsePassword)
                });
            } else if ('phone' in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $chSC8._sessionResponsePassword)
                });
            } else throw new (0, $e1qhh.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $e1qhh.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used for signing in using [Social Login (OAuth) providers](/docs/guides/auth#configure-third-party-providers).
     * - It works by redirecting your application to the provider's authorization screen, before bringing back the user to your app.
     *
     * @example Sign in using a third-party provider
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Sign in using a third-party provider
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>,
     *     flowId: <PKCE_FLOW_ID_OR_NULL>
     *   },
     *   error: null
     * }
     * ```
     *
     * @exampleDescription Sign in using a third-party provider with redirect
     * - When the OAuth provider successfully authenticates the user, they are redirected to the URL specified in the `redirectTo` parameter. This parameter defaults to the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls). It does not redirect the user immediately after invoking this method.
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     *
     * @example Sign in using a third-party provider with redirect
     * ```js
     * const { data, error } = await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     redirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Sign in with scopes and access provider tokens
     * If you need additional access from an OAuth provider, in order to access provider specific APIs in the name of the user, you can do this by passing in the scopes the user should authorize for your application. Note that the `scopes` option takes in **a space-separated list** of scopes.
     *
     * Because OAuth sign-in often includes redirects, you should register an `onAuthStateChange` callback immediately after you create the Supabase client. This callback will listen for the presence of `provider_token` and `provider_refresh_token` properties on the `session` object and store them in local storage. The client library will emit these values **only once** immediately after the user signs in. You can then access them by looking them up in local storage, or send them to your backend servers for further processing.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Sign in with scopes and access provider tokens
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     *
     * // Call this on your Sign in with GitHub button to initiate OAuth
     * // with GitHub with the requested elevated scopes.
     * await supabase.auth.signInWithOAuth({
     *   provider: 'github',
     *   options: {
     *     scopes: 'repo gist notifications'
     *   }
     * })
     * ```
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     *
     * @category Auth
     *
     * @remarks
     * - Used when `flowType` is set to `pkce` in client options.
     * - When several PKCE flows are in flight at once, pass `options.flowId` so
     *   the code is exchanged with the verifier created by that specific flow.
     *   The flow id is returned by `signInWithOAuth`, and with
     *   `experimental.appendPkceFlowIdToRedirects` enabled it also arrives on
     *   your callback URL as the reserved `sb_flow_id` query parameter (read
     *   automatically in a browser).
     * - When a flow id is present but its stored verifier is gone (evicted,
     *   already used, or from another device), the call fails with a verifier
     *   missing error instead of trying another flow's verifier — a mismatched
     *   verifier would consume the single-use code. Without any flow id the
     *   most recently stored verifier is used, as before.
     *
     * @example Exchange Auth Code
     * ```js
     * supabase.auth.exchangeCodeForSession('34e770dd-9ff9-416c-87fa-43b31d7ef225')
     * ```
     *
     * @example Exchange Auth Code for a specific flow (e.g. in a server-side callback handler)
     * ```js
     * const flowId = requestUrl.searchParams.get('sb_flow_id')
     * supabase.auth.exchangeCodeForSession(code, flowId ? { flowId } : undefined)
     * ```
     *
     * @exampleResponse Exchange Auth Code
     * ```json
     * {
     *   "data": {
     *     session: {
     *       access_token: '<ACCESS_TOKEN>',
     *       token_type: 'bearer',
     *       expires_in: 3600,
     *       expires_at: 1700000000,
     *       refresh_token: '<REFRESH_TOKEN>',
     *       user: {
     *         id: '11111111-1111-1111-1111-111111111111',
     *         aud: 'authenticated',
     *         role: 'authenticated',
     *         email: 'example@email.com'
     *         email_confirmed_at: '2024-01-01T00:00:00Z',
     *         phone: '',
     *         confirmation_sent_at: '2024-01-01T00:00:00Z',
     *         confirmed_at: '2024-01-01T00:00:00Z',
     *         last_sign_in_at: '2024-01-01T00:00:00Z',
     *         app_metadata: {
     *           "provider": "email",
     *           "providers": [
     *             "email",
     *             "<OTHER_PROVIDER>"
     *           ]
     *         },
     *         user_metadata: {
     *           email: 'email@email.com',
     *           email_verified: true,
     *           full_name: 'User Name',
     *           iss: '<ISS>',
     *           name: 'User Name',
     *           phone_verified: false,
     *           provider_id: '<PROVIDER_ID>',
     *           sub: '<SUB>'
     *         },
     *         identities: [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "email@example.com"
     *           },
     *           {
     *             "identity_id": "33333333-3333-3333-3333-333333333333",
     *             "id": "<ID>",
     *             "user_id": "<USER_ID>",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": true,
     *               "full_name": "User Name",
     *               "iss": "<ISS>",
     *               "name": "User Name",
     *               "phone_verified": false,
     *               "provider_id": "<PROVIDER_ID>",
     *               "sub": "<SUB>"
     *             },
     *             "provider": "<PROVIDER>",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         created_at: '2024-01-01T00:00:00Z',
     *         updated_at: '2024-01-01T00:00:00Z',
     *         is_anonymous: false
     *       },
     *       provider_token: '<PROVIDER_TOKEN>',
     *       provider_refresh_token: '<PROVIDER_REFRESH_TOKEN>'
     *     },
     *     user: {
     *       id: '11111111-1111-1111-1111-111111111111',
     *       aud: 'authenticated',
     *       role: 'authenticated',
     *       email: 'example@email.com',
     *       email_confirmed_at: '2024-01-01T00:00:00Z',
     *       phone: '',
     *       confirmation_sent_at: '2024-01-01T00:00:00Z',
     *       confirmed_at: '2024-01-01T00:00:00Z',
     *       last_sign_in_at: '2024-01-01T00:00:00Z',
     *       app_metadata: {
     *         provider: 'email',
     *         providers: [
     *           "email",
     *           "<OTHER_PROVIDER>"
     *         ]
     *       },
     *       user_metadata: {
     *         email: 'email@email.com',
     *         email_verified: true,
     *         full_name: 'User Name',
     *         iss: '<ISS>',
     *         name: 'User Name',
     *         phone_verified: false,
     *         provider_id: '<PROVIDER_ID>',
     *         sub: '<SUB>'
     *       },
     *       identities: [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "email@example.com"
     *         },
     *         {
     *           "identity_id": "33333333-3333-3333-3333-333333333333",
     *           "id": "<ID>",
     *           "user_id": "<USER_ID>",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": true,
     *             "full_name": "User Name",
     *             "iss": "<ISS>",
     *             "name": "User Name",
     *             "phone_verified": false,
     *             "provider_id": "<PROVIDER_ID>",
     *             "sub": "<SUB>"
     *           },
     *           "provider": "<PROVIDER>",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       created_at: '2024-01-01T00:00:00Z',
     *       updated_at: '2024-01-01T00:00:00Z',
     *       is_anonymous: false
     *     },
     *     redirectType: null
     *   },
     *   "error": null
     * }
     * ```
     */ async exchangeCodeForSession(authCode, options) {
        await this.initializePromise;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._exchangeCodeForSession(authCode, options);
        });
        return this._exchangeCodeForSession(authCode, options);
    }
    /**
     * Signs in a user by verifying a message signed by the user's private key.
     * Supports Ethereum (via Sign-In-With-Ethereum) & Solana (Sign-In-With-Solana) standards,
     * both of which derive from the EIP-4361 standard
     * With slight variation on Solana's side.
     * @reference https://eips.ethereum.org/EIPS/eip-4361
     *
     * @category Auth
     *
     * @remarks
     * - Uses a Web3 (Ethereum, Solana) wallet to sign a user in.
     * - Read up on the [potential for abuse](/docs/guides/auth/auth-web3#potential-for-abuse) before using it.
     *
     * @example Sign in with Solana or Ethereum (Window API)
     * ```js
     *   // uses window.ethereum for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     *
     *   // uses window.solana for the wallet
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos'
     *   })
     * ```
     *
     * @example Sign in with Ethereum (Message and Signature)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'ethereum',
     *     message: '<sign in with ethereum message>',
     *     signature: '<hex of the ethereum signature over the message>',
     *   })
     * ```
     *
     * @example Sign in with Solana (Brave)
     * ```js
     *   const { data, error } = await supabase.auth.signInWithWeb3({
     *     chain: 'solana',
     *     statement: 'I accept the Terms of Service at https://example.com/tos',
     *     wallet: window.braveSolana
     *   })
     * ```
     *
     * @example Sign in with Solana (Wallet Adapter)
     * ```jsx
     *   function SignInButton() {
     *   const wallet = useWallet()
     *
     *   return (
     *     <>
     *       {wallet.connected ? (
     *         <button
     *           onClick={() => {
     *             supabase.auth.signInWithWeb3({
     *               chain: 'solana',
     *               statement: 'I accept the Terms of Service at https://example.com/tos',
     *               wallet,
     *             })
     *           }}
     *         >
     *           Sign in with Solana
     *         </button>
     *       ) : (
     *         <WalletMultiButton />
     *       )}
     *     </>
     *   )
     * }
     *
     * function App() {
     *   const endpoint = clusterApiUrl('devnet')
     *   const wallets = useMemo(() => [], [])
     *
     *   return (
     *     <ConnectionProvider endpoint={endpoint}>
     *       <WalletProvider wallets={wallets}>
     *         <WalletModalProvider>
     *           <SignInButton />
     *         </WalletModalProvider>
     *       </WalletProvider>
     *     </ConnectionProvider>
     *   )
     * }
     * ```
     */ async signInWithWeb3(credentials) {
        const { chain: chain } = credentials;
        switch(chain){
            case 'ethereum':
                return await this.signInWithEthereum(credentials);
            case 'solana':
                return await this.signInWithSolana(credentials);
            default:
                throw new Error(`@supabase/auth-js: Unsupported chain "${chain}"`);
        }
    }
    async signInWithEthereum(credentials) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m;
        // TODO: flatten type
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $9tGer.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('ethereum' in windowAny && typeof windowAny.ethereum === 'object' && 'request' in windowAny.ethereum && typeof windowAny.ethereum.request === 'function') resolvedWallet = windowAny.ethereum;
                else throw new Error(`@supabase/auth-js: No compatible Ethereum wallet interface on the window object (window.ethereum) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'ethereum', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            const accounts = await resolvedWallet.request({
                method: 'eth_requestAccounts'
            }).then((accs)=>accs).catch(()=>{
                throw new Error(`@supabase/auth-js: Wallet method eth_requestAccounts is missing or invalid`);
            });
            if (!accounts || accounts.length === 0) throw new Error(`@supabase/auth-js: No accounts available. Please ensure the wallet is connected.`);
            const address = (0, $bJ1Vx.getAddress)(accounts[0]);
            let chainId = (_b = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _b === void 0 ? void 0 : _b.chainId;
            if (!chainId) {
                const chainIdHex = await resolvedWallet.request({
                    method: 'eth_chainId'
                });
                chainId = (0, $bJ1Vx.fromHex)(chainIdHex);
            }
            const siweMessage = {
                domain: url.host,
                address: address,
                statement: statement,
                uri: url.href,
                version: '1',
                chainId: chainId,
                nonce: (_c = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _c === void 0 ? void 0 : _c.nonce,
                issuedAt: (_f = (_d = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _d === void 0 ? void 0 : _d.issuedAt) !== null && _f !== void 0 ? _f : new Date(),
                expirationTime: (_g = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _g === void 0 ? void 0 : _g.expirationTime,
                notBefore: (_h = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _h === void 0 ? void 0 : _h.notBefore,
                requestId: (_j = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _j === void 0 ? void 0 : _j.requestId,
                resources: (_k = options === null || options === void 0 ? void 0 : options.signInWithEthereum) === null || _k === void 0 ? void 0 : _k.resources
            };
            message = (0, $bJ1Vx.createSiweMessage)(siweMessage);
            // Sign message
            signature = await resolvedWallet.request({
                method: 'personal_sign',
                params: [
                    (0, $bJ1Vx.toHex)(message),
                    address
                ]
            });
        }
        try {
            const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'ethereum',
                    message: message,
                    signature: signature
                }, ((_l = credentials.options) === null || _l === void 0 ? void 0 : _l.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken
                    }
                } : null),
                xform: (0, $chSC8._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $e1qhh.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async signInWithSolana(credentials) {
        var _a, _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o;
        let message;
        let signature;
        if ('message' in credentials) {
            message = credentials.message;
            signature = credentials.signature;
        } else {
            const { chain: chain, wallet: wallet, statement: statement, options: options } = credentials;
            let resolvedWallet;
            if (!(0, $9tGer.isBrowser)()) {
                if (typeof wallet !== 'object' || !(options === null || options === void 0 ? void 0 : options.url)) throw new Error('@supabase/auth-js: Both wallet and url must be specified in non-browser environments.');
                resolvedWallet = wallet;
            } else if (typeof wallet === 'object') resolvedWallet = wallet;
            else {
                const windowAny = window;
                if ('solana' in windowAny && typeof windowAny.solana === 'object' && ('signIn' in windowAny.solana && typeof windowAny.solana.signIn === 'function' || 'signMessage' in windowAny.solana && typeof windowAny.solana.signMessage === 'function')) resolvedWallet = windowAny.solana;
                else throw new Error(`@supabase/auth-js: No compatible Solana wallet interface on the window object (window.solana) detected. Make sure the user already has a wallet installed and connected for this app. Prefer passing the wallet interface object directly to signInWithWeb3({ chain: 'solana', wallet: resolvedUserWallet }) instead.`);
            }
            const url = new URL((_a = options === null || options === void 0 ? void 0 : options.url) !== null && _a !== void 0 ? _a : window.location.href);
            if ('signIn' in resolvedWallet && resolvedWallet.signIn) {
                const output = await resolvedWallet.signIn(Object.assign(Object.assign(Object.assign({
                    issuedAt: new Date().toISOString()
                }, options === null || options === void 0 ? void 0 : options.signInWithSolana), {
                    // non-overridable properties
                    version: '1',
                    domain: url.host,
                    uri: url.href
                }), statement ? {
                    statement: statement
                } : null));
                let outputToProcess;
                if (Array.isArray(output) && output[0] && typeof output[0] === 'object') outputToProcess = output[0];
                else if (output && typeof output === 'object' && 'signedMessage' in output && 'signature' in output) outputToProcess = output;
                else throw new Error('@supabase/auth-js: Wallet method signIn() returned unrecognized value');
                if ('signedMessage' in outputToProcess && 'signature' in outputToProcess && (typeof outputToProcess.signedMessage === 'string' || outputToProcess.signedMessage instanceof Uint8Array) && outputToProcess.signature instanceof Uint8Array) {
                    message = typeof outputToProcess.signedMessage === 'string' ? outputToProcess.signedMessage : new TextDecoder().decode(outputToProcess.signedMessage);
                    signature = outputToProcess.signature;
                } else throw new Error('@supabase/auth-js: Wallet method signIn() API returned object without signedMessage and signature fields');
            } else {
                if (!('signMessage' in resolvedWallet) || typeof resolvedWallet.signMessage !== 'function' || !('publicKey' in resolvedWallet) || typeof resolvedWallet !== 'object' || !resolvedWallet.publicKey || !('toBase58' in resolvedWallet.publicKey) || typeof resolvedWallet.publicKey.toBase58 !== 'function') throw new Error('@supabase/auth-js: Wallet does not have a compatible signMessage() and publicKey.toBase58() API');
                message = [
                    `${url.host} wants you to sign in with your Solana account:`,
                    resolvedWallet.publicKey.toBase58(),
                    ...statement ? [
                        '',
                        statement,
                        ''
                    ] : [
                        ''
                    ],
                    'Version: 1',
                    `URI: ${url.href}`,
                    `Issued At: ${(_c = (_b = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _b === void 0 ? void 0 : _b.issuedAt) !== null && _c !== void 0 ? _c : new Date().toISOString()}`,
                    ...((_d = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _d === void 0 ? void 0 : _d.notBefore) ? [
                        `Not Before: ${options.signInWithSolana.notBefore}`
                    ] : [],
                    ...((_f = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _f === void 0 ? void 0 : _f.expirationTime) ? [
                        `Expiration Time: ${options.signInWithSolana.expirationTime}`
                    ] : [],
                    ...((_g = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _g === void 0 ? void 0 : _g.chainId) ? [
                        `Chain ID: ${options.signInWithSolana.chainId}`
                    ] : [],
                    ...((_h = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _h === void 0 ? void 0 : _h.nonce) ? [
                        `Nonce: ${options.signInWithSolana.nonce}`
                    ] : [],
                    ...((_j = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _j === void 0 ? void 0 : _j.requestId) ? [
                        `Request ID: ${options.signInWithSolana.requestId}`
                    ] : [],
                    ...((_l = (_k = options === null || options === void 0 ? void 0 : options.signInWithSolana) === null || _k === void 0 ? void 0 : _k.resources) === null || _l === void 0 ? void 0 : _l.length) ? [
                        'Resources',
                        ...options.signInWithSolana.resources.map((resource)=>`- ${resource}`)
                    ] : []
                ].join('\n');
                const maybeSignature = await resolvedWallet.signMessage(new TextEncoder().encode(message), 'utf8');
                if (!maybeSignature || !(maybeSignature instanceof Uint8Array)) throw new Error('@supabase/auth-js: Wallet signMessage() API returned an recognized value');
                signature = maybeSignature;
            }
        }
        try {
            const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=web3`, {
                headers: this.headers,
                body: Object.assign({
                    chain: 'solana',
                    message: message,
                    signature: (0, $PVTtI.bytesToBase64URL)(signature)
                }, ((_m = credentials.options) === null || _m === void 0 ? void 0 : _m.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: (_o = credentials.options) === null || _o === void 0 ? void 0 : _o.captchaToken
                    }
                } : null),
                xform: (0, $chSC8._sessionResponse)
            });
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $e1qhh.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign({}, data),
                error: error
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    async _exchangeCodeForSession(authCode, options) {
        const hasExplicitFlowId = (options === null || options === void 0 ? void 0 : options.flowId) != null;
        const requestedFlowId = hasExplicitFlowId ? (0, $9tGer.validatePKCEFlowId)(options === null || options === void 0 ? void 0 : options.flowId) : (0, $9tGer.isBrowser)() ? (0, $9tGer.validatePKCEFlowId)((0, $9tGer.parseParametersFromURL)(window.location.href)[0, $nTVnO.PKCE_FLOW_ID_PARAM]) : null;
        if (hasExplicitFlowId && !requestedFlowId) this._debug('#_exchangeCodeForSession()', 'provided flowId is not a valid flow id', options === null || options === void 0 ? void 0 : options.flowId);
        // With a flow id (explicit or from the callback URL) the lookup is
        // slot-only and a miss fails fast — see retrievePKCEVerifier. An invalid
        // explicit flow id also fails fast rather than borrowing another flow's
        // verifier.
        const { verifier: storageItem, flowId: flowId } = hasExplicitFlowId && !requestedFlowId ? {
            verifier: null,
            flowId: null
        } : await (0, $9tGer.retrievePKCEVerifier)(this.storage, this.storageKey, requestedFlowId);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            if (!codeVerifier && this.flowType === 'pkce') throw new (0, $e1qhh.AuthPKCECodeVerifierMissingError)();
            const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, $chSC8._sessionResponse)
            });
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if (error) throw error;
            if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $e1qhh.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        redirectType: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers(redirectType === 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error: error
            });
        } catch (error) {
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     *
     * @category Auth
     *
     * @remarks
     * - Use an ID token to sign in.
     * - Especially useful when implementing sign in using native platform dialogs in mobile or desktop apps using Sign in with Apple or Sign in with Google on iOS and Android.
     * - You can also use Google's [One Tap](https://developers.google.com/identity/gsi/web/guides/display-google-one-tap) and [Automatic sign-in](https://developers.google.com/identity/gsi/web/guides/automatic-sign-in-sign-out) via this API.
     *
     * @example Sign In using ID Token
     * ```js
     * const { data, error } = await supabase.auth.signInWithIdToken({
     *   provider: 'google',
     *   token: 'your-id-token'
     * })
     * ```
     *
     * @exampleResponse Sign In using ID Token
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         ...
     *       },
     *       "user_metadata": {
     *         ...
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "provider": "google",
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           ...
     *         },
     *         "user_metadata": {
     *           ...
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "provider": "google",
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async signInWithIdToken(credentials) {
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $chSC8._sessionResponse)
            });
            const { data: data, error: error } = res;
            if (error) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            else if (!data || !data.session || !data.user) {
                const invalidTokenError = new (0, $e1qhh.AuthInvalidTokenResponseError)();
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: invalidTokenError
                });
            }
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: error
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     *
     * @category Auth
     *
     * @remarks
     * - Requires either an email or phone number.
     * - This method is used for passwordless sign-ins where a OTP is sent to the user's email or phone number.
     * - If the user doesn't exist, `signInWithOtp()` will signup the user instead. To restrict this behavior, you can set `shouldCreateUser` in `SignInWithPasswordlessCredentials.options` to `false`.
     * - If you're using an email, you can configure whether you want the user to receive a magiclink or a OTP.
     * - If you're using phone, you can configure whether you want the user to receive a OTP.
     * - The magic link's destination URL is determined by the [`SITE_URL`](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls).
     * - See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - Magic links and OTPs share the same implementation. To send users a one-time code instead of a magic link, [modify the magic link email template](/dashboard/project/_/auth/templates) to include `{{ .Token }}` instead of `{{ .ConfirmationURL }}`.
     * - See our [Twilio Phone Auth Guide](/docs/guides/auth/phone-login?showSMSProvider=Twilio) for details about configuring WhatsApp sign in.
     *
     * @exampleDescription Sign in with email
     * The user will be sent an email which contains either a magiclink or a OTP or both. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with email
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   email: 'example@email.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleResponse Sign in with email
     * ```json
     * {
     *   "data": {
     *     "user": null,
     *     "session": null
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Sign in with SMS OTP
     * The user will be sent a SMS which contains a OTP. By default, a given user can only request a OTP once every 60 seconds.
     *
     * @example Sign in with SMS OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     * })
     * ```
     *
     * @exampleDescription Sign in with WhatsApp OTP
     * The user will be sent a WhatsApp message which contains a OTP. By default, a given user can only request a OTP once every 60 seconds. Note that a user will need to have a valid WhatsApp account that is linked to Twilio in order to use this feature.
     *
     * @example Sign in with WhatsApp OTP
     * ```js
     * const { data, error } = await supabase.auth.signInWithOtp({
     *   phone: '+13334445555',
     *   options: {
     *     channel:'whatsapp',
     *   }
     * })
     * ```
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _f;
        let flowId = null;
        try {
            if ('email' in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod, flowId] = await this._getCodeChallengeAndMethod();
                const { error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: this._maybeAppendFlowIdToRedirect(options === null || options === void 0 ? void 0 : options.emailRedirectTo, flowId)
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            }
            if ('phone' in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_f = options === null || options === void 0 ? void 0 : options.channel) !== null && _f !== void 0 ? _f : 'sms'
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $e1qhh.AuthInvalidCredentialsError)('You must provide either an email or phone number.');
        } catch (error) {
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     *
     * @category Auth
     *
     * @remarks
     * - The `verifyOtp` method takes in different verification types.
     * - If a phone number is used, the type can either be:
     *   1. `sms` – Used when verifying a one-time password (OTP) sent via SMS during sign-up or sign-in.
     *   2. `phone_change` – Used when verifying an OTP sent to a new phone number during a phone number update process.
     * - If an email address is used, the type can be one of the following (note: `signup` and `magiclink` types are deprecated):
     *   1. `email` – Used when verifying an OTP sent to the user's email during sign-up or sign-in.
     *   2. `recovery` – Used when verifying an OTP sent for account recovery, typically after a password reset request.
     *   3. `invite` – Used when verifying an OTP sent as part of an invitation to join a project or organization.
     *   4. `email_change` – Used when verifying an OTP sent to a new email address during an email update process.
     * - The verification type used should be determined based on the corresponding auth method called before `verifyOtp` to sign up / sign-in a user.
     * - The `TokenHash` is contained in the [email templates](/docs/guides/auth/auth-email-templates) and can be used to sign in.  You may wish to use the hash for the PKCE flow for Server Side Auth. Read [the Password-based Auth guide](/docs/guides/auth/passwords) for more details.
     *
     * @example Verify Signup One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ email, token, type: 'email'})
     * ```
     *
     * @exampleResponse Verify Signup One-Time Password (OTP)
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "recovery_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "recovery_sent_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Verify SMS One-Time Password (OTP)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ phone, token, type: 'sms'})
     * ```
     *
     * @example Verify Email Auth (Token Hash)
     * ```js
     * const { data, error } = await supabase.auth.verifyOtp({ token_hash: tokenHash, type: 'email'})
     * ```
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $chSC8._sessionResponse)
            });
            if (error) throw error;
            if (!data) {
                const tokenVerificationError = new Error('An error occurred on token verification.');
                throw tokenVerificationError;
            }
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     *
     * @category Auth
     *
     * @remarks
     * - Before you can call this method you need to [establish a connection](/docs/guides/auth/sso/auth-sso-saml#managing-saml-20-connections) to an identity provider. Use the [CLI commands](/docs/reference/cli/supabase-sso) to do this.
     * - If you've associated an email domain to the identity provider, you can use the `domain` property to start a sign-in flow.
     * - In case you need to use a different way to start the authentication flow with an identity provider, you can use the `providerId` property. For example:
     *     - Mapping specific user email addresses with an identity provider.
     *     - Using different hints to identity the identity provider to be used by the user, like a company-specific page, IP address or other tracking information.
     *
     * @example Sign in with email domain
     * ```js
     *   // You can extract the user's email domain and use it to trigger the
     *   // authentication flow with the correct identity provider.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     domain: 'company.com'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     *
     * @example Sign in with provider UUID
     * ```js
     *   // Useful when you need to map a user's sign in request according
     *   // to different rules that can't use email domains.
     *
     *   const { data, error } = await supabase.auth.signInWithSSO({
     *     providerId: '21648a9d-8d5a-4555-a9d1-d6375dc14e92'
     *   })
     *
     *   if (data?.url) {
     *     // redirect the user to the identity provider's authentication flow
     *     window.location.href = data.url
     *   }
     * ```
     */ async signInWithSSO(params) {
        var _a, _b, _c, _d;
        let flowId = null;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod, flowId] = await this._getCodeChallengeAndMethod();
            const result = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: this._maybeAppendFlowIdToRedirect((_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo, flowId)
                }), ((_b = params === null || params === void 0 ? void 0 : params.options) === null || _b === void 0 ? void 0 : _b.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $chSC8._ssoResponse)
            });
            // Automatically redirect in browser unless skipBrowserRedirect is true
            if (((_c = result.data) === null || _c === void 0 ? void 0 : _c.url) && (0, $9tGer.isBrowser)() && !((_d = params.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect)) window.location.assign(result.data.url);
            return this._returnResult(result);
        } catch (error) {
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     *
     * @category Auth
     *
     * @remarks
     * - This method is used together with `updateUser()` when a user's password needs to be updated.
     * - If you require your user to reauthenticate before updating their password, you need to enable the **Secure password change** option in your [project's email provider settings](/dashboard/project/_/auth/providers).
     * - A user is only require to reauthenticate before updating their password if **Secure password change** is enabled and the user **hasn't recently signed in**. A user is deemed recently signed in if the session was created in the last 24 hours.
     * - This method will send a nonce to the user's email. If the user doesn't have a confirmed email address, the method will send the nonce to the user's confirmed phone number instead.
     * - After receiving the OTP, include it as the `nonce` in your `updateUser()` call to finalize the password change.
     *
     * @exampleDescription Send reauthentication nonce
     * Sends a reauthentication nonce to the user's email or phone number.
     *
     * @example Send reauthentication nonce
     * ```js
     * const { error } = await supabase.auth.reauthenticate()
     * ```
     */ async reauthenticate() {
        await this.initializePromise;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._reauthenticate();
        });
        return await this._reauthenticate();
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $e1qhh.AuthSessionMissingError)();
                const { error: error } = await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     *
     * @category Auth
     *
     * @remarks
     * - Resends a signup confirmation, email change or phone change email to the user.
     * - Passwordless sign-ins can be resent by calling the `signInWithOtp()` method again.
     * - Password recovery emails can be resent by calling the `resetPasswordForEmail()` method again.
     * - This method will only resend an email or phone OTP to the user if there was an initial signup, email change or phone change request being made(note: For existing users signing in with OTP, you should use `signInWithOtp()` again to resend the OTP).
     * - You can specify a redirect url when you resend an email link using the `emailRedirectTo` option.
     *
     * @exampleDescription Resend an email signup confirmation
     * Resends the email signup confirmation to the user
     *
     * @example Resend an email signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'signup',
     *   email: 'email@example.com',
     *   options: {
     *     emailRedirectTo: 'https://example.com/welcome'
     *   }
     * })
     * ```
     *
     * @exampleDescription Resend a phone signup confirmation
     * Resends the phone signup confirmation email to the user
     *
     * @example Resend a phone signup confirmation
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'sms',
     *   phone: '1234567890'
     * })
     * ```
     *
     * @exampleDescription Resend email change email
     * Resends the email change email to the user
     *
     * @example Resend email change email
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'email_change',
     *   email: 'email@example.com'
     * })
     * ```
     *
     * @exampleDescription Resend phone change OTP
     * Resends the phone change OTP to the user
     *
     * @example Resend phone change OTP
     * ```js
     * const { error } = await supabase.auth.resend({
     *   type: 'phone_change',
     *   phone: '1234567890'
     * })
     * ```
     */ async resend(credentials) {
        let flowId = null;
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email: email, type: type, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod, flowId] = await this._getCodeChallengeAndMethod();
                const { error: error } = await (0, $chSC8._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: this._maybeAppendFlowIdToRedirect(options === null || options === void 0 ? void 0 : options.emailRedirectTo, flowId)
                });
                if (error) await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
                return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
            } else if ('phone' in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return this._returnResult({
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                });
            }
            throw new (0, $e1qhh.AuthInvalidCredentialsError)('You must provide either an email or phone number and a type');
        } catch (error) {
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link GoTrueClient.getUser} instead.
     *
     * @category Auth
     *
     * @remarks
     * - Since the introduction of [asymmetric JWT signing keys](/docs/guides/auth/signing-keys), this method is considered low-level and we encourage you to use `getClaims()` or `getUser()` instead.
     * - Retrieves the current [user session](/docs/guides/auth/sessions) from the storage medium (local storage, cookies).
     * - The session contains an access token (signed JWT), a refresh token and the user object.
     * - If the session's access token is expired or is about to expire, this method will use the refresh token to refresh the session.
     * - When using in a browser, or you've called `startAutoRefresh()` in your environment (React Native, etc.) this function always returns a valid access token without refreshing the session itself, as this is done in the background. This function returns very fast.
     * - **IMPORTANT SECURITY NOTICE:** If using an insecure storage medium, such as cookies or request headers, the user object returned by this function **must not be trusted**. Always verify the JWT using `getClaims()` or your own JWT verification library to securely establish the user's identity and access. You can also use `getUser()` to fetch the user object directly from the Auth server for this purpose.
     * - Cross-tab refresh races are handled by the GoTrue server (the rotated token from the first tab is returned to subsequent tabs via the parent-of-active mechanism), so no client-side serialization is needed.
     *
     * @example Get the session data
     * ```js
     * const { data, error } = await supabase.auth.getSession()
     * ```
     *
     * @exampleResponse Get the session data
     * ```json
     * {
     *   "data": {
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async getSession() {
        await this.initializePromise;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return await this._useSession(async (result)=>{
            return result;
        });
    }
    /**
     * Acquires a global lock based on the storage key.
     *
     * TODO(v3): remove along with the legacy lock path. Only called when
     * `this.lock` is non-null (custom lock supplied via constructor). The
     * default lockless path bypasses this entirely.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (_e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link GoTrueClient.getSession} inside the library. Loads the session
     * via `__loadSession` (which may trigger a refresh if the access token is
     * within the expiry margin) and runs `fn` with the result.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // Concurrent callers may both reach __loadSession; storage reads are
            // idempotent, and the only write path inside it (refresh) is
            // single-flighted downstream by `refreshingDeferred` in
            // `_callRefreshToken`. No serialization is needed at this layer.
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use `_useSession`.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (this.lock != null && !this.lockAcquired) // TODO(v3): remove. Only meaningful on the legacy lock path.
        this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $9tGer.getItemAsync)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            // A session is considered expired before the access token _actually_
            // expires. When the autoRefreshToken option is off (or when the tab is
            // in the background), very eager users of getSession() -- like
            // realtime-js -- might send a valid JWT which will expire by the time it
            // reaches the server.
            const hasExpired = currentSession.expires_at ? currentSession.expires_at * 1000 - Date.now() < (0, $nTVnO.EXPIRY_MARGIN_MS) : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) return {
                data: {
                    session: await this._hydrateSessionUser(currentSession)
                },
                error: null
            };
            const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) {
                // A failed refresh does not mean there is no session. Storage is the
                // source of truth at this point, because either:
                //  - `_callRefreshToken` kept the original session in storage since
                //    the access token is still inside its real expiry window (a
                //    proactive refresh that failed non-retryably), or
                //  - another caller, in this tab or a different one, committed its
                //    own rotated session while this refresh was in flight, so this
                //    one was discarded by the commit guard or rejected by the server
                //    as already used.
                // Empty storage (concurrent `signOut`) or an expired stored session
                // means the session is genuinely gone and the error stands. Callers
                // that pass an explicit token (`setSession`,
                // `refreshSession({ refresh_token })`) call `_callRefreshToken`
                // directly and surface the failure instead.
                const stored = await (0, $9tGer.getItemAsync)(this.storage, this.storageKey);
                if (stored && this._isValidSession(stored) && stored.expires_at && stored.expires_at * 1000 > Date.now()) return this._returnResult({
                    data: {
                        session: await this._hydrateSessionUser(stored)
                    },
                    error: null
                });
                return this._returnResult({
                    data: {
                        session: null
                    },
                    error: error
                });
            }
            return this._returnResult({
                data: {
                    session: session
                },
                error: null
            });
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Completes a session read back from storage so it matches what callers of
     * `getSession()` expect: fills in `session.user` from `userStorage` when the
     * client keeps the user in split storage, and wraps the user in the
     * insecure-access warning proxy on the server.
     */ async _hydrateSessionUser(session) {
        if (this.userStorage) {
            const maybeUser = await (0, $9tGer.getItemAsync)(this.userStorage, this.storageKey + '-user');
            session.user = (maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) ? maybeUser.user : (0, $9tGer.userNotAvailableProxy)();
        }
        // Warns when properties of the user are accessed, not when session.user itself is accessed.
        if (this.storage.isServer && session.user && !session.user.__isUserNotAvailableProxy) {
            const suppressWarningRef = {
                value: this.suppressGetSessionWarning
            };
            session.user = (0, $9tGer.insecureUserWarningProxy)(session.user, suppressWarningRef);
            if (suppressWarningRef.value) this.suppressGetSessionWarning = true;
        }
        return session;
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     *
     * @category Auth
     *
     * @remarks
     * - This method fetches the user object from the database instead of local session.
     * - This method is useful for checking if the user is authorized because it validates the user's access token JWT on the server.
     * - Should always be used when checking for user authorization on the server. On the client, you can instead use `getSession().session.user` for faster results. `getSession` is insecure on the server.
     *
     * @example Get the logged in user with the current existing session
     * ```js
     * const { data: { user } } = await supabase.auth.getUser()
     * ```
     *
     * @exampleResponse Get the logged in user with the current existing session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Get the logged in user with a custom access token jwt
     * ```js
     * const { data: { user } } = await supabase.auth.getUser(jwt)
     * ```
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        let result;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        result = await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._getUser();
        });
        else result = await this._getUser();
        if (result.data.user) this.suppressGetSessionWarning = true;
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $chSC8._userResponse)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data: data, error: error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                };
                return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, $chSC8._userResponse)
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) {
                if ((0, $e1qhh.isAuthSessionMissingError)(error)) // JWT contains a `session_id` which does not correspond to an active
                // session in the database, indicating the user is signed out.
                await this._removeSession();
                return this._returnResult({
                    data: {
                        user: null
                    },
                    error: error
                });
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `updateUser()` method, the user needs to be signed in first.
     * - By default, email updates sends a confirmation link to both the user's current and new email.
     * To only send a confirmation link to the user's new email, disable **Secure email change** in your project's [email auth provider settings](/dashboard/project/_/auth/providers).
     *
     * @exampleDescription Update the email for an authenticated user
     * Sends a "Confirm Email Change" email to the new address. If **Secure Email Change** is enabled (default), confirmation is also required from the **old email** before the change is applied. To skip dual confirmation and apply the change after only the new email is verified, disable **Secure Email Change** in the [Email Auth Provider settings](/dashboard/project/_/auth/providers?provider=Email).
     *
     * @example Update the email for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   email: 'new@email.com'
     * })
     * ```
     *
     * @exampleResponse Update the email for an authenticated user
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "new_email": "new@email.com",
     *       "email_change_sent_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @exampleDescription Update the phone number for an authenticated user
     * Sends a one-time password (OTP) to the new phone number.
     *
     * @example Update the phone number for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   phone: '123456789'
     * })
     * ```
     *
     * @example Update the password for an authenticated user
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password'
     * })
     * ```
     *
     * @exampleDescription Update the user's metadata
     * Updates the user's custom metadata.
     *
     * **Note**: The `data` field maps to the `auth.users.raw_user_meta_data` column in your Supabase database. When calling `getUser()`, the data will be available as `user.user_metadata`.
     *
     * @example Update the user's metadata
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   data: { hello: 'world' }
     * })
     * ```
     *
     * @exampleDescription Update the user's password with a nonce
     * If **Secure password change** is enabled in your [project's email provider settings](/dashboard/project/_/auth/providers), updating the user's password would require a nonce if the user **hasn't recently signed in**. The nonce is sent to the user's email or phone number. A user is deemed recently signed in if the session was created in the last 24 hours.
     *
     * @example Update the user's password with a nonce
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: 'new password',
     *   nonce: '123456'
     * })
     * ```
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._updateUser(attributes, options);
        });
        return await this._updateUser(attributes, options);
    }
    async _updateUser(attributes, options = {}) {
        let flowId = null;
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $e1qhh.AuthSessionMissingError)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod, flowId] = await this._getCodeChallengeAndMethod();
                const { data: data, error: userError } = await (0, $chSC8._request)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: this._maybeAppendFlowIdToRedirect(options === null || options === void 0 ? void 0 : options.emailRedirectTo, flowId),
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $chSC8._userResponse)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return this._returnResult({
                    data: {
                        user: session.user
                    },
                    error: null
                });
            });
        } catch (error) {
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method sets the session using an `access_token` and `refresh_token`.
     * - If successful, a `SIGNED_IN` event is emitted.
     *
     * @exampleDescription Set the session
     * Sets the session data from an access_token and refresh_token, then returns an auth response or error.
     *
     * @example Set the session
     * ```js
     *   const { data, error } = await supabase.auth.setSession({
     *     access_token,
     *     refresh_token
     *   })
     * ```
     *
     * @exampleResponse Set the session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "11111111-1111-1111-1111-111111111111",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "2024-01-01T00:00:00Z",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       },
     *       "token_type": "bearer",
     *       "expires_in": 3500,
     *       "expires_at": 1700000000
     *     }
     *   },
     *   "error": null
     * }
     * ```
     */ async setSession(currentSession) {
        await this.initializePromise;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._setSession(currentSession);
        });
        return await this._setSession(currentSession);
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $e1qhh.AuthSessionMissingError)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const { payload: payload } = (0, $9tGer.decodeJWT)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { data: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return this._returnResult({
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     *
     * @category Auth
     *
     * @remarks
     * - This method will refresh and return a new session whether the current one is expired or not.
     *
     * @example Refresh session using the current session
     * ```js
     * const { data, error } = await supabase.auth.refreshSession()
     * const { session, user } = data
     * ```
     *
     * @exampleResponse Refresh session using the current session
     * ```json
     * {
     *   "data": {
     *     "user": {
     *       "id": "11111111-1111-1111-1111-111111111111",
     *       "aud": "authenticated",
     *       "role": "authenticated",
     *       "email": "example@email.com",
     *       "email_confirmed_at": "2024-01-01T00:00:00Z",
     *       "phone": "",
     *       "confirmed_at": "2024-01-01T00:00:00Z",
     *       "last_sign_in_at": "2024-01-01T00:00:00Z",
     *       "app_metadata": {
     *         "provider": "email",
     *         "providers": [
     *           "email"
     *         ]
     *       },
     *       "user_metadata": {
     *         "email": "example@email.com",
     *         "email_verified": false,
     *         "phone_verified": false,
     *         "sub": "11111111-1111-1111-1111-111111111111"
     *       },
     *       "identities": [
     *         {
     *           "identity_id": "22222222-2222-2222-2222-222222222222",
     *           "id": "11111111-1111-1111-1111-111111111111",
     *           "user_id": "11111111-1111-1111-1111-111111111111",
     *           "identity_data": {
     *             "email": "example@email.com",
     *             "email_verified": false,
     *             "phone_verified": false,
     *             "sub": "11111111-1111-1111-1111-111111111111"
     *           },
     *           "provider": "email",
     *           "last_sign_in_at": "2024-01-01T00:00:00Z",
     *           "created_at": "2024-01-01T00:00:00Z",
     *           "updated_at": "2024-01-01T00:00:00Z",
     *           "email": "example@email.com"
     *         }
     *       ],
     *       "created_at": "2024-01-01T00:00:00Z",
     *       "updated_at": "2024-01-01T00:00:00Z",
     *       "is_anonymous": false
     *     },
     *     "session": {
     *       "access_token": "<ACCESS_TOKEN>",
     *       "token_type": "bearer",
     *       "expires_in": 3600,
     *       "expires_at": 1700000000,
     *       "refresh_token": "<REFRESH_TOKEN>",
     *       "user": {
     *         "id": "11111111-1111-1111-1111-111111111111",
     *         "aud": "authenticated",
     *         "role": "authenticated",
     *         "email": "example@email.com",
     *         "email_confirmed_at": "2024-01-01T00:00:00Z",
     *         "phone": "",
     *         "confirmed_at": "2024-01-01T00:00:00Z",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "app_metadata": {
     *           "provider": "email",
     *           "providers": [
     *             "email"
     *           ]
     *         },
     *         "user_metadata": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "identities": [
     *           {
     *             "identity_id": "22222222-2222-2222-2222-222222222222",
     *             "id": "11111111-1111-1111-1111-111111111111",
     *             "user_id": "11111111-1111-1111-1111-111111111111",
     *             "identity_data": {
     *               "email": "example@email.com",
     *               "email_verified": false,
     *               "phone_verified": false,
     *               "sub": "11111111-1111-1111-1111-111111111111"
     *             },
     *             "provider": "email",
     *             "last_sign_in_at": "2024-01-01T00:00:00Z",
     *             "created_at": "2024-01-01T00:00:00Z",
     *             "updated_at": "2024-01-01T00:00:00Z",
     *             "email": "example@email.com"
     *           }
     *         ],
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "is_anonymous": false
     *       }
     *     }
     *   },
     *   "error": null
     * }
     * ```
     *
     * @example Refresh session using a refresh token
     * ```js
     * const { data, error } = await supabase.auth.refreshSession({ refresh_token })
     * const { session, user } = data
     * ```
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._refreshSession(currentSession);
        });
        return await this._refreshSession(currentSession);
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $e1qhh.AuthSessionMissingError)();
                const { data: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                if (!session) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                });
                return this._returnResult({
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    user: null,
                    session: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        var _a;
        try {
            if (!(0, $9tGer.isBrowser)()) throw new (0, $e1qhh.AuthImplicitGrantRedirectError)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, $e1qhh.AuthImplicitGrantRedirectError)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, $e1qhh.AuthPKCEGrantCodeExchangeError)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, $e1qhh.AuthImplicitGrantRedirectError)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, $e1qhh.AuthPKCEGrantCodeExchangeError)('No code detected.');
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code, {
                    flowId: params[0, $nTVnO.PKCE_FLOW_ID_PARAM]
                });
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                url.searchParams.delete((0, $nTVnO.PKCE_FLOW_ID_PARAM));
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: (_a = data.redirectType) !== null && _a !== void 0 ? _a : null
                    },
                    error: null
                };
            }
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $e1qhh.AuthImplicitGrantRedirectError)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= (0, $nTVnO.AUTO_REFRESH_TICK_DURATION_MS)) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return this._returnResult({
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            });
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     *
     * If `detectSessionInUrl` is a function, it will be called with the URL and params to determine
     * if the URL should be processed as a Supabase auth callback. This allows users to exclude
     * URLs from other OAuth providers (e.g., Facebook Login) that also return access_token in the fragment.
     */ _isImplicitGrantCallback(params) {
        if (typeof this.detectSessionInUrl === 'function') return this.detectSessionInUrl(new URL(window.location.href), params);
        return Boolean(params.access_token || params.error || params.error_description || params.error_code);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        if (!params.code) return false;
        const flowId = (0, $9tGer.validatePKCEFlowId)(params[0, $nTVnO.PKCE_FLOW_ID_PARAM]);
        if (flowId && await (0, $9tGer.getItemAsync)(this.storage, (0, $9tGer.pkceVerifierSlotKey)(this.storageKey, flowId))) return true;
        const currentStorageContent = await (0, $9tGer.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        return !!currentStorageContent;
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     *
     * **Warning:** the default `scope` is `'global'`. This signs the user out of
     * **every device they are currently signed in on**, not just the current
     * tab/session. If you only want to sign the user out of the current session
     * (the behavior most other auth libraries default to), pass
     * `{ scope: 'local' }` explicitly.
     *
     * @category Auth
     *
     * @remarks
     * - In order to use the `signOut()` method, the user needs to be signed in first.
     * - By default, `signOut()` uses the **global** scope, which signs out the user
     *   on every device they are signed in on (not just the current one). Pass
     *   `{ scope: 'local' }` to only sign out the current session. This is
     *   usually what apps want on a "Sign out" button, especially when users
     *   sign in from multiple devices and do not expect signing out of one to
     *   terminate the others.
     * - Since Supabase Auth uses JWTs for authentication, the access token JWT will be valid until it's expired. When the user signs out, Supabase revokes the refresh token and deletes the JWT from the client-side. This does not revoke the JWT and it will still be valid until it expires.
     *
     * @example Sign out of every device (global – default)
     * ```js
     * const { error } = await supabase.auth.signOut()
     * ```
     *
     * @example Sign out only the current session (recommended for most apps)
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'local' })
     * ```
     *
     * @example Sign out of all other sessions, keep the current one
     * ```js
     * const { error } = await supabase.auth.signOut({ scope: 'others' })
     * ```
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return await this._acquireLock(this.lockAcquireTimeout, async ()=>{
            return await this._signOut(options);
        });
        return await this._signOut(options);
    }
    async _signOut({ scope: scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const removeCurrentSession = async ()=>{
                await this._removeSession();
            };
            const { data: data, error: sessionError } = result;
            if (sessionError && !(0, $e1qhh.isAuthSessionMissingError)(sessionError)) return this._returnResult({
                error: sessionError
            });
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) // ignore 404s since user might not exist anymore
                // ignore 401s since an invalid or expired JWT should sign out the current session
                {
                    if (!((0, $e1qhh.isAuthApiError)(error) && (error.status === 404 || error.status === 401 || error.status === 403) || (0, $e1qhh.isAuthSessionMissingError)(error))) {
                        if (scope !== 'others') await removeCurrentSession();
                        return this._returnResult({
                            error: error
                        });
                    }
                }
            }
            if (scope !== 'others') await removeCurrentSession();
            return this._returnResult({
                error: null
            });
        });
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - Subscribes to important events occurring on the user's session.
     * - Use on the frontend/client. It is less useful on the server.
     * - Events are emitted across tabs to keep your application's UI up-to-date. Some events can fire very frequently, based on the number of tabs open. Use a quick and efficient callback function, and defer or debounce as many operations as you can to be performed outside of the callback.
     * - Callbacks can be `async` and can safely call other Supabase auth methods (`getUser`, `setSession`, etc.) from inside the callback.
     * - Keep callbacks quick. Events are awaited in order, so a slow callback delays subsequent events to subscribers in this tab.
     * - Emitted events:
     *   - `INITIAL_SESSION`
     *     - Emitted right after the Supabase client is constructed and the initial session from storage is loaded.
     *   - `SIGNED_IN`
     *     - Emitted each time a user session is confirmed or re-established, including on user sign in and when refocusing a tab.
     *     - Avoid making assumptions as to when this event is fired, this may occur even when the user is already signed in. Instead, check the user object attached to the event to see if a new user has signed in and update your application's UI.
     *     - This event can fire very frequently depending on the number of tabs open in your application.
     *   - `SIGNED_OUT`
     *     - Emitted when the user signs out. This can be after:
     *       - A call to `supabase.auth.signOut()`.
     *       - After the user's session has expired for any reason:
     *         - User has signed out on another device.
     *         - The session has reached its timebox limit or inactivity timeout.
     *         - User has signed in on another device with single session per user enabled.
     *         - Check the [User Sessions](/docs/guides/auth/sessions) docs for more information.
     *     - Use this to clean up any local storage your application has associated with the user.
     *   - `TOKEN_REFRESHED`
     *     - Emitted each time a new access and refresh token are fetched for the signed in user.
     *     - It's best practice and highly recommended to extract the access token (JWT) and store it in memory for further use in your application.
     *       - Avoid frequent calls to `supabase.auth.getSession()` for the same purpose.
     *     - There is a background process that keeps track of when the session should be refreshed so you will always receive valid tokens by listening to this event.
     *     - The frequency of this event is related to the JWT expiry limit configured on your project.
     *   - `USER_UPDATED`
     *     - Emitted each time the `supabase.auth.updateUser()` method finishes successfully. Listen to it to update your application's UI based on new profile information.
     *   - `PASSWORD_RECOVERY`
     *     - Emitted instead of the `SIGNED_IN` event when the user lands on a page that includes a password recovery link in the URL.
     *     - Use it to show a UI to the user where they can [reset their password](/docs/guides/auth/passwords#resetting-a-users-password-forgot-password).
     *
     * @example Listen to auth changes
     * ```js
     * const { data } = supabase.auth.onAuthStateChange((event, session) => {
     *   console.log(event, session)
     *
     *   if (event === 'INITIAL_SESSION') {
     *     // handle initial session
     *   } else if (event === 'SIGNED_IN') {
     *     // handle sign in event
     *   } else if (event === 'SIGNED_OUT') {
     *     // handle sign out event
     *   } else if (event === 'PASSWORD_RECOVERY') {
     *     // handle password recovery event
     *   } else if (event === 'TOKEN_REFRESHED') {
     *     // handle token refreshed event
     *   } else if (event === 'USER_UPDATED') {
     *     // handle user updated event
     *   }
     * })
     *
     * // call unsubscribe to remove the callback
     * data.subscription.unsubscribe()
     * ```
     *
     * @exampleDescription Listen to sign out
     * Make sure you clear out any local data, such as local and session storage, after the client library has detected the user's sign out.
     *
     * @example Listen to sign out
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_OUT') {
     *     console.log('SIGNED_OUT', session)
     *
     *     // clear local and session storage
     *     [
     *       window.localStorage,
     *       window.sessionStorage,
     *     ].forEach((storage) => {
     *       Object.entries(storage)
     *         .forEach(([key]) => {
     *           storage.removeItem(key)
     *         })
     *     })
     *   }
     * })
     * ```
     *
     * @exampleDescription Store OAuth provider tokens on sign in
     * When using [OAuth (Social Login)](/docs/guides/auth/social-login) you sometimes wish to get access to the provider's access token and refresh token, in order to call provider APIs in the name of the user.
     *
     * For example, if you are using [Sign in with Google](/docs/guides/auth/social-login/auth-google) you may want to use the provider token to call Google APIs on behalf of the user. Supabase Auth does not keep track of the provider access and refresh token, but does return them for you once, immediately after sign in. You can use the `onAuthStateChange` method to listen for the presence of the provider tokens and store them in local storage. You can further send them to your server's APIs for use on the backend.
     *
     * Finally, make sure you remove them from local storage on the `SIGNED_OUT` event. If the OAuth provider supports token revocation, make sure you call those APIs either from the frontend or schedule them to be called on the backend.
     *
     * @example Store OAuth provider tokens on sign in
     * ```js
     * // Register this immediately after calling createClient!
     * // Because signInWithOAuth causes a redirect, you need to fetch the
     * // provider tokens from the callback.
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (session && session.provider_token) {
     *     window.localStorage.setItem('oauth_provider_token', session.provider_token)
     *   }
     *
     *   if (session && session.provider_refresh_token) {
     *     window.localStorage.setItem('oauth_provider_refresh_token', session.provider_refresh_token)
     *   }
     *
     *   if (event === 'SIGNED_OUT') {
     *     window.localStorage.removeItem('oauth_provider_token')
     *     window.localStorage.removeItem('oauth_provider_refresh_token')
     *   }
     * })
     * ```
     *
     * @exampleDescription Use React Context for the User's session
     * Instead of relying on `supabase.auth.getSession()` within your React components, you can use a [React Context](https://react.dev/reference/react/createContext) to store the latest session information from the `onAuthStateChange` callback and access it that way.
     *
     * @example Use React Context for the User's session
     * ```js
     * const SessionContext = React.createContext(null)
     *
     * function main() {
     *   const [session, setSession] = React.useState(null)
     *
     *   React.useEffect(() => {
     *     const {data: { subscription }} = supabase.auth.onAuthStateChange(
     *       (event, session) => {
     *         if (event === 'SIGNED_OUT') {
     *           setSession(null)
     *         } else if (session) {
     *           setSession(session)
     *         }
     *       })
     *
     *     return () => {
     *       subscription.unsubscribe()
     *     }
     *   }, [])
     *
     *   return (
     *     <SessionContext.Provider value={session}>
     *       <App />
     *     </SessionContext.Provider>
     *   )
     * }
     * ```
     *
     * @example Listen to password recovery events
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'PASSWORD_RECOVERY') {
     *     console.log('PASSWORD_RECOVERY', session)
     *     // show screen to update user's password
     *     showPasswordResetScreen(true)
     *   }
     * })
     * ```
     *
     * @example Listen to sign in
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'SIGNED_IN') console.log('SIGNED_IN', session)
     * })
     * ```
     *
     * @example Listen to token refresh
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'TOKEN_REFRESHED') console.log('TOKEN_REFRESHED', session)
     * })
     * ```
     *
     * @example Listen to user updates
     * ```js
     * supabase.auth.onAuthStateChange((event, session) => {
     *   if (event === 'USER_UPDATED') console.log('USER_UPDATED', session)
     * })
     * ```
     */ onAuthStateChange(callback) {
        const id = (0, $9tGer.generateCallbackId)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            if (this.lock != null) // TODO(v3): remove legacy lock path
            await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                this._emitInitialSession(id);
            });
            else await this._emitInitialSession(id);
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                if ((0, $e1qhh.isAuthRefreshDiscardedError)(err)) // Same successful no-op _recoverAndRefresh treats as debug-only: the
                // commit guard discarded a refresh because a concurrent signOut
                // changed session state mid-flight.
                return;
                if ((0, $e1qhh.isAuthSessionMissingError)(err) || (0, $e1qhh.isAuthRetryableFetchError)(err) || (0, $e1qhh.isAuthApiError)(err) && (err.code === 'refresh_token_not_found' || err.code === 'refresh_token_already_used' || err.code === 'session_expired')) // A missing session, a transient/aborted network failure (e.g. a
                // superseded page navigation cancelling the in-flight request), or
                // a dead refresh token (e.g. stale SSR cookies) is not an
                // application error — warn rather than surface it raw.
                console.warn(err);
                else console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     *
     * @category Auth
     *
     * @remarks
     * - The password reset flow consist of 2 broad steps: (i) Allow the user to login via the password reset link; (ii) Update the user's password.
     * - The `resetPasswordForEmail()` only sends a password reset link to the user's email.
     * To update the user's password, see [`updateUser()`](/docs/reference/javascript/auth-updateuser).
     * - A `PASSWORD_RECOVERY` event will be emitted when the password recovery link is clicked.
     * You can use [`onAuthStateChange()`](/docs/reference/javascript/auth-onauthstatechange) to listen and invoke a callback function on these events.
     * - When the user clicks the reset link in the email they are redirected back to your application.
     * You can configure the URL that the user is redirected to with the `redirectTo` parameter.
     * See [redirect URLs and wildcards](/docs/guides/auth/redirect-urls#use-wildcards-in-redirect-urls) to add additional redirect URLs to your project.
     * - After the user has been redirected successfully, prompt them for a new password and call `updateUser()`:
     * ```js
     * const { data, error } = await supabase.auth.updateUser({
     *   password: new_password
     * })
     * ```
     *
     * @example Reset password
     * ```js
     * const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
     *   redirectTo: 'https://example.com/update-password',
     * })
     * ```
     *
     * @exampleResponse Reset password
     * ```json
     * {
     *   data: {}
     *   error: null
     * }
     * ```
     *
     * @example Reset password (React)
     * ```js
     * /**
     *  * Step 1: Send the user an email to get a password reset token.
     *  * This email contains a link which sends the user back to your application.
     *  *\/
     * const { data, error } = await supabase.auth
     *   .resetPasswordForEmail('user@email.com')
     *
     * /**
     *  * Step 2: Once the user is redirected back to your application,
     *  * ask the user to reset their password.
     *  *\/
     *  useEffect(() => {
     *    supabase.auth.onAuthStateChange(async (event, session) => {
     *      if (event == "PASSWORD_RECOVERY") {
     *        const newPassword = prompt("What would you like your new password to be?");
     *        const { data, error } = await supabase.auth
     *          .updateUser({ password: newPassword })
     *
     *        if (data) alert("Password updated successfully!")
     *        if (error) alert("There was an error updating your password.")
     *      }
     *    })
     *  }, [])
     * ```
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        let flowId = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod, flowId] = await this._getCodeChallengeAndMethod(true // isPasswordRecovery
        );
        try {
            return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: this._maybeAppendFlowIdToRedirect(options.redirectTo, flowId)
            });
        } catch (error) {
            await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, flowId);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     *
     * @category Auth
     *
     * @remarks
     * - The user needs to be signed in to call `getUserIdentities()`.
     *
     * @example Returns a list of identities linked to the user
     * ```js
     * const { data, error } = await supabase.auth.getUserIdentities()
     * ```
     *
     * @exampleResponse Returns a list of identities linked to the user
     * ```json
     * {
     *   "data": {
     *     "identities": [
     *       {
     *         "identity_id": "22222222-2222-2222-2222-222222222222",
     *         "id": "2024-01-01T00:00:00Z",
     *         "user_id": "2024-01-01T00:00:00Z",
     *         "identity_data": {
     *           "email": "example@email.com",
     *           "email_verified": false,
     *           "phone_verified": false,
     *           "sub": "11111111-1111-1111-1111-111111111111"
     *         },
     *         "provider": "email",
     *         "last_sign_in_at": "2024-01-01T00:00:00Z",
     *         "created_at": "2024-01-01T00:00:00Z",
     *         "updated_at": "2024-01-01T00:00:00Z",
     *         "email": "example@email.com"
     *       }
     *     ]
     *   },
     *   "error": null
     * }
     * ```
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return this._returnResult({
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**  *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `linkIdentity()`.
     * - If the candidate identity is already linked to the existing user or another user, `linkIdentity()` will fail.
     * - If `linkIdentity` is run in the browser, the user is automatically redirected to the returned URL. On the server, you should handle the redirect.
     *
     * @example Link an identity to a user
     * ```js
     * const { data, error } = await supabase.auth.linkIdentity({
     *   provider: 'github'
     * })
     * ```
     *
     * @exampleResponse Link an identity to a user
     * ```json
     * {
     *   data: {
     *     provider: 'github',
     *     url: <PROVIDER_URL_TO_REDIRECT_TO>,
     *     flowId: <PKCE_FLOW_ID_OR_NULL>
     *   },
     *   error: null
     * }
     * ```
     */ async linkIdentity(credentials) {
        if ('token' in credentials) return this.linkIdentityIdToken(credentials);
        return this.linkIdentityOAuth(credentials);
    }
    async linkIdentityOAuth(credentials) {
        var _a;
        let flowId = null;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _f;
                const { data: data, error: error } = result;
                if (error) throw error;
                const { url: url, flowId: urlFlowId } = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                flowId = urlFlowId;
                return await (0, $chSC8._request)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_f = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _f !== void 0 ? _f : undefined
                });
            });
            if (error) throw error;
            if ((0, $9tGer.isBrowser)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url,
                    flowId: flowId
                },
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    provider: credentials.provider,
                    url: null,
                    flowId: flowId
                },
                error: error
            });
            throw error;
        }
    }
    async linkIdentityIdToken(credentials) {
        return await this._useSession(async (result)=>{
            var _a;
            try {
                const { error: sessionError, data: { session: session } } = result;
                if (sessionError) throw sessionError;
                const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
                const res = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                    headers: this.headers,
                    jwt: (_a = session === null || session === void 0 ? void 0 : session.access_token) !== null && _a !== void 0 ? _a : undefined,
                    body: {
                        provider: provider,
                        id_token: token,
                        access_token: access_token,
                        nonce: nonce,
                        link_identity: true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $chSC8._sessionResponse)
                });
                const { data: data, error: error } = res;
                if (error) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                else if (!data || !data.session || !data.user) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: new (0, $e1qhh.AuthInvalidTokenResponseError)()
                });
                if (data.session) {
                    await this._saveSession(data.session);
                    await this._notifyAllSubscribers('USER_UPDATED', data.session);
                }
                return this._returnResult({
                    data: data,
                    error: error
                });
            } catch (error) {
                await (0, $9tGer.removePKCEVerifier)(this.storage, this.storageKey, null);
                if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                });
                throw error;
            }
        });
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     *
     * @category Auth
     *
     * @remarks
     * - The **Enable Manual Linking** option must be enabled from your [project's authentication settings](/dashboard/project/_/auth/providers).
     * - The user needs to be signed in to call `unlinkIdentity()`.
     * - The user must have at least 2 identities in order to unlink an identity.
     * - The identity to be unlinked must belong to the user.
     *
     * @example Unlink an identity
     * ```js
     * // retrieve all identities linked to a user
     * const identities = await supabase.auth.getUserIdentities()
     *
     * // find the google identity
     * const googleIdentity = identities.find(
     *   identity => identity.provider === 'google'
     * )
     *
     * // unlink the google identity
     * const { error } = await supabase.auth.unlinkIdentity(googleIdentity)
     * ```
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        // Refresh tokens are long-lived bearer credentials; do NOT include any
        // fragment of the token in the debug tag, even when `debug: true` is
        // enabled (logs may be forwarded to third-party services).
        const debugName = `#_refreshAccessToken()`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $9tGer.retryable)(async (attempt)=>{
                if (attempt > 0) await (0, $9tGer.sleep)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $chSC8._sessionResponse)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, $e1qhh.isAuthRetryableFetchError)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < (0, $nTVnO.AUTO_REFRESH_TICK_DURATION_MS);
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: {
                    session: null,
                    user: null
                },
                error: error
            });
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const { url: url, flowId: flowId } = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, $9tGer.isBrowser)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url,
                flowId: flowId
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a, _b;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, $9tGer.getItemAsync)(this.storage, this.storageKey);
            if (currentSession && this.userStorage) {
                let maybeUser = await (0, $9tGer.getItemAsync)(this.userStorage, this.storageKey + '-user');
                if (!this.storage.isServer && Object.is(this.storage, this.userStorage) && !maybeUser) {
                    // storage and userStorage are the same storage medium, for example
                    // window.localStorage if userStorage does not have the user from
                    // storage stored, store it first thereby migrating the user object
                    // from storage -> userStorage
                    maybeUser = {
                        user: currentSession.user
                    };
                    await (0, $9tGer.setItemAsync)(this.userStorage, this.storageKey + '-user', maybeUser);
                }
                currentSession.user = (_a = maybeUser === null || maybeUser === void 0 ? void 0 : maybeUser.user) !== null && _a !== void 0 ? _a : (0, $9tGer.userNotAvailableProxy)();
            } else if (currentSession && !currentSession.user) // user storage is not set, let's check if it was previously enabled so
            // we bring back the storage as it should be
            {
                if (!currentSession.user) {
                    // test if userStorage was previously enabled and the storage medium was the same, to move the user back under the same key
                    const separateUser = await (0, $9tGer.getItemAsync)(this.storage, this.storageKey + '-user');
                    if (separateUser && (separateUser === null || separateUser === void 0 ? void 0 : separateUser.user)) {
                        currentSession.user = separateUser.user;
                        await (0, $9tGer.removeItemAsync)(this.storage, this.storageKey + '-user');
                        await (0, $9tGer.setItemAsync)(this.storage, this.storageKey, currentSession);
                    } else currentSession.user = (0, $9tGer.userNotAvailableProxy)();
                }
            }
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const expiresWithMargin = ((_b = currentSession.expires_at) !== null && _b !== void 0 ? _b : Infinity) * 1000 - Date.now() < (0, $nTVnO.EXPIRY_MARGIN_MS);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, $nTVnO.EXPIRY_MARGIN_MS)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        // `_callRefreshToken` is the single source of truth for refresh
                        // outcomes: it removes the session itself when the access token
                        // is actually expired, and preserves it when the token is still
                        // valid (proactive-preserve). Don't second-guess that here — a
                        // local `_removeSession` would emit a duplicate `SIGNED_OUT` on
                        // genuine failures and undo the proactive-preserve at init time.
                        if ((0, $e1qhh.isAuthRefreshDiscardedError)(error)) this._debug(debugName, 'refresh discarded by commit guard', error);
                        else this._debug(debugName, 'refresh failed', error);
                    }
                }
            } else if (currentSession.user && currentSession.user.__isUserNotAvailableProxy === true) // If we have a proxy user, try to get the real user data
            try {
                const { data: data, error: userError } = await this._getUser(currentSession.access_token);
                if (!userError && (data === null || data === void 0 ? void 0 : data.user)) {
                    currentSession.user = data.user;
                    await this._saveSession(currentSession);
                    await this._notifyAllSubscribers('SIGNED_IN', currentSession);
                } else this._debug(debugName, 'could not get user data, skipping SIGNED_IN notification');
            } catch (getUserError) {
                console.error('Error getting user data:', getUserError);
                this._debug(debugName, 'error getting user data, skipping SIGNED_IN notification', getUserError);
            }
            else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            if ((0, $e1qhh.isAuthRetryableFetchError)(err)) // Transient/aborted network failure during session recovery (e.g. a
            // superseded page navigation cancelling the in-flight request). Warn
            // rather than surface it raw; the session is untouched and recovery
            // will run again on the next load.
            console.warn(err);
            else console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $e1qhh.AuthSessionMissingError)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        // Serial failure cooldown: callers passing the *same* refresh token
        // after a recent failure receive the cached result instead of firing
        // another `/token` request. This caps the proactive-refresh storm
        // where every `getSession()` call inside the 90s EXPIRY_MARGIN_MS
        // window kept re-firing against the same broken refresh token during
        // outages. Concurrent callers already share `refreshingDeferred`; this
        // cache covers serial callers spaced across cooldown windows.
        //
        // Token-keyed so callers with a fresh refresh token (rotation pickup
        // from another tab, explicit `setSession`/`refreshSession({ refresh_token })`,
        // multi-account switch) bypass the cache and attempt a real refresh.
        if (this.lastRefreshFailure && this.lastRefreshFailure.refreshToken === refreshToken && Date.now() < this.lastRefreshFailure.expiresAt) {
            this._debug('#_callRefreshToken()', 'returning cached failure (cooldown active)');
            return this.lastRefreshFailure.result;
        }
        // Refresh tokens are long-lived bearer credentials; do NOT include any
        // fragment of the token in the debug tag, even when `debug: true` is
        // enabled (logs may be forwarded to third-party services).
        const debugName = `#_callRefreshToken()`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, $9tGer.Deferred)();
            // Only callers that arrive while this refresh is in flight await the
            // deferred; the original caller is served by the `throw` in the catch
            // below. Pre-attach a no-op rejection handler so a failing refresh with
            // no concurrent callers cannot surface as an unhandled rejection —
            // concurrent callers attach their own handlers via `.promise` and still
            // observe the rejection.
            this.refreshingDeferred.promise.then(undefined, ()=>{});
            // Snapshot storage before the fetch. The commit guard discards the
            // rotated tokens only when a non-null pre-fetch snapshot changed under
            // us — typical case: a concurrent `signOut` ran `_removeSession`, or
            // another tab's refresh rewrote the slot. Callers passing
            // externally-sourced tokens (SSR cookie handoff, multi-account
            // switching, `setSession`/`refreshSession({ refresh_token })`) may
            // start from a null snapshot OR from a non-null snapshot whose
            // refresh_token differs from the one they're hydrating; in both
            // cases the guard fires only when storage was *modified between
            // snapshots*, not when the input token disagrees with what's stored.
            const storedAtStart = await (0, $9tGer.getItemAsync)(this.storage, this.storageKey);
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $e1qhh.AuthSessionMissingError)();
            const storedAfter = await (0, $9tGer.getItemAsync)(this.storage, this.storageKey);
            const storageChangedUnderUs = storedAtStart !== null && (storedAfter === null || storedAfter.refresh_token !== storedAtStart.refresh_token);
            if (storageChangedUnderUs) {
                this._debug(debugName, 'commit guard: storage changed since refresh started, discarding rotated tokens', {
                    // Presence indicators only — never log refresh token fragments,
                    // even partial. Logs may be forwarded to third-party services.
                    startedWith: 'present',
                    nowHolds: storedAfter ? 'replaced' : 'cleared'
                });
                const discarded = {
                    data: null,
                    error: new (0, $e1qhh.AuthRefreshDiscardedError)()
                };
                this.refreshingDeferred.resolve(discarded);
                return discarded;
            }
            // Second leg of the commit guard: close the TOCTOU window between the
            // synchronous `storageChangedUnderUs` check and the actual storage
            // writes inside `_saveSession`. A concurrent `signOut → _removeSession`
            // can land inside `_saveSession`'s `await setItemAsync(...)` yields and
            // clear storage just before we overwrite it. Capture the epoch BEFORE
            // the save and re-check after; if it advanced, undo the write directly
            // (do NOT call `_removeSession` — that would emit a duplicate
            // SIGNED_OUT for the concurrent signOut that already fired one).
            const epochBeforeSave = this._sessionRemovalEpoch;
            await this._saveSession(data.session);
            if (this._sessionRemovalEpoch !== epochBeforeSave) {
                this._debug(debugName, 'commit guard (post-save): _removeSession ran during _saveSession, undoing write');
                await (0, $9tGer.removeItemAsync)(this.storage, this.storageKey);
                if (this.userStorage) await (0, $9tGer.removeItemAsync)(this.userStorage, this.storageKey + '-user');
                const discarded = {
                    data: null,
                    error: new (0, $e1qhh.AuthRefreshDiscardedError)()
                };
                this.refreshingDeferred.resolve(discarded);
                return discarded;
            }
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                data: data.session,
                error: null
            };
            // Refresh succeeded — clear any cached failure so the next caller
            // (including the auto-refresh ticker) attempts a real refresh again.
            this.lastRefreshFailure = null;
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, $e1qhh.isAuthError)(error)) {
                const result = {
                    data: null,
                    error: error
                };
                if (!(0, $e1qhh.isAuthRetryableFetchError)(error)) {
                    // Proactive vs reactive distinction: a refresh fires whenever
                    // the access token is within EXPIRY_MARGIN_MS of expiry. If the
                    // access token is *still valid* at this moment, the refresh was
                    // proactive and the existing session is still usable until its
                    // real expiry — destroying it now would log out a user whose
                    // access token works. If the access token has actually expired,
                    // the refresh token is the only credential left and it just got
                    // rejected — the session is genuinely dead. `__loadSession`
                    // mirrors this distinction on the read path so callers see the
                    // preserved session instead of `session: null`.
                    const storedNow = await (0, $9tGer.getItemAsync)(this.storage, this.storageKey);
                    const accessTokenStillValid = !!((storedNow === null || storedNow === void 0 ? void 0 : storedNow.expires_at) && storedNow.expires_at * 1000 > Date.now());
                    if (accessTokenStillValid) this._debug(debugName, "proactive refresh failed, access token still valid \u2014 preserving session");
                    else await this._removeSession();
                }
                // Cache the failure so serial callers (and the next auto-refresh
                // tick) passing the same refresh token within the cooldown window
                // receive it synchronously instead of firing another `/token`
                // call. Set after the optional `_removeSession` above (which
                // clears the cache as part of teardown) so the cache survives.
                this.lastRefreshFailure = {
                    refreshToken: refreshToken,
                    result: result,
                    expiresAt: Date.now() + (0, $nTVnO.REFRESH_FAILURE_COOLDOWN_MS)
                };
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        if (this._pendingInitNotifications !== null && broadcast) {
            // We're inside initialize() before initializePromise has resolved, and
            // this notification originates from the init chain (_recoverAndRefresh),
            // which always fires with broadcast = true. Enqueue instead of firing so
            // that callbacks can safely call getSession() / getUser() without
            // deadlocking on initializePromise.
            //
            // Notifications with broadcast = false come from the incoming
            // BroadcastChannel handler (a cross-tab event), not the init chain, so
            // they are fired immediately to preserve multi-tab ordering.
            this._pendingInitNotifications.push({
                event: event,
                session: session,
                broadcast: broadcast
            });
            return;
        }
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        // Create a shallow copy to work with, to avoid mutating the original session object if it's used elsewhere
        const sessionToProcess = Object.assign({}, session);
        const userIsProxy = sessionToProcess.user && sessionToProcess.user.__isUserNotAvailableProxy === true;
        if (this.userStorage) {
            if (!userIsProxy && sessionToProcess.user) // If it's a real user object, save it to userStorage.
            await (0, $9tGer.setItemAsync)(this.userStorage, this.storageKey + '-user', {
                user: sessionToProcess.user
            });
            else userIsProxy;
            // Prepare the main session data for primary storage: remove the user property before cloning
            // This is important because the original session.user might be the proxy
            const mainSessionData = Object.assign({}, sessionToProcess);
            delete mainSessionData.user; // Remove user (real or proxy) before cloning for main storage
            const clonedMainSessionData = (0, $9tGer.deepClone)(mainSessionData);
            await (0, $9tGer.setItemAsync)(this.storage, this.storageKey, clonedMainSessionData);
        } else {
            // No userStorage is configured.
            // In this case, session.user should ideally not be a proxy.
            // If it were, structuredClone would fail. This implies an issue elsewhere if user is a proxy here
            const clonedSession = (0, $9tGer.deepClone)(sessionToProcess); // sessionToProcess still has its original user property
            await (0, $9tGer.setItemAsync)(this.storage, this.storageKey, clonedSession);
        }
    }
    async _removeSession() {
        // Bump synchronously, BEFORE any `await`, so that `_callRefreshToken`'s
        // post-save check sees the increment whenever this method has started —
        // even if it hasn't finished. Pairs with the epoch check in
        // `_callRefreshToken`. See `_sessionRemovalEpoch` field doc.
        this._sessionRemovalEpoch += 1;
        this._debug('#_removeSession()');
        // The session is gone — no point holding on to a cached refresh failure
        // for a token that no longer exists. Synchronous, before any `await`.
        this.lastRefreshFailure = null;
        this.suppressGetSessionWarning = false;
        await (0, $9tGer.removeItemAsync)(this.storage, this.storageKey);
        await (0, $9tGer.removeAllPKCEVerifiers)(this.storage, this.storageKey);
        await (0, $9tGer.removeItemAsync)(this.storage, this.storageKey + '-user');
        if (this.userStorage) await (0, $9tGer.removeItemAsync)(this.userStorage, this.storageKey + '-user');
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@link GoTrueClient.startAutoRefresh}
     * {@link GoTrueClient.stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $9tGer.isBrowser)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link GoTrueClient.startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), (0, $nTVnO.AUTO_REFRESH_TICK_DURATION_MS));
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        const timeout = setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
        this.autoRefreshTickTimeout = timeout;
        if (timeout && typeof timeout === 'object' && typeof timeout.unref === 'function') timeout.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(timeout);
    }
    /**
     * This is the private implementation of {@link GoTrueClient.stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
        const timeout = this.autoRefreshTickTimeout;
        this.autoRefreshTickTimeout = null;
        if (timeout) clearTimeout(timeout);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@link GoTrueClient.stopAutoRefresh}
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - To give this hint to the application, you should be calling this method when the app is in focus and calling `supabase.auth.stopAutoRefresh()` when it's out of focus.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link GoTrueClient.startAutoRefresh} for more details.
     *
     * @category Auth
     *
     * @remarks
     * - Only useful in non-browser environments such as React Native or Electron.
     * - The Supabase Auth library automatically starts and stops proactively refreshing the session when a tab is focused or not.
     * - On non-browser platforms, such as mobile or desktop apps built with web technologies, the library is not able to effectively determine whether the application is _focused_ or not.
     * - When your application goes in the background or out of focus, call this method to stop the proactive refreshing of the session.
     *
     * @example Start and stop auto refresh in React Native
     * ```js
     * import { AppState } from 'react-native'
     *
     * // make sure you register this only once!
     * AppState.addEventListener('change', (state) => {
     *   if (state === 'active') {
     *     supabase.auth.startAutoRefresh()
     *   } else {
     *     supabase.auth.stopAutoRefresh()
     *   }
     * })
     * ```
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Tears down the client's background work: stops the auto-refresh interval,
     * removes the `visibilitychange` listener, closes the cross-tab
     * `BroadcastChannel`, and clears registered `onAuthStateChange` subscribers.
     *
     * Call this from cleanup hooks when the client is being replaced before
     * its JS realm is destroyed. React Strict Mode and HMR are the common
     * cases. Any in-flight `fetch` calls continue to completion and may still
     * write to storage; dispose doesn't abort them or erase storage.
     *
     * Lifecycle caveat: because in-flight refreshes are not aborted, a
     * disposed instance can still persist a rotated session to storage after
     * `dispose()` returns. A subsequent `createClient` against the same
     * `storageKey` will pick up that session on its next read. If you need
     * strict isolation between client lifecycles, await any pending auth
     * operation before calling `dispose()` (or change the `storageKey` for
     * the replacement client).
     *
     * Safe to call repeatedly.
     *
     * @category Auth
     *
     * @example Cleanup on React unmount
     * ```ts
     * useEffect(() => {
     *   const client = createClient(...)
     *   return () => { client.auth.dispose() }
     * }, [])
     * ```
     */ async dispose() {
        var _a;
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
        (_a = this.broadcastChannel) === null || _a === void 0 || _a.close();
        this.broadcastChannel = null;
        this.stateChangeEmitters.clear();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        if (this.lock != null) {
            // TODO(v3): remove legacy lock path. Uses `_acquireLock(0, ...)` which
            // throws `LockAcquireTimeoutError` immediately if the lock is held —
            // that's the fail-fast skip path that lets the tick bail out instead
            // of queuing behind a long-running operation.
            try {
                await this._acquireLock(0, async ()=>{
                    try {
                        const now = Date.now();
                        try {
                            return await this._useSession(async (result)=>{
                                const { data: { session: session } } = result;
                                if (!session || !session.refresh_token || !session.expires_at) {
                                    this._debug('#_autoRefreshTokenTick()', 'no session');
                                    return;
                                }
                                const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $nTVnO.AUTO_REFRESH_TICK_DURATION_MS));
                                this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $nTVnO.AUTO_REFRESH_TICK_DURATION_MS)}ms, refresh threshold is ${(0, $nTVnO.AUTO_REFRESH_TICK_THRESHOLD)} ticks`);
                                if (expiresInTicks <= (0, $nTVnO.AUTO_REFRESH_TICK_THRESHOLD)) await this._callRefreshToken(session.refresh_token);
                            });
                        } catch (e) {
                            console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                        }
                    } finally{
                        this._debug('#_autoRefreshTokenTick()', 'end');
                    }
                });
            } catch (e) {
                if (e instanceof (0, $cqGWb.LockAcquireTimeoutError)) this._debug('auto refresh token tick lock not available');
                else throw e;
            }
            return;
        }
        // Lockless default: skip if a refresh is already in flight.
        // `_callRefreshToken` also dedupes via the same field; this is just a
        // fast-path skip to avoid an unnecessary storage read.
        if (this.refreshingDeferred !== null) {
            this._debug('#_autoRefreshTokenTick()', 'refresh already in flight, skipping');
            return;
        }
        try {
            const now = Date.now();
            try {
                await this._useSession(async (result)=>{
                    const { data: { session: session } } = result;
                    if (!session || !session.refresh_token || !session.expires_at) {
                        this._debug('#_autoRefreshTokenTick()', 'no session');
                        return;
                    }
                    // session will expire in this many ticks (or has already expired if <= 0)
                    const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / (0, $nTVnO.AUTO_REFRESH_TICK_DURATION_MS));
                    this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${(0, $nTVnO.AUTO_REFRESH_TICK_DURATION_MS)}ms, refresh threshold is ${(0, $nTVnO.AUTO_REFRESH_TICK_THRESHOLD)} ticks`);
                    if (expiresInTicks <= (0, $nTVnO.AUTO_REFRESH_TICK_THRESHOLD)) await this._callRefreshToken(session.refresh_token);
                });
            } catch (e) {
                console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
            }
        } finally{
            this._debug('#_autoRefreshTokenTick()', 'end');
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, $9tGer.isBrowser)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>{
                try {
                    await this._onVisibilityChanged(false);
                } catch (error) {
                    this._debug('#visibilityChangedCallback', 'error', error);
                }
            };
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered
                await this.initializePromise;
                if (this.lock != null) // TODO(v3): remove legacy lock path
                await this._acquireLock(this.lockAcquireTimeout, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        return;
                    }
                    await this._recoverAndRefresh();
                });
                else {
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'visibilityState is no longer visible, skipping recovery');
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                }
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        let redirectTo = options === null || options === void 0 ? void 0 : options.redirectTo;
        let codeChallenge = null;
        let codeChallengeMethod = null;
        let flowId = null;
        if (this.flowType === 'pkce') {
            [codeChallenge, codeChallengeMethod, flowId] = await this._getCodeChallengeAndMethod();
            redirectTo = this._maybeAppendFlowIdToRedirect(redirectTo, flowId);
        }
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (codeChallenge != null && codeChallengeMethod != null) {
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return {
            url: `${url}?${urlParams.join('&')}`,
            flowId: flowId
        };
    }
    /**
     * Appends the reserved flow id parameter to a redirect URL so the callback
     * can be matched to the verifier stored for its flow. Opt-in via
     * `experimental.appendPkceFlowIdToRedirects`: redirect URLs are validated
     * against the project's allow list including the query string, so an extra
     * parameter can stop exact (non-wildcard) entries from matching.
     */ _maybeAppendFlowIdToRedirect(redirectTo, flowId) {
        if (!redirectTo || !flowId || !this.experimental.appendPkceFlowIdToRedirects) return redirectTo !== null && redirectTo !== void 0 ? redirectTo : undefined;
        return (0, $9tGer.appendFlowIdToRedirectTo)(redirectTo, flowId);
    }
    /**
     * Generates and stores a PKCE challenge/verifier pair for a new flow,
     * logging any pending verifier the bounded slot ring evicts.
     */ async _getCodeChallengeAndMethod(isPasswordRecovery = false) {
        return (0, $9tGer.getCodeChallengeAndMethod)(this.storage, this.storageKey, isPasswordRecovery, (evictedFlowId)=>this._debug('#_getCodeChallengeAndMethod()', 'evicted oldest pending PKCE verifier slot', evictedFlowId));
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                return await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : params.factorType === 'totp' ? {
                    issuer: params.issuer
                } : {});
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/factors`, {
                    body: body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                if (params.factorType === 'totp' && data.type === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async _verify(params) {
        const run = async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const body = Object.assign({
                        challenge_id: params.challengeId
                    }, 'webauthn' in params ? {
                        webauthn: Object.assign(Object.assign({}, params.webauthn), {
                            credential_response: params.webauthn.type === 'create' ? (0, $ctRCA.serializeCredentialCreationResponse)(params.webauthn.credential_response) : (0, $ctRCA.serializeCredentialRequestResponse)(params.webauthn.credential_response)
                        })
                    } : {
                        code: params.code
                    });
                    const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: body,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return this._returnResult({
                        data: null,
                        error: error
                    });
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return this._returnResult({
                        data: data,
                        error: error
                    });
                });
            } catch (error) {
                if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        };
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return this._acquireLock(this.lockAcquireTimeout, run);
        return run();
    }
    async _challenge(params) {
        const run = async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const response = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: params,
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (response.error) return response;
                    const { data: data } = response;
                    if (data.type !== 'webauthn') return {
                        data: data,
                        error: null
                    };
                    switch(data.webauthn.type){
                        case 'create':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $ctRCA.deserializeCredentialCreationOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                        case 'request':
                            return {
                                data: Object.assign(Object.assign({}, data), {
                                    webauthn: Object.assign(Object.assign({}, data.webauthn), {
                                        credential_options: Object.assign(Object.assign({}, data.webauthn.credential_options), {
                                            publicKey: (0, $ctRCA.deserializeCredentialRequestOptions)(data.webauthn.credential_options.publicKey)
                                        })
                                    })
                                }),
                                error: null
                            };
                    }
                });
            } catch (error) {
                if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        };
        if (this.lock != null) // TODO(v3): remove legacy lock path
        return this._acquireLock(this.lockAcquireTimeout, run);
        return run();
    }
    /**
     * {@link GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return this._returnResult({
            data: null,
            error: challengeError
        });
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@link GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        var _a;
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const data = {
            all: [],
            phone: [],
            totp: [],
            webauthn: [],
            recovery_code: []
        };
        // loop over the factors ONCE
        for (const factor of (_a = user === null || user === void 0 ? void 0 : user.factors) !== null && _a !== void 0 ? _a : []){
            data.all.push(factor);
            // Types that are not recognized are pushed to `all` bucket.
            if (factor.status === 'verified' && factor.factor_type in data && Array.isArray(data[factor.factor_type])) data[factor.factor_type].push(factor);
        }
        return {
            data: data,
            error: null
        };
    }
    /**
     * {@link GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel(jwt) {
        var _a, _b, _c, _d;
        if (jwt) try {
            const { payload: payload } = (0, $9tGer.decodeJWT)(jwt);
            let currentLevel = null;
            if (payload.aal) currentLevel = payload.aal;
            let nextLevel = currentLevel;
            const { data: { user: user }, error: userError } = await this.getUser(jwt);
            if (userError) return this._returnResult({
                data: null,
                error: userError
            });
            const verifiedFactors = (_b = (_a = user === null || user === void 0 ? void 0 : user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
            if (verifiedFactors.length > 0) nextLevel = 'aal2';
            const currentAuthenticationMethods = payload.amr || [];
            return {
                data: {
                    currentLevel: currentLevel,
                    nextLevel: nextLevel,
                    currentAuthenticationMethods: currentAuthenticationMethods
                },
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
        const { data: { session: session }, error: sessionError } = await this.getSession();
        if (sessionError) return this._returnResult({
            data: null,
            error: sessionError
        });
        if (!session) return {
            data: {
                currentLevel: null,
                nextLevel: null,
                currentAuthenticationMethods: []
            },
            error: null
        };
        const { payload: payload } = (0, $9tGer.decodeJWT)(session.access_token);
        let currentLevel = null;
        if (payload.aal) currentLevel = payload.aal;
        let nextLevel = currentLevel;
        const verifiedFactors = (_d = (_c = session.user.factors) === null || _c === void 0 ? void 0 : _c.filter((factor)=>factor.status === 'verified')) !== null && _d !== void 0 ? _d : [];
        if (verifiedFactors.length > 0) nextLevel = 'aal2';
        const currentAuthenticationMethods = payload.amr || [];
        return {
            data: {
                currentLevel: currentLevel,
                nextLevel: nextLevel,
                currentAuthenticationMethods: currentAuthenticationMethods
            },
            error: null
        };
    }
    /**
     * {@link AuthMFARecoveryCodesApi#getStatus}
     */ async _getRecoveryCodesStatus() {
        (0, $9tGer.assertRecoveryCodesExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/factors/recovery-codes`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * {@link AuthMFARecoveryCodesApi#generate}
     */ async _generateRecoveryCodes(params) {
        (0, $9tGer.assertRecoveryCodesExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/factors/recovery-codes`, {
                    // The body is optional server-side; only send one when a name was given.
                    body: (params === null || params === void 0 ? void 0 : params.friendlyName) ? {
                        friendly_name: params.friendlyName
                    } : undefined,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * {@link AuthMFARecoveryCodesApi#verify}
     */ async _verifyRecoveryCode(params) {
        (0, $9tGer.assertRecoveryCodesExperimentalEnabled)(this.experimental);
        const run = async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return this._returnResult({
                        data: null,
                        error: sessionError
                    });
                    const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/factors/recovery-codes/verify`, {
                        body: {
                            code: params.code
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return this._returnResult({
                        data: null,
                        error: error
                    });
                    // A server-provided expires_at takes precedence over the computed one.
                    const session = Object.assign({
                        expires_at: (0, $9tGer.expiresAt)(data.expires_in)
                    }, data);
                    await this._saveSession(session);
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', session);
                    return this._returnResult({
                        data: data,
                        error: null
                    });
                });
            } catch (error) {
                if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                    data: null,
                    error: error
                });
                throw error;
            }
        };
        if (this.lock != null) return this._acquireLock(this.lockAcquireTimeout, run);
        return run();
    }
    /**
     * {@link AuthMFARecoveryCodesApi#regenerate}
     */ async _regenerateRecoveryCodes() {
        (0, $9tGer.assertRecoveryCodesExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/factors/recovery-codes/regenerate`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * {@link AuthMFARecoveryCodesApi#unenroll}
     */ async _unenrollRecoveryCodes() {
        (0, $9tGer.assertRecoveryCodesExperimentalEnabled)(this.experimental);
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/factors/recovery-codes`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Retrieves details about an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     *
     * Returns authorization details including client info, scopes, and user information.
     * If the response includes only a redirect_url field, it means consent was already given - the caller
     * should handle the redirect manually if needed.
     */ async _getAuthorizationDetails(authorizationId) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/oauth/authorizations/${authorizationId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Approves an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _approveAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                const response = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'approve'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $9tGer.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Denies an OAuth authorization request.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _denyAuthorization(authorizationId, options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                const response = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/oauth/authorizations/${authorizationId}/consent`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        action: 'deny'
                    },
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (response.data && response.data.redirect_url) // Automatically redirect in browser unless skipBrowserRedirect is true
                {
                    if ((0, $9tGer.isBrowser)() && !(options === null || options === void 0 ? void 0 : options.skipBrowserRedirect)) window.location.assign(response.data.redirect_url);
                }
                return response;
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Lists all OAuth grants that the authenticated user has authorized.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _listOAuthGrants() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                return await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Revokes a user's OAuth grant for a specific client.
     * Only relevant when the OAuth 2.1 server is enabled in Supabase Auth.
     */ async _revokeOAuthGrant(options) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/user/oauth/grants`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    query: {
                        client_id: options.clientId
                    },
                    noResolveJson: true
                });
                return {
                    data: {},
                    error: null
                };
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    async fetchJwk(kid, jwks = {
        keys: []
    }) {
        // try fetching from the supplied jwks
        let jwk = jwks.keys.find((key)=>key.kid === kid);
        if (jwk) return jwk;
        const now = Date.now();
        // try fetching from cache
        jwk = this.jwks.keys.find((key)=>key.kid === kid);
        // jwk exists and jwks isn't stale
        if (jwk && this.jwks_cached_at + (0, $nTVnO.JWKS_TTL) > now) return jwk;
        // jwk isn't cached in memory so we need to fetch it from the well-known endpoint
        const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/.well-known/jwks.json`, {
            headers: this.headers
        });
        if (error) throw error;
        if (!data.keys || data.keys.length === 0) return null;
        this.jwks = data;
        this.jwks_cached_at = now;
        // Find the signing key
        jwk = data.keys.find((key)=>key.kid === kid);
        if (!jwk) return null;
        return jwk;
    }
    /**
     * Extracts the JWT claims present in the access token by first verifying the
     * JWT against the server's JSON Web Key Set endpoint
     * `/.well-known/jwks.json` which is often cached, resulting in significantly
     * faster responses. Prefer this method over {@link GoTrueClient.getUser} which always
     * sends a request to the Auth server for each JWT.
     *
     * If the project is not using an asymmetric JWT signing key (like ECC or
     * RSA) it always sends a request to the Auth server (similar to
     * {@link GoTrueClient.getUser}) to verify the JWT.
     *
     * @param jwt An optional specific JWT you wish to verify, not the one you
     *            can obtain from {@link GoTrueClient.getSession}.
     * @param options Various additional options that allow you to customize the
     *                behavior of this method.
     *
     * @category Auth
     *
     * @remarks
     * - Parses the user's [access token](/docs/guides/auth/sessions#access-token-jwt-claims) as a [JSON Web Token (JWT)](/docs/guides/auth/jwts) and returns its components if valid and not expired.
     * - If your project is using asymmetric JWT signing keys, then the verification is done locally usually without a network request using the [WebCrypto API](https://developer.mozilla.org/en-US/docs/Web/API/Web_Crypto_API).
     * - A network request is sent to your project's JWT signing key discovery endpoint `https://project-id.supabase.co/auth/v1/.well-known/jwks.json`, which is cached locally. If your environment is ephemeral, such as a Lambda function that is destroyed after every request, a network request will be sent for each new invocation. Supabase provides a network-edge cache providing fast responses for these situations.
     * - If the user's access token is about to expire when calling this function, the user's session will first be refreshed before validating the JWT.
     * - If your project is using a symmetric secret to sign the JWT, it always sends a request similar to `getUser()` to validate the JWT at the server before returning the decoded token. This is also used if the WebCrypto API is not available in the environment. Make sure you polyfill it in such situations.
     * - The returned claims can be customized per project using the [Custom Access Token Hook](/docs/guides/auth/auth-hooks/custom-access-token-hook).
     *
     * @example Get JWT claims, header and signature
     * ```js
     * const { data, error } = await supabase.auth.getClaims()
     * ```
     *
     * @exampleResponse Get JWT claims, header and signature
     * ```json
     * {
     *   "data": {
     *     "claims": {
     *       "aal": "aal1",
     *       "amr": [{
     *         "method": "email",
     *         "timestamp": 1715766000
     *       }],
     *       "app_metadata": {},
     *       "aud": "authenticated",
     *       "email": "example@email.com",
     *       "exp": 1715769600,
     *       "iat": 1715766000,
     *       "is_anonymous": false,
     *       "iss": "https://project-id.supabase.co/auth/v1",
     *       "phone": "+13334445555",
     *       "role": "authenticated",
     *       "session_id": "11111111-1111-1111-1111-111111111111",
     *       "sub": "11111111-1111-1111-1111-111111111111",
     *       "user_metadata": {}
     *     },
     *     "header": {
     *       "alg": "RS256",
     *       "typ": "JWT",
     *       "kid": "11111111-1111-1111-1111-111111111111"
     *     },
     *     "signature": [/** Uint8Array *\/],
     *   },
     *   "error": null
     * }
     * ```
     */ async getClaims(jwt, options = {}) {
        try {
            let token = jwt;
            if (!token) {
                const { data: data, error: error } = await this.getSession();
                if (error || !data.session) return this._returnResult({
                    data: null,
                    error: error
                });
                token = data.session.access_token;
            }
            const { header: header, payload: payload, signature: signature, raw: { header: rawHeader, payload: rawPayload } } = (0, $9tGer.decodeJWT)(token);
            if (!(options === null || options === void 0 ? void 0 : options.allowExpired)) // Reject expired JWTs should only happen if jwt argument was passed.
            // Rethrow as AuthInvalidJwtError so the outer catch converts it to { data, error }.
            try {
                (0, $9tGer.validateExp)(payload.exp);
            } catch (e) {
                throw new (0, $e1qhh.AuthInvalidJwtError)(e instanceof Error ? e.message : 'JWT validation failed');
            }
            const signingKey = !header.alg || header.alg.startsWith('HS') || !header.kid || !('crypto' in globalThis && 'subtle' in globalThis.crypto) ? null : await this.fetchJwk(header.kid, (options === null || options === void 0 ? void 0 : options.keys) ? {
                keys: options.keys
            } : options === null || options === void 0 ? void 0 : options.jwks);
            // If symmetric algorithm or WebCrypto API is unavailable, fallback to getUser()
            if (!signingKey) {
                const { error: error } = await this.getUser(token);
                if (error) throw error;
                // getUser succeeds so the claims in the JWT can be trusted
                return {
                    data: {
                        claims: payload,
                        header: header,
                        signature: signature
                    },
                    error: null
                };
            }
            const algorithm = (0, $9tGer.getAlgorithm)(header.alg);
            // Convert JWK to CryptoKey
            const publicKey = await crypto.subtle.importKey('jwk', signingKey, algorithm, true, [
                'verify'
            ]);
            // Verify the signature
            const isValid = await crypto.subtle.verify(algorithm, publicKey, signature, (0, $PVTtI.stringToUint8Array)(`${rawHeader}.${rawPayload}`));
            if (!isValid) throw new (0, $e1qhh.AuthInvalidJwtError)('Invalid JWT signature');
            // If verification succeeds, decode and return claims
            return {
                data: {
                    claims: payload,
                    header: header,
                    signature: signature
                },
                error: null
            };
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    // --- Passkey Methods ---
    /**
     * Sign in with a passkey. Handles the full WebAuthn ceremony:
     * 1. Fetches authentication challenge from server
     * 2. Prompts user via navigator.credentials.get()
     * 3. Verifies credential with server and creates session
     *
     * Pass `options.mediation: 'conditional'` to use WebAuthn Conditional UI
     * (passkey autofill) instead of the modal picker; the value is forwarded to
     * `navigator.credentials.get()` unchanged.
     *
     * The challenge fetched in step 1 expires after the server's
     * GOTRUE_WEBAUTHN_CHALLENGE_EXPIRY_DURATION (5 minutes by default). With
     * `mediation: 'conditional'` the autofill prompt can stay pending for longer
     * than that: the browser ceremony then still succeeds, but verification fails
     * with `error_code: "webauthn_challenge_expired"`. Recover by calling
     * `signInWithPasskey()` again. It fetches a fresh challenge and, unless you
     * passed your own `options.signal`, cancels the pending ceremony first, so
     * the browser never sees two concurrent WebAuthn requests; the earlier call
     * resolves with a `WebAuthnError` whose code is `ERROR_CEREMONY_ABORTED`. If
     * you pass your own `signal`, abort it before retrying.
     *
     * @category Auth
     *
     * @example Sign in with Conditional UI (passkey autofill)
     * ```js
     * // <input autocomplete="username webauthn" /> somewhere on the page
     * const { data, error } = await supabase.auth.signInWithPasskey({
     *   options: {
     *     mediation: 'conditional'
     *   }
     * });
     * ```
     */ async signInWithPasskey(credentials) {
        var _a, _b, _c, _d;
        try {
            if (!(0, $ctRCA.browserSupportsWebAuthn)()) return this._returnResult({
                data: null,
                error: new (0, $e1qhh.AuthUnknownError)('Browser does not support WebAuthn', null)
            });
            // 1. Get challenge options from server
            const { data: options, error: optionsError } = await this._startPasskeyAuthentication({
                options: {
                    captchaToken: (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.captchaToken
                }
            });
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            // 2. Deserialize and prompt user via browser WebAuthn API
            const publicKeyOptions = (0, $ctRCA.deserializeCredentialRequestOptions)(options.options);
            const signal = (_c = (_b = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _b === void 0 ? void 0 : _b.signal) !== null && _c !== void 0 ? _c : (0, $ctRCA.webAuthnAbortService).createNewAbortSignal();
            const { data: credential, error: credentialError } = await (0, $ctRCA.getCredential)({
                publicKey: publicKeyOptions,
                signal: signal,
                mediation: (_d = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _d === void 0 ? void 0 : _d.mediation
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new (0, $e1qhh.AuthUnknownError)('WebAuthn ceremony failed', null)
            });
            // 3. Serialize and verify with server
            const serialized = (0, $ctRCA.serializeCredentialRequestResponse)(credential);
            return this._verifyPasskeyAuthentication({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Register a passkey for the current authenticated user. Handles the full WebAuthn ceremony:
     * 1. Fetches registration challenge from server
     * 2. Prompts user via navigator.credentials.create()
     * 3. Verifies credential with server
     *
     * Requires an active session.
     *
     * @category Auth
     */ async registerPasskey(credentials) {
        var _a, _b;
        try {
            if (!(0, $ctRCA.browserSupportsWebAuthn)()) return this._returnResult({
                data: null,
                error: new (0, $e1qhh.AuthUnknownError)('Browser does not support WebAuthn', null)
            });
            // 1. Get challenge options from server
            const { data: options, error: optionsError } = await this._startPasskeyRegistration();
            if (optionsError || !options) return this._returnResult({
                data: null,
                error: optionsError
            });
            // 2. Deserialize and prompt user via browser WebAuthn API
            const publicKeyOptions = (0, $ctRCA.deserializeCredentialCreationOptions)(options.options);
            const signal = (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.signal) !== null && _b !== void 0 ? _b : (0, $ctRCA.webAuthnAbortService).createNewAbortSignal();
            const { data: credential, error: credentialError } = await (0, $ctRCA.createCredential)({
                publicKey: publicKeyOptions,
                signal: signal
            });
            if (credentialError || !credential) return this._returnResult({
                data: null,
                error: credentialError !== null && credentialError !== void 0 ? credentialError : new (0, $e1qhh.AuthUnknownError)('WebAuthn ceremony failed', null)
            });
            // 3. Serialize and verify with server
            const serialized = (0, $ctRCA.serializeCredentialCreationResponse)(credential);
            return this._verifyPasskeyRegistration({
                challengeId: options.challenge_id,
                credential: serialized
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Start passkey registration for the current authenticated user.
     * Returns WebAuthn credential creation options to pass to navigator.credentials.create().
     */ async _startPasskeyRegistration() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/passkeys/registration/options`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {}
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Verify passkey registration with the credential response.
     * The credentialResponse should be the serialized output of navigator.credentials.create().
     */ async _verifyPasskeyRegistration(params) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/passkeys/registration/verify`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        challenge_id: params.challengeId,
                        credential: params.credential
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Start passkey authentication.
     * Returns WebAuthn credential request options to pass to navigator.credentials.get().
     */ async _startPasskeyAuthentication(params) {
        var _a;
        try {
            const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/passkeys/authentication/options`, {
                headers: this.headers,
                body: {
                    gotrue_meta_security: {
                        captcha_token: (_a = params === null || params === void 0 ? void 0 : params.options) === null || _a === void 0 ? void 0 : _a.captchaToken
                    }
                }
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            return this._returnResult({
                data: data,
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Verify passkey authentication and create a session.
     * The credential should be the serialized output of navigator.credentials.get().
     */ async _verifyPasskeyAuthentication(params) {
        try {
            const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'POST', `${this.url}/passkeys/authentication/verify`, {
                headers: this.headers,
                body: {
                    challenge_id: params.challengeId,
                    credential: params.credential
                },
                xform: (0, $chSC8._sessionResponse)
            });
            if (error) return this._returnResult({
                data: null,
                error: error
            });
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return this._returnResult({
                data: data,
                error: null
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * List all passkeys for the current user.
     */ async _listPasskeys() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'GET', `${this.url}/passkeys`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    xform: (data)=>({
                            data: data,
                            error: null
                        })
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Update a passkey.
     */ async _updatePasskey(params) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                const { data: data, error: error } = await (0, $chSC8._request)(this.fetch, 'PATCH', `${this.url}/passkeys/${params.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    body: {
                        friendly_name: params.friendlyName
                    }
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: data,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
    /**
     * Delete a passkey.
     */ async _deletePasskey(params) {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return this._returnResult({
                    data: null,
                    error: sessionError
                });
                if (!session) return this._returnResult({
                    data: null,
                    error: new (0, $e1qhh.AuthSessionMissingError)()
                });
                const { error: error } = await (0, $chSC8._request)(this.fetch, 'DELETE', `${this.url}/passkeys/${params.passkeyId}`, {
                    headers: this.headers,
                    jwt: session.access_token,
                    noResolveJson: true
                });
                if (error) return this._returnResult({
                    data: null,
                    error: error
                });
                return this._returnResult({
                    data: null,
                    error: null
                });
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return this._returnResult({
                data: null,
                error: error
            });
            throw error;
        }
    }
}
$787713ac43d87621$var$GoTrueClient.nextInstanceID = {};
var $787713ac43d87621$export$2e2bcd8739ae039 = $787713ac43d87621$var$GoTrueClient;

});
parcelRegister("i5VQk", function(module, exports) {

$parcel$export(module.exports, "memoryLocalStorageAdapter", () => $d2c59009e29f980b$export$d791f66d7e5710cf);
/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ function $d2c59009e29f980b$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}

});

parcelRegister("cqGWb", function(module, exports) {

$parcel$export(module.exports, "LockAcquireTimeoutError", () => $90c9383aa6f67c36$export$23e9464cc010dff9);
/**
 * Lock primitives retained for backwards-compatible imports. The auth client
 * coordinates refreshes itself (deduping in-instance callers onto a shared
 * in-flight promise) and lets the GoTrue server resolve cross-instance races,
 * so it does not invoke any primitive from this module. The functions still
 * work for direct callers that need a navigator.locks-backed or in-process
 * exclusive lock of their own.
 */ 
var $9tGer = parcelRequire("9tGer");
const $90c9383aa6f67c36$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $9tGer.supportsLocalStorage)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class $90c9383aa6f67c36$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $90c9383aa6f67c36$export$4aa56776043a4631 extends $90c9383aa6f67c36$export$23e9464cc010dff9 {
}
class $90c9383aa6f67c36$export$4b982ee840d3d915 extends $90c9383aa6f67c36$export$23e9464cc010dff9 {
}
async function $90c9383aa6f67c36$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    let acquireTimeoutTimer;
    if (acquireTimeout > 0) acquireTimeoutTimer = setTimeout(()=>{
        abortController.abort();
        if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    await Promise.resolve();
    try {
        return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                // Lock acquired — cancel the acquire-timeout timer so it cannot fire
                // while fn() is running. Without this, a delayed timeout abort would
                // set signal.aborted = true even though we already hold the lock,
                // causing a subsequent steal to be misclassified as "our timeout
                // fired" and triggering a spurious steal-back cascade.
                clearTimeout(acquireTimeoutTimer);
                if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new $90c9383aa6f67c36$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                clearTimeout(acquireTimeoutTimer);
                return await fn();
            }
        });
    } catch (e) {
        // Always clear the acquire timeout once the request settles, so it cannot
        // fire later and incorrectly abort/log after a rejection.
        clearTimeout(acquireTimeoutTimer);
        // DOMException does not extend Error in Node.js, so use structural check
        if (e !== null && typeof e === 'object' && 'name' in e && e.name === 'AbortError') {
            if (abortController.signal.aborted) {
                // OUR timeout fired — the lock is genuinely orphaned. Steal it.
                //
                // The lock acquisition was aborted because the timeout fired while the
                // request was still pending. This typically means another lock holder is
                // not releasing the lock, possibly due to React Strict Mode's
                // double-mount/unmount behavior or a component unmounting mid-operation,
                // leaving an orphaned lock.
                //
                // Recovery: use { steal: true } to forcefully acquire the lock. Per the
                // Web Locks API spec, this releases any currently held lock with the same
                // name and grants the request immediately, preempting any queued requests.
                // The previous holder's callback continues running to completion but no
                // longer holds the lock for exclusion purposes.
                //
                // See: https://github.com/supabase/supabase/issues/42505
                if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire timeout, recovering by stealing lock', name);
                console.warn(`@supabase/gotrue-js: Lock "${name}" was not released within ${acquireTimeout}ms. ` + 'This may indicate an orphaned lock from a component unmount (e.g., React Strict Mode). ' + 'Forcefully acquiring the lock to recover.');
                return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, {
                        mode: 'exclusive',
                        steal: true
                    }, async (lock)=>{
                        if (lock) {
                            if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: recovered (stolen)', name, lock.name);
                            try {
                                return await fn();
                            } finally{
                                if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released (stolen)', name, lock.name);
                            }
                        } else {
                            // This should not happen with steal: true, but handle gracefully.
                            console.warn('@supabase/gotrue-js: Navigator LockManager returned null lock even with steal: true');
                            return await fn();
                        }
                    }));
            } else {
                // We HELD the lock but another request stole it from us.
                // Per the Web Locks spec, our fn() callback is still running as an
                // orphaned background task — do NOT steal back. Stealing back would
                // cause a cascade (A steals B, B steals A, ...) and run fn() a second
                // time concurrently, corrupting auth state.
                // Convert to a typed error so callers (e.g. _autoRefreshTokenTick)
                // can handle/filter it without it leaking to Sentry as a raw AbortError.
                if ($90c9383aa6f67c36$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: lock was stolen by another request', name);
                throw new $90c9383aa6f67c36$export$4aa56776043a4631(`Lock "${name}" was released because another request stole it`);
            }
        }
        throw e;
    }
}
const $90c9383aa6f67c36$var$PROCESS_LOCKS = {};
async function $90c9383aa6f67c36$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = $90c9383aa6f67c36$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    // Wrap previousOperation to handle errors without using .catch()
    // This avoids Firefox content script security errors
    const previousOperationHandled = (async ()=>{
        try {
            await previousOperation;
            return null;
        } catch (e) {
            // ignore error of previous operation that we're waiting to finish
            return null;
        }
    })();
    const currentOperation = (async ()=>{
        let timeoutId = null;
        try {
            // Wait for either previous operation or timeout
            const timeoutPromise = acquireTimeout >= 0 ? new Promise((_, reject)=>{
                timeoutId = setTimeout(()=>{
                    console.warn(`@supabase/gotrue-js: Lock "${name}" acquisition timed out after ${acquireTimeout}ms. ` + 'This may be caused by another operation holding the lock. ' + 'Consider increasing lockAcquireTimeout or checking for stuck operations.');
                    reject(new $90c9383aa6f67c36$export$4b982ee840d3d915(`Acquiring process lock with name "${name}" timed out`));
                }, acquireTimeout);
            }) : null;
            await Promise.race([
                previousOperationHandled,
                timeoutPromise
            ].filter((x)=>x));
            // If we reach here, previousOperationHandled won the race
            // Clear the timeout to prevent false warnings
            if (timeoutId !== null) clearTimeout(timeoutId);
        } catch (e) {
            // Clear the timeout on error path as well
            if (timeoutId !== null) clearTimeout(timeoutId);
            // Re-throw timeout errors, ignore others
            if (e instanceof $90c9383aa6f67c36$export$23e9464cc010dff9) throw e;
        // Fall through to run fn() - previous operation finished with error
        }
        // Previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    })();
    $90c9383aa6f67c36$var$PROCESS_LOCKS[name] = (async ()=>{
        try {
            return await currentOperation;
        } catch (e) {
            if (e instanceof $90c9383aa6f67c36$export$23e9464cc010dff9) {
                // if the current operation timed out, it doesn't mean that the previous
                // operation finished, so we need continue waiting for it to finish
                try {
                    await previousOperation;
                } catch (prevError) {
                // Ignore previous operation errors
                }
                return null;
            }
            throw e;
        }
    })();
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}

});

parcelRegister("8uOnr", function(module, exports) {

$parcel$export(module.exports, "polyfillGlobalThis", () => $62f833ea376f4f27$export$ad067ce270531206);
/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $62f833ea376f4f27$export$ad067ce270531206() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}

});

parcelRegister("bJ1Vx", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $8895645b0a6848ba$export$88411125f012957a);
$parcel$export(module.exports, "fromHex", () => $8895645b0a6848ba$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $8895645b0a6848ba$export$7ea66e3774a60b67);
$parcel$export(module.exports, "createSiweMessage", () => $8895645b0a6848ba$export$7ee2e5fde403d4c8);
// types and functions copied over from viem so this library doesn't depend on it
function $8895645b0a6848ba$export$88411125f012957a(address) {
    if (!/^0x[a-fA-F0-9]{40}$/.test(address)) throw new Error(`@supabase/auth-js: Address "${address}" is invalid.`);
    return address.toLowerCase();
}
function $8895645b0a6848ba$export$1a8ceedbd5845648(hex) {
    return parseInt(hex, 16);
}
function $8895645b0a6848ba$export$7ea66e3774a60b67(value) {
    const bytes = new TextEncoder().encode(value);
    const hex = Array.from(bytes, (byte)=>byte.toString(16).padStart(2, '0')).join('');
    return '0x' + hex;
}
function $8895645b0a6848ba$export$7ee2e5fde403d4c8(parameters) {
    var _a;
    const { chainId: chainId, domain: domain, expirationTime: expirationTime, issuedAt: issuedAt = new Date(), nonce: nonce, notBefore: notBefore, requestId: requestId, resources: resources, scheme: scheme, uri: uri, version: version } = parameters;
    if (!Number.isInteger(chainId)) throw new Error(`@supabase/auth-js: Invalid SIWE message field "chainId". Chain ID must be a EIP-155 chain ID. Provided value: ${chainId}`);
    if (!domain) throw new Error(`@supabase/auth-js: Invalid SIWE message field "domain". Domain must be provided.`);
    if (nonce && nonce.length < 8) throw new Error(`@supabase/auth-js: Invalid SIWE message field "nonce". Nonce must be at least 8 characters. Provided value: ${nonce}`);
    if (!uri) throw new Error(`@supabase/auth-js: Invalid SIWE message field "uri". URI must be provided.`);
    if (version !== '1') throw new Error(`@supabase/auth-js: Invalid SIWE message field "version". Version must be '1'. Provided value: ${version}`);
    if ((_a = parameters.statement) === null || _a === void 0 ? void 0 : _a.includes('\n')) throw new Error(`@supabase/auth-js: Invalid SIWE message field "statement". Statement must not include '\\n'. Provided value: ${parameters.statement}`);
    // Construct message
    const address = $8895645b0a6848ba$export$88411125f012957a(parameters.address);
    const origin = scheme ? `${scheme}://${domain}` : domain;
    const statement = parameters.statement ? `${parameters.statement}\n` : '';
    const prefix = `${origin} wants you to sign in with your Ethereum account:\n${address}\n\n${statement}`;
    let suffix = `URI: ${uri}\nVersion: ${version}\nChain ID: ${chainId}${nonce ? `\nNonce: ${nonce}` : ''}\nIssued At: ${issuedAt.toISOString()}`;
    if (expirationTime) suffix += `\nExpiration Time: ${expirationTime.toISOString()}`;
    if (notBefore) suffix += `\nNot Before: ${notBefore.toISOString()}`;
    if (requestId) suffix += `\nRequest ID: ${requestId}`;
    if (resources) {
        let content = '\nResources:';
        for (const resource of resources){
            if (!resource || typeof resource !== 'string') throw new Error(`@supabase/auth-js: Invalid SIWE message field "resources". Every resource must be a valid string. Provided value: ${resource}`);
            content += `\n- ${resource}`;
        }
        suffix += content;
    }
    return `${prefix}\n${suffix}`;
}

});

parcelRegister("ctRCA", function(module, exports) {

$parcel$export(module.exports, "webAuthnAbortService", () => $9161c990cc444bdc$export$4109de07ec7c8bef);
$parcel$export(module.exports, "deserializeCredentialCreationOptions", () => $9161c990cc444bdc$export$d02e6c69c68605f0);
$parcel$export(module.exports, "deserializeCredentialRequestOptions", () => $9161c990cc444bdc$export$943ff00a541d1017);
$parcel$export(module.exports, "serializeCredentialCreationResponse", () => $9161c990cc444bdc$export$4b534f6222f6d585);
$parcel$export(module.exports, "serializeCredentialRequestResponse", () => $9161c990cc444bdc$export$b3350da6d3acaa5a);
$parcel$export(module.exports, "isValidDomain", () => $9161c990cc444bdc$export$59e759560deddc3c);
$parcel$export(module.exports, "browserSupportsWebAuthn", () => $9161c990cc444bdc$export$21f8045e1be8a25d);
$parcel$export(module.exports, "createCredential", () => $9161c990cc444bdc$export$e4658562cd85d5e4);
$parcel$export(module.exports, "getCredential", () => $9161c990cc444bdc$export$298c59008c641b3e);
$parcel$export(module.exports, "WebAuthnApi", () => $9161c990cc444bdc$export$23264e48ebb7dee0);

var $5qviX = parcelRequire("5qviX");

var $PVTtI = parcelRequire("PVTtI");

var $e1qhh = parcelRequire("e1qhh");

var $9tGer = parcelRequire("9tGer");

var $a6Ecg = parcelRequire("a6Ecg");
class $9161c990cc444bdc$export$442ada5d34ca6e87 {
    /**
     * Create an abort signal for a new WebAuthn operation.
     * Automatically cancels any existing operation.
     *
     * @returns {AbortSignal} Signal to pass to navigator.credentials.create() or .get()
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal MDN - AbortSignal}
     */ createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            const abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    /**
     * Manually cancel the current WebAuthn operation.
     * Useful for cleaning up when user cancels or navigates away.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort MDN - AbortController.abort}
     */ cancelCeremony() {
        if (this.controller) {
            const abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const $9161c990cc444bdc$export$4109de07ec7c8bef = new $9161c990cc444bdc$export$442ada5d34ca6e87();
function $9161c990cc444bdc$export$d02e6c69c68605f0(options) {
    if (!options) throw new Error('Credential creation options are required');
    // Check if the native parseCreationOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseCreationOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseCreationOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseCreationOptionsFromJSON(/** we assert the options here as typescript still doesn't know about future webauthn types */ options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, user: userOpts, excludeCredentials: excludeCredentials } = options, restOptions = (0, $5qviX.__rest)(options, [
        "challenge",
        "user",
        "excludeCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $PVTtI.base64UrlToUint8Array)(challengeStr).buffer;
    // Convert user.id from base64url to ArrayBuffer
    const user = Object.assign(Object.assign({}, userOpts), {
        id: (0, $PVTtI.base64UrlToUint8Array)(userOpts.id).buffer
    });
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge,
        user: user
    });
    // Only add excludeCredentials if it exists
    if (excludeCredentials && excludeCredentials.length > 0) {
        result.excludeCredentials = new Array(excludeCredentials.length);
        for(let i = 0; i < excludeCredentials.length; i++){
            const cred = excludeCredentials[i];
            result.excludeCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $PVTtI.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $9161c990cc444bdc$export$943ff00a541d1017(options) {
    if (!options) throw new Error('Credential request options are required');
    // Check if the native parseRequestOptionsFromJSON method is available
    if (typeof PublicKeyCredential !== 'undefined' && 'parseRequestOptionsFromJSON' in PublicKeyCredential && typeof PublicKeyCredential.parseRequestOptionsFromJSON === 'function') // Use the native WebAuthn Level 3 method
    return PublicKeyCredential.parseRequestOptionsFromJSON(options);
    // Fallback to manual parsing for browsers that don't support the native method
    // Destructure to separate fields that need transformation
    const { challenge: challengeStr, allowCredentials: allowCredentials } = options, restOptions = (0, $5qviX.__rest)(options, [
        "challenge",
        "allowCredentials"
    ]);
    // Convert challenge from base64url to ArrayBuffer
    const challenge = (0, $PVTtI.base64UrlToUint8Array)(challengeStr).buffer;
    // Build the result object
    const result = Object.assign(Object.assign({}, restOptions), {
        challenge: challenge
    });
    // Only add allowCredentials if it exists
    if (allowCredentials && allowCredentials.length > 0) {
        result.allowCredentials = new Array(allowCredentials.length);
        for(let i = 0; i < allowCredentials.length; i++){
            const cred = allowCredentials[i];
            result.allowCredentials[i] = Object.assign(Object.assign({}, cred), {
                id: (0, $PVTtI.base64UrlToUint8Array)(cred.id).buffer,
                type: cred.type || 'public-key',
                // Cast transports to handle future transport types like "cable"
                transports: cred.transports
            });
        }
    }
    return result;
}
function $9161c990cc444bdc$export$4b534f6222f6d585(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    const credentialWithAttachment = credential;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            attestationObject: (0, $PVTtI.bytesToBase64URL)(new Uint8Array(credential.response.attestationObject)),
            clientDataJSON: (0, $PVTtI.bytesToBase64URL)(new Uint8Array(credential.response.clientDataJSON))
        },
        type: 'public-key',
        clientExtensionResults: credential.getClientExtensionResults(),
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $9161c990cc444bdc$export$b3350da6d3acaa5a(credential) {
    var _a;
    // Check if the credential instance has the toJSON method
    if ('toJSON' in credential && typeof credential.toJSON === 'function') // Use the native WebAuthn Level 3 method
    return credential.toJSON();
    // Fallback to manual conversion for browsers that don't support toJSON
    // Access authenticatorAttachment via type assertion to handle TypeScript version differences
    // @simplewebauthn/types includes this property but base TypeScript 4.7.4 doesn't
    const credentialWithAttachment = credential;
    const clientExtensionResults = credential.getClientExtensionResults();
    const assertionResponse = credential.response;
    return {
        id: credential.id,
        rawId: credential.id,
        response: {
            authenticatorData: (0, $PVTtI.bytesToBase64URL)(new Uint8Array(assertionResponse.authenticatorData)),
            clientDataJSON: (0, $PVTtI.bytesToBase64URL)(new Uint8Array(assertionResponse.clientDataJSON)),
            signature: (0, $PVTtI.bytesToBase64URL)(new Uint8Array(assertionResponse.signature)),
            userHandle: assertionResponse.userHandle ? (0, $PVTtI.bytesToBase64URL)(new Uint8Array(assertionResponse.userHandle)) : undefined
        },
        type: 'public-key',
        clientExtensionResults: clientExtensionResults,
        // Convert null to undefined and cast to AuthenticatorAttachment type
        authenticatorAttachment: (_a = credentialWithAttachment.authenticatorAttachment) !== null && _a !== void 0 ? _a : undefined
    };
}
function $9161c990cc444bdc$export$59e759560deddc3c(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}
function $9161c990cc444bdc$export$21f8045e1be8a25d() {
    var _a, _b;
    return !!((0, $9tGer.isBrowser)() && 'PublicKeyCredential' in window && window.PublicKeyCredential && 'credentials' in navigator && typeof ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _a === void 0 ? void 0 : _a.create) === 'function' && typeof ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.credentials) === null || _b === void 0 ? void 0 : _b.get) === 'function');
}
async function $9161c990cc444bdc$export$e4658562cd85d5e4(options) {
    try {
        const response = await navigator.credentials.create(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $a6Ecg.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $a6Ecg.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $a6Ecg.identifyRegistrationError)({
                error: err,
                options: options
            })
        };
    }
}
async function $9161c990cc444bdc$export$298c59008c641b3e(options) {
    try {
        const response = await navigator.credentials.get(/** we assert the type here until typescript types are updated */ options);
        if (!response) return {
            data: null,
            error: new (0, $a6Ecg.WebAuthnUnknownError)('Empty credential response', response)
        };
        if (!(response instanceof PublicKeyCredential)) return {
            data: null,
            error: new (0, $a6Ecg.WebAuthnUnknownError)('Browser returned unexpected credential type', response)
        };
        return {
            data: response,
            error: null
        };
    } catch (err) {
        return {
            data: null,
            error: (0, $a6Ecg.identifyAuthenticationError)({
                error: err,
                options: options
            })
        };
    }
}
const $9161c990cc444bdc$export$315ccaead2259c48 = {
    hints: [
        'security-key'
    ],
    authenticatorSelection: {
        authenticatorAttachment: 'cross-platform',
        requireResidentKey: false,
        /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
        residentKey: 'discouraged'
    },
    attestation: 'direct'
};
const $9161c990cc444bdc$export$26eadd1e9f10eb21 = {
    /** set to preferred because older yubikeys don't have PIN/Biometric */ userVerification: 'preferred',
    hints: [
        'security-key'
    ],
    attestation: 'direct'
};
function $9161c990cc444bdc$var$deepMerge(...sources) {
    const isObject = (val)=>val !== null && typeof val === 'object' && !Array.isArray(val);
    const isArrayBufferLike = (val)=>val instanceof ArrayBuffer || ArrayBuffer.isView(val);
    const result = {};
    for (const source of sources){
        if (!source) continue;
        for(const key in source){
            const value = source[key];
            if (value === undefined) continue;
            if (Array.isArray(value)) // preserve array reference, including unions like AuthenticatorTransport[]
            result[key] = value;
            else if (isArrayBufferLike(value)) result[key] = value;
            else if (isObject(value)) {
                const existing = result[key];
                if (isObject(existing)) result[key] = $9161c990cc444bdc$var$deepMerge(existing, value);
                else result[key] = $9161c990cc444bdc$var$deepMerge(value);
            } else result[key] = value;
        }
    }
    return result;
}
function $9161c990cc444bdc$export$3be75f4dca600793(baseOptions, overrides) {
    return $9161c990cc444bdc$var$deepMerge($9161c990cc444bdc$export$315ccaead2259c48, baseOptions, overrides || {});
}
function $9161c990cc444bdc$export$dd12a9ca29190b76(baseOptions, overrides) {
    return $9161c990cc444bdc$var$deepMerge($9161c990cc444bdc$export$26eadd1e9f10eb21, baseOptions, overrides || {});
}
class $9161c990cc444bdc$export$23264e48ebb7dee0 {
    constructor(client){
        this.client = client;
        // Bind all methods so they can be destructured
        this.enroll = this._enroll.bind(this);
        this.challenge = this._challenge.bind(this);
        this.verify = this._verify.bind(this);
        this.authenticate = this._authenticate.bind(this);
        this.register = this._register.bind(this);
    }
    /**
     * Enroll a new WebAuthn factor.
     * Creates an unverified WebAuthn factor that must be verified with a credential.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Omit<MFAEnrollWebauthnParams, 'factorType'>} params - Enrollment parameters (friendlyName required)
     * @returns {Promise<AuthMFAEnrollWebauthnResponse>} Enrolled factor details or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registering a New Credential}
     */ async _enroll(params) {
        return this.client.mfa.enroll(Object.assign(Object.assign({}, params), {
            factorType: 'webauthn'
        }));
    }
    /**
     * Challenge for WebAuthn credential creation or authentication.
     * Combines server challenge with browser credential operations.
     * Handles both registration (create) and authentication (request) flows.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {MFAChallengeWebauthnParams & { friendlyName?: string; signal?: AbortSignal }} params - Challenge parameters including factorId
     * @param {Object} overrides - Allows you to override the parameters passed to navigator.credentials
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides.create - Override options for credential creation
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides.request - Override options for credential request
     * @returns {Promise<RequestResult>} Challenge response with credential or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-credential-creation W3C WebAuthn Spec - Credential Creation}
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying Assertion}
     */ async _challenge({ factorId: factorId, webauthn: webauthn, friendlyName: friendlyName, signal: signal }, overrides) {
        var _a;
        try {
            // Get challenge from server using the client's MFA methods
            const { data: challengeResponse, error: challengeError } = await this.client.mfa.challenge({
                factorId: factorId,
                webauthn: webauthn
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const abortSignal = signal !== null && signal !== void 0 ? signal : $9161c990cc444bdc$export$4109de07ec7c8bef.createNewAbortSignal();
            /** webauthn will fail if either of the name/displayname are blank */ if (challengeResponse.webauthn.type === 'create') {
                const { user: user } = challengeResponse.webauthn.credential_options.publicKey;
                if (!user.name) {
                    // Preserve original format: use friendlyName if provided, otherwise fetch fallback
                    // This maintains backward compatibility with the ${user.id}:${name} format
                    const nameToUse = friendlyName;
                    if (!nameToUse) {
                        // Only fetch user data if friendlyName is not provided (bug fix for null friendlyName)
                        const currentUser = await this.client.getUser();
                        const userData = currentUser.data.user;
                        const fallbackName = ((_a = userData === null || userData === void 0 ? void 0 : userData.user_metadata) === null || _a === void 0 ? void 0 : _a.name) || (userData === null || userData === void 0 ? void 0 : userData.email) || (userData === null || userData === void 0 ? void 0 : userData.id) || 'User';
                        user.name = `${user.id}:${fallbackName}`;
                    } else user.name = `${user.id}:${nameToUse}`;
                }
                if (!user.displayName) user.displayName = user.name;
            }
            switch(challengeResponse.webauthn.type){
                case 'create':
                    {
                        const options = $9161c990cc444bdc$export$3be75f4dca600793(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.create);
                        const { data: data, error: error } = await $9161c990cc444bdc$export$e4658562cd85d5e4({
                            publicKey: options,
                            signal: abortSignal
                        });
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
                case 'request':
                    {
                        const options = $9161c990cc444bdc$export$dd12a9ca29190b76(challengeResponse.webauthn.credential_options.publicKey, overrides === null || overrides === void 0 ? void 0 : overrides.request);
                        const { data: data, error: error } = await $9161c990cc444bdc$export$298c59008c641b3e(Object.assign(Object.assign({}, challengeResponse.webauthn.credential_options), {
                            publicKey: options,
                            signal: abortSignal
                        }));
                        if (data) return {
                            data: {
                                factorId: factorId,
                                challengeId: challengeResponse.id,
                                webauthn: {
                                    type: challengeResponse.webauthn.type,
                                    credential_response: data
                                }
                            },
                            error: null
                        };
                        return {
                            data: null,
                            error: error
                        };
                    }
            }
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $e1qhh.AuthUnknownError)('Unexpected error in challenge', error)
            };
        }
    }
    /**
     * Verify a WebAuthn credential with the server.
     * Completes the WebAuthn ceremony by sending the credential to the server for verification.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Verification parameters
     * @param {string} params.challengeId - ID of the challenge being verified
     * @param {string} params.factorId - ID of the WebAuthn factor
     * @param {MFAVerifyWebauthnParams<T>['webauthn']} params.webauthn - WebAuthn credential response
     * @returns {Promise<AuthMFAVerifyResponse>} Verification result with session or error
     * @see {@link https://w3c.github.io/webauthn/#sctn-verifying-assertion W3C WebAuthn Spec - Verifying an Authentication Assertion}
     * */ async _verify({ challengeId: challengeId, factorId: factorId, webauthn: webauthn }) {
        return this.client.mfa.verify({
            factorId: factorId,
            challengeId: challengeId,
            webauthn: webauthn
        });
    }
    /**
     * Complete WebAuthn authentication flow.
     * Performs challenge and verification in a single operation for existing credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Authentication parameters
     * @param {string} params.factorId - ID of the WebAuthn factor to authenticate with
     * @param {Object} params.webauthn - WebAuthn configuration
     * @param {string} params.webauthn.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.webauthn.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.webauthn.signal - Optional abort signal
     * @param {PublicKeyCredentialRequestOptionsFuture} overrides - Override options for navigator.credentials.get
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Authentication result
     * @see {@link https://w3c.github.io/webauthn/#sctn-authentication W3C WebAuthn Spec - Authentication Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialRequestOptions MDN - PublicKeyCredentialRequestOptions}
     */ async _authenticate({ factorId: factorId, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $e1qhh.AuthError)('rpId is required for WebAuthn authentication')
        };
        try {
            if (!$9161c990cc444bdc$export$21f8045e1be8a25d()) return {
                data: null,
                error: new (0, $e1qhh.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Get challenge and credential
            const { data: challengeResponse, error: challengeError } = await this.challenge({
                factorId: factorId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                request: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            const { webauthn: webauthn } = challengeResponse;
            // Verify credential
            return this._verify({
                factorId: factorId,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    type: webauthn.type,
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    credential_response: webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $e1qhh.AuthUnknownError)('Unexpected error in authenticate', error)
            };
        }
    }
    /**
     * Complete WebAuthn registration flow.
     * Performs enrollment, challenge, and verification in a single operation for new credentials.
     *
     * @experimental This method is experimental and may change in future releases
     * @param {Object} params - Registration parameters
     * @param {string} params.friendlyName - User-friendly name for the credential
     * @param {string} params.rpId - Relying Party ID (defaults to current hostname)
     * @param {string[]} params.rpOrigins - Allowed origins (defaults to current origin)
     * @param {AbortSignal} params.signal - Optional abort signal
     * @param {PublicKeyCredentialCreationOptionsFuture} overrides - Override options for navigator.credentials.create
     * @returns {Promise<RequestResult<AuthMFAVerifyResponseData, WebAuthnError | AuthError>>} Registration result
     * @see {@link https://w3c.github.io/webauthn/#sctn-registering-a-new-credential W3C WebAuthn Spec - Registration Ceremony}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredentialCreationOptions MDN - PublicKeyCredentialCreationOptions}
     */ async _register({ friendlyName: friendlyName, webauthn: { rpId: rpId = typeof window !== 'undefined' ? window.location.hostname : undefined, rpOrigins: rpOrigins = typeof window !== 'undefined' ? [
        window.location.origin
    ] : undefined, signal: signal } = {} }, overrides) {
        if (!rpId) return {
            data: null,
            error: new (0, $e1qhh.AuthError)('rpId is required for WebAuthn registration')
        };
        try {
            if (!$9161c990cc444bdc$export$21f8045e1be8a25d()) return {
                data: null,
                error: new (0, $e1qhh.AuthUnknownError)('Browser does not support WebAuthn', null)
            };
            // Enroll factor
            const { data: factor, error: enrollError } = await this._enroll({
                friendlyName: friendlyName
            });
            if (!factor) {
                await this.client.mfa.listFactors().then((factors)=>{
                    var _a;
                    // Only an unverified factor is leftover from the enrollment that just
                    // failed, and removing it is what lets a retry with the same name
                    // succeed. A verified factor of that name is a passkey the user is
                    // already using, so it must never be selected here.
                    return (_a = factors.data) === null || _a === void 0 ? void 0 : _a.all.find((v)=>v.factor_type === 'webauthn' && v.friendly_name === friendlyName && v.status === 'unverified');
                }).then((factor)=>factor ? this.client.mfa.unenroll({
                        factorId: factor === null || factor === void 0 ? void 0 : factor.id
                    }) : void 0);
                return {
                    data: null,
                    error: enrollError
                };
            }
            // Get challenge and create credential
            const { data: challengeResponse, error: challengeError } = await this._challenge({
                factorId: factor.id,
                friendlyName: factor.friendly_name,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins
                },
                signal: signal
            }, {
                create: overrides
            });
            if (!challengeResponse) return {
                data: null,
                error: challengeError
            };
            return this._verify({
                factorId: factor.id,
                challengeId: challengeResponse.challengeId,
                webauthn: {
                    rpId: rpId,
                    rpOrigins: rpOrigins,
                    type: challengeResponse.webauthn.type,
                    credential_response: challengeResponse.webauthn.credential_response
                }
            });
        } catch (error) {
            if ((0, $e1qhh.isAuthError)(error)) return {
                data: null,
                error: error
            };
            return {
                data: null,
                error: new (0, $e1qhh.AuthUnknownError)('Unexpected error in register', error)
            };
        }
    }
}

});
parcelRegister("a6Ecg", function(module, exports) {

$parcel$export(module.exports, "WebAuthnUnknownError", () => $75b9a527c5da1295$export$2799e3b911935b0d);
$parcel$export(module.exports, "identifyRegistrationError", () => $75b9a527c5da1295$export$1c18a773f8a28a92);
$parcel$export(module.exports, "identifyAuthenticationError", () => $75b9a527c5da1295$export$9b62fd498befe529);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
var $ctRCA = parcelRequire("ctRCA");
class $75b9a527c5da1295$export$90f0c14a652de832 extends Error {
    constructor({ message: message, code: code, cause: cause, name: name }){
        var _a;
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        super(message, {
            cause: cause
        });
        this.__isWebAuthnError = true;
        this.name = (_a = name !== null && name !== void 0 ? name : cause instanceof Error ? cause.name : undefined) !== null && _a !== void 0 ? _a : 'Unknown Error';
        this.code = code;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            code: this.code
        };
    }
}
class $75b9a527c5da1295$export$2799e3b911935b0d extends $75b9a527c5da1295$export$90f0c14a652de832 {
    constructor(message, originalError){
        super({
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: originalError,
            message: message
        });
        this.name = 'WebAuthnUnknownError';
        this.originalError = originalError;
    }
}
function $75b9a527c5da1295$export$8596540875e19045(error) {
    return typeof error === 'object' && error !== null && '__isWebAuthnError' in error;
}
function $75b9a527c5da1295$export$1c18a773f8a28a92({ error: error, options: options }) {
    var _a, _b, _c;
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'Registration ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'ConstraintError') {
        if (((_a = publicKey.authenticatorSelection) === null || _a === void 0 ? void 0 : _a.requireResidentKey) === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'Discoverable credentials were required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
            cause: error
        });
        else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === 'conditional' && ((_b = publicKey.authenticatorSelection) === null || _b === void 0 ? void 0 : _b.userVerification) === 'required') // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'User verification was required during automatic registration but it could not be performed',
            code: 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE',
            cause: error
        });
        else if (((_c = publicKey.authenticatorSelection) === null || _c === void 0 ? void 0 : _c.userVerification) === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'User verification was required but no available authenticator supported it',
            code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
            cause: error
        });
    } else if (error.name === 'InvalidStateError') // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
    return new $75b9a527c5da1295$export$90f0c14a652de832({
        message: 'The authenticator was previously registered',
        code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
        cause: error
    });
    else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $75b9a527c5da1295$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'NotSupportedError') {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param)=>param.type === 'public-key');
        if (validPubKeyCredParams.length === 0) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'No entry in pubKeyCredParams was of type "public-key"',
            code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
            cause: error
        });
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $ctRCA.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'User ID was not between 1 and 64 characters',
            code: 'ERROR_INVALID_USER_ID_LENGTH',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
    return new $75b9a527c5da1295$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new credential',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $75b9a527c5da1295$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}
function $75b9a527c5da1295$export$9b62fd498befe529({ error: error, options: options }) {
    const { publicKey: publicKey } = options;
    if (!publicKey) throw Error('options was missing required publicKey property');
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: 'Authentication ceremony was sent an abort signal',
            code: 'ERROR_CEREMONY_ABORTED',
            cause: error
        });
    } else if (error.name === 'NotAllowedError') /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new $75b9a527c5da1295$export$90f0c14a652de832({
        message: error.message,
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
    else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!(0, $ctRCA.isValidDomain)(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: `${window.location.hostname} is an invalid domain`,
            code: 'ERROR_INVALID_DOMAIN',
            cause: error
        });
        else if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
        return new $75b9a527c5da1295$export$90f0c14a652de832({
            message: `The RP ID "${publicKey.rpId}" is invalid for this domain`,
            code: 'ERROR_INVALID_RP_ID',
            cause: error
        });
    } else if (error.name === 'UnknownError') // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
    // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
    return new $75b9a527c5da1295$export$90f0c14a652de832({
        message: 'The authenticator was unable to process the specified options, or could not create a new assertion signature',
        code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
        cause: error
    });
    return new $75b9a527c5da1295$export$90f0c14a652de832({
        message: 'a Non-Webauthn related error has occurred',
        code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
        cause: error
    });
}

});



parcelRegister("3NlKP", function(module, exports) {

var $9Errw = parcelRequire("9Errw");
const $2c36d2a4679cd9b1$var$AuthAdminApi = (0, $9Errw.default);
var $2c36d2a4679cd9b1$export$2e2bcd8739ae039 = $2c36d2a4679cd9b1$var$AuthAdminApi;

});

parcelRegister("dVg10", function(module, exports) {

$parcel$export(module.exports, "default", () => $a22d0583ad57dde8$export$2e2bcd8739ae039);

var $alesa = parcelRequire("alesa");
const $a22d0583ad57dde8$var$AuthClient = (0, $alesa.default);
var $a22d0583ad57dde8$export$2e2bcd8739ae039 = $a22d0583ad57dde8$var$AuthClient;

});






parcelRegister("bUsGn", function(module, exports) {

$parcel$export(module.exports, "embedDesignSystem", () => $8abb2c64a39ff9bf$export$8cfe6d8004adff25);
// USER-CODE-ORIGIN: the design-system tile renders OUR DS showcase over the
// PROJECT's own data (design system, components, functions), so it is a
// user-code mount and runs in the opaque user-code frame (userCodeFrame.js).
//
// The DS chrome (swatches / rows / sections) lives in
// workspace/packages/design-system and is handed in by the CALLER (canvas /
// preview) as `dsComponents` + `dsPages`. This keeps @symbo-ls/workspace-shared
// free of any dependency on @symbo-ls/workspace-design-system.
//
// Everything crosses as DATA, so the page is picked HERE: the parent reads
// `dsPages[dsPage]` and mounts that spec directly under `DsScene`. The DS
// package's own `DesignSystemScene` cannot cross — its `children` closes over
// the `dsPages` import, which a bundler renames (`(0, _dsPagesJsDefault
// .default)`) and which does not exist in the frame. A page change is a
// remount over the frame's port (`embedDesignSystem` again with the new
// `dsPage`), not a state write into another realm.

var $lLBGE = parcelRequire("lLBGE");
const $8abb2c64a39ff9bf$var$dsShellFor = (spec)=>({
        flow: 'column',
        height: '100vh',
        width: '100vw',
        gap: '0',
        overflow: 'hidden',
        DsScene: {
            flex: '1',
            position: 'relative',
            overflow: 'auto',
            ...spec ? {
                Page: spec
            } : {}
        }
    });
const $8abb2c64a39ff9bf$var$pageSpecOf = (dsPages, route)=>{
    const active = dsPages && (dsPages[route] || dsPages['/']) || null;
    if (!active || typeof active !== 'object') return null;
    const { key: _dropKey, ...spec } = active;
    return spec;
};
async function $8abb2c64a39ff9bf$export$8cfe6d8004adff25(iframeNode, data, initialState = {}, dsComponents = {}, { dsPages: dsPages = null, dsFrameKit: dsFrameKit = null, calls: calls = {}, allow: allow = null, onError: onError = null, el: el = null } = {}) {
    if (!iframeNode || !data) return null;
    const route = initialState && initialState.dsPage || '/';
    return (0, $lLBGE.mountUserCode)(iframeNode, data, $8abb2c64a39ff9bf$var$dsShellFor($8abb2c64a39ff9bf$var$pageSpecOf(dsPages, route)), {
        path: '/',
        // The DS components reach their helpers through el.call; the frame has no
        // parent registry, so the DS package's own frame kit (pure helpers as
        // CODE) rides in, and its editor actions are `calls` (design review D1).
        frameKit: dsFrameKit,
        calls: calls,
        allow: allow,
        onError: onError,
        el: el,
        logTag: '__ds' + route,
        contextOverrides: {
            pages: undefined,
            app: undefined,
            router: false,
            // The DS bundle under the project's own components: project components
            // still win for any collision (its own tokens / brand overrides).
            components: {
                ...dsComponents,
                ...data.components || {}
            },
            state: {
                ...data.state || {},
                ...initialState,
                dsReady: true
            }
        }
    });
}

});


parcelRegister("duVrF", function(module, exports) {

$parcel$export(module.exports, "catalogSearchText", () => $9d3aa31dcdfce912$export$90e2bbbd1a393681);
$parcel$export(module.exports, "marketplaceCatalog", () => $9d3aa31dcdfce912$export$dab98765e39ba5de);
// Marketplace seed catalog.
// Kinds: 'library' | 'template' | 'plugin' | 'registrar'
// Note: 'integration' entries have been removed — they are now served
// exclusively from the live `integration_kinds` Supabase table (migration 0063).
// At runtime `hydrateLiveCatalog` (functions/index.js) merges live rows on top
// of this static list, keyed by integration id.
//
// Price 0 = free.
// `thumbnail` — 16:9 preview URL (used by libraries/templates as card/detail
//               hero). Empty → the card renders a transparent-checker
//               placeholder until a real thumbnail is uploaded.
//
// `description` — a POLYGLOT KEY (`apps.catalog.<id>.descr`), not copy. This
// file is DATA rendered by six different sites in `packages/marketplace`, so
// it takes the key-in-state form of docs/I18N-CONVENTION.md §1: the row
// carries the key, and every render site resolves it with
// `el.call('polyglot', item.description)`. `translate()` returns its input
// unchanged when nothing resolves, so a LIVE row merged on top by
// `hydrateLiveCatalog` — whose description comes from the
// `integration_kinds` table and is real prose, not a key — passes through
// untouched.
//
// `name` is SPLIT, and the split is the ruling, not a convenience. 13 rows have
// a DESCRIPTIVE name — `Code Review`, `Docs Writer`, `Accessibility Audit` —
// and those carry `apps.catalog.<id>.name`, so the App Store reads Georgian for
// a Georgian reader (Nika, 2026-09-03: "also translate all appstore apps").
// The other 18 stay literals because translating them would be wrong, not
// merely unnecessary: 9 registrar BRANDS (`Namecheap`), three PRODUCT names
// (`Symbols MCP`, `i18n Polyglot`, `Monaco Editor`) and 6 SLASH COMMANDS
// (`/review`) a user types verbatim — a translated command does not run.
// No render site branches on which is which: `storeItemText` passes a
// non-key through `translate()` unchanged, so both forms take one path.
//
// `name` is also the PRIMARY search field, so `_searchName` in
// `packages/marketplace/functions/index.js` resolves it through the same
// English base `catalogSearchText` uses for the description — a query matches
// the English words, and no comparator ever sorts on a dotted key.
// The catalog's `description` is a bundle KEY (see the note above). The
// marketplace's store search (`_storeSearchTexts` in
// `packages/marketplace/functions/index.js`, matched by `catalogSearch.js`)
// searches the words the member reads through `storeItemText` when it holds an
// element, AND always this English base — a bare call holds no element and
// has only the base. So it resolves a key through the BUNDLED English base
// here, never through `polyglot`: search never degrades to matching dotted
// keys.
//
// Written against `globalThis.__i18nRegistry` directly, with the merge inlined
// and memoized ON THE REGISTRY OBJECT — no module-scope `let` and no bare
// sibling call, both of which frank's serializer cannot revive
// (`__tests__/frankModuleMutableGate.test.js`). `reg.base` is the STATIC
// bundle map, so the memo is keyed on its namespace count and rebuilds if a
// namespace is ever added at runtime.
//
// A value that is not a key — every live `integration_kinds` row, every
// hydrated template — misses the map and comes back untouched.
const $9d3aa31dcdfce912$export$90e2bbbd1a393681 = (value)=>{
    if (!value) return '';
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    if (!reg || !reg.base) return value;
    const names = Object.keys(reg.base);
    if (!reg.__enMerged || reg.__enMergedCount !== names.length) {
        const merged = {};
        for (const ns of names)Object.assign(merged, reg.base[ns]);
        reg.__enMerged = merged;
        reg.__enMergedCount = names.length;
    }
    return reg.__enMerged[value] || value;
};
const $9d3aa31dcdfce912$export$dab98765e39ba5de = [
    // ─── Libraries ────────────────────────────────────────────────────────────
    // Library entries removed for the same reason templates were: the four
    // static stubs (Brand / Shared / CMS UI Kit / Charts Kit) didn't back
    // real installable libraries — clicking Install on them did nothing
    // meaningful and the cards rendered with no real thumbnail. Libraries
    // should be sourced from the live SDK the same way templates already
    // are (see hydrateTemplatesFromSdk in marketplace/functions/index.js).
    // Until that hydrator lands for kind=library, the section is empty
    // rather than full of misleading placeholder cards.
    // ─── Templates ────────────────────────────────────────────────────────────
    // Template entries are now sourced exclusively from the SDK at runtime via
    // `hydrateTemplatesFromSdk` (marketplace/functions/index.js) — it queries
    // /projects/public?projectType=template and merges each row into the
    // catalog as kind=template with a screenshot.symbo.ls cover. The previous
    // static stubs (saas-starter / landing / docs / ecommerce) didn't back
    // real projects, so install/use clicks 404'd. Removed.
    // ─── Domain Registrars ───────────────────────────────────────────────────
    {
        id: 'reg.namecheap',
        kind: 'registrar',
        category: 'domains',
        name: 'Namecheap',
        description: 'apps.catalog.regNamecheap.descr',
        price: 0,
        logo: 'namecheap'
    },
    {
        id: 'reg.godaddy',
        kind: 'registrar',
        category: 'domains',
        name: 'GoDaddy',
        description: 'apps.catalog.regGodaddy.descr',
        price: 0,
        logo: 'godaddy'
    },
    {
        id: 'reg.cloudflare-registrar',
        kind: 'registrar',
        category: 'domains',
        name: 'Cloudflare Registrar',
        description: 'apps.catalog.regCloudflareRegistrar.descr',
        price: 0,
        logo: 'cloudflare'
    },
    {
        id: 'reg.porkbun',
        kind: 'registrar',
        category: 'domains',
        name: 'Porkbun',
        description: 'apps.catalog.regPorkbun.descr',
        price: 0,
        logo: 'porkbun'
    },
    {
        id: 'reg.gandi',
        kind: 'registrar',
        category: 'domains',
        name: 'Gandi',
        description: 'apps.catalog.regGandi.descr',
        price: 0,
        logo: 'gandi'
    },
    {
        id: 'reg.squarespace-domains',
        kind: 'registrar',
        category: 'domains',
        name: 'Squarespace Domains',
        description: 'apps.catalog.regSquarespaceDomains.descr',
        price: 0,
        logo: 'squarespace'
    },
    {
        id: 'reg.namesilo',
        kind: 'registrar',
        category: 'domains',
        name: 'NameSilo',
        description: 'apps.catalog.regNamesilo.descr',
        price: 0
    },
    {
        id: 'reg.hover',
        kind: 'registrar',
        category: 'domains',
        name: 'Hover',
        description: 'apps.catalog.regHover.descr',
        price: 0
    },
    {
        id: 'reg.name',
        kind: 'registrar',
        category: 'domains',
        name: 'Name.com',
        description: 'apps.catalog.regName.descr',
        price: 0
    },
    // ─── MCP Connectors ───────────────────────────────────────────────────────
    // MCP (Model Context Protocol) servers that canvas AI agents can call into.
    // Separate from integrations — different runtime contract (JSON-RPC, tools/list, resources/list).
    {
        id: 'mcp.symbols',
        kind: 'mcp',
        category: 'system',
        name: 'Symbols MCP',
        description: 'apps.catalog.mcpSymbols.descr',
        price: 0,
        url: 'https://mcp.symbols.app',
        transport: 'sse',
        auth_kind: 'oauth'
    },
    // ─── Plugins ─────────────────────────────────────────────────────────────
    {
        id: 'plg.seo',
        kind: 'plugin',
        category: 'marketing',
        name: 'apps.catalog.plgSeo.name',
        description: 'apps.catalog.plgSeo.descr',
        price: 0
    },
    {
        id: 'plg.i18n',
        kind: 'plugin',
        category: 'content',
        name: 'i18n Polyglot',
        description: 'apps.catalog.plgI18n.descr',
        price: 0
    },
    {
        id: 'plg.a11y',
        kind: 'plugin',
        category: 'quality',
        name: 'apps.catalog.plgA11y.name',
        description: 'apps.catalog.plgA11y.descr',
        price: 0
    },
    {
        id: 'plg.gridstack',
        kind: 'plugin',
        category: 'editor',
        name: 'apps.catalog.plgGridstack.name',
        description: 'apps.catalog.plgGridstack.descr',
        price: 0
    },
    {
        id: 'plg.monaco',
        kind: 'plugin',
        category: 'editor',
        name: 'Monaco Editor',
        description: 'apps.catalog.plgMonaco.descr',
        price: 0
    },
    // ─── Prompts ─────────────────────────────────────────────────────────────
    // Reusable prompt templates — drop into a new chat thread or pass to an
    // agent. `body` carries the raw prompt; the modal copy button copies
    // that to clipboard. `tokenEstimate` is rough Claude tokens for the
    // prompt itself (response tokens depend on the run).
    {
        id: 'prm.code-review',
        kind: 'prompt',
        category: 'coding',
        name: 'apps.catalog.prmCodeReview.name',
        description: 'apps.catalog.prmCodeReview.descr',
        price: 0,
        body: 'Review the following diff line-by-line. Flag: (1) correctness bugs, (2) edge cases, (3) security risks, (4) style mismatches with surrounding code, (5) missing or misleading tests. Do not paraphrase the diff back. Output a numbered punch list.',
        model: 'claude-opus-4-7',
        tokenEstimate: 80,
        useCount: 0
    },
    {
        id: 'prm.bug-rca',
        kind: 'prompt',
        category: 'coding',
        name: 'apps.catalog.prmBugRca.name',
        description: 'apps.catalog.prmBugRca.descr',
        price: 0,
        body: 'Given the bug report below, identify the root cause. Steps: (1) reproduce locally if possible, (2) walk the call chain, (3) state the invariant that broke, (4) propose the smallest fix, (5) write a regression test. Show your work.',
        model: 'claude-sonnet-4-6',
        tokenEstimate: 70,
        useCount: 0
    },
    {
        id: 'prm.api-design',
        kind: 'prompt',
        category: 'coding',
        name: 'apps.catalog.prmApiDesign.name',
        description: 'apps.catalog.prmApiDesign.descr',
        price: 0,
        body: 'Critique this API surface from three angles: (1) consistency with existing endpoints, (2) ease of use for first-time integrators, (3) backwards-compat risk if we ship and need to evolve. Suggest concrete changes.',
        model: 'claude-opus-4-7',
        tokenEstimate: 90,
        useCount: 0
    },
    {
        id: 'prm.prd-draft',
        kind: 'prompt',
        category: 'product',
        name: 'apps.catalog.prmPrdDraft.name',
        description: 'apps.catalog.prmPrdDraft.descr',
        price: 0,
        body: 'Turn the notes below into a one-page PRD with sections: Problem, Users, Goals, Non-goals, Solution sketch, Open questions, Risks. Aim for ~300 words. Cite the notes when claims rely on them.',
        model: 'claude-opus-4-7',
        tokenEstimate: 60,
        useCount: 0
    },
    {
        id: 'prm.commit-msg',
        kind: 'prompt',
        category: 'coding',
        name: 'apps.catalog.prmCommitMsg.name',
        description: 'apps.catalog.prmCommitMsg.descr',
        price: 0,
        body: 'Read the staged diff and write a commit message: (1) imperative subject under 72 chars, (2) blank line, (3) body explaining WHY (not WHAT), (4) bullet points only if diff spans multiple concerns. Skip if the change is trivial.',
        model: 'claude-haiku-4-5-20251001',
        tokenEstimate: 50,
        useCount: 0
    },
    // ─── Agents ──────────────────────────────────────────────────────────────
    // Claude Code subagents — drop into ~/.claude/agents/<key>.md. Each
    // carries `tools[]` (allow-list), `model` (default), and `body` (the
    // agent's system prompt). Modal renders the body markdown plus a
    // copy-install snippet for the local CLI.
    {
        id: 'agt.code-reviewer',
        kind: 'agent',
        category: 'coding',
        name: 'apps.catalog.agtCodeReviewer.name',
        description: 'apps.catalog.agtCodeReviewer.descr',
        price: 0,
        model: 'claude-opus-4-7',
        tools: [
            'Read',
            'Bash',
            'Grep'
        ],
        body: 'You are an independent code reviewer. Read the diff in the conversation context, walk it line-by-line, and report: correctness bugs, edge cases, missing tests, and style mismatches. Do not edit files.',
        useCount: 0
    },
    {
        id: 'agt.security-auditor',
        kind: 'agent',
        category: 'security',
        name: 'apps.catalog.agtSecurityAuditor.name',
        description: 'apps.catalog.agtSecurityAuditor.descr',
        price: 0,
        model: 'claude-opus-4-7',
        tools: [
            'Read',
            'Grep',
            'WebSearch'
        ],
        body: 'You are a security reviewer. For the diff in scope, look for: SQL injection, XSS, CSRF, insecure direct object references, missing authz checks, secret leakage, broken crypto, outdated dependencies. Output severity (P0/P1/P2) per finding.',
        useCount: 0
    },
    {
        id: 'agt.test-writer',
        kind: 'agent',
        category: 'coding',
        name: 'apps.catalog.agtTestWriter.name',
        description: 'apps.catalog.agtTestWriter.descr',
        price: 0,
        model: 'claude-sonnet-4-6',
        tools: [
            'Read',
            'Edit',
            'Bash'
        ],
        body: "You write tests in the project's existing test framework. For a given feature: (1) write a failing test, (2) run it to confirm red, (3) only then implement until green, (4) refactor if needed. Stop after each step and report.",
        useCount: 0
    },
    {
        id: 'agt.docs-writer',
        kind: 'agent',
        category: 'docs',
        name: 'apps.catalog.agtDocsWriter.name',
        description: 'apps.catalog.agtDocsWriter.descr',
        price: 0,
        model: 'claude-sonnet-4-6',
        tools: [
            'Read',
            'Grep'
        ],
        body: 'You write developer docs. Read the source first, then draft: (1) what the module does, (2) public API with examples, (3) common gotchas. Cite file:line for every claim. Refuse to invent behaviour you cannot verify.',
        useCount: 0
    },
    {
        id: 'agt.refactor',
        kind: 'agent',
        category: 'coding',
        name: 'apps.catalog.agtRefactor.name',
        description: 'apps.catalog.agtRefactor.descr',
        price: 0,
        model: 'claude-opus-4-7',
        tools: [
            'Read',
            'Grep',
            'Edit',
            'Bash'
        ],
        body: 'You plan and execute refactors. Always: (1) survey all callers first, (2) propose the rename/extract plan, (3) wait for confirmation, (4) apply changes file-by-file with tests run between each. Never bulk-edit without a plan.',
        useCount: 0
    },
    // ─── Skills (slash commands) ─────────────────────────────────────────────
    // Claude Code skills installed at ~/.claude/skills/<key>/SKILL.md.
    // Each carries a `trigger` (when to surface it) + the body markdown.
    // The modal "Install" button copies the body to clipboard with the
    // path it should land at — local install is one paste away.
    {
        id: 'skl.security-review',
        kind: 'skill',
        category: 'quality',
        name: '/security-review',
        description: 'apps.catalog.sklSecurityReview.descr',
        price: 0,
        trigger: '`/security-review`',
        useCount: 0,
        body: `# /security-review

Run a security pass over pending changes \u{2014} staged, unstaged, or the diff against \`origin/main\`. Hunts for the OWASP Top 10 plus auth/authz gaps, secret exposure, and broken crypto.

## When to use

- Before opening a PR that touches request handling, auth flows, or anything reading user input
- After accepting AI-generated changes that touch security-sensitive paths
- During code review when you want a second opinion on a specific diff

## What it checks

- **Injection**: SQL, NoSQL, command, header injection
- **Auth**: missing authn checks, broken authz (IDOR), session fixation
- **Crypto**: weak hashing (MD5/SHA1), hardcoded keys, ECB mode, predictable IVs
- **Secrets**: tokens / keys / passwords in code or logs
- **Input validation**: untrusted data crossing trust boundaries
- **Dependencies**: known-vulnerable versions in lockfile

## Output

Severity-ranked findings (P0/P1/P2) with file:line references and a suggested fix per finding. Skips findings that exist on \`main\` already \u{2014} only flags what your diff introduces.
`
    },
    {
        id: 'skl.review',
        kind: 'skill',
        category: 'quality',
        name: '/review',
        description: 'apps.catalog.sklReview.descr',
        price: 0,
        trigger: '`/review [PR#]`',
        useCount: 0,
        body: `# /review

End-to-end review of a PR or local branch. Reads the diff line-by-line and reports correctness, style, missing tests, and architectural smells.

## Usage

- \`/review\` \u{2014} review the current branch against \`main\`
- \`/review 1234\` \u{2014} review GitHub PR #1234 (uses \`gh pr view\`)
- \`/review HEAD~3..HEAD\` \u{2014} review an arbitrary commit range

## What it does

1. Pulls the diff
2. Walks each file change in context
3. Cross-references callers for any modified function (catches breaking changes)
4. Emits a punch list grouped by severity

## What it skips

- Whitespace-only changes
- Generated files / lockfiles
- Test fixture data
`
    },
    {
        id: 'skl.init',
        kind: 'skill',
        category: 'system',
        name: '/init',
        description: 'apps.catalog.sklInit.descr',
        price: 0,
        trigger: '`/init`',
        useCount: 0,
        body: `# /init

Bootstraps a \`CLAUDE.md\` at the repo root by reading the codebase.

## When to run

- First time cloning a repo into a Claude Code session
- After significant refactor \u{2014} the existing CLAUDE.md is stale

## What it captures

- Build / test / lint commands (from package.json, Makefile, etc.)
- Project layout (top-level dirs + their purpose)
- Framework conventions in use
- Anything else worth pinning so future sessions don't re-derive it

## Output

A \`CLAUDE.md\` you can review and commit. It's deliberately concise \u{2014} the goal is to prime the next session, not document the codebase.
`
    },
    {
        id: 'skl.simplify',
        kind: 'skill',
        category: 'coding',
        name: '/simplify',
        description: 'apps.catalog.sklSimplify.descr',
        price: 0,
        trigger: '`/simplify`',
        useCount: 0,
        body: `# /simplify

Audits pending changes for over-engineering. Flags premature abstractions, dead code, unnecessary defensive checks, and feature flags that aren't doing anything.

## What it looks for

- Abstractions with one caller (delete the abstraction)
- Try/catch that swallows errors no one handles
- Configuration knobs that no one toggles
- "Just in case" null checks where the type system guarantees non-null
- Helper functions that are thinner than their inline equivalent

## Output

A list of suggested deletions / inlining opportunities, ordered by code reduction.
`
    },
    {
        id: 'skl.loop',
        kind: 'skill',
        category: 'automation',
        name: '/loop',
        description: 'apps.catalog.sklLoop.descr',
        price: 0,
        trigger: '`/loop 5m /<task>`',
        useCount: 0,
        body: `# /loop

Re-runs a prompt on a recurring schedule.

## Usage

- \`/loop 5m /tests\` \u{2014} run \`/tests\` every 5 minutes
- \`/loop 1h /security-review\` \u{2014} hourly security pass
- \`/loop dynamic <prompt>\` \u{2014} let Claude decide the cadence

## When to use

- Long-running tests / builds \u{2014} poll until green
- Watching for an external event (webhook, queue depth)
- Iterating on a prompt where each run informs the next

## Stopping

\`/loop stop\` cancels the running schedule. Or just close the session \u{2014} schedules don't persist across sessions unless you use \`/schedule\` for remote runs.
`
    },
    {
        id: 'skl.schedule',
        kind: 'skill',
        category: 'automation',
        name: '/schedule',
        description: 'apps.catalog.sklSchedule.descr',
        price: 0,
        trigger: "`/schedule \u2026`",
        useCount: 0,
        body: `# /schedule

Schedules a remote agent run on a cron schedule. Unlike \`/loop\` (which polls within the current session), \`/schedule\` runs in the cloud \u{2014} you can close your laptop.

## Usage

- \`/schedule daily 9am /weekly-review\` \u{2014} run \`/weekly-review\` every weekday at 9am
- \`/schedule every-10-min /watch-deploys\` \u{2014} frequent polling
- \`/schedule cron "0 */4 * * *" /<prompt>\` \u{2014} raw cron expression

## When to use

- Anything you want to run while you're not at the keyboard
- Periodic reports / digests
- Long-running watches (deployments, CI status, queue health)

## Where output lands

Each scheduled run creates a session you can review later. Failures email you. Successes are silent unless you wire up notifications.
`
    }
];

});

parcelRegister("co4gh", function(module, exports) {

$parcel$export(module.exports, "catalogSearchThreshold", () => $904b082ee482ab3d$export$aecd705833508a97);
$parcel$export(module.exports, "catalogSearchRank", () => $904b082ee482ab3d$export$51bbbc2e4bcdc85);
$parcel$export(module.exports, "catalogSearchIncludes", () => $904b082ee482ab3d$export$7d3b75f06a463186);
// THE catalog search rule — word-level matching over a SMALL catalog the
// caller already holds (the App Store, the Integrations shelf, the shell's
// "add an app" suggestions). Pure; no I/O, no element, no state.
//
// IT LIVES IN `shared/` BECAUSE IT HAS TWO CONSUMERS, NOT ONE (the same reason
// `storeItemText.js` lives here): the store itself
// (`packages/marketplace/functions/index.js` — its filter, its counts and its
// rank) and the SHELL (`packages/workspace/functions/search/searchAppResults.js`
// — the App Store and integration rows global search offers when nothing
// matched). Two copies of a search rule drift; one member typing one word must
// get one answer on both surfaces.
//
// It is also the rule the ASSISTANT's store search runs on the server
// (server `src/core/utils/catalogSearch.js`, 7c079e6c). The server and this
// workspace are separate repositories, so that file is ported here word for
// word — same limits, same stem, same levels, same rank — and
// `catalogSearch.test.js` pins the server's own cases so a drift fails here.
// Change the rule in both places or in neither.
//
// Why it exists: a substring match over each field ('schedule' is not a
// substring of 'Scheduling') told a member who typed "schedule" that the store
// had no such app, and a substring cannot rank.
//
// The rule: the query and every catalog text are split into WORDS; a query
// word matches a catalog word by
//   3  exact   the same word
//   2  prefix  the catalog word begins with the query word (3+ characters —
//              a 1–2 character query matches whole words only)
//   1  stem    both reduce to the same light English stem (schedule ↔
//              scheduling / schedules / scheduled / scheduler; book ↔
//              booking ↔ bookings)
// after one normalisation for both sides: lower-cased, accents folded, split
// on anything that is not a letter or a digit of any script.
//
// Script safety: nothing is ever UPPER-cased. Georgian has no case in its
// everyday script (Mkhedruli), and upper-casing it produces a different
// alphabet (Mtavruli) that matches nothing stored; lower-casing maps a
// Mtavruli query back onto Mkhedruli text. A non-Latin word is never stemmed:
// it matches by exact word or prefix.
//
// Safety: the query never becomes a regular expression — there is no pattern
// to inject and nothing to backtrack. Its length and its word count are capped.
//
// Several query words: an item must match EVERY word; when no item does, the
// items that match the most words answer instead (the caller already holds
// the whole catalog, so this narrows — it never widens what is visible).
// Rank: exact > prefix > stem, then the field's weight (a name beats a
// description), then the input order.
//
// `fields` — `[{ get(item) → string | string[], weight }]` — is the caller's:
// WHAT an item is searched on is a surface decision; HOW it matches is this
// file's, and only this file's.
//
// frank: every module-scope name below is globally distinct (`catalogSearch*`
// — frank hoists module-scope declarations into one globalScope), there is no
// module-scope `let`/`var` (`__tests__/frankModuleMutableGate.test.js`), and
// every regular expression is a literal INSIDE the function that uses it.
// Levels and limits — the server's numbers, unchanged.
const $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL = {
    EXACT: 3,
    PREFIX: 2,
    STEM: 1,
    NONE: 0
};
const $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT = {
    queryChars: 200,
    queryWords: 8,
    wordChars: 40,
    fieldChars: 4000,
    prefixChars: 3,
    stemChars: 3,
    // Not a server number: the bound on each memo table a caller's `cache` holds.
    cacheEntries: 20000
};
// One derivational ending is removed, the longest first. "Light" on purpose:
// the stem only has to be the SAME for the forms of one word, and a stem match
// ranks last — it is not a linguistic root.
const $904b082ee482ab3d$var$CATALOG_SEARCH_SUFFIXES = [
    'ment',
    'ing',
    'ion',
    'ed',
    'er'
];
const $904b082ee482ab3d$export$2aae9a5d0317f13d = (value)=>{
    if (value == null) return '';
    return String(value).normalize('NFKD').replace(/\p{M}+/gu, '').toLowerCase();
};
const $904b082ee482ab3d$export$e23e92ea57711b62 = (value, opts)=>{
    const max = opts && opts.max || Infinity;
    const maxChars = opts && opts.maxChars || $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.fieldChars;
    const text = $904b082ee482ab3d$export$2aae9a5d0317f13d(String(value ?? '').slice(0, maxChars));
    const out = [];
    for (const raw of text.split(/[^\p{L}\p{N}]+/u)){
        if (!raw) continue;
        out.push(raw.length > $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.wordChars ? raw.slice(0, $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.wordChars) : raw);
        if (out.length >= max) break;
    }
    return out;
};
const $904b082ee482ab3d$export$35b85eebb71efc7f = (token)=>{
    let s = String(token ?? '');
    if (s.length < 4 || !/^[a-z]+$/.test(s)) return s;
    // plural: companies → company, schedules → schedule, bookings → booking
    if (s.endsWith('ies') && s.length > 4) s = `${s.slice(0, -3)}y`;
    else if (s.endsWith('s') && !s.endsWith('ss')) s = s.slice(0, -1);
    for (const suf of $904b082ee482ab3d$var$CATALOG_SEARCH_SUFFIXES)if (s.endsWith(suf) && s.length - suf.length >= $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.stemChars) {
        s = s.slice(0, -suf.length);
        break;
    }
    // planned → plann → plan (never ll / ss / zz: sell, pass, buzz keep theirs)
    const last = s[s.length - 1];
    if (s.length > $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.stemChars && last === s[s.length - 2] && !'aeiou'.includes(last) && !'lsz'.includes(last)) s = s.slice(0, -1);
    // schedule → schedul, so it meets schedul(ing)
    if (s.length > $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.stemChars && s.endsWith('e')) s = s.slice(0, -1);
    return s;
};
const $904b082ee482ab3d$export$ebee181850f2f022 = (queryToken, fieldToken)=>{
    if (!queryToken || !fieldToken) return $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.NONE;
    if (queryToken === fieldToken) return $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.EXACT;
    if (queryToken.length >= $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.prefixChars && fieldToken.startsWith(queryToken)) return $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.PREFIX;
    if (/^[a-z]+$/.test(queryToken) && /^[a-z]+$/.test(fieldToken)) {
        const qs = $904b082ee482ab3d$export$35b85eebb71efc7f(queryToken);
        if (qs.length >= $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.stemChars && qs === $904b082ee482ab3d$export$35b85eebb71efc7f(fieldToken)) return $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.STEM;
    }
    return $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.NONE;
};
/** The query's words, capped (length and count). A symbols-only query has none. */ const $904b082ee482ab3d$var$catalogSearchQueryWords = (query)=>$904b082ee482ab3d$export$e23e92ea57711b62(String(query ?? '').slice(0, $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.queryChars), {
        max: $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.queryWords,
        maxChars: $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.queryChars
    });
// A caller that searches the same catalog again and again (a grid filters it
// row by row, on every keystroke) may pass `cache` — a plain `{}` it keeps
// between calls; these two tables fill it. They memoise PURE functions (a
// text's words, a word's stem), so a cache can only skip work — it can never
// change an answer, and a stale one cannot exist: a new text is a new key.
// Each table is emptied when it grows past `cacheEntries`.
const $904b082ee482ab3d$var$catalogSearchTextWords = (text, cache)=>{
    if (!cache) return $904b082ee482ab3d$export$e23e92ea57711b62(text);
    const table = cache.words || (cache.words = new Map());
    let out = table.get(text);
    if (out === undefined) {
        out = $904b082ee482ab3d$export$e23e92ea57711b62(text);
        if (table.size >= $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.cacheEntries) table.clear();
        table.set(text, out);
    }
    return out;
};
// A word's light stem, or null for a word the stem never applies to (not
// plain a–z) — `catalogSearchLevel`'s stem test, computed once per word.
const $904b082ee482ab3d$var$catalogSearchWordStem = (word, cache)=>{
    const table = cache && (cache.stems || (cache.stems = new Map()));
    if (table && table.has(word)) return table.get(word);
    const stem = /^[a-z]+$/.test(word) ? $904b082ee482ab3d$export$35b85eebb71efc7f(word) : null;
    if (table) {
        if (table.size >= $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.cacheEntries) table.clear();
        table.set(word, stem);
    }
    return stem;
};
// The query's words through the same cache: a grid asks once per ROW for one
// query, so the last query's words are kept.
const $904b082ee482ab3d$var$catalogSearchCachedQueryWords = (query, cache)=>{
    if (!cache) return $904b082ee482ab3d$var$catalogSearchQueryWords(query);
    if (cache.query !== query || !cache.queryWords) {
        cache.queryWords = $904b082ee482ab3d$var$catalogSearchQueryWords(query);
        cache.query = query;
    }
    return cache.queryWords;
};
/**
 * The words of an item: every word of every field text, each with the weight
 * of the best field it sits in.
 */ const $904b082ee482ab3d$var$catalogSearchItemWords = (item, fields, cache)=>{
    const itemWords = new Map();
    for (const f of fields || []){
        const raw = f.get(item);
        const texts = Array.isArray(raw) ? raw : [
            raw
        ];
        const weight = Number(f.weight) || 0;
        for (const text of texts){
            if (typeof text !== 'string' || !text) continue;
            for (const w of $904b082ee482ab3d$var$catalogSearchTextWords(text, cache))if (!itemWords.has(w) || itemWords.get(w) < weight) itemWords.set(w, weight);
        }
    }
    return itemWords;
};
const $904b082ee482ab3d$export$a5895fe1f6eaa615 = (item, words, fields, cache)=>{
    const itemWords = $904b082ee482ab3d$var$catalogSearchItemWords(item, fields, cache);
    let matched = 0;
    let levelSum = 0;
    let weightSum = 0;
    for (const qt of words || []){
        const qStem = $904b082ee482ab3d$var$catalogSearchWordStem(qt, cache);
        let best = $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.NONE;
        let bestWeight = 0;
        for (const [w, weight] of itemWords){
            let level = $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.NONE;
            if (!qt || !w) level = $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.NONE;
            else if (qt === w) level = $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.EXACT;
            else if (qt.length >= $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.prefixChars && w.startsWith(qt)) level = $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.PREFIX;
            else if (qStem !== null && qStem.length >= $904b082ee482ab3d$var$CATALOG_SEARCH_LIMIT.stemChars && qStem === $904b082ee482ab3d$var$catalogSearchWordStem(w, cache)) level = $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.STEM;
            if (level > best || level === best && level > 0 && weight > bestWeight) {
                best = level;
                bestWeight = weight;
            }
        }
        if (best > $904b082ee482ab3d$var$CATALOG_SEARCH_LEVEL.NONE) {
            matched += 1;
            levelSum += best;
            weightSum += bestWeight;
        }
    }
    return {
        matched: matched,
        levelSum: levelSum,
        weightSum: weightSum
    };
};
const $904b082ee482ab3d$export$aecd705833508a97 = (items, words, fields, cache)=>{
    const all = (words || []).length;
    let best = 0;
    for (const item of items || []){
        const { matched: matched } = $904b082ee482ab3d$export$a5895fe1f6eaa615(item, words, fields, cache);
        if (matched === all) return all;
        if (matched > best) best = matched;
    }
    return best;
};
const $904b082ee482ab3d$export$51bbbc2e4bcdc85 = (items, query, opts)=>{
    const fields = opts && opts.fields || [];
    const cache = opts && opts.cache || null;
    const words = $904b082ee482ab3d$var$catalogSearchCachedQueryWords(query, cache);
    const list = items ? Array.from(items) : [];
    if (!words.length || !fields.length) return [];
    const scored = [];
    list.forEach((item, index)=>{
        const s = $904b082ee482ab3d$export$a5895fe1f6eaa615(item, words, fields, cache);
        if (s.matched) scored.push({
            item: item,
            index: index,
            ...s
        });
    });
    const all = scored.filter((s)=>s.matched === words.length);
    const pool = all.length ? all : scored.filter((s)=>s.matched === Math.max(...scored.map((x)=>x.matched)));
    pool.sort((a, b)=>b.levelSum - a.levelSum || b.weightSum - a.weightSum || a.index - b.index);
    return pool.map((s)=>s.item);
};
const $904b082ee482ab3d$export$7d3b75f06a463186 = (item, query, opts)=>{
    const fields = opts && opts.fields || [];
    const cache = opts && opts.cache || null;
    const words = $904b082ee482ab3d$var$catalogSearchCachedQueryWords(query, cache);
    if (!words.length || !fields.length) return false;
    const { matched: matched } = $904b082ee482ab3d$export$a5895fe1f6eaa615(item, words, fields, cache);
    if (!matched) return false;
    if (matched === words.length) return true;
    const poolThreshold = opts && opts.poolThreshold;
    return typeof poolThreshold === 'function' && matched === poolThreshold(words);
};

});

parcelRegister("joPMm", function(module, exports) {

$parcel$export(module.exports, "appendVoiceTurn", () => $e1f86c76dacd5657$export$406c1bc152910bca);
$parcel$export(module.exports, "voiceStart", () => $e1f86c76dacd5657$export$c24b372886d3353d);
$parcel$export(module.exports, "voiceStop", () => $e1f86c76dacd5657$export$23d01673dd8925d7);
$parcel$export(module.exports, "voiceToggle", () => $e1f86c76dacd5657$export$dade21f33849f17b);
$parcel$export(module.exports, "voiceSetMode", () => $e1f86c76dacd5657$export$a219e0f98f44c6ec);
$parcel$export(module.exports, "voiceExpand", () => $e1f86c76dacd5657$export$74282460fd16ebbc);
$parcel$export(module.exports, "voiceMinimize", () => $e1f86c76dacd5657$export$71972a408da668ca);
$parcel$export(module.exports, "voiceFocusComposer", () => $e1f86c76dacd5657$export$de743ccd088f373e);
$parcel$export(module.exports, "voiceCallFrame", () => $e1f86c76dacd5657$export$dbd1f0f6adfbed2f);
$parcel$export(module.exports, "voicePttPress", () => $e1f86c76dacd5657$export$a5df601355bfd132);
$parcel$export(module.exports, "voicePttRelease", () => $e1f86c76dacd5657$export$1ccaba603621e021);
$parcel$export(module.exports, "voicePttCancel", () => $e1f86c76dacd5657$export$d0a9da0e8c32d004);
$parcel$export(module.exports, "voiceCommitAndClose", () => $e1f86c76dacd5657$export$7594da45e2042f39);
$parcel$export(module.exports, "voiceOnStateChange", () => $e1f86c76dacd5657$export$87c9a39b37f49f2b);
$parcel$export(module.exports, "voiceStopSpeaking", () => $e1f86c76dacd5657$export$8b215ed1f262e333);
$parcel$export(module.exports, "voiceMicToggle", () => $e1f86c76dacd5657$export$21ebdfd7d2dc4e7d);
$parcel$export(module.exports, "voiceAddTurn", () => $e1f86c76dacd5657$export$70e652d77becbd89);
$parcel$export(module.exports, "voiceRetry", () => $e1f86c76dacd5657$export$927eacc5fe718b45);
$parcel$export(module.exports, "voiceEngineFallback", () => $e1f86c76dacd5657$export$af5ed0f9eba5ee64);
$parcel$export(module.exports, "voiceTeardown", () => $e1f86c76dacd5657$export$58416bed8aa0ac66);
// Voice input session — powers the shared VoiceOverlay (mic buttons on the
// canvas prompt composer + the assistant sidebar composer). Owns the
// microphone (getUserMedia → AnalyserNode, live level for the overlay
// visuals) and the v2 server engines (architecture/VOICE_COMMANDS.md):
//
//   STT — MediaRecorder (webm/opus) → `sdk.voiceTranscribe` (Groq Whisper on
//         the API server). No browser recognition engine exists anymore.
//   TTS — `sdk.voiceTts` (ElevenLabs on the API server), a raw streaming
//         Response played back through one primed Audio element so the reply
//         starts before the clip finishes downloading.
//
// v1's Web Speech / speechSynthesis engines are REMOVED (2026-08-06 per Nika:
// "do not use browser at all — use 11labs"). There is NO browser-speech
// fallback: when the server voice routes answer 503 (secrets unprovisioned)
// the overlay shows a clear "Voice backend not provisioned" notice and stops
// gracefully instead of degrading to a robotic browser voice.
//
// Every runtime handle lives on the VoiceOverlay element's `scope` and is torn
// down by the overlay's onBeforeRemove via voiceTeardown — no module-mutable
// state.
//
// FA204/FA207 / frank trap — every private engine helper this file used to
// declare at module scope (`_overlayOf`, `_rootOf`, `_voiceOf`, `_up`,
// `_teardown`, `_speak`, `_startEngine`, … 30+ of them, deeply
// cross-referencing each other) read as `undefined` once this file was
// frank.toJSON'd for platform delivery: each exported `el.call` handler below
// is serialized independently, so a free reference to a module-scope sibling
// — even another EXPORT referenced bare — has nothing to resolve to post-
// serialization (project_frank_drops_module_local_helpers; the exact same
// class the `_causeChain`/`_isTokenRejection` pair in bootShell.js hit).
//
// Fix: the whole engine is genuinely ONE piece of state machinery keyed off a
// single VoiceOverlay instance, so it now lives in THAT component's
// `scope: {}` (components/VoiceOverlay.js) — the same construct
// `syncFocus`/`syncChatSuppression` already use there, and the same one
// AppOrgSwitcher.js's `rawOrgs`/`activeOrg` pair uses for cross-calling scope
// methods. Every export below reaches it via `overlay.scope.<name>(...)`.
// `_overlayOf` is the one exception — it's how a caller GETS to
// `overlay.scope` in the first place, so it can't live on the thing it
// resolves; it stays a tiny self-contained local, duplicated in every export
// (FA207). `appendVoiceTurn`/`talkUnavailableCopy` stay exported for their
// own unit tests (voiceSession.test.js) — their logic is duplicated inline at
// the internal call sites that used to bare-call them (now
// `VoiceOverlay.scope.turn`/`.talkUnavailable`) rather than routing an
// internal call through the export.
//
// Root-state contract (every write carries { preventFetch: true }):
//   voiceOpen      overlay visible
//   voiceMinimized talk posture — overlay collapsed to the composer-width card
//   voiceMode      'command' | 'talk'
//   voiceChatKey   thread prefix the log renders ('' | '_ax_' | '_db_')
//   voiceLang      BCP-47 locale override ('' = browser locale; drives the
//                  conversational agent's language override — Whisper
//                  auto-detects, so transcription needs no hint)
//   voiceStatus    'idle' | 'listening' | 'thinking' | 'speaking' | 'error' |
//                  'waiting' | 'choosing' (the loop holds: a step waits for
//                  the person's OK, or a question for their pick —
//                  VoiceOverlay.scope.holdForAsk)
//   voiceInterim   live partial transcript (server engines produce none — the
//                  key stays so a future engine can light it up again)
//   voiceFinal     last committed transcript
//   voiceResult    short outcome label ("Zoomed to fit") — state only; the
//                  TEXT of every answer lives in voiceTurns, the one thread
//   voiceError     human-readable failure copy
//   voiceHostReady set by VoiceOverlay onInit — mic buttons render only then
//   voiceStartedAt the call clock's zero (ms) — set by voiceStart, 0 when closed
//
// Two modes, ONE streamlined pipeline each (2026-08-06 per Nika — "command is
// one off - talk is continuous"):
//
//   command — ONE-OFF. press → record (silence auto-commits, PTT release
//             commits) → transcribe → execute (host grammar via
//             el.call('voiceProjectCommand'), else the assistant) → answer
//             (text into the one thread + the 11labs voice) → done: the
//             session closes itself. Never re-arms.
//
//   talk    — CONTINUOUS conversation. Engine 'agent' (Nika 2026-10-26:
//             "workspace voice mode should have voice assistant just like we
//             have on fly"; "11labs talks, Simone acts"): a live ElevenLabs
//             voice agent hears and talks in real time, and every workspace
//             question goes to Simone, every "show me" to Fly, as client
//             tools (VoiceOverlay.scope.startAgentEngine). Where the agent is
//             not available, engine 'simone' — the SAME server pipeline run
//             as a loop (VOICE-TALK-ONLY-SIMONE-1 part 3, route A): record
//             (silence auto-commits) → transcribe → Simone (sendPrompt → the
//             sdk.ai transport) → speak ONLY the final turn text → record …
//             Either way the session persists across turns until the user
//             ends it with ✕/Esc (or the agent ends the call on a goodbye).
//
// Answers render in ONE surface: the voiceTurns thread (VoiceLog), shared by
// every posture. Status lines say only where the lifecycle is — they never
// carry the answer text (the old second section).

var $c7KfS = parcelRequire("c7KfS");
const $e1f86c76dacd5657$export$406c1bc152910bca = (turns, entry, cap)=>{
    const list = Array.isArray(turns) ? turns : [];
    if (!entry || !entry.id) return list;
    const max = cap || 50;
    const at = list.findIndex((t)=>t && t.id === entry.id);
    const next = at === -1 ? list.concat([
        entry
    ]) : list.slice();
    if (at !== -1) next[at] = {
        ...next[at],
        ...entry
    };
    return next.length > max ? next.slice(next.length - max) : next;
};
const $e1f86c76dacd5657$export$9f0018e6fde33571 = (reason, root)=>{
    if (reason === 'unsupported-lang') return "The ElevenLabs agent does not speak this language \u2014 pick another to talk.";
    if (reason === 'offline') return "You are offline \u2014 talk needs a connection to the ElevenLabs agent.";
    if (reason === 'start-failed') return "Could not reach the ElevenLabs agent \u2014 try again.";
    return (0, $c7KfS.isOwnerOrAdmin)(root) ? 'Voice needs an ElevenLabs agent. Configure it in /admin/flags.' : "Voice isn't set up for this workspace yet \u2014 contact your administrator.";
};
const $e1f86c76dacd5657$export$c24b372886d3353d = function(opts) {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    sc.primeAudio(overlay);
    const o = opts || {};
    const v = sc.voiceOf(overlay);
    const root = sc.rootOf(overlay);
    // WAI-ARIA dialog focus contract, capture half (see VoiceOverlay.scope's
    // `restoreFocus` for the release half). `this` is the control the user
    // actually pressed — VoiceBtn's onPointerdown / the chat composer's own mic
    // button — never the overlay: voicePttPress/voiceToggle forward their own
    // captured `this` through unchanged, so this reads correctly from the PTT-
    // hold path (the 280ms deferred call closes over the same element), the
    // plain-click path, and a direct voiceStart call alike. Skipped when
    // `this` already IS the overlay (nothing meaningful to restore to).
    if (this && this !== overlay && this.node) v.focusOrigin = this.node;
    v.active = true;
    v.closeAfterCommit = !!o.ptt;
    v.awaiting = null;
    v.chatScope = o.scope || 'general';
    sc.up(overlay, {
        voiceOpen: true,
        // voiceHost re-assert: a hosting composer writes root.voiceHost INSIDE
        // the mic gesture, immediately before this runs — re-writing whatever
        // is there makes the open bundle the single authoritative write, and
        // (with the teardown null below) any opener that did NOT set a host
        // this gesture opens hostless instead of inheriting a stale composer.
        voiceHost: root && root.voiceHost || null,
        // Every session opens on the full surface; a dispatched turn collapses it.
        voiceMinimized: false,
        // VOICE-TALK-ONLY-SIMONE-1 part 2: TALK is the default. Only an
        // EXPLICIT `mode: 'command'` (the composer's push-to-talk HOLD — a
        // one-shot spoken command while held) still opens the one-shot
        // pipeline; every plain open is a conversation. The visible
        // Command/Talk switcher is unmounted (VoiceStrip/VoiceOverlay/
        // ReasoningPill) — voiceSetMode stays exported for programmatic use.
        voiceMode: o.mode === 'command' ? 'command' : 'talk',
        // Which thread the log renders — the same prefix sendPrompt namespaces by.
        voiceChatKey: sc.chatPrefix(v.chatScope),
        voiceStatus: 'listening',
        voiceInterim: '',
        voiceFinal: '',
        voiceResult: '',
        voiceError: '',
        voiceReply: '',
        // Every session opens with a hot mic — mute is a per-session choice.
        voiceMicMuted: false,
        // The call clock's zero (VoiceCallClock) — every open is a new call.
        voiceStartedAt: Date.now(),
        // voiceTurns is deliberately NOT cleared here. The island is ONE running
        // thread you can scroll back through (2026-08-03 per Nika "logging in one
        // small minimized thread so you can keep track"), and command mode is a
        // one-shot — it tears the session down after every exchange, so wiping on
        // open meant the previous exchange vanished the moment you spoke again.
        // appendVoiceTurn's cap bounds the history instead.
        voiceEngine: null,
        // Recomputed by startEngine immediately below; cleared first so a stale
        // reason from the last session can never describe this one.
        voiceEngineReason: null
    });
    sc.startEngine(overlay);
};
const $e1f86c76dacd5657$export$23d01673dd8925d7 = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (overlay) overlay.scope.teardown(overlay);
};
const $e1f86c76dacd5657$export$dade21f33849f17b = function(opts) {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const root = overlay.scope.rootOf(overlay);
    if (root.voiceOpen) overlay.scope.teardown(overlay);
    else this.call('voiceStart', opts);
};
const $e1f86c76dacd5657$export$a219e0f98f44c6ec = function(mode) {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    const root = sc.rootOf(overlay);
    if (root.voiceMode === mode) return;
    v.awaiting = null;
    clearInterval(v.turnPoll);
    v.turnPoll = null;
    // Command needs the full surface (there is no conversation to sit beside).
    sc.up(overlay, {
        voiceMode: mode === 'talk' ? 'talk' : 'command',
        voiceMinimized: mode === 'talk' ? root.voiceMinimized : false
    });
    // The engine follows the mode: leaving talk shuts the conversational
    // session down; entering talk hands capture to the agent. Either direction
    // discards the in-flight utterance/reply — a mode switch is a fresh start.
    if (v.active) {
        sc.stopSpeaking(overlay);
        if (mode === 'talk') sc.stopRecorder(v);
        sc.up(overlay, {
            voiceStatus: 'listening',
            voiceInterim: '',
            voiceError: '',
            voiceResult: ''
        });
        sc.startEngine(overlay);
    }
};
const $e1f86c76dacd5657$export$74282460fd16ebbc = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (overlay) overlay.scope.up(overlay, {
        voiceMinimized: false,
        voiceHost: null
    });
};
const $e1f86c76dacd5657$export$71972a408da668ca = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const root = overlay.scope.rootOf(overlay);
    if (!root || !root.voiceOpen) return;
    overlay.scope.up(overlay, {
        voiceMinimized: true,
        voiceHost: null
    });
};
const $e1f86c76dacd5657$export$de743ccd088f373e = function() {
    const el = this;
    if (!el) return;
    const strip = typeof el.lookup === 'function' ? el.lookup('VoiceStrip') : null;
    const shell = typeof el.getRoot === 'function' ? el.getRoot() : null;
    const composer = strip && strip.parent || (shell && shell.lookdown ? shell.lookdown('CanvasPromptTextarea') : null);
    const field = composer && (composer.Textarea || composer.lookdown && composer.lookdown('Textarea'));
    queueMicrotask(()=>{
        const node = field && field.node;
        if (node && node.isConnected && typeof node.focus === 'function') node.focus();
    });
};
const $e1f86c76dacd5657$export$dbd1f0f6adfbed2f = function() {
    const host = this;
    const root = host && host.state && (host.state.root || host.state);
    if (!root || !root.voiceOpen || !host.node) return 0;
    // Refs resolved once per host and dropped when their node leaves the
    // document — the frame loop must never walk the tree on every tick.
    const live = (ref)=>!!(ref && ref.node && ref.node.isConnected);
    let refs = host.__voiceCallRefs;
    if (!refs || !live(refs.ring)) {
        const shell = typeof host.getRoot === 'function' ? host.getRoot() : null;
        refs = {
            ring: host.lookdown ? host.lookdown('VoiceOrbRing') : null,
            clock: host.lookdown ? host.lookdown('VoiceCallClock') : null,
            overlay: host.scope && host.scope.__isVoiceOverlay ? host : shell && shell.lookdown ? shell.lookdown('VoiceOverlay') : null,
            motion: typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null,
            t: 0,
            scale: 1
        };
        host.__voiceCallRefs = refs;
    }
    const started = Number(root.voiceStartedAt) || 0;
    const clock = refs.clock;
    if (started && clock && clock.state && typeof clock.state.update === 'function') {
        const secs = Math.max(0, Math.floor((Date.now() - started) / 1000));
        if (clock.state.secs !== secs) clock.state.update({
            secs: secs
        });
    }
    const status = root.voiceStatus;
    const v = refs.overlay && refs.overlay.scope && refs.overlay.scope.voice || {};
    let level = 0;
    if (status === 'listening' && !root.voiceMicMuted && v.analyser && v.bins) {
        v.analyser.getByteFrequencyData(v.bins);
        let sum = 0;
        for(let i = 0; i < v.bins.length; i++)sum += v.bins[i];
        level = sum / (v.bins.length * 255);
    }
    const ring = refs.ring;
    if (!ring || typeof ring.setNodeStyles !== 'function') return level;
    refs.t += 1 / 60;
    const t = refs.t;
    let target = 1;
    let opacity = 0.14;
    if (!(refs.motion && refs.motion.matches)) {
        if (status === 'speaking') {
            target = 1.12 + 0.14 * Math.abs(Math.sin(t * 3.2));
            opacity = 0.22;
        } else if (status === 'thinking' || status === 'connecting') {
            target = 1.06 + 0.05 * Math.sin(t * 2.2);
            opacity = 0.16;
        } else if (status === 'listening' && !root.voiceMicMuted) {
            target = 1.04 + Math.min(0.46, level * 2.6);
            opacity = 0.16 + Math.min(0.22, level * 1.4);
        }
    }
    // Eased toward the target so a spiky spectrum reads as breathing, not jitter.
    refs.scale += (target - refs.scale) * 0.28;
    ring.setNodeStyles({
        transform: 'scale(' + refs.scale.toFixed(3) + ')',
        opacity: opacity.toFixed(3)
    });
    return level;
};
const $e1f86c76dacd5657$export$a5df601355bfd132 = function(opts) {
    const el = this;
    const overlayOf = (n)=>{
        if (n && n.scope && n.scope.__isVoiceOverlay) return n;
        const root = n && n.getRoot ? n.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    // Prime here too: this runs INSIDE the pointerdown, whereas voiceStart is
    // reached from the 280ms hold timer — outside the gesture.
    const overlay = overlayOf(el);
    if (overlay) overlay.scope.primeAudio(overlay);
    clearTimeout(el.scope._vpttTimer);
    el.scope._vpttHeld = false;
    el.scope._vpttTimer = setTimeout(()=>{
        el.scope._vpttHeld = true;
        el.call('voiceStart', {
            ...opts || {},
            ptt: true
        });
    }, 280);
};
const $e1f86c76dacd5657$export$1ccaba603621e021 = function(opts) {
    const el = this;
    clearTimeout(el.scope._vpttTimer);
    el.scope._vpttTimer = null;
    if (el.scope._vpttHeld) {
        el.scope._vpttHeld = false;
        el.call('voiceCommitAndClose');
    } else el.call('voiceToggle', opts);
};
const $e1f86c76dacd5657$export$d0a9da0e8c32d004 = function() {
    const el = this;
    clearTimeout(el.scope._vpttTimer);
    el.scope._vpttTimer = null;
    if (el.scope._vpttHeld) {
        el.scope._vpttHeld = false;
        el.call('voiceCommitAndClose');
    }
};
const $e1f86c76dacd5657$export$7594da45e2042f39 = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    v.closeAfterCommit = true;
    // A CONVERSATION is never closed by letting go of the mic — talk ends only
    // on ✕/Esc (the documented contract): the live agent and the SIMONE loop.
    if (v.engine === 'simone' || v.engine === 'agent') return;
    if (v.recorder && v.recorder.state !== 'inactive') {
        sc.finishRecording(overlay);
        return;
    }
    clearTimeout(v.stopTimer);
    // Backstop: released before the recorder armed (mic permission prompt
    // still up, engine still starting) — close once nothing is in flight.
    v.stopTimer = setTimeout(()=>{
        const root = sc.rootOf(overlay);
        if (v.active && !v.awaiting && root.voiceStatus === 'listening') sc.teardown(overlay);
    }, 1400);
};
const $e1f86c76dacd5657$export$87c9a39b37f49f2b = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    if (!v.active || !v.awaiting) return;
    const root = sc.rootOf(overlay);
    if (!root) return;
    // The live agent's ask_workspace turn (VoiceOverlay.scope.agentAsk): the
    // same thread, read the same honest way, but the answer goes back to the
    // agent as the tool's result (VoiceOverlay.scope.agentSettle) — the agent
    // says it in its own words. Nothing is spoken here, and the streamed text
    // stays in the thread: the captions carry what the agent says.
    if (v.awaiting.type === 'chat' && v.awaiting.tool) {
        const turn = v.awaiting;
        const msgs = root[turn.k + 'chatMessages'] || [];
        const typing = !!root[turn.k + 'chatTyping'];
        // The ask in the thread: the newest user row with its words, after the
        // length the thread had when it was sent. Until it lands, nothing can be
        // its answer.
        let at = -1;
        for(let i = msgs.length - 1; i >= (turn.since || 0); i--){
            const m = msgs[i];
            if (m && m.role === 'user' && String(m.text || '').trim() === turn.tool.request) {
                at = i;
                break;
            }
        }
        const after = at === -1 ? [] : msgs.slice(at + 1);
        const last = after[after.length - 1];
        if (!typing && last && last.role === 'system' && String(last.text || '').trim()) {
            sc.agentSettle(overlay, {
                error: String(last.text).trim()
            });
            return;
        }
        if (!typing && last && last.role === 'assistant' && last.metadata && last.metadata.kind === 'error') {
            sc.agentSettle(overlay, {
                error: String(last.metadata.errorMessage || last.text || '').trim() || 'Simone could not answer.'
            });
            return;
        }
        // An ask of this request waits on the person — a step for the OK, a
        // question for a pick: the agent hears it at once, as the tool's result
        // (VoiceOverlay.scope.agentWaits) — never the narration before it as the
        // answer (the typing flag may be off), never "did not answer in time"
        // while the person decides. The answer on the screen resumes the request
        // on a fresh clock (askAnswered).
        const held = sc.heldAsk(after, overlay);
        if (held) {
            sc.agentWaits(overlay, held);
            return;
        }
        if (turn.waitStep) sc.askAnswered(overlay);
        if (turn.startedAt && Date.now() - turn.startedAt > 120000) {
            sc.agentSettle(overlay, {
                error: 'Simone did not answer in time.'
            });
            return;
        }
        if (typing || !last || last.role !== 'assistant' || !String(last.text || '').trim()) return;
        sc.agentSettle(overlay, {
            text: String(last.text)
        });
        return;
    }
    if (v.awaiting.type === 'chat') {
        const k = v.awaiting.k;
        const typing = !!root[k + 'chatTyping'];
        const msgs = root[k + 'chatMessages'] || [];
        const last = msgs[msgs.length - 1];
        // The voice is saying that an ask waits on the person: nothing talks
        // over it — when it ends, VoiceOverlay.scope.noticeSaid reads the thread
        // again.
        if (v.awaiting.notice) return;
        // Honest end states — the loop must never wedge in 'thinking', and
        // nothing but Simone's FINAL answer is ever voiced:
        //   • the transport pushed a role:'system' row (no bridge / no
        //     workspace / AI service not ready) and stopped typing → error;
        //   • the answer row carries `metadata.kind === 'error'` (the server's
        //     failWorkspaceLoop synthesized it — credits exhausted, provider
        //     down) → error with the server's message, not spoken;
        //   • nothing resolved inside TURN_TIMEOUT_MS → error.
        // voiceRetry re-arms the engine from any of these.
        const TURN_TIMEOUT_MS = 120000;
        const endTurn = (msg)=>{
            v.awaiting = null;
            clearInterval(v.turnPoll);
            v.turnPoll = null;
            sc.fail(overlay, msg);
        };
        if (!typing && last && last.role === 'system' && String(last.text || '').trim()) {
            endTurn(String(last.text).trim());
            return;
        }
        if (!typing && last && last.role === 'assistant' && last.metadata && last.metadata.kind === 'error') {
            endTurn(String(last.metadata.errorMessage || last.text || '').trim() || "Simone could not answer \u2014 retry.");
            return;
        }
        // An ask of this turn waits on the person — a step the client gate
        // parked for the OK, or a question ask_user put on the screen — and the
        // server turn waits on it: the voice says so once and the loop holds —
        // VoiceOverlay.scope.holdForAsk. The turn clock stops while it waits (the
        // time on the screen is the person's), and the narration before it is
        // never the answer (the typing flag may be off). The answer on the screen
        // resumes the turn on a fresh clock (askAnswered). Only rows after this
        // turn's send count: an older ask is this send's to supersede.
        const held = sc.heldAsk(msgs.slice(v.awaiting.since || 0), overlay);
        if (!held && v.awaiting.waitStep) sc.askAnswered(overlay);
        if (!held && typing && v.turnStartedAt && Date.now() - v.turnStartedAt > TURN_TIMEOUT_MS) {
            endTurn("Simone did not answer in time \u2014 retry.");
            return;
        }
        // Mirror the in-flight assistant text into the canonical transcript on
        // every tick — BEFORE the typing bail below, because that is exactly when
        // streaming happens. Same turnId each time, so the transcript upsert
        // rewrites the entry in place rather than stacking partial copies. The
        // log shows the stream; the VOICE waits for the final text. Nothing
        // streams while an ask waits.
        if (v.awaiting.turnId && last && last.role === 'assistant') {
            const streamed = String(last.text || '');
            if (streamed.trim()) sc.turn(overlay, {
                id: v.awaiting.turnId,
                role: 'agent',
                text: streamed,
                streaming: typing && !held
            });
        }
        if (held) {
            sc.holdForAsk(overlay, held);
            return;
        }
        if (typing) return;
        if (!last || last.role !== 'assistant' || !String(last.text || '').trim()) return;
        v.awaiting = null;
        clearInterval(v.turnPoll);
        v.turnPoll = null;
        // Crude but effective markdown → speakable text: drop code blocks,
        // inline markup and links; long replies are capped so the readout stays
        // conversational (and bounds the TTS spend per turn). Local — used only
        // here.
        const speakable = (text)=>{
            const t = (text || '').replace(/```[\s\S]*?```/g, ' code block omitted. ').replace(/`([^`]*)`/g, '$1').replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/[#*_>~|]/g, ' ').replace(/\s+/g, ' ').trim();
            return t.length > 600 ? t.slice(0, 597) + "\u2026" : t;
        };
        const reply = speakable(last.text);
        if (reply) sc.speak(overlay, reply);
        else sc.flashDone(overlay, 'Sent');
    } else if (v.awaiting.type === 'freestyle') {
        if (root.freestyleBusy) return;
        v.awaiting = null;
        clearInterval(v.turnPoll);
        v.turnPoll = null;
        const built = root.freestyleError ? 'Build failed' : 'Built on canvas';
        sc.actionTurn(overlay, built);
        sc.flashDone(overlay, built);
    }
};
const $e1f86c76dacd5657$export$8b215ed1f262e333 = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    if (!v.active) return;
    const root = sc.rootOf(overlay);
    if (!root || root.voiceStatus !== 'speaking') return;
    if (v.engine === 'agent') {
        sc.agentStopSpeaking(overlay);
        return;
    }
    sc.stopSpeaking(overlay);
    sc.afterSpeak(overlay);
};
const $e1f86c76dacd5657$export$21ebdfd7d2dc4e7d = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    if (!v.active) return;
    const root = sc.rootOf(overlay);
    if (!root || !root.voiceOpen) return;
    const muted = !root.voiceMicMuted;
    // The live agent holds the mic itself: it stops hearing, the call goes on.
    if (v.engine === 'agent') {
        sc.agentMicMuted(overlay, muted);
        sc.up(overlay, muted ? {
            voiceMicMuted: true,
            voiceInterim: ''
        } : {
            voiceMicMuted: false
        });
        return;
    }
    if (muted) {
        // Pause capture but keep tracks + analyser — the wave stays live and
        // unmute is a plain resume.
        clearInterval(v.silenceLoop);
        v.silenceLoop = null;
        if (v.recorder && v.recorder.state === 'recording') try {
            v.recorder.pause();
        } catch (_) {}
    } else if (v.recorder && v.recorder.state === 'paused') {
        try {
            v.recorder.resume();
        } catch (_) {}
        // Fresh silence clock — a stale one would insta-commit on resume.
        v.lastSpeechAt = Date.now();
        clearInterval(v.silenceLoop);
        v.silenceLoop = setInterval(()=>sc.watchSilence(overlay), 150);
    } else if (!v.recorder && root.voiceStatus === 'listening') sc.record(overlay);
    const patch = {
        voiceMicMuted: muted
    };
    // A half-heard interim would sit stale under a muted mic.
    if (muted) patch.voiceInterim = '';
    sc.up(overlay, patch);
};
const $e1f86c76dacd5657$export$70e652d77becbd89 = function(role, text, id) {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const body = String(text || '');
    if (!body.trim()) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    let turnId = id;
    if (!turnId) {
        v.turnSeq = (v.turnSeq || 0) + 1;
        turnId = (role === 'user' ? 'u' : 'a') + v.turnSeq;
    }
    const entry = {
        id: turnId,
        role: role === 'user' ? 'user' : 'agent',
        text: body
    };
    if (role === 'action') entry.kind = 'action';
    sc.turn(overlay, entry);
};
const $e1f86c76dacd5657$export$927eacc5fe718b45 = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    if (!v.active) return;
    v.awaiting = null;
    sc.up(overlay, {
        voiceError: '',
        voiceStatus: 'listening',
        voiceInterim: '',
        voiceResult: ''
    });
    sc.startEngine(overlay);
};
const $e1f86c76dacd5657$export$af5ed0f9eba5ee64 = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay) return;
    const sc = overlay.scope;
    const v = sc.voiceOf(overlay);
    if (!v.active) return;
    sc.up(overlay, {
        voiceEngineReason: 'start-failed'
    });
    sc.fail(overlay, 'shell.voice.error.agentDisconnected');
};
const $e1f86c76dacd5657$export$58416bed8aa0ac66 = function() {
    const overlayOf = (el)=>{
        if (el && el.scope && el.scope.__isVoiceOverlay) return el;
        const root = el && el.getRoot ? el.getRoot() : null;
        return root && root.lookdown ? root.lookdown('VoiceOverlay') : null;
    };
    const overlay = overlayOf(this);
    if (!overlay || !overlay.scope || !overlay.scope.voice) return;
    const sc = overlay.scope;
    const v = sc.voice;
    v.active = false;
    sc.stopAgent(overlay);
    clearTimeout(v.doneTimer);
    clearTimeout(v.stopTimer);
    clearInterval(v.turnPoll);
    v.turnPoll = null;
    sc.stopRecorder(v);
    sc.stopSpeaking(overlay);
    sc.stopTracks(v);
    v.engine = null;
    // The overlay can unmount with a session still open — the canvas one is
    // gated `if: !_inShell`, so a standalone↔shell transition strands the UI
    // "open" against an engine that no longer exists (mic buttons stuck active,
    // a surface that can never be closed). Releasing the handles without
    // releasing the state is only half a teardown.
    const root = sc.rootOf(overlay);
    if (root && root.update && root.voiceOpen) root.update({
        voiceOpen: false,
        voiceMinimized: false,
        voiceHost: null,
        voiceStatus: 'idle',
        voiceInterim: '',
        voiceEngine: null,
        voiceStartedAt: 0
    }, {
        preventFetch: true
    });
    // Same dialog-close focus restore as a normal teardown — an unmount is
    // still a session end from the user's point of view. Defensive by
    // construction (VoiceOverlay.scope.restoreFocus checks `isConnected`), so
    // this is a safe no-op on the standalone↔shell transition where the origin
    // control is itself mid-unmount.
    sc.restoreFocus(v);
};

});

parcelRegister("5PkPu", function(module, exports) {

$parcel$export(module.exports, "safeMap", () => $43e1df782c2a4647$export$11ce7dbc9f509163);
// _safeMap — Array.isArray guard for SDK fetch-transform callbacks.
//
// The fetch plugin passes the raw SDK response envelope to `transform`.
// When the SDK returns a paginated wrapper `{ data: [...] }`, an error
// object, or `null` instead of a plain array, `(rows || []).map(fn)` throws
// because `rows || []` short-circuits to the non-array truthy value.
//
// Usage in a fetch transform:
//   transform: (rows) => ({ items: safeMap(rows, rowToItem) })
//
// This keeps the transform side-effect free and avoids the silent empty-state
// bug where the page renders with no data but also no error in the console.
const $43e1df782c2a4647$export$11ce7dbc9f509163 = (rows, fn)=>Array.isArray(rows) ? rows.map(fn) : [];

});

parcelRegister("6JQYC", function(module, exports) {

$parcel$export(module.exports, "fetchAiProviderDiagnostics", () => $4e800a199464bbf0$export$a72b1fa3d502662c);
// el.call('fetchAiProviderDiagnostics') — live per-provider model
// diagnostics for the AI model picker (GET /core/ai/providers via
// sdk.ai.describeProviders(), backed by
// ModelRouterService.describeConfiguredProviders()/listDemotedProviders()).
//
// MOVED HERE from packages/preview/functions/_simone/previewAiTransport.js
// (tickets/sonnet.md "live AI model diagnostics are DEAD on the workspace
// shell"): the function was registered ONLY in the preview package's
// function slice, but its three el.call sites live in SHARED components
// (AiModelSwitcher ×2, AiSettingsPanel) that every host app renders — on
// the workspace shell (which does not load preview) the call resolved to
// nothing and was swallowed by the surrounding try/catch: no error, no
// diagnostics, silent. The function's only dependency (getAiService) was
// already a shared function, so SHARED is its correct home — every app
// that loads shared (shell, preview, marketplace, …) now resolves it.
// preview re-exports a delegate for back-compat.
//
// Root key `aiProviderDiagnostics` is intentionally NOT chat-scoped (ck) —
// it is server-wide config, identical for every chat surface/scope in the
// session. Declared in workspace/state-app.js so the write survives (the
// undeclared-key drop was fault 2 of the same ticket).

var $kANrO = parcelRequire("kANrO");
const $4e800a199464bbf0$export$a72b1fa3d502662c = function() {
    const root = this.state && this.state.root;
    if (!root || !root.update) return;
    const ai = (0, $kANrO.getAiService)();
    if (!ai || typeof ai.describeProviders !== 'function') return;
    Promise.resolve(ai.describeProviders()).then((diagnostics)=>{
        if (root.update) root.update({
            aiProviderDiagnostics: diagnostics
        });
    }).catch((err)=>{
        console.warn('[shared] fetchAiProviderDiagnostics:', err);
    });
};

});

parcelRegister("541DJ", function(module, exports) {

$parcel$export(module.exports, "buildOwnershipMap", () => $3afe9916ef680c59$export$ca18e6db83e9ffc2);
$parcel$export(module.exports, "deriveDataDependencies", () => $3afe9916ef680c59$export$f892b9180b581e06);
$parcel$export(module.exports, "diffDataDependencies", () => $3afe9916ef680c59$export$38dab9c69b9a0535);
$parcel$export(module.exports, "findGlobalOrphans", () => $3afe9916ef680c59$export$670583585d8da8c9);
$parcel$export(module.exports, "findDependencyCycles", () => $3afe9916ef680c59$export$c42ab7dcedd5e8ec);
// Manifest v2.1 ownership + dependency-graph analyzer —
// tickets/spec-app-dependencies.md §3/§4/§5.
//
// Pure functions over an array of Manifest v2.1 app manifests
// ({ id, collections: [{ key, stateKey, access }], dependencies: [{ id,
// requirement, kind, provides, reason }] }). No network, no filesystem —
// every consumer (the CI derivation test, a future admin diagnostics page)
// passes in the manifests it already has.
//
// THE GROUND TRUTH THIS TRUSTS: `collections[].access` ('own' | 'read' |
// 'own-admin', default 'own' per §3). 'own-admin' (decided 2026-09-30) is an
// OWNER whose collection only admins write — a settings collection such as
// crm_settings: its grant is the 'read' grant ({ read: member, write: admin },
// collectionGrantsOf.js), but here it owns the collection like 'own' (a reader
// depends on its app; it is never an orphan). Building that field
// correctly — i.e. verifying
// which app actually WRITES a collection, from the real el.call bridge call
// sites, not from a prose comment — is a one-time-per-change human/agent
// derivation (documented per-app in each config.js's collections comment).
// This module does not re-derive access from source; it checks that the
// DEPENDENCY graph (§4) is INTERNALLY CONSISTENT with what's already
// declared (§3) — the same trust boundary workspaceModuleRef.js's
// diffDeclaredCollections draws between a manifest and a grant snapshot.
// Every collection key an app declares access:'own' (or 'own-admin') for,
// unioned across all manifests. A collection may have MULTIPLE owners
// (co-written collections
// are real — e.g. nat_stock_lines is written by warehouse-app, commerce-app
// AND scheduling-app) — ownership is a Set, not a single id.
const $3afe9916ef680c59$export$ca18e6db83e9ffc2 = (manifests)=>{
    const map = {};
    for (const m of manifests || [])for (const c of m && m.collections || []){
        if (!c || !c.key) continue;
        const access = c.access || 'own' // §3 "Default when omitted: 'own'"
        ;
        // 'own-admin' owns too (members read, admins write — see the header)
        if (access !== 'own' && access !== 'own-admin') continue;
        if (!map[c.key]) map[c.key] = new Set();
        map[c.key].add(m.id);
    }
    return map;
};
const $3afe9916ef680c59$export$f892b9180b581e06 = (manifest, ownershipMap)=>{
    const byOwner = {};
    const orphans = [];
    for (const c of manifest && manifest.collections || []){
        if (!c || !c.key) continue;
        const access = c.access || 'own';
        if (access !== 'read') continue;
        const owners = ownershipMap[c.key];
        if (!owners || owners.size === 0) {
            orphans.push(c.key);
            continue;
        }
        for (const ownerId of owners){
            if (ownerId === manifest.id) continue; // guard: a 'read' entry should never self-own
            byOwner[ownerId] = byOwner[ownerId] || new Set();
            byOwner[ownerId].add(c.key);
        }
    }
    return {
        byOwner: byOwner,
        orphans: orphans
    };
};
const $3afe9916ef680c59$export$38dab9c69b9a0535 = (manifest, ownershipMap)=>{
    // FA204 / frank trap — self-contained inline copy of deriveDataDependencies
    // (a bare sibling-export call is exactly as unresolvable post-frank.toJSON
    // as a module-local read; the export above stays live for its own real
    // consumers).
    const { byOwner: byOwner, orphans: orphans } = (()=>{
        const byOwner = {};
        const orphans = [];
        for (const c of manifest && manifest.collections || []){
            if (!c || !c.key) continue;
            const access = c.access || 'own';
            if (access !== 'read') continue;
            const owners = ownershipMap[c.key];
            if (!owners || owners.size === 0) {
                orphans.push(c.key);
                continue;
            }
            for (const ownerId of owners){
                if (ownerId === manifest.id) continue;
                byOwner[ownerId] = byOwner[ownerId] || new Set();
                byOwner[ownerId].add(c.key);
            }
        }
        return {
            byOwner: byOwner,
            orphans: orphans
        };
    })();
    const declaredPairs = new Set();
    for (const dep of manifest && manifest.dependencies || []){
        if (!dep || !Array.isArray(dep.kind) || dep.kind.indexOf('data') === -1) continue;
        for (const key of dep.provides || [])declaredPairs.add(dep.id + '\u0000' + key);
    }
    const derivedPairs = new Set();
    for (const ownerId of Object.keys(byOwner))for (const key of byOwner[ownerId])derivedPairs.add(ownerId + '\u0000' + key);
    const toPairs = (set)=>[
            ...set
        ].map((p)=>{
            const idx = p.indexOf('\u0000');
            return {
                id: p.slice(0, idx),
                key: p.slice(idx + 1)
            };
        });
    const undeclared = toPairs(new Set([
        ...derivedPairs
    ].filter((p)=>!declaredPairs.has(p))));
    const stale = toPairs(new Set([
        ...declaredPairs
    ].filter((p)=>!derivedPairs.has(p))));
    return {
        undeclared: undeclared,
        stale: stale,
        orphans: orphans
    };
};
const $3afe9916ef680c59$export$670583585d8da8c9 = (manifests)=>{
    // FA204 / frank trap — self-contained inline copy of buildOwnershipMap,
    // see diffDataDependencies above.
    const ownershipMap = (()=>{
        const map = {};
        for (const m of manifests || [])for (const c of m && m.collections || []){
            if (!c || !c.key) continue;
            const access = c.access || 'own';
            if (access !== 'own' && access !== 'own-admin') continue;
            if (!map[c.key]) map[c.key] = new Set();
            map[c.key].add(m.id);
        }
        return map;
    })();
    const referenced = new Set();
    for (const m of manifests || []){
        for (const c of m && m.collections || [])if (c && c.key) referenced.add(c.key);
    }
    return [
        ...referenced
    ].filter((key)=>!ownershipMap[key] || ownershipMap[key].size === 0).sort();
};
const $3afe9916ef680c59$export$c42ab7dcedd5e8ec = (manifests)=>{
    const idsByManifest = {};
    for (const m of manifests || [])idsByManifest[m.id] = new Set((m.dependencies || []).map((d)=>d && d.id).filter(Boolean));
    const seen = new Set();
    const cycles = [];
    for (const a of Object.keys(idsByManifest))for (const b of idsByManifest[a]){
        if (!idsByManifest[b] || !idsByManifest[b].has(a)) continue;
        const key = [
            a,
            b
        ].sort().join(' <-> ');
        if (seen.has(key)) continue;
        seen.add(key);
        cycles.push({
            a: a,
            b: b
        });
    }
    return cycles;
};

});

parcelRegister("guNGz", function(module, exports) {

$parcel$export(module.exports, "askCardOptions", () => $c025fd3667a87707$export$a04c435ea3569833);
// askCardOptions(card) — the answers of an ask_user question card (a
// `choice` or a `confirm` card on an assistant message), one row each:
// `{ at, label, value, primary, chosen }`.
//
// ONE rule for every surface that asks (coordinator F2, 2026-10-28): the
// thread's ChatCard (scope.choiceOptions) and AiAsk — the island and the
// full-screen call — read it through `el.call('askCardOptions', card)`, so
// `this` is the calling element (its `polyglot`). The two copies it replaced
// already differed on an option that is not an object.
//
//   • a confirm card answers with its own two labels (the tool's words), else
//     Confirm / Cancel in the active language; the first is the primary;
//   • a choice card answers with its options in their order, each with its
//     value (else its label); `primary` only where the option says so;
//   • an answered card (a pick, not words: never Write my own, an Edit or a
//     question a new message closed) marks its pick `chosen`, and then no row
//     is primary — the chosen capsule is the one fill;
//   • an option that is not an object, or that has no label and no value
//     (nothing to show, nothing to send), is skipped; every row keeps its
//     place (`at`), so a caller's key stays stable.
//
// The caller reads `root.lang` itself (a reactive factory subscribes to the
// language where it reads it).
function $c025fd3667a87707$export$a04c435ea3569833(card) {
    const s = card && typeof card === 'object' ? card : null;
    if (!s) return [];
    const confirm = s.type === 'confirm';
    const opts = confirm ? [
        {
            label: s.confirmLabel || this.call('polyglot', 'ai.chatCard.confirm'),
            value: 'confirm',
            primary: true
        },
        {
            label: s.cancelLabel || this.call('polyglot', 'ai.chatCard.cancel'),
            value: 'cancel'
        }
    ] : Array.isArray(s.options) ? s.options : [];
    // The current answer of an answered card (a pick, not words).
    const picked = s._resolved && !s._superseded && !s._written && !s._edit && s._chosen != null ? String(s._chosen) : null;
    const out = [];
    opts.forEach((o, at)=>{
        if (!o || typeof o !== 'object') return;
        const value = o.value != null ? o.value : o.label;
        if (value == null) return;
        out.push({
            at: at,
            label: o.label != null ? String(o.label) : String(value),
            value: value,
            primary: picked == null && (!!o.primary || confirm && at === 0),
            chosen: picked != null && String(value) === picked
        });
    });
    return out;
}

});

parcelRegister("kBsR3", function(module, exports) {

$parcel$export(module.exports, "attachDbAdapters", () => $effda549e0ab8667$export$8fb36661b90e648);
$parcel$export(module.exports, "resolveDbAdapters", () => $effda549e0ab8667$export$529fe8a87d45a1b0);

var $4skhB = parcelRequire("4skhB");

var $1zcOx = parcelRequire("1zcOx");

// The framework removed its builtin supabase adapter from `@symbo.ls/fetch`
// (smbls@799bf2224 — the PLATFORM has no Supabase), but CUSTOMER projects
// with `db: { adapter: 'supabase' }` (their own Supabase backends) remain a
// product feature. The adapter now lives in ./supabaseFetchAdapter.js and
// is registered into the fetch plugin's cross-copy CUSTOM_ADAPTERS registry
// here. Module-scope registration covers every editor surface that loads
// customer projects (canvas navigation/applyRemoteOps, preview
// renderProject, iframeApp) because they all import this file — and it is
// ALSO re-asserted inside attachDbAdapters()/resolveDbAdapters() because
// Parcel has been seen tree-shaking trailing module-side-effect statements
// from shared files despite `"sideEffects": true` (see the bootShell.js
// eager `registerAdapter('sdk', …)` note). registerAdapter is an idempotent
// map write, so the repeat is free.
//
// FA204 / frank trap — `registerSupabaseAdapter`/`attachOne`/`resolveOne`/
// `ADAPTER_FACTORIES` used to live at module scope and get referenced bare
// from the two exports below; each of the 3 call sites (module-load side
// effect + the two exports) now carries its own self-contained copy —
// registerAdapter is an idempotent map write, so the duplication is free.
(0, $4skhB.registerAdapter)('supabase', ()=>Promise.resolve((parcelRequire("1zcOx"))));

function $effda549e0ab8667$export$8fb36661b90e648(project) {
    (0, $4skhB.registerAdapter)('supabase', ()=>Promise.resolve((parcelRequire("1zcOx"))));
    if (!project) return project;
    // Extend this map when the project runtime grows a new data backend —
    // adding an entry is the single change required; every editor surface
    // picks it up automatically because they all call `attachDbAdapters`.
    const adapterFactories = Object.freeze({
        supabase: (0, $1zcOx.createSupabaseClient)
    });
    const attachOne = (cfg)=>{
        if (!cfg || cfg.__adapterAttached) return;
        const factory = adapterFactories[cfg.adapter];
        // Incomplete configs (missing adapter or url) are left bare — the fetch
        // plugin's adapter resolver will surface the missing field.
        if (!factory || !cfg.url) return;
        cfg.createClient = factory;
        cfg.__adapterAttached = true;
    };
    attachOne(project.db);
    attachOne(project.fetch);
    return project;
}
async function $effda549e0ab8667$export$529fe8a87d45a1b0(project) {
    // USER-CODE-ORIGIN review N4: FAILS CLOSED — a no-op. resolveDb calls the
    // config's `createClient`, and a project payload can carry its own (with
    // `__adapterAttached` so nothing replaces it): parent-realm code with the
    // session in reach. No live caller remains — mountUserCode builds its OWN
    // host adapter from the plain url + key (userCodeFrame.js
    // buildHostSupabaseAdapter) — so nothing here runs.
    return project;
}

});

parcelRegister("65dfg", function(module, exports) {

$parcel$export(module.exports, "authCallbackErrorKey", () => $46dd7bef5eae0532$export$7a9118854a8cbef1);
// Sign-in callback failures — a CODE for the screen, the raw text for the log.
//
// `/github-auth-callback` and `/auth/magic-callback` used to interpolate the
// raw failure straight into the one line they paint:
//
//   statusText: `Sign-in failed: ${err?.message || 'unknown error'}`
//   statusText: `OAuth error: ${errorParam}`
//
// That text is English, it comes from the Symbols server or from GitHub, and
// it is in no bundle — so a Georgian arrival read English at the one frame it
// most needs to understand, and no amount of key work could have fixed it.
// Classify the failure to a CODE here instead, and let the code carry the key.
//
// The raw message is NOT discarded: both pages `console.error` it before they
// call this, which is where a support reader needs it.
//
// FA204 / frank trap, the same one `functions/inviteToken.js` records: nothing
// lives at module scope in this file. frank.toJSON serialises each export on
// its own, so a module-scope table or regex would be unresolvable in the
// published bundle.
/**
 * The `auth.callback.error.*` key for a sign-in failure.
 *
 * `err` is whatever the page has in hand: an `Error` from the SDK, the
 * provider's own `error` / `error_description` value out of the callback
 * query (a bare string), or nothing at all. The answer is always a key that
 * exists in every shipped bundle, so the screen never shows a raw message and
 * never shows a bare key either.
 */ const $46dd7bef5eae0532$export$7a9118854a8cbef1 = (err)=>{
    const text = typeof err === 'string' ? err : [
        err?.cause?.error,
        err?.code,
        err?.error,
        err?.message
    ].filter(Boolean).join(' ');
    const is = (re)=>re.test(text);
    // The user turned the authorization down. Not a fault — say so plainly.
    if (is(/access.?denied|user.?denied|consent.?required|cancell?ed/i)) return 'auth.callback.error.accessDenied';
    // GitHub's `unverified_user_email`, and the server's own `email_not_verified`
    // (the code `pages/auth/accept-invite.js` already classifies by name).
    if (is(/unverified.?user.?email|email.?not.?verified/i)) return 'auth.callback.error.unverifiedEmail';
    // A consumed or stale single-use credential: the magic link's token, or
    // GitHub's `bad_verification_code` for a code already exchanged.
    if (is(/expired|bad.?verification.?code|invalid.?grant|already.?used/i)) return 'auth.callback.error.expired';
    // The round trip never reached the server. `Load failed` is Safari's wording
    // for the same thing Chrome calls `Failed to fetch`.
    if (is(/failed to fetch|load failed|network|offline|timed? ?out|ERR_[A-Z_]+/i)) return 'auth.callback.error.network';
    // Configuration and outage: `redirect_uri_mismatch`,
    // `incorrect_client_credentials`, `application_suspended`, a 5xx, or the
    // magic page's own `SDK token manager unavailable`. None of them is
    // anything the person in front of the screen can act on, so they share one
    // message that says to come back.
    if (is(/redirect.?uri|client.?credentials|application.?suspended|unavailable|unsupported|not configured|50[0-4]|bad gateway|internal server/i)) return 'auth.callback.error.unavailable';
    return 'auth.callback.error.generic';
};

});

parcelRegister("92gMy", function(module, exports) {

$parcel$export(module.exports, "applyAuthGuard", () => $6941518b43adac7b$export$26896b5dd4ca3392);
$parcel$export(module.exports, "isAuthError", () => $6941518b43adac7b$export$cde1786a482f9a1c);
$parcel$export(module.exports, "bounceToSigninOnAuthError", () => $6941518b43adac7b$export$f1d4ce9c82a5e103);
$parcel$export(module.exports, "createAuthRouteGuard", () => $6941518b43adac7b$export$2b28998b896848fd);
// Shared auth-redirect logic for every editor surface (canvas, preview
// when it needs auth, future embeds). Each surface's entry module used
// to reimplement this three-way decision inline:
//
//   1. bare `/` without a project → stays on `/` if authed, else `/signin`
//   2. unauthed on a non-auth page → `/signin` (carrying the query)
//   3. authed on an auth page      → `/` (UNLESS a trusted
//      cross-origin handoff is requested via `?redirect=` — see below)
//
// plus a separate "the saved token expired, log out and bounce" flow
// when a project-data fetch comes back with an auth-flavored error.

var $gDbv0 = parcelRequire("gDbv0");

var $6CwS3 = parcelRequire("6CwS3");
function $6941518b43adac7b$export$26896b5dd4ca3392({ sdk: sdk, hasProjectParams: hasProjectParams = false, loc: loc = typeof window !== 'undefined' ? window.location : null, authPaths: authPaths } = {}) {
    const defaultAuthPaths = new Set([
        '/signin',
        '/signup',
        '/signup-confirmation',
        '/reset-password',
        '/waitlist'
    ]);
    const authed = !!sdk?.getAuthToken?.();
    if (!loc) return {
        authed: authed,
        onAuthPage: false,
        redirected: false
    };
    // Fallback moved from the destructuring default to a body statement —
    // frank's `to-json` rewrites the module-scope `DEFAULT_AUTH_PATHS` free
    // var correctly EITHER way (it's promoted to globalScope, verified: it
    // round-trips as a tagged `Set`), but rewriting it AT the destructuring
    // default position changes the emitted parameter-list TEXT, which trips
    // the `functions`/`methods` arity-contract check as `signature-drift`
    // even though the arity itself never changed. A body reference doesn't
    // touch the signature.
    const resolvedAuthPaths = authPaths || defaultAuthPaths;
    const path = loc.pathname;
    const onAuthPage = resolvedAuthPaths.has(path);
    let redirected = false;
    // When an already-authed user lands on /signin?redirect=<trusted-target>
    // (a consumer surface like gazer/preview redirecting in to grab a
    // handoff), short-circuit the dashboard bounce and mint the fragment
    // immediately. Without this, the `authed && onAuthPage` rule below
    // rewrites /signin → / before signin.onSubmit's handoff branch ever runs.
    const maybeMintHandoffFromGuard = (sdkArg, locArg)=>{
        if (!locArg || typeof window === 'undefined') return false;
        const redirectParam = new URLSearchParams(locArg.search).get('redirect');
        if (!redirectParam || !(0, $gDbv0.isTrustedHandoffTarget)(redirectParam)) return false;
        const accessToken = typeof sdkArg?.getAuthToken === 'function' ? sdkArg.getAuthToken() : null;
        if (!accessToken) return false;
        let refreshToken = '';
        let expiresAt = 0;
        let expiresIn = 0;
        try {
            refreshToken = window.localStorage.getItem('symbols_refresh_token') || '';
            expiresAt = parseInt(window.localStorage.getItem('symbols_expires_at') || '0', 10) || 0;
            expiresIn = parseInt(window.localStorage.getItem('symbols_expires_in') || '0', 10) || 0;
        } catch  {
        /* localStorage unavailable — fragment still works with access token alone */ }
        const payload = (0, $gDbv0.encodeHandoffPayload)({
            accessToken: accessToken,
            refreshToken: refreshToken,
            expiresAt: expiresAt,
            expiresIn: expiresIn
        });
        const target = (0, $gDbv0.appendHandoffFragment)(redirectParam, payload);
        window.location.replace(target);
        return true;
    };
    if (path === '/' && !hasProjectParams) // Authed users STAY on `/` (the workspace home — /dashboard is retired);
    // signed-out users land on /signin.
    {
        if (!authed) {
            history.replaceState(null, '', '/signin' + loc.search);
            redirected = true;
        }
    } else if (!authed && !onAuthPage) {
        // Always land signed-out users on /signin — including when a project
        // URL is requested directly. Project fetches need an auth token, and
        // the editor chrome has its own signed-out states for /signin.
        history.replaceState(null, '', '/signin' + loc.search);
        redirected = true;
    } else if (authed && onAuthPage) {
        // Cross-origin handoff short-circuit — see maybeMintHandoffFromGuard.
        if (maybeMintHandoffFromGuard(sdk, loc)) return {
            authed: authed,
            onAuthPage: onAuthPage,
            redirected: true
        };
        // A target that renders a user project needs the server's word first
        // (confirmHandoffTarget, async) — stay on the auth page so signin.js
        // `onInit` can ask and then mint or send the user home.
        const pendingRedirect = new URLSearchParams(loc.search).get('redirect');
        if (pendingRedirect && (0, $6CwS3.classifyHandoffTarget)(pendingRedirect).verdict === 'confirm') return {
            authed: authed,
            onAuthPage: onAuthPage,
            redirected: false
        };
        history.replaceState(null, '', '/' + loc.search);
        redirected = true;
    }
    return {
        authed: authed,
        onAuthPage: onAuthPage,
        redirected: redirected
    };
}
function $6941518b43adac7b$export$cde1786a482f9a1c(err) {
    if (!err) return false;
    const unauthErrorRe = /(log in|unauthori[sz]ed|401)/i;
    const msg = (err.message || '') + ' ' + (err.cause?.message || '');
    return unauthErrorRe.test(msg);
}
async function $6941518b43adac7b$export$f1d4ce9c82a5e103(sdk) {
    try {
        await sdk?.logout?.();
    } catch  {}
    if (typeof window !== 'undefined') history.replaceState(null, '', '/signin');
}
function $6941518b43adac7b$export$2b28998b896848fd({ sdk: sdk, signedInDestination: signedInDestination = '/', authPaths: authPaths } = {}) {
    // See applyAuthGuard above — fallback moved off the destructuring default
    // for the same signature-drift reason.
    const defaultAuthPaths = new Set([
        '/signin',
        '/signup',
        '/signup-confirmation',
        '/reset-password',
        '/waitlist'
    ]);
    const resolvedAuthPaths = authPaths || defaultAuthPaths;
    return ({ pathname: pathname })=>{
        if (!resolvedAuthPaths.has(pathname)) return true;
        const authed = !!sdk?.getAuthToken?.();
        return authed ? signedInDestination : true;
    };
}

});
parcelRegister("gDbv0", function(module, exports) {

$parcel$export(module.exports, "isTrustedHandoffTarget", () => $c1b9355a87b98051$export$3a8cb3eef899112f);
$parcel$export(module.exports, "confirmHandoffTarget", () => $c1b9355a87b98051$export$154c694c4b086488);
$parcel$export(module.exports, "buildLoginRedirectUrl", () => $c1b9355a87b98051$export$539921d6ce495029);
$parcel$export(module.exports, "encodeHandoffPayload", () => $c1b9355a87b98051$export$c7fbfc89b9bdfabd);
$parcel$export(module.exports, "appendHandoffFragment", () => $c1b9355a87b98051$export$febc514a907d611e);
$parcel$export(module.exports, "consumeHandoffFromUrl", () => $c1b9355a87b98051$export$fc47bddd72bfe65a);
// Cross-origin auth handoff between workspace shell (my.symbols.app) and
// public preview surfaces (*.preview.symbols.app). The two origins do NOT
// share localStorage, so when a logged-in user lands on a preview URL for
// a PRIVATE project we have to:
//
//   1. Redirect the preview to my.symbols.app/signin?redirect=<previewUrl>
//   2. Workspace signs the user in normally (cookies + localStorage on
//      my.symbols.app)
//   3. Workspace mints a one-shot fragment payload and redirects back:
//      <previewUrl>#__symbols_auth=<base64(json{access,refresh,expiresAt})>
//   4. Preview reads the fragment BEFORE the SDK constructs its
//      TokenManager (which hydrates from localStorage in its constructor),
//      writes the tokens into preview-origin localStorage, then scrubs
//      the fragment from history so the credential never persists in
//      browser history or gets bookmarked.
//
// Fragment (not query) is used because (a) fragments aren't sent to
// the server (no access-log leak) and (b) they aren't part of any
// referer header. The payload itself is short-lived — it carries the
// SDK access token (already in the user's localStorage on
// my.symbols.app), not a freshly minted credential.
//
// Redirect targets are restricted (./handoffTargets.js): same-plane shell
// and preview-app hosts, local hosts from a local page, and — only after the
// server confirms access — hosts that render a user project. A crafted
// `?redirect=` must never hand a session to code the user does not trust.

var $6CwS3 = parcelRequire("6CwS3");

var $7sTYS = parcelRequire("7sTYS");
var $c1b9355a87b98051$require$Buffer = $7sTYS.Buffer;
const $c1b9355a87b98051$export$3a8cb3eef899112f = (url)=>{
    try {
        return (0, $6CwS3.classifyHandoffTarget)(url).verdict === 'trusted';
    } catch  {
        return false;
    }
};
const $c1b9355a87b98051$export$154c694c4b086488 = async (url, sdk)=>{
    let c;
    try {
        c = (0, $6CwS3.classifyHandoffTarget)(url);
    } catch  {
        return false;
    }
    if (c.verdict === 'trusted') return true;
    if (c.verdict !== 'confirm' || !c.projects.length) return false;
    if (!sdk || typeof sdk.getPublicProjectVisibility !== 'function' || typeof sdk.getProjectByKey !== 'function') return false;
    try {
        for (const { owner: owner, key: key } of c.projects){
            const visibility = await sdk.getPublicProjectVisibility({
                owner: owner,
                key: key
            });
            if (visibility !== 'private') return false;
            const project = await sdk.getProjectByKey({
                owner: owner,
                key: key
            });
            if (!project) return false;
        }
        return true;
    } catch  {
        return false;
    }
};
const $c1b9355a87b98051$export$539921d6ce495029 = (workspaceOrigin, returnTo)=>{
    const url = new URL('/signin', workspaceOrigin);
    url.searchParams.set('redirect', returnTo);
    return url.toString();
};
const $c1b9355a87b98051$export$c7fbfc89b9bdfabd = ({ accessToken: accessToken, refreshToken: refreshToken, expiresAt: expiresAt, expiresIn: expiresIn })=>{
    const payload = {
        a: accessToken,
        r: refreshToken || '',
        x: expiresAt || 0,
        i: expiresIn || 0
    };
    // base64url so URL-safe without further escaping.
    const json = JSON.stringify(payload);
    if (typeof window !== 'undefined' && typeof window.btoa === 'function') return window.btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return $c1b9355a87b98051$require$Buffer.from(json, 'utf8').toString('base64url');
};
const $c1b9355a87b98051$export$febc514a907d611e = (url, encodedPayload)=>{
    const HANDOFF_FRAGMENT_KEY = '__symbols_auth';
    const here = typeof window !== 'undefined' && window.location ? window.location : null;
    const u = here && here.href ? new URL(url, here.href) : new URL(url);
    // Use a key=value fragment shape so the preview can scrub just our key
    // without nuking unrelated SPA state someone might have placed there.
    const existing = u.hash.replace(/^#/, '');
    const parts = existing ? existing.split('&').filter((p)=>!p.startsWith(`${HANDOFF_FRAGMENT_KEY}=`)) : [];
    const sameOrigin = !!(here && here.origin && u.origin === here.origin);
    if (!sameOrigin) parts.push(`${HANDOFF_FRAGMENT_KEY}=${encodedPayload}`);
    u.hash = parts.join('&');
    return u.toString();
};
const $c1b9355a87b98051$export$fc47bddd72bfe65a = ()=>{
    const HANDOFF_FRAGMENT_KEY = '__symbols_auth';
    const TOKEN_STORAGE_KEYS = {
        accessToken: 'symbols_access_token',
        refreshToken: 'symbols_refresh_token',
        expiresAt: 'symbols_expires_at',
        expiresIn: 'symbols_expires_in'
    };
    const decodeHandoffPayload = (token)=>{
        try {
            const padded = token.replace(/-/g, '+').replace(/_/g, '/');
            const json = typeof window !== 'undefined' ? decodeURIComponent(escape(window.atob(padded))) : $c1b9355a87b98051$require$Buffer.from(padded, 'base64').toString('utf8');
            return JSON.parse(json);
        } catch  {
            return null;
        }
    };
    if (typeof window === 'undefined') return false;
    const hash = window.location.hash || '';
    if (!hash.includes(`${HANDOFF_FRAGMENT_KEY}=`)) return false;
    const params = new Map(hash.replace(/^#/, '').split('&').filter(Boolean).map((p)=>{
        const idx = p.indexOf('=');
        return idx === -1 ? [
            p,
            ''
        ] : [
            p.slice(0, idx),
            p.slice(idx + 1)
        ];
    }));
    const token = params.get(HANDOFF_FRAGMENT_KEY);
    if (!token) return false;
    const decoded = decodeHandoffPayload(token);
    if (!decoded?.a) return false;
    try {
        window.localStorage.setItem(TOKEN_STORAGE_KEYS.accessToken, decoded.a);
        if (decoded.r) {
            window.localStorage.setItem(TOKEN_STORAGE_KEYS.refreshToken, decoded.r);
            // A sign-in on this origin: its refresh token is its own (review D1).
            window.localStorage.setItem('symbols_session_source', 'own');
        }
        if (decoded.x) window.localStorage.setItem(TOKEN_STORAGE_KEYS.expiresAt, String(decoded.x));
        if (decoded.i) window.localStorage.setItem(TOKEN_STORAGE_KEYS.expiresIn, String(decoded.i));
    } catch (err) {
        console.warn('[authHandoff] failed to persist tokens:', err?.message || err);
        return false;
    }
    // Scrub the fragment so the credential doesn't sit in browser history
    // or the address bar. Keep any other fragment keys intact.
    params.delete(HANDOFF_FRAGMENT_KEY);
    const remaining = Array.from(params.entries()).map(([k, v])=>v ? `${k}=${v}` : k).join('&');
    const url = new URL(window.location.href);
    url.hash = remaining ? `#${remaining}` : '';
    try {
        window.history.replaceState(null, '', url.toString());
    } catch  {
    // history API unavailable; fragment will linger but tokens are persisted.
    }
    return true;
};

});
parcelRegister("6CwS3", function(module, exports) {

$parcel$export(module.exports, "classifyHandoffTarget", () => $4d1fca29f882e5e5$export$1db6f82bd04674ec);
// Which hosts may receive a sign-in handoff (`#__symbols_auth=` fragment —
// the user's access + refresh token, see ./authHandoff.js).
//
// A handoff hands the FULL platform session to the receiving origin, so the
// receiving page can do anything the user can. Only two classes qualify:
//
//   (a) the same origin (incl. relative paths) — the page already holds it;
//   (c) localhost / 127.0.0.1 / *.localhost — from a LOCAL page only.
//
// Every remote host is refused: preview hosts (bare or `<owner>--<key>`) run
// user project code, and other shells (demo) are not handoff targets.
// `confirm` is no longer produced; callers keep handling it so the
// project-scoped preview token can reuse the path later.
//
// Returns `{ verdict: 'trusted' | 'confirm' | 'refused', projects }`.
const $4d1fca29f882e5e5$export$1db6f82bd04674ec = (url)=>{
    const refused = {
        verdict: 'refused',
        projects: []
    };
    const trusted = {
        verdict: 'trusted',
        projects: []
    };
    const isLocalHost = (h)=>h === 'localhost' || h === '127.0.0.1' || h === '[::1]' || !!h && h.endsWith('.localhost');
    if (typeof url !== 'string' || !url) return refused;
    const here = typeof window !== 'undefined' ? window.location : null;
    let u;
    try {
        u = new URL(url, here?.href || undefined);
    } catch  {
        return refused;
    }
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return refused;
    if (here?.origin && u.origin === here.origin) return trusted;
    if (!here) return refused;
    // (c) local page → any local target. A deployed page never hands off to
    // a local one (a `?redirect=http://localhost:…` link would exfiltrate a
    // real session to whatever listens on that port).
    const localPage = isLocalHost(here.hostname);
    if (isLocalHost(u.hostname)) return localPage ? trusted : refused;
    // Every remote target is refused (PROD P0 hotfix, Nika 2026-10-09:
    // "Refuse all previews" + "No, refuse demo"). A preview host — the bare
    // preview app (one origin for every project) or a per-project
    // `<owner>--<key>` host — runs USER code that reads that origin's
    // storage, and "the user can read this private project" is no trust: any
    // owner can add the victim by email. Another shell on the same API plane
    // (demo) is not a handoff target either. Preview sign-in returns only with
    // a server-minted project-scoped read token, never the platform session.
    return refused;
};

});



parcelRegister("MSYnq", function(module, exports) {

$parcel$export(module.exports, "takeScreenshot", () => $092f204449265fb3$export$626240114d9522c8);
$parcel$export(module.exports, "generateBlobWindow", () => $092f204449265fb3$export$ddc96db7e4b65524);
function $092f204449265fb3$export$626240114d9522c8(node) {
    const screenshot = (node || document.documentElement).cloneNode(true);
    screenshot.style.pointerEvents = 'none';
    screenshot.style.overflow = 'hidden';
    screenshot.style.webkitUserSelect = 'none';
    screenshot.style.mozUserSelect = 'none';
    screenshot.style.msUserSelect = 'none';
    screenshot.style.oUserSelect = 'none';
    screenshot.style.userSelect = 'none';
    screenshot.dataset.scrollX = window.scrollX;
    screenshot.dataset.scrollY = window.scrollY;
    const blob = new window.Blob([
        screenshot.outerHTML
    ], {
        type: 'text/html'
    });
    return blob;
}
function $092f204449265fb3$export$ddc96db7e4b65524(node) {
    this.log(this.call('takeScreenshot', node));
    window.URL ||= window.webkitURL;
    window.open(window.URL.createObjectURL(this.call('takeScreenshot', node)));
}

});

parcelRegister("fR7qV", function(module, exports) {

$parcel$export(module.exports, "browserWebSocket", () => $b8b19255380c27be$export$ac6cf93a5ed917f8);
// Native browser WebSocket constructor reference.
//
// Why this lives in a shared helper: @supabase/realtime-js v2's
// WebSocketFactory.detectEnvironment() reads `globalThis.process.versions.node`
// to decide whether it's running in Node. Parcel polyfills `process` with
// `{ versions: { node: '...' } }` for legacy CJS compatibility, so realtime
// mis-detects the runtime as Node and throws "Node.js 20 detected without
// native WebSocket support". Passing `transport: BROWSER_WEB_SOCKET` to
// supabase's createClient skips the detection path entirely.
//
// SSR/test paths where neither `globalThis.WebSocket` nor `window.WebSocket`
// are available get `null` here — callers should spread `{ realtime:
// { transport: browserWebSocket() } }` only when truthy so the supabase
// detection runs as before in Node contexts.
//
// A FUNCTION read at call time, not a module-level constant: the constant was
// evaluated wherever the module loaded — at frank's serialization, in Node,
// that is Node's own native WebSocket, which cannot be serialized — so the
// published createSupabaseClient referenced a name that did not exist
// (frank verify: [unresolvable-identifier] BROWSER_WEB_SOCKET, gazer). The
// browser's WebSocket is only knowable in the browser.
function $b8b19255380c27be$export$ac6cf93a5ed917f8() {
    return typeof globalThis !== 'undefined' && globalThis.WebSocket || typeof window !== 'undefined' && window.WebSocket || null;
}

});

parcelRegister("frXJg", function(module, exports) {

$parcel$export(module.exports, "copyFromClipboard", () => $b3f7b59603ed3f5c$export$528683fafea19c20);
$parcel$export(module.exports, "copyTextWhenReady", () => $b3f7b59603ed3f5c$export$b7d7e49d474d0e2e);
const $b3f7b59603ed3f5c$export$528683fafea19c20 = async ()=>{
    let content;
    const clipboard = await navigator.clipboard.readText();
    if (!clipboard) return null;
    try {
        content = JSON.parse(clipboard);
    } catch (error) {
        console.warn('Error copying to clipboard: ', error.message, '');
    }
    return content;
};
const $b3f7b59603ed3f5c$export$b7d7e49d474d0e2e = (textPromise)=>{
    const clip = typeof navigator !== 'undefined' && navigator ? navigator.clipboard : null;
    if (!clip) return Promise.resolve(false);
    try {
        if (typeof ClipboardItem === 'function' && typeof clip.write === 'function') {
            const blob = Promise.resolve(textPromise).then((text)=>{
                if (!text) throw new Error('nothing to copy');
                return new Blob([
                    String(text)
                ], {
                    type: 'text/plain'
                });
            });
            return clip.write([
                new ClipboardItem({
                    'text/plain': blob
                })
            ]).then(()=>true, ()=>false);
        }
    } catch (_) {
    // A ClipboardItem that refuses a promise value: the plain-text path below.
    }
    return Promise.resolve(textPromise).then((text)=>text && typeof clip.writeText === 'function' ? clip.writeText(String(text)).then(()=>true) : false).catch(()=>false);
};

});

parcelRegister("2N9Vv", function(module, exports) {

$parcel$export(module.exports, "closeModalByStateKey", () => $2087db91aad5a87d$export$7c757cedb8b99cef);
// closeModalByStateKey — close a stateKey-driven Modal from a Close
// override handler. Walks up from `modalEl` until it finds the nearest
// ancestor declaring `stateKey` (the Modal element itself or one of
// its wrappers), reads its `extraClose` block, and pushes
// `{ [stateKey]: null, ...extraClose }` onto `root` — the exact
// contract the canonical Modal close path uses
// (shared/components/Modal.js → backdrop/Escape handlers).
//
// Use this when the brand `ModalHeader.Icons.Close` default handler
// (`el.call('closeModal')`) doesn't apply for whatever reason and a
// per-modal override is needed: instead of hardcoding the literal
// stateKey + extraClose fields (which drift away from the Modal's own
// declaration as soon as it gains another extraClose entry), defer to
// the helper so the override stays in lockstep with the Modal's
// declaration.
//
// Why a function and not a method on `el`: it lets the helper run from
// any handler — `onClick: (e, el, s) => el.call('closeModalByStateKey',
// s.root, el)` — without requiring a `this`-bound invocation.
//
// Returns true on success, false on no-op (no stateKey ancestor or
// no root.update available).
const $2087db91aad5a87d$export$7c757cedb8b99cef = (root, modalEl)=>{
    if (!root || typeof root.update !== 'function') return false;
    let m = modalEl;
    while(m){
        const sk = typeof m.stateKey === 'string' ? m.stateKey : null;
        if (sk) {
            const extra = m.extraClose && typeof m.extraClose === 'object' && !Array.isArray(m.extraClose) ? m.extraClose : null;
            root.update(extra ? {
                [sk]: null,
                ...extra
            } : {
                [sk]: null
            });
            return true;
        }
        m = m.parent;
    }
    return false;
};

});

parcelRegister("cnoxk", function(module, exports) {

$parcel$export(module.exports, "coreHeaders", () => $902aaa71ba302862$export$9fc417ac5d8b0ddd);
// coreHeaders — auth headers for the handful of direct `fetch()` calls that
// still predate an SDK route. Everything else goes through
// `sdk.execute(entity, op, args)`. (Renamed from supabaseConfig.js when the
// Supabase plane was removed; the name was the last thing left of it.)
//
// The file is ONLY the `coreHeaders` helper. Its old URL exports are gone:
// the governance Supabase project was removed (RAW_SUPABASE_URL / SUPABASE_KEY
// / SUPABASE_ANON_KEY / workspaceExtensionSessionAccessToken /
// edgeFunctionHeaders / supabaseFetchConfig / getSupabaseRealtimeClient), and
// so are SUPABASE_URL + edgeFunctionUrl() — nothing addressed either any more.
// agent_presence / agent_activity_log moved to Mongo on 2026-07-03 and read
// through /core/agent-presence + /core/agent-activity; the calendar-sync and
// github-sync edge functions were deleted outright.
//
// The name is kept for import stability across the packages that consume it.
// `restHeaders()` — the bearer helper for direct /workspace-project/sb/*
// passthrough fetches — was REMOVED 2026-07-27, and the `/sb` proxy itself is
// deleted (404). Do NOT re-add a raw-fetch helper; SDK-only backend access is
// the rule.
// Headers for MAIN-API (/core/*) fetches. LIVE — three callers:
// tickets/functions/fetchGeneralTriage.js, tickets/functions/fetchActivityFeed.js,
// canvas/pages/team-and-agents.js. (shared/functions/systemStatus.js reads
// through the SDK now — DESIGN-SHARED-SYSTEMSTATUS-RAW-FETCH-ONTO-SDK-1.)
// Sends ONLY the SDK bearer: the Supabase `apikey` header is NOT in the API's
// CORS allowedHeaders (Content-Type/Authorization/X-AppKey), so reusing it
// against dev.api.symbols.app fails the preflight with a bare "Failed to fetch"
// (hit by the 2026-07-03 __USE_CORE_AGENT_PRESENCE__/_ACTIVITY_ default-ON
// flips). No anon-key fallback — /core routes want the SDK token or nothing.
//
// FA204 / frank trap — `_sdkAccessToken` used to be a bare module-scope
// helper, read from inside this exported function's own body: unresolvable
// once this file's exports are individually frank.toJSON'd for platform
// delivery (project_frank_drops_module_local_helpers). Inlined as a local —
// no other export in this file needs it.
const $902aaa71ba302862$export$9fc417ac5d8b0ddd = ()=>{
    // Resolve the user's SDK Mongo access token. The main API verifies it via
    // HS256 and resolves workspace context through its userResolver, which
    // reads `User.activeOrganization` LIVE from Mongo every request — so an
    // org-switch or workspace-rename takes effect immediately. null outside
    // the browser or when no token is present.
    const sdkAccessToken = ()=>{
        if (typeof window === 'undefined') return null;
        try {
            return window.localStorage.getItem('symbols_access_token');
        } catch  {
            return null;
        }
    };
    const token = sdkAccessToken();
    return token ? {
        Authorization: `Bearer ${token}`
    } : {};
};

});

parcelRegister("3BQmv", function(module, exports) {

$parcel$export(module.exports, "resolveFetchErrorStatus", () => $2a0d71cfd824a276$export$cadf04fe41567a91);
$parcel$export(module.exports, "getProjectData", () => $2a0d71cfd824a276$export$c0e4867bec971477);
$parcel$export(module.exports, "unlockProjectData", () => $2a0d71cfd824a276$export$5736b143a6fd0e95);

var $lUr30 = parcelRequire("lUr30");

var $e3DJf = parcelRequire("e3DJf");

var $jXr1P = parcelRequire("jXr1P");
function $2a0d71cfd824a276$export$cadf04fe41567a91(err) {
    if (!err) return null;
    if (typeof err.status === 'number') return err.status;
    if (typeof err.statusCode === 'number') return err.statusCode;
    if (typeof err.response?.status === 'number') return err.response.status;
    if (typeof err.cause?.status === 'number') return err.cause.status;
    const msg = (err.message || '') + ' ' + (err.cause?.message || '');
    const match = msg.match(/\b([4-5]\d{2})\b/);
    return match ? parseInt(match[1], 10) : null;
}
async function $2a0d71cfd824a276$export$c0e4867bec971477({ owner: owner, key: key, branch: branch, useLocal: useLocal, useNext: // Opt-in only — when no `?useNext=` URL flag is present the SDK falls
// through to its channel-based resolution (workspaceApiBase →
// hostname autodetect / build NODE_ENV / defaultChannel). Previously
// this defaulted to true via `parseFlag(...) !== false`, forcing every
// preview fetch through next.api.symbols.app even when the host was
// dev.preview.symbols.app or local.
useNext, env: env, version: version, raw: // USER-CODE-ORIGIN security review B3: the payload UNREVIVED (function
// fields stay strings) for a caller that must never evaluate project code
// — the in-app preview; the opaque user-code frame revives it.
raw = false } = {}) {
    const TRUE_VALUES = new Set([
        'true',
        '1',
        'on',
        'yes'
    ]);
    const FALSE_VALUES = new Set([
        'false',
        '0',
        'off',
        'no'
    ]);
    function parseFlag(v) {
        if (v === true) return true;
        if (v === false) return false;
        if (v == null) return null;
        const lower = String(v).toLowerCase();
        if (TRUE_VALUES.has(lower)) return true;
        if (FALSE_VALUES.has(lower)) return false;
        return null;
    }
    // 3s timeout matches the SDK's own /me budget — if the env config
    // resolver takes longer than that, fall through to the env-name-as-
    // branch path so the user still gets a render attempt.
    const withTimeout = (p, ms = 3000)=>{
        let id;
        return Promise.race([
            p,
            new Promise((r)=>{
                id = setTimeout(()=>r(null), ms);
            })
        ]).finally(()=>clearTimeout(id));
    };
    const params = new URLSearchParams(window.location.search);
    const resolved = (0, $e3DJf.resolveProjectParams)();
    owner = owner ?? resolved.owner;
    key = key ?? resolved.key;
    branch = branch ?? (resolved.branch || 'main');
    useLocal = useLocal ?? parseFlag(params.get('useLocal')) === true;
    useNext = useNext ?? parseFlag(params.get('useNext')) === true;
    env = env ?? resolved.env;
    version = version ?? resolved.version;
    if (!owner || !key) throw new Error('Provide both owner and key');
    const projectKey = `${owner}/${key}`;
    const sdkBase = {
        useLocal: useLocal,
        useNext: useNext,
        ...raw === true ? {
            raw: true
        } : {}
    };
    // Preview domains serve CONSUMPTION, public only (PREVIEW-HOST-PUBLIC-ONLY,
    // Nika 2026-10-09). The host never holds a session, so it never touches the
    // editor's authed data route, never probes visibility, and never resolves an
    // env config (`resolveEnvPublishConfig` is an authed read) — it asks the
    // anonymous public route and nothing else. A private project and a missing
    // one end in the SAME `project_unavailable` error (./publicPreviewData.js).
    //
    // Matches production (`*.preview.symbols.app`) AND local dev
    // (`preview.localhost`, `*.preview.localhost`) so the `preview.` subdomain
    // convention stays consistent across environments.
    const host = window.location.hostname;
    const isPreviewHost = host.endsWith('.preview.symbols.app') || host === 'preview.localhost' || host.endsWith('.preview.localhost');
    if (isPreviewHost) return (0, $jXr1P.loadPublicPreviewData)({
        owner: owner,
        key: key,
        env: env,
        fetchPublic: (envKey)=>(0, $lUr30.fetchPublicProjectFromSDK)(owner, key, {
                envKey: envKey,
                ...sdkBase
            })
    });
    // `env` maps to one of the project's configured environments
    // (listEnvironments → each with its own mode/branch/version). When no env
    // config is found, fall back to treating the env name as a branch.
    let envOpts = {
        branch: branch,
        version: version || 'latest'
    };
    if (env) {
        const envResolved = await withTimeout((0, $lUr30.resolveEnvPublishConfig)(projectKey, env, sdkBase).catch(()=>null));
        envOpts = envResolved || {
            branch: env,
            version: 'latest'
        };
        // An explicit version pin (version-history preview) wins over the env's
        // published config — the inner resolution used to shadow `resolved` and
        // silently discard `?version=` whenever `?env=` was present.
        if (version) envOpts = {
            ...envOpts,
            version: version
        };
    }
    const data = await (0, $lUr30.fetchProjectFromSDK)(owner, key, {
        ...sdkBase,
        ...envOpts
    });
    if (data) return data;
    throw new Error(`No data returned for project "${projectKey}"`);
}
async function $2a0d71cfd824a276$export$5736b143a6fd0e95({ owner: owner, key: key, envKey: envKey, password: password, useLocal: useLocal, useNext: // Same channel-first default as `getProjectData` above — opt-in only.
useNext, raw: // see getProjectData (security review B3)
raw = false } = {}) {
    // FA204 / frank trap — self-contained inline copy, see getProjectData above.
    const TRUE_VALUES = new Set([
        'true',
        '1',
        'on',
        'yes'
    ]);
    const FALSE_VALUES = new Set([
        'false',
        '0',
        'off',
        'no'
    ]);
    function parseFlag(v) {
        if (v === true) return true;
        if (v === false) return false;
        if (v == null) return null;
        const lower = String(v).toLowerCase();
        if (TRUE_VALUES.has(lower)) return true;
        if (FALSE_VALUES.has(lower)) return false;
        return null;
    }
    const params = new URLSearchParams(window.location.search);
    const resolved = (0, $e3DJf.resolveProjectParams)();
    owner = owner ?? resolved.owner;
    key = key ?? resolved.key;
    useLocal = useLocal ?? parseFlag(params.get('useLocal')) === true;
    useNext = useNext ?? parseFlag(params.get('useNext')) === true;
    if (!owner || !key) throw new Error('Provide both owner and key');
    if (!envKey) throw new Error('envKey required');
    if (!password) throw new Error('password required');
    const data = await (0, $lUr30.unlockPublicProjectFromSDK)(owner, key, {
        envKey: envKey,
        password: password,
        useLocal: useLocal,
        useNext: useNext,
        ...raw === true ? {
            raw: true
        } : {}
    });
    if (!data) return null;
    return {
        ...data,
        _resolvedEnv: envKey,
        _requestedEnv: envKey,
        _usedFallback: false,
        _unlocked: true
    };
}

});
parcelRegister("jXr1P", function(module, exports) {

$parcel$export(module.exports, "loadPublicPreviewData", () => $e8787e52cccf084f$export$98cab3a2444d5c12);
// The preview HOST's data load — public only (PREVIEW-HOST-PUBLIC-ONLY,
// Nika 2026-10-09: "Sandboxed iframe in the app + public-only host").
//
// `<owner>--<key>.preview.symbols.app` renders what the SERVER serves to an
// ANONYMOUS request, and nothing else. One question per env — the anonymous
// public data route (`fetchPublic(envKey)`, the SDK's
// `getPublicProjectDataByKey`) — down the env chain:
//
//   data                       → render it (`_resolvedEnv` names the env)
//   null on every env          → `project_unavailable`
//   { code: password_required} → `project_password_protected` (password card —
//                                the unlock is anonymous too)
//   any other throw            → rethrown untouched (transport / 5xx: retryable)
//
// `null` is the SDK's answer for a private project (403 not_public), a missing
// one (404 project_not_found) and a public one with no published env (404
// env_not_found) alike. They become ONE error with ONE set of fields on
// purpose: the preview host must not tell a stranger which keys exist. There is
// deliberately no visibility probe and no authed fallback here — the host never
// holds a session, so neither could add anything but an oracle.
async function $e8787e52cccf084f$export$98cab3a2444d5c12({ owner: owner, key: key, env: env, fetchPublic: fetchPublic } = {}) {
    const envOrder = env ? [
        ...new Set([
            env,
            'production',
            'staging',
            'development'
        ])
    ] : [
        'production',
        'staging',
        'development'
    ];
    const requestedEnv = env || 'production';
    let passwordEnv = null;
    for (const tryEnv of envOrder){
        let pub = null;
        try {
            pub = await fetchPublic(tryEnv);
        } catch (e) {
            // The project IS published in this env; the visitor lacks the password.
            if (e?.code === 'password_required') {
                passwordEnv = tryEnv;
                break;
            }
            throw e;
        }
        if (pub) return {
            ...pub,
            _resolvedEnv: tryEnv,
            _requestedEnv: requestedEnv,
            _usedFallback: tryEnv !== requestedEnv
        };
    }
    const projectKey = `${owner}/${key}`;
    const err = new Error(passwordEnv ? `Project "${projectKey}" is password-protected` : `Project "${projectKey}" is not available`);
    err.code = passwordEnv ? 'project_password_protected' : 'project_unavailable';
    err.owner = owner;
    err.key = key;
    err.triedEnvs = envOrder;
    err.passwordEnv = passwordEnv;
    throw err;
}

});


parcelRegister("5Wa4N", function(module, exports) {

$parcel$export(module.exports, "getPresenceStatus", () => $452a2f76e282d222$export$c51b093fd25777d4);
$parcel$export(module.exports, "onPresenceStatusChange", () => $452a2f76e282d222$export$16e8801514936c0d);
// idleState — tracks the LOCAL user's activity to derive a presence
// status of 'online' (recently active + tab visible) vs 'idle' (no
// activity for 5 min, or the tab is hidden).
//
// This is the SOURCE of the `status` field the realtime provider tracks
// into the Supabase presence channel (see sdkRealtimeProvider.js, the
// `op === 'presence'` branch). presence.js then reads it back off each
// peer's tracked meta and surfaces it as `onlineUsers[].status`, which
// the /team-and-agents person nodes render as a green (online) vs amber
// (idle) dot — mirroring the existing agent idle/online indicators.
//
// Single shared listener set per tab, booted once on first use. Passive
// document listeners reset an idle timer; after IDLE_AFTER_MS of no
// activity (or `document.hidden`) the status flips to 'idle' and every
// registered subscriber is notified. SSR-guarded — on the server it
// reports a stable 'online' and never touches `document`.
// FA204 / frank trap — `status`/`timer`/`booted`/`subscribers` are genuine
// cross-call state (no el/root argument to hang them on; the whole point is
// ONE shared listener set + status per tab, across every independent
// caller of either export below), so they're re-homed onto
// `window.__idleState` per the pointerCapability.js template. The two
// exports below share the boot/status apparatus, so each carries its own
// self-contained copy of the full state-machine builder (mirrors
// openInSlot.js's "shared by 2 exports, duplicated into both" shape) rather
// than depending on a bare module-scope helper that breaks post-frank-
// serialization — `w.__idleState` itself is what keeps the two copies
// pointed at the SAME live state object at runtime.
// Current local presence status: 'online' | 'idle'. SSR returns the
// stable default so server-rendered tracks never claim idle.
function $452a2f76e282d222$export$c51b093fd25777d4() {
    const w = typeof window !== 'undefined' ? window : globalThis;
    if (!w.__idleState) {
        const IDLE_AFTER_MS = 300000;
        const isBrowser = typeof document !== 'undefined' && typeof window !== 'undefined';
        const state = {
            status: 'online',
            timer: null,
            booted: false,
            subscribers: new Set(),
            isBrowser: isBrowser
        };
        const setStatus = (next)=>{
            if (next === state.status) return;
            state.status = next;
            for (const cb of state.subscribers)try {
                cb(state.status);
            } catch (err) {
                console.warn('[idleState] subscriber threw:', err?.message || err);
            }
        };
        const clearTimer = ()=>{
            if (state.timer != null) {
                clearTimeout(state.timer);
                state.timer = null;
            }
        };
        const armTimer = ()=>{
            clearTimer();
            state.timer = setTimeout(()=>setStatus('idle'), IDLE_AFTER_MS);
        };
        // Any user interaction marks active and restarts the countdown —
        // unless the tab is currently hidden, in which case we stay idle
        // until it's visible again.
        const onActivity = ()=>{
            if (isBrowser && document.hidden) {
                setStatus('idle');
                clearTimer();
                return;
            }
            setStatus('online');
            armTimer();
        };
        const onVisibilityChange = ()=>{
            if (document.hidden) {
                setStatus('idle');
                clearTimer();
            } else onActivity();
        };
        // Idempotent boot — attaches the single shared listener set the first
        // time anyone reads the status or subscribes. Safe to call repeatedly.
        state.boot = ()=>{
            if (state.booted || !isBrowser) return;
            state.booted = true;
            const ACTIVITY_EVENTS = [
                'mousemove',
                'keydown',
                'pointerdown',
                'wheel'
            ];
            for (const evt of ACTIVITY_EVENTS)document.addEventListener(evt, onActivity, {
                passive: true
            });
            document.addEventListener('visibilitychange', onVisibilityChange, {
                passive: true
            });
            // Seed the initial countdown so a tab that's opened and left
            // untouched eventually flips to idle on its own.
            if (document.hidden) setStatus('idle');
            else armTimer();
        };
        w.__idleState = state;
    }
    const state = w.__idleState;
    if (!state.isBrowser) return 'online';
    state.boot();
    return state.status;
}
function $452a2f76e282d222$export$16e8801514936c0d(cb) {
    const w = typeof window !== 'undefined' ? window : globalThis;
    if (!w.__idleState) {
        const IDLE_AFTER_MS = 300000;
        const isBrowser = typeof document !== 'undefined' && typeof window !== 'undefined';
        const state = {
            status: 'online',
            timer: null,
            booted: false,
            subscribers: new Set(),
            isBrowser: isBrowser
        };
        const setStatus = (next)=>{
            if (next === state.status) return;
            state.status = next;
            for (const c of state.subscribers)try {
                c(state.status);
            } catch (err) {
                console.warn('[idleState] subscriber threw:', err?.message || err);
            }
        };
        const clearTimer = ()=>{
            if (state.timer != null) {
                clearTimeout(state.timer);
                state.timer = null;
            }
        };
        const armTimer = ()=>{
            clearTimer();
            state.timer = setTimeout(()=>setStatus('idle'), IDLE_AFTER_MS);
        };
        const onActivity = ()=>{
            if (isBrowser && document.hidden) {
                setStatus('idle');
                clearTimer();
                return;
            }
            setStatus('online');
            armTimer();
        };
        const onVisibilityChange = ()=>{
            if (document.hidden) {
                setStatus('idle');
                clearTimer();
            } else onActivity();
        };
        state.boot = ()=>{
            if (state.booted || !isBrowser) return;
            state.booted = true;
            const ACTIVITY_EVENTS = [
                'mousemove',
                'keydown',
                'pointerdown',
                'wheel'
            ];
            for (const evt of ACTIVITY_EVENTS)document.addEventListener(evt, onActivity, {
                passive: true
            });
            document.addEventListener('visibilitychange', onVisibilityChange, {
                passive: true
            });
            if (document.hidden) setStatus('idle');
            else armTimer();
        };
        w.__idleState = state;
    }
    const state = w.__idleState;
    if (typeof cb !== 'function' || !state.isBrowser) return ()=>{};
    state.boot();
    state.subscribers.add(cb);
    return ()=>{
        state.subscribers.delete(cb);
    };
}

});

parcelRegister("fCegb", function(module, exports) {

$parcel$export(module.exports, "whitelabelAuthPaint", () => $b5e5775f43ef03fe$export$50a0097202bb8c36);
// whitelabelAuthPaint — the branded paint for the design-system auth cards
// (signup, reset-password, accept-invite) on a white-label host
// (Nika 2026-10-14: "update login screen make it more beautiful for astio
// login" — login / signup / accept-invite / reset read as ONE family).
//
// `el.call('whitelabelAuthPaint', s)` → null off a branded host, or when the
// record carries no parseable accent (the platform primary then stands);
// else:
//   fill      the tenant accent — the primary button's fill
//   ink       the label ink on that fill: white or near-black, whichever has
//             the higher WCAG contrast on the accent (the same fallback rule
//             as WhitelabelSignin.js onAccentFor)
//   backdrop  the soft accent light behind the card
//
// Everything comes from the org's branding record (root.whitelabelBrand); no
// tenant is named here. Self-contained (FA204 / FA001): no import and no
// module-scope helper — every step lives inside the function body.
const $b5e5775f43ef03fe$export$50a0097202bb8c36 = function(s) {
    const st = s && s.root ? s : this && this.state;
    const brand = st && st.root && st.root.whitelabelBrand;
    const accent = brand && typeof brand.accent === 'string' ? brand.accent.trim() : '';
    if (!accent) return null;
    const rgbOf = (c)=>{
        const hex = c.charAt(0) === '#' ? c.slice(1) : null;
        if (hex && (hex.length === 3 || hex.length === 6)) {
            const f = hex.length === 3 ? hex.replace(/./g, (ch)=>ch + ch) : hex;
            const n = parseInt(f, 16);
            if (!Number.isNaN(n)) return [
                n >> 16 & 255,
                n >> 8 & 255,
                n & 255
            ];
        }
        const m = c.match(/rgba?\(\s*([0-9.]+)[,\s]+([0-9.]+)[,\s]+([0-9.]+)/i);
        return m ? [
            Number(m[1]),
            Number(m[2]),
            Number(m[3])
        ] : null;
    };
    const lum = (rgb)=>{
        const ch = rgb.map((v)=>{
            const x = v / 255;
            return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
        });
        return 0.2126 * ch[0] + 0.7152 * ch[1] + 0.0722 * ch[2];
    };
    const rgb = rgbOf(accent);
    if (!rgb) return null;
    const la = lum(rgb);
    const onWhite = 1.05 / (la + 0.05);
    const onDark = (la + 0.05) / (lum([
        17,
        24,
        32
    ]) + 0.05);
    return {
        fill: accent,
        ink: onWhite >= onDark ? '#FFFFFF' : '#111820',
        backdrop: 'radial-gradient(120% 70% at 50% -10%, color-mix(in srgb, ' + accent + ' 18%, transparent), transparent 70%)'
    };
};

});

parcelRegister("hHiFC", function(module, exports) {

$parcel$export(module.exports, "installKeyboardAvoidance", () => $ce24ef53302e4929$export$4066cdc21d0b80c4);
// Virtual-keyboard avoidance for coarse-pointer (touch) devices.
//
// The workspace had ZERO soft-keyboard handling — no visualViewport reader
// anywhere — so on iPad the on-screen keyboard covers the lower ~40% of the
// LAYOUT viewport and occludes bottom-anchored inputs (the canvas AI prompt,
// the chat composer). Those inputs live in NON-scrolling containers, so iOS
// can't auto-scroll them into view the way it does for inputs inside a normal
// scroll region.
//
// This installs a single window.visualViewport listener that measures how much
// of the layout viewport the keyboard covers and publishes it as a CSS custom
// property on <html> — `--kbd-inset` (px). Bottom-anchored composers translate
// up by that amount via `transform: translateY(calc(-1 * var(--kbd-inset,0px)))`
// so they sit just above the keyboard. Publishing a CSS var on documentElement
// from a boot helper mirrors the shell's --shell-top / canvasBackground pattern
// (the single established way this app threads viewport chrome into CSS).
//
// Idempotent singleton — safe to call from every composer's onInit / onCreate.

var $7hbEo = parcelRequire("7hbEo");
const $ce24ef53302e4929$export$4066cdc21d0b80c4 = ()=>{
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (window.__keyboardAvoidanceInstalled) return;
    const vv = window.visualViewport;
    if (typeof vv === 'undefined' || !vv) return;
    window.__keyboardAvoidanceInstalled = true;
    const KBD_INSET_VAR = '--kbd-inset';
    // The soft keyboard is only up when a text-entry field owns focus. Anything
    // else (a button, the canvas surface, a scroll container) means the
    // keyboard is down, so the inset must collapse to 0 — otherwise a residual
    // visualViewport offset (pinch-zoom, URL-bar collapse) would lift the
    // composer for no reason.
    const isTextEntry = (node)=>{
        if (!node || node.nodeType !== 1) return false;
        const tag = node.tagName;
        if (tag === 'TEXTAREA') return true;
        if (tag === 'INPUT') {
            // Non-text inputs (checkbox, button, range, file…) don't raise a keyboard.
            const type = (node.getAttribute('type') || 'text').toLowerCase();
            return ![
                'button',
                'submit',
                'reset',
                'checkbox',
                'radio',
                'range',
                'color',
                'file'
            ].includes(type);
        }
        return node.isContentEditable === true;
    };
    const root = document.documentElement;
    const apply = ()=>{
        // Keyboard overlap = the slice of the layout viewport the visual viewport no
        // longer covers at the bottom. offsetTop folds in the pinch-zoom / pinned
        // top-bar case so we never over- or under-shoot.
        const overlap = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
        const lifted = overlap > 0 && (0, $7hbEo.isCoarsePointer)() && isTextEntry(document.activeElement);
        root.style.setProperty(KBD_INSET_VAR, (lifted ? overlap : 0) + 'px');
    };
    vv.addEventListener('resize', apply);
    vv.addEventListener('scroll', apply);
    // focusin / focusout catch the field gaining or losing focus without a
    // viewport change — e.g. tabbing between two inputs while the keyboard stays
    // up, or blurring to dismiss it.
    window.addEventListener('focusin', apply);
    window.addEventListener('focusout', apply);
    apply();
};

});

parcelRegister("9UpD3", function(module, exports) {

$parcel$export(module.exports, "noCodeProps", () => $736d3961c8b7c1b2$export$4058e405967271c);
$parcel$export(module.exports, "colorProperties", () => $736d3961c8b7c1b2$export$6fbd67cb9a657d86);
const $736d3961c8b7c1b2$export$4058e405967271c = [
    'extends',
    'tag',
    'text',
    'html',
    'class',
    'state',
    'data',
    'scope',
    'children',
    'childrenAs',
    'src',
    'icon',
    'iconModifier',
    'shape',
    'shapeModifier',
    'animation',
    'animationName',
    'animationDuration',
    'animationDelay',
    'animationTimingFunction',
    'transition',
    'transitionDuration',
    'transitionDelay',
    'transitionTimingFunction',
    'transitionProperty',
    'show',
    'hide',
    'height',
    'width',
    'boxSizing',
    'boxSize',
    'inlineSize',
    'blockSize',
    'minWidth',
    'maxWidth',
    'widthRange',
    'minHeight',
    'maxHeight',
    'heightRange',
    'size',
    'minBlockSize',
    'minInlineSize',
    'maxBlockSize',
    'maxInlineSize',
    'minSize',
    'maxSize',
    'borderWidth',
    'padding',
    'scrollPadding',
    'paddingInline',
    'paddingBlock',
    'paddingTop',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInlineStart',
    'paddingInlineEnd',
    'margin',
    'marginInline',
    'marginBlock',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlockStart',
    'marginBlockEnd',
    'gap',
    'columnGap',
    'rowGap',
    'round',
    'borderRadius',
    'flexWrap',
    'flexFlow',
    'flexAlign',
    'flow',
    'wrap',
    'align',
    'fontSize',
    'fontFamily',
    'fontWeight',
    'area',
    'template',
    'templateAreas',
    'column',
    'columns',
    'templateColumns',
    'autoColumns',
    'columnStart',
    'row',
    'rows',
    'templateRows',
    'autoRows',
    'rowStart',
    'autoFlow',
    'inset',
    'left',
    'top',
    'right',
    'bottom',
    'verticalInset',
    'horizontalInset',
    'theme',
    'color',
    'background',
    'backgroundColor',
    'backgroundImage',
    'textStroke',
    'outline',
    'outlineOffset',
    'border',
    'borderColor',
    'borderLeft',
    'borderTop',
    'borderRight',
    'borderBottom',
    'shadow',
    'boxShadow',
    'textShadow',
    'columnRule'
];
const $736d3961c8b7c1b2$export$6fbd67cb9a657d86 = [
    // Text Colors
    'color',
    'textDecorationColor',
    'textShadow',
    'textEmphasisColor',
    // Background Colors
    'backgroundColor',
    // Border Colors
    'borderColor',
    'borderTopColor',
    'borderRightColor',
    'borderBottomColor',
    'borderLeftColor',
    'borderBlockColor',
    'borderInlineColor',
    'borderTop',
    'borderRight',
    'borderBottom',
    'borderLeft',
    'borderBlock',
    'borderInline',
    // Outline Colors
    'outlineColor',
    // Text Decoration
    'textDecoration',
    'textEmphasis',
    // SVG and Canvas
    'fill',
    'stroke',
    'stopColor',
    'floodColor',
    'lightingColor',
    // Form Elements
    'accentColor',
    'caretColor',
    'webkitTextFillColor',
    'webkitTextStrokeColor',
    // Miscellaneous
    'boxShadow',
    'columnRuleColor',
    'webkitTapHighlightColor',
    'webkitTouchCallout'
];

});

parcelRegister("7Ybqe", function(module, exports) {

$parcel$export(module.exports, "URL_ALLOWED_KINDS", () => $5cd6ff3044a4c63d$export$2face1fc6c66e83b);
$parcel$export(module.exports, "URL_ALLOWED_PRICING", () => $5cd6ff3044a4c63d$export$3ff3751e19032ce0);
$parcel$export(module.exports, "URL_ALLOWED_SORTS", () => $5cd6ff3044a4c63d$export$a81d37b5cc86b234);
$parcel$export(module.exports, "parseFiltersFromSearch", () => $5cd6ff3044a4c63d$export$f400f8b25c79b066);
// Marketplace URL-filter helpers — extracted from
// `marketplace/functions/index.js` so canvas's /marketplace deep-link
// surface and the marketplace sub-app pull from one source. Both call
// sites previously cross-imported across packages, which violated the
// Phase 10 no-restricted-imports rule.
//
// `parseFiltersFromSearch(searchString)` returns a partial diff to apply
// to the host root state — only keys that appear in the URL and pass the
// allowed-set guards are present in the output.
//
// FA204 / frank trap — these three tables used to be private module-scope
// consts, re-exported under public names read bare from `parseFiltersFromSearch`'s
// own body: unresolvable once this file's exports are individually
// frank.toJSON'd for platform delivery (project_frank_drops_module_local_helpers).
// The public names stay exported (marketplace/functions/index.js imports
// them cross-file, unaffected by frank); `parseFiltersFromSearch` carries
// its own self-contained local copies instead of reading them bare.
const $5cd6ff3044a4c63d$export$2face1fc6c66e83b = [
    'library',
    'template',
    'integration',
    'registrar',
    'plugin',
    'mcp',
    'all'
];
const $5cd6ff3044a4c63d$export$3ff3751e19032ce0 = [
    'all',
    'free',
    'paid',
    'installed',
    'pinned'
];
const $5cd6ff3044a4c63d$export$a81d37b5cc86b234 = [
    'name',
    'priceAsc',
    'priceDesc'
];
const $5cd6ff3044a4c63d$export$f400f8b25c79b066 = (search)=>{
    const allowedKinds = [
        'library',
        'template',
        'integration',
        'registrar',
        'plugin',
        'mcp',
        'all'
    ];
    const allowedPricing = [
        'all',
        'free',
        'paid',
        'installed',
        'pinned'
    ];
    const allowedSorts = [
        'name',
        'priceAsc',
        'priceDesc'
    ];
    const sp = new URLSearchParams(search || '');
    const out = {};
    const kind = sp.get('kind');
    if (kind && allowedKinds.includes(kind)) out.activeKind = kind;
    const pricing = sp.get('pricing');
    if (pricing && allowedPricing.includes(pricing)) out.activePricing = pricing;
    const sort = sp.get('sort');
    if (sort && allowedSorts.includes(sort)) out.activeSort = sort;
    const q = sp.get('q');
    if (typeof q === 'string') out.query = q;
    const cats = sp.get('categories');
    if (cats) out.activeCategories = cats.split(',').map((c)=>c.trim()).filter(Boolean);
    const itemId = sp.get('item');
    if (itemId) out._itemId = itemId;
    return out;
};

});

parcelRegister("eHqP0", function(module, exports) {

$parcel$export(module.exports, "mergeProjectIntoEditorContext", () => $ab39e30c9a0f356c$export$16dee9e6c5827ed8);
// Merge a project's content-facing context into an editor chrome's
// context. Chrome values (and `extras`) take precedence. Build/runtime
// flags (useReset, globalTheme, …) must be stripped with
// `splitProjectForEditor` before calling — they belong to the chrome.
function $ab39e30c9a0f356c$export$16dee9e6c5827ed8(editorCtx, projectContent, extras = {}) {
    const { components: extraComponents, functions: extraFunctions, methods: extraMethods, state: extraState, ...rest } = extras || {};
    return {
        ...editorCtx,
        polyglot: projectContent?.polyglot,
        // Chrome libraries first so brand DS tokens survive project overlays.
        sharedLibraries: [
            ...Array.isArray(editorCtx?.sharedLibraries) ? editorCtx.sharedLibraries : [],
            ...Array.isArray(projectContent?.sharedLibraries) ? projectContent.sharedLibraries : []
        ],
        fetch: projectContent?.fetch ?? editorCtx?.fetch,
        designSystem: projectContent?.designSystem ?? editorCtx?.designSystem,
        snippets: {
            ...projectContent?.snippets || {},
            ...editorCtx?.snippets || {}
        },
        files: {
            ...projectContent?.files || {},
            ...editorCtx?.files || {}
        },
        components: {
            ...projectContent?.components || {},
            ...editorCtx?.components || {},
            ...extraComponents || {}
        },
        functions: {
            ...projectContent?.functions || {},
            ...editorCtx?.functions || {},
            ...extraFunctions || {}
        },
        methods: {
            ...projectContent?.methods || {},
            ...editorCtx?.methods || {},
            ...extraMethods || {}
        },
        state: {
            ...projectContent?.state || {},
            ...editorCtx?.state || {},
            ...extraState || {}
        },
        ...rest
    };
}

});

parcelRegister("i6RWv", function(module, exports) {

$parcel$export(module.exports, "moduleRoutesFromRoot", () => $d2f2a1709c1317e0$export$c6bf0aa0ec854cae);
$parcel$export(module.exports, "isModuleRoute", () => $d2f2a1709c1317e0$export$bef5ef67306e9d78);
$parcel$export(module.exports, "isModuleCanvasRoute", () => $d2f2a1709c1317e0$export$b6ecf47807e9ddac);
// moduleRoutes.js — the routes an installed workspace module/app injected at
// RUNTIME (`/exams`, `/exams/admin/registrations`, `/manage/members`, …).
//
// These cannot live in any static list in the shell: they depend entirely on
// what a given workspace has installed. Every classifier that asks "is this one
// of ours?" has to consult this ledger instead of a hardcoded route table, or
// it will silently misjudge exactly the surfaces a workspace adds:
//
//   - the MWT router treated them as non-intranet, so an in-app click dropped
//     the `/w/<org>` prefix and the `?ws=` workspace handle
//   - `_isProjectCanvasPath` claimed any 2-segment path whose first segment
//     wasn't in a hardcoded reserved set, so `/manage/members` and
//     `/exams/documents` were permanently misread as `<owner>/<project>`
//     canvases — dragging canvas chrome (Zoombar, Inspect/Split/Sidebar
//     buttons, the full-bleed `data-shell-route="canvas"` layout) onto ordinary
//     app pages. That reserved list could never be right; it drifts the moment
//     anyone installs an app whose first segment isn't in it.
//
// Sourced from the ledgers the loaders already publish — `workspaceProject.pages`
// (takeover module) and `workspaceApps[].pages` (additive Manifest v2 apps) —
// so there is one source of truth and no second registry to keep in sync.
//
// Pure-ish module, direct ESM import (workspacePrefix.js / guestRoutes.js
// pattern) — not registered in functions/index.js, never frank-serialized.
// Root state → Set of injected route paths, or null when nothing is installed.
// Null (rather than an empty Set) so callers can cheaply skip the whole check.
const $d2f2a1709c1317e0$export$c6bf0aa0ec854cae = (root)=>{
    try {
        if (!root) return null;
        const set = new Set();
        const takeover = root.workspaceProject && root.workspaceProject.pages;
        if (takeover) for (const p of Object.keys(takeover))set.add(p);
        if (Array.isArray(root.workspaceApps)) for (const app of root.workspaceApps){
            if (Array.isArray(app?.pages)) for (const p of app.pages)set.add(p);
        }
        return set.size ? set : null;
    } catch  {
        return null;
    }
};
const $d2f2a1709c1317e0$export$bef5ef67306e9d78 = (path, routes)=>{
    if (!routes || typeof path !== 'string' || !path) return false;
    const has = routes instanceof Set ? (k)=>routes.has(k) : (k)=>!!routes[k];
    const clean = path.split(/[?#]/)[0];
    if (has(clean)) return true;
    const first = clean.split('/').filter(Boolean)[0];
    return !!first && has('/' + first);
};
const $d2f2a1709c1317e0$export$b6ecf47807e9ddac = (route, root)=>{
    if (!root || typeof route !== 'string' || !route) return false;
    const clean = route.split(/[?#]/)[0];
    if (!clean || clean === '/') return false;
    try {
        const owns = (pages)=>{
            if (Array.isArray(pages)) return pages.indexOf(clean) !== -1;
            return !!(pages && typeof pages === 'object' && pages[clean]);
        };
        const lists = (list)=>Array.isArray(list) && list.some((p)=>typeof p === 'string' && p.split(/[?#]/)[0] === clean);
        const take = root.workspaceProject;
        if (take && lists(take.canvasRoutes) && owns(take.pages)) return true;
        const apps = Array.isArray(root.workspaceApps) ? root.workspaceApps : [];
        return apps.some((app)=>!!app && lists(app.canvasRoutes) && owns(app.pages));
    } catch  {
        return false;
    }
};

});

parcelRegister("iXsus", function(module, exports) {

$parcel$export(module.exports, "isMwtIntranetRoute", () => $dcd3d641c855dcc2$export$6a188d6a236eab9);
$parcel$export(module.exports, "mwtOrgToReconcile", () => $dcd3d641c855dcc2$export$db6b455d0504208e);
$parcel$export(module.exports, "planMwtNav", () => $dcd3d641c855dcc2$export$3efeba0a2b20eb43);
// mwtNav.js — the PURE multi-workspace-tabs navigation decision (Phase 3).
// Split out of the router wrapper so it imports nothing but the sibling path
// helpers (no `@symbo.ls/router`) and stays unit-testable in isolation. Both the
// `context.functions.router` wrapper (mwtRouter.js) and any consumer that needs
// to compute the prefixed URL for an intranet target import from here.

var $9juhh = parcelRequire("9juhh");

var $i6RWv = parcelRequire("i6RWv");
const $dcd3d641c855dcc2$export$6a188d6a236eab9 = (p, moduleRoutes)=>{
    const INTRANET_RE = /^\/(tasks|task|tickets|ticket|resolutions|chat|chats|calendar|inbox|epics|teams|team-and-agents|meet|notes|documents|docs|admin|people|my-agents|my|announcements|company|settings|profile|data|system-status|integrations|features|analytics|workspace-analytics|bookmarks|files|agents|reminders|history|add-app|infra|apps|getting-started)(\/|$)/;
    // Bare `/studio` (or `/studio/`) only — NEVER a `/studio/<owner>` sub-path.
    // That shape names a (possibly foreign) org in path segment 2 (app.js
    // `_urlOrgSlug`/`ownerSlugForPath`) and is handled by the cross-org
    // reconcile branch instead of the org-prefix canonicalize branch. Matching
    // it here too would stamp THIS tab's ambient org/workspace onto a URL
    // naming a DIFFERENT org's board — exactly the foreign-handle poisoning
    // class workspaceUrlSync.js's header documents for `/natali/shop?ws=server`
    // (project-canvas paths), reproduced one level up for studio owner paths.
    const isBareStudio = /^\/studio\/?$/.test(p);
    return p === '/' || isBareStudio || INTRANET_RE.test(p) || (0, $i6RWv.isModuleRoute)(p, moduleRoutes);
};
const $dcd3d641c855dcc2$export$db6b455d0504208e = ({ slug: slug, orgs: orgs, activeOrgId: activeOrgId })=>{
    if (!slug || !activeOrgId) return null;
    const org = (Array.isArray(orgs) ? orgs : []).find((o)=>o && o.slug === slug);
    if (!org) return null;
    const id = String(org.id ?? org._id ?? '');
    return id && id !== String(activeOrgId) ? id : null;
};
const $dcd3d641c855dcc2$export$3efeba0a2b20eb43 = ({ path: path, slug: slug, ws: ws, moduleRoutes: moduleRoutes, mwtEnabled: mwtEnabled })=>{
    if (!mwtEnabled) return null;
    const raw = typeof path === 'string' ? path : '/';
    const matchPath = (0, $9juhh.stripWorkspacePrefix)(raw);
    const rawSlug = (0, $9juhh.getWorkspacePrefixSlug)(raw);
    // If the caller ALREADY prefixed the path (e.g. the switcher's cross-org
    // rewrite emits `/w/<newSlug>/…`), trust that slug verbatim — do NOT
    // re-derive from `root.org.slug`, which can still be the OLD org mid-switch.
    // Cross-ORG targets pass through UNTOUCHED: this org's ambient handle (and
    // even an explicit `?ws=`) is org-scoped, so carrying it over would name a
    // workspace that does not exist in the destination org.
    if (rawSlug && rawSlug !== slug) return {
        matchPath: matchPath,
        addressBarUrl: raw
    };
    // WHICH workspace, by precedence: a handle the caller already put IN THE
    // PATH (`/w/org/<handle>/…`) → an explicit legacy `?ws=` (cross-workspace
    // deep link, parsed forever) → the tab's ambient active workspace.
    const explicit = (0, $9juhh.getWorkspaceQueryParam)(raw);
    const handle = (0, $9juhh.getWorkspacePathHandle)(raw) || explicit || ws || null;
    if (!rawSlug) {
        // Self-contained duplicate of isMwtIntranetRoute's logic (FA204/FA207,
        // see the file-header note) — keep both copies in sync, incl. the
        // bare-`/studio`-only carve-out (STUDIO-ORG-DESYNC-1).
        const INTRANET_RE = /^\/(tasks|task|tickets|ticket|resolutions|chat|chats|calendar|inbox|epics|teams|team-and-agents|meet|notes|documents|docs|admin|people|my-agents|my|announcements|company|settings|profile|data|system-status|integrations|features|analytics|workspace-analytics|bookmarks|files|agents|reminders|history|add-app|infra|apps|getting-started)(\/|$)/;
        const pathOnly = matchPath.split(/[?#]/)[0];
        const isBareStudio = /^\/studio\/?$/.test(pathOnly);
        const isIntranet = pathOnly === '/' || isBareStudio || INTRANET_RE.test(pathOnly) || (0, $i6RWv.isModuleRoute)(pathOnly, moduleRoutes);
        if (!slug || !isIntranet) return {
            matchPath: matchPath,
            addressBarUrl: null
        };
    }
    // Emitted URLs are canonical scheme A: handle in the path, `?ws=` stripped.
    const route = explicit ? (0, $9juhh.withWorkspaceQuery)(matchPath, null) : matchPath;
    return {
        matchPath: matchPath,
        addressBarUrl: (0, $9juhh.withWorkspacePath)(rawSlug || slug, handle, route)
    };
};

});

parcelRegister("2UHAL", function(module, exports) {

$parcel$export(module.exports, "stashSignupIntent", () => $21f2a02c9ca2d049$export$5a40927ad5941a0a);
$parcel$export(module.exports, "sendSignupIntent", () => $21f2a02c9ca2d049$export$567273ceeb3bca83);
$parcel$export(module.exports, "takeSignupCheckoutNext", () => $21f2a02c9ca2d049$export$306002180af4fe38);
// SIGNUP-INTENT (symbols.app/built-with) — the sign-up link's preset, plan and
// source, carried across whichever sign-in follows.
//
// The email path already forwards them on the register body
// (pages/auth/signup.js). A Google / GitHub sign-up never touches that body,
// and a verify-email-then-sign-in loses the query. So the signup page STASHES
// the intent here, and the first explicit sign-in afterwards
// (functions/fetch.js initializeUserSession) SENDS it through the existing
// sdk.updateMe as `signupIntent`. The server stores it first-touch only, for
// new accounts only, and installs the preset (server
// auth/services/SignupIntentService.js). A paid plan also queues ONE
// post-sign-in route, /admin/usage?checkout=<plan>, which that page turns into
// the real checkout (pages/admin/usage.js). A `?claim=credits` link rides
// along as `claimCredits`, so a Google / GitHub sign-up claims the sign-up
// credits like the email form does.
//
// D9 — EVERY SIGN-UP CLAIMS (2026-10-25). With nothing stashed (a plain
// Google / GitHub sign-up, no link), the first sign-in on this browser sends
// `{ claimCredits: true }` alone. The server decides whether the account is
// new (created in the last 24 h, else `not_a_new_account`) and claims once
// per person (a repeat is `alreadyClaimed`) — the client never guesses. After
// a definite answer a per-user flag (`signup_claim_answered:<userId>`) stops
// later sign-ins from this browser sending it again. The SDK's updateMe
// resolves with no data for an intent-only PATCH, and the server answers 2xx
// only with an outcome, so a RESOLVED request is the definite answer; a
// rejected one (offline, 5xx) leaves no flag, and the next sign-in asks again.
//
// FA204/FA207 / frank trap: every export is self-contained (keys, limits and
// helpers inlined), as in postOAuthNext.js — module-scope names do not survive
// a per-export frank.toJSON.
const $21f2a02c9ca2d049$export$5a40927ad5941a0a = ()=>{
    const KEY = 'signup_intent';
    if (typeof window === 'undefined') return false;
    try {
        const params = new URL(window.location.href).searchParams;
        const fields = {
            source: 'utm_source',
            medium: 'utm_medium',
            campaign: 'utm_campaign',
            ref: 'ref',
            plan: 'plan'
        };
        const acquisition = {};
        Object.keys(fields).forEach((k)=>{
            const v = params.get(fields[k]);
            if (v) acquisition[k] = String(v).slice(0, 200);
        });
        const preset = String(params.get('preset') || '').slice(0, 64);
        // `?claim=credits` — the sign-up credits a Google / GitHub sign-up would
        // otherwise lose (the email form claims on the register body).
        const claimCredits = params.get('claim') === 'credits';
        if (!preset && !Object.keys(acquisition).length && !claimCredits) return false;
        const stash = {
            preset: preset || null,
            acquisition: acquisition,
            at: Date.now()
        };
        if (claimCredits) stash.claimCredits = true;
        window.localStorage.setItem(KEY, JSON.stringify(stash));
        return true;
    } catch (_) {
        return false;
    }
};
const $21f2a02c9ca2d049$export$567273ceeb3bca83 = function sendSignupIntent() {
    const KEY = 'signup_intent';
    const CHECKOUT_KEY = 'signup_checkout_next';
    const ANSWERED_PREFIX = 'signup_claim_answered:';
    const MAX_AGE_MS = 604800000;
    if (typeof window === 'undefined') return null;
    const root = this && this.state && this.state.root || null;
    const userId = String(root && (root.userId || root.currentUser && root.currentUser.id) || '');
    const answeredKey = userId ? ANSWERED_PREFIX + userId : '';
    // Never blocks or fails the sign-in: the server answers when it answers.
    // A resolved answer marks this person on this browser (see the header).
    const send = (signupIntent)=>{
        try {
            const sdk = this && this.sdk;
            const pending = sdk && typeof sdk.updateMe === 'function' ? sdk.updateMe({
                signupIntent: signupIntent
            }) : null;
            if (pending && typeof pending.then === 'function') pending.then(()=>{
                if (!answeredKey) return;
                try {
                    window.localStorage.setItem(answeredKey, String(Date.now()));
                } catch (_) {}
            }, ()=>{});
        } catch (_) {}
    };
    let intent = null;
    try {
        intent = JSON.parse(window.localStorage.getItem(KEY) || 'null');
        // consumed once, whatever happens next
        window.localStorage.removeItem(KEY);
    } catch (_) {
        return null;
    }
    const fresh = !!intent && typeof intent === 'object' && !!intent.at && Date.now() - Number(intent.at) <= MAX_AGE_MS;
    if (!fresh) {
        // Nothing stashed: the claim alone, once per person on this browser, and
        // only for a known person (the flag needs the id).
        if (!answeredKey) return null;
        try {
            if (window.localStorage.getItem(answeredKey)) return null;
        } catch (_) {
            return null;
        }
        const claimOnly = {
            claimCredits: true
        };
        send(claimOnly);
        return claimOnly;
    }
    const acquisition = intent.acquisition && typeof intent.acquisition === 'object' ? intent.acquisition : {};
    const signupIntent = {
        acquisition: acquisition
    };
    if (intent.preset) signupIntent.preset = intent.preset;
    // The server claims once per user, new accounts only (server
    // auth/services/SignupIntentService.js) — a repeat is `alreadyClaimed`.
    if (intent.claimCredits === true) signupIntent.claimCredits = true;
    send(signupIntent);
    const plan = String(acquisition.plan || '').toLowerCase();
    if (plan === 'pro' || plan === 'scale') try {
        window.localStorage.setItem(CHECKOUT_KEY, JSON.stringify({
            path: '/admin/usage?checkout=' + plan,
            at: Date.now()
        }));
    } catch (_) {}
    return signupIntent;
};
const $21f2a02c9ca2d049$export$306002180af4fe38 = ()=>{
    const CHECKOUT_KEY = 'signup_checkout_next';
    const MAX_AGE_MS = 3600000;
    if (typeof window === 'undefined') return null;
    try {
        const raw = window.localStorage.getItem(CHECKOUT_KEY);
        if (!raw) return null;
        window.localStorage.removeItem(CHECKOUT_KEY);
        const v = JSON.parse(raw);
        if (!v || typeof v.path !== 'string') return null;
        if (!/^\/admin\/usage\?checkout=(pro|scale)$/.test(v.path)) return null;
        if (!v.at || Date.now() - Number(v.at) > MAX_AGE_MS) return null;
        return v.path;
    } catch (_) {
        return null;
    }
};

});

parcelRegister("cKIiY", function(module, exports) {

$parcel$export(module.exports, "insertPanelLibraryRefs", () => $948c25f31f9a97d6$export$e04a14fcbbff24dd);
$parcel$export(module.exports, "fetchInsertPanelLibrary", () => $948c25f31f9a97d6$export$bfce7021bd42de0e);
$parcel$export(module.exports, "ambiguousKeyCandidates", () => $948c25f31f9a97d6$export$3487a8ced80fd794);
// A project is named by `(owner, key)`. A bare key can name several owners'
// projects, and the server's by-key routes answer such a key 409
// `ambiguous_key` with the owner/key pairs the caller may address (server
// 736d2d755) — they never pick one. These helpers keep the owner on every
// by-key read the shell makes, and read the candidates off that 409 so a
// caller can SHOW them; nothing here picks a project for the user.
//
// Each function is self-contained (FA204 / frank trap): no module-scope helper.
// The libraries the CURRENT project links, as `owner/key` refs — the
// project's own `useLibraries` record (GET /core/projects/:id/libraries, each
// row with its owner slug). A row with no owner is left out rather than sent
// as a bare key. The insert panel's library used to be the hardcoded legacy
// key 'default.symbo.ls', and its deleted switcher row dropped the owner the
// same way (`projectPath.split('/')[1] + '.symbo.ls'`).
async function $948c25f31f9a97d6$export$e04a14fcbbff24dd() {
    const el = this;
    const root = el.getRootState && el.getRootState() || el.state && el.state.root || {};
    const projectId = root.projectId || root.data && (root.data._id || root.data.id) || null;
    const sdk = el.sdk;
    if (!projectId || !sdk || typeof sdk.getProjectLibraries !== 'function') return [];
    const rows = await sdk.getProjectLibraries(projectId);
    const list = Array.isArray(rows) ? rows : rows && (rows.items || rows.data) || [];
    return list.filter((row)=>row && typeof row.owner === 'string' && row.owner && row.key).map((row)=>({
            ref: row.owner + '/' + row.key,
            owner: row.owner,
            key: row.key,
            name: row.name || row.key
        }));
}
async function $948c25f31f9a97d6$export$bfce7021bd42de0e(ref) {
    const el = this;
    const value = String(ref || '');
    const at = value.indexOf('/');
    if (at < 1 || at === value.length - 1) return null;
    return el.sdk.getProjectByKey({
        owner: value.slice(0, at),
        key: value.slice(at + 1)
    });
}
function $948c25f31f9a97d6$export$3487a8ced80fd794(error) {
    let node = error;
    for(let depth = 0; node && depth < 5; depth++){
        const body = node && typeof node === 'object' ? node : null;
        if (body && (body.code === 'ambiguous_key' || body.error === 'ambiguous_key')) {
            const list = Array.isArray(body.candidates) ? body.candidates : [];
            return list.filter((c)=>c && c.owner && c.key);
        }
        node = node && node.cause;
    }
    return null;
}

});

parcelRegister("RhMOd", function(module, exports) {

$parcel$export(module.exports, "WORKSPACE_NODES", () => $0a02bf5436387d5f$export$1152f297a8fc369c);
// AUTO-GENERATED by editor/scripts/projectScanner.js — do not edit by hand.
// Regenerated every time the launcher (editor/scripts/launcher.js) starts.
//
// Project data for the canvas is fetched from the SDK at runtime; this
// registry only exposes the workspace-graph metadata.
const $0a02bf5436387d5f$export$1152f297a8fc369c = [
    {
        owner: 'system',
        key: 'analytics',
        group: 'editor',
        type: null,
        sharedLibraries: [
            'brand',
            'shared'
        ]
    },
    {
        owner: 'system',
        key: 'canvas',
        group: 'editor',
        type: null,
        sharedLibraries: [
            'brand'
        ]
    },
    {
        owner: 'system',
        key: 'design-system',
        group: 'editor',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'marketplace',
        group: 'editor',
        type: null,
        sharedLibraries: [
            'brand',
            'shared'
        ]
    },
    {
        owner: 'system',
        key: 'preview',
        group: 'editor',
        type: null,
        sharedLibraries: [
            'brand'
        ]
    },
    {
        owner: 'system',
        key: 'shared',
        group: 'editor',
        type: 'library',
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'workspace-calendar',
        group: 'editor',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'workspace-chat',
        group: 'editor',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'workspace-documents',
        group: 'editor',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'workspace-meet',
        group: 'editor',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'workspace-shell',
        group: 'editor',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'workspace-tickets',
        group: 'editor',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'governance-infra',
        group: 'governance',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'governance-measure',
        group: 'governance',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'governance-product',
        group: 'governance',
        type: null,
        sharedLibraries: [
            'brand'
        ]
    },
    {
        owner: 'system',
        key: 'governance-run',
        group: 'governance',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'docs',
        group: 'docs',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'aihouse',
        key: 'site',
        group: '<root>',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'bigbrother',
        key: 'big-brother',
        group: '<root>',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'focusagency',
        group: '<root>',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'luka',
        key: 'xma',
        group: '<root>',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'silverbreeze-labs',
        key: 'hq',
        group: '<root>',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'symbols-project-1774112015526',
        key: 'project-1774112015526',
        group: '<root>',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'vc-brain',
        key: 'uglybaby',
        group: '<root>',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'akar-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'antd-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'basmilius-weather-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'bitcoin-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'bootstrap-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'boxicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'bytesize-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'cryptocurrency-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'cssgg',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'default',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'devicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'eva-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'feather-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'flag-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'flagkit',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'fluentui-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'font-awesome',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'game-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'gravity-ui-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'heroicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'iconoir',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'iconpark',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'ikonate',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'ionicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'lucide-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'mapsicon',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'material-design-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'mynaui-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'octicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'phosphor-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'radix-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'remix-icon',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'simple-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'solar-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'super-tiny-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'system-uicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'tabler-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'teenyicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'typicons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'vscode-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'system',
        key: 'weather-icons',
        group: 'libraries',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: '4it',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'bazaar',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'bb',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'byld',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'childsafetynet',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'colab',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'landing',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'pavilion',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'rita',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'rosi',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'shveuli',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'smartcapital',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'tmr',
        key: 'vdcapital',
        group: 'projects',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'angry-birds-dom',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'appldroid',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'basketball-scouting',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'chatbot',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'checkmaster',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'golden-fleece',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'hackernews',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'moll',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'muse',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'nikedas',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'non-gov',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'pingpong',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'rez-water-and-powers',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'scaling-portfolio',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'sphere-gallery',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'spreadsheet',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'survey',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'talentflow',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'tic-tac-toe',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'velora',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'word',
        group: 'templates',
        type: null,
        sharedLibraries: []
    },
    {
        owner: 'community',
        key: 'word',
        group: 'templates',
        type: null,
        sharedLibraries: []
    }
];

});

parcelRegister("7hR4u", function(module, exports) {

$parcel$export(module.exports, "speakRepliesEnabled", () => $54e349ca09795852$export$a78b7c97f1149ad1);
$parcel$export(module.exports, "setSpeakReplies", () => $54e349ca09795852$export$9b3a56894888f66d);
$parcel$export(module.exports, "primeSpeakAudio", () => $54e349ca09795852$export$362d4173cb49046d);
$parcel$export(module.exports, "stopSpeakReply", () => $54e349ca09795852$export$93440c0f0aa736e5);
$parcel$export(module.exports, "speakReply", () => $54e349ca09795852$export$2a1ff4ad8f26e9b0);
// Speak the assistant's replies aloud (ElevenLabs) — Simone's voice for the
// TYPED chat surface. The whole TTS chain already exists (server
// /core/ai/voice/tts → sdk.voiceTts → streamed mpeg); this module is the one
// wire that was missing: same conversation pipeline writes the text, this
// speaks it. Playback mirrors documents' readerVoice (blob → object URL →
// one scope-held Audio element), including the degrade-to-silence rule: the
// text is already on screen, so a failed play NEVER surfaces an error and
// NEVER falls back to a browser voice.
//
// Frank constraint: no module-scope helper reads from exported fns — helpers
// are local consts inside each function; cross-file access via el.call.
// Default OFF (S3, tickets/sonnet.md, Nika 2026-08-16: "if voice is NOT
// activated, do not read the AI response aloud by default" — reverses the
// prior default-ON decision this comment used to document). A fresh
// profile with no stored preference must produce no speech; the
// AiSettingsPanel toggle turns it on per user (localStorage), and every
// failure path is silent.
const $54e349ca09795852$export$a78b7c97f1149ad1 = function() {
    try {
        const v = window.localStorage.getItem('symbols_ai_speak_replies');
        return v === 'on';
    } catch (_) {
        return false;
    }
};
const $54e349ca09795852$export$9b3a56894888f66d = function(on) {
    try {
        window.localStorage.setItem('symbols_ai_speak_replies', on ? 'on' : 'off');
    } catch (_) {}
    const el = this;
    const root = el && el.getRoot ? el.getRoot() : null;
    if (root && root.update) root.update({
        _speakReplies: !!on
    }, {
        preventFetch: true
    });
};
const $54e349ca09795852$export$362d4173cb49046d = function() {
    const el = this;
    if (!el || !el.scope) return;
    const h = el.scope.speakReply || (el.scope.speakReply = {});
    if (h.audio) return;
    try {
        const silent = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=';
        const audio = new Audio(silent);
        audio.volume = 1;
        const p = audio.play();
        if (p && typeof p.catch === 'function') p.catch(()=>{});
        try {
            audio.pause();
        } catch (_) {}
        h.audio = audio;
    } catch (_) {}
};
const $54e349ca09795852$export$93440c0f0aa736e5 = function() {
    const el = this;
    const h = el && el.scope ? el.scope.speakReply || (el.scope.speakReply = {}) : {};
    h.token = null;
    if (h.audio) {
        try {
            h.audio.pause();
        } catch (_) {}
        h.audio.onended = null;
        h.audio.onpause = null;
    }
    if (h.url) {
        try {
            URL.revokeObjectURL(h.url);
        } catch (_) {}
        h.url = null;
    }
    const root = el && el.getRoot ? el.getRoot() : null;
    if (root && root.update && root.voiceStatus === 'speaking') root.update({
        voiceStatus: null
    }, {
        preventFetch: true
    });
};
const $54e349ca09795852$export$2a1ff4ad8f26e9b0 = async function(text, opts) {
    const el = this;
    const root = el && el.getRoot ? el.getRoot() : null;
    if (!root) return {
        ok: false
    };
    if (!el.call('speakRepliesEnabled')) return {
        ok: false,
        off: true
    };
    if (root.voiceOpen) return {
        ok: false,
        voiceSessionOwnsAudio: true
    };
    try {
        if (typeof document !== 'undefined' && document.hidden) return {
            ok: false,
            hidden: true
        };
    } catch (_) {}
    const sdk = el && (el.sdk || el.context && el.context.methods && el.context.methods.sdk) || null;
    if (!sdk || typeof sdk.voiceTts !== 'function') return {
        ok: false
    };
    // Markdown → speakable prose (same shape voiceSession.speakable uses):
    // drop fences whole, unwrap inline code/links/emphasis/headings, collapse
    // whitespace, cap the length so a long answer reads its gist, not a saga.
    const speakable = (md)=>{
        let t = String(md || '');
        t = t.replace(/```[\s\S]*?```/g, ' ');
        t = t.replace(/`([^`]*)`/g, '$1');
        t = t.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ');
        t = t.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
        t = t.replace(/^#{1,6}\s+/gm, '');
        t = t.replace(/[*_>#|]/g, ' ');
        t = t.replace(/\s+/g, ' ').trim();
        return t.length > 700 ? `${t.slice(0, 700)}\u{2026}` : t;
    };
    const prose = speakable(text);
    if (!prose) return {
        ok: false
    };
    const h = el.scope ? el.scope.speakReply || (el.scope.speakReply = {}) : {};
    const token = `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    h.token = token;
    el.call('stopSpeakReply');
    h.token = token;
    try {
        // The workspace's own voice (functions/workspaceVoice.js — the admin's
        // pick on /admin/workspace-settings) unless the caller names one; none =
        // the server's default voice.
        const voiceId = opts && opts.voiceId || el.call('workspaceVoiceId', root) || undefined;
        const res = await sdk.voiceTts({
            text: prose,
            voiceId: voiceId
        });
        if (!res || !res.ok || h.token !== token) return {
            ok: false
        };
        const blob = await res.blob();
        if (h.token !== token) return {
            ok: false
        };
        const url = URL.createObjectURL(blob);
        h.url = url;
        const audio = h.audio || new Audio();
        h.audio = audio;
        audio.src = url;
        audio.onended = ()=>{
            if (h.token === token) el.call('stopSpeakReply');
        };
        if (root.update) root.update({
            voiceStatus: 'speaking'
        }, {
            preventFetch: true
        });
        const p = audio.play();
        if (p && typeof p.catch === 'function') p.catch(()=>{
            // Autoplay refusal / decode failure — silent degrade, text is on
            // screen. Clear the status so the pill never sticks on "Speaking…".
            if (h.token === token) el.call('stopSpeakReply');
        });
        return {
            ok: true
        };
    } catch (_) {
        if (h.token === token) el.call('stopSpeakReply');
        return {
            ok: false
        };
    }
};

});

parcelRegister("eEiQY", function(module, exports) {

$parcel$export(module.exports, "workspaceVoiceId", () => $aaa36d03e2ddacb1$export$6081ff91f1b8fcf3);
// THE workspace voice — the ElevenLabs voice id every spoken reply of this
// workspace uses: `settings.voice.voiceId`, picked by a workspace admin on
// /admin/workspace-settings (the Voice card) and checked server-side against
// the account's voice list. ONE reader for both live speakers: the voice
// overlay (components/VoiceOverlay.js `ttsVoiceOf`) and the typed-answer
// reader (functions/speakReply.js).
//
// Read through THE accessor (`workspaceSettings`), so a record still in
// flight (list-shaped) yields no voice rather than a guess, and shape-checked
// so nothing but a plain ElevenLabs id can reach the TTS URL. `null` = the
// server's default voice. `this` is the calling element (el.call).
const $aaa36d03e2ddacb1$export$6081ff91f1b8fcf3 = function workspaceVoiceId(root) {
    const el = this;
    if (!el || typeof el.call !== 'function') return null;
    const read = el.call('workspaceSettings', root);
    const voice = read && read.settings && read.settings.voice;
    const id = voice && typeof voice.voiceId === 'string' ? voice.voiceId.trim() : '';
    return /^[A-Za-z0-9]{10,40}$/.test(id) ? id : null;
};

});

parcelRegister("53J05", function(module, exports) {

$parcel$export(module.exports, "splitProjectForEditor", () => $3af023b87f816093$export$49e4924cb0ffbea4);
// Separates the app-level build/runtime flags (useReset, useVariable,
// globalTheme, ...) from the content-facing project context. Editor
// surfaces that render inside their OWN chrome (canvas, future embeds)
// must keep these flags out of the merged context — the chrome owns its
// own CSS reset / icon sprites / theme, and the project's values would
// override the chrome.
//
// For surfaces that mount the project as a standalone app (preview
// iframe, mermaid SSR), the flags stay with the project and this split
// isn't needed — createIframeApp + bundle.js apply them as-is.
//
// `pages` is split out separately because canvas routes project pages
// through its Collection grid (as thumbnails) rather than its own router.
function $3af023b87f816093$export$49e4924cb0ffbea4(project) {
    if (!project || typeof project !== 'object') return {
        chromeFlags: {},
        projectContent: {},
        projectPages: {}
    };
    const { useReset: useReset, useVariable: useVariable, useFontImport: useFontImport, useIconSprite: useIconSprite, useSvgSprite: useSvgSprite, useDocumentTheme: useDocumentTheme, useDefaultIcons: useDefaultIcons, useDefaultConfig: useDefaultConfig, globalTheme: globalTheme, pages: pages, ...projectContent } = project;
    return {
        chromeFlags: {
            useReset: useReset,
            useVariable: useVariable,
            useFontImport: useFontImport,
            useIconSprite: useIconSprite,
            useSvgSprite: useSvgSprite,
            useDocumentTheme: useDocumentTheme,
            useDefaultIcons: useDefaultIcons,
            useDefaultConfig: useDefaultConfig,
            globalTheme: globalTheme
        },
        projectContent: projectContent,
        projectPages: pages || {}
    };
}

});

parcelRegister("789Y4", function(module, exports) {

$parcel$export(module.exports, "fetchSystemStatus", () => $5311032e744b26e8$export$7efb8bc0f2846c5c);
$parcel$export(module.exports, "fetchUptime", () => $5311032e744b26e8$export$2e7a07f18668f0e5);
// Shared system-status reads — the cross-repo version/health matrix from
// /core/system/status on the main server (Mongo; formerly a Supabase edge
// function) + 120-day uptime data from /core/system/uptime (Mongo; formerly
// the /workspace-project/sb system_uptime table — Supabase is retired, both
// routes are Mongo-only now). Read by the System Health page (workspace
// pages/system.js, through el.call) and the tickets release page.
//
// Both reads go through the SDK (sdk 3.14.794: getSystemStatus /
// getSystemUptime), never a raw fetch — the backend is SDK-only. The SDK owns
// the URL (the same workspaceApiBase channel getSDK() resolves), the bearer
// (the TokenManager session, a per-tab persona included — the old
// localStorage coreHeaders() read skipped the persona) and the transport
// retry. DESIGN-SHARED-SYSTEMSTATUS-RAW-FETCH-ONTO-SDK-1.
//
// Why /core/system/status replaced the edge function: the edge fn read
// `GITHUB_TOKEN` from Deno env. That PAT was scope-limited / expired and
// rotating it was operator pain. The main server has `core/lib/githubApp.js`
// which auths as the symbols-agent GitHub App — installation tokens
// auto-discovered via /orgs/{org}/installation, auto-rotated every hour.
// Installing the App on a new org via GitHub's UI is now the entire flow;
// no secret rotation, no PAT scoping.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
async function $5311032e744b26e8$export$7efb8bc0f2846c5c() {
    // FA204 / frank trap — inlined (self-contained local, see longPress.js for
    // the identical shape). 10s ceiling so the page never sits indefinitely
    // on "Fetching status…" when the request hangs or the network is
    // unreachable. The signal rides into the SDK request.
    const TIMEOUT_MS = 10000;
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), TIMEOUT_MS);
    try {
        // Public read — the route has no auth gate. The SDK still attaches the
        // session bearer, which a public route ignores.
        const data = await (0, $1NxyO.getSDK)().getSystemStatus({
            signal: controller.signal
        });
        // The null client (a host where the SDK class never arrived) answers
        // null: no backend was reached, so fail like any other failure. Never
        // resolve null — both callers read `.matrix` off the answer.
        if (!data || typeof data !== 'object') throw new Error('system-status: no response');
        return data;
    } catch (err) {
        // An HTTP refusal keeps the old status-only message. The SDK's own error
        // text is the SERVER's payload (a GitHub 401 body, for example), and the
        // tickets release page renders the message.
        if (err?.status !== undefined) throw new Error(`system-status: ${err.status}`);
        throw err;
    } finally{
        clearTimeout(timer);
    }
}
async function $5311032e744b26e8$export$2e7a07f18668f0e5() {
    // /core/system/uptime on the main server (superadmin-only; answers the
    // grouped { [service]: [ { service, checked_at, status, latency_ms,
    // message }, … ] } shape — returned as-is).
    // FA204 / frank trap — inlined, see fetchSystemStatus above.
    const TIMEOUT_MS = 10000;
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), TIMEOUT_MS);
    try {
        return await (0, $1NxyO.getSDK)().getSystemUptime({
            limit: 3000,
            signal: controller.signal
        }) || {};
    } catch (err) {
        // An HTTP refusal (a 403 for a non-superadmin) answers {} silently, as
        // the raw read did on !res.ok. Only a request that never completed warns.
        if (err?.status === undefined) console.warn('[systemStatus] /core/system/uptime fetch failed', err);
        return {};
    } finally{
        clearTimeout(timer);
    }
}

});

parcelRegister("yREI6", function(module, exports) {

$parcel$export(module.exports, "collectionGrantsOf", () => $068ccbfa8b2226f6$export$1e620547d07da69d);
// THE MANIFEST → RECORDS GRANT RULE on the client (a permission rule).
//
// A module app's manifest declares its record collections (`collections[]`);
// an install turns them into `capabilities.records.collections` — the grant
// the server's AccessResolver gates every record read and write on. The SERVER
// install path owns this rule (server src/domains/workspaces/services/
// WorkspaceAppManifest.js: normalizeCollectionAccess + deriveFieldRules +
// deriveCollectionsCapability). The shell's module assign and "Check for
// updates" build the same grant on the client (workspaceModuleRef.js), and until
// 2026-09-30 they ignored `access`: a declared `access: 'read'` became a plain
// key — member read AND editor WRITE — where the server grants
// { read: 'member', write: 'admin' } (crm_settings was writable by editors after
// a "Check for updates"; found by crm-w1). This is the client twin of the
// server rule, case for case:
//   access absent / null / 'own'  → the plain key (member read, editor write)
//   'read'                        → { key, read: 'member', write: 'admin' }
//   'own-admin'                   → { key, read: 'member', write: 'admin' } —
//     the app OWNS the collection, members read, admins write (a settings
//     collection; decided 2026-09-30). The same grant as 'read'; the
//     dependency graph (appDependencyGraph.js) counts it as the owner.
//   'own-rows'                    → { key, read: 'member', write: 'own' }
//   'private-rows'                → { key, read: 'own', write: 'own' }
//   anything else                 → as 'read' (fail CLOSED)
//   `fields` (per-field rules)    → the object entry: the levels above (a plain
//     key's are member / editor) plus the valid rules. A malformed rule is
//     dropped (read: member | own | admin | perm:<key>; write: editor | admin |
//     server | perm:<key>); the server's resolver checks a perm key against its
//     catalog and fails closed.
//   `teams` (per-team overrides) → the object entry carries the map — the
//     server's deriveTeamOverrides (server 121a14c2b, 2026-10-05): slugs
//     trimmed and lower-cased (the resolver's keying), an unknown level fails
//     CLOSED to 'admin', a team entry with no axis is dropped, nothing usable
//     → no map. The DFI Finances app declares its fin_* collections
//     `{ read: 'admin', teams: { 'dfli-costs': { read: 'member' } } }`; before
//     this the client grant dropped the exception (admin-only).
// The key is trimmed; an entry without one is dropped.
//
// An entry with NO `access` (absent, null or '') that declares its own `read`
// / `write` levels keeps them ({ key, read, write }, bellforge's manifests),
// exactly as the server: a level the resolver does not know fails CLOSED to
// 'admin', an undeclared axis stays absent, a 'scoped' level carries its
// `scopeField`. Every valid read tier is at most `member` and every write
// tier at most `editor` — the plain key's levels.
//
// ONE copy on the client: workspaceModuleRef.js imports this for both of its
// manifest reads. Self-contained body (frank serializes functions; a
// module-scope read inside the body would not survive it).
const $068ccbfa8b2226f6$export$1e620547d07da69d = (manifestCollections)=>{
    const list = Array.isArray(manifestCollections) ? manifestCollections : [];
    const FIELD_READ = [
        'member',
        'own',
        'admin'
    ];
    const FIELD_WRITE = [
        'editor',
        'admin',
        'server'
    ];
    // The resolver's record grant levels (server core/constants/recordGrantLevels.js).
    // 'acl' is a write level too (server G-1, 98a5bc4e2): a row's ACL decides who
    // may edit it — without it a declared write 'acl' failed CLOSED to 'admin'.
    const LEVEL_READ = [
        'member',
        'admin',
        'own',
        'scoped',
        'acl'
    ];
    const LEVEL_WRITE = [
        'editor',
        'admin',
        'own',
        'scoped',
        'acl'
    ];
    const FIELD_NAME = /^[A-Za-z_][A-Za-z0-9_]*$/;
    // A declared level: present and non-empty (a falsy level reads as absent).
    const declared = (v)=>v !== undefined && v !== null && v !== '';
    const tierOk = (v, tiers)=>typeof v === 'string' && (v.startsWith('perm:') ? v.length > 5 : tiers.includes(v));
    const fieldRules = (raw)=>{
        if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
        const rules = {};
        for (const name of Object.keys(raw)){
            const rule = raw[name];
            if (!FIELD_NAME.test(name) || !rule || typeof rule !== 'object' || Array.isArray(rule)) continue;
            const r = {};
            if (rule.read !== undefined) {
                if (!tierOk(rule.read, FIELD_READ)) continue;
                r.read = rule.read;
            }
            if (rule.write !== undefined) {
                if (!tierOk(rule.write, FIELD_WRITE)) continue;
                r.write = rule.write;
            }
            if (Object.keys(r).length) rules[name] = r;
        }
        return Object.keys(rules).length ? rules : null;
    };
    // The server's deriveTeamOverrides, case for case.
    const teamRules = (raw)=>{
        if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
        const teams = {};
        for (const rawSlug of Object.keys(raw)){
            const slug = rawSlug.trim().toLowerCase();
            const rule = raw[rawSlug];
            if (!slug || !rule || typeof rule !== 'object' || Array.isArray(rule)) continue;
            const r = {};
            if (declared(rule.read)) r.read = LEVEL_READ.includes(rule.read) ? rule.read : 'admin';
            if (declared(rule.write)) r.write = LEVEL_WRITE.includes(rule.write) ? rule.write : 'admin';
            if (Object.keys(r).length) teams[slug] = r;
        }
        return Object.keys(teams).length ? teams : null;
    };
    const out = [];
    for (const c of list){
        const key = c && typeof c.key === 'string' ? c.key.trim() : '';
        if (!key) continue;
        const fields = fieldRules(c.fields);
        const teams = teamRules(c.teams);
        const raw = c.access;
        // No declared access but the entry's OWN levels: kept as declared, never
        // widened to the plain key.
        if (!declared(raw) && (declared(c.read) || declared(c.write))) {
            const entry = {
                key: key
            };
            if (declared(c.read)) entry.read = LEVEL_READ.includes(c.read) ? c.read : 'admin';
            if (declared(c.write)) entry.write = LEVEL_WRITE.includes(c.write) ? c.write : 'admin';
            if ((entry.read === 'scoped' || entry.write === 'scoped') && typeof c.scopeField === 'string' && c.scopeField.trim()) entry.scopeField = c.scopeField.trim();
            if (fields) entry.fields = fields;
            if (teams) entry.teams = teams;
            out.push(entry);
            continue;
        }
        const levels = raw === undefined || raw === null || raw === 'own' ? null : raw === 'own-admin' ? {
            read: 'member',
            write: 'admin'
        } : raw === 'own-rows' ? {
            read: 'member',
            write: 'own'
        } : raw === 'private-rows' ? {
            read: 'own',
            write: 'own'
        } : {
            read: 'member',
            write: 'admin'
        };
        // A field-rule bag or a team map needs the OBJECT entry shape; the levels
        // are the ones the access maps to (a plain key's are member / editor).
        if (fields || teams) out.push({
            key: key,
            ...levels || {
                read: 'member',
                write: 'editor'
            },
            ...fields ? {
                fields: fields
            } : {},
            ...teams ? {
                teams: teams
            } : {}
        });
        else out.push(levels ? {
            key: key,
            ...levels
        } : key);
    }
    return out;
};

});

parcelRegister("dMFBu", function(module, exports) {

$parcel$export(module.exports, "recordsEntryKey", () => $a09007a7d79efa48$export$30ca640b18346f3e);
$parcel$export(module.exports, "upsertWorkspaceApp", () => $a09007a7d79efa48$export$fc5877e4e7b7d3a8);
$parcel$export(module.exports, "removeWorkspaceApp", () => $a09007a7d79efa48$export$cdcb8af53250e893);
$parcel$export(module.exports, "isWorkspaceAppInstalled", () => $a09007a7d79efa48$export$b2716145ed95d0ca);
$parcel$export(module.exports, "installedWorkspaceAppIds", () => $a09007a7d79efa48$export$6d4764126a51f084);
$parcel$export(module.exports, "WS_APP_RECORD_OPS", () => $a09007a7d79efa48$export$52153a317bd14f51);
$parcel$export(module.exports, "fetchDeclaredCollections", () => $a09007a7d79efa48$export$4270e56a063474dd);
$parcel$export(module.exports, "diffDeclaredCollections", () => $a09007a7d79efa48$export$7ad68cb474480c0f);
$parcel$export(module.exports, "applyCollectionsSync", () => $a09007a7d79efa48$export$5d8b650f128c446b);
$parcel$export(module.exports, "appsWritePatch", () => $a09007a7d79efa48$export$3d9fa2cca25b91da);
$parcel$export(module.exports, "isAppsVersionConflict", () => $a09007a7d79efa48$export$ab6dca053bfee5a2);
$parcel$export(module.exports, "writeWorkspaceAppsWithRetry", () => $a09007a7d79efa48$export$c51eb040583b6bd5);
$parcel$export(module.exports, "buildWorkspaceModuleRef", () => $a09007a7d79efa48$export$c2720e074cbe9b07);
// Canonical workspace-module install-ref builder — the ONE place that shapes
// `settings.workspaceModule` and auto-grants an app its declared record
// collections. Consumed by BOTH install paths so the two can't drift:
//   • the /add-app rail        → workspace-shell `workspaceApps.js`
//   • the marketplace install  → `marketplace/functions/index.js` installWorkspaceApp
// (tickets/workspace.md WS-APPS "records-grant" ticket flagged the duplication —
// both were building the identical ref + reading the manifest independently.)
//
// Nothing else writes `capabilities.records` today (WORKSPACE_APPS.md ground
// truth), so an ungranted install would leave the module data bridge with
// nothing to allow — hence the auto-grant here.

var $lUr30 = parcelRequire("lUr30");

var $yREI6 = parcelRequire("yREI6");
const $a09007a7d79efa48$export$30ca640b18346f3e = (e)=>typeof e === 'string' ? e : e && e.key ? String(e.key) : '';
const $a09007a7d79efa48$export$fc5877e4e7b7d3a8 = (list, ref)=>{
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const appId = (r)=>`${lc(r && r.owner)}/${lc(r && r.key)}`;
    const id = appId(ref);
    const out = (Array.isArray(list) ? list : []).filter((r)=>appId(r) !== id);
    out.push(ref);
    return out;
};
const $a09007a7d79efa48$export$cdcb8af53250e893 = (list, { owner: owner, key: key })=>{
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const appId = (r)=>`${lc(r && r.owner)}/${lc(r && r.key)}`;
    const target = `${lc(owner)}/${lc(key)}`;
    return (Array.isArray(list) ? list : []).filter((r)=>appId(r) !== target);
};
const $a09007a7d79efa48$export$b2716145ed95d0ca = (settings, { owner: owner, key: key })=>{
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const appId = (r)=>`${lc(r && r.owner)}/${lc(r && r.key)}`;
    const target = `${lc(owner)}/${lc(key)}`;
    const list = settings && Array.isArray(settings.workspaceApps) ? settings.workspaceApps : [];
    if (list.some((r)=>appId(r) === target)) return true;
    const legacy = settings && settings.workspaceModule;
    return !!(legacy && legacy.installMode === 'app' && appId(legacy) === target);
};
const $a09007a7d79efa48$export$6d4764126a51f084 = (settings)=>{
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const appId = (r)=>`${lc(r && r.owner)}/${lc(r && r.key)}`;
    const ids = new Set();
    const list = settings && Array.isArray(settings.workspaceApps) ? settings.workspaceApps : [];
    for (const r of list)if (r && r.owner && r.key) ids.add(appId(r));
    const legacy = settings && settings.workspaceModule;
    if (legacy && legacy.installMode === 'app' && legacy.owner && legacy.key) ids.add(appId(legacy));
    return [
        ...ids
    ];
};
const $a09007a7d79efa48$export$52153a317bd14f51 = [
    'list',
    'get',
    'create',
    'update',
    'upsert',
    'remove',
    'subscribe'
];
const $a09007a7d79efa48$export$4270e56a063474dd = async (owner, key, { fetchProjectFn: fetchProjectFn, branch: branch, version: version, workspaceId: workspaceId } = {})=>{
    const resolvedFetchProjectFn = fetchProjectFn || (0, $lUr30.fetchProjectFromSDK);
    const location = {};
    if (branch) location.branch = branch;
    if (version) location.version = version;
    if (workspaceId) location.workspaceId = workspaceId;
    try {
        // `raw: true` (security review N2): a manifest read needs plain data only.
        // The default fetch REVIVES every stored project function in this realm
        // (`eval`, side effects run at revive time) - before any tier or audit
        // check, with the installing admin's session.
        const project = await resolvedFetchProjectFn(owner, key, {
            ...location,
            raw: true
        });
        const cfg = project && typeof project.config === 'object' ? project.config : {};
        const manifest = cfg && cfg.manifest === 2 ? cfg : project;
        const cols = manifest && Array.isArray(manifest.collections) ? manifest.collections : [];
        // The server install path's rule, `access` included (collectionGrantsOf.js).
        return (0, $yREI6.collectionGrantsOf)(cols);
    } catch (err) {
        console.warn("[workspaceModuleRef] manifest fetch failed \u2014 no collection grant:", err && err.message);
        return [];
    }
};
const $a09007a7d79efa48$export$7ad68cb474480c0f = (declared, granted)=>{
    const entryKey = (e)=>typeof e === 'string' ? e : e && e.key ? String(e.key) : '';
    const dec = (Array.isArray(declared) ? declared : []).map(entryKey).filter(Boolean);
    const gr = (Array.isArray(granted) ? granted : []).map(entryKey).filter(Boolean);
    return {
        added: dec.filter((c)=>gr.indexOf(c) < 0),
        stale: gr.filter((c)=>dec.indexOf(c) < 0)
    };
};
const $a09007a7d79efa48$export$5d8b650f128c446b = (ref, { add: add = [], prune: prune = [] } = {})=>{
    const entryKey = (e)=>typeof e === 'string' ? e : e && e.key ? String(e.key) : '';
    // Same 7-op default as the exported WS_APP_RECORD_OPS — kept as its own
    // literal (see the FA204 note above `_freshOps`'s old module-scope body).
    const defaultOps = [
        'list',
        'get',
        'create',
        'update',
        'upsert',
        'remove',
        'subscribe'
    ];
    const freshOps = (prevOps)=>Array.isArray(prevOps) && prevOps.length ? [
            ...new Set([
                ...prevOps,
                ...defaultOps
            ])
        ] : defaultOps;
    const base = ref || {};
    const rec = base.capabilities && base.capabilities.records || {
        collections: [],
        ops: defaultOps
    };
    // Entries on the stored grant AND in `add` may be strings or
    // `{ key, read, write }` objects — prune/dedupe compare by KEY so a revoke
    // actually removes an object entry (an identity filter never matches one)
    // and an add can carry its declared levels into the grant verbatim.
    const current = Array.isArray(rec.collections) ? rec.collections : [];
    const pruneSet = new Set((prune || []).map(entryKey).filter(Boolean));
    const kept = current.filter((c)=>!pruneSet.has(entryKey(c)));
    const keptKeys = new Set(kept.map(entryKey));
    // Prune wins over add for the same key (in practice they're disjoint — a
    // collection is either declared-and-ungranted or granted-and-undeclared,
    // never both — but a deterministic tie-break keeps this pure fn sane
    // regardless of what a caller passes).
    const next = [
        ...kept
    ];
    for (const a of add || []){
        const k = entryKey(a);
        if (!k || pruneSet.has(k) || keptKeys.has(k)) continue;
        keptKeys.add(k);
        next.push(a);
    }
    return {
        ...base,
        capabilities: {
            ...base.capabilities || {},
            records: {
                ...rec,
                collections: next,
                ops: freshOps(rec.ops)
            }
        }
    };
};
const $a09007a7d79efa48$export$3d9fa2cca25b91da = (patch, baselineApps)=>({
        ...patch,
        expectedApps: Array.isArray(baselineApps) ? baselineApps : []
    });
const $a09007a7d79efa48$export$ab6dca053bfee5a2 = (err)=>/apps_version_conflict|changed since you read it/i.test(err && err.message || '');
const $a09007a7d79efa48$export$c51eb040583b6bd5 = async (sdk, wsId, currentApps, writeFn)=>{
    const isVersionConflict = (err)=>/apps_version_conflict|changed since you read it/i.test(err && err.message || '');
    try {
        return await writeFn(currentApps);
    } catch (err) {
        if (!isVersionConflict(err)) throw err;
        const fresh = await sdk.getWorkspace(wsId).catch(()=>null);
        const freshApps = fresh && fresh.settings && fresh.settings.workspaceApps || [];
        return await writeFn(freshApps);
    }
};
const $a09007a7d79efa48$export$c2720e074cbe9b07 = async ({ owner: owner, key: key, channel: channel, tier: tier, prevRef: prevRef }, opts = {})=>{
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const appId = (r)=>`${lc(r && r.owner)}/${lc(r && r.key)}`;
    // Same 7-op default as the exported WS_APP_RECORD_OPS — kept as its own
    // literal (see the FA204 note above `_freshOps`'s old module-scope body).
    const defaultOps = [
        'list',
        'get',
        'create',
        'update',
        'upsert',
        'remove',
        'subscribe'
    ];
    const freshOps = (prevOps)=>Array.isArray(prevOps) && prevOps.length ? [
            ...new Set([
                ...prevOps,
                ...defaultOps
            ])
        ] : defaultOps;
    // Self-contained inline copy of fetchDeclaredCollections (a bare
    // sibling-export call is exactly as unresolvable post-frank-serialization
    // as a module-local read; the named export stays live for its own real
    // consumers — workspaceProjects.js/moduleConsole.js/this file's own test
    // suite).
    const fetchDeclared = async (o, k, { fetchProjectFn: fetchProjectFn } = {})=>{
        const resolvedFetchProjectFn = fetchProjectFn || (0, $lUr30.fetchProjectFromSDK);
        try {
            // `raw: true` (security review N2): a manifest read needs plain data only.
            // The default fetch REVIVES every stored project function in this realm
            // (`eval`, side effects run at revive time) - before any tier or audit
            // check, with the installing admin's session.
            const project = await resolvedFetchProjectFn(o, k, {
                raw: true
            });
            const cfg = project && typeof project.config === 'object' ? project.config : {};
            const manifest = cfg && cfg.manifest === 2 ? cfg : project;
            // The app asks for the workspace AI (`ai: true` in its manifest). Read
            // here, in the same manifest read, and honoured below only for a system
            // catalog app.
            aiWanted.value = !!(manifest && manifest.ai === true);
            // The same for the site assistants' admin API (`assistants: true`, the
            // Assistants app): honoured below only for a system catalog app.
            assistantsWanted.value = !!(manifest && manifest.assistants === true);
            const cols = manifest && Array.isArray(manifest.collections) ? manifest.collections : [];
            // The ONE client rule (collectionGrantsOf.js), the same as
            // fetchDeclaredCollections — `access` maps like the server install path.
            return (0, $yREI6.collectionGrantsOf)(cols);
        } catch (err) {
            console.warn("[workspaceModuleRef] manifest fetch failed \u2014 no collection grant:", err && err.message);
            return [];
        }
    };
    const aiWanted = {
        value: false
    };
    const assistantsWanted = {
        value: false
    };
    const collections = await fetchDeclared(owner, key, opts);
    const samePrev = prevRef && appId(prevRef) === appId({
        owner: owner,
        key: key
    }) ? prevRef : null;
    const capabilities = {
        ...samePrev && samePrev.capabilities || {}
    };
    // AI for a CATALOG app that asks for it. `capabilities.ai` used to be
    // operator-hand-written only, so a Socials install from the App Store got an
    // app whose every AI control said "AI capability not granted" and no screen
    // could grant it. A `system`-owned app is curated and trusted by
    // construction (WORKSPACE_APPS.md "Trust model"), the install itself is an
    // owner/admin act, and the server gate on /turn is workspace membership,
    // so this widens nothing a member could not already call. A third-party
    // app's `ai: true` is ignored: its grant stays the operator's decision. A
    // grant already on the ref (hand-written, or revoked to null) is kept.
    if (aiWanted.value && lc(owner) === 'system' && !Object.prototype.hasOwnProperty.call(capabilities, 'ai')) capabilities.ai = {
        granted: 'catalog-install'
    };
    // The assistants bridge (moduleDataBridge `assistants`) opens for a ref whose
    // capabilities.assistants is exactly true. Same trust rule as `ai` above: a
    // system catalog app that asks; a grant already on the ref is kept. The admin
    // API (fly-control) still checks the caller's own project role per assistant,
    // so this grant reveals nothing the member could not read with their session.
    if (assistantsWanted.value && lc(owner) === 'system' && !Object.prototype.hasOwnProperty.call(capabilities, 'assistants')) capabilities.assistants = true;
    if (collections.length) {
        const prevOps = capabilities.records && capabilities.records.ops;
        capabilities.records = {
            collections: collections,
            ops: freshOps(prevOps)
        };
    } else // The manifest no longer declares ANY collections — there is nothing to
    // grant on the records plane, but ai/files/etc. (if any) stay as they were.
    delete capabilities.records;
    return {
        type: 'project',
        owner: owner,
        key: key,
        channel: channel || 'production',
        version: null,
        tier: tier || 'trusted',
        // Both consumers of this builder (marketplace install + /add-app) are
        // "add an app to my workspace" flows — the app must ADD itself (navbar
        // entries appended to the defaults, dashboard panels untouched), never
        // take the workspace over. resolveWorkspaceConfig reads this flag
        // (workspaceConfigs.js app-mode compose). Client-workspace MODULES
        // (admin module console / direct settings writes) carry no flag and
        // keep full-takeover semantics — installing crm-app used to wipe the
        // navbar down to just "Contacts" (2026-07-23).
        installMode: 'app',
        ...Object.keys(capabilities).length ? {
            capabilities: capabilities
        } : {}
    };
};

});

parcelRegister("FZkPK", function(module, exports) {

$parcel$export(module.exports, "assistantModePlaceholder", () => $07e3684eed199771$export$c35451e3df30a5a2);
$parcel$export(module.exports, "assistantModePlaceholderShort", () => $07e3684eed199771$export$f4ea8a3cf4bcf141);
$parcel$export(module.exports, "assistantModePlaceholderTiny", () => $07e3684eed199771$export$eab4f09ae9b00cb7);
$parcel$export(module.exports, "assistantModePlaceholderFit", () => $07e3684eed199771$export$860fd24d3c0f9769);
$parcel$export(module.exports, "assistantModePlaceholderRefit", () => $07e3684eed199771$export$86c67e23248e9605);
$parcel$export(module.exports, "assistantModePlaceholderSettle", () => $07e3684eed199771$export$dcf2fd942ace4f52);
// The composer's placeholder for the AI mode (AI_ASSISTANT_SPEC §8: "placeholder
// per mode, never wrapping: short copy + wider bar") — a polyglot KEY the
// composer translates. el.call('assistantModePlaceholder', root) or a plain call
// with the root state; the mode is the per-user `assistantMode` ('assistant' |
// 'dashboard' | 'tools' | 'apps' | 'presentation' | 'fly', §12.1 — the assistant lane's
// key), 'assistant' when unset. Apps is the FRONTEND app now (a build), so it
// has its own line; Tools works inside the installed platform apps.
// In a call with Fly on, on the call (meet functions/meetFly.js): a Fly, a
// Dashboard and a Presentation ask go to everyone's theater — the line says
// so; meetFlyComposerShared decides. The call's keys are read on EVERY run,
// before any gate (`void` — a tracking read only): the meet function is
// registered only once the call's meet context is folded, and a run that read
// none of them would never re-run when the person joins a call with Fly on.
const $07e3684eed199771$var$_composerAsksTheCall = function(r, m) {
    r.livekitConnected, r.meetFly, r.currentPath, r.meetView;
    if (m !== 'fly' && m !== 'dashboard' && m !== 'presentation') return false;
    const fns = this && this.context && this.context.functions;
    return !!fns && typeof fns.meetFlyComposerShared === 'function' && !!this.call('meetFlyComposerShared', r);
};
const $07e3684eed199771$export$c35451e3df30a5a2 = function(root) {
    const r = root || this && this.state && this.state.root || {};
    const mode = r.assistantMode;
    const fns = this && this.context && this.context.functions;
    const view = fns && typeof fns.assistantEffectiveView === 'function' ? this.call('assistantEffectiveView', r) : null;
    const byView = {
        chat: 'assistant',
        home: 'assistant',
        pages: 'fly',
        build: 'apps',
        present: 'presentation'
    };
    const m = byView[view] || mode;
    const call = $07e3684eed199771$var$_composerAsksTheCall.call(this, r, m);
    if (m === 'dashboard') return call ? 'ai.composer.placeholderDashboardCall' : 'ai.composer.placeholderDashboard';
    if (m === 'tools') return 'ai.composer.placeholderTools';
    if (m === 'apps') return 'ai.composer.placeholderAppsBuild';
    if (m === 'presentation') return call ? 'ai.composer.placeholderPresentationCall' : 'ai.composer.placeholderPresentation';
    if (m === 'fly') return call ? 'ai.composer.placeholderFlyCall' : 'ai.composer.placeholderFly';
    return 'ai.composer.placeholderAssistant';
};
const $07e3684eed199771$export$f4ea8a3cf4bcf141 = function(root) {
    const r = root || this && this.state && this.state.root || {};
    const mode = r.assistantMode;
    const fns = this && this.context && this.context.functions;
    const view = fns && typeof fns.assistantEffectiveView === 'function' ? this.call('assistantEffectiveView', r) : null;
    const byView = {
        chat: 'assistant',
        home: 'assistant',
        pages: 'fly',
        build: 'apps',
        present: 'presentation'
    };
    const m = byView[view] || mode;
    const call = $07e3684eed199771$var$_composerAsksTheCall.call(this, r, m);
    if (m === 'dashboard') return call ? 'ai.composer.placeholderDashboardCallShort' : 'ai.composer.placeholderDashboardShort';
    if (m === 'tools') return 'ai.composer.placeholderToolsShort';
    if (m === 'apps') return 'ai.composer.placeholderAppsBuildShort';
    if (m === 'presentation') return call ? 'ai.composer.placeholderPresentationCallShort' : 'ai.composer.placeholderPresentationShort';
    if (m === 'fly') return call ? 'ai.composer.placeholderFlyCallShort' : 'ai.composer.placeholderFlyShort';
    return 'ai.composer.placeholderAssistantShort';
};
const $07e3684eed199771$export$eab4f09ae9b00cb7 = function(root) {
    const r = root || this && this.state && this.state.root || {};
    const mode = r.assistantMode;
    const fns = this && this.context && this.context.functions;
    const view = fns && typeof fns.assistantEffectiveView === 'function' ? this.call('assistantEffectiveView', r) : null;
    const byView = {
        chat: 'assistant',
        home: 'assistant',
        pages: 'fly',
        build: 'apps',
        present: 'presentation'
    };
    const m = byView[view] || mode;
    if (m === 'dashboard') return 'ai.composer.placeholderDashboardTiny';
    if (m === 'tools') return 'ai.composer.placeholderToolsTiny';
    if (m === 'apps') return 'ai.composer.placeholderAppsBuildTiny';
    if (m === 'presentation') return 'ai.composer.placeholderPresentationTiny';
    if (m === 'fly') return 'ai.composer.placeholderFlyTiny';
    return 'ai.composer.placeholderAssistantTiny';
};
const $07e3684eed199771$export$860fd24d3c0f9769 = function(root, probe) {
    const el = this;
    const r = root || el && el.state && el.state.root || {};
    const long = el.call('polyglot', el.call('assistantModePlaceholder', r));
    let room = probe && typeof probe.room === 'number' ? probe.room : null;
    let width = probe && typeof probe.width === 'function' ? probe.width : null;
    const node = el && el.node;
    let seen = null;
    if ((room === null || !width) && node && node.isConnected && typeof getComputedStyle === 'function') {
        const cs = getComputedStyle(node);
        if (room === null) room = node.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        const font = cs.font || `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
        if (!width && typeof document !== 'undefined') {
            // the font face's load state is part of the key: a measure taken with
            // the fallback face (the brand face still loading) is not reused
            const fonts = typeof document !== 'undefined' ? document.fonts : null;
            seen = long + '|' + room + '|' + font + '|' + (fonts ? fonts.status : '');
            // the face is not loaded yet: measure now, and choose again once it is
            if (fonts && fonts.status !== 'loaded' && fonts.ready && !el.__phFontWait) {
                el.__phFontWait = true;
                fonts.ready.then(()=>{
                    el.__phFontWait = false;
                    if (el.node && el.node.isConnected) el.call('assistantModePlaceholderRefit', r);
                });
            }
            if (el.__phFit && el.__phFit.seen === seen) return el.__phFit.text;
            const cache = globalThis.__placeholderFitCanvas || (globalThis.__placeholderFitCanvas = {});
            if (!cache.ctx) cache.ctx = document.createElement('canvas').getContext('2d');
            const ctx = cache.ctx;
            if (ctx) {
                ctx.font = font;
                width = (t)=>ctx.measureText(t).width;
            }
        }
    }
    if (!(room > 0) || !width) return long;
    // long -> short -> tiny, each by its MEASURED width; nothing at all rather
    // than a cut line (Nika's law: no cut text). Each tier is CHECKED — the
    // short line used to be the fallback unmeasured, and on deploy 9 every
    // Georgian short line was cut in the 390 pill.
    let text = '';
    for (const key of [
        null,
        el.call('assistantModePlaceholderShort', r),
        el.call('assistantModePlaceholderTiny', r)
    ]){
        const line = key === null ? long : el.call('polyglot', key);
        if (typeof line === 'string' && line && width(line) <= room) {
            text = line;
            break;
        }
    }
    if (seen) el.__phFit = {
        seen: seen,
        text: text
    };
    return text;
};
const $07e3684eed199771$export$86c67e23248e9605 = function(root) {
    const el = this;
    const node = el && el.node;
    if (!node || !node.isConnected) return;
    const text = el.call('assistantModePlaceholderFit', root);
    if (typeof text === 'string' && node.getAttribute('placeholder') !== text) node.setAttribute('placeholder', text);
};
const $07e3684eed199771$export$dcf2fd942ace4f52 = function(root) {
    const el = this;
    el.call('assistantModePlaceholderRefit', root);
    const node = el && el.node;
    if (!node || typeof ResizeObserver !== 'function' || el.__phObserved === node) return;
    if (el.__phObserver) el.__phObserver.disconnect();
    el.__phObserved = node;
    const observer = new ResizeObserver(()=>{
        if (!node.isConnected) {
            observer.disconnect();
            if (el.__phObserver === observer) {
                el.__phObserver = null;
                el.__phObserved = null;
            }
            return;
        }
        el.call('assistantModePlaceholderRefit', root);
    });
    el.__phObserver = observer;
    observer.observe(node);
};

});

parcelRegister("8tcVD", function(module, exports) {

$parcel$export(module.exports, "fetchWhitelabelOnboarding", () => $62ab0f80aac8cfbb$export$5efc3eb89cbca9b);
$parcel$export(module.exports, "submitWhitelabelOnboarding", () => $62ab0f80aac8cfbb$export$8680405a0eb5fcc7);
// Public onboarding for a white-label custom domain — the "request an
// invitation" half of the branded gate.
//
// ── Why this is a REQUEST, not a sign-up ─────────────────────────────────
// The Bellforge landing states it outright: "An invitation, not a password
// form." Nobody creates credentials here. This posts to the platform's
// generic public-onboarding surface (`/core/onboarding/*`), which mints a
// workspace INVITATION; accepting that invitation is what creates the
// account. Building a password sign-up instead would have been a second
// account-creation path for the same org, diverging from the landing the
// user asked us to match.
//
// ── Why the role list is fetched, never hardcoded ────────────────────────
// `role` is an ALLOWLIST INDEX into the org's own
// `workspace.settings.publicOnboarding.roles` — the server matches the key
// case-insensitively and applies the teams from ITS config, never from our
// payload. So the client cannot grant itself anything, and "every type
// except admin" is enforced server-side by the org's config (the four
// published roles are searcher/investor/institution/advisor — admin is
// simply not in the allowlist) rather than by a filter we could get wrong.
// Fetching the list also means a copy change on the org needs no redeploy.
//
// Both functions are `this`-bound methods (`el.call(...)`) and neither ever
// throws: a dead endpoint must leave the branded gate usable, not strand it.
// The tenant's display name, read from the SAME pre-auth brand record the
// panes render from (`root.whitelabelBrand`, resolved by
// workspace/functions/whitelabelBrand.js). This shared file must never carry
// a tenant literal: the next white-label org gets its own name with no
// deploy (DESIGN-WHITELABEL-SHARED-FILES-REVIEW-1).
const $62ab0f80aac8cfbb$var$_brandNameOf = (el)=>{
    const b = el && el.state && el.state.root && el.state.root.whitelabelBrand;
    return b && b.name ? String(b.name).trim() : '';
};
const $62ab0f80aac8cfbb$export$5efc3eb89cbca9b = async function(opts = {}) {
    const el = this;
    const win = opts.win || (typeof window !== 'undefined' ? window : null);
    const workspaceKey = String(opts.workspaceKey || '').trim();
    if (!workspaceKey) return null;
    const apiBase = String(opts.apiBase || (el && el.call ? el.call('workspaceApiBase') : '') || '').replace(/\/+$/, '');
    const fetchImpl = opts.fetchImpl || (win && typeof win.fetch === 'function' ? win.fetch.bind(win) : null);
    if (!apiBase || typeof fetchImpl !== 'function') return null;
    try {
        const res = await fetchImpl(`${apiBase}/core/onboarding/options?workspace=${encodeURIComponent(workspaceKey)}`, // Credential-less like the brand and persona reads: a logged-out
        // visitor must be able to resolve this, and it must not depend on
        // whatever session the browser already carries.
        {
            credentials: 'omit'
        });
        if (!res || !res.ok) return null;
        const body = await res.json().catch(()=>null);
        if (!body || body.enabled !== true) return null;
        const roles = (Array.isArray(body.roles) ? body.roles : []).filter((r)=>r && typeof r.key === 'string' && r.key.trim() && r.label).map((r)=>({
                key: String(r.key).trim(),
                label: String(r.label),
                description: r.description ? String(r.description) : ''
            }));
        if (!roles.length) return null;
        // `captcha` is present only when the org requires one. The site key is
        // public by construction (it ships in any client that renders the
        // widget); the secret never leaves the server.
        const captcha = body.captcha && body.captcha.siteKey ? {
            provider: String(body.captcha.provider || ''),
            siteKey: String(body.captcha.siteKey)
        } : null;
        return {
            roles: roles,
            captcha: captcha
        };
    } catch (_) {
        return null;
    }
};
const $62ab0f80aac8cfbb$export$8680405a0eb5fcc7 = async function(payload = {}, opts = {}) {
    const el = this;
    const win = opts.win || (typeof window !== 'undefined' ? window : null);
    const name = String(payload.name || '').trim();
    const email = String(payload.email || '').trim();
    const role = String(payload.role || '').trim();
    const workspaceKey = String(payload.workspaceKey || '').trim();
    // Validate in the order the form reads top-to-bottom, so the message
    // points at the first field the visitor still has to fix.
    if (!role) return {
        ok: false,
        message: el.call('polyglot', 'auth.whitelabel.needRole')
    };
    if (!name) return {
        ok: false,
        message: el.call('polyglot', 'auth.whitelabel.needName')
    };
    // Shape only — the server is the authority. This exists to save a
    // round-trip on an obvious typo, not to be a second validator.
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return {
        ok: false,
        message: el.call('polyglot', 'auth.whitelabel.needEmail')
    };
    const apiBase = String(opts.apiBase || (el && el.call ? el.call('workspaceApiBase') : '') || '').replace(/\/+$/, '');
    const fetchImpl = opts.fetchImpl || (win && typeof win.fetch === 'function' ? win.fetch.bind(win) : null);
    if (!apiBase || !workspaceKey || typeof fetchImpl !== 'function') return {
        ok: false,
        message: el.call('polyglot', 'auth.whitelabel.signupUnavailable')
    };
    try {
        const res = await fetchImpl(`${apiBase}/core/onboarding/request`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'omit',
            body: JSON.stringify({
                workspace: workspaceKey,
                name: name,
                email: email,
                role: role,
                captchaToken: payload.captchaToken || undefined
            })
        });
        const body = await res.json().catch(()=>null);
        if (res.ok && body && body.ok) {
            // The server reports whether the mail actually went out. Saying
            // "check your inbox" when `emailSent` is false would send someone to
            // watch a mailbox nothing was sent to.
            if (body.emailSent === false) return {
                ok: true,
                message: el.call('polyglot', 'auth.whitelabel.requestReceived')
            };
            if (body.alreadyInvited) return {
                ok: true,
                message: el.call('polyglot', 'auth.whitelabel.alreadyInvited')
            };
            // The org's name comes from the live brand record, never a literal —
            // the fallback keeps the sentence whole for a caller with no brand in
            // state (tests, degenerate mounts).
            const brandName = $62ab0f80aac8cfbb$var$_brandNameOf(el);
            return {
                ok: true,
                message: brandName ? el.call('polyglot', 'auth.whitelabel.inboxBranded').replace('{brand}', brandName) : el.call('polyglot', 'auth.whitelabel.inbox')
            };
        }
        // Map only what a visitor can act on. Everything else collapses to one
        // message: the endpoint deliberately refuses without enumerating (a
        // 404 means "no config OR disabled OR unknown workspace" and must not
        // be decoded), so guessing on their behalf would be a false statement.
        const code = body && body.error || '';
        const status = res.status;
        if (code === 'invalid_email') return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.needEmail')
        };
        if (code === 'invalid_role') return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.needValidOption')
        };
        if (code === 'captcha_failed') return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.needCaptcha')
        };
        if (code === 'captcha_unavailable') return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.captchaDown')
        };
        if (status === 429) return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.tooMany')
        };
        if (status === 404) return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.signupSoon')
        };
        return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.genericError')
        };
    } catch (_) {
        return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.networkError')
        };
    }
};

});

parcelRegister("5kIsd", function(module, exports) {

$parcel$export(module.exports, "TURNSTILE_SCRIPT_SRC", () => $3e214da9995a5dc8$export$964423d0a80d26e4);
$parcel$export(module.exports, "ensureTurnstileApi", () => $3e214da9995a5dc8$export$6056028ceb470b14);
$parcel$export(module.exports, "mountWhitelabelTurnstile", () => $3e214da9995a5dc8$export$fd4f54b049db7bb);
$parcel$export(module.exports, "resetWhitelabelTurnstile", () => $3e214da9995a5dc8$export$a385395d9ddb87ed);
$parcel$export(module.exports, "removeWhitelabelTurnstile", () => $3e214da9995a5dc8$export$951485c71f1e15fb);
// The captcha half of the white-label public-onboarding gate — the widget
// side of `whitelabelOnboarding.js` (WS-SHELL-PANES-RENDER-TURNSTILE-WIDGET-1).
//
// ── What the server decides, and what we only obey ───────────────────────
// `GET /core/onboarding/options` returns `captcha: { provider, siteKey }`
// ONLY when the org requires one AND the environment resolves a provider.
// The site key is therefore READ FROM THAT RESPONSE and never written down
// here: a second org, a second environment, or a rotated key must need no
// redeploy. No site key in state → no widget, and the pane behaves exactly
// as it did before captcha existed.
//
// ── Why an EXPLICIT render, never the implicit one ───────────────────────
// Turnstile's implicit mode auto-scans the document for `.cf-turnstile` at
// script load. That scan races DOMQL insertion: the script and the element
// both arrive, the scan has already run, and NO iframe ever appears
// (measured on the landing rollout). So the script is loaded with
// `render=explicit` and `turnstile.render(node, …)` is called by hand once
// the API object exists — hence the poll in `ensureTurnstileApi`.
//
// ── Why a document-injected <script> ─────────────────────────────────────
// Turnstile ships one classic script on Cloudflare's own origin, which must
// stay on that origin to work. There is no importmap or ESM entry to route
// it through, so the injection lives HERE — one library function with `win`
// and `doc` injected — instead of in any component. Components stay
// declarative and every branch below is exercised without a browser.
const $3e214da9995a5dc8$export$964423d0a80d26e4 = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
// One in-flight load per window, so a pane that mounts the widget twice (or
// two panes on one page) share a single script and a single poll.
const $3e214da9995a5dc8$var$_apiByWin = new WeakMap();
// An EXPLICIT `win: null` means "no browser here" and is honoured as such —
// `opts.win || window` would have fallen back to the global and, under a
// test runner that shares one process, quietly polled a shim window for ten
// seconds. Only an ABSENT key falls back.
const $3e214da9995a5dc8$var$_winOf = (opts)=>opts.win === undefined ? typeof window !== 'undefined' ? window : null : opts.win;
const $3e214da9995a5dc8$var$_docOf = (opts, win)=>opts.doc === undefined ? win && win.document || (typeof document !== 'undefined' ? document : null) : opts.doc;
const $3e214da9995a5dc8$var$_apiOf = (win)=>{
    const api = win && win.turnstile;
    return api && typeof api.render === 'function' ? api : null;
};
const $3e214da9995a5dc8$var$_siteKeyOf = (s)=>{
    const c = s && s.onboardingCaptcha;
    const key = c && c.siteKey ? String(c.siteKey).trim() : '';
    return key || '';
};
const $3e214da9995a5dc8$export$6056028ceb470b14 = async function(opts = {}) {
    const win = $3e214da9995a5dc8$var$_winOf(opts);
    const doc = $3e214da9995a5dc8$var$_docOf(opts, win);
    if (!win || !doc) return null;
    const ready = $3e214da9995a5dc8$var$_apiOf(win);
    if (ready) return ready;
    const pending = $3e214da9995a5dc8$var$_apiByWin.get(win);
    if (pending) return pending;
    const src = String(opts.src || $3e214da9995a5dc8$export$964423d0a80d26e4);
    const timeoutMs = Number(opts.timeoutMs > 0 ? opts.timeoutMs : 10000);
    const stepMs = Number(opts.stepMs > 0 ? opts.stepMs : 50);
    const wait = opts.wait || ((ms)=>new Promise((resolve)=>setTimeout(resolve, ms)));
    const now = opts.now || (()=>Date.now());
    const load = (async ()=>{
        try {
            const already = typeof doc.querySelector === 'function' ? doc.querySelector(`script[src="${src}"]`) : null;
            if (!already) {
                const target = doc.head || doc.body;
                if (!target || typeof target.appendChild !== 'function') return null;
                const tag = doc.createElement('script');
                tag.src = src;
                tag.async = true;
                tag.defer = true;
                target.appendChild(tag);
            }
            const deadline = now() + timeoutMs;
            // Poll rather than trust `onload`: the API object is published a tick
            // AFTER the script's load event on some builds, and an `already`
            // script may have loaded long before we asked.
            for(;;){
                const api = $3e214da9995a5dc8$var$_apiOf(win);
                if (api) return api;
                if (now() >= deadline) return null;
                await wait(stepMs);
            }
        } catch (_) {
            return null;
        }
    })();
    $3e214da9995a5dc8$var$_apiByWin.set(win, load);
    const api = await load;
    // A failed load must not poison the next attempt (a remount, or a network
    // that came back), so only a SUCCESS stays cached.
    if (!api) $3e214da9995a5dc8$var$_apiByWin.delete(win);
    return api;
};
const $3e214da9995a5dc8$export$fd4f54b049db7bb = async function(opts = {}) {
    const el = this;
    const s = opts.state || el && el.state || null;
    const node = opts.node || el && el.node || null;
    if (!s || !node) return null;
    // WAIT for the site key instead of bailing (bounded). The options call
    // lands AFTER first paint, and this shell runtime re-runs child FACTORIES
    // on the pane's state write without firing the child's own `onUpdate` —
    // measured live on app.bellforge.eu 2026-08-31: the slot div stood
    // display:block with the config parked in state, and no script was ever
    // injected because the only mount attempt ran pre-config and returned.
    // Polling the SHARED state object here needs no lifecycle at all. The
    // per-instance latch below still collapses concurrent pollers.
    let siteKey = $3e214da9995a5dc8$var$_siteKeyOf(s);
    if (!siteKey) {
        const wait = opts.wait || ((ms)=>new Promise((resolve)=>setTimeout(resolve, ms)));
        const now = opts.now || (()=>Date.now());
        const keyTimeoutMs = Number(opts.keyTimeoutMs > 0 ? opts.keyTimeoutMs : 15000);
        const keyStepMs = Number(opts.keyStepMs > 0 ? opts.keyStepMs : 250);
        const deadline = now() + keyTimeoutMs;
        for(;;){
            await wait(keyStepMs);
            siteKey = $3e214da9995a5dc8$var$_siteKeyOf(s);
            if (siteKey) break;
            if (now() >= deadline) return null;
        }
    }
    // Per-instance latch (set BEFORE the await): `onRender` and `onUpdate`
    // both call this, and the state write that reveals the widget lands while
    // the script is still loading.
    const scope = el && el.scope || null;
    if (scope) {
        if (scope.turnstileSiteKey === siteKey) return scope.turnstileWidgetId || null;
        scope.turnstileSiteKey = siteKey;
    }
    const api = await $3e214da9995a5dc8$export$6056028ceb470b14(opts);
    if (!api) {
        if (scope) scope.turnstileSiteKey = null;
        return null;
    }
    const park = (token)=>s.update({
            captchaToken: token ? String(token) : ''
        }, {
            preventUpdate: true
        });
    try {
        const widgetId = api.render(node, {
            sitekey: siteKey,
            // Managed mode usually issues the token INVISIBLY — no checkbox and no
            // visible challenge. This callback is the only proof it worked.
            callback: (token)=>park(token),
            // A token dies after ~5 minutes and after one use. Clearing it here
            // keeps the pane honest: a stale token would 400 as `captcha_failed`.
            'expired-callback': ()=>park(''),
            'timeout-callback': ()=>park(''),
            'error-callback': ()=>park('')
        });
        if (scope) scope.turnstileWidgetId = widgetId;
        s.update({
            captchaWidgetId: widgetId || null
        }, {
            preventUpdate: true
        });
        return widgetId || null;
    } catch (_) {
        if (scope) scope.turnstileSiteKey = null;
        return null;
    }
};
const $3e214da9995a5dc8$export$a385395d9ddb87ed = function(opts = {}) {
    const el = this;
    const s = opts.state || el && el.state || null;
    const win = $3e214da9995a5dc8$var$_winOf(opts);
    const widgetId = opts.widgetId || s && s.captchaWidgetId || el && el.scope && el.scope.turnstileWidgetId;
    if (s) s.update({
        captchaToken: ''
    }, {
        preventUpdate: true
    });
    const api = win && win.turnstile;
    if (!api || typeof api.reset !== 'function' || !widgetId) return false;
    try {
        api.reset(widgetId);
        return true;
    } catch (_) {
        return false;
    }
};
const $3e214da9995a5dc8$export$951485c71f1e15fb = function(opts = {}) {
    const el = this;
    const s = opts.state || el && el.state || null;
    const win = $3e214da9995a5dc8$var$_winOf(opts);
    const scope = el && el.scope || null;
    const widgetId = opts.widgetId || scope && scope.turnstileWidgetId || s && s.captchaWidgetId;
    if (scope) {
        scope.turnstileWidgetId = null;
        scope.turnstileSiteKey = null;
    }
    const api = win && win.turnstile;
    if (!api || typeof api.remove !== 'function' || !widgetId) return false;
    try {
        api.remove(widgetId);
        return true;
    } catch (_) {
        return false;
    }
};

});

parcelRegister("hZBHz", function(module, exports) {

$parcel$export(module.exports, "whitelabelPersonaSignin", () => $d19560f75ddf498c$export$9575d044efea4232);
// whitelabelSignin.js — the persona sign-in buttons' action, WHITE-LABEL
// HOSTS ONLY (WHITELABEL-BRANDED-BOOT-1, tickets/opus.md).
//
// Nika asked for a branded login with "pre-made user sign-ins" — Admin /
// Searcher / Investor buttons that sign in as a pre-provisioned user.
//
// ⚠️ Registered ONLY behind `isCustomDomainHost()` (context.js), same gate as
// the branded components, per Nika 2026-08-19: "do not change anything for
// symbols — this is for bellforge workspace gate only."
//
// ── The client never names a user ────────────────────────────────────────
// It sends a persona KEY ('admin' | 'searcher' | …) and the HOST. The server
// maps key → pre-provisioned user from the org's own record and refuses
// unless every gate holds (non-production channel, org flag on, verified
// custom domain, known key). Nothing here can select an arbitrary account,
// which is the same invariant the PersonaSession model states for role
// simulation: no client-supplied field may name a target user.
//
// ── No invented auth path ────────────────────────────────────────────────
// The response is the `/demo/start` envelope, and the session is handed to
// the SDK through ITS OWN documented storage contract
// (`TokenManager.storageKeys`) plus a full reload — the SDK's hydration path,
// not a second auth scheme. See the note at the persistence step for why
// this deliberately avoids `sdk._tokenManager` even though it now resolves.
/**
 * Sign in as one of the org's pre-provisioned personas.
 *
 * Called from the branded login as
 * `el.call('whitelabelPersonaSignin', personaKey)`.
 *
 * Resolves `{ ok: true }` after kicking a full-page load, or
 * `{ ok: false, message }` — never throws, so a refused persona leaves the
 * login usable instead of stranding it.
 */ const $d19560f75ddf498c$export$9575d044efea4232 = async function(persona, opts = {}) {
    const el = this;
    const win = opts.win || (typeof window !== 'undefined' ? window : null);
    const key = typeof persona === 'string' ? persona.trim() : '';
    if (!key || !win || !win.location) return {
        ok: false,
        message: el.call('polyglot', 'auth.whitelabel.unavailable')
    };
    const apiBase = String(opts.apiBase || (el?.call ? el.call('workspaceApiBase') : '') || '').replace(/\/+$/, '');
    const fetchImpl = opts.fetchImpl || (typeof win.fetch === 'function' ? win.fetch.bind(win) : null);
    if (!apiBase || typeof fetchImpl !== 'function') return {
        ok: false,
        message: el.call('polyglot', 'auth.whitelabel.unavailable')
    };
    let data = null;
    try {
        const res = await fetchImpl(`${apiBase}/core/organizations/whitelabel-signin`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            // No credentials: this mints a NEW session; it must not depend on,
            // or send, whatever session the browser already carries.
            credentials: 'omit',
            body: JSON.stringify({
                host: win.location.hostname,
                persona: key
            })
        });
        const body = await res.json().catch(()=>null);
        if (!res.ok || !body || !body.success || !body.data) // The server refuses uniformly and without enumerating — mirror that
        // here rather than surfacing a reason the server deliberately withheld.
        return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.signinUnavailable')
        };
        data = body.data;
    } catch (_) {
        return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.signinUnavailable')
        };
    }
    const accessToken = data.accessToken;
    const refreshToken = data.refreshToken;
    if (!accessToken) return {
        ok: false,
        message: el.call('polyglot', 'auth.whitelabel.signinUnavailable')
    };
    // ── Persisting the session ───────────────────────────────────────────
    // `sdk._tokenManager` now resolves on the SDK root (assigned at the end
    // of `initialize()`, sdk/src/index.js) as of sdk@f73e6c8
    // (SDK-TOKENMANAGER-ROOT-1; see sdk/src/services/tests/SDK/
    // tokenManager-root.test.js) — it used to be a field that only existed
    // per-service (BaseService.js), so the root read undefined and every
    // reader of it, including this handler's earlier version, silently
    // failed. `magic-callback.js` and `packages/meet/functions/
    // mintLivekitToken.js` read the same root field and are expected to work
    // now too. The `invalidateClaims` guards this file used to warn about
    // are gone as of sdk@e211dc6 (SDK-INVALIDATECLAIMS-DEAD-GUARD-1) — there
    // was never a claim cache to invalidate.
    //
    // This handler still avoids `sdk._tokenManager` on purpose: going
    // through the SDK's OWN storage contract instead (`TokenManager.
    // storageKeys`, prefix `symbols_`, no consumer overrides it) lets the
    // reload below rebuild the session via the SDK's documented hydration
    // path, rather than reaching into a service-owned singleton directly.
    // Verified end to end on the deployed host. `expires_at` is epoch ms,
    // matching what `saveTokens()` writes and what the server sends as
    // `accessExp`.
    try {
        // Off `win`, not the global: identical object in a browser, and it keeps
        // the storage seam injectable like `win`/`fetchImpl` already are — so a
        // test can assert the REAL keys instead of stubbing an SDK internal.
        const store = opts.storage || win.localStorage || null;
        if (!store) return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.unavailable')
        };
        store.setItem('symbols_access_token', accessToken);
        if (refreshToken) {
            store.setItem('symbols_refresh_token', refreshToken);
            // A sign-in on this origin: its refresh token is its own (review D1).
            store.setItem('symbols_session_source', 'own');
        }
        const accessExp = data.accessExp ? Number(data.accessExp) : null;
        if (accessExp) {
            store.setItem('symbols_expires_at', String(accessExp));
            store.setItem('symbols_expires_in', String(Math.max(0, Math.floor((accessExp - Date.now()) / 1000))));
        }
    } catch (_) {
        return {
            ok: false,
            message: el.call('polyglot', 'auth.whitelabel.unavailable')
        };
    }
    // Full-page load, not a router push — the same deliberate choice
    // `pages/demo.js` makes after `startDemo`: boot must re-run from scratch so
    // every scope fetch, the workspace resolve and the branded loader all see
    // the new session, instead of a half-rescoped SPA.
    try {
        win.location.assign('/');
    } catch (_) {}
    return {
        ok: true
    };
};

});

parcelRegister("1guEp", function(module, exports) {

$parcel$export(module.exports, "shellOverlayOpen", () => $0ebf0fab32af8beb$export$6025dbfade33efe7);
// THE SHELL'S OVERLAY LAYERS — the windows ModalRoot stack, the DropdownRoot
// layer, the open header search and, in the workspace shell, the assistant's
// MAIN LAYER over a page (read, never written). Returns 'modalRoot' |
// 'dropdown' | 'phoneNav' | 'mobileRail' | 'search' | 'mainThread' | null.
// Read the top layer first. THE ONE reader for every LOWER keyboard layer that must stand down
// while an overlay sits above it: the workspace shortcut guard
// (functions/shortcuts.js shortcutBlockReason), the home customize drawer's
// Escape (pages/main.js) and the marketplace's document keys (marketplace
// functions/index.js registerEscHandler) — a lower layer that spent the
// Escape first would close itself AND leave (with the windows plugin's "a
// modal ignores an Escape a layer above it already spent") or also close
// (without it) the dialog on top.
//
// It lives in the shared kit so EVERY host reaches the same one through its
// registry: the workspace shell and the standalone marketplace
// (marketplace.localhost loads this kit through its sharedLibraries, never the
// workspace functions — with the reader in the workspace only, one Escape
// closed its detail pane under an open install confirm). Moved from workspace
// functions/shortcuts.js (b919b1703).
//
// THE MAIN LAYER (AI_ASSISTANT_SPEC §12.2): with the main placement the
// assistant's thread (or a generated board, a live deck) opens OVER the page
// of any route. While it is the top layer over the page, the page's own
// Escape stands down — ONE Escape closes the thread and the page is back. The
// workspace shell answers it (functions/assistantMainThread.js
// `assistantMainLayerOpen`); a host that registers no such function has no
// such layer. It sits BELOW the layers above, which are read first.
//
// `el.call('shellOverlayOpen')` (this = the element) or with a host / element.
function $0ebf0fab32af8beb$export$6025dbfade33efe7(el) {
    const origin = el || this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    const stack = host && host.ModalRoot && host.ModalRoot.state && host.ModalRoot.state.stack;
    if (stack && stack.length > 0) return 'modalRoot';
    if (host && host.DropdownRoot && host.DropdownRoot.state && host.DropdownRoot.state.layer) return 'dropdown';
    // THE HEADER SEARCH (root `_headerSearchOpen`): the search morph sits above
    // the page. Its Escape (HeaderTabs / HeaderSearch) and a page layer's Escape
    // (the home customize drawer) are both document listeners, armed in MOUNT
    // order — when the drawer ran first it closed itself and left the search
    // open (live, dev 3efc1eace, 2026-09-30). A lower layer that asks stands
    // down; the search closes first. Read after the two layers above, which can
    // open over the search.
    const st = origin && origin.state || host && host.state;
    const rootState = st && st.root || st;
    if (rootState?._isPhoneViewport === true) {
        // The phone navigation dialog sits above the page rail and the header.
        // Desktop ignores old phone flags, including during rotation teardown.
        if (rootState._phoneNavPanel) return 'phoneNav';
        const railOpen = [
            '_calRailOpen',
            '_meetRailOpen',
            '_chatSidebarOpen',
            '_docsRailOpen',
            '_ticketsRailOpen',
            '_filesRailOpen',
            '_mailRailOpen',
            '_moduleRailOpen'
        ].some((key)=>!!rootState[key]);
        // A direct rail occupies the 1400 band, above header search (1360).
        // A rail inside PageSlot is capped by the pane's 1300 context, so an
        // open header search owns Escape there. The launcher portal is higher
        // than both and already returned 'dropdown' above.
        const paneOpen = rootState._canvasSlot || rootState._canvasSlotSecond;
        if (railOpen && !(paneOpen && rootState._headerSearchOpen)) return 'mobileRail';
    }
    if (rootState && rootState._headerSearchOpen) return 'search';
    // THE MAIN LAYER: the lowest of the four — the search (navbar chrome) and
    // the two layers above all sit over it.
    const fns = host && host.context && host.context.functions;
    if (fns && typeof fns.assistantMainLayerOpen === 'function' && typeof host.call === 'function' && host.call('assistantMainLayerOpen', host)) return 'mainThread';
    return null;
}

});

parcelRegister("9YPeu", function(module, exports) {

$parcel$export(module.exports, "closeHeaderSearch", () => $7441756b74100e78$export$77e2362d3cc00e23);
// THE HEADER SEARCH ENDS HERE — the writes a close of the open search makes
// (AppHeader › HeaderSearch: the morph shown while root `_headerSearchOpen` is
// true). N2 (Nika 2026-10-27, "fix navbar search button click on workspace for
// both left and top navbar modes"): two closes the header promised never
// existed, and both land here:
//   - a press outside the open search (AppHeader › HeaderSearch
//     `onDocumentMousedown`) passes `returnFocusTo: null` — focus follows the
//     press and is never pulled back to the button;
//   - a second press of the search button (HeaderTabs › SearchBtn) passes its
//     own node — the morph's close edge (AppHeader focusSearchOnOpen) hands
//     focus back to it.
// Without `returnFocusTo` the target the opener stored stays. The results and
// the launcher end through the shell's `closeNavSearch` (the workspace's
// functions/search/globalSearch.js), reached through `this.call` and
// availability-checked: a host without it closes the morph alone. The two
// state writes are the Close X's own.
// el.call('closeHeaderSearch', { returnFocusTo }) → whether it closed.
function $7441756b74100e78$export$77e2362d3cc00e23(opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || !root._headerSearchOpen || typeof root.update !== 'function') return false;
    if (opts && typeof opts === 'object' && 'returnFocusTo' in opts) root.__headerSearchReturnFocusTo = opts.returnFocusTo || null;
    if (typeof el?.context?.functions?.closeNavSearch === 'function') try {
        el.call('closeNavSearch');
    } catch (err) {
        console.warn('[closeHeaderSearch] closeNavSearch failed:', err);
    }
    root.update({
        _headerSearchOpen: false,
        _navSearchOpen: false
    });
    return true;
}

});

parcelRegister("bWtfD", function(module, exports) {

$parcel$export(module.exports, "glyphNameFor", () => $8b1bcd255ecdcb0a$export$3b703cba9c9e7707);
$parcel$export(module.exports, "appRouteIsCurrent", () => $8b1bcd255ecdcb0a$export$85259eb3a0644085);
// THE GLYPH NAME (dropdowns spec 2026-09-30 §3.3, §12) — one answer for every surface that shows an app glyph:
// the search launcher (the PIXEL set, `px`) and the navigation (the LINE set, `ln`: the navbar tabs and the home
// App strip in both looks). A tile names its glyph (`glyph`, a key of scripts/gen-glyph-icons.mjs: a built-in
// row, or a module app in its OWN manifest); a route the redesign drew answers next; anything else wears the
// line-set fallback (`apps`, the installed-app glyph). Manifest data is never trusted as a name: only a bare key is read, and only
// when the element's design system carries that glyph. The route map lives INSIDE the function (frank: no
// module-scope capture). Called as el.call('glyphNameFor', { glyph, route, icon }, 'ln' | 'px').
function $8b1bcd255ecdcb0a$export$3b703cba9c9e7707(tile, set) {
    const t = tile || {};
    const prefix = set === 'ln' ? 'ln' : 'px';
    const icons = this && this.context && this.context.designSystem && this.context.designSystem.icons;
    const nameOf = (key)=>prefix + key[0].toUpperCase() + key.slice(1);
    const usable = (key)=>typeof key === 'string' && /^[a-z][A-Za-z0-9]*$/.test(key) && (!icons || !!icons[nameOf(key)]);
    if (usable(t.glyph)) return nameOf(t.glyph);
    const byRoute = {
        '/': 'home',
        '/studio': 'studio',
        '/infra': 'infra',
        '/terminal': 'terminal',
        '/tasks': 'tasks',
        '/notes': 'notes',
        '/files': 'files',
        '/chat': 'chat',
        '/mail': 'mail',
        '/calendar': 'calendar',
        '/meet': 'meet',
        '/reminders': 'reminders',
        '/bookmarks': 'bookmarks',
        '/history': 'history',
        '/announcements': 'broadcast',
        '/team-and-agents': 'teamAndAgents',
        '/agents': 'agents',
        '/team-members': 'teamMembers',
        '/analytics': 'analytics',
        '/workspace-analytics': 'usage',
        '/system-status': 'health',
        '/crm': 'crm',
        '/realestate': 'realestate',
        '/jobs': 'jobs'
    };
    const path = String(t.route || '').split('?')[0].split('#')[0];
    const top = path === '/' ? '/' : '/' + (path.split('/').filter(Boolean)[0] || '');
    const routeKey = byRoute[top === '/' && path !== '/' ? '' : top];
    if (usable(routeKey)) return nameOf(routeKey);
    // A MODULE APP'S OWN WORDS (Nika 2026-10-23: "make better icons" — the icon navbar drew Payments and Risk as the
    // same app window): its route's segments, the LAST first (/keepz/risk is about risk), then the words of its name
    // and its app key, read against a fixed table of HOUSE glyphs — so the ruling below still holds: no module app
    // wears an icon of its own drawing, and no manifest text is ever taken as a name.
    const WORDS = {
        payments: 'payment payments pay payroll billing checkout transaction transactions card cards wallet finance merchant merchants payout payouts acquiring',
        risk: 'risk risks fraud compliance security alert alerts dispute disputes chargeback chargebacks aml kyc',
        orders: 'order orders sales sale cart purchase purchases',
        inventory: 'inventory warehouse warehouses stock products product catalog catalogue items shipments shipping logistics delivery',
        invoices: 'invoice invoices receipt receipts bill bills accounting expense expenses ledger',
        store: 'store stores shop shops storefront marketplace listing listings commerce ecommerce',
        support: 'support helpdesk service desk inbox',
        analytics: 'report reports reporting insights insight metrics stats statistics kpi kpis',
        crm: 'leads lead deals deal pipeline prospects',
        users: 'contacts contact customers customer clients client people members member hr employees staff partners',
        calendar: 'booking bookings appointment appointments schedule scheduling events reservation reservations',
        notes: 'docs documents document wiki knowledge pages cms content blog articles posts',
        chat: 'messages messaging conversations conversation chats',
        mail: 'email emails newsletter newsletters campaign campaigns',
        tools: 'settings setting config configuration preferences setup',
        jobs: 'careers recruiting hiring applicants vacancies',
        realestate: 'properties property units unit buildings rentals rent leases',
        health: 'status uptime incidents',
        database: 'data records tables datasets',
        lock: 'permissions access roles',
        broadcast: 'announcements news marketing promotions',
        tasks: 'todo todos projects project issues production',
        files: 'storage media assets uploads drive',
        meet: 'calls call meetings meeting video'
    };
    const words = [];
    const segments = path.split('/').filter(Boolean);
    for(let i = segments.length - 1; i >= 0; i--)words.push(segments[i]);
    for (const text of [
        t.label,
        t.title,
        t.name,
        t.appKey,
        t.key
    ])if (typeof text === 'string' && !text.includes('.')) words.push(...text.split(/[\s_\-/]+/));
    for (const raw of words){
        const w = String(raw || '').toLowerCase();
        if (!w) continue;
        for (const key of Object.keys(WORDS)){
            if (WORDS[key].split(' ').includes(w) && usable(key)) return nameOf(key);
        }
    }
    // THE INSTALLED-APP GLYPH (coordinator ruling 2026-10-02): a tile with no valid
    // glyph — a module app whose manifest names none, or names one the line set
    // lacks — wears the ONE `apps` glyph (an app window), never its own foreign
    // icon. Only a design system that carries no glyph set at all keeps the icon.
    if (usable('apps')) return nameOf('apps');
    return t.icon || 'star';
}
function $8b1bcd255ecdcb0a$export$85259eb3a0644085(route, root) {
    const r = String(route || '').split('?')[0];
    if (!r || r === '/') return false;
    const rt = root || {};
    const slot = rt._canvasSlot ? String(rt._canvasSlot).split('?')[0] : '';
    const path = slot || String(rt.currentPath || '').replace(/^\/w\/[a-z0-9-]{1,48}(?=\/|$)/, '').split('?')[0];
    return path === r || path.startsWith(r + '/');
}

});


parcelRegister("dyqu6", function(module, exports) {

var $6c2sG = parcelRequire("6c2sG");

var $7CuOt = parcelRequire("7CuOt");

var $girqX = parcelRequire("girqX");

var $8DDsD = parcelRequire("8DDsD");

var $jjMOM = parcelRequire("jjMOM");

var $9Lyx0 = parcelRequire("9Lyx0");

var $l4Kfs = parcelRequire("l4Kfs");

var $kL2H3 = parcelRequire("kL2H3");

var $Mc7tV = parcelRequire("Mc7tV");

var $17qBN = parcelRequire("17qBN");

var $f9WWp = parcelRequire("f9WWp");

var $ThjgE = parcelRequire("ThjgE");

var $adC1n = parcelRequire("adC1n");

var $fCFLl = parcelRequire("fCFLl");

var $9YVrG = parcelRequire("9YVrG");

var $3x1U4 = parcelRequire("3x1U4");

var $6o208 = parcelRequire("6o208");

var $dpn0W = parcelRequire("dpn0W");

var $dtx6G = parcelRequire("dtx6G");

var $3zvgi = parcelRequire("3zvgi");

var $dKlSw = parcelRequire("dKlSw");

var $jcrbA = parcelRequire("jcrbA");

var $ifwq0 = parcelRequire("ifwq0");

var $183rZ = parcelRequire("183rZ");

var $5qohc = parcelRequire("5qohc");

var $4sPGi = parcelRequire("4sPGi");

var $3QZ4N = parcelRequire("3QZ4N");
$parcel$exportWildcard(module.exports, $6c2sG);
$parcel$exportWildcard(module.exports, $7CuOt);
$parcel$exportWildcard(module.exports, $girqX);
$parcel$exportWildcard(module.exports, $8DDsD);
$parcel$exportWildcard(module.exports, $jjMOM);
$parcel$exportWildcard(module.exports, $9Lyx0);
$parcel$exportWildcard(module.exports, $l4Kfs);
$parcel$exportWildcard(module.exports, $kL2H3);
$parcel$exportWildcard(module.exports, $Mc7tV);
$parcel$exportWildcard(module.exports, $17qBN);
$parcel$exportWildcard(module.exports, $f9WWp);
$parcel$exportWildcard(module.exports, $ThjgE);
$parcel$exportWildcard(module.exports, $adC1n);
$parcel$exportWildcard(module.exports, $fCFLl);
$parcel$exportWildcard(module.exports, $9YVrG);
$parcel$exportWildcard(module.exports, $3x1U4);
$parcel$exportWildcard(module.exports, $6o208);
$parcel$exportWildcard(module.exports, $dpn0W);
$parcel$exportWildcard(module.exports, $dtx6G);
$parcel$exportWildcard(module.exports, $3zvgi);
$parcel$exportWildcard(module.exports, $dKlSw);
$parcel$exportWildcard(module.exports, $jcrbA);
$parcel$exportWildcard(module.exports, $ifwq0);
$parcel$exportWildcard(module.exports, $183rZ);
$parcel$exportWildcard(module.exports, $5qohc);
$parcel$exportWildcard(module.exports, $4sPGi);
$parcel$exportWildcard(module.exports, $3QZ4N);

});
parcelRegister("6c2sG", function(module, exports) {

$parcel$export(module.exports, "getPlatformVersion", () => getPlatformVersion);
$parcel$export(module.exports, "getAppKey", () => getAppKey);
$parcel$export(module.exports, "isPlatform", () => isPlatform);
$parcel$export(module.exports, "getSchema", () => getSchema);
$parcel$export(module.exports, "getData", () => getData);
$parcel$export(module.exports, "getMySharedLibraries", () => getMySharedLibraries);
$parcel$export(module.exports, "getDefaultDesignSystem", () => getDefaultDesignSystem);
$parcel$export(module.exports, "getDefaultComponents", () => getDefaultComponents);
$parcel$export(module.exports, "getDefaultComponentsSchema", () => getDefaultComponentsSchema);
$parcel$export(module.exports, "getDefaultLibrary", () => getDefaultLibrary);
$parcel$export(module.exports, "getDefaultData", () => getDefaultData);
$parcel$export(module.exports, "getDefaults", () => getDefaults);
$parcel$export(module.exports, "getBuiltins", () => getBuiltins);
$parcel$export(module.exports, "getSecrets", () => getSecrets);
$parcel$export(module.exports, "getDependencies", () => getDependencies);
$parcel$export(module.exports, "getFiles", () => getFiles);
$parcel$export(module.exports, "getComponents", () => getComponents);
$parcel$export(module.exports, "getFunctions", () => getFunctions);
$parcel$export(module.exports, "getState", () => getState);
$parcel$export(module.exports, "getMethods", () => getMethods);
$parcel$export(module.exports, "getActivePkgManager", () => getActivePkgManager);
$parcel$export(module.exports, "getPackages", () => getPackages);
$parcel$export(module.exports, "getParsedState", () => getParsedState);
$parcel$export(module.exports, "getUtils", () => getUtils);
$parcel$export(module.exports, "getUtil", () => getUtil);
$parcel$export(module.exports, "getUserSettings", () => getUserSettings);
$parcel$export(module.exports, "setUserSettings", () => setUserSettings);
$parcel$export(module.exports, "toggleUserSettings", () => toggleUserSettings);
$parcel$export(module.exports, "setAllUserSettings", () => setAllUserSettings);
$parcel$export(module.exports, "isState", () => isState);
$parcel$export(module.exports, "addToPlatformContext", () => addToPlatformContext);
$parcel$export(module.exports, "addIfPlatformProject", () => addIfPlatformProject);
$parcel$export(module.exports, "getGlobalTheme", () => getGlobalTheme);
async function getPlatformVersion() {
    // The dynamic import below was disabled (reason predates this fix) but the
    // `PKG` read that depended on it was left in place, guaranteeing
    // `ReferenceError: PKG is not defined` on every call — GovernanceFields.js
    // calls this live on render. Found via the tickets/fable.md CI guard,
    // workspace-scope check (packages/workspace/dist bundle, 2026-08-08).
    // Restoring the import is a separate decision (it may be why it was
    // disabled in the first place — a dynamic `import()` of a bare
    // `package.json` has its own bundler considerations); until then this
    // returns undefined instead of throwing.
    // const PKG = await import('@symbo.ls/platform/package.json')
    // if (PKG) return PKG.version
    return undefined;
}
function getAppKey() {
    return this.getRootState()?.appKey;
}
function isPlatform() {
    return this.getRootState('projectType') === 'platform' || [
        'brand.symbo.ls',
        'smbls.symbo.ls',
        'platform.symbo.ls',
        'docs.symbo.ls',
        'assistant.symbo.ls',
        'landing.symbo.ls',
        'pricing.symbo.ls'
    ].includes(this.getAppKey());
}
function getSchema(key) {
    const { schema } = this.getRootState() || {};
    return key ? schema?.[key] : schema;
}
function getData(key) {
    const rootState = this.getRootState() || this.state?.root || {};
    const source = rootState.data || rootState;
    const { designSystem, state, components, snippets, pages, functions, methods, files, dependencies } = source;
    const data = {
        designSystem: designSystem,
        state: state,
        components: components,
        snippets: snippets,
        pages: pages,
        functions: functions,
        methods: methods,
        files: files,
        dependencies: dependencies
    };
    return key ? data[key] : data;
}
function getMySharedLibraries() {
    const root = this.getRootState && this.getRootState();
    return root && root.sharedLibraries || [];
}
async function getDefaultDesignSystem() {
    return {} // await import('@symbo.ls/library/default/designSystem')
    ;
}
async function getDefaultComponents() {
    return {} // await import('@symbo.ls/library/default/components')
    ;
}
async function getDefaultComponentsSchema() {
    const { DEFAULT_COMPONENTS_SCHEMA } = {} // await import('@symbo.ls/library/default.js')
    ;
    return DEFAULT_COMPONENTS_SCHEMA;
}
async function getDefaultLibrary() {
    const { LIBRARY } = {} // await import('@symbo.ls/library/default.js')
    ;
    return LIBRARY;
}
async function getDefaultData(key) {
    const data = {
        designSystem: await this.getDefaultDesignSystem(),
        components: await this.getDefaultComponents()
    };
    return key ? data[key] : data;
}
function getDefaults(key) {
    const defs = this.getRootState('DEFAULTS');
    return defs?.[key] || defs;
}
function getBuiltins() {
    const defs = this.getRootState('DEFAULTS');
    return defs?.DS_DEFAULTS;
}
function getSecrets(key) {
    const secrets = this.getRootState('secrets');
    return key ? secrets?.[key] : secrets;
}
function getDependencies(key) {
    const dependencies = this.getData('dependencies');
    return key ? dependencies?.[key] : dependencies;
}
function getFiles(key) {
    const files = this.getData('files');
    return key ? files?.[key] : files;
}
function getComponents(key) {
    const components = this.getData('components');
    return key ? components?.[key] : components;
}
function getFunctions(key) {
    const functions = this.getData('functions');
    return key ? functions?.[key] : functions;
}
function getState(key) {
    const state = this.getData('state');
    return key ? state?.[key] : state;
}
function getMethods(key) {
    const methods = this.getData('methods');
    return key ? methods?.[key] : methods;
}
function getActivePkgManager() {
    return this.getRootState('pkgManager');
}
function getPackages(key) {
    const packages = this.getSchema('dependencies');
    return key && packages ? packages[key] : packages || {};
}
function getParsedState(obj = this) {
    const isState2 = this.isState(obj);
    if (isState2) return obj.parse();
    const hasState = this.isState(obj.state);
    if (hasState) return obj.state.parse();
    return obj.parseDeep && obj.parseDeep() || obj;
}
function getUtils() {
    return this.context.utils;
}
function getUtil(key) {
    return this.getUtils()[key];
}
function getUserSettings(key) {
    const userSettings = this.getRootState('user');
    return key ? userSettings?.[key] : userSettings;
}
function setUserSettings(key, val, opts) {
    const autoSaveSettings = false //this.getUserSettings('autoSaveSettings')
    ;
    this.getRootState().update({
        user: {
            [key]: val
        }
    }, autoSaveSettings ? opts : {
        ...opts,
        preventUpdate: true
    });
    // console.log(key, val, opts)
    this.call('setCookie', key, val);
}
function toggleUserSettings(key, opts) {
    const val = !this.getUserSettings(key);
    this.setUserSettings(key, val, opts);
}
function setAllUserSettings(obj, opts) {
    // console.log(obj)
    this.getRootState().update({
        user: obj
    }, opts);
    for(const prop in obj)this.call('setCookie', prop, this.getUserSettings(prop));
}
function isState(obj) {
    if (!this.call('isObjectLike', obj)) return false;
    return obj.update && obj.parse && obj.clean && obj.create && obj.parent && obj.destroy && obj.rootUpdate && obj.parentUpdate && obj.keys && obj.values && obj.toggle && obj.replace && obj.quietUpdate && obj.quietReplace && obj.add && obj.apply && obj.applyReplace && obj.applyFunction && obj.__element && obj.__children;
// return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
}
function addToPlatformContext(type, key) {
    const context = this.context;
    const item = this.getDataItem(key, type);
    context[type][key] = this.call('deepClone', item);
}
function addIfPlatformProject(type, key) {
    if (this.isPlatform()) this.addToPlatformContext(type, key);
}
function getGlobalTheme() {
    const platformState = this.getRootState();
    if (!platformState) return 'dark';
    const { designSystem } = platformState;
    return platformState.sceneTheme || designSystem?.globalTheme;
}

});

parcelRegister("7CuOt", function(module, exports) {

$parcel$export(module.exports, "getCanvas", () => getCanvas);
$parcel$export(module.exports, "getPlayground", () => getPlayground);
$parcel$export(module.exports, "getVersionsAside", () => getVersionsAside);
$parcel$export(module.exports, "getLocalStorageCanvasData", () => getLocalStorageCanvasData);
$parcel$export(module.exports, "getCanvasScope", () => getCanvasScope);
$parcel$export(module.exports, "setCanvasScope", () => setCanvasScope);
$parcel$export(module.exports, "getActiveCanvasPage", () => getActiveCanvasPage);
$parcel$export(module.exports, "getCanvasFrame", () => getCanvasFrame);
$parcel$export(module.exports, "getCanvasFrameWindow", () => getCanvasFrameWindow);
$parcel$export(module.exports, "getEditorPanels", () => getEditorPanels);
$parcel$export(module.exports, "getComponentPanelSwitcher", () => getComponentPanelSwitcher);
$parcel$export(module.exports, "getComponentCodeEditor", () => getComponentCodeEditor);
$parcel$export(module.exports, "getDocsView", () => getDocsView);
$parcel$export(module.exports, "getDynamicIsland", () => getDynamicIsland);
$parcel$export(module.exports, "getQuickEditor", () => getQuickEditor);
$parcel$export(module.exports, "getFloatingPanelElement", () => getFloatingPanelElement);
$parcel$export(module.exports, "getCanvasModal", () => getCanvasModal);
$parcel$export(module.exports, "getCanvasNavbar", () => getCanvasNavbar);
$parcel$export(module.exports, "getFilesSidebar", () => getFilesSidebar);
$parcel$export(module.exports, "getFilesSidebarPrompt", () => getFilesSidebarPrompt);
$parcel$export(module.exports, "getCanvasPages", () => getCanvasPages);
$parcel$export(module.exports, "getComponentEditor", () => getComponentEditor);
$parcel$export(module.exports, "getChosenElement", () => getChosenElement);
$parcel$export(module.exports, "getChosenData", () => getChosenData);
$parcel$export(module.exports, "getChosenElementContext", () => getChosenElementContext);
$parcel$export(module.exports, "getChosenScene", () => getChosenScene);
$parcel$export(module.exports, "getChosenViewSvitcher", () => getChosenViewSvitcher);
$parcel$export(module.exports, "getChosenIframe", () => getChosenIframe);
$parcel$export(module.exports, "getChosenIframeWindow", () => getChosenIframeWindow);
$parcel$export(module.exports, "getChosenSceneNavbar", () => getChosenSceneNavbar);
$parcel$export(module.exports, "getCanvasCollection", () => getCanvasCollection);
$parcel$export(module.exports, "getCanvasContext", () => getCanvasContext);
$parcel$export(module.exports, "activateHovered", () => activateHovered);
$parcel$export(module.exports, "activateSelected", () => activateSelected);
$parcel$export(module.exports, "updateSelectedLabel", () => updateSelectedLabel);
$parcel$export(module.exports, "activateChosen", () => activateChosen);
$parcel$export(module.exports, "activateContext2", () => activateContext2);
$parcel$export(module.exports, "activateContext", () => activateContext);
$parcel$export(module.exports, "changeCodePriority", () => changeCodePriority);
$parcel$export(module.exports, "updateRecents", () => updateRecents);
$parcel$export(module.exports, "activateFunction", () => activateFunction);
$parcel$export(module.exports, "activateState", () => activateState);
$parcel$export(module.exports, "activateDs", () => activateDs);
$parcel$export(module.exports, "getHovered", () => getHovered);
$parcel$export(module.exports, "getHoveredKey", () => getHoveredKey);
$parcel$export(module.exports, "getSelected", () => getSelected);
$parcel$export(module.exports, "getSelectedKey", () => getSelectedKey);
$parcel$export(module.exports, "getChosen", () => getChosen);
$parcel$export(module.exports, "getChosenKey", () => getChosenKey);
$parcel$export(module.exports, "getInContext", () => getInContext);
$parcel$export(module.exports, "getInContextKey", () => getInContextKey);
$parcel$export(module.exports, "getCanvasPositions", () => getCanvasPositions);
$parcel$export(module.exports, "zoomToNode", () => zoomToNode);
$parcel$export(module.exports, "updateGridsInSchema", () => updateGridsInSchema);
$parcel$export(module.exports, "getCleanCanvasScope", () => getCleanCanvasScope);
$parcel$export(module.exports, "syncSocketCanvasData", () => syncSocketCanvasData);
$parcel$export(module.exports, "syncCanvas", () => syncCanvas);
$parcel$export(module.exports, "syncCanvasPositions", () => syncCanvasPositions);
$parcel$export(module.exports, "canvasFade", () => canvasFade);
$parcel$export(module.exports, "toggleLoading", () => toggleLoading);
$parcel$export(module.exports, "resetCanvasPan", () => resetCanvasPan);
$parcel$export(module.exports, "getCanvasScopeFromStorageOrData", () => getCanvasScopeFromStorageOrData);
$parcel$export(module.exports, "isDashboard", () => isDashboard);
$parcel$export(module.exports, "isAuthorised", () => isAuthorised);
$parcel$export(module.exports, "isFree", () => isFree);
$parcel$export(module.exports, "isCanvas", () => isCanvas);
$parcel$export(module.exports, "isEmbed", () => isEmbed);
$parcel$export(module.exports, "hasProjectPermission", () => hasProjectPermission);
$parcel$export(module.exports, "isEditMode", () => isEditMode);
$parcel$export(module.exports, "isAdmin", () => isAdmin);
$parcel$export(module.exports, "isOwner", () => isOwner);
$parcel$export(module.exports, "isReadOnly", () => isReadOnly);
$parcel$export(module.exports, "preventLocationChanges", () => preventLocationChanges);
$parcel$export(module.exports, "isDocs", () => isDocs);
$parcel$export(module.exports, "isDevelopers", () => isDevelopers);
$parcel$export(module.exports, "getCanvasPathname", () => getCanvasPathname);
$parcel$export(module.exports, "getCanvasPathnameAnyway", () => getCanvasPathnameAnyway);
$parcel$export(module.exports, "getCanvasPathnameLocal", () => getCanvasPathnameLocal);
$parcel$export(module.exports, "openArtboardItem", () => openArtboardItem);
$parcel$export(module.exports, "openItem", () => openItem);
$parcel$export(module.exports, "getCanvasMode", () => getCanvasMode);
$parcel$export(module.exports, "isCanvasMode", () => isCanvasMode);
$parcel$export(module.exports, "setCanvasMode", () => setCanvasMode);
parcelRequire("S1wNg");
var $36Jqh = parcelRequire("36Jqh");
function getCanvas(childKey) {
    const Canvas = this.getRootData('Canvas') || this.lookup('Canvas') || this.lookdown('Canvas');
    if (!Canvas) return;
    if (childKey) return Canvas[childKey];
    return Canvas;
}
function getPlayground() {
    const Playground = this.getCanvas()?.parent;
    if (!Playground) return;
    return Playground;
}
function getVersionsAside() {
    const Playground = this.getPlayground();
    if (!Playground) return;
    return Playground.parent?.Versions?.VersionsAside;
}
function getLocalStorageCanvasData() {
    const localStorageKey = `${this.getAppKey()?.split('.')[0]}__data`;
    return this.call('getLocalStorage', localStorageKey);
}
function getCanvasScope(childKey) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetCanvasScope)
    const _canvasFork = this?.context?.methods?.canvasGetCanvasScope;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    const canvas = this.getCanvas();
    const scope = canvas?.scope;
    if (childKey) return scope?.[childKey];
    return scope;
}
function setCanvasScope(obj) {
    const scope = this.getCanvasScope();
    // The editor chrome (CanvasEditor.onInit, QuickEditor, …) can run before —
    // or without — the Canvas scene having built its scope (in-shell mount
    // order, or a scene whose load failed). Writing into a nonexistent scope
    // was a hard TypeError inside `overwrite`, re-thrown on every render retry
    // — observed as a 1/s exception storm on the in-shell project route. No
    // scope yet → no-op; the caller's next write after the scene mounts lands.
    if (!scope) return null;
    this.call('overwrite', scope, obj);
    this.syncCanvas(obj);
    return scope;
}
function getActiveCanvasPage() {
    return this.getCanvasScope('activeCanvasPage');
}
function getCanvasFrame() {
    return this.getCanvas()?.Iframe;
}
function getCanvasFrameWindow() {
    return this.getCanvasFrame()?.node.contentWindow;
}
function getEditorPanels() {
    return this.getCanvas()?.parent?.Chosen?.Flex?.EditorPanels;
}
function getComponentPanelSwitcher() {
    return this.getEditorPanels()?.ComponentEditor.PanelSwitcher;
}
function getComponentCodeEditor() {
    return this.getComponentPanelSwitcher()?.content?.CodePreviewWidget.Monaco;
}
function getDocsView() {
    return this.getChosenScene()?.DocsView;
}
function getDynamicIsland() {
    return this.getPlayground()?.DynamicIsland;
}
function getQuickEditor() {
    const playground = this.getPlayground();
    return playground?.QuickEditor || playground?.CanvasEditor?.QuickEditor || this.getRoot()?.lookdown?.('QuickEditor');
}
function getFloatingPanelElement() {
    return this.getPlayground()?.FloatingPanel;
}
function getCanvasModal() {
    return this.getPlayground()?.CanvasModal;
}
function getCanvasNavbar() {
    return this.getPlayground()?.MainCanvasNavbar;
}
function getFilesSidebar() {
    // return this.getDynamicIsland()?.CanvasProjectSidebar
    return this.getDynamicIsland()?.content;
}
function getFilesSidebarPrompt() {
    return this.getFilesSidebar()?.FilesSidebarPrompt;
}
function getCanvasPages() {
    if (this.isEmbed()) return this.getCanvas()?.ChooseCanvas;
    return this.getCanvasNavbar()?.CanvasPagesDropdown;
}
function getComponentEditor() {
    return this.getEditorPanels()?.ComponentEditor;
}
function getChosenElement() {
    return this.getPlayground()?.Chosen;
}
function getChosenData(key) {
    const data = this.getChosenElement()?.data;
    return key ? data[key] : data;
}
function getChosenElementContext() {
    return this.getChosenElement()?.data.chosen?.context;
}
function getChosenScene() {
    return this.getChosenElement()?.Flex?.ChosenScene;
}
function getChosenViewSvitcher() {
    return this.getChosenScene()?.ViewSvitcher;
}
function getChosenIframe() {
    return this.getChosenScene()?.ViewSvitcher?.ComponentFrameCanvas.Iframe;
}
function getChosenIframeWindow() {
    return this.getChosenIframe()?.node.contentWindow;
}
function getChosenSceneNavbar() {
    return this.getChosenElement()?.SceneNavbar;
}
function getCanvasCollection() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetCanvasCollection)
    const _canvasFork = this?.context?.methods?.canvasGetCanvasCollection;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getCanvasScope('Collection');
}
function getCanvasContext() {
    return this.getCanvasCollection().context;
}
function activateHovered(val) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasActivateHovered)
    const _canvasFork = this?.context?.methods?.canvasActivateHovered;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const hovered = data.hovered = this.call('isDefined', val) ? val : null;
    return this.syncCanvas({
        hovered: hovered
    });
}
function activateSelected(val, opts = {}) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasActivateSelected)
    const _canvasFork = this?.context?.methods?.canvasActivateSelected;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    const data = this.getCanvasScope();
    if (!this.call('isDefined', val)) val = this;
    else if (this.call('isString', val)) {
        const type = this.getType(val);
        const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val);
        if (!isOnCurrent) {
            const onOtherCanvasPage = this.call('findKeyInOtherCanvasPages', type, val);
            if (onOtherCanvasPage) this.call('openCanvasPage', onOtherCanvasPage);
        }
        val = this.call('findComponentOnCanvas', val);
    }
    const selected = data.selected = this.call('isDefined', val) ? val : data.hovered;
    if (selected) {
        this.changeCodePriority('component', opts);
        if (this.getUserSettings('autoSelectSidebar')) {
            if (this.call('getSidebarContent') !== 'ARTBOARD_TYPES') this.call('setSidebarContent', 'ARTBOARD_TYPES');
        }
    }
    this.updateSelectedLabel();
    return !opts.preventSync ? this.syncCanvas({
        selected: selected
    }) : data;
}
function updateSelectedLabel() {
    if (this.isEmbed()) return;
    if (this.getFilesSidebar()?.FilesSidebarPrompt?.state?.focused) this.getFilesSidebar().FilesSidebarPrompt.Label.SearchOverlay.SelectedResource.update();
}
function activateChosen(val, opts = {}) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasActivateChosen)
    const _canvasFork = this?.context?.methods?.canvasActivateChosen;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    const data = this.getCanvasScope();
    if (!this.call('isDefined', val)) val = this;
    else if (this.call('isString', val)) {
        const type = this.getType(val);
        const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val);
        let onOtherCanvas = null;
        if (isOnCurrent) onOtherCanvas = null;
        else onOtherCanvas = this.call('findKeyInOtherCanvasPages', type, val);
        if (onOtherCanvas) this.call('openCanvasPage', onOtherCanvas);
        val = data.Collection?.lookdown((el)=>el.state?.key === val);
    }
    const chosen = data.chosen = this.call('isDefined', val) ? val : data.selected;
    if (chosen && chosen.state) {
        const { key } = chosen.state;
        // this.addToTabs(key)
        this.updateRecents(key);
        this.changeCodePriority('component', opts);
        if (this.call('getSidebarContent') !== 'ARTBOARD_TYPES') this.call('setSidebarContent', 'ARTBOARD_TYPES');
    }
    return !opts.preventSync ? this.syncCanvas({
        chosen: chosen
    }) : data;
}
function activateContext2(ev, val) {
    if (ev?.stopPropagation) ev.stopPropagation();
    const data = this.getCanvasScope();
    const isString = this.call('isString', val);
    const isDefined = this.call('isDefined', val);
    const isNull = val === null;
    if (!ev || isNull) return this.syncCanvas({
        inContext: null,
        positions: {
            contextX: null,
            contextY: null
        }
    });
    if (isString) {
        const onOtherCanvas = this.call('findKeyInOtherCanvasPages', val) || 'Default';
        if (onOtherCanvas) this.call('openCanvasPage', onOtherCanvas);
        val = this.getCanvasCollection().lookdown((el)=>el.state?.key === val) || this.getItem(val) || this.getHovered();
    } else if (!isDefined) val = this;
    const inContext = data.inContext = val;
    const { clientX, clientY } = ev;
    return this.syncCanvas({
        inContext: inContext || null,
        positions: {
            contextX: clientX || null,
            contextY: clientY || null
        }
    });
}
function activateContext(ev, val, preventDefault = true, stopPropagation = true) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasActivateContext)
    const _canvasFork = this?.context?.methods?.canvasActivateContext;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    if (ev?.stopPropagation && stopPropagation) ev.stopPropagation();
    if (ev?.preventDefault && preventDefault) ev.preventDefault();
    const data = this.getCanvasScope();
    const isString = this.call('isString', val);
    const isDefined = this.call('isDefined', val);
    // THE ARMED RECORD LIVES ON THE CANVAS SCOPE, not on `this`.
    // The invocation that OPENS the menu and the one that CLOSES it run on
    // DIFFERENT elements: a sidebar row opens (`el.activateContext(ev, el)`),
    // while the Escape shortcut and the sidebar menu close with
    // `activateContext(null)` on another element. A pair stored on the opener
    // is `undefined` on the closer, `removeEventListener` never runs, and every
    // right-click leaves two capture-phase window listeners subscribed — each
    // holding a closure over its element. `getCanvasScope()` answers ONE object
    // for the whole canvas (it already carries `inContext`), so both reach it.
    //
    // The record holds `clientX` as a NUMBER. The handler outlives the click,
    // and reading `ev.clientX` inside it would retain the whole MouseEvent
    // (target, view, composed path) for as long as the menu stays open.
    const disarm = ()=>{
        const armed = data?._contextMenuArmed;
        if (!armed) return;
        window.removeEventListener('scroll', armed.reposition, true);
        window.removeEventListener('resize', armed.reposition, true);
        data._contextMenuArmed = null;
    };
    const clearContextMenu = ()=>{
        disarm();
        return this.syncCanvas({
            inContext: null,
            positions: {
                contextX: null,
                contextY: null
            }
        });
    };
    const isNull = val === null;
    if (!ev || isNull) return clearContextMenu();
    if (isString) {
        const type = this.getType(val);
        const isOnCurrent = this.call('inOnCurrentCanvasPage', type, val);
        let onOtherCanvas = null;
        if (!isOnCurrent) onOtherCanvas = this.call('findKeyInOtherCanvasPages', val);
        if (onOtherCanvas) this.call('openCanvasPage', onOtherCanvas);
        val = this.getCanvasCollection().lookdown((el)=>el.state?.key === val) || this.getItem(val) || this.getHovered();
    } else if (!isDefined) val = this;
    const inContext = data.inContext = val;
    const { clientX, clientY } = ev;
    // Places the menu beside its target. Answers `true` when the target sits
    // outside the sidebar viewport, and places nothing in that case.
    const place = ()=>{
        const armed = data._contextMenuArmed;
        if (!armed || !armed.target) return false;
        // The menu mounts AFTER this open syncs `inContext`, so it cannot be
        // resolved up front. Resolve it on first use and keep it: a tree walk per
        // scroll event is up to 60 walks a second over the whole playground. A
        // disposed element (`node`/`parent` cleared) is resolved again.
        let ContextMenu = armed.ContextMenu;
        if (!ContextMenu || !ContextMenu.node || !ContextMenu.parent) ContextMenu = armed.ContextMenu = this.getPlayground()?.lookdown('ContextMenu');
        const Overflow = this.getFilesSidebar()?.Overflow;
        if (!ContextMenu || !ContextMenu.node || !Overflow) return false;
        const PANEL_OFFSET_TOP = 10;
        const targetRect = armed.target.getBoundingClientRect();
        const overflowRect = Overflow.node.getBoundingClientRect();
        const contextMenuHeight = ContextMenu.node.getBoundingClientRect().height;
        const viewportHeight = window.innerHeight;
        let topPosition = targetRect.top + targetRect.height / 2;
        if (topPosition + contextMenuHeight > viewportHeight) topPosition = viewportHeight - contextMenuHeight - PANEL_OFFSET_TOP;
        const isOutOfBounds = targetRect.bottom > overflowRect.bottom || targetRect.top < overflowRect.top;
        if (!isOutOfBounds) ContextMenu.setNodeStyles({
            transform: `translate(${armed.clientX}px, ${topPosition}px)`
        });
        return isOutOfBounds;
    };
    // ONE handler for both events: scroll and resize ask the same question and
    // act the same way. A target that SCROLLED out of the sidebar viewport
    // leaves the menu nothing to point at, so it closes.
    const reposition = ()=>{
        if (place()) clearContextMenu();
    };
    // Disarm whatever a previous right-click left subscribed before arming a
    // new pair. Two right-clicks with no close between them are ordinary use
    // (right-click one node, then another), and without this they would stack
    // a second pair on top of the first.
    disarm();
    data._contextMenuArmed = {
        reposition: reposition,
        target: val && val.node ? val.node : null,
        clientX: clientX
    };
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition, true);
    // The first placement only PLACES. A row the sidebar clips at its edge is
    // already "out of bounds" when the user right-clicks it, and closing here
    // would make its menu impossible to open.
    requestAnimationFrame(()=>{
        place();
    });
    return this.syncCanvas({
        inContext: inContext || null,
        positions: {
            contextX: clientX || null,
            contextY: clientY || null
        }
    });
}
function changeCodePriority(val, opts = {}) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const priorityCode = data.priorityCode = val;
    return !opts.preventSync ? this.syncCanvas({
        priorityCode: priorityCode
    }) : data;
}
function updateRecents(key) {
    const platformState = this.getRootState();
    const { appKey } = platformState;
    const { recents } = platformState;
    const recentExists = recents.indexOf(key);
    if (recentExists > -1) this.call('removeFromArray', recents, recentExists);
    if (key) {
        recents.unshift(key);
        if (appKey) window.localStorage.setItem(`recents_${appKey}${platformState.branch}`, JSON.stringify(recents));
    }
}
function activateFunction(val) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasActivateFunction)
    const _canvasFork = this?.context?.methods?.canvasActivateFunction;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const activeFunction = data.activeFunction = val;
    if (activeFunction) this.changeCodePriority('function');
    return this.syncCanvas({
        activeFunction: activeFunction
    });
}
function activateState(val) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const activeState = data.activeState = val;
    if (activeState) this.changeCodePriority('state');
    return this.syncCanvas({
        activeState: activeState
    });
}
function activateDs(val) {
    if (!this.call('isDefined', val)) val = this;
    const data = this.getCanvasScope();
    const activeDs = data.activeDs = val;
    if (activeDs) this.changeCodePriority('designSystem');
    return this.syncCanvas({
        activeDs: activeDs
    });
}
function getHovered() {
    return this.getCanvasScope('hovered');
}
function getHoveredKey() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetHoveredKey)
    const _canvasFork = this?.context?.methods?.canvasGetHoveredKey;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getHovered()?.state?.key;
}
function getSelected() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetSelected)
    const _canvasFork = this?.context?.methods?.canvasGetSelected;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getCanvasScope('selected');
}
function getSelectedKey() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetSelectedKey)
    const _canvasFork = this?.context?.methods?.canvasGetSelectedKey;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getSelected()?.state?.key;
}
function getChosen() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetChosen)
    const _canvasFork = this?.context?.methods?.canvasGetChosen;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getCanvasScope('chosen');
}
function getChosenKey() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetChosenKey)
    const _canvasFork = this?.context?.methods?.canvasGetChosenKey;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    const chosen = this.getChosen();
    return this.call('isString', chosen) ? chosen : chosen?.state?.key;
}
function getInContext() {
    return this.getCanvasScope('inContext');
}
function getInContextKey() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetInContextKey)
    const _canvasFork = this?.context?.methods?.canvasGetInContextKey;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getInContext()?.state?.key;
}
function getCanvasPositions() {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasGetCanvasPositions)
    const _canvasFork = this?.context?.methods?.canvasGetCanvasPositions;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getCanvasScope('positions') || {};
}
function zoomToNode(zoomedElement, opts = {}) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasZoomToNode)
    const _canvasFork = this?.context?.methods?.canvasZoomToNode;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    const canvasScope = this.getCanvasScope();
    const frameWindow = this.getCanvasFrameWindow();
    const { innerWidth, innerHeight } = frameWindow;
    if (!canvasScope.panzoomInstance || !zoomedElement) return;
    const getTransform = canvasScope.panzoomInstance.getTransform();
    if (opts.useZoom) canvasScope.panzoomInstance.zoomAbs(getTransform.x, getTransform.y, 0.65);
    setTimeout(()=>{
        const zoomedNode = zoomedElement.node;
        const { x, y, width, height } = zoomedNode.getBoundingClientRect();
        const panToX = x - (innerWidth - width) / 2;
        const panToY = y - (innerHeight - height) / 2;
        canvasScope.panzoomInstance.moveBy(-panToX, -panToY, true);
    }, 50);
}
async function updateGridsInSchema(items) {
    const changes = items.map((item)=>{
        if (!item.el?.ref) {
            console.error('[updateGridsInSchema] Missing element reference', item);
            return null;
        }
        const { state } = item.el.ref;
        if (!state || state.package) return null // skip packaged components or invalid state
        ;
        const type = this.getType(state);
        const path = [
            'schema',
            type,
            state.key,
            'settings',
            'gridOptions'
        ];
        const value = item._orig;
        // Skip if value did not actually change – avoids unnecessary state churn
        const currentVal = state.settings?.gridOptions;
        const isSame = currentVal && JSON.stringify(currentVal) === JSON.stringify(value);
        if (isSame) return null;
        if (!state.settings) state.settings = {};
        state.settings.gridOptions = value;
        return [
            'update',
            path,
            value
        ];
    }).filter(Boolean);
    if (!changes.length) return; // nothing to apply
    // Apply changes via CollabService but prevent a reactive run-through that would
    // immediately trigger another re-render, causing an infinite loop.
    // When the server eventually confirms (via commit) Canvas will still receive
    // the version update.
    try {
        this.sdk.updateData(changes, {
            skipCanvasUpdate: true,
            skipRuntimeTests: true,
            message: 'Updated gridOptions on artboards at ' + this.getActiveCanvasPage()
        });
    } catch (e) {
        // If the collab connection is not yet established we fall back to applying
        // the changes locally so that the UI stays in sync.
        if (this.sdk?.getService) {
            const collab = this.sdk.getService('collab');
            collab?._stateManager?.applyChanges(changes, {
                preventUpdate: true
            });
        }
    }
}
function getCleanCanvasScope(data) {
    const obj = {};
    const allowedKeys = [
        'explorer',
        'editorPanels',
        'docs',
        'previewSize',
        'modal',
        'followingUser',
        'openUrl',
        'editorActive',
        'activeCanvasPage',
        'hoverLayer',
        'activeLayer',
        'positions',
        'chosenPos',
        'monaco',
        'monacoSelection',
        'preferredEditor',
        'editorActive',
        'priorityCode',
        'showLayersSchema'
    ];
    const elementToUpdate = this.getWindowKeys();
    const allowedNodes = [
        'hovered',
        'selected',
        'chosen',
        'inContext'
    ];
    for(const prop in data){
        const val = data[prop];
        const allowed = allowedKeys.includes(prop) || elementToUpdate.includes(prop);
        if (allowed) obj[prop] = val;
        if (allowedNodes.includes(prop)) obj[prop] = this.call('isString', val) ? val : val?.state?.key ? val?.state?.key : null;
    }
    return obj;
}
function syncSocketCanvasData(clientData, opts = {}) {
    const platformState = this.getRootState();
    const canvasData = this.getCanvasScope();
    if (!canvasData) return;
    // The shell root state carries no `settings` object (the legacy canvas
    // root did), so every `syncCanvas` on the shell threw here AFTER the
    // localStorage write — one uncaught TypeError per scope sync, measured
    // live from `setCanvasScope` at boot and from the files-sidebar layer
    // persist (WS-FILES-SAVE-LAYERS-VISIBILITY-STATE-MISSING-1). No setting →
    // no socket forward, the same answer as `syncCanvas: false`.
    const { userId, settings, followingUser } = platformState;
    if (!settings?.syncCanvas) return;
    if (!followingUser || opts.forceSendSocket) {
        if (this.sdk?.isConnected()) this.sdk.sendCursor({
            [userId]: {
                ...clientData
            }
        });
    } else if (clientData.positions?.mouseX || clientData.chosenPos?.mouseX) {
        if (this.sdk?.isConnected()) this.sdk.sendCursor({
            [userId]: {
                positions: clientData.positions?.mouseX && {
                    mouseX: clientData.positions.mouseX,
                    mouseY: clientData.positions.mouseY
                },
                chosenPos: clientData.chosenPos?.mouseX && {
                    mouseX: clientData.chosenPos.mouseX,
                    mouseY: clientData.chosenPos.mouseY
                }
            }
        });
    }
    return clientData;
}
function syncCanvas(data = {}, opts = {}) {
    const platformState = this.getRootState();
    const canvasData = this.getCanvasScope();
    const { userId } = platformState;
    const resetObjs = (key)=>{
        if (data[key]) data[key] = {
            ...canvasData[key],
            ...data[key]
        };
    };
    resetObjs('positions');
    resetObjs('chosenPos');
    resetObjs('monaco');
    resetObjs('monacoSelection');
    // The files-sidebar layer-visibility map (`showLayersSchema`, see
    // getShowLayersSchema / saveLayersVisibilityState in editor.js) has no
    // boot-time writer, and nothing seeds the scope from `<app>__data` at boot,
    // so the FIRST sync of a fresh scope persisted the clean scope without it
    // and wiped the map — measured live on the shell: the map survived its
    // own write and died on the next reload, under the boot `setCanvasScope`.
    // Seed it once, before the write, from the copy the scope is seeded from
    // (WS-FILES-SAVE-LAYERS-VISIBILITY-STATE-MISSING-1).
    if (canvasData && canvasData.showLayersSchema === undefined && data.showLayersSchema === undefined) canvasData.showLayersSchema = this.getCanvasScopeFromStorageOrData()?.showLayersSchema || {};
    // Merge incoming changes into current canvasData
    this.call('overwrite', canvasData, data);
    // Persist cleaned client state to rootState.clients
    if (!platformState.clients) platformState.clients = {};
    const reservedClientKeys = [
        'localhost',
        'cli',
        'platform'
    ];
    let clientKey = userId;
    if (reservedClientKeys.includes(clientKey)) clientKey = `user_${clientKey}`;
    const cleanData = platformState.clients[clientKey] = this.getCleanCanvasScope(canvasData);
    // Store to localStorage when relevant ( skip continuous mouse move spam )
    const localStorageKey = `${this.getAppKey()?.split('.')[0]}__data`;
    const changesWithValues = Object.values(cleanData).filter((v)=>v).length;
    if (!data.positions && changesWithValues) this.call('setLocalStorage', localStorageKey, cleanData);
    // Forward minimal delta via socket
    return this.call('syncSocketCanvasData', this.getCleanCanvasScope(data), opts);
}
function syncCanvasPositions(positions) {
    const data = this.getCanvasScope();
    if (!data) return;
    return this.syncCanvas({
        positions: positions
    });
}
function canvasFade(condition) {
    const { Fade } = this.getCanvas();
    if (condition) {
        Fade.fadeIn.background = `var(--theme-modalFade-${this.getRootState('globalTheme')}-backgroundColor)`;
        Fade.setNodeStyles(Fade.fadeIn);
    } else Fade.setNodeStyles(Fade.fadeOut);
}
function toggleLoading() {
    const data = this.getCanvasScope();
    if (!data) return;
    this.variables({
        loading: data?.loading
    }).changed((_)=>{
        if (data.loading) this.parent.LoadingGifSection?.setNodeStyles?.(this.parent.LoadingGifSection?.fadeIn);
        else this.parent.LoadingGifSection?.setNodeStyles?.(this.parent.LoadingGifSection?.fadeOut);
    });
}
const resetCanvasPan = function resetCanvasPan() {
    const canvasScope = this.getCanvasScope();
    const activeCanvasPage = this.getActiveCanvasPage();
    const localStorageKey = `${this.getAppKey()?.split('.')[0]}___${activeCanvasPage}`;
    const fromStorage = JSON.parse((this.call('sameOriginTop')?.localStorage || window.localStorage).getItem(localStorageKey));
    const { x, y, scale } = fromStorage || this.getCanvasPositions() || {};
    const { panzoomInstance } = canvasScope;
    if (panzoomInstance) {
        panzoomInstance.moveTo(x || 0, y || 0, scale || 1);
        panzoomInstance.zoomAbs(x || 0, y || 0, scale || 1);
    }
};
function getCanvasScopeFromStorageOrData() {
    const localStorageData = this.getLocalStorageCanvasData();
    const platformState = this.getRootState();
    const { userId } = platformState;
    return localStorageData || platformState.clients?.[userId];
}
function isDashboard() {
    const { pathname } = window.location;
    if (pathname.startsWith('/dashboard')) return true;
}
function isAuthorised() {
    const verdict = this.context && this.context.bootSignedIn;
    if (typeof verdict === 'boolean') {
        const st = this.state && (this.state.root || this.state);
        if (st && st._authReady === true && typeof st.signedIn === 'boolean') return st.signedIn;
        return verdict;
    }
    if (this.context && this.context.bootReady) return false;
    return Boolean(this.sdk?.getAuthToken());
}
function isFree() {
    return Boolean(this.getRootState('tier') === 'free');
}
function isCanvas(routeOverride) {
    const pathname = routeOverride || window.location.pathname;
    if (pathname.startsWith('/canvas') || pathname.startsWith('/embed')) return true;
    const [, user, project] = pathname.split('/');
    if (!user || !project || this.getCanvasPathname() !== `/${user}/${project}`) return;
    return Boolean(this.getCanvasScope());
}
function isEmbed() {
    return this.getRootState('isEmbed');
}
function hasProjectPermission(perm) {
    if (this.isEmbed()) return false;
    const role = this.getRootState('projectRole');
    if (!role) return true;
    return ((0, $36Jqh.PROJECT_ROLE_PERMISSIONS)[role] || []).includes(perm);
}
// `sdk.hasPermission` is ASYNC here and this method is not. The shell wraps
// every SDK method in an init gate — `(...args) => initPromise.then(() =>
// value.apply(target, args))` — so `hasPermission('editMode')` returns a
// PROMISE, and `Boolean(promise)` is true unconditionally. This method
// therefore returned "yes, editable" for everyone, including users whose
// permission resolves to false (verified live: the promise resolved `false`
// while the method still reported editable). Its consumers are sync render
// props — e.g. CanvasV2CodeEditor's `Monaco.readOnly: (el) => el.isReadOnly()`
// — so they cannot await it.
//
// Resolved synchronously from `projectRole` instead, the same signal `isAdmin`
// / `isOwner` below already use. `projectRole` is set by performProjectSwitch
// (shared/methods/project.js) and defaults to 'guest' for non-members.
//
// UNKNOWN role deliberately reads as EDITABLE, not read-only. The consuming
// bindings carry no `subscribeTo`, so they evaluate once at render and never
// re-run: locking the editor before the role lands would be UNRECOVERABLE for
// a legitimate editor, whereas a brief permissive window closes as soon as the
// role resolves on the next render. Fail-open on "not yet known", fail-closed
// on "known and not allowed" — that still fixes the actual bypass, because a
// guest's role IS known.
const EDIT_ROLES = [
    'owner',
    'admin',
    'editor'
];
function isEditMode() {
    if (this.isEmbed()) return false;
    const role = this.getRootState('projectRole');
    if (!role) return true;
    return EDIT_ROLES.includes(role);
}
function isAdmin() {
    return [
        'owner',
        'admin'
    ].includes(this.getRootState('projectRole'));
}
function isOwner() {
    return [
        'owner'
    ].includes(this.getRootState('projectRole'));
}
function isReadOnly() {
    return !this.isEditMode();
}
function preventLocationChanges(window1) {
// Intercept beforeunload/navigation attempts
// window.addEventListener('beforeunload', (e) => {
//   e.preventDefault()
// })
// const expectedUrl = this.getCanvasPathnameAnyway()
// new MutationObserver(() => {
//   if (window.location.href !== expectedUrl) {
//     console.warn('Blocked forced navigation')
//     window.location.replace(expectedUrl)
//   }
// }).observe(document, { childList: true, subtree: true })
}
function isDocs() {
    const { pathname } = window.location;
    if ([
        '/docs',
        '/tutorials',
        '/index'
    ].some((p)=>pathname === p || pathname.startsWith(`${p}/`))) return true;
}
function isDevelopers() {
    const { pathname } = window.location;
    if ([
        '/developers'
    ].some((p)=>pathname === p || pathname.startsWith(`${p}/`))) return true;
}
function getCanvasPathname() {
    const { workingProjectOwner, workingProjectKey } = this.getRootState() || {};
    if (!workingProjectOwner || !workingProjectKey) return;
    return `/${workingProjectOwner}/${workingProjectKey}`;
}
function getCanvasPathnameAnyway() {
    if (this.getCanvasPathname()) return this.getCanvasPathname();
    let { appKey, owner } = this.getRootState() || {};
    appKey = appKey?.split('.')[0];
    owner = owner?.username;
    if (!owner) {
        const { members } = this.getRootState() || {};
        owner = members?.find((m)=>m.role === 'owner')?.username;
    }
    return appKey && owner ? `/${owner}/${appKey}` : '/studio';
}
function getCanvasPathnameLocal() {
    const s = this.state;
    return `/${s.owner?.username}/${s.key.split('.')[0]}`;
}
function openArtboardItem(type = 'components', key) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasOpenArtboardItem)
    const _canvasFork = this?.context?.methods?.canvasOpenArtboardItem;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    if (!this.call('inOnCurrentCanvasPage', type, key)) this.call('openCanvasPage', this.call('findKeyInOtherCanvasPages', key) || 'Default');
    const t = window.setTimeout(()=>{
        this.activateSelected(key);
        const data = this.getCanvasScope();
        const t2 = window.setTimeout(()=>{
            this.zoomToNode(data.selected);
            clearTimeout(t2);
        }, 100);
        clearTimeout(t);
    }, 35);
}
function openItem(type = 'components', key) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasOpenItem)
    const _canvasFork = this?.context?.methods?.canvasOpenItem;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    if (this.call('hasType', 'ARTBOARD_TYPES', type)) return this.call('openArtboardItem', type, key);
    if (this.call('hasType', 'FUNCTION_TYPES', type)) return this.activateFunction(key);
    if (this.call('hasType', 'STATE_TYPES', type)) return this.activateState(key);
    if (this.call('hasType', 'ASSETS_TYPES', type)) return this.call('openRouterModal', '/edit-file', {
        key: key
    });
}
function getCanvasMode() {
    return this.getCanvasScope('canvasMode');
}
function isCanvasMode(mode) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasIsCanvasMode)
    const _canvasFork = this?.context?.methods?.canvasIsCanvasMode;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    const canvasMode = this.getCanvasScope('canvasMode');
    if (mode === 'defaultMode') return !canvasMode || canvasMode === 'defaultMode';
    return canvasMode === mode;
}
function setCanvasMode(mode) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasSetCanvasMode)
    const _canvasFork = this?.context?.methods?.canvasSetCanvasMode;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    return this.getCanvasScope().canvasMode = mode;
}

});

parcelRegister("girqX", function(module, exports) {

$parcel$export(module.exports, "findComponentOnCanvas", () => findComponentOnCanvas);
$parcel$export(module.exports, "findWhereItsUsedOnCanvas", () => findWhereItsUsedOnCanvas);
$parcel$export(module.exports, "refreshComponentsWhereReferencedOnCanvas", () => refreshComponentsWhereReferencedOnCanvas);
$parcel$export(module.exports, "refreshComponentOnCanvas", () => refreshComponentOnCanvas);
$parcel$export(module.exports, "queueUpdateItemInCanvas", () => queueUpdateItemInCanvas);
$parcel$export(module.exports, "refreshCanvasComponentsQueue", () => refreshCanvasComponentsQueue);
$parcel$export(module.exports, "checkIfReferencedInOtherCanvasItems", () => checkIfReferencedInOtherCanvasItems);
$parcel$export(module.exports, "openComponent", () => openComponent);
function findComponentOnCanvas(key) {
    const Collection = this.getCanvasCollection();
    return Collection?.lookdown((el)=>{
        return el.state?.key === key && el.Flex;
    });
}
function findWhereItsUsedOnCanvas(key) {
    const Collection = this.getCanvasCollection();
    return Collection.lookdownAll((el)=>el?.state?.uses?.includes(key));
}
async function refreshComponentsWhereReferencedOnCanvas(key, opts) {
    const foundInOtherComponents = this.findWhereItsUsedOnCanvas(key);
    if (foundInOtherComponents) await foundInOtherComponents.forEach(async (v)=>{
        if (v.Flex) await v.update({}, {
            forceReset: true,
            ...opts
        });
    });
}
async function refreshComponentOnCanvas(key, obj, opts = {}) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasRefreshComponentOnCanvas)
    const _canvasFork = this?.context?.methods?.canvasRefreshComponentOnCanvas;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    const activeElement = this.findComponentOnCanvas(key);
    if (!activeElement) return this.warn('Cant find on canvas');
    try {
        await activeElement.state.replace(obj, {
            forceReset: true,
            onError: opts.onError
        });
    } catch (e) {
        opts.onError?.(e);
    }
    await this.call('refreshComponentsWhereReferencedOnCanvas', key, opts);
}
function queueUpdateItemInCanvas(key) {
    const data = this.getCanvasScope();
    if (!data.queueToUpdate) data.queueToUpdate = [];
    if (data.queueToUpdate.indexOf(key) === -1) data.queueToUpdate.push(key);
}
async function refreshCanvasComponentsQueue() {
    const data = this.getCanvasScope();
    const { queueToUpdate } = data;
    if (!queueToUpdate || !queueToUpdate.length) return;
    queueToUpdate.forEach((key)=>{
        const type = this.getType(key);
        this.call('updateItemInCanvas', type, key);
    });
    data.queueToUpdate = [];
}
function checkIfReferencedInOtherCanvasItems(type, key) {
    const usedInComponents = Object.values(this.getSchema('components')).filter((v)=>v.uses?.includes(key)).map((v)=>v.key);
    const usedInPages = Object.values(this.getSchema('pages')).filter((v)=>v.uses?.includes(key)).map((v)=>v.key);
    const usedIn = usedInComponents.concat(usedInPages);
    const confirmDeps = `Component is used in "${usedIn.join(', ')}" ${type.slice(0, -1)}, do you want to remove it anyway?`;
    // TODO(@symbo.ls/windows migration): replace `window.confirm` with
    // `this.call('confirmDialog', { ... })`. The function currently
    // returns false synchronously when the user declines, and callers
    // (workspace/canvas, design system editor, etc.) read that boolean to
    // decide whether to proceed with the removal. A clean migration
    // means converting this function + every caller chain to callback /
    // async. Deferred until the dependent code paths are inventoried.
    // Validation alerts in workspace/packages/shared/methods/db.js have
    // already moved to the unified dialog.
    if (usedIn.length && !window.confirm(confirmDeps)) return false;
    return usedIn;
}
async function openComponent(opts = {}) {
    const { props, state } = this;
    const { value, extend } = state;
    let key = value || state.key;
    if (extend) key = Array.isArray(extend) ? extend[0] : extend;
    if (props?.extend) key = props.extend;
    const type = this.getType(key);
    if (!type) return;
    const SMBLS_COMPONENT = this.context[type][key];
    const PROJECT_COMPONENT = this.getItem(key);
    let isComponent = this.call('checkIfKeyIsComponent', key) && (SMBLS_COMPONENT || PROJECT_COMPONENT);
    if (!isComponent) {
        const DEFAULT_COMPONENT = await this.getDefaultComponents()[key];
        if (DEFAULT_COMPONENT) isComponent = DEFAULT_COMPONENT;
        else return;
    }
    const s = this.getCanvasCollection()?.lookdown((el)=>el.state?.key === key);
    if (s) this.activateSelected(s);
    if (!opts.chosenOnCmd && !this.getRootState('isModifierPressed')) this.activateChosen(s);
}

});

parcelRegister("8DDsD", function(module, exports) {

$parcel$export(module.exports, "getTabs", () => getTabs);
$parcel$export(module.exports, "getTabsState", () => getTabsState);
$parcel$export(module.exports, "refreshTabs", () => refreshTabs);
$parcel$export(module.exports, "addToTabs", () => addToTabs);
$parcel$export(module.exports, "isInTabs", () => isInTabs);
$parcel$export(module.exports, "closeTab", () => closeTab);
$parcel$export(module.exports, "cleanTabs", () => cleanTabs);
$parcel$export(module.exports, "closeComponentTab", () => closeComponentTab);
$parcel$export(module.exports, "updateTabsLocalStorage", () => updateTabsLocalStorage);
function getTabs() {
    return this.getCanvas().parent.CanvasNavbar;
}
function getTabsState() {
    return this.getRootState().activeTabs;
}
function refreshTabs() {
    this.getTabs().update();
}
function addToTabs(key, opts = {}) {
    const platformState = this.getRootState();
    const activeTabs = this.getTabsState();
    const item = this.getSchemaItem(key);
    const type = this.getType(key);
    const routeExists = activeTabs.filter((v)=>v.key === key);
    if (!routeExists.length) activeTabs.push({
        key: key,
        type: type,
        title: item?.title || key
    });
    this.updateTabsLocalStorage();
    platformState.quietReplace({
        activeTabs: activeTabs
    });
    if (!opts.preventUpdate) this.refreshTabs();
}
function isInTabs(key) {
    const platformState = this.getRootState();
    const { activeTabs } = platformState;
    return activeTabs.filter((v)=>v.key === key)[0];
}
function closeTab(key, opts = {}) {
    const platformState = this.getRootState();
    const { activeTabs } = platformState;
    const activeIndex = activeTabs.findIndex((v)=>v.key === key);
    if (activeIndex < 0) return;
    if (activeTabs[activeIndex]?.key === this.getChosenKey()) this.activateChosen(null);
    this.call('removeFromArray', activeTabs, activeIndex);
    this.updateTabsLocalStorage();
    platformState.quietReplace({
        activeTabs: activeTabs
    });
    if (!opts.preventUpdate) this.refreshTabs();
}
function cleanTabs() {
    const platformState = this.getRootState();
    const activeTabs = platformState.activeTabs = [];
    const key = `activeTabs_${platformState.appKey}${platformState.branch}`;
    window.localStorage.removeItem(key);
    if (platformState.appKey) window.localStorage.setItem(key, JSON.stringify(activeTabs));
}
function closeComponentTab() {
    const activeTabs = this.getTabsState();
    activeTabs.forEach(()=>{
    // if (val.route === '/editor/' + componentKey) closeTab(key)
    });
}
function updateTabsLocalStorage() {
    const platformState = this.getRootState();
    const { activeTabs } = platformState;
    const key = `activeTabs_${platformState.appKey}${platformState.branch}`;
    window.localStorage.removeItem(key);
    if (platformState.appKey) window.localStorage.setItem(key, JSON.stringify(activeTabs));
}

});

parcelRegister("jjMOM", function(module, exports) {

$parcel$export(module.exports, "getWindow", () => getWindow);
$parcel$export(module.exports, "getWindowElements", () => getWindowElements);
$parcel$export(module.exports, "getWindowKeys", () => getWindowKeys);
$parcel$export(module.exports, "setWindow", () => setWindow);
$parcel$export(module.exports, "openWindow", () => openWindow);
$parcel$export(module.exports, "closeWindow", () => closeWindow);
$parcel$export(module.exports, "refreshWindow", () => refreshWindow);
$parcel$export(module.exports, "toggleWindow", () => toggleWindow);
$parcel$export(module.exports, "isWindowMinimized", () => isWindowMinimized);
$parcel$export(module.exports, "isWindowExpanded", () => isWindowExpanded);
$parcel$export(module.exports, "minimizeWindow", () => minimizeWindow);
$parcel$export(module.exports, "toggleExpandWindow", () => toggleExpandWindow);
$parcel$export(module.exports, "expandWindow", () => expandWindow);
$parcel$export(module.exports, "toggleLibrary", () => toggleLibrary);
function getWindow(key) {
    const data = this.getCanvasScope();
    if (!key) return data || {};
    return data?.[key];
}
function getWindowElements(key) {
    const DynamicIsland = this.getDynamicIsland();
    const DocsView = this.getDocsView();
    const map = {
        explorer: [
            // Canvas.parent.DsNavbar,
            // CanvasNavbar.CanvasPanel,
            DynamicIsland
        ],
        // editorPanels: EditorPanels,
        docs: DocsView,
        modal: this.getCanvasModal()
    };
    return key ? map[key.split('Minimized')[0]] : map;
}
function getWindowKeys(excl = []) {
    const keys = Object.keys(this.getWindowElements());
    return excl ? this.call('filterArrays', keys, excl) : keys;
}
async function setWindow(key, val, opts = {
    preventUpdate: [
        'Iframe'
    ]
}) {
    const data = this.getCanvasScope();
    const elementsToUpdate = this.getWindowElements(key);
    const applyElementUpdate = async (elem)=>{
        if (elem.props['.isWindowActive']) elem.setNodeStyles(val ? elem.props['.isWindowActive'] : elem.props['!isWindowActive']);
        else await elem.update({}, opts);
    };
    data[key] = val;
    if (this.call('isArray', elementsToUpdate)) elementsToUpdate.forEach((item)=>{
        if (!item.update) return console.error('no update for', item);
        const t = setTimeout(async ()=>{
            await applyElementUpdate(item);
            clearTimeout(t);
        }, 15);
    });
    else if (!elementsToUpdate?.update) this.warn('No update for', key, elementsToUpdate);
    else if (!opts.forceUpdate && this.call('isBoolean', val)) elementsToUpdate.setNodeStyles({
        display: val ? 'flex' : 'none'
    });
    else await applyElementUpdate(elementsToUpdate);
    this.call('setCookie', key, val);
    this.syncCanvas({
        [key]: val
    });
}
function openWindow(key, opts) {
    return this.setWindow(key, true, {
        forceUpdate: true,
        ...opts
    });
}
function closeWindow(key, opts) {
    return this.setWindow(key, false, {
        forceUpdate: true,
        ...opts
    });
}
function refreshWindow(key, opts) {
    const data = this.getCanvasScope();
    this.setWindow(key, data[key], {
        forceUpdate: true,
        ...opts
    });
}
function toggleWindow(key, opts) {
    const data = this.getCanvasScope();
    this.setWindow(key, !data[key], {
        forceUpdate: true,
        ...opts
    });
}
function isWindowMinimized(key) {
    const data = this.getCanvasScope();
    return data[`${key}Minimized`];
}
function isWindowExpanded(key) {
    return !this.isWindowMinimized(key);
}
function minimizeWindow(key) {
    const data = this.getCanvasScope();
    data[`${key}Minimized`] = true;
    return this.refreshWindow(key);
}
function toggleExpandWindow(key) {
    const data = this.getCanvasScope();
    data[`${key}Minimized`] = !data[`${key}Minimized`];
    return this.refreshWindow(key);
}
function expandWindow(key) {
    const data = this.getCanvasScope();
    data[`${key}Minimized`] = false;
    return this.refreshWindow(key);
}
function toggleLibrary() {
    this.toggleWindow('library');
    this.getDynamicIsland().setNodeStyles(this.getDynamicIsland().props[this.getWindow('library') ? '.isLibraryActive' : '!isLibraryActive']);
    this.getDynamicIsland().Library.setNodeStyles(this.getDynamicIsland().Library.props[this.getWindow('library') ? '.isVisible' : '!isVisible']);
    this.getDynamicIsland().CanvasProjectSidebar.setNodeStyles(this.getDynamicIsland().CanvasProjectSidebar.props[this.getWindow('library') ? '!isVisible' : '.isVisible']);
}

});

parcelRegister("9Lyx0", function(module, exports) {

$parcel$export(module.exports, "listAll", () => listAll);
$parcel$export(module.exports, "filterKeys", () => filterKeys);
$parcel$export(module.exports, "listAllAsArray", () => listAllAsArray);
$parcel$export(module.exports, "listSidebar", () => listSidebar);
function listAll(type, opts = {}) {
    const designSystemList = [
        'reset',
        'sequence',
        'unit',
        'font',
        'font_family',
        'font_face',
        'media',
        'gradient',
        'shadow',
        'icons',
        'semantic_icons',
        'timing',
        'document',
        'breakpoints',
        'devices',
        'cases',
        'animation',
        'svg',
        'grid',
        'class'
    ];
    const designSystem = opts.activeFileSidebar === 'Local' ? this.getDesignSystem() : opts.designSystem;
    // default
    if (designSystemList.includes(type)) return designSystem[type];
    // specific logics
    if (type === 'color') {
        const allColors = designSystem[type];
        return allColors && Object.entries(allColors).reduce((initial, [key, value])=>{
            if (this.call('isString', value)) return {
                ...initial,
                [key]: value
            };
            return initial;
        }, {});
    }
    if (type === 'semantic_color') {
        const allColors = designSystem.color;
        return allColors && Object.entries(allColors).reduce((initial, [key, value])=>{
            if (!this.call('isString', value)) return {
                ...initial,
                [key]: value
            };
            return initial;
        }, {});
    }
    if (type === 'theme') {
        const allThemes = designSystem[type];
        return allThemes && Object.entries(allThemes).reduce((initial, [key, value])=>{
            if (key !== 'document') return {
                ...initial,
                [key]: value
            };
            return initial;
        }, {});
    }
    if (type === 'global_theme') return designSystem.theme?.document;
    if (type === 'spacing') return this.filterKeys(designSystem.spacing, true);
    if (type === 'typography') return this.filterKeys(designSystem.typography, true);
    if (type === 'templates') return this.filterKeys(designSystem.typography?.templates, false);
    return opts[type];
}
function filterKeys(obj, keepAt = false) {
    if (!obj || typeof obj !== 'object') return obj;
    return Object.fromEntries(Object.entries(obj).filter(([key])=>key[0] === '@' === keepAt));
}
function listAllAsArray(type, opts = {}) {
    const data = this.call('listAll', type, opts);
    if (!data) return [];
    const res = Object.keys(data).reduce((initial, key)=>{
        const map = {
            key: key,
            type: type,
            value: data[key],
            ...opts.withSchema ? {} : {}
        };
        if (!opts.search) return [
            ...initial,
            map
        ];
        if (key.toLowerCase().includes(opts.search.toLowerCase()) || typeof data[key] === 'string' && data[key].toLowerCase().includes(opts.search.toLowerCase())) return [
            ...initial,
            map
        ];
        return initial;
    }, []);
    if (!res.length && opts.search) this.state.update({
        noResults: true
    });
    if (opts.sort && opts.sortIf) return res.sort(opts.sort);
    return res;
}
async function listSidebar(type, opts = {
    activeFileSidebar: 'Local'
}) {
    const activeFileSidebar = opts.activeFileSidebar || 'Local';
    const data = await this.call('getDynamicIslandDataByCategory', activeFileSidebar);
    const isLocal = activeFileSidebar === 'Local';
    const designSystem = isLocal ? this.getDesignSystem() : opts.designSystem;
    return this.call('listAllAsArray', type, {
        withSchema: false,
        ...opts,
        activeFileSidebar: activeFileSidebar,
        ...data
    }).filter((v)=>{
        const allowGlobals = [
            'dependencies',
            'secrets'
        ];
        if (allowGlobals.includes(type)) return true;
        if (designSystem?.[type]) return true;
        // TODO: remove components when variants are implemented
        const dotsAllowedList = [
            'files',
            'dependencies',
            'secrets',
            'components'
        ];
        if (!dotsAllowedList.includes(type) && v.key.includes('.')) return false;
        if (opts.search) return true;
        if (isLocal && [
            'pages',
            'components'
        ].includes(type)) return this.call('inOnCurrentCanvasPage', type, v.key);
        return true;
    });
}

});

parcelRegister("l4Kfs", function(module, exports) {

$parcel$export(module.exports, "setDesignSystem", () => setDesignSystem);
$parcel$export(module.exports, "updateDesignSystemOnCanvas", () => updateDesignSystemOnCanvas);
$parcel$export(module.exports, "getDesignSystem", () => getDesignSystem);
$parcel$export(module.exports, "isBuiltinDS", () => isBuiltinDS);
$parcel$export(module.exports, "updateDesignSystem", () => updateDesignSystem);
$parcel$export(module.exports, "bulkUpdateDesignSystem", () => bulkUpdateDesignSystem);
$parcel$export(module.exports, "activeAddingFloatingPanel", () => activeAddingFloatingPanel);
/**
 * Resets the Design System with the provided object.
 * @param {object} obj - Object to reset the Design System with.
 * @param {object} [opts={}] - Options for resetting the Design System.
 */ function setDesignSystem(obj, opts = {}) {
    const { version, ...value } = obj;
    const designSystem = this.getData().designSystem = value;
    this.sdk.updateData([
        'update',
        [
            'designSystem'
        ],
        designSystem
    ], {
        message: 'Reset Design System',
        ...opts
    });
    this.updateDesignSystemOnCanvas(this.getDesignSystem(), opts);
}
function updateDesignSystemOnCanvas(obj) {
    const Collection = this.getCanvasCollection();
    if (!Collection) return;
    Collection.call('reinit', Collection.call('deepClone', obj), {
        preventInject: true
    });
    const vars = Collection.lookup('vars');
    if (vars?.update) vars.update();
}
function getDesignSystem(type) {
    const designSystem = this.getData('designSystem');
    // `getBuiltins()` reads root state DEFAULTS.DS_DEFAULTS, which a host that
    // never seeded the defaults simply does not have. The stored design system
    // below is already treated as optional (`designSystem?.[upper]`) — the
    // builtins get the same treatment, or the spread throws and takes both
    // ThemeDropdown and ThemeSelect down with it.
    const defaultData = this.getBuiltins() || {};
    if (type) {
        const lower = String(type).toLowerCase();
        const upper = String(type).toUpperCase();
        return {
            ...defaultData[upper],
            ...defaultData[lower],
            ...designSystem?.[upper],
            ...designSystem?.[lower]
        };
    }
    return designSystem;
}
function isBuiltinDS(type, field) {
    if (!type || !field) return false;
    const defaultData = this.getDefaults('DS_DEFAULTS') // await this.getDefaultDesignSystem()
    ;
    return Boolean(defaultData?.[type.toUpperCase()]?.[field]);
}
async function updateDesignSystem(key, val, opts = {}) {
    // Object form: build one tuple per top-level category and emit them in a
    // single sdk.updateData batch. Categories live at lowercase keys in the
    // stored data (matches example_tmr.json + scratch CONFIG + Icon.js's
    // `ctx.designSystem.icons` lookup) — do NOT uppercase paths anymore;
    // doing so silently writes to a parallel `ICONS` / `COLOR` namespace
    // that no consumer reads from, which was the underlying #2050 issue.
    if (key && typeof key === 'object' && !Array.isArray(key)) {
        const objectOpts = val && typeof val === 'object' && !Array.isArray(val) ? {
            ...val,
            ...opts
        } : opts;
        const tuples = [];
        const touchedTypes = [];
        for(const category in key){
            if (!Object.prototype.hasOwnProperty.call(key, category)) continue;
            const entries = key[category];
            if (entries && typeof entries === 'object' && !Array.isArray(entries)) {
                // { icons: { iconName: '<svg>' } } → one tuple per leaf so we
                // don't clobber sibling icons stored under the same category.
                for(const leaf in entries){
                    if (!Object.prototype.hasOwnProperty.call(entries, leaf)) continue;
                    const value = entries[leaf];
                    const path = [
                        'designSystem',
                        category,
                        leaf
                    ];
                    tuples.push(value != null ? [
                        'update',
                        path,
                        value
                    ] : [
                        'delete',
                        path
                    ]);
                }
                touchedTypes.push(category);
            } else {
                // Scalar / null replaces the whole category — used by theme flip etc.
                const path = [
                    'designSystem',
                    category
                ];
                tuples.push(entries != null ? [
                    'update',
                    path,
                    entries
                ] : [
                    'delete',
                    path
                ]);
                touchedTypes.push(category);
            }
        }
        if (tuples.length) this.sdk.updateData(tuples, {
            message: objectOpts.message || `Updated ${touchedTypes.join(', ')}`,
            ...objectOpts
        });
        if (touchedTypes.includes('MEDIA') || touchedTypes.includes('media')) this.getCanvas()?.update();
        else this.updateDesignSystemOnCanvas(this.getDesignSystem(), objectOpts);
        if (!objectOpts.preventSidebarUpdate) for (const t of touchedTypes){
            let sectionType = t.toLowerCase();
            if (objectOpts.isSemanticColor) sectionType = 'semantic_color';
            else if (objectOpts.isGlobalTheme) sectionType = 'global_theme';
            else if (objectOpts.isTextStyles) sectionType = 'templates';
            const updatedSection = await this.call('rerenderFileSidebarByType', sectionType);
            if (!updatedSection) await this.getDynamicIsland()?.update();
        }
        return;
    }
    const path = [
        'designSystem'
    ].concat(Array.isArray(key) ? key : key.split('.'));
    this.sdk.updateData(val ? [
        [
            'update',
            path,
            val
        ]
    ] : [
        [
            'delete',
            path
        ]
    ], {
        message: val ? `Updated ${key}` : `Removed ${key}`,
        ...opts
    });
    const type = path[path.length - 2];
    if (type === 'MEDIA' || type === 'media') this.getCanvas().update();
    else this.updateDesignSystemOnCanvas(this.getDesignSystem(), opts);
    if (!opts.preventSidebarUpdate) {
        let sectionType = String(type || '').toLowerCase();
        if (opts.isSemanticColor) sectionType = 'semantic_color';
        else if (opts.isGlobalTheme) sectionType = 'global_theme';
        else if (opts.isTextStyles) sectionType = 'templates';
        const updatedSection = await this.call('rerenderFileSidebarByType', sectionType);
        if (!updatedSection) await this.getDynamicIsland()?.update();
    }
}
function bulkUpdateDesignSystem(changes, message, opts = {}) {
    if (!message || !changes) return;
    const parsed = changes.map(({ type, path: p, value })=>{
        const path = p.includes('designSystem') ? p : [
            'designSystem',
            ...p
        ];
        return value ? [
            type,
            path,
            value
        ] : [
            type,
            path
        ];
    });
    this.sdk.updateData(parsed, {
        message: message,
        ...opts
    });
    if (!opts.preventSidebarUpdate) this.lookup('DynamicIsland')?.update();
    this.updateDesignSystemOnCanvas(this.getDesignSystem(), opts);
}
function activeAddingFloatingPanel(event, type) {
    const Section = this.call('findFileSidebarSection', type);
    if (!Section) return;
    Section?.node?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'center'
    });
    const t = setTimeout(()=>{
        const AddButton = Section.lookdown('IconButton.add');
        AddButton.onClick(event, AddButton, AddButton.state);
        clearTimeout(t);
    }, 350);
}

});

parcelRegister("kL2H3", function(module, exports) {

$parcel$export(module.exports, "getModal", () => getModal);
$parcel$export(module.exports, "getModalData", () => getModalData);
$parcel$export(module.exports, "openRouterModal", () => openRouterModal);
$parcel$export(module.exports, "closeRouterModal", () => closeRouterModal);
$parcel$export(module.exports, "removeModal", () => removeModal);
function getModal() {
    return this.getRoot()?.Modal;
}
function getModalData(key) {
    const data = this.getModal()?.data;
    if (key) return data?.[key];
    return data;
}
async function openRouterModal(key, val, opts = {}) {
    const el = this;
    // Canvas v2 surfaces route `/settings` to the in-canvas settings overlay
    // instead of opening a routed modal — used to live in canvas/methods/
    // openModal as a name-shadow shim; folded here to drop the name clash.
    if (key === '/settings' && el.call?.('isCanvasV2')) {
        el.call('toggleCanvasSettings');
        return;
    }
    const root = el.getRoot();
    const Modal = root.Modal;
    let FoundModal;
    // if () {
    if (key && this.getCanvasScope()) this.getCanvasScope().modal = key;
    const modalKey = key || val?.key || this.getWindow('modal');
    const content = Modal.routes[modalKey];
    if (content) {
        this.getRootState().activeModal = modalKey;
        FoundModal = content;
    } else {
        const modalParams = el.call('findModal');
        // if (val?.key) this.router(val?.key)
        if (!modalParams || opts.forcePreviewUpdate) return;
        this.getRootState().activeModal = modalParams.beforeLastRoute || modalParams.lastRoute;
        FoundModal = modalParams.FoundModal;
    }
    if (FoundModal) {
        root.state.activeModal = modalKey;
        if (root.Modal.content && !opts.forced) return;
        root.Modal.setNodeStyles({
            opacity: '1',
            visibility: 'visible',
            pointerEvents: 'auto'
        });
        await root.Modal.removeContent();
        await root.Modal.set({
            extends: FoundModal,
            state: val,
            animation: 'modalIn',
            animationFillMode: 'both',
            ...opts.animationProps
        }, {
            ...opts,
            bySet: true
        });
    }
}
async function closeRouterModal() {
    const el = this;
    // v3.14 stateKey-driven modals first: walk up from the caller (typically
    // the ModalHeader Close icon) until we find an ancestor declaring
    // `stateKey`. Clearing `root[stateKey]` (and any `extraClose` keys) is
    // the canonical close path — it flips Modal.display back to 'none' via
    // the reactive `display` factory in `shared/components/Modal.js`.
    //
    // Without this walk-up, the brand `ModalHeader.Icons.Close` button (which
    // calls `el.call('closeModal')`) hit the legacy `root.Modal`-driven path
    // below, found no `root.Modal`, and silently no-op'd — the window stayed
    // open. (#2175)
    //
    // The legacy path remains as a fallback for any element that still relies
    // on the router-driven `root.Modal` modal (e.g. canvas overlay flows).
    const root = el?.state?.root;
    if (root?.update) {
        let m = el;
        while(m){
            const sk = typeof m.stateKey === 'string' ? m.stateKey : null;
            if (sk) {
                const extra = m.extraClose && typeof m.extraClose === 'object' && !Array.isArray(m.extraClose) ? m.extraClose : null;
                root.update(extra ? {
                    [sk]: null,
                    ...extra
                } : {
                    [sk]: null
                });
                return;
            }
            m = m.parent;
        }
    }
    // Legacy `root.Modal`-driven modal (router-mounted). Preserved for any
    // canvas/preview surfaces still using the old Modal renderer.
    const Modal = el.getModal();
    delete this.getRootState().activeModal;
    Modal?.setNodeStyles({
        opacity: '0',
        visibility: 'hidden',
        pointerEvents: 'none'
    });
    await Modal?.content?.update({
        animation: 'modalOut',
        animationDuration: '0',
        animationDelay: '0'
    });
    const t = setTimeout(async ()=>{
        await el.call('removeModal');
        clearTimeout(t);
    }, 350);
}
async function removeModal() {
    const Modal = this.getModal();
    // if (location.pathname !== '/canvas') {
    //   const { index } = this.call('findModal')
    //   const path = window.location.pathname
    //   const routes = path.slice(1).split('/').slice(0, -index)
    //   const href = '/' + routes.join('/')
    //   this.router(
    //     href,
    //     this.getRoot(),
    //     {},
    //     {
    //       scrollToTop: false,
    //       updateStateOptions: {
    //         scrollToTop: false,
    //         forceRerender: true,
    //         onlyUpdate: 'Modal'
    //       }
    //     }
    //   )
    // }
    await Modal?.removeContent();
}

});

parcelRegister("Mc7tV", function(module, exports) {

$parcel$export(module.exports, "getPlural", () => getPlural);
$parcel$export(module.exports, "getSingular", () => getSingular);
$parcel$export(module.exports, "getType", () => getType);
$parcel$export(module.exports, "getTypeByKey", () => getTypeByKey);
$parcel$export(module.exports, "getSchemaItem", () => getSchemaItem);
$parcel$export(module.exports, "getDataItem", () => getDataItem);
$parcel$export(module.exports, "getItem", () => getItem);
$parcel$export(module.exports, "prepareSchemaItem", () => prepareSchemaItem);
$parcel$export(module.exports, "setItemSchema", () => setItemSchema);
$parcel$export(module.exports, "prepareDataItem", () => prepareDataItem);
$parcel$export(module.exports, "setItemData", () => setItemData);
$parcel$export(module.exports, "validateFormat", () => validateFormat);
$parcel$export(module.exports, "validateItem", () => validateItem);
$parcel$export(module.exports, "findNewName", () => findNewName);
$parcel$export(module.exports, "convertToDomql3", () => convertToDomql3);
$parcel$export(module.exports, "restoreMissingTypes", () => restoreMissingTypes);
$parcel$export(module.exports, "restoreMissingComponents", () => restoreMissingComponents);
$parcel$export(module.exports, "clearCache", () => clearCache);
$parcel$export(module.exports, "getDefaultValuePerType", () => getDefaultValuePerType);
$parcel$export(module.exports, "buildSchemaItemFromData", () => buildSchemaItemFromData);
function getPlural(key) {
    const overwriteMap = {
        state: 'state',
        dependency: 'dependencies',
        font_family: 'font_families',
        typography: 'typographies'
    };
    return overwriteMap[key] || key.endsWith('s') ? key : `${key}s`;
}
function getSingular(key) {
    const overwriteMap = {
        dependencies: 'dependency'
    };
    return overwriteMap[key] || key.endsWith('s') && key.slice(0, -1) || key;
}
function getType(target) {
    const hasType = target && target.type;
    if (hasType) return this.getPlural(target.type);
    const itemKey = this.call('isString', target) ? target : target?.key || this.state.key;
    const schema = this.getSchema();
    return this.getTypeByKey(itemKey) || Object.keys(schema).find((key)=>itemKey in schema[key]) || null;
}
function getTypeByKey(val) {
    const key = val || this.state?.key;
    if (!key) return;
    const isPage = key.startsWith('/');
    if (isPage) return 'pages';
    const isComponent = /^[A-Z]*$/u.test(key.slice(0, 1));
    if (isComponent) return 'components';
    const isFile = /^[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*\.[a-zA-Z0-9]+$/u.test(key);
    if (isFile) return 'files';
    const isDependecy = /^(?:@[a-z-~][a-z-._~]*\/)?[a-z-~][a-z-._~]*$/u.test(key);
    if (isDependecy) return 'dependencies';
    const isFunction = /^[a-z][a-zA-Z0-9_]*$/u.test(key);
    if (isFunction) return 'functions';
}
function getSchemaItem(key, type) {
    const schema = this.getSchema();
    if (!type) type = this.getType(key);
    type = this.getPlural(type);
    if (key && type && schema[type]?.[key]) return schema[type][key];
    const parentObject = Object.values(schema).find((childObj)=>key in childObj);
    return parentObject ? parentObject[key] : null;
}
function getDataItem(key, type) {
    if (!key) return null;
    if (!type) type = this.getType(key);
    type = this.getPlural(type);
    if (type && this.getData(type)?.[key]) return this.getData(type)[key];
    const parentObject = Object.values(this.getData()).find((childObj)=>key in childObj);
    return parentObject ? parentObject[key] : null;
}
function getItem(key, type) {
    if (!this.getDataItem(key, type) && !this.getSchemaItem(key, type)) return;
    return {
        ...this.getSchemaItem(key, type),
        value: this.getDataItem(key, type)
    };
}
function prepareSchemaItem(obj, forcedKey, forcedType) {
    let { value, ...schema } = this.getParsedState(obj);
    // if item has a new name
    if (forcedKey && forcedKey !== schema.key) {
        schema = this.call('deepClone', schema);
        schema.key = forcedKey;
    }
    if (forcedType && forcedType !== schema.type) schema.type = forcedType;
    return schema;
}
function setItemSchema() {}
function prepareDataItem(obj) {
    const { value } = this.getParsedState(obj);
    return value;
}
function setItemData() {}
function validateFormat(val, arr = [
    'png',
    'svg',
    'jpeg',
    'jpg',
    'gif',
    'bmp',
    'tiff',
    'tif',
    'webp',
    'ico',
    'mp4',
    'webm',
    'avi',
    'mov',
    'wmv',
    'flv',
    'mkv',
    '3gp',
    'mp3',
    'wav',
    'ogg',
    'm4a',
    'flac',
    'aac',
    'wma',
    'mid',
    'midi',
    'pdf',
    'doc',
    'docx',
    'ppt',
    'pptx',
    'xls',
    'xlsx',
    'zip',
    'rar',
    '7z',
    'woff',
    'woff2',
    'ttf',
    'otf' // Fonts
]) {
    return arr.includes(val);
}
function validateItem(obj) {
    const type = this.getType(obj);
    const { key, value } = obj;
    if (!type) return console.error('Type of item is uknown', obj);
    if (!key) return console.error(`${type} does not have a key`, obj);
    if (!value) return console.error(`"${key}" ${type} does not have a value`, obj);
    // Migrated from `window.alert(...)` → `el.call('alertDialog', { ... })`.
    // alertDialog is fire-and-forget (no value returned, the original code
    // didn't read the return value either — `return` was used purely to bail
    // the validation function). The unified dialog matches the app's design
    // system instead of the host OS chrome.
    if (type === 'component') {
        if (!/^[A-Z]*$/u.test(key.slice(0, 1))) {
            this.call('alertDialog', {
                title: this.call('polyglot', 'editor.db.invalidComponentKey'),
                message: this.call('polyglot', 'editor.db.componentKeyCapital').replace('{key}', key)
            });
            return;
        }
        if (!/^[a-zA-Z0-9._]+$/u.test(key.slice(0, 1))) {
            this.call('alertDialog', {
                title: this.call('polyglot', 'editor.db.invalidComponentKey'),
                message: this.call('polyglot', 'editor.db.componentKeyChars').replace('{key}', key)
            });
            return;
        }
    } else if (type === 'page') {
        if (!key.startsWith('/')) {
            this.call('alertDialog', {
                title: this.call('polyglot', 'editor.db.invalidPageKey'),
                message: this.call('polyglot', 'editor.db.pageKeySlash').replace('{key}', key)
            });
            return;
        }
    } else if (type === 'function') {
        if (!this.call('isFunction', value)) {
            this.call('alertDialog', {
                title: this.call('polyglot', 'editor.db.invalidFunction'),
                message: this.call('polyglot', 'editor.db.notAFunction').replace('{key}', key)
            });
            return;
        }
    } else if (type === 'file') {
        if (obj.contentType === 'file') {
            if (!obj.format) {
                this.call('alertDialog', {
                    title: this.call('polyglot', 'editor.db.invalidFile'),
                    message: this.call('polyglot', 'editor.db.fileFormatInvalid').replace('{key}', key)
                });
                return;
            }
            if (!this.validateFormat(obj.format)) {
                this.call('alertDialog', {
                    title: this.call('polyglot', 'editor.db.unsupportedFormat'),
                    message: this.call('polyglot', 'editor.db.formatNotSupported').replace('{format}', obj.format)
                });
                return;
            }
        }
        if (obj.contentType === 'file' && !value) {
            this.call('alertDialog', {
                title: this.call('polyglot', 'editor.db.invalidFile'),
                message: this.call('polyglot', 'editor.db.fileSourceInvalid').replace('{key}', key)
            });
            return;
        }
    }
    return true;
}
function findNewName(type, key, opts = {}) {
    let index = 0;
    const isPage = type === 'pages' || key.startsWith('/');
    while(true){
        let itemExists;
        if (type === 'global_theme') itemExists = this.getDesignSystem('theme').document[key];
        else if (type === 'typography' && key.charAt(0) !== '@') itemExists = this.getDesignSystem('typography').templates[key];
        else if (this.call('hasType', 'DESIGN_SYSTEM_TYPES', type)) itemExists = this.getDesignSystem(type)[key];
        else itemExists = this.getSchemaItem(key, type) || this.getDataItem(key, type);
        if (!itemExists) break;
        const suffix = (isPage ? '-copy' : 'Copy') + (index || '');
        const msg = 'Component with such key exists. Please type the new key';
        index++;
        if (opts.autoRename) {
            key = key + suffix;
            continue;
        }
        // TODO(@symbo.ls/windows migration): convert this synchronous prompt
        // loop to a Promise-wrapped promptDialog. Skipping for now because
        // the surrounding function (findUniqueKey) returns a value its
        // callers consume synchronously — fully migrating means making this
        // function async and updating every consumer call site. Tracked as
        // follow-up; the validation alerts in the same file (above) have
        // already been migrated to the unified dialog.
        key = window.prompt(msg, key + suffix);
        if (!key) return;
    }
    return key;
}
async function convertToDomql3() {
    const data = this.getData();
    const update = [];
    [
        'pages',
        'components'
    ].forEach((type)=>{
        Object.keys(data[type]).forEach((itemKey)=>{
            const value = data[type][itemKey];
            if (!value) return;
            else {
                update.push([
                    'update',
                    [
                        type,
                        itemKey
                    ],
                    value
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'code'
                    ]
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'codeStr'
                    ]
                ]);
            }
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Converted ${update.length} to domql3 format`
        });
        this.call('openNotification', {
            title: this.call('polyglot', 'editor.db.convertedDomql3.title'),
            message: this.call('polyglot', 'editor.db.convertedDomql3.message').replace('{count}', String(update.length)),
            type: 'success'
        });
    }
}
async function restoreMissingTypes() {
    const data = this.getData();
    const schema = this.getSchema();
    const update = [];
    [
        'pages',
        'components',
        'functions',
        'files',
        'state'
    ].forEach((type)=>{
        Object.keys(data[type]).forEach((itemKey)=>{
            const schemaItem = schema[type][itemKey];
            if (schemaItem && schemaItem.type && schemaItem.type.endsWith('s')) return;
            else update.push([
                'update',
                [
                    'schema',
                    type,
                    itemKey,
                    'type'
                ],
                type
            ]);
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Restored ${update.length} types`
        });
        this.call('openNotification', {
            title: this.call('polyglot', 'editor.db.restoredTypes.title'),
            message: this.call('polyglot', 'editor.db.restoredTypes.message').replace('{count}', String(update.length)),
            type: 'success'
        });
    }
}
async function restoreMissingComponents() {
    const data = this.getData();
    const schema = this.getSchema();
    const update = [];
    [
        'pages',
        'components'
    ].forEach((type)=>{
        Object.keys(data[type]).forEach((itemKey)=>{
            const schemaItem = schema[type][itemKey];
            const dataItem = data[type][itemKey];
            if (dataItem && !schemaItem) update.push([
                'update',
                [
                    'schema',
                    type,
                    itemKey
                ],
                {
                    title: itemKey,
                    key: itemKey,
                    type: type,
                    settings: {
                        gridOptions: {}
                    },
                    interactivity: [],
                    dataTypes: []
                }
            ]);
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Restored ${update.length} components`
        });
        this.call('openNotification', {
            title: this.call('polyglot', 'editor.db.restoredComponents.title'),
            message: this.call('polyglot', 'editor.db.restoredComponents.message').replace('{count}', String(update.length)),
            type: 'success'
        });
    }
}
async function clearCache(opts = {}) {
    const schema = this.getSchema();
    const update = [];
    Object.keys(schema).forEach((type)=>{
        Object.keys(schema[type]).forEach((itemKey)=>{
            const val = schema[type][itemKey];
            // cleanup all values without key
            if (!val.key && type !== 'designSystem') {
                update.push([
                    'delete',
                    [
                        type,
                        itemKey
                    ]
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey
                    ]
                ]);
            }
            if ([
                'pages',
                'components',
                'functions',
                'methods',
                'snippets'
            ].includes(type)) {
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'code'
                    ]
                ]);
                update.push([
                    'delete',
                    [
                        'schema',
                        type,
                        itemKey,
                        'codeStr'
                    ]
                ]);
            }
        });
    });
    if (update.length) {
        this.sdk.updateData(update, {
            message: `Cleared ${update.length} components`
        });
        if (opts.skipNotification) return;
        this.call('openNotification', {
            title: this.call('polyglot', 'editor.db.cacheCleared.title'),
            message: this.call('polyglot', 'editor.db.cacheCleared.message').replace('{count}', String(update.length)),
            type: 'success'
        });
    }
}
function getDefaultValuePerType(type, key) {
    if (this.call('hasType', 'ARTBOARD_TYPES', type)) return {
        key: key,
        type: type,
        value: {},
        settings: {}
    };
    if (this.call('hasType', 'FUNCTION_TYPES', type)) {
        // No code generation from the KEY (ws crm review, N5 batch): this used
        // `new Function(\`return function ${key}() {…}\`)()`, so a co-editor's
        // crafted key (`x(){}(<code>), function y`) ran on the shell origin when
        // the victim clicked Duplicate. The default is a plain function named by
        // defineProperty; the code template names it only with a plain identifier.
        const fnName = /^[A-Za-z_$][\w$]*$/.test(String(key)) ? String(key) : 'fn';
        const value = function() {
        /* console.log(this, this.state, this.context) */ };
        Object.defineProperty(value, 'name', {
            value: fnName,
            configurable: true
        });
        return {
            key: key,
            value: value,
            code: `export default function ${fnName} () {
        // console.log(this, this.state, this.context)
      }`,
            type: type
        };
    }
    return {
        key: key,
        type: type,
        value: {}
    };
}
function buildSchemaItemFromData(type, key, value) {
    const schemaType = this.getPlural ? this.getPlural(type) : type;
    const base = {
        title: key,
        key: key,
        type: schemaType
    };
    if ([
        'pages',
        'components'
    ].includes(schemaType)) {
        base.settings = {
            gridOptions: {}
        };
        base.props = {};
        base.interactivity = [];
        base.dataTypes = [];
        base.error = null;
    }
    let code = null;
    try {
        const rawCode = this.call ? this.call('stringifyCode', value) : null;
        if (rawCode) code = this.call('encodeNewlines', rawCode);
    } catch (e) {
        console.error('Failed to build schema code from data', e);
    }
    if (code) base.code = code;
    return base;
}

});

parcelRegister("17qBN", function(module, exports) {

$parcel$export(module.exports, "replaceWithSecrets", () => replaceWithSecrets);
$parcel$export(module.exports, "replaceSecretsWithKeys", () => replaceSecretsWithKeys);
$parcel$export(module.exports, "getCode", () => getCode);
$parcel$export(module.exports, "stringifyCode", () => stringifyCode);
$parcel$export(module.exports, "parseStringCode", () => parseStringCode);
function replaceWithSecrets(str, secrets) {
    if (!str) return '';
    return str.includes('{{{') ? this.call('replaceLiteralsWithObjectFields', str, {
        bracketsLength: 3
    }, secrets) : str;
}
function replaceSecretsWithKeys(code, secrets) {
    if (!code || !secrets) return code || '';
    const secretKeys = Object.keys(secrets);
    if (secretKeys.length) secretKeys.forEach((secret)=>{
        const val = secrets[secret];
        code = code.replaceAll(val, `{{{ ${secret} }}}`);
    });
    return code;
}
function getCode() {
    const { state } = this;
    const route = this.call('getLastLocationPath', 0);
    const propsCode = this.parent.code;
    if (propsCode === 'components') return this.call('deepClone', state.value);
    else if (propsCode === 'designSystem') {
        const rootCode = this.getDesignSystem() || {};
        const subRoute = route !== '/design-system' && route.slice(1).toUpperCase();
        return subRoute ? rootCode[subRoute] : rootCode;
    } else if (propsCode === 'state') {
        const rootCode = this.getData('state') || {};
        const subRoute = this.call('getLastLocationPath', 1) && this.call('getLastLocationPath', 1).slice(1);
        return subRoute ? rootCode[subRoute] : rootCode;
    } else if (propsCode === 'data') return this.getData();
    else if (propsCode === 'schema') return this.getSchema();
}
function stringifyCode(code, options = {
    preventExportDefult: false,
    syntax: '{}',
    indent: 0
}) {
    const { state } = this;
    const codeToConvert = code || this.call('getCode', this, state);
    const codeStr = this.call('isString', codeToConvert) ? codeToConvert : this.call('isFunction', codeToConvert) ? codeToConvert.toString() : this.call('objectToString', codeToConvert, options.indent);
    const exportDefault = options.preventExportDefult ? '' : 'export default ';
    if (!codeToConvert) return exportDefault + (options.syntax || '{}');
    return exportDefault + this.replaceSecretsWithKeys(codeStr, this.getSecrets());
}

async function parseStringCode(codeStr, opts = {}) {
    if (!codeStr) return null;
    if (codeStr.startsWith('export default ')) codeStr = codeStr.slice(15);
    try {
        const acorn = await Promise.resolve((parcelRequire("gQuVO")));
        // Parse with range info so we can slice original code. `preserveParens`
        // lets us prove the WHOLE buffer is the one wrapped expression: a buffer
        // like `a) , (b` escapes the wrapping parens and used to save a fragment.
        const wrapped = `(${codeStr})`;
        const ast = acorn.parse(wrapped, {
            ecmaVersion: 'latest',
            sourceType: 'module',
            ranges: true,
            preserveParens: true
        });
        const top = ast.body.length === 1 && ast.body[0].type === 'ExpressionStatement' ? ast.body[0].expression : null;
        if (!top || top.type !== 'ParenthesizedExpression' || top.start !== 0 || top.end !== wrapped.length) throw new Error('Not a single expression');
        const src = (node)=>wrapped.slice(node.start, node.end);
        const unparen = (node)=>node && node.type === 'ParenthesizedExpression' ? unparen(node.expression) : node;
        // A method / accessor value as a FUNCTION SOURCE (review M1): acorn starts
        // a method's FunctionExpression at its params, so the value slice alone is
        // "(ev, el) {…}" — not a function, never revived. Re-emit the keyword.
        const fnSource = (fn)=>(fn.async ? 'async ' : '') + 'function' + (fn.generator ? '* ' : ' ') + wrapped.slice(fn.start, fn.end);
        // An own key, whatever its name — `__proto__` never sets the prototype.
        const define = (obj, key, value)=>Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                writable: true,
                configurable: true
            });
        // ---- AST → Object or Raw Source (nothing is evaluated) ----
        function astToObject(node) {
            if (!node) return null;
            switch(node.type){
                case 'ParenthesizedExpression':
                    return astToObject(node.expression);
                case 'Literal':
                    return node.value;
                case 'Identifier':
                    if (node.name === 'undefined') return undefined;
                    if (node.name === 'NaN') return NaN;
                    if (node.name === 'Infinity') return Infinity;
                    return src(node);
                case 'UnaryExpression':
                    {
                        const arg = unparen(node.argument);
                        if ((node.operator === '-' || node.operator === '+') && arg.type === 'Literal' && typeof arg.value === 'number') return node.operator === '-' ? -arg.value : +arg.value;
                        if (node.operator === '-' && arg.type === 'Identifier' && arg.name === 'Infinity') return -Infinity;
                        return src(node);
                    }
                case 'TemplateLiteral':
                    // no expressions: the string itself; with expressions: the source,
                    // backticks included (a template is code, not a value)
                    return node.expressions.length ? src(node) : node.quasis.map((q)=>q.value.cooked).join('');
                case 'ArrayExpression':
                    return node.elements.map((el)=>el ? astToObject(el) : null);
                case 'ObjectExpression':
                    {
                        const obj = {};
                        for (const prop of node.properties){
                            if (prop.type === 'Property') {
                                const key = !prop.computed && prop.key.type === 'Identifier' ? prop.key.name : prop.key.type === 'Literal' ? String(prop.key.value) : src(prop.key);
                                const isFn = prop.method || prop.kind === 'get' || prop.kind === 'set';
                                define(obj, key, isFn ? fnSource(prop.value) : astToObject(prop.value));
                            } else if (prop.type === 'SpreadElement') define(obj, `...${src(prop.argument)}`, astToObject(prop.argument));
                        }
                        return obj;
                    }
                default:
                    return src(node);
            }
        }
        const objectified = astToObject(top.expression);
        if (objectified) return objectified;
        throw new Error('Failed to parse object');
    } catch (e) {
        if (opts.onError) opts.onError(e);
        console.error('Can not parse the string: ' + e.message);
        console.error(e);
        return null;
    }
}

});

parcelRegister("f9WWp", function(module, exports) {

$parcel$export(module.exports, "getActiveBranch", () => $b0956ac10ddda395$export$d9080b502819d98b);
$parcel$export(module.exports, "getActiveVersion", () => $b0956ac10ddda395$export$683d510f1dd3e474);
$parcel$export(module.exports, "getLatestVersion", () => $b0956ac10ddda395$export$892e128ba377ffbb);
$parcel$export(module.exports, "setActiveBranch", () => $b0956ac10ddda395$export$4e5bad2272a13d5);
$parcel$export(module.exports, "setActiveVersion", () => $b0956ac10ddda395$export$b0dd6a74f9517c68);
$parcel$export(module.exports, "getActiveProjectName", () => $b0956ac10ddda395$export$ee497b3c885b8e5e);
$parcel$export(module.exports, "getRootProjects", () => $b0956ac10ddda395$export$3d5e1f66ff556ecb);
$parcel$export(module.exports, "getRootProjectsUsers", () => $b0956ac10ddda395$export$67fbc4483c75d073);
$parcel$export(module.exports, "getRootProjectId", () => $b0956ac10ddda395$export$f030a28031d9be25);
$parcel$export(module.exports, "switchProject", () => $b0956ac10ddda395$export$aa6a184b5d48d926);
$parcel$export(module.exports, "switchProjectByKey", () => $b0956ac10ddda395$export$8a8b34fc133941fe);
function $b0956ac10ddda395$export$d9080b502819d98b() {
    return this.getRootState('branch') || 'main';
}
function $b0956ac10ddda395$export$683d510f1dd3e474() {
    return this.getRootState('version');
}
function $b0956ac10ddda395$export$892e128ba377ffbb() {
    return this.getRootState('latestVersion');
}
async function $b0956ac10ddda395$export$4e5bad2272a13d5(branch = 'main') {
    if (branch === 'new-branch') return await this.call('openRouterModal', '/add-branch');
    const rootState = this.getRootState();
    const previousBranch = rootState.branch;
    const previousVersion = rootState.version;
    rootState.quietUpdate({
        loading: true,
        branch: branch,
        version: null
    });
    window.requestAnimationFrame(async ()=>{
        try {
            // const data = await this.sdk.switchBranch(branch)
            const data = await this.sdk.getProjectData(this.getRootState().projectId, {
                branch: branch
            });
            // Validate data before syncing
            if (!data || Object.keys(data).length === 0) throw new Error('Received empty data from branch switch');
            this.call('sync', data, (synced)=>{
                if (!synced) {
                    // Sync failed, restore previous state
                    rootState.update({
                        loading: false,
                        branch: previousBranch,
                        version: previousVersion
                    });
                    return;
                }
                rootState.replace({
                    ...synced,
                    loading: false
                });
            });
        } catch (error) {
            // Restore previous branch state
            rootState.update({
                loading: false,
                branch: previousBranch,
                version: previousVersion
            });
            console.error('Failed to switch branch:', error);
            this.call('openNotification', {
                type: 'error',
                message: this.call('polyglot', 'editor.project.branchSwitchFailed').replace('{branch}', branch).replace('{error}', error.message)
            });
        }
    });
    this.getCanvas().lookup('Versions').update();
}
async function $b0956ac10ddda395$export$b0dd6a74f9517c68(version) {
    const rootState = this.getRootState();
    // Skip if already on the requested version
    if (rootState.version === version || version === 'latest' && !rootState.isOld) return;
    const previousVersion = rootState.version;
    const previousIsOld = rootState.isOld;
    // Indicate loading state & whether we are on an old version
    rootState.quietUpdate({
        isOld: version !== 'latest'
    });
    // Ensure at least one awaited expression so ESLint's require-await rule passes
    await new Promise((resolve)=>{
        window.requestAnimationFrame(resolve);
    });
    try {
        const data = await this.sdk.getProjectData(rootState.projectId, {
            version: version
        });
        // Validate the received payload
        if (!data || Object.keys(data).length === 0) throw new Error('Received empty data from version switch');
        // Sync freshly received data with the current state first so that we keep
        // socket/client information intact. Once synced – replace the root state
        // to trigger full re-render.
        this.call('sync', data, (synced)=>{
            if (!synced) {
                // Sync failed – rollback to previous state
                rootState.update({
                    version: previousVersion,
                    isOld: previousIsOld
                });
                return;
            }
            rootState.replace({
                ...synced,
                version: version,
                isOld: version !== 'latest'
            });
        });
    } catch (error) {
        // Rollback to the previous state on error
        rootState.replace({
            version: previousVersion,
            isOld: previousIsOld
        });
        console.error('Failed to switch version:', error);
        this.call('openNotification', {
            type: 'error',
            message: this.call('polyglot', 'editor.project.versionSwitchFailed').replace('{version}', version).replace('{error}', error.message)
        });
    }
// Force Versions sidebar to refresh its UI state
// this.getCanvas().lookup('Versions').update()
}
function $b0956ac10ddda395$export$ee497b3c885b8e5e() {
    return this.getRootState('projectName');
}
function $b0956ac10ddda395$export$3d5e1f66ff556ecb() {
    const projects = this.getRootState()?.projects || [];
    // Remove duplicates based on project id (This should be just a workaround)
    return [
        ...new Map(projects.map((project)=>[
                project.id,
                project
            ])).values()
    ];
}
function $b0956ac10ddda395$export$67fbc4483c75d073() {
    return this.getRootState()?.projectUsers;
}
function $b0956ac10ddda395$export$f030a28031d9be25() {
    return this.getRootState()?.projectId;
}
// Shared function that handles the common project switching logic
async function $b0956ac10ddda395$var$performProjectSwitch(context, fullProjectData, projectId, projectRole) {
    const { projects: projects } = context.getRootState();
    // Reconstruct the "basicProject" shape from the new payload so that
    // everything assigned into rootState stays the same as before.
    const projectInfo = fullProjectData.projectInfo || {};
    const projectMeta = fullProjectData.projectMeta || {};
    const basicProject = {
        // Core project metadata
        ...projectMeta,
        ...projectInfo,
        // Relations,
        members: fullProjectData.members,
        owner: fullProjectData.owner,
        // Shared libraries info,
        sharedLibraries: fullProjectData.sharedLibraries || []
    };
    const { key: appKey, name: projectName, id: id } = basicProject;
    const effectiveProjectId = id || projectId;
    // Keep SDK context update semantics the same, but use reconstructed basicProject
    await context.call('updateSDKContext', {
        project: basicProject,
        appKey: appKey,
        projectRole: projectRole
    });
    context.call('applyLoader', {
        value: true,
        force: true,
        timeout: 1
    });
    const state = context.getRootState();
    state.clients = {
        localhost: {},
        cli: {},
        platform: {}
    };
    state.settings = {};
    state.project = {};
    state.canvas = {
        pages: {},
        clients: {},
        gridOptions: {
            pages: [],
            comp: [],
            atom: [],
            children: []
        }
    };
    // Use the full project data as the "loadedProjectData" part
    const loadedProjectData = fullProjectData;
    const projectData = {
        ...basicProject,
        ...loadedProjectData,
        ...appKey && {
            appKey: appKey
        },
        ...effectiveProjectId && {
            projectId: effectiveProjectId
        },
        ...projectName && {
            projectName: projectName
        },
        ...projectRole && {
            projectRole: projectRole
        },
        sharedLibraries: basicProject.sharedLibraries || loadedProjectData.sharedLibraries || []
    };
    // USER-CODE-ORIGIN review N4: stored AS IS (strings) — the shell never
    // revives member-authored project code; the opaque frame does.
    context.call('overwrite', state, projectData);
    // If we're on canvas page, connect to new project's collaboration room
    if (context.isCanvas()) await context.call('switchCanvasProject', {
        projectId: effectiveProjectId,
        branch: 'main',
        pro: state.pro || state.userData?.pro
    });
    // Show loader until scene is ready
    context.call('applyLoader', {
        value: true,
        force: true,
        timeout: 35
    });
    return state;
}
async function $b0956ac10ddda395$export$aa6a184b5d48d926(projectId) {
    const { projects: projects } = this.getRootState();
    // New backend returns everything we need in a single getProjectData() call
    const fullProjectData = await this.sdk.getProjectData(projectId);
    // Get the project role with fallback to API call if not found in user projects
    const effectiveProjectId = fullProjectData.projectInfo?.id || fullProjectData.projectMeta?.id || projectId;
    const projectRole = await this.sdk.getProjectRoleWithFallback(effectiveProjectId, projects);
    await $b0956ac10ddda395$var$performProjectSwitch(this, fullProjectData, projectId, projectRole);
    this.router(this.getCanvasPathname() || this.fallbackRoute || '/canvas');
}
async function $b0956ac10ddda395$export$8a8b34fc133941fe(projectRef) {
    // Switch the active project by `owner/key` (or `{ owner, key }`), without
    // relying on state.activeProject. A bare key can name several owners'
    // projects: the server answers it 409 `ambiguous_key` with the candidates,
    // and the user is told which owner/key pairs share the key — never a pick.
    if (!projectRef) return;
    const raw = typeof projectRef === 'object' ? projectRef : String(projectRef);
    const at = typeof raw === 'string' ? raw.indexOf('/') : -1;
    const ref = typeof raw === 'object' ? {
        owner: raw.owner || null,
        key: raw.key
    } : at > 0 ? {
        owner: raw.slice(0, at),
        key: raw.slice(at + 1)
    } : {
        owner: null,
        key: raw
    };
    if (!ref.key) return;
    const label = ref.owner ? `${ref.owner}/${ref.key}` : ref.key;
    const rootState = this.getRootState();
    const { projects: projects = [] } = rootState;
    // 1. Fetch full project data by owner + key (contains everything basicProject used to have)
    let fullProjectData;
    try {
        fullProjectData = await this.sdk.getProjectDataByKey(ref.owner ? {
            owner: ref.owner,
            key: ref.key
        } : ref.key);
    } catch (error) {
        const candidates = this.call('ambiguousKeyCandidates', error);
        if (!candidates) throw error;
        this.openNotification({
            type: 'error',
            title: this.call('polyglot', 'editor.project.ambiguousKey.title'),
            message: this.call('polyglot', 'editor.project.ambiguousKey.message').replace('{key}', ref.key).replace('{candidates}', candidates.map((c)=>`${c.owner}/${c.key}`).join(', '))
        });
        return;
    }
    if (!fullProjectData) {
        this.warn(`[switchProjectByKey] Project data not found for key: ${label}`);
        this.openNotification({
            type: 'error',
            title: this.call('polyglot', 'editor.project.notFound.title'),
            message: this.call('polyglot', 'editor.project.notFound.message').replace('{key}', label)
        });
        return;
    }
    const projectId = fullProjectData.projectInfo?.id || fullProjectData.projectMeta?.id;
    // 2. Determine current user role by project id (never by a bare key) with
    // fallback to the API
    const projectRole = projectId ? await this.sdk.getProjectRoleWithFallback(projectId, projects) : null;
    await $b0956ac10ddda395$var$performProjectSwitch(this, fullProjectData, projectId, projectRole);
    return fullProjectData;
}

});

parcelRegister("ThjgE", function(module, exports) {

$parcel$export(module.exports, "prepareFrameProps", () => prepareFrameProps);
$parcel$export(module.exports, "prepareCode", () => prepareCode);
$parcel$export(module.exports, "prepareRouter", () => prepareRouter);
$parcel$export(module.exports, "prepareUtils", () => prepareUtils);
$parcel$export(module.exports, "prepareMethods", () => prepareMethods);
$parcel$export(module.exports, "prepareInitOptions", () => prepareInitOptions);
// From '@symbo.ls/utils', not the 'smbls' barrel — keeps the framework bundle
// out of the eager chunk (same fix as workspace/functions/extensionDesignSystem.js).
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
function prepareFrameProps(scope, state) {
    const { frameProps } = scope;
    return (0, $2C0hZ.deepMerge)({
        ':focus-within': {
            outline: 'none'
        },
        ...frameProps,
        ...state.props
    }, {
        zoom: this.getUserSettings('zoomLevel'),
        direction: this.getUserSettings('languageDirection')
    });
}
function prepareCode(code) {
    return (0, $2C0hZ.deepClone)(code);
}
function prepareRouter(data, scope) {
    return scope.router || scope.useRouter ? (path)=>this.call('router', scope.activeItem || path || '', this, {}, {
            window: window.top || window
        }) : function(path, ...params) {
        if (typeof path !== 'string' || !path.startsWith('/') || !(this.getRootState() && this.getUserSettings('allowCanvasReplaceRouter')) || params[2]?.initialRender) return;
        window.setTimeout(()=>{
            const chosen = this.getChosenKey();
            const key = '/' + path.split('/')[1];
            this.activateSelected(key);
            if (!chosen) this.zoomToNode(this.getSelected());
        }, 1);
    };
}
function prepareUtils(data, scope) {
    const router = this.prepareRouter?.(data, scope);
    return {
        ...data?.functions,
        ...data?.snippets,
        router: router
    };
}
function prepareMethods(data, scope) {
    const router = this.prepareRouter?.(data, scope);
    return {
        ...this.context?.methods,
        ...data?.methods,
        router: router
    };
}
function prepareInitOptions(scope) {
    return {
        ...scope.initOptions,
        newConfig: {}
    };
}

});

parcelRegister("adC1n", function(module, exports) {

$parcel$export(module.exports, "prepareDesignSystem", () => $77089c84827ea62b$export$d54de307475be07a);
$parcel$export(module.exports, "prepareComponent", () => $77089c84827ea62b$export$31d40bb118b87907);
$parcel$export(module.exports, "prepareDemoApp", () => $77089c84827ea62b$export$b7a6ad77f61cc83e);
$parcel$export(module.exports, "prepareDependencies", () => $77089c84827ea62b$export$c40391394e7726ed);
$parcel$export(module.exports, "prepareContext", () => $77089c84827ea62b$export$9c634076e0a91d1f);
$parcel$export(module.exports, "renderStateComponent", () => $77089c84827ea62b$export$810dfc066ec9c57c);
// From '@symbo.ls/utils', not the 'smbls' barrel — keeps the framework bundle
// out of the eager chunk (same fix as workspace/functions/extensionDesignSystem.js).
// The full smbls namespace is only needed as the iframe-injection FALLBACK when
// loadModule fails, so it's dynamic-imported at those two catch sites below.
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
var $gdfnU = parcelRequire("gdfnU");

var $3QZ4N = parcelRequire("3QZ4N");
const $77089c84827ea62b$var$dotsBase = {
    backgroundPosition: 'top',
    backgroundRepeat: 'repeat',
    backgroundSize: '20px 20px'
};
const $77089c84827ea62b$var$platformUI = {
    gradient: {
        dotsDark: 'radial-gradient(#435067 6%, transparent 6%)',
        dotsLight: 'radial-gradient(#d9d9db 6%, transparent 6%)'
    },
    reset: {
        head: {
            overscrollBehaviorX: 'none'
        },
        body: {
            overscrollBehaviorX: 'none'
        }
    },
    theme: {
        dots: {
            ...$77089c84827ea62b$var$dotsBase,
            '@dark': {
                backgroundImage: 'dotsDark',
                ...$77089c84827ea62b$var$dotsBase
            },
            '@light': {
                backgroundImage: 'dotsLight',
                ...$77089c84827ea62b$var$dotsBase
            }
        }
    },
    animation: {
        fadeIn: {
            '0%': {
                opacity: 0
            },
            '100%': {
                opacity: 1
            }
        },
        blink: {
            '0%': {
                opacity: 1
            },
            '50%': {
                opacity: 0
            },
            '100%': {
                opacity: 1
            }
        },
        componentBlink: {
            '0%': {
                opacity: 1
            },
            '50%': {
                opacity: 0.35
            },
            '100%': {
                opacity: 1
            }
        }
    }
};
// Bug #2050: tolerate legacy data that the old `updateDesignSystem` saved
// at UPPERCASE category keys (`ICONS`, `COLOR`, `SVG`, …). The runtime
// (Icon.js, scratch CONFIG) reads lowercase. Merge any uppercase
// category into its lowercase twin so both rendering paths find the
// same icons. New writes go to lowercase (see design-system.js fix);
// this only matters for projects that uploaded icons before the fix.
const $77089c84827ea62b$var$_DS_CATEGORIES = [
    'icons',
    'svg',
    'color',
    'typography',
    'spacing',
    'theme',
    'fontFamily',
    'cases',
    'media',
    'semanticIcons',
    'animation',
    'gradient',
    'shape',
    'shadow',
    'fontWeight',
    'lineHeight',
    'letterSpacing',
    'transition'
];
function $77089c84827ea62b$var$_normalizeDsCase(ds) {
    if (!ds || typeof ds !== 'object') return ds;
    let mutated = ds;
    for (const cat of $77089c84827ea62b$var$_DS_CATEGORIES){
        const upper = cat.toUpperCase();
        if (ds[upper] && typeof ds[upper] === 'object' && !Array.isArray(ds[upper])) {
            if (mutated === ds) mutated = {
                ...ds
            };
            mutated[cat] = {
                ...mutated[cat] || {},
                ...ds[upper]
            };
        }
    }
    return mutated;
}
function $77089c84827ea62b$export$d54de307475be07a(data, scope) {
    const globalTheme = scope?.sceneTheme || data?.designSystem?.globalTheme;
    const designSystem = $77089c84827ea62b$var$_normalizeDsCase(data.designSystem || {});
    if (designSystem.reset?.body) {
        designSystem.reset.body.position = 'absolute';
        designSystem.reset.body.inset = '0 0 0 0';
    }
    return (0, $2C0hZ.deepMerge)(designSystem, {
        globalTheme: globalTheme,
        ...$77089c84827ea62b$var$platformUI
    });
}
function $77089c84827ea62b$export$31d40bb118b87907(scope, state, code) {
    const el = this;
    const props = state.props || {};
    const demoCode = el.prepareCode(code);
    const extend = [
        demoCode
    ];
    if (state.state) extend.push({
        state: state.state
    });
    // Frame-level overrides applied AFTER demoCode so they win for keys we
    // intentionally control (margin, --spacing-ratio, variant, transition).
    // Bug #2049: `fontSize: props.base && ...` previously evaluated to
    // `undefined` when `props.base` was unset, which then OVERWROTE the
    // component's own saved `fontSize` because later extends win for
    // primitives. Only emit fontSize when we actually have a base value to
    // apply; otherwise let the demo component's own fontSize stand.
    const frameOverride = {
        margin: 'auto',
        '--spacing-ratio': state.ratio,
        variant: state.variant,
        transition: 'all, B, defaultBezier',
        ':focus-within': {
            outline: 'none'
        }
    };
    if (props.base) frameOverride.fontSize = `${props.base}px`;
    extend.push(frameOverride);
    const appjs = el.getFiles('app.js');
    if (scope.useAppjs && appjs?.code) extend.push(appjs?.code);
    return (0, $2C0hZ.deepClone)({
        extend: extend
    });
}
function $77089c84827ea62b$export$b7a6ad77f61cc83e(scope, state, code) {
    const el = this;
    if (scope.renderPureComponent) return code;
    const demoComponent = el.prepareComponent(scope, state, code);
    return (0, $2C0hZ.deepClone)({
        extends: [
            'Flex'
        ],
        props: el.prepareFrameProps(scope, state),
        data: {},
        demoComponent: demoComponent,
        on: scope.appEvents
    });
}


async function $77089c84827ea62b$export$c40391394e7726ed(scope, data, deps) {
    const meta = scope.document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, user-scalable=no';
    scope.document.head.appendChild(meta);
    if (scope.canvas) {
        await (0, $gdfnU.loadRemoteScript)('https://pkg.symbo.ls/panzoom@9.4.3/dist/panzoom.min.js', {
            document: scope.document
        });
        await (0, $gdfnU.loadRemoteScript)('https://pkg.symbo.ls/gridstack@10.3.1/dist/gridstack-all.js', {
            document: scope.document
        });
        await (0, $gdfnU.loadRemoteCSS)('https://pkg.symbo.ls/gridstack@10.3.1/dist/gridstack.css', {
            document: scope.document
        });
    }
    const isSmblsLocal = true;
    // Ensure iframe window.packages exists for loadModule
    if (!scope.window.packages) scope.window.packages = {};
    // Load smbls inside the iframe.
    // Local dev: browser bundle from local server, prod: esm.sh CDN
    if (isSmblsLocal) {
        const localUrl = 'http://localhost:5500/packages/smbls/dist/browser/index.js';
        try {
            // Shim Node globals for browser bundle
            if (!scope.window.process) scope.window.process = {
                env: {}
            };
            const mod = await (0, $3QZ4N.loadModule)('smbls', localUrl, scope, null, '');
            scope.window.smbls = mod;
        } catch (e) {
            this.warn('Problem with local smbls', e);
            scope.window.smbls = await Promise.resolve((parcelRequire("eY4Ct")));
        }
    } else {
        const remoteUrl = 'https://esm.sh/smbls';
        const lastUpdated = this.state.root.updatedAt;
        const randomize = lastUpdated || Math.random();
        const cachingSuffix = `?${randomize}`;
        try {
            const mod = await (0, $3QZ4N.loadModule)('smbls', remoteUrl + cachingSuffix, scope, null, '');
            scope.window.smbls = mod;
        } catch (e) {
            this.warn('Problem with smbls', e);
            scope.window.smbls = await Promise.resolve((parcelRequire("eY4Ct")));
        }
    }
}
async function $77089c84827ea62b$export$9c634076e0a91d1f(scope, data) {
    const el = this;
    const sceneMode = this.call('exec', scope.sceneMode);
    const __cache = scope.__cache;
    if (__cache) Object.assign(data, __cache) // todo: need to check
    ;
    console.log('Preparing context with sceneMode:', sceneMode);
    if (sceneMode === 'basic') return {
        components: {},
        pages: {
            '/': data
        },
        designSystem: {},
        router: {
            pushState: false
        }
    };
    if (sceneMode === 'app') return {
        ...data,
        router: {
            pushState: false
        }
    };
    return {
        ...data,
        designSystem: el.prepareDesignSystem(data, scope),
        utils: el.prepareUtils(data, scope),
        methods: el.prepareMethods(data, scope),
        // USER-CODE-ORIGIN review N4: as stored (strings), never revived here
        sharedLibraries: (data?.sharedLibraries || []).map((v)=>v || {}),
        type: [
            'marketplace',
            'platform'
        ].includes(scope?.projectType) ? 'template' : 'app',
        initOptions: el.prepareInitOptions(scope),
        domqlOptions: {
            allowRefReference: true
        },
        editor: {
            verbose: false,
            inspect: false,
            liveSync: false,
            remote: false
        },
        ...scope.useRouter && {
            router: scope.routerOptions
        }
    };
}
async function $77089c84827ea62b$export$810dfc066ec9c57c(code) {
    const el = this;
    const say = typeof el.warning === 'function' && el.warning || typeof el.warn === 'function' && el.warn || null;
    if (say) say.call(el, '[renderStateComponent] refused: project code renders only in the opaque user-code frame (mountUserCode)');
    return null;
}

});
parcelRegister("3QZ4N", function(module, exports) {

$parcel$export(module.exports, "getCDNUrl", () => $2ce59aeb9a9bebd6$export$8407093f131dcef1);
$parcel$export(module.exports, "loadModule", () => $2ce59aeb9a9bebd6$export$ebb47fdc8f2dbc6f);
const $2ce59aeb9a9bebd6$var$CDN_PROVIDERS = {
    skypack: {
        url: 'https://cdn.skypack.dev',
        formatUrl: (pkg, version)=>`${$2ce59aeb9a9bebd6$var$CDN_PROVIDERS.skypack.url}/${pkg}${version !== 'latest' ? `@${version}` : ''}`
    },
    symbols: {
        url: 'https://pkg.symbo.ls',
        formatUrl: (pkg, version)=>{
            const onlyDotsAndNumbers = (str)=>/^[0-9.]+$/.test(str) && str !== '';
            if (pkg.split('/').length > 2 || !onlyDotsAndNumbers(version)) return `${$2ce59aeb9a9bebd6$var$CDN_PROVIDERS.symbols.url}/${pkg}`;
            return `${$2ce59aeb9a9bebd6$var$CDN_PROVIDERS.symbols.url}/${pkg}/${version}.js`;
        }
    }
};
const $2ce59aeb9a9bebd6$export$8407093f131dcef1 = (packageName, version = 'latest', provider = 'skypack')=>{
    const cdnConfig = $2ce59aeb9a9bebd6$var$CDN_PROVIDERS[provider] || $2ce59aeb9a9bebd6$var$CDN_PROVIDERS.skypack;
    return cdnConfig.formatUrl(packageName, version);
};
async function $2ce59aeb9a9bebd6$export$ebb47fdc8f2dbc6f(key, url, options, provider, random) {
    // Helper function to execute dynamic import via Function constructor
    const createDynamicImport = (win, importUrl)=>{
        const importFn = win.Function('url', 'return import(url)');
        return importFn(importUrl);
    };
    const win = options.window;
    try {
        // --- Primary Import Attempt ---
        const mod = await createDynamicImport(win, url);
        const pkg = mod.default || mod;
        win.packages[key] = pkg;
        return pkg;
    } catch (primaryError) {
        // --- Skypack Fallback Attempt ---
        if (provider === 'skypack') {
            const fallbackUrl = $2ce59aeb9a9bebd6$export$8407093f131dcef1(key, 'latest', 'symbols') + random;
            try {
                const fallbackMod = await createDynamicImport(win, fallbackUrl);
                const fallbackPkg = fallbackMod.default || fallbackMod;
                win.packages[key] = fallbackPkg;
                return fallbackPkg;
            } catch (fallbackError) {
            // Fallback failed, proceed to final error handling and throw the original primaryError
            // The original logic dictates we throw the first error if the fallback fails.
            }
        }
        // --- Final Error Handling (Logs and Re-throws) ---
        // This catches:
        // 1. The primaryError if provider is not 'skypack'.
        // 2. The primaryError if the 'skypack' fallback also failed.
        console.error(`Failed to load ${key}:`, primaryError);
        throw primaryError;
    }
}

});


parcelRegister("fCFLl", function(module, exports) {

$parcel$export(module.exports, "openNotification", () => $b5faccd4c36ded52$export$ca2532046576fe2c);
$parcel$export(module.exports, "openNotificationParams", () => $b5faccd4c36ded52$export$e18636bfa8c0bee6);
$parcel$export(module.exports, "closeNotification", () => $b5faccd4c36ded52$export$d684d3158aada635);
$parcel$export(module.exports, "runNotificationAction", () => $b5faccd4c36ded52$export$8bb9b87fcd93e1a7);
$parcel$export(module.exports, "pauseNotification", () => $b5faccd4c36ded52$export$d3128c08c39835b3);
$parcel$export(module.exports, "resumeNotification", () => $b5faccd4c36ded52$export$786efa0b141bd9de);
// Toast notifications. State-driven: openNotification pushes a record
// into `root.state.notifications` and schedules its auto-dismiss via
// setTimeout. GlobalNotification renders children directly from that
// array — exit animation runs first (`_exiting: true` flag triggers
// fadeOutDown), then the entry is dropped from the array.
//
// Lifecycle per toast:
//   1. openNotification → push { id, ...obj } to state.notifications,
//      schedule dismissal at `duration` ms.
//   2. user mouseover → pauseNotification(id) — clear timer, remember
//      remaining time. mouseout → resumeNotification(id) — restart for
//      remaining time.
//   3. timer fires → flip `_exiting: true` on the toast in state →
//      GlobalNotification's reactive `animation` prop swaps to
//      `fadeOutDown`. After EXIT_MS we drop the toast from the array.
//
// Standalone surfaces (auth pages on the auth-bounce path) reach this
// before the shell mounts; we degrade to console logs so the caller
// doesn't crash. The shell-level GlobalNotification (workspace/app.js)
// means signed-in users see real toasts.
//
// Additive `obj` fields (all optional, all just ride the `{ ...obj }` spread
// straight onto the record — GlobalNotification.js is what actually reads
// them):
//   sound: true                        — chime via el.call('playNotifySound')
//                                         once this call clears the de-dup
//                                         guard below.
//   icon: '<icon name>'                — overrides the toast's IconText.Icon
//                                         (defaults per `type`, see
//                                         GlobalNotification.js).
//   action: { call: 'fn', args: [...] } — called on toast click, AFTER
//                                         href routing, BEFORE dismiss.
//                                         Serializable only — never put a
//                                         function reference into state.
//                                         `fn` is resolved in the context of
//                                         the element that RAISED the toast
//                                         (see runNotificationAction).

var $gGHbJ = parcelRequire("gGHbJ");
const $b5faccd4c36ded52$var$_timers = new Map() // id → { timer, startedAt, remaining, paused, state }
;
// WHERE A TOAST'S ACTION RUNS (DESIGN-WL-SHARED-TOAST-ACTION-CALLS-MODULE-FUNCTIONS-1).
// The toast renders in the SHELL, but an installed workspace module (CRM)
// registers its functions in its OWN context — a CRM "Undo" named a function
// the shell's toast element could not see, and `el.call` of an unknown name
// returns nothing: the Undo silently did nothing. The action is resolved at
// raise time against the raising element (`this` of openNotification — a
// module's `el.call('openNotification', …)` passes its own element); when that
// element can call it, the action runs through that element on click, so the
// function gets the module element as `this`. Otherwise it runs through the
// toast (the shell), exactly as before. The element stays OUT of state (the
// record is serializable): it lives here, beside the timers, and leaves with
// the toast.
const $b5faccd4c36ded52$var$_origins = new Map() // id → the raising element that can run the action
;
const $b5faccd4c36ded52$var$_warnedNames = new Set();
// The framework's own `call` lookup order (utils → functions → methods →
// snippets).
const $b5faccd4c36ded52$var$_canCall = (el, name)=>{
    const c = el && el.context;
    if (!c || !name) return false;
    const fn = c.utils?.[name] || c.functions?.[name] || c.methods?.[name] || c.snippets?.[name];
    return typeof fn === 'function';
};
// One dev warning per unknown action name — never a throw, never a repeat.
const $b5faccd4c36ded52$var$_warnUnknownAction = (name)=>{
    if ($b5faccd4c36ded52$var$_warnedNames.has(name)) return;
    $b5faccd4c36ded52$var$_warnedNames.add(name);
    if (!(0, $gGHbJ.isLoudDevRuntime)()) return;
    console.warn(`[notification] the toast action "${name}" names no function where it was raised or in the shell \u{2014} the toast only closes`);
};
const $b5faccd4c36ded52$var$_forget = (id)=>{
    $b5faccd4c36ded52$var$_origins.delete(id);
};
const $b5faccd4c36ded52$var$EXIT_MS = 300 // must match the fadeOutDown animationDuration on the toast
;
const $b5faccd4c36ded52$var$_genId = ()=>`${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
const $b5faccd4c36ded52$var$_logFallback = (obj)=>{
    if (typeof console === 'undefined') return;
    const tag = `[${obj.type || 'notification'}] ${obj.title || ''}`;
    const msg = obj.message ? `${tag} \u{2014} ${obj.message}` : tag;
    if (obj.type === 'error') console.warn(msg);
    else console.log(msg);
};
const $b5faccd4c36ded52$var$_clearTimer = (id)=>{
    const entry = $b5faccd4c36ded52$var$_timers.get(id);
    if (entry?.timer) clearTimeout(entry.timer);
    $b5faccd4c36ded52$var$_timers.delete(id);
};
const $b5faccd4c36ded52$var$_arm = (state, id, ms)=>{
    const timer = setTimeout(()=>$b5faccd4c36ded52$var$_beginExit(state, id), ms);
    $b5faccd4c36ded52$var$_timers.set(id, {
        timer: timer,
        state: state,
        startedAt: Date.now(),
        remaining: ms,
        paused: false
    });
};
// Phase 1: flip `_exiting` so the toast plays its exit animation.
// Phase 2: after EXIT_MS, drop the toast from the array.
const $b5faccd4c36ded52$var$_beginExit = (state, id)=>{
    $b5faccd4c36ded52$var$_timers.delete(id);
    const arr = state?.notifications;
    if (!arr) return;
    // No-op if already removed (manual dismiss may have raced us).
    if (!arr.some((n)=>n.id === id)) return;
    state.update({
        notifications: arr.map((n)=>n.id === id ? {
                ...n,
                _exiting: true
            } : n)
    }, {
        preventUpdate: false
    });
    setTimeout(()=>{
        const current = state?.notifications;
        if (!current) return;
        state.update({
            notifications: current.filter((n)=>n.id !== id)
        }, {
            preventUpdate: false
        });
        $b5faccd4c36ded52$var$_forget(id);
    }, $b5faccd4c36ded52$var$EXIT_MS);
};
async function $b5faccd4c36ded52$export$ca2532046576fe2c(obj, opts = {}) {
    const state = this.getRootState?.();
    if (!state) {
        $b5faccd4c36ded52$var$_logFallback(obj);
        return;
    }
    // De-dup: identical title+message already queued.
    const dup = state.notifications?.find((n)=>n.title === obj.title && n.message === obj.message && !n._exiting);
    if (dup) return;
    // Chime — opt-in per call (`sound: true`), gated inside playNotifySound
    // itself on the user's notification_sound preference + a debounce, so a
    // burst of toasts never stacks a burst of chimes.
    if (obj.sound) try {
        this.call('playNotifySound');
    } catch (err) {
        console.warn('[openNotification] playNotifySound failed:', err?.message || err);
    }
    const id = $b5faccd4c36ded52$var$_genId();
    const duration = Math.max(0, obj.duration || opts.duration || 3500);
    const record = {
        ...obj,
        id: id,
        _exiting: false
    };
    if (obj.action?.call && $b5faccd4c36ded52$var$_canCall(this, obj.action.call)) $b5faccd4c36ded52$var$_origins.set(id, this);
    await state.update({
        notifications: [
            ...state.notifications || [],
            record
        ]
    }, {
        preventUpdate: false
    });
    if (duration > 0) $b5faccd4c36ded52$var$_arm(state, id, duration);
}
async function $b5faccd4c36ded52$export$e18636bfa8c0bee6(title, error, message, opts = {}) {
    return await $b5faccd4c36ded52$export$ca2532046576fe2c.call(this, {
        title: title,
        error: error,
        message: message
    }, opts);
}
function $b5faccd4c36ded52$export$d684d3158aada635(notification, _opts = {}) {
    const state = this.getRootState?.();
    if (!state) return;
    const id = notification?.id;
    if (!id) return;
    $b5faccd4c36ded52$var$_clearTimer(id);
    $b5faccd4c36ded52$var$_beginExit(state, id);
}
function $b5faccd4c36ded52$export$8bb9b87fcd93e1a7(notification) {
    const id = notification?.id;
    const action = notification?.action;
    if (!action?.call) return;
    const origin = $b5faccd4c36ded52$var$_origins.get(id) || ($b5faccd4c36ded52$var$_canCall(this, action.call) ? this : null);
    if (!origin) {
        $b5faccd4c36ded52$var$_warnUnknownAction(action.call);
        return;
    }
    const args = Array.isArray(action.args) ? action.args : [];
    try {
        return origin.call(action.call, ...args);
    } catch (err) {
        console.warn('[notification] toast action failed:', err?.message || err);
    }
}
function $b5faccd4c36ded52$export$d3128c08c39835b3(id) {
    const entry = $b5faccd4c36ded52$var$_timers.get(id);
    if (!entry || entry.paused) return;
    clearTimeout(entry.timer);
    entry.paused = true;
    entry.remaining = Math.max(0, entry.remaining - (Date.now() - entry.startedAt));
}
function $b5faccd4c36ded52$export$786efa0b141bd9de(id) {
    const entry = $b5faccd4c36ded52$var$_timers.get(id);
    if (!entry?.paused) return;
    entry.paused = false;
    entry.startedAt = Date.now();
    entry.timer = setTimeout(()=>$b5faccd4c36ded52$var$_beginExit(entry.state, id), entry.remaining);
}

});

parcelRegister("9YVrG", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $74464725fa5706cd$export$44487a86467333c3);
/**
 * Resets the Design System with the provided object.
 * @param {object} obj - Object to reset the Design System with.
 * @param {object} [opts={}] - Options for resetting the Design System.
 */ function $74464725fa5706cd$export$44487a86467333c3() {
    const { environment: environment } = this.sdk;
    return {
        apiUrl: environment.apiUrl
    };
}

});

parcelRegister("3x1U4", function(module, exports) {

$parcel$export(module.exports, "addCanvasPage", () => $2925ee203327fd40$export$6d14ce3b9577517d);
$parcel$export(module.exports, "openCanvasPage", () => $2925ee203327fd40$export$24e60188356e3a74);
$parcel$export(module.exports, "getCanvasPage", () => $2925ee203327fd40$export$d6a3fc958f256206);
$parcel$export(module.exports, "getCurrentCanvasPage", () => $2925ee203327fd40$export$9b63abb677f6a745);
$parcel$export(module.exports, "onCurrentCanvasPage", () => $2925ee203327fd40$export$29381aa7e0c51447);
$parcel$export(module.exports, "inOnCurrentCanvasPage", () => $2925ee203327fd40$export$85f5f9581c02a7af);
$parcel$export(module.exports, "findInOtherCanvasPages", () => $2925ee203327fd40$export$f8e73b601272202a);
$parcel$export(module.exports, "findKeyInOtherCanvasPages", () => $2925ee203327fd40$export$d74f90859a22cf4d);
$parcel$export(module.exports, "deleteCanvasPage", () => $2925ee203327fd40$export$2aa8899e61777286);
$parcel$export(module.exports, "renameCanvasPage", () => $2925ee203327fd40$export$8f94e67b894ac942);
$parcel$export(module.exports, "duplicateCanvasPage", () => $2925ee203327fd40$export$597024bd84ed5a82);
$parcel$export(module.exports, "returnAddedCanvasPageChanges", () => $2925ee203327fd40$export$43ca08285ea298c7);
$parcel$export(module.exports, "returnRemovedCanvasPageChanges", () => $2925ee203327fd40$export$fc8c77d6ce8bd677);
$parcel$export(module.exports, "addItemOnCanvasPage", () => $2925ee203327fd40$export$97f6bce516ce1947);
async function $2925ee203327fd40$export$6d14ce3b9577517d(obj, opts = {}) {
    const { title: title, freeform: freeform } = obj;
    if (!title) // Migrated from `window.alert('Title is required.')` — the unified
    // @symbo.ls/windows system replaces native browser dialogs with the
    // app's design-system chrome (theme: 'modal', glass blur, ESC dismiss).
    // Same early-return semantics: the method ends here in both cases.
    return this.call('alertDialog', {
        message: this.call('polyglot', 'editor.canvasPage.titleRequired')
    });
    const canvasPages = this.getRootState().canvas.pages;
    const exists = title === 'Default' || canvasPages && canvasPages[title];
    const query = [
        [
            'update',
            [
                'canvas',
                'pages',
                title
            ],
            {
                title: title,
                freeform: freeform,
                pages: [],
                components: [],
                functions: [],
                methods: [],
                snippets: [],
                atom: [],
                files: [],
                dependencies: [],
                secrets: []
            }
        ]
    ];
    if (!canvasPages) query.unshift([
        'update',
        [
            'canvas',
            'pages'
        ],
        {}
    ]);
    if (exists && !opts.preventNameCheck) return this.call('openNotification', {
        type: 'error',
        title: this.call('polyglot', 'editor.canvasPage.exists.title'),
        message: this.call('polyglot', 'editor.canvasPage.exists.message').replace('{title}', title)
    });
    this.sdk.updateData(query, {
        message: `Added canvas page ${title}`
    });
    this.call('openCanvasPage', title);
}
async function $2925ee203327fd40$export$24e60188356e3a74(val) {
    let pageVal = val;
    const data = this.getCanvasScope();
    const Collection = this.getCanvasCollection();
    const activeCanvasPage = this.getActiveCanvasPage();
    this.syncCanvas({
        activeCanvasPage: pageVal
    });
    if (pageVal === activeCanvasPage) return;
    pageVal ||= this.state.value;
    data.activeCanvasPage = pageVal;
    if (Collection?.update) await Collection.update();
    await this.getCanvasPages()?.update();
    if (this.getFilesSidebar()?.update) await this.getFilesSidebar().update();
    this.call('resetCanvasPan');
}
function $2925ee203327fd40$export$d6a3fc958f256206(key) {
    const { canvas: canvas } = this.getRootState();
    return canvas.pages && Object.keys(canvas.pages).length > 0 && canvas.pages[key];
}
function $2925ee203327fd40$export$9b63abb677f6a745() {
    const activeCanvasPage = this.getActiveCanvasPage();
    return this.call('getCanvasPage', activeCanvasPage);
}
function $2925ee203327fd40$export$29381aa7e0c51447(type, key) {
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const { canvas: canvas } = platformState;
    return canvas.pages[activeCanvasPage][type].includes(key);
}
function $2925ee203327fd40$export$85f5f9581c02a7af(type, key) {
    const { canvas: canvas } = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const isDefaultActive = activeCanvasPage === 'Default';
    const isAnywhereElse = this.call('findInOtherCanvasPages', type, key);
    if (isDefaultActive && !isAnywhereElse) return true;
    const currentCanvas = canvas.pages[activeCanvasPage];
    const currentWhitelist = currentCanvas?.[type];
    if (currentWhitelist?.includes(key)) return true;
}
function $2925ee203327fd40$export$f8e73b601272202a(type, key) {
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const { canvas: canvas } = platformState;
    for(const page in canvas.pages){
        if (page === activeCanvasPage) continue;
        if (canvas.pages[page][type]?.includes(key)) return page;
    }
}
function $2925ee203327fd40$export$d74f90859a22cf4d(key) {
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    const { canvas: canvas } = platformState;
    const type = this.getType(key);
    for(const page in canvas.pages){
        if (page === activeCanvasPage) continue;
        if (canvas.pages[page][type]?.includes(key)) return page;
    }
}
async function $2925ee203327fd40$export$2aa8899e61777286(val) {
    let pageVal = val;
    const platformState = this.getRootState();
    const activeCanvasPage = this.getActiveCanvasPage();
    pageVal ||= this.state.value;
    if (pageVal === 'Default') {
        this.call('openNotification', {
            type: 'warning',
            title: this.call('polyglot', 'editor.canvasPage.defaultRemove.title'),
            message: this.call('polyglot', 'editor.canvasPage.defaultRemove.message')
        });
        return;
    }
    // Migrated from synchronous `window.confirm` + `window.prompt` chain
    // (which blocks the JS event loop and ships native OS chrome) to the
    // unified @symbo.ls/windows dialogs. Callback-style means the original
    // straight-line body is now nested inside `onConfirm`. The method
    // returns immediately; the actual deletion runs after the user
    // dismisses the prompt.
    this.call('confirmDialog', {
        title: this.call('polyglot', 'editor.canvasPage.remove.title'),
        message: this.call('polyglot', 'editor.canvasPage.remove.message').replace('{page}', pageVal),
        confirmText: this.call('polyglot', 'common.action.remove'),
        confirmTheme: 'red',
        icon: 'trash',
        onConfirm: ()=>{
            this.call('promptDialog', {
                title: this.call('polyglot', 'editor.canvasPage.move.title'),
                message: this.call('polyglot', 'editor.canvasPage.move.message'),
                defaultValue: 'Default',
                placeholder: 'Default',
                confirmText: this.call('polyglot', 'editor.canvasPage.move.confirm'),
                onConfirm: async (moveToInput)=>{
                    let moveTo = moveToInput || 'Default';
                    const { canvas: canvas } = platformState;
                    const canvasPage = canvas.pages[pageVal] || {};
                    const query = [
                        [
                            'delete',
                            [
                                'canvas',
                                'pages',
                                pageVal
                            ]
                        ]
                    ];
                    if (canvas.pages[moveTo] && moveTo !== 'Default') {
                        this.call('deepMerge', canvas.pages[moveTo], canvasPage);
                        query.push([
                            'update',
                            [
                                'canvas',
                                'pages',
                                moveTo
                            ],
                            canvas.pages[moveTo]
                        ]);
                    } else moveTo = 'Default';
                    this.sdk.updateData(query, {
                        message: `Removed canvas page ${pageVal}`
                    });
                    await this.getCanvasPages().update();
                    if (activeCanvasPage === moveTo || activeCanvasPage === val) await this.call('openCanvasPage', moveTo);
                }
            });
        }
    });
}
function $2925ee203327fd40$export$8f94e67b894ac942(val) {
    let pageVal = val || this.state.value;
    const platformState = this.getRootState();
    if (pageVal === 'Default') {
        this.call('openNotification', {
            type: 'warning',
            title: this.call('polyglot', 'editor.canvasPage.defaultRename.title'),
            message: this.call('polyglot', 'editor.canvasPage.defaultRename.message')
        });
        return;
    }
    // Migrated from synchronous `window.prompt`. The post-prompt body is
    // now wrapped in onConfirm; the method returns immediately and the
    // rename runs after the user submits the dialog. Cancel / ESC /
    // backdrop click → no-op (preserving the original `if (!newTitle)
    // return` semantics).
    this.call('promptDialog', {
        title: this.call('polyglot', 'editor.canvasPage.rename.title'),
        defaultValue: pageVal,
        placeholder: pageVal,
        confirmText: this.call('polyglot', 'common.action.rename'),
        onConfirm: (newTitle)=>{
            if (!newTitle) return;
            const { canvas: canvas } = platformState;
            const canvasPage = canvas.pages[pageVal] || {};
            if (pageVal !== newTitle) {
                canvasPage.title = newTitle;
                const query = [
                    [
                        'update',
                        [
                            'canvas',
                            'pages',
                            newTitle
                        ],
                        canvasPage
                    ],
                    [
                        'delete',
                        [
                            'canvas',
                            'pages',
                            pageVal
                        ]
                    ]
                ];
                this.sdk.updateData(query, {
                    message: `Renamed canvas page ${pageVal} to ${newTitle}`
                });
                this.getCanvasPages().update();
            }
        }
    });
}
function $2925ee203327fd40$export$597024bd84ed5a82() {}
function $2925ee203327fd40$export$43ca08285ea298c7(type, key) {
    const activeCanvasPage = this.getActiveCanvasPage();
    if (activeCanvasPage === 'Default') return;
    const canvasPages = this.getRootState('canvas').pages || {};
    const tuples = [];
    // 1. Add the key to the active canvas page list (or ensure it exists)
    const currentList = canvasPages?.[activeCanvasPage]?.[type] || [];
    const newCurrentList = currentList.includes(key) ? currentList : [
        ...currentList,
        key
    ];
    tuples.push([
        'update',
        [
            'canvas',
            'pages',
            activeCanvasPage,
            type
        ],
        newCurrentList
    ]);
    // 2. Ensure the key is removed from *other* canvas page lists so that it
    //    is unique to the current page. This prevents unintended navigation
    //    back to "Default" when interacting with the component.
    Object.keys(canvasPages).forEach((page)=>{
        if (activeCanvasPage === page) return;
        const list = canvasPages[page]?.[type];
        if (Array.isArray(list) && list.includes(key)) tuples.push([
            'update',
            [
                'canvas',
                'pages',
                page,
                type
            ],
            list.filter((k)=>k !== key)
        ]);
    });
    return tuples;
}
function $2925ee203327fd40$export$fc8c77d6ce8bd677(type, key) {
    const activeCanvasPage = this.getActiveCanvasPage();
    if (activeCanvasPage === 'Default') return;
    const canvasPages = this.getRootState('canvas').pages || {};
    const tuples = [];
    // Remove the key from the active canvas page list
    const currentList = canvasPages?.[activeCanvasPage]?.[type] || [];
    if (currentList.includes(key)) tuples.push([
        'update',
        [
            'canvas',
            'pages',
            activeCanvasPage,
            type
        ],
        currentList.filter((k)=>k !== key)
    ]);
    return tuples;
}
async function $2925ee203327fd40$export$97f6bce516ce1947(obj) {
    const { key: key } = obj;
    const activeCanvasPage = this.getActiveCanvasPage();
    const currentCanvas = this.call('getCurrentCanvasPage');
    const isDefault = activeCanvasPage === 'Default';
    const type = this.getType(obj);
    if (!isDefault && !currentCanvas[type]) currentCanvas[type] = [];
    if (!isDefault && !currentCanvas[type].includes(key)) currentCanvas[type].push(key);
    await this.call('rerenderFileSidebarByType', type);
} // export function removeCanvasArtboardFromCanvasPage(type, key) {
 //   if (!type || !key) {
 //     return this.error('Type or key is not defined to remove from canvas page')
 //   }
 //   const activeCanvasPage = this.getActiveCanvasPage()
 //   const currentCanvas = this.call('getCurrentCanvasPage')
 //   const isDefault = activeCanvasPage === 'Default'
 //   if (!isDefault && currentCanvas[type].includes(key)) {
 //     this.call('removeValueFromArrayAll', currentCanvas[type], key)
 //     return true
 //   }
 // }

});

parcelRegister("6o208", function(module, exports) {

$parcel$export(module.exports, "sendRequest", () => $4a66895cee1ee435$export$d5a1e65f8aa21b51);
async function $4a66895cee1ee435$export$d5a1e65f8aa21b51(obj) {
    let { endpointUrl: url } = obj || this.state;
    const { method: method, paramsArr: paramsArr = [], headersArr: headersArr = [], body: body = null, authArr: authArr = [] } = obj || this.state;
    return new Promise(async (resolve, reject)=>{
        // Construct query string from params array
        if (paramsArr.length > 0) {
            const queryString = paramsArr.map((param)=>`${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`).join('&');
            url += `?${queryString}`;
        }
        // Construct headers object from headers array
        const headersObject = {};
        headersArr.forEach((header)=>{
            headersObject[header.key] = header.value;
        });
        // Construct auth string if provided
        let authString = null;
        if (authArr.length > 0) {
            const authPair = authArr.find((a)=>a.key && a.value);
            if (authPair) authString = `${authPair.key}:${authPair.value}`;
        }
        // Set up fetch options
        const options = {
            method: method,
            headers: headersObject
        };
        if (authString) options.headers.Authorization = `Basic ${btoa(authString)}`;
        if (body && method !== 'GET') options.body = typeof body === 'string' ? body : JSON.stringify(body);
        // Prevent body from being added for GET requests
        if (method === 'GET') options.body = null;
        // Send the request
        return await fetch(url, options).then((response)=>{
            if (!response.ok) return reject(new Error(`Request failed with status ${response.status}: ${response.statusText}`));
            return response.json();
        }).then((data)=>{
            resolve(data);
        }).catch((error)=>reject(`Network error occurred: ${error.message}`));
    });
}

});

parcelRegister("dpn0W", function(module, exports) {

$parcel$export(module.exports, "followHost", () => $9c2f764763fc1417$export$4cae41899d37cd4);
$parcel$export(module.exports, "setFollowingUser", () => $9c2f764763fc1417$export$ab83b95a1a85fd11);
$parcel$export(module.exports, "askToFollow", () => $9c2f764763fc1417$export$338a839ad3ed7b62);
$parcel$export(module.exports, "clearFollowing", () => $9c2f764763fc1417$export$1a06b88eb3fad81);
function $9c2f764763fc1417$export$4cae41899d37cd4() {
    const { followingUser: followingUser, clients: clients } = this.getRootState();
    const data = this.getCanvasScope();
    const clientCanvas = clients?.[followingUser];
    const Collection = this.getCanvasCollection();
    if (!clientCanvas || !Collection) return;
    const { selected: clientSelected, chosen: clientChosen, openUrl: openUrl } = clientCanvas;
    if (data.openUrl !== openUrl) {
        data.openUrl = openUrl;
        if (openUrl) {
            if (data.openedWindow) data.openedWindow.close();
            data.openedWindow = window.open(openUrl);
        } else {
            (data.openedWindow || window)?.close();
            data.openedWindow = null;
        }
    }
    const { followingUser: skip, ...cleanData } = clientCanvas;
    this.call('overwrite', data, cleanData);
    if (this.getSelectedKey() !== clientSelected) this.activateSelected(clientSelected);
    if (this.getChosenKey() !== clientChosen) this.activateChosen(clientChosen);
    this.variables({
        previewSize: data.previewSize
    }).changed((_)=>{
        this.getChosenSceneNavbar().update();
    });
    this.variables({
        componentEditor: data.componentEditor
    }).changed((_)=>{
        this.setWindow('componentEditor', data.componentEditor);
    });
    this.variables({
        explorer: data.explorer
    }).changed((_)=>{
        this.setWindow('explorer', data.explorer);
    });
    this.variables({
        hoverLayer: data.hoverLayer,
        activeLayer: data.activeLayer
    }).changed((_)=>{
        this.getDynamicIsland().update({});
        this.getEditorPanels()?.parent.update({});
    });
}
async function $9c2f764763fc1417$export$ab83b95a1a85fd11(userId) {
    let { clients: clients } = this.getRootState();
    const client = clients?.[userId];
    if (!client || userId === this.getRootState('userId')) return;
    const followingUser = this.getRootState().followingUser === userId ? null : userId;
    this.syncCanvas({
        followingUser: followingUser
    }, {
        forceSendSocket: true
    });
}
function $9c2f764763fc1417$export$338a839ad3ed7b62(targetUserId) {
    const { clients: clients, userId: userId } = this.getRootState();
    if (userId === targetUserId) return;
    const client = clients?.[userId];
    if (!client) return;
}
function $9c2f764763fc1417$export$1a06b88eb3fad81() {
    const rootState = this.getRootState();
    if (!rootState.followingUser) return;
    rootState.followingUser = null;
}

});

parcelRegister("dtx6G", function(module, exports) {

$parcel$export(module.exports, "handleGoogleAuthResponse", () => $9cf7aa2148c771d3$export$959d81de844d6a99);
$parcel$export(module.exports, "checkGoogleOAuthCallback", () => $9cf7aa2148c771d3$export$d0e289255c18ec3e);
$parcel$export(module.exports, "handleGoogleRedirectFlow", () => $9cf7aa2148c771d3$export$e22b9c675d4bc1c5);
$parcel$export(module.exports, "armNativeAuthDeepLink", () => $9cf7aa2148c771d3$export$b7bb7187863aba8f);
$parcel$export(module.exports, "ensureNativeGoogleAuth", () => $9cf7aa2148c771d3$export$1cbec65af00c993e);
$parcel$export(module.exports, "launchNativeGoogleAuth", () => $9cf7aa2148c771d3$export$8cdbf71a1727c40f);
$parcel$export(module.exports, "processGoogleOAuthCode", () => $9cf7aa2148c771d3$export$5609dd01dc17dd7);
parcelRequire("S1wNg");
var $gN40b = parcelRequire("gN40b");

var $29wU0 = parcelRequire("29wU0");

var $klqGv = parcelRequire("klqGv");

var $e2Fqo = parcelRequire("e2Fqo");

var $k2xRl = parcelRequire("k2xRl");
const $9cf7aa2148c771d3$var$PLUGIN_SESSION_STORAGE_KEY = 'plugin_auth_session';
const $9cf7aa2148c771d3$var$ensurePluginSession = ()=>{
    if (typeof window === 'undefined') return null;
    let session = null;
    try {
        session = new URL(window.location.href).searchParams.get('session');
    } catch  {
    // Ignore URL parsing errors
    }
    if (session) {
        try {
            if (window.localStorage) window.localStorage.setItem($9cf7aa2148c771d3$var$PLUGIN_SESSION_STORAGE_KEY, session);
        } catch  {
        // Ignore storage errors
        }
        return session;
    }
    try {
        if (window.localStorage) return window.localStorage.getItem($9cf7aa2148c771d3$var$PLUGIN_SESSION_STORAGE_KEY);
    } catch  {
    // Ignore storage errors
    }
    return null;
};
async function $9cf7aa2148c771d3$export$959d81de844d6a99(credential) {
    const state = this.getRootState();
    try {
        // Get invite token from localStorage instead of URL
        const inviteToken = localStorage.getItem('google_auth_invite_token');
        const pluginSession = $9cf7aa2148c771d3$var$ensurePluginSession();
        const loginResult = pluginSession ? await this.sdk.googleAuth(credential, inviteToken, {
            session: pluginSession
        }) : await this.sdk.googleAuth(credential, inviteToken);
        if (!loginResult) throw new Error('Invalid response from server');
        // Clean up the stored token
        localStorage.removeItem('google_auth_invite_token');
        // A sign-in on this origin: its refresh token is its own (review D1).
        this.call('markOwnSession');
        this.call('applyLoader', {
            value: true,
            force: true,
            timeout: 1
        });
        await this.call('initializeUserSession', {
            loginData: loginResult
        }, this.getRootState(), this.sdk);
        state.update({
            loading: false
        });
        // SIGNUP-INTENT — see functions/signupIntent.js
        this.router(this.call('takeSignupCheckoutNext') || '/');
    } catch (error) {
        console.error('Failed to sign in with Google:', error);
        // Clean up the stored token on error
        localStorage.removeItem('google_auth_invite_token');
        this.call('openNotification', {
            title: this.call('polyglot', 'auth.signin.failed'),
            message: error.message,
            type: 'error'
        });
        state.update({
            loading: false
        });
    }
}
function $9cf7aa2148c771d3$export$d0e289255c18ec3e() {
    const state = this.getRootState();
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const stateParam = urlParams.get('state');
    const error = urlParams.get('error');
    const storedState = sessionStorage.getItem('google_oauth_state');
    if (error) {
        console.error('Google OAuth error:', error);
        this.call('openNotification', {
            title: this.call('polyglot', 'auth.google.authFailed.title'),
            message: this.call('polyglot', 'auth.google.authFailed.message'),
            type: 'error'
        });
        // Clean up URL
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
    }
    if (code && stateParam) {
        // Verify state parameter
        if (stateParam !== storedState) {
            console.error('State parameter mismatch - possible CSRF attack');
            this.call('openNotification', {
                title: this.call('polyglot', 'auth.google.securityError.title'),
                message: this.call('polyglot', 'auth.google.securityError.message'),
                type: 'error'
            });
            window.history.replaceState({}, document.title, window.location.pathname);
            return;
        }
        // Clean up stored state
        sessionStorage.removeItem('google_oauth_state');
        // Clean up URL first
        window.history.replaceState({}, document.title, window.location.pathname);
        // Process the OAuth code
        this.call('processGoogleOAuthCode', code, this, state);
    }
}
function $9cf7aa2148c771d3$export$e22b9c675d4bc1c5({ redirectUri: redirectUri, state: state, open: open } = {}) {
    try {
        // Store current URL to return to after auth
        sessionStorage.setItem('google_auth_return_url', window.location.href);
        $9cf7aa2148c771d3$var$ensurePluginSession();
        // Store invite token in localStorage instead of appending to redirect URI
        const currentUrl = new URL(window.location.href);
        const inviteToken = currentUrl.searchParams.get('token');
        if (inviteToken) localStorage.setItem('google_auth_invite_token', inviteToken);
        // Create the Google OAuth URL with clean redirect URI (no dynamic parameters)
        const clientId = (0, $gN40b.default).googleClientId;
        const finalRedirectUri = redirectUri || `${window.location.origin}/google-auth-callback`;
        const encodedRedirectUri = encodeURIComponent(finalRedirectUri);
        const scope = encodeURIComponent('openid email profile');
        const responseType = 'code';
        const oauthState = state || `google_oauth_${Math.random().toString(36).substr(2, 9)}`;
        // Store state to verify later
        sessionStorage.setItem('google_oauth_state', oauthState);
        const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?` + `client_id=${clientId}&` + `redirect_uri=${encodedRedirectUri}&` + `response_type=${responseType}&` + `scope=${scope}&` + `state=${encodeURIComponent(oauthState)}&` + `access_type=offline&` + `prompt=consent`;
        if (open) // Caller owns the hand-off (native shell → system browser)
        open(googleAuthUrl);
        else // Redirect to Google OAuth
        window.location.href = googleAuthUrl;
    } catch (error) {
        console.error('Failed to initiate Google redirect flow:', error);
        // Clean up stored token on error
        localStorage.removeItem('google_auth_invite_token');
        this.call('openNotification', {
            title: this.call('polyglot', 'auth.signin.failed'),
            message: this.call('polyglot', 'auth.google.unreachable'),
            type: 'error'
        });
    }
}
// ── Native-shell OAuth (Tauri iOS shell — tickets/ipad.md) ────────────────
//
// In the native shell (isNativeShell()) NO in-webview Google flow can work:
// FedCM/One Tap is unavailable in WKWebView, the shell drops the GIS
// code-client popup, and Google rejects OAuth from embedded webviews
// outright ("disallowed_useragent"). The real flow runs in the SYSTEM
// browser with a deep link back:
//
//   1. launchNativeGoogleAuth() reuses the handleGoogleRedirectFlow URL
//      builder with redirect_uri = the SERVER callback
//      (`${workspaceApiBase()}/auth/google/native-callback`) and
//      state = `<nonce>.<scheme>` — a shell nonce persisted in
//      localStorage, plus THIS build's deep-link scheme
//      (nativeShellScheme() — `symbols` prod / `symbols-canary` canary,
//      see isNativeShell.js), then hands the URL to the system browser
//      (openInSystemBrowser). Google returns `state` verbatim, so no new
//      wire parameter is needed for the scheme to survive the Google leg.
//   2. Safari completes OAuth; the server splits `state` back into
//      nonce + scheme (validated against a hard allowlist — an unknown
//      scheme falls back to `symbols`, never echoes attacker-controlled
//      input into the redirect target), mints a ONE-TIME ≤60s exchange
//      token bound to the nonce, and 302s to
//      `<scheme>://auth-callback?xt=…&state=<nonce>` — the SAME scheme
//      the calling build registered, so prod and canary each land back in
//      the app that started them, installed side by side.
//   3. The shell delivers the deep link back into the webview over three
//      possible paths — a 'symbols:auth-callback' window CustomEvent
//      (warm), window.__SYMBOLS_PENDING_AUTH_CALLBACK__ (event fired
//      before the listener armed), or ?xt=…&state=… boot params on /login
//      (cold start). Whichever fires first wins (window._nativeXtHandled).
//   4. completeNativeAuthExchange verifies the nonce (CSRF check, same
//      posture as checkGoogleOAuthCallback), redeems via
//      sdk.exchangeNativeAuthToken(xt, nonce, inviteToken), then
//      initializeUserSession → post-OAuth `next` routing — identical
//      session semantics to the web Google paths.
const $9cf7aa2148c771d3$var$NATIVE_NONCE_KEY = 'native_auth_nonce';
const $9cf7aa2148c771d3$var$NATIVE_AUTH_EVENT = 'symbols:auth-callback';
const $9cf7aa2148c771d3$var$randomNativeNonce = ()=>{
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (b)=>b.toString(16).padStart(2, '0')).join('');
};
// Shell opener contract — in priority order:
//   1. window.__SYMBOLS_SHELL__.openExternal(url) — explicit bridge, when
//      the shell injects one.
//   2. Tauri opener plugin IPC — granted to my.symbols.app pages via the
//      shell's remote capability (workspace/native/ipad capabilities).
//   3. window.open(_blank) — last resort; the shell maps popup opens to
//      the system browser.
const $9cf7aa2148c771d3$var$openInSystemBrowser = (url)=>{
    const bridge = window.__SYMBOLS_SHELL__;
    if (typeof bridge?.openExternal === 'function') {
        bridge.openExternal(url);
        return;
    }
    const invoke = window.__TAURI_INTERNALS__?.invoke;
    if (typeof invoke === 'function') {
        Promise.resolve(invoke('plugin:opener|open_url', {
            url: url
        })).catch(()=>{
            window.open(url, '_blank');
        });
        return;
    }
    window.open(url, '_blank');
};
const $9cf7aa2148c771d3$var$parseAuthCallbackUrl = (raw)=>{
    try {
        const url = new URL(raw);
        // Accept any REGISTERED build scheme, not just prod's `symbols:` — the
        // canary shell only ever receives links for the scheme it itself
        // registered (`symbols-canary:`), so this is additive, not a widened
        // trust boundary.
        if (!(0, $k2xRl.NATIVE_AUTH_SCHEMES).some((scheme)=>url.protocol === `${scheme}:`)) return null;
        const p = url.searchParams;
        return {
            xt: p.get('xt'),
            state: p.get('state'),
            error: p.get('error')
        };
    } catch (_) {
        return null;
    }
};
const $9cf7aa2148c771d3$var$parseAuthCallbackPayload = (detail)=>{
    if (!detail) return null;
    if (typeof detail === 'string') return $9cf7aa2148c771d3$var$parseAuthCallbackUrl(detail);
    if (detail.xt || detail.error) return {
        xt: detail.xt || null,
        state: detail.state || null,
        error: detail.error || null
    };
    if (detail.url) return $9cf7aa2148c771d3$var$parseAuthCallbackUrl(detail.url);
    return null;
};
async function $9cf7aa2148c771d3$var$completeNativeAuthExchange(el, payload) {
    if (!payload || !payload.xt && !payload.error) return;
    // Whichever delivery path (event / pending global / boot param) fires
    // first wins — the exchange token is single-use server-side anyway.
    if (window._nativeXtHandled) return;
    window._nativeXtHandled = true;
    const s = el.state;
    if (payload.error) {
        window._nativeXtHandled = false;
        (0, $e2Fqo.clearInviteToken)('google');
        s.update({
            loading: false
        });
        if (payload.error !== 'access_denied') el.call('openNotification', {
            title: el.call('polyglot', 'auth.login.googleSignInFailed'),
            message: el.call('polyglot', 'auth.google.incomplete').replace('{error}', payload.error),
            type: 'error'
        });
        return;
    }
    let storedNonce = null;
    try {
        storedNonce = window.localStorage.getItem($9cf7aa2148c771d3$var$NATIVE_NONCE_KEY);
        window.localStorage.removeItem($9cf7aa2148c771d3$var$NATIVE_NONCE_KEY);
    } catch (_) {}
    // CSRF check — the deep link must answer the flow THIS app instance
    // started (same posture as checkGoogleOAuthCallback's state verify).
    // The server additionally verifies the nonce against the token record.
    if (!storedNonce || payload.state && payload.state !== storedNonce) {
        window._nativeXtHandled = false;
        (0, $e2Fqo.clearInviteToken)('google');
        s.update({
            loading: false
        });
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.google.stateMismatch.title'),
            message: el.call('polyglot', 'auth.google.stateMismatch.message'),
            type: 'error'
        });
        return;
    }
    s.update({
        loading: true
    });
    const inviteToken = (0, $e2Fqo.readInviteToken)('google');
    try {
        const loginResult = await el.sdk.exchangeNativeAuthToken(payload.xt, storedNonce, inviteToken);
        if (!loginResult) throw new Error('Invalid authentication response');
        await el.call('initializeUserSession', {
            loginData: loginResult
        });
        let next = (0, $klqGv.consumeOAuthNext)(new URL(window.location.href).searchParams.get('next'));
        // SIGNUP-INTENT — see functions/signupIntent.js
        if (next === '/') next = el.call('takeSignupCheckoutNext') || next;
        s.update({
            loading: false
        });
        el.router(next, el.getRoot());
    } catch (error) {
        console.error('[native-auth] exchange failed:', error);
        window._nativeXtHandled = false;
        (0, $e2Fqo.clearInviteToken)('google');
        s.update({
            loading: false
        });
        el.call('openNotification', {
            title: el.call('polyglot', 'auth.login.googleFailed'),
            message: error?.message || el.call('polyglot', 'auth.login.tryAgain'),
            type: 'error'
        });
    }
}
function $9cf7aa2148c771d3$export$b7bb7187863aba8f() {
    const el = this;
    if (typeof window === 'undefined') return;
    if (!window._nativeAuthDeepLinkArmed) {
        window._nativeAuthDeepLinkArmed = true;
        window.addEventListener($9cf7aa2148c771d3$var$NATIVE_AUTH_EVENT, (ev)=>{
            $9cf7aa2148c771d3$var$completeNativeAuthExchange(el, $9cf7aa2148c771d3$var$parseAuthCallbackPayload(ev?.detail));
        });
    }
    // Delivery race: the shell dispatched before the listener armed.
    if (window.__SYMBOLS_PENDING_AUTH_CALLBACK__) {
        const pending = window.__SYMBOLS_PENDING_AUTH_CALLBACK__;
        delete window.__SYMBOLS_PENDING_AUTH_CALLBACK__;
        $9cf7aa2148c771d3$var$completeNativeAuthExchange(el, $9cf7aa2148c771d3$var$parseAuthCallbackPayload(pending));
    }
    // Cold start: the shell relaunched the webview on /login?xt=…&state=….
    try {
        const params = new URL(window.location.href).searchParams;
        if (params.get('xt') || params.get('error')) {
            const payload = {
                xt: params.get('xt'),
                state: params.get('state'),
                error: params.get('error')
            };
            // Strip the one-time token out of the URL/history before redeeming.
            window.history.replaceState({}, document.title, window.location.pathname);
            $9cf7aa2148c771d3$var$completeNativeAuthExchange(el, payload);
        }
    } catch (_) {}
}
async function $9cf7aa2148c771d3$export$1cbec65af00c993e() {
    const el = this;
    if (typeof window === 'undefined') return;
    $9cf7aa2148c771d3$export$b7bb7187863aba8f.call(el);
    const scope = el.scope || {};
    if (scope._nativeAuthReadyProbe === undefined) scope._nativeAuthReadyProbe = (async ()=>{
        try {
            await el.sdk.exchangeNativeAuthToken('availability-probe', 'availability-probe');
            return true;
        } catch (error) {
            const status = error?.status ?? error?.cause?.status;
            return status === 400 || status === 401;
        }
    })();
    const ready = await scope._nativeAuthReadyProbe;
    if (el.state?.nativeAuthReady !== ready) el.state.update({
        nativeAuthReady: ready
    });
}
function $9cf7aa2148c771d3$export$8cdbf71a1727c40f() {
    const nonce = $9cf7aa2148c771d3$var$randomNativeNonce();
    try {
        window.localStorage.setItem($9cf7aa2148c771d3$var$NATIVE_NONCE_KEY, nonce);
    } catch (_) {}
    window._nativeXtHandled = false;
    $9cf7aa2148c771d3$export$e22b9c675d4bc1c5.call(this, {
        redirectUri: `${(0, $29wU0.workspaceApiBase)()}/auth/google/native-callback`,
        state: `${nonce}.${(0, $k2xRl.nativeShellScheme)()}`,
        open: $9cf7aa2148c771d3$var$openInSystemBrowser
    });
}
async function $9cf7aa2148c771d3$export$5609dd01dc17dd7(code) {
    const state = this.getRootState();
    try {
        state.update({
            loading: true
        });
        // Get invite token from localStorage instead of URL
        const inviteToken = localStorage.getItem('google_auth_invite_token');
        // Use clean redirect URI (no dynamic parameters)
        const redirectUri = `${window.location.origin}/google-auth-callback`;
        const pluginSession = $9cf7aa2148c771d3$var$ensurePluginSession();
        const loginResult = pluginSession ? await this.sdk.googleAuthCallback(code, redirectUri, inviteToken, {
            session: pluginSession
        }) : await this.sdk.googleAuthCallback(code, redirectUri, inviteToken);
        if (!loginResult) throw new Error('Invalid authentication response');
        // Clean up the stored token
        localStorage.removeItem('google_auth_invite_token');
        // A sign-in on this origin: its refresh token is its own (review D1).
        this.call('markOwnSession');
        await this.call('initializeUserSession', {
            loginData: loginResult
        }, this.getRootState(), this.sdk);
        state.update({
            loading: false
        });
        // SIGNUP-INTENT — see functions/signupIntent.js
        this.router(this.call('takeSignupCheckoutNext') || '/');
    } catch (error) {
        console.error('Failed to process Google OAuth code:', error);
        // Clean up stored token on error
        localStorage.removeItem('google_auth_invite_token');
        this.call('openNotification', {
            title: this.call('polyglot', 'auth.google.authFailed.title'),
            message: error.message || this.call('polyglot', 'auth.google.incompleteGeneric'),
            type: 'error'
        });
        state.update({
            loading: false
        });
    }
}

});

parcelRegister("3zvgi", function(module, exports) {

$parcel$export(module.exports, "groupLog", () => groupLog);
$parcel$export(module.exports, "groupLogEnd", () => groupLogEnd);
$parcel$export(module.exports, "verbose", () => verbose);
$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "warn", () => warn);
$parcel$export(module.exports, "error", () => error);
// verbose / log / warn / error BELOW ARE DELIBERATE OVERRIDES of framework
// element methods, and they are the ONLY names in this library's `methods` bag
// that may be (WS-SHARED-METHODS-SHADOW-FRAMEWORK-ELEMENT-METHODS-1, Rule 63 —
// an intentional override is documented, never accidental; ./root.js carries the
// matching note for the seven names withheld there).
//
// WHY THEY WIN, and are allowed to: mergeSharedLibraries copies this bag into the
// consuming app's `context.methods`, which @symbo.ls/element layers OVER its
// built-in element methods, so each of these four replaces the built-in on every
// element of every consuming app. The framework sanctions exactly these four as
// OVERRIDE POINTS (@symbo.ls/utils keys.js ELEMENT_METHOD_OVERRIDE_POINTS, smbls
// 1ad078784): they are observability channels, not element semantics — the
// element's own tree, state and rendering never depend on what they do.
//
// WHY THE WORKSPACE NEEDS ITS OWN: about 90 call sites here rely on
// log-and-continue in EVERY environment (`return this.error('…')` is an early
// exit that must not become an exception). The built-ins differ on all four —
// built-in error() THROWS in test/development and is silent in production,
// built-in log(...keys) prints a `{ key: el[key] }` debug map rather than the
// caller's message, and built-in warn/verbose print only in test/development.
// Taking the built-ins would make every dev build throw on this.error(...).
//
// KNOWN DEAD BRANCH, kept deliberately un-removed here: the OTEL span path in
// warn/error is gated on `window.symbols.faro`, and NOTHING sets it any more —
// the shell replaced Faro with @symbo.ls/analyzing
// (packages/workspace/analyzing.js) and the SDK sets `window.symbols.tracking`,
// not `.faro`. So both functions always take the plain console branch today. It
// is inert rather than wrong, and deleting a tracing hook is a separate call from
// un-shadowing a method, so it stays until someone decides where these two should
// report; do not read its presence as evidence that Faro is wired.
//
// Locked by packages/workspace/__tests__/sharedLibraryMethodsDoNotShadowBuiltins.test.js,
// which fails if a fifth built-in name appears in any library methods bag.
function groupLog(...params) {
    // if (isNotProduction()) {
    console.group(...params);
// }
}
function groupLogEnd(...params) {
    // if (isNotProduction()) {
    console.groupEnd(...params);
// }
}
function verbose(element, ...args) {
    // if (isProduction()) return
    const parent = this;
    const { __ref: ref } = parent;
    console.groupCollapsed(parent.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, 'font-weight: bold', parent[v]));
    else {
        console.log(ref.path);
        const keys = parent.keys();
        keys.forEach((v)=>console.log(`%c${v}:`, 'font-weight: bold', parent[v]));
    }
    console.log(parent);
    console.groupEnd(parent.key);
    return parent;
}
function log(...params) {
    // if (isProduction()) return
    console.log(...params);
}
function warn(...params) {
    // if (isProduction()) return
    const { hostname } = window.location;
    if (!hostname || hostname === 'localhost' || typeof window.symbols?.faro === 'undefined') return console.warn(...params, this);
    const { trace, context } = window.symbols.faro.api.getOTEL();
    const tracer = trace.getTracer('frontend-uikit-tracer');
    const span = tracer.startSpan('warning');
    context.with(trace.setSpan(context.active(), span), ()=>{
        console.warn(...params, this);
        span.end();
    });
}
function error(...params) {
    // if (isProduction()) return
    const logger = ()=>{
        const lastParam = params[params.length - 1];
        const hasOpts = typeof lastParam === 'object' && lastParam;
        if (hasOpts?.debugger) debugger;
        if (hasOpts?.verbose) this.verbose.call(this, ...params);
        if (this.call('isFunction', hasOpts?.onError)) hasOpts?.onError.call(this, ...params);
        console.error(...params, this);
    };
    const { hostname } = window.location;
    if (!hostname || hostname === 'localhost' || typeof window.symbols?.faro === 'undefined') return logger();
    const { trace, context } = window.symbols.faro.api.getOTEL();
    const tracer = trace.getTracer('frontend-uikit-tracer');
    const span = tracer.startSpan('error');
    context.with(trace.setSpan(context.active(), span), ()=>{
        logger();
        span.end();
    });
}

});

parcelRegister("dKlSw", function(module, exports) {

$parcel$export(module.exports, "getProjectSharedLibraries", () => $a0208ad07be7868a$export$1270ca7c3894172b);
async function $a0208ad07be7868a$export$1270ca7c3894172b(maxDepth = 5) {
    if (maxDepth < 1) return [];
    const startId = this.getRootState('id');
    const queue = [
        {
            id: startId,
            depth: 0
        }
    ];
    const visited = new Set([
        startId
    ]);
    const librariesSet = new Set();
    while(queue.length > 0){
        const { id: currentId, depth: depth } = queue.shift();
        // Only process projects within the depth limit
        if (depth >= maxDepth) break; // Exit if we've reached the max depth
        try {
            const libs = await this.sdk.getProjectLibraries(currentId);
            if (!libs || libs.length === 0) continue; // Skip if no libraries found
            for (const lib of libs){
                // Add library to result set
                if (!librariesSet.has(lib.id)) librariesSet.add(lib.id);
                // Enqueue if we haven't visited and within depth limit
                if (!visited.has(lib.id)) {
                    visited.add(lib.id);
                    if (depth + 1 < maxDepth) queue.push({
                        id: lib.id,
                        depth: depth + 1
                    });
                }
            }
        } catch (error) {
            console.error(`Error fetching libraries for ${currentId}:`, error);
        }
    }
    return Array.from(librariesSet);
}

});

parcelRegister("jcrbA", function(module, exports) {

$parcel$export(module.exports, "test", () => test);
$parcel$export(module.exports, "testAll", () => testAll);
$parcel$export(module.exports, "testIf", () => testIf);
$parcel$export(module.exports, "isEqual", () => isEqual);
$parcel$export(module.exports, "isEqualFunction", () => isEqualFunction);
$parcel$export(module.exports, "isEqualObject", () => isEqualObject);
$parcel$export(module.exports, "exists", () => exists);
$parcel$export(module.exports, "existsIf", () => existsIf);
$parcel$export(module.exports, "notExists", () => notExists);
$parcel$export(module.exports, "notExistsIf", () => notExistsIf);
$parcel$export(module.exports, "testCase", () => testCase);
function test(key, fn) {
    if (!this.getUserSettings('debuggingMode')) return;
    this.groupLog('Test results: ' + key);
    try {
        const exec = fn();
        if (!exec) {
            this.error('%c' + key + ' failed: Did not pass', fn);
            window.requestAnimationFrame(()=>{
                this.call('openNotification', {
                    title: key,
                    message: this.call('polyglot', 'editor.test.didNotPass'),
                    type: 'error'
                });
            });
            this.groupLogEnd('Test results: ' + key);
            return;
        }
        this.log('%cTesting ' + key + ' passed!', 'color: green; font-weight: bold');
        this.groupLogEnd('Test results: ' + key);
        return exec;
    } catch (e) {
        this.error(key + ' failed:');
        this.error(e);
        window.requestAnimationFrame(()=>{
            this.call('openNotification', {
                title: this.call('polyglot', 'editor.test.failed').replace('{key}', key),
                message: e,
                type: 'error'
            });
        });
        this.groupLogEnd('Test results: ' + key);
    }
}
function testAll(key, fn) {
    return this.test(key, async ()=>{
        const arr = await this.call('exec', fn);
        if (!Array.isArray(arr)) {
            this.error('Test array is not an array');
            return false;
        }
        if (arr.length === 0) {
            this.error('Test array is empty');
            return false;
        }
        return arr.filter((v)=>v !== undefined).every((item)=>item);
    });
}
function testIf(condition, key, fn) {
    if (condition) return this.test(key, fn);
}
function isEqual(one, second, opts = {}) {
    this.log('%cChecking equality', 'color: gray');
    const isEqual1 = one === second;
    if (!isEqual1 && !opts.skipLogging) {
        this.error('Is not equal:');
        this.log(one);
        this.log(second);
    }
    return isEqual1;
}
function isEqualFunction(one, second, opts = {}) {
    this.log('%cChecking equality of functions', 'color: gray');
    const stringifiedOne = one.toString();
    const stringifiedTwo = second.toString();
    const isEqual = this.isEqual(stringifiedOne, stringifiedTwo);
    if (!isEqual && !opts.skipLogging) {
        this.error('Is not equal:');
        this.log(one);
        this.log(second);
    }
    return isEqual;
}
function isEqualObject(one, second, opts = {}) {
    this.log('%cChecking equality of objects', 'color: gray');
    const diff = this.call('isObjectLike', one) && this.call('isObjectLike', second) && this.call('diff', one, second, void 0, {
        cloneInstances: true
    }) || null;
    const isEqual = one && second && this.call('isObjectLike', diff) && Object.keys(diff).length === 0;
    if (!isEqual && !opts.skipLogging) {
        this.error('Is not equal:');
        this.log(one);
        this.log(second);
        this.log('With diff:');
        this.log(diff);
    }
    return isEqual;
}
function exists(value) {
    this.log('%cChecking value existence', 'color: gray');
    if (value === undefined) {
        this.error('Does not exist');
        return false;
    }
    return true;
}
function existsIf(condition, value) {
    this.log('%cChecking value existence if condition applies', 'color: gray');
    if (condition && value === undefined) {
        this.error('Does not exist');
        return false;
    }
    return true;
}
function notExists(value) {
    this.log('%cChecking value non-existence', 'color: gray');
    if (value) {
        this.error('Exists');
        return false;
    }
    return true;
}
function notExistsIf(condition, value) {
    this.log('%cChecking value non-existence', 'color: gray');
    if (condition && value !== undefined) {
        this.error('Exists');
        return false;
    }
    return true;
}
function testCase(descr, func, ...params) {
    this.groupLog(descr);
    const res = this.call(func, ...params);
    if (res) this.log('%cPassed', 'color: green');
    else this.error('%cFailed: ' + descr, 'color: red');
    this.groupLogEnd(descr);
    return res;
}

});

parcelRegister("ifwq0", function(module, exports) {

$parcel$export(module.exports, "getDynamicIslandDataFromState", () => $d492c6530963db7c$export$42ea9827051fa810);
$parcel$export(module.exports, "getActiveDynamicIslandCategory", () => $d492c6530963db7c$export$aec2ed4623d3fdcd);
$parcel$export(module.exports, "getSidebarContent", () => $d492c6530963db7c$export$87165cad90b97844);
$parcel$export(module.exports, "setSidebarContent", () => $d492c6530963db7c$export$78d0518ff2f2c912);
$parcel$export(module.exports, "getActiveSidebarTypes", () => $d492c6530963db7c$export$8aef342f82ce0193);
$parcel$export(module.exports, "isTypeSidebarActive", () => $d492c6530963db7c$export$80ef19cb612ee08d);
$parcel$export(module.exports, "setActiveDynamicIslandCategory", () => $d492c6530963db7c$export$47a332ff9439102e);
$parcel$export(module.exports, "getDynamicIslandDataByCategory", () => $d492c6530963db7c$export$8591565595195dd);
$parcel$export(module.exports, "toggleRenameInput", () => $d492c6530963db7c$export$7803446a3292744a);
$parcel$export(module.exports, "findFileSidebarSection", () => $d492c6530963db7c$export$a8fbf76319c1014c);
$parcel$export(module.exports, "findFileSidebarItem", () => $d492c6530963db7c$export$92576e8fb3da665a);
$parcel$export(module.exports, "rerenderFileSidebarByType", () => $d492c6530963db7c$export$5c848c9737e2d4aa);
function $d492c6530963db7c$export$42ea9827051fa810() {
    const { designSystem: designSystem, state: state, components: components, snippets: snippets, pages: pages, functions: functions, methods: methods, files: files, dependencies: dependencies } = this.getData();
    return {
        designSystem: designSystem,
        state: state,
        components: components,
        snippets: snippets,
        pages: pages,
        functions: functions,
        methods: methods,
        files: files,
        dependencies: dependencies
    };
}
function $d492c6530963db7c$export$aec2ed4623d3fdcd() {
    return this.getFilesSidebar()?.state?.activeFileSidebar || 'Local';
}
function $d492c6530963db7c$export$87165cad90b97844() {
    return this.getFilesSidebar()?.state?.activeContent;
}
async function $d492c6530963db7c$export$78d0518ff2f2c912(activeContent) {
    // canvas's v2 body when canvas is loaded (one owner per name — canvas registers canvasSetSidebarContent)
    const _canvasFork = this?.context?.methods?.canvasSetSidebarContent;
    if (typeof _canvasFork === 'function') return _canvasFork.apply(this, arguments);
    if (this.isEmbed()) return;
    await this.getFilesSidebar()?.state.update({
        activeContent: activeContent
    });
    this.call('setCookie', this.getAppKey() + '_activeContent', activeContent);
    return activeContent;
}
function $d492c6530963db7c$export$8aef342f82ce0193(contentKey = this.call('getSidebarContent')) {
    return this.call('getTypes', contentKey);
}
function $d492c6530963db7c$export$80ef19cb612ee08d(type) {
    return this.call('getActiveSidebarTypes').includes(type);
}
function $d492c6530963db7c$export$47a332ff9439102e(category) {
    this.getFilesSidebar().state.update({
        activeFileSidebar: category
    });
}
async function $d492c6530963db7c$export$8591565595195dd(activeFileSidebar) {
    if (!activeFileSidebar) return;
    const category = activeFileSidebar.toLowerCase();
    if (category === 'local') return this.call('getDynamicIslandDataFromState');
    else if (category === 'builtins') return {} // BUILTINS_LIBRARY
    ;
    else if (category === 'shared libraries') return await this.getDefaultDesignSystem();
}
function $d492c6530963db7c$export$7803446a3292744a(type, key) {
    // One-argument predicate contract (see findFileSidebarSection below). This
    // site had no short-circuit guard in front of the state read, so the 2-arg
    // form threw on the FIRST candidate — rename never opened.
    const listEl = this.getDynamicIsland().lookdown((candidate)=>candidate.state?.key === key && candidate.state?.type === type);
    if (!listEl) return;
    listEl.state.update({
        editing: true
    });
    const t = setTimeout(()=>{
        listEl.Rename.Label.Input.node.select();
        clearTimeout(t);
    }, 0);
}
function $d492c6530963db7c$export$a8fbf76319c1014c(type) {
    const sidebar = this.getFilesSidebar();
    if (!sidebar || typeof sidebar.lookdown !== 'function') return;
    // `lookdown` invokes its predicate with ONE argument (the candidate element),
    // so a 2-arg `(el, s)` form leaves `s` undefined and throws the moment a
    // candidate satisfies the left side. Read state off the element instead.
    return sidebar.lookdown((candidate)=>candidate.FilesSidebarList && candidate.state?.type === type);
}
function $d492c6530963db7c$export$92576e8fb3da665a(type, key) {
    const section = this.call('findFileSidebarSection', type);
    if (!section) return;
    // Same one-argument predicate contract as findFileSidebarSection above.
    return section.lookdown((candidate)=>candidate.Rename && candidate.state?.key === key);
}
async function $d492c6530963db7c$export$5c848c9737e2d4aa(type, opts) {
    if (!this.getFilesSidebar()) return;
    const section = this.call('findFileSidebarSection', type);
    if (!section) return;
    return await section.update({}, opts);
}

});

parcelRegister("183rZ", function(module, exports) {

$parcel$export(module.exports, "openEditor", () => $0d293701e6cebadf$export$2b9f6e10153464f5);
$parcel$export(module.exports, "getShowLayersSchema", () => $0d293701e6cebadf$export$782ffd2582bb4492);
$parcel$export(module.exports, "getLayerPath", () => $0d293701e6cebadf$export$b0cf34032d59541f);
$parcel$export(module.exports, "saveLayersVisibilityState", () => $0d293701e6cebadf$export$246c019ec1f198ee);
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
async function $0d293701e6cebadf$export$2b9f6e10153464f5(type, key) {
    const item = (key ? this.getItem(key, type) : null) || this.getSelected()?.state;
    if (!item) return;
    const scope = this.getCanvasScope();
    const path = scope.hoverLayer || [];
    this.syncCanvas();
    // The persisted map, not `scope.showLayersSchema || {}`: after a reload
    // the scope has no map yet, and a write that started from `{}` persisted
    // a map that had lost every other row's entry (see getShowLayersSchema).
    const showLayersSchema = $0d293701e6cebadf$export$782ffd2582bb4492.call(this);
    const componentShowLayersSchema = JSON.parse(JSON.stringify(showLayersSchema?.[item.key] || {}));
    if (!componentShowLayersSchema) return;
    const updateShowLayers = (schema, path)=>{
        let current = schema;
        current.showLayers = true;
        path?.some((key)=>{
            if (key[0] !== key[0].toLowerCase()) {
                if (current[key] === undefined) current[key] = {};
                current[key].showLayers = true;
                current = current[key];
            } else return true;
        });
    };
    updateShowLayers(componentShowLayersSchema, path);
    const isActive = this.call('arraysEqual', path, scope.activeLayer || []);
    showLayersSchema[item.key] = componentShowLayersSchema;
    scope.showLayersSchema = showLayersSchema;
    if (isActive) scope.activeLayer = null;
    else scope.activeLayer = path.filter((key)=>key[0] !== key[0].toLowerCase());
    if (scope.componentEditor === 'code') {
        this.changeCodePriority('component');
        await this.getComponentCodeEditor().update({}, new (this.call('sameOriginTop') || window).Object({
            preventUpdate: true,
            allowCodeSelection: true
        }));
    }
    this.syncCanvas();
    const isExplorerActive = Boolean(scope.explorer);
    const isExplorerArtboardsActive = scope.explorer === 'explorer:ARTBOARD_TYPES';
    if (isExplorerActive && !isExplorerArtboardsActive) this.setWindow('explorer', 'explorer:ARTBOARD_TYPES');
    if (!scope.explorer && !scope.editorActive) return;
    const t = setTimeout(async ()=>{
        const componentLayer = isExplorerActive ? this.call('findFileSidebarItem', item.type, item.key) : this.getQuickEditor();
        if (!componentLayer?.state) {
            clearTimeout(t);
            return;
        }
        await componentLayer.state.update({
            showLayers: true
        });
        componentLayer.node?.scrollIntoViewIfNeeded?.();
        // componentLayer.node.focus()
        clearTimeout(t);
    }, 350);
}
function $0d293701e6cebadf$export$b0cf34032d59541f() {
    return [
        this.state.key
    ];
}
function $0d293701e6cebadf$export$782ffd2582bb4492() {
    const scope = this.getCanvasScope();
    if (scope?.showLayersSchema) return scope.showLayersSchema;
    const persisted = this.getCanvasScopeFromStorageOrData()?.showLayersSchema;
    if (!scope) return persisted || {};
    if (persisted) scope.showLayersSchema = persisted;
    return scope.showLayersSchema || {};
}
function $0d293701e6cebadf$export$246c019ec1f198ee(path, value) {
    if (!Array.isArray(path) || !path.length) return null;
    const scope = this.getCanvasScope();
    if (!scope) return null;
    const showLayersSchema = $0d293701e6cebadf$export$782ffd2582bb4492.call(this);
    (0, $2C0hZ.setInObjectByPath)(showLayersSchema, path, Boolean(value));
    this.syncCanvas({
        showLayersSchema: showLayersSchema
    });
    return showLayersSchema;
}

});

parcelRegister("5qohc", function(module, exports) {

$parcel$export(module.exports, "handleClickAway", () => $3f3236459d51830e$export$73ded5ed92dd58c4);
function $3f3236459d51830e$export$73ded5ed92dd58c4(event) {
    function lookupUpDOM(element, targetKey) {
        const parentElement = element?.parentElement;
        const parentKey = parentElement?.getAttribute?.('key');
        if (!parentElement) return null;
        if (parentKey === targetKey) return parentElement;
        return lookupUpDOM(parentElement, targetKey);
    }
    // Don't close if clicking the panel or its trigger
    const isFloatingPanelChildren = lookupUpDOM(event?.target, 'FloatingPanel');
    if (isFloatingPanelChildren) return;
    const floatingPanelElement = this.getFloatingPanelElement();
    floatingPanelElement?.setNodeStyles?.({
        visibility: 'hidden',
        opacity: 0
    });
}

});

parcelRegister("4sPGi", function(module, exports) {

var $icj8C = parcelRequire("icj8C");

var $4KbCZ = parcelRequire("4KbCZ");

var $cHcgu = parcelRequire("cHcgu");

var $fiyHo = parcelRequire("fiyHo");

var $dDKfH = parcelRequire("dDKfH");

var $cwycr = parcelRequire("cwycr");

var $2Cj92 = parcelRequire("2Cj92");
$parcel$exportWildcard(module.exports, $icj8C);
$parcel$exportWildcard(module.exports, $4KbCZ);
$parcel$exportWildcard(module.exports, $cHcgu);
$parcel$exportWildcard(module.exports, $fiyHo);
$parcel$exportWildcard(module.exports, $dDKfH);
$parcel$exportWildcard(module.exports, $cwycr);
$parcel$exportWildcard(module.exports, $2Cj92);

});
parcelRegister("icj8C", function(module, exports) {

$parcel$export(module.exports, "createItem", () => $d3f8316812461761$export$1f768fd5b3313118);
$parcel$export(module.exports, "createItemInSidebar", () => $d3f8316812461761$export$cc30d05b2e4fb9b3);
$parcel$export(module.exports, "createArtboardInCanvas", () => $d3f8316812461761$export$8f280cc1f84cee52);
$parcel$export(module.exports, "createItemInCanvas", () => $d3f8316812461761$export$e38d6b3a2f9fbc0);
$parcel$export(module.exports, "createItemInChosen", () => $d3f8316812461761$export$3234d7e1956cc367);
$parcel$export(module.exports, "createCanvasItem", () => $d3f8316812461761$export$651d04d0277dc388);
$parcel$export(module.exports, "createMultipleItems", () => $d3f8316812461761$export$3e8cca83d22abb50);
/**
 * Creates an item in the database
 */ function $d3f8316812461761$export$1f768fd5b3313118(type, key, forcedValue, opts = {}) {
    if (!type || !key) {
        this.error('Type or key is not defined for create operation');
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'editor.crud.projectIdRequired.title'),
            message: this.call('polyglot', 'editor.crud.projectIdRequired.message')
        });
        return;
    }
    type = this.getPlural(type);
    const item = this.call('isObject', forcedValue) && forcedValue.value ? forcedValue : this.call('getDefaultValuePerType', type, key);
    if (this.call('hasArtboard', type) || this.call('hasExecutable', type)) {
        const canvasPageChanges = this.call('returnAddedCanvasPageChanges', type, key);
        if (canvasPageChanges) opts.append = canvasPageChanges;
    }
    const res = this.sdk.addItem(type, item, opts);
    this.testAll(`Creating ${key} in ${type}`, ()=>[
            this.testCase('Item exists in root state', 'exists', this.getSchemaItem(key, type) && this.getDataItem(key, type))
        ]);
    return res;
}
async function $d3f8316812461761$export$cc30d05b2e4fb9b3(type, key) {
    const section = this.call('findFileSidebarSection', type);
    const List = section?.FilesSidebarList?.content;
    if (!section || !List) return this.error(`Section for type "${type}" not found in sidebar`);
    await section.FilesSidebarList.content.append({
        extends: 'FilesSidebarListItem',
        state: {
            key: key,
            type: type
        }
    }, `${List.__ref.__children.length}`);
}
async function $d3f8316812461761$export$8f280cc1f84cee52(type, key, opts) {
    if (!this.isCanvas()) return this.error('Creating artboard on canvas requires active canvas page');
    await this.call('createCanvasArtboard', type, key, opts);
    this.testAll(`Creating ${key} ${type} artboard in Canvas`, ()=>[
            this.testCase('Item exists on canvas', 'exists', this.call('findComponentOnCanvas', key)),
            this.testCase('Item was create in canvas page', 'existsIf', this.getActiveCanvasPage() !== 'Default', this.call('inOnCurrentCanvasPage', type, key))
        ]);
}
function $d3f8316812461761$export$e38d6b3a2f9fbc0(type, key) {
    if (!this.isCanvas()) this.warn('Creating on canvas requires active canvas page');
    const Collection = this.getCanvasCollection();
    if (!Collection) return this.error('Canvas Collection was not found');
    const frameWindow = this.getCanvasFrameWindow();
    const value = this.getDataItem(key, type);
    const newType = this.call('toTitleCase', typeof value);
    if (this.call('hasArtboard', type)) {
        new frameWindow[newType](value);
        Collection.context[type][key] = new frameWindow[newType](value);
    } else if (this.call('hasExecutable', type)) {
        if (!value) debugger;
        Collection.context[type][key] = value;
    }
}
function $d3f8316812461761$export$3234d7e1956cc367(type, key) {
    if (!this.isCanvas()) this.warn('Creating on canvas requires active canvas page');
    const chosen = this.getChosenKey();
    if (chosen) {
        const frameWindow = this.getCanvasFrameWindow();
        const value = this.getDataItem(key, type);
        const newType = this.call('toTitleCase', typeof value);
        const chosenContext = this.getChosenElementContext();
        if (this.call('hasArtboard', type)) chosenContext[type][key] = new frameWindow[newType](value);
        else if (this.call('hasExecutable', type)) chosenContext[type][key] = value;
    }
}
async function $d3f8316812461761$export$651d04d0277dc388(type, key, opts) {
    if (!this.isCanvas()) return this.error('Creating on canvas requires active canvas page');
    if (!type || !key) return this.error('Type or key is not defined for create operation');
    type = this.getPlural(type);
    await this.call('createItemInCanvas', type, key);
    await this.call('createItemInChosen', type, key);
    const testArr = [];
    const testFn = async ()=>{
        testArr.push(this.testCase('Item exists in canvas context', 'exists', this.getCanvasContext()[type][key]), this.testCase('Item exists in choosen context', 'existsIf', this.getChosenKey(), this.getChosenKey() && this.getChosenElementContext()[type][key]));
        if (!opts.skipSidebar) {
            await this.call('createItemInSidebar', type, key);
            testArr.push(this.testCase('Item exists in sidebar', 'existsIf', this.call('isTypeSidebarActive', type), this.call('findFileSidebarItem', type, key)));
        }
        return testArr;
    };
    this.testAll(`Creating ${key} ${type}`, testFn);
    if (this.call('hasArtboard', type)) await this.call('createArtboardInCanvas', type, key, opts);
}
async function $d3f8316812461761$export$3e8cca83d22abb50(items, opts = {}) {
    try {
        items.forEach((item)=>{
            const elementExisted = this.getSchemaItem(item.key, item.type);
            console.log(elementExisted);
            if (elementExisted) this.call('updateItem', item.type, item.key, item);
            else this.call('createItem', item.type, item.key, item);
        });
    } catch (error) {
        throw new Error(`Failed to create item: ${error.message}`);
    }
}

});

parcelRegister("4KbCZ", function(module, exports) {

$parcel$export(module.exports, "updateItem", () => $37447a577b730d7b$export$72b8c6d38aa6195b);
$parcel$export(module.exports, "updateItemInCanvas", () => $37447a577b730d7b$export$4e61994633dece8d);
$parcel$export(module.exports, "updateItemInChosenWindow", () => $37447a577b730d7b$export$b44bca6c907e900);
$parcel$export(module.exports, "updateItemInChosenPane", () => $37447a577b730d7b$export$8fa2c675b05774e9);
$parcel$export(module.exports, "updateItemInSidebar", () => $37447a577b730d7b$export$2c7325e3b23d4e86);
$parcel$export(module.exports, "updateCanvasItem", () => $37447a577b730d7b$export$5fcc796bf7d7f953);
/**
 * Updates an item in the database with the specified value
 */ function $37447a577b730d7b$export$72b8c6d38aa6195b(type, key, obj, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for update operation');
    type = this.getPlural(type);
    const res = this.sdk.updateItem(type, obj, opts);
    window.requestAnimationFrame(()=>{
        if (this.call('hasExecutable', type)) this.testAll(`Updating ${key} in ${type}`, ()=>[
                this.testCase('Value equals item in root state', 'isEqualObject', {
                    ...obj.value.toString()
                }, {
                    ...this.getDataItem(key).toString()
                }),
                this.testCase('Schema equals item in root state', 'isEqualObject', obj, this.getItem(key))
            ]);
        else this.testAll(`Updating ${key} in ${type}`, ()=>[
                this.testCase('Value equals item in root state', 'isEqualObject', obj.value, this.getDataItem(key, type)),
                this.testCase('Schema equals item in root state', 'isEqualObject', obj, this.getItem(key, type))
            ]);
    });
    return res;
}
async function $37447a577b730d7b$export$4e61994633dece8d(type, key) {
    const say = typeof this.warn === 'function' && this.warn || null;
    if (say) say.call(this, '[updateItemInCanvas] refused: v1 canvas eval path removed (project code renders only in the opaque user-code frame)', type, key);
    return null;
}
async function $37447a577b730d7b$export$b44bca6c907e900(type, key) {
    if (!this.isCanvas()) {
        this.warn('Updating on canvas requires active canvas page');
        return;
    }
    type = this.getPlural(type);
    const data = this.getCanvasScope();
    if (data.previewSize === 'canvas') {
        const { ViewSvitcher: ViewSvitcher } = this.getChosenScene();
        await ViewSvitcher.content?.update();
    } else {
        const ChosenFrame = this.getChosenIframe();
        await ChosenFrame?.update();
    }
    // testing chosen in timeout
    // due to window.onload listener in Chosen iframe
    window.setTimeout(()=>{
        this.test(`Updating ${key} ${type} on canvas`, ()=>this.testCase('Value equals chosen context', 'isEqualObject', this.getDataItem(key, type), this.getChosenElementContext()?.[type][key]));
    }, 100);
}
function $37447a577b730d7b$export$8fa2c675b05774e9(type, key, opts = {}) {
    if (!this.isCanvas()) {
        this.warn('Updating on canvas requires active canvas page');
        return;
    }
    type = this.getPlural(type);
    const obj = this.getItem(key, type);
    const { value: value } = obj;
    const ChosenElement = this.getChosenElement();
    ChosenElement.state.set({
        ...obj,
        value: value
    }, {
        skipChosenPane: opts.skipChosenPane,
        forceMonacoUpdate: true
    });
}
function $37447a577b730d7b$export$2c7325e3b23d4e86(type, key, opts = {}) {
    if (!this.isCanvas()) {
        this.warn('Updating on canvas requires active canvas page');
        return;
    }
    type = this.getPlural(type);
    const item = this.call('findFileSidebarItem', type, key);
    if (!item || opts.preventItemSidebarUpdate) return;
    const value = this.getDataItem(key, type);
    item.state.replace({
        value: value
    }, {
        preventUpdate: !item.state.showLayers || opts.preventItemSidebarElementUpdate
    });
}
async function $37447a577b730d7b$export$5fcc796bf7d7f953(type, key, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for create operation');
    type = this.getPlural(type);
    // updating code editor panel
    const hasChosen = this.getChosenKey();
    if (!opts.skipCanvasUpdate) {
        if (hasChosen) {
            if (hasChosen === key || !opts.skipChosenPane) await this.call('updateItemInChosenPane', type, key, opts);
            else await this.call('updateItemInChosenWindow', type, key, opts);
            this.call('queueUpdateItemInCanvas', key);
        } else {
            if (!opts.skipChosenPane) await this.call('updateItemInChosenPane', type, key, opts);
            await this.call('updateItemInCanvas', type, key, opts);
        }
    }
    if (!opts.skipSidebar) await this.call('updateItemInSidebar', type, key, opts);
    if (opts.skipRuntimeTests) return;
    this.testAll(`Updating ${key} ${type} on canvas`, ()=>{
        const isExecutable = this.call('hasExecutable', type);
        const isArtboard = this.call('hasArtboard', type);
        const componentOnCanvas = !hasChosen && this.findComponentOnCanvas(key);
        return [
            this.testCase('Item value equals sidebar item value', isExecutable ? 'isEqualFunction' : 'isEqualObject', this.getDataItem(key, type), this.call('findFileSidebarItem', type, key)?.state.value),
            this.testCase('Value equals canvas context', isExecutable ? 'isEqualFunction' : 'isEqualObject', this.getDataItem(key, type), this.getCanvasContext()[type][key]),
            componentOnCanvas && this.testCase('Value equals code editor state', 'isEqualObject', this.getItem(key, type), this.getChosenElement().state.parse()),
            componentOnCanvas && this.testCase('Value equals canvas item state', 'isEqualObject', this.getItem(key, type), this.findComponentOnCanvas(key).state.parse())
        ];
    });
}

});

parcelRegister("cHcgu", function(module, exports) {

$parcel$export(module.exports, "removeItemFromSidebar", () => $93e303bd89f96758$export$4ff98033131be45c);
$parcel$export(module.exports, "removeItemFromCanvas", () => $93e303bd89f96758$export$421de41880e8315a);
$parcel$export(module.exports, "removeItemFromChosen", () => $93e303bd89f96758$export$30d82c64babf727);
$parcel$export(module.exports, "removeItem", () => $93e303bd89f96758$export$fe2d9b4e03920b4c);
$parcel$export(module.exports, "removeCanvasArtboard", () => $93e303bd89f96758$export$287a7f23707a14d6);
$parcel$export(module.exports, "removeCanvasExecutable", () => $93e303bd89f96758$export$5faba700ec13f73e);
$parcel$export(module.exports, "removeAny", () => $93e303bd89f96758$export$d9b41b2e1c1e6bb5);
// type = this.call('getType'),
// key = this.state.key
function $93e303bd89f96758$export$4ff98033131be45c(type, key) {
    type = this.getPlural(type);
    const item = this.call('findFileSidebarItem', type, key);
    if (!item) return;
    item.remove();
    if (!this.call('hasItems', type)) this.call('rerenderFileSidebarByType', type);
}
function $93e303bd89f96758$export$421de41880e8315a(type, key) {
    if (!this.isCanvas()) this.warn('Removing from canvas requires active canvas page');
    type = this.getPlural(type);
    const Collection = this.getCanvasCollection();
    if (!Collection) return this.error('Canvas Collection was not found');
    delete Collection.context[type][key];
}
function $93e303bd89f96758$export$30d82c64babf727(type, key) {
    if (!this.isCanvas()) return this.warn('Removing from chosen requires active canvas page');
    type = this.getPlural(type);
    const editor = this.getComponentEditor();
    const functionEditor = editor.parent.FunctionEditor;
    if (functionEditor.state.key === key) this.call('activateFunction', null);
    const chosen = this.getChosenKey();
    const chosenContext = this.getChosenElementContext();
    if (chosen) this.getChosenScene().update();
    if (key === this.call('getChosenKey')) this.call('activateChosen', null);
    if (!chosenContext) {
        if (chosen) this.error('Canvas Chosen is set but chosen context was not found');
        return;
    }
    if (chosen === key) this.activateChosen(null);
    delete chosenContext[type][key];
}
function $93e303bd89f96758$export$fe2d9b4e03920b4c(type, key, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    const confirmMsg = `Do you want to remove the "${key}" from ${type}?`;
    // TODO(@symbo.ls/windows migration): replace with
    // `this.call('confirmDialog', { onConfirm: () => continueWithRemoval() })`.
    // Same blocker as workspace/packages/shared/methods/component.js's
    // `checkIfReferencedInOtherCanvasItems` — this function returns false
    // synchronously when the user declines, and callers consume that
    // boolean. Migration needs the caller chain made async first.
    if (!opts.skipConfirmation && !window.confirm(confirmMsg)) return false;
    const isInDataOrSchema = this.getData(type)[key];
    if (!isInDataOrSchema) this.warn("Trying to remove but can't find in data", type, key);
    this.sdk.deleteItem(type, key, opts);
    this.call('removeItemFromCanvas', type, key);
    this.call('removeItemFromChosen', type, key);
    const testArr = [];
    const testFn = ()=>{
        testArr.push(this.testCase('Item exists in root state', 'notExists', this.getItem(key, type)), this.testCase('Item exists in canvas context', 'notExistsIf', this.call('isCanvas'), this.getCanvasContext()[type][key]), this.testCase('Item exists in chosen context', 'notExistsIf', this.call('isCanvas'), this.getChosenElementContext()?.[type][key]));
        if (!opts.skipSidebar) {
            this.call('removeItemFromSidebar', type, key);
            testArr.push(this.testCase('Item exists in sidebar', 'notExistsIf', this.call('isTypeSidebarActive', type), this.call('findFileSidebarItem', type, key)));
        }
    };
    // run tests if in debugging mode
    this.testAll(`Removing ${key} in ${type}`, testFn);
    return true;
}
function $93e303bd89f96758$export$287a7f23707a14d6(type = this.getType(), key, opts = {}) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    const referencedRemovalPermitted = this.call('checkIfReferencedInOtherCanvasItems', type, key);
    if (!referencedRemovalPermitted) return;
    const canvasPageChanges = this.call('returnRemovedCanvasPageChanges', type, key);
    if (canvasPageChanges) opts.append = canvasPageChanges;
    const removed = this.call('removeItem', type, key, opts);
    if (!removed) return;
    const found = this.findComponentOnCanvas(key);
    if (found?.node) {
        this.getCanvasFrameWindow().gs.removeWidget(found.node);
        found.remove();
    }
    if (referencedRemovalPermitted.length) this.call('refreshComponentsWhereReferencedOnCanvas', key);
    if (this.getSelectedKey() === key) this.activateSelected(null);
    this.testAll(`Removing ${key} in ${type}`, [
        this.testCase('Item exists in root state', 'notExists', this.getSchema(type)[key]),
        this.testCase('Item exists in canvas context', 'notExists', this.getCanvasContext()[type][key]),
        this.testCase('Item exists on canvas', 'notExists', this.findComponentOnCanvas(key)),
        this.testCase('Item was removed from canvas page', 'notExists', this.getActiveCanvasPage() !== 'Default' && this.call('onCurrentCanvasPage', type, key))
    ]);
    return true;
}
function $93e303bd89f96758$export$5faba700ec13f73e(type, key, opts) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    // TODO: find components that use this function
    // and prompt the confirmation
    const removed = this.call('removeItem', type, key, opts);
    if (!removed) return;
    const Canvas = this.getCanvas();
    Canvas.update();
    this.getChosenScene().update();
    return true;
}
function $93e303bd89f96758$export$d9b41b2e1c1e6bb5(type, key, opts) {
    if (!type || !key) return this.error('Type or key is not defined for remove operation');
    type = this.getPlural(type);
    if (this.call('hasArtboard', type)) return this.call('removeCanvasArtboard', type, key, opts);
    else if (this.call('hasExecutable', type)) return this.call('removeCanvasExecutable', type, key, opts);
    return this.call('removeItem', type, key, opts);
}

});

parcelRegister("fiyHo", function(module, exports) {

$parcel$export(module.exports, "getTypes", () => $b23373ec8ee6642a$export$e1d41611756c6326);
$parcel$export(module.exports, "hasType", () => $b23373ec8ee6642a$export$f4e222cb4ec295d5);
$parcel$export(module.exports, "getWhichKey", () => $b23373ec8ee6642a$export$888f5ebd0ea35a46);
$parcel$export(module.exports, "hasItems", () => $b23373ec8ee6642a$export$97057de2cd25fb57);
$parcel$export(module.exports, "hasArtboard", () => $b23373ec8ee6642a$export$803ee7a26cf75791);
$parcel$export(module.exports, "hasExecutable", () => $b23373ec8ee6642a$export$5d65de9976e572db);
function $b23373ec8ee6642a$export$e1d41611756c6326(key) {
    const ARTBOARD_TYPES = [
        'pages',
        'components'
    ];
    // const COMPONENT_TYPES = ['components']
    // const PAGE_TYPES = ['pages']
    const STATE_TYPES = [
        'state'
    ];
    const ASSETS_TYPES = [
        'files'
    ];
    const FUNCTION_TYPES = [
        'functions',
        'methods',
        'snippets'
    ];
    const INTEGRATIONS_TYPES = [
        'dependencies',
        'secrets'
    ];
    const COLOR_TYPES = [
        'color',
        'gradient',
        'semantic_color',
        'global_theme',
        'theme'
    ];
    const TYPOGRAPHY_TYPES = [
        'typography',
        'font',
        'font_family',
        'type_templates'
    ];
    const ICON_TYPES = [
        'icons'
    ];
    const SPACING_TYPES = [
        'spacing',
        'shape'
    ];
    const RESPONSIVE_TYPES = [
        'media'
    ];
    const TRANSITION_TYPES = [
        'animations',
        'transitions'
    ];
    const DESIGN_SYSTEM_TYPES = [
        ...COLOR_TYPES,
        ...TYPOGRAPHY_TYPES,
        ...ICON_TYPES,
        ...SPACING_TYPES,
        ...RESPONSIVE_TYPES,
        ...TRANSITION_TYPES
    ];
    const DATA_TYPES = [
        ...ARTBOARD_TYPES,
        ...STATE_TYPES,
        ...ASSETS_TYPES,
        ...FUNCTION_TYPES,
        ...INTEGRATIONS_TYPES
    ];
    const ALL_TYPES = [
        ...ARTBOARD_TYPES,
        ...STATE_TYPES,
        ...ASSETS_TYPES,
        ...FUNCTION_TYPES,
        ...INTEGRATIONS_TYPES,
        ...DESIGN_SYSTEM_TYPES
    ];
    const typeMap = {
        ALL_TYPES: ALL_TYPES,
        DATA_TYPES: DATA_TYPES,
        ARTBOARD_TYPES: ARTBOARD_TYPES,
        STATE_TYPES: STATE_TYPES,
        ASSETS_TYPES: ASSETS_TYPES,
        FUNCTION_TYPES: FUNCTION_TYPES,
        INTEGRATIONS_TYPES: INTEGRATIONS_TYPES,
        COLOR_TYPES: COLOR_TYPES,
        TYPOGRAPHY_TYPES: TYPOGRAPHY_TYPES,
        ICON_TYPES: ICON_TYPES,
        SPACING_TYPES: SPACING_TYPES,
        RESPONSIVE_TYPES: RESPONSIVE_TYPES,
        TRANSITION_TYPES: TRANSITION_TYPES,
        DESIGN_SYSTEM_TYPES: DESIGN_SYSTEM_TYPES
    };
    return key ? typeMap[key] : typeMap;
}
function $b23373ec8ee6642a$export$f4e222cb4ec295d5(key, type) {
    const types = this.call('getTypes', key);
    return types.includes(type);
}
function $b23373ec8ee6642a$export$888f5ebd0ea35a46(type) {
    const typeMap = this.call('getTypes') // get the full map
    ;
    const keys = Object.keys(typeMap);
    // Skip ALL_TYPES since it's just an aggregate
    const filteredKeys = keys.filter((k)=>k !== 'ALL_TYPES');
    const foundIn = filteredKeys.filter((key)=>{
        const list = typeMap[key];
        return Array.isArray(list) && list.includes(type);
    });
    return foundIn;
}
function $b23373ec8ee6642a$export$97057de2cd25fb57(type) {
    const hasData = this.getData(type);
    return Boolean(hasData && Object.keys(hasData).length > 0);
}
function $b23373ec8ee6642a$export$803ee7a26cf75791(type) {
    return this.call('hasType', 'ARTBOARD_TYPES', type);
}
function $b23373ec8ee6642a$export$5d65de9976e572db(type) {
    return this.call('hasType', 'FUNCTION_TYPES', type);
}

});

parcelRegister("dDKfH", function(module, exports) {

$parcel$export(module.exports, "duplicateItem", () => $9ee2cb968fbd89cf$export$67c53289288d8c33);
async function $9ee2cb968fbd89cf$export$67c53289288d8c33(type, key, forcedValue, opts) {
    if (!type || !key) return this.error('Type or key is not defined for create operation');
    const item = this.call('deepClone', forcedValue?.value ? forcedValue : this.call('getItem', key, type));
    if (!item) {
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'editor.crud.notFound.title'),
            message: this.call('polyglot', 'editor.crud.notFound.message').replace('{key}', key).replace('{type}', type)
        });
        return this.error('Could not find target element');
    }
    const altKey = this.call('findNewName', type, key);
    if (!altKey) {
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'editor.crud.duplicateFailed.title'),
            message: this.call('polyglot', 'editor.crud.duplicateFailed.message').replace('{key}', key).replace('{altKey}', altKey)
        });
        return this.error('Could not duplicate');
    }
    item.key = altKey;
    if (this.call('hasArtboard', type)) {
        if (item.settings.gridOptions.y) item.settings.gridOptions.y += 2;
    }
    await this.call('createItem', type, altKey, item, opts);
    this.testAll(`Duplicating ${key} as ${altKey} in ${type}`, ()=>[
            this.testCase('Item exists in root state', 'exists', this.getSchemaItem(altKey, type) && this.getDataItem(altKey, type))
        ]);
    return item;
}

});

parcelRegister("cwycr", function(module, exports) {

$parcel$export(module.exports, "renameItemInSidebar", () => $91e300846cfad8d8$export$9b435b8df4debf7a);
$parcel$export(module.exports, "rename", () => $91e300846cfad8d8$export$7ac989ec0c9c279);
function $91e300846cfad8d8$export$9b435b8df4debf7a(type, key, newKey) {
    type = this.getPlural(type);
    const item = this.call('findFileSidebarItem', type, key);
    if (!item) return;
    item.state.update({
        key: newKey
    });
}
async function $91e300846cfad8d8$export$7ac989ec0c9c279(type, oldKey, newKey) {
    if (!type || !oldKey || !newKey) return this.error('Type, old name or new name is not defined for rename operation');
    type = this.getPlural(type);
    const confirmMsg = `Do you want to rename "${oldKey}" to "${newKey}" in ${type}?`;
    if (!window.confirm(confirmMsg)) return false;
    let item = this.call('getItem', oldKey, type);
    if (!item) {
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'editor.crud.notFound.title'),
            message: this.call('polyglot', 'editor.crud.notFound.message').replace('{key}', oldKey).replace('{type}', type)
        });
        return this.error('Could not find target element');
    }
    if (this.call('getItem', newKey, type)) {
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'editor.crud.renameFailed.title'),
            message: this.call('polyglot', 'editor.crud.renameFailed.message').replace('{newKey}', newKey)
        });
        return this.error('Could not rename');
    }
    item = this.call('deepClone', item);
    item.key = newKey;
    this.call('removeAny', type, oldKey, {
        skipConfirmation: true,
        skipSidebar: true
    }) // add skipSidebar, skipConfirmation
    ;
    this.call('createItem', type, newKey, item, {
        skipSidebar: true
    });
    this.call('renameItemInSidebar', type, oldKey, newKey);
}

});

parcelRegister("2Cj92", function(module, exports) {

$parcel$export(module.exports, "delegateArtboardUpdate", () => $1e7dfb1e0ab69beb$export$f400ac37a66283ae);
$parcel$export(module.exports, "delegateExecutableUpdate", () => $1e7dfb1e0ab69beb$export$f6703f77fe0f17b0);
$parcel$export(module.exports, "delegateSingleUpdate", () => $1e7dfb1e0ab69beb$export$2b1d43de83771646);
$parcel$export(module.exports, "delegateTypeUpdate", () => $1e7dfb1e0ab69beb$export$ade1e1cd2d622c06);
$parcel$export(module.exports, "delegateUpdates", () => $1e7dfb1e0ab69beb$export$d84508fc0bdb9e5a);
async function $1e7dfb1e0ab69beb$export$f400ac37a66283ae(type, key, opts = {}) {
    const Collection = this.getCanvasCollection();
    const componentExists = Boolean(Collection?.context?.[type]?.[key]);
    if (!componentExists) await this.call('createCanvasItem', type, key, opts);
    else if (this.inOnCurrentCanvasPage(type, key)) await this.call('updateCanvasItem', type, key, opts);
    else await this.refreshComponentsWhereReferencedOnCanvas(key);
}
async function $1e7dfb1e0ab69beb$export$f6703f77fe0f17b0(type, key, opts = {}) {
    const Collection = this.getCanvasCollection();
    const executableExists = Boolean(Collection.context[type][key]);
    if (!executableExists) await this.call('createCanvasItem', type, key, opts);
    else await this.call('updateCanvasItem', type, key, opts);
}
async function $1e7dfb1e0ab69beb$export$2b1d43de83771646(type, key, opts = {}) {
    if (this.call('hasArtboard', type)) await this.call('delegateArtboardUpdate', type, key, opts);
    else if (this.call('hasExecutable', type)) await this.call('delegateExecutableUpdate', type, key, opts);
    this.addIfPlatformProject(type, key);
}
async function $1e7dfb1e0ab69beb$export$ade1e1cd2d622c06(type, typeData, opts = {}) {
    if (!this.hasItems(type)) return;
    for(const key in typeData)await this.call('delegateSingleUpdate', type, key, opts);
}
async function $1e7dfb1e0ab69beb$export$d84508fc0bdb9e5a(changes, opts = {}) {
    const hasSchema = Boolean(changes.schema);
    const hasDataTypes = Object.keys(changes).some((type)=>this.hasItems(type));
    if (!hasDataTypes && hasSchema) changes = changes.schema;
    for(const type in changes){
        const typeData = changes[type];
        await this.call('delegateTypeUpdate', type, typeData, {
            changes: changes,
            ...opts
        });
    }
}

});



parcelRegister("eMkMf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "state", () => $ac25aa535cb907e5$export$ca000e230c0caa3e);
$parcel$export(module.exports, "globalState", () => $ac25aa535cb907e5$export$8e769ad4338a911e);
$parcel$export(module.exports, "optionsState", () => $ac25aa535cb907e5$export$de10ebaa839757cf);
$parcel$export(module.exports, "default", () => $ac25aa535cb907e5$export$2e2bcd8739ae039);
// From '@symbo.ls/utils', not the 'smbls' barrel — keeps the framework bundle
// out of the eager chunk (same fix as workspace/functions/extensionDesignSystem.js).
parcelRequire("byww3");
var $hi618 = parcelRequire("hi618");
parcelRequire("iK7qd");
// Guarded — this module is now reached by a plain `import _wsShared from
// '@symbo-ls/workspace-shared'` (the bare-root fix for the deep-subpath
// frank-serialization break, tickets/execution-board.md §1) from Node/bun
// test files and any future SSR context, none of which have `window`. A
// real browser always has it, so behavior there is unchanged.
const $ac25aa535cb907e5$var$_loc = typeof window !== 'undefined' ? window.location : null;
const [, $ac25aa535cb907e5$var$embed] = ($ac25aa535cb907e5$var$_loc ? $ac25aa535cb907e5$var$_loc.pathname : '').split('/');
const $ac25aa535cb907e5$var$isEmbed = $ac25aa535cb907e5$var$embed === 'embed';
const $ac25aa535cb907e5$var$urlParams = new URLSearchParams($ac25aa535cb907e5$var$_loc ? $ac25aa535cb907e5$var$_loc.search : '');
const $ac25aa535cb907e5$var$globalTheme = $ac25aa535cb907e5$var$urlParams.get('globalTheme');
const $ac25aa535cb907e5$var$followingUser = $ac25aa535cb907e5$var$urlParams.get('followingUser');
const $ac25aa535cb907e5$var$selected = $ac25aa535cb907e5$var$urlParams.get('selected');
// @preserve-env
const $ac25aa535cb907e5$var$ENV = "development";
const $ac25aa535cb907e5$export$ca000e230c0caa3e = {
    isRootState: true,
    isEmbed: $ac25aa535cb907e5$var$isEmbed,
    // shareRootStateOnCanvas: true,
    ENV: (0, $hi618.getCookie)('ENV') || $ac25aa535cb907e5$var$ENV || 'development',
    // DEFAULTS: {
    //   DS_DEFAULTS,
    //   DATA_DEFAULTS,
    //   SETTINGS_DEFAULTS
    // },
    // ...deepClone(DATA_DEFAULTS),
    // schema: deepClone(DATA_DEFAULTS),
    canvas: {
        clients: {},
        pages: {}
    },
    settings: {
        remote: false,
        async: false,
        inspect: true,
        liveSync: true,
        syncCanvas: true
    },
    sampleText: 'Today is a big day for our tribe. The year ends.',
    framework: (0, $hi618.getCookie)('framework') || 'symbols',
    pkgManager: (0, $hi618.getCookie)('pkgManager') || 'npm',
    language: (0, $hi618.getCookie)('language') || 'js',
    installTab: (0, $hi618.getCookie)('installTab') || 'local',
    followingUser: $ac25aa535cb907e5$var$followingUser,
    selected: $ac25aa535cb907e5$var$selected,
    notifications: [],
    // NotificationPanel (shared) All/Unread filter — declared here too so the
    // canvas standalone scope (links shared, not the workspace package) can
    // switch tabs; undeclared keys drop writes silently in v3.14.
    _notifFilter: 'all',
    // HeaderTabs (shared) reorder-drag UI state — same dual-declaration
    // rationale as _notifFilter above.
    _navbarReorder: false,
    _navbarDragPath: null,
    _navbarDragOverPath: null,
    _navbarDragOverAfter: false,
    sync: true,
    syncDesignSystem: true,
    syncState: true,
    syncComponents: true,
    syncPages: true,
    syncSnippets: true,
    syncSchema: true,
    chosenQueue: [],
    sharedLibrary: null,
    user: {
        smblsFromLocal: (0, $hi618.getCookie)('smblsFromLocal') === 'true',
        topNavbarActive: (0, $hi618.getCookie)('topNavbarActive') !== 'false',
        bottomNavbarActive: (0, $hi618.getCookie)('bottomNavbarActive') === 'true',
        allowTitleOnArtboard: (0, $hi618.getCookie)('allowTitleOnArtboard') !== 'false',
        autoSaveSettings: (0, $hi618.getCookie)('autoSaveSettings') !== 'false',
        isSidebarSticky: (0, $hi618.getCookie)('isSidebarSticky') === 'true',
        autoCleanConsole: (0, $hi618.getCookie)('autoCleanConsole') === 'true',
        componentShowFilter: (0, $hi618.getCookie)('componentShowFilter') || 'all',
        navbarPlacement: (0, $hi618.getCookie)('navbarPlacement') || 'right',
        presentMode: (0, $hi618.getCookie)('presentMode') !== 'false',
        showErrorBanner: (0, $hi618.getCookie)('showErrorBanner') !== 'false',
        thumbnailPreview: (0, $hi618.getCookie)('thumbnailPreview') === 'true',
        optimizedMode: (0, $hi618.getCookie)('optimizedMode') === 'true',
        showGrid: (0, $hi618.getCookie)('showGrid') === 'true',
        explorerAutoscroll: (0, $hi618.getCookie)('explorerAutoscroll') !== 'false',
        debuggingMode: (0, $hi618.getCookie)('debuggingMode') === 'true',
        useGlassmorphism: (0, $hi618.getCookie)('useGlassmorphism') !== 'false',
        allowAutoPosition: (0, $hi618.getCookie)('allowAutoPosition') !== 'false',
        allowInitialSelection: (0, $hi618.getCookie)('allowInitialSelection') !== 'false',
        allowTabs: (0, $hi618.getCookie)('allowTabs') !== 'false',
        showReferences: (0, $hi618.getCookie)('showReferences') !== 'false',
        allowTeamCursors: (0, $hi618.getCookie)('allowTeamCursors') !== 'false',
        allowFilesidebarPreview: (0, $hi618.getCookie)('allowFilesidebarPreview') !== 'false',
        allowTabPreview: (0, $hi618.getCookie)('allowTabPreview') !== 'false',
        useAnimations: (0, $hi618.getCookie)('useAnimations') !== 'false',
        allowZoombar: (0, $hi618.getCookie)('allowZoombar') !== 'false',
        zoomLevel: (0, $hi618.getCookie)('zoomLevel') || 1,
        assistant: (0, $hi618.getCookie)('assistant') !== 'false',
        openOnDblClick: (0, $hi618.getCookie)('openOnDblClick') === 'true',
        autoSelectSidebar: (0, $hi618.getCookie)('autoSelectSidebar') === 'true',
        allowCanvasReplaceRouter: (0, $hi618.getCookie)('allowCanvasReplaceRouter') !== 'false',
        languageDirection: (0, $hi618.getCookie)('languageDirection') || 'ltr',
        editorPanelsAtRight: (0, $hi618.getCookie)('editorPanelsAtRight') === 'true'
    },
    sharedLibraries: [],
    clients: {
        localhost: {},
        cli: {},
        platform: {}
    },
    seats: 1,
    loading: true,
    // FALSE-ZERO-1 surface 4 — agent roster (Chat.js `ensureAgentRoster`,
    // consumed by workspace's "Your agents" widgets + tickets assignables +
    // canvas team-and-agents). Declared here (not left to fall through) per
    // the `_worldAtlasTick` lesson (analytics/state.js) — an undeclared key's
    // `root.update` is silently dropped by the v3.14 schema check, which
    // would re-introduce the exact bug this pair of keys exists to fix.
    //
    // Three distinguishable states, never collapsed into one "0":
    //   _agents === null && _agentsError === null  → still loading
    //   _agents === null && _agentsError !== null   → load failed
    //   Array.isArray(_agents)                      → loaded ([] is a real,
    //                                                  verified zero agents)
    _agents: null,
    _agentsError: null
};
const $ac25aa535cb907e5$export$8e769ad4338a911e = $ac25aa535cb907e5$export$ca000e230c0caa3e;
const $ac25aa535cb907e5$export$de10ebaa839757cf = $ac25aa535cb907e5$export$ca000e230c0caa3e;
var $ac25aa535cb907e5$export$2e2bcd8739ae039 = $ac25aa535cb907e5$export$ca000e230c0caa3e;

});
parcelRegister("iK7qd", function(module, exports) {
const $da5247b2ac646156$export$e79573a1cd412b48 = {};
const $da5247b2ac646156$export$9d2f44153ac70a91 = {
    designSystem: {},
    components: {},
    integrations: {},
    snippets: {},
    pages: {},
    state: {},
    files: {},
    dependencies: {},
    methods: {},
    functions: {},
    secrets: {}
};
const $da5247b2ac646156$export$682df56aa4d8a46e = {
    remote: false,
    async: false,
    inspect: true,
    liveSync: true,
    syncCanvas: true
};

});


parcelRegister("eV30a", function(module, exports) {

$parcel$export(module.exports, "default", () => $adc8b7a2e8bc1d4b$export$2e2bcd8739ae039);

var $jnnbJ = parcelRequire("jnnbJ");

var $d7wol = parcelRequire("d7wol");

var $fjLK0 = parcelRequire("fjLK0");

var $bgCAG = parcelRequire("bgCAG");

var $6xlnf = parcelRequire("6xlnf");

var $k3Vb1 = parcelRequire("k3Vb1");

var $ajbVE = parcelRequire("ajbVE");
var // `timing` is gone: its one staged key, `springBezier`, ships in brand since
// 3.14.798 (lane D1 of the white-label redesign) — brand designSystem/timing.js.
$adc8b7a2e8bc1d4b$export$2e2bcd8739ae039 = {
    color: $jnnbJ.default,
    sizes: $d7wol.default,
    shadow: $fjLK0.default,
    theme: $bgCAG.default,
    animation: $6xlnf.default,
    media: $k3Vb1.default,
    icons: $ajbVE.default
};

});
parcelRegister("jnnbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1b226f9d1eaa64f$export$2e2bcd8739ae039);
// Interaction washes — DESIGN_LANGUAGE.md §4.3. Byte-identical to the house
// washes previously pinned as string literals by themeChrome.test.js
// (light-dark(rgba(20,20,22,0.08), rgba(255,255,255,0.1)) and the
// 0.05/0.07 hover pair). Adaptive pairs are [lightValue, darkValue]
// (scratch system/color.js normalizes arrays as { '@light': v[0], '@dark': v[1] }).
// Canonical home is brand designSystem/color.js — this copy carries the
// tokens for deployed workspace builds until the brand publish lands.
var $e1b226f9d1eaa64f$export$2e2bcd8739ae039 = {
    // §4.4 accent ink — accent-hue links/actions must hold AA as SMALL-text ink
    // on BOTH stages AND raised surfaces. Brand `blue` (#0085FF) measured
    // 2.8–3.5:1 on light tints and 4.27:1/3.41:1 on dark gray3/gray4 cards
    // (~460 instances: admin/logs, tickets chips, marketplace Install, /my
    // quick links — 2026-08-08 AA walk). Both halves re-tone the same hue:
    // deepened for light (≥4.9:1 on white/gray15/gray16), brightened for dark
    // (≥5:1 on gray1–gray4). [lightValue, darkValue].
    // Light half deepened #0A66CC → #0A5CB8 (2026-08-08): the first value held
    // on white/gray16/gray15 (5.55/5.32/4.92) but only reached 4.25 on the
    // gray14-class page WASH — where a lot of chrome actually sits, so eyebrows
    // there still failed after the swap. #0A5CB8 clears every light ground:
    // 6.49 white / 6.22 gray16 / 5.75 gray15 / 4.97 wash / 4.14 gray13 (the
    // last is a card-edge tint that carries no small text).
    blueDeep: '#0A5CB8',
    blueBright: '#47A8FF',
    accentInk: [
        'blueDeep',
        'blueBright'
    ],
    // Semantic INK pairs — same construction as accentInk, for the cases where
    // a status hue must be the TEXT rather than a wash or a dot (§4.2 + §8.5
    // rule 3: prefer wash+neutral ink; reach for these only when the hue itself
    // is the signal, e.g. a lone "on"/"3 failed" figure with no plate). The raw
    // brand hues measured 2.15 (green), 2.45 (red), 2.73 (orange), 2.4
    // (magenta) as bold ink on the gray14-class wash — every one under the 4.5
    // floor. Each pair is verified ≥4.7 on white/gray16/gray15/wash (light) and
    // ≥5 on gray1–gray4 (dark).
    greenDeep: '#2A6E28',
    greenBright: '#7FD07B',
    successInk: [
        'greenDeep',
        'greenBright'
    ],
    redDeep: '#A83520',
    redBright: '#FFA191',
    dangerInk: [
        'redDeep',
        'redBright'
    ],
    orangeDeep: '#94500F',
    orangeBright: '#F4A45E',
    warningInk: [
        'orangeDeep',
        'orangeBright'
    ],
    magentaDeep: '#A100A1',
    magentaBright: '#FF7AFF',
    magentaInk: [
        'magentaDeep',
        'magentaBright'
    ],
    // THE TINT PLATE BASE — what a hue chip mixes its own ink into
    // (`color-mix(in srgb, currentColor N%, var(--color-tintBase))`), instead of
    // into `transparent`. A transparent tint lets the ground show through, and
    // the inks above are tuned for the page and card grounds only: on a raised or
    // grey fill (dark ~67–82, light ~181–226) a hue chip fell to 2.7–4.2:1 —
    // measured on dev 2026-10-07 (accent 2.69 on a raised card, warning 3.47,
    // danger 3.59; light accent 4.01, danger 3.15). An opaque plate built on a
    // fixed base keeps the ink's own contrast on every ground: white in light,
    // the card colour in dark (`cardSolid`'s dark half), so a chip on a card
    // looks exactly as before. 10–20 % of every ink here stays >= 4.5:1
    // (__tests__/tintBaseOwnTint.test.js).
    tintBase: [
        'white',
        'gray3'
    ],
    hover: [
        'black.05',
        'white.07'
    ],
    selected: [
        'gray2.08',
        'white.1'
    ],
    // THE CARD'S HOVER AND PRESS (Nika 2026-10-23: "on widgets and sections
    // colors on dark mode, make sections darker on hover instead of light"):
    // the wash over a CARD — a dashboard widget, a Fly page's section, a Fly
    // start tile, a summary tile. Light: the house hover and press, a step
    // darker. Dark: a step darker too. The house `hover` (white) lifted the dark
    // glass card (about rgb 33 on the rgb 69 stage) to about rgb 64, the stage's
    // own grey, so a hovered card lost its edge (measured on dev 2026-10-23).
    // Black 25 % takes it to about rgb 25: the same perceived step as light's
    // (about 4 L*). Controls keep `hover` / `selected`.
    cardHover: [
        'black.05',
        'black.25'
    ],
    cardPress: [
        'gray2.08',
        'black.35'
    ],
    // Workspace STAGE + widget icon plate — canonical in brand color.js (same
    // mirror rule as the washes above). `stage` is the ground under the home
    // dashboard and every canvas page (NOT the PageSlot, which stays on
    // `document`). Replaces the per-workspace settings.designSystem record that
    // skinned only one workspace (Nika 2026-08-15: make it general).
    //
    // Dark = `gray5`, NOT the document's dark half. `gray1+4` resolved to
    // rgb(8,8,8) — effectively black, which Nika rejected on sight (2026-08-15:
    // "fix background - not black - use one that codex created"). `gray5`
    // (rgb(69,69,75)) is the adaptive neutral canvas Codex shipped for /files
    // and the /tasks board (CODEX-V3), and those two surfaces still paint it
    // via `var(--canvas-bg, var(--color-gray5))` — so before this change the
    // home board and the canvas pages were near-black while Files and the task
    // board sat on a mid gray. Pointing `stage` at the same tone is what makes
    // the ground actually general instead of general-but-different-per-surface.
    stage: [
        'milk',
        'gray5'
    ],
    widgetPlate: [
        'gray2.07',
        'white.13'
    ]
};

});

parcelRegister("d7wol", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d50e1b0b9d05b2$export$2e2bcd8739ae039);
// Semantic control geometry — DESIGN_LANGUAGE.md §3 + §6. Fixed-px sizes
// tokens resolve BEFORE the em-relative spacing sequence (scratch
// sequence.js getSequenceValue), so radii and control heights stay stable
// regardless of the element's own fontSize — the trap that broke the
// Bellforge control scale. Mirrored in brand designSystem/sizes.js.
var $98d50e1b0b9d05b2$export$2e2bcd8739ae039 = {
    radiusControl: '12px',
    radiusCard: '17px',
    radiusSheet: '24px',
    radiusPill: '999px',
    controlH: '44px',
    controlHCompact: '36px',
    // THE TOUCH FIELD TEXT FLOOR (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): iOS
    // Safari zooms the page when a focused input / textarea / select computes
    // a font-size under 16px. A device-physical threshold, so a fixed px: the
    // field kit's archetypes (AppField.js) take it under '@coarse', where the
    // em-based type scale put them at 12.8-15.4px (measured on dev DFI).
    fieldTextTouch: '16px',
    // THE GLYPH PLATE (dropdowns spec 2026-09-30 §4): the square that holds a workspace glyph — 48 for a
    // launcher tile (a 32 px glyph), 32 for a menu row, 24 for a chip / tab; the orange 'you are here' dot.
    glyphPlate: '48px',
    glyphPlateSm: '32px',
    glyphPlateXs: '24px',
    glyphDot: '8px'
};

});

parcelRegister("fjLK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b26da9b99b216f98$export$2e2bcd8739ae039);
// The entire elevation system — DESIGN_LANGUAGE.md §2.3. Two named shadows,
// [lightValue, darkValue] pairs; everything not float/overlay casts nothing.
// The dark overlay half is byte-equivalent to the previously dominant modal
// shadow (0 8px 32px rgba(0,0,0,0.45)), so the largest existing family has
// zero visual delta. Mirrored in brand designSystem/shadow.js.
var $b26da9b99b216f98$export$2e2bcd8739ae039 = {
    float: [
        '0 2px 12px black.08',
        '0 4px 16px black.35'
    ],
    overlay: [
        '0 8px 32px black.12',
        '0 8px 32px black.45'
    ],
    // THE focus ring (DESIGN_LANGUAGE §8.2, canonical in brand shadow.js +
    // painted globally by brand reset.js). Reference these ONLY where the ring
    // cannot arrive by itself: `focusRing` on the visible proxy of a hidden
    // input; `focusRingInset` on rows inside a clipped container (menu panels,
    // overflow:auto lists) where the outer spread would be cut off. Never
    // restate the value, never an `outline:` ring — that fork was F1.
    focusRing: '0 0 0 1px var(--color-document), 0 0 0 3px var(--color-highlight)',
    focusRingInset: 'inset 0 0 0 1px var(--color-document), inset 0 0 0 3px var(--color-highlight)'
};

});

parcelRegister("bgCAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $833f1fa009dd1ea1$export$2e2bcd8739ae039);
// Surface themes — DESIGN_LANGUAGE.md §2.2. Brand owns every surface theme
// now: `card` (branded 2026-09-23, 3.14.792), and since 3.14.798 (lane D1 of
// the white-label redesign) the overlay sheet `dialog` (white / gray3) and
// the two veils `backdrop` (scrim + blur(8px), behind every modal, side
// panel and phone sheet) and `backdropSoft` (PageSlot's non-blocking veil).
// The copies that lived here were DEAD the moment brand defined the same
// leaves (`deepDefaults` below only fills a MISSING leaf) and are gone;
// __tests__/stagedOverlayTokens.test.js locks brand's values to the
// contract and keeps this file from re-forking them.
var $833f1fa009dd1ea1$export$2e2bcd8739ae039 = {
    // THE SEGMENTED TRACK (AppSegmented, 2026-09-30; Nika via "unreal crm": "the
    // CRM submenu buttons lose their background on other Windows devices" —
    // Windows follows the LIGHT scheme by default). The old track, brand `layer`
    // (gray2.04 in light), read 1.08:1 against the sheet, the header and the page,
    // and the white view thumb on it 1.08-1.22:1 — "no background".
    //   light: the brand's NEUTRAL PLATE `widgetPlate` ('gray2.07' — its light
    //          half; the brand names it for "a segmented track") — 1.15:1 on
    //          every light ground, the white thumb 1.15-1.30:1 on it (with the
    //          `float` ring and shadow);
    //   dark:  `layer`'s own dark value, unchanged ('gray7.1'). widgetPlate's
    //          dark half (white.13) over the dark sheet (gray3) equals the dark
    //          thumb (`raised` gray5): 1.08:1 — the chosen view would vanish in
    //          every dark dialog; on this value it reads 1.49:1 there and 1.78:1
    //          on the page.
    // __tests__/segmentedTrackContrast.test.js pins both halves to the brand
    // tokens and the ratios to their floors.
    segmentTrack: {
        '@dark': {
            background: 'gray7.1'
        },
        '@light': {
            background: 'gray2.07'
        }
    },
    // THE SEARCH GLASS (Nika 2026-09-30, verbatim: "make searchdropdon bg blur") — the search dropdown (the
    // launcher, idle and with typed results) as a VISIBLE glass. `canvas-card-glass` paints gray1 at 85 % in dark
    // (white 95 % in light), so its 35 px backdrop blur barely read. This variant takes the brand's card-glass
    // alpha — the two halves of the `cardGlass` token (brand color.js: ['white.62', 'gray1.55']) — and the house
    // blur by reference (one source of truth). A NEW name, on purpose: the global `canvas-card-glass` every other
    // surface wears stays as it is (a brand-owned name could not be overridden from here anyway — see this file's notes).
    // AA: every launcher ink keeps >= 4.5:1 over this fill on each theme ground and surface
    // (workspace __tests__/searchGlass.test.js).
    'search-glass': {
        '@dark': {
            background: 'gray1.55',
            color: 'gray12',
            backdropFilter: 'var(--theme-canvas-card-glass-backdropFilter)'
        },
        '@light': {
            background: 'white.62',
            color: 'gray2',
            backdropFilter: 'var(--theme-canvas-card-glass-backdropFilter)'
        }
    }
};

});

parcelRegister("6xlnf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c266797ab481d10$export$2e2bcd8739ae039);
// Feedback-system keyframes — DESIGN_LANGUAGE.md §9. `pulse` is the Skeleton
// shimmer (the only looping animation permitted in chrome); it was referenced
// by Skeleton.js but never defined anywhere, so the shimmer has been silently
// dead — an unresolvable animation name emits nothing.
var $4c266797ab481d10$export$2e2bcd8739ae039 = {
    pulse: {
        '0%': {
            opacity: '1'
        },
        '50%': {
            opacity: '0.55'
        },
        '100%': {
            opacity: '1'
        }
    },
    // The side-panel keyframes `panelIn` / `panelOut` were staged here until
    // brand 3.14.798 shipped them (lane D1) — brand designSystem/animation.js.
    // ── STAGED — the mirrored side-panel entrance (Nika 2026-10-30) ──────────
    // `panelIn` slides a panel in from 4% to the RIGHT (its own edge on the
    // right). A side panel on the LEFT edge (the canvas version panels beside a
    // left navbar, workspace app.js) enters from 4% to the left, the same 0.98
    // settle: the brand's travel-direction naming (fadeInLeft travels left).
    // Canonical home is brand designSystem/animation.js; `deepDefaults` fills a
    // leaf only where brand has none, so this copy goes dead the day the
    // internal-brand pin carries it, and is deleted then. Locked by
    // __tests__/stagedPanelInRight.test.js (the contract, and brand equality).
    panelInRight: {
        from: {
            opacity: 0,
            transform: 'translate3d(-4%, 0, 0) scale(0.98)'
        },
        to: {
            opacity: 1,
            transform: 'none'
        }
    }
};

});

parcelRegister("k3Vb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b0708fd3cb4426$export$2e2bcd8739ae039);
// Media queries the shared kit needs beside brand's (brand designSystem/media.js
// fills first; `deepDefaults` adds only a MISSING key).
//
// `forcedColors` — Windows Contrast themes (and every forced-colours mode): the
// browser repaints fills with system colours and drops every box-shadow, so a
// selection shown by a fill or an elevation vanishes and a focus ring drawn as
// a shadow is gone. A component answers with a system-colour OUTLINE:
// `'@forcedColors': { … }` (AppSegmentedItem is the first; 2026-09-30).
var $e9b0708fd3cb4426$export$2e2bcd8739ae039 = {
    forcedColors: '(forced-colors: active)'
};

});

parcelRegister("ajbVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7814ee8a64618496$export$2e2bcd8739ae039);
// GENERATED by scripts/gen-glyph-icons.mjs — do not edit by hand; change the definitions there and
// run `node scripts/gen-glyph-icons.mjs`. px* = pixel glyphs (iconSm / iconXl only), ln* = line glyphs.
var $7814ee8a64618496$export$2e2bcd8739ae039 = {
    pxCrm: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 3h12v1h-12zM1 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM4 5h2v1h-2zM14 5h1v1h-1zM1 6h1v1h-1zM4 6h2v1h-2zM9 6h4v1h-4zM14 6h1v1h-1zM1 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM3 9h4v1h-4zM9 9h4v1h-4zM14 9h1v1h-1zM1 10h3v1h-3zM6 10h2v1h-2zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM2 12h12v1h-12z"/></svg>',
    pxHome: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 2h2v1h-2zM6 3h1v1h-1zM9 3h1v1h-1zM5 4h1v1h-1zM10 4h1v1h-1zM4 5h1v1h-1zM11 5h1v1h-1zM3 6h1v1h-1zM12 6h1v1h-1zM2 7h2v1h-2zM12 7h2v1h-2zM1 8h1v1h-1zM3 8h1v1h-1zM12 8h1v1h-1zM14 8h1v1h-1zM3 9h1v1h-1zM6 9h4v1h-4zM12 9h1v1h-1zM3 10h1v1h-1zM6 10h1v1h-1zM9 10h1v1h-1zM12 10h1v1h-1zM3 11h1v1h-1zM6 11h1v1h-1zM9 11h1v1h-1zM12 11h1v1h-1zM3 12h1v1h-1zM6 12h1v1h-1zM9 12h1v1h-1zM12 12h1v1h-1zM3 13h10v1h-10z"/></svg>',
    pxRealestate: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 1h10v1h-10zM3 2h1v1h-1zM12 2h1v1h-1zM3 3h1v1h-1zM12 3h1v1h-1zM3 4h1v1h-1zM5 4h2v1h-2zM9 4h2v1h-2zM12 4h1v1h-1zM3 5h1v1h-1zM12 5h1v1h-1zM3 6h1v1h-1zM12 6h1v1h-1zM3 7h1v1h-1zM5 7h2v1h-2zM9 7h2v1h-2zM12 7h1v1h-1zM3 8h1v1h-1zM12 8h1v1h-1zM3 9h1v1h-1zM12 9h1v1h-1zM3 10h1v1h-1zM5 10h2v1h-2zM9 10h2v1h-2zM12 10h1v1h-1zM3 11h1v1h-1zM12 11h1v1h-1zM3 12h1v1h-1zM7 12h2v1h-2zM12 12h1v1h-1zM3 13h1v1h-1zM12 13h1v1h-1zM3 14h10v1h-10z"/></svg>',
    pxJobs: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M6 2h4v1h-4zM5 3h1v1h-1zM10 3h1v1h-1zM5 4h1v1h-1zM10 4h1v1h-1zM2 5h12v1h-12zM1 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM7 7h2v1h-2zM14 7h1v1h-1zM1 8h14v1h-14zM1 9h1v1h-1zM7 9h2v1h-2zM14 9h1v1h-1zM1 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxStudio: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M6 1h2v1h-2zM4 2h2v1h-2zM8 2h2v1h-2zM2 3h2v1h-2zM10 3h2v1h-2zM1 4h2v1h-2zM12 4h2v1h-2zM3 5h2v1h-2zM11 5h2v1h-2zM5 6h2v1h-2zM9 6h2v1h-2zM1 7h1v1h-1zM7 7h2v1h-2zM12 7h2v1h-2zM2 8h2v1h-2zM10 8h2v1h-2zM4 9h2v1h-2zM8 9h2v1h-2zM1 10h1v1h-1zM6 10h2v1h-2zM12 10h2v1h-2zM2 11h2v1h-2zM10 11h2v1h-2zM4 12h2v1h-2zM8 12h2v1h-2zM6 13h2v1h-2z"/></svg>',
    pxInfra: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM3 4h2v1h-2zM7 4h5v1h-5zM14 4h1v1h-1zM1 5h1v1h-1zM14 5h1v1h-1zM2 6h12v1h-12zM2 9h12v1h-12zM1 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM3 11h2v1h-2zM7 11h5v1h-5zM14 11h1v1h-1zM1 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxTerminal: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM4 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM5 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM6 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM5 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM4 10h1v1h-1zM8 10h4v1h-4zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxTasks: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M5 2h6v1h-6zM4 3h1v1h-1zM11 3h1v1h-1zM3 4h1v1h-1zM12 4h1v1h-1zM2 5h1v1h-1zM11 5h1v1h-1zM13 5h1v1h-1zM2 6h1v1h-1zM10 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM9 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM4 8h1v1h-1zM8 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM5 9h1v1h-1zM7 9h1v1h-1zM13 9h1v1h-1zM2 10h1v1h-1zM6 10h1v1h-1zM13 10h1v1h-1zM3 11h1v1h-1zM12 11h1v1h-1zM4 12h1v1h-1zM11 12h1v1h-1zM5 13h6v1h-6z"/></svg>',
    pxNotes: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 1h7v1h-7zM3 2h1v1h-1zM9 2h2v1h-2zM3 3h1v1h-1zM9 3h1v1h-1zM11 3h1v1h-1zM3 4h1v1h-1zM9 4h4v1h-4zM3 5h1v1h-1zM12 5h1v1h-1zM3 6h1v1h-1zM12 6h1v1h-1zM3 7h1v1h-1zM5 7h6v1h-6zM12 7h1v1h-1zM3 8h1v1h-1zM12 8h1v1h-1zM3 9h1v1h-1zM5 9h6v1h-6zM12 9h1v1h-1zM3 10h1v1h-1zM12 10h1v1h-1zM3 11h1v1h-1zM5 11h4v1h-4zM12 11h1v1h-1zM3 12h1v1h-1zM12 12h1v1h-1zM3 13h1v1h-1zM12 13h1v1h-1zM3 14h10v1h-10z"/></svg>',
    pxFiles: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M1 2h5v1h-5zM1 3h1v1h-1zM6 3h1v1h-1zM1 4h1v1h-1zM7 4h8v1h-8zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h14v1h-14zM1 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM14 12h1v1h-1zM1 13h14v1h-14z"/></svg>',
    pxChat: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM4 6h2v1h-2zM7 6h2v1h-2zM10 6h2v1h-2zM14 6h1v1h-1zM1 7h1v1h-1zM4 7h2v1h-2zM7 7h2v1h-2zM10 7h2v1h-2zM14 7h1v1h-1zM1 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM14 10h1v1h-1zM2 11h12v1h-12zM4 12h1v1h-1zM6 12h1v1h-1zM4 13h2v1h-2zM4 14h1v1h-1z"/></svg>',
    pxMail: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M1 3h14v1h-14zM1 4h2v1h-2zM13 4h2v1h-2zM1 5h1v1h-1zM3 5h1v1h-1zM12 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM4 6h2v1h-2zM10 6h2v1h-2zM14 6h1v1h-1zM1 7h1v1h-1zM6 7h1v1h-1zM9 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM7 8h2v1h-2zM14 8h1v1h-1zM1 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM1 12h14v1h-14z"/></svg>',
    pxCalendar: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M4 1h1v1h-1zM11 1h1v1h-1zM4 2h1v1h-1zM11 2h1v1h-1zM2 3h12v1h-12zM1 4h1v1h-1zM4 4h1v1h-1zM11 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h14v1h-14zM1 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM4 9h1v1h-1zM6 9h1v1h-1zM9 9h1v1h-1zM11 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM4 11h1v1h-1zM6 11h1v1h-1zM9 11h2v1h-2zM14 11h1v1h-1zM1 12h1v1h-1zM9 12h2v1h-2zM14 12h1v1h-1zM1 13h1v1h-1zM14 13h1v1h-1zM2 14h12v1h-12z"/></svg>',
    pxMeet: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 4h8v1h-8zM1 5h1v1h-1zM10 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM10 6h1v1h-1zM12 6h3v1h-3zM1 7h1v1h-1zM10 7h2v1h-2zM14 7h1v1h-1zM1 8h1v1h-1zM10 8h2v1h-2zM14 8h1v1h-1zM1 9h1v1h-1zM10 9h2v1h-2zM14 9h1v1h-1zM1 10h1v1h-1zM10 10h1v1h-1zM12 10h3v1h-3zM1 11h1v1h-1zM10 11h1v1h-1zM14 11h1v1h-1zM2 12h8v1h-8z"/></svg>',
    pxReminders: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 1h3v1h-3zM10 1h3v1h-3zM5 2h5v1h-5zM3 3h2v1h-2zM10 3h2v1h-2zM2 4h2v1h-2zM7 4h1v1h-1zM11 4h2v1h-2zM2 5h1v1h-1zM7 5h1v1h-1zM12 5h1v1h-1zM1 6h1v1h-1zM7 6h1v1h-1zM13 6h1v1h-1zM1 7h1v1h-1zM7 7h1v1h-1zM13 7h1v1h-1zM1 8h1v1h-1zM7 8h4v1h-4zM13 8h1v1h-1zM1 9h1v1h-1zM13 9h1v1h-1zM1 10h1v1h-1zM13 10h1v1h-1zM2 11h1v1h-1zM12 11h1v1h-1zM2 12h2v1h-2zM11 12h2v1h-2zM3 13h2v1h-2zM10 13h2v1h-2zM5 14h5v1h-5z"/></svg>',
    pxBookmarks: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 1h10v1h-10zM3 2h1v1h-1zM12 2h1v1h-1zM3 3h1v1h-1zM12 3h1v1h-1zM3 4h1v1h-1zM12 4h1v1h-1zM3 5h1v1h-1zM12 5h1v1h-1zM3 6h1v1h-1zM12 6h1v1h-1zM3 7h1v1h-1zM12 7h1v1h-1zM3 8h1v1h-1zM12 8h1v1h-1zM3 9h1v1h-1zM12 9h1v1h-1zM3 10h1v1h-1zM7 10h2v1h-2zM12 10h1v1h-1zM3 11h1v1h-1zM6 11h1v1h-1zM9 11h1v1h-1zM12 11h1v1h-1zM3 12h1v1h-1zM5 12h1v1h-1zM10 12h1v1h-1zM12 12h1v1h-1zM3 13h2v1h-2zM11 13h2v1h-2zM3 14h1v1h-1zM12 14h1v1h-1z"/></svg>',
    pxHistory: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M9 2h2v1h-2zM1 3h1v1h-1zM11 3h1v1h-1zM1 4h1v1h-1zM7 4h1v1h-1zM12 4h1v1h-1zM2 5h1v1h-1zM4 5h2v1h-2zM7 5h1v1h-1zM13 5h1v1h-1zM2 6h2v1h-2zM7 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM7 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM7 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM8 9h2v1h-2zM13 9h1v1h-1zM2 10h1v1h-1zM10 10h1v1h-1zM13 10h1v1h-1zM3 11h1v1h-1zM12 11h1v1h-1zM4 12h1v1h-1zM11 12h1v1h-1zM5 13h6v1h-6z"/></svg>',
    pxBroadcast: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 4h1v1h-1zM13 4h1v1h-1zM1 5h2v1h-2zM5 5h1v1h-1zM10 5h1v1h-1zM13 5h2v1h-2zM1 6h1v1h-1zM4 6h1v1h-1zM11 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM4 7h1v1h-1zM7 7h2v1h-2zM11 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM4 8h1v1h-1zM7 8h2v1h-2zM11 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM4 9h1v1h-1zM11 9h1v1h-1zM14 9h1v1h-1zM1 10h2v1h-2zM5 10h1v1h-1zM10 10h1v1h-1zM13 10h2v1h-2zM2 11h1v1h-1zM13 11h1v1h-1z"/></svg>',
    pxTeamAndAgents: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M10 2h3v1h-3zM4 3h3v1h-3zM9 3h1v1h-1zM13 3h1v1h-1zM3 4h1v1h-1zM7 4h1v1h-1zM9 4h1v1h-1zM13 4h1v1h-1zM3 5h1v1h-1zM7 5h1v1h-1zM9 5h1v1h-1zM13 5h1v1h-1zM3 6h1v1h-1zM7 6h1v1h-1zM10 6h3v1h-3zM4 7h3v1h-3zM10 8h3v1h-3zM3 9h5v1h-5zM9 9h1v1h-1zM13 9h1v1h-1zM2 10h1v1h-1zM8 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM9 11h1v1h-1zM15 11h1v1h-1zM0 12h1v1h-1zM10 12h1v1h-1z"/></svg>',
    pxAgents: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 1h2v1h-2zM7 2h2v1h-2zM7 3h2v1h-2zM2 4h12v1h-12zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM4 7h2v1h-2zM10 7h2v1h-2zM14 7h1v1h-1zM1 8h1v1h-1zM4 8h2v1h-2zM10 8h2v1h-2zM14 8h1v1h-1zM1 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM6 11h4v1h-4zM14 11h1v1h-1zM1 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxTeamMembers: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M6 2h4v1h-4zM5 3h2v1h-2zM9 3h2v1h-2zM5 4h1v1h-1zM10 4h1v1h-1zM5 5h1v1h-1zM10 5h1v1h-1zM5 6h2v1h-2zM9 6h2v1h-2zM6 7h4v1h-4zM5 9h6v1h-6zM4 10h2v1h-2zM10 10h2v1h-2zM3 11h1v1h-1zM12 11h1v1h-1zM2 12h1v1h-1zM13 12h1v1h-1zM1 13h1v1h-1zM14 13h1v1h-1z"/></svg>',
    pxUsers: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 1h2v1h-2zM5 2h6v1h-6zM4 3h1v1h-1zM6 3h1v1h-1zM9 3h1v1h-1zM11 3h1v1h-1zM3 4h1v1h-1zM5 4h1v1h-1zM10 4h1v1h-1zM12 4h1v1h-1zM2 5h12v1h-12zM2 6h1v1h-1zM5 6h1v1h-1zM10 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM5 7h1v1h-1zM10 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM5 8h1v1h-1zM10 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM5 9h1v1h-1zM10 9h1v1h-1zM13 9h1v1h-1zM2 10h12v1h-12zM3 11h1v1h-1zM5 11h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM4 12h1v1h-1zM6 12h1v1h-1zM9 12h1v1h-1zM11 12h1v1h-1zM5 13h6v1h-6zM7 14h2v1h-2z"/></svg>',
    pxAnalytics: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M11 1h4v1h-4zM11 2h1v1h-1zM14 2h1v1h-1zM11 3h1v1h-1zM14 3h1v1h-1zM11 4h1v1h-1zM14 4h1v1h-1zM6 5h4v1h-4zM11 5h1v1h-1zM14 5h1v1h-1zM6 6h1v1h-1zM9 6h1v1h-1zM11 6h1v1h-1zM14 6h1v1h-1zM6 7h1v1h-1zM9 7h1v1h-1zM11 7h1v1h-1zM14 7h1v1h-1zM6 8h1v1h-1zM9 8h1v1h-1zM11 8h1v1h-1zM14 8h1v1h-1zM1 9h4v1h-4zM6 9h1v1h-1zM9 9h1v1h-1zM11 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM4 10h1v1h-1zM6 10h1v1h-1zM9 10h1v1h-1zM11 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM4 11h1v1h-1zM6 11h1v1h-1zM9 11h1v1h-1zM11 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM4 12h1v1h-1zM6 12h1v1h-1zM9 12h1v1h-1zM11 12h1v1h-1zM14 12h1v1h-1zM1 13h4v1h-4zM6 13h4v1h-4zM11 13h4v1h-4z"/></svg>',
    pxUsage: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M5 4h5v1h-5zM3 5h2v1h-2zM10 5h2v1h-2zM2 6h2v1h-2zM10 6h3v1h-3zM2 7h1v1h-1zM9 7h1v1h-1zM12 7h1v1h-1zM1 8h1v1h-1zM9 8h1v1h-1zM13 8h1v1h-1zM1 9h1v1h-1zM7 9h2v1h-2zM13 9h1v1h-1zM1 10h1v1h-1zM6 10h3v1h-3zM13 10h1v1h-1zM7 11h1v1h-1zM1 13h13v1h-13z"/></svg>',
    pxHealth: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M6 3h1v1h-1zM6 4h1v1h-1zM5 5h1v1h-1zM7 5h1v1h-1zM5 6h1v1h-1zM7 6h1v1h-1zM4 7h1v1h-1zM7 7h1v1h-1zM1 8h4v1h-4zM8 8h1v1h-1zM11 8h4v1h-4zM8 9h1v1h-1zM11 9h1v1h-1zM8 10h1v1h-1zM10 10h1v1h-1zM8 11h1v1h-1zM10 11h1v1h-1zM9 12h1v1h-1zM9 13h1v1h-1z"/></svg>',
    pxLock: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M6 3h4v1h-4zM5 4h1v1h-1zM10 4h1v1h-1zM4 5h1v1h-1zM11 5h1v1h-1zM4 6h1v1h-1zM11 6h1v1h-1zM3 7h10v1h-10zM2 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM13 9h1v1h-1zM2 10h1v1h-1zM7 10h1v1h-1zM13 10h1v1h-1zM2 11h1v1h-1zM7 11h1v1h-1zM13 11h1v1h-1zM2 12h1v1h-1zM13 12h1v1h-1zM2 13h1v1h-1zM13 13h1v1h-1zM3 14h10v1h-10z"/></svg>',
    pxFlag: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 1h1v1h-1zM3 2h11v1h-11zM3 3h1v1h-1zM12 3h1v1h-1zM3 4h1v1h-1zM11 4h1v1h-1zM3 5h1v1h-1zM10 5h1v1h-1zM3 6h1v1h-1zM11 6h1v1h-1zM3 7h1v1h-1zM12 7h1v1h-1zM3 8h11v1h-11zM3 9h1v1h-1zM3 10h1v1h-1zM3 11h1v1h-1zM3 12h1v1h-1zM3 13h1v1h-1zM3 14h1v1h-1z"/></svg>',
    pxDatabase: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M4 1h8v1h-8zM2 2h3v1h-3zM11 2h3v1h-3zM1 3h3v1h-3zM12 3h3v1h-3zM2 4h3v1h-3zM11 4h3v1h-3zM2 5h1v1h-1zM4 5h8v1h-8zM13 5h1v1h-1zM2 6h1v1h-1zM4 6h8v1h-8zM13 6h1v1h-1zM2 7h3v1h-3zM11 7h3v1h-3zM1 8h3v1h-3zM12 8h3v1h-3zM2 9h3v1h-3zM11 9h3v1h-3zM2 10h1v1h-1zM4 10h8v1h-8zM13 10h1v1h-1zM2 11h1v1h-1zM4 11h8v1h-8zM13 11h1v1h-1zM2 12h3v1h-3zM11 12h3v1h-3zM1 13h3v1h-3zM12 13h3v1h-3zM2 14h3v1h-3zM11 14h3v1h-3zM4 15h8v1h-8z"/></svg>',
    pxAppStore: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 1h4v1h-4zM10 1h4v1h-4zM1 2h1v1h-1zM6 2h1v1h-1zM9 2h1v1h-1zM14 2h1v1h-1zM1 3h1v1h-1zM6 3h1v1h-1zM9 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM6 4h1v1h-1zM9 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM6 5h1v1h-1zM9 5h1v1h-1zM14 5h1v1h-1zM2 6h4v1h-4zM10 6h4v1h-4zM2 9h4v1h-4zM9 9h6v1h-6zM1 10h1v1h-1zM6 10h1v1h-1zM9 10h6v1h-6zM1 11h1v1h-1zM6 11h1v1h-1zM9 11h6v1h-6zM1 12h1v1h-1zM6 12h1v1h-1zM9 12h6v1h-6zM1 13h1v1h-1zM6 13h1v1h-1zM9 13h6v1h-6zM2 14h4v1h-4zM9 14h6v1h-6z"/></svg>',
    pxFollowing: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 3h4v1h-4zM9 3h4v1h-4zM2 4h1v1h-1zM7 4h2v1h-2zM13 4h1v1h-1zM2 5h1v1h-1zM7 5h2v1h-2zM13 5h1v1h-1zM2 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM13 7h1v1h-1zM3 8h1v1h-1zM12 8h1v1h-1zM4 9h1v1h-1zM11 9h1v1h-1zM5 10h1v1h-1zM10 10h1v1h-1zM6 11h1v1h-1zM9 11h1v1h-1zM7 12h2v1h-2z"/></svg>',
    pxPlus: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 2h1v1h-1zM7 3h1v1h-1zM7 4h1v1h-1zM7 5h1v1h-1zM7 6h1v1h-1zM2 7h11v1h-11zM7 8h1v1h-1zM7 9h1v1h-1zM7 10h1v1h-1zM7 11h1v1h-1zM7 12h1v1h-1z"/></svg>',
    pxSearch: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M6 1h1v1h-1zM3 2h7v1h-7zM2 3h2v1h-2zM9 3h2v1h-2zM2 4h1v1h-1zM10 4h1v1h-1zM2 5h1v1h-1zM10 5h1v1h-1zM1 6h2v1h-2zM10 6h2v1h-2zM2 7h1v1h-1zM10 7h1v1h-1zM2 8h1v1h-1zM10 8h1v1h-1zM2 9h2v1h-2zM9 9h2v1h-2zM3 10h8v1h-8zM6 11h1v1h-1zM11 11h1v1h-1zM12 12h1v1h-1zM13 13h1v1h-1z"/></svg>',
    pxAssistant: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 1h1v1h-1zM12 1h1v1h-1zM7 2h1v1h-1zM11 2h3v1h-3zM7 3h2v1h-2zM12 3h1v1h-1zM6 4h1v1h-1zM8 4h1v1h-1zM5 5h2v1h-2zM8 5h1v1h-1zM3 6h2v1h-2zM9 6h2v1h-2zM2 7h2v1h-2zM11 7h2v1h-2zM4 8h2v1h-2zM10 8h2v1h-2zM6 9h1v1h-1zM8 9h2v1h-2zM6 10h1v1h-1zM8 10h1v1h-1zM6 11h2v1h-2zM7 12h1v1h-1zM7 13h1v1h-1z"/></svg>',
    pxDashboard: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h14v1h-14zM1 7h1v1h-1zM6 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM6 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM6 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM6 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM6 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM6 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxTools: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M9 2h3v1h-3zM1 3h14v1h-14zM9 4h3v1h-3zM3 6h3v1h-3zM1 7h14v1h-14zM3 8h3v1h-3zM7 11h3v1h-3zM1 12h14v1h-14zM7 13h3v1h-3z"/></svg>',
    pxApps: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM3 3h1v1h-1zM5 3h1v1h-1zM7 3h1v1h-1zM14 3h1v1h-1zM1 4h14v1h-14zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM6 7h4v1h-4zM14 7h1v1h-1zM1 8h1v1h-1zM6 8h4v1h-4zM14 8h1v1h-1zM1 9h1v1h-1zM6 9h4v1h-4zM14 9h1v1h-1zM1 10h1v1h-1zM6 10h4v1h-4zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxPresentation: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M1 1h14v1h-14zM1 2h1v1h-1zM14 2h1v1h-1zM1 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM7 4h2v1h-2zM14 4h1v1h-1zM1 5h1v1h-1zM7 5h2v1h-2zM10 5h2v1h-2zM14 5h1v1h-1zM1 6h1v1h-1zM4 6h2v1h-2zM7 6h2v1h-2zM10 6h2v1h-2zM14 6h1v1h-1zM1 7h1v1h-1zM4 7h2v1h-2zM7 7h2v1h-2zM10 7h2v1h-2zM14 7h1v1h-1zM1 8h1v1h-1zM4 8h2v1h-2zM7 8h2v1h-2zM10 8h2v1h-2zM14 8h1v1h-1zM1 9h1v1h-1zM14 9h1v1h-1zM1 10h14v1h-14zM7 11h2v1h-2zM6 12h1v1h-1zM9 12h1v1h-1zM5 13h1v1h-1zM10 13h1v1h-1zM4 14h1v1h-1zM11 14h1v1h-1z"/></svg>',
    pxFly: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M12 2h2v1h-2zM10 3h2v1h-2zM8 4h2v1h-2zM7 5h1v1h-1zM6 6h1v1h-1zM5 7h1v1h-1zM10 7h4v1h-4zM4 8h1v1h-1zM7 8h3v1h-3zM3 9h1v1h-1zM5 9h2v1h-2zM2 10h4v1h-4zM2 11h3v1h-3zM6 11h7v1h-7zM2 12h4v1h-4zM1 13h3v1h-3zM1 14h1v1h-1z"/></svg>',
    pxGrid: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h2v1h-2zM7 2h2v1h-2zM12 2h2v1h-2zM2 3h2v1h-2zM7 3h2v1h-2zM12 3h2v1h-2zM2 7h2v1h-2zM7 7h2v1h-2zM12 7h2v1h-2zM2 8h2v1h-2zM7 8h2v1h-2zM12 8h2v1h-2zM2 12h2v1h-2zM7 12h2v1h-2zM12 12h2v1h-2zM2 13h2v1h-2zM7 13h2v1h-2zM12 13h2v1h-2z"/></svg>',
    pxCheck: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M13 4h1v1h-1zM12 5h1v1h-1zM11 6h1v1h-1zM10 7h1v1h-1zM2 8h1v1h-1zM10 8h1v1h-1zM3 9h1v1h-1zM9 9h1v1h-1zM4 10h1v1h-1zM8 10h1v1h-1zM5 11h1v1h-1zM7 11h1v1h-1zM6 12h1v1h-1z"/></svg>',
    pxCaret: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 5h1v1h-1zM11 5h1v1h-1zM4 6h1v1h-1zM10 6h1v1h-1zM5 7h1v1h-1zM9 7h1v1h-1zM6 8h1v1h-1zM8 8h1v1h-1zM7 9h1v1h-1z"/></svg>',
    pxClose: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 3h1v1h-1zM12 3h1v1h-1zM4 4h1v1h-1zM11 4h1v1h-1zM5 5h1v1h-1zM10 5h1v1h-1zM6 6h1v1h-1zM9 6h1v1h-1zM7 7h2v1h-2zM7 8h2v1h-2zM6 9h1v1h-1zM9 9h1v1h-1zM5 10h1v1h-1zM10 10h1v1h-1zM4 11h1v1h-1zM11 11h1v1h-1zM3 12h1v1h-1zM12 12h1v1h-1z"/></svg>',
    pxSummarize: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 3h12v1h-12zM2 7h12v1h-12zM2 11h8v1h-8z"/></svg>',
    pxBlocked: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M5 2h6v1h-6zM4 3h1v1h-1zM11 3h1v1h-1zM3 4h1v1h-1zM11 4h2v1h-2zM2 5h1v1h-1zM10 5h1v1h-1zM13 5h1v1h-1zM2 6h1v1h-1zM9 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM8 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM7 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM6 9h1v1h-1zM13 9h1v1h-1zM2 10h1v1h-1zM5 10h1v1h-1zM13 10h1v1h-1zM3 11h2v1h-2zM12 11h1v1h-1zM4 12h1v1h-1zM11 12h1v1h-1zM5 13h6v1h-6z"/></svg>',
    pxArrowUp: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 2h1v1h-1zM6 3h3v1h-3zM5 4h1v1h-1zM7 4h1v1h-1zM9 4h1v1h-1zM4 5h1v1h-1zM7 5h1v1h-1zM10 5h1v1h-1zM3 6h1v1h-1zM7 6h1v1h-1zM11 6h1v1h-1zM7 7h1v1h-1zM7 8h1v1h-1zM7 9h1v1h-1zM7 10h1v1h-1zM7 11h1v1h-1zM7 12h1v1h-1zM7 13h1v1h-1z"/></svg>',
    pxArrowUpRight: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M5 3h8v1h-8zM11 4h2v1h-2zM10 5h1v1h-1zM12 5h1v1h-1zM9 6h1v1h-1zM12 6h1v1h-1zM8 7h1v1h-1zM12 7h1v1h-1zM7 8h1v1h-1zM12 8h1v1h-1zM6 9h1v1h-1zM12 9h1v1h-1zM5 10h1v1h-1zM12 10h1v1h-1zM4 11h1v1h-1zM3 12h1v1h-1z"/></svg>',
    pxSidebarLeft: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM5 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM5 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM5 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM5 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM5 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM5 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM5 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM5 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM5 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM5 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxSidebarRight: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM10 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM10 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM10 5h1v1h-1zM14 5h1v1h-1zM1 6h1v1h-1zM10 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM10 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM10 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM10 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM10 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM10 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM10 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxInspect: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M8 1h1v1h-1zM8 2h1v1h-1zM8 3h1v1h-1zM5 4h6v1h-6zM4 5h2v1h-2zM10 5h2v1h-2zM4 6h1v1h-1zM11 6h1v1h-1zM4 7h1v1h-1zM11 7h1v1h-1zM1 8h4v1h-4zM11 8h4v1h-4zM4 9h1v1h-1zM11 9h1v1h-1zM4 10h2v1h-2zM10 10h2v1h-2zM5 11h6v1h-6zM8 12h1v1h-1zM8 13h1v1h-1zM8 14h1v1h-1z"/></svg>',
    pxAttention: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M8 1h1v1h-1zM7 2h1v1h-1zM9 2h1v1h-1zM7 3h1v1h-1zM9 3h1v1h-1zM6 4h1v1h-1zM10 4h1v1h-1zM6 5h1v1h-1zM10 5h1v1h-1zM5 6h1v1h-1zM8 6h1v1h-1zM11 6h1v1h-1zM5 7h1v1h-1zM8 7h1v1h-1zM11 7h1v1h-1zM4 8h1v1h-1zM8 8h1v1h-1zM12 8h1v1h-1zM3 9h1v1h-1zM8 9h1v1h-1zM12 9h1v1h-1zM3 10h1v1h-1zM13 10h1v1h-1zM2 11h1v1h-1zM13 11h1v1h-1zM2 12h1v1h-1zM14 12h1v1h-1zM1 13h14v1h-14z"/></svg>',
    pxPage: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 2h12v1h-12zM1 3h1v1h-1zM14 3h1v1h-1zM1 4h1v1h-1zM14 4h1v1h-1zM1 5h14v1h-14zM1 6h1v1h-1zM14 6h1v1h-1zM1 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM4 8h8v1h-8zM14 8h1v1h-1zM1 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM4 10h6v1h-6zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM1 12h1v1h-1zM14 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxHelp: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M5 2h6v1h-6zM4 3h1v1h-1zM7 3h2v1h-2zM11 3h1v1h-1zM3 4h1v1h-1zM6 4h1v1h-1zM9 4h1v1h-1zM12 4h1v1h-1zM2 5h1v1h-1zM5 5h1v1h-1zM10 5h1v1h-1zM13 5h1v1h-1zM2 6h1v1h-1zM10 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM9 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM8 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM8 9h1v1h-1zM13 9h1v1h-1zM2 10h1v1h-1zM13 10h1v1h-1zM3 11h1v1h-1zM12 11h1v1h-1zM4 12h1v1h-1zM11 12h1v1h-1zM5 13h6v1h-6z"/></svg>',
    pxPayments: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M2 3h12v1h-12zM1 4h1v1h-1zM14 4h1v1h-1zM1 5h1v1h-1zM14 5h1v1h-1zM1 6h14v1h-14zM1 7h1v1h-1zM14 7h1v1h-1zM1 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM3 9h4v1h-4zM14 9h1v1h-1zM1 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM14 11h1v1h-1zM2 12h12v1h-12z"/></svg>',
    pxRisk: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 1h3v1h-3zM4 2h3v1h-3zM10 2h2v1h-2zM2 3h2v1h-2zM12 3h2v1h-2zM2 4h1v1h-1zM13 4h1v1h-1zM2 5h1v1h-1zM8 5h1v1h-1zM13 5h1v1h-1zM2 6h1v1h-1zM8 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM8 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM8 8h1v1h-1zM13 8h1v1h-1zM3 9h1v1h-1zM12 9h1v1h-1zM4 10h1v1h-1zM11 10h1v1h-1zM5 11h1v1h-1zM10 11h1v1h-1zM6 12h1v1h-1zM10 12h1v1h-1zM7 13h1v1h-1zM9 13h1v1h-1zM8 14h1v1h-1z"/></svg>',
    pxOrders: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M6 2h4v1h-4zM5 3h2v1h-2zM9 3h2v1h-2zM5 4h1v1h-1zM10 4h1v1h-1zM3 5h10v1h-10zM2 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM13 9h1v1h-1zM2 10h1v1h-1zM13 10h1v1h-1zM2 11h1v1h-1zM13 11h1v1h-1zM2 12h1v1h-1zM13 12h1v1h-1zM2 13h1v1h-1zM13 13h1v1h-1zM3 14h10v1h-10z"/></svg>',
    pxInventory: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M7 1h2v1h-2zM5 2h2v1h-2zM9 2h2v1h-2zM3 3h2v1h-2zM11 3h2v1h-2zM1 4h2v1h-2zM13 4h2v1h-2zM1 5h1v1h-1zM3 5h2v1h-2zM11 5h2v1h-2zM14 5h1v1h-1zM1 6h1v1h-1zM5 6h2v1h-2zM9 6h2v1h-2zM14 6h1v1h-1zM1 7h1v1h-1zM7 7h2v1h-2zM14 7h1v1h-1zM1 8h1v1h-1zM8 8h1v1h-1zM14 8h1v1h-1zM1 9h1v1h-1zM8 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM8 10h1v1h-1zM14 10h1v1h-1zM1 11h2v1h-2zM8 11h1v1h-1zM14 11h1v1h-1zM3 12h2v1h-2zM8 12h1v1h-1zM12 12h2v1h-2zM5 13h2v1h-2zM8 13h1v1h-1zM10 13h2v1h-2zM7 14h3v1h-3z"/></svg>',
    pxInvoices: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 1h10v1h-10zM3 2h1v1h-1zM12 2h1v1h-1zM3 3h1v1h-1zM12 3h1v1h-1zM3 4h1v1h-1zM5 4h6v1h-6zM12 4h1v1h-1zM3 5h1v1h-1zM12 5h1v1h-1zM3 6h1v1h-1zM12 6h1v1h-1zM3 7h1v1h-1zM5 7h6v1h-6zM12 7h1v1h-1zM3 8h1v1h-1zM12 8h1v1h-1zM3 9h1v1h-1zM12 9h1v1h-1zM3 10h1v1h-1zM5 10h4v1h-4zM12 10h1v1h-1zM3 11h1v1h-1zM12 11h1v1h-1zM3 12h1v1h-1zM12 12h1v1h-1zM3 13h1v1h-1zM5 13h1v1h-1zM8 13h1v1h-1zM11 13h2v1h-2zM3 14h2v1h-2zM6 14h2v1h-2zM9 14h2v1h-2zM12 14h1v1h-1z"/></svg>',
    pxStore: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M3 2h10v1h-10zM3 3h1v1h-1zM13 3h1v1h-1zM2 4h1v1h-1zM13 4h1v1h-1zM2 5h1v1h-1zM14 5h1v1h-1zM1 6h14v1h-14zM2 7h1v1h-1zM13 7h1v1h-1zM2 8h1v1h-1zM13 8h1v1h-1zM2 9h1v1h-1zM6 9h4v1h-4zM13 9h1v1h-1zM2 10h1v1h-1zM6 10h1v1h-1zM9 10h1v1h-1zM13 10h1v1h-1zM2 11h1v1h-1zM6 11h1v1h-1zM9 11h1v1h-1zM13 11h1v1h-1zM2 12h1v1h-1zM6 12h1v1h-1zM9 12h1v1h-1zM13 12h1v1h-1zM2 13h12v1h-12z"/></svg>',
    pxSupport: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path shape-rendering="crispEdges" d="M5 2h6v1h-6zM4 3h2v1h-2zM10 3h2v1h-2zM3 4h1v1h-1zM12 4h1v1h-1zM2 5h1v1h-1zM13 5h1v1h-1zM2 6h1v1h-1zM13 6h1v1h-1zM2 7h1v1h-1zM13 7h1v1h-1zM1 8h3v1h-3zM12 8h3v1h-3zM1 9h1v1h-1zM3 9h1v1h-1zM12 9h1v1h-1zM14 9h1v1h-1zM1 10h1v1h-1zM3 10h1v1h-1zM12 10h1v1h-1zM14 10h1v1h-1zM1 11h1v1h-1zM3 11h1v1h-1zM12 11h1v1h-1zM14 11h1v1h-1zM1 12h3v1h-3zM12 12h3v1h-3zM12 13h2v1h-2zM9 14h3v1h-3z"/></svg>',
    lnCrm: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 3.5h10.2a1.4 1.4 0 0 1 1.4 1.4v6.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-6.2a1.4 1.4 0 0 1 1.4 -1.4z"/><circle fill="currentColor" stroke="none" cx="5" cy="6" r="1.05"/><path vector-effect="non-scaling-stroke" d="M2.8 11.3A2.2 2.2 0 0 1 7.2 11.3"/><path vector-effect="non-scaling-stroke" d="M9.5 6.5L12.5 6.5"/><path vector-effect="non-scaling-stroke" d="M9.5 9.5L12.5 9.5"/></svg>',
    lnHome: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 8.5L7.5 2.5"/><path vector-effect="non-scaling-stroke" d="M8.5 2.5L14.5 8.5"/><path vector-effect="non-scaling-stroke" d="M3.5 7.5L3.5 13.5L12.5 13.5L12.5 7.5"/><path vector-effect="non-scaling-stroke" d="M6.5 13.5L6.5 9.5L9.5 9.5L9.5 13.5"/></svg>',
    lnRealestate: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 1.5h9v13h-9z"/><circle fill="currentColor" stroke="none" cx="6" cy="4.5" r="1.1"/><circle fill="currentColor" stroke="none" cx="10" cy="4.5" r="1.1"/><circle fill="currentColor" stroke="none" cx="6" cy="7.5" r="1.1"/><circle fill="currentColor" stroke="none" cx="10" cy="7.5" r="1.1"/><circle fill="currentColor" stroke="none" cx="6" cy="10.5" r="1.1"/><circle fill="currentColor" stroke="none" cx="10" cy="10.5" r="1.1"/><path vector-effect="non-scaling-stroke" d="M7.5 12.5L8.5 12.5"/></svg>',
    lnJobs: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 5.5h10.2a1.4 1.4 0 0 1 1.4 1.4v5.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-5.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M5.5 4.5L5.5 3.5"/><path vector-effect="non-scaling-stroke" d="M6.5 2.5L9.5 2.5"/><path vector-effect="non-scaling-stroke" d="M10.5 3.5L10.5 4.5"/><path vector-effect="non-scaling-stroke" d="M1.5 8.5L14.5 8.5"/><path fill="currentColor" stroke="none" d="M7.15 7.15h1.7v2.7h-1.7z"/></svg>',
    lnStudio: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 4.5L7.5 1.5L13.5 4.5L7.5 7.5L1.5 4.5"/><path vector-effect="non-scaling-stroke" d="M1.5 7.5L7.5 10.5L13.5 7.5"/><path vector-effect="non-scaling-stroke" d="M1.5 10.5L7.5 13.5L13.5 10.5"/></svg>',
    lnInfra: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v1.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-1.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M2.9 9.5h10.2a1.4 1.4 0 0 1 1.4 1.4v1.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-1.2a1.4 1.4 0 0 1 1.4 -1.4z"/><circle fill="currentColor" stroke="none" cx="4" cy="4.5" r="1.1"/><path vector-effect="non-scaling-stroke" d="M7.5 4.5L11.5 4.5"/><circle fill="currentColor" stroke="none" cx="4" cy="11.5" r="1.1"/><path vector-effect="non-scaling-stroke" d="M7.5 11.5L11.5 11.5"/></svg>',
    lnTerminal: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v8.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-8.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M4.5 6.5L6.5 8.5L4.5 10.5"/><path vector-effect="non-scaling-stroke" d="M8.5 10.5L11.5 10.5"/></svg>',
    lnTasks: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="8" cy="8" r="6"/><path vector-effect="non-scaling-stroke" d="M4.5 8.5L6.5 10.5L11.5 5.5"/></svg>',
    lnNotes: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 1.5L9.5 1.5L12.5 4.5L12.5 14.5L3.5 14.5L3.5 1.5"/><path vector-effect="non-scaling-stroke" d="M9.5 1.5L9.5 4.5L12.5 4.5"/><path vector-effect="non-scaling-stroke" d="M5.5 7.5L10.5 7.5"/><path vector-effect="non-scaling-stroke" d="M5.5 9.5L10.5 9.5"/><path vector-effect="non-scaling-stroke" d="M5.5 11.5L8.5 11.5"/></svg>',
    lnFiles: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 2.5L5.5 2.5L7.5 4.5L14.5 4.5L14.5 13.5L1.5 13.5L1.5 2.5"/><path vector-effect="non-scaling-stroke" d="M1.5 6.5L14.5 6.5"/></svg>',
    lnChat: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v6.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-6.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M4.5 11.5L4.5 14.5L7.5 11.5"/><circle fill="currentColor" stroke="none" cx="5" cy="7" r="1.05"/><circle fill="currentColor" stroke="none" cx="8" cy="7" r="1.05"/><circle fill="currentColor" stroke="none" cx="11" cy="7" r="1.05"/></svg>',
    lnMail: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 3.5h13v9h-13z"/><path vector-effect="non-scaling-stroke" d="M2.5 4.5L7.5 8.5"/><path vector-effect="non-scaling-stroke" d="M8.5 8.5L13.5 4.5"/></svg>',
    lnCalendar: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 3.5h10.2a1.4 1.4 0 0 1 1.4 1.4v8.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-8.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M1.5 6.5L14.5 6.5"/><path vector-effect="non-scaling-stroke" d="M4.5 1.5L4.5 4.5"/><path vector-effect="non-scaling-stroke" d="M11.5 1.5L11.5 4.5"/><circle fill="currentColor" stroke="none" cx="4.5" cy="9.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="6.5" cy="9.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="9.5" cy="9.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="11.5" cy="9.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="4.5" cy="11.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="6.5" cy="11.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="10" cy="12" r="1.05"/></svg>',
    lnMeet: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 4.5h6.2a1.4 1.4 0 0 1 1.4 1.4v5.2a1.4 1.4 0 0 1 -1.4 1.4h-6.2a1.4 1.4 0 0 1 -1.4 -1.4v-5.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M11.5 7.5L14.5 5.5L14.5 11.5L11.5 9.5L11.5 7.5"/></svg>',
    lnReminders: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="7.5" cy="8.5" r="6"/><path vector-effect="non-scaling-stroke" d="M7.5 4.5L7.5 8.5"/><path vector-effect="non-scaling-stroke" d="M7.5 8.5L10.5 8.5"/><path vector-effect="non-scaling-stroke" d="M2.5 1.5L4.5 1.5"/><path vector-effect="non-scaling-stroke" d="M10.5 1.5L12.5 1.5"/></svg>',
    lnBookmarks: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 1.5L12.5 1.5L12.5 14.5L8.5 10.5"/><path vector-effect="non-scaling-stroke" d="M7.5 10.5L3.5 14.5L3.5 1.5"/></svg>',
    lnHistory: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M9.042 2.091A6 6 0 1 1 2.362 5.948"/><path vector-effect="non-scaling-stroke" d="M1.5 3.5L2.5 6.5L5.5 5.5"/><path vector-effect="non-scaling-stroke" d="M7.5 4.5L7.5 8.5"/><path vector-effect="non-scaling-stroke" d="M7.5 8.5L10.5 10.5"/></svg>',
    lnBroadcast: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle fill="currentColor" stroke="none" cx="8" cy="8" r="1.55"/><path vector-effect="non-scaling-stroke" d="M5.525 10.475A3.5 3.5 0 0 1 5.525 5.525"/><path vector-effect="non-scaling-stroke" d="M10.475 5.525A3.5 3.5 0 0 1 10.475 10.475"/><path vector-effect="non-scaling-stroke" d="M3.021 12.178A6.5 6.5 0 0 1 3.021 3.822"/><path vector-effect="non-scaling-stroke" d="M12.979 3.822A6.5 6.5 0 0 1 12.979 12.178"/></svg>',
    lnTeamAndAgents: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="5.5" cy="5.5" r="2.2"/><path vector-effect="non-scaling-stroke" d="M0.802 12.79A5 5 0 0 1 10.198 12.79"/><circle vector-effect="non-scaling-stroke" cx="11.5" cy="4.5" r="2"/><path vector-effect="non-scaling-stroke" d="M9.4 9.363A4.2 4.2 0 0 1 15.447 11.564"/></svg>',
    lnAgents: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 4.5h10.2a1.4 1.4 0 0 1 1.4 1.4v6.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-6.2a1.4 1.4 0 0 1 1.4 -1.4z"/><circle fill="currentColor" stroke="none" cx="5" cy="8" r="1.05"/><circle fill="currentColor" stroke="none" cx="11" cy="8" r="1.05"/><path vector-effect="non-scaling-stroke" d="M6.5 11.5L9.5 11.5"/><path vector-effect="non-scaling-stroke" d="M7.5 1.5L7.5 3.5"/><path vector-effect="non-scaling-stroke" d="M8.5 1.5L8.5 3.5"/></svg>',
    lnTeamMembers: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="8" cy="5" r="2.6"/><path vector-effect="non-scaling-stroke" d="M1.818 13.991A6.5 6.5 0 0 1 14.182 13.991"/></svg>',
    lnUsers: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="8" cy="8" r="6"/><ellipse vector-effect="non-scaling-stroke" cx="8" cy="8" rx="2.6" ry="6" transform="rotate(0 8 8)"/><path vector-effect="non-scaling-stroke" d="M3.5 5.5L12.5 5.5"/><path vector-effect="non-scaling-stroke" d="M3.5 10.5L12.5 10.5"/></svg>',
    lnAnalytics: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 9.5h3v4h-3z"/><path vector-effect="non-scaling-stroke" d="M6.5 5.5h3v8h-3z"/><path vector-effect="non-scaling-stroke" d="M11.5 1.5h3v12h-3z"/></svg>',
    lnUsage: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 10.5A6 6 0 0 1 13.5 10.5"/><path vector-effect="non-scaling-stroke" d="M7.5 10.5L10.5 6.5"/><circle fill="currentColor" stroke="none" cx="7.5" cy="10.5" r="1.35"/><path vector-effect="non-scaling-stroke" d="M1.5 13.5L13.5 13.5"/></svg>',
    lnHealth: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 8.5L4.5 8.5L6.5 3.5L9.5 13.5L11.5 8.5L14.5 8.5"/></svg>',
    lnLock: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M4 7.5A4 4 0 0 1 12 7.5"/><path vector-effect="non-scaling-stroke" d="M3.9 7.5h8.2a1.4 1.4 0 0 1 1.4 1.4v4.2a1.4 1.4 0 0 1 -1.4 1.4h-8.2a1.4 1.4 0 0 1 -1.4 -1.4v-4.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M7.5 10.5L7.5 11.5"/></svg>',
    lnFlag: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 1.5L3.5 14.5"/><path vector-effect="non-scaling-stroke" d="M3.5 2.5L13.5 2.5L10.5 5.5L13.5 8.5L3.5 8.5"/></svg>',
    lnDatabase: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><ellipse vector-effect="non-scaling-stroke" cx="8" cy="3.5" rx="5.5" ry="2" transform="rotate(0 8 3.5)"/><ellipse vector-effect="non-scaling-stroke" cx="8" cy="8.5" rx="5.5" ry="2" transform="rotate(0 8 8.5)"/><ellipse vector-effect="non-scaling-stroke" cx="8" cy="13.5" rx="5.5" ry="2" transform="rotate(0 8 13.5)"/><path vector-effect="non-scaling-stroke" d="M2.5 3.5L2.5 13.5"/><path vector-effect="non-scaling-stroke" d="M13.5 3.5L13.5 13.5"/></svg>',
    lnAppStore: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 1.5h2.2a1.4 1.4 0 0 1 1.4 1.4v2.2a1.4 1.4 0 0 1 -1.4 1.4h-2.2a1.4 1.4 0 0 1 -1.4 -1.4v-2.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M10.9 1.5h2.2a1.4 1.4 0 0 1 1.4 1.4v2.2a1.4 1.4 0 0 1 -1.4 1.4h-2.2a1.4 1.4 0 0 1 -1.4 -1.4v-2.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M2.9 9.5h2.2a1.4 1.4 0 0 1 1.4 1.4v2.2a1.4 1.4 0 0 1 -1.4 1.4h-2.2a1.4 1.4 0 0 1 -1.4 -1.4v-2.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path fill="currentColor" stroke="none" d="M9.15 9.15h5.7v5.7h-5.7z"/></svg>',
    lnFollowing: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.402 7.5A3 3 0 1 1 8 6"/><path vector-effect="non-scaling-stroke" d="M8 6A3 3 0 1 1 13.598 7.5"/><path vector-effect="non-scaling-stroke" d="M2.5 7.5L7.5 12.5"/><path vector-effect="non-scaling-stroke" d="M8.5 12.5L13.5 7.5"/></svg>',
    lnPlus: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M7.5 2.5L7.5 12.5"/><path vector-effect="non-scaling-stroke" d="M2.5 7.5L12.5 7.5"/></svg>',
    lnSearch: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="6.5" cy="6.5" r="4.5"/><path vector-effect="non-scaling-stroke" d="M10.5 10.5L13.5 13.5"/></svg>',
    lnAssistant: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M7.5 1.5L8.5 5.5L12.5 7.5L8.5 9.5L7.5 13.5L6.5 9.5L2.5 7.5L6.5 5.5L7.5 1.5"/><path vector-effect="non-scaling-stroke" d="M12.5 1.5L12.5 3.5"/><path vector-effect="non-scaling-stroke" d="M11.5 2.5L13.5 2.5"/></svg>',
    lnDashboard: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v8.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-8.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M1.5 6.5L14.5 6.5"/><path vector-effect="non-scaling-stroke" d="M6.5 6.5L6.5 13.5"/></svg>',
    lnTools: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 3.5L14.5 3.5"/><path vector-effect="non-scaling-stroke" d="M1.5 7.5L14.5 7.5"/><path vector-effect="non-scaling-stroke" d="M1.5 12.5L14.5 12.5"/><path fill="currentColor" stroke="none" d="M9.15 2.15h2.7v2.7h-2.7z"/><path fill="currentColor" stroke="none" d="M3.15 6.15h2.7v2.7h-2.7z"/><path fill="currentColor" stroke="none" d="M7.15 11.15h2.7v2.7h-2.7z"/></svg>',
    lnApps: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v8.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-8.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M1.5 4.5L14.5 4.5"/><circle fill="currentColor" stroke="none" cx="3.5" cy="3.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="5.5" cy="3.5" r="0.85"/><circle fill="currentColor" stroke="none" cx="7.5" cy="3.5" r="0.85"/><path fill="currentColor" stroke="none" d="M6.15 7.15h3.7v3.7h-3.7z"/></svg>',
    lnPresentation: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 1.5h13v9h-13z"/><path fill="currentColor" stroke="none" d="M4.15 6.15h1.7v2.7h-1.7z"/><path fill="currentColor" stroke="none" d="M7.15 4.15h1.7v4.7h-1.7z"/><path fill="currentColor" stroke="none" d="M10.15 5.15h1.7v3.7h-1.7z"/><path vector-effect="non-scaling-stroke" d="M7.5 11.5L4.5 14.5"/><path vector-effect="non-scaling-stroke" d="M8.5 11.5L11.5 14.5"/></svg>',
    lnFly: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.475 14.429A16 16 0 0 1 14.497 2.497"/><path vector-effect="non-scaling-stroke" d="M1.476 14.5A14 14 0 0 1 14.455 7.526"/><path vector-effect="non-scaling-stroke" d="M1.501 14.475A14 14 0 0 1 13.411 11.506"/></svg>',
    lnGrid: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle fill="currentColor" stroke="none" cx="3" cy="3" r="1.05"/><circle fill="currentColor" stroke="none" cx="8" cy="3" r="1.05"/><circle fill="currentColor" stroke="none" cx="13" cy="3" r="1.05"/><circle fill="currentColor" stroke="none" cx="3" cy="8" r="1.05"/><circle fill="currentColor" stroke="none" cx="8" cy="8" r="1.05"/><circle fill="currentColor" stroke="none" cx="13" cy="8" r="1.05"/><circle fill="currentColor" stroke="none" cx="3" cy="13" r="1.05"/><circle fill="currentColor" stroke="none" cx="8" cy="13" r="1.05"/><circle fill="currentColor" stroke="none" cx="13" cy="13" r="1.05"/></svg>',
    lnCheck: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.5 8.5L6.5 12.5L13.5 4.5"/></svg>',
    lnCaret: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 5.5L7.5 9.5L11.5 5.5"/></svg>',
    lnClose: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 3.5L12.5 12.5"/><path vector-effect="non-scaling-stroke" d="M12.5 3.5L3.5 12.5"/></svg>',
    lnSummarize: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.5 3.5L13.5 3.5"/><path vector-effect="non-scaling-stroke" d="M2.5 7.5L13.5 7.5"/><path vector-effect="non-scaling-stroke" d="M2.5 11.5L9.5 11.5"/></svg>',
    lnBlocked: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="8" cy="8" r="6"/><path vector-effect="non-scaling-stroke" d="M4.5 11.5L11.5 4.5"/></svg>',
    lnArrowUp: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 6.5L7.5 2.5L11.5 6.5"/><path vector-effect="non-scaling-stroke" d="M7.5 2.5L7.5 13.5"/></svg>',
    lnArrowUpRight: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M5.5 3.5L12.5 3.5L12.5 10.5"/><path vector-effect="non-scaling-stroke" d="M12.5 3.5L3.5 12.5"/></svg>',
    lnSidebarLeft: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v8.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-8.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M5.5 2.5L5.5 13.5"/></svg>',
    lnSidebarRight: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v8.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-8.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M10.5 2.5L10.5 13.5"/></svg>',
    lnInspect: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="8" cy="8" r="4"/><path vector-effect="non-scaling-stroke" d="M8 1.5L8 3.5"/><path vector-effect="non-scaling-stroke" d="M8 12.5L8 14.5"/><path vector-effect="non-scaling-stroke" d="M1.5 8L3.5 8"/><path vector-effect="non-scaling-stroke" d="M12.5 8L14.5 8"/><circle fill="currentColor" stroke="none" cx="8" cy="8" r="0.85"/></svg>',
    lnAttention: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M8 1.5L14.5 13.5L1.5 13.5L8 1.5"/><path vector-effect="non-scaling-stroke" d="M8 6L8 9.5"/><circle fill="currentColor" stroke="none" cx="8" cy="11.5" r="0.85"/></svg>',
    lnPage: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 2.5h10.2a1.4 1.4 0 0 1 1.4 1.4v8.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-8.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M1.5 5.5L14.5 5.5"/><path vector-effect="non-scaling-stroke" d="M4.5 8.5L11.5 8.5"/><path vector-effect="non-scaling-stroke" d="M4.5 10.5L9.5 10.5"/></svg>',
    lnHelp: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle vector-effect="non-scaling-stroke" cx="8" cy="8" r="6"/><path vector-effect="non-scaling-stroke" d="M5.833 5.618A2.2 2.2 0 1 1 9.905 7.1"/><path vector-effect="non-scaling-stroke" d="M9.9 7.1L8 8.5L8 9.5"/><circle fill="currentColor" stroke="none" cx="8" cy="11.5" r="0.85"/></svg>',
    lnPayments: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2.9 3.5h10.2a1.4 1.4 0 0 1 1.4 1.4v6.2a1.4 1.4 0 0 1 -1.4 1.4h-10.2a1.4 1.4 0 0 1 -1.4 -1.4v-6.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M1.5 6.5L14.5 6.5"/><path vector-effect="non-scaling-stroke" d="M3.5 9.5L6.5 9.5"/></svg>',
    lnRisk: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M8 1.5L13.5 3.5L13.5 8.5L8 14.5L2.5 8.5L2.5 3.5L8 1.5"/><path vector-effect="non-scaling-stroke" d="M8 5.5L8 8.5"/><circle fill="currentColor" stroke="none" cx="8" cy="11" r="0.85"/></svg>',
    lnOrders: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.9 5.5h8.2a1.4 1.4 0 0 1 1.4 1.4v6.2a1.4 1.4 0 0 1 -1.4 1.4h-8.2a1.4 1.4 0 0 1 -1.4 -1.4v-6.2a1.4 1.4 0 0 1 1.4 -1.4z"/><path vector-effect="non-scaling-stroke" d="M5 5.5A3 3 0 0 1 11 5.5"/></svg>',
    lnInventory: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M8 1.5L14.5 4.5L14.5 11.5L8 14.5L1.5 11.5L1.5 4.5L8 1.5"/><path vector-effect="non-scaling-stroke" d="M1.5 4.5L8 7.5L14.5 4.5"/><path vector-effect="non-scaling-stroke" d="M8 7.5L8 14.5"/></svg>',
    lnInvoices: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M3.5 1.5L12.5 1.5L12.5 14.5L11 13L9.5 14.5L8 13L6.5 14.5L5 13L3.5 14.5L3.5 1.5"/><path vector-effect="non-scaling-stroke" d="M5.5 4.5L10.5 4.5"/><path vector-effect="non-scaling-stroke" d="M5.5 7.5L10.5 7.5"/><path vector-effect="non-scaling-stroke" d="M5.5 10.5L8.5 10.5"/></svg>',
    lnStore: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M1.5 6.5L3.5 2.5L12.5 2.5L14.5 6.5"/><path vector-effect="non-scaling-stroke" d="M1.5 6.5L14.5 6.5"/><path vector-effect="non-scaling-stroke" d="M2.5 6.5L2.5 13.5L13.5 13.5L13.5 6.5"/><path vector-effect="non-scaling-stroke" d="M6.5 9.5h3v4h-3z"/></svg>',
    lnSupport: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="M2 8.5A6 6 0 0 1 14 8.5"/><path vector-effect="non-scaling-stroke" d="M1.5 8.5h2v4h-2z"/><path vector-effect="non-scaling-stroke" d="M12.5 8.5h2v4h-2z"/><path vector-effect="non-scaling-stroke" d="M13.5 12.5L13.5 13.5L9.5 14.5"/></svg>'
};

});


parcelRegister("8tiQv", function(module, exports) {

$parcel$export(module.exports, "default", () => $62afa68be899ac26$export$2e2bcd8739ae039);
// Runtime importmap (FA209) — ONLY packages this project dynamic-imports at
// runtime. @elevenlabs/client is the live voice agent of a talk call
// (components/VoiceOverlay.js `scope.agentClient` — `await
// import('@elevenlabs/client')`, FA206; Nika 2026-10-26 "11labs talks, Simone
// acts"); pinned to the exact version the engine was written against, the
// same pin as package.json.
//
// prismjs / fuse.js / lottie-web were three more bare dynamic imports
// (CodePreview.js `await import('prismjs')`, CanvasSearchDropdown.js
// `await import('fuse.js')`, Lottie.js `await import('lottie-web')`) that
// had never been declared here — the browser's importmap has no entry for
// a bare specifier that isn't listed, so every one of those imports threw
// "Failed to resolve module specifier" 100% of the time (not an
// intermittent CDN hiccup), leaving CodePreview/Command/Lottie/CanvasMessage/
// CanvasHelpCard/SearchBtn permanently empty everywhere this library is
// consumed, workspace-ui catalog included. Versions pinned to match the
// root `bun.lock` (`prismjs@1.30.0`, `fuse.js@7.4.2`, `lottie-web@5.13.0`)
// so dev and the runtime importmap resolve the same code.
//
// js-beautify is the fifth (functions/prettifyCode.js `await
// import('js-beautify')`), at the version brand declares (brand
// dependencies.js: js-beautify 2.0.3, lottie-web 5.13.0, prismjs 1.30.0 —
// the three match). acorn is the sixth (methods/code.js parseStringCode
// `await import('acorn')`), at the version the root bun.lock resolves
// (acorn@8.19.0). __tests__/dynamicImportsDeclared.test.js pins every bare
// runtime import to an entry here, with no list of owed gaps.
var $62afa68be899ac26$export$2e2bcd8739ae039 = {
    '@elevenlabs/client': '1.30.0',
    prismjs: '1.30.0',
    'fuse.js': '7.4.2',
    'lottie-web': '5.13.0',
    'js-beautify': '2.0.3',
    acorn: '8.19.0'
};

});


parcelRegister("6BQ98", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("l9IUR"))) : import("l9IUR")).then(()=>parcelRequire('c9jLJ'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1qlkh", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("c0sEi"))) : import("c0sEi")).then(()=>parcelRequire('3XGVK'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("e0NO5", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6Uw8h"))) : import("6Uw8h")).then(()=>parcelRequire('kezhB'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("fq8YJ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("1JP9k"))) : import("1JP9k")).then(()=>parcelRequire('lt0Ls'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("kSK4w", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("3wmzc"))) : import("3wmzc")).then(()=>parcelRequire('lXp9g'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("a7o5f", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hhT4g"))) : import("hhT4g")).then(()=>parcelRequire('bF1Ez'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("f99Ni", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("2inxq"))) : import("2inxq")).then(()=>parcelRequire('cNdJJ'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("fHQBL", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("7lpNW"))) : import("7lpNW")).then(()=>parcelRequire('k6tHf'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7qeSZ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("khJfE"))) : import("khJfE")).then(()=>parcelRequire('hziv2'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hoFij", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9Uklh"))) : import("9Uklh")).then(()=>parcelRequire('fV2K2'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("i4y0L", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("60y5c"))) : import("60y5c")).then(()=>parcelRequire('a1DuA'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("cv1dg", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("7u1ZB"))) : import("7u1ZB")).then(()=>parcelRequire('f66ah'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("aL87a", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("7iqFG"))) : import("7iqFG")).then(()=>parcelRequire('2OzJC'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("76R62", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hlgrQ"))) : import("hlgrQ")).then(()=>parcelRequire('gumPT'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("a4yDd", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("depxa"))) : import("depxa")).then(()=>parcelRequire('9kwMu'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("eUDPh", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9E0Ag"))) : import("9E0Ag")).then(()=>parcelRequire('2sSrq'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("c8dgm", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("20szk"))) : import("20szk")).then(()=>parcelRequire('g5sy4'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("8Gcrr", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9UJZy"))) : import("9UJZy")).then(()=>parcelRequire('4VAjv'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("gBje0", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("1YsIl"))) : import("1YsIl")).then(()=>parcelRequire('beqRM'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("9Vdab", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("g86Vy"))) : import("g86Vy")).then(()=>parcelRequire('kTIeQ'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("fAnOD", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6ZtSu"))) : import("6ZtSu")).then(()=>parcelRequire('b7pue'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("aLmjf", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("dAGrm"))) : import("dAGrm")).then(()=>parcelRequire('2kDS9'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("9glIA", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("ddMmP"))) : import("ddMmP")).then(()=>parcelRequire('cSK9T'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("eSvYK", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("29m55"))) : import("29m55")).then(()=>parcelRequire('bLJEj'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hZhUj", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("jvWYj"))) : import("jvWYj")).then(()=>parcelRequire('2z7sK'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1g9G6", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("4feWI"))) : import("4feWI")).then(()=>parcelRequire('bNSzs'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7iFOV", function(module, exports) {

$parcel$export(module.exports, "shellStripWorkspacePrefix", () => $550aa77d630d260e$export$cf234e98f07f7f4b);
$parcel$export(module.exports, "shellParseWorkspaceProjectPath", () => $550aa77d630d260e$export$3c67949a4f352a44);
$parcel$export(module.exports, "shellGetAiService", () => $550aa77d630d260e$export$dda686bbfa86b2ff);
$parcel$export(module.exports, "workspaceSettingsForWrite", () => $550aa77d630d260e$export$79bee8c02f25646f);
$parcel$export(module.exports, "shellSay", () => $550aa77d630d260e$export$d454443287ad2c14);
// The ONE module-scope owner of the shell's deferred shared-library
// delegates that more than one shell file reads.
//
// WHY ONE OWNER. frank hoists every module-scope declaration a function reads
// into ONE flat globalScope, so a name carries one value for the whole
// published bundle. These delegates used to be re-declared in every file that
// read them (17 copies of shellStripWorkspacePrefix, 6 of shellGetAiService,
// four of workspaceSettingsForWrite and of the bundle-sentence helper, two of
// shellParseWorkspaceProjectPath), and the copies drifted apart in text —
// frank's module-scope-name-conflict check refuses that. The files import
// them from here; frank follows the import to this one declaration.
//
// NOT barrel-registered (functions/index.js does not re-export this file):
// these are module helpers, not `el.call` functions.
//
// Deferred-call wrappers, never a module-scope destructure of the shared
// barrel: the shell's modules load INSIDE the shared-barrel init cycle (see
// app.js's circular-init note), where `_wsShared.functions` is not yet set.

var $1X0Je = parcelRequire("1X0Je");
const $550aa77d630d260e$export$cf234e98f07f7f4b = (...args)=>(0, $1X0Je.default).functions.stripWorkspacePrefix(...args);
const $550aa77d630d260e$export$3c67949a4f352a44 = (...args)=>(0, $1X0Je.default).functions.parseWorkspaceProjectPath(...args);
const $550aa77d630d260e$export$dda686bbfa86b2ff = function(...args) {
    return (0, $1X0Je.default).functions.getAiService.apply(this, args);
};
const $550aa77d630d260e$export$79bee8c02f25646f = (...args)=>(0, $1X0Je.default).functions.workspaceSettingsForWrite(...args);
const $550aa77d630d260e$export$d454443287ad2c14 = (el, key)=>{
    const v = el && typeof el.call === 'function' ? el.call('polyglot', key) : (0, $1X0Je.default).functions.i18nStaticEnglish()[key] || key;
    return v == null ? '' : String(v);
};

});

parcelRegister("hv7Tn", function(module, exports) {

$parcel$export(module.exports, "shellResolveClaims", () => $cbdb7427e9c5ab8e$export$3a81d976ce51ae35);
// claimResolver — Capstone GATE A (Phase 6, supabase-mongo-auth-capstone.md).
//
// Mongo-sourced claim READS for the intranet permission / role / superadmin
// gates. The frontend already prefers the Mongo SDK token over the retired
// governance Supabase JWT for transport (`shared/functions/sdk.js`
// `_workspaceTokenProvider`); this module resolves the same primitives the
// gates read — `root.jwtClaims` is now itself SDK/Mongo-sourced (see
// `shared/functions/authBridge.js`) — by re-deriving the permission-sensitive
// fields from `/auth/me`'s per-org enrichment, which is more current than
// whatever snapshot is sitting on `root.jwtClaims`:
//
//   • `permissions[]`  — the intranet permission union (OrgMember role ∪ team perms)
//   • `is_owner`       — active-org ownership (`simpleOrgRole(role) === 'owner'`)
//   • `org_role`       — active-org simple role (owner | admin | member)
//   • `symbols_role`   — platform global role (`User.globalRole`)
//
// This module centralizes those reads in ONE place (`resolveClaims`) so every
// call site stays consistent. Was flag-gated behind `__USE_MONGO_CLAIMS__`
// during the Gate A cutover (2026-07-03); collapsed to Mongo-only 2026-07-31
// after the governance JWT read-dependency was confirmed permanently dead —
// the server stopped minting `app_metadata` claims on 2026-07-28, so the old
// OFF branch (`root.jwtClaims` verbatim) had no live data source left.

var $eb4QA = parcelRequire("eb4QA");
// 6-tier OrgMember.role → 3-tier intranet axis. Mirrors the server's
// `simpleOrgRole` (core/constants/permissions.js) — keep in sync. Used to
// derive `org_role` / `is_owner` from the raw active-org role when the
// server hasn't pre-enriched it.
const $cbdb7427e9c5ab8e$var$_SIMPLE_ROLE_MAP = {
    owner: 'owner',
    'co-owner': 'owner',
    admin: 'admin',
    maintainer: 'admin',
    member: 'member',
    contributor: 'member'
};
const $cbdb7427e9c5ab8e$var$_simpleOrgRole = (role)=>role ? $cbdb7427e9c5ab8e$var$_SIMPLE_ROLE_MAP[role] || 'member' : 'member';
// Local permission union — fallback for when the server hasn't enriched
// `org.permissions` (older /auth/me). Mirrors the server's
// `unionEffectivePermissions` (core/utils/effectivePermissions.js): owner →
// every key; otherwise OrgMember-role perms ∪ each team's perms, with passive
// members intersected to the passive template (today empty → zero elevations).
const $cbdb7427e9c5ab8e$var$_unionPermissions = (memberRole, teamsInOrg)=>{
    const simple = $cbdb7427e9c5ab8e$var$_simpleOrgRole(memberRole);
    if (simple === 'owner') return (0, $eb4QA.PERMISSION_KEYS).slice();
    const merged = new Set((0, $eb4QA.ORG_ROLE_PERMISSIONS)[simple] || []);
    const keySet = new Set((0, $eb4QA.PERMISSION_KEYS));
    const passiveSet = new Set((0, $eb4QA.CATEGORY_PERMISSION_TEMPLATES).passive || []);
    for (const t of Array.isArray(teamsInOrg) ? teamsInOrg : []){
        const isPassive = t && t.status === 'passive';
        const perms = Array.isArray(t && t.permissions) ? t.permissions : [];
        for (const p of perms){
            if (!keySet.has(p)) continue;
            if (isPassive && !passiveSet.has(p)) continue;
            merged.add(p);
        }
    }
    return [
        ...merged
    ];
};
// Resolve the active-org row from the Mongo-sourced state. `root.org` is the
// active-org OrgMember row (`{ id, role, … }`) populated by
// subscribeAuthSession / the eager scope fetch from `/auth/me`. Falls back to
// looking up `workspace_org_id` in `root.orgs` when `root.org` is unset.
const $cbdb7427e9c5ab8e$var$_activeOrg = (root)=>{
    if (!root) return null;
    if (root.org) return root.org;
    const activeId = root.jwtClaims?.workspace_org_id;
    const orgs = Array.isArray(root.orgs) ? root.orgs : [];
    return activeId && orgs.find((o)=>o && o.id === activeId) || orgs[0] || null;
};
// Teams the user belongs to in the active org — for the local permission
// union fallback. The server-enriched `org.permissions` is preferred; this
// only runs when that's absent. Team lists may arrive on `root.jwtClaims.teams`
// (mirrored session claims) or `root.teams` (HR roster) — both are tolerated.
const $cbdb7427e9c5ab8e$var$_activeOrgTeams = (root, activeOrgId)=>{
    const claimsTeams = Array.isArray(root?.jwtClaims?.teams) ? root.jwtClaims.teams : null;
    if (claimsTeams) return activeOrgId ? claimsTeams.filter((t)=>!t.org_id || String(t.org_id) === String(activeOrgId)) : claimsTeams;
    return [];
};
// Build the Mongo-sourced claim object — field-for-field equivalent to the
// shape the gates read, sourced from `/auth/me`. PRESERVES every
// non-permission field already on `root.jwtClaims` (orgs, workspaces,
// active_workspace_id, workspace_org_id, teams, sub, …) so consumers that read
// those keys through the same resolver are unaffected — ONLY the permission /
// role primitives are re-sourced from Mongo.
const $cbdb7427e9c5ab8e$var$_buildMongoClaims = (root)=>{
    const base = root && root.jwtClaims || {};
    const org = $cbdb7427e9c5ab8e$var$_activeOrg(root);
    const rawRole = org?.role || null;
    // Prefer server-enriched fields (single source of truth — the server's
    // sessionClaims union); derive locally only when absent.
    const orgRole = org && typeof org.simpleRole === 'string' ? org.simpleRole : $cbdb7427e9c5ab8e$var$_simpleOrgRole(rawRole);
    const isOwner = org && typeof org.isOwner === 'boolean' ? org.isOwner : orgRole === 'owner';
    let permissions;
    if (org && Array.isArray(org.permissions)) permissions = org.permissions;
    else if (org && Array.isArray(org.intranetPermissions)) permissions = org.intranetPermissions;
    else permissions = $cbdb7427e9c5ab8e$var$_unionPermissions(rawRole, $cbdb7427e9c5ab8e$var$_activeOrgTeams(root, org?.id));
    // `symbols_role` ← Mongo `User.globalRole` (root.user.globalRole, surfaced by
    // /auth/me). Falls back to the existing claim when the user record isn't on
    // root yet.
    const globalRole = root && root.user && root.user.globalRole || base.symbols_role || base.symbolsRole || null;
    return {
        ...base,
        permissions: permissions,
        is_owner: isOwner,
        org_role: orgRole,
        symbols_role: globalRole,
        symbolsRole: globalRole
    };
};
const $cbdb7427e9c5ab8e$export$3a81d976ce51ae35 = (root)=>{
    if (!root) return {};
    return $cbdb7427e9c5ab8e$var$_buildMongoClaims(root);
};

});
parcelRegister("eb4QA", function(module, exports) {

$parcel$export(module.exports, "APP_ACCESS_VERBS", () => $a525da4e74cc70a0$export$a2a5b5f7b9e71a55);
$parcel$export(module.exports, "APP_ACCESS_APPS", () => $a525da4e74cc70a0$export$b769ed7b044b0980);
$parcel$export(module.exports, "APP_PERMISSIONS", () => $a525da4e74cc70a0$export$8e898867419e6d21);
$parcel$export(module.exports, "PERMISSIONS", () => $a525da4e74cc70a0$export$d6eefc103e184eaa);
$parcel$export(module.exports, "PERMISSION_KEYS", () => $a525da4e74cc70a0$export$e08c7aae438e15b4);
$parcel$export(module.exports, "PERMISSION_GROUPS", () => $a525da4e74cc70a0$export$40d95c19a7e19d13);
$parcel$export(module.exports, "ORG_ROLE_PERMISSIONS", () => $a525da4e74cc70a0$export$1a21b5fac534dc68);
$parcel$export(module.exports, "SYSTEM_TEAMS", () => $a525da4e74cc70a0$export$1f4c54125d840468);
$parcel$export(module.exports, "SYSTEM_TEAM_SLUGS", () => $a525da4e74cc70a0$export$3528e60aa7f8a8ca);
$parcel$export(module.exports, "CATEGORIES", () => $a525da4e74cc70a0$export$a513ea61a7bee91c);
$parcel$export(module.exports, "CATEGORY_PERMISSION_TEMPLATES", () => $a525da4e74cc70a0$export$65ab0c15e65c423a);
$parcel$export(module.exports, "teamMatchesTemplate", () => $a525da4e74cc70a0$export$2d61fb14abca3064);
$parcel$export(module.exports, "dominantCategory", () => $a525da4e74cc70a0$export$df6168adaf178a);
$parcel$export(module.exports, "LEGACY_ORG_IDS", () => $a525da4e74cc70a0$export$3dee873c174bc8d8);
$parcel$export(module.exports, "PERMISSIONS_BY_GROUP", () => $a525da4e74cc70a0$export$2931f501d90fd912);
$parcel$export(module.exports, "hasPerm", () => $a525da4e74cc70a0$export$cdac03a8d3b5824e);
$parcel$export(module.exports, "claimsIsActiveMember", () => $a525da4e74cc70a0$export$7ba1aff54dd425d2);
$parcel$export(module.exports, "isInTeam", () => $a525da4e74cc70a0$export$f047224f8a005577);
$parcel$export(module.exports, "claimsIsOwner", () => $a525da4e74cc70a0$export$c053379f058a1e5b);
$parcel$export(module.exports, "claimsIsAdmin", () => $a525da4e74cc70a0$export$e1e7fb31b9b7ab14);
$parcel$export(module.exports, "canAccessGovUI", () => $a525da4e74cc70a0$export$52070e566ccb1e3e);
$parcel$export(module.exports, "effectiveCategory", () => $a525da4e74cc70a0$export$74316c6523cc040e);
$parcel$export(module.exports, "redirectIfExternalOnly", () => $a525da4e74cc70a0$export$5e71ab9ac92f9020);
$parcel$export(module.exports, "permLabel", () => $a525da4e74cc70a0$export$72bc84371f3e87c6);
$parcel$export(module.exports, "permDescription", () => $a525da4e74cc70a0$export$6e2715c6663b7445);
$parcel$export(module.exports, "permGroup", () => $a525da4e74cc70a0$export$912c8ba879008689);
$parcel$export(module.exports, "PERMISSION_GROUP_KEYS", () => $a525da4e74cc70a0$export$aa1563a0551278a1);
$parcel$export(module.exports, "permLabelText", () => $a525da4e74cc70a0$export$51578e56e36af071);
$parcel$export(module.exports, "permDescriptionText", () => $a525da4e74cc70a0$export$f483b16962dc0291);
$parcel$export(module.exports, "permGroupText", () => $a525da4e74cc70a0$export$29dda42e18a0628d);
// Permission vocabulary — single source of truth for the intranet's
// team-based access control. 30 keys, grouped by domain. The server
// mirrors this file at `server/src/core/constants/permissions.js`
// and must stay in sync (see NEEDED_FOR_SERVER.md §I11).
//
// Effective permissions for a user in an org =
//   owner-bypass  ∪  OrgMember.role perms  ∪  team perms  ∪  ancestor team perms
//
// Checked in:
//   • Governance RLS (`jwt_has_perm(key)` — migration 0060)
//   • Server endpoints that mutate teams / perms
//   • Intranet UI gates (admin matrix, tab visibility)
//
// No wildcards by design — enumerate effective perms exactly.

var $hv7Tn = parcelRequire("hv7Tn");
// ── Permission keys ────────────────────────────────────────────────
const $a525da4e74cc70a0$var$BASE_PERMISSIONS = {
    // Admin (settings-page surfaces; not "superuser")
    'admin.pages.read': {
        group: 'Admin',
        label: 'admin.perm.adminPagesRead.label',
        description: 'admin.perm.adminPagesRead.description'
    },
    'admin.users': {
        group: 'Admin',
        label: 'admin.perm.adminUsers.label',
        description: 'admin.perm.adminUsers.description'
    },
    'admin.teams': {
        group: 'Admin',
        label: 'admin.perm.adminTeams.label',
        description: 'admin.perm.adminTeams.description'
    },
    'admin.team_permissions': {
        group: 'Admin',
        label: 'admin.perm.adminTeamPermissions.label',
        description: 'admin.perm.adminTeamPermissions.description'
    },
    'admin.billing': {
        group: 'Admin',
        label: 'admin.perm.adminBilling.label',
        description: 'admin.perm.adminBilling.description'
    },
    'admin.integrations': {
        group: 'Admin',
        label: 'admin.perm.adminIntegrations.label',
        description: 'admin.perm.adminIntegrations.description'
    },
    'admin.commercials': {
        group: 'Admin',
        label: 'admin.perm.adminCommercials.label',
        description: 'admin.perm.adminCommercials.description'
    },
    'admin.cap_table': {
        group: 'Admin',
        label: 'admin.perm.adminCapTable.label',
        description: 'admin.perm.adminCapTable.description'
    },
    'admin.hr': {
        group: 'Admin',
        label: 'admin.perm.adminHr.label',
        description: 'admin.perm.adminHr.description'
    },
    'admin.logs': {
        group: 'Admin',
        label: 'admin.perm.adminLogs.label',
        description: 'admin.perm.adminLogs.description'
    },
    'admin.system': {
        group: 'Admin',
        label: 'admin.perm.adminSystem.label',
        description: 'admin.perm.adminSystem.description'
    },
    'admin.company': {
        group: 'Admin',
        label: 'admin.perm.adminCompany.label',
        description: 'admin.perm.adminCompany.description'
    },
    // Docs
    'docs.edit_others': {
        group: 'Docs',
        label: 'admin.perm.docsEditOthers.label',
        description: 'admin.perm.docsEditOthers.description'
    },
    'docs.delete_others': {
        group: 'Docs',
        label: 'admin.perm.docsDeleteOthers.label',
        description: 'admin.perm.docsDeleteOthers.description'
    },
    'docs.read_private': {
        group: 'Docs',
        label: 'admin.perm.docsReadPrivate.label',
        description: 'admin.perm.docsReadPrivate.description'
    },
    // Knowledge base
    'kb.edit_others': {
        group: 'KB',
        label: 'admin.perm.kbEditOthers.label',
        description: 'admin.perm.kbEditOthers.description'
    },
    'kb.delete_others': {
        group: 'KB',
        label: 'admin.perm.kbDeleteOthers.label',
        description: 'admin.perm.kbDeleteOthers.description'
    },
    // Tasks (né Tickets — user-facing rename 2026-08-06; permission KEYS stay
    // the internal tickets.* vocabulary the server checks against)
    'tickets.assign': {
        group: 'Tasks',
        label: 'admin.perm.ticketsAssign.label',
        description: 'admin.perm.ticketsAssign.description'
    },
    'tickets.close_others': {
        group: 'Tasks',
        label: 'admin.perm.ticketsCloseOthers.label',
        description: 'admin.perm.ticketsCloseOthers.description'
    },
    'tickets.delete_others': {
        group: 'Tasks',
        label: 'admin.perm.ticketsDeleteOthers.label',
        description: 'admin.perm.ticketsDeleteOthers.description'
    },
    'tickets.manage_columns': {
        group: 'Tasks',
        label: 'admin.perm.ticketsManageColumns.label',
        description: 'admin.perm.ticketsManageColumns.description'
    },
    // Stories / announcements
    'stories.post': {
        group: 'Stories',
        label: 'admin.perm.storiesPost.label',
        description: 'admin.perm.storiesPost.description'
    },
    'stories.edit_others': {
        group: 'Stories',
        label: 'admin.perm.storiesEditOthers.label',
        description: 'admin.perm.storiesEditOthers.description'
    },
    'stories.delete_others': {
        group: 'Stories',
        label: 'admin.perm.storiesDeleteOthers.label',
        description: 'admin.perm.storiesDeleteOthers.description'
    },
    'stories.pin': {
        group: 'Stories',
        label: 'admin.perm.storiesPin.label',
        description: 'admin.perm.storiesPin.description'
    },
    // Calendar
    'calendar.create_org_events': {
        group: 'Calendar',
        label: 'admin.perm.calendarCreateOrgEvents.label',
        description: 'admin.perm.calendarCreateOrgEvents.description'
    },
    'calendar.edit_others': {
        group: 'Calendar',
        label: 'admin.perm.calendarEditOthers.label',
        description: 'admin.perm.calendarEditOthers.description'
    },
    // Chat
    'chat.create_channels': {
        group: 'Chat',
        label: 'admin.perm.chatCreateChannels.label',
        description: 'admin.perm.chatCreateChannels.description'
    },
    'chat.archive_channels': {
        group: 'Chat',
        label: 'admin.perm.chatArchiveChannels.label',
        description: 'admin.perm.chatArchiveChannels.description'
    },
    'chat.delete_others': {
        group: 'Chat',
        label: 'admin.perm.chatDeleteOthers.label',
        description: 'admin.perm.chatDeleteOthers.description'
    },
    // Grants
    'grants.view_others': {
        group: 'Grants',
        label: 'admin.perm.grantsViewOthers.label',
        description: 'admin.perm.grantsViewOthers.description'
    }
};
const $a525da4e74cc70a0$export$a2a5b5f7b9e71a55 = [
    'read',
    'create',
    'update',
    'delete'
];
const $a525da4e74cc70a0$export$b769ed7b044b0980 = [
    {
        key: 'calendar',
        label: 'admin.app.calendar'
    },
    {
        key: 'chat',
        label: 'admin.app.chat'
    },
    {
        key: 'meet',
        label: 'admin.app.meet'
    },
    {
        key: 'documents',
        label: 'admin.app.documents'
    },
    {
        key: 'files',
        label: 'admin.app.files'
    },
    {
        key: 'tickets',
        label: 'admin.app.tickets'
    },
    {
        key: 'reminders',
        label: 'admin.app.reminders'
    },
    {
        key: 'resolutions',
        label: 'admin.app.resolutions'
    },
    {
        key: 'analytics',
        label: 'admin.app.analytics'
    },
    {
        key: 'data',
        label: 'admin.app.data'
    },
    {
        key: 'announcements',
        label: 'admin.app.announcements'
    },
    {
        key: 'company',
        label: 'admin.app.company'
    }
];
// The four CRUD verbs, as bundle keys. Written out rather than derived from
// APP_ACCESS_VERBS so every key is greppable (docs/I18N-CONVENTION.md §1.3).
const $a525da4e74cc70a0$var$APP_VERB_KEYS = {
    read: 'admin.perm.verb.read',
    create: 'admin.perm.verb.create',
    update: 'admin.perm.verb.update',
    delete: 'admin.perm.verb.delete'
};
const $a525da4e74cc70a0$export$8e898867419e6d21 = $a525da4e74cc70a0$export$b769ed7b044b0980.reduce((acc, app)=>{
    for (const verb of $a525da4e74cc70a0$export$a2a5b5f7b9e71a55)acc[`app.${app.key}.${verb}`] = {
        group: 'Apps',
        appKey: app.label,
        verbKey: $a525da4e74cc70a0$var$APP_VERB_KEYS[verb]
    };
    return acc;
}, {});
const $a525da4e74cc70a0$export$d6eefc103e184eaa = {
    ...$a525da4e74cc70a0$var$BASE_PERMISSIONS,
    ...$a525da4e74cc70a0$export$8e898867419e6d21
};
const $a525da4e74cc70a0$export$e08c7aae438e15b4 = Object.keys($a525da4e74cc70a0$export$d6eefc103e184eaa);
const $a525da4e74cc70a0$export$40d95c19a7e19d13 = [
    ...new Set($a525da4e74cc70a0$export$e08c7aae438e15b4.map((k)=>$a525da4e74cc70a0$export$d6eefc103e184eaa[k].group))
];
const $a525da4e74cc70a0$export$1a21b5fac534dc68 = {
    owner: $a525da4e74cc70a0$export$e08c7aae438e15b4,
    admin: $a525da4e74cc70a0$export$e08c7aae438e15b4.filter((k)=>k.startsWith('admin.')),
    member: []
};
const $a525da4e74cc70a0$export$1f4c54125d840468 = [
    // Active category — members of these teams see the full intranet.
    {
        slug: 'members',
        name: 'Members',
        category: 'active',
        permissions: []
    },
    {
        slug: 'admin',
        name: 'Admin',
        category: 'active',
        permissions: $a525da4e74cc70a0$export$e08c7aae438e15b4.filter((k)=>k.startsWith('admin.'))
    },
    {
        slug: 'manager',
        name: 'Manager',
        category: 'active',
        permissions: [
            'tickets.assign',
            'tickets.close_others',
            'calendar.create_org_events',
            'stories.post',
            'docs.edit_others'
        ]
    },
    {
        slug: 'hr',
        name: 'HR',
        category: 'active',
        permissions: [
            'admin.hr',
            'admin.users'
        ]
    },
    {
        slug: 'finance',
        name: 'Finance',
        category: 'active',
        permissions: [
            'admin.billing',
            'admin.cap_table',
            'grants.view_others'
        ]
    },
    {
        slug: 'content',
        name: 'Content',
        category: 'active',
        permissions: [
            'docs.edit_others',
            'kb.edit_others',
            'stories.post',
            'stories.pin'
        ]
    },
    // External category — trimmed intranet surface.
    {
        slug: 'advisors',
        name: 'Advisors',
        category: 'external',
        permissions: []
    },
    {
        slug: 'investors',
        name: 'Investors',
        category: 'external',
        permissions: []
    },
    {
        slug: 'alumni',
        name: 'Alumni',
        category: 'external',
        permissions: []
    }
];
const $a525da4e74cc70a0$export$3528e60aa7f8a8ca = new Set($a525da4e74cc70a0$export$1f4c54125d840468.map((t)=>t.slug));
const $a525da4e74cc70a0$export$a513ea61a7bee91c = [
    'manager',
    'active',
    'passive',
    'external',
    'archived'
];
const $a525da4e74cc70a0$export$65ab0c15e65c423a = {
    manager: $a525da4e74cc70a0$export$e08c7aae438e15b4,
    active: [
        'tickets.assign',
        'tickets.close_others',
        'tickets.manage_columns',
        'calendar.create_org_events',
        'stories.post',
        'chat.create_channels',
        'docs.edit_others',
        'kb.edit_others'
    ],
    passive: [],
    external: [],
    archived: []
};
const $a525da4e74cc70a0$export$2d61fb14abca3064 = (team)=>{
    if (!team || !team.category) return false;
    const tpl = $a525da4e74cc70a0$export$65ab0c15e65c423a[team.category];
    if (!tpl) return false;
    const perms = Array.isArray(team.permissions) ? team.permissions : [];
    if (perms.length !== tpl.length) return false;
    const tplSet = new Set(tpl);
    return perms.every((p)=>tplSet.has(p));
};
const $a525da4e74cc70a0$export$df6168adaf178a = (teams)=>{
    if (!Array.isArray(teams) || !teams.length) return null;
    const set = new Set(teams.map((t)=>t.category).filter(Boolean));
    for (const cat of $a525da4e74cc70a0$export$a513ea61a7bee91c)if (set.has(cat)) return cat;
    return null;
};
const $a525da4e74cc70a0$export$3dee873c174bc8d8 = new Set([
    '69b77a61e0e0de1aa47d01cb' // Symbols System — original pre-multitenancy home
]);
const $a525da4e74cc70a0$export$2931f501d90fd912 = Object.fromEntries($a525da4e74cc70a0$export$40d95c19a7e19d13.map((g)=>[
        g,
        $a525da4e74cc70a0$export$e08c7aae438e15b4.filter((k)=>$a525da4e74cc70a0$export$d6eefc103e184eaa[k].group === g)
    ]));
const $a525da4e74cc70a0$export$cdac03a8d3b5824e = (claims, key)=>!!claims && (claims.is_owner === true || (claims.permissions || []).includes(key));
const $a525da4e74cc70a0$export$7ba1aff54dd425d2 = (claims)=>!!claims && (claims.teams || []).some((t)=>t.category === 'active');
const $a525da4e74cc70a0$export$f047224f8a005577 = (claims, slug)=>!!claims && (claims.teams || []).some((t)=>t.slug === slug);
const $a525da4e74cc70a0$export$c053379f058a1e5b = (claims)=>!!claims && claims.is_owner === true;
const $a525da4e74cc70a0$export$e1e7fb31b9b7ab14 = (claims)=>!!claims && (claims.org_role === 'owner' || claims.org_role === 'admin');
const $a525da4e74cc70a0$export$52070e566ccb1e3e = (claims)=>$a525da4e74cc70a0$export$c053379f058a1e5b(claims) || $a525da4e74cc70a0$export$e1e7fb31b9b7ab14(claims) || $a525da4e74cc70a0$export$7ba1aff54dd425d2(claims);
const $a525da4e74cc70a0$export$74316c6523cc040e = (teams)=>{
    if (!teams || !teams.length) return 'none';
    const set = new Set(teams.map((t)=>t.category).filter(Boolean));
    for (const cat of $a525da4e74cc70a0$export$a513ea61a7bee91c)if (set.has(cat)) return cat;
    return 'none';
};
const $a525da4e74cc70a0$export$5e71ab9ac92f9020 = function(s) {
    const el = this;
    // Capstone GATE A: route the claim read through the resolver so this gate
    // stays consistent with roleHelpers (Mongo-sourced via `/auth/me`).
    const claims = (0, $hv7Tn.shellResolveClaims)(s?.root);
    // Claims still loading — don't bounce.
    if (!claims || !Array.isArray(claims.teams)) return false;
    if ($a525da4e74cc70a0$export$52070e566ccb1e3e(claims)) return false;
    const root = el.call('findRouteRoot', el);
    if (root) el.router('/', root, {}, {
        pushState: true
    });
    return true;
};
const $a525da4e74cc70a0$export$72bc84371f3e87c6 = (key)=>$a525da4e74cc70a0$export$d6eefc103e184eaa[key]?.label || key;
const $a525da4e74cc70a0$export$6e2715c6663b7445 = (key)=>$a525da4e74cc70a0$export$d6eefc103e184eaa[key]?.description || '';
const $a525da4e74cc70a0$export$912c8ba879008689 = (key)=>$a525da4e74cc70a0$export$d6eefc103e184eaa[key]?.group || 'Other';
const $a525da4e74cc70a0$export$aa1563a0551278a1 = {
    Admin: 'admin.permGroup.admin',
    Docs: 'admin.permGroup.docs',
    KB: 'admin.permGroup.kb',
    Tasks: 'admin.permGroup.tasks',
    Stories: 'admin.permGroup.stories',
    Calendar: 'admin.permGroup.calendar',
    Chat: 'admin.permGroup.chat',
    Grants: 'admin.permGroup.grants',
    Apps: 'admin.permGroup.apps',
    Other: 'admin.permGroup.other'
};
const $a525da4e74cc70a0$export$51578e56e36af071 = function(key) {
    const p = $a525da4e74cc70a0$export$d6eefc103e184eaa[key];
    if (!p) return key;
    if (p.appKey) return this.call('polyglot', 'admin.perm.appLabel').replace('{app}', this.call('polyglot', p.appKey)).replace('{verb}', this.call('polyglot', p.verbKey));
    return this.call('polyglot', p.label);
};
const $a525da4e74cc70a0$export$f483b16962dc0291 = function(key) {
    const p = $a525da4e74cc70a0$export$d6eefc103e184eaa[key];
    if (!p) return '';
    if (p.appKey) return this.call('polyglot', 'admin.perm.appDescription').replace('{app}', this.call('polyglot', p.appKey)).replace('{verb}', this.call('polyglot', p.verbKey));
    return this.call('polyglot', p.description);
};
const $a525da4e74cc70a0$export$29dda42e18a0628d = function(key) {
    return this.call('polyglot', $a525da4e74cc70a0$export$aa1563a0551278a1[key] || $a525da4e74cc70a0$export$aa1563a0551278a1.Other);
};

});


parcelRegister("96RcK", function(module, exports) {

$parcel$export(module.exports, "DOC_FOLDERS", () => $6a1df1e84ee35887$export$311b086aef03ae07);
$parcel$export(module.exports, "KB_CATEGORIES", () => $6a1df1e84ee35887$export$5b10e3fe3de90251);
// Doc / KB taxonomies — moved out of workspace-project/state.js so the
// constants live with the documents surface that consumes them.
// `label` carries a polyglot KEY, not a string. Every render site resolves it
// through `el.call('polyglot', …)`, and translate() returns a non-key verbatim
// — which is what keeps a USER-CREATED folder (its label is the raw folderPath)
// rendering as itself alongside these.
const $6a1df1e84ee35887$export$311b086aef03ae07 = Object.freeze([
    {
        key: 'all',
        label: 'documents.folder.notes',
        icon: 'folder'
    },
    {
        key: 'company',
        label: 'documents.folder.company',
        icon: 'flag'
    },
    {
        key: 'legal',
        label: 'documents.folder.legal',
        icon: 'bookmark'
    },
    {
        key: 'finance',
        label: 'documents.folder.finance',
        icon: 'document'
    },
    {
        key: 'people',
        label: 'documents.folder.people',
        icon: 'people'
    },
    {
        key: 'engineering',
        label: 'documents.folder.engineering',
        icon: 'code'
    },
    {
        key: 'design',
        label: 'documents.folder.design',
        icon: 'eye'
    }
]);
const $6a1df1e84ee35887$export$5b10e3fe3de90251 = Object.freeze([
    {
        key: 'all',
        label: 'documents.kbCategory.all',
        icon: 'document'
    },
    {
        key: 'getting-started',
        label: 'documents.kbCategory.gettingStarted',
        icon: 'star'
    },
    {
        key: 'engineering',
        label: 'documents.kbCategory.engineering',
        icon: 'code'
    },
    {
        key: 'design',
        label: 'documents.kbCategory.design',
        icon: 'eye'
    },
    {
        key: 'policies',
        label: 'documents.kbCategory.policies',
        icon: 'bookmark'
    },
    {
        key: 'tools',
        label: 'documents.kbCategory.tools',
        icon: 'settings'
    }
]);

});

parcelRegister("aGIjc", function(module, exports) {

$parcel$export(module.exports, "currentPermissions", () => $7c80326208ab9ee7$export$74b261995140129d);
$parcel$export(module.exports, "shellHasPermission", () => $7c80326208ab9ee7$export$e200ca876654e832);
$parcel$export(module.exports, "hasRole", () => $7c80326208ab9ee7$export$128c909470667330);
$parcel$export(module.exports, "userIsSuperadmin", () => $7c80326208ab9ee7$export$1f77f77e69786261);
$parcel$export(module.exports, "userIsAdmin", () => $7c80326208ab9ee7$export$4fa022b027db4f78);
$parcel$export(module.exports, "isExternalEmail", () => $7c80326208ab9ee7$export$2743fcd812a5361c);
$parcel$export(module.exports, "currentUser", () => $7c80326208ab9ee7$export$5671b2216dc5440f);
$parcel$export(module.exports, "currentUserIsAdmin", () => $7c80326208ab9ee7$export$da10c08bc4dc3bad);
$parcel$export(module.exports, "currentUserIsSuperadmin", () => $7c80326208ab9ee7$export$26fd45a3c2642bc0);
$parcel$export(module.exports, "isAdmin", () => $7c80326208ab9ee7$export$fc970ed23da99565);
$parcel$export(module.exports, "findRouteRoot", () => $7c80326208ab9ee7$export$cb73ea256889842e);
$parcel$export(module.exports, "shouldRedirectNonAdmin", () => $7c80326208ab9ee7$export$e11f93c844913942);
$parcel$export(module.exports, "shouldRedirectNoPerm", () => $7c80326208ab9ee7$export$a81d7c13204c7285);
$parcel$export(module.exports, "shellIsSuperAdmin", () => $7c80326208ab9ee7$export$322d0219aa8d2738);
$parcel$export(module.exports, "shouldRedirectNonSuperadmin", () => $7c80326208ab9ee7$export$e924e83c232bae12);
$parcel$export(module.exports, "callerWorkspaceRole", () => $7c80326208ab9ee7$export$1b116c8bbb4ecfbf);
$parcel$export(module.exports, "routeGateKeys", () => $7c80326208ab9ee7$export$85a26a8ae7aeafad);
$parcel$export(module.exports, "routeGateBounce", () => $7c80326208ab9ee7$export$18213d2fcb697deb);
$parcel$export(module.exports, "isManager", () => $7c80326208ab9ee7$export$3dab6dfb846a0869);
$parcel$export(module.exports, "shellCanAdmin", () => $7c80326208ab9ee7$export$fddc6b0a44a1ae27);
$parcel$export(module.exports, "shellCanSuperadmin", () => $7c80326208ab9ee7$export$4830b268f60557a);
$parcel$export(module.exports, "canManage", () => $7c80326208ab9ee7$export$15469708e04353e3);
$parcel$export(module.exports, "shellCanAccessPrivate", () => $7c80326208ab9ee7$export$a530f608f0cdfc65);
$parcel$export(module.exports, "shellCanEditProfile", () => $7c80326208ab9ee7$export$61d0430d2103fe52);
$parcel$export(module.exports, "isActiveMember", () => $7c80326208ab9ee7$export$ea4361933911274e);
$parcel$export(module.exports, "groupByRole", () => $7c80326208ab9ee7$export$30a11599e39125d);
$parcel$export(module.exports, "initials", () => $7c80326208ab9ee7$export$82a129a7016c8ea8);
$parcel$export(module.exports, "rowToPerson", () => $7c80326208ab9ee7$export$6aecab3ebd55662d);
$parcel$export(module.exports, "permGateAnswer", () => $7c80326208ab9ee7$export$b51c3e7b1c125332);
$parcel$export(module.exports, "workspaceAdminGateAnswer", () => $7c80326208ab9ee7$export$8ad1f16f6e94114f);
$parcel$export(module.exports, "orgAdminGateAnswer", () => $7c80326208ab9ee7$export$f2e7557eabc90bc9);
$parcel$export(module.exports, "dataExportGateAnswer", () => $7c80326208ab9ee7$export$47beb28bb0ae4f04);
$parcel$export(module.exports, "adminRoleGateAnswer", () => $7c80326208ab9ee7$export$eb426bb2b66c7716);
$parcel$export(module.exports, "adminPageGates", () => $7c80326208ab9ee7$export$d59d3a96340d38c8);
$parcel$export(module.exports, "adminPageAccess", () => $7c80326208ab9ee7$export$16dcf45ece5bbd8c);
$parcel$export(module.exports, "adminAreaAccess", () => $7c80326208ab9ee7$export$8989fb227fb075d0);
// Role / people helpers. DB-side RLS is the real source of truth;
// these helpers exist so the UI can hide affordances ahead of the round-trip.
//
// Phase E (§I11): prefer JWT-claim permission checks
// (`hasPermission`, `canAdmin`, etc.) over role-name matching.
// Legacy `userIsAdmin` / `userIsSuperadmin` kept as the second leg of
// a union check during the dual-read migration window — matches the
// governance SQL side (see 0067_permission_based_rls.sql).
// Bare shared-library import, not a deep peopleUtils.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0). Deferred-call
// wrapper, not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");

var $hv7Tn = parcelRequire("hv7Tn");
const $7c80326208ab9ee7$var$shellFindPerson = (...args)=>(0, $1X0Je.default).functions.findPerson(...args);
// ── Phase E JWT-claim readers ────────────────────────────────────
// Live claim name is `permissions` (matches `symbols-auth-bridge` +
// `jwt_has_perm` helper). TASKS_NEEDED §62 mentions `active_permissions`
// — that's documentation drift; code authoritative.
// Capstone GATE A: route every claim read through `resolveClaims` so the
// WHOLE module reads consistent, Mongo `/auth/me`-sourced primitives. See
// claimResolver.js.
const $7c80326208ab9ee7$var$_claims = (root)=>(0, $hv7Tn.shellResolveClaims)(root);
const $7c80326208ab9ee7$export$74b261995140129d = (root)=>$7c80326208ab9ee7$var$_claims(root).permissions || [];
// True if the caller has the given permission key OR is an owner.
// Owner shortcut mirrors the SQL helper's owner-bypass.
function $7c80326208ab9ee7$export$e200ca876654e832(root, perm) {
    const r = root != null ? root : this && this.state && this.state.root;
    if (!r) return false;
    if ($7c80326208ab9ee7$var$_claims(r).is_owner) return true;
    return $7c80326208ab9ee7$export$74b261995140129d(r).includes(perm);
}
function $7c80326208ab9ee7$export$128c909470667330(user, role, root) {
    // CU-10 §90: roles are no longer on the person object. They live in
    // root.roles.byUser[userId]. We check that instead.
    if (!user) return false;
    // Legacy path: if person still has a .roles array (pre-migration client),
    // honour it during the transition window.
    if (Array.isArray(user.roles) && user.roles.length > 0) return user.roles.includes(role);
    // New path: look up the userId in root.roles.byUser.
    const r = root != null ? root : this && this.state && this.state.root;
    if (!r || !user.userId) return false;
    const assignedRole = (r.roles?.byUser || {})[user.userId];
    return assignedRole === role;
}
function $7c80326208ab9ee7$export$1f77f77e69786261(user, root) {
    return $7c80326208ab9ee7$export$128c909470667330.call(this, user, 'superadmin', root);
}
function $7c80326208ab9ee7$export$4fa022b027db4f78(user, root) {
    return $7c80326208ab9ee7$export$128c909470667330.call(this, user, 'superadmin', root) || $7c80326208ab9ee7$export$128c909470667330.call(this, user, 'admin', root);
}
function $7c80326208ab9ee7$export$2743fcd812a5361c(email, people = []) {
    if (!email) return true;
    return !people.find((p)=>p.email === email);
}
function $7c80326208ab9ee7$export$5671b2216dc5440f(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    return r ? $7c80326208ab9ee7$var$shellFindPerson(r, r.currentUserEmail) : null;
}
function $7c80326208ab9ee7$export$da10c08bc4dc3bad(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    if (!r) return false;
    // JWT-based ownership trumps the Mongo `roles.byUser` lookup. The auth
    // gates on /admin/* pages use JWT claims (isOwner / org_role / perms),
    // so the dropdown discovery link must follow the same rule — otherwise
    // legitimate owners can reach the pages directly but never see the
    // entry point. Mongo `roles.byUser` is org-membership-scoped and not
    // always seeded for owners on every org.
    const c = $7c80326208ab9ee7$var$_claims(r);
    if (c?.is_owner === true) return true;
    if ($7c80326208ab9ee7$var$_isOwnerLikeRole(c?.org_role)) return true;
    if ($7c80326208ab9ee7$var$_isOwnerLikeRole(c?.workspace_role)) return true;
    if (c?.symbols_role === 'admin' || c?.symbolsRole === 'admin') return true;
    // Mongo-derived org role from `root.org.role` (active-org OrgMember
    // role). Canonical source; bypasses stale federated JWTs per
    // SERVER-AUTH-ORGS-DRIFT-1 in tickets/server.md.
    if ($7c80326208ab9ee7$var$_isOwnerLikeRole(r.org?.role)) return true;
    return $7c80326208ab9ee7$export$4fa022b027db4f78($7c80326208ab9ee7$export$5671b2216dc5440f(r), r);
}
function $7c80326208ab9ee7$export$26fd45a3c2642bc0(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    return $7c80326208ab9ee7$export$1f77f77e69786261($7c80326208ab9ee7$export$5671b2216dc5440f(r), r);
}
function $7c80326208ab9ee7$export$fc970ed23da99565(s) {
    const root = s?.root || this && this.state && this.state.root;
    return $7c80326208ab9ee7$export$4fa022b027db4f78($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
function $7c80326208ab9ee7$export$cb73ea256889842e(startEl) {
    let cur = startEl || this;
    while(cur && !cur.routes)cur = cur.parent;
    return cur || null;
}
// WS-REDIRECT-1 (tickets/opus.md) — the "app silently navigates itself away"
// class. Root cause: every redirect gate below is re-evaluated on BOTH
// mount (onInit) AND every subsequent reactive render (onUpdate — see
// workspaceProjects.js `_guardPage`), and each gate's own "cold-load-safe"
// bail only checks that `root.people`/claims are NON-EMPTY, not that they
// describe the CURRENTLY ACTIVE org/workspace. During an org switch
// (shared/functions/switchers/switchOrg.js) `root.org` is nulled
// synchronously while `root.people` — never cleared by that pipeline — keeps
// serving the PREVIOUS org's roster for the whole async round-trip
// (getOrganization + listWorkspaces + switchWorkspace, each observed
// 1-3s), and `claimResolver.js`'s `_activeOrg` falls back to
// `root.jwtClaims.workspace_org_id` (also stale) whenever `root.org` is
// null. So a page that re-renders mid-switch computes a permission decision
// against the OUTGOING org/workspace's data and can bounce a fully
// permitted user to `/` — which, in turn, resolves against whatever
// org/workspace the router wrapper reads at THAT exact tick, landing on
// unrelated routes (the reported `/w/system/hq/chat` → `/w/system/hq`
// cycle, and the `/chat` → `/calendar` → spinner cycle on a cold boot's
// equivalent hydration window). `_wsSwitching` / `_wpSwitching` /
// `_dataLoading` are the SAME "scope not settled" flags `_isLoaderActive`
// (workspace/app.js) already gates the MainLoader on for this exact
// window — a redirect decision made while any of them is up is reading a
// scope in flux, not a resolved one, so every gate below must wait for the
// same settle signal instead of treating "non-empty" as "current".
const $7c80326208ab9ee7$var$_scopeConverging = (root)=>!!(root?._wsSwitching || root?._wpSwitching || root?._dataLoading);
function $7c80326208ab9ee7$export$e11f93c844913942(s, role) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root?.currentUserId) return false;
    if ($7c80326208ab9ee7$var$_scopeConverging(root)) return false;
    if (!Array.isArray(root.people) || !root.people.length) return false;
    const checker = role === 'superadmin' ? $7c80326208ab9ee7$export$1f77f77e69786261 : $7c80326208ab9ee7$export$4fa022b027db4f78;
    // Phase E union: permission-matching leg first so JWT-carried owners
    // and perm-granted users pass without needing a Supabase `user_roles`
    // row. Legacy role check remains as the second leg during the
    // dual-read window.
    const permKey = role === 'superadmin' ? 'admin.danger.access' : 'admin.pages.read';
    if ($7c80326208ab9ee7$export$e200ca876654e832(root, permKey)) return false;
    return !checker($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
// Phase E — permission-gated page guard. Same cold-load semantics as
// `shouldRedirectNonAdmin` but checks a specific permission key instead
// of role names. Preferred going forward.
//
// Recognises FIVE owner/admin signals, in order from strongest to
// weakest. The federated Supabase JWT can drift (SERVER-AUTH-ORGS-DRIFT-1
// in tickets/server.md — `app_metadata.is_owner` / `org_role` may not
// reflect the user's actual `OrgMember.role` if the bridge mint races
// the membership write), so we ALSO consult Mongo-derived `root.org.role`
// before falling back to the people-roles legacy leg. Otherwise users
// with valid Mongo OrgMember rows but a stale JWT get bounced from the
// admin pages they own.
const $7c80326208ab9ee7$var$_isOwnerLikeRole = (r)=>r === 'owner' || r === 'admin';
// (1)–(4) of `shouldRedirectNoPerm`: the signals that keep the page AT ONCE,
// before the roster or the org role map has landed. `permGateAnswer` reads
// the same legs, so the two can never disagree.
const $7c80326208ab9ee7$var$_permOpensEarly = (root, perm)=>{
    const claims = $7c80326208ab9ee7$var$_claims(root);
    // (1) Federated JWT — fastest path when claims are fresh.
    if (claims.is_owner) return true;
    if ($7c80326208ab9ee7$var$_isOwnerLikeRole(claims.org_role)) return true;
    if ($7c80326208ab9ee7$var$_isOwnerLikeRole(claims.workspace_role)) return true;
    // (2) Symbols-level super-admin (`symbols_role: 'admin'`). Bypasses
    //     org gates because it's a platform-wide privilege.
    if (claims.symbols_role === 'admin' || claims.symbolsRole === 'admin') return true;
    // (3) Specific permission key on the JWT.
    if ($7c80326208ab9ee7$export$e200ca876654e832(root, perm)) return true;
    // (4) Mongo source of truth — `root.org.role` is the active-org's
    //     `OrgMember.role`, populated by `subscribeAuthSession` from
    //     `/core/auth/me`'s `user.organizations[*].role`. This is the
    //     canonical source and bypasses stale federated claims.
    return $7c80326208ab9ee7$var$_isOwnerLikeRole(root.org?.role);
};
// What the final legacy leg (5) waits for: the roster, and — for the two keys
// it maps to a role — the org member-role map.
// (4b) The legacy leg reads the org member-role map (`roles.byUser`, through
//     `hasRole`), and the boot lands that map LAST: loadPrivateData
//     `_loadRoles` runs in the non-blocking tail, after the roster. On a cold
//     deep link the roster is in and the map is not; read then, the leg finds
//     no role and sends away a person whose admin role lives only in the map —
//     for good, since `routeGateBounce` sends a page away once. So the two
//     keys the leg maps to a role wait for the map: the boot declares it at
//     `version` 0, a workspace switch resets it to null, and every
//     `_loadRoles` write moves the version — a failed read included, so the
//     wait always ends (functions/roleMapGate.test.js).
const $7c80326208ab9ee7$var$_permLegacyWaits = (root, perm)=>!Array.isArray(root.people) || !root.people.length || (perm === 'admin.pages.read' || perm === 'admin.danger.access') && !(root.roles && root.roles.version > 0);
function $7c80326208ab9ee7$export$a81d7c13204c7285(s, perm) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root?.currentUserId) return false;
    // See `_scopeConverging`'s header comment above (WS-REDIRECT-1) — this
    // gate is re-run on every reactive render (workspaceProjects.js
    // `_guardPage`'s onUpdate re-check, plus admin.js's own onInit), so an
    // org/workspace switch mid-flight must not be read as a settled "no
    // permission" answer.
    if ($7c80326208ab9ee7$var$_scopeConverging(root)) return false;
    if ($7c80326208ab9ee7$var$_permOpensEarly(root, perm)) return false;
    if ($7c80326208ab9ee7$var$_permLegacyWaits(root, perm)) return false;
    // (5) Final legacy leg — `admin.pages.read` maps to admin role on
    //     the people row; explicit perms not in the claim fall through
    //     so users with `user_roles` entries but no Phase E JWT don't
    //     lose access.
    if (perm === 'admin.pages.read') return !$7c80326208ab9ee7$export$4fa022b027db4f78($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
    if (perm === 'admin.danger.access') return !$7c80326208ab9ee7$export$1f77f77e69786261($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
    return true;
}
function $7c80326208ab9ee7$export$322d0219aa8d2738(s) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root) return false;
    // Symbols-platform super-admin claim trumps the Mongo `roles.byUser`
    // legacy lookup. `symbols_role: 'admin'` (or camelCase `symbolsRole`)
    // is the platform-level super-role and bypasses org/workspace gates.
    const c = $7c80326208ab9ee7$var$_claims(root);
    if (c?.symbols_role === 'admin' || c?.symbolsRole === 'admin') return true;
    return $7c80326208ab9ee7$export$1f77f77e69786261($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
function $7c80326208ab9ee7$export$e924e83c232bae12(s) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root?.currentUserId) return false;
    // See `_scopeConverging`'s header comment above (WS-REDIRECT-1) — bail
    // while an org/workspace switch is mid-flight rather than reading a
    // scope in flux as a settled "not superadmin" answer.
    if ($7c80326208ab9ee7$var$_scopeConverging(root)) return false;
    // Platform-level claim is the fast path — Symbols staff don't need
    // a Mongo people row to administer.
    const c = $7c80326208ab9ee7$var$_claims(root);
    if (c?.symbols_role === 'admin' || c?.symbolsRole === 'admin') return false;
    // People-roster check needs the roster hydrated.
    if (!Array.isArray(root.people) || !root.people.length) return false;
    return !$7c80326208ab9ee7$export$1f77f77e69786261($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
function $7c80326208ab9ee7$export$1b116c8bbb4ecfbf(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    if (!r || !r.currentUserId || $7c80326208ab9ee7$var$_scopeConverging(r)) return undefined;
    const access = r.workspace && r.workspace.access;
    const role = access && typeof access === 'object' ? access.role : undefined;
    return typeof role === 'string' && role ? role : undefined;
}
function $7c80326208ab9ee7$export$85a26a8ae7aeafad() {
    return [
        'currentUserId',
        'currentUserEmail',
        'user',
        'jwtClaims',
        'org',
        'orgs',
        'people',
        'peopleAll',
        'roles',
        'workspace.access',
        '_wsSwitching',
        '_wpSwitching',
        '_dataLoading'
    ];
}
function $7c80326208ab9ee7$export$18213d2fcb697deb(path) {
    const el = this;
    if (!el || typeof el.router !== 'function' || el.__routeGateBounced) return;
    el.__routeGateBounced = true;
    const routeRoot = el.call('findRouteRoot', el) || el.getRoot();
    el.router(path || '/', routeRoot, {}, {
        pushState: true
    });
}
function $7c80326208ab9ee7$export$3dab6dfb846a0869(s) {
    const root = s?.root || this && this.state && this.state.root;
    const user = $7c80326208ab9ee7$export$5671b2216dc5440f(root);
    return $7c80326208ab9ee7$export$128c909470667330(user, 'manager', root) || $7c80326208ab9ee7$export$4fa022b027db4f78(user, root);
}
function $7c80326208ab9ee7$export$fddc6b0a44a1ae27(s) {
    const root = s?.root || this && this.state && this.state.root;
    return $7c80326208ab9ee7$export$e200ca876654e832(root, 'admin.pages.read') || $7c80326208ab9ee7$export$4fa022b027db4f78($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
function $7c80326208ab9ee7$export$4830b268f60557a(s) {
    const root = s?.root || this && this.state && this.state.root;
    return $7c80326208ab9ee7$export$e200ca876654e832(root, 'admin.danger.access') || $7c80326208ab9ee7$export$1f77f77e69786261($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
function $7c80326208ab9ee7$export$15469708e04353e3(s) {
    const root = s?.root || this && this.state && this.state.root;
    if ($7c80326208ab9ee7$export$e200ca876654e832(root, 'member.update_role')) return true;
    const user = $7c80326208ab9ee7$export$5671b2216dc5440f(root);
    return $7c80326208ab9ee7$export$128c909470667330(user, 'manager', root) || $7c80326208ab9ee7$export$4fa022b027db4f78(user, root);
}
function $7c80326208ab9ee7$export$a530f608f0cdfc65(sOrPerson, maybePerson) {
    let root, person;
    if (maybePerson !== undefined) {
        root = sOrPerson?.root || this && this.state && this.state.root;
        person = maybePerson;
    } else {
        root = this && this.state && this.state.root;
        person = sOrPerson;
    }
    if (!root) return true;
    const isSelfUser = !person?.email || person.email === root.currentUserEmail;
    if (isSelfUser) return true;
    if ($7c80326208ab9ee7$export$e200ca876654e832(root, 'profile.private.read')) return true;
    return $7c80326208ab9ee7$export$1f77f77e69786261($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
function $7c80326208ab9ee7$export$61d0430d2103fe52(sOrPerson, maybePerson) {
    let root, person;
    if (maybePerson !== undefined) {
        root = sOrPerson?.root || this && this.state && this.state.root;
        person = maybePerson;
    } else {
        root = this && this.state && this.state.root;
        person = sOrPerson;
    }
    if (!root) return false;
    const isSelfUser = !person?.email || person.email === root.currentUserEmail;
    if (isSelfUser) return true;
    if ($7c80326208ab9ee7$export$e200ca876654e832(root, 'profile.edit_others')) return true;
    return $7c80326208ab9ee7$export$1f77f77e69786261($7c80326208ab9ee7$export$5671b2216dc5440f(root), root);
}
function $7c80326208ab9ee7$export$ea4361933911274e(s) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root || !root.signedIn) return false;
    const people = root.people || [];
    const email = root.currentUserEmail;
    if (!email || !people.find((p)=>p.email === email)) return false;
    // CU-10 §90: roles.available dropped with public.roles view (migration 0087).
    // Any signed-in org member is considered active regardless of role.
    return true;
}
function $7c80326208ab9ee7$export$30a11599e39125d(people) {
    const root = this && this.state && this.state.root;
    const available = root?.roles?.available || [];
    // CU-10 §90: role from root.roles.byUser[userId]; fallback to p.roles for legacy data.
    const byUser = root?.roles?.byUser || {};
    const groups = {};
    for (const p of people || []){
        const legacyRoles = Array.isArray(p.roles) && p.roles.length > 0 ? p.roles : null;
        const role = legacyRoles ? legacyRoles[0] : byUser[p.userId] || 'member';
        if (!groups[role]) groups[role] = [];
        groups[role].push(p);
    }
    // Order by the roles enum order, then any extras
    const ordered = available.length ? available.map((r)=>r.name) : [
        'superadmin',
        'admin',
        'manager',
        'member',
        'advisor',
        'investor'
    ];
    return ordered.filter((r)=>groups[r]?.length).map((r)=>{
        const meta = available.find((m)=>m.name === r) || {};
        return {
            role: r,
            label: meta.label || r.replace(/^./, (c)=>c.toUpperCase()),
            color: meta.color || 'gray',
            users: groups[r].sort((a, b)=>(a.name || '').localeCompare(b.name || ''))
        };
    });
}
const $7c80326208ab9ee7$export$82a129a7016c8ea8 = (name)=>(name || '').split(/\s+/).filter(Boolean).slice(0, 2).map((p)=>p[0]).join('').toUpperCase();
const $7c80326208ab9ee7$export$6aecab3ebd55662d = (r)=>({
        // user_id MUST be carried through — MemberProfile's _patchUser bails out
        // (`if (!person?.userId) return`) when it's missing, silently dropping every
        // Settings save. This mapper feeds root.people via the page boilerplate
        // fetch (calendar/chat/meet/tickets/features), so without userId, opening
        // /settings after any of those pages makes profile edits no-op. Keep this
        // in sync with loadPrivateData._person (the shell's mapper, which already
        // includes userId). Fixes "Setting information is not saved".
        userId: r.user_id,
        name: r.name,
        email: r.email,
        avatar: r.avatar,
        // The monogram letters, as the shell's own mapper carries them
        // (loadPrivateData._person): the photo field is a URL or nothing.
        initials: $7c80326208ab9ee7$export$82a129a7016c8ea8(r.name),
        position: r.position,
        location: r.location,
        country: r.country,
        city: r.city,
        timezone: r.timezone,
        github: r.github || r.github_username,
        weeklyHours: r.weekly_hours,
        workingDays: r.working_days,
        workingHours: {
            start: r.working_hours_start,
            end: r.working_hours_end
        },
        // CU-10 §90: roles/isAdmin removed from people view. Role data lives in
        // root.roles.byUser[userId] (server GET /auth/org/:orgId/member-roles).
        origin_valuation: r.origin_valuation
    });
function $7c80326208ab9ee7$export$b51c3e7b1c125332(s, perm) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root?.currentUserId || $7c80326208ab9ee7$var$_scopeConverging(root)) return 'pending';
    if ($7c80326208ab9ee7$var$_permOpensEarly(root, perm)) return 'open';
    if ($7c80326208ab9ee7$var$_permLegacyWaits(root, perm)) return 'pending';
    return $7c80326208ab9ee7$export$a81d7c13204c7285.call(this, s || {
        root: root
    }, perm) ? 'closed' : 'open';
}
function $7c80326208ab9ee7$export$8ad1f16f6e94114f(root) {
    const role = $7c80326208ab9ee7$export$1b116c8bbb4ecfbf.call(this, root);
    if (role === undefined) return 'pending';
    return role === 'owner' || role === 'admin' ? 'open' : 'closed';
}
function $7c80326208ab9ee7$export$f2e7557eabc90bc9(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    const role = r && r.currentUserId && r.org && r.org.role;
    if (!role) return 'pending';
    return [
        'owner',
        'co-owner',
        'admin',
        'maintainer'
    ].indexOf(role) >= 0 ? 'open' : 'closed';
}
function $7c80326208ab9ee7$export$47beb28bb0ae4f04(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    const claims = r && r.jwtClaims || {};
    const orgRole = r && r.org && r.org.role;
    if (!(r && r.currentUserId && (orgRole || claims.workspace_role))) return 'pending';
    if (orgRole === 'owner' || orgRole === 'co-owner' || orgRole === 'admin') return 'open';
    if (claims.is_owner) return 'open';
    return claims.workspace_role === 'owner' || claims.workspace_role === 'admin' ? 'open' : 'closed';
}
function $7c80326208ab9ee7$export$eb426bb2b66c7716(s) {
    const root = s?.root || this && this.state && this.state.root;
    if (!root?.currentUserId || $7c80326208ab9ee7$var$_scopeConverging(root)) return 'pending';
    if (!Array.isArray(root.people) || !root.people.length) return 'pending';
    return $7c80326208ab9ee7$export$e11f93c844913942.call(this, s || {
        root: root
    }) ? 'closed' : 'open';
}
function $7c80326208ab9ee7$export$d59d3a96340d38c8() {
    return {
        '/admin': [
            'perm',
            'admin.pages.read'
        ],
        '/admin/workspace-settings': [
            'workspace'
        ],
        '/admin/teams': [
            'perm',
            'admin.team_permissions'
        ],
        '/admin/permissions': [
            'perm',
            'admin.team_permissions'
        ],
        '/admin/dashboard-defaults': [
            'workspace'
        ],
        '/admin/domains': [
            'org'
        ],
        '/admin/branding': [
            'org'
        ],
        '/admin/data': [
            'export'
        ],
        '/admin/danger': [
            'perm',
            'admin.danger.access'
        ],
        '/admin/usage': [
            'perm',
            'admin.pages.read'
        ],
        '/admin/analytics': [
            'perm',
            'admin.pages.read'
        ],
        '/admin/logs': [
            'perm',
            'admin.pages.read'
        ],
        '/admin/activity-scoring': [
            'perm',
            'admin.pages.read'
        ],
        '/admin/integrations': [
            'perm',
            'admin.pages.read'
        ],
        '/admin/mail': [
            'org'
        ],
        '/admin/module': [
            'workspace'
        ],
        '/admin/flags': [
            'admin'
        ],
        '/admin/status': [
            'perm',
            'admin.pages.read'
        ],
        '/admin/system': [
            'perm',
            'admin.pages.read'
        ],
        '/data/external': [
            'none'
        ]
    };
}
function $7c80326208ab9ee7$export$16dcf45ece5bbd8c(root, href) {
    const r = root != null ? root : this && this.state && this.state.root;
    const s = {
        root: r
    };
    const gate = $7c80326208ab9ee7$export$d59d3a96340d38c8()[String(href || '').split('?')[0]];
    if (!gate) return undefined;
    if (gate[0] === 'none') return 'open';
    if (gate[0] === 'perm') return $7c80326208ab9ee7$export$b51c3e7b1c125332.call(this, s, gate[1]);
    if (gate[0] === 'workspace') return $7c80326208ab9ee7$export$8ad1f16f6e94114f.call(this, r);
    if (gate[0] === 'org') return $7c80326208ab9ee7$export$f2e7557eabc90bc9.call(this, r);
    if (gate[0] === 'export') return $7c80326208ab9ee7$export$47beb28bb0ae4f04.call(this, r);
    return $7c80326208ab9ee7$export$eb426bb2b66c7716.call(this, s);
}
function $7c80326208ab9ee7$export$8989fb227fb075d0(root) {
    const r = root != null ? root : this && this.state && this.state.root;
    const answers = Object.keys($7c80326208ab9ee7$export$d59d3a96340d38c8()).filter((href)=>href.indexOf('/admin') === 0).map((href)=>$7c80326208ab9ee7$export$16dcf45ece5bbd8c.call(this, r, href));
    if (answers.indexOf('open') >= 0) return 'open';
    return answers.indexOf('pending') >= 0 ? 'pending' : 'closed';
}

});

parcelRegister("gvbDt", function(module, exports) {

$parcel$export(module.exports, "BACKED_RECORD_ENTITIES", () => $c038913017ec1b6f$export$79da00f2f2877abf);
$parcel$export(module.exports, "buildExtensionDataBridge", () => $c038913017ec1b6f$export$5f4977df3e1524c8);
$parcel$export(module.exports, "extensionEntitySupport", () => $c038913017ec1b6f$export$d0459652b3be991e);
$parcel$export(module.exports, "auditExtensionSource", () => $c038913017ec1b6f$export$5af230962a19b76e);
$parcel$export(module.exports, "declaredEntitiesFromSpec", () => $c038913017ec1b6f$export$1f48bb9272332a27);
// extensionDataBridge.js — capability-scoped data access for AI-generated
// workspace extensions (the /add-app self-serving builder).
//
// SECURITY MODEL (per Nika "make it safe and secure"): a generated extension
// renders in an ISOLATED iframe (createIframeApp) and must NOT get the raw
// Supabase client or the workspace's full SDK. Instead it gets a NARROWED `sdk`
// fetch-adapter executor that:
//
//   1. Only routes through `sdk.execute(from, op, args)` — the SDK transport,
//      which is workspace-pinned + RLS-enforced server-side (CLAUDE.md
//      "SDK-Only Backend Access"). No raw fetch / no Supabase client.
//   2. Rejects any entity (`from`) NOT in the extension's declared allow-list.
//      A build spec declares its data surface; anything off-list is denied so a
//      generated app can't read/write data it never asked for.
//   3. Forces every entity into the `workspaceProject.*` namespace — the only
//      namespace that is workspace-scoped. An extension can never reach
//      `organization.*`, `admin.*`, `auth.*`, `payment.*`, etc.
//   4. Allows only data ops (list/get/create/update/upsert/remove + subscribe).
//      Never rpc to arbitrary procedures, never auth/session ops.
//
// The result is a `fetch:` config (`{ adapter: 'sdk', executor }`) you hand to
// createIframeApp via `data.fetch`, so the extension's declarative
// `fetch: [{ from: 'policies', method: 'list' }]` declarations resolve through
// the scoped executor. Declared `from` values are bare entity names (e.g.
// 'policies'); the bridge namespaces them to `workspaceProject.policies`.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $c038913017ec1b6f$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// Data ops an extension may invoke. Everything else (rpc, auth, custom procs)
// is denied. Mirrors the fetch plugin's verb set the sdk adapter supports.
//
// Named distinctly from `moduleDataBridge.js`'s identical-VALUE `ALLOWED_OPS`
// — two top-level consts sharing one name get esbuild-renamed in the merged
// bundle (`ALLOWED_OPS`/`ALLOWED_OPS2`), leaving this file's own read owned
// by no declaration frank's checker could attribute (correct by luck of
// file-processing order, not guaranteed). A locally-unique name removes the
// collision entirely.
const $c038913017ec1b6f$var$EXTENSION_ALLOWED_OPS = new Set([
    'list',
    'get',
    'create',
    'update',
    'upsert',
    'remove',
    'subscribe'
]);
// Entities EVERY extension may read regardless of its declared surface — the
// shared, low-risk workspace context an extension commonly needs to render
// (the people directory for assignee pickers, the active workspace settings for
// theme, and `audience` — the members a page may notify by ref, as the server
// answers them: { ref, name, avatar }, no address, no id — SDK
// workspaceProject.audience → GET /notifications/audience). Read-only is
// enforced below for these.
const $c038913017ec1b6f$var$AMBIENT_READONLY_ENTITIES = new Set([
    'people',
    'workspaceSettings',
    'audience'
]);
const $c038913017ec1b6f$export$79da00f2f2877abf = new Set([
    // Generic record store (migration 0163, workspaceProject.records) — the
    // canonical home for AI-generated record types (policies, claims, …) keyed by
    // a `collection` namespace. New domain types persist here with no new table.
    'records',
    'tickets',
    'documents',
    'calendar',
    'announcements',
    'standups',
    'activity',
    'notifications'
]);
// Strip the namespace if the model already wrote one, so 'workspaceProject.x',
// 'x', and a stray 'public.x' all normalize to the bare entity name we gate on.
const $c038913017ec1b6f$var$_bareEntity = (from)=>{
    const s = String(from || '').trim();
    if (!s) return '';
    const dot = s.lastIndexOf('.');
    return (dot >= 0 ? s.slice(dot + 1) : s).toLowerCase();
};
// Normalize a declared-entities input to a deduped Set of bare names — the one
// place the raw input is processed; everything downstream uses the Set (O(1)
// membership, no per-call re-mapping).
const $c038913017ec1b6f$var$_toEntitySet = (declaredEntities)=>new Set((Array.isArray(declaredEntities) ? declaredEntities : []).map($c038913017ec1b6f$var$_bareEntity).filter(Boolean));
const $c038913017ec1b6f$export$5f4977df3e1524c8 = (declaredEntities = [], { getSdkFn: getSdkFn = $c038913017ec1b6f$var$shellGetSDK } = {})=>{
    // Normalize ONCE. `declared` = what the extension explicitly asked for (write-
    // capable); `allowed` = declared + ambient read-only entities (always
    // reachable for reads so an app can render people/settings without declaring).
    const declared = $c038913017ec1b6f$var$_toEntitySet(declaredEntities);
    const allowed = new Set([
        ...declared,
        ...$c038913017ec1b6f$var$AMBIENT_READONLY_ENTITIES
    ]);
    const WRITE_OPS = new Set([
        'create',
        'update',
        'upsert',
        'remove'
    ]);
    const executor = (from, op, args, cb)=>{
        const entity = $c038913017ec1b6f$var$_bareEntity(from);
        const operation = String(op || '').toLowerCase();
        if (!$c038913017ec1b6f$var$EXTENSION_ALLOWED_OPS.has(operation)) return Promise.reject(new Error(`[extension] operation "${op}" is not permitted.`));
        if (!entity || !allowed.has(entity)) return Promise.reject(new Error(`[extension] entity "${from}" is not in this extension's declared data surface.`));
        // Ambient entities are READ-ONLY — a generated app can read the people
        // directory but never write to it unless it EXPLICITLY declared it (O(1)).
        if (WRITE_OPS.has(operation) && $c038913017ec1b6f$var$AMBIENT_READONLY_ENTITIES.has(entity) && !declared.has(entity)) return Promise.reject(new Error(`[extension] writes to "${entity}" are not permitted.`));
        const sdk = getSdkFn ? getSdkFn() : null;
        if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[extension] SDK unavailable.'));
        // Force the workspace-scoped namespace. This is the hard wall: an extension
        // can ONLY ever touch workspaceProject.* — never organization/admin/auth/…
        // The token this rides (sdk's _workspaceTokenProvider) reads the workspace
        // access token from storage with a fallback — no governance-federation
        // dependency (that plane is retired).
        return sdk.execute(`workspaceProject.${entity}`, operation, args, cb);
    };
    return {
        allowed: [
            ...allowed
        ],
        // Which declared entities are actually server-backed (writes persist) vs
        // not-yet-backed (gated + namespaced, but the dispatcher will reject until
        // the server registers the route). Lets the builder surface honest status.
        support: $c038913017ec1b6f$var$_entitySupport(declared),
        fetch: {
            adapter: 'sdk',
            executor: executor
        }
    };
};
// Split a Set of bare entity names into { backed, unbacked } by backing status.
const $c038913017ec1b6f$var$_entitySupport = (declaredSet)=>{
    const backed = [];
    const unbacked = [];
    for (const e of declaredSet)if ($c038913017ec1b6f$export$79da00f2f2877abf.has(e) || $c038913017ec1b6f$var$AMBIENT_READONLY_ENTITIES.has(e)) backed.push(e);
    else unbacked.push(e);
    return {
        backed: backed,
        unbacked: unbacked
    };
};
const $c038913017ec1b6f$export$d0459652b3be991e = (declaredEntities = [])=>$c038913017ec1b6f$var$_entitySupport($c038913017ec1b6f$var$_toEntitySet(declaredEntities));
// ── Static audit gate ────────────────────────────────────────────────────────
// Runtime safety net BEFORE a generated extension's DOMQL is eval'd + mounted.
// The cloud build agent SHOULD already constrain output, and the iframe realm
// isolates it — but defense-in-depth: reject source that reaches for raw
// network/storage/eval primitives instead of the scoped declarative `fetch:`
// surface. A generated extension has NO legitimate need for these; their
// presence means the model went off the rails (or the source was tampered
// with). Returns { ok: true } or { ok: false, error, violations: [...] }.
//
// This is a string/source scan, deliberately conservative: it can have false
// positives on legitimately-named props, so the patterns are tightened to the
// dangerous call forms (e.g. `fetch(` not the word "fetch", which the
// declarative `fetch:` array legitimately uses as a KEY, not a call).
const $c038913017ec1b6f$var$FORBIDDEN_PATTERNS = [
    {
        re: /\beval\s*\(/,
        label: 'eval()'
    },
    {
        re: /\bnew\s+Function\b/,
        label: 'new Function'
    },
    {
        re: /\bFunction\s*\(/,
        label: 'Function()'
    },
    {
        re: /\bfetch\s*\(/,
        label: "raw fetch() \u2014 use the declarative fetch: array"
    },
    {
        re: /\bXMLHttpRequest\b/,
        label: 'XMLHttpRequest'
    },
    {
        re: /\bWebSocket\b/,
        label: 'WebSocket'
    },
    {
        re: /\bimport\s*\(/,
        label: 'dynamic import()'
    },
    {
        re: /\bdocument\s*\.\s*cookie\b/,
        label: 'document.cookie'
    },
    {
        re: /\blocalStorage\b/,
        label: 'localStorage'
    },
    {
        re: /\bsessionStorage\b/,
        label: 'sessionStorage'
    },
    {
        re: /\bindexedDB\b/,
        label: 'indexedDB'
    },
    {
        re: /\bnavigator\s*\.\s*sendBeacon\b/,
        label: 'navigator.sendBeacon'
    },
    // Reaching for the parent realm / shell root to escape the iframe sandbox.
    {
        re: /\bwindow\s*\.\s*(parent|top|opener)\b/,
        label: 'window.parent/top/opener'
    },
    {
        re: /\b__wsRoot\b/,
        label: '__wsRoot (shell escape)'
    },
    {
        re: /\b__addAppHost\b/,
        label: '__addAppHost (shell escape)'
    },
    {
        re: /\bpostMessage\s*\(/,
        label: 'postMessage'
    },
    // Direct DB/SDK reach-around the scoped bridge.
    {
        re: /\bcreateClient\s*\(/,
        label: 'createClient (raw Supabase)'
    },
    {
        re: /\bgetSupabase\b/,
        label: 'getSupabase'
    },
    {
        re: /\bel\s*\.\s*sdk\b/,
        label: 'el.sdk (use the declarative fetch: array)'
    }
];
const $c038913017ec1b6f$export$5af230962a19b76e = (source)=>{
    const text = String(source || '');
    if (!text.trim()) return {
        ok: false,
        error: 'empty source',
        violations: [
            'empty'
        ]
    };
    const violations = [];
    for (const { re: re, label: label } of $c038913017ec1b6f$var$FORBIDDEN_PATTERNS)if (re.test(text)) violations.push(label);
    if (violations.length) return {
        ok: false,
        error: 'Generated extension uses unsafe patterns and was blocked: ' + violations.join(', ') + '. Extensions must use the declarative fetch: array for data and may not reach raw network/storage/eval.',
        violations: violations
    };
    return {
        ok: true
    };
};
const $c038913017ec1b6f$export$1f48bb9272332a27 = (spec)=>{
    if (!spec || typeof spec !== 'object') return [];
    const raw = spec.entities || spec.dataEntities || spec.data?.entities || spec.capabilities?.entities || [];
    if (!Array.isArray(raw)) return [];
    // Accept ['policies'] or [{ name: 'policies' }] shapes.
    return raw.map((e)=>typeof e === 'string' ? e : e && (e.name || e.entity || e.from)).filter(Boolean);
};

});

parcelRegister("ggoif", function(module, exports) {

$parcel$export(module.exports, "generatedAppAllowlist", () => $bd70fc20703b357c$export$530d3d369fbdee05);
$parcel$export(module.exports, "generatedAppRootKeys", () => $bd70fc20703b357c$export$ec6d3a4c91e33e8a);
$parcel$export(module.exports, "scopeGeneratedAppFunctions", () => $bd70fc20703b357c$export$880c27094d9020db);
$parcel$export(module.exports, "generatedAppViolationHint", () => $bd70fc20703b357c$export$4ca53680afd9d74f);
$parcel$export(module.exports, "parseGeneratedAppSource", () => $bd70fc20703b357c$export$b9f4e66a01c6e85d);
$parcel$export(module.exports, "auditGeneratedAppSource", () => $bd70fc20703b357c$export$d3c96cde1ea6181e);
$parcel$export(module.exports, "GENERATED_APP_BLOCKED", () => (parcelRequire("7iHfb")).GENERATED_APP_BLOCKED);
// generatedAppContainment.js — the AST gate for AI-generated workspace apps.
//
// The rules are data in generatedAppRules.js (the server reads the same file).
// This module parses the EXACT text the freestyle parser evaluates (acorn — a
// runtime dependency of the shared package already, no regex) and refuses:
//   • any free identifier outside GENERATED_APP_GLOBALS (window, self, top,
//     frames, opener, document, fetch, Function, eval, … fall out by
//     construction), resolved per lexical scope so a local `let self` in one
//     function never hides a global `self` in another; `arguments` always;
//   • GENERATED_APP_BLOCKED_MEMBERS as a member, a destructured key or a
//     literal computed key, any `__`-prefixed member, `.apply` / `.bind`, and
//     a computed member key that is not a literal;
//   • `.call` anywhere except `x.call('<allowlisted literal>', …)`;
//   • on an EVENT handle (first parameter of a DOMQL `on<Event>` handler) any
//     member outside GENERATED_APP_EVENT_MEMBERS (`e.view` is the window), and
//     on `e.target` any member outside GENERATED_APP_TARGET_MEMBERS;
//   • on an ELEMENT handle (`el`, `this`) any member outside
//     GENERATED_APP_ELEMENT_MEMBERS — in-shell every shell method is a
//     property of every element, `el.sdk` included;
//   • a handle that escapes: an event / element / `this` may only be the object
//     of a member read or an argument to an allowlisted `el.call`;
//   • `x.root` not followed by a key that passes the seed deny list, and any
//     write (assignment, update, delete, state write method) under a `.root`
//     chain — in-shell `s.root` is the LIVE workspace root;
//   • reflective members of globals (Object.getPrototypeOf, …) and string
//     literals naming GENERATED_APP_BLOCKED_STRINGS;
//   • `with`, tagged templates, `import()`, `import.meta`, `new.target`,
//     setTimeout / setInterval with anything but a function;
//   • and the same inside any string that parses as a function (a
//     JSON-authored source carries its handlers as strings that the parser
//     destringifies and evaluates).
// The auditor itself is @symbo.ls/app-rules (smbls packages/app-rules), pinned
// in package.json: generatedAppAudit.js + generatedAppRules.js are exact
// copies of its src/audit.js + src/rules.js (only the import path differs);
// generatedAppContainment.test.js holds them equal to the installed package. This
// module keeps the WORKSPACE half: the allowlist / readable root keys / live
// registry it hands the audit, the iframe registry, and the parse wrapper.

var $cmUBA = parcelRequire("cmUBA");

var $lo3nm = parcelRequire("lo3nm");

var $7iHfb = parcelRequire("7iHfb");
// Every rule generatedAppAudit.js reads off its `appRules` namespace, with its type
// (generatedAppContainment.test.js holds this list equal to the audit's reads).
// The audit is only as good as `appRules`: when a build mis-binds the namespace
// (measured 2026-10-03 — frank bound the shell's `R` to an inlined library's
// minified helper `function R(n)`, so `R.GENERATED_APP_BLOCKED_PREFIX` read
// undefined and `el.__ref` passed), a missing list is an EMPTY list and the
// audit fails OPEN. So every entry point checks the shape first and refuses
// when it does not hold — fail closed, never open.
const $bd70fc20703b357c$var$GENERATED_APP_RULE_SHAPE = Object.freeze({
    APP_EL_CALL_ALLOWLIST: 'list',
    GENERATED_APP_BLOCKED_MEMBERS: 'list',
    GENERATED_APP_BLOCKED_STRINGS: 'list',
    GENERATED_APP_BLOCKED_INDIRECTION: 'list',
    GENERATED_APP_BLOCKED_PREFIX: 'text',
    GENERATED_APP_GLOBALS: 'list',
    GENERATED_APP_GLOBAL_MEMBERS: 'map',
    GENERATED_APP_EVENT_MEMBERS: 'list',
    GENERATED_APP_EVENT_VALUE_MEMBERS: 'list',
    GENERATED_APP_TARGET_MEMBERS: 'list',
    GENERATED_APP_TARGET_VALUE_MEMBERS: 'list',
    GENERATED_APP_TARGET_DEEP_MEMBERS: 'list',
    GENERATED_APP_TARGET_DEEP_CHAIN: 'map',
    GENERATED_APP_ELEMENT_MEMBERS: 'list',
    GENERATED_APP_LIFECYCLE_HANDLERS: 'list',
    GENERATED_APP_ROOT_DENY_KEYS: 'list',
    GENERATED_APP_ROOT_DENY_PATTERN: 'text',
    GENERATED_APP_ROOT_WRITE_METHODS: 'list',
    GENERATED_APP_TAG_ALLOWLIST: 'list',
    GENERATED_APP_COMPONENT_ALLOWLIST: 'list',
    GENERATED_APP_COMPONENT_DENYLIST: 'list',
    GENERATED_APP_MARKUP_KEYS: 'list',
    GENERATED_APP_URL_KEYS: 'list',
    GENERATED_APP_URL_SCHEMES: 'list',
    GENERATED_APP_CSS_URL_KEYS: 'list',
    GENERATED_APP_SRC_DATA_PREFIX: 'text'
});
const $bd70fc20703b357c$export$6f131d8b1bd74e2b = (rules = $cmUBA)=>{
    try {
        if (!rules || typeof rules !== 'object') return false;
        for (const [key, kind] of Object.entries($bd70fc20703b357c$var$GENERATED_APP_RULE_SHAPE)){
            const v = rules[key];
            if (kind === 'list') {
                if (!Array.isArray(v) || v.length === 0 || !v.every((x)=>typeof x === 'string')) return false;
            } else if (kind === 'text') {
                if (typeof v !== 'string' || v.length === 0) return false;
            } else if (!v || typeof v !== 'object' || Array.isArray(v)) return false;
        }
        return true;
    } catch (_) {
        return false;
    }
};
// The el.call names a page may use: THE one list (generatedAppRules.js
// APP_EL_CALL_ALLOWLIST, the server's list). `root` is accepted for callers
// and ignored: no module loader, AI verb or app-local function joins it.
// Rules that did not load allow nothing.
//
// The body sits in a module helper because generatedAppAllowlist is ALSO a
// shell function entry (el.call): frank emits a function entry that names the
// `appRules` namespace as a value with a free `generatedAppRules_exports` identifier
// (a ReferenceError when called), while a lifted helper reaches `appRules` through
// its scope (workspacePushEmission.test.js holds both forms).
const $bd70fc20703b357c$var$_allowlistFromRules = ()=>$bd70fc20703b357c$export$6f131d8b1bd74e2b($cmUBA) ? [
        ...$cmUBA.APP_EL_CALL_ALLOWLIST
    ] : [];
const $bd70fc20703b357c$export$530d3d369fbdee05 = (root)=>$bd70fc20703b357c$var$_allowlistFromRules();
const $bd70fc20703b357c$export$ec6d3a4c91e33e8a = (root)=>{
    const project = root && root.workspaceProject;
    const keys = new Set(Array.isArray(project && project.stateKeys) ? project.stateKeys : []);
    const loaders = project && project.loaders && typeof project.loaders === 'object' ? project.loaders : {};
    for (const meta of Object.values(loaders))for (const k of Array.isArray(meta && meta.writes) ? meta.writes : [])keys.add(k);
    return [
        ...keys
    ];
};
const $bd70fc20703b357c$export$880c27094d9020db = (functions, allow)=>{
    const out = {};
    if (!functions) return out;
    for (const name of allow)if (typeof functions[name] === 'function') out[name] = functions[name];
    return out;
};
const $bd70fc20703b357c$var$_rootStateOf = (el)=>el && el.getRootState && el.getRootState() || el && el.state && (el.state.root || el.state) || el && el.getRoot && el.getRoot() && el.getRoot().state || null;
function $bd70fc20703b357c$export$4ca53680afd9d74f(violations, extra = {}) {
    const list = Array.isArray(violations) ? violations : [];
    const rules = new Set(list.map((v)=>v && v.rule).filter(Boolean));
    const named = (rule)=>[
            ...new Set(list.filter((v)=>v && v.rule === rule && v.detail && !/^\(/.test(String(v.detail))).map((v)=>String(v.detail)))
        ].slice(0, 6);
    const parts = [];
    if (rules.has('component_not_allowed')) {
        const names = named('component_not_allowed');
        parts.push((names.length ? names.join(', ') + ': ' : '') + "not on the list of components a generated view mounts (an installed app\u2019s own " + "components never are) \u2014 build it from Flex, Grid, Box, Text, Hgroup, Icon, Img, Link " + 'and Button (and the components the source defines in its own `components:`), with ' + 'literal `extends` names.');
    }
    // ANSWER-VIEW-UNABLE-TO-CREATE-THE-SUMMARY-VIEW-1 — measured on dev
    // 2026-10-05 (Storm Validators, "why is this amber?"): the view put each
    // row's shape in an inline `childExtends: { … }` object and keyed its data
    // by `node` (`{ node: 'storm-chi-1' }`, `s.node`). Told only "literal
    // `extends` names" and "no `node`", the model read a technical failure and
    // gave up. Each refusal now names its fix.
    if (list.some((v)=>v && v.rule === 'component_not_allowed' && v.detail === '(computed)')) parts.push("`extends` / `childExtends` take a quoted component NAME (or a list of names) \u2014 never an inline object or an expression. To shape every child alike, write the source as `{ components: { FleetRow: { extends: 'Flex', \u2026 } }, page: { \u2026, childExtends: 'FleetRow' } }` with a distinctive name of your own.");
    if (rules.has('blocked-key') || rules.has('blocked-member')) {
        const names = [
            ...new Set([
                ...named('blocked-key'),
                ...named('blocked-member')
            ])
        ];
        parts.push((names.length ? names.join(', ') + ': ' : '') + "a generated view never reaches the DOM, the window or the shell \u2014 no `node`, " + '`document`, `window` or storage; use DOMQL props, `text`, `children` and state.');
        // A refused OBJECT KEY is the view's own data or prop name — a reserved
        // word everywhere in the source, not only on an element.
        const keys = named('blocked-key');
        if (keys.length) parts.push(keys.map((k)=>'`' + k + '`').join(', ') + " is reserved even as a data field or a state key \u2014 rename it everywhere it " + "appears, in the data and where it is read (`{ node: 'x' }` / `s.node` \u2192 " + "`{ host: 'x' }` / `s.host`).");
    }
    if (rules.has('computed-key')) parts.push('Object keys and member names must be literal names, never computed.');
    // A url-capable style key (background, backgroundImage, mask, cursor, …)
    // takes a LITERAL only — a function / template that computes it is refused
    // ('css-url', or 'url-dynamic' when JSON-authored) since it could form a
    // url(). Measured on dev 2026-10-05 (Storm, "treasury share bars"): three
    // refusals for `background: (el, s) => s.barColor`, told only "no url()" or
    // nothing, and the model gave up. A per-row colour has a dynamic home.
    const cssUrlKeys = new Set($cmUBA.GENERATED_APP_CSS_URL_KEYS || []);
    const styleUrl = [
        ...new Set(list.filter((v)=>v && (v.rule === 'css-url' || v.rule === 'url-dynamic') && cssUrlKeys.has(String(v.detail))).map((v)=>String(v.detail)))
    ];
    // a literal url() to an unsafe address (the detail is not a key)
    if (list.some((v)=>v && v.rule === 'css-url' && !cssUrlKeys.has(String(v.detail)))) parts.push("No url() in styles \u2014 use design-system tokens and Img with a src.");
    if (styleUrl.length) parts.push(styleUrl.join(', ') + ": a style key that can carry url() takes a literal value only \u2014 no url() to an " + 'unsafe address and no function or template that computes it. For a colour ' + 'computed per row use `backgroundColor` (or `color`, `borderColor`), which may be ' + 'a function.');
    const linkUrl = named('url-dynamic').filter((k)=>!cssUrlKeys.has(k));
    if (linkUrl.length) parts.push(linkUrl.join(', ') + ': a link or image address is a literal (https:, a relative path), a ' + 'same-origin path with the row appended to a leading literal ' + "('/chains/chain?id=' + r.id), or an icon name \u2014 never a bare row field, " + "never a function, and never '//' or another origin with the row appended.");
    // GENERATED-VIEW-STYLE-LINT-1 — sizes and colours that render nothing.
    if (rules.has('unitless-size')) {
        const at = [
            ...new Set(list.filter((v)=>v && v.rule === 'unitless-size').map((v)=>v.at))
        ].slice(0, 6);
        parts.push((at.length ? at.join(', ') + ': ' : '') + "a bare number is not a size and renders nothing \u2014 use a spacing token " + "('X', 'Y', 'Z', 'A', 'B2') or a CSS length with its unit ('8px', '50%').");
    }
    // GENERATED-VIEW-SIZE-WORD-1 — `size: 'xl'` on a heading boxed its text in
    // a one-letter-tall box; the lines overflowed onto the next one.
    if (rules.has('size-word')) {
        const at = [
            ...new Set(list.filter((v)=>v && v.rule === 'size-word').map((v)=>v.at))
        ].slice(0, 6);
        parts.push((at.length ? at.join(', ') + ': ' : '') + "`size` sets the box (width and height), never the type size \u2014 a word like " + "'xl' squeezes the text into a tiny box and it spills over the line below. A type " + "size is `fontSize` with a type token ('Z', 'A', 'B', 'C'); drop `size` from text.");
    }
    // GENERATED-VIEW-GRID-COLS-1 — `cols: 2` on a Grid drew one column.
    if (rules.has('grid-cols')) {
        const at = [
            ...new Set(list.filter((v)=>v && v.rule === 'grid-cols').map((v)=>v.at))
        ].slice(0, 6);
        parts.push((at.length ? at.join(', ') + ': ' : '') + "`cols` is not a DOMQL prop \u2014 it is ignored and the grid draws one column. Write " + '`columns` (or `gridTemplateColumns`) as a track STRING: two equal columns are ' + "'repeat(2, 1fr)', a label + value pair 'C 1fr' (a spacing token is a track too).");
    }
    if (rules.has('grid-track')) {
        const at = [
            ...new Set(list.filter((v)=>v && v.rule === 'grid-track').map((v)=>v.at))
        ].slice(0, 6);
        parts.push((at.length ? at.join(', ') + ': ' : '') + "a grid track list is a STRING of tracks \u2014 never a number, an array or an object " + "(the grid falls back to one column): three equal columns are 'repeat(3, 1fr)', a " + "table's columns '2fr 1fr 1fr 2fr'; children fill the cells in order.");
    }
    if (rules.has('unknown-css-var')) {
        const vars = named('unknown-css-var');
        const near = [
            ...new Set(list.filter((v)=>v && v.rule === 'unknown-css-var' && v.near).map((v)=>`${v.detail} \u{2192} ${v.near}`))
        ].slice(0, 4);
        parts.push((vars.length ? vars.join(', ') + ': ' : '') + "not a CSS variable this workspace defines, so it resolves to nothing \u2014 never guess a " + "variable: write the design system's own names (color: 'title', background: " + "'blue.2', padding: 'A'); its variables read --color-<name> and --spacing-<token>" + (near.length ? ' (did you mean ' + near.join(', ') + '?)' : '') + '.');
    }
    if (rules.has('unknown-theme')) {
        const names = named('unknown-theme');
        const themes = Array.isArray(extra.themeExamples) ? extra.themeExamples.slice(0, 6) : [];
        parts.push((names.length ? names.map((n)=>`'${n}'`).join(', ') + ': ' : '') + "not a theme of this design system (it is ignored) \u2014 a text colour is `color: '<name>'`, " + 'not a theme' + (themes.length ? '; its themes are ' + themes.map((n)=>`'${n}'`).join(', ') : '') + '.');
    }
    // GENERATED-VIEW-HGROUP-PLACEHOLDER-TEXT-1 — an Hgroup draws only its H and
    // P slots; anything else shows nothing or the workspace's placeholder copy.
    if (rules.has('hgroup-empty') || rules.has('hgroup-placeholder')) {
        const at = [
            ...new Set(list.filter((v)=>v && (v.rule === 'hgroup-empty' || v.rule === 'hgroup-placeholder')).map((v)=>v.at))
        ].slice(0, 6);
        const instead = [
            ...new Set(list.filter((v)=>v && v.rule === 'hgroup-empty' && v.detail && !/^Hgroup/.test(v.detail)).flatMap((v)=>String(v.detail).split(', ')))
        ];
        const copy = [
            ...new Set(list.filter((v)=>v && v.rule === 'hgroup-placeholder').map((v)=>String(v.detail)))
        ];
        parts.push((at.length ? at.join(', ') + ': ' : '') + 'an Hgroup draws only its own `H` (the heading) and `P` (the line under it)' + (instead.length ? " \u2014 it has no " + instead.map((k)=>'`' + k + '`').join(' / ') + ' prop' : '') + ". Write `{ extends: 'Hgroup', H: { text: \u2026 }, P: { text: \u2026 } }`, and `P: { hide: " + 'true }` when there is no line under the heading' + (copy.length ? " \u2014 a slot left out shows the placeholder copy (" + copy.join('; ') + ')' : '') + '. A list of rows is a Flex, not an Hgroup.');
    }
    if (rules.has('unknown-color')) {
        const names = named('unknown-color');
        const examples = Array.isArray(extra.colorExamples) ? extra.colorExamples.slice(0, 8) : [];
        parts.push((names.length ? names.map((n)=>`'${n}'`).join(', ') + ': ' : '') + 'not a colour of this design system, so it is dropped (a text colour falls back, ' + "a background turns transparent) \u2014 use one of its colours" + (examples.length ? ' (' + examples.map((n)=>`'${n}'`).join(', ') + ", \u2026)" : '') + " or a CSS colour; an alpha or a shade joins the name with no space: 'blue.2', " + "'blue-10', 'blue+10'.");
    }
    // GENERATED-VIEW-PALETTE-FILL-AND-UNKNOWN-ICON-1 — measured on dev 2026-10-05
    // (Storm, "a small answer view that summarizes fleet health"): `{ theme:
    // 'card', backgroundColor: 'cerulean-10' }` painted the accent over the card
    // theme's own ink — the body text read 1.3:1, the title 2.4:1 — and an Icon
    // named 'symbols/support' drew the "no icon" placeholder.
    if (rules.has('palette-fill')) {
        const at = [
            ...new Set(list.filter((v)=>v && v.rule === 'palette-fill').map((v)=>v.at))
        ].slice(0, 6);
        const themes = Array.isArray(extra.themeExamples) ? extra.themeExamples.slice(0, 6) : [];
        parts.push((at.length ? at.join(', ') + ': ' : '') + 'a palette colour as the background of an element that carries TEXT keeps whatever ' + "ink was already in force, so the text reads at about 1.3:1 \u2014 a fill needs its " + 'paired ink. Use a theme, which sets the background AND the colour' + (themes.length ? " (this system's themes are " + themes.map((n)=>`'${n}'`).join(', ') + ')' : '') + ". A `color` of its own is not a pair \u2014 one ink over an accent fill still misses " + "the contrast floor. An accent colour belongs on a small mark \u2014 a dot, a bar, an " + "icon \u2014 never on a text plate.");
    }
    if (rules.has('unknown-icon')) {
        const names = named('unknown-icon');
        const near = [
            ...new Set(list.filter((v)=>v && v.rule === 'unknown-icon' && v.near).map((v)=>`${v.detail} \u{2192} ${v.near}`))
        ].slice(0, 4);
        parts.push((names.length ? names.map((n)=>`'${n}'`).join(', ') + ': ' : '') + 'not an icon this design system registers, so the Icon draws the "no icon" ' + "placeholder \u2014 write a name the system carries, with no `library/` prefix (the " + 'resolver never strips one)' + (near.length ? ' (did you mean ' + near.join(', ') + '?)' : '') + '.');
    }
    // A styling refusal on a BAR (the commonest one — measured on dev
    // 2026-10-05: six "treasury share bars" runs refused for the bar's own
    // height / colour / variable, and none reached for the reviewed component):
    // name the component that needs neither.
    const STYLE_RULES = [
        'unitless-size',
        'unknown-color',
        'unknown-css-var',
        'unknown-theme'
    ];
    // …or a colour / variable refusal on a background, the bar's own paint
    // (measured: anonymous `children.3.children.0.style.backgroundColor` bars).
    const onBar = list.some((v)=>v && STYLE_RULES.includes(v.rule) && (/(^|\.)(\w*Bar|Fill|Track|Progress)\w*\./.test(String(v.at)) || v.rule !== 'unitless-size' && /(^|\.)background(Color)?$/.test(String(v.at))));
    if (onBar) parts.push("A share, progress or usage bar is the reviewed `{ extends: 'ProgressBar', value: 0.46 }` (value 0\u20131) \u2014 it needs no height, colour or variable of its own.");
    return parts.join(' ');
}
// Runs `parserName` (a registered freestyle entry that REQUIRES an audit hook)
// with the containment gate as its hook, and maps every outcome to one shape:
// { ok: true, value, allow } | { ok: false, blocked: true, error, violations }
// | { ok: false, error }. FAIL CLOSED when the rules did not load, and when
// the parser ran no audit (an older parser that ignores the option).
const $bd70fc20703b357c$var$_gatedFreestyle = (el, parserName, source)=>{
    if (!$bd70fc20703b357c$export$6f131d8b1bd74e2b($cmUBA)) return {
        ok: false,
        blocked: true,
        error: (0, $7iHfb.GENERATED_APP_BLOCKED),
        violations: [
            {
                rule: 'rules-unavailable',
                at: null,
                detail: 'the containment rules did not load'
            }
        ]
    };
    const root = $bd70fc20703b357c$var$_rootStateOf(el);
    const allow = $bd70fc20703b357c$export$530d3d369fbdee05(root);
    const ctx = el && el.context || el && el.getRoot && el.getRoot() && el.getRoot().context || null;
    // The local workspace picker controls shell navigation. Keep it blocked
    // even before a lazy registry arrives; never expose it to generated views.
    const registeredComponents = [
        ...new Set([
            ...ctx && ctx.components ? Object.keys(ctx.components) : [],
            'AssistantFlyWorkspace',
            'PhoneNavigation',
            'PhoneNavButton',
            'PhoneAppSection',
            'PhoneAppTile'
        ])
    ];
    const gate = (0, $7iHfb.generatedAppAuditHook)(allow, $bd70fc20703b357c$export$ec6d3a4c91e33e8a(root), registeredComponents);
    let audited = false;
    const hook = (expr)=>{
        audited = true;
        gate(expr);
    };
    let value;
    try {
        value = el.call(parserName, source, {
            audit: hook
        });
    } catch (e) {
        // a syntax error alone is a parse error for the model to fix, not a
        // blocked feature (nothing evaluated either way)
        if (e && e.code === (0, $7iHfb.GENERATED_APP_BLOCKED) && (e.violations || []).every((v)=>v.rule === 'parse')) return {
            ok: false,
            error: 'parse: ' + (e.violations[0] && e.violations[0].detail || 'syntax')
        };
        if (e && e.code === (0, $7iHfb.GENERATED_APP_BLOCKED)) {
            const violations = e.violations || [];
            const hint = $bd70fc20703b357c$export$4ca53680afd9d74f(violations);
            return {
                ok: false,
                blocked: true,
                error: (0, $7iHfb.GENERATED_APP_BLOCKED),
                violations: violations,
                ...hint ? {
                    hint: hint
                } : {}
            };
        }
        return {
            ok: false,
            error: 'parse: ' + (e && e.message || String(e))
        };
    }
    if (!audited) return {
        ok: false,
        blocked: true,
        error: (0, $7iHfb.GENERATED_APP_BLOCKED),
        violations: [
            {
                rule: 'audit-unavailable',
                at: null,
                detail: 'the parser ran no audit'
            }
        ]
    };
    return {
        ok: true,
        value: value,
        allow: allow
    };
};
function $bd70fc20703b357c$export$b9f4e66a01c6e85d(source, opts) {
    const el = this;
    const r = $bd70fc20703b357c$var$_gatedFreestyle(el, 'parseFreestyleSource', source);
    if (!r.ok) return r;
    if (opts && opts.lint && r.value && typeof r.value === 'object') {
        const ctx = el && el.context || el && el.getRoot && el.getRoot() && el.getRoot().context || null;
        const ds = ctx && ctx.designSystem;
        const page = r.value.page && typeof r.value.page === 'object' ? r.value.page : r.value;
        const violations = (0, $lo3nm.generatedViewStyleLint)(page, ds, {
            cssVarDefined: (0, $lo3nm.pageCssVarResolver)(),
            components: ctx && ctx.components || null,
            // the framework's own name transform, so the icon rule resolves a name
            // exactly the way the Icon component does (never a second copy of it)
            toCamelCase: ctx && ctx.utils && ctx.utils.toCamelCase || undefined
        });
        if (violations.length) {
            const hint = $bd70fc20703b357c$export$4ca53680afd9d74f(violations, {
                colorExamples: (0, $lo3nm.designSystemColorExamples)(ds),
                themeExamples: Object.keys(ds && (ds.theme || ds.THEME) || {}).slice(0, 6)
            });
            return {
                ok: false,
                blocked: true,
                error: (0, $7iHfb.GENERATED_APP_BLOCKED),
                violations: violations,
                ...hint ? {
                    hint: hint
                } : {}
            };
        }
    }
    return {
        ok: true,
        def: r.value,
        allow: r.allow
    };
}
function $bd70fc20703b357c$export$d3c96cde1ea6181e(source) {
    const r = $bd70fc20703b357c$var$_gatedFreestyle(this, 'auditFreestyleSource', source);
    if (!r.ok) return r;
    const v = r.value || {};
    if (typeof v.expr !== 'string') return {
        ok: false,
        error: 'parse: the parser returned no expression text'
    };
    return {
        ok: true,
        expr: v.expr,
        jsonAuthored: v.jsonAuthored === true,
        allow: r.allow
    };
}

});
parcelRegister("cmUBA", function(module, exports) {

$parcel$export(module.exports, "APP_EL_CALL_ALLOWLIST", () => $901372b6c334215d$export$7c72a2f97a289a82);
$parcel$export(module.exports, "GENERATED_APP_BLOCKED_MEMBERS", () => $901372b6c334215d$export$4d6d9d63094ce450);
$parcel$export(module.exports, "GENERATED_APP_BLOCKED_PREFIX", () => $901372b6c334215d$export$804a5d73e769af47);
$parcel$export(module.exports, "GENERATED_APP_BLOCKED_INDIRECTION", () => $901372b6c334215d$export$fedee06c84792317);
$parcel$export(module.exports, "GENERATED_APP_ROOT_DENY_KEYS", () => $901372b6c334215d$export$85502c3a21154626);
$parcel$export(module.exports, "GENERATED_APP_ROOT_DENY_PATTERN", () => $901372b6c334215d$export$ee79a2aa3477018a);
$parcel$export(module.exports, "GENERATED_APP_ROOT_WRITE_METHODS", () => $901372b6c334215d$export$9cde4cd2bf424b89);
$parcel$export(module.exports, "GENERATED_APP_ELEMENT_MEMBERS", () => $901372b6c334215d$export$da5216e2cdb9af2e);
$parcel$export(module.exports, "GENERATED_APP_BLOCKED_STRINGS", () => $901372b6c334215d$export$5d856c7c2f4b9362);
$parcel$export(module.exports, "GENERATED_APP_GLOBALS", () => $901372b6c334215d$export$763ab9f1332cb40f);
$parcel$export(module.exports, "GENERATED_APP_GLOBAL_MEMBERS", () => $901372b6c334215d$export$f0c63ecbb70bd05d);
$parcel$export(module.exports, "GENERATED_APP_LIFECYCLE_HANDLERS", () => $901372b6c334215d$export$fb3c9d639dec91b3);
$parcel$export(module.exports, "GENERATED_APP_EVENT_MEMBERS", () => $901372b6c334215d$export$5473ad78c72298e4);
$parcel$export(module.exports, "GENERATED_APP_TARGET_MEMBERS", () => $901372b6c334215d$export$a4866f30ac4a352f);
$parcel$export(module.exports, "GENERATED_APP_TARGET_DEEP_MEMBERS", () => $901372b6c334215d$export$c4c4ed1577cac5b2);
$parcel$export(module.exports, "GENERATED_APP_TARGET_DEEP_CHAIN", () => $901372b6c334215d$export$69bb2b1e297285ae);
$parcel$export(module.exports, "GENERATED_APP_EVENT_VALUE_MEMBERS", () => $901372b6c334215d$export$d4b73d6a78049be0);
$parcel$export(module.exports, "GENERATED_APP_TARGET_VALUE_MEMBERS", () => $901372b6c334215d$export$488bd034f93a8e44);
$parcel$export(module.exports, "GENERATED_APP_TAG_ALLOWLIST", () => $901372b6c334215d$export$6ecf9931d2644793);
$parcel$export(module.exports, "GENERATED_APP_MARKUP_KEYS", () => $901372b6c334215d$export$55cbce7098e5b71a);
$parcel$export(module.exports, "GENERATED_APP_URL_KEYS", () => $901372b6c334215d$export$9f71dd3190fcbc15);
$parcel$export(module.exports, "GENERATED_APP_CSS_URL_KEYS", () => $901372b6c334215d$export$667194d6335479a9);
$parcel$export(module.exports, "GENERATED_APP_URL_SCHEMES", () => $901372b6c334215d$export$3f6d0ebfb6fc4f8d);
$parcel$export(module.exports, "GENERATED_APP_SRC_DATA_PREFIX", () => $901372b6c334215d$export$3f66d0e4336a394d);
$parcel$export(module.exports, "GENERATED_APP_COMPONENT_ALLOWLIST", () => $901372b6c334215d$export$df17a958f15fa98);
$parcel$export(module.exports, "GENERATED_APP_COMPONENT_DENYLIST", () => $901372b6c334215d$export$a139b60b430182f4);
// generatedAppRules.js — THE containment rules for AI-generated workspace apps
// (render_answer_ui views, /add-app extensions, multi-page apps, installed
// /x/<key> apps). Pure data, NO imports: the server's AST check reads this
// same file, so the client and the server refuse the same things.
//
// Nika 2026-10-01: "Cut access now". A generated page runs in the member's
// session. Before this, its `el.call(name)` reached the WHOLE shell function
// registry (getSDK → the member's full SDK), and the only gate was a regex
// list that `el.constructor.constructor('return this')()` and
// `self['par' + 'ent']` walked past.
//
// The model: a generated app may call ONLY the functions named below, may read
// workspace data ONLY as `s.root.<key>` through the seed deny list, and may
// not name anything that reaches a realm, a window, the shell tree, the SDK
// or the router.
// The el.call names a generated app may use — THE one list, identical to the
// server's write-time check (server agents/services/appPageSourceAudit.js
// APP_EL_CALL_ALLOWLIST). Never getSDK or anything returning the sdk, never
// the router, storage, setLang, notifications, a module loader or AI verb, or
// a name from the app's own `functions:` block. Data goes through the
// declarative `fetch:` array (the scoped workspaceProject.* bridge), which
// needs no el.call name.
const $901372b6c334215d$export$7c72a2f97a289a82 = Object.freeze([
    'formatShortDate',
    'formatMonthShort',
    'formatTime',
    'polyglot'
]);
const $901372b6c334215d$export$4d6d9d63094ce450 = Object.freeze([
    // code from text / the prototype chain
    'constructor',
    'prototype',
    '__proto__',
    'callee',
    'caller',
    // a window or a document from a DOM node
    'ownerDocument',
    'defaultView',
    'contentWindow',
    'contentDocument',
    'parentNode',
    'parentElement',
    'offsetParent',
    'getRootNode',
    'composedPath',
    'assignedSlot',
    'frameElement',
    'ownerElement',
    'closest',
    'querySelector',
    'querySelectorAll',
    'getElementById',
    'getElementsByTagName',
    'getElementsByClassName',
    'insertAdjacentHTML',
    'innerHTML',
    'outerHTML',
    'createElement',
    'appendChild',
    'insertBefore',
    'replaceChild',
    // element methods that turn a string into code or fire a handler
    'setAttribute',
    'setAttributeNS',
    'setAttributeNode',
    'toggleAttribute',
    'setHTMLUnsafe',
    'insertAdjacentElement',
    'insertAdjacentText',
    'attachShadow',
    'click',
    'dispatchEvent',
    'requestSubmit',
    'submit',
    'replaceChildren',
    'replaceWith',
    'showModal',
    // the shell tree, the SDK and the router (an in-shell page is a shell node)
    'parent',
    'node',
    'context',
    'getRoot',
    'getRootState',
    'lookup',
    'lookdown',
    'lookdownAll',
    'sdk',
    'getSDK',
    'router'
]);
const $901372b6c334215d$export$804a5d73e769af47 = '__';
const $901372b6c334215d$export$fedee06c84792317 = Object.freeze([
    'apply',
    'bind'
]);
const $901372b6c334215d$export$85502c3a21154626 = Object.freeze([
    // ONE deny list for the AST gate and the sandbox's state snapshot
    // (ISOLATED-RUNTIME-PLAN §3.4): the member and the workspace's people are
    // never readable by a generated app
    'user',
    'members',
    'jwtClaims',
    'orgs',
    'org',
    'workspaces',
    'workspace',
    'userPrefs',
    'roles',
    'orgMembersByOrgId'
]);
const $901372b6c334215d$export$ee79a2aa3477018a = 'token|secret|jwt|claim|credential|password|apikey|auth|session';
const $901372b6c334215d$export$9cde4cd2bf424b89 = Object.freeze([
    'update',
    'set',
    'replace',
    'reset',
    'add',
    'remove',
    'clean',
    'destroy',
    'toggle',
    'quietUpdate',
    'quietReplace',
    'setByPath',
    'removeByPath',
    'apply',
    'applyReplace',
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse',
    'fill',
    'copyWithin'
]);
const $901372b6c334215d$export$da5216e2cdb9af2e = Object.freeze([
    'call',
    'update',
    'set',
    'state',
    'props',
    'text',
    'key',
    'data',
    'value'
]);
const $901372b6c334215d$export$5d856c7c2f4b9362 = Object.freeze([
    'constructor',
    'prototype',
    '__proto__',
    'caller',
    'callee',
    'defaultView',
    'ownerDocument',
    'contentWindow',
    'contentDocument',
    'getSDK',
    'globalThis'
]);
const $901372b6c334215d$export$763ab9f1332cb40f = Object.freeze([
    'undefined',
    'NaN',
    'Infinity',
    'Math',
    'JSON',
    'Date',
    'Intl',
    'Number',
    'String',
    'Boolean',
    'Array',
    'Object',
    'Set',
    'Map',
    'WeakMap',
    'WeakSet',
    'Symbol',
    'Promise',
    'RegExp',
    'Error',
    'TypeError',
    'RangeError',
    'BigInt',
    'parseInt',
    'parseFloat',
    'isNaN',
    'isFinite',
    'encodeURIComponent',
    'decodeURIComponent',
    'encodeURI',
    'decodeURI',
    'console',
    'setTimeout',
    'clearTimeout',
    'setInterval',
    'clearInterval'
]);
const $901372b6c334215d$export$f0c63ecbb70bd05d = Object.freeze({
    Object: [
        'keys',
        'values',
        'entries',
        'assign',
        'fromEntries',
        'freeze',
        'isFrozen'
    ],
    Array: [
        'isArray',
        'from',
        'of'
    ],
    Promise: [
        'all',
        'allSettled',
        'race',
        'any',
        'resolve',
        'reject'
    ],
    console: [
        'log',
        'warn',
        'error',
        'info',
        'debug'
    ]
});
const $901372b6c334215d$export$fb3c9d639dec91b3 = Object.freeze([
    'onInit',
    'onCreate',
    'onRender',
    'onUpdate',
    'onStateUpdate',
    'onBeforeUpdate',
    'onBeforeStateUpdate',
    'onAttachNode',
    'onComplete',
    'onDone',
    'onRemove',
    'onStateCreated',
    'onStateInit',
    'onFrame'
]);
const $901372b6c334215d$export$5473ad78c72298e4 = Object.freeze([
    'target',
    'currentTarget',
    'key',
    'code',
    'keyCode',
    'which',
    'shiftKey',
    'ctrlKey',
    'altKey',
    'metaKey',
    'button',
    'buttons',
    'clientX',
    'clientY',
    'pageX',
    'pageY',
    'offsetX',
    'offsetY',
    'deltaX',
    'deltaY',
    'deltaMode',
    'type',
    'detail',
    'repeat',
    'isComposing',
    'inputType',
    'data',
    'timeStamp',
    'defaultPrevented',
    'preventDefault',
    'stopPropagation',
    'stopImmediatePropagation'
]);
const $901372b6c334215d$export$a4866f30ac4a352f = Object.freeze([
    'value',
    'checked',
    'files',
    'name',
    'id',
    'dataset',
    'type',
    'selectionStart',
    'selectionEnd',
    'valueAsNumber',
    'valueAsDate',
    'selected',
    'selectedIndex',
    'options',
    'scrollTop',
    'scrollLeft',
    'scrollHeight',
    'scrollWidth',
    'clientHeight',
    'clientWidth',
    'focus',
    'blur',
    'select',
    'getBoundingClientRect'
]);
const $901372b6c334215d$export$c4c4ed1577cac5b2 = Object.freeze([
    'files',
    'dataset',
    'options'
]);
const $901372b6c334215d$export$69bb2b1e297285ae = Object.freeze({
    files: {
        list: [
            'length'
        ],
        item: [
            'name',
            'size',
            'type',
            'lastModified',
            'text',
            'arrayBuffer'
        ]
    },
    options: {
        list: [
            'length',
            'selectedIndex'
        ],
        item: [
            'value',
            'text',
            'label',
            'selected',
            'index',
            'disabled'
        ]
    }
});
const $901372b6c334215d$export$d4b73d6a78049be0 = Object.freeze([
    'key',
    'code',
    'keyCode',
    'which',
    'shiftKey',
    'ctrlKey',
    'altKey',
    'metaKey',
    'button',
    'buttons',
    'clientX',
    'clientY',
    'pageX',
    'pageY',
    'offsetX',
    'offsetY',
    'deltaX',
    'deltaY',
    'deltaMode',
    'type',
    'detail',
    'repeat',
    'isComposing',
    'inputType',
    'data',
    'timeStamp',
    'defaultPrevented'
]);
const $901372b6c334215d$export$488bd034f93a8e44 = Object.freeze([
    'value',
    'checked',
    'name',
    'id',
    'type',
    'selectionStart',
    'selectionEnd',
    'valueAsNumber',
    'valueAsDate',
    'selected',
    'selectedIndex',
    'scrollTop',
    'scrollLeft',
    'scrollHeight',
    'scrollWidth',
    'clientHeight',
    'clientWidth',
    'files'
]);
const $901372b6c334215d$export$6ecf9931d2644793 = Object.freeze([
    'div',
    'span',
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'section',
    'article',
    'header',
    'footer',
    'nav',
    'main',
    'aside',
    'figure',
    'figcaption',
    'blockquote',
    'pre',
    'code',
    'strong',
    'em',
    'b',
    'i',
    'u',
    's',
    'small',
    'mark',
    'sub',
    'sup',
    'abbr',
    'time',
    'br',
    'hr',
    'ul',
    'ol',
    'li',
    'dl',
    'dt',
    'dd',
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'th',
    'td',
    'caption',
    'colgroup',
    'col',
    'form',
    'fieldset',
    'legend',
    'label',
    'input',
    'textarea',
    'select',
    'option',
    'optgroup',
    'button',
    'output',
    'progress',
    'meter',
    'details',
    'summary',
    'a',
    'img',
    'picture',
    'canvas',
    'video',
    'audio',
    'source',
    'track'
]);
const $901372b6c334215d$export$55cbce7098e5b71a = Object.freeze([
    'html',
    'innerHTML',
    'outerHTML',
    'srcdoc',
    'srcDoc',
    'dangerouslySetInnerHTML',
    // a form or a ping posting to another origin
    'action',
    'formAction',
    'formaction',
    'ping'
]);
const $901372b6c334215d$export$9f71dd3190fcbc15 = Object.freeze([
    'href',
    'src',
    'poster',
    'xlinkHref',
    'xlink:href',
    'cite',
    'codebase',
    'srcset'
]);
const $901372b6c334215d$export$667194d6335479a9 = Object.freeze([
    'background',
    'backgroundImage',
    'mask',
    'maskImage',
    'WebkitMaskImage',
    'cursor',
    'content',
    'listStyle',
    'listStyleImage',
    'borderImage',
    'borderImageSource',
    'shapeOutside'
]);
const $901372b6c334215d$export$3f6d0ebfb6fc4f8d = Object.freeze([
    'http',
    'https',
    'mailto',
    'tel'
]);
const $901372b6c334215d$export$3f66d0e4336a394d = 'data:image/';
const $901372b6c334215d$export$df17a958f15fa98 = Object.freeze([
    'AccessibilityCheck',
    'AccordionItem',
    'AddButton',
    'AddItemButton',
    'AddRemoveButtons',
    'AgentAvatar',
    'AiActionRow',
    'AiMenuHeading',
    'AiMenuPanel',
    'AiOptionRow',
    'AppCapsuleBtn',
    'AppCapsuleBtnDanger',
    'AppCapsuleBtnGhost',
    'AppCapsuleBtnPrimary',
    'AppCapsuleBtnToolbar',
    'AppChoiceChip',
    'AppChoiceChips',
    'AppChoiceGroup',
    'AppColorChip',
    'AppColorChips',
    'AppDialogBody',
    'AppDialogFoot',
    'AppDialogHint',
    'AppDialogTitle',
    'AppField',
    'AppFieldChips',
    'AppFieldColors',
    'AppFieldError',
    'AppFieldHint',
    'AppFieldLabel',
    'AppKeycap',
    'AppLabelStack',
    'AppMain',
    'AppMicroLabel',
    'AppNavLink',
    'AppOption',
    'AppOrgSwitchOverlay',
    'AppPage',
    'AppPageEyebrow',
    'AppPaginationNext',
    'AppPaginationPrevious',
    'AppPaginationStep',
    'AppScrollRow',
    'AppSidebarGroup',
    'AppSidebarRow',
    'AppStatusChip',
    'AppTable',
    'AppTableHead',
    'AppTableNum',
    'AppTableRow',
    'AppToolbar',
    'ArrowButton',
    'ArticleBig',
    'ArticleHeader',
    'ArticleLink',
    'ArticleMedium',
    'ArticleSmall',
    'ArticleTiny',
    'ArticleXS',
    'AssetPicture',
    'AssetsFromInsert',
    'Audio',
    'Avatar',
    'Block',
    'Box',
    'BoxModelAside',
    'BoxSizeItem',
    'Br',
    'BrandA11yBoard',
    'BrandAnimDot',
    'BrandAnimationBoard',
    'BrandAssetBoard',
    'BrandBezierPlot',
    'BrandBorderlessDuo',
    'BrandCode',
    'BrandComponentCell',
    'BrandControlScale',
    'BrandDensityCard',
    'BrandEyebrow',
    'BrandFamilyBoard',
    'BrandFixedSizes',
    'BrandFocusDemo',
    'BrandGradientBoard',
    'BrandHero',
    'BrandIconButtonSpecimen',
    'BrandIconCell',
    'BrandIllustrativeRow',
    'BrandInkRow',
    'BrandLawsList',
    'BrandLocalisationBoard',
    'BrandLogoBoard',
    'BrandMediaBoard',
    'BrandMicroLabel',
    'BrandMotionStep',
    'BrandNote',
    'BrandOverlayAction',
    'BrandOverlayFact',
    'BrandOverlayFrame',
    'BrandOverlayMenuRow',
    'BrandOverlayMotionBoard',
    'BrandOverlayMotionRow',
    'BrandOverlayPage',
    'BrandOverlayPageCard',
    'BrandOverlayPopover',
    'BrandOverlayPopoverFrame',
    'BrandOverlayTrigger',
    'BrandOverlayVeil',
    'BrandPanel',
    'BrandRadiusBoard',
    'BrandRatioChip',
    'BrandRegisterDuo',
    'BrandReservedBoard',
    'BrandResetBoard',
    'BrandSection',
    'BrandShadowBoard',
    'BrandSkinBoard',
    'BrandSkinCard',
    'BrandSkinOption',
    'BrandSkinPill',
    'BrandSkinStage',
    'BrandSkinSwitch',
    'BrandSpacingBars',
    'BrandStateDuo',
    'BrandStatusTag',
    'BrandSubhead',
    'BrandSwatch',
    'BrandThemeBoard',
    'BrandThemeGroupGrid',
    'BrandThemeSpecimen',
    'BrandTimingBoard',
    'BrandTypeRow',
    'BrandTypeScale',
    'BrandVoiceCard',
    'BrandWeightLaw',
    'Button',
    'ButtonSet',
    'ButtonTitle',
    'CancelButton',
    'CanvasButton',
    'CanvasDots',
    'CanvasMobileSidebarPanelChrome',
    'CanvasPanel',
    'CanvasSidebarCard',
    'CanvasSidebarIsland',
    'Caption',
    'CaptionTitle',
    'ChatConfidenceFactor',
    'ChatMarkdown',
    'CheckButton',
    'CheckParagraph',
    'Checkbox',
    'CheckboxField',
    'CheckboxHgroup',
    'ChromeExt',
    'Circle',
    'CircleButton',
    'Clickable',
    'ClickableItem',
    'CloseButton',
    'ColumnParagraphs',
    'ComingSoon',
    'CommonCard',
    'CommonFieldLike',
    'CompactIconButton',
    'ContinueButton',
    'Contributors',
    'ContributorsCopy',
    'Data',
    'DescriptionField',
    'DesignComponent',
    'DesignComponentHeader',
    'DesignComponentProperties',
    'DesignElement',
    'DesignSystem',
    'DesignSystemBanners',
    'Dialog',
    'DialogFooter',
    'DialogHeader',
    'DocsDesignElement',
    'DocsHgroup',
    'DocsLink',
    'DocsSocialLinks',
    'DocsSupportLinks',
    'DotCaption',
    'DotCaptionArticle',
    'DraftSwitcher',
    'DragComponentsTutorial',
    'DragHandler',
    'DragNdropUser',
    'DragParagraph',
    'Dropdown',
    'DropdownArrow',
    'DropdownButton',
    'DropdownCopy',
    'DropdownField',
    'DropdownHeader',
    'DropdownList',
    'DropdownParent',
    'EmptyState',
    'EmptyStateImages',
    'EmptyStateLoading',
    'EmptyStateTiles',
    'ErrorState',
    'ExplanatoryParagraph',
    'Feedback',
    'FileIcon',
    'Flex',
    'Focusable',
    'FocusableComponent',
    'FontsFromInsert',
    'FooteLite',
    'FooterFull',
    'Footnote',
    'Form',
    'GeexBlobPercent',
    'GeexGridBars',
    'GeexRankedStack',
    'GeexSegmentedBar',
    'GeexStackedColumn',
    'GeexTonalBars',
    'GeexValueRules',
    'GetEarlyAccess',
    'GlyphPlateHolder',
    'Grid',
    'GridChooser',
    'Group',
    'GroupField',
    'Gutter',
    'HeaderHeading',
    'Headline',
    'HelloUser',
    'Hgroup',
    'HgroupButton',
    'HgroupRows',
    'Hoverable',
    'Hr',
    'Icon',
    'IconButton',
    'IconCaption',
    'IconGridTypes',
    'IconLinkWithPath',
    'IconNavbar',
    'IconText',
    'ImageParagraph',
    'Img',
    'Inline',
    'InlineFlex',
    'InlineGrid',
    'InlineSelect',
    'Input',
    'InputField',
    'InsertSectionShadow',
    'InstallFooter',
    'InstallHero',
    'InstallableRailSkeleton',
    'InstallableStateBadge',
    'IntegrationItem',
    'IntegrationScopeBadge',
    'IntegrationScopeOption',
    'IntegrationsList',
    'InviteForm',
    'Italic',
    'Item',
    'ItemAlt',
    'ItemHighlight',
    'ItemHighlightAlt',
    'ItemOutline',
    'ItemPreview',
    'KangorooButton',
    'LabelTag',
    'Labeled',
    'LabeledCopy',
    'LabeledHighlight',
    'LabeledLight',
    'LandingFooterLite',
    'LanguageOption',
    'LayerSimple',
    'Li',
    'LibraryItemInLearn',
    'Line',
    'Link',
    'LoaderRatio',
    'LoadingGif',
    'LoadingGifSection',
    'LoadingSpinner',
    'LoginForm',
    'LogoLoader',
    'Lottie',
    'MemberProfileCheckItem',
    'MenuItem',
    'MicroNavbar',
    'ModalBody',
    'ModalFooter',
    'MultipleSelect',
    'NativeSelect',
    'Navbar',
    'NavbarTooltip',
    'NavigationArrows',
    'NavigationDots',
    'Notification',
    'NumbCaption',
    'NumbCaptionArticleBig',
    'NumbCaptionArticleSmall',
    'NumberInput',
    'NumericBulletin',
    'NumericTip',
    'Ol',
    'OrderingItem',
    'PackageFeatureItem',
    'Page',
    'PageBar',
    'PageBarBtn',
    'PageBarMeta',
    'PageBarTitle',
    'PageTemplate',
    'PasswordField',
    'PeopleSection',
    'ProfileGrantCard',
    'ProgressBar',
    'ProjectInfo',
    'ProjectTab',
    'PromptTextarea',
    'QuickStartNumber',
    'QuickTip',
    'Radio',
    'RadioHgroup',
    'Range',
    'RangeField',
    'RangeFieldWithIcon',
    'RangeFieldWithTitle',
    'RangeFieldWithTitleAndIcon',
    'RangeWithButtons',
    'RequestAccessButtons',
    'ResetEmailForm',
    'ResetPasswordsForm',
    'ResizeOverlay',
    'ResponsiveOverlay',
    'RouteLink',
    'Scrollable',
    'Scrollbar',
    'SearchField',
    'SectionAddButton',
    'SectionHeader',
    'SectionHeaderWithNav',
    'SectionTitle',
    'Select',
    'SelectField',
    'SelectRoleField',
    'ServerPreview',
    'SettingsTabs',
    'Shape',
    'SignupForm',
    'SimpleOverlay',
    'SizeUnits',
    'Skeleton',
    'SkeletonCard',
    'SkeletonCircle',
    'SkeletonRow',
    'Span',
    'SquareButton',
    'StateDesignElement',
    'Strong',
    'Subhead',
    'SummaryComponent',
    'Svg',
    'SwitchField',
    'SwitchFieldWithCaption',
    'SwitchInput',
    'TabSet',
    'TabsLink',
    'TabsLinkSwitcher',
    'Tag',
    'Tests',
    'Text',
    'Textarea',
    'TextareaField',
    'TextareaWithButton',
    'Theme',
    'Title',
    'Toggle',
    'ToggleHgroup',
    'ToolTerminal',
    'Tooltip',
    'TooltipHidden',
    'TooltipParent',
    'TutorialBanner',
    'Ul',
    'Underline',
    'UploadAvatar',
    'UploadField',
    'UploadIcon',
    'UploadImage',
    'UploadProgress',
    'UserProfileIntegrationRow',
    'UsersTableCopy',
    'VerticalLine',
    'Video',
    'Vr',
    'WaitlistForm',
    'WiderButton'
]);
const $901372b6c334215d$export$a139b60b430182f4 = Object.freeze([
    'AccessCodeField',
    'ActionNotification',
    'ActionNotificationButtons',
    'ActiveCanvasUsers',
    'ActiveContentSwitcher',
    'ActiveSyncInPublish',
    'ActivityChart',
    'ActivityChartCell',
    'AddAppCatalogCard',
    'AddPagePickerOverlay',
    'AddReactionEmoji',
    'AddReactionPicker',
    'AddTagStyles',
    'AdmParagraph',
    'AdminActionBtn',
    'AdminActionBtnCompact',
    'AdminActionBtnDanger',
    'AdminActionBtnPrimary',
    'AdminActivityScoringRow',
    'AdminAutoTopup',
    'AdminAutoTopupField',
    'AdminAutoTopupMetric',
    'AdminCard',
    'AdminCardDesc',
    'AdminCardTitle',
    'AdminIconBtn',
    'AdminLedgerRow',
    'AdminLogCalendar',
    'AdminLogCalendarCell',
    'AdminLogDay',
    'AdminLogGroup',
    'AdminLogRow',
    'AdminMetricCard',
    'AdminMetricGrid',
    'AdminPageBody',
    'AdminPageHeader',
    'AdminPlanBenefit',
    'AdminPricingCard',
    'AdminSettingsBody',
    'AdminSidebar',
    'AdminSidebarLink',
    'AdminStatusRow',
    'AdminStatusSection',
    'AdminUsageBreakdownRow',
    'AdminUsageLegend',
    'AdminUsageMetric',
    'AdminUsageRow',
    'AdminUsageSummary',
    'AdminUsageViewButton',
    'AdminUserGroupHeader',
    'AdminUserRow',
    'AgentCard',
    'AgentHeroCard',
    'AgentIdleRow',
    'AgentPulseRail',
    'AgentPulseRow',
    'AiActionConfirmCard',
    'AiBridgeModal',
    'AiContextBar',
    'AiContextChip',
    'AiModePicker',
    'AiModePickerBody',
    'AiModelSwitcher',
    'AiModelSwitcherBody',
    'AiModelSwitcherRow',
    'AiModelSwitcherTrigger',
    'AiPickerRow',
    'AiSettingsButton',
    'AiSettingsPanel',
    'AiWidgetBarChart',
    'AiWidgetBarRow',
    'AiWidgetBlock',
    'AiWidgetChip',
    'AiWidgetChipRow',
    'AiWidgetList',
    'AiWidgetListRow',
    'AiWidgetNumeral',
    'AiWidgetProgressBars',
    'AiWidgetTextBlock',
    'AlertTemplate',
    'AmbientBackdrop',
    'AmbientGround',
    'AnalyticsBarRow',
    'AnalyticsCampaignRow',
    'AnalyticsCampaigns',
    'AnalyticsCard',
    'AnalyticsDailyBand',
    'AnalyticsDailyDayLabel',
    'AnalyticsDemographics',
    'AnalyticsHeader',
    'AnalyticsKpiGrid',
    'AnalyticsKpiTile',
    'AnalyticsMetaChip',
    'AnalyticsNavbar',
    'AnalyticsOnChanges',
    'AnalyticsSparkline',
    'AnalyticsTopPages',
    'AnalyticsTopReferrers',
    'AnalyticsTotals',
    'AnalyticsUsersToday',
    'AnalyticsWeeklyCharts',
    'AnalyticsWhosActive',
    'AnimationTag',
    'AnnouncementCard',
    'AnnouncementDetailModal',
    'AppAssistantDecisionBanner',
    'AppAssistantDecisionCard',
    'AppAssistantThreadPicker',
    'AppAssistantToggle',
    'AppCard',
    'AppCombobox',
    'AppContextMenuButton',
    'AppCreateOrgModal',
    'AppDialog',
    'AppDialogFooter',
    'AppDialogHead',
    'AppFieldInput',
    'AppFieldPrefix',
    'AppFieldSearch',
    'AppFieldSegmented',
    'AppFieldSelect',
    'AppFieldTextarea',
    'AppFrame',
    'AppGlyphPlate',
    'AppGlyphTile',
    'AppGroupColumn',
    'AppHeader',
    'AppHeroCard',
    'AppHueTile',
    'AppInput',
    'AppInputBare',
    'AppInputCompact',
    'AppInputGroup',
    'AppInputPrefix',
    'AppInputWithIcon',
    'AppLightbox',
    'AppListItem',
    'AppNavbar',
    'AppNavbarButton',
    'AppNavbarDropdownItem',
    'AppNavbarMoreMenu',
    'AppOrgSwitcher',
    'AppOrgSwitcherItem',
    'AppOrgSwitcherMenu',
    'AppPagination',
    'AppPersonRow',
    'AppSegmented',
    'AppSegmentedItem',
    'AppSelect',
    'AppSelectCompact',
    'AppSidebar',
    'AppSidebarLink',
    'AppTextarea',
    'AppToolbarMore',
    'AppUsernamePrompt',
    'AppWsGroup',
    'AppWsItem',
    'ApprovalRow',
    'ArpPopoverMenu',
    'ArticleReaderControls',
    'ArticleReaderWord',
    'ArticleView',
    'AssistantAnswerPopover',
    'AssistantBoardCard',
    'AssistantBoardFact',
    'AssistantBoardView',
    'AssistantDeckCard',
    'AssistantDeckPresenter',
    'AssistantDeckSlide',
    'AssistantDeckView',
    'AssistantFormField',
    'AssistantIconButton',
    'AssistantMainLayer',
    'AssistantMainThread',
    'AssistantModeChip',
    'AssistantRecordsBar',
    'AssistantRecordsBlock',
    'AssistantRecordsCell',
    'AssistantRecordsHeadCell',
    'AssistantRecordsHero',
    'AssistantRecordsLine',
    'AssistantRecordsRow',
    'AssistantRecordsSlice',
    'AssistantRecordsTableRow',
    'AssistantSendButton',
    'AssistantSourceCard',
    'AssistantStarter',
    'AssistantStarterList',
    'AssistantThreadBlock',
    'AssistantThreadChips',
    'AssistantThreadRow',
    'AssistantThreadUnavailable',
    'AssistantThreadUrlSync',
    'AttrMachineChip',
    'AttrMemberRow',
    'AuditCard',
    'AvatarBundle',
    'AvatarBundleItem',
    'BaseSizeTool',
    'BirthdayItem',
    'BlockedSection',
    'BlockerChip',
    'BookmarkCard',
    'BookmarkTag',
    'BookmarkTagFilter',
    'BookmarksMain',
    'BookmarksSidebar',
    'BorderRadius',
    'BorderRadiusBox',
    'BoxModel',
    'BoxModelMiddle',
    'BoxModelSubGrid',
    'BoxSize',
    'BoxSizeRow',
    'BrandBackdropList',
    'BrandComponentsGrid',
    'BrandGrayRamp',
    'BrandHueGrid',
    'BrandIconBoard',
    'BrandIconButtonSizes',
    'BrandInkMatrix',
    'BrandOverlayCenter',
    'BrandOverlayCenterSheet',
    'BrandOverlayPhone',
    'BrandOverlayPhoneSheet',
    'BrandOverlaySide',
    'BrandOverlaySidePanel',
    'BrandOverlaySpecimen',
    'BrandPageSelect',
    'BrandRail',
    'BrandRailLink',
    'BrandSiteSearch',
    'BrandSiteShell',
    'BrandThemeToggle',
    'BrandWashBoard',
    'Breadcrumb',
    'BroadcastAudienceSegment',
    'BroadcastComposerAudienceButton',
    'BroadcastComposerModal',
    'BroadcastNewsRow',
    'BroadcastStoryCard',
    'BroadcastTagFilter',
    'CalAddTeammatesModal',
    'CalAgendaDay',
    'CalAgendaEmbed',
    'CalAvailabilityCell',
    'CalAvailabilityDayRow',
    'CalAvailabilityGrid',
    'CalAvailabilityHourHeader',
    'CalConfirmMoveModal',
    'CalDragMoveGhost',
    'CalDragOverlayGhost',
    'CalDragPreview',
    'CalEndRepeatBtn',
    'CalEndRepeatSection',
    'CalEventChip',
    'CalEventDetailModal',
    'CalEventTypeBtn',
    'CalHeader',
    'CalHourLine',
    'CalInviteePill',
    'CalInviteeRow',
    'CalInviteeSuggestion',
    'CalMain',
    'CalMeetingAlertCard',
    'CalMeetingModeBtn',
    'CalMiniCalendar',
    'CalMiniDayCell',
    'CalMiniDayLabel',
    'CalMonthDayCell',
    'CalMonthDayHeader',
    'CalMonthStat',
    'CalMonthView',
    'CalNewBookingModal',
    'CalProfileDetailRow',
    'CalProfileModal',
    'CalProfileTabBtn',
    'CalProfileUnavailRow',
    'CalQuickCreate',
    'CalQuickInvitee',
    'CalQuickTypeBtn',
    'CalRailSheet',
    'CalRecurringBtn',
    'CalRecurringDayBtn',
    'CalSidebar',
    'CalTeamMemberColumn',
    'CalTeamMemberHeader',
    'CalTeamNowColumn',
    'CalTeamNowEvent',
    'CalTeamNowGutterTick',
    'CalTeamNowHeaderCell',
    'CalTeamNowHourLine',
    'CalTeamNowView',
    'CalTeamView',
    'CalTeammateSuggestion',
    'CalTimeLabel',
    'CalUnavailableSlot',
    'CalViewBtn',
    'CalViewSwitcherBtn',
    'CalVisibilityBtn',
    'CalWeekDayColumn',
    'CalWeekDayHeader',
    'CalWeekEvent',
    'CalWeekView',
    'CalibrationOverlay',
    'CallInvitationBanner',
    'CanvasAppHeader',
    'CanvasConnection',
    'CanvasConnectionBar',
    'CanvasCreateIsland',
    'CanvasCreateMenuBody',
    'CanvasCreateMenuItem',
    'CanvasEditor',
    'CanvasEmbed',
    'CanvasEmbed2',
    'CanvasHelpCard',
    'CanvasMainNavbar',
    'CanvasMessage',
    'CanvasNavbar',
    'CanvasOverlay',
    'CanvasOverlayV2',
    'CanvasPagesDropdown',
    'CanvasPrimaryCreateIsland',
    'CanvasProjectSidebar',
    'CanvasPromptTextarea',
    'CanvasSearch',
    'CanvasSearchDropdown',
    'CanvasSearchItem',
    'CanvasSidebarCloseBtn',
    'CanvasSidebarReopenNav',
    'CanvasSplitView',
    'CanvasV2CodeEditor',
    'CanvasVerticalNavbar',
    'CanvasViewNavGroup',
    'CanvasViewNavRow',
    'CanvasViewRail',
    'CanvasViewSidebar',
    'CaseTemplate',
    'CaseTemplateRow',
    'CasesPanelWidget',
    'Chat',
    'ChatAttachmentChip',
    'ChatAttachmentRender',
    'ChatAuthorOption',
    'ChatCard',
    'ChatChannelRow',
    'ChatChannelSettingsModalBody',
    'ChatCode',
    'ChatComposer',
    'ChatConversationGroups',
    'ChatDMPersonRow',
    'ChatDMRow',
    'ChatFieldLabel',
    'ChatFileCard',
    'ChatFilesView',
    'ChatFilterBar',
    'ChatFilterToggle',
    'ChatGroupRow',
    'ChatHeader',
    'ChatHoverActions',
    'ChatHoverDivider',
    'ChatHoverIconBtn',
    'ChatHoverMenuItem',
    'ChatHoverQuickReact',
    'ChatHr',
    'ChatInlineCode',
    'ChatInviteMemberPickRow',
    'ChatLinkRow',
    'ChatLinksView',
    'ChatMain',
    'ChatMemberPickRow',
    'ChatMentionDropdown',
    'ChatMentionRow',
    'ChatMessage',
    'ChatMessageList',
    'ChatMessageRow',
    'ChatMobileRail',
    'ChatMobileSidebarBar',
    'ChatModalKindBtn',
    'ChatNewChannelModalBody',
    'ChatOL',
    'ChatPaneHeader',
    'ChatPaneHeaderBtn',
    'ChatPaneHeaderSubtitle',
    'ChatPaneHeaderTitle',
    'ChatPinnedRow',
    'ChatReactionEmoji',
    'ChatReactionPill',
    'ChatRenameModalBody',
    'ChatReplyBannerItem',
    'ChatSearchPanelBody',
    'ChatSearchResultRow',
    'ChatSettingsMemberRow',
    'ChatSidebar',
    'ChatSidebarGroup',
    'ChatSidebarGroupHeader',
    'ChatSidebarMenuItem',
    'ChatSidebarMore',
    'ChatSourceChip',
    'ChatThreadPanel',
    'ChatThreadReplyRow',
    'ChatTicketRow',
    'ChatTicketsView',
    'ChatToolRow',
    'ChatUL',
    'ChooseCanvas',
    'CityMemberRow',
    'CodeBlock',
    'CodeExample',
    'CodePreview',
    'CodePreviewWidget',
    'CodePreviewWithTitle',
    'CodeWithTitleAndButtons',
    'ColorDropdown',
    'ColorDropdownItem',
    'ColorField',
    'ColorFieldWithTitle',
    'ColorPalleteSection',
    'ColorPicker',
    'ColorPickerInputs',
    'ColorPickerWithTitle',
    'ColorPreview',
    'ColorReferenceTemplate',
    'ColorSelect',
    'ColorSelectWithTitle',
    'ColorShade',
    'ColorSwatchItem',
    'ColorTemplate',
    'ColorTemplateRow',
    'ColorText',
    'Command',
    'CommandBar',
    'CommandPalette',
    'CommentThread',
    'CommentThreadItem',
    'CompanyInfoRow',
    'ComponentAddressBar',
    'ComponentCard',
    'ComponentTag',
    'ConfirmTemplate',
    'ConnectionBadge',
    'ConnectionLabel',
    'ConnectionNavbar',
    'ContentPage',
    'ContentPageSectionLink',
    'ContextDropdown',
    'ContextDropdownItem',
    'CopyButton',
    'CreateAgentModal',
    'CreateMemberModal',
    'CreditBanner',
    'CreditBlocker',
    'CreditWarningPill',
    'CustomTemplate',
    'CvEntityCard',
    'CvEntityCardAction',
    'CvEntityPickerBody',
    'CvEntityPickerRow',
    'CvModeButton',
    'DSGrid',
    'DangerZoneSection',
    'DashboardNavbar',
    'DashboardSidebar',
    'DashboardTabs',
    'DataSourcesInInsert',
    'DayCard',
    'DecisionRow',
    'DecisionsSection',
    'DeckFrame',
    'DemoClaimBanner',
    'DemoClaimBar',
    'DesignSystemItems',
    'DesignSystemLayout',
    'DesignSystemNavbar',
    'DesignSystemOptions',
    'DesignSystemScene',
    'DesignSystemSummary',
    'DesignSystemSummaryMinimal',
    'DesktopFrame',
    'DeviceButtonSet',
    'DirectionOverlay',
    'DocLayout',
    'DocsBrowseColumn',
    'DocsCard',
    'DocsContentHeader',
    'DocsFolderList',
    'DocsFolderRow',
    'DocsGrid',
    'DocsHeader',
    'DocsKbCategoryList',
    'DocsKbCategoryRow',
    'DocsMain',
    'DocsMobileRail',
    'DocsMobileSidebarBar',
    'DocsNotesFilterList',
    'DocsNotesFilterRow',
    'DocsSectionNav',
    'DocsSectionRow',
    'DocsSidebar',
    'DocsSubNav',
    'DocumentRow',
    'DocumentTextStyles',
    'DomainItem',
    'Draggable',
    'DraggableRow',
    'DropOverlay',
    'DropdownItem',
    'DropdownParentFocus',
    'DropdownRoot',
    'DropdownSiblingFocus',
    'DropdownTrigger',
    'DsNavbar',
    'DynamicIsland',
    'DynamicNavbar',
    'EditInNavbarMenu',
    'EditNavbar',
    'EditRequestCard',
    'EditorArea',
    'EditorHeader',
    'EditorMain',
    'EditorPositionNavbar',
    'EditorTools',
    'EmailConfirmationError',
    'EmailConfirmationSuccess',
    'EmptyProjectCard',
    'EnvItem',
    'EnvsNavbar',
    'ExampleItemInLearn',
    'ExamplesInLearn',
    'ExplorerSwitcher',
    'ExportsInPublish',
    'ExtCapChip',
    'ExtFieldPill',
    'ExtSourceRow',
    'ExtendCard',
    'ExtensionCanvasNavbar',
    'FeedDigestSection',
    'FieldDropdown',
    'FieldDropdownGroup',
    'FieldDropdownItem',
    'FileItem',
    'FileSidebarAddNewItem',
    'FileSidebarSearch',
    'FilesCrumb',
    'FilesDesktop',
    'FilesInfoModal',
    'FilesInfoRow',
    'FilesMain',
    'FilesMarquee',
    'FilesNode',
    'FilesNodeFrame',
    'FilesNodeTile',
    'FilesOpenWithLink',
    'FilesScopeSeg',
    'FilesSection',
    'FilesSectionList',
    'FilesSectionTitle',
    'FilesSidebar',
    'FilesSidebarAction',
    'FilesSidebarGettingStarted',
    'FilesSidebarGrid',
    'FilesSidebarGroup',
    'FilesSidebarList',
    'FilesSidebarListItem',
    'FilesSidebarSection',
    'FilesSidebarTitle',
    'FilesToolBtn',
    'FilesTypeFilterRow',
    'FilesUploadLayer',
    'FilesUploadingNode',
    'FilesViewer',
    'FilterChip',
    'FlagAlwaysOnPill',
    'FlagDisclosure',
    'FlagGroupSection',
    'FlagRow',
    'FlagSwitch',
    'FlagsVoiceCard',
    'FnEditNavbar',
    'FontFamilies',
    'FontFamilyObject',
    'FontFamilyRow',
    'FontFamilySelect',
    'FontItem',
    'FontItemRow',
    'FontObject',
    'FontSelect',
    'FontSizeTool',
    'FontWeightObject',
    'GazerNavbar',
    'GeneratedAppBlocked',
    'GenericIntConfigField',
    'GenericIntInstanceCard',
    'GenericIntNewForm',
    'GlobalNotification',
    'GlobalThemeTemplate',
    'GlobalThemeTemplateRow',
    'GlobalThemesSection',
    'GovernanceFields',
    'GradientDropdown',
    'GradientSwatchItem',
    'GradientsSection',
    'GridInDropdown',
    'GridItem',
    'GroupByChip',
    'GroupByControl',
    'HTMLTypeTag',
    'HeaderBreadcrumb',
    'HeaderSearch',
    'HeaderTab',
    'HeaderTabs',
    'HeadingStyles',
    'HeatmapOverlay',
    'HistoryAllTypesRow',
    'HistoryAuthorGroup',
    'HistoryDay',
    'HistoryDensity',
    'HistoryEventCard',
    'HistoryEveryoneRow',
    'HistoryHalf',
    'HistoryHalfCards',
    'HistoryHalfLabel',
    'HistoryNotice',
    'HistoryPersonRow',
    'HistoryRail',
    'HistoryRailCount',
    'HistoryRailIsland',
    'HistoryRailRow',
    'HistoryRailToggle',
    'HistoryStage',
    'HistoryStation',
    'HistoryStepBtn',
    'HistoryTypeRow',
    'HomeAppRail',
    'HomeAppStrip',
    'HomeAppStripAll',
    'HomeAppStripItem',
    'HomeMailRow',
    'HomeNextUpBody',
    'HomePersonalize',
    'HomePersonalizeApp',
    'HomePersonalizeChoice',
    'HomePersonalizeGroup',
    'HomePersonalizeSwitch',
    'HomePosterCaption',
    'HomePosterInk',
    'HomePosterSoftInk',
    'HomeSidebar',
    'HomeSignalChip',
    'HomeSignalGlyph',
    'HomeSignalLink',
    'HomeSignalNone',
    'HomeSignalSkeletonTile',
    'HomeSignalTile',
    'HomeSignalsLine',
    'HomeSkyTile',
    'HomeSummaryBrief',
    'HomeSummaryTiles',
    'HomeTopSummary',
    'HomeWidgetAction',
    'HomeWidgetAvatars',
    'HomeWidgetBody',
    'HomeWidgetColorPicker',
    'HomeWidgetColorSwatch',
    'HomeWidgetDelta',
    'HomeWidgetDot',
    'HomeWidgetDots',
    'HomeWidgetEmpty',
    'HomeWidgetFace',
    'HomeWidgetFooter',
    'HomeWidgetFormHost',
    'HomeWidgetFrame',
    'HomeWidgetHero',
    'HomeWidgetList',
    'HomeWidgetPlate',
    'HomeWidgetProgress',
    'HomeWidgetResizeHandle',
    'HomeWidgetRow',
    'HomeWidgetSpark',
    'IconSection',
    'IconShowcaseItem',
    'IconTemplate',
    'IconTemplateRow',
    'IconTemplateWithTooltip',
    'IconsFromInsert',
    'IconsGroup',
    'IconsGroupWithCaption',
    'IconsPanelWidget',
    'Iframe',
    'ImportInInsert',
    'ImprovementCard',
    'InfraCommandPalette',
    'InfraDemoBanner',
    'InfraDemoCard',
    'InfraDeploymentRow',
    'InfraDetailDrawer',
    'InfraDomainModal',
    'InfraEdge',
    'InfraEnvPicker',
    'InfraFilterRow',
    'InfraLogRow',
    'InfraPaletteRow',
    'InfraRepoModal',
    'InfraSidebar',
    'InfraVarRow',
    'InsertPanel',
    'InsertPanelIcons',
    'InsertPanelLibrary',
    'InstallCdn',
    'InstallDomain',
    'InstallExt',
    'InstallLiveExt',
    'InstallProvider',
    'InstallSymbolsJson',
    'InstallSync',
    'InstallTabs',
    'InstallableGridCard',
    'InstallableListRow',
    'InstallableModalStub',
    'InstallableRail',
    'InstallableRailAddButton',
    'InstallableRailChip',
    'InstallableRailEmpty',
    'InstallableRailHeader',
    'InstallableRailItem',
    'IntegrationCategoryCard',
    'IntegrationCategoryGroup',
    'IntegrationFormField',
    'IntegrationKindRow',
    'IntegrationLogo',
    'IntegrationPickerBody',
    'IntegrationScopeListItem',
    'IntegrationScopeModeBtn',
    'IntegrationScopePicker',
    'IntegrationsInInsert',
    'IntegrationsItem',
    'IntegrationsPanel',
    'InterfaceLanguageField',
    'InterfaceLanguageSelect',
    'IntranetAppHeader',
    'IntroPanel',
    'IntroRun',
    'InviteDropdown',
    'InviteFormInDropdown',
    'IteratorFooter',
    'KbArticleCard',
    'KbArticleGrid',
    'KbHeader',
    'KeyValueColumnFields',
    'KnowledgeBaseMain',
    'LangSwitcher',
    'LangSwitcherItem',
    'LangSwitcherMenu',
    'LanguageSelectField',
    'LaunchOverlay',
    'LearnPanel',
    'LibrariesInLearn',
    'LibrariesRow',
    'LibrariesRowItem',
    'LibraryFrame',
    'LibraryFromInsert',
    'LibraryNavbar',
    'LibraryPickerBody',
    'LibraryPickerItem',
    'LinkedResourcePill',
    'LinkedResources',
    'ListInDropdown',
    'LogItemRow',
    'LoginWindow',
    'Logo',
    'LogoCopy',
    'LogoDropdown',
    'LogsLoadMore',
    'LogsRow',
    'LogsSidebar',
    'MCPConnectorPickerBody',
    'MadeOnSymbols',
    'MailAccountGroup',
    'MailAccountRow',
    'MailAccountSettingsCard',
    'MailAdminAccountRow',
    'MailAdminActionBtn',
    'MailAdminAuditRow',
    'MailAdminConfirmBtn',
    'MailAdminDomainChip',
    'MailAdminProviderCard',
    'MailAdminSelect',
    'MailAdminSelectOption',
    'MailAdminSharedRow',
    'MailAdminStatusBadge',
    'MailAttachmentChip',
    'MailAttachmentPreview',
    'MailAvatar',
    'MailBulkBar',
    'MailComposeDock',
    'MailComposer',
    'MailComposerAttachment',
    'MailComposerToolbar',
    'MailEmptyState',
    'MailFilterBar',
    'MailFolderGroup',
    'MailFolderRow',
    'MailHoverActions',
    'MailInviteCard',
    'MailLabelGroup',
    'MailLabelRow',
    'MailLinkMenu',
    'MailLinkMenuRow',
    'MailMain',
    'MailMessageBody',
    'MailMessageCard',
    'MailMessageHeader',
    'MailMobileRail',
    'MailMobileSidebarBar',
    'MailOverlay',
    'MailProviderButton',
    'MailRecipientChip',
    'MailRecipientOption',
    'MailSchedulePreset',
    'MailSettingsAccountRow',
    'MailSetupAction',
    'MailSetupPanel',
    'MailSetupStep',
    'MailShareChannelRow',
    'MailSidebar',
    'MailSidebarBody',
    'MailSimulatedChip',
    'MailStatusBanner',
    'MailThreadList',
    'MailThreadRow',
    'MailThreadView',
    'MainCanvasNavbar',
    'MainLoader',
    'MainNavbar',
    'MarkdownPreview',
    'MarketplaceAppHeroCard',
    'MarketplaceAppRow',
    'MarketplaceAppStoreView',
    'MarketplaceAuthorChip',
    'MarketplaceBrowseView',
    'MarketplaceCatalogRow',
    'MarketplaceCategoryChip',
    'MarketplaceCopyLinkBtn',
    'MarketplaceCover',
    'MarketplaceDetailGallery',
    'MarketplaceDetailLiveView',
    'MarketplaceDetailMarkdownBody',
    'MarketplaceDetailModal',
    'MarketplaceDetailViewTabs',
    'MarketplaceEmptyState',
    'MarketplaceFeaturedCard',
    'MarketplaceFeaturedToday',
    'MarketplaceFeedComment',
    'MarketplaceFeedComposer',
    'MarketplaceFeedFilterItem',
    'MarketplaceFeedIsland',
    'MarketplaceFeedPost',
    'MarketplaceFeedSidebar',
    'MarketplaceFilterChip',
    'MarketplaceFilters',
    'MarketplaceFollowBtn',
    'MarketplaceFollowSuggestion',
    'MarketplaceInstallButton',
    'MarketplaceInstallCatalogError',
    'MarketplaceInstallConfigField',
    'MarketplaceInstallConfigStep',
    'MarketplaceInstallDepsDialog',
    'MarketplaceInstallModal',
    'MarketplaceInstallScopeStep',
    'MarketplaceIntegrationsSection',
    'MarketplaceIntegrationsView',
    'MarketplaceIsland',
    'MarketplaceKindLink',
    'MarketplaceNavbar',
    'MarketplaceOAuthConnectButton',
    'MarketplaceRailNav',
    'MarketplaceRegistrarDomainPicker',
    'MarketplaceRegistrarSearchResult',
    'MarketplaceResultsBar',
    'MarketplaceSearchField',
    'MarketplaceShortcutsOverlay',
    'MarketplaceShortcutsRow',
    'MarketplaceSigninModal',
    'MarketplaceSurfaceHero',
    'MarketplaceSurfaceTab',
    'MarketplaceSurfaceTabs',
    'MarketplaceTemplateCard',
    'MarketplaceToast',
    'MarketplaceUninstallDependentsDialog',
    'MediaRow',
    'MeetCallWidget',
    'MeetCaptionLine',
    'MeetChatMessage',
    'MeetChatPanel',
    'MeetControlBar',
    'MeetControlBarIconButton',
    'MeetControlBarTextButton',
    'MeetCurrentMemberRow',
    'MeetFeaturedTile',
    'MeetJoinPreviewModal',
    'MeetLiveCaptions',
    'MeetMain',
    'MeetMemberPickRow',
    'MeetNewRoomModal',
    'MeetParticipantTile',
    'MeetRoomList',
    'MeetRoomRow',
    'MeetRoomSettingsModal',
    'MeetSidebar',
    'MeetSuggestionCard',
    'MeetSuggestionConfirmModal',
    'MeetTranscriptPage',
    'MeetTranscriptPanel',
    'MeetTranscriptUtterance',
    'MeetTranscriptUtteranceLine',
    'MeetVideoRoom',
    'MeetWaitingGuestRow',
    'MeetWaitingRoomBanner',
    'MemberProfile',
    'MemberProfileA11yChip',
    'MemberProfileA11yRow',
    'MembersInInvite',
    'MembersNavbar',
    'MembersTable',
    'MenuPanel',
    'MenuPanelItem',
    'Messenger',
    'MessengerOverlay',
    'MinimizedDock',
    'MinimizedDockChip',
    'MobileFrame',
    'MobileRailSheet',
    'MobileTab',
    'Modal',
    'ModalHeader',
    'ModalLayer',
    'ModalRoot',
    'ModalVideo',
    'ModalWindow',
    'ModesInNavbar',
    'MoreInsertMenu',
    'MyTicketCard',
    'NavSearchAppItem',
    'NavSearchCommandItem',
    'NavSearchLoading',
    'NavSearchNoResults',
    'NavSearchResultGroup',
    'NavSearchResultItem',
    'NavTabGlyph',
    'NavbarButton',
    'NavbarButtonSet',
    'NavbarTheming',
    'NavbarTooltipParent',
    'NewProjectPickerBody',
    'NoOrgOverlay',
    'NoteCard',
    'NoteTag',
    'NotesHeader',
    'NotesList',
    'NotesMain',
    'NotificationBell',
    'NotificationPanel',
    'NotificationRow',
    'NotificationWrapper',
    'NpTemplateCard',
    'OfficeTable',
    'OfficeTbody',
    'OfficeTd',
    'OfficeTh',
    'OfficeThead',
    'OfficeTr',
    'OnboardingOverlay',
    'OnboardingPanel',
    'OnlineMember',
    'OnlineMembers',
    'OnlineMembersDock',
    'OptionToggle',
    'OrgChartEditRow',
    'OrgChartModal',
    'OrgChartTreeNode',
    'OrgMemberRow',
    'OrgProjectRow',
    'OrgRow',
    'PageHeader',
    'PageHeaderTitle',
    'PageHero',
    'PageSkeleton',
    'PageSlot',
    'PageSlotBackdrop',
    'PageSlotHeaderBtn',
    'PageSrTitle',
    'Partner',
    'PathnameBreadcrumb',
    'PendingApprovalsSection',
    'PendingInviteCard',
    'PendingInvitesBlock',
    'PeopleFilterLink',
    'PeopleGrid',
    'PeopleGroup',
    'PeopleGroupBlock',
    'PersonCard',
    'PersonDetailModal',
    'PersonPopoverAction',
    'PersonPopoverCard',
    'PersonaPicker',
    'PersonaPill',
    'Picture',
    'PipelineBoard',
    'PipelineCard',
    'PipelineStageColumn',
    'PlatformFrame',
    'PreviewAssistant',
    'PreviewCanvasNavbar',
    'PreviewErrorBoundary',
    'PreviewModesMenu',
    'PreviewNavbar',
    'PreviewSidebar',
    'ProfileAvailabilityCell',
    'ProfileAvailabilityGrid',
    'ProjectCanvasEntityRow',
    'ProjectCanvasEnvPicker',
    'ProjectCanvasFilterRow',
    'ProjectCanvasPageRow',
    'ProjectCanvasSidebar',
    'ProjectCard',
    'ProjectCodeData',
    'ProjectCodeSchema',
    'ProjectCodeSidebar',
    'ProjectPublishModal',
    'ProjectSection',
    'ProjectTileFrame',
    'PromptGalleryCard',
    'PromptGalleryChip',
    'PromptTemplate',
    'ProviderSection',
    'PublishNavbar',
    'PublishTools',
    'QuestionMarkTooltip',
    'QuickAddPanel',
    'QuickEditor',
    'QuickEditorNavbar',
    'RatioTool',
    'ReactionPill',
    'ReadyToTestRail',
    'ReadyToTestRow',
    'ReminderComposer',
    'ReminderGroupSection',
    'ReminderMentionOption',
    'ReminderRow',
    'RemoteRowEditor',
    'RemoteRowField',
    'RemoteRowTable',
    'RemoteRowTr',
    'RemoteSchemaList',
    'RemoteTableCard',
    'RemoteUpdateBannerCard',
    'RequestCard',
    'RequestTag',
    'RequestsAuditMain',
    'RequestsInboundMain',
    'RequestsMain',
    'RequestsOutboundMain',
    'ResolutionDrawer',
    'ResolutionDrawerBackdrop',
    'ResolutionFileChip',
    'ResolutionGroupHeader',
    'ResolutionGroupSection',
    'ResolutionRow',
    'ResolutionsEditRequestsMain',
    'ResolutionsFilterBar',
    'ResolutionsGroupByBtn',
    'ResolutionsGroupByToggle',
    'ResolutionsGroupedList',
    'ResolutionsImprovementsMain',
    'ResolutionsSidebar',
    'ResponsiveSwitching',
    'RoleManagerRow',
    'RoleSelect',
    'RouterLink',
    'SamHeaderGhostBtn',
    'SaveCheckpointControl',
    'Scene',
    'SceneNavbar',
    'SceneTemplate',
    'SearchAppTile',
    'SearchAppsMenu',
    'SearchAppsSection',
    'SearchBar',
    'SearchBtn',
    'SectionBlock',
    'SelectDropdown',
    'SelectDropdownWithTitle',
    'SelectedArticlesPanel',
    'SelectedLayerNavbar',
    'SelectedNavbar',
    'SemanticColorItem',
    'SemanticColorTemplate',
    'SemanticColorTemplateRow',
    'SemanticColorsSection',
    'SequenceSliders',
    'ServiceNode',
    'SessionMenu',
    'SessionOverlayActions',
    'SettingRow',
    'SettingsDrawer',
    'SettingsFooter',
    'SettingsModalBody',
    'SettingsSection',
    'ShareLinkModal',
    'ShareLinkRow',
    'SharedViewSwitcher',
    'SharedViewSwitcherBtn',
    'SharingNavbar',
    'SharingPermissions',
    'ShortcutsOverlay',
    'ShortcutsSheetGroup',
    'ShortcutsSheetJoiner',
    'ShortcutsSheetRow',
    'ShowcaseBanner',
    'ShowcaseGrid',
    'SidebarAgentRow',
    'SidebarChatRow',
    'SidebarEventRow',
    'SidebarItemMenuItem',
    'SidebarItemMore',
    'SidebarPricingOverlay',
    'SidebarRow',
    'SidebarSignupOverlay',
    'SimoneReasoningPill',
    'SimoneSuggestions',
    'SkeletonPill',
    'SlidersResponsive',
    'SlidersTestText',
    'StandupActionCard',
    'StandupAppliedCard',
    'StandupDayCard',
    'StandupFollowUp',
    'StandupHistoryAction',
    'StandupQuickFill',
    'StandupSummaryRow',
    'StateEditNavbar',
    'StoriesSection',
    'StoryCard',
    'StoryCardSegment',
    'StudioNavbar',
    'StudioTypeFilterRow',
    'SubFlagRow',
    'SuggestionAction',
    'SyncSuggestionsInPublish',
    'SystemStatusLegendItem',
    'TVFrame',
    'TemplatesRow',
    'TemplatesRowItem',
    'Terminal',
    'TerminalApp',
    'TerminalCaret',
    'TerminalCaretIdle',
    'TerminalChromeButton',
    'TerminalEmpty',
    'TerminalPane',
    'TerminalRow',
    'TerminalSpan',
    'TerminalStage',
    'TerminalTab',
    'TerminalTabBar',
    'TerminalTitleBar',
    'TerminalWindow',
    'TerminalWithTitle',
    'TestOverlay',
    'TestText',
    'TextNavbar',
    'TextNavbarButton',
    'TextNavbarButtonDropdown',
    'TextTagStyleRow',
    'ThemeButtons',
    'ThemeCard',
    'ThemeDropdown',
    'ThemeDropdownItem',
    'ThemeField',
    'ThemeSelect',
    'ThemeTemplate',
    'ThemeTemplateRow',
    'ThemeTemplateWithValues',
    'ThemeToggle',
    'ThemesInNavbar',
    'ThemesSection',
    'TicketAttachmentRow',
    'TicketCardGrid',
    'TicketCommentRow',
    'TicketDependenciesPanel',
    'TicketDependencyDraftRow',
    'TicketDependencyMainRow',
    'TicketDependencyRow',
    'TicketMentionModal',
    'TicketsActivityHeatmap',
    'TicketsActivityRow',
    'TicketsAnswerColumn',
    'TicketsAnswerView',
    'TicketsAssigneeAvatar',
    'TicketsAssigneeGroup',
    'TicketsCard',
    'TicketsDailyUpdate',
    'TicketsDetailAssignee',
    'TicketsDetailField',
    'TicketsDetailModal',
    'TicketsDetailPersonSuggestion',
    'TicketsDraftsGroup',
    'TicketsDraftsToggle',
    'TicketsEpicCard',
    'TicketsEpicGroup',
    'TicketsEpicHeroStat',
    'TicketsEpicManageRow',
    'TicketsEpicPicker',
    'TicketsEpicsMain',
    'TicketsEpicsManageModal',
    'TicketsEpicsStoriesMain',
    'TicketsFeedMain',
    'TicketsFilterBtn',
    'TicketsFilterGroups',
    'TicketsGeneralMain',
    'TicketsHeader',
    'TicketsHeaderFilter',
    'TicketsHeatmapCell',
    'TicketsIssuerGroup',
    'TicketsKanban',
    'TicketsKanbanColumn',
    'TicketsLabelChip',
    'TicketsLogsMain',
    'TicketsMain',
    'TicketsMyViewMain',
    'TicketsReleaseHistory',
    'TicketsReleaseMain',
    'TicketsReleaseRepoChip',
    'TicketsReleaseRow',
    'TicketsReleaseShowMoreBtn',
    'TicketsReleaseStageStaging',
    'TicketsReleaseTicketRow',
    'TicketsReleaseVersionCell',
    'TicketsReleaseVersionsHeader',
    'TicketsReleaseVersionsRow',
    'TicketsReleaseVersionsStage',
    'TicketsResolutionsMain',
    'TicketsRoadmapActionBtn',
    'TicketsRoadmapActionBtnText',
    'TicketsRoadmapAttachTicketModal',
    'TicketsRoadmapCycleCard',
    'TicketsRoadmapCycleEditModal',
    'TicketsRoadmapCycleTicketRow',
    'TicketsRoadmapMain',
    'TicketsSidebar',
    'TicketsSidebarGroup',
    'TicketsSidebarItem',
    'TicketsStandupsMain',
    'TicketsStoriesEpicGroup',
    'TicketsStoriesMain',
    'TicketsStoryCard',
    'TicketsStoryChildRow',
    'TicketsStoryDetailModal',
    'TicketsStoryGroupSection',
    'TicketsTypeBtn',
    'TicketsTypeGroup',
    'TimingPanelWidget',
    'TimingRow',
    'TimingTable',
    'TitleTooltipTrigger',
    'TokenSwatch',
    'ToolCallCard',
    'TooltipRoot',
    'TooltipTrigger',
    'TriageCard',
    'TriageDensityToggle',
    'TriageFlatGroup',
    'TriageGroup',
    'TriageLabelChip',
    'TriageQuickCreate',
    'TriageRetryCTA',
    'TriageSection',
    'TriageSectionSkeleton',
    'TriageSelectionActionBar',
    'TriageSkeleton',
    'TutorialGifNotification',
    'TutorialGifNotificationSlider',
    'TutorialGifsNotificationStack',
    'TutorialItemInLearn',
    'TutorialNotification',
    'TutorialNotificationButtons',
    'TutorialNotificationStack',
    'TutorialPillsNotification',
    'TutorialsInLearn',
    'TutorialsPanel',
    'TutorialsRow',
    'TutorialsRowItem',
    'TypePreview',
    'TypeRow',
    'TypeScale',
    'TypeScaleRow',
    'TypeScaleSequence',
    'TypeSizeTitle',
    'TypeTagsStyles',
    'TypographyPanelWidget',
    'TzAvatarItem',
    'TzCluster',
    'UpcomingEventCard',
    'UploadedFonts',
    'UrlAddressBar',
    'UserProfile',
    'UserProfileFollowRow',
    'UserProfileProjectCard',
    'UserProfileTab',
    'UsernamePromptGate',
    'UsersTable',
    'VersionDetailPanel',
    'VersionDiffModalBody',
    'VersionHistoryPanel',
    'VersionRestoreConfirmBody',
    'VideoWrapper',
    'VirtualSentinel',
    'VoiceControls',
    'VoiceEngineTag',
    'VoiceLog',
    'VoiceOverlay',
    'VoiceStrip',
    'WatchVideo',
    'WhitelabelPersonaRow',
    'WhitelabelRequestAccess',
    'WhitelabelRoleRow',
    'WhitelabelSignin',
    'WhitelabelTurnstile',
    'WidgetRenderer',
    'WorkspaceActivationStatus',
    'WorkspaceCallAction',
    'WorkspaceCallPanel',
    'WorkspaceChip',
    'WorkspaceHubCard',
    'WorkspaceRow',
    'WorkspaceRowButton',
    'WorkspaceSwitcherItem',
    'WorkspaceThumb',
    'WorkspaceUiGrid',
    'WorkspaceUiRail',
    'WorkspaceUiShell',
    'WysiwygToolbar',
    'YouAreConnected',
    'YourAgentCard',
    'ZoomInNavbar',
    'Zoombar'
]);

});

parcelRegister("lo3nm", function(module, exports) {

$parcel$export(module.exports, "generatedViewStyleLint", () => $f91e75350da22a06$export$613aaf9e72c54a33);
$parcel$export(module.exports, "designSystemColorExamples", () => $f91e75350da22a06$export$8bfe5822fb2a11a);
$parcel$export(module.exports, "designSystemNames", () => $f91e75350da22a06$export$9544f421363a588e);
$parcel$export(module.exports, "pageCssVarResolver", () => $f91e75350da22a06$export$8bc8ca9e5d60f52e);
// generatedViewStyleLint.js — two style mistakes a generated ANSWER VIEW makes
// that render NOTHING, caught before it mounts (GENERATED-VIEW-STYLE-LINT-1).
//
// Measured on dev 2026-10-04 (Storm, render_answer_ui "treasury accounts with
// share bars"): every bar track was `height: 8` and `background: 'surface'`.
// smbls emits a bare number as is (`height: 8` is not a CSS length, so the
// browser drops the declaration — the track was 0 px tall) and an unknown
// colour name as is (`surface` is no colour, so the track was transparent).
// The containment gate accepted the view and said nothing; the share column
// showed percentages and no bars.
//
//   unitless-size  a length prop (width, height, padding, gap, round, …) set to
//                  a bare non-zero number or numeric string — use a spacing
//                  token ('A', 'B2', 'X') or a CSS length with its unit.
//   grid-track     a grid track list (gridTemplateColumns, columns, rows, …)
//                  that is not a string — a bare number (`columns: 3`), an
//                  array or an object (`columns: [{ size: '2fr', key: … }]`) is
//                  no track list, so the grid falls back to ONE column. Measured
//                  on dev 2026-10-05: "three tiles side by side" drew three
//                  stacked rows (columns: 3); a treasury table stacked every
//                  cell (an invented columns array). Write a track string:
//                  'repeat(3, 1fr)', '2fr 1fr 1fr 2fr'.
//   unknown-css-var  a style value that reads a CSS variable the page does not
//                  define — `var(--cerulean-9)`, `--ink-alpha-60` (measured on
//                  dev 2026-10-05: the treasury bars moved into `css: {
//                  background: 'var(--cerulean-9)' }`, an invented variable,
//                  and drew nothing). Judged only with a resolver for the live
//                  page's variables (the real ones read --color-<name>,
//                  --spacing-<token>).
//   unknown-theme  `theme: '<name>'` that is not a theme of the LIVE design
//                  system — 'caption' / 'paragraph' are COLOURS (color:
//                  'caption'), not themes, and a missing theme is ignored.
//   size-word      `size` / `boxSize` / `minSize` / `maxSize` set to a TYPE-size
//                  word ('xl', 's', 'lg', 'small', …). In DOMQL `size` is a BOX
//                  size (css-in-props block.js: inline-size + block-size), never
//                  a type size. Measured on dev 2026-10-15 (Keepz DEV, "Show me
//                  payment pay_09lUkppFn"): `Hgroup.H: { size: 'xl' }` drew
//                  35px type in an 8.3px-tall box, and the title's two lines
//                  overlapped the line under it.
//   grid-cols      `cols` on a grid-like node (extends Grid…, or display grid).
//                  `cols` is no DOMQL prop, so it is ignored and the grid draws
//                  ONE column. Measured on dev 2026-10-15 (Keepz DEV, "Show me
//                  payment pay_09lUkppFn"): `{ extends: 'Grid', cols: 2 }` put
//                  every label on its own row above its value. The track props
//                  are `columns` / `templateColumns` / `gridTemplateColumns`
//                  (css-in-props grid.js). A textarea's HTML `cols` is left be.
//   palette-fill   `background` / `backgroundColor` set to a PALETTE COLOUR on an
//                  element that carries TEXT and names no ink of its own. The
//                  theme owns the background AND the colour, so a palette fill
//                  replaces the background and leaves the theme's ink over it.
//                  Measured on dev 2026-10-05 (Storm, "a small answer view that
//                  summarizes fleet health"): `{ theme: 'card', backgroundColor:
//                  'cerulean-10' }` painted rgb(0,178,245) under the card
//                  theme's own ink rgb(188,188,194) — the body text read 1.3:1
//                  and the title 2.4:1 (AA asks 4.5:1 / 3:1). A theme whose own
//                  background IS that fill still pairs it, and an element that
//                  sets its own `color` (or a child that does) is lit; the
//                  design system's neutral surface roles are not accents.
//   unknown-icon   an Icon `name` / `icon` the live design system does not
//                  register — resolved exactly the way the framework resolves
//                  it (default-config components/Icon applyIconRender: the
//                  variant-suffix join, `toCamelCase`, then the two leading
//                  segments), so a name that paints is never refused. Measured
//                  on the same view: `name: 'symbols/support'` — a library
//                  prefix the resolver never strips — drew the `noIcon`
//                  placeholder and warned `[Icon] Unknown icon name`. Judged
//                  only with an icon table and no `iconsLoader` (which may
//                  register a name late), never a guess.
//   unknown-color  a colour prop (color, background, borderColor, fill, …) whose
//                  value is not a colour of the LIVE design system (its colours
//                  and, for backgrounds, its gradients), not a CSS colour (a
//                  named colour, #hex, rgb()/hsl()/…, var(), a gradient) and not
//                  a keyword. With no design system to read, colours are not
//                  judged (never a guess).
//
// Pure: (def, designSystem) → violations in the containment gate's shape
// ({ rule, at, detail }). Dynamic values (functions) are not judged; `state`,
// `data`, `attr`, `metadata` and `scope` bags are data, never style; the
// children of a `childrenAs: 'state'` list are data rows.
const $f91e75350da22a06$var$LENGTH_PROPS = new Set([
    'width',
    'height',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'boxSize',
    'widthRange',
    'heightRange',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingInline',
    'paddingBlock',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginInline',
    'marginBlock',
    'gap',
    'rowGap',
    'columnGap',
    'top',
    'right',
    'bottom',
    'left',
    'inset',
    'round',
    'borderRadius',
    'borderWidth',
    'fontSize',
    'letterSpacing',
    'flexBasis',
    'outlineWidth',
    'outlineOffset'
]);
const $f91e75350da22a06$var$COLOR_PROPS = new Set([
    'color',
    'background',
    'backgroundColor',
    'borderColor',
    'borderTopColor',
    'borderRightColor',
    'borderBottomColor',
    'borderLeftColor',
    'outlineColor',
    'fill',
    'stroke',
    'caretColor',
    'accentColor'
]);
const $f91e75350da22a06$var$TRACK_PROPS = new Set([
    'gridTemplateColumns',
    'gridTemplateRows',
    'gridAutoColumns',
    'gridAutoRows',
    'columns',
    'rows',
    'templateColumns',
    'templateRows',
    'autoColumns',
    'autoRows'
]);
const $f91e75350da22a06$var$BOX_SIZE_PROPS = new Set([
    'size',
    'boxSize',
    'minSize',
    'maxSize'
]);
// A type-size word, lowercase (spacing tokens are capitals: 'L', 'C1', 'A B').
const $f91e75350da22a06$var$TYPE_SIZE_WORD = /^(x{0,3}s|x{0,3}l|[2-9]x[sl]|sm|md|lg|m|small|medium|large|tiny|huge|big)$/;
// …unless the live design system registers that word as a `sizes` token:
// then it IS a box size (scratch getSizeValue looks the name up as written,
// then lower-cased, before the spacing sequence).
const $f91e75350da22a06$var$_sizeWord = (v, sizes)=>typeof v === 'string' && v.trim().split(/\s+/).some((part)=>$f91e75350da22a06$var$TYPE_SIZE_WORD.test(part) && !(sizes && (sizes[part] !== undefined || sizes[part.toLowerCase()] !== undefined)));
// A grid-like node: it extends a Grid component, or sets display: grid.
const $f91e75350da22a06$var$_gridLike = (node)=>node.display === 'grid' || node.display === 'inline-grid' || $f91e75350da22a06$var$_extendsNames(node.extends).some((n)=>/^Grid/.test(n));
const $f91e75350da22a06$var$DATA_BAGS = new Set([
    'state',
    'data',
    'attr',
    'metadata',
    'scope'
]);
const $f91e75350da22a06$var$CSS_COLOR_KEYWORDS = new Set([
    'transparent',
    'currentcolor',
    'inherit',
    'initial',
    'unset',
    'revert',
    'none'
]);
// CSS Color Module level 4 named colours.
const $f91e75350da22a06$var$CSS_NAMED_COLORS = new Set("aliceblue antiquewhite aqua aquamarine azure beige bisque black blanchedalmond blue blueviolet brown burlywood cadetblue chartreuse chocolate coral cornflowerblue cornsilk crimson cyan darkblue darkcyan darkgoldenrod darkgray darkgreen darkgrey darkkhaki darkmagenta darkolivegreen darkorange darkorchid darkred darksalmon darkseagreen darkslateblue darkslategray darkslategrey darkturquoise darkviolet deeppink deepskyblue dimgray dimgrey dodgerblue firebrick floralwhite forestgreen fuchsia gainsboro ghostwhite gold goldenrod gray green greenyellow grey honeydew hotpink indianred indigo ivory khaki lavender lavenderblush lawngreen lemonchiffon lightblue lightcoral lightcyan lightgoldenrodyellow lightgray lightgreen lightgrey lightpink lightsalmon lightseagreen lightskyblue lightslategray lightslategrey lightsteelblue lightyellow lime limegreen linen magenta maroon mediumaquamarine mediumblue mediumorchid mediumpurple mediumseagreen mediumslateblue mediumspringgreen mediumturquoise mediumvioletred midnightblue mintcream mistyrose moccasin navajowhite navy oldlace olive olivedrab orange orangered orchid palegoldenrod palegreen paleturquoise palevioletred papayawhip peachpuff peru pink plum powderblue purple rebeccapurple red rosybrown royalblue saddlebrown salmon sandybrown seagreen seashell sienna silver skyblue slateblue slategray slategrey snow springgreen steelblue tan teal thistle tomato turquoise violet wheat white whitesmoke yellow yellowgreen".split(' '));
const $f91e75350da22a06$var$CSS_COLOR_SYNTAX = /^(--|var\(|#|rgba?\(|hsla?\(|hwb\(|lab\(|lch\(|oklab\(|oklch\(|color\(|color-mix\(|(repeating-)?(linear|radial|conic)-gradient\(|url\()/i;
const $f91e75350da22a06$var$_isBareNumber = (v)=>typeof v === 'number' && Number.isFinite(v) && v !== 0 || typeof v === 'string' && /^\s*-?\d+(\.\d+)?\s*$/.test(v) && Number(v) !== 0;
// A track list is a string of tracks (or computed by a function); a number, a
// numeric string, an array or an object never is.
const $f91e75350da22a06$var$_isBadTrack = (v)=>typeof v === 'number' && Number.isFinite(v) || typeof v === 'string' && /^\s*\d+(\.\d+)?\s*$/.test(v) || Array.isArray(v) || !!v && typeof v === 'object';
const $f91e75350da22a06$var$_keysOf = (bag)=>bag && typeof bag === 'object' && !Array.isArray(bag) ? Object.keys(bag) : [];
const $f91e75350da22a06$export$692601cc50e629bb = (ds)=>{
    if (!ds || typeof ds !== 'object') return null;
    const colors = $f91e75350da22a06$var$_keysOf(ds.color || ds.COLOR);
    if (!colors.length) return null;
    return {
        colors: new Set(colors),
        gradients: new Set($f91e75350da22a06$var$_keysOf(ds.gradient || ds.GRADIENT))
    };
};
// smbls's own colour-token grammar (scratch utils/color.js COLOR_TOKEN_REGEX):
// `name[.alpha][+N|-N|=N]` with NO spaces — 'purple.2' (alpha), 'purple-10' /
// 'purple+10' (shade), 'line-highlight' (a hyphenated name). A spaced modifier
// ('blue .2') does not parse and is dropped, like an unknown name.
const $f91e75350da22a06$var$SMBLS_COLOR_TOKEN = /^([a-zA-Z]\w*(?:-[a-zA-Z]\w*)*)(?:\.(\d+))?(?:([+-]\d+|=\d+))?$/;
const $f91e75350da22a06$var$_isKnownColor = (prop, value, names)=>{
    const s = value.trim();
    if (!s || $f91e75350da22a06$var$CSS_COLOR_SYNTAX.test(s)) return true;
    const lower = s.toLowerCase();
    if ($f91e75350da22a06$var$CSS_COLOR_KEYWORDS.has(lower) || $f91e75350da22a06$var$CSS_NAMED_COLORS.has(lower)) return true;
    const gradientOk = prop === 'background' || prop === 'backgroundImage';
    if (names.colors.has(s) || gradientOk && names.gradients.has(s)) return true;
    const m = s.match($f91e75350da22a06$var$SMBLS_COLOR_TOKEN);
    if (!m) return false;
    return names.colors.has(m[1]) || gradientOk && names.gradients.has(m[1]);
};
// Keys whose string value is CONTENT, never a style (a `var(` in a label is text).
const $f91e75350da22a06$var$CONTENT_KEYS = new Set([
    'text',
    'html',
    'placeholder',
    'label',
    'title',
    'alt',
    'href',
    'src',
    'name',
    'key',
    'id',
    'value',
    'content',
    'aria-label',
    'ariaLabel'
]);
// ── Hgroup (GENERATED-VIEW-HGROUP-PLACEHOLDER-TEXT-1) ─────────────────────────
// An Hgroup draws ONLY its own two slots — `H` (the heading) and `P` (the line
// under it); it has no `title` / `subtitle` / `children` props. Measured on dev
// 2026-10-05 (Storm): generated views wrote `{ extends: 'Hgroup', title: …,
// subtitle: … }` and `{ extends: 'Hgroup', children: [ … ] }`; the workspace's
// Hgroup (the brand's) ships placeholder copy in both slots, so the view showed
// "Heading" / "Paragraph" — and an Hgroup whose slots hide themselves when
// empty showed nothing at all.
//   hgroup-empty        neither slot is filled — nothing (or only placeholder
//                       copy) would show; `detail` names what was written
//                       instead (`title`, `children`, …) when anything was
//   hgroup-placeholder  one slot is filled, the other is neither filled nor
//                       hidden and the LIVE Hgroup's slot carries default copy
//                       (`detail` "P: Paragraph") — judged only with the live
//                       components (opts.components), never a guess
const $f91e75350da22a06$var$HGROUP_STAND_INS = [
    'title',
    'subtitle',
    'heading',
    'subheading',
    'description',
    'children'
];
const $f91e75350da22a06$var$_extendsNames = (v)=>(Array.isArray(v) ? v : [
        v
    ]).filter((n)=>typeof n === 'string').map((n)=>n.split('>')[0].trim());
const $f91e75350da22a06$var$_hgroupBase = (node)=>$f91e75350da22a06$var$_extendsNames(node.extends).find((n)=>/^Hgroup/.test(n)) || null;
const $f91e75350da22a06$var$_slotFilled = (s)=>{
    if (typeof s === 'string') return !!s.trim();
    if (typeof s === 'number') return true;
    if (!s || typeof s !== 'object' || Array.isArray(s)) return false;
    if (s.text != null || s.html != null) return true;
    return Object.keys(s).some((k)=>/^[A-Z]/.test(k));
};
const $f91e75350da22a06$var$_slotHidden = (s)=>s === null || s === false || !!s && typeof s === 'object' && (s.hide === true || typeof s.hide === 'function' || s.if === false || typeof s.if === 'function' || s.display === 'none');
// The live slot's default copy — a placeholder the slot shows when the view
// leaves it — unless the live slot hides itself (`if`) when nothing fills it.
const $f91e75350da22a06$var$_slotDefaultText = (components, base, slot)=>{
    const live = components && typeof components === 'object' ? components[base] : null;
    const s = live && typeof live === 'object' ? live[slot] : null;
    if (!s || typeof s !== 'object' || s.if != null) return '';
    return typeof s.text === 'string' ? s.text.trim() : '';
};
const $f91e75350da22a06$var$_hgroupViolations = (node, path, components)=>{
    const base = $f91e75350da22a06$var$_hgroupBase(node);
    if (!base) return [];
    const at = path.join('.') || '(root)';
    const filledH = $f91e75350da22a06$var$_slotFilled(node.H);
    const filledP = $f91e75350da22a06$var$_slotFilled(node.P);
    if (!filledH && !filledP) {
        const instead = $f91e75350da22a06$var$HGROUP_STAND_INS.filter((k)=>node[k] != null);
        return [
            {
                rule: 'hgroup-empty',
                at: at,
                detail: instead.join(', ') || base
            }
        ];
    }
    const out = [];
    for (const [slot, filled] of [
        [
            'H',
            filledH
        ],
        [
            'P',
            filledP
        ]
    ]){
        if (filled || $f91e75350da22a06$var$_slotHidden(node[slot])) continue;
        const copy = $f91e75350da22a06$var$_slotDefaultText(components, base, slot);
        if (copy) out.push({
            rule: 'hgroup-placeholder',
            at: `${at}.${slot}`,
            detail: `${slot}: ${copy}`
        });
    }
    return out;
};
// Every CSS variable a style string reads: `var(--x)` anywhere, or smbls's
// bare `--x` shorthand for the whole value.
const $f91e75350da22a06$var$_cssVarsOf = (value)=>{
    const names = [];
    const re = /var\(\s*(--[A-Za-z0-9_-]+)/g;
    let m;
    while(m = re.exec(value))names.push(m[1]);
    const bare = value.trim().match(/^(--[A-Za-z0-9_-]+)$/);
    if (bare) names.push(bare[1]);
    return names;
};
// ── Palette fill under somebody else's ink (GENERATED-VIEW-PALETTE-FILL-AND-UNKNOWN-ICON-1)
// A theme pairs a background with an ink. A palette `background` /
// `backgroundColor` replaces only the background, so whatever ink was in force
// stays over the new fill — the class the ticket measured. The fill is fine
// when something pairs it: a theme whose OWN background is that same fill, an
// ink the element sets for itself, or an ink every text under it sets.
const $f91e75350da22a06$var$FILL_PROPS = new Set([
    'background',
    'backgroundColor'
]);
// The design system's neutral SURFACE roles — a plate colour, not an accent.
// They are made to sit under the current ink, so a fill with one of them keeps
// the pairing. Only names the live system carries are ever exempt.
const $f91e75350da22a06$var$NEUTRAL_FILL_ROLES = new Set([
    'overlay',
    'highlight',
    'hover',
    'line',
    'shadow',
    'blur'
]);
// Copy a plate carries itself. A function is content too (it computes text).
const $f91e75350da22a06$var$TEXT_KEYS = [
    'text',
    'html'
];
const $f91e75350da22a06$var$_carriesOwnText = (node)=>{
    for (const key of $f91e75350da22a06$var$TEXT_KEYS){
        const value = node[key];
        if (typeof value === 'string' ? !!value.trim() : value != null) return true;
    }
    return false;
};
// An element brings its OWN PAIR when it sets a theme: a theme owns the
// background and the ink together, so it is its own plate and never reads the
// fill above it. A bare `color` is NOT a pair — it is one ink over somebody
// else's fill, and the measured view proves the difference: white over
// cerulean-10 still reads 2.4:1, under the 3:1 floor a large title needs.
const $f91e75350da22a06$var$_bringsOwnPair = (node)=>typeof node.theme === 'string' && !!node.theme.trim();
// The path of the first text under `node` that no element between the fill and
// that text pairs an ink with; null when every text is paired (or there is
// none). `depth` 0 is the fill's own element — its theme is exactly what the
// fill overrode, so it never pairs the branch.
const $f91e75350da22a06$var$_unlitText = (node, path, depth)=>{
    if (!node || typeof node !== 'object') return null;
    if (Array.isArray(node)) {
        for(let i = 0; i < node.length; i++){
            const hit = $f91e75350da22a06$var$_unlitText(node[i], path.concat(String(i)), depth + 1);
            if (hit) return hit;
        }
        return null;
    }
    if (depth > 0 && $f91e75350da22a06$var$_bringsOwnPair(node)) return null;
    if ($f91e75350da22a06$var$_carriesOwnText(node)) return path.join('.') || '(root)';
    for (const key of Object.keys(node)){
        if ($f91e75350da22a06$var$DATA_BAGS.has(key)) continue;
        const value = node[key];
        if (!value || typeof value !== 'object') continue;
        const hit = $f91e75350da22a06$var$_unlitText(value, path.concat(key), depth + 1);
        if (hit) return hit;
    }
    return null;
};
// Every background a theme names, across its scheme blocks ('@dark', '@light')
// and its nested states — the fills that theme already pairs with an ink.
const $f91e75350da22a06$var$_themeBackgrounds = (theme)=>{
    const names = new Set();
    const visit = (value, depth)=>{
        if (!value || typeof value !== 'object' || Array.isArray(value) || depth > 4) return;
        for (const key of Object.keys(value)){
            const v = value[key];
            if ($f91e75350da22a06$var$FILL_PROPS.has(key) && typeof v === 'string') names.add(v.trim());
            else visit(v, depth + 1);
        }
    };
    visit(theme, 0);
    return names;
};
const $f91e75350da22a06$var$_themeFills = (ds)=>{
    const themes = ds && (ds.theme || ds.THEME);
    if (!themes || typeof themes !== 'object') return null;
    const out = {};
    for (const name of Object.keys(themes))out[name] = $f91e75350da22a06$var$_themeBackgrounds(themes[name]);
    return out;
};
// The live design system's own name for this fill, or null when the value is
// not a palette colour: a CSS colour, a keyword, a gradient and an unknown
// name are all somebody else's rule ('unknown-color' judges the last one).
const $f91e75350da22a06$var$_paletteFillName = (value, names)=>{
    if (typeof value !== 'string') return null;
    const s = value.trim();
    if (!s || $f91e75350da22a06$var$CSS_COLOR_SYNTAX.test(s)) return null;
    if ($f91e75350da22a06$var$CSS_COLOR_KEYWORDS.has(s.toLowerCase())) return null;
    if (names.colors.has(s)) return s;
    const m = s.match($f91e75350da22a06$var$SMBLS_COLOR_TOKEN);
    return m && names.colors.has(m[1]) ? m[1] : null;
};
// ── Icon names (GENERATED-VIEW-PALETTE-FILL-AND-UNKNOWN-ICON-1) ──────────────
// `toCamelCase` of @symbo.ls/utils (packages/utils/string-extra.js), for a
// caller with no live utils to lend; `opts.toCamelCase` wins when there is one,
// so the gate resolves a name with the very function the framework uses.
const $f91e75350da22a06$var$_toCamelCase = (str)=>String(str == null ? '' : str).replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index)=>index === 0 ? word.toLowerCase() : word.toUpperCase()).replace(/\s+/g, '');
// An Icon: a literal `extends: 'Icon'`, or DOMQL's key-based auto-extend
// (`Icon: {…}`, `Icon_1: {…}` resolve to the registered component).
const $f91e75350da22a06$var$_isIconNode = (node, key)=>$f91e75350da22a06$var$_extendsNames(node.extends).includes('Icon') || /^Icon(_|$)/.test(String(key == null ? '' : key));
// The framework's own resolution, mirrored (default-config components/Icon
// `applyIconRender`): the variant-suffix join ('deviceBigScreen outline' →
// 'deviceBigScreenOutline'), `toCamelCase`, then `icons[camel]`,
// `icons[seg0+seg1]`, `icons[seg0]`.
const $f91e75350da22a06$var$_iconLookup = (raw, camelOf)=>{
    let name = raw.trim();
    if (name.includes(' ')) {
        const parts = name.split(/\s+/);
        name = parts[0] + parts.slice(1).map((p)=>p.charAt(0).toUpperCase() + p.slice(1)).join('');
    }
    const camel = camelOf(name);
    const seg = camel.split(/([a-z])([A-Z])/g);
    return [
        camel,
        seg[0] + seg[1],
        seg[0]
    ];
};
const $f91e75350da22a06$var$_iconResolves = (raw, icons, camelOf)=>{
    if (!raw.trim()) return true;
    return $f91e75350da22a06$var$_iconLookup(raw, camelOf).some((k)=>!!icons[k]);
};
// `semanticIcons` answers a whole family by its root word (an SF Symbols name),
// so a name that family covers paints and is never refused.
const $f91e75350da22a06$var$_semanticIconCovers = (raw, semanticIcons, camelOf)=>{
    if (!semanticIcons || typeof semanticIcons !== 'object') return false;
    const camel = camelOf(raw);
    const seg = camel.split(/([a-z])([A-Z])/g);
    const root = seg[1] ? seg[0] : raw.split('.')[0].split(' ')[0];
    return !!semanticIcons[root];
};
// The registered names nearest a miss: the bare name after a `library/` prefix
// when THAT one is registered (the resolver never strips the prefix itself),
// then the registered names that share the miss's own word, shortest first.
const $f91e75350da22a06$var$_nearIcons = (raw, icons, camelOf, max = 3)=>{
    const out = [];
    const push = (n)=>{
        if (n && !out.includes(n) && out.length < max) out.push(n);
    };
    const slash = raw.indexOf('/');
    if (slash > 0) {
        const bare = raw.slice(slash + 1).trim();
        if (bare && $f91e75350da22a06$var$_iconResolves(bare, icons, camelOf)) push(bare);
    }
    // compared on letters alone, so 'cloud-outline' finds 'cloudOutline': the
    // separators a model guesses are exactly what a name match must ignore.
    const plain = (s)=>camelOf(s).toLowerCase().replace(/[^a-z0-9]/g, '');
    const needle = plain(raw.replace(/^[^/]*\//, ''));
    if (needle.length >= 3) Object.keys(icons).filter((k)=>{
        const l = plain(k);
        return l === needle || l.includes(needle) || l.length >= 3 && needle.includes(l);
    }).sort((a, b)=>a.length - b.length || (a < b ? -1 : 1)).forEach(push);
    return out;
};
function $f91e75350da22a06$export$613aaf9e72c54a33(def, designSystem, opts = {}) {
    const names = $f91e75350da22a06$export$692601cc50e629bb(designSystem);
    const themes = $f91e75350da22a06$var$_keysOf(designSystem && (designSystem.theme || designSystem.THEME));
    const themeNames = themes.length ? new Set(themes) : null;
    const sizesTable = designSystem && (designSystem.sizes || designSystem.SIZES);
    const sizes = sizesTable && typeof sizesTable === 'object' ? sizesTable : null;
    // (name) => true | false | null — null when the page cannot say (never judged)
    const cssVarDefined = typeof opts.cssVarDefined === 'function' ? opts.cssVarDefined : null;
    // the live component registry — the Hgroup rule reads its slots' default copy
    const components = opts.components && typeof opts.components === 'object' ? opts.components : null;
    // the backgrounds each theme already pairs with an ink ('palette-fill')
    const themeFills = $f91e75350da22a06$var$_themeFills(designSystem);
    // the live icon set ('unknown-icon'). An `iconsLoader` may register a name
    // after boot, so with one in place no icon name is judged.
    const iconsTable = designSystem && (designSystem.icons || designSystem.ICONS);
    const icons = iconsTable && typeof iconsTable === 'object' && Object.keys(iconsTable).length && typeof (designSystem.iconsLoader || designSystem.ICONS_LOADER) !== 'function' ? iconsTable : null;
    const semanticIcons = designSystem && designSystem.semanticIcons;
    const camelOf = typeof opts.toCamelCase === 'function' ? opts.toCamelCase : $f91e75350da22a06$var$_toCamelCase;
    const out = [];
    const seen = new WeakSet();
    const walk = (node, path)=>{
        if (!node || typeof node !== 'object' || seen.has(node)) return;
        seen.add(node);
        if (Array.isArray(node)) {
            node.forEach((item, i)=>walk(item, path.concat(String(i))));
            return;
        }
        out.push(...$f91e75350da22a06$var$_hgroupViolations(node, path, components));
        if (node.cols != null && typeof node.cols !== 'function' && $f91e75350da22a06$var$_gridLike(node)) out.push({
            rule: 'grid-cols',
            at: path.concat('cols').join('.'),
            detail: `cols: ${node.cols}`
        });
        // A palette fill on a plate that carries text, with no ink paired to it.
        if (names) for (const key of [
            'background',
            'backgroundColor'
        ]){
            const fill = $f91e75350da22a06$var$_paletteFillName(node[key], names);
            if (!fill || $f91e75350da22a06$var$NEUTRAL_FILL_ROLES.has(fill)) continue;
            const pairedByTheme = themeFills && typeof node.theme === 'string' && node.theme.trim().split(/\s+/).some((t)=>themeFills[t] && themeFills[t].has(String(node[key]).trim()));
            if (pairedByTheme) continue;
            if (!$f91e75350da22a06$var$_unlitText(node, path, 0)) continue;
            out.push({
                rule: 'palette-fill',
                at: path.concat(key).join('.') || key,
                detail: `${key}: ${String(node[key]).trim()}`
            });
        }
        // An Icon name the live design system does not register.
        if (icons && $f91e75350da22a06$var$_isIconNode(node, path[path.length - 1]) && node.src == null) {
            const raw = typeof node.name === 'string' ? node.name : node.icon;
            if (typeof raw === 'string' && raw.trim() && !raw.includes('{{')) {
                if (!$f91e75350da22a06$var$_iconResolves(raw, icons, camelOf) && !$f91e75350da22a06$var$_semanticIconCovers(raw, semanticIcons, camelOf)) {
                    const near = $f91e75350da22a06$var$_nearIcons(raw, icons, camelOf);
                    out.push({
                        rule: 'unknown-icon',
                        at: path.concat(typeof node.name === 'string' ? 'name' : 'icon').join('.'),
                        detail: raw.trim(),
                        ...near.length ? {
                            near: near.join(', ')
                        } : {}
                    });
                }
            }
        }
        const dataRows = node.childrenAs === 'state';
        for (const key of Object.keys(node)){
            const value = node[key];
            if ($f91e75350da22a06$var$DATA_BAGS.has(key)) continue;
            if (key === 'children' && dataRows) continue;
            // checked BEFORE the walk: an array / object on a track key is the error
            // itself, never a child to descend into
            if ($f91e75350da22a06$var$TRACK_PROPS.has(key) && $f91e75350da22a06$var$_isBadTrack(value)) {
                out.push({
                    rule: 'grid-track',
                    at: path.concat(key).join('.'),
                    detail: `${key}: ${typeof value === 'object' ? Array.isArray(value) ? "[\u2026]" : "{\u2026}" : value}`
                });
                continue;
            }
            if (value && typeof value === 'object') {
                walk(value, path.concat(key));
                continue;
            }
            if (cssVarDefined && typeof value === 'string' && !$f91e75350da22a06$var$CONTENT_KEYS.has(key)) {
                const missing = $f91e75350da22a06$var$_cssVarsOf(value).filter((v)=>cssVarDefined(v) === false);
                if (missing.length) {
                    for (const v of missing){
                        // the near miss the page DOES define ('--purple' → --color-purple)
                        const bare = v.replace(/^--(color-|spacing-)?/, '');
                        const near = [
                            '--color-' + bare,
                            '--spacing-' + bare
                        ].find((c)=>c !== v && cssVarDefined(c) === true);
                        out.push({
                            rule: 'unknown-css-var',
                            at: path.concat(key).join('.'),
                            detail: v,
                            ...near ? {
                                near: near
                            } : {}
                        });
                    }
                    continue;
                }
            }
            if (key === 'theme' && themeNames && typeof value === 'string' && value.trim() && !themeNames.has(value.trim().split(/\s+/)[0])) out.push({
                rule: 'unknown-theme',
                at: path.concat(key).join('.'),
                detail: value.trim()
            });
            else if ($f91e75350da22a06$var$BOX_SIZE_PROPS.has(key) && $f91e75350da22a06$var$_sizeWord(value, sizes)) out.push({
                rule: 'size-word',
                at: path.concat(key).join('.'),
                detail: `${key}: ${value.trim()}`
            });
            else if ($f91e75350da22a06$var$LENGTH_PROPS.has(key) && $f91e75350da22a06$var$_isBareNumber(value)) out.push({
                rule: 'unitless-size',
                at: path.concat(key).join('.'),
                detail: `${key}: ${value}`
            });
            else if (names && $f91e75350da22a06$var$COLOR_PROPS.has(key) && typeof value === 'string' && !$f91e75350da22a06$var$_isKnownColor(key, value, names)) out.push({
                rule: 'unknown-color',
                at: path.concat(key).join('.'),
                detail: value.trim()
            });
        }
    };
    walk(def, []);
    return out;
}
// A few of the live design system's own colour names for the hint (never a
// hardcoded palette): its hue names first (the ones CSS also knows — blue,
// green, red, …), then its short lowercase names (title, caption, …); never a
// camelCase app colour or a numbered grey.
// The usual semantic roles, offered first when the live design system has
// them (text: title / caption / paragraph; lines and surfaces: line / overlay /
// highlight / hover) — a model that wrote 'surface' needs a ROLE, not a hue.
// Only names the live system carries are ever offered.
const $f91e75350da22a06$var$SEMANTIC_ROLES = [
    'title',
    'caption',
    'paragraph',
    'line',
    'overlay',
    'highlight',
    'hover'
];
const $f91e75350da22a06$export$8bfe5822fb2a11a = (designSystem, max = 8)=>{
    const names = $f91e75350da22a06$export$692601cc50e629bb(designSystem);
    if (!names) return [];
    const roles = $f91e75350da22a06$var$SEMANTIC_ROLES.filter((n)=>names.colors.has(n)).slice(0, Math.ceil(max / 2));
    const hues = [
        ...names.colors
    ].filter((n)=>$f91e75350da22a06$var$CSS_NAMED_COLORS.has(n) && !/^(gr[ae]y|black|white)/.test(n));
    return [
        ...roles,
        ...hues
    ].slice(0, max);
};
const $f91e75350da22a06$export$9544f421363a588e = (designSystem, { maxColors: maxColors = 32, maxThemes: maxThemes = 24 } = {})=>{
    const names = $f91e75350da22a06$export$692601cc50e629bb(designSystem);
    const colors = [];
    if (names) {
        const all = [
            ...names.colors
        ];
        const push = (n)=>{
            if (!colors.includes(n)) colors.push(n);
        };
        $f91e75350da22a06$var$SEMANTIC_ROLES.filter((n)=>names.colors.has(n)).forEach(push);
        all.filter((n)=>$f91e75350da22a06$var$CSS_NAMED_COLORS.has(n)).forEach(push);
        all.filter((n)=>/^[a-z]+(-[a-z]+)?$/.test(n)).forEach(push);
    }
    const themes = $f91e75350da22a06$var$_keysOf(designSystem && (designSystem.theme || designSystem.THEME)).filter((n)=>/^[a-z]+$/.test(n));
    return {
        colors: colors.slice(0, maxColors),
        themes: themes.slice(0, maxThemes)
    };
};
const $f91e75350da22a06$export$8bc8ca9e5d60f52e = ()=>{
    const doc = typeof globalThis !== 'undefined' ? globalThis.document : null;
    const gcs = typeof globalThis !== 'undefined' ? globalThis.getComputedStyle : null;
    if (!doc || !doc.documentElement || typeof gcs !== 'function') return null;
    let style = null;
    return (name)=>{
        try {
            if (!style) style = gcs(doc.documentElement);
            return !!String(style.getPropertyValue(name) || '').trim();
        } catch (_) {
            return null;
        }
    };
};

});

parcelRegister("7iHfb", function(module, exports) {

$parcel$export(module.exports, "GENERATED_APP_BLOCKED", () => $550bc22b1fc9006b$export$eb8b908f1e573aaa);
$parcel$export(module.exports, "generatedAppAuditHook", () => $550bc22b1fc9006b$export$779218b3dbe76ef7);
// @symbo.ls/app-rules audit — the AST gate for AI-generated app pages.
//
// The rules are data in rules.js (no imports; every consumer reads the same lists).
// This module parses the EXACT text the freestyle parser evaluates (acorn — a
// runtime dependency of the shared package already, no regex) and refuses:
//   • any free identifier outside GENERATED_APP_GLOBALS (window, self, top,
//     frames, opener, document, fetch, Function, eval, … fall out by
//     construction), resolved per lexical scope so a local `let self` in one
//     function never hides a global `self` in another; `arguments` always;
//   • GENERATED_APP_BLOCKED_MEMBERS as a member, a destructured key or a
//     literal computed key, any `__`-prefixed member, `.apply` / `.bind`, and
//     a computed member key that is not a literal;
//   • `.call` anywhere except `x.call('<allowlisted literal>', …)`;
//   • on an EVENT handle (first parameter of a DOMQL `on<Event>` handler) any
//     member outside GENERATED_APP_EVENT_MEMBERS (`e.view` is the window), and
//     on `e.target` any member outside GENERATED_APP_TARGET_MEMBERS;
//   • on an ELEMENT handle (`el`, `this`) any member outside
//     GENERATED_APP_ELEMENT_MEMBERS — in-shell every shell method is a
//     property of every element, `el.sdk` included;
//   • a handle that escapes: an event / element / `this` may only be the object
//     of a member read or an argument to an allowlisted `el.call`;
//   • `x.root` not followed by a key that passes the seed deny list, and any
//     write (assignment, update, delete, state write method) under a `.root`
//     chain — in-shell `s.root` is the LIVE workspace root;
//   • reflective members of globals (Object.getPrototypeOf, …) and string
//     literals naming GENERATED_APP_BLOCKED_STRINGS;
//   • `with`, tagged templates, `import()`, `import.meta`, `new.target`,
//     setTimeout / setInterval with anything but a function;
//   • and the same inside any string that parses as a function (a
//     JSON-authored source carries its handlers as strings that the parser
//     destringifies and evaluates).

var $gQuVO = parcelRequire("gQuVO");

var $cmUBA = parcelRequire("cmUBA");
const $550bc22b1fc9006b$var$BLOCKED_MEMBERS = new Set($cmUBA.GENERATED_APP_BLOCKED_MEMBERS);
const $550bc22b1fc9006b$var$BLOCKED_STRINGS = new Set($cmUBA.GENERATED_APP_BLOCKED_STRINGS);
const $550bc22b1fc9006b$var$INDIRECTION = new Set($cmUBA.GENERATED_APP_BLOCKED_INDIRECTION);
const $550bc22b1fc9006b$var$GLOBALS = new Set($cmUBA.GENERATED_APP_GLOBALS);
const $550bc22b1fc9006b$var$EVENT_MEMBERS = new Set($cmUBA.GENERATED_APP_EVENT_MEMBERS);
const $550bc22b1fc9006b$var$TARGET_MEMBERS = new Set($cmUBA.GENERATED_APP_TARGET_MEMBERS);
const $550bc22b1fc9006b$var$TARGET_DEEP = new Set($cmUBA.GENERATED_APP_TARGET_DEEP_MEMBERS);
const $550bc22b1fc9006b$var$ELEMENT_MEMBERS = new Set($cmUBA.GENERATED_APP_ELEMENT_MEMBERS);
const $550bc22b1fc9006b$var$LIFECYCLE = new Set($cmUBA.GENERATED_APP_LIFECYCLE_HANDLERS);
const $550bc22b1fc9006b$var$ROOT_DENY = new Set($cmUBA.GENERATED_APP_ROOT_DENY_KEYS);
const $550bc22b1fc9006b$var$ROOT_DENY_RE = new RegExp($cmUBA.GENERATED_APP_ROOT_DENY_PATTERN, 'i');
const $550bc22b1fc9006b$var$ROOT_WRITES = new Set($cmUBA.GENERATED_APP_ROOT_WRITE_METHODS);
const $550bc22b1fc9006b$var$GLOBAL_MEMBERS = $cmUBA.GENERATED_APP_GLOBAL_MEMBERS;
const $550bc22b1fc9006b$var$TAGS = new Set($cmUBA.GENERATED_APP_TAG_ALLOWLIST);
const $550bc22b1fc9006b$var$COMPONENT_ALLOW = new Set($cmUBA.GENERATED_APP_COMPONENT_ALLOWLIST);
const $550bc22b1fc9006b$var$COMPONENT_DENY = new Set($cmUBA.GENERATED_APP_COMPONENT_DENYLIST);
const $550bc22b1fc9006b$var$MARKUP_KEYS = new Set($cmUBA.GENERATED_APP_MARKUP_KEYS);
const $550bc22b1fc9006b$var$URL_KEYS = new Set($cmUBA.GENERATED_APP_URL_KEYS);
const $550bc22b1fc9006b$var$URL_SCHEMES = new Set($cmUBA.GENERATED_APP_URL_SCHEMES);
const $550bc22b1fc9006b$var$CSS_URL_KEYS = new Set($cmUBA.GENERATED_APP_CSS_URL_KEYS);
const $550bc22b1fc9006b$var$DEEP_CHAIN = $cmUBA.GENERATED_APP_TARGET_DEEP_CHAIN;
const $550bc22b1fc9006b$var$EVENT_VALUE = new Set($cmUBA.GENERATED_APP_EVENT_VALUE_MEMBERS);
const $550bc22b1fc9006b$var$TARGET_VALUE = new Set($cmUBA.GENERATED_APP_TARGET_VALUE_MEMBERS);
// A URL string is safe when, with whitespace and control characters removed
// (browsers ignore them in a scheme), it has no scheme (relative) or one of
// GENERATED_APP_URL_SCHEMES; `src` may also be an inline image.
const $550bc22b1fc9006b$var$urlSchemeOf = (str)=>{
    const clean = String(str).replace(/[\u0000-\u0020\u007f-\u009f]/g, '');
    const m = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(clean);
    return {
        clean: clean,
        scheme: m ? m[1].toLowerCase() : null
    };
};
const $550bc22b1fc9006b$var$isSafeUrl = (str, key)=>{
    const { clean: clean, scheme: scheme } = $550bc22b1fc9006b$var$urlSchemeOf(str);
    if (!scheme) return true;
    if ($550bc22b1fc9006b$var$URL_SCHEMES.has(scheme)) return true;
    return key === 'src' && clean.toLowerCase().startsWith($cmUBA.GENERATED_APP_SRC_DATA_PREFIX);
};
// A leading literal fixes the whole ORIGIN when it is a SAME-ORIGIN PATH: one
// '/' followed by a character that is neither '/' nor a backslash (both open a
// host — a browser reads '/\evil.example' as '//evil.example'), or a '?' / '#' that
// keeps the address on this page. Nothing appended after such a prefix can
// introduce a scheme or a host. A prefix that carries a SCHEME is not enough:
// 'https://example.com/' + id fixes the scheme and leaves the host to the
// expression, so it stays refused.
const $550bc22b1fc9006b$var$sameOriginPathPrefix = (prefix)=>{
    const { clean: clean, scheme: scheme } = $550bc22b1fc9006b$var$urlSchemeOf(prefix);
    if (scheme) return false;
    return /^(?:\/[^/\\]|[?#])/.test(clean);
};
// The leftmost part of an address built at run time: the first operand of a
// `+` chain, or the first quasi of a template literal. `null` when the left
// end is itself an expression (`${base}/x`, `base + '/x'`).
const $550bc22b1fc9006b$var$leftmostLiteral = (v)=>{
    let n = v;
    while(n && n.type === 'BinaryExpression' && n.operator === '+')n = n.left;
    if (!n) return null;
    if (n.type === 'TemplateLiteral') return n.quasis[0] ? n.quasis[0].value.cooked : null;
    return $550bc22b1fc9006b$var$literalString(n);
};
const $550bc22b1fc9006b$export$eb8b908f1e573aaa = 'generated_app_blocked';
const $550bc22b1fc9006b$var$isFnNode = (n)=>!!n && (n.type === 'ArrowFunctionExpression' || n.type === 'FunctionExpression' || n.type === 'FunctionDeclaration');
const $550bc22b1fc9006b$var$literalString = (n)=>{
    if (!n) return null;
    if (n.type === 'Literal' && (typeof n.value === 'string' || typeof n.value === 'number')) return String(n.value);
    if (n.type === 'TemplateLiteral' && n.expressions.length === 0) return n.quasis.map((q)=>q.value.cooked).join('');
    return null;
};
const $550bc22b1fc9006b$var$propName = (prop)=>{
    if (!prop) return null;
    if (prop.computed) return $550bc22b1fc9006b$var$literalString(prop.key);
    if (prop.key.type === 'Identifier') return prop.key.name;
    return $550bc22b1fc9006b$var$literalString(prop.key);
};
const $550bc22b1fc9006b$var$memberName = (m)=>{
    if (!m.computed) return m.property.type === 'PrivateIdentifier' ? '#' + m.property.name : m.property.name;
    return $550bc22b1fc9006b$var$literalString(m.property);
};
const $550bc22b1fc9006b$var$looksLikeFunctionText = (s)=>/=>|^\s*(async\s+)?function\b/.test(s);
const $550bc22b1fc9006b$var$parsesAsFunction = (s)=>{
    try {
        const e = (0, $gQuVO.parse)('(' + s + ')', {
            ecmaVersion: 'latest',
            sourceType: 'script'
        }).body[0];
        return !!e && $550bc22b1fc9006b$var$isFnNode(e.expression);
    } catch (_) {
        return false;
    }
};
// Role of each parameter of a function that is the value of DOMQL key `key`.
// Functions under these keys take their own arguments (the app's own
// `functions`, a `scope` helper, a `fetch` transform …): their parameters are
// plain values. `this` stays an element and the member denylist still applies.
const $550bc22b1fc9006b$var$PLAIN_FN_KEYS = new Set([
    'functions',
    'methods',
    'scope',
    'fetch'
]);
const $550bc22b1fc9006b$var$paramRoles = (key)=>{
    if (typeof key === 'string' && /^on[A-Z]/.test(key) && !$550bc22b1fc9006b$var$LIFECYCLE.has(key)) return [
        'event',
        'element',
        'state'
    ];
    if (typeof key === 'string') return [
        'element',
        'state'
    ];
    return [];
};
function $550bc22b1fc9006b$export$5939d66fa205155a(text, { allow: allow = $cmUBA.APP_EL_CALL_ALLOWLIST, rootKeys: rootKeys = [], registeredComponents: registeredComponents = null } = {}) {
    const violations = [];
    const allowSet = new Set(allow);
    const flag = (rule, node, detail)=>{
        violations.push({
            rule: rule,
            at: node && typeof node.start === 'number' ? node.start : null,
            detail: detail
        });
    };
    let ast;
    try {
        ast = (0, $gQuVO.parse)(String(text || ''), {
            ecmaVersion: 'latest',
            sourceType: 'script'
        });
    } catch (e) {
        return {
            ok: false,
            violations: [
                {
                    rule: 'parse',
                    at: null,
                    detail: e && e.message || String(e)
                }
            ]
        };
    }
    // `s.root.<key>`: the readable keys are an Array or a Set (the active
    // module's catalog stateKeys + loader write keys) plus the `fetch` `as`
    // targets this source declares itself. ANY other value — undefined, null, a
    // string, an object — is [] (every root read refused); there is no
    // deny-list-only mode (core-wl review of 1ecd5e8b6).
    const rootAllow = new Set(Array.isArray(rootKeys) || rootKeys instanceof Set ? [
        ...rootKeys
    ] : []);
    const collectAs = (n)=>{
        if (!n || typeof n !== 'object') return;
        if (Array.isArray(n)) return n.forEach(collectAs);
        if (n.type === 'Property' && $550bc22b1fc9006b$var$propName(n) === 'as') {
            const v = $550bc22b1fc9006b$var$literalString(n.value);
            if (v) rootAllow.add(v.replace(/^~?\/?/, ''));
        }
        for(const k in n)if (k !== 'type' && n[k] && typeof n[k] === 'object') collectAs(n[k]);
    };
    collectAs(ast);
    // Components: the allowlist + the app's own `components:` names when no
    // registered or denied component carries the name (the supplementary
    // registry never shadows one, so the app's def would not be what renders).
    const registered = Array.isArray(registeredComponents) ? new Set(registeredComponents) : null;
    const ownComponents = new Set();
    const collectOwn = (n)=>{
        if (!n || typeof n !== 'object') return;
        if (Array.isArray(n)) return n.forEach(collectOwn);
        if (n.type === 'Property' && $550bc22b1fc9006b$var$propName(n) === 'components' && n.value && n.value.type === 'ObjectExpression') for (const q of n.value.properties){
            const name = q.type === 'Property' ? $550bc22b1fc9006b$var$propName(q) : null;
            if (name && !$550bc22b1fc9006b$var$COMPONENT_DENY.has(name) && !(registered && registered.has(name))) ownComponents.add(name);
        }
        for(const k in n)if (k !== 'type' && n[k] && typeof n[k] === 'object') collectOwn(n[k]);
    };
    collectOwn(ast);
    const componentAllowed = (name)=>$550bc22b1fc9006b$var$COMPONENT_ALLOW.has(name) || ownComponents.has(name);
    const checkExtendsValue = (v, node)=>{
        const names = [];
        if (v && v.type === 'ArrayExpression') for (const e of v.elements){
            const lit = $550bc22b1fc9006b$var$literalString(e);
            if (lit == null) return flag('component_not_allowed', node, '(computed)');
            names.push(lit);
        }
        else {
            const lit = $550bc22b1fc9006b$var$literalString(v);
            if (lit == null) return flag('component_not_allowed', node, '(computed)');
            names.push(lit);
        }
        for (const n of names){
            const base = n.split('>')[0].trim();
            if (!componentAllowed(base)) flag('component_not_allowed', node, base);
        }
    };
    // A bare PascalCase child key resolves to a registered component of that
    // name (the part before `_`): refused when the name is denied, or, with
    // the live registry, registered and off the list. Other keys are labels.
    const checkBareKey = (key, node)=>{
        if (!/^[A-Z]/.test(key)) return;
        const base = key.split('_')[0];
        if (componentAllowed(base)) return;
        if ($550bc22b1fc9006b$var$COMPONENT_DENY.has(base) || registered && registered.has(base)) flag('component_not_allowed', node, base);
    };
    // ── scopes ──────────────────────────────────────────────────────────────
    const newScope = (parent)=>({
            parent: parent,
            names: new Map()
        });
    const resolve = (scope, name)=>{
        for(let s = scope; s; s = s.parent)if (s.names.has(name)) return {
            declared: true,
            role: s.names.get(name)
        };
        return {
            declared: false,
            role: null
        };
    };
    const patternNames = (p, out = [])=>{
        if (!p) return out;
        if (p.type === 'Identifier') out.push(p.name);
        else if (p.type === 'ObjectPattern') p.properties.forEach((q)=>patternNames(q.type === 'RestElement' ? q.argument : q.value, out));
        else if (p.type === 'ArrayPattern') p.elements.forEach((q)=>patternNames(q, out));
        else if (p.type === 'RestElement') patternNames(p.argument, out);
        else if (p.type === 'AssignmentPattern') patternNames(p.left, out);
        return out;
    };
    // Block-level declarations of a statement list (let/const/class/function).
    const declareBlock = (scope, body)=>{
        for (const st of body || []){
            if (st.type === 'VariableDeclaration' && st.kind !== 'var') st.declarations.forEach((d)=>patternNames(d.id).forEach((n)=>scope.names.set(n, 'plain')));
            else if ((st.type === 'ClassDeclaration' || st.type === 'FunctionDeclaration') && st.id) scope.names.set(st.id.name, 'plain');
        }
    };
    // `var` declarations hoist to the function scope (not into nested functions).
    const declareVars = (scope, node)=>{
        if (!node || typeof node !== 'object') return;
        if (Array.isArray(node)) return node.forEach((n)=>declareVars(scope, n));
        if ($550bc22b1fc9006b$var$isFnNode(node) || node.type === 'ClassBody') return;
        if (node.type === 'VariableDeclaration' && node.kind === 'var') node.declarations.forEach((d)=>patternNames(d.id).forEach((n)=>scope.names.set(n, 'plain')));
        for(const k in node){
            if (k === 'type' || k === 'start' || k === 'end') continue;
            const v = node[k];
            if (v && typeof v === 'object') declareVars(scope, v);
        }
    };
    // ── member chains ───────────────────────────────────────────────────────
    // a.b.c → { base: a, segs: [{ name, node }, …] } (stops at a call / other node)
    const chainOf = (node)=>{
        const segs = [];
        let n = node;
        while(n.type === 'MemberExpression' || n.type === 'ChainExpression'){
            if (n.type === 'ChainExpression') {
                n = n.expression;
                continue;
            }
            segs.unshift({
                name: $550bc22b1fc9006b$var$memberName(n),
                node: n
            });
            n = n.object;
        }
        return {
            base: n,
            segs: segs
        };
    };
    const handleRole = (base, scope)=>{
        if (!base) return null;
        if (base.type === 'ThisExpression') return 'element';
        if (base.type === 'Identifier') {
            const r = resolve(scope, base.name);
            if (r.declared && (r.role === 'event' || r.role === 'element' || r.role === 'state')) return r.role;
        }
        return null;
    };
    const checkChain = (node, scope, { isCallee: isCallee = false, isWrite: isWrite = false } = {})=>{
        const { base: base, segs: segs } = chainOf(node);
        const role = handleRole(base, scope);
        // the base: a handle is fine as a member object; anything else is visited
        if (base.type === 'Identifier') checkIdentifierRef(base, scope, 'member-object');
        else if (base.type !== 'ThisExpression') visit(base, scope);
        for(let i = 0; i < segs.length; i++){
            const { name: name, node: m } = segs[i];
            if (m.computed && name == null) {
                flag('computed-key', m, 'a member key computed from an expression');
                visit(m.property, scope);
                continue;
            }
            if (m.computed) visit(m.property, scope);
            if (name == null) continue;
            if ($550bc22b1fc9006b$var$BLOCKED_MEMBERS.has(name)) flag('blocked-member', m, name);
            else if (name.startsWith($cmUBA.GENERATED_APP_BLOCKED_PREFIX)) flag('internal-member', m, name);
            else if ($550bc22b1fc9006b$var$INDIRECTION.has(name)) flag('indirection', m, name);
            else if (name === 'call' && !(isCallee && i === segs.length - 1)) flag('call-indirection', m, 'call');
            if ($550bc22b1fc9006b$var$BLOCKED_STRINGS.has(name) && !$550bc22b1fc9006b$var$BLOCKED_MEMBERS.has(name)) flag('blocked-member', m, name);
            // roles
            if (i === 0 && role === 'event' && !$550bc22b1fc9006b$var$EVENT_MEMBERS.has(name)) flag('event-member', m, name);
            if (i === 0 && role === 'element' && !$550bc22b1fc9006b$var$ELEMENT_MEMBERS.has(name)) flag('element-member', m, name);
            if (i === 1 && role === 'event' && (segs[0].name === 'target' || segs[0].name === 'currentTarget') && !$550bc22b1fc9006b$var$TARGET_MEMBERS.has(name)) flag('target-member', m, name);
            if (i >= 2 && role === 'event' && (segs[0].name === 'target' || segs[0].name === 'currentTarget')) {
                const deep = segs[1].name;
                const chain = $550bc22b1fc9006b$var$DEEP_CHAIN[deep];
                const isIndex = /^\d+$/.test(name);
                let okDeep = false;
                if (deep === 'dataset') okDeep = i === 2;
                else if (chain) {
                    if (i === 2) okDeep = isIndex || chain.list.includes(name);
                    else if (i === 3) okDeep = /^\d+$/.test(segs[2].name || '') && chain.item.includes(name);
                }
                if (!okDeep) flag('target-member', m, name);
            }
            // globals
            if (i === 0 && base.type === 'Identifier' && !resolve(scope, base.name).declared && $550bc22b1fc9006b$var$GLOBAL_MEMBERS[base.name]) {
                if (!$550bc22b1fc9006b$var$GLOBAL_MEMBERS[base.name].includes(name)) flag('global-member', m, `${base.name}.${name}`);
            }
            // root
            if (name === 'root') {
                const next = segs[i + 1];
                if (!next || next.name == null) flag('root-read', m, 'root must be followed by a data key');
                else if ($550bc22b1fc9006b$var$ROOT_DENY.has(next.name) || $550bc22b1fc9006b$var$ROOT_DENY_RE.test(next.name)) flag('root-key', next.node, next.name);
                else if (!rootAllow.has(next.name)) flag('root-key', next.node, next.name);
                for(let j = i + 1; j < segs.length; j++)if (segs[j].name && $550bc22b1fc9006b$var$ROOT_WRITES.has(segs[j].name)) flag('root-write', segs[j].node, segs[j].name);
                if (isWrite) flag('root-write', m, 'assignment under root');
            }
            if (i === segs.length - 1 && isWrite && (role === 'event' || role === 'element')) flag('handle-write', m, name);
        }
    };
    // A handle chain used as a VALUE must end at a primitive member.
    const checkHandleValueEnd = (node, scope)=>{
        const { base: base, segs: segs } = chainOf(node);
        const role = handleRole(base, scope);
        if (role !== 'event' || !segs.length) return;
        const names = segs.map((x)=>x.name);
        const onTarget = names[0] === 'target' || names[0] === 'currentTarget';
        let ok;
        if (!onTarget) ok = names.length === 1 && $550bc22b1fc9006b$var$EVENT_VALUE.has(names[0]);
        else if (names.length === 1) ok = false;
        else if (names.length === 2) ok = $550bc22b1fc9006b$var$TARGET_VALUE.has(names[1]);
        else if (names[1] === 'dataset') ok = names.length === 3;
        else if (names[1] === 'files') ok = true;
        else if (names[1] === 'options') ok = names.length === 4 || names.length === 3 && !/^\d+$/.test(names[2]);
        else ok = false;
        if (!ok) flag('handle-escape', node, names.join('.'));
    };
    const checkIdentifierRef = (id, scope, position)=>{
        if (id.name === 'arguments') return flag('arguments', id, 'arguments');
        const r = resolve(scope, id.name);
        if (!r.declared) {
            if (!$550bc22b1fc9006b$var$GLOBALS.has(id.name)) flag('global', id, id.name);
            return;
        }
        if ((r.role === 'event' || r.role === 'element') && position !== 'member-object' && position !== 'allowed-arg') flag('handle-escape', id, id.name);
    };
    const checkPatternKeys = (p, scope, role)=>{
        if (!p) return;
        if (p.type === 'ObjectPattern') for (const q of p.properties){
            if (q.type === 'RestElement') {
                if (role === 'event' || role === 'element') flag('handle-escape', q, 'rest of a handle');
                checkPatternKeys(q.argument, scope, null);
                continue;
            }
            const name = $550bc22b1fc9006b$var$propName(q);
            if (q.computed && name == null) {
                flag('computed-key', q, 'a destructured key computed from an expression');
                visit(q.key, scope);
            }
            if (name != null) {
                if ($550bc22b1fc9006b$var$BLOCKED_MEMBERS.has(name) || $550bc22b1fc9006b$var$BLOCKED_STRINGS.has(name)) flag('blocked-member', q, name);
                else if (name.startsWith($cmUBA.GENERATED_APP_BLOCKED_PREFIX)) flag('internal-member', q, name);
                if (role === 'event' && !$550bc22b1fc9006b$var$EVENT_MEMBERS.has(name)) flag('event-member', q, name);
                if (role === 'element' && !$550bc22b1fc9006b$var$ELEMENT_MEMBERS.has(name)) flag('element-member', q, name);
                if (name === 'root') flag('root-read', q, 'root must be read as root.<key>');
            }
            if (q.value && q.value.type !== 'Identifier') checkPatternKeys(q.value, scope, null);
        }
        else if (p.type === 'ArrayPattern') {
            if (role === 'event' || role === 'element') flag('handle-escape', p, 'array pattern of a handle');
            p.elements.forEach((q)=>checkPatternKeys(q, scope, null));
        } else if (p.type === 'AssignmentPattern') {
            checkPatternKeys(p.left, scope, role);
            visit(p.right, scope);
        } else if (p.type === 'RestElement') checkPatternKeys(p.argument, scope, null);
    };
    const enterFunction = (fn, scope, key)=>{
        const s = newScope(scope);
        const roles = $550bc22b1fc9006b$var$paramRoles(key);
        fn.params.forEach((p, i)=>{
            const role = roles[i] || 'plain';
            if (p.type === 'Identifier') s.names.set(p.name, role);
            else {
                patternNames(p).forEach((n)=>s.names.set(n, 'plain'));
                checkPatternKeys(p, s, role);
            }
        });
        if (fn.type === 'FunctionExpression' && fn.id) s.names.set(fn.id.name, 'plain');
        if (fn.body.type === 'BlockStatement') {
            declareVars(s, fn.body);
            declareBlock(s, fn.body.body);
            fn.body.body.forEach((st)=>visit(st, s));
        } else visit(fn.body, s);
    };
    const auditStringFunction = (str, node, key)=>{
        let inner;
        try {
            inner = (0, $gQuVO.parse)('(' + str + ')', {
                ecmaVersion: 'latest',
                sourceType: 'script'
            });
        } catch (_) {
            return;
        }
        const expr = inner.body[0] && inner.body[0].expression;
        if (!$550bc22b1fc9006b$var$isFnNode(expr)) return;
        const sub = $550bc22b1fc9006b$export$5939d66fa205155a('(' + str + ')', {
            allow: [
                ...allowSet
            ],
            rootKeys: rootKeys
        });
        // a role-aware pass for the DOMQL key it sits on
        const s = newScope(null);
        enterFunctionStandalone(expr, s, key, sub.violations, node);
    };
    const enterFunctionStandalone = (expr, s, key, subViolations, node)=>{
        for (const v of subViolations)flag(v.rule, node, `in a string function: ${v.detail}`);
        enterFunction(expr, s, key);
    };
    // A URL key takes a STRING LITERAL with a safe scheme, or an address whose
    // LEFTMOST part is a same-origin path literal and the rest an expression —
    // never a function and never a fully computed value (it could carry
    // workspace data to another origin, or turn into javascript: at run time).
    // `null` / `undefined` literals are fine.
    const urlValueSafe = (v, key)=>{
        if (!v) return false;
        if (v.type === 'Literal') return typeof v.value === 'string' ? $550bc22b1fc9006b$var$isSafeUrl(v.value, key) : v.value == null;
        if (v.type === 'Identifier' && v.name === 'undefined') return true;
        if (v.type === 'TemplateLiteral' && v.expressions.length === 0) return $550bc22b1fc9006b$var$isSafeUrl(v.quasis[0].value.cooked, key);
        // The address a row map builds: a same-origin path on the left, any
        // expression after it ('/chains/chain?id=' + r.id, `/chains/chain?id=${r.id}`).
        if (v.type === 'TemplateLiteral' || v.type === 'BinaryExpression' && v.operator === '+') {
            const prefix = $550bc22b1fc9006b$var$leftmostLiteral(v);
            return prefix != null && $550bc22b1fc9006b$var$sameOriginPathPrefix(prefix);
        }
        return false;
    };
    // A CSS key that may carry url(…): a literal whose every url(…) is safe, or
    // a function / ternary that returns only such literals.
    const cssUrlsSafe = (str)=>{
        const re = /url\(\s*(['"]?)([^'")]*)\1\s*\)/gi;
        let m;
        while(m = re.exec(String(str)))if (!$550bc22b1fc9006b$var$isSafeUrl(m[2], 'href')) return false;
        return true;
    };
    const cssValueSafe = (v)=>{
        if (!v) return false;
        if (v.type === 'Literal') return typeof v.value !== 'string' || cssUrlsSafe(v.value);
        if (v.type === 'TemplateLiteral' && v.expressions.length === 0) return cssUrlsSafe(v.quasis[0].value.cooked);
        if (v.type === 'ConditionalExpression') return cssValueSafe(v.consequent) && cssValueSafe(v.alternate);
        if (v.type === 'LogicalExpression') return cssValueSafe(v.right);
        if (v.type === 'ArrowFunctionExpression' || v.type === 'FunctionExpression') {
            if (v.body.type !== 'BlockStatement') return cssValueSafe(v.body);
            const rets = [];
            const findReturns = (n)=>{
                if (!n || typeof n !== 'object' || $550bc22b1fc9006b$var$isFnNode(n)) return;
                if (Array.isArray(n)) return n.forEach(findReturns);
                if (n.type === 'ReturnStatement') rets.push(n.argument);
                for(const k in n)if (k !== 'type' && n[k] && typeof n[k] === 'object') findReturns(n[k]);
            };
            findReturns(v.body.body);
            return rets.length > 0 && rets.every((r)=>cssValueSafe(r));
        }
        return false;
    };
    // An object that renders as Svg / Icon: its `src` is MARKUP (Svg.js puts it
    // in the svg's innerHTML / the sprite), so it may only be an icon NAME.
    const SVG_BASES = new Set([
        'Svg',
        'Icon'
    ]);
    const isSvgLike = (obj, ownKey)=>{
        if (ownKey && SVG_BASES.has(String(ownKey).split('_')[0])) return true;
        for (const p of obj && obj.properties || []){
            if (p.type !== 'Property' || $550bc22b1fc9006b$var$propName(p) !== 'extends') continue;
            const vals = p.value.type === 'ArrayExpression' ? p.value.elements : [
                p.value
            ];
            for (const v of vals){
                const lit = $550bc22b1fc9006b$var$literalString(v);
                if (lit && SVG_BASES.has(lit.split('>')[0].trim())) return true;
            }
        }
        return false;
    };
    // DOMQL string props: a def is data the framework turns into DOM.
    const checkDomqlProp = (key, value, node, svgLike)=>{
        if ($550bc22b1fc9006b$var$MARKUP_KEYS.has(key)) flag('markup-key', node, key);
        if (key === 'tag') {
            const t = $550bc22b1fc9006b$var$literalString(value);
            if (t == null || !$550bc22b1fc9006b$var$TAGS.has(t.toLowerCase())) flag('tag-not-allowed', node, t == null ? 'computed tag' : t);
        }
        // `on<name>` (onClick, onclick); `on` alone is a fetch trigger ('submit').
        if (/^on[a-zA-Z]/.test(key) && value && (value.type === 'Literal' || value.type === 'TemplateLiteral')) // a handler is a FUNCTION; a string on an on* key is inline code
        flag('string-handler', node, key);
        const strVal = $550bc22b1fc9006b$var$literalString(value);
        // a function-like string on a URL / CSS key is revived into a function
        if (($550bc22b1fc9006b$var$URL_KEYS.has(key) || $550bc22b1fc9006b$var$CSS_URL_KEYS.has(key)) && strVal != null && $550bc22b1fc9006b$var$looksLikeFunctionText(strVal)) {
            flag('url-dynamic', node, key);
            return;
        }
        // markup in a URL value (Svg / Icon src lands in innerHTML)
        if ($550bc22b1fc9006b$var$URL_KEYS.has(key) && strVal != null && strVal.includes('<')) flag('url-markup', node, key);
        if (key === 'src' && svgLike && !(strVal != null && /^[\w-]+$/.test(strVal))) flag('svg-src', node, 'src');
        // `state:` as a string is a PATH the framework resolves against the live
        // tree ('~/<key>' = the root, '../<key>' = up, '<key>' = the parent's)
        if (key === 'state' && value && (value.type === 'Literal' || value.type === 'TemplateLiteral')) flag('state-string', node, strVal == null ? '(template)' : strVal);
        if (key === 'children' && value && (value.type === 'Literal' || value.type === 'TemplateLiteral')) flag('state-string', node, 'children: ' + (strVal == null ? '(template)' : strVal));
        // a fetch target: never a path, never a denied root key
        if (key === 'as' && strVal != null) {
            const bare = strVal.replace(/^\s+/, '');
            if (/^(~\/|\.\.\/|\/)/.test(bare)) flag('fetch-as', node, strVal);
            else if ($550bc22b1fc9006b$var$ROOT_DENY.has(bare) || $550bc22b1fc9006b$var$ROOT_DENY_RE.test(bare)) flag('fetch-as', node, strVal);
        }
        if ($550bc22b1fc9006b$var$CSS_URL_KEYS.has(key) && !cssValueSafe(value)) flag('css-url', node, key);
        if ($550bc22b1fc9006b$var$URL_KEYS.has(key) && !urlValueSafe(value, key)) {
            const lit = value && value.type === 'Literal' && typeof value.value === 'string';
            flag(lit ? 'url-scheme' : 'url-dynamic', node, key);
        }
    };
    const visit = (node, scope, ctx = {})=>{
        if (!node || typeof node !== 'object') return;
        if (Array.isArray(node)) return node.forEach((n)=>visit(n, scope));
        switch(node.type){
            case 'ArrayExpression':
                return node.elements.forEach((n)=>visit(n, scope, {
                        plainFns: !!ctx.plainFns || $550bc22b1fc9006b$var$PLAIN_FN_KEYS.has(ctx.key)
                    }));
            case 'Program':
                declareVars(scope, node.body);
                declareBlock(scope, node.body);
                return node.body.forEach((n)=>visit(n, scope));
            case 'Identifier':
                return checkIdentifierRef(node, scope, ctx.position || 'value');
            case 'ThisExpression':
                if (ctx.position !== 'member-object' && ctx.position !== 'allowed-arg') flag('handle-escape', node, 'this');
                return;
            case 'Literal':
                if (typeof node.value === 'string') {
                    if ($550bc22b1fc9006b$var$BLOCKED_STRINGS.has(node.value)) flag('blocked-string', node, node.value);
                    else if ($550bc22b1fc9006b$var$looksLikeFunctionText(node.value)) auditStringFunction(node.value, node, ctx.key);
                }
                if (node.regex) return;
                return;
            case 'TemplateLiteral':
                for (const q of node.quasis)if ($550bc22b1fc9006b$var$BLOCKED_STRINGS.has(q.value.cooked)) flag('blocked-string', q, q.value.cooked);
                return node.expressions.forEach((e)=>visit(e, scope));
            case 'TaggedTemplateExpression':
                flag('tagged-template', node, 'tagged template');
                return visit(node.quasi, scope);
            case 'WithStatement':
                flag('with', node, 'with');
                return;
            case 'ImportExpression':
                flag('import', node, 'import()');
                return;
            case 'MetaProperty':
                flag('meta-property', node, `${node.meta.name}.${node.property.name}`);
                return;
            case 'ChainExpression':
                return visit(node.expression, scope, ctx);
            case 'MemberExpression':
                checkChain(node, scope, {
                    isWrite: !!ctx.isWrite
                });
                return checkHandleValueEnd(node, scope);
            case 'CallExpression':
                {
                    const callee = node.callee.type === 'ChainExpression' ? node.callee.expression : node.callee;
                    if (callee.type === 'MemberExpression' && $550bc22b1fc9006b$var$memberName(callee) === 'call' && !callee.computed) {
                        const name = $550bc22b1fc9006b$var$literalString(node.arguments[0]);
                        if (name == null) flag('call-name', node, 'el.call with a name that is not a literal');
                        else if (!allowSet.has(name)) flag('call-not-allowed', node, name);
                        checkChain(callee, scope, {
                            isCallee: true
                        });
                        // no function may ride into a shell function as an argument
                        const hasFn = (n)=>!!n && typeof n === 'object' && ($550bc22b1fc9006b$var$isFnNode(n) || Object.keys(n).some((k)=>k !== 'type' && n[k] && typeof n[k] === 'object' && (Array.isArray(n[k]) ? n[k].some(hasFn) : hasFn(n[k]))));
                        if (node.arguments.slice(1).some(hasFn)) flag('call-arg-function', node, name || 'call');
                        return node.arguments.slice(1).forEach((a)=>a.type === 'Identifier' || a.type === 'ThisExpression' ? visit(a, scope, {
                                position: 'allowed-arg'
                            }) : visit(a, scope));
                    }
                    if (callee.type === 'Identifier' && (callee.name === 'setTimeout' || callee.name === 'setInterval')) {
                        if (!$550bc22b1fc9006b$var$isFnNode(node.arguments[0])) flag('timer-string', node, callee.name);
                    }
                    if (callee.type === 'MemberExpression') checkChain(callee, scope, {
                        isCallee: true
                    });
                    else visit(callee, scope);
                    return node.arguments.forEach((a)=>visit(a, scope));
                }
            case 'NewExpression':
                visit(node.callee, scope);
                return node.arguments.forEach((a)=>visit(a, scope));
            case 'AssignmentExpression':
                if (node.left.type === 'MemberExpression') checkChain(node.left, scope, {
                    isWrite: true
                });
                else if (node.left.type === 'Identifier') checkIdentifierRef(node.left, scope, 'value');
                else checkPatternKeys(node.left, scope, null);
                return visit(node.right, scope);
            case 'UpdateExpression':
                if (node.argument.type === 'MemberExpression') return checkChain(node.argument, scope, {
                    isWrite: true
                });
                return visit(node.argument, scope);
            case 'UnaryExpression':
                if (node.operator === 'delete' && node.argument.type === 'MemberExpression') return checkChain(node.argument, scope, {
                    isWrite: true
                });
                return visit(node.argument, scope);
            case 'ObjectExpression':
                {
                    const plainFns = !!ctx.plainFns || $550bc22b1fc9006b$var$PLAIN_FN_KEYS.has(ctx.key);
                    const svgLike = isSvgLike(node, ctx.key);
                    for (const p of node.properties){
                        if (p.type === 'SpreadElement') {
                            visit(p.argument, scope);
                            continue;
                        }
                        const key = $550bc22b1fc9006b$var$propName(p);
                        if (!p.computed && key === '__proto__') flag('proto-key', p, '__proto__');
                        if (p.kind === 'get' || p.kind === 'set') flag('accessor', p, `${p.kind} ${key}`);
                        if (key != null) checkDomqlProp(key, p.value, p, svgLike);
                        if (key === 'extends' || key === 'childExtends') checkExtendsValue(p.value, p);
                        if (key != null && !p.computed && ctx.key !== 'components') checkBareKey(key, p);
                        if (p.computed) {
                            if ($550bc22b1fc9006b$var$literalString(p.key) == null) flag('computed-key', p, 'an object key computed from an expression');
                            visit(p.key, scope);
                        }
                        if (key != null && ($550bc22b1fc9006b$var$BLOCKED_MEMBERS.has(key) || $550bc22b1fc9006b$var$BLOCKED_STRINGS.has(key) || key.startsWith($cmUBA.GENERATED_APP_BLOCKED_PREFIX)) && key !== '__proto__') flag('blocked-key', p, key);
                        // attr: {} — the element's raw attributes: no on* attribute at all
                        if (ctx.key === 'attr' && key != null && /^on/i.test(key)) flag('attr-handler', p, key);
                        // on: { click: … } (the v2 event map) — every entry a function
                        if (ctx.key === 'on' && !$550bc22b1fc9006b$var$isFnNode(p.value)) flag('string-handler', p, `on.${key}`);
                        if ($550bc22b1fc9006b$var$isFnNode(p.value)) enterFunction(p.value, scope, plainFns ? null : key);
                        else visit(p.value, scope, {
                            key: key,
                            plainFns: plainFns
                        });
                    }
                    return;
                }
            case 'ArrowFunctionExpression':
            case 'FunctionExpression':
                return enterFunction(node, scope, ctx.plainFns ? null : ctx.key);
            case 'FunctionDeclaration':
                return enterFunction(node, scope, null);
            case 'ClassDeclaration':
            case 'ClassExpression':
                if (node.superClass) visit(node.superClass, scope);
                for (const m of node.body.body){
                    if (m.kind === 'get' || m.kind === 'set') flag('accessor', m, m.kind);
                    if (m.computed) visit(m.key, scope);
                    if (m.value && $550bc22b1fc9006b$var$isFnNode(m.value)) enterFunction(m.value, scope, null);
                    else if (m.value) visit(m.value, scope);
                }
                return;
            case 'VariableDeclaration':
                for (const d of node.declarations){
                    if (d.id.type !== 'Identifier') checkPatternKeys(d.id, scope, null);
                    if (d.init) visit(d.init, scope);
                }
                return;
            case 'BlockStatement':
            case 'StaticBlock':
                {
                    const s = newScope(scope);
                    declareBlock(s, node.body);
                    return node.body.forEach((n)=>visit(n, s));
                }
            case 'ForStatement':
            case 'ForInStatement':
            case 'ForOfStatement':
                {
                    const s = newScope(scope);
                    const decl = node.init || node.left;
                    if (decl && decl.type === 'VariableDeclaration' && decl.kind !== 'var') decl.declarations.forEach((d)=>patternNames(d.id).forEach((n)=>s.names.set(n, 'plain')));
                    if (node.type === 'ForStatement') {
                        visit(node.init, s);
                        visit(node.test, s);
                        visit(node.update, s);
                    } else {
                        if (node.left.type === 'MemberExpression') checkChain(node.left, s, {
                            isWrite: true
                        });
                        else visit(node.left, s);
                        visit(node.right, s);
                    }
                    return visit(node.body, s);
                }
            case 'SwitchStatement':
                {
                    visit(node.discriminant, scope);
                    const s = newScope(scope);
                    node.cases.forEach((c)=>declareBlock(s, c.consequent));
                    return node.cases.forEach((c)=>{
                        visit(c.test, s);
                        visit(c.consequent, s);
                    });
                }
            case 'CatchClause':
                {
                    const s = newScope(scope);
                    if (node.param) {
                        patternNames(node.param).forEach((n)=>s.names.set(n, 'plain'));
                        checkPatternKeys(node.param, s, null);
                    }
                    return visit(node.body, s);
                }
            case 'Property':
                // object patterns reach here only through checkPatternKeys
                return;
            case 'LabeledStatement':
                return visit(node.body, scope);
            case 'BreakStatement':
            case 'ContinueStatement':
                return;
            default:
                for(const k in node){
                    if (k === 'type' || k === 'start' || k === 'end') continue;
                    const v = node[k];
                    if (v && typeof v === 'object') visit(v, scope);
                }
        }
    };
    visit(ast, newScope(null));
    return {
        ok: violations.length === 0,
        violations: violations
    };
}
const $550bc22b1fc9006b$export$dd6faa11cce9787 = (violations)=>{
    const err = new Error('this app uses a blocked feature');
    err.code = $550bc22b1fc9006b$export$eb8b908f1e573aaa;
    err.violations = violations;
    return err;
};
const $550bc22b1fc9006b$export$779218b3dbe76ef7 = (allow, rootKeys = [], registeredComponents = null)=>(expressionText)=>{
        const res = $550bc22b1fc9006b$export$5939d66fa205155a(expressionText, {
            allow: allow,
            rootKeys: rootKeys,
            registeredComponents: registeredComponents
        });
        if (!res.ok) throw $550bc22b1fc9006b$export$dd6faa11cce9787(res.violations);
    };

});


parcelRegister("7qVzJ", function(module, exports) {

$parcel$export(module.exports, "generatedAppSandboxOn", () => $56979f651d06c932$export$af67d48c227d1441);
$parcel$export(module.exports, "sandboxManifestEntities", () => $56979f651d06c932$export$766ee97d7769cefd);
$parcel$export(module.exports, "sandboxWrapperEntities", () => $56979f651d06c932$export$e12621efee6cf67);
$parcel$export(module.exports, "sandboxComponentRefusals", () => $56979f651d06c932$export$1f7bfbf25baf2a4a);
$parcel$export(module.exports, "sandboxAppDef", () => $56979f651d06c932$export$308a0cba490f7fd1);
$parcel$export(module.exports, "pageStateSeed", () => $56979f651d06c932$export$d252fab2f54a351b);
$parcel$export(module.exports, "buildSandboxedAppDef", () => $56979f651d06c932$export$5d7429b39a1bd0dc);
// generatedAppSandbox.js — the switch that sends AI-generated apps to the
// opaque sandbox frame (ISOLATED-RUNTIME-PLAN §8.1, M2).
//
// The builders (functions/index.js) stay the one door: the AST gate runs in
// the shell first, on the exact text the frame will evaluate. With the flag
// on, a passed page becomes a SandboxedApp def — plain data the frame boots
// from — and nothing generated evaluates in the shell realm. With the flag
// off, the builders mount in the shell as before (the fallback until the
// 10-10 review).

var $gQuVO = parcelRequire("gQuVO");

var $1X0Je = parcelRequire("1X0Je");

var $ggoif = parcelRequire("ggoif");
var $7iHfb = parcelRequire("7iHfb");

var $bAoXv = parcelRequire("bAoXv");

var $cmUBA = parcelRequire("cmUBA");
const $56979f651d06c932$export$62f0308bfba07075 = 'appsSandbox';
// deferred-call wrapper (the bare shared-library import, see featureFlags.js)
const $56979f651d06c932$var$shellFeatureEnabled = (...args)=>(0, $1X0Je.default).functions.featureEnabled(...args);
const $56979f651d06c932$var$_sandboxFlagDef = (key)=>(0, $1X0Je.default).functions.featureFlagDef ? (0, $1X0Je.default).functions.featureFlagDef(key) : null;
const $56979f651d06c932$export$af67d48c227d1441 = (root)=>{
    if (!root || typeof root !== 'object') return false;
    const def = $56979f651d06c932$var$_sandboxFlagDef($56979f651d06c932$export$62f0308bfba07075);
    if (!def || def.defaultOn !== false) return false;
    return $56979f651d06c932$var$shellFeatureEnabled(root, $56979f651d06c932$export$62f0308bfba07075) === true;
};
const $56979f651d06c932$export$766ee97d7769cefd = (entities)=>{
    const out = [];
    for (const e of Array.isArray(entities) ? entities : []){
        const s = typeof e === 'string' ? e.trim() : '';
        const dot = s.lastIndexOf('.');
        const bare = (dot >= 0 ? s.slice(dot + 1) : s).toLowerCase();
        if (bare && !out.includes(bare)) out.push(bare);
    }
    return out;
};
// THE manifest of a sandboxed page (aib 2026-10-02, ROW-ENTITIES.md): no stored
// row carries `entities` and the server drops a client-sent list, so the data
// surface is what the page's OWN source declares — the `entities: [...]` key of
// the top-level object (the `{ entities, page }` wrapper, or a bare page
// literal's own key). Read from the syntax tree of the AUDITED text (acorn, as
// the gate; nothing evaluates): string literals and `{ name | entity | from }`
// objects of string literals; anything computed is ignored. Names are bare
// (`ns.name` -> `name`), lower case; a root deny key / deny-pattern name is
// dropped. No declaration -> [] (fail closed: no data access). The caller's
// list is never read.
const $56979f651d06c932$var$DENY_KEYS = new Set((0, $cmUBA.GENERATED_APP_ROOT_DENY_KEYS));
const $56979f651d06c932$var$DENY_RE = new RegExp((0, $cmUBA.GENERATED_APP_ROOT_DENY_PATTERN), 'i');
const $56979f651d06c932$var$keyName = (prop)=>!prop.computed && prop.key ? prop.key.type === 'Identifier' ? prop.key.name : typeof prop.key.value === 'string' ? prop.key.value : null : null;
const $56979f651d06c932$var$stringOf = (node)=>node && node.type === 'Literal' && typeof node.value === 'string' ? node.value : null;
const $56979f651d06c932$var$entryName = (node)=>{
    const lit = $56979f651d06c932$var$stringOf(node);
    if (lit !== null) return lit;
    if (node && node.type === 'ObjectExpression') for (const k of [
        'name',
        'entity',
        'from'
    ]){
        const prop = node.properties.find((p)=>p.type === 'Property' && $56979f651d06c932$var$keyName(p) === k);
        const v = prop && $56979f651d06c932$var$stringOf(prop.value);
        if (v !== null && v !== undefined) return v;
    }
    return null;
};
const $56979f651d06c932$export$e12621efee6cf67 = (expr)=>{
    let ast;
    try {
        ast = (0, $gQuVO.parseExpressionAt)(String(expr || ''), 0, {
            ecmaVersion: 'latest'
        });
    } catch (_) {
        return [];
    }
    while(ast && ast.type === 'ParenthesizedExpression')ast = ast.expression;
    if (!ast || ast.type !== 'ObjectExpression') return [];
    const prop = ast.properties.find((p)=>p.type === 'Property' && $56979f651d06c932$var$keyName(p) === 'entities');
    if (!prop || !prop.value || prop.value.type !== 'ArrayExpression') return [];
    const out = new Set();
    for (const el of prop.value.elements){
        const raw = $56979f651d06c932$var$entryName(el);
        if (!raw) continue;
        const dot = raw.lastIndexOf('.');
        const bare = (dot >= 0 ? raw.slice(dot + 1) : raw).trim().toLowerCase();
        if (!bare || $56979f651d06c932$var$DENY_KEYS.has(bare) || $56979f651d06c932$var$DENY_RE.test(bare)) continue;
        out.add(bare);
    }
    return [
        ...out
    ].sort();
};
// The frame renders the runtime's built-ins and the PROVEN house components
// only (sandboxComponents.js). A page that names a house component the frame
// cannot render — an `extends` / `childExtends` value or a bare PascalCase key
// (the part before `_`) — would mount blank there, so the sandbox path
// refuses it at build time. Every allowlisted house component is classified,
// so the dropped set is the complete list of such names. Runs on the audited
// text, after the app-rules gate passed (that module stays a byte copy).
const $56979f651d06c932$var$DROPPED = new Set(Object.keys((0, $bAoXv.SANDBOX_COMPONENTS_DROPPED)));
const $56979f651d06c932$export$1f7bfbf25baf2a4a = (expr)=>{
    let ast;
    try {
        ast = (0, $gQuVO.parseExpressionAt)(String(expr || ''), 0, {
            ecmaVersion: 'latest'
        });
    } catch (_) {
        return [];
    }
    const out = [];
    const flag = (node, name)=>out.push({
            rule: 'component_not_in_sandbox',
            at: node.start,
            detail: name
        });
    const visit = (node)=>{
        if (!node || typeof node.type !== 'string') return;
        if (node.type === 'ObjectExpression') for (const p of node.properties){
            if (p.type !== 'Property') continue;
            const key = $56979f651d06c932$var$keyName(p);
            if (key === 'extends' || key === 'childExtends') {
                const vals = p.value.type === 'ArrayExpression' ? p.value.elements : [
                    p.value
                ];
                for (const v of vals){
                    const n = $56979f651d06c932$var$stringOf(v);
                    if (n !== null && n !== undefined) {
                        const base = n.split('>')[0].trim();
                        if ($56979f651d06c932$var$DROPPED.has(base)) flag(v, base);
                    }
                }
            } else if (key && /^[A-Z]/.test(key) && $56979f651d06c932$var$DROPPED.has(key.split('_')[0])) flag(p, key.split('_')[0]);
        }
        for (const k of Object.keys(node)){
            if (k === 'type' || k === 'start' || k === 'end') continue;
            const v = node[k];
            if (Array.isArray(v)) v.forEach(visit);
            else if (v && typeof v.type === 'string') visit(v);
        }
    };
    visit(ast);
    return out;
};
const $56979f651d06c932$export$308a0cba490f7fd1 = ({ name: name, expr: expr, jsonAuthored: jsonAuthored, entities: entities, stateSeed: stateSeed, pages: pages, appLabel: appLabel, crmLeads: crmLeads } = {})=>{
    const sandboxApp = {
        name: String(name || ''),
        expr: String(expr || ''),
        jsonAuthored: jsonAuthored === true,
        entities: $56979f651d06c932$export$766ee97d7769cefd(entities),
        stateSeed: stateSeed && typeof stateSeed === 'object' ? {
            ...stateSeed
        } : {}
    };
    if (Array.isArray(pages)) {
        sandboxApp.pages = pages.map((p)=>({
                route: String(p.route),
                title: String(p.title || ''),
                expr: String(p.expr),
                jsonAuthored: p.jsonAuthored === true
            }));
        sandboxApp.appLabel = String(appLabel || '');
    }
    if (crmLeads && crmLeads.enabled === true) sandboxApp.crmLeads = {
        enabled: true
    };
    return {
        extends: 'SandboxedApp',
        sandboxApp: sandboxApp
    };
};
const $56979f651d06c932$export$8d31b626db8e487d = (source)=>{
    const out = {};
    const re = /\bas\s*:\s*['"]~?\/?([A-Za-z_$][\w$]*)['"]/g;
    let m;
    while(m = re.exec(String(source || '')))out[m[1]] = [];
    return out;
};
const $56979f651d06c932$export$1af241366f60f246 = (source)=>{
    const src = String(source || '');
    const keys = new Set();
    const re = /\b(?:s|state)\.update\(\s*\{/g;
    let m;
    while(m = re.exec(src)){
        let depth = 1;
        let quote = null;
        let token = '';
        let expectKey = true;
        for(let i = re.lastIndex; i < src.length && depth > 0; i++){
            const c = src[i];
            if (quote) {
                if (c === '\\') i++;
                else if (c === quote) quote = null;
                continue;
            }
            if (c === "'" || c === '"' || c === '`') {
                quote = c;
                continue;
            }
            if (c === '{' || c === '[' || c === '(') depth++;
            else if (c === '}' || c === ']' || c === ')') depth--;
            if (depth !== 1) {
                if (depth < 1 && expectKey && token) keys.add(token);
                token = '';
                continue;
            }
            if (/[\w$]/.test(c)) {
                if (expectKey) token += c;
            } else if (c === ':') {
                if (expectKey && token) keys.add(token);
                token = '';
                expectKey = false;
            } else if (c === ',') {
                if (expectKey && token) keys.add(token);
                token = '';
                expectKey = true;
            } else if (c === '.') {
                token = '';
                expectKey = false;
            } else if (!/\s/.test(c)) token = '';
        }
    }
    return [
        ...keys
    ].filter((k)=>/^[A-Za-z_$][\w$]*$/.test(k));
};
const $56979f651d06c932$export$d252fab2f54a351b = (source)=>{
    const out = {};
    for (const k of $56979f651d06c932$export$1af241366f60f246(source))out[k] = null;
    return {
        ...out,
        ...$56979f651d06c932$export$8d31b626db8e487d(source)
    };
};
function $56979f651d06c932$export$5d7429b39a1bd0dc(args = {}) {
    const el = this;
    const a = args || {};
    const source = String(a.source || '');
    const checked = (0, $ggoif.auditGeneratedAppSource).call(el, source);
    if (!checked.ok) return checked;
    const refused = $56979f651d06c932$export$1f7bfbf25baf2a4a(checked.expr);
    if (refused.length) {
        const hint = (0, $ggoif.generatedAppViolationHint)(refused);
        return {
            ok: false,
            blocked: true,
            error: (0, $7iHfb.GENERATED_APP_BLOCKED),
            violations: refused,
            ...hint ? {
                hint: hint
            } : {}
        };
    }
    return {
        ok: true,
        def: $56979f651d06c932$export$308a0cba490f7fd1({
            name: a.name || '',
            expr: checked.expr,
            jsonAuthored: checked.jsonAuthored,
            entities: $56979f651d06c932$export$e12621efee6cf67(checked.expr),
            stateSeed: $56979f651d06c932$export$d252fab2f54a351b(source),
            crmLeads: a.crmLeads
        })
    };
}

});
parcelRegister("bAoXv", function(module, exports) {

$parcel$export(module.exports, "SANDBOX_COMPONENTS_DROPPED", () => $86f66ac8b5b986a4$export$a766795164d5d544);
$parcel$export(module.exports, "sandboxComponentPayload", () => $86f66ac8b5b986a4$export$653d729607c3900c);
// sandboxComponents.js — the house components a sandboxed AI-written app may
// use (ISOLATED-RUNTIME-PLAN §9.3). The opaque frame has no shell registry: the
// runtime's default-config built-ins render there, house components only if
// they travel in the boot payload. A shell definition is a closure in the shell
// bundle; a stringified copy that reads module scope, or el.calls a shell
// function the frame lacks, breaks in the frame. So the set is DATA, and
// __tests__/sandboxComponents.test.js PROVES every entry in the real runtime
// (__tests__/sandboxComponentsProver.js): no el.call outside the frame
// registry, no element method the frame lacks, no free name outside the
// frame's globals (a closure over shell scope), and a render with its own
// default state through the real bootstrap, storage throwing, with no error. Every allowlisted house
// component is classified: listed here, or dropped with its reason.
// The app-rules component allowlist stays the gate on what a page may NAME.
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
const $86f66ac8b5b986a4$export$a21e05f1a44d1a12 = Object.freeze([
    'AgentAvatar',
    'AiActionRow',
    'AiMenuHeading',
    'AiMenuPanel',
    'AiOptionRow',
    'AppCapsuleBtn',
    'AppCapsuleBtnDanger',
    'AppCapsuleBtnGhost',
    'AppCapsuleBtnPrimary',
    'AppCapsuleBtnToolbar',
    'AppChoiceChip',
    'AppChoiceChips',
    'AppColorChip',
    'AppColorChips',
    'AppDialogBody',
    'AppDialogFoot',
    'AppDialogHint',
    'AppDialogTitle',
    'AppField',
    'AppFieldChips',
    'AppFieldColors',
    'AppFieldError',
    'AppFieldHint',
    'AppFieldLabel',
    'AppKeycap',
    'AppLabelStack',
    'AppMain',
    'AppMicroLabel',
    'AppNavLink',
    'AppOption',
    'AppOrgSwitchOverlay',
    'AppPage',
    'AppPageEyebrow',
    'AppPaginationNext',
    'AppPaginationPrevious',
    'AppPaginationStep',
    'AppScrollRow',
    'AppSidebarGroup',
    'AppStatusChip',
    'AppTable',
    'AppTableHead',
    'AppTableNum',
    'AppTableRow',
    'AppToolbar',
    'AssetsFromInsert',
    'BoxModelAside',
    'BoxSizeItem',
    'CanvasDots',
    'CanvasMobileSidebarPanelChrome',
    'CanvasSidebarCard',
    'CanvasSidebarIsland',
    'ChatConfidenceFactor',
    'ChatMarkdown',
    'ChromeExt',
    'CommonCard',
    'CompactIconButton',
    'DesignSystem',
    'DesignSystemBanners',
    'DraftSwitcher',
    'DragComponentsTutorial',
    'DropdownButton',
    'EmptyState',
    'EmptyStateImages',
    'EmptyStateLoading',
    'EmptyStateTiles',
    'ErrorState',
    'Feedback',
    'FontsFromInsert',
    'GeexBlobPercent',
    'GeexGridBars',
    'GeexRankedStack',
    'GeexSegmentedBar',
    'GeexStackedColumn',
    'GeexTonalBars',
    'GeexValueRules',
    'GlyphPlateHolder',
    'GridChooser',
    'IconGridTypes',
    'IconNavbar',
    'InlineSelect',
    'InsertSectionShadow',
    'InstallFooter',
    'InstallHero',
    'InstallableRailSkeleton',
    'InstallableStateBadge',
    'IntegrationItem',
    'IntegrationScopeBadge',
    'IntegrationScopeOption',
    'IntegrationsList',
    'InviteForm',
    'LanguageOption',
    'LibraryItemInLearn',
    'LoadingSpinner',
    'LoginForm',
    'MemberProfileCheckItem',
    'MicroNavbar',
    'ModalFooter',
    'NavigationDots',
    'OrderingItem',
    'Page',
    'PageBar',
    'PageBarBtn',
    'PageBarMeta',
    'PageBarTitle',
    'PageTemplate',
    'PeopleSection',
    'ProfileGrantCard',
    'ProgressBar',
    'RequestAccessButtons',
    'ResetEmailForm',
    'ResetPasswordsForm',
    'SelectRoleField',
    'ServerPreview',
    'SignupForm',
    'Skeleton',
    'SkeletonCard',
    'SkeletonCircle',
    'SkeletonRow',
    'Tests',
    'ToolTerminal',
    'UploadProgress',
    'UserProfileIntegrationRow',
    'WaitlistForm'
]);
const $86f66ac8b5b986a4$export$a766795164d5d544 = Object.freeze({
    AppChoiceGroup: 'calls element methods the frame lacks: el.options',
    AppSidebarRow: 'calls element methods the frame lacks: el.onClick',
    CanvasPanel: 'calls element methods the frame lacks: el.getUserSettings',
    DragHandler: 'calls element methods the frame lacks: el.getUserSettings',
    DragParagraph: 'render error: [DOMQL] Lifecycle "onRender" error: Error: Could not import the module \'lottie-web\'.',
    ItemPreview: 'calls element methods the frame lacks: el.getAppKey',
    Lottie: 'el.call outside the frame: exec, isString, replaceLiteralsWithObjectFields',
    ProjectInfo: "render error: [smbls] createChildren failed at smblsapp.ProjectInfo: el.getAppKey is not a function. (In 'el.getAppKey()', 'el.getAppKey' is undefined) ",
    ResizeOverlay: 'calls element methods the frame lacks: el.getUserSettings',
    ResponsiveOverlay: 'calls element methods the frame lacks: el.isEmbed',
    SettingsTabs: 'calls element methods the frame lacks: el.isAdmin, el.isOwner, el.isEditMode',
    SwitchInput: 'calls element methods the frame lacks: el.onCheck',
    UsersTableCopy: 'calls element methods the frame lacks: el.getRootProjectsUsers'
});
const $86f66ac8b5b986a4$export$203ddd3c200f55c6 = 100000;
const $86f66ac8b5b986a4$var$cache = new WeakMap();
const $86f66ac8b5b986a4$export$653d729607c3900c = (components)=>{
    if (!components || typeof components !== 'object') return {};
    if ($86f66ac8b5b986a4$var$cache.has(components)) return $86f66ac8b5b986a4$var$cache.get(components);
    const out = {};
    for (const k of $86f66ac8b5b986a4$export$a21e05f1a44d1a12){
        const def = components[k];
        if (!def || typeof def !== 'object') continue;
        out[k] = JSON.parse(JSON.stringify((0, $2C0hZ.deepStringifyFunctions)(def, Array.isArray(def) ? [] : {})));
    }
    $86f66ac8b5b986a4$var$cache.set(components, out);
    return out;
};

});


parcelRegister("6jWcN", function(module, exports) {

$parcel$export(module.exports, "workspaceDesignSystemSource", () => $49a1aaceedba0a29$export$3cd59f7d2046c852);
$parcel$export(module.exports, "extensionDesignSystemSource", () => $49a1aaceedba0a29$export$2f7ba20a1945b4b7);
// The workspace shell's RAW design-system SOURCE — the single definition both
// the shell's own boot (`context.js`) and the extension-iframe render path
// (`functions/index.js`) read from.
//
// WHY THIS MODULE EXISTS — the framework's design-system input contract
// ---------------------------------------------------------------------------
// `create()` / `prepareDesignSystem` treat `context.designSystem` as a RAW
// SOURCE and return a PROCESSED scratch CONFIG:
//
//   raw source                       processed CONFIG
//   color:  { black: 'black' }  ->   color:  { black: { value, var, rgb } }
//   theme:  { document: { '@dark': { background: 'gray1+6' } } }
//                               ->   theme:  { document: { background, color } }
//   icons:  { plus: '<svg …>' } ->   icons:  { plus: '<symbol …>' }
//
// `prepareDesignSystem` deep-clones its input, `deepMerge`s the RAW
// `DEFAULT_CONFIG` into it, and runs `init()` over the result. Feeding it a
// config that has ALREADY been through `init()` therefore re-derives every
// suffix from an already-derived value: `--color-black` becomes
// `--color-black-var`, `--theme-document-background` becomes
// `--theme-document-background-background`, and the base names every themed
// class actually references are never emitted at all. `--theme-document-
// background` then resolves to `var(--theme-document-<scheme>-background)`,
// which nothing defines. `injectSprites` double-converts the same way —
// `convertSvgToSymbol` over an already-converted `<symbol>` string.
//
// The workspace extension pane used to hand `ctx.designSystem` (the shell's
// live, already-init'ed CONFIG) back into `create()` and hit exactly that.
// Every other embed caller — `embedComponent`, the canvas frame-mode tile,
// preview's `renderProject` — passes a project's raw published design system
// and resolves correctly. So the input shape was the whole difference, and the
// fix belongs here, at the caller, not in the transformers: making `init()`
// idempotent would mean teaching every transformer to recognise its own output,
// on an object `prepareDesignSystem` has already blended with RAW
// `DEFAULT_CONFIG` keys — a per-key raw/processed mix no shape check can
// disambiguate reliably. Keeping the input type single-valued is what makes
// `init()` a well-defined raw -> processed function.
//
// This module is a pure data helper. It is deliberately NOT re-exported from
// `functions/index.js` (same as `extensionDataSeed.js`) — it is not an
// `el.call`-able project function.
// Sourced directly from @symbo.ls/utils (NOT the 'smbls' umbrella barrel):
// `deepClone`/`deepDefaults` are plain object helpers that live in
// @symbo.ls/utils/{object,sharedLibraries}.js and are simply re-exported by
// smbls's `export * from '@symbo.ls/utils'` — identical functions, same
// module. `smbls`'s own dist entry rolls up create/element/signal/css/state/
// scratch/default-config/wasm into ONE non-splittable bundle; this file is
// statically reachable from the shell entry (context.js -> here), so an
// `import … from 'smbls'` here pulls that whole framework bundle into the
// eager chunk for two tiny object helpers. @symbo.ls/utils has zero deps and
// ships real per-file dist output, so Parcel tree-shakes it down to just the
// two source files these helpers live in. See
// functions/workspaceProjects.js for the same established pattern.
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
var $7gmTd = parcelRequire("7gmTd");

var $4EXYv = parcelRequire("4EXYv");

var $ddnE4 = parcelRequire("ddnE4");

var $opCcU = parcelRequire("opCcU");
const $49a1aaceedba0a29$export$3cd59f7d2046c852 = {
    ...(0, $4EXYv.default),
    icons: {
        ...(0, $4EXYv.default).icons,
        ...(0, $opCcU.default)
    }
};
const $49a1aaceedba0a29$export$2f7ba20a1945b4b7 = ()=>{
    const ds = (0, $2C0hZ.deepClone)($49a1aaceedba0a29$export$3cd59f7d2046c852);
    (0, $7gmTd.deepDefaults)(ds, (0, $2C0hZ.deepClone)((0, $ddnE4.default)));
    return ds;
};

});
parcelRegister("4EXYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $36496ba1e6a1b375$export$2e2bcd8739ae039);
// NOTE — `font` and `fontFamily` are DELIBERATELY absent here. The TBC
// Contractica Georgian faces and the TBCContractica-first `smbls` stack
// moved to company/packages/brand (designSystem/font.js +
// designSystem/font_family.js, Nika 2026-09-02 "move to brand"), and this
// shell inherits them through the shared-library merge: smbls's
// mergeSharedLibraries runs deepDefaults(context.designSystem,
// brand.designSystem), so brand fills both keys here. Re-declaring either
// key in this file would shadow brand for the whole shell.

var $djS9c = parcelRequire("djS9c");

var $hfXlg = parcelRequire("hfXlg");

var $3uWVP = parcelRequire("3uWVP");

var $ic4no = parcelRequire("ic4no");

var $c0yVM = parcelRequire("c0yVM");

var $j5dYI = parcelRequire("j5dYI");

var $2Jr1N = parcelRequire("2Jr1N");

var $hlDmK = parcelRequire("hlDmK");

var $cgevL = parcelRequire("cgevL");

var $hwhfn = parcelRequire("hwhfn");

var $dAWnm = parcelRequire("dAWnm");

var $jfxqJ = parcelRequire("jfxqJ");

var $8QWSJ = parcelRequire("8QWSJ");

var $484y7 = parcelRequire("484y7");
var $36496ba1e6a1b375$export$2e2bcd8739ae039 = {
    color: $djS9c.default,
    gradient: $hfXlg.default,
    theme: $3uWVP.default,
    typography: $ic4no.default,
    spacing: $c0yVM.default,
    sizes: $j5dYI.default,
    timing: $2Jr1N.default,
    class: (0, $hlDmK.default),
    grid: $cgevL.default,
    icons: $hwhfn.default,
    shape: $dAWnm.default,
    reset: $jfxqJ.default,
    animation: $8QWSJ.default,
    media: $484y7.default
};

});
parcelRegister("djS9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b270d3d1c9734d5$export$2e2bcd8739ae039);
var $9b270d3d1c9734d5$export$2e2bcd8739ae039 = {
    // A quiet neutral canvas keeps the default shell's controls and generated
    // cards in the foreground. Workspace record vars and chrome.stage still
    // take precedence through the existing stage chain.
    stage: [
        'milk',
        'gray2'
    ],
    // Ambient cards sit one quiet fill step above the canvas in either theme.
    // Solid skins and explicit workspace card fills keep their own surfaces.
    cardGlass: [
        'white.72',
        'gray5.45'
    ],
    // THE AMBIENT SKY INK, quieter than the brand (DESIGN-WL-BOOT-LOADER-SKY-1,
    // Nika 2026-09-27: "for dashboard img bg keep opacity lower"). The brand pair
    // is ['gray1.25', 'white.15'] (HOME_AMBIENT_SKIN_SPEC §2); the shell's own
    // design system wins over the brand library's for the same key, so
    // AmbientBackdrop keeps `background: 'stageInk'` and paints this pair.
    // The boot overlay keeps its independent loading treatment.
    stageInk: [
        'gray1.08',
        'white.04'
    ],
    // The loader's mountain range (DESIGN-WL-BOOT-LOADER-MOTION-1): the same
    // hues, stronger — the range is the progress, not a backdrop. The
    // pre-bundle overlay mirrors it (#040404 .2 light, #fff .16 dark).
    loaderInk: [
        'gray1.2',
        'white.16'
    ],
    // The loader's ground (DESIGN-WL-BOOT-LOADER-MOTION-1, Nika 2026-09-29:
    // "loading should be black or white depends on theme mode"): the brand's
    // own white (light) and black (dark). The pre-bundle overlay mirrors it.
    loaderGround: [
        'white',
        'black'
    ],
    // Calendar-specific: adaptive day selection highlight.
    //
    // DOT FORM, no space, no `--` prefix. The legacy `['--blue .12', '--blue
    // .18']` spelling mints NOTHING: scratch's colour grammar is `blue.12`, and
    // a space before the alpha fails `parseColorToken`, so the atomic class is
    // emitted with an EMPTY body and the tint paints invisibly — the framework
    // logs "[scratch] color token `blue .12` has a space before its alpha/tone
    // modifier … Dropped rather than shipped invisible" on EVERY page load of
    // the shell, because this file is the shell's own design system. Measured
    // and re-pinned by __tests__/colorTokenGrammar.test.js.
    selectedDay: [
        'blue.12',
        'blue.18'
    ],
    // Brand cyan (#00FFFF) has ~1.25:1 contrast on white — effectively invisible
    // in light mode. Override as adaptive: bright cyan in dark, dark teal in
    // light (#0088A8 achieves ≥4.5:1 on white while staying recognisably cyan).
    cyan: [
        '#00FFFF',
        '#0088A8'
    ],
    // §4.2 danger ink — the accentInk pattern for the danger role. Brand `red`
    // (#EB6650) passes on the dark stage (5.7:1 on gray2) but measured 2.82:1
    // on the light stage (needs 4.5 at control sizes — /my Danger zone, AA walk
    // 2026-08-08). The light half deepens the same hue to ≥5.0:1 on every light
    // stage tint (5.69 white / 5.04 gray15 / 5.00 overlay-on-stage).
    // [lightValue, darkValue].
    // Dark slot inlined for the same deployed-runtime reason as the poster
    // catalog below: 'red' aliased the BRAND red (#EB6650) but the published
    // scratch passes the string through, and the browser paints CSS keyword
    // red (#FF0000) instead — a hotter, off-brand danger ink on every deployed
    // dark surface.
    redInk: [
        '#B93A24',
        '#EB6650' /* brand red */ 
    ],
    // ── HOME-BOARD POSTER CATALOG (tickets/fable.md HOME-POSTER-BRAND-1) ──────
    //
    // ⚠️ LITERAL HEXES, NOT TOKEN-NAME ALIASES — deployed-runtime compat.
    // These were authored as aliases into the brand palette
    // (`posterTickets: 'orange'`, `posterChat: 'grassgreen-35'`, …). The REPO
    // scratch resolves a string value recursively (system/color.js, the
    // `isString(val)` re-lookup), so locally — where node_modules/@symbo.ls/*
    // symlink to the repo — every alias resolved and the board looked right.
    // The PUBLISHED scratch the CI bundle actually ships has no such branch:
    // the alias string landed in CSS verbatim. Aliases that happen to be CSS
    // keywords painted as the KEYWORD (`orange` → rgb(255,165,0), not brand
    // orange #E98232; same for yellow/purple/brown); every other alias
    // (`electricBlue`, `red-40`, `grassgreen-35`, `gray2`, …) was an invalid
    // CSS colour and the declaration dropped — transparent, unstyled cards.
    // Measured live on dev.my.symbols.app/w/system/hq 2026-08-20, reported by
    // Nika as "colors, backgrounds and styles got broken".
    //
    // Each hex below is the value the REPO pipeline resolves the original
    // alias to — computed through the FULL repo pipeline (createConfig + set +
    // resolveColorRgb, the same harness homePosterTokens.test.js uses; a bare
    // getColor over raw tables loses the tone hop and five values came out
    // wrong, which that test caught) — so the rendered result is byte-identical to
    // the feature as designed — only the SHAPE is now one the published
    // runtime supports. Plain hex strings are passthrough on every runtime.
    // The original alias is kept beside each value; when the smbls publish
    // unblocks and the alias-resolving scratch ships, these MAY go back to
    // aliases — but only after the served bundle proves it resolves them.
    // The ink pairs stay `white`/`black`: CSS-native keywords, passthrough
    // everywhere, and proven painting correctly on the same live page.
    // One SEMANTIC pair per poster family — the hue tiles on the home board
    // (Studio / Tasks / Chat / Calendar / …) and every launcher tile, row
    // re-plating and hover wash that belongs to the same identity. Resolved by
    // `functions/homeWidgetHue.js` (`HOUSE_HUE_MAP` points at THESE tokens, not
    // at the raw brand hues), so a poster's whole identity changes in one
    // place. The direction itself is unchanged (Nika 2026-08-16 "keep it,
    // improve, but also maintain the custom workspace branded ones"): one
    // fixed hue + binary ink, identical in dark and light — posters are
    // THEME-INVARIANT by construction, which is why every pair below is a flat
    // hue and an ink whose two halves are equal.
    //
    // WHY TOKENS AND NOT RAW HUES IN THE MAP — the per-workspace override
    // channel. scratch emits each entry as `--color-poster<Family>` /
    // `--color-poster<Family>Ink` on the `:root` rule. A BRANDED workspace
    // supplies its own poster pairs through the record channel the shell
    // already has — `Workspace.settings.designSystem.vars` — which
    // `functions/workspaceConfigs.js` `_applyDesignSystem` writes INLINE on
    // `<html>` (inline beats the `:root` rule; `_revertDesignSystem` removes it
    // on a workspace switch). A workspace without those vars renders exactly
    // the defaults below. Zero tenant values live in code; no second channel.
    //   record contract (values are plain CSS colours, supply the PAIR):
    //     "--color-posterStudio":    "#1F4FD8"      ← the poster's hue
    //     "--color-posterStudioInk": "#FFFFFF"      ← its binary ink (white|black)
    //   families: Studio Tickets Chat Calendar Reminders Meet Broadcast
    //             Documents Agents Team Analytics People Health Files
    //
    // The INK tokens are PAIR-shaped on purpose (two equal halves), not flat:
    // scratch resolves a flat token's `.NN` alpha to a BAKED `rgba(...)` at
    // build time, but a pair token's alpha to `rgb(from var(--color-x) r g b /
    // .NN)` — read off the var at PAINT time — so the secondary-ink steps
    // (`posterStudioInk.81` …) follow a record override too. Byte-identical
    // defaults: the pair's computed colour is the same white/black as before.
    //
    // Hue choices: the brand hue each family always had, except three deepened
    // with the `−N` grammar design-direction.md §6 names for exactly this (the
    // `green-20` Meet precedent) so WHITE ink clears ≥5.0:1 (the §8.5 margin
    // over the 4.5:1 AA text floor) — measured against this design system
    // (`__tests__/homePosterTokens.test.js` re-derives every number):
    //   calendar `red` 3.21 → `red-40` 5.20 · chat `grassgreen` 3.30 →
    //   `grassgreen-35` 5.31 · meet `green-20` 3.61 → `green-45` 5.03.
    posterStudio: '#0F45FF' /* electricBlue */ ,
    posterStudioInk: [
        'white',
        'white'
    ],
    posterTickets: '#E98232' /* orange */ ,
    posterTicketsInk: [
        'black',
        'black'
    ],
    posterChat: '#477732' /* grassgreen-35 */ ,
    posterChatInk: [
        'white',
        'white'
    ],
    posterCalendar: '#C33E28' /* red-40 */ ,
    posterCalendarInk: [
        'white',
        'white'
    ],
    posterReminders: '#E8CC56' /* yellow */ ,
    posterRemindersInk: [
        'black',
        'black'
    ],
    posterMeet: '#2C7F29' /* green-45 */ ,
    posterMeetInk: [
        'white',
        'white'
    ],
    posterBroadcast: '#FFA4D1' /* pink+20 */ ,
    posterBroadcastInk: [
        'black',
        'black'
    ],
    posterDocuments: '#55B7D8' /* indigoblue */ ,
    posterDocumentsInk: [
        'black',
        'black'
    ],
    posterAgents: '#7345AF' /* purple */ ,
    posterAgentsInk: [
        'white',
        'white'
    ],
    posterTeam: '#1EDAFF' /* cerulean+30 */ ,
    posterTeamInk: [
        'black',
        'black'
    ],
    posterAnalytics: '#141416' /* gray2 */ ,
    posterAnalyticsInk: [
        'white',
        'white'
    ],
    posterPeople: '#7D6755' /* brown */ ,
    posterPeopleInk: [
        'white',
        'white'
    ],
    posterHealth: '#BCD835' /* phosphorus */ ,
    posterHealthInk: [
        'black',
        'black'
    ],
    posterFiles: '#00BCFF' /* cerulean */ ,
    posterFilesInk: [
        'black',
        'black'
    ]
};

});

parcelRegister("hfXlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c901de775aa5ae40$export$2e2bcd8739ae039);
var $c901de775aa5ae40$export$2e2bcd8739ae039 = {};

});

parcelRegister("3uWVP", function(module, exports) {

$parcel$export(module.exports, "default", () => $28c1e30849c42d71$export$2e2bcd8739ae039);
var $28c1e30849c42d71$export$2e2bcd8739ae039 = {};

});

parcelRegister("ic4no", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3ecbe077f49f929$export$2e2bcd8739ae039);
// Workspace type scale — OWNS the app's root font-size steps (brand's
// typography only fills gaps via deepDefaults, so values here win without
// touching brand's marketing-page scale).
//
// Scratch turns every `@<media>` step into a ROOT font-size template
// (`base / 16` em on html — smbls/packages/scratch/src/system/typography.js
// runThroughMedia), and the whole token system is EM-based, so each step
// scales text AND spacing together: smaller base = proportionally denser
// UI, not just smaller words. That is the lever for Nika 2026-08-18
// "reduce workspace font size for small screens so it fits more content".
//
// Steps (brand ships 17 → 16 @screenS → 15 @tabletS and stops there; the
// workspace is a dense tool on a tablet, so it goes one step further there):
//   base      17    (desktop, unchanged)
//   @screenS  16    (≤1440, unchanged)
//   @tabletS  14    (≤1024 — was 15; −6.7%)
//   @mobileL  16    (≤768 — a PHONE reads at the laptop root, see below)
//   @mobileM  16    (≤560 — same)
//
// The phone steps used to shrink further (13.5 / 13, 2026-08-18). Measured
// on dev 2026-09-10 at 390px: a 13px root put body copy at 13px, captions at
// 11px, the shortcut labels at 12px and the greeting at 16px — Nika: "fonts
// too small". A phone is read at arm's length with the thumb on the glass,
// so it takes the LAPTOP root (16 — the web's default body size, iOS body is
// 17) with the tightest ratio (1.1): headings stay close to the body instead
// of exploding on a narrow screen, and every em-based spacing token grows
// with it (A 13 → 16, B 21 → 26), which is what gives the dashboard lane its
// room (pages/main.js phone lane). Tablets keep their dense step.
// Each media step must restate `ratio` — runThroughMedia merges from the
// TOP-LEVEL factory (ratio 1.2), not from the previous step, so an
// unstated ratio would silently jump back to 1.2.
//
// Guard rails already in place elsewhere: inputs/textareas are floored at
// 16px on touch widths (app.js iOS zoom-on-focus guard), and device-
// physical chrome is px-pinned by design (shared sizes.js §3/§6), so
// neither zooms nor shrinks with these steps.
var $d3ecbe077f49f929$export$2e2bcd8739ae039 = {
    base: 17,
    ratio: 1.2,
    subSequence: true,
    '@screenS': {
        base: 16,
        ratio: 1.15
    },
    '@tabletS': {
        base: 14,
        ratio: 1.1
    },
    '@mobileL': {
        base: 16,
        ratio: 1.1
    },
    '@mobileM': {
        base: 16,
        ratio: 1.1
    }
};

});

parcelRegister("c0yVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8be094a9d80bef49$export$2e2bcd8739ae039);
var $8be094a9d80bef49$export$2e2bcd8739ae039 = {};

});

parcelRegister("j5dYI", function(module, exports) {

$parcel$export(module.exports, "default", () => $de4953bcd4ddbdb4$export$2e2bcd8739ae039);
// The loader's fixed geometry (DESIGN-WL-BOOT-LOADER-MOTION-1). The
// pre-bundle overlay in index.html mirrors these literally (its :root
// custom properties); __tests__/bootLoaderRange.test.js pins the pair.
var $de4953bcd4ddbdb4$export$2e2bcd8739ae039 = {
    // The range: a band across the bottom of the screen.
    loaderRange: '55vh',
    // The rising front's feather, and the front layer one feather taller than
    // the band (its top edge sits one feather above the band top).
    loaderFront: '44px',
    loaderFrontTop: '-44px',
    loaderFrontHeight: 'calc(100% + 44px)',
    // The art's summit (4.6 % down the band) — the mark rests just above it,
    // like a sun on the ridge, on every viewport.
    loaderSummit: 'calc(45vh + 55vh * 0.046)',
    // The mark's centre: 12px above the summit plus half the 56px mark.
    loaderCenter: 'calc(45vh + 55vh * 0.046 - 40px)',
    loaderMark: '56px',
    loaderLogoFont: 'calc(56px / 2.2)',
    // The stage line sits above the mark in the sky: centre - half the mark -
    // 20px - the 20px line.
    loaderStatusTop: 'calc(45vh + 55vh * 0.046 - 40px - 28px - 20px - 20px)',
    loaderStatusFont: '13px',
    // THE HOME'S GROUND (DESIGN-WL-HOME-SKY-TOP-GROUND-1): the band the
    // mountain range rises into at the end of the home scroll. The range art is
    // 3:1 (1440 x 480), so a third of the width shows it whole; never more than
    // 40 % of the viewport height, so the last widget row keeps its ground.
    groundBand: 'min(33.333vw, 40vh)',
    // THE SEARCH DROPDOWN'S HEIGHT (9A — Nika 2026-09-28: "make it a bit
    // taller"). The launcher body (components/SearchAppsMenu.js) caps at this
    // and scrolls INSIDE — its filter row and toolbar stay put while the tiles
    // or the results scroll. It was the house menu's 60vh; this is three
    // quarters of the viewport, never more than the panel's own viewport bound
    // leaves (the dropdown hangs under the header, so a full-height cap would
    // run off the bottom edge).
    searchPanelMaxH: 'min(76dvh, calc(100dvh - 96px))'
};

});

parcelRegister("2Jr1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fd4bff3d3c010ba$export$2e2bcd8739ae039);
var $1fd4bff3d3c010ba$export$2e2bcd8739ae039 = {};

});

parcelRegister("hlDmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca12ef119a87d808$export$2e2bcd8739ae039);
var $ca12ef119a87d808$export$2e2bcd8739ae039 = {};

});

parcelRegister("cgevL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed23c4be8b5152d$export$2e2bcd8739ae039);
var $8ed23c4be8b5152d$export$2e2bcd8739ae039 = {};

});

parcelRegister("hwhfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc12cdb51843f871$export$2e2bcd8739ae039);
var $cc12cdb51843f871$export$2e2bcd8739ae039 = {
    // The call panel's Hold control (components/WorkspaceCallPanel.js).
    pause: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4.75C8.41421 4.75 8.75 5.08579 8.75 5.5V18.5C8.75 18.9142 8.41421 19.25 8 19.25C7.58579 19.25 7.25 18.9142 7.25 18.5V5.5C7.25 5.08579 7.58579 4.75 8 4.75ZM16 4.75C16.4142 4.75 16.75 5.08579 16.75 5.5V18.5C16.75 18.9142 16.4142 19.25 16 19.25C15.5858 19.25 15.25 18.9142 15.25 18.5V5.5C15.25 5.08579 15.5858 4.75 16 4.75Z" fill="currentColor"/></svg>',
    phone: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/></svg>',
    add: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 3.25C12.4142 3.25 12.75 3.58579 12.75 4V11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H12.75V20C12.75 20.4142 12.4142 20.75 12 20.75C11.5858 20.75 11.25 20.4142 11.25 20V12.75H4C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H11.25V4C11.25 3.58579 11.5858 3.25 12 3.25Z" fill="currentColor"/>\\n</svg>',
    analytics: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5 21C4.44772 21 4 20.5523 4 20V10C4 9.44772 4.44772 9 5 9C5.55229 9 6 9.44772 6 10V20C6 20.5523 5.55229 21 5 21ZM12 21C11.4477 21 11 20.5523 11 20V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V20C13 20.5523 12.5523 21 12 21ZM19 21C18.4477 21 18 20.5523 18 20V14C18 13.4477 18.4477 13 19 13C19.5523 13 20 13.4477 20 14V20C20 20.5523 19.5523 21 19 21Z" fill="currentColor"/>\\n</svg>',
    arrowDown: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M19.7905 13.2673C20.0762 12.9674 20.0646 12.4926 19.7647 12.2069C19.4648 11.9212 18.99 11.9328 18.7043 12.2327L12.7498 18.484V3.75C12.7498 3.33579 12.4141 3 11.9998 3C11.5856 3 11.2498 3.33579 11.2498 3.75V18.4844L5.29502 12.2327C5.00933 11.9328 4.5346 11.9212 4.23467 12.2069C3.93475 12.4926 3.9232 12.9674 4.20889 13.2673L11.2756 20.6862C11.4366 20.8553 11.642 20.9552 11.8556 20.9861C11.9023 20.9952 11.9505 21 11.9998 21C12.0495 21 12.0981 20.9952 12.1451 20.9859C12.3582 20.9548 12.5631 20.8549 12.7238 20.6862L19.7905 13.2673Z" fill="currentColor"/>\\n</svg>',
    arrowLeft: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10.7327 19.7905C11.0326 20.0762 11.5074 20.0646 11.7931 19.7647C12.0788 19.4648 12.0672 18.99 11.7673 18.7043L5.51587 12.7497L20.25 12.7497C20.6642 12.7497 21 12.4139 21 11.9997C21 11.5855 20.6642 11.2497 20.25 11.2497L5.51577 11.2497L11.7673 5.29502C12.0672 5.00933 12.0787 4.5346 11.7931 4.23467C11.5074 3.93475 11.0326 3.9232 10.7327 4.20889L3.31379 11.2756C3.14486 11.4365 3.04491 11.6417 3.01393 11.8551C3.00479 11.9019 3 11.9503 3 11.9997C3 12.0493 3.00481 12.0977 3.01398 12.1446C3.04502 12.3579 3.14496 12.563 3.31379 12.7238L10.7327 19.7905Z" fill="currentColor"/>\\n</svg>',
    arrowRight: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M13.2673 4.20889C12.9674 3.9232 12.4926 3.93475 12.2069 4.23467C11.9212 4.5346 11.9328 5.00933 12.2327 5.29502L18.4841 11.2496H3.75C3.33579 11.2496 3 11.5854 3 11.9996C3 12.4138 3.33579 12.7496 3.75 12.7496H18.4842L12.2327 18.7043C11.9328 18.99 11.9212 19.4648 12.2069 19.7647C12.4926 20.0646 12.9674 20.0762 13.2673 19.7905L20.6862 12.7238C20.8551 12.5629 20.9551 12.3576 20.9861 12.1443C20.9952 12.0975 21 12.0491 21 11.9996C21 11.9501 20.9952 11.9016 20.986 11.8547C20.955 11.6415 20.855 11.4364 20.6862 11.2756L13.2673 4.20889Z" fill="currentColor"/>\\n</svg>',
    arrowUp: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.20889 10.7327C3.9232 11.0326 3.93475 11.5074 4.23467 11.7931C4.5346 12.0788 5.00933 12.0672 5.29502 11.7673L11.2495 5.516V20.25C11.2495 20.6642 11.5853 21 11.9995 21C12.4137 21 12.7495 20.6642 12.7495 20.25V5.51565L18.7043 11.7673C18.99 12.0672 19.4648 12.0788 19.7647 11.7931C20.0646 11.5074 20.0762 11.0326 19.7905 10.7327L12.7238 3.31379C12.5627 3.14474 12.3573 3.04477 12.1438 3.01386C12.0971 3.00477 12.0489 3 11.9995 3C11.9498 3 11.9012 3.00483 11.8543 3.01406C11.6412 3.04518 11.4363 3.14509 11.2756 3.31379L4.20889 10.7327Z" fill="currentColor"/>\\n</svg>',
    attachment: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M11.7722 3.74407C14.1136 1.40049 17.9126 1.40049 20.2558 3.74363C22.5388 6.0267 22.5974 9.69191 20.4314 12.0458L20.2432 12.2432L11.4432 21.0414L11.4066 21.0717C9.94541 22.3884 7.69141 22.3437 6.28404 20.9363C4.96502 19.6173 4.8429 17.5546 5.91769 16.0979C5.94103 16.0525 5.96928 16.0088 6.00249 15.9677L6.05605 15.908L6.14295 15.8203L6.28404 15.6724L6.28695 15.6753L13.7227 8.22096C13.9886 7.95434 14.4052 7.92958 14.6991 8.14704L14.7834 8.21955C15.05 8.48546 15.0747 8.90209 14.8573 9.19599L14.7848 9.28021L7.19015 16.8933C6.47251 17.7689 6.52239 19.0632 7.33979 19.8806C8.16885 20.7096 9.4885 20.7491 10.3643 19.999L19.197 11.1685C20.9525 9.41089 20.9525 6.56165 19.1951 4.80429C17.4927 3.10185 14.7655 3.04865 12.999 4.64469L12.8312 4.80429L12.8186 4.8186L3.28228 14.3549C2.98939 14.6478 2.51452 14.6478 2.22162 14.3549C1.95536 14.0887 1.93115 13.672 2.149 13.3784L2.22162 13.2943L11.7705 3.74363L11.7722 3.74407Z" fill="currentColor"/>\\n</svg>',
    bold: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.93514 4.43963C7.21647 4.15815 7.59813 4 7.99609 4H12.3795C15.0161 4 16.9995 6.18211 16.9995 8.62541C16.9995 9.60205 16.6828 10.5367 16.1341 11.307C17.211 12.134 17.9995 13.4274 17.9995 15.12C17.9995 18.2315 15.301 20 13.1195 20H7.99951C7.17108 20 6.49951 19.3284 6.49951 18.5L6.49609 5.50082C6.49588 5.10285 6.65382 4.72111 6.93514 4.43963ZM9.49869 10.2499H12.3795C13.2824 10.2499 13.9995 9.49051 13.9995 8.62541C13.9995 7.76 13.2814 7 12.3795 7H9.49691L9.49869 10.2499ZM9.49951 13.2499V17H13.1195C13.9927 17 14.9995 16.2464 14.9995 15.12C14.9995 13.9901 14.0248 13.2499 13.1195 13.2499H9.49951Z" fill="currentColor"/>\\n</svg>',
    bookmark: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.19094 21.8547C5.6948 22.2117 5.00293 21.8571 5.00293 21.2459V6.25C5.00293 4.45507 6.458 3 8.25293 3H15.7513C17.5462 3 19.0013 4.45507 19.0013 6.25V21.2459C19.0013 21.8571 18.3094 22.2117 17.8133 21.8547L12.0021 17.6738L6.19094 21.8547ZM17.5013 6.25C17.5013 5.2835 16.7178 4.5 15.7513 4.5H8.25293C7.28643 4.5 6.50293 5.2835 6.50293 6.25V19.7824L11.5641 16.141C11.8258 15.9528 12.1785 15.9528 12.4401 16.141L17.5013 19.7824V6.25Z" fill="currentColor"/>\\n</svg>',
    chat: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.3817 22 8.81782 21.6146 7.41286 20.888L3.58704 21.9553C2.92212 22.141 2.23258 21.7525 2.04691 21.0876C1.98546 20.8676 1.98549 20.6349 2.04695 20.4151L3.11461 16.5922C2.38637 15.186 2 13.6203 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 13.4696 3.87277 14.8834 4.57303 16.1375L4.72368 16.4072L3.61096 20.3914L7.59755 19.2792L7.86709 19.4295C9.12006 20.1281 10.5322 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM8.75 13H13.2483C13.6625 13 13.9983 13.3358 13.9983 13.75C13.9983 14.1297 13.7161 14.4435 13.35 14.4932L13.2483 14.5H8.75C8.33579 14.5 8 14.1642 8 13.75C8 13.3703 8.28215 13.0565 8.64823 13.0068L8.75 13H13.2483H8.75ZM8.75 9.5H15.2545C15.6687 9.5 16.0045 9.83579 16.0045 10.25C16.0045 10.6297 15.7223 10.9435 15.3563 10.9932L15.2545 11H8.75C8.33579 11 8 10.6642 8 10.25C8 9.8703 8.28215 9.55651 8.64823 9.50685L8.75 9.5H15.2545H8.75Z" fill="currentColor"/>\\n</svg>',
    check: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM10.75 13.4393L15.2197 8.96967C15.5126 8.67678 15.9874 8.67678 16.2803 8.96967C16.5466 9.23594 16.5708 9.6526 16.3529 9.94621L16.2803 10.0303L11.2803 15.0303C11.0141 15.2966 10.5974 15.3208 10.3038 15.1029L10.2197 15.0303L7.71967 12.5303C7.42678 12.2374 7.42678 11.7626 7.71967 11.4697C7.98594 11.2034 8.4026 11.1792 8.69621 11.3971L8.78033 11.4697L10.75 13.4393L15.2197 8.96967L10.75 13.4393Z" fill="currentColor"/>\\n</svg>',
    checkmark: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.53033 12.9697C4.23744 12.6768 3.76256 12.6768 3.46967 12.9697C3.17678 13.2626 3.17678 13.7374 3.46967 14.0303L7.96967 18.5303C8.26256 18.8232 8.73744 18.8232 9.03033 18.5303L20.0303 7.53033C20.3232 7.23744 20.3232 6.76256 20.0303 6.46967C19.7374 6.17678 19.2626 6.17678 18.9697 6.46967L8.5 16.9393L4.53033 12.9697Z" fill="currentColor"/>\\n</svg>',
    chevronDown: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.21967 8.46967C4.51256 8.17678 4.98744 8.17678 5.28033 8.46967L12 15.1893L18.7197 8.46967C19.0126 8.17678 19.4874 8.17678 19.7803 8.46967C20.0732 8.76256 20.0732 9.23744 19.7803 9.53033L12.5303 16.7803C12.2374 17.0732 11.7626 17.0732 11.4697 16.7803L4.21967 9.53033C3.92678 9.23744 3.92678 8.76256 4.21967 8.46967Z" fill="currentColor"/>\\n</svg>',
    chevronLeft: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M15.5303 4.21967C15.8232 4.51256 15.8232 4.98744 15.5303 5.28033L8.81066 12L15.5303 18.7197C15.8232 19.0126 15.8232 19.4874 15.5303 19.7803C15.2374 20.0732 14.7626 20.0732 14.4697 19.7803L7.21967 12.5303C6.92678 12.2374 6.92678 11.7626 7.21967 11.4697L14.4697 4.21967C14.7626 3.92678 15.2374 3.92678 15.5303 4.21967Z" fill="currentColor"/>\\n</svg>',
    chevronRight: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M8.46967 4.21967C8.17678 4.51256 8.17678 4.98744 8.46967 5.28033L15.1893 12L8.46967 18.7197C8.17678 19.0126 8.17678 19.4874 8.46967 19.7803C8.76256 20.0732 9.23744 20.0732 9.53033 19.7803L16.7803 12.5303C17.0732 12.2374 17.0732 11.7626 16.7803 11.4697L9.53033 4.21967C9.23744 3.92678 8.76256 3.92678 8.46967 4.21967Z" fill="currentColor"/>\\n</svg>',
    chevronUp: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.21967 15.5303C4.51256 15.8232 4.98744 15.8232 5.28033 15.5303L12 8.81066L18.7197 15.5303C19.0126 15.8232 19.4874 15.8232 19.7803 15.5303C20.0732 15.2374 20.0732 14.7626 19.7803 14.4697L12.5303 7.21967C12.2374 6.92678 11.7626 6.92678 11.4697 7.21967L4.21967 14.4697C3.92678 14.7626 3.92678 15.2374 4.21967 15.5303Z" fill="currentColor"/>\\n</svg>',
    close: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.39705 4.55379L4.46967 4.46967C4.73594 4.2034 5.1526 4.1792 5.44621 4.39705L5.53033 4.46967L12 10.939L18.4697 4.46967C18.7626 4.17678 19.2374 4.17678 19.5303 4.46967C19.8232 4.76256 19.8232 5.23744 19.5303 5.53033L13.061 12L19.5303 18.4697C19.7966 18.7359 19.8208 19.1526 19.6029 19.4462L19.5303 19.5303C19.2641 19.7966 18.8474 19.8208 18.5538 19.6029L18.4697 19.5303L12 13.061L5.53033 19.5303C5.23744 19.8232 4.76256 19.8232 4.46967 19.5303C4.17678 19.2374 4.17678 18.7626 4.46967 18.4697L10.939 12L4.46967 5.53033C4.2034 5.26406 4.1792 4.8474 4.39705 4.55379L4.46967 4.46967L4.39705 4.55379Z" fill="currentColor"/>\\n</svg>',
    code: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M8.06562 18.9434L14.5656 4.44339C14.7351 4.06542 15.1788 3.89637 15.5568 4.0658C15.9033 4.22112 16.0742 4.60695 15.9698 4.96131L15.9344 5.05698L9.43438 19.557C9.26495 19.935 8.82118 20.104 8.44321 19.9346C8.09673 19.7793 7.92581 19.3934 8.03024 19.0391L8.06562 18.9434L14.5656 4.44339L8.06562 18.9434ZM2.21967 11.4699L6.46967 7.21986C6.76256 6.92696 7.23744 6.92696 7.53033 7.21986C7.7966 7.48612 7.8208 7.90279 7.60295 8.1964L7.53033 8.28052L3.81066 12.0002L7.53033 15.7199C7.82322 16.0127 7.82322 16.4876 7.53033 16.7805C7.26406 17.0468 6.8474 17.071 6.55379 16.8531L6.46967 16.7805L2.21967 12.5305C1.9534 12.2642 1.9292 11.8476 2.14705 11.554L2.21967 11.4699L6.46967 7.21986L2.21967 11.4699ZM16.4697 7.21986C16.7359 6.95359 17.1526 6.92938 17.4462 7.14724L17.5303 7.21986L21.7803 11.4699C22.0466 11.7361 22.0708 12.1528 21.8529 12.4464L21.7803 12.5305L17.5303 16.7805C17.2374 17.0734 16.7626 17.0734 16.4697 16.7805C16.2034 16.5143 16.1792 16.0976 16.3971 15.804L16.4697 15.7199L20.1893 12.0002L16.4697 8.28052C16.1768 7.98762 16.1768 7.51275 16.4697 7.21986Z" fill="currentColor"/>\\n</svg>',
    codeBlock: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.25 3C4.45507 3 3 4.45507 3 6.25V17.75C3 19.5449 4.45507 21 6.25 21H17.75C19.5449 21 21 19.5449 21 17.75V6.25C21 4.45507 19.5449 3 17.75 3H6.25ZM4.5 6.25C4.5 5.2835 5.2835 4.5 6.25 4.5H17.75C18.7165 4.5 19.5 5.2835 19.5 6.25V17.75C19.5 18.7165 18.7165 19.5 17.75 19.5H6.25C5.2835 19.5 4.5 18.7165 4.5 17.75V6.25ZM10.5303 9.28033C10.8232 8.98744 10.8232 8.51256 10.5303 8.21967C10.2374 7.92678 9.76256 7.92678 9.46967 8.21967L6.21967 11.4697C5.92678 11.7626 5.92678 12.2374 6.21967 12.5303L9.46967 15.7803C9.76256 16.0732 10.2374 16.0732 10.5303 15.7803C10.8232 15.4874 10.8232 15.0126 10.5303 14.7197L7.81066 12L10.5303 9.28033ZM14.5303 8.21967C14.2374 7.92678 13.7626 7.92678 13.4697 8.21967C13.1768 8.51256 13.1768 8.98744 13.4697 9.28033L16.1893 12L13.4697 14.7197C13.1768 15.0126 13.1768 15.4874 13.4697 15.7803C13.7626 16.0732 14.2374 16.0732 14.5303 15.7803L17.7803 12.5303C18.0732 12.2374 18.0732 11.7626 17.7803 11.4697L14.5303 8.21967Z" fill="currentColor"/>\\n</svg>',
    copy: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.5028 4.62704L5.5 6.75V17.2542C5.5 19.0491 6.95507 20.5042 8.75 20.5042L17.3663 20.5045C17.0573 21.3782 16.224 22.0042 15.2444 22.0042H8.75C6.12665 22.0042 4 19.8776 4 17.2542V6.75C4 5.76929 4.62745 4.93512 5.5028 4.62704ZM17.75 2C18.9926 2 20 3.00736 20 4.25V17.25C20 18.4926 18.9926 19.5 17.75 19.5H8.75C7.50736 19.5 6.5 18.4926 6.5 17.25V4.25C6.5 3.00736 7.50736 2 8.75 2H17.75ZM17.75 3.5H8.75C8.33579 3.5 8 3.83579 8 4.25V17.25C8 17.6642 8.33579 18 8.75 18H17.75C18.1642 18 18.5 17.6642 18.5 17.25V4.25C18.5 3.83579 18.1642 3.5 17.75 3.5Z" fill="currentColor"/>\\n</svg>',
    delete: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10 5H14C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5ZM8.5 5C8.5 3.067 10.067 1.5 12 1.5C13.933 1.5 15.5 3.067 15.5 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.16421 21.6642 6.5 21.25 6.5H19.9309L18.7589 18.6112C18.5729 20.5334 16.9575 22 15.0263 22H8.97369C7.04254 22 5.42715 20.5334 5.24113 18.6112L4.06908 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.33579 2.33579 5 2.75 5H8.5ZM10.5 9.75C10.5 9.33579 10.1642 9 9.75 9C9.33579 9 9 9.33579 9 9.75V17.25C9 17.6642 9.33579 18 9.75 18C10.1642 18 10.5 17.6642 10.5 17.25V9.75ZM14.25 9C14.6642 9 15 9.33579 15 9.75V17.25C15 17.6642 14.6642 18 14.25 18C13.8358 18 13.5 17.6642 13.5 17.25V9.75C13.5 9.33579 13.8358 9 14.25 9ZM6.73416 18.4667C6.84577 19.62 7.815 20.5 8.97369 20.5H15.0263C16.185 20.5 17.1542 19.62 17.2658 18.4667L18.4239 6.5H5.57608L6.73416 18.4667Z" fill="currentColor"/>\\n</svg>',
    dismiss: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.39705 4.55379L4.46967 4.46967C4.73594 4.2034 5.1526 4.1792 5.44621 4.39705L5.53033 4.46967L12 10.939L18.4697 4.46967C18.7626 4.17678 19.2374 4.17678 19.5303 4.46967C19.8232 4.76256 19.8232 5.23744 19.5303 5.53033L13.061 12L19.5303 18.4697C19.7966 18.7359 19.8208 19.1526 19.6029 19.4462L19.5303 19.5303C19.2641 19.7966 18.8474 19.8208 18.5538 19.6029L18.4697 19.5303L12 13.061L5.53033 19.5303C5.23744 19.8232 4.76256 19.8232 4.46967 19.5303C4.17678 19.2374 4.17678 18.7626 4.46967 18.4697L10.939 12L4.46967 5.53033C4.2034 5.26406 4.1792 4.8474 4.39705 4.55379L4.46967 4.46967L4.39705 4.55379Z" fill="currentColor"/>\\n</svg>',
    document: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V9.82777C20 9.29733 19.7893 8.78863 19.4142 8.41355L13.5864 2.58579C13.2114 2.21071 12.7027 2 12.1722 2H6ZM5.5 4C5.5 3.72386 5.72386 3.5 6 3.5H12V8C12 9.10457 12.8954 10 14 10H18.5V20C18.5 20.2761 18.2761 20.5 18 20.5H6C5.72386 20.5 5.5 20.2761 5.5 20V4ZM17.3793 8.5H14C13.7239 8.5 13.5 8.27614 13.5 8V4.62066L17.3793 8.5Z" fill="currentColor"/>\\n</svg>',
    edit: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M20.9519 3.0481C19.5543 1.65058 17.2885 1.65064 15.8911 3.04825L3.94103 14.9997C3.5347 15.4061 3.2491 15.9172 3.116 16.4762L2.02041 21.0777C1.96009 21.3311 2.03552 21.5976 2.21968 21.7817C2.40385 21.9659 2.67037 22.0413 2.92373 21.981L7.52498 20.8855C8.08418 20.7523 8.59546 20.4666 9.00191 20.0601L20.952 8.10861C22.3493 6.71112 22.3493 4.4455 20.9519 3.0481ZM16.9518 4.10884C17.7634 3.29709 19.0795 3.29705 19.8912 4.10876C20.7028 4.9204 20.7029 6.23632 19.8913 7.04801L19 7.93946L16.0606 5.00012L16.9518 4.10884ZM15 6.06084L17.9394 9.00018L7.94119 18.9995C7.73104 19.2097 7.46668 19.3574 7.17755 19.4263L3.76191 20.2395L4.57521 16.8237C4.64402 16.5346 4.79168 16.2704 5.00175 16.0603L15 6.06084Z" fill="currentColor"/>\\n</svg>',
    emoji: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 1.99805C17.5237 1.99805 22.0015 6.47589 22.0015 11.9996C22.0015 17.5233 17.5237 22.0011 12 22.0011C6.47626 22.0011 1.99841 17.5233 1.99841 11.9996C1.99841 6.47589 6.47626 1.99805 12 1.99805ZM12 3.49805C7.30469 3.49805 3.49841 7.30432 3.49841 11.9996C3.49841 16.6949 7.30469 20.5011 12 20.5011C16.6952 20.5011 20.5015 16.6949 20.5015 11.9996C20.5015 7.30432 16.6952 3.49805 12 3.49805ZM8.4617 14.7829C9.31084 15.8606 10.6019 16.5012 11.9999 16.5012C13.3962 16.5012 14.6856 15.8624 15.5349 14.7871C15.7916 14.462 16.2633 14.4066 16.5883 14.6634C16.9134 14.9201 16.9688 15.3917 16.712 15.7168C15.5813 17.1485 13.8601 18.0012 11.9999 18.0012C10.1373 18.0012 8.41408 17.1462 7.28348 15.7112C7.02713 15.3859 7.08307 14.9143 7.40843 14.658C7.73379 14.4016 8.20535 14.4576 8.4617 14.7829ZM9.00041 8.75024C9.69037 8.75024 10.2497 9.30956 10.2497 9.99953C10.2497 10.6895 9.69037 11.2488 9.00041 11.2488C8.31045 11.2488 7.75112 10.6895 7.75112 9.99953C7.75112 9.30956 8.31045 8.75024 9.00041 8.75024ZM15.0004 8.75024C15.6904 8.75024 16.2497 9.30956 16.2497 9.99953C16.2497 10.6895 15.6904 11.2488 15.0004 11.2488C14.3104 11.2488 13.7511 10.6895 13.7511 9.99953C13.7511 9.30956 14.3104 8.75024 15.0004 8.75024Z" fill="currentColor"/>\\n</svg>',
    eye: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M11.9999 9.00462C14.209 9.00462 15.9999 10.7955 15.9999 13.0046C15.9999 15.2138 14.209 17.0046 11.9999 17.0046C9.79073 17.0046 7.99987 15.2138 7.99987 13.0046C7.99987 10.7955 9.79073 9.00462 11.9999 9.00462ZM11.9999 10.5046C10.6192 10.5046 9.49987 11.6239 9.49987 13.0046C9.49987 14.3853 10.6192 15.5046 11.9999 15.5046C13.3806 15.5046 14.4999 14.3853 14.4999 13.0046C14.4999 11.6239 13.3806 10.5046 11.9999 10.5046ZM11.9999 5.5C16.6134 5.5 20.596 8.65001 21.701 13.0644C21.8016 13.4662 21.5574 13.8735 21.1556 13.9741C20.7537 14.0746 20.3465 13.8305 20.2459 13.4286C19.307 9.67796 15.9212 7 11.9999 7C8.07681 7 4.68997 9.68026 3.75273 13.4332C3.65237 13.835 3.24523 14.0794 2.84336 13.9791C2.44149 13.8787 2.19707 13.4716 2.29743 13.0697C3.40052 8.65272 7.38436 5.5 11.9999 5.5Z" fill="currentColor"/>\\n</svg>',
    filter: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M13.5 16C13.9142 16 14.25 16.3358 14.25 16.75C14.25 17.1642 13.9142 17.5 13.5 17.5H10.5C10.0858 17.5 9.75 17.1642 9.75 16.75C9.75 16.3358 10.0858 16 10.5 16H13.5ZM16.5 11C16.9142 11 17.25 11.3358 17.25 11.75C17.25 12.1642 16.9142 12.5 16.5 12.5H7.5C7.08579 12.5 6.75 12.1642 6.75 11.75C6.75 11.3358 7.08579 11 7.5 11H16.5ZM19.5 6C19.9142 6 20.25 6.33579 20.25 6.75C20.25 7.16421 19.9142 7.5 19.5 7.5H4.5C4.08579 7.5 3.75 7.16421 3.75 6.75C3.75 6.33579 4.08579 6 4.5 6H19.5Z" fill="currentColor"/>\\n</svg>',
    flag: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3 3.74805C3 3.33383 3.33579 2.99805 3.75 2.99805H20.2541C20.8722 2.99805 21.225 3.70369 20.8541 4.19811L16.6898 9.74927L20.8541 15.3004C21.225 15.7948 20.8722 16.5005 20.2541 16.5005L4.5 16.5V21.2499C4.5 21.6296 4.21785 21.9434 3.85177 21.993L3.75 21.9999C3.3703 21.9999 3.05651 21.7177 3.00685 21.3517L3 21.2499V3.74805ZM18.7539 4.49805H4.5V15.0005H18.7539L15.1522 10.1993C14.9522 9.93264 14.9522 9.5659 15.1522 9.29921L18.7539 4.49805Z" fill="currentColor"/>\\n</svg>',
    folder: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.5 6.25V8H8.12868C8.32759 8 8.51836 7.92098 8.65901 7.78033L10.1893 6.25L8.65901 4.71967C8.51836 4.57902 8.32759 4.5 8.12868 4.5H5.25C4.2835 4.5 3.5 5.2835 3.5 6.25ZM2 6.25C2 4.45507 3.45507 3 5.25 3H8.12868C8.72542 3 9.29771 3.23705 9.71967 3.65901L11.5607 5.5H18.75C20.5449 5.5 22 6.95507 22 8.75V17.75C22 19.5449 20.5449 21 18.75 21H5.25C3.45507 21 2 19.5449 2 17.75V6.25ZM3.5 9.5V17.75C3.5 18.7165 4.2835 19.5 5.25 19.5H18.75C19.7165 19.5 20.5 18.7165 20.5 17.75V8.75C20.5 7.7835 19.7165 7 18.75 7H11.5607L9.71967 8.84099C9.29771 9.26295 8.72542 9.5 8.12868 9.5H3.5Z" fill="currentColor"/>\\n</svg>',
    heading: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M2.75 17H15.25C15.6642 17 16 17.3358 16 17.75C16 18.1297 15.7178 18.4435 15.3518 18.4932L15.25 18.5H2.75C2.33579 18.5 2 18.1642 2 17.75C2 17.3703 2.28215 17.0565 2.64823 17.0068L2.75 17H15.25H2.75ZM2.75 13H21.25C21.6642 13 22 13.3358 22 13.75C22 14.1297 21.7178 14.4435 21.3518 14.4932L21.25 14.5H2.75C2.33579 14.5 2 14.1642 2 13.75C2 13.3703 2.28215 13.0565 2.64823 13.0068L2.75 13H21.25H2.75ZM2.75 9H21.25C21.6642 9 22 9.33579 22 9.75C22 10.1297 21.7178 10.4435 21.3518 10.4932L21.25 10.5H2.75C2.33579 10.5 2 10.1642 2 9.75C2 9.3703 2.28215 9.05651 2.64823 9.00685L2.75 9H21.25H2.75ZM2.75 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.1297 21.7178 6.44349 21.3518 6.49315L21.25 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.3703 2.28215 5.05651 2.64823 5.00685L2.75 5H21.25H2.75Z" fill="currentColor"/>\\n</svg>',
    home: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5435 2.51449C11.812 2.32411 12.1701 2.32411 12.4386 2.51449L20.6886 8.36449C20.8853 8.5039 21.0021 8.72992 21.0021 8.97098V19.2486C21.0021 20.2151 20.2186 20.9986 19.2521 20.9986H15.2541C14.2876 20.9986 13.5041 20.2151 13.5041 19.2486V14.7505C13.5041 14.6124 13.3922 14.5005 13.2541 14.5005H10.7541C10.616 14.5005 10.5041 14.6124 10.5041 14.7505V19.2486C10.5041 20.2151 9.72061 20.9986 8.75411 20.9986H4.75218C3.78568 20.9986 3.00218 20.2151 3.00218 19.2486V8.97098C3.00218 8.72992 3.119 8.5039 3.31572 8.36449L11.5435 2.51449ZM11.9911 4.0353L4.50218 9.35891V19.2486C4.50218 19.3867 4.61411 19.4986 4.75218 19.4986H8.75411C8.89218 19.4986 9.00411 19.3867 9.00411 19.2486V14.7505C9.00411 13.784 9.78761 13.0005 10.7541 13.0005H13.2541C14.2206 13.0005 15.0041 13.784 15.0041 14.7505V19.2486C15.0041 19.3867 15.116 19.4986 15.2541 19.4986H19.2521C19.3902 19.4986 19.5021 19.3867 19.5021 19.2486V9.35891L11.9911 4.0353Z" fill="currentColor"/></svg>',
    database: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M20 5v6c0 1.66-3.58 3-8 3s-8-1.34-8-3V5"/><path d="M20 11v6c0 1.66-3.58 3-8 3s-8-1.34-8-3v-6"/></svg>',
    server: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="3" width="19" height="7" rx="2"/><rect x="2.5" y="14" width="19" height="7" rx="2"/><line x1="6" y1="6.5" x2="6.01" y2="6.5"/><line x1="6" y1="17.5" x2="6.01" y2="17.5"/></svg>',
    globe: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.2"/><line x1="2.8" y1="12" x2="21.2" y2="12"/><path d="M12 2.8a14 14 0 0 1 3.6 9.2 14 14 0 0 1-3.6 9.2 14 14 0 0 1-3.6-9.2A14 14 0 0 1 12 2.8z"/></svg>',
    gitBranch: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="6.5" y1="4.5" x2="6.5" y2="14"/><circle cx="6.5" cy="18" r="2.6"/><circle cx="17.5" cy="6" r="2.6"/><path d="M17.5 8.6a8.5 8.5 0 0 1-8.5 8.5"/></svg>',
    loadBalancer: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="3" width="6" height="6" rx="1.4"/><rect x="2.5" y="15" width="6" height="6" rx="1.4"/><rect x="15.5" y="15" width="6" height="6" rx="1.4"/><path d="M12 9v3M12 12H5.5v3M12 12h6.5v3"/></svg>',
    volume: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="2.5" y1="12" x2="21.5" y2="12"/><path d="M5.5 5.5L3 12v5.5a1.8 1.8 0 0 0 1.8 1.8h14.4a1.8 1.8 0 0 0 1.8-1.8V12l-2.5-6.5a1.8 1.8 0 0 0-1.7-1.2H7.2a1.8 1.8 0 0 0-1.7 1.2z"/><line x1="6" y1="15.5" x2="6.01" y2="15.5"/><line x1="10" y1="15.5" x2="10.01" y2="15.5"/></svg>',
    container: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 16V8a1.8 1.8 0 0 0-.9-1.56l-6.7-3.83a1.8 1.8 0 0 0-1.8 0L4.4 6.44A1.8 1.8 0 0 0 3.5 8v8a1.8 1.8 0 0 0 .9 1.56l6.7 3.83a1.8 1.8 0 0 0 1.8 0l6.7-3.83A1.8 1.8 0 0 0 20.5 16z"/><path d="M3.7 6.9l8.3 4.8 8.3-4.8"/><line x1="12" y1="21.5" x2="12" y2="11.7"/></svg>',
    worker: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2.5 4 13.5 11.5 13.5 11 21.5 20 10.5 12.5 10.5 13 2.5"/></svg>',
    cron: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.2"/><polyline points="12 6.5 12 12 15.5 14"/></svg>',
    image: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M17.75 3C19.5449 3 21 4.45507 21 6.25V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45507 3 6.25 3H17.75ZM18.3305 19.4014L12.5247 13.7148C12.2596 13.4553 11.8501 13.4316 11.5588 13.644L11.4752 13.7148L5.66845 19.4011C5.8504 19.4651 6.04613 19.5 6.25 19.5H17.75C17.9535 19.5 18.1489 19.4653 18.3305 19.4014L12.5247 13.7148L18.3305 19.4014ZM17.75 4.5H6.25C5.2835 4.5 4.5 5.2835 4.5 6.25V17.75C4.5 17.9584 4.53643 18.1583 4.60326 18.3437L10.4258 12.643C11.2589 11.8273 12.5675 11.7885 13.4458 12.5266L13.5742 12.6431L19.3964 18.3447C19.4634 18.159 19.5 17.9588 19.5 17.75V6.25C19.5 5.2835 18.7165 4.5 17.75 4.5ZM15.2521 6.5C16.4959 6.5 17.5042 7.50831 17.5042 8.75212C17.5042 9.99592 16.4959 11.0042 15.2521 11.0042C14.0083 11.0042 13 9.99592 13 8.75212C13 7.50831 14.0083 6.5 15.2521 6.5ZM15.2521 8C14.8367 8 14.5 8.33673 14.5 8.75212C14.5 9.1675 14.8367 9.50423 15.2521 9.50423C15.6675 9.50423 16.0042 9.1675 16.0042 8.75212C16.0042 8.33673 15.6675 8 15.2521 8Z" fill="currentColor"/>\\n</svg>',
    italic: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M9.75084 4H18.2544C18.6683 4 19.0039 4.33565 19.0039 4.74969C19.0039 5.12923 18.7219 5.4429 18.3561 5.49254L18.2544 5.49938L15.0569 5.499L10.0369 18.5H14.2497C14.6291 18.5 14.9427 18.7823 14.9923 19.1483L14.9992 19.25C14.9992 19.6295 14.7172 19.9435 14.3514 19.9932L14.2497 20H4.75037C4.33642 20 4.00391 19.664 4.00391 19.25C4.00391 18.8705 4.28331 18.5565 4.64872 18.5068L4.75037 18.5H8.43491L8.45616 18.4349L13.4499 5.499L9.75084 5.49938C9.37138 5.49938 9.05739 5.21735 9.00769 4.85142L9.00084 4.74969C9.00084 4.37015 9.28321 4.05649 9.64912 4.00684L9.75084 4H18.2544H9.75084Z" fill="currentColor"/>\\n</svg>',
    link: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M9.25 7C9.66421 7 10 7.33579 10 7.75C10 8.12656 9.72249 8.4383 9.36083 8.49187L9.25 8.5H7C5.067 8.5 3.5 10.067 3.5 12C3.5 13.864 4.95707 15.3876 6.79435 15.4941L7 15.5H9.25C9.66421 15.5 10 15.8358 10 16.25C10 16.6266 9.72249 16.9383 9.36083 16.9919L9.25 17H7C4.23858 17 2 14.7614 2 12C2 9.32226 4.10496 7.13615 6.75045 7.00612L7 7H9.25ZM17 7C19.7614 7 22 9.23858 22 12C22 14.6777 19.895 16.8638 17.2495 16.9939L17 17H14.75C14.3358 17 14 16.6642 14 16.25C14 15.8734 14.2775 15.5617 14.6392 15.5081L14.75 15.5H17C18.933 15.5 20.5 13.933 20.5 12C20.5 10.136 19.0429 8.6124 17.2057 8.50594L17 8.5H14.75C14.3358 8.5 14 8.16421 14 7.75C14 7.37344 14.2775 7.0617 14.6392 7.00813L14.75 7H17ZM7 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.3797 17.4678 12.6935 17.1018 12.7432L17 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12C6.25 11.6203 6.53215 11.3065 6.89823 11.2568L7 11.25H17H7Z" fill="currentColor"/>\\n</svg>',
    listBulleted: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.24929 17.5C3.93925 17.5 4.49858 18.0593 4.49858 18.7493C4.49858 19.4393 3.93925 19.9986 3.24929 19.9986C2.55933 19.9986 2 19.4393 2 18.7493C2 18.0593 2.55933 17.5 3.24929 17.5ZM6.75 18H21.25C21.6642 18 22 18.3358 22 18.75C22 19.1297 21.7178 19.4435 21.3518 19.4932L21.25 19.5H6.75C6.33579 19.5 6 19.1642 6 18.75C6 18.3703 6.28215 18.0565 6.64823 18.0068L6.75 18H21.25H6.75ZM3.24929 11C3.93925 11 4.49858 11.5593 4.49858 12.2493C4.49858 12.9393 3.93925 13.4986 3.24929 13.4986C2.55933 13.4986 2 12.9393 2 12.2493C2 11.5593 2.55933 11 3.24929 11ZM6.75 11.5H21.25C21.6642 11.5 22 11.8358 22 12.25C22 12.6297 21.7178 12.9435 21.3518 12.9932L21.25 13H6.75C6.33579 13 6 12.6642 6 12.25C6 11.8703 6.28215 11.5565 6.64823 11.5068L6.75 11.5H21.25H6.75ZM3.24929 4.5C3.93925 4.5 4.49858 5.05933 4.49858 5.74929C4.49858 6.43925 3.93925 6.99858 3.24929 6.99858C2.55933 6.99858 2 6.43925 2 5.74929C2 5.05933 2.55933 4.5 3.24929 4.5ZM6.75 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.1297 21.7178 6.44349 21.3518 6.49315L21.25 6.5H6.75C6.33579 6.5 6 6.16421 6 5.75C6 5.3703 6.28215 5.05651 6.64823 5.00685L6.75 5H21.25H6.75Z" fill="currentColor"/>\\n</svg>',
    listNumbered: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.0001 2.75007C6.0001 2.39585 5.75227 2.08992 5.40576 2.0164C5.06011 1.94307 4.7103 2.12094 4.5658 2.44311L4.56426 2.44645C4.56226 2.45075 4.55842 2.45889 4.55275 2.47049C4.5414 2.49373 4.52282 2.53063 4.49704 2.57815C4.44527 2.67364 4.36584 2.80953 4.2594 2.96255C4.04176 3.27544 3.73538 3.62496 3.35275 3.86399C3.00144 4.08344 2.89456 4.54613 3.11401 4.89743C3.33346 5.24873 3.79615 5.35562 4.14746 5.13616C4.27205 5.05833 4.38956 4.97481 4.5001 4.88772V7.25007C4.5001 7.66429 4.83589 8.00007 5.2501 8.00007C5.66431 8.00007 6.0001 7.66429 6.0001 7.25007V2.75007ZM20.4995 18.7501C20.4995 18.3359 20.1637 18.0001 19.7495 18.0001H10.7495C10.3353 18.0001 9.99951 18.3359 9.99951 18.7501C9.99951 19.1643 10.3353 19.5001 10.7495 19.5001H19.7495C20.1637 19.5001 20.4995 19.1643 20.4995 18.7501ZM20.4995 12.2437C20.4995 11.8295 20.1637 11.4937 19.7495 11.4937H10.7495C10.3353 11.4937 9.99951 11.8295 9.99951 12.2437C9.99951 12.658 10.3353 12.9937 10.7495 12.9937H19.7495C20.1637 12.9937 20.4995 12.658 20.4995 12.2437ZM20.4995 5.75008C20.4995 5.33586 20.1637 5.00008 19.7495 5.00008H10.7495C10.3353 5.00008 9.99951 5.33586 9.99951 5.75008C9.99951 6.16429 10.3353 6.50008 10.7495 6.50008H19.7495C20.1637 6.50008 20.4995 6.16429 20.4995 5.75008ZM5.15093 10.52C4.84957 10.4668 4.47444 10.5864 4.28031 10.7805C3.98741 11.0733 3.51253 11.0733 3.21965 10.7804C2.92677 10.4875 2.92678 10.0127 3.21969 9.71977C3.77556 9.16393 4.65044 8.90848 5.41157 9.04278C5.809 9.11291 6.2173 9.29717 6.52722 9.64842C6.8426 10.0058 7 10.4727 7 11.0001C7 11.6195 6.72895 12.0801 6.39406 12.4206C6.1163 12.7029 5.76315 12.9311 5.48826 13.1087L5.40874 13.1602C5.21348 13.2871 5.05428 13.3971 4.92686 13.5001H6.25C6.66421 13.5001 7 13.8359 7 14.2501C7 14.6643 6.6642 15.0001 6.24999 15.0001H3.75C3.33579 15.0001 3 14.6643 3 14.2501C3 12.9365 3.98385 12.2972 4.57505 11.913L4.63522 11.8739C4.95259 11.6678 5.16843 11.5275 5.32469 11.3687C5.45855 11.2326 5.5 11.1307 5.5 11.0001C5.5 10.7775 5.43865 10.6819 5.40247 10.6409C5.36083 10.5937 5.28475 10.5436 5.15093 10.52ZM2.96967 21.2804C2.96967 21.2804 3.06251 21.3641 2.97426 21.2849L2.97962 21.2902L2.9929 21.3028C3.00287 21.3122 3.01509 21.3233 3.02956 21.336C3.05848 21.3613 3.09653 21.3928 3.14375 21.4282C3.2381 21.499 3.36996 21.5861 3.53959 21.6709C3.88131 21.8418 4.37043 22.0001 5 22.0001C5.63921 22.0001 6.19596 21.8187 6.60132 21.4606C7.00922 21.1001 7.21163 20.6032 7.19553 20.1011C7.18219 19.6847 7.02903 19.3054 6.76986 19.0001C7.02903 18.6948 7.18219 18.3155 7.19553 17.8991C7.21163 17.3969 7.00922 16.9 6.60132 16.5396C6.19596 16.1814 5.63921 16.0001 5 16.0001C4.37043 16.0001 3.88131 16.1584 3.53959 16.3293C3.36996 16.4141 3.2381 16.5012 3.14375 16.572C3.09653 16.6074 3.05848 16.6389 3.02956 16.6642C3.01509 16.6768 3.00287 16.688 2.9929 16.6973L2.97962 16.71L2.97423 16.7152L2.97189 16.7176L2.97091 16.7185L2.96967 16.7197C2.67678 17.0126 2.67678 17.4875 2.96967 17.7804C3.2586 18.0693 3.72462 18.0732 4.01834 17.7921C4.0217 17.7892 4.03018 17.7821 4.04375 17.772C4.0744 17.749 4.13004 17.7111 4.21041 17.6709C4.36869 17.5918 4.62957 17.5001 5 17.5001C5.36079 17.5001 5.53601 17.6 5.60812 17.6637C5.67768 17.7251 5.69823 17.7907 5.6963 17.8511C5.69423 17.9156 5.66403 18.0028 5.57278 18.0819C5.4845 18.1585 5.30962 18.2501 5 18.2501C4.58579 18.2501 4.25 18.5859 4.25 19.0001C4.25 19.4143 4.58579 19.7501 5 19.7501C5.30962 19.7501 5.4845 19.8417 5.57278 19.9183C5.66403 19.9974 5.69423 20.0845 5.6963 20.1491C5.69823 20.2094 5.67768 20.275 5.60812 20.3365C5.53601 20.4002 5.36079 20.5001 5 20.5001C4.62957 20.5001 4.36869 20.4084 4.21041 20.3293C4.13004 20.2891 4.0744 20.2512 4.04375 20.2282C4.03018 20.218 4.0217 20.2109 4.01834 20.208C3.72462 19.9269 3.2586 19.9308 2.96967 20.2197C2.67678 20.5126 2.67678 20.9875 2.96967 21.2804ZM2.97189 16.7176L2.97091 16.7185C2.9776 16.713 3.17182 16.5516 2.97189 16.7176Z" fill="currentColor"/>\\n</svg>',
    mention: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 2C17.5226 2.00016 21.9999 6.47737 22 12C22 15.0893 20.3198 17.0254 18.25 17.0254C16.9541 17.0254 15.8114 16.2662 15.1377 14.9404C14.3338 16.173 13.0311 17 11.5 17C8.92926 17 7 14.6705 7 12C7 9.32955 8.92926 7 11.5 7C12.6753 7 13.7159 7.48764 14.5 8.27148V7.75C14.5 7.33579 14.8358 7 15.25 7C15.6642 7 16 7.33579 16 7.75V12C16 14.6107 17.3198 15.5254 18.25 15.5254C19.1802 15.5254 20.5 14.6107 20.5 12C20.4999 7.30579 16.6942 3.50016 12 3.5C7.30566 3.5 3.50013 7.30569 3.5 12C3.50016 16.6943 7.30568 20.5 12 20.5C13.0151 20.5 13.9884 20.3201 14.8906 19.9932C15.189 19.8853 15.5266 19.9466 15.751 20.1709C16.1231 20.5431 16.0216 21.1702 15.5293 21.3564C14.4319 21.7717 13.2428 22 12 22C6.47725 22 2.00016 17.5227 2 12C2.00013 6.47726 6.47723 2 12 2ZM11.5 8.5C9.92861 8.5 8.5 9.97603 8.5 12C8.5 14.024 9.92861 15.5 11.5 15.5C13.0714 15.5 14.5 14.024 14.5 12C14.5 9.97603 13.0714 8.5 11.5 8.5Z" fill="currentColor"/>\\n</svg>',
    minus: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.75391 12.5H20.2458C20.66 12.5 20.9958 12.1642 20.9958 11.75C20.9958 11.3358 20.66 11 20.2458 11H3.75391C3.33969 11 3.00391 11.3358 3.00391 11.75C3.00391 12.1642 3.33969 12.5 3.75391 12.5Z" fill="currentColor"/>\\n</svg>',
    more: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M7.75 12C7.75 12.9665 6.9665 13.75 6 13.75C5.0335 13.75 4.25 12.9665 4.25 12C4.25 11.0335 5.0335 10.25 6 10.25C6.9665 10.25 7.75 11.0335 7.75 12ZM13.75 12C13.75 12.9665 12.9665 13.75 12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12ZM18 13.75C18.9665 13.75 19.75 12.9665 19.75 12C19.75 11.0335 18.9665 10.25 18 10.25C17.0335 10.25 16.25 11.0335 16.25 12C16.25 12.9665 17.0335 13.75 18 13.75Z" fill="currentColor"/>\\n</svg>',
    moreVertical: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 7.75C11.0335 7.75 10.25 6.9665 10.25 6C10.25 5.0335 11.0335 4.25 12 4.25C12.9665 4.25 13.75 5.0335 13.75 6C13.75 6.9665 12.9665 7.75 12 7.75ZM12 13.75C11.0335 13.75 10.25 12.9665 10.25 12C10.25 11.0335 11.0335 10.25 12 10.25C12.9665 10.25 13.75 11.0335 13.75 12C13.75 12.9665 12.9665 13.75 12 13.75ZM10.25 18C10.25 18.9665 11.0335 19.75 12 19.75C12.9665 19.75 13.75 18.9665 13.75 18C13.75 17.0335 12.9665 16.25 12 16.25C11.0335 16.25 10.25 17.0335 10.25 18Z" fill="currentColor"/>\\n</svg>',
    people: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8ZM8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM15.5 9C15.5 8.17157 16.1716 7.5 17 7.5C17.8284 7.5 18.5 8.17157 18.5 9C18.5 9.82843 17.8284 10.5 17 10.5C16.1716 10.5 15.5 9.82843 15.5 9ZM17 6C15.3431 6 14 7.34315 14 9C14 10.6569 15.3431 12 17 12C18.6569 12 20 10.6569 20 9C20 7.34315 18.6569 6 17 6ZM14.2484 19.0377C14.9507 19.3232 15.8517 19.5 17.001 19.5C19.2833 19.5 20.5867 18.8027 21.2979 17.9421C21.643 17.5244 21.8186 17.1027 21.9077 16.7795C21.9521 16.6181 21.9754 16.48 21.9875 16.377C21.9936 16.3254 21.997 16.2821 21.9988 16.2487C21.9997 16.232 22.0003 16.2177 22.0006 16.2059L22.0009 16.1903L22.001 16.1839L22.001 16.1811L22.001 16.1786C22.001 14.9754 21.0256 14 19.8224 14H14.1796C14.1521 14 14.1248 14.0005 14.0977 14.0015C14.4916 14.4126 14.7787 14.927 14.914 15.5H19.8224C20.194 15.5 20.4958 15.7986 20.5009 16.1689C20.5006 16.1746 20.4997 16.1855 20.4979 16.2011C20.4934 16.2387 20.4835 16.3015 20.4615 16.3812C20.4177 16.5402 20.3277 16.7613 20.1416 16.9865C19.7903 17.4116 18.9687 18 17.001 18C16.0209 18 15.3252 17.854 14.8302 17.655C14.7231 18.0551 14.5452 18.5378 14.2484 19.0377ZM4.25 14C3.00736 14 2 15.0074 2 16.25V16.5011L2 16.5022L2.00001 16.5048L2.00007 16.5111L2.00035 16.5277C2.00064 16.5406 2.00117 16.5571 2.0021 16.5771C2.00396 16.6169 2.00745 16.6705 2.01398 16.7358C2.02701 16.8661 2.05233 17.045 2.10165 17.2564C2.19995 17.6776 2.39654 18.2404 2.79183 18.8051C3.61066 19.9749 5.17178 21 8 21C10.8282 21 12.3893 19.9749 13.2082 18.8051C13.6035 18.2404 13.8001 17.6776 13.8983 17.2564C13.9477 17.045 13.973 16.8661 13.986 16.7358C13.9926 16.6705 13.996 16.6169 13.9979 16.5771C13.9988 16.5571 13.9994 16.5406 13.9996 16.5277L13.9999 16.5111L14 16.5048L14 16.5022L14 16.25C14 15.0074 12.9926 14 11.75 14H4.25ZM3.50047 16.5072L3.5 16.4947V16.25C3.5 15.8358 3.83579 15.5 4.25 15.5H11.75C12.1642 15.5 12.5 15.8358 12.5 16.25V16.4946L12.4995 16.5072C12.4988 16.5222 12.4972 16.5493 12.4935 16.5865C12.486 16.6612 12.4703 16.7753 12.4376 16.9155C12.3718 17.1974 12.2403 17.5721 11.9793 17.9449C11.4857 18.6501 10.4218 19.5 8 19.5C5.57822 19.5 4.51434 18.6501 4.02067 17.9449C3.75971 17.5721 3.62818 17.1974 3.56241 16.9155C3.5297 16.7753 3.514 16.6612 3.50653 16.5865C3.50281 16.5493 3.50117 16.5222 3.50047 16.5072Z" fill="currentColor"/>\\n</svg>',
    person: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M17.7545 14.0002C18.9966 14.0002 20.0034 15.007 20.0034 16.2491V16.8245C20.0034 17.7188 19.6838 18.5836 19.1023 19.263C17.5329 21.0965 15.1457 22.0013 12.0004 22.0013C8.8545 22.0013 6.46849 21.0962 4.90219 19.2619C4.32242 18.583 4.00391 17.7195 4.00391 16.8267V16.2491C4.00391 15.007 5.01076 14.0002 6.25278 14.0002H17.7545ZM17.7545 15.5002H6.25278C5.83919 15.5002 5.50391 15.8355 5.50391 16.2491V16.8267C5.50391 17.3624 5.69502 17.8805 6.04287 18.2878C7.29618 19.7555 9.26206 20.5013 12.0004 20.5013C14.7387 20.5013 16.7063 19.7555 17.9627 18.2876C18.3117 17.8799 18.5034 17.361 18.5034 16.8245V16.2491C18.5034 15.8355 18.1681 15.5002 17.7545 15.5002ZM12.0004 2.00488C14.7618 2.00488 17.0004 4.24346 17.0004 7.00488C17.0004 9.76631 14.7618 12.0049 12.0004 12.0049C9.23894 12.0049 7.00036 9.76631 7.00036 7.00488C7.00036 4.24346 9.23894 2.00488 12.0004 2.00488ZM12.0004 3.50488C10.0674 3.50488 8.50036 5.07189 8.50036 7.00488C8.50036 8.93788 10.0674 10.5049 12.0004 10.5049C13.9334 10.5049 15.5004 8.93788 15.5004 7.00488C15.5004 5.07189 13.9334 3.50488 12.0004 3.50488Z" fill="currentColor"/>\\n</svg>',
    pin: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M16.2425 2.93189L21.0682 7.75765C22.3955 9.08491 22.0324 11.3224 20.3535 12.1619L15.4826 14.5973C15.3073 14.685 15.1732 14.8379 15.1092 15.0232L13.6699 19.1895C13.3684 20.0622 12.2574 20.3181 11.6045 19.6653L8.50002 16.5607L4.06074 21.0001H3L3.00008 19.9394L7.43936 15.5001L4.33487 12.3956C3.682 11.7427 3.93791 10.6317 4.81061 10.3302L8.97688 8.89096C9.16223 8.82694 9.31512 8.69287 9.40281 8.51748L11.8382 3.6466C12.6777 1.96772 14.9152 1.60462 16.2425 2.93189ZM20.0076 8.81831L15.1818 3.99255C14.5785 3.38924 13.5614 3.55429 13.1799 4.31742L10.7445 9.18829C10.4814 9.71446 10.0227 10.1167 9.46666 10.3087L5.67812 11.6175L12.3826 18.322L13.6914 14.5335C13.8835 13.9774 14.2857 13.5188 14.8118 13.2557L19.6827 10.8202C20.4458 10.4387 20.6109 9.42161 20.0076 8.81831Z" fill="currentColor"/>\\n</svg>',
    quote: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M8 5C9.62875 5 10.9526 6.29802 10.9971 7.91602C11.0002 7.94363 11.0029 7.97156 11.0029 8C11.0029 10.9327 9.936 13.3818 8.88965 15.0811C8.3651 15.9329 7.84001 16.6051 7.44434 17.0664C7.24631 17.2973 7.0797 17.4767 6.96094 17.5996C6.9017 17.6609 6.85398 17.7081 6.82031 17.7412C6.80346 17.7578 6.78999 17.771 6.78027 17.7803C6.77548 17.7849 6.77151 17.7892 6.76855 17.792C6.76721 17.7933 6.76558 17.794 6.76465 17.7949L6.76367 17.7969C6.46146 18.08 5.98635 18.0648 5.70312 17.7627C5.41997 17.4605 5.4352 16.9863 5.7373 16.7031C5.73816 16.7023 5.73972 16.7006 5.74219 16.6982C5.74761 16.693 5.75709 16.6841 5.76953 16.6719C5.79442 16.6474 5.83279 16.6084 5.88281 16.5566C5.98286 16.4531 6.12878 16.2961 6.30566 16.0898C6.6604 15.6762 7.1363 15.067 7.6123 14.2939C8.19982 13.3398 8.77816 12.1484 9.1377 10.7754C8.78672 10.9194 8.40287 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5ZM16 5C17.6288 5 18.9526 6.29802 18.9971 7.91602C19.0002 7.94363 19.0029 7.97156 19.0029 8C19.0029 10.9327 17.936 13.3818 16.8896 15.0811C16.3651 15.9329 15.84 16.6051 15.4443 17.0664C15.2463 17.2973 15.0797 17.4767 14.9609 17.5996C14.9017 17.6609 14.854 17.7081 14.8203 17.7412C14.8035 17.7578 14.79 17.771 14.7803 17.7803C14.7755 17.7849 14.7715 17.7892 14.7686 17.792C14.7672 17.7933 14.7656 17.794 14.7646 17.7949L14.7637 17.7969C14.4615 18.08 13.9863 18.0648 13.7031 17.7627C13.42 17.4605 13.4352 16.9863 13.7373 16.7031C13.7382 16.7023 13.7397 16.7006 13.7422 16.6982C13.7476 16.693 13.7571 16.6841 13.7695 16.6719C13.7944 16.6474 13.8328 16.6084 13.8828 16.5566C13.9829 16.4531 14.1288 16.2961 14.3057 16.0898C14.6604 15.6762 15.1363 15.067 15.6123 14.2939C16.1998 13.3398 16.7782 12.1484 17.1377 10.7754C16.7867 10.9194 16.4029 11 16 11C14.3431 11 13 9.65685 13 8C13 6.34315 14.3431 5 16 5ZM8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5ZM16 6.5C15.1716 6.5 14.5 7.17157 14.5 8C14.5 8.82843 15.1716 9.5 16 9.5C16.8284 9.5 17.5 8.82843 17.5 8C17.5 7.17157 16.8284 6.5 16 6.5Z" fill="currentColor"/>\\n</svg>',
    reply: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M9.28033 6.28033C9.57322 5.98744 9.57322 5.51256 9.28033 5.21967C8.98744 4.92678 8.51256 4.92678 8.21967 5.21967L3.21967 10.2197C2.92678 10.5126 2.92678 10.9874 3.21967 11.2803L8.21967 16.2803C8.51256 16.5732 8.98744 16.5732 9.28033 16.2803C9.57322 15.9874 9.57322 15.5126 9.28033 15.2197L5.56066 11.5H13.25C16.7018 11.5 19.5 14.2982 19.5 17.75V18.25C19.5 18.6642 19.8358 19 20.25 19C20.6642 19 21 18.6642 21 18.25V17.75C21 13.4698 17.5302 10 13.25 10H5.56066L9.28033 6.28033Z" fill="currentColor"/>\\n</svg>',
    save: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3 5.75C3 4.23122 4.23122 3 5.75 3H15.7145C16.5764 3 17.4031 3.34241 18.0126 3.9519L20.0481 5.98744C20.6576 6.59693 21 7.42358 21 8.28553V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75ZM5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H6V14.25C6 13.0074 7.00736 12 8.25 12H15.75C16.9926 12 18 13.0074 18 14.25V19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V8.28553C19.5 7.8214 19.3156 7.37629 18.9874 7.0481L16.9519 5.01256C16.6918 4.75246 16.3582 4.58269 16 4.52344V7.25C16 8.49264 14.9926 9.5 13.75 9.5H9.25C8.00736 9.5 7 8.49264 7 7.25V4.5H5.75ZM16.5 19.5V14.25C16.5 13.8358 16.1642 13.5 15.75 13.5H8.25C7.83579 13.5 7.5 13.8358 7.5 14.25V19.5H16.5ZM8.5 4.5V7.25C8.5 7.66421 8.83579 8 9.25 8H13.75C14.1642 8 14.5 7.66421 14.5 7.25V4.5H8.5Z" fill="currentColor"/>\\n</svg>',
    search: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M16.1017 17.1624C14.717 18.3101 12.9391 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 12.9391 18.3101 14.717 17.1624 16.1018L21.7803 20.7197C22.0732 21.0126 22.0732 21.4874 21.7803 21.7803C21.4874 22.0732 21.0125 22.0732 20.7196 21.7803L16.1017 17.1624ZM17.5 11C17.5 7.41015 14.5899 4.5 11 4.5C7.41015 4.5 4.5 7.41015 4.5 11C4.5 14.5899 7.41015 17.5 11 17.5C14.5899 17.5 17.5 14.5899 17.5 11Z" fill="currentColor"/>\\n</svg>',
    send: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.69362 11.9997L2.29933 3.2715C2.0631 2.66403 2.65544 2.08309 3.2414 2.28959L3.33375 2.32885L21.3337 11.3288C21.852 11.588 21.8844 12.2975 21.4309 12.6129L21.3337 12.6705L3.33375 21.6705C2.75077 21.962 2.11746 21.426 2.2688 20.8234L2.29933 20.7278L5.69362 11.9997L2.29933 3.2715L5.69362 11.9997ZM4.4021 4.54007L7.01109 11.2491L13.6387 11.2497C14.0184 11.2497 14.3322 11.5318 14.3818 11.8979L14.3887 11.9997C14.3887 12.3794 14.1065 12.6932 13.7404 12.7428L13.6387 12.7497L7.01109 12.7491L4.4021 19.4593L19.3213 11.9997L4.4021 4.54007Z" fill="currentColor"/>\\n</svg>',
    settings: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12.0122 2.25C12.7462 2.25846 13.4773 2.34326 14.1937 2.50304C14.5064 2.57279 14.7403 2.83351 14.7758 3.15196L14.946 4.67881C15.0231 5.37986 15.615 5.91084 16.3206 5.91158C16.5103 5.91188 16.6979 5.87238 16.8732 5.79483L18.2738 5.17956C18.5651 5.05159 18.9055 5.12136 19.1229 5.35362C20.1351 6.43464 20.8889 7.73115 21.3277 9.14558C21.4223 9.45058 21.3134 9.78203 21.0564 9.9715L19.8149 10.8866C19.4607 11.1468 19.2516 11.56 19.2516 11.9995C19.2516 12.4389 19.4607 12.8521 19.8157 13.1129L21.0582 14.0283C21.3153 14.2177 21.4243 14.5492 21.3297 14.8543C20.8911 16.2685 20.1377 17.5649 19.1261 18.6461C18.9089 18.8783 18.5688 18.9483 18.2775 18.8206L16.8712 18.2045C16.4688 18.0284 16.0068 18.0542 15.6265 18.274C15.2463 18.4937 14.9933 18.8812 14.945 19.3177L14.7759 20.8444C14.741 21.1592 14.5122 21.4182 14.204 21.4915C12.7556 21.8361 11.2465 21.8361 9.79803 21.4915C9.48991 21.4182 9.26105 21.1592 9.22618 20.8444L9.05736 19.32C9.00777 18.8843 8.75434 18.498 8.37442 18.279C7.99451 18.06 7.5332 18.0343 7.1322 18.2094L5.72557 18.8256C5.43422 18.9533 5.09403 18.8833 4.87678 18.6509C3.86462 17.5685 3.11119 16.2705 2.6732 14.8548C2.57886 14.5499 2.68786 14.2186 2.94485 14.0293L4.18818 13.1133C4.54232 12.8531 4.75147 12.4399 4.75147 12.0005C4.75147 11.561 4.54232 11.1478 4.18771 10.8873L2.94516 9.97285C2.6878 9.78345 2.5787 9.45178 2.67337 9.14658C3.11212 7.73215 3.86594 6.43564 4.87813 5.35462C5.09559 5.12236 5.43594 5.05259 5.72724 5.18056L7.12762 5.79572C7.53056 5.97256 7.9938 5.94585 8.37577 5.72269C8.75609 5.50209 9.00929 5.11422 9.05817 4.67764L9.22824 3.15196C9.26376 2.83335 9.49786 2.57254 9.8108 2.50294C10.5281 2.34342 11.26 2.25865 12.0122 2.25ZM12.0124 3.7499C11.5583 3.75524 11.1056 3.79443 10.6578 3.86702L10.5489 4.84418C10.4471 5.75368 9.92003 6.56102 9.13042 7.01903C8.33597 7.48317 7.36736 7.53903 6.52458 7.16917L5.62629 6.77456C5.05436 7.46873 4.59914 8.25135 4.27852 9.09168L5.07632 9.67879C5.81513 10.2216 6.25147 11.0837 6.25147 12.0005C6.25147 12.9172 5.81513 13.7793 5.0771 14.3215L4.27805 14.9102C4.59839 15.752 5.05368 16.5361 5.626 17.2316L6.53113 16.8351C7.36923 16.4692 8.33124 16.5227 9.12353 16.9794C9.91581 17.4361 10.4443 18.2417 10.548 19.1526L10.657 20.1365C11.5466 20.2878 12.4555 20.2878 13.3451 20.1365L13.4541 19.1527C13.5549 18.2421 14.0828 17.4337 14.876 16.9753C15.6692 16.5168 16.6332 16.463 17.4728 16.8305L18.3772 17.2267C18.949 16.5323 19.4041 15.7495 19.7247 14.909L18.9267 14.3211C18.1879 13.7783 17.7516 12.9162 17.7516 11.9995C17.7516 11.0827 18.1879 10.2206 18.9258 9.67847L19.7227 9.09109C19.4021 8.25061 18.9468 7.46784 18.3748 6.77356L17.4783 7.16737C17.113 7.32901 16.7178 7.4122 16.3187 7.41158C14.849 7.41004 13.6155 6.30355 13.4551 4.84383L13.3462 3.8667C12.9007 3.7942 12.4526 3.75512 12.0124 3.7499ZM11.9997 8.24995C14.0708 8.24995 15.7497 9.92888 15.7497 12C15.7497 14.071 14.0708 15.75 11.9997 15.75C9.92863 15.75 8.2497 14.071 8.2497 12C8.2497 9.92888 9.92863 8.24995 11.9997 8.24995ZM11.9997 9.74995C10.7571 9.74995 9.7497 10.7573 9.7497 12C9.7497 13.2426 10.7571 14.25 11.9997 14.25C13.2423 14.25 14.2497 13.2426 14.2497 12C14.2497 10.7573 13.2423 9.74995 11.9997 9.74995Z" fill="currentColor"/>\\n</svg>',
    star: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10.7878 3.10215C11.283 2.09877 12.7138 2.09876 13.209 3.10215L15.567 7.87987L20.8395 8.64601C21.9468 8.80691 22.3889 10.1677 21.5877 10.9487L17.7724 14.6676L18.6731 19.9189C18.8622 21.0217 17.7047 21.8627 16.7143 21.342L11.9984 18.8627L7.28252 21.342C6.29213 21.8627 5.13459 21.0217 5.32374 19.9189L6.2244 14.6676L2.40916 10.9487C1.60791 10.1677 2.05005 8.80691 3.15735 8.64601L8.42988 7.87987L10.7878 3.10215ZM11.9984 4.03854L9.74008 8.61443C9.54344 9.01288 9.16332 9.28904 8.72361 9.35294L3.67382 10.0867L7.32788 13.6486C7.64606 13.9587 7.79125 14.4055 7.71614 14.8435L6.85353 19.8729L11.3702 17.4983C11.7635 17.2915 12.2333 17.2915 12.6266 17.4983L17.1433 19.8729L16.2807 14.8435C16.2056 14.4055 16.3508 13.9587 16.6689 13.6486L20.323 10.0867L15.2732 9.35294C14.8335 9.28904 14.4534 9.01288 14.2568 8.61443L11.9984 4.03854Z" fill="currentColor"/>\\n</svg>',
    strikethrough: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M4.75 12.0002H19.2507C19.6649 12.0002 20.0007 12.3359 20.0007 12.7502C20.0007 13.1299 19.7185 13.4437 19.3524 13.4933L19.2507 13.5002L16.2763 13.5001C17.1552 14.3132 17.6124 15.2931 17.6124 16.4347C17.6124 19.2599 14.3804 21.0745 10.8577 20.6651C8.6233 20.4054 7.04896 19.5095 6.22285 17.9632C6.02767 17.5978 6.16562 17.1434 6.53097 16.9482C6.89632 16.7531 7.35071 16.891 7.54589 17.2564C8.11607 18.3236 9.2483 18.968 11.0308 19.1751C13.7738 19.4939 16.1124 18.1809 16.1124 16.4347C16.1124 15.2627 15.3072 14.3077 13.547 13.5485L13.431 13.5L4.75 13.5002C4.3703 13.5002 4.05651 13.218 4.00685 12.8519L4 12.7502C4 12.3705 4.28215 12.0567 4.64823 12.007L4.75 12.0002H19.2507H4.75ZM6.26098 8.12336C6.41313 5.29223 9.08273 3.65466 12.5845 4.06162C14.7732 4.31598 16.4484 5.11481 17.5674 6.47091C17.8311 6.79039 17.7858 7.2631 17.4663 7.52674C17.1469 7.79038 16.6742 7.74512 16.4105 7.42564C15.5584 6.393 14.2394 5.76405 12.4113 5.55159C9.69368 5.23576 7.76098 6.35648 7.76098 8.12336C7.76098 8.89538 7.99478 9.47149 8.59075 10.1045L8.71896 10.2372C8.81323 10.3327 8.91566 10.4324 8.96956 10.4763L9 10.4979H7.08082L7.05613 10.4589C6.91314 10.2526 6.1997 9.26354 6.26098 8.12336Z" fill="currentColor"/>\\n</svg>',
    underline: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M6.75001 19H17.25C17.6642 19 18 19.3358 18 19.75C18 20.1297 17.7179 20.4435 17.3518 20.4932L17.25 20.5H6.75001C6.33579 20.5 6.00001 20.1642 6.00001 19.75C6.00001 19.3703 6.28216 19.0565 6.64824 19.0068L6.75001 19H17.25H6.75001ZM17.25 4C17.6297 4 17.9435 4.28215 17.9932 4.64823L18 4.75V10.75C18 15.1437 15.9371 17.5 11.9971 17.5C8.14241 17.5 6.08619 15.2446 6.00265 11.0336L6 10.75V4.75C6 4.33579 6.33579 4 6.75001 4C7.1297 4 7.44349 4.28215 7.49315 4.64823L7.5 4.75V10.7507C7.49647 14.3568 8.93346 16 11.9971 16C14.9824 16 16.4251 14.4395 16.4972 11.0235L16.5 10.75V4.75C16.5 4.33579 16.8358 4 17.25 4Z" fill="currentColor"/>\\n</svg>',
    recordstop: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 9.5C8 8.67157 8.67157 8 9.5 8H14.5C15.3284 8 16 8.67157 16 9.5V14.5C16 15.3284 15.3284 16 14.5 16H9.5C8.67157 16 8 15.3284 8 14.5V9.5Z" fill="currentColor"/>\\n</svg>',
    mic: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M18.25 11C18.6297 11 18.9435 11.2822 18.9932 11.6482L19 11.75V12.25C19 15.8094 16.245 18.7254 12.751 18.9817L12.75 21.25C12.75 21.6642 12.4142 22 12 22C11.6203 22 11.3065 21.7178 11.2568 21.3518L11.25 21.25L11.25 18.9818C7.83323 18.7316 5.12283 15.938 5.00406 12.4863L5 12.25V11.75C5 11.3358 5.33579 11 5.75 11C6.1297 11 6.44349 11.2822 6.49315 11.6482L6.5 11.75V12.25C6.5 15.077 8.73445 17.3821 11.5336 17.4956L11.75 17.5H12.25C15.077 17.5 17.3821 15.2656 17.4956 12.4664L17.5 12.25V11.75C17.5 11.3358 17.8358 11 18.25 11ZM12 2C14.2091 2 16 3.79086 16 6V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V6C8 3.79086 9.79086 2 12 2ZM12 3.5C10.6193 3.5 9.5 4.61929 9.5 6V12C9.5 13.3807 10.6193 14.5 12 14.5C13.3807 14.5 14.5 13.3807 14.5 12V6C14.5 4.61929 13.3807 3.5 12 3.5Z" fill="currentColor"/>\\n</svg>',
    micOff: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.28034 2.21968C2.98745 1.92678 2.51257 1.92677 2.21968 2.21966C1.92678 2.51255 1.92677 2.98743 2.21966 3.28032L8 9.06078V12C8 14.2091 9.79086 16 12 16C12.8335 16 13.6074 15.7451 14.2481 15.309L15.394 16.4549C14.5176 17.1112 13.4292 17.5 12.25 17.5H11.75L11.5336 17.4956C8.73445 17.3821 6.5 15.077 6.5 12.25V11.75L6.49315 11.6482C6.44349 11.2822 6.1297 11 5.75 11C5.33579 11 5 11.3358 5 11.75V12.25L5.00406 12.4863C5.12283 15.938 7.83323 18.7316 11.25 18.9818L11.25 21.25L11.2568 21.3518C11.3065 21.7178 11.6203 22 12 22C12.4142 22 12.75 21.6642 12.75 21.25L12.751 18.9817C14.15 18.8791 15.4305 18.35 16.4631 17.5241L20.7194 21.7805C21.0123 22.0734 21.4872 22.0734 21.7801 21.7805C22.073 21.4876 22.073 21.0127 21.7801 20.7198L3.28034 2.21968ZM13.1562 14.2171C12.8105 14.3978 12.4172 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12V10.5608L13.1562 14.2171ZM14.5 6V11.3182L15.9301 12.7483C15.976 12.5059 16 12.2558 16 12V6C16 3.79086 14.2091 2 12 2C10.1521 2 8.59692 3.25302 8.13768 4.95575L9.5 6.3181V6C9.5 4.61929 10.6193 3.5 12 3.5C13.3807 3.5 14.5 4.61929 14.5 6ZM17.1962 14.0144L18.3421 15.1604C18.7638 14.2791 19 13.2921 19 12.25V11.75L18.9932 11.6482C18.9435 11.2822 18.6297 11 18.25 11C17.8358 11 17.5 11.3358 17.5 11.75V12.25L17.4956 12.4664C17.4737 13.0075 17.3698 13.5276 17.1962 14.0144Z" fill="currentColor"/>\\n</svg>',
    video: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M5.25 5C3.45507 5 2 6.45507 2 8.25V15.75C2 17.5449 3.45507 19 5.25 19H12.75C14.5449 19 16 17.5449 16 15.75V15.438L19.2575 17.6872C20.4183 18.4887 22.0018 17.6578 22.0018 16.2471V7.75204C22.0018 6.34137 20.4183 5.51044 19.2575 6.31197L16 8.56118V8.25C16 6.45507 14.5449 5 12.75 5H5.25ZM16 10.384L20.1098 7.54632C20.2756 7.43181 20.5018 7.55051 20.5018 7.75204V16.2471C20.5018 16.4486 20.2756 16.5673 20.1098 16.4528L16 13.6151V10.384ZM3.5 8.25C3.5 7.2835 4.2835 6.5 5.25 6.5H12.75C13.7165 6.5 14.5 7.2835 14.5 8.25V15.75C14.5 16.7165 13.7165 17.5 12.75 17.5H5.25C4.2835 17.5 3.5 16.7165 3.5 15.75V8.25Z" fill="currentColor"/>\\n</svg>',
    videoOff: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M3.28034 2.21968C2.98745 1.92678 2.51257 1.92677 2.21968 2.21966C1.92678 2.51255 1.92677 2.98743 2.21966 3.28032L4.13545 5.19615C2.88949 5.651 2 6.84662 2 8.25V15.75C2 17.5449 3.45507 19 5.25 19H12.75C14.1533 19 15.3489 18.1106 15.8038 16.8647L20.7194 21.7805C21.0123 22.0734 21.4872 22.0734 21.7801 21.7805C22.073 21.4876 22.073 21.0127 21.7801 20.7198L3.28034 2.21968ZM14.5 15.5609V15.75C14.5 16.7165 13.7165 17.5 12.75 17.5H5.25C4.2835 17.5 3.5 16.7165 3.5 15.75V8.25C3.5 7.2835 4.2835 6.5 5.25 6.5H5.43928L14.5 15.5609ZM14.5 8.25V11.3181L16 12.8181V10.384L20.1098 7.54632C20.2756 7.43181 20.5018 7.55052 20.5018 7.75204V16.2471C20.5018 16.4486 20.2756 16.5673 20.1098 16.4528L18.5749 15.393L21.0074 17.8256C21.5776 17.5521 22.0018 16.9772 22.0018 16.2471V7.75204C22.0018 6.34137 20.4183 5.51044 19.2575 6.31197L16 8.56118V8.25C16 6.45507 14.5449 5 12.75 5H8.18205L9.68202 6.5H12.75C13.7165 6.5 14.5 7.2835 14.5 8.25Z" fill="currentColor"/>\\n</svg>',
    shareScreen: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M2 6.25C2 5.00736 3.00736 4 4.25 4H19.75C20.9926 4 22 5.00736 22 6.25V17.75C22 18.9926 20.9926 20 19.75 20H4.25C3.00736 20 2 18.9926 2 17.75V6.25ZM4.25 5.5C3.83579 5.5 3.5 5.83579 3.5 6.25V17.75C3.5 18.1642 3.83579 18.5 4.25 18.5H19.75C20.1642 18.5 20.5 18.1642 20.5 17.75V6.25C20.5 5.83579 20.1642 5.5 19.75 5.5H4.25ZM11.9997 7.24547C12.1987 7.2454 12.3896 7.32443 12.5303 7.46514L15.7848 10.7197C16.0777 11.0126 16.0777 11.4874 15.7848 11.7803C15.4919 12.0732 15.0171 12.0732 14.7242 11.7803L12.75 9.80613V16.2528C12.75 16.667 12.4142 17.0028 12 17.0028C11.5858 17.0028 11.25 16.667 11.25 16.2528V9.80791L9.2807 11.7799C8.98801 12.073 8.51314 12.0734 8.22004 11.7807C7.92694 11.488 7.92661 11.0131 8.2193 10.72L11.4693 7.46551C11.6099 7.3247 11.8007 7.24554 11.9997 7.24547Z" fill="currentColor"/>\\n</svg>',
    closedCaption: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M18.75 4C20.5449 4 22 5.45507 22 7.25V16.7546C22 18.5495 20.5449 20.0046 18.75 20.0046H5.25C3.45507 20.0046 2 18.5495 2 16.7546V7.25C2 5.51697 3.35645 4.10075 5.06558 4.00514L5.25 4H18.75ZM18.75 5.5H5.25L5.10647 5.5058C4.20711 5.57881 3.5 6.33183 3.5 7.25V16.7546C3.5 17.7211 4.2835 18.5046 5.25 18.5046H18.75C19.7165 18.5046 20.5 17.7211 20.5 16.7546V7.25C20.5 6.2835 19.7165 5.5 18.75 5.5ZM5.5 12C5.5 8.85442 8.21322 7.22469 10.6216 8.59854C10.9814 8.80378 11.1067 9.26183 10.9015 9.62162C10.6962 9.98141 10.2382 10.1067 9.87838 9.90146C8.48071 9.10417 7 9.99357 7 12C7 14.0046 8.48411 14.8962 9.8792 14.1027C10.2392 13.8979 10.6971 14.0238 10.9019 14.3838C11.1067 14.7439 10.9808 15.2018 10.6208 15.4066C8.21539 16.7747 5.5 15.1433 5.5 12ZM13 12C13 8.85442 15.7132 7.22469 18.1216 8.59854C18.4814 8.80378 18.6067 9.26183 18.4015 9.62162C18.1962 9.98141 17.7382 10.1067 17.3784 9.90146C15.9807 9.10417 14.5 9.99357 14.5 12C14.5 14.0046 15.9841 14.8962 17.3792 14.1027C17.7392 13.8979 18.1971 14.0238 18.4019 14.3838C18.6067 14.7439 18.4808 15.2018 18.1208 15.4066C15.7154 16.7747 13 15.1433 13 12Z" fill="currentColor"/>\\n</svg>',
    archive: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M10.25 11C9.83579 11 9.5 11.3358 9.5 11.75C9.5 12.1642 9.83579 12.5 10.25 12.5H13.75C14.1642 12.5 14.5 12.1642 14.5 11.75C14.5 11.3358 14.1642 11 13.75 11H10.25ZM3 5.25C3 4.00736 4.00736 3 5.25 3H18.75C19.9926 3 21 4.00736 21 5.25V6.75C21 7.5301 20.603 8.21748 20 8.62111V17.25C20 19.3211 18.3211 21 16.25 21H7.75C5.67893 21 4 19.3211 4 17.25V8.62111C3.39701 8.21748 3 7.5301 3 6.75V5.25ZM5.5 9V17.25C5.5 18.4926 6.50736 19.5 7.75 19.5H16.25C17.4926 19.5 18.5 18.4926 18.5 17.25V9H5.5ZM5.25 4.5C4.83579 4.5 4.5 4.83579 4.5 5.25V6.75C4.5 7.16421 4.83579 7.5 5.25 7.5H18.75C19.1642 7.5 19.5 7.16421 19.5 6.75V5.25C19.5 4.83579 19.1642 4.5 18.75 4.5H5.25Z" fill="currentColor"/>\\n</svg>',
    warning: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\\n<path d="M12.9993 17C12.9993 16.4484 12.5522 16.0013 12.0006 16.0013C11.4491 16.0013 11.002 16.4484 11.002 17C11.002 17.5515 11.4491 17.9986 12.0006 17.9986C12.5522 17.9986 12.9993 17.5515 12.9993 17ZM12.7401 9.1467C12.6901 8.78066 12.3761 8.49876 11.9964 8.49906C11.5822 8.49939 11.2467 8.83545 11.247 9.24966L11.2506 13.7513L11.2575 13.853C11.3075 14.2191 11.6215 14.501 12.0012 14.5007C12.4154 14.5003 12.7509 14.1643 12.7506 13.7501L12.747 9.24846L12.7401 9.1467ZM13.9693 3.65888C13.113 2.11108 10.8878 2.1111 10.0316 3.65893L2.28634 17.6604C1.45678 19.16 2.5414 20.9995 4.25518 20.9995H19.7462C21.46 20.9995 22.5446 19.16 21.715 17.6603L13.9693 3.65888ZM11.3442 4.38501C11.6296 3.86907 12.3713 3.86906 12.6567 4.38499L20.4025 18.3865C20.679 18.8863 20.3175 19.4995 19.7462 19.4995H4.25518C3.68392 19.4995 3.32238 18.8863 3.5989 18.3865L11.3442 4.38501Z" fill="currentColor"/>\\n</svg>',
    // ── brand logos (from marketplace integrationIcons; fill=currentColor → inherit chip accent) ──
    logoPostgres: '<svg role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23.5594 14.7228a.5269.5269 0 0 0-.0563-.1191c-.139-.2632-.4768-.3418-1.0074-.2321-1.6533.3411-2.2935.1312-2.5256-.0191 1.342-2.0482 2.445-4.522 3.0411-6.8297.2714-1.0507.7982-3.5237.1222-4.7316a1.5641 1.5641 0 0 0-.1509-.235C21.6931.9086 19.8007.0248 17.5099.0005c-1.4947-.0158-2.7705.3461-3.1161.4794a9.449 9.449 0 0 0-.5159-.0816 8.044 8.044 0 0 0-1.3114-.1278c-1.1822-.0184-2.2038.2642-3.0498.8406-.8573-.3211-4.7888-1.645-7.2219.0788C.9359 2.1526.3086 3.8733.4302 6.3043c.0409.818.5069 3.334 1.2423 5.7436.4598 1.5065.9387 2.7019 1.4334 3.582.553.9942 1.1259 1.5933 1.7143 1.7895.4474.1491 1.1327.1441 1.8581-.7279.8012-.9635 1.5903-1.8258 1.9446-2.2069.4351.2355.9064.3625 1.39.3772a.0569.0569 0 0 0 .0004.0041 11.0312 11.0312 0 0 0-.2472.3054c-.3389.4302-.4094.5197-1.5002.7443-.3102.064-1.1344.2339-1.1464.8115-.0025.1224.0329.2309.0919.3268.2269.4231.9216.6097 1.015.6331 1.3345.3335 2.5044.092 3.3714-.6787-.017 2.231.0775 4.4174.3454 5.0874.2212.5529.7618 1.9045 2.4692 1.9043.2505 0 .5263-.0291.8296-.0941 1.7819-.3821 2.5557-1.1696 2.855-2.9059.1503-.8707.4016-2.8753.5388-4.1012.0169-.0703.0357-.1207.057-.1362.0007-.0005.0697-.0471.4272.0307a.3673.3673 0 0 0 .0443.0068l.2539.0223.0149.001c.8468.0384 1.9114-.1426 2.5312-.4308.6438-.2988 1.8057-1.0323 1.5951-1.6698zM2.371 11.8765c-.7435-2.4358-1.1779-4.8851-1.2123-5.5719-.1086-2.1714.4171-3.6829 1.5623-4.4927 1.8367-1.2986 4.8398-.5408 6.108-.13-.0032.0032-.0066.0061-.0098.0094-2.0238 2.044-1.9758 5.536-1.9708 5.7495-.0002.0823.0066.1989.0162.3593.0348.5873.0996 1.6804-.0735 2.9184-.1609 1.1504.1937 2.2764.9728 3.0892.0806.0841.1648.1631.2518.2374-.3468.3714-1.1004 1.1926-1.9025 2.1576-.5677.6825-.9597.5517-1.0886.5087-.3919-.1307-.813-.5871-1.2381-1.3223-.4796-.839-.9635-2.0317-1.4155-3.5126zm6.0072 5.0871c-.1711-.0428-.3271-.1132-.4322-.1772.0889-.0394.2374-.0902.4833-.1409 1.2833-.2641 1.4815-.4506 1.9143-1.0002.0992-.126.2116-.2687.3673-.4426a.3549.3549 0 0 0 .0737-.1298c.1708-.1513.2724-.1099.4369-.0417.156.0646.3078.26.3695.4752.0291.1016.0619.2945-.0452.4444-.9043 1.2658-2.2216 1.2494-3.1676 1.0128zm2.094-3.988-.0525.141c-.133.3566-.2567.6881-.3334 1.003-.6674-.0021-1.3168-.2872-1.8105-.8024-.6279-.6551-.9131-1.5664-.7825-2.5004.1828-1.3079.1153-2.4468.079-3.0586-.005-.0857-.0095-.1607-.0122-.2199.2957-.2621 1.6659-.9962 2.6429-.7724.4459.1022.7176.4057.8305.928.5846 2.7038.0774 3.8307-.3302 4.7363-.084.1866-.1633.3629-.2311.5454zm7.3637 4.5725c-.0169.1768-.0358.376-.0618.5959l-.146.4383a.3547.3547 0 0 0-.0182.1077c-.0059.4747-.054.6489-.115.8693-.0634.2292-.1353.4891-.1794 1.0575-.11 1.4143-.8782 2.2267-2.4172 2.5565-1.5155.3251-1.7843-.4968-2.0212-1.2217a6.5824 6.5824 0 0 0-.0769-.2266c-.2154-.5858-.1911-1.4119-.1574-2.5551.0165-.5612-.0249-1.9013-.3302-2.6462.0044-.2932.0106-.5909.019-.8918a.3529.3529 0 0 0-.0153-.1126 1.4927 1.4927 0 0 0-.0439-.208c-.1226-.4283-.4213-.7866-.7797-.9351-.1424-.059-.4038-.1672-.7178-.0869.067-.276.1831-.5875.309-.9249l.0529-.142c.0595-.16.134-.3257.213-.5012.4265-.9476 1.0106-2.2453.3766-5.1772-.2374-1.0981-1.0304-1.6343-2.2324-1.5098-.7207.0746-1.3799.3654-1.7088.5321a5.6716 5.6716 0 0 0-.1958.1041c.0918-1.1064.4386-3.1741 1.7357-4.4823a4.0306 4.0306 0 0 1 .3033-.276.3532.3532 0 0 0 .1447-.0644c.7524-.5706 1.6945-.8506 2.802-.8325.4091.0067.8017.0339 1.1742.081 1.939.3544 3.2439 1.4468 4.0359 2.3827.8143.9623 1.2552 1.9315 1.4312 2.4543-1.3232-.1346-2.2234.1268-2.6797.779-.9926 1.4189.543 4.1729 1.2811 5.4964.1353.2426.2522.4522.2889.5413.2403.5825.5515.9713.7787 1.2552.0696.087.1372.1714.1885.245-.4008.1155-1.1208.3825-1.0552 1.717-.0123.1563-.0423.4469-.0834.8148-.0461.2077-.0702.4603-.0994.7662zm.8905-1.6211c-.0405-.8316.2691-.9185.5967-1.0105a2.8566 2.8566 0 0 0 .135-.0406 1.202 1.202 0 0 0 .1342.103c.5703.3765 1.5823.4213 3.0068.1344-.2016.1769-.5189.3994-.9533.6011-.4098.1903-1.0957.333-1.7473.3636-.7197.0336-1.0859-.0807-1.1721-.151zm.5695-9.2712c-.0059.3508-.0542.6692-.1054 1.0017-.055.3576-.112.7274-.1264 1.1762-.0142.4368.0404.8909.0932 1.3301.1066.887.216 1.8003-.2075 2.7014a3.5272 3.5272 0 0 1-.1876-.3856c-.0527-.1276-.1669-.3326-.3251-.6162-.6156-1.1041-2.0574-3.6896-1.3193-4.7446.3795-.5427 1.3408-.5661 2.1781-.463zm.2284 7.0137a12.3762 12.3762 0 0 0-.0853-.1074l-.0355-.0444c.7262-1.1995.5842-2.3862.4578-3.4385-.0519-.4318-.1009-.8396-.0885-1.2226.0129-.4061.0666-.7543.1185-1.0911.0639-.415.1288-.8443.1109-1.3505.0134-.0531.0188-.1158.0118-.1902-.0457-.4855-.5999-1.938-1.7294-3.253-.6076-.7073-1.4896-1.4972-2.6889-2.0395.5251-.1066 1.2328-.2035 2.0244-.1859 2.0515.0456 3.6746.8135 4.8242 2.2824a.908.908 0 0 1 .0667.1002c.7231 1.3556-.2762 6.2751-2.9867 10.5405zm-8.8166-6.1162c-.025.1794-.3089.4225-.6211.4225a.5821.5821 0 0 1-.0809-.0056c-.1873-.026-.3765-.144-.5059-.3156-.0458-.0605-.1203-.178-.1055-.2844.0055-.0401.0261-.0985.0925-.1488.1182-.0894.3518-.1226.6096-.0867.3163.0441.6426.1938.6113.4186zm7.9305-.4114c.0111.0792-.049.201-.1531.3102-.0683.0717-.212.1961-.4079.2232a.5456.5456 0 0 1-.075.0052c-.2935 0-.5414-.2344-.5607-.3717-.024-.1765.2641-.3106.5611-.352.297-.0414.6111.0088.6356.1851z"/></svg>',
    logoRedis: '<svg role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22.71 13.145c-1.66 2.092-3.452 4.483-7.038 4.483-3.203 0-4.397-2.825-4.48-5.12.701 1.484 2.073 2.685 4.214 2.63 4.117-.133 6.94-3.852 6.94-7.239 0-4.05-3.022-6.972-8.268-6.972-3.752 0-8.4 1.428-11.455 3.685C2.59 6.937 3.885 9.958 4.35 9.626c2.648-1.904 4.748-3.13 6.784-3.744C8.12 9.244.886 17.05 0 18.425c.1 1.261 1.66 4.648 2.424 4.648.232 0 .431-.133.664-.365a100.49 100.49 0 0 0 5.54-6.765c.222 3.104 1.748 6.898 6.014 6.898 3.819 0 7.604-2.756 9.33-8.965.2-.764-.73-1.361-1.261-.73zm-4.349-5.013c0 1.959-1.926 2.922-3.685 2.922-.941 0-1.664-.247-2.235-.568 1.051-1.592 2.092-3.225 3.21-4.973 1.972.334 2.71 1.43 2.71 2.619z"/></svg>',
    logoMongo: '<svg role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.193 9.555c-1.264-5.58-4.252-7.414-4.573-8.115-.28-.394-.53-.954-.735-1.44-.036.495-.055.685-.523 1.184-.723.566-4.438 3.682-4.74 10.02-.282 5.912 4.27 9.435 4.888 9.884l.07.05A73.49 73.49 0 0111.91 24h.481c.114-1.032.284-2.056.51-3.07.417-.296.604-.463.85-.693a11.342 11.342 0 003.639-8.464c.01-.814-.103-1.662-.197-2.218zm-5.336 8.195s0-8.291.275-8.29c.213 0 .49 10.695.49 10.695-.381-.045-.765-1.76-.765-2.405z"/></svg>',
    logoGithub: '<svg role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/></svg>',
    logoLivekit: '<svg role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0v24h14.4v-4.799h4.8V24H24v-4.8h-4.799v-4.8h-4.8v4.8H4.8V0H0zm14.4 14.4V9.602h4.801V4.8H24V0h-4.8v4.8h-4.8v4.8H9.6v4.8h4.8z"/></svg>',
    logoRailway: '<svg role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M.113 10.27A13.026 13.026 0 000 11.48h18.23c-.064-.125-.15-.237-.235-.347-3.117-4.027-4.793-3.677-7.19-3.78-.8-.034-1.34-.048-4.524-.048-1.704 0-3.555.005-5.358.01-.234.63-.459 1.24-.567 1.737h9.342v1.216H.113v.002zm18.26 2.426H.009c.02.326.05.645.094.961h16.955c.754 0 1.179-.429 1.315-.96zm-17.318 4.28s2.81 6.902 10.93 7.024c4.855 0 9.027-2.883 10.92-7.024H1.056zM11.988 0C7.5 0 3.593 2.466 1.531 6.108l4.75-.005v-.002c3.71 0 3.849.016 4.573.047l.448.016c1.563.052 3.485.22 4.996 1.364.82.621 2.007 1.99 2.712 2.965.654.902.842 1.94.396 2.934-.408.914-1.289 1.458-2.353 1.458H.391s.099.42.249.886h22.748A12.026 12.026 0 0024 12.005C24 5.377 18.621 0 11.988 0z"/></svg>',
    // Full-colour Google "G" (hardcoded brand fills, NOT currentColor) so it
    // renders in real Google colours regardless of the chip's accent.
    logoGoogle: '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/><path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/><path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z"/><path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"/></svg>'
};

});

parcelRegister("dAWnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e5beb5d76eda361$export$2e2bcd8739ae039);
var $9e5beb5d76eda361$export$2e2bcd8739ae039 = {};

});

parcelRegister("jfxqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e039599096a306ee$export$2e2bcd8739ae039);
var $e039599096a306ee$export$2e2bcd8739ae039 = {};

});

parcelRegister("8QWSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6720dac305c3c8f6$export$2e2bcd8739ae039);
var $6720dac305c3c8f6$export$2e2bcd8739ae039 = {
    // THE HOME'S CLOUDS DRIFT (DESIGN-WL-BOOT-LOADER-MOTION-1, Nika 2026-09-28
    // "make clouds animation too"): a layer twice the viewport wide slides left
    // by half its width — exactly one tile of the seamless clouds mask — so the
    // loop has no seam. Transform only: no mask position, no layout.
    ambientDrift: {
        from: {
            transform: 'translateX(0)'
        },
        to: {
            transform: 'translateX(-50%)'
        }
    },
    // Animate the inner mark, leaving its centering transform untouched.
    loaderLogo: {
        '0%, 100%': {
            transform: 'rotate(0deg) scale(1)',
            opacity: '1'
        },
        '50%': {
            transform: 'rotate(-4deg) scale(0.96)',
            opacity: '0.86'
        }
    },
    loaderProgress: {
        '0%, 100%': {
            opacity: '0.65'
        },
        '50%': {
            opacity: '1'
        }
    },
    // /infra deployment-canvas edges: a slow dash flow to read as live traffic.
    infraFlow: {
        from: {
            strokeDashoffset: '24'
        },
        to: {
            strokeDashoffset: '0'
        }
    },
    // /infra detail drawer: slide-in from the left edge on open.
    fadeInLeft: {
        from: {
            opacity: '0',
            transform: 'translateX(-24px)'
        },
        to: {
            opacity: '1',
            transform: 'translateX(0)'
        }
    },
    // Messenger list (left-docked chat panel): short horizontal slide-in from
    // the left edge on open. X-axis mirror of brand's `fadeInUpShort` (same
    // 6.5% travel + opacity fade, axis flipped Y→X with a negative start so a
    // left-docked panel enters from its own edge). Distinct name to avoid the
    // brand `fadeInLeft` collision (that one starts to the right, +12.5%).
    fadeInLeftShort: {
        from: {
            opacity: '0',
            transform: 'translate3d(-6.5%, 0, 0)'
        },
        to: {
            opacity: '1',
            transform: 'translate3d(0, 0, 0)'
        }
    },
    // …and slide-out to the right on close.
    fadeOutRight: {
        from: {
            opacity: '1',
            transform: 'translateX(0)'
        },
        to: {
            opacity: '0',
            transform: 'translateX(24px)'
        }
    },
    // White-label loader mark: a 3D coin flip about the Y axis (Nika: "dont
    // make bellforge loading animation - logo rotating - make it flipping").
    // Perspective INSIDE the transform so the keyframes are self-contained —
    // no parent perspective property to thread through the loader chrome.
    // Distinct name, no brand collision (brand has `rotate`, no flip).
    // ⚠️ STILL THE DEFAULT BOOT MOTION for every white-label tenant, and still
    // used by the shared WhitelabelSignin persona tile. The `dial*` set below is
    // OPT-IN per org record (`branding.loaderMotion === 'dial'`) — Nika
    // 2026-09-10: "change loading spinner only for vault - keep bellforge and
    // gita as was". Deleting this set changes every tenant's boot.
    flipY: {
        from: {
            transform: 'perspective(720px) rotateY(0deg)'
        },
        to: {
            transform: 'perspective(720px) rotateY(360deg)'
        }
    },
    // ── The white-label boot mark: a VAULT DIAL ──────────────────────────────
    // OPT-IN, per org record: only a tenant whose public branding carries
    // `loaderMotion: 'dial'` boots with this. Everyone else keeps `flipY` above.
    // Three keyframe sets, one motion. The org's mark behaves like the dial of
    // a combination lock: it arrives, turns right, turns a full turn left, then
    // turns right onto the number and clicks home. It is the first thing a
    // partner sees on every load, so it has to read as mechanism, not as a
    // spinner: every segment has a destination and every destination is held.
    //
    // ⚠️ NET ROTATION PER CYCLE IS EXACTLY 360° (+270 −360 +90 +6 −6). The loop
    // therefore restarts on the angle it ended on and the seam is invisible on
    // ANY mark. The obvious sequence (+270 −180 +90) nets 180°, which is
    // seamless only for a mark that is 180°-symmetric — true of the Vault dial
    // disc, false of a lettered or asymmetric mark, and this loader is shared
    // by every white-label tenant.
    //
    // One easing family, no per-stop overrides: CSS applies
    // `animation-timing-function` to EVERY keyframe interval, so the single
    // `defaultBezier` on the element gives each turn the house ease-out
    // (fast off the mark, long glide into the stop) and leaves the holds flat.
    //
    // Reduced motion: the global guard in brand/designSystem/reset.js collapses
    // every animation to 0.01ms / 1 iteration. Each set below is written so the
    // resting state is CORRECT under that collapse — see the fill-mode notes.
    // 1. Arrival. Runs ONCE, not per cycle. A boot mark that fades to nothing
    //    every three seconds reads as a rendering fault rather than as work in
    //    progress — the same reasoning brand's `pulse` carries against
    //    `blinking`. Last keyframe is the neutral state, so css-in-props picks
    //    `backwards` and the collapsed (reduced-motion) run rests at full ink.
    dialEnter: {
        from: {
            transform: 'scale(0.85)',
            opacity: '0'
        },
        to: {
            transform: 'scale(1)',
            opacity: '1'
        }
    },
    // 2. The turn. Percentages ARE the choreography (cycle ≈ 3s via timing
    //    token `K1`): turn right to 270°, hold, a full turn left to −90°, hold,
    //    right onto the mark with a 6° overshoot, then settle — the click — and
    //    rest before the next attempt. Rotation only: no vertical bounce, no
    //    scale, nothing that would make the mark breathe.
    dialTurn: {
        '0%': {
            transform: 'rotate(0deg)'
        },
        '24%': {
            transform: 'rotate(270deg)'
        },
        '32%': {
            transform: 'rotate(270deg)'
        },
        '62%': {
            transform: 'rotate(-90deg)'
        },
        '70%': {
            transform: 'rotate(-90deg)'
        },
        '88%': {
            transform: 'rotate(6deg)'
        },
        '94%': {
            transform: 'rotate(0deg)'
        },
        '100%': {
            transform: 'rotate(0deg)'
        }
    },
    // 3. The ring, on the SAME stops as the turn: it advances while the dial
    //    moves and pauses while the dial holds, so the ring reads as the dial's
    //    own progress record and not as a second, unrelated spinner. Offsets
    //    are the circumference of the r=42 circle in the 88-unit viewBox
    //    (2·π·42 ≈ 264) at 0% / 45% / 80% / 100% drawn.
    //    ⚠️ The consumer sets `animationFillMode: 'none'` for this one: the last
    //    keyframe is transparent (the completed ring dims away before the next
    //    fill starts), and the css-in-props default of `both` would freeze a
    //    reduced-motion visitor on that transparent frame — an invisible ring.
    //    With `none` the collapsed run falls back to the element's own
    //    presentation attributes: a full ring.
    dialRingFill: {
        '0%': {
            strokeDashoffset: '264',
            opacity: '1'
        },
        '24%': {
            strokeDashoffset: '145'
        },
        '32%': {
            strokeDashoffset: '145'
        },
        '62%': {
            strokeDashoffset: '53'
        },
        '70%': {
            strokeDashoffset: '53'
        },
        '88%': {
            strokeDashoffset: '0',
            opacity: '1'
        },
        '100%': {
            strokeDashoffset: '0',
            opacity: '0'
        }
    }
};

});

parcelRegister("484y7", function(module, exports) {

$parcel$export(module.exports, "default", () => $301b7027f92c7609$export$2e2bcd8739ae039);
// Workspace-local media tokens (merged on top of the inherited breakpoints).
//
// Touch-capability tokens for the iPad pass. They MUST be registered here so a
// component key like '@coarse' compiles to a real @media query — an
// UNregistered '@name' silently compiles to a bogus [data-theme="name"]
// selector instead (that's how @dark/@light work). Value = the query body only,
// no @media wrapper (matches the default token format, e.g. tv: 'min-width: 2780px').
//
//   '@coarse': { … }  → touch-primary devices (iPad, phones, touchscreens)
//   '@touch':  { … }  → touch AND no true hover (excludes trackpad hybrids)
//
// tabletSOnly / tabletMOnly / desktopSOnly — MUTUALLY EXCLUSIVE responsive
// ranges (2026-08-02,
// phone "one deck" header merge). The base tabletS/tabletM tokens are plain
// max-width, so a viewport ≤768px matches @mobileL AND @tabletS AND @tabletM
// simultaneously. That's fine when a component's blocks don't disagree — but
// where a @mobileL block overrides the SAME property a @tabletS/@tabletM
// block also sets on the SAME component (AppHeader's HeaderLeft/HeaderTabs/
// HeaderRight), the one that wins is decided by the ATOMIC CSS ENGINE'S
// GLOBAL class-insertion order (first-encountered-anywhere-in-the-app order,
// not JS object key order, not "narrower breakpoint should win" logic) —
// verified live: HeaderTabs' @tabletS `left: calc(--hdr-left-w …)` was
// winning over its own @mobileL `left: auto` at 390px, because that calc()
// value's class had already been registered earlier by another component.
// tabletSOnly/tabletMOnly close the gap at its root: a genuinely
// non-overlapping range can never lose a cascade tie to @mobileL, because it
// never matches in the same viewport at all.
var $301b7027f92c7609$export$2e2bcd8739ae039 = {
    reducedMotion: '(prefers-reduced-motion: reduce)',
    coarse: '(pointer: coarse)',
    touch: '(hover: none) and (pointer: coarse)',
    calendarActionsCompact: '(max-width: 847px)',
    calendarHeaderWide: '(min-width: 1441px)',
    tabletSOnly: '(max-width: 1024px) and (min-width: 769px)',
    tabletMOnly: '(max-width: 1280px) and (min-width: 769px)',
    desktopSOnly: '(max-width: 1440px) and (min-width: 1281px)',
    // ABOVE THE PHONE STEP — the exact complement of the brand's `mobileL`
    // (max-width: 768px), in range syntax so no fractional width falls between
    // the two. The brand's own `mobileL<` is min-width: 768px, which OVERLAPS
    // `mobileL` at exactly 768 (iPad portrait): a pair of rules keyed on both
    // would both match there. Used by the home top (components/HomeAppStrip.js):
    // the Dock steps aside for the Rail only above the phone step, as ONE rule
    // inside this media block — never a base rule plus a phone override, whose
    // winner the atomic engine's sheet order would decide.
    aboveMobileL: '(width > 768px)',
    // BELOW THE SPLIT FLOOR — the viewport where the shell refuses a second
    // PageSlot pane: `width < SPLIT_MIN_WIDTH_PX` (functions/searchApps.js,
    // 1024), the exact complement of `splitFitsWidth`. The pane header's Split
    // button hides here (canvas/components/PageSlot.js SplitBtn), so the button
    // is shown exactly where a split can open. Range syntax, so 1024 itself —
    // where a split fits — never matches; the brand's `tabletS` (max-width:
    // 1024px) would hide the button at a width that splits.
    // __tests__/pageSlotSplitFloor.test.js locks this number to the constant.
    splitBelowFloor: '(width < 1024px)'
};

});


parcelRegister("ddnE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $99eed4bb147c80e4$export$2e2bcd8739ae039);

var $f2PVE = parcelRequire("f2PVE");

var $cFAzA = parcelRequire("cFAzA");

var $fANbU = parcelRequire("fANbU");

var $7x7K2 = parcelRequire("7x7K2");

var $2zaom = parcelRequire("2zaom");

var $cb0lo = parcelRequire("cb0lo");

var $529WE = parcelRequire("529WE");

var $gzeRz = parcelRequire("gzeRz");

var $3WuWE = parcelRequire("3WuWE");

var $d2rDO = parcelRequire("d2rDO");

var $ln7NP = parcelRequire("ln7NP");

var $5BzM7 = parcelRequire("5BzM7");

var $5IvaF = parcelRequire("5IvaF");

var $lAOZP = parcelRequire("lAOZP");

var $lhMi0 = parcelRequire("lhMi0");

var $1c9wR = parcelRequire("1c9wR");

var $86MWO = parcelRequire("86MWO");

var $debL2 = parcelRequire("debL2");

var $alQJE = parcelRequire("alQJE");

var $7IAr3 = parcelRequire("7IAr3");
var $99eed4bb147c80e4$export$2e2bcd8739ae039 = {
    color: $f2PVE.default,
    gradient: $cFAzA.default,
    theme: $fANbU.default,
    font: $7x7K2.default,
    font_family: $2zaom.default,
    typography: $cb0lo.default,
    spacing: $529WE.default,
    sizes: $gzeRz.default,
    shadow: $3WuWE.default,
    timing: $d2rDO.default,
    class: (0, $ln7NP.default),
    grid: $5BzM7.default,
    icons: $5IvaF.default,
    shape: $lAOZP.default,
    reset: $lhMi0.default,
    skins: $1c9wR.default,
    animation: $86MWO.default,
    media: $debL2.default,
    cases: $alQJE.default,
    a11y: $7IAr3.default
};

});
parcelRegister("f2PVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $af3f52e68047500a$export$2e2bcd8739ae039);
var $af3f52e68047500a$export$2e2bcd8739ae039 = {
    transparent: 'transparent',
    black: 'black',
    white: 'white',
    blue: '#0085FF',
    electricBlue: '#0F45FF',
    cerulean: '#00BCFF',
    indigo: '#50E1FF',
    green: '#59AC56',
    red: '#EB6650',
    yellow: '#E8CC56',
    orange: '#E98232',
    brown: '#7D6755',
    pink: '#EE90BD',
    cyan: '#00FFFF',
    magenta: '#FF00FF',
    purple: '#7345AF',
    phosphorus: '#BCD835',
    indigoblue: '#55B7D8',
    milk: '#D8D8D8',
    grassgreen: '#6A9A55',
    gray: '#57575c',
    gray1: '#040404',
    gray2: '#141416',
    gray3: '#242428',
    gray4: '#34343a',
    gray5: '#45454b',
    gray6: '#55555d',
    gray7: '#65656f',
    gray8: '#757581',
    gray9: '#878791',
    gray10: '#9898a2',
    gray11: '#aaaab2',
    gray12: '#bcbcc2',
    gray13: '#ceced2',
    gray14: '#e0e0e2',
    gray15: '#f1f1f3',
    gray16: '#fafafb',
    color: 'pink.25',
    typography: 'indigoblue.25',
    space: 'blue.25',
    shape: 'purple.3',
    icons: 'brown.2',
    css: 'yellow.25',
    html: 'green.25',
    padding: '#C5D08A',
    margin: '#FACD9F',
    sizing: '#EAAC46',
    gap: '#CA3CE6',
    border: '#FEDC9B',
    document: [
        'gray15',
        'gray1+4'
    ],
    // Workspace STAGE — the ground under the home dashboard and every canvas
    // page (tickets/files/studio/team boards, epics, infra). NOT the PageSlot
    // (stays on `document`). Light half is `milk`, one step darker than the
    // document so raised cards/columns read lighter than the ground
    // (DESIGN_LANGUAGE §2). Was a per-workspace settings.designSystem record
    // (--home-bg: light-dark(milk, transparent)) that only skinned ONE
    // workspace; Nika 2026-08-15: make it general.
    //
    // Dark half is `gray5`, NOT a repeat of `document`'s dark half. The mirror
    // (`gray1+4`) resolved to rgb(8,8,8) — effectively black — and Nika
    // rejected it on sight (2026-08-15: "not black - use one that codex
    // created"). `gray5` (rgb(69,69,75)) is the adaptive neutral canvas Codex
    // shipped as CODEX-V3, which /files and the /tasks board still paint via
    // `var(--canvas-bg, var(--color-gray5))`. Before this, "one ground" was
    // true in name only: home and the canvas pages went near-black while those
    // two sat on mid gray. Same token now, so they actually match.
    //
    // NOTE this repaints every brand consumer's stage, not just workspace —
    // admin, extensions/ext-ui and governance (infra/product/measure/run) all
    // link this library. That breadth is the point of "make it general", but it
    // does mean a stage regression here shows up in six projects at once.
    stage: [
        'milk',
        'gray5'
    ],
    // Neutral widget icon plate on the stage (home widget headers, app tiles):
    // ink-alpha wash, stronger than `overlay` so the tile still reads on milk.
    widgetPlate: [
        'gray2.07',
        'white.13'
    ],
    'canvas-card': [
        'gray16.95+6',
        'gray1.85'
    ],
    highlight: [
        'black',
        'white'
    ],
    'highlight-reversed': [
        'white',
        'black'
    ],
    title: [
        'gray1',
        'gray15'
    ],
    'title-reversed': [
        'gray15',
        'gray1'
    ],
    subtitle: [
        'gray2',
        'gray14'
    ],
    caption: [
        'gray3',
        'gray13'
    ],
    code: [
        'gray2',
        'gray14'
    ],
    paragraph: [
        'gray4',
        'gray12'
    ],
    // D-6 (Nika 2026-09-23): a placeholder is a HINT, never a value — it was the
    // `paragraph` pair (gray4 / gray12), which made a hint read like a typed
    // value. This one token is the brand default for every placeholder: the
    // `field-placeholder` theme ink (and through it every `field` input's
    // ::placeholder) and the global ::placeholder rule in reset.js both read it.
    //
    // THE FLOOR ON EVERY STATE (D-6, decided "fix it" for Nika 2026-10-28: the
    // brand's 4.5:1 floor). A hint sits on the FIELD PLATE, and the dark plate
    // lightens on hover and focus (`gray4.65+2` / `gray4.65+6`, theme.js). The
    // quiet `inactive` tone the hint shared (gray10) clears a resting plate but
    // not a lit one: 4.44:1 in a focused field on a dialog sheet or a solid
    // card, 3.72-3.88:1 in a field on the bare stage (the white-label spec's
    // tripwire: "never put `inactive` text inside a field"). So the two split in
    // DARK only: the hint takes the next step, gray11 — 4.61:1 at the weakest
    // (a focused field on the stage), 5.50:1 in a focused field on a sheet, and
    // still at least 3.5 under the value ink on the same plate, so it reads as a
    // hint. `inactive` keeps gray10, the tone of quiet text on a resting
    // surface. LIGHT keeps the shared gray6: 4.52:1 at the weakest (a resting
    // field on the milk stage), 7.38:1 on the white hover / focus plate.
    // Guarded by tests/brand/placeholderInk.test.mjs.
    placeholder: [
        'gray6',
        'gray11'
    ],
    inactive: [
        'gray6',
        'gray10'
    ],
    disabled: [
        'gray7',
        'gray9'
    ],
    dim: [
        'gray9',
        'gray7'
    ],
    shadow: [
        'gray14',
        'gray3'
    ],
    overlay: [
        'gray14.05',
        'gray2.05'
    ],
    overlayStrong: [
        'gray14.95',
        'gray2.98'
    ],
    // Overlay veils — the fills of the `backdrop` / `backdropSoft` themes
    // (theme.js). `scrim` dims the page behind every BLOCKING overlay (a modal,
    // a floating side panel, a phone sheet); `scrimSoft` is the lighter,
    // non-blocking veil behind a PageSlot window.
    //
    // White-label redesign (Nika 2026-09-26, "update them in brand"; spec Q1 A
    // + Q2 A). The old pair was the page's OWN colour at alpha — `gray15.55`
    // over the gray15 page and `gray2.35` over a gray2 page composite to the
    // page itself: 1.00:1 in both schemes, an invisible veil.
    //
    // LIGHT `gray1.12` — an ink dim: the page dims 1.30:1 and the white
    // `dialog` sheet stands off the dimmed page on every light ground — 1.47
    // on the gray15 document, 1.36 on the gray16 app frame, 1.85 on the milk
    // stage.
    // DARK `black.25` — NOT the spec's black.45. The dark grounds sit on both
    // sides of the gray3 sheet: the app frame (gray2) is darker than it, the
    // home/canvas stage (gray5) lighter. At .45 the dimmed gray5 stage lands ON
    // gray3 and the sheet melts into it (1.02:1); no single alpha keeps 1.25
    // on both grounds, and .25 is the balance point: the sheet stands 1.24:1
    // off the dimmed frame, 1.24:1 off the dimmed stage (darker, like the dark
    // cards on that stage) and 1.30:1 off the document — iOS's own dark-sheet
    // step (#1C1C1E on black) is 1.24:1. On the near-black frame .45 dimmed
    // only 1.07:1 anyway; the 8px blur carries "behind glass" there.
    // `scrimSoft` IS PageSlot's hand-tuned veil, byte for byte in BOTH schemes:
    // `gray7.12` is a fixed tint on purpose (Nika tuned it lighter over several
    // passes, and the window paints it in light and dark alike), so the window
    // adopts the token with zero change in either scheme. It stays weaker than
    // the blocking veil: 1.17:1 on gray15 in light, a faint fog in dark. (The
    // spec's dark `black.3` would have darkened every window backdrop 1.37:1
    // over the stage — and out-dimmed the blocking scrim.) A same-value pair
    // keeps the [light, dark] convention, as `fillInk` does.
    // Guarded by tests/brand/overlayTokens.test.mjs.
    scrim: [
        'gray1.12',
        'black.25'
    ],
    scrimSoft: [
        'gray7.12',
        'gray7.12'
    ],
    'document-background': [
        'gray15',
        'gray1+4'
    ],
    line: [
        'gray13',
        'gray5'
    ],
    'line-faded': [
        'gray15',
        'gray1+26'
    ],
    'line-highlight': [
        'gray13+4',
        'gray2+16'
    ],
    blue2: '#4676EC',
    lightBlue: '#6899D1',
    // Interaction washes — the workspace design language §4.3 (DESIGN_LANGUAGE.md).
    // Byte-identical to the house washes previously re-typed as raw literals and
    // pinned by workspace themeChrome.test.js. [lightValue, darkValue].
    //
    // D-2 (Nika 2026-09-23): the DARK halves rise so every state step clears
    // Rule 65's floor — a composited luminance step of more than 0.02 — on
    // every dark surface. The document (gray1+6, rgb(10,10,10)) is the hardest
    // ground: white.07 stepped +0.008 there and white.1 +0.013 (the two states
    // read as no change). Measured over document / common-box / gray3 / stage:
    //   hover    white.14 → +0.0225 / +0.0286 / +0.0381 / +0.0552 over rest
    //   selected white.21 → +0.022  / +0.025  / +0.029  / +0.036  past hover
    // white.16 would clear rest but sit only +0.005 past hover on the document
    // — a hovered row would read as selected. `title` on selected stays >= 4.6
    // on all four; `caption` >= 5.0 except on the bare stage. `inactive` does
    // NOT survive a washed dark row (4.29 hover / 3.33 selected on common-box):
    // secondary text on a hovered or selected dark row takes `caption`.
    // Light halves unchanged. Guarded by tests/brand/interactionWashes.test.mjs.
    hover: [
        'black.05',
        'white.14'
    ],
    selected: [
        'gray2.08',
        'white.21'
    ],
    // RAISED — the fill of a control that LIFTS off its track or row: the
    // chosen thumb of a view segmented control, a keycap on a menu's
    // highlighted row (white-label spec §5.2, §5.9). Always paired with the
    // `float` elevation. White in light. In dark it must be LIGHTER than what
    // it rests on: a thumb in the sheet colour (gray3) sits on a `layer` track
    // that is itself washed lighter than the sheet, and reads sunken — gray5
    // stands 1.49:1 off that track on a dark sheet, and `title` on it reads
    // 8.4:1. Promoted byte for byte from workspace shared/designSystem (lane D2
    // staged it there first). Guarded by tests/brand/overlayTokens.test.mjs.
    raised: [
        'white',
        'gray5'
    ],
    // SKINS — two skins on ONE token set, orthogonal to light / dark (Nika
    // 2026-09-26: "we make default exceptionally beautiful, white-label (solid)
    // as secondary"; skins.js is the map, the framework's skins dimension emits it).
    // `cardSolid` — the card of the SOLID skin, i.e. today's card exactly (Nika
    // 2026-09-23/24, option C: gray15-3 light, gray3 dark) — one source for the
    // `card` theme and for the reduced-transparency fallback of ambient.
    // `cardGlass` — the card of the AMBIENT skin, a translucent glass over the
    // ground (with an 18px backdrop blur). LIGHT white.62: milk under it
    // composites to ~gray15, a 1.25 step, the quietest ink (`inactive`) 6.49:1.
    // DARK gray1.55 — NOT the relayed white.06: over the gray5 stage (Nika's
    // dark ground, "not black") white.06 composites to (80,80,86) and drops
    // `inactive` to 2.80:1 and `paragraph` to ~4.2:1. A dark glass keeps the
    // house dark convention (cards darker than the gray5 stage, a 1.68 step)
    // and `inactive` at 5.60:1. Guarded by tests/brand/skins.test.mjs.
    // `stageInk` — the ambient ground's dither ink (the AmbientBackdrop dots),
    // ambient only.
    // `pillSolid` — the header pill and the composer in the SOLID skin: the
    // `navbar` glass exactly as it is today (white .95 light, gray1 .85 dark,
    // under a 35px blur — theme.js), named once. The ambient skin puts both on
    // `cardGlass` (HOME_AMBIENT_SKIN_SPEC §1: card, header pill and composer
    // share one glass).
    cardSolid: [
        'gray15-3',
        'gray3'
    ],
    cardGlass: [
        'white.62',
        'gray1.55'
    ],
    stageInk: [
        'gray1.25',
        'white.15'
    ],
    pillSolid: [
        'gray16.95+6',
        'gray1.85'
    ],
    // ── Semantic HUE inks — [lightValue, darkValue] ─────────────────────────
    // Every pair above this point is a NEUTRAL. That gap is why light mode kept
    // breaking: an author needing "orange for a warning figure" had no adaptive
    // token to reach for, so the only options were a raw hue (fixed — correct in
    // exactly one theme) or a hand-written @dark/@light block. 150 raw-hue
    // `color:` declarations across 12 workspace apps took the first option;
    // measured 2026-08-09 on /warehouse in light, the LOW badges read 1.91:1 and
    // the expired count 2.45:1 (Nika: "you've might broken light mode").
    //
    // The raw brand hues are tuned for a near-black ground and cannot be reused
    // as ink on a light one — as small text on the gray14-class page wash they
    // measure 2.15 (green), 2.42 (orange), 2.45 (red), 2.4 (magenta), 2.70
    // (blue). Each pair below re-tones the SAME hue twice: deepened for light,
    // brightened for dark. Verified >=4.7 on white/gray16/gray15/wash (light)
    // and >=5 on gray1-gray4 (dark).
    //
    // Use these for ink that must CARRY MEANING in colour. For a hue on a plate,
    // prefer wash + neutral ink (DESIGN_LANGUAGE §8.5 rule 3) — the raw hues
    // above stay correct for decoration on a known ground (plates, dots, washes).
    blueDeep: '#0A5CB8',
    blueBright: '#47A8FF',
    accentInk: [
        'blueDeep',
        'blueBright'
    ],
    greenDeep: '#2A6E28',
    greenBright: '#7FD07B',
    successInk: [
        'greenDeep',
        'greenBright'
    ],
    redDeep: '#A83520',
    // #FFA191 (was #FF8C78, 4.20:1 on `raised` gray5 — the ground a menu takes
    // inside a dialog): 4.88:1 on raised, 7.92:1 on the dialog; lighter, so no
    // dark ground loses contrast (tests/brand/dangerInkOnRaised.test.mjs).
    redBright: '#FFA191',
    dangerInk: [
        'redDeep',
        'redBright'
    ],
    orangeDeep: '#94500F',
    orangeBright: '#F4A45E',
    warningInk: [
        'orangeDeep',
        'orangeBright'
    ],
    magentaDeep: '#A100A1',
    magentaBright: '#FF7AFF',
    magentaInk: [
        'magentaDeep',
        'magentaBright'
    ],
    // ── Status FILL pairs — tickets/fable.md LMC-F2 ────────────────────────
    // `theme.js`'s `warning`/`error`/`success` FILL themes (coloured
    // background + reversed ink, for badges/plates) used to hand-author their
    // @dark and @light blocks as two independent literal pairs that were
    // NOT symmetric (e.g. warning was `yellow.85`/`gray1` in dark vs
    // `yellow`/`gray16` in light) — every future edit had to touch both
    // blocks by hand, and nothing caught them drifting apart. Each pair below
    // is now the SINGLE source of truth: `theme.js` references the SAME
    // token name from both its @dark and @light blocks, so there is nothing
    // left to restate twice. [lightValue, darkValue], matching the existing
    // convention above. Values are byte-identical to the prior hand-authored
    // literals — this is a structural dedupe, not a re-tone; see
    // tickets/fable.md LMC-F2 for the token-math proof.
    warningFillBg: [
        'yellow',
        'yellow.85'
    ],
    errorFillBg: [
        'red',
        'red.85'
    ],
    successFillBg: [
        'green',
        'green.85'
    ],
    // Fill ink is SCHEME-INVARIANT: the plate keeps its hue in both schemes
    // (the dark half only drops to .85 alpha), so a flipping ink is wrong in one
    // scheme by construction. Until 2026-09-21 this was ['gray16', 'gray1'] and
    // the light half painted near-white on a mid-luminance hue — 1.52:1 on
    // `yellow`, 2.70:1 on `green`. Near-black reads 12.89 / 7.28 (light) and
    // 9.32+ / 5.44+ (dark, over gray1–gray5). Same-value pair keeps this
    // section's [lightValue, darkValue] convention. Guarded by
    // tests/brand/statusFillInkContrast.test.mjs.
    fillInk: [
        'gray1',
        'gray1'
    ],
    // Error ink is the SAME near-black, and scheme-invariant for the same reason.
    // It was near-WHITE until 2026-09-21 (WS-CREDIT-TOAST-ICON-CONTRAST-1 asked
    // for "white on the error fill" so the toast would stop flipping per scheme).
    // White on the brand coral reads 3.07 light / 3.62 dark — under the 4.5 text
    // floor in BOTH schemes, on the toast that carries the most important text in
    // the product. Re-decided by Nika 2026-09-21: near-black reads 6.39 light and
    // 4.81+ dark (over gray1–gray5). The invariance that ticket wanted is kept.
    // The token stays separate so `theme.js` and any consumer that names it keep
    // resolving; the brand test holds all three fills to ONE ink value.
    errorFillInk: [
        'gray1',
        'gray1'
    ]
};

});

parcelRegister("cFAzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9395af045be7880f$export$2e2bcd8739ae039);
var $9395af045be7880f$export$2e2bcd8739ae039 = {
    dotsDark: 'radial-gradient(#252527 6%, transparent 6%)',
    dotsMid: 'radial-gradient(#43434b 6%, transparent 6%)',
    dotsLight: 'radial-gradient(#d9d9db 6%, transparent 6%)',
    radialGrad: 'radial-gradient(#08080E00 0%, #0A0A0B 100%)',
    transparentBg: 'linear-gradient(45deg, #1c1c1f 25%, transparent 25%), linear-gradient(-45deg, #1c1c1f 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #1c1c1f 75%), linear-gradient(-45deg, transparent 75%, #1c1c1f 75%)',
    'shadow-overlay': {
        '@dark': 'linear-gradient(0deg, var(--theme-document-dark-background) 0%, transparent 100%)',
        '@light': 'linear-gradient(0deg, var(--theme-document-light-background) 0%, transparent 100%)'
    },
    'shadow-overlay-reversed': {
        '@dark': 'linear-gradient(180deg, var(--theme-document-dark-background) 0%, transparent 100%)',
        '@light': 'linear-gradient(180deg, var(--theme-document-light-background) 0%, transparent 100%)'
    },
    'panel-overlay': {
        '@dark': 'linear-gradient(to top, rgba(8, 8, 8, 1) 0%, rgba(8, 8, 8, .85) 45%, rgba(8, 8, 8, .65) 65%, rgba(8, 8, 8, 0) 100%)',
        '@light': 'linear-gradient(to top, rgba(241, 241, 243, 1) 0%, rgba(241, 241, 243, 0.85) 65%, rgba(241, 241, 243, 0.65) 40%, rgba(241, 241, 243, 0) 100%)'
    },
    'button-gradient': 'linear-gradient(to top, rgba(50, 114, 184, .2), rgba(0, 121, 253, .27), rgba(0, 121, 253, .27))',
    'button-gradient-active': 'linear-gradient(to top, rgba(50, 114, 184, .25), rgba(0, 121, 253, .32), rgba(0, 121, 253, .32))',
    theme: 'conic-gradient(rgba(91,194,229,0.3), rgba(109,71,169,0.3), rgba(238,144,189,0.3), rgba(52,119,244,0.3), rgba(91,194,229,0.3))',
    themeDark: 'conic-gradient(rgba(91,194,229,0.65), rgba(109,71,169,0.65), rgba(238,144,189,0.65), rgba(52,119,244,0.65), rgba(91,194,229,0.65))',
    'gradient-dark': `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
    'gradient-dark-active': `linear-gradient(0deg,
    rgba(0,0,0,0.1) 0%,
    rgba(0,0,0,0.11) 100%
  )`,
    'gradient-light': `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
    'gradient-light-active': `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
    'gradient-colorful': `linear-gradient(60deg,
    #0E1766 0%,
    #2127A7 65%,
    #1A1F8E 100%
  )`,
    'gradient-colorful-active': `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 25%,
    #1E54F0 32%,
    #8B4CCA 75%,
    #C66894 100%
  )`
};

});

parcelRegister("fANbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a06025412af7fa$export$2e2bcd8739ae039);
var $b5a06025412af7fa$export$2e2bcd8739ae039 = {
    transparent: {
        '@dark': {
            background: 'transparent',
            color: 'white.65'
        },
        '@light': {
            background: 'transparent',
            color: 'black.65'
        }
    },
    text: {
        background: 'transparent.0',
        '@dark': {
            color: 'gray10'
        },
        '@light': {
            color: 'gray4'
        }
    },
    document: {
        '@dark': {
            color: 'gray12',
            background: 'gray1+6'
        },
        '@light': {
            background: 'gray15',
            color: 'gray1'
        }
    },
    // RULE 65 (2026-09-23): every state here is a FILL step of more than 0.02
    // composited luminance. primary @light stepped gray1 → gray1+6 (+0.0018) and
    // secondary @dark gray2.85 → gray2+6 (+0.0034) — invisible; ClickableItem's
    // opacity .85 → .9 hid that. They now step on the ramp: primary light hover
    // gray4 (+0.034) / pressed gray5 (+0.060); secondary dark hover gray4
    // (+0.028) / pressed gray5. The -interactive card themes take the interaction
    // washes (hover / selected), as DESIGN_LANGUAGE §2.4 plans.
    primary: {
        '@dark': {
            color: 'gray1',
            background: 'white',
            ':hover': {
                background: 'white-6'
            },
            ':focus': {
                background: 'white-8'
            },
            ':active': {
                background: 'white-10'
            }
        },
        '@light': {
            color: 'white',
            background: 'gray1',
            ':hover': {
                background: 'gray4'
            },
            ':focus': {
                background: 'gray4'
            },
            ':active': {
                background: 'gray5'
            }
        }
    },
    secondary: {
        '@dark': {
            color: 'gray14',
            background: 'gray2.85',
            ':hover': {
                color: 'gray15',
                background: 'gray4'
            },
            ':active': {
                color: 'gray16',
                background: 'gray5'
            },
            '.isActive': {
                color: 'gray16',
                background: 'gray5'
            }
        },
        '@light': {
            color: 'gray4',
            background: 'gradient-dark',
            ':hover': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            '.isActive': {
                color: 'gray2',
                background: 'gradient-dark-active'
            }
        }
    },
    'secondary-highlight': {
        '@dark': {
            color: 'gray14',
            background: 'gray2.85+16',
            ':hover': {
                color: 'gray15',
                background: 'gray2+20'
            },
            ':active': {
                color: 'gray16',
                background: 'gray2+26'
            },
            '.isActive': {
                color: 'gray16',
                background: 'gray2+26'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gray15',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':active': {
                color: 'gray2',
                background: 'white'
            },
            '.isActive': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    tertiary: {
        '@dark': {
            color: 'gray10',
            background: 'transparent',
            ':hover': {
                color: 'gray15',
                background: 'gray2+6'
            },
            ':active': {
                color: 'gray16',
                background: 'gray2+10'
            },
            '.isActive': {
                color: 'gray16',
                background: 'gray2+10'
            }
        },
        '@light': {
            color: 'gray6',
            background: 'transparent',
            ':hover': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            '.isActive': {
                color: 'gray2',
                background: 'gradient-dark-active'
            }
        }
    },
    quaternary: {
        '@dark': {
            color: 'gray10',
            background: 'gray3.95',
            ':hover': {
                color: 'gray15',
                background: 'gray3'
            },
            ':active': {
                color: 'gray15',
                background: 'gray3'
            },
            '.isActive': {
                color: 'gray15',
                background: 'gray3'
            }
        },
        '@light': {
            color: 'gray2',
            background: 'gray15.95',
            ':hover': {
                color: 'gray15',
                background: 'gray4'
            },
            ':active': {
                color: 'gray15',
                background: 'gray4'
            },
            '.isActive': {
                color: 'gray15',
                background: 'gray4'
            }
        }
    },
    quinary: {
        '@dark': {
            color: 'gray10',
            background: 'gradient-light',
            ':hover': {
                color: 'gray15',
                background: 'gradient-light-active'
            },
            ':active': {
                color: 'gray15',
                background: 'gradient-light-active'
            },
            '.isActive': {
                color: 'gray15',
                background: 'gradient-light-active'
            }
        },
        '@light': {
            color: 'gray4',
            background: 'gradient-dark',
            ':hover': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            ':active': {
                color: 'gray2',
                background: 'gradient-dark-active'
            },
            '.isActive': {
                color: 'gray2',
                background: 'gradient-dark-active'
            }
        },
        '.child': '--quaternary'
    },
    default: {
        '@dark': {
            color: 'gray11',
            background: 'gray6.35'
        },
        '@light': {
            background: 'gray7.15',
            color: 'gray6=32'
        }
    },
    property: {
        '@dark': {
            color: '--theme-default-dark-color',
            background: '--theme-default-dark-background'
        },
        '@light': {
            background: '--theme-default-light-background',
            color: '--theme-default-light-color'
        }
    },
    color: {
        '@dark': {
            color: 'white',
            background: 'color.25'
        },
        '@light': {
            background: 'color.25',
            color: 'color=32'
        }
    },
    theme: {
        '@dark': {
            color: 'white',
            background: 'theme'
        },
        '@light': {
            color: 'gray4.75',
            background: 'theme'
        }
    },
    typography: {
        '@dark': {
            color: 'white',
            background: 'typography.25'
        },
        '@light': {
            background: 'typography.25',
            color: 'typography=32'
        }
    },
    space: {
        '@dark': {
            color: 'white',
            background: 'space.25'
        },
        '@light': {
            background: 'space.25',
            color: 'space=32'
        }
    },
    shape: {
        '@dark': {
            color: 'white',
            background: 'shape.3'
        },
        '@light': {
            background: 'shape.3',
            color: 'shape=32'
        }
    },
    icons: {
        '@dark': {
            color: 'white',
            background: 'icons.25'
        },
        '@light': {
            background: 'icons.25',
            color: 'icons=32'
        }
    },
    css: {
        '@dark': {
            color: 'white',
            background: 'css.25'
        },
        '@light': {
            background: 'css.25',
            color: 'css=32'
        }
    },
    html: {
        '@dark': {
            color: 'white',
            background: 'html.28'
        },
        '@light': {
            background: 'html.28',
            color: 'html=32'
        }
    },
    // `alert` is the coral FILL, same plate and same ink as `error`. Until
    // 2026-09-21 this read `{ background: 'yellow', color: 'black' }` with no
    // scheme wrapper — and the pipeline drops an unwrapped property (see the
    // LMC-F2 note below), so it never painted. The framework default did: WHITE
    // on `red`, 3.21:1 in both schemes (measured on this site's own specimen).
    // The product relies on the red reading (policy pills: expired, cancelled,
    // lapsed), so the brand now owns it: near-black on coral, 6.39 light and
    // 4.81+ dark. Guarded by tests/brand/statusFillInkContrast.test.mjs.
    alert: {
        '@dark': {
            background: 'errorFillBg',
            color: 'errorFillInk'
        },
        '@light': {
            background: 'errorFillBg',
            color: 'errorFillInk'
        }
    },
    // FILL themes (coloured background + reversed ink) for badges/plates —
    // tickets/fable.md LMC-F2. `@dark`/`@light` blocks are still required by
    // scratch's theme-var pipeline (system/theme.js `setMediaTheme` only emits
    // a theme's `background`/`color` CSS vars by walking `@`-scheme blocks —
    // a top-level property with no scheme wrapper is dropped, not just
    // unswitched), so the wrapper itself can't be removed without a
    // framework change. What CAN be collapsed — and is, here — is the
    // hand-duplicated LITERAL values: both blocks now reference the exact
    // same `designSystem/color.js` pair token, so there is nothing left to
    // restate twice and nothing left to drift. Byte-identical rendered output
    // verified before/after — see LMC-F2.
    warning: {
        '@dark': {
            background: 'warningFillBg',
            color: 'fillInk'
        },
        '@light': {
            background: 'warningFillBg',
            color: 'fillInk'
        }
    },
    error: {
        '@dark': {
            background: 'errorFillBg',
            color: 'errorFillInk'
        },
        '@light': {
            background: 'errorFillBg',
            color: 'errorFillInk'
        }
    },
    success: {
        '@dark': {
            background: 'successFillBg',
            color: 'fillInk'
        },
        '@light': {
            background: 'successFillBg',
            color: 'fillInk'
        }
    },
    info: '--common-card-outline-interactive',
    header: {
        '@dark': {
            color: 'white',
            background: 'gray1.85',
            borderColor: 'white.01'
        },
        '@light': {
            color: 'black',
            background: 'gray15.9',
            borderColor: 'black.01'
        }
    },
    navbar: {
        // One glass recipe for the whole header row: these values MIRROR
        // 'canvas-card-glass' (background + blur), because the AppHeader side
        // islands carry `navbar` while HeaderTabs carries the card glass — two
        // recipes on one chrome row. On the flagship's neutral ground the old
        // gray15 vs white split (14 RGB points) was invisible; on a tinted
        // tenant ground it read as mismatched pills (app.bellforge.eu light
        // mode, measured 2026-08-31: sides rgba(241,241,243,.95)+blur(3px) vs
        // middle rgba(255,255,255,.95)+blur(35px), page ground rgb(242,237,227)).
        // Inks stay white/black — only the fill and blur align.
        '@dark': {
            color: 'white',
            backdropFilter: 'blur(35px)',
            background: 'gray1.85'
        },
        '@light': {
            color: 'black',
            backdropFilter: 'blur(35px)',
            background: 'gray16.95+6'
        }
    },
    navbarButton: {
        '@dark': {
            color: 'gray14',
            background: 'transparent.0',
            ':hover': {
                color: 'white',
                background: 'gray4.9'
            },
            ':active': {
                color: 'white',
                background: 'gray5.9'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'transparent.0',
            ':hover': {
                color: 'black',
                background: 'gray13.95'
            },
            ':active': {
                color: 'black',
                background: 'gray12.95'
            }
        }
    },
    'navbarButton-active': {
        '@dark': {
            color: 'white',
            background: 'gray5',
            ':hover': {
                background: 'gray5.9'
            }
        },
        '@light': {
            color: 'black',
            background: 'gray11',
            ':hover': {
                background: 'gray12.95'
            }
        }
    },
    'navbar-button': {
        '@dark': {
            color: 'gray14',
            backgroundColor: 'transparent.0'
        },
        '@light': {
            color: 'gray3',
            backgroundColor: 'transparent.0'
        },
        ':hover': {
            '@dark': {
                color: 'white',
                backgroundColor: 'gray5.9'
            },
            '@light': {
                color: 'black',
                backgroundColor: 'gray12.95'
            }
        },
        ':active': {
            '@dark': {
                color: 'white',
                backgroundColor: 'gray5.9'
            },
            '@light': {
                color: 'black',
                backgroundColor: 'gray12.95'
            }
        }
    },
    'navbar-button-active': {
        '@dark': {
            color: 'white',
            backgroundColor: 'gray5'
        },
        '@light': {
            color: 'black',
            backgroundColor: 'gray11'
        },
        ':hover': {
            '@dark': {
                backgroundColor: 'gray5.9'
            },
            '@light': {
                backgroundColor: 'gray12.95'
            }
        }
    },
    stroke: {
        '@dark': {
            color: 'transparent',
            '-webkit-text-stroke': '.5px white'
        },
        '@light': {
            color: 'transparent',
            '-webkit-text-stroke': '.5px black'
        }
    },
    'common-card': {
        '@dark': {
            color: 'gray12',
            background: 'gray2.65'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16+6'
        }
    },
    'common-card-interactive': {
        '@dark': {
            color: 'gray13',
            background: 'gray2.65',
            ':hover': {
                background: 'hover'
            },
            ':focus': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gray16+6',
            ':hover': {
                background: 'hover'
            },
            ':focus': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            }
        }
    },
    'common-card-outline': {
        '@dark': {
            color: 'gray12',
            borderColor: 'gray3.65'
        },
        '@light': {
            color: 'gray2',
            borderColor: 'gray14'
        }
    },
    'common-card-outline-interactive': {
        '@dark': {
            color: 'gray12',
            borderColor: 'gray3.65',
            ':hover': {
                background: 'hover'
            },
            ':focus': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            }
        },
        '@light': {
            color: 'gray2',
            borderColor: 'gray14',
            ':hover': {
                background: 'hover'
            },
            ':focus': {
                background: 'hover'
            },
            ':active': {
                background: 'selected'
            }
        }
    },
    'common-card-child': {
        '@dark': {
            color: 'gray12',
            background: 'gray2-10'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16+16'
        }
    },
    // tickets/fable.md (brand-tier proposal, DESIGN, 2026-08-14) — both
    // `@light` fills used to be translucent washes (`white.75` / `white.65`),
    // the two most washed-out light surfaces in this file: alpha-composited
    // over the `document`/`document-background` `@light` page (`gray15`,
    // `#f1f1f3`), `common-box` measured fill-vs-page contrast **1.10:1** —
    // near-imperceptible (QA acceptance-walk P3, tickets/opus.md item 6,
    // "light-theme card fills at white.75 on a white page are
    // near-imperceptible"). Every OTHER translucent `@light` fill in this
    // file sits at .85-.98 alpha (`white.95`, `gray16.95+6`, `gray15.95`) —
    // these two were the only outliers below .85, not part of a deliberate
    // low-alpha family. `@dark` was already flat/opaque (`gray2`/`gray3`) —
    // only `@light` regressed to a wash. A workspace-tier override attempt
    // (workspace `fc468785`) proved live-inert against the real
    // `mergeSharedLibraries` -> `deepDefaults` fill-gaps-only merge (reverted,
    // workspace `967aa46a`) — brand-tier is the only layer that reaches every
    // consumer (~35 sites across workspace + company/packages/brand/
    // components/landing/no-code-landing). Now flat opaque fills, same
    // verified values, landed at the layer that actually reaches runtime:
    // light contrast vs `document`/`document-background` measures **1.13:1**
    // for `common-box` (parity with `card`) and **1.08:1** for
    // `common-box-secondary` (parity with `dialog`) — both clear this
    // ticket's acceptance floors; `@dark` stays byte-identical. Standard inks
    // (title/caption/paragraph) on both new fills recompute at 11.85-20.50:1,
    // nowhere close to the 4.5:1 AA floor. Compile-proof + ink-contrast
    // recompute (real scratch createConfig -> set pipeline, real WCAG math
    // from smbls/packages/scratch/src/utils/color.js) on tickets/fable.md.
    // `card` — the RAISED surface one fill step above a sheet (Nika 2026-09-23;
    // brand-language D5, the card half). A card on the workspace AppMain sheet
    // (CommonCard: `overlayStrong` dark ≈ gray2, `white` light) painted as
    // `common-box` measured 1.009:1 dark / 1.000:1 light — invisible. One ramp
    // step off the sheet, opaque, no stroke (D-4: separate with gaps): gray3
    // on gray2 = 1.19:1 dark. LIGHT is a HALF step darker than gray15 —
    // `gray15-3` (Nika 2026-09-24, option C): the workspace sheet went flat on
    // the gray16 frame, where gray15 read 1.081:1, under the 1.1:1 card step.
    // gray15-3 reads 1.111 on gray16 and 1.159 on white; a FULL step (gray14,
    // 1.264) was rejected — the disabled ink fell to 4.37:1 on it and the
    // field hairline to 1.036:1 against the field plate. Its OWN ink is
    // set on purpose: the framework default `card` resolved WHITE ink in light
    // (1.16:1 on its near-white fill). A card sits INSIDE a sheet; directly on
    // the stage, `common-box` stays the raised surface. Guarded by
    // tests/brand/cardSurface.test.mjs.
    // SKINS (2026-09-26): the fill is the `cardSolid` pair — the same gray3 /
    // gray15-3, named once so the ambient skin's reduced-transparency fallback
    // can reach it — and `backdropFilter` is declared ('none') so every card's
    // class reads the var the ambient skin turns into an 18px blur (skins.js;
    // the framework's skins dimension emits the per-skin overrides). Solid =
    // exactly this.
    card: {
        '@dark': {
            background: 'cardSolid',
            color: 'gray12',
            backdropFilter: 'none'
        },
        '@light': {
            background: 'cardSolid',
            color: 'gray1',
            backdropFilter: 'none'
        }
    },
    // `pill` — THE PILL: the header pill and the home composer (SKINS,
    // 2026-09-26; HOME_AMBIENT_SKIN_SPEC §1). Solid = today's header glass,
    // the `navbar` recipe (the `pillSolid` pair under a 35px blur, max-contrast
    // ink); the ambient skin rewrites it to the card glass (skins.js). Its own
    // name, not `navbar`: menus and toolbars also carry `navbar`, and overlays
    // and menus stay opaque in both skins.
    pill: {
        '@dark': {
            color: 'white',
            background: 'pillSolid',
            backdropFilter: 'blur(35px)'
        },
        '@light': {
            color: 'black',
            background: 'pillSolid',
            backdropFilter: 'blur(35px)'
        }
    },
    // `dialog` — the OVERLAY SHEET: every modal, floating side panel and phone
    // sheet (white-label spec §4.2, §6.2), always paired with `shadow:
    // 'overlay'` at the component (a theme cannot name a shadow primitive —
    // tests/brand/themeShadowReference.test.mjs). Opaque on purpose: forms sit
    // on it and need a measurable ground. White in light; `gray3` in dark, where
    // it stands 1.24:1 off both dark grounds under the dark `scrim` — lighter
    // than the gray2 app frame, darker than the gray5 stage (color.js has the
    // numbers). The last open piece of decision D5: `dialog` resolved from the
    // framework default (light: a 10% wash with no opaque fill) and then from
    // workspace shared/designSystem as gray16 / gray2+6 — the same values
    // within rounding, now exact ramp steps. Key order ('@light' first,
    // background then colour) matches the staged workspace copy, which a lock
    // test compares as JSON until the internal-brand pin carries this key.
    // A `card` (gray3 dark) directly on a dark dialog does not step off it —
    // content sits on the sheet unboxed (no-wrapper law).
    dialog: {
        '@light': {
            background: 'white',
            color: 'title'
        },
        '@dark': {
            background: 'gray3',
            color: 'title'
        }
    },
    // `backdrop` — THE blocking veil behind every modal, floating side panel
    // and phone sheet (spec §6.3): the `scrim` fill plus an 8px blur, so the
    // page reads as "behind glass" while it stays legible in outline (Nika
    // 2026-09-26, Q1 A). Only its OPACITY may animate — the blur radius never
    // does (cost). `backdropSoft` is the PageSlot window's lighter,
    // non-blocking veil: `scrimSoft` + 4px. Under `@reduceTransparency`
    // (media.js) the consumer drops the blur (`backdropFilter: 'none'`).
    backdrop: {
        '@light': {
            background: 'scrim',
            backdropFilter: 'blur(8px)'
        },
        '@dark': {
            background: 'scrim',
            backdropFilter: 'blur(8px)'
        }
    },
    backdropSoft: {
        '@light': {
            background: 'scrimSoft',
            backdropFilter: 'blur(4px)'
        },
        '@dark': {
            background: 'scrimSoft',
            backdropFilter: 'blur(4px)'
        }
    },
    'common-box': {
        '@dark': {
            background: 'gray2'
        },
        '@light': {
            background: 'white'
        }
    },
    'common-box-secondary': {
        '@dark': {
            background: 'gray3'
        },
        '@light': {
            background: 'gray16'
        }
    },
    'canvas-card': {
        '@dark': {
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            // Token-grammar color, byte-identical to the prior raw literal —
            // `black.1` parses to alpha 0.1 against the `black` keyword (see the
            // already-shipped `hover: ['black.05', 'white.07']` precedent two
            // files up in color.js). tickets/fable.md — brand direction pass.
            boxShadow: '0 4px 30px black.1',
            color: 'gray12',
            background: 'gray1.97'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16+6'
        }
    },
    'canvas-card-glass': {
        '@dark': {
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            // Shadow budget (brief §8, "zero shadows inside product surfaces...
            // no glassmorphism outside sanctioned product chrome"). The INSET
            // highlight simulating a glass bevel was the banned decorative glow —
            // Nika's marketplace visual sign-off (tickets/fable.md, 2026-08-09)
            // named this exact theme's inset as the offender and routed the fix
            // here. Removed the inset layer; kept the single outer grounding
            // shadow (shadow budget = 1).
            //
            // tickets/fable.md (2026-08-13, "box-shadow tokens resolve to
            // nothing"): this used to be the LITERAL token-grammar string
            // `'0 4px 32px black.25'` (and `black.01` on the @light half below).
            // That silently computed to `box-shadow: none` in BOTH schemes —
            // proven empirically (smbls/packages/scratch, real color.js +
            // theme.js through `set()`/`getActiveConfig()`): scratch's THEME
            // emission (`generateAutoVars` + `setMediaTheme`'s per-scheme branch,
            // packages/scratch/src/system/theme.js) resolves every non-`@`/`.`/`:`
            // theme param with a bare, whole-string `getColor(value, ...)` call —
            // correct for single-token color params (`background`, `color`,
            // `borderColor`) but NOT token-aware for compound multi-word CSS
            // values like `boxShadow`. `getColor('0 4px 32px black.25', …)` can't
            // parse a 4-token string as one color, falls through every branch,
            // and returns the literal input unchanged — the emitted CSS var ends
            // up as `--theme-canvas-card-glass-boxShadow: 0 4px 32px black.25`,
            // which is not valid CSS, so the browser drops the whole declaration
            // (invalid-at-computed-value-time → initial value `none`). This is a
            // framework gap in `system/theme.js`, NOT specific to `@light` or to
            // this token — filed for the framework lane, not fixed here.
            //
            // Fix at this layer: stop hand-authoring a shadow value here at all.
            // Reference the shadow primitive's OWN adaptive CSS var
            // (`designSystem/shadow.js` → `float`, resolved by the framework's
            // token-AWARE `setShadow`/`getShadow`, which two-way space-splits
            // shadow strings instead of whole-string matching). `var(--shadow-float)`
            // is already fully-resolved, native CSS — scratch's theme emitter
            // passes an already-native value straight through unchanged in both
            // schemes (verified same way), and the browser then chain-resolves
            // `var(--theme-canvas-card-glass-boxShadow)` → `var(--shadow-float)`
            // → the real per-scheme `rgba(...)` shadow. `float` IS the
            // `[light, dark]`-adaptive elevation for floating glass surfaces
            // (DESIGN_LANGUAGE.md §2.3) — one value, both schemes, no per-scheme
            // duplication needed here.
            //
            // 2026-09-25 (DESIGN-BRAND-SHADOW-FLOAT-SITES-RETURN-TO-SHADOW-PROP-1):
            // the compound-value gap above is closed in the framework (scratch
            // 742fcceb3 — `'0 4px 32px black.25'` resolves in a theme today), and
            // smbls badb29ac2 made the ELEMENT `shadow:` prop emit
            // `var(--shadow-float)`. Neither lets a THEME name the primitive. A
            // theme param resolves once, at build time, into a `--theme-*` var and
            // never reaches `getShadow`: `boxShadow: 'float'` emits
            // `var(--spacing-FLOAT)` (no such var — the declaration is dropped) and
            // `shadow: 'float'` emits the literal `float`. The var reference below
            // stays the one spelling that paints, and it keeps ONE value for both
            // schemes instead of a second copy of float's numbers.
            // tests/brand/themeShadowReference.test.mjs measures all of this on
            // every run and goes red the day a theme can name a primitive — return
            // these six sites to `float` then.
            boxShadow: 'var(--shadow-float)',
            backdropFilter: 'blur(35px)',
            background: 'gray1.85',
            color: 'gray12'
        },
        '@light': {
            color: 'gray2',
            background: 'gray16.95+6',
            backdropFilter: 'blur(35px)',
            // See the @dark block's comment above — same primitive, same fix.
            boxShadow: 'var(--shadow-float)'
        }
    },
    // The PageSlot pane chrome — inks + blur + the one float shadow ONLY.
    // The pane's GROUND deliberately lives at the component (canvas
    // PageSlot's _slotPane, `style: background var(--stage-bg,
    // var(--color-stage))`): the workspace's ONE ground chain
    // (BF-WIDGET-INK-1 — shell root, MainColumn, the main page and every
    // canvas Stage all paint it), so the pane can never differ from the
    // board beside it, in either scheme, and ground tuning iterates in the
    // project file instead of this linked package (Nika 2026-09-01 "we need
    // to make it very consistent" / "lets try keep one bg" — three fixed-
    // fill trials each drifted from SOME neighbor; the chain cannot).
    'pane-ground': {
        '@dark': {
            color: 'gray12',
            backdropFilter: 'blur(35px)',
            boxShadow: 'var(--shadow-float)'
        },
        '@light': {
            color: 'gray2',
            backdropFilter: 'blur(35px)',
            boxShadow: 'var(--shadow-float)'
        }
    },
    'canvas-card-glass-reversed': {
        '@dark': {
            borderWidth: '1px',
            borderColor: 'line',
            borderStyle: 'solid',
            // Same shadow-budget fix as `canvas-card-glass` above (this theme is
            // its light/dark mirror) — inset glow removed, outer shadow now
            // references the `float` primitive instead of a hand-authored
            // token-grammar string (see the sibling theme's comment for the full
            // root-cause writeup; tickets/fable.md 2026-08-13).
            boxShadow: 'var(--shadow-float)',
            backdropFilter: 'blur(35px)',
            background: 'gray16.95+6',
            color: 'gray2'
        },
        '@light': {
            color: 'gray12',
            background: 'gray1.85',
            backdropFilter: 'blur(35px)',
            boxShadow: 'var(--shadow-float)'
        }
    },
    'dialog-elevated': {
        '@dark': {
            color: 'title',
            background: 'gray3.95-16'
        },
        '@light': {
            color: 'title',
            background: 'gray14.98'
        }
    },
    // The DARK base is gray4 at .5 — one ramp step above the raised `card`
    // (gray3), so a field keeps an edge on a card: 1.11:1 (it was gray3.5, the
    // card's own colour: 1.00:1, no edge). On the document it reads 1.20:1 and
    // on a gray2 sheet 1.19:1 (1.10 / 1.07 before). The error / success /
    // placeholder variants share the base so a field in a state keeps its fill.
    //
    // The LIGHT rest fill is `widgetPlate` (Nika 2026-09-24, Q1 (c)): the
    // neutral plate that steps on the white sheet AND on the card, 1.15:1 on
    // both. It was `white.95` — 1.00:1 on the white sheet, so a light field
    // was only its hairline (1.57:1). Hover and focus still go to `white`,
    // and the `line` hairline the field kit draws stays. The variants that
    // share the base (placeholder, error, success) and the static look rest
    // on the same plate. Guarded by tests/brand/fieldLightRest.test.mjs.
    field: {
        '@dark': {
            color: 'gray14',
            background: 'gray4.5',
            ':hover': {
                color: 'gray15',
                background: 'gray4.65+2'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray4.65+6'
            },
            // Native :disabled — the Input atom forwards the `disabled` prop to the
            // attribute, so disabled inputs read as inert automatically (no per-field
            // markup). Safe: :disabled only matches form controls that carry the attr.
            // THE DISABLED LAW (2026-09-23): the `field-disabled` pair — `disabled`
            // ink on the neutral disabled plate — + not-allowed, NEVER opacity: the
            // old opacity .55 read 2.42:1 (dark) / 2.22:1 (light) live.
            ':disabled': {
                color: 'gray9',
                background: 'gray2.5',
                cursor: 'not-allowed'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'widgetPlate',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            },
            ':disabled': {
                color: 'gray7',
                background: 'gray15.6',
                cursor: 'not-allowed'
            }
        }
    },
    // The ink of this theme is ALSO every `field` input's ::placeholder ink:
    // the framework `field` theme's ::placeholder block emits a rule that reads
    // the same var name (--theme-field-placeholder-color), and this theme owns
    // that var. Both halves read the one `placeholder` pair (D-6, color.js).
    'field-placeholder': {
        '@dark': {
            color: 'placeholder',
            background: 'gray4.5',
            ':hover': {
                color: 'gray15',
                background: 'gray4.65+2'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray4.65+6'
            }
        },
        '@light': {
            color: 'placeholder',
            background: 'widgetPlate',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    'field-static': {
        '@dark': {
            color: 'gray14',
            background: 'gray3.5'
        },
        '@light': {
            color: 'gray3',
            background: 'widgetPlate'
        }
    },
    'field-highlight': {
        '@dark': {
            color: 'gray14',
            background: 'gray3.65+6',
            ':hover': {
                color: 'gray15',
                background: 'gray3.85+10'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray3.85+10'
            }
        },
        '@light': {
            color: 'gray3',
            // An in-field chip (the DropdownField icon groups) EQUALS the field
            // at rest in light — it was `white.95` on a `white.95` field. On
            // the `widgetPlate` rest a plate of its own would paint a white
            // (or a doubled grey) square inside the field, so it lets the
            // field's own fill show. Hover still goes to `white`, with the field.
            background: 'transparent',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    // Validation / state themes for fields. State is carried on `border` (and bg for
    // disabled/readonly) so it never collides with the global :focus-visible box-shadow
    // ring — a focused error field shows BOTH the red border and the neutral focus ring.
    //
    // Border colour is the SEMANTIC PAIR (`dangerInk`/`successInk`, color.js),
    // referenced IDENTICALLY from both `@dark`/`@light` blocks — same shape as
    // the `warning`/`error`/`success` FILL themes above (LMC-F2): the pair
    // token is `[lightValue, darkValue]`-adaptive, so one declaration resolves
    // two different literals per scheme instead of restating one by hand.
    // tickets/fable.md (brand-parity audit 2026-08-13): a bare `red`/`green`
    // hue was THEME-INVARIANT here — identical in both schemes, so at most one
    // of the two backgrounds it sits against (`gray4.5` dark / `white.95`
    // light, now `widgetPlate`) was ever actually measured. Both now clear the 3:1 non-text
    // floor against their own background in both schemes — see tickets/fable.md.
    'field-error': {
        '@dark': {
            color: 'gray14',
            background: 'gray4.5',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'dangerInk',
            ':hover': {
                color: 'gray15',
                background: 'gray4.65+2'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray4.65+6'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'widgetPlate',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'dangerInk',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    'field-success': {
        '@dark': {
            color: 'gray14',
            background: 'gray4.5',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'successInk',
            ':hover': {
                color: 'gray15',
                background: 'gray4.65+2'
            },
            ':focus': {
                color: 'gray16',
                background: 'gray4.65+6'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'widgetPlate',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'successInk',
            ':hover': {
                color: 'gray2',
                background: 'white'
            },
            ':focus': {
                color: 'gray2',
                background: 'white'
            }
        }
    },
    // Explicit disabled/readonly themes for non-native controls (custom dropdowns,
    // button-based fields) that can't rely on the :disabled pseudo. Native inputs get
    // disabled styling for free via the `field` theme's :disabled block.
    // THE DISABLED LAW (2026-09-23) — ONE pair for every disabled control,
    // field or button: the `disabled` ink (gray9 / gray7) on the neutral
    // disabled plate, + cursor not-allowed + the real `disabled` attribute.
    // NEVER opacity: it drags the label under the floor (a disabled primary
    // read 2.73:1 dark / 1.89:1 light at opacity .35). Without it the label
    // reads >= 4.84:1 on document, common-box and card in both schemes.
    'field-disabled': {
        '@dark': {
            color: 'gray9',
            background: 'gray2.5',
            cursor: 'not-allowed'
        },
        '@light': {
            color: 'gray7',
            background: 'gray15.6',
            cursor: 'not-allowed'
        }
    },
    'field-readonly': {
        '@dark': {
            color: 'gray12',
            background: 'gray2.5',
            cursor: 'default'
        },
        '@light': {
            color: 'gray4',
            background: 'gray15.85',
            cursor: 'default'
        }
    },
    scene: {
        '@dark': {
            color: 'gray14',
            background: 'gray2.85'
        },
        '@light': {
            color: 'gray4',
            background: 'gradient-dark'
        }
    },
    'scene-preview-interactive': {
        '@dark': {
            color: 'gray13',
            background: 'gray2.5',
            ':hover': {
                background: 'gray2.85'
            },
            ':active': {
                background: 'gray2+1'
            }
        },
        '@light': {
            color: 'gray3',
            background: 'gray16+6',
            ':hover': {
                background: 'gray16+16'
            },
            ':active': {
                background: 'gray16+26'
            }
        }
    },
    headerCaptions: {
        '@dark': {
            color: 'white',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray2.95-6'
        },
        '@light': {
            color: 'black',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray13.89'
        }
    },
    headerSidebar: {
        '@dark': {
            color: 'white',
            background: 'gray1.95',
            borderColor: 'white.01'
        },
        '@light': {
            color: 'black',
            background: 'gray16.95+10',
            borderColor: 'black.01'
        }
    },
    // `layer` — the resting wash one step off the ground: chips, pills,
    // starter rows, recipient chips, suggestion chips. It has to read over BOTH
    // grounds it lands on — the document AND a raised `common-box` card —
    // in both schemes, and it has to sit UNDER the state fills (`hover`
    // black.05 / white.07, `selected` gray2.08 / white.1) so a hover on a
    // layer chip still steps.
    //
    // DESIGN-LAYER-THEME-LIGHT-FILL-1 (measured 2026-09-10): the light half was
    // `gray15.1` — gray15 at 10% over a gray15 document composites to the
    // document itself (contrast 1.000; 1.012 over a white card): every layer
    // chip on the light theme was bare text. The dark half `gray7.1` measures
    // 1.06 over `gray1` and 1.08 over a `gray2` card, which is the relation the
    // light half now mirrors with the SAME construction — a translucent wash of
    // the far end of the ramp: `gray2.04` measures 1.08 over gray15 and 1.09
    // over white (WCAG contrast recomputed from designSystem/color.js), and it
    // stays below `hover` (black.05 → 1.11) and `selected` (gray2.08 → 1.18).
    // An opaque `white`/`gray16` was rejected: 1.13/1.08 over the document but
    // 1.00/1.04 over a white card, i.e. invisible exactly where the reply
    // capsules and attachment chips sit.
    layer: {
        '@dark': {
            background: 'gray7.1'
        },
        '@light': {
            background: 'gray2.04'
        }
    },
    transparentPattern: {
        '@dark': {
            background: 'transparentBg',
            backgroundColor: 'document',
            backgroundSize: '20px 20px',
            backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px'
        }
    },
    dots: {
        backgroundPosition: 'top',
        backgroundRepeat: 'repeat',
        backgroundSize: '20px 20px',
        '@dark': {
            backgroundImage: 'dotsDark',
            backgroundPosition: 'top',
            backgroundRepeat: 'repeat',
            backgroundSize: '20px 20px'
        },
        '@light': {
            backgroundImage: 'dotsLight',
            backgroundPosition: 'top',
            backgroundRepeat: 'repeat',
            backgroundSize: '20px 20px'
        }
    },
    line: {
        '@dark': {
            background: '--color-line-dark'
        },
        '@light': {
            background: '--color-line-light'
        }
    },
    modalFade: {
        '@dark': {
            color: 'white',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray1.75+6'
        },
        '@light': {
            color: 'black',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'gray13.75'
        }
    },
    // The framework's own overlays default to this theme — the windows-plugin
    // ModalLayer window and the dropdown host (DropdownRoot). Aligned BY VALUE
    // with `dialog` (white / gray3, `title` ink; spec §4.2), so every framework
    // modal and default popover restyles with zero framework edits. It was
    // gray16 / gray2 with a gray5 / white ink.
    modal: {
        '@dark': {
            color: 'title',
            background: 'gray3'
        },
        '@light': {
            color: 'title',
            background: 'white'
        }
    },
    modalPreview: {
        '@dark': {
            color: 'white',
            background: 'gray3.98-16'
        },
        '@light': {
            color: 'gray5',
            background: 'gray16'
        }
    },
    sepia: {
        ':hover': {
            opacity: '.65'
        },
        ':active': {
            opacity: '1'
        },
        '@dark': {
            color: 'yellow',
            background: 'transparent.0',
            ':hover': {
                background: 'yellow.15=85'
            },
            ':active': {
                background: 'yellow.15=85'
            }
        },
        '@light': {
            // `yellow-25` (#cfb33d) read 1.83:1 on the light document and 2.07 on
            // white: under the 4.5 text floor AND the 3:1 floor of an icon-only
            // control, on the six editor buttons that use this theme. `yellow-120`
            // (#705400) keeps the hue family and clears the floor on EVERY light
            // ground: 6.30 on the document, 7.10 on white, 4.98 on the `milk` stage
            // (`-110` read 4.30 there; tests/brand/sepiaInkContrast.test.mjs). The
            // dark half is unchanged: `yellow` reads 5.99 on the dark stage, 9.7 and up
            // on the rest.
            color: 'yellow-120',
            background: 'transparent.0',
            ':hover': {
                background: 'yellow.2'
            },
            ':active': {
                background: 'yellow.2'
            }
        }
    },
    'sepia-active': {
        color: 'yellow',
        background: 'yellow.15=85',
        borderColor: 'yellow.15=85'
    }
};

});

parcelRegister("7x7K2", function(module, exports) {

$parcel$export(module.exports, "default", () => $57c19ecdaa1de48d$export$2e2bcd8739ae039);
// TBC Contractica — the GEORGIAN-script face for every Symbols surface.
//
// Nika 2026-08-31: "add TBC Contractica to workspace for Georgian texts".
// Nika 2026-09-02: "it should have Contractica - as we added it (maybe its in
// Gita only - move to brand)". So the face lives HERE, in brand, and reaches
// the workspace shell, the landing and the docs through the shared-library
// merge (mergeSharedLibraries -> deepDefaults(context.designSystem,
// brand.designSystem)) instead of being pinned to one app.
//
// Every face is unicode-range-scoped to the Georgian blocks (Mkhedruli +
// Asomtavruli U+10A0-10FF, Mtavruli U+1C90-1CBF, Nuskhuri U+2D00-2D2F), so
// the browser downloads and uses the face ONLY for Georgian codepoints. Latin
// and every other script falls through to the next family in the stack
// (font_family.js prepends TBCContractica to the `smbls` default). The
// unicodeRange prop threads through scratch since smbls@80a2a8d1e.
//
// Weights follow the house law {400,500,700}: Book=400, Medium=500, Bold=700
// (Light/Black exist in the family but stay out of the scale). The files are
// package-local woff2 (~42 KB each, converted from the licensed TBC TTFs) and
// live in `fonts/`, which package.json `files` ships with the npm package.
//
// TWO PLANES READ THIS FILE — DO NOT "SIMPLIFY" THE GUARD BELOW
// ---------------------------------------------------------------------------
// 1. PARCEL (the workspace shell, the landing and the docs, dev serve and
//    deploy artifact). Parcel detects `new URL('<literal>', import.meta.url)`
//    SYNTACTICALLY and rewrites the whole call to `new URL(require('<asset
//    id>'))`, which resolves to the real hashed asset URL of the emitting
//    bundle. The first argument must stay a literal string written inline at
//    the call — a path passed in through a variable or a parameter emits no
//    asset at all and the face 404s.
// 2. FRANK (`frank.toJSON`, i.e. every `smbls push` of brand and of every
//    project that imports brand). Frank bundles the project to CJS with
//    esbuild and EVALUATES it in node. esbuild empties `import.meta` to `{}`
//    under the cjs output format ("import.meta is not available with the cjs
//    output format and will be empty"), so `new URL(rel, undefined)` throws
//    `TypeError: Invalid URL` AT MODULE INIT and the whole build dies. That
//    is WS-SHELL-FONT-URL-BREAKS-FRANK-PUSH-1: from 2026-08-31 to 2026-09-02
//    every workspace-shell push failed this way, and brand is a shared
//    library for many more projects than the shell was.
//
// `assetUrl` therefore (a) keeps a throw from escaping module init, and
// (b) rejects a `file:` URL — a node ESM eval DOES have `import.meta.url`,
// and it points at the build box's own filesystem; serializing that path into
// a published record is junk data that 404s on every plane. A face with no
// usable url is DROPPED, so a frank-published record carries no
// `TBCContractica` entry at all rather than a broken one. Latin text is
// unaffected on that plane too: CSS skips a family that has no matching
// @font-face and falls straight through to Helvetica Neue.
const $57c19ecdaa1de48d$var$georgianRange = 'U+10A0-10FF, U+1C90-1CBF, U+2D00-2D2F';
const $57c19ecdaa1de48d$var$assetUrl = (resolve)=>{
    try {
        const href = resolve();
        if (typeof href !== 'string' || !href) return null;
        if (href.slice(0, 5).toLowerCase() === 'file:') return null;
        return href;
    } catch (e) {
        // No `import.meta` (frank's node eval of the CJS bundle) — drop the face.
        return null;
    }
};
const $57c19ecdaa1de48d$var$face = (url, fontWeight)=>url ? {
        url: url,
        fontWeight: fontWeight,
        fontDisplay: 'swap',
        unicodeRange: $57c19ecdaa1de48d$var$georgianRange
    } : null;



const $57c19ecdaa1de48d$var$TBCContractica = [
    $57c19ecdaa1de48d$var$face($57c19ecdaa1de48d$var$assetUrl(()=>new URL((parcelRequire("a9tHk"))).href), 400),
    $57c19ecdaa1de48d$var$face($57c19ecdaa1de48d$var$assetUrl(()=>new URL((parcelRequire("kDEIZ"))).href), 500),
    $57c19ecdaa1de48d$var$face($57c19ecdaa1de48d$var$assetUrl(()=>new URL((parcelRequire("3NnFp"))).href), 700)
].filter(Boolean);
var $57c19ecdaa1de48d$export$2e2bcd8739ae039 = $57c19ecdaa1de48d$var$TBCContractica.length ? {
    TBCContractica: $57c19ecdaa1de48d$var$TBCContractica
} : {};

});
parcelRegister("a9tHk", function(module, exports) {
module.exports = import.meta.resolve("lD7Xe");

});

parcelRegister("kDEIZ", function(module, exports) {
module.exports = import.meta.resolve("2tBPs");

});

parcelRegister("3NnFp", function(module, exports) {
module.exports = import.meta.resolve("jfU22");

});


parcelRegister("2zaom", function(module, exports) {

$parcel$export(module.exports, "default", () => $1de6e940392d836e$export$2e2bcd8739ae039);
var $1de6e940392d836e$export$2e2bcd8739ae039 = {
    // TBCContractica sits FIRST and costs Latin text nothing: its @font-face
    // (font.js) is unicode-range-scoped to the Georgian blocks, so the browser
    // uses — and even downloads — the face ONLY for Georgian codepoints. Every
    // other script skips it and lands on Helvetica Neue exactly as before.
    // The same holds where the face never loads at all (a frank-published
    // record ships no TBCContractica @font-face): CSS skips a family it cannot
    // resolve and falls through to the next entry in the stack.
    // Nika 2026-09-02: "it should have Contractica - as we added it (maybe its
    // in Gita only - move to brand)".
    smbls: {
        isDefault: true,
        value: [
            '"TBCContractica"',
            '"Helvetica Neue"',
            '"Helvetica"'
        ],
        // `type` picks the GENERIC tail the framework appends to the stack
        // (scratch's fontFamilyTypes map): 'sans-serif' appends
        // `Helvetica, Arial, sans-serif`, 'serif' appends
        // `Times New Roman, Georgia, serif`. This is the sans stack, so it must
        // be 'sans-serif' — declared 'serif', every device WITHOUT Helvetica
        // (Android, most Linux) fell through to Times New Roman and rendered the
        // brand, and every shell that consumes it, in a serif face
        // (DESIGN-BRAND-SANS-STACK-DECLARED-SERIF-1).
        type: 'sans-serif'
    },
    // The MONO face — micro-labels and data numerals (money, counts, times,
    // ids), never buttons, nav or titles (white-label spec §5.7, Q6 A). A
    // SYSTEM stack, no web font (decision D8 holds): every platform ships one
    // of these. It was "Droid Sans Mono for Powerline", a terminal font absent
    // on user machines, so `Code` fell to the browser default (measured live:
    // Courier New). TBCContractica leads for the same reason it leads `smbls`:
    // its @font-face is unicode-range-scoped to Georgian, so Latin skips it and
    // Georgian — which no system mono covers — lands on the brand face. The
    // face ships all 33 modern Mtavruli capitals (checked in the woff2 cmap,
    // 2026-09-26), so an uppercase micro-label in Georgian renders in
    // Mtavruli, never tofu.
    Code: {
        value: [
            '"TBCContractica"',
            'ui-monospace',
            '"SF Mono"',
            '"SFMono-Regular"',
            'Menlo',
            '"Cascadia Mono"',
            'Consolas',
            '"Roboto Mono"'
        ],
        type: 'monospace'
    }
};

});

parcelRegister("cb0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dd6c774f23f8510$export$2e2bcd8739ae039);
var $8dd6c774f23f8510$export$2e2bcd8739ae039 = {
    base: 17,
    ratio: 1.2,
    subSequence: true,
    '@screenS': {
        base: 16,
        ratio: 1.15
    },
    '@tabletS': {
        base: 15,
        ratio: 1.1
    }
};

});

parcelRegister("529WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aa4da80a2f99c1e$export$2e2bcd8739ae039);
var $3aa4da80a2f99c1e$export$2e2bcd8739ae039 = {
    base: 17,
    ratio: 1.618,
    range: [
        '-6',
        12
    ],
    subSequence: true
};

});

parcelRegister("gzeRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0fb71b3ee42fc6c$export$2e2bcd8739ae039);
/**
 * Fixed-dimension tokens — named pixel values that sit outside the
 * ratio-based spacing scale (base 17, phi 1.618).
 *
 * These cover UI primitives whose dimensions are intentional constants
 * (hairline borders, avatar circles, thumbnail slots) rather than
 * harmonics of the typographic rhythm. Use these tokens instead of
 * raw px literals to satisfy the FA304 audit rule.
 *
 * Usage in components:
 *   width: 'avatarMd'        → 48px
 *   height: 'avatarSm'       → 36px
 *   borderWidth: 'hairline'  → 1px
 */ var $c0fb71b3ee42fc6c$export$2e2bcd8739ae039 = {
    // Hairlines — sub-spacing-scale borders and dividers
    hairline: '1px',
    hairline2: '2px',
    // Coarse-pointer tap-slop — the invisible ::after outset that grows a
    // control's HIT area to ~44pt without growing its visual size (see
    // NavbarButton/IconButton '@coarse'). Fixed px on purpose: tap slop is a
    // device-physical quantity — an em token would shrink exactly where glyphs
    // are smallest, which is where slop is needed most. Negative baked in so
    // consumers write `inset: 'tapSlop'`. Magnitude pairs with the smallest
    // common neighbor gap (~13px) so adjacent slops don't cross mid-gap.
    tapSlop: '-6px',
    // Avatar / user-profile circles
    avatarXs: '24px',
    avatarSm: '36px',
    avatarMd: '48px',
    avatarLg: '54px',
    avatarXl: '72px',
    // Thumbnail / media card fixed heights
    thumbnailXs: '56px',
    thumbnailSm: '64px',
    thumbnailMd: '80px',
    thumbnailLg: '120px',
    // Icon container sizes (distinct from spacing-scale-derived icon glyphs)
    iconXs: '12px',
    iconSm: '16px',
    iconMd: '20px',
    iconLg: '24px',
    iconXl: '32px',
    // FLOATING-CHROME TYPE — an ABSOLUTE, NON-COMPOUNDING text size.
    //
    // `rem`, not `px`, and not a `--font-size-*` letter. The whole type scale is
    // em-relative (`--font-size-Z` is `0.83em`), which is correct for text that
    // sits IN a document flow and wrong for a panel that floats OVER one: the
    // panel inherits its parent's font-size, so every em token on it — its own
    // size, its padding, its width cap — is multiplied by whatever the trigger
    // happened to inherit. Measured on the help tooltip, 2026-09-10: a `Z` panel
    // (0.83em) inside a `Z` consumer override, holding a framework `P` at `Z2`
    // (0.936em), rendered its body copy at 12.55px beside a 17px page — and at
    // 6.96px next to a `fontSize: 'Y'` button. Three multiplications, no floor.
    //
    // A rem value is resolved against the DOCUMENT root, which the design system
    // itself sets (`html { font-size: 1.0625em }` = the 17px typography base), so
    // this token IS on the scale — it is the `Z` step (base / 1.2) — but it can
    // never compound. Chrome must be one size everywhere; that is the whole
    // point of chrome.
    tooltipText: '0.8333rem',
    // Semantic control geometry — workspace design language §3 + §6
    // (workspace/DESIGN_LANGUAGE.md). Fixed px on purpose. The four radius
    // tokens (radiusControl/radiusCard/radiusSheet/radiusPill) moved to
    // their canonical home in `designSystem/shape.js` — the framework
    // resolves CONFIG.shape first for round:/borderRadius:, with sizes.js
    // kept only as the back-compat fallback for projects that still
    // register radii here. Control heights are not radii, so they stay.
    controlH: '44px',
    controlHCompact: '36px',
    // OVERLAY GEOMETRY — the white-label redesign's floating overlays (spec
    // §4.5, §6.1). Fixed px on purpose, like the control heights above: an
    // overlay's width must not scale with the font size of whatever it floats
    // over (the em trap). Every centred sheet and floating side panel picks one
    // width; `overlayGutter` is its inset from the frame (a side panel floats
    // that far off the top, outer and bottom edges; a centred sheet keeps at
    // least that margin). The phone sheet's grabber is a decorative pill.
    // Byte-identical to the staged copies in workspace shared/designSystem
    // (lane D2), which a lock test compares until the internal-brand pin.
    overlaySm: '400px',
    overlayMd: '480px',
    overlayLg: '560px',
    overlayXl: '880px',
    overlayGutter: '12px',
    grabberW: '36px',
    grabberH: '5px'
};

});

parcelRegister("3WuWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2deecae1f0df2bd1$export$2e2bcd8739ae039);
/**
 * Elevation — the entire shadow vocabulary (workspace design language §2.3,
 * workspace/DESIGN_LANGUAGE.md). Two levels, [lightValue, darkValue] pairs:
 *
 *   float   — things that hover over live content: popovers, menus, toasts,
 *             floating islands and toolbars, the chosen thumb of a view
 *             segmented control, a card while it is dragged
 *   overlay — the sheets: modals, floating side panels, phone sheets
 *
 * Everything else casts nothing: stage and raised surfaces separate by fill
 * contrast (borderless law).
 *
 * Each level is ONE token of THREE layers (white-label redesign, Nika
 * 2026-09-26 "update them in brand"; spec §4.3). The budget counts tokens,
 * not layers — there are still exactly two:
 *   1. a 1px hairline RING (`0 0 0 1px`) — the edge an elevated surface needs
 *      on a ground of its own colour (reference r024: #EAEDF0 ≈ black.06 on
 *      white; white.08–.09 is the dark separator). It lives INSIDE the token,
 *      so only elevated things carry it and in-page cards stay borderless;
 *   2. a tight CONTACT shadow under the edge;
 *   3. a wide, soft AMBIENT shadow.
 * The dark `overlay` keeps the weight of the previous dominant modal shadow
 * (black .45 over 32px) and adds the ring. Guarded by
 * tests/brand/overlayTokens.test.mjs (three layers, ring first, real rgba
 * colours, no `var(--spacing-` anywhere).
 */ var $2deecae1f0df2bd1$export$2e2bcd8739ae039 = {
    float: [
        '0 0 0 1px black.06, 0 1px 2px black.06, 0 8px 24px -8px black.12',
        '0 0 0 1px white.08, 0 1px 2px black.4, 0 8px 24px -8px black.5'
    ],
    overlay: [
        '0 0 0 1px black.05, 0 4px 12px -4px black.08, 0 24px 64px -12px black.18',
        '0 0 0 1px white.09, 0 4px 12px -4px black.4, 0 24px 64px -12px black.55'
    ],
    // THE focus ring — DESIGN_LANGUAGE §8.2 "one ring, globally". `reset.js`
    // paints it on every focusable's `:focus-visible`; this token exists ONLY
    // for the controls whose native input is visually hidden (checkbox,
    // switch, upload label) and must land the SAME ring on the visible proxy
    // — reference `shadow: 'focusRing'` there, never restate the value and
    // never reach for the framework atom's `outline: solid X blue.3` (a second,
    // different ring; that fork was the F1 inconsistency, Nika 2026-08-16).
    // Raw `var(--color-…)` refs on purpose: the ring must be scheme-adaptive
    // (highlight = black on light, white on dark) inside a single string, and
    // the 1px `document` gap keeps it visible on same-coloured neighbours.
    // ⚠ Reference shadow TOKENS through the `shadow:` prop, never `boxShadow:`
    // — css-in-props' boxShadow resolver walks colour → spacing → passthrough
    // and never consults CONFIG.shadow, so `boxShadow: 'float'` compiles to
    // `var(--spacing-FLOAT)` (nothing renders). Measured live 2026-08-16 on the
    // menu-row ring: `boxShadow: 'focusRingInset'` → var(--spacing-FOCUSRINGINSET).
    focusRing: '0 0 0 1px var(--color-document), 0 0 0 3px var(--color-highlight)',
    // The SAME ring drawn inward — for rows inside a clipped container (menu
    // panels, `overflow: auto` lists) where an outer spread would be cut off at
    // the panel edge. Identical colours and 1px gap + 2px ring geometry; only
    // the direction differs, so keyboard focus reads the same everywhere.
    focusRingInset: 'inset 0 0 0 1px var(--color-document), inset 0 0 0 3px var(--color-highlight)'
};

});

parcelRegister("d2rDO", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e0e7384fcac43a$export$2e2bcd8739ae039);
var $97e0e7384fcac43a$export$2e2bcd8739ae039 = {
    default: 150,
    base: 150,
    subSequence: true,
    defaultBezier: 'cubic-bezier(.29, .67, .51, .97)',
    // The overlay ENTRANCE curve (white-label redesign, spec §4.6 / §6.4):
    // PageSlot's `_IOS_EASE`, the curve Nika approved on the window pane
    // ("smooth like iOS", 2026-07-12). Entrances only — a sheet, side panel,
    // phone sheet or toast settling in. Exits and micro-states (hover, press,
    // colour) stay on `defaultBezier`, one duration letter faster than the
    // entrance. Byte-identical to the staged workspace copy (lane D2).
    springBezier: 'cubic-bezier(.32, .72, 0, 1)'
};

});

parcelRegister("ln7NP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f1cc6de3aa6cb3$export$2e2bcd8739ae039);
var $f8f1cc6de3aa6cb3$export$2e2bcd8739ae039 = {};

});

parcelRegister("5BzM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $414c289eb4d28825$export$2e2bcd8739ae039);
var $414c289eb4d28825$export$2e2bcd8739ae039 = {};

});

parcelRegister("5IvaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $42993dbf8f861089$export$2e2bcd8739ae039);
var $42993dbf8f861089$export$2e2bcd8739ae039 = {
    return: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.05064658,21.553253 C7.76773351,21.553253 7.51729885,21.4475567 7.29934261,21.236164 L1.33151755,15.3674717 C1.22242626,15.264944 1.13990052,15.1480443 1.08394031,15.0167726 C1.0279801,14.885501 1,14.7477223 1,14.6034366 C1,14.4656014 1.0279801,14.3292373 1.08394031,14.1943443 C1.13990052,14.0594514 1.22242626,13.9410805 1.33151755,13.8392318 L7.29934261,7.97155798 C7.51729885,7.76016532 7.76773351,7.654469 8.05064658,7.654469 C8.35653221,7.654469 8.60057303,7.7491883 8.78276905,7.93862689 C8.96496507,8.12806549 9.05606308,8.36712704 9.05606308,8.65581155 C9.05606308,8.80507649 9.03178914,8.9384983 8.98324126,9.05607697 C8.93469337,9.17365565 8.8617018,9.27788083 8.76426653,9.36875251 L5.9792136,12.0896408 L3.42349002,14.2583392 L3.16632203,13.7183713 L6.49422857,13.5796874 L19.4415759,13.5796874 C19.9715287,13.5796874 20.3561207,13.4584025 20.595352,13.2158328 C20.8345833,12.9732632 20.9541989,12.5804949 20.9541989,12.0375282 L20.9541989,6.01877874 C20.9541989,5.48893913 20.8345833,5.10437538 20.595352,4.8650875 C20.3561207,4.62579962 19.9715287,4.50615567 19.4415759,4.50615567 L13.7371995,4.50615567 C13.4254293,4.50615567 13.1732405,4.40495767 12.9806333,4.20256165 C12.7880261,4.00016563 12.6917225,3.76011389 12.6917225,3.48240641 C12.6917225,3.19813535 12.7880261,2.95499985 12.9806333,2.75299991 C13.1732405,2.55099997 13.4254293,2.45 13.7371995,2.45 L19.4666986,2.45 C20.7078948,2.45 21.6070775,2.72838647 22.1642465,3.28515941 C22.7214155,3.84193235 23,4.74091695 23,5.98211321 L23,12.0741937 C23,13.2883435 22.7214155,14.1840463 22.1642465,14.7613021 C21.6070775,15.338558 20.7078948,15.6271859 19.4666986,15.6271859 L6.49422857,15.6271859 L3.16632203,15.4883322 L3.42349002,14.948534 L5.9792136,17.1160443 L8.76426653,19.8389695 C8.8617018,19.9291622 8.93469337,20.0330478 8.98324126,20.1506265 C9.03178914,20.2682052 9.05606308,20.401627 9.05606308,20.5508919 C9.05606308,20.84614 8.96496507,21.0870122 8.78276905,21.2735085 C8.60057303,21.4600048 8.35653221,21.553253 8.05064658,21.553253 Z"/></svg>',
    googleLogoNormal: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/></svg>',
    facebook: '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" width="48px" height="48px"><linearGradient id="Ld6sqrtcxMyckEl6xeDdMa" x1="9.993" x2="40.615" y1="9.993" y2="40.615" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2aa4f4"/><stop offset="1" stop-color="#007ad9"/></linearGradient><path fill="url(#Ld6sqrtcxMyckEl6xeDdMa)" d="M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20s20-8.954,20-20S35.046,4,24,4z"/><path fill="#fff" d="M26.707,29.301h5.176l0.813-5.258h-5.989v-2.874c0-2.184,0.714-4.121,2.757-4.121h3.283V12.46 c-0.577-0.078-1.797-0.248-4.102-0.248c-4.814,0-7.636,2.542-7.636,8.334v3.498H16.06v5.258h4.948v14.452 C21.988,43.9,22.981,44,24,44c0.921,0,1.82-0.084,2.707-0.204V29.301z"/></svg>',
    accessibility: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.368 6.848c-1.752 1.034-3.11 1.805-4.315 2.305a.496.496 0 00-.303.46V20.5c0 .275-.225.5-.5.5h-1a.5.5 0 01-.5-.5v-5h-1.5v5c0 .275-.225.5-.5.5h-.998a.5.5 0 01-.5-.5V9.613c0-.2-.118-.383-.303-.46-1.206-.5-2.564-1.27-4.317-2.305a.5.5 0 01-.177-.686l.424-.717a.5.5 0 01.685-.176C8.794 7.172 10.44 7.972 12 8c1.56-.027 3.206-.827 6.436-2.73a.5.5 0 01.685.176l.424.717a.5.5 0 01-.177.686M12 3c1.008 0 1.833.825 1.833 1.832s-.825 1.833-1.833 1.833c-1.007 0-1.832-.825-1.832-1.833S10.992 3 11.999 3m0-2C5.924 1 1 5.925 1 12s4.925 11 11 11c6.076 0 11-4.925 11-11S18.075 1 12 1" fill-rule="evenodd"/></svg>',
    accessibilityOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.06 4.457a.5.5 0 01.685.176l.51.86a.5.5 0 01-.177.686c-1.94 1.144-3.437 1.996-4.764 2.545a.503.503 0 00-.315.464v12.27c0 .275-.224.5-.5.5h-1a.5.5 0 01-.5-.5V16h-2v5.458c0 .275-.224.5-.5.5h-.997a.5.5 0 01-.5-.5V9.188a.504.504 0 00-.314-.464c-1.328-.549-2.826-1.4-4.766-2.545a.5.5 0 01-.177-.685l.51-.861a.5.5 0 01.684-.176C8.49 6.55 10.292 7.428 12 7.46l.172-.006c1.659-.085 3.458-.973 6.89-2.996zM12 2.017c1.099 0 1.998.9 1.998 2 0 1.099-.9 1.999-1.999 1.999-1.099 0-1.999-.9-1.999-2 0-1.099.9-1.998 2-1.998z" fill-rule="evenodd"/></svg>',
    colorContrast: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 5c5.58 0 8.83 4.917 9.737 6.509a.992.992 0 010 .983C20.83 14.084 17.58 19 12 19c-5.58 0-8.83-4.916-9.737-6.508a.992.992 0 010-.983C3.169 9.917 6.42 5 12 5zm3.882 3.118L14.12 9.88A2.99 2.99 0 0012 9c-1.654 0-3 1.346-3 3 0 .827.336 1.577.88 2.12l-1.762 1.762C9.214 16.542 10.51 17 12 17c4.04 0 6.664-3.366 7.7-5-.654-1.031-1.942-2.752-3.818-3.882zM14.12 9.88A2.99 2.99 0 0115 12c0 1.654-1.346 3-3 3a2.99 2.99 0 01-2.12-.88z" fill-rule="evenodd"/></svg>',
    colorContrastAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 16.001v-8c2.207 0 4 1.794 4 4 0 2.203-1.793 4-4 4m9.737-4.492C20.83 9.916 17.58 5 12 5 6.42 5 3.17 9.916 2.263 11.51a.991.991 0 000 .982c.907 1.593 4.158 6.51 9.737 6.51 5.58 0 8.83-4.917 9.737-6.51a.991.991 0 000-.982" fill-rule="evenodd"/></svg>',
    colorContrastAltOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 5c5.58 0 8.83 4.917 9.737 6.509a.993.993 0 010 .983C20.831 14.084 17.58 19 12 19s-8.83-4.916-9.737-6.508a.992.992 0 010-.983C3.17 9.917 6.421 5 12 5zm0 2c-4.04 0-6.664 3.366-7.699 5 1.035 1.634 3.659 5 7.7 5 4.04 0 6.663-3.366 7.698-5C18.664 10.366 16.04 7 12 7zm0 2.001c1.655 0 3 1.345 3 3 0 1.653-1.345 3-3 3z" fill-rule="evenodd"/></svg>',
    eyeClosed: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.71 3.16c.2-.2.51-.2.71 0l.71.71c.2.2.2.51 0 .71L4.35 21.37c-.2.2-.51.2-.71 0l-.71-.71c-.2-.2-.2-.51 0-.71l3.09-3.09c-1.99-1.54-3.25-3.47-3.76-4.37-.17-.3-.17-.67 0-.98C3.17 9.92 6.42 5 12 5c1.79 0 3.33.51 4.63 1.24zm.05 5.62a16.42 16.42 0 011.98 2.73c.17.3.17.68 0 .98C20.83 14.08 17.58 19 12 19c-.78 0-1.51-.1-2.19-.27l1.75-1.75c.14.01.29.02.44.02 4.04 0 6.67-3.37 7.7-5-.31-.49-.77-1.14-1.36-1.8zM12 7c-4.04 0-6.67 3.37-7.7 5 .57.9 1.64 2.33 3.15 3.43l2.32-2.32c-.17-.33-.27-.71-.27-1.11A2.5 2.5 0 0112 9.5c.4 0 .78.1 1.11.27l2.04-2.04C14.22 7.29 13.17 7 12 7z" fill-rule="evenodd"/></svg>',
    eyeOpen: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 5c5.58 0 8.83 4.92 9.74 6.51.17.3.17.67 0 .98C20.83 14.08 17.58 19 12 19s-8.83-4.92-9.74-6.51c-.17-.3-.17-.67 0-.98C3.17 9.92 6.42 5 12 5zm0 2c-4.04 0-6.66 3.37-7.7 5 1.04 1.63 3.66 5 7.7 5s6.67-3.37 7.7-5c-1.04-1.63-3.66-5-7.7-5zm0 2.5a2.5 2.5 0 010 5 2.5 2.5 0 010-5z" fill-rule="evenodd"/></svg>',
    voiceover: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.002 13.499c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m12 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m0-6.5a5 5 0 00-5 5c0 1.127.378 2.164 1.007 3H9.995a4.971 4.971 0 001.007-3 5 5 0 10-5 5h12a5 5 0 000-10" fill-rule="evenodd"/></svg>',
    voiceoverOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18 7a5 5 0 110 10H6a5 5 0 115-5 4.971 4.971 0 01-1.007 3h4.014A4.971 4.971 0 0113 12a5 5 0 015-5zM6 9c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm12 0c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM6 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm12 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    borderRadius: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17 3.5v.94c-4.69.8-9.05 4.29-11.25 8.65V7.37c1.1-.35 1.87-1.42 1.73-2.66a2.517 2.517 0 00-2.19-2.2A2.51 2.51 0 002.5 5c0 1.12.74 2.05 1.75 2.37V17H3.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-.53C7 11.81 11.81 7 17 5.97v.53c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    borderRadiusEndEnd: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.236 12.639l-.055.081-.146.21c-.124.178-.253.353-.384.525l-.324.409c-2.38 2.923-5.758 5.09-9.327 5.698v.94c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.53c1.734-.344 3.426-1.11 4.949-2.172 3.033-2.117 5.395-5.404 6.081-8.86h-.53c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.94c-.305 1.785-.999 3.522-1.983 5.11l-.34.529z"/></svg>',
    borderRadiusEndStart: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.764 11.363l.055-.081.146-.21c.124-.178.253-.353.384-.525l.324-.409c2.38-2.923 5.758-5.09 9.327-5.698V3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.53c-1.734.344-3.426 1.11-4.949 2.172-3.033 2.117-5.395 5.404-6.081 8.86h.53c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.94c.305-1.785.999-3.522 1.983-5.11l.34-.529z"/></svg>',
    borderRadiusStartEnd: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.638 6.765l.081.055.21.146c.178.124.353.253.525.384l.409.324c2.923 2.38 5.09 5.758 5.698 9.327h.94c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.53c-.344-1.734-1.11-3.426-2.172-4.949-2.117-3.033-5.404-5.395-8.86-6.081v.53c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.94c1.785.305 3.522.999 5.11 1.983l.529.34z"/></svg>',
    borderRadiusStartStart: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.362 17.237l-.081-.055-.21-.146a16.777 16.777 0 01-.525-.384l-.409-.324C7.214 13.948 5.047 10.57 4.439 7h-.94c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.53c.344 1.734 1.11 3.426 2.172 4.949 2.117 3.033 5.404 5.395 8.86 6.081v-.53c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.94c-1.785-.305-3.522-.999-5.11-1.983l-.529-.34z"/></svg>',
    borderWidth: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.41.492L20.5 21a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm-3.668 0a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm-4.667 0a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM6.497 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5H3.503a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    dimensions: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19zM20 4H4v16h16V4zm-9.166 2.5c.334 0 .501.404.265.64L9.827 8.412l5.76 5.761 1.273-1.272a.375.375 0 01.64.265V17a.5.5 0 01-.5.5h-3.834a.375.375 0 01-.265-.64l1.272-1.273-5.76-5.76-1.273 1.272a.375.375 0 01-.64-.265V7a.5.5 0 01.5-.5z"/></svg>',
    dimensionsAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M16.86 12.901l-1.272 1.272-5.761-5.76 1.272-1.273a.375.375 0 00-.265-.64H7a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265l1.272-1.272 5.761 5.76-1.272 1.273a.375.375 0 00.265.64H17a.5.5 0 00.5-.5v-3.834a.375.375 0 00-.64-.265M18 2.501v1a.5.5 0 00.5.5H20v1.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5M18 21.5v-1a.5.5 0 01.5-.5H20v-1.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5M20.5 10h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5m-18 0h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5M6 2.5v1a.5.5 0 01-.5.5H4v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 19v-1a.5.5 0 00-.5-.5H4v-1.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5m8-19v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 18v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5"/></svg>',
    dimensionsAltColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M16.86 12.9l-1.272 1.273-5.761-5.76 1.272-1.273a.375.375 0 00-.265-.64H7a.5.5 0 00-.5.5v3.833c0 .334.404.502.64.266l1.272-1.273 5.761 5.761-1.272 1.272a.375.375 0 00.265.64H17a.5.5 0 00.5-.5v-3.833a.375.375 0 00-.64-.265"/><path fill="currentColor" d="M18 2.5v1a.5.5 0 00.5.5H20v1.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5m0 19v-1a.5.5 0 01.5-.5H20v-1.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5M20.5 10h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5m-18 0h1a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5M6 2.5v1a.5.5 0 01-.5.5H4v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 19v-1a.5.5 0 00-.5-.5H4v-1.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5m8-19v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5m0 18v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5" opacity=".35"/></g></svg>',
    dimensionsColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M4 20h16V4H4v16zm17.5 2h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19a.5.5 0 01-.5.5z" opacity=".35"/><path fill="currentColor" d="M16.86 12.9l-1.273 1.273-5.76-5.76 1.272-1.273a.375.375 0 00-.265-.64H7a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265l1.272-1.272 5.761 5.76-1.272 1.273a.375.375 0 00.265.64H17a.5.5 0 00.5-.5v-3.834a.375.375 0 00-.64-.265"/></g></svg>',
    gap: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M18.851 11.646l-2.711-2.71a.375.375 0 00-.64.265V11h-7V9.2a.375.375 0 00-.64-.265l-2.711 2.711a.5.5 0 000 .708l2.71 2.71c.237.237.641.07.641-.265V13h7v1.8c0 .333.404.5.64.264l2.711-2.71a.5.5 0 000-.708"/><path fill="currentColor" d="M21.5 18h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5m-18 0h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    gapVertical: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M14.8 15.5H13v-7h1.8a.375.375 0 00.265-.64l-2.711-2.711a.5.5 0 00-.707 0l-2.711 2.71A.375.375 0 009.2 8.5H11v7H9.2a.375.375 0 00-.265.64l2.71 2.711a.5.5 0 00.708 0l2.71-2.71a.375.375 0 00-.265-.641"/><path fill="currentColor" d="M17.5 4h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 18h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    height: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.8 15.5H13v-7h1.8a.375.375 0 00.264-.64l-2.71-2.711a.5.5 0 00-.708 0l-2.71 2.71A.375.375 0 009.2 8.5H11v7H9.2a.375.375 0 00-.265.64l2.711 2.711a.5.5 0 00.707 0l2.711-2.71a.375.375 0 00-.265-.641M17.5 4h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 18h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/></svg>',
    heightColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M14.8 15.5H13v-7h1.8a.375.375 0 00.265-.64l-2.711-2.711a.5.5 0 00-.707 0l-2.711 2.71A.375.375 0 009.2 8.5H11v7H9.2a.375.375 0 00-.265.64l2.71 2.711a.5.5 0 00.708 0l2.71-2.71a.375.375 0 00-.265-.641" opacity=".35"/><path fill="currentColor" d="M17.5 4h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 18h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/></g></svg>',
    margin: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5"/><path fill="currentColor" d="M4.5 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    marginAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.824 7.423l-2.55-2.458L7.599 3.64A.375.375 0 007.334 3H3.5a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265L4.86 6.38l2.577 2.483a.5.5 0 00.707-.013l.693-.72a.5.5 0 00-.013-.707M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5"/></svg>',
    marginColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M8.824 7.423l-2.55-2.458L7.599 3.64A.375.375 0 007.334 3H3.5a.5.5 0 00-.5.5v3.834c0 .334.404.501.64.265l1.22-1.22 2.576 2.484a.5.5 0 00.707-.013l.694-.72a.5.5 0 00-.013-.707"/><path fill="currentColor" d="M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    padding: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M11 21h-1a.5.5 0 01-.5-.5V10a.5.5 0 01.5-.5h10.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9v9a.5.5 0 01-.5.5" opacity=".35"/><path fill="currentColor" d="M4.5 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5"/></g></svg>',
    paddingAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M20.5 3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM7.847 7.14a.5.5 0 01.707-.013l2.577 2.484 1.22-1.22a.375.375 0 01.64.266v3.833a.5.5 0 01-.5.5H8.657a.375.375 0 01-.265-.64l1.325-1.325-2.55-2.458a.5.5 0 01-.014-.707z"/></svg>',
    paddingBlockEnd: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M16.5 17h-9a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v4a.5.5 0 01-.5.5"/><path fill="currentColor" d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingBlockStart: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M16.5 12h-9a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v4a.5.5 0 01-.5.5"/><path fill="currentColor" d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingBottom: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.002 3.5a.5.5 0 01.41-.492L3.503 3h17a.5.5 0 01.492.41l.008.09v17a.5.5 0 01-.41.492l-.09.008h-17a.5.5 0 01-.492-.41l-.008-.09zm2 2.502v7a1 1 0 00.884.993l.116.007h12a1 1 0 00.994-.883l.006-.117v-7a1 1 0 00-.883-.993l-.117-.007h-12a1 1 0 00-.993.884z" fill-rule="evenodd"/></svg>',
    paddingColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M12.35 8.391l-1.219 1.22-2.577-2.484a.5.5 0 00-.707.013l-.694.72a.5.5 0 00.013.707l2.55 2.458-1.325 1.325a.375.375 0 00.265.64h3.834a.5.5 0 00.5-.5V8.657a.375.375 0 00-.64-.266"/><path fill="currentColor" d="M4.5 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v15.5a.5.5 0 01-.5.5" opacity=".35"/></g></svg>',
    paddingInlineEnd: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M12 16.5v-9a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5"/><path fill="currentColor" d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingInlineStart: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M12 7.5v9a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h4a.5.5 0 01.5.5"/><path fill="currentColor" d="M5 19h14V5H5v14zm15.5 2h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    paddingLeft: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.502 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM18 5h-7a1 1 0 00-1 1v12a1 1 0 001 1h7a1 1 0 001-1V6a1 1 0 00-1-1z" fill-rule="evenodd"/></svg>',
    paddingRight: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.502 21a.5.5 0 01-.492-.41l-.008-.09v-17a.5.5 0 01.41-.492L3.503 3h17a.5.5 0 01.492.41l.008.09v17a.5.5 0 01-.41.492l-.09.008zm2.503-2h7a1 1 0 00.993-.884l.007-.116V6a1 1 0 00-.884-.993L13.005 5h-7a1 1 0 00-.994.883L5.005 6v12a1 1 0 00.883.993z" fill-rule="evenodd"/></svg>',
    paddingTop: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.002 20.5a.5.5 0 01-.41.492l-.09.008h-17a.5.5 0 01-.492-.41l-.008-.09v-17a.5.5 0 01.41-.492L3.502 3h17a.5.5 0 01.492.41l.008.09zm-2-2.502v-7a1 1 0 00-.883-.994l-.117-.006h-12a1 1 0 00-.993.883l-.007.117v7a1 1 0 00.884.993l.116.007h12a1 1 0 00.993-.884z" fill-rule="evenodd"/></svg>',
    proportion: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19zM20 4H4v16h16V4zM7.14 12.901l3.96 3.959a.375.375 0 01-.266.64H7a.5.5 0 01-.5-.5v-3.834c0-.334.404-.501.64-.265zM17 6.5a.5.5 0 01.5.5v3.834a.375.375 0 01-.64.265L12.9 7.14a.375.375 0 01.265-.64z"/></svg>',
    proportionAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19zM20 4H4v16h16V4zM7.5 13a.5.5 0 01.5.5V16h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h1zm10-7a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V8h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4z"/></svg>',
    proportionAltColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M7.14 12.9a.375.375 0 00-.64.266V17a.5.5 0 00.5.5h3.834a.375.375 0 00.265-.64L7.14 12.9zm9.72-1.801c.236.236.64.069.64-.265V7a.5.5 0 00-.5-.5h-3.834a.375.375 0 00-.265.64L16.86 11.1z"/><path fill="currentColor" d="M4 20h16V4H4v16zm17.5 2h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    proportionColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M17.5 11h-1a.5.5 0 01-.5-.5V8h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v4a.5.5 0 01-.5.5m-7 7h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V16h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path fill="currentColor" d="M4 20h16V4H4v16zm17.5 2h-19a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v19a.5.5 0 01-.5.5z" opacity=".5"/></g></svg>',
    round: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17 3.5v.94c-4.69.8-9.05 4.29-11.25 8.65V7.37c1.1-.35 1.87-1.42 1.73-2.66a2.517 2.517 0 00-2.19-2.2A2.51 2.51 0 002.5 5c0 1.12.74 2.05 1.75 2.37V17H3.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-.53C7 11.81 11.81 7 17 5.97v.53c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    roundEndEnd: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.236 12.639l-.055.081-.146.21c-.124.178-.253.353-.384.525l-.324.409c-2.38 2.923-5.758 5.09-9.327 5.698v.94c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.53c1.734-.344 3.426-1.11 4.949-2.172 3.033-2.117 5.395-5.404 6.081-8.86h-.53c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.94c-.305 1.785-.999 3.522-1.983 5.11l-.34.529z"/></svg>',
    roundEndStart: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.764 11.363l.055-.081.146-.21c.124-.178.253-.353.384-.525l.324-.409c2.38-2.923 5.758-5.09 9.327-5.698V3.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.53c-1.734.344-3.426 1.11-4.949 2.172-3.033 2.117-5.395 5.404-6.081 8.86h.53c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.94c.305-1.785.999-3.522 1.983-5.11l.34-.529z"/></svg>',
    roundStartEnd: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.638 6.765l.081.055.21.146c.178.124.353.253.525.384l.409.324c2.923 2.38 5.09 5.758 5.698 9.327h.94c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h.53c-.344-1.734-1.11-3.426-2.172-4.949-2.117-3.033-5.404-5.395-8.86-6.081v.53c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v.94c1.785.305 3.522.999 5.11 1.983l.529.34z"/></svg>',
    roundStartStart: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.362 17.237l-.081-.055-.21-.146a16.777 16.777 0 01-.525-.384l-.409-.324C7.214 13.948 5.047 10.57 4.439 7h-.94c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-.53c.344 1.734 1.11 3.426 2.172 4.949 2.117 3.033 5.404 5.395 8.86 6.081v-.53c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-.94c-1.785-.305-3.522-.999-5.11-1.983l-.529-.34z"/></svg>',
    sequence: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M19.2 12v2.4H0V12h19.2zM9.81 8v2.4H.01V8h9.8zM5.222 4v2.4H.011V4h5.21zm-3-4v2.4H.011V0h2.21z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.4 4.8)"><path fill="currentColor" d="M0 0h19.2v14.4H0V0z"/></g></svg>',
    sequenceAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M19.2 4v2.4H0V4h19.2zM8.421 0v2.4h-5.21V0h5.21zm-6.21 0v2.4H0V0h2.21zm17.01 0v2.4h-9.8V0h9.8z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.39 8.8)"><path fill="currentColor" d="M0 0h19.221v6.4H0V0z"/></g></svg>',
    sequenceColored: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M5.21 0v2H0V0h5.21z"/></clipPath><clipPath id="b"><path fill="currentColor" d="M2.21 0v2H0V0h2.21z"/></clipPath><clipPath id="c"><path fill="currentColor" d="M9.8 0v2H0V0h9.8z"/></clipPath><clipPath id="d"><path fill="currentColor" d="M19.2 0v2H0V0h19.2z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.41 8.8)"><path fill="currentColor" opacity="85%" d="M0 0h5.211v2H0V0z"/></g><g clip-path="url(#b)" transform="translate(2.41 4.8)"><path fill="currentColor" d="M0 0h2.211v2H0V0z"/></g><g clip-path="url(#c)" transform="translate(2.41 12.8)"><path fill="currentColor" opacity="70%" d="M0 0h9.8v2H0V0z"/></g><g clip-path="url(#d)" transform="translate(2.4 16.8)"><path fill="currentColor" opacity="55%" d="M0 0h19.2v2H0V0z"/></g></svg>',
    space: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13.29 5.25C6.88 5.25 2 10.05 1.76 16.5c-.01.27.2.5.47.5h1.53c.27 0 .49-.21.5-.47.22-5.04 4.03-8.78 9.03-8.78 3.68 0 6.46 2.3 6.46 5.34 0 1.8-1.29 3.15-3.01 3.16-.88 0-1.49-.52-1.49-1.25 0-.3.24-.75.75-.75h.21c.19 0 .35-.16.35-.35v-1.77a.38.38 0 00-.38-.38h-.11c-1.82 0-3.35 1.49-3.32 3.31.03 2.09 1.71 3.67 3.94 3.69h.08c3.08-.03 5.48-2.5 5.48-5.66 0-4.4-3.93-7.84-8.96-7.84z" fill-rule="evenodd"/></svg>',
    spaceOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.75 18.9h-.05c-2.06-.02-3.6-1.48-3.6-3.4 0-1.28 1-2.65 2.62-2.79.15-.01.28.1.28.25v1.21c0 .17-.11.32-.28.36-.56.13-.82.62-.82.97 0 .93.77 1.6 1.84 1.6 1.92-.01 3.36-1.51 3.36-3.51 0-3.25-2.93-5.69-6.81-5.69-5.23 0-9.21 3.94-9.39 9.23-.01.2-.17.37-.37.37H2.46c-.2 0-.36-.16-.35-.36C2.28 10.82 7.03 6.1 13.29 6.1c4.83 0 8.61 3.29 8.61 7.49 0 2.96-2.25 5.28-5.13 5.31h-.02z" fill-rule="evenodd"/></svg>',
    width: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.5 6a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1zm-18 0a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1zm12 3.2c0-.308.344-.474.583-.312l.057.047 2.711 2.711a.5.5 0 01.058.638l-.058.07-2.71 2.71a.375.375 0 01-.634-.19l-.007-.075V13h-7v1.8a.375.375 0 01-.583.312l-.057-.048-2.711-2.71a.5.5 0 01-.058-.638l.058-.07 2.71-2.71a.375.375 0 01.634.19l.007.075V11h7V9.2z"/></svg>',
    widthColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M18.851 11.646l-2.711-2.71a.375.375 0 00-.64.265V11h-7V9.2a.375.375 0 00-.64-.265l-2.711 2.711a.5.5 0 000 .708l2.71 2.71c.237.237.641.07.641-.265V13h7v1.8c0 .333.404.5.64.264l2.711-2.71a.5.5 0 000-.708" opacity=".35"/><path fill="currentColor" d="M21.5 18h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5m-18 0h-1a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v11a.5.5 0 01-.5.5"/></g></svg>',
    brightness: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.44 20a.5.5 0 01.5.5V22a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5v-1.5a.5.5 0 01.5-.5zm6.277-2.954l.962.962a.5.5 0 010 .707l-.962.961a.5.5 0 01-.707 0l-.961-.961a.5.5 0 010-.707l.961-.962a.5.5 0 01.707 0zm-12.732 0l.962.962a.5.5 0 010 .707l-.962.961a.5.5 0 01-.707 0l-.961-.961a.5.5 0 010-.707l.961-.962a.5.5 0 01.707 0zm6.013-11.044A6.006 6.006 0 0118 12a6.005 6.005 0 01-5.998 5.998c-3.31-.004-5.998-2.695-5.998-5.998a6.008 6.008 0 015.994-5.998zm0 2.5A3.504 3.504 0 008.505 12a3.504 3.504 0 003.495 3.498zm10.007 2.247a.5.5 0 01.5.5v1.504a.5.5 0 01-.5.5H20.5a.5.5 0 01-.5-.5V11.25a.5.5 0 01.5-.5zm-18.505 0a.5.5 0 01.5.5v1.504a.5.5 0 01-.5.5H1.995a.5.5 0 01-.5-.5V11.25a.5.5 0 01.5-.5zm15.217-6.427l.962.961a.5.5 0 010 .707l-.962.962a.5.5 0 01-.707 0l-.961-.962a.5.5 0 010-.707l.961-.961a.5.5 0 01.707 0zm-12.726 0l.961.961a.5.5 0 010 .707l-.961.962a.5.5 0 01-.707 0l-.962-.962a.5.5 0 010-.707l.962-.961a.5.5 0 01.707 0zM12.75 1.5a.5.5 0 01.5.5v1.5a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    columns: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M16 19.5v-15a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5zm-6 0v-15a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5zm-6 0v-15a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5z"/></svg>',
    columnsAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13 19.5v-15a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5zm-9 0v-15a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5z"/></svg>',
    columnsAltOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13 5v14h6V5h-6zM5 5v14h6V5H5zm16 15.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.492-.41L21 20.5z"/></svg>',
    columnsOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.5 4.5v15h4v-15h-4zm5.5 0v15h4v-15h-4zm5.5 0v15h4v-15h-4zm5.5 16v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.492-.41L21 20.5z"/></svg>',
    deviceBigScreen: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 16.5v-13a.5.5 0 00-.5-.5h-19a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H11v2H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13v-2h8.5a.5.5 0 00.5-.5" fill-rule="evenodd"/></svg>',
    deviceBigScreenHalfFill: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4 13h16V5H4zm18 3.5v-13a.5.5 0 00-.5-.5h-19a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H11v2H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13v-2h8.5a.5.5 0 00.5-.5z" fill-rule="evenodd"/></svg>',
    deviceBigScreenOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4 15h16V5H4zm18 1.5v-13a.5.5 0 00-.5-.5h-19a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H11v2H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13v-2h8.5a.5.5 0 00.5-.5z" fill-rule="evenodd"/></svg>',
    deviceMobile: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 19.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5M18 2H6a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-19A.5.5 0 0018 2" fill-rule="evenodd"/></svg>',
    deviceMobileHalfFill: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.5 18h9V4h-9zm4.5 3.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM18 2H6a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-19A.5.5 0 0018 2z" fill-rule="evenodd"/></svg>',
    deviceMobileOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-19A.5.5 0 016 2zm-1.5 2h-9v16h9zM12 15.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    // The End button of the shared call controls (VoiceControls); the workspace shell's drawing.
    phone: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/></svg>',
    deviceSmallScreen: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 18a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-1A.5.5 0 012 18zM20.5 4a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    deviceSmallScreenHalfFill: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5 15h14V6H5zm4 3h6v-1.5H9zm13 0h-1V4.5a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5V18H2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h20a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    deviceSmallScreenOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 18a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-1A.5.5 0 012 18zM20.5 4a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5zM19 6H5v8h14z" fill-rule="evenodd"/></svg>',
    deviceTabletLandscape: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6 13.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5M21.5 4h-19a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    deviceTabletLandscapeHalfFill: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6 18h14V6H6zm-2-4.75a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM21.5 4h-19a.5.5 0 00-.5.5v15a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-15a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    deviceTabletLandscapeOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.5 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zM20 6H4v12h16zM7 10.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    deviceTabletPortrait: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 19.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5M19.5 2h-15a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    deviceTabletPortraitHalfFill: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6 18h12V4H6zm6 3.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM19.5 2h-15a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    deviceTabletPortraitOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.5 2a.5.5 0 01.5.5v19a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5zM18 4H6v16h12zm-6 11.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" fill-rule="evenodd"/></svg>',
    displayPreferences: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H4v12h16v-3a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v4.5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm.506 4A6.5 6.5 0 0018 14.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5zm7.1-5a.5.5 0 01.487.382l.308 1.274c.284.12.547.276.79.46l1.262-.371a.5.5 0 01.574.23l.606 1.05a.5.5 0 01-.088.613l-.952.906c.019.15.032.301.032.456 0 .155-.013.306-.032.456l.952.907a.5.5 0 01.088.612l-.606 1.05a.5.5 0 01-.574.23l-1.263-.371c-.242.184-.505.34-.789.46l-.308 1.274a.5.5 0 01-.486.382h-1.214a.5.5 0 01-.486-.382l-.308-1.274a3.623 3.623 0 01-.79-.46l-1.262.371a.5.5 0 01-.574-.23l-.607-1.05a.5.5 0 01.088-.612l.953-.907A3.655 3.655 0 0114.375 8c0-.155.013-.306.032-.455l-.953-.907a.5.5 0 01-.088-.612l.607-1.051a.5.5 0 01.574-.23l1.262.371c.242-.184.506-.34.79-.46l.308-1.274A.5.5 0 0117.393 3zM18 5.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" fill-rule="evenodd"/></svg>',
    displayPreferencesOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H4v11.999h16v-3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm7.607-1a.5.5 0 01.486.381l.308 1.274c.284.12.547.276.79.46l1.262-.371a.5.5 0 01.574.23l.606 1.05a.5.5 0 01-.088.613l-.952.906c.019.15.032.301.032.456 0 .155-.013.306-.032.456l.952.907a.5.5 0 01.088.612l-.606 1.05a.5.5 0 01-.574.23l-1.263-.371c-.242.184-.505.34-.79.46l-.307 1.274a.5.5 0 01-.486.382h-1.214a.5.5 0 01-.486-.382l-.308-1.274a3.623 3.623 0 01-.79-.46l-1.262.371a.5.5 0 01-.574-.23l-.607-1.05a.5.5 0 01.088-.612l.953-.907a3.6 3.6 0 01-.032-.456c0-.155.013-.306.031-.455l-.952-.907a.5.5 0 01-.088-.612l.607-1.051a.5.5 0 01.574-.23l1.263.372c.241-.185.505-.341.789-.46l.308-1.275A.5.5 0 0117.393 3zM18 5.75a2.25 2.25 0 100 4.499 2.25 2.25 0 000-4.5z" fill-rule="evenodd"/></svg>',
    grid: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.5 16a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm-12-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm-12-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm6 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    gridAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.5 13a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm-9 0a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm9-9a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm-9 0a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    gridAltOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13 11h6V5h-6zm0 8h6v-6h-6zm-8 0h6v-6H5zm0-8h6V5H5zm15.5-8h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    gridOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.5 19.5h4v-4h-4zm-11 0h4v-4h-4zm0-11h4v-4h-4zm11 5.5h4v-4h-4zM10 8.5h4v-4h-4zM4.5 14h4v-4h-4zm5.5 5.5h4v-4h-4zm0-5.5h4v-4h-4zm5.5-5.5h4v-4h-4zm5-5.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    layout: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.5 15a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5zm9-4a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5zm-9-7a.5.5 0 01.5.5v8a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5zm9 0a.5.5 0 01.5.5v4a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    layoutOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15 19h6v-8h-6zM3 19h10v-4H3zm0-6h10V5H3zm12-4h6V5h-6zM1 3.5v17a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-21a.5.5 0 00-.5.5z" fill-rule="evenodd"/></svg>',
    list: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.355 16.078l1.569 1.568a.5.5 0 010 .708l-1.57 1.568a.5.5 0 01-.706 0l-1.569-1.568a.5.5 0 010-.708l1.569-1.568a.5.5 0 01.707 0zM21.5 16.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-13A.5.5 0 018 19v-2a.5.5 0 01.5-.5zM4.355 10.078l1.569 1.568a.5.5 0 010 .708l-1.57 1.568a.5.5 0 01-.706 0l-1.569-1.568a.5.5 0 010-.708l1.569-1.568a.5.5 0 01.707 0zM21.5 10.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-13A.5.5 0 018 13v-2a.5.5 0 01.5-.5zM4.355 4.075l1.569 1.568a.5.5 0 010 .708l-1.57 1.568a.5.5 0 01-.706 0L2.079 6.351a.5.5 0 010-.708l1.569-1.568a.5.5 0 01.707 0zM21.5 4.5a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-13A.5.5 0 018 7V5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    listOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.355 16.666l1.002 1.002a.5.5 0 010 .707l-1.002 1.003a.5.5 0 01-.707 0l-1.003-1.003a.5.5 0 010-.707l1.003-1.002a.5.5 0 01.707 0zM21.5 17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM4.355 10.653l1.002 1.003a.5.5 0 010 .707l-1.002 1.002a.5.5 0 01-.707 0l-1.003-1.002a.5.5 0 010-.707l1.003-1.003a.5.5 0 01.707 0zM21.5 11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM4.355 4.64l1.002 1.003a.5.5 0 010 .707L4.355 7.353a.5.5 0 01-.707 0L2.645 6.35a.5.5 0 010-.707l1.003-1.002a.5.5 0 01.707 0zM21.5 5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    moon: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.875 3.568a.5.5 0 01.622.693 7.643 7.643 0 0010.242 10.243c.405-.202.852.191.696.616a8.994 8.994 0 01-15.221 2.781c-2.972-3.403-2.92-8.583.114-11.931a8.963 8.963 0 013.547-2.402zm7.822 1.556a.428.428 0 01.606 0l1.573 1.573a.427.427 0 010 .605l-1.573 1.574a.428.428 0 01-.606 0l-1.573-1.574a.428.428 0 010-.605z" fill-rule="evenodd"/></svg>',
    moonOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9.053 3.535c.35 0 .617.376.444.726a7.644 7.644 0 0010.242 10.243.5.5 0 01.696.616 8.95 8.95 0 01-2.076 3.239A8.965 8.965 0 0112 20.993 8.972 8.972 0 015.214 17.9c-2.972-3.403-2.92-8.583.115-11.931a8.96 8.96 0 013.546-2.402.51.51 0 01.178-.033zM6.702 7.436c-2.23 2.586-2.233 6.572.018 9.15A7.012 7.012 0 0012 18.993a6.94 6.94 0 004.568-1.698 9.576 9.576 0 01-7.042-2.82 9.634 9.634 0 01-2.824-7.039zm9.996-2.312a.428.428 0 01.605 0l1.573 1.573a.427.427 0 010 .605l-1.573 1.574a.428.428 0 01-.605 0l-1.574-1.574a.428.428 0 010-.605z" fill-rule="evenodd"/></svg>',
    print: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17 16v5.5a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5V16zm2-9a3 3 0 013 3v7.5a.5.5 0 01-.5.5H19v-4H5v4H2.5a.5.5 0 01-.5-.5V10a3 3 0 013-3zm-.646 2.229a.5.5 0 00-.708 0l-.917.917a.5.5 0 000 .707l.917.918a.5.5 0 00.708 0l.917-.918a.5.5 0 000-.707zM17.5 2a.5.5 0 01.5.5V5H6V2.5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    printOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.5 2a.5.5 0 01.5.5V7h1c1.654 0 3 1.346 3 3v8h-4v3.5a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5V18H2v-8c0-1.654 1.346-3 3-3h1V2.5a.5.5 0 01.5-.5zM16 16H8v4h8zm3-7H5c-.551 0-1 .449-1 1v6h2v-1.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5V16h2v-6c0-.551-.448-1-1-1zm-2.354 1.506a.5.5 0 01.707 0l.641.64a.5.5 0 010 .707l-.64.641a.5.5 0 01-.708 0l-.64-.64a.5.5 0 010-.708zM16 4H8v3h8z" fill-rule="evenodd"/></svg>',
    rows: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.5 16a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm0-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm0-6a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    rowsAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.5 13a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm0-9a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    rowsAltOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5 11h14V5H5zm0 8h14v-6H5zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    rowsOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.5 19.5h15v-4h-15zm0-5.5h15v-4h-15zm0-5.5h15v-4h-15zm16-5.5h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    sun: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.491 19.864c.272 0 .492.22.492.491v1.966c0 .271-.22.491-.492.491h-.982a.492.492 0 01-.492-.491v-1.966c0-.271.22-.491.492-.491zm-7.094-1.956l.695.695a.492.492 0 010 .695l-.695.695a.491.491 0 01-.695 0l-.695-.695a.491.491 0 010-.695l.695-.695a.491.491 0 01.695 0zm13.901 0l.695.695a.49.49 0 010 .695l-.695.695a.492.492 0 01-.695 0l-.695-.695a.491.491 0 010-.695l.695-.695a.491.491 0 01.695 0zM12 7.085A4.92 4.92 0 0116.915 12 4.92 4.92 0 0112 16.915 4.92 4.92 0 017.085 12 4.92 4.92 0 0112 7.085zm-8.355 3.932c.271 0 .491.22.491.492v.982c0 .272-.22.492-.491.492H1.679a.492.492 0 01-.492-.492v-.982c0-.272.22-.492.492-.492zm18.676 0c.271 0 .491.22.491.492v.982c0 .272-.22.492-.491.492h-1.966a.492.492 0 01-.491-.492v-.982c0-.272.22-.492.491-.492zM5.397 4.007l.695.695a.491.491 0 010 .695l-.695.695a.491.491 0 01-.695 0l-.695-.695a.49.49 0 010-.695l.695-.695a.492.492 0 01.695 0zm13.901 0l.695.695a.491.491 0 010 .695l-.695.695a.491.491 0 01-.695 0l-.695-.695a.492.492 0 010-.695l.695-.695a.491.491 0 01.695 0zm-6.807-2.82c.272 0 .492.22.492.492v1.966c0 .271-.22.491-.492.491h-.982a.492.492 0 01-.492-.491V1.679c0-.271.22-.491.492-.491z" fill-rule="evenodd"/></svg>',
    sunOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.455 19.273c.25 0 .454.203.454.454v1.818c0 .251-.204.455-.454.455h-.91a.455.455 0 01-.454-.455v-1.818c0-.25.204-.454.454-.454zm-6.562-1.809l.643.643a.454.454 0 010 .643l-.643.642a.454.454 0 01-.643 0l-.643-.642a.454.454 0 010-.643l.643-.643a.454.454 0 01.643 0zm12.857 0l.643.643a.454.454 0 010 .643l-.643.643a.455.455 0 01-.643 0l-.643-.643a.454.454 0 010-.643l.643-.643a.455.455 0 01.643 0zM12 7.454A4.55 4.55 0 0116.546 12 4.55 4.55 0 0112 16.545 4.55 4.55 0 017.455 12 4.55 4.55 0 0112 7.455zm0 1.819A2.73 2.73 0 009.273 12 2.73 2.73 0 0012 14.727 2.73 2.73 0 0014.727 12 2.73 2.73 0 0012 9.273zM4.273 11.09c.25 0 .454.204.454.454v.91c0 .25-.203.454-.454.454H2.455A.455.455 0 012 12.455v-.91c0-.25.204-.454.455-.454zm17.272 0c.251 0 .455.204.455.454v.91c0 .25-.204.454-.455.454h-1.818a.455.455 0 01-.454-.454v-.91c0-.25.203-.454.454-.454zM5.893 4.607l.643.643a.454.454 0 010 .643l-.643.643a.454.454 0 01-.643 0l-.642-.643a.454.454 0 010-.643l.642-.643a.455.455 0 01.643 0zm12.857 0l.643.643a.454.454 0 010 .643l-.643.643a.455.455 0 01-.643 0l-.643-.643a.454.454 0 010-.643l.643-.643a.455.455 0 01.643 0zM12.455 2c.25 0 .454.204.454.455v1.818c0 .25-.204.454-.454.454h-.91a.455.455 0 01-.454-.454V2.455c0-.251.204-.455.454-.455z" fill-rule="evenodd"/></svg>',
    zoomIn: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.065 11.038c-.658-5.22 3.746-9.628 8.963-8.973 3.545.445 6.398 3.266 6.892 6.805a7.957 7.957 0 01-1.566 5.974l5.49 5.492a.533.533 0 010 .754l-.754.754a.533.533 0 01-.753 0l-5.489-5.49a7.95 7.95 0 01-5.973 1.574c-3.54-.49-6.363-3.343-6.81-6.89zM10 4.133a5.876 5.876 0 00-5.867 5.87 5.876 5.876 0 005.867 5.87 5.876 5.876 0 005.868-5.87 5.876 5.876 0 00-5.868-5.87zm.4 2.666c.294 0 .533.24.533.533v1.733h1.732c.295 0 .533.24.533.534v.8a.533.533 0 01-.533.533h-1.732v1.733a.533.533 0 01-.533.533h-.8a.533.533 0 01-.532-.533v-1.733H7.334a.533.533 0 01-.533-.533v-.8c0-.295.239-.534.533-.534h1.733V7.332c0-.294.238-.533.533-.533z" fill-rule="evenodd"/></svg>',
    zoomOut: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.065 11.038c-.658-5.22 3.747-9.628 8.963-8.973 3.545.445 6.398 3.266 6.892 6.805a7.959 7.959 0 01-1.566 5.974l5.49 5.492a.533.533 0 010 .754l-.754.754a.534.534 0 01-.754 0l-5.488-5.49a7.95 7.95 0 01-5.973 1.574c-3.54-.49-6.362-3.343-6.81-6.89zM10 4.133a5.875 5.875 0 00-5.868 5.87A5.875 5.875 0 0010 15.873a5.876 5.876 0 005.867-5.87A5.876 5.876 0 0010 4.133zm2.665 4.932c.294 0 .533.24.533.534v.8a.533.533 0 01-.533.533h-5.33a.533.533 0 01-.534-.533v-.8c0-.295.24-.534.533-.534z" fill-rule="evenodd"/></svg>',
    zoomReset: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.065 11.038c-.658-5.22 3.747-9.628 8.963-8.973 3.545.445 6.398 3.266 6.892 6.805a7.959 7.959 0 01-1.566 5.974l5.49 5.492a.533.533 0 010 .754l-.754.754a.533.533 0 01-.753 0l-5.489-5.49a7.95 7.95 0 01-5.973 1.574c-3.54-.49-6.362-3.343-6.81-6.89zM10 4.133a5.876 5.876 0 00-5.868 5.87A5.876 5.876 0 0010 15.873a5.876 5.876 0 005.867-5.87A5.876 5.876 0 0010 4.133zm1.225 3.32a.533.533 0 01.753 0l.566.566a.534.534 0 010 .754l-3.77 3.77a.533.533 0 01-.753 0l-.566-.565a.534.534 0 010-.754z" fill-rule="evenodd"/></svg>',
    choose: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M10.5 7a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm11.998 0a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm-1.547 2.423a.5.5 0 00-.707.001l-3.271 3.281-1.217-1.216a.5.5 0 00-.707 0l-.703.703a.5.5 0 000 .707l2.282 2.281a.5.5 0 00.708 0l4.32-4.347a.5.5 0 00-.001-.706z" fill-rule="evenodd"/></svg>',
    chooseOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M10.5 7a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm11.998 0a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm-1.546 2.424a.5.5 0 00-.708 0l-3.271 3.281-1.217-1.216a.5.5 0 00-.707 0l-.703.703a.5.5 0 000 .707l2.282 2.282a.5.5 0 00.708-.001l4.32-4.347a.5.5 0 00-.001-.706zM9 9H3v6h6z" fill-rule="evenodd"/></svg>',
    click: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.038 5c.82.025 1.453.741 1.453 1.562V12h.762c.158 0 .314.037.455.11l4.722 2.412a1.5 1.5 0 01.806 1.522l-.58 4.639a1.5 1.5 0 01-1.481 1.314l-2.531.014.014.013h-4.115a3.56 3.56 0 01-2.979-1.612L5.12 16.688a.892.892 0 01.253-1.233 2.625 2.625 0 012.005-.376c.61.133 1.14.507 1.517 1.004l.598.616v-10.2a1.5 1.5 0 011.545-1.498zm-.046-3c2.481 0 4.5 2.018 4.5 4.5 0 1.556-.796 2.93-2 3.738V6.499c0-1.378-1.122-2.499-2.5-2.499a2.502 2.502 0 00-2.499 2.5h-.002v3.737a4.498 4.498 0 01-1.998-3.738C6.493 4.02 8.511 2 10.993 2z" fill-rule="evenodd"/></svg>',
    clickOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.577 20.557a.502.502 0 01-.496.439l-2.53.015-1.219.015h-2.876a2.561 2.561 0 01-2.144-1.161l-2.381-3.633c.348-.2.917-.304 1.316-.217.348.075.566.3.9.547L10.09 18h.317V6.998c0-.267.104-.518.293-.707a1 1 0 011.705.706v5.616l5.483 2.797a.506.506 0 01.27.51zM7.279 7a4.13 4.13 0 014.125-4.125A4.13 4.13 0 0115.53 7a4.124 4.124 0 01-1.125 2.829V6.998a3.003 3.003 0 00-2.997-2.999h-.002c-.8 0-1.553.312-2.12.878a2.979 2.979 0 00-.879 2.121v2.835A4.118 4.118 0 017.28 7zm11.52 6.63l-3.837-1.957A5.874 5.874 0 0017.28 7a5.882 5.882 0 00-5.875-5.875A5.882 5.882 0 005.53 7a5.864 5.864 0 002.877 5.052v2.387a3.337 3.337 0 00-.9-.335 3.626 3.626 0 00-2.77.516 1.891 1.891 0 00-.538 2.616l2.443 3.726a4.554 4.554 0 003.815 2.064h4.116l2.427-.015-.015-.015h.106a2.507 2.507 0 002.471-2.189l.58-4.64v-.001a2.514 2.514 0 00-1.343-2.536z" fill-rule="evenodd"/></svg>',
    cursor: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.345 13a.5.5 0 00.317-.886l-10.845-8.9A.5.5 0 006 3.6v14.026c0 .47.59.68.887.317l3.352-4.1 3.43 7.256a.5.5 0 00.666.238l.905-.428a.5.5 0 00.238-.666L12.048 13z" fill-rule="evenodd"/></svg>',
    cursorOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.821 19.952l2.064-1.014-2.757-5.616 4.376-.867L5.7 4.885l.002 12.386 3.362-2.935zm3.89-.017l-4.217 2.072a.5.5 0 01-.67-.228l-2.31-4.706-3.683 3.214a.5.5 0 01-.83-.376V2.442a.5.5 0 01.805-.395l13.826 10.676a.5.5 0 01-.208.886l-4.795.95 2.311 4.707a.5.5 0 01-.228.669z" fill-rule="evenodd"/></svg>',
    cursorPointer: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.5 14.063a5.443 5.443 0 01-5.437 5.437 5.402 5.402 0 01-3.845-1.592l-3.702-3.703a2.735 2.735 0 013.221.395L9 15.784V5a.5.5 0 011 0V12h1.5V8.999a.5.5 0 011 0V12H14V9.999a.5.5 0 011 0V12h1.5v-1.001a.5.5 0 011 0zM17 8.999c-.247 0-.483.047-.702.13a1.987 1.987 0 00-2.5-1A2 2 0 0012 6.998a2 2 0 00-.5.065V5c0-1.103-.897-2-2-2s-2 .897-2 2v7.684a4.23 4.23 0 00-4.648.92l-.53.53 4.836 4.835A6.892 6.892 0 0012.063 21 6.945 6.945 0 0019 14.063v-3.064c0-1.103-.897-2-2-2z" fill-rule="evenodd"/></svg>',
    drag: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.646 12.354l-2.22 2.22a.25.25 0 01-.426-.177v-1.646h-4.25V17h1.646a.25.25 0 01.177.427l-2.22 2.22a.5.5 0 01-.707 0l-2.22-2.22A.25.25 0 019.604 17h1.647v-4.25H7v1.646a.25.25 0 01-.427.177l-2.22-2.22a.5.5 0 010-.707l2.22-2.22A.25.25 0 017 9.605v1.647h4.25V7H9.603a.25.25 0 01-.176-.427l2.22-2.22a.5.5 0 01.706 0l2.22 2.22a.25.25 0 01-.177.427H12.75v4.25H17V9.604a.25.25 0 01.427-.176l2.22 2.22a.5.5 0 010 .706M3 3.501v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5" fill-rule="evenodd"/></svg>',
    dragOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.647 11.647L17.89 8.89a.25.25 0 00-.426.177v2.182H12.75V6.536h2.182a.25.25 0 00.177-.427l-2.755-2.755a.5.5 0 00-.707 0L8.89 6.109a.25.25 0 00.177.427h2.182v4.714H6.536V9.068a.25.25 0 00-.427-.177l-2.755 2.756a.5.5 0 000 .707l2.755 2.755a.25.25 0 00.427-.177V12.75h4.714v4.715H9.068a.25.25 0 00-.177.426l2.756 2.756a.5.5 0 00.707 0l2.755-2.756a.25.25 0 00-.177-.426H12.75V12.75h4.715v2.182c0 .223.269.334.426.177l2.756-2.755a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    focus: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M1.5 15a.5.5 0 01.5.5V19h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm22 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H22v-3.5a.5.5 0 01.5-.5zM16 7c2.757 0 5 2.243 5 5s-2.243 5-5 5H8c-2.757 0-5-2.243-5-5s2.243-5 5-5zM5.5 3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5A.5.5 0 01.5 3zm18 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V5h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    focusOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M1.5 15a.5.5 0 01.5.5V19h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zm22 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H22v-3.5a.5.5 0 01.5-.5zM16 7c2.757 0 5 2.243 5 5s-2.243 5-5 5H8c-2.757 0-5-2.243-5-5s2.243-5 5-5zm0 2H8c-1.654 0-3 1.346-3 3s1.346 3 3 3h8c1.655 0 3-1.346 3-3s-1.345-3-3-3zM5.5 3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5A.5.5 0 01.5 3zm18 0a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V5h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    hover: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.822 6.993l-5.045 1.633a.997.997 0 00-.399.245l-.538.538-3.845-3.845c-.58-.58-1.534-.64-2.132-.076A1.5 1.5 0 003.83 7.64l7.213 7.212-.86-.013c-.617-.084-1.256.026-1.78.363a2.626 2.626 0 00-1.153 1.683c-.099.48.213.95.693 1.051l4.361.905a3.562 3.562 0 003.247-.966l1.05-1.049.019-.02 1.84-1.84h-.02l1.78-1.8a1.5 1.5 0 00.118-1.975l-2.87-3.692a1.5 1.5 0 00-1.646-.506" fill-rule="evenodd"/></svg>',
    hoverOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.154 17.306l4.253.885a2.562 2.562 0 002.337-.695l2.033-2.033.851-.872 1.779-1.8a.502.502 0 00.04-.661L16.58 8.44a.506.506 0 00-.552-.17l-5.854 1.899L6.202 6.2a1 1 0 00-1.412-.001.993.993 0 00-.293.706c0 .267.104.518.292.707l7.78 7.78-.224.224-2.39.356c-.411.061-.724.057-1.023.25-.345.221-.673.697-.778 1.084zM19.068 16l-2.91 2.91a4.555 4.555 0 01-4.157 1.24l-4.362-.908a1.891 1.891 0 01-1.47-2.23 3.627 3.627 0 011.595-2.324 3.33 3.33 0 01.873-.4L3.375 9.026a2.98 2.98 0 01-.878-2.121 2.98 2.98 0 01.88-2.121 3.003 3.003 0 014.24.001L10.72 7.89l4.692-1.522c.998-.32 2.1.02 2.743.844v.001l2.871 3.691a2.507 2.507 0 01-.2 3.295l-.074.076h.02z" fill-rule="evenodd"/></svg>',
    input: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.502 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H2.498a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H3.998v12h16.004zM17.5 8a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5zm-8 1H8a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h.5v4a.5.5 0 00.5.5h.5a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5zm3.213 4.428a.5.5 0 00-.707 0l-.36.36a.5.5 0 000 .707l.36.36a.5.5 0 00.707 0l.36-.36a.5.5 0 000-.707zm3.25 0a.5.5 0 00-.707 0l-.36.36a.5.5 0 000 .707l.36.36a.5.5 0 00.707 0l.36-.36a.5.5 0 000-.707z" fill-rule="evenodd"/></svg>',
    inputOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.502 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H2.498a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H3.998v12h16.004zM9.5 9a.5.5 0 01.5.5v5a.5.5 0 01-.5.5H9a.5.5 0 01-.5-.5v-4H8a.5.5 0 01-.5-.5v-.5A.5.5 0 018 9zm3.213 4.428l.36.359a.5.5 0 010 .707l-.36.36a.5.5 0 01-.707 0l-.36-.36a.5.5 0 010-.707l.36-.36a.5.5 0 01.707 0zm3.25 0l.36.359a.5.5 0 010 .707l-.36.36a.5.5 0 01-.707 0l-.36-.36a.5.5 0 010-.707l.36-.36a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    keyboard: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.312 5.187a.5.5 0 01.5.5v12.625a.5.5 0 01-.5.5H2.687a.5.5 0 01-.5-.5V5.687a.5.5 0 01.5-.5zm-1.125 1.625H3.812v10.375h16.375zm-4.688 7.44a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25H8.502a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3-3a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm-12 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3-3a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm-12 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25zm3 0a.25.25 0 01.25.25v.997a.25.25 0 01-.25.25h-.997a.25.25 0 01-.25-.25v-.997a.25.25 0 01.25-.25z" fill-rule="evenodd"/></svg>',
    mouse: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2c3.86 0 7 3.14 7 7v6c0 3.86-3.14 7-7 7s-7-3.14-7-7V9c0-3.86 3.14-7 7-7zm0 2C9.243 4 7 6.243 7 9v6c0 2.757 2.243 5 5 5s5-2.243 5-5V9c0-2.757-2.243-5-5-5zm.5 4a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    notAllowed: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15 8c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm-4.169 4.246a4.968 4.968 0 00-.83 2.754c0 2.757 2.242 5 4.999 5a4.97 4.97 0 002.754-.83zM15 10a4.97 4.97 0 00-2.755.832l6.923 6.923c.525-.79.832-1.737.832-2.755 0-2.757-2.243-5-5-5zM2.003 2.542c0-.403.476-.617.778-.35l6.38 5.65c.329.292.11.836-.33.818l-3.675-.15-2.323 2.85a.468.468 0 01-.83-.296z"/></svg>',
    selection: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 17a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H19v-1.5a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5V19h1.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm9 2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm7-9a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm16-7a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V5h-1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-14 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v1.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5zm7 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    selectionAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.5 19a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm16-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm16-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm16-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-16 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm12-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    switching: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5M17 6H7a6 6 0 100 12h10a6 6 0 100-12" fill-rule="evenodd"/></svg>',
    switchingOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17 5c3.86 0 7 3.14 7 7s-3.14 7-7 7H7c-3.86 0-7-3.14-7-7s3.14-7 7-7zm0 2H7c-2.757 0-5 2.243-5 5s2.243 5 5 5h10c2.757 0 5-2.243 5-5s-2.243-5-5-5zm0 2a3 3 0 110 6 3 3 0 010-6z" fill-rule="evenodd"/></svg>',
    switchingOutlineOff: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17 5c3.86 0 7 3.14 7 7s-3.14 7-7 7H7c-3.86 0-7-3.14-7-7s3.14-7 7-7zm0 2H7c-2.757 0-5 2.243-5 5s2.243 5 5 5h10c2.757 0 5-2.243 5-5s-2.243-5-5-5zm-10 2a3 3 0 110 6 3 3 0 010-6z" fill-rule="evenodd"/></svg>',
    angular: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.629 18h-1.363a.5.5 0 01-.46-.303l-.99-2.309H9.184l-.99 2.31a.5.5 0 01-.46.302H6.379a.25.25 0 01-.23-.349l5.625-13.115a.25.25 0 01.46 0l5.624 13.115a.25.25 0 01-.23.349M21.13 5.363l-8.784-3.236a1 1 0 00-.692 0L2.871 5.363a.5.5 0 00-.324.53l1.405 11.706a.75.75 0 00.41.582l7.19 3.595a1 1 0 00.894 0l7.193-3.593a.75.75 0 00.41-.581l1.404-11.71a.5.5 0 00-.324-.529M9.934 13.64h4.132L12 8.822l-2.066 4.817z"/></svg>',
    discord: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.277 5.326a17.323 17.323 0 00-4.274-1.325.065.065 0 00-.069.033c-.184.328-.389.756-.532 1.092a15.994 15.994 0 00-4.801 0 11.057 11.057 0 00-.54-1.092A.067.067 0 008.99 4c-1.5.258-2.934.71-4.274 1.325a.061.061 0 00-.028.024c-2.722 4.066-3.468 8.032-3.102 11.948.001.02.012.038.027.05a17.417 17.417 0 005.244 2.65.068.068 0 00.074-.025 12.44 12.44 0 001.072-1.744.066.066 0 00-.036-.093 11.47 11.47 0 01-1.638-.78.067.067 0 01-.007-.112c.11-.082.22-.168.325-.255a.065.065 0 01.068-.009c3.437 1.569 7.158 1.569 10.554 0a.065.065 0 01.069.008c.105.087.215.174.326.256a.067.067 0 01-.006.112c-.523.305-1.067.564-1.639.78a.067.067 0 00-.035.093c.315.61.675 1.192 1.072 1.743a.067.067 0 00.073.025 17.36 17.36 0 005.252-2.65.067.067 0 00.028-.048c.437-4.528-.734-8.461-3.105-11.948a.053.053 0 00-.028-.025zm-10.76 9.588c-1.034 0-1.887-.95-1.887-2.116 0-1.166.836-2.116 1.888-2.116 1.059 0 1.903.958 1.887 2.116 0 1.166-.836 2.116-1.887 2.116zm6.978 0c-1.034 0-1.887-.95-1.887-2.116 0-1.166.836-2.116 1.887-2.116 1.06 0 1.904.958 1.888 2.116 0 1.166-.828 2.116-1.888 2.116z"/></svg>',
    domql: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M30 17.147c-7.276 1.661-12.936.896-16.98-2.295.318-.213.634-.433.952-.659l.909-.655c.317-.227.628-.445.931-.655 4.585 3.642 8.39 4.158 14.188 4.264zm-17.057-6.143C19.47 6.437 25 4.984 29.524 6.696l.476.18c-6.334-.852-10.24.72-16.539 5.126l-.898.635C6.04 17.187.012 18.85-5.509 17.595L-6 17.483c5.3.791 12.002-1.512 18.507-6.17zm-1.566-1.896l-.355.25a41.27 41.27 0 01-2.49 1.605C4.452 7.94.897 7.313-6 6.317c7.525-.873 13.317.057 17.377 2.79z"/></svg>',
    elm: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.995 12.605L20.39 21H3.6l8.395-8.395zM3 3.61l8.395 8.395L3 20.4V3.61zm17.99 8.995V20.4l-3.898-3.897 3.898-3.898zm-4.498-4.498l3.898 3.898-3.898 3.898-3.897-3.898 3.897-3.898zm-.6-.6l-3.897 3.898-3.898-3.897h7.796zM21 3v8.396L12.604 3H21zm-9.605.01l3.658 3.658H7.258L3.6 3.01h7.795z"/></svg>',
    figma: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15.583 7.667H12.75V2h2.833a2.833 2.833 0 010 5.667m-4.333 0H8.417a2.833 2.833 0 110-5.667h2.833v5.667zm4.333 7.167a2.833 2.833 0 110-5.667 2.833 2.833 0 010 5.667m-4.333 0H8.417a2.833 2.833 0 110-5.667h2.833v5.667zM8.417 22a2.833 2.833 0 010-5.666h2.833v2.833A2.833 2.833 0 018.417 22"/></svg>',
    github: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.293 2.025c-4.957.341-8.962 4.375-9.27 9.334A10.004 10.004 0 008.67 21.43a.25.25 0 00.33-.238V19.5h-.375c-2.25 0-2.098-3-3.25-3H5.25a.25.25 0 110-.5h.625c1.03 0 1.5 2 2.5 2H9c0-.82.33-1.56.861-2.102C7.604 15.238 6 13.563 6 11.6c0-1.042.452-2.002 1.214-2.773a4.971 4.971 0 01-.123-2.378.5.5 0 01.565-.398c.911.146 1.78.543 2.495 1.172A7.682 7.682 0 0112 7c.645 0 1.267.079 1.849.223a4.963 4.963 0 012.495-1.172.5.5 0 01.565.398c.15.782.113 1.599-.122 2.378C17.548 9.598 18 10.558 18 11.6c0 1.963-1.604 3.637-3.861 4.298.532.541.861 1.283.861 2.102v3.194a.25.25 0 00.33.238c3.886-1.371 6.672-5.076 6.672-9.432 0-5.758-4.866-10.378-10.709-9.975"/></svg>',
    githubOutline: '<svg height="16" width="16" viewBox="0 0 16 16"><path fill="currentColor" d="M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 1.2A6.79 6.79 0 0114.8 8a6.79 6.79 0 01-4.8 6.5v-2.045c0-.764-.44-1.42-1.077-1.746 1.256-.24 2.289-.95 2.775-1.906s.366-2.042-.323-2.915c.177-.546.376-1.504-.095-2.258-.908 0-1.494.623-1.774 1.01a4.882 4.882 0 00-3.014-.003C6.212 4.25 5.626 3.63 4.72 3.63c-.54.866-.206 1.796-.027 2.175-.736.87-.892 1.973-.417 2.952.475.98 1.52 1.71 2.797 1.955-.523.269-.914.758-1.034 1.35h-.526c-.519 0-.72-.21-1-.566-.277-.356-.575-.594-.933-.694-.192-.02-.322.127-.154.257.567.386.607 1.018.834 1.432.207.373.632.709 1.112.709H6v1.3A6.79 6.79 0 011.2 8 6.79 6.79 0 018 1.2z" fill-rule="evenodd"/></svg>',
    // ── brand marks (third-party trademarks; simple-icons canonical single-path
    // renditions, MIT-licensed lookup/build tooling — simple-icons.org). Each
    // vendor's own simplified mark at native square proportions, sized to the
    // house icon grid — NOT restyled beyond currentColor + 24×24, per
    // tickets/fable.md "commission ~12 real brand-mark SVGs" (Nika, 2026-08-12).
    // Call sites: shared/components/IntegrationsInInsert.js,
    // marketplace/pages/installable-rail-demo.js. ──
    auth0: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.98 7.448L19.62 0H4.347L2.02 7.448c-1.352 4.312.03 9.206 3.815 12.015L12.007 24l6.157-4.552c3.755-2.81 5.182-7.688 3.815-12.015l-6.16 4.58 2.343 7.45-6.157-4.597-6.158 4.58 2.358-7.433-6.188-4.55 7.63-.045L12.008 0l2.356 7.404 7.615.044z"/></svg>',
    firebase: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.455 8.369c-.538-.748-1.778-2.285-3.681-4.569-.826-.991-1.535-1.832-1.884-2.245a146 146 0 0 0-.488-.576l-.207-.245-.113-.133-.022-.032-.01-.005L12.57 0l-.609.488c-1.555 1.246-2.828 2.851-3.681 4.64-.523 1.064-.864 2.105-1.043 3.176-.047.241-.088.489-.121.738-.209-.017-.421-.028-.632-.033-.018-.001-.035-.002-.059-.003a7.46 7.46 0 0 0-2.28.274l-.317.089-.163.286c-.765 1.342-1.198 2.869-1.252 4.416-.07 2.01.477 3.954 1.583 5.625 1.082 1.633 2.61 2.882 4.42 3.611l.236.095.071.025.003-.001a9.59 9.59 0 0 0 2.941.568q.171.006.342.006c1.273 0 2.513-.249 3.69-.742l.008.004.313-.145a9.63 9.63 0 0 0 3.927-3.335c1.01-1.49 1.577-3.234 1.641-5.042.075-2.161-.643-4.304-2.133-6.371m-7.083 6.695c.328 1.244.264 2.44-.191 3.558-1.135-1.12-1.967-2.352-2.475-3.665-.543-1.404-.87-2.74-.974-3.975.48.157.922.366 1.315.622 1.132.737 1.914 1.902 2.325 3.461zm.207 6.022c.482.368.99.712 1.513 1.028-.771.21-1.565.302-2.369.273a8 8 0 0 1-.373-.022c.458-.394.869-.823 1.228-1.279zm1.347-6.431c-.516-1.957-1.527-3.437-3.002-4.398-.647-.421-1.385-.741-2.194-.95.011-.134.026-.268.043-.4.014-.113.03-.216.046-.313.133-.689.332-1.37.589-2.025.099-.25.206-.499.321-.74l.004-.008c.177-.358.376-.719.61-1.105l.092-.152-.003-.001c.544-.851 1.197-1.627 1.942-2.311l.288.341c.672.796 1.304 1.548 1.878 2.237 1.291 1.549 2.966 3.583 3.612 4.48 1.277 1.771 1.893 3.579 1.83 5.375-.049 1.395-.461 2.755-1.195 3.933-.694 1.116-1.661 2.05-2.8 2.708-.636-.318-1.559-.839-2.539-1.599.79-1.575.952-3.28.479-5.072zm-2.575 5.397c-.725.939-1.587 1.55-2.09 1.856-.081-.029-.163-.06-.243-.093l-.065-.026c-1.49-.616-2.747-1.656-3.635-3.01-.907-1.384-1.356-2.993-1.298-4.653.041-1.19.338-2.327.882-3.379.316-.07.638-.114.96-.131l.084-.002c.162-.003.324-.003.478 0 .227.011.454.035.677.07.073 1.513.445 3.145 1.105 4.852.637 1.644 1.694 3.162 3.144 4.515z"/></svg>',
    googleAnalytics: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22.84 2.9982v17.9987c.0086 1.6473-1.3197 2.9897-2.967 2.9984a2.9808 2.9808 0 01-.3677-.0208c-1.528-.226-2.6477-1.5558-2.6105-3.1V3.1204c-.0369-1.5458 1.0856-2.8762 2.6157-3.1 1.6361-.1915 3.1178.9796 3.3093 2.6158.014.1201.0208.241.0202.3619zM4.1326 18.0548c-1.6417 0-2.9726 1.331-2.9726 2.9726C1.16 22.6691 2.4909 24 4.1326 24s2.9726-1.3309 2.9726-2.9726-1.331-2.9726-2.9726-2.9726zm7.8728-9.0098c-.0171 0-.0342 0-.0513.0003-1.6495.0904-2.9293 1.474-2.891 3.1256v7.9846c0 2.167.9535 3.4825 2.3505 3.763 1.6118.3266 3.1832-.7152 3.5098-2.327.04-.1974.06-.3983.0593-.5998v-8.9585c.003-1.6474-1.33-2.9852-2.9773-2.9882z"/></svg>',
    googleSheets: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.318 12.545H7.91v-1.909h3.41v1.91zM14.728 0v6h6l-6-6zm1.363 10.636h-3.41v1.91h3.41v-1.91zm0 3.273h-3.41v1.91h3.41v-1.91zM20.727 6.5v15.864c0 .904-.732 1.636-1.636 1.636H4.909a1.636 1.636 0 0 1-1.636-1.636V1.636C3.273.732 4.005 0 4.909 0h9.318v6.5h6.5zm-3.273 2.773H6.545v7.909h10.91v-7.91zm-6.136 4.636H7.91v1.91h3.41v-1.91z"/></svg>',
    instagram: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077"/></svg>',
    intercom: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21 0H3C1.343 0 0 1.343 0 3v18c0 1.658 1.343 3 3 3h18c1.658 0 3-1.342 3-3V3c0-1.657-1.342-3-3-3zm-5.801 4.399c0-.44.36-.8.802-.8.44 0 .8.36.8.8v10.688c0 .442-.36.801-.8.801-.443 0-.802-.359-.802-.801V4.399zM11.2 3.994c0-.44.357-.799.8-.799s.8.359.8.799v11.602c0 .44-.357.8-.8.8s-.8-.36-.8-.8V3.994zm-4 .405c0-.44.359-.8.799-.8.443 0 .802.36.802.8v10.688c0 .442-.36.801-.802.801-.44 0-.799-.359-.799-.801V4.399zM3.199 6c0-.442.36-.8.802-.8.44 0 .799.358.799.8v7.195c0 .441-.359.8-.799.8-.443 0-.802-.36-.802-.8V6zM20.52 18.202c-.123.105-3.086 2.593-8.52 2.593-5.433 0-8.397-2.486-8.521-2.593-.335-.288-.375-.792-.086-1.128.285-.334.79-.375 1.125-.09.047.041 2.693 2.211 7.481 2.211 4.848 0 7.456-2.186 7.479-2.207.334-.289.839-.25 1.128.086.289.336.25.84-.086 1.128zm.281-5.007c0 .441-.36.8-.801.8-.441 0-.801-.36-.801-.8V6c0-.442.361-.8.801-.8.441 0 .801.357.801.8v7.195z"/></svg>',
    linear: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.886 4.18A11.982 11.982 0 0 1 11.99 0C18.624 0 24 5.376 24 12.009c0 3.64-1.62 6.903-4.18 9.105L2.887 4.18ZM1.817 5.626l16.556 16.556c-.524.33-1.075.62-1.65.866L.951 7.277c.247-.575.537-1.126.866-1.65ZM.322 9.163l14.515 14.515c-.71.172-1.443.282-2.195.322L0 11.358a12 12 0 0 1 .322-2.195Zm-.17 4.862 9.823 9.824a12.02 12.02 0 0 1-9.824-9.824Z"/></svg>',
    notion: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.981-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.887l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952L12.21 19s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.139c-.093-.514.28-.887.747-.933zM1.936 1.035l13.31-.98c1.634-.14 2.055-.047 3.082.7l4.249 2.986c.7.513.934.653.934 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.667c0-.839.374-1.54 1.447-1.632z"/></svg>',
    slack: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z"/></svg>',
    stripe: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.594-7.305h.003z"/></svg>',
    sfRefreshFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.9570312,22.9140625 C18.0048828,22.9140625 22.9140625,18.0048828 22.9140625,11.9570312 C22.9140625,5.91992188 18.0048828,1 11.9570312,1 C5.91992188,1 1,5.91992188 1,11.9570312 C1,18.0048828 5.91992188,22.9140625 11.9570312,22.9140625 Z M11.9570312,17.4570312 C9.21777344,17.4570312 7.015625,15.2333984 7.015625,12.4619141 C7.015625,9.74414062 9.25,7.60644531 11.7421875,7.60644531 C11.8388672,7.60644531 11.9355469,7.60644531 12.0537109,7.6171875 L11.2802734,6.86523438 C11.1621094,6.73632812 11.0654297,6.55371094 11.0654297,6.33886719 C11.0654297,5.95214844 11.3769531,5.65136719 11.7744141,5.65136719 C11.9570312,5.65136719 12.171875,5.76953125 12.2578125,5.85546875 L14.40625,8.00390625 C14.5458984,8.1328125 14.6103516,8.32617188 14.6103516,8.49804688 C14.6103516,8.69140625 14.5458984,8.87402344 14.40625,9.01367188 L12.2578125,11.1621094 C12.1611328,11.2587891 11.9570312,11.3554688 11.7744141,11.3554688 C11.3769531,11.3554688 11.0654297,11.0546875 11.0654297,10.6679688 C11.0654297,10.453125 11.1513672,10.2919922 11.2802734,10.1416016 L12.3222656,9.12109375 C12.2363281,9.09960938 12.1074219,9.08886719 11.9570312,9.08886719 C10.0664062,9.08886719 8.55175781,10.6035156 8.55175781,12.5048828 C8.55175781,14.40625 10.0664062,15.9316406 11.9570312,15.9316406 C13.8476562,15.9316406 15.3623047,14.40625 15.3623047,12.5048828 C15.3623047,12.0859375 15.7167969,11.7421875 16.1357422,11.7421875 C16.5439453,11.7421875 16.8984375,12.0859375 16.8984375,12.5048828 C16.8984375,15.2333984 14.6962891,17.4570312 11.9570312,17.4570312 Z"/></svg>',
    playOvalDotted: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.9999758,22.9633119 C13.553625,22.9633119 14.0121806,23.423961 14.0121806,23.9829305 C14.0121806,24.5392295 13.553625,25 12.9999758,25 C12.4437536,25 11.9877952,24.5392295 11.9877952,23.9829305 C11.9877952,23.423961 12.4437536,22.9633119 12.9999758,22.9633119 Z M16.3767138,22.4061632 C16.9303388,22.4061632 17.3888945,22.8669337 17.3888945,23.4259032 C17.3888945,23.9822022 16.9303388,24.4429727 16.3767138,24.4429727 C15.8204313,24.4429727 15.3645332,23.9822022 15.3645332,23.4259032 C15.3645332,22.8669337 15.8204313,22.4061632 16.3767138,22.4061632 Z M9.62329823,22.4061632 C10.1795325,22.4061632 10.6479937,22.8669337 10.6479937,23.4259032 C10.6479937,23.9822022 10.1795325,24.4429727 9.62329823,24.4429727 C9.06707604,24.4429727 8.6111176,23.9822022 8.6111176,23.4259032 C8.6111176,22.8669337 9.06707604,22.4061632 9.62329823,22.4061632 Z M19.4472005,20.8534298 C20.0008255,20.8534298 20.4593811,21.3140789 20.4593811,21.8730484 C20.4593811,22.4293474 20.0008255,22.8901179 19.4472005,22.8901179 C18.8909179,22.8901179 18.4199199,22.4293474 18.4199199,21.8730484 C18.4199199,21.3140789 18.8909179,20.8534298 19.4472005,20.8534298 Z M6.56527814,20.8534298 C7.12151241,20.8534298 7.57747086,21.3140789 7.57747086,21.8730484 C7.57747086,22.4293474 7.12151241,22.8901179 6.56527814,22.8901179 C6.00905595,22.8901179 5.55309751,22.4293474 5.55309751,21.8730484 C5.55309751,21.3140789 6.00905595,20.8534298 6.56527814,20.8534298 Z M21.8605368,18.4184836 C22.4141618,18.4184836 22.8851598,18.8892075 22.8851598,19.4480556 C22.8851598,20.004476 22.4141618,20.4651251 21.8605368,20.4651251 C21.3042542,20.4651251 20.8456985,20.004476 20.8456985,19.4480556 C20.8456985,18.8892075 21.3042542,18.4184836 21.8605368,18.4184836 Z M4.13947533,18.4184836 C4.6957096,18.4184836 5.15166804,18.8892075 5.15166804,19.4480556 C5.15166804,20.004476 4.6957096,20.4651251 4.13947533,20.4651251 C3.58580201,20.4651251 3.12729469,20.004476 3.12729469,19.4480556 C3.12729469,18.8892075 3.58580201,18.4184836 4.13947533,18.4184836 Z M9.91699219,9.51660156 C9.91699219,8.99023438 10.5292969,8.78613281 10.9912109,9.0546875 L17.1035156,12.6748047 C17.5439453,12.9433594 17.5546875,13.5664063 17.1035156,13.8242188 L10.9912109,17.4443359 C10.4863281,17.7451172 9.91699219,17.4980469 9.91699219,16.9824219 Z M23.4058064,15.3885172 C23.9595522,15.3885172 24.4179871,15.8466172 24.4179871,16.4055867 C24.4179871,16.9644347 23.9595522,17.4226562 23.4058064,17.4226562 C22.8496446,17.4226562 22.391089,16.9644347 22.391089,16.4055867 C22.391089,15.8466172 22.8496446,15.3885172 23.4058064,15.3885172 Z M2.59414524,15.3885172 C3.15036743,15.3885172 3.60632588,15.8466172 3.60632588,16.4055867 C3.60632588,16.9644347 3.15036743,17.4226562 2.59414524,17.4226562 C2.04046468,17.4226562 1.58195977,16.9644347 1.58195977,16.4055867 C1.58195977,15.8466172 2.04046468,15.3885172 2.59414524,15.3885172 Z M23.9852826,11.9829305 C24.5414444,11.9829305 25,12.4410912 25,13 C25,13.5589088 24.5414444,14.0171302 23.9852826,14.0171302 C23.4315368,14.0171302 22.9731019,13.5589088 22.9731019,13 C22.9731019,12.4410912 23.4315368,11.9829305 23.9852826,11.9829305 Z M2.01218184,11.9829305 C2.56841491,11.9829305 3.02691015,12.4410912 3.02691015,13 C3.02691015,13.5589088 2.56841491,14.0171302 2.01218184,14.0171302 C1.4585049,14.0171302 1,13.5589088 1,13 C1,12.4410912 1.4585049,11.9829305 2.01218184,11.9829305 Z M23.4058064,8.57738025 C23.9595522,8.57738025 24.4179871,9.03810217 24.4179871,9.59444975 C24.4179871,10.1533585 23.9595522,10.6115193 23.4058064,10.6115193 C22.8496446,10.6115193 22.391089,10.1533585 22.391089,9.59444975 C22.391089,9.03810217 22.8496446,8.57738025 23.4058064,8.57738025 Z M2.59414524,8.57738025 C3.15036743,8.57738025 3.60632588,9.03810217 3.60632588,9.59444975 C3.60632588,10.1533585 3.15036743,10.6115193 2.59414524,10.6115193 C2.04046468,10.6115193 1.58195977,10.1533585 1.58195977,9.59444975 C1.58195977,9.03810217 2.04046468,8.57738025 2.59414524,8.57738025 Z M21.8605368,5.53483848 C22.4141618,5.53483848 22.8851598,6.00812357 22.8851598,6.56447115 C22.8851598,7.12339205 22.4141618,7.58154066 21.8605368,7.58154066 C21.3042542,7.58154066 20.8456985,7.12339205 20.8456985,6.56447115 C20.8456985,6.00812357 21.3042542,5.53483848 21.8605368,5.53483848 Z M4.13947533,5.53483848 C4.6957096,5.53483848 5.15166804,6.00812357 5.15166804,6.56447115 C5.15166804,7.12339205 4.6957096,7.58154066 4.13947533,7.58154066 C3.58580201,7.58154066 3.12729469,7.12339205 3.12729469,6.56447115 C3.12729469,6.00812357 3.58580201,5.53483848 4.13947533,5.53483848 Z M19.4472005,3.10988211 C20.0008255,3.10988211 20.4593811,3.57060403 20.4593811,4.12695161 C20.4593811,4.68587252 20.0008255,5.14658231 19.4472005,5.14658231 C18.8909179,5.14658231 18.4199199,4.68587252 18.4199199,4.12695161 C18.4199199,3.57060403 18.8909179,3.10988211 19.4472005,3.10988211 Z M6.56527814,3.10988211 C7.12151241,3.10988211 7.57747086,3.57060403 7.57747086,4.12695161 C7.57747086,4.68587252 7.12151241,5.14658231 6.56527814,5.14658231 C6.00905595,5.14658231 5.55309751,4.68587252 5.55309751,4.12695161 C5.55309751,3.57060403 6.00905595,3.10988211 6.56527814,3.10988211 Z M16.3767138,1.55708073 C16.9303388,1.55708073 17.3888945,2.01780023 17.3888945,2.57415752 C17.3888945,3.13306629 16.9303388,3.59378822 16.3767138,3.59378822 C15.8204313,3.59378822 15.3645332,3.13306629 15.3645332,2.57415752 C15.3645332,2.01780023 15.8204313,1.55708073 16.3767138,1.55708073 Z M9.62329823,1.55708073 C10.1795325,1.55708073 10.6479937,2.01780023 10.6479937,2.57415752 C10.6479937,3.13306629 10.1795325,3.59378822 9.62329823,3.59378822 C9.06707604,3.59378822 8.6111176,3.13306629 8.6111176,2.57415752 C8.6111176,2.01780023 9.06707604,1.55708073 9.62329823,1.55708073 Z M12.9999758,1 C13.553625,1 14.0121806,1.4607195 14.0121806,2.01707072 C14.0121806,2.57599041 13.553625,3.0367002 12.9999758,3.0367002 C12.4437536,3.0367002 11.9877952,2.57599041 11.9877952,2.01707072 C11.9877952,1.4607195 12.4437536,1 12.9999758,1 Z" transform="translate(-1 -1)"/></svg>',
    linkedin: `<svg  width="32" height="32" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
<path d="M28.778 1.004h-25.56c-0.008-0-0.017-0-0.027-0-1.199 0-2.172 0.964-2.186 2.159v25.672c0.014 1.196 0.987 2.161 2.186 2.161 0.010 0 0.019-0 0.029-0h25.555c0.008 0 0.018 0 0.028 0 1.2 0 2.175-0.963 2.194-2.159l0-0.002v-25.67c-0.019-1.197-0.994-2.161-2.195-2.161-0.010 0-0.019 0-0.029 0h0.001zM9.9 26.562h-4.454v-14.311h4.454zM7.674 10.293c-1.425 0-2.579-1.155-2.579-2.579s1.155-2.579 2.579-2.579c1.424 0 2.579 1.154 2.579 2.578v0c0 0.001 0 0.002 0 0.004 0 1.423-1.154 2.577-2.577 2.577-0.001 0-0.002 0-0.003 0h0zM26.556 26.562h-4.441v-6.959c0-1.66-0.034-3.795-2.314-3.795-2.316 0-2.669 1.806-2.669 3.673v7.082h-4.441v-14.311h4.266v1.951h0.058c0.828-1.395 2.326-2.315 4.039-2.315 0.061 0 0.121 0.001 0.181 0.003l-0.009-0c4.5 0 5.332 2.962 5.332 6.817v7.855z"></path>
</svg>`,
    logov2: '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42"><path fill="currentColor" fill-rule="evenodd" d="M26.6448969,0.699064106 C31.4862479,1.83000067 35.6718819,4.48073656 38.3104478,8.91022511 C40.5212645,12.5974948 41.4936378,17.0951724 40.5085112,21.3679841 C39.7174644,25.0315254 37.8558379,27.853625 34.8002871,29.8369535 C31.9792925,31.7073227 27.90737,32.069064 24.6776501,31.3213124 C23.2887047,30.9944607 20.6411869,29.9775216 19.044333,28.0178349 C17.5928447,26.2365433 17.1250067,23.5192397 17.0461096,22.8419583 C16.9044422,21.6258334 17.1065683,20.249997 17.3800113,19.0276209 C17.9614095,16.4655592 18.9984397,14.7924534 21.1401118,13.3818866 C22.95018,12.1750388 24.6834696,11.8738651 26.7601335,12.3496124 C28.1855093,12.6880929 29.4520072,13.526716 30.3514025,14.7276098 C30.6271426,15.093878 30.8260324,15.4389318 31.059655,15.8362933 L30.9598079,15.7715366 C29.6377659,14.9422902 28.1654404,14.6590001 26.6448969,15.0752526 C25.2996601,15.4486698 24.1453463,16.3687006 23.4390969,17.6304467 C22.6973258,18.9448239 22.4839364,20.5087166 22.8465467,21.9733145 C23.2152637,23.4394215 24.1276197,24.6832715 25.381967,25.429977 C26.7647836,26.2608222 28.5893081,26.47537 30.1320438,26.0161118 C32.0344739,25.4497656 33.5958796,24.1165457 34.5824098,22.3233381 C35.8078311,20.0959926 36.0316242,17.5753145 35.4197363,15.1376991 C34.8712232,12.9726344 33.491011,11.1258939 31.7578503,9.86101942 C28.3978494,7.40873928 23.8145474,6.88014849 19.8961329,8.1555193 C16.9596954,9.11146975 14.399202,11.0657028 12.6221782,13.707146 C10.5375814,16.8894059 9.73736372,20.794518 10.3986926,24.5579956 C10.9302311,27.7327705 12.5716868,31.0242929 14.8485647,33.1339502 C15.5517576,33.7855358 16.0056239,34.2996296 16.8186608,34.9238068 C16.1252729,35.6670587 15.729719,36.1210912 15.0276006,36.8553491 L10.5425168,41.6144377 C8.59431563,40.2572487 6.84060794,38.6181461 5.33246714,36.7448351 C1.65619854,32.1632109 -0.0655234106,26.1858125 0.562658817,20.1851649 C1.1000136,14.4158268 3.81414269,9.08050481 8.0996615,5.36924966 C12.3107417,1.69300072 17.6911238,0.0107792851 23.1108097,0.299129816 C25.006381,0.458182488 26.18441,0.591493918 26.6448969,0.699064106 Z"/></svg>',
    html: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M22.503 15.253a.25.25 0 01-.25.25H19.25a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h1.002a.25.25 0 01.25.25V14h1.751a.25.25 0 01.25.25v1.003zm-4.628 0a.25.25 0 01-.25.25h-1.002a.25.25 0 01-.25-.25V11l-.927 1.217a.25.25 0 01-.397 0L14.122 11v4.253a.25.25 0 01-.25.25H12.87a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h1.004a.5.5 0 01.398.197l.976 1.28.975-1.28a.5.5 0 01.398-.197h1.004a.25.25 0 01.25.25v6.506zm-6.248-5.505a.25.25 0 01-.25.25h-.751v5.255a.25.25 0 01-.25.25H9.374a.25.25 0 01-.25-.25V9.998h-.75a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h3.003a.25.25 0 01.25.25v1.001zm-4.752 5.505a.25.25 0 01-.25.25H5.623a.25.25 0 01-.25-.25v-2.565H3.998v2.565a.25.25 0 01-.25.25H2.746a.25.25 0 01-.25-.25V8.747a.25.25 0 01.25-.25h1.002a.25.25 0 01.25.25v2.565h1.375V8.747a.25.25 0 01.25-.25h1.002a.25.25 0 01.25.25v6.506zM23.5 5H.5a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h23a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5z"/></svg>',
    jquery: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.21 2.004a.522.522 0 00-.142.043c-.391.193-.835.768-.92.882a4.075 4.075 0 00-.696 2.248c-.005.6.112 1.195.35 1.768.554 1.33 1.704 2.43 3.073 2.946l.17.06a.965.965 0 00.086.027l.05.018c.07.023.143.046.214.06.36.073.712.114 1.042.124l.17.002c2.492 0 3.458-1.758 3.779-2.344.032-.057.055-.103.076-.131l.002-.004a.454.454 0 10-.751-.511h-.002c-.664.978-1.8 1.275-3.375.884a3.242 3.242 0 01-.358-.115 4.344 4.344 0 01-.437-.183 4.635 4.635 0 01-.769-.481c-1.385-1.074-1.926-3.31-1.117-4.6a.455.455 0 00-.445-.693zm-4.027.905a.445.445 0 00-.293.104c-.687.559-1.39 1.475-1.42 1.512a.12.12 0 01-.013.02c-1.243 1.809-1.337 4.383-.238 6.558.172.345.368.673.575.975l.063.089c.175.257.372.549.624.776.087.1.182.195.274.287l.044.047.038.037c.094.09.19.183.289.272h.002c.007.01.018.017.026.026.112.1.226.194.377.313l.04.03a7.566 7.566 0 00.397.296c.042.029.085.055.127.086l.043.028.05.032c.09.06.179.115.305.188.082.05.169.1.226.128l.113.062.139.073.046.021c.09.046.185.09.279.133l.143.064c.095.041.19.08.308.125l.053.02a11.099 11.099 0 00.31.11l.2.065c.099.034.214.073.34.094.62.103 1.222.156 1.792.156l.2-.002a6.645 6.645 0 006.335-4.415.455.455 0 00-.811-.384c-1.271 1.857-3.675 2.642-6.124 1.996a5.261 5.261 0 01-.44-.133 4.133 4.133 0 01-.247-.085l-.126-.048a5.594 5.594 0 01-.234-.096l-.059-.027c-.108-.046-.213-.098-.307-.144l-.26-.135c-.058-.028-.11-.06-.19-.108l-.044-.025-.044-.026a2.946 2.946 0 01-.192-.123l-.042-.027a.628.628 0 01-.043-.03c-.053-.033-.105-.067-.154-.1a8.34 8.34 0 01-.345-.258l-.05-.041c-1.171-.936-2.038-2.186-2.444-3.526-.379-1.23-.098-2.841.75-4.308a.452.452 0 00-.388-.682zM5.18 4.273a.458.458 0 00-.305.117c-.868.78-1.518 1.79-1.59 1.905C1.43 9 1.789 13.202 3.064 15.771c.025.053.052.105.078.156l.018.029c.023.051.05.105.059.115a.44.44 0 00.044.082c.021.044.043.083.082.15l.145.251c.022.034.043.07.05.082l.089.142.07.114a.985.985 0 00.058.081c.07.11.142.22.22.325l.01.013.029.039c.064.092.13.18.188.253l.26.329a.683.683 0 01.033.04l.037.043c.078.096.162.192.245.284l.038.041.246.265.082.078a4.506 4.506 0 00.24.24l.07.065a5.531 5.531 0 00.315.284c.083.075.167.146.252.215l.435.345.233.168c.028.022.058.043.088.063l.036.026.327.219c.119.078.238.15.383.237l.078.045c.09.053.183.106.27.153l.147.076c.063.034.13.07.233.12.009.006.082.041.09.045.104.051.208.1.34.158 0 .002.042.021.042.021a19.162 19.162 0 00.448.185c.11.043.225.085.32.119l.065.027a16.864 16.864 0 00.469.15l.09.029c.11.034.22.07.34.092.845.155 1.67.235 2.451.235h.002c6.51 0 8.585-5.24 8.606-5.293a.455.455 0 00-.788-.437c-1.671 2.2-4.823 3.017-8.43 2.187a4.829 4.829 0 01-.263-.072l-.17-.052a9.68 9.68 0 01-.343-.113l-.054-.02c-.099-.034-.198-.073-.285-.106l-.1-.04c-.11-.044-.22-.09-.327-.138l-.062-.027c-.096-.044-.188-.087-.28-.133a6.773 6.773 0 01-.297-.15l-.37-.2a1.272 1.272 0 00-.114-.067c-.112-.07-.228-.139-.341-.211-.027-.016-.05-.034-.094-.064a7.2 7.2 0 01-.267-.18l-.044-.032c-.076-.053-.151-.11-.213-.156-.04-.028-.078-.06-.142-.108-.057-.044-.114-.087-.167-.13l-.1-.081c-.083-.068-.161-.139-.243-.208a.231.231 0 00-.032-.027c-.09-.083-.183-.167-.293-.271l-.321-.32a9.505 9.505 0 01-.51-.565l-.191-.234a1.214 1.214 0 00-.078-.103c-.066-.089-.132-.176-.198-.268-1.768-2.436-2.23-7.521-.852-9.383a.454.454 0 00-.364-.725z"/></svg>',
    js: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M16.837 19c-1.463 0-2.418-.684-2.899-1.587a.064.064 0 01.025-.085l1.204-.697a.062.062 0 01.083.02c.34.537.785.926 1.553.926.665 0 1.09-.333 1.09-.792 0-.551-.436-.746-1.17-1.068l-.402-.172c-1.16-.493-1.929-1.113-1.929-2.422 0-1.205.919-2.123 2.353-2.123 1.002 0 1.728.342 2.253 1.232a.065.065 0 01-.02.086l-1.146.736a.063.063 0 01-.087-.022c-.266-.452-.559-.632-1-.632-.47 0-.769.299-.769.689 0 .482.299.677.987.976l.402.172c1.366.585 2.135 1.182 2.135 2.525 0 1.446-1.136 2.238-2.663 2.238zm-4.23-2.422c0 1.664-.976 2.422-2.4 2.422-1.256 0-1.998-.637-2.384-1.417a.064.064 0 01.024-.082l1.204-.729a.063.063 0 01.087.023c.24.423.474.77 1.001.77.528 0 .86-.206.86-1.01v-5.4c0-.035.03-.063.063-.063h1.482c.035 0 .063.028.063.062v5.424zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z"/></svg>',
    jsOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.5 20.5h17v-17h-17v17zM21.5 2h-19a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5zM9.708 18.5c1.423 0 2.399-.757 2.399-2.422v-5.423a.063.063 0 00-.063-.063h-1.482a.062.062 0 00-.062.063v5.4c0 .804-.333 1.01-.86 1.01-.529 0-.761-.347-1.002-.77a.063.063 0 00-.087-.023l-1.203.729a.064.064 0 00-.025.082c.386.78 1.128 1.417 2.385 1.417m6.595-1.423c-.768 0-1.212-.389-1.553-.925a.062.062 0 00-.083-.02l-1.257.727c.471.93 1.435 1.64 2.927 1.64 1.527 0 2.663-.79 2.663-2.237 0-1.343-.769-1.94-2.135-2.525l-.402-.172c-.688-.299-.987-.494-.987-.976 0-.39.299-.689.77-.689.44 0 .733.18 1 .632.017.03.057.041.086.022l1.146-.735a.065.065 0 00.02-.087c-.525-.89-1.251-1.232-2.253-1.232-1.434 0-2.353.918-2.353 2.124 0 1.308.77 1.928 1.929 2.421l.401.173c.735.32 1.171.516 1.171 1.067 0 .459-.425.792-1.09.792"/></svg>',
    medium: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13.435 12.025c0 3.416-2.75 6.185-6.142 6.185-3.393 0-6.143-2.769-6.143-6.185 0-3.415 2.75-6.184 6.143-6.184 3.392 0 6.142 2.769 6.142 6.184m6.738 0c0 3.216-1.375 5.822-3.071 5.822-1.696 0-3.071-2.606-3.071-5.822 0-3.215 1.375-5.821 3.07-5.821 1.697 0 3.072 2.606 3.072 5.821m2.756 0c0 2.881-.483 5.216-1.08 5.216-.596 0-1.08-2.335-1.08-5.216 0-2.88.484-5.215 1.08-5.215.597 0 1.08 2.335 1.08 5.215" fill-rule="evenodd"/></svg>',
    openSource: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.289 2.025c-4.94.341-8.936 4.35-9.266 9.29a10 10 0 006.582 10.09.25.25 0 00.324-.165L11 14.292h.003a2.5 2.5 0 01-1.478-2.647 2.51 2.51 0 012.19-2.13 2.5 2.5 0 011.282 4.777H13l2.072 6.948a.25.25 0 00.323.166C19.246 20.016 22 16.33 22 12c0-5.758-4.866-10.38-10.711-9.975" fill-rule="evenodd"/></svg>',
    pdf: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.746 13.411c-1.217 0-2.343.167-2.794.22-1.405-1.35-2.698-3.542-2.698-3.542s.9-2.627.9-4.665c0-1.572-.488-2.924-2.093-2.924-.633 0-1.757.424-1.757 2.5 0 1.201.362 2.712 1.04 4.245-.62 1.743-1.181 3.429-2.755 6.408 0 0-5.37 1.899-5.37 4.347 0 .84.843 1.5 1.781 1.5 2.08 0 4.207-2.867 5.613-5.284 1.18-.393 3.035-.956 4.89-1.292 2.192 1.91 4.103 2.191 5.116 2.191 1.559 0 2.163-.84 2.163-1.638 0-1.18-1.226-2.066-4.036-2.066m2.227 1.873c0 .393-.369.715-.975.715-.92 0-2.551-.845-3.371-1.525 0 0 1.029-.165 2.246-.165 1.53 0 2.1.423 2.1.975m-8.95-11.772c.498 0 .613.806.613 1.312 0 1.286-.242 2.174-.636 3.298C10.583 7.01 10.34 5.964 10.34 5c0-.935.282-1.488.684-1.488m-.567 11.186c.45-.899 1.068-2.473 1.292-3.148.506.843 1.35 1.855 1.8 2.305 0 .056-1.744.394-3.092.843m-3.317 2.25c-1.293 2.135-2.642 3.485-3.372 3.485-.274 0-.527-.189-.527-.446 0-.88 1.789-2.177 3.9-3.04"/></svg>',
    react: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.619 14.968a19.68 19.68 0 00-1.026-2.972 19.677 19.677 0 001.026-2.971c2.135.779 3.38 1.896 3.38 2.971 0 1.075-1.245 2.192-3.38 2.972m-1.62 5.688c-.844.488-2.208.109-3.743-1.04a12.08 12.08 0 01-.513-.408c.697-.68 1.39-1.474 2.053-2.369a19.615 19.615 0 003.087-.597c.392 2.24.048 3.877-.883 4.414m-10 0c-.931-.537-1.275-2.175-.883-4.414.94.266 1.977.47 3.09.598a19.81 19.81 0 002.056 2.375C9.52 20.673 7.93 21.194 7 20.656m-5-8.66c0-1.075 1.246-2.192 3.381-2.971.24.946.582 1.945 1.027 2.971a19.654 19.654 0 00-1.027 2.972C3.246 14.188 2 13.07 2 11.996m5-8.66c.93-.538 2.521-.017 4.264 1.442-.7.68-1.394 1.477-2.06 2.375a19.604 19.604 0 00-3.087.597C5.725 5.51 6.07 3.874 7 3.336m9.33 6.16a25.336 25.336 0 00-.762-1.234c.76.119 1.464.274 2.107.458-.163.649-.38 1.336-.657 2.053-.213-.424-.442-.85-.688-1.277M12 5.443c.48.465.967.997 1.45 1.596a25.228 25.228 0 00-2.9 0c.482-.599.97-1.13 1.45-1.596m-5.018 5.33a17.585 17.585 0 01-.657-2.053 17.611 17.611 0 012.107-.458 25.143 25.143 0 00-1.45 2.51m1.45 4.958a17.611 17.611 0 01-2.107-.457c.163-.65.38-1.336.657-2.054a25.266 25.266 0 001.45 2.511m3.573 2.814a17.805 17.805 0 01-1.447-1.59 25.184 25.184 0 002.892 0 17.595 17.595 0 01-1.445 1.59m5.013-5.325c.277.718.494 1.405.657 2.054-.643.183-1.346.338-2.105.457a25.238 25.238 0 001.448-2.51m-1.554.776c-.393.68-.8 1.313-1.214 1.897-.713.067-1.464.103-2.25.103a24.25 24.25 0 01-2.246-.102A24.428 24.428 0 017.5 11.997c.3-.652.643-1.32 1.036-2.001.392-.68.8-1.312 1.213-1.897a24.354 24.354 0 014.5 0c.415.585.822 1.217 1.215 1.897.393.68.737 1.349 1.036 2-.3.651-.643 1.32-1.036 2m.692-10.867c.32 0 .604.068.844.207.931.538 1.275 2.175.883 4.414a19.647 19.647 0 00-3.087-.597 19.62 19.62 0 00-2.06-2.375c1.293-1.082 2.502-1.65 3.42-1.65M23 11.997c0-1.62-1.616-3.036-4.168-3.944.49-2.665.071-4.772-1.332-5.582-1.403-.81-3.438-.12-5.5 1.638C9.937 2.35 7.903 1.66 6.5 2.47c-1.403.81-1.822 2.917-1.332 5.582C2.616 8.96 1 10.376 1 11.996s1.616 3.037 4.168 3.945c-.49 2.664-.071 4.771 1.332 5.581.395.229.84.338 1.322.338 1.229 0 2.695-.711 4.176-1.972.22.188.439.365.66.53 1.28.958 2.48 1.448 3.501 1.448a2.64 2.64 0 001.34-.344c1.404-.81 1.823-2.917 1.333-5.581C21.384 15.033 23 13.616 23 11.996M14.004 12a2 2 0 11-4 0 2 2 0 014 0"/></svg>',
    sketch: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.1 4H6.9c-.25 0-.48.13-.62.33L2.82 9.52c-.19.28-.16.65.06.91l8.56 9.91c.3.35.84.35 1.14 0l8.56-9.91c.22-.26.24-.63.06-.91l-3.46-5.19A.83.83 0 0017.1 4zm-5.1.47L18 9H6l6-4.53zM12 20l-5.5-9h11L12 20z"/></svg>',
    stackoverflow: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.125 13.77c.207 0 .375.167.375.375v6.375h11v-6.375c0-.208.168-.375.375-.375h.75c.207 0 .375.167.375.375v7.5a.375.375 0 01-.375.375H4.375A.375.375 0 014 21.645v-7.5c0-.208.168-.375.375-.375h.75zm9.5 3.75c.207 0 .375.168.375.375v.75a.375.375 0 01-.375.375H7.352a.375.375 0 01-.375-.375v-.75c0-.207.168-.375.375-.375h7.273zm-7.02-2.978l7.243.668c.206.02.357.202.338.408l-.068.747a.375.375 0 01-.408.339l-7.243-.668a.375.375 0 01-.339-.408l.07-.747a.375.375 0 01.407-.339zm.7-3.474l7.024 1.889c.2.053.319.26.265.459l-.195.724a.375.375 0 01-.46.265l-7.023-1.888a.375.375 0 01-.265-.46l.195-.724c.054-.2.26-.318.46-.265zm1.736-3.803l6.265 3.695a.375.375 0 01.133.514l-.381.646a.375.375 0 01-.514.132L9.28 8.557a.375.375 0 01-.132-.513l.381-.646a.375.375 0 01.513-.133zM13.96 3.58l4.097 6.01a.375.375 0 01-.098.52l-.62.423a.375.375 0 01-.52-.099l-4.099-6.01a.375.375 0 01.099-.52l.62-.423a.375.375 0 01.52.099zm4.972-1.623l1.244 7.166a.375.375 0 01-.306.433l-.739.129a.375.375 0 01-.433-.306l-1.244-7.166a.375.375 0 01.306-.433l.739-.129a.375.375 0 01.433.306z"/></svg>',
    svelte: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.894 9.072a5.506 5.506 0 00-2.21-1.172 1 1 0 00-1.47-1.213L9.18 9.955a1 1 0 101.09 1.677l2.097-1.361a3.504 3.504 0 014.841 1.029 3.504 3.504 0 01-1.029 4.842l-5.032 3.267a3.48 3.48 0 01-2.634.489 3.478 3.478 0 01-2.208-1.518 3.528 3.528 0 01-.201-3.449 5.501 5.501 0 002.21 1.173.998.998 0 001.471 1.209l5.032-3.268a1 1 0 10-1.089-1.677l-2.097 1.361A3.504 3.504 0 016.791 12.7a3.504 3.504 0 011.03-4.842l5.031-3.267a3.477 3.477 0 012.634-.489 3.478 3.478 0 012.208 1.518 3.53 3.53 0 01.2 3.452M19.37 4.53a5.464 5.464 0 00-3.47-2.384 5.464 5.464 0 00-4.138.767L6.73 6.181a5.506 5.506 0 00-1.93 7.052 5.463 5.463 0 00-.172 6.236 5.465 5.465 0 003.47 2.385 5.462 5.462 0 004.14-.767l5.03-3.268a5.507 5.507 0 001.93-7.053 5.463 5.463 0 00.172-6.236"/></svg>',
    ts: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M16.837 19c-1.463 0-2.418-.684-2.899-1.587a.064.064 0 01.025-.085l1.204-.697a.062.062 0 01.083.021c.34.537.785.925 1.553.925.665 0 1.09-.333 1.09-.792 0-.551-.436-.746-1.17-1.067l-.402-.173c-1.16-.493-1.929-1.113-1.929-2.421 0-1.206.919-2.124 2.353-2.124 1.002 0 1.728.342 2.253 1.232a.065.065 0 01-.02.087l-1.146.735a.063.063 0 01-.087-.022c-.266-.452-.559-.631-1-.631-.47 0-.769.298-.769.688 0 .482.299.677.987.976l.402.172c1.366.585 2.135 1.182 2.135 2.525 0 1.446-1.136 2.238-2.663 2.238m-3.4-6.51H11.28v6.356a.062.062 0 01-.062.062H9.782a.063.063 0 01-.062-.062V12.49H7.562a.063.063 0 01-.062-.063v-1.272c0-.035.028-.063.062-.063h5.875c.035 0 .063.028.063.063v1.272a.062.062 0 01-.063.063M20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5"/></svg>',
    tsOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.5 20.5h17v-17h-17v17zM21.5 2h-19a.5.5 0 00-.5.5v19a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-19a.5.5 0 00-.5-.5zm-5.197 15.077c-.768 0-1.212-.389-1.552-.925a.062.062 0 00-.084-.02l-1.204.696a.064.064 0 00-.024.085c.48.903 1.435 1.587 2.898 1.587 1.527 0 2.663-.792 2.663-2.238 0-1.343-.769-1.94-2.135-2.525l-.401-.172c-.69-.299-.988-.494-.988-.976 0-.39.299-.689.77-.689.44 0 .733.18 1 .632.017.03.057.041.087.022l1.145-.735a.065.065 0 00.02-.087c-.525-.89-1.251-1.232-2.252-1.232-1.435 0-2.354.918-2.354 2.124 0 1.308.77 1.928 1.929 2.421l.402.173c.734.32 1.17.516 1.17 1.067 0 .459-.424.792-1.09.792m-7.02 1.33h1.435a.062.062 0 00.062-.062V11.99h2.157a.063.063 0 00.063-.063v-1.273a.063.063 0 00-.063-.062H7.063a.062.062 0 00-.063.062v1.273c0 .035.028.063.063.063H9.22v6.355c0 .035.028.063.062.063"/></svg>',
    twitter: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 5.923a8.208 8.208 0 01-2.358.647 4.114 4.114 0 001.805-2.27 8.24 8.24 0 01-2.607.995 4.103 4.103 0 00-6.99 3.742A11.65 11.65 0 013.392 4.75a4.087 4.087 0 00-.555 2.063c0 1.424.723 2.68 1.825 3.417a4.1 4.1 0 01-1.86-.514v.051a4.109 4.109 0 003.291 4.025 4.106 4.106 0 01-1.853.068 4.113 4.113 0 003.833 2.851 8.225 8.225 0 01-5.096 1.756c-.332 0-.657-.02-.977-.058a11.593 11.593 0 006.29 1.844c7.547 0 11.674-6.252 11.674-11.673 0-.178-.004-.357-.01-.532A8.341 8.341 0 0022 5.923z"/></svg>',
    vscode: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.574 12l6.39-4.968v9.938L10.574 12zM16.256 1.73L7.67 9.743 3.849 6.77a.5.5 0 00-.661.041L1.866 8.134a.5.5 0 00.012.72L5.251 12l-3.373 3.147a.5.5 0 00-.012.719l1.322 1.322a.5.5 0 00.66.041L7.67 14.26l8.586 8.013a.5.5 0 00.548.09l4.903-2.229a.5.5 0 00.293-.455V4.323a.5.5 0 00-.293-.455L16.804 1.64a.5.5 0 00-.548.089z"/></svg>',
    vue: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.08 3.257L12 7 9.92 3.257A.5.5 0 009.484 3H2.425a.25.25 0 00-.219.371l9.576 17.236a.25.25 0 00.437 0L21.796 3.37A.25.25 0 0021.577 3h-7.06a.5.5 0 00-.437.257"/></svg>',
    webComponents: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.655 4h-3.38a.5.5 0 00-.422.232L6.93 16.734 3.93 12l4.826-7.616A.25.25 0 008.546 4H5.344a.5.5 0 00-.422.232l-4.752 7.5a.499.499 0 000 .535l4.752 7.5a.5.5 0 00.422.233h3.38a.5.5 0 00.423-.233L17.07 7.266l3 4.734-4.826 7.616a.25.25 0 00.211.384h3.201a.5.5 0 00.423-.233l4.752-7.5a.5.5 0 000-.535l-4.752-7.5A.5.5 0 0018.655 4"/></svg>',
    wordpress: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm7.57 6.536c.003.08.015.148.015.232 0 .869-.163 1.847-.652 3.072l-2.49 7.198a8.27 8.27 0 01-1.695.82l-2.596-7.11-2.493 7.244a8.314 8.314 0 01-1.527-.619L4.289 8.851c.226-.551.508-1.072.84-1.557.085.002.181.004.256.004.897 0 2.286-.109 2.286-.109.463-.026.516.653.055.708 0 0-.465.054-.982.081l3.123 9.293 1.877-5.631-1.335-3.663c-.463-.026-.9-.08-.9-.08-.463-.028-.407-.735.054-.708 0 0 1.417.11 2.259.11.896 0 2.286-.11 2.286-.11.463-.026.516.653.054.708 0 0-.465.054-.981.081l3.1 9.222.857-2.862c.434-1.114.652-2.036.652-2.772 0-1.06-.38-1.794-.707-2.365-.435-.708-.844-1.305-.844-2.013 0-.707.483-1.366 1.193-1.495a8.38 8.38 0 012.138 2.843z"/></svg>',
    xd: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.707 15.575c0 .05-.028.094-.074.114-.253.111-1.138.456-2.378.456-1.741 0-3.201-.936-3.201-3.145 0-1.661 1.24-3.201 3.558-3.201.136 0 .268.005.396.015V7.391c0-.034.028-.062.063-.062h1.574c.034 0 .062.028.062.062v8.184zM12.056 16h-1.91a.125.125 0 01-.11-.066L8.475 13h-.017L6.9 15.934a.125.125 0 01-.11.066H5.063a.062.062 0 01-.054-.095L7.381 12 5.074 8.094A.063.063 0 015.128 8h1.808c.046 0 .089.026.11.067L8.6 11h.01l1.553-2.933a.125.125 0 01.11-.067h1.63c.049 0 .08.053.054.095l-2.293 3.784 2.445 4.026a.062.062 0 01-.053.095zm5.452-13h-11a3.5 3.5 0 00-3.5 3.5v11a3.5 3.5 0 003.5 3.5h11a3.5 3.5 0 003.5-3.5v-11a3.5 3.5 0 00-3.5-3.5zM14.79 13c0 .986.56 1.675 1.624 1.675.202 0 .403-.014.594-.07V11.27a1.851 1.851 0 00-.446-.054c-.776 0-1.772.437-1.772 1.784"/></svg>',
    arrowAngleDiagonalLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.5 12a.5.5 0 01.5.5V18h5.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h1zm14-8a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6h-5.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h7z"/></svg>',
    arrowAngleDiagonalRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.5 12a.5.5 0 00-.5.5V18h-5.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-1zm-14-8a.5.5 0 00-.5.5v7a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V6h5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-7z"/></svg>',
    arrowAngleDown: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.99 8.11l-.707.707a.5.5 0 000 .707l6.363 6.365a.5.5 0 00.707 0l6.364-6.364a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0L12 13.414 6.697 8.11a.5.5 0 00-.707 0" fill-rule="evenodd"/></svg>',
    arrowAngleDownLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.5 7h-1a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H9V7.5a.5.5 0 00-.5-.5"/></svg>',
    arrowAngleDownRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7 15.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V15H7.5a.5.5 0 00-.5.5"/></svg>',
    arrowAngleLeft: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.89 5.99l-.707-.707a.5.5 0 00-.707 0L8.11 11.646a.5.5 0 000 .707l6.364 6.364a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L10.586 12l5.304-5.303a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    arrowAngleMirroringHorizontal: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.854 6.147a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L4.828 12l4.439 4.438a.5.5 0 010 .708l-.707.706a.5.5 0 01-.707 0l-5.5-5.499a.5.5 0 010-.707zm7.585 0a.5.5 0 01.707 0l5.5 5.5a.5.5 0 010 .707l-5.5 5.5a.5.5 0 01-.706 0l-.707-.707a.5.5 0 010-.708l4.439-4.438-4.44-4.44a.5.5 0 010-.708z" fill-rule="evenodd"/></svg>',
    arrowAngleMirroringVertical: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.853 14.732a.5.5 0 01.708 0l4.44 4.44 4.438-4.439a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-5.499 5.5a.5.5 0 01-.707 0l-5.5-5.5a.5.5 0 010-.708zm4.794-12.378a.5.5 0 01.707 0l5.5 5.5a.5.5 0 010 .707l-.707.707a.5.5 0 01-.708 0l-4.438-4.44-4.44 4.44a.5.5 0 01-.707 0l-.707-.706a.5.5 0 010-.707z" fill-rule="evenodd"/></svg>',
    arrowAngleRight: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.11 18.01l.707.707a.5.5 0 00.707 0l6.365-6.363a.5.5 0 000-.707L9.525 5.283a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L13.414 12 8.11 17.303a.5.5 0 000 .707" fill-rule="evenodd"/></svg>',
    arrowAngleUp: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.01 15.89l.707-.707a.5.5 0 000-.707L12.354 8.11a.5.5 0 00-.707 0l-6.364 6.364a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0L12 10.586l5.303 5.304a.5.5 0 00.707 0" fill-rule="evenodd"/></svg>',
    arrowAngleUpLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17 8.5v-1a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V9h7.5a.5.5 0 00.5-.5"/></svg>',
    arrowAngleUpRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15.5 17h1a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H15v7.5a.5.5 0 00.5.5"/></svg>',
    arrowDown: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.146 14.958l5.5 5.5a.5.5 0 00.707 0l5.5-5.501a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0L13 16.983V4.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v12.484l-3.439-3.44a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707" fill-rule="evenodd"/></svg>',
    arrowDownLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.983 10.04v7.778a.5.5 0 00.5.5h7.779a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H9.397l8.827-8.826a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0l-8.828 8.827v-4.864a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5"/></svg>',
    arrowDownRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.04 18.017h7.778a.5.5 0 00.5-.5V9.738a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v4.865L7.493 5.776a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l8.827 8.828h-4.864a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/></svg>',
    arrowLeft: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9.042 6.146l-5.5 5.5a.5.5 0 000 .707l5.501 5.5a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L7.017 13H19.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H7.016l3.44-3.439a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0" fill-rule="evenodd"/></svg>',
    arrowMirroringHorizontal: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.56 16.65a.5.5 0 000-.707L5.62 13h12.76l-2.941 2.943a.5.5 0 000 .707l.708.707a.5.5 0 00.707 0l5-5.005a.5.5 0 000-.707l-5-5.002a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L18.382 11H5.62l2.94-2.943a.5.5 0 000-.708l-.707-.706a.5.5 0 00-.707 0l-5 5.005a.5.5 0 000 .706l5 5.003a.5.5 0 00.707 0z" fill-rule="evenodd"/></svg>',
    arrowMirroringVertical: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.65 15.44a.5.5 0 00-.707 0L13 18.38V5.621l2.943 2.94a.5.5 0 00.707 0l.707-.708a.5.5 0 000-.707l-5.005-5a.5.5 0 00-.707 0l-5.002 5a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0L11 5.618V18.38l-2.943-2.941a.5.5 0 00-.708 0l-.706.708a.5.5 0 000 .707l5.005 5a.5.5 0 00.707 0l5.002-5a.5.5 0 000-.707z" fill-rule="evenodd"/></svg>',
    arrowRight: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.958 17.854l5.5-5.5a.5.5 0 000-.707l-5.501-5.5a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l3.44 3.44H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h12.484l-3.44 3.439a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0" fill-rule="evenodd"/></svg>',
    arrowSwitchDiagonalLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.353 16.076A1.033 1.033 0 003.416 17.1a1.138 1.138 0 001.104-1.067l.07-3.516 8.705 8.706c.415.415 1.102.401 1.533-.03.432-.432.446-1.119.03-1.534l-8.705-8.705 3.516-.07a1.138 1.138 0 001.067-1.104 1.033 1.033 0 00-1.024-1.063L3.58 8.84a1.137 1.137 0 00-1.105 1.105l-.122 6.132zm11.973-.831a1.04 1.04 0 01-.96-.512 1.082 1.082 0 01.02-1.104c.208-.343.582-.552.977-.545l3.507-.061-8.705-8.706c-.415-.415-.404-1.1.026-1.529.43-.43 1.114-.441 1.53-.026l8.705 8.705.06-3.507a1.128 1.128 0 011.1-1.061 1.037 1.037 0 011.062 1.024l-.106 6.117a1.128 1.128 0 01-1.1 1.099l-6.116.106z"/></svg>',
    arrowSwitchDiagonalRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.924 2.353A1.033 1.033 0 006.9 3.416 1.138 1.138 0 007.967 4.52l3.516.07-8.706 8.705c-.415.415-.401 1.102.03 1.533.432.432 1.119.446 1.534.03l8.705-8.705.07 3.516c.032.584.52 1.056 1.104 1.067a1.033 1.033 0 001.063-1.024L15.16 3.58a1.137 1.137 0 00-1.105-1.105l-6.132-.122zm.831 11.973a1.04 1.04 0 01.512-.96c.337-.195.76-.188 1.104.02.343.208.552.582.545.977l.061 3.507 8.706-8.705c.415-.415 1.1-.404 1.529.026.43.43.441 1.114.026 1.53l-8.705 8.705 3.507.06c.582.031 1.051.517 1.061 1.1a1.037 1.037 0 01-1.024 1.062l-6.117-.106a1.128 1.128 0 01-1.099-1.1l-.106-6.116z"/></svg>',
    arrowSwitchHorizontal: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.061 21.703a1.033 1.033 0 001.476-.027c.404-.42.416-1.1.026-1.535l-2.437-2.535h12.311c.587 0 1.063-.495 1.063-1.106 0-.61-.476-1.106-1.063-1.106H7.126l2.437-2.535a1.138 1.138 0 00-.026-1.535 1.033 1.033 0 00-1.476-.027l-4.25 4.422a1.137 1.137 0 000 1.562l4.25 4.422zm7.878-9.053a1.04 1.04 0 01-1.04.316c-.377-.1-.67-.404-.767-.794-.096-.39.021-.803.305-1.077l2.437-2.522H4.563c-.587 0-1.063-.493-1.063-1.1 0-.608.476-1.1 1.063-1.1h12.311L14.437 3.85a1.128 1.128 0 01.026-1.528 1.037 1.037 0 011.476-.027l4.25 4.4c.415.43.415 1.125 0 1.555l-4.25 4.4z"/></svg>',
    arrowSwitchVertical: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.297 8.061a1.033 1.033 0 00.027 1.476c.42.404 1.1.416 1.535.026l2.535-2.437v12.311c0 .587.495 1.063 1.106 1.063.61 0 1.106-.476 1.106-1.063V7.126l2.535 2.437c.435.39 1.114.378 1.535-.026a1.033 1.033 0 00.027-1.476l-4.422-4.25a1.137 1.137 0 00-1.562 0L2.297 8.06zm9.053 7.878a1.04 1.04 0 01-.316-1.04c.1-.377.404-.67.794-.767.39-.096.803.021 1.077.305l2.522 2.437V4.563c0-.587.493-1.063 1.1-1.063.608 0 1.1.476 1.1 1.063v12.311l2.523-2.437a1.128 1.128 0 011.528.026c.419.405.43 1.057.027 1.476l-4.4 4.25a1.128 1.128 0 01-1.555 0l-4.4-4.25z"/></svg>',
    arrowTriangleDown: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.293 9H6.707a.5.5 0 00-.353.853l5.292 5.293a.5.5 0 00.708 0l5.292-5.293A.5.5 0 0017.293 9" fill-rule="evenodd"/></svg>',
    arrowTriangleDownLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M16.339 15.633L8.853 8.148A.5.5 0 008 8.5v7.485a.5.5 0 00.5.5h7.485a.5.5 0 00.354-.853"/></svg>',
    arrowTriangleDownRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15.633 8.147l-7.485 7.486a.5.5 0 00.353.853h7.485a.5.5 0 00.5-.5V8.501a.5.5 0 00-.853-.354"/></svg>',
    arrowTriangleLeft: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15 17.293V6.707a.5.5 0 00-.853-.353l-5.293 5.292a.5.5 0 000 .708l5.293 5.292a.5.5 0 00.853-.353" fill-rule="evenodd"/></svg>',
    arrowTriangleMirroringDiagonalLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.843 14.329l7.485-7.486a.5.5 0 00-.353-.853H6.49a.5.5 0 00-.5.5v7.485a.5.5 0 00.853.354zm10.314-4.657l-7.485 7.485a.5.5 0 00.353.854h7.485a.5.5 0 00.5-.5v-7.486a.5.5 0 00-.853-.353z"/></svg>',
    arrowTriangleMirroringDiagonalRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.329 17.157L6.843 9.672a.5.5 0 00-.853.353v7.485a.5.5 0 00.5.5h7.485a.5.5 0 00.354-.853zM9.672 6.843l7.485 7.485a.5.5 0 00.853-.353V6.49a.5.5 0 00-.5-.5h-7.485a.5.5 0 00-.353.853z"/></svg>',
    arrowTriangleMirroringHorizontal: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9.147 6.354a.5.5 0 01.853.353v10.586a.5.5 0 01-.853.353l-5.293-5.292a.5.5 0 010-.707zM14 6.707a.5.5 0 01.854-.353l5.293 5.293a.5.5 0 010 .707l-5.293 5.293a.5.5 0 01-.854-.354z" fill-rule="evenodd"/></svg>',
    arrowTriangleMirroringVertical: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.293 14a.5.5 0 01.354.854l-5.293 5.293a.5.5 0 01-.707 0l-5.293-5.293A.5.5 0 016.707 14zM11.646 3.854a.5.5 0 01.708 0l5.292 5.293a.5.5 0 01-.353.853H6.707a.5.5 0 01-.353-.853z" fill-rule="evenodd"/></svg>',
    arrowTriangleRight: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9 6.707v10.586a.5.5 0 00.853.353l5.293-5.292a.5.5 0 000-.708L9.853 6.354A.5.5 0 009 6.707" fill-rule="evenodd"/></svg>',
    arrowTriangleUp: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.5 7h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m-18.755-.814V5.808a.5.5 0 01.098-.297l.642-.87c.144-.195.377-.195.521 0l.642.87a.5.5 0 01.097.297v12.378a.5.5 0 01-.097.297l-.642.87c-.144.195-.377.195-.521 0l-.642-.87a.5.5 0 01-.098-.297z"/></svg>',
    arrowTriangleUpLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.853 16.339l7.486-7.486A.5.5 0 0015.985 8H8.5a.5.5 0 00-.5.5v7.485a.5.5 0 00.853.354"/></svg>',
    arrowTriangleUpRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.147 8.853l7.486 7.486a.5.5 0 00.853-.354V8.5a.5.5 0 00-.5-.5H8.501a.5.5 0 00-.354.853"/></svg>',
    arrowUp: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.854 9.042l-5.5-5.5a.5.5 0 00-.707 0l-5.5 5.501a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0L11 7.017V19.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V7.016l3.439 3.44a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    arrowUpLeft: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.96 5.983H6.181a.5.5 0 00-.5.5v7.779a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V9.397l8.826 8.827a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707L9.095 7.982h4.864a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5"/></svg>',
    arrowUpRight: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.017 13.96V6.181a.5.5 0 00-.5-.5H9.738a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h4.865l-8.827 8.826a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l8.828-8.827v4.864a.5.5 0 00.5.5h1a.5.5 0 00.5-.5"/></svg>',
    checkmark: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17l-4.228-3.85a.5.5 0 00-.69.015l-.713.709a.5.5 0 00.011.72l5.258 4.899a.5.5 0 00.703-.02l11.322-11.88a.5.5 0 00-.008-.698l-.702-.702a.5.5 0 00-.716.01z" fill-rule="evenodd"/></svg>',
    crossmark: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.718 5.99c.173.173.167.467 0 .695l-.071.082L13.415 12l5.232 5.233c.21.211.257.515.123.715l-.052.063-.707.707c-.174.174-.468.168-.696 0l-.082-.07-5.234-5.234-5.232 5.234c-.21.21-.514.257-.714.122l-.063-.052-.707-.707c-.174-.173-.168-.468 0-.696l.07-.082 5.233-5.234-5.233-5.23c-.21-.212-.257-.515-.122-.716l.052-.063.707-.707c.173-.173.468-.167.696 0l.082.071L12 10.584l5.233-5.231c.21-.21.514-.257.715-.122l.062.051z" fill-rule="evenodd"/></svg>',
    info: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.5 10c.28 0 .5.22.5.5V19h2.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5H11v-7H8.5c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm-1-7a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z" fill-rule="evenodd"/></svg>',
    infoOval: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11C5.923 23 .998 18.075.998 12s4.925-11 11-11zm.749 8.811H8.971a.468.468 0 00-.472.472v.945c0 .264.208.472.472.472h2.361v6.611h-2.36a.468.468 0 00-.473.472v.945c0 .264.208.472.472.472h6.611a.468.468 0 00.473-.472v-.945a.468.468 0 00-.473-.472h-2.36v-8.028a.468.468 0 00-.473-.472zM11.805 3.2a1.653 1.653 0 100 3.305 1.653 1.653 0 000-3.305z"/></svg>',
    logout: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1C9.043 1 6.34 2.145 4.358 4.06a1.1 1.1 0 101.53 1.58C7.466 4.115 9.607 3.2 12 3.2c4.873 0 8.8 3.927 8.8 8.8 0 4.873-3.927 8.8-8.8 8.8a8.843 8.843 0 01-6.115-2.446 1.1 1.1 0 10-1.521 1.59A11.045 11.045 0 0012 23c6.062 0 11-4.938 11-11S18.062 1 12 1zM5.418 8c-.288.01-.562.13-.763.34l-3.33 3.365a1.13 1.13 0 000 1.586l3.33 3.364c.278.293.692.411 1.08.309.39-.103.693-.41.795-.803a1.13 1.13 0 00-.306-1.092L4.79 13.62h10.085c.4.006.773-.207.975-.556.201-.35.201-.781 0-1.13a1.108 1.108 0 00-.975-.557H4.79l1.435-1.45a1.13 1.13 0 00.249-1.242A1.11 1.11 0 005.418 8z"/></svg>',
    logoutNew: '<svg width="24px" height="24px" viewBox="0 0 24 24"><g stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M5.18421053,1 C3.43592026,1 2,2.43592026 2,4.18421053 L2,19.8157895 C2,21.5640797 3.43592026,23 5.18421053,23 L12.1315789,23 C13.8798692,23 15.3157895,21.5640797 15.3157895,19.8157895 L15.3157895,14.3157895 L13.5789474,14.3157895 L13.5789474,19.8157895 C13.5789474,20.6252887 12.9410782,21.2631579 12.1315789,21.2631579 L5.18421053,21.2631579 C4.37471126,21.2631579 3.73684211,20.6252887 3.73684211,19.8157895 L3.73684211,4.18421053 C3.73684211,3.37471132 4.37471126,2.73684211 5.18421053,2.73684211 L12.1315789,2.73684211 C12.9410782,2.73684211 13.5789474,3.37471132 13.5789474,4.18421053 L13.5789474,9.68421053 L15.3157895,9.68421053 L15.3157895,4.18421053 C15.3157895,2.43592026 13.8798692,1 12.1315789,1 L5.18421053,1 Z M17.9120066,7.06990132 C17.5584752,7.06990132 17.2402766,7.28435667 17.1073954,7.61196468 C16.9745142,7.93957269 17.0534721,8.31503261 17.3070517,8.56136932 L19.8772614,11.1315789 L6.92105263,11.1315789 C6.60786881,11.1271497 6.31656092,11.2916943 6.15867645,11.5622054 C6.00079198,11.8327164 6.00079198,12.1672836 6.15867645,12.4377946 C6.31656092,12.7083057 6.60786881,12.8728503 6.92105263,12.8684211 L19.8772614,12.8684211 L17.3070517,15.4386307 C17.0801932,15.656447 16.9888117,15.9798867 17.068149,16.2842127 C17.1474863,16.5885387 17.3851455,16.8261979 17.6894715,16.9055352 C17.9937975,16.9848726 18.3172372,16.893491 18.5350535,16.6666325 L22.5876851,12.6140009 C22.9266893,12.2748565 22.9266893,11.7251435 22.5876851,11.3859991 L18.5350535,7.33336753 C18.3715131,7.16495103 18.1467609,7.06990132 17.9120066,7.06990132 Z"></path></g></svg>',
    minus: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.5 11h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5" fill-rule="evenodd"/></svg>',
    play: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5 4.764v14.472a1.7 1.7 0 002.62 1.43l11.37-7.32a1.6 1.6 0 000-2.691L7.62 3.335A1.7 1.7 0 005 4.765z"/></svg>',
    playOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5 4.764v14.472a1.7 1.7 0 002.62 1.43l11.37-7.32a1.6 1.6 0 000-2.691L7.62 3.335A1.7 1.7 0 005 4.765zm2.723.804l9.433 5.931a.7.7 0 01-.011 1.192l-9.433 5.691a.7.7 0 01-1.061-.6V6.162a.7.7 0 011.072-.593z"/></svg>',
    plus: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.5 11H13V5.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V11H5.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H11v5.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V13h5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    questionMark: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13 17a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5zm-.775-13c2.602 0 4.38 1.639 4.38 4.138 0 1.454-.41 2.274-1.864 3.462-1.318 1.054-1.684 1.797-1.734 3.055a.358.358 0 01-.357.345h-1.292a.358.358 0 01-.358-.358c0-1.106.123-1.69.41-2.285.266-.614.696-1.147 1.331-1.638 1.291-1.024 1.516-1.557 1.516-2.5 0-1.413-1.192-2.273-2.134-2.273-1.431 0-2.309.865-2.44 2.581a.503.503 0 01-.5.471h-1.35a.5.5 0 01-.5-.539C7.566 5.72 9.434 4 12.226 4z" fill-rule="evenodd"/></svg>',
    questionMarkFill: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11C5.923 23 .998 18.075.998 12s4.925-11 11-11zm1 16h-2a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zm-.775-13c-2.791 0-4.66 1.719-4.891 4.46a.5.5 0 00.5.538h1.35a.503.503 0 00.498-.47c.132-1.717 1.01-2.582 2.441-2.582.942 0 2.134.86 2.134 2.274 0 .942-.225 1.475-1.516 2.499-.635.491-1.065 1.024-1.33 1.638-.288.595-.41 1.179-.41 2.285 0 .198.16.358.357.358h1.292a.358.358 0 00.357-.345c.05-1.258.416-2.001 1.734-3.055 1.455-1.188 1.865-2.008 1.865-3.462 0-2.5-1.78-4.138-4.38-4.138z"/></svg>',
    refresh: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.82 7.517a.234.234 0 00-.334-.003L16.402 8.6a.233.233 0 00-.003.324c1.46 1.574 2.088 3.93 1.175 6.363a5.643 5.643 0 01-3.287 3.288c-5.034 1.889-9.747-2.821-7.863-7.855a5.652 5.652 0 013.309-3.3 6.384 6.384 0 012.73-.4l-1.527 1.387a.5.5 0 000 .707l.707.708a.5.5 0 00.707 0l3.536-3.536a.5.5 0 000-.707L12.35 2.042a.5.5 0 00-.707 0l-.69.69a.5.5 0 000 .707l1.754 1.593a8.443 8.443 0 00-3.551.464 7.662 7.662 0 00-4.726 4.851 8.042 8.042 0 0010.235 10.22 7.685 7.685 0 004.902-4.904c1.022-3.13.154-6.13-1.747-8.146" fill-rule="evenodd"/></svg>',
    reload: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.48 12c.29 0 .52.245.502.533a7.977 7.977 0 01-2.955 5.695c-2.847 2.312-6.98 2.368-9.885.129a8.154 8.154 0 01-1.279-1.227l.114 2.377a.5.5 0 01-.5.5h-.975a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5l-2.048-.097c.192.222.4.436.63.635 2.22 1.92 5.575 1.933 7.806.027a5.979 5.979 0 002.093-4.111.498.498 0 01.496-.461zm.019-8a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5l2.058.099a6.076 6.076 0 00-.632-.64c-2.22-1.923-5.579-1.936-7.811-.027a5.98 5.98 0 00-2.091 4.116.498.498 0 01-.497.462H4.525a.501.501 0 01-.501-.533 7.974 7.974 0 012.938-5.689c2.843-2.321 6.982-2.387 9.892-.15.484.372.911.784 1.282 1.227L18.023 4.5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    reset: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.999 1C5.941 1 1 5.94 1 11.999c0 6.061 4.941 10.999 10.999 10.999 5.546 0 10.153-4.135 10.893-9.492a1.268 1.268 0 10-2.512-.344A8.456 8.456 0 0112 20.46a8.441 8.441 0 01-8.46-8.461 8.443 8.443 0 018.46-8.46 8.465 8.465 0 016.716 3.304L17.208 8.35a.505.505 0 00-.106.503c.05.171.192.28.37.317 2.28.45 4.915.251 5.024.238a.518.518 0 00.29-.159c.077-.076.143-.152.16-.264.012-.11.21-2.767-.239-5.05a.468.468 0 00-.317-.37.511.511 0 00-.502.105l-1.375 1.375A11 11 0 0011.999 1z"/></svg>',
    shuffle: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.822 13.422L18 16.599V14a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v5.513a.5.5 0 01-.5.5H14a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.584l-3.177-3.177 1.415-1.414zM19.5 4a.5.5 0 01.5.5V10a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7.416L5.742 19.672a.5.5 0 01-.707 0l-.707-.708a.5.5 0 010-.707L16.588 6H14a.5.5 0 01-.5-.5v-1A.5.5 0 0114 4h5.5zm-13.758.34L10.58 9.18l-1.414 1.414-4.837-4.838a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0z"/></svg>',
    shuffleAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.318 13.111a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L18.379 16l-2.426.003A2.752 2.752 0 0113.7 14.83l-1.98-2.828 1.98-2.829A2.752 2.752 0 0115.953 8l2.426.003-1.475 1.475a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l3.536-3.535a.5.5 0 000-.707l-3.536-3.536a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707L18.376 6h-2.423a4.753 4.753 0 00-3.892 2.027l-1.56 2.23-1.562-2.23A4.753 4.753 0 005.047 6H2v2h3.047c.897 0 1.74.439 2.253 1.173l1.98 2.829L7.3 14.83a2.753 2.753 0 01-2.253 1.173H2v2h3.047a4.753 4.753 0 003.892-2.027l1.561-2.23 1.561 2.23a4.753 4.753 0 003.892 2.027h2.423l-1.472 1.472a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l3.536-3.535a.5.5 0 000-.707l-3.536-3.536z"/></svg>',
    shuffleAlt2: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.201 13.027a.494.494 0 01.117.084l3.536 3.536a.5.5 0 010 .707l-3.536 3.535a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l1.472-1.472h-2.423a4.753 4.753 0 01-3.892-2.027l-.34-.486 1.22-1.744.759 1.084a2.752 2.752 0 002.253 1.173L18.379 16l-1.475-1.475a.5.5 0 010-.707l.707-.707a.495.495 0 01.116-.084 2.567 2.567 0 00.474 0zm-.59-9.913a.5.5 0 01.707 0l3.536 3.536a.5.5 0 010 .707l-3.536 3.535a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l1.475-1.475L15.953 8c-.897 0-1.74.439-2.253 1.173l-4.76 6.803a4.753 4.753 0 01-3.893 2.027H2v-2h3.047c.897 0 1.74-.439 2.253-1.173l4.761-6.803A4.754 4.754 0 0115.953 6h2.423l-1.472-1.471a.5.5 0 010-.708zM5.047 6c1.55 0 3.004.758 3.892 2.027l.34.486-1.22 1.745L7.3 9.173A2.752 2.752 0 005.047 8H2V6z"/></svg>',
    borderOpacity: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M20.5 21a.5.5 0 01-.5-.5v-17a.5.5 0 011 0v17a.5.5 0 01-.5.5" opacity=".25"/><path fill="currentColor" d="M16.832 21h-1a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v17a.5.5 0 01-.5.5" opacity=".4"/><path fill="currentColor" d="M12.164 21h-2a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v17a.5.5 0 01-.5.5" opacity=".75"/><path fill="currentColor" d="M6.497 21H3.503a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h2.994a.5.5 0 01.5.5v17a.5.5 0 01-.5.5"/></g></svg>',
    borderProps: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 3c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5H5v15.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-17c0-.28.22-.5.5-.5zm-12 16c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm4 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm4 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm4 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-4c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-4c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-4c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    color: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.7 15.24l3.11 5.38c.15.27.03.61-.25.72-1.1.43-2.3.66-3.56.66s-2.47-.24-3.57-.66a.507.507 0 01-.26-.72l3.11-5.38c.1-.17.29-.26.48-.25.08.01.16.01.24.01.07 0 .15 0 .22-.01.2-.02.38.08.48.25zm8.69-2.23c.3-.01.53.26.49.57a9.977 9.977 0 01-3.58 6.19c-.24.19-.6.13-.75-.14l-3.11-5.39c-.1-.17-.09-.37.02-.53.09-.13.18-.28.25-.42a.5.5 0 01.45-.28zM8.85 13c.19 0 .37.11.45.29.07.14.15.28.24.41.11.16.12.36.02.53l-3.11 5.39c-.15.27-.51.33-.75.14-.27-.22-.52-.45-.76-.69a9.98 9.98 0 01-2.81-5.49c-.05-.31.18-.58.49-.58zM6.44 4.38l3.11 5.39c.1.17.09.37-.02.53-.09.13-.17.27-.24.41-.08.18-.25.29-.44.29H2.62a.51.51 0 01-.5-.58 9.915 9.915 0 012.81-5.49c.24-.24.5-.47.76-.69.24-.19.6-.12.75.14zm11.86-.14c.27.22.52.45.76.69a9.98 9.98 0 012.81 5.49c.05.3-.19.58-.5.58h-6.23c-.18 0-.35-.11-.44-.28-.07-.15-.15-.29-.24-.42a.506.506 0 01-.02-.53l3.11-5.39c.15-.27.51-.33.75-.14zM12 2c1.26 0 2.47.24 3.57.66.29.11.41.46.26.72l-3.11 5.38c-.1.17-.29.26-.48.25C12.16 9 12.08 9 12 9s-.16 0-.25.01a.504.504 0 01-.48-.25l-3.1-5.38a.507.507 0 01.26-.72C9.53 2.24 10.74 2 12 2z" fill-rule="evenodd"/></svg>',
    colorAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 16l.027.04.194.29c.521.793 1.779 2.798 1.779 3.67 0 1.1-.9 2-2 2s-2-.9-2-2c0-.872 1.258-2.877 1.779-3.67l.194-.29.027-.04zM9.72 2.45c.2-.2.51-.2.71 0l10.32 10.32c.23.24.06.64-.27.64h-1.92l-7.07 7.07c-.78.78-2.05.78-2.83 0l-7.07-7.07c-.78-.78-.78-2.05 0-2.83zm.35 2.48L3 12h14.14z" fill-rule="evenodd"/></svg>',
    colorColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M2.62 13h6.23c.19 0 .37.11.45.29.07.14.15.28.24.41.11.16.12.36.02.53l-3.11 5.39c-.15.27-.51.33-.75.14-.27-.22-.52-.45-.76-.69a9.98 9.98 0 01-2.81-5.49c-.05-.31.18-.58.49-.58z" opacity=".53"/><path fill="currentColor" d="M6.44 4.38l3.11 5.39c.1.17.09.37-.02.53-.09.13-.17.27-.24.41-.08.18-.25.29-.44.29H2.62a.51.51 0 01-.5-.58 9.915 9.915 0 012.81-5.49c.24-.24.5-.47.76-.69.24-.19.6-.12.75.14z" opacity=".422"/><path fill="currentColor" d="M21.88 13.58a9.977 9.977 0 01-3.58 6.19c-.24.19-.6.13-.75-.14l-3.11-5.39c-.1-.17-.09-.37.02-.53.09-.13.18-.28.25-.42a.5.5 0 01.45-.28h6.23c.3-.01.53.26.49.57z" opacity=".77"/><path fill="currentColor" d="M14.7 10.72c-.07-.15-.15-.29-.24-.42a.506.506 0 01-.02-.53l3.11-5.39c.15-.27.51-.33.75-.14.27.22.52.45.76.69a9.98 9.98 0 012.81 5.49c.05.3-.19.58-.5.58h-6.23c-.18 0-.35-.11-.44-.28z" opacity=".88"/><path fill="currentColor" d="M15.83 3.38l-3.11 5.38c-.1.17-.29.26-.48.25C12.16 9 12.08 9 12 9s-.16 0-.25.01a.504.504 0 01-.48-.25l-3.1-5.38a.507.507 0 01.26-.72C9.53 2.24 10.74 2 12 2c1.26 0 2.47.24 3.57.66.29.11.41.46.26.72z"/><path fill="currentColor" d="M8.17 20.62l3.11-5.38c.1-.17.29-.26.48-.25.08.01.16.01.24.01.07 0 .15 0 .22-.01.2-.02.38.08.48.25l3.11 5.38c.15.27.03.61-.25.72-1.1.43-2.3.66-3.56.66-1.26 0-2.47-.24-3.57-.66a.507.507 0 01-.26-.72z" opacity=".65"/></g></svg>',
    colorInvert: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2l.28.004C17.664 2.152 22 6.58 22 12c0 5.514-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 1.991l.001 16.017c4.415 0 8.007-3.593 8.007-8.008 0-4.416-3.592-8.008-8.008-8.008z" fill-rule="evenodd"/></svg>',
    colorOpacity: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd" transform="translate(2 2)"><circle cx="6" cy="6" r="6" opacity=".25"/><circle cx="10" cy="10" r="6" opacity=".5"/><circle cx="14" cy="14" r="6"/></g></svg>',
    colorOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M17.24 13.41l1.91.62c-1.42 3.22-4.5 5.56-8.15 5.92v-2.01c2.77-.34 5.09-2.1 6.24-4.53zm-14.48 0A8.053 8.053 0 009 17.94v2.01c-3.65-.36-6.73-2.7-8.15-5.92zM16.65 2.55A9.938 9.938 0 0120 10.01c0 .73-.08 1.44-.23 2.12l-1.91-.62c.09-.49.14-.99.14-1.5 0-2.3-.97-4.37-2.53-5.83zm-13.3 0l1.18 1.63A7.955 7.955 0 002 10.01c0 .51.05 1.01.14 1.5l-1.91.62C.08 11.45 0 10.74 0 10.01c0-2.97 1.29-5.63 3.35-7.46zM9.99 0c1.84 0 3.56.5 5.04 1.37L13.85 3A7.929 7.929 0 0010 2.01c-1.4 0-2.71.36-3.85.99l-1.2-1.63C6.43.5 8.15 0 9.99 0z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2 2.02)"><path fill="currentColor" d="M0 0h20v19.95H0V0z"/></g></svg>',
    colorOutlineColored: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.24 15.43c-1.15 2.43-3.47 4.19-6.24 4.53v2.01c3.65-.36 6.73-2.7 8.15-5.92l-1.91-.62z" opacity=".7"/><path fill="currentColor" d="M11 19.96a8.053 8.053 0 01-6.24-4.53l-1.91.62c1.42 3.22 4.5 5.56 8.15 5.92v-2.01z" opacity=".5"/><path fill="currentColor" d="M8.15 5.02c1.14-.63 2.45-.99 3.85-.99s2.71.36 3.85.99l1.18-1.63a9.908 9.908 0 00-5.04-1.37c-1.84 0-3.56.5-5.04 1.37l1.2 1.63z"/><path fill="currentColor" d="M18.65 4.57L17.47 6.2A7.955 7.955 0 0120 12.03c0 .51-.05 1.01-.14 1.5l1.91.62c.15-.68.23-1.39.23-2.12 0-2.97-1.29-5.63-3.35-7.46z" opacity=".85"/><path fill="currentColor" d="M4.14 13.53c-.09-.49-.14-.99-.14-1.5 0-2.3.97-4.37 2.53-5.83L5.35 4.57A9.938 9.938 0 002 12.03c0 .73.08 1.44.23 2.12l1.91-.62z" opacity=".42"/></svg>',
    colorShades: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M7.983 5.084v13.83A8.002 8.002 0 014.001 12a8.002 8.002 0 013.982-6.915"/><path fill="currentColor" d="M11.978 4v16a7.964 7.964 0 01-3.995-1.086V5.084A7.964 7.964 0 0111.978 4" opacity=".75"/><path fill="currentColor" d="M15.97 5.057v13.885A7.94 7.94 0 0112 19.999h-.022V4h.023c1.445 0 2.8.385 3.97 1.058" opacity=".5"/><path fill="currentColor" d="M4 12c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8zm-2 0C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10S2 17.514 2 12z"/></g></svg>',
    alignCenter: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path fill="currentColor" d="M7.502 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path fill="currentColor" d="M7.502 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path fill="currentColor" d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    alignJustify: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path fill="currentColor" d="M5.5 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path fill="currentColor" d="M5.5 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path fill="currentColor" d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    alignLeft: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M20.5 7h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path fill="currentColor" d="M16.5 11h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".7"/><path fill="currentColor" d="M16.5 19h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".3"/><path fill="currentColor" d="M20.5 15h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".5"/></g></svg>',
    alignRight: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M3.5 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path fill="currentColor" d="M3.5 11h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path fill="currentColor" d="M3.5 19h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path fill="currentColor" d="M3.5 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    analytics: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21 7a2 2 0 00-1.97 2.34l-3.343 2.785A2 2 0 0015 12a2 2 0 00-1.102.332l-2.904-1.453A2 2 0 007 11a2 2 0 00.006.129l-3.121 2.08a2 2 0 101.11 1.664l3.12-2.082A2 2 0 009 13a2 2 0 001.102-.332l2.904 1.453a2 2 0 103.965-.46l3.341-2.786A2 2 0 0021 11a2 2 0 100-4z"/></svg>',
    animations: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.5 11a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zm4-4a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V9H7.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    animationsAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8 10a6.007 6.007 0 015.996 5.775L14 16c0 3.309-2.692 6-6 6-3.309 0-6-2.691-6-6 0-3.308 2.691-6 6-6zm4-4c3.308 0 6 2.692 6 6l-.006.263a5.998 5.998 0 01-2.551 4.647c.036-.299.057-.602.057-.91l-.009-.357a7.526 7.526 0 00-.196-1.38A3.974 3.974 0 0016 12c0-2.205-1.794-4-4-4-.84 0-1.62.261-2.263.705a7.49 7.49 0 00-2.647-.148A5.995 5.995 0 0112 6zm7.536 4.121l1.06 1.06a.5.5 0 010 .708l-1.06 1.06zM21.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-1.61-3.596l.706.707a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0zm-7.072 0l1.06 1.06H11.05l1.06-1.06a.5.5 0 01.708 0zM16.5 2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    animationsAltOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8 10c3.308 0 6 2.692 6 6 0 3.309-2.692 6-6 6s-6-2.691-6-6c0-3.308 2.692-6 6-6zm0 2c-2.206 0-4 1.795-4 4 0 2.206 1.794 4 4 4s4-1.794 4-4c0-2.205-1.794-4-4-4zm4-6c3.308 0 6 2.692 6 6a5.996 5.996 0 01-2.557 4.91 7.49 7.49 0 00-.148-2.646A3.975 3.975 0 0016 12c0-2.205-1.794-4-4-4-.84 0-1.62.262-2.263.705a7.494 7.494 0 00-2.647-.148A5.996 5.996 0 0112 6zm7.536 4.121l1.06 1.06a.5.5 0 010 .708l-1.06 1.06zM21.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-1.61-3.596l.706.707a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0zm-7.072 0l1.06 1.06H11.05l1.061-1.06a.5.5 0 01.707 0zM16.5 2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    animationsOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.5 11a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5zM11 13H5v6h6zm5.5-6a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V9H7.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm0-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-4-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-8 0a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    blocks: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.25 5.1c-.967 0-1.75.766-1.75 1.713v10.274c0 .947.783 1.713 1.75 1.713h17.5c.967 0 1.75-.766 1.75-1.713V6.813c0-.947-.783-1.713-1.75-1.713H3.25zm1.9 2.1h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5V7.7a.5.5 0 01.5-.5zm8.4 0h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5V7.7a.5.5 0 01.5-.5zm-8.4 5.25h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5v-3.2a.5.5 0 01.5-.5zm8.4 0h5.3a.5.5 0 01.5.5v3.2a.5.5 0 01-.5.5h-5.3a.5.5 0 01-.5-.5v-3.2a.5.5 0 01.5-.5z"/></svg>',
    blocksAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.25 3.5c-.967 0-1.75.766-1.75 1.713v10.274c0 .947.783 1.713 1.75 1.713h17.5c.967 0 1.75-.766 1.75-1.712V5.213c0-.947-.783-1.713-1.75-1.713H3.25zm1.4 2.1h6.3v4.2h-6.3V5.6zm8.4 0h6.3v4.2h-6.3V5.6zm-8.4 5.25h6.3v4.2h-6.3v-4.2zm8.4 0h6.3v4.2h-6.3v-4.2zM7.885 18.4c-.314-.005-.607.194-.766.52a1.236 1.236 0 000 1.06c.159.326.452.525.766.52h8.73c.314.005.607-.194.766-.52a1.236 1.236 0 000-1.06c-.159-.326-.452-.525-.766-.52h-8.73z"/></svg>',
    blocksAltOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4 4c-1.097 0-2 .886-2 1.962v10.461c0 1.076.903 1.962 2 1.962h16c1.097 0 2-.886 2-1.962V5.962C22 4.886 21.097 4 20 4H4zm0 1.308h16c.375 0 .667.285.667.654v10.461a.652.652 0 01-.667.654H4a.652.652 0 01-.667-.654V5.962c0-.369.292-.654.667-.654zm1.333 1.307a.66.66 0 00-.666.654v2.616a.66.66 0 00.666.653h5.334a.66.66 0 00.666-.653V7.269a.66.66 0 00-.666-.654H5.333zm8 0a.66.66 0 00-.666.654v2.616a.66.66 0 00.666.653h5.334a.66.66 0 00.666-.653V7.269a.66.66 0 00-.666-.654h-5.334zM6 7.923h4v1.308H6V7.923zm8 0h4v1.308h-4V7.923zm-8.667 3.923a.66.66 0 00-.666.654v2.615a.66.66 0 00.666.654h5.334a.66.66 0 00.666-.654V12.5a.66.66 0 00-.666-.654H5.333zm8 0a.66.66 0 00-.666.654v2.615a.66.66 0 00.666.654h5.334a.66.66 0 00.666-.654V12.5a.66.66 0 00-.666-.654h-5.334zM6 13.154h4v1.308H6v-1.308zm8 0h4v1.308h-4v-1.308zm-6.667 6.538V21h9.334v-1.308H7.333z"/></svg>',
    blocksHalfOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 4.8c1.097 0 2 .886 2 1.962v10.461c0 1.076-.903 1.962-2 1.962H4c-1.097 0-2-.886-2-1.962V6.762C2 5.686 2.903 4.8 4 4.8zm0 1.308H4a.652.652 0 00-.667.654v10.461c0 .368.292.654.667.654h16a.652.652 0 00.667-.654V6.762A.652.652 0 0020 6.108zm-9.473 6.738c.335 0 .606.263.606.587v2.35a.597.597 0 01-.606.586H5.673a.597.597 0 01-.606-.587v-2.349c0-.324.271-.587.606-.587zm7.8 0c.335 0 .606.263.606.587v2.35a.597.597 0 01-.606.586h-4.854a.597.597 0 01-.606-.587v-2.349c0-.324.271-.587.606-.587zm-7.8-5.23c.335 0 .606.262.606.587v2.348a.597.597 0 01-.606.587H5.673a.597.597 0 01-.606-.587V8.203c0-.325.271-.588.606-.588zm7.8 0c.335 0 .606.262.606.587v2.348a.597.597 0 01-.606.587h-4.854a.597.597 0 01-.606-.587V8.203c0-.325.271-.588.606-.588z"/></svg>',
    blocksOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 4.8c1.097 0 2 .886 2 1.962v10.461c0 1.076-.903 1.962-2 1.962H4c-1.097 0-2-.886-2-1.962V6.762C2 5.686 2.903 4.8 4 4.8zm0 1.308H4a.652.652 0 00-.667.654v10.461c0 .368.292.654.667.654h16a.652.652 0 00.667-.654V6.762A.652.652 0 0020 6.108zm-9.333 6.538a.66.66 0 01.666.654v2.615a.66.66 0 01-.666.654H5.333a.66.66 0 01-.666-.654V13.3a.66.66 0 01.666-.654zm8 0a.66.66 0 01.666.654v2.615a.66.66 0 01-.666.654h-5.334a.66.66 0 01-.666-.654V13.3a.66.66 0 01.666-.654zM10 13.954H6v1.308h4v-1.308zm8 0h-4v1.308h4v-1.308zm-7.333-6.539a.66.66 0 01.666.654v2.616a.66.66 0 01-.666.653H5.333a.66.66 0 01-.666-.653V8.069a.66.66 0 01.666-.654zm8 0a.66.66 0 01.666.654v2.616a.66.66 0 01-.666.653h-5.334a.66.66 0 01-.666-.653V8.069a.66.66 0 01.666-.654zM10 8.723H6v1.308h4V8.723zm8 0h-4v1.308h4V8.723z"/></svg>',
    burgerMenu: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 17c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-17c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-6c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-17c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm0-6c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-17c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    clock: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.523 19.983c-4.823.309-8.815-3.684-8.506-8.507.254-3.97 3.471-7.195 7.441-7.458 2.403-.16 4.6.75 6.165 2.298L12 11.94 9.383 9.322a.5.5 0 00-.707 0l-.354.354a.5.5 0 000 .707l3.324 3.324a.5.5 0 00.707 0l6.237-6.236a7.965 7.965 0 011.386 5.155c-.302 3.937-3.512 7.105-7.453 7.357M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-.499 3.003h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5m-.5 13.496v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5m-6-6v-.995a.5.5 0 01.5-.5h.993a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H5.5a.5.5 0 01-.5-.5m13.496.5h-.994a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5" fill-rule="evenodd"/></svg>',
    clockColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm5.623 4.316a7.975 7.975 0 00-6.165-2.298c-3.97.263-7.187 3.487-7.441 7.458-.31 4.823 3.683 8.816 8.506 8.507 3.94-.252 7.15-3.42 7.453-7.357a7.965 7.965 0 00-1.387-5.155z" opacity=".4"/><path fill="currentColor" d="M11.5 5.003h.995a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5M11 18.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5M5 12.5v-.995a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H5.5a.5.5 0 01-.5-.5m13.496.5h-.994a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5" opacity=".55"/><path fill="currentColor" d="M17.623 6.316L12 11.94 9.382 9.322a.5.5 0 00-.707 0l-.353.354a.5.5 0 000 .707l3.324 3.324a.5.5 0 00.707 0l6.236-6.236-.966-1.155z"/></g></svg>',
    clockOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.998 19.936V18.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1.435A8.013 8.013 0 014.065 13h1.433a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H4.065a8.013 8.013 0 016.933-6.935V5.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V4.065a7.98 7.98 0 014.625 2.251L12 11.94 9.383 9.322a.5.5 0 00-.707 0l-.354.354a.5.5 0 000 .707l3.324 3.324a.5.5 0 00.707 0l6.237-6.236a7.949 7.949 0 011.345 3.53h-1.437a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.437a8.013 8.013 0 01-6.937 6.935M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2" fill-rule="evenodd"/></svg>',
    clockOutlineColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm5.623 4.316a7.975 7.975 0 00-6.165-2.298c-3.97.263-7.187 3.487-7.441 7.458-.31 4.823 3.683 8.816 8.506 8.507 3.94-.252 7.15-3.42 7.453-7.357a7.965 7.965 0 00-1.387-5.155l-6.236 6.236a.5.5 0 01-.707 0l-3.324-3.324a.5.5 0 010-.707l.353-.354a.5.5 0 01.707 0L12 11.94z"/><path fill="currentColor" d="M11.5 5.003h.995a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5M11 18.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H11.5a.5.5 0 01-.5-.5M5 12.5v-.995a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5H5.5a.5.5 0 01-.5-.5m13.496.5h-.994a.5.5 0 01-.5-.5v-.994a.5.5 0 01.5-.5h.994a.5.5 0 01.5.5v.994a.5.5 0 01-.5.5" opacity=".65"/></g></svg>',
    cloud: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.393 8.5h-.417A5.998 5.998 0 0012 3a5.996 5.996 0 00-5.45 3.504c-.017 0-.033-.004-.05-.004a5.5 5.5 0 00-5.496 5.7c.105 2.981 2.645 5.3 5.628 5.3H18.5a4.5 4.5 0 004.497-4.664c-.087-2.439-2.165-4.336-4.605-4.336" fill-rule="evenodd"/></svg>',
    cloudOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.46 9a4.463 4.463 0 00-3.199 1.376 4.468 4.468 0 00-1.258 3.29C2.088 16.055 4.164 18 6.632 18H18.5c.958 0 1.853-.38 2.518-1.07a3.476 3.476 0 00.98-2.559c-.066-1.858-1.684-3.37-3.606-3.37h-1.338l-.076-.918C16.765 7.513 14.58 5.5 12 5.5a5.014 5.014 0 00-4.542 2.92l-.272.593zM18.5 20H6.632C3.1 20 .127 17.19.004 13.736a6.452 6.452 0 011.818-4.75A6.44 6.44 0 015.93 7.026 7.02 7.02 0 0112 3.5c3.304 0 6.149 2.36 6.837 5.518 2.787.221 5.06 2.506 5.16 5.283a5.46 5.46 0 01-1.54 4.018A5.454 5.454 0 0118.5 20z" fill-rule="evenodd"/></svg>',
    comments: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.499 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-6.086l-3.06 2.854a.5.5 0 01-.708 0L8.585 20H2.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H4.001v12h5.412L12 20.38 14.585 18h5.414zm-3.5 7a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-3-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    content: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3 4v12h18V4H3zm4 3h10v2H7V7zm0 4h7v2H7v-2zm-5 7v2h20v-2H2z"/></svg>',
    copy: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.5 9c.28 0 .5.22.5.5V19h9.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-11c-.28 0-.5-.22-.5-.5v-11c0-.28.22-.5.5-.5zm16-6c.28 0 .5.22.5.5v13c0 .28-.22.5-.5.5h-13c-.28 0-.5-.22-.5-.5v-13c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    copyOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.5 9c.28 0 .5.22.5.5V19h9.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-11c-.28 0-.5-.22-.5-.5v-11c0-.28.22-.5.5-.5zm16-6c.28 0 .5.22.5.5v13c0 .28-.22.5-.5.5h-13c-.28 0-.5-.22-.5-.5v-13c0-.28.22-.5.5-.5zM19 5H9v10h10z" fill-rule="evenodd"/></svg>',
    copywriting: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.4 1c-1.21 0-2.2.99-2.2 2.2v17.6c0 1.21.99 2.2 2.2 2.2h13.2c1.21 0 2.2-.99 2.2-2.2V7.6L14.2 1H5.4zm7.7 1.65l6.05 6.05H13.1V2.65zm-2.802 8.263c.645 0 1.292.251 1.79.76.717.732 1.026 1.808 1.012 2.548-.019 1.01-.572 2.13-1.463 3.094.185.118.356.185.5.185.423 0 .706-.298 1.208-.928.452-.567 1.016-1.272 1.955-1.272.488 0 .92.323 1.057.793.132.438.605 1.407 1.143 1.407v2.2c-1.18 0-2.036-.741-2.587-1.568-.556.685-1.379 1.568-2.776 1.568-.785 0-1.567-.38-2.255-.973-1.01.595-2.174.973-3.382.973v-2.2c.678 0 1.354-.2 1.966-.513-.51-.884-.834-1.863-.864-2.748-.026-.753.204-1.824.933-2.578a2.445 2.445 0 011.763-.748zm.005 2.187c-.053 0-.107.007-.187.09-.19.197-.33.623-.318.971.017.48.177.984.412 1.45.424-.5.682-1.018.69-1.432.004-.231-.13-.708-.382-.965-.113-.115-.182-.114-.215-.114z"/></svg>',
    copywritingOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.4 1c-1.204 0-2.2.996-2.2 2.2v17.6c0 1.204.996 2.2 2.2 2.2h13.2c1.204 0 2.2-.996 2.2-2.2V7.6L14.2 1H5.4zm0 2.2h7.7v5.5h5.5v12.1H5.4V3.2zm4.903 6.6c-.992 0-1.784.64-2.18 1.302a3.677 3.677 0 00-.523 2.037c.035.992.43 1.912.935 2.758-.326.152-.685.503-.935.503v2.2c.92 0 1.727-.368 2.47-.85.59.48 1.249.85 2.067.85 1.128 0 1.872-.633 2.398-1.199.079.161.067.315.2.47.371.435 1.017.729 1.665.729v-3.294-.006a1.1 1.1 0 00-1.1-1.1c-.66 0-1.139.37-1.435.668-.297.297-.501.589-.703.834-.403.49-.617.698-1.025.698-.039 0-.246-.211-.337-.251.719-.899 1.279-1.902 1.3-3.028v-.002c.012-.67-.171-1.342-.582-1.998-.411-.655-1.19-1.321-2.215-1.321zm0 2.2c.117 0 .194.042.35.29.156.248.25.675.247.79-.005.266-.387.741-.612 1.165-.176-.42-.476-.853-.488-1.184-.008-.217.079-.613.208-.829.13-.216.155-.232.295-.232z"/></svg>',
    customize: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.515 21.827l2.323-2.851 3.675.151a.468.468 0 00.33-.818l-6.38-5.65a.468.468 0 00-.778.35v8.522c0 .44.552.637.83.296M2.499 9h1.634A4.003 4.003 0 008 12a4.003 4.003 0 003.868-3h9.632a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H11.87a4.003 4.003 0 00-3.868-3 4.003 4.003 0 00-3.868 3H2.499a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" fill-rule="evenodd"/></svg>',
    customizeOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.001 6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M2.5 9h1.634A4.004 4.004 0 008 12a4.003 4.003 0 003.868-3h9.632a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H11.87c-.445-1.723-2.008-3-3.868-3S4.58 5.277 4.133 7H2.499a.5.5 0 00-.5.5v1a.5.5 0 00.5.5m13.016 12.827l2.323-2.851 3.675.151a.468.468 0 00.33-.818l-6.38-5.65a.468.468 0 00-.778.35v8.522c0 .44.552.637.83.296" fill-rule="evenodd"/></svg>',
    database: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M20.767 15.65c.625.329.933.709.933 1.147l.002.514c-1.842 1.06-5.35 2.35-9.702 2.35-4.427 0-7.985-1.12-9.8-2.189l.1.057v-.732c0-.422.285-.79.865-1.11l.066-.036c1.552.81 4.74 1.84 8.767 1.84 3.991 0 7.161-1.013 8.728-1.82zm-.025-5.655c.641.332.958.715.958 1.16l.001.2c-1.835 1.065-5.146 2.5-9.7 2.5-4.635 0-7.986-1.27-9.8-2.338l.098.056.001-.418c0-.415.275-.775.831-1.091l.124-.067c1.561.726 4.738 1.61 8.745 1.61 3.99 0 7.16-.878 8.726-1.603zM12 3.1c1.678 0 4.102.13 6.107.497 2.005.372 3.589.986 3.593 1.956l.002.17C19.86 6.778 16.355 7.9 12 7.9c-4.431 0-7.985-.946-9.8-2.015l.1.056v-.388c.004-1.901 6.094-2.432 9.495-2.452z"/></svg>',
    databaseOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.254 15.969c.299.25.446.525.446.828l.002.514c-1.842 1.06-5.35 2.35-9.702 2.35-4.427 0-7.985-1.12-9.8-2.189l.1.057v-.732c0-.303.147-.578.444-.827 1.283.828 4.742 2.12 9.254 2.12 4.46 0 7.896-1.264 9.213-2.093zm-.146-5.755c.396.279.592.59.592.941l.001.2c-1.835 1.061-5.146 2.4-9.7 2.4-4.635 0-7.986-1.17-9.8-2.238l.098.056.001-.418c0-.35.196-.662.591-.94 1.391.751 4.762 1.792 9.11 1.792 4.342 0 7.712-1.04 9.102-1.79zM12 3.1c1.678 0 4.102.13 6.107.497 1.73.321 3.147.822 3.505 1.577C19.747 6.213 16.285 7.3 12 7.3c-4.431 0-7.985-.946-9.8-2.015l.123.07C2.743 3.578 8.763 3.1 12 3.1z"/></svg>',
    // The shared navigation's Infra view (CanvasViewNav, AppNavbar); the workspace shell's drawing.
    server: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="3" width="19" height="7" rx="2"/><rect x="2.5" y="14" width="19" height="7" rx="2"/><line x1="6" y1="6.5" x2="6.01" y2="6.5"/><line x1="6" y1="17.5" x2="6.01" y2="17.5"/></svg>',
    disabled: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.002 12c0-1.845.63-3.545 1.683-4.9l11.218 11.217a7.96 7.96 0 01-4.9 1.683c-4.412 0-8-3.588-8-8m16 0c0 1.847-.631 3.547-1.686 4.903L7.1 5.685A7.958 7.958 0 0112.002 4c4.411 0 8 3.589 8 8m-8-10c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10" fill-rule="evenodd"/></svg>',
    discussion: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.498 7a.5.5 0 01.5.5v13.54a.5.5 0 01-.812.391l-2.9-2.321a.5.5 0 00-.313-.11H7.5a.5.5 0 01-.5-.5V16h2v1h9.851l1.147.918V9H19V7zM16.5 2a.5.5 0 01.5.5v11a.5.5 0 01-.5.5H5.85l-3.036 2.431a.5.5 0 01-.812-.39V2.5a.5.5 0 01.5-.5zM15 4H4.002v8.919L5.149 12h9.85zm-2.677 3.184a.25.25 0 01.354 0l.64.64a.25.25 0 010 .354l-.638.638a.25.25 0 01-.354 0l-.64-.64a.25.25 0 010-.354zm-6.002 0a.25.25 0 01.354 0l.64.64a.25.25 0 010 .354l-.638.638a.25.25 0 01-.354 0l-.64-.64a.25.25 0 010-.354zm3.002 0a.25.25 0 01.354 0l.64.64a.25.25 0 010 .354l-.638.638a.25.25 0 01-.354 0l-.64-.64a.25.25 0 010-.354z" fill-rule="evenodd"/></svg>',
    discussionAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.498 9a.5.5 0 01.5.5v11.422a.5.5 0 01-.776.416L17.696 19H9.498a.5.5 0 01-.5-.5v-4.505h2V17H18.3l1.698 1.127V11h-2.99V9zm-7-7a.5.5 0 01.5.5v9a.5.5 0 01-.5.5H6.509l-3.748 2.323a.5.5 0 01-.763-.425V2.5a.5.5 0 01.5-.5zm-1.5 2h-9v7.204L5.94 10h7.058z" fill-rule="evenodd"/></svg>',
    document: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.207 2a.5.5 0 01.353.146l5.295 5.293a.5.5 0 01.147.354V21.5a.5.5 0 01-.5.5H4.5a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5zm-2.208 2H6v16h12.002V10h-5.503a.5.5 0 01-.5-.5zm3.5 12a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-2-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm.5-7.587V8h3.588z"/></svg>',
    download: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13 6.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5v3zM12 21c3.14 0 5.72-2.42 5.97-5.5h.42c2.44 0 4.52-1.9 4.61-4.34a4.5 4.5 0 00-4.5-4.66H13v6.59l2.17-2.19c.2-.2.51-.2.71 0l.71.71c.2.2.2.51 0 .71l-4.24 4.24c-.2.2-.51.2-.71 0L7.4 12.32c-.2-.2-.2-.51 0-.71l.71-.71c.2-.2.51-.2.71 0L11 13.09V6.5H6.63C3.65 6.5 1.11 8.82 1 11.8c-.11 3.13 2.4 5.7 5.5 5.7h.05C7.5 19.56 9.58 21 12 21z" fill-rule="evenodd"/></svg>',
    downloadOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.5 5.501a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H6.624c-2.38 0-4.403 1.796-4.605 4.088a4.468 4.468 0 001.162 3.45A4.511 4.511 0 006.459 16.5l.73-.009.27.588a5.003 5.003 0 005.759 2.77c2.101-.526 3.592-2.4 3.77-4.558l.066-.79h1.344c1.855 0 3.43-1.397 3.587-3.18a3.477 3.477 0 00-.934-2.718c-.683-.727-1.662-1.103-2.66-1.103H15.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.883c1.537 0 3.035.59 4.095 1.703a5.456 5.456 0 011.5 4.294c-.235 2.662-2.454 4.777-5.141 4.986-.689 3.157-3.533 5.517-6.837 5.517a7.02 7.02 0 01-6.07-3.525 6.52 6.52 0 01-4.225-2.086 6.447 6.447 0 01-1.679-4.977C.32 8.098 3.217 5.501 6.624 5.501zM12.5 3a.5.5 0 01.5.5v8.878l2.182-2.182a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-4.242 4.243a.5.5 0 01-.708 0L7.404 11.61a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L11 12.38v-8.88a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    edit: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.008 3.998A1 1 0 0117.42 4l2.595 2.599a1 1 0 01-.001 1.413L8.162 19.85a.5.5 0 01-.354.146l-3.303-.003a.5.5 0 01-.5-.5l.003-3.303a.5.5 0 01.146-.353zm-2.477 4.84l-7.85 7.838v1.643l1.642.001 7.85-7.839zm3.182-3.178l-1.998 1.995 1.642 1.644 1.998-1.995z" fill-rule="evenodd"/></svg>',
    editor: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.813 8.25h-2.625a.438.438 0 01-.438-.438V5.187c0-.241.196-.437.438-.437h2.625c.241 0 .437.196.437.437v2.625a.438.438 0 01-.437.438m8.312-2.75h-2.25a.375.375 0 01-.375-.375v-2.25c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 01-.375.375m-2.312 8.75h-2.625a.438.438 0 01-.438-.438v-2.625c0-.241.196-.437.438-.437h2.625c.241 0 .437.196.437.437v2.625a.438.438 0 01-.437.438M5.5 10h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m0 6h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m6 0h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m-6 6h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m6 0h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5m6 0h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-.5.5"/></svg>',
    editorOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6 8.5a.5.5 0 01.5.5v4h4a.5.5 0 01.5.5v4h4a.5.5 0 01.5.5v5a.5.5 0 01-.5.5H1a.5.5 0 01-.5-.5V9a.5.5 0 01.5-.5h5zM14 19h-3v3h3v-3zm-4.5 0h-3v3h3v-3zM5 19H2v3h3v-3zm0-4.5H2v3h3v-3zm4.5 0h-3v3h3v-3zm10.188-4.125c.241 0 .437.196.437.437v4.375a.437.437 0 01-.437.438h-4.375a.437.437 0 01-.438-.438v-4.375c0-.241.196-.437.438-.437h4.375zm-.875 1.312h-2.625v2.625h2.625v-2.625zM5 10H2v3h3v-3zm8.188-6.125c.241 0 .437.196.437.437v4.375a.437.437 0 01-.437.438H8.813a.437.437 0 01-.438-.438V4.312c0-.241.196-.437.438-.437h4.375zm-.875 1.312H9.688v2.625h2.625V5.187zM22.375 1.25c.207 0 .375.168.375.375v3.75a.375.375 0 01-.375.375h-3.75a.375.375 0 01-.375-.375v-3.75c0-.207.168-.375.375-.375zm-.75 1.125h-2.25v2.25h2.25v-2.25z"/></svg>',
    exclMark: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13 17a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2a.5.5 0 01.5-.5zm0-12.984a.5.5 0 01.5.5v3.952a.5.5 0 01-.002.048l-.578 6.032a.5.5 0 01-.497.452h-.833a.5.5 0 01-.498-.462l-.463-6.027-.001-.019V4.516a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    filter: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9 21.01v-8.24L2.92 3.93c-.23-.33.01-.78.41-.78H20.6a.5.5 0 01.43.75L16 12.73v6.02c0 .21-.13.39-.32.47l-6 2.26a.504.504 0 01-.68-.47zM5.62 4.85l5.08 7.39v7.04l3.6-1.36v-5.64l4.24-7.42H5.62z" fill-rule="evenodd"/></svg>',
    flow: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6 3C4.355 3 3 4.355 3 6c0 1.293.843 2.395 2 2.813V13h2V8.812C8.157 8.396 9 7.293 9 6c0-1.645-1.355-3-3-3zm12 0a3 3 0 00-2.824 2H11v2h4.174A3 3 0 1018 3zM6 5c.564 0 1 .436 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.564.436-1 1-1zm10.524 6v4.156l-2.239 2.383a1.088 1.088 0 000 1.47l2.525 2.686a.934.934 0 001.38 0l2.524-2.687a1.086 1.086 0 000-1.47l-2.238-2.382V11h-1.952zM4 15a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1H4z"/></svg>',
    fn: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.677 18.757a.493.493 0 01-.43.243h-.781a.248.248 0 01-.219-.368c.63-1.15 1.003-2.58 1.003-4.131 0-1.551-.374-2.982-1.004-4.132a.248.248 0 01.22-.368h.781c.176 0 .342.09.43.242.672 1.171 1.073 2.65 1.073 4.258 0 1.607-.401 3.086-1.073 4.256zm-1.806-3.196a.5.5 0 010 .708l-.353.353a.5.5 0 01-.707 0l-1.061-1.06-1.06 1.06a.5.5 0 01-.708 0l-.353-.353a.5.5 0 010-.708l1.06-1.06-1.06-1.06a.5.5 0 010-.708l.353-.354a.5.5 0 01.707 0l1.061 1.061 1.06-1.06a.5.5 0 01.708 0l.353.353a.5.5 0 010 .707l-1.06 1.06zm-4.618 3.071a.248.248 0 01-.218.368h-.924a.25.25 0 01-.216-.12c-.715-1.19-1.145-2.715-1.145-4.38 0-1.607.401-3.086 1.074-4.257a.493.493 0 01.43-.242h.781c.19 0 .31.201.219.368-.63 1.15-1.004 2.58-1.004 4.132 0 1.55.373 2.981 1.003 4.131zM9.75 6.001a.5.5 0 01-.5.5H8.5a.75.75 0 00-.75.75V10h1a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5h-1v5.25A2.25 2.25 0 015.5 19h-.75a.5.5 0 01-.5-.5V18a.5.5 0 01.5-.5h.75a.75.75 0 00.75-.75V11.5h-1a.5.5 0 01-.5-.5v-.5a.5.5 0 01.5-.5h1V7.25A2.25 2.25 0 018.5 5h.75a.5.5 0 01.5.5zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    fnOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.5 4a.5.5 0 01.5.5V5a.5.5 0 01-.5.5h-1a.75.75 0 00-.75.75V10H8a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5H6.75v6.25A2.25 2.25 0 014.5 20h-1a.5.5 0 01-.5-.5V19a.5.5 0 01.5-.5h1a.75.75 0 00.75-.75V11.5H4a.5.5 0 01-.5-.5v-.5A.5.5 0 014 10h1.25V6.25A2.25 2.25 0 017.5 4zm3.305 6c.185 0 .307.193.224.359C11.384 11.645 11 13.255 11 15c0 1.745.384 3.354 1.029 4.64a.248.248 0 01-.224.359h-.787a.495.495 0 01-.44-.262C9.903 18.436 9.5 16.79 9.5 15.001c0-1.79.403-3.436 1.078-4.739a.494.494 0 01.44-.262zm7.678 0c.183 0 .356.099.44.262C20.598 11.564 21 13.21 21 15c0 1.79-.403 3.436-1.077 4.738a.495.495 0 01-.44.262h-.787a.248.248 0 01-.224-.358C19.117 18.355 19.5 16.746 19.5 15c0-1.746-.383-3.355-1.028-4.641a.249.249 0 01.224-.359zm-6.177 2.702a.5.5 0 01.707 0l1.237 1.237 1.238-1.237a.5.5 0 01.707 0l.354.353a.5.5 0 010 .708L16.31 15l1.238 1.238a.5.5 0 010 .707l-.354.353a.5.5 0 01-.707 0l-1.238-1.237-1.237 1.237a.5.5 0 01-.707 0l-.354-.353a.5.5 0 010-.707L14.19 15l-1.238-1.237a.5.5 0 010-.708z" fill-rule="evenodd"/></svg>',
    folder: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M22.8 5.46H12L9.84 3.3H1.2v17.28h21.6z"/></svg>',
    folderOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M22.8 5.46H12L9.84 3.3H1.2v17.28h21.6V5.46zm-2.16 12.96H3.36V7.62h17.28v10.8z"/></svg>',
    fullscreen: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.5 2.5v6.333h2.111V4.611h4.222V2.5H2.5zm12.667 0v2.111h4.222v4.222H21.5V2.5h-6.333zM2.5 15.167V21.5h6.333v-2.111H4.611v-4.222H2.5zm16.889 0v4.222h-4.222V21.5H21.5v-6.333h-2.111z"/></svg>',
    fullscreenExit: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.5 14.35l.15.15V22l-.15.15H7.833l-.15-.15v-5.684H2l-.15-.15V14.5l.15-.15h7.5zm12.5 0l.15.15v1.667l-.15.15-5.684-.001V22l-.15.15H14.5l-.15-.15v-7.5l.15-.15H22zM9.5 1.85l.15.15v7.5l-.15.15H2l-.15-.15V7.833l.15-.15h5.683V2l.15-.15H9.5zm6.667 0l.15.15-.001 5.683H22l.15.15V9.5l-.15.15h-7.5l-.15-.15V2l.15-.15h1.667z"/></svg>',
    fuse: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11 1v2.205c-.49.164-.934.403-1.248.756A3.05 3.05 0 009 6c0 .435.272.82.453 1.229C8.101 7.518 7 8.568 7 10c0 1.645 1.355 3 3 3h4c.565 0 1 .435 1 1s-.435 1-1 1h-2c-.917 0-1.731.38-2.248.96A3.05 3.05 0 009 18c0 .722.235 1.458.752 2.04.314.352.758.59 1.248.755V23h2v-2.205c.49-.164.934-.403 1.248-.756A3.05 3.05 0 0015 18c0-.435-.272-.82-.453-1.229C15.899 16.482 17 15.432 17 14c0-1.645-1.355-3-3-3h-4c-.565 0-1-.435-1-1s.435-1 1-1h2c.917 0 1.731-.38 2.248-.96A3.05 3.05 0 0015 6a3.05 3.05 0 00-.752-2.04c-.314-.352-.758-.59-1.248-.755V1h-2zm1 4c.417 0 .602.12.752.29.15.168.248.432.248.71 0 .278-.098.542-.248.71-.15.17-.335.29-.752.29s-.602-.12-.752-.29A1.095 1.095 0 0111 6c0-.278.098-.542.248-.71.15-.17.335-.29.752-.29zm0 12c.417 0 .602.12.752.29.15.168.248.432.248.71 0 .278-.098.542-.248.71-.15.17-.335.29-.752.29s-.602-.12-.752-.29A1.095 1.095 0 0111 18c0-.278.098-.542.248-.71.15-.17.335-.29.752-.29z"/></svg>',
    globeOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1C5.938 1 1 5.938 1 12s4.938 11 11 11 11-4.938 11-11S18.062 1 12 1zm0 2.2c.273 0 .572.112.954.475.381.363.796.971 1.151 1.772.271.61.493 1.354.684 2.153H9.21c.19-.799.413-1.543.684-2.153.355-.8.77-1.41 1.151-1.772.382-.363.68-.475.954-.475zm-3.904.917c-.071.144-.145.285-.212.437-.398.895-.707 1.93-.94 3.046H4.38a8.79 8.79 0 013.717-3.483zm7.808 0A8.79 8.79 0 0119.62 7.6h-2.566c-.232-1.115-.54-2.151-.939-3.046-.067-.152-.14-.293-.212-.437zM3.488 9.8h3.12A23.256 23.256 0 006.5 12c0 .755.04 1.488.107 2.2h-3.12A8.83 8.83 0 013.2 12c0-.762.107-1.496.288-2.2zm5.34 0h6.343c.077.707.129 1.437.129 2.2 0 .763-.052 1.493-.129 2.2H8.83A20.318 20.318 0 018.7 12c0-.763.052-1.493.129-2.2zm8.565 0h3.12A8.83 8.83 0 0120.8 12a8.83 8.83 0 01-.288 2.2h-3.12c.068-.712.108-1.445.108-2.2 0-.755-.04-1.488-.107-2.2zM4.379 16.4h2.566c.232 1.115.54 2.151.939 3.046.067.152.14.293.212.437A8.79 8.79 0 014.38 16.4zm4.832 0h5.578c-.19.799-.413 1.543-.684 2.153-.355.8-.77 1.41-1.151 1.772-.382.363-.68.475-.954.475-.273 0-.572-.112-.954-.475-.381-.363-.796-.971-1.151-1.772-.271-.61-.493-1.354-.684-2.153zm7.844 0h2.566a8.79 8.79 0 01-3.717 3.483c.071-.144.145-.285.212-.437.398-.895.707-1.93.94-3.046z"/></svg>',
    icons: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.58 11.12c.2-.29.64-.29.83 0l6.07 9.1c.22.33-.02.78-.42.78H2.93a.5.5 0 01-.41-.78l3.57-5.35c.2-.3.63-.3.83 0l2.58 3.88zM6.5 3.5a3 3 0 110 6 3 3 0 010-6z" fill-rule="evenodd"/></svg>',
    iconsBold: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.58 11.12c.2-.29.64-.29.83 0l6.07 9.1c.22.33-.02.78-.42.78H2.93a.5.5 0 01-.41-.78l3.57-5.35c.2-.3.63-.3.83 0l2.58 3.88zM6.75 3.5a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5z" fill-rule="evenodd"/></svg>',
    iconsColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor" transform="translate(2.435 3.5)"><path fill="currentColor" d="M12.145 7.62l-5.08 7.63-2.58-3.88c-.2-.3-.63-.3-.83 0l-3.57 5.35a.5.5 0 00.41.78h18.13c.4 0 .64-.45.42-.78l-6.07-9.1a.505.505 0 00-.83 0z" opacity=".4"/><circle cx="4.065" cy="3" r="3"/></g></svg>',
    iconsOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.39 9.76l7.49 10.16a.67.67 0 01-.53 1.08H2.64c-.56 0-.88-.64-.54-1.09l5.49-7.14c.2-.26.59-.26.79 0l1.52 1.98 3.68-4.99c.2-.27.61-.27.81 0zM14 12.08l-3.66 4.96c-.2.27-.6.27-.8.01L8 15.04 4.73 19.3h14.59zM7 2.75c2.07 0 3.75 1.68 3.75 3.75S9.07 10.25 7 10.25 3.25 8.57 3.25 6.5 4.93 2.75 7 2.75zM7 4.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" fill-rule="evenodd"/></svg>',
    iconsOutlineColored: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7 4.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-1.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75z" opacity=".9"/><path fill="currentColor" d="M21.35 21H2.64c-.56 0-.88-.64-.54-1.09l5.49-7.14c.2-.26.59-.26.79 0l1.52 1.98 3.68-4.99c.2-.27.61-.27.81 0l7.49 10.16a.67.67 0 01-.53 1.08zM4.73 19.3h14.59L14 12.08l-3.66 4.96c-.2.27-.6.27-.8.01L8 15.04 4.73 19.3z" opacity=".5"/></svg>',
    images: '<svg height="16" width="16" viewBox="0 0 16 16"><path fill="currentColor" d="M10.067 7.3a.4.4 0 01.666 0l4.852 7.278a.4.4 0 01-.332.622H.747a.4.4 0 01-.332-.622L3.267 10.3a.4.4 0 01.666 0L6 13.4zM3.6 1.2a2.4 2.4 0 110 4.8 2.4 2.4 0 010-4.8z" fill-rule="evenodd"/></svg>',
    install: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13 4.5v7.88l2.182-2.184a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-4.243 4.243a.5.5 0 01-.707 0L7.404 11.61a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L11 12.38V4.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5M20.502 20H3.499a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17.003a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/></svg>',
    installAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.533 15a.5.5 0 01.5.5V18H18v-2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4.533a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h1zM12.5 4a.5.5 0 01.5.5v7.88l2.182-2.184a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-4.242 4.243a.5.5 0 01-.708 0L7.404 11.61a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L11 12.38V4.5a.5.5 0 01.5-.5h1z"/></svg>',
    key: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.417 6a6.417 6.417 0 106.148 8.25H17.5V17h3.667v-2.75H23v-3.667h-9.435A6.417 6.417 0 007.417 6zm0 3.667a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5z"/></svg>',
    keyOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.417 6C3.892 6 1 8.892 1 12.417s2.892 6.416 6.417 6.416c2.543 0 4.665-1.545 5.749-3.666h2.5v2.75h5.5v-2.75H23v-5.5h-9.82C12.158 7.536 10.02 6 7.417 6zm0 1.833c2.09 0 3.751 1.303 4.36 3.051l.212.616h9.178v1.833h-1.834v2.75H17.5v-2.75h-5.484l-.227.582C11.093 15.695 9.4 17 7.417 17a4.591 4.591 0 01-4.584-4.583 4.591 4.591 0 014.584-4.584zm0 1.834a2.764 2.764 0 00-2.75 2.75 2.764 2.764 0 002.75 2.75 2.764 2.764 0 002.75-2.75 2.764 2.764 0 00-2.75-2.75zm0 1.833c.517 0 .916.4.916.917s-.4.916-.916.916a.903.903 0 01-.917-.916c0-.517.4-.917.917-.917z"/></svg>',
    layers: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.103 19.821l.017.005a.785.785 0 01.231.073l1.03.511c.378.188.39.722.02.926l-1.021.565a.785.785 0 01-.117.053l.092-.044a.75.75 0 01-.727 0l-1.038-.574a.523.523 0 01.02-.926l1.046-.52a.75.75 0 01.447-.069zm4.774-2.295l.91.505a.5.5 0 010 .875l-.91.504a.75.75 0 01-.727 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.727 0zm-9.035 0l.91.505a.5.5 0 010 .875l-.91.504a.75.75 0 01-.728 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.728 0zm-5.217-6.482a.75.75 0 01.728 0L12 15.846l8.648-4.8a.75.75 0 01.728 0l1.11.616a.375.375 0 010 .656L12.365 17.93a.75.75 0 01-.728 0L1.513 12.317a.375.375 0 010-.656zm18.76 3.98l.911.504a.5.5 0 010 .875l-.91.504a.75.75 0 01-.728 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.728 0zm-18.052 0l.91.504a.5.5 0 010 .875l-.91.504a.75.75 0 01-.727 0l-.91-.504a.5.5 0 010-.875l.91-.505a.75.75 0 01.727 0zm9.03-12.93l9.927 5.505a.5.5 0 010 .874l-9.926 5.505a.75.75 0 01-.728 0L1.71 8.473a.5.5 0 010-.874l9.926-5.505a.75.75 0 01.728 0z" fill-rule="evenodd"/></svg>',
    layersOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.28 19.821l.016.005a.786.786 0 01.231.072l1.03.512c.378.188.39.722.02.926l-1.02.565a.786.786 0 01-.118.053l.092-.044a.75.75 0 01-.726 0l-1.039-.574a.523.523 0 01.02-.926l1.046-.52c.14-.069.297-.092.448-.069zm4.774-2.295l.91.505a.5.5 0 010 .874l-.91.505a.75.75 0 01-.728 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.728 0zm-9.036 0l.91.505a.5.5 0 010 .874l-.91.505a.75.75 0 01-.727 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.727 0zm-5.217-6.482a.75.75 0 01.728 0l8.647 4.801 8.649-4.8a.75.75 0 01.727 0l1.111.616a.375.375 0 010 .656L12.54 17.93a.75.75 0 01-.727 0L1.69 12.317a.375.375 0 010-.656zm18.761 3.98l.91.504a.5.5 0 010 .874l-.91.505a.75.75 0 01-.727 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.727 0zm-18.053 0l.91.504a.5.5 0 010 .874l-.91.505a.75.75 0 01-.727 0l-.91-.505a.5.5 0 010-.874l.91-.505a.75.75 0 01.727 0zm9.03-12.93l9.927 5.505a.5.5 0 010 .874l-9.926 5.505a.75.75 0 01-.728 0L1.887 8.473a.5.5 0 010-.874l9.925-5.505a.75.75 0 01.728 0zm-.363 2.085L5.222 8.036l6.954 3.856 6.955-3.856z" fill-rule="evenodd"/></svg>',
    library: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.168 12c.28 0 .46.29.34.54l-3.52 7.04c-.14.26-.4.42-.68.42h-9.08a.76.76 0 01-.67-.41l-3.52-7.04c-.12-.26.06-.55.34-.55zm-1-4c.28 0 .46.29.34.54l-.52 1.04c-.14.26-.4.42-.68.42H5.228a.76.76 0 01-.67-.41l-.52-1.05c-.12-.25.06-.54.34-.54zm-1-4c.28 0 .46.29.34.54l-.52 1.04c-.14.26-.4.42-.68.42H6.228a.76.76 0 01-.67-.41l-.52-1.05c-.12-.25.06-.54.34-.54z" fill-rule="evenodd"/></svg>',
    lock: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15 10H9V7c0-1.654 1.346-3 3-3s3 1.346 3 3zm-1.055 6.53l-1.414 1.414a.75.75 0 01-1.061 0l-1.414-1.414a.75.75 0 010-1.06l1.414-1.415a.75.75 0 011.06 0l1.415 1.414a.75.75 0 010 1.061zM19.5 10H17V7.122c0-2.707-2.101-5.016-4.807-5.118A5.005 5.005 0 007 7v3H4.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    lockOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6 20h12v-8H6zM9 7c0-1.654 1.346-3 3-3s3 1.346 3 3v3H9zm8 3V7.123c0-2.708-2.101-5.017-4.807-5.12A5.005 5.005 0 007 7v3H4.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zm-4.558 7.68l1.237-1.238a.625.625 0 000-.884l-1.237-1.238a.625.625 0 00-.884 0l-1.237 1.238a.625.625 0 000 .884l1.237 1.237c.244.244.64.244.884 0" fill-rule="evenodd"/></svg>',
    // DEPRECATED 2026-09-11 - alias of logov2, remove after every consumer moves
    logo: '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42"><path fill="currentColor" fill-rule="evenodd" d="M26.6448969,0.699064106 C31.4862479,1.83000067 35.6718819,4.48073656 38.3104478,8.91022511 C40.5212645,12.5974948 41.4936378,17.0951724 40.5085112,21.3679841 C39.7174644,25.0315254 37.8558379,27.853625 34.8002871,29.8369535 C31.9792925,31.7073227 27.90737,32.069064 24.6776501,31.3213124 C23.2887047,30.9944607 20.6411869,29.9775216 19.044333,28.0178349 C17.5928447,26.2365433 17.1250067,23.5192397 17.0461096,22.8419583 C16.9044422,21.6258334 17.1065683,20.249997 17.3800113,19.0276209 C17.9614095,16.4655592 18.9984397,14.7924534 21.1401118,13.3818866 C22.95018,12.1750388 24.6834696,11.8738651 26.7601335,12.3496124 C28.1855093,12.6880929 29.4520072,13.526716 30.3514025,14.7276098 C30.6271426,15.093878 30.8260324,15.4389318 31.059655,15.8362933 L30.9598079,15.7715366 C29.6377659,14.9422902 28.1654404,14.6590001 26.6448969,15.0752526 C25.2996601,15.4486698 24.1453463,16.3687006 23.4390969,17.6304467 C22.6973258,18.9448239 22.4839364,20.5087166 22.8465467,21.9733145 C23.2152637,23.4394215 24.1276197,24.6832715 25.381967,25.429977 C26.7647836,26.2608222 28.5893081,26.47537 30.1320438,26.0161118 C32.0344739,25.4497656 33.5958796,24.1165457 34.5824098,22.3233381 C35.8078311,20.0959926 36.0316242,17.5753145 35.4197363,15.1376991 C34.8712232,12.9726344 33.491011,11.1258939 31.7578503,9.86101942 C28.3978494,7.40873928 23.8145474,6.88014849 19.8961329,8.1555193 C16.9596954,9.11146975 14.399202,11.0657028 12.6221782,13.707146 C10.5375814,16.8894059 9.73736372,20.794518 10.3986926,24.5579956 C10.9302311,27.7327705 12.5716868,31.0242929 14.8485647,33.1339502 C15.5517576,33.7855358 16.0056239,34.2996296 16.8186608,34.9238068 C16.1252729,35.6670587 15.729719,36.1210912 15.0276006,36.8553491 L10.5425168,41.6144377 C8.59431563,40.2572487 6.84060794,38.6181461 5.33246714,36.7448351 C1.65619854,32.1632109 -0.0655234106,26.1858125 0.562658817,20.1851649 C1.1000136,14.4158268 3.81414269,9.08050481 8.0996615,5.36924966 C12.3107417,1.69300072 17.6911238,0.0107792851 23.1108097,0.299129816 C25.006381,0.458182488 26.18441,0.591493918 26.6448969,0.699064106 Z"/></svg>',
    magic: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.76.9a.854.854 0 00-.84.866v.853h-.854a.854.854 0 100 1.707h.853v.854a.854.854 0 101.707 0v-.854h.853a.854.854 0 100-1.707h-.853v-.853A.854.854 0 003.759.9zm13.655 2.276a.854.854 0 00-.84.866v.853h-.854a.854.854 0 100 1.707h.854v.854a.854.854 0 101.706 0v-.854h.854a.854.854 0 100-1.707h-.854v-.853a.854.854 0 00-.866-.866zM8.348 6.061c-.657 0-1.315.248-1.812.744a2.574 2.574 0 000 3.622l1.326 1.325.003.004c.054.075.12.14.195.195l10.375 10.374a2.574 2.574 0 003.62 0 2.574 2.574 0 000-3.622L11.656 8.305a.854.854 0 00-.198-.199l-1.3-1.3a2.552 2.552 0 00-1.81-.745zm0 1.697a.85.85 0 01.603.255l.8.8-1.191 1.223-.816-.816a.84.84 0 010-1.207.85.85 0 01.604-.255zm2.61 2.262l9.89 9.89a.84.84 0 010 1.208.842.842 0 01-1.206 0h-.001l-9.874-9.875 1.191-1.223zm-4.923 5.105a.854.854 0 00-.84.865v.854h-.853a.854.854 0 100 1.707h.853v.853a.854.854 0 101.707 0v-.853h.853a.854.854 0 100-1.707h-.853v-.854a.854.854 0 00-.867-.865z"/></svg>',
    magicstar: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.354 13.762l-1.293.323-.323 1.315 7.177 7.177a1.143 1.143 0 001.639 0 1.143 1.143 0 000-1.638l-7.2-7.177zM6.007 15.7l-1.892 1.916a.962.962 0 000 1.384.91.91 0 00.692.3A1 1 0 005.5 19l1.915-1.915a.962.962 0 000-1.385.989.989 0 00-1.408 0zm6.716-7.892l-1.5 1.246a.464.464 0 01-.485.07l-1.777-.74a.477.477 0 00-.623.624l.739 1.777a.464.464 0 01-.07.484l-1.246 1.477c-.277.323-.023.808.439.762l1.915-.139c.185 0 .347.092.439.23l1.015 1.64c.208.346.762.276.854-.139l.462-1.87a.52.52 0 01.346-.345l1.869-.462c.415-.092.485-.623.138-.854L13.6 10.554a.435.435 0 01-.231-.439l.138-1.915c.024-.415-.461-.67-.784-.392zM1.969 10.577a.98.98 0 00-.97.992c0 .554.44.992.993.992h2.7a.985.985 0 00.992-.992.985.985 0 00-.992-.992zm15.623-6.485l-1.915 1.916a.962.962 0 000 1.384.91.91 0 00.692.3 1 1 0 00.692-.3L19 5.477a.962.962 0 000-1.385.989.989 0 00-1.408 0zm-13.523 0a.962.962 0 000 1.385l1.915 1.915a.91.91 0 00.693.3.996.996 0 00.715-.3.962.962 0 000-1.384L5.477 4.092a.989.989 0 00-1.408 0zM11.499 1a.985.985 0 00-.991.992v2.7c0 .554.438.993.992.993a.985.985 0 00.992-.993v-2.7A.985.985 0 0011.5 1z"/></svg>',
    magicstarOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15.354 13.762l-1.293.323-.323 1.315 7.177 7.177c.198.198.443.311.694.34l.126.006c.294 0 .588-.115.819-.346a1.143 1.143 0 000-1.638l-7.2-7.177zM6.007 15.7l-1.892 1.916a.962.962 0 000 1.384.896.896 0 00.584.295l.108.005A1 1 0 005.5 19l1.915-1.915a.962.962 0 000-1.385.993.993 0 00-.645-.292h-.117a.993.993 0 00-.646.292zm6.716-7.892l-1.5 1.246a.461.461 0 01-.318.108l-.084-.012a.486.486 0 01-.083-.027l-1.777-.738-.078-.026-.077-.01a.478.478 0 00-.468.659l.739 1.777a.464.464 0 01-.07.484l-1.246 1.477a.458.458 0 00.266.753l.084.01.044.001 1.96-.14c.185 0 .347.091.439.23l1.015 1.638a.452.452 0 00.319.216l.076.006a.457.457 0 00.46-.36l.46-1.87a.52.52 0 01.347-.345l1.869-.462c.415-.092.485-.623.138-.854L13.6 10.554a.435.435 0 01-.231-.439l.138-1.915a.48.48 0 00-.432-.506l-.072-.002a.467.467 0 00-.28.116zm-.65 2.229l-.006.07c-.023.607.27 1.16.73 1.477l.079.049a1.83 1.83 0 00-1.202 1.13l-.038.116-.089-.122c-.311-.391-.78-.64-1.35-.679l-.169-.006.078-.103a1.76 1.76 0 00.228-1.532l-.034-.092.08.03c.52.169 1.088.09 1.541-.221l.152-.117zm-10.104.54a.98.98 0 00-.97.992c0 .554.44.992.993.992h2.7a.985.985 0 00.992-.992.985.985 0 00-.992-.992H1.97zm15.623-6.485l-1.915 1.916a.962.962 0 000 1.384.896.896 0 00.584.295l.108.005a1 1 0 00.692-.3L19 5.477a.962.962 0 000-1.385.993.993 0 00-.645-.292h-.118a.993.993 0 00-.645.292zm-13.523 0a.962.962 0 000 1.385l1.915 1.915a.896.896 0 00.584.295l.109.005a.996.996 0 00.715-.3.962.962 0 000-1.384L5.477 4.092A.993.993 0 004.83 3.8h-.117a.993.993 0 00-.645.292zM11.499 1a.985.985 0 00-.991.992v2.7c0 .515.378.93.875.986l.117.007a.985.985 0 00.992-.993v-2.7a.984.984 0 00-.875-.985L11.5 1z"/></svg>',
    menu: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M7.5 8h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM13.5 8h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM19.5 8h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM7.5 14h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM13.5 14h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM19.5 14h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM7.5 20h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM13.5 20h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5zM19.5 20h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5z"/><path fill="currentColor" d="M7.5 16c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm-12-6c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm-12-6c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6 0c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5z"/></g></svg>',
    menuAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.293 16.245l1.586 1.587a.414.414 0 010 .585l-1.586 1.587a.414.414 0 01-.586 0l-1.586-1.587a.414.414 0 010-.585l1.586-1.587a.414.414 0 01.586 0zm3.221-3.077l1.443 1.442a.362.362 0 010 .512l-1.443 1.443a.362.362 0 01-.512 0l-1.443-1.443a.362.362 0 010-.512l1.443-1.442a.362.362 0 01.512 0zm-6.516 0l1.443 1.442a.362.362 0 010 .512l-1.443 1.443a.362.362 0 01-.512 0l-1.443-1.443a.362.362 0 010-.512l1.443-1.442a.362.362 0 01.512 0zm9.737-3.078l1.3 1.299a.31.31 0 010 .439l-1.3 1.299a.31.31 0 01-.439 0l-1.298-1.299a.31.31 0 010-.439l1.298-1.299a.31.31 0 01.44 0zm-6.516 0l1.3 1.299a.31.31 0 010 .439l-1.3 1.299a.31.31 0 01-.438 0l-1.3-1.299a.31.31 0 010-.439l1.3-1.299a.31.31 0 01.438 0zm-6.515 0l1.298 1.299a.31.31 0 010 .439l-1.298 1.299a.31.31 0 01-.44 0l-1.298-1.299a.31.31 0 010-.439l1.299-1.299a.31.31 0 01.439 0zm9.737-3.077l1.155 1.154c.1.102.1.265 0 .366L15.44 9.688c-.101.101-.265.101-.366 0L13.92 8.533c-.1-.1-.1-.264 0-.366l1.155-1.154c.101-.101.265-.101.366 0zm-6.516 0l1.155 1.154c.1.102.1.265 0 .366L8.925 9.688c-.101.101-.265.101-.366 0L7.404 8.533c-.1-.1-.1-.264 0-.366L8.56 7.013c.101-.101.265-.101.366 0zm3.221-3.078l1.011 1.011c.08.08.08.212 0 .293l-1.01 1.01a.207.207 0 01-.293 0l-1.011-1.01a.207.207 0 010-.293l1.01-1.01c.082-.081.212-.081.293 0z" fill-rule="evenodd"/></svg>',
    mic: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a3.47 3.47 0 00-3.468 3.474v6.947A3.47 3.47 0 0012 14.895a3.47 3.47 0 003.468-3.474V4.474A3.47 3.47 0 0012 1zM5.166 11.421c-.7 0-1.265.623-1.151 1.316a8.099 8.099 0 006.83 6.699v2.406c0 .64.517 1.158 1.155 1.158s1.156-.519 1.156-1.158v-2.406a8.099 8.099 0 006.83-6.699c.113-.693-.451-1.316-1.152-1.316-.571 0-1.042.421-1.138.986A5.786 5.786 0 0112 17.211a5.786 5.786 0 01-5.696-4.804c-.096-.565-.566-.986-1.138-.986z"/></svg>',
    micOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.834 10.321c1.2 0 2.133 1.07 1.941 2.245a8.902 8.902 0 01-6.68 7.203l-.14.03.001 1.743a1.96 1.96 0 01-1.65 1.933l-.15.019L12 23.5a1.957 1.957 0 01-1.956-1.958V19.8l-.15-.034a8.906 8.906 0 01-6.56-6.644l-.06-.283-.049-.273c-.192-1.175.742-2.245 1.941-2.245a1.96 1.96 0 011.926 1.65A4.986 4.986 0 0012 16.112a4.985 4.985 0 004.908-4.138 1.962 1.962 0 011.926-1.652zm0 1.6c-.17 0-.317.13-.35.321A6.586 6.586 0 0112 17.711a6.586 6.586 0 01-6.485-5.47c-.032-.191-.178-.32-.349-.32-.22 0-.393.194-.362.388a7.299 7.299 0 006.154 6.035l.429.062.257.037v3.1c0 .197.16.357.356.357.196 0 .356-.16.356-.358v-3.1l.257-.036.43-.062a7.299 7.299 0 006.153-6.036c.032-.193-.141-.387-.362-.387zM12 1a3.77 3.77 0 013.768 3.774v6.947A3.77 3.77 0 0112 15.495a3.77 3.77 0 01-3.768-3.774V4.774A3.77 3.77 0 0112 1zm0 1.7a2.07 2.07 0 00-2.068 2.074v6.947A2.07 2.07 0 0012 13.795a2.07 2.07 0 002.068-2.074V4.774A2.07 2.07 0 0012 2.7z"/></svg>',
    noIcon: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.75 3a.25.25 0 01.25.25v.955a.5.5 0 01-.147.354L4.56 20.854a.5.5 0 01-.354.146H3.25a.25.25 0 01-.25-.25v-.96a.5.5 0 01.147-.353l16.29-16.29A.5.5 0 0119.791 3zm.037 6.578a.125.125 0 01.213.088v2.32a.5.5 0 01-.147.353l-8.514 8.515a.5.5 0 01-.354.146h-2.32a.125.125 0 01-.088-.213zm0 7.778a.125.125 0 01.213.088v3.306a.25.25 0 01-.25.25h-3.306a.125.125 0 01-.089-.213zM14.334 3c.112 0 .167.135.089.214L3.213 14.423A.125.125 0 013 14.335v-2.32a.5.5 0 01.146-.354l8.515-8.514A.5.5 0 0112.015 3zM6.556 3c.111 0 .167.135.089.214l-3.431 3.43A.125.125 0 013 6.557V3.25A.25.25 0 013.25 3z" fill-rule="evenodd"/></svg>',
    pages: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.857 9.143c1.182 0 2.143.961 2.143 2.143v8.571A2.145 2.145 0 019.857 22H4.143A2.145 2.145 0 012 19.857v-8.571c0-1.182.961-2.143 2.143-2.143zm4.5-3.6c1.182 0 2.143.961 2.143 2.143v8.571a2.145 2.145 0 01-2.143 2.143l-1.434-.001v-7.985a2.145 2.145 0 00-2.142-2.143H6.5v-.585c0-1.13.88-2.06 1.99-2.138l.153-.005zm-9.262 7.886h3.81a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428zm3.81 2.857a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428h3.81zM19.857 2C21.04 2 22 2.961 22 4.143v8.571a2.145 2.145 0 01-2.143 2.143h-2.38v-4.286h1.428a.715.715 0 000-1.428h-1.429V7.714h1.429a.715.715 0 000-1.428h-1.78a3.098 3.098 0 00-2.744-1.667H12v-.476C12 2.96 12.961 2 14.143 2z"/></svg>',
    pagesHalfOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.143 2A2.145 2.145 0 0012 4.143v.476h2.381c1.191 0 2.226.678 2.744 1.667h1.78a.715.715 0 010 1.428h-1.429v1.429h1.429a.715.715 0 010 1.428h-1.429v4.286h2.381A2.145 2.145 0 0022 12.714V4.143A2.145 2.145 0 0019.857 2h-5.714zM8.667 5.571a2.145 2.145 0 00-2.143 2.143v.476h1.428v-.476c0-.394.32-.714.715-.714h5.714c.394 0 .714.32.714.714v8.572c0 .394-.32.714-.714.714h-1.429v1.429h1.429a2.145 2.145 0 002.143-2.143V7.714a2.145 2.145 0 00-2.143-2.143H8.667zM4.143 9.143A2.145 2.145 0 002 11.286v8.571C2 21.04 2.961 22 4.143 22h5.714A2.145 2.145 0 0012 19.857v-8.571a2.145 2.145 0 00-2.143-2.143H4.143zm.952 4.286h3.81a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428zm0 2.857h3.81a.715.715 0 010 1.428h-3.81a.715.715 0 010-1.428z"/></svg>',
    pagesOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.143 2A2.145 2.145 0 0012 4.143v.476h1.429v-.476c0-.394.32-.714.714-.714h5.714c.394 0 .714.32.714.714v8.571c0 .394-.32.715-.714.715h-2.38v1.428h2.38A2.145 2.145 0 0022 12.714V4.143A2.145 2.145 0 0019.857 2h-5.714zM8.667 5.571a2.145 2.145 0 00-2.143 2.143v.476h1.428v-.476c0-.394.32-.714.715-.714h5.714c.394 0 .714.32.714.714v8.572c0 .394-.32.714-.714.714h-1.429v1.429h1.429a2.145 2.145 0 002.143-2.143V10.57h2.38a.714.714 0 100-1.428h-2.38V7.714h2.38a.714.714 0 100-1.428h-2.856a.714.714 0 00-.08.003 2.13 2.13 0 00-1.587-.718H8.667zM4.143 9.143A2.154 2.154 0 002 11.286v8.571C2 21.032 2.968 22 4.143 22h5.714A2.154 2.154 0 0012 19.857v-8.571a2.154 2.154 0 00-2.143-2.143H4.143zm0 1.428h5.714c.403 0 .714.312.714.715v8.571a.704.704 0 01-.714.714H4.143a.704.704 0 01-.714-.714v-8.571c0-.403.31-.715.714-.715zm.952 2.858a.714.714 0 100 1.428h3.81a.714.714 0 100-1.428h-3.81zm0 2.857a.714.714 0 100 1.428h3.81a.714.714 0 100-1.428h-3.81z"/></svg>',
    pin: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.72 2.02c-.128.434.048.901.43 1.14.084.054.144.104.278.221l.072.063.022.018-4.633 4.436a.064.064 0 01-.04.018h-.025a11.047 11.047 0 00-1.581-.152l-.334.005a8.115 8.115 0 00-3.955 1.153c-1.159.702-1.343 2.348-.385 3.305l3.393 3.393-5.353 5.352a1.007 1.007 0 00-.3.863l.023.118a1.007 1.007 0 001.699.447l5.355-5.356 3.393 3.393c.92.92 2.473.787 3.216-.25l.089-.134c.762-1.26 1.165-2.728 1.158-4.29a14.697 14.697 0 00-.108-1.628l.001.001c-.003-.022-.002-.035.004-.046l.011-.016 1.928-2.013.462-.483 1.968-2.056.064-.067.036.05c.117.162.166.233.22.323a1.008 1.008 0 101.729-1.036c-1.696-2.825-4.141-5.271-7.311-7.323a1.009 1.009 0 00-1.525.551z"/></svg>',
    pinOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.72 2.02c-.128.434.048.901.43 1.14.084.054.144.104.278.221l.072.063.022.018-4.633 4.436a.064.064 0 01-.04.018h-.025a11.047 11.047 0 00-1.581-.152l-.334.005a8.115 8.115 0 00-3.955 1.153c-1.159.702-1.343 2.348-.385 3.305l3.393 3.393-5.353 5.352a1.007 1.007 0 00-.3.863l.023.118a1.007 1.007 0 001.699.447l5.355-5.356 3.393 3.393c.92.92 2.473.787 3.216-.25l.089-.134c.762-1.26 1.165-2.728 1.158-4.29a14.697 14.697 0 00-.108-1.628l.001.001c-.003-.022-.002-.035.004-.046l.011-.016 1.928-2.013.462-.483 1.968-2.056.064-.067.036.05c.117.162.166.233.22.323a1.008 1.008 0 101.729-1.036c-1.696-2.825-4.141-5.271-7.311-7.323a1.009 1.009 0 00-1.525.551zm2.392 2.709l.19.152c1.482 1.187 2.426 2.065 3.195 3.034l-.11-.136-.133.14-1.78 1.86-.638.666-.231.24-1.91 1.996a2.076 2.076 0 00-.561 1.676l.001.026c.055.443.09.999.092 1.39.006 1.199-.293 2.29-.866 3.236-.035.057-.099.063-.158.004l-8.21-8.21c-.059-.06-.053-.123.004-.157.948-.574 2.037-.873 3.237-.867l.137.003c.299.013.738.06 1.144.123l-.132-.021.132.022c.584.09 1.179-.07 1.635-.437l.132-.117 4.83-4.623z"/></svg>',
    playground: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M4.2 11.707c0-.223.166-.413.386-.44 1.102-.136 1.807-.923 1.562-2.807-.073-.567-.16-1.111-.16-1.678 0-1.486.956-2.59 2.242-2.582.306.002 1.94 0 2.525 0 .246 0 .445.177.445.423V5.73a.46.46 0 01-.442.462c-.358.002-1.27 0-1.392 0-.974 0-1.463.071-1.463.982 0 .464.08.733.142 1.22.08.504.155 1.017.155 1.563 0 1.293-.508 1.959-1.372 2.199l-.1.022v.044l.1.022c.864.24 1.372.905 1.372 2.199 0 .546-.075 1.059-.155 1.563-.062.487-.142.756-.142 1.22 0 .911.489.981 1.463.981h1.392a.46.46 0 01.442.463v1.107c0 .246-.199.423-.445.423-.586 0-2.219-.002-2.525 0-1.286.009-2.242-1.096-2.242-2.582 0-.567.087-1.111.16-1.678.245-1.884-.46-2.672-1.562-2.807a.442.442 0 01-.386-.44zm11.061 6.346l-.707-.706a.5.5 0 010-.708l4.439-4.438-4.44-4.44a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0l5.5 5.5a.5.5 0 010 .707l-5.499 5.5a.5.5 0 01-.707 0" fill-rule="evenodd"/></svg>',
    preferences: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16 12.5a3.502 3.502 0 013.355 2.5h2.147a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.147a3.502 3.502 0 01-6.71 0H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h10.145A3.502 3.502 0 0116 12.5zm-8-8A3.502 3.502 0 0111.355 7h10.147a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H11.355a3.502 3.502 0 01-6.71 0H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.145A3.502 3.502 0 018 4.5z" fill-rule="evenodd"/></svg>',
    preferencesOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16 12a4.003 4.003 0 013.869 3h1.633a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H19.87c-.446 1.722-2.009 3-3.869 3s-3.422-1.278-3.868-3H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h9.632A4.003 4.003 0 0116 12zm0 2c-1.102 0-2 .896-2 2 0 1.102.898 2 2 2 1.103 0 2-.898 2-2 0-1.104-.897-2-2-2zM8 4a4.003 4.003 0 013.869 3h9.633a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H11.87A4.004 4.004 0 018 12a4.004 4.004 0 01-3.868-3H2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1.632A4.003 4.003 0 018 4zm0 2c-1.102 0-2 .896-2 2 0 1.102.898 2 2 2 1.103 0 2-.898 2-2 0-1.104-.897-2-2-2z" fill-rule="evenodd"/></svg>',
    priceTag: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.485 2a1 1 0 01.708.293l10.252 10.253a.5.5 0 010 .707l-9.192 9.193a.5.5 0 01-.707 0L2.293 12.192A1 1 0 012 11.485V2.5a.5.5 0 01.5-.5zm-.414 2h-7.07v7.071l8.899 8.9 7.07-7.071zM8.354 6.554l1.092 1.093a.5.5 0 010 .707L8.354 9.446a.5.5 0 01-.707 0L6.554 8.354a.5.5 0 010-.707l1.093-1.093a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    qr: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18 22v-2h-2v2h-4v-2h-2v2H8v-2H6v2H2v-6h2v-2H2v-4h2V8H2V6h2V4H2V2v20h16zM4 4h2V2H4v2zm2 0v2h2v2h2V6h4V4h-4V2H8v2H6zm8 0h2V2h-2v2zm2 0v2h2v2h2V6h2V4h-6zm4 4v4h2V8h-2zm0 4h-2V8h-2v6h4v-2zm0 2v2h2v-2h-2zm0 2h-4v2h4v-2zm0 2v2h2v-2h-2zm-4 0h-2v2h2v-2zm-2 0v-2h-2v2h2zm0-2h2v-2h-2v2zm2-8V6h-2v2h2zm-2 0h-4v2h2v2h2V8zm-2 4h-2v2h2v-2zm-2 2H8v2H6v2h2v2h2v-6zm-4 4H4v2h2v-2zm4-6v-2H8v2h2zm-2-2V8H6v2h2zm-2 0H4v4h2v-4zm0-2V6H4v2h2z"/></svg>',
    ratingFrame: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.502 3a.5.5 0 01.5.5v17.002a.5.5 0 01-.5.5H3.5a.5.5 0 01-.5-.5V3.5a.5.5 0 01.5-.5zm-1.5 2H5v14.002h14.002zm-6.687 3.198l.97 2.008 2.209.302a.35.35 0 01.195.599l-1.61 1.542.396 2.195a.35.35 0 01-.51.37L12 14.16l-1.965 1.054a.35.35 0 01-.51-.37l.397-2.195-1.61-1.542a.35.35 0 01.194-.6l2.21-.3.969-2.01a.35.35 0 01.63 0z" fill-rule="evenodd"/></svg>',
    ratingPointer: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.33 12.056c.457-.324 1.094-.194 1.431.252l2.232 2.955.414-.312a.682.682 0 01.292-.128l3.557-.627c.423-.074.848.124 1.062.497l1.589 2.76c.256.444.142 1.01-.266 1.321l-3.592 2.737a2.426 2.426 0 01-2.281.346l-2.857-1.02a.608.608 0 01-.369-.775c.167-.47.512-.83.936-1.027a1.793 1.793 0 011.236-.077l.578.09-4.186-5.544a1.02 1.02 0 01.225-1.448zm-.743-9.375a.51.51 0 01.92 0l2.472 5.121 5.634.769c.424.058.593.58.285.875l-3.87 3.708-1.19-1.512 1.633-1.566-3.77-.515-1.654-3.427-1.655 3.427-3.77.515 2.747 2.632-.675 3.745 2.19-1.176 1.177 1.558-5.025 2.682a.511.511 0 01-.744-.54l1.01-5.597-4.107-3.934a.511.511 0 01.285-.875l5.634-.769z" fill-rule="evenodd"/></svg>',
    ratingStar: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.677 12.833l.676 3.745-3.353-1.8-3.353 1.8.676-3.745-2.748-2.632 3.77-.515L12 6.26l1.654 3.427 3.771.515zm5.89-4.137l-5.634-.769-2.473-5.12a.51.51 0 00-.92 0l-2.473 5.12-5.634.77a.511.511 0 00-.284.874l4.106 3.934-1.01 5.596a.51.51 0 00.745.541L12 16.968l5.01 2.674a.51.51 0 00.745-.54l-1.01-5.597 4.106-3.934a.511.511 0 00-.284-.875z" fill-rule="evenodd"/></svg>',
    report: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.222 3a.5.5 0 01.354.146l5.277 5.276a.5.5 0 01.147.353V20.5a.5.5 0 01-.5.5h-18a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM15 5H5v14h15.002v-9H15.5a.5.5 0 01-.5-.5zm2.5 10a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm-5-4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM8.354 6.94l.707.706a.5.5 0 010 .708l-.707.707a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.708l.707-.707a.5.5 0 01.708 0z" fill-rule="evenodd"/></svg>',
    reportAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.222 3a.5.5 0 01.353.146l5.278 5.276a.5.5 0 01.146.353V20.5a.5.5 0 01-.5.5H3.5a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM15 5H5v14h15.002v-9H15.5a.5.5 0 01-.5-.5zM8.5 7.053a.5.5 0 01.5.5V16.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7.553a.5.5 0 01.5-.5zM12.502 10a.5.5 0 01.5.5v6a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-6a.5.5 0 01.5-.5zm4.344 3.626l1.02 1.02a.5.5 0 010 .708l-1.02 1.02a.5.5 0 01-.708 0l-1.02-1.02a.5.5 0 010-.708l1.02-1.02a.5.5 0 01.708 0z" fill-rule="evenodd"/></svg>',
    saveAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.556 2H4.222C2.99 2 2 3 2 4.222v15.556C2 21 2.989 22 4.222 22h15.556C21 22 22 21 22 19.778V6.444L17.556 2zM12 19.778a3.329 3.329 0 01-3.333-3.334A3.329 3.329 0 0112 13.111a3.329 3.329 0 013.333 3.333A3.329 3.329 0 0112 19.778zm3.333-11.111H4.223V4.222h11.11v4.445z"/></svg>',
    saveAltOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.222 2A2.237 2.237 0 002 4.222v15.556A2.237 2.237 0 004.222 22h15.556A2.237 2.237 0 0022 19.778V6.444L17.556 2H4.222zm0 2.222h12.413l3.143 3.143v12.413H4.222V4.222zm2.222 2.222v3.334h8.89V6.444h-8.89zm5 5.556a2.778 2.778 0 100 5.556 2.778 2.778 0 000-5.556z"/></svg>',
    saveColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M7.3 14.2a2.5 2.5 0 000 5 2.5 2.5 0 000-5z" opacity=".65"/><path fill="currentColor" d="M19.293 3.545a.795.795 0 011.138-.015l.414.413c.305.305.31.798.013 1.11l-6.67 6.998a.795.795 0 01-1.116.033L9.974 9.198a.794.794 0 01-.018-1.145l.42-.418a.794.794 0 011.095-.023L13.6 9.55l5.694-6.005z"/></g></svg>',
    searchOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.61 19.19l-5.15-5.15a7.485 7.485 0 001.47-5.6c-.46-3.32-3.14-5.96-6.46-6.38-4.89-.61-9.02 3.52-8.41 8.41.42 3.33 3.07 6 6.39 6.46 2.12.29 4.08-.31 5.6-1.48l5.15 5.15c.2.2.51.2.71 0l.71-.71c.18-.19.18-.5-.01-.7zM3.99 9.5C3.99 6.47 6.46 4 9.5 4S15 6.47 15 9.5 12.53 15 9.5 15s-5.51-2.46-5.51-5.5z" fill-rule="evenodd"/></svg>',
    settings: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22 12.72v-1.44c0-.23-.16-.43-.38-.49l-2.64-.64c-.17-.63-.42-1.23-.74-1.79l1.42-2.32c.12-.2.09-.45-.07-.61l-1.02-1.01a.5.5 0 00-.61-.07l-2.32 1.42a7.26 7.26 0 00-1.79-.74l-.65-2.65a.493.493 0 00-.48-.38h-1.44c-.23 0-.43.16-.49.38l-.64 2.64c-.63.17-1.23.42-1.78.74L6.05 4.35a.497.497 0 00-.61.07L4.42 5.44c-.16.16-.19.41-.07.61l1.42 2.32a7.26 7.26 0 00-.74 1.79l-2.65.64c-.22.05-.38.25-.38.48v1.44c0 .23.16.43.38.49l2.64.64c.17.63.42 1.23.74 1.79l-1.42 2.32c-.12.2-.09.45.07.61l1.01 1.01a.5.5 0 00.61.07l2.32-1.42c.55.32 1.15.57 1.79.74l.64 2.64c.05.22.26.38.49.38h1.44c.23 0 .43-.16.49-.38l.64-2.64c.63-.17 1.23-.42 1.79-.74l2.32 1.42c.2.12.45.09.61-.07l1.02-1.01a.5.5 0 00.07-.61l-1.42-2.32c.32-.55.57-1.15.74-1.79l2.64-.64a.51.51 0 00.39-.49zm-10 3.72c-2.45 0-4.44-1.99-4.44-4.44S9.55 7.56 12 7.56s4.44 1.99 4.44 4.44-1.99 4.44-4.44 4.44z" fill-rule="evenodd"/></svg>',
    shape: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.57 12.64l6.29 6.29c.2.2.2.51 0 .71l-.71.71c-.2.2-.52.2-.71 0l-6.29-6.29c-.2-.2-.2-.51 0-.71l.71-.71c.2-.2.51-.2.71 0zM9.5 13c.28 0 .5.22.5.5v6c0 .28-.23.5-.5.5h-6c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5zm-3-10.55a4 4 0 110 8 4 4 0 010-8zm10.91.67l4.07 6.1c.22.33-.02.78-.42.78h-8.13c-.4 0-.64-.45-.42-.78l4.07-6.1c.2-.3.63-.3.83 0z" fill-rule="evenodd"/></svg>',
    shapeColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor" transform="translate(2.5 2.45)"><path d="M18.56 7.55h-8.13c-.4 0-.64-.45-.42-.78l4.07-6.1c.2-.3.63-.3.83 0l4.07 6.1c.22.33-.02.78-.42.78z" fill="#313233" opacity=".8"/><path d="M7 17.55H1c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v6c0 .28-.23.5-.5.5z" fill="#626365" opacity=".6"/><circle cx="4" cy="4" r="4"/><path d="M16.94 17.9l-6.29-6.29c-.2-.2-.2-.51 0-.71l.71-.71c.2-.2.51-.2.71 0l6.29 6.29c.2.2.2.51 0 .71l-.71.71c-.2.2-.52.2-.71 0z" fill="#939598" opacity=".4"/></g></svg>',
    shapeOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M14.27 13.05l6.68 6.68c.2.2.2.51 0 .71l-.5.5c-.2.19-.52.19-.71 0l-6.68-6.68c-.2-.2-.2-.51 0-.71l.5-.5c.2-.2.51-.2.71 0zm-4.42.1c.28 0 .5.22.5.5v6.7c0 .28-.22.5-.5.5h-6.7c-.28 0-.5-.22-.5-.5v-6.7c0-.28.22-.5.5-.5zm-1.2 1.7h-4.3v4.3h4.3zM6.5 2.15c2.4 0 4.35 1.95 4.35 4.35S8.9 10.85 6.5 10.85 2.15 8.9 2.15 6.5 4.1 2.15 6.5 2.15zm11.33.66L21.9 9.1c.45.66-.03 1.55-.83 1.55h-8.14c-.8 0-1.28-.89-.83-1.55l4.07-6.29a1 1 0 011.66 0zM6.5 3.85c-1.46 0-2.65 1.19-2.65 2.65S5.04 9.15 6.5 9.15 9.15 7.96 9.15 6.5 7.96 3.85 6.5 3.85zm10.5.69l-2.84 4.45h5.68z" fill-rule="evenodd"/></svg>',
    shapeOutlineColored: '<svg width="24" height="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" fill-rule="nonzero" d="M9.85 20.85h-6.7c-.28 0-.5-.22-.5-.5v-6.7c0-.28.22-.5.5-.5h6.7c.28 0 .5.22.5.5v6.7c0 .28-.22.5-.5.5zm-5.5-1.7h4.3v-4.3h-4.3v4.3z" opacity=".85"/><path fill="currentColor" fill-rule="nonzero" d="M6.5 10.85c-2.4 0-4.35-1.95-4.35-4.35 0-2.4 1.95-4.35 4.35-4.35 2.4 0 4.35 1.95 4.35 4.35 0 2.4-1.95 4.35-4.35 4.35zm0-7c-1.46 0-2.65 1.19-2.65 2.65S5.04 9.15 6.5 9.15 9.15 7.96 9.15 6.5 7.96 3.85 6.5 3.85z" opacity=".55"/><path fill="currentColor" d="M19.74 20.94l-6.68-6.68c-.2-.2-.2-.51 0-.71l.5-.5c.2-.2.51-.2.71 0l6.68 6.68c.2.2.2.51 0 .71l-.5.5c-.2.19-.52.19-.71 0z"/><path fill="currentColor" fill-rule="nonzero" d="M21.07 10.65h-8.14c-.8 0-1.28-.89-.83-1.55l4.07-6.29a1 1 0 011.66 0L21.9 9.1c.45.66-.03 1.55-.83 1.55zm-6.91-1.66h5.68L17 4.54l-2.84 4.45z" opacity=".7"/></g></svg>',
    share: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.1 11.74l8.44-3.96 1.54.89c.23.13.52.13.75 0l1.8-1.04c.23-.13.37-.38.37-.65V4.9c0-.27-.14-.52-.37-.65l-1.8-1.04a.77.77 0 00-.75 0l-1.8 1.04c-.24.14-.38.39-.38.65v1.3l-8.44 3.96-1.54-.89a.77.77 0 00-.75 0l-1.8 1.04c-.23.14-.37.38-.37.65v2.08c0 .27.14.52.38.65l1.8 1.04c.23.13.52.13.75 0l1.54-.89 8.44 3.96v1.3c0 .27.14.52.38.65l1.8 1.04c.23.13.52.13.75 0l1.8-1.04c.22-.14.36-.39.36-.65v-2.08c0-.27-.14-.52-.38-.65l-1.8-1.04a.77.77 0 00-.75 0l-1.54.89-8.43-3.96z" fill-rule="evenodd"/></svg>',
    shootingstaHalfOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.5 1c.396 0 .786.225.978.661l1.03 2.327 2.513.265c.43.043.797.343.926.74.132.407.013.853-.291 1.137l-.503.45C20.461 8.798 23 17.977 23 17.977l-2.644-1.719s1.13 2.763.608 6.77l-3.226-5.078s-.486 2.764-1.508 3.914c0 0-1.328-9.05-6.082-12.243l.133.74c.089.42-.08.86-.424 1.11a1.052 1.052 0 01-.634.186.963.963 0 01-.53-.132L6.5 10.229l-2.195 1.296a1.07 1.07 0 01-1.163-.053l-.027-.027a1.094 1.094 0 01-.396-1.084L3.22 7.85 1.343 6.13a1.058 1.058 0 01-.291-1.11v-.027c.125-.387.489-.658.899-.714.006 0-.007-.026 0-.026h.026l2.512-.265 1.032-2.327c.191-.436.581-.661.978-.661zm0 2.618l-.662 1.507-.212.45-2.141.238 1.242 1.11.37.344-.105.45-.344 1.666 1.428-.847.423-.238.423.238 1.428.847-.344-1.666-.105-.45.37-.344 1.243-1.11-2.142-.238-.212-.45-.66-1.507z"/></svg>',
    shootingstar: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.75 1c.486 0 .923.27 1.139.706l1.087 2.188 2.432.351c.484.07.877.402 1.027.865.15.463.027.96-.323 1.299l-1.758 1.703.415 2.403a1.272 1.272 0 01-1.843 1.338l-2.177-1.137-2.176 1.136c-.432.226-.945.19-1.34-.098a1.26 1.26 0 01-.503-1.24l.414-2.402-1.758-1.703a1.257 1.257 0 01-.323-1.299c.15-.463.543-.795 1.027-.865l2.433-.352 1.086-2.188A1.264 1.264 0 016.75 1zm6.406 5.692c7.946 2.167 9.807 10.31 9.826 10.4a.75.75 0 01-1.214.733c-.01-.008-.744-.615-1.85-1.214.28 1.233.58 3.137.58 5.638a.75.75 0 01-1.472.198c-.006-.022-.576-2.02-2.294-3.91-.365.777-.891 1.85-1.34 2.598a.75.75 0 01-1.39-.44c.003-.055.298-4.828-2.626-8.667.338-.481.483-1.08.379-1.683l-.325-1.882 1.379-1.335c.136-.133.25-.28.347-.436z"/></svg>',
    shootingstarOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.518 12c.264 0 .525-.083.749-.245a1.26 1.26 0 00.503-1.24l-.414-2.403 1.758-1.703c.35-.338.473-.836.323-1.299a1.262 1.262 0 00-1.027-.865l-2.433-.35L7.89 1.705A1.265 1.265 0 006.75 1c-.487 0-.924.27-1.14.705L4.523 3.894l-2.431.35c-.484.07-.878.402-1.028.866-.15.462-.026.96.323 1.299l1.758 1.703-.414 2.403c-.083.478.11.953.503 1.24.395.286.909.324 1.341.098l2.175-1.137 2.177 1.137c.187.098.39.147.591.147zm1.207-6.336L9.123 7.215c-.24.232-.35.567-.293.896l.38 2.196-1.99-1.04a1.016 1.016 0 00-.94 0l-1.989 1.04.38-2.196a1.006 1.006 0 00-.293-.896l-1.601-1.55 2.217-.32c.33-.048.615-.255.762-.553l.994-2.004.996 2.004c.147.297.431.504.761.551l2.218.32zm.652 6.364a2.248 2.248 0 00.38-1.683l-.041-.234c2.423 2.554 3.318 5.641 3.634 7.843.272-.575.46-1 .465-1.01a.75.75 0 011.187-.252 12.248 12.248 0 011.763 1.977c-.278-2.023-.705-3.126-.71-3.14a.75.75 0 01.959-.981c.662.248 1.27.547 1.795.84-1.078-2.445-3.593-6.363-8.848-7.438l.849-.822c.136-.133.25-.28.347-.436 7.946 2.167 9.807 10.31 9.826 10.4a.75.75 0 01-1.213.734 12.55 12.55 0 00-1.85-1.215c.28 1.233.58 3.137.58 5.639a.75.75 0 01-1.473.198c-.006-.022-.576-2.02-2.294-3.91-.365.777-.89 1.849-1.34 2.597a.751.751 0 01-1.391-.44c.004-.055.299-4.828-2.625-8.667z"/></svg>',
    signal: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.4 2.4l-1 2-9 3h-4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2v5h2v-5l9 3 1 2h2v-7.277a1.99 1.99 0 001-1.723 1.99 1.99 0 00-1-1.723V2.4h-2zm0 3.775v10.45l-.367-.123-7.633-2.543V8.84l7.633-2.543.367-.123zM4.4 9.4h4v4h-4v-4z"/></svg>',
    heart: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill-rule="evenodd"/></svg>',
    heartOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" fill-rule="evenodd"/></svg>',
    star: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.79 8.64l-6.28.86c-.41.06-.58.57-.28.86l4.58 4.39-1.13 6.24c-.07.41.36.73.73.53l5.59-3 5.59 3c.37.2.8-.12.73-.53l-1.13-6.24 4.58-4.39c.3-.29.14-.8-.28-.86l-6.28-.86-2.76-5.71a.498.498 0 00-.9 0z" fill-rule="evenodd"/></svg>',
    starOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 6.6l1.41 2.91.47.97 1.06.15 3.2.44-2.33 2.24-.78.74.19 1.06.57 3.18-2.85-1.53-.94-.52-.95.51-2.85 1.53.57-3.18.19-1.06-.77-.74-2.33-2.24 3.2-.44 1.06-.15.47-.97zM8.79 8.64l-6.28.86c-.41.06-.58.57-.28.86l4.58 4.39-1.13 6.24c-.07.41.36.73.73.53l5.59-3 5.59 3c.37.2.8-.12.73-.53l-1.13-6.24 4.58-4.39c.3-.29.14-.8-.28-.86l-6.28-.86-2.76-5.71a.498.498 0 00-.9 0z" fill-rule="evenodd"/></svg>',
    symbols: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 01.137.229l-.016.058-.514 1.18a.223.223 0 01-.245.13 2.965 2.965 0 00-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 002.871 5.924l-4.96 3.18A12.042 12.042 0 012 14.7c0-6.617 5.313-12 11.843-12z" fill-rule="evenodd"/></svg>',
    sync: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 3a6.44 6.44 0 00-5.264 2.754A5.966 5.966 0 001 11.708c0 3.13 2.428 5.7 5.5 5.935v-1.856c-2.057-.232-3.667-1.96-3.667-4.077a4.131 4.131 0 014.125-4.127l.788.043.283-.488A4.596 4.596 0 0112 4.833a4.557 4.557 0 014.52 3.864l.139.88 1.008-.132c.096-.013.191-.028.291-.028 1.77 0 3.209 1.439 3.209 3.208 0 1.77-1.44 3.208-3.209 3.208H17.5v1.834h.458A5.048 5.048 0 0023 12.625c0-2.717-2.16-4.94-4.854-5.038A6.378 6.378 0 0012 3zm-2.75 8.25L6.5 14h1.833v7.333h1.834V14H12l-2.75-2.75zm4.583.917V19.5H12l2.75 2.75 2.75-2.75h-1.833v-7.333h-1.834z"/></svg>',
    theme: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M10 13v4.5a3.5 3.5 0 01-7 0V13zm10.5 1a.5.5 0 01.5.5v6a.5.5 0 01-.5.5H10.071l7-7zm-14 1.707a.498.498 0 00-.354.147l-.793.792a.5.5 0 000 .708l.793.792a.498.498 0 00.707 0l.793-.792a.5.5 0 000-.708l-.793-.792a.498.498 0 00-.353-.147zM14.278 4.98c.128 0 .256.049.354.146l4.243 4.243a.5.5 0 010 .707L11.5 17.45v-9.9l2.425-2.425a.5.5 0 01.353-.146zM10 8.01v3.49H3V8.01zM9.5 3a.5.5 0 01.5.5v3.009H3V3.5a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    themeOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M10.5 3a.5.5 0 01.5.5v3.843l2.717-2.718a.499.499 0 01.707 0l4.95 4.95a.5.5 0 010 .707L16.664 13H20.5a.5.5 0 01.5.5v7a.5.5 0 01-.5.5H7a4 4 0 01-4-4V3.5a.5.5 0 01.5-.5zm9 11.5h-4.332l-4.986 5H19.5zM9.5 13h-5v4c0 1.378 1.121 2.5 2.5 2.5 1.378 0 2.5-1.122 2.5-2.5zm-2.146 3.11l.535.536a.5.5 0 010 .707l-.535.536a.5.5 0 01-.707 0l-.536-.536a.5.5 0 010-.707l.536-.535a.5.5 0 01.707 0zm6.717-9.717L11 9.464v7.072l6.607-6.607zM9.5 8.76h-5V11.5h5zm0-4.259h-5v2.759h5z" fill-rule="evenodd"/></svg>',
    threeDots: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10a2 2 0 110 4 2 2 0 010-4zm-6 0a2 2 0 110 4 2 2 0 010-4zm-6 0a2 2 0 110 4 2 2 0 010-4z" fill-rule="evenodd"/></svg>',
    threeDotsVertical: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14 18a2 2 0 11-4 0 2 2 0 014 0zm0-6a2 2 0 11-4 0 2 2 0 014 0zm0-6a2 2 0 11-4 0 2 2 0 014 0z"/></svg>',
    touchscreen: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.518 8.652c.547.017.969.494.969 1.041v3.625h.507c.106 0 .21.025.303.073l3.148 1.608a1 1 0 01.537 1.014l-.387 3.093a1 1 0 01-.987.875l-1.687.01.01.009H12.187c-.8 0-1.547-.404-1.986-1.075l-1.629-2.482a.595.595 0 01.169-.822 1.75 1.75 0 011.336-.25c.407.088.76.337 1.011.668l.399.411V9.651a1 1 0 011.03-.999zM21.492 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5h-2.07a2.96 2.96 0 00.158-.646l.387-3.092a3 3 0 00-1.612-3.044l-2.868-1.466V9.693c0-1.628-1.305-2.992-2.91-3.04l-.09-.001c-.828 0-1.605.333-2.177.936-.547.577-.822 1.36-.822 2.154v3.595a3.741 3.741 0 00-1.847.614 2.6 2.6 0 00-.741 3.587L8.516 20H2.492a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    touchscreenOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.528 8.652c.547.017.969.494.969 1.04v3.625h.507c.105 0 .21.026.303.073L17.455 15a1 1 0 01.537 1.014l-.387 3.093a1 1 0 01-.987.875l-1.687.01.01.009H12.196c-.8 0-1.546-.404-1.985-1.075l-1.629-2.483a.595.595 0 01.169-.822c.407-.268.89-.346 1.336-.25.406.089.76.338 1.011.669l.399.411V9.651a1 1 0 011.03-.999zM21.502 4a.5.5 0 01.5.5v11.022a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6h-16v12H6.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H2.502a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    trash: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.5 3a.5.5 0 01.5.5v1.625h3.502a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5h-.627v13.5a.5.5 0 01-.5.5H5.625a.5.5 0 01-.5-.5v-13.5h-.584a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h3.502V3.5a.5.5 0 01.5-.5zm1.625 3.875H6.875v12.25h10.25zM10.375 9a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-.75a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-.75a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5z" fill-rule="evenodd"/></svg>',
    trashAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M16.38 2.125a.5.5 0 01.5.5v3.5h4.122a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5h-1.687l-.967 13.536a.5.5 0 01-.499.464H6.151a.5.5 0 01-.499-.464L4.683 7.875h-1.68a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h4.12v-3.5a.5.5 0 01.5-.5zm1.18 5.75H6.438l.877 12.25h9.37zm-2.43-4H8.873v2.25h6.257z" fill-rule="evenodd"/></svg>',
    tree: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M9.361 0a2 2 0 11-1.23 3.576L3.98 5.973a2 2 0 010 .553l4.154 2.399A2 2 0 019.36 8.5a2 2 0 011.23.424l4.152-2.397a2 2 0 11.75 1.3l-4.152 2.396a2 2 0 01-1.23 2.13v4.795a2 2 0 01.48.276l4.152-2.397a2 2 0 11.75 1.3l-4.152 2.396A2 2 0 019.36 21a2 2 0 01-1.978-2.276l-4.154-2.399a2 2 0 11.751-1.299l4.153 2.399a2 2 0 01.478-.278v-4.795a2 2 0 01-1.228-2.128L3.229 7.825a2 2 0 11.001-3.151l4.152-2.397A2 2 0 019.362 0z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(2.8 1.7)"><path fill="currentColor" d="M0 0h18.723v21H0V0z"/></g></svg>',
    tutorial: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.619 4.2l.115.008c.077.01.154.027.228.052l9.607 3.206c.416.073.757.364.896.752l.044.155.02.125.006.117v5.751l.09.067c.41.336.674.823.718 1.361l.007.163c0 .388-.207.928-.572 1.621-.089.168-.186.342-.29.522-.121.208-.248.417-.376.621l-.373.575-.369.536-.368-.536a21.853 21.853 0 01-1.039-1.718c-.366-.693-.572-1.233-.572-1.621 0-.602.273-1.154.725-1.524l.089-.067v-4.125l-8.243 2.747a1.165 1.165 0 01-.592.039l-.145-.039L1.448 9.73a1.165 1.165 0 010-2.211l9.777-3.26c.127-.042.26-.062.394-.059zm6.028 8.372v3.193l-.077.096c-.197.245-.622.585-1.33.913-1.143.532-2.675.848-4.647.848-1.972 0-3.504-.316-4.647-.848-.707-.328-1.132-.668-1.329-.913l-.077-.096v-3.193l5.39 1.797a2.114 2.114 0 001.326 0l5.39-1.797z"/></svg>',
    tutorialAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.61 2a.815.815 0 00-.275.042L1.558 5.3a.815.815 0 10.516 1.546l9.52-3.173 9.519 3.173a.815.815 0 10.515-1.546l-9.777-3.26a.815.815 0 00-.24-.04zm0 5.704a.815.815 0 00-.275.04l-9.777 3.26a.815.815 0 000 1.547l9.777 3.259a.815.815 0 00.516 0l8.705-2.901v4.798a1.621 1.621 0 00-.815 1.403c0 .9 1.63 3.26 1.63 3.26S23 20.01 23 19.11c0-.602-.33-1.121-.815-1.403v-5.888a.815.815 0 00-.003-.108v-.015a.815.815 0 00-.02-.12.815.815 0 00-.653-.612l-9.658-3.22a.815.815 0 00-.24-.04zM5.89 15.71v2.584s1.308 1.63 5.703 1.63c4.395 0 5.704-1.63 5.704-1.63v-2.584l-4.93 1.644a2.464 2.464 0 01-1.547 0l-4.93-1.644z"/></svg>',
    tutorialOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.625 3.754l.145.01c.097.012.193.033.287.064l9.564 3.196c.575.1 1.036.533 1.17 1.093l.018.08.02.14.006.124v5.611l.088.077c.414.384.676.91.72 1.487l.007.174c0 .453-.219 1.026-.607 1.761-.09.172-.19.35-.296.533-.122.211-.25.423-.38.63l-.462.705-.535.774-.67-.976a23.849 23.849 0 01-.707-1.133c-.105-.183-.204-.36-.295-.533-.389-.735-.607-1.308-.607-1.76 0-.645.272-1.24.727-1.662l.087-.077V10.51l-7.848 2.616c-.251.084-.519.098-.775.042l-.152-.042-9.776-3.258a1.465 1.465 0 01-.001-2.78l9.777-3.26c.16-.053.327-.078.495-.074zm-.027 1.3c-.02-.001-.04.002-.057.008L1.763 8.32a.165.165 0 000 .313l9.778 3.26c.034.01.07.01.105 0l9.56-3.187v6.074l-.324.188a.971.971 0 00-.491.841c0 .17.166.604.457 1.154.082.156.172.319.27.487l.176.297.076.122.077-.122.176-.297c.098-.168.188-.33.27-.487.29-.55.457-.985.457-1.154a.971.971 0 00-.491-.841l-.324-.188-.002-6.338-.004-.015c-.015-.063-.067-.112-.226-.147l-9.657-3.22a.168.168 0 00-.048-.008zm6.349 6.955v3.715l-.144.178c-.224.28-.686.65-1.436.998-1.184.55-2.76.875-4.774.875-2.014 0-3.589-.325-4.773-.875-.75-.349-1.212-.717-1.437-.998l-.143-.178V12.01l5.784 1.929a1.814 1.814 0 001.137 0l5.786-1.929zm-1.301 1.803l-4.075 1.36a3.114 3.114 0 01-1.957 0l-4.074-1.36v1.416c.142.116.358.26.666.415l.161.078c1.007.468 2.395.754 4.226.754s3.22-.286 4.226-.754c.395-.184.663-.358.823-.49l.004-1.419z"/></svg>',
    unlock: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.808 2.004A5.005 5.005 0 0123 7v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7a3.003 3.003 0 00-3.289-2.986c-1.554.146-2.71 1.512-2.71 3.074V10h2.5a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5H13V7.123c0-2.708 2.1-5.017 4.807-5.12zM16 12H4v8h12zm-6.442 2.32a.625.625 0 01.884 0l1.238 1.238a.625.625 0 010 .884l-1.238 1.237a.625.625 0 01-.884 0l-1.237-1.237a.625.625 0 010-.884z" fill-rule="evenodd"/></svg>',
    unlockAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13.945 16.53l-1.414 1.415a.75.75 0 01-1.06 0l-1.415-1.414a.75.75 0 010-1.061l1.414-1.414a.75.75 0 011.06 0l1.415 1.414a.75.75 0 010 1.06M19.501 10H9V7.088c0-1.561 1.156-2.928 2.71-3.074a3.004 3.004 0 013.259 2.558.486.486 0 00.477.428h1.162a.377.377 0 00.375-.405 5.006 5.006 0 00-5.176-4.591C9.102 2.106 7 4.415 7 7.123V10H4.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    unlockAltOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.807 2.004a5.006 5.006 0 015.177 4.59.377.377 0 01-.376.406h-1.161a.487.487 0 01-.477-.428 3.004 3.004 0 00-3.259-2.558c-1.496.14-2.71 1.571-2.71 3.074V10h10.5a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-15a.5.5 0 01-.5-.5v-11a.5.5 0 01.5-.5H7V7.123c0-2.649 2.16-5.019 4.806-5.12zM18 12H6v8h12zm-6.442 2.32a.625.625 0 01.884 0l1.238 1.238a.625.625 0 010 .884l-1.238 1.237a.625.625 0 01-.884 0l-1.237-1.237a.625.625 0 010-.884z" fill-rule="evenodd"/></svg>',
    unlockOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.945 16.53l-1.414 1.415a.75.75 0 01-1.06 0L8.055 16.53a.75.75 0 010-1.061l1.414-1.414a.75.75 0 011.06 0l1.415 1.414a.75.75 0 010 1.06m5.863-14.526C15.102 2.106 13 4.415 13 7.123V10H2.5a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5H15V7.088c0-1.562 1.156-2.928 2.71-3.074A3.003 3.003 0 0121.001 7v2.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V7a5.005 5.005 0 00-5.193-4.996" fill-rule="evenodd"/></svg>',
    unsaveColored: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.5 10a2.5 2.5 0 000 5 2.5 2.5 0 000-5z" opacity=".65"/></svg>',
    upload: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13 17.5v3c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-3zM12 3c3.14 0 5.72 2.42 5.97 5.5h.42c2.44 0 4.52 1.9 4.61 4.34a4.5 4.5 0 01-4.5 4.66H13v-6.59l2.17 2.19c.2.2.51.2.71 0l.71-.71c.2-.2.2-.51 0-.71l-4.24-4.24c-.2-.2-.51-.2-.71 0L7.4 11.68c-.2.2-.2.51 0 .71l.71.71c.2.2.51.2.71 0L11 10.91v6.59H6.63c-2.98 0-5.52-2.32-5.63-5.3-.11-3.13 2.4-5.7 5.5-5.7h.05C7.5 4.44 9.58 3 12 3z"/></svg>',
    uploadOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.354 8.147l4.243 4.243a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L13 11.62V20.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-8.88l-2.183 2.184a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707l4.243-4.243a.5.5 0 01.707 0zM12 1.999c3.304 0 6.149 2.36 6.837 5.517 2.688.21 4.907 2.324 5.141 4.986a5.456 5.456 0 01-1.499 4.294c-1.06 1.113-2.558 1.702-4.095 1.702H15.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.892c.997 0 1.976-.376 2.66-1.102a3.477 3.477 0 00.934-2.718c-.157-1.783-1.733-3.18-3.587-3.18h-1.344l-.066-.79c-.179-2.159-1.67-4.032-3.771-4.558a5.003 5.003 0 00-5.76 2.77l-.27.587L6.46 7.5A4.513 4.513 0 003.18 8.96a4.468 4.468 0 00-1.161 3.45c.202 2.292 2.225 4.087 4.605 4.087H8.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H6.624c-3.407 0-6.305-2.596-6.598-5.912a6.446 6.446 0 011.68-4.976 6.52 6.52 0 014.223-2.086A7.02 7.02 0 0112 1.999z" fill-rule="evenodd"/></svg>',
    url: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.58 7.22c.2-.2.51-.2.71 0l4.34 4.34c1.8 1.8 1.8 4.74 0 6.54-.9.9-2.09 1.35-3.27 1.35s-2.37-.45-3.27-1.35l-4.34-4.34c-.2-.2-.2-.51 0-.71l.72-.72c.2-.2.51-.2.71 0l4.34 4.34c.5.49 1.15.76 1.85.76s1.36-.27 1.85-.76a2.607 2.607 0 000-3.69l-4.34-4.34c-.2-.2-.2-.51 0-.71zM6.62 4.56c1.18 0 2.37.45 3.27 1.35l4.35 4.33c.2.2.2.51 0 .71l-.72.72c-.2.2-.51.2-.71 0L8.47 7.33c-.5-.49-1.15-.76-1.85-.76s-1.36.27-1.85.76a2.607 2.607 0 000 3.69l4.34 4.34c.2.2.2.51 0 .71l-.71.72c-.2.2-.51.2-.71 0l-4.34-4.34c-1.8-1.8-1.8-4.74 0-6.54.9-.9 2.09-1.35 3.27-1.35z" fill-rule="evenodd"/></svg>',
    user: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 2.3a5.142 5.142 0 00-5.143 5.147c0 2.844 2.3 5.146 5.143 5.146a5.142 5.142 0 005.143-5.146c0-2.845-2.3-5.147-5.143-5.147zm0 2.573a2.57 2.57 0 012.571 2.574 2.57 2.57 0 11-5.142 0A2.57 2.57 0 0112 4.873zm0 9.007c-6.835 0-9 5.147-9 5.147V21.6h18v-2.573s-2.165-5.147-9-5.147zm0 2.573c4.415 0 5.826 2.574 5.826 2.574H6.174S7.641 16.453 12 16.453z"/></svg>',
    // Invite/add-member: the brand `user` glyph (scaled, anchored left) with the
    // brand `plus` glyph in the top-right corner. Used by the org switcher's
    // invite button (2026-06-10 per Nika).
    userPlus: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" transform="scale(0.85)" d="M12 2.3a5.142 5.142 0 00-5.143 5.147c0 2.844 2.3 5.146 5.143 5.146a5.142 5.142 0 005.143-5.146c0-2.845-2.3-5.147-5.143-5.147zm0 2.573a2.57 2.57 0 012.571 2.574 2.57 2.57 0 11-5.142 0A2.57 2.57 0 0112 4.873zm0 9.007c-6.835 0-9 5.147-9 5.147V21.6h18v-2.573s-2.165-5.147-9-5.147zm0 2.573c4.415 0 5.826 2.574 5.826 2.574H6.174S7.641 16.453 12 16.453z"/><path fill="currentColor" fill-rule="evenodd" transform="translate(11.8 -1.7) scale(0.6)" d="M18.5 11H13V5.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V11H5.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H11v5.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V13h5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5"/></svg>',
    // The shared navigation's Agents, Team and agents and Team members views (CanvasViewNav, AppNavbar, MainNavbar); the workspace shell's drawing.
    people: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 8C5.5 6.61929 6.61929 5.5 8 5.5C9.38071 5.5 10.5 6.61929 10.5 8C10.5 9.38071 9.38071 10.5 8 10.5C6.61929 10.5 5.5 9.38071 5.5 8ZM8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM15.5 9C15.5 8.17157 16.1716 7.5 17 7.5C17.8284 7.5 18.5 8.17157 18.5 9C18.5 9.82843 17.8284 10.5 17 10.5C16.1716 10.5 15.5 9.82843 15.5 9ZM17 6C15.3431 6 14 7.34315 14 9C14 10.6569 15.3431 12 17 12C18.6569 12 20 10.6569 20 9C20 7.34315 18.6569 6 17 6ZM14.2484 19.0377C14.9507 19.3232 15.8517 19.5 17.001 19.5C19.2833 19.5 20.5867 18.8027 21.2979 17.9421C21.643 17.5244 21.8186 17.1027 21.9077 16.7795C21.9521 16.6181 21.9754 16.48 21.9875 16.377C21.9936 16.3254 21.997 16.2821 21.9988 16.2487C21.9997 16.232 22.0003 16.2177 22.0006 16.2059L22.0009 16.1903L22.001 16.1839L22.001 16.1811L22.001 16.1786C22.001 14.9754 21.0256 14 19.8224 14H14.1796C14.1521 14 14.1248 14.0005 14.0977 14.0015C14.4916 14.4126 14.7787 14.927 14.914 15.5H19.8224C20.194 15.5 20.4958 15.7986 20.5009 16.1689C20.5006 16.1746 20.4997 16.1855 20.4979 16.2011C20.4934 16.2387 20.4835 16.3015 20.4615 16.3812C20.4177 16.5402 20.3277 16.7613 20.1416 16.9865C19.7903 17.4116 18.9687 18 17.001 18C16.0209 18 15.3252 17.854 14.8302 17.655C14.7231 18.0551 14.5452 18.5378 14.2484 19.0377ZM4.25 14C3.00736 14 2 15.0074 2 16.25V16.5011L2 16.5022L2.00001 16.5048L2.00007 16.5111L2.00035 16.5277C2.00064 16.5406 2.00117 16.5571 2.0021 16.5771C2.00396 16.6169 2.00745 16.6705 2.01398 16.7358C2.02701 16.8661 2.05233 17.045 2.10165 17.2564C2.19995 17.6776 2.39654 18.2404 2.79183 18.8051C3.61066 19.9749 5.17178 21 8 21C10.8282 21 12.3893 19.9749 13.2082 18.8051C13.6035 18.2404 13.8001 17.6776 13.8983 17.2564C13.9477 17.045 13.973 16.8661 13.986 16.7358C13.9926 16.6705 13.996 16.6169 13.9979 16.5771C13.9988 16.5571 13.9994 16.5406 13.9996 16.5277L13.9999 16.5111L14 16.5048L14 16.5022L14 16.25C14 15.0074 12.9926 14 11.75 14H4.25ZM3.50047 16.5072L3.5 16.4947V16.25C3.5 15.8358 3.83579 15.5 4.25 15.5H11.75C12.1642 15.5 12.5 15.8358 12.5 16.25V16.4946L12.4995 16.5072C12.4988 16.5222 12.4972 16.5493 12.4935 16.5865C12.486 16.6612 12.4703 16.7753 12.4376 16.9155C12.3718 17.1974 12.2403 17.5721 11.9793 17.9449C11.4857 18.6501 10.4218 19.5 8 19.5C5.57822 19.5 4.51434 18.6501 4.02067 17.9449C3.75971 17.5721 3.62818 17.1974 3.56241 16.9155C3.5297 16.7753 3.514 16.6612 3.50653 16.5865C3.50281 16.5493 3.50117 16.5222 3.50047 16.5072Z" fill="currentColor"/></svg>',
    wave: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.29 1.5a1.044 1.044 0 00-1.03 1.058v9.391a1.044 1.044 0 102.088 0V2.558A1.044 1.044 0 007.289 1.5zM4.158 5.674A1.044 1.044 0 003.13 6.732v5.217a1.044 1.044 0 102.086 0V6.732A1.044 1.044 0 004.16 5.674zm6.26.522a1.044 1.044 0 00-1.028 1.058v4.695a1.044 1.044 0 102.087 0V7.254a1.044 1.044 0 00-1.058-1.058zM1.03 8.283A1.044 1.044 0 000 9.34v2.608a1.044 1.044 0 102.087 0V9.341a1.044 1.044 0 00-1.059-1.058zm12.52 2.608a1.044 1.044 0 00-1.027 1.058v4.696a1.044 1.044 0 102.087 0v-4.696a1.044 1.044 0 00-1.06-1.058zm3.131 0a1.044 1.044 0 00-1.028 1.058v9.391a1.044 1.044 0 102.087 0v-9.39a1.044 1.044 0 00-1.059-1.059zm3.13 0a1.044 1.044 0 00-1.027 1.058v5.218a1.044 1.044 0 102.086 0v-5.218a1.044 1.044 0 00-1.058-1.058zm3.131 0a1.044 1.044 0 00-1.028 1.058v2.609a1.044 1.044 0 102.087 0v-2.609a1.044 1.044 0 00-1.059-1.058z"/></svg>',
    waveOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.188 1.85a.8.8 0 00-.788.812v9.6a.8.8 0 101.6 0v-9.6a.8.8 0 00-.812-.812zm-3.2 4.267a.8.8 0 00-.788.811v5.334a.8.8 0 101.6 0V6.928a.8.8 0 00-.812-.811zm6.4.533a.8.8 0 00-.788.812v4.8a.8.8 0 101.6 0v-4.8a.8.8 0 00-.812-.812zm-9.6 2.133A.8.8 0 000 9.595v2.667a.8.8 0 101.6 0V9.595a.8.8 0 00-.812-.812zm12.8 2.134a.8.8 0 00-.788.811v4.8a.8.8 0 101.6 0v-4.8a.8.8 0 00-.813-.811zm3.2 0a.8.8 0 00-.788.811v9.6a.8.8 0 101.6 0v-9.6a.8.8 0 00-.813-.811zm3.2 0a.8.8 0 00-.788.811v5.334a.8.8 0 101.6 0v-5.334a.8.8 0 00-.813-.811zm3.2 0a.8.8 0 00-.788.811v2.667a.8.8 0 101.6 0v-2.667a.8.8 0 00-.813-.811z"/></svg>',
    api: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M20.308 0C21.243 0 22 .757 22 1.692v13.539c0 .935-.757 1.692-1.692 1.692H1.692A1.692 1.692 0 010 15.231V1.692C0 .757.757 0 1.692 0zM6.55 5.077H4.444l-2.27 6.77h1.708l.436-1.488h2.21l.423 1.487h1.876L6.55 5.076zm6.568 0h-2.965v6.77h1.72V9.86h1.142c1.506 0 2.542-.941 2.542-2.381 0-1.455-.985-2.403-2.44-2.403zm6.37 0h-1.72v6.77h1.72v-6.77zM5.478 6.602l.727 2.519H4.646l.742-2.519h.089zm7.187-.203c.727 0 1.153.37 1.154 1.084 0 .703-.432 1.08-1.164 1.08h-.778V6.398z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(1 4)"><path fill="currentColor" d="M0 0h22v16.923H0V0z"/></g></svg>',
    apiOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.606 8h2.419l2.611 7.77H7.484l-.486-1.708H4.462l-.5 1.707H2L4.606 8zm6.554 0h3.402c1.67 0 2.8 1.089 2.8 2.758 0 1.653-1.19 2.733-2.917 2.733h-1.31v2.278H11.16V8zm8.74 0h1.975v7.77H19.9V8zm-6.764 1.517V12h.893c.84 0 1.336-.431 1.336-1.238-.001-.819-.49-1.245-1.324-1.245h-.905zm-7.447.234l-.851 2.89h1.788l-.834-2.89h-.103z"/></svg>',
    array: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.502 19h-4a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.5V7h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v13a.5.5 0 01-.5.5m-9-12h-2.5v10h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m-6.5-3.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5" fill-rule="evenodd"/></svg>',
    arrayOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9 4a.5.5 0 01.5.5v1A.5.5 0 019 6H6v12h3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H4.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm10.5 0a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H15a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3V6h-3a.5.5 0 01-.5-.5v-1A.5.5 0 0115 4z" fill-rule="evenodd"/></svg>',
    boolean: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zM7.85 7.42c-.86 0-1.603.256-2.231.782-.629.526-.988 1.18-1.078 1.962-.026.27-.038.898-.038 1.86v.236c.002.841.015 1.39.038 1.636.09.783.45 1.437 1.078 1.963.628.525 1.372.782 2.231.782.86 0 1.59-.257 2.219-.782.628-.526 1-1.18 1.09-1.963.026-.269.038-.897.038-1.872v-.233c-.002-.831-.014-1.38-.038-1.627-.09-.782-.462-1.436-1.09-1.962-.629-.526-1.36-.782-2.219-.782zm10.65.074h-2.284a.5.5 0 00-.5.5v.795a.5.5 0 00.5.5h.809v6.644a.5.5 0 00.5.5h.975a.5.5 0 00.5-.5V7.994a.5.5 0 00-.5-.5zM7.85 9.215c.705 0 1.257.513 1.347 1.219.012.205.025.73.025 1.59v.217c-.002.77-.015 1.25-.038 1.437-.064.68-.629 1.167-1.334 1.167-.705 0-1.27-.487-1.334-1.167-.025-.205-.038-.756-.038-1.654v-.208c.002-.737.014-1.194.025-1.382.09-.706.642-1.219 1.347-1.219zM13.5 12.5a1 1 0 100 2 1 1 0 000-2zm0-3a1 1 0 100 2 1 1 0 000-2z" fill-rule="evenodd"/></svg>',
    booleanOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.06 6.881c.927 0 1.71.285 2.38.87a3.304 3.304 0 011.155 2.18c.026.29.04.907.042 1.852v.243c0 1.098-.014 1.796-.042 2.11-.1.869-.485 1.596-1.154 2.18-.67.584-1.454.87-2.38.87-.927 0-1.725-.286-2.395-.87a3.287 3.287 0 01-1.14-2.18c-.026-.29-.04-.907-.043-1.864v-.246c0-1.083.015-1.781.043-2.095.1-.87.47-1.596 1.14-2.18.67-.585 1.468-.87 2.394-.87zM19.502 7a.5.5 0 01.5.5v8.933a.5.5 0 01-.5.5h-.782a.5.5 0 01-.5-.5V8.61h-.91a.5.5 0 01-.5-.5V7.5a.5.5 0 01.5-.5zM7.06 8.506c-.47 0-.869.157-1.225.47-.342.3-.542.699-.585 1.17-.014.241-.028.868-.028 1.88 0 1.04.014 1.682.043 1.924.071.926.84 1.61 1.795 1.61s1.725-.684 1.796-1.61c.027-.223.04-.787.043-1.69v-.234a41.25 41.25 0 00-.029-1.88 1.676 1.676 0 00-.598-1.17 1.726 1.726 0 00-1.212-.47zm6.69 4.244a1 1 0 110 2 1 1 0 010-2zm0-3.5a1 1 0 110 2 1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    bug: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.855 3.146a.5.5 0 01.707 0l1.793 1.794c.072.071.117.16.136.253a5.997 5.997 0 013.02 0 .498.498 0 01.135-.253l1.794-1.794a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-1.48 1.481a6.038 6.038 0 012.077 2.457l1.579-1.05a.5.5 0 01.693.139l.554.832a.5.5 0 01-.14.693l-2.156 1.436c.011.15.019.3.019.452v1h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H18v1c0 .152-.008.303-.019.453l2.158 1.438a.5.5 0 01.138.693l-.554.832a.5.5 0 01-.694.139l-1.578-1.052A6.007 6.007 0 0112 21a6.007 6.007 0 01-5.451-3.497l-1.576 1.051a.5.5 0 01-.694-.138l-.555-.832a.5.5 0 01.139-.693l2.156-1.438C6.007 15.303 6 15.153 6 15v-1H3.502a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H6v-1c0-.154.008-.306.02-.457L3.862 9.104a.5.5 0 01-.139-.693l.555-.832a.5.5 0 01.694-.139l1.578 1.053A6.038 6.038 0 018.628 6.04l-1.48-1.48a.5.5 0 010-.707zM12 7c-2.206 0-4 1.795-4 4v4c0 2.206 1.794 4 4 4 2.205 0 4-1.794 4-4v-4c0-2.205-1.795-4-4-4zm.354 3.44l.707.707a.5.5 0 010 .707l-.707.707a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.707l.707-.707a.5.5 0 01.708 0z"/></svg>',
    bugAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.855 3.146a.5.5 0 01.707 0l1.794 1.794c.072.071.117.16.135.253a5.997 5.997 0 013.02 0 .498.498 0 01.136-.253l1.793-1.794a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707l-1.48 1.481a6.038 6.038 0 012.078 2.457l1.578-1.05a.5.5 0 01.693.139l.554.832a.5.5 0 01-.139.693l-2.157 1.436c.012.15.019.3.019.452v1h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H18v1c0 .152-.007.303-.019.453l2.158 1.438a.5.5 0 01.138.693l-.554.832a.5.5 0 01-.694.139l-1.578-1.052A6.007 6.007 0 0112 21a6.007 6.007 0 01-5.45-3.497l-1.577 1.051a.5.5 0 01-.693-.138l-.555-.832a.5.5 0 01.138-.693l2.156-1.438C6.008 15.303 6 15.153 6 15v-1H3.502a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H6v-1c0-.154.008-.306.02-.457L3.862 9.104a.5.5 0 01-.138-.693l.555-.832a.5.5 0 01.693-.139l1.578 1.053A6.038 6.038 0 018.628 6.04l-1.48-1.48a.5.5 0 010-.707zM12 7c-2.205 0-4 1.795-4 4v4c0 2.206 1.795 4 4 4 2.206 0 4-1.794 4-4v-4c0-2.205-1.794-4-4-4zm.5 4a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5z"/></svg>',
    bugAlt2: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.354 2.646a.5.5 0 01.707 0l1.68 1.682c.38-.21.812-.326 1.26-.326.446 0 .877.116 1.257.326l1.681-1.682a.5.5 0 01.707 0l.708.707a.5.5 0 010 .707l-1.755 1.756c.492.78.988 1.69 1.402 2.692l2.079-1.143a.5.5 0 01.679.197l.482.876a.5.5 0 01-.197.68l-2.4 1.32c.208.82.337 1.68.351 2.562H19.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.518a.49.49 0 01-.143-.023c-.135.77-.347 1.505-.607 2.197l2.855 1.711a.5.5 0 01.17.686l-.515.857a.5.5 0 01-.686.172l-2.662-1.596c-.416.77-.866 1.457-1.291 2.036-.496.677-1.263.96-2.103.96-.84 0-1.607-.283-2.103-.96A17.618 17.618 0 018.604 19l-2.66 1.6a.5.5 0 01-.686-.172l-.516-.857a.5.5 0 01.171-.686l2.853-1.715a12.27 12.27 0 01-.605-2.193.49.49 0 01-.143.023H4.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2.505c.014-.882.143-1.741.35-2.563l-2.399-1.32a.5.5 0 01-.197-.68l.482-.875a.5.5 0 01.68-.197l2.078 1.143a17.93 17.93 0 011.403-2.692L7.646 4.06a.5.5 0 010-.707zM12 6.002a.601.601 0 00-.5.26C10.36 7.92 9 10.464 9 13.164c0 2.703 1.365 5.027 2.51 6.588A.604.604 0 0012 20a.605.605 0 00.49-.248c1.145-1.561 2.51-3.885 2.51-6.588 0-2.7-1.36-5.244-2.501-6.902a.6.6 0 00-.499-.26zm.354 3.437l.707.707a.5.5 0 010 .708l-.707.707a.5.5 0 01-.708 0l-.707-.707a.5.5 0 010-.708l.707-.707a.5.5 0 01.708 0z"/></svg>',
    bugAlt3: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.49 19.752A.604.604 0 0112 20a.604.604 0 01-.49-.248C10.365 18.191 9 15.867 9 13.164c0-2.7 1.36-5.244 2.5-6.902a.601.601 0 01.5-.26.6.6 0 01.5.26c1.14 1.658 2.5 4.202 2.5 6.902 0 2.703-1.365 5.027-2.51 6.588M19.5 13h-2.505a11.214 11.214 0 00-.35-2.563l2.399-1.32a.5.5 0 00.197-.68l-.482-.875a.5.5 0 00-.68-.197l-2.078 1.143A17.954 17.954 0 0014.6 5.816l1.755-1.756a.5.5 0 000-.707l-.708-.707a.5.5 0 00-.707 0l-1.68 1.682c-.38-.21-.812-.326-1.259-.326-.447 0-.878.116-1.258.326L9.06 2.646a.5.5 0 00-.707 0l-.708.707a.5.5 0 000 .707l1.756 1.756a17.93 17.93 0 00-1.403 2.692L5.92 7.365a.5.5 0 00-.679.197l-.482.876a.5.5 0 00.197.68l2.4 1.32c-.208.82-.337 1.68-.351 2.562H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h2.518a.49.49 0 00.143-.023c.135.768.346 1.502.605 2.193l-2.853 1.715a.5.5 0 00-.17.686l.515.857a.5.5 0 00.686.172l2.66-1.6c.417.773.868 1.46 1.293 2.04.496.677 1.263.96 2.103.96.84 0 1.607-.283 2.103-.96.425-.579.875-1.265 1.291-2.036l2.662 1.596a.5.5 0 00.686-.172l.516-.857a.5.5 0 00-.171-.686l-2.855-1.71c.26-.693.472-1.429.607-2.198a.49.49 0 00.143.023H19.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5"/></svg>',
    cdn: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.308 4C22.243 4 23 4.757 23 5.692v13.539c0 .935-.757 1.692-1.692 1.692H2.692A1.692 1.692 0 011 19.231V5.692C1 4.757 1.757 4 2.692 4zM5.022 8.971c-.5 0-.952.089-1.355.267a2.918 2.918 0 00-1.021.74 3.28 3.28 0 00-.635 1.099c-.146.417-.219.868-.219 1.352 0 .474.073.916.22 1.328a3.2 3.2 0 00.635 1.08c.277.31.618.552 1.02.727.404.175.855.262 1.355.262.403 0 .775-.061 1.113-.184a2.611 2.611 0 001.507-1.394c.153-.332.248-.703.285-1.112l-.096-.109-1.383-.053-.101.079c-.1.454-.237.76-.447.987-.207.226-.497.339-.878.339-.286 0-.525-.054-.718-.162a1.359 1.359 0 01-.475-.431 1.927 1.927 0 01-.273-.624 3.042 3.042 0 01-.088-.733c0-.263.03-.518.088-.764.057-.24.148-.454.273-.641.121-.182.28-.327.475-.435.193-.107.432-.162.718-.162a1.284 1.284 0 011.085.593c.071.114.117.24.137.378l.082.102 1.4.025.1-.099a2.074 2.074 0 00-.269-1.089 2.497 2.497 0 00-.64-.75 2.798 2.798 0 00-.87-.46 3.307 3.307 0 00-1.025-.156zm6.985.15H9.303l-.12.077-.029 6.34.099.1 2.752.048c.503 0 .94-.085 1.315-.255.374-.17.687-.404.938-.702a2.93 2.93 0 00.56-1.054c.122-.4.182-.836.182-1.307 0-.538-.074-1.009-.224-1.413a2.823 2.823 0 00-.63-1.018 2.597 2.597 0 00-.96-.614 3.376 3.376 0 00-1.179-.203zm8.393 0l-.103.098-.045 3.809-2.362-3.837-1.495-.07-.12.077-.03 6.34.096.099 1.34.049.103-.099.043-3.802 2.355 3.83 1.504.07.101-.098.049-6.317-.096-.1-1.34-.05zm-9.57 1.412l.83.043c.325 0 .592.046.803.134.208.087.373.21.498.37.127.165.219.364.275.599.059.242.088.516.088.82 0 .33-.04.605-.122.827-.081.221-.187.398-.318.531-.13.133-.277.227-.442.284l-.134.04-.129.027a1.648 1.648 0 01-.268.022l-1.081-.002v-3.695z"/></svg>',
    cdnOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.354 8.3c.391 0 .762.057 1.112.17.35.113.666.28.945.498.28.22.511.491.693.814.2.356.299.733.292 1.182l-.109.106-1.518-.026-.089-.111a1.06 1.06 0 00-.149-.41 1.342 1.342 0 00-.703-.562 1.393 1.393 0 00-.474-.081c-.31 0-.57.059-.779.175a1.457 1.457 0 00-.515.472 2.134 2.134 0 00-.296.696 3.56 3.56 0 00-.096.829c0 .272.032.537.095.794.062.252.161.477.296.677.132.195.303.35.516.468.21.117.469.175.78.175.413 0 .727-.122.952-.367.227-.246.376-.579.484-1.071l.11-.085 1.5.057.104.118c-.04.444-.143.846-.31 1.206-.167.362-.389.671-.665.927s-.6.451-.968.586c-.368.133-.77.2-1.208.2a3.647 3.647 0 01-1.469-.285 3.171 3.171 0 01-1.108-.788 3.47 3.47 0 01-.69-1.173 4.268 4.268 0 01-.237-1.44c0-.525.08-1.014.238-1.467.159-.454.388-.852.688-1.191.301-.342.671-.61 1.108-.803.437-.193.927-.29 1.47-.29zm7.578.162c.456 0 .883.073 1.28.22.399.147.746.37 1.039.666.293.296.52.665.684 1.105.163.438.243.948.243 1.532 0 .51-.065.984-.197 1.418-.133.44-.336.821-.607 1.143a2.861 2.861 0 01-1.019.762c-.406.185-.88.276-1.425.276l-2.987-.053-.106-.108.032-6.876.13-.085h2.933zm9.105 0l1.452.053.105.11-.053 6.852-.11.107-1.63-.076-2.556-4.155-.047 4.124-.112.107-1.453-.053-.104-.108.031-6.876.132-.085 1.621.076 2.563 4.163.048-4.132.113-.107zM10.655 9.994v4.009l1.172.001c.099 0 .196-.007.29-.023l.14-.03.146-.042c.179-.062.339-.164.48-.308.142-.145.257-.337.345-.576.088-.242.133-.54.133-.897 0-.33-.032-.628-.096-.89a1.692 1.692 0 00-.3-.65 1.296 1.296 0 00-.539-.402c-.23-.096-.518-.144-.872-.144l-.9-.048z"/></svg>',
    code: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.44 6.15c.2-.2.51-.2.71 0l5.5 5.5c.2.2.2.51 0 .71l-5.5 5.5c-.2.2-.51.2-.71 0l-.71-.71c-.2-.2-.2-.51 0-.71L19.17 12l-4.44-4.43c-.2-.2-.2-.51 0-.71zm-7.59 0c.2-.2.51-.2.71 0l.71.7c.19.2.19.52 0 .71L4.83 12l4.44 4.44c.2.2.2.51 0 .71l-.71.71c-.2.2-.51.2-.71 0l-5.5-5.5c-.2-.2-.2-.51 0-.71z" fill-rule="evenodd"/></svg>',
    date: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.346 10.355l-1.997 1.997a.5.5 0 01-.707 0l-1.997-1.997a.5.5 0 010-.707L8.642 7.65a.5.5 0 01.707 0l1.997 1.997a.5.5 0 010 .707M20.502 4h-3.504V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4h-6V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4H3.496a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h17.005a.5.5 0 00.5-.5v-16a.5.5 0 00-.5-.5" fill-rule="evenodd"/></svg>',
    dateOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.497 2a.5.5 0 01.5.5V4h6V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h3.505a.5.5 0 01.5.5v16a.5.5 0 01-.5.5H3.497a.5.5 0 01-.5-.5v-16a.5.5 0 01.5-.5h3.5V2.5a.5.5 0 01.5-.5zm10.505 4H4.997v13h14.005zM9.35 8.144l1.504 1.504a.5.5 0 010 .707l-1.504 1.503a.5.5 0 01-.707 0l-1.503-1.503a.5.5 0 010-.707l1.503-1.504a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    fork: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M16.536 3a2.893 2.893 0 01.964 5.62v1.13a2.893 2.893 0 01-2.893 2.892H12.68v2.736a2.894 2.894 0 11-1.929 0v-2.736H8.822a2.893 2.893 0 01-2.893-2.893V8.62a2.893 2.893 0 111.928 0v1.13a.964.964 0 00.965.963h5.785a.964.964 0 00.965-.964V8.62A2.893 2.893 0 0116.536 3zm-4.822 14.142a.964.964 0 100 1.928.964.964 0 000-1.928zM6.894 4.928a.964.964 0 100 1.928.964.964 0 000-1.928zm9.642 0a.964.964 0 100 1.928.964.964 0 000-1.928z"/></svg>',
    int: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.165 15.663c-.628.603-1.475.898-2.526.898-1.382 0-2.553-.575-3.207-1.52a.253.253 0 01.068-.358l1.12-.719a.247.247 0 01.335.063c.355.496.904.739 1.645.739.91 0 1.59-.526 1.59-1.296 0-.718-.68-1.257-1.718-1.257-.288 0-.55.025-.788.074a.25.25 0 01-.268-.11l-.424-.694a.25.25 0 01.049-.319l2.15-1.875h-2.855a.25.25 0 01-.25-.25V7.744a.25.25 0 01.25-.25h5.182a.25.25 0 01.25.25v.94a.5.5 0 01-.164.37l-1.901 1.723h.013c1.5.167 2.41 1.244 2.41 2.642 0 .898-.32 1.642-.96 2.244zm-6.368.837c0 .99-.805 1.795-1.795 1.795v-.897a.899.899 0 00.898-.898h-.898v-1.796h1.795zm-2.54-.25a.25.25 0 01-.25.25H4.12a.25.25 0 01-.25-.25v-.837a.5.5 0 01.148-.355l3.79-3.752c.346-.36.512-.731.512-1.103 0-.616-.513-1.09-1.141-1.09-.601 0-1.098.458-1.19 1.084a.247.247 0 01-.246.211H4.464a.253.253 0 01-.25-.278c.06-.714.35-1.326.862-1.838a2.846 2.846 0 012.116-.885c.808 0 1.487.27 2.052.82.577.552.859 1.206.859 1.976 0 .808-.385 1.59-1.141 2.321l-2.194 2.18h3.239a.25.25 0 01.25.25zM3.002 3.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5z" fill-rule="evenodd"/></svg>',
    intOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.813 15.375V17l-.006.14a1.627 1.627 0 01-1.62 1.485v-.813A.813.813 0 0012 17h-.812v-1.625zm7.937-8.376a.25.25 0 01.25.25v.77a.5.5 0 01-.162.37l-2.475 2.273c.043-.014.1-.014.171-.014.813.043 1.497.356 2.038.94.542.57.813 1.27.813 2.081 0 .998-.343 1.825-1.041 2.466-.698.641-1.596.969-2.708.969-1.589 0-2.903-.663-3.578-1.767a.253.253 0 01.084-.352l.983-.575a.247.247 0 01.333.078c.422.66 1.138.991 2.15.991 1.183 0 2.052-.727 2.052-1.767 0-1.012-.84-1.739-2.195-1.739-.317 0-.625.04-.915.109a.252.252 0 01-.278-.114l-.383-.645a.25.25 0 01.047-.313l2.67-2.4h-3.527a.25.25 0 01-.25-.25V7.25a.25.25 0 01.25-.25zM6.565 6.881c.84 0 1.567.3 2.166.884.613.584.912 1.283.912 2.109 0 .84-.385 1.682-1.169 2.494L5.596 15.39h3.996a.25.25 0 01.25.25v1.11a.25.25 0 01-.25.25h-6.34a.25.25 0 01-.25-.25v-.704a.5.5 0 01.138-.345l4.265-4.473c.41-.437.609-.874.613-1.339.007-.768-.638-1.41-1.405-1.439-.592-.022-1.07.27-1.434.836-.095.147-.116.323-.126.498a.248.248 0 01-.247.233h-1.13a.252.252 0 01-.25-.273c.056-.75.354-1.389.901-1.936a3.067 3.067 0 012.238-.927z" fill-rule="evenodd"/></svg>',
    npm: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M0 7v8.25h6.75v1.5H12v-1.5h12V7H0zm1.333 1.333h5.335v5.751H5.333V9.667H4v4.417H1.333V8.333zm6.668 0h5.333v5.75h-2.667v1.334H8.001V8.333zm6.666 0h8.001v5.751h-1.334V9.667h-1.333v4.417h-1.333V9.667h-1.335v4.417h-2.666V8.333zm-4 1.334v3.084H12V9.667h-1.333z"/></svg>',
    npmOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M1.733 8.333h5.335v5.751H5.733V9.667H4.4v4.417H1.733V8.333zm6.268 0h5.333v5.75h-2.667v1.334H8.001V8.333zm6.266 0h8.001v5.751h-1.334V9.667h-1.333v4.417h-1.333V9.667h-1.335v4.417h-2.666V8.333zm-3.6 1.334v3.084H12V9.667h-1.333z"/></svg>',
    object: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 12.432c0 .195-.145.36-.338.385-.964.118-1.581.808-1.367 2.456.064.495.14.972.14 1.468 0 1.3-.836 2.267-1.962 2.259H14.39c-.215 0-.389-.155-.389-.37v-1.225c0-.214.173-.404.387-.405h1.093c.852 0 1.28-.061 1.28-.858 0-.407-.26-1.355-.26-2.18 0-1.131.445-1.713 1.2-1.923l.087-.02v-.038l-.086-.02c-.756-.21-1.201-.792-1.201-1.923 0-.825.26-1.773.26-2.18 0-.796-.428-.858-1.28-.858h-1.093c-.214-.001-.387-.19-.387-.405V5.37c0-.215.174-.37.39-.37.512 0 1.816.002 2.083 0 1.126-.008 1.962.959 1.962 2.26 0 .495-.076.972-.14 1.468-.214 1.648.403 2.337 1.367 2.456.193.024.338.19.338.384zM10 6.595C10 6.81 9.828 7 9.613 7H8.521c-.853 0-1.28.062-1.28.859 0 .406.26 1.354.26 2.179 0 1.131-.445 1.713-1.201 1.923l-.087.02v.038l.087.02c.756.21 1.2.792 1.2 1.924 0 .824-.26 1.772-.26 2.179 0 .797.428.858 1.28.858h1.093c.215.001.387.19.387.405v1.225c0 .215-.174.37-.39.37H7.528c-1.126.008-1.962-.959-1.962-2.26 0-.495.076-.972.14-1.467.214-1.648-.403-2.338-1.366-2.456A.388.388 0 014 12.432v-.864c0-.195.145-.36.339-.384.963-.119 1.58-.808 1.366-2.456-.064-.496-.14-.973-.14-1.468 0-1.301.836-2.268 1.962-2.26.268.002 1.571 0 2.084 0 .215 0 .39.155.39.37zM20.5 3h-17a.5.5 0 00-.5.5v17a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-17a.5.5 0 00-.5-.5z" fill-rule="evenodd"/></svg>',
    objectOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.97 4c1.286-.009 2.241 1.096 2.241 2.582 0 .567-.086 1.111-.16 1.678-.244 1.884.461 2.671 1.562 2.807a.443.443 0 01.387.44v.986a.442.442 0 01-.387.44c-1.101.135-1.806.923-1.561 2.807.073.567.16 1.111.16 1.678 0 1.486-.956 2.59-2.243 2.582h-2.524c-.246 0-.445-.177-.445-.423V18.47a.46.46 0 01.442-.463h1.392c.974 0 1.463-.07 1.463-.98 0-.465-.08-.734-.143-1.22-.08-.505-.154-1.018-.154-1.564 0-1.294.508-1.959 1.372-2.199l.1-.022v-.044l-.1-.022C18.508 11.716 18 11.05 18 9.757c0-.546.074-1.059.154-1.563.063-.487.143-.756.143-1.22 0-.91-.489-.982-1.463-.982h-.467l-.14.001h-.785C15.197 5.99 15 5.774 15 5.53V4.423c0-.246.2-.423.445-.423zM8.554 4c.246 0 .445.177.445.423V5.53a.46.46 0 01-.442.462l-.219.001H7.166c-.974 0-1.463.07-1.463.98 0 .465.08.734.143 1.22.08.505.154 1.018.154 1.564 0 1.293-.508 1.959-1.372 2.199l-.099.022v.044l.1.022c.863.24 1.371.905 1.371 2.199 0 .546-.074 1.059-.154 1.563-.063.487-.143.756-.143 1.22 0 .911.49.981 1.463.981H8.56A.46.46 0 019 18.47v1.107c0 .246-.199.423-.445.423H6.031c-1.287.009-2.242-1.096-2.242-2.582 0-.567.086-1.111.16-1.678.244-1.884-.46-2.672-1.562-2.807a.442.442 0 01-.387-.44v-.986c0-.223.166-.413.387-.44 1.101-.136 1.806-.923 1.562-2.807-.074-.567-.16-1.111-.16-1.678 0-1.486.955-2.59 2.242-2.582z" fill-rule="evenodd"/></svg>',
    pnpm: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M22 8h-6V2h6v6zm-7 0H9V2h6v6zM8 8H2V2h6v6zm14 7h-6V9h6v6zm-7 0H9V9h6v6zm0 7H9v-6h6v6zm7 0h-6v-6h6v6zM8 22H2v-6h6v6z"/></svg>',
    pnpmOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15 16v6H9v-6h6zm7 0v6h-6v-6h6zM8 16v6H2v-6h6zm13 1h-4v4h4v-4zm-7 0h-4v4h4v-4zm-7 0H3v4h4v-4zm15-8v6h-6V9h6zm-7 0v6H9V9h6zm6 1h-4v4h4v-4zm-7 0h-4v4h4v-4zm8-8v6h-6V2h6zm-7 0v6H9V2h6zM8 2v6H2V2h6zm13 1h-4v4h4V3zm-7 0h-4v4h4V3zM7 3H3v4h4V3z"/></svg>',
    properties: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.5 7h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m0 6h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5m-18.755-.814V5.808a.5.5 0 01.098-.297l.642-.87c.144-.195.377-.195.521 0l.642.87a.5.5 0 01.097.297v12.378a.5.5 0 01-.097.297l-.642.87c-.144.195-.377.195-.521 0l-.642-.87a.5.5 0 01-.098-.297z"/></svg>',
    state: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.53 10.97l.94-.94c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06l-.94.94c-.29.29-.77.29-1.06 0l-.94-.94a.754.754 0 010-1.06zm9-1.71l1.71 1.71c.29.29.29.77 0 1.06l-1.71 1.71c-.29.29-.77.29-1.06 0l-1.71-1.71a.754.754 0 010-1.06l1.71-1.71c.29-.29.77-.29 1.06 0zm5 2.77l1.94 1.94c.29.29.77.29 1.06 0l1.94-1.94c.29-.29.29-.77 0-1.06l-1.94-1.94a.754.754 0 00-1.06 0l-1.94 1.94c-.29.29-.29.77 0 1.06z"/></svg>',
    stateColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="nonzero" fill="currentColor"><path fill="currentColor" d="M2.53 10.97l.94-.94c.29-.29.77-.29 1.06 0l.94.94c.29.29.29.77 0 1.06l-.94.94c-.29.29-.77.29-1.06 0l-.94-.94a.754.754 0 010-1.06z" opacity=".45"/><path fill="currentColor" d="M11.535 9.26l1.71 1.71c.29.29.29.77 0 1.06l-1.71 1.71c-.29.29-.77.29-1.06 0l-1.71-1.71a.754.754 0 010-1.06l1.71-1.71c.29-.29.77-.29 1.06 0z" opacity=".65"/><path fill="currentColor" d="M16.54 12.03l1.94 1.94c.29.29.77.29 1.06 0l1.94-1.94c.29-.29.29-.77 0-1.06l-1.94-1.94a.754.754 0 00-1.06 0l-1.94 1.94c-.29.29-.29.77 0 1.06z"/></g></svg>',
    stateOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M1.605 12l1.394 1.394L4.393 12l-1.394-1.394zm1.022 2.844L.154 12.371a.525.525 0 010-.742l2.473-2.473a.526.526 0 01.743 0l2.473 2.473a.525.525 0 010 .742L3.37 14.844a.525.525 0 01-.743 0zM9.285 12l1.708 1.708L12.701 12l-1.708-1.708zm1.355 3.475l-3.121-3.122a.5.5 0 010-.706l3.12-3.122a.5.5 0 01.707 0l3.122 3.122a.5.5 0 010 .706l-3.122 3.122a.5.5 0 01-.706 0zM17.976 12l2.011 2.012L22 12l-2.012-2.012zm1.644 3.845l-3.478-3.478a.519.519 0 010-.734l3.478-3.479a.519.519 0 01.734 0l3.479 3.48a.519.519 0 010 .733l-3.48 3.478a.519.519 0 01-.733 0z"/></svg>',
    string: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5zm-8.322 5.613c-.914 0-1.689.17-2.323.508a4.978 4.978 0 00-1.43 1.139.248.248 0 00.05.373l.842.535a.293.293 0 00.365-.037c.348-.344 1.24-1.094 2.381-1.094 1.552 0 2.352.701 2.352 1.915v.338h-2.463c-1.226 0-2.191.245-2.895.734C8.352 13.514 8 14.21 8 15.113c0 .355.065.685.194.992.129.306.322.578.58.814.259.237.581.423.968.557.387.134.839.201 1.355.201.752 0 1.446-.15 2.08-.451a3.893 3.893 0 001.25-.898v.877c0 .163.132.295.295.295h.983a.295.295 0 00.295-.295v-5.253c0-.495-.083-.946-.25-1.355a2.902 2.902 0 00-.734-1.057 3.33 3.33 0 00-1.193-.685c-.474-.161-1.022-.242-1.645-.242zm2.237 5.037v.832c-.226.44-1.232 1.739-3.076 1.739-1.09 0-1.689-.428-1.689-1.205 0-.587.245-1.366 2.367-1.366zM19 6.5h-2v2h1c0 .552-.448 1-1 1v1c1.103 0 2-.897 2-2zm-12 0c-1.102 0-2 .897-2 2v2h2v-2H6c0-.551.449-1 1-1z" fill-rule="evenodd"/></svg>',
    stringOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.184 8.002c.702 0 1.319.09 1.851.272.532.182.98.439 1.343.772.363.332.638.729.825 1.188a4 4 0 01.282 1.524v5.91a.332.332 0 01-.332.332h-1.107a.332.332 0 01-.332-.332v-.986c-.326.339-.69.671-1.405 1.01a5.397 5.397 0 01-2.34.508c-.58 0-1.09-.076-1.525-.227a3.081 3.081 0 01-1.088-.626 2.605 2.605 0 01-.654-.916 2.85 2.85 0 01-.217-1.116c0-1.017.396-1.8 1.188-2.35.792-.55 1.878-.826 3.257-.826h2.771v-.381c0-1.365-.9-2.154-2.645-2.154-1.284 0-2.287.844-2.68 1.23a.33.33 0 01-.41.043l-.946-.602a.279.279 0 01-.057-.42c.455-.524.99-.952 1.608-1.281.714-.381 1.585-.572 2.613-.572zm2.517 5.667h-2.698c-2.386 0-2.662.877-2.662 1.537 0 .874.675 1.355 1.9 1.355 2.074 0 3.206-1.461 3.46-1.956zM20.001 6v2l-.006.15A2.003 2.003 0 0118 10V9c.551 0 1-.448 1-1h-1V6zM6 6v1c-.551 0-1 .449-1 1h1v2H4V8l.006-.149A2.003 2.003 0 016 6z" fill-rule="evenodd"/></svg>',
    terminal: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21.499 4a.5.5 0 01.5.5v15a.5.5 0 01-.5.5H2.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5zm-1.5 2H4v12h16zm-3 7.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM7.56 8.147l3 3a.5.5 0 010 .707l-3 3a.5.5 0 01-.707 0l-.707-.708a.5.5 0 010-.707l1.94-1.939-1.94-1.94a.5.5 0 010-.706l.707-.707a.5.5 0 01.707 0z" fill-rule="evenodd"/></svg>',
    version: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11 3c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-8zM7 4a1 1 0 00-1 1v14a1 1 0 002 0V5a1 1 0 00-1-1zM4 6a1 1 0 00-1 1v10a1 1 0 002 0V7a1 1 0 00-1-1z"/></svg>',
    versionOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11 3c-1.093 0-2 .907-2 2v14c0 1.093.907 2 2 2h8c1.093 0 2-.907 2-2V5c0-1.093-.907-2-2-2h-8zM8 4c-1.093 0-2 .907-2 2v12c0 1.093.907 2 2 2V4zm3 1h8v14h-8V5zM5 6c-1.093 0-2 .907-2 2v8c0 1.093.907 2 2 2V6z"/></svg>',
    yarn: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.188 2.005c-.65.11-1.312 2.085-1.312 2.085s-1.736-.286-3.18 1.147c-.29.287-.577.428-1.01.57-.145.144-.29.146-.579 1.006-.578 1.29.866 2.865.866 2.865-3.033 2.15-2.89 5.015-2.745 5.732-1.878 1.576-1.156 3.582-.722 4.155.289.43.577.286.722.286 0 .143-.722 1.003 0 1.29.722.43 1.88.573 2.458 0 .433-.43.577-1.291.722-1.721.144-.143.144.287.722.573 0 0-1.012.43-.578 1.433.144.287.578.574 1.444.574.29 0 3.755-.144 4.622-.431.578-.143.723-.428.723-.428 3.756-1.003 4.479-2.58 7.079-3.154.867-.143.867-1.576-.722-1.433-1.156 0-2.167.574-3.034 1.148-1.444.86-2.454 1.002-2.454.859-.145-.144.575-1.862-.147-3.725-.722-2.006-2.02-2.58-1.876-2.723.433-.717 1.443-1.862 1.876-3.868.144-1.29.146-3.438-.432-4.44-.144-.287-1.013.285-1.013.285s-.865-1.864-1.154-2.007a.34.34 0 00-.276-.078z"/></svg>',
    yarnOutline: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M21.987 16.611c-.107-.834-.822-1.409-1.74-1.397-1.37.017-2.52.716-3.284 1.18a7.178 7.178 0 01-.774.417 6.147 6.147 0 00-.352-2.554c-.435-1.174-1.019-1.896-1.436-2.313.483-.693 1.144-1.702 1.454-3.264.268-1.332.185-3.405-.43-4.567a.946.946 0 00-.595-.475c-.107-.03-.31-.088-.71.023-.601-1.227-.81-1.356-.97-1.462a1.23 1.23 0 00-1.097-.123c-.495.176-.918.646-1.317 1.48-.06.123-.113.24-.161.357a4.423 4.423 0 00-2.956 1.398c-.125.135-.37.234-.626.328H7c-.524.182-.762.605-1.054 1.368-.406 1.069.012 2.12.423 2.8-.56.493-1.305 1.28-1.699 2.202-.488 1.139-.542 2.254-.524 2.859-.417.434-1.06 1.25-1.132 2.166-.096 1.28.375 2.148.584 2.465.06.094.125.17.196.247-.024.158-.03.329.006.505.078.41.34.745.74.957.786.41 1.882.587 2.729.17.303.317.858.622 1.865.622h.06c.256 0 3.51-.17 4.457-.4.423-.099.715-.275.906-.434.608-.187 2.288-.751 3.873-1.76 1.12-.717 1.508-.87 2.342-1.07.81-.193 1.317-.92 1.216-1.725zm-1.418.863c-.954.223-1.436.429-2.616 1.186-1.842 1.174-3.856 1.72-3.856 1.72s-.167.246-.65.358c-.834.2-3.974.37-4.26.376-.77.005-1.24-.194-1.371-.505-.4-.94.572-1.35.572-1.35s-.215-.13-.34-.247c-.113-.112-.232-.335-.268-.252-.149.358-.226 1.232-.626 1.626-.548.546-1.585.364-2.199.047-.673-.353.048-1.18.048-1.18s-.364.211-.656-.223c-.262-.4-.506-1.08-.44-1.92.071-.957 1.156-1.884 1.156-1.884s-.191-1.415.435-2.865c.566-1.32 2.091-2.383 2.091-2.383S6.31 8.58 6.785 7.324c.31-.822.435-.816.536-.851.358-.135.703-.282.96-.558 1.28-1.362 2.914-1.103 2.914-1.103s.774-2.32 1.49-1.867c.22.14 1.013 1.878 1.013 1.878s.846-.487.941-.305c.513.98.572 2.853.346 3.992-.381 1.878-1.335 2.888-1.716 3.522-.09.147 1.025.61 1.728 2.53.65 1.756.071 3.229.173 3.393.018.03.023.041.023.041s.745.06 2.241-.85c.799-.488 1.746-1.034 2.825-1.046 1.043-.017 1.096 1.186.31 1.374z"/></svg>',
    cmd: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zm-4-9a.5.5 0 01-.5-.5V11l.5-.001a.5.5 0 010 1zm-2.512-1.993v-1L15 9.004v1l-1.012.003zm-1 1.505a.5.5 0 11-.5-.5v-.003l.5.001v.502zm-.5-3.5a.5.5 0 11.5-.5v.498l-.5.002zM16 7.5a.5.5 0 11.5.5V8H16V7.5zm.5 2.5L16 10v-1L16.5 9A1.502 1.502 0 0018 7.5c0-.827-.673-1.5-1.5-1.5S15 6.673 15 7.5v.504l-1.012.003v-.495c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5.673 1.5 1.5 1.5l.5-.002v1l-.502.002a1.502 1.502 0 00-1.498 1.5c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-.505L15 11.004v.496c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z"/></svg>',
    cmdAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM15 16c-.552 0-1-.449-1-1v-1h1a1.001 1.001 0 010 2zm-4-3h2v-2h-2v2zm-1 2a1.001 1.001 0 01-2 0c0-.552.448-1 1-1h1v1zm-1-5a1.001 1.001 0 010-2c.551 0 1 .448 1 1v1H9zm5-1a1.001 1.001 0 012 0c0 .551-.449 1-1 1h-1V9zm1 4h-1v-2h1c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2v1h-2V9c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2h1v2H9c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2v-1h2v1c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2z"/></svg>',
    ctrlMac: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zm-3.348-10.323L14.5 8.025l-2.652 2.652a.25.25 0 01-.353 0l-.354-.354a.25.25 0 010-.353l3.182-3.183a.25.25 0 01.354 0l3.182 3.183a.25.25 0 010 .353l-.354.354a.25.25 0 01-.353 0"/></svg>',
    ctrlMacAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-7.735 4.808l4.526 4.526a.25.25 0 010 .353l-.354.354a.25.25 0 01-.353 0L12 9.957l-4.084 4.084a.25.25 0 01-.353 0l-.354-.354a.25.25 0 010-.353l4.526-4.526a.376.376 0 01.53 0z"/></svg>',
    ctrlWin: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM8.307 10.208c0-1.071.7-1.897 1.792-1.897.9 0 1.466.504 1.617 1.24a.064.064 0 01-.063.076h-.806a.061.061 0 01-.06-.047.654.654 0 00-.646-.506c-.574 0-.868.441-.868 1.134 0 .679.273 1.134.854 1.134.368 0 .634-.186.712-.558a.062.062 0 01.06-.051h.795c.037 0 .068.033.063.07-.093.73-.68 1.302-1.61 1.302-1.133 0-1.84-.826-1.84-1.897m3.756-1.8h.427V7.352c0-.034.028-.062.062-.062h.806c.035 0 .063.028.063.062V8.41h.553c.035 0 .063.028.063.062v.505a.063.063 0 01-.063.063h-.553v1.904c0 .266.147.357.357.357h.217c.035 0 .063.028.063.062v.572c0 .033-.025.06-.059.062-.088.004-.273.01-.536.01-.462 0-.973-.181-.973-.86V9.039h-.427A.063.063 0 0112 8.976v-.505c0-.034.028-.062.063-.062m3.406.574h.02c.218-.406.463-.616.883-.616.076 0 .13.004.176.014a.062.062 0 01.048.06v.72c0 .036-.031.064-.067.062-.59-.034-1.025.298-1.025 1.027v1.687a.062.062 0 01-.063.063h-.827a.062.062 0 01-.062-.063V8.471c0-.034.028-.062.062-.062h.792c.035 0 .063.028.063.062v.512zM17.11 7h.827c.035 0 .063.028.063.063v4.874a.062.062 0 01-.063.063h-.827a.062.062 0 01-.062-.063V7.063c0-.035.028-.063.062-.063"/></svg>',
    ctrlWinAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM6 12.834c0-1.295.696-2.293 2.016-2.293 1.065 0 1.609.583 1.794 1.442a.125.125 0 01-.124.149H8.96a.126.126 0 01-.12-.094c-.103-.34-.384-.625-.772-.625-.694 0-1.05.583-1.05 1.421 0 .82.33 1.42 1.033 1.42.433 0 .748-.255.852-.685a.127.127 0 01.122-.1h.715c.075 0 .136.066.125.14-.12.855-.689 1.518-1.789 1.518-1.37 0-2.075-.998-2.075-2.293m4.625-2.175h.476V9.431c0-.069.056-.125.125-.125h.725c.07 0 .125.056.125.125v1.228h.62c.069 0 .125.057.125.125v.462a.125.125 0 01-.125.125h-.62v2.351c0 .322.178.432.432.432.067 0 .146-.002.21-.004a.125.125 0 01.128.125v.6a.124.124 0 01-.119.125 9.479 9.479 0 01-.45.008c-.558 0-1.176-.22-1.176-1.04V11.37h-.476a.125.125 0 01-.125-.125v-.462c0-.068.056-.125.125-.125m4.121.694h.026c.262-.49.558-.744 1.066-.744.067 0 .12.002.165.008a.124.124 0 01.105.124v.725c0 .07-.056.127-.126.125-.69-.021-1.194.382-1.194 1.244v2.04a.125.125 0 01-.125.125h-.75a.125.125 0 01-.125-.125v-4.09c0-.07.056-.125.125-.125h.708c.07 0 .125.056.125.125v.568zM17.124 9h.751c.069 0 .125.056.125.125v5.75a.125.125 0 01-.125.125h-.75a.125.125 0 01-.126-.125v-5.75c0-.069.056-.125.125-.125"/></svg>',
    ctrlWinAlt2: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM7.057 12.208c0-1.071.7-1.897 1.792-1.897.9 0 1.467.504 1.617 1.24a.065.065 0 01-.063.076h-.806a.062.062 0 01-.059-.048.654.654 0 00-.647-.505c-.574 0-.868.44-.868 1.134 0 .679.273 1.134.854 1.134.368 0 .634-.186.712-.558a.062.062 0 01.06-.051h.795c.037 0 .068.033.063.07-.093.73-.68 1.302-1.609 1.302-1.134 0-1.841-.826-1.841-1.897m3.756-1.8h.427V9.353c0-.035.028-.063.062-.063h.807c.034 0 .062.028.062.063v1.057h.553c.035 0 .063.028.063.062v.506a.063.063 0 01-.063.062h-.553v1.904c0 .266.147.357.357.357h.217c.035 0 .063.028.063.062v.572a.062.062 0 01-.059.062c-.088.004-.273.01-.536.01-.462 0-.973-.181-.973-.86v-2.107h-.427a.063.063 0 01-.063-.062v-.506c0-.034.028-.062.063-.062m3.406.574h.02c.218-.406.463-.616.883-.616.076 0 .13.004.176.014a.062.062 0 01.048.06v.72c0 .036-.03.064-.067.062-.59-.034-1.025.298-1.025 1.027v1.687a.063.063 0 01-.063.063h-.827a.063.063 0 01-.062-.063v-3.466c0-.034.028-.062.062-.062h.792c.035 0 .063.028.063.062v.512zM15.86 9h.827c.035 0 .063.028.063.062v4.875a.063.063 0 01-.063.063h-.827a.063.063 0 01-.062-.063V9.062c0-.034.028-.062.062-.062"/></svg>',
    option: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM17.75 8h-3.5a.25.25 0 01-.25-.25v-.5a.25.25 0 01.25-.25h3.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25m0 4H14a.5.5 0 01-.433-.25L11.402 8H9.25A.25.25 0 019 7.75v-.5A.25.25 0 019.25 7h2.44a.5.5 0 01.433.25L14.288 11h3.462a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25"/></svg>',
    optionAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 20h16V4H4v16zm16.5 1h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17a.5.5 0 01-.5.5zM16.75 8h-3.5a.25.25 0 01-.25-.25v-.5a.25.25 0 01.25-.25h3.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25m0 9h-3.522a.25.25 0 01-.239-.175L10.221 8H7.25A.25.25 0 017 7.75v-.5A.25.25 0 017.25 7h3.522c.11 0 .206.07.239.175L13.779 16h2.97a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25"/></svg>',
    shift: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9 17h2v-3h.975L10 12.025 8.025 14H9v3zM20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-9.735 6.876l3.697 3.697a.25.25 0 01-.176.427H12v2.75a.25.25 0 01-.25.25h-3.5a.25.25 0 01-.25-.25V15H6.214a.25.25 0 01-.176-.427l3.697-3.697a.375.375 0 01.53 0z"/></svg>',
    shiftAlt: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.5 13.026h2v-3h.975L14.5 8.05l-1.975 1.975h.975v3zM20.5 3a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-5.235 2.902l3.697 3.697a.25.25 0 01-.176.427H16.5v2.75a.25.25 0 01-.25.25h-3.5a.25.25 0 01-.25-.25v-2.75h-1.786a.25.25 0 01-.176-.427l3.697-3.697a.375.375 0 01.53 0z"/></svg>',
    shiftAlt2: '<svg width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.5 16h3v-4.368h1.907L12 8.225l-3.407 3.407H10.5V16zm10-13a.5.5 0 01.5.5v17a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-17a.5.5 0 01.5-.5h17zM20 4H4v16h16V4zm-7.735 3.076l4.916 4.916a.375.375 0 01-.265.64H14.5v3.993a.375.375 0 01-.375.375h-4.25a.375.375 0 01-.375-.375v-3.993H7.084a.375.375 0 01-.265-.64l4.916-4.916a.376.376 0 01.53 0z"/></svg>',
    fontFace: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M14.793 0l.112.12V5.3l.055.016c.33-.35.69-.614 1.08-.79.391-.174.775-.262 1.153-.262.967 0 1.775.382 2.423 1.148.648.765.972 1.761.972 2.99 0 1.179-.372 2.17-1.116 2.973-.744.802-1.607 1.203-2.59 1.203-.43 0-.855-.066-1.272-.199a5.41 5.41 0 01-1.176-.534l-.59.917-.494-.112c.027-.393.045-.866.056-1.419.01-.553.016-1.087.016-1.602V1.85c0-.181-.041-.362-.124-.543a.865.865 0 00-.314-.39c-.101-.07-.27-.121-.507-.156a8.47 8.47 0 00-.57-.067v-.51L14.793 0zM6.03.134c.134 0 .242.074.292.2l4.698 11.87a.31.31 0 01-.292.424h-1.05a.426.426 0 01-.391-.266l-.883-2.233H2.631l-.875 2.233a.425.425 0 01-.391.266H.315a.31.31 0 01-.292-.425L4.721.333a.298.298 0 01.292-.2zM16.635 5.15c-.372 0-.698.073-.977.219-.279.146-.53.344-.753.594v4.576c.032.127.094.276.187.446.093.17.22.332.379.486.16.149.34.27.542.363.202.093.449.14.741.14.648 0 1.172-.314 1.57-.941.4-.627.598-1.486.598-2.575 0-.393-.042-.795-.127-1.204a3.435 3.435 0 00-.399-1.068 2.23 2.23 0 00-.71-.75c-.292-.19-.642-.286-1.051-.286zM5.52 2.833L3.29 8.463h4.464l-2.232-5.63z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(1.8 5.374)"><path fill="currentColor" d="M0 0h20.588v12.763H0V0z"/></g></svg>',
    fontFaceColored: '<svg width="24" height="24" viewBox="0 0 24 24"><defs><clipPath id="a"><path fill="currentColor" d="M6.03 0c.133 0 .24.075.29.2l4.699 11.87a.31.31 0 01-.292.424h-1.05a.426.426 0 01-.391-.266l-.883-2.232H2.631l-.875 2.232a.425.425 0 01-.391.266H.315a.31.31 0 01-.292-.424L4.721.2a.298.298 0 01.292-.2zM5.52 2.699L3.29 8.329h4.464L5.521 2.7z"/></clipPath><clipPath id="b"><path fill="currentColor" d="M2.886 0l.111.12V5.3l.056.016c.33-.35.69-.614 1.08-.79.39-.174.775-.262 1.152-.262.967 0 1.775.382 2.424 1.148.648.765.972 1.761.972 2.99 0 1.179-.372 2.17-1.116 2.973-.744.802-1.608 1.203-2.59 1.203-.431 0-.855-.066-1.272-.199a5.41 5.41 0 01-1.176-.534l-.59.917-.494-.112c.026-.393.045-.866.056-1.419.01-.553.016-1.087.016-1.602V1.85c0-.181-.042-.362-.124-.543a.865.865 0 00-.315-.39C.976.847.806.796.57.76A8.47 8.47 0 000 .694v-.51L2.886 0zm1.841 5.15c-.372 0-.697.073-.976.219-.28.146-.53.344-.754.594v4.576c.032.127.095.276.188.446.093.17.219.332.378.486.16.149.34.27.542.363.202.093.45.14.742.14.648 0 1.172-.314 1.57-.941.399-.627.598-1.486.598-2.575 0-.393-.042-.795-.128-1.204a3.435 3.435 0 00-.398-1.068 2.23 2.23 0 00-.71-.75c-.292-.19-.643-.286-1.052-.286z"/></clipPath></defs><g clip-path="url(#a)" transform="translate(1.8 5.508)"><path fill="currentColor" opacity="55%" d="M0 0h11.042v12.494H0V0z"/></g><g clip-path="url(#b)" transform="translate(13.707 5.374)"><path fill="currentColor" opacity="85%" d="M0 0h8.681v12.763H0V0z"/></g></svg>',
    fontOpacity: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M7.983 5.084v13.83A8.002 8.002 0 014.001 12a8.002 8.002 0 013.982-6.915"/><path fill="currentColor" d="M11.978 4v16a7.964 7.964 0 01-3.995-1.086V5.084A7.964 7.964 0 0111.978 4" opacity=".75"/><path d="M15.97 5.057v13.885A7.94 7.94 0 0112 19.999h-.022V4h.023c1.445 0 2.8.385 3.97 1.058" fill="#4d4d4d" opacity=".5"/><path fill="currentColor" d="M4 12c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8zm-2 0C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10S2 17.514 2 12z"/></g></svg>',
    fontOpacityAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path d="M14.5 12h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" fill="#ccc" opacity=".75"/><path fill="currentColor" d="M12.5 16h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".6"/><path fill="currentColor" d="M12.5 20h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".25"/><path fill="currentColor" d="M13.5 4h-11a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H7v13.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V6h4.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5"/></g></svg>',
    fontSize: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.377 8.704c.792 0 1.49.103 2.091.308.601.205 1.107.496 1.517.871.41.376.72.824.933 1.343.212.52.318 1.094.318 1.722v6.677a.375.375 0 01-.375.375h-1.25a.375.375 0 01-.375-.375v-1.114c-.37.383-.782.758-1.588 1.14a6.093 6.093 0 01-2.644.574c-.656 0-1.23-.085-1.722-.256a3.482 3.482 0 01-1.23-.707 2.946 2.946 0 01-.738-1.035 3.217 3.217 0 01-.246-1.261c0-1.148.447-2.033 1.342-2.655.895-.621 2.122-.933 3.68-.933h3.13v-.43c0-1.542-1.016-2.434-2.988-2.434-1.451 0-2.584.954-3.027 1.39a.373.373 0 01-.464.049l-1.069-.681a.315.315 0 01-.064-.474 6.322 6.322 0 011.817-1.448c.806-.43 1.79-.646 2.952-.646zM7.042 5c.154 0 .292.094.349.237l5.641 14.25a.375.375 0 01-.348.513h-1.265a.5.5 0 01-.465-.317L9.896 17H2.963l-1.058 2.683A.5.5 0 011.44 20H.175a.375.375 0 01-.348-.513l5.641-14.25A.375.375 0 015.817 5zm15.179 10.106h-3.049c-2.696 0-3.007.991-3.007 1.737 0 .987.762 1.531 2.146 1.531 2.344 0 3.623-1.65 3.91-2.21zM6.43 8.241L3.754 15h5.351z" fill-rule="evenodd"/></svg>',
    fontSizeMinus: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M10.19 5c.2 0 .38.12.46.3l6.05 14c.14.33-.1.7-.46.7h-1.6a.76.76 0 01-.69-.47L12.91 17H6.09l-1.04 2.53c-.11.29-.39.47-.69.47h-1.6c-.36 0-.6-.37-.46-.7l6.05-14c.08-.18.26-.3.46-.3zM9.5 7.7l-2.55 6.85h5.1zm13-2.7c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-7c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    fontSizePlus: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M10.19 5c.2 0 .38.12.46.3l6.05 14c.14.33-.1.7-.46.7h-1.6a.76.76 0 01-.69-.47L12.91 17H6.09l-1.04 2.53c-.11.29-.39.47-.69.47h-1.6c-.36 0-.6-.37-.46-.7l6.05-14c.08-.18.26-.3.46-.3zM9.5 7.7l-2.55 6.85h5.1zm10-5.7c.28 0 .5.22.5.5V5h2.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5H20v2.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5V7h-2.5c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5H18V2.5c0-.28.22-.5.5-.5z" fill-rule="evenodd"/></svg>',
    fontStyleItalic: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18 5.5v-1a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h2.217l-2.486 12H7.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-2.208l2.486-12H17.5a.5.5 0 00.5-.5" fill-rule="evenodd"/></svg>',
    fontStyleUnderline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.5 18a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zM8 4a.5.5 0 01.5.5v5.898c0 1.883 1.444 3.505 3.324 3.598A3.504 3.504 0 0015.5 10.5v-6A.5.5 0 0116 4h1a.5.5 0 01.5.5v6a5.506 5.506 0 01-5.712 5.496c-2.976-.113-5.288-2.653-5.288-5.63V4.5A.5.5 0 017 4z" fill-rule="evenodd"/></svg>',
    fontStyleUnderlineColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M18.5 20h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path fill="currentColor" d="M11.788 15.996C8.812 15.883 6.5 13.343 6.5 10.365V4.5A.5.5 0 017 4h1a.5.5 0 01.5.5v5.898c0 1.883 1.444 3.505 3.324 3.597A3.504 3.504 0 0015.5 10.5v-6A.5.5 0 0116 4h1a.5.5 0 01.5.5v6a5.506 5.506 0 01-5.712 5.496" opacity=".5"/></g></svg>',
    fontVariable: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15 16.123A2.86 2.86 0 0117.683 18H20.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-2.834A2.86 2.86 0 0115 21.835 2.86 2.86 0 0112.334 20L3.5 20a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h8.817A2.86 2.86 0 0115 16.123zm0 1.7c-.637 0-1.155.518-1.155 1.155s.518 1.156 1.155 1.156a1.157 1.157 0 000-2.311zm2.693-14.475c4.137 0 4.299 3.257 4.307 3.782v5.553a.317.317 0 01-.318.317h-1.539a.317.317 0 01-.317-.317V12c-.664.842-2.09 1.444-3.274 1.444-.84 0-3.532-.31-3.532-2.974 0-1.47.849-3.232 4.432-3.232h2.365V7.13c0-1.008-.608-1.769-2.249-1.769-1.207 0-1.931.678-2.298 1.044-.1.1-.258.117-.383.042l-1.296-.819a.258.258 0 01-.05-.392A5.527 5.527 0 0115.077 4a5.834 5.834 0 012.616-.652zm-10.75.33c.658 0 1.242.091 1.741.257s.925.409 1.266.725c.342.308.6.683.775 1.116.175.433.267.908.275 1.433v5.475a.316.316 0 01-.317.316h-1.04a.316.316 0 01-.317-.316v-.915c-.309.317-.65.633-1.325.95-.666.316-1.4.475-2.199.475a4.39 4.39 0 01-1.433-.217 2.933 2.933 0 01-1.024-.592 2.472 2.472 0 01-.616-.866 2.593 2.593 0 01-.209-1.05c0-.949.367-1.61 1.116-2.127.75-.517 1.766-.775 3.066-.775h2.607V7.21c0-1.283-.85-2.024-2.49-2.024-1.208 0-2.158.791-2.524 1.158-.1.1-.259.116-.384.041l-.89-.566a.258.258 0 01-.05-.392A5.34 5.34 0 014.485 4.22c.667-.358 1.491-.542 2.457-.542zM9.317 9h-2.54c-2.25 0-2.507.745-2.507 1.37 0 .824.641 1.274 1.79 1.274 1.95 0 3.016-1.374 3.257-1.84zm10.5.17h-2.29c-1.682 0-2.257.575-2.257 1.2 0 .824 1.13 1.024 1.54 1.024 1.95 0 2.766-1.124 3.007-1.59z" fill-rule="evenodd"/></svg>',
    fontVariableColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M9.317 9.804c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.79-.45-1.79-1.274 0-.625.257-1.37 2.506-1.37h2.541zm1.408-4.027A2.997 2.997 0 009.95 4.66a3.433 3.433 0 00-1.266-.724 5.513 5.513 0 00-1.741-.259c-.966 0-1.79.184-2.457.542A5.34 5.34 0 002.97 5.427a.258.258 0 00.05.391l.891.567a.313.313 0 00.383-.042c.367-.367 1.316-1.158 2.524-1.158 1.641 0 2.49.741 2.49 2.024v.359H6.702c-1.299 0-2.315.258-3.065.774-.75.517-1.116 1.178-1.116 2.128 0 .375.066.724.208 1.05.133.324.342.608.616.866.275.25.617.45 1.025.591a4.39 4.39 0 001.433.217c.8 0 1.532-.158 2.199-.475a4.104 4.104 0 001.324-.95v.915c0 .175.142.316.317.316h1.041a.316.316 0 00.316-.316V7.209c-.008-.525-.1-1-.274-1.432z"/><path fill="currentColor" d="M19.817 9.804c-.242.466-1.058 1.59-3.007 1.59-.41 0-1.54-.2-1.54-1.024 0-.625.574-1.2 2.256-1.2h2.291zm-2.124-6.456c-.966 0-1.95.294-2.617.652a5.527 5.527 0 00-1.535 1.237.258.258 0 00.05.391l1.296.82a.313.313 0 00.383-.042c.366-.367 1.09-1.044 2.298-1.044 1.641 0 2.249.76 2.249 1.768v.108h-2.366c-3.583 0-4.431 1.762-4.431 3.232 0 2.665 2.691 2.974 3.532 2.974 1.183 0 2.61-.602 3.273-1.444v.683c0 .175.142.317.318.317h1.539a.317.317 0 00.317-.317V7.13c-.008-.525-.17-3.782-4.306-3.782zM13 18H3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H13zm7.5 0H17v2h3.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5" opacity=".5"/><path fill="currentColor" d="M15 17.823c-.637 0-1.156.518-1.156 1.155A1.157 1.157 0 1015 17.823m0 4.011a2.859 2.859 0 01-2.855-2.856A2.858 2.858 0 0115 16.123a2.859 2.859 0 012.855 2.855A2.859 2.859 0 0115 21.834"/></g></svg>',
    fontWeight: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M17.693 8.348c4.137 0 4.299 3.257 4.307 3.782v5.553a.317.317 0 01-.318.317h-1.539a.317.317 0 01-.317-.317V17c-.664.842-2.09 1.444-3.274 1.444-.84 0-3.532-.31-3.532-2.974 0-1.47.849-3.232 4.432-3.232h2.365v-.108c0-1.008-.608-1.769-2.249-1.769-1.207 0-1.931.678-2.298 1.044-.1.1-.258.117-.383.042l-1.296-.819a.258.258 0 01-.05-.392A5.527 5.527 0 0115.077 9a5.834 5.834 0 012.616-.652zm-10.75.33c.659 0 1.242.091 1.741.257.5.167.925.409 1.266.725.342.308.6.683.775 1.116.175.434.267.908.275 1.433v5.475a.316.316 0 01-.317.316h-1.04a.316.316 0 01-.317-.316v-.915c-.308.317-.65.633-1.325.95-.666.316-1.4.475-2.199.475a4.386 4.386 0 01-1.432-.217 2.932 2.932 0 01-1.025-.592 2.472 2.472 0 01-.616-.866 2.596 2.596 0 01-.209-1.05c0-.949.367-1.61 1.117-2.127.75-.516 1.765-.775 3.065-.775h2.607v-.358c0-1.283-.85-2.024-2.49-2.024-1.208 0-2.158.791-2.524 1.158-.1.1-.259.116-.384.041l-.89-.566a.258.258 0 01-.05-.392A5.34 5.34 0 014.485 9.22c.667-.358 1.491-.542 2.457-.542zM9.317 14h-2.54c-2.25 0-2.507.745-2.507 1.37 0 .824.641 1.274 1.79 1.274 1.95 0 3.016-1.374 3.257-1.84zm10.5.17h-2.29c-1.682 0-2.257.575-2.257 1.2 0 .824 1.13 1.024 1.54 1.024 1.95 0 2.766-1.124 3.007-1.59z" fill-rule="evenodd"/></svg>',
    fontWeightColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M9.317 14.804c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.79-.45-1.79-1.274 0-.625.257-1.37 2.506-1.37h2.541zm1.408-4.027A2.991 2.991 0 009.95 9.66a3.431 3.431 0 00-1.266-.725 5.512 5.512 0 00-1.741-.258c-.966 0-1.79.183-2.457.541a5.34 5.34 0 00-1.516 1.208.258.258 0 00.05.391l.891.567a.313.313 0 00.383-.042c.367-.367 1.316-1.158 2.524-1.158 1.641 0 2.49.742 2.49 2.024v.359H6.702c-1.299 0-2.315.258-3.065.774-.75.517-1.116 1.178-1.116 2.128 0 .375.067.725.208 1.05.133.324.342.608.616.866.275.25.617.45 1.025.591.408.142.891.217 1.433.217.8 0 1.532-.158 2.199-.475a4.106 4.106 0 001.324-.95v.915c0 .175.142.316.317.316h1.041a.316.316 0 00.316-.316v-5.475c-.008-.525-.1-.999-.274-1.432z"/><path fill="currentColor" d="M19.817 14.804c-.242.466-1.058 1.59-3.007 1.59-.41 0-1.54-.2-1.54-1.024 0-.625.574-1.2 2.256-1.2h2.291zm-2.124-6.456c-.966 0-1.95.294-2.617.652a5.527 5.527 0 00-1.535 1.237.258.258 0 00.05.391l1.296.82a.313.313 0 00.383-.042c.366-.367 1.09-1.044 2.298-1.044 1.641 0 2.249.76 2.249 1.768v.108h-2.366c-3.583 0-4.431 1.762-4.431 3.232 0 2.665 2.691 2.974 3.532 2.974 1.183 0 2.61-.602 3.273-1.444v.683c0 .175.142.317.318.317h1.539a.317.317 0 00.317-.317V12.13c-.008-.525-.17-3.782-4.306-3.782z" opacity=".5"/></g></svg>',
    language: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M15.167 16.67a.076.076 0 01-.03-.01v.01zm1.553-2.566a1.79 1.79 0 00-.496.063 1.062 1.062 0 00-.379.192v-.01a.755.755 0 00-.201.275.892.892 0 00-.074.364c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01a4.54 4.54 0 00-.202-.014 14.544 14.544 0 01-.284-.015c-.905 0-1.357.318-1.357.953 0 .348.111.616.334.806.256.243.606.364 1.052.364.406 0 .75-.138 1.032-.413.125-.11.223-.254.295-.427.072-.174.124-.385.157-.634h1.337c-.033.42-.12.79-.26 1.11a2.52 2.52 0 01-.546.807c-.269.255-.58.449-.934.58a3.4 3.4 0 01-1.19.196c-.38 0-.73-.06-1.051-.177a2.74 2.74 0 01-.865-.511 2.532 2.532 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.334-.417.59-.58-.413-.387-.62-.823-.62-1.308 0-.649.227-1.173.679-1.573.445-.406 1.114-.61 1.887-.61h.64v1.23zM5.837 7.917L6.99 5.012l1.152 2.905zm4.732 2.345l-2.632-6.65a.171.171 0 00-.163-.112h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.163.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.234l.494 1.25c.038.09.122.15.22.15h1.088c.126 0 .21-.126.163-.238zm-2.112 5.76l-.48-.48a.5.5 0 00-.706 0l-.48.48a.5.5 0 000 .707l.48.479a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.916l-.48-.48a.5.5 0 00-.706 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.917l-.48-.48a.5.5 0 00-.707 0l-.479.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.479-.48a.5.5 0 000-.707m2.917-2.917l-.48-.48a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707" fill-rule="evenodd"/></svg>',
    languageAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M15.167 16.67a.076.076 0 01-.029-.01v.01zm1.553-2.566a1.79 1.79 0 00-.496.063 1.062 1.062 0 00-.378.192v-.01a.755.755 0 00-.202.275.892.892 0 00-.074.364c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01a4.54 4.54 0 00-.201-.014 14.544 14.544 0 01-.285-.015c-.904 0-1.357.318-1.357.953 0 .348.112.616.334.806.256.243.607.364 1.052.364.407 0 .75-.138 1.032-.413.125-.11.223-.254.295-.427.072-.174.125-.385.157-.634h1.337c-.032.42-.119.79-.26 1.11a2.52 2.52 0 01-.545.807c-.27.255-.58.449-.935.58a3.4 3.4 0 01-1.189.196c-.38 0-.73-.06-1.052-.177a2.74 2.74 0 01-.865-.511 2.532 2.532 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.335-.417.59-.58-.413-.387-.619-.823-.619-1.308 0-.649.226-1.173.678-1.573.446-.406 1.114-.61 1.887-.61h.64v1.23zM5.838 7.917l1.151-2.905 1.152 2.905zm4.732 2.345l-2.633-6.65a.171.171 0 00-.163-.112h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.164.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.233l.495 1.25c.037.09.121.15.22.15h1.087c.126 0 .21-.126.164-.238z"/><path fill="currentColor" d="M3.75 1.5C2.51 1.5 1.5 2.51 1.5 3.75v12.5c0 1.24 1.01 2.25 2.25 2.25H5.5v1.75c0 1.24 1.01 2.25 2.25 2.25h12.5c1.24 0 2.25-1.01 2.25-2.25V7.75c0-1.24-1.01-2.25-2.25-2.25H18.5V3.75c0-1.24-1.01-2.25-2.25-2.25zM20.25 24H7.75A3.754 3.754 0 014 20.25V20h-.25A3.754 3.754 0 010 16.25V3.75A3.754 3.754 0 013.75 0h12.5A3.754 3.754 0 0120 3.75V4h.25A3.754 3.754 0 0124 7.75v12.5A3.754 3.754 0 0120.25 24z" opacity=".5"/><path fill="currentColor" d="M8.458 16.021l-.48-.479a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.479a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.917-2.916l-.48-.48a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.917l-.479-.48a.5.5 0 00-.707 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.48-.48a.5.5 0 000-.707m2.916-2.917l-.48-.48a.5.5 0 00-.706 0l-.48.48a.5.5 0 000 .707l.48.48a.5.5 0 00.707 0l.479-.48a.5.5 0 000-.707"/></g></svg>',
    languageColored: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M14.995 17.278l1.723-4.58 1.717 4.58zm6.72 4.074l-4.126-11a.5.5 0 00-.468-.324h-.807a.5.5 0 00-.468.324l-4.125 11a.5.5 0 00.468.676h.682a.5.5 0 00.468-.325l.999-2.675h4.75l1.008 2.676a.5.5 0 00.468.324h.682a.5.5 0 00.468-.676z" opacity=".5"/><path fill="currentColor" d="M11.884 15.93l.357-.953a.5.5 0 00-.114-.529l-2.195-2.195c2.125-2.275 2.99-3.842 3.13-6.344h3.676a.5.5 0 00.5-.5v-.75a.5.5 0 00-.5-.5H9.093V2.5a.5.5 0 00-.5-.5h-.75a.5.5 0 00-.5.5v1.66h-4.59a.5.5 0 00-.5.5v.75a.5.5 0 00.5.5h8.56c-.111 1.866-.703 3.048-2.6 5.086C7.728 9.94 7.096 9.114 6.7 8.303a.495.495 0 00-.445-.275H5.44a.501.501 0 00-.46.698c.489 1.148 1.294 2.22 2.513 3.527l-3.746 3.746a.5.5 0 00-.115.529l.358.953a.375.375 0 00.616.134l4.106-4.107 2.556 2.556c.193.193.52.121.616-.134"/></g></svg>',
    languageDirection: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M14.5 7.497h2.258v1.547c0 .222.27.334.427.176L19.405 7a.5.5 0 000-.706l-2.22-2.22a.25.25 0 00-.427.177v1.546H14.5a.5.5 0 00-.5.5v.7a.5.5 0 00.5.5m-5.45 9.006H6.793v-1.547a.25.25 0 00-.426-.176L4.146 17a.5.5 0 000 .706l2.22 2.22a.25.25 0 00.426-.177v-1.546h2.259a.5.5 0 00.5-.5v-.7a.5.5 0 00-.5-.5"/><path fill="currentColor" d="M15.167 16.294a.076.076 0 01-.03-.01v.01zm1.553-2.565a1.79 1.79 0 00-.496.063 1.062 1.062 0 00-.379.192v-.01a.753.753 0 00-.201.275.896.896 0 00-.074.364c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01-.069-.006-.136-.011-.202-.014a10.338 10.338 0 01-.285-.015c-.904 0-1.356.318-1.356.953 0 .348.111.616.334.806.256.243.606.364 1.052.364.406 0 .75-.138 1.032-.413.124-.11.223-.254.295-.427.072-.174.124-.385.157-.634h1.337c-.033.42-.12.79-.26 1.11-.141.321-.323.59-.546.807-.269.255-.58.449-.934.58a3.4 3.4 0 01-1.19.196c-.38 0-.73-.06-1.051-.177a2.74 2.74 0 01-.865-.511 2.532 2.532 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.334-.417.59-.58-.413-.387-.62-.823-.62-1.308 0-.649.227-1.173.679-1.573.445-.406 1.114-.61 1.887-.61h.64v1.23z" opacity=".5"/><path fill="currentColor" d="M5.837 8.417L6.99 5.512l1.152 2.905zm4.732 2.345l-2.632-6.65A.171.171 0 007.774 4h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.163.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.234l.494 1.25c.038.09.122.15.22.15h1.088c.126 0 .21-.126.163-.238z" opacity=".7"/></g></svg>',
    languageDirectionAlt: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M19.5 4h-3.14a.25.25 0 00-.176.427l1.093 1.093L5.52 17.278l-1.094-1.094a.25.25 0 00-.426.177V19.5a.5.5 0 00.5.5h3.139a.25.25 0 00.177-.427L6.722 18.48 18.48 6.723l1.094 1.093A.25.25 0 0020 7.639V4.5a.5.5 0 00-.5-.5"/><path fill="currentColor" d="M15.167 16.294a.076.076 0 01-.03-.01v.01zm1.553-2.565a1.79 1.79 0 00-.496.063 1.063 1.063 0 00-.379.192v-.01a.754.754 0 00-.201.276.89.89 0 00-.074.363c0 .322.115.534.344.64.223.117.705.183 1.445.196v1.248c-.046 0-.103-.003-.172-.01a4.186 4.186 0 00-.202-.014 21.487 21.487 0 01-.284-.015c-.905 0-1.357.318-1.357.953 0 .348.111.616.334.806.256.243.606.364 1.052.364.406 0 .75-.138 1.032-.413a1.16 1.16 0 00.295-.427c.072-.174.124-.385.157-.634h1.337c-.033.42-.12.79-.26 1.11a2.52 2.52 0 01-.546.807c-.269.255-.58.449-.934.58a3.4 3.4 0 01-1.19.196c-.38 0-.73-.06-1.051-.177a2.74 2.74 0 01-.865-.511 2.53 2.53 0 01-.56-.762 2.085 2.085 0 01-.197-.9c0-.438.079-.799.236-1.08.138-.223.334-.417.59-.58-.413-.387-.62-.823-.62-1.308 0-.649.227-1.173.679-1.573.445-.406 1.114-.61 1.887-.61h.64v1.23z" opacity=".5"/><path fill="currentColor" d="M5.837 8.417L6.99 5.512l1.152 2.905zm4.732 2.345l-2.632-6.65A.171.171 0 007.774 4h-1.57a.167.167 0 00-.163.112l-2.632 6.65a.174.174 0 00.163.238H4.66c.098 0 .182-.06.22-.15l.49-1.25h3.234l.494 1.25c.038.09.122.15.22.15h1.088c.126 0 .21-.126.163-.238z" opacity=".7"/></g></svg>',
    textAlignCenter: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path fill="currentColor" d="M7.502 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path fill="currentColor" d="M7.502 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path fill="currentColor" d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    textAlignJustify: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M3.502 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path fill="currentColor" d="M5.5 11h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path fill="currentColor" d="M5.5 19h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path fill="currentColor" d="M3.502 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    textAlignLeft: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M20.5 7h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5"/><path fill="currentColor" d="M16.5 11h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".7"/><path fill="currentColor" d="M16.5 19h-13a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h13a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".3"/><path fill="currentColor" d="M20.5 15h-17a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".5"/></g></svg>',
    textAlignRight: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M3.5 7h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5"/><path fill="currentColor" d="M3.5 11h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".7"/><path fill="currentColor" d="M3.5 19h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".3"/><path fill="currentColor" d="M3.5 15h17a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v1a.5.5 0 00.5.5" opacity=".5"/></g></svg>',
    textCaseCapital: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M3.289 13.837L5.52 8.206l2.232 5.63zm7.73 3.74L6.32 5.707a.305.305 0 00-.292-.2H5.013a.298.298 0 00-.292.2L.023 17.577A.31.31 0 00.315 18h1.05a.426.426 0 00.391-.266l.875-2.232h5.772l.883 2.232a.425.425 0 00.392.266h1.049a.31.31 0 00.292-.424z"/><path fill="currentColor" d="M16.288 13.837l2.233-5.631 2.232 5.63zm7.73 3.74L19.32 5.707a.305.305 0 00-.291-.2h-1.016a.298.298 0 00-.292.2l-4.698 11.87a.31.31 0 00.292.424h1.05a.425.425 0 00.39-.266l.875-2.232h5.773l.883 2.232a.426.426 0 00.391.266h1.05a.31.31 0 00.291-.424z" opacity=".5"/></g></svg>',
    textCaseLower: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M9.393 14.803c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.79-.449-1.79-1.274 0-.624.257-1.37 2.506-1.37h2.541zm1.408-4.027a2.992 2.992 0 00-.775-1.116 3.43 3.43 0 00-1.266-.725 5.505 5.505 0 00-1.741-.258c-.966 0-1.79.183-2.457.541a5.336 5.336 0 00-1.516 1.208.258.258 0 00.05.392l.891.566a.313.313 0 00.383-.042c.367-.366 1.316-1.158 2.524-1.158 1.641 0 2.49.742 2.49 2.025v.358H6.778c-1.299 0-2.315.258-3.065.774-.75.517-1.116 1.179-1.116 2.128 0 .375.066.725.208 1.05.133.325.342.608.616.866.275.25.617.45 1.025.591.408.142.891.217 1.433.217.8 0 1.532-.158 2.199-.475a4.1 4.1 0 001.324-.95v.915c0 .175.142.317.317.317h1.041a.316.316 0 00.316-.317V12.21c-.008-.525-.1-1-.274-1.433z"/><path fill="currentColor" d="M19.873 14.803c-.242.466-1.308 1.84-3.257 1.84-1.15 0-1.791-.449-1.791-1.274 0-.624.258-1.37 2.507-1.37h2.54zm1.407-4.027a2.998 2.998 0 00-.774-1.116 3.43 3.43 0 00-1.266-.725 5.507 5.507 0 00-1.741-.258c-.967 0-1.791.183-2.458.541a5.338 5.338 0 00-1.516 1.208.258.258 0 00.05.392l.892.566a.313.313 0 00.383-.042c.366-.366 1.316-1.158 2.524-1.158 1.64 0 2.49.742 2.49 2.025v.358h-2.607c-1.3 0-2.316.258-3.065.774-.75.517-1.116 1.179-1.116 2.128 0 .375.066.725.208 1.05.133.325.341.608.616.866.275.25.616.45 1.025.591.408.142.89.217 1.432.217.8 0 1.533-.158 2.2-.475a4.106 4.106 0 001.324-.95v.915c0 .175.142.317.316.317h1.042a.316.316 0 00.316-.317V12.21c-.008-.525-.1-1-.275-1.433z" opacity=".5"/></g></svg>',
    textCaseTitle: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill-rule="evenodd"><path fill="currentColor" d="M4.806 13.837l2.232-5.631 2.232 5.63zm7.73 3.74L7.838 5.707a.305.305 0 00-.292-.2H6.53a.298.298 0 00-.292.2L1.54 17.577a.31.31 0 00.292.424h1.05a.425.425 0 00.391-.266l.875-2.232H9.92l.883 2.232a.426.426 0 00.392.266h1.05a.31.31 0 00.29-.424z"/><path fill="currentColor" d="M21.037 14.803c-.241.467-1.307 1.84-3.256 1.84-1.15 0-1.791-.449-1.791-1.273 0-.625.258-1.37 2.507-1.37h2.54zm1.408-4.027a2.992 2.992 0 00-.775-1.116 3.425 3.425 0 00-1.266-.725 5.504 5.504 0 00-1.74-.258c-.967 0-1.791.183-2.458.542a5.334 5.334 0 00-1.516 1.207.258.258 0 00.05.392l.891.566a.313.313 0 00.384-.041c.366-.367 1.316-1.158 2.524-1.158 1.64 0 2.49.741 2.49 2.024v.358h-2.607c-1.3 0-2.316.258-3.065.775-.75.516-1.116 1.178-1.116 2.128 0 .374.066.724.208 1.049.133.325.341.608.616.866.275.25.616.45 1.025.592.408.141.89.216 1.432.216.8 0 1.533-.158 2.2-.474a4.106 4.106 0 001.324-.95v.914c0 .175.142.317.316.317h1.042a.316.316 0 00.316-.317V12.21c-.008-.525-.1-1-.275-1.433z" opacity=".5"/></g></svg>',
    textLetterSpacing: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M4.977 10.65l1.884-4.817 1.86 4.817zm7.188 3.926L7.701 3.21A.321.321 0 007.395 3H6.328a.313.313 0 00-.306.21L1.524 14.576c-.087.21.07.446.306.446h1.102a.447.447 0 00.411-.28l.943-2.343h5.117l.943 2.343c.07.166.228.28.411.28h1.102a.325.325 0 00.306-.446z" opacity=".3"/><path fill="currentColor" d="M21.647 18.647l-2.22-2.22a.25.25 0 00-.427.177v1.546H5v-1.546a.25.25 0 00-.426-.177l-2.22 2.22a.5.5 0 000 .707l2.22 2.22A.25.25 0 005 21.396V19.85h14v1.547c0 .222.27.334.427.176l2.22-2.22a.5.5 0 000-.706"/><path fill="currentColor" d="M11.835 3.446L16.3 14.812c.052.13.166.21.306.21h1.066c.14 0 .263-.08.306-.21l4.498-11.366A.325.325 0 0022.17 3h-1.102a.447.447 0 00-.411.28l-3.518 8.91-3.485-8.91a.447.447 0 00-.411-.28H12.14a.325.325 0 00-.306.446" opacity=".5"/></g></svg>',
    textLetterWidth: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor"><path fill="currentColor" d="M21.646 18.646l-2.22-2.22a.25.25 0 00-.426.177v1.547H5v-1.547a.25.25 0 00-.427-.176l-2.22 2.22a.5.5 0 000 .706l2.22 2.22A.25.25 0 005 21.396V19.85h14v1.546c0 .223.269.335.426.177l2.22-2.22a.5.5 0 000-.707"/><path fill="currentColor" d="M17.5 3h-11a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h4.502v9.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V5H17.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5" opacity=".5"/></g></svg>',
    textLineHeight: '<svg height="24" width="24" viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd"><path fill="currentColor" d="M7.043 17H5.497V7h1.546a.25.25 0 00.177-.427L5 4.353a.5.5 0 00-.707 0l-2.22 2.22A.25.25 0 002.25 7h1.547v10H2.25a.25.25 0 00-.176.427l2.22 2.22a.5.5 0 00.706 0l2.22-2.22A.25.25 0 007.043 17"/><path fill="currentColor" d="M21.5 19h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".7"/><path fill="currentColor" d="M21.5 13h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".5"/><path fill="currentColor" d="M21.5 7h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5" opacity=".3"/></g></svg>',
    typography: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5 4.5v4c0 .28.22.5.5.5H7c.28 0 .5-.22.5-.5v-2h3.25v11H9c-.28 0-.5.22-.5.5v1.5c0 .28.22.5.5.5h6c.28 0 .5-.22.5-.5V18c0-.28-.22-.5-.5-.5h-1.75v-11h3.25v2c0 .28.22.5.5.5h1.5c.28 0 .5-.22.5-.5v-4c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    typographyOutline: '<svg height="24" width="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5 4.5V8c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5V6h4v12H9c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h6c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5h-2V6h4v2c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5V4.5c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5z" fill-rule="evenodd"/></svg>',
    arrowDownCircle: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-down-circle"><circle cx="12" cy="12" r="10"/><path fill="currentColor" d="M8 12l4 4 4-4M12 8v8"/></svg>',
    arrowLeftCircle: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left-circle"><circle cx="12" cy="12" r="10"/><path fill="currentColor" d="M12 8l-4 4 4 4M16 12H8"/></svg>',
    arrowRightCircle: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right-circle"><circle cx="12" cy="12" r="10"/><path fill="currentColor" d="M12 16l4-4-4-4M8 12h8"/></svg>',
    arrowUpCircle: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-up-circle"><circle cx="12" cy="12" r="10"/><path fill="currentColor" d="M16 12l-4-4-4 4M12 16V8"/></svg>',
    checkCircle: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path fill="currentColor" d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path fill="currentColor" d="M22 4L12 14.01l-3-3"/></svg>',
    chevronDown: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><path fill="currentColor" d="M6 9l6 6 6-6"/></svg>',
    chevronLeft: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><path fill="currentColor" d="M15 18l-6-6 6-6"/></svg>',
    chevronRight: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><path fill="currentColor" d="M9 18l6-6-6-6"/></svg>',
    chevronUp: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><path fill="currentColor" d="M18 15l-6-6-6 6"/></svg>',
    eyeOff: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off"><path fill="currentColor" d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"/></svg>',
    eye: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path fill="currentColor" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
    moreHorizontal: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>',
    moreVertical: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>',
    send: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send"><path fill="currentColor" d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>',
    smile: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-smile"><circle cx="12" cy="12" r="10"/><path fill="currentColor" d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></svg>',
    search: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"/><path fill="currentColor" d="M21 21l-4.35-4.35"/></svg>',
    video: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><path fill="currentColor" d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>',
    email: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.57143 4C1.70355 4 1 4.56554 1 5.26316V18.7368C1 19.4345 1.70355 20 2.57143 20H21.4286C22.2964 20 23 19.4345 23 18.7368V5.26316C23 4.56553 22.2964 4 21.4286 4H2.57143ZM3.09524 6.34082V18.3158H20.9048V6.98746L12.876 12.6076C12.3368 12.9851 11.6145 12.9669 11.0949 12.5628L3.09524 6.34082ZM19.279 5.68421H5.50867L12.0314 10.7575L19.279 5.68421Z" fill="currentColor"/></svg>',
    inspect: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" fill-rule="evenodd" d="m12.385 11.077 10 4.166c.85.354.81 1.573-.063 1.87l-2.833.961 2.218 2.219a1 1 0 0 1-1.414 1.414l-2.219-2.218-.961 2.833c-.283.833-1.407.908-1.817.173l-.053-.11-4.166-10c-.343-.825.483-1.651 1.308-1.308ZM17 1a3 3 0 0 1 3 3v7a1 1 0 0 1-2 0V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h7a1 1 0 0 1 0 2H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h13Zm-3.144 12.856 2.215 5.315.628-1.848a1 1 0 0 1 .518-.581l.107-.044 1.847-.627-5.315-2.215Z"/></svg>',
    symbolsFromHere: '<>',
    arrowUpRightRect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M15.5942383,13.2119141 L15.5942383,15.0703125 C15.5942383,15.5751953 15.9057617,15.9082031 16.3891602,15.9082031 C16.8618164,15.9082031 17.1733398,15.5429688 17.1733398,15.0488281 L17.1733398,9.97851562 C17.1733398,9.34472656 16.8295898,9.09765625 16.2817383,9.09765625 L11.1791992,9.09765625 C10.6743164,9.09765625 10.3520508,9.40917969 10.3520508,9.88183594 C10.3520508,10.3544922 10.6850586,10.6660156 11.2006836,10.6660156 L13.1557617,10.6660156 L14.7670898,10.4833984 L13.0698242,12.0517578 L9.11669922,16.015625 C8.96630859,16.1660156 8.85888672,16.3808594 8.85888672,16.5957031 C8.85888672,17.0791016 9.17041016,17.390625 9.64306641,17.390625 C9.91162109,17.390625 10.1049805,17.2939453 10.2553711,17.1435547 L14.2084961,13.1904297 L15.7768555,11.5146484 L15.5942383,13.2119141 Z" transform="translate(-1 -1)"/></svg>',
    arrowUpRightRectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M16.4750977,15.9941406 C15.980957,15.9941406 15.6586914,15.6503906 15.6586914,15.1240234 L15.6586914,13.2226562 L15.8198242,11.4931641 L14.2192383,13.2011719 L10.1694336,17.2617188 C10.0083008,17.4228516 9.79345703,17.5195312 9.52490234,17.5195312 C9.04150391,17.5195312 8.71923828,17.1972656 8.71923828,16.6923828 C8.71923828,16.4775391 8.81591797,16.2519531 8.97705078,16.0908203 L13.0483398,12.0302734 L14.777832,10.4189453 L13.1342773,10.5908203 L11.1362305,10.5908203 C10.5991211,10.5908203 10.2553711,10.2685547 10.2553711,9.78515625 C10.2553711,9.29101562 10.5883789,8.96875 11.1147461,8.96875 L16.3569336,8.96875 C16.9262695,8.96875 17.2915039,9.2265625 17.2915039,9.88183594 L17.2915039,15.1025391 C17.2915039,15.6181641 16.9584961,15.9941406 16.4750977,15.9941406 Z" transform="translate(-1 -1)"/></svg>',
    back: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"><path fill="currentColor" d="M12.4262695,23.0947266 C13.1567383,23.0947266 13.6831055,22.5576172 13.6831055,21.8378906 L13.6831055,17.734375 L13.9946289,17.734375 C18.1625977,17.734375 20.7836914,18.7871094 22.6635742,22.2998047 C23.0395508,22.9873047 23.5336914,23.0947266 23.9848633,23.0947266 C24.5541992,23.0947266 25.0913086,22.5791016 25.0913086,21.6552734 C25.0913086,13.7167969 21.7290039,8.76464844 13.9946289,8.76464844 L13.6831055,8.76464844 L13.6831055,4.70410156 C13.6831055,3.984375 13.1567383,3.39355469 12.4047852,3.39355469 C11.878418,3.39355469 11.5239258,3.61914062 10.9545898,4.15625 L2.47900391,12.0839844 C2.06005859,12.4814453 1.93115234,12.8789062 1.93115234,13.2441406 C1.93115234,13.5986328 2.07080078,14.0068359 2.47900391,14.3935547 L10.9545898,22.3964844 C11.4702148,22.8798828 11.8999023,23.0947266 12.4262695,23.0947266 Z M11.8139648,20.7851562 C11.7495117,20.7851562 11.6850586,20.7529297 11.6313477,20.6884766 L3.97216797,13.4482422 C3.88623047,13.3623047 3.85400391,13.3085938 3.85400391,13.2441406 C3.85400391,13.1796875 3.88623047,13.1152344 3.97216797,13.0400391 L11.6206055,5.703125 C11.6743164,5.66015625 11.7387695,5.6171875 11.8032227,5.6171875 C11.8999023,5.6171875 11.9536133,5.68164062 11.9536133,5.76757812 L11.9536133,10.0322266 C11.9536133,10.2792969 12.0717773,10.3867188 12.3188477,10.3867188 L13.7583008,10.3867188 C21.1274414,10.3867188 23.3510742,15.5 23.565918,20.5703125 C23.565918,20.65625 23.5336914,20.6884766 23.4799805,20.6884766 C23.4370117,20.6884766 23.4155273,20.65625 23.3833008,20.5810547 C22.1157227,17.8847656 18.8608398,16.1123047 13.7583008,16.1123047 L12.3188477,16.1123047 C12.0717773,16.1123047 11.9536133,16.2197266 11.9536133,16.4667969 L11.9536133,20.6240234 C11.9536133,20.7207031 11.8999023,20.7851562 11.8139648,20.7851562 Z" transform="translate(-1 -1)"/></svg>',
    billing: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M12.8691406,19.2167969 C13.0625,19.2167969 13.2236328,19.0556641 13.2236328,18.8623047 L13.2236328,17.9277344 C14.8994141,17.8310547 16.3173828,16.9824219 16.3173828,15.2421875 C16.3173828,13.6308594 15.0175781,13.0078125 13.5566406,12.6640625 L13.2236328,12.5888672 L13.2236328,9.47363281 C14.1044922,9.55957031 14.7167969,10.0107422 14.9746094,10.8164062 C15.0820312,11.1386719 15.2861328,11.2998047 15.5761719,11.2998047 C15.8447266,11.2998047 16.15625,11.1279297 16.15625,10.7519531 C16.15625,9.47363281 14.6523438,8.54980469 13.2236328,8.41015625 L13.2236328,7.49707031 C13.2236328,7.30371094 13.0625,7.14257812 12.8691406,7.14257812 C12.6757812,7.14257812 12.5146484,7.30371094 12.5146484,7.49707031 L12.5146484,8.41015625 C10.9355469,8.5390625 9.59277344,9.484375 9.59277344,11.0205078 C9.59277344,12.6210938 10.9355469,13.2333984 12.2568359,13.5449219 L12.5146484,13.609375 L12.5146484,16.8642578 C11.5800781,16.7890625 10.9355469,16.3916016 10.5917969,15.4785156 C10.4628906,15.15625 10.2802734,15.0166016 9.99023438,15.0166016 C9.67871094,15.0166016 9.42089844,15.2314453 9.42089844,15.5751953 C9.42089844,15.6826172 9.44238281,15.7900391 9.48535156,15.9189453 C9.86132812,17.2080078 11.2148438,17.8310547 12.5146484,17.9277344 L12.5146484,18.8623047 C12.5146484,19.0556641 12.6757812,19.2167969 12.8691406,19.2167969 Z M10.7958984,10.9345703 C10.7958984,10.0429688 11.6337891,9.58105469 12.5146484,9.47363281 L12.5146484,12.4169922 C11.5908203,12.2021484 10.7958984,11.8046875 10.7958984,10.9345703 Z M13.2880859,13.7919922 C14.2441406,14.0175781 15.125,14.3613281 15.125,15.3388672 C15.125,16.4023438 14.2119141,16.7998047 13.2236328,16.875 L13.2236328,13.7705078 L13.2880859,13.7919922 Z" transform="translate(-1 -1)"/></svg>',
    bookmark: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.8984375,24.7490234 C6.42480469,24.7490234 6.73632812,24.4482422 7.703125,23.5136719 L11.9033203,19.3779297 C11.9570312,19.3242188 12.0537109,19.3242188 12.0966797,19.3779297 L16.296875,23.5136719 C17.2636719,24.4482422 17.5751953,24.7490234 18.1015625,24.7490234 C18.8212891,24.7490234 19.2402344,24.2763672 19.2402344,23.4384766 L19.2402344,4.79003906 C19.2402344,2.74902344 18.2197266,1.70703125 16.2001953,1.70703125 L7.79980469,1.70703125 C5.78027344,1.70703125 4.75976562,2.74902344 4.75976562,4.79003906 L4.75976562,23.4384766 C4.75976562,24.2763672 5.17871094,24.7490234 5.8984375,24.7490234 Z M6.77929688,21.8486328 C6.62890625,21.9990234 6.45703125,21.9560547 6.45703125,21.7412109 L6.45703125,4.81152344 C6.45703125,3.88769531 6.94042969,3.40429688 7.88574219,3.40429688 L16.125,3.40429688 C17.0595703,3.40429688 17.5429688,3.88769531 17.5429688,4.81152344 L17.5429688,21.7412109 C17.5429688,21.9560547 17.3818359,21.9990234 17.2207031,21.8486328 L12.5693359,17.3369141 C12.2255859,17.0039062 11.7744141,17.0039062 11.4306641,17.3369141 L6.77929688,21.8486328 Z" transform="translate(0 -1)"/></svg>',
    chat: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M15,22.9121094 C22.21875,22.9121094 27.4931641,18.5078125 27.4931641,12.4492188 C27.4931641,6.36914062 22.2080078,1.99707031 15,1.99707031 C7.78125,1.99707031 2.50683594,6.36914062 2.50683594,12.4492188 C2.50683594,14.4580078 3.09765625,16.3271484 4.12890625,17.8417969 C4.63378906,18.59375 4.81640625,19.1201172 4.81640625,19.5605469 C4.81640625,20.1298828 4.64453125,20.5917969 4.15039062,21.0214844 C3.30175781,21.7412109 3.7421875,22.9121094 4.859375,22.9121094 C6.20214844,22.9121094 7.6953125,22.4501953 8.80175781,21.6875 C10.6171875,22.4824219 12.7333984,22.9121094 15,22.9121094 Z M15,21.1826172 C12.9482422,21.1826172 11.1113281,20.7958984 9.55371094,20.0976562 C8.86621094,19.796875 8.37207031,19.8828125 7.71679688,20.2695312 C7.25488281,20.5595703 6.71777344,20.8066406 6.16992188,20.9248047 C6.39550781,20.5488281 6.54589844,20.1191406 6.54589844,19.5605469 C6.54589844,18.765625 6.25585938,17.8955078 5.56835938,16.8642578 C4.70898438,15.6181641 4.23632812,14.1035156 4.23632812,12.4492188 C4.23632812,7.41113281 8.68359375,3.7265625 15,3.7265625 C21.3164062,3.7265625 25.7636719,7.41113281 25.7636719,12.4492188 C25.7636719,17.4873047 21.3164062,21.1826172 15,21.1826172 Z M9.98339844,13.9960938 C10.8427734,13.9960938 11.5410156,13.2978516 11.5410156,12.4384766 C11.5410156,11.5791016 10.8320312,10.8808594 9.98339844,10.8808594 C9.12402344,10.8808594 8.42578125,11.5791016 8.42578125,12.4384766 C8.42578125,13.2978516 9.12402344,13.9960938 9.98339844,13.9960938 Z M15,13.9960938 C15.8486328,13.9960938 16.546875,13.2978516 16.546875,12.4384766 C16.546875,11.5791016 15.8486328,10.8808594 15,10.8808594 C14.140625,10.8808594 13.4423828,11.5791016 13.4423828,12.4384766 C13.4423828,13.2978516 14.140625,13.9960938 15,13.9960938 Z M20.0058594,13.9960938 C20.8652344,13.9960938 21.5634766,13.2978516 21.5634766,12.4384766 C21.5634766,11.5791016 20.8652344,10.8808594 20.0058594,10.8808594 C19.1464844,10.8808594 18.4482422,11.5791016 18.4482422,12.4384766 C18.4482422,13.2978516 19.1464844,13.9960938 20.0058594,13.9960938 Z" transform="translate(-2 -1)"/></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9.74951172,22.7294922 C10.2114258,22.7294922 10.5766602,22.5253906 10.8344727,22.1279297 L20.9858398,6.14355469 C21.1791992,5.83203125 21.2543945,5.59570312 21.2543945,5.34863281 C21.2543945,4.7578125 20.8676758,4.37109375 20.2768555,4.37109375 C19.847168,4.37109375 19.6108398,4.51074219 19.3530273,4.91894531 L9.70654297,20.2910156 L4.70068359,13.7382812 C4.43212891,13.3623047 4.16357422,13.2119141 3.77685547,13.2119141 C3.16455078,13.2119141 2.74560547,13.6308594 2.74560547,14.2216797 C2.74560547,14.46875 2.85302734,14.7480469 3.05712891,15.0058594 L8.63232422,22.1064453 C8.95458984,22.5253906 9.28759766,22.7294922 9.74951172,22.7294922 Z" transform="translate(0 -1)"/></svg>',
    checkOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M11.8183594,18.3466797 C12.1728516,18.3466797 12.4736328,18.1748047 12.6884766,17.8417969 L17.5976562,10.1181641 C17.7158203,9.90332031 17.8554688,9.66699219 17.8554688,9.43066406 C17.8554688,8.94726562 17.4257812,8.63574219 16.9746094,8.63574219 C16.7060547,8.63574219 16.4375,8.80761719 16.2333984,9.11914062 L11.7753906,16.2734375 L9.65917969,13.5341797 C9.40136719,13.1904297 9.16503906,13.1044922 8.86425781,13.1044922 C8.40234375,13.1044922 8.03710938,13.4804688 8.03710938,13.953125 C8.03710938,14.1894531 8.13378906,14.4150391 8.28417969,14.6191406 L10.9052734,17.8417969 C11.1738281,18.1962891 11.4638672,18.3466797 11.8183594,18.3466797 Z" transform="translate(-1 -1)"/></svg>',
    checkOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.28125 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.96289062,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.28125 6.96289062,24.2011719 13,24.2011719 Z M11.796875,18.4970703 C11.4316406,18.4970703 11.1308594,18.3466797 10.8515625,17.9707031 L8.15527344,14.6621094 C7.99414062,14.4472656 7.89746094,14.2109375 7.89746094,13.9638672 C7.89746094,13.4804688 8.2734375,13.0830078 8.75683594,13.0830078 C9.06835938,13.0830078 9.3046875,13.1796875 9.57324219,13.5341797 L11.7539062,16.3486328 L16.3408203,8.97949219 C16.5449219,8.65722656 16.8242188,8.48535156 17.1035156,8.48535156 C17.5761719,8.48535156 18.0166016,8.80761719 18.0166016,9.3125 C18.0166016,9.54882812 17.8769531,9.79589844 17.7480469,10.0214844 L12.6992188,17.9707031 C12.4736328,18.3251953 12.1621094,18.4970703 11.796875,18.4970703 Z" transform="translate(-1 -1)"/></svg>',
    forward: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"><path fill="currentColor" d="M15.5737305,23.0947266 C16.1000977,23.0947266 16.5297852,22.8798828 17.0454102,22.3964844 L25.5209961,14.3935547 C25.9291992,14.0068359 26.0688477,13.5986328 26.0688477,13.2441406 C26.0688477,12.8789062 25.9399414,12.4814453 25.5209961,12.0839844 L17.0454102,4.15625 C16.4760742,3.61914062 16.121582,3.39355469 15.5952148,3.39355469 C14.8432617,3.39355469 14.3061523,3.984375 14.3061523,4.70410156 L14.3061523,8.76464844 L13.9946289,8.76464844 C6.27099609,8.76464844 2.90869141,13.7167969 2.90869141,21.6552734 C2.90869141,22.5791016 3.43505859,23.0947266 4.01513672,23.0947266 C4.46630859,23.0947266 4.96044922,22.9873047 5.33642578,22.2998047 C7.20556641,18.7871094 9.83740234,17.734375 13.9946289,17.734375 L14.3061523,17.734375 L14.3061523,21.8378906 C14.3061523,22.5576172 14.8432617,23.0947266 15.5737305,23.0947266 Z M16.1860352,20.7851562 C16.1000977,20.7851562 16.0356445,20.7207031 16.0356445,20.6240234 L16.0356445,16.4667969 C16.0356445,16.2197266 15.9282227,16.1123047 15.6811523,16.1123047 L14.2416992,16.1123047 C9.13916016,16.1123047 5.88427734,17.8847656 4.61669922,20.5810547 C4.58447266,20.65625 4.56298828,20.6884766 4.50927734,20.6884766 C4.46630859,20.6884766 4.43408203,20.65625 4.43408203,20.5703125 C4.64892578,15.5 6.86181641,10.3867188 14.2416992,10.3867188 L15.6811523,10.3867188 C15.9282227,10.3867188 16.0356445,10.2792969 16.0356445,10.0322266 L16.0356445,5.76757812 C16.0356445,5.68164062 16.1000977,5.6171875 16.1967773,5.6171875 C16.2612305,5.6171875 16.3256836,5.66015625 16.3793945,5.703125 L24.027832,13.0400391 C24.1030273,13.1152344 24.1352539,13.1796875 24.1352539,13.2441406 C24.1352539,13.3085938 24.1137695,13.3623047 24.027832,13.4482422 L16.3686523,20.6884766 C16.3149414,20.7529297 16.2504883,20.7851562 16.1860352,20.7851562 Z" transform="translate(-2 -1)"/></svg>',
    minimize: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22.5454102,12.2128906 C23.1147461,12.2128906 23.5551758,11.7939453 23.5551758,11.2246094 C23.5444336,10.6445312 23.1147461,10.2470703 22.5454102,10.2470703 L21.6430664,10.2470703 L17.8833008,10.4619141 L20.8588867,7.63671875 L24.1782227,4.328125 C24.371582,4.13476562 24.4682617,3.86621094 24.4682617,3.58691406 C24.4682617,2.98535156 24.0170898,2.57714844 23.4155273,2.57714844 C23.1469727,2.57714844 22.9106445,2.67382812 22.7280273,2.8671875 L19.4301758,6.19726562 L16.5942383,9.17285156 L16.809082,5.42382812 L16.809082,4.52148438 C16.809082,3.95214844 16.4008789,3.52246094 15.8422852,3.52246094 C15.262207,3.52246094 14.8432617,3.96289062 14.8432617,4.52148438 L14.8432617,10.4726562 C14.8432617,11.5683594 15.4770508,12.2128906 16.5727539,12.2128906 L22.5454102,12.2128906 Z M12.2329102,23.1162109 C12.8129883,23.1162109 13.2319336,22.6865234 13.2319336,22.1171875 L13.2319336,16.0478516 C13.2319336,14.9521484 12.5981445,14.3183594 11.5024414,14.3183594 L5.41162109,14.3183594 C4.84228516,14.3183594 4.40185547,14.7265625 4.40185547,15.3066406 C4.41259766,15.8759766 4.84228516,16.2734375 5.41162109,16.2734375 L6.43212891,16.2734375 L10.1918945,16.0585938 L7.21630859,18.8837891 L3.83251953,22.2675781 C3.63916016,22.4609375 3.53173828,22.7294922 3.53173828,23.0087891 C3.53173828,23.6103516 3.98291016,24.0185547 4.59521484,24.0185547 C4.85302734,24.0185547 5.10009766,23.921875 5.28271484,23.7285156 L8.64501953,20.3339844 L11.480957,17.3583984 L11.2661133,21.0966797 L11.2661133,22.1171875 C11.2661133,22.6972656 11.6743164,23.1162109 12.2329102,23.1162109 Z" transform="translate(-2 -1)"/></svg>',
    expand: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M22.2382812,11.6865234 C22.8183594,11.6865234 23.2373047,11.2460938 23.2373047,10.6875 L23.2373047,4.72558594 C23.2373047,3.62988281 22.5927734,2.99609375 21.4970703,2.99609375 L15.5351562,2.99609375 C14.9658203,2.99609375 14.5253906,3.40429688 14.5253906,3.984375 C14.5253906,4.56445312 14.9658203,4.96191406 15.5351562,4.96191406 L16.4375,4.96191406 L20.1972656,4.74707031 L17.2109375,7.57226562 L13.9023438,10.8808594 C13.7089844,11.0742188 13.6015625,11.3320312 13.6015625,11.6220703 C13.6015625,12.2236328 14.0634766,12.6210938 14.6650391,12.6210938 C14.9228516,12.6210938 15.1699219,12.5351562 15.3525391,12.3417969 L18.6503906,9.01171875 L21.4863281,6.03613281 L21.2607422,9.78515625 L21.2607422,10.6875 C21.2607422,11.2568359 21.6796875,11.6865234 22.2382812,11.6865234 Z M10.4541016,23.4921875 C11.0341797,23.4921875 11.4638672,23.0839844 11.4638672,22.5039062 C11.4638672,21.9238281 11.0234375,21.5263672 10.4541016,21.5263672 L9.5625,21.5263672 L5.80273438,21.7412109 L8.77832031,18.9160156 L12.0976562,15.6074219 C12.2910156,15.4140625 12.3876953,15.15625 12.3876953,14.8662109 C12.3876953,14.2646484 11.9365234,13.8671875 11.3242188,13.8671875 C11.0664062,13.8671875 10.8300781,13.953125 10.6474609,14.1464844 L7.33886719,17.4765625 L4.51367188,20.4521484 L4.72851562,16.703125 L4.72851562,15.8007812 C4.72851562,15.2314453 4.3203125,14.8017578 3.75097656,14.8017578 C3.18164062,14.8017578 2.76269531,15.2421875 2.76269531,15.8007812 L2.76269531,21.7626953 C2.76269531,22.8583984 3.39648438,23.4921875 4.4921875,23.4921875 L10.4541016,23.4921875 Z" transform="translate(-1 -1)"/></svg>',
    globe: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.7402344 C7.7578125,22.7402344 3.50390625,18.4863281 3.50390625,13.2441406 C3.50390625,9.55957031 5.609375,6.35839844 8.67089844,4.79003906 C8.63867188,4.91894531 8.6171875,5.05859375 8.6171875,5.1875 C8.6171875,6.59472656 7.46777344,6.91699219 7.46777344,7.765625 C7.46777344,8.30273438 7.84375,8.65722656 8.42382812,8.65722656 C9.66992188,8.65722656 9.65917969,7.30371094 10.2929688,7.30371094 C10.765625,7.31445312 11.2060547,8.0234375 11.9902344,8.0234375 C12.3447266,8.0234375 12.5166016,7.79785156 12.5380859,7.47558594 C12.5595703,7.3359375 12.6240234,7.27148438 12.7529297,7.27148438 C13.4404297,7.27148438 14.203125,8.04492188 14.203125,8.51757812 C14.203125,8.96875 14.03125,9.3125 13.7519531,9.3125 C13.2685547,9.3125 12.0654297,8.74316406 10.9912109,8.74316406 C8.58496094,8.74316406 6.57617188,10.4511719 6.57617188,12.4921875 C6.57617188,14.2646484 7.61816406,15.2958984 9.44433594,15.2958984 C10.5507812,15.2958984 11.3671875,16.0478516 11.3671875,17.0683594 C11.3671875,18.6582031 11.1953125,21.3974609 13.4511719,21.3974609 C15.4277344,21.3974609 17.1142578,18.3359375 17.5546875,17.6054688 C18.1025391,16.7246094 17.8447266,15.84375 17.8447266,15.2958984 C17.8447266,14.9091797 18.9833984,14.0927734 18.9833984,13.1582031 C18.9833984,12.2128906 16.78125,11.4609375 16.78125,10.9238281 C16.78125,10.5800781 17.0390625,10.2792969 17.3183594,10.2792969 C17.7910156,10.2792969 18.9511719,11.7724609 19.6064453,11.7724609 C20.0361328,11.7724609 20.0683594,11.3964844 20.3046875,11.3964844 C20.8203125,11.3964844 20.9277344,14.1035156 22.3242188,15.0488281 C21.4863281,19.4316406 17.6298828,22.7402344 13,22.7402344 Z M16.1582031,6.76660156 C15.7607422,6.76660156 15.5996094,6.97070312 15.2558594,6.97070312 C14.9228516,6.97070312 14.6757812,6.734375 14.6757812,6.40136719 C14.6757812,5.88574219 15.1914062,5.59570312 16.0722656,5.59570312 C16.8242188,5.59570312 17.3935547,5.98242188 17.3935547,6.48730469 C17.3935547,6.76660156 17.2109375,6.9921875 16.9746094,6.9921875 C16.5878906,6.9921875 16.3837891,6.76660156 16.1582031,6.76660156 Z" transform="translate(-1 -1)"/></svg>',
    helpcenter: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.96582031,21.3974609 C2.96582031,23.6425781 4.07226562,24.7597656 6.29589844,24.7597656 L17.7041016,24.7597656 C19.9277344,24.7597656 21.0341797,23.6425781 21.0341797,21.3974609 L21.0341797,5.1015625 C21.0341797,2.8671875 19.9277344,1.72851562 17.7041016,1.72851562 L6.29589844,1.72851562 C4.07226562,1.72851562 2.96582031,2.8671875 2.96582031,5.1015625 L2.96582031,21.3974609 Z M11.7529297,11.3427734 C11.2910156,11.3427734 11.0224609,11.0957031 11.0224609,10.6230469 L11.0224609,10.5048828 C11.0224609,9.63476562 11.4951172,9.16210938 12.1181641,8.72167969 C12.8701172,8.20605469 13.2138672,7.92675781 13.2138672,7.37890625 C13.2138672,6.74511719 12.7412109,6.32617188 11.9570312,6.32617188 C11.3769531,6.32617188 10.9472656,6.61621094 10.6679688,7.12109375 L10.5175781,7.31445312 C10.3564453,7.54003906 10.1738281,7.6796875 9.8515625,7.6796875 C9.55078125,7.6796875 9.21777344,7.45410156 9.21777344,7.04589844 C9.21777344,6.91699219 9.22851562,6.79882812 9.26074219,6.68066406 C9.49707031,5.703125 10.7431641,5.06933594 12.0214844,5.06933594 C13.4931641,5.06933594 14.7929688,5.86425781 14.7929688,7.31445312 C14.7929688,8.35644531 14.1806641,8.89355469 13.3427734,9.44140625 C12.7519531,9.83886719 12.4941406,10.1181641 12.4941406,10.5693359 L12.4941406,10.6875 C12.4941406,11.0527344 12.2041016,11.3427734 11.7529297,11.3427734 Z M11.7421875,13.8994141 C11.2050781,13.8994141 10.7539062,13.4697266 10.7539062,12.9648438 C10.7539062,12.4384766 11.1943359,12.0087891 11.7421875,12.0087891 C12.2685547,12.0087891 12.7089844,12.4277344 12.7089844,12.9648438 C12.7089844,13.4804688 12.2470703,13.8994141 11.7421875,13.8994141 Z M7.90722656,16.6816406 C7.52050781,16.6816406 7.23046875,16.3808594 7.23046875,16.0048828 C7.23046875,15.6396484 7.52050781,15.3603516 7.90722656,15.3603516 L16.1142578,15.3603516 C16.5009766,15.3603516 16.7802734,15.6396484 16.7802734,16.0048828 C16.7802734,16.3808594 16.5009766,16.6816406 16.1142578,16.6816406 L7.90722656,16.6816406 Z M7.90722656,19.9042969 C7.52050781,19.9042969 7.23046875,19.625 7.23046875,19.2597656 C7.23046875,18.8837891 7.52050781,18.5830078 7.90722656,18.5830078 L11.7851562,18.5830078 C12.171875,18.5830078 12.4511719,18.8837891 12.4511719,19.2597656 C12.4511719,19.625 12.171875,19.9042969 11.7851562,19.9042969 L7.90722656,19.9042969 Z" transform="translate(0 -1)"/></svg>',
    learn: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28"><path fill="currentColor" d="M7.58544922,17.8525391 C7.58544922,19.3671875 8.48779297,20.7744141 10.1098633,21.8271484 L10.1098633,23.2880859 C9.58349609,23.4707031 9.26123047,23.9433594 9.26123047,24.5878906 L9.26123047,27.4130859 C9.26123047,28.2617188 9.80908203,28.8095703 10.6577148,28.8095703 L10.9477539,28.8095703 C11.7963867,28.8095703 12.3442383,28.2617188 12.3442383,27.4130859 L12.3442383,24.5878906 C12.3442383,23.9433594 12.0219727,23.4814453 11.5063477,23.2880859 L11.5063477,22.5791016 C13.2143555,23.3310547 15.4165039,23.7822266 17.9946289,23.7822266 C24.3325195,23.7822266 28.4145508,21.0644531 28.4145508,17.8525391 L28.4145508,12.8037109 L31.5512695,11.3642578 C32.2495117,11.0419922 32.6040039,10.4189453 32.6040039,9.77441406 C32.6040039,9.140625 32.2495117,8.51757812 31.5512695,8.1953125 L20.9702148,3.36132812 C19.831543,2.84570312 18.918457,2.609375 17.9946289,2.62011719 C17.081543,2.609375 16.168457,2.84570312 15.019043,3.36132812 L4.44873047,8.1953125 C3.75048828,8.51757812 3.39599609,9.140625 3.39599609,9.77441406 C3.39599609,10.4189453 3.75048828,11.0419922 4.44873047,11.3642578 L7.58544922,12.8037109 L7.58544922,17.8525391 Z M17.9946289,15.2421875 C17.2856445,15.2421875 16.5874023,15.0595703 15.6743164,14.640625 L12.6235352,13.2441406 L17.0922852,10.8808594 C17.3930664,10.9560547 17.715332,10.9990234 18.0375977,10.9990234 C19.1977539,10.9990234 20.3149414,10.4726562 20.3149414,9.77441406 C20.3149414,9.09765625 19.1977539,8.58203125 18.0375977,8.58203125 C16.8881836,8.58203125 15.7495117,9.09765625 15.7495117,9.77441406 C15.7495117,9.89257812 15.7817383,10 15.8461914,10.1074219 L11.1303711,12.5673828 L5.78076172,10.1396484 C5.58740234,10.0537109 5.50146484,9.92480469 5.50146484,9.77441406 C5.50146484,9.63476562 5.58740234,9.50585938 5.78076172,9.41992188 L15.6743164,4.91894531 C16.5874023,4.5 17.2856445,4.31738281 17.9946289,4.31738281 C18.7143555,4.31738281 19.4018555,4.5 20.3256836,4.91894531 L30.2192383,9.41992188 C30.4018555,9.50585938 30.4985352,9.63476562 30.4985352,9.77441406 C30.4985352,9.92480469 30.4018555,10.0537109 30.2192383,10.1396484 L20.3256836,14.640625 C19.4018555,15.0595703 18.7143555,15.2421875 17.9946289,15.2421875 Z M9.31494141,17.8525391 L9.31494141,13.5878906 L10.1098633,13.953125 L10.1098633,19.6894531 C9.59423828,19.1201172 9.31494141,18.4863281 9.31494141,17.8525391 Z M17.9946289,16.9394531 C18.918457,16.9501953 19.831543,16.7138672 20.9702148,16.1982422 L26.6850586,13.5878906 L26.6850586,17.8525391 C26.6850586,20.0976562 23.2905273,22.1601562 17.9946289,22.1601562 C15.2553711,22.1601562 13.0209961,21.6015625 11.5063477,20.7529297 L11.5063477,14.5869141 L15.019043,16.1982422 C16.168457,16.7138672 17.081543,16.9501953 17.9946289,16.9394531 Z" transform="translate(-3 -1)"/></svg>',
    learnFill: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 30 28"><path fill="currentColor" d="M31.3901367,8.3671875 L20.8735352,3.5546875 C19.777832,3.06054688 18.8862305,2.82421875 17.9946289,2.84570312 C17.1137695,2.82421875 16.222168,3.06054688 15.1157227,3.5546875 L4.60986328,8.3671875 C3.92236328,8.67871094 3.58935547,9.2265625 3.58935547,9.77441406 C3.58935547,10.3222656 3.92236328,10.859375 4.60986328,11.1816406 L9.03564453,13.2011719 L15.8354492,10.0107422 C15.7709961,9.93554688 15.7495117,9.84960938 15.7495117,9.77441406 C15.7495117,9.09765625 16.8881836,8.58203125 18.0375977,8.58203125 C19.1977539,8.58203125 20.3149414,9.09765625 20.3149414,9.77441406 C20.3149414,10.4726562 19.1977539,10.9990234 18.0375977,10.9990234 C17.6831055,10.9990234 17.3286133,10.9453125 17.0170898,10.859375 L10.5288086,13.8994141 L15.1157227,16.0048828 C16.222168,16.5097656 17.1137695,16.7246094 17.9946289,16.7138672 C18.8862305,16.7246094 19.777832,16.5097656 20.8735352,16.0048828 L31.3901367,11.1816406 C32.0776367,10.859375 32.4106445,10.3222656 32.4106445,9.77441406 C32.4106445,9.2265625 32.0776367,8.67871094 31.3901367,8.3671875 Z M10.4858398,15.4892578 L10.4858398,22.0205078 C12.2905273,23.1162109 14.8686523,23.7822266 17.9946289,23.7822266 C24.3325195,23.7822266 28.4145508,21.0644531 28.4145508,17.8525391 L28.4145508,14.1572266 L21.4858398,17.3261719 C20.2290039,17.90625 19.090332,18.1962891 17.9946289,18.1855469 C16.909668,18.1962891 15.7602539,17.90625 14.503418,17.3261719 L10.4858398,15.4892578 Z M7.58544922,14.1572266 L7.58544922,17.8525391 C7.58544922,18.7871094 8.12255859,19.9472656 9.08935547,20.9355469 L9.08935547,14.8554688 L7.58544922,14.1572266 Z M8.24072266,24.5878906 L8.24072266,27.4130859 C8.24072266,28.2617188 8.78857422,28.8095703 9.63720703,28.8095703 L9.92724609,28.8095703 C10.7758789,28.8095703 11.3237305,28.2617188 11.3237305,27.4130859 L11.3237305,24.5878906 C11.3237305,23.9433594 11.0014648,23.4814453 10.4858398,23.2880859 L10.4858398,22.0205078 C9.94873047,21.6982422 9.47607422,21.3330078 9.08935547,20.9355469 L9.08935547,23.2880859 C8.56298828,23.4707031 8.24072266,23.9433594 8.24072266,24.5878906 Z" transform="translate(-3 -1)"/></svg>',
    network: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M10.0029297,11.1708984 C9.95996094,10.7519531 9.77734375,10.3759766 9.48730469,10.1074219 C10.4326172,7.71191406 11.9365234,5.54199219 13.9023438,3.79101562 C14.0527344,3.80175781 14.203125,3.82324219 14.3535156,3.84472656 C12.9462891,6.21875 12.0976562,8.8828125 11.8935547,11.6435547 C11.2490234,11.5361328 10.6152344,11.375 10.0029297,11.1708984 Z M5.02929688,8.07714844 C6.56542969,5.72460938 9.10058594,4.09179688 12.0332031,3.79101562 C10.4003906,5.49902344 9.1328125,7.48632812 8.2734375,9.64550781 C7.97265625,9.64550781 7.65039062,9.75292969 7.37109375,9.93554688 C6.53320312,9.41992188 5.73828125,8.78613281 5.02929688,8.07714844 Z M15.0087891,8.21679688 C15.0195312,9.19433594 15.1376953,10.1611328 15.3632812,11.0957031 C15.1699219,11.2890625 15.0302734,11.5361328 14.9550781,11.8046875 C14.6865234,11.8261719 14.4179688,11.8369141 14.1386719,11.8369141 C13.8164062,11.8369141 13.4941406,11.8261719 13.1826172,11.8046875 C13.3652344,9.17285156 14.1708984,6.65917969 15.5136719,4.43554688 C15.1591797,5.64941406 14.9980469,6.91699219 15.0087891,8.21679688 Z M16.3085938,8.20605469 C16.2978516,6.95996094 16.4697266,5.72460938 16.8349609,4.55371094 C18.9619141,5.49902344 20.6806641,7.19628906 21.6474609,9.3125 C20.5087891,10.171875 19.2304688,10.8271484 17.8769531,11.2568359 C17.5869141,10.859375 17.1142578,10.6015625 16.5771484,10.5908203 C16.4160156,9.81738281 16.3193359,9.02246094 16.3085938,8.20605469 Z M3.50390625,13.2441406 C3.50390625,11.8261719 3.81542969,10.4833984 4.36328125,9.28027344 C5.07226562,9.94628906 5.84570312,10.5371094 6.67285156,11.0419922 C6.65136719,11.1279297 6.65136719,11.2246094 6.65136719,11.3212891 C6.65136719,11.890625 6.93066406,12.3955078 7.37109375,12.7070312 C7.14550781,13.8242188 7.02734375,14.984375 7.02734375,16.1552734 C5.79199219,15.5537109 4.61035156,14.7910156 3.52539062,13.8779297 C3.51464844,13.6630859 3.50390625,13.4589844 3.50390625,13.2441406 Z M22.4960938,13.2441406 C22.4960938,14.1679688 22.3671875,15.0703125 22.1201172,15.9082031 C21.4863281,16.2519531 20.8310547,16.5419922 20.1650391,16.7890625 C19.1337891,15.8544922 18.2744141,14.7373047 17.6298828,13.5019531 C17.9199219,13.2548828 18.1132812,12.9111328 18.1884766,12.5244141 C19.5849609,12.0947266 20.9169922,11.4394531 22.1201172,10.5908203 C22.3671875,11.4287109 22.4960938,12.3203125 22.4960938,13.2441406 Z M11.8398438,13.0185547 C11.8398438,14.4150391 12.0009766,15.7900391 12.3125,17.1328125 C12.1298828,17.2724609 11.9794922,17.4550781 11.8720703,17.6591797 C10.6689453,17.4765625 9.4765625,17.1650391 8.32714844,16.7246094 C8.29492188,15.4462891 8.39160156,14.1894531 8.63867188,12.9755859 C9.02539062,12.9003906 9.35839844,12.6962891 9.60546875,12.40625 C10.3251953,12.6533203 11.0771484,12.8359375 11.8398438,12.9541016 C11.8398438,12.9755859 11.8398438,12.9970703 11.8398438,13.0185547 Z M14.1386719,13.1367188 C14.4824219,13.1367188 14.8154297,13.1259766 15.1376953,13.09375 C15.3955078,13.5234375 15.8466797,13.8242188 16.3730469,13.8886719 C16.9853516,15.1240234 17.8017578,16.2626953 18.7792969,17.2402344 C17.5117188,17.5947266 16.2226562,17.7880859 14.9228516,17.8310547 C14.6972656,17.2617188 14.1816406,16.8535156 13.5585938,16.7783203 C13.2900391,15.5859375 13.1396484,14.3505859 13.1396484,13.1044922 C13.4726562,13.1259766 13.8056641,13.1367188 14.1386719,13.1367188 Z M3.84765625,15.7792969 C4.86816406,16.5097656 5.94238281,17.1113281 7.0703125,17.6054688 C7.11328125,18.765625 7.29589844,19.9150391 7.59667969,21.0537109 C5.79199219,19.796875 4.44921875,17.9492188 3.84765625,15.7792969 Z M13,22.7402344 C11.6679688,22.7402344 10.4111328,22.4609375 9.26171875,21.9775391 C8.79980469,20.7314453 8.50976562,19.4423828 8.40234375,18.1318359 C9.49804688,18.5078125 10.6152344,18.7871094 11.7646484,18.9482422 C11.96875,19.6035156 12.5703125,20.0761719 13.2900391,20.1083984 C13.6552734,20.9677734 14.0957031,21.8056641 14.6005859,22.6005859 C14.0742188,22.6972656 13.5478516,22.7402344 13,22.7402344 Z M14.5146484,19.6572266 C14.6650391,19.5068359 14.7939453,19.3242188 14.8798828,19.1308594 C16.5771484,19.0771484 18.2744141,18.7978516 19.9072266,18.2607422 C20.1542969,18.4648438 20.4121094,18.6474609 20.6806641,18.8300781 C19.5097656,20.4306641 17.8554688,21.6552734 15.9326172,22.2783203 C15.3847656,21.4404297 14.9013672,20.5703125 14.5146484,19.6572266 Z" transform="translate(-1 -1)"/></svg>',
    playOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M10.9912109,17.4443359 L17.1035156,13.8242188 C17.5546875,13.5664062 17.5439453,12.9433594 17.1035156,12.6748047 L10.9912109,9.0546875 C10.5292969,8.78613281 9.91699219,8.99023438 9.91699219,9.51660156 L9.91699219,16.9824219 C9.91699219,17.4980469 10.4863281,17.7451172 10.9912109,17.4443359 Z" transform="translate(-1 -1)"/></svg>',
    playOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.28125 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.96289062,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.28125 6.96289062,24.2011719 13,24.2011719 Z M10.9589844,17.5732422 C10.4433594,17.8847656 9.85253906,17.6376953 9.85253906,17.1005859 L9.85253906,9.3984375 C9.85253906,8.87207031 10.4863281,8.64648438 10.9589844,8.92578125 L17.2646484,12.6640625 C17.7158203,12.9326172 17.7265625,13.5771484 17.2646484,13.8564453 L10.9589844,17.5732422 Z" transform="translate(-1 -1)"/></svg>',
    stop: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8 5.75h8A2.25 2.25 0 0 1 18.25 8v8a2.25 2.25 0 0 1-2.25 2.25H8A2.25 2.25 0 0 1 5.75 16V8A2.25 2.25 0 0 1 8 5.75z"/></svg>',
    plusOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M8.80859375,14.125 L11.9667969,14.125 L11.9667969,17.2939453 C11.9667969,17.8310547 12.3320312,18.2070312 12.8583984,18.2070312 C13.3955078,18.2070312 13.7714844,17.8417969 13.7714844,17.2939453 L13.7714844,14.125 L16.9404297,14.125 C17.4775391,14.125 17.8535156,13.7705078 17.8535156,13.2441406 C17.8535156,12.7070312 17.4775391,12.3310547 16.9404297,12.3310547 L13.7714844,12.3310547 L13.7714844,9.17285156 C13.7714844,8.625 13.3955078,8.24902344 12.8583984,8.24902344 C12.3320312,8.24902344 11.9667969,8.625 11.9667969,9.17285156 L11.9667969,12.3310547 L8.80859375,12.3310547 C8.26074219,12.3310547 7.89550781,12.7070312 7.89550781,13.2441406 C7.89550781,13.7705078 8.26074219,14.125 8.80859375,14.125 Z" transform="translate(-1 -1)"/></svg>',
    plusOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.28125 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.28125 6.84277344,24.2011719 12.8798828,24.2011719 Z M12.8691406,18.3681641 C12.3212891,18.3681641 11.9453125,17.9707031 11.9453125,17.4228516 L11.9453125,14.1572266 L8.69042969,14.1572266 C8.13183594,14.1572266 7.74511719,13.7919922 7.74511719,13.2441406 C7.74511719,12.6855469 8.13183594,12.2988281 8.69042969,12.2988281 L11.9453125,12.2988281 L11.9453125,9.04394531 C11.9453125,8.48535156 12.3212891,8.08789062 12.8691406,8.08789062 C13.4277344,8.08789062 13.8144531,8.48535156 13.8144531,9.04394531 L13.8144531,12.2988281 L17.0800781,12.2988281 C17.6279297,12.2988281 18.0253906,12.6855469 18.0253906,13.2441406 C18.0253906,13.7919922 17.6279297,14.1572266 17.0800781,14.1572266 L13.8144531,14.1572266 L13.8144531,17.4228516 C13.8144531,17.9814453 13.4277344,18.3681641 12.8691406,18.3681641 Z" transform="translate(-1 -1)"/></svg>',
    plusRectDotted: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.59863281,9.58105469 C4.16796875,9.58105469 4.46875,9.25878906 4.46875,8.70019531 L4.46875,6.16503906 C4.46875,5.04785156 5.05957031,4.47851562 6.13378906,4.47851562 L8.73339844,4.47851562 C9.30273438,4.47851562 9.61425781,4.16699219 9.61425781,3.60839844 C9.61425781,3.04980469 9.30273438,2.74902344 8.73339844,2.74902344 L6.11230469,2.74902344 C3.8671875,2.74902344 2.73925781,3.85546875 2.73925781,6.06835938 L2.73925781,8.70019531 C2.73925781,9.25878906 3.05078125,9.58105469 3.59863281,9.58105469 Z M22.9023438,9.58105469 C23.4716797,9.58105469 23.7724609,9.25878906 23.7724609,8.70019531 L23.7724609,6.06835938 C23.7724609,3.85546875 22.6445312,2.74902344 20.3994141,2.74902344 L17.7675781,2.74902344 C17.2089844,2.74902344 16.8974609,3.04980469 16.8974609,3.60839844 C16.8974609,4.16699219 17.2089844,4.47851562 17.7675781,4.47851562 L20.3671875,4.47851562 C21.4306641,4.47851562 22.0429688,5.04785156 22.0429688,6.16503906 L22.0429688,8.70019531 C22.0429688,9.25878906 22.3544922,9.58105469 22.9023438,9.58105469 Z M9.20605469,14.125 L12.3642578,14.125 L12.3642578,17.2939453 C12.3642578,17.8310547 12.71875,18.2070312 13.2451172,18.2070312 C13.7929688,18.2070312 14.1582031,17.8417969 14.1582031,17.2939453 L14.1582031,14.125 L17.3271484,14.125 C17.8642578,14.125 18.2402344,13.7705078 18.2402344,13.2441406 C18.2402344,12.7070312 17.875,12.3310547 17.3271484,12.3310547 L14.1582031,12.3310547 L14.1582031,9.17285156 C14.1582031,8.625 13.7929688,8.24902344 13.2451172,8.24902344 C12.71875,8.24902344 12.3642578,8.625 12.3642578,9.17285156 L12.3642578,12.3310547 L9.20605469,12.3310547 C8.64746094,12.3310547 8.28222656,12.7070312 8.28222656,13.2441406 C8.28222656,13.7705078 8.65820312,14.125 9.20605469,14.125 Z M6.11230469,23.7714844 L8.73339844,23.7714844 C9.30273438,23.7714844 9.61425781,23.4599609 9.61425781,22.9121094 C9.61425781,22.3535156 9.30273438,22.0419922 8.73339844,22.0419922 L6.13378906,22.0419922 C5.05957031,22.0419922 4.46875,21.4726562 4.46875,20.3554688 L4.46875,17.8203125 C4.46875,17.2509766 4.15722656,16.9394531 3.59863281,16.9394531 C3.04003906,16.9394531 2.73925781,17.2509766 2.73925781,17.8203125 L2.73925781,20.4414062 C2.73925781,22.6650391 3.8671875,23.7714844 6.11230469,23.7714844 Z M17.7675781,23.7714844 L20.3994141,23.7714844 C22.6445312,23.7714844 23.7724609,22.6542969 23.7724609,20.4414062 L23.7724609,17.8203125 C23.7724609,17.2509766 23.4609375,16.9394531 22.9023438,16.9394531 C22.34375,16.9394531 22.0429688,17.2509766 22.0429688,17.8203125 L22.0429688,20.3554688 C22.0429688,21.4726562 21.4306641,22.0419922 20.3671875,22.0419922 L17.7675781,22.0419922 C17.2089844,22.0419922 16.8974609,22.3535156 16.8974609,22.9121094 C16.8974609,23.4599609 17.2089844,23.7714844 17.7675781,23.7714844 Z" transform="translate(-1 -1)"/></svg>',
    redo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13.8164062,22.3212891 C13.8164062,21.7949219 13.4296875,21.3652344 12.8388672,21.3652344 L10.3681641,21.3652344 C6.70507812,21.3652344 4.76074219,19.2167969 4.76074219,16.3164062 C4.76074219,13.4267578 6.70507812,11.4072266 10.3681641,11.4072266 L17.7373047,11.4072266 L20.2724609,11.2890625 L18.2207031,13.0400391 L15.1269531,16.0585938 C14.9550781,16.2304688 14.8691406,16.4345703 14.8691406,16.7138672 C14.8691406,17.2724609 15.2451172,17.6591797 15.8144531,17.6591797 C16.0507812,17.6591797 16.3300781,17.5517578 16.5126953,17.3583984 L22.8291016,11.1601562 C23.0439453,10.9560547 23.1513672,10.7089844 23.1513672,10.4511719 C23.1513672,10.1826172 23.0439453,9.93554688 22.8291016,9.73144531 L16.5126953,3.53320312 C16.3300781,3.33984375 16.0507812,3.23242188 15.8144531,3.23242188 C15.2451172,3.23242188 14.8691406,3.61914062 14.8691406,4.17773438 C14.8691406,4.45703125 14.9550781,4.66113281 15.1269531,4.83300781 L18.2207031,7.8515625 L20.2724609,9.60253906 L17.7373047,9.484375 L10.5292969,9.484375 C5.62011719,9.484375 2.84863281,12.3203125 2.84863281,16.4238281 C2.84863281,20.5380859 5.54492188,23.2773438 10.3574219,23.2773438 L12.8388672,23.2773438 C13.4296875,23.2773438 13.8164062,22.8476562 13.8164062,22.3212891 Z" transform="translate(-1 -1)"/></svg>',
    searchOvalDotted: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.9999758,2.0367002 C12.553625,2.0367002 13.0121806,1.57599041 13.0121806,1.01707072 C13.0121806,0.460719499 12.553625,1.66533454e-16 11.9999758,1.66533454e-16 C11.4437536,1.66533454e-16 10.9877952,0.460719499 10.9877952,1.01707072 C10.9877952,1.57599041 11.4437536,2.0367002 11.9999758,2.0367002 Z M15.3767138,2.59378822 C15.9303388,2.59378822 16.3888945,2.13306629 16.3888945,1.57415752 C16.3888945,1.01780023 15.9303388,0.557080735 15.3767138,0.557080735 C14.8204313,0.557080735 14.3645332,1.01780023 14.3645332,1.57415752 C14.3645332,2.13306629 14.8204313,2.59378822 15.3767138,2.59378822 Z M18.4472005,4.14658231 C19.0008255,4.14658231 19.4593811,3.68587252 19.4593811,3.12695161 C19.4593811,2.57060403 19.0008255,2.10988211 18.4472005,2.10988211 C17.8909179,2.10988211 17.4199199,2.57060403 17.4199199,3.12695161 C17.4199199,3.68587252 17.8909179,4.14658231 18.4472005,4.14658231 Z M20.8605368,6.58154066 C21.4141618,6.58154066 21.8851598,6.12339205 21.8851598,5.56447115 C21.8851598,5.00812357 21.4141618,4.53483848 20.8605368,4.53483848 C20.3042542,4.53483848 19.8456985,5.00812357 19.8456985,5.56447115 C19.8456985,6.12339205 20.3042542,6.58154066 20.8605368,6.58154066 Z M22.4058064,9.61151926 C22.9595522,9.61151926 23.4179871,9.15335852 23.4179871,8.59444975 C23.4179871,8.03810217 22.9595522,7.57738025 22.4058064,7.57738025 C21.8496446,7.57738025 21.391089,8.03810217 21.391089,8.59444975 C21.391089,9.15335852 21.8496446,9.61151926 22.4058064,9.61151926 Z M22.9852826,13.0171302 C23.5414444,13.0171302 24,12.5589088 24,12 C24,11.4410912 23.5414444,10.9829305 22.9852826,10.9829305 C22.4315368,10.9829305 21.9731019,11.4410912 21.9731019,12 C21.9731019,12.5589088 22.4315368,13.0171302 22.9852826,13.0171302 Z M22.4058064,16.4226562 C22.9595522,16.4226562 23.4179871,15.9644347 23.4179871,15.4055867 C23.4179871,14.8466172 22.9595522,14.3885172 22.4058064,14.3885172 C21.8496446,14.3885172 21.391089,14.8466172 21.391089,15.4055867 C21.391089,15.9644347 21.8496446,16.4226562 22.4058064,16.4226562 Z M20.8605368,19.4651251 C21.4141618,19.4651251 21.8851598,19.004476 21.8851598,18.4480556 C21.8851598,17.8892075 21.4141618,17.4184836 20.8605368,17.4184836 C20.3042542,17.4184836 19.8456985,17.8892075 19.8456985,18.4480556 C19.8456985,19.004476 20.3042542,19.4651251 20.8605368,19.4651251 Z M18.4472005,21.8901179 C19.0008255,21.8901179 19.4593811,21.4293474 19.4593811,20.8730484 C19.4593811,20.3140789 19.0008255,19.8534298 18.4472005,19.8534298 C17.8909179,19.8534298 17.4199199,20.3140789 17.4199199,20.8730484 C17.4199199,21.4293474 17.8909179,21.8901179 18.4472005,21.8901179 Z M15.3767138,23.4429727 C15.9303388,23.4429727 16.3888945,22.9822022 16.3888945,22.4259032 C16.3888945,21.8669337 15.9303388,21.4061632 15.3767138,21.4061632 C14.8204313,21.4061632 14.3645332,21.8669337 14.3645332,22.4259032 C14.3645332,22.9822022 14.8204313,23.4429727 15.3767138,23.4429727 Z M11.9999758,24 C12.553625,24 13.0121806,23.5392295 13.0121806,22.9829305 C13.0121806,22.423961 12.553625,21.9633119 11.9999758,21.9633119 C11.4437536,21.9633119 10.9877952,22.423961 10.9877952,22.9829305 C10.9877952,23.5392295 11.4437536,24 11.9999758,24 Z M8.62329823,23.4429727 C9.17953251,23.4429727 9.64799372,22.9822022 9.64799372,22.4259032 C9.64799372,21.8669337 9.17953251,21.4061632 8.62329823,21.4061632 C8.06707604,21.4061632 7.6111176,21.8669337 7.6111176,22.4259032 C7.6111176,22.9822022 8.06707604,23.4429727 8.62329823,23.4429727 Z M5.56527814,21.8901179 C6.12151241,21.8901179 6.57747086,21.4293474 6.57747086,20.8730484 C6.57747086,20.3140789 6.12151241,19.8534298 5.56527814,19.8534298 C5.00905595,19.8534298 4.55309751,20.3140789 4.55309751,20.8730484 C4.55309751,21.4293474 5.00905595,21.8901179 5.56527814,21.8901179 Z M3.13947533,19.4651251 C3.6957096,19.4651251 4.15166804,19.004476 4.15166804,18.4480556 C4.15166804,17.8892075 3.6957096,17.4184836 3.13947533,17.4184836 C2.58580201,17.4184836 2.12729469,17.8892075 2.12729469,18.4480556 C2.12729469,19.004476 2.58580201,19.4651251 3.13947533,19.4651251 Z M1.59414524,16.4226562 C2.15036743,16.4226562 2.60632588,15.9644347 2.60632588,15.4055867 C2.60632588,14.8466172 2.15036743,14.3885172 1.59414524,14.3885172 C1.04046468,14.3885172 0.581959774,14.8466172 0.581959774,15.4055867 C0.581959774,15.9644347 1.04046468,16.4226562 1.59414524,16.4226562 Z M1.01218184,13.0171302 C1.56841491,13.0171302 2.02691015,12.5589088 2.02691015,12 C2.02691015,11.4410912 1.56841491,10.9829305 1.01218184,10.9829305 C0.458504902,10.9829305 -1.38777878e-17,11.4410912 -1.38777878e-17,12 C-1.38777878e-17,12.5589088 0.458504902,13.0171302 1.01218184,13.0171302 Z M1.59414524,9.61151926 C2.15036743,9.61151926 2.60632588,9.15335852 2.60632588,8.59444975 C2.60632588,8.03810217 2.15036743,7.57738025 1.59414524,7.57738025 C1.04046468,7.57738025 0.581959774,8.03810217 0.581959774,8.59444975 C0.581959774,9.15335852 1.04046468,9.61151926 1.59414524,9.61151926 Z M3.13947533,6.58154066 C3.6957096,6.58154066 4.15166804,6.12339205 4.15166804,5.56447115 C4.15166804,5.00812357 3.6957096,4.53483848 3.13947533,4.53483848 C2.58580201,4.53483848 2.12729469,5.00812357 2.12729469,5.56447115 C2.12729469,6.12339205 2.58580201,6.58154066 3.13947533,6.58154066 Z M5.56527814,4.14658231 C6.12151241,4.14658231 6.57747086,3.68587252 6.57747086,3.12695161 C6.57747086,2.57060403 6.12151241,2.10988211 5.56527814,2.10988211 C5.00905595,2.10988211 4.55309751,2.57060403 4.55309751,3.12695161 C4.55309751,3.68587252 5.00905595,4.14658231 5.56527814,4.14658231 Z M8.62329823,2.59378822 C9.17953251,2.59378822 9.64799372,2.13306629 9.64799372,1.57415752 C9.64799372,1.01780023 9.17953251,0.557080735 8.62329823,0.557080735 C8.06707604,0.557080735 7.6111176,1.01780023 7.6111176,1.57415752 C7.6111176,2.13306629 8.06707604,2.59378822 8.62329823,2.59378822 Z M6,10.9807531 C6,13.7316153 8.24974062,15.9578651 11.0244672,15.9578651 C11.9569867,15.9578651 12.820778,15.6985021 13.5586207,15.2506549 L15.9948358,17.670365 C16.2232769,17.8931963 16.5271304,18 16.8386966,18 C17.5045546,18 18,17.4951099 18,16.8400878 C18,16.5341195 17.8878607,16.243565 17.6688461,16.0178208 L15.2533205,13.618986 C15.7550094,12.8625004 16.0444171,11.9577883 16.0444171,10.9807531 C16.0444171,8.23035207 13.7988143,6 11.0244672,6 C8.24974062,6 6,8.23035207 6,10.9807531 Z M7.60168291,10.9807531 C7.60168291,9.10769573 9.13469882,7.5878794 11.0244672,7.5878794 C12.91284,7.5878794 14.4467986,9.10769573 14.4467986,10.9807531 C14.4467986,12.8501209 12.91284,14.3740152 11.0244672,14.3740152 C9.13469882,14.3740152 7.60168291,12.8501209 7.60168291,10.9807531 Z"/></svg>',
    sfArrowDownSquare: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M13.0161133,18.6582031 C13.2416992,18.6582031 13.4243164,18.59375 13.6391602,18.3789062 L17.184082,14.9628906 C17.3452148,14.8017578 17.4311523,14.6298828 17.4311523,14.3935547 C17.4311523,13.953125 17.0981445,13.6416016 16.6469727,13.6416016 C16.4428711,13.6416016 16.2172852,13.7275391 16.0668945,13.8994141 L14.434082,15.6396484 L13.8217773,16.2949219 L13.8754883,14.6943359 L13.8754883,8.65722656 C13.8754883,8.20605469 13.4780273,7.83007812 13.0161133,7.83007812 C12.5541992,7.83007812 12.1674805,8.20605469 12.1674805,8.65722656 L12.1674805,14.6943359 L12.2211914,16.2949219 L11.5981445,15.6396484 L9.96533203,13.8994141 C9.81494141,13.7275391 9.57861328,13.6416016 9.37451172,13.6416016 C8.92333984,13.6416016 8.60107422,13.953125 8.60107422,14.3935547 C8.60107422,14.6298828 8.68701172,14.8017578 8.85888672,14.9628906 L12.3930664,18.3789062 C12.6079102,18.59375 12.8012695,18.6582031 13.0161133,18.6582031 Z" transform="translate(-1 -1)"/></svg>',
    sfArrowUpRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.36230469,20.8818359 C3.75976562,21.2685547 4.30761719,21.2900391 4.71582031,20.8818359 L15.6191406,9.98925781 L17.1875,8.30273438 L16.9833984,13.2548828 L16.9833984,17.21875 C16.9833984,17.734375 17.4345703,18.1962891 17.9609375,18.1962891 C18.4765625,18.1962891 18.9384766,17.7666016 18.9384766,17.1757812 L18.9277344,6.37988281 C18.9277344,5.75683594 18.5195312,5.33789062 17.8857422,5.33789062 L7.07910156,5.33789062 C6.47753906,5.33789062 6.06933594,5.7890625 6.06933594,6.3046875 C6.06933594,6.8203125 6.53125,7.26074219 7.03613281,7.26074219 L10.7744141,7.26074219 L15.8984375,7.09960938 L14.2548828,8.625 L3.36230469,19.5283203 C2.95410156,19.9365234 2.96484375,20.484375 3.36230469,20.8818359 Z" transform="translate(1 -1)"/></svg>',
    sfAssets: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="currentColor" d="M7.22705078,2.72753906 L20.7836914,2.72753906 C20.7192383,1.81445312 20.2036133,1.34179688 19.2045898,1.34179688 L8.79541016,1.34179688 C7.80712891,1.34179688 7.29150391,1.81445312 7.22705078,2.72753906 Z M5.01416016,5.703125 L22.996582,5.703125 C22.8354492,4.72558594 22.3735352,4.18847656 21.2993164,4.18847656 L6.71142578,4.18847656 C5.63720703,4.18847656 5.17529297,4.72558594 5.01416016,5.703125 Z M6.12060547,25.125 L21.8793945,25.125 C24.1137695,25.125 25.2524414,24.0078125 25.2524414,21.7949219 L25.2524414,10.7626953 C25.2524414,8.54980469 24.1137695,7.43261719 21.8793945,7.43261719 L6.12060547,7.43261719 C3.86474609,7.43261719 2.74755859,8.54980469 2.74755859,10.7626953 L2.74755859,21.7949219 C2.74755859,24.0078125 3.86474609,25.125 6.12060547,25.125 Z M4.47705078,10.859375 C4.47705078,9.7421875 5.06787109,9.16210938 6.14208984,9.16210938 L21.847168,9.16210938 C22.9106445,9.16210938 23.5229492,9.7421875 23.5229492,10.859375 L23.5229492,19.7861328 L19.4731445,15.9619141 C19.0219727,15.5429688 18.4633789,15.3388672 17.9047852,15.3388672 C17.3354492,15.3388672 16.8305664,15.5214844 16.347168,15.9511719 L11.6743164,20.0761719 L9.80517578,18.4111328 C9.36474609,18.0136719 8.90283203,17.8095703 8.40869141,17.8095703 C7.94677734,17.8095703 7.51708984,18.0244141 7.07666016,18.4003906 L4.47705078,20.65625 L4.47705078,10.859375 Z M10.8364258,16.2197266 C12.1899414,16.2197266 13.2963867,15.0917969 13.2963867,13.7490234 C13.2963867,12.40625 12.1899414,11.2998047 10.8364258,11.2998047 C9.48291016,11.2998047 8.38720703,12.40625 8.38720703,13.7490234 C8.38720703,15.0917969 9.48291016,16.2197266 10.8364258,16.2197266 Z" transform="translate(-2 -1)"/></svg>',
    sfComment: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M23.8837891,9.01171875 C25.9140625,9.01171875 27.6113281,7.3359375 27.6113281,5.29492188 C27.6113281,3.24316406 25.9140625,1.56738281 23.8837891,1.56738281 C21.8427734,1.56738281 20.15625,3.24316406 20.15625,5.29492188 C20.15625,7.3359375 21.8427734,9.01171875 23.8837891,9.01171875 Z M15,22.9121094 C22.21875,22.9121094 27.4931641,18.5078125 27.4931641,12.4492188 C27.4931641,11.375 27.3212891,10.3544922 27.0097656,9.40917969 C26.5478516,9.76367188 26.0214844,10.0214844 25.4306641,10.1933594 C25.6455078,10.9023438 25.7636719,11.6542969 25.7636719,12.4492188 C25.7636719,17.4873047 21.3164062,21.1826172 15,21.1826172 C12.9482422,21.1826172 11.1113281,20.7958984 9.55371094,20.0976562 C8.86621094,19.796875 8.37207031,19.8828125 7.71679688,20.2695312 C7.25488281,20.5595703 6.71777344,20.8066406 6.16992188,20.9248047 C6.39550781,20.5488281 6.54589844,20.1191406 6.54589844,19.5605469 C6.54589844,18.765625 6.25585938,17.8955078 5.56835938,16.8642578 C4.70898438,15.6181641 4.23632812,14.1035156 4.23632812,12.4492188 C4.23632812,7.41113281 8.68359375,3.7265625 15,3.7265625 C16.375,3.7265625 17.6640625,3.90917969 18.8349609,4.23144531 C18.9423828,3.65136719 19.1572266,3.10351562 19.4472656,2.609375 C18.0830078,2.20117188 16.5791016,1.99707031 15,1.99707031 C7.78125,1.99707031 2.50683594,6.36914062 2.50683594,12.4492188 C2.50683594,14.4580078 3.09765625,16.3271484 4.12890625,17.8417969 C4.63378906,18.59375 4.81640625,19.1201172 4.81640625,19.5605469 C4.81640625,20.1298828 4.64453125,20.5917969 4.15039062,21.0214844 C3.30175781,21.7412109 3.7421875,22.9121094 4.859375,22.9121094 C6.20214844,22.9121094 7.6953125,22.4501953 8.80175781,21.6875 C10.6171875,22.4824219 12.7333984,22.9121094 15,22.9121094 Z" transform="translate(-2 -1)"/></svg>',
    sfCommentFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M24.2275391,9.01171875 C26.2578125,9.01171875 27.9550781,7.3359375 27.9550781,5.29492188 C27.9550781,3.24316406 26.2578125,1.56738281 24.2275391,1.56738281 C22.1865234,1.56738281 20.5,3.24316406 20.5,5.29492188 C20.5,7.3359375 22.1865234,9.01171875 24.2275391,9.01171875 Z M15,22.7294922 C22.2080078,22.7294922 27.4287109,18.3789062 27.4287109,12.3955078 C27.4287109,11.4179688 27.2890625,10.4941406 27.03125,9.62402344 C26.2148438,10.1611328 25.2373047,10.4833984 24.1953125,10.4833984 C21.3486328,10.4833984 19.0068359,8.14160156 19.0068359,5.29492188 C19.0068359,4.36035156 19.2539062,3.49023438 19.6835938,2.73828125 C18.265625,2.28710938 16.6865234,2.06152344 15,2.06152344 C7.80273438,2.06152344 2.58203125,6.40136719 2.58203125,12.3955078 C2.58203125,16.703125 4.9453125,17.8632812 4.9453125,19.7861328 C4.9453125,20.6240234 4.67675781,21.171875 4.03222656,21.7734375 C3.54882812,22.203125 3.80664062,22.7294922 4.515625,22.7294922 C5.99804688,22.7294922 7.51269531,22.2460938 8.61914062,21.4404297 C10.4775391,22.2890625 12.6367188,22.7294922 15,22.7294922 Z" transform="translate(-2 -1)"/></svg>',
    sfComponents: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.32568359,9.00097656 L7.69970703,9.00097656 C8.87060547,9.00097656 9.55810547,8.31347656 9.55810547,7.09960938 L9.55810547,4.81152344 C9.55810547,3.59765625 8.87060547,2.91015625 7.69970703,2.91015625 L5.32568359,2.91015625 C4.15478516,2.91015625 3.46728516,3.59765625 3.46728516,4.81152344 L3.46728516,7.09960938 C3.46728516,8.31347656 4.15478516,9.00097656 5.32568359,9.00097656 Z M12.8022461,9.00097656 L15.1870117,9.00097656 C16.3579102,9.00097656 17.034668,8.31347656 17.034668,7.09960938 L17.034668,4.81152344 C17.034668,3.59765625 16.3579102,2.91015625 15.1870117,2.91015625 L12.8022461,2.91015625 C11.6313477,2.91015625 10.9545898,3.59765625 10.9545898,4.81152344 L10.9545898,7.09960938 C10.9545898,8.31347656 11.6313477,9.00097656 12.8022461,9.00097656 Z M20.300293,9.00097656 L22.6743164,9.00097656 C23.8452148,9.00097656 24.5327148,8.31347656 24.5327148,7.09960938 L24.5327148,4.81152344 C24.5327148,3.59765625 23.8452148,2.91015625 22.6743164,2.91015625 L20.300293,2.91015625 C19.1293945,2.91015625 18.4418945,3.59765625 18.4418945,4.81152344 L18.4418945,7.09960938 C18.4418945,8.31347656 19.1293945,9.00097656 20.300293,9.00097656 Z M13.0063477,7.52929688 C12.6196289,7.52929688 12.4262695,7.32519531 12.4262695,6.91699219 L12.4262695,4.99414062 C12.4262695,4.59667969 12.6196289,4.39257812 13.0063477,4.39257812 L14.9829102,4.39257812 C15.3588867,4.39257812 15.5629883,4.59667969 15.5629883,4.99414062 L15.5629883,6.91699219 C15.5629883,7.32519531 15.3588867,7.52929688 14.9829102,7.52929688 L13.0063477,7.52929688 Z M20.5043945,7.52929688 C20.1176758,7.52929688 19.9135742,7.32519531 19.9135742,6.91699219 L19.9135742,4.99414062 C19.9135742,4.59667969 20.1176758,4.39257812 20.5043945,4.39257812 L22.4702148,4.39257812 C22.8461914,4.39257812 23.050293,4.59667969 23.050293,4.99414062 L23.050293,6.91699219 C23.050293,7.32519531 22.8461914,7.52929688 22.4702148,7.52929688 L20.5043945,7.52929688 Z M5.32568359,16.2734375 L7.69970703,16.2734375 C8.87060547,16.2734375 9.55810547,15.5966797 9.55810547,14.3828125 L9.55810547,12.0839844 C9.55810547,10.8701172 8.87060547,10.1826172 7.69970703,10.1826172 L5.32568359,10.1826172 C4.15478516,10.1826172 3.46728516,10.8701172 3.46728516,12.0839844 L3.46728516,14.3828125 C3.46728516,15.5966797 4.15478516,16.2734375 5.32568359,16.2734375 Z M12.8022461,16.2734375 L15.1870117,16.2734375 C16.3579102,16.2734375 17.034668,15.5966797 17.034668,14.3828125 L17.034668,12.0839844 C17.034668,10.8701172 16.3579102,10.1826172 15.1870117,10.1826172 L12.8022461,10.1826172 C11.6313477,10.1826172 10.9545898,10.8701172 10.9545898,12.0839844 L10.9545898,14.3828125 C10.9545898,15.5966797 11.6313477,16.2734375 12.8022461,16.2734375 Z M20.300293,16.2734375 L22.6743164,16.2734375 C23.8452148,16.2734375 24.5327148,15.5966797 24.5327148,14.3828125 L24.5327148,12.0839844 C24.5327148,10.8701172 23.8452148,10.1826172 22.6743164,10.1826172 L20.300293,10.1826172 C19.1293945,10.1826172 18.4418945,10.8701172 18.4418945,12.0839844 L18.4418945,14.3828125 C18.4418945,15.5966797 19.1293945,16.2734375 20.300293,16.2734375 Z M5.52978516,14.8017578 C5.14306641,14.8017578 4.94970703,14.5976562 4.94970703,14.1894531 L4.94970703,12.2558594 C4.94970703,11.8583984 5.14306641,11.6542969 5.52978516,11.6542969 L7.49560547,11.6542969 C7.87158203,11.6542969 8.08642578,11.8583984 8.08642578,12.2558594 L8.08642578,14.1894531 C8.08642578,14.5976562 7.87158203,14.8017578 7.49560547,14.8017578 L5.52978516,14.8017578 Z M13.0063477,14.8017578 C12.6196289,14.8017578 12.4262695,14.5976562 12.4262695,14.1894531 L12.4262695,12.2558594 C12.4262695,11.8583984 12.6196289,11.6542969 13.0063477,11.6542969 L14.9829102,11.6542969 C15.3588867,11.6542969 15.5629883,11.8583984 15.5629883,12.2558594 L15.5629883,14.1894531 C15.5629883,14.5976562 15.3588867,14.8017578 14.9829102,14.8017578 L13.0063477,14.8017578 Z M20.5043945,14.8017578 C20.1176758,14.8017578 19.9135742,14.5976562 19.9135742,14.1894531 L19.9135742,12.2558594 C19.9135742,11.8583984 20.1176758,11.6542969 20.5043945,11.6542969 L22.4702148,11.6542969 C22.8461914,11.6542969 23.050293,11.8583984 23.050293,12.2558594 L23.050293,14.1894531 C23.050293,14.5976562 22.8461914,14.8017578 22.4702148,14.8017578 L20.5043945,14.8017578 Z M5.32568359,23.5458984 L7.69970703,23.5458984 C8.87060547,23.5458984 9.55810547,22.8583984 9.55810547,21.6445312 L9.55810547,19.3564453 C9.55810547,18.1425781 8.87060547,17.4550781 7.69970703,17.4550781 L5.32568359,17.4550781 C4.15478516,17.4550781 3.46728516,18.1425781 3.46728516,19.3564453 L3.46728516,21.6445312 C3.46728516,22.8583984 4.15478516,23.5458984 5.32568359,23.5458984 Z M12.8022461,23.5458984 L15.1870117,23.5458984 C16.3579102,23.5458984 17.034668,22.8583984 17.034668,21.6445312 L17.034668,19.3564453 C17.034668,18.1425781 16.3579102,17.4550781 15.1870117,17.4550781 L12.8022461,17.4550781 C11.6313477,17.4550781 10.9545898,18.1425781 10.9545898,19.3564453 L10.9545898,21.6445312 C10.9545898,22.8583984 11.6313477,23.5458984 12.8022461,23.5458984 Z M20.300293,23.5458984 L22.6743164,23.5458984 C23.8452148,23.5458984 24.5327148,22.8583984 24.5327148,21.6445312 L24.5327148,19.3564453 C24.5327148,18.1425781 23.8452148,17.4550781 22.6743164,17.4550781 L20.300293,17.4550781 C19.1293945,17.4550781 18.4418945,18.1425781 18.4418945,19.3564453 L18.4418945,21.6445312 C18.4418945,22.8583984 19.1293945,23.5458984 20.300293,23.5458984 Z M5.52978516,22.0634766 C5.14306641,22.0634766 4.94970703,21.859375 4.94970703,21.4619141 L4.94970703,19.5390625 C4.94970703,19.1308594 5.14306641,18.9267578 5.52978516,18.9267578 L7.49560547,18.9267578 C7.87158203,18.9267578 8.08642578,19.1308594 8.08642578,19.5390625 L8.08642578,21.4619141 C8.08642578,21.859375 7.87158203,22.0634766 7.49560547,22.0634766 L5.52978516,22.0634766 Z M13.0063477,22.0634766 C12.6196289,22.0634766 12.4262695,21.859375 12.4262695,21.4619141 L12.4262695,19.5390625 C12.4262695,19.1308594 12.6196289,18.9267578 13.0063477,18.9267578 L14.9829102,18.9267578 C15.3588867,18.9267578 15.5629883,19.1308594 15.5629883,19.5390625 L15.5629883,21.4619141 C15.5629883,21.859375 15.3588867,22.0634766 14.9829102,22.0634766 L13.0063477,22.0634766 Z M20.5043945,22.0634766 C20.1176758,22.0634766 19.9135742,21.859375 19.9135742,21.4619141 L19.9135742,19.5390625 C19.9135742,19.1308594 20.1176758,18.9267578 20.5043945,18.9267578 L22.4702148,18.9267578 C22.8461914,18.9267578 23.050293,19.1308594 23.050293,19.5390625 L23.050293,21.4619141 C23.050293,21.859375 22.8461914,22.0634766 22.4702148,22.0634766 L20.5043945,22.0634766 Z" transform="translate(-2 -1)"/></svg>',
    sfCopy: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><path fill="currentColor" d="M3.01611328,23.6542969 C3.01611328,25.8994141 4.12255859,27.0273438 6.34619141,27.0273438 L16.4438477,27.0273438 C18.6674805,27.0273438 19.7739258,25.8886719 19.7739258,23.6542969 L19.7739258,21.6669922 L21.6538086,21.6669922 C23.8666992,21.6669922 24.9838867,20.5283203 24.9838867,18.2939453 L24.9838867,9.57128906 C24.9838867,8.25 24.715332,7.41210938 23.909668,6.58496094 L18.4848633,1.07421875 C17.722168,0.290039062 16.8198242,0 15.6704102,0 L11.5561523,0 C9.34326172,0 8.22607422,1.13867188 8.22607422,3.37304688 L8.22607422,5.36035156 L6.34619141,5.36035156 C4.13330078,5.36035156 3.01611328,6.48828125 3.01611328,8.73339844 L3.01611328,23.6542969 Z M18.753418,12.4072266 L12.8344727,6.38085938 C12.0180664,5.54296875 11.3413086,5.36035156 10.1381836,5.36035156 L9.95556641,5.36035156 L9.95556641,3.40527344 C9.95556641,2.34179688 10.5249023,1.72949219 11.6420898,1.72949219 L16.3901367,1.72949219 L16.3901367,7.24023438 C16.3901367,8.48632812 16.9916992,9.07714844 18.2270508,9.07714844 L23.2543945,9.07714844 L23.2543945,18.2617188 C23.2543945,19.3359375 22.6743164,19.9375 21.5571289,19.9375 L19.7739258,19.9375 L19.7739258,15.2646484 C19.7739258,13.8896484 19.612793,13.2880859 18.753418,12.4072266 Z M17.9477539,6.98242188 L17.9477539,2.578125 L22.8032227,7.51953125 L18.4741211,7.51953125 C18.0981445,7.51953125 17.9477539,7.35839844 17.9477539,6.98242188 Z M4.74560547,23.6220703 L4.74560547,8.75488281 C4.74560547,7.70214844 5.31494141,7.08984375 6.43212891,7.08984375 L9.95556641,7.08984375 L9.95556641,13.3203125 C9.95556641,14.6738281 10.6430664,15.3505859 11.9750977,15.3505859 L18.0444336,15.3505859 L18.0444336,23.6220703 C18.0444336,24.6962891 17.4643555,25.2978516 16.3579102,25.2978516 L6.42138672,25.2978516 C5.31494141,25.2978516 4.74560547,24.6962891 4.74560547,23.6220703 Z M12.1791992,13.7285156 C11.7495117,13.7285156 11.5776367,13.5566406 11.5776367,13.1269531 L11.5776367,7.48730469 L17.7114258,13.7285156 L12.1791992,13.7285156 Z" transform="translate(-2 .72)"/></svg>',
    sfCopyFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" viewBox="0 0 24 28"><path fill="currentColor" d="M21.2348633,21.6669922 L21.6538086,21.6669922 C23.855957,21.6669922 24.9838867,20.5283203 24.9838867,18.2939453 L24.9838867,8.09960938 L19.043457,8.09960938 C17.9155273,8.09960938 17.2817383,7.46582031 17.2817383,6.34863281 L17.2817383,0 L11.5561523,0 C9.37548828,0 8.22607422,1.13867188 8.22607422,3.28710938 L8.22607422,3.89941406 L9.78369141,3.89941406 C11.2875977,3.89941406 12.5014648,4.24316406 13.7045898,5.44628906 L19.8061523,11.5371094 C21.0092773,12.7509766 21.2348633,13.9970703 21.2348633,15.4580078 L21.2348633,21.6669922 Z M19.2475586,6.75683594 L24.8549805,6.75683594 C24.8012695,6.41308594 24.5649414,6.11230469 24.1889648,5.73632812 L19.6450195,1.10644531 C19.2797852,0.719726562 18.9682617,0.483398438 18.6352539,0.440429688 L18.6459961,6.13378906 C18.6459961,6.57421875 18.8071289,6.75683594 19.2475586,6.75683594 Z M6.34619141,27.0273438 L16.4438477,27.0273438 C18.6674805,27.0273438 19.7739258,25.8886719 19.7739258,23.6542969 L19.7739258,15.1679688 L12.2758789,15.1679688 C10.8901367,15.1679688 10.2456055,14.5126953 10.2456055,13.1376953 L10.2456055,5.36035156 L6.34619141,5.36035156 C4.13330078,5.36035156 3.01611328,6.48828125 3.01611328,8.73339844 L3.01611328,23.6542969 C3.01611328,25.8994141 4.12255859,27.0273438 6.34619141,27.0273438 Z M12.2651367,13.6962891 L19.5805664,13.6962891 C19.4731445,13.2773438 19.2260742,12.890625 18.7426758,12.3964844 L13.0063477,6.55273438 C12.5336914,6.06933594 12.1254883,5.74707031 11.706543,5.62890625 L11.706543,13.1484375 C11.706543,13.5136719 11.8999023,13.6962891 12.2651367,13.6962891 Z" transform="translate(-2 .72)"/></svg>',
    sfCursor: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.1367188,23.8574219 C12.953125,23.5351562 13.3505859,22.6113281 13.0068359,21.7841797 L9.92382812,14.5009766 L14.3710938,14.7480469 C15.0908203,14.7910156 15.4345703,14.0175781 14.9189453,13.4912109 L4.28417969,2.62011719 C3.81152344,2.13671875 3.08105469,2.40527344 3.0703125,3.08203125 L2.8983339,18.2070312 C2.88769531,18.9482422 3.71484375,19.2490234 4.19824219,18.7011719 L7.03417969,15.5644531 L10.0419922,22.9980469 C10.3857422,23.8037109 11.3095703,24.2011719 12.1367188,23.8574219 Z" transform="translate(3 -1)"/></svg>',
    sfCursorFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.1367188,23.8574219 C12.953125,23.5351562 13.3505859,22.6113281 13.0068359,21.7841797 L9.92382812,14.5009766 L14.3710938,14.7480469 C15.0908203,14.7910156 15.4345703,14.0175781 14.9189453,13.4912109 L4.28417969,2.62011719 C3.81152344,2.13671875 3.08105469,2.40527344 3.0703125,3.08203125 L2.8983339,18.2070312 C2.88769531,18.9482422 3.71484375,19.2490234 4.19824219,18.7011719 L7.03417969,15.5644531 L10.0419922,22.9980469 C10.3857422,23.8037109 11.3095703,24.2011719 12.1367188,23.8574219 Z" transform="translate(3 -1)"/></svg>',
    sfDocument: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.29589844,24.7597656 L17.7041016,24.7597656 C19.9277344,24.7597656 21.0341797,23.6318359 21.0341797,21.3974609 L21.0341797,11.6435547 C21.0341797,10.2578125 20.8730469,9.65625 20.0136719,8.77539062 L14.0947266,2.74902344 C13.2783203,1.91113281 12.6015625,1.72851562 11.3984375,1.72851562 L6.29589844,1.72851562 C4.08300781,1.72851562 2.96582031,2.8671875 2.96582031,5.1015625 L2.96582031,21.3974609 C2.96582031,23.6425781 4.07226562,24.7597656 6.29589844,24.7597656 Z M6.37109375,23.0302734 C5.26464844,23.0302734 4.6953125,22.4394531 4.6953125,21.3652344 L4.6953125,5.13378906 C4.6953125,4.0703125 5.26464844,3.45800781 6.38183594,3.45800781 L11.1621094,3.45800781 L11.1621094,9.69921875 C11.1621094,11.0527344 11.8388672,11.71875 13.1816406,11.71875 L19.3046875,11.71875 L19.3046875,21.3652344 C19.3046875,22.4394531 18.7353516,23.0302734 17.6181641,23.0302734 L6.37109375,23.0302734 Z M13.375,10.0966797 C12.9453125,10.0966797 12.7841797,9.92480469 12.7841797,9.49511719 L12.7841797,3.79101562 L18.9716797,10.0966797 L13.375,10.0966797 Z M15.953125,14.6835938 L7.79980469,14.6835938 C7.41308594,14.6835938 7.12304688,14.9736328 7.12304688,15.3388672 C7.12304688,15.7148438 7.41308594,16.0048828 7.79980469,16.0048828 L15.953125,16.0048828 C16.3291016,16.0048828 16.6083984,15.7148438 16.6083984,15.3388672 C16.6083984,14.9736328 16.3291016,14.6835938 15.953125,14.6835938 Z M15.953125,18.4326172 L7.79980469,18.4326172 C7.41308594,18.4326172 7.12304688,18.7333984 7.12304688,19.109375 C7.12304688,19.4746094 7.41308594,19.7539062 7.79980469,19.7539062 L15.953125,19.7539062 C16.3291016,19.7539062 16.6083984,19.4746094 16.6083984,19.109375 C16.6083984,18.7333984 16.3291016,18.4326172 15.953125,18.4326172 Z" transform="translate(0 -1)"/></svg>',
    sfDownload: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" viewBox="0 0 28 26"><path fill="currentColor" d="M18.921875,18.0136719 L18.921875,19.7431641 L24.2285156,19.7431641 C27.5263672,19.7431641 29.5029297,17.7558594 29.5029297,15.15625 C29.5029297,12.9863281 28.203125,11.203125 26.1083984,10.3544922 C26.1298828,5.56347656 22.6816406,2.10449219 18.2880859,2.10449219 C15.3769531,2.10449219 13.3037109,3.66210938 12.0146484,5.54199219 C9.57617188,4.88671875 6.49316406,6.77734375 6.43945312,9.79589844 C4.01171875,10.171875 2.49707031,12.1591797 2.49707031,14.6943359 C2.49707031,17.4873047 4.59179688,19.7431641 8.11523438,19.7431641 L13.1748047,19.7431641 L13.1748047,18.0136719 L8.10449219,18.0136719 C5.55859375,18.0136719 4.2265625,16.5419922 4.2265625,14.6943359 C4.2265625,12.6425781 5.52636719,11.1171875 7.80371094,11.1171875 C7.95410156,11.1171875 8.0078125,11.03125 8.0078125,10.8916016 C8.0078125,7.59375 10.3818359,6.68066406 12.5947266,7.32519531 C12.7236328,7.36816406 12.7988281,7.34667969 12.8632812,7.22851562 C13.9052734,5.37011719 15.5058594,3.83398438 18.2880859,3.83398438 C21.8115234,3.83398438 24.25,6.62695312 24.4326172,9.828125 C24.4648438,10.3115234 24.4326172,10.8916016 24.3896484,11.3964844 C24.3789062,11.5361328 24.4326172,11.6220703 24.5615234,11.6435547 C26.5166016,12.0732422 27.7734375,13.2978516 27.7734375,15.15625 C27.7734375,16.8105469 26.5703125,18.0136719 24.2177734,18.0136719 L18.921875,18.0136719 Z M12.4013672,21.1074219 C11.9501953,21.1074219 11.6279297,21.4189453 11.6279297,21.859375 C11.6279297,22.0849609 11.7246094,22.2568359 11.8857422,22.4179688 L15.4306641,25.8339844 C15.6455078,26.0488281 15.828125,26.1240234 16.0537109,26.1240234 C16.2685547,26.1240234 16.4511719,26.0488281 16.6660156,25.8339844 L20.2109375,22.4179688 C20.3720703,22.2568359 20.46875,22.0849609 20.46875,21.859375 C20.46875,21.4189453 20.125,21.1074219 19.6845703,21.1074219 C19.4697266,21.1074219 19.2548828,21.1826172 19.09375,21.3544922 L17.4394531,23.1269531 L16.8271484,23.7822266 L16.9023438,22.1601562 L16.9023438,12.9326172 C16.9023438,12.4814453 16.515625,12.1054688 16.0537109,12.1054688 C15.5917969,12.1054688 15.1943359,12.4814453 15.1943359,12.9326172 L15.1943359,22.1601562 L15.2695312,23.7822266 L14.6572266,23.1269531 L12.9921875,21.3544922 C12.8417969,21.1826172 12.6162109,21.1074219 12.4013672,21.1074219 Z" transform="translate(-2 -1)"/></svg>',
    sfEye: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24"><path fill="currentColor" d="M17.0053711,22.4609375 C25.6850586,22.4609375 31.6791992,15.4462891 31.6791992,13.2548828 C31.6791992,11.0527344 25.6743164,4.04882812 17.0053711,4.04882812 C8.44384766,4.04882812 2.32080078,11.0527344 2.32080078,13.2548828 C2.32080078,15.4462891 8.43310547,22.4609375 17.0053711,22.4609375 Z M17.0053711,20.7636719 C9.92626953,20.7636719 4.20068359,14.7695312 4.20068359,13.2548828 C4.20068359,11.9765625 9.92626953,5.74609375 17.0053711,5.74609375 C24.0522461,5.74609375 29.7993164,11.9765625 29.7993164,13.2548828 C29.7993164,14.7695312 24.0522461,20.7636719 17.0053711,20.7636719 Z M17.0053711,19.2597656 C20.3354492,19.2597656 23.0317383,16.5634766 23.0317383,13.2333984 C23.0317383,9.90332031 20.3354492,7.20703125 17.0053711,7.20703125 C13.675293,7.20703125 10.9682617,9.90332031 10.9682617,13.2333984 C10.9682617,16.5634766 13.675293,19.2597656 17.0053711,19.2597656 Z M17.0053711,15.2421875 C15.8989258,15.2421875 15.0073242,14.3505859 15.0073242,13.2441406 C15.0073242,12.1376953 15.8989258,11.2460938 17.0053711,11.2460938 C18.1118164,11.2460938 19.003418,12.1376953 19.003418,13.2441406 C19.003418,14.3505859 18.1118164,15.2421875 17.0053711,15.2421875 Z" transform="translate(-2 -1)"/></svg>',
    sfEyeFill: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24"><path fill="currentColor" d="M17.0053711,22.375 C25.6098633,22.375 31.5610352,15.4140625 31.5610352,13.2441406 C31.5610352,11.0634766 25.5991211,4.11328125 17.0053711,4.11328125 C8.50830078,4.11328125 2.43896484,11.0634766 2.43896484,13.2441406 C2.43896484,15.4140625 8.50830078,22.375 17.0053711,22.375 Z M17.0053711,19.2490234 C13.6860352,19.2490234 11.0004883,16.5527344 11.0004883,13.2441406 C11.0004883,9.92480469 13.6860352,7.23925781 17.0053711,7.23925781 C20.3139648,7.23925781 23.0102539,9.92480469 23.0102539,13.2441406 C23.0102539,16.5527344 20.3139648,19.2490234 17.0053711,19.2490234 Z M17.0053711,15.4355469 C18.2192383,15.4355469 19.1967773,14.4580078 19.1967773,13.2441406 C19.1967773,12.0302734 18.2192383,11.0527344 17.0053711,11.0527344 C15.7915039,11.0527344 14.8139648,12.0302734 14.8139648,13.2441406 C14.8139648,14.4580078 15.7915039,15.4355469 17.0053711,15.4355469 Z" transform="translate(-2 -1)"/></svg>',
    sfEyes: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M8.32910156,23.0410156 C11.5947266,23.0410156 14.2050781,19.0664062 14.2050781,13.2441406 C14.2050781,7.41113281 11.5947266,3.45800781 8.32910156,3.45800781 C5.05273438,3.45800781 2.44238281,7.41113281 2.44238281,13.2441406 C2.44238281,19.0664062 5.05273438,23.0410156 8.32910156,23.0410156 Z M21.6708984,23.0410156 C24.9472656,23.0410156 27.5576172,19.0664062 27.5576172,13.2441406 C27.5576172,7.41113281 24.9472656,3.45800781 21.6708984,3.45800781 C18.4052734,3.45800781 15.7949219,7.41113281 15.7949219,13.2441406 C15.7949219,19.0664062 18.4052734,23.0410156 21.6708984,23.0410156 Z M6.00878906,17.0361328 C7.80273438,17.0361328 8.99511719,15.7900391 8.99511719,13.8994141 C8.99511719,12.0410156 7.80273438,10.7841797 6.00878906,10.7841797 C5.23535156,10.7841797 4.58007812,11.0097656 4.0859375,11.4179688 C4.50488281,7.54003906 6.27734375,4.99414063 8.32910156,4.97263058 C10.703125,4.96191406 12.6904297,8.32421875 12.6904297,13.2441406 C12.6904297,18.1318359 10.703125,21.5048828 8.32910156,21.5263672 C6.55664062,21.5263672 4.98828125,19.625 4.32226562,16.5742188 C4.78417969,16.875 5.35351562,17.0361328 6.00878906,17.0361328 Z M19.3398438,17.0361328 C21.1337891,17.0361328 22.3476562,15.7900391 22.3476562,13.8994141 C22.3476562,12.0410156 21.1337891,10.7841797 19.3398438,10.7841797 C18.5771484,10.7841797 17.9111328,11.0097656 17.40625,11.4179688 C17.8359375,7.54003906 19.6083984,4.99414062 21.6708984,4.98339844 C24.0234375,4.98339844 26.0214844,8.34570312 26.0214844,13.2441406 C26.0214844,18.1425781 24.0234375,21.5048828 21.6708984,21.515625 C19.8876953,21.515625 18.3193359,19.6035156 17.6533203,16.5742188 C18.1152344,16.8642578 18.6953125,17.0361328 19.3398438,17.0361328 Z M5.16015625,13.5341797 C4.7734375,13.4804688 4.53710938,13.0185547 4.62304688,12.5458984 C4.71972656,12.0839844 5.08496094,11.7402344 5.45019531,11.8154297 C5.83691406,11.890625 6.07324219,12.3310547 5.9765625,12.7929688 C5.890625,13.265625 5.53613281,13.5986328 5.16015625,13.5341797 Z M18.4912109,13.5341797 C18.1152344,13.4697266 17.8681641,13.0185547 17.9648438,12.5458984 C18.0615234,12.0839844 18.4160156,11.7402344 18.7919922,11.8154297 C19.1787109,11.8798828 19.4042969,12.3310547 19.3076172,12.7929688 C19.2216797,13.265625 18.8671875,13.5986328 18.4912109,13.5341797 Z" transform="translate(-2 -1)"/></svg>',
    sfEyesFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M8.28613281,22.890625 C11.5087891,22.890625 14.0761719,18.9804688 14.0761719,13.2441406 C14.0761719,7.5078125 11.5087891,3.60839844 8.28613281,3.60839844 C5.26757812,3.60839844 2.81835938,7.05664062 2.52832031,12.234375 C3.03320312,11.2460938 4,10.6552734 5.26757812,10.6552734 C7.13671875,10.6552734 8.37207031,11.9658203 8.37207031,13.8994141 C8.37207031,15.8652344 7.13671875,17.1650391 5.26757812,17.1650391 C4.12890625,17.1650391 3.2265625,16.6923828 2.68945312,15.8759766 C3.34472656,20.140625 5.58984375,22.890625 8.28613281,22.890625 Z M21.6816406,22.890625 C24.9042969,22.890625 27.4716797,18.9804688 27.4716797,13.2441406 C27.4716797,7.5078125 24.9042969,3.60839844 21.6816406,3.60839844 C18.6630859,3.60839844 16.2138672,7.05664062 15.9238281,12.234375 C16.4287109,11.2460938 17.3955078,10.6552734 18.6523438,10.6552734 C20.5322266,10.6552734 21.7675781,11.9658203 21.7675781,13.8994141 C21.7675781,15.8652344 20.5322266,17.1650391 18.6523438,17.1650391 C17.5244141,17.1650391 16.6220703,16.6923828 16.0849609,15.8759766 C16.7402344,20.140625 18.9853516,22.890625 21.6816406,22.890625 Z M4.38671875,13.5126953 C4.7734375,13.5878906 5.12792969,13.2333984 5.23535156,12.75 C5.33203125,12.2666016 5.09570312,11.8046875 4.6875,11.7294922 C4.31152344,11.6542969 3.9140625,12.0087891 3.828125,12.4921875 C3.7421875,12.9863281 4,13.4482422 4.38671875,13.5126953 Z M17.7822266,13.5126953 C18.1582031,13.5878906 18.5341797,13.2333984 18.6308594,12.75 C18.7167969,12.2666016 18.4804688,11.7939453 18.0830078,11.7294922 C17.7070312,11.6542969 17.3095703,12.0087891 17.2236328,12.4921875 C17.1376953,12.9863281 17.3847656,13.4375 17.7822266,13.5126953 Z" transform="translate(-2 -1)"/></svg>',
    sfHistory: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M7.38183594,14.4042969 L12.9892578,14.4042969 C13.4082031,14.4042969 13.7412109,14.0820312 13.7412109,13.6523438 L13.7412109,6.41210938 C13.7412109,5.99316406 13.4082031,5.67089844 12.9892578,5.67089844 C12.5703125,5.67089844 12.2480469,5.99316406 12.2480469,6.41210938 L12.2480469,12.9111328 L7.38183594,12.9111328 C6.95214844,12.9111328 6.62988281,13.2333984 6.62988281,13.6523438 C6.62988281,14.0820312 6.95214844,14.4042969 7.38183594,14.4042969 Z" transform="translate(-1 -1)"/></svg>',
    'sfInfo Copy': '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M2.73925781,21.515625 C2.73925781,23.6533203 3.80273438,24.7597656 5.98339844,24.7597656 L23.7939453,24.7597656 C26.0498047,24.7597656 27.1669922,23.6533203 27.1669922,21.4404297 L27.1669922,5.05859375 C27.1669922,2.84570312 26.0498047,1.72851562 23.7939453,1.72851562 L10.8496094,1.72851562 C8.60449219,1.72851562 7.4765625,2.84570312 7.4765625,5.05859375 L7.4765625,10.1826172 L4.90917969,10.1826172 C3.54492188,10.1826172 2.73925781,10.9238281 2.73925781,12.2021484 L2.73925781,21.515625 Z M8.84082031,23.0302734 C9.07714844,22.5683594 9.20605469,22.03125 9.20605469,21.4082031 L9.20605469,5.15527344 C9.20605469,4.03808594 9.80761719,3.45800781 10.8818359,3.45800781 L23.7617188,3.45800781 C24.8359375,3.45800781 25.4375,4.03808594 25.4375,5.15527344 L25.4375,21.34375 C25.4375,22.4609375 24.8359375,23.0302734 23.7617188,23.0302734 L8.84082031,23.0302734 Z M11.9990234,8.13085938 L22.6660156,8.13085938 C23.0419922,8.13085938 23.3320312,7.83007812 23.3320312,7.45410156 C23.3320312,7.08886719 23.0419922,6.80957031 22.6660156,6.80957031 L11.9990234,6.80957031 C11.6123047,6.80957031 11.3222656,7.08886719 11.3222656,7.45410156 C11.3222656,7.83007812 11.6123047,8.13085938 11.9990234,8.13085938 Z M11.9990234,11.9121094 L22.6660156,11.9121094 C23.0419922,11.9121094 23.3320312,11.6220703 23.3320312,11.2568359 C23.3320312,10.8808594 23.0419922,10.5908203 22.6660156,10.5908203 L11.9990234,10.5908203 C11.6123047,10.5908203 11.3222656,10.8808594 11.3222656,11.2568359 C11.3222656,11.6220703 11.6123047,11.9121094 11.9990234,11.9121094 Z M4.46875,21.515625 L4.46875,12.5351562 C4.46875,12.1376953 4.70507812,11.9121094 5.10253906,11.9121094 L7.4765625,11.9121094 L7.4765625,21.515625 C7.4765625,22.4072266 6.82128906,23.0302734 5.98339844,23.0302734 C5.13476562,23.0302734 4.46875,22.375 4.46875,21.515625 Z M12.6328125,19.5712891 L15.4150391,19.5712891 C16.2314453,19.5712891 16.7255859,19.0771484 16.7255859,18.2607422 L16.7255859,15.7041016 C16.7255859,14.8769531 16.2314453,14.3828125 15.4150391,14.3828125 L12.6328125,14.3828125 C11.8056641,14.3828125 11.3115234,14.8769531 11.3115234,15.7041016 L11.3115234,18.2607422 C11.3115234,19.0771484 11.8056641,19.5712891 12.6328125,19.5712891 Z M18.6591797,15.7041016 L22.6552734,15.7041016 C23.0419922,15.7041016 23.3212891,15.4248047 23.3212891,15.0595703 C23.3212891,14.6728516 23.0419922,14.3828125 22.6552734,14.3828125 L18.6591797,14.3828125 C18.2724609,14.3828125 17.9931641,14.6728516 17.9931641,15.0595703 C17.9931641,15.4248047 18.2724609,15.7041016 18.6591797,15.7041016 Z M18.6591797,19.5712891 L22.6552734,19.5712891 C23.0419922,19.5712891 23.3212891,19.2919922 23.3212891,18.9267578 C23.3212891,18.5507812 23.0419922,18.25 22.6552734,18.25 L18.6591797,18.25 C18.2724609,18.25 17.9931641,18.5507812 17.9931641,18.9267578 C17.9931641,19.2919922 18.2724609,19.5712891 18.6591797,19.5712891 Z" transform="translate(-2 -1)"/></svg>',
    sfInfo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.12109375,5.60644531 C9.06640625,5.60644531 9.82910156,4.84375 9.82910156,3.88769531 C9.82910156,2.94238281 9.06640625,2.1796875 8.12109375,2.1796875 C7.17578125,2.1796875 6.41308594,2.94238281 6.41308594,3.88769531 C6.41308594,4.84375 7.17578125,5.60644531 8.12109375,5.60644531 Z M3.01855469,22.0527344 C3.01855469,22.5253906 3.42675781,22.9121094 3.953125,22.9121094 L12.6435547,22.9121094 C13.1591797,22.9121094 13.578125,22.5253906 13.578125,22.0527344 C13.578125,21.5800781 13.1591797,21.2148438 12.6435547,21.2148438 L9.61425781,21.2148438 L9.61425781,10.4619141 C9.61425781,9.92480469 9.1953125,9.49511719 8.6796875,9.49511719 L4.35058594,9.49511719 C3.81347656,9.49511719 3.39453125,9.86035156 3.39453125,10.3222656 C3.39453125,10.8164062 3.81347656,11.1923828 4.35058594,11.1923828 L7.61621094,11.1923828 L7.61621094,21.2148438 L3.953125,21.2148438 C3.42675781,21.2148438 3.01855469,21.5800781 3.01855469,22.0527344 Z" transform="translate(3 -1)"/></svg>',
    sfInfoOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M12.7832031,9.52734375 C13.5673828,9.52734375 14.1796875,8.90429688 14.1796875,8.12011719 C14.1796875,7.3359375 13.5673828,6.71289062 12.7832031,6.71289062 C12.0097656,6.71289062 11.3867188,7.3359375 11.3867188,8.12011719 C11.3867188,8.90429688 12.0097656,9.52734375 12.7832031,9.52734375 Z M11,19.2597656 L15.3720703,19.2597656 C15.8125,19.2597656 16.15625,18.9375 16.15625,18.4970703 C16.15625,18.078125 15.8125,17.7451172 15.3720703,17.7451172 L14.0400391,17.7451172 L14.0400391,12.2773438 C14.0400391,11.6972656 13.75,11.3105469 13.2021484,11.3105469 L11.1826172,11.3105469 C10.7421875,11.3105469 10.3984375,11.6435547 10.3984375,12.0625 C10.3984375,12.5029297 10.7421875,12.8251953 11.1826172,12.8251953 L12.3320312,12.8251953 L12.3320312,17.7451172 L11,17.7451172 C10.5595703,17.7451172 10.2158203,18.078125 10.2158203,18.4970703 C10.2158203,18.9375 10.5595703,19.2597656 11,19.2597656 Z" transform="translate(-1 -1)"/></svg>',
    sfInfoOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.28125 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.28125 6.84277344,24.2011719 12.8798828,24.2011719 Z M12.7832031,9.43066406 C11.9775391,9.43066406 11.3330078,8.78613281 11.3330078,7.96972656 C11.3330078,7.15332031 11.9775391,6.50878906 12.7832031,6.50878906 C13.5888672,6.50878906 14.2226562,7.15332031 14.2226562,7.96972656 C14.2226562,8.78613281 13.5888672,9.43066406 12.7832031,9.43066406 Z M10.9462891,19.4638672 C10.484375,19.4638672 10.1298828,19.1308594 10.1298828,18.6689453 C10.1298828,18.2392578 10.484375,17.8847656 10.9462891,17.8847656 L12.3105469,17.8847656 L12.3105469,12.8359375 L11.1289062,12.8359375 C10.6777344,12.8359375 10.3232422,12.5029297 10.3232422,12.0410156 C10.3232422,11.6113281 10.6777344,11.2568359 11.1289062,11.2568359 L13.2128906,11.2568359 C13.7822266,11.2568359 14.0830078,11.6650391 14.0830078,12.2666016 L14.0830078,17.8847656 L15.4472656,17.8847656 C15.9091797,17.8847656 16.2636719,18.2392578 16.2636719,18.6689453 C16.2636719,19.1308594 15.9091797,19.4638672 15.4472656,19.4638672 L10.9462891,19.4638672 Z" transform="translate(-1 -1)"/></svg>',
    sfInfoTriangle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.12402344,23.3955078 L21.7744141,23.3955078 C23.6005859,23.3955078 24.7070312,22.1279297 24.7070312,20.484375 C24.7070312,19.9794922 24.5566406,19.453125 24.2880859,18.9804688 L15.9521484,4.45703125 C15.3935547,3.47949219 14.4375,2.98535156 13.4492188,2.98535156 C12.4609375,2.98535156 11.4941406,3.47949219 10.9462891,4.45703125 L2.61035156,18.9804688 C2.3203125,19.4638672 2.19140625,19.9794922 2.19140625,20.484375 C2.19140625,22.1279297 3.29785156,23.3955078 5.12402344,23.3955078 Z M5.13476562,21.7089844 C4.3828125,21.7089844 3.93164062,21.1289062 3.93164062,20.4736328 C3.93164062,20.2695312 3.97460938,20.0117188 4.09277344,19.7861328 L12.4179688,5.2734375 C12.6435547,4.87597656 13.0517578,4.70410156 13.4492188,4.70410156 C13.8466797,4.70410156 14.2441406,4.87597656 14.4697266,5.2734375 L22.7949219,19.796875 C22.9130859,20.0224609 22.9667969,20.2695312 22.9667969,20.4736328 C22.9667969,21.1289062 22.4941406,21.7089844 21.7529297,21.7089844 L5.13476562,21.7089844 Z M13.3740234,10.8701172 C14.0830078,10.8701172 14.6308594,10.3115234 14.6308594,9.61328125 C14.6308594,8.90429688 14.0830078,8.34570312 13.3740234,8.34570312 C12.6757812,8.34570312 12.1171875,8.90429688 12.1171875,9.61328125 C12.1171875,10.3115234 12.6757812,10.8701172 13.3740234,10.8701172 Z M11.7734375,19.6357422 L15.7050781,19.6357422 C16.1025391,19.6357422 16.4140625,19.3457031 16.4140625,18.9482422 C16.4140625,18.5722656 16.1025391,18.2714844 15.7050781,18.2714844 L14.5019531,18.2714844 L14.5019531,13.3515625 C14.5019531,12.8251953 14.2441406,12.4814453 13.75,12.4814453 L11.9345703,12.4814453 C11.5371094,12.4814453 11.2255859,12.7822266 11.2255859,13.1582031 C11.2255859,13.5556641 11.5371094,13.8349609 11.9345703,13.8349609 L12.9658203,13.8349609 L12.9658203,18.2714844 L11.7734375,18.2714844 C11.3759766,18.2714844 11.0644531,18.5722656 11.0644531,18.9482422 C11.0644531,19.3457031 11.3759766,19.6357422 11.7734375,19.6357422 Z" transform="translate(-1 -1)"/></svg>',
    // the framework's default confirm-dialog indicator (smbls windows ConfirmTemplate
    // `icon: 'warning'`): the sfInfoTriangle outline with an exclamation mark
    warning: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.12402344,23.3955078 L21.7744141,23.3955078 C23.6005859,23.3955078 24.7070312,22.1279297 24.7070312,20.484375 C24.7070312,19.9794922 24.5566406,19.453125 24.2880859,18.9804688 L15.9521484,4.45703125 C15.3935547,3.47949219 14.4375,2.98535156 13.4492188,2.98535156 C12.4609375,2.98535156 11.4941406,3.47949219 10.9462891,4.45703125 L2.61035156,18.9804688 C2.3203125,19.4638672 2.19140625,19.9794922 2.19140625,20.484375 C2.19140625,22.1279297 3.29785156,23.3955078 5.12402344,23.3955078 Z M5.13476562,21.7089844 C4.3828125,21.7089844 3.93164062,21.1289062 3.93164062,20.4736328 C3.93164062,20.2695312 3.97460938,20.0117188 4.09277344,19.7861328 L12.4179688,5.2734375 C12.6435547,4.87597656 13.0517578,4.70410156 13.4492188,4.70410156 C13.8466797,4.70410156 14.2441406,4.87597656 14.4697266,5.2734375 L22.7949219,19.796875 C22.9130859,20.0224609 22.9667969,20.2695312 22.9667969,20.4736328 C22.9667969,21.1289062 22.4941406,21.7089844 21.7529297,21.7089844 L5.13476562,21.7089844 Z M13.4492188,9.20 C13.9600000,9.20 14.3200000,9.56 14.3100000,10.07 L14.2000000,16.03 C14.1900000,16.45 13.8700000,16.77 13.4492188,16.77 C13.0300000,16.77 12.7100000,16.45 12.7000000,16.03 L12.5900000,10.07 C12.5800000,9.56 12.9400000,9.20 13.4492188,9.20 Z M13.4492188,18.00 C14.0300000,18.00 14.5000000,18.47 14.5000000,19.05 C14.5000000,19.63 14.0300000,20.10 13.4492188,20.10 C12.8700000,20.10 12.4000000,19.63 12.4000000,19.05 C12.4000000,18.47 12.8700000,18.00 13.4492188,18.00 Z" transform="translate(-1 -1)"/></svg>',
    sfInfoTriangleFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.12402344,23.3955078 L21.7744141,23.3955078 C23.6005859,23.3955078 24.7070312,22.1279297 24.7070312,20.484375 C24.7070312,19.9794922 24.5566406,19.453125 24.2880859,18.9804688 L15.9521484,4.45703125 C15.3935547,3.47949219 14.4375,2.98535156 13.4492188,2.98535156 C12.4609375,2.98535156 11.4941406,3.47949219 10.9462891,4.45703125 L2.61035156,18.9804688 C2.3203125,19.4638672 2.19140625,19.9794922 2.19140625,20.484375 C2.19140625,22.1279297 3.29785156,23.3955078 5.12402344,23.3955078 Z M13.3632812,10.7841797 C12.6435547,10.7841797 12.0634766,10.2041016 12.0634766,9.47363281 C12.0634766,8.73242188 12.6435547,8.15234375 13.3632812,8.15234375 C14.09375,8.15234375 14.6630859,8.73242188 14.6630859,9.47363281 C14.6630859,10.2041016 14.09375,10.7841797 13.3632812,10.7841797 Z M11.7089844,19.8183594 C11.3007812,19.8183594 10.9785156,19.5175781 10.9785156,19.0986328 C10.9785156,18.7119141 11.3007812,18.4003906 11.7089844,18.4003906 L12.9443359,18.4003906 L12.9443359,13.8457031 L11.8808594,13.8457031 C11.4726562,13.8457031 11.1503906,13.5556641 11.1503906,13.1367188 C11.1503906,12.75 11.4726562,12.4277344 11.8808594,12.4277344 L13.7607422,12.4277344 C14.265625,12.4277344 14.5341797,12.7929688 14.5341797,13.3408203 L14.5341797,18.4003906 L15.7695312,18.4003906 C16.1777344,18.4003906 16.5,18.7119141 16.5,19.0986328 C16.5,19.5175781 16.1777344,19.8183594 15.7695312,19.8183594 L11.7089844,19.8183594 Z" transform="translate(-1 -1)"/></svg>',
    sfInspect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M13.5854492,16.4560547 L17.409668,16.4560547 C18.3979492,16.4560547 18.7954102,15.5537109 18.215332,14.9628906 L10.878418,7.63671875 C10.2338867,6.9921875 9.25634766,7.3359375 9.25634766,8.27050781 L9.25634766,18.6689453 C9.25634766,19.5068359 10.1694336,19.8505859 10.878418,19.1523438 L13.5854492,16.4560547 Z" transform="translate(-1 -1)"/></svg>',
    sfInspectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M13.574707,16.5527344 L10.7817383,19.3349609 C10.0512695,20.0546875 9.10595703,19.7001953 9.10595703,18.8300781 L9.10595703,8.109375 C9.10595703,7.14257812 10.1157227,6.78808594 10.7817383,7.45410156 L18.3442383,15.0058594 C18.9458008,15.6181641 18.5375977,16.5527344 17.5063477,16.5527344 L13.574707,16.5527344 Z" transform="translate(-1 -1)"/></svg>',
    sfKeyboard: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 28 24"><path fill="currentColor" d="M6.11230469,21.7304688 L26.4042969,21.7304688 C28.6386719,21.7304688 29.7773438,20.6132812 29.7773438,18.4003906 L29.7773438,8.07714844 C29.7773438,5.875 28.6386719,4.7578125 26.4042969,4.7578125 L6.11230469,4.7578125 C3.85644531,4.7578125 2.73925781,5.86425781 2.73925781,8.07714844 L2.73925781,18.4003906 C2.73925781,20.6132812 3.85644531,21.7304688 6.11230469,21.7304688 Z M6.13378906,20.0009766 C5.05957031,20.0009766 4.46875,19.4208984 4.46875,18.3037109 L4.46875,8.17382812 C4.46875,7.05664062 5.05957031,6.48730469 6.13378906,6.48730469 L26.3720703,6.48730469 C27.4355469,6.48730469 28.0478516,7.05664062 28.0478516,8.17382812 L28.0478516,18.3037109 C28.0478516,19.4208984 27.4355469,20.0009766 26.3720703,20.0009766 L6.13378906,20.0009766 Z M7.10058594,10.7412109 L8.08886719,10.7412109 C8.38964844,10.7412109 8.57226562,10.5585938 8.57226562,10.2685547 L8.57226562,9.28027344 C8.57226562,8.97949219 8.38964844,8.796875 8.08886719,8.796875 L7.10058594,8.796875 C6.81054688,8.796875 6.62792969,8.97949219 6.62792969,9.28027344 L6.62792969,10.2685547 C6.62792969,10.5585938 6.81054688,10.7412109 7.10058594,10.7412109 Z M10.5595703,10.7412109 L11.5478516,10.7412109 C11.8378906,10.7412109 12.0205078,10.5585938 12.0205078,10.2685547 L12.0205078,9.28027344 C12.0205078,8.97949219 11.8378906,8.796875 11.5478516,8.796875 L10.5595703,8.796875 C10.2587891,8.796875 10.0761719,8.97949219 10.0761719,9.28027344 L10.0761719,10.2685547 C10.0761719,10.5585938 10.2587891,10.7412109 10.5595703,10.7412109 Z M14.0185547,10.7412109 L14.9960938,10.7412109 C15.296875,10.7412109 15.4794922,10.5585938 15.4794922,10.2685547 L15.4794922,9.28027344 C15.4794922,8.97949219 15.296875,8.796875 14.9960938,8.796875 L14.0185547,8.796875 C13.7177734,8.796875 13.5351562,8.97949219 13.5351562,9.28027344 L13.5351562,10.2685547 C13.5351562,10.5585938 13.7177734,10.7412109 14.0185547,10.7412109 Z M17.4667969,10.7412109 L18.4550781,10.7412109 C18.7558594,10.7412109 18.9384766,10.5585938 18.9384766,10.2685547 L18.9384766,9.28027344 C18.9384766,8.97949219 18.7558594,8.796875 18.4550781,8.796875 L17.4667969,8.796875 C17.1767578,8.796875 16.9941406,8.97949219 16.9941406,9.28027344 L16.9941406,10.2685547 C16.9941406,10.5585938 17.1767578,10.7412109 17.4667969,10.7412109 Z M20.9257812,10.7412109 L21.9140625,10.7412109 C22.2041016,10.7412109 22.3867188,10.5585938 22.3867188,10.2685547 L22.3867188,9.28027344 C22.3867188,8.97949219 22.2041016,8.796875 21.9140625,8.796875 L20.9257812,8.796875 C20.625,8.796875 20.4423828,8.97949219 20.4423828,9.28027344 L20.4423828,10.2685547 C20.4423828,10.5585938 20.625,10.7412109 20.9257812,10.7412109 Z M24.3847656,10.7412109 L25.3623047,10.7412109 C25.6630859,10.7412109 25.8457031,10.5585938 25.8457031,10.2685547 L25.8457031,9.28027344 C25.8457031,8.97949219 25.6630859,8.796875 25.3623047,8.796875 L24.3847656,8.796875 C24.0839844,8.796875 23.9013672,8.97949219 23.9013672,9.28027344 L23.9013672,10.2685547 C23.9013672,10.5585938 24.0839844,10.7412109 24.3847656,10.7412109 Z M7.10058594,14.2001953 L8.08886719,14.2001953 C8.38964844,14.2001953 8.57226562,14.0175781 8.57226562,13.7167969 L8.57226562,12.7392578 C8.57226562,12.4384766 8.38964844,12.2558594 8.08886719,12.2558594 L7.10058594,12.2558594 C6.81054688,12.2558594 6.62792969,12.4384766 6.62792969,12.7392578 L6.62792969,13.7167969 C6.62792969,14.0175781 6.81054688,14.2001953 7.10058594,14.2001953 Z M10.5595703,14.2001953 L11.5478516,14.2001953 C11.8378906,14.2001953 12.0205078,14.0175781 12.0205078,13.7167969 L12.0205078,12.7392578 C12.0205078,12.4384766 11.8378906,12.2558594 11.5478516,12.2558594 L10.5595703,12.2558594 C10.2587891,12.2558594 10.0761719,12.4384766 10.0761719,12.7392578 L10.0761719,13.7167969 C10.0761719,14.0175781 10.2587891,14.2001953 10.5595703,14.2001953 Z M14.0185547,14.2001953 L14.9960938,14.2001953 C15.296875,14.2001953 15.4794922,14.0175781 15.4794922,13.7167969 L15.4794922,12.7392578 C15.4794922,12.4384766 15.296875,12.2558594 14.9960938,12.2558594 L14.0185547,12.2558594 C13.7177734,12.2558594 13.5351562,12.4384766 13.5351562,12.7392578 L13.5351562,13.7167969 C13.5351562,14.0175781 13.7177734,14.2001953 14.0185547,14.2001953 Z M17.4667969,14.2001953 L18.4550781,14.2001953 C18.7558594,14.2001953 18.9384766,14.0175781 18.9384766,13.7167969 L18.9384766,12.7392578 C18.9384766,12.4384766 18.7558594,12.2558594 18.4550781,12.2558594 L17.4667969,12.2558594 C17.1767578,12.2558594 16.9941406,12.4384766 16.9941406,12.7392578 L16.9941406,13.7167969 C16.9941406,14.0175781 17.1767578,14.2001953 17.4667969,14.2001953 Z M20.9257812,14.2001953 L21.9140625,14.2001953 C22.2041016,14.2001953 22.3867188,14.0175781 22.3867188,13.7167969 L22.3867188,12.7392578 C22.3867188,12.4384766 22.2041016,12.2558594 21.9140625,12.2558594 L20.9257812,12.2558594 C20.625,12.2558594 20.4423828,12.4384766 20.4423828,12.7392578 L20.4423828,13.7167969 C20.4423828,14.0175781 20.625,14.2001953 20.9257812,14.2001953 Z M24.3847656,14.2001953 L25.3623047,14.2001953 C25.6630859,14.2001953 25.8457031,14.0175781 25.8457031,13.7167969 L25.8457031,12.7392578 C25.8457031,12.4384766 25.6630859,12.2558594 25.3623047,12.2558594 L24.3847656,12.2558594 C24.0839844,12.2558594 23.9013672,12.4384766 23.9013672,12.7392578 L23.9013672,13.7167969 C23.9013672,14.0175781 24.0839844,14.2001953 24.3847656,14.2001953 Z M7.10058594,17.6591797 L8.08886719,17.6591797 C8.38964844,17.6591797 8.57226562,17.4765625 8.57226562,17.1757812 L8.57226562,16.1875 C8.57226562,15.8974609 8.38964844,15.7148438 8.08886719,15.7148438 L7.10058594,15.7148438 C6.81054688,15.7148438 6.62792969,15.8974609 6.62792969,16.1875 L6.62792969,17.1757812 C6.62792969,17.4765625 6.81054688,17.6591797 7.10058594,17.6591797 Z M10.6669922,17.6591797 L21.8066406,17.6591797 C22.171875,17.6591797 22.3867188,17.4443359 22.3867188,17.0683594 L22.3867188,16.2949219 C22.3867188,15.9296875 22.171875,15.7148438 21.8066406,15.7148438 L10.6669922,15.7148438 C10.2910156,15.7148438 10.0761719,15.9296875 10.0761719,16.2949219 L10.0761719,17.0683594 C10.0761719,17.4443359 10.2910156,17.6591797 10.6669922,17.6591797 Z M24.3847656,17.6591797 L25.3623047,17.6591797 C25.6630859,17.6591797 25.8457031,17.4765625 25.8457031,17.1757812 L25.8457031,16.1875 C25.8457031,15.8974609 25.6630859,15.7148438 25.3623047,15.7148438 L24.3847656,15.7148438 C24.0839844,15.7148438 23.9013672,15.8974609 23.9013672,16.1875 L23.9013672,17.1757812 C23.9013672,17.4765625 24.0839844,17.6591797 24.3847656,17.6591797 Z" transform="translate(-2 -1)"/></svg>',
    sfMessage: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M12.9785156,18.1855469 C16.4160156,18.1855469 18.9189453,16.1015625 18.9189453,13.2441406 C18.9189453,10.3759766 16.4160156,8.31347656 12.9785156,8.31347656 C9.55175781,8.31347656 7.04882812,10.3759766 7.04882812,13.2441406 C7.04882812,15.3066406 8.1875,15.8544922 8.1875,16.7783203 C8.1875,17.1757812 8.05859375,17.4443359 7.73632812,17.7236328 C7.52148438,17.9384766 7.63964844,18.1855469 7.97265625,18.1855469 C8.67089844,18.1855469 9.40136719,17.9384766 9.92773438,17.5517578 C10.8193359,17.9707031 11.8505859,18.1855469 12.9785156,18.1855469 Z" transform="translate(-1 -1)"/></svg>',
    sfMessageFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2119141 C19.0478516,24.2119141 23.9570312,19.3027344 23.9570312,13.2548828 C23.9570312,7.21777344 19.0478516,2.29785156 13,2.29785156 C6.96289062,2.29785156 2.04296875,7.21777344 2.04296875,13.2548828 C2.04296875,19.3027344 6.96289062,24.2119141 13,24.2119141 Z M12.9892578,18.3466797 C11.8291016,18.3466797 10.765625,18.1318359 9.84179688,17.7021484 C9.3046875,18.1103516 8.55273438,18.3466797 7.83300781,18.3466797 C7.48925781,18.3466797 7.36035156,18.0996094 7.5859375,17.8740234 C7.91894531,17.5947266 8.04785156,17.3046875 8.04785156,16.9072266 C8.04785156,15.9511719 6.87695312,15.3818359 6.87695312,13.2548828 C6.87695312,10.3007812 9.45507812,8.17382812 12.9892578,8.17382812 C16.5341797,8.17382812 19.1123047,10.3007812 19.1123047,13.2548828 C19.1123047,16.2089844 16.5341797,18.3466797 12.9892578,18.3466797 Z" transform="translate(-1 -1)"/></svg>',
    sfMove: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path fill="currentColor" d="M8.08203125,16.4775391 L8.08203125,14.1894531 L14.0439453,14.1894531 L14.0439453,20.1835938 L11.7558594,20.1835938 C10.8320312,20.1835938 10.2841797,21.1289062 10.9716797,21.8486328 L14.2265625,25.2861328 C14.6884766,25.7695312 15.34375,25.7480469 15.7841797,25.2753906 L19.0283203,21.8486328 C19.7265625,21.1289062 19.1787109,20.1835938 18.2441406,20.1835938 L15.9667969,20.1835938 L15.9667969,14.1894531 L21.9179688,14.1894531 L21.9179688,16.4775391 C21.9179688,17.4121094 22.8632812,17.9599609 23.59375,17.2617188 L27.0205078,14.0175781 C27.4824219,13.5664062 27.5039062,12.921875 27.03125,12.4599609 L23.59375,9.20507812 C22.8632812,8.51757812 21.9179688,9.06542969 21.9179688,9.98925781 L21.9179688,12.2666016 L15.9667969,12.2666016 L15.9667969,6.28320312 L18.2441406,6.28320312 C19.1787109,6.28320312 19.7265625,5.33789062 19.0283203,4.61816406 L15.7734375,1.18066406 C15.3222656,0.697265625 14.6669922,0.71875 14.2158203,1.19140625 L10.9716797,4.61816406 C10.2841797,5.33789062 10.8320312,6.28320312 11.7558594,6.28320312 L14.0439453,6.28320312 L14.0439453,12.2666016 L8.08203125,12.2666016 L8.08203125,9.98925781 C8.08203125,9.06542969 7.12597656,8.51757812 6.40625,9.20507812 L2.97949219,12.4492188 C2.51757812,12.9003906 2.49609375,13.5449219 2.96875,14.0068359 L6.40625,17.2617188 C7.12597656,17.9599609 8.08203125,17.4121094 8.08203125,16.4775391 Z" transform="translate(-2)"/></svg>',
    sfMoveFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path fill="currentColor" d="M8.08203125,16.4775391 L8.08203125,14.1894531 L14.0439453,14.1894531 L14.0439453,20.1835938 L11.7558594,20.1835938 C10.8320312,20.1835938 10.2841797,21.1289062 10.9716797,21.8486328 L14.2265625,25.2861328 C14.6884766,25.7695312 15.34375,25.7480469 15.7841797,25.2753906 L19.0283203,21.8486328 C19.7265625,21.1289062 19.1787109,20.1835938 18.2441406,20.1835938 L15.9667969,20.1835938 L15.9667969,14.1894531 L21.9179688,14.1894531 L21.9179688,16.4775391 C21.9179688,17.4121094 22.8632812,17.9599609 23.59375,17.2617188 L27.0205078,14.0175781 C27.4824219,13.5664062 27.5039062,12.921875 27.03125,12.4599609 L23.59375,9.20507812 C22.8632812,8.51757812 21.9179688,9.06542969 21.9179688,9.98925781 L21.9179688,12.2666016 L15.9667969,12.2666016 L15.9667969,6.28320312 L18.2441406,6.28320312 C19.1787109,6.28320312 19.7265625,5.33789062 19.0283203,4.61816406 L15.7734375,1.18066406 C15.3222656,0.697265625 14.6669922,0.71875 14.2158203,1.19140625 L10.9716797,4.61816406 C10.2841797,5.33789062 10.8320312,6.28320312 11.7558594,6.28320312 L14.0439453,6.28320312 L14.0439453,12.2666016 L8.08203125,12.2666016 L8.08203125,9.98925781 C8.08203125,9.06542969 7.12597656,8.51757812 6.40625,9.20507812 L2.97949219,12.4492188 C2.51757812,12.9003906 2.49609375,13.5449219 2.96875,14.0068359 L6.40625,17.2617188 C7.12597656,17.9599609 8.08203125,17.4121094 8.08203125,16.4775391 Z" transform="translate(-2)"/></svg>',
    sfPage: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.96582031,21.3974609 C2.96582031,23.6425781 4.07226562,24.7597656 6.29589844,24.7597656 L17.7041016,24.7597656 C19.9277344,24.7597656 21.0341797,23.6425781 21.0341797,21.3974609 L21.0341797,5.1015625 C21.0341797,2.8671875 19.9277344,1.72851562 17.7041016,1.72851562 L6.29589844,1.72851562 C4.07226562,1.72851562 2.96582031,2.8671875 2.96582031,5.1015625 L2.96582031,21.3974609 Z M4.6953125,21.3652344 L4.6953125,5.13378906 C4.6953125,4.05957031 5.26464844,3.45800781 6.38183594,3.45800781 L17.6181641,3.45800781 C18.7353516,3.45800781 19.3046875,4.05957031 19.3046875,5.13378906 L19.3046875,21.3652344 C19.3046875,22.4394531 18.7353516,23.0302734 17.6181641,23.0302734 L6.38183594,23.0302734 C5.26464844,23.0302734 4.6953125,22.4394531 4.6953125,21.3652344 Z M7.15527344,11.9873047 C7.4453125,11.9873047 7.62792969,11.8369141 7.72460938,11.4716797 L8.08984375,10.4082031 L10.109375,10.4082031 L10.4960938,11.4716797 C10.5927734,11.8261719 10.7753906,11.9873047 11.0546875,11.9873047 C11.4199219,11.9873047 11.6240234,11.7832031 11.6240234,11.4394531 C11.6240234,11.3642578 11.6025391,11.2246094 11.5595703,11.0849609 L9.98046875,6.71289062 C9.81933594,6.26171875 9.55078125,6.046875 9.08886719,6.046875 C8.65917969,6.046875 8.40136719,6.26171875 8.24023438,6.71289062 L6.66113281,11.0849609 C6.60742188,11.2138672 6.5859375,11.3642578 6.5859375,11.4394531 C6.5859375,11.7832031 6.80078125,11.9873047 7.15527344,11.9873047 Z M13.4931641,7.90527344 L16.7695312,7.90527344 C17.1455078,7.90527344 17.4355469,7.61523438 17.4355469,7.23925781 C17.4355469,6.87402344 17.1455078,6.58398438 16.7695312,6.58398438 L13.4931641,6.58398438 C13.0957031,6.58398438 12.8164062,6.87402344 12.8164062,7.23925781 C12.8164062,7.61523438 13.0957031,7.90527344 13.4931641,7.90527344 Z M8.33691406,9.51660156 L9.06738281,7.26074219 L9.13183594,7.26074219 L9.87304688,9.51660156 L8.33691406,9.51660156 Z M13.4931641,11.6542969 L16.7695312,11.6542969 C17.1455078,11.6542969 17.4355469,11.3642578 17.4355469,10.9882812 C17.4355469,10.6230469 17.1455078,10.3330078 16.7695312,10.3330078 L13.4931641,10.3330078 C13.0957031,10.3330078 12.8164062,10.6230469 12.8164062,10.9882812 C12.8164062,11.3642578 13.0957031,11.6542969 13.4931641,11.6542969 Z M6.53222656,20.5380859 L7.28417969,20.5380859 L8.70214844,19.109375 C8.90625,18.9160156 9.12109375,18.8408203 9.3359375,18.8408203 C9.55078125,18.8408203 9.78710938,18.9267578 9.99121094,19.109375 L10.8720703,19.9150391 L13.0742188,17.9599609 C13.3212891,17.7451172 13.5791016,17.6484375 13.8261719,17.6484375 C14.0947266,17.6484375 14.3740234,17.734375 14.5673828,17.9599609 L16.7158203,20.4306641 L17.4677734,20.4306641 L17.4677734,15.2958984 C17.4677734,14.3505859 16.9736328,13.8671875 16.0283203,13.8671875 L7.98242188,13.8671875 C7.06933594,13.8671875 6.53222656,14.3505859 6.53222656,15.2958984 L6.53222656,20.5380859 Z M10.0771484,17.9599609 C9.43261719,17.9599609 8.91699219,17.4228516 8.91699219,16.7998047 C8.91699219,16.1552734 9.43261719,15.6181641 10.0771484,15.6396484 C10.7109375,15.6611328 11.2373047,16.1552734 11.2373047,16.7998047 C11.2373047,17.4228516 10.7109375,17.9599609 10.0771484,17.9599609 Z" transform="translate(0 -1)"/></svg>',
    sfPallete: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><path fill="currentColor" d="M5.99804688,25.640625 L10.0585938,25.640625 C11.2939453,25.640625 12.1425781,25.2431641 12.6044922,24.4697266 L25.484375,17.046875 C27.1279297,16.0908203 27.4824219,14.7158203 26.515625,13.0400391 L24.4853516,9.52734375 C23.8515625,8.42089844 23.0566406,7.84082031 22.1435547,7.83007812 C22.6484375,6.4765625 22.1650391,5.359375 20.7255859,4.53222656 L17.2021484,2.49121094 C15.4619141,1.48144531 14.0761719,1.81445312 13.1201172,3.46875 L13.0126953,3.66210938 C12.9804688,1.80371094 11.9814453,0.84765625 10.0585938,0.84765625 L5.99804688,0.84765625 C3.98925781,0.84765625 2.94726562,1.82519531 2.94726562,3.73730469 L2.94726562,22.7402344 C2.94726562,24.6523438 3.98925781,25.640625 5.99804688,25.640625 Z M4.67675781,3.82324219 C4.67675781,3.10351562 5.25683594,2.57714844 6.01953125,2.57714844 L10.0371094,2.57714844 C10.7568359,2.57714844 11.2832031,3.10351562 11.2832031,3.82324219 L11.2832031,8.5390625 L4.67675781,8.5390625 L4.67675781,3.82324219 Z M14.5703125,4.40332031 C14.9248047,3.78027344 15.6982422,3.60839844 16.3642578,3.99511719 L19.8447266,6.00390625 C20.4570312,6.35839844 20.6396484,7.078125 20.2851562,7.71191406 L17.9326172,11.7832031 L13.0126953,8.94726562 L13.0126953,7.09960938 L14.5703125,4.40332031 Z M21.2412109,9.87109375 C21.8642578,9.50585938 22.6162109,9.7421875 23.0029297,10.4082031 L25.0117188,13.8779297 C25.3662109,14.5009766 25.1621094,15.2314453 24.5498047,15.5859375 L20.4677734,17.9384766 L18.4267578,14.3935547 L20.9296875,10.0537109 L21.2412109,9.87109375 Z M4.67675781,16.2197266 L4.67675781,10.2685547 L11.2832031,10.2685547 L11.2832031,16.2197266 L4.67675781,16.2197266 Z M13.0126953,17.8095703 L13.0126953,10.9345703 L17.0625,13.2871094 L14.0976562,18.4433594 L13.0126953,17.8095703 Z M17.4277344,16.1230469 L18.9638672,18.8085938 L14.3339844,21.4833984 L17.4277344,16.1230469 Z M6.01953125,23.9111328 C5.25683594,23.9111328 4.67675781,23.3740234 4.67675781,22.6542969 L4.67675781,17.9492188 L11.2832031,17.9492188 L11.2832031,22.6542969 C11.2832031,23.3740234 10.7568359,23.9111328 10.0371094,23.9111328 L6.01953125,23.9111328 Z M13.0126953,19.8076172 L13.2275391,19.9365234 L13.0126953,20.3232422 L13.0126953,19.8076172 Z" transform="translate(-2)"/></svg>',
    sfPencil: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.0361328,8.17382812 L20.1210938,7.11035156 C20.6689453,6.5625 20.7011719,5.97167969 20.2070312,5.47753906 L19.8417969,5.11230469 C19.3583984,4.62890625 18.7675781,4.671875 18.2197266,5.20898438 L17.1347656,6.28320312 L19.0361328,8.17382812 Z M6.37109375,20.8066406 L18.0908203,9.09765625 L16.2109375,7.20703125 L4.48046875,18.9160156 L3.45996094,21.3115234 C3.35253906,21.5693359 3.63183594,21.8701172 3.88964844,21.7626953 L6.37109375,20.8066406 Z" transform="translate(0 -1)"/></svg>',
    sfPlay: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.11962891,20.6992188 C3.11962891,21.7626953 3.73193359,22.2675781 4.46240234,22.2675781 C4.78466797,22.2675781 5.11767578,22.1601562 5.45068359,21.9882812 L17.965332,14.6728516 C18.8569336,14.1572266 19.1577148,13.8027344 19.1577148,13.2441406 C19.1577148,12.6748047 18.8569336,12.3310547 17.965332,11.8154297 L5.45068359,4.5 C5.11767578,4.31738281 4.78466797,4.22070312 4.46240234,4.22070312 C3.73193359,4.22070312 3.11962891,4.72558594 3.11962891,5.7890625 L3.11962891,20.6992188 Z M4.84912109,19.9365234 L4.84912109,6.55175781 C4.84912109,6.35839844 5.02099609,6.27246094 5.18212891,6.36914062 L16.6655273,13.0722656 C16.7407227,13.1044922 16.7836914,13.1796875 16.7836914,13.2441406 C16.7836914,13.3085938 16.7407227,13.3730469 16.6655273,13.4160156 L5.18212891,20.1191406 C5.02099609,20.2158203 4.84912109,20.1298828 4.84912109,19.9365234 Z" transform="translate(2 -1)"/></svg>',
    sfPlayFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.11962891,20.6992188 C3.11962891,21.7626953 3.73193359,22.2675781 4.46240234,22.2675781 C4.78466797,22.2675781 5.11767578,22.1601562 5.45068359,21.9882812 L17.965332,14.6728516 C18.8569336,14.1572266 19.1577148,13.8027344 19.1577148,13.2441406 C19.1577148,12.6748047 18.8569336,12.3310547 17.965332,11.8154297 L5.45068359,4.5 C5.11767578,4.31738281 4.78466797,4.22070312 4.46240234,4.22070312 C3.73193359,4.22070312 3.11962891,4.72558594 3.11962891,5.7890625 L3.11962891,20.6992188 Z" transform="translate(2 -1)"/></svg>',
    sfPlugin: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M6.70800781,22.4609375 L25.2919922,22.4609375 C27.5478516,22.4609375 28.6650391,21.34375 28.6650391,19.1308594 L28.6650391,10.1181641 C28.6650391,7.91601562 27.5478516,6.79882812 25.2919922,6.79882812 L24.0996094,6.79882812 L24.0996094,5.359375 C24.0996094,4.54296875 23.6269531,4.04882812 22.7998047,4.04882812 L20.6513672,4.04882812 C19.8349609,4.04882812 19.3623047,4.54296875 19.3623047,5.359375 L19.3623047,6.79882812 L12.6484375,6.79882812 L12.6484375,5.359375 C12.6484375,4.54296875 12.1757812,4.04882812 11.3486328,4.04882812 L9.20019531,4.04882812 C8.37304688,4.04882812 7.90039062,4.54296875 7.90039062,5.359375 L7.90039062,6.79882812 L6.70800781,6.79882812 C4.46289062,6.79882812 3.33496094,7.90527344 3.33496094,10.1181641 L3.33496094,19.1308594 C3.33496094,21.3544922 4.46289062,22.4609375 6.70800781,22.4609375 Z M5.06445312,19.0449219 L5.06445312,10.2148438 C5.06445312,9.09765625 5.65527344,8.52832031 6.72949219,8.52832031 L25.2705078,8.52832031 C26.3339844,8.52832031 26.9355469,9.09765625 26.9355469,10.2148438 L26.9355469,19.0449219 C26.9355469,20.1513672 26.3339844,20.7314453 25.2705078,20.7314453 L6.72949219,20.7314453 C5.65527344,20.7314453 5.06445312,20.1513672 5.06445312,19.0449219 Z" transform="translate(-3 -1)"/></svg>',
    sfQuestion: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8.05664062,17.6591797 C8.80859375,17.6591797 9.15234375,17.1435547 9.15234375,16.4560547 L9.15234375,16.0908203 C9.17382812,14.6728516 9.67871094,14.0820312 11.3974609,12.9003906 C13.2451172,11.6542969 14.4160156,10.2148438 14.4160156,8.14160156 C14.4160156,4.91894531 11.7949219,3.07128906 8.52929688,3.07128906 C6.1015625,3.07128906 3.97460938,4.22070312 3.06152344,6.29394531 C2.8359375,6.79882812 2.73925781,7.29296875 2.73925781,7.70117188 C2.73925781,8.31347656 3.09375,8.74316406 3.74902344,8.74316406 C4.296875,8.74316406 4.66210938,8.42089844 4.82324219,7.89453125 C5.37109375,5.85351562 6.72460938,5.08007812 8.45410156,5.08007812 C10.5488281,5.08007812 12.1923828,6.26171875 12.1923828,8.13085938 C12.1923828,9.66699219 11.2363281,10.5263672 9.86132812,11.4931641 C8.17480469,12.6640625 6.93945312,13.9208984 6.93945312,15.8115234 L6.93945312,16.4882812 C6.93945312,17.1757812 7.31542969,17.6591797 8.05664062,17.6591797 Z M8.05664062,23.5351562 C8.91601562,23.5351562 9.59277344,22.8476562 9.59277344,22.0097656 C9.59277344,21.1611328 8.91601562,20.484375 8.05664062,20.484375 C7.21875,20.484375 6.53125,21.1611328 6.53125,22.0097656 C6.53125,22.8476562 7.21875,23.5351562 8.05664062,23.5351562 Z" transform="translate(3 -1)"/></svg>',
    sfQuestionOval: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M12.6542969,15.4677734 C13.1914062,15.4677734 13.5244141,15.1240234 13.5244141,14.7050781 L13.5244141,14.5761719 C13.5244141,13.9746094 13.8681641,13.5878906 14.6201172,13.09375 C15.6621094,12.40625 16.4033203,11.7832031 16.4033203,10.4941406 C16.4033203,8.7109375 14.8134766,7.74414062 12.9873047,7.74414062 C11.1396484,7.74414062 9.92578125,8.625 9.63574219,9.61328125 C9.58203125,9.78515625 9.54980469,9.95703125 9.54980469,10.1396484 C9.54980469,10.6230469 9.92578125,10.8808594 10.2802734,10.8808594 C10.6455078,10.8808594 10.8818359,10.7089844 11.0751953,10.4511719 L11.2685547,10.1933594 C11.6445312,9.5703125 12.203125,9.20507812 12.9228516,9.20507812 C13.9003906,9.20507812 14.5341797,9.76367188 14.5341797,10.5800781 C14.5341797,11.3105469 14.0830078,11.6650391 13.1484375,12.3203125 C12.375,12.8574219 11.7949219,13.4267578 11.7949219,14.4794922 L11.7949219,14.6191406 C11.7949219,15.1777344 12.1064453,15.4677734 12.6542969,15.4677734 Z M12.6328125,18.6689453 C13.2558594,18.6689453 13.7929688,18.1748047 13.7929688,17.5517578 C13.7929688,16.9287109 13.2666016,16.4345703 12.6328125,16.4345703 C11.9990234,16.4345703 11.4726562,16.9394531 11.4726562,17.5517578 C11.4726562,18.1640625 12.0097656,18.6689453 12.6328125,18.6689453 Z" transform="translate(-1 -1)"/></svg>',
    sfQuestionOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.28125 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.28125 6.84277344,24.2011719 12.8798828,24.2011719 Z M12.6542969,15.5429688 C12.0849609,15.5429688 11.7626953,15.2421875 11.7626953,14.6621094 L11.7626953,14.5224609 C11.7626953,13.4267578 12.3642578,12.8466797 13.1591797,12.2880859 C14.1259766,11.6113281 14.5878906,11.2460938 14.5878906,10.4941406 C14.5878906,9.65625 13.9326172,9.08691406 12.9335938,9.08691406 C12.1923828,9.08691406 11.6230469,9.45214844 11.2255859,10.0966797 L11.0322266,10.3652344 C10.828125,10.6230469 10.5810547,10.8056641 10.2050781,10.8056641 C9.83984375,10.8056641 9.44238281,10.5371094 9.44238281,10.0429688 C9.44238281,9.84960938 9.48535156,9.66699219 9.5390625,9.49511719 C9.83984375,8.47460938 11.0859375,7.58300781 12.9980469,7.58300781 C14.8886719,7.58300781 16.5322266,8.56054688 16.5322266,10.4082031 C16.5322266,11.7402344 15.7587891,12.3847656 14.6845703,13.09375 C13.9111328,13.5986328 13.5566406,13.9960938 13.5566406,14.6191406 L13.5566406,14.7480469 C13.5566406,15.1884766 13.2128906,15.5429688 12.6542969,15.5429688 Z M12.6328125,18.8408203 C11.9882812,18.8408203 11.4296875,18.3251953 11.4296875,17.6914062 C11.4296875,17.0576172 11.9775391,16.53125 12.6328125,16.53125 C13.2880859,16.53125 13.8359375,17.046875 13.8359375,17.6914062 C13.8359375,18.3359375 13.2773438,18.8408203 12.6328125,18.8408203 Z" transform="translate(-1 -1)"/></svg>',
    sfReplace: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M11.796875,14.640625 C12.0869141,14.3613281 12.0976562,13.9638672 11.8076172,13.6738281 C11.6894531,13.5341797 11.5175781,13.4697266 11.3242188,13.4697266 L9.734375,13.4912109 L9.10058594,13.5341797 L9.48730469,13.1796875 L14.4287109,8.23828125 C14.7080078,7.95898438 14.6972656,7.54003906 14.4179688,7.26074219 C14.1386719,6.98144531 13.7197266,6.97070312 13.4404297,7.26074219 L8.50976562,12.1806641 L8.14453125,12.5673828 L8.19824219,11.9658203 L8.21972656,10.3652344 C8.23046875,10.1933594 8.15527344,10.0107422 8.015625,9.88183594 C7.73632812,9.59179688 7.33886719,9.59179688 7.04882812,9.88183594 C6.91992187,10 6.85546875,10.2041016 6.85546875,10.3867188 L6.80175781,14.1572266 C6.79101562,14.5546875 7.13476562,14.8984375 7.53222656,14.8876953 L11.3134766,14.8554688 C11.4960938,14.8554688 11.6894531,14.7587891 11.796875,14.640625 Z M11.5390625,19.2275391 C11.8183594,19.5175781 12.2373047,19.5175781 12.5166016,19.2382812 L17.4580078,14.3076172 L17.8232422,13.9208984 L17.7802734,14.5439453 L17.7480469,16.1337891 C17.7480469,16.3164062 17.8232422,16.4882812 17.9521484,16.6279297 C18.2421875,16.9072266 18.6396484,16.9072266 18.9296875,16.6171875 C19.0371094,16.5097656 19.1445312,16.3164062 19.1445312,16.1230469 L19.1767578,12.3417969 C19.1875,11.9550781 18.8330078,11.6113281 18.4462891,11.6113281 L14.6865234,11.6542969 C14.4931641,11.6542969 14.2890625,11.7402344 14.1708984,11.8583984 C13.8808594,12.1376953 13.8808594,12.5458984 14.1708984,12.8359375 C14.2998047,12.9541016 14.4824219,13.0400391 14.6650391,13.0292969 L16.2441406,13.0078125 L16.8349609,12.9648438 L16.4589844,13.3193359 L11.5390625,18.25 C11.2490234,18.5400391 11.2597656,18.9482422 11.5390625,19.2275391 Z" transform="translate(-1 -1)"/></svg>',
    sfResponsive: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27"><path fill="currentColor" d="M3.39746094,4.53222656 L5.01953125,4.53222656 L5.01953125,3.0390625 C5.01953125,2.36230469 5.45996094,1.94335938 6.15820312,1.94335938 L10.4228516,1.94335938 L10.4228516,0.310546875 L5.98632812,0.310546875 C4.41796875,0.310546875 3.39746094,1.29882812 3.39746094,2.80273437 L3.39746094,4.53222656 Z M17.0722656,4.12402344 L18.7050781,4.12402344 L18.7050781,2.80273438 C18.7050781,1.29882812 17.6738281,0.310546875 16.1054688,0.310546875 L11.6796875,0.310546875 L11.6796875,1.94335938 L15.9228516,1.94335938 C16.6318359,1.94335938 17.0722656,2.36230469 17.0722656,3.0390625 L17.0722656,4.12402344 Z M11.8837891,26.1777344 L22.0029297,26.1777344 C23.5712891,26.1777344 24.6025391,25.2001953 24.6025391,23.6962891 L24.6025391,8.08789062 C24.6025391,6.58398438 23.5712891,5.59570312 22.0029297,5.59570312 L11.8837891,5.59570312 C10.3154297,5.59570312 9.29492188,6.58398438 9.29492188,8.08789062 L9.29492188,23.6962891 C9.29492188,25.2001953 10.3154297,26.1777344 11.8837891,26.1777344 Z M3.39746094,9.95703125 L5.01953125,9.95703125 L5.01953125,5.7890625 L3.39746094,5.7890625 L3.39746094,9.95703125 Z M12.0556641,24.5556641 C11.3574219,24.5556641 10.9169922,24.1367188 10.9169922,23.4707031 L10.9169922,8.33496094 C10.9169922,7.64746094 11.3574219,7.22851562 12.0556641,7.22851562 L21.8095703,7.22851562 C22.5292969,7.22851562 22.9697266,7.64746094 22.9697266,8.33496094 L22.9697266,23.4707031 C22.9697266,24.1367188 22.5292969,24.5556641 21.8095703,24.5556641 L12.0556641,24.5556641 Z M12.8935547,10.4296875 L13.6669922,10.4296875 C13.9033203,10.4296875 14.0859375,10.2578125 14.0859375,10.0429688 L14.0859375,9.23730469 C14.0859375,9.01171875 13.9033203,8.85058594 13.6669922,8.85058594 L12.8935547,8.85058594 C12.6894531,8.85058594 12.5068359,9.01171875 12.5068359,9.23730469 L12.5068359,10.0429688 C12.5068359,10.2470703 12.6894531,10.4296875 12.8935547,10.4296875 Z M15.3427734,10.4296875 L16.1269531,10.4296875 C16.3740234,10.4296875 16.5351562,10.2578125 16.5351562,10.0429688 L16.5351562,9.23730469 C16.5351562,9.01171875 16.3740234,8.85058594 16.1269531,8.85058594 L15.3427734,8.85058594 C15.1386719,8.85058594 14.9775391,9.01171875 14.9775391,9.23730469 L14.9775391,10.0429688 C14.9775391,10.2470703 15.1386719,10.4296875 15.3427734,10.4296875 Z M17.7919922,10.4296875 L18.5869141,10.4296875 C18.8017578,10.4296875 18.9736328,10.2578125 18.9736328,10.0429688 L18.9736328,9.23730469 C18.9736328,9.01171875 18.8017578,8.85058594 18.5869141,8.85058594 L17.7919922,8.85058594 C17.5771484,8.85058594 17.4160156,9.01171875 17.4160156,9.23730469 L17.4160156,10.0429688 C17.4160156,10.2470703 17.5771484,10.4296875 17.7919922,10.4296875 Z M20.2412109,10.4296875 L21.0253906,10.4296875 C21.2724609,10.4296875 21.4335938,10.2578125 21.4335938,10.0429688 L21.4335938,9.23730469 C21.4335938,9.01171875 21.2724609,8.85058594 21.0253906,8.85058594 L20.2412109,8.85058594 C20.0371094,8.85058594 19.8652344,9.01171875 19.8652344,9.23730469 L19.8652344,10.0429688 C19.8652344,10.2470703 20.0371094,10.4296875 20.2412109,10.4296875 Z M3.39746094,15.3818359 L5.01953125,15.3818359 L5.01953125,11.2138672 L3.39746094,11.2138672 L3.39746094,15.3818359 Z M12.8935547,12.8251953 L13.6669922,12.8251953 C13.9033203,12.8251953 14.0859375,12.6640625 14.0859375,12.4492188 L14.0859375,11.6328125 C14.0859375,11.4179688 13.9033203,11.2675781 13.6669922,11.2675781 L12.8935547,11.2675781 C12.6894531,11.2675781 12.5068359,11.4287109 12.5068359,11.6328125 L12.5068359,12.4492188 C12.5068359,12.6640625 12.6894531,12.8251953 12.8935547,12.8251953 Z M15.3427734,12.8251953 L16.1269531,12.8251953 C16.3740234,12.8251953 16.5351562,12.6640625 16.5351562,12.4492188 L16.5351562,11.6328125 C16.5351562,11.4179688 16.3740234,11.2675781 16.1269531,11.2675781 L15.3427734,11.2675781 C15.1386719,11.2675781 14.9560547,11.4287109 14.9560547,11.6328125 L14.9560547,12.4492188 C14.9560547,12.6640625 15.1386719,12.8251953 15.3427734,12.8251953 Z M17.7919922,12.8251953 L18.5869141,12.8251953 C18.8017578,12.8251953 18.9736328,12.6640625 18.9736328,12.4599609 L18.9736328,11.6328125 C18.9736328,11.4179688 18.8017578,11.2675781 18.5869141,11.2675781 L17.7919922,11.2675781 C17.5771484,11.2675781 17.4160156,11.4287109 17.4160156,11.6328125 L17.4160156,12.4599609 C17.4160156,12.6640625 17.5771484,12.8251953 17.7919922,12.8251953 Z M20.2412109,12.8251953 L21.0253906,12.8251953 C21.2724609,12.8251953 21.4335938,12.6640625 21.4335938,12.4599609 L21.4335938,11.6328125 C21.4335938,11.4179688 21.2724609,11.2675781 21.0253906,11.2675781 L20.2412109,11.2675781 C20.0371094,11.2675781 19.8652344,11.4287109 19.8652344,11.6328125 L19.8652344,12.4599609 C19.8652344,12.6640625 20.0371094,12.8251953 20.2412109,12.8251953 Z M12.8935547,15.2421875 L13.6669922,15.2421875 C13.9033203,15.2421875 14.0859375,15.0810547 14.0859375,14.8662109 L14.0859375,14.0605469 C14.0859375,13.8457031 13.9033203,13.6630859 13.6669922,13.6630859 L12.8935547,13.6630859 C12.6894531,13.6630859 12.5068359,13.8457031 12.5068359,14.0605469 L12.5068359,14.8662109 C12.5068359,15.0810547 12.6894531,15.2421875 12.8935547,15.2421875 Z M15.3427734,15.2421875 L16.1269531,15.2421875 C16.3740234,15.2421875 16.5351562,15.0810547 16.5351562,14.8662109 L16.5351562,14.0605469 C16.5351562,13.8457031 16.3740234,13.6630859 16.1269531,13.6630859 L15.3427734,13.6630859 C15.1386719,13.6630859 14.9560547,13.8457031 14.9560547,14.0605469 L14.9560547,14.8662109 C14.9560547,15.0810547 15.1386719,15.2421875 15.3427734,15.2421875 Z M5.98632812,20.8925781 L7.82324219,20.8925781 L7.82324219,19.2705078 L6.15820312,19.2705078 C5.45996094,19.2705078 5.01953125,18.8515625 5.01953125,18.1748047 L5.01953125,16.6386719 L3.39746094,16.6386719 L3.39746094,18.4111328 C3.39746094,19.9150391 4.41796875,20.8925781 5.98632812,20.8925781 Z M12.8935547,22.9335938 L13.6669922,22.9335938 C13.9033203,22.9335938 14.0859375,22.7724609 14.0859375,22.546875 L14.0859375,21.7412109 C14.0859375,21.5263672 13.9033203,21.3652344 13.6669922,21.3652344 L12.8935547,21.3652344 C12.6894531,21.3652344 12.5068359,21.5371094 12.5068359,21.7412109 L12.5068359,22.546875 C12.5068359,22.7724609 12.6894531,22.9335938 12.8935547,22.9335938 Z M15.3427734,22.9335938 L16.1269531,22.9335938 C16.3740234,22.9335938 16.5351562,22.7724609 16.5351562,22.546875 L16.5351562,21.7412109 C16.5351562,21.5263672 16.3740234,21.3652344 16.1269531,21.3652344 L15.3427734,21.3652344 C15.1386719,21.3652344 14.9560547,21.5371094 14.9560547,21.7412109 L14.9560547,22.546875 C14.9560547,22.7724609 15.1386719,22.9335938 15.3427734,22.9335938 Z M17.7919922,22.9335938 L18.5869141,22.9335938 C18.8017578,22.9335938 18.9736328,22.7724609 18.9736328,22.546875 L18.9736328,21.7412109 C18.9736328,21.5263672 18.8017578,21.3652344 18.5869141,21.3652344 L17.7919922,21.3652344 C17.5771484,21.3652344 17.4160156,21.5371094 17.4160156,21.7412109 L17.4160156,22.546875 C17.4160156,22.7724609 17.5771484,22.9335938 17.7919922,22.9335938 Z M20.2412109,22.9335938 L21.0253906,22.9335938 C21.2724609,22.9335938 21.4335938,22.7724609 21.4335938,22.546875 L21.4335938,21.7412109 C21.4335938,21.5263672 21.2724609,21.3652344 21.0253906,21.3652344 L20.2412109,21.3652344 C20.0371094,21.3652344 19.8759766,21.5371094 19.8759766,21.7412109 L19.8759766,22.546875 C19.8759766,22.7724609 20.0371094,22.9335938 20.2412109,22.9335938 Z" transform="translate(-2)"/></svg>',
    sfSearch: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.50488281,11.2246094 C2.50488281,15.9511719 6.35058594,19.796875 11.0771484,19.796875 C12.9462891,19.796875 14.6542969,19.1953125 16.0615234,18.1855469 L21.3466797,23.4814453 C21.59375,23.7285156 21.9160156,23.8466797 22.2597656,23.8466797 C22.9902344,23.8466797 23.4951172,23.2988281 23.4951172,22.5791016 C23.4951172,22.2353516 23.3662109,21.9238281 23.140625,21.6982422 L17.8876953,16.4130859 C18.9941406,14.9736328 19.6494141,13.1796875 19.6494141,11.2246094 C19.6494141,6.49804688 15.8037109,2.65234375 11.0771484,2.65234375 C6.35058594,2.65234375 2.50488281,6.49804688 2.50488281,11.2246094 Z M4.34179688,11.2246094 C4.34179688,7.5078125 7.36035156,4.48925781 11.0771484,4.48925781 C14.7939453,4.48925781 17.8125,7.5078125 17.8125,11.2246094 C17.8125,14.9414062 14.7939453,17.9599609 11.0771484,17.9599609 C7.36035156,17.9599609 4.34179688,14.9414062 4.34179688,11.2246094 Z" transform="translate(-1 -1)"/></svg>',
    sfSendFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="currentColor" d="M15.6435547,25.0175781 C16.4169922,25.0175781 16.9648438,24.3515625 17.3623047,23.3203125 L24.3984375,4.94042969 C24.5917969,4.44628906 24.6992188,4.00585938 24.6992188,3.640625 C24.6992188,2.94238281 24.2695312,2.51269531 23.5712891,2.51269531 C23.2060547,2.51269531 22.765625,2.62011719 22.2714844,2.81347656 L3.79492188,9.89257812 C2.89257812,10.2363281 2.19433594,10.7841797 2.19433594,11.5683594 C2.19433594,12.5566406 2.94628906,12.8896484 3.97753906,13.2011719 L9.77832031,14.9628906 C10.4658203,15.1777344 10.8525391,15.15625 11.3144531,14.7265625 L23.0986328,3.71582031 C23.2382812,3.58691406 23.3994141,3.60839844 23.5068359,3.70507812 C23.6142578,3.8125 23.625,3.97363281 23.4960938,4.11328125 L12.5283203,15.9404297 C12.109375,16.3808594 12.0771484,16.7460938 12.28125,17.4658203 L13.9892578,23.1376953 C14.3115234,24.2226562 14.6445312,25.0175781 15.6435547,25.0175781 Z" transform="translate(-2 -1)"/></svg>',
    sfSettings: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.3320312,24.7275391 L14.5019531,24.7275391 C15.3291016,24.7275391 15.9736328,24.2226562 16.15625,23.4277344 L16.6181641,21.4189453 L16.9619141,21.3007812 L18.7128906,22.375 C19.4111328,22.8046875 20.2167969,22.7080078 20.8076172,22.1171875 L22.3115234,20.6240234 C22.9023438,20.0332031 22.9990234,19.2167969 22.5693359,18.5292969 L21.4736328,16.7890625 L21.6025391,16.4667969 L23.6113281,15.9941406 C24.3955078,15.8115234 24.9111328,15.15625 24.9111328,14.3398438 L24.9111328,12.2128906 C24.9111328,11.3964844 24.40625,10.7519531 23.6113281,10.5585938 L21.6240234,10.0751953 L21.484375,9.73144531 L22.5800781,7.99121094 C23.0097656,7.30371094 22.9238281,6.49804688 22.3222656,5.89648438 L20.8183594,4.39257812 C20.2382812,3.8125 19.4326172,3.70507812 18.734375,4.13476562 L16.9833984,5.20898438 L16.6181641,5.06933594 L16.15625,3.06054688 C15.9736328,2.265625 15.3291016,1.76074219 14.5019531,1.76074219 L12.3320312,1.76074219 C11.5048828,1.76074219 10.8603516,2.265625 10.6777344,3.06054688 L10.2050781,5.06933594 L9.83984375,5.20898438 L8.09960938,4.13476562 C7.40136719,3.70507812 6.58496094,3.8125 6.00488281,4.39257812 L4.51171875,5.89648438 C3.91015625,6.49804688 3.81347656,7.30371094 4.25390625,7.99121094 L5.33886719,9.73144531 L5.20996094,10.0751953 L3.22265625,10.5585938 C2.42773438,10.7519531 1.92285156,11.3964844 1.92285156,12.2128906 L1.92285156,14.3398438 C1.92285156,15.15625 2.43847656,15.8115234 3.22265625,15.9941406 L5.23144531,16.4667969 L5.34960938,16.7890625 L4.26464844,18.5292969 C3.82421875,19.2167969 3.93164062,20.0332031 4.52246094,20.6240234 L6.015625,22.1171875 C6.60644531,22.7080078 7.42285156,22.8046875 8.12109375,22.375 L9.86132812,21.3007812 L10.2050781,21.4189453 L10.6777344,23.4277344 C10.8603516,24.2226562 11.5048828,24.7275391 12.3320312,24.7275391 Z M12.5039062,23.0517578 C12.3212891,23.0517578 12.2246094,22.9765625 12.1923828,22.8046875 L11.5478516,20.140625 C10.8925781,19.9794922 10.2802734,19.7216797 9.81835938,19.4316406 L7.4765625,20.8710938 C7.34765625,20.9677734 7.19726562,20.9570312 7.07910156,20.8173828 L5.81152344,19.5498047 C5.69335938,19.4316406 5.68261719,19.3027344 5.76855469,19.1523438 L7.20800781,16.8320312 C6.9609375,16.3808594 6.68164062,15.7685547 6.50976562,15.1132813 L3.84570312,14.4794922 C3.67382812,14.4472656 3.59863281,14.3505859 3.59863281,14.1679688 L3.59863281,12.3740234 C3.59863281,12.1806641 3.66308594,12.0947266 3.84570312,12.0625 L6.49902344,11.4179688 C6.67089844,10.7197266 6.99316406,10.0859375 7.18652344,9.68847656 L5.7578125,7.36816406 C5.66113281,7.20703125 5.671875,7.078125 5.79003906,6.94921875 L7.06835938,5.703125 C7.19726562,5.57421875 7.31542969,5.56347656 7.4765625,5.64941406 L9.796875,7.05664062 C10.2587891,6.79882812 10.9140625,6.53027344 11.5585938,6.34765625 L12.1923828,3.68359375 C12.2246094,3.51171875 12.3212891,3.43652344 12.5039062,3.43652344 L14.3300781,3.43652344 C14.5126953,3.43652344 14.609375,3.51171875 14.6308594,3.68359375 L15.2861328,6.36914062 C15.9521484,6.54101562 16.5322266,6.80957031 17.015625,7.06738281 L19.3466797,5.64941406 C19.5185547,5.56347656 19.6259766,5.57421875 19.765625,5.703125 L21.0332031,6.94921875 C21.1621094,7.078125 21.1621094,7.20703125 21.0654297,7.36816406 L19.6367188,9.68847656 C19.8408203,10.0859375 20.1523438,10.7197266 20.3242188,11.4179688 L22.9882812,12.0625 C23.1601562,12.0947266 23.2353516,12.1806641 23.2353516,12.3740234 L23.2353516,14.1679688 C23.2353516,14.3505859 23.1494141,14.4472656 22.9882812,14.4794922 L20.3134766,15.1132813 C20.1416016,15.7685547 19.8730469,16.3808594 19.6152344,16.8320312 L21.0546875,19.1523438 C21.140625,19.3027344 21.140625,19.4316406 21.0117188,19.5498047 L19.7548828,20.8173828 C19.6259766,20.9570312 19.4863281,20.9677734 19.3466797,20.8710938 L17.0048828,19.4316406 C16.5429688,19.7216797 15.9414062,19.9794922 15.2861328,20.140625 L14.6308594,22.8046875 C14.609375,22.9765625 14.5126953,23.0517578 14.3300781,23.0517578 L12.5039062,23.0517578 Z M13.4169922,17.3369141 C15.6835938,17.3369141 17.5097656,15.5107422 17.5097656,13.2441406 C17.5097656,10.9775391 15.6835938,9.15136719 13.4169922,9.15136719 C11.1503906,9.15136719 9.32421875,10.9775391 9.32421875,13.2441406 C9.32421875,15.5107422 11.1503906,17.3369141 13.4169922,17.3369141 Z M13.4169922,15.671875 C12.0742188,15.671875 10.9892578,14.5869141 10.9892578,13.2441406 C10.9892578,11.9013672 12.0742188,10.8164062 13.4169922,10.8164062 C14.7597656,10.8164062 15.8447266,11.9013672 15.8447266,13.2441406 C15.8447266,14.5869141 14.7597656,15.671875 13.4169922,15.671875 Z" transform="translate(-1 -1)"/></svg>',
    sfSettingsFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.1601562,24.4697266 L14.1367188,24.4697266 C14.6953125,24.4697266 15.0927734,24.1367188 15.2216797,23.5888672 L15.7802734,21.2255859 C16.1992188,21.0859375 16.6074219,20.9248047 16.9619141,20.7529297 L19.0351562,22.0205078 C19.4970703,22.3105469 20.0234375,22.2675781 20.4101562,21.8808594 L21.7958984,20.5058594 C22.1826172,20.1191406 22.2363281,19.5605469 21.9248047,19.0986328 L20.6572266,17.046875 C20.8398438,16.6708984 21.0009766,16.2841797 21.1191406,15.8974609 L23.5039062,15.328125 C24.0517578,15.1992188 24.3740234,14.8017578 24.3740234,14.2431641 L24.3740234,12.2988281 C24.3740234,11.7509766 24.0517578,11.3535156 23.5039062,11.2246094 L21.140625,10.6552734 C21.0009766,10.2148438 20.8291016,9.81738281 20.6787109,9.484375 L21.9462891,7.40039062 C22.2363281,6.92773438 22.2148438,6.42285156 21.8173828,6.02539062 L20.4101562,4.63964844 C20.0126953,4.27441406 19.5292969,4.18847656 19.0673828,4.47851562 L16.9619141,5.77832031 C16.6181641,5.59570312 16.2207031,5.43457031 15.7802734,5.29492188 L15.2216797,2.89941406 C15.0927734,2.3515625 14.6953125,2.01855469 14.1367188,2.01855469 L12.1601562,2.01855469 C11.6015625,2.01855469 11.2041016,2.3515625 11.0644531,2.89941406 L10.5058594,5.2734375 C10.0869141,5.41308594 9.67871094,5.57421875 9.31347656,5.76757812 L7.22949219,4.47851562 C6.76757812,4.18847656 6.26269531,4.25292969 5.87597656,4.63964844 L4.47949219,6.02539062 C4.08203125,6.42285156 4.04980469,6.92773438 4.35058594,7.40039062 L5.60742188,9.484375 C5.46777344,9.81738281 5.29589844,10.2148438 5.15625,10.6552734 L2.79296875,11.2246094 C2.24511719,11.3535156 1.92285156,11.7509766 1.92285156,12.2988281 L1.92285156,14.2431641 C1.92285156,14.8017578 2.24511719,15.1992188 2.79296875,15.328125 L5.17773438,15.8974609 C5.29589844,16.2841797 5.45703125,16.6708984 5.62890625,17.046875 L4.37207031,19.0986328 C4.04980469,19.5605469 4.11425781,20.1191406 4.50097656,20.5058594 L5.87597656,21.8808594 C6.26269531,22.2675781 6.79980469,22.3105469 7.26171875,22.0205078 L9.32421875,20.7529297 C9.68945312,20.9248047 10.0869141,21.0859375 10.5058594,21.2255859 L11.0644531,23.5888672 C11.2041016,24.1367188 11.6015625,24.4697266 12.1601562,24.4697266 Z M13.1484375,17.0361328 C11.0537109,17.0361328 9.35644531,15.3388672 9.35644531,13.2441406 C9.35644531,11.1494141 11.0537109,9.45214844 13.1484375,9.45214844 C15.2431641,9.45214844 16.9404297,11.1494141 16.9404297,13.2441406 C16.9404297,15.3388672 15.2431641,17.0361328 13.1484375,17.0361328 Z" transform="translate(-1 -1)"/></svg>',
    sfShare: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"><path fill="currentColor" d="M12.9946289,16.3486328 C13.456543,16.3486328 13.8540039,15.9726562 13.8540039,15.5214844 L13.8540039,4.5859375 L13.7788086,2.97460938 L14.3911133,3.61914062 L16.0454102,5.39160156 C16.1958008,5.56347656 16.4213867,5.64941406 16.6254883,5.64941406 C17.0766602,5.64941406 17.409668,5.32714844 17.409668,4.89746094 C17.409668,4.66113281 17.3237305,4.48925781 17.1625977,4.328125 L13.6176758,0.912109375 C13.402832,0.697265625 13.2202148,0.6328125 12.9946289,0.6328125 C12.7797852,0.6328125 12.597168,0.697265625 12.371582,0.912109375 L8.83740234,4.328125 C8.67626953,4.48925781 8.57958984,4.66113281 8.57958984,4.89746094 C8.57958984,5.32714844 8.90185547,5.64941406 9.35302734,5.64941406 C9.55712891,5.64941406 9.79345703,5.56347656 9.94384766,5.39160156 L11.6088867,3.61914062 L12.2211914,2.96386719 L12.1459961,4.5859375 L12.1459961,15.5214844 C12.1459961,15.9726562 12.5327148,16.3486328 12.9946289,16.3486328 Z M7.95654297,24.7597656 L18.0327148,24.7597656 C20.9223633,24.7597656 22.5336914,23.1484375 22.5336914,20.2695312 L22.5336914,11.9980469 C22.5336914,9.10839844 20.9223633,7.5078125 18.0327148,7.5078125 L15.862793,7.5078125 L15.862793,9.23730469 L18.0327148,9.23730469 C19.8051758,9.23730469 20.8041992,10.2255859 20.8041992,11.9980469 L20.8041992,20.2695312 C20.8041992,22.0419922 19.8051758,23.0302734 18.0327148,23.0302734 L7.95654297,23.0302734 C6.19482422,23.0302734 5.19580078,22.0419922 5.19580078,20.2695312 L5.19580078,11.9980469 C5.19580078,10.2255859 6.19482422,9.23730469 7.95654297,9.23730469 L10.1264648,9.23730469 L10.1264648,7.5078125 L7.95654297,7.5078125 C5.06689453,7.5078125 3.46630859,9.10839844 3.46630859,11.9980469 L3.46630859,20.2695312 C3.46630859,23.1484375 5.06689453,24.7597656 7.95654297,24.7597656 Z" transform="translate(-1)"/></svg>',
    sfUpload: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 25"><path fill="currentColor" d="M18.8574219,18.0136719 L18.8574219,19.7431641 L24.2285156,19.7431641 C27.5263672,19.7431641 29.5029297,17.7558594 29.5029297,15.15625 C29.5029297,12.9863281 28.203125,11.203125 26.1083984,10.3544922 C26.1298828,5.56347656 22.6816406,2.10449219 18.2880859,2.10449219 C15.3769531,2.10449219 13.3037109,3.66210938 12.0146484,5.54199219 C9.57617188,4.88671875 6.49316406,6.77734375 6.43945312,9.79589844 C4.01171875,10.171875 2.49707031,12.1591797 2.49707031,14.6943359 C2.49707031,17.4873047 4.59179688,19.7431641 8.11523438,19.7431641 L13.2392578,19.7431641 L13.2392578,18.0136719 L8.10449219,18.0136719 C5.55859375,18.0136719 4.2265625,16.5419922 4.2265625,14.6943359 C4.2265625,12.6425781 5.52636719,11.1171875 7.80371094,11.1171875 C7.95410156,11.1171875 8.0078125,11.03125 8.0078125,10.8916016 C8.0078125,7.59375 10.3818359,6.68066406 12.5947266,7.32519531 C12.7236328,7.36816406 12.7988281,7.34667969 12.8632812,7.22851562 C13.9052734,5.37011719 15.5058594,3.83398438 18.2880859,3.83398438 C21.8115234,3.83398438 24.25,6.62695312 24.4326172,9.828125 C24.4648438,10.3115234 24.4326172,10.8916016 24.3896484,11.3964844 C24.3789062,11.5361328 24.4326172,11.6220703 24.5615234,11.6435547 C26.5166016,12.0732422 27.7734375,13.2978516 27.7734375,15.15625 C27.7734375,16.8105469 26.5703125,18.0136719 24.2177734,18.0136719 L18.8574219,18.0136719 Z M12.4013672,15.0166016 C12.6162109,15.0166016 12.8417969,14.9306641 12.9921875,14.7587891 L14.6572266,12.9863281 L15.2695312,12.3417969 L15.1943359,13.953125 L15.1943359,24.5019531 C15.1943359,24.953125 15.5917969,25.3291016 16.0537109,25.3291016 C16.515625,25.3291016 16.9023438,24.953125 16.9023438,24.5019531 L16.9023438,13.953125 L16.8271484,12.3417969 L17.4394531,12.9863281 L19.09375,14.7587891 C19.2548828,14.9306641 19.4697266,15.0166016 19.6845703,15.0166016 C20.125,15.0166016 20.46875,14.6943359 20.46875,14.2646484 C20.46875,14.0283203 20.3720703,13.8564453 20.2109375,13.6953125 L16.6660156,10.2792969 C16.4511719,10.0644531 16.2685547,10 16.0537109,10 C15.828125,10 15.6455078,10.0644531 15.4306641,10.2792969 L11.8857422,13.6953125 C11.7246094,13.8564453 11.6279297,14.0283203 11.6279297,14.2646484 C11.6279297,14.6943359 11.9501953,15.0166016 12.4013672,15.0166016 Z" transform="translate(-2 -1)"/></svg>',
    sfZoomIn: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.47070312,11.2246094 C2.47070312,15.9511719 6.31640625,19.796875 11.0429688,19.796875 C12.9121094,19.796875 14.6201172,19.1953125 16.0273438,18.1855469 L21.3125,23.4814453 C21.5595703,23.7285156 21.8818359,23.8466797 22.2255859,23.8466797 C22.9560547,23.8466797 23.4609375,23.2988281 23.4609375,22.5791016 C23.4609375,22.2353516 23.3320312,21.9238281 23.1064453,21.6982422 L17.8535156,16.4130859 C18.9599609,14.9736328 19.6152344,13.1796875 19.6152344,11.2246094 C19.6152344,6.49804688 15.7695312,2.65234375 11.0429688,2.65234375 C6.31640625,2.65234375 2.47070312,6.49804688 2.47070312,11.2246094 Z M4.30761719,11.2246094 C4.30761719,7.5078125 7.32617188,4.48925781 11.0429688,4.48925781 C14.7597656,4.48925781 17.7783203,7.5078125 17.7783203,11.2246094 C17.7783203,14.9414062 14.7597656,17.9599609 11.0429688,17.9599609 C7.32617188,17.9599609 4.30761719,14.9414062 4.30761719,11.2246094 Z M8.28222656,12.0087891 L10.2587891,12.0087891 L10.2587891,13.9853516 C10.2587891,14.4257812 10.6025391,14.7695312 11.0429688,14.7695312 C11.4833984,14.7695312 11.8378906,14.4257812 11.8378906,13.9853516 L11.8378906,12.0087891 L13.8037109,12.0087891 C14.2441406,12.0087891 14.5878906,11.6650391 14.5878906,11.2246094 C14.5878906,10.7841797 14.2441406,10.4296875 13.8037109,10.4296875 L11.8378906,10.4296875 L11.8378906,8.46386719 C11.8378906,8.0234375 11.4833984,7.6796875 11.0429688,7.6796875 C10.6025391,7.6796875 10.2587891,8.0234375 10.2587891,8.46386719 L10.2587891,10.4296875 L8.28222656,10.4296875 C7.84179688,10.4296875 7.49804688,10.7841797 7.49804688,11.2246094 C7.49804688,11.6650391 7.84179688,12.0087891 8.28222656,12.0087891 Z" transform="translate(-1 -1)"/></svg>',
    sfZoomOut: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.47070312,11.2246094 C2.47070312,15.9511719 6.31640625,19.796875 11.0429688,19.796875 C12.9121094,19.796875 14.6201172,19.1953125 16.0273438,18.1855469 L21.3125,23.4814453 C21.5595703,23.7285156 21.8818359,23.8466797 22.2255859,23.8466797 C22.9560547,23.8466797 23.4609375,23.2988281 23.4609375,22.5791016 C23.4609375,22.2353516 23.3320312,21.9238281 23.1064453,21.6982422 L17.8535156,16.4130859 C18.9599609,14.9736328 19.6152344,13.1796875 19.6152344,11.2246094 C19.6152344,6.49804688 15.7695312,2.65234375 11.0429688,2.65234375 C6.31640625,2.65234375 2.47070312,6.49804688 2.47070312,11.2246094 Z M4.30761719,11.2246094 C4.30761719,7.5078125 7.32617188,4.48925781 11.0429688,4.48925781 C14.7597656,4.48925781 17.7783203,7.5078125 17.7783203,11.2246094 C17.7783203,14.9414062 14.7597656,17.9599609 11.0429688,17.9599609 C7.32617188,17.9599609 4.30761719,14.9414062 4.30761719,11.2246094 Z M8.28222656,12.0087891 L13.8037109,12.0087891 C14.2333984,12.0087891 14.5878906,11.6542969 14.5878906,11.2246094 C14.5878906,10.7949219 14.2333984,10.4296875 13.8037109,10.4296875 L8.28222656,10.4296875 C7.85253906,10.4296875 7.48730469,10.7949219 7.48730469,11.2246094 C7.48730469,11.6542969 7.85253906,12.0087891 8.28222656,12.0087891 Z" transform="translate(-1 -1)"/></svg>',
    support: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M15,22.9121094 C22.21875,22.9121094 27.4931641,18.5078125 27.4931641,12.4492188 C27.4931641,6.36914062 22.2080078,1.99707031 15,1.99707031 C7.78125,1.99707031 2.50683594,6.36914062 2.50683594,12.4492188 C2.50683594,14.4580078 3.09765625,16.3271484 4.12890625,17.8417969 C4.63378906,18.59375 4.81640625,19.1201172 4.81640625,19.5605469 C4.81640625,20.1298828 4.64453125,20.5917969 4.15039062,21.0214844 C3.30175781,21.7412109 3.7421875,22.9121094 4.859375,22.9121094 C6.20214844,22.9121094 7.6953125,22.4501953 8.80175781,21.6875 C10.6171875,22.4824219 12.7333984,22.9121094 15,22.9121094 Z M15,21.1826172 C12.9482422,21.1826172 11.1113281,20.7958984 9.55371094,20.0976562 C8.86621094,19.796875 8.37207031,19.8828125 7.71679688,20.2695312 C7.25488281,20.5595703 6.71777344,20.8066406 6.16992188,20.9248047 C6.39550781,20.5488281 6.54589844,20.1191406 6.54589844,19.5605469 C6.54589844,18.765625 6.25585938,17.8955078 5.56835938,16.8642578 C4.70898438,15.6181641 4.23632812,14.1035156 4.23632812,12.4492188 C4.23632812,7.41113281 8.68359375,3.7265625 15,3.7265625 C21.3164062,3.7265625 25.7636719,7.41113281 25.7636719,12.4492188 C25.7636719,17.4873047 21.3164062,21.1826172 15,21.1826172 Z M14.7851562,14.6728516 C15.3222656,14.6728516 15.6445312,14.3291016 15.6445312,13.9101562 L15.6445312,13.78125 C15.6445312,13.1689453 15.9990234,12.7929688 16.7509766,12.2988281 C17.7929688,11.6113281 18.5341797,10.9775391 18.5341797,9.69921875 C18.5341797,7.91601562 16.9443359,6.94921875 15.1181641,6.94921875 C13.2705078,6.94921875 12.0566406,7.83007812 11.7558594,8.81835938 C11.7021484,8.99023438 11.6699219,9.16210938 11.6699219,9.34472656 C11.6699219,9.828125 12.0458984,10.0859375 12.4111328,10.0859375 C12.7763672,10.0859375 13.0019531,9.9140625 13.1953125,9.65625 L13.3886719,9.3984375 C13.7646484,8.77539062 14.3339844,8.41015625 15.0429688,8.41015625 C16.03125,8.41015625 16.6650391,8.96875 16.6650391,9.78515625 C16.6650391,10.515625 16.2138672,10.8701172 15.2685547,11.5253906 C14.5058594,12.0625 13.9257812,12.6318359 13.9257812,13.6845703 L13.9257812,13.8242188 C13.9257812,14.3828125 14.2265625,14.6728516 14.7851562,14.6728516 Z M14.7529297,17.8740234 C15.3759766,17.8740234 15.9130859,17.3798828 15.9130859,16.7568359 C15.9130859,16.1337891 15.3867188,15.6396484 14.7529297,15.6396484 C14.1298828,15.6396484 13.6035156,16.1445312 13.6035156,16.7568359 C13.6035156,17.3691406 14.140625,17.8740234 14.7529297,17.8740234 Z" transform="translate(-2 -1)"/></svg>',
    syncOvalFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.20703125 18.9277344,2.28710938 12.8798828,2.28710938 C6.84277344,2.28710938 1.92285156,7.20703125 1.92285156,13.2441406 C1.92285156,19.2919922 6.84277344,24.2011719 12.8798828,24.2011719 Z M20.2490234,12.2558594 C20.7646484,12.2558594 20.8720703,12.75 20.5927734,13.1474609 L18.8203125,15.6396484 C18.4980469,16.0908203 17.9824219,16.0478516 17.6923828,15.6396484 L15.8876953,13.1474609 C15.6083984,12.75 15.7265625,12.2558594 16.2314453,12.2558594 L17.2197266,12.2558594 C16.7792969,10.2578125 15.0068359,8.78613281 12.8798828,8.78613281 C11.8164062,8.78613281 10.8925781,9.16210938 10.1513672,9.73144531 C9.59277344,10.1289062 9.07714844,10.0107422 8.83007812,9.67773438 C8.55078125,9.33398438 8.57226562,8.74316406 9.12011719,8.32421875 C10.0761719,7.55078125 11.4189453,7.03515625 12.8798828,7.03515625 C15.9736328,7.03515625 18.5410156,9.30175781 19.0029297,12.2558594 L20.2490234,12.2558594 Z M5.51074219,14.2431641 C5.00585937,14.2431641 4.88769531,13.7382812 5.16699219,13.3515625 L6.93945312,10.8486328 C7.26171875,10.3974609 7.77734375,10.4404297 8.06738281,10.8486328 L9.87207031,13.3515625 C10.1513672,13.7382812 10.0332031,14.2431641 9.52832031,14.2431641 L8.54003906,14.2431641 C8.98046875,16.2304688 10.7529297,17.7021484 12.8798828,17.7021484 C13.9433594,17.7021484 14.8671875,17.3369141 15.6083984,16.7568359 C16.1669922,16.3701172 16.6826172,16.4882812 16.9296875,16.8105469 C17.2089844,17.1650391 17.1875,17.7451172 16.6396484,18.1748047 C15.6835938,18.9375 14.3408203,19.453125 12.8798828,19.453125 C9.78613281,19.453125 7.21875,17.1865234 6.75683594,14.2431641 L5.51074219,14.2431641 Z" transform="translate(-1 -1)"/></svg>',
    target: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27"><path fill="currentColor" d="M2.7109375,14.0283203 L4.89160156,14.0283203 C5.26757812,19.0019531 9.25292969,22.9765625 14.2373047,23.3525391 L14.2373047,25.5439453 C14.2373047,25.9736328 14.5703125,26.3173828 15,26.3173828 C15.4404297,26.3173828 15.7734375,25.9736328 15.7734375,25.5439453 L15.7734375,23.3525391 C20.7470703,22.9765625 24.7324219,19.0019531 25.1191406,14.0283203 L27.2890625,14.0283203 C27.71875,14.0283203 28.0625,13.6845703 28.0625,13.2548828 C28.0625,12.8251953 27.71875,12.4921875 27.2890625,12.4921875 L25.1191406,12.4921875 C24.7539062,7.49707031 20.7685547,3.49023438 15.7734375,3.11425781 L15.7734375,0.965820312 C15.7734375,0.536132812 15.4404297,0.192382812 15,0.192382812 C14.5703125,0.192382812 14.2373047,0.536132812 14.2373047,0.965820312 L14.2373047,3.11425781 C9.2421875,3.49023438 5.24609375,7.49707031 4.88085938,12.4921875 L2.7109375,12.4921875 C2.28125,12.4921875 1.9375,12.8251953 1.9375,13.2548828 C1.9375,13.6845703 2.28125,14.0283203 2.7109375,14.0283203 Z M15,9.01171875 C15.4404297,9.01171875 15.7734375,8.66796875 15.7734375,8.23828125 L15.7734375,4.86523438 C19.8125,5.23046875 23.0244141,8.453125 23.3789062,12.4921875 L20.0166016,12.4921875 C19.5869141,12.4921875 19.2431641,12.8251953 19.2431641,13.2548828 C19.2431641,13.6845703 19.5869141,14.0283203 20.0166016,14.0283203 L23.3681641,14.0283203 C23.0029297,18.0458984 19.7910156,21.2470703 15.7734375,21.6015625 L15.7734375,18.2714844 C15.7734375,17.8417969 15.4404297,17.5087891 15,17.5087891 C14.5703125,17.5087891 14.2373047,17.8417969 14.2373047,18.2714844 L14.2373047,21.6015625 C10.2089844,21.2470703 7.0078125,18.0458984 6.63183594,14.0283203 L9.98339844,14.0283203 C10.4130859,14.0283203 10.7568359,13.6845703 10.7568359,13.2548828 C10.7568359,12.8251953 10.4130859,12.4921875 9.98339844,12.4921875 L6.63183594,12.4921875 C6.98632812,8.453125 10.1982422,5.23046875 14.2373047,4.86523438 L14.2373047,8.23828125 C14.2373047,8.66796875 14.5703125,9.01171875 15,9.01171875 Z" transform="translate(-1)"/></svg>',
    undo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M2.84863281,10.4511719 C2.84863281,10.7089844 2.95605469,10.9560547 3.17089844,11.1601562 L9.48730469,17.3583984 C9.66992188,17.5517578 9.94921875,17.6591797 10.1748047,17.6591797 C10.7548828,17.6591797 11.1308594,17.2724609 11.1308594,16.7138672 C11.1308594,16.4345703 11.0341797,16.2304688 10.8730469,16.0585938 L7.76855469,13.0400391 L5.72753906,11.2890625 L8.25195312,11.4072266 L15.6318359,11.4072266 C19.2949219,11.4072266 21.2285156,13.4267578 21.2285156,16.3164062 C21.2285156,19.2167969 19.2949219,21.3652344 15.6318359,21.3652344 L13.1611328,21.3652344 C12.5703125,21.3652344 12.1835938,21.7949219 12.1835938,22.3212891 C12.1835938,22.8476562 12.5703125,23.2773438 13.1611328,23.2773438 L15.6425781,23.2773438 C20.4443359,23.2773438 23.1513672,20.5380859 23.1513672,16.4238281 C23.1513672,12.3203125 20.3691406,9.484375 15.4707031,9.484375 L8.25195312,9.484375 L5.72753906,9.60253906 L7.76855469,7.8515625 L10.8730469,4.83300781 C11.0341797,4.66113281 11.1308594,4.45703125 11.1308594,4.17773438 C11.1308594,3.61914062 10.7548828,3.23242188 10.1748047,3.23242188 C9.94921875,3.23242188 9.66992188,3.33984375 9.48730469,3.53320312 L3.17089844,9.73144531 C2.95605469,9.93554688 2.84863281,10.1826172 2.84863281,10.4511719 Z" transform="translate(-1 -1)"/></svg>',
    upgrade: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2011719 C18.9277344,24.2011719 23.8369141,19.2919922 23.8369141,13.2441406 C23.8369141,7.19628906 18.9277344,2.28710938 12.8798828,2.28710938 C6.83203125,2.28710938 1.92285156,7.19628906 1.92285156,13.2441406 C1.92285156,19.2919922 6.83203125,24.2011719 12.8798828,24.2011719 Z M12.8798828,22.375 C7.83105469,22.375 3.74902344,18.2929688 3.74902344,13.2441406 C3.74902344,8.1953125 7.83105469,4.11328125 12.8798828,4.11328125 C17.9287109,4.11328125 22.0107422,8.1953125 22.0107422,13.2441406 C22.0107422,18.2929688 17.9287109,22.375 12.8798828,22.375 Z M8.20703125,13.0615234 L10.5810547,13.0615234 L10.5810547,17.9169922 C10.5810547,18.7763672 11.0644531,19.2705078 11.8916016,19.2705078 L13.8789062,19.2705078 C14.7060547,19.2705078 15.1894531,18.7763672 15.1894531,17.9169922 L15.1894531,13.0615234 L17.53125,13.0615234 C17.9179688,13.0615234 18.2294922,12.7714844 18.2294922,12.3632812 C18.2294922,12.0839844 18.1113281,11.890625 17.8212891,11.5898438 L13.5136719,6.97070312 C13.2988281,6.74511719 13.0732422,6.66992188 12.8798828,6.66992188 C12.6972656,6.66992188 12.4609375,6.74511719 12.2568359,6.97070312 L7.89550781,11.5898438 C7.6484375,11.8583984 7.53027344,12.0947266 7.53027344,12.3847656 C7.53027344,12.7714844 7.80957031,13.0615234 8.20703125,13.0615234 Z" transform="translate(-1 -1)"/></svg>',
    upgradeFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.8798828,24.2119141 C18.9277344,24.2119141 23.8369141,19.3027344 23.8369141,13.2548828 C23.8369141,7.21777344 18.9277344,2.29785156 12.8798828,2.29785156 C6.84277344,2.29785156 1.92285156,7.21777344 1.92285156,13.2548828 C1.92285156,19.3027344 6.84277344,24.2119141 12.8798828,24.2119141 Z M12.8798828,6.48730469 C13.0839844,6.48730469 13.3095703,6.5625 13.5351562,6.79882812 L17.9716797,11.5576172 C18.2724609,11.8798828 18.4013672,12.0625 18.4013672,12.3525391 C18.4013672,12.7822266 18.0683594,13.0830078 17.6708984,13.0830078 L15.2646484,13.0830078 L15.2646484,18.0888672 C15.2646484,18.9697266 14.7597656,19.4746094 13.9111328,19.4746094 L11.859375,19.4746094 C11.0107422,19.4746094 10.5058594,18.9697266 10.5058594,18.0888672 L10.5058594,13.0830078 L8.06738281,13.0830078 C7.6484375,13.0830078 7.35839844,12.7822266 7.35839844,12.3740234 C7.35839844,12.0732422 7.48730469,11.8476562 7.74511719,11.5576172 L12.2353516,6.79882812 C12.4501953,6.5625 12.6865234,6.48730469 12.8798828,6.48730469 Z" transform="translate(-1 -1)"/></svg>',
    x: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.2392578,20.140625 L13.3642578,13.2548828 L20.2392578,6.37988281 C20.6044922,6.01464844 20.6152344,5.39160156 20.2392578,5.02636719 C19.8632812,4.65039062 19.2509766,4.63964844 18.875,5.02636719 L12,11.9013672 L5.125,5.02636719 C4.75976562,4.65039062 4.12597656,4.63964844 3.76074219,5.02636719 C3.39550781,5.40234375 3.39550781,6.01464844 3.76074219,6.37988281 L10.6357422,13.2548828 L3.76074219,20.140625 C3.39550781,20.5058594 3.38476562,21.1289062 3.76074219,21.4941406 C4.13671875,21.859375 4.75976562,21.859375 5.125,21.4941406 L12,14.6191406 L18.875,21.4941406 C19.2402344,21.859375 19.8740234,21.8701172 20.2392578,21.4941406 C20.6044922,21.1181641 20.6044922,20.5058594 20.2392578,20.140625 Z" transform="translate(0 -1)"/></svg>',
    xCircle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.2919922 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.95214844,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.2919922 6.95214844,24.2011719 13,24.2011719 Z M13,22.375 C7.95117188,22.375 3.86914062,18.2929688 3.86914062,13.2441406 C3.86914062,8.1953125 7.95117188,4.11328125 13,4.11328125 C18.0488281,4.11328125 22.1308594,8.1953125 22.1308594,13.2441406 C22.1308594,18.2929688 18.0488281,22.375 13,22.375 Z M9.94921875,17.5195312 L13,14.46875 L16.0507812,17.5195312 C16.2119141,17.6806641 16.4160156,17.7880859 16.6630859,17.7880859 C17.1357422,17.7880859 17.5224609,17.4013672 17.5224609,16.9179688 C17.5224609,16.6708984 17.4365234,16.4775391 17.2646484,16.3056641 L14.203125,13.2548828 L17.2646484,10.1933594 C17.4365234,10.0322266 17.5224609,9.828125 17.5224609,9.59179688 C17.5224609,9.11914062 17.1357422,8.74316406 16.6630859,8.74316406 C16.4267578,8.74316406 16.2333984,8.82910156 16.0722656,9.00097656 L13,12.0625 L9.92773438,9.00097656 C9.76660156,8.82910156 9.5625,8.74316406 9.32617188,8.74316406 C8.85351562,8.74316406 8.46679688,9.11914062 8.46679688,9.59179688 C8.46679688,9.828125 8.56347656,10.0322266 8.72460938,10.1933594 L11.7861328,13.2548828 L8.72460938,16.3056641 C8.56347656,16.4775391 8.46679688,16.6708984 8.46679688,16.9179688 C8.46679688,17.4013672 8.85351562,17.7880859 9.32617188,17.7880859 C9.58398438,17.7880859 9.78808594,17.6806641 9.94921875,17.5195312 Z" transform="translate(-1 -1)"/></svg>',
    xCircleFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13,24.2011719 C19.0478516,24.2011719 23.9570312,19.28125 23.9570312,13.2441406 C23.9570312,7.19628906 19.0478516,2.28710938 13,2.28710938 C6.96289062,2.28710938 2.04296875,7.19628906 2.04296875,13.2441406 C2.04296875,19.28125 6.96289062,24.2011719 13,24.2011719 Z M9.390625,17.7558594 C8.89648438,17.7558594 8.50976562,17.3583984 8.50976562,16.8642578 C8.50976562,16.6279297 8.59570312,16.4023438 8.76757812,16.2412109 L11.7431641,13.2548828 L8.76757812,10.2792969 C8.59570312,10.1074219 8.50976562,9.89257812 8.50976562,9.65625 C8.50976562,9.15136719 8.89648438,8.77539062 9.390625,8.77539062 C9.63769531,8.77539062 9.83105469,8.86132812 10.0029297,9.02246094 L13,12.0087891 L16.0185547,9.01171875 C16.2011719,8.82910156 16.3945312,8.75390625 16.6308594,8.75390625 C17.125,8.75390625 17.5224609,9.140625 17.5224609,9.63476562 C17.5224609,9.88183594 17.4472656,10.0751953 17.2539062,10.2685547 L14.2675781,13.2548828 L17.2431641,16.2304688 C17.4257812,16.3916016 17.5117188,16.6171875 17.5117188,16.8642578 C17.5117188,17.3583984 17.1142578,17.7558594 16.609375,17.7558594 C16.3623047,17.7558594 16.1367188,17.6699219 15.9755859,17.4980469 L13,14.5117188 L10.0351562,17.4980469 C9.86328125,17.6699219 9.63769531,17.7558594 9.390625,17.7558594 Z" transform="translate(-1 -1)"/></svg>',
    xRect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M6.50634766,21.4082031 C5.43212891,21.4082031 4.84130859,20.8388672 4.84130859,19.7216797 L4.84130859,6.78808594 C4.84130859,5.67089844 5.43212891,5.09082031 6.50634766,5.09082031 L19.4936523,5.09082031 C20.5571289,5.09082031 21.1586914,5.67089844 21.1586914,6.78808594 L21.1586914,19.7216797 C21.1586914,20.8388672 20.5571289,21.4082031 19.4936523,21.4082031 L6.50634766,21.4082031 Z M9.96533203,17.5195312 L13.0161133,14.46875 L16.0668945,17.5195312 C16.2280273,17.6806641 16.4321289,17.7880859 16.6791992,17.7880859 C17.1625977,17.7880859 17.5385742,17.4013672 17.5385742,16.9179688 C17.5385742,16.6708984 17.4526367,16.4775391 17.2807617,16.3056641 L14.2192383,13.2548828 L17.2807617,10.1933594 C17.4526367,10.0322266 17.5385742,9.828125 17.5385742,9.59179688 C17.5385742,9.11914062 17.1625977,8.74316406 16.6791992,8.74316406 C16.4428711,8.74316406 16.2495117,8.82910156 16.0883789,9.00097656 L13.0161133,12.0625 L9.94384766,9.00097656 C9.78271484,8.82910156 9.57861328,8.74316406 9.34228516,8.74316406 C8.86962891,8.74316406 8.48291016,9.11914062 8.48291016,9.59179688 C8.48291016,9.828125 8.57958984,10.0322266 8.74072266,10.1933594 L11.8022461,13.2548828 L8.74072266,16.3056641 C8.57958984,16.4775391 8.48291016,16.6708984 8.48291016,16.9179688 C8.48291016,17.4013672 8.86962891,17.7880859 9.34228516,17.7880859 C9.60009766,17.7880859 9.80419922,17.6806641 9.96533203,17.5195312 Z" transform="translate(-1 -1)"/></svg>',
    xRectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M6.48486328,23.1376953 L19.5151367,23.1376953 C21.7709961,23.1376953 22.8881836,22.03125 22.8881836,19.8183594 L22.8881836,6.69140625 C22.8881836,4.47851562 21.7709961,3.36132812 19.5151367,3.36132812 L6.48486328,3.36132812 C4.23974609,3.36132812 3.11181641,4.47851562 3.11181641,6.69140625 L3.11181641,19.8183594 C3.11181641,22.03125 4.23974609,23.1376953 6.48486328,23.1376953 Z M9.39599609,17.7558594 C8.90185547,17.7558594 8.51513672,17.3583984 8.51513672,16.8642578 C8.51513672,16.6279297 8.60107422,16.4023438 8.77294922,16.2412109 L11.7485352,13.2548828 L8.77294922,10.2792969 C8.60107422,10.1074219 8.51513672,9.89257812 8.51513672,9.65625 C8.51513672,9.15136719 8.90185547,8.77539062 9.39599609,8.77539062 C9.64306641,8.77539062 9.83642578,8.86132812 10.0083008,9.02246094 L13.0053711,12.0087891 L16.0239258,9.01171875 C16.206543,8.82910156 16.4106445,8.75390625 16.6362305,8.75390625 C17.1303711,8.75390625 17.527832,9.140625 17.527832,9.63476562 C17.527832,9.88183594 17.4526367,10.0751953 17.2700195,10.2685547 L14.2729492,13.2548828 L17.2592773,16.2304688 C17.4311523,16.3916016 17.5170898,16.6171875 17.5170898,16.8642578 C17.5170898,17.3583984 17.1196289,17.7558594 16.6147461,17.7558594 C16.378418,17.7558594 16.1420898,17.6699219 15.980957,17.4980469 L13.0053711,14.5117188 L10.0405273,17.4980469 C9.86865234,17.6699219 9.64306641,17.7558594 9.39599609,17.7558594 Z" transform="translate(-1 -1)"/></svg>',
    news: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M2.73925781,21.515625 C2.73925781,23.6533203 3.80273438,24.7597656 5.98339844,24.7597656 L23.7939453,24.7597656 C26.0498047,24.7597656 27.1669922,23.6533203 27.1669922,21.4404297 L27.1669922,5.05859375 C27.1669922,2.84570313 26.0498047,1.72851562 23.7939453,1.72851562 L10.8496094,1.72851562 C8.60449219,1.72851562 7.4765625,2.84570313 7.4765625,5.05859375 L7.4765625,10.1826172 L4.90917969,10.1826172 C3.54492187,10.1826172 2.73925781,10.9238281 2.73925781,12.2021484 L2.73925781,21.515625 Z M8.84082031,23.0302734 C9.07714844,22.5683594 9.20605469,22.03125 9.20605469,21.4082031 L9.20605469,5.15527344 C9.20605469,4.03808594 9.80761719,3.45800781 10.8818359,3.45800781 L23.7617187,3.45800781 C24.8359375,3.45800781 25.4375,4.03808594 25.4375,5.15527344 L25.4375,21.34375 C25.4375,22.4609375 24.8359375,23.0302734 23.7617187,23.0302734 L8.84082031,23.0302734 Z M11.9990234,8.13085938 L22.6660156,8.13085938 C23.0419922,8.13085938 23.3320312,7.83007812 23.3320312,7.45410156 C23.3320312,7.08886719 23.0419922,6.80957031 22.6660156,6.80957031 L11.9990234,6.80957031 C11.6123047,6.80957031 11.3222656,7.08886719 11.3222656,7.45410156 C11.3222656,7.83007812 11.6123047,8.13085938 11.9990234,8.13085938 Z M11.9990234,11.9121094 L22.6660156,11.9121094 C23.0419922,11.9121094 23.3320312,11.6220703 23.3320312,11.2568359 C23.3320312,10.8808594 23.0419922,10.5908203 22.6660156,10.5908203 L11.9990234,10.5908203 C11.6123047,10.5908203 11.3222656,10.8808594 11.3222656,11.2568359 C11.3222656,11.6220703 11.6123047,11.9121094 11.9990234,11.9121094 Z M4.46875,21.515625 L4.46875,12.5351562 C4.46875,12.1376953 4.70507812,11.9121094 5.10253906,11.9121094 L7.4765625,11.9121094 L7.4765625,21.515625 C7.4765625,22.4072266 6.82128906,23.0302734 5.98339844,23.0302734 C5.13476562,23.0302734 4.46875,22.375 4.46875,21.515625 Z M12.6328125,19.5712891 L15.4150391,19.5712891 C16.2314453,19.5712891 16.7255859,19.0771484 16.7255859,18.2607422 L16.7255859,15.7041016 C16.7255859,14.8769531 16.2314453,14.3828125 15.4150391,14.3828125 L12.6328125,14.3828125 C11.8056641,14.3828125 11.3115234,14.8769531 11.3115234,15.7041016 L11.3115234,18.2607422 C11.3115234,19.0771484 11.8056641,19.5712891 12.6328125,19.5712891 Z M18.6591797,15.7041016 L22.6552734,15.7041016 C23.0419922,15.7041016 23.3212891,15.4248047 23.3212891,15.0595703 C23.3212891,14.6728516 23.0419922,14.3828125 22.6552734,14.3828125 L18.6591797,14.3828125 C18.2724609,14.3828125 17.9931641,14.6728516 17.9931641,15.0595703 C17.9931641,15.4248047 18.2724609,15.7041016 18.6591797,15.7041016 Z M18.6591797,19.5712891 L22.6552734,19.5712891 C23.0419922,19.5712891 23.3212891,19.2919922 23.3212891,18.9267578 C23.3212891,18.5507812 23.0419922,18.25 22.6552734,18.25 L18.6591797,18.25 C18.2724609,18.25 17.9931641,18.5507812 17.9931641,18.9267578 C17.9931641,19.2919922 18.2724609,19.5712891 18.6591797,19.5712891 Z" transform="translate(-2 -1)"/></svg>',
    arrowsDiagonal: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9.60758414,13.4331784 L6.83365836,13.4795651 L4.44938102,13.665112 L6.13785758,12.1992917 L14.9049474,3.42292451 C15.2389318,3.08894014 15.2482091,2.59724092 14.9049474,2.2539792 C14.5616857,1.91071748 14.0607091,1.91999482 13.7267248,2.2539792 L4.95963493,11.021069 L3.49381461,12.6817136 L3.67936149,10.3159909 L3.72574821,7.53278779 C3.72574821,7.31940889 3.65152946,7.13386201 3.48453727,6.96686982 C3.14127555,6.6236081 2.66813102,6.6236081 2.31559196,6.96686982 C2.16715446,7.11530732 2.07438102,7.35651826 2.07438102,7.57917451 L2.00016227,14.2774167 C1.99088493,14.7876706 2.38053336,15.1680417 2.88150993,15.1587644 L9.57047477,15.0752683 C9.80240836,15.0752683 10.0436193,14.9824948 10.1920568,14.8433347 C10.5353185,14.4815183 10.5353185,14.0176511 10.1920568,13.6743894 C10.0250646,13.4981198 9.83951774,13.4331784 9.60758414,13.4331784 Z M21.0558263,17.255444 C21.0558263,17.4781003 21.1300451,17.6543698 21.2970373,17.8306394 C21.640299,18.1739011 22.1134435,18.1739011 22.4659826,17.8306394 C22.6051427,17.6822019 22.6979162,17.4409909 22.6979162,17.2090573 L22.7814123,10.5200925 C22.7906896,10.0098386 22.4195959,9.62946748 21.9000646,9.63874482 L15.2110998,9.71296357 C14.9791662,9.71296357 14.7379552,9.80573701 14.5895177,9.95417451 C14.246256,10.3067136 14.246256,10.7798581 14.5895177,11.1231198 C14.7565099,11.290112 14.9420568,11.3643308 15.1739904,11.3643308 L17.9386388,11.317944 L20.3136388,11.1231198 L18.643717,12.5982175 L9.87662711,21.3653073 C9.54264274,21.6992917 9.53336539,22.2002683 9.87662711,22.54353 C10.2198888,22.8775144 10.7208654,22.8775144 11.0548498,22.54353 L19.8219396,13.7764401 L21.2877599,12.0879636 L21.1022131,14.4722409 L21.0558263,17.255444 Z"/></svg>',
    sfPlus: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.95605469,12.8183594 L10.90625,12.8183594 L10.90625,19.7685547 C10.90625,20.2841797 11.3359375,20.7246094 11.8623047,20.7246094 C12.3886719,20.7246094 12.8291016,20.2841797 12.8291016,19.7685547 L12.8291016,12.8183594 L19.7685547,12.8183594 C20.2841797,12.8183594 20.7246094,12.3886719 20.7246094,11.8623047 C20.7246094,11.3359375 20.2841797,10.8955078 19.7685547,10.8955078 L12.8291016,10.8955078 L12.8291016,3.95605469 C12.8291016,3.44042969 12.3886719,3 11.8623047,3 C11.3359375,3 10.90625,3.44042969 10.90625,3.95605469 L10.90625,10.8955078 L3.95605469,10.8955078 C3.44042969,10.8955078 3,11.3359375 3,11.8623047 C3,12.3886719 3.44042969,12.8183594 3.95605469,12.8183594 Z"/></svg>',
    sfRefresh: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.4853516,23.0742188 C17.7275391,23.0742188 21.9707031,18.8310547 21.9707031,13.578125 C21.9707031,13.1054688 21.5839844,12.71875 21.1113281,12.71875 C20.6386719,12.71875 20.2412109,13.1054688 20.2412109,13.578125 C20.2412109,17.8642578 16.7714844,21.3339844 12.4853516,21.3339844 C8.19921875,21.3339844 4.72949219,17.8642578 4.72949219,13.578125 C4.72949219,9.29199219 8.19921875,5.82226562 12.4853516,5.82226562 C13.2373047,5.82226562 13.9677734,5.9296875 14.6552734,6.13378906 L11.4970703,9.27050781 C11.3144531,9.43164062 11.25,9.64648438 11.25,9.87207031 C11.25,10.3662109 11.6152344,10.7421875 12.0878906,10.7421875 C12.3564453,10.7421875 12.5498047,10.6455078 12.7109375,10.4951172 L17.1367188,6.04785156 C17.3300781,5.85449219 17.4160156,5.63964844 17.4160156,5.40332031 C17.4160156,5.16699219 17.3193359,4.93066406 17.1367188,4.75878906 L12.7216797,0.268554688 C12.5498047,0.107421875 12.3564453,0 12.0878906,0 C11.6152344,0 11.25,0.397460938 11.25,0.880859375 C11.25,1.10644531 11.3144531,1.34277344 11.4863281,1.50390625 L14.2792969,4.27539062 C13.6992188,4.16796875 13.0976562,4.10351562 12.4853516,4.10351562 C7.24316406,4.10351562 3,8.34667969 3,13.5888672 C3,18.8310547 7.24316406,23.0742188 12.4853516,23.0742188 Z"/></svg>',
    sfRefreshCircle: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.9570312,22.9140625 C18.0048828,22.9140625 22.9140625,18.0048828 22.9140625,11.9570312 C22.9140625,5.90917969 18.0048828,1 11.9570312,1 C5.90917969,1 1,5.90917969 1,11.9570312 C1,18.0048828 5.90917969,22.9140625 11.9570312,22.9140625 Z M11.9570312,21.0878906 C6.90820312,21.0878906 2.82617188,17.0058594 2.82617188,11.9570312 C2.82617188,6.90820312 6.90820312,2.82617188 11.9570312,2.82617188 C17.0058594,2.82617188 21.0878906,6.90820312 21.0878906,11.9570312 C21.0878906,17.0058594 17.0058594,21.0878906 11.9570312,21.0878906 Z M11.9462891,17.2851562 C14.5996094,17.2851562 16.7373047,15.1367188 16.7373047,12.4833984 C16.7373047,12.0859375 16.3935547,11.7529297 15.9960938,11.7529297 C15.5986328,11.7529297 15.2548828,12.0859375 15.2548828,12.4833984 C15.2548828,14.3203125 13.7832031,15.8027344 11.9462891,15.8027344 C10.109375,15.8027344 8.63769531,14.3310547 8.63769531,12.4833984 C8.63769531,10.6464844 10.109375,9.17480469 11.9462891,9.17480469 C12.0859375,9.17480469 12.2148438,9.17480469 12.34375,9.17480469 L11.2910156,10.2060547 C11.1621094,10.3349609 11.0869141,10.5068359 11.0869141,10.7001953 C11.0869141,11.0761719 11.3876953,11.3769531 11.7636719,11.3769531 C11.9462891,11.3769531 12.1289062,11.2910156 12.2363281,11.1728516 L14.3203125,9.08886719 C14.4492188,8.97070312 14.5136719,8.78808594 14.5136719,8.60546875 C14.5136719,8.42285156 14.4492188,8.24023438 14.3203125,8.12207031 L12.2363281,6.03808594 C12.1396484,5.93066406 11.9462891,5.83398438 11.7636719,5.83398438 C11.3876953,5.83398438 11.0869141,6.13476562 11.0869141,6.51074219 C11.0869141,6.70410156 11.1621094,6.87597656 11.2910156,7.00488281 L12.0429688,7.74609375 C11.9462891,7.73535156 11.8388672,7.73535156 11.7421875,7.73535156 C9.32519531,7.73535156 7.15527344,9.80859375 7.15527344,12.4511719 C7.15527344,15.1367188 9.29296875,17.2851562 11.9462891,17.2851562 Z"/></svg>',
    sfRefreshCircleFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.9570312,22.9140625 C18.0048828,22.9140625 22.9140625,18.0048828 22.9140625,11.9570312 C22.9140625,5.91992188 18.0048828,1 11.9570312,1 C5.91992188,1 1,5.91992188 1,11.9570312 C1,18.0048828 5.91992188,22.9140625 11.9570312,22.9140625 Z M11.9570312,17.4570312 C9.21777344,17.4570312 7.015625,15.2333984 7.015625,12.4619141 C7.015625,9.74414062 9.25,7.60644531 11.7421875,7.60644531 C11.8388672,7.60644531 11.9355469,7.60644531 12.0537109,7.6171875 L11.2802734,6.86523438 C11.1621094,6.73632812 11.0654297,6.55371094 11.0654297,6.33886719 C11.0654297,5.95214844 11.3769531,5.65136719 11.7744141,5.65136719 C11.9570312,5.65136719 12.171875,5.76953125 12.2578125,5.85546875 L14.40625,8.00390625 C14.5458984,8.1328125 14.6103516,8.32617188 14.6103516,8.49804688 C14.6103516,8.69140625 14.5458984,8.87402344 14.40625,9.01367188 L12.2578125,11.1621094 C12.1611328,11.2587891 11.9570312,11.3554688 11.7744141,11.3554688 C11.3769531,11.3554688 11.0654297,11.0546875 11.0654297,10.6679688 C11.0654297,10.453125 11.1513672,10.2919922 11.2802734,10.1416016 L12.3222656,9.12109375 C12.2363281,9.09960938 12.1074219,9.08886719 11.9570312,9.08886719 C10.0664062,9.08886719 8.55175781,10.6035156 8.55175781,12.5048828 C8.55175781,14.40625 10.0664062,15.9316406 11.9570312,15.9316406 C13.8476562,15.9316406 15.3623047,14.40625 15.3623047,12.5048828 C15.3623047,12.0859375 15.7167969,11.7421875 16.1357422,11.7421875 C16.5439453,11.7421875 16.8984375,12.0859375 16.8984375,12.5048828 C16.8984375,15.2333984 14.6962891,17.4570312 11.9570312,17.4570312 Z"/></svg>',
    sfRefreshRect: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.37304688,21.7763672 L18.4033203,21.7763672 C20.6591797,21.7763672 21.7763672,20.6699219 21.7763672,18.4570312 L21.7763672,5.33007812 C21.7763672,3.1171875 20.6591797,2 18.4033203,2 L5.37304688,2 C3.12792969,2 2,3.1171875 2,5.33007812 L2,18.4570312 C2,20.6699219 3.12792969,21.7763672 5.37304688,21.7763672 Z M5.39453125,20.046875 C4.3203125,20.046875 3.72949219,19.4775391 3.72949219,18.3603516 L3.72949219,5.42675781 C3.72949219,4.30957031 4.3203125,3.72949219 5.39453125,3.72949219 L18.3818359,3.72949219 C19.4453125,3.72949219 20.046875,4.30957031 20.046875,5.42675781 L20.046875,18.3603516 C20.046875,19.4775391 19.4453125,20.046875 18.3818359,20.046875 L5.39453125,20.046875 Z M11.8935547,17.2109375 C14.546875,17.2109375 16.6845703,15.0625 16.6845703,12.4091797 C16.6845703,12.0117188 16.3408203,11.6787109 15.9433594,11.6787109 C15.5458984,11.6787109 15.2021484,12.0117188 15.2021484,12.4091797 C15.2021484,14.2460938 13.7304688,15.7285156 11.8935547,15.7285156 C10.0566406,15.7285156 8.58496094,14.2568359 8.58496094,12.4091797 C8.58496094,10.5722656 10.0566406,9.10058594 11.8935547,9.10058594 C12.0332031,9.10058594 12.1621094,9.10058594 12.2910156,9.10058594 L11.2382812,10.1318359 C11.109375,10.2607422 11.0341797,10.4326172 11.0341797,10.6259766 C11.0341797,11.0019531 11.3349609,11.3027344 11.7109375,11.3027344 C11.8935547,11.3027344 12.0761719,11.2167969 12.1835938,11.0986328 L14.2675781,9.01464844 C14.4072266,8.89648438 14.4609375,8.71386719 14.4609375,8.53125 C14.4609375,8.34863281 14.4072266,8.16601562 14.2675781,8.04785156 L12.1835938,5.96386719 C12.0869141,5.85644531 11.8935547,5.75976562 11.7109375,5.75976562 C11.3349609,5.75976562 11.0341797,6.06054688 11.0341797,6.43652344 C11.0341797,6.62988281 11.109375,6.80175781 11.2382812,6.93066406 L11.9902344,7.671875 C11.8935547,7.66113281 11.796875,7.66113281 11.6894531,7.66113281 C9.27246094,7.66113281 7.10253906,9.734375 7.10253906,12.3769531 C7.10253906,15.0625 9.24023438,17.2109375 11.8935547,17.2109375 Z"/></svg>',
    sfRefreshRectFill: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.37304688,21.7763672 L18.4033203,21.7763672 C20.6591797,21.7763672 21.7763672,20.6699219 21.7763672,18.4570312 L21.7763672,5.33007812 C21.7763672,3.1171875 20.6591797,2 18.4033203,2 L5.37304688,2 C3.12792969,2 2,3.1171875 2,5.33007812 L2,18.4570312 C2,20.6699219 3.12792969,21.7763672 5.37304688,21.7763672 Z M11.8935547,17.3828125 C9.15429688,17.3828125 6.95214844,15.1591797 6.95214844,12.3876953 C6.95214844,9.66992188 9.18652344,7.52148438 11.6787109,7.52148438 C11.7753906,7.52148438 11.8720703,7.53222656 11.9902344,7.54296875 L11.2167969,6.78027344 C11.0986328,6.66210938 11.0019531,6.46875 11.0019531,6.26464844 C11.0019531,5.87792969 11.3134766,5.56640625 11.7109375,5.56640625 C11.8935547,5.56640625 12.1083984,5.68457031 12.1943359,5.78125 L14.3427734,7.9296875 C14.4931641,8.04785156 14.546875,8.24121094 14.546875,8.42382812 C14.546875,8.6171875 14.4931641,8.79980469 14.3427734,8.92871094 L12.1943359,11.0771484 C12.0976562,11.1845703 11.8935547,11.28125 11.7109375,11.28125 C11.3134766,11.28125 11.0019531,10.9697266 11.0019531,10.5830078 C11.0019531,10.3789062 11.0878906,10.2070312 11.2167969,10.0673828 L12.2587891,9.046875 C12.1728516,9.02539062 12.0439453,9.01464844 11.8935547,9.01464844 C10.0029297,9.01464844 8.48828125,10.5292969 8.48828125,12.4306641 C8.48828125,14.3320312 10.0029297,15.8466797 11.8935547,15.8466797 C13.7841797,15.8466797 15.2988281,14.3212891 15.2988281,12.4306641 C15.2988281,12.0117188 15.6533203,11.6679688 16.0722656,11.6679688 C16.4804688,11.6679688 16.8349609,12.0117188 16.8349609,12.4306641 C16.8349609,15.1591797 14.6328125,17.3828125 11.8935547,17.3828125 Z"/></svg>',
    arrowCompactLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.6391602,21.1064453 C12.800293,21.5253906 13.1655273,21.7939453 13.5522461,21.7939453 C14.1860352,21.7939453 14.6694336,21.3320312 14.6694336,20.6982422 C14.6694336,20.3759766 14.4868164,19.9570312 14.3793945,19.6777344 L11.4467773,12.2119141 L14.3793945,4.74609375 C14.4868164,4.46679688 14.6694336,4.03710938 14.6694336,3.72558594 C14.6694336,3.10253906 14.1860352,2.640625 13.5522461,2.640625 C13.1655273,2.640625 12.800293,2.8984375 12.6391602,3.31738281 L9.76025391,10.6435547 C9.56689453,11.1376953 9.33056641,11.7392578 9.33056641,12.2119141 C9.33056641,12.6845703 9.56689453,13.2861328 9.76025391,13.7802734 L12.6391602,21.1064453 Z"/></svg>',
    arrowCompactRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.3608398,21.1064453 L14.2397461,13.7802734 C14.4331055,13.2861328 14.6694336,12.6845703 14.6694336,12.2119141 C14.6694336,11.7392578 14.4331055,11.1376953 14.2397461,10.6435547 L11.3608398,3.31738281 C11.199707,2.8984375 10.8344727,2.640625 10.4370117,2.640625 C9.80322266,2.640625 9.33056641,3.10253906 9.33056641,3.72558594 C9.33056641,4.03710938 9.51318359,4.46679688 9.60986328,4.74609375 L12.5424805,12.2119141 L9.60986328,19.6777344 C9.51318359,19.9570312 9.33056641,20.3759766 9.33056641,20.6982422 C9.33056641,21.3320312 9.80322266,21.7939453 10.4370117,21.7939453 C10.8344727,21.7939453 11.199707,21.5253906 11.3608398,21.1064453 Z"/></svg>',
    boxFilledLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.48486328,22.1376953 L18.5151367,22.1376953 C20.7709961,22.1376953 21.8881836,21.03125 21.8881836,18.8183594 L21.8881836,5.69140625 C21.8881836,3.47851562 20.7709961,2.36132812 18.5151367,2.36132812 L5.48486328,2.36132812 C3.23974609,2.36132812 2.11181641,3.47851562 2.11181641,5.69140625 L2.11181641,18.8183594 C2.11181641,21.03125 3.23974609,22.1376953 5.48486328,22.1376953 Z M5.50634766,20.4082031 C4.43212891,20.4082031 3.84130859,19.8388672 3.84130859,18.7216797 L3.84130859,5.78808594 C3.84130859,4.67089844 4.43212891,4.09082031 5.50634766,4.09082031 L18.4936523,4.09082031 C19.5571289,4.09082031 20.1586914,4.67089844 20.1586914,5.78808594 L20.1586914,18.7216797 C20.1586914,19.8388672 19.5571289,20.4082031 18.4936523,20.4082031 L5.50634766,20.4082031 Z M15.3891602,18.9472656 L17.730957,18.9472656 C18.418457,18.9472656 18.6977539,18.6787109 18.6977539,18.0126953 L18.6977539,6.5078125 C18.6977539,5.83105469 18.418457,5.5625 17.730957,5.5625 L15.3891602,5.5625 C14.7016602,5.5625 14.4223633,5.83105469 14.4223633,6.5078125 L14.4223633,18.0126953 C14.4223633,18.6787109 14.7016602,18.9472656 15.3891602,18.9472656 Z" transform="matrix(-1 0 0 1 24 0)"/></svg>',
    boxFilledRight: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5.48486328,22.1376953 L18.5151367,22.1376953 C20.7709961,22.1376953 21.8881836,21.03125 21.8881836,18.8183594 L21.8881836,5.69140625 C21.8881836,3.47851562 20.7709961,2.36132812 18.5151367,2.36132812 L5.48486328,2.36132812 C3.23974609,2.36132812 2.11181641,3.47851562 2.11181641,5.69140625 L2.11181641,18.8183594 C2.11181641,21.03125 3.23974609,22.1376953 5.48486328,22.1376953 Z M5.50634766,20.4082031 C4.43212891,20.4082031 3.84130859,19.8388672 3.84130859,18.7216797 L3.84130859,5.78808594 C3.84130859,4.67089844 4.43212891,4.09082031 5.50634766,4.09082031 L18.4936523,4.09082031 C19.5571289,4.09082031 20.1586914,4.67089844 20.1586914,5.78808594 L20.1586914,18.7216797 C20.1586914,19.8388672 19.5571289,20.4082031 18.4936523,20.4082031 L5.50634766,20.4082031 Z M15.3891602,18.9472656 L17.730957,18.9472656 C18.418457,18.9472656 18.6977539,18.6787109 18.6977539,18.0126953 L18.6977539,6.5078125 C18.6977539,5.83105469 18.418457,5.5625 17.730957,5.5625 L15.3891602,5.5625 C14.7016602,5.5625 14.4223633,5.83105469 14.4223633,6.5078125 L14.4223633,18.0126953 C14.4223633,18.6787109 14.7016602,18.9472656 15.3891602,18.9472656 Z"/></svg>',
    boxHalfFilledLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M2.70800781,22.1376953 L21.2919922,22.1376953 C23.5478516,22.1376953 24.6650391,21.03125 24.6650391,18.8183594 L24.6650391,5.69140625 C24.6650391,3.47851562 23.5478516,2.36132812 21.2919922,2.36132812 L2.70800781,2.36132812 C0.462890625,2.36132812 -0.665039062,3.47851562 -0.665039062,5.69140625 L-0.665039062,18.8183594 C-0.665039062,21.03125 0.462890625,22.1376953 2.70800781,22.1376953 Z M2.72949219,20.4082031 C1.65527344,20.4082031 1.06445312,19.8388672 1.06445312,18.7216797 L1.06445312,5.78808594 C1.06445312,4.67089844 1.65527344,4.09082031 2.72949219,4.09082031 L21.2705078,4.09082031 C22.3339844,4.09082031 22.9355469,4.67089844 22.9355469,5.78808594 L22.9355469,18.7216797 C22.9355469,19.8388672 22.3339844,20.4082031 21.2705078,20.4082031 L2.72949219,20.4082031 Z M12.9238281,18.9472656 L20.5292969,18.9472656 C21.2060547,18.9472656 21.4746094,18.6679688 21.4746094,17.9804688 L21.4746094,6.52929688 C21.4746094,5.84179688 21.2060547,5.5625 20.5292969,5.5625 L12.9238281,5.5625 C12.2470703,5.5625 11.9785156,5.84179688 11.9785156,6.52929688 L11.9785156,17.9804688 C11.9785156,18.6679688 12.2470703,18.9472656 12.9238281,18.9472656 Z" transform="matrix(-1 0 0 1 25 0)"/></svg>',
    sidebarRightFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M20.4003906,2.36132812 C23.1074219,2.36132812 24.6650391,4.00488281 24.6650391,6.90527344 L24.6650391,17.6044922 C24.6650391,20.5048828 23.1074219,22.1376953 20.4003906,22.1376953 L3.86816406,22.1376953 C0.978515625,22.1376953 -0.665039062,20.5048828 -0.665039062,17.6044922 L-0.665039062,6.90527344 C-0.665039062,4.00488281 0.978515625,2.36132812 3.86816406,2.36132812 Z M20.1210938,4.09082031 L9.20703125,4.09082031 L9.20703125,20.4082031 L20.1210938,20.4082031 C21.9042969,20.4082031 22.9355469,19.3876953 22.9355469,17.6044922 L22.9355469,6.90527344 C22.9355469,5.12207031 21.9042969,4.09082031 20.1210938,4.09082031 Z M5.91113281,12.4482422 L2.6015625,12.4482422 C2.27929688,12.4482422 2,12.7275391 2,13.0498047 C2,13.3720703 2.27929688,13.640625 2.6015625,13.640625 L5.91113281,13.640625 C6.23339844,13.640625 6.5234375,13.3720703 6.5234375,13.0498047 C6.5234375,12.7275391 6.23339844,12.4482422 5.91113281,12.4482422 Z M5.91113281,9.66601562 L2.6015625,9.66601562 C2.27929688,9.66601562 2,9.93457031 2,10.2568359 C2,10.5791016 2.27929688,10.8691406 2.6015625,10.8691406 L5.91113281,10.8691406 C6.23339844,10.8691406 6.5234375,10.5791016 6.5234375,10.2568359 C6.5234375,9.93457031 6.23339844,9.66601562 5.91113281,9.66601562 Z M5.91113281,6.88378906 L2.6015625,6.88378906 C2.27929688,6.88378906 2,7.16308594 2,7.48535156 C2,7.796875 2.27929688,8.08691406 2.6015625,8.08691406 L5.91113281,8.08691406 C6.23339844,8.08691406 6.5234375,7.796875 6.5234375,7.48535156 C6.5234375,7.16308594 6.23339844,6.88378906 5.91113281,6.88378906 Z" transform="matrix(-1 0 0 1 25 0)"/></svg>',
    sidebarLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M3.86816406,22.1376953 L20.4003906,22.1376953 C23.1074219,22.1376953 24.6650391,20.5048828 24.6650391,17.6044922 L24.6650391,6.90527344 C24.6650391,4.00488281 23.1074219,2.36132812 20.4003906,2.36132812 L3.86816406,2.36132812 C0.978515625,2.36132812 -0.665039062,4.00488281 -0.665039062,6.90527344 L-0.665039062,17.6044922 C-0.665039062,20.5048828 0.978515625,22.1376953 3.86816406,22.1376953 Z M3.87890625,20.4082031 C2.09570313,20.4082031 1.06445312,19.3876953 1.06445312,17.6044922 L1.06445312,6.90527344 C1.06445312,5.12207031 2.09570313,4.09082031 3.87890625,4.09082031 L7.52050781,4.09082031 L7.52050781,20.4082031 L3.87890625,20.4082031 Z M20.1210938,4.09082031 C21.9042969,4.09082031 22.9355469,5.12207031 22.9355469,6.90527344 L22.9355469,17.6044922 C22.9355469,19.3876953 21.9042969,20.4082031 20.1210938,20.4082031 L9.20703125,20.4082031 L9.20703125,4.09082031 L20.1210938,4.09082031 Z M5.45800781,8.08691406 C5.78027344,8.08691406 6.0703125,7.796875 6.0703125,7.48535156 C6.0703125,7.16308594 5.78027344,6.88378906 5.45800781,6.88378906 L3.1484375,6.88378906 C2.82617188,6.88378906 2.546875,7.16308594 2.546875,7.48535156 C2.546875,7.796875 2.82617188,8.08691406 3.1484375,8.08691406 L5.45800781,8.08691406 Z M5.45800781,10.8691406 C5.78027344,10.8691406 6.0703125,10.5791016 6.0703125,10.2568359 C6.0703125,9.93457031 5.78027344,9.66601562 5.45800781,9.66601562 L3.1484375,9.66601562 C2.82617188,9.66601562 2.546875,9.93457031 2.546875,10.2568359 C2.546875,10.5791016 2.82617188,10.8691406 3.1484375,10.8691406 L5.45800781,10.8691406 Z M5.45800781,13.640625 C5.78027344,13.640625 6.0703125,13.3720703 6.0703125,13.0498047 C6.0703125,12.7275391 5.78027344,12.4482422 5.45800781,12.4482422 L3.1484375,12.4482422 C2.82617188,12.4482422 2.546875,12.7275391 2.546875,13.0498047 C2.546875,13.3720703 2.82617188,13.640625 3.1484375,13.640625 L5.45800781,13.640625 Z" transform="translate(1)"/></svg>',
    sidebarLeftFill: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24"><path fill="currentColor" d="M20.4003906,2.36132812 C23.1074219,2.36132812 24.6650391,4.00488281 24.6650391,6.90527344 L24.6650391,17.6044922 C24.6650391,20.5048828 23.1074219,22.1376953 20.4003906,22.1376953 L3.86816406,22.1376953 C0.978515625,22.1376953 -0.665039062,20.5048828 -0.665039062,17.6044922 L-0.665039062,6.90527344 C-0.665039062,4.00488281 0.978515625,2.36132812 3.86816406,2.36132812 Z M20.1210938,4.09082031 L9.20703125,4.09082031 L9.20703125,20.4082031 L20.1210938,20.4082031 C21.9042969,20.4082031 22.9355469,19.3876953 22.9355469,17.6044922 L22.9355469,6.90527344 C22.9355469,5.12207031 21.9042969,4.09082031 20.1210938,4.09082031 Z M5.81113281,12.4482422 L2.5015625,12.4482422 C2.17929687,12.4482422 1.9,12.7275391 1.9,13.0498047 C1.9,13.3720703 2.17929687,13.640625 2.5015625,13.640625 L5.81113281,13.640625 C6.13339844,13.640625 6.4234375,13.3720703 6.4234375,13.0498047 C6.4234375,12.7275391 6.13339844,12.4482422 5.81113281,12.4482422 Z M5.81113281,9.66601562 L2.5015625,9.66601562 C2.17929687,9.66601562 1.9,9.93457031 1.9,10.2568359 C1.9,10.5791016 2.17929687,10.8691406 2.5015625,10.8691406 L5.81113281,10.8691406 C6.13339844,10.8691406 6.4234375,10.5791016 6.4234375,10.2568359 C6.4234375,9.93457031 6.13339844,9.66601562 5.81113281,9.66601562 Z M5.81113281,6.88378906 L2.5015625,6.88378906 C2.17929687,6.88378906 1.9,7.16308594 1.9,7.48535156 C1.9,7.796875 2.17929687,8.08691406 2.5015625,8.08691406 L5.81113281,8.08691406 C6.13339844,8.08691406 6.4234375,7.796875 6.4234375,7.48535156 C6.4234375,7.16308594 6.13339844,6.88378906 5.81113281,6.88378906 Z" transform="translate(1)"/></svg>',
    // No `id` on the root: the sprite builder keys the <symbol> by the icon
    // name and the Icon's <use> resolves `#xcom-<that id>` when the source
    // carries one — the exported Streamline id made the reference dangle and
    // the mark painted nothing (measured 2026-09-02, footer social row).
    xcom: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="16" width="16">
  <path fill="currentColor" d="M12.6 0.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867 -5.07 -4.425 5.07H0.316l5.733 -6.57L0 0.75h5.063l3.495 4.633L12.601 0.75Zm-0.86 13.028h1.36L4.323 2.145H2.865z" stroke-width="1"></path>
</svg>`,
    bell: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path fill="currentColor" d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path fill="currentColor" d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>'
};

});

parcelRegister("lAOZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb84848bdad43e13$export$2e2bcd8739ae039);
/**
 * Shape tokens — the radius vocabulary (workspace design language §3 + §6,
 * DESIGN_LANGUAGE.md).
 *
 * RADIUS LAW (Nika 2026-09-23, verbatim option): "Letters everywhere. The
 * px-named tokens become aliases of letters in shape.js; radiusPill stays for
 * capsules." — "always use token vars (A,B,C)", never a raw px in a component.
 *
 * So the three named radii ARE em-scale spacing letters. Components keep the
 * names; the values live here, in one file:
 *   round: 'radiusControl'  → letter Z1 — 12.99px at the 17px base (was 12px)
 *   round: 'radiusCard'     → letter A  — 17.00px at the 17px base (was 17px)
 *   round: 'radiusSheet'    → letter B  — 27.51px at the 17px base
 *   round: 'radiusPill'     → 999px, a capsule on any height (unchanged)
 * Each letter is the nearest to the old px value (Z = 10.51, Z1 = 12.99;
 * A2 = 23.49, B = 27.51 — browser-resolved at 17px). Like every letter
 * radius, the three scale with the element's own font size (em) — so an
 * overlay panel keeps the base font size, or its corners shrink with it.
 *
 * radiusSheet moved A2 → B on 2026-09-26 (white-label redesign, Nika "update
 * them in brand"; spec §4.4): overlays read iPad-like at ~28px, one clear
 * step above radiusCard. The spec asked for a 28px literal; the letter law
 * above binds, and B is the letter nearest 28 (27.51px). It is the radius of
 * every modal, floating side panel and phone sheet — nothing in-page.
 *
 * WHY A COMPUTED em LITERAL: the framework emits a shape value VERBATIM
 * (scratch `transformBorderRadius` → `getShapeByKey`, no second pass through
 * the spacing scale), so a bare 'Z1' here would render `border-radius: Z1`.
 * `var(--spacing-Z1)` rendered, but only where the UNPREFIXED var exists — a
 * secondary app names its vars `--<prefix>-spacing-*`, so inside an isolated
 * iframe it resolved to nothing. The letter's own number, computed here from
 * the brand's spacing scale with scratch's sequence math, resolves in every
 * app scope. When the framework accepts a bare letter in a shape token (an fw
 * lane is on it), these three become 'Z1' / 'A' / 'A2'.
 *
 * The em value tracks `spacing.ratio` (the base cancels out of em). A project
 * that overrides the spacing RATIO moves its letters but not these literals.
 * Pinned to the framework's own emitted letters by tests/brand/shapeAliases
 * and tests/brand/questionMarkTooltip.a11y.
 *
 * Control HEIGHTS (`controlH`, `controlHCompact`) stay in `sizes.js` —
 * shape is radius-family only and never leaks into width/height/padding
 * resolution.
 */ 
var $529WE = parcelRequire("529WE");
// scratch utils/sequence.js, reproduced for three letters:
// - getSubratioDifference: a step's sub-steps split it by 1/1.618
//   (two sub-steps while the rounded px step is <= 16: X1 = first, X2 = second)
const $fb84848bdad43e13$var$r = (0, $529WE.default).ratio;
const $fb84848bdad43e13$var$sub = ($fb84848bdad43e13$var$r - 1) / 1.618;
// - switchSequenceOnNegative for Z, as the emitted CSS writes it:
//   max(1em / ratio, 1em * ratio / φ²) with φ² printed to four places
const $fb84848bdad43e13$var$Z = Math.max(1 / $fb84848bdad43e13$var$r, $fb84848bdad43e13$var$r / Number((1.618 ** 2).toFixed(4)));
const $fb84848bdad43e13$var$em = (v)=>`${Number(v.toFixed(6))}em`;
var $fb84848bdad43e13$export$2e2bcd8739ae039 = {
    radiusControl: $fb84848bdad43e13$var$em($fb84848bdad43e13$var$Z * ($fb84848bdad43e13$var$r - $fb84848bdad43e13$var$sub)),
    radiusCard: $fb84848bdad43e13$var$em(1),
    radiusSheet: $fb84848bdad43e13$var$em($fb84848bdad43e13$var$r),
    radiusPill: '999px'
};

});

parcelRegister("lhMi0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f0a4cb02dbe03d$export$2e2bcd8739ae039);
// Accessible keyboard focus ring (WCAG 2.2 SC 2.4.13 Focus Appearance + 1.4.11
// Non-text Contrast). The framework's Focusable atom only ships a faint
// `outline: solid X blue.3` ring; this gives every focusable control a crisp,
// high-contrast ring instead.
//   - `:focus-visible` only — shows for keyboard / programmatic focus, never on a
//     mouse click, so pointer users don't see a ring on press.
//   - box-shadow (not outline) so it never fights the framework atom's outline and
//     automatically hugs the element's own border-radius.
//   - `highlight` token is mode-aware (black on light, white on dark) → maximum
//     contrast on both themes from one rule; the 1px `document` (page background)
//     gap separates the ring from the control so it stays visible on same-colored
//     adjacent surfaces.

var $3WuWE = parcelRequire("3WuWE");

var $2Xro2 = parcelRequire("2Xro2");
// ONE source: the ring string lives in shadow.js as the `focusRing` token so
// the visually-hidden-input controls (CheckboxField, SwitchField, UploadIcon)
// can land the identical ring on their visible proxy via `boxShadow:
// 'focusRing'` instead of restating it or forking to a second ring.
const $f7f0a4cb02dbe03d$var$focusRing = (0, $3WuWE.default).focusRing;
const $f7f0a4cb02dbe03d$var$focusableSelector = 'a:focus-visible, button:focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible, summary:focus-visible, [tabindex]:focus-visible, [role="button"]:focus-visible, [role="menuitem"]:focus-visible, [role="option"]:focus-visible, [role="switch"]:focus-visible, [role="tab"]:focus-visible, [role="link"]:focus-visible, [role="checkbox"]:focus-visible, [role="radio"]:focus-visible, [role="combobox"]:focus-visible, [role="listbox"]:focus-visible, [role="slider"]:focus-visible, [role="textbox"]:focus-visible, [role="menuitemcheckbox"]:focus-visible, [role="menuitemradio"]:focus-visible, [contenteditable="true"]:focus-visible';
// Respect the OS "Reduce Motion" setting (WCAG 2.3.3). Snapping every
// animation/transition to ~0ms lands it on its FINAL keyframe (opacity:1,
// transform:none) so fade/scale reveals and the framework's `hide`-prop toggles
// still resolve visibly — opacity/visibility are never zeroed. 0.01ms (not 0)
// keeps animationend/transitionend firing so JS awaiting them never hangs.
// One global rule neutralizes every transition + the infinite loops (spinners,
// presence pulses, marching-ant edges) and cancels the framework's smooth-scroll.
const $f7f0a4cb02dbe03d$var$reducedMotionGuard = {
    '@media (prefers-reduced-motion: reduce)': {
        '*, *::before, *::after': {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            animationDelay: '0ms !important',
            transitionDuration: '0.01ms !important',
            transitionDelay: '0ms !important',
            scrollBehavior: 'auto !important'
        },
        html: {
            scrollBehavior: 'auto !important'
        }
    }
};
var $f7f0a4cb02dbe03d$export$2e2bcd8739ae039 = {
    html: {
        // D-7 (Nika 2026-09-23): numerals are TABULAR by brand default — one
        // rule, here, inherited by all text (it touches digits only), so counts,
        // money, times and table columns align without a per-component opt-in.
        // A component that needs proportional digits sets its own value.
        fontVariantNumeric: 'tabular-nums',
        maxWidth: '100dvw',
        minWidth: '320px',
        minHeight: '100dvh',
        height: 'auto',
        transform: 'none',
        overscrollBehavior: 'none'
    },
    body: {
        transform: 'none',
        overscrollBehavior: 'none',
        minHeight: '100dvh'
    },
    [$f7f0a4cb02dbe03d$var$focusableSelector]: {
        outline: 'none',
        boxShadow: $f7f0a4cb02dbe03d$var$focusRing
    },
    // D-6: the brand default for EVERY placeholder, themed field or not — the
    // `placeholder` colour pair (the quiet `inactive` tone). A themed field's
    // own ::placeholder rule is more specific and reads the same pair.
    '::placeholder': {
        color: 'var(--color-placeholder)'
    },
    ...$f7f0a4cb02dbe03d$var$reducedMotionGuard,
    // Georgian descender floor — raises ONLY the leading values that are too
    // short for the TBCContractica ink, and only under `:lang(ka)`. See
    // scriptLeading.js for the measurement and the collision guard.
    ...(0, $2Xro2.default)
};

});
parcelRegister("2Xro2", function(module, exports) {

$parcel$export(module.exports, "default", () => $227655e7bb646068$export$2e2bcd8739ae039);
// Per-script MINIMUM LEADING — the Georgian descender floor.
//
// Nika 2026-09-02: "fix tails cut on widgets on georgian letters".
//
// THE DEFECT
// ---------------------------------------------------------------------------
// `font.js` added TBCContractica as the Georgian face and `font_family.js`
// prepends it to the `smbls` default stack. The face is unicode-range-scoped
// to the Georgian blocks, so Latin text never touches it — but Georgian text
// now renders from a face whose INK descends further than the face's own
// declared descent. Measured on the running workspace at font-size 100px
// (canvas TextMetrics, full Mkhedruli U+10D0-10FF + Mtavruli U+1C90-1CBF,
// weights 400/500/700):
//
//                       fontBoundingBox   max ink    line-height the FONT
//                       ascent / descent  descent    metrics alone imply
//   TBCContractica         90 / 25          31.1        1.272   <- deepest: გ ქ კ ტ
//   Helvetica Neue (bold)  98 / 22          19.5        1.150
//
// Latin ink (19.5) sits inside Helvetica's declared descent (22), so a line
// box built from any line-height >= 1.15 contains it. Georgian ink (31.1)
// pokes 6.1% of the em BELOW TBCContractica's declared descent (25), so a
// short line-height leaves the tails outside the line box — and any
// `overflow: hidden` on that element (every truncating single-line label in
// the app) cuts them off. That is the shape of the bug: the leading scale was
// tuned against the Latin face and a second face with different metrics
// joined the stack.
//
// ⚠ 1.272 IS NOT THE SHIPPED FLOOR, AND THE ROW ABOVE IS NOT THE WHOLE STORY.
// It is what the two fonts' own metrics imply at font-size 100px. The browser
// does not lay out at 100px and does not build the line box from the Georgian
// face at all. The real, measured requirement at UI sizes is 1.45 — see
// SCRIPT_LEADING_FLOOR below for the two corrections (the strut comes from
// the LATIN face; the baseline is pixel-quantised) and the measurement table.
//
// WHY THE FIX LIVES HERE AND NOT IN THE COMPONENTS
// ---------------------------------------------------------------------------
// The offending values are ordinary `lineHeight: '1.2'` props spread across
// dozens of files in packages this design system does not own (the measured
// /w/gita offenders come from `workspace/packages/workspace/pages/main.js`).
// Patching them one by one is a sprinkle that the next component re-breaks.
// The design system owns typography AND owns the font stack that introduced
// the taller face, so the floor belongs here, once.
//
// WHY A FLOOR AND NOT A BLANKET `:lang(ka) { line-height: 1.3 }`
// ---------------------------------------------------------------------------
// A blanket rule also drags the 1.4/1.5/1.6 body values DOWN to the floor and
// cramps every paragraph in the app. CSS cannot express "raise this only if it
// is below N" — there is no way to read the inherited/declared value inside
// `max()`. So the floor names ONLY the values that are too small and leaves
// everything else unmentioned, which is the strictly safe direction: a value
// this file does not name cannot move.
//
// HOW THE VALUES ARE ADDRESSABLE
// ---------------------------------------------------------------------------
// The smbls CSS engine emits every flat `lineHeight` prop as one atomic class
// `_lh-<value with non-alphanumerics stripped>` (`@symbo.ls/css`
// `atomicClass()` + `sanitizeValue()`; `PROP_ABBREV.lineHeight === 'lh'`).
// The alphabet is therefore mechanical and enumerable, so the floor is
// GENERATED from a numeric range rather than hand-written. That coupling to a
// framework-internal naming scheme is deliberate and is PINNED by
// `workspace/packages/shared/__tests__/georgianLeadingFloor.test.js` — if the
// engine ever renames the prefix or changes the sanitizer, that test goes red
// instead of this file silently doing nothing.
//
// `._lh-12:lang(ka)` is (0,2,0) against the engine's (0,1,0) `._lh-12`, so the
// floor wins on specificity alone — no `!important`, no source-order
// dependency. `:lang()` is matched on the element itself, so an English island
// explicitly marked `lang="en"` inside a Georgian page keeps the tight Latin
// leading it was designed with, and an English session matches nothing in this
// file at all.
//
// KNOWN LIMITS (deliberate, measured, not oversights)
// ---------------------------------------------------------------------------
//  - A `lineHeight` nested inside a media query or a `:hover`/`&` block is
//    emitted as a hashed COMPOUND class (`_c<hash>`), not `_lh-*`, so it is
//    not addressable by name and the floor does not reach it. One such class
//    exists on the live workspace (`line-height: 1.25`, from a `@media` block
//    in LoginForm) — 0.8% under the floor, and it carries no Georgian text.
//  - An ABSOLUTE line-height (`19px`, `1.4rem`) cannot be floored by a ratio
//    without knowing the element's font size. None carry Georgian text today.
//  - `line-height: normal` computes to 1.20 for this face and is also short,
//    but CSS cannot select on it. The reset pins html to 1.5, so `normal`
//    only appears where a component asks for it; none do today.
// The floor, per BCP-47 language subtag. ADDING A LANGUAGE IS ONE ENTRY HERE —
// measure the face the same way (max ink descent vs declared descent) and add
// `<subtag>: <ratio>`. Nothing else in this file or in any component changes.
//
// Georgian: 1.45.
//
// ⚠ THE 1.272 FIGURE ABOVE IS A FONT-METRIC IDENTITY, NOT A LAYOUT ONE — it
// was derived at font-size 100px, where the browser's per-size rounding is
// negligible, and it UNDERSTATES the requirement at every real UI size. Two
// corrections, both measured in Chrome against the shipped woff2 files
// (2026-09-02, full U+10A0-10FF + U+1C90-1CBF + U+2D00-2D2F repertoire,
// weights 400/500/700, font sizes 9.0-40.0px in 0.1px steps, dpr 1 AND 2,
// ink-vs-painted-box with the baseline read from a zero-height
// `vertical-align: baseline` marker rather than derived from metrics):
//
//  1. TBCContractica DOES NOT BUILD THE LINE BOX. Chrome picks the "first
//     available font" for the strut, and it SKIPS a unicode-range-restricted
//     face — measured: a stack of [TBCContractica, Helvetica Neue] produces
//     byte-identical baselines to Helvetica Neue alone, and different ones
//     from an unrestricted copy of the same TBC file. So the box is sized by
//     a LATIN face (Helvetica Neue, used ascent-descent = 0.70em) while the
//     glyphs are drawn from a Georgian one (ink descent 0.311em). The box is
//     not too small for its own font; it is sized by the wrong font.
//     Corollary, also measured: `ascent-override` / `descent-override` /
//     `line-gap-override` on the restricted face change NOTHING (identical to
//     3 decimals at every size), so the face descriptors cannot fix this and
//     leading is the only lever.
//  2. THE BASELINE IS QUANTISED. Chrome lands the first baseline on a whole
//     CSS pixel, and the rounding always favours the ascent, so the descent
//     room left over jitters by up to ~0.13em with font size. A ratio floor
//     must therefore clear the worst case, not the average.
//
// Measured minimum ratio that leaves NO ink outside the painted box:
//     floor   failing sizes (of 311)   worst remaining cut
//     1.30      223                    +1.330px  <- the previously shipped value
//     1.35       58                    +0.464px
//     1.38        8                    +0.155px
//     1.40        2                    +0.110px
//     1.45        0                    -0.248px  <- shipped
//
// 1.45 is the first 0.05 step of this design system's own leading scale with
// zero failures and real clearance. It costs Georgian ~2.4px of extra line
// box on a 16px widget title; a cut tail costs the reader the letter.
const $227655e7bb646068$export$1454c40ecc3673c7 = {
    ka: 1.45
};
// Mirror of `@symbo.ls/css` `sanitizeValue()` for the short-value branch
// (values <= 20 chars are used directly; longer ones are hashed, which no
// line-height literal ever reaches).
const $227655e7bb646068$var$sanitizeValue = (value)=>String(value).replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase();
// Every spelling an author can write for one ratio: the canonical decimal, its
// `em` twin (`lineHeight: '1em'` appears 134 times in this repo, and an `em`
// line-height is the same multiple of the element's own font size as a
// unitless one) and the percentage form (`ColorPicker.js` writes `'100%'`).
// The `%` form is gated at >= 0.5 on purpose: below that it sanitizes to a
// bare one- or two-digit token (`9%` -> `9`) that reads as a whole-number
// ratio, and a line box under half the font size is not a thing anyone writes.
const $227655e7bb646068$var$spellingsFor = (ratio)=>{
    const spellings = [
        String(ratio),
        String(ratio) + 'em'
    ];
    if (ratio >= 0.5) spellings.push(Math.round(ratio * 1000) / 10 + '%');
    return spellings;
};
// THE COLLISION GUARD — the load-bearing safety property of this file.
//
// `sanitizeValue()` strips the decimal point, so ONE token can stand for two
// different ratios: `0.13` spelled `13%` sanitizes to `13`, and so does `1.3`.
// Emitting `._lh-13:lang(ka) { line-height: 1.3 }` on account of 0.13 would
// therefore also seize `line-height: 1.3` — and `14%`/`15%` would drag 1.4 and
// 1.5 DOWN to the floor, which is precisely the blanket-cramping regression
// this file exists to avoid. (Measured: the first draft of this generator did
// exactly that.)
//
// So: build the token set that every AT-OR-ABOVE-floor ratio can produce, and
// refuse to emit any token in it. A token this guard rejects means the value
// is simply not addressable without collateral damage — leaving it unfixed is
// always correct, cramping a sibling never is. The scan covers 0.01 steps from
// the floor up to 3.0 — no real leading exceeds it, and every value this
// design system and its consumers actually use lives well inside it.
const $227655e7bb646068$var$protectedTokens = (floor)=>{
    const tokens = new Set();
    for(let hundredths = Math.round(floor * 100); hundredths <= 300; hundredths++)for (const spelling of $227655e7bb646068$var$spellingsFor(hundredths / 100))tokens.add($227655e7bb646068$var$sanitizeValue(spelling));
    return tokens;
};
const $227655e7bb646068$export$bce2b53ddd1ba250 = (floor)=>{
    const unsafe = $227655e7bb646068$var$protectedTokens(floor);
    const classes = new Set();
    for(let hundredths = 0; hundredths < Math.round(floor * 100); hundredths++)for (const spelling of $227655e7bb646068$var$spellingsFor(hundredths / 100)){
        const token = $227655e7bb646068$var$sanitizeValue(spelling);
        if (!unsafe.has(token)) classes.add('_lh-' + token);
    }
    return [
        ...classes
    ];
};
const $227655e7bb646068$export$c2fff82e9993e829 = Object.keys($227655e7bb646068$export$1454c40ecc3673c7).reduce((rules, lang)=>{
    const floor = $227655e7bb646068$export$1454c40ecc3673c7[lang];
    const selector = $227655e7bb646068$export$bce2b53ddd1ba250(floor).map((className)=>`.${className}:lang(${lang})`).join(', ');
    rules[selector] = {
        lineHeight: String(floor)
    };
    return rules;
}, {});
var $227655e7bb646068$export$2e2bcd8739ae039 = $227655e7bb646068$export$c2fff82e9993e829;

});


parcelRegister("1c9wR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dee4db3f441bcb5$export$2e2bcd8739ae039);
/**
 * SKINS — two skins on ONE token set, orthogonal to light / dark (Nika
 * 2026-09-26: "also we should support theming. we make default exceptionally
 * beautiful, white-label (solid) as secondary"; ticket
 * DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1).
 *
 *   solid    — the white-label skin: flat stage, opaque cards. Exactly today's
 *              tokens (DESIGN_SPEC + HOME_WIDGETS_SPEC are its law).
 *   ambient  — the default skin: glass cards over the ambient ground (the
 *              dithered sky), an 18px backdrop blur.
 *
 * THE CONTRACT. A skin is chosen by `data-skin="solid" | "ambient"` on the
 * theme root (<html>, stamped by the shell) — or on ANY element, which scopes
 * the skin to that subtree (a preview, an app frame that keeps solid while
 * the home is ambient). No attribute = solid. Only the tokens listed here
 * differ; everything else is shared. Components never branch on the skin: a
 * skin rewrites the theme's own CSS variables (`--theme-<theme>-<param>`), so
 * `theme: 'card'` just follows. The light / dark halves come from the colour
 * PAIRS the values name (`cardGlass`, `cardSolid`), which flip with
 * `data-theme` on their own — the skin needs no scheme branch.
 *
 * THE NAMES consumers code against (they never read the skin itself):
 *   theme `card`  — every widget card; solid = today's card (`cardSolid`),
 *                   ambient = the `cardGlass` pair + blur(18px);
 *   theme `pill`  — the header pill and the home composer; solid = today's
 *                   header glass (`pillSolid` + blur(35px)), ambient = the
 *                   card glass;
 *   color `stageInk` — the ambient ground's dither dots (AmbientBackdrop).
 * Overlays, menus, sheets and icon plates keep their opaque tokens in both
 * skins. Glass is legible only over the stage: a solid frame (an app page on
 * gray16) keeps `data-skin="solid"` on its own subtree.
 *
 * Under `prefers-reduced-transparency: reduce` the ambient skin falls back to
 * the solid values (no glass, no blur): `fallback: 'solid'`, the one reserved
 * key of a skin — the framework does not guess which skin falls back to
 * which.
 *
 * EMISSION is the framework's (the design system's `skins` dimension, smbls
 * FW-SCRATCH-SKINS-DIMENSION-1): this map is the `skins` family of the brand
 * design system (designSystem/index.js). Per skin the emitter writes
 * `:root[data-skin="S"], [data-skin="S"] { --theme-<theme>-<param>: … }` after
 * the scheme table — a value that names a colour token becomes
 * `var(--color-<token>)`, anything else is CSS as written — and the fallback
 * as a `prefers-reduced-transparency` block. It replaced the brand's interim
 * `skinRules` block in reset.js, rule for rule. Guarded by
 * tests/brand/skins.test.mjs.
 */ const $0dee4db3f441bcb5$var$skins = {
    solid: {
        card: {
            background: 'cardSolid',
            backdropFilter: 'none'
        },
        pill: {
            background: 'pillSolid',
            backdropFilter: 'blur(35px)'
        }
    },
    ambient: {
        fallback: 'solid',
        card: {
            background: 'cardGlass',
            backdropFilter: 'blur(18px)'
        },
        pill: {
            background: 'cardGlass',
            backdropFilter: 'blur(18px)'
        }
    }
};
var $0dee4db3f441bcb5$export$2e2bcd8739ae039 = $0dee4db3f441bcb5$var$skins;

});

parcelRegister("86MWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e74da38a5144046$export$2e2bcd8739ae039);
// The named keyframes — the brand's whole motion vocabulary. The budget:
// opacity + transform only, travel under 10%, exits one step faster than
// entrances; `prefers-reduced-motion` is enforced globally by reset.js.
//
// OVERLAY MOTION (white-label redesign, Nika 2026-09-26; spec §4.7, §6.4) —
// each overlay moves from where it comes from, entering on `springBezier`
// (timing.js) at `D`, leaving on `defaultBezier` at `C`:
//   modalIn / modalOut      the centred sheet — rises 2.5% and settles from
//                           0.97; leaves 2% / 0.98 (PageSlot's _PANE_ENTER /
//                           _PANE_EXIT, the motion Nika approved)
//   panelIn / panelOut      the floating side panel — slides 4% from its edge,
//                           settles from 0.98; leaves 3% / 0.99
//   modalInUp / modalOutDown  the phone sheet — 6.5% up from the bottom
//   dropdownOpen            a popover — 6px from its anchor, from 0.98 (the
//                           shell's smbls-dropdown-fade-in)
//   fadeInUpShort           a toast (6.5%)
// Retired 2026-09-26: fadeInUpLong, fadeInDownLong, fadeOutUpLong (45%
// travel broke the 10% budget), fadeInSlowly, fadeOutSlowly — a census of
// every repo that links brand (workspace, company, extensions, governance,
// templates, smbls, docs, admin, starter-kit, standalone projects) found zero
// consumers; the only other definitions are two templates' own copies.
var $5e74da38a5144046$export$2e2bcd8739ae039 = {
    dropdownOpen: {
        from: {
            transform: 'translate3d(0, -6px, 0) scale(0.98)',
            opacity: 0
        },
        to: {
            transform: 'none',
            opacity: 1
        }
    },
    modalIn: {
        from: {
            transform: 'translate3d(0, 2.5%, 0) scale(0.97)',
            opacity: 0
        },
        to: {
            transform: 'none',
            opacity: 1
        }
    },
    modalInUp: {
        from: {
            transform: 'translate3d(0, 6.5%, 0)',
            opacity: 0
        },
        to: {
            transform: '',
            opacity: 1
        }
    },
    modalInDown: {
        from: {
            transform: 'translate3d(0, -6.5%, 0)',
            opacity: 0
        },
        to: {
            transform: '',
            opacity: 1
        }
    },
    modalOut: {
        to: {
            transform: 'translate3d(0, 2%, 0) scale(0.98)',
            opacity: 0
        }
    },
    // Key order (opacity first) matches the staged workspace copy, which a lock
    // test compares as JSON until the internal-brand pin carries these keys.
    panelIn: {
        from: {
            opacity: 0,
            transform: 'translate3d(4%, 0, 0) scale(0.98)'
        },
        to: {
            opacity: 1,
            transform: 'none'
        }
    },
    panelOut: {
        to: {
            opacity: 0,
            transform: 'translate3d(3%, 0, 0) scale(0.99)'
        }
    },
    modalOutDown: {
        from: {
            transform: '',
            opacity: 1
        },
        to: {
            transform: 'translate3d(0, 6.5%, 0)',
            opacity: 0
        }
    },
    fadeIn: {
        from: {
            opacity: 0
        },
        to: {
            opacity: 1
        }
    },
    fadeInUp: {
        from: {
            transform: 'translate3d(0, 12.5%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInUpShort: {
        from: {
            transform: 'translate3d(0, 6.5%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInDown: {
        from: {
            transform: 'translate3d(0, -12.5%, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeInLeft: {
        from: {
            transform: 'translate3d(12.5%, 0, 0)',
            opacity: 0
        },
        to: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        }
    },
    fadeOut: {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0
        }
    },
    fadeOutUp: {
        from: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        },
        to: {
            transform: 'translate3d(0, -12.5%, 0)',
            opacity: 0
        }
    },
    fadeOutDown: {
        from: {
            transform: 'translate3d(0, 0, 0)',
            opacity: 1
        },
        to: {
            transform: 'translate3d(0, 12.5%, 0)',
            opacity: 0
        }
    },
    slideInOut: {
        '0%': {
            transform: 'translate3d(0, 50%, 0)',
            opacity: 0
        },
        '15%': {
            transform: 'translate3d(0, -50%, 0)',
            opacity: 1
        },
        '85%': {
            transform: 'translate3d(0, -50%, 0)',
            opacity: 1
        },
        '100%': {
            transform: 'translate3d(0, -150%, 0)',
            opacity: 0
        }
    },
    scaleOutIn: {
        from: {
            transform: 'scale(1.2)',
            opacity: '0'
        },
        to: {
            transform: 'scale(1)',
            opacity: '1'
        }
    },
    scaleInOut: {
        from: {
            transform: 'scale(1)',
            opacity: '1'
        },
        to: {
            transform: 'scale(1.2)',
            opacity: '0'
        }
    },
    overflowVisibleSlowly: {
        '0%': {
            overflow: 'hidden'
        },
        '35%': {
            overflow: 'hidden'
        },
        '100%': {
            overflow: 'visible'
        }
    },
    overflowHiddenSlowly: {
        '0%': {
            overflow: 'visible'
        },
        '75%': {
            overflow: 'hidden'
        },
        '100%': {
            overflow: 'hidden'
        }
    },
    rotate: {
        from: {
            transform: 'rotate(0deg)'
        },
        to: {
            transform: 'rotate(360deg)'
        }
    },
    blinking: {
        '0%': {
            opacity: 1
        },
        '50%': {
            opacity: 0
        },
        '100%': {
            opacity: 1
        }
    },
    // Loading placeholders (shared `Skeleton` and everything extending it).
    // Deliberately NOT `blinking`: a placeholder that passes through opacity 0
    // twice a second flashes the layout empty and reads as a rendering fault, not
    // as work in progress. This breathes between 55% and 100% so the block is
    // always present. Added 2026-08-08 — Skeleton had always NAMED `pulse`, but
    // nothing defined it, and an unknown animation-name is silently inert, so
    // every skeleton in the product rendered as a flat static block.
    pulse: {
        '0%': {
            opacity: 0.55
        },
        '50%': {
            opacity: 1
        },
        '100%': {
            opacity: 0.55
        }
    }
};

});

parcelRegister("alQJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7894c5b112b87814$export$2e2bcd8739ae039);
var $7894c5b112b87814$export$2e2bcd8739ae039 = {};

});

parcelRegister("7IAr3", function(module, exports) {

$parcel$export(module.exports, "filters", () => $59e8e7bed1a67525$export$82462a21aead86ed);
$parcel$export(module.exports, "svgDefs", () => $59e8e7bed1a67525$export$53d8590270d12c2d);
$parcel$export(module.exports, "options", () => $59e8e7bed1a67525$export$41c562ebe57d11e2);
$parcel$export(module.exports, "default", () => $59e8e7bed1a67525$export$2e2bcd8739ae039);
const $59e8e7bed1a67525$export$82462a21aead86ed = {
    protanopia: 'url(#a11y-protanopia)',
    deuteranopia: 'url(#a11y-deuteranopia)',
    tritanopia: 'url(#a11y-tritanopia)',
    achromatopsia: 'grayscale(100%)',
    'low-contrast': 'contrast(0.5)',
    'high-contrast': 'contrast(1.75)',
    'low-vision': 'blur(1.5px)',
    inverted: 'invert(100%) hue-rotate(180deg)'
};
const $59e8e7bed1a67525$export$53d8590270d12c2d = `
  <defs>
    <filter id="a11y-protanopia">
      <feColorMatrix type="matrix" values="0.567 0.433 0 0 0  0.558 0.442 0 0 0  0 0.242 0.758 0 0  0 0 0 1 0"/>
    </filter>
    <filter id="a11y-deuteranopia">
      <feColorMatrix type="matrix" values="0.625 0.375 0 0 0  0.7 0.3 0 0 0  0 0.3 0.7 0 0  0 0 0 1 0"/>
    </filter>
    <filter id="a11y-tritanopia">
      <feColorMatrix type="matrix" values="0.95 0.05 0 0 0  0 0.433 0.567 0 0  0 0.475 0.525 0 0  0 0 0 1 0"/>
    </filter>
  </defs>
`;
const $59e8e7bed1a67525$export$41c562ebe57d11e2 = [
    {
        key: 'none',
        label: 'No filter'
    },
    {
        key: 'protanopia',
        label: 'Protanopia'
    },
    {
        key: 'deuteranopia',
        label: 'Deuteranopia'
    },
    {
        key: 'tritanopia',
        label: 'Tritanopia'
    },
    {
        key: 'achromatopsia',
        label: 'Achromatopsia'
    },
    {
        key: 'low-contrast',
        label: 'Low contrast'
    },
    {
        key: 'high-contrast',
        label: 'High contrast'
    },
    {
        key: 'low-vision',
        label: 'Low vision'
    },
    {
        key: 'inverted',
        label: 'Inverted'
    }
];
var $59e8e7bed1a67525$export$2e2bcd8739ae039 = {
    filters: $59e8e7bed1a67525$export$82462a21aead86ed,
    svgDefs: $59e8e7bed1a67525$export$53d8590270d12c2d,
    options: $59e8e7bed1a67525$export$41c562ebe57d11e2
};

});


parcelRegister("opCcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $04961ca8fcd75fa7$export$2e2bcd8739ae039);
// AUTO-CURATED integration logos for the marketplace design system.
// Sourced from local icon libraries (simple-icons / devicons / brand) — NOT a
// CDN. Resolved by scratch's icon sprite via the Icon component (name=slug).
// Regenerate: see scripts/build-integration-icons (slug list from integration_kinds + catalog registrars).
//
// Brand-owned marks below are re-exported from brand's canonical icon registry
// (company/packages/brand/designSystem/icons.js) instead of being independently
// redeclared here — a prior independent declaration of 'slack' drifted to a
// 128x128 multi-color logo and won the scratch sprite merge over brand's
// commissioned 24x24 currentColor mark. Re-exporting keeps a single source of
// truth (no drift possible) while still keeping the slug present in this map's
// keys, which functions/index.js's hasIntegrationLogo() gates Icon-vs-letter
// rendering on — removing the key outright would fall the catalog tile back to
// a letter chip. See tickets/sonnet.md 2026-08-13 slack icon sprite collision.

var $5IvaF = parcelRequire("5IvaF");
var $04961ca8fcd75fa7$export$2e2bcd8739ae039 = {
    anthropic: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Anthropic</title><path d="M17.3041 3.541h-3.6718l6.696 16.918H24Zm-10.6082 0L0 20.459h3.7442l1.3693-3.5527h7.0052l1.3693 3.5528h3.7442L10.5363 3.5409Zm-.3712 10.2232 2.2914-5.9456 2.2914 5.9456Z"/></svg>',
    clerk: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Clerk</title><path d="m21.47 20.829-2.881-2.881a.572.572 0 0 0-.7-.084 6.854 6.854 0 0 1-7.081 0 .576.576 0 0 0-.7.084l-2.881 2.881a.576.576 0 0 0-.103.69.57.57 0 0 0 .166.186 12 12 0 0 0 14.113 0 .58.58 0 0 0 .239-.423.576.576 0 0 0-.172-.453Zm.002-17.668-2.88 2.88a.569.569 0 0 1-.701.084A6.857 6.857 0 0 0 8.724 8.08a6.862 6.862 0 0 0-1.222 3.692 6.86 6.86 0 0 0 .978 3.764.573.573 0 0 1-.083.699l-2.881 2.88a.567.567 0 0 1-.864-.063A11.993 11.993 0 0 1 6.771 2.7a11.99 11.99 0 0 1 14.637-.405.566.566 0 0 1 .232.418.57.57 0 0 1-.168.448Zm-7.118 12.261a3.427 3.427 0 1 0 0-6.854 3.427 3.427 0 0 0 0 6.854Z"/></svg>',
    cloudflare: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Cloudflare</title><path d="M16.5088 16.8447c.1475-.5068.0908-.9707-.1553-1.3154-.2246-.3164-.6045-.499-1.0615-.5205l-8.6592-.1123a.1559.1559 0 0 1-.1333-.0713c-.0283-.042-.0351-.0986-.021-.1553.0278-.084.1123-.1484.2036-.1562l8.7359-.1123c1.0351-.0489 2.1601-.8868 2.5537-1.9136l.499-1.3013c.0215-.0561.0293-.1128.0147-.168-.5625-2.5463-2.835-4.4453-5.5499-4.4453-2.5039 0-4.6284 1.6177-5.3876 3.8614-.4927-.3658-1.1187-.5625-1.794-.499-1.2026.119-2.1665 1.083-2.2861 2.2856-.0283.31-.0069.6128.0635.894C1.5683 13.171 0 14.7754 0 16.752c0 .1748.0142.3515.0352.5273.0141.083.0844.1475.1689.1475h15.9814c.0909 0 .1758-.0645.2032-.1553l.12-.4268zm2.7568-5.5634c-.0771 0-.1611 0-.2383.0112-.0566 0-.1054.0415-.127.0976l-.3378 1.1744c-.1475.5068-.0918.9707.1543 1.3164.2256.3164.6055.498 1.0625.5195l1.8437.1133c.0557 0 .1055.0263.1329.0703.0283.043.0351.1074.0214.1562-.0283.084-.1132.1485-.204.1553l-1.921.1123c-1.041.0488-2.1582.8867-2.5527 1.914l-.1406.3585c-.0283.0713.0215.1416.0986.1416h6.5977c.0771 0 .1474-.0489.169-.126.1122-.4082.1757-.837.1757-1.2803 0-2.6025-2.125-4.727-4.7344-4.727"/></svg>',
    cloudflareworkers: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Cloudflare Workers</title><path d="m8.213.063 8.879 12.136-8.67 11.739h2.476l8.665-11.735-8.89-12.14Zm4.728 0 9.02 11.992-9.018 11.883h2.496L24 12.656v-1.199L15.434.063ZM7.178 2.02.01 11.398l-.01 1.2 7.203 9.644 1.238-1.676-6.396-8.556 6.361-8.313Z"/></svg>',
    datadog: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Datadog</title><path d="M19.57 17.04l-1.997-1.316-1.665 2.782-1.937-.567-1.706 2.604.087.82 9.274-1.71-.538-5.794zm-8.649-2.498l1.488-.204c.241.108.409.15.697.223.45.117.97.23 1.741-.16.18-.088.553-.43.704-.625l6.096-1.106.622 7.527-10.444 1.882zm11.325-2.712l-.602.115L20.488 0 .789 2.285l2.427 19.693 2.306-.334c-.184-.263-.471-.581-.96-.989-.68-.564-.44-1.522-.039-2.127.53-1.022 3.26-2.322 3.106-3.956-.056-.594-.15-1.368-.702-1.898-.02.22.017.432.017.432s-.227-.289-.34-.683c-.112-.15-.2-.199-.319-.4-.085.233-.073.503-.073.503s-.186-.437-.216-.807c-.11.166-.137.48-.137.48s-.241-.69-.186-1.062c-.11-.323-.436-.965-.343-2.424.6.421 1.924.321 2.44-.439.171-.251.288-.939-.086-2.293-.24-.868-.835-2.16-1.066-2.651l-.028.02c.122.395.374 1.223.47 1.625.293 1.218.372 1.642.234 2.204-.116.488-.397.808-1.107 1.165-.71.358-1.653-.514-1.713-.562-.69-.55-1.224-1.447-1.284-1.883-.062-.477.275-.763.445-1.153-.243.07-.514.192-.514.192s.323-.334.722-.624c.165-.109.262-.178.436-.323a9.762 9.762 0 0 0-.456.003s.42-.227.855-.392c-.318-.014-.623-.003-.623-.003s.937-.419 1.678-.727c.509-.208 1.006-.147 1.286.257.367.53.752.817 1.569.996.501-.223.653-.337 1.284-.509.554-.61.99-.688.99-.688s-.216.198-.274.51c.314-.249.66-.455.66-.455s-.134.164-.259.426l.03.043c.366-.22.797-.394.797-.394s-.123.156-.268.358c.277-.002.838.012 1.056.037 1.285.028 1.552-1.374 2.045-1.55.618-.22.894-.353 1.947.68.903.888 1.609 2.477 1.259 2.833-.294.295-.874-.115-1.516-.916a3.466 3.466 0 0 1-.716-1.562 1.533 1.533 0 0 0-.497-.85s.23.51.23.96c0 .246.03 1.165.424 1.68-.039.076-.057.374-.1.43-.458-.554-1.443-.95-1.604-1.067.544.445 1.793 1.468 2.273 2.449.453.927.186 1.777.416 1.997.065.063.976 1.197 1.15 1.767.306.994.019 2.038-.381 2.685l-1.117.174c-.163-.045-.273-.068-.42-.153.08-.143.241-.5.243-.572l-.063-.111c-.348.492-.93.97-1.414 1.245-.633.359-1.363.304-1.838.156-1.348-.415-2.623-1.327-2.93-1.566 0 0-.01.191.048.234.34.383 1.119 1.077 1.872 1.56l-1.605.177.759 5.908c-.337.048-.39.071-.757.124-.325-1.147-.946-1.895-1.624-2.332-.599-.384-1.424-.47-2.214-.314l-.05.059a2.851 2.851 0 0 1 1.863.444c.654.413 1.181 1.481 1.375 2.124.248.822.42 1.7-.248 2.632-.476.662-1.864 1.028-2.986.237.3.481.705.876 1.25.95.809.11 1.577-.03 2.106-.574.452-.464.69-1.434.628-2.456l.714-.104.258 1.834 11.827-1.424zM15.05 6.848c-.034.075-.085.125-.007.37l.004.014.013.032.032.073c.14.287.295.558.552.696.067-.011.136-.019.207-.023.242-.01.395.028.492.08.009-.048.01-.119.005-.222-.018-.364.072-.982-.626-1.308-.264-.122-.634-.084-.757.068a.302.302 0 0 1 .058.013c.186.066.06.13.027.207m1.958 3.392c-.092-.05-.52-.03-.821.005-.574.068-1.193.267-1.328.372-.247.191-.135.523.047.66.511.382.96.638 1.432.575.29-.038.546-.497.728-.914.124-.288.124-.598-.058-.698m-5.077-2.942c.162-.154-.805-.355-1.556.156-.554.378-.571 1.187-.041 1.646.053.046.096.078.137.104a4.77 4.77 0 0 1 1.396-.412c.113-.125.243-.345.21-.745-.044-.542-.455-.456-.146-.749"/></svg>',
    gandi: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Gandi</title><path d="M16.72 5.908a1.496 1.496 0 1 1 2.442 1.729c-.871 1.23-1.906 2.176-3.082 2.82-.661.436-1.414.844-2.209 1.274-.689.373-1.401.758-2.065 1.171-1.565.974-2.46 1.87-2.814 2.82-.473 1.266-.26 2.322.002 2.985a3.8 3.8 0 0 0 1.79 2.006c.808.413 1.931.39 2.93-.06.924-.415 1.542-1.11 1.612-1.813.07-.71-.24-1.114-.553-1.255-.368-.165-.788.006-1.152.467a1.495 1.495 0 1 1-2.349-1.854c1.227-1.554 3.082-2.08 4.726-1.342 1.588.713 2.493 2.392 2.305 4.28-.179 1.792-1.435 3.38-3.36 4.246-1.836.826-3.899.824-5.52-.005a6.8 6.8 0 0 1-3.212-3.572c-.642-1.625-.65-3.446-.022-5.13.605-1.62 1.869-2.803 3.037-3.647a8 8 0 0 1-.828-.33c-1.376-.638-2.573-1.668-3.56-3.061A1.496 1.496 0 0 1 7.28 5.908c.69.976 1.467 1.654 2.376 2.075.69.319 1.457.487 2.344.514.888-.027 1.656-.195 2.345-.514q.098-.045.194-.096.106-.053.208-.112c.738-.424 1.387-1.038 1.972-1.867M11.2 4.17c.191.192.447.297.717.297.271 0 .526-.105.718-.297s.297-.446.297-.717a1 1 0 0 0-.298-.718 1 1 0 0 0-.717-.297c-.27 0-.526.105-.717.297a1 1 0 0 0-.297.718c0 .27.105.525.297.717M9.476 1.011A3.43 3.43 0 0 1 11.917 0c.922 0 1.79.359 2.442 1.01a3.43 3.43 0 0 1 1.01 2.443c0 .922-.358 1.789-1.01 2.44a3.43 3.43 0 0 1-2.442 1.012 3.43 3.43 0 0 1-2.44-1.011 3.43 3.43 0 0 1-1.013-2.441c0-.923.36-1.79 1.012-2.442"/></svg>',
    godaddy: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>GoDaddy</title><path d="M20.702 2.29c-2.494-1.554-5.778-1.187-8.706.654C9.076 1.104 5.79.736 3.3 2.29c-3.941 2.463-4.42 8.806-1.07 14.167 2.47 3.954 6.333 6.269 9.77 6.226 3.439.043 7.301-2.273 9.771-6.226 3.347-5.361 2.872-11.704-1.069-14.167zM4.042 15.328a12.838 12.838 0 01-1.546-3.541 10.12 10.12 0 01-.336-3.338c.15-1.98.956-3.524 2.27-4.345 1.315-.822 3.052-.87 4.903-.137.281.113.556.24.825.382A15.11 15.11 0 007.5 7.54c-2.035 3.255-2.655 6.878-1.945 9.765a13.247 13.247 0 01-1.514-1.98zm17.465-3.541a12.866 12.866 0 01-1.547 3.54 13.25 13.25 0 01-1.513 1.984c.635-2.589.203-5.76-1.353-8.734a.39.39 0 00-.563-.153l-4.852 3.032a.397.397 0 00-.126.546l.712 1.139a.395.395 0 00.547.126l3.145-1.965c.101.306.203.606.28.916.296 1.086.41 2.214.335 3.337-.15 1.982-.956 3.525-2.27 4.347a4.437 4.437 0 01-2.25.65h-.101a4.432 4.432 0 01-2.25-.65c-1.314-.822-2.121-2.365-2.27-4.347-.074-1.123.039-2.251.335-3.337a13.212 13.212 0 014.05-6.482 10.148 10.148 0 012.849-1.765c1.845-.733 3.586-.685 4.9.137 1.316.822 2.122 2.365 2.271 4.345a10.146 10.146 0 01-.33 3.334z"/></svg>',
    google: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Google</title><path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"/></svg>',
    googleanalytics: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Google Analytics</title><path d="M22.84 2.9982v17.9987c.0086 1.6473-1.3197 2.9897-2.967 2.9984a2.9808 2.9808 0 01-.3677-.0208c-1.528-.226-2.6477-1.5558-2.6105-3.1V3.1204c-.0369-1.5458 1.0856-2.8762 2.6157-3.1 1.6361-.1915 3.1178.9796 3.3093 2.6158.014.1201.0208.241.0202.3619zM4.1326 18.0548c-1.6417 0-2.9726 1.331-2.9726 2.9726C1.16 22.6691 2.4909 24 4.1326 24s2.9726-1.3309 2.9726-2.9726-1.331-2.9726-2.9726-2.9726zm7.8728-9.0098c-.0171 0-.0342 0-.0513.0003-1.6495.0904-2.9293 1.474-2.891 3.1256v7.9846c0 2.167.9535 3.4825 2.3505 3.763 1.6118.3266 3.1832-.7152 3.5098-2.327.04-.1974.06-.3983.0593-.5998v-8.9585c.003-1.6474-1.33-2.9852-2.9773-2.9882z"/></svg>',
    lemonsqueezy: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Lemon Squeezy</title><path d="m7.4916 10.835 2.3748-6.5114a3.1497 3.1497 0 0 0-.065-2.3418C9.0315.183 6.9427-.398 5.2928.265 3.643.929 2.71 2.4348 3.512 4.3046l2.8197 6.5615c.219.509.97.489 1.16-.03m1.6798 1.0969 6.5334-2.7758c2.1699-.9219 2.7218-3.6907 1.022-5.2905l-.068-.063c-1.6669-1.5469-4.4217-1.002-5.3706 1.0359L8.3566 11.135c-.234.503.295 1.0199.8159.7979m.373.87 6.6454-2.5119c2.2078-.8349 4.6206.745 4.5886 3.0398l-.002.09c-.048 2.2358-2.3938 3.7376-4.5536 2.9467l-6.6724-2.4418a.595.595 0 0 1-.006-1.1229m-.386 1.9269 6.4375 2.9767a3.2997 3.2997 0 0 1 1.6658 1.6989c.769 1.7998-.283 3.6396-1.9328 4.3016-1.6499.662-3.4097.235-4.2097-1.6359l-2.8027-6.5694c-.217-.509.328-1.009.8419-.772"/></svg>',
    livekit: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>LiveKit</title><path d="M0 0v24h14.4v-4.799h4.8V24H24v-4.8h-4.799v-4.8h-4.8v4.8H4.8V0H0zm14.4 14.4V9.602h4.801V4.8H24V0h-4.8v4.8h-4.8v4.8H9.6v4.8h4.8z"/></svg>',
    make: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Make</title><path d="M13.38 3.498c-.27 0-.511.19-.566.465L9.85 18.986a.578.578 0 0 0 .453.678l4.095.826a.58.58 0 0 0 .682-.455l2.963-15.021a.578.578 0 0 0-.453-.678l-4.096-.826a.589.589 0 0 0-.113-.012zm-5.876.098a.576.576 0 0 0-.516.318L.062 17.697a.575.575 0 0 0 .256.774l3.733 1.877a.578.578 0 0 0 .775-.258l6.926-13.781a.577.577 0 0 0-.256-.776L7.762 3.658a.571.571 0 0 0-.258-.062zm11.74.115a.576.576 0 0 0-.576.576v15.426c0 .318.258.578.576.578h4.178a.58.58 0 0 0 .578-.578V4.287a.578.578 0 0 0-.578-.576Z"/></svg>',
    mixpanel: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Mixpanel</title><path d="M6.967 9.996h3.053c-.763-.477-1.048-1.145-1.431-2.384L7.443 3.366C6.919 1.458 6.49.551 4.39.551H.004v1.145h.621c1.286 0 1.431.477 1.814 1.908L3.44 7.326c.524 1.814 1.337 2.67 3.53 2.67h-.003Zm7.06 0h3.053c2.194 0 2.956-.86 3.484-2.67l1.001-3.722c.382-1.431.57-1.908 1.814-1.908H24V.551h-4.34c-2.146 0-2.576.86-3.053 2.815l-1.145 4.246c-.384 1.286-.673 1.907-1.435 2.384Zm-4.007 4.008h4.007V9.996H10.02v4.008ZM0 23.449h4.39c2.1 0 2.529-.907 3.053-2.815l1.146-4.246c.383-1.239.668-1.907 1.431-2.384H6.967c-2.194 0-3.007.86-3.531 2.67l-1.001 3.722c-.383 1.431-.524 1.907-1.814 1.907H0v1.146Zm19.65 0h4.343v-1.146h-.622c-1.239 0-1.431-.476-1.814-1.907l-1.001-3.722c-.524-1.814-1.286-2.67-3.483-2.67h-3.046c.762.477 1.041 1.098 1.424 2.384l1.145 4.246c.477 1.955.907 2.815 3.054 2.815Z"/></svg>',
    mongodb: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>MongoDB</title><path d="M17.193 9.555c-1.264-5.58-4.252-7.414-4.573-8.115-.28-.394-.53-.954-.735-1.44-.036.495-.055.685-.523 1.184-.723.566-4.438 3.682-4.74 10.02-.282 5.912 4.27 9.435 4.888 9.884l.07.05A73.49 73.49 0 0111.91 24h.481c.114-1.032.284-2.056.51-3.07.417-.296.604-.463.85-.693a11.342 11.342 0 003.639-8.464c.01-.814-.103-1.662-.197-2.218zm-5.336 8.195s0-8.291.275-8.29c.213 0 .49 10.695.49 10.695-.381-.045-.765-1.76-.765-2.405z"/></svg>',
    n8n: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>n8n</title><path d="M21.4737 5.6842c-1.1772 0-2.1663.8051-2.4468 1.8947h-2.8955c-1.235 0-2.289.893-2.492 2.111l-.1038.623a1.263 1.263 0 0 1-1.246 1.0555H11.289c-.2805-1.0896-1.2696-1.8947-2.4468-1.8947s-2.1663.8051-2.4467 1.8947H4.973c-.2805-1.0896-1.2696-1.8947-2.4468-1.8947C1.1311 9.4737 0 10.6047 0 12s1.131 2.5263 2.5263 2.5263c1.1772 0 2.1663-.8051 2.4468-1.8947h1.4223c.2804 1.0896 1.2696 1.8947 2.4467 1.8947 1.1772 0 2.1663-.8051 2.4468-1.8947h1.0008a1.263 1.263 0 0 1 1.2459 1.0555l.1038.623c.203 1.218 1.257 2.111 2.492 2.111h.3692c.2804 1.0895 1.2696 1.8947 2.4468 1.8947 1.3952 0 2.5263-1.131 2.5263-2.5263s-1.131-2.5263-2.5263-2.5263c-1.1772 0-2.1664.805-2.4468 1.8947h-.3692a1.263 1.263 0 0 1-1.246-1.0555l-.1037-.623A2.52 2.52 0 0 0 13.9607 12a2.52 2.52 0 0 0 .821-1.4794l.1038-.623a1.263 1.263 0 0 1 1.2459-1.0555h2.8955c.2805 1.0896 1.2696 1.8947 2.4468 1.8947 1.3952 0 2.5263-1.131 2.5263-2.5263s-1.131-2.5263-2.5263-2.5263m0 1.2632a1.263 1.263 0 0 1 1.2631 1.2631 1.263 1.263 0 0 1-1.2631 1.2632 1.263 1.263 0 0 1-1.2632-1.2632 1.263 1.263 0 0 1 1.2632-1.2631M2.5263 10.7368A1.263 1.263 0 0 1 3.7895 12a1.263 1.263 0 0 1-1.2632 1.2632A1.263 1.263 0 0 1 1.2632 12a1.263 1.263 0 0 1 1.2631-1.2632m6.3158 0A1.263 1.263 0 0 1 10.1053 12a1.263 1.263 0 0 1-1.2632 1.2632A1.263 1.263 0 0 1 7.579 12a1.263 1.263 0 0 1 1.2632-1.2632m10.1053 3.7895a1.263 1.263 0 0 1 1.2631 1.2632 1.263 1.263 0 0 1-1.2631 1.2631 1.263 1.263 0 0 1-1.2632-1.2631 1.263 1.263 0 0 1 1.2632-1.2632"/></svg>',
    namecheap: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Namecheap</title><path d="M17.295 17.484c.227.403.57.728.985.931-.309.15-.647.229-.99.232h-3.068a2.26 2.26 0 0 1-1.957-1.143L6.705 6.511a2.27 2.27 0 0 0-.974-.922c.309-.153.652-.233.997-.232h3.05c.81.003 1.558.438 1.959 1.143l5.558 10.984zm-9.329-7.392L6.269 6.755c-.209-.392-.582-.657-.984-.829-.204.165-.391.35-.522.581-.184.349-4.391 8.648-4.569 8.987a2.245 2.245 0 0 0 4.016 1.999l3.756-7.401zm15.846-1.593a2.245 2.245 0 0 0-1.162-2.955v-.001a2.243 2.243 0 0 0-.892-.187l-.003-.011c-.816 0-1.569.443-1.965 1.157l-3.749 7.414 1.689 3.323c.213.399.59.664.998.839.252-.2.473-.444.605-.742l4.479-8.837z"/></svg>',
    neon: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Neon</title><path d="M24 0V24l-9.365-8.045V24H0V0ZM2.942 21.087h8.751V9.563l9.365 8.204V2.919L2.942 2.914Z"/></svg>',
    paddle: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Paddle</title><path d="M2.363 7.904v.849a3.95 3.95 0 0 1 3.65 2.425c.198.476.3.987.299 1.502h.791c0-1.04.416-2.037 1.157-2.772a3.962 3.962 0 0 1 2.792-1.149V7.91a3.959 3.959 0 0 1-3.65-2.425 3.893 3.893 0 0 1-.299-1.502h-.791c0 1.04-.416 2.037-1.157 2.772a3.96 3.96 0 0 1-2.792 1.149M13.105 2.51H6.312V0h6.793c4.772 0 8.532 3.735 8.532 8.314 0 4.58-3.76 8.314-8.532 8.314H9.156V24H6.312v-9.882h6.793c3.319 0 5.688-2.352 5.688-5.804 0-3.451-2.37-5.804-5.688-5.804"/></svg>',
    planetscale: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>PlanetScale</title><path d="M0 12C0 5.373 5.373 0 12 0c4.873 0 9.067 2.904 10.947 7.077l-15.87 15.87a11.981 11.981 0 0 1-1.935-1.099L14.99 12H12l-8.485 8.485A11.962 11.962 0 0 1 0 12Zm12.004 12L24 12.004C23.998 18.628 18.628 23.998 12.004 24Z"/></svg>',
    plausibleanalytics: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Plausible Analytics</title><path d="M12.1835.0017c-.6378-.0097-1.2884.022-1.7246.0996C8.601.424 7.035 1.2116 5.7384 2.4782 4.406 3.7806 3.582 5.299 3.1818 7.1929l-.1387.6445c-.0118 5.3872-.0233 10.7744-.035 16.1617.2914.0081.591-.0392.8416-.0606 2.348-.2868 4.3442-1.7083 5.4315-3.8651.2749-.5497.472-1.182.6094-1.9707.1135-.6691.1195-.8915.1016-4.3807l-.0176-3.6737.1425-.3574c.1972-.49.7425-1.0352 1.2324-1.2324l.3574-.1426 3.3457-.0058c1.8401 0 3.4545-.025 3.58-.0489.5854-.1135 1.2118-.6027 1.4628-1.1464.0717-.1494.1671-.4415.209-.6387.0657-.3286.0604-.4186-.0352-.789-.2987-1.0993-1.3503-2.6234-2.4257-3.5136C16.6247 1.1638 15.2798.4887 13.828.1482c-.3824-.0866-1.0067-.1368-1.6445-.1465zm8.5369 6.8006c-.0506.1798-.098.3662-.172.5215-.3358.7278-1.0382 1.2776-1.8221 1.4296-3.6737.0566-2.5392.0561-3.6737.0566l-3.248.0059-.2695.1074c-.3135.1262-.827.6397-.9531.9531l-.1074.2676.0175 3.576c.0149 2.8888.007 3.5821-.0605 4.125a8.9918 8.9918 0 0 0 1.5683.1386c4.9662.0001 8.992-4.0258 8.992-8.992a8.9918 8.9918 0 0 0-.2715-2.1893Z"/></svg>',
    porkbun: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Porkbun</title><path d="M12 0C5.3708 0 .0176 5.3532.0176 11.9824.0176 18.6117 5.3708 24 12 24s11.9824-5.3532 11.9824-11.9824C23.9824 5.3883 18.6292 0 12 0ZM5.832 5.8848c1.0635.2481 2.092.6384 3.0137 1.1347-1.099.5318-1.9866 1.3824-2.6602 2.375-.4254-.5672-.6738-1.2767-.6738-2.0566 0-.5318.1076-.9923.3203-1.4531zm12.336 0c.2127.4254.3203.9213.3203 1.453 0 .78-.2484 1.4895-.6738 2.0567-.6736-.9926-1.5967-1.8432-2.6602-2.375a9.9821 9.9821 0 0 1 3.0137-1.1347zm-6.0723.8105c3.5286.0471 6.3547 2.9198 6.3203 6.457v3.8282c0 .638-.5318 1.1699-1.17 1.1699-.638 0-1.1698-.5318-1.1698-1.17v-.957H7.8516v.957c0 .6382-.5319 1.17-1.17 1.17-.638 0-1.1699-.5318-1.1699-1.17v-3.6503c0-3.5096 2.7307-6.489 6.2403-6.6309.1152-.0044.2299-.0054.3437-.0039zm1.5 3.7988c-.4963 0-.9219.4256-.9219.922 0 .248.0711.4242.213.6015.1417.2127.3536.3546.5663.461-.1418.0708-.3188.1425-.496.1425-.2128 0-.3907.176-.3907.3887s.178.3906.3906.3906h.1778c.6026 0 1.1346-.3553 1.3828-.8516.39-.1418.7092-.3896.9219-.7441.0709-.1064.0337-.2484-.0372-.2129-.1063-.0355-.2123-.034-.2832.0723-.1063.1418-.2485.2826-.4257.3535v-.1426c0-.39-.1409-.7086-.3536-.9922-.1772-.2481-.425-.3887-.7441-.3887zm0 .5313c.2127 0 .3532.1408.3887.3535v.1777c0 .1773-.0346.3543-.1055.4961-.2481-.0709-.4617-.213-.6035-.4257-.0355-.071-.0703-.14-.0703-.211 0-.2392.2063-.3906.3906-.3906z"/></svg>',
    postgresql: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>PostgreSQL</title><path d="M23.5594 14.7228a.5269.5269 0 0 0-.0563-.1191c-.139-.2632-.4768-.3418-1.0074-.2321-1.6533.3411-2.2935.1312-2.5256-.0191 1.342-2.0482 2.445-4.522 3.0411-6.8297.2714-1.0507.7982-3.5237.1222-4.7316a1.5641 1.5641 0 0 0-.1509-.235C21.6931.9086 19.8007.0248 17.5099.0005c-1.4947-.0158-2.7705.3461-3.1161.4794a9.449 9.449 0 0 0-.5159-.0816 8.044 8.044 0 0 0-1.3114-.1278c-1.1822-.0184-2.2038.2642-3.0498.8406-.8573-.3211-4.7888-1.645-7.2219.0788C.9359 2.1526.3086 3.8733.4302 6.3043c.0409.818.5069 3.334 1.2423 5.7436.4598 1.5065.9387 2.7019 1.4334 3.582.553.9942 1.1259 1.5933 1.7143 1.7895.4474.1491 1.1327.1441 1.8581-.7279.8012-.9635 1.5903-1.8258 1.9446-2.2069.4351.2355.9064.3625 1.39.3772a.0569.0569 0 0 0 .0004.0041 11.0312 11.0312 0 0 0-.2472.3054c-.3389.4302-.4094.5197-1.5002.7443-.3102.064-1.1344.2339-1.1464.8115-.0025.1224.0329.2309.0919.3268.2269.4231.9216.6097 1.015.6331 1.3345.3335 2.5044.092 3.3714-.6787-.017 2.231.0775 4.4174.3454 5.0874.2212.5529.7618 1.9045 2.4692 1.9043.2505 0 .5263-.0291.8296-.0941 1.7819-.3821 2.5557-1.1696 2.855-2.9059.1503-.8707.4016-2.8753.5388-4.1012.0169-.0703.0357-.1207.057-.1362.0007-.0005.0697-.0471.4272.0307a.3673.3673 0 0 0 .0443.0068l.2539.0223.0149.001c.8468.0384 1.9114-.1426 2.5312-.4308.6438-.2988 1.8057-1.0323 1.5951-1.6698zM2.371 11.8765c-.7435-2.4358-1.1779-4.8851-1.2123-5.5719-.1086-2.1714.4171-3.6829 1.5623-4.4927 1.8367-1.2986 4.8398-.5408 6.108-.13-.0032.0032-.0066.0061-.0098.0094-2.0238 2.044-1.9758 5.536-1.9708 5.7495-.0002.0823.0066.1989.0162.3593.0348.5873.0996 1.6804-.0735 2.9184-.1609 1.1504.1937 2.2764.9728 3.0892.0806.0841.1648.1631.2518.2374-.3468.3714-1.1004 1.1926-1.9025 2.1576-.5677.6825-.9597.5517-1.0886.5087-.3919-.1307-.813-.5871-1.2381-1.3223-.4796-.839-.9635-2.0317-1.4155-3.5126zm6.0072 5.0871c-.1711-.0428-.3271-.1132-.4322-.1772.0889-.0394.2374-.0902.4833-.1409 1.2833-.2641 1.4815-.4506 1.9143-1.0002.0992-.126.2116-.2687.3673-.4426a.3549.3549 0 0 0 .0737-.1298c.1708-.1513.2724-.1099.4369-.0417.156.0646.3078.26.3695.4752.0291.1016.0619.2945-.0452.4444-.9043 1.2658-2.2216 1.2494-3.1676 1.0128zm2.094-3.988-.0525.141c-.133.3566-.2567.6881-.3334 1.003-.6674-.0021-1.3168-.2872-1.8105-.8024-.6279-.6551-.9131-1.5664-.7825-2.5004.1828-1.3079.1153-2.4468.079-3.0586-.005-.0857-.0095-.1607-.0122-.2199.2957-.2621 1.6659-.9962 2.6429-.7724.4459.1022.7176.4057.8305.928.5846 2.7038.0774 3.8307-.3302 4.7363-.084.1866-.1633.3629-.2311.5454zm7.3637 4.5725c-.0169.1768-.0358.376-.0618.5959l-.146.4383a.3547.3547 0 0 0-.0182.1077c-.0059.4747-.054.6489-.115.8693-.0634.2292-.1353.4891-.1794 1.0575-.11 1.4143-.8782 2.2267-2.4172 2.5565-1.5155.3251-1.7843-.4968-2.0212-1.2217a6.5824 6.5824 0 0 0-.0769-.2266c-.2154-.5858-.1911-1.4119-.1574-2.5551.0165-.5612-.0249-1.9013-.3302-2.6462.0044-.2932.0106-.5909.019-.8918a.3529.3529 0 0 0-.0153-.1126 1.4927 1.4927 0 0 0-.0439-.208c-.1226-.4283-.4213-.7866-.7797-.9351-.1424-.059-.4038-.1672-.7178-.0869.067-.276.1831-.5875.309-.9249l.0529-.142c.0595-.16.134-.3257.213-.5012.4265-.9476 1.0106-2.2453.3766-5.1772-.2374-1.0981-1.0304-1.6343-2.2324-1.5098-.7207.0746-1.3799.3654-1.7088.5321a5.6716 5.6716 0 0 0-.1958.1041c.0918-1.1064.4386-3.1741 1.7357-4.4823a4.0306 4.0306 0 0 1 .3033-.276.3532.3532 0 0 0 .1447-.0644c.7524-.5706 1.6945-.8506 2.802-.8325.4091.0067.8017.0339 1.1742.081 1.939.3544 3.2439 1.4468 4.0359 2.3827.8143.9623 1.2552 1.9315 1.4312 2.4543-1.3232-.1346-2.2234.1268-2.6797.779-.9926 1.4189.543 4.1729 1.2811 5.4964.1353.2426.2522.4522.2889.5413.2403.5825.5515.9713.7787 1.2552.0696.087.1372.1714.1885.245-.4008.1155-1.1208.3825-1.0552 1.717-.0123.1563-.0423.4469-.0834.8148-.0461.2077-.0702.4603-.0994.7662zm.8905-1.6211c-.0405-.8316.2691-.9185.5967-1.0105a2.8566 2.8566 0 0 0 .135-.0406 1.202 1.202 0 0 0 .1342.103c.5703.3765 1.5823.4213 3.0068.1344-.2016.1769-.5189.3994-.9533.6011-.4098.1903-1.0957.333-1.7473.3636-.7197.0336-1.0859-.0807-1.1721-.151zm.5695-9.2712c-.0059.3508-.0542.6692-.1054 1.0017-.055.3576-.112.7274-.1264 1.1762-.0142.4368.0404.8909.0932 1.3301.1066.887.216 1.8003-.2075 2.7014a3.5272 3.5272 0 0 1-.1876-.3856c-.0527-.1276-.1669-.3326-.3251-.6162-.6156-1.1041-2.0574-3.6896-1.3193-4.7446.3795-.5427 1.3408-.5661 2.1781-.463zm.2284 7.0137a12.3762 12.3762 0 0 0-.0853-.1074l-.0355-.0444c.7262-1.1995.5842-2.3862.4578-3.4385-.0519-.4318-.1009-.8396-.0885-1.2226.0129-.4061.0666-.7543.1185-1.0911.0639-.415.1288-.8443.1109-1.3505.0134-.0531.0188-.1158.0118-.1902-.0457-.4855-.5999-1.938-1.7294-3.253-.6076-.7073-1.4896-1.4972-2.6889-2.0395.5251-.1066 1.2328-.2035 2.0244-.1859 2.0515.0456 3.6746.8135 4.8242 2.2824a.908.908 0 0 1 .0667.1002c.7231 1.3556-.2762 6.2751-2.9867 10.5405zm-8.8166-6.1162c-.025.1794-.3089.4225-.6211.4225a.5821.5821 0 0 1-.0809-.0056c-.1873-.026-.3765-.144-.5059-.3156-.0458-.0605-.1203-.178-.1055-.2844.0055-.0401.0261-.0985.0925-.1488.1182-.0894.3518-.1226.6096-.0867.3163.0441.6426.1938.6113.4186zm7.9305-.4114c.0111.0792-.049.201-.1531.3102-.0683.0717-.212.1961-.4079.2232a.5456.5456 0 0 1-.075.0052c-.2935 0-.5414-.2344-.5607-.3717-.024-.1765.2641-.3106.5611-.352.297-.0414.6111.0088.6356.1851z"/></svg>',
    posthog: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>PostHog</title><path d="M9.854 14.5 5 9.647.854 5.5A.5.5 0 0 0 0 5.854V8.44a.5.5 0 0 0 .146.353L5 13.647l.147.146L9.854 18.5l.146.147v-.049c.065.03.134.049.207.049h2.586a.5.5 0 0 0 .353-.854L9.854 14.5zm0-5-4-4a.487.487 0 0 0-.409-.144.515.515 0 0 0-.356.21.493.493 0 0 0-.089.288V8.44a.5.5 0 0 0 .147.353l9 9a.5.5 0 0 0 .853-.354v-2.585a.5.5 0 0 0-.146-.354l-5-5zm1-4a.5.5 0 0 0-.854.354V8.44a.5.5 0 0 0 .147.353l4 4a.5.5 0 0 0 .853-.354V9.854a.5.5 0 0 0-.146-.354l-4-4zm12.647 11.515a3.863 3.863 0 0 1-2.232-1.1l-4.708-4.707a.5.5 0 0 0-.854.354v6.585a.5.5 0 0 0 .5.5H23.5a.5.5 0 0 0 .5-.5v-.6c0-.276-.225-.497-.499-.532zm-5.394.032a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6zM.854 15.5a.5.5 0 0 0-.854.354v2.293a.5.5 0 0 0 .5.5h2.293c.222 0 .39-.135.462-.309a.493.493 0 0 0-.109-.545L.854 15.501zM5 14.647.854 10.5a.5.5 0 0 0-.854.353v2.586a.5.5 0 0 0 .146.353L4.854 18.5l.146.147h2.793a.5.5 0 0 0 .353-.854L5 14.647z"/></svg>',
    redis: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Redis</title><path d="M22.71 13.145c-1.66 2.092-3.452 4.483-7.038 4.483-3.203 0-4.397-2.825-4.48-5.12.701 1.484 2.073 2.685 4.214 2.63 4.117-.133 6.94-3.852 6.94-7.239 0-4.05-3.022-6.972-8.268-6.972-3.752 0-8.4 1.428-11.455 3.685C2.59 6.937 3.885 9.958 4.35 9.626c2.648-1.904 4.748-3.13 6.784-3.744C8.12 9.244.886 17.05 0 18.425c.1 1.261 1.66 4.648 2.424 4.648.232 0 .431-.133.664-.365a100.49 100.49 0 0 0 5.54-6.765c.222 3.104 1.748 6.898 6.014 6.898 3.819 0 7.604-2.756 9.33-8.965.2-.764-.73-1.361-1.261-.73zm-4.349-5.013c0 1.959-1.926 2.922-3.685 2.922-.941 0-1.664-.247-2.235-.568 1.051-1.592 2.092-3.225 3.21-4.973 1.972.334 2.71 1.43 2.71 2.619z"/></svg>',
    replicate: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Replicate</title><path d="M24 10.262v2.712h-9.518V24h-3.034V10.262zm0-5.131v2.717H8.755V24H5.722V5.131zM24 0v2.717H3.034V24H0V0z"/></svg>',
    resend: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Resend</title><path d="M14.679 0c4.648 0 7.413 2.765 7.413 6.434s-2.765 6.434-7.413 6.434H12.33L24 24h-8.245l-8.88-8.44c-.636-.588-.93-1.273-.93-1.86 0-.831.587-1.565 1.713-1.883l4.574-1.224c1.737-.465 2.936-1.81 2.936-3.572 0-2.153-1.761-3.4-3.939-3.4H0V0z"/></svg>',
    sentry: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Sentry</title><path d="M13.91 2.505c-.873-1.448-2.972-1.448-3.844 0L6.904 7.92a15.478 15.478 0 0 1 8.53 12.811h-2.221A13.301 13.301 0 0 0 5.784 9.814l-2.926 5.06a7.65 7.65 0 0 1 4.435 5.848H2.194a.365.365 0 0 1-.298-.534l1.413-2.402a5.16 5.16 0 0 0-1.614-.913L.296 19.275a2.182 2.182 0 0 0 .812 2.999 2.24 2.24 0 0 0 1.086.288h6.983a9.322 9.322 0 0 0-3.845-8.318l1.11-1.922a11.47 11.47 0 0 1 4.95 10.24h5.915a17.242 17.242 0 0 0-7.885-15.28l2.244-3.845a.37.37 0 0 1 .504-.13c.255.14 9.75 16.708 9.928 16.9a.365.365 0 0 1-.327.543h-2.287c.029.612.029 1.223 0 1.831h2.297a2.206 2.206 0 0 0 1.922-3.31z"/></svg>',
    squarespace: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Squarespace</title><path d="M22.655 8.719c-1.802-1.801-4.726-1.801-6.564 0l-7.351 7.35c-.45.45-.45 1.2 0 1.65.45.449 1.2.449 1.65 0l7.351-7.351c.899-.899 2.362-.899 3.264 0 .9.9.9 2.364 0 3.264l-7.239 7.239c.9.899 2.362.899 3.263 0l5.589-5.589c1.836-1.838 1.836-4.763.037-6.563zm-2.475 2.437c-.451-.45-1.201-.45-1.65 0l-7.354 7.389c-.9.899-2.361.899-3.262 0-.45-.45-1.2-.45-1.65 0s-.45 1.2 0 1.649c1.801 1.801 4.726 1.801 6.564 0l7.351-7.35c.449-.487.449-1.239.001-1.688zm-2.439-7.35c-1.801-1.801-4.726-1.801-6.564 0l-7.351 7.351c-.45.449-.45 1.199 0 1.649s1.2.45 1.65 0l7.395-7.351c.9-.899 2.371-.899 3.27 0 .451.45 1.201.45 1.65 0 .421-.487.421-1.199-.029-1.649h-.021zm-2.475 2.437c-.45-.45-1.2-.45-1.65 0l-7.351 7.389c-.899.9-2.363.9-3.265 0-.9-.899-.9-2.363 0-3.264l7.239-7.239c-.9-.9-2.362-.9-3.263 0L1.35 8.719c-1.8 1.8-1.8 4.725 0 6.563 1.801 1.801 4.725 1.801 6.564 0l7.35-7.351c.451-.488.451-1.238 0-1.688h.002z"/></svg>',
    supabase: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Supabase</title><path d="M11.9 1.036c-.015-.986-1.26-1.41-1.874-.637L.764 12.05C-.33 13.427.65 15.455 2.409 15.455h9.579l.113 7.51c.014.985 1.259 1.408 1.873.636l9.262-11.653c1.093-1.375.113-3.403-1.645-3.403h-9.642z"/></svg>',
    telegram: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Telegram</title><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>',
    temporal: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Temporal</title><path d="M16.206 7.794C15.64 3.546 14.204 0 12 0 9.796 0 8.361 3.546 7.794 7.794 3.546 8.36 0 9.796 0 12c0 2.204 3.546 3.639 7.794 4.206C8.36 20.453 9.796 24 12 24c2.204 0 3.639-3.546 4.206-7.794C20.454 15.64 24 14.204 24 12c0-2.204-3.547-3.64-7.794-4.206Zm-8.55 7.174c-4.069-.587-6.44-1.932-6.44-2.969 0-1.036 2.372-2.381 6.44-2.969-.09.98-.137 1.98-.137 2.97 0 .99.047 1.99.137 2.968zM12 1.215c1.036 0 2.381 2.372 2.969 6.44a32.718 32.718 0 0 0-5.938 0c.587-4.068 1.932-6.44 2.969-6.44Zm4.344 13.753c-.2.03-1.022.126-1.23.146-.02.209-.117 1.03-.145 1.23-.588 4.068-1.933 6.44-2.97 6.44-1.036 0-2.38-2.372-2.968-6.44-.03-.2-.126-1.022-.147-1.23a31.833 31.833 0 0 1 0-6.23 31.813 31.813 0 0 1 7.46.146c4.068.587 6.442 1.933 6.442 2.969-.001 1.036-2.374 2.382-6.442 2.97z"/></svg>',
    tiktok: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>TikTok</title><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>',
    twilio: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path fill="#f22f46" d="M48 92.309c16.41 0 16.41-24.618 0-24.618S31.59 92.31 48 92.31Zm0-32c16.41 0 16.41-24.618 0-24.618S31.59 60.31 48 60.31Zm32 32c16.41 0 16.41-24.618 0-24.618S63.59 92.31 80 92.31Zm0-32c16.41 0 16.41-24.618 0-24.618S63.59 60.31 80 60.31ZM64 0c34.664 0 64 29.336 64 64s-29.336 64-64 64S0 98.664 0 64 29.336 0 64 0Zm0 17.23c-25.758 0-46.77 20.286-46.77 45.91 0 25.626 21.012 47.63 46.77 47.63 25.758 0 46.77-22.004 46.77-47.63 0-25.624-21.012-45.91-46.77-45.91Zm0 0"/></svg>',
    vercel: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Vercel</title><path d="m12 1.608 12 20.784H0Z"/></svg>',
    zapier: '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Zapier</title><path d="M4.157 0A4.151 4.151 0 0 0 0 4.161v15.678A4.151 4.151 0 0 0 4.157 24h15.682A4.152 4.152 0 0 0 24 19.839V4.161A4.152 4.152 0 0 0 19.839 0H4.157Zm10.61 8.761h.03a.577.577 0 0 1 .23.038.585.585 0 0 1 .201.124.63.63 0 0 1 .162.431.612.612 0 0 1-.162.435.58.58 0 0 1-.201.128.58.58 0 0 1-.23.042.529.529 0 0 1-.235-.042.585.585 0 0 1-.332-.328.559.559 0 0 1-.038-.235.613.613 0 0 1 .17-.431.59.59 0 0 1 .405-.162Zm2.853 1.572c.03.004.061.004.095.004.325-.011.646.064.937.219.238.144.431.355.552.609.128.279.189.582.185.888v.193a2 2 0 0 1 0 .219h-2.498c.003.227.075.45.204.642a.78.78 0 0 0 .646.265.714.714 0 0 0 .484-.136.642.642 0 0 0 .23-.318l.915.257a1.398 1.398 0 0 1-.28.537c-.14.159-.321.284-.521.355a2.234 2.234 0 0 1-.836.136 1.923 1.923 0 0 1-1.001-.245 1.618 1.618 0 0 1-.665-.703 2.221 2.221 0 0 1-.227-1.036 1.95 1.95 0 0 1 .48-1.398 1.9 1.9 0 0 1 1.3-.488Zm-9.607.023c.162.004.325.026.48.079.207.065.4.174.563.314.26.302.393.692.366 1.088v2.276H8.53l-.109-.711h-.065c-.064.163-.155.31-.272.439a1.122 1.122 0 0 1-.374.264 1.023 1.023 0 0 1-.453.083 1.334 1.334 0 0 1-.866-.264.965.965 0 0 1-.329-.801.993.993 0 0 1 .076-.431 1.02 1.02 0 0 1 .242-.363 1.478 1.478 0 0 1 1.043-.303h.952v-.181a.696.696 0 0 0-.136-.454.553.553 0 0 0-.438-.154.695.695 0 0 0-.378.086.48.48 0 0 0-.193.254l-.99-.144a1.26 1.26 0 0 1 .257-.563c.14-.174.321-.302.533-.378.261-.091.54-.136.82-.129.053-.003.106-.007.163-.007Zm4.384.007c.174 0 .347.038.506.114.182.083.34.211.458.374.257.423.377.911.351 1.406a2.53 2.53 0 0 1-.355 1.448 1.148 1.148 0 0 1-1.009.517c-.204 0-.401-.045-.582-.136a1.052 1.052 0 0 1-.48-.457 1.298 1.298 0 0 1-.114-.234h-.045l.004 1.784h-1.059v-4.713h.904l.117.805h.057c.068-.208.177-.401.328-.56a1.129 1.129 0 0 1 .843-.344h.076v-.004Zm7.559.084h.903l.113.805h.053a1.37 1.37 0 0 1 .235-.484.813.813 0 0 1 .313-.242.82.82 0 0 1 .39-.076h.234v1.051h-.401a.662.662 0 0 0-.313.008.623.623 0 0 0-.272.155.663.663 0 0 0-.174.26.683.683 0 0 0-.027.314v1.875h-1.054v-3.666Zm-17.515.003h3.262v.896L3.73 13.104l.034.113h1.973l.042.9H2.4v-.9l1.931-1.754-.045-.117H2.441v-.896Zm11.815 0h1.055v3.659h-1.055V10.45Zm3.443.684.019.016a.69.69 0 0 0-.351.045.756.756 0 0 0-.287.204c-.11.155-.174.336-.189.522h1.545c-.034-.526-.257-.787-.74-.787h.003Zm-5.718.163c-.026 0-.057 0-.083.004a.78.78 0 0 0-.31.053.746.746 0 0 0-.257.189 1.016 1.016 0 0 0-.204.695v.064c-.015.257.057.507.204.711a.634.634 0 0 0 .253.196.638.638 0 0 0 .314.061.644.644 0 0 0 .578-.265c.14-.223.204-.48.189-.74a1.216 1.216 0 0 0-.181-.711.677.677 0 0 0-.503-.257Zm-4.509 1.266a.464.464 0 0 0-.268.102.373.373 0 0 0-.114.276c0 .053.008.106.027.155a.375.375 0 0 0 .087.132.576.576 0 0 0 .397.11v.004a.863.863 0 0 0 .563-.182.573.573 0 0 0 .211-.457v-.14h-.903Z"/></svg>',
    // Brand-owned marks — single source of truth is brand/designSystem/icons.js
    analytics: (0, $5IvaF.default).analytics,
    auth0: (0, $5IvaF.default).auth0,
    database: (0, $5IvaF.default).database,
    discord: (0, $5IvaF.default).discord,
    facebook: (0, $5IvaF.default).facebook,
    figma: (0, $5IvaF.default).figma,
    firebase: (0, $5IvaF.default).firebase,
    github: (0, $5IvaF.default).github,
    instagram: (0, $5IvaF.default).instagram,
    linkedin: (0, $5IvaF.default).linkedin,
    mic: (0, $5IvaF.default).mic,
    npm: (0, $5IvaF.default).npm,
    slack: (0, $5IvaF.default).slack,
    stripe: (0, $5IvaF.default).stripe
};

});


parcelRegister("lG24I", function(module, exports) {

$parcel$export(module.exports, "cleanRoute", () => $fc7f214d08c276e6$export$7d27c2c31873fdd0);
$parcel$export(module.exports, "normalizePages", () => $fc7f214d08c276e6$export$a00a3520afe34ff9);
$parcel$export(module.exports, "buildNav", () => $fc7f214d08c276e6$export$9b0a37887f0339d6);
$parcel$export(module.exports, "buildAppShell", () => $fc7f214d08c276e6$export$45c5fca219f8da04);
// multiPageApp.js — pure assembly for AI-generated MULTI-PAGE apps (the /studio
// "create a full app from a prompt" path). Dependency-free (no smbls / no DOM) so
// it's unit-testable under `node --test`.
//
// WHY THIS EXISTS
// An "extension" is a Project with ONE source page rendered instantly via
// createIframeApp (no frank/publish). A full app is the SAME model with N source
// pages + a nav app-shell. renderMultiPageApp (functions/index.js) parses each
// page, seeds the shared root state, then hands { pages, app-shell } to
// createIframeApp. This module owns the PURE parts: normalizing the page list
// (routes/titles) and building the deterministic nav app-shell — the two pieces
// worth pinning with tests.
//
// THE APP-SHELL — state-based page switcher (NOT the framework URL router).
// The framework's `content`-outlet router does NOT fire through the
// createIframeApp embed path (verified live: the reserved `content` key renders
// its props as literal children and the RenderRouter lifecycle never triggers in
// the reduced iframe boot). Rather than reach into router internals across the
// realm boundary, the shell switches pages via reactive state — the robust,
// verified DOMQL pattern:
//   - the shell's own state `_appRoute` holds the active route (default '/')
//   - every page mounts as a `hide`-gated child (`hide` is the ONE reactive
//     visibility toggle in v3.14; only the active page shows)
//   - each nav button sets `_appRoute` on click
// This is fully client-side, deterministic, and free of the router-through-embed
// fragility. Real URL routing (deep-linkable) is a deferred enhancement that
// would need router init wired into the shared createIframeApp boot.
// Normalize a route string to a URL-safe path: lowercase, '/'-prefixed, spaces
// and punctuation → single hyphens, collapsed slashes, no trailing slash.
const $fc7f214d08c276e6$export$7d27c2c31873fdd0 = (route)=>{
    let r = String(route || '').trim().toLowerCase();
    if (!r || r === '/') return '/';
    if (r[0] !== '/') r = '/' + r;
    // Keep slashes (nested routes) and alphanumerics; everything else → '-'.
    r = '/' + r.slice(1).replace(/[^a-z0-9/]+/g, '-').replace(/-*\/-*/g, '/').replace(/^-+|-+$/g, '');
    r = r.replace(/\/+/g, '/').replace(/\/$/, '');
    return r || '/';
};
// Derive a human title from a route SLUG when the model didn't supply one. The
// root route has no slug — its word comes from the caller (`labels.home` below).
const $fc7f214d08c276e6$var$_mpaTitleFromRoute = (route)=>{
    const seg = String(route || '/').split('/').filter(Boolean).pop();
    if (!seg) return '';
    return seg.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase()).trim();
};
const $fc7f214d08c276e6$export$a00a3520afe34ff9 = (pages, labels = {})=>{
    const list = Array.isArray(pages) ? pages : [];
    const out = [];
    const seen = new Set();
    for (const p of list){
        const source = p && typeof p.source === 'string' ? p.source.trim() : '';
        if (!source) continue;
        const isFirst = out.length === 0;
        let route = isFirst ? '/' : $fc7f214d08c276e6$export$7d27c2c31873fdd0(p && p.route);
        if (seen.has(route)) {
            const base = route === '/' ? '/page' : route;
            let n = 2;
            while(seen.has(`${base}-${n}`))n += 1;
            route = `${base}-${n}`;
        }
        seen.add(route);
        const rawTitle = p && typeof p.title === 'string' ? p.title.trim() : '';
        const title = rawTitle || (route === '/' ? labels.home || '' : $fc7f214d08c276e6$var$_mpaTitleFromRoute(route));
        out.push({
            route: route,
            title: title,
            source: source
        });
    }
    // Guarantee a '/' entry exists even if the first survivor was reassigned.
    if (out.length && !out.some((p)=>p.route === '/')) out[0].route = '/';
    return out;
};
const $fc7f214d08c276e6$export$9b0a37887f0339d6 = (normalizedPages)=>(normalizedPages || []).map((p)=>({
            route: p.route,
            title: p.title
        }));
const $fc7f214d08c276e6$export$45c5fca219f8da04 = ({ name: name, nav: nav, pageDefs: pageDefs, seedState: seedState, appLabel: appLabel } = {})=>{
    // Nav buttons — key `NavBtn_N` (PascalCase, uniqueness via `_N`). Each sets the
    // active route; active button wears the house active-state (title text + weight).
    const navChildren = {};
    (nav || []).forEach((n, i)=>{
        navChildren[`NavBtn_${i + 1}`] = {
            tag: 'button',
            type: 'button',
            text: n.title,
            border: '0',
            background: 'none',
            cursor: 'pointer',
            padding: 'Y Z1',
            round: 'X2',
            fontWeight: (el, s)=>s._appRoute === n.route ? '600' : '500',
            color: (el, s)=>s._appRoute === n.route ? 'title' : 'caption',
            onClick: (e, el, s)=>s.update({
                    _appRoute: n.route
                })
        };
    });
    // Page slots — key `Page_N`. Each wraps the parsed page def and shows only when
    // its route is active. The wrapper carries NO inline `display` (no flow/align),
    // so `hide` (→ display:none) applies cleanly instead of losing to an inline
    // display the way it does over a flex child (domql-hide-loses-to-inline-display).
    const pageChildren = {};
    Object.entries(pageDefs || {}).forEach(([route, def], i)=>{
        pageChildren[`Page_${i + 1}`] = {
            width: '100%',
            display: null,
            hide: (el, s)=>s._appRoute !== route,
            Content: def
        };
    });
    return {
        flow: 'column',
        minHeight: '100%',
        // House page surface — the same design-system theme every native workspace
        // page renders on, so a multi-page app reads like a native module page.
        // (Was a `_paintHostSurface` copy of the host's computed colors while the
        // embed iframe resolved no theme vars; both causes of that are fixed — see
        // _applyPlatformSurface in index.js.)
        theme: 'document',
        overflow: 'hidden',
        // Navigation stays local even when two generated previews share a workspace.
        state: {
            _appRoute: '/',
            ...seedState && typeof seedState === 'object' ? seedState : {}
        },
        Nav: {
            tag: 'nav',
            flow: 'row',
            align: 'center space-between',
            gap: 'C',
            padding: 'B C',
            // App-bar hairline so the nav reads as chrome above the page body.
            flexShrink: '0',
            borderBottomWidth: 'hairline',
            borderBottomStyle: 'solid',
            borderColor: 'line',
            Brand: {
                tag: 'button',
                type: 'button',
                text: name || appLabel || '',
                fontWeight: '700',
                border: '0',
                background: 'none',
                cursor: 'pointer',
                onClick: (e, el, s)=>s.update({
                        _appRoute: '/'
                    })
            },
            Links: {
                flow: 'row',
                align: 'center',
                gap: 'Y',
                ...navChildren
            }
        },
        Body: {
            flex: '1',
            minHeight: '0',
            flow: 'y',
            // Page padding + scroll so each page reads like a workspace module page
            // (the page slots themselves carry no edge spacing).
            padding: 'B C',
            overflowY: 'auto',
            ...pageChildren
        }
    };
};

});

parcelRegister("XpvS7", function(module, exports) {

$parcel$export(module.exports, "crmLeadsVisitorLine", () => $0b294d2a4ee8736c$export$334a4138ae9bf80c);
// crmLeadsVisitorLine.js — the one line a built app's sign-up form shows while
// its CRM sending is on (POB "CRM leads, opt-in per app"; Nika 2026-10-31
// 00:06, STATUS r124 option A):
//
//   en "Your details go to our team so we can contact you."
//   key workspace.apps.crmLeads.visitorLine (packages/shared/i18n/<lang>/workspace.json)
//
// WHO DECIDES. The server: sdk.ai.listExtensions answers `crmLeads: { enabled }`
// on each built-app row (AgentWorkspaceConversationController). A missing
// field reads OFF. The shell never infers it.
//
// WHICH FORM. The one the server reads as a sign-up form
// (server core/utils/appCrmLeadForms.js): an element whose `fetch` holds a
// records `insert` that carries `crmLead` (true, or a map with at least one of
// name / firstName / lastName / email / phone). The line goes INTO that form
// element as its last child, so it sits under the form's fields and its send
// button. An element that is not the form (no `tag: 'form'`, no
// `on: 'submit'`; a click-insert on a button) gets no line: a text inside a
// button would read as the button's label.
//
// WHERE IT RUNS. ONE function for every mount path:
//   - in-shell, after _rewriteFetchDecls (functions/index.js
//     buildInlineExtensionDef / buildInlineMultiPageDef);
//   - in the sandbox frame (functions/sandboxFrameBoot.js), which receives this
//     function as TEXT (sandboxBootstrapSource). So it is SELF-CONTAINED: no
//     closure over this module, no imports, ES2017 syntax only (no object
//     spread, no optional chaining), like sandboxFrameBoot itself.
// The text resolves through `el.call('polyglot', …)`: the shell's polyglot
// in-shell, the frame's pushed-bundle lookup in the sandbox.
//
// Walks element DEFINITIONS (never DOM), skips `state` / `fetch` / `scope` /
// `data` and function values (a `children` factory's rows are not walked: a
// sign-up form is a page part, not a list row). Idempotent: a definition that
// already has the line is left alone. Mutates `definition`; returns how many
// lines it added.
function $0b294d2a4ee8736c$export$334a4138ae9bf80c(definition, crmLeads) {
    'use strict';
    if (!crmLeads || typeof crmLeads !== 'object' || crmLeads.enabled !== true) return 0;
    if (!definition || typeof definition !== 'object') return 0;
    var LINE_KEY = 'CrmLeadsVisitorLine';
    var FIELD_KEYS = [
        'name',
        'firstName',
        'lastName',
        'email',
        'phone'
    ];
    var SKIP = {
        state: 1,
        fetch: 1,
        scope: 1,
        data: 1,
        attr: 1,
        style: 1
    };
    var seen = [];
    var added = 0;
    var marksLead = function(mark) {
        if (mark === true) return true;
        if (!mark || typeof mark !== 'object') return false;
        for(var i = 0; i < FIELD_KEYS.length; i++){
            var v = mark[FIELD_KEYS[i]];
            if (typeof v === 'string' && v.trim()) return true;
        }
        return false;
    };
    var onSubmit = function(on) {
        if (on === 'submit') return true;
        return Array.isArray(on) && on.indexOf('submit') !== -1;
    };
    // a records insert with a crmLead mark; `from` is bare in the frame and
    // namespaced (workspaceProject.records) after the in-shell rewrite
    var leadDecl = function(d) {
        if (!d || typeof d !== 'object' || !marksLead(d.crmLead)) return null;
        if (d.from !== 'records' && d.from !== 'workspaceProject.records') return null;
        if (d.method !== 'insert') return null;
        return d;
    };
    var isSignupForm = function(def) {
        var list = Array.isArray(def.fetch) ? def.fetch : [
            def.fetch
        ];
        for(var i = 0; i < list.length; i++){
            var d = leadDecl(list[i]);
            if (d && (def.tag === 'form' || onSubmit(d.on))) return true;
        }
        return false;
    };
    var visit = function(def) {
        if (!def || typeof def !== 'object' || seen.indexOf(def) !== -1) return;
        seen.push(def);
        if (Array.isArray(def)) {
            for(var i = 0; i < def.length; i++)visit(def[i]);
            return;
        }
        for(var k in def){
            if (SKIP[k] === 1 || k === LINE_KEY) continue;
            var v = def[k];
            if (v && typeof v === 'object') visit(v);
        }
        if (def.fetch && typeof def.fetch === 'object' && !def[LINE_KEY] && isSignupForm(def)) {
            def[LINE_KEY] = {
                extends: 'AppFieldHint',
                tag: 'p',
                margin: '0',
                text: function(el) {
                    return el.call('polyglot', 'workspace.apps.crmLeads.visitorLine');
                },
                hide: false
            };
            added++;
        }
    };
    visit(definition);
    return added;
}

});

parcelRegister("jPn99", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("iq5w1"))) : import("iq5w1")).then(()=>parcelRequire('6aLoQ'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("gOp2u", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("8fLx8"))) : import("8fLx8")).then(()=>parcelRequire('gZ6BV'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("aNDji", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};

Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = Promise.all([
            (parcelRequire("l6CkT"))(import.meta.resolve("cREu5")),
            $smblsAttempt ? import($smblsAddress(import.meta.resolve("J1MAH"))) : import("J1MAH")
        ]).then(()=>parcelRequire('bWG83'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});
parcelRegister("l6CkT", function(module, exports) {
"use strict";

var $31tos = parcelRequire("31tos");
module.exports = $31tos(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("31tos", function(module, exports) {
"use strict";
var $2338440511b4b3f9$var$cachedBundles = {};
var $2338440511b4b3f9$var$cachedPreloads = {};
var $2338440511b4b3f9$var$cachedPrefetches = {};
function $2338440511b4b3f9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $2338440511b4b3f9$var$cachedPreloads;
        case 'prefetch':
            return $2338440511b4b3f9$var$cachedPrefetches;
        default:
            return $2338440511b4b3f9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $2338440511b4b3f9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("l9i79", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("gOE3c"))) : import("gOE3c")).then(()=>parcelRequire('jU3m2'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("17dat", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("3fHP6"))) : import("3fHP6")).then(()=>parcelRequire('ecc2Q'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("8z3sU", function(module, exports) {

$parcel$export(module.exports, "formatTime", () => $63c447bb7a84e5f2$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatMonthShort", () => $63c447bb7a84e5f2$export$81711723c5a14da7);
$parcel$export(module.exports, "formatShortDate", () => $63c447bb7a84e5f2$export$62a922abef97e45e);
$parcel$export(module.exports, "SANDBOX_FORMATTERS", () => $63c447bb7a84e5f2$export$ac30bd3e30dbca3d);
// sandboxFormatters.js — the pure helpers a generated app may el.call
// (APP_EL_CALL_ALLOWLIST, besides polyglot): ONE source for the shell (which
// re-exports them from functions/index.js) and the sandbox frame (whose
// bootstrap receives them as text — sandboxFrameBoot.js). Each function is
// SELF-CONTAINED: no module-scope name, only frame-realm globals (Date,
// String, Number), so its .toString() runs the same in the opaque frame.
// toLocale*String reuses the engine's own formatter cache, so no module
// cache is needed. __tests__/sandboxFormatters.test.js holds them: outputs,
// one source, free names, and the frame registry.
// formatTime and formatMonthShort keep the exact semantics of the
// Intl.DateTimeFormat#format they replaced: `undefined` is now, any other
// value goes through Number() (a date STRING is NaN), and NaN throws
// RangeError — measured equal over a 2,863-row grid of inputs and zones.
// Clock time, "1:07pm" (en-US, 12-hour, lower case, no space); an unknown
// time zone falls back to the local zone.
const $63c447bb7a84e5f2$export$3203edd9e5edd663 = (ts, tz)=>{
    if (!ts) return '';
    const t = Number(ts);
    if (Number.isNaN(t)) throw new RangeError('Invalid time value');
    try {
        return new Date(t).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            timeZone: tz,
            hour12: true
        }).toLowerCase().replace(' ', '');
    } catch  {
        return new Date(t).toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    }
};
// Short month name, "Oct".
const $63c447bb7a84e5f2$export$81711723c5a14da7 = (ts)=>{
    const t = ts === undefined ? Date.now() : Number(ts);
    if (Number.isNaN(t)) throw new RangeError('Invalid time value');
    return new Date(t).toLocaleDateString('en', {
        month: 'short'
    });
};
// Compact numeric date for data-dense rows, "22.06.2022" (dotted so it reads
// as data next to a Code-mono amount or time).
const $63c447bb7a84e5f2$export$62a922abef97e45e = (ts)=>{
    if (!ts) return '';
    try {
        const d = new Date(ts);
        if (Number.isNaN(d.getTime())) return '';
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        return `${dd}.${mm}.${d.getFullYear()}`;
    } catch  {
        return '';
    }
};
const $63c447bb7a84e5f2$export$ac30bd3e30dbca3d = Object.freeze({
    formatShortDate: $63c447bb7a84e5f2$export$62a922abef97e45e,
    formatMonthShort: $63c447bb7a84e5f2$export$81711723c5a14da7,
    formatTime: $63c447bb7a84e5f2$export$3203edd9e5edd663
});

});

parcelRegister("cGe9G", function(module, exports) {

$parcel$export(module.exports, "aiStream", () => $93b46338d6fe5528$export$878a61b0c0af99dd);
$parcel$export(module.exports, "aiActionStyles", () => $93b46338d6fe5528$export$521c301728abae36);
$parcel$export(module.exports, "aiSuggestions", () => $93b46338d6fe5528$export$8b7c0f192bda3159);
$parcel$export(module.exports, "fetchPendingApprovals", () => $93b46338d6fe5528$export$b1f4fbd50795be9a);
$parcel$export(module.exports, "aiWelcomeText", () => $93b46338d6fe5528$export$685f2c86cb5ea7a0);
$parcel$export(module.exports, "aiPerformAction", () => $93b46338d6fe5528$export$34f4b73b6bb5f6f9);
$parcel$export(module.exports, "subscribeTicketRealtime", () => $93b46338d6fe5528$export$e213f1f9272c4814);
$parcel$export(module.exports, "unsubscribeTicketRealtime", () => $93b46338d6fe5528$export$7d639d10c28c9b0);
$parcel$export(module.exports, "subscribeAskUserDecisions", () => $93b46338d6fe5528$export$627cf069d880166);
$parcel$export(module.exports, "unsubscribeAskUserDecisions", () => $93b46338d6fe5528$export$12cbdb1a6df3b3d3);
$parcel$export(module.exports, "fetchAskUserDecisions", () => $93b46338d6fe5528$export$f5dedbcee30f8802);
$parcel$export(module.exports, "approveDecisionTicket", () => $93b46338d6fe5528$export$c0aa80f425725705);
$parcel$export(module.exports, "rejectDecisionTicket", () => $93b46338d6fe5528$export$ea8f8215074947cf);
$parcel$export(module.exports, "clarifyDecisionTicket", () => $93b46338d6fe5528$export$dcf4229e34a598a4);
// Intranet-side AI assistant wiring for the shared AppAssistant component.
//
// The shared AppAssistant (workspace/packages/shared/components/AppAssistant.js)
// calls these via `el.call('...')`:
//
//   - aiStream(messages, attachment, onChunk, onDone)
//       Streams the AI response to the governance ai-chat edge function
//       and burns credits via the shared credit-meter.
//
//   - aiPerformAction(action, s)
//       Dispatches a confirmed action proposed by the assistant
//       (create_ticket, create_event, create_note, create_kb,
//        update_ticket, move_ticket).
//
//   - aiActionStyles()
//       Returns the icon/color/label map used for proposed-action cards.
//
//   - aiSuggestions()
//       Returns the starter prompts shown in the Welcome view.
//
//   - aiWelcomeText()
//       Returns the Welcome copy shown above the suggestions.
//
//   - fetchPendingApprovals()  — TASK#4360
//       Returns tickets in state='awaiting_approval' for the governance
//       workspace. Server-side, the ai-chat edge function injects the same
//       data into the AI prompt; this client helper exists so non-AI
//       surfaces (or future inline cards) can surface the count/list with
//       the same query and avoid drift.
//
// Canvas registers nothing; the toggle button self-hides when
// `context.functions.aiStream` is absent.
//
//   - subscribeTicketRealtime(root)
//       Subscribes to ticket updates over the SDK realtime channel. On state
//       transitions (→done, blocked→in_progress, →awaiting_approval) for
//       tickets whose metadata.simona_user_id matches the signed-in user,
//       injects a system message into root.assistantMessages so Simona
//       auto-surfaces the update in the thread.
//
//   - unsubscribeTicketRealtime()
//       Removes the realtime channel opened by subscribeTicketRealtime.
// migrated 2026-04-27 — getSupabase + sb.channel/removeChannel replaced by
// the SDK realtime API (`workspaceProject.realtime.tickets` subscribe).
// migrated 2026-05-20 — raw Supabase ai-chat fetch replaced by SDK
// `sdk.aiChat.stream` (Mongo-backed, server holds the provider keys).
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");

var $gzr3m = parcelRequire("gzr3m");
const $93b46338d6fe5528$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// Credit metering for ai-chat now happens server-side inside the
// AiChatService — server knows the actual token count from the AI
// provider response, so client-side estimation is inherently
// inaccurate AND trivially manipulable from the browser.
// See server/packages/credit-meter for the canonical burn primitive.
// Builds a workspace-context prefix appended to the server's system prompt
// so the AI knows which Symbols app surface the user is on.
// `el` — the DOMQL element that called aiStream (via `el.call('aiStream', ...)`).
// Returns a string to inject, or null when context is unavailable.
const $93b46338d6fe5528$var$_buildAppContext = (el)=>{
    try {
        const root = el?.state?.root || el?.context?.state;
        const path = (typeof window !== 'undefined' ? window.location.pathname : null) || root?.currentPath || '/';
        const user = root?.currentUser;
        const workspace = root?.activeWorkspace;
        const orgName = workspace?.name || workspace?.title || null;
        const lines = [
            'CURRENT APP CONTEXT:',
            `  Surface: Symbols Workspace intranet (workspace.localhost / workspace.symbols.app)`,
            `  Current route: ${path}`
        ];
        if (orgName) lines.push(`  Active workspace: ${orgName}`);
        if (user?.name) lines.push(`  Signed-in user: ${user.name} (${user.email || ''})`.trim());
        lines.push('', 'You have knowledge of the Symbols workspace app features: calendar, chat, tickets, documents, people directory, announcements, company pages, and data. Answer questions about any of these surfaces using the context above.');
        return lines.join('\n');
    } catch (_) {
        return null;
    }
};
// Pull the text to send out of the caller's message list. `sdk.ai.stream`
// resolves ONE turn against a server-side conversation, which is where the
// history lives — the array is the caller's local view of it, and only its
// newest user turn is new information.
const $93b46338d6fe5528$var$_latestUserText = (messages)=>{
    const list = Array.isArray(messages) ? messages : [];
    for(let i = list.length - 1; i >= 0; i--){
        const m = list[i];
        if (!m || m.role && m.role !== 'user') continue;
        const t = typeof m === 'string' ? m : m.content || m.text || '';
        if (typeof t === 'string' && t.trim()) return t.trim();
    }
    // A bare string, or a list of plain strings.
    if (typeof messages === 'string' && messages.trim()) return messages.trim();
    return '';
};
const $93b46338d6fe5528$export$878a61b0c0af99dd = async function aiStream(messages, attachment, onChunk, onDone, opts = {}) {
    let full = '';
    let settled = false;
    // The client's own replies are bundle sentences. `this` is the element
    // (`el.call('aiStream', …)`); a direct call has none and gets the key.
    const say = (key)=>this && typeof this.call === 'function' ? this.call('polyglot', key) : key;
    const finish = (text)=>{
        if (settled) return;
        settled = true;
        try {
            onDone(text);
        } catch (_) {
        /* swallow */ }
    };
    const content = $93b46338d6fe5528$var$_latestUserText(messages);
    if (!content) {
        // Never post an empty turn — that is precisely how this resurrected a
        // stale thread and answered from it.
        console.warn("[aiAssistant] aiStream called with no user text \u2014 nothing sent.");
        finish('');
        return;
    }
    try {
        const appCtx = $93b46338d6fe5528$var$_buildAppContext(this);
        const root = this?.state?.root || this?.context?.state;
        // Same per-turn context shape simoneAiTransport dispatches, so the server
        // surfaces it in the agent's system instruction the same way.
        let pageCtx = null;
        try {
            const pc = root ? (0, $gzr3m.buildPageContext)(root) : null;
            if (pc && pc.currentPage) pageCtx = {
                currentPage: pc.currentPage,
                pageData: pc.pageData || null,
                pageActions: pc.pageActions || null,
                openView: pc.openView || null,
                uiState: pc.uiState || null
            };
        } catch (_) {
        /* page awareness is best-effort — never block a turn on it */ }
        const ai = await $93b46338d6fe5528$var$shellGetSDK().getService('ai');
        ai.stream({
            content: content,
            attachedCard: attachment || null,
            // Continue the caller's thread when it names one; otherwise START one.
            // Inheriting the workspace's cached thread is never right for a helper
            // that holds no thread of its own — it answers from someone else's
            // conversation.
            conversationId: opts.conversationId || null,
            newConversation: !opts.conversationId,
            context: {
                surface: 'workspace-shell',
                ...appCtx ? {
                    appContext: appCtx
                } : {},
                ...pageCtx || {}
            }
        }, {
            onChunk: (delta)=>{
                full += delta;
                try {
                    onChunk(full);
                } catch (_) {
                /* swallow */ }
            },
            onDone: (payload)=>{
                const finalText = payload?.text || full || say('workspace.ai.reply.empty');
                finish(finalText);
            },
            onError: (err)=>{
                console.error('[aiAssistant] aiStream error:', err);
                finish(say('workspace.ai.reply.connectionError'));
            }
        });
    } catch (e) {
        console.error('[aiAssistant] AI stream failed:', e);
        finish(say('workspace.ai.reply.connectionError'));
    }
};
const $93b46338d6fe5528$export$521c301728abae36 = function aiActionStyles() {
    return {
        create_ticket: {
            icon: 'check',
            color: 'orange',
            label: 'workspace.ai.action.createTicket'
        },
        create_event: {
            icon: 'date outline',
            color: 'blue',
            label: 'workspace.ai.action.createEvent'
        },
        create_note: {
            icon: 'document',
            color: 'green',
            label: 'workspace.ai.action.createNote'
        },
        create_kb: {
            icon: 'document',
            color: 'cerulean',
            label: 'workspace.ai.action.createKb'
        },
        update_ticket: {
            icon: 'edit',
            color: 'yellow',
            label: 'workspace.ai.action.updateTicket'
        },
        move_ticket: {
            icon: 'arrowRight',
            color: 'purple',
            label: 'workspace.ai.action.moveTicket'
        }
    };
};
const $93b46338d6fe5528$export$8b7c0f192bda3159 = function aiSuggestions() {
    return [
        {
            text: this.call('polyglot', 'workspace.ai.suggest.team')
        },
        {
            text: this.call('polyglot', 'workspace.ai.suggest.events')
        },
        {
            text: this.call('polyglot', 'workspace.ai.suggest.documents')
        },
        {
            text: this.call('polyglot', 'workspace.ai.suggest.tasks')
        },
        {
            text: this.call('polyglot', 'workspace.ai.suggest.approvals')
        }
    ];
};
const $93b46338d6fe5528$export$b1f4fbd50795be9a = async function fetchPendingApprovals() {
    try {
        // Phase 4: sdk.tickets.list (Mongo-backed main server).
        const tSvc = await $93b46338d6fe5528$var$shellGetSDK().getService('tickets');
        const result = await tSvc.list({
            state: 'awaiting_approval',
            deleted: false
        }, {
            limit: 50,
            sortBy: 'updatedAt',
            sortDir: 'desc'
        });
        const rows = Array.isArray(result?.data) ? result.data : result?.data || result || [];
        if (!Array.isArray(rows)) return [];
        const now = Date.now();
        return rows.map((t)=>{
            const labels = Array.isArray(t.labels) ? t.labels : [];
            const ts = t.updated_at || t.created_at;
            const ageMs = ts ? now - new Date(ts).getTime() : null;
            return {
                ...t,
                labels: labels,
                ageMs: Number.isFinite(ageMs) && ageMs >= 0 ? ageMs : null,
                needsHumanApproval: labels.includes('human-approval-needed')
            };
        });
    } catch (err) {
        console.error('[aiAssistant] fetchPendingApprovals error:', err);
        return [];
    }
};
const $93b46338d6fe5528$export$685f2c86cb5ea7a0 = function aiWelcomeText() {
    return this.call('polyglot', 'workspace.ai.emptyHint');
};
// Action → [registered function name, payload builder]. `me` is the
// current user's email. Each builder returns the payload to pass into
// the named function via `el.call`.
// `t` is a translate function the caller passes in (`el.call('polyglot', k)`);
// each builder stays self-contained over its parameters, so frank.toJSON can
// revive it without a closure over module scope.
const $93b46338d6fe5528$var$_ACTION_DISPATCH = {
    create_ticket: (a, me, t)=>[
            'saveTicket',
            {
                title: a.title || t('workspace.ai.newRecord.ticket'),
                body: a.body || '',
                columnKey: 'backlog',
                priority: a.priority || 'medium',
                assigneeEmail: a.assignee || me,
                reporterEmail: me
            }
        ],
    create_event: (a, me, t)=>[
            'saveEvent',
            {
                title: a.title || t('workspace.ai.newRecord.event'),
                date: a.date || new Date().toISOString().slice(0, 10),
                startTime: a.startTime || '09:00',
                endTime: a.endTime || '10:00',
                type: 'meeting',
                creatorEmail: me
            }
        ],
    create_note: (a, me, t)=>[
            'createNote',
            {
                title: a.title || t('workspace.ai.newRecord.note'),
                content: a.content || a.body || '',
                source: 'ai'
            }
        ],
    create_kb: (a, me, t)=>[
            'saveKbArticle',
            {
                title: a.title || t('workspace.ai.newRecord.article'),
                category: a.category || t('workspace.ai.newRecord.category'),
                content: a.content || a.body || '',
                summary: (a.content || a.body || '').slice(0, 100)
            }
        ],
    move_ticket: (a)=>[
            'moveTicket',
            {
                ticketId: a.number,
                columnKey: a.column_key,
                position: 0
            }
        ]
};
const $93b46338d6fe5528$export$34f4b73b6bb5f6f9 = function aiPerformAction(a, s) {
    if (!a) return;
    const root = s && s.root || this?.state?.root;
    const me = root?.currentUserEmail;
    const type = a.type;
    // `update_ticket` writes directly through the SDK rather than through a
    // registered mutator, so it stays a special case outside the table.
    if (type === 'update_ticket') {
        const row = {
            updated_at: new Date().toISOString()
        };
        if (a.body) row.body = a.body;
        if (a.title) row.title = a.title;
        if (a.column_key) row.column_key = a.column_key;
        if (a.priority) row.priority = a.priority;
        // Phase 4: sdk.tickets.update(id, payload) — getService is Proxy-deferred
        Promise.resolve($93b46338d6fe5528$var$shellGetSDK().getService('tickets')).then((svc)=>svc.update(a.number, row)).catch((err)=>console.error('[aiAssistant] update_ticket failed:', err));
        return;
    }
    const builder = $93b46338d6fe5528$var$_ACTION_DISPATCH[type];
    if (!builder) return;
    const [fnName, payload] = builder(a, me, (k)=>this.call('polyglot', k));
    this.call(fnName, payload);
};
// ─── Realtime ticket subscription ──────────────────────────────────────────
//
// Watches ticket updates via the SDK realtime channel. When a Simona-originated
// ticket (metadata.simona_user_id === current user) transitions to a
// noteworthy state, injects a system notification card into the assistant
// thread so Simona surfaces it without being invoked manually.
//
// Design invariants:
//   - One channel per session; calling subscribeTicketRealtime again
//     while already subscribed is a no-op (returns existing channel).
//   - User identity comes from root.currentUserId (preferred) with
//     root.currentUserEmail as fallback — matches how simona.md tags tickets.
//   - System messages use role:'system' so AppAssistantMessage renders them
//     with the 'AI' role label and the standard assistant bubble style.
//   - unsubscribeTicketRealtime() removes the channel and clears the ref so
//     the AppAssistant onRemove lifecycle can clean up without leaking sockets.
// Noteworthy state transitions → the sentence the thread shows. One whole
// sentence per state: a state word slotted into one English frame cannot be
// translated. Every key is written out, so grep and the key gates see it.
const $93b46338d6fe5528$var$_TRANSITION_KEY = {
    done: 'workspace.assistant.ticketNotice.done',
    awaiting_approval: 'workspace.assistant.ticketNotice.awaitingApproval',
    in_progress: 'workspace.assistant.ticketNotice.started'
};
// Build the notification text for a ticket state change. `say(key)` resolves
// a bundle key. Each value goes in through a replacer FUNCTION, and the ticket
// subject goes in LAST, so a `$&` or a `{commit}` inside a title stays text.
const $93b46338d6fe5528$var$_notifyText = (say, ticket, newState)=>{
    const sha = ticket.metadata?.commitSha;
    const commit = sha ? say('workspace.assistant.ticketNotice.commit').replace('{sha}', ()=>sha.slice(0, 7)) : '';
    const subject = ticket.title ? say('workspace.assistant.ticketNotice.titled').replace('{title}', ()=>ticket.title) : say('workspace.assistant.ticketNotice.numbered').replace('{id}', ()=>String(ticket.id));
    // Intranet ticket deep-link — relative path works for all origins.
    return say($93b46338d6fe5528$var$_TRANSITION_KEY[newState]).replace('{commit}', ()=>commit).replace('{href}', ()=>`/tickets/${ticket.id}`).replace('{ticket}', ()=>subject);
};
// Module-level subscription handle so subscribe/unsubscribe are stateless
// from the component's perspective — it just calls el.call('subscribeTicketRealtime', root).
//
// STALE-COMMENT FIX (2026-07-27): this used to say ticket realtime rode
// `workspaceProject.realtime.tickets` via a legacy realtime provider
// in bootShell. Neither claim matches the code
// below anymore — Phase 4 replaced that path with the SDK's dedicated
// `TicketService` SSE stream (`getSDK().getService('tickets').subscribe()`,
// see the inline comment at the call site), which is NOT routed through
// `sdkRealtimeProvider`/`workspaceProject.realtime.*` at all (that provider
// only ever handles `meet` / `presence` / `notifications` — anything else,
// including `tickets`, has no backend there, same as chat). Mirrors the
// pattern the chat page's own `subscribeRealtime.js` uses: tickets realtime
// is owned by the tickets SSE service, not this generic provider.
// WS-SWITCH-MEMO-PLANE-1 — the workspace id the stream belongs to. `/tickets/
// stream` is WORKSPACE-scoped: the SDK binds the active workspace at open
// time. Both latches below are module-level memos that survive an in-app
// switch, so their reuse key MUST carry the workspace, or workspace B keeps
// reading workspace A's stream until a full reload (B's own events never
// arrive; A's keep landing in B's root). An unresolved workspace keys as ''
// — a DIFFERENT scope, so it re-opens once the id lands: a miss, never a
// stale serve. Tenant-keyed, not torn down on switch, per the ticket's rule.
const $93b46338d6fe5528$var$_streamWsId = (root)=>{
    const ws = root?.workspace;
    return String(ws && (ws.id || ws._id) || '');
};
let $93b46338d6fe5528$var$_ticketUnsub = null;
let $93b46338d6fe5528$var$_ticketChannelKey = null // `${userId}|${wsId}` the channel was opened for
;
const $93b46338d6fe5528$export$e213f1f9272c4814 = function subscribeTicketRealtime(root) {
    // `el.call('subscribeTicketRealtime', root)` binds the element, whose
    // polyglot speaks the workspace's language. A bare call has no element and
    // reads the shipped English — never a raw key.
    const el = this;
    const say = (key)=>el && typeof el.call === 'function' ? String(el.call('polyglot', key)) : String((0, $1X0Je.default).functions.i18nStaticEnglish()[key] || key);
    const userId = root?.currentUserId || root?.currentUserEmail || null;
    const wsId = $93b46338d6fe5528$var$_streamWsId(root);
    const channelKey = `${userId || ''}|${wsId}`;
    // If already subscribed for the same user IN THE SAME WORKSPACE, skip.
    if ($93b46338d6fe5528$var$_ticketUnsub && $93b46338d6fe5528$var$_ticketChannelKey === channelKey) return $93b46338d6fe5528$var$_ticketUnsub;
    // If subscribed for a DIFFERENT identity or workspace (workspace switch /
    // sign-out + re-in), tear down and re-subscribe for the new scope.
    if ($93b46338d6fe5528$var$_ticketUnsub && $93b46338d6fe5528$var$_ticketChannelKey !== channelKey) $93b46338d6fe5528$export$7d639d10c28c9b0();
    // No user yet — defer; subscribeTicketRealtime will be called again once
    // root.currentUserId populates (AppAssistant.Panel.Thread.onUpdate retries).
    if (!userId) return null;
    $93b46338d6fe5528$var$_ticketChannelKey = channelKey;
    // Phase 4: sdk.tickets.subscribe (SSE) replaces wp.realtime.subscribeTickets.
    // getSDK() returns a Proxy — getService() is deferred via initPromise so we
    // must await it (Promise.resolve pattern to stay sync-callable).
    let _resolved = null;
    let _cancelled = false;
    Promise.resolve($93b46338d6fe5528$var$shellGetSDK().getService('tickets')).then((ticketService)=>{
        if (_cancelled) return;
        _resolved = ticketService.subscribe(wsId ? {
            workspaceId: wsId
        } : {}, (eventObj)=>{
            if (eventObj?.type !== 'tickets.update') return;
            // Late-write guard: an event from the workspace this stream was opened
            // for must not land in a root that has since switched tenant.
            if ($93b46338d6fe5528$var$_streamWsId(root) !== wsId) return;
            const ticket = eventObj?.ticket;
            if (!ticket) return;
            // Filter: only tickets Simona tagged for this user.
            const meta = ticket.metadata || {};
            const ticketUserId = meta.simona_user_id;
            if (!ticketUserId || ticketUserId !== userId) return;
            const newState = ticket.state;
            if (!$93b46338d6fe5528$var$_TRANSITION_KEY[newState]) return;
            const notifMsg = {
                role: 'system',
                content: $93b46338d6fe5528$var$_notifyText(say, ticket, newState),
                _ticketNotif: true,
                _ticketId: ticket.id,
                _ticketState: newState
            };
            const current = root?.assistantMessages || [];
            if (root?.update) root.update({
                assistantMessages: [
                    ...current,
                    notifMsg
                ],
                assistantOpen: true
            });
        });
    }).catch((err)=>{
        console.warn('[aiAssistant] subscribeTicketRealtime failed:', err?.message || err);
    });
    // Stable unsubscribe wrapper.
    $93b46338d6fe5528$var$_ticketUnsub = ()=>{
        _cancelled = true;
        if (typeof _resolved === 'function') try {
            _resolved();
        } catch (_) {}
    };
    return $93b46338d6fe5528$var$_ticketUnsub;
};
const $93b46338d6fe5528$export$7d639d10c28c9b0 = function unsubscribeTicketRealtime() {
    if (!$93b46338d6fe5528$var$_ticketUnsub) return;
    // Read the latch into a local and call THAT: frank lifts this module `let`
    // into its state bag, but a bare call of the binding shipped unrewritten.
    const unsub = $93b46338d6fe5528$var$_ticketUnsub;
    $93b46338d6fe5528$var$_ticketUnsub = null;
    $93b46338d6fe5528$var$_ticketChannelKey = null;
    try {
        unsub();
    } catch (_) {}
};
// ─── ASK-USER decision panel subscription ──────────────────────────────────
//
// Watches public.tickets for INSERT/UPDATE events where:
//   - assignee_email contains 'simona', OR
//   - labels includes 'ASK-USER' or 'ask-user' or 'human-approval-needed'
// AND ticket type='decision' (TEMO's open_resolution_ticket + ASK-USER label).
//
// When a qualifying ticket lands, splices it into root.askUserDecisions so
// the AppAssistantDecisionBanner in the panel reacts immediately.
// Dismissed tickets are tracked in a module-level Set so they don't reappear
// after a realtime UPDATE (e.g. state change fires another event).
//
// Design invariants:
//   - One subscription per session; idempotent on re-call.
//   - Dismissed cards (stored in root._dismissedDecisionIds) never reappear
//     unless the page refreshes (Set lives in memory, not localStorage).
//   - subscribeAskUserDecisions and unsubscribeAskUserDecisions mirror the
//     subscribeTicketRealtime / unsubscribeTicketRealtime pattern so
//     AppAssistant.onInit/onRemove can hook in consistently.
const $93b46338d6fe5528$var$_isAskUserTicket = (ticket)=>{
    if (!ticket) return false;
    const labels = Array.isArray(ticket.labels) ? ticket.labels : [];
    const assignee = (ticket.assignee_email || '').toLowerCase();
    return labels.some((l)=>[
            'ASK-USER',
            'ask-user',
            'human-approval-needed'
        ].includes(l)) || assignee.includes('simona');
};
const $93b46338d6fe5528$var$_isResolvedDecision = (ticket)=>{
    // Cards where the human already responded — hide from the panel.
    const state = ticket?.state;
    return state === 'done' || state === 'cancelled' || state === 'in_progress';
};
// Active subscription handle + the workspace it was opened for (see
// `_streamWsId` above — same memo-plane rule: the reuse key carries the tenant).
let $93b46338d6fe5528$var$_askUserUnsub = null;
let $93b46338d6fe5528$var$_askUserScope = null;
const $93b46338d6fe5528$export$627cf069d880166 = function subscribeAskUserDecisions(root) {
    const wsId = $93b46338d6fe5528$var$_streamWsId(root);
    if ($93b46338d6fe5528$var$_askUserUnsub && $93b46338d6fe5528$var$_askUserScope === wsId) return $93b46338d6fe5528$var$_askUserUnsub;
    // A stream bound to ANOTHER workspace: close it and open this tenant's own.
    if ($93b46338d6fe5528$var$_askUserUnsub) $93b46338d6fe5528$export$12cbdb1a6df3b3d3();
    $93b46338d6fe5528$var$_askUserScope = wsId;
    // Phase 4: sdk.tickets.subscribe (SSE) replaces wp.realtime.subscribeTickets.
    // getSDK() Proxy defers getService — await via Promise.resolve.
    let _resolved = null;
    let _subscCancelled = false;
    Promise.resolve($93b46338d6fe5528$var$shellGetSDK().getService('tickets')).then((ticketService)=>{
        if (_subscCancelled) return;
        _resolved = ticketService.subscribe(wsId ? {
            workspaceId: wsId
        } : {}, (eventObj)=>{
            const { type: type, ticket: ticket } = eventObj || {};
            if (type !== 'tickets.insert' && type !== 'tickets.update') return;
            if (!ticket) return;
            // Late-write guard: never merge this workspace's rows into a root that
            // has since switched tenant.
            if ($93b46338d6fe5528$var$_streamWsId(root) !== wsId) return;
            // Only process ASK-USER tickets.
            if (!$93b46338d6fe5528$var$_isAskUserTicket(ticket)) return;
            const dismissed = root?._dismissedDecisionIds || [];
            const isDismissed = dismissed.includes(ticket.id);
            if ($93b46338d6fe5528$var$_isResolvedDecision(ticket) || isDismissed) {
                const existing = root?.askUserDecisions || [];
                if (existing.some((d)=>d.id === ticket.id)) root.update({
                    askUserDecisions: existing.filter((d)=>d.id !== ticket.id)
                });
                return;
            }
            const current = root?.askUserDecisions || [];
            const idx = current.findIndex((d)=>d.id === ticket.id);
            const updated = idx >= 0 ? current.map((d, i)=>i === idx ? {
                    ...d,
                    ...ticket
                } : d) : [
                ticket,
                ...current
            ];
            if (root?.update) root.update({
                askUserDecisions: updated,
                assistantOpen: true
            });
        });
    }).catch((err)=>{
        console.warn('[aiAssistant] subscribeAskUserDecisions failed:', err?.message || err);
    });
    $93b46338d6fe5528$var$_askUserUnsub = ()=>{
        _subscCancelled = true;
        if (typeof _resolved === 'function') try {
            _resolved();
        } catch (_) {}
    };
    return $93b46338d6fe5528$var$_askUserUnsub;
};
const $93b46338d6fe5528$export$12cbdb1a6df3b3d3 = function unsubscribeAskUserDecisions() {
    if (!$93b46338d6fe5528$var$_askUserUnsub) return;
    // Read the latch into a local and call THAT (see unsubscribeTicketRealtime).
    const unsub = $93b46338d6fe5528$var$_askUserUnsub;
    $93b46338d6fe5528$var$_askUserUnsub = null;
    $93b46338d6fe5528$var$_askUserScope = null;
    try {
        unsub();
    } catch (_) {}
};
const $93b46338d6fe5528$export$f5dedbcee30f8802 = async function fetchAskUserDecisions(root) {
    try {
        // Phase 4: sdk.tickets.list (Mongo-backed main server).
        const tSvc = await $93b46338d6fe5528$var$shellGetSDK().getService('tickets');
        const result = await tSvc.list({
            deleted: false
        }, {
            limit: 100,
            sortBy: 'updatedAt',
            sortDir: 'desc'
        });
        const rows = Array.isArray(result?.data) ? result.data : result?.data || result || [];
        if (!Array.isArray(rows)) return [];
        const dismissed = root?._dismissedDecisionIds || [];
        return rows.filter((t)=>$93b46338d6fe5528$var$_isAskUserTicket(t) && !$93b46338d6fe5528$var$_isResolvedDecision(t) && !dismissed.includes(t.id));
    } catch (err) {
        console.error('[aiAssistant] fetchAskUserDecisions error:', err);
        return [];
    }
};
const $93b46338d6fe5528$export$c0aa80f425725705 = async function approveDecisionTicket(ticketId, root) {
    if (!ticketId) return;
    try {
        // Read current ticket from local cache first.
        const decisions = root?.askUserDecisions || [];
        const ticket = decisions.find((d)=>d.id === ticketId);
        const currentLabels = Array.isArray(ticket?.labels) ? ticket.labels : [];
        const currentMeta = ticket?.metadata || {};
        const newLabels = [
            ...currentLabels.filter((l)=>![
                    'ASK-USER',
                    'ask-user',
                    'human-approval-needed'
                ].includes(l)),
            'human-approval-given'
        ];
        // Phase 4: sdk.tickets.update(id, payload) — getService is Proxy-deferred
        const tSvc1 = await $93b46338d6fe5528$var$shellGetSDK().getService('tickets');
        await tSvc1.update(ticketId, {
            state: 'in_progress',
            labels: newLabels,
            metadata: {
                ...currentMeta,
                nika_decision: 'approved',
                nika_decided_at: new Date().toISOString()
            },
            updated_at: new Date().toISOString()
        });
        // Dismiss the card immediately — don't wait for realtime echo.
        const dismissed = [
            ...root?._dismissedDecisionIds || [],
            ticketId
        ];
        root.update({
            askUserDecisions: (root?.askUserDecisions || []).filter((d)=>d.id !== ticketId),
            _dismissedDecisionIds: dismissed
        });
    } catch (err) {
        console.error('[aiAssistant] approveDecisionTicket error:', err);
    }
};
const $93b46338d6fe5528$export$ea8f8215074947cf = async function rejectDecisionTicket(ticketId, reason, root) {
    if (!ticketId) return;
    try {
        const decisions = root?.askUserDecisions || [];
        const ticket = decisions.find((d)=>d.id === ticketId);
        const currentLabels = Array.isArray(ticket?.labels) ? ticket.labels : [];
        const currentMeta = ticket?.metadata || {};
        const newLabels = [
            ...currentLabels.filter((l)=>![
                    'ASK-USER',
                    'ask-user',
                    'human-approval-needed'
                ].includes(l)),
            'human-approval-rejected'
        ];
        // Phase 4: sdk.tickets.update(id, payload) — getService is Proxy-deferred
        const tSvc2 = await $93b46338d6fe5528$var$shellGetSDK().getService('tickets');
        await tSvc2.update(ticketId, {
            state: 'cancelled',
            labels: newLabels,
            metadata: {
                ...currentMeta,
                nika_decision: 'rejected',
                nika_rejection_reason: reason || '',
                nika_decided_at: new Date().toISOString()
            },
            updated_at: new Date().toISOString()
        });
        const dismissed = [
            ...root?._dismissedDecisionIds || [],
            ticketId
        ];
        root.update({
            askUserDecisions: (root?.askUserDecisions || []).filter((d)=>d.id !== ticketId),
            _dismissedDecisionIds: dismissed
        });
    } catch (err) {
        console.error('[aiAssistant] rejectDecisionTicket error:', err);
    }
};
const $93b46338d6fe5528$export$dcf4229e34a598a4 = async function clarifyDecisionTicket(ticketId, clarification, root) {
    if (!ticketId || !clarification) return;
    try {
        const decisions = root?.askUserDecisions || [];
        const ticket = decisions.find((d)=>d.id === ticketId);
        const currentMeta = ticket?.metadata || {};
        // Phase 4: sdk.tickets.update(id, payload) — getService is Proxy-deferred
        const tSvc3 = await $93b46338d6fe5528$var$shellGetSDK().getService('tickets');
        await tSvc3.update(ticketId, {
            metadata: {
                ...currentMeta,
                clarification: clarification,
                clarification_at: new Date().toISOString()
            },
            updated_at: new Date().toISOString()
        });
        const dismissed = [
            ...root?._dismissedDecisionIds || [],
            ticketId
        ];
        root.update({
            askUserDecisions: (root?.askUserDecisions || []).filter((d)=>d.id !== ticketId),
            _dismissedDecisionIds: dismissed
        });
    } catch (err) {
        console.error('[aiAssistant] clarifyDecisionTicket error:', err);
    }
};

});
parcelRegister("gzr3m", function(module, exports) {

$parcel$export(module.exports, "AI_AWARENESS_PAGES", () => $c104e66f813cfb63$export$1fb5af12d4f68343);
$parcel$export(module.exports, "moduleRouteTitle", () => $c104e66f813cfb63$export$f174002b710c997e);
$parcel$export(module.exports, "aiModulePageTitle", () => $c104e66f813cfb63$export$cd53c9f612c041a2);
$parcel$export(module.exports, "buildSuggestions", () => $c104e66f813cfb63$export$42a7dcd7dc4186c3);
$parcel$export(module.exports, "aiEffectivePath", () => $c104e66f813cfb63$export$1e9e234045d0d8f);
$parcel$export(module.exports, "aiOpenRecord", () => $c104e66f813cfb63$export$41012afe37443be0);
$parcel$export(module.exports, "aiRecordRefKey", () => $c104e66f813cfb63$export$9993da236aff70d0);
$parcel$export(module.exports, "aiRecordMuted", () => $c104e66f813cfb63$export$da4985c4c2b21b92);
$parcel$export(module.exports, "aiRecordSuggestionItems", () => $c104e66f813cfb63$export$c9a3ba6a1b1bd798);
$parcel$export(module.exports, "aiPageSuggestionItems", () => $c104e66f813cfb63$export$5ea9d37eab57d9f6);
$parcel$export(module.exports, "aiGenericSuggestionItems", () => $c104e66f813cfb63$export$241a0c6669c62a48);
$parcel$export(module.exports, "aiDeclaredRouteLabel", () => $c104e66f813cfb63$export$21430161971eda5b);
$parcel$export(module.exports, "buildPageContext", () => $c104e66f813cfb63$export$9e506a4ac928dedc);
$parcel$export(module.exports, "buildAiAwareness", () => $c104e66f813cfb63$export$cdaa13c6395ddfd1);
$parcel$export(module.exports, "selectPageItem", () => $c104e66f813cfb63$export$376a6c1bb83858e3);
// pageContext.js — page awareness for the GENERAL workspace AI.
//
// buildPageContext(root) inspects the live workspace state (the state-root
// object held at el.state.root) and returns a COMPACT, model-readable snapshot
// of the page the user is currently viewing: { currentPage, pageData,
// pageActions }. simoneAiTransport merges it into the per-turn dispatch context
// for the GENERAL scope only (the add-app builder is extension-scoped and gets
// none). The server surfaces it in the agent's system instruction so the AI can
// answer about — and act on — what the user is looking at.
//
// selectPageItem(type, id, collection?) is the el.call companion (registered
// via functions/index.js) the AI's `select_page_item` client tool invokes to
// open a specific item (a ticket, channel, document, event, room — or a
// workspace RECORD, on the app page that owns its collection). It only flips
// client selection state / opens a modal or page — it never writes data (data
// mutations route through the proper SDK paths, not the page AI).
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).
// The `.functions` read is DEFERRED to call time: this module loads inside
// the shared-barrel init cycle (shared components → IdentityAdminComponents
// → shell AdminChrome → shell functions barrel → here), where the barrel's
// default export is still undefined — a module-scope destructure crashed
// the entire shell boot (blank app, no spiral removal, 2026-08-12).

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $7ytvD = parcelRequire("7ytvD");

var $8eEEA = parcelRequire("8eEEA");

var $i2kG6 = parcelRequire("i2kG6");

var $15Bho = parcelRequire("15Bho");

var $9ZTVI = parcelRequire("9ZTVI");

var $g7CNh = parcelRequire("g7CNh");

var $hml1G = parcelRequire("hml1G");

var $er1Z5 = parcelRequire("er1Z5");

var $7nvlv = parcelRequire("7nvlv");
const $c104e66f813cfb63$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// EntityRef helpers (shared/functions/entityRef.js) — deferred to call time
// for the same barrel-init-cycle reason as the three handles above.
const $c104e66f813cfb63$var$formatEntityRef = (...args)=>(0, $1X0Je.default).functions.formatEntityRef(...args);
const $c104e66f813cfb63$var$entityRefIcon = (...args)=>(0, $1X0Je.default).functions.entityRefIcon(...args);
const $c104e66f813cfb63$var$entityRefKindKey = (...args)=>(0, $1X0Je.default).functions.entityRefKindKey(...args);
const $c104e66f813cfb63$var$i18nStaticEnglish = ()=>(0, $1X0Je.default).functions.i18nStaticEnglish();
// A bundle sentence for a chip or a page name: through the element's polyglot
// when there is one (every `el.call(...)` caller), the SHIPPED ENGLISH value on
// the headless path (aiAssistant.js's bare buildPageContext call — the model
// wire, which must never carry a raw key).
const $c104e66f813cfb63$var$cap = (arr, n = 15)=>Array.isArray(arr) ? arr.slice(0, n) : [];
const $c104e66f813cfb63$var$str = (v)=>v == null ? '' : String(v);
// People/assignee fields are sometimes a populated object, sometimes a bare
// string/id — never stringify an object into "[object Object]".
const $c104e66f813cfb63$var$nameOf = (v)=>v && typeof v === 'object' ? $c104e66f813cfb63$var$str(v.name || v.fullName || v.email) : $c104e66f813cfb63$var$str(v);
// Resolve the effective route the user is viewing; when on the home dashboard
// ('/') with a sub-app opened in the AppWindow (PageSlot), selectedPage is
// what's actually visible.
// THE ROUTE SIGNAL FIRST: `root.currentPath` — AppShell's history patch
// (shared AppShell.js installAppShellSync) writes it on every push, replace
// and popstate, so it IS the browser path — and reading it subscribes. A
// reactive prop that resolves the surface through here (the composer chip's
// "Context: …", aiScope.js) re-runs on an SPA navigation; reading
// `window.location` first, it never did: after Studio → Home by a click the
// chip kept "Context: Apps" until a reload (Fly QA 2026-10-18, D2). The
// browser path stays the fallback for a root that has no route (a headless
// caller, a test).
function $c104e66f813cfb63$var$effectivePath(root) {
    const routePath = root && typeof root.currentPath === 'string' ? root.currentPath : '';
    const winPath = routePath || typeof window !== 'undefined' && window.location && window.location.pathname || '';
    // Normalize past any `/w/<org-slug>` prefix so the intranet home ('/') check
    // + every downstream PAGES / PAGE_SUGGESTIONS / titleFromPath test resolves
    // correctly under multi-workspace tabs (§6d). No-op until Phase 3 emits the
    // prefix. `_canvasSlot` is an already-unprefixed internal route key.
    let path = (0, $7iFOV.shellStripWorkspacePrefix)(winPath || '/');
    if ((!path || path === '/') && root?._canvasSlot) path = root._canvasSlot;
    return path || '/';
}
// The documents editor's routes: '/notes/editor' and the legacy
// '/documents/editor' (pages/main.js PageSlot map, pages/index.js routes).
const $c104e66f813cfb63$var$EDITOR_ROUTE = /^\/(?:notes|documents)\/editor(?:[/?#]|$)/;
// Is the editor ON SCREEN — as the page, in the PageSlot pane or in the
// split's second pane? Leaving the editor keeps `editorDoc` (documents
// pages/editor.js reuses it on the next open), so the key alone is not an
// open note (wave-2 (5), dev 2026-10-28: a closed note kept its chip).
const $c104e66f813cfb63$var$editorOnScreen = (root)=>[
        $c104e66f813cfb63$var$effectivePath(root),
        root._canvasSlot,
        root._canvasSlotSecond
    ].some((p)=>typeof p === 'string' && $c104e66f813cfb63$var$EDITOR_ROUTE.test(p));
// Per-route descriptors. `data(root)` returns a compact plain object (no
// functions, bounded arrays); `actions` lists what the AI can do here, phrased
// to name the exact tool + arg shape so the model calls it correctly.
const $c104e66f813cfb63$var$PAGES = [
    {
        test: (p)=>p.startsWith('/tasks') || p.startsWith('/task/') || p.startsWith('/tickets'),
        page: 'Tasks',
        data: (root)=>{
            // The board column carries the human label (`label`); a ticket's status is
            // the label of the column it sits in (linked by `columnKey`), falling back
            // to the raw `state`. Assignee is an email / login, not an object.
            const cols = Array.isArray(root.columns) ? root.columns : [];
            const labelByKey = new Map(cols.map((c)=>[
                    $c104e66f813cfb63$var$str(c?.key),
                    $c104e66f813cfb63$var$str(c?.label || c?.name || c?.title)
                ]));
            const labelById = new Map(cols.map((c)=>[
                    $c104e66f813cfb63$var$str(c?.id),
                    $c104e66f813cfb63$var$str(c?.label || c?.name || c?.title)
                ]));
            const statusOf = (t)=>labelByKey.get($c104e66f813cfb63$var$str(t?.columnKey || t?.column_key)) || labelById.get($c104e66f813cfb63$var$str(t?.columnId)) || $c104e66f813cfb63$var$str(t?.state || t?.status);
            const assigneeOf = (t)=>$c104e66f813cfb63$var$nameOf(t?.assignee) || $c104e66f813cfb63$var$str(t?.assigneeEmail || t?.assignee_email || (Array.isArray(t?.assigneeLogins) ? t.assigneeLogins[0] : ''));
            return {
                columns: $c104e66f813cfb63$var$cap(root.columns).map((c)=>({
                        id: $c104e66f813cfb63$var$str(c?.id),
                        name: $c104e66f813cfb63$var$str(c?.label || c?.name || c?.title)
                    })),
                tickets: $c104e66f813cfb63$var$cap(root.tickets, 25).map((t)=>({
                        id: $c104e66f813cfb63$var$str(t?.id),
                        number: t?.number != null ? t.number : undefined,
                        title: $c104e66f813cfb63$var$str(t?.title || t?.name),
                        status: statusOf(t),
                        assignee: assigneeOf(t)
                    })),
                selectedTicket: root.selectedTicket ? {
                    id: $c104e66f813cfb63$var$str(root.selectedTicket.id),
                    title: $c104e66f813cfb63$var$str(root.selectedTicket.title)
                } : null
            };
        },
        actions: [
            "open a ticket (select_page_item type:'ticket' id:<ticketId>)",
            'move a ticket to another column / change its status (move_ticket ticket:<id|title> column:<name>)',
            'create a ticket (create_ticket); delete a ticket (delete_ticket)',
            'search the workspace (open_search)'
        ]
    },
    {
        test: (p)=>p.startsWith('/chat'),
        page: 'Chat',
        data: (root)=>({
                channels: $c104e66f813cfb63$var$cap(root.channels, 30).map((c)=>({
                        id: $c104e66f813cfb63$var$str(c?.id),
                        name: $c104e66f813cfb63$var$str(c?.name || c?.label || c?.title)
                    })),
                activeChannelId: $c104e66f813cfb63$var$str(root.activeChannelId) || null
            }),
        actions: [
            "switch to a channel (select_page_item type:'channel' id:<channelId>)",
            'send a message (send_message channel:<id|name> message:<text>); create a channel (create_channel)',
            'search the workspace (open_search)'
        ]
    },
    {
        test: (p)=>p.startsWith('/calendar'),
        page: 'Calendar',
        data: (root)=>({
                // Shell root stores calendar events under `events` (state-app.js), matching
                // selectPageItem's event case + the shell calendar page — NOT the
                // standalone `calendarEvents` key. Reading calendarEvents here left the AI's
                // calendar context silently empty.
                events: $c104e66f813cfb63$var$cap(root.events, 30).map((e)=>({
                        id: $c104e66f813cfb63$var$str(e?.id),
                        title: $c104e66f813cfb63$var$str(e?.title || e?.name),
                        start: $c104e66f813cfb63$var$str(e?.start || e?.date)
                    })),
                selectedEvent: root.selectedEvent ? {
                    id: $c104e66f813cfb63$var$str(root.selectedEvent.id),
                    title: $c104e66f813cfb63$var$str(root.selectedEvent.title)
                } : null
            }),
        actions: [
            "open an event (select_page_item type:'event' id:<eventId>)",
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        // The built-in History app: the workspace activity log as a timeline
        // (pages/history.js). The rows are the audit log the page holds
        // (`historyEvents`, newest first); the two filters say what the person is
        // looking at.
        test: (p)=>p.startsWith('/history'),
        page: 'History',
        data: (root)=>({
                activity: $c104e66f813cfb63$var$cap(root.historyEvents, 30).map((e)=>({
                        id: $c104e66f813cfb63$var$str(e?.id),
                        title: $c104e66f813cfb63$var$str((0, $7nvlv.historyEventWords)(e)),
                        who: $c104e66f813cfb63$var$str(e?.user_email),
                        type: $c104e66f813cfb63$var$str(e?.activity_type),
                        at: $c104e66f813cfb63$var$str(e?.created_at)
                    })),
                person: $c104e66f813cfb63$var$str(root.historyPerson) || null,
                activityType: $c104e66f813cfb63$var$str(root.historyType) || null
            }),
        actions: [
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        // Terminal — the App Store app system/terminal-app (apps/terminal; a
        // built-in until 2026-10-21). Its sessions live in the window's own
        // state, not on root, and the stub shell runs nothing, so the page tells
        // the model where the person is and carries no rows.
        test: (p)=>p.startsWith('/terminal'),
        page: 'Terminal',
        data: ()=>({}),
        actions: [
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        test: (p)=>p.startsWith('/notes') || p.startsWith('/documents') || p.startsWith('/docs'),
        page: 'Notes',
        data: (root)=>({
                documents: $c104e66f813cfb63$var$cap(root.documents, 30).map((d)=>({
                        id: $c104e66f813cfb63$var$str(d?.id),
                        title: $c104e66f813cfb63$var$str(d?.title || d?.name || d?.label)
                    })),
                notes: $c104e66f813cfb63$var$cap(root.notes, 30).map((n)=>({
                        id: $c104e66f813cfb63$var$str(n?.id),
                        title: $c104e66f813cfb63$var$str(n?.title || n?.name)
                    })),
                selectedFolder: $c104e66f813cfb63$var$str(root.selectedFolder) || null,
                selectedDocument: root.selectedDocument ? {
                    id: $c104e66f813cfb63$var$str(root.selectedDocument.id),
                    title: $c104e66f813cfb63$var$str(root.selectedDocument.title || root.selectedDocument.name)
                } : null
            }),
        actions: [
            "open a document (select_page_item type:'document' id:<docId>)",
            'create a note (create_note title:<t> content:<c>); rename (rename_note); delete (delete_note)',
            'search the workspace (open_search)'
        ]
    },
    {
        test: (p)=>p.startsWith('/files') || p.startsWith('/infra'),
        page: 'Files',
        // `files` below is cut from `root.fileNodes` (40 at most). The rows chip
        // counts the WHOLE list there, so a desktop past the cap reads truncated.
        rootKeys: {
            files: 'fileNodes'
        },
        data: (root)=>{
            // A file's CONTENT is what people actually ask about — "summarise the
            // docx", "what are the totals in the spreadsheet". This slice used to
            // carry name/kind only, so those prompts could be answered only by
            // guessing from the filename.
            //
            // The desktop already HAS the text: the office/markdown reader extracts
            // it into `_filePreviews[id]` to draw each tile's snippet, so it is
            // sitting in memory on this very page. Passing a bounded slice of it
            // costs nothing extra to produce. (No `mime` — the extension in `name`
            // already tells the model the format, and 40 × a 70-char OOXML mime
            // string is pure bulk.)
            //
            // Budgeted twice over: per file, so one long document can't crowd out
            // every other file, and in total, so a 40-icon desktop can't blow the
            // dispatch context. A file can end up with no `content` two ways — its
            // preview hasn't resolved (unreadable container, still loading, a format
            // with no text) or the budget ran out, which is flagged explicitly as
            // `contentOmitted`. The actions list below tells the model to say so
            // rather than guess from the filename; that distinction is the whole
            // difference between a correct answer and an invented one.
            const PER_FILE = 400;
            const TOTAL = 4000;
            let spent = 0;
            let omitted = 0;
            const files = $c104e66f813cfb63$var$cap(root.fileNodes, 40).map((n)=>{
                const out = {
                    id: $c104e66f813cfb63$var$str(n?.id),
                    name: $c104e66f813cfb63$var$str(n?.name),
                    kind: $c104e66f813cfb63$var$str(n?.kind)
                };
                if (typeof n?.size === 'number') out.size = n.size;
                const preview = $c104e66f813cfb63$var$str((root._filePreviews || {})[n?.id]).trim();
                if (!preview) return out;
                if (spent >= TOTAL) {
                    omitted++;
                    out.contentOmitted = true;
                    return out;
                }
                const slice = preview.slice(0, Math.min(PER_FILE, TOTAL - spent));
                spent += slice.length;
                out.content = slice;
                if (slice.length < preview.length) out.contentTruncated = true;
                return out;
            });
            return {
                files: files,
                currentFolder: $c104e66f813cfb63$var$str(root.filesOpenFolder) || null,
                // Never let the model treat a budget cut as "this file is empty".
                ...omitted ? {
                    note: omitted + ' more file(s) have contents that did not fit this context'
                } : {}
            };
        },
        actions: [
            "answer questions about a file's contents from its `content` field (extracted text \u2014 documents, spreadsheets, decks, notes)",
            "a file with no `content` field: its text was NOT provided \u2014 say the contents are unavailable, never guess them from the filename",
            'create a folder (create_folder name:<n>)',
            'rename (rename_file file:<id|name> newName:<n>); duplicate (duplicate_file file:<id|name> newName:<n>)',
            'delete (delete_file file:<id|name>); move into a folder (move_file file:<id|name> folder:<id|name|desktop>)',
            'search the workspace (open_search)'
        ]
    },
    {
        test: (p)=>p.startsWith('/meet'),
        page: 'Meet',
        data: (root)=>({
                rooms: $c104e66f813cfb63$var$cap(root.rooms, 30).map((r)=>({
                        id: $c104e66f813cfb63$var$str(r?.id),
                        name: $c104e66f813cfb63$var$str(r?.name || r?.label || r?.title)
                    })),
                activeRoomId: $c104e66f813cfb63$var$str(root.activeRoomId) || null
            }),
        actions: [
            "open a meeting room (select_page_item type:'room' id:<roomId>)",
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        // POB getting-started (S9): the pages the workspace ai's first-thread
        // offers open, as the route or in the PageSlot. Their rows are the page's
        // own form (names found on the site, the e-mails the owner types, the
        // import steps), not root collections, so the page tells the model where
        // the person is and carries no rows. The `page` names are the pages' own
        // English titles; the chip reads the same title keys.
        test: (p)=>p.startsWith('/getting-started/team'),
        page: 'Invite your team',
        data: ()=>({}),
        actions: [
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        test: (p)=>p.startsWith('/getting-started/imports'),
        page: 'Import your data',
        data: ()=>({}),
        actions: [
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        // Three built-in pages the W27 dev check found unnamed (www-ee,
        // 2026-10-31): each chip read its segment-cased first segment, English in a
        // Georgian session. Their rows are the page's own lists (the requests, the
        // map's points, the one shared item), not root collections, so each tells
        // the model where the person is and carries no rows. The chip reads a title
        // key the page already ships (aiAwarenessLabels.js). The request views under
        // the route (/inbound, /outbound) are the same requests.
        test: (p)=>/^\/resolutions\/requests(?:[/?#]|$)/.test(p),
        page: 'Customer requests',
        data: ()=>({}),
        actions: [
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        // One map page (analyticsMap) under the workspace and the project analytics.
        test: (p)=>/^\/(?:workspace-)?analytics\/map(?:[/?#]|$)/.test(p),
        page: 'Analytics map',
        data: ()=>({}),
        actions: [
            'navigate to another section (navigate_to_app)'
        ]
    },
    {
        // The public share viewer, /s/<token>. It is chromeless (no composer), but
        // a signed-in visit still derives the chips, and a token is not a name.
        test: (p)=>/^\/s\/[^/?#]+/.test(p),
        page: 'Shared item',
        data: ()=>({}),
        actions: [
            'navigate to another section (navigate_to_app)'
        ]
    }
];
const $c104e66f813cfb63$export$1fb5af12d4f68343 = $c104e66f813cfb63$var$PAGES;
// A ROUTE is not a TITLE: it carries a query string and a hash, and neither is
// part of the page's name. `setModuleRouteQuery` writes the open row onto the
// module route (`/vault-training?board=<id>`), so the segment-casing below —
// which split on '/' and title-cased whatever came back — rendered the FOCUS
// route chip as `Vault Training?Board=<id>`, the query string capitalised as
// if it were prose (V2, VaultOS 1.38.1, 2026-09-10; the module lane fixed the
// ATTACH chip's half of the same defect). Strip both before anything reads the
// path as a name.
const $c104e66f813cfb63$var$_pathOnly = (p)=>$c104e66f813cfb63$var$str(p).split('#')[0].split('?')[0];
// Every list on the live root that names a route AND gives it a human label.
// Order is the contract:
//   1. `workspaceSettings` — the RESOLVED navbar/launcher the user is actually
//      looking at (personalisation applied). The chip should say what the tab
//      says.
//   2. the takeover module's own `configDefaults` — the module's declaration,
//      for a route the resolved lists do not carry (a page reachable only from
//      inside the module, never pinned to a tab).
//   3. each additive app's, last — same "first declaration wins" ordering
//      functions/moduleRecordRoutes.js documents, so a marketplace install can
//      never rename the workspace's own module page.
const $c104e66f813cfb63$var$_titleLists = (root)=>{
    const out = [];
    if (!root || typeof root !== 'object') return out;
    const ws = root.workspaceSettings;
    if (ws && typeof ws === 'object') out.push(ws.navbar, ws.apps);
    const project = root.workspaceProject;
    if (project && typeof project === 'object') {
        const cd = project.configDefaults;
        if (cd && typeof cd === 'object') out.push(cd.navbar, cd.apps);
    }
    if (Array.isArray(root.workspaceApps)) {
        for (const app of root.workspaceApps)if (app && typeof app === 'object') out.push(app.navbar, app.apps);
    }
    return out;
};
// Every route the installed modules serve. A navbar entry is `{ label, path }`
// and a launcher tile is `{ title, route }` (launcherTiles.js
// normalizeLauncherTile) — both shapes are read, because a module page may be
// declared as either.
const $c104e66f813cfb63$var$_moduleRoutes = (root)=>{
    const routes = new Set();
    if (!root || typeof root !== 'object') return routes;
    const project = root.workspaceProject;
    if (project && project.pages && typeof project.pages === 'object') for (const k of Object.keys(project.pages))routes.add($c104e66f813cfb63$var$_pathOnly(k));
    if (Array.isArray(root.workspaceApps)) for (const app of root.workspaceApps){
        if (app && Array.isArray(app.pages)) for (const k of app.pages)routes.add($c104e66f813cfb63$var$_pathOnly($c104e66f813cfb63$var$str(k)));
    }
    // A declared record route is a module page route BY CONSTRUCTION —
    // `_normalizeRecordRoutes` validates it against the module's own `pages` at
    // load. Reading the registry too means a module whose pages stash has not
    // landed yet (or an older bundle that only published recordRoutes) still
    // resolves. This is a READ of the S1/S3 contract; the registry is not
    // changed here.
    try {
        for (const row of Object.values((0, $15Bho.moduleRecordRoutes)(root)))if (row && row.route) routes.add($c104e66f813cfb63$var$_pathOnly($c104e66f813cfb63$var$str(row.route)));
    } catch (_) {
    /* registry unavailable — the page set above still answers */ }
    return routes;
};
// The name the MODULE gives this route, or '' when no installed module serves
// it. `path` must already be query/hash-free.
// The row the modules declare for EXACTLY `route` (navbar tab or launcher
// tile) → `{ label, appKey }` (both '' when none). `appKey` is the installed
// app's identity the shell stamps on the ONE row an app contributes
// (workspaceConfigs.js) — the identity the tab itself names the app by.
const $c104e66f813cfb63$var$_declaredRow = (root, route)=>{
    for (const list of $c104e66f813cfb63$var$_titleLists(root)){
        if (!Array.isArray(list)) continue;
        for (const item of list){
            if (!item || typeof item !== 'object') continue;
            if ($c104e66f813cfb63$var$_pathOnly($c104e66f813cfb63$var$str(item.path || item.route || item.href)) !== route) continue;
            const label = $c104e66f813cfb63$var$str(item.label || item.title || item.name);
            if (label) return {
                label: label,
                appKey: $c104e66f813cfb63$var$str(item.appKey)
            };
        }
    }
    return {
        label: '',
        appKey: ''
    };
};
const $c104e66f813cfb63$var$_declaredLabel = (root, route)=>$c104e66f813cfb63$var$_declaredRow(root, route).label;
// The declared row for a module route, else its NEAREST named ancestor's — an
// installed app names its main page (`/realestate`) but not every route it
// serves (the CRM's unit picker opens `/realestate/pick`), and the chip fell
// to segment-casing: "Realestate" in a Georgian workspace (current-2a
// 2026-09-28). The ancestor is the app's own name — read from the module,
// never a shell table row per installed app.
const $c104e66f813cfb63$var$_moduleRouteRow = (root, path)=>{
    const none = {
        label: '',
        appKey: ''
    };
    const route = $c104e66f813cfb63$var$_pathOnly(path);
    if (!route || route === '/') return none;
    if (!$c104e66f813cfb63$var$_moduleRoutes(root).has(route)) return none;
    const own = $c104e66f813cfb63$var$_declaredRow(root, route);
    if (own.label) return own;
    const segs = route.split('/').filter(Boolean);
    for(let i = segs.length - 1; i > 0; i--){
        const row = $c104e66f813cfb63$var$_declaredRow(root, '/' + segs.slice(0, i).join('/'));
        if (row.label) return row;
    }
    return none;
};
const $c104e66f813cfb63$export$f174002b710c997e = (root, path)=>$c104e66f813cfb63$var$_moduleRouteRow(root, path).label;
// THE PAGE'S OWN TITLE, read from its DEFINITION by route — the page the
// shell serves at `route` (`el.context.pages`, a module page wrapped with the
// module's own context, workspaceProjects.js _wrapModulePages), its
// `metadata.title` resolved IN that context (a title factory calls the app's
// own functions — BESSI's `bsPageTitle`) and so in the session language. The
// app's name the title carries ("შეკვეთები · BESSI") is left to the app chip:
// the page's part is the first one. '' when the shell serves no such page or
// its title needs the live page (a factory that reads the page's own state
// throws here, and reads as none).
// Lane www-9b G-2 (2026-10-28): a module page with no navbar row read its
// path segment-cased — BESSI /orders said "Orders" in a Georgian session — and
// the routed element, read during an in-app navigation, is still the PREVIOUS
// page (BESSI /alerts said „მომხმარებლები" for one page). The definition is
// keyed by the route, so it is never the page before.
// CHIP-TITLES (2026-10-31): the shell's own pages read here too (titleFromPath),
// so a route with no key of its own takes the key the router itself picks — its
// `matchRoute` (context.utils): /user/<slug> is /user/:slug — never a wildcard
// key (the shell's one wildcard is the catch-all, no page of its own; the test
// is written without its quoted key, which i18nWorkspaceExtraction's comment
// stripper reads as a block-comment opener). A shell title is pageTitle()'s
// "<page> / <brand>": " / " cuts like " · ".
const $c104e66f813cfb63$var$_modulePageTitle = (route, el)=>{
    if (!el || typeof el.call !== 'function' || !route || route === '/') return '';
    const pages = el.context && el.context.pages;
    if (!pages || typeof pages !== 'object') return '';
    let def = pages[route];
    if (!def) {
        const hit = el.call('matchRoute', route, pages);
        def = hit && hit.key && !hit.key.endsWith('*') ? pages[hit.key] : null;
    }
    if (!def || typeof def !== 'object' || !def.metadata) return '';
    const own = def.context && typeof def.context === 'object' ? def.context : null;
    const reader = own && own !== el.context ? Object.create(el, {
        context: {
            value: own
        }
    }) : el;
    let title = '';
    try {
        title = $c104e66f813cfb63$var$str(reader.call('resolvePageMetadataTitle', def.metadata)).trim();
        if ($c104e66f813cfb63$var$_KEYISH.test(title)) title = $c104e66f813cfb63$var$str(reader.call('polyglot', title)).trim();
    } catch (_) {
        title = '';
    }
    if (!title || $c104e66f813cfb63$var$_KEYISH.test(title)) return '';
    return title.split(/\s+[·|—–/]\s+/)[0].trim();
};
function $c104e66f813cfb63$export$cd53c9f612c041a2(path, el) {
    return $c104e66f813cfb63$var$_modulePageTitle($c104e66f813cfb63$var$_pathOnly(path), el || this);
}
// A bundle key, as `packages/shared/__tests__/i18nTestBinding.js KEY_RE`
// defines one. Used ONLY to decide whether a declared label is safe to hand to
// a consumer that cannot resolve polyglot — see titleFromPath.
const $c104e66f813cfb63$var$_KEYISH = /^[a-z][A-Za-z0-9]*(\.[A-Za-z][A-Za-z0-9]*)+$/;
// The page's name, from its path.
//
// `el` is optional and is the polyglot resolver: a module's declared label is
// either a bundle KEY or a literal (exactly like a widget's `title`), and
// polyglot returns a non-key verbatim, so one call resolves both. Both callers
// are `export function`s reached as `el.call('buildAiAwareness', ...)` /
// `el.call('buildPageContext', ...)`, so `this` is the element there; a direct
// import call (the unit tests, aiAssistant.js's bare `buildPageContext(root)`)
// has none, and then a KEY-shaped label is dropped rather than shipped raw —
// the model must never be told the user is on `vault.nav.rooms`.
// THE LOADING WINDOW: the workspace's modules may still be landing, so a
// route no module serves YET may be one of theirs — the full workspace record
// is not in (`workspaceReady` false: its app declarations are unknown), or it
// declares installed apps (`settings.workspaceApps`) whose runtime rows have
// not arrived (`root.workspaceApps` still unset), or a takeover module
// (`settings.workspaceModule`) whose project has not. A record that will never
// complete (`_completionUnreachable`) is not loading. MEASURED (current-2a
// 2026-09-29): the composer mounts before the apps land and derives the
// awareness chips at once, so every dev load of /realestate logged the "no
// label" warning below for a route its app names a render later.
const $c104e66f813cfb63$var$_modulesLanding = (root)=>{
    if (!root || typeof root !== 'object') return false;
    const ws = root.workspace;
    if (!ws || typeof ws !== 'object' || ws._completionUnreachable) return false;
    if (root.workspaceReady === false) return true;
    const settings = ws.settings && typeof ws.settings === 'object' ? ws.settings : null;
    if (!settings) return false;
    // Installed app entries only (installedAppRefs): the records-grant row is
    // not an app and never publishes — counting it held the window open for good.
    const apps = (0, $g7CNh.installedAppRefs)(settings);
    if (apps.length && !Array.isArray(root.workspaceApps)) return true;
    return !!settings.workspaceModule && !root.workspaceProject;
};
// CHIP-WAIT (2026-10-31): A PAGE THE SHELL ITSELF SERVES WAITS FOR NO MODULE.
// The loading window above held every chip empty, so /admin/teams showed no
// chip until the workspace's apps had landed — although no module can ever
// serve that address. Each module registration skips a key it finds taken
// (workspaceProjects.js: the takeover's "key collision skipped", the installed
// apps' "page collision skipped" and "extension page collision skipped"), an
// app's activation replaces only its own opening placeholder, and the router's
// matchRoute scores an exact key above any `:param` or wildcard key, so nothing
// a module adds can win that address. True when the address is EXACTLY one of
// the registry's own keys — the test the boot reveal gate makes
// (workspaceProjects.js _pathRoutable) — and the page there is no module's:
// no own `context` (_wrapModulePages and _routeTableDef give each module page
// one), not an installed app's opening placeholder (its registered marker, read
// the way pages/main.js reads it), not a custom app's (isCustomAppTile, the
// extension space). A `:param` address (/user/<slug>) still waits: a module may
// register that exact address and win it.
const $c104e66f813cfb63$var$_shellServedRoute = (route, el)=>{
    if (!route || route === '/' || !el || typeof el.call !== 'function') return false;
    const pages = el.context && el.context.pages;
    if (!pages || typeof pages !== 'object') return false;
    if (!Object.prototype.hasOwnProperty.call(pages, route)) return false;
    const def = pages[route];
    if (!def || typeof def !== 'object') return false;
    if (Object.prototype.hasOwnProperty.call(def, 'context')) return false;
    if (def[Symbol.for('symbols.workspace.appOpening')]) return false;
    return !el.call('isCustomAppTile', {
        route: route
    });
};
// `chip: true` is the AI-awareness route CHIP (a person reads it): while the
// modules land it stays EMPTY rather than show an English stand-in — except on
// a page the shell itself serves (_shellServedRoute), which names itself at
// once — and the chip re-derives when they arrive. The model wire
// (`currentPage`) still gets a page name. Neither warns in that window — the
// warning is for a route that stays unnamed once everything has loaded.
const $c104e66f813cfb63$var$titleFromPath = (p, root, el, { chip: chip = false } = {})=>{
    const clean = $c104e66f813cfb63$var$_pathOnly(p);
    const row = $c104e66f813cfb63$var$_moduleRouteRow(root, clean);
    const declared = row.label;
    if (declared) {
        if (el && typeof el.call === 'function') {
            // An installed app's own row (it carries `appKey`) reads the App Store's
            // name — THE store-copy resolver, the call its navbar tab makes
            // (HeaderTabs), so the chip says what the tab says (Nika 2026-10-23:
            // "app names = what a person sees in the workspace App Store"). Any
            // other declared label resolves through polyglot, as before.
            const resolved = $c104e66f813cfb63$var$str(row.appKey ? el.call('storeItemText', {
                key: row.appKey,
                name: declared
            }, 'name') : el.call('polyglot', declared));
            if (resolved) return resolved;
        }
        if (!$c104e66f813cfb63$var$_KEYISH.test(declared)) return declared;
    }
    // A module page the navbar never named: its own title, in the session's
    // language — before the English stand-in below.
    if (row.label === '' && $c104e66f813cfb63$var$_moduleRoutes(root).has(clean)) {
        const own = $c104e66f813cfb63$var$_modulePageTitle(clean, el);
        if (own) return own;
    }
    const seg = clean.split('/').filter(Boolean)[0];
    if (!seg) return (0, $7iFOV.shellSay)(el, 'workspace.aiAware.home');
    const cased = seg.replace(/[-_]/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
    const landing = $c104e66f813cfb63$var$_modulesLanding(root);
    if (landing && !(chip && $c104e66f813cfb63$var$_shellServedRoute(clean, el))) return chip ? '' : cased;
    // SIGNED OUT on a guest route (/login, /signup, an invitation landing): no
    // assistant is there to read a chip, so the chip stays empty and nothing
    // warns — every signed-out dev load of /login and /signup logged "no label"
    // (2026-10-21). The model wire keeps the segment name. Signed in, a
    // guest-allowed page (/marketplace, /feed) keeps its chip.
    if (chip && root && !root.currentUserId && el && typeof el.call === 'function' && el.call('isGuestAllowedPath', clean)) return '';
    // A page no descriptor and no app row names: its own registered title — the
    // words its tab and its pane header carry — in the session's language
    // (CHIP-TITLES, Nika 2026-10-31: every route gets an en and a ka chip title;
    // census __tests__/aiChipTitleCensus.test.js). Only the chip reads it: the
    // model wire keeps the segment name, one English name in every language.
    const own = $c104e66f813cfb63$var$_modulePageTitle(clean, el);
    if (own) return chip ? own : cased;
    // A shell page with no title of its own while the modules land: the chip
    // waits as before — no stand-in, no warning.
    if (landing) return '';
    // No label anywhere: the route's own name, segment-cased. It reads English in
    // a Georgian workspace, so DEV says so — once per route.
    (0, $er1Z5.warnUnlabelledOnce)('route', clean);
    return cased;
};
// What the user is FOCUSED on right now — an open detail modal / editor / dialog
// and the specific record it shows. detectOpenRecord is the SINGLE detection
// ladder (most-specific first; works across pages, incl. ones without a PAGES
// descriptor like /studio, /team-and-agents), returning `{ type, id, title }`
// (+ a few prose-only extras). buildSuggestions keys chips off the record TYPE;
// detectOpenView derives the server-facing sentence from the SAME record so the
// two can't drift. Returns null when nothing modal-ish is open.
function $c104e66f813cfb63$var$detectOpenRecord(root, el) {
    if (!root || typeof root !== 'object') return null;
    const t = root.selectedTicket;
    if (t) return {
        type: 'ticket',
        id: $c104e66f813cfb63$var$str(t.id),
        title: $c104e66f813cfb63$var$str(t.title || t.name),
        number: t.number
    };
    if (root.showEventDetail && root.selectedEvent) {
        const e = root.selectedEvent;
        return {
            type: 'event',
            id: $c104e66f813cfb63$var$str(e.id),
            title: $c104e66f813cfb63$var$str(e.title || e.name)
        };
    }
    const d = root.selectedDocument;
    if (d) return {
        type: 'document',
        id: $c104e66f813cfb63$var$str(d.id),
        title: $c104e66f813cfb63$var$str(d.title || d.name),
        editorMode: root.editorMode ? $c104e66f813cfb63$var$str(root.editorMode) : ''
    };
    if (root.profileEmail) {
        const email = $c104e66f813cfb63$var$str(root.profileEmail);
        return {
            type: 'person',
            id: email,
            title: email,
            profile: true
        };
    }
    if (root.selectedPerson) {
        const p = root.selectedPerson;
        return {
            type: 'person',
            id: $c104e66f813cfb63$var$str(p.id || p.email),
            title: $c104e66f813cfb63$var$nameOf(p),
            email: p.email ? $c104e66f813cfb63$var$str(p.email) : ''
        };
    }
    if (root._selectedAgent) {
        const a = root._selectedAgent;
        return {
            type: 'agent',
            id: $c104e66f813cfb63$var$str(a.id),
            title: $c104e66f813cfb63$var$str(a.name || a.id)
        };
    }
    if (root._selectedTeamMember) {
        const m = root._selectedTeamMember;
        return {
            type: 'teamMember',
            id: $c104e66f813cfb63$var$str(m.id || m.email),
            title: $c104e66f813cfb63$var$nameOf(m)
        };
    }
    if (root._createAgentOpen) return {
        type: 'createAgent',
        id: null,
        title: 'workspace.aiSuggest.record.newAgent'
    };
    if (root._createMemberOpen) return {
        type: 'createMember',
        id: null,
        title: 'workspace.aiSuggest.record.inviteMember'
    };
    if (root.selectedAnnouncement) {
        const a = root.selectedAnnouncement;
        return {
            type: 'announcement',
            id: $c104e66f813cfb63$var$str(a.id),
            title: $c104e66f813cfb63$var$str(a.title || '')
        };
    }
    // A note/KB/document open in the editor. `selectedDocument` above has readers
    // and no writer (state-app.js bucket note); the editor route + selectPageItem
    // write `editorDoc` — that is the key an open note actually lives on, while
    // the editor shows it (editorOnScreen).
    if (root.editorDoc && typeof root.editorDoc === 'object' && $c104e66f813cfb63$var$editorOnScreen(root)) {
        const d = root.editorDoc;
        return {
            type: 'document',
            id: $c104e66f813cfb63$var$str(d.id),
            title: $c104e66f813cfb63$var$str(d.title || d.name) || (0, $7iFOV.shellSay)(el, 'workspace.aiSuggest.record.untitledNote'),
            editorMode: root.editorMode ? $c104e66f813cfb63$var$str(root.editorMode) : ''
        };
    }
    // The open canvas PROJECT — least specific, so it sits last: a ticket/note
    // opened over the canvas wins. Same derivation as the canvas page title
    // (canvas/pages/main.js projectTitle): data.name → data.key → the URL key.
    const proj = $c104e66f813cfb63$var$openCanvasProject(root);
    if (proj) return proj;
    return null;
}
// `/p/<key>` on the workspace-stripped path (the ONLY canvas-project shape the
// unified shell serves) or the canvas main page's own mount flag. Title comes
// from the loaded project (`root.data`) when it is the open project, else the
// key — never blank, never the shell's own project.
const $c104e66f813cfb63$var$CANVAS_PROJECT_RE = /^\/p\/([^/?#]+)/;
// The project key the current URL opens, or null. Two shapes: the RAW
// `/w/<org>[/<ws>]/p/<key>` (the canvas page's own classifier,
// parseWorkspaceProjectPath — positional, resolver-free) and the stripped
// `/p/<key>` that effectivePath yields once the workspace handle resolver has
// eaten the prefix. Neither a bare `/w/<org>` nor any shell route matches.
function $c104e66f813cfb63$var$canvasProjectKey(root) {
    const raw = typeof window !== 'undefined' && window.location && window.location.pathname || $c104e66f813cfb63$var$str(root?.currentPath);
    const ws = raw ? (0, $7iFOV.shellParseWorkspaceProjectPath)(raw) : null;
    if (ws && ws.key) return $c104e66f813cfb63$var$str(ws.key);
    const m = $c104e66f813cfb63$var$CANVAS_PROJECT_RE.exec($c104e66f813cfb63$var$effectivePath(root));
    return m ? decodeURIComponent(m[1]) : null;
}
function $c104e66f813cfb63$var$openCanvasProject(root) {
    const key = $c104e66f813cfb63$var$canvasProjectKey(root) || '';
    if (!key && !root._projectCanvasOpen) return null;
    const data = root.data && typeof root.data === 'object' && !root.projectNotFound ? root.data : null;
    const loadedKey = data ? $c104e66f813cfb63$var$str(data.key) : '';
    // Only trust root.data when it IS this project (key match) or the path
    // carries no key to compare against.
    const trusted = data && (!key || !loadedKey || loadedKey === key);
    const title = trusted && $c104e66f813cfb63$var$str(data.name || data.key).trim() || key;
    if (!title) return null;
    return {
        type: 'project',
        id: key || loadedKey || title,
        title: title
    };
}
// ── THE ALTERABLE REFERENCE (2026-08-26 per Nika "user can alter this
// reference … might want to go with generic choice") ────────────────────────
// `root._aiRefMutedFor` pins a mute to ONE record identity — the same id
// string the awareness FOCUS-2 chip carries — so the user can take the open
// record OUT of the prompt (chip click) and every derived surface follows:
// detectOpenView returns null (the wire), buildSuggestions falls back to the
// page/generic set, and the chip renders with the existing `sent: 'dropped'`
// truth ("not sent", inactive ink). Opening a DIFFERENT record
// self-invalidates the mute — a stale flag can never silently strip context
// from an unrelated surface.
const $c104e66f813cfb63$var$recordRefKey = (rec)=>rec ? 'record:' + $c104e66f813cfb63$var$str(rec.type) + ':' + $c104e66f813cfb63$var$str(rec.id || '') : null;
const $c104e66f813cfb63$var$refMuted = (root, rec)=>!!(rec && root && root._aiRefMutedFor === $c104e66f813cfb63$var$recordRefKey(rec));
// Prose sentence for the server's system instruction — derived from the single
// detectOpenRecord ladder so the two never diverge. Byte-for-byte the sentences
// the AI resolves "this ticket / doc / person / agent" against.
// A MUTED reference returns null: the wire must carry nothing the user
// excluded, or "this ticket" would silently resolve against a record the UI
// says is not sent.
function $c104e66f813cfb63$var$detectOpenView(root) {
    const r = $c104e66f813cfb63$var$detectOpenRecord(root);
    if (!r) return null;
    if ($c104e66f813cfb63$var$refMuted(root, r)) return null;
    const { type: type, id: id, title: title } = r;
    switch(type){
        case 'ticket':
            return `A TICKET detail is open \u{2014} ${r.number != null ? '#' + r.number + ' ' : ''}"${title}" (id ${id}). "this ticket" refers to it.`;
        case 'event':
            return `An EVENT detail is open \u{2014} "${title}" (id ${id}). "this event" refers to it.`;
        case 'document':
            return `A DOCUMENT is open in the editor \u{2014} "${title}" (id ${id})${r.editorMode ? `, ${r.editorMode} mode` : ''}. "this doc" refers to it.`;
        case 'person':
            return r.profile ? `A PERSON profile is open for ${id}. "this person" refers to them.` : `A PERSON detail is open \u{2014} ${title}${r.email ? ' <' + r.email + '>' : ''}.`;
        case 'agent':
            return `An AGENT settings modal is open \u{2014} ${title}. "this agent" refers to it.`;
        case 'teamMember':
            return `A TEAM MEMBER detail is open \u{2014} ${title}.`;
        // MODEL-FACING, not UI copy: every case of this switch composes an English
        // sentence that goes into the assistant's context window beside the
        // page/record facts. It is never rendered.
        case 'createAgent':
            return 'The CREATE-AGENT dialog is open.';
        case 'createMember':
            return 'The INVITE-MEMBER dialog is open.';
        case 'announcement':
            return `An ANNOUNCEMENT is open \u{2014} "${title}".`;
        case 'project':
            return `A canvas PROJECT is open \u{2014} "${title}" (key ${id}). "this project" refers to it.`;
        default:
            return null;
    }
}
// Contextual action suggestions ("suggested UI to apply changes on whatever is
// open") — tappable chips the client surfaces above the composer. Each dispatches
// its `prompt` to the GENERAL assistant, which already receives the page/record
// context, so the prompt says "this ticket / doc / person" and the model resolves
// it. RECORD suggestions (a modal/detail is open) win over PAGE suggestions (a
// known section with nothing focused). `on` is the record title for the chip
// subtitle. Bounded, phrased as intents — not tool calls.
const $c104e66f813cfb63$var$RECORD_SUGGESTIONS = {
    ticket: [
        {
            labelKey: 'workspace.aiSuggest.ticket.status',
            promptKey: 'workspace.aiSuggest.ticket.statusPrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.ticket.reassign',
            promptKey: 'workspace.aiSuggest.ticket.reassignPrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.ticket.summarize',
            promptKey: 'workspace.aiSuggest.ticket.summarizePrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.ticket.subtasks',
            promptKey: 'workspace.aiSuggest.ticket.subtasksPrompt'
        }
    ],
    event: [
        {
            labelKey: 'workspace.aiSuggest.event.reschedule',
            promptKey: 'workspace.aiSuggest.event.reschedulePrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.event.summarize',
            promptKey: 'workspace.aiSuggest.event.summarizePrompt'
        }
    ],
    document: [
        {
            labelKey: 'workspace.aiSuggest.document.summarize',
            promptKey: 'workspace.aiSuggest.document.summarizePrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.document.improve',
            promptKey: 'workspace.aiSuggest.document.improvePrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.document.grammar',
            promptKey: 'workspace.aiSuggest.document.grammarPrompt'
        }
    ],
    person: [
        {
            labelKey: 'workspace.aiSuggest.person.summarize',
            promptKey: 'workspace.aiSuggest.person.summarizePrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.person.draftMessage',
            promptKey: 'workspace.aiSuggest.person.draftMessagePrompt'
        }
    ],
    agent: [
        {
            labelKey: 'workspace.aiSuggest.agent.refine',
            promptKey: 'workspace.aiSuggest.agent.refinePrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.agent.access',
            promptKey: 'workspace.aiSuggest.agent.accessPrompt'
        }
    ],
    teamMember: [
        {
            labelKey: 'workspace.aiSuggest.teamMember.summarize',
            promptKey: 'workspace.aiSuggest.teamMember.summarizePrompt'
        }
    ],
    announcement: [
        {
            labelKey: 'workspace.aiSuggest.announcement.summarize',
            promptKey: 'workspace.aiSuggest.announcement.summarizePrompt'
        },
        {
            labelKey: 'workspace.aiSuggest.announcement.draftReply',
            promptKey: 'workspace.aiSuggest.announcement.draftReplyPrompt'
        }
    ],
    createAgent: [
        {
            labelKey: 'workspace.aiSuggest.createAgent.setup',
            promptKey: 'workspace.aiSuggest.createAgent.setupPrompt'
        }
    ],
    createMember: [
        {
            labelKey: 'workspace.aiSuggest.createMember.who',
            promptKey: 'workspace.aiSuggest.createMember.whoPrompt'
        }
    ]
};
const $c104e66f813cfb63$var$PAGE_SUGGESTIONS = [
    {
        test: (p)=>p.startsWith('/tasks') || p.startsWith('/task/') || p.startsWith('/tickets'),
        items: [
            {
                labelKey: 'workspace.aiSuggest.tasks.create',
                promptKey: 'workspace.aiSuggest.tasks.createPrompt'
            },
            {
                labelKey: 'workspace.aiSuggest.tasks.blocked',
                promptKey: 'workspace.aiSuggest.tasks.blockedPrompt'
            },
            {
                labelKey: 'workspace.aiSuggest.tasks.board',
                promptKey: 'workspace.aiSuggest.tasks.boardPrompt'
            }
        ]
    },
    {
        test: (p)=>p.startsWith('/calendar'),
        items: [
            {
                labelKey: 'workspace.aiSuggest.calendar.agenda',
                promptKey: 'workspace.aiSuggest.calendar.agendaPrompt'
            },
            {
                labelKey: 'workspace.aiSuggest.calendar.schedule',
                promptKey: 'workspace.aiSuggest.calendar.schedulePrompt'
            }
        ]
    },
    {
        test: (p)=>p.startsWith('/chat'),
        items: [
            {
                labelKey: 'workspace.aiSuggest.chat.catchUp',
                promptKey: 'workspace.aiSuggest.chat.catchUpPrompt'
            }
        ]
    },
    {
        test: (p)=>p.startsWith('/notes') || p.startsWith('/documents') || p.startsWith('/docs'),
        items: [
            {
                labelKey: 'workspace.aiSuggest.notes.create',
                promptKey: 'workspace.aiSuggest.notes.createPrompt'
            }
        ]
    }
];
// The generic staples — always offered LAST, in quieter ink, so the active
// item never railroads the user (2026-08-26 per Nika "user might want to go
// with generic choice"). Marked `generic: true` for the island's styling.
const $c104e66f813cfb63$var$GENERIC_SUGGESTIONS = [
    {
        labelKey: 'workspace.aiSuggest.generic.myPlate',
        promptKey: 'workspace.aiSuggest.generic.myPlatePrompt'
    },
    {
        labelKey: 'workspace.aiSuggest.generic.whatCanYouDo',
        promptKey: 'workspace.aiSuggest.generic.whatCanYouDoPrompt'
    }
];
// A chip carries a bundle KEY, and the LABEL + the PROMPT it dispatches are
// both resolved here — the shared render site (`packages/shared/components/
// _simone/Suggestions.js`, `text: (el, s) => s.label`) belongs to another
// package and cannot resolve a key itself. `buildSuggestions` is reached as
// `el.call('buildSuggestions', root)`, so `this` is the element; a direct
// import call (the unit tests) gets the key back verbatim, which is exactly
// what those tests pin.
const $c104e66f813cfb63$var$_chipText = (el, key)=>el && typeof el.call === 'function' ? el.call('polyglot', key) : key;
const $c104e66f813cfb63$var$_resolveChip = (el, s)=>({
        ...s,
        label: $c104e66f813cfb63$var$_chipText(el, s.labelKey),
        prompt: $c104e66f813cfb63$var$_chipText(el, s.promptKey)
    });
function $c104e66f813cfb63$export$42a7dcd7dc4186c3(root) {
    const el = this;
    if (!root || typeof root !== 'object') return [];
    const out = [];
    const rec = $c104e66f813cfb63$var$detectOpenRecord(root, el);
    const recActive = rec && !$c104e66f813cfb63$var$refMuted(root, rec) && $c104e66f813cfb63$var$RECORD_SUGGESTIONS[rec.type];
    if (recActive) out.push(...$c104e66f813cfb63$var$RECORD_SUGGESTIONS[rec.type].map((s)=>({
            ...$c104e66f813cfb63$var$_resolveChip(el, s),
            on: $c104e66f813cfb63$var$_chipText(el, rec.title || '')
        })));
    else {
        const path = $c104e66f813cfb63$var$effectivePath(root);
        const pg = $c104e66f813cfb63$var$PAGE_SUGGESTIONS.find((p)=>{
            try {
                return p.test(path);
            } catch (_) {
                return false;
            }
        });
        if (pg) out.push(...pg.items.map((s)=>({
                ...$c104e66f813cfb63$var$_resolveChip(el, s),
                on: ''
            })));
    }
    const seen = new Set(out.map((s)=>s.labelKey));
    for (const g of $c104e66f813cfb63$var$GENERIC_SUGGESTIONS)if (!seen.has(g.labelKey)) out.push({
        ...$c104e66f813cfb63$var$_resolveChip(el, g),
        on: '',
        generic: true
    });
    return out;
}
const $c104e66f813cfb63$export$1e9e234045d0d8f = (root)=>$c104e66f813cfb63$var$effectivePath(root);
const $c104e66f813cfb63$export$41012afe37443be0 = (root, el)=>$c104e66f813cfb63$var$detectOpenRecord(root, el);
const $c104e66f813cfb63$export$9993da236aff70d0 = (rec)=>$c104e66f813cfb63$var$recordRefKey(rec);
const $c104e66f813cfb63$export$da4985c4c2b21b92 = (root, rec)=>$c104e66f813cfb63$var$refMuted(root, rec);
const $c104e66f813cfb63$export$c9a3ba6a1b1bd798 = (type)=>$c104e66f813cfb63$var$RECORD_SUGGESTIONS[type] || [];
const $c104e66f813cfb63$export$5ea9d37eab57d9f6 = (path)=>{
    const pg = $c104e66f813cfb63$var$PAGE_SUGGESTIONS.find((p)=>{
        try {
            return p.test(path);
        } catch (_) {
            return false;
        }
    });
    return pg ? pg.items : [];
};
const $c104e66f813cfb63$export$241a0c6669c62a48 = ()=>$c104e66f813cfb63$var$GENERIC_SUGGESTIONS;
const $c104e66f813cfb63$export$21430161971eda5b = (root, route)=>$c104e66f813cfb63$var$_declaredLabel(root, $c104e66f813cfb63$var$_pathOnly(route));
// (returns null when nothing notable is open). Reads root state (the framework-
// idiomatic source) plus a couple of shell signals the state doesn't mirror (the
// <html> chat-drawer/theme attributes, the windows-plugin modal stack), each
// guarded for non-browser contexts.
const $c104e66f813cfb63$var$buildUiState = (root)=>{
    const ui = {};
    // DATA SCOPE — the workspace + org the SDK and every read/write are pinned to.
    // The single most load-bearing context fact: whose data the AI is looking at
    // (switching workspaces changes everything the tools return).
    const ws = root.workspace;
    if (ws) {
        ui.workspace = {
            id: $c104e66f813cfb63$var$str(ws._id || ws.id),
            name: $c104e66f813cfb63$var$str(ws.displayName || ws.name || ws.slug),
            slug: $c104e66f813cfb63$var$str(ws.slug)
        };
        const mod = ws.settings && ws.settings.workspaceModule;
        if (mod && mod.owner && mod.key) ui.installedApp = $c104e66f813cfb63$var$str(mod.owner) + '/' + $c104e66f813cfb63$var$str(mod.key);
    }
    const org = root.org;
    if (org) ui.organization = {
        id: $c104e66f813cfb63$var$str(org.id || org._id),
        name: $c104e66f813cfb63$var$str(org.name),
        slug: $c104e66f813cfb63$var$str(org.slug)
    };
    // A page open in the shell PageSlot — the split pane BESIDE this chat. The AI
    // can reference it ("the page in the slot") and change it via open_page_in_split.
    if (root._canvasSlot) {
        ui.pageSlot = {
            route: $c104e66f813cfb63$var$str(root._canvasSlot)
        };
        if (root._canvasSlotSecond) ui.pageSlot.secondPane = $c104e66f813cfb63$var$str(root._canvasSlotSecond);
        if ((0, $7ytvD.slotFullscreenActive)(root)) ui.pageSlot.fullscreen = true;
    }
    // Assistant drawer (this chat's own container) + header-search morph.
    if (root.assistantOpen) ui.assistant = {
        open: true,
        dock: $c104e66f813cfb63$var$str(root.assistantDock || 'right')
    };
    if (root._headerSearchOpen) ui.searchOpen = true;
    // Shell chrome the root state doesn't mirror — read the <html> data-attributes
    // the shell stamps (chat drawer sidebar, forced theme). Guarded for SSR.
    if (typeof document !== 'undefined' && document.documentElement) {
        const de = document.documentElement;
        if (de.getAttribute('data-chat-drawer') === 'open') ui.chatDrawer = 'open';
        const theme = de.getAttribute('data-theme');
        if (theme) ui.theme = $c104e66f813cfb63$var$str(theme);
    }
    // Generic modal — the @symbo.ls/windows stack top (confirm/alert/prompt/custom
    // dialogs the app-specific detectOpenView ladder doesn't cover). The plugin
    // registers its ModalRoot element on a global handle (see windows ModalRoot
    // onInit); read the live stack off it. App-record modals are already reported
    // via `openView`, so this only adds the shared-dialog signal.
    try {
        const mr = typeof globalThis !== 'undefined' && globalThis.__SMBLS_WINDOWS_MODAL_ROOT__;
        const stack = mr && mr.state && mr.state.stack;
        if (Array.isArray(stack) && stack.length) {
            const top = stack[stack.length - 1];
            if (top) ui.dialog = {
                template: $c104e66f813cfb63$var$str(top.template || 'custom'),
                title: $c104e66f813cfb63$var$str(top.title || '')
            };
        }
    } catch (_) {
    /* windows plugin absent / not yet mounted — no dialog signal */ }
    return Object.keys(ui).length ? ui : null;
};
function $c104e66f813cfb63$export$9e506a4ac928dedc(root) {
    if (!root || typeof root !== 'object') return null;
    const path = $c104e66f813cfb63$var$effectivePath(root);
    const uiState = $c104e66f813cfb63$var$buildUiState(root);
    // Focused modal/record applies on every page (even ones without a descriptor).
    const openView = $c104e66f813cfb63$var$detectOpenView(root);
    const match = $c104e66f813cfb63$var$PAGES.find((d)=>{
        try {
            return d.test(path);
        } catch (_) {
            return false;
        }
    });
    if (!match) // Unknown / unregistered page — still tell the AI WHERE the user is, what is
    // open, and the generic capabilities, so it never claims to be blind.
    return {
        currentPage: $c104e66f813cfb63$var$titleFromPath(path, root, this),
        pageData: null,
        pageActions: [
            'navigate to a section (navigate_to_app)',
            'search the workspace (open_search)'
        ],
        openView: openView,
        uiState: uiState
    };
    let data = null;
    try {
        data = match.data(root);
    } catch (_) {
        data = null;
    }
    return {
        currentPage: match.page,
        pageData: data,
        pageActions: match.actions,
        openView: openView,
        uiState: uiState
    };
}
// ── AI AWARENESS — "what the AI can see" as ONE derived set (O1, opus.md) ────
//
// DEFINITION: "the AI is aware of X" means X is present in the payload the
// current Send would transmit. Not "on screen", not "selected". The set is
// DERIVED from the transmit path (this module builds dispatchContext for
// simoneAiTransport, and the composer draft bag is serialised by
// promptAttachments.buildPromptPayload) — so the UI cannot claim more than the
// wire carries, and this module and the wire cannot drift.
//
// THREE TIERS, one item shape:
//   scope    — what the AI can REACH: workspace + org the SDK is pinned to,
//              plus the workspace-wide tools. One line, never a chip.
//   focus    — what the AI is LOOKING AT (implicit): the route, the open record
//              (detectOpenRecord ladder), the bounded page rows, the canvas
//              selection. Canvas selection carries a removeVia (deselect) —
//              the one focus item the user can act on; route/record do not.
//   attached — what the user HANDED it: STRUCTURED entity refs + one canvas
//              board (root.aiAttached, spec §4.1), then the text-only legs —
//              dragged refs, dropped files/images, picked elements. Removable.
// Item: { id, kind, title, icon, source, sent, removeVia }
//   kind    element | subject | ticket | project | artboard | note | file |
//           app | page | event | person | agent | announcement | image |
//           rows | route (Nika's list maps straight onto these)
//   sent    'structured' — in the allowlisted context object the server keeps
//           'text-only'  — survives ONLY as a text line/prefix in the prompt
//                          body (canvas selection, picked elements, refs, files)
//           'truncated'  — sent, but capped (board rows past the per-page cap)
//           'dropped'    — never leaves the browser. Since image attachments
//                          ride the turn (the SDK body is {content, modelMode,
//                          targetAgentId, context, attachments}), an image is
//                          'dropped' only when the attachment caps REFUSE it.
//   removeVia — a DESCRIPTOR { fn, arg } the chip dispatches with el.call, never
//           a handler. Collapses the three hardcoded removal paths.
// `composerState` is the SECOND ARGUMENT, not a root key: the draft bag
// (draft/files/refs/images) is per-composer element state and two composers can
// be live at once. Callers pass their own.
// Reactive inputs are all flat on root — a consumer MUST `subscribeTo:
// ['_cvSelectionTick']` for the canvas selection (the selection object is a
// plain in-place mutation; the tick is the only bridge) — plus pickedElements,
// currentPath, _canvasSlot, workspace, org and the detectOpenRecord keys.
const $c104e66f813cfb63$var$RECORD_KIND = {
    ticket: 'ticket',
    event: 'event',
    document: 'note',
    person: 'subject',
    agent: 'agent',
    teamMember: 'subject',
    createAgent: 'agent',
    createMember: 'subject',
    announcement: 'announcement',
    project: 'project'
};
const $c104e66f813cfb63$var$RECORD_ICON = {
    ticket: 'checkOval',
    event: 'dateOutline',
    document: 'edit',
    person: 'user',
    agent: 'star',
    teamMember: 'user',
    createAgent: 'star',
    createMember: 'user',
    announcement: 'bell',
    project: 'grid'
};
const $c104e66f813cfb63$var$REF_KIND = {
    ticket: 'ticket',
    project: 'project',
    page: 'artboard',
    file: 'file',
    note: 'note',
    kb: 'note',
    event: 'event'
};
const $c104e66f813cfb63$var$REF_ICON = {
    ticket: 'checkOval',
    project: 'grid',
    page: 'document',
    file: 'document',
    note: 'edit',
    kb: 'star',
    event: 'dateOutline'
};
const $c104e66f813cfb63$var$_CV_DS_PREFIX = '__ds/';
function $c104e66f813cfb63$export$cdaa13c6395ddfd1(root, composerState) {
    const out = {
        scope: null,
        focus: [],
        attached: []
    };
    if (!root || typeof root !== 'object') return out;
    const st = composerState && typeof composerState === 'object' ? composerState : {};
    // SCOPE — mirrors buildUiState's workspace/organization block (the wire's
    // uiState), rendered as one line.
    const ws = root.workspace;
    const org = root.org;
    const wsName = ws ? $c104e66f813cfb63$var$str(ws.displayName || ws.name || ws.slug) : '';
    const orgName = org ? $c104e66f813cfb63$var$str(org.name || org.slug) : '';
    out.scope = {
        workspace: wsName || null,
        organization: orgName || null,
        line: [
            wsName ? (0, $7iFOV.shellSay)(this, 'workspace.aiAware.scopeWorkspace').replace('{name}', wsName) : null,
            orgName ? (0, $7iFOV.shellSay)(this, 'workspace.aiAware.scopeOrg').replace('{name}', orgName) : null,
            (0, $7iFOV.shellSay)(this, 'workspace.aiAware.scopeTools')
        ].filter(Boolean).join(" \xb7 ")
    };
    // FOCUS 1 — the route (dispatchContext.currentPage): structured.
    const path = $c104e66f813cfb63$var$effectivePath(root);
    const match = $c104e66f813cfb63$var$PAGES.find((d)=>{
        try {
            return d.test(path);
        } catch (_) {
            return false;
        }
    });
    // On a canvas project path the open-record ladder yields the PROJECT (FOCUS 2);
    // a generic route chip there would read "P" (titleFromPath of `/p/<key>`) —
    // the labeling nit the 2026-08-18 qa pass filed. The project chip is the page.
    //
    // The chip is for a PERSON, so a known route reads its label-table key in the
    // workspace's language. `match.page` is the MODEL's name for the route
    // (buildPageContext sends it as `currentPage`) and stays English.
    const pageTitle = match ? (0, $er1Z5.routeLabel)(match.page, (key)=>(0, $7iFOV.shellSay)(this, key)) : $c104e66f813cfb63$var$canvasProjectKey(root) ? '' : $c104e66f813cfb63$var$titleFromPath(path, root, this, {
        chip: true
    });
    if (pageTitle) out.focus.push({
        id: 'route:' + $c104e66f813cfb63$var$str(path),
        kind: 'route',
        title: pageTitle,
        icon: 'grid',
        source: 'route',
        sent: 'structured',
        removeVia: null
    });
    // FOCUS 2 — the open record (detectOpenRecord ladder → dispatchContext.openView).
    // THE user-alterable reference: the item carries its refKey + muted state so
    // the chip can toggle it, and a muted reference reports the EXISTING
    // `dropped` truth — the wire (detectOpenView) really does carry nothing then.
    const rec = $c104e66f813cfb63$var$detectOpenRecord(root, this);
    if (rec) {
        const muted = $c104e66f813cfb63$var$refMuted(root, rec);
        out.focus.push({
            id: $c104e66f813cfb63$var$recordRefKey(rec),
            kind: $c104e66f813cfb63$var$RECORD_KIND[rec.type] || 'subject',
            title: rec.title || rec.type,
            icon: $c104e66f813cfb63$var$RECORD_ICON[rec.type] || 'document',
            source: 'record',
            sent: muted ? 'dropped' : 'structured',
            refKey: $c104e66f813cfb63$var$recordRefKey(rec),
            muted: muted,
            removeVia: null
        });
    }
    // FOCUS 3 — bounded page rows (dispatchContext.pageData): structured, or
    // TRUNCATED when a root array is longer than what the descriptor caps.
    if (match) {
        let data = null;
        try {
            data = match.data(root);
        } catch (_) {
            data = null;
        }
        if (data && typeof data === 'object') {
            // Each collection reads its own phrase keys (aiAwarenessLabels.js):
            // "1 ticket", "25 of 30 tickets" — in the workspace's language.
            const rows = (0, $er1Z5.rowsSummary)(data, root, (key)=>(0, $7iFOV.shellSay)(this, key), match.rootKeys);
            if (rows.title) out.focus.push({
                id: 'rows:' + $c104e66f813cfb63$var$str(match.page),
                kind: 'rows',
                title: rows.title,
                icon: 'list',
                source: 'pageData',
                sent: rows.truncated ? 'truncated' : 'structured',
                removeVia: null
            });
        }
    }
    // FOCUS 4 — canvas selection (root.canvas.selection.ids). Survives ONLY as the
    // "Selected artboards: …" prompt prefix (the server drops selectedItems).
    root._cvSelectionTick;
    const canvas = root.canvas;
    const ids = canvas && canvas.selection && Array.isArray(canvas.selection.ids) ? canvas.selection.ids : [];
    if (ids.length) {
        const pages = root.data && root.data.pages || {};
        for (const key of ids){
            const isDs = typeof key === 'string' && key.indexOf($c104e66f813cfb63$var$_CV_DS_PREFIX) === 0;
            const isPage = key in pages;
            out.focus.push({
                id: 'cv:' + $c104e66f813cfb63$var$str(key),
                kind: isDs ? 'app' : isPage ? 'artboard' : 'element',
                title: isDs ? (0, $7iFOV.shellSay)(this, 'workspace.aiAware.designSystem').replace('{name}', $c104e66f813cfb63$var$str(key).slice($c104e66f813cfb63$var$_CV_DS_PREFIX.length).replace(/^\w/, (c)=>c.toUpperCase())) : $c104e66f813cfb63$var$str(key),
                icon: isPage ? 'copy' : 'library',
                source: 'canvasSelection',
                sent: 'text-only',
                removeVia: {
                    fn: 'toggleSelection',
                    arg: key
                }
            });
        }
    }
    // ATTACHED — STRUCTURED (spec §4.1). What the user HANDED the assistant
    // through `el.call('attachAiRef' | 'attachAiCanvas', …)`: entity refs and at
    // most one canvas board, held on `root.aiAttached` and forwarded by
    // simoneAiTransport as `context.attached`. These are the only attachments
    // that reach the model as DATA — the server keeps them after its allowlist,
    // the orchestrator renders them as a fenced ATTACHED CONTEXT block and
    // registers each ref as a retrieval candidate — so they carry
    // `sent: 'structured'` while the numbered tiers below stay 'text-only'.
    // They come FIRST for the same reason: strongest delivery, first chip.
    //
    // `kind` here is the EntityRef TYPE verbatim (record | doc | mail | ticket |
    // file | event | channel | canvas), which widens the vocabulary listed in
    // this function's header. Nothing renders off `kind` (AiContextChip reads
    // icon/title/sent/removeVia), so the honest name beats a lossy remap onto
    // the older list.
    const attached = (0, $i2kG6.readAiAttached)(root);
    for (const ref of attached.refs){
        if (!ref) continue;
        const key = $c104e66f813cfb63$var$formatEntityRef(ref);
        if (!key) continue;
        out.attached.push({
            id: 'attached:' + key,
            kind: $c104e66f813cfb63$var$str(ref.type),
            // The producer's own name for the row ▸ the ref's resolved title ▸ the
            // KIND, as a polyglot key the chip resolves at its render site. NEVER
            // the id: '<collection>/<rowId>' is a machine string, and it is the same
            // defect as the Longbow board's "Mail thread f82cc8" card (design §3.5).
            title: $c104e66f813cfb63$var$str(ref.meta && ref.meta.title || ref.title || $c104e66f813cfb63$var$entityRefKindKey(ref)),
            icon: $c104e66f813cfb63$var$entityRefIcon(ref),
            source: 'attachedRef',
            sent: 'structured',
            removeVia: {
                fn: 'detachAiRef',
                arg: key
            }
        });
    }
    // The attached canvas board. One per turn (attachAiCanvas REPLACES), so one
    // chip. The title says how much of the board is going, because the payload
    // is capped upstream (spec §3.8: 60 nodes, 120 connections) and a chip that
    // said only the board name would over-claim.
    if (attached.canvas) {
        const cv = attached.canvas;
        const nodes = Array.isArray(cv.nodes) ? cv.nodes.length : 0;
        const label = $c104e66f813cfb63$var$str(cv.title) || (0, $7iFOV.shellSay)(this, 'workspace.aiAware.canvasBoard');
        out.attached.push({
            id: 'attachedCanvas:' + $c104e66f813cfb63$var$str(cv.projectId || '') + '/' + $c104e66f813cfb63$var$str(cv.boardPageId || ''),
            kind: 'canvas',
            title: !nodes ? label : nodes === 1 ? (0, $7iFOV.shellSay)(this, 'workspace.aiAware.canvasItemsOne').replace('{name}', label) : (0, $7iFOV.shellSay)(this, 'workspace.aiAware.canvasItems').replace('{name}', label).replace('{count}', nodes),
            icon: 'grid',
            source: 'attachedCanvas',
            sent: 'structured',
            // `attachAiCanvas(null)` IS the detach — one function, no second name.
            removeVia: {
                fn: 'attachAiCanvas',
                arg: null
            }
        });
    }
    // ATTACHED 1 — dragged entity refs (buildPromptPayload → dragRefToText line).
    for (const ref of Array.isArray(st.refs) ? st.refs : []){
        if (!ref) continue;
        out.attached.push({
            id: 'ref:' + $c104e66f813cfb63$var$str(ref.key || ref.id || ref.href),
            kind: $c104e66f813cfb63$var$REF_KIND[ref.kind] || 'subject',
            title: $c104e66f813cfb63$var$str(ref.title || ref.href || ref.kind),
            icon: $c104e66f813cfb63$var$REF_ICON[ref.kind] || 'document',
            source: 'ref',
            sent: 'text-only',
            removeVia: {
                fn: 'removePromptAttachment',
                arg: {
                    kind: 'ref',
                    key: ref.key
                }
            }
        });
    }
    // ATTACHED 2 — dropped files ("[Attached file: …]" line only).
    for (const f of Array.isArray(st.files) ? st.files : []){
        if (!f) continue;
        out.attached.push({
            id: 'file:' + $c104e66f813cfb63$var$str(f.key || f.name),
            kind: 'file',
            title: $c104e66f813cfb63$var$str(f.name),
            icon: 'document',
            source: 'file',
            sent: 'text-only',
            removeVia: {
                fn: 'removePromptAttachment',
                arg: {
                    kind: 'file',
                    key: f.key
                }
            }
        });
    }
    // ATTACHED 3 — images. The BYTES now go: sendPrompt puts them on the
    // envelope as `attachments`, the transport hands them to sdk.ai, and the
    // server persists them as `image` content parts the multimodal providers
    // send as real image blocks. So a chip is 'structured' when the caps accept
    // it, and 'dropped' ONLY for one they refuse (too many / too big / an
    // unsupported format) — the honest per-image verdict, computed by the SAME
    // normalizer the send path runs, so the chip and the wire can never disagree.
    const imageList = Array.isArray(st.images) ? st.images : [];
    const imageVerdicts = imageList.length ? (0, $8eEEA.normalizeComposerImages)(imageList).decisions : [];
    for(let i = 0; i < imageList.length; i++){
        const img = imageList[i];
        if (!img) continue;
        const obj = typeof img === 'object';
        const accepted = imageVerdicts.find((d)=>d.index === i)?.accepted === true;
        out.attached.push({
            id: 'image:' + $c104e66f813cfb63$var$str(obj ? img.key || img.name : 'legacy'),
            kind: 'image',
            title: obj && img.name ? $c104e66f813cfb63$var$str(img.name) : (0, $7iFOV.shellSay)(this, 'workspace.aiAware.image'),
            icon: 'image',
            source: 'image',
            sent: accepted ? 'structured' : 'dropped',
            removeVia: obj && img.key ? {
                fn: 'removePromptAttachment',
                arg: {
                    kind: 'image',
                    key: img.key
                }
            } : null
        });
    }
    // ATTACHED 4 — picked elements ("[user is pointing at: …]" prefix only).
    // An INSPECTED region (the composer's Inspect & ask — functions/aiInspect.js)
    // is a picked entry with its facts on `inspect`: it rides the turn
    // STRUCTURED (`context.inspected`, the server's INSPECTED line), so its
    // chip says so and wears the inspect glyph.
    for (const p of Array.isArray(root.pickedElements) ? root.pickedElements : []){
        if (!p) continue;
        const kp = Array.isArray(p.keyPath) ? p.keyPath : [];
        const region = !!(p.inspect && typeof p.inspect === 'object');
        out.attached.push({
            id: 'picked:' + $c104e66f813cfb63$var$str(p.pickedAt || p.key || p.tag),
            kind: region ? 'region' : 'element',
            title: kp.length ? kp.join(" \u203A ") : $c104e66f813cfb63$var$str(p.component || p.key || p.tag) || (0, $7iFOV.shellSay)(this, 'workspace.aiAware.element'),
            icon: region ? 'lnInspect' : 'cursor',
            source: 'picked',
            sent: region ? 'structured' : 'text-only',
            removeVia: p.pickedAt != null ? {
                fn: 'removePickedElement',
                arg: p.pickedAt
            } : null
        });
    }
    return out;
}
// ── The doc-family open path (document / note / kb) ─────────────────────────
// Dev 2026-10-27 (thread 6ae11be063f259960e3fa243): "Open the 'Lead Generation
// Strategy' document" showed "Empty note", and an off-page doc never opened.
// One doc carries TWO ids: its docId (the slug, `NOTE-LEAD-GENERATION-STRATEGY`)
// and its Mongo _id. Search lists it under both, and the model opens the one it
// read — so a loaded row matches either.
const $c104e66f813cfb63$var$_docRowIs = (x, wanted)=>!!(x && wanted) && ($c104e66f813cfb63$var$str(x.id) === wanted || $c104e66f813cfb63$var$str(x._id) === wanted || $c104e66f813cfb63$var$str(x.docId) === wanted);
// The body the editor shows: a markdown STRING stays the string, a legacy
// blocks object stays the object — the documents surface's own open shape
// (components/Main.js `_ensureContent`). Anything else is the empty note. The
// old `{ blocks: [] }` for a string body emptied every markdown doc, and the
// editor keeps an editorDoc whose id matches the address.
const $c104e66f813cfb63$var$_pageDocContent = (c)=>typeof c === 'string' ? c : c && typeof c === 'object' ? c : '';
// A LOADED row is the doc only when it carries a body: a markdown string or a
// legacy blocks object, as the list fetch normalized it. A row with neither is
// a LEAN list row (the home Documents tile maps no body). Opened as it is, the
// editor showed the note empty, and Edit → Save / Back wrote '' over it (the
// editor saves what it holds, documents functions/saveNote.js). A lean row is
// read by id instead (_fetchPageDoc).
const $c104e66f813cfb63$var$_pageDocWithBody = (row)=>row && (typeof row.content === 'string' || !!row.content && typeof row.content === 'object') ? row : null;
// A doc off the loaded list: ONE docs `get`, which takes a docId OR a Mongo _id
// (server DocService.get). Through `execute`: the shell's SDK answers EVERY
// method with a promise, `getService` included, so the old
// `getService('docs').get(id)` read `.get` off a promise, threw, and every
// off-page open answered "not found". → { row, id } or null (unknown or refused).
const $c104e66f813cfb63$var$_fetchPageDoc = async (wanted)=>{
    try {
        const res = await $c104e66f813cfb63$var$shellGetSDK().execute('docs', 'get', {
            id: wanted
        });
        const row = res && typeof res === 'object' && res.data ? res.data : res;
        const rid = row && typeof row === 'object' && (row.docId || row._id || row.id);
        return rid ? {
            row: row,
            id: $c104e66f813cfb63$var$str(rid)
        } : null;
    } catch (_) {
        return null;
    }
};
// WHERE a doc opens. Beside the assistant's main thread it opens in the PageSlot
// (`notesNavigate` with `{ slot: true }`): a shell navigation changes the route,
// and the main thread closes on any route change (assistantMainThreadSync), so
// "open the doc" used to close the conversation that asked for it. Elsewhere the
// slot-aware notes navigation decides as it always has: a notes pane keeps it, a
// page routes. The documents surface is folded first when it is not registered
// yet. → true when something opened.
const $c104e66f813cfb63$var$_openPageDoc = async (el, root, path)=>{
    const fnsOf = ()=>el && el.context && el.context.functions || {};
    let fns = fnsOf();
    const beside = typeof fns.assistantMainThreadOpen === 'function' && el.call('assistantMainThreadOpen', root) === true;
    if (typeof fns.notesNavigate !== 'function' && typeof fns.ensureDocumentsContext === 'function') {
        try {
            await el.call('ensureDocumentsContext');
        } catch (_) {
        /* the fold failed — the router below, or nothing */ }
        fns = fnsOf();
    }
    if (typeof fns.notesNavigate === 'function') {
        if (beside) el.call('notesNavigate', path, {
            slot: true
        });
        else el.call('notesNavigate', path);
        return true;
    }
    // No documents surface at all: the route — never beside a main thread.
    if (beside) return false;
    let node = el;
    while(node && !node.routes)node = node.parent;
    if (!node || typeof el.router !== 'function') return false;
    el.router(path, node);
    return true;
};
async function $c104e66f813cfb63$export$376a6c1bb83858e3(type, id, collection) {
    const root = this?.state?.root || this?.state;
    if (!root || typeof root.update !== 'function') return {
        ok: false,
        error: (0, $7iFOV.shellSay)(this, 'workspace.pageItem.noUi')
    };
    const wanted = $c104e66f813cfb63$var$str(id);
    // A refusal reaches the tool row's result and the model: through the
    // element's polyglot (`_say`), the id in as text, never as a pattern.
    const notFound = (key)=>({
            ok: false,
            error: (0, $7iFOV.shellSay)(this, key).replace('{id}', ()=>wanted)
        });
    const byId = (arr)=>Array.isArray(arr) ? arr.find((x)=>$c104e66f813cfb63$var$str(x?.id) === wanted) : null;
    const docById = (arr)=>Array.isArray(arr) ? arr.find((x)=>$c104e66f813cfb63$var$_docRowIs(x, wanted)) : null;
    // Walk up to the routes-bearing root element so this.router() can drive SPA
    // navigation from any calling element — the same pattern LinkedResources
    // ._navigateTo uses (workspace/components/LinkedResources.js). Needed so an
    // "open this record" call from one page can hand off to the record's owning
    // route (its page fetch loads the record, then its own open path runs).
    const routeEl = ()=>{
        let node = this;
        while(node && !node.routes)node = node.parent;
        return node;
    };
    const onRoute = (prefix)=>$c104e66f813cfb63$var$effectivePath(root).startsWith(prefix);
    switch($c104e66f813cfb63$var$str(type)){
        case 'ticket':
            {
                let t = byId(root.tickets);
                if (!t) // Not in the loaded board page — freshly created elsewhere, paginated
                // out, or the user is off the board. openTicketDetailModal is a GLOBAL
                // @symbo.ls/windows layer (not board-bound), so fetch the ticket by id
                // and open it from any page instead of failing with "not on this page".
                try {
                    const tSvc = await $c104e66f813cfb63$var$shellGetSDK().getService('tickets');
                    const doc = await tSvc.get(wanted);
                    const row = doc?.data || doc;
                    const rid = row && (row._id || row.id);
                    if (rid) t = {
                        ...row,
                        id: rid
                    };
                } catch (_) {}
                if (!t) return notFound('workspace.pageItem.ticketNotFound');
                try {
                    this.call('openTicketDetailModal', t);
                } catch (_) {
                    root.update({
                        selectedTicket: t
                    });
                }
                return {
                    ok: true,
                    opened: {
                        type: 'ticket',
                        id: wanted
                    }
                };
            }
        case 'channel':
            {
                // No `get`-by-id op exists for workspaceProject.chat (only list/create/
                // update/remove), so an off-/chat call relies on /chat's own list fetch
                // to load the channel after we navigate. If we ARE on /chat and the
                // channel still isn't in the loaded list, it genuinely isn't a channel
                // in this workspace — fail honestly rather than select nothing.
                const c = byId(root.channels);
                if (onRoute('/chat') && !c) return notFound('workspace.pageItem.channelNotFound');
                const rootEl = routeEl();
                // Canonical channel open (chat/pages/index.js data-channel-link handler +
                // LinkedResources._navigateTo): select the channel, reset any open
                // thread, land on the conversation tab, mark it read. Navigate to /chat
                // so the page is mounted and its channel list fetch runs when off-route.
                root.update({
                    activeChannelId: wanted,
                    activeTab: 'conversation',
                    activeThreadRootId: null
                });
                if (rootEl) this.router('/chat', rootEl);
                try {
                    // markRead rides the lazily-folded chat context (bundle-fold) — the
                    // /chat route fold above is in flight; sequence behind the fold.
                    Promise.resolve(this.call('ensureChatContext')).then((ok)=>{
                        if (ok !== false) this.call('markRead', wanted);
                    }).catch(()=>{});
                } catch (_) {}
                return {
                    ok: true,
                    opened: {
                        type: 'channel',
                        id: wanted
                    }
                };
            }
        case 'document':
            {
                // The unified /notes grid holds every doc-family row; a doc can also sit
                // in the legacy `notes` store.
                let d = $c104e66f813cfb63$var$_pageDocWithBody(docById(root.documents)) || $c104e66f813cfb63$var$_pageDocWithBody(docById(root.notes));
                if (!d) {
                    // Off the loaded lists, or only a lean row there — one docs `get`
                    // (_fetchPageDoc). Works from any page, by docId or by _id.
                    const got = await $c104e66f813cfb63$var$_fetchPageDoc(wanted);
                    if (got) d = {
                        id: got.id,
                        // `editorDoc` is rendered by the DOCUMENTS surface, so its
                        // untitled fallback is that surface's copy. Reused, never
                        // duplicated into `workspace.*` — the workspace manifest
                        // declares `documents`, so the bundle is loaded here.
                        title: got.row.title || this.call('polyglot', 'documents.editor.untitled'),
                        content: (0, $hml1G._docContent)(got.row.body || got.row.content)
                    };
                }
                if (!d) return notFound('workspace.pageItem.documentNotFound');
                // Canonical open = DocsCard.onClick (documents/components/Main.js): seed
                // editorDoc + view mode + the editor section, then open the editor.
                // No editor reads `selectedDocument`, so the old bare update was dead.
                root.update({
                    editorDoc: {
                        id: d.id,
                        title: d.title,
                        content: $c104e66f813cfb63$var$_pageDocContent(d.content)
                    },
                    editorMode: 'view',
                    activeSection: 'editor'
                });
                const shown = await $c104e66f813cfb63$var$_openPageDoc(this, root, '/notes/editor#note=' + encodeURIComponent($c104e66f813cfb63$var$str(d.id)));
                if (!shown) return {
                    ok: false,
                    error: (0, $7iFOV.shellSay)(this, 'workspace.pageItem.noUi')
                };
                return {
                    ok: true,
                    opened: {
                        type: 'document',
                        id: wanted
                    }
                };
            }
        case 'note':
            {
                let n = $c104e66f813cfb63$var$_pageDocWithBody(docById(root.notes)) || $c104e66f813cfb63$var$_pageDocWithBody(docById(root.documents));
                if (!n) {
                    // Off the notes lists, or only a lean row there — same off-page read
                    // as 'document' (docId is
                    // unique across every doc-family type, so the plain get op works
                    // regardless of which discriminator the row is).
                    const got = await $c104e66f813cfb63$var$_fetchPageDoc(wanted);
                    if (got) n = {
                        id: got.id,
                        title: got.row.title || this.call('polyglot', 'documents.notes.untitled'),
                        content: (0, $hml1G._docContent)(got.row.body || got.row.content),
                        source: got.row.source || 'member',
                        author: got.row.author
                    };
                }
                if (!n) return notFound('workspace.pageItem.noteNotFound');
                // Canonical open = NoteCard.onClick (documents/components/Notes.js).
                root.update({
                    selectedNoteId: n.id,
                    editorDoc: {
                        id: n.id,
                        title: n.title || this.call('polyglot', 'documents.notes.untitled'),
                        content: $c104e66f813cfb63$var$_pageDocContent(n.content),
                        source: n.source || 'member',
                        author: n.author
                    },
                    editorMode: 'view',
                    activeSection: 'editor'
                });
                const shown = await $c104e66f813cfb63$var$_openPageDoc(this, root, '/notes/editor#note=' + encodeURIComponent($c104e66f813cfb63$var$str(n.id)));
                if (!shown) return {
                    ok: false,
                    error: (0, $7iFOV.shellSay)(this, 'workspace.pageItem.noUi')
                };
                return {
                    ok: true,
                    opened: {
                        type: 'note',
                        id: wanted
                    }
                };
            }
        case 'kb':
            {
                let k = $c104e66f813cfb63$var$_pageDocWithBody(docById(root.kbArticles));
                if (!k) {
                    const got = await $c104e66f813cfb63$var$_fetchPageDoc(wanted);
                    if (got) k = {
                        id: got.id,
                        title: got.row.title || this.call('polyglot', 'documents.kb.untitledArticle'),
                        content: (0, $hml1G._docContent)(got.row.body || got.row.content)
                    };
                }
                if (!k) return notFound('workspace.pageItem.articleNotFound');
                // Canonical open = KbCard.onClick (documents/components/KnowledgeBase.js).
                root.update({
                    editorDoc: {
                        id: k.id,
                        title: k.title,
                        content: $c104e66f813cfb63$var$_pageDocContent(k.content),
                        source: 'kb'
                    },
                    editorMode: 'view',
                    activeSection: 'editor'
                });
                const shown = await $c104e66f813cfb63$var$_openPageDoc(this, root, '/notes/editor#kb=' + encodeURIComponent($c104e66f813cfb63$var$str(k.id)));
                if (!shown) return {
                    ok: false,
                    error: (0, $7iFOV.shellSay)(this, 'workspace.pageItem.noUi')
                };
                return {
                    ok: true,
                    opened: {
                        type: 'kb',
                        id: wanted
                    }
                };
            }
        case 'event':
            {
                const e = byId(root.events);
                if (e) {
                    // Global @symbo.ls/windows modal — opens over any route (mirrors the
                    // ticket case). openEventDetailModal sets selectedEvent +
                    // showEventDetail AND mounts the modal layer via openModal; the old
                    // bare `root.update({ selectedEvent })` set state but opened nothing.
                    this.call('openEventDetailModal', e);
                    return {
                        ok: true,
                        opened: {
                            type: 'event',
                            id: wanted
                        }
                    };
                }
                // Off the calendar / outside the loaded ±14-day window. workspaceProject
                // .calendar has a `get` op, but its raw row needs rowToEvent (a
                // calendar-page mapper not reachable here). The calendar route's own
                // `?event=<id>` deep-link restore (hashRestoreTick) fetches + maps +
                // opens the SAME global modal, polling until events load — hand off to
                // it instead of duplicating rowToEvent.
                const rootEl = routeEl();
                if (rootEl) {
                    this.router('/calendar?event=' + encodeURIComponent(wanted), rootEl);
                    return {
                        ok: true,
                        opened: {
                            type: 'event',
                            id: wanted
                        }
                    };
                }
                return notFound('workspace.pageItem.eventNotFound');
            }
        case 'room':
            {
                let r = byId(root.rooms);
                if (!r) // workspaceProject.meet.rooms has a `get` op — verify the room exists
                // off-route so we fail honestly instead of joining an empty call. The
                // raw row is only an existence flag; the /meet page fetch maps + shows
                // it after navigation.
                try {
                    const res = await $c104e66f813cfb63$var$shellGetSDK().execute('workspaceProject.meet.rooms', 'get', {
                        id: wanted
                    });
                    const row = Array.isArray(res?.data) ? res.data[0] : res?.data ?? res;
                    if (row && (row.id || row._id)) r = row;
                } catch (_) {}
                if (!r) return notFound('workspace.pageItem.roomNotFound');
                // OPENING A ROOM IS NEVER A JOIN (MEET-AUTOJOIN-1). This case used to
                // call connectCall — microphone on, no preview — and select_page_item
                // is a read-only tool, so a RE-OFFERED pending call (_simone/
                // pendingClientCall.js) ran it in whatever tab next read the
                // conversation: live on dev 2026-10-18 a tab joined a call nobody
                // clicked Join on. The room now opens through the meet page's own
                // guarded deep link, `#room=<id>&view=call` (meet pages/index.js
                // `_resolveMeetSeed`): a cold link opens the JOIN PREVIEW, whose "Join
                // now" is the only thing that starts media; a link to the call this tab
                // is already in shows it again (no new media).
                const rootEl = routeEl();
                const onMeet = onRoute('/meet');
                if (rootEl) this.router('/meet#room=' + encodeURIComponent(wanted) + '&view=call', rootEl);
                if (!onMeet) return {
                    ok: true,
                    opened: {
                        type: 'room',
                        id: wanted
                    }
                };
                // Already on /meet: the page does not remount and a pushed hash fires no
                // hashchange, so its seed never runs — apply its decision here. The meet
                // context is folded while its page is mounted (getLivekitRoom).
                const live = this.call('getLivekitRoom');
                if (live && $c104e66f813cfb63$var$str(live._smblsRoomId || live.name) === wanted) {
                    root.update({
                        activeRoomId: wanted,
                        meetView: 'call'
                    });
                    return {
                        ok: true,
                        opened: {
                            type: 'room',
                            id: wanted
                        }
                    };
                }
                root.update({
                    activeRoomId: wanted,
                    meetView: 'list',
                    showJoinPreview: true,
                    joinPreviewDraft: {
                        roomId: wanted,
                        mic: true,
                        cam: true
                    }
                });
                return {
                    ok: true,
                    opened: {
                        type: 'room',
                        id: wanted
                    },
                    preview: true
                };
            }
        case 'record':
            {
                // A workspace RECORD — a row of an installed app's collection:
                // select_page_item { type: 'record', id, collection: '<app>.<collection>' },
                // the catalogue id the assistant reads ('crm.crm_deals'). A record has no
                // shell page: it opens on the module page that owns its collection, found
                // through the record-route registry the installed modules declare
                // (moduleRecordRoutes.js) and opened with the shell's module opener — the
                // path a record source chip takes (ChatSourceChip: entityRefHref, then
                // openAppPage with preferSlot; a plain router call is a hard navigation
                // to a blank page on a branded host).
                const named = $c104e66f813cfb63$var$str(collection).trim();
                // Every refusal NAMES the record (and the collection it was asked in),
                // through the element's polyglot, both as text, never as a pattern.
                const refuse = (key)=>({
                        ok: false,
                        error: (0, $7iFOV.shellSay)(this, key).replace('{id}', ()=>wanted).replace('{collection}', ()=>named)
                    });
                if (!wanted || !named) return refuse('workspace.pageItem.recordNoCollection');
                // The registry is keyed by the collection AS STORED, and the catalogue id
                // puts the app in front: 'crm.crm_deals' is stored as 'crm_deals'. A key
                // may carry its own dot ('vault.items'), so the name is tried whole
                // first, then without its app part.
                const dot = named.indexOf('.');
                let stored = '';
                let where = null;
                for (const key of dot > 0 ? [
                    named,
                    named.slice(dot + 1)
                ] : [
                    named
                ]){
                    where = (0, $15Bho.moduleRecordRoute)(root, key);
                    if (where) {
                        stored = key.toLowerCase();
                        break;
                    }
                }
                // No installed app opens this collection here. Nothing was looked up,
                // so the sentence says that — never that the record does not exist.
                if (!where) return refuse('workspace.pageItem.recordNoRoute');
                // A declared record route names an app's OWN collection, which lives on
                // the records plane — one `records.get` says whether this reader can
                // open the row. ONLY that answer may call the record missing: a 404, no
                // row, or a row of another collection. Any other failure (offline, a
                // server error) opens the page anyway, and the app's page says what it
                // finds; the shell claims nothing it did not see. The shared NULL client
                // (no backend on this host) answers null to everything, so it is never
                // asked (`isNullClient`, shared/functions/sdkClient.js).
                let missing = false;
                try {
                    const sdk = $c104e66f813cfb63$var$shellGetSDK();
                    if (sdk && sdk.isNullClient !== true) {
                        const ws = (0, $9ZTVI.activeWorkspaceId)(root);
                        const row = await sdk.execute('workspaceProject.records', 'get', {
                            id: wanted,
                            ...ws ? {
                                workspaceId: ws
                            } : {}
                        });
                        const inCollection = row && typeof row === 'object' ? $c104e66f813cfb63$var$str(row.collection).toLowerCase() : '';
                        missing = !row || !!inCollection && inCollection !== stored;
                    }
                } catch (err) {
                    missing = !!err && Number(err.status) === 404;
                }
                if (missing) return refuse('workspace.pageItem.recordNotFound');
                this.call('openAppPage', where.route + '?' + where.param + '=' + encodeURIComponent(wanted), {
                    preferSlot: true
                });
                return {
                    ok: true,
                    opened: {
                        type: 'record',
                        id: wanted,
                        collection: named
                    }
                };
            }
        default:
            return {
                ok: false,
                error: (0, $7iFOV.shellSay)(this, 'workspace.pageItem.unknownType').replace('{type}', ()=>$c104e66f813cfb63$var$str(type))
            };
    }
}
// THE CAPABILITY the 'record' case above answers for. The server offers
// select_page_item type 'record' only to a shell that declares
// `capabilities.openRecord: 1` on its chat request (aib's gate); an older
// server never sends the type, and an older shell never declares it. The flag
// rides THIS function, so a host whose registered selectPageItem is not this
// one (no record case) declares nothing — assistantClientCapabilities
// (assistantRecords.js) reads it off `context.functions.selectPageItem`.
$c104e66f813cfb63$export$376a6c1bb83858e3.opensRecords = 1;

});
parcelRegister("7ytvD", function(module, exports) {

$parcel$export(module.exports, "setWorkspaceModuleDev", () => $58029952ef70329d$export$809a4a250908d135);
$parcel$export(module.exports, "clearWorkspaceModuleDev", () => $58029952ef70329d$export$fba011885080ad5f);
$parcel$export(module.exports, "settleWorkspaceActivation", () => $58029952ef70329d$export$2ec12c96491253d1);
$parcel$export(module.exports, "updateWorkspaceActivation", () => $58029952ef70329d$export$5cda0d0e0ba2885a);
$parcel$export(module.exports, "workspaceActivationView", () => $58029952ef70329d$export$18ed75d0bc8fa89c);
$parcel$export(module.exports, "prefetchWorkspaceModule", () => $58029952ef70329d$export$1d479800cdecfb34);
$parcel$export(module.exports, "getModulePageDef", () => $58029952ef70329d$export$a5a7185d91a2c7c7);
$parcel$export(module.exports, "getAppsLoadOutcome", () => $58029952ef70329d$export$707aeefbb5f783b2);
$parcel$export(module.exports, "getModuleLoadOutcome", () => $58029952ef70329d$export$5ac4065fceab2866);
$parcel$export(module.exports, "loadWorkspaceProject", () => $58029952ef70329d$export$d6a922b3bbd88180);
$parcel$export(module.exports, "loadWorkspaceApps", () => $58029952ef70329d$export$54bc558f801f5f96);
$parcel$export(module.exports, "moduleViewAsKey", () => $58029952ef70329d$export$a9b228c74739c85c);
$parcel$export(module.exports, "moduleImmersiveActive", () => $58029952ef70329d$export$8a84674485ee3e88);
$parcel$export(module.exports, "moduleImmersiveLanding", () => $58029952ef70329d$export$a69f284518eb2ae9);
$parcel$export(module.exports, "moduleRailActive", () => $58029952ef70329d$export$fd6706fef94e4e7f);
$parcel$export(module.exports, "readModuleChromePref", () => $58029952ef70329d$export$f2d9b2ae4338c644);
$parcel$export(module.exports, "moduleViewAsActive", () => $58029952ef70329d$export$8b266bc4e73cce64);
$parcel$export(module.exports, "moduleRailEdge", () => $58029952ef70329d$export$9ea09d81f0bd322b);
$parcel$export(module.exports, "writeModuleChromePref", () => $58029952ef70329d$export$1238c27f026d6fac);
$parcel$export(module.exports, "readSlotFullscreenPref", () => $58029952ef70329d$export$69b4a908fa05a863);
$parcel$export(module.exports, "writeSlotFullscreenPref", () => $58029952ef70329d$export$dea073705d5e4ad1);
$parcel$export(module.exports, "slotFullscreenActive", () => $58029952ef70329d$export$a512cb55fb79fca8);
$parcel$export(module.exports, "applyStageVar", () => $58029952ef70329d$export$82c08a6f8280f40c);
$parcel$export(module.exports, "whenAppRouteReady", () => $58029952ef70329d$export$dfda81474d0ab60e);
// Workspace projects — the runtime LOADER that resolves a workspace's MODULE and
// applies it to the live context. A "workspace module" (type:'workspace') is a
// self-contained personalization bundle — design system, navbar, dashboard
// panels, apps section, seed records, AND its own components / pages / functions.
//
// On workspace activation loadWorkspaceProject():
//   1. resolves the module for the active workspace (server-driven, org-guarded),
//   2. LOADS its code — a PUBLISHED PROJECT fetched by reference (manifest
//      v2: the module lives in the CLIENT's own repo/project and arrives as
//      serialized data — zero client code in this repo; the legacy v1 bundled
//      chunk was retired with the WS6 GreenIG migration, 2026-07-30),
//   3. normalizes the payload to ONE manifest (_normalizeManifest),
//   4. INJECTS its components + functions into the live context (context.components
//      / context.functions) so bare-key resolution + el.call work ONLY here —
//      skipping (with a warn) any key the shell already owns,
//   5. registers its pages into root.workspaceProject.pages AND the live router
//      map (the home AppWindow / openAppPage / el.router consult these),
//   6. stashes the manifest surface (widgets / aiFunctions / chatStarters) on
//      root.workspaceProject and seeds its declared state keys.
// On switch-away it TEARS DOWN exactly the injected keys + state, so a plain
// workspace sees none of it — every workspace's personalization is isolated
// from the shared shell. Any load failure = plain workspace, never a broken shell.
//
// WHICH module a workspace runs — and all of its config/panels/data — is
// SERVER-driven: the Mongo workspace record's `settings.workspaceModule` holds a
// project reference ({type:'project', owner, key, channel, version, tier,
// capabilities}); the legacy `settings.projectModule` string selects a bundled
// chunk. No workspace id is hardcoded in the frontend.
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");
var $7gmTd = parcelRequire("7gmTd");

var $hWNk6 = parcelRequire("hWNk6");

var $fcczA = parcelRequire("fcczA");

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $g7CNh = parcelRequire("g7CNh");

var $6lGuT = parcelRequire("6lGuT");

var $aGIjc = parcelRequire("aGIjc");

var $f18a7 = parcelRequire("f18a7");

var $i8Ov5 = parcelRequire("i8Ov5");

var $atmQm = parcelRequire("atmQm");

var $984mC = parcelRequire("984mC");

var $25fky = parcelRequire("25fky");

var $8Oeas = parcelRequire("8Oeas");

var $dk5k7 = parcelRequire("dk5k7");

var $jqUS6 = parcelRequire("jqUS6");

var $aKkqm = parcelRequire("aKkqm");

var $duW2E = parcelRequire("duW2E");

var $5gsjA = parcelRequire("5gsjA");

var $asht4 = parcelRequire("asht4");

var $7muxD = parcelRequire("7muxD");

var $j9v8x = parcelRequire("j9v8x");

var $jFE3F = parcelRequire("jFE3F");
const $58029952ef70329d$var$fetchProjectFromSDK = (...args)=>(0, $1X0Je.default).functions.fetchProjectFromSDK(...args);
const $58029952ef70329d$var$resolveEnvPublishConfig = (...args)=>(0, $1X0Je.default).functions.resolveEnvPublishConfig(...args);
const $58029952ef70329d$var$recordsEntryKey = (...args)=>(0, $1X0Je.default).functions.recordsEntryKey(...args);
const $58029952ef70329d$var$shellWorkspaceSettings = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
const $58029952ef70329d$var$shellIsCommHost = ()=>(0, $1X0Je.default).functions.isCommHost();
const $58029952ef70329d$var$_lc = (v)=>v == null ? '' : String(v).toLowerCase();
// Drop null/undefined-valued keys before a source merges INTO a fallback
// object, so an explicitly-cleared settings key falls through to the next
// precedence layer instead of clobbering it with `null` (the four "reset"
// call sites — see the config: comment below — persist a reset as
// `settings.<key>:null`; the merge-safe PATCH writer has no real $unset yet,
// see tickets/server.md). Mirrors workspaceConfigs.js's _normalizeSavedRow,
// which already does the same per-key `!= null` filter for the no-module
// Mongo-settings path — this brings the module-config path in line with it.
// Keeps real falsy values (`false`/`0`/`''`/`[]`) since those ARE deliberate
// overrides; only null/undefined mean "absent." Pure — never mutates its
// input.
const $58029952ef70329d$var$_stripNullish = (obj)=>{
    const out = {};
    for (const k of Object.keys(obj || {}))if (obj[k] != null) out[k] = obj[k];
    return out;
};
// Settings-bag strip for the config merge below. On top of _stripNullish,
// navbar is the one key where an EMPTY ARRAY is ALSO "cleared", not a
// deliberate override — `settings.navbar: []` (a legacy admin-console
// Save-after-Reset write; mcSavePersonalization now normalizes it to null)
// would otherwise win the spread and render a header with ZERO tabs instead
// of falling through to configDefaults.navbar / DEFAULT_NAVBAR. Other keys
// keep [] (an empty home_default_panels is a deliberate hide-all). Same
// guard as workspaceConfigs.js's _normalizeSavedRow and HeaderTabs' readers.
const $58029952ef70329d$var$_stripClearedSettings = (obj)=>{
    const out = $58029952ef70329d$var$_stripNullish(obj);
    if (Array.isArray(out.navbar) && !out.navbar.length) delete out.navbar;
    return out;
};
// Stale-safety org-guard. root.workspace can lag root.org across an ORG switch
// (cross-org stale-workspace leak) — only adopt a module when the workspace's
// parent org matches the active org (root.org updates reliably on switch).
const $58029952ef70329d$var$_belongsToActiveOrg = (root)=>{
    const org = root.org || {};
    const ws = root.workspace || {};
    const orgId = $58029952ef70329d$var$_lc(org.id || org._id);
    const wsOrg = $58029952ef70329d$var$_lc(ws.organization || ws.organizationId || ws.org);
    if (orgId && wsOrg && orgId !== wsOrg) return false;
    return true;
};
// Live context registry (context.components / context.functions) reachable from
// the root STATE. The state itself carries no .context — but state.__element is
// the root element, and element.context is the singleton registry DOMQL resolves
// bare keys + el.call against (verified: injecting into it makes el.call resolve).
const $58029952ef70329d$var$_ctx = (root)=>{
    const elx = root && (root.__element || root.getRoot && root.getRoot());
    return elx && elx.context || root && root.context || null;
};
// The ROUTED root element — the one carrying `.routes`, which smbls' router
// matches `pathname` against LIVE on every navigation (router/index.js:
// matchRoute(pathname, element.routes, …)). preparePages() assigns the merged
// page map to this element's `.routes` at boot. Injecting module routes here
// (and tearing them down on switch-away) lets a module page navigate as a real
// full shell page (el.router('/policies')) — resolving ONLY while this module
// is active, exactly like its components/functions. `el.router(path, el.getRoot())`
// from a nav item reads this same element, so target getRoot().routes.
const $58029952ef70329d$var$_routedEl = (root)=>{
    if (!root) return null;
    const elx = root.__element || root.getRoot && root.getRoot();
    if (!elx) return null;
    const top = elx.getRoot && elx.getRoot() || elx;
    if (top && top.routes) return top;
    return elx.routes ? elx : null;
};
// ── Published-module pipeline ─────────────────────────────────────────────────
// SDK-backed fetch + channel resolution, held in a swappable holder so the
// colocated node --test suite can inject mocks (no network). Production code
// never reassigns it.
const $58029952ef70329d$var$_pipeline = {
    fetchProject: $58029952ef70329d$var$fetchProjectFromSDK,
    resolveEnv: $58029952ef70329d$var$resolveEnvPublishConfig
};
const $58029952ef70329d$export$dd6ad3d7b31d41b1 = (limit)=>{
    let active = 0;
    const queued = [];
    const pump = ()=>{
        while(active < limit && queued.length){
            active++;
            queued.shift()();
        }
    };
    return (fn)=>new Promise((resolve, reject)=>{
            queued.push(()=>{
                Promise.resolve().then(fn).then(resolve, reject).finally(()=>{
                    active--;
                    pump();
                });
            });
            pump();
        });
};
// Loaded modules memoized per `${owner}/${key}@${branch}#${version}` — a
// workspace re-activation (or an A→B→A switch) within one session never
// re-fetches; a different branch of the same project is a different entry.
const $58029952ef70329d$var$_moduleMemo = new Map();
// Content refusals by `owner/key` — audit, tier, manifest, missing — for the
// apps pass to tell a settled 'blocked' from a transient 'partial'. See
// _loadPublishedModule's `_refuse`.
const $58029952ef70329d$var$_refusals = new Map();
// In-flight loads keyed the same way — the dual-trigger's two concurrent
// onWorkspaceChange runs share ONE fetch+process instead of both hitting the
// backend (the memo above is only SET after the await, leaving a dedup gap).
const $58029952ef70329d$var$_moduleInflight = new Map();
// CHANNEL HANDOFF (perf/shell-boot, 2026-10-09). A channel resolves through
// two serial reads (getProjectByKey → listEnvironments). Measured live on
// staging /w/vault/default with a cold env-config cache: the takeover pass
// resolved vault/vaultos-app at 9.6 s and the apps pass resolved the SAME
// channel again at 18.3 s (the workspace also lists the module in
// settings.workspaceApps) — too far apart for the SDK's in-flight GET dedupe.
// A resolution is now handed to the NEXT consumer of the same key, once:
//   'prefetch' (prefetchWorkspaceModule, at /core/boot) → the takeover pass
//   'takeover' (the takeover pass)                     → the apps pass
// The takeover never accepts a 'takeover' entry, so an explicit reload (module
// console, converge retry) still re-resolves. One read per entry, 30 s max age.
// The key carries the workspace id, so no handoff crosses workspaces.
const $58029952ef70329d$var$_channelHandoff = new Map();
const $58029952ef70329d$var$_CHANNEL_HANDOFF_MAX_AGE_MS = 30000;
const $58029952ef70329d$var$_channelHandoffKey = (owner, key, channel, wsId)=>String(owner) + '/' + String(key) + '@' + String(channel) + '#' + String(wsId || '');
const $58029952ef70329d$var$_channelHandoffFresh = (k, accept)=>{
    const h = $58029952ef70329d$var$_channelHandoff.get(k);
    return !!(h && accept.includes(h.from) && Date.now() - h.at < $58029952ef70329d$var$_CHANNEL_HANDOFF_MAX_AGE_MS);
};
const $58029952ef70329d$var$_takeChannelHandoff = (k, accept)=>{
    if (!accept.length || !$58029952ef70329d$var$_channelHandoff.has(k)) return null;
    const fresh = $58029952ef70329d$var$_channelHandoffFresh(k, accept);
    const h = $58029952ef70329d$var$_channelHandoff.get(k);
    if (accept.includes(h.from)) $58029952ef70329d$var$_channelHandoff.delete(k);
    return fresh ? h.p : null;
};
// Which handoffs a caller may take: the takeover only takes the boot
// prefetch's; the prefetch takes none; the apps pass (no role) takes either.
const $58029952ef70329d$var$_channelAccept = (role)=>role === 'prefetch' ? [] : role === 'takeover' ? [
        'prefetch'
    ] : [
        'takeover',
        'prefetch'
    ];
// One boot prefetch per workspace per page (prefetchWorkspaceModule).
let $58029952ef70329d$var$_bootPrefetchWsId = null;
// Capability-bridge SDK seam (test-only): `buildModuleDataBridge` defaults to
// the REAL `getSDK()` (network-backed), which the loader never overrides in
// production. A unit test that exercises a GRANTED capability (as opposed to
// the deny-by-default path, which short-circuits before ever calling
// getSdkFn()) reaches that real SDK — CI-load-dependent, not a hang locally
// where the SDK's own client-side arg validation rejects fast (see
// tickets/workspace.md "CI Test red on main: capabilities.integrations tests
// hang at 5000ms (local-green)"). `__setModuleSdkFnForTests` lets a test
// inject the same `getSdkFn` seam `buildModuleDataBridge` already exposes,
// with zero source-behavior change when unset (production never calls it).
let $58029952ef70329d$var$_sdkFnOverrideForTests = null;
const $58029952ef70329d$export$f7575ba40865dbf0 = (fn)=>{
    $58029952ef70329d$var$_sdkFnOverrideForTests = fn;
};
const $58029952ef70329d$export$498d930e29912467 = (overrides)=>Object.assign($58029952ef70329d$var$_pipeline, overrides);
const $58029952ef70329d$export$e2feca58d85e6ede = ()=>{
    if (globalThis.__wsEnvWarm) globalThis.__wsEnvWarm.clear();
    $58029952ef70329d$var$_channelHandoff.clear();
    $58029952ef70329d$var$_bootPrefetchWsId = null;
    $58029952ef70329d$var$_refusals.clear();
    $58029952ef70329d$var$_moduleMemo.clear();
    $58029952ef70329d$var$_libraryFnTexts.clear();
    $58029952ef70329d$var$_moduleDsCtxCache.clear();
    $58029952ef70329d$var$_moduleScopeCache.clear();
    $58029952ef70329d$var$_moduleStateCache.clear();
    $58029952ef70329d$var$_moduleInflight.clear();
    $58029952ef70329d$var$_activeProjectId = null;
    $58029952ef70329d$var$_moduleLoadedWorkspaceId = null;
    $58029952ef70329d$var$_injectedComponentKeys = [];
    $58029952ef70329d$var$_injectedFunctionKeys = [];
    $58029952ef70329d$var$_injectedPageKeys = [];
    $58029952ef70329d$var$_injectedBags = null;
    $58029952ef70329d$var$_injectedTranslations = null;
    $58029952ef70329d$var$_injectedStateKeys = [];
    $58029952ef70329d$var$_injectedStateSeeds = {};
    $58029952ef70329d$var$_takeoverActions = null;
    $58029952ef70329d$var$_takeoverStash = null;
    $58029952ef70329d$var$_lastTakeoverFp = null;
    $58029952ef70329d$var$_lastAppsFp = null;
    $58029952ef70329d$var$_injectedByApp.clear();
    $58029952ef70329d$var$_lastLoadOutcome = 'idle';
    $58029952ef70329d$var$_lastAppsOutcome = 'idle';
    // Dev-override warn-once latches — module-level, so without this a test that
    // exercises the unpinned path would suppress the warning for every later one.
    $58029952ef70329d$var$_warnedUnpinnedOverride = false;
    $58029952ef70329d$var$_announcedOverrideFor = '';
    // Invalidate any in-flight converge loop (it checks the gen after every
    // await) and re-open the singleton slot for the next test case.
    $58029952ef70329d$var$_convergeGen++;
    $58029952ef70329d$var$_convergeRunning = null;
    $58029952ef70329d$var$_convergeOwner = null;
    // Single-flight slots (F4) — a settled-in-a-previous-test promise must
    // never be handed to the next test's same-key call.
    $58029952ef70329d$var$_projectFlightKey = null;
    $58029952ef70329d$var$_projectFlight = null;
    $58029952ef70329d$var$_projectFlightRoot = null;
    $58029952ef70329d$var$_appsFlightKey = null;
    $58029952ef70329d$var$_appsFlight = null;
    $58029952ef70329d$var$_appsFlightRoot = null;
    $58029952ef70329d$var$_appsSettled = null;
    $58029952ef70329d$var$_projectSettled = null;
    for (const waiter of $58029952ef70329d$var$_routeWaiters)waiter.resolve(true);
    $58029952ef70329d$var$_routeWaiters.clear();
    $58029952ef70329d$var$_appActivations.clear();
    $58029952ef70329d$var$_activationQueueSeq++;
    $58029952ef70329d$var$_navLangLedgers.clear();
    // A previous test's injected fake SDK must never leak into the next case.
    $58029952ef70329d$var$_sdkFnOverrideForTests = null;
    // Var-ownership latches — module-level; a test that left the module layer
    // owning `--stage-bg`/`--home-card-bg` would make a later test's release
    // branch remove a value that test never wrote.
    $58029952ef70329d$var$_moduleStageVarOwned = false;
    $58029952ef70329d$var$_moduleCardVarOwned = false;
    (0, $j9v8x.__resetModuleScopedKeysForTests)();
};
// WS-MODULE-PAYLOAD-CACHE-1 (BF-SIGNIN-LAYOUT-LATENCY-1) — persistent
// single-slot payload cache. The 1.1MB module payload fetch measured
// 2.6-3.0s of EVERY boot's reveal window (sidebar at 12.7s cold / 7.2s warm,
// 2026-08-18); a warm slot mounts the module with ZERO payload wait and
// revalidates through the SAME fetch in the background (write-through lives
// in shared fetchProjectFromSDK — the pre-revive seam). ONE fixed slot keeps
// the localStorage quota bounded to a single payload; multi-workspace users
// evict each other's slot — correct, just fewer hits. The payload
// self-describes its version; a superseded slot logs and the fresh slot
// serves on the NEXT load (in-session hot-swap is deliberately NOT done —
// the reveal-once design exists to avoid mid-session repaints). The cached
// row carries moduleAudit, so the publish-time refusal gate applies to
// cached payloads identically. Module CODE, not user data — no sign-out
// clearing; a cross-user hit revalidates immediately.
//
// Review D4 (perf/shell-boot, 2026-10-10): the slot is keyed by the WORKSPACE
// RECORD id (`workspaceModulePayloadCache_v2:<wsId>`), and at most two
// workspaces keep a slot (LRU through a tiny index row, so no 1 MB row is
// parsed to decide). A boot prefetch that guessed the wrong workspace now
// writes that workspace's own slot instead of overwriting the one the next
// boot needs. The row still carries its own version; the background
// revalidation compares it. The legacy single slot (v1) is dropped on the
// first write.
const $58029952ef70329d$var$PAYLOAD_CACHE_PREFIX = 'workspaceModulePayloadCache_v2:';
const $58029952ef70329d$var$PAYLOAD_CACHE_INDEX = 'workspaceModulePayloadCache_v2__index';
const $58029952ef70329d$var$PAYLOAD_CACHE_LEGACY = 'workspaceModulePayloadCache_v1';
const $58029952ef70329d$var$PAYLOAD_CACHE_MAX_SLOTS = 2;
const $58029952ef70329d$export$424c45021ed2f6fe = (wsId)=>$58029952ef70329d$var$PAYLOAD_CACHE_PREFIX + String(wsId || '');
const $58029952ef70329d$export$171eda5ee8acb001 = (owner, key, branch, wsId)=>{
    try {
        // No workspace id → no slot (review Delta 2 N7b: never a shared empty key).
        if (!wsId || typeof localStorage === 'undefined') return null;
        const raw = localStorage.getItem($58029952ef70329d$export$424c45021ed2f6fe(wsId));
        if (!raw) return null;
        const row = JSON.parse(raw);
        if (!row || row.v !== 1 || !row.data) return null;
        // The row names the workspace it was cached for (shared fetchProjectFromSDK
        // stores options.workspaceId) — the key alone is not the guard (N7b).
        if (String(row.wsId || '') !== String(wsId)) return null;
        if (row.owner !== owner || row.key !== key) return null;
        if ((row.branch || 'main') !== (branch || 'main')) return null;
        return row;
    } catch (_) {
        return null;
    }
};
const $58029952ef70329d$export$714146a0ca5c20d7 = (wsId)=>{
    try {
        if (!wsId || typeof localStorage === 'undefined') return;
        const mine = $58029952ef70329d$export$424c45021ed2f6fe(wsId);
        let order = [];
        try {
            const parsed = JSON.parse(localStorage.getItem($58029952ef70329d$var$PAYLOAD_CACHE_INDEX) || '[]');
            if (Array.isArray(parsed)) order = parsed.filter((k)=>typeof k === 'string' && k !== mine);
        } catch (_) {
            order = [];
        }
        order.unshift(mine);
        for (const k of order.slice($58029952ef70329d$var$PAYLOAD_CACHE_MAX_SLOTS))localStorage.removeItem(k);
        localStorage.setItem($58029952ef70329d$var$PAYLOAD_CACHE_INDEX, JSON.stringify(order.slice(0, $58029952ef70329d$var$PAYLOAD_CACHE_MAX_SLOTS)));
        localStorage.removeItem($58029952ef70329d$var$PAYLOAD_CACHE_LEGACY);
        const kept = new Set(order.slice(0, $58029952ef70329d$var$PAYLOAD_CACHE_MAX_SLOTS));
        const n = typeof localStorage.length === 'number' ? localStorage.length : 0;
        const orphans = [];
        for(let i = 0; i < n; i++){
            const k = localStorage.key(i);
            if (typeof k === 'string' && k.startsWith($58029952ef70329d$var$PAYLOAD_CACHE_PREFIX) && !kept.has(k)) orphans.push(k);
        }
        for (const k of orphans)localStorage.removeItem(k);
    } catch (_) {
    /* the cache is best-effort */ }
};
// Dev-only module override: `localStorage.workspaceModuleDev` holds a JSON
// reference ({owner, key, channel?, version?}) that REPLACES the server ref's
// target — the local iteration loop for authoring a module against a dev
// channel. Allowed on a development build OR any *.localhost host (the dev
// hostnames) — a RUNTIME check, so it survives a production-mode bundle where
// `process.env.NODE_ENV` is inlined and the NODE_ENV branch is dead-code
// stripped. Never fires on a real deployment (prod is *.symbols.app), so it
// can't leak into production.
const $58029952ef70329d$var$_devOverrideAllowed = ()=>{
    var _;
    return true;
};
// The override MUST name the workspace it was authored against. Without this
// pin the key is GLOBAL: it merges over whatever workspace you happen to be in
// (see _loadPublishedModule's `{...ref, ...dev}`) AND forces a module load into
// workspaces the server says have none (_resolveModuleLoader). That is exactly
// how the Bellforge workspace rendered the AI House module's navbar and pages
// (2026-08-05 per Nika "why I'm in bellforge account and its showing aihouse
// navbar") — a dev pin left over from authoring a different org's module,
// silently shadowing real tenant content with no visible signal anywhere.
//
// So the pin is REQUIRED and this fails CLOSED: an unpinned (legacy) override
// is ignored outright rather than applied globally, and a pinned override is
// applied ONLY to its own workspace. Use setWorkspaceModuleDev() below, which
// stamps the active workspace for you.
const $58029952ef70329d$var$DEV_OVERRIDE_KEY = 'workspaceModuleDev';
let $58029952ef70329d$var$_warnedUnpinnedOverride = false;
let $58029952ef70329d$var$_announcedOverrideFor = '';
// Same derivation loadWorkspaceProject uses for the pass's `wsId`
// (`root.workspace.id || ._id`), so a pin written here matches what the loader
// compares against.
const $58029952ef70329d$var$_activeWsIdFromRoot = (root)=>{
    const ws = root && root.workspace || {};
    return ws.id || ws._id || '';
};
const $58029952ef70329d$var$_readDevOverrideRaw = ()=>{
    if (!$58029952ef70329d$var$_devOverrideAllowed()) return null;
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem($58029952ef70329d$var$DEV_OVERRIDE_KEY);
        if (!raw) return null;
        const ref = JSON.parse(raw);
        if (ref && typeof ref === 'object' && ref.owner && ref.key) return ref;
    } catch (_) {
    /* unparsable override — ignore */ }
    return null;
};
// `wsId` is the workspace this pass is resolving a module FOR. Callers that
// genuinely have no workspace in hand pass nothing — and get null, because an
// override that can't be matched against a workspace must never apply.
const $58029952ef70329d$var$_devModuleOverride = (wsId)=>{
    const ref = $58029952ef70329d$var$_readDevOverrideRaw();
    if (!ref) return null;
    const pinned = String(ref.workspaceId || '');
    if (!pinned) {
        if (!$58029952ef70329d$var$_warnedUnpinnedOverride) {
            $58029952ef70329d$var$_warnedUnpinnedOverride = true;
            console.warn(`[workspaceModule] IGNORING an unpinned ${$58029952ef70329d$var$DEV_OVERRIDE_KEY} override ` + `(${ref.owner}/${ref.key}). An override with no workspaceId applies to EVERY ` + 'workspace and silently replaces real tenant content. Re-set it pinned:\n' + "  el.call('setWorkspaceModuleDev', { owner: '<owner>', key: '<key>', channel: 'development' })\n" + `  \u{2014} or clear it:  localStorage.removeItem('${$58029952ef70329d$var$DEV_OVERRIDE_KEY}')`);
        }
        return null;
    }
    if (!wsId || String(wsId) !== pinned) return null;
    // Applied — say so, loudly and once per workspace. A dev override that
    // shadows the server's module with no visible signal is the whole hazard.
    if ($58029952ef70329d$var$_announcedOverrideFor !== pinned) {
        $58029952ef70329d$var$_announcedOverrideFor = pinned;
        console.warn(`[workspaceModule] DEV OVERRIDE ACTIVE \u{2014} loading ${ref.owner}/${ref.key}` + `${ref.channel ? `@${ref.channel}` : ''} instead of this workspace's configured module. ` + `Pinned to workspace ${pinned}. Clear with el.call('clearWorkspaceModuleDev').`);
    }
    return ref;
};
function $58029952ef70329d$export$809a4a250908d135(ref) {
    const el = this;
    if (!$58029952ef70329d$var$_devOverrideAllowed()) {
        console.warn('[workspaceModule] dev override is only available on a dev build / *.localhost');
        return null;
    }
    if (!ref || !ref.owner || !ref.key) {
        console.warn('[workspaceModule] setWorkspaceModuleDev needs at least { owner, key }');
        return null;
    }
    const root = el && el.state && el.state.root;
    const wsId = root && $58029952ef70329d$var$_activeWsIdFromRoot(root);
    if (!wsId) {
        console.warn("[workspaceModule] no active workspace to pin the override to \u2014 aborting");
        return null;
    }
    const pinned = {
        ...ref,
        workspaceId: String(wsId)
    };
    try {
        localStorage.setItem($58029952ef70329d$var$DEV_OVERRIDE_KEY, JSON.stringify(pinned));
    } catch (e) {
        console.warn('[workspaceModule] could not persist the dev override', e && e.message);
        return null;
    }
    $58029952ef70329d$var$_warnedUnpinnedOverride = false;
    $58029952ef70329d$var$_announcedOverrideFor = '';
    console.warn(`[workspaceModule] dev override pinned to workspace ${wsId} -> ${pinned.owner}/${pinned.key}. Reload to apply.`);
    return pinned;
}
function $58029952ef70329d$export$fba011885080ad5f() {
    try {
        localStorage.removeItem($58029952ef70329d$var$DEV_OVERRIDE_KEY);
    } catch (_) {
    /* storage unavailable — nothing to clear */ }
    $58029952ef70329d$var$_warnedUnpinnedOverride = false;
    $58029952ef70329d$var$_announcedOverrideFor = '';
    console.warn('[workspaceModule] dev override cleared. Reload to return to the server module.');
    return true;
}
// ── Manifest normalization ────────────────────────────────────────────────────
// Map a manifest pageGuard to the permission key shouldRedirectNoPerm gates on.
const $58029952ef70329d$var$_guardPermFor = (guard)=>{
    if (guard && typeof guard.permission === 'string') return guard.permission;
    if (guard && guard.workspaceRole === 'superadmin') return 'admin.danger.access';
    return 'admin.pages.read';
};
const $58029952ef70329d$export$7fd24a98f51ec4f1 = (def, guard)=>{
    const perm = $58029952ef70329d$var$_guardPermFor(guard);
    const check = (el, s)=>{
        try {
            if (!el.call('shouldRedirectNoPerm', s, perm)) return;
            el.call('routeGateBounce', '/');
        } catch (_) {
        /* guard helpers unavailable (non-workspace shell) — server still enforces */ }
    };
    const page = {
        ...def,
        onInit: (el, s, ...rest)=>{
            check(el, s);
            if (typeof def.onInit === 'function') return def.onInit(el, s, ...rest);
        },
        onUpdate: (el, s, ...rest)=>{
            check(el, s);
            if (typeof def.onUpdate === 'function') return def.onUpdate(el, s, ...rest);
        }
    };
    if (def.subscribeTo != null) return page;
    page.subscribeTo = (el)=>el.call('routeGateKeys');
    page.onBeforeUpdate = (el, s, ctx, opts, ...rest)=>{
        if (opts && opts.updateBySubscription) {
            check(el, s);
            return false;
        }
        if (typeof def.onBeforeUpdate !== 'function') return undefined;
        return def.onBeforeUpdate(el, s, ctx, opts, ...rest);
    };
    return page;
};
const $58029952ef70329d$var$_WIDGET_ID_RE = /^[a-z0-9-]+$/;
// ── A module's own shared libraries ─────────────────────────────────────────
//
// A published module project can link shared libraries (`useLibraries` on the
// project record). The server RESOLVES those links and ships the library
// CONTENT on the payload as `sharedLibraries: [{ id, key, name, projectType,
// components, functions, pages, designSystem, … }]` (ProjectDataService
// `pickSharedLibrarySlices`). Until WS-MODULE-LOADER-DROPS-SHARED-LIBRARIES-1
// this loader read `mod.components` / `mod.functions` ONLY and dropped that
// array on the floor — so a module that adopted a library rendered nothing
// (bellforge → system/pipeline: `ctx.components.PipelineBoard` undefined, zero
// of the 20 `pipeline*` functions merged, console clean because an unresolved
// bare key renders silently).
//
// The merge REUSES the platform's one resolver, `mergeSharedLibraries` from
// `@symbo.ls/utils` — the same function `smbls/packages/smbls/src/prepare.js`
// `prepareSharedLibs` runs for every standalone app boot. That buys the exact
// platform precedence for free: it is non-destructive (`if (!(k in context[key]))`),
// so framework built-ins → shared libraries → the module's OWN keys, the
// module always winning, never shadowed (Rule 63). It also honors the
// library-side `sharedLibIgnore` / `sharePages:false` privacy declarations.
//
// Only the sections this loader actually consumes are merged (components /
// functions / pages / designSystem / globalScope). The payload entries also
// carry METADATA (`id`, `key`, `name`, `version`, `projectType`) which
// `mergeOneLibrary` would copy wholesale into the merge target as new top-level
// keys — `_libContentSlice` strips them so a library can never inject an
// `id`/`version` into the module manifest it is merged into.
//
// `globalScope` is in the list for the same reason the other four are: the
// server ships a resolved library's globalScope bag on the payload
// (ProjectDataService `pickSharedLibrarySlices`) precisely so the client can
// fold it under the consumer, and a standalone boot of the same app does fold
// it (prepareSharedLibs merges every section key generically). Leaving it out
// made a library component's `__scope.X` read resolve standalone and come back
// undefined in-shell — the exact divergence class of
// WS-MODULE-CTX-DROPS-APP-GLOBALSCOPE-1.
const $58029952ef70329d$var$_LIB_MERGE_SECTIONS = [
    'components',
    'functions',
    'pages',
    'designSystem',
    'globalScope'
];
// Deep copy of plain data. `deepDefaults` (the designSystem branch of the
// merge) recurses INTO the target, so merging straight onto the fetched
// payload's own designSystem objects would mutate the memoized payload (and
// the sessionStorage warm slot it was revived from). Tokens are plain data —
// non-plain values (functions, class instances) pass through by reference.
const $58029952ef70329d$var$_clonePlain = (v)=>{
    if (Array.isArray(v)) return v.map($58029952ef70329d$var$_clonePlain);
    if (v && typeof v === 'object' && (v.constructor === Object || !v.constructor)) {
        const out = {};
        for(const k in v)if (Object.prototype.hasOwnProperty.call(v, k)) out[k] = $58029952ef70329d$var$_clonePlain(v[k]);
        return out;
    }
    return v;
};
// One payload library entry → the content-only slice that is safe to merge.
// Returns null when the entry carries nothing this loader consumes.
const $58029952ef70329d$var$_libContentSlice = (lib)=>{
    if (!lib || typeof lib !== 'object') return null;
    const slice = {};
    for (const section of $58029952ef70329d$var$_LIB_MERGE_SECTIONS)if (lib[section] && typeof lib[section] === 'object') slice[section] = lib[section];
    if (!Object.keys(slice).length) return null;
    // Merge DIRECTIVES, not content — carried through so the library's own
    // privacy declaration is honored by mergeOneLibrary.
    if (lib.sharedLibIgnore !== undefined) slice.sharedLibIgnore = lib.sharedLibIgnore;
    if (lib.sharePages !== undefined) slice.sharePages = lib.sharePages;
    return slice;
};
const $58029952ef70329d$export$cd3b44b2d44aeb29 = (mod)=>{
    const own = {
        components: mod && mod.components || {},
        functions: mod && mod.functions || {},
        pages: mod && mod.pages || {},
        globalScope: mod && mod.globalScope && typeof mod.globalScope === 'object' ? mod.globalScope : {},
        designSystem: mod && mod.designSystem && typeof mod.designSystem === 'object' ? mod.designSystem : null
    };
    const raw = mod && Array.isArray(mod.sharedLibraries) ? mod.sharedLibraries : [];
    if (!raw.length) return own;
    const entries = [];
    for (const entry of raw){
        // A wrapped `{ library, ignoreList }` (utils `sharedLibrary()`) may reach
        // the payload from a project that declared consumer-side ignores.
        let library = entry;
        let ignoreList = null;
        if ((0, $7gmTd.isWrappedLibrary)(entry)) {
            ignoreList = entry.ignoreList;
            library = entry.library;
        }
        const slice = $58029952ef70329d$var$_libContentSlice(library);
        if (!slice) continue;
        entries.push(ignoreList ? {
            library: slice,
            ignoreList: ignoreList
        } : slice);
    }
    if (!entries.length) return own;
    // Descriptor copies: lazy component entries stay lazy (boot fix step 4).
    const merged = {
        components: $58029952ef70329d$var$_copyEntries(own.components),
        functions: {
            ...own.functions
        },
        pages: $58029952ef70329d$var$_copyEntries(own.pages),
        globalScope: {
            ...own.globalScope
        },
        designSystem: own.designSystem ? $58029952ef70329d$var$_clonePlain(own.designSystem) : {}
    };
    (0, $7gmTd.mergeSharedLibraries)(merged, entries);
    if (!Object.keys(merged.designSystem).length) merged.designSystem = null;
    return merged;
};
const $58029952ef70329d$export$37bb30be4c4e3ce = (list)=>{
    if (!Array.isArray(list)) return [];
    const verdict = new Map();
    for (const f of list){
        const name = typeof f === 'string' ? f.trim() : f && typeof f.name === 'string' ? f.name.trim() : '';
        if (!name) continue;
        const ro = !!(f && typeof f === 'object' && f.readOnly === true);
        verdict.set(name, verdict.has(name) ? verdict.get(name) && ro : ro);
    }
    return [
        ...verdict
    ].filter(([, ro])=>ro).map(([name])=>name);
};
const $58029952ef70329d$export$3871725e3f98f87a = (mod, ref)=>{
    if (!mod || typeof mod !== 'object') return null;
    const cfg = mod.config && typeof mod.config === 'object' ? mod.config : {};
    const isV2 = mod.manifest === 2 || cfg.manifest === 2;
    if (!isV2) {
        console.warn("[workspaceModule] payload declares no v2 module manifest \u2014 refusing to load:", ref ? `${ref.owner}/${ref.key}` : mod.id || '(unknown)');
        return null;
    }
    const manifest = cfg.manifest === 2 ? cfg : mod;
    const rawId = manifest.id || mod.id;
    // The Symbols project's OWN top-level `id` (a Mongo ObjectId) shadows the
    // module's declared `id` when the manifest extras are spread onto project
    // data at publish. An ObjectId-shaped value therefore means "no module id
    // survived serialization" — fall back to the already-authenticated ref
    // (server settings / dev override) rather than rejecting. A real spoof would
    // declare a string `owner/key`, which is NOT ObjectId-shaped and is still
    // caught below. (TODO: namespace the manifest so `id` can't collide.)
    const id = /^[0-9a-f]{24}$/i.test(String(rawId)) && ref ? `${ref.owner}/${ref.key}` : rawId;
    if (ref) {
        const expected = `${ref.owner}/${ref.key}`;
        if (id !== expected) {
            console.warn("[workspaceModule] manifest id mismatch \u2014 refusing to load:", id, '!==', expected);
            return null;
        }
    }
    // The module's own sections WITH its linked shared libraries folded under
    // them (module keys always win — see _mergeModuleLibraries). Everything
    // downstream (widget body validation, the page loop, both injection paths in
    // loadWorkspaceProject / loadWorkspaceApps) reads these, so a library key is
    // indistinguishable from a module key from here on — exactly how a
    // standalone app boot sees it after prepareSharedLibs.
    const withLibs = $58029952ef70329d$export$cd3b44b2d44aeb29(mod);
    const components = withLibs.components;
    const functions = withLibs.functions;
    // WS-MODULE-CTX-DROPS-APP-GLOBALSCOPE-1 — the module's own globalScope bag
    // (frank rewrites every `__scope.<key>` read to a `<key>` read on
    // `el.context.globalScope`). Keep the dotted form out of this comment: frank
    // reads `globalScope` + dot + a name in a lifted helper's text as a member
    // read even inside a comment, and the phantom `X` it lifted from here broke
    // the shell emission (frank serializationScanner `_scanGlobalScopeMemberAccess`).
    // Passed through the platform's own resolver, exactly as `createDomql` does
    // for a standalone boot: a helper string that survived the payload-wide
    // `deepDestringifyFunctions` pass gets eval'd in ONE closure where every
    // sibling constant and helper is declared, and Set/Map tagged forms rehydrate.
    // With no strings left in the bag it is a copy and evals nothing.
    const globalScope = (0, $2C0hZ.destringifyGlobalScope)(withLibs.globalScope || {});
    const pages = {};
    for (const [path, def] of Object.entries(withLibs.pages || {})){
        if (!path.startsWith('/')) {
            console.warn('[workspaceModule] page key must start with "/" \u2014 skipped:', path);
            continue;
        }
        pages[path] = def && def.pageGuard ? $58029952ef70329d$export$7fd24a98f51ec4f1(def, def.pageGuard) : def;
    }
    const widgets = [];
    for (const w of Array.isArray(manifest.widgets) ? manifest.widgets : []){
        if (!w || typeof w !== 'object') continue;
        if (!$58029952ef70329d$var$_WIDGET_ID_RE.test(String(w.id || ''))) {
            console.warn("[workspaceModule] widget id must match /^[a-z0-9-]+$/ \u2014 skipped:", w.id);
            continue;
        }
        // A key check, not a read: reading would revive a lazy entry at boot.
        if (typeof w.body === 'string' && !Object.prototype.hasOwnProperty.call(components, w.body)) {
            console.warn("[workspaceModule] widget body component not found \u2014 skipped:", w.id, w.body);
            continue;
        }
        // OPTIONAL `help` — normalised ONCE, at load, to `{ tip, ariaLabel }` or
        // null, so the two header render sites (pages/main.js `_widget` and
        // `HomeModuleWidget`) read one shape instead of re-deciding what the
        // manifest meant. See functions/widgetHelp.js for the full contract. A
        // declared-but-unusable `help` warns like a bad body does, and the widget
        // still ships — the (?) is chrome, never a reason to drop a card.
        const help = (0, $hWNk6.normalizeWidgetHelp)(w.help);
        if (w.help && !help) console.warn("[workspaceModule] widget `help` needs a non-empty `tip` string (or a bare string) \u2014 ignored:", w.id);
        widgets.push(w.help === undefined && !help ? w : {
            ...w,
            help: help
        });
    }
    // Declared collections → owned state keys (+ optional seeds).
    const stateKeys = [];
    const seeds = {};
    for (const c of Array.isArray(manifest.collections) ? manifest.collections : []){
        const stateKey = c && (c.stateKey || c.key);
        if (!stateKey) continue;
        stateKeys.push(stateKey);
        if (c.seed !== undefined) seeds[stateKey] = c.seed;
    }
    // …and → WHERE ONE OF THOSE ROWS OPENS. Same array, second reading. See
    // _normalizeRecordRoutes below.
    const recordRoutes = $58029952ef70329d$export$230d26dbf5fa98ad(manifest.collections, pages, id);
    // …and → WHICH OF THE MODULE'S OWN COMPONENTS DRAWS ONE ROW, wherever the
    // shell lists that collection's records outside the module's page (an AI
    // answer's records block). Third reading. See _normalizeRecordRows below.
    const recordRows = $58029952ef70329d$export$ec992cea3a773a94(manifest.collections, components, id);
    // …and the app's READ-ONLY VIEWS for AI answers (manifest `views[]`). See
    // _normalizeViews below.
    const views = $58029952ef70329d$export$24ef60579bfd3e31(manifest.views, components, id);
    // …and the app's OWN FORMS an AI answer may open, prefilled (manifest
    // `forms[]`). See _normalizeForms below.
    const forms = $58029952ef70329d$export$cbb7c3781ab2971d(manifest.forms, components, id, functions);
    // Declared data recipes — OPTIONAL manifest metadata for the AI's workspace
    // catalog: declarative fetch descriptors ({ id, from, method, params, as, …})
    // a drawn answer view can paste verbatim. Pure catalog data — nothing in the
    // shell executes them; capability walls still apply at call time.
    const dataRecipes = Array.isArray(manifest.dataRecipes) ? manifest.dataRecipes.filter((r)=>r && typeof r === 'object' && (r.id || r.from)) : [];
    return {
        id: id,
        type: mod.type || 'workspace',
        manifestVersion: 2,
        components: components,
        functions: functions,
        globalScope: // The module's OWN scope root. `_moduleScopeFor` lays it over the shell's
        // as `modCtx.globalScope`; every element under a module page then resolves
        // `el.scope` to it (element/create.js: `baseScope = ancestorScope ||
        // element.context.globalScope`). Without this carrier a module's
        // `__scope.X` read returned the SHELL's bag — measured on prod
        // scheduling-app 1.2.0, where `__scope.NAT_COLLECTIONS` was undefined and
        // `natFetchAll` threw before its first request (the Salons tab read
        // "0 salons · 0 professionals" behind an error banner).
        globalScope,
        pages: pages,
        widgets: widgets,
        // Names only — every consumer (the AI call gate, the merged action trio)
        // matches on a string, so that shape is load-bearing and stays.
        //
        // An entry MAY also be `{ name, description }`. The description is split
        // out into `aiFunctionDocs` below rather than widening this array, because
        // the description is for the MODEL and the names are for the gate: telling
        // the assistant a verb exists and letting it run are different decisions.
        aiFunctions: Array.isArray(manifest.aiFunctions) ? manifest.aiFunctions.map((f)=>typeof f === 'string' ? f : f && typeof f.name === 'string' ? f.name : null).filter(Boolean) : [],
        // How each AI-drivable verb should be CALLED, keyed by name. Without this
        // the catalog could only tell the model a function exists — not what to
        // pass it — so an assistant had to guess the argument shape. Measured cost
        // of guessing, on excalidraw: free-floating text elements overlapping their
        // boxes instead of bound, wrapped labels.
        aiFunctionDocs: Array.isArray(manifest.aiFunctions) ? manifest.aiFunctions.reduce((acc, f)=>{
            if (f && typeof f === 'object' && typeof f.name === 'string' && f.description) acc[f.name] = String(f.description);
            return acc;
        }, {}) : {},
        // The verbs the manifest marks `readOnly: true` (MODULE-FN-READONLY-
        // ENFORCED-1): the assistant runs them without the Run / Skip row, on a
        // read-only caller that refuses every write (moduleReadOnlyCall.js). A
        // name declared twice is read-only only when every declaration says so.
        readOnlyAiFunctions: $58029952ef70329d$export$37bb30be4c4e3ce(manifest.aiFunctions),
        chatStarters: Array.isArray(manifest.chatStarters) ? manifest.chatStarters : [],
        stateKeys: stateKeys,
        seeds: seeds,
        recordRoutes: // WHERE a row of a declared collection OPENS — `[{ key, route, param }]`,
        // or null. Manifest-read like `opens`/`libraries` and for the same reason:
        // it grants nothing. It only names one of the module's OWN pages and the
        // query key that page already reads. See _normalizeRecordRoutes.
        recordRoutes,
        recordRows: // The module's OWN row component for a declared collection —
        // `[{ key, row, moduleId }]`, or null. Names only: the def stays in the
        // module's components, mounted under the module context. See
        // _normalizeRecordRows.
        recordRows,
        views: // The app's read-only views an AI answer may mount (manifest `views[]`),
        // or null. See _normalizeViews.
        views,
        forms: // The app's own forms an AI answer may open, prefilled (manifest
        // `forms[]`), or null. See _normalizeForms.
        forms,
        dataRecipes: dataRecipes,
        // Presentation-mode manifest: `{ immersive: 'non-admin'|true, landing:
        // '/route' }`. Immersive hides the shell's top/bottom chrome for the
        // matched members and lands them on the module's own page (with the
        // module rail) instead of the home board — a module UX decision, so it
        // lives in the manifest like navbar/widgets, NOT a capability grant
        // (those are server-ref-only by design).
        chrome: manifest.chrome && typeof manifest.chrome === 'object' ? manifest.chrome : null,
        // The module's own pages that are pan/zoom CANVAS pages (manifest
        // `canvasRoutes: ['/route', …]`): the shell lands them full-bleed like
        // /tasks and shows its Zoombar, which drives the instance the page
        // registers (canvas registerCanvasPanzoom). shared moduleRoutes.js
        // isModuleCanvasRoute only honours a route the module also serves.
        canvasRoutes: Array.isArray(manifest.canvasRoutes) ? manifest.canvasRoutes.filter((r)=>typeof r === 'string' && r.startsWith('/') && r !== '/') : null,
        // The module project's OWN raw design system (designSystem/ token files —
        // color, spacing, typography…). Without threading this, every module
        // token resolves against the SHELL's scratch config where the names don't
        // exist: unknown color names pass through as raw CSS ("navy" paints the
        // CSS keyword, "paper" silently drops the declaration) — the module looks
        // right standalone and broken in-shell. Processed into an isolated
        // per-module scratch config at inject time (_ensureModuleDsContext).
        // …with the linked libraries' tokens folded in as DEFAULTS (deepDefaults —
        // the module's own token always wins), so a library component that paints
        // with its own palette names resolves in-shell too.
        designSystem: withLibs.designSystem,
        actions: manifest.actions && typeof manifest.actions === 'object' ? manifest.actions : null,
        configDefaults: manifest.configDefaults && typeof manifest.configDefaults === 'object' ? manifest.configDefaults : null,
        // WS-MODULE-DECLARED-STATE-NOT-SEEDED-IN-SHELL-1 — the module's own
        // `state.js` default export. A top-level payload field exactly like
        // `globalScope` (never nested under the v2 manifest object — see
        // ProjectDataService.js `pick('state')`). Standalone, `prepareState`
        // (smbls prepare.js) merges `app.state` into the boot-time root; nothing
        // in this loader did the equivalent for a module's own store, so a key
        // only ever READ before a handler writes it (a url, a flag, an empty
        // list) stayed undefined in-shell forever. Seeded once per module store
        // at inject — see _seedDeclaredState.
        declaredState: mod.state && typeof mod.state === 'object' ? mod.state : null,
        // Vendor libraries the app may load at runtime (`{ pkg: 'x.y.z' }`), the
        // allowlist for the `moduleImport` bridge. Unlike `capabilities` this IS
        // read from the manifest: it grants no workspace data or authority — it
        // only names which public npm packages the shell will fetch on the app's
        // behalf, pinned to the exact declared version (moduleImportBridge.js).
        //
        // Keyed `libraries`, NOT `dependencies`: a project's own `dependencies.js`
        // (the runtime importmap, FA209) lands on the SAME payload as a top-level
        // `dependencies` and silently overwrote the manifest's map — the published
        // project came back with `dependencies: {}` and every moduleImport call
        // would have thrown "not declared". Caught by reading the published
        // payload back, which is why we do that.
        libraries: manifest.libraries && typeof manifest.libraries === 'object' ? manifest.libraries : null,
        // File formats this app OPENS, and the function that opens one. Installing
        // an app is what teaches the desktop a new file type — before this the
        // /files package carried a hardcoded row per app and drove the app's own
        // surface from outside to deliver the file, which is the shell knowing
        // another app's internals (tickets/workspace.md).
        //
        // Manifest-read for the same reason `libraries` is, and it needs saying
        // because `capabilities` sitting two lines below reads the opposite way:
        // this grants NOTHING. It claims an extension and names a function the app
        // already exports — every one of which the shell could call anyway.
        // `capabilities.files` is a different thing entirely (an upload grant) and
        // is NOT a place to declare formats.
        //
        // A row needs `ext` + `entry` to be usable at all; anything short of that
        // is dropped rather than half-registered, so a typo shows up as "no app
        // opens this" instead of a handler that routes and then does nothing.
        opens: $58029952ef70329d$export$dcf0f8dea5f5ccc8(manifest.opens, pages),
        // WS-MODULE-SCOPED-KEYS-CONTRACT-1 — the module's DECLARED tenant-scoped
        // root keys (`'key'` | `'prefix*'` | `{ key|prefix, empty }`) and its
        // tenant-boundary hook (`hooks.onWorkspaceSwitch: '<moduleFn>'`). Both are
        // manifest-read like widgets/chrome: they grant nothing, they only tell
        // the shell which root keys are this module's to wipe on a switch and
        // which module function fences its late writes. See
        // functions/moduleScopedKeys.js for the full contract.
        scopedKeys: $58029952ef70329d$var$_normalizeScopedKeysWarn(manifest.scopedKeys, id),
        // WS-MODULE-STATE-SCOPE-1 — the module's EXPLICIT opt-in to the SHELL state
        // plane. Same entry grammar as `scopedKeys` (`'key'` | `'prefix*'`). A
        // module's `s.root` writes are module-local by default; a key declared here
        // writes THROUGH to the shell root instead, for the rare key a module
        // genuinely shares with the shell or with a sibling app. Declaring nothing
        // is the correct default — the shell's own keys are already write-through
        // by schema (see functions/moduleStateScope.js SHELL_OWNED_STATE_KEYS).
        rootStateKeys: $58029952ef70329d$var$_normalizeScopedKeysWarn(manifest.rootStateKeys, id, 'rootStateKeys'),
        hooks: $58029952ef70329d$var$_normalizeHooks(manifest.hooks, id),
        // The grant is DATA on the server ref — the manifest can declare wants,
        // but only the workspace record's reference grants capabilities.
        capabilities: ref && ref.capabilities || null
    };
};
// Manifest `scopedKeys` → normalized entries; a malformed entry is dropped
// with a warn naming the module (never fatal — the rest of the contract holds).
const $58029952ef70329d$var$_normalizeScopedKeysWarn = (raw, id, field = 'scopedKeys')=>{
    if (raw === undefined || raw === null) return [];
    if (!Array.isArray(raw)) {
        console.warn('[workspaceModule] manifest ' + field + " must be an array \u2014 ignored:", id);
        return [];
    }
    const out = (0, $j9v8x.normalizeScopedKeys)(raw);
    if (out.length !== raw.length) console.warn('[workspaceModule] manifest ' + field + " \u2014 malformed entries dropped:", id, raw.length - out.length);
    return out;
};
// Manifest `hooks` → `{ onWorkspaceSwitch }` (function NAMES only — the shell
// resolves them through the module's injected functions at call time) or null.
const $58029952ef70329d$var$_normalizeHooks = (raw, id)=>{
    if (raw === undefined || raw === null) return null;
    if (typeof raw !== 'object') {
        console.warn("[workspaceModule] manifest hooks must be an object \u2014 ignored:", id);
        return null;
    }
    const out = {};
    if (typeof raw.onWorkspaceSwitch === 'string' && raw.onWorkspaceSwitch.trim()) out.onWorkspaceSwitch = raw.onWorkspaceSwitch.trim();
    else if (raw.onWorkspaceSwitch !== undefined) console.warn("[workspaceModule] manifest hooks.onWorkspaceSwitch must name a module function \u2014 ignored:", id);
    return Object.keys(out).length ? out : null;
};
const $58029952ef70329d$export$230d26dbf5fa98ad = (collections, pages, id)=>{
    if (collections === undefined || collections === null) return null;
    if (!Array.isArray(collections)) {
        console.warn("[workspaceModule] manifest collections must be an array \u2014 ignored:", id);
        return null;
    }
    const out = [];
    const seen = new Set();
    for (const c of collections){
        if (!c || typeof c !== 'object') continue;
        const key = c.key == null ? '' : String(c.key).trim().toLowerCase();
        const route = c.route == null ? '' : String(c.route).trim();
        const param = c.param == null ? '' : String(c.param).trim();
        // A collection with no route at all is the NORM — most declare state keys
        // only. Say nothing about those; warn only about a half-declaration,
        // which is the one a developer meant to work.
        if (!key || !route && !param) continue;
        if (!route || !param || route.charAt(0) !== '/') {
            console.warn('[workspaceModule] collection record route needs { key, route: "/path", param } \u2014 skipped:', id, c.key);
            continue;
        }
        if (!pages || !pages[route]) {
            console.warn("[workspaceModule] collection record route names a page this module does not serve \u2014 skipped:", id, route);
            continue;
        }
        if (seen.has(key)) continue;
        seen.add(key);
        out.push({
            key: key,
            route: route,
            param: param
        });
    }
    return out.length ? out : null;
};
const $58029952ef70329d$export$ec992cea3a773a94 = (collections, components, id)=>{
    if (!Array.isArray(collections)) return null;
    const out = [];
    const seen = new Set();
    for (const c of collections){
        if (!c || typeof c !== 'object' || c.row === undefined || c.row === null) continue;
        const key = c.key == null ? '' : String(c.key).trim().toLowerCase();
        const row = typeof c.row === 'string' ? c.row.trim() : '';
        if (!key || !row) {
            console.warn('[workspaceModule] collection record row needs { key, row: "<Component>" } \u2014 skipped:', id, c.key);
            continue;
        }
        if (!components || !Object.prototype.hasOwnProperty.call(components, row)) {
            console.warn("[workspaceModule] collection record row component not found \u2014 skipped:", id, row);
            continue;
        }
        if (seen.has(key)) continue;
        seen.add(key);
        out.push({
            key: key,
            row: row,
            moduleId: id == null ? null : String(id)
        });
    }
    return out.length ? out : null;
};
const $58029952ef70329d$export$24ef60579bfd3e31 = (views, components, id)=>{
    if (!Array.isArray(views)) return null;
    const out = [];
    const seen = new Set();
    for (const v of views){
        if (!v || typeof v !== 'object') continue;
        const vid = String(v.id || '');
        if (!/^[a-z0-9-]{1,60}$/.test(vid)) {
            console.warn("[workspaceModule] view id must match /^[a-z0-9-]+$/ \u2014 skipped:", id, v.id);
            continue;
        }
        const component = typeof v.component === 'string' ? v.component.trim() : '';
        if (!component || !components || !Object.prototype.hasOwnProperty.call(components, component)) {
            console.warn("[workspaceModule] view component not found \u2014 skipped:", id, vid, v.component);
            continue;
        }
        if (seen.has(vid)) continue;
        seen.add(vid);
        out.push(component === v.component ? v : {
            ...v,
            component: component
        });
    }
    return out.length ? out : null;
};
const $58029952ef70329d$export$cbb7c3781ab2971d = (forms, components, id, functions)=>{
    if (!Array.isArray(forms)) return null;
    const out = [];
    const seen = new Set();
    for (const f of forms){
        if (!f || typeof f !== 'object') continue;
        const fid = String(f.id || '');
        if (!/^[a-z0-9-]{1,60}$/.test(fid)) {
            console.warn("[workspaceModule] form id must match /^[a-z0-9-]+$/ \u2014 skipped:", id, f.id);
            continue;
        }
        if (typeof f.open !== 'string' || !f.open) {
            console.warn('[workspaceModule] form needs `open: "<function>"` \u2014 skipped:', id, fid);
            continue;
        }
        if (functions && !Object.prototype.hasOwnProperty.call(functions, f.open)) {
            console.warn("[workspaceModule] form open function not found \u2014 skipped:", id, fid, f.open);
            continue;
        }
        if (f.component != null && (typeof f.component !== 'string' || !components || !Object.prototype.hasOwnProperty.call(components, f.component))) {
            console.warn("[workspaceModule] form component not found \u2014 skipped:", id, fid, f.component);
            continue;
        }
        if (seen.has(fid)) continue;
        seen.add(fid);
        out.push(f);
    }
    return out.length ? out : null;
};
const $58029952ef70329d$export$dcf0f8dea5f5ccc8 = (opens, pages)=>{
    if (!Array.isArray(opens) || !opens.length) return null;
    const routes = Object.keys(pages || {});
    const out = [];
    for (const row of opens){
        if (!row || typeof row !== 'object') continue;
        const ext = (Array.isArray(row.ext) ? row.ext : [
            row.ext
        ]).filter((e)=>typeof e === 'string' && e.trim())// Stored bare and lowercase — the desktop matches on a bare extension
        // (fileExtOf), so a declared '.excalidraw' and 'EXCALIDRAW' both have to
        // land as 'excalidraw' or the row silently never matches.
        .map((e)=>e.trim().replace(/^\./, '').toLowerCase());
        const entry = typeof row.entry === 'string' && row.entry.trim() ? row.entry.trim() : null;
        if (!ext.length || !entry) continue;
        const route = typeof row.route === 'string' && row.route ? row.route : routes[0];
        if (!route || routes.length && routes.indexOf(route) < 0) continue;
        out.push({
            ext: ext,
            entry: entry,
            route: route,
            mime: typeof row.mime === 'string' ? row.mime : '',
            label: typeof row.label === 'string' ? row.label : '',
            icon: typeof row.icon === 'string' ? row.icon : ''
        });
    }
    return out.length ? out : null;
};
// ── Loader discovery (AI workspace catalog) ──────────────────────────────────
// Modules commonly load their data IMPERATIVELY: a page onInit calls a module
// function (aihouse: `ahFetchTransactions`) that writes rows + status flags
// into root state (`ahTx`, `ahTxLoading`, `ahTxLoaded`, `ahTxError`). Nothing
// declares this — the manifest's stateKeys only cover records-plane
// collections, so the AI catalog couldn't see where the module's REAL data
// lives. Recover the mapping from the functions themselves: for each injected
// function whose name reads like a loader, statically parse its source for the
// state keys it writes and split data keys from status flags. Best-effort —
// a parse miss just means a thinner catalog hint, never an error.
const $58029952ef70329d$var$_LOADER_NAME_RE = /fetch|load|refresh/i;
const $58029952ef70329d$var$_LOADER_FLAG_RE = /(Loading|Loaded|Error|Busy|Status)$/;
const $58029952ef70329d$var$_discoverLoaders = (functions)=>{
    const out = {};
    for (const [name, fn] of Object.entries(functions || {})){
        if (typeof fn !== 'function' || !$58029952ef70329d$var$_LOADER_NAME_RE.test(name)) continue;
        let src = '';
        try {
            src = String(fn);
        } catch (_) {
            continue;
        }
        const keys = new Set();
        for (const call of src.matchAll(/update\(\s*\{([^}]*)/g))for (const key of call[1].matchAll(/(\w+)\s*:/g))keys.add(key[1]);
        const writes = [
            ...keys
        ].filter((k)=>!$58029952ef70329d$var$_LOADER_FLAG_RE.test(k));
        const flags = [
            ...keys
        ].filter((k)=>$58029952ef70329d$var$_LOADER_FLAG_RE.test(k));
        if (writes.length) out[name] = {
            writes: writes.slice(0, 4),
            flags: flags.slice(0, 4)
        };
        if (Object.keys(out).length >= 16) break;
    }
    return out;
};
// ── Module resolution ─────────────────────────────────────────────────────────
// A published-module reference from the workspace settings bag:
// `settings.workspaceModule` (canonical) or an object-form `settings
// .projectModule` (transitional). Must be `{type:'project', owner, key, …}`.
const $58029952ef70329d$var$_publishedRef = (settings)=>{
    const candidates = [
        settings && settings.workspaceModule,
        settings && settings.projectModule
    ];
    for (const c of candidates){
        if (c && typeof c === 'object' && c.type === 'project' && c.owner && c.key) return c;
    }
    return null;
};
// The additive workspace-app references from `settings.workspaceApps[]`. Each
// must be a `{type:'project', owner, key, …}` ref (same shape as workspaceModule
// but installMode:'app'). Deduped by `owner/key` (last wins) so a double-write
// can't inject the same app twice. A malformed entry is skipped, never fatal.
const $58029952ef70329d$var$_appId = (ref)=>`${$58029952ef70329d$var$_lc(ref && ref.owner)}/${$58029952ef70329d$var$_lc(ref && ref.key)}`;
// WS-SWITCH-MEMO-PLANE-1 — the `_injectedByApp` ledger key must carry the
// WORKSPACE; `_appId` alone is a GLOBAL catalog identity. Keyed by `owner/key`
// only, the same app installed in two workspaces owned ONE ledger entry, and
// both guards that read it then did the wrong thing on a switch: the teardown
// loop keeps it (it IS in the new workspace's desired list) and the injection
// gate skips it (`_injectedByApp.has` is already true), so the new workspace's
// `ctx.pages`/`routedEl.routes` never receive the app's pages — installed,
// listed, and blank until a full reload.
// Tenant-keying and NOT a teardown call, on purpose: once the key carries the
// workspace, the previous tenant's entries are simply absent from the new
// tenant's `desiredIds`, so the teardown loop that already exists collects them
// on its own. `_appId` keeps its catalog meaning for ref dedupe, the `_prefetched`
// map and the published `appId` field.
const $58029952ef70329d$var$_ledgerKey = (wsId, ref)=>`${String(wsId || '')}::${$58029952ef70329d$var$_appId(ref)}`;
// The installed-app entries — the shared reader in workspaceConfigs.js (moved
// from here; every consumer calls the same function).
const $58029952ef70329d$var$_appRefs = (settings)=>(0, $g7CNh.installedAppRefs)(settings);
// Deep equality for plain capability-config JSON — objects/arrays/primitives
// straight off the stored server ref, so no cycles and no functions to worry
// about. Used to tell an actual ai/files grant COLLISION (two apps shipping
// different configs, which one shared bridge cannot serve) apart from two apps
// declaring the SAME grant, which is no collision at all.
const $58029952ef70329d$var$_capConfigsEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return false;
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    const ka = Object.keys(a);
    if (ka.length !== Object.keys(b).length) return false;
    return ka.every((k)=>$58029952ef70329d$var$_capConfigsEqual(a[k], b[k]));
};
const $58029952ef70329d$export$a5671be23532b340 = (a, b)=>{
    const { mimeTypes: mimesA, ...restA } = a || {};
    const { mimeTypes: mimesB, ...restB } = b || {};
    if (!$58029952ef70329d$var$_capConfigsEqual(restA, restB)) return null;
    if (!Array.isArray(mimesA) || !Array.isArray(mimesB)) return {
        ...restA
    };
    return {
        ...restA,
        mimeTypes: [
            ...new Set([
                ...mimesA,
                ...mimesB
            ])
        ]
    };
};
// Each published request must settle so a failed activation can retry instead
// of sharing one permanently pending flight.
//
// The budget is charged in TICKS, never by subtracting two wall-clock reads. A
// page has ONE javascript thread and every app on it shares that thread, so a
// wall-clock deadline bills app B for app A's synchronous payload revival.
// Measured 2026-09-23 on my.symbols.app/w/aihouse: `system/warehouse-app`
// logged "Workspace app request timed out" while the server answered that same
// data read in 0.3s (272 KB), because `aihouse/workspace-module` (736 revived
// function strings) held the thread past the 15s mark. The workspace then
// showed "Some apps couldn't load - 1 of 2" on every boot, and the converge
// loop paid five more full reload passes before it gave up.
//
// A tick that arrives LATE measures time in which the page could not run ANY
// javascript. The request never had that time, so the budget is charged at most
// one interval for it. A slow NETWORK leaves the thread free, its ticks land on
// schedule, and the budget drains exactly as it did before.
let $58029952ef70329d$var$_moduleRequestBudgetMs = 15000;
const $58029952ef70329d$export$c4ecc9cf35aa0cef = (ms)=>{
    $58029952ef70329d$var$_moduleRequestBudgetMs = ms;
};
// One budget per app load, shared by that app's channel resolution and its
// payload fetch — the same single allowance the deadline gave them.
const $58029952ef70329d$var$_newRequestBudget = ()=>({
        left: $58029952ef70329d$var$_moduleRequestBudgetMs,
        tick: Math.max(20, Math.min(500, Math.round($58029952ef70329d$var$_moduleRequestBudgetMs / 8)))
    });
// Every phase entry carries a stamp (`seq`), so an owner can settle ONLY the
// entry it wrote last. The root store wraps each nested write in a new proxy,
// so object identity cannot tell an owner "this is still mine"; a stamp can.
let $58029952ef70329d$var$_activationStampSeq = 0;
// 'slow' is the reveal budget's voice — the page the person waits for is late —
// and never a final state. An SDK request carries no deadline of its own, so a
// read that never answers used to keep "Workspace is still loading" on screen
// for the rest of the session (dev 2026-10-30: stuck past 25 s while dev Redis
// was down; prod 2026-10-21: the Shaker workspace in the 503 incident). Past
// this ceiling the phase turns into the retryable failure. A late answer still
// lands and clears it, because the owner keeps its stamp.
let $58029952ef70329d$var$_activationCeilingMs = 30000;
const $58029952ef70329d$export$934b8ac78ddb0521 = (ms)=>{
    $58029952ef70329d$var$_activationCeilingMs = ms;
};
const $58029952ef70329d$var$_activationCeilingTimers = new WeakMap();
// The one write path: re-arm the phase's ceiling BEFORE the update, so a
// listener that writes the same phase during it keeps its own timer.
const $58029952ef70329d$var$_writeActivationPhase = (root, base, phase, entry)=>{
    const timers = $58029952ef70329d$var$_activationCeilingTimers.get(root) || {};
    clearTimeout(timers[phase]);
    timers[phase] = null;
    if (entry.state === 'slow') {
        timers[phase] = setTimeout(()=>{
            if (root._workspaceActivation?.[phase]?.state !== 'slow') return;
            try {
                $58029952ef70329d$export$2ec12c96491253d1(root, phase, entry.seq, {
                    state: 'error',
                    timedOut: true
                });
            } catch (_) {
            /* torn down while the ceiling waited */ }
        }, $58029952ef70329d$var$_activationCeilingMs);
        timers[phase]?.unref?.();
    }
    $58029952ef70329d$var$_activationCeilingTimers.set(root, timers);
    root.update({
        _workspaceActivation: {
            ...base,
            [phase]: entry
        }
    });
};
const $58029952ef70329d$export$5cda0d0e0ba2885a = (root, phase, next)=>{
    if (!root || typeof root.update !== 'function') return 0;
    const workspaceId = String(root.workspace?.id || root.workspace?._id || '');
    const orgId = String(root.org?.id || root.org?._id || '');
    const previous = root._workspaceActivation;
    const held = previous?.workspaceId === workspaceId && previous?.orgId === orgId ? previous : {};
    const seq = ++$58029952ef70329d$var$_activationStampSeq;
    $58029952ef70329d$var$_writeActivationPhase(root, {
        ...held,
        workspaceId: workspaceId,
        orgId: orgId
    }, phase, {
        ...next,
        seq: seq
    });
    return seq;
};
const $58029952ef70329d$export$2ec12c96491253d1 = (root, phase, seq, next)=>{
    const status = root?._workspaceActivation;
    if (!seq || !status || status[phase]?.seq !== seq || typeof root.update !== 'function') return false;
    $58029952ef70329d$var$_writeActivationPhase(root, status, phase, {
        ...next,
        seq: seq
    });
    return true;
};
const $58029952ef70329d$export$18ed75d0bc8fa89c = (root)=>{
    // THE WELCOME IS THE LAYER (R2c-m2, elena-r2c + sam-r2): while the new-account
    // welcome holds the screen (components/OnboardingWizard.js — opaque, the shell
    // inert and "simply not on screen"), the shell's loading strip waits. It sat
    // over the welcome's Continue, inert itself. The status stays on the root, so
    // a failure shows the moment the welcome closes. Both keys are read on every
    // run, so the view follows either.
    const welcomeOpen = !!root?._onboardingOpen;
    const welcomeHold = !!root?._onboardingHold;
    if (welcomeOpen || welcomeHold) return {
        visible: false,
        busy: false
    };
    const status = root?._workspaceActivation;
    const workspaceId = String(root?.workspace?.id || root?.workspace?._id || '');
    const orgId = String(root?.org?.id || root?.org?._id || '');
    if (!status || root.signedIn === false || status.workspaceId !== workspaceId || status.orgId !== orgId) return {
        visible: false,
        busy: false
    };
    const phases = [
        status.core,
        status.reconcile,
        status.module,
        status.apps
    ];
    // 'blocked' is a SETTLED failure: the payload arrived and the shell refused
    // it on content grounds (publish-time audit, sandboxed tier, a manifest it
    // cannot read, an extension the workspace no longer holds). It belongs in
    // `failed` because the user must be told, and OUT of every retry path
    // because no amount of retrying changes a content verdict.
    const failed = phases.some((phase)=>phase?.state === 'error' || phase?.state === 'partial' || phase?.state === 'blocked');
    // A QUIET load is the hot-activation after the person's own install
    // (loadWorkspaceApps `{ quiet: true }`, BLD-28): it is no reason to show
    // "Retrying workspace loading". Its failure still shows (the settle writes
    // the outcome without `quiet`).
    const pending = phases.some((phase)=>phase?.state === 'loading' && !phase.quiet);
    const retrying = status.core?.state === 'loading' && status.core?.visible === true;
    const visible = failed || phases.some((phase)=>phase?.state === 'slow') || retrying || status.core?.state === 'ready' && pending;
    const busy = retrying || status.core?.state === 'ready' && pending;
    const appsState = status.apps?.state;
    const variant = appsState === 'blocked' || appsState === 'partial' ? appsState : failed ? 'error' : busy ? 'retrying' : 'slow';
    const messages = {
        slow: {
            titleKey: 'workspace.activation.slowTitle',
            bodyKey: 'workspace.activation.slowBody'
        },
        error: {
            titleKey: 'workspace.activation.errorTitle',
            bodyKey: 'workspace.activation.errorBody'
        },
        partial: {
            titleKey: 'workspace.activation.partialTitle',
            bodyKey: 'workspace.activation.partialBody'
        },
        blocked: {
            titleKey: 'workspace.activation.blockedTitle',
            bodyKey: 'workspace.activation.blockedBody'
        },
        retrying: {
            titleKey: 'workspace.activation.retryingTitle',
            bodyKey: 'workspace.activation.retryingBody'
        }
    };
    return {
        visible: visible,
        busy: busy,
        // The Retry button exists only where a retry can change the answer. On a
        // blocked verdict it promised an outcome it could never deliver, and the
        // converge loop behind it paid five full reload passes to learn the same
        // thing five times.
        retryable: variant !== 'blocked',
        ...messages[variant],
        values: {
            loaded: status.apps?.loaded || 0,
            total: status.apps?.total || 0,
            blocked: Array.isArray(status.apps?.blocked) ? status.apps.blocked.join(', ') : ''
        }
    };
};
const $58029952ef70329d$var$_waitForModuleRequest = async (work, budget = $58029952ef70329d$var$_newRequestBudget())=>{
    let timer;
    try {
        return await Promise.race([
            work,
            new Promise((resolve, reject)=>{
                // A timer never fires before its delay, so a tick charges exactly the
                // delay it was armed with — at most one interval, however late it
                // lands. That is the whole mechanism: a blocked thread delays the
                // tick, it does not inflate the charge. No clock is read.
                const arm = ()=>{
                    const delay = Math.min(budget.tick, budget.left);
                    timer = setTimeout(()=>{
                        budget.left -= delay;
                        if (budget.left > 0) return arm();
                        const error = new Error('Workspace app request timed out');
                        error.code = 'WORKSPACE_MODULE_TIMEOUT';
                        reject(error);
                    }, delay);
                };
                arm();
            })
        ]);
    } finally{
        clearTimeout(timer);
    }
};
// Per-app boot spans (boot fix step 0) — `wsboot:app:<key>:<phase>` measures
// with an explicit start, so a synchronous phase reads as its own main-thread
// time even in a background tab that delays every timer around it. Phases:
// channel (env resolution), cache (warm-slot read + revive), fetch (payload
// read; the SDK revives inside it), build (audit + normalize), wait (the
// serial loop waiting on the prefetch), inject (components + functions),
// wrap (module DS context + state root + page wrap), routes (page + route
// table registration). The pass adds `wsboot:app:module-apps:publish` around
// the one surface publish. Telemetry only — never throws, never gates.
const $58029952ef70329d$var$_spanStart = ()=>typeof performance !== 'undefined' && typeof performance.now === 'function' ? performance.now() : 0;
const $58029952ef70329d$var$_span = (key, phase, start)=>{
    try {
        if (typeof performance === 'undefined' || typeof performance.measure !== 'function') return;
        performance.measure('wsboot:app:' + key + ':' + phase, {
            start: start,
            end: performance.now()
        });
    } catch (_) {
    /* telemetry only */ }
};
// Fetch + normalize a published module by reference. Channel resolves to a
// {branch, version} pair via the project's env publish config unless the ref
// pins a version. Memoized per owner/key@version (dev override skips the memo
// so the authoring loop always sees fresh data).
const $58029952ef70329d$var$_loadPublishedModule = async (ref, sdk, wsId, opts = {})=>{
    const budget = $58029952ef70329d$var$_newRequestBudget();
    // Scoped to THIS workspace — see _devModuleOverride: an override pinned to a
    // different workspace (or not pinned at all) resolves null here, so the
    // spread below can no longer hijack another tenant's module ref.
    // `devOverride: false` (the catalog-apps pipeline) keeps the override OFF
    // while still carrying wsId for the SERVER's workspace-module grant —
    // dropping the id entirely made every catalog-app read arrive with no
    // workspaceId, which the grant middleware refuses outright
    // ("Required roles: guest, editor, admin, owner" on system/crm-app +
    // system/excalidraw for every white-label member, measured 2026-08-31).
    // `channelRole` — 'prefetch' | 'takeover' | undefined (an app): who offers
    // and who may take a channel handoff (see _channelHandoff).
    const { devOverride: devOverride = true, channelRole: channelRole = null } = opts;
    const dev = devOverride ? $58029952ef70329d$var$_devModuleOverride(wsId) : null;
    const eff = dev ? {
        ...ref,
        ...dev
    } : ref;
    // A content refusal is recorded in the module-level ledger under the app's
    // id, not in a per-call sink: `_moduleInflight` hands a second concurrent
    // caller the FIRST caller's promise, so a sink that lived in that caller's
    // closure was invisible to everyone else. The ledger is also what the
    // takeover loader reads through `_lastRefusal`, so each refusal site is one
    // call. A successful load clears the entry.
    const appId = `${eff.owner}/${eff.key}` // eff, not ref: a dev override may arrive with ref === null
    ;
    const _refuse = (code, message)=>{
        $58029952ef70329d$var$_refusals.set(appId, {
            code: code,
            message: message
        });
        $58029952ef70329d$var$_lastRefusal = message;
        if (code === 'manifest') $58029952ef70329d$var$_lastNullDefinitive = true;
        return null;
    };
    // Tier enforcement — `sandboxed` has no runtime isolation yet (the server
    // clamps cross-org, non-catalog refs to it; see WORKSPACE_APPS.md "Trust
    // model"). Until a real sandbox execution tier ships, refuse instead of
    // silently running third-party code in-realm. The dev override is exempt —
    // it's the authoring loop on dev builds / *.localhost only.
    if (!dev && eff.tier === 'sandboxed') {
        console.warn("[workspaceModule] sandboxed tier is not executable yet \u2014 refusing to load:", `${eff.owner}/${eff.key}`);
        return _refuse('tier', "This app is pending trust review and can\u2019t run in your workspace yet.");
    }
    let branch = eff.branch || 'main';
    let version = eff.version || null;
    if (!version && eff.channel) try {
        // MODULE-CHANNEL-PIN-1: thread the in-scope workspace id through so the
        // channel-resolution reads (getProjectByKey/listEnvironments inside
        // resolveEnvPublishConfig) can use the workspace-module read grant.
        // Without it every non-admin member 403s on both reads and silently
        // falls back to 'latest' below — the pin only ever applies to admins.
        // MODULE-CHANNEL-PIN-1: the shared/** sdk.js side now forwards
        // `workspaceId` into the two SDK calls too — all three parts landed.
        const tChannel = $58029952ef70329d$var$_spanStart();
        // The apps pass may already have started this exact read (the channel
        // warm-up in _loadWorkspaceAppsPass) - take that promise, never a
        // second request.
        const _warmKey = $58029952ef70329d$var$_channelHandoffKey(eff.owner, eff.key, eff.channel, wsId);
        // A handed-over resolution (boot prefetch → takeover → apps) first.
        // Never under a dev override: the authoring loop always re-resolves.
        const _handed = dev ? null : $58029952ef70329d$var$_takeChannelHandoff(_warmKey, $58029952ef70329d$var$_channelAccept(channelRole));
        const _warmHit = _handed ? null : globalThis.__wsEnvWarm && globalThis.__wsEnvWarm.get(_warmKey);
        if (_warmHit) globalThis.__wsEnvWarm.delete(_warmKey);
        const _resolveChannel = ()=>$58029952ef70329d$var$_pipeline.resolveEnv({
                owner: eff.owner,
                key: eff.key
            }, eff.channel, {
                workspaceId: wsId
            });
        const _cfgFlight = Promise.resolve(_handed || (_warmHit && Date.now() - _warmHit.at < 30000 ? _warmHit.p : _resolveChannel()));
        // Offer the SAME flight (in flight or settled) to the next consumer.
        if (!dev && (channelRole === 'prefetch' || channelRole === 'takeover')) {
            _cfgFlight.catch(()=>{});
            $58029952ef70329d$var$_channelHandoff.set(_warmKey, {
                p: _cfgFlight,
                from: channelRole,
                at: Date.now()
            });
        }
        let cfg;
        try {
            cfg = await $58029952ef70329d$var$_waitForModuleRequest(_cfgFlight, budget);
        } catch (handedErr) {
            // A handed-over flight that failed is the GIVER's failure: resolve
            // once on our own, exactly as before the handoff existed.
            if (!_handed) throw handedErr;
            cfg = await $58029952ef70329d$var$_waitForModuleRequest(_resolveChannel(), budget);
        }
        $58029952ef70329d$var$_span(eff.key, 'channel', tChannel);
        if (cfg) {
            branch = cfg.branch || branch;
            if (cfg.version && cfg.version !== 'latest') version = cfg.version;
        }
    } catch (e) {
        console.warn("[workspaceModule] channel resolution failed \u2014 falling back to latest:", e && e.message);
    }
    // WS-SWITCH-MEMO-PLANE-1 — the BRANCH is in the key. A channel resolves to
    // `{branch, version:'latest'}` for every non-pinned env, so two workspaces
    // on different channels of the SAME project both read `owner/key@latest`
    // and the second one was served the first one's branch build until a full
    // reload. Put the dimension in the key; never a teardown call.
    const memoKey = `${eff.owner}/${eff.key}@${branch || 'main'}#${version || 'latest'}`;
    if (!dev && $58029952ef70329d$var$_moduleMemo.has(memoKey)) return $58029952ef70329d$var$_moduleMemo.get(memoKey);
    // In-flight dedup — the memo is only SET after the fetch+process below, so the
    // dual-trigger's two concurrent onWorkspaceChange runs would otherwise both
    // fetch the SAME module project. Share one load; the resolved module still
    // lands in _moduleMemo, so post-load reads keep hitting the fast path.
    //
    // EVERY caller owns its own deadline (review D6, perf/shell-boot): the
    // shared flight carries no timer of its own, each caller races it against
    // its OWN budget. Before, a joiner got the creator's deadlined promise — a
    // slow boot PREFETCH failed the takeover pass that joined it later on the
    // prefetch's timer. The build still drops a late payload nobody waits for:
    // its guard reads how many callers are still waiting, and when the last one
    // gives up the flight leaves the map, so a retry fetches fresh.
    if (!dev && $58029952ef70329d$var$_moduleInflight.has(memoKey)) return $58029952ef70329d$var$_awaitModuleFlight($58029952ef70329d$var$_moduleInflight.get(memoKey), budget, memoKey);
    // The creator counts as waiting BEFORE the build starts: a warm-slot hit
    // reaches the build's guard synchronously.
    const flight = {
        waiting: 1,
        work: null
    };
    const stillWanted = {
        get left () {
            return flight.waiting > 0 ? 1 : 0;
        }
    };
    flight.work = $58029952ef70329d$var$_fetchAndBuildModule(eff, branch, version, dev, memoKey, wsId, stillWanted, _refuse, !dev && Array.isArray(opts.lazyParts) && opts.lazyParts.length ? opts.lazyParts : null).then((mod)=>{
        if (mod) $58029952ef70329d$var$_refusals.delete(appId);
        if (mod && !dev) $58029952ef70329d$var$_moduleMemo.set(memoKey, mod);
        return mod;
    });
    const clear = ()=>{
        if ($58029952ef70329d$var$_moduleInflight.get(memoKey) === flight) $58029952ef70329d$var$_moduleInflight.delete(memoKey);
    };
    flight.work.then(clear, clear);
    if (!dev) $58029952ef70329d$var$_moduleInflight.set(memoKey, flight);
    return $58029952ef70329d$var$_awaitModuleFlight(flight, budget, memoKey, true);
};
// Wait for a shared module flight under THIS caller's budget (see above).
const $58029952ef70329d$var$_awaitModuleFlight = async (flight, budget, memoKey, counted = false)=>{
    if (!counted) flight.waiting++;
    try {
        return await $58029952ef70329d$var$_waitForModuleRequest(flight.work, budget);
    } catch (err) {
        flight.waiting--;
        if (flight.waiting <= 0 && $58029952ef70329d$var$_moduleInflight.get(memoKey) === flight) $58029952ef70329d$var$_moduleInflight.delete(memoKey);
        throw err;
    }
};
// WS-MODULE-LIB-FN-ONE-BINDING-1 — one shared library's function is ONE binding
// across every module that links the library.
//
// The server ships each module payload its OWN copy of every linked library
// (`sharedLibraries[].functions`, as text — ProjectDataService). Each payload
// revives on its own (_reviveModulePayload below), so two apps that link one
// library got two function objects for each library function.
// _mergeModuleLibraries folds each copy into its app's functions by
// reference, and the root inject (_injectEntries, same-binding rule) read the
// second copy as a collision: dev.my /w/bessi/orders-qa logged 27 `key
// collision skipped` lines per boot, one per business-kit function, because
// orders-app and production-app both link the kit (108 per four-page walk).
//
// The root bag must keep library functions: shell code runs app code with a
// shell element (an approved AI action runs on the shell card, moduleActions;
// the AI transport calls `el.call(fn)`), and the app code there finds its
// library peers through `this.call` in the root bag.
//
// The rule: a revived function has no closure (the revive is a global eval),
// so one text of one library is one behaviour. The first function revived
// from a library function's text becomes its binding, and every later payload
// that ships the SAME library (by id) with the SAME text reuses it — at the
// same version, or at a version that left that function unchanged. Two
// bindings, and the warn, stay for:
//   - a function the versions changed (another text): each app's module
//     scope keeps its own version, the root bag keeps the first app's;
//   - one name in two different libraries (another id);
//   - an app's OWN function (only `sharedLibraries` text is ever bound);
//   - a value that arrived as a real function (a local source): it may hold a
//     closure, so it is never shared.
// Session lifetime, like _moduleMemo, which keeps the revived modules anyway.
// (moduleLibrarySameBindingNoCollision.test.js)
const $58029952ef70329d$var$_libraryFnTexts = new Map() // `${libraryId}\n${name}` → Map(text → function)
;
// A library entry's identity: the record id the server ships (`id`, `_id`).
// An entry with no id has no identity and is never bound.
const $58029952ef70329d$var$_libraryIdOf = (lib)=>{
    if (!lib || typeof lib !== 'object') return null;
    const id = lib.id != null ? lib.id : lib._id;
    return id == null || id === '' ? null : String(id);
};
// Bind each library function of a freshly revived payload to the first
// function revived from the same text of the same library. `raw` is the
// payload as fetched (text); `revived` is the revive walk's new copy of it.
// Only the copy's own function bags are written, never the raw payload (the
// warm cache slot keeps it).
const $58029952ef70329d$var$_bindLibraryFnTexts = (raw, revived)=>{
    const rawLibs = raw && Array.isArray(raw.sharedLibraries) ? raw.sharedLibraries : null;
    const libs = revived && Array.isArray(revived.sharedLibraries) ? revived.sharedLibraries : null;
    if (!rawLibs || !libs) return;
    for(let i = 0; i < rawLibs.length; i++){
        const rawLib = (0, $7gmTd.isWrappedLibrary)(rawLibs[i]) ? rawLibs[i].library : rawLibs[i];
        const lib = (0, $7gmTd.isWrappedLibrary)(libs[i]) ? libs[i].library : libs[i];
        const libId = $58029952ef70329d$var$_libraryIdOf(rawLib);
        const texts = rawLib && rawLib.functions;
        const fns = lib && lib.functions;
        if (!libId || !texts || typeof texts !== 'object' || !fns || typeof fns !== 'object') continue;
        for (const name of Object.keys(texts)){
            const text = texts[name];
            if (typeof text !== 'string' || !Object.prototype.hasOwnProperty.call(fns, name)) continue;
            if (typeof fns[name] !== 'function') continue;
            const slot = libId + '\n' + name;
            let held = $58029952ef70329d$var$_libraryFnTexts.get(slot);
            if (!held) $58029952ef70329d$var$_libraryFnTexts.set(slot, held = new Map());
            const first = held.get(text);
            if (first) fns[name] = first;
            else held.set(text, fns[name]);
        }
    }
};
const $58029952ef70329d$export$abfd9259f86c33cf = (data, deferRevive)=>{
    const rawGlobalScope = data && typeof data === 'object' ? data.globalScope : null;
    const defer = Array.isArray(deferRevive) && data && typeof data === 'object' ? deferRevive.filter((part)=>Object.prototype.hasOwnProperty.call(data, part)) : [];
    let revived;
    if (defer.length) {
        const eager = {};
        for (const part of Object.keys(data))if (!defer.includes(part)) eager[part] = data[part];
        revived = (0, $2C0hZ.deepDestringifyFunctions)(eager);
        for (const part of defer)revived[part] = data[part];
    } else revived = (0, $2C0hZ.deepDestringifyFunctions)(data);
    // One library function text, one binding (WS-MODULE-LIB-FN-ONE-BINDING-1).
    $58029952ef70329d$var$_bindLibraryFnTexts(data, revived);
    if (rawGlobalScope && typeof rawGlobalScope === 'object' && revived) revived.globalScope = (0, $2C0hZ.destringifyGlobalScope)(rawGlobalScope);
    return revived;
};
const $58029952ef70329d$export$8eb5d8a7147b4dc3 = (raw)=>{
    const out = {};
    if (!raw || typeof raw !== 'object') return out;
    for (const key of Object.keys(raw)){
        const cell = {
            done: false,
            value: undefined
        };
        const settle = (target, value)=>{
            try {
                Object.defineProperty(target, key, {
                    value: value,
                    writable: true,
                    enumerable: true,
                    configurable: true
                });
            } catch (_) {
            /* a frozen copy keeps its accessor; it still returns the one value */ }
        };
        const get = function() {
            if (!cell.done) {
                cell.value = (0, $2C0hZ.deepDestringifyFunctions)({
                    [key]: raw[key]
                })[key];
                cell.done = true;
            }
            const d = Object.getOwnPropertyDescriptor(out, key);
            if (d && d.get === get) settle(out, cell.value);
            if (this && this !== out && typeof this === 'object') {
                const own = Object.getOwnPropertyDescriptor(this, key);
                if (own && own.get === get) settle(this, cell.value);
            }
            return cell.value;
        };
        const set = function(value) {
            settle(this && typeof this === 'object' ? this : out, value);
        };
        Object.defineProperty(out, key, {
            get: get,
            set: set,
            enumerable: true,
            configurable: true
        });
    }
    return out;
};
// Copy every own property as a DESCRIPTOR — a lazy entry stays lazy in the
// copy. A spread or Object.assign would read (and revive) every entry.
const $58029952ef70329d$var$_copyEntries = (src, target = {})=>{
    if (!src || typeof src !== 'object') return target;
    return Object.defineProperties(target, Object.getOwnPropertyDescriptors(src));
};
// Fetch + parse + audit-gate + normalize a published module. Extracted from
// _loadPublishedModule so the in-flight promise can be memoized for dedup.
const $58029952ef70329d$var$_fetchAndBuildModule = async (eff, branch, version, dev, memoKey, wsId, budget, refuse, lazyParts = null)=>{
    // WS-MODULE-PAYLOAD-CACHE-1 — warm-slot fast path, 'latest' requests only
    // (pinned versions are immutable admin-channel flows; they keep the direct
    // fetch). On a hit the module mounts from the slot with no payload wait,
    // and ONE background fetch (write-through) refreshes the slot — every boot
    // still costs exactly one payload fetch server-side, it just stops gating
    // the reveal. On a miss the direct fetch also writes the slot.
    // Dev-only local source (localWorkspaceApps.js): an opted-in app builds its
    // payload from apps/* — no cache slot, no fetch, nothing to revive.
    const local = (0, $fcczA.localWorkspaceAppLoader)(eff.owner, eff.key);
    if (local) lazyParts = null;
    const cacheable = !local && !dev && !!wsId && (!version || version === 'latest');
    // Security review N3: every remote path below yields the payload RAW (not
    // one function string evaluated). The publish-time audit is read on the
    // raw data and a refused module is dropped BEFORE any revive — the revive
    // evaluates `(' + str + ')'`, so a revive-then-check ran a refused module's
    // side effects in the shell. Only an admitted payload is revived (below).
    let data = local ? await local() : null;
    if (cacheable) {
        const tCache = $58029952ef70329d$var$_spanStart();
        const hit = $58029952ef70329d$export$171eda5ee8acb001(eff.owner, eff.key, branch, wsId);
        if (hit) {
            $58029952ef70329d$export$714146a0ca5c20d7(wsId);
            data = hit.data;
            $58029952ef70329d$var$_span(eff.key, 'cache', tCache);
            $58029952ef70329d$var$_pipeline.fetchProject(eff.owner, eff.key, {
                branch: branch,
                version: 'latest',
                workspaceId: wsId,
                payloadCacheKey: $58029952ef70329d$export$424c45021ed2f6fe(wsId),
                // N3: only the slot write and the version are needed — never
                // revive a payload no audit gate has read (`raw` is the shared
                // fetchProjectFromSDK option; `revive: false` is main's name for
                // the same intent — both kept so neither seam revives)
                raw: true,
                revive: false
            }).then((fresh)=>{
                const fv = fresh && (fresh.version || fresh.latestVersion);
                if (fv && hit.version && fv !== hit.version) console.info('[workspaceModule] cached payload superseded in background (' + hit.version + " \u2192 " + fv + ") \u2014 the fresh slot serves on the next load");
            }).catch(()=>{})// the revalidation wrote (or failed to write) the slot: index it now
            .finally(()=>$58029952ef70329d$export$714146a0ca5c20d7(wsId));
        }
    }
    if (!data) {
        const tFetch = $58029952ef70329d$var$_spanStart();
        try {
            data = await $58029952ef70329d$var$_pipeline.fetchProject(eff.owner, eff.key, {
                branch: branch,
                version: version || 'latest',
                // Workspace-module read grant (GA onboarding): the member's workspace id
                // authorizes the bundle read server-side even without a project-level
                // role — without it, every invited (non-org-admin) member 403'd here and
                // the module never loaded.
                workspaceId: wsId,
                ...cacheable ? {
                    payloadCacheKey: $58029952ef70329d$export$424c45021ed2f6fe(wsId)
                } : {},
                // N3: raw — the audit gate below reads it before anything revives
                raw: true
            });
        } finally{
            // AFTER the SDK's write-through (review Delta 2 N7a)
            if (cacheable) $58029952ef70329d$export$714146a0ca5c20d7(wsId);
        }
        $58029952ef70329d$var$_span(eff.key, 'fetch', tFetch);
    }
    // A timed-out request has relinquished its flight. Do not revive or audit
    // its late payload: refusal flags would otherwise contaminate an active
    // retry, and processing unused module code adds avoidable main-thread work.
    if (budget.left <= 0) return null;
    const tBuild = $58029952ef70329d$var$_spanStart();
    if (typeof data === 'string') // A string payload: parse only (N3 — revive after the audit gate).
    try {
        data = JSON.parse(data);
    } catch (e) {
        console.warn('[workspaceModule] module payload unparsable:', e && e.message);
        return null;
    }
    if (!data) return null;
    // Publish-time module audit stamp — the server's static scan of the
    // published fn strings rides the fetched project data as top-level
    // `moduleAudit` ({ok, findings, scannedFnStrings, at}). A version that
    // FAILED the audit is refused (fail to plain workspace). A MISSING stamp is
    // allowed with a warn — tolerant-by-absence in v1, so pre-audit publishes
    // and the dev-override authoring loop keep working.
    const audit = data.moduleAudit;
    if (audit && audit.ok === false) {
        console.warn("[workspaceModule] module failed the publish-time audit \u2014 refusing to load:", `${eff.owner}/${eff.key}`, `${Array.isArray(audit.findings) && audit.findings.length || 0} finding(s)`);
        return refuse('audit', 'This app failed its publish-time security check and was not loaded.');
    }
    if (!audit) console.warn("[workspaceModule] no publish-time audit stamp (pre-audit publish) \u2014 loading anyway:", `${eff.owner}/${eff.key}`);
    // Admitted: revive now (a local dev source arrives as real code). Deferred
    // parts stay RAW here; each entry revives on its first read (boot fix
    // step 4).
    if (!local) data = $58029952ef70329d$export$abfd9259f86c33cf(data, lazyParts);
    if (lazyParts && !local) {
        for (const part of lazyParts)if (data[part] && typeof data[part] === 'object') data[part] = $58029952ef70329d$export$8eb5d8a7147b4dc3(data[part]);
    }
    const mod = $58029952ef70329d$export$3871725e3f98f87a(data, eff);
    $58029952ef70329d$var$_span(eff.key, 'build', tBuild);
    // The payload ARRIVED and normalization rejected it (no manifest / id
    // mismatch) — a content verdict, not a transient failure: retrying the
    // fetch returns the same payload, so the converge loop must not spin on it.
    if (!mod) refuse('manifest', "This app\u2019s published manifest could not be read.");
    return mod;
};
const $58029952ef70329d$export$d8bc16b6ff44ac03 = (settings, sdk, wsId)=>{
    const ref = $58029952ef70329d$var$_publishedRef(settings);
    // A dev override drives a load even when the server names no module — it
    // carries its own {owner,key}, and _loadPublishedModule merges it over `ref`
    // (null included). Route to the published pipeline when EITHER is present.
    //
    // `wsId` scopes that override to the workspace it was pinned to. Without it
    // this branch forced a foreign module into EVERY workspace the server said
    // had none — the more severe half of the Bellforge/AI House mashup, since it
    // fabricated a module where the tenant had configured nothing at all.
    if (ref || $58029952ef70329d$var$_devModuleOverride(wsId)) return ()=>$58029952ef70329d$var$_loadPublishedModule(ref, sdk, wsId, {
            channelRole: 'takeover'
        });
    return null;
};
const $58029952ef70329d$export$1d479800cdecfb34 = (sdk, wsId, record)=>{
    if (!wsId || !record || typeof record !== 'object') return null;
    if (String(record._id || record.id || '') !== String(wsId)) return null;
    if ($58029952ef70329d$var$_bootPrefetchWsId === String(wsId)) return null;
    const ref = $58029952ef70329d$var$_publishedRef(record.settings);
    if (!ref || $58029952ef70329d$var$_devModuleOverride(wsId)) return null;
    $58029952ef70329d$var$_bootPrefetchWsId = String(wsId);
    return $58029952ef70329d$var$_loadPublishedModule(ref, sdk, wsId, {
        channelRole: 'prefetch'
    }).catch(()=>null);
};
// ── Module design-system threading ──────────────────────────────────────────
//
// A workspace module ships its own designSystem tokens (the bellforge desk
// palette, a tenant brand, …). The shell's scratch config knows nothing about
// those names, and css-in-props resolves color props against the ACTIVE
// config — so without threading, a module token either passes through as raw
// CSS (a name that happens to be a CSS keyword, e.g. "navy" → rgb(0,0,128))
// or silently drops (everything else), and the module renders broken ONLY
// in-shell (2026-08-11 bellforge desk).
//
// Fix = the framework's own secondary-in-document recipe (smbls prepare.js):
// an ISOLATED createConfig(cleanBase) processed via init() while pushed, then
// handed to the module's page subtrees via `definition.context` — element
// create honors it (element/src/create.js: definition.context || parent
// context) and css-in-props pushes context.designSystem per element, so the
// whole page subtree resolves tokens against the module palette. The atomic
// engine keys classes on RESOLVED values, so shell/module classes can never
// collide in the shared sheet. Object.create(ctx) keeps every other context
// read (components/functions/pages/state) falling through live to the shell.
//
// Document-level side effects are all disabled: no reset, no font import, no
// document-theme stamping, no CSS vars (useVariable:false — the config's own
// token tables resolve to literal values exactly like a standalone bundle
// with vars off). Failure is soft: the module loads with shell-resolved
// tokens, same as before this feature.
// Prewarmed at module evaluation: these dynamic chunks otherwise load INSIDE
// the workspace-activation pass, and a cold parcel dev chunk fetch there blew
// the shell's 10s bounded onWorkspaceChange window ("[shell] onWorkspaceChange
// exceeded its bounded window") on every bellforge activation. Kicking the
// import at module load makes the await in _ensureModuleDsContext a cache hit.
// ONE import, the 'smbls' umbrella: the published smbls dist rolls scratch
// INTO its bundle, so importing createConfig/pushConfig from
// '@symbo.ls/scratch' yields a SECOND scratch instance whose config stack
// the bundled css engine never reads — the threading then silently no-ops
// on deployed builds while working against local source symlinks (observed
// on dev.my 2026-08-11: defs wrapped, config raw/unprocessed, tokens
// passthrough). smbls re-exports the primitives from its own instance.
let $58029952ef70329d$var$_dsDepsPromise = null;

// Plain `if`-assignment, not `||=`: frank classifies a module-level `let` as
// MUTABLE (and lifts it into the emitted state bag) only when it sees a real
// assignment to it; a logical-assignment operator was not recognised and the
// binding was dropped from the published payload.
const $58029952ef70329d$var$_dsDeps = ()=>{
    if (!$58029952ef70329d$var$_dsDepsPromise) $58029952ef70329d$var$_dsDepsPromise = Promise.resolve((parcelRequire("eY4Ct")));
    return $58029952ef70329d$var$_dsDepsPromise;
};

// Prewarm the chunk WITHOUT seeding the memo. frank evaluates this module
// during serialization, and a pending Promise parked on `_dsDepsPromise`
// there is not a serializable value — frank then drops the binding and the
// published `_dsDeps` read a name that does not exist at runtime
// (WORKSPACE-SHELL-FRANK-GATE-BLOCKS-REPUBLISH-1). A bare dynamic import
// warms the very same module-cache entry, so the `await` inside
// `_ensureModuleDsContext` still hits a resolved chunk.
Promise.resolve((parcelRequire("eY4Ct"))).catch(()=>{}) // prewarm; failures re-surface at the real await
;
// ── Per-module resolution scope (WS-MODULE-FN-NAME-COLLISION-CROSS-APP) ─────
//
// THE DEFECT, measured on my.symbols.app/w/natali with 5 apps installed (crm,
// scheduling, commerce, warehouse, bi): crm-app and scheduling-app BOTH define
// `natEnsureLoaded`. Every module used to register its functions and components
// into the ONE flat `ctx.functions` / `ctx.components`, first-writer-wins, so
// the console logged `[workspaceModule] key collision skipped: natEnsureLoaded`
// (and natCustomerById / natCustomerRows / natProcedureById) and scheduling's
// pages then resolved `el.call('natEnsureLoaded')` to CRM's loader. Its own
// `natFetchAll` never ran, natSalons / natProcedures / natProfessionals stayed
// undefined, four `effect error: reading 'find'` followed, the Salons list was
// empty and the header stuck on "Loading…". Independently-authored apps WILL
// pick the same names, so a flat registry is the defect — not the app.
//
// THE SCOPE. Each module gets ONE context object of its own, prototype-chained
// to the shell context, with its own components and functions as OWN
// properties:
//
//   modCtx           = Object.create(ctx)
//   modCtx.functions = Object.create(ctx.functions) + the module's own
//   modCtx.components= Object.create(ctx.components) + the module's own
//
// Resolution then reads "module first, then root" for free, because both
// resolvers are PLAIN PROPERTY READS and therefore already walk a prototype
// chain: `el.call` is `ctx?.functions?.[name]` (smbls packages/element
// src/methods.js `call`), and bare component keys are `components[prop] ||
// components['smbls.'+prop]` (src/create.js, src/extends.js). No framework
// change, no per-call routing table, and no copy: the chain stays LIVE, so
// bridges and shell keys injected into the root bags after a module loads are
// still visible through it.
//
// Every module page def carries this context (see _wrapModulePages), and DOMQL
// hands an element's context to its whole subtree, so a module's pages, its
// widget bodies and everything they mount resolve inside the module's own
// scope. The root bags keep receiving the module's keys exactly as before —
// shell surfaces, the merged approval-action registry and `root._moduleFnGet`
// all read root — so this is additive: it can only CHANGE the resolution of a
// name that two modules both define, which is precisely the broken case.
//
// STATE KEYS ARE SCOPED BY WS-MODULE-STATE-SCOPE-1, the data-plane half of the
// same defect: `natCustomersLoaded` (crm-app) and `natLoading` / `natSalons`
// (scheduling-app) used to land on the ONE reactive root store and collide the
// same way. State is not resolved through `context`, so it needs its own
// carrier: each module gets a module-local reactive store
// (`_moduleStateFor` below, built on the engine's own child-store-with-parent-
// fallback — see functions/moduleStateScope.js for the full contract), and
// every def that already carries `modCtx` also carries that store as its
// `s.root`. Reads still fall back to the shell root; writes land module-locally
// unless the key is shell-owned or the module opted in. Diagnosability from the
// function-plane pass stays: a cross-module key collision names BOTH module ids
// (see _injectEntries).
const $58029952ef70329d$var$_moduleScopeCache = new Map() // project.id → { ctx, modCtx, wrappedPages }
;
const $58029952ef70329d$export$2d3738f8ae4966e8 = (ctx, project, ownFns)=>{
    if (!ctx || !project || project.id == null) return null;
    const hit = $58029952ef70329d$var$_moduleScopeCache.get(project.id);
    if (hit && hit.ctx === ctx) {
        // A later pass may know more of the module's own functions than the pass
        // that created the scope (bridges are built after the components inject).
        if (ownFns) for (const [k, v] of Object.entries(ownFns))hit.modCtx.functions[k] = v;
        // Same for the scope root: a later pass may carry a project object that
        // knows more of the module's own globalScope than the pass that minted the
        // scope. Own keys only — the prototype stays the shell's live bag.
        if (project.globalScope) for (const [k, v] of Object.entries(project.globalScope))hit.modCtx.globalScope[k] = v;
        // Same for the declared config: a later pass may carry the manifest's
        // configDefaults where the pass that minted the scope did not.
        if (project.configDefaults && typeof project.configDefaults === 'object') hit.modCtx.configDefaults = project.configDefaults;
        return hit.modCtx;
    }
    const modCtx = Object.create(ctx);
    // Own-property overlays over LIVE prototypes — not copies. `ctx.components`
    // / `ctx.functions` keep being mutated after this point (other modules, the
    // shared capability bridges, the approval trio); the chain must see all of
    // it.
    // Descriptors, not values: a lazy entry stays lazy in the scope.
    modCtx.components = $58029952ef70329d$var$_copyEntries(project.components || {}, Object.create(ctx.components || Object.prototype));
    modCtx.functions = Object.assign(Object.create(ctx.functions || Object.prototype), ownFns || project.functions || {});
    // The module's SCOPE root — the third carrier, and the one that was missing
    // (WS-MODULE-CTX-DROPS-APP-GLOBALSCOPE-1). Same overlay shape as the two
    // above, and for the same two reasons: a shell globalScope key added after
    // this point stays visible through the live prototype, and a module key can
    // never land on the shell's own object where a sibling module would read it.
    //
    // `element/create.js` reads `element.context.globalScope` for the scope base
    // of every element that has no ancestor scope, so this one own property is
    // what makes a module page's `__scope.X` resolve to the app's own root
    // instead of the shell's.
    modCtx.globalScope = Object.assign(Object.create(ctx.globalScope || Object.prototype), project.globalScope || {});
    // The module's DECLARED config (manifest `configDefaults`: websiteUrl,
    // integrationSlug, navbar, …) — the fourth carrier. Standalone, the app
    // context spreads config.js, so `el.context.configDefaults` IS the
    // declaration; in-shell only the takeover stash surfaced it
    // (`root.workspaceProject.config`), and an additive app could reach its
    // own declared values nowhere at all (aihouse admin: `websiteUrl` read as
    // undefined on every relation row's site link, measured live 2026-09-24,
    // WS-MODULE-CONFIG-DEFAULTS-MISSING-FROM-APP-CONTEXT-1). An OWN property
    // even when the module declares nothing, so a module never inherits the
    // shell's own config.js defaults through the prototype.
    modCtx.configDefaults = project.configDefaults && typeof project.configDefaults === 'object' ? project.configDefaults : null;
    $58029952ef70329d$var$_moduleScopeCache.set(project.id, {
        ctx: ctx,
        modCtx: modCtx
    });
    return modCtx;
};
const $58029952ef70329d$export$35a4f2bf5f18fb05 = (ctx)=>{
    if (!ctx || typeof ctx !== 'object') return null;
    for (const cache of [
        $58029952ef70329d$var$_moduleScopeCache,
        $58029952ef70329d$var$_moduleDsCtxCache
    ])for (const [id, hit] of cache){
        if (hit && hit.modCtx === ctx && id != null) return String(id);
    }
    return null;
};
// Options for every buildModuleDataBridge call: the test SDK seam (when set)
// and the caller-module resolver above.
const $58029952ef70329d$var$_moduleDataBridgeOpts = ()=>({
        ...$58029952ef70329d$var$_sdkFnOverrideForTests ? {
            getSdkFn: $58029952ef70329d$var$_sdkFnOverrideForTests
        } : {},
        moduleIdOf: $58029952ef70329d$export$35a4f2bf5f18fb05
    });
// ── Per-module STATE root (WS-MODULE-STATE-SCOPE-1) ──────────────────────────
//
// One reactive store per installed module, chained to the SHELL root through
// the engine's own `store.root` delegation. The whole contract — read fallback,
// module-local writes, the shell-owned write-through set, the `s.root.shell`
// and `manifest.rootStateKeys` opt-ins, and the exact framework primitive that
// would replace the signal-alias step — is documented in moduleStateScope.js.
//
// Keyed on project.id AND on the shell root identity: the switch pipeline can
// replace the root store, and a module left holding a store chained to a dead
// root would read a frozen shell.
const $58029952ef70329d$var$_moduleStateCache = new Map() // project.id → { shellRoot, store }
;
// WS-MODULE-DECLARED-STATE-NOT-SEEDED-IN-SHELL-1 — seed `project.declaredState`
// (the module's own `state.js` defaults) onto `store`. Only a key that is (a)
// NOT shell-owned — the shell's own default already governs those, same rule
// `aliasShellOwnedKeys` uses for write-through — and (b) currently undefined
// on `store` is seeded, so a value a handler already wrote before this pass
// (or a declared default that is itself `undefined`) is never clobbered. The
// "currently undefined" gate also makes this idempotent across passes: once a
// key is seeded it reads defined and is never reconsidered.
const $58029952ef70329d$var$_seedDeclaredState = (project, store)=>{
    const defaults = project && project.declaredState;
    if (!defaults || typeof defaults !== 'object' || !store) return;
    const rootStateKeys = (0, $j9v8x.normalizeScopedKeys)(project.rootStateKeys || []);
    const patch = {};
    for (const key of Object.keys(defaults)){
        if ((0, $jFE3F.isShellOwnedStateKey)(key, rootStateKeys)) continue;
        if (store[key] !== undefined) continue;
        patch[key] = defaults[key];
    }
    if (Object.keys(patch).length) store.update(patch);
};
// The store, or null when scoping is unavailable (no engine / no root) — every
// caller then leaves the module on the shell root, exactly as before this
// feature. `engine` is the awaited `smbls` barrel.
const $58029952ef70329d$var$_moduleStateFor = (project, root, engine)=>{
    if (!project || project.id == null || !root) return null;
    const rootStateKeys = (0, $j9v8x.normalizeScopedKeys)(project.rootStateKeys || []);
    const hit = $58029952ef70329d$var$_moduleStateCache.get(project.id);
    if (hit && hit.shellRoot === root) {
        // Re-sync on every pass: a shell `clean()`/`replace()` that dropped a
        // signal would otherwise leave this store holding an orphan, and a module
        // may declare a `prefix*` opt-in whose live matches grew since last pass.
        (0, $jFE3F.aliasShellOwnedKeys)(hit.store, root, engine, rootStateKeys);
        return hit.store;
    }
    const store = (0, $jFE3F.createModuleStateRoot)(root, engine, {
        rootStateKeys: rootStateKeys
    });
    if (!store) return null;
    // Fresh store — inject-time seeding happens exactly once here; a later
    // cache hit above never re-enters this branch for the same module+root.
    $58029952ef70329d$var$_seedDeclaredState(project, store);
    $58029952ef70329d$var$_moduleStateCache.set(project.id, {
        shellRoot: root,
        store: store
    });
    return store;
};
// The live store for a module, without building one (render-time callers).
const $58029952ef70329d$var$_liveModuleState = (projectId, root)=>{
    if (projectId == null) return null;
    const hit = $58029952ef70329d$var$_moduleStateCache.get(projectId);
    if (!hit) return null;
    if (root && hit.shellRoot !== root) return null;
    return hit.store;
};
// The keys that GENERATE a `typography`/`spacing` sequence. Stripped from a
// module's own design system so the shell's sequence is the only one in play —
// recursively, because a media block (`'@screenS': { base, ratio }`) restates
// the same generators for one breakpoint. A block left empty is dropped: the
// shell's block for that key then inherits whole.
const $58029952ef70329d$var$_SCALE_GENERATOR_KEYS = [
    'base',
    'ratio',
    'subSequence',
    'range'
];
const $58029952ef70329d$var$_withoutScaleGenerators = (family)=>{
    if (!family || typeof family !== 'object' || Array.isArray(family)) return family;
    const out = {
        ...family
    };
    for (const key of $58029952ef70329d$var$_SCALE_GENERATOR_KEYS)delete out[key];
    for (const key of Object.keys(out)){
        if (key.charAt(0) !== '@') continue;
        const block = $58029952ef70329d$var$_withoutScaleGenerators(out[key]);
        if (block && typeof block === 'object' && !Array.isArray(block) && !Object.keys(block).length) delete out[key];
        else out[key] = block;
    }
    return out;
};
const $58029952ef70329d$var$_moduleDsCtxCache = new Map() // project.id → { ctx, modCtx, wrappedPages }
;
const $58029952ef70329d$var$_ensureModuleDsContext = async (ctx, project, root)=>{
    if (!project || !project.designSystem) return null;
    const hit = $58029952ef70329d$var$_moduleDsCtxCache.get(project.id);
    if (hit && hit.ctx === ctx) return hit.modCtx;
    try {
        const { createConfig: createConfig, pushConfig: pushConfig, popConfig: popConfig, init: init, changeGlobalTheme: changeGlobalTheme } = await $58029952ef70329d$var$_dsDeps();
        if (typeof createConfig !== 'function' || typeof init !== 'function') // Older published smbls without the scratch re-exports — soft-fail:
        // the module renders with shell tokens, same as before the feature.
        throw new Error('smbls build lacks createConfig/init re-exports');
        const key = 'wsmod-' + String(project.id).replace(/[^a-zA-Z0-9]/g, '').slice(0, 16);
        // NO cleanBase: an in-shell module page composes SHELL components
        // (AppPage/AppSidebar chrome and friends) whose props use SHELL tokens —
        // an isolated clean-base config made those throw at createChildren
        // ("Unresolvable design-system token \"radiusCard\"", observed live) and
        // the whole page subtree stayed blank. Inheriting the ACTIVE (shell)
        // processed config gives every shell token as fallback while the
        // module's own tokens deep-merge OVER it and win on collision.
        // In-shell semantics: the module's OWN app flags (useVariable, useReset,
        // useDocumentTheme, …) describe how it boots STANDALONE and must not run
        // inside the shell — set() spreads the config back OVER init's options,
        // so a truthy flag in the published designSystem blob silently overrides
        // the explicit `false` passed to init below. Observed live (2026-08-12):
        // bellforge's `useVariable: true` re-enabled var injection inside init,
        // and its `[data-theme]` var blocks landed UNSCOPED in the document —
        // overriding the shell's global --theme-* table with var() references
        // that only resolve module-side. Every shell surface reading --theme-*
        // (context menus, dialogs, board widgets) painted transparent, in the
        // module's workspace only.
        const ds = {
            ...project.designSystem
        };
        for (const flag of [
            'useVariable',
            'useReset',
            'useFontImport',
            'useIconSprite',
            'useSvgSprite',
            'useDocumentTheme',
            'useDefaultIcons',
            'globalTheme',
            'themeRoot',
            'verbose'
        ])delete ds[flag];
        // The SHELL owns the type and spacing SCALE, at every breakpoint
        // (CORE-ORG-CREATE-PROJECT-SEEDS-DESIGN-TOKENS-THAT-OVERRIDE-SHELL-1).
        // A module page renders INSIDE shell chrome, so a letter must mean the
        // same pixel value on both sides of the seam; a module that generates its
        // own sequence renders at a scale the surrounding shell does not share.
        // The common case is not even a deliberate choice: a project created
        // through the org route declares no design system at all, and the server's
        // head read materializes `DESIGNSYSTEM_DEFAULTS` onto the empty namespace
        // (typography base 16 / ratio 1.25, spacing base 16 / ratio 1.618) — so
        // every such module arrived carrying a scale its author never wrote. Live
        // on my.symbols.app/w/shaker/default 2026-10-17 against the brand's
        // base 17 / ratio 1.2; clearing the token groups in the module's own
        // version 1.0.2 was the workaround this strip replaces.
        // Same class as `useVariable` and the theme mode above: dropping the
        // generators lets `createConfig`'s deep merge fill them from the shell
        // base it already inherits. Everything else in the two families —
        // `templates`, `unit`, `h1Matches`, a module's own keys — still belongs to
        // the module.
        for (const family of [
            'typography',
            'spacing'
        ])if (ds[family]) ds[family] = $58029952ef70329d$var$_withoutScaleGenerators(ds[family]);
        // Media keys come from the HOST config this function holds, not from the
        // ambient one. `createConfig` without cleanBase inherits whatever
        // `getActiveConfig()` returns at call time — the top of the global config
        // stack, else the factory's active entry — and nothing ties that to
        // `ctx.designSystem`, the shell config the loader actually passes in. When
        // the ambient base is the framework default rather than the shell, every
        // default key (`mobileL`, `light`, `dark`) still inherits and only the
        // BRAND-only keys vanish: `appMobile` (`@container app-surface …`, brand
        // designSystem/media.js, absent from default-config) then compiled to a
        // theme selector and the module emitted zero `@container` rules (aihouse
        // admin, 2026-09-22; the module restated `appMobile` in its own media
        // file to get it back). So every host media key the module did not
        // declare is filled here; a module key always wins.
        const hostMedia = ctx && ctx.designSystem && ctx.designSystem.media;
        if (hostMedia && typeof hostMedia === 'object') {
            const ownMedia = ds.media && typeof ds.media === 'object' ? ds.media : {};
            ds.media = {
                ...hostMedia,
                ...ownMedia
            };
        }
        const cfg = createConfig(key, ds);
        cfg.__domDocument = globalThis.document;
        // Pinned BEFORE init, not only after: createConfig re-seeds the mode
        // flag from the framework default (true), and set() reads the spread
        // config over init's options — the injection gate inside init() only
        // sees false when the config itself carries it.
        //
        // Scheme-keyed tokens ARE supported here since scratch 3.14.778
        // (WS-MODULE-THEME-RULES-EMPTY-ON-DEPLOYED-SHELL-1). Before it, this
        // literal compile stored the scalar `{ var: '--theme-X' }` for every
        // theme name the module context saw — its own AND the shell's, since
        // createConfig runs without cleanBase — and the emitted rule body was
        // the invalid declaration `var: --theme-X`, which browsers drop: every
        // module surface painted with `theme:` rendered transparent. A module
        // may now ship its own `designSystem/theme.js`: its OWN entries inline
        // as `light-dark(...)` (module vars are never injected into the shared
        // document, so a reference would not resolve), and an INHERITED shell
        // entry keeps the host's `var(--theme-X-…)` refs, which the shell does
        // inject. Locked by workspaceProjects.moduleThemeRule.test.js.
        cfg.useVariable = false;
        // Thread the HOST's resolved theme mode into the module config — pinned
        // on the config like useVariable above, and for the same reason.
        //
        // The strip list above deletes the module's OWN `globalTheme` (its
        // standalone boot flag must not run in-shell) but that left the module
        // config with NO globalTheme at all, and scratch's set() treats that as
        // 'auto': it stamps `data-theme` on the SHARED documentElement straight
        // from `matchMedia('(prefers-color-scheme: dark)')` and installs a
        // listener. So ~10s into boot, when the module DS initialised, it
        // OVERWROTE the shell's forced theme with the OS value — measured live on
        // app.bellforge.eu: root state light, `data-theme` dark, and even an
        // explicit `?globalTheme=light` ended dark once the module landed.
        //
        // Scratch has an owner-guard for exactly this (a late 'auto' config
        // ADOPTS an already-governed root). That guard now SHIPS: published
        // @symbo.ls/scratch 3.14.778 carries `__smblsThemeRootOwner` beside the
        // auto-stamper `__prefersListener` (measured 2026-09-22 on the published
        // tarball, which is byte-identical to the local dist the dev shell
        // serves). Threading the host mode stays correct regardless: it makes
        // scratch take its forced branch and stamp the same value the shell
        // already set — idempotent, listener-free, right on old and new builds.
        //
        // 'auto' is deliberately NOT threaded: under auto the OS legitimately
        // decides, the module's stamp equals the shell's, and forcing a resolved
        // value would freeze an OS flip mid-session.
        //
        // WS-THEME-BOOT-WRONG-MODE-1 (2026-08-21): this creation-time read is the
        // FAST PATH only — it races the shell's theme seed, so the module config
        // also FOLLOWS the host from here on (`_followHostTheme` below). The mode
        // of record is the LIVE root state (`root.themeMode`, what ThemeToggle /
        // the prefs reconcile / the storage event write); `ctx.state` is smbls'
        // boot-seed SNAPSHOT (prepareState copies it into the root state and
        // never writes back), kept only as the pre-create fallback.
        const hostThemeMode = $58029952ef70329d$var$_hostThemeModeOf(root, ctx);
        if (hostThemeMode === 'light' || hostThemeMode === 'dark') cfg.globalTheme = hostThemeMode;
        pushConfig(cfg);
        try {
            // init/set MUTATE the config they operate on and do not reliably
            // return it — `cfg` (pushed AND passed via options.config) is the
            // processed, `_scratchConfig`-marked object; anything else fails
            // pushConfig's marker check downstream and the threading silently
            // no-ops (the first live symptom of exactly that: dsMarked=false).
            init(cfg, {
                key: key,
                document: globalThis.document,
                config: cfg,
                scopeSelector: `[data-smbls-module="${key}"]`,
                useReset: false,
                useFontImport: false,
                useDocumentTheme: false,
                useVariable: false,
                useIconSprite: false,
                useSvgSprite: false,
                useDefaultConfig: true
            });
        } finally{
            popConfig();
        }
        // Literal-value resolution, enforced ON THE CONFIG: getColor returns
        // `var(--color-X)` whenever CONFIG.useVariable is truthy, and the module
        // config's vars are never injected into the document — the class would
        // paint transparent. The init option alone does not reliably survive
        // onto the config object (observed live: _bg-var--color-navy, computed
        // rgba(0,0,0,0)).
        cfg.useVariable = false;
        // ONE context per module: the DS config rides the SAME object that already
        // carries the module's own component/function overlays, so a module page
        // never has to choose between its tokens and its own function names.
        const modCtx = $58029952ef70329d$export$2d3738f8ae4966e8(ctx, project) || Object.create(ctx);
        modCtx.designSystem = cfg;
        $58029952ef70329d$var$_moduleDsCtxCache.set(project.id, {
            ctx: ctx,
            modCtx: modCtx,
            root: root
        });
        $58029952ef70329d$var$_followHostTheme({
            pushConfig: pushConfig,
            popConfig: popConfig,
            changeGlobalTheme: changeGlobalTheme
        });
        return modCtx;
    } catch (e) {
        console.warn("[workspaceModule] design-system processing failed \u2014 module renders with shell tokens:", e && e.message);
        return null;
    }
};
// WS-THEME-BOOT-WRONG-MODE-1 — the module config FOLLOWS the host theme mode.
//
// Threading the host mode into the module config at creation (the block in
// `_ensureModuleDsContext` above) is necessary but not sufficient: it RACES
// the shell's theme seed. bootShell seeds the mode only after the prefs
// pre-flight resolves, and the module project fetch is fired in the same
// tick as that pre-flight. Measured 2026-08-21 on ONE bundle
// (workspace.f7f0f762.js, identical bytes on dev.my and staging.my):
//   dev.my    — /core/projects/key/bellforge/bellforge-app landed 90 ms
//               BEFORE /core/prefs/user → module config created with no host
//               mode → scratch set() took its 'auto' branch → stamped the OS
//               value (dark) over the shell's forced light and installed its
//               own prefers listener. Live: module config {globalTheme:'auto',
//               resolvedTheme:'dark', __prefersListener:true}, root state
//               themeMode:'light', shell frame dark, module cards light,
//               "54" ink #D9A521 (dark-tone) inline on white — the reported
//               "loads dark, partly light" page.
//   staging.my — prefs first → module config {globalTheme:'light'} → light.
// Same bytes, opposite outcome: a race, not a build. The snapshot ALSO froze
// a module at the mode it was created under — a later ThemeToggle / prefs
// reconcile / storage-event `changeGlobalTheme` moved the shell config only.
//
// Follower: every `data-theme` write on the shared root (the shell's forced
// boot write, a toggle, the reconcile, a storage event, an OS flip) re-reads
// the HOST mode and re-threads every cached module config through scratch's
// own `changeGlobalTheme(mode, cfg)` when config or attribute disagree — the
// same instrument `watchThemeResolved` (shared/functions/themeResolved.js)
// uses for `state.themeResolved`. Idempotent by construction: a re-thread
// writes the attribute the host already holds, so the next observer pass
// finds config and attribute equal and stops. A stale module prefers
// listener (installed by an 'auto' pass on a scratch without the theme-root
// owner guard, smbls 2fd42c892 unpublished) is neutralised the same way: its
// OS write disagrees with a forced host and is re-threaded back.
//
// Mode of record: the LIVE root state (`root.themeMode`). `ctx.state` is the
// boot-seed snapshot (smbls prepareState copies it into the root state and
// never writes back) and is only a pre-create fallback.
const $58029952ef70329d$var$_hostThemeModeOf = (root, ctx)=>{
    const live = root && typeof root === 'object' ? root.themeMode : null;
    const seed = ctx && ctx.state ? ctx.state.themeMode : null;
    const mode = live === 'light' || live === 'dark' || live === 'auto' ? live : seed;
    return mode === 'light' || mode === 'dark' || mode === 'auto' ? mode : null;
};
let $58029952ef70329d$var$_dsThemeDeps = null;
let $58029952ef70329d$var$_hostThemeObserver = null;
const $58029952ef70329d$var$_syncOneModuleDsTheme = (hit)=>{
    const cfg = hit && hit.modCtx && hit.modCtx.designSystem;
    const host = $58029952ef70329d$var$_hostThemeModeOf(hit && hit.root, hit && hit.ctx);
    if (!cfg || !host || !$58029952ef70329d$var$_dsThemeDeps) return false;
    const forced = host === 'light' || host === 'dark';
    const doc = globalThis.document;
    const el = doc && doc.documentElement;
    const attr = el && typeof el.getAttribute === 'function' ? el.getAttribute('data-theme') : null;
    if (cfg.globalTheme === host && (!forced || attr === host)) return false;
    const { pushConfig: pushConfig, popConfig: popConfig, changeGlobalTheme: changeGlobalTheme } = $58029952ef70329d$var$_dsThemeDeps;
    pushConfig(cfg);
    try {
        changeGlobalTheme(host, cfg);
    } finally{
        popConfig();
    }
    return true;
};
const $58029952ef70329d$export$1932b5400a86cc44 = ()=>{
    let n = 0;
    for (const hit of $58029952ef70329d$var$_moduleDsCtxCache.values())try {
        if ($58029952ef70329d$var$_syncOneModuleDsTheme(hit)) n++;
    } catch (e) {
        console.warn('[workspaceModule] host theme re-thread failed:', e && e.message);
    }
    return n;
};
const $58029952ef70329d$var$_followHostTheme = (deps)=>{
    $58029952ef70329d$var$_dsThemeDeps = deps;
    if ($58029952ef70329d$var$_hostThemeObserver || typeof MutationObserver === 'undefined') return;
    const doc = globalThis.document;
    const el = doc && doc.documentElement;
    if (!el || typeof el.setAttribute !== 'function') return;
    $58029952ef70329d$var$_hostThemeObserver = new MutationObserver(()=>{
        $58029952ef70329d$export$1932b5400a86cc44();
    });
    $58029952ef70329d$var$_hostThemeObserver.observe(el, {
        attributes: true,
        attributeFilter: [
            'data-theme'
        ]
    });
};
// Wrap every module page def with the module DS context — cached alongside
// the context so re-passes hand the SAME objects to every resolver. The
// `context` property is NON-ENUMERABLE on purpose (fingerprint + clone
// safety); element create reads `definition.context` directly, which works
// regardless of enumerability.
//
// IMPORTANT: the wrapped defs can NEVER ride root state — root.update deep-
// clones, and a clone strips the non-enumerable context (and would cycle on
// the scratch config if it were enumerable). The PageSlot's home resolver
// (_appPageFor via root._slotResolve) therefore consults the LIVE map below
// (getModulePageDef) instead of the cloned workspaceProject.pages stash.
let $58029952ef70329d$var$_liveModulePages = null;
const $58029952ef70329d$export$a5a7185d91a2c7c7 = (path)=>$58029952ef70329d$var$_liveModulePages && $58029952ef70329d$var$_liveModulePages[path] || null;
// Cross-chunk safety: main.js's home resolver can live in a DIFFERENT bundle
// instance of this module (observed live 2026-08-11: inject ran and ctx.pages
// carried wrapped defs, yet the resolver's imported getModulePageDef saw
// null). The loader therefore ALSO installs a getter CLOSURE on the state
// root each pass — the closure carries THIS instance's map regardless of
// chunking; root.update clones drop functions harmlessly and the next pass
// reinstalls.
const $58029952ef70329d$var$_installLiveGetter = (root)=>{
    if (!root) return;
    try {
        root._modulePagesLiveGet = ()=>$58029952ef70329d$var$_liveModulePages;
        // Live module-FUNCTION getter — the home board's widget resolver
        // (pages/main.js _allModuleWidgetsFor) evaluates a widget's optional
        // `visibleFn` gate through this, so a module can persona-scope its own
        // home widgets without the shell knowing any persona model. Same
        // cross-chunk closure contract as the two getters around it.
        // `ownerId` (the widget's owning module) resolves the name in THAT
        // module's own scope, own property only — two apps may name the same
        // gate function, and the root bag keeps only the first copy
        // (moduleSwitchHookOwnScope.test.js). No owner, or an owner with no
        // module scope: the root bag, as before.
        root._moduleFnGet = (name, ownerId)=>{
            const scoped = $58029952ef70329d$var$_ownerScopeFns(ownerId);
            if (scoped) {
                const own = Object.prototype.hasOwnProperty.call(scoped, name) ? scoped[name] : null;
                return typeof own === 'function' ? own : null;
            }
            const c = $58029952ef70329d$var$_ctx(root);
            const f = c && c.functions ? c.functions[name] : null;
            return typeof f === 'function' ? f : null;
        };
        // Same cross-chunk closure trick for the module DS context itself: the
        // home board mounts MODULE WIDGET bodies (`_mountModuleWidgetBody` in
        // pages/main.js) under the SHELL config — module tokens inside a widget
        // silently dropped (the exact failure _ensureModuleDsContext documents
        // for pages, previously unfixed for widgets). The board reads this
        // getter to attach the module context to widget body defs.
        // Also the carrier of the module's own component/function overlays now, so
        // a widget body mounted under it resolves the module's `natEnsureLoaded`
        // rather than whichever same-named app registered into root first. A
        // DS-less module has no entry in the DS cache but always has a scope.
        root._moduleDsCtxGet = (projectId)=>{
            if (projectId == null) return null;
            const hit = $58029952ef70329d$var$_moduleDsCtxCache.get(projectId) || $58029952ef70329d$var$_moduleScopeCache.get(projectId);
            return hit && hit.modCtx || null;
        };
        // WS-MODULE-STATE-SCOPE-1 — same cross-chunk closure contract for the
        // module's STATE root. The scope itself travels on the module CONTEXT (a
        // plugin — see moduleStateScope.js), so no mount point needs this; it is
        // for SHELL code that must READ a module's live data without being inside
        // it. Today that is `uiCatalog.buildUiCatalog`, which reports each module's
        // declared stateKeys to the assistant and would otherwise read the shell
        // store and report every loaded slice as empty. Returns null for an
        // unscoped module, and every caller falls back to the shell root.
        root._moduleStateGet = (projectId)=>$58029952ef70329d$var$_liveModuleState(projectId, root);
    } catch (e) {
    /* sealed root — resolver falls back to the import path */ }
};
// Append the composer-latch error plugin to a module context's OWN plugin
// list, once. Inherited plugins (the shell's) stay in front, exactly like
// attachModuleStateScope builds its list.
const $58029952ef70329d$var$_attachComposerErrorPlugin = (modCtx, root)=>{
    if (!modCtx || !root) return;
    const own = Object.prototype.hasOwnProperty.call(modCtx, 'plugins') ? modCtx.plugins : null;
    const list = Array.isArray(own) ? own : Array.isArray(modCtx.plugins) ? [
        ...modCtx.plugins
    ] : [];
    if (list.some((p)=>p && p.__moduleComposerLatch === root)) return;
    // A plugin bound to a replaced shell root (the switch pipeline can swap the
    // root store) is dropped, not kept beside the new one.
    const kept = list.filter((p)=>!(p && p.__moduleComposerLatch));
    modCtx.plugins = [
        ...kept,
        (0, $984mC.buildModuleComposerErrorPlugin)(root)
    ];
};
const $58029952ef70329d$export$82b02b58ffdd9aec = async (ctx, project, root)=>{
    const pages = project.pages || {};
    // A module with NO design system still needs its own resolution scope — the
    // cross-app function collision (natEnsureLoaded) has nothing to do with
    // tokens. So the DS context is the preferred carrier when there is one, and
    // the plain scope is the carrier otherwise; both are the same object shape
    // and both are prototype-chained to the shell context.
    const dsCtx = ctx ? await $58029952ef70329d$var$_ensureModuleDsContext(ctx, project, root) : null;
    const modCtx = dsCtx || $58029952ef70329d$export$2d3738f8ae4966e8(ctx, project);
    if (!modCtx) return pages;
    // WS-MODULE-STATE-SCOPE-1 — the module's STATE root, built on the same
    // awaited engine the DS context uses, and carried into the tree by a plugin
    // on the SAME context object that already carries the module's design system
    // and its function/component overlays. Nothing is written onto the defs: a
    // def property would be shadowed by the extends chain at the two call sites
    // that mount a module surface by name (see moduleStateScope.js). A soft
    // failure here (no engine, a non-store root) leaves every module surface on
    // the shell root, exactly as before this feature.
    const modState = await $58029952ef70329d$var$_ensureModuleStateRoot(project, root);
    if (modState) (0, $jFE3F.attachModuleStateScope)(modCtx, ctx, modState);
    else // WS-MODULE-DECLARED-STATE-NOT-SEEDED-IN-SHELL-1 — scoping declined, so
    // this module reads/writes the shell root directly (no isolation, exactly
    // the pre-WS-MODULE-STATE-SCOPE-1 behaviour). Its declared defaults still
    // deserve the same treatment every other un-scoped module key already
    // gets on this root: seed once, never touch a key already defined.
    $58029952ef70329d$var$_seedDeclaredState(project, root);
    // MODULE-SHELL-COMPOSER-1 — a lifecycle error inside a module page that
    // hid the shell composer releases that page's latch (moduleShellComposer.js).
    // Same carrier as the state scope: a plugin on the module context, appended
    // once, never a def property.
    $58029952ef70329d$var$_attachComposerErrorPlugin(modCtx, root);
    const hit = $58029952ef70329d$var$_moduleDsCtxCache.get(project.id) || $58029952ef70329d$var$_moduleScopeCache.get(project.id);
    if (hit && hit.modCtx === modCtx && hit.wrappedPages) {
        // WS-MODULE-PAGE-SCOPE-SNAPSHOT-STALES-A-LATE-HELPER-1 — a page that
        // declares its own `scope:` (below) got a MINT-TIME COPY of
        // modCtx.globalScope merged with its own keys, frozen into this cached
        // wrappedPages entry forever. _moduleScopeFor's cache-hit refresh keeps
        // modCtx.globalScope itself fresh — every OTHER wrapped page already
        // sees that, because its `w.scope` is a LIVE REFERENCE to that same
        // object — but a page with its own scope got a COPY, and a copy never
        // reads modCtx.globalScope again once cached. A key whose usable value
        // arrives after the first wrap (a helper revived from its published
        // string form) then stayed stale forever, only on pages that declare
        // their own scope. Refresh those copies' globalScope-sourced keys the
        // same way modCtx.globalScope itself is refreshed: a key the page's OWN
        // `scope:` declares is never touched, so a page-level override still
        // wins.
        for (const [path, w] of Object.entries(hit.wrappedPages)){
            const def = pages[path];
            if (!def || typeof def.scope !== 'object' || def.scope === null) continue;
            for (const [k, v] of Object.entries(modCtx.globalScope))if (!Object.prototype.hasOwnProperty.call(def.scope, k)) w.scope[k] = v;
        }
        return hit.wrappedPages;
    }
    const wrapped = {};
    for (const [path, def] of Object.entries(pages)){
        const w = {
            ...def
        };
        Object.defineProperty(w, 'context', {
            value: modCtx,
            enumerable: false
        });
        // WS-MODULE-CTX-DROPS-APP-GLOBALSCOPE-1 (live leg) — the context carrier
        // alone never reaches `el.scope`: element/create.js bases scope on
        // `ancestorScope || context.globalScope`, and a module page always HAS an
        // ancestor scope (the shell's), so `__scope` reads inside the app's
        // published functions still resolved the SHELL chain (measured live on
        // prod b8b4b820: ctx.globalScope owned NAT_COLLECTIONS, el.scope did not).
        // `scope` on the def makes create.js mint the page's OWN scope store with
        // the app bag as own keys and the ancestor chain as live fallback. It must
        // be ENUMERABLE — the router mounts `{ ...content }`, which drops
        // non-enumerable keys (`context` pays for that with _routeTableDef); the
        // bag is plain data, so def fingerprints (_publishFp) stay stringifiable.
        if (modCtx.globalScope) w.scope = def && typeof def.scope === 'object' && def.scope !== null ? Object.assign({}, modCtx.globalScope, def.scope) : modCtx.globalScope;
        wrapped[path] = w;
    }
    if (hit) hit.wrappedPages = wrapped;
    return wrapped;
};
// Build (or refresh) one module's state root, awaiting the SAME `smbls` chunk
// the module design system already awaits — no second import, and therefore no
// second reactive engine introduced by this feature. Whether the engine it
// hands back is the one that OWNS the shell root is not assumed:
// `createModuleStateRoot` proves it and declines loudly when it is not (see
// moduleStateScope.js's one-engine note).
const $58029952ef70329d$var$_ensureModuleStateRoot = async (project, root)=>{
    if (!project || project.id == null || !root) return null;
    try {
        return $58029952ef70329d$var$_moduleStateFor(project, root, await $58029952ef70329d$var$_dsDeps());
    } catch (e) {
        console.warn("[workspaceModule] state scoping unavailable \u2014 module writes stay on the shell root:", e && e.message);
        return null;
    }
};
// MODULE-ROUTE-CTX (tickets/fable.md ~5129): a copy of a wrapped module page
// def SAFE for the smbls auto-router's own merge. `router()`
// (smbls/plugins/router/index.js) matches `element.routes[path]`, then does
// `nextContent = { ...contentStyles, ...content }` before `element.set(
// nextContent, …)` — for EVERY navigation that reaches this table (a hard
// URL load's initial render, a top-navbar tab's `el.router()` SPA nav, and
// popstate). A plain object spread copies only OWN ENUMERABLE properties, so
// `def.context` — deliberately non-enumerable in `_wrapModulePages` above
// (clone/fingerprint defense: these defs can never ride root state, see that
// fn's block comment) — never survives into the router's `nextContent`, and
// the matched module page falls back to the SHELL's scratch config: dark
// shell theme, blue links, unreadable dim title (measured live 2026-08-13,
// bellforge /w/bellforge/theses hard-load + its top-navbar tabs). PageSlot.js
// hits the identical "spread drops non-enumerable props" hazard on ITS OWN
// mount spread and works around it by re-declaring `context: def.context`
// explicitly in the object literal it hands to `host.set({...})` — there is
// no equivalent shell call site inside the framework router to annotate the
// same way, so the copy handed to the ROUTE TABLE instead carries `context`
// as a normal OWN ENUMERABLE property from the start: it then survives ANY
// downstream spread, including the router's. `ctx.pages` (read by PageSlot's
// own resolver via root._slotResolve/_appPageFor) keeps the ORIGINAL
// non-enumerable-context def unchanged — this second, routes-table-only copy
// exists solely to satisfy the router's merge; DS-less modules (def.context
// absent) get back the identical `def` reference, so non-module/non-DS
// routes are byte-for-byte unchanged.
const $58029952ef70329d$var$_routeTableDef = (def)=>def && def.context ? {
        ...def,
        context: def.context
    } : def;
// ── App setup on demand (boot fix step 4b) ──────────────────────────────────
// An installed app's page wrap — its design-system context, state root and
// wrapped page defs — no longer runs inside the boot pass. The pass registers
// the app cheaply (functions, components as lazy entries, grants, navbar) and
// puts a PLACEHOLDER page on each of its paths. The wrap runs when the app is
// first opened (the placeholder renders) or in the app's own idle slice after
// the reveal, whichever comes first, and only once. design-d2's rules for the
// placeholder: it shows only on the first open, reads busy (aria-busy + a
// polite status "Opening {app}…"), routes again to the SAME URL with no new
// history entry and no scroll reset, and on a failed wrap shows the app's
// error, never an endless load. An app's home widgets publish only after its
// wrap: before it they would render with the shell's tokens.
const $58029952ef70329d$var$_appActivations = new Map();
const $58029952ef70329d$var$_appDisplayName = (project, ref)=>{
    const nav = project && project.configDefaults && project.configDefaults.navbar;
    const label = Array.isArray(nav) && nav[0] && nav[0].label;
    return String(label || project && project.name || ref && ref.key || '');
};
// The opening placeholder's marker. Non-enumerable (see _appOpeningPage): DOMQL
// key iteration, an object spread and root.update's clone never see it. A
// REGISTERED symbol, so the home's page resolver (pages/main.js _appPageFor)
// reads the same marker with no import between the two files: a marked
// placeholder in the context bag beats the project-stash copy of the app's
// page, because RENDERING the placeholder is what sets the app up
// (WS-APP-OPEN-SLOT-PLACEHOLDER-1: a navbar tab opened the stash copy in the
// page slot, against the shell design system, and the app's setup waited for
// its idle slice — +14.1 s after the click, measured live on the Unreal twin).
const $58029952ef70329d$var$_APP_OPENING = Symbol.for('symbols.workspace.appOpening');
const $58029952ef70329d$export$ae44f6f7f74edfe4 = (def)=>!!(def && def[$58029952ef70329d$var$_APP_OPENING]);
// Click-to-content time (`wsopen:<app>:*`), beside the `wsboot:app:*` spans:
// `:intent` when an opening placeholder renders (the member asked for the
// app), `:setup:start` / `:setup:end` around the page wrap, `:reopen` when the
// real page took the placeholder's place, and ONE measure `wsopen:<app>` from
// the first intent to that reopen. An app set up in its idle slice, with no
// open intent, gets the setup marks only. The measure starts and ends exactly
// ON its two marks (their own times), so the span and the marks line up in the
// timeline. Telemetry only — never throws.
const $58029952ef70329d$var$_openMarkAt = (name)=>{
    try {
        if (typeof performance === 'undefined' || typeof performance.mark !== 'function') return null;
        const mark = performance.mark(name);
        return mark && typeof mark.startTime === 'number' ? mark.startTime : performance.now();
    } catch (_) {
        return null;
    }
};
const $58029952ef70329d$var$_openIntent = (entry)=>{
    if (entry.openAt != null) return;
    const at = $58029952ef70329d$var$_openMarkAt('wsopen:' + entry.spanKey + ':intent');
    entry.openAt = at != null ? at : $58029952ef70329d$var$_spanStart();
};
const $58029952ef70329d$var$_openReopened = (entry)=>{
    const end = $58029952ef70329d$var$_openMarkAt('wsopen:' + entry.spanKey + ':reopen');
    const start = entry.openAt;
    entry.openAt = null;
    if (start == null || end == null) return;
    try {
        if (typeof performance.measure === 'function') performance.measure('wsopen:' + entry.spanKey, {
            start: start,
            end: end
        });
    } catch (_) {
    /* telemetry only */ }
};
// The real page takes the placeholder's place wherever a `set` mounted it: a
// page slot pane, a parked slot host, the second pane. `set` on the parent is
// the very call that mounted the placeholder there, so the page lands exactly
// where the placeholder was. Nothing else re-mounts a slot pane: its host is
// keep-alive (canvas components/PageSlot.js), so a re-open of the same path
// only reveals the host that is already there. The ROUTER's page is left to
// the same-URL re-route (_reopenActivatedApp): the router holds that swap for
// the leaving page's exit motion, and a second set here would race it.
//
// The page is mounted with the props the page slot forces on every page it
// mounts (PageSlot.js _mountPane -> apply): `context` explicitly — the wrapped
// def carries it NON-enumerable (_wrapModulePages) and a spread drops it; a
// plain div — a page is a <main>, and a pane must not add a second main
// landmark; no page-grid placement; full height.
// __tests__/appOpenSwapMountParity.test.js holds the two mounts together.
const $58029952ef70329d$var$_swapInAppPage = (entry, path, el)=>{
    // A placeholder that was replaced or swept meanwhile is disposed: it has no
    // parent left. One that is still mounted is its parent's `content`.
    const holder = el && el.parent;
    if (!holder || holder === entry.routedEl) return false;
    if (el.key !== 'content' || holder.content !== el) return false;
    if (typeof holder.set !== 'function') return false;
    // Disposed meanwhile: dispose() clears __ref (and node).
    if (!el.__ref) return false;
    const def = entry.ctx && entry.ctx.pages ? entry.ctx.pages[path] : null;
    if (!def || $58029952ef70329d$export$ae44f6f7f74edfe4(def)) return false;
    const swap = ()=>{
        // The holder may have moved on before the insertion.
        if (holder.content !== el) return;
        holder.set({
            ...def,
            context: def.context,
            tag: 'div',
            gridRow: null,
            gridColumn: null,
            height: '100%',
            minHeight: '100%'
        });
    };
    // NOT connected YET is not gone: smbls 3.14.84x builds an app's first view
    // detached and inserts it whole (firstRender), so a cold deep link to an app
    // that is already set up settles here before the insertion. The old guard
    // (`isConnected === false` → no swap) left that placeholder on "Opening …"
    // forever. el.whenConnected swaps now when connected, else in the task that
    // inserts the node, and never for a disposed element.
    if (typeof el.whenConnected === 'function') el.whenConnected(swap);
    else swap();
    return true;
};
// Open the app from its placeholder: the open intent, the setup (single flight,
// _activateWorkspaceApp), then the real page in the placeholder's place — or
// the error with its Retry.
const $58029952ef70329d$var$_openAppPage = (entry, path, el, s)=>{
    $58029952ef70329d$var$_openIntent(entry);
    const fail = ()=>{
        if (s && typeof s.update === 'function') s.update({
            failed: true
        });
    };
    $58029952ef70329d$export$eb600665dd60f5f(entry).then((ok)=>{
        if (ok === false) return fail();
        if ($58029952ef70329d$var$_swapInAppPage(entry, path, el)) $58029952ef70329d$var$_openReopened(entry);
    }, fail);
};
const $58029952ef70329d$var$_appOpeningPage = (entry, path)=>{
    const page = {
        tag: 'section',
        flow: 'y',
        align: 'center center',
        gap: 'A',
        minHeight: '100%',
        padding: 'C',
        state: {
            failed: false
        },
        ariaBusy: (el, s)=>s && s.failed ? 'false' : 'true',
        // "Opening Commerce…" — the app by its App Store name, in the session
        // language (Nika 2026-10-23: "app names = what a person sees in the
        // workspace App Store"). `entry.name` is the manifest's first tab
        // (_appDisplayName: "Store"); installedAppName asks THE store resolver
        // with the app's catalog identity and keeps those words for an app the
        // store ships no name for.
        Status: {
            tag: 'p',
            color: 'caption',
            role: 'status',
            ariaLive: 'polite',
            text: (el, s)=>s && s.failed ? el.call('polyglot', 'workspace.apps.loadFailed') : String(el.call('polyglot', 'workspace.apps.opening') || '').replace('{app}', el.call('installedAppName', {
                    catalogId: entry.catalogId,
                    label: entry.name
                }) || entry.name)
        },
        // A failed setup offers ONE recovery action — Retry: set the app up again,
        // here, without closing the sheet. The house error-poster action (the
        // brand Button in solid ink, on its own control scale). Its box is reserved
        // while the app opens, so the status line never moves when it appears.
        Button: {
            theme: 'primary',
            text: '{{ common.action.try_again | polyglot }}',
            visibility: (el, s)=>s && s.failed ? 'visible' : 'hidden',
            pointerEvents: (el, s)=>s && s.failed ? 'auto' : 'none',
            tabindex: (el, s)=>s && s.failed ? '0' : '-1',
            aria: {
                hidden: (el, s)=>s && s.failed ? null : 'true'
            },
            onClick: (e, el, s)=>{
                if (s && typeof s.update === 'function') s.update({
                    failed: false
                });
                $58029952ef70329d$var$_openAppPage(entry, path, el.parent, s);
            }
        },
        onRender: (el, s)=>$58029952ef70329d$var$_openAppPage(entry, path, el, s)
    };
    // The placeholder names its page: the page's own `metadata` rides on it. The
    // pane header and the tab title read a def's metadata when the pane opens,
    // and nothing reads it again when the real page takes the placeholder's
    // place — without it the pane header would show the raw path for good.
    const own = entry.project && entry.project.pages ? entry.project.pages[path] : null;
    if (own && own.metadata !== undefined) page.metadata = own.metadata;
    Object.defineProperty(page, $58029952ef70329d$var$_APP_OPENING, {
        value: true
    });
    return page;
};
// The page on screen is one of this app's paths: show the real page at the
// SAME URL — no history entry, no scroll reset. A page slot needs no re-open
// here: the placeholder it shows takes the real page itself (_swapInAppPage).
// The old slot re-open — `_canvasSlot` written null, then the same path —
// never re-mounted anything: both writes land in ONE effect flush (the signal
// engine defers effects to a microtask and a store update batches), so the
// pane saw the same path and its keep-alive revealed the host it already had.
const $58029952ef70329d$var$_reopenActivatedApp = (entry, appPages)=>{
    const { routedEl: routedEl } = entry;
    try {
        const loc = typeof window !== 'undefined' && window.location ? window.location : null;
        const pathname = loc && loc.pathname || '';
        const routePath = pathname ? (0, $7iFOV.shellStripWorkspacePrefix)(pathname) : '';
        if (routePath && appPages[routePath] && routedEl && typeof routedEl.router === 'function') {
            const nav = routedEl.router(pathname + (loc && loc.search || '') + (loc && loc.hash || ''), routedEl, {}, {
                pushState: false,
                scrollToTop: false
            });
            // The router may hold the swap for the leaving page's exit motion.
            Promise.resolve(nav).then(()=>$58029952ef70329d$var$_openReopened(entry), ()=>{});
        }
    } catch (e) {
        console.warn('[workspaceApps] re-open after setup failed', e && e.message);
    }
};
// One app's published entry, rebuilt in the list (matched by its catalog id).
// `setupFailed` rides only on an entry whose last setup failed.
const $58029952ef70329d$var$_publishAppEntry = (entry, patch)=>{
    const { root: root, catalogId: catalogId } = entry;
    const list = root && root.workspaceApps;
    if (!Array.isArray(list) || !list.some((a)=>a && a.appId === catalogId)) return;
    root.update({
        workspaceApps: list.map((a)=>{
            if (!a || a.appId !== catalogId) return a;
            const next = {
                ...a,
                ...patch
            };
            if (!patch.setupFailed) delete next.setupFailed;
            return next;
        })
    });
};
const $58029952ef70329d$var$_publishActivatedApp = (entry)=>{
    const { project: project } = entry;
    if (!project || !project.widgets && !project.views && !project.forms) return;
    $58029952ef70329d$var$_publishAppEntry(entry, {
        widgets: project.widgets || null,
        pendingWidgets: null,
        views: project.views || null,
        forms: project.forms || null
    });
};
// A FAILED setup releases the home at the source (time to facts): the entry
// stops naming widgets on their way (the home would wait for them forever) and
// says its setup failed — `setupFailed: true`, since `pendingWidgets: null`
// alone reads as "set up" — so the home never asks a provider that has no
// state root and can name the app as failed. Its widgets stay null and its
// placeholder keeps the error; a later open still retries, and a success
// publishes the widgets and drops the flag. An install that is no longer
// current (a newer pass, a teardown) publishes nothing.
const $58029952ef70329d$var$_releaseFailedApp = (entry)=>{
    if ($58029952ef70329d$var$_appActivations.get(entry.ledgerId) !== entry) return;
    const list = entry.root && entry.root.workspaceApps;
    const cur = Array.isArray(list) ? list.find((a)=>a && a.appId === entry.catalogId) : null;
    if (!cur || cur.pendingWidgets == null && cur.setupFailed === true) return;
    $58029952ef70329d$var$_publishAppEntry(entry, {
        pendingWidgets: null,
        setupFailed: true
    });
};
const $58029952ef70329d$export$eb600665dd60f5f = (entry)=>{
    if (!entry) return Promise.resolve(false);
    if (entry.done) return Promise.resolve(true);
    if (entry.promise) return entry.promise;
    const run = (async ()=>{
        const { root: root, ctx: ctx, routedEl: routedEl, project: project, ledgerId: ledgerId } = entry;
        const tWrap = $58029952ef70329d$var$_spanStart();
        $58029952ef70329d$var$_mark('wsopen:' + entry.spanKey + ':setup:start');
        const appPages = await $58029952ef70329d$export$82b02b58ffdd9aec(ctx, project, root);
        $58029952ef70329d$var$_span(entry.spanKey, 'wrap', tWrap);
        $58029952ef70329d$var$_mark('wsopen:' + entry.spanKey + ':setup:end');
        if ($58029952ef70329d$var$_appActivations.get(ledgerId) !== entry) return false;
        for (const [path, def] of Object.entries(appPages)){
            const held = entry.placeholders[path];
            if (!held || ctx.pages[path] !== held) continue;
            // Read the route table BEFORE writing ctx.pages: in the live shell the
            // router's table IS ctx.pages (one object — measured on dev 2026-10-04,
            // `getRoot().routes === context.pages`), so once ctx.pages held `def`
            // the table no longer read `held` and the context-carrying copy never
            // landed. The router then mounted the app page from `def` through its
            // spread, which drops the non-enumerable `context`: every installed
            // app's ROUTE page ran on the SHELL context — its own icons painted
            // the noIcon placeholder (Storm Validators: valRefresh / valNetwork …)
            // and its own tokens fell back to the shell's
            // (MODULE-PAGE-ROUTE-MOUNTS-ON-SHELL-CONTEXT-1).
            const routeHeld = !!(routedEl && routedEl.routes && routedEl.routes[path] === held);
            ctx.pages[path] = def;
            // _routeTableDef: the router's merge spread drops a def's non-enumerable
            // `context` (MODULE-ROUTE-CTX) — the table needs it as an own property.
            if (routeHeld) routedEl.routes[path] = $58029952ef70329d$var$_routeTableDef(def);
        }
        entry.done = true;
        $58029952ef70329d$var$_publishActivatedApp(entry);
        $58029952ef70329d$var$_reopenActivatedApp(entry, appPages);
        return true;
    })();
    entry.promise = run;
    run.catch((e)=>{
        if (entry.promise === run) entry.promise = null;
        console.warn('[workspaceApps] app setup failed', entry.catalogId, e && e.message);
        try {
            $58029952ef70329d$var$_releaseFailedApp(entry);
        } catch (_) {
        /* the placeholder still shows the error */ }
    });
    return run;
};
const $58029952ef70329d$export$1c34eb2a380f5bb3 = [
    [
        'signals',
        'homeSignals'
    ],
    [
        'upcoming',
        'homeUpcoming'
    ]
];
const $58029952ef70329d$var$_homeProvidersOf = (project)=>{
    const fns = project && project.functions;
    if (!fns || typeof fns !== 'object') return [];
    return $58029952ef70329d$export$1c34eb2a380f5bb3.filter(([, name])=>Object.prototype.hasOwnProperty.call(fns, name) && typeof fns[name] === 'function').map(([kind])=>kind);
};
// After the pass every registered app sets up, one at a time — first the apps
// that feed the home (homeProviders), then apps with a widget on the saved
// board, then the rest in install order. A home feeder takes a NORMAL-priority
// task right after the pass: the home's facts wait for it, and a background
// slice comes late on a busy cold boot. Apps with visible board widgets also
// take a normal task; only the remaining apps wait for a background idle slice.
// The pass and the reveal never wait for either. The root flag
// `_appsSettingUp` stays up until the queue drains, so a saved cell keeps its
// skeleton until its app's widgets publish (no reflow).
// One macrotask that a HIDDEN page does not throttle (2026-10-02: a background
// tab sat on "Opening apps" for 143 s). Chrome clamps a hidden page's timers to
// >= 1 s (once a minute after 5 minutes) and runs no frames, so boot work must
// never wait on setTimeout / requestAnimationFrame to progress. Same order as
// the framework's mountScheduler: scheduler.yield, MessageChannel, setTimeout.
const $58029952ef70329d$var$_yieldTask = ()=>new Promise((resolve)=>{
        const sch = typeof globalThis !== 'undefined' ? globalThis.scheduler : null;
        if (sch && typeof sch.yield === 'function') {
            sch.yield().then(resolve, resolve);
            return;
        }
        if (typeof MessageChannel === 'function') {
            const ch = new MessageChannel();
            ch.port1.onmessage = ()=>{
                ch.port1.onmessage = null;
                ch.port1.close();
                ch.port2.close();
                resolve();
            };
            ch.port2.postMessage(0);
            return;
        }
        setTimeout(resolve, 0);
    });
const $58029952ef70329d$var$_pageHidden = ()=>typeof document !== 'undefined' && !!document && document.hidden === true;
// The pass's yield between app registrations. A VISIBLE page keeps the timer
// task: queued input, paint and the reveal watchdog (a timer) get their turn
// before the next app (workspaceProjects.test.js pins a switch queued that
// way). A HIDDEN page takes a task the browser does not throttle.
const $58029952ef70329d$var$_passYield = ()=>$58029952ef70329d$var$_pageHidden() ? $58029952ef70329d$var$_yieldTask() : new Promise((resolve)=>setTimeout(resolve, 0));
const $58029952ef70329d$var$_taskSlice = ()=>new Promise((resolve)=>{
        const sch = typeof globalThis !== 'undefined' ? globalThis.scheduler : null;
        if (sch && typeof sch.postTask === 'function') sch.postTask(()=>resolve(), {
            priority: 'user-visible'
        }).catch(()=>resolve());
        else if ($58029952ef70329d$var$_pageHidden()) $58029952ef70329d$var$_yieldTask().then(resolve);
        else setTimeout(resolve, 0);
    });
// A hidden page paints nothing, so an idle slice means nothing there: it takes
// a plain task (an idle callback's 2 s timeout is a throttled timer).
const $58029952ef70329d$var$_idleSlice = ()=>new Promise((resolve)=>{
        const sch = typeof globalThis !== 'undefined' ? globalThis.scheduler : null;
        if ($58029952ef70329d$var$_pageHidden()) $58029952ef70329d$var$_yieldTask().then(resolve);
        else if (sch && typeof sch.postTask === 'function') sch.postTask(()=>resolve(), {
            priority: 'background'
        }).catch(()=>resolve());
        else if (typeof globalThis !== 'undefined' && typeof globalThis.requestIdleCallback === 'function') globalThis.requestIdleCallback(()=>resolve(), {
            timeout: 2000
        });
        else setTimeout(resolve, 0);
    });
const $58029952ef70329d$var$_homeBoardIds = (root)=>{
    const ids = new Set();
    const layout = root && root.userDashboardPrefs && root.userDashboardPrefs.grid_layout;
    for (const e of Array.isArray(layout) ? layout : [])if (e && e.id) ids.add(String(e.id));
    const live = root && root._homeLayout;
    for (const e of Array.isArray(live) ? live : [])if (e && e.id) ids.add(String(e.id));
    const panels = root && root.workspaceSettings && root.workspaceSettings.home_default_panels;
    for (const id of Array.isArray(panels) ? panels : [])if (id) ids.add(String(id));
    // On a fresh board the app's widgets have not published yet. Its pending
    // ids already describe the same default-on set the home will render
    // (homePanelSet.js appDefaultWidgetIds): explicit panels intersect the
    // app's own ids; an omitted panel list means all its widgets.
    const apps = root && root.workspaceApps;
    for (const app of Array.isArray(apps) ? apps : []){
        if (!app) continue;
        const defaults = Array.isArray(app.home_default_panels) ? new Set(app.home_default_panels) : null;
        const declared = Array.isArray(app.widgets) ? app.widgets.map((w)=>w && w.id) : Array.isArray(app.pendingWidgets) ? app.pendingWidgets : [];
        for (const id of declared)if (id && (!defaults || defaults.has(id))) ids.add(String(id));
    }
    const hidden = root && root._homeHiddenWidgets;
    if (hidden) {
        for (const id of ids)if (hidden[id]) ids.delete(id);
    }
    return ids;
};
const $58029952ef70329d$var$_activationRank = (entry, boardIds)=>{
    const feeds = Array.isArray(entry.homeProviders) ? entry.homeProviders : $58029952ef70329d$var$_homeProvidersOf(entry.project);
    if (feeds.length) return 0;
    const widgets = Array.isArray(entry.project && entry.project.widgets) ? entry.project.widgets : [];
    if (widgets.some((w)=>w && boardIds.has(String(w.id)))) return 1;
    return 2;
};
let $58029952ef70329d$var$_activationQueueSeq = 0;
const $58029952ef70329d$var$_runAppActivations = async (root, onDrain)=>{
    const seq = ++$58029952ef70329d$var$_activationQueueSeq;
    const boardIds = $58029952ef70329d$var$_homeBoardIds(root);
    const pending = [
        ...$58029952ef70329d$var$_appActivations.values()
    ].filter((e)=>e.root === root && !e.done);
    pending.sort((a, b)=>$58029952ef70329d$var$_activationRank(a, boardIds) - $58029952ef70329d$var$_activationRank(b, boardIds));
    for (const entry of pending){
        await ($58029952ef70329d$var$_activationRank(entry, boardIds) < 2 ? $58029952ef70329d$var$_taskSlice() : $58029952ef70329d$var$_idleSlice());
        if (seq !== $58029952ef70329d$var$_activationQueueSeq) return;
        if ($58029952ef70329d$var$_appActivations.get(entry.ledgerId) !== entry || entry.done) continue;
        try {
            await $58029952ef70329d$export$eb600665dd60f5f(entry);
        } catch (_) {
        /* logged by _activateWorkspaceApp; the placeholder shows the error */ }
    }
    if (seq === $58029952ef70329d$var$_activationQueueSeq && typeof onDrain === 'function') onDrain();
};
const $58029952ef70329d$var$_activationsPending = (root)=>[
        ...$58029952ef70329d$var$_appActivations.values()
    ].some((e)=>e.root === root && !e.done);
const $58029952ef70329d$export$7217646781da7f5c = async (root)=>{
    const pending = [
        ...$58029952ef70329d$var$_appActivations.values()
    ].filter((e)=>e.root === root && !e.done);
    await Promise.all(pending.map((e)=>$58029952ef70329d$export$eb600665dd60f5f(e).catch(()=>false)));
    return !$58029952ef70329d$var$_activationsPending(root);
};
// ── Inject / teardown ─────────────────────────────────────────────────────────
// Currently-injected module + its context keys, so a switch can remove EXACTLY
// what it added (module-level: one app instance, one active module at a time).
// _injectedStateKeys tracks the root state keys the module seeded (declared
// stateKeys that were empty at inject time) so teardown clears exactly those.
let $58029952ef70329d$var$_activeProjectId = null;
// The workspace the active module was loaded FOR — rebound on every successful
// pass. Lets a failing LATER pass tell "the live module's own workspace hit a
// transient blip (keep it)" apart from "we're switching somewhere else (tear it
// down)"; without it every transient scope miss destroyed + re-injected a
// healthy module (2026-07-30 GreenIG duplicate-widgets loop).
let $58029952ef70329d$var$_moduleLoadedWorkspaceId = null;
let $58029952ef70329d$var$_injectedComponentKeys = [];
let $58029952ef70329d$var$_injectedFunctionKeys = [];
let $58029952ef70329d$var$_injectedPageKeys = [];
// WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — the BAGS this registration
// actually wrote into, captured AT INJECT TIME (see _captureBags).
let $58029952ef70329d$var$_injectedBags = null;
// The takeover module's translation merge ledger (_mergeModuleTranslations).
let $58029952ef70329d$var$_injectedTranslations = null;
let $58029952ef70329d$var$_injectedStateKeys = [];
// key → the DECLARED seed value it was injected with (manifest `seeds[key]`,
// or [] when undeclared). WS-SWITCH-RESET-SHAPE (tickets/opus.md workspace-
// switch enumeration, 2026-08-18): _clearState used to reset EVERY tracked
// key to a hardcoded [] — wrong-typed for a key whose declared empty value
// is null or an object: [] is empty to a .length check but TRUTHY to
// `if (!key)`, so emptiness guards saw a survivor after a switch. The reset
// now writes the correctly-typed empty per seed (see _emptyForSeed).
let $58029952ef70329d$var$_injectedStateSeeds = {};
// The takeover module's manifest `actions` + the stash object it wrote to
// root.workspaceProject — cached module-side so loadWorkspaceApps can compose
// the ONE merged action registry / AI-surface stash over takeover + additive
// apps (see _composeAiStash). Cleared with the rest of the takeover teardown.
let $58029952ef70329d$var$_takeoverActions = null;
let $58029952ef70329d$var$_takeoverStash = null;
// BOOT-RESHUFFLE F4 — identical-republish guards. The activation chain
// (project → apps → config) runs from up to four independent drivers per boot
// (boot chain, auth `_ensureWorkspaceModule`, the switch pipeline, converge
// retries); each publish used to re-render GridContainer + HeaderTabs + every
// moduleRoutes subscriber even when the content was byte-identical. A
// stringify fingerprint of the outgoing payload (functions drop out — a
// module version pins them, so data equality implies function equality)
// makes the repeat passes cheap no-ops. Publish sites additionally require
// the live root value to be PRESENT — the switch registry wipes them to
// null/sentinel, and a wiped root must republish regardless of fingerprint.
let $58029952ef70329d$var$_lastTakeoverFp = null;
let $58029952ef70329d$var$_lastAppsFp = null;
const $58029952ef70329d$var$_publishFp = (parts)=>{
    try {
        return JSON.stringify(parts);
    } catch (_) {
        return null // unfingerprintable → always republish
        ;
    }
};
// ── Additive workspace-apps (plural) ────────────────────────────────────────
// The single-module machinery above owns the ONE full-takeover module
// (`settings.workspaceModule`): skin + home panels + navbar-replace. That stays
// single by nature — one <html> design system, one home layout.
//
// `settings.workspaceApps[]` is the ADDITIVE plural: any number of apps that
// each contribute navbar entries / pages / components / a launcher tile WITHOUT
// taking the workspace over. They load in PARALLEL to the takeover module via
// loadWorkspaceApps() and keep their own per-app injection ledger so removing
// one app tears down EXACTLY its keys and leaves the others (and the shell, and
// the takeover module) intact. Keyed by appId (`owner/key`).
const $58029952ef70329d$var$_injectedByApp = new Map() // appId → { components:[], functions:[], pages:[] }
;
let $58029952ef70329d$var$_appsLoadSeq = 0;
// Outcome of the last COMPLETED loadWorkspaceApps pass — the additive-apps
// mirror of `_lastLoadOutcome` above. The takeover loader always had a
// transient-vs-definitive verdict + a converge retry; the apps loader silently
// settled EVERY pass, so a cold boot whose scope hadn't converged yet (org ↔
// workspace mismatch while a cross-org /w/<slug> URL reconciles, or a failed
// workspace-record fetch) published `workspaceApps: []` + latched
// `_appRoutesSettled` and NEVER retried — 0 of N installed apps for the whole
// session (natali 0-of-13, 2026-08-06; measured live: record eventually holds
// 13 refs, zero /core/projects fetches ever issued).
//   'idle'       — never ran (nothing expected; definitive for converge)
//   'active'     — every installed app loaded (definitive)
//   'partial'    — some apps loaded, others failed — retry without removing ready apps
//   'empty'      — settings resolved for this org's workspace and carry no app
//                  refs (definitive)
//   'unresolved' — scope not determinable this pass (no workspace, org guard
//                  blocking mid-convergence, record fetch failed) — transient
//   'error'      — refs exist but EVERY app failed to load — transient
let $58029952ef70329d$var$_lastAppsOutcome = 'idle';
const $58029952ef70329d$export$707aeefbb5f783b2 = ()=>$58029952ef70329d$var$_lastAppsOutcome;
// Synthetic ledger id for the shared capability bridges (moduleData / …), which
// are built over the UNION of all apps' grants rather than per-app so multiple
// record-using apps coexist. Tracked in _injectedByApp so teardown is uniform.
const $58029952ef70329d$var$_CAPS_LEDGER = '__apps_caps__';
// WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — the bags a registration wrote
// into, captured at INJECT time and read back at teardown.
//
// Teardown must never RE-RESOLVE the context to find where its keys live:
// `_ctx(root)` reads `root.__element.context`, and the root STATE is replaced
// under the loader on an org switch (scopes.js PHASE-1 `root.replace`) — the
// `__element` link is transiently absent, so `_ctx` returned null. The old
// teardown then deleted nothing, cleared its key list ANYWAY, and the keys were
// orphaned in the live bag with no owner: the module's next registration saw
// them as a "key collision skipped", dropped its own fresh copies, and the
// PREVIOUS tenant's module code stayed bound across the tenant boundary (25
// such warns per org return — every module-own component + function).
//
// Same mechanism as the 6a7cdafd3 caps-ledger eviction, one layer earlier: a
// key is owned by the registration that wrote it, and ownership is released
// only by really deleting it — never by losing track of the bag.
const $58029952ef70329d$var$_captureBags = (ctx, routedEl)=>({
        components: ctx && ctx.components || null,
        functions: ctx && ctx.functions || null,
        pages: ctx && ctx.pages || null,
        routes: routedEl && routedEl.routes || null
    });
// The bag to delete from: the one written at inject, else the live context's
// (an older ledger, or a registration made before the bags were captured).
const $58029952ef70329d$var$_bagOr = (bags, name, fallback)=>bags && bags[name] || fallback || null;
const $58029952ef70329d$var$_moduleTeardown = (root)=>{
    const ctx = $58029952ef70329d$var$_ctx(root);
    const comps = $58029952ef70329d$var$_bagOr($58029952ef70329d$var$_injectedBags, 'components', ctx && ctx.components);
    const fns = $58029952ef70329d$var$_bagOr($58029952ef70329d$var$_injectedBags, 'functions', ctx && ctx.functions);
    const pages = $58029952ef70329d$var$_bagOr($58029952ef70329d$var$_injectedBags, 'pages', ctx && ctx.pages);
    if (comps) for (const k of $58029952ef70329d$var$_injectedComponentKeys)delete comps[k];
    if (fns) for (const k of $58029952ef70329d$var$_injectedFunctionKeys)delete fns[k];
    if (pages) for (const k of $58029952ef70329d$var$_injectedPageKeys)delete pages[k];
    $58029952ef70329d$var$_liveModulePages = null;
    if (root && typeof root._modulePagesLiveGet === 'function') root._modulePagesLiveGet = null;
    if (root && typeof root._moduleFnGet === 'function') root._moduleFnGet = null;
    // Pull the module routes back out of the live router map so other workspaces
    // never resolve /policies, /claims, … (matches the components/functions teardown).
    const routedEl = $58029952ef70329d$var$_routedEl(root);
    const routes = $58029952ef70329d$var$_bagOr($58029952ef70329d$var$_injectedBags, 'routes', routedEl && routedEl.routes);
    if (routes) for (const k of $58029952ef70329d$var$_injectedPageKeys)delete routes[k];
    $58029952ef70329d$export$76c11bb2425194b3($58029952ef70329d$var$_injectedTranslations);
    $58029952ef70329d$var$_injectedTranslations = null;
    $58029952ef70329d$var$_injectedComponentKeys = [];
    $58029952ef70329d$var$_injectedFunctionKeys = [];
    $58029952ef70329d$var$_injectedPageKeys = [];
    $58029952ef70329d$var$_injectedBags = null;
    $58029952ef70329d$var$_activeProjectId = null;
    $58029952ef70329d$var$_moduleLoadedWorkspaceId = null;
    $58029952ef70329d$var$_takeoverActions = null;
};
// Clear the module's state footprint: the stash, any parked approval action,
// and EXACTLY the state keys this module seeded (tracked at inject) — never a
// hardcoded list, so a module's domain state can't leak across workspaces and
// shell-owned keys are never touched. Each key resets to the correctly-TYPED
// empty for its declared seed — [] for array seeds, null otherwise — NOT the
// seed itself (a seed can carry demo content, which must not survive into a
// module-less workspace) and NOT a hardcoded [] (wrong-typed for object/null
// seeds: [] is empty to .length but TRUTHY to `if (!key)`, so emptiness
// guards saw a survivor — see _injectedStateSeeds).
const $58029952ef70329d$var$_emptyForSeed = (v)=>v === undefined || Array.isArray(v) ? [] : null;
// WS-MODULE-STATE-SCOPE-1 — reset + evict ONE owner's module state store.
// Elements that still hold a reference to the outgoing store (a subtree that
// has not unmounted yet) read the declared empties instead of the previous
// tenant's rows; the eviction makes the next inject start from nothing.
// `ownerId` keys the scoped-keys REGISTRY (the takeover's project id, or an
// additive app's tenant-scoped ledger id); `projectId` keys the store (always
// the module project id). They differ for an additive app.
const $58029952ef70329d$var$_clearModuleStatePlane = (ownerId, root, projectId)=>{
    if (ownerId == null) return;
    const storeKey = projectId === undefined ? ownerId : projectId;
    const store = $58029952ef70329d$var$_liveModuleState(storeKey, root);
    if (store) try {
        const patch = (0, $j9v8x.moduleScopedWipeFor)(ownerId, store);
        if (Object.keys(patch).length) store.update(patch);
    } catch (e) {
        console.warn('[workspaceModule] module state wipe failed:', ownerId, e && e.message);
    }
    if (storeKey != null) $58029952ef70329d$var$_moduleStateCache.delete(storeKey);
};
const $58029952ef70329d$var$_clearState = (root)=>{
    const patch = {
        workspaceProject: null,
        _aiAction: null
    };
    for (const k of $58029952ef70329d$var$_injectedStateKeys)patch[k] = $58029952ef70329d$var$_emptyForSeed($58029952ef70329d$var$_injectedStateSeeds[k]);
    // WS-MODULE-SCOPED-KEYS-CONTRACT-1: the module's DECLARED scoped keys reset
    // too — regardless of the "only seed when empty" gate above (a declaration
    // means "mine"), typed-empty per live value or the declared `empty`. Same
    // patch the PHASE-1 switch wipe already spread (scopes.js) — idempotent.
    Object.assign(patch, (0, $j9v8x.moduleScopedWipeFor)($58029952ef70329d$var$_activeProjectId, root));
    // WS-MODULE-STATE-SCOPE-1 — the module's OWN state plane resets at the same
    // beat. Its rows live on its module store now, so the declared-key patch is
    // computed against THAT bag, and the store is then evicted so the next inject
    // builds a fresh one. Eviction is what makes the tenant boundary total: a
    // module that declares no `scopedKeys` used to leak its rows across a switch
    // on the shell root and would otherwise leak them on its own store instead.
    $58029952ef70329d$var$_clearModuleStatePlane($58029952ef70329d$var$_activeProjectId, root);
    (0, $j9v8x.unregisterModuleScopedKeys)($58029952ef70329d$var$_activeProjectId);
    $58029952ef70329d$var$_injectedStateKeys = [];
    $58029952ef70329d$var$_injectedStateSeeds = {};
    $58029952ef70329d$var$_takeoverStash = null;
    // Torn-down module ⇒ the next publish is never an "identical republish".
    $58029952ef70329d$var$_lastTakeoverFp = null;
    $58029952ef70329d$var$_lastAppsFp = null;
    root.update(patch);
};
// ── Ordered module teardown (BF-MODULE-UNREGISTERED-COMPONENTS-CONSOLE-1) ────
// The module's rail and home widgets are mounted by the SHELL (app.js
// `ModuleRailHost.Body.__mountModuleRail`, pages/main.js `ModuleWidgets`) but
// their factories call MODULE functions (`el.call('bfPersona', …)`). Teardown
// used to run `_moduleTeardown(root)` (delete the injected ctx.functions keys) and
// only THEN `_clearState(root)`, whose `root.update({ workspaceProject: null })`
// re-renders every `subscribeTo: ['workspaceProject']` subscriber — with the
// rail still mounted (the `__railSig` guard mounts but never unmounts). Every
// such factory then called a name deleted the same tick: measured on a
// cross-org switch away from Bellforge, 8 `is not registered` warnings, 6
// `factory threw` errors and the `reading 'accent'` TypeError (an unregistered
// call returns undefined) — 28 console errors in one pass.
//
// The order is the fix, at the layer that owns the mount: unmount the
// module-owned subtrees, publish the null state so every remaining subscriber
// re-renders module-less WHILE the functions still resolve, and only then
// delete the injected entries. Bellforge (and every other module) needs no
// defensive guard in its own call sites.
//
// `root.update` renders synchronously, so the publish has settled by the time
// `_moduleTeardown` runs — there is no tick to await.
const $58029952ef70329d$var$_unmountModuleSurfaces = (root)=>{
    const elx = root && (root.__element || root.getRoot && root.getRoot());
    const body = elx && elx.ModuleRailHost && elx.ModuleRailHost.Body;
    // Only a BUILT rail host can hold a mounted rail. The shell root's onCreate
    // kicks the first module load before the root renders its children (app.js,
    // "Kick the private-data load NOW"), and that first load tears down before it
    // injects — so on a cold boot `ModuleRailHost.Body` can still be the child
    // DEFINITION from app.js: a plain object with no node and no element methods.
    // Its `set({})` fallback threw `set is not a function` on every cold load of
    // a module workspace, and the signature write below landed on the definition
    // (functions/workspaceProjects.railUnmountBoot.test.js).
    if (!body || !body.node) return;
    // Clear the mount signature FIRST: the remount on switch-back is driven by
    // `__railSig === rail` being false, and an unmount that left the old
    // signature behind would keep the rail permanently empty.
    body.__railSig = null;
    try {
        if (typeof body.removeContent === 'function') body.removeContent();
        else body.set({});
    } catch (err) {
        console.warn('[workspaceModule] rail unmount failed:', err && err.message);
    }
};
// The ONE teardown entry point for the takeover module — every switch-away
// path calls this, never `_moduleTeardown` + `_clearState` by hand (three call sites
// used to repeat the pair, and each repeat was a chance to get the order
// wrong).
const $58029952ef70329d$var$_teardownModule = (root)=>{
    // WS-MODULE-SCOPED-KEYS-CONTRACT-1: the module's `hooks.onWorkspaceSwitch`
    // fires FIRST — its functions still resolve and its surfaces are still
    // mounted, so a late-write fence can arm before anything is torn down.
    $58029952ef70329d$var$_runModuleSwitchHook(root, $58029952ef70329d$var$_activeProjectId);
    $58029952ef70329d$var$_unmountModuleSurfaces(root);
    $58029952ef70329d$var$_clearState(root);
    $58029952ef70329d$var$_moduleTeardown(root);
};
// Resolve a hook NAME for its owner. A module owner (the takeover's project
// id, or an additive install's ledger id) resolves through ITS OWN module
// scope, own property only: two apps may name the same hook function, and the
// root bag keeps only the first copy (_injectEntries skips the rest), so a
// root lookup ran app A's release code on app B's switch
// (moduleSwitchHookOwnScope.test.js). Only an owner with no module scope
// (shell-owned) falls back to the root bag.
// The OWN function bag of a module owner — a project id (takeover, or an
// additive app's `workspaceApps[].id`) or an additive install's ledger id —
// or null for an owner with no module scope (shell-owned).
const $58029952ef70329d$var$_ownerScopeFns = (ownerId)=>{
    if (ownerId == null) return null;
    // An additive install's owner id IS its tenant-scoped ledger id.
    const ledgerId = ownerId;
    const led = $58029952ef70329d$var$_injectedByApp.get(ledgerId);
    const projectId = led && led.projectId != null ? led.projectId : ownerId;
    const hit = $58029952ef70329d$var$_moduleDsCtxCache.get(projectId) || $58029952ef70329d$var$_moduleScopeCache.get(projectId);
    return hit && hit.modCtx && hit.modCtx.functions || null;
};
const $58029952ef70329d$export$5eccf6d30791a603 = (root, ownerId)=>{
    const ctx = $58029952ef70329d$var$_ctx(root);
    const scoped = $58029952ef70329d$var$_ownerScopeFns(ownerId);
    if (scoped) return (name)=>Object.prototype.hasOwnProperty.call(scoped, name) ? scoped[name] : undefined;
    return (name)=>ctx && ctx.functions ? ctx.functions[name] : undefined;
};
// Resolve + run one owner's tenant-boundary hook (see _switchHookResolver),
// with the root ELEMENT as `this` when one exists and the root STATE as the
// first arg.
const $58029952ef70329d$var$_runModuleSwitchHook = (root, ownerId, reason = 'teardown')=>{
    if (!ownerId) return false;
    const elx = root && (root.__element || root.getRoot && root.getRoot()) || null;
    return (0, $j9v8x.runModuleSwitchHook)(ownerId, {
        resolveFn: $58029952ef70329d$export$5eccf6d30791a603(root, ownerId),
        thisArg: elx,
        root: root,
        reason: reason
    });
};
// Guarded per-bag injection with the SKIP-EXISTING-WITH-WARN collision policy:
// a module can never shadow a shell key, and only actually-set keys enter the
// injected-key arrays — so teardown is provably exact.
// Who already holds this key in the root bags? Derived from the ledgers that
// already exist — no second bookkeeping structure to keep in sync, and no
// module-scope memo to survive a tenant switch. `kind` is 'components' or
// 'functions'.
const $58029952ef70329d$var$_rootKeyOwner = (kind, key)=>{
    const takeover = kind === 'components' ? $58029952ef70329d$var$_injectedComponentKeys : $58029952ef70329d$var$_injectedFunctionKeys;
    if (takeover && takeover.indexOf(key) !== -1) return String($58029952ef70329d$var$_activeProjectId || 'workspaceModule');
    try {
        for (const [ledgerId, led] of $58029952ef70329d$var$_injectedByApp.entries()){
            const list = led && led[kind];
            if (Array.isArray(list) && list.indexOf(key) !== -1) return String(ledgerId);
        }
    } catch (_) {
    /* ledger shape is best-effort diagnostics only */ }
    return 'shell';
};
// Guarded per-bag injection with the SKIP-EXISTING-WITH-WARN collision policy
// for the ROOT bags. Since WS-MODULE-FN-NAME-COLLISION-CROSS-APP the skip is
// no longer a silent mis-binding — the module keeps its own copy in its own
// scope (see _moduleScopeFor) — so this warn is a DIAGNOSTIC, and it now names
// both sides: which module wanted the key and which one already holds it. The
// anonymous form cost a live customer a working Scheduling app because nobody
// could tell "crm and scheduling both define natEnsureLoaded" from "a module
// tried to shadow a shell key".
const $58029952ef70329d$var$_injectEntries = (bag, entries, injectedKeys, kind, owner)=>{
    for (const k of Object.keys(entries)){
        if (k in bag) {
            // The SAME binding is not a collision: the takeover bridge hands the
            // module the shell's own deep-link readers (readPageParam, …) that the
            // root already registers, and the module scope still gets them through
            // _moduleScopeFor. Read through the descriptor so a lazy root accessor
            // is never forced here. (moduleBridgeSameBindingNoCollision.test.js)
            // A shared library function that two modules link is one binding too:
            // the revive binds one library text to one function (_bindLibraryFnTexts).
            const held = Object.getOwnPropertyDescriptor(bag, k);
            const offered = Object.getOwnPropertyDescriptor(entries, k);
            if (held && offered && 'value' in held && 'value' in offered && held.value === offered.value) continue;
            // A per-app CONTRACT function (HOME_SIGNALS_CONTRACT v1: every home
            // feeder exports `homeSignals` / `homeUpcoming` under that exact name)
            // is read only from each app's OWN module scope (homeSignals.js,
            // homeNextUp.js — hasOwnProperty on the app's functions), never from
            // the root bag, so a second app's copy is by design, not a collision.
            // The names come from the contract list itself (_HOME_PROVIDER_FNS).
            if (kind === 'functions' && $58029952ef70329d$export$1c34eb2a380f5bb3.some(([, name])=>name === k)) continue;
            if (kind && owner) console.warn('[workspaceModule] key collision skipped:', k, `\u{2014} ${owner} also defines it; root keeps ${$58029952ef70329d$var$_rootKeyOwner(kind, k)}'s copy` + ` (${owner} resolves its own inside its module scope)`);
            else console.warn('[workspaceModule] key collision skipped:', k);
            continue;
        }
        // A lazy entry forwards through its own accessor (boot fix step 4): the
        // root bag reads the one revived value on first use, never at boot.
        const d = Object.getOwnPropertyDescriptor(entries, k);
        if (d && typeof d.get === 'function') Object.defineProperty(bag, k, {
            get: d.get,
            set: d.set,
            enumerable: true,
            configurable: true
        });
        else bag[k] = entries[k];
        injectedKeys.push(k);
    }
};
// ── Module translations → the shell's polyglot map ──────────────────────────
//
// A module ships its copy as `designSystem.lang` — `{ en: {...}, ka: {...} }`,
// flat undotted keys. The loader injected the module's components, functions,
// pages and design system, but nothing carried that bundle into
// `context.polyglot.translations`, the ONE map `el.call('polyglot', key)` and
// `{{ key | polyglot }}` read (smbls plugins/polyglot `translate`). Every module
// therefore seeded the map itself (aihouse/admin `ahSeedLang`, 2026-09-23), and
// a module that did not rendered its raw keys. The merge belongs here, once per
// module load, beside the other injections.
//
// The module context is `Object.create(ctx)` (see _moduleScopeFor), so its
// `polyglot` IS the shell's object — one write reaches module pages, module
// widget bodies AND the shell chrome that shows a module string (a widget title
// in the home-board header renders under the SHELL context).
//
// NON-DESTRUCTIVE: a key the host already holds is never overwritten. Shell
// keys are dotted and module keys are not, so they should never meet — the
// guard holds even when they do. EXACT TEARDOWN: every key this pass wrote is
// ledgered with its value and removed on switch-away, but only while the map
// still holds that same value; a language map the merge had to create goes
// again when it is empty (an empty `ka` map would otherwise add a language to
// `getLanguages()`). The ledger keeps the `translations` OBJECT, not the
// per-language maps: the shell's setLang/boot REPLACE `translations[lang]`
// with a spread copy, so a held per-language map would go stale.
const $58029952ef70329d$var$_isTranslationMap = (v)=>!!v && typeof v === 'object' && !Array.isArray(v);
const $58029952ef70329d$export$ebac99e278359f95 = (ctx, project)=>{
    const bundle = project && project.designSystem && project.designSystem.lang;
    const poly = ctx && ctx.polyglot;
    if (!$58029952ef70329d$var$_isTranslationMap(bundle) || !poly || typeof poly !== 'object') return null;
    if (!$58029952ef70329d$var$_isTranslationMap(poly.translations)) poly.translations = {};
    const translations = poly.translations;
    const added = [];
    const createdLangs = [];
    for (const lang of Object.keys(bundle)){
        const src = bundle[lang];
        if (!$58029952ef70329d$var$_isTranslationMap(src)) continue;
        if (!$58029952ef70329d$var$_isTranslationMap(translations[lang])) {
            translations[lang] = {};
            createdLangs.push(lang);
        }
        const target = translations[lang];
        for (const key of Object.keys(src)){
            const value = src[key];
            if (value === undefined || value === null || typeof value === 'function') continue;
            if (target[key] !== undefined) continue;
            target[key] = value;
            added.push([
                lang,
                key,
                value
            ]);
        }
    }
    return {
        translations: translations,
        added: added,
        createdLangs: createdLangs
    };
};
// Step 3a: the server `nav.lang` merges per installed app, keyed by the tenant
// ledger id, with its content hash (a changed copy re-merges).
const $58029952ef70329d$var$_navLangLedgers = new Map();
const $58029952ef70329d$var$_dropNavLang = (ledgerId)=>{
    const held = $58029952ef70329d$var$_navLangLedgers.get(ledgerId);
    $58029952ef70329d$var$_navLangLedgers.delete(ledgerId);
    if (held) $58029952ef70329d$export$76c11bb2425194b3(held.ledger);
};
const $58029952ef70329d$export$76c11bb2425194b3 = (ledger)=>{
    if (!ledger || !$58029952ef70329d$var$_isTranslationMap(ledger.translations)) return 0;
    const translations = ledger.translations;
    let removed = 0;
    for (const [lang, key, value] of ledger.added || []){
        const map = translations[lang];
        if ($58029952ef70329d$var$_isTranslationMap(map) && map[key] === value) {
            delete map[key];
            removed++;
        }
    }
    for (const lang of ledger.createdLangs || []){
        const map = translations[lang];
        if ($58029952ef70329d$var$_isTranslationMap(map) && !Object.keys(map).length) delete translations[lang];
    }
    return removed;
};
// Monotonic load token — every loadWorkspaceProject entry claims the next seq;
// after EVERY await the call re-checks it and bails if a newer load started
// (mid-flight workspace switch race: the loser must not inject/stash over the
// winner).
let $58029952ef70329d$var$_loadSeq = 0;
// ── Single-flight per loader (BOOT-RESHUFFLE F4) ────────────────────────────
// Boot fires up to four entrants at the same scope within moments of each
// other (_projectChain, auth's _ensureWorkspaceModule, onWorkspaceChange,
// converge retries) and each used to claim a fresh _loadSeq — aborting the
// pass already in flight and re-running the whole project→apps fetch chain.
// Same key + same root while a pass is IN FLIGHT → share its promise WITHOUT
// bumping the seq (no abort, no rerun). A different key (real switch, or an
// install/uninstall that patched the local settings bag first —
// workspaceApps.js, moduleConsole.js) starts a fresh pass and takes over the
// slot, so the seq/isStale supersession semantics are untouched. Single SLOT
// per loader, deliberately not a map: under the supersede model only the
// LATEST pass is ever shareable — a map would hand a doomed stale promise to
// an A→B→A switch. Slot clears on settle: this is dedupe, never a cache.
let $58029952ef70329d$var$_projectFlightKey = null;
let $58029952ef70329d$var$_projectFlight = null;
let $58029952ef70329d$var$_projectFlightRoot = null;
let $58029952ef70329d$var$_appsFlightKey = null;
let $58029952ef70329d$var$_appsFlight = null;
let $58029952ef70329d$var$_appsFlightRoot = null;
// BOOT single-flight across SEQUENTIAL entrants. The slots above share a pass
// only while it runs. A cold boot has three entrants (auth.js post-sign-in
// chain, loadPrivateData's full-record converge, loadPrivateData's boot
// chain), and on a slow boot a later entrant arrives AFTER the first pass
// settled: it then ran a second full pass, re-sent every app's channel
// resolution (getProjectByKey + listEnvironments) and flipped the loader back
// to "Opening apps…" (Unreal dev twin 2026-09-29: pass A 38.7-46.1 s, pass B
// 55.4-57.1 s, six duplicate requests). A boot entrant (`{ boot: true }`)
// reuses a DEFINITIVE settled pass for the same scope key and root. Every
// other caller (install, uninstall, console reload, converge retry) runs a
// fresh pass, and any fresh pass start clears the slot.
let $58029952ef70329d$var$_appsSettled = null;
let $58029952ef70329d$var$_projectSettled = null;
const $58029952ef70329d$var$_loaderFlightKey = (root)=>{
    const ws = root && root.workspace || {};
    const wsId = String(ws.id || ws._id || '');
    const orgId = $58029952ef70329d$var$_lc(String(root && root.org && (root.org.id || root.org._id) || ''));
    // Lean-claims boots carry no settings bag — every boot entrant keys '' for
    // both sigs and shares one chain. Flows that patch the bag locally before
    // reloading key differently on purpose: they MUST supersede.
    //
    // DECISION site (spec §5), and the one place readiness has to enter the KEY
    // itself. The sigs below cannot distinguish "no settings because the record
    // hasn't arrived" from "settings arrived and carry no module/apps" — both
    // produce `''|''`. With the dedup slot keyed on the sigs alone, the
    // pre-arrival flight and the post-arrival flight (the §6 late-arrival
    // re-render, which re-enters these loaders precisely BECAUSE the record just
    // landed) collapse into one: the second call is handed the first's promise
    // and the full record is never read. `readySig` is the disambiguator — every
    // lean entrant still shares one chain ('lean'), and the moment the record
    // completes the key flips to 'full' and supersedes it. Load-bearing for the
    // late-arrival re-render; do not fold it back into the sigs.
    //
    // The sigs themselves deliberately keep reading the RAW held bag rather than
    // the accessor's (which is null whenever !ready): the key is a fingerprint of
    // what THIS pass would see, and the local-patch-then-reload flows named above
    // must keep superseding an in-flight pass on either shape. Readiness is the
    // accessor's job; the fingerprint is not.
    const ready = $58029952ef70329d$var$shellWorkspaceSettings(root).ready;
    const readySig = ready ? 'full' : 'lean';
    const settings = ws && ws.settings || null;
    const ref = settings ? $58029952ef70329d$var$_publishedRef(settings) : null;
    const moduleSig = ref ? `${$58029952ef70329d$var$_appId(ref)}@${ref.version || ref.channel || ''}` : '';
    const appsSig = settings ? $58029952ef70329d$var$_appRefs(settings).map($58029952ef70329d$var$_appId).join(',') : '';
    return `${orgId}|${wsId}|${readySig}|${moduleSig}|${appsSig}`;
};
// Why the most recent module load REFUSED (sandboxed tier / failed audit),
// captured at the refusal points in _loadPublishedModule / _fetchAndBuildModule
// and surfaced by loadWorkspaceProject. Without this a configured-but-unloadable
// module is a silent no-op — the app just never appears, no user-facing signal
// (tickets/workspace.md WS-APPS bug #4). Reset per loadWorkspaceProject entry.
let $58029952ef70329d$var$_lastRefusal = null;
// Whether the most recent null module resolution is a DEFINITIVE content
// verdict (the payload arrived and was rejected: manifest missing, id
// mismatch — set where _normalizeManifest returns null on fetched data) as
// opposed to a TRANSIENT failure (fetch/parse/channel error) that the
// converge retry below should re-attempt. Reset per loadWorkspaceProject
// entry alongside _lastRefusal.
let $58029952ef70329d$var$_lastNullDefinitive = false;
// Outcome of the most recent COMPLETED loadWorkspaceProject pass — separates a
// DEFINITIVE result from a transient one:
//   'active'     — a module is injected and live
//   'no-module'  — the settings were RESOLVED and carry no module reference
//                  (a legitimately plain workspace — final, never retried)
//   'refused'    — the loader refused for a known policy reason (sandboxed
//                  tier / failed publish-time audit — final, never retried)
//   'error'      — a module IS referenced but its load failed (fetch/parse/
//                  channel resolution) — transient, retried by the converge
//                  loop below
//   'unresolved' — the workspace SCOPE couldn't be determined on this pass
//                  (no workspace resolved yet, org↔workspace mismatch while an
//                  org switch settles, workspace-record fetch failed) —
//                  transient, retried
// Read by auth.js's _ensureWorkspaceModule so its per-workspace latch only
// sticks on definitive outcomes. Stale (superseded-seq) passes leave it alone.
let $58029952ef70329d$var$_lastLoadOutcome = 'idle';
const $58029952ef70329d$export$5ac4065fceab2866 = ()=>$58029952ef70329d$var$_lastLoadOutcome;
// ── Cold-boot convergence retry ──────────────────────────────────────────────
// On a COLD boot the module load races the auth/scope convergence:
// root.workspace and root.org settle over SEVERAL async ticks (bootShell's
// eager fetch → auth claims tick re-lean → SDK workspaces-list fallback →
// cross-org drift heal), while loadPrivateData's boot chain runs
// loadWorkspaceProject exactly ONCE against whatever tuple happens to be
// current. Every transient miss (stale ?ws= pointer workspace, org guard
// blocking mid-convergence, a failed workspace-record fetch on token churn)
// used to settle SILENTLY into a plain workspace with no retry — while
// applyWorkspaceConfig, re-run later by other triggers, still painted the
// workspace's theme + home panels. Net effect: full module chrome, zero module
// code/data — the GreenIG "widgets render empty on sign-in" bug.
//
// This loop is the self-heal: scheduled ONLY when a pass ends transient
// ('unresolved'/'error'), it re-runs the full activation chain (project →
// apps → config) on a short backoff until the scope converges, a DEFINITIVE
// outcome lands ('active'/'no-module'/'refused'), or attempts exhaust.
// Re-entrancy safe: loadWorkspaceProject's _loadSeq + _activeProjectId dedup
// make a retry racing a genuine switch load idempotent, and the singleton
// guard collapses overlapping schedules to one loop.
let $58029952ef70329d$var$_convergeGen = 0;
let $58029952ef70329d$var$_convergeRunning = null;
let $58029952ef70329d$var$_convergeOwner = null;
const $58029952ef70329d$var$_moduleRootAlive = (root, element)=>!!root && (root.__element || null) === element && !element?.__destroyed && element?.__ref !== null && (!element?.state || (element.state.root || element.state) === root);
const $58029952ef70329d$var$_moduleOwnerCurrent = (owner)=>!!owner && owner === $58029952ef70329d$var$_convergeOwner && $58029952ef70329d$var$_moduleRootAlive(owner.root, owner.element);
// Root replacement, not a workspace change on one root, transfers retry
// ownership. Claim before either loader awaits so an older retry cannot
// advance a sequence over the replacement's current pass.
const $58029952ef70329d$var$_claimModuleOwner = (root, sdk)=>{
    if (!root) return null;
    const element = root.__element || null;
    if (!$58029952ef70329d$var$_moduleRootAlive(root, element)) return null;
    if ($58029952ef70329d$var$_convergeOwner?.root !== root || $58029952ef70329d$var$_convergeOwner.element !== element) {
        $58029952ef70329d$var$_convergeOwner = {
            root: root,
            element: element,
            sdk: sdk
        };
        $58029952ef70329d$var$_convergeGen++;
        $58029952ef70329d$var$_loadSeq++;
        $58029952ef70329d$var$_appsLoadSeq++;
        // Do not let A -> B -> A share A's cancelled promise. Payload caches
        // remain valid; only the two active pass slots lose their old owner.
        $58029952ef70329d$var$_projectFlight = null;
        $58029952ef70329d$var$_projectFlightKey = null;
        $58029952ef70329d$var$_projectFlightRoot = null;
        $58029952ef70329d$var$_appsFlight = null;
        $58029952ef70329d$var$_appsFlightKey = null;
        $58029952ef70329d$var$_appsFlightRoot = null;
        $58029952ef70329d$var$_appsSettled = null;
        $58029952ef70329d$var$_projectSettled = null;
    } else if (sdk) $58029952ef70329d$var$_convergeOwner.sdk = sdk;
    return $58029952ef70329d$var$_convergeOwner;
};
// First retry fires fast — the scope usually settles within the first second
// of boot (the very next auth tick), so a quick first attempt closes the
// visible empty-chrome window; later attempts back off for slow convergence
// (token re-mint, workspaces-list fallback). ~15s total bound.
let $58029952ef70329d$var$_convergeDelays = [
    400,
    1000,
    2000,
    4000,
    8000
];
const $58029952ef70329d$export$a27041345259150f = (delays)=>{
    $58029952ef70329d$var$_convergeDelays = delays;
};
// Browser-first sleep; unref'd under node so a pending retry never holds a
// test process open.
const $58029952ef70329d$var$_sleep = (ms)=>new Promise((resolve)=>{
        const t = setTimeout(resolve, ms);
        if (t && typeof t.unref === 'function') t.unref();
    });
const $58029952ef70329d$var$_scheduleModuleConverge = (root)=>{
    const owner = $58029952ef70329d$var$_convergeOwner;
    if (!$58029952ef70329d$var$_moduleOwnerCurrent(owner) || owner.root !== root || $58029952ef70329d$var$_convergeRunning === owner) return;
    $58029952ef70329d$var$_convergeRunning = owner;
    const gen = $58029952ef70329d$var$_convergeGen;
    const current = ()=>gen === $58029952ef70329d$var$_convergeGen && $58029952ef70329d$var$_moduleOwnerCurrent(owner) && root.signedIn !== false;
    (async ()=>{
        try {
            // The APPS loader has its own transient outcomes ('unresolved'/'error')
            // and MUST converge independently of the takeover module: a workspace
            // running only additive apps (no takeover module) ends every module
            // pass on the DEFINITIVE 'no-module' — bailing on that alone meant the
            // apps loader was never retried, permanently stranding an app-only
            // workspace whose boot pass raced the org/scope convergence at 0 loaded
            // apps (natali 0-of-13, 2026-08-06).
            // 'blocked' is deliberately ABSENT: it means every unloaded app carries a
            // content verdict, so each further pass would re-fetch the same payload
            // and refuse it again. Adding it here re-arms five wasted reload passes.
            const appsPending = ()=>[
                    'unresolved',
                    'error',
                    'partial'
                ].includes($58029952ef70329d$var$_lastAppsOutcome);
            for (const delay of $58029952ef70329d$var$_convergeDelays){
                await $58029952ef70329d$var$_sleep(delay);
                if (!current()) return;
                // A module became active (this workspace's or a switched-to one) or a
                // definitive outcome landed meanwhile — converged, stop (unless the
                // apps side is still owed a successful pass).
                if ($58029952ef70329d$var$_activeProjectId && root.workspaceProject && !appsPending()) return;
                if (($58029952ef70329d$var$_lastLoadOutcome === 'no-module' || $58029952ef70329d$var$_lastLoadOutcome === 'refused') && !appsPending()) return;
                // A real workspace switch owns the loaders while it runs — stand down
                // for this attempt; the next delay re-checks the settled state.
                if (root._wsSwitching) continue;
                const project = await $58029952ef70329d$export$d6a922b3bbd88180(root, owner.sdk);
                if (!current()) return;
                const moduleDone = !!project || $58029952ef70329d$var$_activeProjectId && root.workspaceProject || $58029952ef70329d$var$_lastLoadOutcome === 'no-module' || $58029952ef70329d$var$_lastLoadOutcome === 'refused';
                if (project || moduleDone && appsPending()) {
                    // Late activation: complete the same chain every activation path
                    // runs so widgets/navbar/apps resolve from the freshly-injected
                    // module (loadWorkspaceApps also re-runs its own settings read).
                    await $58029952ef70329d$export$54bc558f801f5f96(root, owner.sdk);
                    if (!current()) return;
                    try {
                        (0, $g7CNh.applyWorkspaceConfig)(root);
                    } catch (e) {
                        console.warn('[workspaceProject] converge applyWorkspaceConfig failed', e?.message || e);
                    }
                    // Converged only when the apps side is definitive too — otherwise
                    // keep backing off (the module memo makes the re-runs cheap).
                    if (!appsPending()) return;
                    continue;
                }
                if (moduleDone && !appsPending()) return;
            }
            if (!current()) return;
            console.warn("[workspaceProject] module scope never converged \u2014 giving up until the next trigger");
            if ($58029952ef70329d$var$_lastLoadOutcome === 'unresolved' || $58029952ef70329d$var$_lastLoadOutcome === 'error') $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'module', {
                state: 'error'
            });
            if ($58029952ef70329d$var$_lastAppsOutcome === 'unresolved') $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'apps', {
                state: 'error'
            });
            // Exhausted with a transient outcome still standing: the loaders above
            // deliberately did NOT latch `_appRoutesSettled` on those passes, and
            // nothing else will — settle it now so the '/*' catch-all's 404
            // suppression (projectRedirect.js) doesn't hide genuinely nonexistent
            // paths behind a loader forever.
            try {
                root?.update?.({
                    _appRoutesSettled: true
                }, {
                    preventFetch: true
                });
            } catch (_) {
            /* settle is best-effort */ }
        } catch (e) {
            console.warn('[workspaceProject] module converge retry failed', e?.message || e);
        } finally{
            if ($58029952ef70329d$var$_convergeRunning === owner) $58029952ef70329d$var$_convergeRunning = null;
        }
    })();
};
// Apply the active workspace's module to the live context. Async (fetch/import).
// Call BEFORE applyWorkspaceConfig so the config + pages resolve from the freshly
// applied module. Returns the normalized module (or null).
// ?page= recovery: a module page opened in the home PageSlot rides
// ?page=<route> in the URL (pages/main.js). The home page's own restore runs at
// page onCreate — usually BEFORE module pages inject (they aren't in the shared
// route map) — so re-apply it once the pages exist. Never overrides an
// already-open sheet.
//
// Called from BOTH loader paths. It used to live inline in
// `loadWorkspaceProject` only, so a workspace running additive apps (the
// `settings.workspaceApps` shape — no takeover module) never restored the
// param: every ?page=/warehouse-style deep link landed on Home and needed a
// nav click.
// Captured at bundle evaluation — BEFORE the boot router runs. The boot
// org-reconcile/normalize replaces the URL WITHOUT the query string, so by the
// time either loader below reaches _restorePageParam on a COLD deep link, the
// live location no longer carries ?page= and the restore silently no-oped
// (every cold ?page=/discover landed on Home; warm nav worked). One-shot: a
// later workspace switch must not resurrect a stale boot param.
let $58029952ef70329d$var$_bootPageParam = null;
let $58029952ef70329d$var$_bootViewAsParam = null;
// Capture is idempotent and NEVER clears an earlier capture: an empty query
// string means "nothing to read here" (the boot reconcile already rewrote
// the URL, or this is frank's node-side serialization pass), not "the param
// is absent". That rule replaces the module-level IIFE consts this file used
// to hold: an IIFE result is not statically evaluable, so the emitted
// `_restorePageParam` / `_restoreViewAsParam` read bindings the published
// payload never assigned and threw on every call
// (WORKSPACE-SHELL-FRANK-GATE-BLOCKS-REPUBLISH-1). A plain module `let` DOES
// lift into the emitted globalScope, so both loaders keep working there too:
// module-level code never runs in a published payload, hence the second
// capture call at the top of `_restorePageParam`.
const $58029952ef70329d$var$_captureBootParams = ()=>{
    try {
        const search = typeof window !== 'undefined' && window.location && window.location.search || '';
        if (!search) return;
        const q = new URLSearchParams(search);
        $58029952ef70329d$var$_bootPageParam = q.get('page') ?? $58029952ef70329d$var$_bootPageParam;
        $58029952ef70329d$var$_bootViewAsParam = q.get('viewAs') ?? $58029952ef70329d$var$_bootViewAsParam;
    } catch (_) {}
};
$58029952ef70329d$var$_captureBootParams();
let $58029952ef70329d$var$_bootPageParamUsed = false;
// ?viewAs= recovery — same shape as ?page= above, for a module's own View-as
// override (`chrome.viewAsKey`, e.g. bellforge's `bfPersonaOverride`). The
// override is a plain in-memory root-state key — it is deliberately NOT in
// WORKSPACE_SCOPED_KEYS (scopes.js), so it is not a tenant-boundary value —
// which means nothing re-seeds it after a hard reload, and any in-session
// workspace-change re-run can leave it looking reset for the brief window
// before the module's chrome republishes. Persisting the override's VALUE in
// the URL (generic — keyed by `chrome.viewAsKey`, not a module-specific
// name) makes View-as durable across BOTH a hard reload and an in-session
// re-hydration: whichever one happens, restoring here re-applies it the
// moment the module's chrome is resolvable again. The WRITE side lives in
// the shell (app.js `_syncShellRoute`) — this is the read/restore half,
// symmetric with the ?page= recovery beside it (RAIL-TRANSITION,
// tickets/fable.md).
let $58029952ef70329d$var$_bootViewAsParamUsed = false;
const $58029952ef70329d$var$_restoreViewAsParam = (root)=>{
    try {
        const key = $58029952ef70329d$export$a9b228c74739c85c(root);
        if (!key) return;
        // A live in-memory value (the user just clicked a persona chip this
        // session) always wins over a stale/boot URL param — never clobber it.
        if (root[key]) return;
        const search = typeof window !== 'undefined' && window.location && window.location.search || '';
        const liveParam = search ? new URLSearchParams(search).get('viewAs') : null;
        const value = liveParam || (!$58029952ef70329d$var$_bootViewAsParamUsed ? $58029952ef70329d$var$_bootViewAsParam : null);
        if (!value || value === 'admin') return;
        $58029952ef70329d$var$_bootViewAsParamUsed = true;
        root.update({
            [key]: value
        });
    } catch (err) {
        console.warn('[workspaceProject] ?viewAs= restore failed', err);
    }
};
// tickets/sonnet.md MODULE-TEARDOWN-1/ROOT-CALL-REF-1 — one notification per
// DISTINCT missed page param, not per re-call (this function is called from
// both loader paths and re-runs on every workspace-module publish, so a
// naive check-every-time would toast on every retry).
let $58029952ef70329d$var$_lastPageParamMissNotified = null;
const $58029952ef70329d$export$ac4776a1cef5badb = (root, pages)=>{
    try {
        $58029952ef70329d$var$_captureBootParams();
        const search = typeof window !== 'undefined' && window.location && window.location.search || '';
        const liveParam = search ? new URLSearchParams(search).get('page') : null;
        const pageParam = liveParam || (!$58029952ef70329d$var$_bootPageParamUsed ? $58029952ef70329d$var$_bootPageParam : null);
        // A1-06 — resolve the PAGE, restore the ROUTE. A module deep link carries
        // the params that identify the record it opened
        // (`?page=/vault-rooms?item=<id>`), and an exact `pages[pageParam]` lookup
        // never matches one — so a reload of a shared deep link fell through to
        // the "page not available" branch and dropped the user back on the grid.
        // Same query/hash normalization PageSlot's `_defFor` and openAppPage
        // already use; `_canvasSlot` still receives the FULL route.
        const pageParamPath = pageParam ? String(pageParam).split('?')[0].split('#')[0] : null;
        $58029952ef70329d$var$_restoreViewAsParam(root);
        if (pageParam && pages && (pages[pageParam] || pages[pageParamPath]) && !root._canvasSlot) {
            $58029952ef70329d$var$_bootPageParamUsed = true;
            $58029952ef70329d$var$_lastPageParamMissNotified = null;
            root.update({
                _canvasSlot: pageParam
            });
            return;
        }
        // Immersive landing: a member the module's chrome manifest puts in
        // immersive mode never sees the bare home board — no ?page= to restore
        // means they land on the module's own landing page (which carries the
        // module rail), on '/' only (a direct module ROUTE load keeps its page).
        if (!root._canvasSlot && $58029952ef70329d$export$8a84674485ee3e88(root)) {
            const landing = $58029952ef70329d$export$a69f284518eb2ae9(root);
            if (landing && pages && pages[landing]) {
                root.update({
                    _canvasSlot: landing
                });
                return;
            }
        }
        // A ?page= that never matches ANY installed route used to fail here
        // completely silently — no error, no notice, the caller's own default
        // (Home) renders with zero explanation (measured live: a bare load on
        // `?page=/theses` picked a workspace with 0 installed apps and landed on
        // Home with nothing telling the user why). `root._appRoutesSettled` is
        // the "route injection for this workspace is DEFINITELY complete" latch
        // (workspaceApps.js/auth.js) — checking it here is load-bearing, not
        // decoration: without it, a page that simply hasn't injected YET (the
        // exact race this function's per-loader recall already exists to
        // handle) would wrongly report "not available" before its own retry
        // ever got a chance to resolve it.
        if (pageParam && root && root._appRoutesSettled === true && !root._canvasSlot && $58029952ef70329d$var$_lastPageParamMissNotified !== pageParam) {
            $58029952ef70329d$var$_lastPageParamMissNotified = pageParam;
            try {
                root.call?.('openNotification', {
                    title: root.call?.('polyglot', 'workspace.apps.pageMissing'),
                    message: (root.call?.('polyglot', 'workspace.apps.pageMissingBody') || '').replace('{page}', pageParam),
                    type: 'error'
                });
            } catch (e) {
            /* the notification surface isn't reachable from the loader context */ }
        }
    } catch (err) {
        console.warn('[workspaceProject] ?page= restore failed', err);
    }
};
// ── Immersive chrome (module manifest `chrome`) ─────────────────────────────
// `chrome: { immersive: 'non-admin' | true, landing: '/route' }` in a module
// manifest hides the shell's top/bottom chrome (AppHeader, prompt composer,
// presence dock) for matched members and lands them on the module's own page
// instead of the home board. Admins ALWAYS keep the full shell chrome — they
// need the console/customize surfaces regardless of the manifest value.
// Consumers (the chrome hide gates) must be reactive on `workspaceProject`.
// Chrome manifest resolution — WORKSPACE SETTINGS OVERRIDE THE MODULE
// DEFAULT (2026-08-12 per Nika "personal workspace should be able to
// override generic changes"): the module manifest's `chrome` is the generic
// default for every workspace running the module; a workspace's own
// `settings.chrome` (stash `config.chrome`, same settings ▸ configDefaults
// precedence as navbar/panels) replaces it wholesale — e.g.
// `settings.chrome = { immersive: false }` restores the full shell chrome
// for that one workspace. Absent/cleared settings fall through to the
// manifest.
const $58029952ef70329d$var$_moduleChrome = (root)=>{
    const wp = root?.workspaceProject;
    if (!wp) return null;
    const cfg = wp.config;
    if (cfg && cfg.chrome !== undefined) return cfg.chrome;
    return wp.chrome || null;
};
const $58029952ef70329d$export$a9b228c74739c85c = (root)=>{
    const chrome = $58029952ef70329d$var$_moduleChrome(root);
    return chrome && typeof chrome.viewAsKey === 'string' ? chrome.viewAsKey : null;
};
const $58029952ef70329d$export$8a84674485ee3e88 = (root)=>{
    const chrome = $58029952ef70329d$var$_moduleChrome(root);
    if (!chrome || !chrome.immersive) return false;
    try {
        // Item 11 route gate: immersive (no shell chrome) only holds on the
        // module surface. On /studio, /infra and other own-sidebar routes the
        // rail hides — without this gate a member/preview there would have NO
        // navigation at all (no rail, no navbar).
        if (!$58029952ef70329d$export$88bd7c6eeee57aae(root)) return false;
        if (!(0, $aGIjc.currentUserIsAdmin)(root)) return true;
        // View-as: the manifest may name a root-state key (chrome.viewAsKey)
        // that the module's own persona switcher writes (e.g. bellforge's
        // bfPersonaOverride). An admin previewing a non-admin persona gets the
        // REAL immersive chrome — navbars and composer disappear — so the
        // preview is truthful (Nika 2026-08-13: "after switching to non-admin
        // personas navbars should dissapear"). The key is read on every admin
        // pass, so the factory tracks it and chrome re-resolves on switch.
        const key = $58029952ef70329d$export$a9b228c74739c85c(root);
        if (key) {
            const v = root ? root[key] : null;
            if (typeof v === 'string' && v && v !== 'admin') return true;
        }
        // Nika 2026-08-16: a rail workspace is immersive for ADMINS by default
        // too — top navbar hidden even with the pageslot closed — unless this
        // admin toggled the shell chrome back (persisted per workspace). The
        // root mirror is read FIRST (reactive after a toggle); storage covers
        // the first render of a fresh boot.
        if ($58029952ef70329d$export$fd6706fef94e4e7f(root)) {
            const mirror = root ? root._moduleChromePref : undefined;
            const pref = mirror !== undefined ? mirror : $58029952ef70329d$export$f2d9b2ae4338c644(root);
            if (pref !== 'shell') return true;
        }
        return false;
    } catch (_) {
        return false;
    }
};
const $58029952ef70329d$export$8b266bc4e73cce64 = (root)=>{
    try {
        if (!$58029952ef70329d$var$_moduleChrome(root)) return false;
        if (!(0, $aGIjc.currentUserIsAdmin)(root)) return false;
        const key = $58029952ef70329d$export$a9b228c74739c85c(root);
        if (!key) return false;
        const v = root ? root[key] : null;
        return typeof v === 'string' && !!v && v !== 'admin';
    } catch (_) {
        return false;
    }
};
const $58029952ef70329d$export$88bd7c6eeee57aae = (root)=>{
    try {
        const raw = root && root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/') || '/';
        const inner = String(raw).replace(/^\/w\/[^/]+\/[^/]+/, '') || '/';
        const p = inner.split(/[?#]/)[0];
        return p === '/' || p === '';
    } catch (_) {
        return true;
    }
};
const $58029952ef70329d$export$fd6706fef94e4e7f = (root)=>{
    const chrome = $58029952ef70329d$var$_moduleChrome(root);
    if (!(chrome && typeof chrome.rail === 'string' && chrome.rail)) return false;
    return $58029952ef70329d$export$88bd7c6eeee57aae(root);
};
const $58029952ef70329d$export$9ea09d81f0bd322b = (root)=>{
    const chrome = $58029952ef70329d$var$_moduleChrome(root);
    return !!(chrome && chrome.railEdge === true);
};
// ── Admin chrome preference (Nika 2026-08-16: "admin has expanded by
// default so top navbar should not be visible … only if admin toggles
// back", "expanded even if pageslot is closed") ─────────────────────────────
//
// In a rail workspace the ADMIN's default presentation is the IMMERSIVE one
// too — no shell top/bottom chrome, slot edge-to-edge, full-bleed home
// board. The escape hatch is a persisted per-workspace preference:
// 'shell' = the admin toggled the chrome back on. Stored in localStorage
// (survives reload); mirrored on root._moduleChromePref by the toggle so
// factories re-run (the storage read alone is not reactive).
const $58029952ef70329d$var$_moduleChromePrefKey = (root)=>{
    const wsId = root?.activeWorkspaceId || root?.workspace?.id || root?.jwtClaims?.active_workspace_id || null;
    return wsId ? 'moduleChromePref.' + String(wsId) : null;
};
const $58029952ef70329d$export$f2d9b2ae4338c644 = (root)=>{
    try {
        const key = $58029952ef70329d$var$_moduleChromePrefKey(root);
        const raw = key && globalThis.localStorage ? globalThis.localStorage.getItem(key) : null;
        return raw === 'shell' ? 'shell' : null;
    } catch (_) {
        return null;
    }
};
const $58029952ef70329d$export$1238c27f026d6fac = (root, value)=>{
    try {
        const key = $58029952ef70329d$var$_moduleChromePrefKey(root);
        if (!key || !globalThis.localStorage) return;
        if (value === 'shell') globalThis.localStorage.setItem(key, 'shell');
        else globalThis.localStorage.removeItem(key);
    } catch (_) {
    /* best-effort */ }
};
// ── Slot fullscreen resolution (B1, tickets/bellforge.md) ──────────────────
//
// `root._slotFullscreen` is a TRI-STATE: true/false record an EXPLICIT user
// choice (the header toggle); null/undefined mean "no choice this session".
// Close/minimize/route-away paths reset to null — a close is not an opinion
// about the next open. With no explicit choice, a persisted per-workspace
// preference wins; with neither, a module workspace (chrome.rail — the
// admin's windowed module view) defaults EXPANDED (Nika: "the workspace
// admin view opens collapsed; it should be EXPANDED by default"), while
// plain workspaces keep the floating card.
//
// localStorage, not sessionStorage: the acceptance is "a fresh load shows
// the expanded state" with "persisted user preference still winning" — the
// preference must survive the reload boundary. Per-workspace key, same
// tenant-scoping shape as minimizedSlots'.
const $58029952ef70329d$var$_slotFsPrefKey = (root)=>{
    const wsId = root?.activeWorkspaceId || root?.workspace?.id || root?.jwtClaims?.active_workspace_id || null;
    return wsId ? 'slotFullscreenPref.' + String(wsId) : null;
};
const $58029952ef70329d$export$69b4a908fa05a863 = (root)=>{
    try {
        const key = $58029952ef70329d$var$_slotFsPrefKey(root);
        const raw = key && globalThis.localStorage ? globalThis.localStorage.getItem(key) : null;
        if (raw === 'false') {
            globalThis.localStorage.removeItem(key);
            return null;
        }
        return raw === 'true' ? true : null;
    } catch (_) {
        return null;
    }
};
const $58029952ef70329d$export$dea073705d5e4ad1 = (root, value)=>{
    try {
        const key = $58029952ef70329d$var$_slotFsPrefKey(root);
        if (!key || !globalThis.localStorage) return;
        // Only `true` persists (explicit edge-to-edge). `false`/null both CLEAR:
        // a stored "false" is exactly the B1-era pin the reader above heals, so
        // the writer must not be able to re-create it.
        if (value === true) globalThis.localStorage.setItem(key, 'true');
        else globalThis.localStorage.removeItem(key);
    } catch (_) {
    /* best-effort — quota, privacy mode */ }
};
const $58029952ef70329d$export$a512cb55fb79fca8 = (root)=>{
    if (!root) return false;
    const explicit = root._slotFullscreen;
    if (root._canvasSlotSecond || root._slotSplitIntent) return false;
    if ($58029952ef70329d$export$8a84674485ee3e88(root)) return true;
    if (explicit === true || explicit === false) return explicit;
    const pref = $58029952ef70329d$export$69b4a908fa05a863(root);
    if (pref === true || pref === false) return pref;
    return $58029952ef70329d$export$fd6706fef94e4e7f(root);
};
// Per-module stage colour (chrome.stage) — the shell paints this behind
// every in-flow surface while the module's workspace is active: the strip
// behind the floating module rail AND the shell pages (home, studio,
// tickets, route mounts). One key, one paint site (shellApp.background),
// so "change the bg per workspace" is a one-line module-config edit
// (2026-08-16 per Nika: "make it consistent so we change bg per
// workspace"). The value crosses the module→shell boundary as a literal
// CSS colour string — the shell cannot resolve a module's design-system
// tokens, same contract shape as chrome.rail carrying a component name.
// Theme-aware chrome VALUE picker — shared by chrome.stage and chrome.card
// (BF-WIDGET-INK-1, Nika's Q2 "desk pair"): a literal CSS colour string, or a
// `{ light: '#…', dark: '#…' }` pair resolved by the shell's LIVE theme.
// Force-track BOTH theme keys UNCONDITIONALLY (FA515 discipline) — the
// value must re-resolve when the user flips theme AND when the OS scheme
// flips under 'auto'. themeMode stays the string 'auto' across an OS
// flip, so tracking it alone never repaints (BF-THEME-SURFACES-1,
// measured by brand 2026-08-16: opaque rgb(37,34,28) across both
// data-theme flips); themeResolved is the shell's live resolution.
// Resolution order for a pair: the shell's LIVE resolution (themeResolved,
// which already folds the user choice + OS preference) → explicit
// themeMode → matchMedia, so 'auto' follows the OS on a fresh load AND
// on a mid-session scheme flip. The pair is resolved HERE, in JS, and
// written as ONE colour — a CSS `light-dark()` value would follow the OS
// `color-scheme`, never the forced `[data-theme]`, and a module
// design-system array pair does not re-resolve per forced theme on the
// app-module render path of the shell's pinned runtime.
const $58029952ef70329d$var$_pickThemedChromeValue = (root, value)=>{
    const mode = root ? root.themeMode : null;
    const resolved = root ? root.themeResolved : null;
    if (typeof value === 'string' && value.trim()) return value.trim();
    if (value && typeof value === 'object') {
        let dark;
        if (resolved === 'dark' || resolved === 'light') dark = resolved === 'dark';
        else if (mode === 'dark' || mode === 'light') dark = mode === 'dark';
        else dark = typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches;
        const pick = dark ? value.dark || value.light : value.light || value.dark;
        return typeof pick === 'string' && pick.trim() ? pick.trim() : null;
    }
    return null;
};
const $58029952ef70329d$export$64021e44c9ae1d35 = (root)=>{
    const chrome = $58029952ef70329d$var$_moduleChrome(root);
    if (!chrome) return null;
    // Theme-aware form: chrome.stage = { light: '#…', dark: '#…' } — light
    // beige stages want darker companions in dark mode (2026-08-16 per Nika:
    // "on light mode is light beige … on dark mode choose a bit darker tones
    // too"). Resolution: _pickThemedChromeValue above.
    return $58029952ef70329d$var$_pickThemedChromeValue(root, chrome.stage);
};
const $58029952ef70329d$export$bed54be12644d6a1 = '--home-card-bg';
const $58029952ef70329d$export$52770a6903de51e5 = (root)=>{
    const chrome = $58029952ef70329d$var$_moduleChrome(root);
    if (!chrome) return null;
    return $58029952ef70329d$var$_pickThemedChromeValue(root, chrome.card);
};
// Variable-level stage repair — the module-chrome writer of `--stage-bg`,
// callable without an element. `_setStageVar` (app.js) delegates its var half
// here; settle points whose repairing re-render a no-op guard suppresses (the
// takeover-publish swallow in loadWorkspaceProject) call it directly.
// VARIABLE level only: the inline `var(--stage-bg, var(--color-stage))`
// chains on the root/content nodes are declared CONSUMERS on 3+ mounted
// nodes — repairing any single node's background instead of the var would
// repaint one consumer and strand the rest (BF-STAGE-ACTIVATION-FLAKE-1).
// OWNERSHIP: `--stage-bg` is ALSO a workspace-record hook — workspaceConfigs
// `_applyDesignSystem` writes `settings.designSystem.vars['--stage-bg']` to
// the SAME inline property (the per-workspace ground for workspaces WITHOUT
// a module desk). Same contract as applyModuleCardVar below: this writer
// removes the property only when it set it itself, so a module that declares
// no stage never strips a record-authored value on a rail render
// (WS-DESIGN-SYSTEM-STAGE-BG-CLOBBERED-BY-MODULE-CHROME-1 — the record's
// ground survived only on `/` and was gone on every module route).
let $58029952ef70329d$var$_moduleStageVarOwned = false;
const $58029952ef70329d$export$82c08a6f8280f40c = (root)=>{
    if (typeof document === 'undefined') return;
    const stage = $58029952ef70329d$export$64021e44c9ae1d35(root);
    const docEl = document.documentElement;
    if (stage) {
        if (docEl.style.getPropertyValue('--stage-bg') !== stage) docEl.style.setProperty('--stage-bg', stage);
        $58029952ef70329d$var$_moduleStageVarOwned = true;
    } else if ($58029952ef70329d$var$_moduleStageVarOwned) {
        docEl.style.removeProperty('--stage-bg');
        $58029952ef70329d$var$_moduleStageVarOwned = false;
    }
    // The card half rides the SAME writer so stage and card can never
    // disagree (one resolver, one render path, one theme read).
    $58029952ef70329d$export$1691a2ea582dd0ce(root);
};
// Module-owned card var writer (chrome.card → --home-card-bg on <html>).
// Unlike `--stage-bg`, `--home-card-bg` is ALSO a workspace-record hook
// (workspaceConfigs._applyDesignSystem writes `settings.designSystem.vars`
// inline on <html> — GreenIG's green glass rides it), so this writer
// tracks OWNERSHIP: it removes the property only when it set it itself,
// and a module that declares no card never strips a record's value. While
// a module that declares a card is active, the module's value wins — this
// writer runs on every ModuleRailHost render/update (after any record
// re-apply), exactly as the stage var does; the module's own desk is the
// authority for its own cards, a record var is the per-workspace override
// for workspaces WITHOUT a module desk.
let $58029952ef70329d$var$_moduleCardVarOwned = false;
const $58029952ef70329d$export$1691a2ea582dd0ce = (root)=>{
    if (typeof document === 'undefined') return;
    const card = $58029952ef70329d$export$52770a6903de51e5(root);
    const docEl = document.documentElement;
    if (card) {
        if (docEl.style.getPropertyValue($58029952ef70329d$export$bed54be12644d6a1) !== card) docEl.style.setProperty($58029952ef70329d$export$bed54be12644d6a1, card);
        $58029952ef70329d$var$_moduleCardVarOwned = true;
    } else if ($58029952ef70329d$var$_moduleCardVarOwned) {
        docEl.style.removeProperty($58029952ef70329d$export$bed54be12644d6a1);
        $58029952ef70329d$var$_moduleCardVarOwned = false;
    }
};
const $58029952ef70329d$export$a69f284518eb2ae9 = (root)=>{
    const chrome = $58029952ef70329d$var$_moduleChrome(root);
    const landing = chrome && typeof chrome.landing === 'string' ? chrome.landing : null;
    return landing && landing.startsWith('/') ? landing : null;
};
const $58029952ef70329d$export$d6a922b3bbd88180 = async (root, sdk, opts = {})=>{
    if (!root) return null;
    // A comm host (comm.symbols.app, shared commHost.js) loads no workspace
    // module: it is chat, calls and AI only (docs/COMM_HOST.md). Every entrant
    // ends here — the boot chain and a workspace switch (loadPrivateData.js),
    // the post-sign-in re-run (auth.js _ensureWorkspaceModule) and the config
    // converge — and the outcome stays 'idle', which is definitive: no latch
    // waits for it and no converge retries it.
    if ($58029952ef70329d$var$shellIsCommHost()) return null;
    const owner = $58029952ef70329d$var$_claimModuleOwner(root, sdk);
    if (!owner) return null;
    const flightKey = $58029952ef70329d$var$_loaderFlightKey(root);
    if ($58029952ef70329d$var$_projectFlight && $58029952ef70329d$var$_projectFlightKey === flightKey && $58029952ef70329d$var$_projectFlightRoot === root) return $58029952ef70329d$var$_projectFlight;
    // Boot reuse (see `_projectSettled`): only an ACTIVE module that is still
    // live on this root. The switch registry wipes root.workspaceProject to
    // null, and a wiped root must be republished by a real pass.
    const held = $58029952ef70329d$var$_projectSettled;
    if (opts.boot === true && held && held.key === flightKey && held.root === root && root.workspaceProject) return held.result;
    $58029952ef70329d$var$_projectSettled = null;
    const run = $58029952ef70329d$var$_loadWorkspaceProjectPass(root, sdk, owner, !!opts.quiet);
    if (!$58029952ef70329d$var$_moduleOwnerCurrent(owner)) return run;
    $58029952ef70329d$var$_projectFlightKey = flightKey;
    $58029952ef70329d$var$_projectFlightRoot = root;
    $58029952ef70329d$var$_projectFlight = run;
    const clear = ()=>{
        if ($58029952ef70329d$var$_projectFlight !== run) return;
        $58029952ef70329d$var$_projectFlight = null;
        $58029952ef70329d$var$_projectFlightKey = null;
        $58029952ef70329d$var$_projectFlightRoot = null;
    };
    run.then(clear, clear);
    return run;
};
const $58029952ef70329d$var$_loadWorkspaceProjectPass = async (root, sdk, owner, quiet = false)=>{
    const seq = ++$58029952ef70329d$var$_loadSeq;
    const flightKey = $58029952ef70329d$var$_loaderFlightKey(root);
    const isStale = ()=>seq !== $58029952ef70329d$var$_loadSeq || $58029952ef70329d$var$_loaderFlightKey(root) !== flightKey || !$58029952ef70329d$var$_moduleOwnerCurrent(owner);
    // A QUIET pass (R2c-m2, the reload after the person's own apply) is no
    // reason for the retry strip; its outcome (ready / error) settles without
    // `quiet`, so a failure still shows. Same rule as the apps pass (BLD-28).
    $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'module', quiet ? {
        state: 'loading',
        quiet: true
    } : {
        state: 'loading'
    });
    // Fresh attempt — clear any prior refusal reason + stale surfaced error.
    $58029952ef70329d$var$_lastRefusal = null;
    $58029952ef70329d$var$_lastNullDefinitive = false;
    if (root._workspaceModuleError) root.update?.({
        _workspaceModuleError: null
    });
    if (isStale()) return null;
    const ws = root.workspace || {};
    const wsId = ws.id || ws._id;
    // Which module (if any) this workspace runs is SERVER-driven: the workspace
    // record's `settings.workspaceModule` reference (or legacy `settings
    // .projectModule` string). No workspace id is matched here — a workspace gets
    // a module ONLY because its server record says so.
    //
    // root.workspace is built from lean JWT claims at boot (auth.js maps it to
    // {id,name,slug,type,org_id,role} — no `settings` bag) and is re-leaned on every
    // claims tick. The selector + config live in `settings`, so fetch the FULL record
    // from the server when it's absent. Resolving it here (rather than mutating
    // root.workspace, which auth would clobber) gives one resolution point for boot +
    // switch. Org-guarded against the cross-org stale-workspace leak.
    // DECISION site (spec §5) — the branch it takes is "do I already hold an
    // authoritative settings bag, or must I go and fetch the record?", and
    // getting it wrong is not cosmetic: `settingsResolved` is what makes the
    // no-module verdict DEFINITIVE (it suppresses the converge retry). The old
    // `!!ws.settings` was a hand-rolled `ready` that any settings-shaped property
    // on a LIST record satisfied — including the optimistic mirrors other flows
    // write back onto `root.workspace` (moduleConsole.js, workspaceApps.js),
    // which publish a bag holding only the one key they just changed. Reading a
    // partial bag as resolved settles a configured workspace as a plain one.
    // Provenance answers it instead: ready ⇒ authoritative (a full record with
    // `{}` IS a real "no overrides" answer and correctly skips the fetch).
    const { settings: heldSettings, ready: heldReady } = $58029952ef70329d$var$shellWorkspaceSettings(root);
    let settings = heldReady ? heldSettings : null;
    // Whether this pass POSITIVELY read the workspace's settings (off the record
    // on root, or by fetching the record — a fetched record WITHOUT a settings
    // bag is still a definitive read: the workspace simply has none). Anything
    // less means the scope is unresolved and the plain-workspace settle below is
    // provisional, not final.
    // (Seeded from the accessor's `ready` — same meaning, one implementation.
    // The FETCH fallback below stays exactly as it was: the accessor reports what
    // is held right now and deliberately never fetches, so it can only narrow the
    // initial read, never replace the completion path.)
    let settingsResolved = heldReady;
    if (!settings && wsId && $58029952ef70329d$var$_belongsToActiveOrg(root) && sdk && typeof sdk.getWorkspace === 'function') {
        try {
            const full = await $58029952ef70329d$var$_waitForModuleRequest((0, $7muxD.getWorkspaceCached)(sdk, wsId));
            // Org-verify the FETCHED record too (mirrors onWorkspaceChange's guard in
            // loadPrivateData.js): root.workspace can still be a stale pointer's
            // foreign-org workspace mid-boot — its settings must neither load a
            // foreign module here nor count as this org's definitive "no module".
            const orgId = $58029952ef70329d$var$_lc(root.org && (root.org.id || root.org._id) || '');
            const recOrg = $58029952ef70329d$var$_lc(full && (full.organization || full.organizationId || full.org) || '');
            if (full && orgId && recOrg && recOrg !== orgId) console.warn("[workspaceProject] fetched workspace belongs to another org \u2014 module load deferred");
            else if (full) {
                settings = full.settings || null;
                settingsResolved = true;
            }
        } catch (e) {
            console.warn('[workspaceProject] full workspace fetch failed', e);
        }
        if (isStale()) return null;
    }
    const belongs = $58029952ef70329d$var$_belongsToActiveOrg(root);
    const loader = belongs ? $58029952ef70329d$export$d8bc16b6ff44ac03(settings, sdk, wsId) : null;
    if (!loader) {
        const definitive = !!(wsId && belongs && settingsResolved);
        // A TRANSIENT miss (scope not readable this pass) while a module is
        // ALREADY LIVE for this same workspace — or for a pass that couldn't even
        // name one — must NOT tear the live module down: destroying + re-injecting
        // a healthy module on every blip (a failed workspace-record refetch, an
        // auth-tick re-lean) looped the whole widget surface through teardown/
        // re-inject and left duplicate grid registrations behind (2026-07-30
        // GreenIG). A DIFFERENT workspace's transient pass still tears down below
        // (never leak a module across a real switch) and a definitive "this
        // workspace has no module" verdict always does.
        if (!definitive && $58029952ef70329d$var$_activeProjectId && (!wsId || String(wsId) === $58029952ef70329d$var$_moduleLoadedWorkspaceId)) {
            $58029952ef70329d$var$_lastLoadOutcome = 'unresolved';
            console.warn("[workspaceProject] scope unresolved on this pass \u2014 keeping live module", {
                wsId: wsId || null,
                belongs: belongs,
                settingsResolved: settingsResolved
            });
            if (!root.workspaceProject) $58029952ef70329d$var$_scheduleModuleConverge(root);
            return null;
        }
        $58029952ef70329d$var$_teardownModule(root);
        // Settle as a plain workspace — but only DEFINITIVELY when the settings
        // were actually resolved for a workspace of the active org and carry no
        // module reference. Everything else (no workspace resolved yet, org guard
        // blocking mid-switch, record fetch failed) is transient boot noise: the
        // module may well be configured, this pass just couldn't know. Cold boots
        // hit exactly that window — the old silent settle here left a configured
        // module unloaded for the whole session (theme + legacy widget chrome
        // still painted via applyWorkspaceConfig's own later re-runs), the
        // GreenIG "widgets empty on sign-in" bug. Schedule the converge retry.
        if (definitive) {
            $58029952ef70329d$var$_lastLoadOutcome = 'no-module';
            $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'module', {
                state: 'ready'
            });
        } else {
            $58029952ef70329d$var$_lastLoadOutcome = 'unresolved';
            console.warn("[workspaceProject] module scope unresolved on this pass \u2014 will retry", {
                wsId: wsId || null,
                belongs: belongs,
                settingsResolved: settingsResolved
            });
            $58029952ef70329d$var$_scheduleModuleConverge(root);
        }
        return null;
    }
    let project;
    try {
        project = await loader();
    } catch (e) {
        console.warn('[workspaceProject] module load failed', e);
        project = null;
    }
    if (isStale()) return null;
    if (!project) {
        $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'module', {
            state: 'error'
        });
        // A module WAS referenced (a loader existed) but resolved to null. If the
        // loader refused it for a KNOWN reason (sandboxed tier / failed audit),
        // surface it — a configured app silently never appearing is a support
        // black hole (tickets/workspace.md WS-APPS bug #4). Generic/transient fetch
        // nulls stay quiet (no _lastRefusal set).
        if ($58029952ef70329d$var$_lastRefusal) {
            root.update?.({
                _workspaceModuleError: $58029952ef70329d$var$_lastRefusal
            });
            try {
                root.call?.('openNotification', {
                    title: root.call?.('polyglot', 'workspace.apps.loadFailed'),
                    message: $58029952ef70329d$var$_lastRefusal,
                    type: 'error'
                });
            } catch (e) {
            /* the notification surface isn't reachable from the loader context */ }
        }
        // Same live-module protection as the unresolved branch above: a TRANSIENT
        // re-load failure for the workspace whose module is already live keeps the
        // module (one bad round-trip must not destroy the session's widget
        // surface). Refusals and definitive verdicts still tear down, as does any
        // failure while switching to a DIFFERENT workspace.
        if (!$58029952ef70329d$var$_lastRefusal && !$58029952ef70329d$var$_lastNullDefinitive && $58029952ef70329d$var$_activeProjectId && (!wsId || String(wsId) === $58029952ef70329d$var$_moduleLoadedWorkspaceId)) {
            $58029952ef70329d$var$_lastLoadOutcome = 'error';
            console.warn("[workspaceProject] module re-load failed \u2014 keeping live module");
            if (!root.workspaceProject) $58029952ef70329d$var$_scheduleModuleConverge(root);
            return null;
        }
        $58029952ef70329d$var$_teardownModule(root);
        // A refusal (sandboxed tier / failed audit) or a definitive content
        // verdict (manifest missing / id mismatch on a fetched payload) is final.
        // A TRANSIENT null (fetch/parse/channel failure on a REFERENCED module)
        // is retried — else one bad round-trip costs the whole session's module
        // (failures are never memoized, so the refetch is real).
        if ($58029952ef70329d$var$_lastRefusal || $58029952ef70329d$var$_lastNullDefinitive) $58029952ef70329d$var$_lastLoadOutcome = 'refused';
        else {
            $58029952ef70329d$var$_lastLoadOutcome = 'error';
            $58029952ef70329d$var$_scheduleModuleConverge(root);
        }
        return null;
    }
    // Inject components + functions into the live context — but only when switching
    // INTO this module (re-entrancy: onWorkspaceChange can fire twice). A different
    // module first tears down the previous one's keys + state.
    //
    // The gate is (module id × WORKSPACE): two workspaces can run the SAME
    // module, and a module-id-only gate skipped teardown on that switch — so
    // workspace A's seeded rows survived (the registry wipe doesn't know module
    // state keys, and the seed loop below skips non-empty keys as "someone
    // else's data") and rendered as workspace B's (2026-07-30 isolation audit
    // #3). Same-workspace re-passes stay idempotent.
    if ($58029952ef70329d$var$_activeProjectId !== project.id || String(wsId || '') !== $58029952ef70329d$var$_moduleLoadedWorkspaceId) {
        $58029952ef70329d$var$_teardownModule(root);
        const ctx = $58029952ef70329d$var$_ctx(root);
        if (ctx) {
            ctx.components = ctx.components || {};
            ctx.functions = ctx.functions || {};
            ctx.pages = ctx.pages || {};
            // WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — hold the bags this pass
            // writes into, so the NEXT teardown deletes from them even if the root
            // state was replaced under us in between (see _captureBags). The routes
            // map is added below, where the routed element is resolved.
            $58029952ef70329d$var$_injectedBags = $58029952ef70329d$var$_captureBags(ctx, null);
            $58029952ef70329d$var$_injectEntries(ctx.components, project.components || {}, $58029952ef70329d$var$_injectedComponentKeys, 'components', String(project.id));
            // The module's own copy reaches the shell's polyglot map — once per
            // load, non-destructively, ledgered for _moduleTeardown.
            $58029952ef70329d$var$_injectedTranslations = $58029952ef70329d$export$ebac99e278359f95(ctx, project);
            // Engine-synthesized fns ride along with the module's own: a capability
            // grant gets the scoped `moduleData` bridge (moduleDataBridge.js). The
            // approval-gated action TRIO is NOT injected here — it is built ONCE by
            // loadWorkspaceApps over the union of this module's actions and every
            // additive app's (a per-module trio would collide on the shared fn names
            // and only the first registry would be reachable — the "Unknown action"
            // bug with multiple apps installed). loadWorkspaceApps always runs right
            // after this loader on every activation path (auth boot, module console,
            // install/uninstall), so the trio is present by the time anything can
            // propose an action.
            const fns = {
                ...project.functions || {}
            };
            // Injected UNCONDITIONALLY — same contract as moduleAiChat below. The
            // bridge live-resolves the grant on EVERY call (union of the build-time
            // snapshot and the workspace record's stored ref) and fails closed, so
            // registration must not depend on `project.capabilities` having resolved
            // by loader time: a late settings bag (or an unaudited development-
            // channel load, where the ref reaches the loader before the grant) left
            // `moduleData` unregistered for the whole session and every records call
            // returned undefined — measured live on gita/backoffice 2026-08-29, the
            // same frozen-at-registration shape the bridge itself was taught to heal
            // (bellforge 2026-08-13/16).
            fns.moduleData = (0, $f18a7.buildModuleDataBridge)(root, project.capabilities || {}, $58029952ef70329d$var$_moduleDataBridgeOpts());
            // The scoped server-routed completion bridge (moduleAiBridge.js) —
            // el.call('moduleAiChat', prompt, opts). Injected UNCONDITIONALLY: the
            // bridge resolves the live `ai` grant per call (cold-boot heal — a
            // load-time grant check froze "no grant" forever when settings resolved
            // late, the exact race moduleDataBridge heals for records; measured
            // live 2026-08-13: granted workspace answered offline-draft only).
            // Logo-home bridge (Nika 2026-08-16: "clicking logo should close
            // pageslot and navigate to / home"): ONE sanctioned close+home the
            // module can call — clears both panes and the split intent, arms the
            // one-shot reopen suppression (_slotOnClose's immersive landing
            // reopen would otherwise undo the close 11ms later — the measured
            // second-writer), and routes to '/' when the tab sits on a deep
            // shell route. The slot's own close choreography handles the ?page=
            // URL sync and title restore.
            fns.moduleGoHome = ()=>{
                try {
                    root._slotSkipReopenOnce = true;
                    root.update({
                        _canvasSlot: null,
                        _canvasSlotSecond: null,
                        _slotSplitIntent: false,
                        // null, not false — a close is not an explicit windowed choice
                        // (tri-state contract at slotFullscreenActive above).
                        _slotFullscreen: null
                    });
                    const path = (0, $7iFOV.shellStripWorkspacePrefix)(String(root.currentPath || '/'));
                    if (path && path !== '/') {
                        const rel = $58029952ef70329d$var$_routedEl(root);
                        if (rel && typeof rel.router === 'function') rel.router('/', typeof rel.getRoot === 'function' ? rel.getRoot() : rel);
                    }
                } catch (e) {
                    console.warn('[workspaceModule] moduleGoHome failed:', e && e.message);
                }
                return true;
            };
            fns.moduleAiChat = (0, $8Oeas.buildModuleAiBridge)(root, project.capabilities || {});
            // The streamed sibling over the SAME grant and the same live check —
            // el.call('moduleAiStream', prompt, { …, onText }) (moduleAiBridge.js).
            fns.moduleAiStream = (0, $8Oeas.buildModuleAiStreamBridge)(root, project.capabilities || {});
            // Admin ops over the same grant — usage counter + settings.ai write
            // (el.call('moduleAiAdmin', 'usage'|'settings', args), B7).
            fns.moduleAiAdmin = (0, $8Oeas.buildModuleAiAdminBridge)(root, project.capabilities || {});
            // External company-registry lookups (moduleRegistryBridge.js, D2-1) —
            // el.call('moduleRegistryLookup', 'search'|'company'|'status', args).
            // Injected unconditionally for the same cold-boot reason as the ai
            // bridge: the `registry` grant is resolved live per call.
            fns.moduleRegistryLookup = (0, $dk5k7.buildModuleRegistryBridge)(root, project.capabilities || {});
            // A `files` grant gets the scoped upload bridge (moduleFileBridge.js) —
            // el.call('moduleFileUpload', file, opts).
            if (project.capabilities && project.capabilities.files) {
                fns.moduleFileUpload = (0, $jqUS6.buildModuleFileBridge)(root, project.capabilities);
                // Long-form media over the SAME grant: direct-to-storage, chunked,
                // resumable, cancellable, the workspace's tier limit
                // (el.call('moduleFileUploadLarge', file, { onProgress, signal })).
                fns.moduleFileUploadLarge = (0, $jqUS6.buildModuleFileUploadLargeBridge)(root, project.capabilities);
                // Read side of the SAME grant — upload without read left the module
                // able to write files it could never open again.
                fns.moduleFileList = (0, $jqUS6.buildModuleFileListBridge)(root, project.capabilities);
                fns.moduleFileRead = (0, $jqUS6.buildModuleFileReadBridge)(root, project.capabilities);
                // Server-side docx/pdf → text extraction over the same grant
                // (el.call('moduleFileExtractText', ref)) — F16.2b.
                fns.moduleFileExtractText = (0, $jqUS6.buildModuleFileExtractTextBridge)(root, project.capabilities);
                // Write side: save an edit BACK to the file the app was handed. Without
                // it an app opened from /files could only ever mint a second copy.
                fns.moduleFileUpdate = (0, $jqUS6.buildModuleFileUpdateBridge)(root, project.capabilities);
                // The create half — a fresh save lands ON the /files desktop, visibly.
                fns.moduleFileCreate = (0, $jqUS6.buildModuleFileCreateBridge)(root, project.capabilities);
            }
            // Declared vendor libraries get the import bridge (moduleImportBridge.js)
            // — el.call('moduleImport', pkg) / el.call('moduleAssetUrl', pkg, path).
            // Manifest-driven (not a server grant): it exposes no workspace data,
            // only which public npm packages the shell will fetch for this app.
            if (project.libraries) {
                fns.moduleImport = (0, $i8Ov5.buildModuleImportBridge)(project.libraries);
                fns.moduleAssetUrl = (0, $i8Ov5.buildModuleAssetUrlBridge)(project.libraries);
                fns.moduleMount = (0, $i8Ov5.buildModuleMountBridge)(project.libraries);
                fns.moduleUnmount = (0, $i8Ov5.buildModuleUnmountBridge)();
                fns.moduleApi = (0, $i8Ov5.buildModuleApiBridge)();
                fns.moduleToken = (0, $i8Ov5.buildModuleTokenBridge)();
                fns.moduleTheme = (0, $i8Ov5.buildModuleThemeBridge)();
            }
            // A `calendar` grant chains the module to the NATIVE workspace calendar
            // (moduleCalendarBridge.js) — el.call('moduleCalendarCreate', {...}),
            // el.call('moduleCalendarUpdate', {id,...}), el.call('moduleCalendarRemove',
            // {id}) and el.call('moduleCalendarList', {from,to}). Without it a module's events
            // live only in its own records plane, where the Calendar app, freebusy
            // and reminders can never see them.
            if (project.capabilities && project.capabilities.calendar) {
                const cal = (0, $aKkqm.buildModuleCalendarBridge)(root, project.capabilities);
                fns.moduleCalendarCreate = cal.moduleCalendarCreate;
                // The edit/remove half of the SAME grant (WS-MODULE-CALENDAR-BRIDGE-
                // UPDATE-REMOVE-1). Injected here too, or a module that chained an
                // event could create it natively but never move or retire it: the
                // module row drifts from its native twin and a deleted row leaves an
                // orphan event plus a live meet room.
                fns.moduleCalendarUpdate = cal.moduleCalendarUpdate;
                fns.moduleCalendarRemove = cal.moduleCalendarRemove;
                fns.moduleCalendarList = cal.moduleCalendarList;
            }
            // Page-open bridge (moduleOpenBridge.js) — module code opens its own
            // registered pages in the PageSlot: el.call('moduleOpenPage', '/route').
            // No capability gate: it can only reach the module's own pages.
            fns.moduleOpenPage = (0, $atmQm.buildModuleOpenBridge)(root);
            // Same-page record opens do NOT navigate (a second mount of the page
            // the module is already showing was the doubled-sheet bug), so the
            // module has no route change to carry `?item=<id>`. This is the seam
            // that writes it: query-only, replaceState, no new page instance. See
            // moduleOpenBridge.js for the full contract.
            fns.setModuleRouteQuery = (0, $atmQm.buildModuleRouteQueryBridge)(root);
            // The page asks the shell to hide its global composer while it shows
            // its own (moduleShellComposer.js, MODULE-SHELL-COMPOSER-1) — latched
            // to the caller's own page, released on leave; the header stays.
            fns.setShellComposer = (0, $984mC.buildModuleShellComposerBridge)(root, {
                moduleIdOf: $58029952ef70329d$export$35a4f2bf5f18fb05
            });
            // The READ half of the same seam (D2 §9 "open = exact spot"). A module
            // page must be able to read the param it (or a room's Open) just wrote,
            // AT MOUNT — `el.call('readPageParam', 'node')`. Same reader the five
            // shell apps use (functions/pageParam.js), so a module's `?node=` and
            // mail's `?thread=` resolve through ONE implementation: the pane's own
            // route first, the address bar second. Without the bridge a module page
            // mounted in the PageSlot could only see `location.search`, which never
            // carries the SECOND pane's route.
            fns.readPageParam = (0, $25fky.readPageParam);
            fns.readPageParams = (0, $25fky.readPageParams);
            fns.readPageRoute = (0, $25fky.readPageRoute);
            // The share-link seam (WS-SHELL-MODULE-BRIDGE-NO-CURRENT-URL-1): a
            // module had no bridge function for its own absolute URL, so a "Copy
            // link" composed one from this trio plus the inherited `workspaceUrl`
            // — which answers the canonical channel-shell origin, not THIS host,
            // so a custom-domain copy pointed at my.symbols.app. One call now
            // answers the pane's real address, current host included.
            fns.readPageUrl = (0, $25fky.readPageUrl);
            // NOTE: the workspace-notification bridge (`moduleNotify`) is NOT
            // injected here — like the approval-action trio it is a shared fn name
            // built ONCE by loadWorkspaceApps over the union of this module's id
            // and every additive app's (a per-plane copy would collide and only
            // the first would be reachable). loadWorkspaceApps always runs right
            // after this loader on every activation path.
            // Platform bridges WIN over same-named module functions. A module may
            // ship its own `moduleOpenPage` (a standalone-router fallback — the
            // bridge doesn't exist outside the shell, and el.call on an
            // unregistered name is a SILENT no-op, so standalone CTAs were dead
            // clicks). _injectEntries skips collisions, which would let that
            // module fallback shadow the real bridge in-shell — evict the
            // module's copy first so the platform implementation lands.
            //
            // WS-MODULEDATA-GRANT-LOST-ON-ORG-RETURN-1 — the same eviction applies to
            // a copy held by the synthetic caps ledger (`__apps_caps__`). That
            // ledger is rebuilt by EVERY loadWorkspaceApps pass, and loadWorkspaceApps
            // runs AFTER this loader — so on an in-session org return the previous
            // tenant's apps-pass `moduleData` was still in the bag here, this
            // injection skipped the fresh takeover bridge as a "collision", and the
            // apps pass then tore the stale ledger down (deleting moduleData) and
            // never rebuilt it for a takeover-only workspace: every
            // `el.call('moduleData', …)` returned undefined until a full reload
            // ("module capability grant missing"). A platform-bridge name is
            // OWNED by the latest loader that builds it — evict the stale copy
            // AND drop it from that ledger's list, so the later caps teardown
            // cannot delete the fresh bridge.
            const capsLed = $58029952ef70329d$var$_injectedByApp.get($58029952ef70329d$var$_CAPS_LEDGER);
            for (const k of Object.keys(fns)){
                if (!(k in ctx.functions)) continue;
                const i = $58029952ef70329d$var$_injectedFunctionKeys.indexOf(k);
                if (i !== -1) {
                    delete ctx.functions[k];
                    $58029952ef70329d$var$_injectedFunctionKeys.splice(i, 1);
                    continue;
                }
                const j = capsLed ? capsLed.functions.indexOf(k) : -1;
                if (j !== -1) {
                    delete ctx.functions[k];
                    capsLed.functions.splice(j, 1);
                }
            }
            $58029952ef70329d$var$_injectEntries(ctx.functions, fns, $58029952ef70329d$var$_injectedFunctionKeys, 'functions', String(project.id));
            // WS-MODULE-FN-NAME-COLLISION-CROSS-APP — build this module's own
            // resolution scope from the SAME bag that went to root (its functions
            // plus its capability bridges), so the two planes can never disagree.
            // Root keeps every key it had; the scope only decides which copy the
            // module's own pages and widgets see when another app took the name.
            $58029952ef70329d$export$2d3738f8ae4966e8(ctx, project, fns);
            // Register the module's pages into both the context map (read by the home
            // split-pane mount via el.context.pages) AND the live router map on the
            // routed element, so a nav item can open them as a real full shell page
            // (browser-back works) — not only inside the home PageSlot overlay. Removed
            // on switch-away by _moduleTeardown, so the routes stay isolated to this module.
            const routedEl = $58029952ef70329d$var$_routedEl(root);
            if ($58029952ef70329d$var$_injectedBags) $58029952ef70329d$var$_injectedBags.routes = routedEl && routedEl.routes || null;
            // Module design-system context — see _ensureModuleDsContext /
            // _wrapModulePages. The SAME wrapped defs must reach every resolver
            // (ctx.pages, the live router map, AND the workspaceProject stash
            // below) — PageSlot's _defFor prefers root._slotResolve, which reads
            // the stash, so wrapping only the context map left the slot mounting
            // the bare def with shell tokens.
            const wrappedPages = await $58029952ef70329d$export$82b02b58ffdd9aec(ctx, project, root);
            if (isStale()) return null;
            $58029952ef70329d$var$_liveModulePages = wrappedPages;
            $58029952ef70329d$var$_installLiveGetter(root);
            for (const [path, def] of Object.entries(wrappedPages)){
                const taken = path in ctx.pages || !!(routedEl && routedEl.routes && path in routedEl.routes);
                if (taken) {
                    console.warn('[workspaceModule] key collision skipped:', path);
                    continue;
                }
                ctx.pages[path] = def;
                // _routeTableDef: the router's own merge spread drops the def's
                // non-enumerable module DS `context` — see that fn's comment
                // (MODULE-ROUTE-CTX). ctx.pages keeps the original `def`.
                if (routedEl && routedEl.routes) routedEl.routes[path] = $58029952ef70329d$var$_routeTableDef(def);
                $58029952ef70329d$var$_injectedPageKeys.push(path);
            }
        }
        $58029952ef70329d$var$_activeProjectId = project.id;
        // WS-MODULE-SCOPED-KEYS-CONTRACT-1: publish the module's declared scoped
        // keys + boundary hook to the registry the PHASE-1 switch wipe reads.
        (0, $j9v8x.registerModuleScopedKeys)(project.id, {
            keys: project.scopedKeys || [],
            hook: project.hooks && project.hooks.onWorkspaceSwitch
        });
    }
    // Keep the live map fresh on re-passes too (the inject block above is
    // skipped when the module is unchanged, but a prior teardown from a
    // failed pass may have nulled it).
    if (!$58029952ef70329d$var$_liveModulePages) {
        const wrappedPages = await $58029952ef70329d$export$82b02b58ffdd9aec($58029952ef70329d$var$_ctx(root), project, root);
        if (isStale()) return null;
        $58029952ef70329d$var$_liveModulePages = wrappedPages;
    }
    $58029952ef70329d$var$_installLiveGetter(root);
    // AI-drivable fn set = manifest-declared + the engine-synthesized PROPOSE
    // (never approve / reject — those are the member's clicks).
    const aiFunctions = project.actions ? [
        ...new Set([
            ...project.aiFunctions || [],
            ...(0, $6lGuT.MODULE_ACTION_AI_FNS)
        ])
    ] : project.aiFunctions || [];
    // Cache the takeover module's action registry for the merged trio built by
    // loadWorkspaceApps (idempotent — re-runs of this loader refresh it).
    $58029952ef70329d$var$_takeoverActions = project.actions || null;
    // Seed the module's declared state keys — ONLY where the current value is
    // empty/absent (a non-empty key is someone else's data: hands off, untracked,
    // never cleared on teardown). Tracked keys are reset to the correctly-typed
    // empty for their declared seed by _clearState (never a hardcoded [] — see
    // _injectedStateSeeds / _emptyForSeed).
    const seedPatch = {};
    for (const key of project.stateKeys || []){
        const cur = root[key];
        const empty = cur == null || Array.isArray(cur) && !cur.length;
        if (!empty) continue;
        seedPatch[key] = project.seeds && project.seeds[key] !== undefined ? project.seeds[key] : [];
        $58029952ef70329d$var$_injectedStateSeeds[key] = seedPatch[key];
        if (!$58029952ef70329d$var$_injectedStateKeys.includes(key)) $58029952ef70329d$var$_injectedStateKeys.push(key);
    }
    const takeoverStash = {
        id: project.id,
        type: project.type,
        manifestVersion: project.manifestVersion,
        // The active workspace's SERVER `settings` (designSystem/navbar/modules/apps/
        // home_default_panels) cached as the resolved config — falling back to the
        // manifest's configDefaults (server settings ▸ configDefaults ▸ shell
        // defaults). A STABLE slot: resolveWorkspaceConfig (#1) reads it, and unlike
        // root.workspace.settings it survives the auth claims-tick that re-leans
        // root.workspace — so the skin + panels don't flicker away after boot.
        // Server-sourced, never a frontend hardcode.
        //
        // `settings` is null-stripped before the spread (_stripClearedSettings,
        // which also drops an empty-array navbar — see its comment): a
        // workspace whose personalization was RESET carries an EXPLICIT
        // `settings.<key>:null` for the cleared key(s) (mcResetNavbar/
        // mcRemoveModule in moduleConsole.js; resetWorkspaceNavbar/
        // uninstallWorkspaceApp in workspaceApps.js) — that used to WIN this
        // spread and blank the key instead of falling through to the module's
        // configDefaults. Absent and explicit-null now behave identically here
        // (matching _normalizeSavedRow's per-key `!= null` handling below in
        // workspaceConfigs.js); only a REAL settings value still overrides
        // configDefaults — tickets/workspace.md "settings.navbar:null
        // suppresses an assigned module's configDefaults.navbar".
        config: settings || project.configDefaults ? {
            ...project.configDefaults || {},
            ...$58029952ef70329d$var$_stripClearedSettings(settings || {})
        } : null,
        pages: project.pages,
        widgets: project.widgets,
        // Presentation-mode manifest (immersive chrome + landing) — consumed by
        // the shell chrome gates (moduleImmersiveActive) and the home landing
        // redirect. Rides the stash so the gates are reactive on
        // root.workspaceProject like every other module surface.
        chrome: project.chrome || null,
        // Its canvas pages (manifest `canvasRoutes`) — shared moduleRoutes.js
        // isModuleCanvasRoute reads them here (takeover) and off each
        // root.workspaceApps[] entry (additive apps).
        canvasRoutes: project.canvasRoutes || null,
        // Formats this module opens (config.js `opens[]`) — the /files handler
        // registry merges these the same way it merges the additive apps'.
        opens: project.opens || null,
        // Where a row of a declared collection OPENS (config.js `collections[]`)
        // — functions/moduleRecordRoutes.js unions these with the additive apps',
        // and shared `entityRefHref` reads the union off this stash. Same shape,
        // same publish site and same "or null" as `opens` right above.
        recordRoutes: project.recordRoutes || null,
        // Which module component draws one row of a declared collection
        // (config.js `collections[].row`) — functions/moduleRecordRows.js unions
        // these with the additive apps'. Same publish site as recordRoutes.
        recordRows: project.recordRows || null,
        // The module's read-only views for AI answers (config.js `views[]`) —
        // functions/assistantAppViews.js reads them off this stash.
        views: project.views || null,
        // …and its own forms (config.js `forms[]`) — functions/assistantAppForms.js.
        forms: project.forms || null,
        aiFunctions: aiFunctions,
        // How each of those verbs is CALLED, for the assistant's catalog. Carried
        // beside the names, never merged into them: the names are the call GATE,
        // the docs are for the model.
        aiFunctionDocs: project.aiFunctionDocs || {},
        // The approval-gated actions this module declares — the keys the
        // assistant may PROPOSE (uiCatalog `moduleActions`), and their own words.
        actionKeys: (0, $6lGuT.moduleActionKeys)(project.actions),
        actionDocs: (0, $6lGuT.moduleActionDocs)(project.actions),
        chatStarters: project.chatStarters,
        // Catalog metadata for the AI's workspace knowledge layer (uiCatalog.js):
        // the module's injected component names (its UI vocabulary — what
        // render_answer_ui sources may extend), its live root state keys (where
        // its loaded data lives), the discovered loader functions (imperative
        // data paths the AI can drive via el.call), and any declared data
        // recipes. Names/descriptors only — the defs stay in context.
        components: Object.keys(project.components || {}),
        stateKeys: (project.stateKeys || []).slice(),
        loaders: $58029952ef70329d$var$_discoverLoaders(project.functions),
        dataRecipes: (project.dataRecipes || []).slice()
    };
    // Cache the takeover-only stash so loadWorkspaceApps can recompose the
    // published root.workspaceProject over it + the additive apps' union without
    // compounding earlier compositions (the base must stay takeover-pure).
    $58029952ef70329d$var$_takeoverStash = takeoverStash;
    $58029952ef70329d$var$_lastLoadOutcome = 'active';
    $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'module', {
        state: 'ready'
    });
    // Rebound on EVERY successful pass (not only inside the inject block): the
    // same module can serve two workspaces, and the live-module guards above key
    // on which workspace the module is currently active FOR.
    $58029952ef70329d$var$_moduleLoadedWorkspaceId = String(wsId || '');
    // BOOT-RESHUFFLE F4: publishing an IDENTICAL stash is a no-op. The
    // activation chain runs from up to four drivers per boot (boot chain, auth
    // ensure, switch pipeline, converge retries) and every republish
    // re-rendered GridContainer + HeaderTabs + every moduleRoutes subscriber.
    // Skip only when the live value is still present — the switch registry
    // wipes root.workspaceProject to null, and a wiped root MUST be
    // republished even when the content fingerprint is unchanged.
    const _fp = $58029952ef70329d$var$_publishFp([
        'takeover',
        $58029952ef70329d$var$_moduleLoadedWorkspaceId,
        takeoverStash
    ]);
    const _hasSeeds = Object.keys(seedPatch || {}).length > 0;
    if (_fp && _fp === $58029952ef70329d$var$_lastTakeoverFp && root.workspaceProject && !_hasSeeds) // identical republish — swallow. The swallow also swallows the rail
    // re-render that used to repair `--stage-bg` after a transient removal
    // (the accidental-repair regression, BF-STAGE-ACTIVATION-FLAKE-1) — so
    // repair EXPLICITLY, at the variable level, before swallowing.
    // ⚠ REACHABILITY DEPENDENCY: applyStageVar REMOVES the var on a falsy
    // moduleStageColor, and this call stays safe for TRANSIENTLY
    // chrome-less roots only because (a) _composeAiStash preserves takeover
    // chrome and (b) loadWorkspaceApps' transitional-chrome hold carries
    // chrome forward onto a chrome-less composed stash. The fingerprint
    // does NOT protect this: _lastTakeoverFp moves only on the takeover
    // branch, while the composed republish replaces root.workspaceProject
    // without touching it — root content and fp CAN diverge. Do not
    // re-derive safety from fp identity.
    $58029952ef70329d$export$82c08a6f8280f40c(root);
    else {
        $58029952ef70329d$var$_lastTakeoverFp = _fp;
        root.update({
            workspaceProject: takeoverStash,
            ...seedPatch
        });
    }
    $58029952ef70329d$var$_rerouteIfStranded(root, project.pages, 'workspaceProject');
    $58029952ef70329d$export$ac4776a1cef5badb(root, project.pages);
    if (!isStale()) $58029952ef70329d$var$_projectSettled = {
        key: flightKey,
        root: root,
        result: project
    };
    return project;
};
// Reload recovery for injected module/app routes.
//
// A HARD load directly on a module route (refreshing while on /policies, or
// opening /w/icca/exams from a link) hits the router at BOOT — before the
// workspace module or app has activated and injected its pages — so the boot
// pass finds no matching route and falls through. Now that the routes exist,
// re-dispatch the current URL so the real page renders.
//
// Only fires when the URL is one of the just-injected routes AND the boot pass
// actually stranded, so it never disturbs normal in-app navigation. Shared by
// BOTH loaders: the takeover module had this recovery, the ADDITIVE app loader
// did not — which is why a refresh on an installed app's page (the Manifest v2
// path every workspace app uses) rendered an empty pane while its navbar and
// data loaded fine.
const $58029952ef70329d$var$_rerouteIfStranded = (root, pages, tag)=>{
    try {
        if (!pages) return;
        const pathname = typeof window !== 'undefined' && window.location && window.location.pathname || '';
        if (!pathname) return;
        const routePath = (0, $7iFOV.shellStripWorkspacePrefix)(pathname);
        if (!pages[routePath]) return;
        const routedEl = $58029952ef70329d$var$_routedEl(root);
        if (!routedEl || typeof routedEl.router !== 'function') return;
        const matched = root.route;
        // The original guard only asked whether ROUTING STATE looked wrong
        // (`'/*'` / null / a path mismatch). That misses the case this helper
        // exists for: a module injects its pages AFTER the router already
        // resolved, so `root.route` has since been updated to the module's path
        // and `currentPath` matches — yet the VIEW is still the not-found page.
        // Every cold load of an installed app's route rendered "Not found" until
        // something re-routed by hand (2026-08-08).
        //
        // Routing state cannot answer "is the right page on screen", so ask the
        // DOM instead: if the routed element is not currently showing the element
        // for `routePath`, re-route. Cheap, and it makes the helper correct for
        // both the stranded-state case and the late-injection case.
        const stateStranded = matched === '/*' || matched == null || root.currentPath !== pathname;
        let viewStranded = false;
        try {
            const node = routedEl.node;
            // A rendered module page carries its own route key; a not-found page
            // does not match it. Comparing the KEY avoids depending on any single
            // page's markup.
            const shown = node && node.firstElementChild && node.firstElementChild.getAttribute ? node.firstElementChild.getAttribute('data-key') : null;
            const expected = pages[routePath] && pages[routePath].key;
            viewStranded = !!(expected && shown && shown !== expected);
            // No key to compare (most pages) — fall back to "the routed element has
            // no children at all", which is unambiguous.
            if (!expected && node) viewStranded = viewStranded || !node.firstElementChild;
        } catch (err) {
            viewStranded = false;
        }
        if (stateStranded || viewStranded) {
            // Carry the QUERY (and hash) through the re-dispatch. This helper fires
            // on the COLD load of a module route — the module injects its pages
            // after the router already resolved — and it used to hand the router a
            // bare pathname, so mwtRouter pushed a query-less URL and the record
            // the link named was gone before the page ever mounted. Measured live:
            // `/w/vault/default/vault-rooms?item=…&tenant=…` became
            // `/w/vault/default/vault-rooms` in a single pushState from here, which
            // is why a shared record link dead-ended on the module's generic list
            // on a cold mount while working perfectly warm (A1-06 / V1-4).
            const search = typeof window !== 'undefined' && window.location.search || '';
            const hash = typeof window !== 'undefined' && window.location.hash || '';
            routedEl.router(pathname + search + hash, routedEl);
        }
    } catch (err) {
        console.warn('[' + tag + '] reload re-route failed', err);
    }
};
// Remove EXACTLY one additive app's injected keys (components / functions /
// pages + live routes), leaving the shell, the takeover module, and every other
// app untouched. The per-app ledger makes the teardown provably exact.
const $58029952ef70329d$var$_teardownApp = (root, ledgerId)=>{
    $58029952ef70329d$var$_appActivations.delete(ledgerId);
    const led = $58029952ef70329d$var$_injectedByApp.get(ledgerId);
    if (!led) return;
    // WS-MODULE-SCOPED-KEYS-CONTRACT-1: the app's boundary hook fires while its
    // functions still resolve; its declared scoped keys reset; then the ledger
    // goes. (The synthetic caps ledger declares nothing — all three are no-ops.)
    $58029952ef70329d$var$_runModuleSwitchHook(root, ledgerId);
    const scopedPatch = (0, $j9v8x.moduleScopedWipeFor)(ledgerId, root);
    // WS-MODULE-STATE-SCOPE-1 — the app's own state plane resets and is evicted
    // at the same beat (see _clearModuleStatePlane). Must run BEFORE the
    // unregister below: the wipe patch is built from this owner's registry entry,
    // which is keyed by LEDGER id while the store is keyed by PROJECT id.
    $58029952ef70329d$var$_clearModuleStatePlane(ledgerId, root, led.projectId);
    (0, $j9v8x.unregisterModuleScopedKeys)(ledgerId);
    if (Object.keys(scopedPatch).length && root && typeof root.update === 'function') root.update(scopedPatch);
    // WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — delete from the bags this
    // ledger was INJECTED into, not from a context re-resolved now (which is
    // null while the root state is being replaced mid-switch). Dropping the
    // ledger without deleting its keys orphans them: the next install of the
    // same app is then skipped as a "collision" and the previous tenant's copy
    // stays bound. Fallback keeps ledgers written before this capture working.
    const ctx = $58029952ef70329d$var$_ctx(root);
    const comps = $58029952ef70329d$var$_bagOr(led.bags, 'components', ctx && ctx.components);
    const fns = $58029952ef70329d$var$_bagOr(led.bags, 'functions', ctx && ctx.functions);
    const pages = $58029952ef70329d$var$_bagOr(led.bags, 'pages', ctx && ctx.pages);
    if (comps) for (const k of led.components)delete comps[k];
    if (fns) for (const k of led.functions)delete fns[k];
    if (pages) for (const k of led.pages)delete pages[k];
    const routedEl = $58029952ef70329d$var$_routedEl(root);
    const routes = $58029952ef70329d$var$_bagOr(led.bags, 'routes', routedEl && routedEl.routes);
    if (routes) for (const k of led.pages)delete routes[k];
    $58029952ef70329d$export$76c11bb2425194b3(led.translations);
    $58029952ef70329d$var$_injectedByApp.delete(ledgerId);
};
// Compose the published `root.workspaceProject` stash over the takeover
// module's own stash (may be null) + the loaded additive apps. The stash is
// the assistant's whole client-side AI surface: `aiFunctions` gates which fns
// the AI transport may run (simoneAiTransport._moduleAiFns), `chatStarters`
// feeds the composer's starter bubbles (shared Chat.js), and pages/components/
// stateKeys/loaders/dataRecipes feed the per-turn workspace UI catalog
// (uiCatalog.js). Recomputed from scratch on every apps load — uninstalling an
// app shrinks the surface — and always from the PURE takeover base, never a
// previous composition. Identity fields (id/config/widgets) pass through from
// the takeover only: app-only workspaces keep a null id so takeover-only
// consumers (uninstallWorkspaceApp's activeId check, /add-app gating,
// resolveWorkspaceConfig's project.config branch) behave exactly as before.
const $58029952ef70329d$var$_composeAiStash = (takeover, apps, mergedActions = {})=>{
    if (!apps.length) return takeover || null;
    const uniq = (lists)=>[
            ...new Set(lists.flat().filter(Boolean))
        ];
    const aiFunctions = uniq([
        takeover && takeover.aiFunctions || [],
        ...apps.map((p)=>p.aiFunctions || [])
    ]);
    if (Object.keys(mergedActions).length) {
        for (const n of (0, $6lGuT.MODULE_ACTION_AI_FNS))if (!aiFunctions.includes(n)) aiFunctions.push(n);
    }
    // A verb runs read-only only when EVERY source that declares it marks it so
    // (MODULE-FN-READONLY-ENFORCED-1) — on a name collision either app's
    // function could be the one that runs, and an unmarked one may write.
    const readOnlyAiFunctions = aiFunctions.filter((name)=>{
        const declarers = [
            takeover,
            ...apps
        ].filter((src)=>src && Array.isArray(src.aiFunctions) && src.aiFunctions.includes(name));
        return declarers.length > 0 && declarers.every((src)=>Array.isArray(src.readOnlyAiFunctions) && src.readOnlyAiFunctions.includes(name));
    });
    // Union the call docs the same way the names are unioned — without this the
    // merged stash carried the verbs but dropped how to call them, so every
    // workspace with an additive app fell back to an assistant guessing argument
    // shapes. FIRST declaration wins on a collision, matching this loader's
    // policy for page paths and merged actions.
    const aiFunctionDocs = {};
    for (const src of [
        takeover,
        ...apps
    ]){
        const docs = src && src.aiFunctionDocs;
        if (!docs || typeof docs !== 'object') continue;
        for (const [name, text] of Object.entries(docs))if (!(name in aiFunctionDocs)) aiFunctionDocs[name] = text;
    }
    // Chat starters: round-robin across sources (takeover first, then each app)
    // so every installed app is represented before any single app's long list
    // fills the cap — six apps × 4-5 starters each would otherwise overflow the
    // composer with one app's prompts.
    const MAX_STARTERS = 12;
    // A starter that names its app's OWN FORM (`{ text, form }`) carries the
    // app it came from (`app`), so the merged list still knows whose form it
    // opens (assistantStarters.js moduleStarters → assistantStarterForm).
    const ownStarters = (src)=>(Array.isArray(src && src.chatStarters) ? src.chatStarters : []).map((it)=>it && typeof it === 'object' && typeof it.form === 'string' && !it.app && src.id ? {
                ...it,
                app: String(src.id)
            } : it);
    const starterLists = [
        ownStarters(takeover),
        ...apps.map(ownStarters)
    ].filter((l)=>Array.isArray(l) && l.length);
    const chatStarters = [];
    for(let i = 0; chatStarters.length < MAX_STARTERS; i++){
        let took = false;
        for (const list of starterLists){
            if (i >= list.length || chatStarters.length >= MAX_STARTERS) continue;
            if (!chatStarters.includes(list[i])) chatStarters.push(list[i]);
            took = true;
        }
        if (!took) break;
    }
    const pages = {
        ...takeover && takeover.pages || {}
    };
    for (const p of apps)Object.assign(pages, p.pages || {});
    const components = uniq([
        takeover && takeover.components || [],
        ...apps.map((p)=>Object.keys(p.components || {}))
    ]);
    const stateKeys = uniq([
        takeover && takeover.stateKeys || [],
        ...apps.map((p)=>p.stateKeys || [])
    ]);
    const loaders = {
        ...takeover && takeover.loaders || {}
    };
    for (const p of apps)Object.assign(loaders, $58029952ef70329d$var$_discoverLoaders(p.functions));
    const dataRecipes = [
        ...takeover && takeover.dataRecipes || [],
        ...apps.flatMap((p)=>p.dataRecipes || [])
    ];
    return {
        id: takeover && takeover.id || null,
        type: takeover && takeover.type || 'workspace',
        manifestVersion: takeover && takeover.manifestVersion || 2,
        config: takeover && takeover.config || null,
        widgets: takeover && takeover.widgets || null,
        // Takeover-only, like config/widgets: the immersive-chrome gates read
        // root.workspaceProject.chrome — this composed republish (any workspace
        // with an additive app installed) silently DROPPED it, so immersive
        // never activated exactly where additive apps were present (found live
        // on bellforge 2026-08-12: manifest chrome published, stash null).
        chrome: takeover && takeover.chrome || null,
        // Takeover-only like chrome: the additive apps' canvas pages are read off
        // their own `root.workspaceApps[]` entries (isModuleCanvasRoute).
        canvasRoutes: takeover && takeover.canvasRoutes || null,
        // Takeover-only: each additive app's own `opens` is read off its
        // `root.workspaceApps[]` entry, so unioning them here would double-count.
        opens: takeover && takeover.opens || null,
        // Takeover-only for the same reason, and moduleRecordRoutes reads the
        // apps' rows straight off `root.workspaceApps[]`.
        recordRoutes: takeover && takeover.recordRoutes || null,
        // Takeover-only too: moduleRecordRows reads the apps' rows off
        // `root.workspaceApps[]`.
        recordRows: takeover && takeover.recordRows || null,
        // Takeover-only too: assistantAppViews reads the apps' views off
        // `root.workspaceApps[]`.
        views: takeover && takeover.views || null,
        forms: takeover && takeover.forms || null,
        pages: pages,
        aiFunctions: aiFunctions,
        aiFunctionDocs: aiFunctionDocs,
        readOnlyAiFunctions: readOnlyAiFunctions,
        // Every installed app's approval-gated action keys (the merged registry
        // the one propose / approve / reject trio resolves) and their own words.
        actionKeys: Object.keys(mergedActions),
        actionDocs: (0, $6lGuT.moduleActionDocs)(mergedActions),
        chatStarters: chatStarters,
        components: components,
        stateKeys: stateKeys,
        loaders: loaders,
        dataRecipes: dataRecipes
    };
};
// ── Boot reveal route gate (boot fix step 2) ────────────────────────────────
// The boot loader used to wait for the WHOLE module-apps pass (or a 7 s timer
// that a busy main thread starved: Natali 2026-09-29, due ~13.3 s, fired at
// 52.5 s). A page needs at most ONE app: the one whose page the URL names.
// `whenAppRouteReady(root, pathname)` resolves when that path is routable —
// a shell route or takeover page at once, an app page as soon as its app
// registers — or when the running pass settles (after which no app can still
// claim the path, so a genuine 404 is right). No pass in flight: at once.
const $58029952ef70329d$var$_routeWaiters = new Set();
const $58029952ef70329d$var$_pathRoutable = (root, routePath)=>{
    const ctx = $58029952ef70329d$var$_ctx(root);
    if (ctx && ctx.pages && Object.prototype.hasOwnProperty.call(ctx.pages, routePath)) return true;
    const routedEl = $58029952ef70329d$var$_routedEl(root);
    const routes = routedEl && routedEl.routes;
    return !!(routes && routePath !== '/*' && Object.prototype.hasOwnProperty.call(routes, routePath));
};
const $58029952ef70329d$var$_notifyRouteWaiters = (root, settled = false)=>{
    for (const waiter of [
        ...$58029952ef70329d$var$_routeWaiters
    ]){
        if (waiter.root !== root) continue;
        if (settled || $58029952ef70329d$var$_pathRoutable(root, waiter.routePath)) {
            $58029952ef70329d$var$_routeWaiters.delete(waiter);
            waiter.resolve(true);
        }
    }
};
const $58029952ef70329d$export$dfda81474d0ab60e = (root, pathname)=>{
    const raw = pathname || typeof window !== 'undefined' && window.location && window.location.pathname || '/';
    const routePath = (0, $7iFOV.shellStripWorkspacePrefix)(String(raw).split('?')[0]) || '/';
    if (!root || !$58029952ef70329d$var$_appsFlight || $58029952ef70329d$var$_appsFlightRoot !== root || $58029952ef70329d$var$_pathRoutable(root, routePath)) return Promise.resolve(true);
    return new Promise((resolve)=>$58029952ef70329d$var$_routeWaiters.add({
            root: root,
            routePath: routePath,
            resolve: resolve
        }));
};
const $58029952ef70329d$export$54bc558f801f5f96 = async (root, sdk, opts = {})=>{
    if (!root) return [];
    // A comm host loads no apps either (see loadWorkspaceProject).
    if ($58029952ef70329d$var$shellIsCommHost()) return [];
    const owner = $58029952ef70329d$var$_claimModuleOwner(root, sdk);
    if (!owner) return [];
    // Boot reuse (see `_appsSettled`) — checked BEFORE the activating flag goes
    // up, so a reused pass never shows "Opening apps…" again. The surface
    // identity check refuses a root whose app list was wiped or replaced since.
    if (opts.boot === true && !$58029952ef70329d$var$_appsFlight) {
        const held = $58029952ef70329d$var$_appsSettled;
        if (held && held.key === $58029952ef70329d$var$_loaderFlightKey(root) && held.root === root && Array.isArray(root.workspaceApps) && root.workspaceApps === held.surface) return held.result;
    }
    // Apps inject their pages asynchronously; anything that renders in the
    // meantime (notably the not-found page) must be able to tell "still
    // activating" from "genuinely unresolvable" — otherwise a cold load of an
    // installed app's route flashes "Not found" in the tab title.
    try {
        if (root && typeof root.update === 'function') root.update({
            _wsAppsActivating: true
        });
    } catch (flagErr) {
    /* a state that cannot take the flag simply gets the old behaviour */ }
    // update() can synchronously hand the shell to another root.
    if (!$58029952ef70329d$var$_moduleOwnerCurrent(owner)) return [];
    const flightKey = $58029952ef70329d$var$_loaderFlightKey(root);
    if ($58029952ef70329d$var$_appsFlight && $58029952ef70329d$var$_appsFlightKey === flightKey && $58029952ef70329d$var$_appsFlightRoot === root) return $58029952ef70329d$var$_appsFlight;
    const run = $58029952ef70329d$var$_loadWorkspaceAppsPass(root, sdk, owner, !!opts.quiet);
    if (!$58029952ef70329d$var$_moduleOwnerCurrent(owner)) return run;
    $58029952ef70329d$var$_appsFlightKey = flightKey;
    $58029952ef70329d$var$_appsFlightRoot = root;
    $58029952ef70329d$var$_appsFlight = run;
    const clear = ()=>{
        if ($58029952ef70329d$var$_appsFlight !== run) return;
        if ($58029952ef70329d$var$_loaderFlightKey(root) === flightKey) root.update?.({
            _wsAppsActivating: false
        });
        $58029952ef70329d$var$_appsFlight = null;
        $58029952ef70329d$var$_appsFlightKey = null;
        $58029952ef70329d$var$_appsFlightRoot = null;
        // The pass settled: a path still unclaimed now is not an app page.
        $58029952ef70329d$var$_notifyRouteWaiters(root, true);
    };
    run.then(clear, clear);
    return run;
};
// Sub-phase telemetry for BF-MODULE-APPS-LOADER-INTERMITTENT-SLOW-1 — the
// wsboot:module-apps span (loadPrivateData.js) swung 755ms-13,578ms across
// identical cold boots with no code/deploy change between them. These marks
// localize the swing to one of the three candidates named in that ticket:
// the getWorkspaceCached full-record fetch, the capped per-app prefetch, or
// a _scheduleModuleConverge retry firing mid-pass. Guarded no-op like
// loadPrivateData.js's wsboot:* marks.
const $58029952ef70329d$var$_mark = (name)=>{
    try {
        if (typeof performance !== 'undefined') performance.mark(name);
    } catch (_) {
    /* telemetry only */ }
};
const $58029952ef70329d$var$_measure = (name, from, to)=>{
    try {
        if (typeof performance !== 'undefined') performance.measure(name, from, to);
    } catch (_) {
    /* telemetry only */ }
};

const $58029952ef70329d$var$_loadWorkspaceAppsPass = async (root, sdk, owner, quiet = false)=>{
    const seq = ++$58029952ef70329d$var$_appsLoadSeq;
    $58029952ef70329d$var$_appsSettled = null;
    const flightKey = $58029952ef70329d$var$_loaderFlightKey(root);
    const isStale = ()=>seq !== $58029952ef70329d$var$_appsLoadSeq || $58029952ef70329d$var$_loaderFlightKey(root) !== flightKey || !$58029952ef70329d$var$_moduleOwnerCurrent(owner);
    $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'apps', quiet ? {
        state: 'loading',
        quiet: true
    } : {
        state: 'loading'
    });
    $58029952ef70329d$var$_mark('wsboot:module-apps:pass-start');
    const ws = root.workspace || {};
    const wsId = ws.id || ws._id;
    // DECISION site (spec §5) — same branch, same stakes as loadWorkspaceProject's
    // read above, and here the wrong answer is the measured one: a list-shaped
    // record read as "resolved" makes `_appRefs(null)` an authoritative EMPTY app
    // list, which publishes `workspaceApps: []` and latches the surface (the
    // natali 0-of-13 failure mode described below). Provenance, not bag presence.
    const { settings: heldSettings, ready: heldReady } = $58029952ef70329d$var$shellWorkspaceSettings(root);
    let settings = heldReady ? heldSettings : null;
    // Whether this pass POSITIVELY read the workspace's settings (off the record
    // on root, or by fetching the record — a fetched record WITHOUT a settings
    // bag is still a definitive read). Mirrors loadWorkspaceProject's
    // `settingsResolved`: anything less means the scope is unresolved and this
    // pass is PROVISIONAL — it must not publish a definitive empty app list,
    // must not latch `_appRoutesSettled`, and must leave a converge retry armed.
    // (Seeded from the accessor's `ready`; the fetch fallback below is untouched —
    // the accessor never fetches, so it narrows the initial read only.)
    let settingsResolved = heldReady;
    if (!settings && wsId && $58029952ef70329d$var$_belongsToActiveOrg(root) && sdk && typeof sdk.getWorkspace === 'function') {
        $58029952ef70329d$var$_mark('wsboot:module-apps:ws-fetch:start');
        try {
            const full = await $58029952ef70329d$var$_waitForModuleRequest((0, $7muxD.getWorkspaceCached)(sdk, wsId));
            // Org-verify the FETCHED record too (same guard as loadWorkspaceProject):
            // a stale pointer's foreign-org workspace must neither load foreign apps
            // nor count as this org's definitive "no apps".
            const orgId = $58029952ef70329d$var$_lc(root.org && (root.org.id || root.org._id) || '');
            const recOrg = $58029952ef70329d$var$_lc(full && (full.organization || full.organizationId || full.org) || '');
            if (full && orgId && recOrg && recOrg !== orgId) console.warn("[workspaceApps] fetched workspace belongs to another org \u2014 apps deferred");
            else if (full) {
                settings = full.settings || null;
                settingsResolved = true;
            }
        } catch (e) {
            console.warn('[workspaceApps] full workspace fetch failed', e && e.message);
        }
        $58029952ef70329d$var$_mark('wsboot:module-apps:ws-fetch:end');
        $58029952ef70329d$var$_measure('wsboot:module-apps:ws-fetch', 'wsboot:module-apps:ws-fetch:start', 'wsboot:module-apps:ws-fetch:end');
        if (isStale()) return null;
    }
    const belongs = $58029952ef70329d$var$_belongsToActiveOrg(root);
    // Transient scope miss (no workspace resolved yet, org guard blocking while
    // a cross-org /w/<slug> boot converges, record fetch failed) with the SAME
    // workspace's apps possibly already live: do NOT tear down, do NOT publish
    // an empty list, do NOT settle — retry once the scope lands. This is the
    // natali 0-of-13 root cause: boot ran this loader while root.org still held
    // the server-side active org (URL named a different org), refs resolved [],
    // and the unconditional publish+settle below suppressed every later retry
    // (the converge loop bailed on the takeover module's own definitive
    // 'no-module' without ever re-running the apps loader).
    if (!wsId || !settingsResolved) {
        $58029952ef70329d$var$_lastAppsOutcome = 'unresolved';
        console.warn("[workspaceApps] scope unresolved on this pass \u2014 will retry", {
            wsId: wsId || null,
            belongs: belongs,
            settingsResolved: settingsResolved
        });
        $58029952ef70329d$var$_scheduleModuleConverge(root);
        $58029952ef70329d$var$_mark('wsboot:module-apps:converge-scheduled');
        return null;
    }
    if (!belongs) {
        // A workspace from ANOTHER org on root — either a real org switch-away
        // (onWorkspaceChange re-runs this loader for the new scope) or a boot
        // whose org hasn't converged yet. Tear the foreign apps down NOW (cross-
        // org isolation must never wait), publish the cleared surface, but treat
        // the pass as transient: no `_appRoutesSettled` latch, converge retry
        // armed so the converged scope re-loads its own apps.
        for (const ledgerId of [
            ...$58029952ef70329d$var$_injectedByApp.keys()
        ])$58029952ef70329d$var$_teardownApp(root, ledgerId);
        for (const ledgerId of [
            ...$58029952ef70329d$var$_navLangLedgers.keys()
        ])$58029952ef70329d$var$_dropNavLang(ledgerId);
        $58029952ef70329d$var$_lastAppsOutcome = 'unresolved';
        console.warn("[workspaceApps] workspace not in active org on this pass \u2014 will retry");
        root.update({
            workspaceApps: []
        });
        $58029952ef70329d$var$_scheduleModuleConverge(root);
        $58029952ef70329d$var$_mark('wsboot:module-apps:converge-scheduled');
        return null;
    }
    const refs = $58029952ef70329d$var$_appRefs(settings);
    const desiredIds = new Set(refs.map((r)=>$58029952ef70329d$var$_ledgerKey(wsId, r)));
    // Teardown apps no longer in the list (uninstalled, org switched away, or
    // belonging to the workspace we just switched OFF — see `_ledgerKey`).
    for (const ledgerId of [
        ...$58029952ef70329d$var$_injectedByApp.keys()
    ])if (!desiredIds.has(ledgerId)) $58029952ef70329d$var$_teardownApp(root, ledgerId);
    // Boot fix step 3a: each entry's server `nav.lang` (the words its nav rows
    // use) merges before any app loads, the way _mergeModuleTranslations merges
    // an app's own bundle (never over an existing key). Keyed by the tenant
    // ledger id: an app of another workspace leaves with its keys.
    for (const ledgerId of [
        ...$58029952ef70329d$var$_navLangLedgers.keys()
    ])if (!desiredIds.has(ledgerId)) $58029952ef70329d$var$_dropNavLang(ledgerId);
    const _navCtx = $58029952ef70329d$var$_ctx(root);
    for (const r of refs){
        const nav = r && r.nav;
        if (!nav || nav.v !== 1 || !nav.lang || typeof nav.lang !== 'object') continue;
        const ledgerId = $58029952ef70329d$var$_ledgerKey(wsId, r);
        const held = $58029952ef70329d$var$_navLangLedgers.get(ledgerId);
        if (held && held.hash === nav.hash) continue;
        if (held) $58029952ef70329d$var$_dropNavLang(ledgerId);
        const ledger = $58029952ef70329d$export$ebac99e278359f95(_navCtx, {
            designSystem: {
                lang: nav.lang
            }
        });
        if (ledger) $58029952ef70329d$var$_navLangLedgers.set(ledgerId, {
            hash: nav.hash,
            ledger: ledger
        });
    }
    // Capability bridges (moduleData / moduleAiChat / moduleFileUpload) are shared
    // fn names hardcoded by every app's page code, so they can't be per-app —
    // instead we build ONE bridge set over the UNION of all apps' grants (below,
    // after the load loop) and re-derive it on every load. Rebuild each time: the
    // union changes as apps add/remove, so tear the old synthetic ledger down first.
    $58029952ef70329d$var$_teardownApp(root, $58029952ef70329d$var$_CAPS_LEDGER);
    const mergedCollections = new Set();
    const mergedOps = new Set();
    // capabilities.integrations (tickets/workspace.md "module-plane
    // `integrations` capability — make 'Data' an installable catalog app",
    // DECIDED 2026-08-06) is a GRANT SET like records.collections — the union
    // of every installed app's granted kinds/capabilities determines what the
    // one shared moduleData bridge may reach, same reasoning as
    // mergedCollections/mergedOps above (unlike ai/files' single CONFIG object,
    // which genuinely can't be unioned — see the note below). A wildcard `'*'`
    // from ANY app wins outright (widest declared grant).
    const mergedIntegrationKinds = new Set();
    const mergedIntegrationCapabilities = new Set();
    let integrationKindsWildcard = false;
    let integrationCapabilitiesWildcard = false;
    // The actual ai/files grant CONFIG (not a boolean) — the bridges read
    // capabilities.ai / capabilities.files as objects, which can't be unioned
    // like the collections set above. COMPATIBLE configs merge (deep-equal
    // collapses, files.mimeTypes unions widest — see the checks in the load
    // loop below); only genuinely DIVERGENT configs keep the first app's grant
    // and warn, because one shared bridge cannot serve two different configs —
    // that day needs per-app namespaced bridges. The `…By` trackers carry which
    // app's grant currently holds the slot, so a divergence warn names both
    // sides instead of just the loser.
    let aiCap = null;
    let aiCapBy = null;
    let filesCap = null;
    let filesCapBy = null;
    // pkg → exact version, unioned over every installed app (moduleImportBridge).
    const mergedDependencies = new Map();
    const ctx = $58029952ef70329d$var$_ctx(root);
    const routedEl = $58029952ef70329d$var$_routedEl(root);
    const loaded = [];
    // Full normalized module objects for the loaded module-apps (not extension
    // refs) — feed the merged action registry + the composed AI-surface stash.
    const appProjects = [];
    // BOUNDED parallel prefetch of every module-app's published payload — the fetches
    // are independent network work (env resolve + project fetch, ~2s each on a
    // busy backend) and were paid SERIALLY by the loop below: measured live at
    // 4.7s of a 5.7s boot-loader window with two apps (wsboot:module-apps,
    // 2026-07-28). The loop stays serial for its ORDER-dependent side effects
    // (first-wins ai/files capability grants, page-collision checks, injection
    // ledger) and just consumes settled results. _loadPublishedModule has its
    // own memo + in-flight dedup, so concurrent starts are safe.
    //
    // …but UNBOUNDED parallelism starved the page the user is actually looking
    // at. Each app costs TWO round-trips (getProjectByKey + listEnvironments on
    // a cold env-config cache), so a workspace with 8 apps opened ~16 sockets
    // at once and consumed the browser's whole per-host HTTP/1.1 budget (~6).
    // Measured live on /natali/shop (2026-08-08 per Nika "does not render until
    // i pan"): app mounted at 5.3s, then six `system/*-app` fetches ALL started
    // at 5371ms taking ~2.7-2.9s each, and the canvas project's own data — plus
    // therefore every artboard tile — did not land until 8.5s (17.9s on a
    // busier run). Panning only *appeared* to fix it: by then the queue had
    // drained. Capping in-flight prefetches leaves sockets free for the route's
    // own data while keeping most of the parallel win over the old serial loop.
    // Deliberately NOT 1 (that reinstates the 4.7s serial window this replaced).
    // SELF-CONTAINED on purpose. This runs on the boot path
    // (applyWorkspaceConfig → loadWorkspaceApps), and reaching OUT to a
    // module-scope binding from here threw
    // `ReferenceError: _concurrencyGate is not defined` on the deployed dev
    // bundle — every installed workspace app's routes 404'd because
    // applyWorkspaceConfig aborted before composing them (2026-08-08, P0;
    // prod, which predates the helper, was unaffected). The declaration and
    // the export were both correct in source: the reference simply did not
    // resolve once bundled. A boot-critical helper must therefore not depend
    // on cross-scope resolution at all — build it here, from nothing but its
    // own arguments. `_concurrencyGate` stays exported as the canonical
    // implementation the colocated node --test suite pins.
    const _startPrefetch = ((limit)=>{
        let active = 0;
        const queued = [];
        const pump = ()=>{
            while(active < limit && queued.length){
                active++;
                queued.shift()();
            }
        };
        return (fn)=>new Promise((resolve, reject)=>{
                queued.push(()=>{
                    Promise.resolve().then(fn).then(resolve, reject).finally(()=>{
                        active--;
                        pump();
                    });
                });
                pump();
            });
    })(3) // see the module-const note above for why 3, and why it is inlined
    ;
    // AI-built extension refs resolve against the workspace extension store, not
    // the published-module pipeline — ONE listExtensions round-trip covers every
    // extension ref in the list. Rows carry name/source/pages, and the privacy
    // filter is server-side (an added app is shared, so every member sees it).
    // null until the LIST itself answers: a missing row is a verdict about the
    // extension only when the list came back, never when the call failed.
    // The extension list and published payloads are independent reads. Keep them
    // under one limit so a slow extension does not block all module downloads.
    // Queue it first; registration below still waits for its rows and follows
    // install order. A superseded queued task must not change the AI scope.
    const extensionRowsPromise = refs.some((r)=>r && r.type === 'extension') ? _startPrefetch(async ()=>{
        if (isStale()) return null;
        try {
            const ai = (0, $7iFOV.shellGetAiService)();
            if (ai && typeof ai.listExtensions === 'function' && wsId) {
                if (typeof ai.updateContext === 'function') ai.updateContext({
                    activeWorkspaceId: String(wsId)
                });
                const res = await $58029952ef70329d$var$_waitForModuleRequest(ai.listExtensions({
                    workspaceId: String(wsId)
                }));
                return Array.isArray(res) ? res : null;
            }
        } catch (e) {
            console.warn('[workspaceApps] extension list failed', e && e.message);
            return null;
        }
        return null;
    }) : Promise.resolve(null);
    // ROUTE-FIRST ORDERING. The gate above starts prefetches in INSTALL order,
    // so on a workspace with a dozen apps the one the user actually navigated to
    // could sit in the last batch of 3 — measured ~60s to first paint on
    // /w/natali/…/excalidraw, with the route parked on the not-found page the
    // whole time while crm / hr / scheduling loaded ahead of it. Nothing was
    // broken; the app the URL names was simply last in line.
    //
    // So the ref whose key matches the current route's first segment goes first.
    // Pure ordering — it changes no outcome, only which app the user waits for.
    // The match is a heuristic (an app's key is its route segment by
    // convention); when it misses, the order is exactly what it was before.
    // `sort` is stable, so everything else keeps its install order.
    // Match against EVERY segment of the path, not the first one. The workspace
    // prefix helper strips `/w/<org>` but leaves the workspace slug, so
    // `/w/natali/ws_X/excalidraw` starts at `ws_X`, not the app; and an app's own
    // nested route (`…/excalidraw/board/1`) puts the key mid-path. A segment set
    // is right for all of those shapes and costs nothing.
    const _routeSegments = (()=>{
        try {
            const location = typeof window !== 'undefined' && window.location;
            if (!location) return null;
            // PageSlot deep links name the requested app in ?page=, while the
            // pathname can still point to Home or to another installed app.
            const page = new URLSearchParams(location.search || '').get('page');
            const segs = String(page || location.pathname || '').split('?')[0].split('#')[0].split('/').filter(Boolean).map((seg)=>seg.toLowerCase());
            return segs.length ? new Set(segs) : null;
        } catch (segErr) {
            return null;
        }
    })();
    const _refRouteKey = (r)=>{
        const id = $58029952ef70329d$var$_appId(r) || '';
        const parts = String(id).split('/');
        return (parts[parts.length - 1] || '').toLowerCase();
    };
    const _prefetchOrder = refs.filter((r)=>r && r.type !== 'extension');
    if (_routeSegments) {
        const matchesRoute = (ref)=>{
            const key = _refRouteKey(ref);
            // Published app keys conventionally add -app to their public route.
            // Keep exact matches too, including projects whose route uses -app.
            return _routeSegments.has(key) || _routeSegments.has(key.replace(/-app$/, ''));
        };
        _prefetchOrder.sort((a, b)=>(matchesRoute(a) ? 0 : 1) - (matchesRoute(b) ? 0 : 1));
    }
    $58029952ef70329d$var$_mark('wsboot:module-apps:prefetch:start');
    // CHANNEL READS START TOGETHER (2026-10-03). Each app's channel resolution
    // (getProjectByKey + /core/projects/:id/environments) is small metadata; it
    // used to sit INSIDE the gated task below, so on dev 1061f366e the additive
    // apps' environments reads ran a few at a time (3453 / 3702 / 3702 / 3835 ms
    // on a cold /w/unreal/default). Both API hosts serve HTTP/2. Start every
    // app's channel read now, ungated; _loadPublishedModule picks the same
    // promise up from the warm holder. The payload downloads keep the 3-slot
    // gate (the /natali/shop starvation note above is about those).
    // Self-contained on purpose (see the gate's own note): no module-scope helper.
    try {
        const warm = globalThis.__wsEnvWarm = globalThis.__wsEnvWarm || new Map();
        const now = Date.now();
        for (const r of _prefetchOrder){
            if (!r || r.type !== 'project' || !r.owner || !r.key || !r.channel || r.version) continue;
            const k = String(r.owner) + '/' + String(r.key) + '@' + String(r.channel) + '#' + String(wsId || '');
            // The takeover pass (or the boot prefetch) just resolved this exact
            // channel and handed it over (_channelHandoff): _loadPublishedModule
            // takes that flight, so warming here would re-send getProjectByKey +
            // listEnvironments for nothing (measured twice per cold boot on
            // /w/vault/default). Read inline, like `_pipeline` above.
            const handed = $58029952ef70329d$var$_channelHandoff.get(k);
            if (handed && Date.now() - handed.at < 30000) continue;
            // Every pass warms afresh (an explicit reload must re-resolve every
            // channel); _loadPublishedModule CONSUMES the entry, so it is one read.
            const prom = Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("eY4Ct")));
            }).then((res)=>$58029952ef70329d$var$_pipeline.resolveEnv({
                    owner: r.owner,
                    key: r.key
                }, r.channel, {
                    workspaceId: wsId
                })).catch(()=>null);
            warm.set(k, {
                p: prom,
                at: now
            });
        }
    } catch (e) {
        console.warn('[workspaceApps] channel warm-up skipped', e && e.message);
    }
    const _prefetched = new Map(_prefetchOrder.map((r)=>[
            $58029952ef70329d$var$_appId(r),
            // devOverride:false — the dev override targets THE WORKSPACE MODULE,
            // not the apps: with it on, the override's {owner,key} would merge
            // over EVERY app ref in this loop, collapsing all of them onto one
            // project. wsId still rides so the server's workspace-module grant
            // can authorize the read (see _loadPublishedModule's own note).
            _startPrefetch(()=>isStale() ? null : $58029952ef70329d$var$_loadPublishedModule(r, sdk, wsId, {
                    devOverride: false,
                    lazyParts: [
                        'components'
                    ]
                })).catch((e)=>{
                console.warn('[workspaceApps] module load failed', $58029952ef70329d$var$_appId(r), e && e.message);
                return null;
            })
        ]));
    const extensionRows = await extensionRowsPromise;
    if (isStale()) return null;
    // ── Extension app pages (type 'extension') — a page + navbar/launcher entry
    // over the SAME isolated iframe pipeline /add-app renders with (ExtensionEmbed
    // → renderExtensionInPane audit/parse/scoped-bridge). Never an in-realm mount
    // of AI-authored source, so the module tier gate below doesn't apply. The
    // page needs its list row and nothing else: it registers once per install
    // (the ledger guards a second call), here or in the loop below.
    const extensionRowOf = (ref)=>(extensionRows || []).find((x)=>x && String(x.id) === String(ref.projectId)) || null;
    // ONE builder with the record's `nav` copy (workspaceConfigs.js), so a row
    // painted at boot does not move when the extension loads.
    const extensionRowsFor = (ref, row, name)=>(0, $g7CNh.extensionAppRows)({
            key: row.key,
            projectId: ref.projectId,
            name: name
        });
    const registerExtensionPage = (ref, row)=>{
        const ledgerId = $58029952ef70329d$var$_ledgerKey(wsId, ref);
        const path = extensionRowsFor(ref, row, '').navbar[0].path;
        // A nameless extension row: the bundle word through the routed element,
        // or — with no element to resolve through — the KEY itself, which the
        // navbar tab and the launcher tile resolve through polyglot at render.
        const appName = row.name || (routedEl && typeof routedEl.call === 'function' ? routedEl.call('polyglot', 'workspace.apps.nameFallback') : 'workspace.apps.nameFallback');
        if (!$58029952ef70329d$var$_injectedByApp.has(ledgerId) && ctx) {
            const led = {
                components: [],
                functions: [],
                pages: []
            };
            ctx.pages = ctx.pages || {};
            // WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — see _captureBags.
            led.bags = $58029952ef70329d$var$_captureBags(ctx, routedEl);
            const taken = path in ctx.pages || !!(routedEl && routedEl.routes && path in routedEl.routes);
            if (taken) console.warn('[workspaceApps] extension page collision skipped:', path);
            else if (routedEl && typeof routedEl.call === 'function') {
                // IN-SHELL page def (no iframe — 2026-07-25 per Nika): the installed
                // app renders as a native workspace view through the same audited +
                // entity-scoped builder the /add-app canvas and preview use.
                // `crmLeads` (the row's `{ enabled }`, server listExtensions) turns on
                // the visitor line under a sign-up form. The row is read once per
                // install, so a toggle change shows after the next shell reload.
                const built = row.appKind === 'multipage' ? routedEl.call('buildInlineMultiPageDef', {
                    name: appName,
                    pages: row.pages || [],
                    crmLeads: row.crmLeads
                }) : routedEl.call('buildInlineExtensionDef', {
                    name: appName,
                    source: row.source || '',
                    crmLeads: row.crmLeads
                });
                // A contained refusal (generatedAppContainment.js) registers the
                // blocked-feature page in place of the app: the route still opens,
                // none of the app's own code runs.
                if (built && built.def && (built.ok !== false || built.blocked)) {
                    const pageDef = {
                        ...built.def,
                        metadata: {
                            ...built.def.metadata || {},
                            title: appName
                        }
                    };
                    ctx.pages[path] = pageDef;
                    if (routedEl.routes) routedEl.routes[path] = pageDef;
                    led.pages.push(path);
                } else console.warn('[workspaceApps] extension def build failed:', path, built && built.error);
            }
            $58029952ef70329d$var$_injectedByApp.set(ledgerId, led);
        }
        return {
            appName: appName,
            path: path
        };
    };
    // A ?page= deep link to an extension opens its window as soon as the list
    // answers. The restore at the pass end waited for every module payload
    // installed ahead of the extension: persona round ai-r1 (2026-10-28)
    // reloaded `?page=/x/restock-board` twice and saw no window at the ~9 s
    // look. A MODULE page stays at the pass end: it calls the shared capability
    // bridges, which exist only after the loop. Install order still decides the
    // published list below. Same param read as _restorePageParam.
    {
        const search = typeof window !== 'undefined' && window.location && window.location.search || '';
        const liveParam = search ? new URLSearchParams(search).get('page') : null;
        const pageParam = liveParam || (!$58029952ef70329d$var$_bootPageParamUsed ? $58029952ef70329d$var$_bootPageParam : null);
        const pagePath = pageParam ? String(pageParam).split('?')[0].split('#')[0] : null;
        const target = pagePath && refs.find((ref)=>{
            const row = ref && ref.type === 'extension' ? extensionRowOf(ref) : null;
            return !!row && extensionRowsFor(ref, row, '').navbar[0].path === pagePath;
        });
        if (target) {
            registerExtensionPage(target, extensionRowOf(target));
            if (ctx && ctx.pages && ctx.pages[pagePath]) $58029952ef70329d$export$ac4776a1cef5badb(root, ctx.pages);
        }
    }
    for (const [index, ref] of refs.entries()){
        // A resolved-payload loop otherwise remains entirely in microtasks. Give
        // input, paint and the reveal watchdog a task between registrations, then
        // verify ownership again before touching the next app's registry.
        // A hidden tab throttles timers: there the yield is a plain task (_passYield).
        if (index > 0) await $58029952ef70329d$var$_passYield();
        if (isStale()) return null;
        const appId = $58029952ef70329d$var$_appId(ref);
        // Catalog identity above (published on `loaded`, keys `_prefetched`);
        // tenant-scoped identity below for the injection ledger ONLY.
        const ledgerId = $58029952ef70329d$var$_ledgerKey(wsId, ref);
        // An extension app: its page registers above (registerExtensionPage).
        if (ref.type === 'extension') {
            const row = extensionRowOf(ref);
            if (!row) {
                console.warn('[workspaceApps] extension ref unresolved:', ref.projectId);
                if (extensionRows !== null) $58029952ef70329d$var$_refusals.set(appId, {
                    code: 'missing',
                    message: null
                });
                continue;
            }
            const { appName: appName, path: path } = registerExtensionPage(ref, row);
            const extRowsFor = (name)=>extensionRowsFor(ref, row, name);
            loaded.push({
                id: String(ref.projectId),
                appId: appId,
                manifestVersion: null,
                navbar: extRowsFor(appName).navbar,
                // Launcher tiles follow the { title, caption, icon, iconBg, route }
                // contract (what SearchAppTile reads) — the old { label, path } shape
                // rendered a nameless, glyphless, unclickable tile in the apps
                // dropdown (the natali blank-tiles bug, 2026-07-30). Emit the real
                // meta an extension has (name + route); icon/iconBg fall back at the
                // canonical spot (launcherTiles.js normalizeLauncherTile).
                //
                // `projectId` + `kind` ride along as the tile's IDENTITY (not display
                // meta): they mark this as a custom, AI-built app so the launcher's
                // right-click menu can offer "Edit" and route back into /add-app for
                // exactly this extension (2026-08-02 per Nika "on custom made apps you
                // can add context menu edit"). normalizeLauncherTile spreads the tile,
                // so both survive normalization. House apps carry neither.
                apps: extRowsFor(appName).apps,
                widgets: null,
                // An extension is a page: it never feeds the home.
                homeProviders: [],
                pages: [
                    path
                ]
            });
            continue;
        }
        // Consume the parallel prefetch (falls back to a direct load for safety —
        // e.g. a ref shape the prefetch filter didn't cover). Errors were already
        // caught + null'd inside the prefetch.
        let project = null;
        const _spanKey = String(ref && ref.key || appId);
        const tWait = $58029952ef70329d$var$_spanStart();
        try {
            // devOverride:false — see the prefetch above: apps stay override-free,
            // but wsId rides for the server's workspace-module grant.
            project = await (_prefetched.get(appId) ?? $58029952ef70329d$var$_loadPublishedModule(ref, sdk, wsId, {
                devOverride: false,
                lazyParts: [
                    'components'
                ]
            }));
            $58029952ef70329d$var$_span(_spanKey, 'wait', tWait);
        } catch (e) {
            console.warn('[workspaceApps] module load failed', appId, e && e.message);
            project = null;
        }
        if (isStale()) return null;
        if (!project) continue;
        appProjects.push(project);
        // The home surfaces this app feeds — known now, before its setup.
        const homeProviders = $58029952ef70329d$var$_homeProvidersOf(project);
        // WS-MODULE-FN-NAME-COLLISION-CROSS-APP — every installed app gets its own
        // resolution scope, UNCONDITIONALLY: before the injection guard, so a
        // re-pass (already injected) and a takeover-duplicated app (injection
        // skipped) both still have one. Without it the second app to declare a
        // name would keep resolving the first app's implementation — measured on
        // my.symbols.app/w/natali, where scheduling's pages ran CRM's
        // `natEnsureLoaded` and its own `natFetchAll` never loaded a single
        // collection.
        if (ctx) $58029952ef70329d$export$2d3738f8ae4966e8(ctx, project, {
            ...project.functions || {}
        });
        // Accumulate this app's capability grants into the union (used for the
        // single merged bridge built after the loop) — even for an already-injected
        // app, so a reload rebuilds the union correctly.
        const recs = project.capabilities && project.capabilities.records;
        if (recs) {
            // Entries may be strings or `{ key, read, write }` objects (F1) — the
            // union normalizes to KEYS: the merged client bridge gates membership
            // only, per-collection levels stay server-enforced per caller.
            for (const c of Array.isArray(recs.collections) ? recs.collections : []){
                const k = $58029952ef70329d$var$recordsEntryKey(c);
                if (k) mergedCollections.add(k);
            }
            for (const o of Array.isArray(recs.ops) ? recs.ops : [])mergedOps.add(o);
        }
        const integrations = project.capabilities && project.capabilities.integrations;
        if (integrations) {
            if (integrations.kinds === '*') integrationKindsWildcard = true;
            else for (const k of Array.isArray(integrations.kinds) ? integrations.kinds : [])mergedIntegrationKinds.add(k);
            if (integrations.capabilities === '*') integrationCapabilitiesWildcard = true;
            else for (const c of Array.isArray(integrations.capabilities) ? integrations.capabilities : [])mergedIntegrationCapabilities.add(c);
        }
        // ai/files grants are CONFIG objects (system prompt, modelMode,
        // visibility), not a collections set — two DIFFERENT configs can't share
        // one moduleAiChat/moduleFileUpload fn (that day needs per-app namespaced
        // bridges; today's manifest generation hardcodes the plain fn names onto
        // every app's page code, so it's a bigger design change). But IDENTICAL
        // configs are not a collision at all: jobs-app and excalidraw both grant
        // `files:{visibility:'private'}`, and the old first-wins-with-warning
        // path fired on every boot over a distinction without a difference. So:
        // compatible configs MERGE — deep-equal collapses silently, and
        // files.mimeTypes unions to the widest grant (absent already means the
        // server's own allowlist and stays absent). Only genuine divergence keeps
        // the first app's grant and warns, naming BOTH apps.
        if (project.capabilities && project.capabilities.ai) {
            const nextAi = project.capabilities.ai;
            if (!aiCap) {
                aiCap = nextAi;
                aiCapBy = project.id;
            } else if (!$58029952ef70329d$var$_capConfigsEqual(aiCap, nextAi)) console.warn("[workspaceApps] ai capability divergence \u2014 keeping", `${aiCapBy},`, 'skipping', project.id);
        }
        if (project.capabilities && project.capabilities.files) {
            const nextFiles = project.capabilities.files;
            if (!filesCap) {
                filesCap = nextFiles;
                filesCapBy = project.id;
            } else {
                const merged = $58029952ef70329d$export$a5671be23532b340(filesCap, nextFiles);
                if (merged) filesCap = merged;
                else console.warn("[workspaceApps] files capability divergence \u2014 keeping", `${filesCapBy},`, 'skipping', project.id);
            }
        }
        // Declared vendor libraries union across installed apps. Unlike ai/files
        // (single config objects) this is a per-package map, so two apps CAN each
        // declare their own. A same-package/different-version collision keeps the
        // first and warns — one page can only hold one copy of a library, and
        // silently swapping versions under an app is the worse failure.
        if (project.libraries && typeof project.libraries === 'object') for (const [pkg, version] of Object.entries(project.libraries)){
            const prev = mergedDependencies.get(pkg);
            if (prev && prev !== version) {
                console.warn("[workspaceApps] dependency version collision \u2014 keeping", `${pkg}@${prev},`, 'skipping', `${pkg}@${version}`, 'from', project.id);
                continue;
            }
            mergedDependencies.set(pkg, version);
        }
        // WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — a workspace can BOTH set
        // a module as its takeover (`settings.workspaceModule`) AND carry that same
        // module in its installed-apps list. `loadWorkspaceProject` injects the
        // takeover's components/functions/pages first (it always runs immediately
        // before this loader on every activation path), so by the time this loop
        // reaches the same project every one of its keys is already in the bags —
        // owned by the TAKEOVER ledger. Re-injecting them here cannot succeed: the
        // skip-existing collision policy drops every fresh copy and logs one warn
        // per key.
        //
        // MEASURED on a PLAIN boot with NO org switch (dev.my.symbols.app,
        // /w/bellforge/ws_UYAOhQyNjm, bundle workspace.09e57f4d.js, 2026-08-28,
        // console.warn hooked with stacks): 26 `[workspaceModule] key collision
        // skipped` — 2 at t=10.5 s from the takeover pass (AppPage, TooltipHidden,
        // both genuine shell keys a module may not shadow) and 23 at t=12.1 s from
        // THIS loop (PipelineBoard, PipelineCard, PipelineStageColumn + 20
        // `pipeline*` functions). The two bursts carry different call stacks into
        // the same `_injectEntries`, which is what proves they are two passes over
        // ONE project rather than one pass running twice.
        //
        // The noise was never the real damage. `_injectEntries` only records keys
        // it actually SET, so the app ledger for a takeover-duplicated app ends up
        // EMPTY — it claims none of the keys it appears to own, and a later
        // `_teardownApp` for it is a silent no-op while the takeover ledger still
        // holds the live copies. That is the same ownership confusion the caps
        // ledger hit in 6a7cdafd3.
        //
        // So: the takeover owns the code, this loop owns the launcher surface. The
        // app still contributes its capability union, its actions and its
        // navbar/launcher entry above and below — only the duplicate injection and
        // the empty ledger it would leave behind are skipped.
        const _ownedByTakeover = !!$58029952ef70329d$var$_activeProjectId && String(project.id) === String($58029952ef70329d$var$_activeProjectId);
        if (_ownedByTakeover && !$58029952ef70329d$var$_injectedByApp.has(ledgerId)) // Not a collision and not a warn: this is the designed division of
        // ownership, and it must stay quiet or it becomes the noise it replaced.
        $58029952ef70329d$var$_mark('wsboot:module-apps:takeover-dup:' + appId);
        if (!_ownedByTakeover && !$58029952ef70329d$var$_injectedByApp.has(ledgerId) && ctx) {
            // `projectId` alongside the key ledger: the scoped-keys registry and this
            // ledger are keyed by the TENANT-scoped `ledgerId`, but the module state
            // store (WS-MODULE-STATE-SCOPE-1) is keyed by the module PROJECT id — the
            // teardown needs both, and re-deriving one from the other at teardown
            // time is exactly the kind of guess `_captureBags` exists to avoid.
            const led = {
                components: [],
                functions: [],
                pages: [],
                projectId: project.id
            };
            ctx.components = ctx.components || {};
            ctx.functions = ctx.functions || {};
            ctx.pages = ctx.pages || {};
            // WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — see _captureBags.
            led.bags = $58029952ef70329d$var$_captureBags(ctx, routedEl);
            const tInject = $58029952ef70329d$var$_spanStart();
            $58029952ef70329d$var$_injectEntries(ctx.components, project.components || {}, led.components, 'components', String(project.id));
            // Same translation merge as the takeover path; the ledger rides the
            // app's own entry so _teardownApp removes exactly this app's keys.
            led.translations = $58029952ef70329d$export$ebac99e278359f95(ctx, project);
            // The app's own functions ONLY. The shared capability BRIDGES and the
            // approval-action TRIO are NOT injected per-app — both are built once
            // over the union after the loop (a per-app copy would collide on the
            // shared fn names and only the FIRST app's grant/actions would win —
            // every later app's proposeModuleAction returned "Unknown action").
            $58029952ef70329d$var$_injectEntries(ctx.functions, {
                ...project.functions || {}
            }, led.functions, 'functions', String(project.id));
            $58029952ef70329d$var$_span(_spanKey, 'inject', tInject);
            // WS-MODULE-FN-NAME-COLLISION-CROSS-APP — an ADDITIVE app's pages used to
            // be registered RAW here, with no context of their own, while only the
            // takeover module's pages went through `_wrapModulePages`. That is why
            // the natali failure hit installed apps specifically: with no module
            // context, an app page resolved every `el.call` and every bare component
            // key against the flat root bag, so the second app to declare a name got
            // the first app's implementation. They now carry the same module scope
            // the takeover path has always used (and its design-system config too,
            // when the app ships one — a bonus fix, module tokens previously never
            // reached an installed app's pages).
            // Boot fix step 4b: the wrap itself (_wrapModulePages) runs on the first
            // open or in the app's idle slice (_activateWorkspaceApp); each path
            // holds a placeholder until then. Key reads only — of a page def the
            // placeholder takes the `metadata` reference (the pane title), no more.
            const tRoutes = $58029952ef70329d$var$_spanStart();
            const activation = {
                root: root,
                ctx: ctx,
                routedEl: routedEl,
                project: project,
                ledgerId: ledgerId,
                // the catalog identity (owner/key), as `loaded[].appId` publishes it
                catalogId: appId,
                spanKey: _spanKey,
                name: $58029952ef70329d$var$_appDisplayName(project, ref),
                homeProviders: homeProviders,
                placeholders: {},
                promise: null,
                done: false,
                // the first open intent's time (wsopen:<app>), cleared at the reopen
                openAt: null
            };
            for (const path of Object.keys(project.pages || {})){
                const taken = path in ctx.pages || !!(routedEl && routedEl.routes && path in routedEl.routes);
                if (taken) {
                    console.warn('[workspaceApps] page collision skipped:', path);
                    continue;
                }
                const placeholder = $58029952ef70329d$var$_appOpeningPage(activation, path);
                activation.placeholders[path] = placeholder;
                ctx.pages[path] = placeholder;
                if (routedEl && routedEl.routes) routedEl.routes[path] = placeholder;
                led.pages.push(path);
            }
            $58029952ef70329d$var$_appActivations.set(ledgerId, activation);
            $58029952ef70329d$var$_span(_spanKey, 'routes', tRoutes);
            $58029952ef70329d$var$_injectedByApp.set(ledgerId, led);
            // A deep link to this app's page may be holding the boot reveal.
            $58029952ef70329d$var$_notifyRouteWaiters(root);
            // WS-MODULE-SCOPED-KEYS-CONTRACT-1: an additive app declares scoped
            // keys + a boundary hook exactly like the takeover module; keyed by the
            // tenant-scoped ledger id so a switch tears down exactly this install.
            (0, $j9v8x.registerModuleScopedKeys)(ledgerId, {
                keys: project.scopedKeys || [],
                hook: project.hooks && project.hooks.onWorkspaceSwitch
            });
        }
        loaded.push({
            id: project.id,
            appId: appId,
            manifestVersion: project.manifestVersion,
            // Launcher/navbar surface used by resolveWorkspaceConfig (append) + the
            // installed-apps UI. configDefaults holds the app's own declared navbar.
            navbar: (project.configDefaults && Array.isArray(project.configDefaults.navbar) ? project.configDefaults.navbar : []) || [],
            apps: (project.configDefaults && Array.isArray(project.configDefaults.apps) ? project.configDefaults.apps : []) || [],
            // The app's canvas pages (manifest `canvasRoutes`) — full-bleed with the
            // shell Zoombar (shared moduleRoutes.js isModuleCanvasRoute).
            canvasRoutes: Array.isArray(project.canvasRoutes) ? project.canvasRoutes : null,
            // Published after the app's wrap (boot fix step 4b): before it, a widget
            // would render with the shell's tokens instead of the app's.
            widgets: $58029952ef70329d$var$_appActivations.has(ledgerId) && !$58029952ef70329d$var$_appActivations.get(ledgerId).done ? null : project.widgets || null,
            // The widget ids still on their way (ids only, no defs): the home keeps a
            // saved cell's skeleton only for a widget that WILL arrive for this member.
            pendingWidgets: $58029952ef70329d$var$_appActivations.has(ledgerId) && !$58029952ef70329d$var$_appActivations.get(ledgerId).done ? (Array.isArray(project.widgets) ? project.widgets : []).map((w)=>w && w.id).filter(Boolean) : null,
            homeProviders: // The home surfaces this app feeds ('signals' / 'upcoming', [] for
            // none), from this first pass on: the home waits only for a feeder.
            homeProviders,
            // The app's OWN declared default panel set (manifest configDefaults).
            // The app-mode config compose deliberately never takes panels from an
            // app (a marketplace install must never take the dashboard over), so
            // this rides the stash for the home board's per-app widget-defaults
            // rule instead: `appDefaultWidgetIds` (functions/homePanelSet.js)
            // intersects it with `widgets[].id` — an app pins only its own.
            home_default_panels: project.configDefaults && Array.isArray(project.configDefaults.home_default_panels) ? project.configDefaults.home_default_panels : null,
            pages: Object.keys(project.pages || {}),
            // Declared file formats — what makes installing this app teach the
            // desktop a new type (files/functions/fileHandlers.js reads it off here).
            opens: project.opens || null,
            // Declared record routes — what makes installing this app teach the
            // shell where its rows open (functions/moduleRecordRoutes.js reads it
            // off here, and `entityRefHref` off that).
            recordRoutes: project.recordRoutes || null,
            // Declared record rows — which of this app's components draws one row
            // of its collection where the shell lists records (an AI answer);
            // functions/moduleRecordRows.js reads it off here.
            recordRows: project.recordRows || null,
            // Declared read-only views for AI answers (functions/assistantAppViews.js).
            // Mounted under the app's context like a widget body, so they publish
            // with the widgets — after the app's wrap.
            views: $58029952ef70329d$var$_appActivations.has(ledgerId) && !$58029952ef70329d$var$_appActivations.get(ledgerId).done ? null : project.views || null,
            // Declared forms for AI answers (functions/assistantAppForms.js) — the
            // form mounts under the app's context too: published with the views.
            forms: $58029952ef70329d$var$_appActivations.has(ledgerId) && !$58029952ef70329d$var$_appActivations.get(ledgerId).done ? null : project.forms || null,
            // THE APP'S OWN AI SURFACE, kept per app (DESIGN-COMPOSER-FOCUS-POPOVER-
            // CONTEXT-INSPECT-1). The composed stash (`root.workspaceProject`) unions
            // every app's starters, verbs and actions and loses which app said what;
            // the composer's context selector scopes them back to ONE app (its
            // suggestions, the capabilities answer), so each entry keeps its own.
            // Data only — the call gate stays the composed stash's `aiFunctions`.
            chatStarters: Array.isArray(project.chatStarters) ? project.chatStarters : [],
            aiFunctions: Array.isArray(project.aiFunctions) ? project.aiFunctions : [],
            aiFunctionDocs: project.aiFunctionDocs && typeof project.aiFunctionDocs === 'object' ? project.aiFunctionDocs : {},
            actionKeys: (0, $6lGuT.moduleActionKeys)(project.actions),
            actionDocs: (0, $6lGuT.moduleActionDocs)(project.actions),
            actionLabels: (0, $6lGuT.moduleActionLabels)(project.actions)
        });
    }
    $58029952ef70329d$var$_mark('wsboot:module-apps:prefetch:end');
    $58029952ef70329d$var$_measure('wsboot:module-apps:prefetch', 'wsboot:module-apps:prefetch:start', 'wsboot:module-apps:prefetch:end');
    // WS-MODULE-STATE-SCOPE-1 — (re)install the cross-chunk root getters after the
    // additive apps injected. `loadWorkspaceProject` installs them for the
    // TAKEOVER module only, so on a workspace whose personalization is apps-only
    // (the natali shape: no takeover, five installed apps) `root._moduleStateGet`
    // was never published at all and `uiCatalog` reported every installed app's
    // loaded slices as empty. Idempotent: the same closures are re-assigned.
    $58029952ef70329d$var$_installLiveGetter(root);
    // ONE merged approval-action registry over the takeover module + every
    // additive app. Action keys are module-scoped by convention (crm createDeal,
    // scheduling assignShift, …) — a cross-module duplicate keeps the first and
    // warns, matching the shell's collision policy everywhere else.
    //
    // WS-MODULE-ACTIONS-RUN-ON-THE-SHELL-ROOT-NOT-THE-MODULE-STORE-1 — the merge
    // used to discard WHICH module an action key came from, so
    // buildModuleActionFns had no way to find that module's own state root and
    // ran validate/run against whatever root the invoking (shell chat) element
    // happened to carry. `mergedActionOwners` keeps the project id so the trio
    // can look the owner's store up through `root._moduleStateGet`.
    const mergedActions = {};
    const mergedActionOwners = {} // action key → owning project id
    ;
    const _mergeActions = (actions, from, ownerId)=>{
        if (!actions || typeof actions !== 'object') return;
        for (const [key, def] of Object.entries(actions)){
            // Skip serializer metadata (__order) + anything that isn't an action def.
            if (!def || typeof def !== 'object') continue;
            if (typeof def.run !== 'function' && typeof def.validate !== 'function') continue;
            if (key in mergedActions) {
                console.warn('[workspaceApps] action key collision skipped:', key, 'from', from);
                continue;
            }
            mergedActions[key] = def;
            mergedActionOwners[key] = ownerId;
        }
    };
    _mergeActions($58029952ef70329d$var$_takeoverActions, 'workspaceModule', $58029952ef70329d$var$_takeoverStash && $58029952ef70329d$var$_takeoverStash.id);
    for (const p of appProjects)_mergeActions(p.actions, p.id, p.id);
    // Build the ONE shared capability bridge set over the union of every app's
    // grants — plus the single approval-action trio over the merged registry —
    // and inject under the plain names apps call (moduleData / moduleAiChat /
    // moduleFileUpload / proposeModuleAction / …), tracked in the synthetic caps
    // ledger so the next load tears it down and rebuilds it. This is what lets
    // two record-using apps (crm + cms) both reach the records plane, and what
    // makes EVERY installed app's actions proposable — a per-app bridge/trio
    // would collide on the shared name and only the first would work.
    const hasIntegrationsGrant = integrationKindsWildcard || integrationCapabilitiesWildcard || mergedIntegrationKinds.size || mergedIntegrationCapabilities.size;
    // Installed surfaces that may post workspace notifications through the ONE
    // shared `moduleNotify` bridge — the takeover module (if any) plus every
    // loaded additive app. Ambient like moduleOpenPage (no capability grant:
    // the server surface already lets any member notify another member; the
    // bridge only constrains recipients to the workspace roster and stamps the
    // caller's app identity + a workspace-addressed href).
    const notifyIds = [
        ...$58029952ef70329d$var$_takeoverStash && $58029952ef70329d$var$_takeoverStash.id ? [
            $58029952ef70329d$var$_takeoverStash.id
        ] : [],
        ...loaded.map((a)=>a.appId)
    ].filter(Boolean);
    if (ctx && (mergedCollections.size || hasIntegrationsGrant || aiCap || filesCap || mergedDependencies.size || Object.keys(mergedActions).length || notifyIds.length)) {
        const led = {
            components: [],
            functions: [],
            pages: []
        };
        ctx.functions = ctx.functions || {};
        // WS-MODULE-OWN-KEYS-STALE-ACROSS-ORG-SWITCH-1 — see _captureBags.
        led.bags = $58029952ef70329d$var$_captureBags(ctx, routedEl);
        const capFns = {};
        if (mergedDependencies.size) {
            const deps = Object.fromEntries(mergedDependencies);
            capFns.moduleImport = (0, $i8Ov5.buildModuleImportBridge)(deps);
            capFns.moduleAssetUrl = (0, $i8Ov5.buildModuleAssetUrlBridge)(deps);
            capFns.moduleMount = (0, $i8Ov5.buildModuleMountBridge)(deps);
            capFns.moduleUnmount = (0, $i8Ov5.buildModuleUnmountBridge)();
            capFns.moduleApi = (0, $i8Ov5.buildModuleApiBridge)();
            capFns.moduleToken = (0, $i8Ov5.buildModuleTokenBridge)();
            capFns.moduleTheme = (0, $i8Ov5.buildModuleThemeBridge)();
        }
        // The page seams for INSTALLED apps (current-2a 2026-09-28): an app from
        // the App Store opens its own records in the PageSlot (moduleOpenPage)
        // and writes a same-page record open into the address (setModuleRouteQuery
        // — `/realestate?unit=…`), exactly like a takeover module. Ambient like
        // moduleNotify: both are scope-guarded to the installed modules' own
        // pages (moduleOpenBridge.js), and a takeover's own copies win below.
        capFns.moduleOpenPage = (0, $atmQm.buildModuleOpenBridge)(root);
        capFns.setModuleRouteQuery = (0, $atmQm.buildModuleRouteQueryBridge)(root);
        // Same seam for installed apps: hide the shell composer on the caller's
        // own page only (moduleShellComposer.js). Ambient like moduleOpenPage.
        capFns.setShellComposer = (0, $984mC.buildModuleShellComposerBridge)(root, {
            moduleIdOf: $58029952ef70329d$export$35a4f2bf5f18fb05
        });
        // What the member may see (MODULE-ROLE-CAN-BRIDGES-1): their role and
        // whether they hold a permission key, from the workspace read's `access`
        // — so an app hides what its member cannot use (moduleAccessBridge.js).
        // Ambient like moduleOpenPage: read-only answers about the caller.
        capFns.moduleRole = (0, $5gsjA.buildModuleRoleBridge)(root);
        capFns.moduleCan = (0, $5gsjA.buildModuleCanBridge)(root);
        // An app asks the assistant about what it shows, the context structured
        // like an Inspect & ask pick (moduleAskBridge.js, MODULE-ASK-BRIDGE-1).
        capFns.moduleAsk = (0, $asht4.buildModuleAskBridge)(root);
        capFns.moduleData = (0, $f18a7.buildModuleDataBridge)(root, {
            ...mergedCollections.size ? {
                records: {
                    collections: [
                        ...mergedCollections
                    ],
                    ops: [
                        ...mergedOps
                    ]
                }
            } : {},
            ...hasIntegrationsGrant ? {
                integrations: {
                    kinds: integrationKindsWildcard ? '*' : [
                        ...mergedIntegrationKinds
                    ],
                    capabilities: integrationCapabilitiesWildcard ? '*' : [
                        ...mergedIntegrationCapabilities
                    ]
                }
            } : {}
        }, $58029952ef70329d$var$_moduleDataBridgeOpts());
        // Unconditional for the same cold-boot heal as the takeover path — the
        // bridge checks the live grant per call.
        capFns.moduleAiChat = (0, $8Oeas.buildModuleAiBridge)(root, aiCap ? {
            ai: aiCap
        } : {});
        capFns.moduleAiStream = (0, $8Oeas.buildModuleAiStreamBridge)(root, aiCap ? {
            ai: aiCap
        } : {});
        capFns.moduleAiAdmin = (0, $8Oeas.buildModuleAiAdminBridge)(root, aiCap ? {
            ai: aiCap
        } : {});
        if (filesCap) {
            capFns.moduleFileUpload = (0, $jqUS6.buildModuleFileBridge)(root, {
                files: filesCap
            });
            capFns.moduleFileUploadLarge = (0, $jqUS6.buildModuleFileUploadLargeBridge)(root, {
                files: filesCap
            });
            capFns.moduleFileList = (0, $jqUS6.buildModuleFileListBridge)(root, {
                files: filesCap
            });
            capFns.moduleFileRead = (0, $jqUS6.buildModuleFileReadBridge)(root, {
                files: filesCap
            });
            capFns.moduleFileExtractText = (0, $jqUS6.buildModuleFileExtractTextBridge)(root, {
                files: filesCap
            });
            capFns.moduleFileUpdate = (0, $jqUS6.buildModuleFileUpdateBridge)(root, {
                files: filesCap
            });
            capFns.moduleFileCreate = (0, $jqUS6.buildModuleFileCreateBridge)(root, {
                files: filesCap
            });
        }
        if (Object.keys(mergedActions).length) // Resolve EACH action's validate/summarize/run root to its OWNER
        // module's own state store — falls back to the shell root when that
        // module never built one (e.g. it declared actions but its page never
        // mounted this session), same soft-fail as an unscoped module.
        Object.assign(capFns, (0, $6lGuT.buildModuleActionFns)(mergedActions, (actionKey, shellRoot)=>{
            const ownerId = mergedActionOwners[actionKey];
            return ownerId != null ? shellRoot._moduleStateGet?.(ownerId) : null;
        }));
        if (notifyIds.length) {
            capFns.moduleNotify = (0, $duW2E.buildModuleNotifyBridge)(root, notifyIds, $58029952ef70329d$var$_sdkFnOverrideForTests ? {
                getSdkFn: $58029952ef70329d$var$_sdkFnOverrideForTests
            } : undefined);
            // Its pair: close the open notices an app sent under one dedupKey.
            capFns.moduleNotifyClose = (0, $duW2E.buildModuleNotifyCloseBridge)(root, notifyIds, $58029952ef70329d$var$_sdkFnOverrideForTests ? {
                getSdkFn: $58029952ef70329d$var$_sdkFnOverrideForTests
            } : undefined);
        }
        // A name the TAKEOVER ledger already holds is the takeover loader's own
        // platform bridge over its own grant — that loader always runs first on
        // every activation path and owns it; this union covers the additive apps.
        // Not a collision and not a warn (it used to log `key collision skipped:
        // moduleData/moduleAiChat/moduleAiAdmin` on every cold takeover boot,
        // which hid the one real collision — WS-MODULEDATA-GRANT-LOST-ON-ORG-
        // RETURN-1 — in noise).
        for (const k of Object.keys(capFns))if (k in ctx.functions && $58029952ef70329d$var$_injectedFunctionKeys.includes(k)) delete capFns[k];
        $58029952ef70329d$var$_injectEntries(ctx.functions, capFns, led.functions);
        $58029952ef70329d$var$_injectedByApp.set($58029952ef70329d$var$_CAPS_LEDGER, led);
    }
    // Publish the AI-surface stash composed over the takeover module + the
    // additive apps, so the assistant's knowledge layer (uiCatalog), the client
    // tool gate (aiFunctions) and the chat starters cover app-only workspaces
    // too — the additive loader used to leave root.workspaceProject null, which
    // blanked all three for every workspace without a takeover module.
    // Definitive vs transient verdict for THIS pass. `loaded === 0` while the
    // record names refs means every install failed to load (network/auth churn,
    // channel resolution outage) — publish what we have, but keep the converge
    // retry armed and do NOT latch the 404 suppression as "settled": a settled
    // empty surface with N>0 installed apps is exactly the empty-dashboard bug.
    // Refs that are ALL unresolvable extensions land here too — the retry is
    // bounded by the converge loop's backoff, which settles the latch on
    // give-up so a genuinely dead catalog still 404s instead of blanking.
    const definitive = loaded.length === refs.length;
    // Every ref that did NOT load and carries a content verdict. Their failure is
    // settled: a retry re-reads the same published payload and refuses it again.
    // Naming them is the only useful thing left to do — the owner has to
    // republish or remove the app.
    const _loadedIds = new Set(loaded.map((a)=>a.appId));
    const blockedIds = refs.map($58029952ef70329d$var$_appId).filter((id)=>!_loadedIds.has(id) && $58029952ef70329d$var$_refusals.has(id));
    // Settled = nothing left that a retry could still turn into a load. Note this
    // holds `loaded.length === 0` too: an install list of one blocked app is
    // blocked, not 'error', and must not keep the converge loop running.
    const settled = !definitive && loaded.length + blockedIds.length === refs.length;
    $58029952ef70329d$var$_lastAppsOutcome = refs.length === 0 ? 'empty' : definitive ? 'active' : settled ? 'blocked' : loaded.length ? 'partial' : 'error';
    if (blockedIds.length) console.warn('[workspaceApps] blocked, a retry cannot change this:', blockedIds.map((id)=>`${id} (${$58029952ef70329d$var$_refusals.get(id).code})`).join(', '));
    $58029952ef70329d$export$5cda0d0e0ba2885a(root, 'apps', {
        state: $58029952ef70329d$var$_lastAppsOutcome === 'active' ? 'ready' : $58029952ef70329d$var$_lastAppsOutcome,
        loaded: loaded.length,
        total: refs.length,
        blocked: blockedIds
    });
    // BOOT-RESHUFFLE F4: identical-republish guard, same shape as the takeover
    // publish above. `root.workspaceApps` is nulled by the switch registry —
    // a wiped root always republishes regardless of the fingerprint.
    const _appsFp = $58029952ef70329d$var$_publishFp([
        'apps',
        String(wsId || ''),
        loaded,
        $58029952ef70329d$var$_takeoverStash ? 1 : 0
    ]);
    if (_appsFp && _appsFp === $58029952ef70329d$var$_lastAppsFp && Array.isArray(root.workspaceApps)) // identical republish — still re-assert the routes-settled latch when
    // this pass is definitive and the latch is down.
    {
        if (definitive && !root._appRoutesSettled) root.update({
            _appRoutesSettled: true
        });
    } else {
        $58029952ef70329d$var$_lastAppsFp = _appsFp;
        const _composedStash = $58029952ef70329d$var$_composeAiStash($58029952ef70329d$var$_takeoverStash, appProjects, mergedActions);
        // Hold the last-known chrome through TRANSITIONAL rebuilds: this composed
        // republish can run while the takeover reload is mid-flight
        // (_takeoverStash null), and a chrome-less frame unmounts the always-on
        // module rail + drops the immersive gates until convergence re-publishes
        // (measured live 2026-08-14: rail flicker + double-sidebar on View-as).
        // A rebuild that genuinely removes the module tears the stash down via
        // `workspaceProject: null` elsewhere, so carrying forward never
        // resurrects a dead module's chrome.
        // ⚠ ALSO LOAD-BEARING FOR THE STAGE REPAIR (BF-STAGE-ACTIVATION-
        // FLAKE-1): the takeover swallow branch calls applyStageVar, whose
        // removal path is reachable only if a chrome-less stash can sit on the
        // root while the module has chrome — exactly what this hold prevents.
        // Removing or narrowing it makes `--stage-bg` actively REMOVABLE at
        // the swallow, and the wrong-colour flake returns on a build that
        // carries the fix.
        if (_composedStash && !_composedStash.chrome && root.workspaceProject && root.workspaceProject.chrome) _composedStash.chrome = root.workspaceProject.chrome;
        const tPublish = $58029952ef70329d$var$_spanStart();
        root.update({
            workspaceApps: loaded,
            workspaceProject: _composedStash,
            // Route injection is COMPLETE at this point — latch the '/*' catch-all's
            // 404 suppression here, in the function BOTH loader entrypoints share.
            // auth.js's `_ensureWorkspaceModule` also settles this after its chain,
            // but workspace switches load the module via `onWorkspaceChange`, which
            // never passes through that wrapper — on those boots the latch stayed
            // unset forever and a genuinely nonexistent path showed a blank page
            // instead of its 404 (measured: apps=9 injected, 185 routes live,
            // `_appRoutesSettled` still undefined). Setting it in the same update
            // that publishes the injected apps closes every DEFINITIVE path; a pass
            // that expected apps and loaded none stays unsettled and retries.
            // A BLOCKED pass settles here too: its unloaded apps carry content
            // verdicts, so no later pass will add a route, and leaving the latch down
            // would hide every genuinely nonexistent path behind a loader forever.
            ...definitive || settled ? {
                _appRoutesSettled: true
            } : {}
        });
        $58029952ef70329d$var$_span('module-apps', 'publish', tPublish);
    }
    if (!definitive) {
        console.warn('[workspaceApps]', loaded.length, 'of', refs.length, settled ? "installed apps loaded \u2014 the rest are blocked" : "installed apps loaded \u2014 will retry");
        // A settled pass has nothing left to converge ON: every unloaded app
        // carries a content verdict. Scheduling the loop anyway made it wake, read
        // the same verdict and stand down, once per backoff step.
        if (!settled) $58029952ef70329d$var$_scheduleModuleConverge(root);
    }
    // Same reload recovery the takeover loader gets — a hard load on an installed
    // app's route boots before these routes exist and would otherwise strand.
    $58029952ef70329d$var$_rerouteIfStranded(root, ctx && ctx.pages, 'workspaceApps');
    try {
        if (root && typeof root.update === 'function') root.update({
            _wsAppsActivating: false
        });
    } catch (flagErr) {
    /* non-fatal — the flag is a hint for the not-found page, nothing more */ }
    // Boot fix step 4b: a ?page=<app route> deep link opens its sheet with the
    // REAL page, so that app sets up before the restore; the rest set up in
    // idle slices after the reveal, home feeders first.
    try {
        const search = typeof window !== 'undefined' && window.location && window.location.search || '';
        const pageParam = search ? new URLSearchParams(search).get('page') : null;
        const pagePath = pageParam ? String(pageParam).split('?')[0].split('#')[0] : null;
        const target = pagePath && [
            ...$58029952ef70329d$var$_appActivations.values()
        ].find((e)=>e.root === root && !e.done && e.placeholders[pagePath]);
        if (target) await $58029952ef70329d$export$eb600665dd60f5f(target);
    } catch (_) {
    /* the sheet falls back to the placeholder, which opens the app itself */ }
    // `_appsSettingUp` holds the home's saved-cell skeletons (pages/main.js
    // _moduleRoutesPending) until every app's widgets have published.
    if ($58029952ef70329d$var$_activationsPending(root)) {
        root.update({
            _appsSettingUp: true
        });
        $58029952ef70329d$var$_runAppActivations(root, ()=>{
            if (root._appsSettingUp) root.update({
                _appsSettingUp: false
            });
        });
    }
    // Deep-link restore for app-only workspaces — `ctx.pages` now carries every
    // additive app's injected routes, so a ?page=<app route> URL opens its sheet
    // instead of stranding on Home.
    $58029952ef70329d$export$ac4776a1cef5badb(root, ctx && ctx.pages);
    $58029952ef70329d$var$_mark('wsboot:module-apps:pass-end');
    $58029952ef70329d$var$_measure('wsboot:module-apps:pass', 'wsboot:module-apps:pass-start', 'wsboot:module-apps:pass-end');
    if (!isStale() && (definitive || settled)) $58029952ef70329d$var$_appsSettled = {
        key: flightKey,
        root: root,
        result: loaded,
        surface: root.workspaceApps
    };
    return loaded;
};

});
parcelRegister("hWNk6", function(module, exports) {

$parcel$export(module.exports, "normalizeWidgetHelp", () => $d10e1d05414322dc$export$414895f455ed1ac8);
// The widget `help` field — an OPTIONAL (?) beside a widget's header title.
//
// ── WHY ───────────────────────────────────────────────────────────────────
// A widget header holds a title and, optionally, one short subtitle. A module
// that wants to EXPLAIN its widget has nowhere to put the sentence, so it puts
// it in the header: VaultOS 1.38.1 shipped five home widgets whose captions ran
// as long as their titles, and the board read as prose instead of as cards
// (measured 2026-09-10). `help` is that sentence's proper home — folded behind
// a question mark the reader opens when they want it, and closed the rest of
// the time, so the header keeps ONE line of chrome at every width.
//
// ── THE CONTRACT (what a module author writes) ────────────────────────────
// On a manifest widget row (`manifest.widgets[]`), and on a house catalog row
// in pages/main.js, `help` is optional and takes either shape:
//
//   help: 'vault.widget.rooms.help'                       // shorthand — tip only
//   help: { tip: 'vault.widget.rooms.help' }              // same thing
//   help: { tip: '…', ariaLabel: 'vault.widget.rooms.helpAria' }
//
//   tip        REQUIRED. A string OR a polyglot key. What the (?) reveals.
//              Resolved EXACTLY the way a widget `title` is — through
//              `el.call('polyglot', …)` at the render site — and polyglot
//              returns a non-key verbatim, so a plain English sentence and a
//              bundle key both work, with no flag to choose between them.
//   ariaLabel  OPTIONAL. A string OR a polyglot key. The accessible name of
//              the (?) control. DEFAULTS TO `tip`: the control's only purpose
//              is to reveal that sentence, so naming it with the sentence
//              loses nothing and costs no bundle key. Pass a short one when
//              the tip is long.
//
// Anything else — no `help`, no `tip`, a blank string, an array, a number, a
// function — normalises to `null`, and the widget header renders NOTHING
// extra. A `help` is never a required field and its absence is never an error.
//
// ── WHY IT IS NORMALISED ONCE, HERE ───────────────────────────────────────
// Three readers want it (the module-manifest loader in
// functions/workspaceProjects.js, the static widget header and the module
// widget header in pages/main.js), and a field with two accepted shapes read
// three times is a field with three slightly different meanings. One
// normaliser, one output shape: `{ tip, ariaLabel }` with both strings
// non-empty, or `null`.
const $d10e1d05414322dc$export$414895f455ed1ac8 = (help)=>{
    if (!help) return null;
    if (typeof help === 'string') {
        const tip = help.trim();
        return tip ? {
            tip: tip,
            ariaLabel: tip
        } : null;
    }
    if (typeof help !== 'object' || Array.isArray(help)) return null;
    const tip = typeof help.tip === 'string' ? help.tip.trim() : '';
    if (!tip) return null;
    const aria = typeof help.ariaLabel === 'string' ? help.ariaLabel.trim() : '';
    return {
        tip: tip,
        ariaLabel: aria || tip
    };
};

});

parcelRegister("fcczA", function(module, exports) {

$parcel$export(module.exports, "localWorkspaceAppLoader", () => $b101bac0b5116a8f$export$a7a13d727f19f64b);
// Dev-only local source for installed workspace apps.
//
// An installed app (apps/* — system/crm-app, …) normally arrives as a published
// payload through fetchProjectFromSDK, so an edit under apps/ never reaches the
// shell until it is published. Listing an app's `owner/key` in
// `localStorage.workspaceAppsLocal` (a JSON array) makes _fetchAndBuildModule
// build that app's payload from its local source instead — the same object the
// app's own standalone boot sees: `config.js` (manifest v2 extras) plus the
// `symbols/index.js` sections. Parcel then bundles and watches those files, so
// an edit rebuilds the shell.
//
//   localStorage.workspaceAppsLocal = JSON.stringify(['system/crm-app'])
//   localStorage.removeItem('workspaceAppsLocal')
//
// The app must still be installed in the workspace: this only swaps where its
// code comes from, never which apps the server says are installed.
//
// One entry per apps/* folder with a package.json, keyed by its symbols.json
// `owner/key` (localWorkspaceApps.test.js keeps the two in step). Each import
// path is spelled out: Parcel only bundles a literal import() specifier.
//
// The loader map sits behind `process.env.NODE_ENV === 'development'`, which
// Parcel inlines — a production bundle drops the branch and never pulls apps/*
// in. The opt-in is read at runtime on top of that.
const $b101bac0b5116a8f$var$LOCAL_APPS_KEY = 'workspaceAppsLocal';
const $b101bac0b5116a8f$var$_loaders = {};

$b101bac0b5116a8f$var$_loaders['system/assistants-app'] = ()=>(parcelRequire("1qlkh"));

$b101bac0b5116a8f$var$_loaders['system/bi-app'] = ()=>(parcelRequire("e0NO5"));

$b101bac0b5116a8f$var$_loaders['system/bookmarks-app'] = ()=>(parcelRequire("fq8YJ"));

$b101bac0b5116a8f$var$_loaders['system/cap-table-app'] = ()=>(parcelRequire("kSK4w"));

$b101bac0b5116a8f$var$_loaders['system/catalog-app'] = ()=>(parcelRequire("a7o5f"));

$b101bac0b5116a8f$var$_loaders['system/cms-app'] = ()=>(parcelRequire("f99Ni"));

$b101bac0b5116a8f$var$_loaders['system/commerce-app'] = ()=>(parcelRequire("fHQBL"));

$b101bac0b5116a8f$var$_loaders['system/crm-app'] = ()=>(parcelRequire("7qeSZ"));

$b101bac0b5116a8f$var$_loaders['system/gazer-app'] = ()=>(parcelRequire("hoFij"));

$b101bac0b5116a8f$var$_loaders['system/growth-app'] = ()=>(parcelRequire("i4y0L"));

$b101bac0b5116a8f$var$_loaders['system/helmet-app'] = ()=>(parcelRequire("cv1dg"));

$b101bac0b5116a8f$var$_loaders['system/hr-app'] = ()=>(parcelRequire("aL87a"));

$b101bac0b5116a8f$var$_loaders['system/insurance-app'] = ()=>(parcelRequire("76R62"));

$b101bac0b5116a8f$var$_loaders['system/invoices-app'] = ()=>(parcelRequire("a4yDd"));

$b101bac0b5116a8f$var$_loaders['system/jobs-app'] = ()=>(parcelRequire("eUDPh"));

$b101bac0b5116a8f$var$_loaders['system/orders-app'] = ()=>(parcelRequire("c8dgm"));

$b101bac0b5116a8f$var$_loaders['system/payroll-app'] = ()=>(parcelRequire("8Gcrr"));

$b101bac0b5116a8f$var$_loaders['system/policies-management-app'] = ()=>(parcelRequire("gBje0"));

$b101bac0b5116a8f$var$_loaders['system/polyglot-app'] = ()=>(parcelRequire("9Vdab"));

$b101bac0b5116a8f$var$_loaders['system/production-app'] = ()=>(parcelRequire("fAnOD"));

$b101bac0b5116a8f$var$_loaders['system/realestate-app'] = ()=>(parcelRequire("aLmjf"));

$b101bac0b5116a8f$var$_loaders['system/scheduling-app'] = ()=>(parcelRequire("9glIA"));

$b101bac0b5116a8f$var$_loaders['system/socials-app'] = ()=>(parcelRequire("eSvYK"));

$b101bac0b5116a8f$var$_loaders['system/terminal-app'] = ()=>(parcelRequire("hZhUj"));

$b101bac0b5116a8f$var$_loaders['system/warehouse-app'] = ()=>(parcelRequire("1g9G6"));
const $b101bac0b5116a8f$var$_optedIn = ()=>{
    try {
        const raw = typeof localStorage !== 'undefined' && localStorage.getItem($b101bac0b5116a8f$var$LOCAL_APPS_KEY);
        const list = raw ? JSON.parse(raw) : null;
        return Array.isArray(list) ? list.map(String) : [];
    } catch (_) {
        return [];
    }
};
const $b101bac0b5116a8f$var$_announced = new Set();
const $b101bac0b5116a8f$export$a7a13d727f19f64b = (owner, key)=>{
    const id = `${owner}/${key}`;
    const load = $b101bac0b5116a8f$var$_loaders[id];
    if (!load || !$b101bac0b5116a8f$var$_optedIn().includes(id)) return null;
    return async ()=>{
        const context = (await load()).default || {};
        if (!$b101bac0b5116a8f$var$_announced.has(id)) {
            $b101bac0b5116a8f$var$_announced.add(id);
            console.warn(`[workspaceApps] LOCAL SOURCE ACTIVE \u{2014} ${id} loads from apps/ instead of its published ` + `payload. Clear with localStorage.removeItem('${$b101bac0b5116a8f$var$LOCAL_APPS_KEY}').`);
        }
        // Module namespaces are frozen (context.js pulls whole sections in as
        // `import * as components`), and the loader writes into the payload — copy
        // every namespace into a plain object.
        const data = {};
        for (const [name, value] of Object.entries(context))data[name] = Object.prototype.toString.call(value) === '[object Module]' ? {
            ...value
        } : value;
        return data;
    };
};

});

parcelRegister("g7CNh", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_NAVBAR", () => $bbcb6469932687c5$export$4fbb9df63dbf8321);
$parcel$export(module.exports, "DEFAULT_DESIGN_SYSTEM", () => $bbcb6469932687c5$export$586898d32e949b88);
$parcel$export(module.exports, "DEFAULT_CONFIG", () => $bbcb6469932687c5$export$c2f8e0cc249a8d8f);
$parcel$export(module.exports, "installedAppRefs", () => $bbcb6469932687c5$export$e9bdd65c0a29bfaf);
$parcel$export(module.exports, "shellDeepEqual", () => $bbcb6469932687c5$export$b64b70f6ab4b814b);
$parcel$export(module.exports, "extensionAppRows", () => $bbcb6469932687c5$export$31afe92ffbcdb2d8);
$parcel$export(module.exports, "resolveWorkspaceConfig", () => $bbcb6469932687c5$export$43825f9143f08441);
$parcel$export(module.exports, "resolveDesignSystemVars", () => $bbcb6469932687c5$export$8467e4da404b12f1);
$parcel$export(module.exports, "watchDesignSystemTheme", () => $bbcb6469932687c5$export$9ac69f1298a64dd4);
$parcel$export(module.exports, "applyWorkspaceConfig", () => $bbcb6469932687c5$export$18eca25bb66a0a25);
// Per-workspace settings + personalization.
//
// `root.workspaceSettings` is the per-workspace settings bag. It carries
// `home_default_panels` plus these per-workspace personalization fields, all
// resolved from the server workspace record's `settings` bag (ONE store —
// `Workspace.settings`, written via the merge-safe sdk.updateWorkspaceSettings.
// A separate `workspace_dashboard_defaults` row used to double as a second
// home_default_panels source; retired 2026-07-13, see loadPrivateData.js
// _dashboardPrefsFetches and tickets/workspace.md "home_default_panels
// dual-store fight"):
//
//   designSystem        — personalized look (canvas bg + color/shadow overrides)
//   language            — BCP-47 lang for <html lang>
//   layoutDirection     — 'ltr' | 'rtl' for <html dir>
//   navbar              — ordered HeaderTabs arrangement; default Studio/Tasks/Files
//   modules             — enabled workspace module ids
//   home_default_panels — visible home dashboard widget ids
//   apps                — apps-menu section entries
//
// PRECEDENCE (resolveWorkspaceConfig): the unpacked workspace PROJECT
// (root.workspaceProject.config — functions/workspaceProjects.js, the
// integration-based source of truth) ▸ the Mongo workspace record `settings`
// bag (org-guarded, generic per-workspace personalization) ▸ DEFAULT_CONFIG
// (framework default). No workspace is special-cased in this file.
//
// A workspace's config is APPLIED when it becomes active — see
// applyWorkspaceConfig, driven from loadPrivateData (boot) + onWorkspaceChange,
// which call loadWorkspaceProject first so the project is in context. The skin
// reverts to the framework default as part of that activate-new cycle
// (_applyDesignSystem reverts the previous workspace's vars before applying).

var $1X0Je = parcelRequire("1X0Je");

var $kO6Bt = parcelRequire("kO6Bt");

var $5gsjA = parcelRequire("5gsjA");

var $8Zc6q = parcelRequire("8Zc6q");
const $bbcb6469932687c5$var$shellSetCanvasBackgroundVar = (...args)=>(0, $1X0Je.default).functions.setCanvasBackgroundVar(...args);
const $bbcb6469932687c5$var$shellClearCanvasBackgroundVar = (...args)=>(0, $1X0Je.default).functions.clearCanvasBackgroundVar(...args);
const $bbcb6469932687c5$var$shellResolveCanvasBackgroundTheme = (...args)=>(0, $1X0Je.default).functions.resolveCanvasBackgroundTheme(...args);
const $bbcb6469932687c5$var$shellWorkspaceSettings = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
const $bbcb6469932687c5$var$shellResolveWorkspaceThemeMode = (...args)=>(0, $1X0Je.default).functions.resolveWorkspaceThemeMode(...args);
const $bbcb6469932687c5$var$shellUserHasOwnThemeChoice = (...args)=>(0, $1X0Je.default).functions.userHasOwnThemeChoice(...args);
const $bbcb6469932687c5$var$shellHasNoStoredThemeMode = (...args)=>(0, $1X0Je.default).functions.hasNoStoredThemeMode(...args);
// Opt-in boot breadcrumbs (`?trail=1`) — inert otherwise. See bootTrail.js
// for why a wedged renderer cannot be diagnosed by any post-hoc probe.
// Optional-call on purpose, unlike its load-bearing neighbours above: this
// is a diagnostic, and it is called at the ENTRY of applyWorkspaceConfig,
// outside any try. If a stale shared build ever resolves without it, a
// plain call would throw there and take workspace activation down with it —
// a debugging aid that can break the boot is worse than no aid at all.
const $bbcb6469932687c5$var$shellBootTrail = (...args)=>(0, $1X0Je.default).functions.bootTrail?.(...args);
const $bbcb6469932687c5$export$4fbb9df63dbf8321 = [
    {
        label: 'shell.app.studio',
        path: '/apps'
    },
    {
        label: 'shell.app.tasks',
        path: '/tasks'
    },
    {
        label: 'shell.app.files',
        path: '/files'
    }
];
const $bbcb6469932687c5$export$586898d32e949b88 = null // null = framework default (no overrides)
;
const $bbcb6469932687c5$export$c2f8e0cc249a8d8f = {
    navbar: $bbcb6469932687c5$export$4fbb9df63dbf8321,
    designSystem: $bbcb6469932687c5$export$586898d32e949b88,
    language: 'en',
    // 'default' | 'enforced' (workspace-shared functions/languages.js
    // DEFAULT_LANGUAGE_POLICY). Since 2026-09-10 the two RENDER THE SAME: the
    // workspace's own `language` decides its interface language for every
    // member, and a workspace that sets none renders English. A member's own
    // account preference and this device's stored choice outrank nothing
    // inside a workspace (resolveLang ignores both), and setLang refuses a
    // switch the workspace's resolved language would revert. Carried through
    // this file for the admin card that reads `root.workspaceSettings`; the
    // RESOLUTION itself lives in `enforcedWorkspaceLang` + `resolveLang`, never
    // here.
    languagePolicy: 'default',
    layoutDirection: 'ltr',
    modules: null
};
const $bbcb6469932687c5$var$_lc = (v)=>v == null ? '' : String(v).toLowerCase();
const $bbcb6469932687c5$export$e9bdd65c0a29bfaf = (settings)=>{
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const idOf = (ref)=>`${lc(ref && ref.owner)}/${lc(ref && ref.key)}`;
    const list = settings && Array.isArray(settings.workspaceApps) ? settings.workspaceApps : [];
    const byId = new Map();
    for (const c of list){
        if (!c || typeof c !== 'object') continue;
        if (c.type === 'extension' && c.projectId) {
            const norm = {
                owner: 'extension',
                key: String(c.projectId),
                ...c
            };
            byId.set(idOf(norm), norm);
            continue;
        }
        if ((!c.type || c.type === 'project') && c.owner && c.key) byId.set(idOf(c), c);
    }
    return [
        ...byId.values()
    ];
};
const $bbcb6469932687c5$export$b64b70f6ab4b814b = (a, b, seen = null)=>{
    if (a === b) return true;
    if (typeof a === 'number' && typeof b === 'number') return Number.isNaN(a) && Number.isNaN(b);
    if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return false;
    if (a instanceof Date || b instanceof Date) return a instanceof Date && b instanceof Date && a.getTime() === b.getTime();
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    if (seen) for (const [sa, sb] of seen){
        if (sa === a && sb === b) return false;
    }
    else seen = [];
    seen.push([
        a,
        b
    ]);
    const ka = Object.keys(a);
    const kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    for (const k of ka){
        if (!Object.prototype.hasOwnProperty.call(b, k)) return false;
        if (!$bbcb6469932687c5$export$b64b70f6ab4b814b(a[k], b[k], seen)) return false;
    }
    return true;
};
// ── Legacy navbar-label migration (i18n, 2026-09-02) ─────────────────────────
// DEFAULT_NAVBAR's labels used to be the English WORDS; they are polyglot KEYS
// now. A workspace whose admin saved the navbar through the module console
// before that change has the old words persisted in Mongo `settings.navbar`,
// and those rows have to keep behaving like the shipped default — otherwise
// `_sameNavbar` below stops recognising them, the bare-default guard in
// applyWorkspaceConfig flips them to "a deliberate personalization", and a
// module's own navbar can never win again (the exact failure that guard was
// written for). They must also render translated, like any other house row.
//
// The match is a (path, exact-old-word) PAIR, so it is as tight as it can be:
// a workspace that RENAMED /studio to "Design Lab", or that named some other
// route "Studio", is untouched and stays the customer's content. This is a
// migration table — it encodes history, not copy — so the English words are
// frozen here on purpose and must never grow a fourth entry for a NEW default
// (a new default ships with its key from day one).
const $bbcb6469932687c5$var$_LEGACY_NAVBAR_LABEL_KEYS = {
    '/studio': {
        Studio: 'shell.app.studio'
    },
    '/tasks': {
        Tasks: 'shell.app.tasks'
    },
    '/files': {
        Files: 'shell.app.files'
    }
};
// ── The shipped "Apps" tab moved (2026-10-25, ledger AS-3) ──────────────────
// DEFAULT_NAVBAR's first tab opens /apps now (see its header). A workspace
// that stored the OLD shipped row (`shell.app.studio` on /studio) stored the
// bare default, so that row moves with the default — otherwise `_sameNavbar`
// would read it as a deliberate personalization and a module's own bar could
// never win again (the bare-default guard in applyWorkspaceConfig). Like the
// table above, the match is the exact shipped (path, label) pair: a tab a
// person renamed or pointed elsewhere is theirs and stays untouched.
const $bbcb6469932687c5$var$_MOVED_NAVBAR_ROWS = {
    '/studio': {
        'shell.app.studio': '/apps'
    }
};
const $bbcb6469932687c5$var$_canonicalNavbar = (nav)=>{
    if (!Array.isArray(nav)) return nav;
    let changed = false;
    const out = nav.map((tab)=>{
        const key = tab && $bbcb6469932687c5$var$_LEGACY_NAVBAR_LABEL_KEYS[tab.path]?.[tab.label];
        const row = key ? {
            ...tab,
            label: key
        } : tab;
        const movedTo = row && $bbcb6469932687c5$var$_MOVED_NAVBAR_ROWS[row.path]?.[row.label];
        if (!key && !movedTo) return tab;
        changed = true;
        return movedTo ? {
            ...row,
            path: movedTo
        } : row;
    });
    // Identity is preserved when nothing migrated, so the deep-equal no-op guard
    // in applyWorkspaceConfig is unaffected on the common (already-key) path.
    return changed ? out : nav;
};
// Shallow navbar equality by ordered (path, label) pairs. Used to tell a real
// personalization from the bare shell default — see the navbar precedence in
// applyWorkspaceConfig.
const $bbcb6469932687c5$var$_sameNavbar = (a, b)=>{
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
    return a.every((t, i)=>t && b[i] && t.path === b[i].path && t.label === b[i].label);
};
// Stale-safety gate. `root.workspace` can lag `root.org` across an ORG switch
// (cross-org stale-workspace leak; see MEMORY cross-org-workspace-leak) — after
// switching away, root.workspace can STILL read the previous workspace doc while
// root.org is already the new org. So a Mongo `settings` bag is only trusted when
// the workspace record's parent org matches the active org.
const $bbcb6469932687c5$var$_workspaceBelongsToActiveOrg = (root)=>{
    const org = root.org || {};
    const ws = root.workspace || {};
    const orgId = $bbcb6469932687c5$var$_lc(org.id || org._id);
    const wsOrg = $bbcb6469932687c5$var$_lc(ws.organization || ws.organizationId || ws.org);
    return !!orgId && !!wsOrg && orgId === wsOrg;
};
// Resolve the active workspace's config. PRECEDENCE:
//   1) the unpacked workspace PROJECT (root.workspaceProject.config) — the
//      integration-based source of truth for a project-backed workspace
//      (skin/navbar/panels/apps/modules). Set by loadWorkspaceProject at init.
//   2) the Mongo workspace record's `settings` bag (org-guarded) — generic
//      per-workspace personalization for workspaces with no project.
//   3) DEFAULT_CONFIG (framework default).
// No workspace is special-cased here — a workspace gets a non-default config
// ONLY because its project (or Mongo settings) says so.
// Additive (app-mode) compose — a marketplace / add-app install must ADD the
// app to the workspace, never take it over (2026-07-23 per Nika: installing
// crm-app wiped the default navbar down to just "Contacts"). The install paths
// mark their ref `installMode: 'app'` (workspaceModuleRef.js); refs written by
// the admin module console / direct settings (client-workspace modules like
// greenig-app, bellforge-app, financials-app) carry no flag and keep the
// full-takeover semantics below. App-mode:
//   navbar               → base default + the app's entries APPENDED (deduped
//                          by path; a saved personalization still wins later
//                          in applyWorkspaceConfig's precedence)
//   home_default_panels  → NOT taken from the app (existing dashboard stays;
//                          the app's widgets are still offered via
//                          homeCatalogFor / Customize)
//   apps / everything else → the app's values (workspace-scoped surfaces)
// DECISION site (spec §5): "is the installed module app-mode or full-takeover?"
// Absent and unknown lead to the same branch — full-takeover semantics — and
// this is only ever consulted when `root.workspaceProject.config` already
// exists, i.e. after loadWorkspaceProject resolved the ref (which does its own
// full-record fetch when the bag is missing). So it does NOT gate on `ready`.
// It still reads through the accessor so the record's shape is respected: a
// list-shaped record must contribute nothing here rather than an `undefined`
// that reads identically to "no module".
// ONE rule, ONE place. This expression used to live here AND, restated from
// memory against the wrong plane, in functions/homeDefaultWidgets.js — where it
// read `root.workspaceSettings.workspaceModule` (the RESOLVED CONFIG bag this
// very file publishes, which never carries that key) and was inert on every
// real workspace. Delegating removes the second opinion: whatever decides that
// an app-mode install strips `home_default_panels` here is the same function
// that decides the home board's default widget set.
const $bbcb6469932687c5$var$_isAppModeInstall = (root)=>(0, $8Zc6q.isAppModeWorkspace)(root);
const $bbcb6469932687c5$var$_appendNavbar = (base, extra)=>{
    const out = Array.isArray(base) ? base.slice() : [];
    const seen = new Set(out.map((t)=>$bbcb6469932687c5$var$_lc(t && t.path)));
    for (const tab of Array.isArray(extra) ? extra : []){
        if (!tab || seen.has($bbcb6469932687c5$var$_lc(tab.path))) continue;
        seen.add($bbcb6469932687c5$var$_lc(tab.path));
        out.push(tab);
    }
    return out;
};
// ── The installed app's OWN identity, stamped onto the rows it contributes ──
//
// A row an app contributes (`configDefaults.navbar` / `.apps`, published on the
// app's manifest) carries only `{ label, path }` — WORDS, and no identity at
// all. So the shell had no way to ask "which app is this tab?" and the tab
// printed the manifest's English literal for good: "Warehouse" in the navbar
// while the App Store called the same record "Inventory / ინვენტარი".
//
// `appKey` is that missing identity: the store key of the app the row STANDS
// FOR, taken from the app's own `appId` (`system/warehouse-app` -> the record
// key `warehouse-app`, which is exactly what the store resolves its copy off).
// The render sites then read the label through THE store-copy resolver
// (`shared/functions/storeItemText.js`, `el.call('storeItemText', { key:
// row.appKey, name: row.label }, 'name')`) instead of printing the literal.
// One app, one name, one resolver — the shell never learns a second rule, and
// a third party's app or an extension keeps its own name for free, because
// `translate()` returns its input unchanged for a key nobody ships.
//
// ONE ROW ONLY, and this is a contract, not a shortcut: the app's store name
// names the APP. It can stand for a ROW only when the app contributes exactly
// one row of that kind. An app that contributes several is naming its own
// SUB-SURFACES (policies-management ships `Policies` + `Claims` on one appId),
// and no app-level name can be right for any single one of them — stamping
// them all would rename "Claims" to "Insurance Policy Dashboard". Unstamped
// rows keep their published words, exactly as today.
const $bbcb6469932687c5$var$_appRowsWithKey = (rows, appId)=>{
    if (!Array.isArray(rows) || rows.length !== 1 || !rows[0]) return rows;
    const key = String(appId || '').split('/').pop();
    if (!key) return rows;
    // A NEW object — an app's manifest rows are shared state, never mutated.
    return [
        {
            ...rows[0],
            appKey: key
        }
    ];
};
const $bbcb6469932687c5$export$31afe92ffbcdb2d8 = ({ key: key, projectId: projectId, name: name })=>{
    const path = '/x/' + (key || String(projectId));
    return {
        navbar: [
            {
                label: name,
                path: path
            }
        ],
        apps: [
            {
                title: name,
                route: path,
                projectId: String(projectId),
                kind: 'extension'
            }
        ]
    };
};
// Boot fix step 3a — the server-owned `nav` copy on each settings.workspaceApps[]
// entry (core app-nav contract): the rows an app contributes, readable at boot
// before its module loads. App content: only whitelisted string / number fields
// ride into a row (rendered as text by the same row consumers as a loaded app's).
const $bbcb6469932687c5$var$_navText = (v)=>typeof v === 'string' ? v : '';
const $bbcb6469932687c5$var$_navPick = (src, keys)=>{
    const out = {};
    for (const k of keys){
        const v = src[k];
        if (typeof v === 'string' || typeof v === 'number' && Number.isFinite(v)) out[k] = v;
    }
    return out;
};
const $bbcb6469932687c5$var$_navRows = (ref, appId)=>{
    const nav = ref && ref.nav;
    if (!nav || typeof nav !== 'object' || nav.v !== 1) return null;
    if (ref.type === 'extension') {
        const name = $bbcb6469932687c5$var$_navText(nav.name);
        if (!name) return null;
        return {
            appId: appId,
            ...$bbcb6469932687c5$export$31afe92ffbcdb2d8({
                key: $bbcb6469932687c5$var$_navText(nav.key),
                projectId: ref.projectId,
                name: name
            })
        };
    }
    const navbar = (Array.isArray(nav.navbar) ? nav.navbar : []).filter((r)=>r && $bbcb6469932687c5$var$_navText(r.path) && $bbcb6469932687c5$var$_navText(r.label)).map((r)=>$bbcb6469932687c5$var$_navPick(r, [
            'label',
            'path',
            'icon',
            'order',
            'permission'
        ]));
    const apps = (Array.isArray(nav.apps) ? nav.apps : []).filter((t)=>t && $bbcb6469932687c5$var$_navText(t.route) && $bbcb6469932687c5$var$_navText(t.title)).map((t)=>$bbcb6469932687c5$var$_navPick(t, [
            'title',
            'caption',
            'icon',
            'iconBg',
            'glyph',
            'route',
            'order',
            'permission'
        ]));
    if (!navbar.length && !apps.length) return null;
    return {
        appId: appId,
        navbar: navbar,
        apps: apps
    };
};
// The rows every installed app contributes, in INSTALL order: a loaded app
// (root.workspaceApps) speaks for itself; an app that has not loaded yet speaks
// through its entry's `nav`; an entry without `nav` adds nothing until it loads.
// Only the CURRENT workspace's full record is read (provenance + org guard), so
// a switch never paints the previous workspace's rows.
const $bbcb6469932687c5$var$_appRowSources = (root)=>{
    const published = Array.isArray(root && root.workspaceApps) ? root.workspaceApps : [];
    const { settings: settings, ready: ready } = $bbcb6469932687c5$var$shellWorkspaceSettings(root);
    const list = ready && settings && Array.isArray(settings.workspaceApps) && $bbcb6469932687c5$var$_workspaceBelongsToActiveOrg(root) ? settings.workspaceApps : null;
    if (!list) return published;
    const byId = new Map();
    for (const a of published)if (a && a.appId) byId.set($bbcb6469932687c5$var$_lc(a.appId), a);
    const out = [];
    // THE installed-app entries (installedAppRefs — the loader's own reader):
    // extensions come normalized to owner 'extension', key projectId; a row
    // that is not an app (the records-grant legacy-backfill row) never appears.
    for (const ref of $bbcb6469932687c5$export$e9bdd65c0a29bfaf(settings)){
        const id = $bbcb6469932687c5$var$_lc(ref.owner) + '/' + $bbcb6469932687c5$var$_lc(ref.key);
        const live = byId.get(id);
        if (live) out.push(live);
        else {
            const fromNav = $bbcb6469932687c5$var$_navRows(ref, id);
            if (fromNav) out.push(fromNav);
        }
    }
    return out;
};
// Append EVERY additive app's navbar entries (root.workspaceApps — loaded by
// loadWorkspaceApps) onto a base navbar, deduped by path. This is what makes
// installing app B not clobber app A: each app contributes its tabs on top of
// the base, in install order. Order is stable (the array preserves it).
// A row or tile an app gates on a permission key (MODULE-NAV-PERMISSION-1,
// manifest `permission: '<key>'` on configDefaults.navbar[i] / .apps[i]):
// shown only when the member holds the key — moduleCan's answer, so owners and
// admins always see it and an unknown member does not until the workspace
// record says. A hidden row also takes a stored copy of itself (same path)
// out of the base navbar, so a saved arrangement cannot bring it back.
const $bbcb6469932687c5$var$_gated = (item)=>!!item && typeof item.permission === 'string' && item.permission.trim() !== '';
const $bbcb6469932687c5$var$_hiddenFor = (root, item)=>$bbcb6469932687c5$var$_gated(item) && !(0, $5gsjA.memberCan)(root, item.permission);
const $bbcb6469932687c5$var$_appendAppsNavbar = (base, root)=>{
    let nav = base;
    for (const app of $bbcb6469932687c5$var$_appRowSources(root)){
        const rows = app && $bbcb6469932687c5$var$_appRowsWithKey(app.navbar, app.appId);
        const list = Array.isArray(rows) ? rows : [];
        const hidden = new Set(list.filter((r)=>$bbcb6469932687c5$var$_hiddenFor(root, r)).map((r)=>$bbcb6469932687c5$var$_lc(r.path)));
        if (hidden.size) nav = (Array.isArray(nav) ? nav : []).filter((t)=>!hidden.has($bbcb6469932687c5$var$_lc(t && t.path)));
        nav = $bbcb6469932687c5$var$_appendNavbar(nav, list.filter((r)=>!hidden.has($bbcb6469932687c5$var$_lc(r && r.path))));
    }
    return nav;
};
// Union of every additive app's launcher tiles (config.apps) — appended to the
// base launcher list, deduped so the app-drawer shows each installed app once.
//
// The identity MUST cover `route`/`title`, not just `path`/`label`: a manifest-v2
// launcher tile is `{ title, caption, icon, iconBg, route }` (every app in
// workspace/apps/* uses that shape), so a path||label key was always falsy for
// them and the dedupe never fired. Re-resolving over an already-appended base
// then duplicated every tile — ICCA Exams' 8 tiles resolved as 16 (2026-07-25).
const $bbcb6469932687c5$var$_tileKey = (t)=>$bbcb6469932687c5$var$_lc(t && (t.route || t.path) || t && (t.title || t.label));
const $bbcb6469932687c5$var$_appendAppsLauncher = (base, root)=>{
    const out = Array.isArray(base) ? base.slice() : [];
    const idxByKey = new Map();
    out.forEach((t, i)=>{
        const k = $bbcb6469932687c5$var$_tileKey(t);
        if (k && !idxByKey.has(k)) idxByKey.set(k, i);
    });
    const hiddenTiles = new Set();
    for (const app of $bbcb6469932687c5$var$_appRowSources(root)){
        const appTiles = $bbcb6469932687c5$var$_appRowsWithKey(app && app.apps, app && app.appId);
        for (const tile of Array.isArray(appTiles) ? appTiles : []){
            if (!tile) continue;
            const key = $bbcb6469932687c5$var$_tileKey(tile);
            if ($bbcb6469932687c5$var$_hiddenFor(root, tile)) {
                if (key) hiddenTiles.add(key);
                continue;
            }
            if (key && idxByKey.has(key)) {
                // A base row (a stored settings.apps entry) already claims this
                // identity. It used to WIN the dedupe outright — so a thin stored row
                // (bare { route }, no title/icon) shadowed the installed app's own
                // manifest tile and the launcher rendered a blank tile. Keep the
                // stored row's slot + deliberate overrides, but backfill its MISSING
                // display meta from the richer manifest tile (returns a new object;
                // state rows are never mutated).
                const i = idxByKey.get(key);
                out[i] = (0, $kO6Bt.fillLauncherTileFrom)(out[i], tile);
                continue;
            }
            if (key) idxByKey.set(key, out.length);
            out.push(tile);
        }
    }
    // A stored copy of a hidden tile (same route / title) goes too.
    return hiddenTiles.size ? out.filter((t)=>!hiddenTiles.has($bbcb6469932687c5$var$_tileKey(t))) : out;
};
const $bbcb6469932687c5$export$43825f9143f08441 = (root)=>{
    if (!root) return $bbcb6469932687c5$export$c2f8e0cc249a8d8f;
    // Loaded apps, or installed apps whose rows the record's `nav` already carries.
    const hasApps = $bbcb6469932687c5$var$_appRowSources(root).length > 0;
    // 1) Workspace project (the ONE full-takeover module, unpacked into context by
    //    loadWorkspaceProject). Its config is the base; additive apps still append.
    const project = root.workspaceProject;
    if (project && project.config) {
        // Legacy single-app-stored-as-module (pre-plural: installMode:'app' on
        // workspaceModule). Base = DEFAULT, the module's own navbar appended, home
        // panels NOT taken — then any plural apps append on top too.
        if ($bbcb6469932687c5$var$_isAppModeInstall(root)) {
            const cfg = {
                ...$bbcb6469932687c5$export$c2f8e0cc249a8d8f,
                ...project.config
            };
            // A STORED arrangement wins (Nika 2026-10-11: "remove apps tasks files.
            // move training as first, decisions second"): the record's
            // settings.navbar — full record, active org — IS the bar; installed
            // additive apps still append. A stored copy of the bare default is no
            // personalization. applyWorkspaceConfig's "saved" is the derived
            // root.workspaceSettings cache, never the record, so this is the one
            // place the stored bar can win (__tests__/appModeStoredNavbar.test.js).
            const { settings: stored, ready: storedReady } = $bbcb6469932687c5$var$shellWorkspaceSettings(root);
            const storedNav = storedReady && stored && $bbcb6469932687c5$var$_workspaceBelongsToActiveOrg(root) ? $bbcb6469932687c5$var$_normalizeSavedRow(stored).navbar : null;
            const personal = storedNav && !$bbcb6469932687c5$var$_sameNavbar(storedNav, $bbcb6469932687c5$export$4fbb9df63dbf8321) ? storedNav : null;
            // A module page NOT in the stored bar appends at the END, so a page the
            // module adds later still shows; the shell defaults never come back.
            cfg.navbar = $bbcb6469932687c5$var$_appendAppsNavbar($bbcb6469932687c5$var$_appendNavbar(personal || $bbcb6469932687c5$export$4fbb9df63dbf8321, project.config.navbar), root);
            cfg.apps = $bbcb6469932687c5$var$_appendAppsLauncher(project.config.apps, root);
            delete cfg.home_default_panels;
            return cfg;
        }
        // Real full-takeover client module (greenig/bellforge/financials): its
        // config wins — skin, home panels, navbar — but additive apps still append
        // their navbar tabs + launcher tiles on top (they never take over).
        const cfg = {
            ...$bbcb6469932687c5$export$c2f8e0cc249a8d8f,
            ...project.config
        };
        if (hasApps) {
            cfg.navbar = $bbcb6469932687c5$var$_appendAppsNavbar(cfg.navbar || $bbcb6469932687c5$export$4fbb9df63dbf8321, root);
            cfg.apps = $bbcb6469932687c5$var$_appendAppsLauncher(cfg.apps, root);
        }
        return cfg;
    }
    // 2) No takeover module. Base = Mongo workspace `settings` (org-guarded) or
    //    DEFAULT_CONFIG. Additive apps append their navbar + launcher on top.
    //
    // §5 RENDER SOURCE — this is where "the workspace hasn't loaded" turned into
    // "the workspace is configured with the framework default". `ws.settings` was
    // read directly; on a list-shaped record it is `undefined`, the `if` below
    // never fires, and the function returns DEFAULT_CONFIG — which
    // applyWorkspaceConfig then PUBLISHES as `root.workspaceSettings.navbar`,
    // making the default indistinguishable from a real choice for every
    // downstream reader. Reading through the accessor makes the two cases
    // separable; the caller (applyWorkspaceConfig) is what acts on it.
    const { settings: settings, ready: ready } = $bbcb6469932687c5$var$shellWorkspaceSettings(root);
    let base = null;
    if (ready && settings && typeof settings === 'object' && $bbcb6469932687c5$var$_workspaceBelongsToActiveOrg(root)) {
        const fromMongo = $bbcb6469932687c5$var$_normalizeSavedRow(settings);
        // ANY personalization key qualifies the bag as a base — not just
        // designSystem/navbar. The old two-key gate silently discarded a settings
        // bag that carried ONLY home_default_panels (e.g. an additive-apps
        // workspace pinning its module widgets: settings = { workspaceApps,
        // home_default_panels }), so the authoritative panel set never reached
        // root.workspaceSettings and the home dashboard force-hid every pinned
        // module widget (verified live on natali 2026-07-25). _normalizeSavedRow
        // already whitelists the keys and drops null/empty values, so an empty or
        // junk bag still falls through to DEFAULT_CONFIG.
        if (Object.keys(fromMongo).length) base = {
            ...$bbcb6469932687c5$export$c2f8e0cc249a8d8f,
            ...fromMongo
        };
    }
    if (!base) {
        if (!hasApps) return $bbcb6469932687c5$export$c2f8e0cc249a8d8f;
        base = {
            ...$bbcb6469932687c5$export$c2f8e0cc249a8d8f
        };
    }
    if (hasApps) {
        base.navbar = $bbcb6469932687c5$var$_appendAppsNavbar(base.navbar || $bbcb6469932687c5$export$4fbb9df63dbf8321, root);
        base.apps = $bbcb6469932687c5$var$_appendAppsLauncher(base.apps, root);
    }
    return base;
};
// ── Apply / revert the personalized design system at runtime ─────────────────
// All overrides go on <html> inline style so they win over the :root sheet and
// revert cleanly via removeProperty. We track what we set so revert is exact.
const $bbcb6469932687c5$var$_appliedVars = new Set();
// BOOT-RESHUFFLE F4 — re-applying an IDENTICAL design system is a no-op. The
// activation chain calls applyWorkspaceConfig up to four times per boot; each
// call reverted + re-set every <html> css var (a live document-level swap) even
// when nothing changed. Fingerprint the outgoing ds; unfingerprintable → apply.
let $bbcb6469932687c5$var$_lastDsFp = null;
// The workspace-driven theme currently in force, or null. Mirrors the
// _lastDsFp/_revertDesignSystem pattern: this module owns ONE workspace
// override at a time and must be able to take it back on a switch, otherwise
// a light workspace would leak its theme into the next workspace.
let $bbcb6469932687c5$var$_appliedWorkspaceTheme = null;
// The design system currently in force, or null. `vars` is resolved PER THEME
// (below), so the record has to stay readable after the apply pass: the
// data-theme watcher repaints from this, never from a re-run of the whole
// config chain.
let $bbcb6469932687c5$var$_activeDesignSystem = null;
const $bbcb6469932687c5$export$8467e4da404b12f1 = (ds, theme)=>{
    const out = {};
    if (!ds || typeof ds !== 'object') return out;
    const half = theme === 'light' ? 'light' : 'dark';
    const isPair = (v)=>!!v && typeof v === 'object' && !Array.isArray(v) && ('light' in v || 'dark' in v);
    const take = (prop, value)=>{
        if (value == null || value === '') return;
        out[prop] = String(value);
    };
    const vars = ds.vars && typeof ds.vars === 'object' && !Array.isArray(ds.vars) ? ds.vars : {};
    for (const [prop, value] of Object.entries(vars))take(prop, isPair(value) ? value[half] : value);
    const perTheme = half === 'light' ? ds.varsLight : ds.varsDark;
    if (perTheme && typeof perTheme === 'object' && !Array.isArray(perTheme)) for (const [prop, value] of Object.entries(perTheme))take(prop, value);
    return out;
};
// Write the half of `_activeDesignSystem` that belongs to the theme in force
// right now. Idempotent: a prop both halves declare is re-set, never removed
// and re-added, so a theme flip cannot blink it.
const $bbcb6469932687c5$var$_paintDesignSystemVars = (doc = globalThis.document)=>{
    const rootEl = doc?.documentElement;
    if (!rootEl) return;
    const next = $bbcb6469932687c5$export$8467e4da404b12f1($bbcb6469932687c5$var$_activeDesignSystem, $bbcb6469932687c5$var$shellResolveCanvasBackgroundTheme(undefined, doc));
    for (const prop of $bbcb6469932687c5$var$_appliedVars)if (!(prop in next)) rootEl.style.removeProperty(prop);
    $bbcb6469932687c5$var$_appliedVars.clear();
    for (const [prop, value] of Object.entries(next)){
        rootEl.style.setProperty(prop, value);
        $bbcb6469932687c5$var$_appliedVars.add(prop);
    }
};
const $bbcb6469932687c5$export$9ac69f1298a64dd4 = (doc = globalThis.document)=>{
    const rootEl = doc?.documentElement;
    if (!rootEl) return null;
    if (doc.__wsDesignSystemThemeWatcher) return doc.__wsDesignSystemThemeWatcher;
    const Observer = doc.defaultView?.MutationObserver || globalThis.MutationObserver;
    if (!Observer) return null;
    const observer = new Observer(()=>$bbcb6469932687c5$var$_paintDesignSystemVars(doc));
    observer.observe(rootEl, {
        attributes: true,
        attributeFilter: [
            'data-theme'
        ]
    });
    doc.__wsDesignSystemThemeWatcher = observer;
    return observer;
};
const $bbcb6469932687c5$var$_applyDesignSystem = (ds, doc = globalThis.document)=>{
    const rootEl = doc?.documentElement;
    if (!rootEl) return;
    // Always start from a clean slate so switching A→B doesn't leave A's vars.
    $bbcb6469932687c5$var$_revertDesignSystem(doc);
    $bbcb6469932687c5$var$_activeDesignSystem = ds || null;
    if (!ds) {
        $bbcb6469932687c5$var$shellClearCanvasBackgroundVar(doc);
        return;
    }
    if (ds.canvasBg) $bbcb6469932687c5$var$shellSetCanvasBackgroundVar(doc, ds.canvasBg);
    else $bbcb6469932687c5$var$shellClearCanvasBackgroundVar(doc);
    $bbcb6469932687c5$var$_paintDesignSystemVars(doc);
    $bbcb6469932687c5$export$9ac69f1298a64dd4(doc);
};
const $bbcb6469932687c5$var$_revertDesignSystem = (doc = globalThis.document)=>{
    const rootEl = doc?.documentElement;
    if (!rootEl) return;
    for (const prop of $bbcb6469932687c5$var$_appliedVars)rootEl.style.removeProperty(prop);
    $bbcb6469932687c5$var$_appliedVars.clear();
    // The watcher stays (it is a document singleton) but must find nothing to
    // repaint, or a theme flip would put the reverted workspace's vars back.
    $bbcb6469932687c5$var$_activeDesignSystem = null;
};
// Normalize a SAVED workspace_settings row (snake_case columns from the DB) to
// the camelCase shape the rest of the app consumes. Only fields the row actually
// carries are returned, so they can override the registry preset selectively.
const $bbcb6469932687c5$var$_normalizeSavedRow = (ws)=>{
    if (!ws || typeof ws !== 'object') return {};
    const out = {};
    // navbar: null AND [] both mean "cleared, fall through to the preset/
    // default" — an empty tab list is never a real personalization (it renders
    // a header with ZERO links). Same guard as HeaderTabs' readers and
    // workspaceProjects.js's config merge.
    // `_canonicalNavbar` migrates the three pre-i18n English house labels back to
    // their polyglot keys; every other row is returned untouched (see the table).
    if (Array.isArray(ws.navbar) && ws.navbar.length) out.navbar = $bbcb6469932687c5$var$_canonicalNavbar(ws.navbar);
    // design system: accept either camelCase (already-applied) or snake_case (row).
    if (ws.designSystem != null) out.designSystem = ws.designSystem;
    else if (ws.design_system != null) out.designSystem = ws.design_system;
    if (ws.language != null) out.language = ws.language;
    if (ws.languagePolicy != null) out.languagePolicy = ws.languagePolicy;
    if (ws.layoutDirection != null) out.layoutDirection = ws.layoutDirection;
    else if (ws.layout_direction != null) out.layoutDirection = ws.layout_direction;
    if (ws.modules != null) out.modules = ws.modules;
    if (ws.home_default_panels != null) out.home_default_panels = ws.home_default_panels;
    if (ws.apps != null) out.apps = ws.apps;
    return out;
};

const $bbcb6469932687c5$export$18eca25bb66a0a25 = (root, doc = globalThis.document)=>{
    if (!root) return;
    $bbcb6469932687c5$var$shellBootTrail('workspaceConfig:apply', root.workspace?.key || root.workspace?.id || '?');
    // `workspaceSettings` is a derived, root-level cache. Its contents are only
    // meaningful for the workspace that produced them; treating a previous
    // workspace's bag as a user override is what let a late System pass win over
    // the freshly-resolved workspace's module/navbar/panels during boot. Every
    // successful application stamps the bag below, so once a bag has provenance
    // it is an explicit ownership boundary rather than a best-effort hint.
    //
    // Keep unscoped bags for the current invocation as a migration bridge: older
    // in-place personalization flows created them before the stamp existed. They
    // are immediately restamped below. A stamped mismatch, however, is never
    // carried forward — a new workspace must resolve from its own record/module.
    const activeWorkspaceId = String(root.workspace?.id ?? root.workspace?._id ?? '');
    const heldSettings = root.workspaceSettings;
    const heldWorkspaceId = String(heldSettings?.workspace_id ?? '');
    const scopedSettings = heldSettings && typeof heldSettings === 'object' && (!heldWorkspaceId || activeWorkspaceId && heldWorkspaceId === activeWorkspaceId) ? heldSettings : {};
    // PRECEDENCE (field-by-field): whatever root.workspaceSettings ALREADY holds
    // (its own prior value — e.g. an admin console's optimistic in-flight edit,
    // written ahead of the network round-trip by dashboard-defaults.js /
    // moduleConsole.js mcSavePersonalization) > the Mongo workspace record
    // `settings` bag (the actual source of truth, returned by
    // resolveWorkspaceConfig) > the frontend registry preset > DEFAULT_CONFIG.
    // This is a self-merge, not a second store: root.workspaceSettings is
    // populated ONLY by this function (from Mongo) plus the two admin consoles'
    // optimistic writes of the SAME `Workspace.settings` keys — never a separate
    // row (the legacy `workspace_dashboard_defaults` row that used to double as
    // one was retired 2026-07-13; see loadPrivateData.js _dashboardPrefsFetches).
    const preset = $bbcb6469932687c5$export$43825f9143f08441(root);
    const saved = $bbcb6469932687c5$var$_normalizeSavedRow(scopedSettings);
    // Language is resolved from the workspace record, not the previously
    // derived settings bag. Self-merging that bag pinned an old language after
    // a full-record refresh, even when the shared resolver had already switched
    // the rendered interface. Keep the same precedence as boot and live policy.
    const { settings: languageSettings, ready: languageReady } = $bbcb6469932687c5$var$shellWorkspaceSettings(root);
    const languageScopeReady = languageReady && $bbcb6469932687c5$var$_workspaceBelongsToActiveOrg(root);
    const liveLanguageSettings = languageScopeReady ? languageSettings : null;
    const resolvedLanguage = (0, $1X0Je.default).functions.resolveLang({
        workspaceEnforced: (0, $1X0Je.default).functions.enforcedWorkspaceLang(liveLanguageSettings),
        workspaceDefault: liveLanguageSettings?.language || null,
        brandDefault: root.whitelabelBrand?.lang || null
    });
    // Navbar precedence with a default-guard. Unlike home_default_panels/apps
    // (written below ONLY when present), applyWorkspaceConfig ALWAYS writes a
    // navbar back into root.workspaceSettings — including the bare DEFAULT_NAVBAR
    // when it runs BEFORE the workspace project loads (boot race:
    // loadWorkspaceProject hadn't populated root.workspaceProject yet, so the
    // preset fell through to DEFAULT_CONFIG). On the next run that stale default
    // is now `saved.navbar` and, under a plain `saved.navbar || preset.navbar`,
    // pins Studio/Tasks/Files over the module's own navbar forever. So a saved
    // navbar that is merely the bare default is NOT treated as a personalization:
    // when the resolved preset carries a NON-default navbar (a project/module
    // ships its own), the preset wins. A saved navbar that DIFFERS from the
    // default is a deliberate reorder and is always kept. (Module-console reset
    // writes navbar:null, not the default array, so it also falls to the preset.)
    const savedNavbarIsBareDefault = saved.navbar && $bbcb6469932687c5$var$_sameNavbar(saved.navbar, $bbcb6469932687c5$export$4fbb9df63dbf8321);
    const presetHasCustomNavbar = preset.navbar && !$bbcb6469932687c5$var$_sameNavbar(preset.navbar, $bbcb6469932687c5$export$4fbb9df63dbf8321);
    // Installed additive apps ALWAYS contribute their tabs on top of whichever
    // navbar wins — appending an installed app is not a personalization question.
    // Without this, a workspace whose SAVED navbar is a module's custom set (any
    // takeover-module workspace, e.g. bellforge) could never surface a
    // just-installed app's tab: the saved navbar wins the precedence below, and
    // only the PRESET carried the append (verified live 2026-07-24 — "Add to
    // Workspace" wrote the ref + loaded the app but no tab appeared). Deduped by
    // path, so a navbar that already carries the tabs is untouched.
    // DERIVED vs PERSONAL (ws crm review of e713f38ea). The bag this function
    // publishes carries the bar it derived (`_navbarDerived`, below). A cached
    // bar equal to that stamp came from an EARLIER pass, not from a person; in
    // app mode such a bar gives way to the fresh resolve — otherwise a pass that
    // ran before the org resolved (P12) or on a lean record (P3) pinned
    // default + module tabs and the record's stored bar never showed. An
    // optimistic console edit changes the bar but not the stamp, so it still
    // wins. Other modes keep their precedence unchanged.
    const derivedStamp = Array.isArray(scopedSettings._navbarDerived) ? scopedSettings._navbarDerived : null;
    const savedIsDerived = !!(saved.navbar && derivedStamp && $bbcb6469932687c5$var$_sameNavbar(saved.navbar, derivedStamp) && $bbcb6469932687c5$var$_isAppModeInstall(root));
    const navbar = $bbcb6469932687c5$var$_appendAppsNavbar(!saved.navbar || savedNavbarIsBareDefault && presetHasCustomNavbar || savedIsDerived ? preset.navbar : saved.navbar, root);
    const cfg = {
        navbar: navbar,
        designSystem: saved.designSystem !== undefined ? saved.designSystem : preset.designSystem,
        // `workspace.settings.theme = { mode }` — an object, not a bare string,
        // so a later accent/logo can join without a migration.
        theme: saved.theme !== undefined ? saved.theme : preset.theme,
        language: resolvedLanguage,
        languagePolicy: liveLanguageSettings?.languagePolicy || (0, $1X0Je.default).functions.DEFAULT_LANGUAGE_POLICY,
        layoutDirection: saved.layoutDirection || preset.layoutDirection,
        modules: saved.modules || preset.modules,
        home_default_panels: saved.home_default_panels || preset.home_default_panels,
        // Same always-append rule as the navbar above — installed apps' launcher
        // tiles surface regardless of which apps list won the precedence.
        apps: $bbcb6469932687c5$var$_appendAppsLauncher(saved.apps || preset.apps, root)
    };
    // Design system — apply (or revert to framework default when designSystem is
    // null/absent). This is the deactivate-old / activate-new cycle. Skipped
    // when the ds is byte-identical to the one already applied (see _lastDsFp).
    let _dsFp = null;
    try {
        _dsFp = JSON.stringify(cfg.designSystem ?? null);
    } catch (_) {
        _dsFp = null;
    }
    if (!(_dsFp && _dsFp === $bbcb6469932687c5$var$_lastDsFp)) {
        $bbcb6469932687c5$var$_lastDsFp = _dsFp;
        $bbcb6469932687c5$var$shellBootTrail('workspaceConfig:designSystem');
        $bbcb6469932687c5$var$_applyDesignSystem(cfg.designSystem, doc);
    }
    // Workspace DEFAULT theme (Nika 2026-08-19: "set 'globalTheme' 'light' for
    // bellforge workspace by default - overriding users system preference").
    // Precedence, highest first: the user's own choice → this workspace's
    // setting → the OS. The decision itself is a pure, separately tested
    // function in shared/functions/themeMode.js; this only carries it out.
    //
    // ⚠️ A user who explicitly chose 'auto' keeps following their OS and is
    // NOT overridden — that is why the raw-key answer is passed rather than the
    // normalized mode, which cannot tell "chose auto" from "never chose".
    // ⚠️ Applied here, in the same deactivate-old/activate-new cycle as the
    // design system, so a switch to a workspace with no setting REVERTS rather
    // than leaking the previous workspace's theme.
    // Never persisted to the user record: this is a workspace default, not a
    // choice the user made.
    // ⚠️ PARKED 2026-08-19 — DO NOT RE-ARM WITHOUT READING THIS.
    //
    // This block is the prime suspect for the total freeze on the bellforge
    // workspace, and it is parked as the decisive test. The narrowing, from
    // two independent reproductions (mine and bellforge2's):
    //   • The wedge reproduces on the PLATFORM host
    //     (staging.my.symbols.app/w/bellforge/ws_UYAOhQyNjm), where no
    //     custom-domain code runs at all — so neither the branded surfaces nor
    //     the host→org resolver can be the cause.
    //   • It is a build regression: workspace.7df32db5.js rendered that URL
    //     (slow, ~30s, but it always arrived); workspace.a51d52c5.js wedges.
    //   • Of the six commits between those builds, this one (70dd21090) is the
    //     ONLY one whose code executes on the platform host. Every other commit
    //     in the range touches whitelabel-only or test-only files.
    //   • Before it, `applyWorkspaceConfig` NEVER called `changeGlobalTheme`.
    //     This added that call, and it fires only for a workspace that carries
    //     a `theme` setting — which, right now, is bellforge and nothing else.
    //     That is exactly why one workspace wedges and the others do not.
    //
    // The mechanism is a BLOCK, not a loop: `resolveWorkspaceThemeMode` is
    // convergent (its own tests cover apply→noop and revert→noop), so this does
    // not spin. But `changeGlobalTheme` re-applies the design system across the
    // whole app, smbls element preparation is super-linear in component size,
    // and the bellforge module is ~20k lines that already took ~30s to settle
    // BEFORE this. A few extra full re-applies on that tree is enough to turn a
    // slow boot into an unresponsive one.
    //
    // Parked, not deleted — the decision function, its tests, and the
    // precedence contract all stay. Nika asked for this default and it should
    // come back, but through the BOOT SEED (the same pre-mount path that
    // already sets themeMode/data-theme before anything mounts), not by
    // re-theming a mounted app. Re-arming is flipping this one constant, and
    // it must not be flipped until a build proves the freeze is gone without it.
    //
    // RE-ARMED AT THE BOOT SEED (2026-10-18, GreenIG "Dark theme by default"):
    // the workspace default now applies where this note asked — shared
    // bootResolve.js 5b (the warm mount, from its scope snapshot's cached
    // `workspaceTheme`) and 7c (the cold mount, from the full record's
    // `settings.theme`), both BEFORE create(). This mounted-app path stays
    // parked: an in-session switch into such a workspace keeps the current
    // theme until the next load.
    const WORKSPACE_DEFAULT_THEME_ENABLED = false;
    try {
        // ⚠️ Record the RAW value BEFORE the park gate. bellforge2 rightly
        // pointed out that parking the feature would otherwise blind the one
        // check that tests whether it was ever guilty: with the gate applied
        // first, the trail would report "no theme" on every workspace by
        // construction and prove nothing. This label answers, on the host that
        // actually wedges, whether `cfg.theme` is even present.
        //
        // Their static reading says it is NOT: bellforge is a full-takeover
        // client module, so resolveWorkspaceConfig returns
        // `{...DEFAULT_CONFIG, ...project.config}` EARLY, never reaching the
        // `_normalizeSavedRow` branch that sets `theme` — and DEFAULT_CONFIG has
        // no theme key. They also read staging directly: `settings.theme` exists
        // on zero workspaces. If that holds, this block no-ops for bellforge and
        // my parking it fixed nothing. The remaining caveat is that the
        // PLATFORM's stored module config is authoritative at runtime and can
        // differ from the repo's config.js, which is exactly what this measures.
        const rawThemeCfg = cfg.theme;
        $bbcb6469932687c5$var$shellBootTrail('workspaceConfig:theme:cfg', rawThemeCfg && typeof rawThemeCfg === 'object' ? `mode=${rawThemeCfg.mode}` : `absent:${typeof rawThemeCfg}`);
        const wsThemeMode = WORKSPACE_DEFAULT_THEME_ENABLED && rawThemeCfg && typeof rawThemeCfg === 'object' ? rawThemeCfg.mode : null;
        const decision = $bbcb6469932687c5$var$shellResolveWorkspaceThemeMode({
            userChoseExplicitly: $bbcb6469932687c5$var$shellUserHasOwnThemeChoice({
                rawStoredKeyAbsent: $bbcb6469932687c5$var$shellHasNoStoredThemeMode(),
                userRecordMode: root && root.userPrefs ? root.userPrefs.themeMode : null
            }),
            workspaceMode: wsThemeMode,
            appliedWorkspaceMode: $bbcb6469932687c5$var$_appliedWorkspaceTheme
        });
        $bbcb6469932687c5$var$shellBootTrail(decision && decision.apply ? 'workspaceConfig:theme:apply' : decision && decision.revert ? 'workspaceConfig:theme:revert' : 'workspaceConfig:theme:noop', wsThemeMode || '-');
        if (decision && (decision.apply || decision.revert)) {
            // Revert falls back to the user's OWN mode — their record/local choice
            // if any, else 'auto' so the OS resumes deciding.
            const next = decision.apply || root && root.themeMode || 'auto';
            $bbcb6469932687c5$var$_appliedWorkspaceTheme = decision.apply || null;
            // Dynamic import for the same reason wireGlobalListeners uses one: this
            // path must not drag the framework chunk into the eager bundle.
            Promise.resolve((parcelRequire("eY4Ct"))).then(({ changeGlobalTheme: changeGlobalTheme })=>{
                if (typeof changeGlobalTheme === 'function') changeGlobalTheme(next);
            }).catch(()=>{});
        }
    } catch (err) {
        // A theme default must never be able to break workspace activation.
        console.warn('[workspaceConfigs] workspace theme default skipped:', err && err.message);
    }
    // The shared language primitive owns translations and <html lang>
    // together. A separate attribute write here could contradict the visible
    // strings or race a lazy language delivery. Workspace resolution remains
    // transient, so it never records a personal/account preference.
    const languageElement = root.__element;
    if (languageScopeReady && typeof languageElement?.call === 'function') try {
        Promise.resolve(languageElement.call('applyWorkspaceLangPolicy')).catch((err)=>console.warn('[workspaceConfigs] workspace language policy failed:', err?.message || err));
    } catch (err) {
        console.warn('[workspaceConfigs] workspace language policy failed:', err?.message || err);
    }
    // Explicit layout direction remains a workspace layout setting.
    const rootEl = doc?.documentElement;
    if (rootEl) rootEl.setAttribute('dir', cfg.layoutDirection || 'ltr');
    // Write the resolved (camelCase) settings back so reactive consumers see them.
    // HeaderTabs reads `navbar`; the home dashboard reads `home_default_panels`;
    // the apps menu reads `apps`. Preserve any other keys already on the bag, and
    // only overwrite home_default_panels/apps when the resolved config carries them
    // (so a workspace WITHOUT a project keeps its server dashboard-defaults).
    const nextSettings = {
        ...scopedSettings,
        navbar: cfg.navbar,
        designSystem: cfg.designSystem,
        language: cfg.language,
        languagePolicy: cfg.languagePolicy,
        layoutDirection: cfg.layoutDirection,
        modules: cfg.modules
    };
    if (cfg.home_default_panels !== undefined) nextSettings.home_default_panels = cfg.home_default_panels;
    if (cfg.apps !== undefined) nextSettings.apps = cfg.apps;
    // PROVENANCE stamp: which workspace this bag DESCRIBES (isolation audit
    // #10). `root.workspaceSettings` is a global key that lags a switch, while
    // its consumers key caches by the CURRENT `root.workspace.id` — so a reader
    // pairing a fresh scope with a stale bag wrote one workspace's panel set
    // under another's cache key (the wsPanels cross-workspace poison). Readers
    // (_resolveWsPanelsInfo) now trust the bag only when this stamp matches the
    // active scope. Written from the same source resolveWorkspaceConfig read.
    const _wsIdForBag = String(root.workspace?.id ?? root.workspace?._id ?? '') || null;
    if (_wsIdForBag) nextSettings.workspace_id = _wsIdForBag;
    // The bar THIS pass derived — see "DERIVED vs PERSONAL" above. Local only:
    // the consoles send the server only the keys they change.
    nextSettings._navbarDerived = cfg.navbar;
    // No-op guard (boot F4): applyWorkspaceConfig is re-run by EVERY activation
    // trigger (boot chain, auth ensure, onWorkspaceChange, converge retries) and
    // unconditionally re-published the bag each time — re-rendering HeaderTabs,
    // the home dashboard and every other workspaceSettings consumer with
    // byte-identical data, all post-reveal. Skip the write when the recomputed
    // bag deep-equals what is already live; the DOM side effects above
    // (design-system vars, <html> lang/dir) are idempotent and already ran.
    if ($bbcb6469932687c5$export$b64b70f6ab4b814b(root.workspaceSettings, nextSettings)) return;
    root.update({
        workspaceSettings: nextSettings
    });
};

});
parcelRegister("kO6Bt", function(module, exports) {

$parcel$export(module.exports, "LAUNCHER_FALLBACK_ICON", () => $f25d9977214a5b90$export$52d1ec293b2e32fe);
$parcel$export(module.exports, "LAUNCHER_ICON_BGS", () => $f25d9977214a5b90$export$2ddc47512164fbc4);
$parcel$export(module.exports, "titleFromRoute", () => $f25d9977214a5b90$export$462cf4d7bb173448);
$parcel$export(module.exports, "normalizeLauncherTile", () => $f25d9977214a5b90$export$53623a44049026a1);
$parcel$export(module.exports, "fillLauncherTileFrom", () => $f25d9977214a5b90$export$e639140405ab64f1);
// Launcher-tile normalization — the ONE canonical guard that keeps the apps
// launcher from ever rendering a blank tile.
//
// A launcher tile's contract is { title, caption, icon, iconBg, route } (every
// manifest-v2 app in workspace/apps/* ships that shape), but tiles reach the
// launcher from THREE composers that historically emitted thinner rows:
//   • loadWorkspaceApps' extension branch pushed { label, path } refs,
//   • a Mongo `settings.apps` row can be a bare { route } pointer,
//   • an app manifest can simply omit icon/iconBg.
// SearchAppTile reads `s.title` / `s.icon` / `s.iconBg` / `s.route`, so every
// one of those thin rows rendered as a nameless tile with an empty sprite
// glyph (Svg emits `<use href="#">` for an unresolvable name — the natali
// blank-tiles bug, 2026-07-30).
//
// `normalizeLauncherTile` is applied at the single launcher feed
// (searchAppGroupsFor) so BOTH read paths — the raw takeover project config
// and the composed workspaceSettings.apps — pass through it, and
// `fillLauncherTileFrom` lets the launcher composer (_appendAppsLauncher)
// backfill a thin stored row from the richer installed-app manifest tile so
// real meta always beats the generic fallback.
const $f25d9977214a5b90$export$52d1ec293b2e32fe = 'blocks';
const $f25d9977214a5b90$export$2ddc47512164fbc4 = [
    'blue',
    'green',
    'red',
    'purple',
    'orange',
    'cerulean'
];
const $f25d9977214a5b90$export$462cf4d7bb173448 = (route)=>{
    const path = String(route || '').split('?')[0].split('#')[0];
    const seg = path.split('/').filter(Boolean).pop() || '';
    const words = seg.replace(/[-_]+/g, ' ').trim();
    if (!words) return '';
    return words.split(' ').map((w)=>w ? w.charAt(0).toUpperCase() + w.slice(1) : w).join(' ');
};
// Deterministic iconBg pick — hashed off the tile identity so re-renders and
// re-composes never shuffle a fallback tile's color.
const $f25d9977214a5b90$var$_bgFor = (seed)=>{
    const s = String(seed || '');
    let hash = 0;
    for(let i = 0; i < s.length; i++)hash = hash * 31 + s.charCodeAt(i) | 0;
    return $f25d9977214a5b90$export$2ddc47512164fbc4[Math.abs(hash) % $f25d9977214a5b90$export$2ddc47512164fbc4.length];
};
const $f25d9977214a5b90$export$53623a44049026a1 = (tile)=>{
    if (!tile || typeof tile !== 'object') return null;
    const route = tile.route || tile.path || '';
    const title = tile.title || tile.label || $f25d9977214a5b90$export$462cf4d7bb173448(route);
    if (!route && !title) return null;
    const out = {
        ...tile
    };
    if (route) out.route = route;
    if (title) out.title = title;
    if (!out.icon) out.icon = $f25d9977214a5b90$export$52d1ec293b2e32fe;
    if (!out.iconBg) out.iconBg = $f25d9977214a5b90$var$_bgFor(route || title);
    return out;
};
const $f25d9977214a5b90$export$e639140405ab64f1 = (base, rich)=>{
    if (!base || typeof base !== 'object' || !rich || typeof rich !== 'object') return base;
    const patch = {};
    if (!(base.route || base.path) && (rich.route || rich.path)) patch.route = rich.route || rich.path;
    if (!(base.title || base.label) && (rich.title || rich.label)) patch.title = rich.title || rich.label;
    // IDENTITY, not display meta — but backfilled for exactly the same reason.
    // `appKey` is what lets the tile resolve the installed app's real store name
    // (workspaceConfigs.js `_appRowsWithKey`); a thin stored row that carries
    // only `{ route }` would otherwise keep printing the app manifest's English
    // literal while the store shows the app's translated name.
    if (!base.appKey && rich.appKey) patch.appKey = rich.appKey;
    if (!base.caption && rich.caption) patch.caption = rich.caption;
    if (!base.icon && rich.icon) patch.icon = rich.icon;
    if (!base.iconBg && rich.iconBg) patch.iconBg = rich.iconBg;
    // the module's own glyph for the launcher (dropdowns spec 2026-09-30 §3.3)
    if (!base.glyph && rich.glyph) patch.glyph = rich.glyph;
    return Object.keys(patch).length ? {
        ...base,
        ...patch
    } : base;
};

});

parcelRegister("5gsjA", function(module, exports) {

$parcel$export(module.exports, "memberCan", () => $3d546919ef079191$export$728d48052048ecce);
$parcel$export(module.exports, "buildModuleRoleBridge", () => $3d546919ef079191$export$8e3c2c1224d948bb);
$parcel$export(module.exports, "buildModuleCanBridge", () => $3d546919ef079191$export$93966a72f77eac54);
// moduleRole / moduleCan (MODULE-ROLE-CAN-BRIDGES-1) — what an installed app
// may ask about the member looking at it, so it can HIDE what that member
// cannot use: the DFI Finances app hides its cost nav, widgets and views from a
// guest judge, while admins and the "Cost viewers" team (granted the app key
// `dfli.view_costs`) keep them.
//
// The answers come from the workspace read's `access` (server
// WorkspaceController.getWorkspace → callerAccess): the role the read was
// gated on, and the member's effective permission keys in the workspace's org,
// app-declared keys included — the set the records FIELDS axis reads. The
// server's data gates stay the protection; a hidden view would have read
// nothing anyway.
//
//   el.call('moduleRole') → 'owner' | 'admin' | 'editor' | 'viewer' | 'guest'
//                         | null — null while the workspace record (or its
//                           `access`) has not loaded: unknown, never a role.
//   el.call('moduleCan', key) → true | false. Owner and admin always pass;
//                         otherwise the key must be one of the member's
//                         effective permissions. Unknown → false (an app
//                         shows its gated views once the record lands — the
//                         bridges read the live record on every call).
//
// Read-only: neither touches state, so both also answer inside a read-only
// app verb (moduleReadOnlyCall.js refuses only the write-shaped names).
//
// Before the record carries `access` (an older server, or a record from the
// warm-boot snapshot), the org claims still say who is an owner or an admin —
// a workspace's owner/admin role cascades from exactly those org roles — so
// those two answer from the claims and every other member reads as unknown.

var $hv7Tn = parcelRequire("hv7Tn");
const $3d546919ef079191$export$4e50ba942b49d7f7 = Object.freeze([
    'owner',
    'admin',
    'editor',
    'viewer',
    'guest'
]);
const $3d546919ef079191$var$_access = (root)=>{
    const ws = root && root.workspace;
    const access = ws && ws.access;
    return access && typeof access === 'object' ? access : null;
};
const $3d546919ef079191$var$_claimsRole = (root)=>{
    try {
        const claims = root && (0, $hv7Tn.shellResolveClaims)(root) || {};
        if (claims.is_owner === true) return 'owner';
        if (claims.org_role === 'admin') return 'admin';
    } catch (_) {
    /* no claims yet — unknown */ }
    return null;
};
const $3d546919ef079191$export$e881400372b6fb1d = (root)=>{
    const access = $3d546919ef079191$var$_access(root);
    if (!access) return $3d546919ef079191$var$_claimsRole(root);
    const role = typeof access.role === 'string' ? access.role.trim().toLowerCase() : '';
    // A platform superuser reads a workspace with the admin's reach.
    if (role === 'superadmin') return 'admin';
    return $3d546919ef079191$export$4e50ba942b49d7f7.includes(role) ? role : null;
};
const $3d546919ef079191$export$728d48052048ecce = (root, key)=>{
    if (typeof key !== 'string' || !key.trim()) return false;
    const role = $3d546919ef079191$export$e881400372b6fb1d(root);
    if (role === 'owner' || role === 'admin') return true;
    const access = $3d546919ef079191$var$_access(root);
    return !!(access && Array.isArray(access.permissions) && access.permissions.includes(key.trim()));
};
const $3d546919ef079191$export$8e3c2c1224d948bb = (root)=>function moduleRole() {
        return $3d546919ef079191$export$e881400372b6fb1d(root);
    };
const $3d546919ef079191$export$93966a72f77eac54 = (root)=>function moduleCan(key) {
        return $3d546919ef079191$export$728d48052048ecce(root, key);
    };

});

parcelRegister("8Zc6q", function(module, exports) {

$parcel$export(module.exports, "appModeModuleRef", () => $68ad689148e875ea$export$6094ed01f218640e);
$parcel$export(module.exports, "isAppModeWorkspace", () => $68ad689148e875ea$export$f957dd5aaeefb27d);
$parcel$export(module.exports, "takeoverModuleRef", () => $68ad689148e875ea$export$cae7530d5d47f792);
$parcel$export(module.exports, "panelSetHiddenMap", () => $68ad689148e875ea$export$50676a137c69918e);
$parcel$export(module.exports, "houseDefaultHiddenMap", () => $68ad689148e875ea$export$fe5333d6b6a32dc4);
// homeDefaultWidgets.js — the one decision behind "which widgets does a
// workspace's home board show BEFORE anybody personalises it?"
//
// Two answers, and the workspace's install shape picks between them.
//
//   A GENERAL workspace ships the house default set: the greeting card plus
//   the app-shortcut icons (`_DEFAULT_VISIBLE_WIDGETS` in pages/main.js).
//   Everything else in the catalog is opt-in through the Customize drawer.
//
//   An APP-MODE workspace — one whose `settings.workspaceModule` carries
//   `installMode: 'app'` — exists to run ONE installed app. Nika, 2026-09-10:
//   its board lists the MODULE's declared widgets by default and nothing
//   else.
//   Nika, 2026-10-03 (answer A, "Greeting + house dock"): the page FRAME —
//   the greeting with its summary and the Dock's house apps — shows there
//   like on every other workspace; the rule above now covers the BOARD only.
//   The house widgets are not removed and not forbidden; they are
//   simply not part of that workspace's default board. Every one of them
//   stays in the Customize drawer, and adding one back is an ordinary
//   gesture that persists like any other.
//
// WHY THIS IS A DEFAULT AND NOT A HIDE. The board's composed map stacks three
// kinds of fact (see functions/homeHiddenPersist.js): defaults, user choices,
// render clamps. Expressing the app-mode rule as a DEFAULT — a base map every
// resolver re-derives — keeps it in the first kind. Writing the same
// house-widget hides into the gesture ledger or the prefs row would put a
// default in the second kind, which is the exact defect WS-HOME-PREFS-DURABLE-1
// fixed: a stored default outranks every future default for that member,
// permanently, because the read path composes `{ ...base, ...saved }`.
// `persistableHiddenMap` therefore keeps dropping anything that agrees with
// the base, and this file supplies that base.
//
// PRECEDENCE. A workspace that names its own `home_default_panels` still wins
// for what that set can SAY: it is an admin's (or a module's) explicit
// configuration for one workspace, more specific than any default, and
// `_resolveBootHidden` consults it first. What it cannot say — the house
// default-visible ids (the greeting, Next up, the App strip shortcuts), which
// no panel-set writer ever offered — follows the GLOBAL default below
// (`panelSetHiddenMap`, DESIGN-WL-HOME-DEFAULTS-ALL-WORKSPACES-1: the
// redesign's defaults reach every workspace, its personalisation stays). A
// takeover module's panel set keeps its old total reading until Nika decides
// (`takeoverModuleRef`).
//
// Pure by design (the predicate aside): the caller supplies the id lists, so
// a test can pin the decision without a browser, a grid or a network.

var $1X0Je = parcelRequire("1X0Je");
const $68ad689148e875ea$export$6094ed01f218640e = (root)=>{
    // Deferred barrel read — a module-scope destructure of `_wsShared.functions`
    // runs inside the shared-barrel init cycle, where the default export is
    // still undefined, and killed the whole shell boot twice (2026-08-12). Same
    // arrow idiom as workspaceProjects.js / workspaceConfigs.js.
    const read = (0, $1X0Je.default) && (0, $1X0Je.default).functions && (0, $1X0Je.default).functions.workspaceSettings;
    const bag = read ? read(root) : null;
    const ref = bag && bag.settings && bag.settings.workspaceModule || root && root.workspaceSettings && root.workspaceSettings.workspaceModule || null;
    return ref && ref.installMode === 'app' ? ref : null;
};
const $68ad689148e875ea$export$f957dd5aaeefb27d = (root)=>!!$68ad689148e875ea$export$6094ed01f218640e(root);
const $68ad689148e875ea$export$cae7530d5d47f792 = (root)=>{
    // Deferred barrel read — the same idiom as appModeModuleRef above.
    const read = (0, $1X0Je.default) && (0, $1X0Je.default).functions && (0, $1X0Je.default).functions.workspaceSettings;
    const bag = read ? read(root) : null;
    const ref = bag && bag.settings && bag.settings.workspaceModule || root && root.workspaceSettings && root.workspaceSettings.workspaceModule || null;
    return ref && typeof ref === 'object' && ref.installMode !== 'app' ? ref : null;
};
const $68ad689148e875ea$export$50676a137c69918e = ({ catalogIds: catalogIds = [], panels: panels = [], houseDefaultIds: houseDefaultIds = [], globalHidden: globalHidden = {}, panelsGovernHouseDefaults: panelsGovernHouseDefaults = false } = {})=>{
    const named = new Set(Array.isArray(panels) ? panels : []);
    const house = new Set(panelsGovernHouseDefaults || !Array.isArray(houseDefaultIds) ? [] : houseDefaultIds);
    const fallback = globalHidden && typeof globalHidden === 'object' ? globalHidden : {};
    const out = {};
    for (const id of Array.isArray(catalogIds) ? catalogIds : []){
        if (named.has(id)) out[id] = false;
        else if (house.has(id)) out[id] = !!fallback[id];
        else out[id] = true;
    }
    return out;
};
const $68ad689148e875ea$export$fe5333d6b6a32dc4 = ({ houseIds: houseIds = [], defaultHiddenIds: defaultHiddenIds = [], appMode: appMode = false, frameIds: frameIds = [] } = {})=>{
    const generalHidden = Array.isArray(defaultHiddenIds) ? defaultHiddenIds : [];
    let ids = generalHidden;
    if (appMode) {
        const frame = new Set(Array.isArray(frameIds) ? frameIds : []);
        const offEverywhere = new Set(generalHidden);
        ids = (houseIds || []).filter((id)=>!frame.has(id) || offEverywhere.has(id));
    }
    const out = {};
    for (const id of ids)out[id] = true;
    return out;
} // THE RESET WRITES NO CHOICES. The Customize drawer's "Reset" (pages/main.js)
 // sends `hidden_widgets: {}` and `grid_layout: null`, and the board composes
 // this file's defaults over that — so a reset means the same thing as a first
 // boot, on every workspace kind. It used to send `resetDefaultHiddenMap`: an
 // explicit boolean for every catalog id, the defaults of that day stamped into
 // the member's row, which outranks every later default for that member and
 // ignored the workspace's panel set (DESIGN-WL-HOME-DEFAULTS-ALL-WORKSPACES-1).
;

});


parcelRegister("6lGuT", function(module, exports) {

$parcel$export(module.exports, "MODULE_ACTION_FN_NAMES", () => $49f5ab559e19564a$export$dbaa31a640a46360);
$parcel$export(module.exports, "MODULE_ACTION_AI_FNS", () => $49f5ab559e19564a$export$804563581e9fa284);
$parcel$export(module.exports, "moduleActionKeys", () => $49f5ab559e19564a$export$81d5e0652c4104a5);
$parcel$export(module.exports, "moduleActionDocs", () => $49f5ab559e19564a$export$4bb67a3422984b1);
$parcel$export(module.exports, "moduleActionLabels", () => $49f5ab559e19564a$export$652211f5c205e820);
$parcel$export(module.exports, "buildModuleActionFns", () => $49f5ab559e19564a$export$f7a4a1802c5ed914);
// moduleActions.js — ENGINE-synthesized AI actions for workspace modules,
// gated by HUMAN APPROVAL. Generic replacement for the flow the legacy v1
// GreenIG module pioneered (retired with the WS6 migration, 2026-07-30):
// the assistant never mutates module data directly.
//
// A manifest-v2 module declares `actions: { key → { validate, summarize, run } }`
// (plain functions over (root, args), revived from the published project data).
// The loader (workspaceProjects.js) injects the trio built here into
// context.functions when the module activates — and tears it down with the
// rest of the module's keys:
//
//   proposeModuleAction(actionKey, args)
//     1. validates + summarizes the action,
//     2. parks { id, key, args, summary } on root._aiAction,
//     3. pushes an assistant message carrying an `aiAction` card
//        (Approve / Reject — rendered by ChatCard's PvCardAiAction).
//   approveAiAction()  — AWAITS actions[key].run(root, args, el) (runs may be
//                        async; legacy 2-arg sync runs work unchanged), clears
//                        the park (even on failure), confirms in chat.
//   rejectAiAction()   — clears the park, acknowledges in chat.
//
// Nothing changes until the user clicks Approve — every action needs a click.
// All three are (el, s)-style `this`-bound functions, matching how el.call
// invokes registered functions. The fn NAMES are appended to the module's
// stashed aiFunctions so simoneAiTransport's module gate accepts them.
//
// WS-MODULE-ACTIONS-RUN-ON-THE-SHELL-ROOT-NOT-THE-MODULE-STORE-1 — the
// INVOKING element is shell chrome (the chat / approval card), so its own
// `state.root` is the SHELL root, not the module's own state root
// (WS-MODULE-STATE-SCOPE-1). The park (`_aiAction`) and the chat message stay
// on that shell root on purpose — the approval UI is shell chrome and reads
// them there. But `def.validate` / `def.summarize` / `def.run` must see the
// OWNING module's loaded data, so the optional `resolveOwnerRoot(actionKey,
// shellRoot)` callback (passed by the loader, which alone knows which module
// declared each action key) resolves that module's store; a missing/null
// result falls back to the shell root, same soft-fail as an unscoped module.

var $go87e = parcelRequire("go87e");

var $jFE3F = parcelRequire("jFE3F");
// Chat-scope key resolution — which chatMessages bag the approval card lands
// in ('' = simone drawer, '_db_' = dashboard thread, '_ax_' = add-app).
const $49f5ab559e19564a$var$_resolveCk = (el)=>{
    let n = el;
    while(n){
        if (n.chatScope) {
            const s = n.chatScope;
            if (s === 'addapp') return '_ax_';
            if (s === 'dashboard') return '_db_';
            return '';
        }
        n = n.parent;
    }
    const root = el && el.state && el.state.root;
    if (!root) return '';
    if (root._db_currentAssistantId) return '_db_';
    return '';
};
// The SHELL's root — where the park and its card live — even while the
// element is scoped to a module store (an approved run scopes the card's own
// state to the owning store; see approveAiAction).
const $49f5ab559e19564a$var$_actionsRootOf = (el)=>(0, $jFE3F.shellRootOf)(el && el.state && el.state.root || el && el.getRoot && el.getRoot().state);
const $49f5ab559e19564a$var$_pushAssistant = (el, root, text, cards)=>{
    const k = $49f5ab559e19564a$var$_resolveCk(el);
    const msg = {
        id: `a-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        role: 'assistant',
        text: text,
        ts: Date.now()
    };
    if (cards) msg.cards = cards;
    root.update({
        [k + 'chatMessages']: (root[k + 'chatMessages'] || []).concat(msg)
    });
};
// Copy resolution for the approval trio. These fns are reached as
// `el.call('proposeModuleAction', …)`, so `this` is the element — but the AI
// transport also invokes them off a bare stash in tests and in the module
// sandbox, where there is no element to reach polyglot through. Return the KEY
// in that case rather than throwing; a raw key in a headless call site is
// harmless, an exception is not.
const $49f5ab559e19564a$var$_t = (el, key)=>el && typeof el.call === 'function' ? el.call('polyglot', key) : key;
// What an app's `summarize` gets to write the approval card's line in the
// person's language (a Georgian session showed an English line: summarize had
// no way to reach polyglot). `t(key, vars)` — the shell's polyglot, `{name}`
// placeholders filled from `vars`; `lang` — the session language. A
// two-argument summarize ignores it and keeps working.
const $49f5ab559e19564a$var$_summaryContext = (el)=>{
    let lang = '';
    try {
        lang = el && typeof el.call === 'function' ? String(el.call('getActiveLang') || '') : '';
    } catch (_) {
        lang = '';
    }
    return {
        lang: lang,
        t: (key, vars)=>{
            let out = String($49f5ab559e19564a$var$_t(el, key));
            if (vars && typeof vars === 'object') for (const name of Object.keys(vars))out = out.split(`{${name}}`).join(String(vars[name]));
            return out;
        }
    };
};
const $49f5ab559e19564a$export$dbaa31a640a46360 = [
    'proposeModuleAction',
    'approveAiAction',
    'rejectAiAction'
];
const $49f5ab559e19564a$export$804563581e9fa284 = [
    'proposeModuleAction'
];
const $49f5ab559e19564a$export$81d5e0652c4104a5 = (actions)=>Object.entries(actions && typeof actions === 'object' ? actions : {}).filter(([, def])=>def && typeof def === 'object' && (typeof def.run === 'function' || typeof def.validate === 'function')).map(([key])=>key);
const $49f5ab559e19564a$export$4bb67a3422984b1 = (actions)=>{
    const out = {};
    for (const key of $49f5ab559e19564a$export$81d5e0652c4104a5(actions)){
        const def = actions[key];
        const text = typeof def.describe === 'string' ? def.describe.trim() : '';
        if (text) out[key] = text.slice(0, 300);
    }
    return out;
};
const $49f5ab559e19564a$export$652211f5c205e820 = (actions)=>{
    const out = {};
    for (const key of $49f5ab559e19564a$export$81d5e0652c4104a5(actions)){
        const def = actions[key];
        const text = typeof def.label === 'string' ? def.label.trim() : '';
        if (text) out[key] = text.slice(0, 80);
    }
    return out;
};
// What an approved run answered, in words for the member. A run may return:
//   a string                          → done, in the app's words (as always)
//   { ok: false, error? | message? }  → NOT applied, in the app's words — no ✓
//   { message } / { ok: true, message } → done, in the app's words
//   nothing, or an object with no words → the shell's own "Done."
// A run that throws stays the catch path ("could not be applied"). Before
// this, an object answer printed "✓ [object Object]" and a run could report a
// no-op only by throwing, so "No incident … — nothing changed." wore the
// success mark (STORM-VAL-ACK-INCIDENT-ACTION-1 measure, dev 2026-10-04).
const $49f5ab559e19564a$var$_words = (v)=>typeof v === 'string' && v.trim() ? v.trim() : '';
// A run may name the page its write landed on — `{ message, open: '/orders' }`
// — and the card offers Open there. Only a same-origin path rides along: never
// a URL, never a protocol-relative `//host` (nor `/\host`, which browsers read
// as one).
const $49f5ab559e19564a$var$_openPath = (v)=>typeof v === 'string' && /^\/(?![/\\])/.test(v) ? v : '';
const $49f5ab559e19564a$var$_runOutcome = (el, out)=>{
    const done = $49f5ab559e19564a$var$_t(el, 'workspace.ai.actionDone');
    if (typeof out === 'string') return {
        ok: true,
        text: $49f5ab559e19564a$var$_words(out) || done
    };
    if (out && typeof out === 'object' && !Array.isArray(out)) {
        if (out.ok === false) return {
            ok: false,
            text: $49f5ab559e19564a$var$_words(out.error) || $49f5ab559e19564a$var$_words(out.message) || $49f5ab559e19564a$var$_t(el, 'workspace.ai.actionNotApplied')
        };
        const text = $49f5ab559e19564a$var$_words(out.message) || done;
        const open = $49f5ab559e19564a$var$_openPath(out.open);
        return open ? {
            ok: true,
            text: text,
            open: open
        } : {
            ok: true,
            text: text
        };
    }
    return {
        ok: true,
        text: done
    };
};
// THE CARD'S OUTCOME (APPROVAL-CARD-SHOWS-HANDLED-AFTER-A-REFUSAL-1). Once the
// park clears, the approval card used to read "✓ Handled" whatever happened:
// measured on dev 2026-10-05 (Storm Tokens) — an approved action the app
// REFUSED wrote its own words in chat with no ✓, while the card above it still
// said "✓ Handled". The outcome now rides the card itself, written in the SAME
// update that clears the park (so the card never shows a check mark first):
//
//   card.outcome = { state: 'handled',    text }  — the run changed something;
//                                                   `text` is the app's words
//                                                   (or the shell's "Done.")
//                | { state: 'notApplied', text }  — the run answered ok:false
//                                                   (`text` = its reason) or
//                                                   threw (`text` = the shell's
//                                                   "could not be applied")
//                | { state: 'rejected' }         — the member clicked Reject
//
// ChatCard's PvCardAiAction reads `card.outcome`; a handled card without one
// (a card from before this field) keeps the plain "✓ Handled". The card lives
// in whichever chat bag the proposal landed in, so every bag is searched.
const $49f5ab559e19564a$var$OUTCOME_CHAT_BAGS = [
    '',
    '_db_',
    '_ax_'
];
const $49f5ab559e19564a$var$_isCard = (c, id)=>Boolean(c) && c.type === 'aiAction' && c.id === id;
const $49f5ab559e19564a$export$bd290b31eb8f2748 = (root, cardId, outcome)=>{
    const patch = {};
    if (!root || !cardId || !outcome) return patch;
    for (const k of $49f5ab559e19564a$var$OUTCOME_CHAT_BAGS){
        const list = root[k + 'chatMessages'];
        if (!Array.isArray(list)) continue;
        let hit = false;
        const next = list.map((m)=>{
            if (!m || !Array.isArray(m.cards) || !m.cards.some((c)=>$49f5ab559e19564a$var$_isCard(c, cardId))) return m;
            hit = true;
            return {
                ...m,
                cards: m.cards.map((c)=>$49f5ab559e19564a$var$_isCard(c, cardId) ? {
                        ...c,
                        outcome: outcome
                    } : c)
            };
        });
        if (hit) patch[k + 'chatMessages'] = next;
    }
    return patch;
};
// ONE LINE PER OUTCOME (APPROVAL-OUTCOME-PRINTED-TWICE-1, decided 2026-10-05).
// The card carries the outcome — "✓ <the app's words>", "✗ Not applied:
// <reason>", "Rejected" (ChatCard PvAiHandled) — so the chat gets no second
// line saying the same thing: measured on dev (Storm Tokens), every approved
// action printed "✓ Handled" on its card AND "✓ <words>" under it. Only when no
// card shows the outcome (the bag that held it is gone) does it fall back to
// one chat line, so an outcome is never silent.
const $49f5ab559e19564a$var$_outcomeLine = (el, outcome)=>{
    if (!outcome) return '';
    if (outcome.state === 'rejected') return $49f5ab559e19564a$var$_t(el, 'workspace.ai.actionCancelled');
    if (outcome.state === 'handled') return `\u{2713} ${outcome.text}`;
    return outcome.text || '';
};
const $49f5ab559e19564a$var$_landOutcome = (el, root, cardId, outcome)=>{
    const patch = $49f5ab559e19564a$export$bd290b31eb8f2748(root, cardId, outcome);
    root.update({
        _aiAction: null,
        ...patch
    });
    if (Object.keys(patch).length) return;
    const line = $49f5ab559e19564a$var$_outcomeLine(el, outcome);
    if (line) $49f5ab559e19564a$var$_pushAssistant(el, root, line);
};
const $49f5ab559e19564a$export$f7a4a1802c5ed914 = (actions = {}, resolveOwnerRoot)=>{
    // One run per park: a second Approve, or a Reject, while the approved run is
    // in flight changes nothing — the run's own outcome lands when it ends.
    const inFlight = new Set();
    // Propose an action — parks it + shows the Approve/Reject card. Returns a
    // result object the cloud assistant reads (so it knows it's awaiting the
    // human).
    function proposeModuleAction(actionKey, args) {
        const el = this;
        // A verb marked readOnly never proposes a change (MODULE-FN-READONLY-ENFORCED-1).
        const readOnlyCall = (0, $go87e.readOnlyCallOf)(el);
        if (readOnlyCall) return (0, $go87e.refuseInReadOnlyCall)(readOnlyCall, 'proposeModuleAction', [
            actionKey
        ]);
        const root = $49f5ab559e19564a$var$_actionsRootOf(el);
        if (!root || typeof root.update !== 'function') return {
            ok: false,
            error: $49f5ab559e19564a$var$_t(el, 'workspace.ai.noWorkspaceUi')
        };
        const def = actions[actionKey];
        if (!def) return {
            ok: false,
            error: $49f5ab559e19564a$var$_t(el, 'workspace.ai.unknownAction').replace('{action}', actionKey)
        };
        const dataRoot = typeof resolveOwnerRoot === 'function' && resolveOwnerRoot(actionKey, root) || root;
        const a = args || {};
        if (typeof def.validate === 'function') {
            const err = def.validate(dataRoot, a);
            if (err) return {
                ok: false,
                error: err
            };
        }
        // `this` = the element, third argument = _summaryContext (the line in the
        // person's language).
        const summary = typeof def.summarize === 'function' ? def.summarize.call(el, dataRoot, a, $49f5ab559e19564a$var$_summaryContext(el)) : String(actionKey);
        const id = `act-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
        root.update({
            _aiAction: {
                id: id,
                key: actionKey,
                args: a,
                summary: summary
            }
        });
        const k = $49f5ab559e19564a$var$_resolveCk(el);
        const msg = {
            id: `a-${id}`,
            role: 'assistant',
            text: $49f5ab559e19564a$var$_t(el, 'workspace.ai.approvalPrompt'),
            ts: Date.now(),
            cards: [
                {
                    type: 'aiAction',
                    id: id,
                    summary: summary
                }
            ]
        };
        root.update({
            [k + 'chatMessages']: (root[k + 'chatMessages'] || []).concat(msg)
        });
        return {
            ok: true,
            pending: true,
            summary: summary,
            message: $49f5ab559e19564a$var$_t(el, 'workspace.ai.awaitingApproval')
        };
    }
    async function approveAiAction() {
        const el = this;
        const readOnlyCall = (0, $go87e.readOnlyCallOf)(el);
        if (readOnlyCall) return (0, $go87e.refuseInReadOnlyCall)(readOnlyCall, 'approveAiAction');
        const root = $49f5ab559e19564a$var$_actionsRootOf(el);
        const pa = root && root._aiAction;
        if (!pa) return {
            ok: false,
            error: $49f5ab559e19564a$var$_t(el, 'workspace.ai.nothingToApprove')
        };
        if (inFlight.has(pa.id)) return {
            ok: false,
            running: true
        };
        const def = actions[pa.key];
        const dataRoot = typeof resolveOwnerRoot === 'function' && resolveOwnerRoot(pa.key, root) || root;
        // THE OWNER'S SCOPE FOR THE RUN (BESSI dev 2026-10-28). run() gets the
        // owning store, but an app run reaches its data plane through the element
        // it is handed — el.call('bsCreate', …) writes `this.state.root` — and that
        // element is the card's Approve button, whose root is the SHELL's: the
        // approved draft order landed on the shell root and the module's /orders
        // never showed it. For the run, the card's own state reads the owning store
        // as its root (scopeHostState, as a home widget frame scopes its module
        // host); it gets its own root back before the outcome lands.
        const ownRoot = el && el.state ? el.state.root : null;
        const scoped = dataRoot !== root && (0, $jFE3F.scopeHostState)(el, dataRoot);
        inFlight.add(pa.id);
        // The card's outcome (cardOutcomePatch) — set on every path, landed with
        // the park's clear below, and the ONE place the outcome shows.
        let cardOutcome = null;
        try {
            let out;
            if (def && typeof def.run === 'function') // run(root, args, el) — the invoking element rides along so async
            // actions can reach their data plane (el.call('moduleData', …)).
            // Awaiting tolerates both shapes: a legacy sync 2-arg run returns its
            // string (awaiting a non-promise is a no-op), an async run resolves it.
            out = await def.run(dataRoot, pa.args, el);
            const outcome = $49f5ab559e19564a$var$_runOutcome(el, out);
            // Only a change that happened wears the check mark; a run that answers
            // { ok: false } speaks in its own words, with none.
            cardOutcome = {
                state: outcome.ok ? 'handled' : 'notApplied',
                text: outcome.text,
                ...outcome.open ? {
                    open: outcome.open
                } : {}
            };
            return outcome.ok ? {
                ok: true,
                result: outcome.text
            } : {
                ok: false,
                error: outcome.text
            };
        } catch (e) {
            // A rejected run must never strand the parked action (finally clears
            // it) — the card says it was not applied instead of silently swallowing.
            console.warn('[moduleActions] approved action failed:', pa.key, e && e.message);
            cardOutcome = {
                state: 'notApplied',
                text: $49f5ab559e19564a$var$_t(el, 'workspace.ai.actionNotApplied')
            };
            return {
                ok: false,
                error: e && e.message || $49f5ab559e19564a$var$_t(el, 'workspace.ai.actionFailed')
            };
        } finally{
            inFlight.delete(pa.id);
            if (scoped) (0, $jFE3F.scopeHostState)(el, ownRoot);
            $49f5ab559e19564a$var$_landOutcome(el, root, pa.id, cardOutcome);
        }
    }
    function rejectAiAction() {
        const el = this;
        const readOnlyCall = (0, $go87e.readOnlyCallOf)(el);
        if (readOnlyCall) return (0, $go87e.refuseInReadOnlyCall)(readOnlyCall, 'rejectAiAction');
        const root = $49f5ab559e19564a$var$_actionsRootOf(el);
        if (!root) return {
            ok: false
        };
        const pa = root._aiAction;
        // The approved run already started: a Reject now cancels nothing.
        if (pa && inFlight.has(pa.id)) return {
            ok: false,
            running: true
        };
        if (pa) $49f5ab559e19564a$var$_landOutcome(el, root, pa.id, {
            state: 'rejected'
        });
        else root.update({
            _aiAction: null
        });
        return {
            ok: true,
            cancelled: true
        };
    }
    return {
        proposeModuleAction: proposeModuleAction,
        approveAiAction: approveAiAction,
        rejectAiAction: rejectAiAction
    };
};

});
parcelRegister("go87e", function(module, exports) {

$parcel$export(module.exports, "readOnlyCallOf", () => $bee52eda1c0a8c73$export$435eea1a75facb34);
$parcel$export(module.exports, "isReadOnlyDataCall", () => $bee52eda1c0a8c73$export$500f22a07798238e);
$parcel$export(module.exports, "refuseInReadOnlyCall", () => $bee52eda1c0a8c73$export$b6b213b0426b936e);
$parcel$export(module.exports, "readOnlyCaller", () => $bee52eda1c0a8c73$export$3a2236f8950f6333);
$parcel$export(module.exports, "withReadOnlyOutcome", () => $bee52eda1c0a8c73$export$e7e3b179cc4b8ea0);
// moduleReadOnlyCall.js — the shell's enforcement of an app verb the manifest
// marks `readOnly: true` (MODULE-FN-READONLY-ENFORCED-1; Nika 2026-10-05:
// "Yes, enforced read-only").
//
// An `aiFunctions` entry `{ name, description, readOnly: true }` lets the
// assistant run that verb WITHOUT the Run / Skip row. What makes that safe is
// not the label but this file: the verb runs on a READ-ONLY CALLER, so a
// mislabelled verb cannot write.
//
// How. The transport runs the verb as `caller.call(fn, …args)` where `caller`
// wraps the invoking element in a Proxy. smbls `el.call` resolves the fn on
// `this.context` and invokes it with `this` = the caller, and app code reaches
// the platform the same way (`el.call('moduleData', …)`, `el.call('valData',
// …)` → `el.call('moduleData', …)`), so `this` stays the read-only caller down
// every helper chain. The caller's `context` hands out GUARDED copies of the
// platform's writing surfaces:
//   - moduleData: records list / get / subscribe and the schema reads pass;
//     create / update / upsert / remove and integration calls are refused;
//   - the action verbs (propose / approve / reject), file create / update /
//     upload, calendar writes, notifications, the AI chat and AI stream
//     bridges (both spend credits), AI settings and a mounted library's
//     imperative API (moduleApi / mount / unmount) are refused;
//   - the shell's own AI data ops (aiCreateTicket, aiSendMessage, …), passed
//     in by the transport, are refused.
// Everything else (the app's own helpers, reads, polyglot, opening a page)
// runs as before. The bridges ALSO check `this` themselves (moduleDataBridge,
// moduleActions), so a write reached with the read-only caller as `this` is
// refused even when it did not come through the guarded context.
//
// A refused call never reaches the SDK. It answers in the bridge's own error
// shape (moduleData rejects, the others answer { ok: false, error }), and the
// call record lists it; the transport then marks the verb's result ok:false
// with what was refused, so the assistant never reports a refused change as
// done.
//
// Scope: per CALLER, never a global flag — a write the member makes in the app
// UI while a read-only verb is running is not affected.
const $bee52eda1c0a8c73$export$bc753521755968d3 = Symbol.for('symbols.workspace.readOnlyCall');
const $bee52eda1c0a8c73$export$435eea1a75facb34 = (el)=>{
    try {
        return el && el[$bee52eda1c0a8c73$export$bc753521755968d3] || null;
    } catch (_) {
        return null;
    }
};
const $bee52eda1c0a8c73$var$_readOnlyBareEntity = (from)=>{
    const s = String(from || '').trim();
    const dot = s.lastIndexOf('.');
    return (dot >= 0 ? s.slice(dot + 1) : s).toLowerCase();
};
// moduleData(from, op, args, cb): reads of the record store and of the two
// schema entities only.
const $bee52eda1c0a8c73$var$RECORD_READ_OPS = new Set([
    'list',
    'get',
    'subscribe'
]);
const $bee52eda1c0a8c73$var$META_READ_OPS = new Set([
    'list',
    'get'
]);
const $bee52eda1c0a8c73$export$500f22a07798238e = (from, op)=>{
    const entity = $bee52eda1c0a8c73$var$_readOnlyBareEntity(from);
    const operation = String(op || '').toLowerCase();
    if (entity === 'records') return $bee52eda1c0a8c73$var$RECORD_READ_OPS.has(operation);
    if (entity === 'recordcollections' || entity === 'fielddefs') return $bee52eda1c0a8c73$var$META_READ_OPS.has(operation);
    return false;
};
// Surfaces that pass only for some arguments.
const $bee52eda1c0a8c73$var$CONDITIONAL = {
    moduleData: (from, op)=>$bee52eda1c0a8c73$export$500f22a07798238e(from, op),
    moduleAiAdmin: (op)=>op === 'usage' || op === 'credits'
};
// Surfaces that write, send, spend, or drive a mounted library.
const $bee52eda1c0a8c73$var$REFUSED = [
    'proposeModuleAction',
    'approveAiAction',
    'rejectAiAction',
    'moduleFileUpload',
    'moduleFileUploadLarge',
    'moduleFileUpdate',
    'moduleFileCreate',
    'moduleCalendarCreate',
    'moduleCalendarUpdate',
    'moduleCalendarRemove',
    'moduleNotify',
    'moduleNotifyClose',
    'moduleAiChat',
    'moduleAiStream',
    'moduleAsk',
    'moduleApi',
    'moduleMount',
    'moduleUnmount'
];
// How each refused surface answers, in its own convention.
const $bee52eda1c0a8c73$var$REJECTS = new Set([
    'moduleData'
]);
const $bee52eda1c0a8c73$var$NULLS = new Set([
    'moduleApi',
    'moduleMount',
    'moduleUnmount'
]);
const $bee52eda1c0a8c73$var$_describe = (name, args)=>{
    if (name === 'moduleData') {
        const entity = String(args[0] || '');
        const op = String(args[1] || '');
        const coll = args[2] && typeof args[2] === 'object' && args[2].collection;
        return `moduleData ${op} on ${entity}${coll ? ` (${coll})` : ''}`;
    }
    if (name === 'moduleAiAdmin') return `moduleAiAdmin ${String(args[0] || '')}`;
    return name;
};
function $bee52eda1c0a8c73$export$b6b213b0426b936e(record, name, args = []) {
    const what = $bee52eda1c0a8c73$var$_describe(name, args);
    const message = `[module] read-only call: "${record.fn || 'this function'}" is declared readOnly \u{2014} ${what} is refused (it may only read records).`;
    if (record) {
        record.refused.push(what);
        if (record.refused.length === 1) try {
            console.warn(message);
        } catch (_) {}
    }
    if ($bee52eda1c0a8c73$var$REJECTS.has(name)) return Promise.reject(new Error(message));
    if ($bee52eda1c0a8c73$var$NULLS.has(name)) return null;
    return {
        ok: false,
        error: message,
        code: 'read_only_call'
    };
}
const $bee52eda1c0a8c73$export$3690c90760545fc3 = (name, args, refuse)=>{
    if (Object.prototype.hasOwnProperty.call($bee52eda1c0a8c73$var$CONDITIONAL, name)) return !!$bee52eda1c0a8c73$var$CONDITIONAL[name](...args);
    return !refuse.has(name);
};
const $bee52eda1c0a8c73$var$BAGS = new Set([
    'utils',
    'functions',
    'methods',
    'snippets'
]);
function $bee52eda1c0a8c73$export$3a2236f8950f6333(el, opts = {}) {
    const record = {
        fn: String(opts.fn || ''),
        refused: []
    };
    const refuse = new Set([
        ...$bee52eda1c0a8c73$var$REFUSED,
        ...Array.isArray(opts.refuse) ? opts.refuse : []
    ]);
    const guarded = new Map();
    let caller = null;
    let contextProxy = null;
    const bagProxies = new Map();
    const guardOf = (bagName, bagProxy, name, real)=>{
        const key = bagName + ':' + name;
        if (guarded.has(key) && guarded.get(key).real === real) return guarded.get(key).fn;
        const fn = function readOnlyGuard(...args) {
            if (!$bee52eda1c0a8c73$export$3690c90760545fc3(name, args, refuse)) return $bee52eda1c0a8c73$export$b6b213b0426b936e(record, name, args);
            // Called off the bag itself (`ctx.functions.moduleData(…)`) or bare:
            // the real surface still sees the read-only caller as `this`.
            const self = this === bagProxy || this === undefined || this === null ? caller : this;
            return real.apply(self, args);
        };
        guarded.set(key, {
            real: real,
            fn: fn
        });
        return fn;
    };
    const bagProxyOf = (bagName, bag)=>{
        if (!bag || typeof bag !== 'object') return bag;
        const hit = bagProxies.get(bagName);
        if (hit && hit.bag === bag) return hit.proxy;
        const proxy = new Proxy(bag, {
            get (target, prop, receiver) {
                const real = Reflect.get(target, prop, receiver);
                if (typeof prop !== 'string' || typeof real !== 'function') return real;
                const watched = refuse.has(prop) || Object.prototype.hasOwnProperty.call($bee52eda1c0a8c73$var$CONDITIONAL, prop);
                return watched ? guardOf(bagName, proxy, prop, real) : real;
            }
        });
        bagProxies.set(bagName, {
            bag: bag,
            proxy: proxy
        });
        return proxy;
    };
    const contextOf = (ctx)=>{
        if (!ctx || typeof ctx !== 'object') return ctx;
        if (contextProxy && contextProxy.ctx === ctx) return contextProxy.proxy;
        const proxy = new Proxy(ctx, {
            get (target, prop, receiver) {
                const value = Reflect.get(target, prop, receiver);
                return typeof prop === 'string' && $bee52eda1c0a8c73$var$BAGS.has(prop) ? bagProxyOf(prop, value) : value;
            }
        });
        contextProxy = {
            ctx: ctx,
            proxy: proxy
        };
        return proxy;
    };
    caller = new Proxy(el, {
        get (target, prop) {
            if (prop === $bee52eda1c0a8c73$export$bc753521755968d3) return record;
            // `this` inside element methods (call, update, …) is the caller, so a
            // nested el.call stays read-only; plain reads come off the element.
            const value = Reflect.get(target, prop, caller);
            return prop === 'context' ? contextOf(value) : value;
        },
        set (target, prop, value) {
            return Reflect.set(target, prop, value, target);
        }
    });
    return caller;
}
function $bee52eda1c0a8c73$export$e7e3b179cc4b8ea0(res, record) {
    if (!record || !record.refused.length) return res;
    const error = `This read-only function tried to change data (${record.refused.join('; ')}); the change was refused and nothing was written.`;
    const base = res && typeof res === 'object' && !Array.isArray(res) ? res : {
        result: res
    };
    return {
        ...base,
        ok: false,
        error: error,
        readOnlyRefused: record.refused.slice()
    };
}

});

parcelRegister("jFE3F", function(module, exports) {

$parcel$export(module.exports, "isShellOwnedStateKey", () => $e520eb5bcb0581e0$export$d3ac4353863eeab);
$parcel$export(module.exports, "aliasShellOwnedKeys", () => $e520eb5bcb0581e0$export$ef7f1577b9e15434);
$parcel$export(module.exports, "createModuleStateRoot", () => $e520eb5bcb0581e0$export$8cb8eed138907dde);
$parcel$export(module.exports, "attachModuleStateScope", () => $e520eb5bcb0581e0$export$689335756bbb11c1);
$parcel$export(module.exports, "moduleStateScopeOf", () => $e520eb5bcb0581e0$export$c0220a55ef92fa80);
$parcel$export(module.exports, "shellRootOf", () => $e520eb5bcb0581e0$export$40f9de2c803fe028);
$parcel$export(module.exports, "scopeHostState", () => $e520eb5bcb0581e0$export$f38ac0574d62ded4);
// WS-MODULE-STATE-SCOPE-1 — the STATE half of per-module scoping.
//
// ─────────────────────────────────────────────────────────────────────────────
// THE CONTRACT
// ─────────────────────────────────────────────────────────────────────────────
//
// 1. Every installed/takeover module gets ONE module-local reactive store — its
//    `moduleStateRoot`. Inside that module's own surfaces (its pages, its home
//    widget bodies, its chrome rail), `s.root` resolves to THAT store, not to
//    the shell root.
//
// 2. READS FALL BACK. A key the module never wrote resolves on the shell root
//    and subscribes the reading effect to the SHELL's signal — so `activeWorkspace`,
//    `user`, `themeMode`, the capability bridges and the approval trio keep
//    working inside a module exactly as before, and a shell write still
//    re-renders module UI.
//
// 3. WRITES LAND MODULE-LOCALLY by default. Two installed apps that both write
//    `natLoading` / `natSalons` / `natCustomersLoaded` no longer clobber each
//    other, and a shell subscriber never fires on a module-local write.
//
// 4. SHELL-OWNED KEYS WRITE THROUGH. For every key in the shell's own declared
//    schema (`SHELL_OWNED_STATE_KEYS` below — STATE_DEFAULTS plus the reviewed
//    WORKSPACE_SCOPED / WORKSPACE_UNSCOPED / WORKSPACE_SCOPE_UNREVIEWED
//    partition of state.js + state-app.js) the module store's SIGNAL *is* the
//    shell's signal. A module that closes the shared dropdown with
//    `s.root.update({ contextDropdown: null })` still moves the shell's value
//    and still notifies every shell subscriber; it cannot silently shadow a
//    shell key with a module-local copy.
//
// 5. EXPLICIT ROOT OPT-IN, two forms:
//      • `s.root.shell` is the shell root store itself — `s.root.shell.update({…})`
//        writes the shell plane ON PURPOSE. (Standalone, outside the shell, the
//        module store does not exist and `s.root.shell` is undefined: write
//        `(s.root.shell || s.root).update(…)` in code that must run both ways.)
//      • a module manifest may declare `rootStateKeys: ['x', 'y*']`, which adds
//        those keys to the write-through set for that module only. Same entry
//        grammar as `scopedKeys` (plain key or `prefix*`), read by the same
//        normalizer in moduleScopedKeys.js.
//
// ─────────────────────────────────────────────────────────────────────────────
// WHY THIS NEEDS NO FRAMEWORK CHANGE — the engine already has the concept
// ─────────────────────────────────────────────────────────────────────────────
//
// `@symbo.ls/signal` src/store.js ALREADY implements "child store with a parent
// fallback", and it implements exactly the semantics this contract wants:
//
//   • its `get` trap ends with «Delegate to root state for keys not found
//     locally»: `if (prop !== 'root' && target.root && target.root !== proxy)
//     return target.root[prop]` — a read miss resolves on `store.root` and the
//     observer subscribes to the OWNER's signal. It even mirrors a local
//     placeholder signal when the key is missing everywhere, so a value that
//     arrives on the parent later is still seen.
//   • its `set` trap has no upward walk: a new key lands on THIS store's own
//     signal. Writes are local by construction.
//
// So a module store is `createStore({})` with `store.root = shellRoot`. Nothing
// is forked, nothing is proxied twice, and no smbls change is required for the
// default half of the contract.
//
// The one thing the engine does NOT have is a KEYED WRITE-THROUGH (`createScopeStore`
// has the opposite, unconditional, write-to-the-owner rule — right for the scope
// chain, wrong for state). Rather than wrap `s.root` in a shell-side Proxy — which
// would fork the read path, break `isStore`, and hide the engine's own tracking —
// point 4 is implemented by ALIASING THE SIGNAL OBJECT: for a shell-owned key the
// module store's entry in its signals map IS the shell store's signal, obtained
// through the engine's own public `getSignals()` accessor. Both traps then behave
// correctly with no interception at all: `hasOwnProperty(signals, key)` is true, so
// a read returns the shell's value (and subscribes to the shell's signal) and a
// write calls `.set()` on the shell's signal (so the shell's subscribers notify).
//
// IF A FRAMEWORK PRIMITIVE IS EVER WANTED, this is its precise shape:
//   createStore(initial, { parent, writeThrough: (key) => boolean })
// i.e. the existing `root` delegation plus a per-key predicate consulted by the
// `set` trap before it mints a local signal. That would replace `aliasShellOwnedKeys`
// below with one option, and it would also remove this file's one blemish — a
// shell-owned key that has no signal yet has to be MINTED on the shell store so
// there is something to alias (see `aliasShellOwnedKeys`). That is an fw-squad
// change; it is NOT required for this contract to be correct, so the workspace
// half ships against the primitive that exists.
//
// ─────────────────────────────────────────────────────────────────────────────
// This file deliberately imports NOTHING but the shell's own state registry —
// the reactive engine arrives as an injected `engine` bag (the same
// `import('smbls')` the loader already awaits for the module design system), so
// there is exactly ONE reactive engine on the page and this module stays
// testable without a DOM.

var $MygIX = parcelRequire("MygIX");
const $e520eb5bcb0581e0$export$569a2e02dca03128 = new Set([
    ...Object.keys((0, $MygIX.STATE_DEFAULTS)),
    ...(0, $MygIX.WORKSPACE_SCOPED_KEYS),
    ...(0, $MygIX.WORKSPACE_UNSCOPED_KEYS),
    ...(0, $MygIX.WORKSPACE_SCOPE_UNREVIEWED)
]);
// A module's own extra write-through declarations (`manifest.rootStateKeys`),
// normalized to the same `{ key } | { prefix }` entries `scopedKeys` uses.
const $e520eb5bcb0581e0$var$_coversKey = (entries, key)=>{
    for (const e of entries || []){
        if (e.key !== undefined && e.key === key) return true;
        if (e.prefix !== undefined && key.startsWith(e.prefix)) return true;
    }
    return false;
};
const $e520eb5bcb0581e0$export$d3ac4353863eeab = (key, rootStateKeys)=>$e520eb5bcb0581e0$export$569a2e02dca03128.has(key) || $e520eb5bcb0581e0$var$_coversKey(rootStateKeys, key);
// The keys a given module writes through: the shell schema plus any EXPLICIT
// key the module declared. A `prefix*` declaration cannot be pre-expanded (it
// has no key list), so it is honoured on demand by `isShellOwnedStateKey` and
// re-checked by every alias sync against the shell store's live key list.
const $e520eb5bcb0581e0$var$_writeThroughKeys = (shellSignals, rootStateKeys)=>{
    const out = new Set($e520eb5bcb0581e0$export$569a2e02dca03128);
    for (const e of rootStateKeys || []){
        if (e.key !== undefined) out.add(e.key);
        else if (e.prefix !== undefined && shellSignals) {
            for (const k of Object.keys(shellSignals))if (k.startsWith(e.prefix)) out.add(k);
        }
    }
    return out;
};
const $e520eb5bcb0581e0$export$ef7f1577b9e15434 = (moduleStore, shellRoot, engine, rootStateKeys)=>{
    const getSignals = engine && engine.getSignals;
    const createSignal = engine && engine.createSignal;
    if (!moduleStore || !shellRoot || typeof getSignals !== 'function') return 0;
    const shellSignals = getSignals(shellRoot);
    const modSignals = getSignals(moduleStore);
    if (!shellSignals || !modSignals) return 0;
    let n = 0;
    for (const key of $e520eb5bcb0581e0$var$_writeThroughKeys(shellSignals, rootStateKeys)){
        let sig = Object.prototype.hasOwnProperty.call(shellSignals, key) ? shellSignals[key] : null;
        if (!sig) {
            if (typeof createSignal !== 'function') continue;
            sig = createSignal(undefined);
            shellSignals[key] = sig;
        }
        if (modSignals[key] !== sig) {
            modSignals[key] = sig;
            n++;
        }
    }
    return n;
};
// ONE ENGINE, PROVEN — not assumed.
//
// @symbo.ls/signal's engineRegistry makes copies of the SAME version adopt a
// single function table, but copies of DIFFERENT versions deliberately do not
// (see its own comment: impersonating a fossil engine is the worse failure).
// On such a page the shell root belongs to engine B while `import('smbls')`
// hands back engine A, and every A/B mix here fails SILENTLY rather than
// loudly: A's `getSignals` reads a Symbol B's store never answers to (so the
// write-through alias would no-op), and a read of a B signal from inside an A
// effect registers in B's observer, which A never flushes (so a module would
// stop re-rendering on shell changes).
//
// So the engine is not trusted, it is PROVEN: the only usable engine is one
// whose `getSignals` actually resolves the shell root's own signal map. If none
// does, scoping is refused and every module stays on the shell root — exactly
// the pre-WS-MODULE-STATE-SCOPE-1 behaviour, with the fault named once.
let $e520eb5bcb0581e0$var$_warnedEngineSplit = false;
const $e520eb5bcb0581e0$export$be1edfa668e2b2ca = (engine, store)=>{
    const getSignals = engine && engine.getSignals;
    if (typeof getSignals !== 'function' || !store) return false;
    try {
        const signals = getSignals(store);
        return !!signals && typeof signals === 'object';
    } catch (_) {
        return false;
    }
};
const $e520eb5bcb0581e0$export$b67ab36fb714a91c = ()=>{
    $e520eb5bcb0581e0$var$_warnedEngineSplit = false;
    $e520eb5bcb0581e0$var$_warnedNoEngineSlot = false;
};
const $e520eb5bcb0581e0$export$8cb8eed138907dde = (shellRoot, engine, { rootStateKeys: rootStateKeys } = {})=>{
    const createStore = engine && engine.createStore;
    if (!shellRoot || typeof createStore !== 'function') return null;
    // A non-store root (a plain bag: tests, a shell that has not booted its
    // reactive root yet) is not something to scope — quietly decline.
    const isStore = engine.isStore;
    if (typeof isStore === 'function' && !isStore(shellRoot)) return null;
    if (!$e520eb5bcb0581e0$export$be1edfa668e2b2ca(engine, shellRoot)) {
        if (!$e520eb5bcb0581e0$var$_warnedEngineSplit) {
            $e520eb5bcb0581e0$var$_warnedEngineSplit = true;
            // MEASURED, and the reason this guard is not paranoia: in a checkout
            // where `smbls` resolves to a STALE `smbls/packages/smbls/dist/smbls.cjs`
            // (it inlines its own @symbo.ls/signal copy at build time) beside a newer
            // `@symbo.ls/signal` source, the two versions do not adopt each other and
            // this branch is taken. The fix is upstream — rebuild/republish smbls so
            // the dist and the resolved signal agree — never a workaround here.
            console.warn('[workspaceModule] per-module state scoping is OFF: the reactive engine that owns the shell root is not the one this bundle imported (duplicate @symbo.ls/signal versions \u2014 the framework prints its own "duplicate @symbo.ls/signal instance" diagnostic beside this). Modules keep writing the shared root store; align the signal version so exactly one engine resolves.');
        }
        return null;
    }
    const store = createStore({});
    // The engine's OWN parent link. Assigning `root` goes through the store's
    // `set` trap, which stores it as a plain (non-signal, non-enumerable-to-parse)
    // property — the same field `element/src/create.js` writes when it chains a
    // child state to its parent.
    store.root = shellRoot;
    // `s.root.shell` — the explicit write-to-the-shell channel. Defined on the
    // RAW target, non-enumerable: the `get` trap returns `target[prop]` before it
    // ever delegates, and `ownKeys` / `$parse` only ever walk the signals map, so
    // this is invisible to every clone, fingerprint and wipe.
    try {
        Object.defineProperty(store.__raw, 'shell', {
            value: shellRoot,
            enumerable: false,
            configurable: true,
            writable: true
        });
        // The engine this store was built with, so the scope plugin can mint
        // sibling stores from the SAME engine without importing one.
        Object.defineProperty(store.__raw, $e520eb5bcb0581e0$var$ENGINE_SLOT, {
            value: engine,
            enumerable: false,
            configurable: true,
            writable: true
        });
    } catch (_) {
    /* frozen raw — `s.root.shell` is simply unavailable, contract point 5a */ }
    // v3 state API (set/toggle/rootUpdate/setByPath/…). The store proxy already
    // answers update/parse/replace/add/…; these are the state package's extras,
    // and module code calls them. Applied AFTER `store.root` is assigned: the
    // helper only installs its own parent-walking `root` getter when `raw` has no
    // own `root` descriptor, and that getter would ignore this link.
    const applyStateMethods = engine && engine.applyStateMethods;
    if (typeof applyStateMethods === 'function') try {
        applyStateMethods(null, store);
    } catch (_) {
    /* extras unavailable — update/parse/replace still work via the proxy */ }
    $e520eb5bcb0581e0$export$ef7f1577b9e15434(store, shellRoot, engine, rootStateKeys);
    return store;
};
const $e520eb5bcb0581e0$export$ef9e064ddee0d1c0 = (moduleStore)=>({
        init (el) {
            if (!el || !moduleStore) return;
            const s = el.state;
            if (!s || s === moduleStore) return;
            // Already inside this module's scope (the common case — every descendant).
            if (s.root === moduleStore) return;
            const shellRoot = moduleStore.root;
            // (1) The element inherited the APP ROOT itself (`s.root === s`: the shell
            //     root, or any self-referencing root). There is nothing local to
            //     preserve, and re-pointing the app root's own `root` would re-home the
            //     entire shell — so this element gets its OWN store instead, chained to
            //     the module root. The shell's keys stay readable through the module
            //     store's fallback.
            if (s === shellRoot || s.root === s) {
                $e520eb5bcb0581e0$var$_adoptOwnStore(el, moduleStore);
                return;
            }
            // (2) A state that belongs to a shell HOST of this module surface (the home
            //     board's per-widget child state, a slot's child state, …). Re-pointing
            //     its `root` keeps every local key of that state intact — `s.spec`,
            //     `s.moduleId`, `s.body` are still there — and only changes what
            //     `s.root` MEANS inside this subtree. Shell code reading that host
            //     state is unaffected in practice: everything it reads or writes on
            //     `s.root` is a shell-owned key, which the module store shares with the
            //     shell store signal-for-signal (see aliasShellOwnedKeys).
            try {
                s.root = moduleStore;
            } catch (_) {
            /* frozen state — the subtree keeps the shell root, same as before */ }
        }
    });
// Give `el` its own reactive store chained to the module root — the same wiring
// `element/src/create.js` does for a declared `state:` object (own store,
// `__element`, `parent`, the parent's `__children` entry, the v3 method set),
// with `root` pointed at the module store instead of at the app root.
let $e520eb5bcb0581e0$var$_warnedNoEngineSlot = false;
const $e520eb5bcb0581e0$var$_adoptOwnStore = (el, moduleStore)=>{
    const engine = $e520eb5bcb0581e0$var$_engineOf(moduleStore);
    if (!engine) {
        // Never a silent no-op: without an engine this element keeps the shell
        // root and the module is unscoped from here down — say so once.
        if (!$e520eb5bcb0581e0$var$_warnedNoEngineSlot) {
            $e520eb5bcb0581e0$var$_warnedNoEngineSlot = true;
            console.warn("[workspaceModule] a module state root was built without its engine stamp \u2014 the subtree stays on the shell root. Build module stores with createModuleStateRoot().");
        }
        return;
    }
    try {
        const parentState = el.parent && el.parent.state;
        const store = engine.createStore({});
        store.__element = el;
        if (parentState) {
            store.parent = parentState;
            if (parentState.__children && el.key != null) parentState.__children[el.key] = store;
        }
        store.root = moduleStore;
        if (typeof engine.applyStateMethods === 'function') engine.applyStateMethods(el, store);
        el.state = store;
    } catch (e) {
        console.warn("[workspaceModule] could not scope a module subtree\u2019s state:", e && e.message);
    }
};
// The engine a module store was built with — stashed on the store's raw target
// at creation so the plugin can mint sibling stores from the SAME engine
// without importing one (see the one-engine note above).
const $e520eb5bcb0581e0$var$ENGINE_SLOT = '__moduleStateEngine';
const $e520eb5bcb0581e0$var$_engineOf = (store)=>{
    try {
        return store && store.__raw && store.__raw[$e520eb5bcb0581e0$var$ENGINE_SLOT] || null;
    } catch (_) {
        return null;
    }
};
const $e520eb5bcb0581e0$export$689335756bbb11c1 = (modCtx, shellCtx, moduleStore)=>{
    if (!modCtx || !moduleStore) return false;
    const inherited = shellCtx && Array.isArray(shellCtx.plugins) && shellCtx.plugins || [];
    const own = Object.prototype.hasOwnProperty.call(modCtx, 'plugins') ? modCtx.plugins : null;
    if (Array.isArray(own) && own.some((p)=>p && p.__moduleStateScope === moduleStore)) return true;
    const plugin = $e520eb5bcb0581e0$export$ef9e064ddee0d1c0(moduleStore);
    plugin.__moduleStateScope = moduleStore;
    modCtx.plugins = [
        ...inherited,
        plugin
    ];
    return true;
};
const $e520eb5bcb0581e0$export$c0220a55ef92fa80 = (ctx)=>{
    if (!ctx || typeof ctx !== 'object') return null;
    const own = Object.prototype.hasOwnProperty.call(ctx, 'plugins') ? ctx.plugins : null;
    if (!Array.isArray(own)) return null;
    for (const p of own)if (p && p.__moduleStateScope) return p.__moduleStateScope;
    return null;
};
const $e520eb5bcb0581e0$export$40f9de2c803fe028 = (root)=>root && typeof root === 'object' && root.root && root.root !== root ? root.root : root;
const $e520eb5bcb0581e0$export$f38ac0574d62ded4 = (host, moduleStore)=>{
    const s = host && host.state;
    if (!s || typeof s !== 'object') return null;
    const current = s.root;
    if (!current || typeof current !== 'object') return null;
    const shellRoot = $e520eb5bcb0581e0$export$40f9de2c803fe028(current);
    if (s === shellRoot || s === current) return null;
    // A store chained to another shell root is stale (the switch pipeline can
    // replace the root store): the shell root is the safe scope then.
    const target = moduleStore && moduleStore.root === shellRoot ? moduleStore : shellRoot;
    if (current !== target) s.root = target;
    return shellRoot;
};

});
parcelRegister("MygIX", function(module, exports) {

$parcel$export(module.exports, "STATE_DEFAULTS", () => $091f10de306fac2f$export$85f66272382e17d5);
$parcel$export(module.exports, "default", () => $091f10de306fac2f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "WORKSPACE_SCOPED_KEYS", () => $091f10de306fac2f$export$40e714049df95579);
$parcel$export(module.exports, "WORKSPACE_UNSCOPED_KEYS", () => $091f10de306fac2f$export$d5231c3582a837c6);
$parcel$export(module.exports, "WORKSPACE_SCOPE_UNREVIEWED", () => $091f10de306fac2f$export$8ed3e65848a95751);
$parcel$export(module.exports, "WORKSPACE_SCOPED_OVERRIDES", () => (parcelRequire("4MpU9")).WORKSPACE_SCOPED_OVERRIDES);

var $4MpU9 = parcelRequire("4MpU9");
const $091f10de306fac2f$export$85f66272382e17d5 = {
    ...(0, $4MpU9.default),
    // USER scope — logout invalidates
    user: null,
    preferences: {},
    themeMode: 'auto',
    // The campaigns card's group-by pill (WS-ANALYTICS-UTM-CAMPAIGNS-UI-1) —
    // the same class as `themeMode`: a USER view preference ('campaign' |
    // 'source' | 'medium' | 'content' | 'term'), owned and also declared by
    // @symbo-ls/workspace-analytics/state.js, declared HERE so the partition +
    // census classify it unscoped (WORKSPACE_UNSCOPED_KEYS below). Every other
    // analytics key is tenant data with a reset shape in state-app.js instead.
    // (The Local | UTC `_analyticsTz` preference is retired —
    // WS-ANALYTICS-REMOVE-UTC-DISPLAY-TOGGLE-1.)
    _analyticsCampaignsGroupBy: 'campaign',
    // ── Accessibility preferences (2026-09-04) ──
    // Per PERSON and per DEVICE, exactly like `themeMode` beside them: written
    // only by shared/functions/a11yPrefs.js, persisted to one localStorage key
    // and mirrored onto <html> for the shell sheet to scope on. Declared here so
    // the root-write census can classify them (WORKSPACE_UNSCOPED_KEYS below —
    // a workspace switch must never take someone's larger type away).
    a11yFontScale: 'md',
    a11yContrast: false,
    a11yMotion: false,
    a11yLinks: false,
    // The RESOLVED theme (`'dark'|'light'`) — `themeMode` above is the MODE,
    // never what `'auto'` resolves to. bootShell.js (shared) overwrites this
    // default with the real boot-time value and keeps it live for the whole
    // session via a `data-theme` MutationObserver (themeResolved.js) — see
    // tickets/opus.md "DECIDED: themeResolved". Declared here (mirrors the
    // themeMode declaration one line up) purely to document the key on this
    // app's canonical schema.
    themeResolved: null,
    // White-label branding for the CURRENT host, resolved pre-auth from the
    // org's record (WHITELABEL-BRANDED-BOOT-1, functions/whitelabelBrand.js).
    // `null` on every platform host and for any custom domain with no record —
    // which is what makes every consumer's fallback the generic Symbols
    // chrome. Display fields only; the server never projects persona user ids.
    // Declared here so smbls 3.14's typed-bag `state.update()` keeps the key
    // on the late-apply write.
    whitelabelBrand: null,
    // The host-scope pin MIRROR (customDomainBoot.js writes it the moment the
    // scope lookup lands; WhitelabelRequestAccess subscribes to it). Declared
    // so the key exists from FIRST render — an absent key registers no
    // dependency — and so the typed bag keeps it. `null` = no opinion, same
    // contract as hostScopePin.js.
    _hostScopeOrgId: null,
    // The TENANT this white-label host is bound to (WHITELABEL-STRICT-TENANT-
    // SCOPE-1, functions/whitelabelBrand.js seedWhitelabelHostScope), resolved
    // pre-auth and independent of branding: `{ organizationId, workspaceId,
    // workspaceKey, domain }` on a bound customer host, `false` on a customer
    // host whose tenant could not be established (render no tenant), `null` on
    // every platform host. Declared so the typed bag keeps the pre-mount seed.
    whitelabelHostScope: null,
    // `whitelabelSigninError` was declared here and REMOVED 2026-08-19: its only
    // writer was `functions/whitelabelSignin.js`, which `cbbf88fa0` deleted
    // ("REVERT the white-label LoginWindow override — it silently destroyed the
    // Google/GitHub column"). The declaration outlived it with zero readers, so
    // this was never a scoping question. The live refusal message is
    // component-local in shared/components/WhitelabelSignin.js, and
    // __tests__/whitelabelBrand.test.js already bans the deleted file from
    // returning. Re-verified before removal: one occurrence in the whole tree —
    // this declaration — across workspace/packages, server, smbls, company, docs
    // and sdk, including a search for computed-key writers.
    lang: 'en',
    // ORG scope — switchOrg invalidates (cascades to all below)
    // `orgs` is the membership list (from JWT app_metadata.orgs); `org` is
    // the active one. AppWorkspaceSwitcher reads from JWT claims directly;
    // shell-state copies are the canonical "you're signed in to N orgs"
    // surface for everywhere else.
    orgs: [],
    org: null,
    permissions: null,
    orgMembers: null,
    orgRoles: null,
    orgTeams: null,
    // WORKSPACE scope — switchWorkspace invalidates
    // `workspaces` is the membership list (from JWT app_metadata.workspaces);
    // `workspace` is the active one matching `active_workspace_id`.
    workspaces: [],
    workspace: null,
    // True ONLY while `root.workspace` holds a COMPLETE record (`_shape:'full'`
    // — has `settings`), false while it holds a list/claims-shaped identity-only
    // entry (or nothing). Written EXCLUSIVELY by
    // shared/functions/activeWorkspaceRecord.js's `setActiveWorkspaceRecord` —
    // see that file for the full shape-discipline contract
    // (tickets/spec-workspace-record-shape.md). NOT the same thing as
    // "workspace.settings is non-empty" — a workspace can legitimately carry no
    // settings overrides and still be `ready`. Consumers rendering
    // configuration derived from `workspace.settings.*` (navbar, designSystem,
    // modules, …) MUST branch on this instead of assuming a present `workspace`
    // means a complete one.
    workspaceReady: false,
    workspaceMembers: null,
    workspaceIntegrations: null,
    workspaceBilling: null,
    // Live credit balance for the guard surfaces (CreditBlocker/CreditBanner
    // + threshold notifications) — sdk.getCreditBalance(wsId) payload, fetched
    // by functions/creditGuard.js on boot + workspace switch. Workspace-scoped:
    // a previous tenant's balance must never gate (or un-gate) the next one.
    _creditGuard: null,
    // State mirror of the banner's per-(workspace, month, level) dismissal
    // pref, so the hide re-evaluates immediately on dismiss (prefs alone are
    // not reactive). Workspace-scoped for the same isolation reason.
    _creditBannerDismissed: null,
    // CREDIT-BLOCK-1 (tickets/opus.md) — session dismissal of the exhausted
    // full-viewport notice (Escape / ✕ / backdrop). Deliberately NOT a pref
    // cookie like the banner's: a `smbls_pref_*` cookie's one-year, cross-app,
    // cross-tab scope would outlive the tab, so a genuinely new session would
    // never see the notice again — running out of credits is a hard fact that
    // should restate once per session, not be silenced for a year.
    // Workspace-scoped like its siblings — dismissing for one tenant must
    // never suppress the notice for the next one.
    //
    // CREDITS-GATE-UI-BREAK-1 (tickets/sonnet.md): this key alone is
    // in-memory root state, wiped by ANY remount — including ordinary
    // dev-server HMR/live-reload churn, not just a real reload — so the gate
    // re-armed on every single page mount. `components/CreditBlocker.js`'s
    // `scope.close` now ALSO mirrors the dismissal into per-workspace
    // sessionStorage (`writeCreditBlockerDismissed`,
    // functions/creditGuard.js) and its `Overlay.hide` seeds this key back
    // from there on the next mount (`readCreditBlockerDismissed`) — still
    // session-scoped (sessionStorage dies with the tab, so a genuinely new
    // tab sees the gate once), just no longer reset by an in-tab remount.
    _creditBlockerDismissed: null,
    // The shortfall of the last AI request the server refused for credits —
    // `{ needed, available, at, msgId, dismissed }`, or null. Held by
    // functions/creditGuard.js `notifyCreditsExhaustedFromMessage` (the toast
    // alone is gone in seconds) so CreditBanner can keep the way out on screen —
    // an admin's "Add credits", a member's "Ask an admin" — until the balance
    // covers it or the person closes it, and so /admin/usage can say "Not enough
    // for your last AI request" instead of "Healthy balance". `dismissed` hides
    // the banner only; the record stays true until the balance covers it.
    // Workspace-scoped like its siblings: a previous tenant's shortfall must
    // never warn (or reassure) the next one.
    _creditsShort: null,
    // DemoClaimBanner — the new email a demo claim parked on the server's
    // `pendingEmail` (verification link not clicked yet), and whether the
    // server could mail that link. Declared so the claim window's `hide` /
    // `text` reads subscribe from the first render.
    _demoClaimPendingEmail: null,
    _demoClaimPendingSent: null,
    // Persona (tickets/sonnet.md PERSONA-5 — the shell-state half of PERSONA-1
    // ..6). `_personaSession` is the DOMQL-state reflection of the sessionStorage
    // blob personaSession.js owns (`personaStateFromSession` shape: { role, sid,
    // startedAt, expiresAt, workspaceId, actorWorkspaceRole } | null) — the JWT
    // itself never enters state (see that file's header). components/
    // PersonaPill.js is the SOLE reader/writer of these three keys (`personaActive`,
    // the RoleToggle label, the ExitBtn) — do not add a second copy of persona UI
    // state anywhere else; extend this one.
    //
    // Declared here (not left to smbls 3.14's create-signal-on-first-write)
    // because EVERY write below was a silent no-op before this line existed —
    // v3.14's typed-bag root.update() drops writes to undeclared keys, so
    // `endPersonaSession`'s `root.update({ _personaSession: null, ... })` and
    // every other write in shared/functions/persona.js + components/
    // PersonaPill.js landed on the floor. PERSONA-1..4 shipped a fully working
    // server + SDK + client-plumbing stack around a state key that could never
    // actually hold a value client-side.
    //
    // Workspace-SCOPED (below, WORKSPACE_SCOPED_KEYS): a persona session is
    // bound to one workspace (`workspaceId` in the blob; the server's sid
    // resolver refuses cross-tenant reuse — 886a9b27) and `sdk.switchWorkspace`/
    // `switchOrg` already end the persona server-side + restore the admin's
    // token via PersonaService's own switchWorkspace/switchOrg hooks (sdk
    // src/services/PersonaService.js) — so a workspace switch means "the persona
    // ended" is already true API-side by the time onWorkspaceChange's PHASE-1
    // wipe runs. Registering the key here just makes the CLIENT admit the same
    // truth: without it, a stale `_personaSession` would keep painting "Viewing
    // as <role>" over the NEW workspace after the persona that role referred to
    // was already gone — the exact "registered but the wrong state survives"
    // half of the standing isolation invariant. `_personaPickerOpen` /
    // `_personaExiting` are pure transient UI state for the SAME pill, wiped for
    // the same reason (an open picker or a stuck "Exiting…" must never carry
    // into the next workspace's first paint).
    _personaSession: null,
    _personaPickerOpen: false,
    _personaExiting: false,
    // Org-switcher transient UI flags. Declared explicitly because smbls
    // 3.14 root.update() drops keys not in the schema (treats state as a
    // typed bag). `_wsSwitching` drives AppWorkspaceSwitchOverlay;
    // `_pendingActiveOrgId` is the optimistic-pick override the org
    // switcher reads so the dropdown reflects the click instantly,
    // without waiting on the server JWT refresh round-trip.
    //
    // (Removed 2026-06-03: _wsMenuOpen — AppOrgSwitcher migrated to
    // @symbo.ls/dropdown which owns visibility state internally.)
    _wsSwitching: null,
    // Boot fix step 4b: true while the installed apps of THIS workspace set up
    // in their idle slices after the reveal (functions/workspaceProjects.js
    // _runAppActivations). The home keeps a saved app cell's skeleton while it
    // is up (pages/main.js _moduleRoutesPending); the queue drops it on drain.
    // Declared so the PendingWidgets subscription sees every flip.
    _appsSettingUp: false,
    _pendingActiveOrgId: null,
    _loginLoading: false,
    // The address a finished sign-up hands to the sign-in form when it could
    // not open the new account itself (shared pages/auth/signup.js
    // handToSignIn; signin.js reads it once and clears it). Never in the URL.
    _signInEmail: '',
    // Re-render signal of the runtime loader's ready hold (app.js THE READY HOLD).
    _loaderReadyHold: 0,
    // A sign-in ON this page has not applied the session's interface language
    // yet: the runtime loader holds and shows no word. Raised and paid by
    // functions/shellLangPolicy.js (markShellLangOwed / applyShellLangPolicy).
    _langOwed: false,
    // WorkspaceProjectSwitcher raises this synchronously on click so the
    // brand MainLoader surfaces before the SDK round-trip + fetch-cache
    // invalidation completes. Cleared in the switcher's try/finally.
    _wpSwitching: null,
    // Per-session "the server rejected setActiveOrganization for this org id"
    // cache. `AppOrgSwitcherItem.onClick`'s 403 catch pushes here so the
    // org disappears from the AppWorkspaceSwitcher menu for the rest of
    // the session — defensive against stale JWT `app_metadata.orgs` that
    // includes orgs the user has no `OrgMember` row for. Reset on the next
    // full sign-in cycle (state schema is fresh per shell mount).
    _invalidOrgs: [],
    // Root-mounted MainLoader's reactive visibility binds to this flag.
    // `applyLoader({ value: true|false })` writes through here so
    // long-running flows (org switch, project create, etc.) can surface
    // the brand loading overlay. Must be declared in the schema — smbls
    // 3.14 root.update() drops keys missing from the typed bag.
    loading: false,
    // Private data — populated by loadPrivateData on sign-in / org-switch.
    peopleAll: [],
    // Populated by useOnlinePresence (subscribed in app.js onCreate).
    onlineUsers: [],
    teamsByEmail: {},
    // Primary team-membership index, keyed on the stable non-PII userId that
    // rides every roster row (server memberProjection.js). teamsByEmail is a
    // legacy alias kept for mgmt viewers / optimistic writes where an email is
    // known — but a non-mgmt viewer's roster payload has NO email, so the id
    // index is the one that resolves for them (tickets/fable.md P0 regression).
    teamsByUserId: {},
    orgMembersByOrgId: {},
    // Per-team "members already fetched this session" flags — `{ [teamId]: true }`.
    // MUST be declared here: smbls 3.14 root.update() silently drops any key
    // missing from this typed schema, so without it `loadTeamMembers`' (teams.js)
    // idempotency guard never persisted — every loadPrivateData fire (sign-in,
    // ~hourly token refresh, org switch) re-fetched every team's members,
    // storming GET /organizations/:org/teams/:team/members.
    teamMembersLoaded: {},
    userDocs: null,
    userPrefs: null,
    // Home dashboard prefs (workspace-scoped): the user's own hidden-widget set +
    // grid layout (userDashboardPrefs, per user × workspace) and the workspace
    // admin default panel set (workspaceSettings). See migration 0157 + main.js.
    userDashboardPrefs: null,
    // True once the home-dashboard prefs GET for the ACTIVE workspace has
    // SUCCEEDED this scope (even when it returned no row). Distinguishes "the
    // user has no saved row" from "the read failed/hasn't landed" — the grid
    // boot must never persist its default hidden set over an UNREAD row (that
    // clobber is how a degraded boot rewrote saved dashboards to
    // greeting-only, 2026-07-28). Wiped on workspace switch below.
    _dashPrefsReadOk: false,
    // Per-workspace settings bag. The server persists `home_default_panels` today;
    // applyWorkspaceConfig (functions/workspaceConfigs.js) also resolves four
    // frontend fields on workspace activation and merges them here:
    //   home_default_panels — admin default home panels (server)
    //   designSystem        — personalized skin { canvasBg, vars } | null
    //   language            — BCP-47 lang for <html lang>
    //   layoutDirection     — 'ltr' | 'rtl' for <html dir>
    //   navbar              — HeaderTabs arrangement [{key,label,path}] (default
    //                         Studio/Tasks/Files; GreenIG → Claims/Users/Calendar)
    //   modules             — enabled workspace module ids | null
    workspaceSettings: null,
    resourceLinks: [],
    intranetEvents: [],
    // The calendar window has answered (loadPrivateData), so an empty
    // `intranetEvents` is a real "nothing", not "not read yet" — or it failed,
    // and the home Next up widget says so instead of a skeleton that waits
    // forever. Both are wiped with the events on a workspace switch.
    intranetEventsLoaded: false,
    intranetEventsError: false,
    jwtClaims: null,
    signedIn: false,
    // Auth-resolution gate. Flipped to true synchronously inside the
    // shell's `onCreate` once the pre-resolved auth snapshot from
    // bootShell has been seeded into root (or once subscribeAuthSession
    // has fired at least once on the anonymous-boot path). Reactive
    // consumers that would otherwise flash with schema-default values
    // (NoOrgOverlay's empty create-team modal, sign-out chrome, etc.)
    // hide until this flips. Without it, the window between mount and
    // the first auth fire painted an incorrect frame for every signed-in
    // user.
    _authReady: false,
    // True ONLY while the currently-painted chrome (org/workspace/roster —
    // the fields `context.preResolvedAuth` carries) came from
    // bootSnapshot.js's warm-start cache rather than a confirmed live
    // response (tickets/opus.md "boot: the scope-keyed warm-start snapshot's
    // PAINT half"). bootShell flips it back to `false` the moment the REAL
    // `/core/boot` round trip resolves and reconciles over the seed — never
    // reuse `workspaceReady` for this (that flag means "confirmed complete
    // record"; overloading it would let an unconfirmed cache paint as
    // authoritative). Declared here so smbls 3.14's typed-bag
    // `state.update()` doesn't silently drop it on that reconcile write.
    _bootFromCache: false,
    currentUserEmail: '',
    currentUserId: '',
    // Legacy external auth UUID (nothing mints new ones). Mongo `_id` and
    // the legacy UUID are different identifiers for the same person;
    // most legacy meet/canvas/governance rows (`meet_rooms.created_by`,
    // `canvas_pages.created_by`, RLS-scoped tables) reference the
    // legacy UUID, while `currentUserId` above carries the Mongo
    // _id. Host-only gates on those rows compare against this field —
    // see ControlBar.SettingsBtn / EndRoomBtn — so a federated user
    // who created a meet room can actually unlock the room-settings
    // pane on their own call.
    currentUserSupabaseId: '',
    // Mongo `User.username` — declared so it survives smbls 3.14's
    // "typed bag" root.update() (any key not in this schema is silently
    // dropped). bootShell seeds it from the /core/auth/me response so
    // components that build `/user/:slug` links (header dropdown, share
    // sheets, etc.) have the canonical slug instead of falling back to
    // the email local-part.
    currentUserUsername: '',
    orgNotifCount: {},
    // PROJECT scope — canvas-internal switchProject invalidates
    project: null,
    projectComponents: null,
    projectPages: null,
    projectState: null,
    createMenuOpen: false,
    _addPagePicker: null,
    _addComponentPicker: null,
    // Public share-link dialog (PUBLIC-SHARE-LINKS-1) — ephemeral UI state for
    // the "Share publicly" modal, opened from /files and /notes alike.
    // WORKSPACE-scoped on purpose: the target is a file or a note that belongs
    // to ONE workspace, so a switch must not leave the dialog holding another
    // tenant's resource (or, worse, its freshly-minted URL) on screen.
    // `_shareNewUrl` carries the one-time link the server will never return
    // again; it lives here for the life of the dialog and nothing persists it.
    _shareTarget: null,
    _shareLinks: [],
    _shareBusy: false,
    _shareLoading: false,
    _shareError: null,
    _shareNewUrl: null,
    _shareExpiryKey: '30',
    // Public share-link VIEWER (/s/<token>, PUBLIC-SHARE-LINKS-1) — the
    // recipient's read state. Deliberately NOT workspace-scoped: the person on
    // this page has no workspace, no org and no session, and the surface is
    // reached by URL only. See WORKSPACE_UNSCOPED_KEYS below.
    _sharedStatus: null,
    _sharedDoc: null,
    _sharedToken: null,
    // The file link's byte URL, resolved once when the payload lands (the
    // SDK proxy is async — a render factory cannot await).
    _sharedContentUrl: null,
    // WORKSPACE PROJECT scope — switchWorkspaceProject invalidates
    workspaceProject: null,
    // Navigation
    currentPath: '/',
    currentSearch: '',
    // The catch-all route's "Not found" grace latch
    // (WS-PREBOOT-NOT-FOUND-FLASH-ON-MODULE-ROUTE-1, pages/projectRedirect.js).
    // The catch-all's onInit arms a timer; when it fires, this flips to true
    // and NotFoundBody may show its copy although `_appRoutesSettled` never
    // latched (a signed-out visit runs no route loaders). One-way for the page
    // load: no code writes it back to false. Declared so the key exists from
    // the FIRST render and the root-write census can classify it.
    _notFoundGraceElapsed: false,
    // Unified-shell flag — sub-apps (canvas, …) read this to suppress their
    // own AppHeader when mounted inside the shell. Standalone wrappers
    // (canvas.localhost) do not set it, so app-specific headers keep rendering.
    _inShell: true,
    // ── WS-ROOT-STATE-FORM2-WRITE-HOLE-1 — Form-2 census drain, batch 2. ──
    // Eleven keys written by direct assignment (`root.key = …`) left the
    // ROOT_WRITE_UNDECLARED baseline for the declared universe. Scope verdicts
    // live in WORKSPACE_UNSCOPED_KEYS below (one block, argued per key).
    //
    // Canvas agents-page LENSES — seeded by the page's own onCreate
    // (`if (root._agentsScope == null) root._agentsScope = 'all'`), so the
    // declared default is null: 'all' as a default here would turn the seeds
    // into no-ops and hide the pages' own seeding contract.
    _canvasAgentsOnly: null,
    _canvasScope: null,
    _agentsScope: null,
    _agentsStatus: null,
    _agentsType: null,
    _agentsAssign: null,
    // Agent-editor capability/tool catalog — `sdk.getAgentToolCatalog()` takes
    // no scope argument (platform-wide config, the aiProviderDiagnostics
    // class). `null` = not fetched; the loader flag re-arms on failure.
    _agentToolCatalog: null,
    _agentToolCatalogLoaded: false,
    // TicketDetailModal dependency picker — query text + section collapse,
    // reset per ticket by the modal's own `el._fetchedForId` transition
    // (tickets/components/TicketDetailModal.js onUpdate).
    _depQuery: null,
    _depsOpen: false,
    // The open (?) help tooltip, by tip id — the brand QuestionMarkTooltip's
    // "one panel open at a time" latch (company/packages/brand/components/
    // QuestionMarkTooltip.js: `onMouseenter` writes it, the panel's `style`
    // factory + `styleDeps` and the button's `aria.expanded` + `ariaDeps` read
    // it off `s.root`).
    //
    // WHY THE SHELL HAS TO DECLARE A BRAND KEY. Measured live on
    // vault.pr.symbols.app (shell db2b1fd98, brand 3.14.787): every home MODULE
    // widget's (?) was dead while the static widgets' and the module pages'
    // (?) opened. Inside a module widget `s.root` is the MODULE store
    // (functions/moduleStateScope.js), whose signal traps split by key:
    //   • a READ of a key the module store does not own delegates to the shell
    //     root and subscribes the effect to the SHELL's signal;
    //   • a WRITE mints a LOCAL signal on the module store — unless the key is
    //     in SHELL_OWNED_STATE_KEYS, where `aliasShellOwnedKeys` has made the
    //     two stores share ONE signal object.
    // `helpTooltipOpenId` was declared nowhere in the shell, so it was not
    // shell-owned: the (?) button's hover wrote the module store's own signal
    // while its style/aria effects sat subscribed to the shell's. Measured on
    // the running page — after a real `mouseenter` the panel kept
    // `opacity: 0; visibility: hidden` and `aria-expanded="false"`, and forcing
    // the style effect to re-run painted the panel open immediately, i.e. the
    // factory was right and only the notification never arrived.
    // Declaring it here puts it in SHELL_OWNED_STATE_KEYS, so the module store
    // aliases the shell's signal for it and both halves meet on one signal.
    helpTooltipOpenId: null,
    // The ? keyboard sheet's open flag — the AppDialog stateKey of
    // components/ShortcutsOverlay.js, written by `?` (functions/shortcutsDefault.js
    // openShortcutsSheet) or the palette's row, cleared by the dialog's close
    // paths. Declared so the module store aliases the shell signal for it
    // (SHELL_OWNED_STATE_KEYS) — a palette row fired from a module surface writes
    // the SAME signal the shell-root sheet listens on.
    _shortcutsSheetOpen: null,
    // THE NEW-ACCOUNT WELCOME (functions/onboarding.js): the setup surface's
    // open flag (components/OnboardingWizard.js), the HOLD that covers a new
    // account's first load while its record is read (functions/onboarding.js
    // onboardingHoldNeeded), its flow ({ step, replay, progressed, picked,
    // picks, turns, ask, answered, seq, busy } — the wizard's picks and the
    // assistant's conversation live here as values and bundle KEYS, never
    // resolved text; the ready screen's flow adds `made`, the facts it froze
    // when it opened), the quick tour while it runs ({ at, ids, rect, total } —
    // functions/onboardingTour.js) and this session's decision (the copy of
    // `userPrefs.onboarding` that is newer than any read). Declared so the
    // root-write census classifies them (WORKSPACE_UNSCOPED_KEYS below).
    _onboardingOpen: null,
    _onboardingHold: false,
    _onboardingFlow: null,
    _onboardingTour: null,
    _onboardingDecision: null,
    // THE FLY ARRIVAL mark — true when this page load came through Fly's
    // hand-over (`?fly` in the address at boot, or the app builder's `&fly=`,
    // functions/onboarding.js onboardingNoteFlyArrival). It writes no decision:
    // it only keeps the new-account hold down and the full wizard closed for
    // this load, while Fly's own `pending` record (not this mark) is what owes
    // the person the one "Your workspace is ready" screen
    // (functions/onboardingReady.js). Per page load, never persisted.
    _onboardingFlyArrival: false,
    // Demo-session flag — written by bootShell's auth snapshot
    // (`resolveAuthSnapshot` → `{ isDemo: !!me.isDemo }`, spread into
    // `shell.state.update({ ...restAuth })` on the warm path). The write is
    // census-INVISIBLE (a spread carries no literal key), which is how it
    // stayed undeclared: nothing enforced it. Read by DemoClaimBanner.
    isDemo: false,
    // /admin/usage's bookkeeping (pages/admin/usage.js `_loadAll`): which
    // workspace the loaded numbers belong to, and the newest request's number.
    // The loader clears the numbers on a switch and drops an answer that is not
    // current; these two must SURVIVE the switch to do it (WORKSPACE_UNSCOPED).
    _usageWorkspaceId: null,
    _usageRequestId: 0,
    // /admin/usage's auto-top-up card (components/AdminAutoTopup.js,
    // functions/autoTopup.js, pages/admin/usage.js `_loadAll`). The rule, its
    // editor draft and step, the secure-setup URL, the consent box, the error
    // key, the touched flag and the in-flight flag belong to ONE workspace
    // (WORKSPACE_SCOPED: a switch wipes them, as the loader itself does on a
    // changed workspace). `_autoTopupRequest` is the answer counter
    // (functions/autoTopup.js `current()`): it must SURVIVE a switch
    // (WORKSPACE_UNSCOPED), like `_usageRequestId`.
    _autoTopup: null,
    _autoTopupDraft: null,
    _autoTopupStep: null,
    _autoTopupCheckoutUrl: null,
    _autoTopupConsent: false,
    _autoTopupError: null,
    _autoTopupTouched: false,
    _autoTopupBusy: false,
    _autoTopupRequest: 0,
    // /admin/usage: the return leg of a credit top-up checkout
    // (functions/topupReturn.js) — null, or { status: 'confirming' | 'paid' |
    // 'failed' | 'cancelled', sessionId, credits, error }. One workspace's
    // payment: WORKSPACE_SCOPED.
    _topupReturn: null,
    // /admin/usage: the person typed in (or cleared) the amount field — the
    // loader then leaves the field alone instead of filling in the server's
    // minimum (pages/admin/usage.js `_loadAll`). WORKSPACE_SCOPED, like the
    // loader's own reset of it on a changed workspace.
    _topupTouched: false,
    // The shell call panel (components/WorkspaceCallPanel.js). `_callPanel` is
    // the one call on screen (null = idle, hidden), written only by
    // functions/calls/workspaceCall.js — WORKSPACE_SCOPED: a call belongs to one
    // workspace's number; the switch stops the voice session first
    // (loadPrivateData.js, beside the LiveKit teardown). `_callPanelTick` is the
    // in-call timer's 1 s clock nudge — WORKSPACE_UNSCOPED, it carries no data.
    _callPanel: null,
    _callPanelTick: 0
};
var $091f10de306fac2f$export$2e2bcd8739ae039 = $091f10de306fac2f$export$85f66272382e17d5;
const $091f10de306fac2f$export$40e714049df95579 = new Set([
    ...(0, $4MpU9.WORKSPACE_SCOPED_KEYS),
    // ORG scope
    'orgMembers',
    'orgRoles',
    'orgTeams',
    'permissions',
    // WORKSPACE scope
    // The current workspace's app-setup queue flag (boot fix step 4b): a switch
    // wipes it, and the new workspace's pass raises its own when it has apps.
    '_appsSettingUp',
    // /admin/usage's auto-top-up card: one workspace's rule, editor and
    // in-flight state (see the STATE_DEFAULTS entry; the counter is unscoped).
    '_autoTopup',
    '_autoTopupDraft',
    '_autoTopupStep',
    '_autoTopupCheckoutUrl',
    '_autoTopupConsent',
    '_autoTopupError',
    '_autoTopupTouched',
    '_autoTopupBusy',
    // /admin/usage: one workspace's top-up return line (see STATE_DEFAULTS).
    '_topupReturn',
    '_topupTouched',
    'workspaceMembers',
    'workspaceIntegrations',
    'workspaceBilling',
    // The alterable-AI-reference mute holds a RECORD ID from this tenant
    // ('record:<type>:<id>', pageContext.js) — meaningless and stale across a
    // switch, so it wipes. It also self-invalidates on any record change, so
    // the wipe is belt-and-braces, not load-bearing.
    '_aiRefMutedFor',
    // The composer's chosen AI context names this tenant's apps and routes
    // (functions/aiScope.js); inspect & ask's mode and outline are dropped with
    // the page they were over (functions/aiInspect.js).
    '_aiAskContext',
    '_aiInspect',
    '_aiInspectBox',
    '_creditGuard',
    '_creditBannerDismissed',
    '_creditBlockerDismissed',
    '_creditsShort',
    // Persona (PERSONA-5) — bound to one workspace; see the defaults' doc
    // comment above for why a switch must wipe it even though the SDK/server
    // already ended the session by the time this runs.
    '_personaSession',
    '_personaPickerOpen',
    '_personaExiting',
    // Public share-link dialog (PUBLIC-SHARE-LINKS-1) — see the defaults above
    // for why a workspace switch must wipe it.
    '_shareTarget',
    '_shareLinks',
    '_shareBusy',
    '_shareLoading',
    '_shareError',
    '_shareNewUrl',
    '_shareExpiryKey',
    'userDashboardPrefs',
    '_dashPrefsReadOk',
    'workspaceSettings',
    'intranetEvents',
    'intranetEventsLoaded',
    'intranetEventsError',
    // A workspace switch's NEW target starts not-ready until its full record
    // lands — see `workspaceReady`'s doc comment above.
    'workspaceReady',
    // PROJECT scope (canvas)
    'project',
    'projectComponents',
    'projectPages',
    'projectState',
    // WORKSPACE PROJECT scope
    'workspaceProject',
    // Per-session "server-rejected orgs" cache — reset so a new session's
    // claims aren't pre-filtered by a previous tier's 403'd ids.
    '_invalidOrgs',
    // WS-SWITCH-DRAIN-EPICSTREE-FILEPREVIEWS-1 — three keys measured riding a
    // real cross-org switch on :4506. None is in this file's stateDefaults, so
    // each has a reset shape in WORKSPACE_SCOPED_OVERRIDES (state-app.js):
    // `epicsTree` is declared only in tickets/state.js (epic-type tickets;
    // loadEpicsTree's non-empty guard KEEPS a foreign list, so the wipe is the
    // only thing that can clear it — 13 system epics showed in Bellforge's
    // picker); `_filePreviews` / `_fileThumbs` are files/functions/index.js's
    // per-file snippet + cover caches, keyed by file id — tenant file content.
    'epicsTree',
    '_filePreviews',
    '_fileThumbs',
    // WS-SWITCH-INCOMPLETE-1 leg 14 (2026-08-21) — THE PIPELINE DRAG POINTERS.
    // Declared in `packages/pipeline/state.js`, not in this file's
    // stateDefaults, so their reset shape lives in WORKSPACE_SCOPED_OVERRIDES
    // (state-app.js) exactly like `epicsTree` above. The stage-pipeline is an
    // ABSTRACT shared library — it never names a collection — but the two id
    // keys hold `String(s.id)` of a CONSUMING APP'S ROW (bellforge's /execute
    // card, crm's deal), so what sits in root after a drag is a tenant row id.
    // Registered scoped because a drag interrupted by a switch is exactly the
    // case `pipelineDragEnd` never runs for: dragstart writes `pipelineDragId`,
    // the user switches workspace mid-drag, and A's card id stays pointed at
    // while B's board renders — `pipelineDragOverCard` then compares B's ids
    // against it and `pipelineDrop` reads it as the card to move.
    'pipelineDragId',
    'pipelineDragOverStage',
    'pipelineDropBeforeId',
    // WS-UNDECLARED-KEYS-DRAIN-BATCH-1 — the first five keys drained from the
    // root-write census backlog. None is in this file's stateDefaults, so each
    // carries its reset shape in WORKSPACE_SCOPED_OVERRIDES (state-app.js),
    // argued there key by key. One line of scope reasoning each:
    //   `projectMembers`  — PROJECT scope, beside `project`/`projectComponents`
    //     above: it is `sdk.getProjectMembers(projectId)`'s row list, i.e. the
    //     people of ONE canvas project, so it names a foreign tenant's members
    //     the moment the project or the workspace changes.
    //   `_mcpConnectorDraft` — WORKSPACE scope: a half-typed MCP connector form
    //     (url/token/name) for the workspace being administered; a leftover
    //     draft would be saved INTO the next tenant's connector list.
    //   `activityScoring` — WORKSPACE PROJECT scope: fetched from
    //     `workspaceProject.activity.scoringConfig`, so every row is one
    //     workspace-project's scoring config, never a platform constant.
    //   `_usageTurnStats` — WORKSPACE scope: fetched as
    //     `ai.turnStats({ workspaceId: wsId })`; the id in the request IS the
    //     scope, so the answer belongs to that workspace alone.
    //   `roomSettingsDraft` — WORKSPACE scope: the meet room-settings modal's
    //     buffered draft for one room, and rooms are workspace records.
    'projectMembers',
    '_mcpConnectorDraft',
    'activityScoring',
    '_usageTurnStats',
    'roomSettingsDraft',
    // WS-ROOT-STATE-FORM2-WRITE-HOLE-1 — Form-2 census drain, batch 2. None is
    // in this file's stateDefaults, so each carries its reset shape in
    // WORKSPACE_SCOPED_OVERRIDES (state-app.js), argued there. One line each:
    //   `_agents` / `_agentsError` / `_agentsLoaded` — the ORG agent roster
    //     (`sdk.listAgents(workspace_org_id)`), its failure text, and its
    //     one-shot fetch gate. The exact `peopleLoaded` shape one tier down
    //     (FALSE-ZERO-HOME-NON-AGENT-KEYS-1): a stale `_agentsLoaded: true`
    //     suppresses the next tenant's refetch, so org A's agent names/emails
    //     render in org B forever. Three producers share the gate (home
    //     _loadHomeAgentRoster, canvas team-and-agents _loadAgents, simone
    //     Chat.ensureAgentRoster) — all mount/touch-gated, so the wipe re-arms
    //     them; home's org-change onUpdate re-runs its loader in place.
    //   `_agentAssignmentsLoaded` + `agentAssignmentsByAssignee` /
    //     `agentAssignmentsByAgent` — the agent↔person assignment maps and
    //     their gate. Both maps are keyed by GLOBAL userId ("the shape that
    //     leaks silently" — the `roles` lesson above): the same key is valid in
    //     every tenant, so a stale row never looks wrong. Rows carry orgId.
    //   `_integrationHub` — `loadIntegrationCatalogue(workspace_org_id)` rows
    //     (org's integration kinds + configured instances incl. has_secret
    //     flags) written to the SHELL root by every /admin/integrations* page;
    //     each page refetches in onCreate, so the wipe shows "loading", never
    //     a foreign org's connector list. (The marketplace island writes a key
    //     of the same name on its OWN island host — out of this registry's
    //     jurisdiction; see the census fixture.)
    '_agents',
    '_agentsError',
    '_agentsLoaded',
    '_agentAssignmentsLoaded',
    'agentAssignmentsByAssignee',
    'agentAssignmentsByAgent',
    '_integrationHub',
    // Admin fix lane D (2026-09-24) — /admin/logs' read failure:
    //   `_adminLogsError` — WORKSPACE scope: `true` when the workspace's audit
    //     log could not be read (`workspaceProject.auditLog` list, scoped by the
    //     workspace id), so the page says the read failed instead of "No activity
    //     events". It describes one workspace's read and must not follow the
    //     member into the next workspace; the page re-reads on mount.
    '_adminLogsError',
    // The shell call panel's one call (components/WorkspaceCallPanel.js) — a
    // call on workspace A's number never shows in workspace B. The live voice
    // session is stopped before the wipe (loadPrivateData.js).
    '_callPanel'
]);
const $091f10de306fac2f$export$d5231c3582a837c6 = new Set([
    // The call panel's in-call timer nudge (functions/calls/workspaceCall.js):
    // a wall-clock number, no tenant data.
    '_callPanelTick',
    // The /tickets board's mounted status (tickets/pages/board.js). A fact about
    // the DOM, not about the tenant: a workspace switch keeps the board mounted
    // (its `workspace` watcher reloads it), so a wipe would read false under a
    // board still on screen and stop its counts refresh until a remount. The
    // counts it gates ARE scoped (totalByColumn / totalByType / _rawTypeCounts).
    '_ticketsBoardLive',
    // WS-SHELL-MOUNT-TREE-BUILD-2700MS-1 — the ModalRoot `if:` latch. One-way
    // and app-lifetime: it says "the shared dialog host has been built", which
    // is a fact about the DOM, not about the tenant. Wiping it on a switch
    // would evaluate the latch false and DESTROY the live ModalRoot (an `if:`
    // flip removes the node), so every openModal after the first tenant switch
    // would warn and no-op.
    '_modalHostReady',
    // WS-SHELL-BOOT-TASK-LOAF-ACCEPTANCE-1 — the staged-mount ladder counter
    // (functions/shellStages.js). Exactly the same class as `_modalHostReady`
    // above, and for exactly the same reason: it is a monotonic fact about what
    // the DOM has ALREADY BUILT ("the shell has reached stage N"), not about the
    // tenant. The latches that read it are one-way, so a wipe on a switch could
    // not un-build anything — it would only make the counter disagree with the
    // tree, and any latch re-evaluated in that window would read 0 and destroy a
    // live subtree (an `if:` flip removes the node). The ladder runs once per
    // page load and is never re-armed on a switch.
    '_shellStage',
    // The ticket-modal fold latch (functions/ticketDetailModalLoad.js). Same
    // class as `_modalHostReady` / `_shellStage`: a one-way fact about what
    // the registry and the DOM already hold, never about the tenant.
    '_ticketModalReady',
    // The white-label host-scope pin MIRROR (customDomainBoot.js →
    // WhitelabelRequestAccess). Derived from the HOSTNAME, not the tenant:
    // app.<customer> pins the same org for the life of the page whoever is
    // signed in and whatever workspace is active, so a workspace switch must
    // NOT wipe it — wiping would blank the non-member gate's reactive input
    // while the module pin (hostScopePin.js, the auth authority) still holds.
    // Null on every platform host by the same fail-closed contract.
    '_hostScopeOrgId',
    // The host's tenant binding itself (seedWhitelabelHostScope) — the same
    // hostname-derived fact as the pin above, so the same reasoning: a
    // workspace switch must never wipe the boundary that limits which
    // workspaces this tab may switch between.
    'whitelabelHostScope',
    // WS-ROOTWRITE-CENSUS-CHAT-ROOM-KEYS-UNDECLARED-1 (2026-10-18) — the meet
    // rooms sidebar's archive list. BROWSER-GLOBAL BY CONSTRUCTION: the archive
    // stub (meet functions/archiveRooms.js) keeps ONE list in localStorage
    // (`meet_archivedRoomsIds`) for every workspace this browser opens, and the
    // /meet page re-reads that same list into this key on every mount (meet
    // pages/index.js). A switch wipe could not make it tenant-correct — the next
    // /meet mount restores it — and while /meet stays mounted it would un-hide
    // the rooms this workspace archived. Its entries are room ids, globally
    // unique, so an id from another workspace matches none of this workspace's
    // rooms. A workspace-keyed (or server-side) archive is the meet stub's own
    // change, not the switch's. The edit-mode pair and the archived view that
    // read it ARE scoped (state-app.js, the meet block).
    'archivedRoomsIds',
    // /admin/usage's bookkeeping (pages/admin/usage.js `_loadAll`): the
    // workspace the loaded numbers belong to and the newest request's number.
    // NOT tenant data — they are how the loader tells a switch happened and an
    // answer went stale; a wipe would make an old workspace's late answer look
    // current. The numbers themselves are cleared by the loader on a switch.
    '_usageWorkspaceId',
    '_usageRequestId',
    // The auto-top-up card's answer counter (functions/autoTopup.js `current()`,
    // bumped by the usage loader on a changed workspace): a wipe would let an
    // old workspace's in-flight answer match a new request number.
    '_autoTopupRequest',
    // Public share-link VIEWER state (/s/<token>, PUBLIC-SHARE-LINKS-1). The
    // recipient is anonymous by design — this surface has no tenant to be
    // scoped to, and a workspace switch cannot happen while it is on screen
    // (it renders outside the app chrome). Wiping it would be a no-op that
    // implies a tenancy the page does not have.
    '_sharedStatus',
    '_sharedDoc',
    '_sharedToken',
    '_sharedContentUrl',
    // INVITE FLOW — user-level onboarding beats, not tenant data. The accept
    // page raises `_inviteFlowActive` before any workspace scope exists, and
    // `_usernamePromptPending` + the `_unamePrompt*` modal carriers must
    // SURVIVE the joined-workspace switch (the nudge opens right after it);
    // a scoped wipe would eat the prompt mid-flow.
    '_inviteFlowActive',
    '_usernamePromptPending',
    '_unamePromptDraft',
    '_unamePromptBusy',
    '_unamePromptError',
    '_unamePromptStatus',
    '_unamePromptReason',
    // The campaigns card's group-by pill (WS-ANALYTICS-UTM-CAMPAIGNS-UI-1) —
    // a USER view preference ('campaign' | 'source' | 'medium' | 'content' |
    // 'term', declared in analytics/state.js), no tenant data in it; the feed
    // it selects (`_analyticsCampaigns`) IS scoped and refetches per tenant.
    '_analyticsCampaignsGroupBy',
    // Workspace presets (marketplace functions/workspacePresets.js, declared in
    // state-app.js's presets block): the PUBLIC preset registry
    // (GET /core/presets, one answer for every workspace and every visitor), the
    // time of its last good read, whether this host's SDK can read it at all,
    // and whether the last read failed. No tenant data in any of them — a wipe
    // would only make the next workspace read the same public list again. The
    // in-flight APPLY (`_presetApply`) names one workspace and IS scoped.
    '_workspacePresets',
    '_workspacePresetsAt',
    '_workspacePresetsUnsupported',
    '_workspacePresetsError',
    // USER identity + preferences — survive every tenant boundary; cleared only on logout
    'authBypass',
    'authUser',
    'cliAuth',
    'currentUserEmail',
    'currentUserId',
    'currentUserSupabaseId',
    'currentUserUsername',
    'jwtClaims',
    'lang',
    'perTabSessions',
    'preferences',
    'sdkSignedIn',
    'signedIn',
    // The sign-up → sign-in address handoff (shared pages/auth/signup.js
    // handToSignIn → signin.js, read once and cleared). PRE-AUTH: written and
    // read while signed out, when there is no workspace to switch; no tenant
    // data in it. A wipe could only lose the address mid-handoff.
    '_signInEmail',
    // Accessibility preferences — a person's contrast, motion, type-scale and
    // link-underline choices belong to THEM and to the device, not to whichever
    // workspace they happen to be in. Blanking these on a switch would take
    // someone's larger type or high contrast away mid-session, which is the
    // one class of setting where that is never acceptable. Same verdict, same
    // reason, as `themeMode` two lines down.
    'a11yContrast',
    'a11yFontScale',
    'a11yLinks',
    'a11yMotion',
    'themeMode',
    'themeResolved',
    // The home top's look (App strip style, names, summary style, sky;
    // functions/homeLook.js) — this session's decisions about a PERSON's
    // preference, the same class as `themeMode` beside it: it follows them to
    // every workspace, and a switch must not undo a choice they just made.
    '_homeLook',
    // The home tip's dismissal (functions/homeCtxTip.js) — the same class: a
    // PERSON's choice on this device, never workspace data.
    '_homeCtxTipDismissed',
    // The home tab's mode (functions/homeView.js, BLD-13): { workspaceId, mode,
    // barMode }. It carries its own workspace id and MUST survive a switch:
    // homeModeSync reads it in workspace B to give the person's own pick back
    // (a wipe first would leave A's home-tab mode live in B), then clears it.
    '_homeMode',
    // The window width's session decision (functions/slotSheetWidth.js) — the
    // same class.
    '_slotSheetWidth',
    // The /chat rail's dragged width (chat functions/chatSidebarResize.js) — the
    // same class: a layout choice with no workspace data in it.
    '_chatSidebarWidth',
    // The split view's divider (canvas PageSlot) — the same class: a layout
    // choice of the frame, with no workspace data in it.
    '_slotSplitRatio',
    'user',
    // TENANT identity itself — assigned by the switch, never blanked by it (see scopes.js: blanking `workspace` breaks chrome guards)
    '_pendingActiveOrgId',
    'cloudWorkspaces',
    'cloudWorkspacesError',
    'companyName',
    'org',
    'orgs',
    'workspace',
    'workspaceEmbed',
    'workspaces',
    // ENV / runtime facts — properties of the page or clock, not of a tenant
    '_bootFromCache',
    '_inShell',
    // The catch-all's "Not found" grace latch (see its STATE_DEFAULTS entry).
    // A fact about the page's CLOCK — the catch-all waited out its grace window
    // once this page load — with no tenant data in it. Its twin in the same
    // gate, `_appRoutesSettled`, is never wiped either, and it wins whenever it
    // is set. A wipe could only re-hide a "Not found" already on screen, and no
    // timer would reveal it again.
    '_notFoundGraceElapsed',
    'bridgeStatus',
    'bridgeUrl',
    'currentDay',
    'currentMinutes',
    'currentMonth',
    'currentOrigin',
    'currentPath',
    'currentYear',
    // DEPLOYMENT IDENTITY — a property of the HOST, not of the tenant.
    // `whitelabelBrand` is derived from `window.location.hostname`
    // (functions/whitelabelBrand.js) and stored on the ORG, not the workspace —
    // CustomDomainService returns {name,tagline,logoSvg,loaderLogoSvg,accent,
    // background,theme,personaSignins} and there is no workspace-level branding
    // field at all. A client-side switch cannot change the hostname, so the
    // correct value cannot change during a page's lifetime.
    // ⛔ And a wipe is PERMANENT for the session: `applyWhitelabelBrandLate` is
    // called only from the boot entry, no switch path calls it. Since the org
    // switcher raises the full-screen MainLoader and the white-label override
    // gates every branded prop on `s.root.whitelabelBrand`, wiping it flips a
    // customer's own domain to the Symbols spiral mid-switch and leaves it
    // generic until reload.
    // ⚠️ THE COUNTER-CASE, so it does not have to be re-derived: a white-label
    // host may legitimately display another tenant's data, which makes
    // branding-as-tenant-identity a fair concern. It does not change the answer
    // here — the lookup is host-keyed, so wiping yields NO brand rather than the
    // other tenant's. If that concern is real the fix is a RENDER GATE plus a
    // server change (projectBrandingForPublic projects away every identifier, so
    // the bag carries no organizationId to gate on) — not a registry entry.
    // Flip this one line if you disagree; the argument is here, not elsewhere.
    'whitelabelBrand',
    // The Fly rail put away or shown (functions/assistantFly.js
    // assistantFlyRailToggle, its only writer): a person's UI choice, kept on
    // the device, holding no tenant data — the same in every workspace, so a
    // switch keeps it (the rail of the next workspace's session opens the way
    // the person left it).
    '_aiFlyRailHidden',
    // The phone-viewport answer (functions/phoneNavigation.js phoneNavigationSync,
    // shared/components/MobileRailSheet.js): a fact about the device width, read
    // from the brand's mobileL query. A switch keeps the same screen; wiping it
    // would un-park the composer and drop the rails' phone gate until the next
    // resize. The phone dock's own panel and composer keys ARE scoped.
    '_isPhoneViewport',
    // DEVICE capture state — belongs to the mic/tab, not the workspace
    'voiceChatKey',
    'voiceEngine',
    'voiceEngineReason',
    'voiceError',
    'voiceFinal',
    'voiceHost',
    'voiceHostReady',
    'voiceInterim',
    'voiceLang',
    'voiceMicMuted',
    'voiceMinimized',
    'voiceMode',
    'voiceOpen',
    'voiceReply',
    'voiceResult',
    'voiceStartedAt',
    'voiceStatus',
    'voiceTurns',
    // UI INPUTS — the documented carry-across set (searchQuery/filter*/…) the user expects to persist
    // A transient focus flag of the open ticket modal — no workspace data in it,
    // and the modal closes on a workspace switch.
    '_assigneeFocused',
    '_assigneeQuery',
    '_broadcastQuery',
    // The launcher's category filter (components/SearchAppsMenu.js) — a view
    // filter, no workspace data in it; a group the next workspace lacks reads
    // as 'all' (SamSections), so carrying it across shows nothing foreign.
    // Its filter text and its search model likewise: typed app-name words,
    // reset on every trigger open, and which opener opened the panel.
    '_launcherFilter',
    '_launcherGroup',
    '_launcherMode',
    '_notifFilter',
    // The active option of an open ticket people list — a list position, no
    // workspace data in it; the modal closes on a workspace switch.
    '_peopleFieldActive',
    '_remindersFilter',
    // WS-SWITCH-INCOMPLETE-1 drain step 3 (bucket A2) — ⛔ THE ONE KEY IN
    // THE REMINDERS COMPOSER WHOSE BUCKET NAME POINTS THE WRONG WAY. It is
    // called a draft field, but its value is a MODE from a vocabulary the
    // source defines ('private' | 'shared'), byte-identical in every
    // workspace — and it is held in LOCKSTEP with `remindersScope`, two
    // lines above, which was reviewed unscoped for that same reason.
    // `setRemindersScope`'s early-return literally asserts the two are
    // equal. Wiping one half and not the other would desync the composer's
    // visibility toggle from the list it feeds — a state no writer in
    // functions/reminders.js can produce. A lockstep pair is classified as
    // a UNIT or not at all. See __tests__/remindersDraftTenantScope.test.js.
    '_reminderDraftShared',
    '_reporterQuery',
    'chatInput',
    'currentSearch',
    'docsQuery',
    'feedFilter',
    'filterAssignee',
    'filterLabel',
    'filters',
    'kbQuery',
    'navSearchQuery',
    'notesFilter',
    'peopleQuery',
    'searchQuery',
    'targetDraftCustom',
    'targetDraftCwd',
    'targetDraftMode',
    // UI VIEW/LAYOUT prefs — how a surface is displayed, not what it displays
    '_addAppScope',
    '_addAppPhonePane',
    '_broadcastScope',
    '_broadcastVisibleCount',
    '_chatCtxFolded',
    '_commentTab',
    '_documentsCtxFolded',
    '_mailCtxFolded',
    '_meetCtxFolded',
    '_profileTab',
    'activeSection',
    'activeTab',
    'assistantWidth',
    'collapsedGroups',
    // The reader's own note reading settings (documents functions/
    // notesReader.js) — a size, a line height and a column width from a
    // vocabulary the source defines, the same in every workspace. The person
    // keeps them across a switch, like the assistant's width beside it.
    'notesReader',
    'contentSection',
    'editorMode',
    // The History app's activity-type filter — a MODE from a vocabulary the
    // source defines ('ticket_update', 'standup', …), byte-identical in every
    // workspace; the person filter beside it names a roster email and is scoped.
    'historyType',
    'isRootState',
    'meetView',
    'modelMode',
    'profileModalTab',
    'remindersScope',
    'showEventDetail',
    'showFilterBar',
    'showLiveCaptions',
    'showMeetChat',
    'showMeetTranscript',
    'showNewBooking',
    'showNewChannel',
    'showRoomSettings',
    'showSessionMenu',
    'showSettings',
    'targetMode',
    'targetPickerView',
    'ticketEditMode',
    'viewMode',
    // UI TRANSIENT — overlays, anchors, drag state; closed or re-derived by the navigation the switch performs
    '_addComponentPicker',
    '_addPagePicker',
    '_aiModePickerAnchor',
    '_aiModePickerOpen',
    '_aiModePickerTick',
    '_aiPinMenuOpen',
    '_ax_showSessionMenu',
    // ⛔ `_canvasSlot` + `_canvasSlotSecond` LEFT THIS BLOCK on 2026-10-23
    // (WS-SWITCH-RESET-MISSES-SLOTS-AND-DRAFT-1). They sat here under this
    // block's reason — "closed or re-derived by the navigation the switch
    // performs" — and a workspace switch performs no such navigation: the URL
    // sync rewrites only the `/w/<org>/<ws-handle>` prefix and keeps every
    // route segment. Their value is a full tenant ROUTE ('/tickets/<id>',
    // '/documents/<id>'), not an overlay flag, so workspace A's pane page
    // re-mounted under workspace B. They are now registered scoped beside the
    // other pane keys (state-app.js, the PageSlot block).
    '_cvSelectionTick',
    '_db_showSessionMenu',
    '_dropdownLayer',
    '_homeThreadOpen',
    '_homeWidgetForm',
    '_infraIntent',
    '_mainThreadPath',
    '_mentionModal',
    '_modelMenuOpen',
    '_navSearchOpen',
    '_navbarDragOverAfter',
    '_navbarDragOverPath',
    '_navbarDragPath',
    '_profileEditing',
    '_promptFocused',
    '_promptMenuOpen',
    '_aiPanel',
    // the open view's room under a new answer's section: re-derived by the view
    // itself — a switch changes its conversation or Fly session, which clears it
    '_revealRoom',
    '_routeNudge',
    '_searchResultsInLauncher',
    '_simoneAgentPicker',
    '_slotNudge',
    '_teamInviteLinkCopied',
    '_versionsOpen',
    '_wsInviteLinkCopied',
    'activeDrag',
    'assistantOpen',
    'assistantResizing',
    'composerOpen',
    'composerPreview',
    'composerSubmitting',
    'contextDropdown',
    'createMenuOpen',
    'dragPreview',
    'dropPreview',
    // The open (?) help tooltip id (see the STATE_DEFAULTS entry). Pure UI
    // chrome about the pointer's position on THIS page — it carries no tenant
    // data, and a workspace switch re-renders the board anyway, so wiping it
    // would only close a panel that is already gone.
    'helpTooltipOpenId',
    // The ? keyboard sheet (see the STATE_DEFAULTS entry). A UI mode on the shell
    // root — no tenant data; a workspace switch leaves an open sheet open.
    '_shortcutsSheetOpen',
    // The new-account welcome (see the STATE_DEFAULTS entry). A PERSON's
    // onboarding beat, the class of `_usernamePromptPending`: the surface's
    // flag and its first-load hold, its flow (the wizard's picks and the
    // conversation — values and bundle keys, no tenant data; the workspace's
    // name is read live from `workspace`, which the switch reassigns), the
    // tour's stop box, and the person's own decision, which follows them to
    // every workspace like `_homeLook`. A wipe on a switch would end a setup or
    // a tour mid-way and let the welcome re-open for a decision already made.
    '_onboardingOpen',
    '_onboardingHold',
    '_onboardingFlow',
    '_onboardingTour',
    '_onboardingDecision',
    // …and how this page load arrived (the Fly arrival mark, see its
    // STATE_DEFAULTS entry): a fact about the load, not about a tenant.
    '_onboardingFlyArrival',
    'hidePickTool',
    'inspectorTools',
    'lightbox',
    'mentionPicker',
    'myViewQueueOpen',
    'notificationsPanelOpen',
    'picking',
    'quickCreate',
    'renameModal',
    'searchOpen',
    'selectedCategory',
    'selectedFolder',
    'shareLinkCopied',
    'sidebarDropdown',
    'targetPickerOpen',
    // TRANSPORT flags — in-flight/loading/typing booleans, re-derived by the switch itself
    //
    // ⛔ THE NAME IS A CLAIM, AND IT MUST STAY TRUE OF EVERY ENTRY. Corrected
    // 2026-08-19 (WS-SWITCH-INCOMPLETE-1): `_wsInviteStatus`/`_teamInviteStatus`
    // were filed here and were NOT booleans — objects `{tone, message, inviteUrl}`
    // carrying the previous workspace's invite URL, which the admin page rendered
    // and offered to copy. Nothing re-derived them on a switch either, so BOTH
    // halves of this heading were false for them; they now live in
    // WORKSPACE_SCOPED_KEYS (state-app.js, beside their defaults).
    // ⇒ Before adding a `*Status` / `*State` / `*Result` key here, check the VALUE
    // and not just the name: a key that holds an object belongs here only if that
    // object carries no tenant data, and "re-derived by the switch" must name the
    // code that actually re-derives it.
    '_aiActionRunning',
    '_aiSvcReady',
    '_aiTicketLoading',
    // ⛔ `_approvalPending` LEFT THIS SET on 2026-08-20 (WS-SWITCH-INCOMPLETE-1,
    // bucket A2) and it is the SECOND correction to this heading, in a new way.
    // It really was a boolean, so the first half of the heading held. The second
    // half — "re-derived by the switch itself" — held only by ACCIDENT: nothing
    // re-derives it, but its completion handler always ran and always wrote
    // `false`. Adding the `sameWorkspaceWriter` tenant guard to that handler (as
    // the same commit had to) makes the completion DROPPABLE, and a dropped
    // completion never clears the latch. It is scoped now, beside its four
    // siblings in state-app.js.
    // ⇒ Before adding an in-flight flag here, ask who clears it, and whether
    // that clearer can be SKIPPED. "The reply always writes false" is not
    // re-derivation by the switch; it is a dependency on the reply arriving.
    '_authReady',
    '_ax_chatTyping',
    '_broadcastSaving',
    '_commentsLoading',
    '_db_chatTyping',
    '_docSaving',
    '_followInFlight',
    // A boolean, no data. Re-derived by the switch: the new workspace's full
    // record re-runs applyShellLangPolicy, which pays it; a 7 s cap (on the
    // shell element) pays it whatever happens (functions/shellLangPolicy.js).
    '_langOwed',
    // The runtime loader's ready-hold re-render signal (a counter, no data):
    // carried across a switch on purpose, the hold itself lives on the element.
    '_loaderReadyHold',
    '_loginLoading',
    '_meetAnalyzeInFlight',
    '_navSearchLoading',
    '_profileLoading',
    '_profileSaving',
    '_wpSwitching',
    '_wsRefreshing',
    '_wsSwitching',
    'analyzing',
    'authReady',
    'chatTyping',
    'cloudWorkspacesLoading',
    'feedLoading',
    'loading',
    'meetCallInFlight',
    'meetChatUnread',
    'syncing',
    'transcriptPending',
    // WS-SWITCH-INCOMPLETE-1 drain step 6 — BUCKET B, the half of the overlay
    // pointers the rule sends HERE. The rule is written once, beside the twelve
    // that went the other way, in state-app.js's WORKSPACE_SCOPED_KEYS: a pointer
    // is scoped when its value is drawn from workspace-scoped data, unscoped when
    // its value comes from a vocabulary the SOURCE defines. Every value below is
    // a literal in the source, so none of them can name anything of workspace A.
    // ⛔ AND WIPING THEM WOULD BE ITS OWN BUG — a dock position or a reorder mode
    // is the USER'S choice, not the tenant's; a wipe would yank the assistant
    // back to the right edge mid-switch. See __tests__/bucketBOverlayPointers.test.js.
    '_assistantPillHandle',
    // Session marker of a Page-mode promotion (values: 'main' | null — a
    // vocabulary the source defines); the user's dock choice, like
    // `assistantDock` below, survives a switch.
    '_assistantDockPromotedFrom',
    '_navbarReorder',
    '_ticketFullPage',
    'assistantDock',
    // The assistant's MODE ('assistant' | 'dashboard' | 'apps' — a vocabulary
    // the source defines, functions/assistantMode.js): the person's choice, the
    // same class as `assistantDock` beside it; a switch must not undo it.
    'assistantMode',
    // Agent mode (functions/agentMode.js): the person's choice and a link
    // visit survive a switch; the runtime re-creates itself for the new
    // workspace (functions/agentModeRuntime.js), so its render counter and its
    // start error are not workspace data either.
    'agentMode',
    '_agentModeLink',
    '_agentModeRev',
    '_agentModeError',
    // What this page's shell + SDK render (`{ records: 1 | 0 }`,
    // assistantClientCapabilities): a fact about the SDK the page loaded,
    // the same in every workspace, so a switch keeps it (a wipe would only
    // read the same answer again).
    '_aiClientCaps',
    'hoverTime',
    // ⚠️ THE THIRD NAME `_selField` CAN RETURN, and the one no instrument saw.
    // `selectedTeamCategory` is the binary member-status lens ('active' |
    // 'inactive'), so the rule files it here — but it reached step 6 UNDECLARED,
    // invisible to the partition (no default ⇒ not in the universe) and to the
    // root-write census (computed-key write ⇒ not a literal). Its default is now
    // declared beside selectedGroup/selectedRole in state-app.js. See that
    // comment; it is the clearest example this ticket found of the enumeration
    // hole the whole ticket exists to close.
    'selectedTeamCategory',
    // ── WS-SWITCH-INCOMPLETE-1 step 8 (bucket E, 2026-08-21) — thirteen keys
    // that left WORKSPACE_SCOPE_UNREVIEWED for HERE, each on its WRITER and the
    // SERVER CALL it mirrors (see __tests__/bucketETenantScope.test.js).
    // USER profile page plane — three of the five `_profile*` keys are NOT
    // tenant rows (the other two, `_profileViewed` + `_profileActivity`, are
    // scoped in state-app.js):
    //   `_profileSlug` is the URL segment of /user/:slug — a string off
    //   window.location, nulled by the page's own onRemove (shared/pages/
    //   userProfile.js). `_profileProjects` is `listPublicProjects({ owner })`
    //   — the VIEWED user's public projects, keyed by owner slug, the same list
    //   in every workspace. `_profileSaveError` is the error text of
    //   `updateUserHrProfile(userId, …)` — a USER-record write with no
    //   workspace argument (its header rejects the caller-scoped route on
    //   purpose).
    '_profileProjects',
    '_profileSaveError',
    '_profileSlug',
    // USER follow graph — `followingEmails` has NO server call: it mirrors the
    // localStorage blob `marketplace.follows` (app.js boot hydrate, UserProfile
    // toggleFollow), and every reader falls back to that blob. A wipe would
    // only desync state from the disk copy that re-hydrates it on the next read.
    'followingEmails',
    // TOAST queue — `notifications` is the GlobalNotification plane: transient
    // text raised locally by `openNotification`, auto-dismissed by the
    // module-level `_timers` map. No rows, no server. (The notification CENTER
    // is `notifs`, below — a different key on purpose, state-app.js says so.)
    'notifications',
    // NOTIFICATION CENTER — `notifs` is the USER's inbox, not a workspace list:
    // `workspaceProject.notifications list` takes no argument and returns the
    // recipient's rows across workspaces (shared/functions/notificationScope.js:
    // "The inbox is NOT single-workspace… a row can name another org entirely",
    // which is why it ships a Workspace TAB). SETTLED AGAINST THE SERVER on this
    // ticket's live runs (legs 9 + 10: the same rows came back in both
    // workspaces — qualified, not residue). Its fetch memo is tenant-keyed
    // already (WS-SWITCH-MEMO-PLANE-1). ⛔ AND WIPE-HOSTILE: the bell's element
    // memo `el._loadedFor = email` gates the reload on EMAIL ONLY, so a wipe
    // without a forced refetch leaves the bell empty until remount.
    'notifs',
    // …and whether it answered once: it follows `notifs` (the user's inbox,
    // not a workspace list), so a switch keeps it with the rows it describes.
    'notifsLoaded',
    // PRESENCE — `onlineUsers` is fed by ONE global subscription,
    // `sdk.subscribePresence({ scope: 'symbols', … })` (shared/functions/
    // presence.js): org/company-wide, no workspaceId anywhere, so a switch
    // does not change who is online. ⛔ WIPE-HOSTILE: its writer keeps a
    // closure memo `lastOnlineSig`; the roster signature is unchanged across a
    // switch, so the next sync would skip the repair write and the strip would
    // stay empty until someone's status happened to change.
    'onlineUsers',
    // LOCAL CLAUDE-CODE BRIDGE — five keys written ONLY by `ws://localhost:8765`
    // handshake frames (functions/_simone/wsBridge.js handleBridgePayload) or
    // by `installSimoneAiTransport`: `agent` (the CLI label in the connection
    // badge, rewritten to 'sdk-ai' on every install), `target` (a local cwd /
    // cloud pairing), `targetOptions` (the user's machine's project list),
    // `targetSelected` (the pairing flag, default TRUE — `_freshEmpty` would
    // restore true, never false) and `recentPairings` (keyed by browser ORIGIN,
    // mirrored to localStorage `symbols_recent_pairings`). The user's machine
    // does not change when the workspace does.
    'agent',
    'target',
    'targetOptions',
    'targetSelected',
    'recentPairings',
    // SERVER-WIDE AI config — `aiProviderDiagnostics` is `GET /core/ai/providers`
    // (no workspace argument); shared/functions/aiProviderDiagnostics.js says it
    // itself: "intentionally NOT chat-scoped — server-wide config, identical for
    // every chat surface/scope in the session".
    'aiProviderDiagnostics',
    // ── WS-ROOT-STATE-FORM2-WRITE-HOLE-1 — Form-2 census drain, batch 2. ──
    // CANVAS AGENTS-PAGE LENSES — bucket-B rule (see `_assistantPillHandle`
    // above): every value comes from a vocabulary the SOURCE defines, so none
    // can name anything of workspace A. `_canvasAgentsOnly` (true/null) and
    // `_canvasScope` ('mine'/null) are route lenses the pages set on mount and
    // CLEAR in their own onRemove (canvas/pages/agents.js, my-agents.js) — a
    // wipe would fight the pages' own lifecycle. `_agentsScope` / `_agentsStatus`
    // / `_agentsType` / `_agentsAssign` are filter pills seeded 'all'; filters
    // are the documented carry-across family (UI INPUTS above).
    '_canvasAgentsOnly',
    '_canvasScope',
    '_agentsScope',
    '_agentsStatus',
    '_agentsType',
    '_agentsAssign',
    // PLATFORM-WIDE tool catalog — `sdk.getAgentToolCatalog()` carries no org/
    // workspace argument, so the rows are identical in every tenant: the
    // aiProviderDiagnostics class, gate included. (Contrast `_agentsLoaded`,
    // which gates an ORG-scoped call and is therefore scoped.)
    '_agentToolCatalog',
    '_agentToolCatalogLoaded',
    // TICKET-MODAL DEP PICKER — `_depQuery` is user-typed search text (the
    // carry-across UI INPUTS family) and `_depsOpen` a section collapse (UI
    // VIEW prefs family); BOTH are reset per ticket by the modal's own
    // `el._fetchedForId` transition, which runs before any cross-tenant read
    // could happen (a switch closes the modal's ticket either way).
    '_depQuery',
    '_depsOpen',
    // USER-SESSION fact — `isDemo` is `getMe().isDemo` (an unclaimed sandbox
    // demo account); a property of the signed-in user, rewritten by every boot
    // auth resolve, cleared server-side on /demo/claim. Not tenant data.
    'isDemo',
    // …and the same claim's pending state (components/DemoClaimBanner.js, the
    // only writer): the new email the claim parked on the server's
    // `pendingEmail` and whether the server could mail its link — the signed-in
    // person's OWN account, never tenant data, and a demo session is locked to
    // its one workspace (DemoRouteGuard), so no switch reaches it.
    '_demoClaimPendingEmail',
    '_demoClaimPendingSent'
]);
const $091f10de306fac2f$export$8ed3e65848a95751 = new Set([
    // ── WS-SWITCH-INCOMPLETE-1 step 8 (bucket E, 2026-08-21): 80 -> 35. ──
    // Forty-five keys left this set in one argued diff — 32 to
    // WORKSPACE_SCOPED_KEYS (state-app.js, each beside its registration) and
    // 13 to WORKSPACE_UNSCOPED_KEYS (above, each with its reason). EVERYTHING
    // STILL HERE IS HERE FOR A NAMED REASON, and none of them is "unreviewed"
    // any more — they are two families with owners elsewhere:
    //
    // (D) DEAD ROOT DEFAULTS — 31 keys with NO LIVE ROOT WRITER at HEAD when
    //     bucket E landed; 23 now (the deletion bullet below).
    //     Classifying a key that nothing writes says nothing about the switch;
    //     they are bucket D, owned by WS-ROOT-DEFAULTS-NO-WRITER-1's coordinated
    //     build/delete call, not by this drain. Moving them to either registry
    //     would only make this set look shorter. Sub-kinds, each proven by a
    //     grep with a `_ticketComments` positive control (31 hits):
    //     • no writer anywhere — `_standupUserName` (one READ, TicketDetailModal's
    //       author fallback; the survivor control of the tenant-scope suite),
    //       `customerRequests`, `inboundRequests`, `outboundRequests`,
    //       `editRequests`, `improvementRequests`, `auditReports` (the six
    //       ROUTED request/resolution keys — they stay until Nika's
    //       build/delete/flag call lands), `noGeneralTarget`, `presence`
    //       (chat/functions/subscribeRealtime.js: the Supabase presence track
    //       was RETIRED; zero readers).
    //     • DELETED 2026-08-29 by WS-ROOT-DEFAULTS-NO-WRITER-1 (31 -> 23), the
    //       declaration in state-app.js and the entry here in ONE diff:
    //       `_standupHistory`, `_standupMessages`, `_todayUpdate`,
    //       `reactionsByMessage`, `epicCounts` (fetchEpicCounts RETURNS its map,
    //       never writes root), `epicOptions`, `assistantDraft` (its own comment
    //       said the new simone Chat reads `chatInput`) — no reader either; and
    //       `suggestions`, read only by the gallery-only `ResolutionsMain`
    //       (Suggestions) page, deleted with it on Nika's answer D. Pinned gone
    //       by __tests__/deadRootDefaults.test.js.
    //     • written only `null` — `selectedDocument` (pageContext.js says so:
    //       "No editor reads `selectedDocument`, so the old bare update was
    //       dead").
    //     • HOST-written only — `feedPosts`, `_openThreads`, `_commentsByPost`,
    //       `composerDraft`, `composerError`, `_myProjects`: every write is
    //       `host.update?.()` on MarketplaceFeedIsland's OWN `state:` block,
    //       resolved by `useHostState(el, '_marketplaceHost')`; the root copies
    //       are shadowed defaults.
    //       ⛔ THIS ENTRY USED TO ADD "and `_marketplaceHost` is set nowhere in
    //       this shell", WHICH ARGUED THE OPPOSITE OF ITS OWN CONCLUSION and is
    //       corrected here (WS-SWITCH-RESET-MISSES-SLOTS-AND-DRAFT-1,
    //       2026-10-23). `useHostState`'s `_findHost` FALLS BACK to the nearest
    //       stateful ancestor when the predicate matches nothing, so a shell
    //       with no `_marketplaceHost` anywhere would route every one of these
    //       writes to THIS ROOT. The flag IS set in this shell — on
    //       MarketplaceFeedIsland itself — and the shell's `/marketplace/feed`
    //       route mounts that island (pages/index.js lazySharedLib entry ->
    //       marketplace/pages/feed.js, whose only child is the island), so the
    //       predicate matches before the walk reaches the root. The flag is
    //       what makes these shadowed, and it is pinned by
    //       marketplace/functions/communityDraftHostIsIsland.test.js — which
    //       also carries the no-island negative control showing the identical
    //       handler writing workspace A's project id onto the shell root.
    //       ⇒ AND NOTHING IS OWED AT THE ISLAND EITHER, so do not "finish the
    //       job" by teaching the island to wipe on a switch. The community
    //       feed carries NO tenant dimension: the posts and the follow graph
    //       are localStorage (marketplace/functions/community.js), and the
    //       composer's project picker is `sdk.listPublicProjects()` — the
    //       USER's own public projects, never a workspace-filtered list. A
    //       draft there is user data, so it legitimately outlives a tenant
    //       boundary, exactly like the UI-only filter inputs the registry
    //       deliberately leaves outside itself.
    //     • computed key with NO REACHABLE PREFIX — the six `_db_*` keys.
    //       `k = '_db_'` needs an ancestor with `chatScope: 'dashboard'`; the
    //       only chatScope mounts at HEAD are 'general' (Chat.js) and 'addapp'
    //       (pages/add-app.js), and homeAiSend.js records the retirement
    //       ("the inline dashboard thread is retired", 2026-07-19).
    //     • writer in an UNMOUNTED component — the sub-kind is now EMPTY.
    //       `navUnreadCounts` was its one member (writer: IntranetAppHeader,
    //       which nothing renders — app.js mounts the shared AppHeader — so
    //       AppNavbar's read always saw `{}`). It moved to
    //       APP_WORKSPACE_SCOPED_KEYS (state-app.js, the ⑮ MAIL block) on
    //       2026-09-06: the mail stream reducer gave it a LIVE MOUNTED writer,
    //       and the count it writes is a per-tenant fact. The chat half of the
    //       map still has no live writer; the key is scoped as a whole because
    //       the WIPE is per key, and its default `{}` is the correct reset for
    //       both halves.
    //
    // (L) LIVEKIT SESSION — DRAINED 2026-08-21, MEET-LIVE-CALL-SURVIVES-SWITCH-1.
    //     The 4 keys (`livekitConnected`, `livekitParticipants`,
    //     `livekitSpeakers`, `meetChatMessages`) that MIRROR the module-level
    //     `_livekitRoom` singleton in meet/functions/connectCall.js left this set
    //     for APP_WORKSPACE_SCOPED_KEYS (state-app.js, the meet block) in ONE
    //     LOCKSTEP diff with the teardown that makes the wipe truthful:
    //     `onWorkspaceChange` el.calls `disconnectCall` BEFORE its PHASE-1 wipe.
    //     Wiping the mirror without that teardown hides CallWidget over a room
    //     that is still publishing — the wrong state, not a fix — so if the
    //     teardown is ever removed these four return here in the same diff.
    //
    // ⭐ SURVIVOR CONTROL FOR THE LIVE PROBES FROM THIS LEG ON: `_standupUserName`
    // (bucket D, no writer, carries no tenant data — legitimately untouched by a
    // registry-driven wipe). `ticketDraft`, the previous control, drained in this
    // step.
    // (D) dead root defaults
    '_commentsByPost',
    '_db_activeProcesses',
    '_db_activeSessionId',
    '_db_chatMessages',
    '_db_currentAssistantId',
    '_db_runHistory',
    '_db_sessions',
    '_myProjects',
    '_openThreads',
    '_standupUserName',
    'auditReports',
    'composerDraft',
    'composerError',
    'customerRequests',
    'editRequests',
    'feedPosts',
    'improvementRequests',
    'inboundRequests',
    'noGeneralTarget',
    'outboundRequests',
    'presence',
    'selectedDocument'
]);

});
parcelRegister("4MpU9", function(module, exports) {

$parcel$export(module.exports, "default", () => $37afbd444df360a1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "WORKSPACE_SCOPED_KEYS", () => $37afbd444df360a1$export$40e714049df95579);
$parcel$export(module.exports, "WORKSPACE_SCOPED_OVERRIDES", () => $37afbd444df360a1$export$bb5fb09c0a882408);
// NO @symbo-ls/workspace-shared read here — not even a deferred-call
// wrapper. This state module is INVOKED at module scope below (the
// newBooking seed calls todayISO()), and under the current parcel cycle it
// evaluates BEFORE workspace-shared's default export settles — the wrapper
// fired eagerly and `_wsShared.functions` threw at parcelRequire time,
// booting every dev.my page BLACK (2026-08-12). A state seed must stay
// init-order-independent, so the trivial local-date format is inlined
// (same output as shared dateUtils.todayISO).

var $96RcK = parcelRequire("96RcK");
const $37afbd444df360a1$var$todayISO = ()=>{
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const $37afbd444df360a1$var$_today = new Date();
var $37afbd444df360a1$export$2e2bcd8739ae039 = {
    isRootState: true,
    currentUserEmail: '',
    currentUserId: '',
    signedIn: false,
    companyName: 'Symbols',
    // Auth claims + org context — populated by subscribeAuthSession from the
    // governance JWT. Without these declared, smbls 3.14 silently drops the
    // updates and org switching / People filter / role gates all break.
    jwtClaims: null,
    // Live AI model diagnostics (shared/functions/aiProviderDiagnostics.js —
    // server-wide, not chat-scoped). Undeclared, the write was dropped
    // outright (fault 2 of the diagnostics ticket).
    aiProviderDiagnostics: null,
    orgs: [],
    workspaces: [],
    org: null,
    workspace: null,
    _wsSwitching: null,
    // Current workspace's load phases; pending/failed apps must never look like
    // an empty successful install list. Wiped with the workspace below.
    _workspaceActivation: null,
    loading: false,
    // Optimistic-pick override for AppWorkspaceSwitcher. When the user
    // clicks an org in the dropdown, this gets set to the picked org id
    // so `_activeOrg(root)` (and thus the Trigger label + checkmark)
    // reflects the choice this same tick instead of waiting for the
    // server's JWT refresh. Cleared once the workspace-change handler
    // fires (or on switch error).
    _pendingActiveOrgId: null,
    _wsRefreshing: false,
    _loginLoading: false,
    orgNotifCount: {},
    orgNotifSignals: {},
    selectedGroup: null,
    selectedRole: null,
    // ⚠️ DECLARED 2026-08-20 (WS-SWITCH-INCOMPLETE-1 step 6) BECAUSE NOTHING
    // COULD SEE IT. `selectedTeamCategory` is the third key PersonCard.js's
    // `_selField` helper can name, alongside the two above — and all three are
    // written as `s.root.update({ [_selField(s.kind)]: s.name })`, a COMPUTED
    // key. It had no default anywhere, so the closed-world partition never had
    // it in its universe; and its only write is computed, so the root-write
    // census could not see it either. It was created by first write and was
    // invisible to BOTH instruments at once. It does not leak — its value is the
    // binary member-status lens 'active' | 'inactive', a vocabulary the source
    // defines — but "does not leak" and "nothing is watching" are different
    // facts, and only the first one was ever true here.
    // ⇒ Declared here so the partition can see it, and filed in
    // WORKSPACE_UNSCOPED_KEYS (state.js) with that reason.
    selectedTeamCategory: null,
    peopleQuery: '',
    // A plain seed — the page's location is never read while this module
    // LOADS. A test or tool that imports it under a partial `window` (no
    // `location`) passed the old `typeof window` guard and threw on
    // `window.location.pathname` at import time (authLoginBounceBreaker /
    // foreignOrgUrl, 2026-09-02). The shell's state.js seeds '/' over this key
    // anyway, and the router writes the real path on every navigation.
    currentPath: '/',
    // SEARCH-1 (2026-08-14): bumped by shellApp's onRouteChanged (app.js) on
    // EVERY el.router() navigation — the one reactive "the URL may have
    // changed" signal single-shell-root-instance components (TicketsDetailModal
    // chief among them) can subscribe to, since they never get a fresh
    // onCreate from the router's own content-swap.
    _routeNudge: 0,
    // HeaderTabs re-derives this route on navigation. It may include tenant
    // record ids, so the old workspace's active marker must not survive a switch.
    _navActivePath: null,
    navSearchQuery: '',
    navSearchResults: [],
    _navSearchGrouped: [],
    _navSearchLoading: false,
    _navSearchOpen: false,
    // ⌘K FILTER CHIPS (CMDK-05): `[{ field, value, label, fieldLabel }]` — the
    // app-record values the palette is filtered by (functions/search/
    // globalSearch.js runSearchAction). Tenant values (a customer, a wallet
    // kind), so workspace-scoped below; a closed search drops them.
    _navSearchChips: [],
    // THE ONE SEARCH DROPDOWN (9A — DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1): in
    // this shell the launcher (components/SearchAppsMenu.js) hosts the typed
    // results itself, so the header search's own results panel (shared
    // HeaderSearch `Dropdown`) stays hidden here — one dropdown, never two, and
    // never a second panel flashing in when the launcher closes. A capability,
    // not a state: declared true, never written. A shell that does not declare
    // it (canvas standalone's MainNavbar) keeps the header's own panel.
    _searchResultsInLauncher: true,
    // A home widget's "+" form, hosted at the shell root (components/
    // HomeWidgetFormHost.js — pick 10 C: "a widget + opens only its form,
    // never the whole page"): { form, moduleId, widgetId, seq } while a
    // module form is mounted, null otherwise.
    _homeWidgetForm: null,
    // THIS SESSION's decision about the window's WIDTH (the PageSlot sheet's
    // resize handle — functions/slotSheetWidth.js setSlotSheetWidth): a percent
    // of the band once the person decides, null until then (the sheet then
    // reads the record, `userPrefs.slotSheetWidth`, then this device's copy).
    // A PERSON's choice, unscoped like `_homeLook`.
    _slotSheetWidth: null,
    // THIS SESSION's width of the /chat rail (chat functions/chatSidebarResize.js
    // — the handle on the rail's inner edge): its share of the page row in
    // percent, null until the person drags (the rail then shows its `G`). A
    // PERSON's layout choice, unscoped like `_slotSheetWidth`.
    _chatSidebarWidth: null,
    // The split view's divider (canvas/components/PageSlot.js
    // PageSlotSplitHandle — drag, arrow keys, double-click back to 50): the
    // first pane's percent of the band, 30–70. Split sizing belongs to the
    // frame, never to an app or a route: a PERSON's layout choice, unscoped
    // like `_slotSheetWidth` (state.js WORKSPACE_UNSCOPED_KEYS).
    _slotSplitRatio: 50,
    // The launcher's category filter (components/SearchAppsMenu.js
    // SearchAppCategory): a searchAppGroupsFor group key, 'all' by default. A
    // view filter with no workspace data in it, unscoped with the other UI
    // inputs (state.js); a group the next workspace lacks reads as 'all'.
    _launcherGroup: 'all',
    // The open launcher's search model (functions/searchApps.js, the note above
    // launcherTileGroups): 'trigger' when a navbar chevron or the home App strip
    // opened it, 'companion' when the focused header search did. Written on
    // every open; one launcher layer exists at a time.
    _launcherMode: 'companion',
    // The launcher's OWN filter text — the field a trigger-opened panel shows
    // (components/SearchAppsMenu.js SamFilterField). Never the header search's
    // `navSearchQuery`; a trigger open resets it (functions/searchApps.js
    // openSearchAppsDropdown), and the companion never reads it.
    _launcherFilter: '',
    // SEARCH-1: keyboard-selected row index in the grouped results dropdown
    // (flat index across every group's items, matching NavSearchResultGroup's
    // flatten order) — -1 means no row is keyboard-selected.
    _navSearchActiveIndex: -1,
    // /admin/teams invite feedback (GA-W3.2) — seeded so the status/link/copy
    // factories register their deps at first render (absent-key trap).
    _teamInviteEmail: '',
    _teamInviteStatus: null,
    _teamInviteLinkCopied: false,
    // Workspace-invite card (GA-W2.1 UI) — same seeding rule.
    _wsInviteEmail: '',
    _wsInviteRole: 'editor',
    _wsInviteTeams: {},
    _wsInviteStatus: null,
    _wsInviteLinkCopied: false,
    navUnreadCounts: {},
    contentSection: null,
    // Anchored mini-profile popover (bottom-left presence dock avatars, and any
    // other person-avatar trigger that reuses it) — el.call('openPersonPopover',
    // email, anchorEl) in functions/personPopover.js stashes the target email
    // here right before opening the @symbo.ls/dropdown layer; PersonPopoverCard
    // (components/PersonPopover.js) reads it back reactively. Same "pointer on
    // root, read live" contract as profileEmail / _personDetail / selectedTicket.
    _personPopoverEmail: null,
    // The display name the OPENER knows for that email (a mail sender header)
    // — beats the bare address when the popover mints a Party from it.
    _personPopoverName: null,
    // Party-by-email resolution cache (§3.7 Directory, functions/
    // partyLookup.js): absent = never asked, `false` = resolved with no
    // match (gates "Add to directory"), object = the party summary.
    _partyByEmail: {},
    people: [],
    // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — the roster's POSITIVE load marker and
    // its error key. `people` is seeded `[]` above, so `Array.isArray(people)`
    // is true from the first frame and can never mean "loaded": measured on the
    // real schema default, a loaded 2-agent roster against the seeded `[]`
    // rendered a confident "2" team headcount and a 100%-agents share bar.
    // Written by every people producer — the shell-mount prime peek (app.js),
    // the boot loader and the workspace-switch reload (loadPrivateData.js), and
    // Home's Refresh (pages/main.js). `peopleError` records the boot fetch
    // failure that was previously only console.warn'd, so a failed roster read
    // renders '!' instead of the same 0 an empty workspace shows.
    peopleLoaded: false,
    peopleError: null,
    peopleAll: [],
    teams: [],
    teamsByEmail: {},
    // See state.js — the userId-keyed team-membership index that resolves for
    // non-mgmt viewers whose roster email is redacted (fable.md P0 regression).
    teamsByUserId: {},
    orgMembersByOrgId: {},
    // Pending WorkspaceInvitation rows for the active workspace — see
    // functions/pendingInvitations.js. Admin/owner-gated; a member's
    // fetch is skipped client-side (server 403s it anyway).
    pendingInvitations: [],
    // See state.js — `loadTeamMembers`' idempotency guard key. Undeclared keys
    // are dropped by smbls 3.14 root.update(), which broke the guard and caused
    // a team-members request storm.
    teamMembersLoaded: {},
    userDocs: [],
    userPrefs: null,
    resourceLinks: [],
    // (Removed 2026-06-03: _wsMenuOpen — AppOrgSwitcher migrated to
    // @symbo.ls/dropdown; the plugin owns visibility state internally.)
    announcements: [],
    selectedAnnouncement: null,
    // Broadcast newsroom UI. The records remain in `announcements`; these are
    // local view/editor controls so a workspace switch never carries content.
    _broadcastScope: 'internal',
    _broadcastTag: 'all',
    _broadcastQuery: '',
    _broadcastVisibleCount: 50,
    _broadcastDraft: null,
    _broadcastSaving: false,
    _broadcastSaveError: null,
    birthdays: [],
    companyInfo: [],
    roles: {
        available: [],
        byUser: {},
        version: 0
    },
    // ── Calendar ──
    viewMode: 'week',
    currentYear: $37afbd444df360a1$var$_today.getFullYear(),
    currentMonth: $37afbd444df360a1$var$_today.getMonth(),
    currentDay: $37afbd444df360a1$var$_today.getDate(),
    currentMinutes: $37afbd444df360a1$var$_today.getHours() * 60 + $37afbd444df360a1$var$_today.getMinutes(),
    selectedEvent: null,
    showNewBooking: false,
    showEventDetail: false,
    // (Removed 2026-06-01: `confirmAction` migrated to @symbo.ls/windows
    // `confirmDialog`. Callers now `el.call('confirmDialog', {title, message,
    // confirmText, confirmTheme, icon, onConfirm, onCancel})` instead of
    // writing a state field. No state declaration needed.)
    selectedPerson: null,
    profileEmail: null,
    profileModalTab: 'profile',
    dragPreview: null,
    quickCreate: null,
    hoverTime: null,
    teamMembers: [],
    // AddTeammatesModal (calendar Team view) — `teamMembers`' roster-editing
    // satellites. Declared here, not only in the calendar eager slice, so the
    // workspace-switch wipe can read their reset values from this file's
    // defaults; the slice seeds the same values at boot.
    showAddTeammates: false,
    addTeammateQuery: '',
    addTeammateFeedback: '',
    onlineUsers: [],
    newBooking: {
        title: '',
        date: $37afbd444df360a1$var$todayISO(),
        startTime: '09:00',
        endTime: '10:00',
        invitees: '',
        inviteeQuery: '',
        description: '',
        type: 'meeting',
        meetingMode: 'symbols-meet',
        recurring: 'none',
        recurringDays: [],
        editingEventId: null
    },
    events: [],
    // ── Reminders ──
    // Personal and workspace-shared reminders (records plane, collection:
    // 'reminders') — see functions/reminders.js. `remindersScope` selects the
    // visible plane (Private is the safe default); filter/draft keys stay UI-only
    // and intentionally remain outside WORKSPACE_SCOPED_KEYS below.
    reminders: [],
    // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — same `[]`-seed problem as `people`:
    // the Home Reminders widget rendered "0 due today" before its own fetch had
    // ever resolved. Written by both producers — Home's inline records-plane
    // fetch (pages/main.js) and the /reminders page fetch (pages/reminders.js).
    // Distinct from `_remindersLoadError` below, which is the records-plane
    // CAPABILITY gate (403) and carries its own "not enabled" copy.
    remindersLoaded: false,
    remindersError: null,
    remindersScope: 'private',
    _remindersFilter: 'all',
    _reminderDraft: '',
    _reminderDraftDue: null,
    _reminderDraftShared: false,
    // Set by the /reminders fetch's onFetchError when the records-plane
    // capability gate 403s (forbidden_collection_not_granted) — drives the
    // "Reminders isn't enabled for this workspace" empty-state copy instead
    // of a broken page (reminderEmptyText, functions/reminders.js).
    _remindersLoadError: false,
    // ── History ──
    // Built-in History app (/history): the workspace activity log as a
    // timeline. The rows are the audit log of ONE workspace — tenant data, in
    // the workspace scope cascade below with their load marker, their error
    // key, the person filter (an email off this workspace's roster) and the
    // open-card map (keyed by day + email). The type filter is a vocabulary
    // the source defines, byte-identical in every workspace, and stays
    // unscoped (state.js) like `remindersScope`.
    historyEvents: [],
    historyLoaded: false,
    historyLoadError: false,
    historyPerson: null,
    historyType: null,
    _historyExpanded: {},
    // ── Getting started → Team ──
    // POB S9 (/getting-started/team, functions/gettingStartedTeam.js): the
    // people the onboarding research read off the company's own team page,
    // the owner's typed invites to them and the company-domain join switch.
    // All of it is ONE workspace's data, in the workspace scope cascade below;
    // the switch tail re-reads it while the page is on screen.
    // The read: idle | loading | ready | soon (no server yet) | denied | error.
    gettingStartedTeamStatus: 'idle',
    gettingStartedPeople: [],
    gettingStartedDomain: '',
    // { [personId]: { email, on, status, error } } — what the OWNER typed;
    // never prefilled. Every write carries all four fields (a write REPLACES
    // the object a key holds — smbls 3.14.870 store — so a left-out field
    // would be lost).
    gettingStartedInvites: {},
    // "Invite someone else by e-mail" — a person the research did not find.
    gettingStartedOther: {
        email: '',
        status: '',
        error: ''
    },
    gettingStartedSending: false,
    gettingStartedSendResult: null,
    // { domain, enabled, eligible } from the server; null = no switch.
    gettingStartedDomainJoin: null,
    gettingStartedDomainJoinStatus: '',
    _gettingStartedWhyOpen: false,
    // ── Getting started → Imports ──
    // POB S10 (/getting-started/imports, functions/gettingStartedImports.js):
    // the files and pages the onboarding research found on the company's own
    // site, the owner's own upload, the open preview and its column → field
    // mapping, the run. ONE workspace's data, in the workspace scope cascade
    // below; the switch tail re-reads it while the page is on screen.
    // The read: idle | loading | ready | soon (no server yet) | denied | error.
    gettingStartedImportStatus: 'idle',
    gettingStartedSources: [],
    // The installed apps' collections an import may fill (the server's list).
    gettingStartedTargets: [],
    // The open review — { previewId, name, total, columns }, what the preview
    // holds — or null on the list.
    gettingStartedReview: null,
    // The owner's choice for it — { targetKey, mapping } — its own key, so a
    // pick never replaces the review the column list renders from. `mapping`
    // holds EVERY column ('' = skip), so a write never leaves a stale column
    // behind.
    gettingStartedMapping: null,
    // The last refusal: unsupported_file | too_large | no_table_found |
    // unavailable | failed, or ''.
    gettingStartedImportError: '',
    gettingStartedUploading: false,
    // { importId, status: starting|running|done|failed|pending, created,
    // skipped, failed, undo: ''|undoing|done|failed } or null.
    gettingStartedRun: null,
    // ── Tickets ──
    columns: [],
    tickets: [],
    loadedByColumn: {},
    totalByColumn: {},
    // The /tickets sidebar TYPE counts (PR #283) — written beside totalByColumn
    // by tickets/pages/board.js; see fetchTypeCounts (tickets ticketLoaders.js).
    totalByType: {},
    // PR #287's raw per-type x per-column counts behind totalByType
    // (fetchTypeCounts writes them; the Task Settings modal and the kanban
    // re-sum them without a refetch when a column is hidden or excluded).
    // null = not loaded yet: every reader guards `if (raw)`.
    _rawTypeCounts: null,
    // The board's status beside its counts: true while the /tickets board page
    // is mounted (tickets/pages/board.js onCreate / onRemove). The registered
    // counts refresh (el.call('refreshTicketsCounts')) reads nothing while it is
    // false — PR #287 kept a FUNCTION on root for this instead.
    _ticketsBoardLive: false,
    loadingColumn: {},
    myTickets: [],
    // ── Home dashboard load state (FALSE-ZERO-HOME-NON-AGENT-KEYS-1) ──
    // All five were created by FIRST WRITE and lived in no state tier, so the
    // partition could not see them. Declared here in the same commit that
    // drains them from __tests__/fixtures/rootWriteUndeclared.js.
    //
    // `_userTickets` is Home's OWN ticket cache, written by _ensureHomeTickets
    // (pages/main.js). It exists because `tickets` above is the /tickets BOARD
    // cache and has no Home producer at all: the agent status caption read
    // `Array.isArray(root.tickets) ? length : 0`, a permanent 0 on every cold
    // Home load, which rendered an agent as confidently idle while the user had
    // open work. `_userTickets` is seeded `null` ("not read yet", like
    // `_agents`) and becomes an array — possibly `[]` — only when a fetch
    // resolves; `_homeTicketsLoaded` is the producer's one-shot REQUEST gate
    // (set before the fetch, so it can never be the load marker);
    // `_homeTicketsError` records the failure the loader previously only
    // console.warn'd.
    _userTickets: null,
    _homeTicketsLoaded: false,
    _homeTicketsError: null,
    // Workspace presence for the Home analytics widget + the Watcher agent
    // caption — a DEDICATED key, never the Projects-scoped `_analytics`
    // (PRESENCE-ZERO-1). `null` is "not read yet"; a loaded payload's own
    // metrics may each be `null` when the server omitted the field, which is
    // what stops an ABSENT field from becoming a well-formed 0 at the data
    // layer the way `Number(res.usersNow) || 0` did.
    _homeWorkspaceActivity: null,
    _homeWorkspaceActivityError: null,
    recentTickets: [],
    // /tickets/feed's activity cache (tickets/pages/feed.js, FeedMain.js).
    // null (not []) is the page's own "not fetched this session yet" sentinel
    // — FeedMain reads `s.root.feedItems == null` to show the loading state
    // instead of an empty-state flash. Previously undeclared (relied on smbls
    // 3.14's create-signal-on-first-write); declared here so it has a real
    // schema-empty default and WORKSPACE_SCOPED_KEYS below can single-source
    // its workspace-switch reset value instead of hand-typing it separately.
    feedItems: null,
    myViewQueueOpen: false,
    _activityData: {},
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20): the heatmap's DRILL-DOWN pair, declared
    // here for the first time. Both were created by FIRST WRITE
    // (tickets/components/ActivityHeatmap.js) and lived in NO defaults tier, so
    // they sat in the root-write census baseline instead of the partition's
    // universe — the closed-world check could not fail on either. Declaring them
    // is what lets them be scoped at all.
    // ⛔ BOTH DEFAULT TO null, NOT {} / []. `_activitySelectedDate` is what the
    // details panel's `hide:` reads, so a truthy empty would reopen an empty
    // panel over the new tenant; `_activityDetails` distinguishes "still
    // loading" (null) from "loaded, no events" ([]) in the very next `hide:`
    // line, and a `[]` default would make the skeleton never show.
    _activitySelectedDate: null,
    _activityDetails: null,
    _dailyDraft: '',
    _dailyUpdates: [],
    // WS-SWITCH-INCOMPLETE-1 step 3 (standup domain) — which history cards are
    // expanded, as ONE map keyed by row id. This used to be an UNBOUNDED family
    // of root keys (`_standupOpen_<created_at|date>`, written by
    // `root.update({ [key]: !root[key] })` in StandupsMain.js). A key whose NAME
    // is computed at runtime can never appear in a static registry, so neither
    // the wipe nor the root-write census could ever see it — it was residue that
    // survived every switch by construction. One declared map fixes both: the
    // wipe reaches it and the census counts it. Same move as `_ticketComments`'
    // slot tag in step 4 — a fact about ROOT state has to live on root.
    _standupOpenIds: {},
    _standupUserName: '',
    _standupPhase: 'idle',
    _standupSummary: '',
    _standupActions: [],
    _standupFollowUps: [],
    // Local date the standup gate was last evaluated against — lets the
    // rollover interval in TicketsDailyUpdate.onCreate detect day-changes
    // on tabs left open overnight without firing a network call every tick.
    //
    // ⭐ WS-SWITCH-INCOMPLETE-1 — SCOPING THIS KEY CHANGED ITS GATE, IN THE SAME
    // DIFF. The stamp used to mean "a day was checked"; the interval fired on
    // `stamp && stamp !== today`, so an EMPTY stamp meant "never poll". A wipe
    // sets it empty — scoping it alone would have disarmed the only poller the
    // standup plane has, permanently, for the rest of the session. The gate is
    // now `stamp !== today`, and the stamp means "this plane was derived for the
    // ACTIVE workspace, today". So the wipe un-stamps it and the SAME interval
    // re-derives the plane for the new workspace on its next tick — the switch's
    // PHASE-2 refetch for this domain, with no second mechanism. This is the
    // mirror of the tenant-guard rule found in the approval domain: a wipe can
    // orphan the handler that a key's own correctness depended on, so the wipe
    // and the handler must ship together.
    _standupCheckedDate: '',
    _ticketComments: [],
    // The open comment editor is part of that ticket thread, including its
    // unsaved content. Clear both halves when the workspace changes.
    _editingCommentId: null,
    _commentEditDraft: '',
    // TicketDetailModal's mail reply belongs to the current ticket/workspace.
    _mailReplySending: false,
    // WS-SWITCH-INCOMPLETE-1 step 4 — which ticket's comments occupy the SINGLE
    // shared `_ticketComments` slot. This used to be `el._lastCommentsTicketId`,
    // an ELEMENT-LOCAL memo of a ROOT-LEVEL fact, and that mismatch is what made
    // `_ticketComments` unsafe to wipe: a workspace switch empties the slot but
    // cannot reach an element property, so the memo kept naming the OLD tenant's
    // ticket and the guard skipped the refetch that would have refilled it.
    // Living here, it is wiped by the same registry entry as the slot it
    // describes — the memo is tenant-correct by construction, not by a teardown
    // call somebody has to remember to add.
    _ticketCommentsFor: null,
    // Comment paging for that slot: server rows fetched so far (the next older
    // page's offset), whether the server has older rows, and the in-flight flag
    // for "Load more comments". They describe the slot, so they wipe with it.
    _ticketCommentsSkip: 0,
    _ticketCommentsHasMore: false,
    _ticketCommentsLoadingOlder: false,
    // The first page of the slot is in flight — the thread shows a comment-shaped
    // skeleton instead of an empty list until it lands.
    _ticketCommentsLoading: false,
    _mentionModal: {
        open: false
    },
    // TicketDetailModal transient UI state — declared so initial reads
    // (before any write) get a defined value instead of `undefined`,
    // which simplifies the binding factories that compare against
    // primitives (`s.root._approvalPending ? 'not-allowed' : 'pointer'`).
    // smbls 3.14 creates signals for undeclared keys on first write, so
    // this isn't a typed-bag whitelist — just sensible defaults.
    _aiTicketLoading: false,
    // Renders TicketDetailModal as a dedicated full-bleed page instead of an
    // overlay when true. Toggled by the /ticket/:id page on mount; the
    // existing modal styles react to flip backdrop + Window sizing.
    _ticketFullPage: false,
    // WS-SHELL-MOUNT-TREE-BUILD-2700MS-1 — the ModalRoot `if:` latch. False at
    // boot so the 246-element modal host is NOT built inside the boot task;
    // bootShell flips it once, on its bounded post-mount `yieldToPaint`.
    // One-way and app-lifetime: deliberately NOT in any workspace-scoped wipe
    // tier — re-arming it would destroy the live dialog host on a tenant switch.
    _modalHostReady: false,
    // WS-SHELL-BOOT-TASK-LOAF-ACCEPTANCE-1 — the staged-mount ladder counter
    // (functions/shellStages.js). 0 at boot so every off-screen top-level
    // subtree evaluates its `if:` false and is NOT built inside the mount task;
    // the shell root's onCreate then walks it 1 → 2 → 3, one macrotask apart,
    // so the shell's one long build becomes several bounded ones. Monotonic and
    // one-way, same tier as `_modalHostReady` above: re-arming it on a tenant
    // switch would evaluate a built subtree's latch false and destroy it.
    _shellStage: 0,
    // The ticket detail modal's module has been loaded and folded into the
    // registry (functions/ticketDetailModalLoad.js). Gates the TicketsDetailModal
    // `if:` latch with the need; one-way and app-lifetime like the two above -
    // the folded registry survives tenant switches, and a wipe would only make a
    // built modal's latch read false.
    _ticketModalReady: false,
    _approvalPending: false,
    _approvalError: null,
    _approvalNote: '',
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20): the post-decision pill's pair. Both
    // were UNDECLARED — written at root by the approve/reject success paths and
    // by nothing else, so smbls 3.14 minted their signals on first write and no
    // tier ever named them. They have no reset of any kind, which is why a
    // decision made once suppressed the Approve button everywhere afterwards.
    // ⛔ `null`, never `''`: ApprovedPill's own gate is `_approvalDoneAt &&
    // !_isEditing`, and `new Date('')` is Invalid Date — an '' would still be
    // falsy at the gate but would print `APPROVED · Invalid Date` the moment any
    // future read stops gating on presence first.
    _approvalDoneAt: null,
    _approvalKind: null,
    _assigneeQuery: '',
    // The assignee field has focus: opens its suggestion list before the first
    // keystroke (tickets/components/TicketDetailModal.js). Declared, because a
    // root key created by its first write is not reactive for an effect that read
    // it before the write, and the root-write census refuses it.
    _assigneeFocused: false,
    // The option the arrow keys stand on in a ticket people list:
    // `{ kind: 'reporter' | 'assignee', index }`, or null for none. One key for
    // both fields, tagged with its field, so the two lists never light each
    // other's rows. Declared for the same reason as the flag above.
    _peopleFieldActive: null,
    // null = idle (show the current reporter's name); a string = the user is
    // actively typing a query. The reporter value factory (`if (q != null)`) and
    // the edit-sync guard (`_reporterQuery == null`) both treat null as idle, so
    // this MUST default to null, not '' — an '' default counts as "typing" and
    // left the reporter input blank on first edit of a freshly opened ticket (#111).
    _reporterQuery: null,
    _commentTab: 'comment',
    _ticketDeps: {},
    // WS-SWITCH-INCOMPLETE-1 step 5 — the "Add dependency" picker's candidate
    // pool and its two in-flight flags. All three were created by FIRST WRITE
    // (`root.update({ _depPool: docs })` in TicketDetailModal.js's _loadDepPool)
    // and declared in NO state-defaults tier, so they were outside
    // scopes.partition.test.js's UNIVERSE and the closed-world check could not
    // see them at all. Declaring them is what makes them classifiable.
    //
    // ⛔ `_depPool` DEFAULTS TO null, NOT []. `_freshEmpty` (scopes.js) restores
    // the DECLARED default, and the picker refills only when
    // `!s.root._depPool && !s.root._depPoolError` — a truthiness test. A `[]`
    // default would wipe to `[]`, which is TRUTHY, so the guard would never fire
    // again and the picker would show zero matches for the rest of the session.
    // The empty of a value a GUARD consumes must be falsy; step 3's
    // `_wsInviteRole` is the same lesson read the other way round.
    _depPool: null,
    _depPoolLoading: false,
    _depPoolError: null,
    filterAssignee: null,
    // The /tasks board's ?project=<id> scope (tickets/pages/board.js
    // boardUrlScope). Workspace-scoped — see WORKSPACE_SCOPED_KEYS below.
    filterProjectId: null,
    filterLabel: null,
    searchQuery: '',
    // ── Requests ──
    // Empty so empty-state UX + SDK fetch wiring own what users see;
    // any fixture seed would ship to every signed-in user.
    customerRequests: [],
    inboundRequests: [],
    outboundRequests: [],
    auditReports: [],
    // ── Resolutions ──
    // Same reasoning as the request arrays above.
    improvementRequests: [],
    editRequests: [],
    selectedTicket: null,
    ticketDraft: null,
    ticketEditMode: false,
    activeDrag: null,
    dropPreview: null,
    syncing: false,
    // ── Chat ──
    // One-shot latch: flips true when ensureChatContext folds the full chat
    // context (components + functions) into the live registry. Gates the
    // MessengerOverlay's `if:` mount (app.js) so the ~215KB chat UI tree is
    // neither bundled eagerly nor built pre-fold. Deliberately NOT in the
    // workspace-scoped wipe registry — the folded registry survives tenant
    // switches, so the latch must too.
    _chatCtxFolded: false,
    // Latched once the documents context folds (the /files note editor folds it
    // outside any /documents route). Deliberately NOT workspace-scoped: the
    // component registry keeps folded definitions across tenant switches.
    _documentsCtxFolded: false,
    // Meet-side twin of the latch above: flips true when ensureMeetContext
    // (functions/meetFold.js) folds the deferred meet context in for a surface
    // that needs a meet component key OFF a meet route — today chat's
    // channel-header group call, whose modal body extends MeetVideoRoom. Same
    // survives-tenant-switch reasoning, so it is likewise NOT wipe-registered.
    _meetCtxFolded: false,
    // Mail-side twin of the chat latch: flips true when ensureMailContext
    // (functions/mailFold.js) folds the deferred mail context in and fills the
    // MailOverlaySlot — the header envelope opens the docked MailOverlay from
    // ANY route, long before /mail ever mounts. Same survives-tenant-switch
    // reasoning, so it is likewise NOT wipe-registered.
    _mailCtxFolded: false,
    // Set before navigating to /chat to auto-open a DM with the given email.
    // Consumed and cleared by chat's onCreate once channels are loaded.
    _pendingDmEmail: null,
    channels: [],
    channelMembers: [],
    activeChannelId: null,
    showNewChannel: false,
    newChannelDraft: {
        name: '',
        topic: '',
        kind: 'channel',
        is_private: false,
        members: []
    },
    messagesByChannel: {},
    activeThreadRootId: null,
    presence: {},
    typingByChannel: {},
    myMentions: [],
    collapsedGroups: {},
    searchOpen: false,
    searchResults: [],
    mentionPicker: null,
    sidebarDropdown: {
        open: false
    },
    contextDropdown: null,
    _hiddenChannels: [],
    _pinnedChannels: [],
    renameModal: {
        open: false
    },
    pendingAttachments: {},
    composerPreview: false,
    composerReplyTo: {},
    // Edit-in-place state for chat messages. When set, the Composer switches
    // to edit mode, pre-fills with _editingMsgBody, and submits via
    // saveEditMessage (functions/chat/messageActions.js).
    _editingMsgId: null,
    _editingMsgBody: '',
    // The message list's "New messages" / "Jump to latest" pill
    // (chat/components/MessageList.js JumpLatest): when the reader left the
    // newest row, the channel they left it in, and each channel's unread span
    // captured on open (functions/markRead.js — a map keyed by channel id).
    _chatAwaySince: null,
    _chatAwayCid: null,
    _chatNewFrom: {},
    // The composer whose emoji picker is open (its __composerId,
    // chat/components/Composer.js), and whether the thread reply field holds
    // text (chat/components/ThreadPanel.js — its send button).
    _composerEmoji: null,
    _threadHasText: false,
    // Who is typing where (CHAT-TYPING-1, chat/functions/chatTyping.js):
    // { [channelId]: { [email]: { email, userId, thread, until } } }, filled
    // by the chat stream's `chat.typing` frames. NOT `chatTyping` — that key is
    // the AI assistant's "working" flag (its composer spinner reads it).
    _chatTypists: {},
    chatVisibleCounts: null,
    activeTab: 'conversation',
    showFilterBar: false,
    filters: {
        authorEmail: null,
        hasAttachments: false,
        hasMentions: false,
        query: ''
    },
    // Messenger drawer legacy slice (shared/components/Messenger.js) — a
    // separate mini chat surface from the /chat page above, same tenant
    // boundary. Previously undeclared (relied on smbls 3.14's create-signal-
    // on-first-write, which meant Messenger's `s.root.update({...})` writes
    // to these were at risk of being silently dropped by the typed-bag guard
    // until first touched); declared here for a real schema-empty default +
    // single-sourced workspace-switch reset value (WORKSPACE_SCOPED_KEYS below).
    _chatDrawerChannels: null,
    _chatDrawerChannelId: null,
    _chatDrawerMessages: null,
    // ── Documents ──
    activeSection: 'notes',
    selectedFolder: 'all',
    selectedDocument: null,
    docsQuery: '',
    documents: [],
    // First-load gate for the documents Count UI — see DocsMain.Count
    // factory. Avoids the "0 documents" flash before the fetch resolves
    // (WORKSPACE-DOCS-COUNT-RESET).
    _documentsLoaded: false,
    selectedNoteId: null,
    notesFilter: 'all',
    notes: [],
    editorDoc: null,
    editorMode: null,
    _docSaving: false,
    // The reader's own reading settings for a note — { size, leading, measure }
    // or null when never chosen (documents functions/notesReader.js). Hydrated
    // per person from user_preferences, this device's copy painting first.
    notesReader: null,
    // A note card drag in flight (DocsCard) and the sidebar row it hovers: a
    // folder row takes the note into that folder, Shared / Private set its
    // privacy (documents components/DocsSidebarExport.js), a chat row
    // (`chat:<id>`) shares the note there (chat functions/chatNoteDrop.js).
    _notesDragId: null,
    _notesDropKey: null,
    // The share-to-chat picker (documents functions/noteShare.js): the note it
    // shares ({ id, kind, title, privacy } or null when closed), its search,
    // and the conversation a send is in flight to (null when none).
    _noteShareTarget: null,
    _noteShareQuery: '',
    _noteShareBusy: null,
    // The note a reference opened beside the open one in the reading view —
    // { kind, id, from } or null when that split is closed (documents
    // functions/notesRefs.js). Session only.
    _notesRef: null,
    kbQuery: '',
    selectedCategory: 'all',
    kbArticles: [],
    // ── Files ──
    // The @symbo-ls/workspace-files context is deferred out of the eager
    // sharedLibraries merge (its ~105K of components + functions load only on
    // /files via lazySharedLibPage), so its state.js no longer seeds on every
    // route. pageContext.js reads root.fileNodes on BOTH /files AND /infra, so the
    // desktop's persisted state stays eager here — mirroring how documents' state
    // lives in this file. The lazySharedLibPage merge re-seeds files/state.js on
    // /files with add-missing semantics, so these declarations win (no double-seed).
    fileNodes: [],
    fileDocs: [],
    filesOpenFolder: null,
    _fileNodePos: {},
    _fileNodesLoaded: false,
    // The failed fileCanvas fetch's message (files/functions/fetchConfigs.js,
    // or the 'files.empty.error' key), null otherwise: FilesMain's empty state
    // reads it. Workspace-scoped (WORKSPACE_SCOPED_KEYS below).
    _fileNodesError: null,
    _filesUploading: [],
    // ── Meet ──
    rooms: [],
    activeRoomId: null,
    meetView: 'list',
    liveParticipants: {},
    waitingRoom: {},
    livekitParticipants: [],
    livekitSpeakers: {},
    livekitConnected: false,
    meetCallInFlight: false,
    meetCallError: null,
    // WS-SWITCH-INCOMPLETE-1 step 3, bucket A2 (2026-08-21): the error's two
    // satellites. Both were UNDECLARED — connectCall writes `err.name` /
    // `err.code` beside `err.message` (MEET-ERROR-COPY-LIES-1) and nothing
    // else names them, so smbls minted their signals on first write and the
    // partition one tier up could not see them. Declared `null`, like the
    // message they travel with; registered scoped beside it below.
    meetCallErrorName: null,
    meetCallErrorCode: null,
    // WS-SWITCH-INCOMPLETE-1 leg 14 (2026-08-21): the error record GREW from a
    // triple to a QUINTUPLE after step 3 shipped. `livekitErrorFields` now also
    // carries `reasonName` and the HTTP `status` (the 429 quota rejection
    // arrives as `err.context.status`), connectCall co-writes both in its
    // pre-flight reset AND its catch, and VideoRoom reads them straight into
    // the overlay's copy. Both were UNDECLARED — the census named them by
    // hand. Declared `null`, like the three they travel with; registered
    // scoped beside them below so the LOCKSTEP is whole again.
    meetCallErrorReason: null,
    meetCallErrorStatus: null,
    // (Removed 2026-06-01: `showNewRoom` migrated to @symbo.ls/windows
    // openNewRoomModal layer. `newRoomDraft` below retained as the data
    // carrier the body component still reads via _draft(s).)
    showRoomSettings: false,
    showLiveCaptions: true,
    shareLinkCopied: false,
    newRoomDraft: {
        name: '',
        kind: 'room',
        transcribeEnabled: true,
        isPrivate: false
    },
    utterances: [],
    analysis: null,
    // The transcript view's "its rows answered" flag (meet TranscriptPage's
    // fetch transform sets it; a room switch clears it — meet pages/index.js
    // _planHashReseed, meet functions/meetAnswer.js meetAnswerOpen).
    transcriptLoaded: false,
    analyzing: false,
    analyzeError: null,
    transcriptPending: false,
    _meetAnalyzeInFlight: false,
    meetChatMessages: [],
    meetChatUnread: 0,
    showMeetChat: false,
    // FLY IN A CALL (meet functions/meetFly.js, the reads in meetFlyState.js):
    // the call's Fly state — { v: 2, roomId, mode (the room's switch: null or
    // { on, by, at }), open (this person's theater over the call), focus,
    // hidden, pages: [{ key, roomId, agent, by, mine, prompt, at, page }] };
    // `_meetMention` the `@…` being typed in the call chat (the agent
    // suggestions). Both this call's — workspace-scoped below.
    meetFly: null,
    _meetMention: null,
    // THE PERSON CALLED RINGS (functions/incomingCall.js): { roomId, callerId,
    // at } while a fresh private room this person is a MEMBER of rings, else
    // null — read by components/IncomingCallBanner.js. Workspace-scoped below.
    _callRing: null,
    // WHAT CHANGED DURING THE CALL (meet functions/meetCallChanges.js): { roomId,
    // since, at, groups: [{ key, label, appKey, route, added, updated }] } — the
    // workspace's timeline since the call began, by app; read by the call's live
    // summary and its end screen. Workspace-scoped below.
    _callChanges: null,
    // Toggles MeetTranscriptPanel — the in-call full-transcript side
    // drawer. Distinct from `showLiveCaptions` which controls the small
    // 3-line caption OVERLAY at the bottom of VideoRoom.
    showMeetTranscript: false,
    // WS-ROOTWRITE-CENSUS-CHAT-ROOM-KEYS-UNDECLARED-1 (2026-10-18): the rooms
    // sidebar's ARCHIVE FAMILY. All four were UNDECLARED — the sidebar's Edit
    // and Archived controls (meet components/Sidebar.js, RoomList.js), the
    // archive stub (meet functions/archiveRooms.js) and the /meet page seed
    // (meet pages/index.js) write them at root, so smbls minted their signals on
    // first write; the root-write census named them once 11a38e3a3 rewrote the
    // sidebar. Declared with the values every reader already falls back to
    // (`|| []`, falsy). `isEditingRooms` / `selectedRooms` / `viewingArchived`
    // are registered scoped below; `archivedRoomsIds` unscoped, in state.js.
    archivedRoomsIds: [],
    isEditingRooms: false,
    selectedRooms: [],
    viewingArchived: false,
    // ── Lightbox ──
    lightbox: null,
    // ── AI Assistant ──
    assistantOpen: false,
    assistantMessages: [],
    assistantTyping: false,
    // aiChat thread picker (AppAssistantThreadPicker.js + functions/
    // aiAssistantThreads.js). Threads are WORKSPACE-scoped (2026-07-14 per
    // Nika) — wiped + refetched on workspace switch in loadPrivateData's
    // onWorkspaceChange, same convention as the chat isolation switch.
    _aiThreads: [],
    _aiThreadId: null,
    _aiThreadsLoading: false,
    _aiThreadsLoadAttempted: false,
    _aiThreadMenuOpen: false,
    // ASK-USER decision cards — ticket rows requiring Nika's approval/rejection/clarification.
    // Populated by fetchAskUserDecisions on AppAssistant init + kept live via
    // subscribeAskUserDecisions realtime. Cleared per-ticket when the user responds.
    askUserDecisions: [],
    // Set of ticket ids already dismissed this session so resolved cards don't reappear.
    _dismissedDecisionIds: [],
    // Clarify/reject inline form state.
    _decisionClarifyId: null,
    _decisionClarifyText: '',
    _decisionClarifyIntent: null,
    // ── Shell PageSlot (unified 2026-07-10) ──
    // `_canvasSlot` is the single route the shell PageSlot opens IN-PLACE — set
    // from any surface (home widgets, /studio marketplace, /infra, the /tickets
    // rail, global search) to mount that route's page via `el.set(pageDef)`. On
    // home the URL stays '/' with a ?page=<route> restore param. Full route path
    // (e.g. '/chat', '/tickets-page'); resolution lives in
    // canvas/components/PageSlot.js (_defFor → root._slotResolve → context.pages).
    // Cleared on close. Replaced the bespoke home AppWindow's `selectedPage` — the
    // two slot systems were folded into this one.
    _canvasSlot: null,
    // Cross-page hand-off for the Infra canvas — `{ domainFlow }` parked by
    // shared/functions/openProjectDomainFlow.js (Dropdown.Envs' "Custom domain"
    // row), lifted into root.infra.domainFlow and cleared by infraInit on the
    // next /infra mount. Declared so the partition (scopes.partition.test.js)
    // knows the key; classified UNSCOPED with the other transient overlay flags.
    _infraIntent: null,
    // Second PageSlot pane (side-by-side split view — cmd/ctrl+click opens here).
    _canvasSlotSecond: null,
    // The opt-in pane pin — '_canvasSlot' | '_canvasSlotSecond' | null (Nika
    // 2026-10-10: "Yes, opt-in pin"). The pane a user ("Keep this pane open" in
    // the pane header) or a module (openAppPage(route, { pin: true })) keeps: a
    // navbar/launcher open lands BESIDE it (functions/searchApps.js). Session
    // only — never persisted, never in the URL; in WORKSPACE_SCOPED_KEYS below.
    _slotPinned: null,
    // Minimize-to-dock (2026-08-06 per Nika "we should support minimize feature
    // for apps, to continue exactly where it left off"): ordered (oldest →
    // newest) parked-app entries { href, title, icon, wsId, minimizedAt }, cap
    // 5. The PARKED SURFACES themselves are keep-alive host elements inside the
    // PageSlot (canvas/components/PageSlot.js `SlotKeep_*`) — display-gated,
    // never unmounted while listed here, so restoring reveals the exact same
    // element. This list is what the MinimizedDock chips render, persisted
    // per-workspace to sessionStorage (shared/functions/minimizedSlots.js) so a
    // reload offers the same apps as COLD restores. In WORKSPACE_SCOPED_KEYS
    // below — a tenant boundary wipes the list, and the PageSlot host sweep
    // (wsId-stamped) unmounts the kept-alive DOM with it.
    _minimizedSlots: [],
    // PageSlot close-finish re-render nudge (see canvas/components/PageSlot.js +
    // the el.update({}) ticket in tickets/smbls.md).
    _slotNudge: 0,
    // Edge-to-edge toggle for the shell PageSlot (the Header's FullscreenBtn).
    _slotFullscreen: null,
    // Per-pane PageSlot back/forward history — { stack: [href, …], index }
    // (2026-08-06 per Nika "when we navigate accross pageslots - we shuld also
    // support back and forward navigations in pageslots"). The pure model lives
    // in canvas/functions/slotHistory.js; the pane Slot's lifecycle records
    // every slot path change (canvas/components/PageSlot.js _recordSlotHist),
    // and the pane header's arrows consume. Pane-scoped by design: the primary
    // (`_canvasSlot`) and the split second (`_canvasSlotSecond`) never share a
    // stack, so back/forward in one pane cannot move the other. In
    // WORKSPACE_SCOPED_KEYS below — a history names tenant routes.
    _slotHistPrimary: null,
    _slotHistSecond: null,
    // Per-pane PageSlot apps rail (the header's sidebar toggle — in-sheet quick
    // access to every slot-hostable app, fed by the same searchAppGroupsFor
    // source the launcher uses). Reset on pane close by PageSlot's close paths.
    _slotRailPrimary: false,
    _slotRailSecond: false,
    // Transient AI answer views (render_answer_ui): '/answer/<slug>-<seq>' →
    // page def, written by canvas/functions/answerUi.js and resolved as the
    // FIRST PageSlot tier. Session-only — never persisted, never in the router.
    _aiAnswerPages: null,
    // ── The assistant's generated board (DESIGN-WL-ASSISTANT-MAIN-VIEW-1,
    // functions/assistantBoard.js). `_aiBoard` is the board on screen in Page
    // mode — a view model: status, the validated spec and its cards, the pins,
    // the previous board kept under a failure. `_aiBoardHistory` the recent
    // boards behind the thread chips (max 5); `_aiBoards` the saved boards
    // (`ai.boards.list`) the boards row shows. `_aiBoardPreview` the UI mode
    // that shows the view without the Page-mode/home gate (the fixture board
    // until `ai.boards.generate` exists). All four in WORKSPACE_SCOPED_KEYS
    // below.
    _aiBoard: null,
    _aiBoardHistory: [],
    _aiBoards: [],
    _aiBoardPreview: false,
    // The board opened EXPLICITLY — by a `?board=<id>` link or a board tab
    // (assistantBoardSelect): it shows on the home whatever the placement and
    // the mode, until Esc / Back to home / Dismiss (assistantBoardDismiss).
    // Session-only; workspace-scoped (it names workspace A's board).
    _aiBoardExplicit: null,
    // ── The assistant's LIVE DECK (Presentation mode, AI_ASSISTANT_SPEC §12.1;
    // functions/assistantDeck.js). `_aiDeck` is the deck on screen — a view model
    // like `_aiBoard`: status, the DeckSpec as it streams, its slides (each
    // content slide's items derived by the board's own validation), the slide on
    // the stage (`index`), the save state, the route it was made on.
    // `_aiDeckPreview` the UI mode that shows the contract's fixture deck (before
    // the server's deck path answers); `_aiDeckPreviewIndex` that preview's slide.
    // All three in WORKSPACE_SCOPED_KEYS below.
    _aiDeck: null,
    _aiDeckPreview: false,
    _aiDeckPreviewIndex: 0,
    // ── FLY MODE (docs/FLY_MODE.md; functions/assistantFly.js). `_aiFly` is the
    // session of composed pages: { v, workspaceId, threadId, open, path, focus,
    // pages }. Workspace-scoped (its pages are built from A's apps and read A's
    // rows): in WORKSPACE_SCOPED_KEYS below.
    _aiFly: null,
    // Local Fly navigation and picker state belong to the active workspace.
    _aiFlyWorkspace: null,
    // The Fly rail put away (true) or shown (false); null = this device's last
    // choice (functions/assistantFly.js assistantFlyRailHidden). A person's UI
    // choice, the same in every workspace: in WORKSPACE_UNSCOPED_KEYS (state.js).
    _aiFlyRailHidden: null,
    // Phone navigation is local to the active workspace. The viewport flag is
    // device state; page/menu/composer state must never cross workspaces.
    _isPhoneViewport: null,
    _phoneNavPanel: null,
    _phoneNavError: null,
    _phoneNavOperation: null,
    _phoneComposerOpen: false,
    // The shell's own route history for the phone Back on a full-page app route
    // (functions/phoneNavigation.js phoneNavigationBack): the panes' shape,
    // { stack, index } (canvas/functions/slotHistory.js). A workspace's own
    // trail: a switch wipes it.
    _phoneNavHist: null,
    _filesRailOpen: false,
    _canvasRailOpen: false,
    // The module rail as a phone drawer (app.js ModuleRailHost): opened from
    // the dock's Page button on module routes without a rail of their own.
    _moduleRailOpen: false,
    // What THIS shell renders, as its first read found it
    // (functions/assistantRecords.js assistantClientCapabilities):
    // `{ records: 1 | 0 }` — the records renderer AND the SDK's
    // `ai.boards.records`. The board request and every chat turn declare it to
    // the server's capability gate. null until that read answers. A fact about
    // this page's SDK, not about a workspace.
    _aiClientCaps: null,
    // The assistant's RECORDS BLOCK answers (AI_ASSISTANT_SPEC v1 §2–§3,
    // functions/assistantRecords.js): `ai.boards.records` rows per
    // workspace + block ({ status, answer }), read once and shared by the
    // board cards and the thread's inline blocks — the 40 newest. `_aiBlockSaves`
    // the Save-as-board state of an inline block (saving | saved | failed).
    // Both hold workspace data: WORKSPACE_SCOPED_KEYS below.
    _aiRecords: {},
    _aiBlockSaves: {},
    // The AI answers' FORM requests (functions/assistantAppForms.js): per
    // request id { status: 'open' | 'saved', saved? } — the app's own form was
    // opened from a proposal, and the app reported the row it saved. Workspace
    // A's records: WORKSPACE_SCOPED_KEYS below.
    _aiForms: {},
    // The app record rows that failed to mount this session, keyed
    // `<moduleId>/<row component>` (functions/assistantRecords.js
    // assistantRecordsRowMount): a marked row falls back to the generic list
    // row. Names workspace A's installed apps: WORKSPACE_SCOPED_KEYS below.
    _aiRecordRowsBroken: {},
    // The minimized island's "Answer ready" marker — the id of the answer the
    // person dismissed (functions/assistantAnswerPopover.js; the island's head,
    // shared _simone/ReasoningPill.js).
    // Workspace-scoped with the thread it names (WORKSPACE_SCOPED_KEYS below).
    _aiAnswerPopoverDismissed: null,
    // The main thread's URL, `?ai=<conversationId>` (functions/
    // assistantThreadUrl.js). `_aiThreadUrlId` is the conversation the address
    // bar and the thread last AGREED on; `_aiThreadLink` marks a link while it
    // loads ({ id, status: 'loading', ws }) and when this person cannot read
    // it ({ id, status: 'unavailable', ws }) — `ws` is the workspace the read
    // ran in. Both name a conversation of ONE workspace: WORKSPACE_SCOPED_KEYS
    // below.
    _aiThreadUrlId: null,
    _aiThreadLink: null,
    // ── The home top (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1) ──
    // `_homeSignals` — HOME_SIGNALS_CONTRACT v1's in-memory cache and pass
    // state for the ACTIVE workspace (functions/homeSignals.js): each provider's
    // last answer, the calls in flight, the providers expected, the first pass
    // window. Workspace-scoped (WORKSPACE_SCOPED_KEYS below). `_homeLook` — this
    // session's own decisions about the look of the home top (App strip style,
    // names, summary style, sky; functions/homeLook.js): a PERSON's choice,
    // unscoped like `themeMode` (state.js WORKSPACE_UNSCOPED_KEYS).
    _homeSignals: null,
    _homeLook: null,
    // The home's context-menu tip is dismissed (its ×, or seen once for a few
    // seconds — functions/homeCtxTip.js, persona audit WH-9). A PERSON's
    // device choice, mirrored from the `smbls_pref__homeCtxTipDismissed` cookie
    // at boot (app.js): unscoped like `_homeLook` (state.js
    // WORKSPACE_UNSCOPED_KEYS).
    _homeCtxTipDismissed: false,
    // The AI source of the Brief (functions/homeSummaryAi.js): the one ask for
    // the settled signals — { key, ws, status, text, chips, generatedAt }.
    // Workspace data (the summary names workspace A's counts):
    // WORKSPACE_SCOPED_KEYS below.
    _homeSummaryAi: null,
    // The home's last Ask and Create mode, for ONE workspace
    // (functions/homeView.js homeViewGroupSelect): { workspaceId, ask, create }.
    // Modes only, no content. WORKSPACE_SCOPED_KEYS below.
    _homeViewRecent: null,
    // The mode a home TAB set, for ONE workspace (functions/homeView.js, BLD-13
    // "Change only the home view"): { workspaceId, mode, barMode }. Never
    // persisted; an explicit pick clears it (setAssistantMode), and off the home
    // homeModeSync gives the person's pick back. WORKSPACE_UNSCOPED_KEYS
    // (state.js): it must outlive a switch to undo itself there.
    _homeMode: null,
    // A module page's "hide the shell composer" latch — { moduleId, pane, route }
    // (functions/moduleShellComposer.js, el.call('setShellComposer', false)).
    // Holds only while that page is live. Names workspace A's module:
    // WORKSPACE_SCOPED_KEYS below.
    _moduleComposerHidden: null,
    // The Fly start screen's "Get started" (functions/assistantFlyFirstRun.js):
    // the server's activation answer for the ACTIVE workspace — { ws, status,
    // at, data, code, wasOpen }. Workspace data: WORKSPACE_SCOPED_KEYS below.
    _flyFirstRun: null,
    // The cost before a build (functions/addAppEstimate.js; server CORE-EST):
    // the estimate of the builder's next turn for ONE place — { key ('ws|thread'),
    // at, full, min, waived, allocationExceeded, canStart, enough }. Numbers,
    // flags and ids only, never the draft. Workspace data (a balance verdict and
    // a waiver of workspace A): WORKSPACE_SCOPED_KEYS below.
    _addAppEstimate: null,
    // The workspace builds itself (functions/workspaceSetup.js, lane WS1): the
    // setup job of the ACTIVE workspace as the builder's first thread shows it —
    // { ws, status, at, job, code, arrived, back, opened, opening, retrying,
    // policy, me, site, build, apps }. Workspace data: WORKSPACE_SCOPED_KEYS below.
    _workspaceSetup: null,
    // A personalized sign-up's build board (functions/onboardingBuild.js, POB
    // S6): the server's board of the ACTIVE workspace — { ws, status, at, board,
    // code, since, timedOut, retrying, note, canRetry }. Workspace data:
    // WORKSPACE_SCOPED_KEYS below.
    _pobBuild: null,
    // ── AI parameters picker ──
    // Open/close gate for the CanvasPromptTextarea ParamsBtn dropdown.
    // `_aiModePickerTick` is bumped on every mode/authMode selection so
    // the dropdown's `children:` factories (which read sdk.ai.getMode /
    // getAuthMode) re-evaluate and the active checkmark moves immediately.
    _aiModePickerOpen: false,
    _aiModePickerTick: 0,
    // Viewport-space anchor for the position:fixed picker. Captured by
    // ParamsBtn.onClick from the button's getBoundingClientRect so the
    // picker can render outside CanvasPromptTextarea's `overflow: hidden`
    // and still align under (above) the button. Shape: { right, bottom }
    // (both in px). Null until the first open.
    _aiModePickerAnchor: null,
    // Becomes true once the shared/functions/aiService singleton has
    // resolved at shell boot (see app.js shellApp.onCreate). Reactive
    // factories that depend on the AI service gate on this so they
    // re-fire when it lands. The service ITSELF lives in the singleton
    // (not state) because smbls' state clone strips the class prototype.
    _aiSvcReady: false,
    // Proposals from sdk.ai.dispatch when intent === 'action' and the
    // user is in authMode='ask'. AiActionConfirmCard reads this; Confirm
    // fires sdk.ai.executeActions(proposals) and writes the results to
    // _aiActionResults, then clears the proposals.
    _aiActionProposals: null,
    _aiActionRunning: false,
    _aiActionError: null,
    _aiActionResults: null,
    // Drawer width (px) driven by the ResizeHandle drag. null falls back
    // to the AssistantDrawer default (640px). Persisted across re-renders
    // within a session; not currently stored in user prefs (the previous
    // legacy AppAssistant didn't either — survives only as long as the
    // tab is open).
    assistantWidth: null,
    assistantResizing: false,
    // WHERE the assistant's answers show (AI_ASSISTANT_SPEC v1 §1 — the
    // PLACEMENT) — one of 'main' | 'right' | 'left' | 'minimized'. 'main' is
    // Page: the main thread over the home's grid area, the DEFAULT (Nika's pick
    // 6 A — "main thread = default"); 'right'/'left' dock the full drawer to
    // that edge and SHRINK the main content (never overlay); 'minimized'
    // collapses the drawer into the SimoneReasoningPill small view above the
    // composer. An explicit choice always wins over this default: hydrated on
    // boot from localStorage('symbols_assistant_dock'), then the user record
    // (functions/assistantDock.js); the default itself is never written up.
    // The shell mirrors it onto <html data-assistant-dock> so the injected
    // shell CSS can drive the layout (reactive layout props freeze at mount in
    // v3.14 — see app.js).
    assistantDock: 'main',
    // Session-only: the dock was PROMOTED out of Page mode ('main') by an opener
    // (the header star, an "Ask AI" link) that asked for the transcript — the
    // close edge returns to Page (functions/assistantDock.js). null when the
    // dock is the user's own choice. Never persisted.
    _assistantDockPromotedFrom: null,
    // WHAT the assistant produces (AI_ASSISTANT_SPEC v1 §1) — 'fly' (every ask
    // composes a page; THE DEFAULT, Nika 2026-10-22: "ok make fly default
    // view" — the home opens on Fly) | 'assistant' (a conversation with
    // embedded live blocks) | 'dashboard' (a generated board) | 'tools' |
    // 'apps' | 'presentation'. The placement (`assistantDock` above) is WHERE
    // it shows. Written only by setAssistantMode (functions/assistantMode.js);
    // persisted per person (localStorage + user_preferences.assistantMode, the
    // record wins), so it is unscoped like `assistantDock` (state.js
    // WORKSPACE_UNSCOPED_KEYS). A person's own choice always wins over this.
    assistantMode: 'fly',
    // AGENT MODE (WS-AGENT-MODE-1, functions/agentMode.js): the workspace TUI
    // as the whole shell. `agentMode` is the person's choice (localStorage +
    // user_preferences.agentMode, the record wins; written only by
    // setAgentMode); `_agentModeLink` is a `?mode=agent` visit (no write).
    // `_agentModeRev` counts the shared runtime's renders: every frame factory
    // reads it, so one render re-runs exactly them (the runtime itself is the
    // plain `root.__agentModeRuntime`, outside the store). `_agentModeError`
    // holds why the model could not start. All four are unscoped (state.js):
    // the runtime re-creates itself on a workspace switch.
    agentMode: false,
    _agentModeLink: false,
    _agentModeRev: 0,
    _agentModeError: null,
    // The generated-board service answers for THIS workspace (set by the view
    // lane's vocabulary fetch, DESIGN-WL-ASSISTANT-MAIN-VIEW-1). Only the
    // DASHBOARD mode needs it (a send builds a board); Page — the placement —
    // needs nothing. Declared so every reader subscribes from first render.
    _aiBoardsAvailable: false,
    // The ai.boards VOCABULARY of the active workspace (installed apps ∩
    // grants) — the Page view's empty-workspace starter chips read it
    // (functions/assistantPageStarters.js); fetched lazily, once per
    // workspace. Declared so every reader subscribes from first render.
    _aiBoardVocab: null,
    // Session-only: the SimoneReasoningPill is acting as the assistant's
    // PERSISTENT handle even though the drawer is closed. Set by homeAiSend when
    // it deliberately suppresses the drawer (a page sheet is open in the PageSlot
    // and would be covered by it), cleared when the pill is expanded. Without it
    // the pill — which otherwise only shows while a turn is LIVE — vanished the
    // instant the turn finished, taking the user's message and the answer with it
    // (natali QA 2026-07-27: "sending a message while a generated view is open is
    // silently dropped"). Never persisted; a reload has no turn to surface.
    _assistantPillHandle: false,
    // ── simone chat surface — state keys consumed by extensions/packages/
    // simone components when imported into the workspace shell. Workspace
    // declares them here with safe defaults so DOMQL signal subscriptions
    // resolve (smbls 3.14 drops writes to undeclared root keys).
    //
    // Wire is sdk.ai (see functions/simoneAiTransport.js) — bridgeStatus
    // is forced to 'open' once the SDK service resolves so simone's
    // composer enables the Send button. bridgeUrl + target chrome show
    // the sdk.ai name (the picker dropdown is the real mode selector).
    bridgeStatus: 'connecting',
    bridgeUrl: 'sdk.ai',
    agent: 'sdk-ai',
    chatInput: '',
    chatMessages: [],
    chatTyping: false,
    pickedElements: [],
    // STRUCTURED AI ATTACHMENTS (VaultOS v2 design §4.1) — what the user HANDED
    // the assistant, as opposed to what it can infer. `{ refs: EntityRef[],
    // canvas: <spec §3.8 payload>|null }`; written only through
    // functions/aiAttached.js (attachAiRef / detachAiRef / attachAiCanvas /
    // clearAiAttached) and read by buildAiAwareness (the ATTACHED tier) and
    // simoneAiTransport (`context.attached` on the wire). Declared here because
    // v3.14 drops an undeclared root key on update() — an attach would have
    // rendered nothing and reported success.
    aiAttached: {
        refs: [],
        canvas: null
    },
    // CONFIDENCE BREAKDOWN DISCLOSURE (spec §4.3) — `{ [messageId]: true }`,
    // written by ChatMessage's confidence pill. Exactly the shape and purpose
    // `_aiToolOpen` carries for tool rows, declared rather than created by first
    // write so the root-write census (__tests__/rootWriteCensus.test.js) sees it
    // classified instead of adding it to the undeclared baseline.
    _aiConfidenceOpen: {},
    // A FAILED UNDO on a tool row (ChatToolRow UndoCreated / UndoFailure) —
    // `{ [createdId]: { cause } }`, the `_aiUndone` latch's twin: the cause
    // code (aiUndoCreated: gone · denied · network · unavailable · failed, the
    // row says it in the active language) and a "Try again" stay on the row
    // until a retry works.
    _aiUndoError: {},
    // ADVICE LEVEL DISCLOSURE (vault spec 06 §7) — `{ [messageId]: true }`,
    // written by ChatMessage's level pill. The confidence pill's twin, declared
    // for the same reason: v3.14 drops an undeclared root key on update().
    _aiLevelOpen: {},
    // A QUESTION CARD'S FACE (ChatCard PvCardChoice, Nika 2026-10-28) —
    // `{ [cardId]: { field: 'own' | 'edit' | null, change: boolean } }`: the
    // field open under its answers (Write my own / Edit) and an answered card
    // reopened by Change. UI state only, written with preventFetch.
    _aiAskCompose: {},
    picking: false,
    showSettings: false,
    currentAssistantId: null,
    // ── voice input (shared VoiceOverlay + functions/voiceSession.js —
    // architecture/VOICE_COMMANDS.md). Same undeclared-root-key rule as the
    // simone block above.
    voiceOpen: false,
    voiceMinimized: false,
    voiceMode: 'talk',
    // TRUE while the global composer's textarea holds focus (blur clears it on
    // a short delay so suggestion-chip clicks land first). Drives the
    // SimoneSuggestions focus-gated fade-in (2026-08-06 per Nika "show AI
    // recommendation buttons on focus instead of overlaying on pageslots").
    _promptFocused: false,
    // TRUE while the composer's "+" menu is open (its local `attachOpen`, mirrored by CanvasPromptTextarea): the AI
    // focus panel yields to it, one panel at a time (shared SimoneSuggestions, design-d2 8673ce440).
    _promptMenuOpen: false,
    // The OPEN dropdown layer's id (or true) — the shared openDropdown's root mirror, set by the layer's onOpen and
    // cleared by its onClose (design-d2, 2026-10-01). A UI transient: null on every boot, never persisted; the AI
    // focus panel reads it to yield under a menu (_simone/Suggestions.js).
    _dropdownLayer: null,
    // THE ALTERABLE AI REFERENCE (2026-08-26): holds the awareness refKey
    // ('record:<type>:<id>') of an open record the user EXCLUDED from the
    // prompt via its context chip. Keyed to one record identity, so opening a
    // different record self-invalidates it — never wiped, never persisted.
    _aiRefMutedFor: null,
    // THE COMPOSER'S AI CONTEXT (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1,
    // functions/aiScope.js): the member's explicit choice `{ key, at }` — a
    // context key ('page' | 'app' | 'workspace' | 'record' | 'app:<id>') and the
    // surface it was made on; null = the default (the most specific context).
    // Names this workspace's apps: wiped on a switch (state.js).
    _aiAskContext: null,
    // The focus panel's own word over its painting (shared functions/
    // aiPanelFocus.js): null (the resting rule) | 'open' (asked for) |
    // 'dismissed' (put away until the field is focused again). A UI transient.
    _aiPanel: null,
    // INSPECT & ASK (functions/aiInspect.js): the mode is on, and the outline's
    // measured box `{ x, y, w, h, label }` (null while nothing is under the
    // pointer). Off and empty after a switch.
    _aiInspect: false,
    _aiInspectBox: null,
    // INVITE FLOW (INVITE-ACCEPT-ACTIVATES-WORKSPACE-LIVE-1 /
    // INVITE-ONBOARDING-USERNAME-NOT-ORG-1): `_inviteFlowActive` marks the
    // accept page's beat so NoOrgOverlay never pushes org creation at an
    // invitee; `_usernamePromptPending` queues the one-time username nudge
    // (consumed by UsernamePromptGate AFTER the joined-workspace switch —
    // wiping it on that very switch would eat the nudge, hence unscoped).
    _inviteFlowActive: false,
    _usernamePromptPending: false,
    // Username-nudge modal draft carriers (functions/usernamePrompt.js +
    // AppUsernamePrompt) — same root-carrier pattern as _createOrg*.
    _unamePromptDraft: '',
    _unamePromptBusy: false,
    _unamePromptError: null,
    _unamePromptStatus: 'idle',
    // The server's explanation for a refusal (reserved word / format error) —
    // null when it sent none, which is the plain "already taken" case.
    _unamePromptReason: null,
    voiceChatKey: '',
    voiceLang: '',
    voiceStatus: 'idle',
    voiceInterim: '',
    voiceFinal: '',
    voiceResult: '',
    voiceError: '',
    voiceHostReady: false,
    // Which composer hosts the in-place voice strip: 'canvas' | 'chat' | null
    // (contract in shared/components/VoiceStrip.js — written by the composer
    // VoiceBtn before voicePttPress, AND-ed with voiceOpen by every reader).
    voiceHost: null,
    // Full text of the agent's last spoken turn (conversational engine).
    voiceReply: '',
    // Input-axis mic mute — voiceMicToggle flips it; every session opens unmuted.
    voiceMicMuted: false,
    // The call clock's zero (ms since epoch) — voiceStart sets it, every close
    // returns it to 0 (shared/components/VoiceControls.js VoiceCallClock).
    voiceStartedAt: 0,
    // THE canonical voice transcript, written by BOTH engines so no surface ever
    // learns which one is live: `{ id, role: 'user' | 'agent', text, streaming }`.
    // The one-shot pipeline mirrors the assistant thread into it (streaming
    // preserved); the conversational engine appends its own turns. Capped — see
    // appendVoiceTurn in shared/functions/voiceSession.js.
    voiceTurns: [],
    // Which engine owns the live session: null | 'convai' | 'recorder'. Mirrors
    // the scope-held handle into reactive state so the UI can say so honestly —
    // a failed conversational start must never look identical to a working one.
    voiceEngine: null,
    // WHY the conversational engine did not take this session:
    // null | 'command-mode' | 'no-agent' | 'unsupported-lang' | 'offline' |
    // 'start-failed'. Set by _startEngine — the source for the visible
    // talk-unavailable notice and the engine tag tooltip.
    voiceEngineReason: null,
    // Live active processes for the current turn — delegated/chained sub-agents
    // (agent.started/completed events via the SDK onProcessActive). The Chat
    // process panel renders this; reset per turn by the transport.
    activeProcesses: [],
    // Retained finished sub-agent runs (the multi-agent view). The transport
    // moves each turn's completed activeProcesses batch here (capped at 30)
    // instead of dropping it, so past parallel/chained runs stay reviewable.
    runHistory: [],
    // @-agent mention: the Simone composer's @-autocomplete picker
    // ({ query, start, end, options, activeIndex } | null). _targetAgentId /
    // _targetAgentName (the thread's directed agent) are created on write by the
    // existing YourAgentCard/ChatCard/team-and-agents set-sites; the picker key is
    // declared here so root.update never drops it.
    _simoneAgentPicker: null,
    perTabSessions: false,
    sessions: {},
    activeSessionId: null,
    showSessionMenu: false,
    // /add-app project-scoped chat context — one extension (= Project) = one
    // thread. Namespaced (_ax_*) so it never collides with the general chat above
    // (the drawer can be open on /add-app). _addAppProjectId = the active extension.
    // _addAppScope mirrors that extension's own scope ('private' | 'shared') so
    // the sidebar's Visibility tab + filtered Apps list stay in sync with
    // whichever thread is active (extensionSaveShare.js _persist and
    // selectAddAppExtension both write it). Was read/written in several places
    // (pages/add-app.js ScopeSwitcher, extensionSaveShare.js) without a declared
    // default — undeclared root keys risk a silently-dropped write, so it's
    // declared here rather than left to smbls 3.14's create-signal-on-first-write.
    _addAppProjectId: null,
    _addAppScope: 'private',
    // /add-app on a phone shows ONE pane: 'chat' | 'preview' | 'apps'
    // (functions/addAppPhonePane.js — persona round 5, marcus at 390 px).
    _addAppPhonePane: 'chat',
    // The way to open the app the builder just saved, shared or added
    // (functions/addAppSaved.js, BLD-28) — { notice, href, label }: the link of
    // the builder's line `_addAppSaveNotice` (it shows only beside ITS sentence,
    // `notice`). Names workspace A's app: WORKSPACE_SCOPED_KEYS below.
    _addAppSaveLink: null,
    // THE APP SPLIT (docs/APP_SPLIT.md): the two lists the project LIST
    // endpoint cannot tell yet — `{ wsId, extensions: [projectId], modules:
    // ['owner/key'], at }`, loaded by shared loadProjectKindSignals and read by
    // shared projectKindContext. One workspace's AI-app ids and catalog ids;
    // wiped on a switch (WORKSPACE_SCOPED_KEYS below).
    _projectKindSignals: null,
    // Draft carried by the composer '+' menu's "Build app" row — auto-sent as
    // the first build-chat message once /add-app's bridge opens (consumed by
    // pages/add-app.js BuildCanvas; written by functions/forceBuildApp.js).
    _addAppAutoSend: null,
    // Build MODE (2026-09-02 per Nika "should be toggle which runs this
    // functionality and opens that generated page after output"): while
    // armed, a send from either AI surface routes into the addapp build
    // pipeline (canvas composer branches in _sendPrompt; the sidebar rides
    // the scope flip in functions/_simone/sendPrompt.js) and
    // watchAiBuildOutput opens the build surface in the PageSlot when the
    // output lands.
    _aiBuildMode: false,
    _ax_chatMessages: [],
    _ax_chatTyping: false,
    _ax_currentAssistantId: null,
    _ax_activeProcesses: [],
    _ax_runHistory: [],
    _ax_sessions: {},
    _ax_activeSessionId: null,
    _ax_showSessionMenu: false,
    // Dashboard inline-thread chat context — prompting from the global
    // CanvasPromptTextarea on / answers ON the dashboard (a thread that replaces
    // the widget grid) instead of opening the side drawer. Namespaced (_db_*) so it
    // is its OWN thread, separate from the general drawer (like _ax_ for /add-app).
    // _homeThreadOpen toggles the inline thread vs the widget grid on /.
    // Since 2026-09-28 it is the MAIN THREAD's flag (AI_ASSISTANT_SPEC v1 §8,
    // functions/assistantMainThread.js): the GENERAL conversation — the same
    // thread the sidebar shows — over the home grid area with the main
    // placement; the reasoning pill and the suggestion island step aside while
    // it is up. The `_db_*` keys stay declared for the retired thread's rows.
    // Since 2026-09-29 (§12.2, main thread = "Everywhere") the flag holds on
    // every route: `_mainThreadPath` is the route it opened on — a navigation
    // closes the thread (functions/assistantMainThread.js assistantMainThreadSync).
    _homeThreadOpen: false,
    _mainThreadPath: null,
    // A new answer's section at the top of its view (functions/assistantReveal.js,
    // Nika 2026-10-23): the room the open main-area view lacks below that section
    // so the scroller can lift it there — `{ view, px }`, the view's place in the
    // tree and its `min-height`. One view holds the main area at a time, so one
    // room; the view gives it back when its conversation or session changes.
    _revealRoom: null,
    // ── Project Version History (2026-08-07 per Nika — legacy platform's
    // Versions rail rebuilt on the canvas page) ──
    // Visibility of the VersionHistoryPanel right rail. May be seeded true
    // BEFORE navigating to the canvas route (dashboard card menu → "Version
    // history"); the panel's onRender self-heals the fetch.
    _versionsOpen: false,
    // The single carrier for the whole history UI (the `_publish` idiom):
    // { projectId, branch, items, page, total, pages, hasMore, loading, error,
    //   selectedId, detail, detailLoading, restoreBusy, restoreError,
    //   restoredTo } — written ONLY by canvas/functions/versionHistory.js.
    _versions: null,
    // ── Site builder (/preview in the shell) ──
    // The website the builder shows, written by the builder page once its data
    // lands (preview/functions/previewSite.js): `{ owner, key, projectId, env,
    // page }`. The assistant resolves the site on screen PER SEND from the
    // visible route or pane (previewSiteInView) and takes `projectId` / `page`
    // from here only when this record names the same site. Null = no builder.
    _previewSite: null,
    // The builder's quiet status line: null, 'setup' (a new site is being
    // made — the builder waits for the first project write) or 'updating' (an
    // AI write landed; the frame reloads the latest saved version).
    _previewSiteStatus: null,
    // The running project write's own label (the server's tool label), shown
    // as the builder's non-blocking chip while the write runs. Null = none.
    _previewSiteStep: null,
    // True when the version on screen is a draft: the latest saved version is
    // not the published one. Drives the quiet "Draft · not published" mark.
    _previewSiteDraft: false,
    // The page the builder shows (`'/'`, `'/about'`): its page picker
    // (previewSiteGoTo) and its sidebar write it; the assistant is told about
    // it per send (previewSiteInView). Preview's own state.js declares the
    // same key for preview standalone. Null = the site's home.
    activePage: null,
    // The last AI project write the shell saw (`{ projectId, tool, at }`). The
    // canvas editor's update watcher (canvas pages/main.js) applies it to the
    // open project; null = none yet.
    _aiProjectWrite: null,
    // Reactive bridge for canvas v2 selection (2026-08-08 per Nika — the
    // CanvasPromptTextarea selection-chips row). `root.canvas.selection` is
    // mutated IN PLACE by functions/canvas/selection.js's setSel — never
    // through root.update — so nothing subscribeTo'd would ever re-render off a
    // selection change alone. setSel bumps this counter via
    // `root.update({ _cvSelectionTick: ... }, { preventFetch: true })` on every
    // selectOne/toggleSelection/selectMany/clearSelection; declarative
    // consumers `subscribeTo: ['_cvSelectionTick']` to re-read the live
    // selection themselves. Declared here (not left to smbls 3.14's
    // create-signal-on-first-write) per house convention — same as every other
    // canvas UI-signal key on this page.
    _cvSelectionTick: 0,
    _db_chatMessages: [],
    _db_chatTyping: false,
    _db_currentAssistantId: null,
    _db_activeProcesses: [],
    _db_runHistory: [],
    _db_sessions: {},
    _db_activeSessionId: null,
    _db_showSessionMenu: false,
    target: null,
    targetSelected: true,
    targetOptions: null,
    targetDraftMode: null,
    targetDraftCwd: null,
    targetDraftCustom: '',
    // sdk auth + cloud workspace state simone reads for its TargetPicker.
    // We don't mount the picker, but the components reference these on
    // create — keep them declared with safe defaults to avoid runtime
    // ReferenceError-style warnings from smbls' undeclared-write guard.
    sdkSignedIn: false,
    cliAuth: null,
    cloudWorkspaces: [],
    cloudWorkspacesLoading: false,
    cloudWorkspacesError: null,
    recentPairings: {},
    // Empty seed, read lazily: its one reader (functions/_simone/wsBridge.js)
    // falls back to `window.location.origin` when it runs — never at module
    // load (see `currentPath` above).
    currentOrigin: '',
    // ── canonical Chat header (hoisted into simone Chat.js) ──
    // The AssistantDrawer mounts simone's Chat wholesale; these keys back the
    // header's TargetSwitcher / ProviderDropdown / Avatar. Declared with safe
    // defaults so smbls 3.14 doesn't drop the writes.
    // Workspace-embedded: default to the workspace target (the my-app is always
    // workspace-scoped via sdk.ai) and hide 'General Questions' in the
    // TargetSwitcher — only 'Workspace' (default) + 'Local' are offered.
    targetMode: 'workspace',
    noGeneralTarget: true,
    targetPickerOpen: false,
    targetPickerView: 'home',
    modelMode: 'auto',
    _modelMenuOpen: false,
    // ParamsBtn's _aiModePickerOpen)
    _aiPinMenuOpen: false,
    // Nullify simone's login gate — the workspace shell already owns auth.
    authBypass: true,
    authReady: true,
    authUser: null,
    inspectorTools: false,
    hidePickTool: false,
    // here just points the AI at an item (context),
    // not a DOM-update request like the extension
    workspaceEmbed: true,
    // (shell chrome shows one), pointing Pick copy,
    // embed-trimmed SettingsDrawer
    // ── Notifications ──
    // `notifications` = transient toast queue (GlobalNotification, shared method).
    // `notifs` = the persisted notification CENTER (bell + panel) — a SEPARATE key
    // so center rows never render as toasts or inflate the bell count.
    notifications: [],
    notifs: [],
    // The notification centre has answered at least once (functions/
    // notifications/subscribeNotifications.js fetchNotifications, a failure
    // too): Home's inbox signal waits for it (functions/homeSignals.js).
    notifsLoaded: false,
    notificationsPanelOpen: false,
    // NotificationPanel's All/Unread segmented filter. MUST be declared or the
    // tab clicks' `root.update({ _notifFilter })` is silently dropped (v3.14)
    // and the tabs never switch — shipped broken exactly that way (2026-08-01).
    _notifFilter: 'all',
    // HeaderTabs (module navbar) reorder-drag UI state. `_navbarReorder` is the
    // long-press arm flag (was undeclared since 2026-07-30 — its writes were
    // silently dropped, the same v3.14 trap as _notifFilter above); the three
    // drag keys drive the lift + insertion-indicator visuals (2026-08-01).
    _navbarReorder: false,
    _navbarDragPath: null,
    _navbarDragOverPath: null,
    _navbarDragOverAfter: false,
    // Reminders composer extras (2026-08-01): the armed @mention autocomplete
    // query (null = menu closed). The shared/private toggle default
    // `_reminderDraftShared` lives with its draft siblings further up — a
    // duplicate key here shadowed it (esbuild duplicate-object-key warning on
    // every workspace-shell platform push).
    _reminderMentionQuery: null,
    // ── Public user profile (`/user/:slug`) ──
    // Populated by pages/userProfile.js#onCreate. Without these declared,
    // smbls 3.14 silently drops the writes and the profile renders blank.
    _profileSlug: null,
    _profileViewed: null,
    _profileLoading: false,
    _profileTab: 'projects',
    _profileActivity: {},
    _profileProjects: null,
    _profileEditing: false,
    _profileSaving: false,
    _profileSaveError: null,
    // ── Follow graph ──
    // List of lowercase email addresses the current user follows.
    // Mirrored across marketplace + shell via localStorage hydrate.
    followingEmails: [],
    // ── Marketplace community feed (mounted at /marketplace/feed) ──
    // Each post mirrors the shape persisted by marketplace's community.js.
    feedFilter: 'all',
    feedPosts: null,
    feedLoading: false,
    composerOpen: false,
    composerDraft: {
        projectId: null,
        message: ''
    },
    composerSubmitting: false,
    composerError: null,
    _followInFlight: {},
    _myProjects: null,
    _openThreads: {},
    _commentsByPost: {},
    _commentsLoading: {},
    _commentDrafts: {},
    // ── Workspace presets (App Store presets row + sheet, new-account wizard) ──
    // The ONE writer is marketplace/functions/workspacePresets.js, which the shell
    // registers at boot (marketplace functions/eagerSlice.js). Declared so each
    // key exists from the first render (an absent key registers no dependency):
    //   `_workspacePresets` — null until the first good read of the public
    //     registry, then the preset list. `_workspacePresetsAt` — ms of that
    //     read (0 = never). `_workspacePresetsUnsupported` — this host's SDK has
    //     no `listWorkspacePresets`, so every preset surface hides itself.
    //     `_workspacePresetsError` — null | 'failed'. All four are the PUBLIC
    //     registry: unscoped (state.js, with the reason).
    //   `_presetApply` — null | { key, workspaceId, status, lines, result, error }:
    //     the apply in flight or just finished against ONE workspace. Scoped
    //     (WORKSPACE_SCOPED_KEYS below): a switch must not show workspace A's
    //     progress lines under workspace B.
    _workspacePresets: null,
    _workspacePresetsAt: 0,
    _workspacePresetsUnsupported: false,
    _workspacePresetsError: null,
    _presetApply: null
};
const $37afbd444df360a1$export$40e714049df95579 = new Set([
    '_workspaceActivation',
    // people / teams
    'peopleAll',
    'people',
    // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — the roster's load marker + error key.
    // Both are per-workspace facts: the next workspace's roster is unread until
    // its own producer runs, so carrying `peopleLoaded: true` across a switch
    // would let the new workspace render the previous one's headcount as a
    // verified number.
    'peopleLoaded',
    'peopleError',
    'teams',
    'teamsByEmail',
    'teamsByUserId',
    'teamMembersLoaded',
    'orgMembersByOrgId',
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20): the org MEMBER-ROLE MAP left quarantine
    // here, beside `orgMembersByOrgId` / `peopleAll` — the same
    // `sdk.listOrgMembers(jwtClaims.workspace_org_id)` payload, split across two
    // keys of which only one was registered. `roles.byUser` maps a GLOBAL userId to
    // that member's role in the ACTIVE org, and `roles.byUserMemberId` maps it to
    // the OrgMember._id that `sdk.updateOrgMember` PATCHes.
    // ⭐ THE LEAK IS THIS FILE'S OWN KNOWN BUG, HALF-FIXED. loadPrivateData's
    // switch tail already records it: "role badges kept showing the PREVIOUS org's
    // member-role mapping (`root.roles.byUser` is keyed by the global userId, not
    // scoped per-org, and nothing re-ran the fetch)". That fix added the REFETCH
    // and never added the WIPE — and `_loadRoles` fires in the NON-BLOCKING TAIL,
    // AFTER reveal, behind a network round trip. So for the whole duration of that
    // round trip /people, /admin, PersonCard, MemberProfile and availabilityUtils
    // render workspace A's roles against workspace B's roster, on revealed UI. A
    // global-id key is the shape that leaks silently: the same userId is a valid
    // key in both tenants, so a stale entry never looks wrong.
    // PHASE-2 pair: already present and UNCONDITIONAL — `_loadRoles(root, sdk)` in
    // the switch tail's `void Promise.all([...])`. It carries NO "already fetched"
    // latch, module-level or element-local; its only gates read ROOT state
    // (`jwtClaims.workspace_org_id`, preserved by PHASE-1's `...root.parse()`, and
    // `peopleAll`, filled by the awaited essential set before the tail runs). ⇒
    // nothing outside root state can strand this key.
    // ⛔ Wipes to `null` via WORKSPACE_SCOPED_OVERRIDES, NOT to a bare `{}` — see
    // the override entry for why a bare `{}` would break two shape fallbacks.
    'roles',
    'pendingInvitations',
    // WS-SWITCH-INCOMPLETE-1 (2026-08-19): the four /admin/teams INVITE DRAFTS left
    // quarantine here, beside the `pendingInvitations` rows they produce — the
    // "headline registered, satellite left behind" shape: the fetched invite list was
    // scoped, the drafts that create it were not. An invite draft belongs to the
    // workspace you are inviting INTO. ⭐ `_wsInviteTeams` makes the leak concrete
    // rather than cosmetic: it holds TEAM SLUGS of the current workspace
    // (pages/admin/teams.js team toggles) and the submit posts them together with the
    // ACTIVE `workspace.id` to `inviteToWorkspace` — so a draft that survives a switch
    // writes workspace A's team slugs into workspace B's invite. Safe to wipe with no
    // PHASE-2 pair: a draft's correct post-switch value IS its schema default, and no
    // module-level memo guards them (every read is a direct `s.root?.…` in the page).
    // ⛔ `_wsInviteRole` resets to 'editor', NOT '' — _freshEmpty passes scalars
    // through, so the role select keeps a valid option. Do not "fix" that with a
    // WORKSPACE_SCOPED_OVERRIDES entry.
    '_wsInviteEmail',
    '_wsInviteRole',
    '_wsInviteTeams',
    '_teamInviteEmail',
    // 🚨 WS-SWITCH-INCOMPLETE-1 (2026-08-19): the invite RESULTS, moved here from
    // WORKSPACE_UNSCOPED_KEYS — a MISCLASSIFICATION, not a quarantine drain. They
    // sat under the comment "TRANSPORT flags — in-flight/loading/typing booleans,
    // re-derived by the switch itself", and BOTH HALVES OF THAT WERE FALSE, which
    // is exactly why the leak survived review:
    //   • Not booleans — objects `{tone, message, inviteUrl}`. `inviteUrl` is the
    //     server's invite link for the ACTIVE workspace (`res?.inviteUrl` from
    //     inviteToWorkspace), which pages/admin/teams.js RENDERS as visible text
    //     beside a copy button that writes it to the clipboard. `message` also
    //     embeds the invitee's email and the selected team names.
    //   • Nothing re-derived them on a switch — their only writers are the invite
    //     submit handlers, and the two `: null` resets are modal-close paths, not
    //     switch paths. Workspace A's invite URL stayed on screen, and copyable,
    //     after switching to workspace B.
    // Wipes to `null`, which is both the schema default and the correct
    // post-switch value (no invite is in progress in the new workspace), so no
    // PHASE-2 refetch pair is needed.
    // ⚠️ ONE NARROWER WINDOW REMAINS, deliberately not fixed here: the success
    // write lands AFTER `await inviteToWorkspace(...)`, so a switch DURING an
    // in-flight invite still writes workspace A's result into workspace B. That
    // needs a scope guard at the handler in pages/admin/teams.js — a different
    // file and a different argument. Scoping closes the persistent case, which is
    // the one a user actually hits.
    '_wsInviteStatus',
    '_teamInviteStatus',
    'announcements',
    'resourceLinks',
    'userDocs',
    'userPrefs',
    'orgNotifCount',
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20): the per-type signals join their headline
    // here. `fetchOrgNotifCount` writes BOTH keys in ONE
    // `root.update({ orgNotifCount, orgNotifSignals })`, and only the headline was
    // ever registered — the "satellite left behind" shape, provable by CO-WRITE
    // rather than by name. Without this the two halves of one payload disagree
    // after every switch: the count empties, the signals keep the pre-switch
    // numbers. Wiping is free today (the repo-wide scan finds ZERO readers — four
    // hits total, all declaration/comment/write), and the write's own comment
    // promises "a future per-type surfacing can read root.orgNotifSignals[orgId]
    // without refetching" — that future reader would show stale counts on revealed
    // UI and would look correct, because the badge beside it is right.
    // PHASE-2 pair: already present and UNCONDITIONAL — `fetchOrgNotifCount(root)`
    // in the switch tail. No "already fetched" latch, module-level or
    // element-local; its two early returns (`document.hidden`, missing auth token)
    // are a DOM fact and a transport fact, not memos, and the hidden-tab case
    // self-heals on the next NOTIF_POLL_MS tick of app.js's poll interval — the
    // same gate `orgNotifCount` has always been scoped through.
    // ⛔ SCOUTED, NOT ANSWERED HERE: app.js's poll comment calls this pair
    // "Cross-org by design — not reset on workspace switch", which the headline's
    // own scoped classification already contradicts. Whether the PAIR belongs in
    // USER scope is a separate argued diff; a satellite drain must not silently
    // reclassify its headline, and splitting one `root.update` across opposite
    // registries would be worse than either consistent answer.
    'orgNotifSignals',
    // Tickets — board cache + /tickets/my + /tickets/feed
    'tickets',
    'myTickets',
    // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — Home's own ticket cache and its
    // load-state pair (see their declarations above). Same tenancy boundary as
    // the board cache they sit beside; the one-shot gate MUST reset on a switch
    // or the new workspace never fetches its own tickets.
    '_userTickets',
    '_homeTicketsLoaded',
    '_homeTicketsError',
    // Workspace presence rollup for the Home analytics widget — scoped
    // `projectId: 'workspace'` per PRESENCE-ZERO-1, so it is the ACTIVE
    // workspace's number and must not survive a switch.
    '_homeWorkspaceActivity',
    '_homeWorkspaceActivityError',
    'feedItems',
    'totalByColumn',
    // PR #283's sidebar TYPE counts: the SAME workspace's tickets as
    // totalByColumn, written in the same root.update. Kept across a switch they
    // would show the previous workspace's numbers beside the new board; the
    // board's `workspace` watcher re-runs the load wave, which refills them.
    'totalByType',
    // Their raw source (PR #287): the same workspace's counts, refilled by the
    // same load wave; kept across a switch they would re-sum A's numbers on B.
    '_rawTypeCounts',
    'loadedByColumn',
    'loadingColumn',
    'columns',
    'selectedTicket',
    // The board's ?project= scope: a project id from THIS workspace, which
    // every column query filters by (filtersFromRoot → _buildMongoFilter). Kept
    // across a switch, the next workspace's board would filter by a project it
    // does not have and show empty columns.
    'filterProjectId',
    // WS-SWITCH-INCOMPLETE-1 step 4 (2026-08-20) — the ticket comment thread left
    // quarantine here. It holds comment ROWS (body, author email, timestamp) for
    // the open ticket, so it is tenant data under any reading, and it is exactly
    // the "headline registered, satellite left behind" shape this ticket names:
    // `selectedTicket` directly above was registered, the thread hanging off it
    // was not, so a switch wiped the ticket and kept its comments.
    //
    // Quarantined until now because the comments plane carried a permanent
    // "ever fetched" memo. That plane was REMOVED, not keyed (`workspace
    // aeec537df`) — `_commentsInFlight` releases in a `finally` — so the PHASE-2
    // refill is just the display reactive re-firing on the next ticket open.
    // `_ticketCommentsFor` is the slot's own tag and MUST wipe with it; see its
    // declaration above for why it stopped being an element property.
    '_ticketComments',
    '_ticketCommentsFor',
    '_ticketCommentsSkip',
    '_ticketCommentsHasMore',
    '_ticketCommentsLoadingOlder',
    '_ticketCommentsLoading',
    '_editingCommentId',
    '_commentEditDraft',
    // WS-SWITCH-INCOMPLETE-1 step 5 (2026-08-20) — the dependency plane left
    // quarantine here. `_ticketDeps` caches the open ticket's dependency ROWS
    // (id + title of tickets on both sides of the link) keyed by ticket id, and
    // `_depPool` holds the 200 most-recent tickets of the ACTIVE workspace —
    // the list the "Add dependency" picker searches. Neither was wiped, so after
    // A -> B the picker searched workspace A's titles and picking one wrote a
    // dependency across a tenant boundary. `selectedTicket` and `tickets` beside
    // them were already registered: the same "headline registered, satellite
    // left behind" shape.
    //
    // The PHASE-2 refill needs no new teardown in either case, because both
    // guards read the wiped state itself: `_ticketDeps`'s per-ticket fetch is
    // gated on `cache[id]` and the pool's on `!_depPool && !_depPoolError`. The
    // two flags MUST wipe with the pool — a mid-switch failure or an unreleased
    // in-flight flag is itself a permanent "do not retry" signal for the next
    // tenant.
    '_ticketDeps',
    '_depPool',
    '_depPoolLoading',
    '_depPoolError',
    // WS-SWITCH-INCOMPLETE-1 step 3, bucket A2 (2026-08-20) — THE APPROVAL
    // DOMAIN, all five keys of it, and the only place on this ticket where a
    // leftover value REMOVES a control instead of showing a stale one.
    //
    // ⭐ THE DEFECT. The human-approval bar has two gates and only one of them
    // reads the ticket:
    //   ApprovalBar  → `_isAwaitingApproval(root) && !_isEditing(root) &&
    //                   !root._approvalDoneAt`
    //   ApprovedPill → `root._approvalDoneAt && !_isEditing(root)`
    // `_isAwaitingApproval` reads `selectedTicket` (registered above), so the
    // first gate follows the tenant. The pill's gate does not read the ticket at
    // all, and NOTHING ever clears the pair — two writers (the approve and the
    // reject success paths), zero resets. So one decision in workspace A hides
    // the Approve/Reject buttons on every ticket opened afterwards in workspace
    // B and renders `APPROVED · 14:32` over them instead. The user cannot
    // approve, and is told the decision is already made.
    //
    // ⭐ `_approvalNote` IS THE SINK RULE AGAIN (see `_reminderDraft` below).
    // Traced backward it is free text the user typed, which step 6's
    // overlay-pointer rule files UNSCOPED. Traced FORWARD it is the `body` of a
    // `ticket_comment` INSERT — `_approveTicket` hands it to
    // `comments.create(t.id, body)`. Carried across, a note written about
    // workspace A's ticket becomes a permanent audit-trail row on workspace B's
    // ticket under the current user's email. A draft's sink is a WRITE.
    // ⛔ Its empty is `''`, its declared default — not null. The textarea binds
    // `value` directly.
    //
    // ⭐ `_approvalError` IS TENANT-DERIVED ON ONE BRANCH, WHICH IS ENOUGH. Two
    // sources write it: a fixed copy string ("Session not ready…") and
    // `err?.message` from an SDK call issued against workspace A's ticket. A key
    // is classified by its WORST source. Its 4-second auto-clear timer is not a
    // reset either — it fires late and unconditionally, so unguarded it reaches
    // across the boundary and clears an error workspace B raised for itself.
    //
    // ⭐ AND THE RULE THIS DOMAIN ADDS — A TENANT GUARD CAN ORPHAN A KEY THAT
    // WAS CORRECTLY CLASSIFIED BEFORE IT. `_approvalPending` sat under state.js's
    // TRANSPORT FLAGS heading, whose claim is "re-derived by the switch itself".
    // That claim held only by accident: nothing re-derives it, but the completion
    // handler always ran and always wrote `false`. This commit adds
    // `sameWorkspaceWriter` to those handlers — mandatory, because an approval
    // issued in A otherwise lands its `_approvalDoneAt` / `_ticketComments` /
    // `selectedTicket` writes in B AFTER the wipe. The instant the guard exists
    // the completion can be DROPPED, and a dropped completion never clears the
    // latch: workspace B's Approve button then reads `Approving…` and `disabled`
    // forever. ⇒ The guard and this reclassification MUST ship in one diff;
    // adding the guard alone converts a leak into a wedge.
    // ⛔ It wipes to `false`, never null — `false` is the declaration, and the
    // partition asserts declaration equality, not truthiness.
    '_approvalError',
    '_approvalNote',
    '_approvalPending',
    '_approvalDoneAt',
    '_approvalKind',
    // Chat — RLS-scoped by workspace_id
    // WS-SWITCH-INCOMPLETE-1 (2026-08-19): `_pinnedChannels`/`_hiddenChannels` left
    // quarantine here. ⭐ Their localStorage IS already tenant-segmented
    // (`chat_pinned_channels:${wsId}`, channelActions.js:259) — but a correctly
    // partitioned STORE does not help if its in-memory MIRROR is never reset: the
    // store held workspace B's pins while state still showed A's. Safe to wipe
    // because the PHASE-2 re-read already exists — `loadPinnedChannels` re-reads on
    // mount (MessengerOverlay.js:146, chat/pages/index.js:143) — and no module-level
    // memo guards it (`_loadPinned` hits localStorage every call).
    '_pinnedChannels',
    '_hiddenChannels',
    'channels',
    'channelMembers',
    'messagesByChannel',
    'myMentions',
    'activeChannelId',
    'activeThreadRootId',
    'threadOpen',
    'threadParentId',
    'composerReplyTo',
    '_editingMsgId',
    '_editingMsgBody',
    'typingByChannel',
    'chatVisibleCounts',
    '_chatDrawerChannels',
    '_chatDrawerChannelId',
    '_chatDrawerMessages',
    // The pill's away mark and each channel's unread span hold this tenant's
    // channel ids and message times; the open emoji picker and the thread
    // field's has-text flag belong to composers on the page the switch leaves
    // (the `_aiInspect` precedent: dropped with the page they were over). Each
    // wipes to a value its writers already produce: null, null, {} (the
    // MessageList prune writes it), null, false.
    '_chatAwaySince',
    '_chatAwayCid',
    '_chatNewFrom',
    '_composerEmoji',
    '_threadHasText',
    // Who is typing in which channel — another workspace's channels and
    // people; wipes to {} (what the chat stream's prune writes).
    '_chatTypists',
    // WS-SWITCH-INCOMPLETE-1 step 3, bucket A2 (2026-08-21) — THE CHAT DRAFTS.
    //
    // ⭐ `newChannelDraft` IS THE SINK RULE (see `_reminderDraft` below) WITH
    // TENANT ROWS ALREADY INSIDE IT. Backward it is a form the user typed
    // (name, topic, kind). Forward it is the payload of `createChannel`:
    // `d.members` is a list of EMAILS picked from workspace A's roster and
    // `createChannel` turns every one of them into a `chat_channel_members`
    // INSERT. Carried across, a channel started in A and finished in B seeds
    // B's new channel with A's people. The draft becomes rows.
    // ⛔ Wipes to `null`, NOT to the `{name:'',…}` default and NOT to `{}`. The
    // rule: A WIPE MUST PRODUCE A VALUE SOME WRITER ALREADY PRODUCES, so every
    // reader has met it. `closeNewChannelModal` writes `newChannelDraft: null`;
    // `{}` is a shape no writer produces. Every read is
    // `s.root?.newChannelDraft?.X` or `|| {…}`, and `openNewChannelModal`
    // re-seeds the full shape on open. (WORKSPACE_SCOPED_OVERRIDES below.)
    //
    // ⭐ `pendingAttachments` IS KEYED BY CHANNEL ID — a map from workspace A's
    // channel ids to upload chips (name, size, mime, the public URL once
    // uploaded, a `blob:` preview and the File itself). Left in place, A's
    // channel ids sit in B's root as keys and A's file URLs sit under them. It
    // is tenant data by content and by key.
    // ⛔ Wipes to `{}` (the declared default, via `_freshEmpty`), NEVER null:
    // Composer's AttachmentBar `children` reads
    // `s.root.pendingAttachments[s.root.activeChannelId]` UNGUARDED, and so does
    // `uploadAttachment`. `{}` is also writer-produced — `sendMessage` deletes
    // the channel's entry after a send.
    // ⚠️ Known, not fixed here: a chip's `blob:` object URL is revoked only by
    // the chip-remove / retry / send paths (chat/pages/index.js, sendMessage.js).
    // The wipe drops the chip without revoking, so a pending chip that crosses
    // a switch keeps its object URL alive until page unload. A registry wipe
    // cannot run per-key teardown; that wants a switch hook this registry does
    // not have. Recorded on the ticket.
    // ⚠️ Also known: `uploadAttachment`'s two post-await writes (success and
    // failure) are NOT tenant-guarded — after a switch they land
    // `{ [A-channelId]: [] }` in B's root (the wiped list, mapped, is empty).
    // The chat package has NO `sameWorkspaceWriter` today, and its loaders of
    // already-scoped keys (`channels`, `messagesByChannel`) have the same late
    // write exposed with far more payload — one ticket for the class, not a
    // fourth copy of the helper for one key: CHAT-LATE-WRITES-NO-TENANT-GUARD-1.
    'newChannelDraft',
    'pendingAttachments',
    // AI assistant threads — WORKSPACE-scoped (2026-07-14 per Nika)
    '_aiThreads',
    '_aiThreadId',
    '_aiThreadsLoading',
    '_aiThreadsLoadAttempted',
    '_aiThreadMenuOpen',
    'assistantMessages',
    'assistantTyping',
    // Calendar / Meet page caches — RLS-scoped by workspace_id
    'events',
    // WS-SWITCH-INCOMPLETE-1 step 3, bucket A2 (2026-08-21) — `newBooking`, THE
    // LAST KEY OF THE BUCKET, drained last on purpose: it was the survivor
    // control of every live probe on the ticket until the rest was proven.
    //
    // ⭐ SINK RULE, AND THE `_broadcastDraft` SHAPE OF IT. Backward it is the
    // booking form. Forward it is `saveEvent`'s payload into the ACTIVE
    // workspace — and the save BRANCHES ON A ROW ID THE DRAFT CARRIES:
    // `newBooking.editingEventId` is workspace A's calendar_events id, and the
    // off-route edit path PATCHes it directly (`saveEvent({ id:
    // nb.editingEventId, ...payload })`). A Save pressed in B after a switch is
    // a CROSS-TENANT WRITE against A's event; the header even reads "Edit
    // Booking" over B. `invitees` is A's roster emails (each becomes an invite
    // + notification on save) and the Delete control gates on the same id.
    // ⛔ Wipes to `{}` (the declared default, via `_freshEmpty`), NO override.
    // This key has no close value to borrow — `closeNewBookingModal` clears
    // `showNewBooking` only and never nulls the draft — and no writer produces
    // `null` either; the two modal drafts above could borrow theirs, this one
    // cannot. `{}` is the closer of the two non-writer values: every reader is
    // `root?.newBooking?.X` or spreads it (`{ ...root.newBooking, invitees }`,
    // which `{}` and `null` both survive), `nb?.date` falsy short-circuits the
    // availability check, and EVERY opener re-seeds `freshBooking(overrides)`
    // before the modal is usable (`openNewBookingModal`); submit resets with
    // `freshBooking({ date })` too. The per-switch loss is half-typed text,
    // which is the desired behaviour for a tenant boundary.
    'newBooking',
    // Reminders — personal records-plane rows, tenant-scoped (functions/
    // reminders.js). Filter/draft UI keys stay OFF this list (see their
    // declarations above) — only the fetched row cache resets on switch.
    'reminders',
    // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — the reminders load marker + error key,
    // on the same tenancy boundary as the row cache they describe.
    'remindersLoaded',
    'remindersError',
    // History — the audit-log rows of one workspace, their load marker and
    // error key (the page reads on mount; the switch tail re-reads while it is
    // on screen — loadPrivateData.js `historySurfaceActive`), the person filter
    // (an email of THIS roster) and the open-card map (its keys carry those
    // emails).
    'historyEvents',
    'historyLoaded',
    'historyLoadError',
    'historyPerson',
    '_historyExpanded',
    // Getting started → Team (POB S9) — the found people of one workspace, the
    // owner's typed addresses for them, the domain switch of that workspace and
    // the page's send state (the page reads on mount; the switch tail re-reads
    // while it is on screen — loadPrivateData.js `gettingStartedSurfaceActive`).
    'gettingStartedTeamStatus',
    'gettingStartedPeople',
    'gettingStartedDomain',
    'gettingStartedInvites',
    'gettingStartedOther',
    'gettingStartedSending',
    'gettingStartedSendResult',
    'gettingStartedDomainJoin',
    'gettingStartedDomainJoinStatus',
    '_gettingStartedWhyOpen',
    // Getting started → Imports (POB S10) — the found sources of one
    // workspace, the open review of one of its files and the run into one of
    // its apps (the page reads on mount; the switch tail re-reads while it is
    // on screen — loadPrivateData.js `gettingStartedImportsActive`).
    'gettingStartedImportStatus',
    'gettingStartedSources',
    'gettingStartedTargets',
    'gettingStartedReview',
    'gettingStartedMapping',
    'gettingStartedImportError',
    'gettingStartedUploading',
    'gettingStartedRun',
    'rooms',
    'waitingRoom',
    // Meet realtime + transcript surfaces (2026-07-30 isolation audit #7):
    // written by subscribeMeetRealtime/TranscriptPage, previously carried
    // meeting content across tenants indefinitely.
    'utterances',
    'analysis',
    // per-room with `analysis`: a switch must not carry room A's "loaded"
    // over room B's transcript
    'transcriptLoaded',
    'liveParticipants',
    'activeRoomId',
    // a ring is a room of THIS workspace: a switch must not carry it over
    '_callRing',
    // the timeline of THIS workspace: a switch must not carry it over
    '_callChanges',
    // WS-SWITCH-INCOMPLETE-1 step 3, bucket A2 (2026-08-21) — THE MEET DRAFT
    // AND THE CALL ERROR.
    //
    // ⭐ `newRoomDraft` — SINK RULE. Backward: name / kind / transcribeEnabled /
    // isPrivate, no tenant id in it. Forward: it is the payload of `createRoom`,
    // a `rooms` INSERT into the ACTIVE workspace — a call named in A is created
    // in B. Wipes to `null`, the value `closeNewRoomModal` writes; every reader
    // goes through `_draft(s)` = `root.newRoomDraft || {}`, and EVERY opener
    // re-seeds the full shape (`openNewRoomModal`, meet/pages onCreate,
    // MainNavbar's Meet button). Same rule as `newChannelDraft` above.
    //
    // ⭐ `meetCallError` (+ `meetCallErrorName` / `meetCallErrorCode` / — added
    // leg 14 — `meetCallErrorReason` / `meetCallErrorStatus`, its four
    // satellites, each UNDECLARED until the diff that scoped it) — the
    // `_approvalError` argument:
    // `err?.message` from a connect issued against workspace A's room, and a
    // key is classified by its WORST source. Left in place, VideoRoom's
    // ErrorOverlay (`hide: !s.root?.meetCallError`) shows A's "Couldn't join: …"
    // over B's room until B dismisses it. The three are written together in
    // both writers (connectCall's pre-flight reset and its catch), so they land
    // in one set (LOCKSTEP). All five wipe to `null`.
    // ⚠️ THE LOCKSTEP IS THE POINT, AND IT BROKE ONCE ALREADY. Step 3 scoped the
    // triple; a later diff widened the record to five and scoped neither new
    // key, so a switch wiped 3 of 5 and left A's `reasonName` + HTTP `status`
    // feeding VideoRoom's overlay copy under B's room — a PARTIAL wipe of one
    // co-written record, which reads worse than no wipe. The root-write census
    // (b0f12cb90) is what named the two by hand; the source pin in
    // meetChatDraftsTenantScope asserts the writer's FULL shape so the next
    // widening of this record fails the suite instead of leaking quietly.
    // ⭐ THE TENANT GUARD ON connectCall's COMPLETION EXISTS NOW, AND ONLY
    // BECAUSE THE SWITCH DISCONNECTS FIRST (MEET-LIVE-CALL-SURVIVES-SWITCH-1).
    // Step 3 withheld it on purpose: dropping the success write while the
    // LiveKit connection itself was live would have left an INVISIBLE active
    // call in B — a worse wedge than a stale banner. `onWorkspaceChange` now
    // el.calls `disconnectCall` BEFORE its PHASE-1 wipe, so a join that
    // completes after a switch is provably orphaned; connectCall's guarded
    // completion (`sameWorkspaceWriter`) therefore DISCONNECTS that room
    // instead of merely skipping the update. Order is the whole fix: teardown,
    // then wipe, then guard.
    'newRoomDraft',
    'meetCallError',
    'meetCallErrorName',
    'meetCallErrorCode',
    'meetCallErrorReason',
    'meetCallErrorStatus',
    // MEET-LIVE-CALL-SURVIVES-SWITCH-1 (2026-08-21) — THE LIVEKIT SESSION
    // FAMILY, released from quarantine as ONE LOCKSTEP GROUP with the teardown
    // above. These four MIRROR the module-level `_livekitRoom` singleton in
    // meet/functions/connectCall.js — state cannot hold the Room itself (the
    // reactive proxy strips its class methods), so the mirror is all the UI
    // reads. Two of them carry workspace-A content outright: participant
    // identities and free-text call chat.
    // ⛔ WHY THEY COULD NOT SHIP EARLIER, AND WHY THEY SHIP NOW. Wiping the
    // mirror while the room still publishes hides CallWidget over a LIVE call —
    // the wrong state, not a fix, which is why they sat in
    // WORKSPACE_SCOPE_UNREVIEWED through the whole WS-SWITCH-INCOMPLETE-1 drain.
    // The switch path now tears the room down first, so the wipe describes
    // reality. If the teardown is ever removed, these four go back to
    // quarantine in the same diff — they are one unit.
    // All four wipe to their declaration (`false`, `[]`, `[]`, `[]`); no
    // OVERRIDES entry is owed. `meetCallInFlight` stays UNSCOPED — it is a
    // latch, not tenant content, and connectCall's own guarded writers own it.
    'livekitConnected',
    'livekitParticipants',
    'livekitSpeakers',
    'meetChatMessages',
    // A call's fly page and its @-query are this workspace's call (meetFly.js).
    'meetFly',
    '_meetMention',
    // WS-ROOTWRITE-CENSUS-CHAT-ROOM-KEYS-UNDECLARED-1 (2026-10-18) — the rooms
    // sidebar's edit mode and its archived view: the `filesSelectedIds` class
    // below, per-surface UI selection that points at another workspace's rows.
    // `selectedRooms` holds workspace A's room ids and IS the payload of the bulk
    // Archive / Unarchive (meet functions/archiveRooms.js): carried into B, B's
    // Archive button would write A's rooms into the archive list.
    // `isEditingRooms` travels with it (LOCKSTEP — the Edit / Done toggle in
    // Sidebar.js and both archive writers write the pair together).
    // `viewingArchived` carried into B keeps B on the archived view while the
    // browser-global archive list still holds A's ids: it lists none of B's
    // rooms and hides the rest. All three wipe to their declaration (`false`,
    // `[]`, `false`), the values Done and both archive writers already write; no
    // OVERRIDES entry is owed. `archivedRoomsIds` itself is unscoped (state.js).
    'isEditingRooms',
    'selectedRooms',
    'viewingArchived',
    // Documents / KB / notes (audit #2 — CRITICAL: previous workspace's doc
    // titles rendered on the next workspace's dashboard DocumentsWidget).
    'documents',
    '_documentsLoaded',
    'notes',
    'kbArticles',
    // Files desktop (audit #2): nodes + docs + per-surface UI selection state
    // that points at foreign row ids after a switch.
    'fileNodes',
    '_fileNodesLoaded',
    // Workspace A's failed fetch is no news about B: a switch wipes it to
    // `null`, its declared default, and B's own fetch writes its outcome.
    '_fileNodesError',
    'fileDocs',
    '_fileNodePos',
    'filesOpenFolder',
    'filesSelectedIds',
    'filesViewer',
    // In-flight upload ghosts. An upload started in the previous workspace either
    // already landed there or is about to fail against the new claim — either way
    // its ghost must not sit on the next workspace's desktop. (uploadFilesToCanvas
    // removes each entry by key in its own `finally`, so a late removal against a
    // wiped array is a no-op filter, not a resurrection.)
    '_filesUploading',
    // Additive workspace apps (audit #1 — the crm-recent-in-GreenIG vector):
    // the stash feeds _allModuleWidgetsFor/homeCatalogFor, so a stale bag kept
    // the PREVIOUS workspace's app widgets in the next one's catalog. Wiped
    // here; loadWorkspaceApps repopulates in the activation chain.
    'workspaceApps',
    // The workspace MODULE bag itself (manifest: widgets/routes/skin/panels) —
    // per Nika 2026-08-01 "loading old apps … is super malicious": this key
    // was NEVER in the registry, so the PREVIOUS workspace's module widgets,
    // routes and skin stayed live in state (and therefore in the DOM catalog)
    // for the whole wipe→reload window. Wiped to the not-loaded sentinel;
    // loadWorkspaceProject repopulates unconditionally in the switch pipeline.
    'workspaceProject',
    // Home dashboard per-workspace visibility map — recomputed by the widget
    // resync from the new workspace's panels; carrying it over let one
    // workspace's hidden set mask another's dashboard.
    '_homeHiddenWidgets',
    // Home dashboard per-widget COLOUR map (2026-09-02, "Add color"). Scoped
    // for the same reason as the visibility map above, and more sharply: house
    // widget ids COLLIDE across workspaces by construction — every workspace
    // has `greeting`, `received`, `app-chat` — so carrying this over paints one
    // workspace's choices onto another's board. Its cache key already carries
    // the workspace scope (pages/main.js `_widgetColorsKey`); the switch
    // re-resolves it from the new workspace's row/cache.
    '_homeWidgetColors',
    // The open "Add color" swatch palette, `{ widgetId, x, y }`. Transient UI,
    // wiped because the widget it points at need not exist in the workspace
    // being switched to — a palette left open over a vanished card would write
    // a colour for a widget that is not on this board.
    '_homeColorPicker',
    // Home board LAYOUT v2 — the saved ORDER of widgets, one size each
    // (DESIGN-WL-HOME-WIDGETS-1, pages/main.js `_resolveHomeLayout`). Scoped
    // like the visibility map: ids collide across workspaces (`received`,
    // `app-chat`), so one workspace's order must never lay out another's board;
    // the board re-resolves it from the new workspace's row / scoped cache.
    '_homeLayout',
    // The widget being dragged in edit mode (its id, for the lifted look).
    // Transient UI, like the palette above: a drag cannot outlive a switch.
    '_homeDragId',
    // Org/company financial identity (audit runners-up).
    'companyInfo',
    'financials',
    // Analytics page state (audit #1b table).
    '_wsMembers',
    '_projectsForActiveOrg',
    // The app split's signals (AI-app ids, catalog ids) belong to ONE
    // workspace — a switch must not classify org B's projects with org A's ids.
    '_projectKindSignals',
    // Analytics dashboards + logs tables (2026-08-08 merge audit): every
    // one of these holds tenant-scoped analyzed rows / rollups. None were
    // in the registry, so a workspace switch carried org A's sessions,
    // logs and error clusters into org B's view until each surface
    // happened to refetch. The fetcher caches are workspace-keyed now;
    // the state slots get wiped here.
    '_analytics',
    '_analyticsSessions',
    '_analyticsActiveUsers',
    '_analyticsServerSource',
    '_analyticsSampleSize',
    '_analyticsProjectKey',
    '_analyticsParams',
    '_wsaWeekly',
    '_wsaBugs',
    '_wsaOpenTasks',
    '_wsaActive',
    'logsUsers',
    'logsSessions',
    'logsEvents',
    'logsNetwork',
    'logsVerbose',
    'logsBugs',
    'logsSessionDetail',
    'logsSessionEvents',
    '_logsSessionId',
    '_logsCountry',
    '_logsUser',
    // WS-ANALYTICS-FAMILY-SPLIT-UTC-TOTALS-1 — the overall totals, top pages
    // and top referrers feeds (analytics/functions/loadAnalyticsData.js), the
    // zone the `now` rollup was bucketed in, and the workspace overview's
    // 7-day totals: all tenant-scoped analyzed rollups, same class as the
    // block above.
    '_analyticsTotals',
    '_analyticsTotalsError',
    '_analyticsPages',
    '_analyticsReferrers',
    '_analyticsRollupTz',
    // WS-ANALYTICS-UTM-CAMPAIGNS-UI-1 — the UTM campaigns feed, the last-12-
    // days feed (both tenant-scoped analyzed reads) and the sessions-list
    // drill filters a campaign row / visitor row / session detail sets
    // (`_logsUtm*`, `_logsVisitor` — same class as `_logsCountry` /
    // `_logsUser`: carried into B they filter B's sessions by A's ids).
    // (The group-by pill `_analyticsCampaignsGroupBy` is a USER preference —
    // WORKSPACE_UNSCOPED_KEYS in state.js.)
    '_analyticsCampaigns',
    '_analyticsCampaignsError',
    '_analyticsDaily',
    '_analyticsDailyError',
    '_logsUtmSource',
    '_logsUtmMedium',
    '_logsUtmCampaign',
    '_logsVisitor',
    '_wsaTotals',
    '_wsaTotalsError',
    // Calendar team view + standups (audit #1b table).
    'teamMembers',
    // WS-CALENDAR-TEAMMATE-KEYS-UNCLASSIFIED-BREAK-SUITE-1 — `teamMembers`'
    // AddTeammatesModal satellites (PR #253). Same class as the standup
    // satellites below: `addTeammateFeedback` renders a teammate NAME from the
    // active org ("X is already in Team") and `addTeammateQuery` holds typed
    // member text, so carried into B they are tenant residue on screen; the
    // open flag rides along so a switch never leaves A's roster editor open
    // over B.
    'showAddTeammates',
    'addTeammateQuery',
    'addTeammateFeedback',
    '_dailyUpdates',
    '_standupSummary',
    '_standupActions',
    // WS-SWITCH-INCOMPLETE-1 step 3 (standup domain) — the rest of the plane.
    // `_standupSummary`/`_standupActions` were registered alone; the satellites
    // below survived every switch. Standups are per-workspace by route
    // (`/workspaces/:id/standups`), so all of it is tenant data.
    //   `_dailyDraft`   — the SINK rule: it is not display text, it BECOMES
    //     `update_text` on the row `_saveStandup` upserts into whichever
    //     workspace is ACTIVE at save time. Carried into B it is a
    //     cross-tenant WRITE of A's words, not a stale label.
    //   `_standupPhase` — ⭐ this one REMOVES A CONTROL. `InputSection` hides
    //     unless the phase is `idle`, so a stale `complete` from A leaves
    //     workspace B with NO standup composer at all, under A's summary card.
    //     A census that only compares VALUES cannot see a missing control.
    //   `_standupFollowUps` — orphaned dependent: chips parsed out of A's
    //     analysis, rendered beside the (already scoped) summary.
    //   `_standupCheckedDate` — the plane's "derived for THIS tenant, today"
    //     stamp; see its default for why the rollover gate changed with it.
    //   `_standupOpenIds` — pointer at rows `_dailyUpdates` empties.
    '_dailyDraft',
    '_standupPhase',
    '_standupFollowUps',
    '_standupCheckedDate',
    '_standupOpenIds',
    // Tickets board prefs — storage went per-workspace (245f9761), so the
    // once-per-SESSION seed latch + the seeded root values are now tenant
    // data: carrying them across a switch pinned workspace A's board shape
    // onto B. The wipe resets the latch; the PHASE-2 tickets branch (and any
    // later board mount) re-seeds from the NEW workspace's storage blob.
    '_ticketsPrefsSeeded',
    '_ticketsFreeform',
    '_colCount',
    '_hiddenCols',
    // The Task Settings "excluded from counts" columns (PR #287): the same
    // per-workspace board pref as `_hiddenCols` (boardPrefs.js _ROOT_TO_PREF).
    '_excludedCols',
    '_showDrafts',
    // Marketplace installed set — same shape: per-workspace storage behind a
    // per-session hydrate latch (hydrateInstalledFromPrefs re-runs on the next
    // marketplace mount).
    'installed',
    '_installedHydrated',
    // A workspace preset's apply (marketplace functions/workspacePresets.js):
    // its lines and result name ONE workspace's apps, so a switch wipes it to
    // its default `null` — every reader treats null as "nothing applied here
    // in this session". The public preset registry beside it is unscoped
    // (state.js).
    '_presetApply',
    // PageSlot minimize-to-dock: parked-app routes are tenant data (each entry
    // names another workspace's app surface). The wipe resets the list; the
    // PageSlot host sweep (canvas/components/PageSlot.js — wsId-stamped hosts)
    // unmounts the kept-alive DOM in the same switch, and MinimizedDock
    // re-seeds the NEW workspace's list from ITS OWN sessionStorage blob.
    '_minimizedSlots',
    // PageSlot pane ROUTES (WS-SWITCH-RESET-MISSES-SLOTS-AND-DRAFT-1,
    // 2026-10-23). `_canvasSlot` is the route the shell PageSlot opens in
    // place and `_canvasSlotSecond` is the split pane's — full tenant paths
    // ('/tickets/<id>', '/documents/<id>', '/u/<slug>', a module route with
    // its query), so an un-wiped pane re-mounted workspace A's page under
    // workspace B. They were in state.js's WORKSPACE_UNSCOPED_KEYS on the
    // claim that "the navigation the switch performs" closes them; it does
    // not — the switch's URL sync rewrites only the `/w/<org>/<ws-handle>`
    // prefix (functions/orgSwitchUrl.js) and keeps every route segment, and
    // the wsId host sweep (canvas/components/PageSlot.js) unmounts A's
    // kept-alive DOM only to have the Slot mount a FRESH host for the same A
    // route. Every sibling pane key below was already scoped, so the pane
    // kept its route while its own back/forward history was wiped under it.
    // NO PHASE-2 refetch pair is owed: a closed pane needs no data, and
    // onWorkspaceChange reads both keys into its surface-active snapshot
    // BEFORE the PHASE-1 replace (pinned by
    // __tests__/slotRouteTenantScope.test.js).
    '_canvasSlot',
    '_canvasSlotSecond',
    // PageSlot per-pane back/forward history + apps-rail flags — a history
    // stack names tenant routes (same reasoning as _minimizedSlots), and an
    // open rail must never greet the next workspace's first slot open.
    '_slotHistPrimary',
    '_slotHistSecond',
    '_slotRailPrimary',
    '_slotRailSecond',
    // The pane pin names a pane of THIS workspace's slot — a switch drops it.
    '_slotPinned',
    '_navActivePath',
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20): the GLOBAL NAVBAR SEARCH plane left
    // quarantine here. `navSearchResults` holds hits fanned out over the ACTIVE
    // workspace's tickets, channels, messages, events, notes, KB and files —
    // `workspaceProject.search` rpc plus the client-side people/docs/files
    // passes, every one of them tenant-filtered server-side.
    // `_navSearchGrouped` is `_groupResults(navSearchResults)`: THE SAME ROWS,
    // re-shaped, and the only thing IntranetAppHeader's dropdown actually
    // renders. `_navSearchActiveIndex` is a flat index INTO those rows.
    // ⛔ THE NAME LIED, AND state.js's OWN QUARANTINE COMMENT REPEATED THE LIE —
    // it cited `_navSearchGrouped` in its "some of these read as UI" list,
    // beside `_slotFullscreen` and `pickedElements`. It is a projection of
    // tenant rows, not a display toggle; the writer settles it in one line
    // (`_navSearchGrouped: _groupResults(all)` in the same `root.update({…})`
    // that writes `navSearchResults: all`). That comment is corrected in place.
    // ⭐ THE LEAK IS REACHABLE, NOT THEORETICAL: the dropdown kept offering
    // workspace A's tasks and notes after the switch, and Enter on a
    // still-highlighted row called `openInSlot` with A's href — the shell then
    // opened another tenant's ticket inside workspace B's slot.
    // Safe to wipe with NO PHASE-2 refetch pair: the correct post-switch value
    // of a search result set IS the empty one, and the next keystroke refills
    // it. No module-level memo guards these three — globalSearch's two caches
    // (`_docsSearchCache` / `_filesSearchCache`) are already workspace-KEYED, so
    // they self-invalidate rather than stranding a wiped key.
    // ⛔ `_navSearchActiveIndex` wipes to -1, its declared default, NOT to 0.
    // `_freshEmpty` passes scalars through, so this is already right — do not
    // "normalize" it with a WORKSPACE_SCOPED_OVERRIDES entry. A 0 would leave
    // NavSearchDropdown's `_navSearchActiveIndex === s._flatIndex` highlight
    // lit on the first row of the NEXT query before any key is pressed.
    // ⛔ THE SIBLING FLAGS STAY UNSCOPED ON PURPOSE. `navSearchQuery` is the
    // user's own typed text, and `_navSearchOpen` / `_navSearchLoading` are
    // transport. That is exactly why scoping alone is not the whole fix: an
    // UNSCOPED query text survives the switch unchanged, so globalSearch's only
    // in-flight guard (`root.navSearchQuery !== query`) still MATCHES after
    // A -> B and a reply issued in A would land in B. The race is closed
    // separately, by functions/sameWorkspaceWriter.js at the terminal write.
    'navSearchResults',
    '_navSearchGrouped',
    '_navSearchActiveIndex',
    // The ⌘K chips are tenant values too (a customer's name, an environment of
    // THIS fleet) — a switch empties them with the rows they filtered.
    '_navSearchChips',
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20): the tickets ACTIVITY plane left
    // quarantine here. `_activityData` is the reply to `workspaceProject.activity`
    // heatmap, and the server scopes that RPC by the caller's user_email AND the
    // workspace_id on the JWT — so it is this user's activity INSIDE THE ACTIVE
    // WORKSPACE, a different year-grid in every tenant. `_activitySelectedDate` +
    // `_activityDetails` are the drill-down: the day the user clicked and that
    // day's rows, which carry `source_table` / `source_id` / `metadata` naming
    // workspace A's tickets and notes outright.
    // ⭐ THE SURFACE IS NOT NICHE: `TicketsActivityHeatmap` is bare-keyed on the
    // HOME dashboard (pages/main.js) and inside MyViewMain, so after a switch the
    // first screen of the new workspace rendered the previous tenant's
    // contribution grid.
    // ⛔ THIS ONE NEEDED A PHASE-2 PAIR AND DID NOT HAVE ONE. The only fetch was
    // `onCreate`, and the shell does not tear the widget down on a tenant
    // boundary, so wiping alone would have left an empty year-grid until the user
    // navigated away and back — a leak fix that becomes a blank surface. The
    // re-derivation ships with this commit: ActivityHeatmap now refetches on a
    // workspace change, stamped per ELEMENT and keyed on the TENANT (never a
    // boolean latch, which is the memo class that strands a wiped key).
    '_activityData',
    '_activitySelectedDate',
    '_activityDetails',
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20), bucket C: the two keys the quarantine
    // comment in state.js named as "reads as UI". Both were re-checked against
    // their WRITERS, and only one of them was even a UI key.
    // ⭐ `pickedElements` IS NOT UI AND THE LEAK IS DISCLOSURE. It is the AI
    // assistant's attached context; a picked TICKET entry carries
    // `{ id, priority, assignee, epic, repository }` (TicketDetailModal's
    // AskAIBtn) — a tenant row plus a MEMBER'S EMAIL — and EventDetailModal
    // pushes calendar events the same way. `sendPrompt` snapshots the whole array
    // onto the outgoing turn as `context.pickedElements`, so a ticket picked in
    // workspace A was TRANSMITTED as context on a prompt typed in workspace B.
    // Its only two resets are the AI session change and the post-send clear;
    // neither fires on a tenant boundary. Wipes to `[]`, its declared default and
    // the "chip stack empty" state assistantSimone.js already documents — no
    // PHASE-2 pair is owed.
    // ⚠️ `preview` declares its OWN `pickedElements` on a DIFFERENT root
    // (preview/state.js). This registry does not reach it, and preview has no
    // workspace switch to leak across. Do not "finish" this by editing preview.
    'pickedElements',
    // `aiAttached` is `pickedElements`' twin and carries the SAME disclosure:
    // an attached EntityRef names a tenant row ('ref:record:vault.items/i-1'),
    // an attached canvas payload carries that board's node titles and statuses,
    // and simoneAiTransport puts both on the outgoing turn as
    // `context.attached`. Nothing else resets it — the attachments deliberately
    // survive a turn (see functions/aiAttached.js) — so the tenant boundary is
    // the only place they can be dropped.
    // ⛔ WIPES TO `{}`, not to `{ refs: [], canvas: null }`: `_freshEmpty`
    // (scopes.js) returns a bare object for an object default. That is why
    // `readAiAttached` is the single reader and normalizes both shapes; no
    // OVERRIDES entry is owed.
    'aiAttached',
    // `_aiConfidenceOpen` is keyed by CONVERSATION MESSAGE ID, and a workspace
    // switch changes the conversation entirely. It carries no tenant data (it
    // is a map of booleans), so this is hygiene rather than a disclosure fix —
    // but a stale entry can only ever pre-expand a row that no longer exists,
    // and wiping it costs nothing. Wipes to `{}`, which is both `_freshEmpty`'s
    // result for an object default AND the declared default, so no OVERRIDES
    // entry is owed.
    '_aiConfidenceOpen',
    // `_aiLevelOpen` — the level pill's disclosure map, keyed the same way and
    // wiped for the same reason as `_aiConfidenceOpen` just above.
    '_aiLevelOpen',
    // `_aiUndoError` — keyed by the created item's id in a thread of this
    // workspace; a switch leaves no other workspace's failure on a row.
    '_aiUndoError',
    // `_aiAskCompose` — keyed by the question card's id in a thread of this
    // workspace; a switch leaves no other workspace's open field or Change on a
    // card. Wipes to `{}`, its declared default: no OVERRIDES entry is owed.
    '_aiAskCompose',
    // ⛔ `_slotFullscreen` — RIGHT VERDICT, WRONG REASON IN THE DRAIN PLAN, which
    // argued it in as one "whose value is a slot ROUTE". It is not a route; it is
    // a TRI-STATE BOOLEAN (workspaceProjects.js says so): true/false record an
    // explicit header-toggle choice, null means "no choice this session". The
    // route is `_canvasSlot`.
    // THE REAL ARGUMENT IS THE FALLBACK ORDER: getSlotFullscreen reads this key
    // FIRST and only falls back to the persisted preference when it is null —
    // and that preference is ALREADY tenant-keyed ('slotFullscreenPref.' + wsId).
    // So a leftover `true` from workspace A SHADOWED workspace B's own saved
    // preference, including the admin-rail expanded default.
    // ⭐ The component's own contract already decides this: "close/minimize/
    // route-away paths reset to null — a close is not an opinion about the next
    // open." A switch is a stronger boundary than a route-away.
    // ⛔ WIPES TO null, NOT false. `false` is an EXPLICIT "not fullscreen" and
    // would beat B's saved expanded default — the exact artefact
    // workspaceProjects.js already has healing code for. The declared default is
    // null, so `_freshEmpty` is already right; do not add an OVERRIDES entry.
    // No PHASE-2 pair is owed: the tenant-keyed preference IS the re-derivation.
    '_slotFullscreen',
    // ─────────────────────────────────────────────────────────────────────────
    // WS-SWITCH-INCOMPLETE-1 drain step 6 — BUCKET B, THE OVERLAY POINTERS, and
    // it is ONE QUESTION ASKED SEVENTEEN TIMES. Answering it seventeen times is
    // how a rule drifts, so the rule is written here once and the whole bucket
    // lands as one diff. See __tests__/bucketBOverlayPointers.test.js.
    //
    // ⭐ THE RULE. An overlay or selection pointer is WORKSPACE-SCOPED when its
    // value is drawn from workspace-scoped data — a row, a row id, or a LABEL
    // that exists only in that workspace's data. It is UNSCOPED when its value
    // comes from a vocabulary the SOURCE defines — a mode, a dock position, a
    // tab, a boolean — because that vocabulary is byte-identical in every
    // workspace. Mechanically: take the writer, ask where the written value
    // comes from. A server row, or `root.<X>` where X is scoped ⇒ scoped. A
    // string literal in the source ⇒ unscoped. Free text the USER typed
    // (peopleQuery) stays unscoped — it is the user's intent,
    // not the tenant's data.
    //
    // ⭐ WHY THE WHOLE BUCKET OWES NO PHASE-2 PAIR: for a pointer the correct
    // post-switch value IS "closed", and every key below already declares a
    // closed default above (null). The wipe restores the
    // closed state by construction, so the module-memo hazard that gates
    // buckets A1 and E cannot apply here. No OVERRIDES entry is owed either.
    //
    // ⛔ FOUR NAMES THAT READ LIKE THIS BUCKET ARE NOT IN IT, and the reasons
    // are recorded so nobody "completes" it by adding them on the name alone:
    // `selectedDocument` — EVERY write in the tree sets it null, and
    // functions/pageContext.js says so itself ("No editor reads
    // `selectedDocument`, so the old bare update was dead"); it has readers and
    // no writer, so it cannot carry workspace A's data ⇒ bucket D, by deletion.
    // `_openThreads` — written on `host`, marketplace component state ⇒ D.
    // `target`/`targetSelected`/`targetOptions` — the Simone wsBridge family ⇒
    // bucket E, held until the live diff. `noGeneralTarget` — a preview/state.js
    // default with no writer ⇒ D.
    // ⛔ `_profileSlug`/`_profileViewed` DO carry tenant rows and are still not
    // here: they are a PAGE plane with its own onRemove teardown
    // (shared/pages/userProfile.js), which is a different argument from a
    // pointer with none. They get their own diff.
    //
    // Tenant ROWS held open by a pointer — the overlay must close on a switch.
    'selectedAnnouncement',
    'selectedEvent',
    'selectedNoteId',
    // The note being dragged onto the notes sidebar, and the row under it (a
    // folder key can be a folder this tenant created). Closed (null) is the
    // right post-switch value, the same as the pointers around it.
    '_notesDragId',
    '_notesDropKey',
    // The note opened beside the open one (a reference's split) names a tenant
    // row by id. Closed (null) after a switch, like the pointers around it.
    '_notesRef',
    // The share-to-chat picker names a tenant note, its search is UI state of
    // the page a switch leaves, and a send in flight names a tenant channel.
    // Closed / empty after a switch.
    '_noteShareTarget',
    '_noteShareQuery',
    '_noteShareBusy',
    'selectedPerson',
    // ⛔ FORM 3 — INVISIBLE TO A LITERAL GREP, which is why both of these read
    // as "no writer" in every census this ticket ran. PersonCard.js writes them
    // as `s.root.update({ [_selField(s.kind)]: s.name })`, where `_selField`
    // RETURNS THE KEY NAME. `selectedGroup` holds a team LABEL out of this
    // workspace's roster; `selectedRole` holds a role name out of
    // `root.roles.available`, and `roles` is itself scoped (drained at step 2),
    // so this is a pointer into a set this registry already wipes.
    // ⭐ selectedGroup's consequence is VISIBLE, not a stale filter chip:
    // pages/people.js prints it verbatim — `No members of "<selectedGroup>" are
    // in this organization's roster.` — so workspace A's team name was rendered
    // on workspace B's own empty state.
    'selectedGroup',
    'selectedRole',
    // Pointers at a row in THIS org's people roster. An email is a global
    // identity, but the OVERLAY it holds open is the current org's member card,
    // and _pendingDmEmail is a cross-page handoff that would otherwise open the
    // DM composer in the wrong tenant.
    '_personPopoverEmail',
    // Its stashed display name, and the party-by-email cache those cards read
    // — party rows are tenant facts of the org that resolved them.
    '_personPopoverName',
    '_partyByEmail',
    '_pendingDmEmail',
    'profileEmail',
    // A decision ROW id from the AI assistant's decision queue.
    '_decisionClarifyId',
    // ─────────────────────────────────────────────────────────────────────────
    // WS-SWITCH-INCOMPLETE-1 drain step 3 — BUCKET A2, THE REMINDERS COMPOSER.
    // Bucket A2's premise holds for all of these: a draft's correct
    // post-switch value IS its declared default, so no PHASE-2 refetch pair
    // is owed and the module-memo hazard cannot apply. What the premise does
    // NOT decide is WHICH SET each key joins, and two of the five did not go
    // where the bucket name suggested.
    //
    // ⭐ THE RULE THIS DOMAIN ADDS — FOLLOW THE VALUE FORWARD TO ITS SINK,
    // not only backward to its source. Step 6's overlay-pointer rule traces
    // BACKWARD and says free text the USER typed stays unscoped
    // (peopleQuery). Applied backward-only, `_reminderDraft`
    // is user-typed text and reads UNSCOPED — and that is wrong. The
    // difference is the SINK. A query's sink is a FILTER over the current
    // view: it survives a switch harmlessly, and wiping it would throw away
    // the user's own intent. A draft's sink is a WRITE into the ACTIVE
    // workspace — `submitReminderDraft` hands the text straight to
    // `createReminder`. A surviving draft does not look stale; it BECOMES
    // workspace B's row carrying workspace A's content. Same authorship,
    // opposite verdict.
    // ⭐ And it carries tenant data literally too: `applyReminderMention`
    // splices a person's first name out of THIS workspace's roster into the
    // text, and `createReminder` then fires a 'mention' notification to that
    // person's email address.
    '_reminderDraft',
    // ⭐ LOCKSTEP. Only ever written together with the draft above — the
    // submit clear, the failed-insert rollback and the row itself all treat
    // the two as ONE fact. Wipe the title alone and workspace B's composer
    // shows an EMPTY title with workspace A's due-date chip still rendered
    // (ReminderComposer hides that chip on `!_reminderDraftDue`, nothing
    // else), and the next reminder typed in B silently inherits A's date.
    // ⛔ A PARTIAL WIPE OF A LOCKSTEP PAIR IS WORSE THAN NO WIPE, because it
    // produces a state no writer can produce and it looks clean.
    '_reminderDraftDue',
    // ⭐ RECLASSIFIED unscoped → scoped, and the only reviewed key this diff
    // moves. It is not an independent input: it is the trailing '@token' OF
    // `_reminderDraft` — a DERIVED CURSOR INTO a value this commit wipes.
    // Left behind, the suggestion popover renders over an empty composer
    // against workspace B's roster; its only render gate is
    // `_reminderMentionQuery == null || no matches`. THE PRECEDENT IS THIS
    // TICKET'S OWN: step 5 part 2 scoped `_navSearchActiveIndex` for exactly
    // this reason — the cursor moves with the value it indexes.
    '_reminderMentionQuery',
    // ⭐ NOT A DRAFT AT ALL — A PER-WORKSPACE CAPABILITY GATE, and the
    // concrete user-visible leak of this domain. pages/reminders.js sets it
    // only on a 403 `forbidden_collection_not_granted` from the records
    // plane, for the ACTIVE workspace id, and `reminderEmptyText` then prints
    // "Reminders isn't enabled for this workspace" verbatim. Carry it across
    // and workspace B — where reminders ARE granted — tells the user its own
    // feature is switched off. Its declared default is `false`, so
    // `_freshEmpty` is already right; no OVERRIDES entry is owed. No PHASE-2
    // pair either: the page's declarative fetch re-runs with the new
    // workspace id and re-decides the gate itself.
    '_remindersLoadError',
    // ─────────────────────────────────────────────────────────────────────────
    // WS-SWITCH-INCOMPLETE-1 drain step 3 — BUCKET A2, THE BROADCAST COMPOSER,
    // and it holds the strongest leak this ticket has found: a CROSS-TENANT
    // WRITE, not a stale form. `openBroadcastComposer(post)` seeds the draft
    // from an announcement ROW and keeps its `id`. `saveBroadcastDraft` then
    // branches on exactly that field — `const operation = draft.id ? 'update'
    // : 'create'` — and issues `sdk.execute('workspaceProject.announcements',
    // 'update', { id: draft.id, payload })`. Open workspace A's release, switch
    // to workspace B, press Publish: the call carries WORKSPACE A'S ROW ID on a
    // session whose active workspace is B. Best case a confusing rejection;
    // bad case workspace A's published announcement is rewritten from B, with
    // `author` resolved from the CURRENT session. ⛔ Nothing else closes it —
    // the only clear paths are a successful save and closeBroadcastComposer,
    // and neither fires on a tenant boundary.
    '_broadcastDraft',
    // ⭐ THE ORPHAN RULE, AND IT IS NOW THE SAME RULE THREE TIMES ON THIS
    // TICKET, so it is named here once. A key whose meaning is only defined
    // RELATIVE to a value this wipe empties must be wiped WITH it, or the
    // switch leaves UI pointing at nothing: `_navSearchActiveIndex` (step 5
    // part 2) a cursor into wiped results, `_reminderMentionQuery` (above) a
    // cursor into a wiped draft, and this — an error BANNER about a wiped
    // draft, whose only render gate is its own presence
    // (`hide: !_broadcastSaveError`). THE MECHANICAL TEST: can this key's
    // value be READ without the value it describes? If not, it is a dependent,
    // and dependents move with their parent. It is written in lockstep at both
    // ends too — the open nulls it while seeding, the save writes the pair.
    '_broadcastSaveError',
    // Follows the retired built-in `bookmarksTag` (step 6; Bookmarks is the
    // App Store app system/bookmarks-app now) for the same reason:
    // `broadcastTags` builds the entire filter rail by counting `post.tag`
    // over `root.announcements` — scoped rows. In workspace B the carried tag
    // names nothing, `broadcastItemsForView` filters EVERY post out, and the
    // page reads "no news" in a workspace that has news, behind a chip that
    // cannot be satisfied. ⛔ ITS DEFAULT IS NOT FALSY — it is 'all', and
    // `_freshEmpty` returns it unchanged; no OVERRIDES entry is owed. No
    // PHASE-2 pair either: the vocabulary re-derives from `announcements`,
    // which this registry already wipes and the page already refetches.
    // ⛔ `_broadcastVisibleCount` IS DELIBERATELY NOT HERE, though
    // `setBroadcastTag` co-writes it. Co-write is evidence, never the verdict:
    // it has three independent writers, so it is not read as one fact with the
    // tag, and a carried page size only shows more of workspace B'S OWN posts.
    '_broadcastTag',
    // ── WS-SWITCH-INCOMPLETE-1 step 8 — BUCKET E, one argued diff (2026-08-21).
    // Thirty-two keys leave WORKSPACE_SCOPE_UNREVIEWED for here, by FAMILY and
    // on each family's WRITER + SINK. Thirteen more went to
    // WORKSPACE_UNSCOPED_KEYS (state.js) in the same diff, and what stays
    // quarantined is named there (31 dead defaults = bucket D, 4 livekit =
    // MEET-LIVE-CALL-SURVIVES-SWITCH-1). Every wipe value below is the declared
    // default through `_freshEmpty` and is a value SOME WRITER ALREADY PRODUCES
    // — no OVERRIDES entry is owed by this step. Live: 32 of 32 carried a
    // seeded marker across a real :4506 switch on the unmoved registry, both
    // directions. See __tests__/bucketETenantScope.test.js.
    //
    // ① TICKET COMPOSER — `ticketDraft` (the previous survivor control, drained
    // LAST of bucket A2 here) is the open ticket form: title/body/labels/
    // epicName/assigneeEmail of workspace A, and `_pendingDeps` holds REAL A
    // ticket ids that `_save` attaches as dependency links after create. Sink
    // rule, the `_broadcastDraft` shape again. Wipes to `null`, the value
    // `_close`/`_cancelEdit`/`resolutions.onCreate` already write (with
    // `selectedTicket: null, ticketEditMode: false` in the same patch).
    // `_commentDrafts` is the unsent comment HTML keyed BY TICKET ROW ID
    // (`_commentDraftKey(root)` = selectedTicket.id, TicketDetailModal); after a
    // switch an id collision in B restores A's text into B's composer and
    // `_postComment` POSTs it to B's ticket. Wipes to `{}`. (The marketplace
    // feed writes a key of the same NAME on its island host, not on root.)
    'ticketDraft',
    '_commentDrafts',
    // ② TICKET CACHE — `recentTickets` is up to 20 FULL ticket rows of workspace
    // A, kept after close by design (functions/ticketDetailModal.js header) and
    // read as a PEER of the scoped `tickets`/`myTickets` lists by
    // `_findTicketInRootLists` and chat's `##number` resolver — a B `##123` that
    // matches a cached A row opens (and `_save` PATCHes) the foreign ticket.
    // Wipes to `[]`; re-seeds on the next modal open, no PHASE-2 pair.
    'recentTickets',
    // ③ DOCUMENTS EDITOR — `editorDoc` carries a doc/note/KB ROW ID plus its
    // full body, and documents/functions/saveNote.js `_savePass` UPDATEs that
    // `doc.id` (or `fileNodeId`). It wipes to `null`, the close value every
    // Back/delete path writes. ⛔ THE AUTOSAVE RACE IS CLOSED BY THE WIPE
    // VALUE, not by a guard: `_savePass` reads `root.editorDoc` at pass time and
    // returns on `!doc`, and re-reads it LIVE after the request, so a timer that
    // fires after the switch writes nothing. (`editorMode` stays unscoped: a UI
    // view/edit lens — with `editorDoc` null neither EditorArea renders.)
    'editorDoc',
    // ④ CANVAS VERSION HISTORY — `_versions` is stamped `{ projectId, branch,
    // items[] … }` from workspace A's project, and `confirmRestore` writes to
    // that captured id: `restoreProjectVersion(cur.projectId, selected._id)` —
    // a destructive PROJECT write aimed by a stale carrier. Wipes to `null`;
    // `ensureVersionsLoaded` re-seeds from the panel's own render, so the
    // unscoped `_versionsOpen` tri-state can stay open harmlessly.
    '_versions',
    // ⑤ CHAT MESSAGE SEARCH — the bare `searchResults` is chat's
    // `workspaceProject.chat.search` hits (message bodies + channel ids of the
    // active workspace), NOT the navbar plane (`navSearchResults`, drained in
    // step 5). Wipes to `[]`, the value `searchMessages`' empty-query reset and
    // `openSearchModal`/`onClose` already write. `searchQuery` stays unscoped
    // under the UI-input rule; an old query over an empty result list is a
    // re-searchable form, not A's rows.
    'searchResults',
    // ⑥ ADD-APP / EXTENSION BUILDER — `_addAppProjectId` is the id of a
    // workspace-bound extension Project (created with `workspaceId`), and
    // functions/extensionSaveShare.js reads `workspaceId = activeWorkspaceId(root)`
    // (the NEW workspace) but `existingId = root._addAppProjectId` (the OLD
    // one's project), then `ai.updateExtension(existingId, { workspaceId, … })`
    // — a stale id after a switch RE-PARENTS A's extension into B and overwrites
    // its source. The cleanest cross-tenant write in this bucket. Wipes to
    // `null` (hydrateAddAppThread's give-up value). Its `_ax_*` thread below
    // hangs off it and re-hydrates on the next `selectAddAppExtension`.
    '_addAppProjectId',
    // The builder's "Open <app>" link points at workspace A's app (its page or
    // its thread); carried into B it would open A's app from B's builder. Wipes
    // to `null`, its declared default (the line it belongs to then shows none).
    '_addAppSaveLink',
    // The composer '+' menu's Build-app hand-off draft (forceBuildApp →
    // pages/add-app.js consume). A pending draft is a message INTO the
    // workspace it was typed in — carrying it across a switch would auto-send
    // A's prompt into B's build chat the moment /add-app opens there. Wipes
    // to `null` (the consumed value).
    '_addAppAutoSend',
    // Build mode is armed against the workspace whose apps it would build —
    // carrying it silently reroutes the FIRST send in workspace B into the
    // build pipeline. Wipes to `false`.
    '_aiBuildMode',
    // ⑦ PROFILE PAGE PLANE — split by CONTENT, not prefix (the other three
    // `_profile*` keys are unscoped in state.js). `_profileViewed` is a ROW
    // LIFTED FROM THE WIPED ROSTER: `_resolveLocal` resolves it out of
    // `peopleAll`/`people`, both registered above, so a surviving copy outlives
    // its own source list. `_profileActivity` is the `workspaceProject.activity`
    // heatmap — per-workspace rows keyed only by email. Both wipe to the values
    // the page's own onCreate/onRemove write (`null`, `{}`). PHASE-2 pair
    // (PROFILE-PAGE-NO-REHYDRATE-ON-SWITCH-1, fixed): the loaders moved out of
    // shared/pages/userProfile.js into shared/functions/userProfileData.js, so
    // onWorkspaceChange re-runs `hydrateUserProfile(root, { write: put })` when
    // `profileSurfaceActive` — the same hydration the page runs on mount. A
    // same-route switch no longer leaves the empty shell behind.
    '_profileViewed',
    '_profileActivity',
    // ⑧ `birthdays` — a PROJECTION of the roster (`person.birthday` over
    // `people`/`peopleAll`, no network): derived data follows its source, and
    // the source is registered above. Wipes to `[]`; onWorkspaceChange's roster
    // put re-derives it (`_deriveBirthdays`, the boot derivation shared).
    'birthdays',
    // ⑨ SIMONE CONVERSATION CORE (general drawer, prefix ''). SERVER-BACKED PER
    // MEMBER PER WORKSPACE: functions/_simone/sessions.js `pinWorkspace` sets
    // `ai.updateContext({ activeWorkspaceId })` before every list/get/create
    // and dispatch routes to `/core/agents/workspaces/:wsId/conversations`;
    // the registered `_aiThreads`/`assistantMessages` block above is the same
    // call already made ("aiChat threads are WORKSPACE-scoped", 2026-07-14).
    // `chatMessages` = the verbatim transcript; `sessions` = the thread index
    // (titles are A's first messages) with message buffers; `activeSessionId` =
    // a conversation id that 404s under B's wsId or continues A's thread;
    // `activeProcesses`/`runHistory` = sub-agent runs whose `agentId`s
    // team-and-agents matches against the CURRENT roster (a surviving batch
    // lights "working now" on B's agents). `currentAssistantId` is a per-turn
    // transport pointer, not rows — it moves by the ORPHANED-DEPENDENTS rule
    // (its meaning is an id in `chatMessages`, wiped in the same tick, or the
    // ReasoningPill points at a removed row). Wipe values `[]`/`{}`/`null` are
    // what `newSession`/`deleteSession`/`session_reset` already write. PHASE-2
    // pair: onWorkspaceChange re-runs `hydrateServerSessions('general')` when
    // the drawer was open or held a thread (`hadSimoneSessions`).
    'chatMessages',
    'sessions',
    'activeSessionId',
    'activeProcesses',
    'runHistory',
    'currentAssistantId',
    // ⑩ `_ax_*` — the SAME six keys under the add-app prefix (`k = '_ax_'`,
    // selected by `chatScope: 'addapp'`, mounted only by pages/add-app.js): the
    // per-EXTENSION thread, project-scoped to an extension that
    // `ai.listExtensions({ workspaceId })` resolved — workspace data one hop
    // out, hanging off `_addAppProjectId` (⑥). `selectAddAppExtension` already
    // writes `_ax_chatMessages: [], _ax_activeSessionId: null` as one patch —
    // the wipe mirrors it. No shell-side PHASE-2 pair: the pointer is nulled,
    // the page re-hydrates on its next select.
    '_ax_chatMessages',
    '_ax_sessions',
    '_ax_activeSessionId',
    '_ax_activeProcesses',
    '_ax_runHistory',
    '_ax_currentAssistantId',
    // ⑪ ASK-USER DECISIONS — `askUserDecisions` is full TICKET ROWS (JWT
    // active_workspace_id-scoped `sdk.tickets.list`, aiAssistant.js says so)
    // rendered as approve/reject cards; `_dismissedDecisionIds` is A's ticket
    // ids used as a SUPPRESSION FILTER in fetchAskUserDecisions — carried into
    // B it can hide B's cards on an id collision; `_decisionClarifyText` is the
    // reason text whose sink is `sdk.tickets.update(ticketId, …)` under the
    // registered `_decisionClarifyId` (the `_wsInviteEmail` shape), and
    // `_decisionClarifyIntent` is the form mode that is meaningless without
    // that id (ORPHANED DEPENDENTS). Wipe values `[]`/`[]`/''/`null` are the
    // component's own submit/cancel values. PHASE-2 pair: onWorkspaceChange
    // re-runs `fetchAskUserDecisions` when the panel was open or held rows.
    'askUserDecisions',
    '_dismissedDecisionIds',
    '_decisionClarifyText',
    '_decisionClarifyIntent',
    // ⑫ AI ACTION CHAIN — `_aiActionProposals` is produced by a dispatch pinned
    // to A's `activeWorkspaceId`, and ConfirmBtn runs `ai.executeActions(
    // actions)` against the THEN-CURRENT SDK context: a surviving proposal
    // executes A's actions inside B. `_aiAnswerPages` is the workspace agent's
    // rendered answer pages, stamped `__extensionApp: { projectId }` from A's
    // extension and persisted back as an A extension by extensionSaveShare.
    // `_aiActionError` (the card's error text) and `_aiActionResults` (the
    // executed results, written once, read by nothing today) move with their
    // producer — ORPHANED DEPENDENTS again: a stale error under B's next card,
    // and A's result rows waiting for a future reader. All wipe to `null`, the
    // value the card's backdrop/Reject/success paths already write.
    // ⑮ MAIL — the §3.2a setup gate and the §3.4 account surface
    // (MAIL-UI-CONNECT-SETTINGS-1). Every one of these is a TENANT FACT:
    // `mailSetup` carries workspace A's policy, provider list, admin flag and
    // mailbox ADDRESSES, and `mailAccounts` is the address list itself — left
    // standing across a switch, workspace B's /settings card and drawer paint
    // A's mailboxes until B's own read returns. The three transient keys
    // (loading / error / notice + the two busy latches) are ORPHANED DEPENDENTS
    // of those two: a 429 "an admin was notified" belongs to the org it was
    // sent in, and a save-in-flight latch keyed to A's account id would block
    // B's rows. Declared + owned by @symbo-ls/workspace-mail/state.js, so their
    // reset values are mirrored in WORKSPACE_SCOPED_OVERRIDES below — the shell
    // must not reach into another package's state file.
    'mailAccounts',
    // /admin/mail's cached accounts and their load state are one tenant read.
    // null re-arms its cache guard; false releases an old workspace's request
    // latch so the next workspace can issue its own read immediately.
    'mailAdminAccounts',
    'mailAdminAccountsLoading',
    'mailAdminAccountsError',
    '_mailReplySending',
    // The compose draft and its open flag: a half-written message names the
    // workspace it was written in — its recipients are that tenancy's people —
    // so it must not reopen over the next workspace. `openMailCompose` (the
    // §3.2a gate entry point) is the first writer of both.
    'mailComposeDraft',
    'mailComposeOpen',
    // The compose lifecycle around that draft (MAIL-UI-COMPOSE-1) — ORPHANED
    // DEPENDENTS of `mailComposeDraft`: a save/send error, an in-flight busy
    // latch, an open recipient menu and the Cc fold all describe A's draft,
    // which the wipe above just cleared. `mailOutbox` rows are A's queued
    // sends (subjects + recipient addresses) — tenant facts like the rest.
    'mailComposeSaving',
    'mailComposeSavedAt',
    'mailComposeError',
    'mailComposeBusy',
    'mailRecipientPicker',
    'mailOutbox',
    '_mailComposeCcOpen',
    '_mailComposeMenu',
    'mailSetup',
    'mailSetupLoading',
    'mailSetupError',
    'mailSetupNotice',
    'mailSetupBusy',
    'mailSettingsDraft',
    'mailSettingsBusy',
    'mailSettingsError',
    // The mail READ path (MAIL-UI-READ-1) — thread rows, envelopes, bodies and
    // the view/selection state are all tenant facts (subjects, addresses,
    // snippets of workspace A). The `_mail*` view latches are ORPHANED
    // DEPENDENTS keyed by A's thread/message ids. `_mailStream` stays OUT on
    // purpose: subscribeMailStream owns that handle's lifecycle (close +
    // re-key on drift) — a registry wipe would drop the reference without
    // closing the EventSource.
    'mailFolders',
    'mailThreads',
    'mailActiveAccountId',
    'mailActiveFolder',
    'mailActiveThreadId',
    'mailMessages',
    'mailBodies',
    'mailUnreadCounts',
    // The SHELL badge signal derived from the map above (architecture/MAIL.md
    // §3.6) — `navUnreadCounts.mail`, read by AppNavbarButton.UnreadBadge and by
    // the header envelope's dot. It drained from state.js's
    // WORKSPACE_SCOPE_UNREVIEWED to here on 2026-09-06, and the evidence is the
    // writer, not a switch diff: that quarantine's stated reason was "its only
    // writer is IntranetAppHeader, which nothing renders", and mail's stream
    // reducer (withMailNavUnread) is now a LIVE writer running at shell scope on
    // every route. What it writes is a TENANT FACT — workspace A's unread inbox
    // total, over A's accounts — so left standing it lights a red dot over B's
    // envelope for mail B cannot open. Scoped as a WHOLE key because the wipe is
    // per key: the map's other half (`chat`) still has no live writer, and `{}`
    // is the right reset for both halves. The stream re-opens on the tenant
    // re-key and its `mail.snapshot` frame refills the count for B, so the wipe
    // needs no PHASE-2 refetch pair.
    'navUnreadCounts',
    'mailSelection',
    'mailFilters',
    'mailSearchQuery',
    'mailThreadLoading',
    'mailThreadError',
    '_mailCursorId',
    '_mailMessageOpen',
    '_mailQuotedOpen',
    // Deep integrations (§3.7, MAIL-INTEGRATIONS-1) — the same ORPHANED-
    // DEPENDENT class: an in-flight integration act on A's thread, and the
    // link-menu pane/query latches over A's channel list.
    '_mailIntegrationBusy',
    '_mailLinkMenuView',
    '_mailShareQuery',
    '_aiActionProposals',
    // Page mode's availability is a fact about THIS workspace's installed apps
    // (the generated-board vocabulary = installed apps ∩ grants), so a switch
    // wipes it until the next workspace's vocabulary answers.
    '_aiBoardsAvailable',
    // The vocabulary itself is the same per-workspace fact — workspace B must
    // never offer starter chips built from A's installed apps.
    '_aiBoardVocab',
    '_aiAnswerPages',
    // ⑯ THE GENERATED BOARD (DESIGN-WL-ASSISTANT-MAIN-VIEW-1). `_aiBoard` is
    // built from workspace A's installed apps and A's data (its cards mount A's
    // module bodies, its blocks carry numbers the model read from A), and its
    // Pin / Save write INTO the active workspace — a surviving board would pin
    // A's widget into B. `_aiBoardHistory` holds A's prompts and specs (the
    // thread chips), `_aiBoards` A's saved-board records. `_aiBoardPreview` is a
    // UI mode over the CURRENT workspace's apps (the fixture is validated
    // against them) — a switch ends the look, like a close. Every late write of
    // a superseded request is already a no-op (`requestId`), so the wipe is the
    // whole story: each resets to its own declared default (null / [] / [] /
    // false), no OVERRIDES entry, no PHASE-2 refetch owed (the boards row
    // re-lists on its next mount).
    '_aiBoard',
    '_aiBoardHistory',
    '_aiBoards',
    '_aiBoardPreview',
    '_aiBoardExplicit',
    // The LIVE DECK — the same class as the board: built from A's installed apps,
    // its records blocks read A's rows, its Save writes INTO the active
    // workspace. A switch wipes it to its declared default (null / false / 0).
    '_aiDeck',
    '_aiDeckPreview',
    '_aiDeckPreviewIndex',
    // FLY MODE's session — A's pages, A's thread: a switch wipes it to null
    // (the stored session of the next workspace comes back on the canvas's
    // mount, functions/assistantFly.js assistantFlyRestore).
    '_aiFly',
    '_aiFlyWorkspace',
    '_phoneNavPanel',
    '_phoneNavError',
    '_phoneNavOperation',
    '_phoneComposerOpen',
    '_phoneNavHist',
    '_filesRailOpen',
    '_canvasRailOpen',
    '_moduleRailOpen',
    // The records answers are workspace A's rows (A's viewings, A's invoices)
    // and the block saves name A's boards: both wipe to `{}`, their declared
    // default, and a late answer for A drops itself (assistantRecordsEnsure
    // re-checks the workspace before it writes).
    '_aiRecords',
    '_aiBlockSaves',
    // The form requests name workspace A's saved rows (A's deal, A's task):
    // wipe to `{}`, their declared default.
    '_aiForms',
    // The broken app-row marks name workspace A's installed apps (A's CRM
    // version); workspace B may run another version of the same app, so a mark
    // from A must not hide B's row. Wipes to `{}`, its declared default.
    '_aiRecordRowsBroken',
    // The popover's dismissed-answer id names a message of workspace A's thread.
    '_aiAnswerPopoverDismissed',
    // The main thread's URL marker and its link state name a conversation of
    // workspace A. The reconcile reads this wipe: the open thread's `?ai=` is
    // removed from the address bar, a link that was never open is read again.
    '_aiThreadUrlId',
    '_aiThreadLink',
    // The home Brief's AI answer speaks about workspace A's signals; a switch
    // wipes it to `null` and the new workspace's signals ask again (a late
    // answer for A drops itself: the ask's key names the workspace).
    '_homeSummaryAi',
    // The home's last Ask / Create mode is workspace A's own (it carries A's
    // id, and homeViewGroupSelect already starts over for any other id). A
    // switch wipes it to `null`, its declared default; B's first menu pick
    // starts B's.
    '_homeViewRecent',
    // A module page's composer latch names workspace A's module and page; a
    // switch wipes it to `null`, its declared default, and the composer shows.
    '_moduleComposerHidden',
    // The first-run answer says whether workspace A is activated and how far
    // its four steps are; carried into B it would offer B A's steps. Wipes to
    // `null`; B's start screen asks again, and a late answer for A drops itself
    // (the read re-checks the workspace before it writes).
    '_flyFirstRun',
    // The builder's cost estimate says what workspace A can pay and whether A's
    // first-build waiver covers the turn; carried into B it would price B's
    // build with A's balance. Wipes to `null`; B's composer asks again, and a
    // late answer for A drops itself (it must still be the newest ask, for the
    // same place, when it lands).
    '_addAppEstimate',
    // The setup job, its first thread and its first build name workspace A;
    // carried into B they would show A's steps over B's builder. Wipes to
    // `null`; B's builder asks again, and a late answer for A drops itself (the
    // read re-checks the workspace before it writes).
    '_workspaceSetup',
    // The build board names workspace A's steps and links; carried into B it
    // would show A's board over B's start screen. Wipes to `null`; B asks again
    // (a 404 there is "no board"), and a late answer for A drops itself (the
    // read re-checks the workspace before it writes).
    '_pobBuild',
    // ⑰ THE HOME SIGNALS (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1). `_homeSignals`
    // holds workspace A's counts (A's overdue follow-ups, A's unread mail) and
    // the providers A has installed; carried into B it would greet B with A's
    // numbers — and the contract says the cache is PER WORKSPACE. Wipes to
    // `null`, its declared default; the greeting head's own pass refills it for
    // B (its `stateDeps` read the workspace id), and every late answer of A's
    // pass drops itself (the collector re-checks the workspace before a write).
    '_homeSignals',
    '_aiActionError',
    '_aiActionResults',
    // ⑬ MEET ANALYSIS LATCH — `analyzeError` is the analysis-failure text for
    // `activeRoomId`, and BOTH auto-analyze kicks (meet/pages/index.js,
    // TranscriptPage onCreate) SUPPRESS while it is set: A's error blocks the
    // analyze for B's room. It is the error banner of the registered
    // `analysis`, so it moves with it (the `_approvalError` precedent). Wipes
    // to `null`, the Analyze/Regenerate button's own reset value.
    'analyzeError',
    // ⑮ SITE BUILDER — the site on screen, its status, the running write's
    // label, its draft mark, the page it shows and the last AI project write
    // all name THIS workspace's projects. A switch leaves the builder, so each
    // wipes to its cold-boot default (null, null, null, false, null, null).
    '_previewSite',
    '_previewSiteStatus',
    '_previewSiteStep',
    '_previewSiteDraft',
    'activePage',
    '_aiProjectWrite'
]);
const $37afbd444df360a1$export$bb5fb09c0a882408 = {
    _workspaceActivation: null,
    // Cold-boot default above is `[]`; the switch-reset has always used
    // `null` instead, mirroring feedItems' "not fetched this session yet"
    // sentinel convention (no current consumer reads myTickets' null-vs-[]
    // distinction, but preserved byte-identical rather than assumed-safe).
    myTickets: null,
    // WS-SWITCH-INCOMPLETE-1 (2026-08-20): cold-boot default above is
    // `{ available: [], byUser: {}, version: 0 }`, but the switch-reset MUST be
    // `null`, and this is the one override whose value changes behaviour rather
    // than just shape. `_freshEmpty` (scopes.js) collapses EVERY object to `{}`,
    // so a "shaped empty" override is impossible here and would be a false edit
    // that merely looks like a safeguard. It also would not be the right value:
    // TWO independent call sites restore the full shape with the idiom
    // `root.roles || { available: [], byUser: {}, byUserMemberId: {}, version: 0 }`
    // — loadPrivateData `_loadRoles` and PersonCard's optimistic role write. A
    // bare `{}` is TRUTHY, so it silently DEFEATS both fallbacks and leaves the
    // object permanently missing the fields they exist to restore. `null` is
    // falsy, so both fire as designed, and `null` is already the state every
    // consumer handles — it is the pre-`_loadRoles` value AdminChrome documents
    // ("`s.root.roles` stays undefined until `_loadRoles` resolves"). Every reader
    // found in packages/** guards with `root?.roles?.X || {}` / `|| []` or
    // `root.roles && root.roles.X`.
    roles: null,
    // Cold-boot default above is `{}` (meet/pages/index.js keys it by room
    // id: `waitingRoom[roomId]`); the switch-reset has always used `[]`
    // instead. Pre-existing type mismatch, not introduced by this registry —
    // preserved as-is rather than changed as a drive-by fix.
    waitingRoom: [],
    // Declared + owned by @symbo-ls/workspace-mail/state.js (a shared library),
    // so the shell's own stateDefaults carry no entry and the wipe would write
    // `undefined` — which v3.14's schema check refuses. Mirrored here, exactly
    // as the analytics keys below are; keep in sync with that file.
    mailAccounts: [],
    mailAdminAccounts: null,
    mailAdminAccountsLoading: false,
    mailAdminAccountsError: null,
    mailComposeDraft: null,
    mailComposeOpen: false,
    mailSetup: null,
    mailSetupLoading: false,
    mailSetupError: null,
    mailSetupNotice: null,
    mailSetupBusy: null,
    mailSettingsDraft: {},
    mailSettingsBusy: null,
    mailSettingsError: null,
    mailComposeSaving: false,
    mailComposeSavedAt: null,
    mailComposeError: null,
    mailComposeBusy: null,
    mailRecipientPicker: null,
    mailOutbox: [],
    _mailComposeCcOpen: false,
    _mailComposeMenu: null,
    mailFolders: {},
    mailThreads: {},
    mailActiveAccountId: null,
    mailActiveFolder: 'inbox',
    mailActiveThreadId: null,
    mailMessages: {},
    mailBodies: {},
    mailUnreadCounts: {},
    mailSelection: [],
    mailFilters: {
        unread: false,
        starred: false,
        attachments: false,
        from: null,
        label: null
    },
    mailSearchQuery: '',
    mailThreadLoading: null,
    mailThreadError: null,
    _mailCursorId: null,
    _mailMessageOpen: {},
    _mailQuotedOpen: {},
    _mailIntegrationBusy: null,
    _mailLinkMenuView: 'actions',
    _mailShareQuery: '',
    // Declared + owned by chat/state.js — keep in sync with it if its
    // defaults ever change.
    threadOpen: false,
    threadParentId: null,
    // Keys with NO cold-boot default declaration (written ad-hoc by their
    // feature surfaces) — the wipe needs an explicit reset shape or it would
    // write `undefined` (2026-07-30 isolation-audit additions).
    filesSelectedIds: [],
    filesViewer: null,
    // Analytics package keys — declared in @symbo-ls/workspace-analytics/
    // state.js (merged via sharedLibraries), so the shell's own
    // stateDefaults carry no entry for them; explicit reset shapes keep the
    // wipe from writing `undefined` (2026-08-08 analytics-merge audit).
    _analytics: null,
    _analyticsSessions: null,
    _analyticsActiveUsers: null,
    _analyticsServerSource: null,
    _analyticsSampleSize: 0,
    _analyticsProjectKey: null,
    _analyticsParams: null,
    _wsaWeekly: null,
    _wsaBugs: null,
    _wsaOpenTasks: null,
    _wsaActive: null,
    logsUsers: [],
    logsSessions: [],
    logsEvents: [],
    logsNetwork: [],
    logsVerbose: [],
    logsBugs: [],
    logsSessionDetail: null,
    logsSessionEvents: [],
    _logsSessionId: null,
    _logsCountry: null,
    _logsUser: null,
    // WS-ANALYTICS-FAMILY-SPLIT-UTC-TOTALS-1 feeds — null is each feed's own
    // "not read yet" sentinel (analytics/state.js), so the honest-state rule
    // (only a positively read feed prints a number) holds across a switch.
    _analyticsTotals: null,
    _analyticsTotalsError: null,
    _analyticsPages: null,
    _analyticsReferrers: null,
    _analyticsRollupTz: null,
    // WS-ANALYTICS-UTM-CAMPAIGNS-UI-1 feeds + drill filters — null is each
    // feed's "not read yet" sentinel and each filter's "no filter"
    // (analytics/state.js).
    _analyticsCampaigns: null,
    _analyticsCampaignsError: null,
    _analyticsDaily: null,
    _analyticsDailyError: null,
    _logsUtmSource: null,
    _logsUtmMedium: null,
    _logsUtmCampaign: null,
    _logsVisitor: null,
    _wsaTotals: null,
    _wsaTotalsError: null,
    // "Not loaded" sentinel — loadWorkspaceApps repopulates in the activation
    // chain; `[]` would read as "loaded, none installed".
    workspaceApps: null,
    // Same sentinel rationale — loadWorkspaceProject repopulates; `{}` would
    // read as "loaded, module-less workspace" and skip module activation UI.
    workspaceProject: null,
    // Recomputed from the new workspace's panels by the widget resync.
    _homeHiddenWidgets: null,
    // Re-resolved from the NEW workspace's prefs row / scoped cache by the home
    // page's own switch hook (pages/main.js `_resolveBootWidgetColors`).
    _homeWidgetColors: null,
    // Transient palette — closed by the switch, never carried.
    _homeColorPicker: null,
    // Re-resolved from the NEW workspace's prefs row / scoped cache by the
    // board's reconcile (pages/main.js `_reconcileHomeBoard`).
    _homeLayout: null,
    // A drag never survives a switch.
    _homeDragId: null,
    financials: null,
    _wsMembers: null,
    _projectsForActiveOrg: null,
    // Tickets board prefs (per-workspace since 245f9761): latch re-arms so the
    // seed re-runs for the new workspace; value keys clear to "unseeded" (the
    // seed writes real defaults from the new workspace's storage blob).
    _ticketsPrefsSeeded: false,
    _ticketsFreeform: null,
    _colCount: null,
    _hiddenCols: null,
    _excludedCols: null,
    _showDrafts: null,
    // WS-SWITCH-INCOMPLETE-1 step 3, bucket A2 (2026-08-21): the two modal
    // drafts wipe to the value their CLOSE path writes, not to `_freshEmpty`'s
    // `{}` of their shaped default. `closeNewChannelModal` and
    // `closeNewRoomModal` both write `null`; every reader already handles it;
    // `{}` is a shape no writer produces. Argued beside their registration.
    newChannelDraft: null,
    newRoomDraft: null,
    // WS-SWITCH-DRAIN-EPICSTREE-FILEPREVIEWS-1. `epicsTree` is declared `null`
    // in tickets/state.js (merged via sharedLibraries, so no entry here); its
    // readers all guard `root?.epicsTree || []` / `?.length`, and `null` — not
    // `[]` — is what lets loadEpicsTree's `!root.epicsTree?.length` refetch for
    // the new tenant. The two file caches are declared nowhere (first-write
    // keys of files/functions/index.js); every reader does
    // `(root._fileThumbs || {})[id]`, so `{}` is the value they expect.
    epicsTree: null,
    _filePreviews: {},
    _fileThumbs: {},
    // WS-SWITCH-INCOMPLETE-1 leg 14. The three pipeline drag pointers, declared
    // in `packages/pipeline/state.js` (merged via the consuming app's context,
    // so no entry in this file's stateDefaults). `null` is not a guess: it is
    // the exact value `pipelineDragEnd` already writes to all three when a drag
    // finishes, and the value `pipeline/state.js` declares — so the wipe hands
    // every reader a value it has already met, and `pipelineDragOverCard`'s
    // `root.pipelineDragId === id` / `root.pipelineDropBeforeId !== id`
    // comparisons behave as they do between drags. `{}` would be a shape no
    // writer in that library produces.
    pipelineDragId: null,
    pipelineDragOverStage: null,
    pipelineDropBeforeId: null,
    // WS-UNDECLARED-KEYS-DRAIN-BATCH-1 (2026-08-21) — five census-backlog keys,
    // declared in state.js's WORKSPACE_SCOPED_KEYS in this same commit. None has
    // a cold-boot default anywhere, so each needs an explicit reset shape here or
    // the wipe would write `undefined`. Each value is the one its own readers
    // already handle:
    //   `projectMembers` — every reader guards `s.root?.projectMembers || []` /
    //     `!s.projectMembers || s.projectMembers.length === 0`, and `null` (not
    //     `[]`) matches its declared PROJECT-scope siblings `project`,
    //     `projectComponents`, `projectPages`, `projectState`, which are all
    //     `null`. It also keeps "never fetched" distinct from "fetched, empty".
    //   `_mcpConnectorDraft` / `roomSettingsDraft` — wipe to the value their own
    //     CLOSE path writes, the same argument `newChannelDraft` /`newRoomDraft`
    //     carry above: both overlays close with `{ …Draft: null }`, and
    //     RoomSettingsModal's seed guard is literally `if (s.root
    //     ?.roomSettingsDraft) return`, so a truthy `{}` would permanently
    //     suppress the re-seed. `{}` is a shape no writer produces.
    //   `activityScoring` — the fetch transform always writes an ARRAY of rows
    //     and both readers do `(s.root?.activityScoring || [])`, so `[]` is the
    //     shape they expect; the table renders its empty state until the new
    //     workspace-project's rows land.
    //   `_usageTurnStats` — read once as `root?._usageTurnStats || {}`; `null` is
    //     the pre-fetch value that reader already handles, and it keeps the
    //     `{ error }` degrade shape from surviving into the next workspace.
    projectMembers: null,
    _mcpConnectorDraft: null,
    activityScoring: [],
    _usageTurnStats: null,
    roomSettingsDraft: null,
    // Marketplace installed set — hydrate latch re-arms; the list empties.
    installed: [],
    _installedHydrated: false,
    // WS-ROOT-STATE-FORM2-WRITE-HOLE-1 (2026-08-30) — Form-2 census drain,
    // batch 2; declared in state.js's WORKSPACE_SCOPED_KEYS in this same
    // commit. None has a cold-boot default, so each needs its reset shape here.
    //   `_agents` — `null`, NOT `[]`: yourAgents.js reads
    //     `Array.isArray(root._agents)` as "loaded", so `[]` would be a FALSE
    //     ZERO ("loaded, no agents") — the exact ambiguity FALSE-ZERO-1 removed
    //     at the producers. `null` re-arms every consumer's fallback and the
    //     seed roster (`_agents(root)` in team-and-agents falls back to
    //     `_seedAgents`). All readers guard `Array.isArray(...)`.
    //   `_agentsLoaded` — `false` re-arms the three shared-gate producers for
    //     the new org (home _loadHomeAgentRoster re-runs from the org-change
    //     onUpdate; the canvas + simone producers re-run on their next mount/
    //     touch — both re-read the gate every call).
    //   `_agentsError` — a failure text about the PREVIOUS org's fetch must not
    //     render `!` badges over the new org's widgets.
    //   `_agentAssignmentsLoaded` — `false`, same re-arm as `_agentsLoaded`
    //     (team-and-agents onCreate re-loads).
    //   `agentAssignmentsByAssignee` / `agentAssignmentsByAgent` — `null`; every
    //     reader guards (`root?.agentAssignmentsByAssignee?.[id]`,
    //     `{ ...(root.agentAssignmentsByAssignee || {}) }`), and the loader
    //     rewrites BOTH maps wholesale, so `null` never survives a load.
    //   `_integrationHub` — `null` is the pre-fetch value `_hubLoaded()` already
    //     distinguishes ("loading vs empty", pages/admin/integrations.js); every
    //     admin page refetches it in onCreate.
    _agents: null,
    _agentsLoaded: false,
    _agentsError: null,
    _agentAssignmentsLoaded: false,
    agentAssignmentsByAssignee: null,
    agentAssignmentsByAgent: null,
    _integrationHub: null,
    // `_adminLogsError` — `false`: the read has not failed. The one reader
    // (pages/admin/logs.js) tests it for truth, and the loader writes it on
    // every read, so a wiped `false` shows the list or its empty line again.
    _adminLogsError: false
};

});




parcelRegister("f18a7", function(module, exports) {

$parcel$export(module.exports, "buildModuleDataBridge", () => $aeed47dc480e006a$export$fd5dfafc509409c7);
// moduleDataBridge.js — capability-scoped data access for workspace MODULES
// (manifest v2). Generalization of extensionDataBridge.js for the module
// plane: instead of an extension's declared-entity list, the gate is the
// module's server-granted `capabilities` (workspace.settings.workspaceModule
// .capabilities — data, written by the workspace owner/admin, never by the
// module itself).
//
// The loader (workspaceProjects.js) registers the built bridge as the
// `moduleData` context function when a capability grant is present, so module
// functions reach data via `el.call('moduleData', from, op, args)` — never
// through raw fetch / el.sdk (the publish-time module audit forbids those).
//
// Client-side this is defense-in-depth ONLY — the server enforces the same
// grant on every route it guards; this bridge just fails fast + keeps honest
// modules honest:
//   1. Only data ops (list/get/create/update/upsert/remove + subscribe).
//   2. Every entity is FORCED into the `workspaceProject.*` namespace — a
//      module can never reach organization.*, admin.*, auth.*, payment.*, ….
//      (`orgIntegration` + `recordCollections`/`fieldDefs` below are the
//      three deliberate, narrowly-scoped exceptions — see each block.)
//   3. The generic `records` store is collection-gated: args.collection must
//      be in capabilities.records.collections, ops in capabilities.records.ops.
//   4. Entities outside the grant are rejected.
//
// ── `orgIntegration` + `recordCollections`/`fieldDefs` (tickets/workspace.md
// "module-plane `integrations` capability — make 'Data' an installable
// catalog app", DECIDED 2026-08-06, Nika: "BUILD IT, server-authoritative —
// same trust model as the aiFunctions and records decisions") ─────────────
//   - `orgIntegration` / op 'call' ONLY, row-addressed (`args.idOrSlug`
//     required — never the body-addressed `/call` route, which has no
//     module-grant escape hatch server-side). Requires
//     `capabilities.integrations = { kinds, capabilities }` on the grant;
//     `args.capability` must be in the granted capability set (or the grant's
//     `capabilities` is the wildcard `'*'`). The KIND itself is checked
//     SERVER-SIDE only (OrgIntegrationsController.callByIdOrSlug +
//     AccessResolver.isIntegrationCallGranted) — the client can't know a row's
//     kind from `idOrSlug` alone without a round trip, so this bridge is
//     defense-in-depth on the capability name only; the server is the actual
//     authority, exactly like every other entity here.
//   - `recordCollections` / `fieldDefs`, ops 'list'/'get' ONLY (read-only
//     schema metadata, never row data) — gated on the module holding ANY
//     `capabilities.records` grant at all (not a specific collection; these
//     two entities are already `requireWorkspaceMember`-readable server-side
//     for every member regardless of the records collection allowlist — see
//     server/src/domains/recordCollections + fieldDefs routes — so this bridge
//     only needs to establish "this module IS a records-capable module",
//     letting a Data-catalog app enumerate collections/fields it wasn't
//     statically granted row access to, per the ticket's proposed shape).
//     A `capabilities.records.collections` array containing the literal
//     string `'*'` is also accepted as "records-capable" here — NOTE this is
//     ONLY a schema-enumeration signal for these two meta entities; it does
//     NOT (yet) unlock row data for arbitrary collections on the `records`
//     entity below — the server's `resolveGrantedRecordCollections` has no
//     wildcard support for actual row access, so granting it here would be a
//     client-side promise the server can't keep. A full row-data wildcard is
//     explicitly left as follow-up work, not silently half-built.
//
// ── `analyzed` — READ-ONLY site analytics for TRUSTED modules (Shaker
// program, CONTRACT §8: a BI app draws visits → view_item → add_to_cart →
// begin_checkout → purchase). The fourth deliberate exception to the
// `workspaceProject.*` namespace, and the narrowest one:
//     el.call('moduleData', 'analyzed', 'totals',     { since?, tz?, projectId?, excludeProjectId? })
//     el.call('moduleData', 'analyzed', 'funnel',     { steps, since?, until?, tz?, projectId?, excludeProjectId? })
//     el.call('moduleData', 'analyzed', 'listEvents', { message, since?, projectId?, excludeProjectId?, limit?, offset?, order? })
//   → sdk.execute('analyzed', 'totals' | 'funnel' | 'listEvents', { filter[, options] }).
// The BRIDGE sets the scope, never the module:
//   - the CALLER must be an installed module of this workspace whose ref
//     tier is 'trusted' (moduleIdOf(this.context) → settings.workspaceModule
//     or a settings.workspaceApps[] entry). An unidentified caller — shell
//     code, a read-only verb's proxied context, a sandboxed or uninstalled
//     module — is refused;
//   - `workspaceId` is the TAB's workspace, always. A module that names any
//     other workspace is refused, never silently re-pointed: the server
//     honours an explicit workspaceId for every workspace the member belongs
//     to, so a forwarded id would read another tenant's visitors;
//   - `family` is 'projects', always — visitors of the workspace's published
//     projects. The team's own shell telemetry ('workspace' family: who used
//     the shell, which pages) is not a module's to read;
//   - listEvents needs one exact `message` (a named event such as
//     'purchase') and reads info captures only (logType 'log') — never a
//     site's console lines or bug reports;
//   - only the filter keys named above reach the SDK, with plain values; any
//     other op (ingest, ingestPublic, sessions, users, bugs, pages, …) and any
//     other key is refused.
// The server applies its own member gate on top (the workspace pair the
// member may read; projectId narrows inside it), so this entry only narrows.
// It never caches: a period switch re-reads, and reads are rare (one per
// board mount + period). Inside a verb the manifest marks `readOnly`
// (moduleReadOnlyCall.js) it is refused like every read that is not a record
// or schema read — that caller's context is a proxy, so its module cannot be
// named.
// ── `assistants` — the site-assistant settings of the CALLER's projects, for
// a TRUSTED module that holds `capabilities.assistants === true` (the
// system/assistants-app: a small dash for the AI assistant of a Symbols
// project, Nika 2026-10-22: "make it configurable from workspace"). The fifth
// deliberate exception to the `workspaceProject.*` namespace:
//     el.call('moduleData', 'assistants', op, { id, ...rest })
//       op: list | get | update | revisions | rollback | usage | resetCounter | testChat
//   → sdk.execute('assistants', op, args).
// The gate here is narrow on purpose:
//   - the CALLER must be an installed module of this workspace whose ref tier
//     is 'trusted' (moduleIdOf(this.context), as `analyzed` reads it) AND whose
//     own ref grants `capabilities.assistants === true` (data on the workspace
//     record, written by the owner/admin — never by the module). Another app's
//     grant never counts: the check reads the caller's ref, not the union;
//   - only the eight ops above reach the SDK; any other op is refused.
// The bridge does NOT scope the data: an assistant belongs to a Symbols
// PROJECT, not to the tab's workspace. The backend (the Fly control Worker
// behind the SDK service) checks the signed-in Symbols user and that user's
// role on the assistant's project on every call — a viewer reads, an owner /
// admin writes — so no workspace id is added and none is honoured. Inside a
// read-only verb (moduleReadOnlyCall.js) it is refused like every non-record
// read.
// ── `growth` — the Symbols sign-up funnel (fly docs/FUNNEL.md §3), READ-ONLY,
// for the Growth app (system/growth-app, Nika 2026-10-23: "make a new one into
// the appstore and also chain it to system org so we see the analytics in our
// workspace"). The sixth deliberate exception to the `workspaceProject.*`
// namespace:
//     el.call('moduleData', 'growth', 'funnel',   { since?, until?, tz?, groupBy? })
//     el.call('moduleData', 'growth', 'accounts', { stage?, since?, until?, tz?,
//                                                   limit?, offset?, order?, sort? })
//   → sdk.execute('growth', 'funnel',   { filter })
//   → sdk.execute('growth', 'accounts', { filter, options })   (GrowthService)
// The gate is narrow on purpose:
//   - the CALLER must be an installed module of this workspace whose ref tier
//     is 'trusted' AND whose owner is `system` — a curated catalog app, the
//     rule the install flow (shared workspaceModuleRef.js) and the server
//     (WorkspaceAppManifest deriveAssistantsCapability) already apply to the
//     `ai` / `assistants` asks. A customer's own same-org module is trusted
//     too and is refused here: a Symbols-team member who opens that workspace
//     must not hand that module our funnel or our accounts list;
//   - only the two reads reach the SDK, with the named keys only and plain
//     values (`limit` capped); any other op or key is refused. The manifest
//     asks for no capability: the app holds no records grant, no AI grant.
// The bridge does NOT scope the data: the funnel belongs to the Symbols system
// org, not to the tab's workspace. The server answers a member of the system
// org only (requireSymbolsSystemOrg) and refuses everyone else with 403, which
// the app shows as "for the Symbols team". No workspace id is added and none
// is honoured. It never caches (a range switch re-reads). Inside a read-only
// verb (moduleReadOnlyCall.js) it is refused like every non-record read.

var $1X0Je = parcelRequire("1X0Je");

var $go87e = parcelRequire("go87e");

var $bunII = parcelRequire("bunII");
const $aeed47dc480e006a$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $aeed47dc480e006a$var$recordsEntryKey = (...args)=>(0, $1X0Je.default).functions.recordsEntryKey(...args);
// Data ops a module may invoke. Everything else (rpc, auth, custom procs) is
// denied. Mirrors the extension bridge's verb set the sdk adapter supports.
const $aeed47dc480e006a$var$ALLOWED_OPS = new Set([
    'list',
    'get',
    'create',
    'update',
    'upsert',
    'remove',
    'subscribe'
]);
// BOOT-RESHUFFLE F6 (records stampede): a module board mounts N widgets that
// each issue the SAME records read at the same tick — measured 13×
// /core/workspaces/<ws>/records in one boot, saturating the browser's 6
// HTTP/1.1 connections to the dev API and queueing everything else behind
// them. Identical READS (list/get, promise-style) within a short window
// collapse onto one in-flight request; writes invalidate their collection's
// window so a re-list after a mutation always sees the new row. Keyed by
// workspace scope so a switch can never serve the previous tenant's rows.
const $aeed47dc480e006a$var$_READ_TTL_MS = 5000;
const $aeed47dc480e006a$var$_readCache = new Map() // key → { at, promise }
;
const $aeed47dc480e006a$var$_readKey = (root, entity, operation, args)=>{
    try {
        const ws = String(root?.workspace?.id ?? root?.workspace?._id ?? root?.jwtClaims?.active_workspace_id ?? '');
        return ws + '|' + entity + '|' + operation + '|' + JSON.stringify(args || {});
    } catch (_) {
        return null // unkeyable → no dedupe
        ;
    }
};
const $aeed47dc480e006a$var$_sweepReadCache = ()=>{
    if ($aeed47dc480e006a$var$_readCache.size < 200) return;
    const cutoff = Date.now() - $aeed47dc480e006a$var$_READ_TTL_MS;
    for (const [k, v] of $aeed47dc480e006a$var$_readCache)if (v.at < cutoff) $aeed47dc480e006a$var$_readCache.delete(k);
};
// Strip the namespace if the caller already wrote one, so 'workspaceProject.x',
// 'x', and a stray 'public.x' all normalize to the bare entity name we gate on.
const $aeed47dc480e006a$var$_bareEntity = (from)=>{
    const s = String(from || '').trim();
    if (!s) return '';
    const dot = s.lastIndexOf('.');
    return (dot >= 0 ? s.slice(dot + 1) : s).toLowerCase();
};
// Read-only ops the recordCollections/fieldDefs meta entities permit from a
// module — never create/update/remove (schema mutation stays owner/admin-only
// through the admin UI's direct SDK path, never the module bridge).
const $aeed47dc480e006a$var$READONLY_META_OPS = new Set([
    'list',
    'get'
]);
// Best-effort workspace id off the live root — same lookup `_readKey` above
// uses for the records dedupe cache; reused here so orgIntegration.call +
// the meta reads default `workspaceId` without every module having to thread
// it through by hand.
const $aeed47dc480e006a$var$_rootWsId = (root)=>root && root.workspace && (root.workspace.id || root.workspace._id) || undefined;
// Org scope for orgIntegration dispatch — same resolution chain the calendar
// bridge uses. The sdk's callOrgIntegrationCapability REQUIRES orgId
// (sdk@3.14.677 enforces it client-side); a module must never supply its own
// org, so the bridge stamps it from root state (caught live on dev
// 2026-08-07: every Track B search threw "orgId is required").
const $aeed47dc480e006a$var$_rootOrgId = (root)=>root?.jwtClaims?.workspace_org_id || root?.org && (root.org.id || root.org._id) || undefined;
// ── analyzed (see the header) ──────────────────────────────────────────────
// Module op (lower-cased) → the SDK op and the filter keys a module may send.
const $aeed47dc480e006a$var$ANALYZED_READS = {
    totals: {
        op: 'totals',
        keys: [
            'since',
            'tz',
            'projectId',
            'excludeProjectId'
        ]
    },
    funnel: {
        op: 'funnel',
        keys: [
            'steps',
            'since',
            'until',
            'tz',
            'projectId',
            'excludeProjectId'
        ]
    },
    listevents: {
        op: 'listEvents',
        keys: [
            'message',
            'since',
            'projectId',
            'excludeProjectId'
        ]
    }
};
// Keys the bridge owns. A module may send them only with the value the bridge
// sets anyway (the tab's workspace, the projects family, info captures).
const $aeed47dc480e006a$var$ANALYZED_OWNED_KEYS = [
    'workspaceId',
    'family',
    'logType'
];
const $aeed47dc480e006a$var$ANALYZED_EVENT_OPTIONS = [
    'limit',
    'offset',
    'order'
];
// The server's own default page for /events — a module never asks for more.
const $aeed47dc480e006a$var$ANALYZED_EVENTS_MAX_LIMIT = 500;
// The server's exact-match ceiling for `message` (CONTRACT §8, CORE-C).
const $aeed47dc480e006a$var$ANALYZED_MESSAGE_MAX = 64;
const $aeed47dc480e006a$var$ANALYZED_STRING_MAX = 200;
const $aeed47dc480e006a$var$_analyzedRefusal = (message)=>Promise.reject(Object.assign(new Error('[module] ' + message), {
        code: 'module_analytics_refused'
    }));
// The installed ref of a module id ('owner/key', the id moduleIdOf returns)
// on THIS workspace: the takeover module or an additive app. Extension refs
// never match — they run sandboxed, outside the realm.
const $aeed47dc480e006a$var$_installedModuleRef = (root, moduleId)=>{
    const id = String(moduleId || '').toLowerCase();
    const settings = root && root.workspace && root.workspace.settings;
    if (!id || !settings || typeof settings !== 'object') return null;
    const refs = [];
    if (settings.workspaceModule && typeof settings.workspaceModule === 'object') refs.push(settings.workspaceModule);
    if (Array.isArray(settings.workspaceApps)) refs.push(...settings.workspaceApps);
    for (const ref of refs){
        if (!ref || typeof ref !== 'object' || ref.type && ref.type !== 'project') continue;
        if (!ref.owner || !ref.key) continue;
        if ((String(ref.owner) + '/' + String(ref.key)).toLowerCase() === id) return ref;
    }
    return null;
};
// One filter value as the SDK sends it, or undefined when it is not plain.
const $aeed47dc480e006a$var$_analyzedValue = (key, value)=>{
    if (key === 'steps') {
        if (typeof value === 'string') return value.trim() ? value.trim() : undefined;
        if (!Array.isArray(value) || !value.length || value.length > 8) return undefined;
        return value.every((v)=>typeof v === 'string' && v.trim()) ? value.map((v)=>v.trim()) : undefined;
    }
    if ((key === 'since' || key === 'until') && value instanceof Date) return isNaN(value.getTime()) ? undefined : value.toISOString();
    if (typeof value !== 'string') return undefined;
    const v = value.trim();
    if (!v) return undefined;
    if (key === 'message') return v.length <= $aeed47dc480e006a$var$ANALYZED_MESSAGE_MAX ? v : undefined;
    return v.length <= $aeed47dc480e006a$var$ANALYZED_STRING_MAX ? v : undefined;
};
// `{ filter, options }` for one analyzed read, or `{ error }`.
const $aeed47dc480e006a$var$_analyzedRequest = (read, args, wsId)=>{
    const a = args && typeof args === 'object' && !Array.isArray(args) ? args : {};
    const allowed = new Set([
        ...read.keys,
        ...$aeed47dc480e006a$var$ANALYZED_OWNED_KEYS
    ]);
    if (read.op === 'listEvents') $aeed47dc480e006a$var$ANALYZED_EVENT_OPTIONS.forEach((k)=>allowed.add(k));
    for (const k of Object.keys(a)){
        if (!allowed.has(k)) return {
            error: `analytics filter "${k}" is not permitted from a module.`
        };
    }
    if (a.workspaceId != null && String(a.workspaceId) !== String(wsId)) return {
        error: 'analytics reads stay in the workspace this tab shows.'
    };
    if (a.family != null && a.family !== 'projects') return {
        error: "analytics reads cover the workspace's published projects only (family 'projects')."
    };
    if (a.logType != null && a.logType !== 'log') return {
        error: "analytics events are the info captures only (logType 'log')."
    };
    const filter = {};
    for (const k of read.keys){
        if (a[k] == null) continue;
        const v = $aeed47dc480e006a$var$_analyzedValue(k, a[k]);
        if (v === undefined) return {
            error: `analytics filter "${k}" has a value a module may not send.`
        };
        filter[k] = v;
    }
    if (read.op === 'funnel' && !filter.steps) return {
        error: 'analytics funnel needs `steps` (event names).'
    };
    filter.workspaceId = String(wsId);
    filter.family = 'projects';
    if (read.op !== 'listEvents') return {
        filter: filter
    };
    if (!filter.message) return {
        error: 'analytics events need one exact `message` (a named event).'
    };
    filter.logType = 'log';
    const options = {};
    if (a.limit != null) {
        const n = Number(a.limit);
        if (!Number.isInteger(n) || n < 1) return {
            error: 'analytics events `limit` must be 1 or more.'
        };
        options.limit = Math.min(n, $aeed47dc480e006a$var$ANALYZED_EVENTS_MAX_LIMIT);
    }
    if (a.offset != null) {
        const n = Number(a.offset);
        if (!Number.isInteger(n) || n < 0) return {
            error: 'analytics events `offset` must be 0 or more.'
        };
        options.offset = n;
    }
    if (a.order != null) {
        if (a.order !== 'asc' && a.order !== 'desc') return {
            error: "analytics events `order` is 'asc' or 'desc'."
        };
        options.order = a.order;
    }
    return {
        filter: filter,
        options: options
    };
};
// ── assistants (see the header) ────────────────────────────────────────────
// Module op (lower-cased) → the SDK op. Nothing else reaches the SDK.
const $aeed47dc480e006a$var$ASSISTANTS_OPS = {
    list: 'list',
    get: 'get',
    update: 'update',
    revisions: 'revisions',
    rollback: 'rollback',
    usage: 'usage',
    resetcounter: 'resetCounter',
    testchat: 'testChat'
};
const $aeed47dc480e006a$var$_assistantsRefusal = (message)=>Promise.reject(Object.assign(new Error('[module] ' + message), {
        code: 'module_assistants_refused'
    }));
// ── growth (see the header) ────────────────────────────────────────────────
// Module op (lower-cased) → the SDK op, the filter keys and the paging keys a
// module may send. Nothing else reaches the SDK.
const $aeed47dc480e006a$var$GROWTH_READS = {
    funnel: {
        op: 'funnel',
        keys: [
            'since',
            'until',
            'tz',
            'groupBy'
        ],
        options: []
    },
    accounts: {
        op: 'accounts',
        keys: [
            'stage',
            'since',
            'until',
            'tz'
        ],
        options: [
            'limit',
            'offset',
            'order',
            'sort'
        ]
    }
};
// The curated catalog owner: the platform's one publisher of App Store apps
// (WORKSPACE_APPS.md "Curation v1"), the same literal the install flow and
// the server's grant derivation compare against.
const $aeed47dc480e006a$var$GROWTH_CATALOG_OWNER = 'system';
const $aeed47dc480e006a$var$GROWTH_ACCOUNTS_MAX_LIMIT = 200;
// A date, an IANA zone or a vocabulary word — none is longer.
const $aeed47dc480e006a$var$GROWTH_STRING_MAX = 64;
const $aeed47dc480e006a$var$_growthRefusal = (message)=>Promise.reject(Object.assign(new Error('[module] ' + message), {
        code: 'module_growth_refused'
    }));
// One growth value as the SDK sends it, or undefined when it is not plain.
const $aeed47dc480e006a$var$_growthValue = (key, value)=>{
    if (key === 'limit' || key === 'offset') {
        const n = Number(value);
        if (!Number.isInteger(n) || n < (key === 'limit' ? 1 : 0)) return undefined;
        return key === 'limit' ? Math.min(n, $aeed47dc480e006a$var$GROWTH_ACCOUNTS_MAX_LIMIT) : n;
    }
    if (key === 'order') return value === 'asc' || value === 'desc' ? value : undefined;
    if ((key === 'since' || key === 'until') && value instanceof Date) return isNaN(value.getTime()) ? undefined : value.toISOString();
    if (typeof value !== 'string') return undefined;
    const v = value.trim();
    return v && v.length <= $aeed47dc480e006a$var$GROWTH_STRING_MAX ? v : undefined;
};
// `{ args }` for one growth read (`{ filter }`, plus `options` for accounts),
// or `{ error }`.
const $aeed47dc480e006a$var$_growthRequest = (read, args)=>{
    const a = args && typeof args === 'object' && !Array.isArray(args) ? args : {};
    const named = [
        ...read.keys,
        ...read.options
    ];
    for (const k of Object.keys(a)){
        if (!named.includes(k)) return {
            error: `growth filter "${k}" is not permitted from a module.`
        };
    }
    const filter = {};
    const options = {};
    for (const k of named){
        if (a[k] == null) continue;
        const v = $aeed47dc480e006a$var$_growthValue(k, a[k]);
        if (v === undefined) return {
            error: `growth filter "${k}" has a value a module may not send.`
        };
        if (read.options.includes(k)) options[k] = v;
        else filter[k] = v;
    }
    return {
        args: read.op === 'accounts' ? {
            filter: filter,
            options: options
        } : {
            filter: filter
        }
    };
};
const $aeed47dc480e006a$export$fd5dfafc509409c7 = (root, capabilities = {}, { getSdkFn: getSdkFn = $aeed47dc480e006a$var$shellGetSDK, moduleIdOf: moduleIdOf = null } = {})=>{
    let recordsCap = capabilities && capabilities.records || null;
    // COLD-BOOT RACE FALLBACK: the bridge used to freeze the grant at build
    // time. When the loader's pass ran before the workspace settings bag
    // resolved, `capabilities` arrived EMPTY and every records call failed
    // '[module] records collection "…" is not in this module's capability
    // grant' for the rest of the session — data never loaded (reported live
    // on bellforge, 2026-08-13). When the SNAPSHOT grants nothing, re-read
    // the live server ref (workspace.settings.workspaceModule — the grant is
    // DATA on that record) so a late-resolving grant heals the same bridge.
    // A non-empty snapshot keeps build-time semantics untouched (additive
    // apps pass their own per-app grant — never widened by the takeover ref).
    // A collections entry is a string OR `{ key, read, write }` (per-collection
    // access levels, F1). This bridge gates MEMBERSHIP only — read/write levels
    // are enforced server-side per caller (AccessResolver), so both shapes
    // collapse to their key here. String-coercing an object entry would turn it
    // into '[object Object]' and reject every call on that collection.
    const _fillSets = (cap, cols, ops)=>{
        for (const c of Array.isArray(cap && cap.collections) ? cap.collections : []){
            const k = $aeed47dc480e006a$var$recordsEntryKey(c).toLowerCase();
            if (k) cols.add(k);
        }
        const src = Array.isArray(cap && cap.ops) && cap.ops.length ? cap.ops : [
            ...$aeed47dc480e006a$var$ALLOWED_OPS
        ];
        for (const o of src)ops.add(String(o || '').toLowerCase());
    };
    const recordCollections = new Set();
    const recordOps = new Set();
    _fillSets(recordsCap, recordCollections, recordOps);
    // Live-grant sync — call before any membership guard, on EVERY call. The
    // bridge used to FREEZE the grant at build time; when the loader's pass ran
    // before the workspace settings bag resolved, the snapshot arrived EMPTY and
    // every records call failed '[module] records collection "…" is not in this
    // module's capability grant' for the rest of the session — data never
    // loaded (reported live on bellforge, 2026-08-13). The first fix healed
    // only while the set was still EMPTY, which left the sibling shape open: a
    // NON-EMPTY snapshot taken before a stored grant gained a collection kept
    // rejecting exactly that collection for the whole session — measured on
    // bellforge 2026-08-16 (Nika, live): 23 collections loaded, `bf_profiles`
    // alone failed with this message although the stored grant on the workspace
    // record carried it (audited: 24/24 present); the banner's Retry re-ran the
    // loader through the same frozen bridge, so only a hard reload cleared it.
    //
    // Now the membership set is the UNION of the build-time snapshot and the
    // LIVE grants on the workspace record — the takeover ref
    // (settings.workspaceModule) AND every additive ref (settings.workspaceApps[])
    // — re-read per call. That is the same rule the server applies
    // (AccessResolver.resolveGrantedRecordCollections unions the same two
    // sources), so the client gate can no longer be NARROWER than the server's
    // for a session that outlives a grant write; it never widens beyond what the
    // record grants, and per-collection read/write levels stay server-enforced
    // per caller. Sets only grow (mutated in place); the read is a few small
    // arrays, so per-call cost is negligible. Never throws — a torn-down root
    // during a workspace switch just leaves the sets as they were.
    const _syncLiveGrant = ()=>{
        try {
            const ws = root && root.workspace;
            const settings = ws && ws.settings;
            if (!settings) return;
            const refs = [
                settings.workspaceModule
            ];
            if (Array.isArray(settings.workspaceApps)) refs.push(...settings.workspaceApps);
            for (const ref of refs){
                const live = ref && ref.capabilities && ref.capabilities.records || null;
                if (live && Array.isArray(live.collections) && live.collections.length) _fillSets(live, recordCollections, recordOps);
            }
        } catch (_) {
        /* sets stay as they were — the guard rejects exactly as before */ }
    };
    // "Is this module records-capable at all" — gates recordCollections/
    // fieldDefs meta reads (see file header). Any non-empty grant qualifies,
    // including a literal `'*'` entry (schema-enumeration signal only — see
    // header note on why that never widens actual row-data access above).
    const integrationsCap = capabilities && capabilities.integrations || null;
    const grantedIntegrationCapabilities = integrationsCap && integrationsCap.capabilities === '*' ? '*' : new Set((Array.isArray(integrationsCap && integrationsCap.capabilities) ? integrationsCap.capabilities : []).map((c)=>String(c || '').toLowerCase()));
    const hasIntegrationsGrant = !!integrationsCap && (grantedIntegrationCapabilities === '*' || grantedIntegrationCapabilities.size > 0);
    return function moduleData(from, op, args, cb) {
        // MODULE-FN-READONLY-ENFORCED-1 — inside a verb the manifest marks
        // `readOnly: true` (run on a read-only caller, moduleReadOnlyCall.js) only
        // record / schema READS pass; a write or an integration call never
        // reaches the SDK.
        const readOnlyCall = (0, $go87e.readOnlyCallOf)(this);
        if (readOnlyCall && !(0, $go87e.isReadOnlyDataCall)(from, op)) return (0, $go87e.refuseInReadOnlyCall)(readOnlyCall, 'moduleData', [
            from,
            op,
            args
        ]);
        const entity = $aeed47dc480e006a$var$_bareEntity(from);
        const operation = String(op || '').toLowerCase();
        // Live-grant sync — see _syncLiveGrant above (cold-boot race + a grant
        // that changed after this bridge was built).
        _syncLiveGrant();
        // ── orgIntegration — row-addressed capability dispatch ONLY. Handled
        // BEFORE the generic ALLOWED_OPS gate below: 'call' is not one of the
        // `records` store's verbs (list/get/create/update/upsert/remove/
        // subscribe), so it would be rejected outright by that gate otherwise. ─
        if (entity === 'orgintegration') {
            if (!hasIntegrationsGrant) return Promise.reject(new Error(`[module] entity "${from}" is not in this module's capability grant.`));
            if (operation !== 'call') return Promise.reject(new Error(`[module] orgIntegration operation "${op}" is not permitted from a module \u{2014} only "call".`));
            const idOrSlug = args && args.idOrSlug;
            if (!idOrSlug || typeof idOrSlug !== 'string') return Promise.reject(new Error("[module] orgIntegration.call requires args.idOrSlug \u2014 row-addressed dispatch only (the body-addressed /call route has no module-grant escape hatch server-side)."));
            const capability = String(args && args.capability || '').toLowerCase();
            if (!capability || grantedIntegrationCapabilities !== '*' && !grantedIntegrationCapabilities.has(capability)) return Promise.reject(new Error(`[module] integration capability "${args && args.capability || '(missing)'}" is not in this module's capability grant.`));
            const sdk = getSdkFn ? getSdkFn() : null;
            if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[module] SDK unavailable.'));
            const finalArgs = {
                ...args,
                workspaceId: args.workspaceId || $aeed47dc480e006a$var$_rootWsId(root),
                orgId: args.orgId || $aeed47dc480e006a$var$_rootOrgId(root)
            };
            return sdk.execute('orgIntegration', 'call', finalArgs, cb);
        }
        // ── prefs — the CALLER's own per-module preferences (modulePrefs.js,
        // MODULE-USER-PREFS-1). No capability grant: the data is the person's own,
        // stored in their user-preferences row (server-scoped to the caller), and
        // partitioned by the active workspace and the calling module. The module
        // partition is NOT enforced: modules share one JS context, so module A can
        // read, write or remove B's prefs through B's element or context — see
        // modulePrefs.js. Handled before the generic op gate: 'set' is not a
        // records verb. ───────────────────────────────────────────────────────
        if (entity === 'prefs') return (0, $bunII.modulePrefsCall).call(this, operation, args, {
            root: root,
            sdk: getSdkFn ? getSdkFn() : null,
            moduleIdOf: moduleIdOf
        });
        // ── analyzed — read-only site analytics for a TRUSTED caller, pinned to
        // the tab's workspace and the published-projects family (see the file
        // header). Handled before the generic op gate: totals / funnel /
        // listEvents are not records verbs, and no records grant is involved.
        if (entity === 'analyzed') {
            const read = Object.prototype.hasOwnProperty.call($aeed47dc480e006a$var$ANALYZED_READS, operation) ? $aeed47dc480e006a$var$ANALYZED_READS[operation] : null;
            if (!read) return $aeed47dc480e006a$var$_analyzedRefusal(`analyzed operation "${op}" is not permitted from a module \u{2014} only totals, funnel and listEvents (read-only).`);
            const moduleId = typeof moduleIdOf === 'function' ? moduleIdOf(this && this.context) : null;
            const ref = moduleId ? $aeed47dc480e006a$var$_installedModuleRef(root, moduleId) : null;
            if (!ref || ref.tier !== 'trusted') return $aeed47dc480e006a$var$_analyzedRefusal('analytics reads are served to a trusted module installed in this workspace only.');
            const wsId = $aeed47dc480e006a$var$_rootWsId(root);
            if (!wsId) return $aeed47dc480e006a$var$_analyzedRefusal('analytics reads need the workspace this tab shows.');
            const req = $aeed47dc480e006a$var$_analyzedRequest(read, args, wsId);
            if (req.error) return $aeed47dc480e006a$var$_analyzedRefusal(req.error);
            const sdk = getSdkFn ? getSdkFn() : null;
            if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[module] SDK unavailable.'));
            return sdk.execute('analyzed', read.op, read.op === 'listEvents' ? {
                filter: req.filter,
                options: req.options
            } : {
                filter: req.filter
            });
        }
        // ── assistants — the site-assistant settings, for a TRUSTED caller whose
        // own ref grants capabilities.assistants (see the file header). Handled
        // before the generic op gate: these ops are not records verbs, and no
        // records grant is involved.
        if (entity === 'assistants') {
            const sdkOp = Object.prototype.hasOwnProperty.call($aeed47dc480e006a$var$ASSISTANTS_OPS, operation) ? $aeed47dc480e006a$var$ASSISTANTS_OPS[operation] : null;
            if (!sdkOp) return $aeed47dc480e006a$var$_assistantsRefusal(`assistants operation "${op}" is not permitted from a module \u{2014} only list, get, update, revisions, rollback, usage, resetCounter and testChat.`);
            const moduleId = typeof moduleIdOf === 'function' ? moduleIdOf(this && this.context) : null;
            const ref = moduleId ? $aeed47dc480e006a$var$_installedModuleRef(root, moduleId) : null;
            if (!ref || ref.tier !== 'trusted') return $aeed47dc480e006a$var$_assistantsRefusal('assistant settings are served to a trusted module installed in this workspace only.');
            if (!ref.capabilities || ref.capabilities.assistants !== true) return $aeed47dc480e006a$var$_assistantsRefusal('entity "assistants" is not in this module\'s capability grant.');
            const sdk = getSdkFn ? getSdkFn() : null;
            if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[module] SDK unavailable.'));
            const a = args && typeof args === 'object' && !Array.isArray(args) ? {
                ...args
            } : {};
            return sdk.execute('assistants', sdkOp, a, cb);
        }
        // ── growth — the sign-up funnel and the accounts, read-only, for a
        // TRUSTED `system` catalog app (see the file header). Handled before the
        // generic op gate: funnel / accounts are not records verbs, and no records
        // grant is involved.
        if (entity === 'growth') {
            const read = Object.prototype.hasOwnProperty.call($aeed47dc480e006a$var$GROWTH_READS, operation) ? $aeed47dc480e006a$var$GROWTH_READS[operation] : null;
            if (!read) return $aeed47dc480e006a$var$_growthRefusal(`growth operation "${op}" is not permitted from a module \u{2014} only funnel and accounts (read-only).`);
            const moduleId = typeof moduleIdOf === 'function' ? moduleIdOf(this && this.context) : null;
            const ref = moduleId ? $aeed47dc480e006a$var$_installedModuleRef(root, moduleId) : null;
            if (!ref || ref.tier !== 'trusted') return $aeed47dc480e006a$var$_growthRefusal('growth reads are served to a trusted module installed in this workspace only.');
            if (String(ref.owner || '').toLowerCase() !== $aeed47dc480e006a$var$GROWTH_CATALOG_OWNER) return $aeed47dc480e006a$var$_growthRefusal('growth reads are served to a Symbols catalog app only.');
            const req = $aeed47dc480e006a$var$_growthRequest(read, args);
            if (req.error) return $aeed47dc480e006a$var$_growthRefusal(req.error);
            const sdk = getSdkFn ? getSdkFn() : null;
            if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[module] SDK unavailable.'));
            // An SDK without GrowthService (before its release) THROWS "Unknown
            // entity: 'growth'" synchronously from execute; the app reads that
            // rejection as "waiting for the data service". Always a promise.
            try {
                return Promise.resolve(sdk.execute('growth', read.op, req.args));
            } catch (err) {
                return Promise.reject(err);
            }
        }
        // ── recordCollections / fieldDefs — read-only schema metadata. Also
        // handled before the generic op gate: list/get ARE in ALLOWED_OPS, but
        // gating them here keeps both entities' checks (grant + op-allowlist)
        // together in one place instead of split across two gates. ───────────
        if (entity === 'recordcollections' || entity === 'fielddefs') {
            // Live read (not the build-time isRecordsCapable const) — the grant
            // may have synced since build; see _syncLiveGrant.
            if (recordCollections.size === 0) return Promise.reject(new Error(`[module] entity "${from}" is not in this module's capability grant.`));
            if (!$aeed47dc480e006a$var$READONLY_META_OPS.has(operation)) return Promise.reject(new Error(`[module] "${from}" operation "${op}" is not permitted from a module \u{2014} only list/get.`));
            const sdk = getSdkFn ? getSdkFn() : null;
            if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[module] SDK unavailable.'));
            const service = entity === 'recordcollections' ? 'recordCollections' : 'fieldDefs';
            const finalArgs = {
                ...args,
                workspaceId: args && args.workspaceId || $aeed47dc480e006a$var$_rootWsId(root)
            };
            return sdk.execute(service, operation, finalArgs, cb);
        }
        if (!$aeed47dc480e006a$var$ALLOWED_OPS.has(operation)) return Promise.reject(new Error(`[module] operation "${op}" is not permitted.`));
        // v1 module grant covers the generic record store only — client-owned
        // integration data flows through its own server-enforced dispatch.
        if (entity !== 'records') return Promise.reject(new Error(`[module] entity "${from}" is not in this module's capability grant.`));
        const collection = String(args && args.collection || '').toLowerCase();
        if (!collection || !recordCollections.has(collection)) return Promise.reject(new Error(`[module] records collection "${collection || '(missing)'}" is not in this module's capability grant.`));
        if (!recordOps.has(operation)) return Promise.reject(new Error(`[module] records operation "${op}" is not in this module's capability grant.`));
        const sdk = getSdkFn ? getSdkFn() : null;
        if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[module] SDK unavailable.'));
        const finalArgs = {
            ...args,
            collection: collection
        };
        const invalidateCollectionReads = ()=>{
            const marker = `"collection":${JSON.stringify(collection)}`;
            for (const k of $aeed47dc480e006a$var$_readCache.keys())if (k.includes('|' + entity + '|') && k.includes(marker)) $aeed47dc480e006a$var$_readCache.delete(k);
        };
        // Reads dedupe (see _readCache above); callback-style calls bypass — the
        // cb contract is per-invocation. Writes clear the collection's window.
        if ((operation === 'list' || operation === 'get') && !cb) {
            const key = $aeed47dc480e006a$var$_readKey(root, entity, operation, finalArgs);
            if (key) {
                const hit = $aeed47dc480e006a$var$_readCache.get(key);
                if (hit && Date.now() - hit.at < $aeed47dc480e006a$var$_READ_TTL_MS) return hit.promise;
                const promise = sdk.execute(`workspaceProject.${entity}`, operation, finalArgs);
                $aeed47dc480e006a$var$_readCache.set(key, {
                    at: Date.now(),
                    promise: promise
                });
                // A failed read must not poison the window — retries re-issue.
                promise.catch(()=>$aeed47dc480e006a$var$_readCache.delete(key));
                $aeed47dc480e006a$var$_sweepReadCache();
                return promise;
            }
        } else if (operation === 'subscribe') // A FOREIGN write can never clear this client's read window — the only
        // signal this client ever gets is the records.change/records.open hint
        // delivered right here. If that hint does not invalidate the dedupe
        // cache, the subscriber's follow-up re-read within _READ_TTL_MS is
        // served the PRE-change row and the change is swallowed silently, with
        // no retry (the hint is already consumed). Root-caused live on dev
        // 2026-08-14 against the shipped excalidraw board: records.change
        // always ARRIVED (~0.1s after the foreign PATCH), but the board's
        // re-read converged only when its previous get was >5s old — across 13
        // measured runs the miss/converge boundary sat exactly on the 5000ms
        // TTL (miss at a 4949ms-old cache entry, converge at 5086ms). So:
        // invalidate the collection's window BEFORE delivering each hint, so
        // the subscriber's re-read always reaches the server.
        {
            if (typeof cb === 'function') {
                const deliver = cb;
                cb = (evt)=>{
                    if (evt && (evt.type === 'records.change' || evt.type === 'records.open')) invalidateCollectionReads();
                    return deliver(evt);
                };
            }
        } else invalidateCollectionReads();
        // Force the workspace-scoped namespace — the hard wall (server-enforced too).
        return sdk.execute(`workspaceProject.${entity}`, operation, finalArgs, cb);
    };
};

});
parcelRegister("bunII", function(module, exports) {

$parcel$export(module.exports, "modulePrefsCall", () => $85d4e561bc6b7b0f$export$f2fc3eeaab82031e);
// modulePrefs.js — per-person preferences for workspace MODULES
// (MODULE-USER-PREFS-1). Reached through the module data bridge:
//
//   await el.call('moduleData', 'prefs', 'get',    { key: 'adjustOpen' })  // → value | null
//   await el.call('moduleData', 'prefs', 'list',   {})                     // → { key: value, … }
//   await el.call('moduleData', 'prefs', 'set',    { key: 'adjustOpen', value: true })
//   await el.call('moduleData', 'prefs', 'remove', { key: 'adjustOpen' })
//
// STORAGE — the caller's own user-preferences row (`workspaceProject.
// userPreferences`, GET/PUT /core/prefs/user). The server scopes that row by
// the CALLER's identity and nothing else (PrefsService.getUserPrefs /
// upsertUserPrefs, fail-closed on the user), so no other member can read or
// write it — the privacy between PEOPLE comes from the server, not from this
// file. No server change was needed: the row is a Mixed bag that already
// persists ad-hoc nested keys.
//
// LAYOUT inside the row: `modulePrefs[<workspaceId>][<moduleId>][<key>]`.
//   • workspaceId — the ACTIVE workspace (root.workspace.id).
//   • moduleId — the installed module that owns the CALLING element's scope
//     context (workspaceProjects.js `moduleIdOfContext`).
//   Both are stored percent-encoded (`_storeKey`), so an id with a `.` can
//   never meet the server's key sanitizer (below).
//
// ⚠ MODULE ISOLATION IS NOT ENFORCED. The module id comes from the caller's
// element context, and every module runs in ONE shared JS context with the
// shell: module A can reach module B's element or context (or read
// `root.userPrefs` outright) and so read, write or remove B's prefs. The
// partition keeps honest modules apart and stops accidents; it is not a
// security boundary, and nothing here may rely on it as one. That is accepted
// because there is no boundary to enforce between modules that share a realm —
// the boundary that matters, between people, is the server's.
//
// THE SERVER SANITIZER drops keys silently. The API's `mongoSanitize`
// (server src/core/middleware/mongoSanitize.js) deletes every object KEY that
// starts with `$` or contains `.` from a request body, at any depth up to 12,
// and the PUT still answers 200 — a `set` resolved and a fresh session read
// null (ws crm review, 2026-10-09). So: a pref key is
// `^[A-Za-z][A-Za-z0-9_-]{0,63}$` (no `.`), and a value whose nested object
// keys contain `.` or start with `$` is REFUSED here, loudly, before any write.
//
// LIMITS: value must be plain JSON (stored as its JSON round-trip); one
// module's bag ≤ 16 KB of UTF-8 JSON in one workspace; every module bag of the
// person together ≤ 256 KB, so module data can never crowd out the shell's own
// preferences in the shared row. `remove` is always allowed — it is the way
// back under a limit.
//
// WRITES are whole-row PUTs (the server $sets the row), so they ride the SAME
// per-workspace queue every other shell user-pref writer uses
// (`root.__navbarSaveQueue`, see assistantMode.js) and merge onto the live
// `root.userPrefs` at send time — a write never drops another writer's keys in
// THIS tab. (Two tabs still race: the last whole-row PUT wins.) The local copy
// updates first, so a re-read right after a set sees it; when the PUT fails
// the local change is rolled back, unless a later call changed the key since.
const $85d4e561bc6b7b0f$export$e7f534def76ec853 = 'modulePrefs';
const $85d4e561bc6b7b0f$export$13e457ef43f7331 = 16384;
const $85d4e561bc6b7b0f$export$38915d05d2c97da2 = 262144;
const $85d4e561bc6b7b0f$export$86ddada59f5e89c6 = /^[A-Za-z][A-Za-z0-9_-]{0,63}$/;
const $85d4e561bc6b7b0f$var$OPS = new Set([
    'get',
    'list',
    'set',
    'remove'
]);
const $85d4e561bc6b7b0f$var$_isObj = (v)=>!!v && typeof v === 'object' && !Array.isArray(v);
const $85d4e561bc6b7b0f$var$_bytes = (v)=>{
    const s = JSON.stringify(v);
    return typeof TextEncoder === 'function' ? new TextEncoder().encode(s).length : s.length * 3;
};
const $85d4e561bc6b7b0f$var$_wsIdOf = (root)=>{
    const w = root && root.workspace;
    const id = w && (w.id || w._id) || root && root.jwtClaims && root.jwtClaims.active_workspace_id;
    return id ? String(id) : '';
};
// The JSON round-trip of a value, or an Error naming why it is not plain JSON.
const $85d4e561bc6b7b0f$var$_plainJson = (value)=>{
    if (value === undefined) return new Error('[module] prefs.set requires args.value');
    let s;
    try {
        s = JSON.stringify(value);
    } catch (err) {
        return new Error(`[module] prefs value is not JSON: ${err && err.message}`);
    }
    if (typeof s !== 'string') return new Error('[module] prefs value is not JSON');
    const parsed = JSON.parse(s);
    const bad = $85d4e561bc6b7b0f$var$_forbiddenKeyIn(parsed, 0);
    if (bad !== null) return new Error(`[module] prefs value has the object key "${bad}" \u{2014} keys with "." or a leading "$" are dropped by the server; rename it.`);
    return parsed;
};
// The first object key (at any depth) the server's sanitizer would drop, or
// null. Same test as server mongoSanitize.hasForbiddenKey.
const $85d4e561bc6b7b0f$var$_forbiddenKeyIn = (v, depth)=>{
    if (v === null || typeof v !== 'object' || depth > 64) return null;
    if (Array.isArray(v)) {
        for (const item of v){
            const bad = $85d4e561bc6b7b0f$var$_forbiddenKeyIn(item, depth + 1);
            if (bad !== null) return bad;
        }
        return null;
    }
    for (const k of Object.keys(v)){
        if (k.startsWith('$') || k.includes('.')) return k;
        const bad = $85d4e561bc6b7b0f$var$_forbiddenKeyIn(v[k], depth + 1);
        if (bad !== null) return bad;
    }
    return null;
};
// A workspace / module id as a row key: percent-encoded, `.` included, so the
// server sanitizer can never drop a whole bag for its id.
const $85d4e561bc6b7b0f$var$_storeKey = (id)=>encodeURIComponent(String(id)).replace(/\./g, '%2E');
const $85d4e561bc6b7b0f$var$_bagOf = (prefs, wsId, moduleId)=>{
    const all = prefs && $85d4e561bc6b7b0f$var$_isObj(prefs[$85d4e561bc6b7b0f$export$e7f534def76ec853]) ? prefs[$85d4e561bc6b7b0f$export$e7f534def76ec853] : null;
    const ws = all && $85d4e561bc6b7b0f$var$_isObj(all[wsId]) ? all[wsId] : null;
    return ws && $85d4e561bc6b7b0f$var$_isObj(ws[moduleId]) ? ws[moduleId] : {};
};
const $85d4e561bc6b7b0f$export$f11ff295eefe6c12 = (prefs, wsId, moduleId, bag, { caps: caps = true } = {})=>{
    const base = $85d4e561bc6b7b0f$var$_isObj(prefs) ? prefs : {};
    const all = $85d4e561bc6b7b0f$var$_isObj(base[$85d4e561bc6b7b0f$export$e7f534def76ec853]) ? base[$85d4e561bc6b7b0f$export$e7f534def76ec853] : {};
    const ws = {
        ...$85d4e561bc6b7b0f$var$_isObj(all[wsId]) ? all[wsId] : {}
    };
    if (bag && Object.keys(bag).length) ws[moduleId] = bag;
    else delete ws[moduleId];
    const nextAll = {
        ...all
    };
    if (Object.keys(ws).length) nextAll[wsId] = ws;
    else delete nextAll[wsId];
    if (!caps) return {
        ...base,
        [$85d4e561bc6b7b0f$export$e7f534def76ec853]: nextAll
    };
    if (bag && $85d4e561bc6b7b0f$var$_bytes(bag) > $85d4e561bc6b7b0f$export$13e457ef43f7331) return new Error(`[module] prefs for this module exceed ${$85d4e561bc6b7b0f$export$13e457ef43f7331} bytes \u{2014} store less, or keep data in records`);
    if ($85d4e561bc6b7b0f$var$_bytes(nextAll) > $85d4e561bc6b7b0f$export$38915d05d2c97da2) return new Error(`[module] module prefs of this person exceed ${$85d4e561bc6b7b0f$export$38915d05d2c97da2} bytes in total`);
    return {
        ...base,
        [$85d4e561bc6b7b0f$export$e7f534def76ec853]: nextAll
    };
};
// A name no other catalog library hoists: frank lifts this helper into the
// library's ONE flat globalScope, where marketplace's own `_copy` (the hero
// copy lookup) already sits (globalScopeNameCensus).
const $85d4e561bc6b7b0f$var$_modulePrefCopy = (v)=>v === undefined ? null : JSON.parse(JSON.stringify(v));
function $85d4e561bc6b7b0f$export$f2fc3eeaab82031e(op, args, { root: root, sdk: sdk, moduleIdOf: moduleIdOf } = {}) {
    const operation = String(op || '').toLowerCase();
    if (!$85d4e561bc6b7b0f$var$OPS.has(operation)) return Promise.reject(new Error(`[module] prefs operation "${op}" is not permitted \u{2014} only get/list/set/remove.`));
    const moduleId = typeof moduleIdOf === 'function' ? moduleIdOf(this && this.context) : null;
    if (!moduleId) return Promise.reject(new Error('[module] prefs: the caller is not inside an installed module.'));
    const rawWsId = $85d4e561bc6b7b0f$var$_wsIdOf(root);
    if (!rawWsId) return Promise.reject(new Error('[module] prefs: no active workspace.'));
    const wsId = $85d4e561bc6b7b0f$var$_storeKey(rawWsId);
    const modKey = $85d4e561bc6b7b0f$var$_storeKey(moduleId);
    const key = args && args.key;
    if (operation !== 'list' && (typeof key !== 'string' || !$85d4e561bc6b7b0f$export$86ddada59f5e89c6.test(key))) return Promise.reject(new Error(`[module] prefs key "${String(key)}" is invalid \u{2014} use 1-64 chars: a letter, then letters, digits, "_" or "-".`));
    if (!sdk || typeof sdk.execute !== 'function') return Promise.reject(new Error('[module] SDK unavailable.'));
    const loaded = ()=>root && $85d4e561bc6b7b0f$var$_isObj(root.userPrefs) ? root.userPrefs : null;
    const readRow = async ()=>{
        const live = loaded();
        if (live) return live;
        const got = await sdk.execute('workspaceProject.userPreferences', 'get');
        return $85d4e561bc6b7b0f$var$_isObj(got) ? got : {};
    };
    if (operation === 'get' || operation === 'list') return readRow().then((row)=>{
        const bag = $85d4e561bc6b7b0f$var$_bagOf(row, wsId, modKey);
        if (operation === 'list') return $85d4e561bc6b7b0f$var$_modulePrefCopy(bag);
        return Object.prototype.hasOwnProperty.call(bag, key) ? $85d4e561bc6b7b0f$var$_modulePrefCopy(bag[key]) : null;
    });
    let value;
    if (operation === 'set') {
        value = $85d4e561bc6b7b0f$var$_plainJson(args && args.value);
        if (value instanceof Error) return Promise.reject(value);
    }
    const change = (row)=>{
        const bag = {
            ...$85d4e561bc6b7b0f$var$_bagOf(row, wsId, modKey)
        };
        if (operation === 'set') bag[key] = value;
        else delete bag[key];
        return $85d4e561bc6b7b0f$export$f11ff295eefe6c12(row, wsId, modKey, bag, {
            caps: operation === 'set'
        });
    };
    // Validate and apply locally first, so a set is visible to the next get.
    // Remember what the key held, for the roll-back below.
    const now = loaded();
    const before = now ? $85d4e561bc6b7b0f$var$_bagOf(now, wsId, modKey) : null;
    const had = !!before && Object.prototype.hasOwnProperty.call(before, key);
    const prevValue = had ? $85d4e561bc6b7b0f$var$_modulePrefCopy(before[key]) : undefined;
    if (now) {
        const next = change(now);
        if (next instanceof Error) return Promise.reject(next);
        if (typeof root.update === 'function') root.update({
            userPrefs: next
        }, {
            preventFetch: true
        });
    }
    const ours = JSON.stringify(operation === 'set' ? value : undefined);
    const rollBack = ()=>{
        const cur = loaded();
        if (!now || !cur || typeof root.update !== 'function') return;
        const bag = {
            ...$85d4e561bc6b7b0f$var$_bagOf(cur, wsId, modKey)
        };
        const has = Object.prototype.hasOwnProperty.call(bag, key);
        // A later call changed the key since — its value stands.
        if (JSON.stringify(has ? bag[key] : undefined) !== ours) return;
        if (had) bag[key] = prevValue;
        else delete bag[key];
        root.update({
            userPrefs: $85d4e561bc6b7b0f$export$f11ff295eefe6c12(cur, wsId, modKey, bag, {
                caps: false
            })
        }, {
            preventFetch: true
        });
    };
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    const qKey = rawWsId || 'user';
    const prior = queue.get(qKey) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        // `change(row)` still runs — it is how the byte-budget caps get
        // checked against a fresh row on a cold write (`now` unset below) — but
        // its RESULT is no longer the wire payload.
        const row = await readRow();
        const validated = change(row);
        if (validated instanceof Error) throw validated;
        // PER-PATH PATCH — the path is an ARRAY OF SEGMENTS (never a dotted
        // string: the server's sanitizer drops a dotted key silently), and it
        // names only THIS module's (workspace, module, key) tuple, so a
        // different module, workspace or key is never overwritten
        // (CORE-USERPREFS-PATCH-PER-PATH-1). A `remove` that empties the bag —
        // or the workspace's last bag — collapses the EMPTY PARENT instead of
        // the leaf, the same cleanup `withModuleBag` already does locally
        // (one path only: never the leaf AND an ancestor in the same call).
        let unsetPath = [
            $85d4e561bc6b7b0f$export$e7f534def76ec853,
            wsId,
            modKey,
            key
        ];
        if (operation === 'remove') {
            const bagNow = $85d4e561bc6b7b0f$var$_bagOf(row, wsId, modKey);
            if (!Object.keys(bagNow).some((k)=>k !== key)) {
                const all = row && $85d4e561bc6b7b0f$var$_isObj(row[$85d4e561bc6b7b0f$export$e7f534def76ec853]) ? row[$85d4e561bc6b7b0f$export$e7f534def76ec853] : {};
                const wsBag = $85d4e561bc6b7b0f$var$_isObj(all[wsId]) ? all[wsId] : {};
                unsetPath = Object.keys(wsBag).some((m)=>m !== modKey) ? [
                    $85d4e561bc6b7b0f$export$e7f534def76ec853,
                    wsId,
                    modKey
                ] : [
                    $85d4e561bc6b7b0f$export$e7f534def76ec853,
                    wsId
                ];
            }
        }
        await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: operation === 'set' ? {
                set: [
                    {
                        path: [
                            $85d4e561bc6b7b0f$export$e7f534def76ec853,
                            wsId,
                            modKey,
                            key
                        ],
                        value: value
                    }
                ]
            } : {
                unset: [
                    unsetPath
                ]
            }
        });
        // A cold write (row not loaded before) lands in the local copy only if
        // the boot read has filled it meanwhile; never invent the whole row.
        const after = loaded();
        if (after && typeof root.update === 'function') {
            const merged = change(after);
            if (!(merged instanceof Error)) root.update({
                userPrefs: merged
            }, {
                preventFetch: true
            });
        }
        return operation === 'set' ? $85d4e561bc6b7b0f$var$_modulePrefCopy(value) : null;
    }).catch((err)=>{
        rollBack();
        throw err;
    });
    queue.set(qKey, task);
    return task;
}

});


parcelRegister("i8Ov5", function(module, exports) {

$parcel$export(module.exports, "resolveModuleUrl", () => $d35025a969f9d73f$export$d6e27d0b2c113127);
$parcel$export(module.exports, "resolveAssetUrl", () => $d35025a969f9d73f$export$9f7ff270ca03dc03);
$parcel$export(module.exports, "normalizeDependencies", () => $d35025a969f9d73f$export$4254095731628688);
$parcel$export(module.exports, "peerPins", () => $d35025a969f9d73f$export$ff4bb32a12e24d70);
$parcel$export(module.exports, "buildModuleImportBridge", () => $d35025a969f9d73f$export$3187a3a7b4e526c9);
$parcel$export(module.exports, "buildModuleMountBridge", () => $d35025a969f9d73f$export$dd509fbc6005d659);
$parcel$export(module.exports, "buildModuleAssetUrlBridge", () => $d35025a969f9d73f$export$d6836a2c82e9a180);
$parcel$export(module.exports, "buildModuleApiBridge", () => $d35025a969f9d73f$export$20bb2968cae4c4c8);
$parcel$export(module.exports, "buildModuleTokenBridge", () => $d35025a969f9d73f$export$3b4518d03dd5184);
$parcel$export(module.exports, "buildModuleThemeBridge", () => $d35025a969f9d73f$export$732cd90d1a3785bb);
$parcel$export(module.exports, "buildModuleUnmountBridge", () => $d35025a969f9d73f$export$7e09ec77e7d7d249);
// moduleImportBridge.js — capability-scoped VENDOR-LIBRARY loading for
// workspace MODULES (manifest v2). The third capability bridge, alongside
// moduleDataBridge (data) and moduleFileBridge (uploads).
//
// ── Why this exists ────────────────────────────────────────────────────────
// A catalog app that wraps a third-party library (a drawing canvas, a chart
// pack, a video player) has to get that library into the page. Until now it
// could NOT:
//   • `import('pkg')` inside module code is FORBIDDEN — ModuleAuditService's
//     FORBIDDEN_PATTERNS bans dynamic import(), and a version whose
//     `moduleAudit.ok === false` is REFUSED outright by the loader.
//   • The module loader has no importmap support, so a bare specifier has
//     nothing to resolve against either.
// So the framework, not the app, must own the import — exactly the shape the
// data plane already uses. The `import()` below lives in SHELL code, which is
// not module-audited; modules stay audit-clean because they only ever call
// `el.call('moduleImport', pkg)`.
//
// ── Trust model (identical to moduleData) ──────────────────────────────────
// The allowlist is the module's own manifest `libraries` map, which the
// workspace owner/admin sees at install time. A module can load NOTHING it did
// not declare: an undeclared package throws, and the declared version is the
// one fetched — the module never supplies a URL, so it cannot point the shell
// at arbitrary code. Every request is pinned to an exact version (a floating
// range would let an upstream release change what an installed app executes).
//
// ── Why esm.sh, and why NOT (yet) pkg.symbo.ls ─────────────────────────────
// Measured in a browser, not assumed (scratchpad mount harness, 2026-08-08):
// our own mirror is jsDelivr-backed, and jsDelivr's `+esm` bundles resolve
// each package's peers INDEPENDENTLY — Excalidraw's bundle pulled react@19.2.5
// while its own `jotai-scope` dep pulled react@18.3.1. Two React copies means a
// null hooks dispatcher ("Cannot read properties of null (reading 'useEffect')")
// and a silent blank mount. No amount of pinning OUR react fixes a peer the
// bundle resolved itself.
//
// esm.sh's `?deps=` pins peers across the WHOLE transitive graph — the pins are
// encoded into every nested URL it emits — so one React instance reaches every
// package. Verified: the editor mounts and paints.
//
// Moving this onto pkg.symbo.ls is tracked in tickets/excalidraw.md: the worker
// must mirror esm.sh (whose nested imports are root-relative, e.g.
// `/react@19.2.5/es2022/react.mjs`), which needs a routing decision — a
// dedicated host, or a path heuristic — that is operator territory. `CDN_BASE`
// is the single line that changes when that lands.
//
// Either way NOTHING is added to the workspace bundle: the shell ships this
// resolver and nothing else; library bytes arrive only when a user opens an
// installed app that asks for them.
const $d35025a969f9d73f$var$CDN_BASE = 'https://esm.sh';
// Exact-version pin. A range/tag would mean an upstream publish silently
// changes what an already-installed app runs.
// Raw file mirror for non-module assets (css, fonts, workers). Our own CDN
// handles these correctly today — only the ESM *graph* needed esm.sh.
const $d35025a969f9d73f$var$ASSET_BASE = 'https://pkg.symbo.ls';
const $d35025a969f9d73f$var$EXACT_VERSION = /^\d+\.\d+\.\d+(?:[-+][0-9A-Za-z.-]+)?$/;
// url → Promise<namespace>. Module-scope so two widgets mounting the same
// library in one tick share ONE network fetch (same reasoning as the records
// stampede collapse in moduleDataBridge).
const $d35025a969f9d73f$var$_moduleCache = new Map();
// url → Promise<parsed JSON>. A separate cache from `_moduleCache`: a JSON
// data file and an ES module are different fetch kinds, even for the same
// declared package, and must not collide on the same key.
const $d35025a969f9d73f$var$_jsonCache = new Map();
const $d35025a969f9d73f$var$_cssLoaded = new Set();
const $d35025a969f9d73f$export$d6e27d0b2c113127 = (pkg, version, path, pins)=>{
    const base = `${$d35025a969f9d73f$var$CDN_BASE}/${pkg}@${version}`;
    const sub = path ? '/' + String(path).replace(/^\/+/, '').replace(/\/+$/, '') : '';
    // `?deps=` is what makes the transitive graph agree on ONE copy of a shared
    // peer (React). Built from the app's declared map — never hardcoded.
    const q = pins && pins.length ? `?deps=${pins.join(',')}` : '';
    return `${base}${sub}${q}`;
};
const $d35025a969f9d73f$export$9f7ff270ca03dc03 = (pkg, version, path)=>{
    // Assets bypass the ESM builder entirely — a raw file mirror serves them.
    const base = `${$d35025a969f9d73f$var$ASSET_BASE}/${pkg}@${version}`;
    if (!path) return `${base}/`;
    return `${base}/${String(path).replace(/^\/+/, '')}`;
};
const $d35025a969f9d73f$export$4254095731628688 = (declared)=>{
    const allow = new Map();
    if (!declared || typeof declared !== 'object') return allow;
    for (const [pkg, version] of Object.entries(declared)){
        if (typeof pkg !== 'string' || !pkg) continue;
        const v = typeof version === 'string' ? version.trim().replace(/^[\^~]/, '') : '';
        if (!$d35025a969f9d73f$var$EXACT_VERSION.test(v)) {
            console.warn("[moduleImport] dependency skipped \u2014 an EXACT version is required (got", JSON.stringify(version), 'for', pkg + ')');
            continue;
        }
        allow.set(pkg, v);
    }
    return allow;
};
/**
 * Inject a stylesheet once per URL. Vendor CSS (e.g. Excalidraw's) is
 * namespaced by the library itself; the shell does not sandbox it.
 */ const $d35025a969f9d73f$var$_shellInjectCss = (url)=>{
    if ($d35025a969f9d73f$var$_cssLoaded.has(url) || typeof document === 'undefined') return;
    $d35025a969f9d73f$var$_cssLoaded.add(url);
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.dataset.moduleImport = 'true';
    document.head.appendChild(link);
};
/**
 * Build the bridge the loader registers as the `moduleImport` context
 * function. Modules call:
 *
 *   const Lib = await el.call('moduleImport', '@excalidraw/excalidraw')
 *   const Lib = await el.call('moduleImport', 'react-dom', { path: 'client' })
 *   await el.call('moduleImport', '@excalidraw/excalidraw', {
 *     css: 'dist/prod/index.css'
 *   })
 *   const topo = await el.call('moduleImport', 'world-atlas', {
 *     path: 'land-110m.json', json: true
 *   })
 *
 * `opts.json: true` fetches a DATA file off the same asset resolver as
 * `opts.css` (declared package + exact version, never a module URL) and
 * returns the parsed JSON — for a library data file (TopoJSON, a lookup
 * table) that is not and never becomes an ES module. Without it, the only
 * way to pull a JSON file through this bridge was a CDN-specific query flag
 * smuggled into `opts.path` (`?module`), which depends on esm.sh and breaks
 * if the resolver changes host or drops the flag.
 *
 * Returns the module namespace, or the parsed JSON for `opts.json`. Throws
 * (never resolves undefined) when the package isn't declared — a silent
 * null would surface as an unrenderable component with no explanation.
 */ // Peer packages worth pinning across a dependency graph. Anything the app
// declares that also appears as a nested peer must resolve to ONE copy.
const $d35025a969f9d73f$var$PINNABLE_PEERS = [
    'react',
    'react-dom',
    'preact',
    'vue',
    'svelte'
];
const $d35025a969f9d73f$export$ff4bb32a12e24d70 = (allow)=>$d35025a969f9d73f$var$PINNABLE_PEERS.filter((p)=>allow.has(p)).map((p)=>`${p}@${allow.get(p)}`);
const $d35025a969f9d73f$export$3187a3a7b4e526c9 = (declaredDependencies, options = {})=>{
    const allow = $d35025a969f9d73f$export$4254095731628688(declaredDependencies);
    const pins = $d35025a969f9d73f$export$ff4bb32a12e24d70(allow);
    // Injectable for tests — the real ones are the platform's dynamic import
    // and a plain fetch-and-parse.
    const importFn = options.importFn || ((url)=>import(/* @vite-ignore */ url));
    const fetchJsonFn = options.fetchJsonFn || (async (url)=>{
        const res = await fetch(url);
        if (!res.ok) throw new Error(`[moduleImport] ${res.status} fetching ${url}`);
        return res.json();
    });
    return async function moduleImport(pkg, opts = {}) {
        if (typeof pkg !== 'string' || !pkg) throw new Error('[moduleImport] a package name is required');
        const version = allow.get(pkg);
        if (!version) throw new Error(`[moduleImport] "${pkg}" is not declared in this app's manifest \`libraries\` \u{2014} ` + 'declare it with an exact version to make it loadable.');
        if (opts.css) $d35025a969f9d73f$var$_shellInjectCss($d35025a969f9d73f$export$9f7ff270ca03dc03(pkg, version, opts.css));
        if (opts.json) {
            // Same resolver as `opts.css` — a raw file, never the ESM builder.
            const url = $d35025a969f9d73f$export$9f7ff270ca03dc03(pkg, version, opts.path);
            if (!$d35025a969f9d73f$var$_jsonCache.has(url)) $d35025a969f9d73f$var$_jsonCache.set(url, fetchJsonFn(url).catch((err)=>{
                // Don't poison the cache with a transient network failure — the
                // next call should be able to retry.
                $d35025a969f9d73f$var$_jsonCache.delete(url);
                throw err;
            }));
            return $d35025a969f9d73f$var$_jsonCache.get(url);
        }
        // `assetPath` — some libraries need a base URL to fetch their own runtime
        // assets (fonts, workers) from. Returning it lets the app hand the library
        // a pkg.symbo.ls path instead of hardcoding a CDN.
        const url = $d35025a969f9d73f$export$d6e27d0b2c113127(pkg, version, opts.path, pins);
        if (!$d35025a969f9d73f$var$_moduleCache.has(url)) $d35025a969f9d73f$var$_moduleCache.set(url, importFn(url).catch((err)=>{
            // Don't poison the cache with a transient network failure — the next
            // mount should be able to retry.
            $d35025a969f9d73f$var$_moduleCache.delete(url);
            throw err;
        }));
        return $d35025a969f9d73f$var$_moduleCache.get(url);
    };
};
// node → mounted root, and node → the library's imperative API. WeakMaps so a
// discarded node's handles are collectable without the app tracking anything.
const $d35025a969f9d73f$var$_mountedRoots = new WeakMap();
const $d35025a969f9d73f$var$_mountedApis = new WeakMap();
const $d35025a969f9d73f$var$_injectedSheets = new Set();
const $d35025a969f9d73f$export$dd509fbc6005d659 = (declaredDependencies, options = {})=>{
    const moduleImport = $d35025a969f9d73f$export$3187a3a7b4e526c9(declaredDependencies, options);
    const moduleAssetUrl = $d35025a969f9d73f$export$d6836a2c82e9a180(declaredDependencies);
    return async function moduleMount(el, spec = {}) {
        const node = el && el.node;
        if (!node) return null;
        if ($d35025a969f9d73f$var$_mountedRoots.has(node)) return $d35025a969f9d73f$var$_mountedRoots.get(node);
        if (!spec.pkg) throw new Error('[moduleMount] `pkg` is required');
        // Set BEFORE the library evaluates — asset globals are read at module init.
        if (spec.assetPathGlobal) globalThis[spec.assetPathGlobal] = moduleAssetUrl(spec.pkg, spec.assetPath || '');
        const React = await moduleImport('react');
        const ReactDOMClient = await moduleImport('react-dom', {
            path: 'client'
        });
        const Lib = await moduleImport(spec.pkg, spec.css ? {
            css: spec.css
        } : undefined);
        const Component = spec.export ? Lib[spec.export] : Lib.default || Lib;
        if (typeof Component !== 'function' && typeof Component !== 'object') throw new Error(`[moduleMount] "${spec.export || 'default'}" is not a component export of ${spec.pkg}`);
        // Brand skin: the app hands us CSS custom properties to set on the
        // mounted subtree, so a vendor UI can be dressed in OUR design-system
        // tokens (`var(--color-…)`) without the app writing to the DOM itself.
        //
        // `cssVarsTarget` matters more than it looks. A library that declares its
        // own theme vars ON ITS ROOT (`.excalidraw { --island-bg-color: … }`)
        // OVERRIDES anything inherited from an ancestor — setting the vars on the
        // mount node alone silently did nothing (measured: islands kept
        // Excalidraw's #232329 instead of the workspace surface). So the vars are
        // applied to the library's own root too, once React has rendered it.
        const applyVars = (target)=>{
            if (!target || !spec.cssVars || typeof spec.cssVars !== 'object') return;
            for (const [name, value] of Object.entries(spec.cssVars))if (typeof name === 'string' && name.startsWith('--')) target.style.setProperty(name, value);
        };
        applyVars(node);
        // Scoped stylesheet. Custom properties cover most vendor skinning, but not
        // everything a house surface needs — `backdrop-filter` and a layered
        // `box-shadow` are real declarations, not variables any library exposes.
        // The app supplies CSS text (referencing OUR theme vars, so it stays
        // token-driven and theme-aware) and the shell injects it once.
        if (typeof spec.styleSheet === 'string' && spec.styleSheet.trim()) {
            const id = 'module-skin-' + String(spec.pkg).replace(/[^a-z0-9]+/gi, '-');
            if (!$d35025a969f9d73f$var$_injectedSheets.has(id) && typeof document !== 'undefined') {
                $d35025a969f9d73f$var$_injectedSheets.add(id);
                const style = document.createElement('style');
                style.id = id;
                style.textContent = spec.styleSheet;
                document.head.appendChild(style);
            }
        }
        if (spec.cssVars && spec.cssVarsTarget) {
            // React renders asynchronously — poll briefly for the root rather than
            // guessing a timeout, and give up quietly if the selector never matches.
            let tries = 0;
            const paint = ()=>{
                const found = node.querySelector(spec.cssVarsTarget);
                if (found) return applyVars(found);
                if (tries++ < 40) setTimeout(paint, 75);
            };
            setTimeout(paint, 0);
        }
        // Imperative API handle. Libraries like Excalidraw hand back a controller
        // through a prop (`excalidrawAPI`); the app cannot stash it itself (no
        // el.node writes), so the shell captures it into the same WeakMap and
        // serves it via `el.call('moduleApi', el)`. This is what lets an app
        // drive the mounted library AFTER mount — live theme changes, AI-authored
        // content — without ever re-mounting it.
        const props = {
            ...spec.componentProps || {}
        };
        if (spec.apiProp) {
            const userHook = props[spec.apiProp];
            props[spec.apiProp] = (api)=>{
                $d35025a969f9d73f$var$_mountedApis.set(node, api);
                if (typeof userHook === 'function') userHook(api);
            };
        }
        const root = ReactDOMClient.createRoot(node);
        $d35025a969f9d73f$var$_mountedRoots.set(node, root);
        root.render(React.createElement(Component, props));
        return root;
    };
};
const $d35025a969f9d73f$export$20bb2968cae4c4c8 = ()=>function moduleApi(el) {
        const node = el && el.node;
        if (!node) return null;
        return $d35025a969f9d73f$var$_mountedApis.get(node) || null;
    };
const $d35025a969f9d73f$export$3b4518d03dd5184 = ()=>function moduleToken(name, fallback) {
        if (typeof name !== 'string' || !name.startsWith('--')) return fallback || null;
        if (typeof document === 'undefined' || typeof window === 'undefined') return fallback || null;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(name);
        const trimmed = (value || '').trim();
        return trimmed || fallback || null;
    };
const $d35025a969f9d73f$export$732cd90d1a3785bb = ()=>function moduleTheme() {
        if (typeof document === 'undefined') return 'light';
        const attr = document.documentElement.getAttribute('data-theme');
        if (attr === 'dark' || attr === 'light') return attr;
        if (typeof window !== 'undefined' && window.matchMedia) return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        return 'light';
    };
const $d35025a969f9d73f$export$7e09ec77e7d7d249 = ()=>function moduleUnmount(el) {
        const node = el && el.node;
        if (!node) return false;
        const root = $d35025a969f9d73f$var$_mountedRoots.get(node);
        $d35025a969f9d73f$var$_mountedApis.delete(node);
        if (!root) return false;
        $d35025a969f9d73f$var$_mountedRoots.delete(node);
        try {
            root.unmount();
        } catch (err) {
            console.warn('[moduleUnmount] unmount failed:', err);
        }
        return true;
    };
const $d35025a969f9d73f$export$d6836a2c82e9a180 = (declaredDependencies)=>{
    const allow = $d35025a969f9d73f$export$4254095731628688(declaredDependencies);
    return function moduleAssetUrl(pkg, path) {
        const version = allow.get(pkg);
        if (!version) throw new Error(`[moduleAssetUrl] "${pkg}" is not declared in this app's manifest \`libraries\`.`);
        // Assets are served verbatim; no path yields the package ROOT with a
        // trailing slash (a base path a library appends to).
        return $d35025a969f9d73f$export$9f7ff270ca03dc03(pkg, version, path);
    };
};

});

parcelRegister("atmQm", function(module, exports) {

$parcel$export(module.exports, "buildModuleOpenBridge", () => $79fe5514f6c578df$export$da553d7c02639254);
$parcel$export(module.exports, "buildModuleRouteQueryBridge", () => $79fe5514f6c578df$export$e8941de054606122);
// Page-open bridge — lets a workspace-module widget body (or any module
// code) open one of the MODULE'S OWN registered pages in the shell PageSlot,
// exactly like a navbar tab does. Scope-guarded: routes no installed module
// serves (`_servesPage` below: root.workspaceProject.pages, or an installed
// app's own root.workspaceApps[].pages) are refused, so a module can never
// steer the shell to arbitrary surfaces. Sibling of the moduleData /
// moduleAiChat / moduleFileUpload bridges (workspaceProjects.js injection
// site).
//
// Invoked as el.call('moduleOpenPage', '/route') — the function registry
// binds `this` to the calling element, which openAppPage needs for its
// state / router access.

var $D8RKl = parcelRequire("D8RKl");

var $25fky = parcelRequire("25fky");

var $7ytvD = parcelRequire("7ytvD");

var $15Bho = parcelRequire("15Bho");

var $7iFOV = parcelRequire("7iFOV");
// RAIL-TRANSITION (tickets/fable.md) — the `?viewAs=` durability fix's
// original write site (app.js `_syncShellRoute`, via the invisible
// `ShellRouteSync` component) never actually ran on a View-as click:
// `ShellRouteSync`'s `subscribeTo` only names
// `['currentPath', '_chatDrawerOpen', 'assistantOpen', 'assistantDock',
// 'assistantWidth']`, and neither a persona's `s.root.update({bfPersonaOverride,
// bfView})` nor `moduleOpenPage`'s own `_canvasSlot` write touches any of
// those — so the reactive component never re-fires and `?viewAs=` never
// lands (Chrome-MCP-confirmed live, 2026-08-14: `?page=` updates every
// switch, `?viewAs=` never once across ten). `subscribeTo`'s key list is
// also resolved ONCE at element-create time (registerSubscribeToEffects,
// smbls create.js) — a dynamic function form keyed off
// `moduleViewAsKey(root)` would still be frozen at shell-mount time, before
// any module (and its `chrome.viewAsKey`) has loaded, so widening the
// reactive subscription can't work either.
//
// Fixed here instead: `moduleOpenPage` is the ONE bridge every View-as
// persona-switch and every other module-page-open call funnels through
// (BfNav.js pairs its override write with this call unconditionally), so
// syncing `?viewAs=` imperatively, right here, right after the slot opens,
// is deterministic — no reactive gating, no create-time freeze, no missed
// tick. Generic: keyed off the active module's `chrome.viewAsKey` (never a
// module-specific name), so any module gets this for free. Read/restore
// half is `_restoreViewAsParam` (workspaceProjects.js), unchanged.
const $79fe5514f6c578df$var$_syncViewAsUrl = (root)=>{
    if (typeof window === 'undefined') return;
    const key = (0, $7ytvD.moduleViewAsKey)(root);
    if (!key) return;
    try {
        const url = new URL(window.location.href);
        const cur = url.searchParams.get('viewAs');
        const val = root ? root[key] : null;
        const next = typeof val === 'string' && val && val !== 'admin' ? val : null;
        if (next === cur) return;
        if (next) url.searchParams.set('viewAs', next);
        else url.searchParams.delete('viewAs');
        const nextUrl = url.pathname + url.search + url.hash;
        const current = window.location.pathname + window.location.search + window.location.hash;
        if (nextUrl !== current) window.history.replaceState(window.history.state, '', nextUrl);
    } catch (err) {
        console.warn('[moduleOpenPage] viewAs url sync failed:', err?.message || err);
    }
};
const $79fe5514f6c578df$export$da553d7c02639254 = (root)=>{
    return function moduleOpenPage(route) {
        try {
            const key = String(route || '');
            // A1-06 — the scope guard resolves the PATH, the open carries the FULL
            // route. A module opening one of its own records passes the params that
            // identify it (`/vault-rooms?tenant=longbow&item=<id>`); an exact
            // `pages[key]` lookup never matches those, so every deep open was
            // REFUSED here (returned false, nothing opened) and the module had to
            // latch the record in root state instead — nothing shareable, nothing
            // reload-safe. Same normalization openAppPage and PageSlot's `_defFor`
            // already apply; the guard is unchanged in strength, only in what it
            // compares (a route outside the module's own pages is still refused).
            const path = key.split('?')[0].split('#')[0];
            if (!key || !($79fe5514f6c578df$var$_servesPage(root, key) || $79fe5514f6c578df$var$_servesPage(root, path))) return false;
            (0, $D8RKl.openAppPage).call(this, key, {
                preferSlot: true
            });
            $79fe5514f6c578df$var$_syncViewAsUrl(root);
            return true;
        } catch (e) {
            console.warn('[moduleOpenPage] failed:', e?.message || e);
            return false;
        }
    };
};
// ── setModuleRouteQuery — the URL seam for a SAME-PAGE record open ─────────
//
// A module that is already ON one of its pages must NOT navigate to open a
// record: `openAppPage(..., { preferSlot: true })` mounted a SECOND instance
// of the page it was already showing (the doubled-sheet bug; the module side
// now simply does not navigate). That left it with no way to put `?item=<id>`
// in the address at all, so a same-page open was unshareable and lost on
// reload.
//
// The SHELL owns the URL, so the shell provides the write:
//
//   el.call('setModuleRouteQuery', { item: 'lb-1' })   // open  -> ?item=lb-1
//   el.call('setModuleRouteQuery', { item: null })     // one param away
//   el.call('setModuleRouteQuery', null)               // sheet closed -> clear
//
// Contract:
//   • history.replaceState ONLY for the top-level query — no navigation
//     event, no new page instance, no router dispatch. (The AppShell history
//     patch fires `locationchange` on every replaceState, and the shell's
//     `_closeOnNav` acts on PATHNAME changes only, so a query-only write
//     disturbs nothing. The no-op guard below keeps an unchanged URL from
//     firing it at all — the same guard PageSlot._writeSlotUrl carries, for
//     the same reason.)
//   • A key the PANE route already carries is patched there as well
//     (`_patchPaneRoute` below), with no re-mount. That address write is
//     PageSlot's own, and it records it like any pane route change.
//   • Scope-guarded like moduleOpenPage: it writes only while the CALLER'S
//     surface IS one of this module's own pages (the route of the pane the
//     caller sits in; outside a pane, the open primary PageSlot route or the
//     pathname). A module can never rewrite a shell route's query.
//   • The address bar is the PRIMARY pane's mirror (PageSlot `_slotUrlNext`).
//     A caller in the SECOND pane writes its own pane route only, never the
//     address (`_moduleSurface` below).
//   • Shell-owned params are untouchable: `page` is the PageSlot key and
//     `viewAs` is the persona pin, both written by the shell itself.
//   • `null` clears the params this module DECLARES for the current route
//     (manifest `collections` -> root.workspaceProject.recordRoutes), so the
//     close path needs no bookkeeping and can never strip a param it does not
//     own.
//   • The value survives a reload with no extra work: it is a real query
//     param, so the page reads it from `location.search` on a cold mount
//     exactly as it does after a slot open (A1-06).
//
// Returns true when the URL changed.
const $79fe5514f6c578df$var$_RESERVED_SHELL_PARAMS = new Set([
    'page',
    'viewAs'
]);
// A page route one of the installed modules serves: the takeover module's
// (and the composed stash's) `root.workspaceProject.pages`, or an ADDITIVE
// app's own list, `root.workspaceApps[].pages` — an app installed from the
// App Store serves its pages there, and the composed stash may not carry them
// yet (current-2a 2026-09-28: the seam answered only for the takeover, so an
// installed app — /realestate?unit=… — could not write its own record param).
const $79fe5514f6c578df$var$_servesPage = (root, path)=>{
    if (!path) return false;
    const pages = root && root.workspaceProject && root.workspaceProject.pages || {};
    if (pages[path]) return true;
    const apps = root && Array.isArray(root.workspaceApps) ? root.workspaceApps : [];
    return apps.some((a)=>a && Array.isArray(a.pages) && a.pages.includes(path));
};
// THE CALLER'S SURFACE — `{ route, second }`, or null when the caller is on
// no page an installed module serves. `host` is the PageSlot keep-alive host
// the caller sits in (`slotHostOf(this)`), or null outside a pane.
//
//   • In the SECOND pane: that pane's own route (`host._slotPath`, the
//     `root._canvasSlotSecond` value PageSlot stamped on it). `second: true`
//     tells the bridge to stop at the pane route: the address bar mirrors the
//     PRIMARY pane only (PageSlot `_slotUrlNext`; the split pane is transient,
//     never in the address), and `readPageParam` never reads the address for
//     a second-pane caller (pageParam.js `pageParams`).
//   • Anywhere else (the primary pane, or no pane at all): the address bar's
//     own surface, unchanged — the primary pane's route, else the pathname.
//
// The guard used to read `root._canvasSlot` for every caller (lane RQ-2,
// 2026-10-30). So a page in the SECOND pane was refused in full, pane route
// and address, whenever the primary showed a shell route (`/chat`, `/tasks`):
// an App Store app's consumed create link (`/catalog?new=1&name=…`) stayed in
// `root._canvasSlotSecond`, and a close of the primary pane PROMOTES that route
// into the primary and into `?page=` (PageSlot `_closeSlot`), where the
// promoted page and a reload opened a second form. Workspace pages had the
// same gap. And when the primary DID show a module page, a second-pane
// `null` cleared the params the PRIMARY's route declares, and a second-pane
// write reached the address, the primary's mirror.
const $79fe5514f6c578df$var$_SECOND_PANE = '_canvasSlotSecond';
const $79fe5514f6c578df$var$_moduleSurface = (root, host)=>{
    if (typeof window === 'undefined') return null;
    if (host && host._slotPaneKey === $79fe5514f6c578df$var$_SECOND_PANE) {
        const p = String(host._slotPath).split('?')[0].split('#')[0];
        return $79fe5514f6c578df$var$_servesPage(root, p) ? {
            route: p,
            second: true
        } : null;
    }
    const slot = root && root._canvasSlot;
    const p = slot ? String(slot).split('?')[0].split('#')[0] : (0, $7iFOV.shellStripWorkspacePrefix)(window.location.pathname);
    return $79fe5514f6c578df$var$_servesPage(root, p) ? {
        route: p,
        second: false
    } : null;
};
// The params the installed modules DECLARE for a route — every record route
// live in this workspace, the takeover's and every installed app's
// (moduleRecordRoutes: the ONE composed reader the record links use).
const $79fe5514f6c578df$var$_declaredParamsFor = (root, route)=>{
    const out = new Set();
    for (const r of Object.values((0, $15Bho.moduleRecordRoutes)(root)))if (r && r.param && r.route === route) out.add(String(r.param));
    return out;
};
// ── The PANE half ────────────────────────────────────────────────────────
//
// A record param can ride in TWO places: the top-level query (a same-page
// open writes it there) and the pane's OWN route — `root._canvasSlot`, the
// `?page=` value — when the page was OPENED on that record (a deep link, an
// Open from another page, a cold load of a shared URL). The top-level write
// alone left the pane route naming the record, and the pane route WINS in
// `readPageParam`, so:
//   • Close cleared the top-level `item` and the address still named the
//     record inside `?page=` — a reload, a shared link or Back re-opened what
//     the reader had just closed. Measured on vault.pr (shell 7a7f367b1,
//     VaultOS 1.44.0), 2026-09-21: close → `?page=/vault-rooms?tenant=…&
//     item=6aa16…&tenant=…`, reload → the sheet is open again.
//   • A second open on the same page wrote `item=NEW` at the top level while
//     the pane route kept `item=OLD`, and a reload opened the OLD record.
//
// So a key the pane route ALREADY carries is patched there too — never
// added there (the top level carries a same-page open, exactly as before).
// The bridge still never writes `?page=` itself: it moves the pane's state
// and PageSlot's own URL sync writes the address (`_slotUrlNext` retires
// the keys it mirrored for the old route and mirrors the new one).
//
// NO RE-MOUNT: PageSlot reads "same route, different query" as a deep-link
// change and re-mounts the page (`_mountPane`: `live._slotPath === path` is
// the only keep-alive hit). The host is stamped with the new route BEFORE
// the state write, so the mount pass sees the page it already has — scroll,
// inputs and in-flight loads survive a close.
//
// SCOPE: the pane must show a page an installed module serves — the SAME
// `_servesPage` the surface guard reads (the composed stash's pages OR an
// installed app's own `root.workspaceApps[].pages`). This check used to read
// `root.workspaceProject.pages` alone, and the composed stash does not
// always carry the apps' pages (an app-only workspace's "no module" pass
// publishes `workspaceProject: null`; a takeover republish writes the
// takeover's pages only), while `root.workspaceApps[]` does. So an App Store
// app's clear reached the address bar and never its pane route: Catalog's
// `?new=1&name=` (Inventory's "Create in Products") and Orders' `?new=1&
// party=` stayed in `?page=`, and a re-mount or a reload of the pane opened
// a second create form (lane RQ, 2026-10-30).
//
// Returns true when the pane route changed.
const $79fe5514f6c578df$var$_patchPaneRoute = (el, root, entries)=>{
    const host = (0, $25fky.slotHostOf)(el);
    if (!host || !root || typeof root.update !== 'function') return false;
    const paneKey = host._slotPaneKey || '_canvasSlot';
    const current = root[paneKey];
    if (typeof current !== 'string' || !current || current !== host._slotPath) return false;
    const hashAt = current.indexOf('#');
    const hash = hashAt === -1 ? '' : current.slice(hashAt);
    const bare = hashAt === -1 ? current : current.slice(0, hashAt);
    const qAt = bare.indexOf('?');
    if (qAt === -1) return false;
    const path = bare.slice(0, qAt);
    if (!$79fe5514f6c578df$var$_servesPage(root, path)) return false;
    const query = new URLSearchParams(bare.slice(qAt + 1));
    let changed = false;
    for (const [rawKey, rawVal] of entries){
        const key = String(rawKey || '').trim();
        if (!key || $79fe5514f6c578df$var$_RESERVED_SHELL_PARAMS.has(key) || !query.has(key)) continue;
        const val = rawVal == null ? '' : String(rawVal);
        if (!val) query.delete(key);
        else if (query.get(key) !== val) query.set(key, val);
        else continue;
        changed = true;
    }
    if (!changed) return false;
    const qs = query.toString();
    const next = path + (qs ? '?' + qs : '') + hash;
    host._slotPath = next;
    root.update({
        [paneKey]: next
    });
    return true;
};
const $79fe5514f6c578df$export$e8941de054606122 = (root)=>{
    return function setModuleRouteQuery(patch) {
        try {
            if (typeof window === 'undefined') return false;
            const surface = $79fe5514f6c578df$var$_moduleSurface(root, (0, $25fky.slotHostOf)(this));
            if (!surface) return false;
            const entries = patch == null ? [
                ...$79fe5514f6c578df$var$_declaredParamsFor(root, surface.route)
            ].map((k)=>[
                    k,
                    null
                ]) : Object.entries(patch || {});
            // The pane first: its URL sync rewrites the address, so the top-level
            // write below must read the address AFTER it, or it would put back the
            // keys the sync just retired.
            const paneChanged = $79fe5514f6c578df$var$_patchPaneRoute(this, root, entries);
            // A second-pane caller ends at its own pane route: the address is the
            // primary's mirror. A key its route does not carry is written nowhere
            // (the pane half never adds keys; the app's state holds the open).
            if (surface.second) return paneChanged;
            const url = new URL(window.location.href);
            for (const [rawKey, rawVal] of entries){
                const key = String(rawKey || '').trim();
                if (!key || $79fe5514f6c578df$var$_RESERVED_SHELL_PARAMS.has(key)) continue;
                const val = rawVal == null ? '' : String(rawVal);
                if (!val) url.searchParams.delete(key);
                else url.searchParams.set(key, val);
            }
            const next = url.pathname + url.search + url.hash;
            const current = window.location.pathname + window.location.search + window.location.hash;
            if (next === current) return paneChanged;
            window.history.replaceState(window.history.state, '', next);
            return true;
        } catch (e) {
            console.warn('[setModuleRouteQuery] failed:', e?.message || e);
            return false;
        }
    };
};

});
parcelRegister("D8RKl", function(module, exports) {

$parcel$export(module.exports, "SEARCH_APPS", () => $075a85363babcf9d$export$f33149dad166df4d);
$parcel$export(module.exports, "launcherTitleKeyFor", () => $075a85363babcf9d$export$4be3014a4ee5a606);
$parcel$export(module.exports, "launcherGlyphName", () => $075a85363babcf9d$export$1613c61a44b8bdf1);
$parcel$export(module.exports, "SEARCH_APP_GROUPS", () => $075a85363babcf9d$export$6e0511a1e21edf5e);
$parcel$export(module.exports, "ADMIN_APPS", () => $075a85363babcf9d$export$16beef9fca2a07d);
$parcel$export(module.exports, "searchAppGroupsFor", () => $075a85363babcf9d$export$98ebb44fe6e216d0);
$parcel$export(module.exports, "launcherTileGroups", () => $075a85363babcf9d$export$9d7478b54159aa4e);
$parcel$export(module.exports, "APP_WINDOW_ROUTES", () => $075a85363babcf9d$export$6c7412efa782d5ff);
$parcel$export(module.exports, "isCanvasRoute", () => $075a85363babcf9d$export$ce9a58c81b5bc771);
$parcel$export(module.exports, "isPaneableCanvasRoute", () => $075a85363babcf9d$export$6c2aada7ac7767c);
$parcel$export(module.exports, "SPLIT_MIN_WIDTH_PX", () => $075a85363babcf9d$export$58dce729e9384f7d);
$parcel$export(module.exports, "splitFitsWidth", () => $075a85363babcf9d$export$48aceb885a091d2c);
$parcel$export(module.exports, "foldSplitBelowWidthFloor", () => $075a85363babcf9d$export$ae878117d24a9a82);
$parcel$export(module.exports, "foldSplitOnResize", () => $075a85363babcf9d$export$b5208b08d795ad71);
$parcel$export(module.exports, "isFullPageRoute", () => $075a85363babcf9d$export$847294ee6676ff0a);
$parcel$export(module.exports, "openAppPage", () => $075a85363babcf9d$export$93dba0d3859ef79f);
$parcel$export(module.exports, "selectAppFromSwitcher", () => $075a85363babcf9d$export$20f4d2d91b2a0fd);
$parcel$export(module.exports, "noteSearchAppsDismissed", () => $075a85363babcf9d$export$8b0f972b08e4700);
$parcel$export(module.exports, "searchAppsJustDismissed", () => $075a85363babcf9d$export$c4ea51dea8dd34da);
$parcel$export(module.exports, "forgetSearchAppsDismissed", () => $075a85363babcf9d$export$e4e4ca79c66596ea);
$parcel$export(module.exports, "cancelSearchAppsClose", () => $075a85363babcf9d$export$fa8ae6ee936db55d);
$parcel$export(module.exports, "scheduleSearchAppsClose", () => $075a85363babcf9d$export$6b168a5fb3f29a5);
$parcel$export(module.exports, "openSearchAppsDropdown", () => $075a85363babcf9d$export$a833dc4e24507113);
$parcel$export(module.exports, "searchLauncherIsOpen", () => $075a85363babcf9d$export$84d127fecd70af50);
$parcel$export(module.exports, "ensureSearchLauncher", () => $075a85363babcf9d$export$d9fb49e60c3b2c1f);
$parcel$export(module.exports, "closeSearchLauncher", () => $075a85363babcf9d$export$f09924b3ac485553);
$parcel$export(module.exports, "toggleSearchAppsDropdown", () => $075a85363babcf9d$export$2722e9321df09a42);
$parcel$export(module.exports, "focusSearchLauncher", () => $075a85363babcf9d$export$c998b3a3991369cf);
$parcel$export(module.exports, "focusHeaderSearch", () => $075a85363babcf9d$export$5456a73090679116);
// Apps launcher — search-focus dropdown + app navigation.
//
// Replaces the home AppsWidget card (removed 2026-06-06 per Nika): the
// same app list now appears as a @symbo.ls/dropdown panel anchored to
// the global search bar whenever the (empty) search input gains focus.
// Navbar apps own their URLs; other app opens use PageSlot.
// The four canvas views (Frontend · Infra · Tasks · Agents) — single source of
// truth is CanvasViewNav's VIEW_NAV (the left-rail switcher). The apps launcher
// surfaces them as their own VIEWS section so the navbar dropdown offers the
// same view-switch the sidebar does, without re-typing the routes.
// ⚠ VIEW_NAV must stay a DEFERRED read (getViewNav(), never a module-scope
// `const { VIEW_NAV } = _wsShared.components`): this module loads INSIDE
// the shared-barrel init cycle — same class as workspaceProjects.js/
// pageContext.js/featureFlags.js's fix note — and a module-scope
// destructure here crashed the PRODUCTION BUILD itself ("Cannot
// destructure property 'VIEW_NAV' of '...default.components' as it is
// undefined", smbls push, tickets/execution-board.md §1).

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $aGIjc = parcelRequire("aGIjc");

var $kO6Bt = parcelRequire("kO6Bt");
const $075a85363babcf9d$var$shellNavItemVisible = (...args)=>(0, $1X0Je.default).functions.navItemVisible(...args);
const $075a85363babcf9d$var$shellCleanHref = (...args)=>(0, $1X0Je.default).functions.cleanHref(...args);
const $075a85363babcf9d$var$shellSlotPaneKeyFor = (...args)=>(0, $1X0Je.default).functions.slotPaneKeyFor(...args);
const $075a85363babcf9d$var$shellIsModuleCanvasRoute = (...args)=>(0, $1X0Je.default).functions.isModuleCanvasRoute(...args);
const $075a85363babcf9d$var$getViewNav = ()=>(0, $1X0Je.default).components.VIEW_NAV;
const $075a85363babcf9d$export$f33149dad166df4d = [
    // Work — day-to-day execution surfaces.
    {
        title: 'shell.viewNav.workspaceApps',
        caption: 'shell.launcher.workspaceApps.caption',
        icon: 'grid',
        iconBg: 'blue',
        category: 'Work',
        route: '/apps'
    },
    {
        title: 'shell.viewNav.websites',
        caption: 'shell.launcher.studio.caption',
        icon: 'layers',
        glyph: 'studio',
        iconBg: 'blue',
        category: 'Work',
        route: '/studio'
    },
    // Infrastructure — the /infra canvas (services, environments, status).
    // Nika 2026-09-09 "make Infrastructure as one builtin app as others": the
    // route, its pages and its VIEW lens existed, but no launcher tile, navbar
    // row or home tile listed it. Icon + hue mirror the infra lens
    // (CanvasViewNav VIEW_NAV 'server', VIEW_TILE_BG cerulean).
    {
        title: 'shell.launcher.infra.title',
        caption: 'shell.launcher.infra.caption',
        icon: 'server',
        glyph: 'infra',
        iconBg: 'cerulean',
        category: 'Work',
        route: '/infra',
        // A developer tool: off a business workspace's launcher (persona audit
        // WH-8 — see searchAppGroupsFor).
        dev: true
    },
    // Marketplace moved OUT of the tile grid into the launcher header as the
    // "App Store" action (2026-07-30 per Nika "remove marketplace from search
    // dropdown … rename marketplace with app store").
    {
        title: 'shell.launcher.tasks.title',
        caption: 'shell.launcher.tasks.caption',
        icon: 'check',
        glyph: 'tasks',
        iconBg: 'green',
        category: 'Work',
        route: '/tasks'
    },
    // Documents + Files were missing from the launcher entirely (2026-08-05 per
    // Nika "why documents and files are not in search dropdown") even though both
    // own a navbar slot and a Home tile. Title / icon / route mirror
    // shared/components/AppNavbar.js's NAV_APPS + DROPDOWN_APPS entries exactly,
    // and they sit here in that same tickets → documents → files order.
    {
        title: 'shell.launcher.notes.title',
        caption: 'shell.launcher.notes.caption',
        icon: 'document',
        glyph: 'notes',
        iconBg: 'cerulean',
        category: 'Work',
        route: '/notes'
    },
    {
        title: 'shell.launcher.files.title',
        caption: 'shell.launcher.files.caption',
        icon: 'folder',
        glyph: 'files',
        iconBg: 'orange',
        category: 'Work',
        route: '/files'
    },
    {
        title: 'shell.launcher.chat.title',
        caption: 'shell.launcher.chat.caption',
        icon: 'chat',
        glyph: 'chat',
        iconBg: 'cerulean',
        category: 'Work',
        route: '/chat'
    },
    // Mail — the built-in email client (architecture/MAIL.md). The route, its
    // PageSlot registration (APP_WINDOW_ROUTES below), the header envelope and
    // both navbar copies all existed; the launcher tile was the one listing
    // that was still missing. Glyph mirrors the header button and the two
    // AppNavbar rows exactly ('email'), and it sits directly after Chat here
    // because that is the order both navbar copies already use (chat → mail →
    // meet). No hand-carried flag: `searchAppGroupsFor` filters every tile
    // through `navItemVisible`, whose ROUTE_FLAGS maps '/mail' → the
    // dark-by-default `mail` feature flag — the same one resolver the header
    // button and the navbar rows gate on, so the tile appears exactly when
    // they do and never on a workspace that has Mail switched off.
    {
        title: 'shell.launcher.mail.title',
        caption: 'shell.launcher.mail.caption',
        icon: 'email',
        glyph: 'mail',
        iconBg: 'blue',
        category: 'Work',
        route: '/mail'
    },
    {
        title: 'shell.launcher.calendar.title',
        caption: 'shell.launcher.calendar.caption',
        icon: 'date outline',
        glyph: 'calendar',
        iconBg: 'red',
        category: 'Work',
        route: '/calendar'
    },
    {
        title: 'shell.launcher.meet.title',
        caption: 'shell.launcher.meet.caption',
        icon: 'video',
        glyph: 'meet',
        iconBg: 'blue',
        category: 'Work',
        route: '/meet'
    },
    {
        title: 'shell.launcher.reminders.title',
        caption: 'shell.launcher.reminders.caption',
        icon: 'clockOutline',
        glyph: 'reminders',
        iconBg: 'red',
        category: 'Work',
        route: '/reminders'
    },
    // History — the built-in timeline of the workspace activity log. Gated
    // like every tile here: navItemVisible resolves '/history' through
    // ROUTE_FLAGS to the `history` flag.
    {
        title: 'shell.launcher.history.title',
        caption: 'shell.launcher.history.caption',
        icon: 'sfHistory',
        glyph: 'history',
        iconBg: 'purple',
        category: 'Work',
        route: '/history'
    },
    {
        title: 'shell.launcher.broadcast.title',
        caption: 'shell.launcher.broadcast.caption',
        icon: 'bell',
        glyph: 'broadcast',
        iconBg: 'purple',
        category: 'Work',
        route: '/announcements'
    },
    // Team — people + agents.
    {
        title: 'shell.launcher.teamAndAgents.title',
        caption: 'shell.launcher.teamAndAgents.caption',
        icon: 'people',
        glyph: 'teamAndAgents',
        iconBg: 'purple',
        category: 'Team',
        route: '/team-and-agents'
    },
    {
        title: 'shell.launcher.agents.title',
        caption: 'shell.launcher.agents.caption',
        icon: 'star',
        glyph: 'agents',
        iconBg: 'orange',
        category: 'Team',
        route: '/agents'
    },
    {
        title: 'shell.launcher.teamMembers.title',
        caption: 'shell.launcher.teamMembers.caption',
        icon: 'user',
        glyph: 'teamMembers',
        iconBg: 'cerulean',
        category: 'Team',
        route: '/team-members'
    },
    {
        title: 'shell.launcher.users.title',
        caption: 'shell.launcher.users.caption',
        icon: 'globe',
        glyph: 'users',
        iconBg: 'blue',
        category: 'Team',
        route: '/team-members'
    },
    // Insights — observability surfaces.
    {
        title: 'shell.launcher.analytics.title',
        caption: 'shell.launcher.analytics.caption',
        icon: 'analytics',
        glyph: 'analytics',
        iconBg: 'green',
        category: 'Insights',
        route: '/analytics'
    },
    // Workspace usage dashboard — the "Workspace" tab of the merged analytics
    // surface (AnalyticsNavbar.js), previously reachable only by opening
    // Analytics first and switching tabs. Same 'analytics' feature-flag scope
    // as the Analytics tile above (featureFlags.js / appAccess.js both map
    // '/workspace-analytics' to the 'analytics' flag), so it appears/hides in
    // lockstep with it. 2026-08-09 audit: /workspace-analytics rendered but had
    // no launcher entry point of its own.
    {
        title: 'shell.launcher.workspaceUsage.title',
        caption: 'shell.launcher.workspaceUsage.caption',
        icon: 'analytics',
        glyph: 'usage',
        iconBg: 'purple',
        category: 'Insights',
        route: '/workspace-analytics'
    }
];
function $075a85363babcf9d$export$4be3014a4ee5a606(route) {
    const p = String(route || '');
    if (!p || p !== p.split('#')[0].split('?')[0]) return '';
    const tile = $075a85363babcf9d$export$f33149dad166df4d.find((t)=>t && t.route === p);
    return tile && typeof tile.title === 'string' ? tile.title : '';
}
function $075a85363babcf9d$export$1613c61a44b8bdf1(tile) {
    return (0, $1X0Je.default).functions.glyphNameFor.call(this, tile, 'px');
}
// VIEWS section — the four canvas lenses, mapped from CanvasViewNav's VIEW_NAV
// into the springboard tile shape ({ title, icon, iconBg, route }). Routes stay
// single-sourced in VIEW_NAV; only the per-tile gradient colour is assigned
// here (VIEW_NAV carries no iconBg). Tiles navigate via selectAppFromSwitcher →
// openAppPage, same as every other app.
const $075a85363babcf9d$var$VIEW_TILE_BG = {
    workspaceApps: 'blue',
    websites: 'green',
    frontend: 'blue',
    infra: 'cerulean',
    tasks: 'green',
    agents: 'purple'
};
// The canvas lenses are the developer's lab (the Frontend / Infra / Agents
// canvases): every view tile is a developer tool (persona audit WH-8). A
// business workspace keeps Apps and Websites through the Work group.
const $075a85363babcf9d$var$_searchViewApps = ()=>$075a85363babcf9d$var$getViewNav().map((v)=>({
            title: v.label,
            icon: v.icon,
            iconBg: $075a85363babcf9d$var$VIEW_TILE_BG[v.key] || 'blue',
            category: 'Views',
            route: v.path,
            dev: true
        }));
const $075a85363babcf9d$export$6e0511a1e21edf5e = ()=>[
        // `category` stays an ENGLISH JOIN KEY — it is the internal field every
        // SEARCH_APPS row is filtered by, never rendered. `label` is what a reader
        // sees, so it is the polyglot key. Keeping the two apart is why translating
        // the launcher did not have to touch a single row's `category`.
        ...[
            [
                'Work',
                'shell.launcher.groupWork'
            ],
            [
                'Team',
                'shell.launcher.groupTeam'
            ],
            [
                'Insights',
                'shell.launcher.groupInsights'
            ]
        ].map(([category, label])=>({
                key: category.toLowerCase(),
                label: label,
                apps: $075a85363babcf9d$export$f33149dad166df4d.filter((a)=>a.category === category)
            })),
        {
            key: 'views',
            label: 'shell.launcher.groupViews',
            apps: $075a85363babcf9d$var$_searchViewApps()
        }
    ];
const $075a85363babcf9d$export$16beef9fca2a07d = [
    {
        title: 'shell.launcher.adminConsole.title',
        caption: 'shell.launcher.adminConsole.caption',
        icon: 'settings',
        iconBg: 'red',
        category: 'Admin',
        route: '/admin',
        // the line glyph (glyphNames.js reads only the first route segment, '/admin')
        glyph: 'tools'
    },
    {
        title: 'shell.launcher.moduleConsole.title',
        caption: 'shell.launcher.moduleConsole.caption',
        icon: 'blocks',
        iconBg: 'purple',
        category: 'Admin',
        route: '/admin/module',
        // the line glyph (glyphNames.js reads only the first route segment, '/admin')
        glyph: 'apps',
        // a developer tool (persona audit WH-8)
        dev: true
    },
    {
        title: 'shell.launcher.permissions.title',
        caption: 'shell.launcher.permissions.caption',
        icon: 'lock',
        iconBg: 'orange',
        category: 'Admin',
        route: '/admin/permissions',
        // the line glyph (glyphNames.js reads only the first route segment)
        glyph: 'lock'
    },
    {
        title: 'shell.launcher.teams.title',
        caption: 'shell.launcher.teams.caption',
        icon: 'people',
        iconBg: 'cerulean',
        category: 'Admin',
        route: '/admin/teams',
        // the line glyph (glyphNames.js reads only the first route segment, '/admin')
        glyph: 'teamMembers'
    },
    {
        title: 'shell.launcher.usage.title',
        caption: 'shell.launcher.usage.caption',
        icon: 'analytics',
        iconBg: 'green',
        category: 'Admin',
        route: '/admin/usage',
        // the line glyph (glyphNames.js reads only the first route segment, '/admin')
        glyph: 'usage'
    },
    {
        title: 'shell.launcher.adminLogs.title',
        caption: 'shell.launcher.adminLogs.caption',
        icon: 'document',
        iconBg: 'blue',
        category: 'Admin',
        route: '/admin/logs',
        // the line glyph (glyphNames.js reads only the first route segment, '/admin')
        glyph: 'history'
    },
    {
        title: 'shell.launcher.featureFlags.title',
        caption: 'shell.launcher.featureFlags.caption',
        icon: 'state',
        iconBg: 'green',
        category: 'Admin',
        route: '/admin/flags',
        // the line glyph (glyphNames.js reads only the first route segment)
        glyph: 'flag',
        // a developer tool (persona audit WH-8)
        dev: true
    },
    {
        title: 'shell.launcher.systemHealth.title',
        caption: 'shell.launcher.systemHealth.caption',
        icon: 'state',
        iconBg: 'phosphorus',
        category: 'Admin',
        route: '/admin/system',
        // the line glyph (glyphNames.js reads only the first route segment, '/admin')
        glyph: 'health',
        // a developer tool (persona audit WH-8)
        dev: true
    },
    {
        title: 'shell.launcher.data.title',
        caption: 'shell.launcher.data.caption',
        icon: 'database',
        iconBg: 'purple',
        category: 'Admin',
        route: '/data/projects',
        // the line glyph (glyphNames.js reads only the first route segment)
        glyph: 'database',
        // a developer tool (persona audit WH-8)
        dev: true
    }
];
const $075a85363babcf9d$export$98ebb44fe6e216d0 = (root)=>{
    const rawApps = root?.workspaceProject?.config?.apps || root?.workspaceSettings?.apps;
    // Normalize + dedupe the workspace group. Both sources can carry thin rows
    // (an extension's { label, path } ref, a stored bare { route } row, a
    // manifest tile without icon/iconBg) — normalizeLauncherTile is the ONE
    // canonical guard that maps them to the full { title, icon, iconBg, route }
    // contract so a tile can never render nameless with an empty glyph (the
    // natali blank-tiles bug, 2026-07-30). Dedupe by route||title —
    // resolveWorkspaceConfig appends installed apps' tiles onto config.apps, and
    // a module that also lists its own tiles produced doubles (CMS/Contacts ×2,
    // live 2026-07-25).
    const seenApp = new Set();
    const apps = (Array.isArray(rawApps) ? rawApps : []).map((0, $kO6Bt.normalizeLauncherTile)).filter((a)=>{
        if (!a) return false;
        const k = String(a.route || a.title || '').toLowerCase();
        if (!k || seenApp.has(k)) return false;
        seenApp.add(k);
        return true;
    });
    // Root cause of the persistent duplicate-Admin-section bug (Fable
    // 2026-08-09): when `apps.length` was falsy this used to assign the
    // MODULE-LEVEL CONSTANT `SEARCH_APP_GROUPS` directly (no copy) to `groups`,
    // and the `.push()` below then mutated that shared singleton IN PLACE —
    // every dropdown open in a workspace with no launcher tiles (any org whose
    // config/settings carry no `apps`, e.g. a fresh install or right after an
    // uninstall drops the last app) permanently appended ANOTHER 'Admin' group
    // onto the constant every session touched it. Repeat installs/uninstalls
    // (and the system-org HQ workspace, which has no custom launcher tiles)
    // compounded it fast. Always build a NEW array here — `.push()` must never
    // reach a module-level constant.
    const groups = apps.length ? [
        {
            // i18n — the two leading reads are the CUSTOMER'S OWN workspace
            // name and must reach the renderer untouched; only the last-resort
            // fallback is shipped chrome, so only it is a polyglot key. The
            // render sites (SearchAppsMenu SasHead, PageSlot's rail GroupLabel)
            // pass every label through `polyglot`, which resolves the key and
            // returns a name it has never heard of unchanged — so one call
            // serves both without a branch here.
            key: 'workspace-apps',
            label: (root?.workspace || {}).displayName || (root?.workspace || {}).name || 'shell.app.workspace',
            apps: apps
        },
        ...$075a85363babcf9d$export$6e0511a1e21edf5e()
    ] : [
        ...$075a85363babcf9d$export$6e0511a1e21edf5e()
    ];
    // Admin group — appended last. Explicit `key` (not just
    // `label`) so SamSections' childrenAs:'state' reconciles this and every
    // other group by stable IDENTITY rather than array position — the same
    // class of bug the navbar arrangement comment above warns about, just
    // hitting from the opposite direction (a shifting group COUNT, not a
    // shared key), and a stable key forecloses it regardless of mechanism.
    //
    // IT FOLLOWS EACH PAGE'S OWN GATE (3c; concierge decision 2026-10-31 23:35,
    // the admin menus follow the page's own gate). The group shows when the
    // person's role opens at least one /admin page (roleHelpers
    // `adminAreaAccess`: the rule of the account menu's Admin entry,
    // functions/adminRail.js `canOpenAdmin`, asked with no element, because
    // this builder runs bare: SearchAppsMenu, the ⌘K search). A tile hides when
    // its page answers 'closed' (roleHelpers `adminPageAccess`, the gate that
    // page runs); a page still waiting for its inputs keeps its tile, as the
    // page keeps the person. The Admin console tile opens the admin area
    // itself: /admin forwards a person Users & Roles keeps out to the first
    // page their role opens (pages/admin/admin.js), so it shows whenever the
    // group does. A route the gate table does not know (/data/projects: the
    // Data app has no role gate of its own) keeps its tile. Before: the whole
    // group, every tile, on `currentUserIsAdmin`, so a workspace admin who is
    // only an org member had no Admin group, and a person some admin pages
    // send away saw their tiles.
    if ((0, $aGIjc.adminAreaAccess)(root) === 'open' && !groups.some((g)=>g && g.key === 'admin')) {
        const adminApps = $075a85363babcf9d$export$16beef9fca2a07d.filter((a)=>a.route === '/admin' || (0, $aGIjc.adminPageAccess)(root, a.route) !== 'closed');
        groups.push({
            key: 'admin',
            label: 'shell.launcher.groupAdmin',
            apps: adminApps
        });
    }
    // Feature-flag gate: tiles whose route maps to a disabled flag drop out
    // (navItemVisible / ROUTE_FLAGS); groups that empty out disappear whole.
    //
    // Per-VIEWER gate (GA D1 "railless" follow-through): a module config tile
    // may carry `visible(root, tile) → boolean` — a frank-revived function the
    // MODULE ships (workspace config functions arrive live through the module
    // loader), so persona/role trimming stays module-owned while the shell
    // stays abstract. Absent → shown; a throwing gate also shows (a broken
    // module fn must never hide navigation). Server settings rows are plain
    // JSON and can't carry functions — this is deliberately a module-config
    // capability only.
    const viewerVisible = (a)=>{
        if (typeof a?.visible !== 'function') return true;
        try {
            return a.visible(root, a) !== false;
        } catch (err) {
            console.warn("[searchApps] tile visible() threw \u2014 showing tile:", a?.title, err?.message);
            return true;
        }
    };
    // A BUSINESS workspace keeps the developer tools out of its launcher
    // (persona audit WH-8: a clinic's launcher carried Infrastructure, Module
    // console, Feature flags, System health and Data). The workspace attribute
    // is `settings.preset` — the work its owner chose (an industry or
    // "Something else"; CONTRACT §1, functions/adminRail.js
    // workspaceIsBusiness); the tile's own `dev: true` says which tools are a
    // developer's. A workspace with no preset keeps every tool. The tools stay
    // reachable from the admin rail's "Developer tools" group.
    const _preset = root?.workspace?.settings?.preset;
    const _business = !!(_preset && typeof _preset.key === 'string' && _preset.key);
    const seenRoutes = new Set();
    return groups.map((g)=>({
            ...g,
            apps: (g.apps || []).filter((a)=>{
                if (_business && a && a.dev === true) return false;
                if (!$075a85363babcf9d$var$shellNavItemVisible(root, a) || !viewerVisible(a)) return false;
                const route = (0, $7iFOV.shellStripWorkspacePrefix)(String(a.route || '')).replace(/\/$/, '') || '/';
                if (seenRoutes.has(route)) return false;
                seenRoutes.add(route);
                return true;
            })
        })).filter((g)=>g.apps.length);
};
function $075a85363babcf9d$export$9d7478b54159aa4e(root) {
    const groups = $075a85363babcf9d$export$98ebb44fe6e216d0(root);
    const selected = root?._launcherGroup || 'all';
    const shown = selected === 'all' || !groups.some((g)=>g.key === selected) ? groups : groups.filter((g)=>g.key === selected);
    const query = root?._launcherMode === 'trigger' ? String(root._launcherFilter || '').trim().toLowerCase() : '';
    if (!query) return shown;
    const matches = (app)=>{
        const name = this.call('storeItemText', {
            key: app.appKey,
            name: app.title
        }, 'name');
        const caption = app.caption ? this.call('polyglot', app.caption) : '';
        return `${name || ''} ${caption || ''}`.toLowerCase().includes(query);
    };
    return shown.map((g)=>({
            ...g,
            apps: (g.apps || []).filter(matches)
        })).filter((g)=>g.apps.length);
}
const $075a85363babcf9d$export$6c7412efa782d5ff = new Set([
    // Every NON-CANVAS app in the search dropdown opens inside the shell
    // PageSlot — paired with `_APP_WINDOW_PAGES` in pages/main.js for page
    // registration (2026-06-08 per Nika). The canvas surfaces that also appear
    // below (/studio, /tickets, /team-and-agents, /agents, /my-agents) are in
    // the set ONLY for that registration pairing: `openAppPage`'s `isCanvasRoute`
    // gate (checked first) routes them as a FULL canvas page, never the slot —
    // they carry fixed/absolute children + their own scratch config and flicker
    // when mounted in the slot. Rule: non-canvas apps → PageSlot, canvas pages →
    // full page (per Nika 2026-07-16).
    '/studio',
    // Marketplace is a non-canvas app — opens in the PageSlot. PageSlot's _defFor
    // resolves it via _CANVAS_SLOT_PAGES (canvas/components/PageSlot.js), so it
    // mounts in-slot without an _APP_WINDOW_PAGES entry (that pairing only adds
    // the `?page=/marketplace` reload-restore on the home route).
    '/marketplace',
    // `/add-app` sits in the SAME launcher header as the App Store and Following
    // buttons (SearchAppsMenu.js), all three opening via `openAppPage`. With the
    // other two now landing in the slot, leaving this one full-page would make
    // three adjacent buttons behave differently for no reason the user can see
    // (2026-08-09 per Nika "mostly all non-canvas pages should open in
    // pageslot"). Non-canvas, so no _APP_WINDOW_PAGES pairing is needed to
    // mount — that pairing only adds the `?page=` reload-restore.
    '/add-app',
    '/chat',
    // Mail — the built-in email client (architecture/MAIL.md), a non-canvas
    // app: opens in the PageSlot, paired with `_APP_WINDOW_PAGES` in
    // pages/main.js. Its SEARCH_APPS launcher tile is registered above
    // (strings: `shell.launcher.mail.*` in shell.json).
    '/mail',
    // Canonical /tasks + legacy /tickets aliases (tickets→tasks rename
    // 2026-08-06) — both forms stay registered for the `_APP_WINDOW_PAGES`
    // pairing; isCanvasRoute still routes the board full-page.
    '/tasks',
    '/tasks/my',
    '/tickets',
    '/tickets/my',
    '/calendar',
    '/reminders',
    // History — a non-canvas app: opens in the PageSlot, paired with
    // `_APP_WINDOW_PAGES` in pages/main.js.
    '/history',
    '/notes',
    '/documents',
    // Merged analytics: /analytics = Projects family (overview + map +
    // logs), /workspace-analytics = Workspace usage. All open in the
    // PageSlot — paired with `_APP_WINDOW_PAGES` in pages/main.js.
    '/analytics',
    '/analytics/map',
    '/analytics/sessions',
    // Projects-family views registered in _APP_WINDOW_PAGES (pages/main.js)
    // but missing here: visitors (WS-ANALYTICS-UTM-CAMPAIGNS-UI-1) + bugs /
    // events (pre-existing gap).
    '/analytics/visitors',
    '/analytics/bugs',
    '/analytics/events',
    '/analytics/logs/users',
    '/analytics/logs/sessions',
    '/analytics/logs/session',
    '/workspace-analytics/logs/session',
    '/analytics/logs/events',
    '/analytics/logs/bugs',
    '/analytics/logs/network',
    '/analytics/logs/verbose',
    '/workspace-analytics',
    '/workspace-analytics/map',
    '/workspace-analytics/logs/users',
    '/team-and-agents',
    '/agents',
    '/my-agents',
    // '/studio' + the canvas surfaces above are kept in the set for the
    // `_APP_WINDOW_PAGES` registration pairing (2026-06-10 per Nika "all apps in
    // SearchDropdown should be reachable"). They still open FULL-PAGE via
    // isCanvasRoute — the flicker that first excluded /studio is exactly why the
    // canvas gate keeps them out of the slot (see the header comment above).
    '/meet',
    '/announcements',
    '/team-members',
    '/system-status',
    // '/admin' kept ONLY for the `_APP_WINDOW_PAGES` ?page= registration
    // pairing — it no longer opens in the slot: isFullPageRoute short-circuits
    // openAppPage to full-page above (2026-07-25 per Nika "admin pages should
    // not open in pageSlot"). Admin is a full settings surface with its own
    // AdminSidebar.
    '/admin'
]);
// Full-bleed pan/zoom CANVAS surfaces — these MUST land as the full canvas
// (a hard top-level route) and never inside the windowed home PageSlot, even
// from home. Mirrors the 'canvas' route-kinds in pages/app.js (the surfaces
// that get <html data-shell-route="canvas">): /studio, /canvas, /files,
// /infra, /tickets (board route only), /team-and-agents, /agents, /my-agents.
// Without this, a header-navbar tab to Studio/Tasks/Agents/Infra from `/`
// opened cramped in the AppWindow PageSlot instead of landing the canvas —
// the "sometimes the navbar opens a PageSlot when it should land the canvas"
// bug. These are real top-level routes, so router() never 404s them.
const $075a85363babcf9d$var$_CANVAS_ROUTE_RE = /^\/(studio|canvas|files|infra|team-and-agents|agents|my-agents)(\/|$)/;
function $075a85363babcf9d$export$ce9a58c81b5bc771(route) {
    const p = (0, $7iFOV.shellStripWorkspacePrefix)(String(route || '').split('?')[0].split('#')[0]);
    // /tasks (canonical) and /tickets (legacy alias) are canvas ONLY for the
    // board route; /tasks/my, /tasks/* are windowed app pages (matches
    // _isTicketsCanvasPath in pages/app.js).
    return p === '/tasks' || p === '/tickets' || $075a85363babcf9d$var$_CANVAS_ROUTE_RE.test(p);
}
// D2 §8.2 — the CANVAS surfaces a DELIBERATE split may put in a pane.
//
// A ticket opens beside what you are reading and a file opens as
// `/files?node=<key>`; both are canvas routes, so `isCanvasRoute` above sent
// them full-page before `openAppPage` ever reached its split branch, and a
// split of either was impossible. Measured 2026-09-10 on the local shell
// against staging: `openAppPage('/tasks?ticket=…', { preferSlot: true,
// split: true })` from inside an open pane replaced the whole shell with the
// tasks board and never wrote `_canvasSlotSecond`.
//
// Deliberately NARROWER than `isCanvasRoute`: /studio, /canvas, /infra,
// /agents, /team-and-agents and /my-agents carry fixed/absolute children and
// their own scratch config, and they still have no pane form. Only the two
// surfaces D2 names are listed. The allowance is gated on INTENT at the call
// site (see `openAppPage`), never on the route alone — a plain navbar or
// launcher click still lands the canvas.
const $075a85363babcf9d$var$_PANEABLE_CANVAS_RE = /^\/(tasks|tickets|files)(\/|$)/;
function $075a85363babcf9d$export$6c2aada7ac7767c(route) {
    return $075a85363babcf9d$var$_PANEABLE_CANVAS_RE.test((0, $7iFOV.shellStripWorkspacePrefix)(String(route || '').split('?')[0].split('#')[0]));
}
const $075a85363babcf9d$export$58dce729e9384f7d = 1024;
function $075a85363babcf9d$export$48aceb885a091d2c(width) {
    const w = Number(width) || 0;
    return !w || w >= $075a85363babcf9d$export$58dce729e9384f7d;
}
const $075a85363babcf9d$var$_viewportWidth = ()=>typeof window !== 'undefined' && window ? Number(window.innerWidth) || 0 : 0;
// The state a FOLDED split leaves behind — the same four keys PageSlot's own
// second-pane dismissal writes (`_dismissPane(root, false)`, canvas/components/
// PageSlot.js): the pane's route, any in-progress split intent, and the pane's
// own history + rail flags, which are a lineage that dies with it. Declared
// once here so the two shell callers below cannot drift from each other.
const $075a85363babcf9d$var$_FOLD_SPLIT = {
    _canvasSlotSecond: null,
    _slotSplitIntent: false,
    _slotHistSecond: null,
    _slotRailSecond: false,
    // one pane left: a "Keep this pane open" pin has nothing to keep apart
    _slotPinned: null
};
function $075a85363babcf9d$export$ae878117d24a9a82(root, width) {
    if (!root || typeof root.update !== 'function') return false;
    if ($075a85363babcf9d$export$48aceb885a091d2c(width)) return false;
    if (!root._canvasSlotSecond && !root._slotSplitIntent) return false;
    root.update({
        ...$075a85363babcf9d$var$_FOLD_SPLIT
    });
    return true;
}
function $075a85363babcf9d$export$b5208b08d795ad71() {
    const root = this?.state?.root || this?.state;
    return $075a85363babcf9d$export$ae878117d24a9a82(root, $075a85363babcf9d$var$_viewportWidth());
}
// STRICT pane probe — "is this caller INSIDE a PageSlot pane?".
//
// `slotPaneKeyFor` (shared) answers the WRITER's question, "which pane state
// key should this opener write", and DELIBERATELY falls through to the
// primary for a caller that is in no pane at all (navbar, launcher, toast).
// That default is right for the write and useless for this decision: a navbar
// click and an in-pane click both read '_canvasSlot' from it. Returns the
// stamp or null. Hop-capped exactly like its sibling. It lives here because
// packages/shared is read-only for this squad.
const $075a85363babcf9d$var$_callerPaneKey = (el)=>{
    let node = el;
    let hops = 0;
    while(node && hops < 100){
        const key = node._slotPaneKey;
        if (key === '_canvasSlot' || key === '_canvasSlotSecond') return key;
        if (node.parent === node) break;
        node = node.parent;
        hops++;
    }
    return null;
};
// Full-page SETTINGS destinations — /admin/* and /data/* carry their OWN
// AdminSidebar nav, so they must land as a real top-level page, never the
// cramped modal PageSlot: a sidebar-in-a-sheet can't drive slot routing,
// so its links fired shell navigations that left the slot open over a
// stale page (2026-07-25 per Nika "fix admin pages opening in pageSlot
// from search dropdown"). Like isCanvasRoute, this wins over the
// APP_WINDOW_ROUTES / preferSlot branches below.
// Unlike ordinary app navigation (which can explicitly split), these surfaces
// always own the page, including explicit pane requests.
const $075a85363babcf9d$var$_FULLPAGE_ROUTE_RE = /^\/(admin|data)(\/|$)/;
const $075a85363babcf9d$var$_routePath = (route)=>(0, $7iFOV.shellStripWorkspacePrefix)(String(route || '').split(/[?#]/)[0]).replace(/\/+$/, '') || '/';
function $075a85363babcf9d$export$847294ee6676ff0a(route) {
    return $075a85363babcf9d$var$_FULLPAGE_ROUTE_RE.test($075a85363babcf9d$var$_routePath(route));
}
// Navigation reads paths, not rendered tabs: loading and presentation flags
// must not discard already-known configuration or resolve translated labels.
const $075a85363babcf9d$var$_navbarOwnsAppRoute = (route, root)=>{
    const { components: components, functions: functions } = (0, $1X0Je.default);
    const prefs = functions.navbarTabPrefs(root);
    const { settings: settings, ready: ready, workspace: workspace } = functions.workspaceSettings(root);
    const lc = (value)=>String(value || '').toLowerCase();
    const org = lc(root?.org?.id || root?.org?._id);
    const ownsRecord = ready && org && org === lc(workspace.organization || workspace.organizationId || workspace.org);
    const saved = root?.workspaceSettings?.navbar;
    const config = Array.isArray(saved) && saved.length ? saved : ownsRecord && Array.isArray(settings?.navbar) ? settings.navbar : [];
    const path = $075a85363babcf9d$var$_routePath(route);
    const canonical = functions.canonicalRoutePath;
    const matches = (tab, custom = false)=>{
        if (!tab?.path) return false;
        const base = $075a85363babcf9d$var$_routePath(tab.path);
        const suffix = String(tab.path).slice(String(tab.path).search(/[?#]|$/));
        // A record/view pin owns exactly that destination. Only an app-root pin
        // (one path segment) or a configured app tab owns descendant routes.
        if (suffix || custom && base.split('/').filter(Boolean).length > 1) {
            const targetSuffix = String(route).slice(String(route).search(/[?#]|$/));
            return canonical(base) === canonical(path) && suffix === targetSuffix;
        }
        return components.HeaderTabs.scope.matchesPath(base, path);
    };
    return components.HEADER_TABS.some((tab)=>matches(tab)) || config.some((tab)=>!prefs.hidden.includes(tab?.path) && matches(tab)) || prefs.pinnedCustom.some((tab)=>!prefs.hidden.includes(tab?.path) && matches(tab, true));
};
function $075a85363babcf9d$export$93dba0d3859ef79f(route, opts) {
    const out = $075a85363babcf9d$var$_openAppRoute.call(this, route, opts);
    if (opts && opts.pin) {
        const root = this?.state?.root || this?.state;
        const at = root && route ? [
            '_canvasSlotSecond',
            '_canvasSlot'
        ].find((k)=>root[k] && $075a85363babcf9d$var$shellCleanHref(root[k]) === $075a85363babcf9d$var$shellCleanHref(route)) : null;
        if (at && root._slotPinned !== at) root.update({
            _slotPinned: at
        });
    }
    return out;
}
// Not `_openAppPage`: workspaceProjects.js declares its own `_openAppPage`
// (entry, path, el, s) for the opening placeholder, and frank lifts both into
// the shell's ONE flat globalScope under the bare name. frank 3.14.792 kept
// this one for both, so the PUBLISHED placeholder's onRender ran this route
// opener with an entry object; frank 3.14.800 refuses the pair
// (module-scope-name-conflict).
function $075a85363babcf9d$var$_openAppRoute(route, opts) {
    if (!route) return;
    const root = this?.state?.root || this?.state;
    // D2 §5 (P1): a context menu is anchored to viewport coordinates on the
    // surface it was opened from, so every open dismisses it. The shell root's
    // `onRouteChanged` covers ROUTER navigations, but a PageSlot open writes
    // `_canvasSlot` and fires no route event at all — which is exactly the
    // navigation D2 measured a stray menu surviving TWICE (Data Rooms →
    // Decisions → board are all slot opens). One line at the single choke point
    // every opener already funnels through.
    try {
        this?.call?.('closeContextMenuOnRouteChange');
    } catch (_) {}
    // Gesture→intent mapping lives HERE, beside the mechanics it triggers:
    // callers may pass { split: true } explicitly OR forward their raw click
    // event — cmd/ctrl is normalized once for every opener (header tabs, search,
    // app tiles), so the split gesture can never drift per call site.
    // Split intent: an explicit gesture (cmd/ctrl-click, forwarded event) OR the
    // PageSlot header's split button, which arms `root._slotSplitIntent` so the
    // NEXT app pick lands in the second pane (consumed + cleared here).
    const split = !!(opts && (opts.split || opts.metaKey || opts.ctrlKey) || root?._slotSplitIntent);
    if (root?._slotSplitIntent) root.update({
        _slotSplitIntent: false
    });
    // Legacy callers still pass preferSlot. It keeps in-pane links in their
    // current host and lets installed app routes resolve in PageSlot.
    const preferSlot = !!(opts && opts.preferSlot);
    // PANE INTENT — the one thing that can put a D2 §8.2 canvas surface
    // (/tasks, /tickets, /files) in a pane instead of the full canvas. Two
    // shapes, both deliberate:
    //   • an explicit split gesture (`opts.split`, cmd/ctrl-click, or the
    //     header's split button via `_slotSplitIntent` — all already folded
    //     into `split` above), or
    //   • a `preferSlot` open fired from INSIDE an already-open pane (an
    //     in-app link, a module row's Open): the user is reading in a pane and
    //     asked for the next thing, so the next thing belongs in a pane too.
    // A navbar tab or a launcher tile is NEITHER — it carries no split gesture
    // and sits outside every pane — so it still lands the canvas. That is the
    // "sometimes the navbar opens a PageSlot when it should land the canvas"
    // bug (the reason `isCanvasRoute` exists at all), and it stays fixed.
    const callerPaneKey = $075a85363babcf9d$var$_callerPaneKey(this);
    const fromOpenPane = !!(callerPaneKey && root && root[callerPaneKey]);
    const paneIntent = split || preferSlot && fromOpenPane;
    const appPath = (0, $7iFOV.shellStripWorkspacePrefix)(String(route).split('?')[0].split('#')[0]);
    // Chat has two entry surfaces but only one may be visible at a time:
    // navigating to its PageSlot dismisses the floating MessengerOverlay first.
    // Keep this at the route choke point so every HeaderTabs variant and every
    // other route opener observes the same singleton contract.
    if (appPath === '/chat' && root?._chatDrawerOpen) root.update({
        _chatDrawerOpen: false
    });
    // A builder address that names an app (`/add-app?thread=<id>` — a deep
    // link, the search's Your apps rows, the builder's "Open <app>" line —
    // BLD-28) binds that app FIRST, so the builder opens on it wherever it
    // opens: the home's Build tab, a pane or the page (a pane reads no address
    // bar; /add-app keys its thread on `_addAppProjectId`).
    if (appPath === '/add-app' && root && typeof root.update === 'function') {
        const query = String(route).split('#')[0].split('?')[1] || '';
        const thread = new URLSearchParams(query).get('thread');
        if (thread && String(root._addAppProjectId || '') !== thread) root.update({
            _addAppProjectId: thread
        }, {
            preventFetch: true
        });
    }
    // THE HOME'S BUILD TAB IS /add-app (functions/homeBuild.js; Nika
    // 2026-10-23: "build tab should reuse ui/ux of /add-apps"): on the home,
    // its tabs on screen, the builder opens as that tab — never a second
    // builder in a pane over it (both would hold the one thread and the one
    // render address). A deep link's thread binds the builder (above); a split
    // gesture still asks for a pane.
    const homeFns = this && this.context && this.context.functions || {};
    if (appPath === '/add-app' && !paneIntent && root && typeof homeFns.homeTabsOnScreen === 'function' && typeof homeFns.homeViewSelect === 'function' && this.call('homeTabsOnScreen', root)) {
        this.call('homeViewSelect', 'build');
        return true;
    }
    // A plain app pick on its dedicated page keeps that existing surface and
    // its filters/draft. Explicit destinations and pane gestures still navigate.
    const currentPath = String(root?.currentPath || '').split('?')[0].split('#')[0];
    if (!paneIntent && !callerPaneKey && !root?._canvasSlot && !root?._canvasSlotSecond && !/[?#]/.test(route) && currentPath && (0, $7iFOV.shellStripWorkspacePrefix)(currentPath) === appPath && (!String(route).startsWith('/w/') || currentPath === route)) return true;
    // Navbar membership decides normal opens, including installed apps.
    // A deliberate split, an existing split/pin, or navigation within a pane
    // retains the pane host. Read membership on every open so pin/unpin and
    // workspace switches take effect without a reload or a route allowlist.
    const hasPaneSession = !!(fromOpenPane || root?._canvasSlotSecond || root?._slotPinned && root[root._slotPinned]);
    if (!paneIntent && !hasPaneSession && !(opts && opts.pin) && $075a85363babcf9d$var$_navbarOwnsAppRoute(route, root)) {
        if (root?._slotPinned) root.update({
            _slotPinned: null
        });
        return this.router(route, this.getRoot());
    }
    const canvasMayPane = paneIntent && $075a85363babcf9d$export$6c2aada7ac7767c(route);
    // Canvas surfaces always land as the full canvas — never the windowed
    // PageSlot, even from home. (See isCanvasRoute above.) Admin + data
    // settings surfaces are full-page for the same "own sidebar nav" reason
    // (isFullPageRoute) and have NO pane form at all.
    // An installed module's canvas page (manifest `canvasRoutes`) lands as the
    // full canvas too — the root Zoombar drives it only on its own route.
    const moduleCanvas = !paneIntent && $075a85363babcf9d$var$shellIsModuleCanvasRoute($075a85363babcf9d$var$_routePath(route), root);
    if ($075a85363babcf9d$export$ce9a58c81b5bc771(route) && !canvasMayPane || moduleCanvas || $075a85363babcf9d$export$847294ee6676ff0a(route)) return this.router(route, this.getRoot());
    // Slot lookups compare the PATH, never the raw href. Callers legitimately
    // pass query- and hash-carrying routes — the launcher's App Store button
    // sends `/marketplace?surface=appstore`, chat deep-links carry `?channel=`
    // — and an exact `Set.has()` on the raw string misses every one of them.
    // That is why the App Store opened as a FULL PAGE instead of the PageSlot
    // (2026-08-09 per Nika "opening appstore and mostly all non-canvas pages
    // should open in pageslot"): `/marketplace` is in the set, but
    // `/marketplace?surface=appstore` is a different string.
    //
    // `isCanvasRoute` and `isFullPageRoute` above already normalize exactly this
    // way; only this gate did not, so the three route tests disagreed with each
    // other about what a route even was. The FULL route (query + hash intact) is
    // still what gets opened — normalization decides, it never rewrites.
    const slotPath = $075a85363babcf9d$var$_routePath(route);
    // A sub-path belongs to its app: `/marketplace/feed` is the marketplace,
    // `/analytics/logs/anything` is analytics. Registering every leaf explicitly
    // is what left `/marketplace/feed` (the launcher's Following button) opening
    // full-page while its own parent opened in the slot. Safe as a prefix test
    // because both "always full page" gates — isCanvasRoute and isFullPageRoute
    // — return above this point, so `/admin/*` and the canvas surfaces are
    // already gone even though `/admin` and `/tickets` sit in this set.
    const isAppWindowRoute = $075a85363babcf9d$export$6c7412efa782d5ff.has(slotPath) || [
        ...$075a85363babcf9d$export$6c7412efa782d5ff
    ].some((r)=>slotPath.startsWith(r + '/'));
    // A workspace-project page (root.workspaceProject.pages) opens in the PageSlot
    // too — these routes live only in the active workspace's project, so they're
    // not in the shared APP_WINDOW_ROUTES set.
    const isProjectPage = !!(root && root.workspaceProject && root.workspaceProject.pages && (root.workspaceProject.pages[slotPath] || root.workspaceProject.pages[route]));
    // Non-canvas app + workspace-module pages open in the shell PageSlot from
    // ANY surface, not just home (2026-07-14 per Nika "all non-canvas pages
    // from search dropdown should open in PageSlot"). The old `path === '/'`
    // gate predates the slot move: PageSlot is now mounted once at the shell
    // root (app.js `PageSlot: {}`), so it exists on every page, and these
    // routes resolve everywhere via el.context.pages (shell registry + the
    // active module's injected pages). Canvas surfaces already returned above.
    if (isAppWindowRoute || isProjectPage || preferSlot || canvasMayPane) {
        // Split view (iPad style): `opts.split` (cmd/ctrl+click on a navbar tab)
        // opens the route in the SECOND PageSlot pane beside the current one.
        // Without an open primary there's nothing to split against — fall through
        // to a plain primary open. Same-route splits are a no-op re-focus.
        // NARROW WINDOW (D2 §8.4): below SPLIT_MIN_WIDTH_PX a split request opens
        // the route in the PRIMARY pane instead — the same open, one pane. The
        // shell owns this floor because a split can arrive without ever passing
        // the module's own disabled menu row: a cmd/ctrl-click, the pane header's
        // split button, or an opener that armed `_slotSplitIntent` on a wide
        // window and fired it after a resize. Without it `openAppPage` split at
        // ANY width and a phone got two ~190px panes. The module's own-item sheet
        // is untouched by this — it never reaches openAppPage.
        const fitsWidth = $075a85363babcf9d$export$48aceb885a091d2c($075a85363babcf9d$var$_viewportWidth());
        // THE CALLER'S PANE (resolved once; rule (1) below reuses it). A split
        // ALWAYS opens in the pane OPPOSITE the caller (Nika 2026-10-09: "clicking
        // from a decision to other apps like data room opens in split view"): from
        // the left pane the right one, from the RIGHT pane the LEFT one — never the
        // caller's own pane, which used to happen when the caller sat in the second
        // pane (a decision there was replaced by the app it linked to). The target
        // pane is REPLACED, never stacked. A call from outside any pane keeps the
        // old target, the second pane. A split to the route the caller already
        // shows is no split (it falls through to the pane-scoped re-focus).
        const paneKey = this ? $075a85363babcf9d$var$shellSlotPaneKeyFor(this) : '_canvasSlot';
        // ASK BEFORE REPLACING (Nika 2026-10-10): a split — and a call the pin
        // redirects — REPLACES a pane. When the page that pane SHOWS declares
        // unsaved work — the shell's one dirty rule, hasUnsavedInput (an `isDirty`
        // hook or a `dirty` flag) — ask with the one prompt, confirmDiscardChanges.
        // Keep (also Esc, the veil, a refused layer) leaves both panes as they
        // are; Discard replaces. The shown page is the host canvas PageSlot
        // records per pane (`_markLiveHost`); a parked keep-alive host is not
        // recorded, because a replace keeps it. An empty pane, a clean page, or a
        // surface without the shell prompt (canvas standalone) is replaced at once.
        const replaceAsking = (target)=>{
            const replace = ()=>root.update({
                    [target]: route,
                    _slotFullscreen: null
                });
            const live = root[target] && root.__slotLiveHosts && root.__slotLiveHosts[target];
            const fns = this?.context?.functions;
            if (live && live.__ref && fns && typeof fns.hasUnsavedInput === 'function' && typeof fns.confirmDiscardChanges === 'function' && this.call('hasUnsavedInput', live)) {
                this.call('confirmDiscardChanges', {
                    onDiscard: replace,
                    onKeep: ()=>{}
                });
                return;
            }
            replace();
        };
        // THE OPT-IN PIN (Nika 2026-10-10: "Yes, opt-in pin"). `root._slotPinned`
        // names the pane a user (the pane header's "Keep this pane open") or a
        // module (`{ pin: true }`) keeps. A pin on a pane that shows nothing is
        // stale, and below the split floor there is ONE pane, so the pin cannot
        // hold: both clear it. While it holds, a call from OUTSIDE every pane
        // (navbar, launcher, search — split or not) acts as a split from the
        // pinned pane: the route replaces the OTHER pane; a route the pinned pane
        // already shows is focus only. Nothing is pinned by default.
        let pinned = root._slotPinned === '_canvasSlot' || root._slotPinned === '_canvasSlotSecond' ? root._slotPinned : null;
        if (root._slotPinned && (!pinned || !root[pinned] || !fitsWidth)) {
            root.update({
                _slotPinned: null
            });
            pinned = null;
        }
        if (pinned && !callerPaneKey) {
            if ($075a85363babcf9d$var$shellCleanHref(root[pinned]) === $075a85363babcf9d$var$shellCleanHref(route)) return;
            replaceAsking(pinned === '_canvasSlot' ? '_canvasSlotSecond' : '_canvasSlot');
            return;
        }
        if (split && fitsWidth && root._canvasSlot && root[paneKey] !== route) {
            // the pinned pane is never a split's target: the caller's own pane is
            let target = paneKey === '_canvasSlotSecond' ? '_canvasSlot' : '_canvasSlotSecond';
            if (target === pinned) target = paneKey;
            replaceAsking(target);
            return;
        }
        // BELOW THE FLOOR THERE IS EXACTLY ONE PANE — so the open lands in the
        // primary AND a split still standing from a wider window folds away, in
        // the SAME write. Without this half the guard only refused the NEW split:
        // it fell through to the pane-scoped branches below, which either wrote
        // the primary while the old second pane stayed on screen, or (for a
        // caller inside that second pane) wrote the second pane itself — both
        // measured live at a verified 1000px on the deployed staging shell as two
        // 491px panes. See `foldSplitBelowWidthFloor`.
        //
        // Unconditional on `split`: a PLAIN open is just as bound by the floor as
        // a split gesture is. The condition is the width, never the gesture.
        if (!fitsWidth && (root._canvasSlotSecond || root._slotSplitIntent)) {
            root.update({
                _canvasSlot: route,
                ...$075a85363babcf9d$var$_FOLD_SPLIT
            });
            return;
        }
        // PANE-SCOPED targeting (split-view fix, 2026-08-06 per Nika "fix bug
        // when its on split view - it often changes both views on navigation
        // click"). Two rules, in order:
        //
        // (1) An open fired from INSIDE a pane lands in THAT pane. el.call binds
        //     `this` to the origin element, and PageSlot stamps `_slotPaneKey` on
        //     every pane + keep-alive host, so slotPaneKeyFor resolves the origin
        //     pane by a parent walk — an in-pane click (marketplace tile, in-app
        //     link) must never retarget the sibling pane.
        //
        // (2) A route already living in the SECOND pane re-focuses/deep-links
        //     THERE instead of also writing the primary (iPad semantics: tapping
        //     an app that's already in the split shows the split). This is ALSO
        //     the guard that restores this function's documented idempotency
        //     under double-fire openers: HeaderTabs fires _openTab on BOTH
        //     onMousedown (pointer path) and onClick (keyboard path) — with
        //     `_slotSplitIntent` armed, the mousedown call consumed the intent
        //     and landed the route in the second pane, then the click call re-ran
        //     with the intent cleared and wrote the SAME route into the PRIMARY:
        //     one click changed both panes (the reported bug). Now the second
        //     call resolves to the second pane and dedupes to a no-op.
        if (paneKey === '_canvasSlotSecond') {
            root.update({
                _canvasSlotSecond: route
            });
            return;
        }
        if (root._canvasSlotSecond && $075a85363babcf9d$var$shellCleanHref(root._canvasSlotSecond) === $075a85363babcf9d$var$shellCleanHref(route)) {
            root.update({
                _canvasSlotSecond: route
            });
            return;
        }
        root.update({
            _canvasSlot: route
        });
        return;
    }
    return this.router(route, this.getRoot());
}
function $075a85363babcf9d$export$20f4d2d91b2a0fd(route, opts) {
    if (!route) return;
    const root = this?.state?.root || this?.state;
    // Save thread: snapshot the live Simone buffer into root.sessions — but only
    // when there's something to save, so empty "New chat" threads don't pile up
    // in history. persistActiveSession is a no-op without an active session.
    try {
        if ((root?.chatMessages || []).length) this.call('persistActiveSession');
    } catch (_) {
    /* simone session fns absent off the workspace shell — ignore */ }
    // Switching apps no longer auto-opens the assistant drawer / chat history —
    // that fired on every PageSlot open / page switch and was disruptive. The
    // thread is still saved above, so it stays resumable when the user opens the
    // assistant deliberately (the magic-star toggle). (2026-06-22 per Nika "fix
    // why opening PageSlot or switching page triggers assistant opening".)
    // preferSlot: a pick from the app switcher is the same *kind* of gesture as a
    // navbar tab click, so it gets the same container. Without this the two
    // disagreed for any route outside the static APP_WINDOW_ROUTES set — an
    // installed module's tab ('/crm', '/cms') opened in the PageSlot from the
    // navbar and as a FULL PAGE from the search dropdown, for the same app.
    //
    // The intent has been on record since 2026-07-14 ("all non-canvas pages from
    // search dropdown should open in PageSlot"); it was implemented by listing
    // routes in APP_WINDOW_ROUTES, which cannot cover module routes that only
    // exist once an app is installed. Declaring the intent is what generalizes.
    // Restated 2026-08-09: "opening appstore and mostly all non-canvas pages
    // should open in pageslot from / page, search dropdown and navbar".
    //
    // Safe because preferSlot only ever routes NON-canvas links FROM HERE:
    // isCanvasRoute and isFullPageRoute both return ahead of it, so canvas
    // surfaces and the /admin + /data settings pages (which carry their own
    // sidebar nav) still take the full page. The D2 §8.2 pane allowance for
    // /tasks + /files needs an explicit split gesture or an origin INSIDE an
    // open pane. The switcher is outside every pane, but preserves an explicit
    // split gesture in opts. openAppPage remains the one intent normalizer.
    this.call('openAppPage', route, {
        ...opts,
        preferSlot: true
    });
}
// Hover-close debounce (module-level, mirrors the More-menu pattern in
// shared/components/AppNavbar.js): the search opens the panel on hover
// too, so leaving the pill arms a 200ms close that the panel's own
// mouseenter cancels — the cursor can travel from the pill into the
// grid without it snapping shut.
let $075a85363babcf9d$var$_searchAppsCloseTimer = null;
// A dismissal STAMP. The dropdown plugin restores focus to the closing
// layer's restoreEl, and for this launcher that target is the search INPUT
// (A2-08 — anything else drops the user's keystrokes). The input's own
// onFocus opens the launcher, so every close handed focus back to the one
// element that re-opened it: Escape, an outside click and a tile pick all
// looked like they did nothing (measured live — layerId stayed 'searchApps'
// through an Escape, with focus on the Input).
//
// SearchAppsMenu.onRemove stamps here as the body unmounts, which is inside
// closeDropdown's own state write and therefore BEFORE its focus restore.
// The input's onFocus reads the stamp and lets that one focus pass without
// opening anything. Deliberate opens (the chevron, Cmd+K, a click into the
// field) are unaffected — they arrive well outside the window.
let $075a85363babcf9d$var$_searchAppsDismissedAt = 0;
const $075a85363babcf9d$var$SEARCH_APPS_REOPEN_GRACE_MS = 400;
function $075a85363babcf9d$export$8b0f972b08e4700() {
    $075a85363babcf9d$var$_searchAppsDismissedAt = Date.now();
}
function $075a85363babcf9d$export$c4ea51dea8dd34da() {
    return Date.now() - $075a85363babcf9d$var$_searchAppsDismissedAt < $075a85363babcf9d$var$SEARCH_APPS_REOPEN_GRACE_MS;
}
function $075a85363babcf9d$export$e4e4ca79c66596ea() {
    $075a85363babcf9d$var$_searchAppsDismissedAt = 0;
}
function $075a85363babcf9d$export$fa8ae6ee936db55d() {
    if ($075a85363babcf9d$var$_searchAppsCloseTimer) {
        clearTimeout($075a85363babcf9d$var$_searchAppsCloseTimer);
        $075a85363babcf9d$var$_searchAppsCloseTimer = null;
    }
}
function $075a85363babcf9d$export$6b168a5fb3f29a5() {
    const el = this;
    $075a85363babcf9d$export$fa8ae6ee936db55d();
    // Dismiss-inert is CANVAS-SURFACE-ONLY — that is its whole reason to
    // exist: a drag started during the ~200ms fade must reach the pan/zoom
    // board underneath instead of being swallowed by the dismissing panel
    // (the July /studio drag bug, smbls 834d6ba23 + workspace 1c483192).
    // Arming it EVERYWHERE was the "search dropdown doesn't open / flickers
    // when the PageSlot is open" bug (Nika 2026-08-06): pointer-events:none
    // also kills the panel's OWN mouseenter, so the documented re-enter
    // cancel could never fire — and the focused-skip below kept the panel
    // OPEN but permanently click-through: an open panel where no tile click
    // lands, every click passing through to whatever sits beneath (over an
    // open slot sheet, very visibly so). Non-canvas surfaces keep a solid
    // panel through the debounce; re-entering it cancels the close again.
    const _onCanvasSurface = typeof window !== 'undefined' && $075a85363babcf9d$export$ce9a58c81b5bc771(window.location.pathname || '');
    if (_onCanvasSurface) el.call('setDropdownInert', true);
    $075a85363babcf9d$var$_searchAppsCloseTimer = setTimeout(()=>{
        $075a85363babcf9d$var$_searchAppsCloseTimer = null;
        // Keep the panel open as long as the search input is still focused
        // (2026-07-14 per Nika "fix dropdown that hides on mouseout — keep it as
        // long as search is focused"). mouseleave off the panel/pill fires this
        // close, but while the user is focused/typing the panel must stay — only
        // a real blur (focus left the pill) or the dropdown plugin's outside-click
        // should close it. A HOVER-opened panel (input not focused) still closes
        // on mouseout, unchanged.
        if (typeof document !== 'undefined') {
            const active = document.activeElement;
            // A2-06 — focus INSIDE the launcher counts exactly as much as focus in
            // the pill. Arrowing or tabbing from the field into a tile blurs the
            // input, which is what schedules this close; without this clause the
            // panel dismissed itself the moment a keyboard user reached it, so it
            // could never be operated from the keyboard at all. The panel is matched
            // by the PLUGIN's own marker: the layer body mounts through `el.set`, so
            // it carries the key `content`, never the component's own name.
            // A menu of the SEARCH (a launcher tile's or a result row's — opened
            // with `fromNavSearch`) takes focus and sits over the panel, so both the
            // input's blur and the panel's mouseleave schedule this close while it
            // is up: the launcher stays behind its own menu. Every close of that
            // menu nulls `contextDropdown`, and the next leave closes as before.
            const menu = el && el.state && el.state.root && el.state.root.contextDropdown;
            const inside = active && active.closest && (active.closest('[data-key="HeaderSearch"]') || active.closest('[data-smbls-dropdown="panel"]')) || !!(menu && menu.open && menu.fromNavSearch);
            if (inside) {
                // Close skipped — the panel lives on and MUST be interactive again.
                // Leaving the dismiss-inert armed here was the permanent
                // click-through state described above.
                el.call('setDropdownInert', false);
                return;
            }
        // Focus HAS left the pill and the panel, so this close is a consequence
        // of the user moving on — falls through to the close below. Used to
        // also retarget the plugin's restore here (`keepDropdownFocus`); no
        // shell-side retarget is needed any more.
        // @symbo.ls/dropdown's closeDropdown now makes this check itself
        // (FW-DROPDOWN-CLOSE-RESTORES-FOCUS-UNCONDITIONALLY-1): it restores
        // focus only when the close would otherwise lose it — <body>, or
        // still inside the closing panel — and leaves it alone here, where
        // `active` is a real control outside both.
        }
        // Stamp the dismissal before the close — see noteSearchAppsDismissed.
        $075a85363babcf9d$export$8b0f972b08e4700();
        el.call('closeDropdown', 'searchApps');
    }, 200);
}
function $075a85363babcf9d$export$a833dc4e24507113(opts) {
    $075a85363babcf9d$export$fa8ae6ee936db55d();
    // Fresh open — a brand-new dropdown layer starts pointer-interactive
    // (openDropdown never carries a stale `inert`), but clear defensively in
    // case a previous dismiss left the same layer inert mid-close.
    this.call('setDropdownInert', false);
    const anchorEl = opts?.anchorEl || this;
    const root = this?.state?.root || this?.state;
    const dropdownRoot = this.getRoot?.()?.DropdownRoot;
    const splitPicker = !!root?._slotSplitIntent;
    const railLauncher = !!opts?.anchorRect && /^(left|right)/.test(opts?.placement || '');
    // The search model of this open (`_launcherMode`, launcherTileGroups):
    // only the header search's own path (ensureSearchLauncher) asks for the
    // companion; every other opener — the navbar chevron, the home App strip —
    // is a trigger, and a trigger's own filter starts empty: a word typed in the
    // last panel must not hide tiles in this one.
    const launcherMode = opts?.launcherMode === 'companion' ? 'companion' : 'trigger';
    if (typeof root?.update === 'function') root.update(launcherMode === 'trigger' ? {
        _launcherMode: launcherMode,
        _launcherFilter: ''
    } : {
        _launcherMode: launcherMode
    }, {
        preventFetch: true
    });
    this.call('openDropdown', {
        id: 'searchApps',
        // A navbar rail's chevron hands a RECT and a side instead (shared
        // functions/navbarLayout.js navbarMenuAnchor): the rail's outer edge at
        // the chevron's height, the panel beside the rail.
        ...opts?.anchorRect ? {
            anchorRect: opts.anchorRect
        } : {
            anchorEl: anchorEl
        },
        restoreEl: opts?.restoreEl || anchorEl,
        onClose: ()=>{
            if (!splitPicker) return;
            // App rows close the dropdown before opening their destination in
            // the same event. Let that selection consume the intent first; a
            // dismissal without a selection clears the empty split pane.
            queueMicrotask(()=>{
                // Revealing/focusing the header input replaces this same launcher.
                // The picker is still open; its previous layer is not a dismissal.
                if (dropdownRoot?.state?.layer?.id === 'searchApps') return;
                // Typing hands the same picker to the search results. Keep its
                // destination until a result is picked or the search is dismissed.
                if (root?._navSearchOpen) return;
                if (root?._slotSplitIntent) root.update({
                    _slotSplitIntent: false
                });
            });
        },
        // Drop the panel DOWN from the navbar search pill (anchored just below it)
        // with the directional slide-in animation, instead of the viewport-centered
        // spotlight (2026-06-18 per Nika "should be down to the navbar, open with
        // animation" — reverses the 2026-06-17 'center' placement). 'bottom-center'
        // keeps the wide panel horizontally centered under the (centered) pill while
        // resolving side='bottom' → fadeInTransform translateY(-6px) slide.
        // Beside a rail: the side the opener names ('right-end', …).
        placement: opts?.placement || 'bottom-center',
        // As wide as the body asks (9A, Nika 2026-09-28: "make it more wider and
        // add maxWidth also"): SearchAppsMenu declares `width: 'overlayXl'`, the
        // brand's wide overlay, and the positioned panel shrink-wraps it. Only
        // the VIEWPORT bound lives here — a max, never a min: the old fixed
        // min = max pair (760 px) kept the panel from ever being the token's
        // width, and a min that exceeds the max would win and overflow.
        // The launcher's WIDTH is a token on its body; the only numbers here are
        // the viewport bounds the positioned panel may never pass (32px gutter).
        // Keep a rail launcher beside the rail even when the wide body cannot
        // fit at its preferred size. The plugin leaves an 8px gap at each edge.
        maxWidth: opts?.anchorRect && opts?.placement?.startsWith('right') ? `calc(100dvw - ${opts.anchorRect.right}px - 16px)` : opts?.anchorRect && opts?.placement?.startsWith('left') ? `${Math.max(0, opts.anchorRect.left - 16)}px` : 'calc(100dvw - 32px)',
        maxHeight: railLauncher ? 'calc(100dvh - 16px)' : 'calc(100dvh - 32px)',
        // THE GLASS SITS ON THE LAYER — the popover recipe (DESIGN_SPEC 6.1: the
        // shell glass on the overlay elevation, the card radius), the same opt-in
        // NotificationBell and AiSettingsButton pass. The body (SearchAppsMenu)
        // paints no surface of its own.
        // Why not on the body (it was, until the live check of 3efc1eace on dev,
        // 2026-09-30): the plugin Panel is a BACKDROP ROOT for as long as it is
        // open — @symbo.ls/dropdown writes `opacity: 0.999` on it, and its open
        // keyframe keeps `animation-fill-mode: both` on opacity, which acts as
        // `will-change: opacity`. A backdrop-filter INSIDE a backdrop root samples
        // only that root's own surface, and the Panel's was empty: the page text
        // showed sharp through the .55 fill (111 under the glass = the fill alone;
        // luminance spread 77.9 against 3.1 for a control outside the Panel). The
        // Panel's OWN backdrop-filter samples the page, at every opacity.
        // No `background` here: a surface override beats the theme's fill (the
        // plugin paints `--smbls-dropdown-surface` with !important).
        theme: railLauncher ? 'common-box' : 'search-glass',
        shadow: 'overlay',
        // The card radius, the one the body's own rounded clip carries too
        // (SearchAppsMenu: MenuPanel's radiusCard) — a mismatched shell radius
        // clips the corners under the panel's overflow (the corner-peek class the
        // 2026-09-02 dropdown-surface audit fixed on appOrgSwitcher/
        // langSwitcher; this call was its flagged ws-side sibling).
        round: 'radiusCard',
        content: {
            extends: 'SearchAppsMenu',
            railLauncher: railLauncher
        }
    });
}
function $075a85363babcf9d$export$84d127fecd70af50() {
    const layer = this?.getRoot?.()?.DropdownRoot?.state?.layer;
    return !!(layer && layer.id === 'searchApps');
}
function $075a85363babcf9d$export$d9fb49e60c3b2c1f(opts) {
    if (this.call('searchLauncherIsOpen')) {
        const root = this?.state?.root || this?.state;
        if (root?._launcherMode !== 'trigger') return false;
    }
    this.call('openSearchAppsDropdown', {
        ...opts,
        launcherMode: 'companion'
    });
    return true;
}
function $075a85363babcf9d$export$f09924b3ac485553() {
    if (!this.call('searchLauncherIsOpen')) return false;
    this.call('noteSearchAppsDismissed');
    this.call('closeDropdown', 'searchApps');
    return true;
}
function $075a85363babcf9d$export$2722e9321df09a42(opts) {
    const opener = opts?.restoreEl || opts?.anchorEl || this;
    const node = opener?.node || opener;
    const layer = this?.getRoot?.()?.DropdownRoot?.state?.layer;
    if (layer && layer.id === 'searchApps' && node && layer.restoreEl === node) {
        this.call('closeSearchLauncher');
        return false;
    }
    this.call('openSearchAppsDropdown', opts);
    return true;
}
function $075a85363babcf9d$export$c998b3a3991369cf(edge) {
    if (!this.call('searchLauncherIsOpen')) return false;
    const host = this?.getRoot?.()?.DropdownRoot?.node;
    if (!host || typeof host.querySelectorAll !== 'function') return false;
    const rows = [
        ...host.querySelectorAll('[role="menuitem"], [data-launcher-category]')
    ].filter((n)=>!n.hasAttribute('disabled') && typeof n.getClientRects === 'function' && n.getClientRects().length > 0);
    const row = edge === 'last' ? rows[rows.length - 1] : rows[0];
    if (!row || typeof row.focus !== 'function') return false;
    row.focus();
    return true;
}
function $075a85363babcf9d$export$5456a73090679116() {
    const shell = this?.getRoot?.();
    const input = shell?.AppHeader?.HeaderSearch?.Form?.Input?.node;
    if (!input || typeof input.focus !== 'function') return false;
    const root = shell?.state?.root || shell?.state;
    if (root && root._headerSearchOpen === false && typeof root.update === 'function') {
        const active = typeof document !== 'undefined' ? document.activeElement : null;
        if (active && active !== document.body) root.__headerSearchReturnFocusTo = active;
        root.update({
            _headerSearchOpen: true
        });
        return true;
    }
    input.focus();
    return typeof document === 'undefined' || document.activeElement === input;
}

});

parcelRegister("25fky", function(module, exports) {

$parcel$export(module.exports, "slotHostOf", () => $1847f0b8e3c39d4a$export$18e8b29c59d4c933);
$parcel$export(module.exports, "pageParams", () => $1847f0b8e3c39d4a$export$e1acdbbe7c24d88);
$parcel$export(module.exports, "pageParam", () => $1847f0b8e3c39d4a$export$bcd28f10d0b8e3a1);
$parcel$export(module.exports, "pageRoute", () => $1847f0b8e3c39d4a$export$9725e64c244bed22);
$parcel$export(module.exports, "pageHash", () => $1847f0b8e3c39d4a$export$c6d55152ed09c558);
$parcel$export(module.exports, "readPageParam", () => $1847f0b8e3c39d4a$export$4e3a4b6c04a284d3);
$parcel$export(module.exports, "readPageHash", () => $1847f0b8e3c39d4a$export$beff919bb744cc46);
$parcel$export(module.exports, "readPageParams", () => $1847f0b8e3c39d4a$export$c521e88a4604f04a);
$parcel$export(module.exports, "readPageRoute", () => $1847f0b8e3c39d4a$export$81d2ab6916cf3613);
$parcel$export(module.exports, "pageUrl", () => $1847f0b8e3c39d4a$export$4e91d6e2d02f01f1);
$parcel$export(module.exports, "readPageUrl", () => $1847f0b8e3c39d4a$export$6801abcd7c5195f0);
// pageParam — the ONE deep-link parameter reader every app page uses.
//
// "Open always opens the exact spot" (D2 §9) needs three things to hold, and
// the third is the one that kept failing: the target app must read its
// deep-link param WHEN IT MOUNTS, not only when it is already warm. A room's
// "Open" on a Document or a Task set the URL first and mounted the app
// second, so every app that read its param once — at a moment that had
// already passed — landed on its generic list instead of the object.
//
// The reason five apps each grew their own reader is that a param can arrive
// through TWO different channels, and neither one alone is enough:
//
//   1. `window.location.search` — a cold load of `/mail?thread=…`, a module's
//      `setModuleRouteQuery` write, and the PageSlot's own URL mirror
//      (canvas/components/PageSlot.js `_slotUrlNext` copies the PRIMARY
//      pane's route query into the address bar).
//   2. the PANE'S OWN ROUTE — `root._canvasSlot` / `root._canvasSlotSecond`
//      carry the full href (`/mail?thread=…`), and PageSlot stamps that href
//      on the keep-alive host it mounts the page into (`host._slotPath`,
//      beside `host._slotPaneKey`). The SECOND pane is mirrored nowhere else:
//      the address bar belongs to the primary, so a split-pane open is
//      readable ONLY here.
//
// So the reader walks up from the calling element to the nearest slot host
// and merges: the pane's route wins per key, the address bar fills the rest.
// That fallback is what makes a cold `/?page=/vault-training&node=<key>` work
// — the shell re-opens the slot with the PATH, while `node=` stays in
// `location.search` (the module's own `setModuleRouteQuery` writes there too).
// The one place the fallback is refused is a SECOND pane: it must never
// inherit the primary's thread/ticket/event id — and that holds whether or
// not it carries a query of its own, because the address bar it would fall
// back to IS the primary's mirror.
//
// Two faces, ONE implementation (Rule 63):
//   • `pageParam(el, key)` / `pageParams(el)` — pure, for shell code + tests.
//   • `el.call('readPageParam', key)` / `el.call('readPageParams')` — the
//     registry face every app package and every workspace MODULE uses
//     (module bridge: workspaceProjects.js, beside setModuleRouteQuery).
//     App packages must not import across packages for this; el.call is the
//     canonical channel and it works pre-fold on a lazily-merged package.
const $1847f0b8e3c39d4a$var$_SECOND_PANE = '_canvasSlotSecond';
// The query half of a slot route href, or null when it carries none.
const $1847f0b8e3c39d4a$var$_queryOf = (route)=>{
    const raw = String(route || '');
    const q = raw.indexOf('?');
    if (q === -1) return null;
    return new URLSearchParams(raw.slice(q + 1).split('#')[0]);
};
// Nearest ancestor PageSlot keep-alive host — the element PageSlot mounts a
// page def into, stamped with the FULL route (`_slotPath`) and its pane key.
// Returns null when the element is not inside a slot at all (the real-route
// case), so a stale `_canvasSlot` can never leak into a page that is the live
// route. Hop-capped like slotPaneKeyFor, so a malformed parent chain can
// never hang a mount.
const $1847f0b8e3c39d4a$var$_slotHostOf = (el)=>{
    let node = el;
    let hops = 0;
    while(node && hops < 100){
        if (typeof node._slotPath === 'string' && node._slotPath) return node;
        if (node.parent === node) break;
        node = node.parent;
        hops++;
    }
    return null;
};
const $1847f0b8e3c39d4a$export$18e8b29c59d4c933 = (el)=>$1847f0b8e3c39d4a$var$_slotHostOf(el);
const $1847f0b8e3c39d4a$export$e1acdbbe7c24d88 = (el)=>{
    const host = $1847f0b8e3c39d4a$var$_slotHostOf(el);
    const paneQuery = host ? $1847f0b8e3c39d4a$var$_queryOf(host._slotPath) : null;
    // A SECOND pane is self-contained — see header. Not "a second pane that
    // happens to carry a query": the address bar mirrors the PRIMARY pane's
    // route (PageSlot `_writeSlotUrl` / `_slotUrlNext`), so the location
    // fallback is the primary's params by construction, and a second pane with
    // NO query of its own inherited them. Measured 2026-09-10 on the local
    // shell against staging: primary `/notes?id=PRIMARY-AAA`, second pane
    // `/tasks`, and `readPageParam('id')` inside the SECOND pane answered
    // `PRIMARY-AAA` — the address bar read `?page=%2Fnotes%3Fid%3DPRIMARY-AAA&
    // id=PRIMARY-AAA`. Same-app case is the damaging one (primary `/notes?id=A`
    // + second `/notes` opened document A twice, side by side). A second pane's
    // params are its OWN route's query, or none at all.
    if (host && host._slotPaneKey === $1847f0b8e3c39d4a$var$_SECOND_PANE) return paneQuery || new URLSearchParams();
    const search = typeof window !== 'undefined' && window.location ? window.location.search || '' : '';
    const out = new URLSearchParams(search);
    if (paneQuery) for (const [k, v] of paneQuery.entries())out.set(k, v);
    return out;
};
const $1847f0b8e3c39d4a$export$bcd28f10d0b8e3a1 = (el, key)=>{
    const k = String(key || '');
    if (!k) return null;
    const v = $1847f0b8e3c39d4a$export$e1acdbbe7c24d88(el).get(k);
    return v != null && v !== '' ? v : null;
};
const $1847f0b8e3c39d4a$export$9725e64c244bed22 = (el)=>{
    const host = $1847f0b8e3c39d4a$var$_slotHostOf(el);
    if (host) return String(host._slotPath).split('?')[0].split('#')[0];
    if (typeof window === 'undefined' || !window.location) return '';
    return window.location.pathname || '';
};
const $1847f0b8e3c39d4a$export$c6d55152ed09c558 = (el)=>{
    const host = $1847f0b8e3c39d4a$var$_slotHostOf(el);
    if (host) {
        const route = String(host._slotPath);
        const index = route.indexOf('#');
        return index < 0 ? '' : route.slice(index);
    }
    return typeof window !== 'undefined' && window.location ? window.location.hash || '' : '';
};
function $1847f0b8e3c39d4a$export$4e3a4b6c04a284d3(key) {
    return $1847f0b8e3c39d4a$export$bcd28f10d0b8e3a1(this, key);
}
function $1847f0b8e3c39d4a$export$beff919bb744cc46() {
    return $1847f0b8e3c39d4a$export$c6d55152ed09c558(this);
}
function $1847f0b8e3c39d4a$export$c521e88a4604f04a() {
    return $1847f0b8e3c39d4a$export$e1acdbbe7c24d88(this);
}
function $1847f0b8e3c39d4a$export$81d2ab6916cf3613() {
    return $1847f0b8e3c39d4a$export$9725e64c244bed22(this);
}
const $1847f0b8e3c39d4a$export$4e91d6e2d02f01f1 = (el)=>{
    if (typeof window === 'undefined' || !window.location) return '';
    const origin = `${window.location.protocol}//${window.location.host}`;
    const query = $1847f0b8e3c39d4a$export$e1acdbbe7c24d88(el).toString();
    return `${origin}${$1847f0b8e3c39d4a$export$9725e64c244bed22(el)}${query ? `?${query}` : ''}${$1847f0b8e3c39d4a$export$c6d55152ed09c558()}`;
};
function $1847f0b8e3c39d4a$export$6801abcd7c5195f0() {
    return $1847f0b8e3c39d4a$export$4e91d6e2d02f01f1(this);
}

});

parcelRegister("15Bho", function(module, exports) {

$parcel$export(module.exports, "moduleRecordRoutes", () => $0cb32d00164abd2d$export$c88f4425e2cc1d0);
$parcel$export(module.exports, "moduleRecordRoute", () => $0cb32d00164abd2d$export$a930eab8da0e9838);
// The MODULE RECORD-ROUTE REGISTRY — "where does a row of this collection
// open?" (VaultOS v2 design §3.4).
//
// A workspace RECORD (`ref:record:<collection>/<rowId>`) has no shell page.
// Its only home is whatever module page owns its collection, and the shell
// must never learn WHICH module that is — naming one here would make every new
// app a shell change, and would put a tenant's app name in shipped code.
//
// So each installed module declares it, on the `collections` array it already
// uses to declare its owned state keys:
//
//   collections: [{ key: 'vault.items', route: '/vault-rooms', param: 'item' }]
//
// `workspaceProjects.js _normalizeRecordRoutes` validates those rows at load
// (route must be one of the module's own pages, key folded to lower case, a
// half-declaration dropped) and publishes them on
// `root.workspaceProject.recordRoutes` and on each
// `root.workspaceApps[].recordRoutes` — the same two places `opens` rides.
//
// This file is the ONE reader over that pair. Sibling of
// `files/functions/fileHandlers.js liveFileHandlers`, deliberately: same
// union, same order, same reasoning.
//
// ORDER IS THE CONTRACT. The takeover module's rows come first and the
// additive apps' after, so the FIRST declaration of a key wins — an app
// installed from the marketplace can never shadow where the workspace's own
// module opens its records.
//
// ── The one duplicate, and why it is allowed ─────────────────────────────
// `shared/functions/entityRef.js entityRefHref` inlines its own copy of this
// read. It has to: packages must not import from each other (FA001), and
// every function in that file is self-contained on purpose (FA204 — a bare
// sibling read is `undefined` once frank.toJSON has been through it). The two
// stay ONE contract because `__tests__/moduleRecordRoutes.test.js` runs both
// against the same root and requires identical answers. Change one, change
// both, and that test is what says so.
// ── HOW THESE ARE CALLED ──────────────────────────────────────────────────
// Both accept the direct form `(root, …)` AND the `el.call` form, where the
// element is `this` and the root is not passed at all:
//
//   moduleRecordRoute(root, 'vault.items')     // direct (tests, shell code)
//   el.call('moduleRecordRoute', 'vault.items')  // any component
//
// This is not a convenience. `el.call('fn', …args)` runs `fn.call(element,
// …args)` (smbls methods.js), so a component that wrote the obvious call
// passed the COLLECTION KEY into the `root` parameter and got null for every
// lookup — measured live on the worktree shell, 2026-09-09, with a fully
// populated registry sitting right there. A signature that only works when
// the caller knows to thread the root is a signature that will be called
// wrong.
const $0cb32d00164abd2d$var$_recordRoutesRootFrom = (maybeRoot, self)=>{
    if (maybeRoot && typeof maybeRoot === 'object') return maybeRoot;
    if (!self || typeof self !== 'object') return null;
    if (self.state && self.state.root) return self.state.root;
    if (typeof self.getRootState === 'function') try {
        return self.getRootState();
    } catch (_) {
        return null;
    }
    return null;
};
function $0cb32d00164abd2d$export$c88f4425e2cc1d0(maybeRoot) {
    const out = {};
    const root = $0cb32d00164abd2d$var$_recordRoutesRootFrom(maybeRoot, this);
    if (!root || typeof root !== 'object') return out;
    const lists = [];
    const project = root.workspaceProject;
    if (project && typeof project === 'object' && Array.isArray(project.recordRoutes)) lists.push(project.recordRoutes);
    if (Array.isArray(root.workspaceApps)) {
        for (const app of root.workspaceApps)if (app && typeof app === 'object' && Array.isArray(app.recordRoutes)) lists.push(app.recordRoutes);
    }
    for (const rows of lists)for (const row of rows){
        if (!row || typeof row !== 'object') continue;
        const key = row.key == null ? '' : String(row.key).trim().toLowerCase();
        const route = row.route == null ? '' : String(row.route).trim();
        const param = row.param == null ? '' : String(row.param).trim();
        // A half-declared row can never mint a route here either. The loader
        // already dropped these, but a stash written by an older bundle (or a
        // dev override) reaches this function unvalidated.
        if (!key || !route || !param || route.charAt(0) !== '/') continue;
        if (out[key]) continue;
        out[key] = {
            route: route,
            param: param
        };
    }
    return out;
}
function $0cb32d00164abd2d$export$a930eab8da0e9838(rootOrKey, maybeKey) {
    // `(root, key)` when the first argument is an object, `(key)` otherwise —
    // see the note above `_recordRoutesRootFrom`.
    const rootArg = rootOrKey && typeof rootOrKey === 'object' ? rootOrKey : null;
    const rawKey = rootArg ? maybeKey : rootOrKey;
    const key = rawKey == null ? '' : String(rawKey).trim().toLowerCase();
    if (!key) return null;
    const root = $0cb32d00164abd2d$var$_recordRoutesRootFrom(rootArg, this);
    if (!root) return null;
    // Deliberately re-derives the whole map rather than caching: the stash is
    // republished on every workspace activation, and a memo keyed on nothing
    // would serve the previous tenant's routes after a switch.
    const all = $0cb32d00164abd2d$export$c88f4425e2cc1d0.call(this, root);
    return all[key] || null;
}

});


parcelRegister("984mC", function(module, exports) {

$parcel$export(module.exports, "moduleComposerHiddenLive", () => $6a583efa353be6f0$export$37f83fb585c6af79);
$parcel$export(module.exports, "releaseStaleModuleComposerLatch", () => $6a583efa353be6f0$export$38deae157bd7d786);
$parcel$export(module.exports, "buildModuleShellComposerBridge", () => $6a583efa353be6f0$export$756dab5e99009713);
$parcel$export(module.exports, "buildModuleComposerErrorPlugin", () => $6a583efa353be6f0$export$a6e1b12a59564a6d);
// moduleShellComposer.js — a module page hides the shell's global composer
// ("Ask anything…", the root CanvasPromptTextarea) while it shows a composer
// of its own (MODULE-SHELL-COMPOSER-1).
//
//   el.call('setShellComposer', false)   // hide it while THIS page shows its own
//   el.call('setShellComposer', true)    // show it again
//
// Before this seam the only module path to the composer was immersive chrome
// (manifest `chrome.immersive`), which also hides the shell header and holds
// for the whole module surface. A module that opens its own input panel (the
// VaultOS Adjust panel) needs the narrow half only: no second prompt under its
// own, the header untouched, and nothing changed anywhere else.
//
// WHO MAY ASK — only a module's OWN PAGE, resolved from the caller's MOUNT
// POINT, never from its context alone. A module's context also reaches its
// rail (mounted on every route, `/` included) and its home widget bodies
// (mounted inside the shell's home); a context-only check let those hide the
// composer on `/` and on another module's page (ws crm review, 2026-10-09).
// The rule (`moduleOwnPageOf`): walk up from the caller to the topmost element
// that still carries the caller's module context — the module's mount root.
// It must be the CONTENT child of either
//   • a PageSlot pane host (`_slotPath` stamp; a family host's `Body` too) —
//     the page the pane shows, or
//   • the routed shell root (the element carrying `.routes`) — the page the
//     router mounted for the main route.
// The router and PageSlot mount a page def with its own module context, so a
// content child carrying module M's context IS one of M's own pages. Anything
// else — the rail, a widget body, a component nested in a shell surface — is
// refused.
//
// THE LATCH — `root._moduleComposerHidden`, ONE SLOT PER SURFACE:
//   { main?, _canvasSlot?, _canvasSlotSecond?: { moduleId, route, token } }
// A pane page and the main page each own their slot: a pane never overwrites
// the main page's latch, and closing the pane never un-hides the main page.
// `route` is the page's path (query/hash dropped, `/w/<slug>` prefix
// stripped); `token` names the mounted page element in this module's registry
// (`_mounts`), so the latch also dies with the page itself.
//
// A SLOT IS LIVE only while (a) its page element is still mounted at the same
// mount point (not disposed, not replaced — a same-route re-mount or a failed
// mount counts as gone) and (b) its surface still shows that route. The
// composer hides while ANY slot is live (`moduleComposerHiddenLive`, read by
// app.js _composerVisible). `releaseStaleModuleComposerLatch` (the shell's
// route sync — subscribed to currentPath and both pane keys) clears dead
// slots, so coming back to a page shows the composer until the module asks
// again. A lifecycle error inside the latched page releases its slot at once
// (`buildModuleComposerErrorPlugin`, a module-context plugin). A workspace
// switch wipes the key (state-app.js WORKSPACE_SCOPED_KEYS).
//
// GAP (framework): DOMQL has no public "element disposed" subscription, so an
// unmount that writes no shell state at all is seen at the next evaluation of
// the composer / route sync, not at the instant of disposal.

var $7iFOV = parcelRequire("7iFOV");
const $6a583efa353be6f0$var$PANE_KEYS = new Set([
    '_canvasSlot',
    '_canvasSlotSecond'
]);
const $6a583efa353be6f0$var$SLOTS = [
    'main',
    '_canvasSlot',
    '_canvasSlotSecond'
];
// token → { top, parent, ck } — the mounted page each latch slot names.
// Session-only, like the latch itself.
const $6a583efa353be6f0$var$_mounts = new Map();
let $6a583efa353be6f0$var$_seq = 0;
// Path only — no query, no hash, no `/w/<slug>` prefix, never empty.
const $6a583efa353be6f0$var$_pathOf = (raw)=>{
    const s = String(raw || '').split('#')[0].split('?')[0];
    return s || '/';
};
const $6a583efa353be6f0$var$_mainRoute = (root)=>$6a583efa353be6f0$var$_pathOf((0, $7iFOV.shellStripWorkspacePrefix)($6a583efa353be6f0$var$_pathOf(root && root.currentPath ? root.currentPath : '/')));
const $6a583efa353be6f0$var$_contentKeyOf = (parent)=>parent && parent.__ref && parent.__ref.contentElementKey || 'content';
const $6a583efa353be6f0$var$_slotHost = (parent)=>{
    if (!parent) return null;
    if (typeof parent._slotPath === 'string' && parent._slotPath) return parent;
    const up = parent.parent;
    if (parent.key === 'Body' && up && typeof up._slotPath === 'string' && up._slotPath) return up;
    return null;
};
const $6a583efa353be6f0$export$b12170cf78bca72c = (el)=>{
    const ctx = el && el.context;
    if (!ctx || typeof ctx !== 'object') return null;
    let top = el;
    let hops = 0;
    while(top.parent && top.parent !== top && top.parent.context === ctx && hops < 1000){
        top = top.parent;
        hops++;
    }
    const parent = top.parent;
    if (!parent || parent === top) return null;
    const ck = $6a583efa353be6f0$var$_contentKeyOf(parent);
    if (top.key !== ck || parent[ck] !== top) return null;
    const host = $6a583efa353be6f0$var$_slotHost(parent);
    if (host) {
        const slot = $6a583efa353be6f0$var$PANE_KEYS.has(host._slotPaneKey) ? host._slotPaneKey : '_canvasSlot';
        return {
            top: top,
            parent: parent,
            ck: ck,
            slot: slot,
            route: $6a583efa353be6f0$var$_pathOf(host._slotPath)
        };
    }
    if (parent.routes && typeof parent.routes === 'object') return {
        top: top,
        parent: parent,
        ck: ck,
        slot: 'main'
    };
    return null;
};
const $6a583efa353be6f0$var$_mountAlive = (token)=>{
    const m = token ? $6a583efa353be6f0$var$_mounts.get(token) : null;
    return !!(m && m.top && m.top.__ref && m.parent && m.parent[m.ck] === m.top);
};
const $6a583efa353be6f0$var$_slotLive = (root, slot, latch)=>{
    if (!latch || typeof latch !== 'object' || !latch.moduleId || !latch.route) return false;
    if (!$6a583efa353be6f0$var$_mountAlive(latch.token)) return false;
    if (slot === 'main') return $6a583efa353be6f0$var$_mainRoute(root) === latch.route;
    if (!$6a583efa353be6f0$var$PANE_KEYS.has(slot)) return false;
    const live = root[slot];
    return typeof live === 'string' && !!live && $6a583efa353be6f0$var$_pathOf(live) === latch.route;
};
const $6a583efa353be6f0$var$_latchOf = (root)=>{
    const v = root ? root._moduleComposerHidden : null;
    return v && typeof v === 'object' ? v : null;
};
const $6a583efa353be6f0$export$37f83fb585c6af79 = (root)=>{
    const latch = $6a583efa353be6f0$var$_latchOf(root);
    if (!latch) return false;
    return $6a583efa353be6f0$var$SLOTS.some((slot)=>$6a583efa353be6f0$var$_slotLive(root, slot, latch[slot]));
};
// The latch with dead slots dropped (null when none is left), or `undefined`
// when nothing changes.
const $6a583efa353be6f0$var$_pruned = (root)=>{
    const latch = $6a583efa353be6f0$var$_latchOf(root);
    if (!latch) return undefined;
    const next = {};
    let changed = false;
    for (const slot of Object.keys(latch))if ($6a583efa353be6f0$var$SLOTS.includes(slot) && $6a583efa353be6f0$var$_slotLive(root, slot, latch[slot])) next[slot] = latch[slot];
    else {
        changed = true;
        if (latch[slot] && latch[slot].token) $6a583efa353be6f0$var$_mounts.delete(latch[slot].token);
    }
    if (!changed) return undefined;
    return Object.keys(next).length ? next : null;
};
const $6a583efa353be6f0$export$38deae157bd7d786 = (root)=>{
    if (!root || typeof root.update !== 'function') return false;
    const next = $6a583efa353be6f0$var$_pruned(root);
    if (next === undefined) return false;
    root.update({
        _moduleComposerHidden: next
    }, {
        preventFetch: true
    });
    return true;
};
const $6a583efa353be6f0$var$_writeSlot = (root, slot, value)=>{
    const latch = $6a583efa353be6f0$var$_latchOf(root) || {};
    const prev = latch[slot];
    if (prev && prev.token && (!value || prev.token !== value.token)) $6a583efa353be6f0$var$_mounts.delete(prev.token);
    const next = {
        ...latch
    };
    if (value) next[slot] = value;
    else delete next[slot];
    root.update({
        _moduleComposerHidden: Object.keys(next).length ? next : null
    }, {
        preventFetch: true
    });
};
const $6a583efa353be6f0$export$756dab5e99009713 = (root, { moduleIdOf: moduleIdOf } = {})=>function setShellComposer(visible) {
        if (!root || typeof root.update !== 'function') return false;
        if (visible !== true && visible !== false) {
            console.warn(`[setShellComposer] ignored "${String(visible)}" \u{2014} pass false to hide the shell composer on this page, true to show it again`);
            return false;
        }
        const moduleId = typeof moduleIdOf === 'function' ? moduleIdOf(this && this.context) : null;
        if (!moduleId) {
            console.warn("[setShellComposer] refused \u2014 the caller is not inside an installed module");
            return false;
        }
        const page = $6a583efa353be6f0$export$b12170cf78bca72c(this);
        if (!page) {
            console.warn("[setShellComposer] refused \u2014 call it from the module's own page (a PageSlot pane or the routed page), not from its rail or a home widget");
            return false;
        }
        const route = page.slot === 'main' ? $6a583efa353be6f0$var$_mainRoute(root) : page.route;
        const current = ($6a583efa353be6f0$var$_latchOf(root) || {})[page.slot];
        if (visible) {
            if (!current) return true;
            // One module never clears another module's latch.
            if (current.moduleId !== moduleId) return false;
            $6a583efa353be6f0$var$_writeSlot(root, page.slot, null);
            return true;
        }
        if (current && current.moduleId === moduleId && current.route === route && $6a583efa353be6f0$var$_mountAlive(current.token) && $6a583efa353be6f0$var$_mounts.get(current.token).top === page.top) return true;
        $6a583efa353be6f0$var$_seq += 1;
        const token = 'c' + $6a583efa353be6f0$var$_seq;
        $6a583efa353be6f0$var$_mounts.set(token, {
            top: page.top,
            parent: page.parent,
            ck: page.ck
        });
        $6a583efa353be6f0$var$_writeSlot(root, page.slot, {
            moduleId: moduleId,
            route: route,
            token: token
        });
        return true;
    };
const $6a583efa353be6f0$export$a6e1b12a59564a6d = (root)=>{
    const plugin = {
        error (el, info) {
            try {
                const latch = $6a583efa353be6f0$var$_latchOf(root);
                if (latch && typeof root.update === 'function') for (const slot of $6a583efa353be6f0$var$SLOTS){
                    const l = latch[slot];
                    const m = l && l.token ? $6a583efa353be6f0$var$_mounts.get(l.token) : null;
                    if (!m) continue;
                    let node = el;
                    let hops = 0;
                    while(node && node !== m.top && hops < 1000){
                        node = node.parent === node ? null : node.parent;
                        hops++;
                    }
                    if (node === m.top) $6a583efa353be6f0$var$_writeSlot(root, slot, null);
                }
            } catch (_) {
            /* never let the latch turn an error into a second error */ }
            const plugins = el && el.context && el.context.plugins || [];
            const others = plugins.some((p)=>p && p !== plugin && typeof p.error === 'function');
            if (!others) console.error(`[DOMQL] Lifecycle "${info && info.hook}" error:`, info && info.error);
        }
    };
    // Marker AND the root it is bound to (workspaceProjects.js re-binds on a
    // replaced root).
    plugin.__moduleComposerLatch = root;
    return plugin;
};

});

parcelRegister("8Oeas", function(module, exports) {

$parcel$export(module.exports, "buildModuleAiBridge", () => $669dfba6017dcb4f$export$818a1ba762e606a9);
$parcel$export(module.exports, "buildModuleAiStreamBridge", () => $669dfba6017dcb4f$export$d26196d89e4720fc);
$parcel$export(module.exports, "buildModuleAiAdminBridge", () => $669dfba6017dcb4f$export$f5d23b896fc34996);
// moduleAiBridge.js — capability-scoped AI completions for workspace MODULES
// (manifest v2). The AI-plane sibling of moduleDataBridge.js: instead of the
// records grant, the gate is the module's server-granted `capabilities.ai`
// (workspace.settings.workspaceModule.capabilities.ai — written by the
// workspace owner/admin, never by the module itself).
//
// The loader (workspaceProjects.js) registers the built bridge as the
// `moduleAiChat` context function when an `ai` grant is present, so module
// functions reach the LLM via `el.call('moduleAiChat', prompt, opts)` — never
// through raw fetch / a browser API key (the publish-time module audit forbids
// those). It reuses the existing server-routed, zero-persistence completion
// (`sdk.ai.turn` → POST /core/agents/workspaces/:wsId/turn → Anthropic),
// workspace-scoped — the key stays server-side.
//
// Returns a plain result object `{ ok, text, usage?, error? }` (never throws)
// so a module copilot degrades gracefully. `opts.systemRef` is forwarded to
// the turn call so the server can resolve a server-stored system prompt
// (B1); `usage` (inputTokens/outputTokens) passes through from the server
// response when present.
//
// STREAMING sibling — `el.call('moduleAiStream', prompt, opts)`: the SAME
// gate, the SAME request and the SAME result shape, but the answer arrives
// as it is written (`sdk.ai.turnStream` → the same /turn with stream:true →
// SSE). `opts.onText(fullText)` gets the answer so far — batched to at most
// one call per animation frame, so a module re-renders at frame rate, not per
// token. `opts.signal` aborts it like moduleAiChat. A module feature-detects
// it (`el.context.functions.moduleAiStream`) and keeps moduleAiChat as the
// fallback; on an SDK without turnStream the bridge itself falls back to the
// one-shot turn and calls onText once with the whole answer.

var $1X0Je = parcelRequire("1X0Je");
const $669dfba6017dcb4f$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $669dfba6017dcb4f$var$shellWorkspaceSettings = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
// Live-grant heal (cold-boot race): the loader can build these bridges before
// the workspace settings record has arrived, so the load-time `capabilities.ai`
// snapshot may be absent while the REAL grant exists — the same defect family
// moduleDataBridge heals with _healGrant. Resolve the grant at CALL time from
// the live settings, falling back to the captured snapshot. The server
// enforces the grant on every /turn regardless — this client gate is UX, not
// security, so healing it open never widens access.
const $669dfba6017dcb4f$var$_liveAiCap = (root, snapshot)=>{
    try {
        const { settings: settings } = $669dfba6017dcb4f$var$shellWorkspaceSettings(root);
        const cap = settings && settings.workspaceModule && settings.workspaceModule.capabilities;
        if (cap && cap.ai) return cap.ai;
    } catch (e) {
    // settings accessor unavailable mid-boot — snapshot decides
    }
    return snapshot || null;
};
// The sdk's `ai` service, or null. Services init async and are reached via
// getService(name) (a promise); sdk.ai is not a direct property. Fall back to
// sdk.ai for any build that does expose it directly.
const $669dfba6017dcb4f$var$_aiBridgeService = async (getSdkFn)=>{
    const sdk = getSdkFn ? getSdkFn() : null;
    if (!sdk) return null;
    try {
        return typeof sdk.getService === 'function' ? await sdk.getService('ai') : sdk.ai;
    } catch (e) {
        return sdk.ai || null;
    }
};
// Workspace-scoped — the /turn route lives on the workspace.
const $669dfba6017dcb4f$var$_aiBridgeWorkspaceId = (root)=>root && root.workspace && (root.workspace.id || root.workspace._id) || undefined;
// The /turn payload — ONE builder for moduleAiChat and moduleAiStream, so the
// two can never send a different request for the same call.
const $669dfba6017dcb4f$var$_aiBridgeTurnPayload = (prompt, options, cap)=>{
    const payload = Array.isArray(options.messages) && options.messages.length ? {
        messages: options.messages
    } : {
        content: String(prompt || options.content || '')
    };
    const system = options.system || cap && cap.system || null;
    if (system) payload.system = String(system);
    const modelMode = options.modelMode || cap && cap.modelMode || null;
    if (modelMode) payload.modelMode = modelMode;
    if (options.systemRef) payload.systemRef = String(options.systemRef);
    if (options.allowTools === false) payload.allowTools = false;
    return payload;
};
// Bellforge B10 — an optional AbortSignal from the module (a Cancel button)
// rides through sdk.ai → fetch → the server, which aborts the upstream model
// call. An aborted turn reports { ok:false, aborted:true } so the module can
// tell "user cancelled" from "the AI failed" without string-matching an
// error message.
const $669dfba6017dcb4f$var$_aiBridgeTurnOpts = (root, options)=>{
    const wsId = $669dfba6017dcb4f$var$_aiBridgeWorkspaceId(root);
    const turnOpts = wsId ? {
        workspaceId: wsId
    } : {};
    if (options.signal) turnOpts.signal = options.signal;
    return turnOpts;
};
const $669dfba6017dcb4f$export$818a1ba762e606a9 = (root, capabilities = {}, { getSdkFn: getSdkFn = $669dfba6017dcb4f$var$shellGetSDK } = {})=>{
    const aiCap = capabilities && capabilities.ai || null;
    return async function moduleAiChat(prompt, opts = {}) {
        const options = opts || {};
        const cap = $669dfba6017dcb4f$var$_liveAiCap(root, aiCap);
        if (!cap) return {
            ok: false,
            text: '',
            error: 'AI capability not granted.'
        };
        const ai = await $669dfba6017dcb4f$var$_aiBridgeService(getSdkFn);
        if (!ai || typeof ai.turn !== 'function') return {
            ok: false,
            text: '',
            error: 'AI service unavailable.'
        };
        const payload = $669dfba6017dcb4f$var$_aiBridgeTurnPayload(prompt, options, cap);
        try {
            const r = await ai.turn(payload, $669dfba6017dcb4f$var$_aiBridgeTurnOpts(root, options));
            return {
                ok: true,
                text: r && r.text || '',
                usage: r && r.usage || undefined
            };
        } catch (e) {
            if (options.signal && options.signal.aborted) return {
                ok: false,
                aborted: true,
                text: '',
                error: 'Cancelled.'
            };
            return {
                ok: false,
                text: '',
                error: e && e.message || 'AI request failed.'
            };
        }
    };
};
// When onText may run next: the next animation frame, raced by a timer — a
// hidden tab gets no frames at all, and a stream that stops painting there
// looks dead. Without rAF (a worker, a test) the timer alone: ~50 ms.
// Returns a cancel function.
const $669dfba6017dcb4f$var$_aiBridgeNextFrame = (fn)=>{
    const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : null;
    let done = false;
    let frame = null;
    let timer = null;
    const stopBoth = ()=>{
        if (frame !== null && typeof cancelAnimationFrame === 'function') cancelAnimationFrame(frame);
        if (timer !== null) clearTimeout(timer);
    };
    const run = ()=>{
        if (done) return;
        done = true;
        stopBoth();
        fn();
    };
    if (raf) frame = raf(run);
    timer = setTimeout(run, raf ? 250 : 50);
    return ()=>{
        done = true;
        stopBoth();
    };
};
const $669dfba6017dcb4f$export$d26196d89e4720fc = (root, capabilities = {}, { getSdkFn: getSdkFn = $669dfba6017dcb4f$var$shellGetSDK, nextFrame: nextFrame = $669dfba6017dcb4f$var$_aiBridgeNextFrame } = {})=>{
    const aiCap = capabilities && capabilities.ai || null;
    return async function moduleAiStream(prompt, opts = {}) {
        const options = opts || {};
        const cap = $669dfba6017dcb4f$var$_liveAiCap(root, aiCap);
        if (!cap) return {
            ok: false,
            text: '',
            error: 'AI capability not granted.'
        };
        const ai = await $669dfba6017dcb4f$var$_aiBridgeService(getSdkFn);
        const streams = !!ai && typeof ai.turnStream === 'function';
        if (!ai || !streams && typeof ai.turn !== 'function') return {
            ok: false,
            text: '',
            error: 'AI service unavailable.'
        };
        const payload = $669dfba6017dcb4f$var$_aiBridgeTurnPayload(prompt, options, cap);
        const turnOpts = $669dfba6017dcb4f$var$_aiBridgeTurnOpts(root, options);
        const onText = typeof options.onText === 'function' ? options.onText : null;
        // onText batching — per call, so nothing outlives it: keep only the
        // LATEST full text and hand it over at most once per frame; the final
        // text goes over before the call resolves (skipped when the module
        // already has it); after a cancel or a failure the pending text is
        // dropped — nothing paints. A throwing onText never breaks the turn.
        let partial = '';
        let pendingText = null;
        let sentText = null;
        let cancelFrame = null;
        const deliverText = ()=>{
            cancelFrame = null;
            if (pendingText === null) return;
            const text = pendingText;
            pendingText = null;
            if (text === sentText) return;
            sentText = text;
            try {
                onText(text);
            } catch (e) {
            // the module's render fault is the module's — the turn goes on
            }
        };
        const dropPendingText = ()=>{
            if (cancelFrame) cancelFrame();
            cancelFrame = null;
            pendingText = null;
        };
        try {
            // An SDK without turnStream gets the one-shot turn; onText then fires
            // once, with the whole answer (the flush below).
            const r = streams ? await ai.turnStream(payload, {
                ...turnOpts,
                onDelta: (_delta, fullText)=>{
                    partial = String(fullText || '');
                    if (!onText) return;
                    pendingText = partial;
                    if (!cancelFrame) cancelFrame = nextFrame(deliverText);
                }
            }) : await ai.turn(payload, turnOpts);
            const text = r && r.text || '';
            if (onText) {
                dropPendingText();
                pendingText = text;
                deliverText();
            }
            return {
                ok: true,
                text: text,
                usage: r && r.usage || undefined
            };
        } catch (e) {
            dropPendingText();
            const rest = partial ? {
                partial: partial
            } : {};
            if (options.signal && options.signal.aborted) return {
                ok: false,
                aborted: true,
                text: '',
                error: 'Cancelled.',
                ...rest
            };
            return {
                ok: false,
                text: '',
                error: e && e.message || 'AI request failed.',
                ...rest
            };
        }
    };
};
const $669dfba6017dcb4f$export$f5d23b896fc34996 = (root, capabilities = {}, { getSdkFn: getSdkFn = $669dfba6017dcb4f$var$shellGetSDK } = {})=>{
    const aiCap = capabilities && capabilities.ai || null;
    return async function moduleAiAdmin(op, args = {}) {
        if (!$669dfba6017dcb4f$var$_liveAiCap(root, aiCap)) return {
            ok: false,
            error: 'AI capability not granted.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        if (!sdk) return {
            ok: false,
            error: 'AI service unavailable.'
        };
        const wsId = root && root.workspace && (root.workspace.id || root.workspace._id) || undefined;
        try {
            if (op === 'usage') {
                let ai;
                try {
                    ai = typeof sdk.getService === 'function' ? await sdk.getService('ai') : sdk.ai;
                } catch (e) {
                    ai = sdk.ai || null;
                }
                if (!ai || typeof ai.usage !== 'function') return {
                    ok: false,
                    error: 'AI usage unavailable.'
                };
                const data = await ai.usage(wsId ? {
                    workspaceId: wsId
                } : {});
                return {
                    ok: true,
                    data: data
                };
            }
            if (op === 'credits') {
                // The AUTHORITATIVE workspace credit balance (server
                // CreditsService.getWorkspaceBalance via sdk.getCreditBalance —
                // pool-scope aware, member-gated server-side). Exposed on the SAME
                // ai grant as 'usage': the grant that spends credits grants reading
                // the spend. Added for the bellforge credits ticket (2026-08-15):
                // the app's hand-seeded bf_credits row is not a money surface, and
                // a module has no other route to the real ledger (el.sdk is
                // refused by the publish-time module audit).
                if (!wsId) return {
                    ok: false,
                    error: 'No workspace selected.'
                };
                if (typeof sdk.getCreditBalance !== 'function') return {
                    ok: false,
                    error: 'Credits service unavailable.'
                };
                const data = await sdk.getCreditBalance(wsId);
                return {
                    ok: true,
                    data: data
                };
            }
            if (op === 'settings') {
                if (!wsId) return {
                    ok: false,
                    error: 'No workspace selected.'
                };
                // WRITE-BASE (spec §5). Not a DECISION site: `cur` is never branched
                // on, it is spread into the patch that gets PUT back. The server merges
                // per top-level key, so `{ ai: patch }` REPLACES the whole `ai` object
                // — a `{}` base read from a record that simply had not arrived writes
                // back an `ai` bag missing whichever of `modelMode` / `monthlyTokenCap`
                // this call did not set, silently erasing the workspace's cap.
                //
                // Aborting is the only safe answer here (there is no per-leaf half of
                // this write to keep, unlike the featureFlags/voice setters), and this
                // function already speaks `{ ok, error }`, so the caller gets a real
                // failure instead of a success that quietly lost a setting.
                const { settings: settings, ready: ready } = $669dfba6017dcb4f$var$shellWorkspaceSettings(root);
                if (!ready) return {
                    ok: false,
                    error: "Workspace settings are still loading \u2014 try again shortly."
                };
                const cur = settings && settings.ai || {};
                const patch = {
                    ...cur
                };
                if (args.modelMode !== undefined) patch.modelMode = args.modelMode;
                if (args.monthlyTokenCap !== undefined) patch.monthlyTokenCap = args.monthlyTokenCap;
                await sdk.updateWorkspaceSettings(wsId, {
                    ai: patch
                });
                return {
                    ok: true,
                    data: patch
                };
            }
            return {
                ok: false,
                error: 'Unknown op: ' + op
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'AI admin request failed.'
            };
        }
    };
};

});

parcelRegister("dk5k7", function(module, exports) {

$parcel$export(module.exports, "buildModuleRegistryBridge", () => $9b3145bec42ee532$export$60cdc997ba1a943c);
// moduleRegistryBridge.js — capability-scoped external company-registry
// lookups for workspace MODULES (bellforge D2-1). The registry-plane sibling
// of moduleAiBridge.js: the gate is the module's server-granted
// `capabilities.registry` (workspace.settings.workspaceModule.capabilities
// .registry — written by the workspace owner/admin, never by the module).
//
// The loader (workspaceProjects.js) registers the built bridge as the
// `moduleRegistryLookup` context function, so module functions reach the
// server's registry proxy via
//   el.call('moduleRegistryLookup', op, args)
//     op 'search'  → args { q, limit? }        → { ok, rows, provider }
//     op 'company' → args { siren }            → { ok, company, provider }
//     op 'status'  → args {}                   → { ok, mode, providers }
// — never through raw fetch (the publish-time module audit forbids it, and
// provider keys must stay server-side). Transport: sdk RegistryService →
// GET /core/registry/fr/* (provider chain + 1h cache live on the server).
//
// Returns plain result objects `{ ok, ...fields }` / `{ ok:false, error }`
// (never throws) so the module's discovery surface degrades to sim-only
// rows gracefully. Same live-grant heal as the ai bridge: the load-time
// capability snapshot may predate the settings record (cold-boot race), so
// the grant is re-read at CALL time; the server enforces auth regardless —
// this client gate is UX, not security.

var $1X0Je = parcelRequire("1X0Je");
const $9b3145bec42ee532$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $9b3145bec42ee532$var$shellWorkspaceSettings = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
const $9b3145bec42ee532$var$_liveRegistryCap = (root, snapshot)=>{
    try {
        const { settings: settings } = $9b3145bec42ee532$var$shellWorkspaceSettings(root);
        const cap = settings && settings.workspaceModule && settings.workspaceModule.capabilities;
        if (cap && cap.registry) return cap.registry;
    } catch (e) {
    // settings accessor unavailable mid-boot — snapshot decides
    }
    return snapshot || null;
};
const $9b3145bec42ee532$export$60cdc997ba1a943c = (root, capabilities = {}, { getSdkFn: getSdkFn = $9b3145bec42ee532$var$shellGetSDK } = {})=>{
    const registryCap = capabilities && capabilities.registry || null;
    return async function moduleRegistryLookup(op, args = {}) {
        const a = args || {};
        if (!$9b3145bec42ee532$var$_liveRegistryCap(root, registryCap)) return {
            ok: false,
            error: 'Registry capability not granted.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        if (!sdk) return {
            ok: false,
            error: 'Registry service unavailable.'
        };
        let registry = null;
        try {
            registry = typeof sdk.getService === 'function' ? await sdk.getService('registry') : sdk.registry;
        } catch (e) {
            registry = sdk.registry || null;
        }
        if (!registry || typeof registry.frSearch !== 'function') return {
            ok: false,
            error: 'Registry service unavailable.'
        };
        try {
            if (op === 'search') {
                const data = await registry.frSearch(String(a.q || ''), {
                    limit: a.limit != null ? a.limit : undefined
                });
                return {
                    ok: true,
                    rows: data && data.rows || [],
                    provider: data && data.provider
                };
            }
            if (op === 'company') {
                const data = await registry.frCompany(String(a.siren || ''));
                return {
                    ok: true,
                    company: data && data.company || null,
                    provider: data && data.provider
                };
            }
            if (op === 'status') {
                const data = await registry.frStatus();
                return {
                    ok: true,
                    mode: data && data.mode || 'live',
                    providers: data && data.providers || {}
                };
            }
            return {
                ok: false,
                error: 'Unknown op: ' + op
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Registry request failed.'
            };
        }
    };
};

});

parcelRegister("jqUS6", function(module, exports) {

$parcel$export(module.exports, "buildModuleFileListBridge", () => $e25c8f8e2bdc58ab$export$7d2d21d58d13f6f4);
$parcel$export(module.exports, "buildModuleFileReadBridge", () => $e25c8f8e2bdc58ab$export$481dcea5c661632f);
$parcel$export(module.exports, "_storageRefFromUrl", () => $e25c8f8e2bdc58ab$export$9600af02b11f1e18);
$parcel$export(module.exports, "buildModuleFileExtractTextBridge", () => $e25c8f8e2bdc58ab$export$3a7b81d78b806631);
$parcel$export(module.exports, "buildModuleFileBridge", () => $e25c8f8e2bdc58ab$export$86c927df8228b1e4);
$parcel$export(module.exports, "buildModuleFileUploadLargeBridge", () => $e25c8f8e2bdc58ab$export$79a9c5a998ebbe33);
$parcel$export(module.exports, "buildModuleFileCreateBridge", () => $e25c8f8e2bdc58ab$export$77cf7b65bf54966f);
$parcel$export(module.exports, "buildModuleFileUpdateBridge", () => $e25c8f8e2bdc58ab$export$b716164f63dbf661);
// moduleFileBridge.js — capability-scoped file upload for workspace MODULES
// (manifest v2). The file-plane sibling of moduleDataBridge/moduleAiBridge:
// when a module ref carries `capabilities.files`, the loader injects
// `moduleFileUpload(file, opts)` so a module can store a real blob (e.g. a PDF
// CV) via `el.call` — never raw fetch / a browser upload (the publish-time
// module audit forbids those). It reuses the existing user-scoped file service
// (`sdk.file.uploadDocument` → POST /core/files/upload → GCS + a Mongo File
// doc) and returns a public download URL to persist on a record.
//
// Returns a plain result object `{ ok, id, url, name, size } | { ok:false,
// error, status? }` (never throws) so a module upload UI degrades gracefully.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $e25c8f8e2bdc58ab$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// What the workspace file plane accepts, MIRRORING the server's own filter
// (server/src/core/middleware/upload.js — ALLOWED_DOCUMENT_TYPES +
// ALLOWED_WORKSPACE_TYPES). The server is the real authority; this list exists
// only so a module gets an instant, accurate rejection instead of a round-trip
// 4xx, which means it has to stay in step with it.
//
// It previously mirrored the SDK's `uploadDocument` helper — pdf/txt/doc/docx
// and nothing else — which had drifted well behind the server. The visible
// cost: the server had already been taught that a `.excalidraw` is
// `application/vnd.excalidraw+json` and allowed, and yet every board save and
// every 20s autosave was rejected in the browser before a request was made.
// Any module storing markdown or CSV was equally stuck.
const $e25c8f8e2bdc58ab$var$DEFAULT_MIME_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'text/csv',
    'text/markdown',
    'text/x-markdown',
    // Formats a workspace SURFACE opens, as opposed to ones a viewer renders.
    'application/vnd.excalidraw+json'
];
const $e25c8f8e2bdc58ab$var$MAX_UPLOAD_BYTES = 20971520;
const $e25c8f8e2bdc58ab$export$7d2d21d58d13f6f4 = (root, capabilities = {}, { getSdkFn: getSdkFn = $e25c8f8e2bdc58ab$var$shellGetSDK } = {})=>{
    return async function moduleFileList(opts = {}) {
        const options = opts || {};
        const sdk = getSdkFn ? getSdkFn() : null;
        const fileSvc = sdk && (typeof sdk.getService === 'function' ? await sdk.getService('file') : sdk.file);
        if (!fileSvc || typeof fileSvc.listMyUploads !== 'function') return {
            ok: false,
            error: 'File service unavailable.',
            files: []
        };
        try {
            const res = await fileSvc.listMyUploads({
                limit: Math.min(Number(options.limit) || 25, 100),
                sortBy: 'createdAt',
                sortOrder: 'desc'
            });
            const rows = Array.isArray(res) ? res : res && (res.data || res.files) || [];
            const name = (f)=>String(f && (f.originalName || f.filename || f.name) || '');
            const files = rows// Own uploads only, and — when the caller asks — only the extension it
            // actually opens, so a module never has to sift the user's documents.
            .filter((f)=>{
                const meta = f && f.metadata || {};
                if (meta.module && meta.module !== 'workspaceModule') return false;
                if (options.kind && meta.kind && meta.kind !== options.kind) return false;
                if (options.extension) return name(f).toLowerCase().endsWith(String(options.extension).toLowerCase());
                return true;
            }).map((f)=>({
                    id: f && (f._id || f.id),
                    name: name(f),
                    size: f && f.size,
                    createdAt: f && (f.createdAt || f.created_at),
                    // Carried so a read can go STRAIGHT to the stored object instead of
                    // bouncing through the API's redirect (see moduleFileRead).
                    url: f && (f.storageUrl || f.url) || ''
                }));
            return {
                ok: true,
                files: files
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Could not list files.',
                files: []
            };
        }
    };
};
const $e25c8f8e2bdc58ab$export$481dcea5c661632f = (root, capabilities = {}, { getSdkFn: getSdkFn = $e25c8f8e2bdc58ab$var$shellGetSDK } = {})=>{
    return async function moduleFileRead(ref) {
        // Accepts an id, or a row from `moduleFileList` (whose `url` points
        // straight at the stored object).
        const fileId = ref && typeof ref === 'object' ? ref.id : ref;
        const directUrl = ref && typeof ref === 'object' && ref.url || '';
        if (!fileId && !directUrl) return {
            ok: false,
            error: 'A file id is required.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        const fileSvc = sdk && (typeof sdk.getService === 'function' ? await sdk.getService('file') : sdk.file);
        // AUTHENTICATED SDK download first. Module files are uploaded private, and
        // both unauthenticated paths fail for that exact reason — the public route
        // 404s (it only serves files published as public) and the raw GCS object
        // 403s (that bucket is not world-readable). Measured both. So the real read
        // is `GET /core/files/:id/download` behind requireAuth, which the SDK owns.
        if (fileId && fileSvc && typeof fileSvc.downloadFileContent === 'function') try {
            const text = await fileSvc.downloadFileContent(fileId);
            if (typeof text === 'string' && text) return {
                ok: true,
                text: text
            };
        } catch (authErr) {
        /* fall through to the URL candidates below */ }
        // Fallbacks, for genuinely PUBLIC files (a published asset, an older
        // upload): direct object URL first, the API's public route second. Both are tried
        // because which one resolves is environment-shaped, and a reader that gives
        // up after the first works on dev and fails in production.
        const candidates = [];
        if (directUrl) candidates.push(directUrl);
        if (fileId && fileSvc && typeof fileSvc.getFileUrl === 'function') try {
            const u = fileSvc.getFileUrl(fileId);
            if (u && u !== directUrl) candidates.push(u);
        } catch (urlErr) {
        /* fall through to whatever else we have */ }
        if (!candidates.length) return {
            ok: false,
            error: 'That file has no readable URL.'
        };
        // `credentials: 'omit'` ON PURPOSE. These objects live in a PUBLIC bucket
        // (allUsers:objectViewer) whose CORS allows GET/HEAD only. Sending
        // credentials makes it a CREDENTIALED cross-origin read, which GCS will not
        // satisfy — the browser rejects it before any status exists, surfacing as a
        // bare "Failed to fetch" that reads like the file is missing. It is not;
        // the object is public and needs no credentials. (See the CORS note in
        // server StorageService.js: "the objects are public but fetch() from the
        // app is blocked, so in-browser readers fail while curl succeeds".)
        let lastErr = '';
        for (const url of candidates)try {
            const res = await fetch(url, {
                credentials: 'omit'
            });
            if (res && res.ok) return {
                ok: true,
                text: await res.text()
            };
            lastErr = `Could not read the file (${res && res.status}).`;
        } catch (e) {
            lastErr = e && e.message || 'Could not read the file.';
        }
        // LAST RESORT — the object through the API. A public-bucket URL only
        // works where the BUCKET's CORS config lists the app's origin, and that
        // list covers the deployed hosts only: measured 2026-08-11, every
        // `*.localhost` dev origin gets no ACAO header, so BOTH candidates above
        // die with a bare "Failed to fetch" while curl serves the same object
        // 200. The API sits behind the same CORS surface as every other SDK
        // call, so `POST /core/storage/:bucket/download` (auth + workspace
        // prefix guard server-side) works wherever the app itself works. Only
        // desktop-plane objects qualify: their URL path is
        // `…/<physical-bucket>/<logicalBucket>/<workspaceId>/<file>`, and the
        // server rejects any path outside the caller's own workspace prefix.
        const wsDownload = $e25c8f8e2bdc58ab$export$9600af02b11f1e18(directUrl);
        if (wsDownload && sdk && typeof sdk.execute === 'function') try {
            const text = await sdk.execute('workspaceProject.storage', 'download', wsDownload);
            if (typeof text === 'string' && text) return {
                ok: true,
                text: text
            };
        } catch (apiErr) {
            lastErr = apiErr && apiErr.message || lastErr;
        }
        return {
            ok: false,
            error: lastErr || 'Could not read the file.'
        };
    };
};
const $e25c8f8e2bdc58ab$export$3a7b81d78b806631 = (root, capabilities = {}, { getSdkFn: getSdkFn = $e25c8f8e2bdc58ab$var$shellGetSDK } = {})=>{
    return async function moduleFileExtractText(ref) {
        const fileId = ref && typeof ref === 'object' ? ref.id : ref;
        if (!fileId) return {
            ok: false,
            error: 'A file id is required.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        const fileSvc = sdk && (typeof sdk.getService === 'function' ? await sdk.getService('file') : sdk.file);
        if (!fileSvc || typeof fileSvc.extractFileText !== 'function') return {
            ok: false,
            error: 'File service unavailable.'
        };
        try {
            const result = await fileSvc.extractFileText(fileId);
            if (!result || typeof result.text !== 'string') return {
                ok: false,
                error: 'That file could not be read as text.'
            };
            return {
                ok: true,
                ...result
            };
        } catch (e) {
            // Server distinguishes unsupported type / too large / corrupt /
            // timed-out — the message is already user-facing (FileController.js
            // extractText), so it is passed through rather than genericized.
            return {
                ok: false,
                error: e && e.message || 'Could not extract text from that file.'
            };
        }
    };
};
// Parse a stored public-bucket object URL back into the `{ bucket, path }`
// the storage API takes. Recognizes the workspace logical buckets wherever
// they appear as a path segment (works for any physical-bucket host or name):
//   https://storage.googleapis.com/<physical>/workspace-files/<wsId>/<file>
//     → { bucket: 'workspace-files', path: '<wsId>/<file>' }
// Returns null for anything else — module-plane /core/files objects have
// their own authenticated route (downloadFileContent above).
const $e25c8f8e2bdc58ab$var$WORKSPACE_STORAGE_BUCKETS = [
    'workspace-files',
    'chat-attachments'
];
const $e25c8f8e2bdc58ab$export$9600af02b11f1e18 = (url)=>{
    if (!url) return null;
    let segs;
    try {
        segs = new URL(url).pathname.split('/').filter(Boolean);
    } catch (e) {
        return null;
    }
    for (const bucket of $e25c8f8e2bdc58ab$var$WORKSPACE_STORAGE_BUCKETS){
        const i = segs.indexOf(bucket);
        if (i >= 0 && i < segs.length - 1) return {
            bucket: bucket,
            path: decodeURIComponent(segs.slice(i + 1).join('/'))
        };
    }
    return null;
};
const $e25c8f8e2bdc58ab$export$86c927df8228b1e4 = (root, capabilities = {}, { getSdkFn: getSdkFn = $e25c8f8e2bdc58ab$var$shellGetSDK, uploadLarge: uploadLarge = null } = {})=>{
    const cap = capabilities && capabilities.files || null;
    // A PRIVATE upload used to come back with the PUBLIC download URL
    // (`fileSvc.getFileUrl`), which answers 404 for a private file — for
    // everyone, the uploader included (measured on dev 2026-10-23: TC task
    // assets were dead links; the CMS stores this url as its image src). The
    // direct path mints a LINK exactly for this, so a private upload goes
    // through it first. The multipart path below stays for public files and
    // as the fallback ONLY when the direct path is unavailable: an older API,
    // which the large bridge marks `unavailable` (concierge 2026-11-01). A
    // refusal is the answer. The direct path's workspace scope lets only
    // editor or above upload (server FileController.beginDirectUpload, 403
    // below that), and the multipart upload has no such floor: falling back on
    // a 403 stored the refused file as the member's personal file.
    const isPrivate = (cap && cap.visibility || 'private') !== 'public';
    let viaLink = typeof uploadLarge === 'function' ? uploadLarge : null;
    // An OPERATOR may narrow or widen this per install via the stored
    // `capabilities.files.mimeTypes` on the server-side module ref. Note the
    // source: capabilities come from the SERVER REF ONLY, NEVER THE MANIFEST
    // (workspaceProjects.js:371) — an app cannot widen its own file grant by
    // declaring a field in config.js, and must not be able to. Not a trust
    // boundary either way; the server's upload filter is.
    const allowedTypes = Array.isArray(cap && cap.mimeTypes) && cap.mimeTypes.length ? cap.mimeTypes : $e25c8f8e2bdc58ab$var$DEFAULT_MIME_TYPES;
    return async function moduleFileUpload(file, opts = {}) {
        const options = opts || {};
        if (!file || typeof file !== 'object' || typeof file.name !== 'string') return {
            ok: false,
            error: 'A file is required.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        if (!sdk) return {
            ok: false,
            error: 'File service unavailable.'
        };
        if (isPrivate && !(typeof file.size === 'number' && file.size > $e25c8f8e2bdc58ab$var$MAX_UPLOAD_BYTES)) {
            if (!viaLink) viaLink = $e25c8f8e2bdc58ab$export$79a9c5a998ebbe33(root, capabilities, {
                getSdkFn: getSdkFn
            });
            const linked = await viaLink(file, {
                kind: options.kind || ''
            });
            if (linked && linked.ok) return {
                ok: true,
                id: linked.id,
                url: linked.url,
                name: linked.name,
                size: linked.size
            };
            if (linked && linked.cancelled) return linked;
            // Not offered by this API (404 / 405 / 501, no workspace scope, an
            // older SDK): the multipart path below. Anything else (a 403 below
            // editor, a 413 over the tier, a failed transfer) is the answer.
            if (!(linked && linked.unavailable === true)) return {
                ok: false,
                error: linked && linked.error || 'Upload failed.',
                ...linked && typeof linked.status === 'number' ? {
                    status: linked.status
                } : {}
            };
        }
        // Services init async; reach via getService (a promise). sdk.file may also
        // be a direct property on some builds.
        let fileSvc = null;
        try {
            fileSvc = typeof sdk.getService === 'function' ? await sdk.getService('file') : sdk.file;
        } catch (e) {
            fileSvc = sdk.file || null;
        }
        if (!fileSvc || typeof fileSvc.uploadDocument !== 'function') return {
            ok: false,
            error: 'File service unavailable.'
        };
        // `uploadDocument` SPREADS ITS OWN `allowedTypes` OVER the caller's, so
        // passing them to it does nothing — the declared list has to go through
        // the validating primitive directly.
        const upload = typeof fileSvc.uploadFileWithValidation === 'function' ? (f, o)=>fileSvc.uploadFileWithValidation(f, o) : (f, o)=>fileSvc.uploadDocument(f, o);
        const wsId = root && root.workspace && (root.workspace.id || root.workspace._id) || undefined;
        try {
            // 20MB cap retained from the old document path. Reached by public
            // files and as the fallback for private ones (see the top of this
            // builder): a PRIVATE file's url from here does not open.
            const rec = await upload(file, {
                allowedTypes: allowedTypes,
                maxSize: $e25c8f8e2bdc58ab$var$MAX_UPLOAD_BYTES,
                visibility: cap && cap.visibility || 'private',
                metadata: {
                    workspaceId: wsId,
                    module: 'workspaceModule',
                    kind: options.kind || ''
                }
            });
            const id = rec && (rec._id || rec.id);
            const url = typeof fileSvc.getFileUrl === 'function' && id && fileSvc.getFileUrl(id) || rec && (rec.storageUrl || rec.url) || '';
            return {
                ok: true,
                id: id,
                url: url,
                name: rec && (rec.originalName || rec.filename),
                size: rec && rec.size
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Upload failed.'
            };
        }
    };
};
// LARGE uploads over the SAME files grant — `moduleFileUploadLarge(file, {
// onProgress, signal, kind })`. `moduleFileUpload` above is one multipart
// request through the API: capped at 20 MB here and by the ingress (~32 MB)
// anyway. Long-form media (a 3 GB edit delivered on a task) goes DIRECT to
// storage instead (server POST /core/files/direct):
//
//   1. open a session SCOPED TO THIS WORKSPACE — the server checks the member
//      holds editor or above there and applies the workspace's tier limit
//      (free 50 MB … enterprise 10 GB; a module's users are workspace
//      members, not members of the module's project, so a project scope would
//      refuse them) and mints a download LINK;
//   2. PUT the bytes to the resumable storage session in chunks (XHR, for
//      upload progress), resuming from what storage says it holds after a
//      failed chunk — a dropped connection costs one chunk, not the file;
//   3. complete — the server holds the object that arrived to the limit.
//
// The link (GET /core/files/link/:id/:token) answers with a short-lived signed
// storage URL, so the stored `url` downloads/plays for whoever the module
// shows it to without the bytes passing through the API (its other download
// routes read the whole object into memory). Never throws: `{ ok, id, url,
// name, size, mimeType } | { ok:false, error, cancelled?, status?,
// unavailable? }`. `unavailable: true` marks a direct path this API does not
// offer (an older SDK; /direct answers 404, 405 or 501; a session without the
// workspace scope): only then may a caller try another upload path. Every
// other failure is the answer, a 403 below editor included.
//
// Cancel: pass `signal` — an AbortSignal, or any `{ aborted,
// addEventListener('abort', fn) }` (a module need not reach for a global
// constructor). The session is aborted server-side, so nothing is left behind.
const $e25c8f8e2bdc58ab$var$LARGE_CHUNK_QUANTUM = 262144 // GCS: every chunk but the last is a multiple of this
;
const $e25c8f8e2bdc58ab$var$LARGE_DEFAULT_CHUNK_BYTES = 8388608;
const $e25c8f8e2bdc58ab$var$LARGE_MAX_CHUNK_ATTEMPTS = 6;
const $e25c8f8e2bdc58ab$var$LARGE_PROGRESS_INTERVAL_MS = 250;
const $e25c8f8e2bdc58ab$var$LARGE_COMPLETE_ATTEMPTS = 4;
// A browser reports some media under names the server's allowlist does not
// carry (server/src/core/middleware/upload.js ALL_ALLOWED_TYPES) — and reports
// nothing at all for some files. Map both onto the allowlisted name; the
// declared type becomes the stored object's Content-Type.
const $e25c8f8e2bdc58ab$var$LARGE_MIME_ALIASES = {
    'audio/x-m4a': 'audio/mp4',
    'audio/m4a': 'audio/mp4',
    'audio/aac': 'audio/mp4',
    'audio/x-wav': 'audio/wav',
    'audio/wave': 'audio/wav',
    'audio/vnd.wave': 'audio/wav',
    'audio/mp3': 'audio/mpeg',
    'video/x-m4v': 'video/mp4',
    'application/x-zip': 'application/zip',
    'application/zip-compressed': 'application/zip',
    'application/x-zip-compressed': 'application/zip'
};
const $e25c8f8e2bdc58ab$var$LARGE_MIME_BY_EXT = {
    mp4: 'video/mp4',
    m4v: 'video/mp4',
    mov: 'video/quicktime',
    webm: 'video/webm',
    avi: 'video/x-msvideo',
    mpg: 'video/mpeg',
    mpeg: 'video/mpeg',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    m4a: 'audio/mp4',
    aac: 'audio/mp4',
    ogg: 'audio/ogg',
    zip: 'application/zip',
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    webp: 'image/webp'
};
const $e25c8f8e2bdc58ab$export$31c4287d55f84a8 = (file)=>{
    const raw = String(file && file.type || '').toLowerCase().split(';')[0].trim();
    if (raw && raw !== 'application/octet-stream') return $e25c8f8e2bdc58ab$var$LARGE_MIME_ALIASES[raw] || raw;
    const m = /\.([a-z0-9]+)$/i.exec(String(file && file.name || ''));
    return m && $e25c8f8e2bdc58ab$var$LARGE_MIME_BY_EXT[m[1].toLowerCase()] || raw || '';
};
const $e25c8f8e2bdc58ab$var$_largeTypeAllowed = (mime, allowed)=>!!mime && allowed.some((t)=>String(t).endsWith('/*') ? mime.indexOf(String(t).slice(0, -1)) === 0 : t === mime);
const $e25c8f8e2bdc58ab$export$f836810dbd3153f2 = (range)=>{
    const m = /bytes=(\d+)-(\d+)/.exec(String(range || ''));
    return m ? Number(m[2]) + 1 : null;
};
const $e25c8f8e2bdc58ab$var$_largeRetryable = (status)=>status === 0 || status === 408 || status === 429 || status >= 500 && status < 600;
const $e25c8f8e2bdc58ab$var$_largeOnAbort = (signal, fn)=>{
    if (!signal || typeof signal.addEventListener !== 'function') return ()=>{};
    signal.addEventListener('abort', fn);
    return ()=>{
        try {
            signal.removeEventListener && signal.removeEventListener('abort', fn);
        } catch (e) {
        /* a signal-like without remove is fine */ }
    };
};
// One PUT to the storage session. Resolves `{ status, range }` — never rejects.
const $e25c8f8e2bdc58ab$var$_largePut = (xhrFactory, url, body, contentRange, onBytes, signal)=>new Promise((resolve)=>{
        let xhr;
        try {
            xhr = xhrFactory();
        } catch (e) {
            resolve({
                status: 0,
                error: e && e.message || 'no transport'
            });
            return;
        }
        let settled = false;
        let detach = ()=>{};
        const done = (r)=>{
            if (settled) return;
            settled = true;
            detach();
            resolve(r);
        };
        detach = $e25c8f8e2bdc58ab$var$_largeOnAbort(signal, ()=>{
            try {
                xhr.abort();
            } catch (e) {
            /* already finished */ }
            done({
                status: 0,
                aborted: true
            });
        });
        try {
            xhr.open('PUT', url, true);
            xhr.setRequestHeader('Content-Range', contentRange);
            if (xhr.upload && onBytes) xhr.upload.onprogress = (e)=>{
                if (e && typeof e.loaded === 'number') onBytes(e.loaded);
            };
            xhr.onload = ()=>{
                // Only a 308 (storage holds part of the object) carries the Range
                // the resume reads. Read it from getAllResponseHeaders(), which lists
                // only the headers the bucket's CORS exposes: getResponseHeader on an
                // unexposed header logs "Refused to get unsafe header" on every PUT
                // (a console error per upload, seen on dev 2026-10-23). Unexposed →
                // null, as before.
                let range = null;
                if (xhr.status === 308) try {
                    const all = typeof xhr.getAllResponseHeaders === 'function' ? String(xhr.getAllResponseHeaders() || '') : '';
                    const m = /^range:\s*(.+)$/im.exec(all);
                    range = m ? m[1].trim() : null;
                } catch (e) {
                    range = null;
                }
                done({
                    status: xhr.status,
                    range: range
                });
            };
            xhr.onerror = ()=>done({
                    status: 0,
                    error: 'network'
                });
            xhr.ontimeout = ()=>done({
                    status: 0,
                    error: 'timeout'
                });
            xhr.onabort = ()=>done({
                    status: 0,
                    aborted: true
                });
            xhr.send(body);
        } catch (e) {
            done({
                status: 0,
                error: e && e.message || 'send failed'
            });
        }
    });
const $e25c8f8e2bdc58ab$export$79a9c5a998ebbe33 = (root, capabilities = {}, { getSdkFn: getSdkFn = $e25c8f8e2bdc58ab$var$shellGetSDK, xhrFactory: xhrFactory = ()=>new XMLHttpRequest(), sleep: sleep = (ms)=>new Promise((r)=>setTimeout(r, ms)), now: now = ()=>Date.now() } = {})=>{
    const cap = capabilities && capabilities.files || null;
    const allowedTypes = Array.isArray(cap && cap.mimeTypes) && cap.mimeTypes.length ? cap.mimeTypes : $e25c8f8e2bdc58ab$var$DEFAULT_MIME_TYPES;
    return async function moduleFileUploadLarge(file, opts = {}) {
        const options = opts || {};
        const signal = options.signal || null;
        const onProgress = typeof options.onProgress === 'function' ? options.onProgress : null;
        const cancelled = ()=>({
                ok: false,
                cancelled: true,
                error: 'Upload cancelled.'
            });
        const isAborted = ()=>!!(signal && signal.aborted);
        if (!cap) return {
            ok: false,
            error: 'File uploads are not enabled for this app.'
        };
        if (!file || typeof file !== 'object' || typeof file.name !== 'string' || typeof file.slice !== 'function') return {
            ok: false,
            error: 'A file is required.'
        };
        const total = Number(file.size);
        if (!Number.isFinite(total) || total <= 0) return {
            ok: false,
            error: 'That file is empty.'
        };
        const mime = $e25c8f8e2bdc58ab$export$31c4287d55f84a8(file);
        if (!$e25c8f8e2bdc58ab$var$_largeTypeAllowed(mime, allowedTypes)) return {
            ok: false,
            error: 'File type ' + (mime || 'unknown') + ' is not allowed.'
        };
        if (isAborted()) return cancelled();
        const wsId = root && root.workspace && (root.workspace.id || root.workspace._id) || null;
        if (!wsId) return {
            ok: false,
            error: 'Open a workspace first.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        let fileSvc = null;
        try {
            fileSvc = sdk && (typeof sdk.getService === 'function' ? await sdk.getService('file') : sdk.file);
        } catch (e) {
            fileSvc = sdk && sdk.file || null;
        }
        if (!fileSvc || typeof fileSvc._request !== 'function') // An SDK without the raw request (an older one) cannot reach /direct.
        return {
            ok: false,
            error: 'File service unavailable.',
            unavailable: true
        };
        const call = (path, body, methodName)=>fileSvc._request(path, {
                method: 'POST',
                body: JSON.stringify(body || {}),
                methodName: methodName
            });
        // 1. Open the session.
        let session;
        try {
            const res = await call('/files/direct', {
                originalName: file.name,
                mimeType: mime,
                size: total,
                workspaceId: String(wsId),
                visibility: cap && cap.visibility || 'private',
                link: true,
                metadata: {
                    workspaceId: String(wsId),
                    module: 'workspaceModule',
                    kind: options.kind || ''
                }
            }, 'beginDirectUpload');
            session = res && res.data;
        } catch (e) {
            // The server's own words are user-facing ("A 3.1 GB file is over the
            // free tier's limit of 50 MB"). The SDK's raw request rejects with the
            // HTTP status on the error. 404 / 405 / 501 here: a server without the
            // direct path (an older API), marked `unavailable`. Only this step
            // marks it: a 404 from storage after the session opened is no older API.
            const status = e && e.status;
            return {
                ok: false,
                error: e && e.message || 'Could not start the upload.',
                status: status,
                ...status === 404 || status === 405 || status === 501 ? {
                    unavailable: true
                } : {}
            };
        }
        const fileId = session && session.file && (session.file.id || session.file._id);
        const abortSession = async ()=>{
            if (!fileId) return;
            try {
                await call('/files/' + fileId + '/abort', {}, 'abortDirectUpload');
            } catch (e) {
            /* best effort — an unfinished session expires on its own */ }
        };
        if (!session || !session.uploadUrl || !fileId) {
            await abortSession();
            return {
                ok: false,
                error: 'The server did not open an upload.'
            };
        }
        // An API without the workspace scope ignores it: the upload would land
        // personal (free tier) with no link anyone else could open. Refuse rather
        // than store a file nobody can download.
        if (session.scope !== 'workspace' || !session.link) {
            await abortSession();
            return {
                ok: false,
                error: 'Large uploads are not available on this server yet.',
                unavailable: true
            };
        }
        const quantum = $e25c8f8e2bdc58ab$var$LARGE_CHUNK_QUANTUM;
        const asked = Number(session.chunkBytes) || $e25c8f8e2bdc58ab$var$LARGE_DEFAULT_CHUNK_BYTES;
        const chunkBytes = Math.max(quantum, Math.floor(asked / quantum) * quantum);
        let lastEmit = 0;
        let lastLoaded = -1;
        const emit = (loaded, force)=>{
            if (!onProgress) return;
            const n = Math.min(total, Math.max(0, loaded));
            const t = now();
            if (!force && (n === lastLoaded || t - lastEmit < $e25c8f8e2bdc58ab$var$LARGE_PROGRESS_INTERVAL_MS)) return;
            lastEmit = t;
            lastLoaded = n;
            try {
                onProgress({
                    loaded: n,
                    total: total,
                    percent: Math.floor(n / total * 100)
                });
            } catch (e) {
            /* a module's progress handler must not break the upload */ }
        };
        emit(0, true);
        // 2. The bytes.
        let offset = 0;
        let attempts = 0;
        while(offset < total){
            if (isAborted()) {
                await abortSession();
                return cancelled();
            }
            const end = Math.min(offset + chunkBytes, total) - 1;
            const start = offset;
            const r = await $e25c8f8e2bdc58ab$var$_largePut(xhrFactory, session.uploadUrl, file.slice(start, end + 1), 'bytes ' + start + '-' + end + '/' + total, (n)=>emit(start + n), signal);
            if (r.aborted || isAborted()) {
                await abortSession();
                return cancelled();
            }
            if (r.status === 308) {
                // What storage HOLDS, which may be less than was sent.
                const next = $e25c8f8e2bdc58ab$export$f836810dbd3153f2(r.range);
                offset = next == null ? end + 1 : next;
                if (offset > start) {
                    attempts = 0;
                    emit(offset);
                    continue;
                }
                // Storage took none of it — count it, so a stuck session cannot spin.
                attempts += 1;
                if (attempts >= $e25c8f8e2bdc58ab$var$LARGE_MAX_CHUNK_ATTEMPTS) {
                    await abortSession();
                    return {
                        ok: false,
                        error: 'Storage is not accepting the file. Try again.',
                        status: 308
                    };
                }
                continue;
            }
            if (r.status === 200 || r.status === 201) {
                offset = total;
                break;
            }
            attempts += 1;
            if (!$e25c8f8e2bdc58ab$var$_largeRetryable(r.status) || attempts >= $e25c8f8e2bdc58ab$var$LARGE_MAX_CHUNK_ATTEMPTS) {
                await abortSession();
                return {
                    ok: false,
                    error: r.status === 0 ? 'The connection dropped and did not come back. Try again.' : 'Storage refused the upload (' + r.status + ').',
                    status: r.status
                };
            }
            await sleep(Math.min(20000, 1000 * Math.pow(2, attempts - 1)));
            if (isAborted()) {
                await abortSession();
                return cancelled();
            }
            // Ask storage what it holds and resume from there.
            const q = await $e25c8f8e2bdc58ab$var$_largePut(xhrFactory, session.uploadUrl, null, 'bytes */' + total, null, signal);
            if (q.aborted) {
                await abortSession();
                return cancelled();
            }
            if (q.status === 200 || q.status === 201) {
                offset = total;
                break;
            }
            if (q.status === 308) offset = $e25c8f8e2bdc58ab$export$f836810dbd3153f2(q.range) || 0;
        }
        emit(total, true);
        // 3. Complete. A 409 means storage has not finalized the object yet.
        let completed = null;
        for(let i = 0; i < $e25c8f8e2bdc58ab$var$LARGE_COMPLETE_ATTEMPTS && !completed; i++)try {
            const res = await call('/files/' + fileId + '/complete', {}, 'completeDirectUpload');
            completed = res && res.data || {};
        } catch (e) {
            const status = e && e.status;
            if ((status === 409 || $e25c8f8e2bdc58ab$var$_largeRetryable(Number(status) || 0)) && i < $e25c8f8e2bdc58ab$var$LARGE_COMPLETE_ATTEMPTS - 1) {
                await sleep(1000 * (i + 1));
                continue;
            }
            if (status !== 413) await abortSession();
            return {
                ok: false,
                error: e && e.message || 'Could not finish the upload.',
                status: status
            };
        }
        return {
            ok: true,
            id: fileId,
            url: session.link,
            name: completed && completed.originalName || file.name,
            size: completed && completed.size || total,
            mimeType: completed && completed.mimeType || mime
        };
    };
};
const $e25c8f8e2bdc58ab$export$77cf7b65bf54966f = (root, capabilities = {}, { getSdkFn: getSdkFn = $e25c8f8e2bdc58ab$var$shellGetSDK } = {})=>{
    const cap = capabilities && capabilities.files || null;
    const allowedTypes = Array.isArray(cap && cap.mimeTypes) && cap.mimeTypes.length ? cap.mimeTypes : $e25c8f8e2bdc58ab$var$DEFAULT_MIME_TYPES;
    return async function moduleFileCreate(file) {
        if (!file || typeof file !== 'object' || typeof file.name !== 'string') return {
            ok: false,
            error: 'A file is required.'
        };
        if (typeof file.size === 'number' && file.size > $e25c8f8e2bdc58ab$var$MAX_UPLOAD_BYTES) return {
            ok: false,
            error: 'That file is too large.'
        };
        const mime = String(file.type || '').toLowerCase().split(';')[0].trim();
        if (mime && allowedTypes.indexOf(mime) < 0) return {
            ok: false,
            error: 'File type ' + mime + ' is not allowed.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        if (!sdk || typeof sdk.execute !== 'function') return {
            ok: false,
            error: 'File service unavailable.'
        };
        try {
            const fd = new FormData();
            fd.append('file', file);
            const up = await sdk.execute('workspaceProject.storage', 'upload', {
                bucket: 'workspace-files',
                formData: fd
            });
            const url = up && (up.url || up.data && up.data.url) || null;
            const path = up && (up.path || up.data && up.data.path) || null;
            if (!url) return {
                ok: false,
                error: 'Storage returned no url.'
            };
            const payload = {
                kind: 'file',
                name: file.name,
                parent_id: null,
                x: 80 + Math.round(Math.random() * 280),
                y: 80 + Math.round(Math.random() * 180),
                file_id: path,
                url: url,
                mime_type: mime || null,
                size: typeof file.size === 'number' ? file.size : null,
                scope: root && root.filesScope || 'shared',
                created_by: root && root.currentUserEmail || null
            };
            const created = await sdk.execute('workspaceProject.fileCanvas', 'create', {
                payload: payload
            });
            const id = created && (created.id || created._id) || created && created.data && (created.data.id || created.data._id) || null;
            if (!id) return {
                ok: false,
                error: 'The Files desktop refused the document.'
            };
            // When the desktop state is loaded (the user has visited /files this
            // session), show the new tile immediately — same patch shape the
            // desktop's own creators use. When it is not, /files loads the row from
            // the server on its next mount and nothing here is needed.
            if (root && root.update && Array.isArray(root.fileNodes)) root.update({
                fileNodes: [
                    ...root.fileNodes,
                    {
                        id: id,
                        kind: 'file',
                        name: payload.name,
                        parentId: null,
                        x: payload.x,
                        y: payload.y,
                        fileId: path,
                        docId: null,
                        url: url,
                        mime: payload.mime_type,
                        size: payload.size,
                        scope: payload.scope,
                        createdBy: payload.created_by,
                        createdAt: new Date().toISOString()
                    }
                ]
            });
            return {
                ok: true,
                node: {
                    id: id,
                    url: url,
                    name: payload.name
                }
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Could not save to Files.'
            };
        }
    };
};
const $e25c8f8e2bdc58ab$export$b716164f63dbf661 = (root, capabilities = {}, { getSdkFn: getSdkFn = $e25c8f8e2bdc58ab$var$shellGetSDK } = {})=>{
    const cap = capabilities && capabilities.files || null;
    const allowedTypes = Array.isArray(cap && cap.mimeTypes) && cap.mimeTypes.length ? cap.mimeTypes : $e25c8f8e2bdc58ab$var$DEFAULT_MIME_TYPES;
    return async function moduleFileUpdate(ref, file) {
        if (!file || typeof file !== 'object' || typeof file.name !== 'string') return {
            ok: false,
            error: 'A file is required.'
        };
        if (typeof file.size === 'number' && file.size > $e25c8f8e2bdc58ab$var$MAX_UPLOAD_BYTES) return {
            ok: false,
            error: 'That file is too large.'
        };
        // A grant that cannot upload a type must not be able to write it either.
        const mime = String(file.type || '').toLowerCase().split(';')[0].trim();
        if (mime && allowedTypes.indexOf(mime) < 0) return {
            ok: false,
            error: 'File type ' + mime + ' is not allowed.'
        };
        const nodeId = ref && typeof ref === 'object' ? ref.id : ref;
        if (!nodeId) return {
            ok: false,
            error: 'A file reference is required.'
        };
        const node = (root && root.fileNodes || []).find((n)=>String(n.id) === String(nodeId));
        if (!node) return {
            ok: false,
            error: "That file was not opened from this workspace\u2019s Files desktop, so it cannot be updated here."
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        if (!sdk || typeof sdk.execute !== 'function') return {
            ok: false,
            error: 'File service unavailable.'
        };
        // The object this write supersedes. Read BEFORE the upload so a failure
        // anywhere below leaves it exactly where it was.
        const previousPath = node.fileId || null;
        try {
            const fd = new FormData();
            fd.append('file', file);
            const up = await sdk.execute('workspaceProject.storage', 'upload', {
                bucket: 'workspace-files',
                formData: fd
            });
            const url = up && (up.url || up.data && up.data.url) || null;
            const path = up && (up.path || up.data && up.data.path) || null;
            if (!url) return {
                ok: false,
                error: 'Storage returned no url.'
            };
            const size = typeof file.size === 'number' ? file.size : null;
            await sdk.execute('workspaceProject.fileCanvas', 'update', {
                id: node.id,
                payload: {
                    url: url,
                    file_id: path,
                    size: size
                }
            });
            // Repoint every reader: the desktop row, and — for a text format — the
            // tile snippet cache keyed by node id, which otherwise keeps showing the
            // previous revision until a reload. The snippet is only rewritten when we
            // can actually produce one; blanking it instead would leave the tile empty
            // for good, since the loader only fills a snippet from the tile's
            // onCreate and these tiles are already mounted.
            const patch = {
                fileNodes: (root.fileNodes || []).map((n)=>String(n.id) === String(node.id) ? {
                        ...n,
                        url: url,
                        fileId: path,
                        size: size
                    } : n)
            };
            if (mime.indexOf('text/') === 0 && typeof file.text === 'function') try {
                const text = await file.text();
                patch._filePreviews = {
                    ...root && root._filePreviews || {},
                    [node.id]: text.slice(0, 400)
                };
            } catch (readErr) {
            /* snippet is a nicety; a save must not fail over one */ }
            if (root && typeof root.update === 'function') root.update(patch, {
                preventFetch: true
            });
            // Reclaim the replaced object — AFTER the row points at the new one, never
            // before, or a failed update would leave the row naming an object that no
            // longer exists. Best-effort: a failed delete is an orphan, which is what
            // we had before, so it must never fail the save.
            if (previousPath && previousPath !== path) try {
                await sdk.execute('workspaceProject.storage', 'remove', {
                    bucket: 'workspace-files',
                    path: previousPath
                });
            } catch (rmErr) {
                console.warn('[moduleFileUpdate] superseded blob not removed:', rmErr && rmErr.message);
            }
            return {
                ok: true,
                id: node.id,
                url: url,
                size: size
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Could not save the file.'
            };
        }
    };
};

});

parcelRegister("aKkqm", function(module, exports) {

$parcel$export(module.exports, "buildModuleCalendarBridge", () => $7d2e0b14d023f74e$export$25fbb27f492bf1f5);
// moduleCalendarBridge.js — capability-scoped NATIVE calendar access for
// workspace MODULES (manifest v2). The calendar-plane sibling of
// moduleDataBridge / moduleAiBridge / moduleFileBridge: when a module ref
// carries `capabilities.calendar`, the loader injects `moduleCalendarCreate`,
// `moduleCalendarUpdate`, `moduleCalendarRemove` and `moduleCalendarList` so a
// module can put a real event on the WORKSPACE calendar — and keep it in step —
// via `el.call`, never raw fetch (the publish-time module audit forbids that).
//
// Why this exists: a module that keeps its own event rows in the records plane
// has a calendar nobody else can see. Chaining through the workspace calendar
// service (`sdk.calendar.*` → /core/calendar/*) means the module's sessions
// show up in the native Calendar app, in freebusy, and in reminders — one
// source of truth instead of two.
//
// Every function returns a plain result object (`{ ok, ... } | { ok:false,
// error }`) and NEVER throws, so a module's scheduling UI degrades gracefully
// when the grant is absent or the service is still booting.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $7d2e0b14d023f74e$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// Services init ASYNC — `sdk.calendar` is undefined at runtime on some builds,
// so always prefer getService() (which returns a promise). Same trap the AI
// bridge documents.
const $7d2e0b14d023f74e$var$_calendarService = async (sdk)=>{
    if (!sdk) return null;
    try {
        return typeof sdk.getService === 'function' ? await sdk.getService('calendar') : sdk.calendar;
    } catch (_) {
        return sdk.calendar || null;
    }
};
const $7d2e0b14d023f74e$export$ba5f6dc1f7d3f6d4 = 'symbols-meet';
const $7d2e0b14d023f74e$var$_meetLinkFor = (root, roomId, call)=>{
    try {
        const url = call ? call('meetRoomUrl', root, roomId) : '';
        return typeof url === 'string' ? url : '';
    } catch (_) {
        return '';
    }
};
const $7d2e0b14d023f74e$export$25fbb27f492bf1f5 = (root, capabilities = {}, { getSdkFn: getSdkFn = $7d2e0b14d023f74e$var$shellGetSDK, callFn: callFn } = {})=>{
    const cap = capabilities && capabilities.calendar || null;
    // Idempotency memo — a module retry with the SAME `ref` (its own mirror
    // row id) in one session returns the triple it already minted instead of
    // a second event + second room. Keyed by ref only when the caller gave one.
    const _byRef = new Map();
    const wsId = ()=>root && root.workspace && (root.workspace.id || root.workspace._id) || undefined;
    const orgId = ()=>root?.jwtClaims?.workspace_org_id || root?.org && (root.org.id || root.org._id) || undefined;
    // Create a real workspace calendar event.
    //   moduleCalendarCreate({ title, start, end?, allDay?, location?, notes? })
    // `start` accepts a Date or any ISO-8601 string. `end` defaults to start +
    // 1h, because the native event model wants a range and a module that only
    // knows "a session happens that day" should not have to invent one.
    //   moduleCalendarCreate({ title, start, end?, allDay?, location?, notes?,
    //                          ref?, meetingMode? })
    // `meetingMode: 'symbols-meet'` also creates the native meet room and
    // returns `{ ok, id, event, roomId, joinUrl }`; any other value (or none)
    // creates the event alone (`roomId`/`joinUrl` null). When the event lands
    // but the room step fails, the result is still ok (the event exists) with
    // `meetError` naming why — the module decides whether to retry.
    const moduleCalendarCreate = async function(input = {}) {
        const ev = input || {};
        const title = typeof ev.title === 'string' ? ev.title.trim() : '';
        if (!title) return {
            ok: false,
            error: 'An event title is required.'
        };
        if (!ev.start) return {
            ok: false,
            error: 'An event start is required.'
        };
        const wantsMeet = ev.meetingMode === $7d2e0b14d023f74e$export$ba5f6dc1f7d3f6d4;
        const refKey = ev.ref != null && String(ev.ref) !== '' ? String(ev.ref) : '';
        if (refKey && _byRef.has(refKey)) {
            // Retry semantics: the event never lands twice. If the first call
            // landed the event but the room step failed, the retry only redoes
            // the room step on the SAME event id.
            const prev = _byRef.get(refKey);
            if (wantsMeet && prev && prev.ok && prev.id != null && !prev.joinUrl) {
                const sdkR = getSdkFn ? getSdkFn() : null;
                const svcR = await $7d2e0b14d023f74e$var$_calendarService(sdkR);
                const selfR = this;
                const callR = callFn || (selfR && typeof selfR.call === 'function' ? (name, ...args)=>selfR.call(name, ...args) : null);
                const meet = await _ensureMeetRoom({
                    id: prev.id,
                    title: title,
                    description: ev.notes || ev.description || '',
                    row: prev.event,
                    call: callR,
                    svc: svcR
                });
                prev.roomId = meet.roomId;
                prev.joinUrl = meet.joinUrl;
                if (meet.event) prev.event = meet.event;
                if (meet.error) prev.meetError = meet.error;
                else delete prev.meetError;
            }
            return prev;
        }
        // el.call binds `this` to the calling element (smbls methods.js
        // `method.call(this, …)`); the module's fns are injected into the SHELL
        // context, so meet's eager-slice `createRoom` / `meetRoomUrl` resolve
        // from here exactly as they do for the calendar package.
        const self = this;
        const call = callFn || (self && typeof self.call === 'function' ? (name, ...args)=>self.call(name, ...args) : null);
        const start = ev.start instanceof Date ? ev.start : new Date(ev.start);
        if (isNaN(start.getTime())) return {
            ok: false,
            error: 'Invalid event start.'
        };
        const end = ev.end != null ? ev.end instanceof Date ? ev.end : new Date(ev.end) : new Date(start.getTime() + 3600000);
        if (isNaN(end.getTime())) return {
            ok: false,
            error: 'Invalid event end.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        const svc = await $7d2e0b14d023f74e$var$_calendarService(sdk);
        // The calendar service exposes FLAT method names (calendarCreateEvent),
        // not createEvent — and its write contract is { payload, organization,
        // workspaceId } with WIRE columns (date + startTime, not an ISO range).
        // The first cut called svc.createEvent with an ISO shape: undefined
        // method → absorbed into "unavailable", so every chained module event
        // silently never landed (caught live 2026-08-06).
        if (!svc || typeof svc.calendarCreateEvent !== 'function') return {
            ok: false,
            error: 'Calendar service unavailable.'
        };
        const pad = (n)=>(n < 10 ? '0' : '') + n;
        const dateStr = start.getFullYear() + '-' + pad(start.getMonth() + 1) + '-' + pad(start.getDate());
        const timeStr = pad(start.getHours()) + ':' + pad(start.getMinutes());
        const endTimeStr = pad(end.getHours()) + ':' + pad(end.getMinutes());
        try {
            const rec = await svc.calendarCreateEvent({
                payload: {
                    // WIRE columns are snake_case (store EVENT_CLIENT_COLUMNS) —
                    // camelCase startTime/endTime are silently dropped by the
                    // allowlist. start_at/end_at ISO keep windowed list queries
                    // working (they filter on startAt).
                    title: title,
                    date: dateStr,
                    start_time: ev.allDay ? null : timeStr,
                    end_time: ev.allDay ? null : endTimeStr,
                    start_at: start.toISOString(),
                    end_at: end.toISOString(),
                    type: 'meeting',
                    description: ev.notes || ev.description || '',
                    // Provenance + module-side fields ride the module-writable bag —
                    // `location` is not a wire column and `metadata` is server-owned.
                    // `meta` is the module's own record fields (kind, userId,
                    // companyId …) — merged UNDER the provenance keys so a module can
                    // never spoof source/module/ref, and a chained event can still be
                    // reconciled back to the row that minted it
                    // (BF-CALENDAR-NATIVE-PROPAGATE-DEAL-CHAIN-1).
                    integration_metadata: {
                        ...ev.meta && typeof ev.meta === 'object' && !Array.isArray(ev.meta) ? ev.meta : {},
                        source: 'workspaceModule',
                        module: cap && cap.module || 'workspaceModule',
                        location: ev.location || '',
                        ref: ev.ref || ''
                    }
                },
                organization: orgId(),
                workspaceId: wsId()
            });
            const row = Array.isArray(rec) ? rec[0] : rec;
            const id = row && (row.id || row._id);
            const result = {
                ok: true,
                id: id,
                event: row,
                roomId: null,
                joinUrl: null
            };
            if (wantsMeet && id != null) {
                const meet = await _ensureMeetRoom({
                    id: id,
                    title: title,
                    description: ev.notes || ev.description || '',
                    row: row,
                    call: call,
                    svc: svc
                });
                result.roomId = meet.roomId;
                result.joinUrl = meet.joinUrl;
                if (meet.event) result.event = meet.event;
                if (meet.error) result.meetError = meet.error;
            }
            if (refKey) _byRef.set(refKey, result);
            return result;
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Could not create the event.'
            };
        }
    };
    // The room half of a symbols-meet event — find-or-create, exactly as the
    // home "Coming up" Join (eventMeetJoin.js) and New Booking do: a room
    // already keyed by this calendarEventId on the shell's rooms list is
    // reused (a retry never mints a second room), otherwise meet's own
    // `createRoom` writes it. Then the /meet#room= link is appended to the
    // event description through the same calendar service PATCH.
    const _ensureMeetRoom = async ({ id: id, title: title, description: description, row: row, call: call, svc: svc })=>{
        if (!call) return {
            roomId: null,
            joinUrl: null,
            error: 'Meet is unavailable in this context.'
        };
        let roomId = null;
        try {
            const rooms = root && Array.isArray(root.rooms) && root.rooms || [];
            const existing = rooms.find((r)=>r && String(r.calendarEventId) === String(id));
            roomId = existing ? existing.id : null;
            if (!roomId) roomId = await call('createRoom', {
                name: title || 'Calendar call',
                kind: 'scheduled',
                calendarEventId: id,
                transcribeEnabled: true
            });
        } catch (e) {
            return {
                roomId: null,
                joinUrl: null,
                error: e && e.message || 'Could not create the meet room.'
            };
        }
        if (!roomId) return {
            roomId: null,
            joinUrl: null,
            error: 'Could not create the meet room.'
        };
        const joinUrl = $7d2e0b14d023f74e$var$_meetLinkFor(root, roomId, call);
        if (!joinUrl) return {
            roomId: roomId,
            joinUrl: null,
            error: 'Could not build the meet link.'
        };
        const desc = row && row.description || description || '';
        if (desc.indexOf(joinUrl) !== -1) return {
            roomId: roomId,
            joinUrl: joinUrl
        };
        const updatedDesc = desc ? desc + '\n' + joinUrl : joinUrl;
        let event = row;
        if (svc && typeof svc.calendarUpdateEvent === 'function') try {
            const rec = await svc.calendarUpdateEvent({
                id: id,
                payload: {
                    description: updatedDesc
                },
                organization: orgId(),
                workspaceId: wsId()
            });
            const patched = Array.isArray(rec) ? rec[0] : rec;
            event = patched && (patched.id || patched._id) ? patched : {
                ...row || {},
                description: updatedDesc
            };
        } catch (e) {
            return {
                roomId: roomId,
                joinUrl: joinUrl,
                error: e && e.message || 'Could not stamp the meet link on the event.'
            };
        }
        return {
            roomId: roomId,
            joinUrl: joinUrl,
            event: event
        };
    };
    // ── update / remove ───────────────────────────────────────────────────
    // WS-MODULE-CALENDAR-BRIDGE-UPDATE-REMOVE-1. The create half alone made the
    // two stores DRIFT: a module row that moved kept its native twin on the old
    // slot, and a deleted row left an orphan event (plus a live meet room) that
    // no module screen could reach again. Same grant, same service, same wire
    // columns as create — never a second write path.
    const _pad = (n)=>(n < 10 ? '0' : '') + n;
    const _dateStr = (d)=>d.getFullYear() + '-' + _pad(d.getMonth() + 1) + '-' + _pad(d.getDate());
    const _timeStr = (d)=>_pad(d.getHours()) + ':' + _pad(d.getMinutes());
    const _asDate = (v)=>v instanceof Date ? v : new Date(v);
    // `this` is the calling element (smbls methods.js binds it) — the same
    // resolution create uses, so meet's fns reach us through el.call.
    const _callOf = (self)=>callFn || (self && typeof self.call === 'function' ? (name, ...args)=>self.call(name, ...args) : null);
    // Move / rename / re-slot the native twin of a module row.
    //   moduleCalendarUpdate({ id, title?, start?, end?, allDay?, location?,
    //                          notes?, meta? })
    // PARTIAL by design: only the fields the module sent are written, so an
    // edit form that knows about a title never blanks a description. `start`
    // rewrites the whole slot (date + start_time/end_time + start_at/end_at),
    // mirroring create — a half-written slot is how a moved event ends up on
    // two days at once.
    const moduleCalendarUpdate = async function(input = {}) {
        const ev = input || {};
        const id = ev.id != null && String(ev.id) !== '' ? ev.id : null;
        if (id == null) return {
            ok: false,
            error: 'An event id is required.'
        };
        const payload = {};
        if (ev.title !== undefined) {
            const title = typeof ev.title === 'string' ? ev.title.trim() : '';
            if (!title) return {
                ok: false,
                error: 'An event title cannot be empty.'
            };
            payload.title = title;
        }
        if (ev.notes !== undefined || ev.description !== undefined) payload.description = ev.notes !== undefined ? ev.notes || '' : ev.description || '';
        if (ev.start !== undefined && ev.start !== null) {
            const start = _asDate(ev.start);
            if (isNaN(start.getTime())) return {
                ok: false,
                error: 'Invalid event start.'
            };
            const end = ev.end != null ? _asDate(ev.end) : new Date(start.getTime() + 3600000);
            if (isNaN(end.getTime())) return {
                ok: false,
                error: 'Invalid event end.'
            };
            payload.date = _dateStr(start);
            payload.start_time = ev.allDay ? null : _timeStr(start);
            payload.end_time = ev.allDay ? null : _timeStr(end);
            payload.start_at = start.toISOString();
            payload.end_at = end.toISOString();
        } else if (ev.end !== undefined && ev.end !== null) {
            const end = _asDate(ev.end);
            if (isNaN(end.getTime())) return {
                ok: false,
                error: 'Invalid event end.'
            };
            payload.end_time = ev.allDay ? null : _timeStr(end);
            payload.end_at = end.toISOString();
        } else if (ev.allDay === true) {
            payload.start_time = null;
            payload.end_time = null;
        }
        const sdk = getSdkFn ? getSdkFn() : null;
        const svc = await $7d2e0b14d023f74e$var$_calendarService(sdk);
        if (!svc || typeof svc.calendarUpdateEvent !== 'function') return {
            ok: false,
            error: 'Calendar service unavailable.'
        };
        // integration_metadata is a WHOLE-BAG column: patching it with only the
        // new keys would drop `source` / `module` / `ref` and orphan the event
        // from the row that minted it. So read the live bag first and merge —
        // module `meta` UNDER the provenance keys, exactly as create does.
        const wantsMeta = ev.location !== undefined || ev.ref !== undefined || ev.meta && typeof ev.meta === 'object' && !Array.isArray(ev.meta);
        if (wantsMeta) {
            let current = null;
            if (typeof svc.calendarGetEvent === 'function') try {
                const got = await svc.calendarGetEvent({
                    id: id,
                    workspaceId: wsId()
                });
                current = Array.isArray(got) ? got[0] : got;
            } catch (_) {
                current = null;
            }
            const prev = current && current.integration_metadata || {};
            payload.integration_metadata = {
                ...prev,
                ...ev.meta && typeof ev.meta === 'object' && !Array.isArray(ev.meta) ? ev.meta : {},
                source: 'workspaceModule',
                module: cap && cap.module || 'workspaceModule',
                location: ev.location !== undefined ? ev.location || '' : prev.location || '',
                ref: ev.ref !== undefined ? ev.ref || '' : prev.ref || ''
            };
        }
        try {
            const rec = await svc.calendarUpdateEvent({
                id: id,
                payload: payload,
                organization: orgId(),
                workspaceId: wsId()
            });
            const row = Array.isArray(rec) ? rec[0] : rec;
            return {
                ok: true,
                id: (row && (row.id || row._id)) != null ? row.id || row._id : id,
                event: row
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Could not update the event.'
            };
        }
    };
    // Retire the native twin. Soft-delete through the service (the calendar
    // app's own `deleteEvent` flips `deleted` so the sync server can push a
    // tombstone — the service DELETE route is that same soft-delete), then end
    // the meet room keyed by this event through MEET'S OWN `endRoom` (el.call),
    // never a second meet_rooms write. The event delete comes FIRST: if it is
    // refused, the room must stay live.
    const moduleCalendarRemove = async function(input = {}) {
        const ev = input || {};
        const id = ev.id != null && String(ev.id) !== '' ? ev.id : null;
        if (id == null) return {
            ok: false,
            error: 'An event id is required.'
        };
        const sdk = getSdkFn ? getSdkFn() : null;
        const svc = await $7d2e0b14d023f74e$var$_calendarService(sdk);
        if (!svc || typeof svc.calendarDeleteEvent !== 'function') return {
            ok: false,
            error: 'Calendar service unavailable.'
        };
        try {
            await svc.calendarDeleteEvent({
                id: id,
                organization: orgId(),
                workspaceId: wsId()
            });
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Could not remove the event.'
            };
        }
        const result = {
            ok: true,
            id: id,
            roomId: null,
            roomEnded: false
        };
        const rooms = root && Array.isArray(root.rooms) && root.rooms || [];
        const room = rooms.find((r)=>r && String(r.calendarEventId) === String(id));
        if (!room) return result;
        result.roomId = room.id;
        const call = _callOf(this);
        // `el.call` on an UNREGISTERED name is a silent no-op that returns
        // undefined — so an absent `endRoom` (it was missing from meet's eager
        // slice until this ticket) would otherwise be reported as a successful
        // end while the room stayed live. Assert the registration, and treat only
        // an explicit `true` as ended.
        const bag = root && root.context && root.context.functions || null;
        if (!call || bag && typeof bag.endRoom !== 'function') {
            result.meetError = 'Meet is unavailable in this context.';
            return result;
        }
        try {
            const ended = await call('endRoom', room.id);
            result.roomEnded = ended === true;
            if (!result.roomEnded) result.meetError = 'Could not end the meet room.';
        } catch (e) {
            result.meetError = e && e.message || 'Could not end the meet room.';
        }
        return result;
    };
    // Read the workspace's events back, so a module can render the NATIVE
    // calendar rather than its own private copy.
    const moduleCalendarList = async function(range = {}) {
        const sdk = getSdkFn ? getSdkFn() : null;
        const svc = await $7d2e0b14d023f74e$var$_calendarService(sdk);
        if (!svc || typeof svc.calendarListEvents !== 'function') return {
            ok: false,
            error: 'Calendar service unavailable.',
            events: []
        };
        try {
            const q = {
                workspaceId: wsId(),
                organization: orgId()
            };
            if (range && (range.from || range.to)) {
                q.window = {};
                if (range.from) q.window.gte = new Date(range.from).toISOString();
                if (range.to) q.window.lte = new Date(range.to).toISOString();
            }
            const res = await svc.calendarListEvents(q);
            const events = Array.isArray(res) ? res : res && (res.data || res.events) || [];
            return {
                ok: true,
                events: events
            };
        } catch (e) {
            return {
                ok: false,
                error: e && e.message || 'Could not load events.',
                events: []
            };
        }
    };
    return {
        moduleCalendarCreate: moduleCalendarCreate,
        moduleCalendarUpdate: moduleCalendarUpdate,
        moduleCalendarRemove: moduleCalendarRemove,
        moduleCalendarList: moduleCalendarList
    };
};

});

parcelRegister("duW2E", function(module, exports) {

$parcel$export(module.exports, "buildModuleNotifyBridge", () => $9d3b1992a122eaa0$export$ced3193a53c5582);
$parcel$export(module.exports, "buildModuleNotifyCloseBridge", () => $9d3b1992a122eaa0$export$70c9cfb3ce4eb234);
// moduleNotifyBridge.js — the GENERIC notification path for installed
// workspace APPS (manifest v2). The notifications sibling of moduleDataBridge
// / moduleCalendarBridge: `el.call('moduleNotify', …)` lets any installed
// appstore app put a real row into the workspace notification surface (bell
// panel + /inbox — packages/shared Notifications.js / notificationScope.js)
// for members of the CURRENT workspace, with zero per-workspace wiring.
// Injected by loadWorkspaceApps for every workspace with ≥1 installed app
// (2026-08-13 per Nika: "appstore apps also come with widgets + notifications
// support — after installing they are just main part of the workspace
// workflow").
//
// ONE DOOR (2026-10-28, server notify by audience — server
// src/domains/notifications/services/notificationAudience.js): every
// moduleNotify is ONE create through the server's audience door, and the
// SERVER picks the recipients from the workspace's own member list. The
// bridge never decides who is a member:
//   • `toUserIds` and the ids in `to` go out as given. The server resolves a
//     Mongo id AND a legacy external id; this roster carries only one of the
//     two per member, so the old client-side match dropped an app's Mongo id
//     for an account that has a legacy id (the bell gap). A non-member id is
//     refused server-side and counted (`refused`).
//   • An email in `to` becomes that roster member's user id — the address
//     never leaves the bridge; an email not on the roster is dropped.
//   • Groups pass through: toRole, toPermission, toTeam, toMembers (refs from
//     the SDK's notifications.audience()), includeAdmins. The server sends a
//     group only when the app's manifest `notify` declares it
//     (403 notify_not_declared otherwise).
//   • No recipient named → every roster member, the caller included (app
//     events are system alerts — low stock, shift assigned — and on a
//     one-member workspace a skip-self default would make the surface
//     silently unreachable). A roster row with no user id is not reachable.
//   • excludeSelf goes to the server, which knows the caller's id exactly.
//   • metadata.dedupKey (with the stamped appId) keeps ONE open notice per
//     member across repeated runs (a repeat answers `deduped`);
//     moduleNotifyClose({ appId, dedupKey }) closes them for every member.
//     metadata.severity: 'INFO' | 'WARNING' | 'ACTION_REQUIRED'.
//   • The app identity, the workspace id and the href are stamped by the
//     bridge, never the caller; the caller must name one of THIS workspace's
//     installed apps. Realtime delivery: the store's create fires the
//     `notification-created` user-socket emit at the write choke point.
//
// CALL CONTRACT (from module code, e.g. a widget body's action handler):
//   await el.call('moduleNotify', {
//     appId: 'system/warehouse-app',   // REQUIRED — the caller's manifest id
//     title: 'Low stock: Shampoo 250ml', // REQUIRED
//     body: '3 left at Central',          // optional
//     route: '/warehouse',                // optional app route ('/'-prefixed);
//                                         // minted into a workspace-addressed
//                                         // href so the row files under the
//                                         // Workspace tab and clicking it
//                                         // opens the app IN this workspace
//     type: 'module',                     // optional row type (defaults to
//                                         // 'module')
//     to: ['a@x.com', '<userId>'],        // optional — roster emails or user ids
//     toUserIds: ['<userId>'],            // optional — Mongo or legacy user ids
//     toRole: 'editor',                   // optional groups — toRole,
//     toPermission: 'production.plan',    //   toPermission, toTeam, toMembers,
//     toTeam: 'planners',                 //   includeAdmins — each one declared
//     includeAdmins: true,                //   in the manifest `notify`
//     excludeSelf: true,                  // optional — skip the caller
//     metadata: { kind: 'overdue', severity: 'WARNING', dedupKey: 'step-9' }
//                                         // optional (appId + workspaceId are
//                                         // stamped on top)
//   }) → { ok, sent, deduped, refused, recipients } | { ok: false, error }
//
//   await el.call('moduleNotifyClose', { appId, dedupKey })
//     → { ok: true, closed } | { ok: false, error }
//
// Every function returns a plain result object and NEVER throws, so an app's
// UI degrades gracefully (same contract as moduleCalendarBridge).
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $9d3b1992a122eaa0$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $9d3b1992a122eaa0$var$shellWithWorkspacePath = (...args)=>(0, $1X0Je.default).functions.withWorkspacePath(...args);
const $9d3b1992a122eaa0$var$shellWorkspaceUrlHandle = (...args)=>(0, $1X0Je.default).functions.workspaceUrlHandle(...args);
// Fan-out ceiling — the server's own cap per send is the same 200 (server
// notificationAudience MAX_AUDIENCE_RECIPIENTS); this guards the default
// fan-out against a pathological people list ever landing on root.
const $9d3b1992a122eaa0$var$MAX_RECIPIENTS = 200;
// The member groups the server resolves (server notificationAudience
// AUDIENCE_KEYS; `toUserIds` is built here from `to` + `toUserIds`).
const $9d3b1992a122eaa0$var$NOTIFY_GROUP_KEYS = [
    'toRole',
    'toPermission',
    'toTeam',
    'toMembers'
];
const $9d3b1992a122eaa0$var$_notifyLc = (v)=>v == null ? '' : String(v).toLowerCase();
// User ids are opaque (Mongo _id or a legacy external id) — compared and sent
// as exact strings, never lowercased.
const $9d3b1992a122eaa0$var$_notifyIdOf = (v)=>v == null || typeof v === 'object' ? '' : String(v).trim();
const $9d3b1992a122eaa0$var$_notifyInstalledIds = (installedAppIds)=>(Array.isArray(installedAppIds) ? installedAppIds : []).map($9d3b1992a122eaa0$var$_notifyLc).filter(Boolean);
const $9d3b1992a122eaa0$var$_notifyWorkspaceIdOf = (root)=>{
    const ws = root && root.workspace;
    const id = ws && (ws.id || ws._id);
    return id ? String(id) : '';
};
// The server's refusal as one line: `<code> — <message>` (the SDK error's
// `cause` is the route's error body), else 'notify_failed'.
const $9d3b1992a122eaa0$var$_notifyErrorOf = (err)=>{
    const cause = err && err.cause && typeof err.cause === 'object' ? err.cause : null;
    const code = cause && (cause.code || cause.error) ? String(cause.code || cause.error) : '';
    const message = cause && cause.message ? String(cause.message) : '';
    if (!code) return 'notify_failed';
    return message && message !== code ? code + " \u2014 " + message : code;
};
// One roster entry per member: the email when this viewer may see it (their
// own row; every row for an org-mgmt viewer) and the user id (every row carries
// it — root.people `userId`, raw rows `user_id`).
const $9d3b1992a122eaa0$var$_notifyRosterOf = (root)=>{
    const people = Array.isArray(root && root.people) ? root.people : [];
    const roster = [];
    const seen = new Set();
    people.forEach((p)=>{
        if (!p || typeof p !== 'object') return;
        const email = $9d3b1992a122eaa0$var$_notifyLc(p.email);
        const userId = $9d3b1992a122eaa0$var$_notifyIdOf(p.userId != null ? p.userId : p.user_id);
        const key = userId ? 'id:' + userId : email ? 'email:' + email : '';
        if (!key || seen.has(key)) return;
        seen.add(key);
        roster.push({
            email: email,
            userId: userId
        });
    });
    return roster;
};
const $9d3b1992a122eaa0$export$ced3193a53c5582 = (root, installedAppIds = [], { getSdkFn: getSdkFn = $9d3b1992a122eaa0$var$shellGetSDK } = {})=>{
    const ids = $9d3b1992a122eaa0$var$_notifyInstalledIds(installedAppIds);
    return async function moduleNotify(opts = {}) {
        try {
            const o = opts && typeof opts === 'object' ? opts : {};
            const appId = $9d3b1992a122eaa0$var$_notifyLc(o.appId);
            if (!appId || ids.indexOf(appId) < 0) return {
                ok: false,
                error: "unknown_app \u2014 appId must name an installed app"
            };
            const title = o.title ? String(o.title) : '';
            if (!title) return {
                ok: false,
                error: 'title_required'
            };
            const groups = {};
            $9d3b1992a122eaa0$var$NOTIFY_GROUP_KEYS.forEach((k)=>{
                if (o[k] !== undefined && o[k] !== null) groups[k] = o[k];
            });
            if (o.includeAdmins === true) groups.includeAdmins = true;
            const hasGroups = Object.keys(groups).length > 0;
            const roster = $9d3b1992a122eaa0$var$_notifyRosterOf(root);
            const to = Array.isArray(o.to) ? o.to : [];
            const toUserIds = Array.isArray(o.toUserIds) ? o.toUserIds : [];
            let userIds = [];
            if (to.length || toUserIds.length || hasGroups) {
                const byEmail = new Map();
                roster.forEach((m)=>{
                    if (m.email && m.userId) byEmail.set(m.email, m.userId);
                });
                to.forEach((v)=>{
                    const s = $9d3b1992a122eaa0$var$_notifyIdOf(v);
                    if (!s) return;
                    if (s.indexOf('@') < 0) userIds.push(s);
                    else if (byEmail.has($9d3b1992a122eaa0$var$_notifyLc(s))) userIds.push(byEmail.get($9d3b1992a122eaa0$var$_notifyLc(s)));
                });
                toUserIds.forEach((v)=>{
                    const s = $9d3b1992a122eaa0$var$_notifyIdOf(v);
                    if (s) userIds.push(s);
                });
            } else {
                if (!roster.length) return {
                    ok: false,
                    error: "no_members \u2014 workspace roster not loaded yet"
                };
                userIds = roster.map((m)=>m.userId).filter(Boolean);
            }
            userIds = Array.from(new Set(userIds)).slice(0, $9d3b1992a122eaa0$var$MAX_RECIPIENTS);
            if (!userIds.length && !hasGroups) return {
                ok: false,
                error: "no_recipients \u2014 none of `to` are workspace members"
            };
            // Href — workspace-ADDRESSED, not workspace-relative: notificationScope's
            // Workspace tab places a row by its `/w/<org>/<ws>` prefix, and a bare
            // app route ('/bi') would read as "current" in EVERY workspace. Minted
            // from the live org + workspace the app is running in.
            const route = typeof o.route === 'string' && o.route.charAt(0) === '/' ? o.route : null;
            const orgSlug = root && root.org && (root.org.slug || root.org.key);
            const wsHandle = $9d3b1992a122eaa0$var$shellWorkspaceUrlHandle(root && root.workspace);
            const href = route && orgSlug ? $9d3b1992a122eaa0$var$shellWithWorkspacePath(orgSlug, wsHandle, route) : route;
            // `workspaceId` names the workspace whose member list the server reads
            // (stamped in metadata, and the SDK's `?workspaceId=`).
            const wsId = $9d3b1992a122eaa0$var$_notifyWorkspaceIdOf(root);
            const metadata = {
                ...o.metadata && typeof o.metadata === 'object' ? o.metadata : {},
                appId: appId,
                ...wsId ? {
                    workspaceId: wsId
                } : {}
            };
            const sdk = getSdkFn();
            if (!sdk || typeof sdk.execute !== 'function') return {
                ok: false,
                error: 'sdk_unavailable'
            };
            const payload = {
                type: (o.type ? String(o.type) : '') || 'module',
                title: title,
                body: o.body ? String(o.body) : null,
                href: href || null,
                ...userIds.length ? {
                    toUserIds: userIds
                } : {},
                ...groups,
                ...o.excludeSelf ? {
                    excludeSelf: true
                } : {},
                metadata: metadata
            };
            let out;
            try {
                out = await Promise.resolve().then(()=>sdk.execute('workspaceProject.notifications', 'create', {
                        payload: payload,
                        ...wsId ? {
                            workspaceId: wsId
                        } : {}
                    }));
            } catch (err) {
                console.warn('[moduleNotify]', appId, err && err.message);
                return {
                    ok: false,
                    error: $9d3b1992a122eaa0$var$_notifyErrorOf(err)
                };
            }
            const n = (k)=>out && Number.isFinite(Number(out[k])) ? Number(out[k]) : 0;
            const sent = n('sent');
            const deduped = n('deduped');
            return {
                ok: sent + deduped > 0,
                sent: sent,
                deduped: deduped,
                refused: n('refused'),
                recipients: n('recipients')
            };
        } catch (err) {
            console.warn('[moduleNotify] failed', err && err.message);
            return {
                ok: false,
                error: 'notify_failed'
            };
        }
    };
};
const $9d3b1992a122eaa0$export$70c9cfb3ce4eb234 = (root, installedAppIds = [], { getSdkFn: getSdkFn = $9d3b1992a122eaa0$var$shellGetSDK } = {})=>{
    const ids = $9d3b1992a122eaa0$var$_notifyInstalledIds(installedAppIds);
    return async function moduleNotifyClose(opts = {}) {
        try {
            const o = opts && typeof opts === 'object' ? opts : {};
            const appId = $9d3b1992a122eaa0$var$_notifyLc(o.appId);
            if (!appId || ids.indexOf(appId) < 0) return {
                ok: false,
                error: "unknown_app \u2014 appId must name an installed app"
            };
            const dedupKey = typeof o.dedupKey === 'string' ? o.dedupKey.trim() : '';
            if (!dedupKey) return {
                ok: false,
                error: 'dedupKey_required'
            };
            const sdk = getSdkFn();
            if (!sdk || typeof sdk.execute !== 'function') return {
                ok: false,
                error: 'sdk_unavailable'
            };
            const wsId = $9d3b1992a122eaa0$var$_notifyWorkspaceIdOf(root);
            let out;
            try {
                out = await Promise.resolve().then(()=>sdk.execute('workspaceProject.notifications', 'close', {
                        appId: appId,
                        dedupKey: dedupKey,
                        ...wsId ? {
                            workspaceId: wsId
                        } : {}
                    }));
            } catch (err) {
                console.warn('[moduleNotifyClose]', appId, err && err.message);
                return {
                    ok: false,
                    error: $9d3b1992a122eaa0$var$_notifyErrorOf(err)
                };
            }
            const closed = out && Number.isFinite(Number(out.closed)) ? Number(out.closed) : 0;
            return {
                ok: true,
                closed: closed
            };
        } catch (err) {
            console.warn('[moduleNotifyClose] failed', err && err.message);
            return {
                ok: false,
                error: 'notify_failed'
            };
        }
    };
};

});

parcelRegister("asht4", function(module, exports) {

$parcel$export(module.exports, "buildModuleAskBridge", () => $79ca11aa9a74e885$export$3e74a5f2525837f9);
// moduleAsk (MODULE-ASK-BRIDGE-1) — an installed app asks the workspace
// assistant a question ABOUT something it shows, the way a member does with
// Inspect & ask (functions/aiInspect.js): the context rides the turn
// STRUCTURED (`context.inspected`, the server's INSPECTED line), and the ask
// goes through the composer's own send (homeAiSend), so the drawer, the main
// thread and the member's placement all behave as for a typed question.
//
//   el.call('moduleAsk', prompt, {
//     context: { title, text?, records?: ['<collection>:<id>' | { collection, id }],
//                route? },
//     mode?: 'assistant' | 'dashboard' | 'tools' | 'apps' | 'presentation' | 'fly'
//   }) → Promise<{ ok: true } | { ok: false, error }>
//
// Before this, the DFI Finances app's "Ask more" called homeAiSend directly
// with the context pasted into the prompt text — the model read it as the
// member's words, and nothing named the app or the records it was about.
//
// Records travel as Inspect & ask marks them (`data-inspect-record`,
// "<collection>:<record id>" — the server's INSPECTED line prints them as
// "records shown"); an object form is folded into that string.
// Bounded like a pick: prompt 2,000 chars, title 120, text 2,000, records 20.
// It starts a turn (credits), so a read-only verb is refused it
// (moduleReadOnlyCall.js REFUSED). The member's own picks stay; an earlier
// ask from the same app and title is replaced, never stacked.
const $79ca11aa9a74e885$var$PROMPT_MAX = 2000;
const $79ca11aa9a74e885$var$TITLE_MAX = 120;
const $79ca11aa9a74e885$var$TEXT_MAX = 2000;
const $79ca11aa9a74e885$var$RECORDS_MAX = 20;
const $79ca11aa9a74e885$var$ASK_BRIDGE_MODES = [
    'assistant',
    'dashboard',
    'tools',
    'apps',
    'presentation',
    'fly'
];
const $79ca11aa9a74e885$var$_str = (v, max)=>typeof v === 'string' ? v.trim().slice(0, max) : '';
const $79ca11aa9a74e885$var$_recordToken = (r)=>{
    if (typeof r === 'string') return $79ca11aa9a74e885$var$_str(r, 120);
    if (!r || typeof r !== 'object') return '';
    const collection = $79ca11aa9a74e885$var$_str(r.collection, 80);
    const id = $79ca11aa9a74e885$var$_str(String(r.id ?? ''), 120);
    return collection && id ? `${collection}:${id}`.slice(0, 120) : '';
};
const $79ca11aa9a74e885$var$_askBridgeRecords = (list)=>[
        ...new Set((Array.isArray(list) ? list : []).map($79ca11aa9a74e885$var$_recordToken).filter(Boolean))
    ].slice(0, $79ca11aa9a74e885$var$RECORDS_MAX);
// What a pick needs to know about where the ask comes from: the surface the
// member is on (aiScopeSurface — the same reader Inspect & ask uses).
const $79ca11aa9a74e885$var$_surface = (el, root)=>{
    try {
        const sf = el.call('aiScopeSurface', root);
        return sf && typeof sf === 'object' ? sf : null;
    } catch (_) {
        return null;
    }
};
const $79ca11aa9a74e885$export$3e74a5f2525837f9 = (root)=>async function moduleAsk(prompt, opts) {
        const el = this;
        const text = $79ca11aa9a74e885$var$_str(prompt, $79ca11aa9a74e885$var$PROMPT_MAX);
        if (!text) return {
            ok: false,
            error: 'moduleAsk needs a question.'
        };
        if (!root || typeof root.update !== 'function' || !el || typeof el.call !== 'function') return {
            ok: false,
            error: 'No workspace assistant here.'
        };
        const o = opts && typeof opts === 'object' ? opts : {};
        const c = o.context && typeof o.context === 'object' ? o.context : null;
        if (c) {
            const title = $79ca11aa9a74e885$var$_str(c.title, $79ca11aa9a74e885$var$TITLE_MAX);
            if (!title) return {
                ok: false,
                error: 'moduleAsk context needs a title.'
            };
            const surface = $79ca11aa9a74e885$var$_surface(el, root);
            const facts = {
                id: 'ask-' + Date.now().toString(36),
                title: title,
                kind: 'section'
            };
            const route = $79ca11aa9a74e885$var$_str(c.route, 240) || $79ca11aa9a74e885$var$_str(surface && surface.path, 240);
            if (route) facts.route = route;
            if (surface && surface.app && surface.app.module && surface.app.id) facts.app = {
                id: $79ca11aa9a74e885$var$_str(surface.app.id, 120),
                ...surface.app.name ? {
                    name: $79ca11aa9a74e885$var$_str(surface.app.name, 120)
                } : {}
            };
            const body = $79ca11aa9a74e885$var$_str(c.text, $79ca11aa9a74e885$var$TEXT_MAX);
            if (body) facts.text = body;
            const records = $79ca11aa9a74e885$var$_askBridgeRecords(c.records);
            if (records.length) facts.records = records;
            const entry = {
                keyPath: [
                    title
                ],
                key: title,
                tag: 'region',
                title: title,
                text: (body || title).slice(0, 80),
                pickedAt: Date.now(),
                inspect: facts
            };
            const keep = (Array.isArray(root.pickedElements) ? root.pickedElements : []).filter((p)=>!(p && p.inspect && p.inspect.title === facts.title && (p.inspect.app && p.inspect.app.id) === (facts.app && facts.app.id)));
            root.update({
                pickedElements: [
                    ...keep,
                    entry
                ]
            });
        }
        try {
            await el.call('homeAiSend', text, null, 0, null, $79ca11aa9a74e885$var$ASK_BRIDGE_MODES.includes(o.mode) ? {
                mode: o.mode
            } : null);
            return {
                ok: true
            };
        } catch (err) {
            return {
                ok: false,
                error: err && err.message || 'The assistant could not take the question.'
            };
        }
    };

});

parcelRegister("7muxD", function(module, exports) {

$parcel$export(module.exports, "getWorkspaceCached", () => $55c247655b75a39c$export$4b83db223441a4e5);
$parcel$export(module.exports, "invalidateWorkspaceCache", () => $55c247655b75a39c$export$11c4e4655c46394e);
$parcel$export(module.exports, "primeWorkspaceCache", () => $55c247655b75a39c$export$6aece8dd9a3f308);
// Coalesce sdk.getWorkspace(wsId) calls. A single org/workspace switch was
// firing getWorkspace up to 8× — onWorkspaceChange + loadWorkspaceProject, each
// re-run by the orgSwitched-bus + auth `active_workspace_id` dual-trigger — and
// the 8 concurrent calls saturated the browser's ~6-connection pool so EACH took
// 2-4s instead of the ~170ms it takes uncontended, pinning the switch's pre-wipe
// window at ~3.8s (and starving the roster / dashboard-prefs reads racing them).
// In-flight dedup + a short TTL keyed by workspaceId collapses them to ONE
// round-trip. Same pattern as listOrgMembers.js / loadAllTeams.
let $55c247655b75a39c$var$_inflight = {};
let $55c247655b75a39c$var$_cache = {};
const $55c247655b75a39c$var$TTL_MS = 8000;
const $55c247655b75a39c$export$4b83db223441a4e5 = (sdk, wsId, opts = {})=>{
    if (!sdk || wsId == null || typeof sdk.getWorkspace !== 'function') return Promise.resolve(null);
    const key = String(wsId);
    if (!opts.force) {
        const c = $55c247655b75a39c$var$_cache[key];
        if (c && Date.now() - c.at < $55c247655b75a39c$var$TTL_MS) return Promise.resolve(c.rec);
        // In-flight reuse is TIME-BOUNDED (WS-SWITCH-ONWORKSPACECHANGE-BOUNDED-
        // WINDOW-TRIP-1). The entry is dropped in `.finally` — which NEVER runs for
        // a request that neither resolves nor rejects, so one hung round-trip used
        // to poison this workspace id for the rest of the session: every later
        // caller (the switch pipeline, loadWorkspaceProject, the config resolver)
        // awaited the same dead promise. Past the TTL a fresh fetch is issued
        // instead; the dead one is simply abandoned.
        const f = $55c247655b75a39c$var$_inflight[key];
        if (f && Date.now() - f.at < $55c247655b75a39c$var$TTL_MS) return f.p;
    }
    const p = Promise.resolve(sdk.getWorkspace(wsId)).then((res)=>{
        const raw = res && res.data || res || null;
        // Only an id-shaped payload is a workspace RECORD. SDK error payloads
        // ({ error: 'no active workspace for user', … }) resolve (not reject) —
        // caching one as "the record" poisoned every consumer for TTL_MS
        // (settings unresolvable across the whole boot chain: module loader,
        // config resolver, workspace-apps). Return null instead — every caller
        // already treats null as fetch-miss.
        const rec = raw && (raw._id || raw.id) ? raw : null;
        if (rec) $55c247655b75a39c$var$_cache[key] = {
            rec: rec,
            at: Date.now()
        };
        return rec;
    }).finally(()=>{
        if ($55c247655b75a39c$var$_inflight[key] && $55c247655b75a39c$var$_inflight[key].p === p) delete $55c247655b75a39c$var$_inflight[key];
    });
    $55c247655b75a39c$var$_inflight[key] = {
        p: p,
        at: Date.now()
    };
    return p;
};
const $55c247655b75a39c$export$11c4e4655c46394e = (wsId)=>{
    if (wsId == null) {
        $55c247655b75a39c$var$_cache = {};
        $55c247655b75a39c$var$_inflight = {};
    } else {
        const k = String(wsId);
        delete $55c247655b75a39c$var$_cache[k];
        delete $55c247655b75a39c$var$_inflight[k];
    }
};
const $55c247655b75a39c$export$6aece8dd9a3f308 = (wsId, rec)=>{
    if (wsId == null || !rec || !(rec._id || rec.id)) return false;
    if (String(rec._id || rec.id) !== String(wsId)) return false;
    $55c247655b75a39c$var$_cache[String(wsId)] = {
        rec: rec,
        at: Date.now()
    };
    return true;
};

});

parcelRegister("j9v8x", function(module, exports) {

$parcel$export(module.exports, "normalizeScopedKeys", () => $df1702b00e644f2d$export$1636dc6fcf4e7e2e);
$parcel$export(module.exports, "registerModuleScopedKeys", () => $df1702b00e644f2d$export$bd6d4321180d3654);
$parcel$export(module.exports, "unregisterModuleScopedKeys", () => $df1702b00e644f2d$export$af7d2f4f85f15aa);
$parcel$export(module.exports, "__resetModuleScopedKeysForTests", () => $df1702b00e644f2d$export$2b83fb35a2d04bad);
$parcel$export(module.exports, "moduleScopedWipeFor", () => $df1702b00e644f2d$export$cce22f376ca3728a);
$parcel$export(module.exports, "moduleScopedWipe", () => $df1702b00e644f2d$export$cfdd011bc52b95ac);
$parcel$export(module.exports, "runModuleSwitchHook", () => $df1702b00e644f2d$export$87876d28f1bd34cc);
// WS-MODULE-SCOPED-KEYS-CONTRACT-1 — the MODULE half of the tenant-boundary
// wipe registry.
//
// `scopes.js workspaceScopedWipe()` is the single source of truth for SHELL
// state that resets on an org/workspace switch (WORKSPACE_SCOPED_KEYS). A
// workspace MODULE (the takeover `settings.workspaceModule` or an additive
// `settings.workspaceApps[]` entry) writes its own root keys — and until this
// registry existed it had NO way to say "these are mine and tenant-scoped".
// Every module key survived the switch by construction unless the module
// wiped by hand at its own teardown (bellforge-app 0097ee9 / b1ec6eb —
// BF-WSEVENTS-SURVIVES-ORG-SWITCH-1, BF-MODULE-SLICES-DONT-RELOAD-ON-ORG-
// RETURN-1), and a module that forgets leaks one tenant's rows into the next.
//
// THE CONTRACT (manifest v2, read by workspaceProjects.js `_normalizeManifest`):
//
//   scopedKeys: ['bfWsEvents', 'bf*', { key: 'bfView', empty: 'home' }]
//   hooks: { onWorkspaceSwitch: 'bfReleaseTenantState' }
//
// • `scopedKeys` entries: a plain key, a `prefix*` family (every LIVE root key
//   that starts with the prefix), or `{ key | prefix, empty }` with an explicit
//   reset value. The default reset is the TYPED EMPTY of the live value
//   (array → [], boolean → false, number → 0, string → '', object → null) —
//   mirroring the shell's own `_freshEmpty` semantics (a hardcoded [] is
//   wrong-typed for an object key: truthy to `if (!key)`, see
//   WS-SWITCH-RESET-SHAPE). Absent keys are skipped — a wipe resets what
//   exists, it never mints state. Declared keys reset REGARDLESS of the
//   loader's "only seed when empty" gate: a declaration means "mine".
// • `hooks.onWorkspaceSwitch` names a MODULE function the shell calls at the
//   module's tenant boundary (first thing in `_teardownModule`, while the
//   module's functions still resolve and its surfaces are still mounted) as
//   `fn.call(rootElement, rootState, { reason, moduleId })`. It is the place
//   for late-write fences (a listing in flight at the boundary must drop its
//   result instead of repainting the outgoing tenant's rows).
//
// WHO CALLS WHAT. The loader registers on inject (takeover module and every
// additive-app ledger alike) and unregisters on teardown. `scopes.js
// workspaceScopedWipe(root)` spreads `moduleScopedWipe(liveState)` into the
// PHASE-1 `root.replace` of the switch pipeline, so every loaded module's
// declared keys reset SYNCHRONOUSLY at the boundary with no module code;
// `_clearState` / `_teardownApp` apply the same patch at teardown (idempotent:
// a second pass over already-empty keys writes the same empties).
//
// This file has NO shell imports on purpose — scopes.js imports it and
// workspaceProjects.js imports it; a dependency on either would be a cycle.
const $df1702b00e644f2d$var$_registry = new Map() // ownerId → { keys: NormalizedEntry[], hook: string|null }
;
const $df1702b00e644f2d$export$4d38d3de47f70518 = (v)=>{
    if (Array.isArray(v)) return [];
    if (typeof v === 'boolean') return false;
    if (typeof v === 'number') return 0;
    if (typeof v === 'string') return '';
    return null;
};
// A fresh instance of an explicit `empty` — arrays/objects must be NEW per
// switch so one tenant's mutations cannot bleed into the next wipe.
const $df1702b00e644f2d$var$_freshOf = (v)=>{
    if (Array.isArray(v)) return [
        ...v
    ];
    if (v && typeof v === 'object') return {
        ...v
    };
    return v;
};
const $df1702b00e644f2d$export$60a8f25893500516 = (entry)=>{
    if (typeof entry === 'string') {
        const s = entry.trim();
        if (!s) return null;
        if (s.endsWith('*')) {
            const prefix = s.slice(0, -1);
            return prefix ? {
                prefix: prefix
            } : null;
        }
        return {
            key: s
        };
    }
    if (entry && typeof entry === 'object') {
        const hasEmpty = Object.prototype.hasOwnProperty.call(entry, 'empty');
        if (typeof entry.prefix === 'string' && entry.prefix) return hasEmpty ? {
            prefix: entry.prefix,
            empty: entry.empty,
            hasEmpty: hasEmpty
        } : {
            prefix: entry.prefix
        };
        if (typeof entry.key === 'string' && entry.key) {
            const key = entry.key.endsWith('*') ? null : entry.key;
            if (!key) return hasEmpty ? {
                prefix: entry.key.slice(0, -1),
                empty: entry.empty,
                hasEmpty: hasEmpty
            } : {
                prefix: entry.key.slice(0, -1)
            };
            return hasEmpty ? {
                key: key,
                empty: entry.empty,
                hasEmpty: hasEmpty
            } : {
                key: key
            };
        }
    }
    return null;
};
const $df1702b00e644f2d$export$1636dc6fcf4e7e2e = (list)=>{
    const out = [];
    for (const raw of Array.isArray(list) ? list : []){
        const n = $df1702b00e644f2d$export$60a8f25893500516(raw);
        if (n) out.push(n);
    }
    return out;
};
const $df1702b00e644f2d$export$bd6d4321180d3654 = (ownerId, { keys: keys = [], hook: hook = null } = {})=>{
    if (!ownerId) return;
    $df1702b00e644f2d$var$_registry.set(String(ownerId), {
        keys: $df1702b00e644f2d$export$1636dc6fcf4e7e2e(keys),
        hook: typeof hook === 'string' && hook ? hook : null
    });
};
const $df1702b00e644f2d$export$af7d2f4f85f15aa = (ownerId)=>{
    if (ownerId == null) return;
    $df1702b00e644f2d$var$_registry.delete(String(ownerId));
};
const $df1702b00e644f2d$export$8be9accd939fdfe3 = (ownerId)=>$df1702b00e644f2d$var$_registry.has(String(ownerId));
const $df1702b00e644f2d$export$5f5b433fb27ec781 = ()=>[
        ...$df1702b00e644f2d$var$_registry.entries()
    ].map(([ownerId, d])=>({
            ownerId: ownerId,
            keys: d.keys.map((e)=>({
                    ...e
                })),
            hook: d.hook
        }));
const $df1702b00e644f2d$export$2b83fb35a2d04bad = ()=>$df1702b00e644f2d$var$_registry.clear();
const $df1702b00e644f2d$export$3a774a290b78b207 = (entries, key)=>{
    for (const e of entries || []){
        if (e.key !== undefined && e.key === key) return true;
        if (e.prefix !== undefined && key.startsWith(e.prefix)) return true;
    }
    return false;
};
const $df1702b00e644f2d$export$3bfafd0288ce049c = (root)=>{
    if (!root) return {};
    if (typeof root.parse === 'function') try {
        const p = root.parse();
        if (p && typeof p === 'object') return p;
    } catch (_) {
    /* fall through to own props */ }
    return root;
};
const $df1702b00e644f2d$export$528091a951ebc513 = (entries, bag)=>{
    const patch = {};
    const live = bag || {};
    for (const e of entries || []){
        if (e.key !== undefined) {
            if (!Object.prototype.hasOwnProperty.call(live, e.key)) continue;
            patch[e.key] = e.hasEmpty ? $df1702b00e644f2d$var$_freshOf(e.empty) : $df1702b00e644f2d$export$4d38d3de47f70518(live[e.key]);
            continue;
        }
        if (e.prefix !== undefined) for (const k of Object.keys(live)){
            if (!k.startsWith(e.prefix)) continue;
            // An explicit-key entry for the same key wins over a family default
            // (declared more specifically) — keep the first write.
            if (Object.prototype.hasOwnProperty.call(patch, k)) continue;
            patch[k] = e.hasEmpty ? $df1702b00e644f2d$var$_freshOf(e.empty) : $df1702b00e644f2d$export$4d38d3de47f70518(live[k]);
        }
    }
    return patch;
};
const $df1702b00e644f2d$export$cce22f376ca3728a = (ownerId, root)=>{
    const d = ownerId != null ? $df1702b00e644f2d$var$_registry.get(String(ownerId)) : null;
    if (!d || !d.keys.length) return {};
    return $df1702b00e644f2d$export$528091a951ebc513(d.keys, $df1702b00e644f2d$export$3bfafd0288ce049c(root));
};
const $df1702b00e644f2d$export$cfdd011bc52b95ac = (root)=>{
    if (!$df1702b00e644f2d$var$_registry.size) return {};
    const bag = $df1702b00e644f2d$export$3bfafd0288ce049c(root);
    const patch = {};
    // Explicit keys first across all owners, then families, so a specific
    // declaration always wins over a prefix default from any owner.
    const explicit = [];
    const families = [];
    for (const d of $df1702b00e644f2d$var$_registry.values())for (const e of d.keys)(e.key !== undefined ? explicit : families).push(e);
    Object.assign(patch, $df1702b00e644f2d$export$528091a951ebc513(explicit, bag));
    for (const [k, v] of Object.entries($df1702b00e644f2d$export$528091a951ebc513(families, bag)))if (!Object.prototype.hasOwnProperty.call(patch, k)) patch[k] = v;
    return patch;
};
const $df1702b00e644f2d$export$87876d28f1bd34cc = (ownerId, { resolveFn: resolveFn, thisArg: thisArg, root: root, reason: reason = 'teardown' } = {})=>{
    const d = $df1702b00e644f2d$var$_registry.get(String(ownerId));
    if (!d || !d.hook) return false;
    const fn = typeof resolveFn === 'function' ? resolveFn(d.hook) : null;
    if (typeof fn !== 'function') {
        console.warn('[workspaceModule] onWorkspaceSwitch hook is not a module function:', ownerId, d.hook);
        return false;
    }
    try {
        fn.call(thisArg || root, root, {
            reason: reason,
            moduleId: String(ownerId)
        });
        return true;
    } catch (err) {
        console.warn('[workspaceModule] onWorkspaceSwitch hook threw:', ownerId, d.hook, err && err.message);
        return false;
    }
};

});


parcelRegister("8eEEA", function(module, exports) {

$parcel$export(module.exports, "normalizeComposerImages", () => $5fef2a794e5d957c$export$9551f5984c01637d);
$parcel$export(module.exports, "describeRejectedImages", () => $5fef2a794e5d957c$export$584e258d99daea41);
// Composer image attachments → the wire shape the assistant transport sends.
//
// TWO composer shapes exist today and both land here:
//   • the drawer/sidebar UploadBtn (shared/components/_simone/Chat.js) pushes a
//     BARE data-URL string — `reader.result` straight from FileReader;
//   • the canvas composer (canvas/components/CanvasPromptTextarea.js) pushes
//     `{ key, name, mime, size, dataUrl }` from its drop/paste/upload handlers.
// `normalizeComposerImages` accepts either and emits ONE shape.
//
// Bare shared-library import, deferred-call style (circular-init safety).

var $1X0Je = parcelRequire("1X0Je");
// The shipped English, for a caller that has no element to speak through
// (the unit tests, a headless send) — never a raw key.
const $5fef2a794e5d957c$var$_shippedEnglish = (key)=>String((0, $1X0Je.default).functions.i18nStaticEnglish()[key] || key);
const $5fef2a794e5d957c$export$599b045b6fd2219e = {
    maxCount: 4,
    maxBytesPerImage: 3145728,
    maxBytesTotal: 6291456,
    // The four formats the Anthropic image block and the OpenAI `image_url`
    // data-URL block both accept.
    mimeTypes: [
        'image/png',
        'image/jpeg',
        'image/gif',
        'image/webp'
    ]
};
// HEADER ONLY — deliberately not `([\s\S]*)$`. This runs on the reactive
// awareness path (pageContext.js) where a capture group would copy the whole
// multi-megabyte base64 body on every render. Everything downstream needs the
// data URL whole, so it is never split.
const $5fef2a794e5d957c$var$DATA_URL_HEAD_RE = /^data:([a-z0-9.+/-]+);base64,/i;
const $5fef2a794e5d957c$export$4d05511f2f102071 = (dataUrl, headerLength)=>{
    const s = String(dataUrl || '');
    const encoded = Math.max(0, s.length - (headerLength || 0));
    if (!encoded) return 0;
    const padding = s.endsWith('==') ? 2 : s.endsWith('=') ? 1 : 0;
    return Math.max(0, Math.floor(encoded * 3 / 4) - padding);
};
const $5fef2a794e5d957c$export$e1a3971de07c83b5 = (bytes)=>{
    const n = Number(bytes) || 0;
    if (n < 1024) return `${n} B`;
    if (n < 1048576) return `${Math.round(n / 1024)} KB`;
    return `${(n / 1048576).toFixed(1)} MB`;
};
const $5fef2a794e5d957c$export$9551f5984c01637d = (images)=>{
    const attachments = [];
    const rejected = [];
    const decisions = [];
    let total = 0;
    const list = Array.isArray(images) ? images : [];
    for(let index = 0; index < list.length; index++){
        const entry = list[index];
        const refuse = (name, reason)=>{
            rejected.push({
                name: name,
                reason: reason
            });
            decisions.push({
                index: index,
                accepted: false,
                reason: reason
            });
        };
        if (!entry) {
            refuse('image', 'empty');
            continue;
        }
        const raw = typeof entry === 'string' ? {
            dataUrl: entry
        } : entry;
        const dataUrl = String(raw.dataUrl || raw.url || '');
        const name = String(raw.name || `image-${index + 1}`).slice(0, 200);
        const head = $5fef2a794e5d957c$var$DATA_URL_HEAD_RE.exec(dataUrl);
        if (!head) {
            refuse(name, 'not_a_base64_data_url');
            continue;
        }
        const mime = String(raw.mime || raw.type || head[1] || '').toLowerCase();
        if (!$5fef2a794e5d957c$export$599b045b6fd2219e.mimeTypes.includes(mime)) {
            refuse(name, `unsupported_type:${mime || 'unknown'}`);
            continue;
        }
        if (attachments.length >= $5fef2a794e5d957c$export$599b045b6fd2219e.maxCount) {
            refuse(name, 'too_many');
            continue;
        }
        // Trust the composer's own byte count when it has one (the File it read),
        // otherwise weigh the data URL — the drawer UploadBtn keeps no size.
        const size = Number(raw.size) > 0 ? Number(raw.size) : $5fef2a794e5d957c$export$4d05511f2f102071(dataUrl, head[0].length);
        if (size > $5fef2a794e5d957c$export$599b045b6fd2219e.maxBytesPerImage) {
            refuse(name, 'too_large');
            continue;
        }
        if (total + size > $5fef2a794e5d957c$export$599b045b6fd2219e.maxBytesTotal) {
            refuse(name, 'total_too_large');
            continue;
        }
        total += size;
        attachments.push({
            name: name,
            mime: mime,
            size: size,
            dataUrl: dataUrl
        });
        decisions.push({
            index: index,
            accepted: true,
            reason: null
        });
    }
    return {
        attachments: attachments,
        rejected: rejected,
        decisions: decisions
    };
};
const $5fef2a794e5d957c$export$584e258d99daea41 = (rejected, say = $5fef2a794e5d957c$var$_shippedEnglish)=>{
    if (!Array.isArray(rejected) || !rejected.length) return null;
    const why = {
        too_many: ()=>say('workspace.simone.images.tooMany').replace('{max}', ()=>String($5fef2a794e5d957c$export$599b045b6fd2219e.maxCount)),
        too_large: ()=>say('workspace.simone.images.tooLarge').replace('{size}', ()=>$5fef2a794e5d957c$export$e1a3971de07c83b5($5fef2a794e5d957c$export$599b045b6fd2219e.maxBytesPerImage)),
        total_too_large: ()=>say('workspace.simone.images.totalTooLarge').replace('{size}', ()=>$5fef2a794e5d957c$export$e1a3971de07c83b5($5fef2a794e5d957c$export$599b045b6fd2219e.maxBytesTotal)),
        not_a_base64_data_url: ()=>say('workspace.simone.images.notReadable'),
        empty: ()=>say('workspace.simone.images.empty')
    };
    const lines = rejected.map((r)=>{
        const reason = String(r?.reason || '');
        const label = reason.startsWith('unsupported_type:') ? say('workspace.simone.images.unsupported').replace('{type}', ()=>reason.slice(17)) : why[reason] ? why[reason]() : reason || say('workspace.simone.images.notAccepted');
        return `${r?.name || say('workspace.simone.images.defaultName')} \u{2014} ${label}`;
    });
    return say('workspace.simone.images.notSent').replace('{list}', ()=>lines.join('; '));
};

});

parcelRegister("i2kG6", function(module, exports) {

$parcel$export(module.exports, "AI_ATTACHED_REF_CAP", () => $d218742091f6f599$export$8a61781514865212);
$parcel$export(module.exports, "readAiAttached", () => $d218742091f6f599$export$dec2bd3b60e4aab);
$parcel$export(module.exports, "attachAiRef", () => $d218742091f6f599$export$3e50a04ca8d0261d);
$parcel$export(module.exports, "detachAiRef", () => $d218742091f6f599$export$4a616a119f2a51d6);
$parcel$export(module.exports, "attachAiCanvas", () => $d218742091f6f599$export$7b01b04ddea5afe2);
$parcel$export(module.exports, "clearAiAttached", () => $d218742091f6f599$export$da88016b81b56196);
// aiAttached — the STRUCTURED attachments the user hands the assistant
// (VaultOS v2 design §4.1).
//
// One root bag, `root.aiAttached = { refs: EntityRef[], canvas: <payload>|null }`,
// declared in state-app.js beside `pickedElements` and wiped on a workspace
// switch for the same disclosure reason (a ref names a tenant row).
//
// WHY ROOT AND NOT THE COMPOSER BAG. The composer's own draft state
// (`draft/files/refs/images`, serialised by buildPromptPayload) survives only
// as TEXT in the prompt body — `sent: 'text-only'`. These attachments are
// different in kind: they ride the wire as `context.attached`, the server
// keeps them after its allowlist + caps, and the orchestrator renders them as
// a fenced ATTACHED CONTEXT block and registers every ref as a retrieval
// candidate. That is `sent: 'structured'`, and it must be reachable from a
// PAGE (`el.call('attachAiRef', ref)`) as well as from the drawer composer, so
// it cannot live on one composer's element state.
//
// THE ATTACHMENTS SURVIVE A TURN. Sending does NOT clear them (unlike
// `pickedElements`, which sendPrompt snapshots onto the message and empties).
// The user attached a data room / a canvas / a contract to talk about it for
// several questions; clearing it under them would make every follow-up
// silently ungrounded. `clearAiAttached` and the per-chip remove are the only
// two ways out, and both are explicit user acts.
//
// Every function here is `this`-bound and reached via el.call — same shape as
// removePickedElement / removePromptAttachment (shared/promptAttachments.js).
// Max refs on one turn. Mirrors the server allowlist cap (spec §4.1, ≤24) so
// the client never renders a chip for something the wire will drop — the
// awareness contract is "the UI cannot claim more than the wire carries".
const $d218742091f6f599$export$8a61781514865212 = 24;
const $d218742091f6f599$export$dec2bd3b60e4aab = (root)=>{
    const bag = root && typeof root.aiAttached === 'object' && root.aiAttached ? root.aiAttached : null;
    return {
        refs: bag && Array.isArray(bag.refs) ? bag.refs : [],
        canvas: bag && bag.canvas && typeof bag.canvas === 'object' ? bag.canvas : null
    };
};
const $d218742091f6f599$export$3e50a04ca8d0261d = function(ref, opts) {
    const el = this;
    const root = el && el.state && el.state.root || el && el.getRoot && el.getRoot()?.state || null;
    if (!root || typeof root.update !== 'function') return false;
    // A drag-ref carries `kind` where an EntityRef carries `type` — accept both
    // at this seam so a drop handler can hand the payload straight through.
    const raw = ref && typeof ref === 'object' && !ref.type && ref.kind ? {
        ...ref,
        type: ref.kind
    } : ref;
    let parsed = null;
    try {
        parsed = el.call('parseEntityRef', raw);
    } catch (_) {
        parsed = null;
    }
    if (!parsed) return false;
    const key = el.call('formatEntityRef', parsed);
    if (!key) return false;
    const bag = root && typeof root.aiAttached === 'object' && root.aiAttached ? root.aiAttached : null;
    const current = bag && Array.isArray(bag.refs) ? bag.refs : [];
    const canvas = bag && bag.canvas && typeof bag.canvas === 'object' ? bag.canvas : null;
    // Re-attach REPLACES in place (keeps chip order stable) instead of appending.
    let replaced = false;
    const next = current.map((r)=>{
        if (replaced) return r;
        let existing = '';
        try {
            existing = el.call('formatEntityRef', r);
        } catch (_) {
            existing = '';
        }
        if (existing !== key) return r;
        replaced = true;
        return parsed;
    });
    if (!replaced) {
        // 24 = AI_ATTACHED_REF_CAP, inlined. FA204 / frank trap: a module-scope
        // const read from inside an exported handler is `undefined` once this file
        // is frank.toJSON'd, and `next.length >= undefined` is always false — the
        // cap would silently stop existing in a published consumer. The exported
        // constant above stays live for callers that need to SHOW the cap.
        if (next.length >= 24) return false;
        next.push(parsed);
    }
    root.update({
        aiAttached: {
            refs: next,
            canvas: canvas
        }
    });
    // ── REVEAL: attaching SHOWS the assistant (2026-09-09, P0) ─────────────
    // "Attach this to the assistant" is a user act whose whole point is that
    // the assistant now has the thing. Writing `root.aiAttached` alone made it
    // a silent no-op from any surface where the drawer was closed: nothing
    // moved, no chip appeared, no error — measured on the deployed staging
    // shell from a module list row. Every other attach site in this repo
    // already pairs the write with the open patch by hand (calendar
    // EventDetailModal, tickets TicketDetailModal, canvas), so the behaviour
    // was never in doubt; only its home was. It belongs HERE, on the shell's
    // own attach API, where no caller can forget it and no caller has to
    // learn the shell's state keys.
    //
    // The patch is the deep-link opener's, verbatim (app.js `aiConversation`):
    // a MINIMIZED dock has to be restored or `assistantOpen` alone shows
    // nothing. `{ reveal: false }` opts out for a programmatic attach that
    // must not steal the screen.
    const reveal = !(opts && opts.reveal === false);
    if (reveal) {
        const patch = {
            assistantOpen: true
        };
        if (root.assistantDock === 'minimized') patch.assistantDock = 'right';
        root.update(patch);
    }
    return true;
};
const $d218742091f6f599$export$4a616a119f2a51d6 = function(ref) {
    const el = this;
    const root = el && el.state && el.state.root || el && el.getRoot && el.getRoot()?.state || null;
    if (!root || typeof root.update !== 'function') return false;
    const raw = ref && typeof ref === 'object' && !ref.type && ref.kind ? {
        ...ref,
        type: ref.kind
    } : ref;
    let key = '';
    try {
        key = el.call('formatEntityRef', raw);
    } catch (_) {
        key = '';
    }
    if (!key) return false;
    const bag = root && typeof root.aiAttached === 'object' && root.aiAttached ? root.aiAttached : null;
    const current = bag && Array.isArray(bag.refs) ? bag.refs : [];
    const canvas = bag && bag.canvas && typeof bag.canvas === 'object' ? bag.canvas : null;
    const next = current.filter((r)=>{
        let existing = '';
        try {
            existing = el.call('formatEntityRef', r);
        } catch (_) {
            existing = '';
        }
        return existing !== key;
    });
    if (next.length === current.length) return false;
    root.update({
        aiAttached: {
            refs: next,
            canvas: canvas
        }
    });
    return true;
};
const $d218742091f6f599$export$7b01b04ddea5afe2 = function(payload, opts) {
    const el = this;
    const root = el && el.state && el.state.root || el && el.getRoot && el.getRoot()?.state || null;
    if (!root || typeof root.update !== 'function') return false;
    const bag = root && typeof root.aiAttached === 'object' && root.aiAttached ? root.aiAttached : null;
    const refs = bag && Array.isArray(bag.refs) ? bag.refs : [];
    const canvas = payload && typeof payload === 'object' ? payload : null;
    root.update({
        aiAttached: {
            refs: refs,
            canvas: canvas
        }
    });
    // Same reveal rule as attachAiRef — see the note there. `null` DETACHES,
    // and taking something back must never open a panel.
    const reveal = !!canvas && !(opts && opts.reveal === false);
    if (reveal) {
        const patch = {
            assistantOpen: true
        };
        if (root.assistantDock === 'minimized') patch.assistantDock = 'right';
        root.update(patch);
    }
    return true;
};
const $d218742091f6f599$export$da88016b81b56196 = function() {
    const el = this;
    const root = el && el.state && el.state.root || el && el.getRoot && el.getRoot()?.state || null;
    if (!root || typeof root.update !== 'function') return false;
    root.update({
        aiAttached: {
            refs: [],
            canvas: null
        }
    });
    return true;
};

});

parcelRegister("9ZTVI", function(module, exports) {

$parcel$export(module.exports, "activeWorkspaceId", () => $7475321690aecf4d$export$d5dc34adaaba13d7);
$parcel$export(module.exports, "hasActiveWorkspace", () => $7475321690aecf4d$export$1bcdbdc5bd168d8);
// Active-workspace-id resolver. Split from the retired Supabase-scoping
// half of this module (2026-07-13, Supabase retirement sweep):
// `scopedFrom` / `insertScoped` / `updateScoped` / `realtimeScoped` /
// `WORKSPACE_SCOPED` / the `USE_MULTITENANT` re-export existed to
// workspace_id-scope Supabase governance-table queries behind a flag that
// was never flipped on for any live call site (grep confirmed zero
// importers of any of them beyond this file) — removed rather than kept
// as dead Supabase-era scaffolding. `activeWorkspaceId` stays — it's
// imported across the shell (loadAddAppExtensions, simone's AI transport,
// session persistence, extension save/share, pages/main.js).
// `hasActiveWorkspace` has no current importer either, but is kept
// (per ticket instruction) as the paired convenience predicate.
// Read the active workspace id. PREFER the drift-corrected in-org workspace
// (`root.workspace`, re-resolved by auth.js when the JWT's active_workspace_id
// points at a workspace in the PREVIOUS org) over the raw JWT claim. The claim
// lags an org switch (it re-mints async), so after switching orgs it still names
// the old org's workspace — and any consumer scoping to it (the AI's
// list_projects, conversation list, scoped reads) leaks the previous org's data.
// Fall back to the claim only during the boot window before root.workspace resolves.
// Callers must pass the root — DOMQL handlers always have `s.root`.
//
// ── WHY BOTH ID SHAPES (WS-ACTIVE-WORKSPACE-ID-SHAPE-1) ────────────────────
// `root.workspace` arrives in one of TWO shapes depending on who populated it:
// the SDK's normalised record, which carries `id`, or the raw workspace
// document, which carries Mongo's `_id` and no `id` alias. This resolver read
// `.id` ONLY — so whenever the raw document was the one on root, the first
// branch was `undefined` and every caller silently fell through to the JWT
// claim. The guard above describes a protection that, in that shape, never
// once ran.
//
// Measured live on gita.pr.symbols.app 2026-08-31: `root.workspace` had keys
// `_id, organization, slug, displayName, …` and NO `id`, so this returned the
// claim `69e54008…` (a workspace in a DIFFERENT org) while the shell was
// rendering GITA's `6a92951a…`. The AI transport scopes `sdk.ai` with this
// value, so every prompt dispatched to — and was BILLED to — the other org's
// workspace, which answered "out of AI credits (needed 49, available 0)"
// while GITA's own balance sat at 9920 untouched. The same wrong id feeds
// `list_projects`, the conversation list and the scoped reads this comment
// already warned would leak the previous org's data.
//
// `moduleAiBridge.js` already resolves both shapes (`id || _id`); this file
// carried only half of that rule. Accepting both is what makes the documented
// precedence — the tab's own workspace beats the session-global claim — real.
// Order matches the house idiom; a root that somehow carries both always
// carries the same id in each.
const $7475321690aecf4d$export$d5dc34adaaba13d7 = (root)=>root && root.workspace && (root.workspace.id || root.workspace._id) || root?.jwtClaims?.active_workspace_id || null;
const $7475321690aecf4d$export$1bcdbdc5bd168d8 = (root)=>!!$7475321690aecf4d$export$d5dc34adaaba13d7(root);

});

parcelRegister("hml1G", function(module, exports) {

$parcel$export(module.exports, "_parseBody", () => $ca34cd19a62150ee$export$d956e6e26ff2b173);
$parcel$export(module.exports, "_docContent", () => $ca34cd19a62150ee$export$8a08b82695754d14);
$parcel$export(module.exports, "_firstImage", () => $ca34cd19a62150ee$export$fa99ccb08d3309c4);
$parcel$export(module.exports, "_joinBodyText", () => $ca34cd19a62150ee$export$99c24ac71e072bc6);
// Body field from the server is stored as either a plain MARKDOWN string
// (the canonical format since the Crepe editor swap, 2026-08-06) or a legacy
// JSON-stringified EditorJS output object ({ time, blocks, version }). The UI
// carries content in whichever of the two shapes the row is in:
//   - markdown → the raw STRING (strings are primitives, inherently
//     signal-store leaves — no freezing needed)
//   - legacy blocks → the parsed object, FROZEN (see _docContent)
// The editor + article view normalize legacy blocks to markdown at the edge
// (components/Editor.js `_toMarkdown`); after the next save the row becomes
// markdown for good.
const $ca34cd19a62150ee$export$d956e6e26ff2b173 = (raw)=>{
    if (!raw) return '';
    if (typeof raw === 'object') return raw;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && Array.isArray(parsed.blocks)) return parsed;
    } catch (_) {}
    // Plain markdown/text — keep the string itself.
    return String(raw);
};
const $ca34cd19a62150ee$export$8a08b82695754d14 = (raw)=>{
    const parsed = $ca34cd19a62150ee$export$d956e6e26ff2b173(raw);
    return typeof parsed === 'object' ? Object.freeze(parsed) : parsed;
};
// Strip markdown syntax down to preview-able plain text. Deliberately light —
// enough for card previews + search, not a parser.
// Block body with an explicit `return`, not an implicit-return chained
// arrow: frank's emission mis-parses a bare multi-line `.replace()` chain
// as the function body (surfaced as `[emitted-parse-error] Assigning to
// rvalue` on `globalScope._stripMarkdown` — the auto-lifted helper).
// Behaviour is identical. tickets/fable.md.
const $ca34cd19a62150ee$var$_stripMarkdown = (md)=>{
    return String(md)// The Crepe serializer escapes anything that could read as syntax —
    // `\-`, `\[`, `\\`, `\.`, `\:` — and every one of them printed on the card
    // as a literal backslash ("Bullet one \- Bullet two … \[Symbols docs\]",
    // live 2026-09-04). Drop the escape, keep the character. FIRST, so an
    // escaped bracket pair then reads as the link it was and collapses to
    // its text below. A preview never needs a literal backslash, so every
    // one that survives (a run of three, one before a space) goes as well.
    .replace(/\\([^a-zA-Z0-9\s])/g, '$1').replace(/\\/g, '').replace(/```[\s\S]*?```/g, ' ')// A table's delimiter row (`| --- | :-: |`, `---|---`) and a thematic
    // break (`---`, `- - -`, `***`) are layout: the card printed them as
    // "Step Owner Status --- --- --- M0 …" (live on dev 2026-10-27). A line
    // of only dashes, pipes, colons and blanks carries no text. Blanks are
    // `[ \t]`, never `\s` (which crosses lines), and no two quantifiers
    // share a run: the first cut ran cubic on blank lines.
    .replace(/^[ \t|:]*-[ \t|:-]*$/gm, '').replace(/^[ \t]*([*_])(?:[ \t]*\1){2,}[ \t]*$/gm, '').replace(/`([^`]*)`/g, '$1').replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/^\s{0,3}(#{1,6}|>+|[-*+]\s|\d+\.\s)\s*/gm, '').replace(/[*_~]{1,3}([^*_~]+)[*_~]{1,3}/g, '$1').replace(/<[^>]+>/g, '')// Table pipes are layout, not text.
    .replace(/\s*\|\s*/g, ' ').replace(/\s+/g, ' ').trim();
};
const $ca34cd19a62150ee$export$fa99ccb08d3309c4 = (content)=>{
    if (typeof content !== 'string') return '';
    // Both destination forms: a bare URL, or an angle-bracketed one (the way
    // a path with a space is written). An optional title after it is ignored.
    const m = /!\[[^\]]*\]\(\s*(?:<([^>]+)>|([^\s)]+))(?:\s+"[^"]*")?\s*\)/.exec(content);
    return m ? m[1] || m[2] : '';
};
const $ca34cd19a62150ee$export$99c24ac71e072bc6 = (content)=>{
    if (typeof content === 'string') return $ca34cd19a62150ee$var$_stripMarkdown(content);
    return (content?.blocks || []).map((b)=>b?.data?.text || '').filter(Boolean).join(' ').replace(/<[^>]+>/g, '')// Legacy EditorJS inline text is HTML-ish — decode the common
    // entities so previews don't show a literal &nbsp;.
    .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/\s+/g, ' ').trim();
};

});

parcelRegister("er1Z5", function(module, exports) {

$parcel$export(module.exports, "warnUnlabelledOnce", () => $a825205aea8f17a3$export$673291533b7e90a4);
$parcel$export(module.exports, "routeLabel", () => $a825205aea8f17a3$export$80ace2b99405d272);
$parcel$export(module.exports, "rowsSummary", () => $a825205aea8f17a3$export$1dbae4390ec1e7fe);
// aiAwarenessLabels.js — the LABEL TABLE behind the AI context chips
// (WS-AI-CONTEXT-CHIPS-SHOW-ENGLISH-PAGE-NAMES-1).
//
// MEASURED (workspace i18n sweep, 2026-09-24): in a Georgian workspace the AI
// panel's chips read "Tasks", "Chat" and "25 of 30 tickets". The route chip took
// the PAGES descriptor's `page` — the English name the MODEL is told — and the
// rows chip rebuilt a sentence from the descriptor's own data keys, `${shown} of
// ${total} ${key}`. Neither is a bundle key, so no entry existed to translate and
// a per-key fix could not work: the names were DATA.
//
// This table is the bridge, and the ONLY place either chip gets its words:
//   PAGE_LABEL_KEYS        a route (the PAGES descriptor's `page`) → a bundle key
//   COLLECTION_LABEL_KEYS  a record collection (an array a descriptor's `data()`
//                          returns) → { one, many, partial } bundle keys
//
// A collection is three whole PHRASES, never a noun plus glue: `many` ("{count}
// tickets"), `one` ("1 ticket") and `partial` ("{count} of {total} tickets" —
// the page holds more rows than the wire carries). A phrase leaves word order and
// noun form to the translator. Georgian keeps the SINGULAR noun after a number
// ("25 დავალება"), which no `+ 's'` can produce — the same convention as
// workspace.aiAware.canvasItems / canvasItemsOne.
//
// The model wire is NOT read from here. `currentPage` stays the English `page`
// name: the model is told one English name in every workspace language.
//
// A PAGES route or a data collection with no row here, or a key missing from
// either bundle, fails __tests__/aiContextChipLabels.test.js.
const $a825205aea8f17a3$export$3240d937fa0a164a = {
    Calendar: 'workspace.aiAware.page.calendar',
    Chat: 'workspace.aiAware.page.chat',
    Files: 'workspace.aiAware.page.files',
    History: 'workspace.aiAware.page.history',
    Meet: 'workspace.aiAware.page.meet',
    Notes: 'workspace.aiAware.page.notes',
    Tasks: 'workspace.aiAware.page.tasks',
    Terminal: 'workspace.aiAware.page.terminal',
    // The POB getting-started pages read their OWN title keys — the words of
    // their h1 and their tab title, one name per page on every surface.
    'Invite your team': 'workspace.gettingStarted.team.title',
    'Import your data': 'workspace.gettingStarted.imports.title',
    // Three built-in pages read keys they already ship: the requests page's own
    // nav name in the Resolutions app (its tab-title key reads "Customer requests
    // / Resolutions", and a chip names the page, not its section; `tickets` is in
    // the shell manifest's i18nNamespaces), the map page's tab title (one map
    // page under the workspace and the project analytics routes), and the share
    // viewer's own name for the item it shows — its tab key bakes in "/ Symbols",
    // a brand a white-label host does not carry.
    'Customer requests': 'tickets.resolutions.nav.customerRequests',
    'Analytics map': 'workspace.page.analyticsMap',
    'Shared item': 'workspace.sharedResource.untitled'
};
const $a825205aea8f17a3$export$fd8617950eed6d0b = {
    // The History app's rows: activity-log events (მოვლენა), not calendar
    // events (ღონისძიება) — their own phrase.
    activity: {
        one: 'workspace.aiAware.rows.activityOne',
        many: 'workspace.aiAware.rows.activity',
        partial: 'workspace.aiAware.rows.activityOfTotal'
    },
    channels: {
        one: 'workspace.aiAware.rows.channelsOne',
        many: 'workspace.aiAware.rows.channels',
        partial: 'workspace.aiAware.rows.channelsOfTotal'
    },
    columns: {
        one: 'workspace.aiAware.rows.columnsOne',
        many: 'workspace.aiAware.rows.columns',
        partial: 'workspace.aiAware.rows.columnsOfTotal'
    },
    documents: {
        one: 'workspace.aiAware.rows.documentsOne',
        many: 'workspace.aiAware.rows.documents',
        partial: 'workspace.aiAware.rows.documentsOfTotal'
    },
    events: {
        one: 'workspace.aiAware.rows.eventsOne',
        many: 'workspace.aiAware.rows.events',
        partial: 'workspace.aiAware.rows.eventsOfTotal'
    },
    files: {
        one: 'workspace.aiAware.rows.filesOne',
        many: 'workspace.aiAware.rows.files',
        partial: 'workspace.aiAware.rows.filesOfTotal'
    },
    notes: {
        one: 'workspace.aiAware.rows.notesOne',
        many: 'workspace.aiAware.rows.notes',
        partial: 'workspace.aiAware.rows.notesOfTotal'
    },
    rooms: {
        one: 'workspace.aiAware.rows.roomsOne',
        many: 'workspace.aiAware.rows.rooms',
        partial: 'workspace.aiAware.rows.roomsOfTotal'
    },
    tickets: {
        one: 'workspace.aiAware.rows.ticketsOne',
        many: 'workspace.aiAware.rows.tickets',
        partial: 'workspace.aiAware.rows.ticketsOfTotal'
    }
};
// A development build, or any *.localhost host. The same RUNTIME rule as the
// module override in workspaceProjects.js: it survives a production bundle,
// where `process.env.NODE_ENV` is inlined and its branch is dead-code stripped,
// and it never fires on a real deployment.
const $a825205aea8f17a3$var$_isDev = ()=>{
    var _;
    return true;
};
// A route or a collection this table does not know still gets a chip — the
// raw name, never a blank — but a missing row is a bug to fix, not a state to
// live with. So in DEV the fallback says so, ONCE per name: the awareness set is
// re-derived on every render, and a line per render would bury the console.
// Returns whether it logged (the test reads it).
const $a825205aea8f17a3$var$_warned = new Set();
const $a825205aea8f17a3$export$673291533b7e90a4 = (kind, name)=>{
    if (!$a825205aea8f17a3$var$_isDev()) return false;
    const id = kind + ':' + name;
    if ($a825205aea8f17a3$var$_warned.has(id)) return false;
    $a825205aea8f17a3$var$_warned.add(id);
    console.warn(`[ai-context] no label for ${kind} "${name}" \u{2014} the chip falls back to its raw name. ` + 'Add a row to functions/aiAwarenessLabels.js and both workspace.aiAware.* bundles.');
    return true;
};
const $a825205aea8f17a3$export$80ace2b99405d272 = (page, say)=>{
    const key = $a825205aea8f17a3$export$3240d937fa0a164a[page];
    if (!key) {
        $a825205aea8f17a3$export$673291533b7e90a4('route', page);
        return page;
    }
    return say(key);
};
// One collection's phrase: "1 ticket", "3 tickets" or "25 of 30 tickets".
// `partial` wins whenever the page holds more rows than the wire carries; else
// `one` for a single row and `many` for the rest.
const $a825205aea8f17a3$var$_collectionPhrase = (collection, shown, total, say)=>{
    const keys = $a825205aea8f17a3$export$fd8617950eed6d0b[collection];
    if (!keys) {
        $a825205aea8f17a3$export$673291533b7e90a4('collection', collection);
        return `${shown} ${collection}`;
    }
    const key = total > shown ? keys.partial : shown === 1 ? keys.one : keys.many;
    return say(key).replace('{count}', String(shown)).replace('{total}', String(total));
};
const $a825205aea8f17a3$export$1dbae4390ec1e7fe = (data, root, say, rootKeys = {})=>{
    const parts = [];
    let truncated = false;
    for (const k of Object.keys(data)){
        const v = data[k];
        if (!Array.isArray(v)) continue;
        const source = root[rootKeys[k] || k];
        const total = Array.isArray(source) ? source.length : v.length;
        if (total > v.length) truncated = true;
        if (v.length) parts.push($a825205aea8f17a3$var$_collectionPhrase(k, v.length, total, say));
    }
    return {
        title: parts.join(', '),
        truncated: truncated
    };
};

});

parcelRegister("7nvlv", function(module, exports) {

$parcel$export(module.exports, "historyDayKey", () => $55f2ff0773eac965$export$cf96f7c6ad8d1825);
$parcel$export(module.exports, "historyWorkingTime", () => $55f2ff0773eac965$export$fe4af2c09c621624);
$parcel$export(module.exports, "historyClock", () => $55f2ff0773eac965$export$26b580a2cb7c6237);
$parcel$export(module.exports, "historyHalfOf", () => $55f2ff0773eac965$export$1db4cf2fede95c88);
$parcel$export(module.exports, "historyWorkday", () => $55f2ff0773eac965$export$25cd341fb88c582b);
$parcel$export(module.exports, "historyHalfBounds", () => $55f2ff0773eac965$export$4c7bd217ce0623e);
$parcel$export(module.exports, "loadHistoryEvents", () => $55f2ff0773eac965$export$770644b8bb3527c5);
$parcel$export(module.exports, "isHistoryPath", () => $55f2ff0773eac965$export$9c07138ba69c78f4);
$parcel$export(module.exports, "historyRows", () => $55f2ff0773eac965$export$f637bff68c57027a);
$parcel$export(module.exports, "historyDays", () => $55f2ff0773eac965$export$fe59e90498b1800);
$parcel$export(module.exports, "historyDensity", () => $55f2ff0773eac965$export$d7c679280e47eb78);
$parcel$export(module.exports, "historyGroupEvents", () => $55f2ff0773eac965$export$64d825da7b77a5f0);
$parcel$export(module.exports, "historyPeople", () => $55f2ff0773eac965$export$9b647f23e14f29da);
$parcel$export(module.exports, "historyTypes", () => $55f2ff0773eac965$export$8383a6069a051b20);
$parcel$export(module.exports, "historySummary", () => $55f2ff0773eac965$export$b9741927c3fecb06);
$parcel$export(module.exports, "historyCountText", () => $55f2ff0773eac965$export$deb22de0ee4b466a);
$parcel$export(module.exports, "historyTypeLabelKey", () => $55f2ff0773eac965$export$28ccdc638492a787);
$parcel$export(module.exports, "historyTypeIcon", () => $55f2ff0773eac965$export$e2a63003d1cd21ec);
$parcel$export(module.exports, "historyEventWords", () => $55f2ff0773eac965$export$5b7582f650d50680);
$parcel$export(module.exports, "historyEventTitle", () => $55f2ff0773eac965$export$da096d71565a3eed);
$parcel$export(module.exports, "historyEventRef", () => $55f2ff0773eac965$export$493e5bdae8579611);
$parcel$export(module.exports, "historyEventHref", () => $55f2ff0773eac965$export$b781d035844d4b55);
$parcel$export(module.exports, "openHistoryEvent", () => $55f2ff0773eac965$export$267e38db68870462);
$parcel$export(module.exports, "historyPersonName", () => $55f2ff0773eac965$export$733825046f2cd106);
$parcel$export(module.exports, "historyPersonAvatar", () => $55f2ff0773eac965$export$6ad0c36728574ca6);
$parcel$export(module.exports, "historyStation", () => $55f2ff0773eac965$export$e38f3d12f8adff50);
$parcel$export(module.exports, "historyTime", () => $55f2ff0773eac965$export$1e25256543dcc9e6);
$parcel$export(module.exports, "historyHalfRange", () => $55f2ff0773eac965$export$7ed80da4e48ed0a4);
$parcel$export(module.exports, "setHistoryPerson", () => $55f2ff0773eac965$export$1f320be29bce7025);
$parcel$export(module.exports, "setHistoryType", () => $55f2ff0773eac965$export$22f851249fa05da5);
$parcel$export(module.exports, "toggleHistoryGroup", () => $55f2ff0773eac965$export$f3600ac8b030a456);
$parcel$export(module.exports, "scrollHistoryStage", () => $55f2ff0773eac965$export$978adc296571c750);
$parcel$export(module.exports, "panHistoryStage", () => $55f2ff0773eac965$export$747f0c11aaee6223);
// History — the built-in workspace app that shows the workspace activity log
// (the same `workspaceProject.auditLog` read /admin/logs makes, scoped to the
// active workspace) as a horizontal timeline: one station per day, newest
// first, and under each station the people who were active that day with
// their events. This file owns the read and every shaping function the
// components in components/HistoryTimeline.js call through `el.call`; the
// components hold no logic of their own.
//
// Every export is a `function` declaration (Rule 8): `el.call` invokes it
// with `this` = the calling element, which is how a function reaches the
// session language (`localizedDate`, `polyglot`), the roster (`findPerson`)
// and the router. A function that takes `root` accepts the root state or any
// state that carries `.root`, so a component may pass `s.root` or `s` alike.

var $1X0Je = parcelRequire("1X0Je");

var $9ZTVI = parcelRequire("9ZTVI");
const $55f2ff0773eac965$var$_historyRootOf = (root)=>root && root.root ? root.root : root;
const $55f2ff0773eac965$var$_call = (host, name, ...args)=>host && typeof host.call === 'function' ? host.call(name, ...args) : undefined;
function $55f2ff0773eac965$export$cf96f7c6ad8d1825(row, clock) {
    if (!row) return '';
    const at = clock ? clock.wall(row.created_at) : null;
    if (at) return at.date;
    return row.occurred_on || (row.created_at ? String(row.created_at).slice(0, 10) : '');
}
function $55f2ff0773eac965$export$fe4af2c09c621624(root) {
    const r = $55f2ff0773eac965$var$_historyRootOf(root);
    const settings = r && r.workspace && r.workspace.settings;
    const raw = settings ? settings.workingTime : null;
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
    const tz = raw.timezone;
    if (typeof tz !== 'string' || !tz) return null;
    try {
        new Intl.DateTimeFormat('en-US', {
            timeZone: tz
        }).format(0);
    } catch (_) {
        return null;
    }
    const minutes = (hhmm, midnight)=>{
        if (midnight && hhmm === '24:00') return 1440;
        const m = typeof hhmm === 'string' ? /^([01]\d|2[0-3]):([0-5]\d)$/.exec(hhmm) : null;
        return m ? Number(m[1]) * 60 + Number(m[2]) : null;
    };
    const start = minutes(raw.start, false);
    const end = minutes(raw.end, true);
    if (start === null || end === null || end <= start) return null;
    const days = Array.isArray(raw.days) ? raw.days : [];
    if (!days.length || days.some((d)=>!Number.isInteger(d) || d < 1 || d > 7)) return null;
    const holidays = Array.isArray(raw.holidays) ? raw.holidays.filter((h)=>typeof h === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(h)) : [];
    return {
        timezone: tz,
        days: [
            ...new Set(days)
        ].sort((a, b)=>a - b),
        start: raw.start,
        end: raw.end,
        holidays: [
            ...new Set(holidays)
        ].sort()
    };
}
function $55f2ff0773eac965$export$26b580a2cb7c6237(root) {
    const cal = $55f2ff0773eac965$export$fe4af2c09c621624(root);
    const minutes = (hhmm)=>hhmm === '24:00' ? 1440 : Number(hhmm.slice(0, 2)) * 60 + Number(hhmm.slice(3, 5));
    const start = cal ? minutes(cal.start) : 0;
    const end = cal ? minutes(cal.end) : 1440;
    const timeZone = cal ? cal.timezone : undefined;
    let fmt = null;
    const wall = (ts)=>{
        const t = ts instanceof Date ? ts.getTime() : ts ? new Date(ts).getTime() : NaN;
        if (!Number.isFinite(t)) return null;
        if (!fmt) fmt = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            hourCycle: 'h23',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
        const p = {};
        for (const part of fmt.formatToParts(new Date(t)))p[part.type] = part.value;
        return {
            date: `${p.year}-${p.month}-${p.day}`,
            minutes: Number(p.hour) % 24 * 60 + Number(p.minute)
        };
    };
    return {
        calendar: !!cal,
        timeZone: timeZone,
        start: start,
        end: end,
        split: Math.floor((start + end) / 2),
        days: cal ? cal.days : [
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ],
        holidays: cal ? cal.holidays : [],
        wall: wall
    };
}
function $55f2ff0773eac965$export$1db4cf2fede95c88(row, clock) {
    const c = clock || $55f2ff0773eac965$export$26b580a2cb7c6237(null);
    const at = row ? c.wall(row.created_at) : null;
    return at && at.minutes >= c.split ? 'second' : 'first';
}
function $55f2ff0773eac965$export$25cd341fb88c582b(dayKey, clock) {
    const c = clock || $55f2ff0773eac965$export$26b580a2cb7c6237(null);
    if (!c.calendar) return true;
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dayKey || '');
    if (!m) return true;
    const dow = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]))).getUTCDay();
    return c.days.includes(dow === 0 ? 7 : dow) && !c.holidays.includes(dayKey);
}
function $55f2ff0773eac965$export$4c7bd217ce0623e(clock, half) {
    const c = clock || $55f2ff0773eac965$export$26b580a2cb7c6237(null);
    return half === 'second' ? {
        from: c.split,
        to: c.end
    } : {
        from: c.start,
        to: c.split
    };
}
async function $55f2ff0773eac965$export$770644b8bb3527c5(root, via) {
    const r = $55f2ff0773eac965$var$_historyRootOf(root);
    if (!r) return;
    const seam = via && typeof via === 'object' ? via : {};
    const idNow = ()=>String((0, $9ZTVI.activeWorkspaceId)(r) || '');
    (0, $1X0Je.default).functions.onWorkspaceIdentityCorrected($55f2ff0773eac965$export$770644b8bb3527c5);
    const wsId = idNow();
    if (!wsId) {
        (0, $1X0Je.default).functions.onActiveWorkspaceFull($55f2ff0773eac965$export$770644b8bb3527c5);
        return;
    }
    const write = typeof seam.write === 'function' ? seam.write : (patch)=>r.update(patch);
    const land = (patch)=>{
        if (idNow() === wsId) {
            write(patch);
            return;
        }
        if (idNow() && !r.historyLoaded) $55f2ff0773eac965$export$770644b8bb3527c5(r, seam.sdk ? {
            sdk: seam.sdk
        } : undefined);
    };
    try {
        const sdk = seam.sdk && typeof seam.sdk.execute === 'function' ? seam.sdk : (0, $1X0Je.default).functions.getSDK();
        const result = await sdk.execute('workspaceProject.auditLog', 'list', {
            filter: {},
            options: {
                workspaceId: wsId,
                columns: 'id, user_email, activity_type, score, source_table, source_id, metadata, created_at, occurred_on',
                // PostgREST-style "column.direction" — the one order shape the
                // audit-log worker parses (see pages/admin/logs.js).
                order: 'created_at.desc',
                limit: 400
            }
        });
        const rows = Array.isArray(result) ? result : result && (result.data || result.rows || result.events) || [];
        land({
            historyEvents: rows || [],
            historyLoaded: true,
            historyLoadError: false
        });
    } catch (err) {
        // A failed read is not an empty history: the page says the read failed.
        console.error('[history]', err);
        land({
            historyEvents: [],
            historyLoaded: true,
            historyLoadError: true
        });
    }
}
function $55f2ff0773eac965$export$9c07138ba69c78f4(href) {
    return String(href || '').split('?')[0] === '/history';
}
function $55f2ff0773eac965$export$f637bff68c57027a(root, over) {
    const r = $55f2ff0773eac965$var$_historyRootOf(root);
    const all = Array.isArray(r && r.historyEvents) ? r.historyEvents : [];
    const o = over || {};
    const person = 'person' in o ? o.person : r && r.historyPerson || null;
    const type = 'type' in o ? o.type : r && r.historyType || null;
    return all.filter((row)=>row && (!person || (row.user_email || '') === person) && (!type || row.activity_type === type));
}
function $55f2ff0773eac965$export$fe59e90498b1800(root) {
    const clock = $55f2ff0773eac965$export$26b580a2cb7c6237(root);
    const at = (row)=>new Date(row.created_at).getTime() || 0;
    const days = new Map();
    for (const row of $55f2ff0773eac965$export$f637bff68c57027a(root)){
        const day = $55f2ff0773eac965$export$cf96f7c6ad8d1825(row, clock);
        if (!days.has(day)) days.set(day, {
            first: [],
            second: []
        });
        days.get(day)[$55f2ff0773eac965$export$1db4cf2fede95c88(row, clock)].push(row);
    }
    const groupsOf = (day, rows, half)=>{
        const authors = new Map();
        for (const row of rows){
            const email = row.user_email || '';
            if (!authors.has(email)) authors.set(email, []);
            authors.get(email).push(row);
        }
        return [
            ...authors.entries()
        ].map(([email, events])=>{
            const key = half ? `g-${day}-${half}-${email}` : `g-${day}-${email}`;
            const sorted = events.slice().sort((a, b)=>at(b) - at(a)).map((e, i)=>({
                    ...e,
                    key: `ev-${e.id || `${day}-${email}-${i}`}`,
                    _timeZone: clock.timeZone
                }));
            const group = {
                key: key,
                _groupKey: key,
                _day: day,
                _email: email,
                _count: sorted.length,
                _score: sorted.reduce((sum, e)=>sum + (e.score || 0), 0),
                _latestAt: sorted.length ? at(sorted[0]) : 0,
                _earliestAt: sorted.length ? at(sorted[sorted.length - 1]) : 0,
                _events: sorted
            };
            if (half) group._half = half;
            return group;
        });
    };
    return [
        ...days.entries()
    ].sort(([a], [b])=>b.localeCompare(a)).map(([day, halves])=>{
        const groups = groupsOf(day, [
            ...halves.first,
            ...halves.second
        ], null).sort((a, b)=>b._latestAt - a._latestAt);
        return {
            key: `d-${day}`,
            _day: day,
            _timeZone: clock.timeZone,
            _workday: $55f2ff0773eac965$export$25cd341fb88c582b(day, clock),
            _firstRange: $55f2ff0773eac965$export$4c7bd217ce0623e(clock, 'first'),
            _secondRange: $55f2ff0773eac965$export$4c7bd217ce0623e(clock, 'second'),
            _count: groups.reduce((sum, g)=>sum + g._count, 0),
            _score: groups.reduce((sum, g)=>sum + g._score, 0),
            _people: groups.length,
            _groups: groups,
            _firstHalf: groupsOf(day, halves.first, 'first').sort((a, b)=>b._latestAt - a._latestAt),
            _secondHalf: groupsOf(day, halves.second, 'second').sort((a, b)=>a._earliestAt - b._earliestAt)
        };
    }).map($55f2ff0773eac965$export$d7c679280e47eb78);
}
function $55f2ff0773eac965$export$d7c679280e47eb78(day, i, days) {
    const max = Math.max(1, ...days.map((d)=>d._count || 0));
    const v = (d)=>d ? (d._count || 0) / max : 0;
    const mid = v(day);
    const left = i > 0 ? (v(days[i - 1]) + mid) / 2 : mid;
    const right = i < days.length - 1 ? (mid + v(days[i + 1])) / 2 : mid;
    const y = (x)=>100 - Math.round(x * 90);
    return {
        ...day,
        _densityClip: `polygon(0% ${y(left)}%, 50% ${y(mid)}%, 100% ${y(right)}%, 100% 100%, 0% 100%)`
    };
}
function $55f2ff0773eac965$export$64d825da7b77a5f0(state) {
    const PREVIEW = 3;
    const s = state || {};
    const open = s.root && s.root._historyExpanded ? !!s.root._historyExpanded[s._groupKey] : false;
    const events = Array.isArray(s._events) ? s._events : [];
    return open ? events : events.slice(0, PREVIEW);
}
function $55f2ff0773eac965$export$9b647f23e14f29da(root) {
    const r = $55f2ff0773eac965$var$_historyRootOf(root);
    const all = Array.isArray(r && r.historyEvents) ? r.historyEvents : [];
    const type = r && r.historyType || null;
    const counts = new Map();
    for (const row of all){
        if (!row || type && row.activity_type !== type) continue;
        const email = row.user_email || '';
        counts.set(email, (counts.get(email) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1] || a[0].localeCompare(b[0])).map(([email, count])=>({
            key: `p-${email}`,
            _email: email,
            _count: count
        }));
}
function $55f2ff0773eac965$export$8383a6069a051b20(root) {
    const r = $55f2ff0773eac965$var$_historyRootOf(root);
    const all = Array.isArray(r && r.historyEvents) ? r.historyEvents : [];
    const person = r && r.historyPerson || null;
    const counts = new Map();
    for (const row of all){
        if (!row || person && (row.user_email || '') !== person) continue;
        const type = row.activity_type || '';
        counts.set(type, (counts.get(type) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort((a, b)=>b[1] - a[1] || a[0].localeCompare(b[0])).map(([type, count])=>({
            key: `t-${type}`,
            _type: type,
            _count: count
        }));
}
function $55f2ff0773eac965$export$b9741927c3fecb06(root) {
    const clock = $55f2ff0773eac965$export$26b580a2cb7c6237(root);
    const rows = $55f2ff0773eac965$export$f637bff68c57027a(root);
    const people = new Set();
    const days = new Set();
    for (const row of rows){
        people.add(row.user_email || '');
        days.add($55f2ff0773eac965$export$cf96f7c6ad8d1825(row, clock));
    }
    return {
        events: rows.length,
        people: people.size,
        days: days.size
    };
}
function $55f2ff0773eac965$export$deb22de0ee4b466a(key, keyOne, count) {
    const n = Number(count) || 0;
    const k = n === 1 ? keyOne : key;
    const text = $55f2ff0773eac965$var$_call(this, 'polyglot', k);
    return String(typeof text === 'string' && text ? text : k).replace('{count}', String(n));
}
function $55f2ff0773eac965$export$28ccdc638492a787(type) {
    const KEYS = {
        standup: 'workspace.history.type.standup',
        ticket_update: 'workspace.history.type.ticketUpdate',
        note_edit: 'workspace.history.type.noteEdit',
        kb_edit: 'workspace.history.type.kbEdit',
        meet_call: 'workspace.history.type.meetCall'
    };
    return KEYS[type] || type || '';
}
function $55f2ff0773eac965$export$e2a63003d1cd21ec(type) {
    const ICONS = {
        standup: 'discussion',
        ticket_update: 'check',
        note_edit: 'document',
        kb_edit: 'library',
        meet_call: 'video'
    };
    return ICONS[type] || 'sfHistory';
}
function $55f2ff0773eac965$export$5b7582f650d50680(row) {
    const md = row && row.metadata || {};
    return md.title || md.summary || md.body || md.summary_preview || '';
}
function $55f2ff0773eac965$export$da096d71565a3eed(row) {
    return $55f2ff0773eac965$export$5b7582f650d50680(row) || row && row.source_table || '';
}
function $55f2ff0773eac965$export$493e5bdae8579611(row) {
    const md = row && row.metadata || {};
    if (md.ticket_number) return `#${md.ticket_number}`;
    if (row && row.source_id) return String(row.source_id).slice(0, 8);
    return '';
}
function $55f2ff0773eac965$export$b781d035844d4b55(row) {
    if (!row) return null;
    const md = row.metadata || {};
    switch(row.activity_type){
        case 'ticket_update':
            return md.ticket_number ? `/tasks/my?ticket=${md.ticket_number}` : '/tasks/my';
        case 'standup':
            return '/tasks/standups';
        case 'note_edit':
            return row.source_id ? `/notes?id=${row.source_id}` : '/notes';
        case 'kb_edit':
            return row.source_id ? `/notes/knowledge-base?id=${row.source_id}` : '/notes/knowledge-base';
        case 'meet_call':
            return row.source_id ? `/meet?room=${row.source_id}` : '/meet';
        default:
            return null;
    }
}
function $55f2ff0773eac965$export$267e38db68870462(row) {
    const el = this;
    if (!el || !row) return;
    const root = el.state && el.state.root;
    if (row.activity_type === 'ticket_update' && root) {
        const md = row.metadata || {};
        const ticket = (root.myTickets || []).find((t)=>t.id === row.source_id || md.ticket_number && (t.number === md.ticket_number || t.id === md.ticket_number));
        if (ticket) {
            root.update({
                selectedTicket: {
                    ...ticket
                }
            });
            return;
        }
    }
    const href = $55f2ff0773eac965$export$b781d035844d4b55(row);
    if (!href) return;
    let host = el;
    while(host && !host.routes)host = host.parent;
    if (host) el.router(href, host);
}
function $55f2ff0773eac965$export$733825046f2cd106(email) {
    const me = $55f2ff0773eac965$var$_call(this, 'findPerson', email);
    return me && me.name || email || '';
}
function $55f2ff0773eac965$export$6ad0c36728574ca6(email) {
    const me = $55f2ff0773eac965$var$_call(this, 'findPerson', email);
    const src = me && me.avatar || $55f2ff0773eac965$var$_call(this, 'avatarUrl', me && me.name || email || '?') || '';
    return src ? `url(${src}) center/cover` : 'transparent';
}
function $55f2ff0773eac965$export$e38f3d12f8adff50(dayKey, timeZone) {
    // Noon: a date-only key parsed at midnight can slip a day across a time zone.
    const d = new Date(`${dayKey}T12:00:00`);
    if (!dayKey || Number.isNaN(d.getTime())) return {
        day: '',
        month: '',
        year: '',
        weekday: '',
        relative: ''
    };
    const word = (key)=>{
        const text = $55f2ff0773eac965$var$_call(this, 'polyglot', key);
        return typeof text === 'string' && text && text !== key ? text : '';
    };
    const fmt = (opts)=>{
        const out = $55f2ff0773eac965$var$_call(this, 'localizedDate', d, opts);
        return typeof out === 'string' && out ? out : d.toLocaleDateString(undefined, opts);
    };
    // Today's and yesterday's dates on the day's clock ('YYYY-MM-DD'); an
    // unreadable zone falls back to the browser's clock.
    let zoned = null;
    if (timeZone) try {
        const p = {};
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).formatToParts(new Date());
        for (const part of parts)p[part.type] = part.value;
        const prev = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day) - 1));
        zoned = {
            today: `${p.year}-${p.month}-${p.day}`,
            yesterday: prev.toISOString().slice(0, 10)
        };
    } catch (_) {
        zoned = null;
    }
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    const isToday = zoned ? dayKey === zoned.today : d.toDateString() === today.toDateString();
    const isYesterday = zoned ? dayKey === zoned.yesterday : d.toDateString() === yesterday.toDateString();
    const relative = isToday ? word('common.time.today') : isYesterday ? word('common.time.yesterday') : '';
    return {
        day: String(d.getDate()),
        month: fmt({
            month: 'short'
        }),
        year: d.getFullYear() === today.getFullYear() ? '' : String(d.getFullYear()),
        weekday: fmt({
            weekday: 'short'
        }),
        relative: relative
    };
}
function $55f2ff0773eac965$export$1e25256543dcc9e6(ts, timeZone) {
    if (!ts) return '';
    const d = new Date(ts);
    if (Number.isNaN(d.getTime())) return '';
    const bare = {
        hour: 'numeric',
        minute: '2-digit'
    };
    const zoned = timeZone ? {
        ...bare,
        timeZone: timeZone
    } : bare;
    const read = (opts)=>{
        const out = $55f2ff0773eac965$var$_call(this, 'localizedDate', d, opts);
        return typeof out === 'string' && out ? out : d.toLocaleTimeString(undefined, opts);
    };
    try {
        return read(zoned);
    } catch (_) {
        return read(bare);
    }
}
function $55f2ff0773eac965$export$7ed80da4e48ed0a4(range) {
    if (!range || !Number.isFinite(range.from) || !Number.isFinite(range.to)) return '';
    const opts = {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: 'UTC'
    };
    const clock = (min)=>{
        const d = new Date(Date.UTC(2000, 0, 1, Math.floor(min / 60), min % 60));
        const out = $55f2ff0773eac965$var$_call(this, 'localizedDate', d, opts);
        return typeof out === 'string' && out ? out : d.toLocaleTimeString(undefined, opts);
    };
    return `${clock(range.from)}\u{2013}${clock(range.to)}`;
}
function $55f2ff0773eac965$export$1f320be29bce7025(email) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const next = email && root.historyPerson !== email ? email : null;
    root.update({
        historyPerson: next
    });
}
function $55f2ff0773eac965$export$22f851249fa05da5(type) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const next = type && root.historyType !== type ? type : null;
    root.update({
        historyType: next
    });
}
function $55f2ff0773eac965$export$f3600ac8b030a456(groupKey) {
    const root = this && this.state && this.state.root;
    if (!root || !groupKey) return;
    const open = {
        ...root._historyExpanded || {}
    };
    if (open[groupKey]) delete open[groupKey];
    else open[groupKey] = true;
    root.update({
        _historyExpanded: open
    });
}
function $55f2ff0773eac965$export$978adc296571c750(direction) {
    const el = this;
    if (!el) return;
    let stage = el.key === 'HistoryStage' ? el : null;
    if (!stage && typeof el.lookup === 'function') {
        const main = el.lookup('AppMain');
        stage = main && typeof main.lookdown === 'function' ? main.lookdown('HistoryStage') : null;
    }
    const node = stage && stage.node;
    if (!node || typeof node.scrollBy !== 'function') return;
    const first = node.firstElementChild;
    const column = first ? first.getBoundingClientRect().width : 0;
    const step = column || node.clientWidth * 0.8;
    node.scrollBy({
        left: (direction < 0 ? -1 : 1) * step,
        behavior: 'smooth'
    });
}
function $55f2ff0773eac965$export$747f0c11aaee6223(event) {
    const node = this && this.node;
    if (!node || !event) return;
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
    let t = event.target;
    while(t && t !== node){
        if (t.dataset && t.dataset.historyScroll && t.scrollHeight > t.clientHeight + 1) return;
        t = t.parentElement;
    }
    if (node.scrollHeight > node.clientHeight + 1) return;
    if (node.scrollWidth <= node.clientWidth + 1) return;
    node.scrollLeft += event.deltaY;
}

});



parcelRegister("bnEwy", function(module, exports) {

$parcel$export(module.exports, "appSettingsFetch", () => $849146e816646108$export$3970e432c1515f85);
$parcel$export(module.exports, "peopleFetch", () => $849146e816646108$export$4e12284f8c6638cd);
$parcel$export(module.exports, "appPageBoilerplateFetch", () => $849146e816646108$export$8bf8c59a80c21236);

var $aGIjc = parcelRequire("aGIjc");

var $1X0Je = parcelRequire("1X0Je");
const $849146e816646108$var$safeMap = (...args)=>(0, $1X0Je.default).functions.safeMap(...args);
const $849146e816646108$export$3970e432c1515f85 = {
    method: 'select',
    from: 'auth.session',
    as: '~/_settings',
    transform: (session)=>{
        const u = session && session.user || {};
        const email = u.email || '';
        return {
            // Trigger the fetch plugin's smart-spread (sees `_settings` in the
            // returned object) so the rest of these keys land on `root.*` directly.
            _settings: {
                currentUserEmail: email,
                companyName: 'Symbols'
            },
            currentUserEmail: email,
            currentUserId: String(u._id || u.id || ''),
            currentUserUsername: u.username || '',
            currentUserSupabaseId: u.supabaseUserId || '',
            companyName: 'Symbols'
        };
    }
};
const $849146e816646108$export$4e12284f8c6638cd = {
    // `method: 'select'` routes through the SDK adapter's `select` handler,
    // which internally calls sdk.execute(from, 'list', …). This is the correct
    // path — `method: 'list'` is not in ADAPTER_METHODS (['select', 'rpc',
    // 'insert', 'update', 'delete', 'subscribe']), so declaring it there caused
    // adapter.list to be undefined and the fetch to silently return {data:null},
    // leaving root.people unpopulated and the invitee autocomplete empty (#2255).
    method: 'select',
    // Migrated from workspaceProject.people (the legacy people
    // view) to users.members (main-server route /core/users/people —
    // canonical Mongo User identity joined with workspace-extension
    // user_profiles). Row shape is identical.
    from: 'users.members',
    // Scope by PAYLOAD, not by the ambient claim: an explicit workspaceId
    // makes the server resolve THAT workspace's org (membership-verified,
    // same contract listOrgMembers.js uses), so a request issued mid-switch
    // returns the roster of the workspace the tab is viewing — not whatever
    // claim happens to be active when it lands. The workspaceId also lands
    // in the fetch-plugin cache key, so cached pages are tenant-scoped too.
    // No workspace resolved yet (boot) → {} keeps the legacy claim-scoped
    // read (EntityDispatcher maps an empty arg to [undefined]).
    params: (el, s)=>{
        const root = s?.root || s;
        const workspaceId = root?.workspace?.id || root?.activeWorkspaceId || root?.jwtClaims?.active_workspace_id;
        return workspaceId ? {
            workspaceId: workspaceId
        } : {};
    },
    order: 'name',
    as: '~/people',
    // WORKSPACE-TICKETS-STATUS-MAP-NONARRAY: Array.isArray guard via safeMap —
    // `rows || []` lets a truthy non-array envelope pass through to .map().
    transform: (rows)=>({
            people: $849146e816646108$var$safeMap(rows, (0, $aGIjc.rowToPerson))
        })
};
const $849146e816646108$export$8bf8c59a80c21236 = [
    $849146e816646108$export$3970e432c1515f85,
    $849146e816646108$export$4e12284f8c6638cd
];

});

parcelRegister("5Vf2y", function(module, exports) {

$parcel$export(module.exports, "isWorkspaceSkin", () => $44fdf14ec6cbe8d2$export$c30aeb18d94c00b4);
$parcel$export(module.exports, "resolveWorkspaceSkin", () => $44fdf14ec6cbe8d2$export$38b2250f95240040);
$parcel$export(module.exports, "hasStageOverride", () => $44fdf14ec6cbe8d2$export$b6e74909693e178b);
$parcel$export(module.exports, "expectedAppearanceOf", () => $44fdf14ec6cbe8d2$export$af5718a7e9a8c63);
// workspaceSkin.js — THE skin rule of the shell (HOME_AMBIENT_SKIN_SPEC §1,
// DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1).
//
// Two skins on one token set, orthogonal to light/dark:
//   'ambient'  the DEFAULT (the Symbols look) — the sky ground, glass card /
//              pill / composer over it.
//   'solid'    the white-label look — a flat stage, the opaque card wash.
// The design system resolves the few tokens that differ at the ROOT
// (`:root[data-skin=…]`); no attribute is today's look (solid). Components
// never branch on the skin.
//
// The choice is the WORKSPACE's (Nika: "skin = workspace setting only"):
// `settings.appearance.skin`, written by the admin card on
// /admin/workspace-settings. Absent a choice the DEFAULT RULE answers: a
// white-label host, or a workspace that paints its own ground (`--stage-bg`
// or `--color-stage`), stays solid until its stage is measured; everyone else
// is ambient.
//
// ONE rule, two readers — the <html data-skin> stamp in app.js and the admin
// card — so the card can never show one skin while the shell paints another.
// Pure: the caller hands in what it holds (the workspaceSettings() answer and
// the host class), so this file imports nothing.
//
// THE SERVER RESOLVES IT TOO (core 9193ff2c, CORE-WORKSPACE-SETTINGS-
// APPEARANCE-SKIN-1): every workspace read carries `resolvedAppearance
// { skin, sky, skinSource, skySource }` beside `settings`, computed with the
// VERIFIED custom-domain signal the client can only guess from its hostname.
// The rule below reads it before its own default; the local default is the
// fallback for a record read before that field existed. The stage-override
// forms mirror the server's `hasStageOverride` so the two agree.
// Registered through functions/index.js (el.call('resolveWorkspaceSkin', …)
// works anywhere in the shell), so every export is SELF-CONTAINED: frank
// serializes each one alone (FA204) and a sibling read would revive as a
// ReferenceError. The two small checks are restated where they are used.
const $44fdf14ec6cbe8d2$export$c30aeb18d94c00b4 = (value)=>value === 'ambient' || value === 'solid';
const $44fdf14ec6cbe8d2$export$38b2250f95240040 = (root, opts)=>{
    const r = root || {};
    const o = opts || {};
    const info = o.info || null;
    const ws = r.workspace || null;
    const wsId = ws ? String(ws.id || ws._id || '') || null : null;
    const bag = r.workspaceSettings;
    const bagHeld = !!bag && typeof bag === 'object';
    const bagCurrent = bagHeld && (!bag.workspace_id || String(bag.workspace_id) === wsId);
    const skinValue = (v)=>v === 'ambient' || v === 'solid';
    const pick = (holder)=>holder && holder.appearance && skinValue(holder.appearance.skin) ? holder.appearance.skin : null;
    // the same vars and forms as hasStageOverride below (restated — see the
    // note above)
    const stageOverride = (holder)=>{
        const ds = holder && typeof holder === 'object' ? holder.designSystem : null;
        if (!ds || typeof ds !== 'object') return false;
        const filled = (v)=>typeof v === 'string' && v.trim() !== '';
        return [
            '--stage-bg',
            '--color-stage'
        ].some((name)=>{
            const v = ds.vars && typeof ds.vars === 'object' ? ds.vars[name] : undefined;
            if (filled(v)) return true;
            if (v && typeof v === 'object' && (filled(v.light) || filled(v.dark))) return true;
            return [
                ds.varsLight,
                ds.varsDark
            ].some((half)=>!!half && typeof half === 'object' && filled(half[name]));
        });
    };
    const settings = info && info.settings || null;
    const chosen = bagCurrent && pick(bag) || pick(settings);
    if (chosen) return {
        skin: chosen,
        chosen: chosen
    };
    const resolved = ws && ws.resolvedAppearance;
    const resolvedSkin = resolved && skinValue(resolved.skin) ? resolved.skin : null;
    if (resolvedSkin && resolved.skinSource === 'workspace') return {
        skin: resolvedSkin,
        chosen: resolvedSkin
    };
    // The module's ground (the same forms as ambientBackdrop.js
    // `ambientModuleStage`, restated — see the note above): a string, or a
    // { light, dark } pair, on the module's config chrome first.
    const wp = r.workspaceProject && typeof r.workspaceProject === 'object' ? r.workspaceProject : null;
    if (wp) {
        const cfg = wp.config && typeof wp.config === 'object' ? wp.config : null;
        const chrome = cfg && cfg.chrome !== undefined ? cfg.chrome : wp.chrome;
        const stage = chrome && typeof chrome === 'object' ? chrome.stage : null;
        const filled = (v)=>typeof v === 'string' && v.trim() !== '';
        if (filled(stage) || stage && typeof stage === 'object' && (filled(stage.light) || filled(stage.dark))) return {
            skin: 'solid',
            chosen: null
        };
    } else if (settings && settings.workspaceModule) return {
        skin: null,
        chosen: null
    };
    // The record's own ground outranks the server's DEFAULT answer, for the same
    // reason the module's ground above does: the server answers 'default' only
    // when it saw no pick, no branded host and no ground, so a ground this
    // client reads is a form that server does not read yet (2026-10-30: a
    // server that knew only `--stage-bg` answered 'ambient' for a record that
    // paints `--color-stage`). Every other server answer still wins.
    const recordGround = bagCurrent && stageOverride(bag) || stageOverride(settings);
    if (resolvedSkin && !(recordGround && resolved.skinSource === 'default')) return {
        skin: resolvedSkin,
        chosen: null
    };
    if (info && info.pending) return {
        skin: null,
        chosen: null
    };
    if (o.brandedHost || r.whitelabelBrand) return {
        skin: 'solid',
        chosen: null
    };
    if (recordGround) return {
        skin: 'solid',
        chosen: null
    };
    return {
        skin: 'ambient',
        chosen: null
    };
};
const $44fdf14ec6cbe8d2$export$b6e74909693e178b = (holder)=>{
    const ds = holder && typeof holder === 'object' ? holder.designSystem : null;
    if (!ds || typeof ds !== 'object') return false;
    const filled = (v)=>typeof v === 'string' && v.trim() !== '';
    return [
        '--stage-bg',
        '--color-stage'
    ].some((name)=>{
        const v = ds.vars && typeof ds.vars === 'object' ? ds.vars[name] : undefined;
        if (filled(v)) return true;
        if (v && typeof v === 'object' && (filled(v.light) || filled(v.dark))) return true;
        return [
            ds.varsLight,
            ds.varsDark
        ].some((half)=>!!half && typeof half === 'object' && filled(half[name]));
    });
};
const $44fdf14ec6cbe8d2$export$af5718a7e9a8c63 = (settings)=>{
    const stored = settings && settings.appearance && typeof settings.appearance === 'object' ? settings.appearance : {};
    return {
        skin: stored.skin === undefined ? null : stored.skin,
        sky: stored.sky === undefined ? null : stored.sky
    };
};

});

parcelRegister("iNbdw", function(module, exports) {

$parcel$export(module.exports, "wsIdOf", () => $dae581155f9744c5$export$2f030010e0ef3300);
$parcel$export(module.exports, "sameWorkspaceWriter", () => $dae581155f9744c5$export$a8d9ac2d63d85b3b);
// WS-SWITCH-INCOMPLETE-1 — the canonical "drop a reply that outlived its
// tenant" writer.
//
// THE CLASS IT CLOSES. Registering a key as workspace-scoped (state-app.js)
// wipes it ON the switch. It cannot stop a request ISSUED in workspace A from
// writing its reply into workspace B after the switch has already run — and
// that is the harder half, because the result looks freshly fetched and the
// wipe has already happened, so nothing corrects it again. Every write that
// lands after an `await` on a workspace-scoped key needs this.
//
// DROPPING is right rather than rerouting or retrying: the payload describes a
// workspace the user is no longer looking at, and PHASE-1 of the switch has
// already restored the correct empty for the one they are. A refetch for the
// new workspace, where one is owed, is the switch tail's job (loadPrivateData
// PHASE-2), not this writer's.
//
// ⛔ CAPTURE BEFORE THE AWAIT. `sameWorkspaceWriter(root)` must be called on
// the SAME tick as the request, before the first `await` — it snapshots the
// workspace id at call time. Calling it inside the `.then()` snapshots the NEW
// workspace and the guard can never fire.
//
// Shipped first as a copy inside pages/admin/teams.js (workspace 27d4abdf2),
// copied a second time into tickets/components/TicketDetailModal.js
// (workspace ca5dcd758) whose note asked for exactly this extraction on the
// third use. The tickets copy stays where it is on purpose: the tickets
// package is a sub-app and must not import the shell — see
// __tests__/navSearchTenantScope.test.js's drift pin, which fails if the two
// implementations ever drift.
// Both id shapes are live on root: `workspace.id` from the SDK's workspace
// payload and `workspace._id` from the raw Mongo document. Stringified so a
// numeric id and its string form never read as two different tenants.
const $dae581155f9744c5$export$2f030010e0ef3300 = (root)=>String(root?.workspace?.id || root?.workspace?._id || '');
const $dae581155f9744c5$export$a8d9ac2d63d85b3b = (root)=>{
    // Keep the registered function self-contained when Frank revives its source.
    const idOf = (state)=>String(state?.workspace?.id || state?.workspace?._id || '');
    const issuedFor = idOf(root);
    return (patch)=>{
        if (idOf(root) !== issuedFor) return false;
        root.update(patch);
        return true;
    };
};

});

parcelRegister("gOQVi", function(module, exports) {

$parcel$export(module.exports, "USE_FINANCIALS_PROJECT", () => $c3ea5e4c9e84b9e8$export$1a681483c8a4e7b5);
$parcel$export(module.exports, "USE_MULTITENANT", () => $c3ea5e4c9e84b9e8$export$7f155ea6d757f29);
$parcel$export(module.exports, "DUAL_WRITE_FINANCIALS", () => $c3ea5e4c9e84b9e8$export$2ff542b96ee4bece);
$parcel$export(module.exports, "USE_PROFILES_OVERLAY", () => $c3ea5e4c9e84b9e8$export$f9c40da90d757778);
$parcel$export(module.exports, "USE_ONBOARDING_GATE", () => $c3ea5e4c9e84b9e8$export$51a4cb17b0ed5f3c);
$parcel$export(module.exports, "shellFeatureEnabled", () => $c3ea5e4c9e84b9e8$export$77af28394f5e69a6);
$parcel$export(module.exports, "hydrateFeatureFlags", () => $c3ea5e4c9e84b9e8$export$d02bf75b6714f4d1);
$parcel$export(module.exports, "setFeatureFlag", () => $c3ea5e4c9e84b9e8$export$4672beabf7ff6568);
$parcel$export(module.exports, "setAppAccessEnforced", () => $c3ea5e4c9e84b9e8$export$20e674e8a0af41ea);
$parcel$export(module.exports, "featureFlagGroupsWithFlags", () => $c3ea5e4c9e84b9e8$export$31a8490b2f0c11de);
// Single source of truth for intranet feature flags. Every flag lives
// here so flipping one at cutover time is a one-line edit with a
// visible blast radius. Importing call-sites stay flag-agnostic — they
// read the constant and branch.
//
// Flip order when the server is ready (details in
// NEEDED_FOR_INTRANET_CLIENT.md):
//
//   1. USE_FINANCIALS_PROJECT   — reads grants from financials project
//   2. USE_MULTITENANT          — scopedClient filters by workspace_id
//   3. DUAL_WRITE_FINANCIALS    — grantsWriter mirrors writes to financials
// Governance reads grants + company_settings from the financials
// Supabase project via finance-features/grants instead of direct
// governance tables. Requires server to emit `orgs[]` in JWT claims
// so financials RLS admin policies pass.

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");
const $c3ea5e4c9e84b9e8$export$1a681483c8a4e7b5 = true;
const $c3ea5e4c9e84b9e8$export$7f155ea6d757f29 = true;
const $c3ea5e4c9e84b9e8$export$2ff542b96ee4bece = true;
const $c3ea5e4c9e84b9e8$export$f9c40da90d757778 = true;
const $c3ea5e4c9e84b9e8$export$51a4cb17b0ed5f3c = true;
const $c3ea5e4c9e84b9e8$var$featureFlagDef = (...args)=>(0, $1X0Je.default).functions.featureFlagDef(...args);
const $c3ea5e4c9e84b9e8$var$featureFlagOverrides = (...args)=>(0, $1X0Je.default).functions.featureFlagOverrides(...args);
const $c3ea5e4c9e84b9e8$var$loadFeatureFlagOverrides = (...args)=>(0, $1X0Je.default).functions.loadFeatureFlagOverrides(...args);
const $c3ea5e4c9e84b9e8$var$cacheFeatureFlagOverrides = (...args)=>(0, $1X0Je.default).functions.cacheFeatureFlagOverrides(...args);
const $c3ea5e4c9e84b9e8$export$77af28394f5e69a6 = (...args)=>(0, $1X0Je.default).functions.featureEnabled(...args);
const $c3ea5e4c9e84b9e8$export$d02bf75b6714f4d1 = (root)=>{
    if (!root || root._featureFlags) return;
    root.update?.({
        _featureFlags: $c3ea5e4c9e84b9e8$var$loadFeatureFlagOverrides()
    });
};
const $c3ea5e4c9e84b9e8$export$4672beabf7ff6568 = (root, key, value, el)=>{
    const def = $c3ea5e4c9e84b9e8$var$featureFlagDef(key);
    if (!def || def.core || !root) return;
    const next = {
        ...$c3ea5e4c9e84b9e8$var$featureFlagOverrides(root)
    };
    const defaultOn = def.defaultOn !== false;
    if (value === defaultOn) delete next[key];
    else next[key] = value;
    $c3ea5e4c9e84b9e8$var$cacheFeatureFlagOverrides(next);
    const ws = root.workspace;
    const patch = {
        _featureFlags: next
    };
    // WRITE-BASE site (spec §5) — `ws.settings` is read only to rebuild the bag.
    // Merged over a missing base it stamps a `featureFlags`-only settings object
    // onto a LIST-shaped record, which then reads as a full one to anything that
    // (wrongly) infers readiness from settings presence.
    //
    // Only this optimistic mirror is skipped. `next` is computed from
    // featureFlagOverrides(root) — which already falls back to the localStorage
    // cache — and the PATCH below is a per-key merge-safe $set of `featureFlags`
    // alone, so both the local cache write above and the server persist stay
    // correct with no workspace record at all. Dropping them would lose the flip.
    const base = (0, $7iFOV.workspaceSettingsForWrite)(root);
    if (ws && base) patch.workspace = {
        ...ws,
        settings: {
            ...base,
            featureFlags: next
        }
    };
    root.update?.(patch);
    const wsId = ws && (ws._id || ws.id);
    const sdk = el && (el.sdk || el.context?.methods?.sdk);
    if (wsId && sdk && typeof sdk.updateWorkspaceSettings === 'function') sdk.updateWorkspaceSettings(wsId, {
        featureFlags: next
    }).catch((err)=>console.warn('[featureFlags] workspace persist failed:', err?.message || err));
};
const $c3ea5e4c9e84b9e8$export$20e674e8a0af41ea = (root, enforced, el)=>{
    if (!root) return;
    const ws = root.workspace;
    const next = {
        enforced: !!enforced
    };
    // WRITE-BASE site (spec §5), same reasoning as setFeatureFlag above: skip the
    // optimistic mirror rather than fabricate a bag, keep the merge-safe per-key
    // persist. `next` is self-contained (`{ enforced }` is derived from the
    // argument, not from the existing bag), so nothing about the server write
    // depends on having read the record — only the local paint does.
    const base = (0, $7iFOV.workspaceSettingsForWrite)(root);
    if (ws && base) root.update?.({
        workspace: {
            ...ws,
            settings: {
                ...base,
                appAccessControl: next
            }
        }
    });
    const wsId = ws && (ws._id || ws.id);
    const sdk = el && (el.sdk || el.context?.methods?.sdk);
    if (wsId && sdk && typeof sdk.updateWorkspaceSettings === 'function') sdk.updateWorkspaceSettings(wsId, {
        appAccessControl: next
    }).catch((err)=>console.warn('[appAccess] workspace persist failed:', err?.message || err));
};
const $c3ea5e4c9e84b9e8$export$31a8490b2f0c11de = ()=>{
    const groups = (0, $1X0Je.default).functions && (0, $1X0Je.default).functions.FEATURE_FLAG_GROUPS || [];
    const flags = (0, $1X0Je.default).functions && (0, $1X0Je.default).functions.FEATURE_FLAGS || [];
    return groups.map((group)=>({
            ...group,
            flags: flags.filter((f)=>f.group === group.key)
        }));
};

});

parcelRegister("87igY", function(module, exports) {

$parcel$export(module.exports, "EXT_BASE_PATH", () => $5e8d26c8795be0c3$export$fbf22af76c305dc8);
$parcel$export(module.exports, "EXT_WORKSPACE_SLUG", () => $5e8d26c8795be0c3$export$d3b1f4c76c2714f1);
$parcel$export(module.exports, "parseRemotePath", () => $5e8d26c8795be0c3$export$d8adf6eaef493085);
$parcel$export(module.exports, "makeRemoteUrl", () => $5e8d26c8795be0c3$export$e7633ae2e03675e0);
$parcel$export(module.exports, "schemaForRemoteTable", () => $5e8d26c8795be0c3$export$ad5eedbb2fb6efc5);
$parcel$export(module.exports, "saveRemoteRow", () => $5e8d26c8795be0c3$export$f92b3efc98187173);
$parcel$export(module.exports, "extLoadRows", () => $5e8d26c8795be0c3$export$40551bec6000ed8d);
$parcel$export(module.exports, "deleteRemoteRow", () => $5e8d26c8795be0c3$export$4d43055218cdf21e);
$parcel$export(module.exports, "extEnsureStateSeed", () => $5e8d26c8795be0c3$export$9c81acb7f526f652);
$parcel$export(module.exports, "extHasDataCapabilities", () => $5e8d26c8795be0c3$export$96db15d843597c3b);
$parcel$export(module.exports, "extLoadSources", () => $5e8d26c8795be0c3$export$384601782857c51a);
$parcel$export(module.exports, "extLoadRowCounts", () => $5e8d26c8795be0c3$export$fabbfe8de5d27ede);
$parcel$export(module.exports, "extSelectSource", () => $5e8d26c8795be0c3$export$81c3943cdcd07298);
$parcel$export(module.exports, "extSyncFromUrl", () => $5e8d26c8795be0c3$export$fcbd4de2e509d2d8);
$parcel$export(module.exports, "extOpenNewRow", () => $5e8d26c8795be0c3$export$c3d8dcd9b754f6e);
$parcel$export(module.exports, "extSelectionEditable", () => $5e8d26c8795be0c3$export$5c74c7af0b888f3);
$parcel$export(module.exports, "extSetRunnerField", () => $5e8d26c8795be0c3$export$7f64d7dc06dd2b09);
$parcel$export(module.exports, "extRunHttpRequest", () => $5e8d26c8795be0c3$export$116dcbc082e3d704);
$parcel$export(module.exports, "extSnippetFor", () => $5e8d26c8795be0c3$export$1236503ddbffdcd0);
$parcel$export(module.exports, "extCopySnippet", () => $5e8d26c8795be0c3$export$903525dec02641f3);
// externalData — the /data/external backend-visualization surface's data layer.
//
// Owns the FIVE functions the prebuilt shared Remote* components call via
// el.call (parseRemotePath / makeRemoteUrl / schemaForRemoteTable /
// saveRemoteRow / deleteRemoteRow — see shared/components/RemoteSchemaList.js,
// RemoteTableCard.js, RemoteRowTable.js, RemoteRowEditor.js) plus the page's
// loaders (sources, schema, rows), the selection/URL sync, the custom_http
// request runner, and the fetch-wiring snippet builders.
//
// Selection model — STATE-DRIVEN, single registered route:
//   root._extPath holds the canonical '/data/external[/<slug>[/<table>]]'
//   string. The records plane rides the reserved pseudo-slug 'workspace'
//   (one "table" per RecordCollection), so every Remote* component works
//   unchanged for both org integrations and workspace records.
//   Only '/data/external' is a registered route, so NAVIGATION carries the
//   selection as query params ('/data/external?src=<slug>&table=<table>') —
//   a path-segment URL would fall through to the '/*' projectRedirect
//   catch-all. parseRemotePath accepts BOTH shapes (path segments + query)
//   for resilience; makeRemoteUrl emits the routable query shape.
//
// Backend routing (saveRemoteRow / deleteRemoteRow / extLoadRows):
//   slug 'workspace'      → sdk.execute('workspaceProject.records', …)
//   slug = integration    → sdk.execute('orgIntegration', 'call', …) via
//                           callCapability — instantdb only (its capability
//                           strings ARE the ops: list/get/create/update/
//                           remove, namespace-allowlisted server-side).
//   Everything else is read-only here (postgres/mongodb/neon/planetscale/
//   firebase declare data capabilities but the dispatcher is not implemented
//   yet — the page renders "query engine coming soon" for those).
//
// SDK-only transport throughout — no raw fetch anywhere.

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $9ZTVI = parcelRequire("9ZTVI");
const $5e8d26c8795be0c3$var$shellListIntegrationKinds = (...args)=>(0, $1X0Je.default).functions.listIntegrationKinds(...args);
const $5e8d26c8795be0c3$var$shellListScopedIntegrations = (...args)=>(0, $1X0Je.default).functions.listScopedIntegrations(...args);
const $5e8d26c8795be0c3$var$shellCallCapability = (...args)=>(0, $1X0Je.default).functions.callCapability(...args);
const $5e8d26c8795be0c3$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $5e8d26c8795be0c3$export$fbf22af76c305dc8 = '/data/external';
const $5e8d26c8795be0c3$export$d3b1f4c76c2714f1 = 'workspace';
const $5e8d26c8795be0c3$var$RECORDS_PAGE_SIZE = 100 // records plane 400s on limit > 100 — never raise
;
const $5e8d26c8795be0c3$var$RECORDS_MAX_ROWS = 2000;
const $5e8d26c8795be0c3$var$INSTANTDB_LIST_LIMIT = 500 // server MAX_LIMIT is 1000
;
// Base columns every records-plane row carries (WorkspaceRecord wire shape:
// { id, collection, name, data, created_at, updated_at } — custom fields live
// in the `data` bag and are flattened onto the browsing row).
const $5e8d26c8795be0c3$var$RECORD_BASE_COLUMNS = [
    {
        name: 'id',
        type: 'string',
        format: 'uuid',
        is_primary_key: true,
        nullable: false
    },
    {
        name: 'name',
        type: 'string',
        nullable: true
    }
];
const $5e8d26c8795be0c3$var$RECORD_TAIL_COLUMNS = [
    {
        name: 'created_at',
        type: 'string',
        format: 'date-time',
        nullable: true
    },
    {
        name: 'updated_at',
        type: 'string',
        format: 'date-time',
        nullable: true
    }
];
const $5e8d26c8795be0c3$var$RECORD_META_KEYS = [
    'id',
    '_id',
    'name',
    'collection',
    'created_at',
    'updated_at',
    '__raw'
];
// ---------- small resolvers ----------
const $5e8d26c8795be0c3$var$_externalRootFrom = (el, maybeRoot)=>{
    if (maybeRoot && typeof maybeRoot.update === 'function') return maybeRoot.root && typeof maybeRoot.root.update === 'function' ? maybeRoot.root : maybeRoot;
    if (el && typeof el.getRootState === 'function') return el.getRootState();
    return null;
};
const $5e8d26c8795be0c3$var$_elFrom = (self)=>self && typeof self.call === 'function' ? self : null;
// A refusal the Remote row editor prints as its toast message
// (RemoteRowEditor passes `res.error` as `message`): through the bound
// element's polyglot, or the shipped English when none is bound — never a
// raw key.
const $5e8d26c8795be0c3$var$_extRefusal = (el, key)=>({
        ok: false,
        error: el ? String(el.call('polyglot', key)) : String((0, $1X0Je.default).functions.i18nStaticEnglish()[key] || key)
    });
const $5e8d26c8795be0c3$var$_orgId = (root)=>root?.jwtClaims?.workspace_org_id || root?.org?.id || root?.org?._id || null;
const $5e8d26c8795be0c3$var$_integrationRows = (root)=>Array.isArray(root?._extIntegrations) ? root._extIntegrations : [];
const $5e8d26c8795be0c3$var$_findIntegration = (root, slug)=>$5e8d26c8795be0c3$var$_integrationRows(root).find((r)=>r && r.slug === slug) || null;
const $5e8d26c8795be0c3$var$_capabilityRef = (root, row)=>({
        orgId: $5e8d26c8795be0c3$var$_orgId(root),
        kind: row.kind,
        slug: row.slug || 'default',
        scopeType: row.scope_type || 'org',
        scopeId: row.scope_id ?? null,
        workspaceId: (0, $9ZTVI.activeWorkspaceId)(root) || undefined
    });
// Translate a callCapability outcome into a human-readable error line (or
// null when the call succeeded). Permission failures surface as inline
// notices — never crashes.
const $5e8d26c8795be0c3$var$_readableCallError = (el, res)=>{
    const t = (k)=>el.call('polyglot', k);
    if (!res) return t('data.external.error.noResponse');
    if (res.error) {
        if (res.status === 401) return t('data.external.error.notSignedIn');
        if (res.status === 403) return t('data.external.error.notAllowed');
        if (res.status === 404) return t('data.external.error.notFound');
        return res.status ? t('data.external.error.httpStatus').replace('{error}', res.error).replace('{status}', res.status) : res.error;
    }
    if (res.ok === false) {
        const detail = typeof res.result === 'string' ? res.result.slice(0, 160) : '';
        const status = res.status || t('data.external.error.unknownStatus');
        return detail ? t('data.external.error.upstreamWithDetail').replace('{status}', status).replace('{detail}', detail) : t('data.external.error.upstream').replace('{status}', status);
    }
    return null;
};
// ---------- canonical path model ----------
const $5e8d26c8795be0c3$var$_canonicalPath = (slug, table)=>{
    if (!slug) return $5e8d26c8795be0c3$export$fbf22af76c305dc8;
    const s = encodeURIComponent(String(slug));
    if (!table) return `${$5e8d26c8795be0c3$export$fbf22af76c305dc8}/${s}`;
    return `${$5e8d26c8795be0c3$export$fbf22af76c305dc8}/${s}/${encodeURIComponent(String(table))}`;
};
const $5e8d26c8795be0c3$var$_parsePathString = (raw)=>{
    const out = {
        base: $5e8d26c8795be0c3$export$fbf22af76c305dc8,
        slug: null,
        table: null
    };
    if (!raw || typeof raw !== 'string') return out;
    let str = raw;
    let query = '';
    const hashIdx = str.indexOf('#');
    if (hashIdx >= 0) str = str.slice(0, hashIdx);
    const qIdx = str.indexOf('?');
    if (qIdx >= 0) {
        query = str.slice(qIdx + 1);
        str = str.slice(0, qIdx);
    }
    str = (0, $7iFOV.shellStripWorkspacePrefix)(str || '');
    // Routable query shape: /data/external?src=<slug>&table=<table>
    if (query) {
        const params = new URLSearchParams(query);
        const src = params.get('src');
        if (src) {
            out.slug = src;
            out.table = params.get('table') || null;
            return out;
        }
    }
    // Path-segment shape: /data/external[/<slug>[/<table>]]
    if (str === $5e8d26c8795be0c3$export$fbf22af76c305dc8 || str.indexOf(`${$5e8d26c8795be0c3$export$fbf22af76c305dc8}/`) === 0) {
        const rest = str.slice($5e8d26c8795be0c3$export$fbf22af76c305dc8.length).split('/').filter(Boolean);
        if (rest[0]) out.slug = decodeURIComponent(rest[0]);
        if (rest[1]) out.table = decodeURIComponent(rest[1]);
    }
    return out;
};
const $5e8d26c8795be0c3$export$d8adf6eaef493085 = function parseRemotePath(path) {
    if (typeof path === 'string' && path) return $5e8d26c8795be0c3$var$_parsePathString(path);
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, null);
    if (root && typeof root._extPath === 'string' && root._extPath) return $5e8d26c8795be0c3$var$_parsePathString(root._extPath);
    if (typeof window !== 'undefined') return $5e8d26c8795be0c3$var$_parsePathString(window.location.pathname + window.location.search);
    return {
        base: $5e8d26c8795be0c3$export$fbf22af76c305dc8,
        slug: null,
        table: null
    };
};
const $5e8d26c8795be0c3$export$e7633ae2e03675e0 = function makeRemoteUrl(base, sel = {}) {
    let b = typeof base === 'string' && base ? base : $5e8d26c8795be0c3$export$fbf22af76c305dc8;
    b = b.split(/[?#]/)[0].replace(/\/+$/, '') || $5e8d26c8795be0c3$export$fbf22af76c305dc8;
    const slug = sel && sel.slug ? String(sel.slug) : null;
    if (!slug) return b;
    const params = new URLSearchParams();
    params.set('src', slug);
    if (sel.table) params.set('table', String(sel.table));
    return `${b}?${params.toString()}`;
};
const $5e8d26c8795be0c3$export$ad5eedbb2fb6efc5 = function schemaForRemoteTable(rootArg, slugArg, tableArg) {
    let root = rootArg;
    let slug = slugArg;
    let table = tableArg;
    if (typeof rootArg === 'string') {
        table = slugArg;
        slug = rootArg;
        root = null;
    }
    if (!root || typeof root !== 'object') root = $5e8d26c8795be0c3$var$_externalRootFrom($5e8d26c8795be0c3$var$_elFrom(this), null);
    if (!root || !slug || !table) return null;
    const tables = root._extSchemaBySlug ? root._extSchemaBySlug[slug] : null;
    if (!Array.isArray(tables)) return null;
    return tables.find((t)=>t && t.name === table) || null;
};
// Editor string values → typed payload, per the column schema. '' means null
// for nullable columns; booleans come from the editor's true/false select;
// json textareas must parse.
const $5e8d26c8795be0c3$var$_coerceValues = (el, schema, values, mode)=>{
    const out = {};
    const cols = schema?.columns || [];
    const byName = {};
    for (const c of cols)byName[c.name] = c;
    for(const key in values || {}){
        const col = byName[key];
        const raw = values[key];
        if (!col) {
            if (raw !== '' && raw != null) out[key] = raw;
            continue;
        }
        if (col.is_primary_key && mode === 'update') continue; // PK immutable
        if (raw === '' || raw == null) {
            if (col.is_primary_key) continue; // let the backend generate ids
            out[key] = null;
            continue;
        }
        if (col.type === 'boolean') out[key] = raw === true || raw === 'true';
        else if (col.type === 'number' || col.type === 'integer') {
            const n = Number(raw);
            if (Number.isNaN(n)) return {
                error: el.call('polyglot', 'data.external.error.notANumber').replace('{field}', key).replace('{value}', raw)
            };
            out[key] = n;
        } else if (col.format === 'json' || col.format === 'jsonb') {
            if (typeof raw === 'string') try {
                out[key] = JSON.parse(raw);
            } catch (e) {
                return {
                    error: el.call('polyglot', 'data.external.error.invalidJson').replace('{field}', key).replace('{message}', e.message)
                };
            }
            else out[key] = raw;
        } else out[key] = raw;
    }
    return {
        values: out
    };
};
const $5e8d26c8795be0c3$var$_saveRecordRow = async (el, root, ed, values)=>{
    const sdk = $5e8d26c8795be0c3$var$shellGetSDK();
    const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root);
    const data = {};
    let name;
    for(const key in values){
        if (key === 'name') name = values[key];
        else if (!$5e8d26c8795be0c3$var$RECORD_META_KEYS.includes(key)) data[key] = values[key];
    }
    if (ed.mode === 'update') {
        const id = ed.original?.id || ed.original?._id;
        if (!id) return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.rowIdMissing');
        // PATCH replaces the fields it carries — merge over the original data
        // bag so untouched custom fields survive the write.
        const baseData = ed.original && ed.original.__raw && ed.original.__raw.data || {};
        await sdk.execute('workspaceProject.records', 'update', {
            id: id,
            collection: ed.table,
            ...name !== undefined ? {
                name: name
            } : {},
            data: {
                ...baseData,
                ...data
            },
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
    } else await sdk.execute('workspaceProject.records', 'create', {
        collection: ed.table,
        ...name !== undefined ? {
            name: name
        } : {},
        data: data,
        ...workspaceId ? {
            workspaceId: workspaceId
        } : {}
    });
    return {
        ok: true
    };
};
const $5e8d26c8795be0c3$var$_saveInstantDbRow = async (el, root, ed, values)=>{
    const row = $5e8d26c8795be0c3$var$_findIntegration(root, ed.slug);
    if (!row) return {
        ok: false,
        error: el.call('polyglot', 'data.external.error.integrationNotFound').replace('{slug}', ed.slug)
    };
    if (row.kind !== 'instantdb') return {
        ok: false,
        error: el.call('polyglot', 'data.external.error.readOnly').replace('{kind}', row.kindLabel || row.kind)
    };
    const isUpdate = ed.mode === 'update';
    const id = isUpdate ? ed.original?.id || ed.original?._id : values.id || undefined;
    if (isUpdate && !id) return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.rowIdMissing');
    const vals = {
        ...values
    };
    delete vals.id;
    const res = await $5e8d26c8795be0c3$var$shellCallCapability($5e8d26c8795be0c3$var$_capabilityRef(root, row), isUpdate ? 'update' : 'create', {
        namespace: ed.table,
        ...id ? {
            id: id
        } : {},
        values: vals
    });
    const err = $5e8d26c8795be0c3$var$_readableCallError(el, res);
    return err ? {
        ok: false,
        error: err
    } : {
        ok: true
    };
};
const $5e8d26c8795be0c3$export$f92b3efc98187173 = async function saveRemoteRow(rootArg) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    if (!root) return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.noRoot');
    const ed = root._extEditor;
    if (!ed || !ed.slug || !ed.table) return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.nothingToSave');
    if (root._extEditorSaving) return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.saveInFlight');
    const schema = $5e8d26c8795be0c3$export$ad5eedbb2fb6efc5(root, ed.slug, ed.table);
    const coerced = $5e8d26c8795be0c3$var$_coerceValues(el, schema, ed.values, ed.mode);
    if (coerced.error) return {
        ok: false,
        error: coerced.error
    };
    root.update({
        _extEditorSaving: true
    });
    try {
        const res = ed.slug === $5e8d26c8795be0c3$export$d3b1f4c76c2714f1 ? await $5e8d26c8795be0c3$var$_saveRecordRow(el, root, ed, coerced.values) : await $5e8d26c8795be0c3$var$_saveInstantDbRow(el, root, ed, coerced.values);
        if (!res.ok) {
            root.update({
                _extEditorSaving: false
            });
            return res;
        }
        root.update({
            _extEditorSaving: false,
            _extEditor: null
        });
        await $5e8d26c8795be0c3$export$40551bec6000ed8d.call(el, root, {
            force: true
        });
        return {
            ok: true
        };
    } catch (e) {
        root.update({
            _extEditorSaving: false
        });
        return {
            ok: false,
            error: e?.message || String(e)
        };
    }
};
const $5e8d26c8795be0c3$export$4d43055218cdf21e = async function deleteRemoteRow(rootArg) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    if (!root) return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.noRoot');
    const ed = root._extEditor;
    if (!ed || ed.mode !== 'update') return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.nothingToDelete');
    const id = ed.original?.id || ed.original?._id;
    if (!id) return $5e8d26c8795be0c3$var$_extRefusal(el, 'data.external.error.rowIdMissing');
    try {
        if (ed.slug === $5e8d26c8795be0c3$export$d3b1f4c76c2714f1) {
            const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root);
            await $5e8d26c8795be0c3$var$shellGetSDK().execute('workspaceProject.records', 'remove', {
                id: id,
                ...workspaceId ? {
                    workspaceId: workspaceId
                } : {}
            });
        } else {
            const row = $5e8d26c8795be0c3$var$_findIntegration(root, ed.slug);
            if (!row) return {
                ok: false,
                error: el.call('polyglot', 'data.external.error.integrationNotFound').replace('{slug}', ed.slug)
            };
            if (row.kind !== 'instantdb') return {
                ok: false,
                error: el.call('polyglot', 'data.external.error.readOnly').replace('{kind}', row.kindLabel || row.kind)
            };
            const res = await $5e8d26c8795be0c3$var$shellCallCapability($5e8d26c8795be0c3$var$_capabilityRef(root, row), 'remove', {
                namespace: ed.table,
                id: id
            });
            const err = $5e8d26c8795be0c3$var$_readableCallError(el, res);
            if (err) return {
                ok: false,
                error: err
            };
        }
        root.update({
            _extEditor: null
        });
        await $5e8d26c8795be0c3$export$40551bec6000ed8d.call(el, root, {
            force: true
        });
        return {
            ok: true
        };
    } catch (e) {
        return {
            ok: false,
            error: e?.message || String(e)
        };
    }
};
const $5e8d26c8795be0c3$export$9c81acb7f526f652 = function extEnsureStateSeed(rootArg) {
    const root = $5e8d26c8795be0c3$var$_externalRootFrom($5e8d26c8795be0c3$var$_elFrom(this), rootArg);
    if (!root) return;
    const defaults = {
        _extPath: $5e8d26c8795be0c3$export$fbf22af76c305dc8,
        _extIntegrations: [],
        _extCollections: [],
        _extSourcesLoading: false,
        _extSourcesLoaded: false,
        _extSourcesError: null,
        _extSchemaBySlug: {},
        _extSchemaLoading: false,
        _extSchemaError: null,
        _extRows: [],
        _extRowsLoading: false,
        _extRowsError: null,
        _extRowsKey: null,
        _extRowsTotal: null,
        _extRowsHasMore: false,
        _extRowCounts: {},
        _extEditor: null,
        _extEditorSaving: false,
        _extRunner: {
            method: 'GET',
            path: '/',
            body: '',
            running: false,
            response: null,
            status: null,
            error: null
        }
    };
    const patch = {};
    for(const key in defaults)if (root[key] === undefined) patch[key] = defaults[key];
    if (Object.keys(patch).length) root.update(patch);
};
// ---------- sources (rail) ----------
const $5e8d26c8795be0c3$var$_fieldTypeToColumn = (def)=>{
    const t = String(def?.type || '').toLowerCase();
    const col = {
        name: def.key,
        type: 'string',
        nullable: !def.required
    };
    if (def.label) col.label = def.label;
    if (t === 'boolean' || t === 'checkbox' || t === 'toggle') col.type = 'boolean';
    else if (t === 'number' || t === 'integer' || t === 'currency' || t === 'float') col.type = 'number';
    else if (t === 'json' || t === 'object' || t === 'array') col.format = 'json';
    else if (t === 'date' || t === 'datetime' || t === 'date-time') col.format = 'date-time';
    else if (t === 'select' || t === 'multiselect') col.format = t;
    else if (t) col.format = t;
    return col;
};
const $5e8d26c8795be0c3$var$_recordTables = (collections, fieldDefs)=>{
    const defsByEntity = {};
    for (const def of fieldDefs || []){
        if (!def || !def.key) continue;
        const entity = String(def.entityType || '');
        // CustomFieldDef.entityType for record collections is 'record:<key>' —
        // tolerate a bare key too so older rows still resolve.
        const key = entity.indexOf('record:') === 0 ? entity.slice(7) : entity;
        if (!defsByEntity[key]) defsByEntity[key] = [];
        defsByEntity[key].push(def);
    }
    return (collections || []).map((c)=>({
            name: c.key,
            label: c.label || c.key,
            icon: c.icon || null,
            color: c.color || null,
            titleField: c.titleField || null,
            columns: [
                ...$5e8d26c8795be0c3$var$RECORD_BASE_COLUMNS,
                ...(defsByEntity[c.key] || []).slice().sort((a, b)=>(a.position ?? 0) - (b.position ?? 0)).map($5e8d26c8795be0c3$var$_fieldTypeToColumn),
                ...$5e8d26c8795be0c3$var$RECORD_TAIL_COLUMNS
            ],
            ops: [
                'list',
                'get',
                'create',
                'update',
                'remove'
            ]
        }));
};
// config.namespaceAllowlist arrives as an object ({ namespace: [ops] }) or a
// JSON string typed into the admin form — accept both, fail to {}.
const $5e8d26c8795be0c3$var$_namespaceAllowlist = (config)=>{
    const raw = config?.namespaceAllowlist;
    if (!raw) return {};
    if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
    if (typeof raw === 'string') try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch  {
        return {};
    }
    return {};
};
const $5e8d26c8795be0c3$var$_instantDbTables = (row)=>Object.keys($5e8d26c8795be0c3$var$_namespaceAllowlist(row.config)).map((namespace)=>({
            name: namespace,
            columns: [
                $5e8d26c8795be0c3$var$RECORD_BASE_COLUMNS[0]
            ],
            columnsDerived: false,
            ops: ($5e8d26c8795be0c3$var$_namespaceAllowlist(row.config)[namespace] || []).map(String)
        }));
const $5e8d26c8795be0c3$export$96db15d843597c3b = (row)=>(row?.capabilities || []).some((c)=>c === 'data.read' || c === 'data.write' || c === 'schema.introspect');
const $5e8d26c8795be0c3$export$384601782857c51a = async function extLoadSources(rootArg, opts = {}) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    if (!root) return;
    const orgId = $5e8d26c8795be0c3$var$_orgId(root);
    if (!orgId) {
        if (!root._extClaimsWatcher && typeof setInterval === 'function') root._extClaimsWatcher = setInterval(()=>{
            if ($5e8d26c8795be0c3$var$_orgId(root)) {
                clearInterval(root._extClaimsWatcher);
                root._extClaimsWatcher = null;
                extLoadSources.call(el, root, opts);
            }
        }, 300);
        return;
    }
    if (root._extSourcesLoading && !opts.force) return;
    root.update({
        _extSourcesLoading: true,
        _extSourcesError: null
    });
    try {
        const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root);
        const sdk = $5e8d26c8795be0c3$var$shellGetSDK();
        // Partial-failure tolerant: a records-plane permission error must not
        // blank the integrations rail (and vice versa) — whichever group loads
        // renders; the first failure surfaces as the inline notice.
        const settled = await Promise.allSettled([
            $5e8d26c8795be0c3$var$shellListIntegrationKinds(),
            $5e8d26c8795be0c3$var$shellListScopedIntegrations(workspaceId ? {
                type: 'workspace',
                orgId: orgId,
                id: workspaceId,
                includeParents: true
            } : {
                type: 'org',
                orgId: orgId
            }),
            sdk.execute('recordCollections', 'list', workspaceId ? {
                workspaceId: workspaceId
            } : {}),
            sdk.execute('fieldDefs', 'list', workspaceId ? {
                workspaceId: workspaceId
            } : {})
        ]);
        const [kinds, rows, collections, fieldDefs] = settled.map((r)=>r.status === 'fulfilled' ? r.value : null);
        const firstFailure = settled.find((r)=>r.status === 'rejected');
        const partialError = firstFailure ? firstFailure.reason?.message || String(firstFailure.reason) : null;
        const kindByName = {};
        for (const k of kinds || [])kindByName[k.kind] = k;
        const integrations = (Array.isArray(rows) ? rows : []).filter((r)=>r && r.enabled !== false).map((r)=>{
            const kind = kindByName[r.kind] || {};
            return {
                slug: r.slug || 'default',
                kind: r.kind,
                kindLabel: kind.label || r.kind,
                kindIcon: kind.icon || null,
                category: kind.category || null,
                capabilities: kind.capabilities || [],
                display_name: r.display_name || kind.label || r.kind,
                scope_type: r.scope_type || 'org',
                scope_id: r.scope_id ?? null,
                dispatchable: !!r.dispatchable,
                has_secret: !!r.has_secret,
                config: r.config || {}
            };
        });
        const cols = Array.isArray(collections) ? collections : [];
        const defs = Array.isArray(fieldDefs) ? fieldDefs : [];
        const schemaBySlug = {
            [$5e8d26c8795be0c3$export$d3b1f4c76c2714f1]: $5e8d26c8795be0c3$var$_recordTables(cols, defs)
        };
        for (const row of integrations){
            if (row.kind === 'instantdb') schemaBySlug[row.slug] = $5e8d26c8795be0c3$var$_instantDbTables(row);
            else if (!schemaBySlug[row.slug]) schemaBySlug[row.slug] = [];
        }
        root.update({
            _extIntegrations: integrations,
            _extCollections: cols.map((c)=>({
                    key: c.key,
                    label: c.label || c.key,
                    labelSingular: c.labelSingular || null,
                    icon: c.icon || null,
                    color: c.color || null,
                    titleField: c.titleField || null
                })),
            _extSchemaBySlug: schemaBySlug,
            _extSourcesLoading: false,
            _extSourcesLoaded: true,
            _extSourcesError: partialError
        });
        $5e8d26c8795be0c3$export$fabbfe8de5d27ede.call(el, root);
        // Cold deep-link: the selection may have been synced (and its row load
        // errored with "integration not found") BEFORE the source registry
        // resolved — re-run the row load now that integrations are known.
        const { slug: selSlug } = $5e8d26c8795be0c3$var$_parsePathString(root._extPath || '');
        if (selSlug && selSlug !== $5e8d26c8795be0c3$export$d3b1f4c76c2714f1) $5e8d26c8795be0c3$export$40551bec6000ed8d.call(el, root, {
            force: true
        });
    } catch (e) {
        root.update({
            _extSourcesLoading: false,
            _extSourcesLoaded: true,
            _extSourcesError: e?.message || String(e)
        });
    }
};
const $5e8d26c8795be0c3$export$fabbfe8de5d27ede = async function extLoadRowCounts(rootArg) {
    const root = $5e8d26c8795be0c3$var$_externalRootFrom($5e8d26c8795be0c3$var$_elFrom(this), rootArg);
    if (!root) return;
    const collections = Array.isArray(root._extCollections) ? root._extCollections : [];
    if (!collections.length) return;
    const sdk = $5e8d26c8795be0c3$var$shellGetSDK();
    const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root);
    for (const c of collections)try {
        const page = await sdk.execute('workspaceProject.records', 'list', {
            collection: c.key,
            limit: 1,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const total = page?.pagination?.totalCount;
        if (typeof total === 'number') root.update({
            _extRowCounts: {
                ...root._extRowCounts || {},
                [c.key]: total
            }
        });
    } catch  {
    // count stays absent — the rail simply shows no badge
    }
};
// ---------- rows ----------
const $5e8d26c8795be0c3$var$_flattenRecordRow = (r)=>{
    const flat = {
        id: r.id || r._id,
        name: r.name ?? null,
        ...r.data && typeof r.data === 'object' ? r.data : {},
        created_at: r.created_at || null,
        updated_at: r.updated_at || null
    };
    flat.__raw = r;
    return flat;
};
// Records-plane pager — id.asc + repeat-first-row guard + dedupe (offset
// paging over a non-unique order silently loses rows; see the commerce
// comListAllRecords discipline this mirrors).
const $5e8d26c8795be0c3$var$_loadRecordRows = async (root, table)=>{
    const sdk = $5e8d26c8795be0c3$var$shellGetSDK();
    const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root);
    const rows = [];
    const seen = {};
    let lastFirstId = null;
    let total = null;
    let hasMore = false;
    for(let offset = 0; offset < $5e8d26c8795be0c3$var$RECORDS_MAX_ROWS; offset += $5e8d26c8795be0c3$var$RECORDS_PAGE_SIZE){
        const page = await sdk.execute('workspaceProject.records', 'list', {
            collection: table,
            limit: $5e8d26c8795be0c3$var$RECORDS_PAGE_SIZE,
            offset: offset,
            order: 'id.asc',
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const arr = Array.isArray(page) ? page : [];
        if (page?.pagination && typeof page.pagination.totalCount === 'number') total = page.pagination.totalCount;
        const firstId = arr[0] && (arr[0].id || arr[0]._id);
        if (firstId && firstId === lastFirstId) break;
        lastFirstId = firstId || lastFirstId;
        for (const r of arr){
            const id = r && (r.id || r._id);
            if (id == null || seen[id]) continue;
            seen[id] = true;
            rows.push($5e8d26c8795be0c3$var$_flattenRecordRow(r));
        }
        if (arr.length < $5e8d26c8795be0c3$var$RECORDS_PAGE_SIZE) break;
        if (rows.length >= $5e8d26c8795be0c3$var$RECORDS_MAX_ROWS) {
            hasMore = true;
            break;
        }
    }
    return {
        rows: rows,
        total: total ?? rows.length,
        hasMore: hasMore
    };
};
// Union the keys of fetched rows into a column schema (instantdb namespaces
// are not introspectable — the allowlist names them, the rows reveal shape).
const $5e8d26c8795be0c3$var$_deriveColumns = (rows)=>{
    const names = [];
    const seen = {};
    const push = (n)=>{
        if (!n || seen[n]) return;
        seen[n] = true;
        names.push(n);
    };
    push('id');
    for (const r of rows){
        if (r && typeof r === 'object') for(const k in r)push(k);
    }
    return names.map((name)=>{
        const sample = rows.find((r)=>r && r[name] !== null && r[name] !== undefined);
        const v = sample ? sample[name] : null;
        const col = {
            name: name,
            type: 'string',
            nullable: name !== 'id'
        };
        if (name === 'id') {
            col.is_primary_key = true;
            col.format = 'uuid';
        } else if (typeof v === 'boolean') col.type = 'boolean';
        else if (typeof v === 'number') col.type = 'number';
        else if (v && typeof v === 'object') {
            col.type = 'object';
            col.format = 'json';
        }
        return col;
    });
};
const $5e8d26c8795be0c3$var$_mergeDerivedColumns = (root, slug, table, rows)=>{
    const tables = root._extSchemaBySlug && root._extSchemaBySlug[slug] || [];
    const next = tables.map((t)=>t && t.name === table && rows.length ? {
            ...t,
            columns: $5e8d26c8795be0c3$var$_deriveColumns(rows),
            columnsDerived: true
        } : t);
    root.update({
        _extSchemaBySlug: {
            ...root._extSchemaBySlug || {},
            [slug]: next
        }
    });
};
const $5e8d26c8795be0c3$var$_loadInstantDbRows = async (el, root, slug, table)=>{
    const row = $5e8d26c8795be0c3$var$_findIntegration(root, slug);
    if (!row) return {
        error: el.call('polyglot', 'data.external.error.integrationNotFound').replace('{slug}', slug)
    };
    const res = await $5e8d26c8795be0c3$var$shellCallCapability($5e8d26c8795be0c3$var$_capabilityRef(root, row), 'list', {
        namespace: table,
        limit: $5e8d26c8795be0c3$var$INSTANTDB_LIST_LIMIT
    });
    const err = $5e8d26c8795be0c3$var$_readableCallError(el, res);
    if (err) return {
        error: err
    };
    const rows = Array.isArray(res?.result?.rows) ? res.result.rows : [];
    const total = typeof res?.result?.total === 'number' ? res.result.total : rows.length;
    $5e8d26c8795be0c3$var$_mergeDerivedColumns(root, slug, table, rows);
    return {
        rows: rows,
        total: total,
        hasMore: rows.length >= $5e8d26c8795be0c3$var$INSTANTDB_LIST_LIMIT
    };
};
const $5e8d26c8795be0c3$export$40551bec6000ed8d = async function extLoadRows(rootArg, opts = {}) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    if (!root) return;
    const { slug: slug, table: table } = $5e8d26c8795be0c3$var$_parsePathString(root._extPath || '');
    if (!slug || !table) {
        root.update({
            _extRows: [],
            _extRowsLoading: false,
            _extRowsError: null,
            _extRowsKey: null,
            _extRowsTotal: null,
            _extRowsHasMore: false
        });
        return;
    }
    const key = `${slug}/${table}`;
    if (root._extRowsLoading && root._extRowsKey === key && !opts.force) return;
    root.update({
        _extRowsLoading: true,
        _extRowsError: null,
        _extRowsKey: key
    });
    try {
        let out;
        if (slug === $5e8d26c8795be0c3$export$d3b1f4c76c2714f1) out = await $5e8d26c8795be0c3$var$_loadRecordRows(root, table);
        else {
            const row = $5e8d26c8795be0c3$var$_findIntegration(root, slug);
            if (!row) out = {
                error: el.call('polyglot', 'data.external.error.integrationNotFound').replace('{slug}', slug)
            };
            else if (row.kind === 'instantdb' && row.dispatchable) out = await $5e8d26c8795be0c3$var$_loadInstantDbRows(el, root, slug, table);
            else out = {
                error: el.call('polyglot', 'data.external.error.notBrowsable').replace('{kind}', row.kindLabel || row.kind)
            };
        }
        if (root._extRowsKey !== key) return; // selection moved on — drop stale page
        if (out.error) {
            root.update({
                _extRows: [],
                _extRowsLoading: false,
                _extRowsError: out.error
            });
            return;
        }
        root.update({
            _extRows: out.rows,
            _extRowsLoading: false,
            _extRowsError: null,
            _extRowsTotal: out.total,
            _extRowsHasMore: !!out.hasMore
        });
    } catch (e) {
        if (root._extRowsKey !== key) return;
        root.update({
            _extRows: [],
            _extRowsLoading: false,
            _extRowsError: e?.message || String(e)
        });
    }
};
const $5e8d26c8795be0c3$export$81c3943cdcd07298 = function extSelectSource(sel = {}) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    if (!el) return;
    const url = $5e8d26c8795be0c3$export$e7633ae2e03675e0($5e8d26c8795be0c3$export$fbf22af76c305dc8, sel);
    const root = el.call('findRouteRoot', el) || el.getRoot();
    if (root) el.router(url, root);
};
const $5e8d26c8795be0c3$export$fcbd4de2e509d2d8 = function extSyncFromUrl(rootArg) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    if (!root) return;
    const pathname = typeof window !== 'undefined' ? window.location.pathname : root.currentPath || '';
    const search = typeof window !== 'undefined' ? window.location.search : root.currentSearch || '';
    if ((0, $7iFOV.shellStripWorkspacePrefix)(pathname) !== $5e8d26c8795be0c3$export$fbf22af76c305dc8) return;
    const { slug: slug, table: table } = $5e8d26c8795be0c3$var$_parsePathString(pathname + search);
    const canonical = $5e8d26c8795be0c3$var$_canonicalPath(slug, table);
    if (root._extPath === canonical) return;
    root.update({
        _extPath: canonical,
        _extEditor: null,
        _extRows: [],
        _extRowsError: null,
        _extRowsTotal: null,
        _extRowsHasMore: false
    });
    $5e8d26c8795be0c3$export$40551bec6000ed8d.call(el, root);
};
const $5e8d26c8795be0c3$export$c3d8dcd9b754f6e = function extOpenNewRow(rootArg) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    if (!root) return;
    const { slug: slug, table: table } = $5e8d26c8795be0c3$var$_parsePathString(root._extPath || '');
    if (!slug || !table) return;
    root.update({
        _extEditor: {
            mode: 'insert',
            slug: slug,
            table: table,
            values: {},
            original: null
        }
    });
};
const $5e8d26c8795be0c3$export$5c74c7af0b888f3 = function extSelectionEditable(rootArg) {
    const root = $5e8d26c8795be0c3$var$_externalRootFrom($5e8d26c8795be0c3$var$_elFrom(this), rootArg);
    if (!root) return false;
    const { slug: slug, table: table } = $5e8d26c8795be0c3$var$_parsePathString(root._extPath || '');
    if (!slug || !table) return false;
    if (slug === $5e8d26c8795be0c3$export$d3b1f4c76c2714f1) return true;
    const row = $5e8d26c8795be0c3$var$_findIntegration(root, slug);
    if (!row || row.kind !== 'instantdb' || !row.dispatchable) return false;
    const schema = $5e8d26c8795be0c3$export$ad5eedbb2fb6efc5(root, slug, table);
    return Array.isArray(schema?.ops) ? schema.ops.includes('create') : false;
};
const $5e8d26c8795be0c3$export$7f64d7dc06dd2b09 = function extSetRunnerField(patch) {
    const root = $5e8d26c8795be0c3$var$_externalRootFrom($5e8d26c8795be0c3$var$_elFrom(this), null);
    if (!root || !patch || typeof patch !== 'object') return;
    root.update({
        _extRunner: {
            ...root._extRunner || {},
            ...patch
        }
    });
};
const $5e8d26c8795be0c3$export$116dcbc082e3d704 = async function extRunHttpRequest(rootArg) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    if (!root) return;
    const { slug: slug } = $5e8d26c8795be0c3$var$_parsePathString(root._extPath || '');
    const row = $5e8d26c8795be0c3$var$_findIntegration(root, slug);
    if (!row || row.kind !== 'custom_http' || !row.dispatchable) return;
    const runner = root._extRunner || {};
    if (runner.running) return;
    let body;
    const rawBody = typeof runner.body === 'string' ? runner.body.trim() : '';
    if (rawBody) try {
        body = JSON.parse(rawBody);
    } catch  {
        body = rawBody // non-JSON bodies pass through as text
        ;
    }
    root.update({
        _extRunner: {
            ...runner,
            running: true,
            error: null
        }
    });
    const method = String(runner.method || 'GET').toUpperCase();
    const res = await $5e8d26c8795be0c3$var$shellCallCapability($5e8d26c8795be0c3$var$_capabilityRef(root, row), 'http.request', {
        method: method,
        path: runner.path || '/',
        ...body !== undefined && method !== 'GET' && method !== 'HEAD' ? {
            body: body
        } : {}
    });
    const err = $5e8d26c8795be0c3$var$_readableCallError(el, res);
    root.update({
        _extRunner: {
            ...root._extRunner || {},
            running: false,
            error: err,
            status: res?.status ?? null,
            response: err && res?.result === undefined ? null : res?.result ?? null
        }
    });
};
const $5e8d26c8795be0c3$export$1236503ddbffdcd0 = function extSnippetFor(rootArg) {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, rootArg);
    const { slug: slug, table: table } = $5e8d26c8795be0c3$var$_parsePathString(root?._extPath || '');
    const orgId = $5e8d26c8795be0c3$var$_orgId(root) || '<orgId>';
    const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root) || '<workspaceId>';
    if (slug === $5e8d26c8795be0c3$export$d3b1f4c76c2714f1 && table) return {
        label: el.call('polyglot', 'data.external.snippet.recordsLabel'),
        code: "fetch: [{\n  from: 'workspaceProject.records',\n  method: 'select',\n" + `  params: { collection: '${table}' },\n` + "  as: '~/rows'\n" + '}]',
        caption: el.call('polyglot', 'data.external.snippet.recordsCaption')
    };
    if (slug && slug !== $5e8d26c8795be0c3$export$d3b1f4c76c2714f1 && root) {
        const row = $5e8d26c8795be0c3$var$_findIntegration(root, slug);
        if (row && row.kind === 'instantdb') return {
            label: table ? el.call('polyglot', 'data.external.snippet.readTable').replace('{table}', table) : el.call('polyglot', 'data.external.snippet.callBackend'),
            code: "const res = await el.sdk.execute('orgIntegration', 'call', {\n" + `  orgId: '${orgId}',\n` + `  idOrSlug: '${slug}',\n` + "  capability: 'list',\n" + `  args: { namespace: '${table || '<namespace>'}', limit: 100 },\n` + `  workspaceId: '${workspaceId}'\n` + '})\n' + "// res \u2192 { ok, status, result: { rows, total } }",
            caption: el.call('polyglot', 'data.external.snippet.imperative')
        };
        if (row && row.kind === 'custom_http') return {
            label: el.call('polyglot', 'data.external.snippet.callBackend'),
            code: "const res = await el.sdk.execute('orgIntegration', 'call', {\n" + `  orgId: '${orgId}',\n` + `  idOrSlug: '${slug}',\n` + "  capability: 'http.request',\n" + "  args: { method: 'GET', path: '/status' },\n" + `  workspaceId: '${workspaceId}'\n` + '})\n' + "// res \u2192 { ok, status, result }",
            caption: el.call('polyglot', 'data.external.snippet.imperative')
        };
    }
    return {
        label: el.call('polyglot', 'data.external.snippet.listLabel'),
        code: "fetch: [{\n  from: 'orgIntegration',\n  method: 'select',\n" + `  params: { orgId: '${orgId}', scopeType: 'workspace', scopeId: '${workspaceId}' },\n` + "  as: '~/integrations'\n" + '}]',
        caption: el.call('polyglot', 'data.external.snippet.listCaption').replace('{imperative}', el.call('polyglot', 'data.external.snippet.imperative'))
    };
};
const $5e8d26c8795be0c3$export$903525dec02641f3 = async function extCopySnippet() {
    const el = $5e8d26c8795be0c3$var$_elFrom(this);
    const root = $5e8d26c8795be0c3$var$_externalRootFrom(el, null);
    const snippet = $5e8d26c8795be0c3$export$1236503ddbffdcd0.call(el, root);
    if (!snippet?.code) return;
    try {
        await navigator.clipboard.writeText(snippet.code);
        el?.call('openNotification', {
            title: el.call('polyglot', 'data.external.copy.done'),
            type: 'success'
        });
    } catch (e) {
        el?.call('openNotification', {
            title: el.call('polyglot', 'data.external.copy.failed'),
            message: e?.message,
            type: 'error'
        });
    }
};

});

parcelRegister("cJlgS", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6A4Zm"))) : import("6A4Zm")).then(()=>parcelRequire('bQ1DP'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("fu4Jd", function(module, exports) {
$parcel$export(module.exports, "applyStateMethods", () => (parcelRequire("bugUg")).applyStateMethods);
$parcel$export(module.exports, "STATE_METHODS", () => (parcelRequire("bugUg")).STATE_METHODS);
$parcel$export(module.exports, "useHostState", () => (parcelRequire("9mXYz")).useHostState);
parcelRequire("5GlgG");

});
parcelRegister("5GlgG", function(module, exports) {

$parcel$export(module.exports, "STATE_METHODS", () => (parcelRequire("bugUg")).STATE_METHODS);
$parcel$export(module.exports, "applyStateMethods", () => (parcelRequire("bugUg")).applyStateMethods);
$parcel$export(module.exports, "useHostState", () => (parcelRequire("9mXYz")).useHostState);

var $fGqeM = parcelRequire("fGqeM");

var $bugUg = parcelRequire("bugUg");

var $9mXYz = parcelRequire("9mXYz");

});
parcelRegister("fGqeM", function(module, exports) {
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $bugUg = parcelRequire("bugUg");
const $b6af2171cc18f913$export$e6a0daad8304de = function(e, s, i) {
    return e.state = $b6af2171cc18f913$export$6e8a0938c76079c7(e, s, i), e.state;
}, $b6af2171cc18f913$export$6e8a0938c76079c7 = function(e, s, i) {
    const { __ref: r } = e;
    let t = e.state;
    if (t == null || t === !1) {
        const o = s?.state || {};
        return (0, $bugUg.applyStateMethods)(e, o), o;
    }
    if (typeof t == "string") return r && (r.__state = t), r.__stateType = "string", $b6af2171cc18f913$var$y(t, e, s);
    if (typeof t == "number" || typeof t == "boolean") {
        r && (r.__state = t, r.__stateType = typeof t, r.__hasRootState = !0);
        const o = (0, $4VQqJ.createStore)({
            value: t
        });
        return o.__element = e, s?.state && (o.parent = s.state), (0, $bugUg.applyStateMethods)(e, o), o;
    }
    if (typeof t == "function" && (t = t(e, s?.state) || {}), typeof t == "object" && !(0, $4VQqJ.isStore)(t)) {
        r && (r.__hasRootState = !0), t.isRootState && r && (r.__hasRootState = !0);
        const o = (0, $4VQqJ.createStore)({
            ...t
        });
        if (o.__element = e, !Object.getOwnPropertyDescriptor(o, "root")) {
            const c = s?.state?.root || s?.state || o;
            Object.defineProperty(o, "root", {
                get: ()=>c,
                enumerable: !1,
                configurable: !0
            });
        }
        return s?.state && (o.parent = s.state, s.state.__children && (s.state.__children[e.key] = o)), (0, $bugUg.applyStateMethods)(e, o), typeof e.onStateCreated == "function" && e.onStateCreated(e, o, e.context, i), o;
    }
    return (0, $4VQqJ.isStore)(t) ? (t.__element = e, t) : s?.state || {};
};
function $b6af2171cc18f913$var$n(e, s) {
    if (!s) return e;
    const i = s.split("/");
    let r = e;
    for (const t of i){
        if (r == null) return {};
        r = r[t];
    }
    return r ?? {};
}
function $b6af2171cc18f913$var$y(e, s, i) {
    if (!i?.state) return {};
    if (e === ".") return i.state;
    if (e.startsWith("../")) {
        const t = e.slice(3), o = i.state?.parent;
        return t && o ? $b6af2171cc18f913$var$n(o, t) : o ?? i.state ?? {};
    }
    if (e.startsWith("~/")) {
        let t = i.state;
        for(; t?.parent;)t = t.parent;
        const o = e.slice(2);
        return o ? $b6af2171cc18f913$var$n(t, o) : t ?? {};
    }
    const r = $b6af2171cc18f913$var$n(i.state, e);
    if (r && typeof r == "object" && !(0, $4VQqJ.isStore)(r) && !Object.getOwnPropertyDescriptor(r, "root")) {
        const t = i.state?.root || i.state;
        Object.defineProperty(r, "root", {
            get: ()=>t,
            enumerable: !1,
            configurable: !0
        });
    }
    return r;
}

});
parcelRegister("bugUg", function(module, exports) {

$parcel$export(module.exports, "STATE_METHODS", () => $85cf9c551ff191a2$export$76c843b7166304af);
$parcel$export(module.exports, "applyStateMethods", () => $85cf9c551ff191a2$export$4100ab4dd77a48b9);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");
const $85cf9c551ff191a2$export$76c843b7166304af = new Set([
    "update",
    "parse",
    "clean",
    "destroy",
    "create",
    "add",
    "toggle",
    "remove",
    "set",
    "replace",
    "setByPath",
    "setPathCollection",
    "removeByPath",
    "removePathCollection",
    "getByPath",
    "reset",
    "apply",
    "applyReplace",
    "applyFunction",
    "quietUpdate",
    "quietReplace",
    "rootUpdate",
    "parentUpdate",
    "keys",
    "values",
    "__element",
    "__children",
    "parent",
    "root"
]), $85cf9c551ff191a2$var$y = (u, e, c)=>{
    Object.defineProperty(u, e, {
        value: c,
        enumerable: !1,
        configurable: !0,
        writable: !0
    });
}, $85cf9c551ff191a2$var$i = (u, e, c, { onlyIfAbsent: l } = {})=>{
    $85cf9c551ff191a2$var$y(u, "$" + e, c), !(l && Object.prototype.hasOwnProperty.call(u, e)) && $85cf9c551ff191a2$var$y(u, e, c);
}, $85cf9c551ff191a2$export$45d228d65bdad4bf = (u, e, ...c)=>{
    if (!u) return;
    const l = u["$" + e];
    if (typeof l == "function") return l.apply(u, c);
    const r = u[e];
    if (typeof r == "function") return r.apply(u, c);
}, $85cf9c551ff191a2$export$4100ab4dd77a48b9 = (u, e)=>{
    if ((0, $4VQqJ.isStore)(e)) {
        const r = e.__raw || e;
        $85cf9c551ff191a2$var$i(r, "toggle", function(n, o = {}) {
            e[n] = !e[n];
        }, {
            onlyIfAbsent: !0
        }), $85cf9c551ff191a2$var$i(r, "set", function(n, o = {}) {
            const t = e.__element;
            return typeof n == "object" && n !== null && t && typeof t.onBeforeStateUpdate == "function" && !o.preventBeforeStateUpdateListener && t.onBeforeStateUpdate(t, e, t.context, {
                changes: n,
                options: o
            }) === !1 || (e.$clean({
                preventStateUpdate: !0
            }), typeof n == "object" && n !== null && e.$update(n, {
                ...o,
                preventBeforeStateUpdateListener: !0
            })), e;
        }, {
            onlyIfAbsent: !0
        }), $85cf9c551ff191a2$var$i(r, "setByPath", function(n, o, t = {}) {
            const p = n.split(".");
            let f = e;
            for(let d = 0; d < p.length - 1; d++)f[p[d]] === void 0 && (f[p[d]] = {}), f = f[p[d]];
            return f[p[p.length - 1]] = o, e;
        }), $85cf9c551ff191a2$var$i(r, "getByPath", function(n) {
            const o = n.split(".");
            let t = e;
            for(let p = 0; p < o.length; p++){
                if (t == null) return;
                t = t[o[p]];
            }
            return t;
        }), $85cf9c551ff191a2$var$i(r, "removeByPath", function(n, o = {}) {
            const t = n.split(".");
            let p = e;
            for(let f = 0; f < t.length - 1; f++){
                if (p == null) return e;
                p = p[t[f]];
            }
            return p && delete p[t[t.length - 1]], e;
        }), $85cf9c551ff191a2$var$i(r, "reset", function(n = {}) {
            const o = e.$parse();
            return e.$set(o, n);
        }), $85cf9c551ff191a2$var$i(r, "apply", function(n, o = {}) {
            if (typeof n == "function") {
                const t = n(e);
                return e.$update(t, o);
            }
        }), $85cf9c551ff191a2$var$i(r, "applyFunction", function(n, o = {}) {
            if (typeof n == "function") return n(e), e.$update(e.$parse(), o);
        }), $85cf9c551ff191a2$var$i(r, "rootUpdate", function(n, o = {}) {
            let t = e;
            for(; t?.parent && (0, $4VQqJ.isStore)(t.parent);)t = t.parent;
            return $85cf9c551ff191a2$export$45d228d65bdad4bf(t, "update", n, o);
        }), $85cf9c551ff191a2$var$i(r, "parentUpdate", function(n, o = {}) {
            if (e.parent) return $85cf9c551ff191a2$export$45d228d65bdad4bf(e.parent, "update", n, o);
        }), $85cf9c551ff191a2$var$i(r, "quietReplace", function(n, o = {}) {
            return e.$replace(n, {
                quiet: !0,
                ...o
            });
        }), Object.getOwnPropertyDescriptor(r, "root") || Object.defineProperty(r, "root", {
            get: function() {
                let n = e, o = (0, $4VQqJ.isStore)(n) ? n : null;
                for(let t = 0; t < 64 && n?.parent && n.parent !== n; t++)n = n.parent, (0, $4VQqJ.isStore)(n) && (o = n);
                return o || n;
            },
            enumerable: !1,
            configurable: !0
        });
        return;
    }
    if (!e || typeof e != "object") return;
    const c = ()=>{
        for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && delete e[r];
    }, l = {
        update (r) {
            if (!r || typeof r != "object") return e;
            for(const n in r)e[n] = r[n];
            return e;
        },
        apply (r) {
            if (typeof r != "function") return e;
            const n = r(e);
            return n ? e.$update(n) : e;
        },
        parse () {
            return {
                ...e
            };
        },
        toggle (r) {
            return e[r] = !e[r], e;
        },
        set (r) {
            if (!r || typeof r != "object") return e;
            c();
            for(const n in r)e[n] = r[n];
            return e;
        },
        replace (r) {
            return e.$set(r);
        },
        clean () {
            return c(), e;
        }
    };
    $85cf9c551ff191a2$var$y(e, "$settled", function() {
        return (0, $4VQqJ.settled)().then(()=>e);
    });
    for(const r in l)if ($85cf9c551ff191a2$var$y(e, "$" + r, l[r]), typeof e[r] != "function") {
        if (Object.prototype.hasOwnProperty.call(e, r)) {
            (0, $4VQqJ.warnStateKeyShadowsMethod)(r, "");
            continue;
        }
        $85cf9c551ff191a2$var$y(e, r, l[r]);
    }
};

});


parcelRegister("9mXYz", function(module, exports) {

$parcel$export(module.exports, "useHostState", () => $6d24b117d84d5a12$export$1e60c6a95cafae70);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");
const $6d24b117d84d5a12$export$1e60c6a95cafae70 = (n, t)=>{
    if (!n) return $6d24b117d84d5a12$var$u;
    const o = $6d24b117d84d5a12$var$i(n, t);
    return !o || !o.state ? $6d24b117d84d5a12$var$u : $6d24b117d84d5a12$export$535d218771922c0f(o.state);
}, $6d24b117d84d5a12$export$3b2fa93ec930bfea = ()=>(0, $4VQqJ.getObserver)() != null, $6d24b117d84d5a12$var$f = 128;
function $6d24b117d84d5a12$var$i(n, t) {
    const o = typeof t == "function" ? t : typeof t == "string" ? (r)=>!!r?.[t] : (r)=>!!r?.state;
    let e = n, s = null;
    for(let r = 0; r < $6d24b117d84d5a12$var$f && e; r++){
        if (o(e) && e.state) return e;
        if (e.state && !s && (s = e), !e.parent || e.parent === e) break;
        e = e.parent;
    }
    return s;
}
const $6d24b117d84d5a12$var$l = {
    get (n, t) {
        return n[t];
    }
}, $6d24b117d84d5a12$var$a = new WeakMap, $6d24b117d84d5a12$export$535d218771922c0f = (n)=>{
    let t = $6d24b117d84d5a12$var$a.get(n);
    return t || (t = new Proxy(n, $6d24b117d84d5a12$var$l), $6d24b117d84d5a12$var$a.set(n, t)), t;
}, $6d24b117d84d5a12$var$u = new Proxy(Object.create(null), {
    get () {},
    has () {
        return !1;
    }
});

});



parcelRegister("fe4kH", function(module, exports) {
$parcel$export(module.exports, "popStaticCssPass", () => (parcelRequire("j2Odm")).popStaticCssPass);
$parcel$export(module.exports, "pushStaticCssPass", () => (parcelRequire("j2Odm")).pushStaticCssPass);
$parcel$export(module.exports, "THEME_PROPS", () => (parcelRequire("j2Odm")).THEME_PROPS);
$parcel$export(module.exports, "BREAKPOINT_PROPS", () => (parcelRequire("9aRcW")).BREAKPOINT_PROPS);
$parcel$export(module.exports, "breakpointsContainerName", () => (parcelRequire("9aRcW")).breakpointsContainerName);
$parcel$export(module.exports, "containerBreakpointQuery", () => (parcelRequire("9aRcW")).containerBreakpointQuery);
$parcel$export(module.exports, "CSS_PROP_WRITES", () => (parcelRequire("kaMEs")).CSS_PROP_WRITES);

$parcel$export(module.exports, "CSS_PROPS_REGISTRY", () => $b15b863eaaeedadc$export$b474245a861fc144);

var $1Ggma = parcelRequire("1Ggma");

var $ld662 = parcelRequire("ld662");

var $6L10a = parcelRequire("6L10a");

var $d2JON = parcelRequire("d2JON");

var $hfQig = parcelRequire("hfQig");

var $j2Odm = parcelRequire("j2Odm");

var $5ATG6 = parcelRequire("5ATG6");

var $1wHSA = parcelRequire("1wHSA");

var $9CCRp = parcelRequire("9CCRp");

var $9aRcW = parcelRequire("9aRcW");
parcelRequire("kaMEs");
const $b15b863eaaeedadc$export$b474245a861fc144 = {
    ...(0, $1Ggma.ANIMATION_PROPS),
    ...(0, $ld662.BLOCK_PROPS),
    ...(0, $6L10a.FONT_PROPS),
    ...(0, $d2JON.MISC_PROPS),
    ...(0, $hfQig.POSITION_PROPS),
    ...(0, $j2Odm.THEME_PROPS),
    ...(0, $5ATG6.TIMING_PROPS),
    ...(0, $1wHSA.FLEX_PROPS),
    ...(0, $9CCRp.GRID_PROPS),
    ...(0, $9aRcW.BREAKPOINT_PROPS)
};
var $b15b863eaaeedadc$export$2e2bcd8739ae039 = $b15b863eaaeedadc$export$b474245a861fc144;

});
parcelRegister("1Ggma", function(module, exports) {

$parcel$export(module.exports, "ANIMATION_PROPS", () => $139666c4f09e5a8b$export$29173f57c6f2005);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
var $6Bm4P = parcelRequire("6Bm4P");
parcelRequire("6pGsV");
var $9L4Qx = parcelRequire("9L4Qx");
parcelRequire("67GC6");
var $d52u8 = parcelRequire("d52u8");
var $521xJ = parcelRequire("521xJ");
var $ZN2Fd = parcelRequire("ZN2Fd");
var $hzNzB = parcelRequire("hzNzB");
const $139666c4f09e5a8b$var$C = [
    "ease",
    "linear",
    "ease-in",
    "ease-out",
    "ease-in-out",
    "step-start",
    "step-end"
], $139666c4f09e5a8b$var$b = [
    "none",
    "forwards",
    "backwards",
    "both"
], $139666c4f09e5a8b$var$x = [
    "normal",
    "reverse",
    "alternate",
    "alternate-reverse"
], $139666c4f09e5a8b$var$w = [
    "running",
    "paused"
], $139666c4f09e5a8b$var$P = /^(?:translate(?:3d|x|y|z)?\((?:\s*0[a-z%]*\s*,?)+\)|scale(?:3d|x|y|z)?\((?:\s*1(?:\.0+)?\s*,?)+\)|rotate(?:3d|x|y|z)?\((?:\s*0[a-z%]*\s*,?)+\)|skew(?:x|y)?\((?:\s*0[a-z%]*\s*,?)+\)|matrix\(\s*1\s*,\s*0\s*,\s*0\s*,\s*1\s*,\s*0\s*,\s*0\s*\))$/, $139666c4f09e5a8b$var$$ = (n)=>{
    const t = String(n).trim().toLowerCase();
    if (t === "" || t === "none" || t === "initial" || t === "unset") return !0;
    const i = t.match(/[a-z0-9]+\([^()]*\)/g);
    return !i || i.join("").replace(/\s+/g, "") !== t.replace(/\s+/g, "") ? !1 : i.every((e)=>$139666c4f09e5a8b$var$P.test(e.replace(/\s+/g, "")));
}, $139666c4f09e5a8b$var$N = (n)=>/^(?:\s*0[a-z%]*)+\s*$/.test(String(n).toLowerCase()) || /^(none|initial|unset)$/.test(String(n).trim().toLowerCase()), $139666c4f09e5a8b$var$v = {
    transform: $139666c4f09e5a8b$var$$,
    translate: $139666c4f09e5a8b$var$N,
    rotate: (n)=>$139666c4f09e5a8b$var$N(n) || /^\s*(?:[xyz]\s+)?0(?:deg|rad|turn|grad)?\s*$/.test(String(n).toLowerCase()),
    scale: (n)=>/^(none|initial|unset)$/.test(String(n).trim().toLowerCase()) || /^(?:\s*1(?:\.0+)?)+\s*$/.test(String(n)),
    opacity: (n)=>/^(initial|unset)$/.test(String(n).trim().toLowerCase()) || Number(n) === 1
}, $139666c4f09e5a8b$var$z = (n)=>{
    const t = String(n).trim().toLowerCase();
    if (t === "from") return 0;
    if (t === "to") return 100;
    const i = t.match(/^(\d+(?:\.\d+)?)%$/);
    return i ? Number(i[1]) : null;
}, $139666c4f09e5a8b$var$U = (n)=>{
    if (!(0, $czfS0.isObject)(n)) return null;
    let t = null, i = -1;
    for(const e in n){
        const o = $139666c4f09e5a8b$var$z(e);
        o == null || !(0, $czfS0.isObject)(n[e]) || o >= i && (i = o, t = n[e]);
    }
    return t;
}, $139666c4f09e5a8b$var$q = (n)=>{
    const t = $139666c4f09e5a8b$var$U(n);
    if (!t) return !1;
    const i = Object.keys(t);
    if (!i.length) return !1;
    for (const e of i){
        const o = $139666c4f09e5a8b$var$v[e];
        if (!o) return !1;
        const s = t[e];
        if (s == null || typeof s == "object" || typeof s == "function" || !o(s)) return !1;
    }
    return !0;
}, $139666c4f09e5a8b$var$j = (n, t)=>{
    if ((0, $czfS0.isObject)(n)) return n;
    const { animation: i } = t.context && t.context.designSystem || {}, e = i && i[n];
    return (0, $czfS0.isObject)(e) ? e : null;
}, $139666c4f09e5a8b$var$k = [
    "reverse",
    "alternate",
    "alternate-reverse"
], $139666c4f09e5a8b$var$T = (n, t, i)=>{
    const e = i || t.animationDirection;
    return e && $139666c4f09e5a8b$var$k.includes(String(e)) ? "both" : $139666c4f09e5a8b$var$q($139666c4f09e5a8b$var$j(n, t)) ? "backwards" : "both";
};
let $139666c4f09e5a8b$var$K = 0;
const $139666c4f09e5a8b$var$h = new Map, $139666c4f09e5a8b$var$g = (n, t)=>{
    const { animation: i } = t.context && t.context.designSystem || {};
    if ((0, $czfS0.isObject)(n)) {
        const o = JSON.stringify(n), s = $139666c4f09e5a8b$var$h.get(o);
        if (s) return s;
        const r = `smbls-anim-${$139666c4f09e5a8b$var$K++}`, l = (0, $9L4Qx.keyframes)(r, n);
        return $139666c4f09e5a8b$var$h.set(o, l), l;
    }
    const e = i && i[n];
    return (0, $czfS0.isObject)(e) ? (0, $9L4Qx.keyframes)(n, e) : n;
}, $139666c4f09e5a8b$var$F = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)m?s$/i, $139666c4f09e5a8b$var$B = /^(?:\d+(?:\.\d*)?|\.\d+)$/, $139666c4f09e5a8b$var$A = /^(?:cubic-bezier|steps|linear)\(/, $139666c4f09e5a8b$var$W = /^(?:calc|min|max|clamp)\(/, $139666c4f09e5a8b$var$V = (n)=>n.includes("(") || n.startsWith("--"), $139666c4f09e5a8b$var$Q = (n, t)=>{
    if (!(0, $d52u8.BARE_SEQUENCE_TOKEN_RE).test(n)) return !1;
    const i = t && t.sequence;
    if (!(0, $czfS0.isObject)(i)) return !1;
    const e = n.charCodeAt(0) === 45 ? n.slice(1) : n;
    return !!(i[e] || e.length === 2 && i[e[0]]);
}, $139666c4f09e5a8b$var$Y = (n)=>{
    if (!(0, $czfS0.isString)(n)) return !1;
    const t = n.trim();
    return $139666c4f09e5a8b$var$C.includes(t) || $139666c4f09e5a8b$var$A.test(t) || t.startsWith("var(");
}, $139666c4f09e5a8b$var$H = (n, t)=>!!t && $139666c4f09e5a8b$var$Y(t[n] || t[(0, $6Bm4P.toCamelCase)(n)]), $139666c4f09e5a8b$var$J = [
    "duration",
    "timingFunction",
    "delay",
    "iterationCount",
    "direction",
    "fillMode",
    "playState"
], $139666c4f09e5a8b$var$Z = (n)=>(0, $hzNzB.splitTopLevelSpaces)(String(n)), $139666c4f09e5a8b$var$G = (n, t, i)=>{
    const e = {
        duration: null,
        delay: null,
        timingFunction: null,
        iterationCount: null,
        direction: null,
        fillMode: null,
        playState: null
    };
    let o = null;
    const s = [], r = [], l = (a, c)=>e[a] != null ? !1 : (e[a] = c, !0), f = (a, c)=>{
        l(a, c) || s.push(c);
    };
    for (const a of $139666c4f09e5a8b$var$Z(n))t && t[a] ? o = a : $139666c4f09e5a8b$var$F.test(a) || $139666c4f09e5a8b$var$Q(a, i) ? l("duration", a) || l("delay", a) : $139666c4f09e5a8b$var$C.includes(a) || $139666c4f09e5a8b$var$H(a, i) ? f("timingFunction", a) : $139666c4f09e5a8b$var$A.test(a) ? l("timingFunction", a) : a === "infinite" ? f("iterationCount", a) : $139666c4f09e5a8b$var$B.test(a) ? l("iterationCount", Number(a)) : $139666c4f09e5a8b$var$x.includes(a) ? f("direction", a) : $139666c4f09e5a8b$var$b.includes(a) ? f("fillMode", a) : $139666c4f09e5a8b$var$w.includes(a) ? f("playState", a) : $139666c4f09e5a8b$var$V(a) ? r.push(a) : s.push(a);
    const E = o || s[0] || r.shift() || null, S = new Set;
    for (const a of r){
        const c = $139666c4f09e5a8b$var$J.find((I)=>e[I] == null);
        if (!c) break;
        e[c] = a.startsWith("--") ? `var(${a})` : a, S.add(c);
    }
    return {
        name: E,
        ...e,
        opaqueSlots: S
    };
}, $139666c4f09e5a8b$var$X = (n, t)=>{
    const { animation: i } = t.context && t.context.designSystem || {}, { timing: e } = (0, $521xJ.getActiveConfig)() || {};
    return (0, $hzNzB.splitTopLevelCommas)(String(n)).map((o)=>o.trim()).filter(Boolean).map((o)=>$139666c4f09e5a8b$var$G(o, i, e));
}, $139666c4f09e5a8b$var$D = (n, t)=>$139666c4f09e5a8b$var$F.test(n) || t && !$139666c4f09e5a8b$var$W.test(n) && !/^(?:var|env)\(/.test(n) ? n : (0, $ZN2Fd.getTimingByKey)(n).timing || n, $139666c4f09e5a8b$var$nn = (n, t)=>{
    const i = (e)=>n.opaqueSlots.has(e);
    return {
        animationName: n.name == null ? void 0 : $139666c4f09e5a8b$var$g(n.name, t),
        animationDuration: n.duration != null ? $139666c4f09e5a8b$var$D(n.duration, i("duration")) : (0, $ZN2Fd.getTimingByKey)(t.animationDuration || "A").timing,
        animationDelay: n.delay != null ? $139666c4f09e5a8b$var$D(n.delay, i("delay")) : (0, $ZN2Fd.getTimingByKey)(t.animationDelay || "0s").timing,
        animationTimingFunction: n.timingFunction != null ? i("timingFunction") ? n.timingFunction : (0, $ZN2Fd.getTimingFunction)(n.timingFunction) : (0, $ZN2Fd.getTimingFunction)(t.animationTimingFunction || "ease"),
        animationFillMode: n.fillMode || t.animationFillMode || $139666c4f09e5a8b$var$T(n.name, t, n.direction),
        animationIterationCount: n.iterationCount != null ? n.iterationCount : t.animationIterationCount || 1,
        animationPlayState: n.playState || t.animationPlayState,
        animationDirection: n.direction || t.animationDirection
    };
}, $139666c4f09e5a8b$var$tn = {
    animationName: "none",
    animationPlayState: "running",
    animationDirection: "normal"
}, $139666c4f09e5a8b$var$en = (n, t)=>{
    const i = n.map((o)=>$139666c4f09e5a8b$var$nn(o, t));
    if (i.length === 1) return i[0];
    const e = {};
    for(const o in i[0]){
        const s = i.map((r)=>r[o]);
        s.every((r)=>r == null) || (e[o] = s.map((r)=>r ?? $139666c4f09e5a8b$var$tn[o]).join(", "));
    }
    return e;
}, $139666c4f09e5a8b$export$29173f57c6f2005 = {
    animation: (n, t)=>{
        if (n != null) {
            if ((0, $czfS0.isString)(n) && /[\s,]/.test(n)) {
                const i = $139666c4f09e5a8b$var$X(n, t);
                if (i.length) return $139666c4f09e5a8b$var$en(i, t);
            }
            return {
                animationName: $139666c4f09e5a8b$var$g(n, t),
                animationDuration: (0, $ZN2Fd.getTimingByKey)(t.animationDuration || "A").timing,
                animationDelay: (0, $ZN2Fd.getTimingByKey)(t.animationDelay || "0s").timing,
                animationTimingFunction: (0, $ZN2Fd.getTimingFunction)(t.animationTimingFunction || "ease"),
                animationFillMode: t.animationFillMode || $139666c4f09e5a8b$var$T(n, t),
                animationIterationCount: t.animationIterationCount || 1,
                animationPlayState: t.animationPlayState,
                animationDirection: t.animationDirection
            };
        }
    },
    animationName: (n, t)=>({
            animationName: $139666c4f09e5a8b$var$g(n, t)
        }),
    animationDuration: (n)=>({
            animationDuration: (0, $ZN2Fd.getTimingByKey)(n).timing
        }),
    animationDelay: (n)=>({
            animationDelay: (0, $ZN2Fd.getTimingByKey)(n).timing
        }),
    animationTimingFunction: (n)=>({
            animationTimingFunction: (0, $ZN2Fd.getTimingFunction)(n)
        }),
    animationIterationCount: (n)=>({
            animationIterationCount: n
        }),
    animationFillMode: (n)=>({
            animationFillMode: n
        }),
    animationPlayState: (n)=>({
            animationPlayState: n
        }),
    animationDirection: (n)=>({
            animationDirection: n
        })
};

});
parcelRegister("6pGsV", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("9L4Qx")).css);
$parcel$export(module.exports, "CSS_LONGHAND_SHORTHANDS", () => (parcelRequire("aFJFR")).CSS_LONGHAND_SHORTHANDS);
$parcel$export(module.exports, "CSS_SHORTHAND_LONGHANDS", () => (parcelRequire("aFJFR")).CSS_SHORTHAND_LONGHANDS);
$parcel$export(module.exports, "cssCamelName", () => (parcelRequire("9L4Qx")).cssCamelName);
$parcel$export(module.exports, "cssPropName", () => (parcelRequire("9L4Qx")).cssPropName);
$parcel$export(module.exports, "cssShorthandStatesLonghand", () => (parcelRequire("aFJFR")).cssShorthandStatesLonghand);
$parcel$export(module.exports, "cssShorthandStatesThemeLonghand", () => (parcelRequire("aFJFR")).cssShorthandStatesThemeLonghand);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("9L4Qx")).keyframes);
$parcel$export(module.exports, "splitSelectorList", () => (parcelRequire("9L4Qx")).splitSelectorList);
$parcel$export(module.exports, "wrapHoverRule", () => (parcelRequire("9L4Qx")).wrapHoverRule);
parcelRequire("4zByR");

});
parcelRegister("4zByR", function(module, exports) {

$parcel$export(module.exports, "CSS_LONGHAND_SHORTHANDS", () => (parcelRequire("aFJFR")).CSS_LONGHAND_SHORTHANDS);
$parcel$export(module.exports, "CSS_SHORTHAND_LONGHANDS", () => (parcelRequire("aFJFR")).CSS_SHORTHAND_LONGHANDS);
$parcel$export(module.exports, "css", () => (parcelRequire("9L4Qx")).css);
$parcel$export(module.exports, "cssCamelName", () => (parcelRequire("9L4Qx")).cssCamelName);
$parcel$export(module.exports, "cssPropName", () => (parcelRequire("9L4Qx")).cssPropName);
$parcel$export(module.exports, "cssShorthandStatesLonghand", () => (parcelRequire("aFJFR")).cssShorthandStatesLonghand);
$parcel$export(module.exports, "cssShorthandStatesThemeLonghand", () => (parcelRequire("aFJFR")).cssShorthandStatesThemeLonghand);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("9L4Qx")).keyframes);
$parcel$export(module.exports, "splitSelectorList", () => (parcelRequire("9L4Qx")).splitSelectorList);
$parcel$export(module.exports, "wrapHoverRule", () => (parcelRequire("9L4Qx")).wrapHoverRule);

var $9L4Qx = parcelRequire("9L4Qx");

var $aFJFR = parcelRequire("aFJFR");

});
parcelRegister("9L4Qx", function(module, exports) {

$parcel$export(module.exports, "cssPropName", () => $71ac433c3918c546$export$7996caeb46a3bdf6);
$parcel$export(module.exports, "cssCamelName", () => $71ac433c3918c546$export$210d7b134e4cafb0);
$parcel$export(module.exports, "wrapHoverRule", () => $71ac433c3918c546$export$b0de4e5e9a88127b);
$parcel$export(module.exports, "css", () => $71ac433c3918c546$export$dbf350e5966cf602);
$parcel$export(module.exports, "splitSelectorList", () => $71ac433c3918c546$export$86cca2c9cdf8abd7);
$parcel$export(module.exports, "keyframes", () => $71ac433c3918c546$export$d25ddfdf17c3ad3e);
parcelRequire("67GC6");
var $521xJ = parcelRequire("521xJ");

var $g8ey8 = parcelRequire("g8ey8");

var $aFJFR = parcelRequire("aFJFR");
const $71ac433c3918c546$var$O = new Map;
let $71ac433c3918c546$var$ht = null, $71ac433c3918c546$var$K = null, $71ac433c3918c546$var$Mt = null;
function $71ac433c3918c546$export$8c5e2ec1e153591(t) {
    t.batchAtomicCss && ($71ac433c3918c546$var$K = t.batchAtomicCss), t.compoundCssClass && ($71ac433c3918c546$var$Mt = t.compoundCssClass);
}
const $71ac433c3918c546$var$pt = new Set, $71ac433c3918c546$var$mt = (t)=>!!(t && t.documentElement && typeof t.createElement == "function" && t.head !== void 0);
function $71ac433c3918c546$export$149520325e406055(t) {
    try {
        const e = (0, $521xJ.getActiveConfig)();
        e && (e.__domDocument = t);
    } catch  {}
    t && $71ac433c3918c546$var$pt.add(t);
}
function $71ac433c3918c546$export$b95447fc6bac8667() {
    try {
        const t = (0, $521xJ.getActiveConfig)();
        if (t) {
            if ($71ac433c3918c546$var$mt(t.__domDocument)) return t.__domDocument;
            if ($71ac433c3918c546$var$mt(t.document)) return t.document;
        }
    } catch  {}
    return typeof document < "u" ? document : null;
}
function $71ac433c3918c546$export$469ebc401c7f18f8() {
    return $71ac433c3918c546$var$pt;
}
const $71ac433c3918c546$var$b = {
    atomic: 0,
    variable: 0,
    global: 0,
    keyframes: 0,
    duplicate: 0,
    invalid: 0,
    dropped: 0
};
function $71ac433c3918c546$export$7d203f86ebfe3895() {
    return {
        ...$71ac433c3918c546$var$b
    };
}
function $71ac433c3918c546$export$93c20df9d85f443e() {
    for(const t in $71ac433c3918c546$var$b)$71ac433c3918c546$var$b[t] = 0;
    $71ac433c3918c546$var$V = !1;
}
let $71ac433c3918c546$var$V = !1;
const $71ac433c3918c546$var$z = (t, e)=>`${t} ${e}${t === 1 ? "" : "s"}`;
function $71ac433c3918c546$var$Wt(t) {
    const e = Date.parse(t);
    if (!isFinite(e)) return "";
    const n = Math.floor((Date.now() - e) / 864e5);
    return n < 1 ? " (today)" : ` (${$71ac433c3918c546$var$z(n, "day")} ago)`;
}
function $71ac433c3918c546$var$Ht() {
    try {
        const t = $71ac433c3918c546$var$Jt();
        if (!t.length) return -1;
        let e = 0;
        for(let n = 0; n < t.length; n++)e += t[n].cssRules ? t[n].cssRules.length : 0;
        return e;
    } catch  {
        return -1;
    }
}
function $71ac433c3918c546$var$Lt(t, e) {
    if ($71ac433c3918c546$var$V) return !1;
    $71ac433c3918c546$var$V = !0;
    const n = (0, $g8ey8.BUILD_STAMP) ? `${0, $g8ey8.BUILD_STAMP}${$71ac433c3918c546$var$Wt((0, $g8ey8.BUILD_STAMP))}   <- dist/esm, this is the code that just ran` : "n/a \u2014 running from src/ (unbuilt), so no dist is in play", o = (0, $g8ey8.BUILD_STAMP) ? "not readable from a browser; run the FIX below to print it per package" : "this IS the source", s = (0, $g8ey8.BUILD_VERSION) ? `@symbo.ls/css@${0, $g8ey8.BUILD_VERSION}` : "@symbo.ls/css";
    return console.error(`[@symbo.ls/css] CSS EMIT FAILURE (${t}) \u2014 the engine emitted ${$71ac433c3918c546$var$z($71ac433c3918c546$var$b.variable, "variable rule")} and ${$71ac433c3918c546$var$z($71ac433c3918c546$var$b.atomic, "atomic rule")}, while the design system held ${$71ac433c3918c546$var$z(e, "CSS variable")}.
  The document will render UNSTYLED and nothing else will report an error.
  This is what a STALE dist/ looks like: an obsolete emitter against a current design system.
  package : ${s}
  built   : ${n}
  source  : ${o}
  emitted : ${JSON.stringify($71ac433c3918c546$var$b)}
  sheets  : the style[data-smbls] tiers currently hold ${$71ac433c3918c546$var$Ht()} rule(s)
  FIX     : cd smbls && npm run check:stale   # every package whose src is newer than its dist
            then rebuild the listed packages and clear the app's .parcel-cache
  Do NOT trust any browser measurement taken on this page until that reads clean.`), !0;
}
function $71ac433c3918c546$var$gt() {
    try {
        const t = (0, $521xJ.getActiveConfig)(), e = t && (t.CSS_VARS || t.cssVars);
        return e ? Object.keys(e).length : 0;
    } catch  {
        return 0;
    }
}
function $71ac433c3918c546$var$q(t) {
    $71ac433c3918c546$var$V || $71ac433c3918c546$var$b.variable > 0 || $71ac433c3918c546$var$b.atomic > 0 || $71ac433c3918c546$var$bt(Math.max(t, $71ac433c3918c546$var$gt()));
}
function $71ac433c3918c546$export$d6116afdcd58121a(t) {
    const e = t && (t.CSS_VARS || t.cssVars);
    return $71ac433c3918c546$var$bt(e ? Object.keys(e).length : $71ac433c3918c546$var$gt());
}
function $71ac433c3918c546$var$bt(t) {
    const e = $71ac433c3918c546$export$7d203f86ebfe3895();
    if (t === 0) return {
        ok: !0,
        reason: "no-design-system",
        stats: e,
        varCount: t
    };
    if (!$71ac433c3918c546$var$st()) return {
        ok: !0,
        reason: "no-sheet",
        stats: e,
        varCount: t
    };
    if (e.variable > 0 || e.atomic > 0) return {
        ok: !0,
        reason: null,
        stats: e,
        varCount: t
    };
    const n = e.invalid > 0 ? "every rule was rejected as malformed" : "no rule was ever produced";
    return $71ac433c3918c546$var$Lt(n, t), {
        ok: !1,
        reason: n,
        stats: e,
        varCount: t
    };
}
const $71ac433c3918c546$var$Vt = {
    display: "d",
    position: "pos",
    padding: "p",
    paddingTop: "pt",
    paddingRight: "pr",
    paddingBottom: "pb",
    paddingLeft: "pl",
    margin: "m",
    marginTop: "mt",
    marginRight: "mr",
    marginBottom: "mb",
    marginLeft: "ml",
    width: "w",
    height: "h",
    minWidth: "mnw",
    minHeight: "mnh",
    maxWidth: "mxw",
    maxHeight: "mxh",
    top: "t",
    right: "r",
    bottom: "b",
    left: "l",
    flex: "fx",
    flexDirection: "fxd",
    flexWrap: "fxw",
    flexGrow: "fxg",
    flexShrink: "fxs",
    flexBasis: "fxb",
    justifyContent: "jc",
    alignItems: "ai",
    alignSelf: "as",
    alignContent: "ac",
    gap: "g",
    rowGap: "rg",
    columnGap: "cg",
    gridTemplateColumns: "gtc",
    gridTemplateRows: "gtr",
    gridColumn: "gc",
    gridRow: "gr",
    overflow: "of",
    overflowX: "ofx",
    overflowY: "ofy",
    fontSize: "fs",
    fontWeight: "fw",
    fontFamily: "ff",
    fontStyle: "fst",
    lineHeight: "lh",
    letterSpacing: "ls",
    textAlign: "ta",
    textDecoration: "td",
    textTransform: "tt",
    color: "c",
    background: "bg",
    backgroundColor: "bgc",
    backgroundImage: "bgi",
    border: "bd",
    borderRadius: "br",
    borderColor: "bdc",
    borderWidth: "bdw",
    borderStyle: "bds",
    boxShadow: "bxsh",
    opacity: "op",
    zIndex: "z",
    cursor: "cur",
    transition: "tr",
    transform: "tf",
    animation: "an",
    visibility: "vis",
    whiteSpace: "ws",
    wordBreak: "wb",
    objectFit: "obj",
    pointerEvents: "pe",
    userSelect: "us",
    boxSizing: "bxz",
    outline: "ol",
    listStyle: "lis",
    textOverflow: "txo",
    verticalAlign: "va",
    float: "fl",
    clear: "cl",
    content: "cnt",
    backdropFilter: "bdf",
    filter: "flt",
    resize: "rsz",
    appearance: "apr",
    fill: "fil",
    stroke: "stk"
};
function $71ac433c3918c546$var$zt(t) {
    return t.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase());
}
const $71ac433c3918c546$var$I = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, $71ac433c3918c546$var$yt = new Map, $71ac433c3918c546$export$7996caeb46a3bdf6 = (t)=>{
    if ($71ac433c3918c546$var$I(t)) return t;
    let e = $71ac433c3918c546$var$yt.get(t);
    return e === void 0 && (e = $71ac433c3918c546$var$zt(t), $71ac433c3918c546$var$yt.set(t, e)), e;
}, $71ac433c3918c546$var$kt = new Map, $71ac433c3918c546$export$210d7b134e4cafb0 = (t)=>{
    if ($71ac433c3918c546$var$I(t)) return t;
    let e = $71ac433c3918c546$var$kt.get(t);
    return e === void 0 && (e = t.replace(/-([a-z])/g, (n, o)=>o.toUpperCase()), $71ac433c3918c546$var$kt.set(t, e)), e;
};
function $71ac433c3918c546$var$P(t) {
    let e = 2166136261;
    for(let n = 0; n < t.length; n++)e ^= t.charCodeAt(n), e = e * 16777619 >>> 0;
    return e.toString(36);
}
function $71ac433c3918c546$var$Pt(t) {
    const e = String(t);
    return e.length <= 20 ? e.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_-]/g, "").toLowerCase() : $71ac433c3918c546$var$P(e);
}
const $71ac433c3918c546$var$Ft = {
    "backdrop-filter": "-webkit-backdrop-filter",
    "user-select": "-webkit-user-select",
    "mask-image": "-webkit-mask-image",
    "mask-size": "-webkit-mask-size",
    "mask-repeat": "-webkit-mask-repeat",
    "mask-position": "-webkit-mask-position",
    "mask-clip": "-webkit-mask-clip",
    "mask-origin": "-webkit-mask-origin",
    "background-clip": "-webkit-background-clip"
};
function $71ac433c3918c546$var$E(t, e) {
    const n = $71ac433c3918c546$var$Ft[t];
    return n ? `${t}:${e};${n}:${e};` : `${t}:${e};`;
}
function $71ac433c3918c546$var$X(t) {
    let e = "";
    for(const n in t){
        const o = t[n];
        if (typeof o != "object" || o === null) continue;
        let s = "";
        for(const r in o)o[r] != null && (s += $71ac433c3918c546$var$E($71ac433c3918c546$export$7996caeb46a3bdf6(r), o[r]));
        e += `${n}{${s}}`;
    }
    return e;
}
function $71ac433c3918c546$var$Y(t) {
    return t.charCodeAt(0) === 64 && !$71ac433c3918c546$var$j(t);
}
function $71ac433c3918c546$var$St(t) {
    let e = "";
    for(const n in t){
        const o = t[n];
        if (!$71ac433c3918c546$var$Y(n) || typeof o != "object" || o === null) continue;
        let s = "";
        for(const r in o){
            const l = o[r];
            l == null || typeof l == "object" || (s += $71ac433c3918c546$var$E($71ac433c3918c546$export$7996caeb46a3bdf6(r), l));
        }
        e += `${n}{${s}}`;
    }
    return e;
}
const $71ac433c3918c546$var$Ut = "@media (hover: hover)", $71ac433c3918c546$var$Gt = /(?:^|[^\\]):hover(?![\w-])/;
function $71ac433c3918c546$var$J() {
    try {
        const t = (0, $521xJ.getActiveConfig)();
        if (t && t.hoverMedia === !1) return !1;
    } catch  {}
    return !0;
}
function $71ac433c3918c546$export$b0de4e5e9a88127b(t, e, n) {
    return n === !1 || !$71ac433c3918c546$var$Gt.test(e) || n === void 0 && !$71ac433c3918c546$var$J() ? t : `${$71ac433c3918c546$var$Ut}{${t}}`;
}
const $71ac433c3918c546$var$Q = new Map;
function $71ac433c3918c546$var$Kt(t, e, n, o) {
    let s = $71ac433c3918c546$var$O.get(t);
    if (!s) {
        const i = $71ac433c3918c546$var$Vt[e] || $71ac433c3918c546$var$P(e), a = $71ac433c3918c546$var$Pt(n);
        s = o ? `_${o}_${i}-${a}` : `_${i}-${a}`, $71ac433c3918c546$var$O.set(t, s);
    }
    const l = typeof n == "string" && (n.indexOf("}") !== -1 || n.indexOf("{") !== -1) ? null : `.${s}{${$71ac433c3918c546$var$E($71ac433c3918c546$export$7996caeb46a3bdf6(e), n)}}`, c = {
        className: s,
        rule: l,
        tier: l === null ? null : $71ac433c3918c546$var$et(l, !0, "atomic")
    };
    return $71ac433c3918c546$var$Q.set(t, c), c;
}
function $71ac433c3918c546$var$xt(t, e, n) {
    const o = (n ? n + "" : "") + t + ":" + e, s = $71ac433c3918c546$var$Q.get(o) || $71ac433c3918c546$var$Kt(o, t, e, n);
    return s.rule !== null && $71ac433c3918c546$var$x(s.rule, void 0, "atomic", !0, s.tier), s.className;
}
const $71ac433c3918c546$var$wt = new WeakMap, $71ac433c3918c546$var$$t = new WeakMap;
function $71ac433c3918c546$var$x(t, e, n, o, s) {
    const r = s || $71ac433c3918c546$var$et(t, o, n);
    $71ac433c3918c546$var$N && !e && $71ac433c3918c546$var$N.push([
        t,
        n || "global",
        r
    ]);
    const l = $71ac433c3918c546$var$Yt(e, r);
    if (!l) return $71ac433c3918c546$var$b.dropped++, "dropped";
    const c = l.sheet;
    let i = l.rules;
    if (i || (i = $71ac433c3918c546$var$wt.get(c), i || (i = new Set, $71ac433c3918c546$var$wt.set(c, i)), l.rules = i), i.has(t)) return $71ac433c3918c546$var$b.duplicate++, $71ac433c3918c546$var$b[n || "global"]++, "duplicate";
    let a = $71ac433c3918c546$var$$t.get(c);
    if (a && a.has(t)) return $71ac433c3918c546$var$b.invalid++, "invalid";
    try {
        c.insertRule(t, c.cssRules.length);
    } catch  {
        return a || (a = new Set, $71ac433c3918c546$var$$t.set(c, a)), a.add(t), $71ac433c3918c546$var$b.invalid++, "invalid";
    }
    return i.add(t), $71ac433c3918c546$var$b[n || "global"]++, "inserted";
}
const $71ac433c3918c546$var$y = "0:0", $71ac433c3918c546$var$tt = "1:0", $71ac433c3918c546$var$_t = "0:99", $71ac433c3918c546$var$Ct = /\((max|min)-width:\s*([\d.]+)(px|em|rem)?\)/g;
function $71ac433c3918c546$var$et(t, e, n) {
    if (typeof t != "string" || !t) return $71ac433c3918c546$var$y;
    if (t.charCodeAt(0) === 64) {
        if (!t.startsWith("@media") && !t.startsWith("@supports") && !t.startsWith("@container")) return $71ac433c3918c546$var$y;
        let l = 1 / 0, c = -1 / 0;
        $71ac433c3918c546$var$Ct.lastIndex = 0;
        let i;
        for(; i = $71ac433c3918c546$var$Ct.exec(t);){
            const a = parseFloat(i[2]) * (i[3] === "em" || i[3] === "rem" ? 16 : 1);
            i[1] === "max" ? l = Math.min(l, a) : c = Math.max(c, a);
        }
        return l !== 1 / 0 ? "2:" + -l : c !== -1 / 0 ? "3:" + c : $71ac433c3918c546$var$tt;
    }
    if (t.charCodeAt(0) !== 46) return n === "atomic" && !e ? $71ac433c3918c546$var$_t : $71ac433c3918c546$var$y;
    if (!/^\.[\w-]+\{/.test(t)) return $71ac433c3918c546$var$tt;
    if (!e) return $71ac433c3918c546$var$y;
    const o = t.indexOf("{"), s = t.indexOf(":", o);
    if (s === -1) return $71ac433c3918c546$var$y;
    const r = (0, $aFJFR.cssShorthandDepth)(t.slice(o + 1, s).trim());
    return r ? "0:" + r : $71ac433c3918c546$var$y;
}
let $71ac433c3918c546$var$T = null;
const $71ac433c3918c546$var$qt = ()=>{
    if ($71ac433c3918c546$var$T) return $71ac433c3918c546$var$T;
    let t = 0;
    for(const e in 0, $aFJFR.CSS_LONGHAND_SHORTHANDS)t = Math.max(t, (0, $aFJFR.cssShorthandDepth)(e));
    $71ac433c3918c546$var$T = [
        $71ac433c3918c546$var$y
    ];
    for(let e = 1; e <= t; e++)$71ac433c3918c546$var$T.push("0:" + e);
    return $71ac433c3918c546$var$T.push($71ac433c3918c546$var$_t, $71ac433c3918c546$var$tt), $71ac433c3918c546$var$T;
}, $71ac433c3918c546$var$At = (t)=>{
    const e = t.indexOf(":");
    return [
        Number(t.slice(0, e)),
        Number(t.slice(e + 1))
    ];
}, $71ac433c3918c546$var$vt = (t, e)=>{
    const [n, o] = $71ac433c3918c546$var$At(t), [s, r] = $71ac433c3918c546$var$At(e);
    return n !== s ? n - s : o - r;
}, $71ac433c3918c546$var$Rt = (t, e)=>$71ac433c3918c546$var$vt(t, e) < 0, $71ac433c3918c546$var$Et = (t)=>t.getAttribute("data-tier") || $71ac433c3918c546$var$y, $71ac433c3918c546$var$Xt = /^\d+:-?\d+(?:\.\d+)?$/;
function $71ac433c3918c546$export$cd6904fb5b425b69(t) {
    return !t || typeof t.hasAttribute != "function" || !t.hasAttribute("data-smbls") ? null : $71ac433c3918c546$var$Et(t);
}
function $71ac433c3918c546$export$16d133d9c1214097(t, e) {
    const n = Array.from(t || [], (o, s)=>{
        const r = typeof e == "function" ? e(o) : null;
        return {
            item: o,
            i: s,
            tier: typeof r == "string" && $71ac433c3918c546$var$Xt.test(r) ? r : $71ac433c3918c546$var$y
        };
    });
    return n.sort((o, s)=>$71ac433c3918c546$var$vt(o.tier, s.tier) || o.i - s.i), n.map((o)=>o.item);
}
const $71ac433c3918c546$var$nt = new WeakMap;
let $71ac433c3918c546$var$F = !1, $71ac433c3918c546$var$M = null, $71ac433c3918c546$var$ot = 0;
function $71ac433c3918c546$var$Yt(t, e) {
    if ($71ac433c3918c546$var$F && !t) {
        const n = $71ac433c3918c546$var$M && $71ac433c3918c546$var$nt.get($71ac433c3918c546$var$M), o = n && n.get(e);
        if (o && o.epoch === $71ac433c3918c546$var$ot) return o;
        const s = $71ac433c3918c546$var$U($71ac433c3918c546$var$M, e);
        return s && (s.epoch = $71ac433c3918c546$var$ot), s;
    }
    return $71ac433c3918c546$var$U(t || $71ac433c3918c546$export$b95447fc6bac8667(), e);
}
function $71ac433c3918c546$var$st(t, e) {
    const n = $71ac433c3918c546$var$U(t || $71ac433c3918c546$export$b95447fc6bac8667(), e);
    return n ? n.sheet : null;
}
function $71ac433c3918c546$var$U(t, e) {
    if (!t || !t.head) return null;
    const n = e || $71ac433c3918c546$var$y;
    let o = $71ac433c3918c546$var$nt.get(t);
    o || (o = new Map, $71ac433c3918c546$var$nt.set(t, o));
    const s = o.get(n);
    if (s && s.node.parentNode === t.head && s.node.sheet === s.sheet) return s;
    if (n !== $71ac433c3918c546$var$y) {
        const i = $71ac433c3918c546$var$qt();
        for(let a = 0; a < i.length && $71ac433c3918c546$var$Rt(i[a], n); a++)$71ac433c3918c546$var$U(t, i[a]);
    }
    let r = n === $71ac433c3918c546$var$y ? t.head.querySelector("style[data-smbls]:not([data-tier])") : t.head.querySelector(`style[data-smbls][data-tier="${n}"]`);
    if (!r) {
        r = t.createElement("style"), r.setAttribute("data-smbls", ""), n !== $71ac433c3918c546$var$y && r.setAttribute("data-tier", n);
        const i = t.head.querySelectorAll("style[data-smbls]");
        let a = null;
        for(let f = 0; f < i.length; f++)if ($71ac433c3918c546$var$Rt(n, $71ac433c3918c546$var$Et(i[f]))) {
            a = i[f];
            break;
        }
        const u = i.length ? i[i.length - 1] : null;
        if (a) t.head.insertBefore(r, a);
        else if (u) t.head.insertBefore(r, u.nextSibling);
        else {
            const f = t.head.querySelector('style[data-brender], style[data-emotion="smbls"]');
            f ? t.head.insertBefore(r, f) : t.head.appendChild(r);
        }
    }
    const l = r.sheet;
    if (!l) return o.delete(n), null;
    const c = {
        sheet: l,
        node: r,
        rules: null,
        epoch: 0
    };
    return o.set(n, c), n === $71ac433c3918c546$var$y && ($71ac433c3918c546$var$ht = l), c;
}
function $71ac433c3918c546$var$Jt(t) {
    const e = t || $71ac433c3918c546$export$b95447fc6bac8667();
    if (!e || !e.head) return [];
    const n = [], o = e.head.querySelectorAll("style[data-smbls]");
    for(let s = 0; s < o.length; s++)o[s].sheet && n.push(o[s].sheet);
    return n;
}
const $71ac433c3918c546$var$Zt = 8;
function $71ac433c3918c546$export$dbf350e5966cf602(t, e, n, o) {
    if (!t || typeof t != "object") return "";
    if ($71ac433c3918c546$var$F) return $71ac433c3918c546$var$Ot(t, n, o);
    $71ac433c3918c546$var$F = !0, $71ac433c3918c546$var$M = $71ac433c3918c546$export$b95447fc6bac8667(), $71ac433c3918c546$var$ot++;
    try {
        return $71ac433c3918c546$var$Ot(t, n, o);
    } finally{
        $71ac433c3918c546$var$F = !1, $71ac433c3918c546$var$M = null;
    }
}
function $71ac433c3918c546$var$Ot(t, e, n) {
    const o = !!(n && n.state);
    let s = null, r = 0;
    const l = [], c = [], i = Object.keys(t);
    for(let u = 0; u < i.length; u++){
        const f = i[u], h = t[f];
        h == null || h === !1 || h === "" || (typeof h == "object" ? c.push([
            f,
            h
        ]) : $71ac433c3918c546$var$K && !$71ac433c3918c546$var$I(f) ? (s || (s = []), s.push(f, String(h)), r++) : l.push($71ac433c3918c546$var$xt(f, String(h), e)));
    }
    if (s && r >= $71ac433c3918c546$var$Zt) {
        const u = s.join("\0"), f = $71ac433c3918c546$var$K(u), h = f.indexOf("\0"), p = f.substring(0, h), C = f.substring(h + 1);
        if (C) {
            const A = C.split(`
`);
            for(let $ = 0; $ < A.length; $++)A[$] && $71ac433c3918c546$var$x(A[$], void 0, "atomic", !0);
        }
        l.push(p);
    } else if (s) for(let u = 0; u < s.length; u += 2)l.push($71ac433c3918c546$var$xt(s[u], s[u + 1], e));
    const a = [];
    for(let u = 0; u < c.length; u++)a.push($71ac433c3918c546$var$ne(c[u][0], c[u][1], e, o));
    return l.concat(a).join(" ").trim();
}
const $71ac433c3918c546$var$It = new Map, $71ac433c3918c546$var$Qt = /^&?:(hover|focus|focus-visible|focus-within|active)(?![\w-])/;
function $71ac433c3918c546$var$j(t) {
    return /^@(media|supports|container)\b/.test(t);
}
function $71ac433c3918c546$export$86cca2c9cdf8abd7(t) {
    const e = [];
    let n = 0, o = 0;
    for(let s = 0; s < t.length; s++){
        const r = t.charCodeAt(s);
        r === 40 ? n++ : r === 41 ? n-- : r === 44 && n === 0 && (e.push(t.slice(o, s).trim()), o = s + 1);
    }
    return e.push(t.slice(o).trim()), e;
}
function $71ac433c3918c546$var$te(t) {
    return typeof t != "string" || !t || $71ac433c3918c546$var$j(t) ? !1 : $71ac433c3918c546$export$86cca2c9cdf8abd7(t).every((e)=>$71ac433c3918c546$var$Qt.test(e));
}
const $71ac433c3918c546$var$Tt = (t)=>{
    const e = Object.prototype.toString.call(t);
    return e === "[object Object]" || e === "[object Array]";
}, $71ac433c3918c546$var$it = 32, $71ac433c3918c546$var$lt = 1024;
let $71ac433c3918c546$var$ct = !1;
function $71ac433c3918c546$var$G(t, e, n) {
    if ($71ac433c3918c546$var$ct) return;
    $71ac433c3918c546$var$ct = !0;
    const o = [
        e,
        ...n
    ], s = o.length > 12 ? [
        ...o.slice(0, 6),
        `\u2026${o.length - 9} more\u2026`,
        ...o.slice(-3)
    ] : o;
}
function $71ac433c3918c546$var$ee(t) {
    try {
        return JSON.stringify(t);
    } catch  {
        const n = [];
        let o = 0;
        return JSON.stringify(t, function(s, r) {
            if (!r || typeof r != "object") return r;
            for(; n.length && n[n.length - 1] !== this;)n.pop();
            if (!(n.length && (n.includes(r) || !$71ac433c3918c546$var$Tt(r) || n.length > $71ac433c3918c546$var$it || ++o > $71ac433c3918c546$var$lt))) return n.push(r), r;
        });
    }
}
function $71ac433c3918c546$var$ne(t, e, n, o) {
    const s = $71ac433c3918c546$var$ee(e), r = t.indexOf(":hover") !== -1 || s.indexOf(":hover") !== -1, l = r && $71ac433c3918c546$var$J(), c = (n ? n + "" : "") + t + s + (r && !l ? "rawhover" : "") + (o ? "state" : "");
    let i = $71ac433c3918c546$var$O.get(c);
    if (i) {
        const d = $71ac433c3918c546$var$It.get(i);
        if (d) for(let k = 0; k < d.length; k += 2)$71ac433c3918c546$var$x(d[k], void 0, "atomic", void 0, d[k + 1]);
        return i;
    }
    i = n ? `_${n}_c${$71ac433c3918c546$var$P(c)}` : `_c${$71ac433c3918c546$var$P(c)}`;
    const a = o ? `.${i}.${i}` : `.${i}`, u = $71ac433c3918c546$var$te(t) ? `${a}.${i}` : a;
    let f = "";
    const h = [], p = (d)=>typeof d == "string" && (d.indexOf("{") !== -1 || d.indexOf("}") !== -1), C = new Set;
    let A = 0;
    const $ = (d, k)=>{
        C.add(k);
        let S = "";
        const _ = Object.keys(k);
        for(let m = 0; m < _.length; m++){
            const v = _[m], g = k[v];
            if (g != null) {
                if (typeof g == "object") {
                    const w = [
                        ...d,
                        v
                    ];
                    C.has(g) ? $71ac433c3918c546$var$G("a style value that loops back to one of its own ancestors", t, w) : $71ac433c3918c546$var$Tt(g) ? w.length > $71ac433c3918c546$var$it ? $71ac433c3918c546$var$G(`a style block nested more than ${$71ac433c3918c546$var$it} levels deep`, t, w) : ++A > $71ac433c3918c546$var$lt ? $71ac433c3918c546$var$G(`a style object with more than ${$71ac433c3918c546$var$lt} nested blocks`, t, w) : $(w, g) : $71ac433c3918c546$var$G(`a ${Object.prototype.toString.call(g).slice(8, -1)} (not a style block)`, t, w);
                } else {
                    if (p(g)) continue;
                    S += $71ac433c3918c546$var$E($71ac433c3918c546$export$7996caeb46a3bdf6(v), g);
                }
            }
        }
        C.delete(k), S && (d.length === 0 ? f += S : h.push({
            chain: d,
            body: S
        }));
    };
    $([], e);
    const D = (d)=>d.startsWith(":") || d.startsWith("["), Dt = (d, k = !0)=>{
        const S = k && d.length === 1 ? u : a;
        if (!d.length) return S;
        let _ = $71ac433c3918c546$export$86cca2c9cdf8abd7(d[0]).map((m)=>m.includes("&") ? m.replace(/&/g, S) : D(m) ? `${S}${m}` : `${S} ${m}`);
        for(let m = 1; m < d.length; m++){
            const v = $71ac433c3918c546$export$86cca2c9cdf8abd7(d[m]), g = [];
            for (const w of _)for (const B of v)B.includes("&") ? g.push(B.replace(/&/g, w)) : D(B) ? g.push(w + B) : g.push(w + " " + B);
            _ = g;
        }
        return _.join(", ");
    }, at = [], ft = (d, k)=>{
        const S = d.filter($71ac433c3918c546$var$j), _ = Dt(d.filter((g)=>!$71ac433c3918c546$var$j(g)), S.length === 0);
        let m = `${_}{${k}}`;
        for(let g = S.length - 1; g >= 0; g--)m = `${S[g]}{${m}}`;
        m = $71ac433c3918c546$export$b0de4e5e9a88127b(m, _, l);
        const v = $71ac433c3918c546$var$et(m, void 0, "atomic");
        at.push(m, v), $71ac433c3918c546$var$x(m, void 0, "atomic", void 0, v);
    };
    f && ft([
        t
    ], f);
    for (const d of h)ft([
        t,
        ...d.chain
    ], d.body);
    return $71ac433c3918c546$var$It.set(i, at), $71ac433c3918c546$var$O.set(c, i), i;
}
let $71ac433c3918c546$var$N = null;
function $71ac433c3918c546$export$491a165a24f5745(t) {
    const e = $71ac433c3918c546$var$N, n = [];
    $71ac433c3918c546$var$N = n;
    try {
        t();
    } finally{
        $71ac433c3918c546$var$N = e;
    }
    return n;
}
function $71ac433c3918c546$export$7091046007212466(t) {
    if (!Array.isArray(t)) return;
    $71ac433c3918c546$var$st();
    let e = 0;
    for (const n of t){
        if (!Array.isArray(n) || typeof n[0] != "string") continue;
        const o = n[1] || "global";
        o === "variable" && e++, $71ac433c3918c546$var$x(n[0], void 0, o, void 0, n[2] || void 0);
    }
    e > 0 && $71ac433c3918c546$var$q(e);
}
function $71ac433c3918c546$export$efb9f5caaa2ca0c7(t) {
    if (t == null || typeof t != "string" && typeof t != "object") return;
    if ($71ac433c3918c546$var$st(), typeof t == "string") {
        const r = t.indexOf("--") !== -1;
        $71ac433c3918c546$var$x(t, void 0, r ? "variable" : "global"), r && $71ac433c3918c546$var$q(1);
        return;
    }
    const e = $71ac433c3918c546$var$J();
    let n = 0;
    const o = Object.keys(t), s = (r)=>{
        const l = r.match(/max-width:\s*(\d+)/);
        return l ? parseInt(l[1]) : 0;
    };
    o.sort((r, l)=>{
        const c = r.startsWith("@media"), i = l.startsWith("@media");
        return !c && !i ? 0 : c ? i ? s(l) - s(r) : 1 : -1;
    });
    for (const r of o){
        const l = t[r];
        if (r.startsWith("@keyframes")) {
            const c = $71ac433c3918c546$var$X(l);
            c && $71ac433c3918c546$var$x(`${r}{${c}}`, void 0, "keyframes");
            continue;
        }
        if ($71ac433c3918c546$var$j(r)) for(const c in l){
            const i = l[c];
            if (c.startsWith("@keyframes")) {
                const a = $71ac433c3918c546$var$X(i);
                a && $71ac433c3918c546$var$x(`${r}{${c}{${a}}}`, void 0, "keyframes");
                continue;
            }
            if (typeof i == "object" && i !== null) {
                let a = "", u = 0;
                const f = c.charCodeAt(0) === 64;
                for(const h in i){
                    const p = i[h];
                    p != null && (f && typeof p == "object" || ($71ac433c3918c546$var$I(h) && u++, a += $71ac433c3918c546$var$E($71ac433c3918c546$export$7996caeb46a3bdf6(h), p)));
                }
                f && (a += $71ac433c3918c546$var$St(i)), n += u, $71ac433c3918c546$var$x($71ac433c3918c546$export$b0de4e5e9a88127b(`${r}{${c}{${a}}}`, c, e), void 0, u ? "variable" : "global");
            } else if (i != null) {
                const a = $71ac433c3918c546$var$I(c);
                a && n++, $71ac433c3918c546$var$x(`${r}{${$71ac433c3918c546$var$E($71ac433c3918c546$export$7996caeb46a3bdf6(c), i)}}`, void 0, a ? "variable" : "global");
            }
        }
        else {
            let c = "", i = !1, a = 0;
            const u = r.charCodeAt(0) === 64;
            for(const f in l){
                const h = l[f];
                if (h != null) {
                    if (typeof h == "object") {
                        if (u && $71ac433c3918c546$var$Y(f)) continue;
                        i = !0;
                    } else $71ac433c3918c546$var$I(f) && a++, c += $71ac433c3918c546$var$E($71ac433c3918c546$export$7996caeb46a3bdf6(f), h);
                }
            }
            if (u && (c += $71ac433c3918c546$var$St(l)), n += a, c && $71ac433c3918c546$var$x($71ac433c3918c546$export$b0de4e5e9a88127b(`${r}{${c}}`, r, e), void 0, a ? "variable" : "global"), i) {
                const f = [], h = [];
                for(const p in l)if (typeof l[p] == "object" && l[p] !== null) {
                    if (u && $71ac433c3918c546$var$Y(p)) continue;
                    $71ac433c3918c546$var$j(p) ? f.push(p) : h.push(p);
                }
                f.sort((p, C)=>{
                    const A = ($)=>{
                        const D = $.match(/max-width:\s*(\d+)/);
                        return D ? parseInt(D[1]) : 0;
                    };
                    return A(C) - A(p);
                });
                for (const p of h)$71ac433c3918c546$export$efb9f5caaa2ca0c7({
                    [`${r} ${p}`]: l[p]
                });
                for (const p of f)$71ac433c3918c546$export$efb9f5caaa2ca0c7({
                    [p]: {
                        [r]: l[p]
                    }
                });
            }
        }
    }
    n > 0 && $71ac433c3918c546$var$q(n);
}
function $71ac433c3918c546$export$d25ddfdf17c3ad3e(t, e) {
    return $71ac433c3918c546$var$x(`@keyframes ${t}{${$71ac433c3918c546$var$X(e)}}`, void 0, "keyframes"), t;
}
function $71ac433c3918c546$export$aad8462122ac592b() {
    $71ac433c3918c546$var$O.clear(), $71ac433c3918c546$var$Q.clear(), $71ac433c3918c546$var$ht = null, $71ac433c3918c546$var$ct = !1;
}
function $71ac433c3918c546$export$91630538791620d6() {
    return $71ac433c3918c546$var$O.size;
}

});
parcelRegister("g8ey8", function(module, exports) {

$parcel$export(module.exports, "BUILD_STAMP", () => $bbe8adf0578d3344$export$bde511834fe05dca);
$parcel$export(module.exports, "BUILD_VERSION", () => $bbe8adf0578d3344$export$2db401a6b81eceee);
const $bbe8adf0578d3344$export$bde511834fe05dca = "2026-10-31T04:25:43.046Z";
const $bbe8adf0578d3344$export$2db401a6b81eceee = "3.14.783";

});

parcelRegister("aFJFR", function(module, exports) {

$parcel$export(module.exports, "CSS_SHORTHAND_LONGHANDS", () => $7c5129a51c64c87e$export$957250e5cfab4acc);
$parcel$export(module.exports, "CSS_LONGHAND_SHORTHANDS", () => $7c5129a51c64c87e$export$7f1f6beb13bf1a4d);
$parcel$export(module.exports, "cssShorthandDepth", () => $7c5129a51c64c87e$export$4ca9546c45ad4b90);
$parcel$export(module.exports, "cssShorthandStatesLonghand", () => $7c5129a51c64c87e$export$da574fd15a2c79e3);
$parcel$export(module.exports, "cssShorthandStatesThemeLonghand", () => $7c5129a51c64c87e$export$16aed46cf362f662);
parcelRequire("67GC6");
var $hzNzB = parcelRequire("hzNzB");
const $7c5129a51c64c87e$var$e = (t, o)=>o.split(" ").map((n)=>t + "-" + n), $7c5129a51c64c87e$var$g = "top right bottom left", $7c5129a51c64c87e$var$f = $7c5129a51c64c87e$var$g + " block block-start block-end inline inline-start inline-end", $7c5129a51c64c87e$var$i = "start end", $7c5129a51c64c87e$var$c = "width style color", $7c5129a51c64c87e$var$p = (t)=>$7c5129a51c64c87e$var$e(t, $7c5129a51c64c87e$var$f), $7c5129a51c64c87e$var$O = (()=>{
    const t = $7c5129a51c64c87e$var$e("border", "width style color image");
    for (const o of $7c5129a51c64c87e$var$f.split(" "))t.push("border-" + o, ...$7c5129a51c64c87e$var$e("border-" + o, $7c5129a51c64c87e$var$c));
    return t;
})(), $7c5129a51c64c87e$var$h = (t)=>[
        ...$7c5129a51c64c87e$var$e("border-" + t, $7c5129a51c64c87e$var$c + " start end"),
        ...$7c5129a51c64c87e$var$e("border-" + t + "-start", $7c5129a51c64c87e$var$c),
        ...$7c5129a51c64c87e$var$e("border-" + t + "-end", $7c5129a51c64c87e$var$c)
    ], $7c5129a51c64c87e$export$957250e5cfab4acc = {
    animation: $7c5129a51c64c87e$var$e("animation", "name duration timing-function delay iteration-count direction fill-mode play-state timeline range range-start range-end"),
    background: $7c5129a51c64c87e$var$e("background", "image position position-x position-y size repeat origin clip attachment color"),
    border: $7c5129a51c64c87e$var$O
};
for (const t of [
    "width",
    "style",
    "color"
])$7c5129a51c64c87e$export$957250e5cfab4acc["border-" + t] = $7c5129a51c64c87e$var$f.split(" ").map((o)=>"border-" + o + "-" + t);
for (const t of $7c5129a51c64c87e$var$g.split(" "))$7c5129a51c64c87e$export$957250e5cfab4acc["border-" + t] = $7c5129a51c64c87e$var$e("border-" + t, $7c5129a51c64c87e$var$c);
$7c5129a51c64c87e$export$957250e5cfab4acc["border-block"] = $7c5129a51c64c87e$var$h("block"), $7c5129a51c64c87e$export$957250e5cfab4acc["border-inline"] = $7c5129a51c64c87e$var$h("inline"), Object.assign($7c5129a51c64c87e$export$957250e5cfab4acc, {
    "border-image": $7c5129a51c64c87e$var$e("border-image", "source slice width outset repeat"),
    "border-radius": "top-left top-right bottom-right bottom-left start-start start-end end-start end-end".split(" ").map((t)=>"border-" + t + "-radius"),
    columns: $7c5129a51c64c87e$var$e("column", "width count"),
    "column-rule": $7c5129a51c64c87e$var$e("column-rule", $7c5129a51c64c87e$var$c),
    container: $7c5129a51c64c87e$var$e("container", "name type"),
    "contain-intrinsic-size": $7c5129a51c64c87e$var$e("contain-intrinsic", "width height"),
    flex: $7c5129a51c64c87e$var$e("flex", "grow shrink basis"),
    "flex-flow": $7c5129a51c64c87e$var$e("flex", "direction wrap"),
    font: [
        ...$7c5129a51c64c87e$var$e("font", "style variant weight stretch size"),
        "line-height",
        ...$7c5129a51c64c87e$var$e("font", "family size-adjust kerning feature-settings variation-settings optical-sizing")
    ],
    gap: [
        "row-gap",
        "column-gap"
    ],
    grid: $7c5129a51c64c87e$var$e("grid", "template template-rows template-columns template-areas auto-rows auto-columns auto-flow"),
    "grid-template": $7c5129a51c64c87e$var$e("grid-template", "rows columns areas"),
    "grid-area": $7c5129a51c64c87e$var$e("grid", "row column row-start row-end column-start column-end"),
    "grid-row": $7c5129a51c64c87e$var$e("grid-row", $7c5129a51c64c87e$var$i),
    "grid-column": $7c5129a51c64c87e$var$e("grid-column", $7c5129a51c64c87e$var$i),
    inset: [
        ...$7c5129a51c64c87e$var$g.split(" "),
        ...$7c5129a51c64c87e$var$e("inset", "block block-start block-end inline inline-start inline-end")
    ],
    "inset-block": $7c5129a51c64c87e$var$e("inset-block", $7c5129a51c64c87e$var$i),
    "inset-inline": $7c5129a51c64c87e$var$e("inset-inline", $7c5129a51c64c87e$var$i),
    "list-style": $7c5129a51c64c87e$var$e("list-style", "type position image"),
    margin: $7c5129a51c64c87e$var$p("margin"),
    "margin-block": $7c5129a51c64c87e$var$e("margin-block", $7c5129a51c64c87e$var$i),
    "margin-inline": $7c5129a51c64c87e$var$e("margin-inline", $7c5129a51c64c87e$var$i),
    mask: $7c5129a51c64c87e$var$e("mask", "image mode repeat position clip origin size composite"),
    offset: $7c5129a51c64c87e$var$e("offset", "position path distance rotate anchor"),
    outline: $7c5129a51c64c87e$var$e("outline", $7c5129a51c64c87e$var$c),
    overflow: $7c5129a51c64c87e$var$e("overflow", "x y"),
    "overscroll-behavior": $7c5129a51c64c87e$var$e("overscroll-behavior", "x y"),
    padding: $7c5129a51c64c87e$var$p("padding"),
    "padding-block": $7c5129a51c64c87e$var$e("padding-block", $7c5129a51c64c87e$var$i),
    "padding-inline": $7c5129a51c64c87e$var$e("padding-inline", $7c5129a51c64c87e$var$i)
});
for (const t of [
    "content",
    "items",
    "self"
])$7c5129a51c64c87e$export$957250e5cfab4acc["place-" + t] = [
    "align-" + t,
    "justify-" + t
];
Object.assign($7c5129a51c64c87e$export$957250e5cfab4acc, {
    "scroll-margin": $7c5129a51c64c87e$var$p("scroll-margin"),
    "scroll-padding": $7c5129a51c64c87e$var$p("scroll-padding"),
    "text-decoration": $7c5129a51c64c87e$var$e("text-decoration", "line style color thickness"),
    "text-emphasis": $7c5129a51c64c87e$var$e("text-emphasis", "style color"),
    transition: $7c5129a51c64c87e$var$e("transition", "property duration timing-function delay behavior")
});
const $7c5129a51c64c87e$var$v = "block-start block-end inline-start inline-end".split(" ");
for (const t of $7c5129a51c64c87e$var$v)$7c5129a51c64c87e$export$957250e5cfab4acc["border-" + t] = $7c5129a51c64c87e$var$e("border-" + t, $7c5129a51c64c87e$var$c);
for (const t of [
    "block",
    "inline"
])for (const o of $7c5129a51c64c87e$var$c.split(" "))$7c5129a51c64c87e$export$957250e5cfab4acc["border-" + t + "-" + o] = $7c5129a51c64c87e$var$e("border-" + t, $7c5129a51c64c87e$var$i.split(" ").map((n)=>n + "-" + o).join(" "));
Object.assign($7c5129a51c64c87e$export$957250e5cfab4acc, {
    "animation-range": $7c5129a51c64c87e$var$e("animation-range", $7c5129a51c64c87e$var$i),
    "background-position": $7c5129a51c64c87e$var$e("background-position", "x y"),
    "font-variant": $7c5129a51c64c87e$var$e("font-variant", "alternates caps east-asian emoji ligatures numeric position"),
    "font-synthesis": $7c5129a51c64c87e$var$e("font-synthesis", "weight style small-caps"),
    marker: $7c5129a51c64c87e$var$e("marker", "start mid end"),
    "position-try": $7c5129a51c64c87e$var$e("position-try", "order fallbacks"),
    "scroll-margin-block": $7c5129a51c64c87e$var$e("scroll-margin-block", $7c5129a51c64c87e$var$i),
    "scroll-margin-inline": $7c5129a51c64c87e$var$e("scroll-margin-inline", $7c5129a51c64c87e$var$i),
    "scroll-padding-block": $7c5129a51c64c87e$var$e("scroll-padding-block", $7c5129a51c64c87e$var$i),
    "scroll-padding-inline": $7c5129a51c64c87e$var$e("scroll-padding-inline", $7c5129a51c64c87e$var$i),
    "scroll-timeline": $7c5129a51c64c87e$var$e("scroll-timeline", "name axis"),
    "view-timeline": $7c5129a51c64c87e$var$e("view-timeline", "name axis inset"),
    "text-box": $7c5129a51c64c87e$var$e("text-box", "trim edge"),
    "text-wrap": $7c5129a51c64c87e$var$e("text-wrap", "mode style"),
    "white-space": [
        "white-space-collapse",
        "text-wrap-mode"
    ]
}), $7c5129a51c64c87e$export$957250e5cfab4acc.font.push("font-language-override");
const $7c5129a51c64c87e$var$d = (t)=>"corner-" + t + "-shape";
$7c5129a51c64c87e$export$957250e5cfab4acc["corner-shape"] = [
    ..."top-left top-right bottom-right bottom-left start-start start-end end-start end-end".split(" "),
    ..."top right bottom left block-start block-end inline-start inline-end".split(" ")
].map($7c5129a51c64c87e$var$d), Object.assign($7c5129a51c64c87e$export$957250e5cfab4acc, {
    "corner-top-shape": [
        "top-left",
        "top-right"
    ].map($7c5129a51c64c87e$var$d),
    "corner-right-shape": [
        "top-right",
        "bottom-right"
    ].map($7c5129a51c64c87e$var$d),
    "corner-bottom-shape": [
        "bottom-left",
        "bottom-right"
    ].map($7c5129a51c64c87e$var$d),
    "corner-left-shape": [
        "top-left",
        "bottom-left"
    ].map($7c5129a51c64c87e$var$d),
    "corner-block-start-shape": [
        "start-start",
        "start-end"
    ].map($7c5129a51c64c87e$var$d),
    "corner-block-end-shape": [
        "end-start",
        "end-end"
    ].map($7c5129a51c64c87e$var$d),
    "corner-inline-start-shape": [
        "start-start",
        "end-start"
    ].map($7c5129a51c64c87e$var$d),
    "corner-inline-end-shape": [
        "start-end",
        "end-end"
    ].map($7c5129a51c64c87e$var$d)
});
for(const t in $7c5129a51c64c87e$export$957250e5cfab4acc){
    const o = $7c5129a51c64c87e$export$957250e5cfab4acc[t], n = new Set(o);
    for(let s = 0; s < o.length; s++){
        const a = $7c5129a51c64c87e$export$957250e5cfab4acc[o[s]];
        if (a) for (const l of a)n.has(l) || (n.add(l), o.push(l));
    }
}
const $7c5129a51c64c87e$export$7f1f6beb13bf1a4d = {};
for(const t in $7c5129a51c64c87e$export$957250e5cfab4acc)for (const o of $7c5129a51c64c87e$export$957250e5cfab4acc[t])($7c5129a51c64c87e$export$7f1f6beb13bf1a4d[o] || ($7c5129a51c64c87e$export$7f1f6beb13bf1a4d[o] = [])).push(t);
const $7c5129a51c64c87e$var$u = new Map, $7c5129a51c64c87e$var$w = (t)=>{
    let o = $7c5129a51c64c87e$var$u.get(t);
    if (o !== void 0) return o;
    $7c5129a51c64c87e$var$u.set(t, 0), o = 0;
    const n = $7c5129a51c64c87e$export$7f1f6beb13bf1a4d[t];
    if (n) for(let s = 0; s < n.length; s++)o = Math.max(o, $7c5129a51c64c87e$var$w(n[s]) + 1);
    return $7c5129a51c64c87e$var$u.set(t, o), o;
};
function $7c5129a51c64c87e$export$4ca9546c45ad4b90(t) {
    if (typeof t != "string") return 0;
    const o = t.charCodeAt(0) === 45 && t.charCodeAt(1) !== 45 ? t.replace(/^-(webkit|moz|ms|o)-/, "") : t;
    return Object.prototype.hasOwnProperty.call($7c5129a51c64c87e$export$7f1f6beb13bf1a4d, o) ? $7c5129a51c64c87e$var$w(o) : 0;
}
const $7c5129a51c64c87e$var$E = /^(?:margin|padding|inset|scroll-margin|scroll-padding)(?:-(?:block|inline))?$|^border(?:-(?:block|inline))?-(?:width|style|color)$|^(?:border-radius|corner(?:-[a-z]+)*-shape|gap|overflow|overscroll-behavior|place-(?:content|items|self)|background-position|contain-intrinsic-size)$/, $7c5129a51c64c87e$var$k = /^(?:border(?:-(?:top|right|bottom|left|block|inline)(?:-(?:start|end))?)?|outline|column-rule)$/, $7c5129a51c64c87e$var$L = new Set([
    "none",
    "hidden",
    "dotted",
    "dashed",
    "solid",
    "double",
    "groove",
    "ridge",
    "inset",
    "outset",
    "auto"
]), $7c5129a51c64c87e$var$b = (t)=>(0, $hzNzB.splitTopLevelSpaces)(String(t).replace(/\s*!important\s*$/, ""));
function $7c5129a51c64c87e$export$da574fd15a2c79e3(t, o, n) {
    const s = $7c5129a51c64c87e$export$957250e5cfab4acc[t];
    if (!s || s.indexOf(n) === -1) return !1;
    if ($7c5129a51c64c87e$var$E.test(t)) return !0;
    if (!$7c5129a51c64c87e$var$k.test(t) || typeof o == "function" || o == null || n.indexOf("border-image") === 0) return !1;
    const a = $7c5129a51c64c87e$var$b(o);
    return a.length >= 3 ? !0 : /-style$/.test(n) && a.some((l)=>$7c5129a51c64c87e$var$L.has(l.toLowerCase()));
}
const $7c5129a51c64c87e$var$C = new Set([
    "thin",
    "medium",
    "thick"
]), $7c5129a51c64c87e$var$D = (t)=>/^[+-]?\.?\d/.test(t) || $7c5129a51c64c87e$var$C.has(t.toLowerCase()) || /^(?:calc|min|max|clamp)\(/i.test(t) || /^var\(--(?:[a-zA-Z0-9]{1,6}-)?spacing-/.test(t), $7c5129a51c64c87e$var$N = (t)=>t === "transparent" || t === "currentcolor" || Object.prototype.hasOwnProperty.call((0, $hzNzB.CSS_NAMED_COLOR_HEX), t), $7c5129a51c64c87e$var$A = (t)=>(0, $hzNzB.isNativeColorToken)(t) || /^var\(--(?:(?!theme-|shadow-)[a-zA-Z0-9]{1,6}-)?color-/.test(t) || $7c5129a51c64c87e$var$N(t.toLowerCase()), $7c5129a51c64c87e$var$R = /-(width|style|color)$/;
function $7c5129a51c64c87e$export$16aed46cf362f662(t, o, n) {
    if ($7c5129a51c64c87e$export$da574fd15a2c79e3(t, o, n)) return !0;
    const s = $7c5129a51c64c87e$export$957250e5cfab4acc[t];
    if (!s || s.indexOf(n) === -1 || typeof o == "function" || o == null) return !1;
    if ($7c5129a51c64c87e$var$k.test(t)) {
        if (n.indexOf("border-image") === 0) return !1;
        const a = $7c5129a51c64c87e$var$R.exec(n);
        if (!a) return !1;
        const l = $7c5129a51c64c87e$var$b(o);
        return l.length === 1 && /^(?:0|none)$/i.test(l[0]) ? a[1] !== "color" : a[1] === "width" && l.some($7c5129a51c64c87e$var$D);
    }
    if (t === "background" && n === "background-color") {
        const a = $7c5129a51c64c87e$var$b(o);
        return a.length === 1 && $7c5129a51c64c87e$var$A(a[0]);
    }
    return !1;
}

});





parcelRegister("ld662", function(module, exports) {

$parcel$export(module.exports, "BLOCK_PROPS", () => $f70f8a82ab17bdff$export$d8a4821b5338da9d);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
parcelRequire("67GC6");
var $amsMb = parcelRequire("amsMb");
var $hzNzB = parcelRequire("hzNzB");
var $2iwMe = parcelRequire("2iwMe");
const $f70f8a82ab17bdff$var$s = (i, n, t)=>{
    if (typeof n == "number" && (n = String(n)), !(0, $czfS0.isString)(n)) return;
    const [a, c] = (0, $hzNzB.splitTopLevelSpaces)(n);
    return {
        ...(0, $2iwMe.transformSizeRatio)(i + "Start", a, t),
        ...(0, $2iwMe.transformSizeRatio)(i + "End", c || a, t)
    };
}, $f70f8a82ab17bdff$export$d8a4821b5338da9d = {
    show: (i)=>i ? void 0 : {
            display: "none !important"
        },
    hide: (i)=>i ? {
            display: "none !important"
        } : void 0,
    height: (i, n)=>(0, $2iwMe.transformSizeRatio)("height", i, n),
    width: (i, n)=>(0, $2iwMe.transformSizeRatio)("width", i, n),
    boxSizing: (i)=>(0, $czfS0.isUndefined)(i) ? {
            boxSizing: "border-box"
        } : {
            boxSizing: i
        },
    boxSize: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("height", n),
            ...(0, $2iwMe.transformSize)("width", t || n)
        };
    },
    inlineSize: (i, n)=>(0, $2iwMe.transformSizeRatio)("inlineSize", i, n),
    blockSize: (i, n)=>(0, $2iwMe.transformSizeRatio)("blockSize", i, n),
    minWidth: (i, n)=>(0, $2iwMe.transformSizeRatio)("minWidth", i, n),
    maxWidth: (i, n)=>(0, $2iwMe.transformSizeRatio)("maxWidth", i, n),
    widthRange: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("minWidth", n),
            ...(0, $2iwMe.transformSize)("maxWidth", t || n)
        };
    },
    minHeight: (i, n)=>(0, $2iwMe.transformSizeRatio)("minHeight", i, n),
    maxHeight: (i, n)=>(0, $2iwMe.transformSizeRatio)("maxHeight", i, n),
    heightRange: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("minHeight", n),
            ...(0, $2iwMe.transformSize)("maxHeight", t || n)
        };
    },
    size: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSizeRatio)("inlineSize", n),
            ...(0, $2iwMe.transformSizeRatio)("blockSize", t || n)
        };
    },
    minBlockSize: (i, n)=>(0, $2iwMe.transformSizeRatio)("minBlockSize", i, n),
    minInlineSize: (i, n)=>(0, $2iwMe.transformSizeRatio)("minInlineSize", i, n),
    maxBlockSize: (i, n)=>(0, $2iwMe.transformSizeRatio)("maxBlockSize", i, n),
    maxInlineSize: (i, n)=>(0, $2iwMe.transformSizeRatio)("maxInlineSize", i, n),
    minSize: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("minInlineSize", n),
            ...(0, $2iwMe.transformSize)("minBlockSize", t || n)
        };
    },
    maxSize: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("maxInlineSize", n),
            ...(0, $2iwMe.transformSize)("maxBlockSize", t || n)
        };
    },
    borderWidth: (i, n)=>(0, $2iwMe.transformSizeRatio)("borderWidth", i, n),
    borderTopWidth: (i, n)=>(0, $2iwMe.transformSizeRatio)("borderTopWidth", i, n),
    borderRightWidth: (i, n)=>(0, $2iwMe.transformSizeRatio)("borderRightWidth", i, n),
    borderBottomWidth: (i, n)=>(0, $2iwMe.transformSizeRatio)("borderBottomWidth", i, n),
    borderLeftWidth: (i, n)=>(0, $2iwMe.transformSizeRatio)("borderLeftWidth", i, n),
    textDecorationThickness: (i, n)=>(0, $2iwMe.transformSizeRatio)("textDecorationThickness", i, n),
    textUnderlineOffset: (i, n)=>(0, $2iwMe.transformSizeRatio)("textUnderlineOffset", i, n),
    padding: (i, n)=>(0, $2iwMe.transformSizeRatio)("padding", i, n),
    paddingInline: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("paddingInlineStart", n),
            ...(0, $2iwMe.transformSize)("paddingInlineEnd", t || n)
        };
    },
    paddingBlock: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("paddingBlockStart", n),
            ...(0, $2iwMe.transformSize)("paddingBlockEnd", t || n)
        };
    },
    paddingTop: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingBlockStart", i, n),
    paddingBottom: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingBlockEnd", i, n),
    paddingLeft: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingInlineStart", i, n),
    paddingRight: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingInlineEnd", i, n),
    paddingBlockStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingBlockStart", i, n),
    paddingBlockEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingBlockEnd", i, n),
    paddingInlineStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingInlineStart", i, n),
    paddingInlineEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("paddingInlineEnd", i, n),
    margin: (i, n)=>(0, $2iwMe.transformSizeRatio)("margin", i, n),
    marginInline: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("marginInlineStart", n),
            ...(0, $2iwMe.transformSize)("marginInlineEnd", t || n)
        };
    },
    marginBlock: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = (0, $hzNzB.splitTopLevelSpaces)(i);
        return {
            ...(0, $2iwMe.transformSize)("marginBlockStart", n),
            ...(0, $2iwMe.transformSize)("marginBlockEnd", t || n)
        };
    },
    marginTop: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginBlockStart", i, n),
    marginBottom: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginBlockEnd", i, n),
    marginLeft: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginInlineStart", i, n),
    marginRight: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginInlineEnd", i, n),
    marginInlineStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginInlineStart", i, n),
    marginInlineEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginInlineEnd", i, n),
    marginBlockStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginBlockStart", i, n),
    marginBlockEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("marginBlockEnd", i, n),
    scrollMargin: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMargin", i, n),
    scrollMarginTop: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginTop", i, n),
    scrollMarginRight: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginRight", i, n),
    scrollMarginBottom: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginBottom", i, n),
    scrollMarginLeft: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginLeft", i, n),
    scrollMarginBlock: (i, n)=>$f70f8a82ab17bdff$var$s("scrollMarginBlock", i, n),
    scrollMarginInline: (i, n)=>$f70f8a82ab17bdff$var$s("scrollMarginInline", i, n),
    scrollMarginBlockStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginBlockStart", i, n),
    scrollMarginBlockEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginBlockEnd", i, n),
    scrollMarginInlineStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginInlineStart", i, n),
    scrollMarginInlineEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollMarginInlineEnd", i, n),
    scrollPadding: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPadding", i, n),
    scrollPaddingTop: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingTop", i, n),
    scrollPaddingRight: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingRight", i, n),
    scrollPaddingBottom: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingBottom", i, n),
    scrollPaddingLeft: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingLeft", i, n),
    scrollPaddingBlock: (i, n)=>$f70f8a82ab17bdff$var$s("scrollPaddingBlock", i, n),
    scrollPaddingInline: (i, n)=>$f70f8a82ab17bdff$var$s("scrollPaddingInline", i, n),
    scrollPaddingBlockStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingBlockStart", i, n),
    scrollPaddingBlockEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingBlockEnd", i, n),
    scrollPaddingInlineStart: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingInlineStart", i, n),
    scrollPaddingInlineEnd: (i, n)=>(0, $2iwMe.transformSizeRatio)("scrollPaddingInlineEnd", i, n),
    gap: (i)=>({
            gap: (0, $2iwMe.transfromGap)(i)
        }),
    columnGap: (i, n)=>(0, $amsMb.getSpacingBasedOnRatio)(n, "columnGap", i),
    rowGap: (i, n)=>(0, $amsMb.getSpacingBasedOnRatio)(n, "rowGap", i),
    flexWrap: (i)=>{
        if (i != null) return {
            display: "flex",
            flexWrap: i
        };
    },
    flexFlow: (i, n)=>{
        const t = n.reverse;
        if (!(0, $czfS0.isString)(i)) return;
        let [a, c] = (i || "row").split(" ");
        return (i.startsWith("x") || i === "row") && (a = "row"), (i.startsWith("y") || i === "column") && (a = "column"), {
            display: "flex",
            flexFlow: (a || "") + (!a.includes("-reverse") && t ? "-reverse" : "") + " " + (c || "")
        };
    },
    flexAlign: (i)=>{
        if (!(0, $czfS0.isString)(i)) return;
        const [n, t] = i.split(" ");
        return {
            display: "flex",
            alignItems: n,
            justifyContent: t
        };
    },
    round: (i, n)=>(0, $2iwMe.transformBorderRadius)(i ?? n.borderRadius, n, "round"),
    borderRadius: (i, n)=>(0, $2iwMe.transformBorderRadius)(i ?? n.round, n, "borderRadius"),
    borderTopLeftRadius: (i, n)=>(0, $2iwMe.transformBorderRadius)(i, n, "borderTopLeftRadius", "borderTopLeftRadius"),
    borderTopRightRadius: (i, n)=>(0, $2iwMe.transformBorderRadius)(i, n, "borderTopRightRadius", "borderTopRightRadius"),
    borderBottomLeftRadius: (i, n)=>(0, $2iwMe.transformBorderRadius)(i, n, "borderBottomLeftRadius", "borderBottomLeftRadius"),
    borderBottomRightRadius: (i, n)=>(0, $2iwMe.transformBorderRadius)(i, n, "borderBottomRightRadius", "borderBottomRightRadius"),
    backgroundSize: (i, n)=>({
            backgroundSize: (0, $2iwMe.transformTilingValue)(i, "backgroundSize", (0, $2iwMe.TILING_SIZE_KEYWORDS), n)
        }),
    backgroundPosition: (i, n)=>({
            backgroundPosition: (0, $2iwMe.transformTilingValue)(i, "backgroundPosition", (0, $2iwMe.TILING_POSITION_KEYWORDS), n)
        }),
    maskSize: (i, n)=>({
            maskSize: (0, $2iwMe.transformTilingValue)(i, "maskSize", (0, $2iwMe.TILING_SIZE_KEYWORDS), n)
        }),
    maskPosition: (i, n)=>({
            maskPosition: (0, $2iwMe.transformTilingValue)(i, "maskPosition", (0, $2iwMe.TILING_POSITION_KEYWORDS), n)
        })
};

});

parcelRegister("6L10a", function(module, exports) {

$parcel$export(module.exports, "FONT_PROPS", () => $4eb7e8cd2602900c$export$e6c8c930b1cd765);
parcelRequire("67GC6");
var $amQH3 = parcelRequire("amQH3");
var $13hKf = parcelRequire("13hKf");
const $4eb7e8cd2602900c$export$e6c8c930b1cd765 = {
    fontSize: (t)=>(0, $13hKf.getFontSizeByKey)(t) || t,
    fontFamily: (t)=>({
            fontFamily: (0, $amQH3.getFontFamily)(t) || t
        }),
    fontWeight: (t)=>({
            fontWeight: t,
            fontVariationSettings: '"wght" ' + t
        }),
    lineClamp: (t)=>{
        if (t != null) return t === "none" ? {
            WebkitLineClamp: "none",
            lineClamp: "none"
        } : {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: String(t),
            lineClamp: String(t),
            overflow: "hidden"
        };
    }
};

});

parcelRegister("d2JON", function(module, exports) {

$parcel$export(module.exports, "MISC_PROPS", () => $97ef00cd09ccd58f$export$24dfac4a0da20903);
const $97ef00cd09ccd58f$export$24dfac4a0da20903 = {
    overflow: (n)=>({
            overflow: n
        }),
    cursor: (n, e, r, s)=>{
        if (!n) return;
        const t = s.assets && s.assets[n];
        if (t && t.content) n = `url(${t.content.src})`;
        else {
            const i = s.files && s.files[n];
            i && i.content && (n = `url(${i.content.src})`);
        }
        return {
            cursor: n
        };
    },
    opacity: (n)=>n != null ? {
            opacity: String(n)
        } : void 0,
    visibility: (n)=>n != null ? {
            visibility: n
        } : void 0,
    pointerEvents: (n)=>n != null ? {
            pointerEvents: n
        } : void 0
};

});

parcelRegister("hfQig", function(module, exports) {

$parcel$export(module.exports, "POSITION_PROPS", () => $c8fc66cca2054ff2$export$c0036cbb5416e2bc);
parcelRequire("67GC6");
var $amsMb = parcelRequire("amsMb");
var $hzNzB = parcelRequire("hzNzB");
const $c8fc66cca2054ff2$export$c0036cbb5416e2bc = {
    inset: (t, r)=>{
        if (r.call("isNumber", t)) return {
            inset: t
        };
        if (r.call("isString", t)) return {
            inset: (0, $hzNzB.splitTopLevelSpaces)(t).map((i)=>(0, $amsMb.getSpacingByKey)(i, "k").k).join(" ")
        };
    },
    left: (t)=>(0, $amsMb.getSpacingByKey)(t, "left"),
    top: (t)=>(0, $amsMb.getSpacingByKey)(t, "top"),
    right: (t)=>(0, $amsMb.getSpacingByKey)(t, "right"),
    bottom: (t)=>(0, $amsMb.getSpacingByKey)(t, "bottom"),
    verticalInset: (t)=>{
        if (typeof t != "string") return;
        const r = (0, $hzNzB.splitTopLevelSpaces)(t).map((i)=>(0, $amsMb.getSpacingByKey)(i, "k").k);
        return {
            top: r[0],
            bottom: r[1] || r[0]
        };
    },
    horizontalInset: (t)=>{
        if (typeof t != "string") return;
        const r = (0, $hzNzB.splitTopLevelSpaces)(t).map((i)=>(0, $amsMb.getSpacingByKey)(i, "k").k);
        return {
            left: r[0],
            right: r[1] || r[0]
        };
    }
};

});

parcelRegister("j2Odm", function(module, exports) {

$parcel$export(module.exports, "pushStaticCssPass", () => $ddd527c6c2f81dd0$export$32900a431fddb8aa);
$parcel$export(module.exports, "popStaticCssPass", () => $ddd527c6c2f81dd0$export$4b264036c561442a);
$parcel$export(module.exports, "THEME_PROPS", () => $ddd527c6c2f81dd0$export$11ce017e3ee09814);
parcelRequire("67GC6");
var $521xJ = parcelRequire("521xJ");
var $5koEk = parcelRequire("5koEk");
var $habKp = parcelRequire("habKp");
var $2iwMe = parcelRequire("2iwMe");
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
let $ddd527c6c2f81dd0$var$m = 0;
const $ddd527c6c2f81dd0$export$32900a431fddb8aa = ()=>{
    $ddd527c6c2f81dd0$var$m++;
}, $ddd527c6c2f81dd0$export$4b264036c561442a = ()=>{
    $ddd527c6c2f81dd0$var$m > 0 && $ddd527c6c2f81dd0$var$m--;
}, $ddd527c6c2f81dd0$export$f12bbb197a836138 = ({ context: o, state: r })=>{
    const t = o?.designSystem, e = r?.root?.globalTheme || t?.globalTheme;
    return e && e !== "auto" ? e : $ddd527c6c2f81dd0$var$m > 0 ? null : t && t.resolvedTheme || null;
}, $ddd527c6c2f81dd0$var$n = (o, r)=>{
    if (r == null || r === "") return;
    if (!(0, $czfS0.isObject)(r)) return {
        [o]: r
    };
    const t = {};
    let e = !1;
    for(const u in r){
        const i = r[u];
        if (!(i == null || i === "")) {
            if ((0, $czfS0.isObject)(i)) {
                const d = $ddd527c6c2f81dd0$var$n(o, i);
                d && (t[u] = d, e = !0);
                continue;
            }
            t[u] = {
                [o]: i
            }, e = !0;
        }
    }
    return e ? t : void 0;
}, $ddd527c6c2f81dd0$var$T = (o)=>{
    const r = {};
    for(const t in o){
        const e = o[t];
        r[t] = (0, $czfS0.isObject)(e) ? $ddd527c6c2f81dd0$var$T(e) : (0, $czfS0.isString)(e) ? e + " !important" : e;
    }
    return r;
}, $ddd527c6c2f81dd0$var$l = (o)=>(r, t)=>{
        const e = t && (0, $czfS0.isString)(r) && !(0, $521xJ.getActiveConfig)().useVariable, u = (0, $2iwMe.transformBorder)(r, e ? $ddd527c6c2f81dd0$export$f12bbb197a836138(t) : null);
        return (0, $czfS0.isObject)(u) ? $ddd527c6c2f81dd0$var$n(o, u) : {
            [o]: u
        };
    }, $ddd527c6c2f81dd0$export$11ce017e3ee09814 = {
    theme: (o, r)=>{
        if (o) return r.themeModifier ? (0, $habKp.getMediaTheme)(o, `@${r.themeModifier}`) : (0, $habKp.getMediaTheme)(o);
    },
    color: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("color", (0, $5koEk.getMediaColor)(o, t));
    },
    background: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return (0, $czfS0.isString)(o) && o.includes("gradient") && o.includes("(") ? {
            background: (0, $5koEk.resolveColorsInGradient)(o, t)
        } : $ddd527c6c2f81dd0$var$n("background", (0, $5koEk.getMediaColor)(o, t));
    },
    backgroundColor: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("backgroundColor", (0, $5koEk.getMediaColor)(o, t));
    },
    backgroundImage: (o, r, t, e)=>{
        const u = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (!o) return;
        const i = e.assets && e.assets[o];
        if (i && i.content) o = i.content.src;
        else {
            const d = e.files && e.files[o];
            d && d.content && (o = d.content.src);
        }
        return $ddd527c6c2f81dd0$var$n("backgroundImage", (0, $2iwMe.transformBackgroundImage)(o, u));
    },
    textStroke: (o)=>{
        const r = (0, $2iwMe.transformTextStroke)(o);
        if (r != null) return {
            WebkitTextStroke: r
        };
    },
    outline: $ddd527c6c2f81dd0$var$l("outline"),
    outlineWidth: (o, r)=>(0, $2iwMe.transformSizeRatio)("outlineWidth", o, r),
    outlineColor: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("outlineColor", (0, $5koEk.getMediaColor)(o, t));
    },
    outlineOffset: (o, r)=>(0, $2iwMe.transformSizeRatio)("outlineOffset", o, r),
    border: $ddd527c6c2f81dd0$var$l("border"),
    borderColor: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("borderColor", (0, $5koEk.getMediaColor)(o, t));
    },
    borderTopColor: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("borderTopColor", (0, $5koEk.getMediaColor)(o, t));
    },
    borderBottomColor: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("borderBottomColor", (0, $5koEk.getMediaColor)(o, t));
    },
    borderLeftColor: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("borderLeftColor", (0, $5koEk.getMediaColor)(o, t));
    },
    borderRightColor: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("borderRightColor", (0, $5koEk.getMediaColor)(o, t));
    },
    borderLeft: $ddd527c6c2f81dd0$var$l("borderLeft"),
    borderTop: $ddd527c6c2f81dd0$var$l("borderTop"),
    borderRight: $ddd527c6c2f81dd0$var$l("borderRight"),
    borderBottom: $ddd527c6c2f81dd0$var$l("borderBottom"),
    shadow: (o, r)=>{
        const t = $ddd527c6c2f81dd0$export$f12bbb197a836138(r);
        if (o) return $ddd527c6c2f81dd0$var$n("boxShadow", (0, $2iwMe.transformShadow)(o, t));
    },
    boxShadow: (o, r)=>{
        if (!(0, $czfS0.isString)(o)) return;
        const [t, e] = o.split("!importan"), u = $ddd527c6c2f81dd0$export$f12bbb197a836138(r), i = e ? " !important" : "", d = (0, $2iwMe.transformBoxShadow)(t.trim(), u);
        return (0, $czfS0.isString)(d) ? {
            boxShadow: d + i
        } : $ddd527c6c2f81dd0$var$n("boxShadow", i ? $ddd527c6c2f81dd0$var$T(d) : d);
    },
    textShadow: (o, r)=>$ddd527c6c2f81dd0$var$n("textShadow", (0, $2iwMe.transformBoxShadow)(o, r ? $ddd527c6c2f81dd0$export$f12bbb197a836138(r) : null)),
    columnRule: $ddd527c6c2f81dd0$var$l("columnRule")
};

});

parcelRegister("5ATG6", function(module, exports) {

$parcel$export(module.exports, "TIMING_PROPS", () => $412b810fd3c5f347$export$801d104720a35e80);
parcelRequire("67GC6");
var $ZN2Fd = parcelRequire("ZN2Fd");
var $2iwMe = parcelRequire("2iwMe");
const $412b810fd3c5f347$export$801d104720a35e80 = {
    transition: (n)=>{
        const t = (0, $2iwMe.splitTransition)(n);
        if (t != null) return {
            transition: t
        };
    },
    transitionDuration: (n)=>({
            transitionDuration: (0, $2iwMe.transformDuration)(n)
        }),
    transitionDelay: (n)=>({
            transitionDelay: (0, $2iwMe.transformDuration)(n)
        }),
    transitionTimingFunction: (n)=>({
            transitionTimingFunction: (0, $ZN2Fd.getTimingFunction)(n)
        }),
    transitionProperty: (n)=>({
            transitionProperty: n,
            willChange: n
        })
};

});

parcelRegister("1wHSA", function(module, exports) {

$parcel$export(module.exports, "FLEX_PROPS", () => $11cad12090063481$export$736b75ae6a344b36);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
const $11cad12090063481$export$736b75ae6a344b36 = {
    flow: (r, e)=>{
        const i = e.reverse;
        if (!(0, $czfS0.isString)(r)) return;
        let [t, n] = (r || "row").split(" ");
        return (r.startsWith("x") || r === "row") && (t = "row"), (r.startsWith("y") || r === "column") && (t = "column"), {
            display: "flex",
            flexFlow: (t || "") + (!t.includes("-reverse") && i ? "-reverse" : "") + " " + (n || "")
        };
    },
    wrap: (r, e)=>{
        if (r != null) return {
            display: "flex",
            flexWrap: r
        };
    },
    align: (r, e)=>{
        if (!(0, $czfS0.isString)(r)) return;
        const [i, t] = r.split(" ");
        return {
            display: "flex",
            alignItems: i,
            justifyContent: t
        };
    }
};

});

parcelRegister("9CCRp", function(module, exports) {

$parcel$export(module.exports, "GRID_PROPS", () => $7015ce8fcac3e6a4$export$e33f615210a2138f);
parcelRequire("byww3");
var $czfS0 = parcelRequire("czfS0");
parcelRequire("67GC6");
var $521xJ = parcelRequire("521xJ");
var $2iwMe = parcelRequire("2iwMe");
const $7015ce8fcac3e6a4$var$u = /(^|[^\w.-])([A-Za-z_][\w-]*)/g, $7015ce8fcac3e6a4$export$a784cc36cc19655b = (t)=>{
    if (!(0, $czfS0.isString)(t)) return t;
    const e = (0, $521xJ.getActiveConfig)().sizes;
    return e ? t.replace($7015ce8fcac3e6a4$var$u, (s, i, m)=>{
        const o = e[m];
        return o == null ? s : i + String(o);
    }) : t;
}, $7015ce8fcac3e6a4$var$r = (t)=>$7015ce8fcac3e6a4$export$a784cc36cc19655b((0, $2iwMe.transformGridTemplate)(t)), $7015ce8fcac3e6a4$export$e33f615210a2138f = {
    gridTemplateColumns: (t)=>({
            gridTemplateColumns: $7015ce8fcac3e6a4$var$r(t)
        }),
    gridTemplateRows: (t)=>({
            gridTemplateRows: $7015ce8fcac3e6a4$var$r(t)
        }),
    gridAutoColumns: (t)=>({
            gridAutoColumns: $7015ce8fcac3e6a4$var$r(t)
        }),
    gridAutoRows: (t)=>({
            gridAutoRows: $7015ce8fcac3e6a4$var$r(t)
        }),
    area: (t)=>({
            gridArea: t
        }),
    template: (t)=>({
            gridTemplate: t
        }),
    templateAreas: (t)=>({
            gridTemplateAreas: t
        }),
    column: (t)=>({
            gridColumn: t
        }),
    columns: (t)=>({
            gridTemplateColumns: $7015ce8fcac3e6a4$var$r(t)
        }),
    templateColumns: (t)=>({
            gridTemplateColumns: $7015ce8fcac3e6a4$var$r(t)
        }),
    autoColumns: (t)=>({
            gridAutoColumns: $7015ce8fcac3e6a4$var$r(t)
        }),
    columnStart: (t)=>({
            gridColumnStart: t
        }),
    row: (t)=>({
            gridRow: t
        }),
    rows: (t)=>({
            gridTemplateRows: $7015ce8fcac3e6a4$var$r(t)
        }),
    templateRows: (t)=>({
            gridTemplateRows: $7015ce8fcac3e6a4$var$r(t)
        }),
    autoRows: (t)=>({
            gridAutoRows: $7015ce8fcac3e6a4$var$r(t)
        }),
    rowStart: (t)=>({
            gridRowStart: t
        }),
    autoFlow: (t)=>({
            gridAutoFlow: t
        })
};

});

parcelRegister("9aRcW", function(module, exports) {

$parcel$export(module.exports, "breakpointsContainerName", () => $6ade5230366a4c00$export$4f53ddbe45629560);
$parcel$export(module.exports, "containerBreakpointQuery", () => $6ade5230366a4c00$export$95f3678981a8300c);
$parcel$export(module.exports, "BREAKPOINT_PROPS", () => $6ade5230366a4c00$export$2d068f12642b2579);
const $6ade5230366a4c00$export$137f04f0750f234e = "breakpoints", $6ade5230366a4c00$var$l = new Set([
    "window",
    "media"
]), $6ade5230366a4c00$var$s = /^-?[A-Za-z_][\w-]*$/, $6ade5230366a4c00$var$c = new Set([
    "none",
    "and",
    "or",
    "not",
    "initial",
    "inherit",
    "unset",
    "revert",
    "revert-layer",
    "default"
]), $6ade5230366a4c00$var$u = (r)=>{
    const t = r && r.containerName;
    if (typeof t != "string") return null;
    const n = t.trim().split(/\s+/)[0];
    return n && $6ade5230366a4c00$var$s.test(n) && !$6ade5230366a4c00$var$c.has(n) ? n : null;
}, $6ade5230366a4c00$export$4f53ddbe45629560 = (r, t)=>{
    if (typeof r == "function") try {
        r = r(t, t && t.state, t && t.context);
    } catch  {
        return null;
    }
    if (typeof r != "string") return null;
    const n = r.trim();
    return !n || $6ade5230366a4c00$var$l.has(n) ? null : n === "container" ? $6ade5230366a4c00$var$u(t) || $6ade5230366a4c00$export$137f04f0750f234e : $6ade5230366a4c00$var$s.test(n) && !$6ade5230366a4c00$var$c.has(n) ? n : null;
}, $6ade5230366a4c00$var$p = /^@media\s+/i, $6ade5230366a4c00$var$E = /^(?:only\s+)?(?:screen|all)\s+and\s+/i, $6ade5230366a4c00$var$d = /(?:^|[^\w-])(?:(?:min|max)-)?(?:width|inline-size)(?![\w-])/i, $6ade5230366a4c00$var$_ = /height|block-size|aspect-ratio|orientation|device-|resolution/i, $6ade5230366a4c00$export$95f3678981a8300c = (r)=>{
    if (typeof r != "string") return null;
    let t = r.trim().replace($6ade5230366a4c00$var$p, "").replace($6ade5230366a4c00$var$E, "").trim();
    if (!t || t.indexOf(",") !== -1) return null;
    const n = t.split(/\s+(?:and|or)\s+/i);
    for (const e of n){
        const i = e.trim();
        if (i.charCodeAt(0) !== 40 || i.charCodeAt(i.length - 1) !== 41) return null;
        const o = i.slice(1, -1);
        if (o.indexOf("(") !== -1 || o.indexOf(")") !== -1 || !$6ade5230366a4c00$var$d.test(o) || $6ade5230366a4c00$var$_.test(o)) return null;
    }
    return t;
}, $6ade5230366a4c00$export$2d068f12642b2579 = {
    breakpointsFrom: (r, t)=>{
        const n = $6ade5230366a4c00$export$4f53ddbe45629560(r, t);
        if (!n) return;
        const e = {}, i = t && t.container != null;
        return !i && (!t || t.containerType == null) && (e.containerType = "inline-size"), !i && (!t || t.containerName == null) && (e.containerName = n), e;
    }
};

});

parcelRegister("kaMEs", function(module, exports) {

$parcel$export(module.exports, "CSS_PROP_WRITES", () => $eafa7b06c544ed72$export$3538fe51123590b7);
const $eafa7b06c544ed72$export$3538fe51123590b7 = {
    show: [
        "display"
    ],
    hide: [
        "display"
    ],
    boxSize: [
        "height",
        "width"
    ],
    widthRange: [
        "minWidth",
        "maxWidth"
    ],
    heightRange: [
        "minHeight",
        "maxHeight"
    ],
    size: [
        "inlineSize",
        "blockSize"
    ],
    minSize: [
        "minInlineSize",
        "minBlockSize"
    ],
    maxSize: [
        "maxInlineSize",
        "maxBlockSize"
    ],
    marginTop: [
        "marginBlockStart"
    ],
    marginBottom: [
        "marginBlockEnd"
    ],
    marginLeft: [
        "marginInlineStart"
    ],
    marginRight: [
        "marginInlineEnd"
    ],
    paddingTop: [
        "paddingBlockStart"
    ],
    paddingBottom: [
        "paddingBlockEnd"
    ],
    paddingLeft: [
        "paddingInlineStart"
    ],
    paddingRight: [
        "paddingInlineEnd"
    ],
    flexWrap: [
        "display",
        "flexWrap"
    ],
    flexFlow: [
        "display",
        "flexFlow"
    ],
    flexAlign: [
        "display",
        "alignItems",
        "justifyContent"
    ],
    round: [
        "borderRadius"
    ],
    flow: [
        "display",
        "flexFlow"
    ],
    wrap: [
        "display",
        "flexWrap"
    ],
    align: [
        "display",
        "alignItems",
        "justifyContent"
    ],
    fontWeight: [
        "fontWeight",
        "fontVariationSettings"
    ],
    lineClamp: [
        "display",
        "WebkitBoxOrient",
        "WebkitLineClamp",
        "lineClamp",
        "overflow"
    ],
    transitionProperty: [
        "transitionProperty",
        "willChange"
    ],
    area: [
        "gridArea"
    ],
    template: [
        "gridTemplate"
    ],
    templateAreas: [
        "gridTemplateAreas"
    ],
    column: [
        "gridColumn"
    ],
    columns: [
        "gridTemplateColumns"
    ],
    templateColumns: [
        "gridTemplateColumns"
    ],
    autoColumns: [
        "gridAutoColumns"
    ],
    columnStart: [
        "gridColumnStart"
    ],
    row: [
        "gridRow"
    ],
    rows: [
        "gridTemplateRows"
    ],
    templateRows: [
        "gridTemplateRows"
    ],
    autoRows: [
        "gridAutoRows"
    ],
    rowStart: [
        "gridRowStart"
    ],
    autoFlow: [
        "gridAutoFlow"
    ],
    verticalInset: [
        "top",
        "bottom"
    ],
    horizontalInset: [
        "left",
        "right"
    ],
    shadow: [
        "boxShadow"
    ],
    textStroke: [
        "WebkitTextStroke"
    ],
    breakpointsFrom: [
        "containerType",
        "containerName"
    ]
};

});


parcelRegister("4XTEI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CSS_PROPERTIES_LIST", () => $39d7d82e81b3c1a7$export$33f20e95f48422c);
const $39d7d82e81b3c1a7$export$33f20e95f48422c = new Set([
    "accentColor",
    "alignContent",
    "alignItems",
    "alignSelf",
    "alignmentBaseline",
    "all",
    "anchorName",
    "anchorScope",
    "animation",
    "animationDelay",
    "animationDirection",
    "animationDuration",
    "animationFillMode",
    "animationIterationCount",
    "animationName",
    "animationPlayState",
    "animationRange",
    "animationRangeEnd",
    "animationRangeStart",
    "animationTimeline",
    "animationTimingFunction",
    "appearance",
    "aspectRatio",
    "backdropFilter",
    "backfaceVisibility",
    "background",
    "backgroundAttachment",
    "backgroundBlendMode",
    "backgroundClip",
    "backgroundColor",
    "backgroundImage",
    "backgroundOrigin",
    "backgroundPosition",
    "backgroundPositionX",
    "backgroundPositionY",
    "backgroundRepeat",
    "backgroundRepeatX",
    "backgroundRepeatY",
    "backgroundSize",
    "baselineShift",
    "blockSize",
    "border",
    "borderBlock",
    "borderBlockColor",
    "borderBlockEnd",
    "borderBlockEndColor",
    "borderBlockEndStyle",
    "borderBlockEndWidth",
    "borderBlockStart",
    "borderBlockStartColor",
    "borderBlockStartStyle",
    "borderBlockStartWidth",
    "borderBlockStyle",
    "borderBlockWidth",
    "borderBottom",
    "borderBottomColor",
    "borderBottomLeftRadius",
    "borderBottomRightRadius",
    "borderBottomStyle",
    "borderBottomWidth",
    "borderCollapse",
    "borderColor",
    "borderImage",
    "borderImageOutset",
    "borderImageRepeat",
    "borderImageSlice",
    "borderImageSource",
    "borderImageWidth",
    "borderLeft",
    "borderLeftColor",
    "borderLeftStyle",
    "borderLeftWidth",
    "borderRadius",
    "borderRight",
    "borderRightColor",
    "borderRightStyle",
    "borderRightWidth",
    "borderSpacing",
    "borderStyle",
    "borderTop",
    "borderTopColor",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderTopStyle",
    "borderTopWidth",
    "borderWidth",
    "bottom",
    "boxDecorationBreak",
    "boxShadow",
    "boxSizing",
    "breakAfter",
    "breakBefore",
    "breakInside",
    "captionSide",
    "caretColor",
    "clear",
    "clip",
    "clipPath",
    "color",
    "colorAdjust",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorRendering",
    "columnCount",
    "columnFill",
    "columnGap",
    "columnRule",
    "columnRuleColor",
    "columnRuleStyle",
    "columnRuleWidth",
    "columnSpan",
    "columnWidth",
    "columns",
    "contain",
    "containIntrinsicBlockSize",
    "containIntrinsicHeight",
    "containIntrinsicInlineSize",
    "containIntrinsicSize",
    "containIntrinsicWidth",
    "container",
    "containerName",
    "containerType",
    "content",
    "contentVisibility",
    "counterIncrement",
    "counterReset",
    "cursor",
    "direction",
    "display",
    "emptyCells",
    "fieldSizing",
    "fill",
    "filter",
    "flex",
    "flexBasis",
    "flexDirection",
    "flexFlow",
    "flexGrow",
    "flexShrink",
    "flexWrap",
    "float",
    "font",
    "fontFamily",
    "fontFeatureSettings",
    "fontKerning",
    "fontLanguageOverride",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontVariantAlternates",
    "fontVariantCaps",
    "fontVariantEastAsian",
    "fontVariantNumeric",
    "fontVariantPosition",
    "fontWeight",
    "fontVariationSettings",
    "fontSynthesis",
    "forcedColorAdjust",
    "gap",
    "grid",
    "gridArea",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridColumn",
    "gridColumnEnd",
    "gridColumnGap",
    "gridColumnStart",
    "gridGap",
    "gridRow",
    "gridRowEnd",
    "gridRowGap",
    "gridRowStart",
    "gridTemplate",
    "gridTemplateAreas",
    "gridTemplateColumns",
    "gridTemplateRows",
    "height",
    "hyphens",
    "imageOrientation",
    "imageRendering",
    "imeMode",
    "inset",
    "insetBlock",
    "insetBlockEnd",
    "insetBlockStart",
    "insetInline",
    "insetInlineEnd",
    "insetInlineStart",
    "initialLetter",
    "interpolateSize",
    "isolation",
    "justifyContent",
    "justifyItems",
    "justifySelf",
    "left",
    "letterSpacing",
    "lineBreak",
    "lineClamp",
    "lineHeight",
    "listStyle",
    "listStyleImage",
    "listStylePosition",
    "listStyleType",
    "margin",
    "marginBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBlock",
    "marginBlockEnd",
    "marginBlockStart",
    "marginInline",
    "marginInlineEnd",
    "marginInlineStart",
    "mask",
    "maskBorder",
    "maskBorderImage",
    "maskBorderOutset",
    "maskBorderRepeat",
    "maskBorderSlice",
    "maskBorderSource",
    "maskBorderWidth",
    "maskClip",
    "maskComposite",
    "maskImage",
    "maskOrigin",
    "maskPosition",
    "maskRepeat",
    "maskSize",
    "maskType",
    "maxBlockSize",
    "maxHeight",
    "maxInlineSize",
    "maxWidth",
    "minBlockSize",
    "minHeight",
    "minInlineSize",
    "minWidth",
    "mixBlendMode",
    "objectFit",
    "objectPosition",
    "objectViewBox",
    "offset",
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "opacity",
    "order",
    "orientation",
    "outline",
    "outlineColor",
    "outlineOffset",
    "outlineStyle",
    "outlineWidth",
    "overflow",
    "overflowAnchor",
    "overflowClip",
    "overflowScrolling",
    "overflowWrap",
    "overflowX",
    "overflowY",
    "overscrollBehavior",
    "overscrollBehaviorX",
    "overscrollBehaviorY",
    "padding",
    "paddingBottom",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "pageBreakAfter",
    "pageBreakBefore",
    "pageBreakInside",
    "paintOrder",
    "perspective",
    "perspectiveOrigin",
    "placeContent",
    "placeItems",
    "placeSelf",
    "pointerEvents",
    "position",
    "positionAnchor",
    "positionArea",
    "positionTry",
    "positionTryFallbacks",
    "positionTryOrder",
    "positionVisibility",
    "resize",
    "right",
    "rotate",
    "rowGap",
    "scrollBehavior",
    "scrollMargin",
    "scrollMarginBlock",
    "scrollMarginBlockEnd",
    "scrollMarginBlockStart",
    "scrollMarginBottom",
    "scrollMarginInline",
    "scrollMarginInlineEnd",
    "scrollMarginInlineStart",
    "scrollMarginLeft",
    "scrollMarginRight",
    "scrollMarginTop",
    "scrollPadding",
    "scrollPaddingBlock",
    "scrollPaddingBlockEnd",
    "scrollPaddingBlockStart",
    "scrollPaddingBottom",
    "scrollPaddingInline",
    "scrollPaddingInlineEnd",
    "scrollPaddingInlineStart",
    "scrollPaddingLeft",
    "scrollPaddingRight",
    "scrollPaddingTop",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollSnapType",
    "scrollTimeline",
    "scrollTimelineAxis",
    "scrollTimelineName",
    "scrollbarColor",
    "scrollbarGutter",
    "scrollbarWidth",
    "shapeImageThreshold",
    "shapeMargin",
    "shapeOutside",
    "stroke",
    "tabSize",
    "tableLayout",
    "textAlign",
    "textAlignLast",
    "textBox",
    "textBoxEdge",
    "textBoxTrim",
    "textDecoration",
    "textDecorationColor",
    "textDecorationLine",
    "textDecorationSkipInk",
    "textDecorationStyle",
    "textDecorationThickness",
    "textIndent",
    "textOverflow",
    "textShadow",
    "textTransform",
    "textUnderlineOffset",
    "textWrap",
    "textWrapMode",
    "textWrapStyle",
    "timelineScope",
    "top",
    "touchAction",
    "transform",
    "transformOrigin",
    "transformStyle",
    "transition",
    "transitionDelay",
    "transitionDuration",
    "transitionProperty",
    "transitionTimingFunction",
    "translate",
    "translateX",
    "translateY",
    "translateZ",
    "unicodeBidi",
    "userSelect",
    "verticalAlign",
    "viewTimeline",
    "viewTimelineAxis",
    "viewTimelineInset",
    "viewTimelineName",
    "viewTransitionClass",
    "viewTransitionName",
    "visibility",
    "whiteSpace",
    "widows",
    "width",
    "willChange",
    "wordBreak",
    "wordSpacing",
    "wordWrap",
    "writingMode",
    "zIndex"
]);

});

parcelRegister("lhJVy", function(module, exports) {

$parcel$export(module.exports, "resolveStyleBlockTokens", () => $f7eecfb98bd0ad88$export$dff729908f0040a4);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");
var $czfS0 = parcelRequire("czfS0");
parcelRequire("67GC6");
var $521xJ = parcelRequire("521xJ");
var $d52u8 = parcelRequire("d52u8");
parcelRequire("6pGsV");
var $9L4Qx = parcelRequire("9L4Qx");

var $fe4kH = parcelRequire("fe4kH");

var $4XTEI = parcelRequire("4XTEI");

var $7sECv = parcelRequire("7sECv");
const $f7eecfb98bd0ad88$var$d = /\s*!important\s*$/, $f7eecfb98bd0ad88$var$R = ()=>{
    let t;
    try {
        t = (0, $521xJ.getActiveConfig)();
    } catch  {
        t = null;
    }
    const n = t && t.sizes && typeof t.sizes == "object" ? t.sizes : null;
    let e = null;
    const r = (o)=>{
        e || (e = new Map);
        let i = e.get(o);
        return i === void 0 && (i = (0, $7sECv.isKnownSequenceLetter)(t, o), e.set(o, i)), i;
    }, s = (o)=>(0, $d52u8.getSizeValue)(n, o) !== void 0;
    return {
        isToken: (o)=>o.charCodeAt(0) !== 35 && ((0, $7sECv.isKnownBareToken)(o, r) || s(o))
    };
}, $f7eecfb98bd0ad88$var$j = (t, n)=>{
    const e = String(t).split((0, $7sECv.TOKEN_WORD_SPLIT_RE));
    for(let r = 0; r < e.length; r++)if (e[r] === n) return !0;
    return !1;
}, $f7eecfb98bd0ad88$var$w = (t, n)=>{
    const e = typeof globalThis < "u" ? globalThis.CSS : void 0;
    if (!e || typeof e.supports != "function") return !1;
    try {
        return e.supports((0, $9L4Qx.cssPropName)(t), n);
    } catch  {
        return !1;
    }
}, $f7eecfb98bd0ad88$var$p = new Set, $f7eecfb98bd0ad88$var$O = (t, n, e)=>{
    if (!(0, $dSdIt.isLoudDevRuntime)()) return;
    const r = t?.__ref?.path ? t.__ref.path.join(".") : t?.key || "?", s = r + "::" + n + "::" + e;
    $f7eecfb98bd0ad88$var$p.has(s) || ($f7eecfb98bd0ad88$var$p.add(s), console.warn(`[smbls/css-in-props] style.${n} on <${r}> holds a design-system token the "${n}" transformer could not resolve to one inline value, so it is written as is and the browser drops it. Move the key out of \`style\` to the element itself, or write the resolved CSS. Value: "${e}"`));
}, $f7eecfb98bd0ad88$var$E = (t, n)=>{
    if (!t || typeof t != "object") return !1;
    let e = !1;
    for(const r in t){
        const s = t[r];
        if (s != null) {
            if (typeof s == "object" || typeof s == "function") return !1;
            for (const o of n)if ($f7eecfb98bd0ad88$var$j(s, o)) return !1;
            e = !0;
        }
    }
    return e;
}, $f7eecfb98bd0ad88$var$I = (t, n, e, r)=>{
    if (!(0, $czfS0.isString)(n) || !n || t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45) return null;
    const s = (0, $fe4kH.CSS_PROPS_REGISTRY)[t];
    if (!s || !(0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(t)) return null;
    const o = $f7eecfb98bd0ad88$var$d.test(n), i = o ? n.replace($f7eecfb98bd0ad88$var$d, "") : n, l = (0, $7sECv.findTokenWords)(i, r.isToken);
    if (!l || $f7eecfb98bd0ad88$var$w(t, i)) return null;
    let c;
    try {
        c = s(i, e, e?.state, e?.context);
    } catch  {
        c = null;
    }
    if (Array.isArray(c)) {
        const u = {};
        for (const f of c)f && typeof f == "object" && Object.assign(u, f);
        c = u;
    }
    if (!$f7eecfb98bd0ad88$var$E(c, l)) return $f7eecfb98bd0ad88$var$O(e, t, n), null;
    const a = {};
    for(const u in c){
        const f = c[u];
        f != null && (a[u] = o ? String(f) + " !important" : f);
    }
    return a;
}, $f7eecfb98bd0ad88$var$h = (t, n, e)=>{
    const r = {};
    let s = !1;
    for(const o in t){
        const i = t[o];
        if (o.charCodeAt(0) === 38 && i && typeof i == "object" && !Array.isArray(i)) {
            const c = $f7eecfb98bd0ad88$var$h(i, n, e);
            c !== i && (s = !0), r[o] = c;
            continue;
        }
        const l = $f7eecfb98bd0ad88$var$I(o, i, n, e);
        l ? (s = !0, Object.assign(r, l)) : r[o] = i;
    }
    return s ? r : t;
}, $f7eecfb98bd0ad88$export$dff729908f0040a4 = (t, n)=>!t || typeof t != "object" || Array.isArray(t) ? t : $f7eecfb98bd0ad88$var$h(t, n, $f7eecfb98bd0ad88$var$R());

});
parcelRegister("7sECv", function(module, exports) {

$parcel$export(module.exports, "isKnownSequenceLetter", () => $56eaa83c548e19f7$export$a8502e322d09e893);
$parcel$export(module.exports, "TOKEN_WORD_SPLIT_RE", () => $56eaa83c548e19f7$export$d093f0d7a9c209fe);
$parcel$export(module.exports, "findTokenWords", () => $56eaa83c548e19f7$export$b3e7e6706a070d55);
$parcel$export(module.exports, "isKnownBareToken", () => $56eaa83c548e19f7$export$9c7a07a4d1aae999);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");
var $czfS0 = parcelRequire("czfS0");
parcelRequire("67GC6");
var $d52u8 = parcelRequire("d52u8");
var $521xJ = parcelRequire("521xJ");
const $56eaa83c548e19f7$var$b = /^[a-z][0-9]?$/, $56eaa83c548e19f7$var$d = /var\(\s*(--[A-Za-z0-9-]+)/g, $56eaa83c548e19f7$export$7529bb3ad6b70c12 = (t)=>{
    const n = new Set, s = new Set;
    if (!t || typeof t != "object") return {
        knownLetters: n,
        knownVars: s
    };
    for(const o in t){
        const e = t[o];
        if (!(!e || typeof e != "object")) {
            if (e.sequence && typeof e.sequence == "object") for(const r in e.sequence)n.add(r);
            if (e.vars && typeof e.vars == "object") for(const r in e.vars)s.add(r);
        }
    }
    return {
        knownLetters: n,
        knownVars: s
    };
}, $56eaa83c548e19f7$var$E = Object.prototype.propertyIsEnumerable, $56eaa83c548e19f7$export$a8502e322d09e893 = (t, n)=>{
    if (!t || typeof t != "object") return !1;
    for(const s in t){
        const o = t[s];
        if (!o || typeof o != "object") continue;
        const e = o.sequence;
        if (e && typeof e == "object" && $56eaa83c548e19f7$var$E.call(e, n)) return !0;
    }
    return !1;
}, $56eaa83c548e19f7$export$d093f0d7a9c209fe = /[(),\s]+/, $56eaa83c548e19f7$export$b3e7e6706a070d55 = (t, n)=>{
    let s = null;
    const o = t.split($56eaa83c548e19f7$export$d093f0d7a9c209fe);
    for(let e = 0; e < o.length; e++){
        const r = o[e];
        r && n(r) && (s || (s = [])).push(r);
    }
    return s;
}, $56eaa83c548e19f7$export$9c7a07a4d1aae999 = (t, n)=>(0, $d52u8.BARE_SEQUENCE_TOKEN_RE).test(t) && n(t.charCodeAt(0) === 45 ? t.slice(1) : t), $56eaa83c548e19f7$var$S = (t, n)=>{
    if (!n.size) return [];
    const s = (e)=>n.has(e), o = $56eaa83c548e19f7$export$b3e7e6706a070d55(t, (e)=>$56eaa83c548e19f7$export$9c7a07a4d1aae999(e, s));
    return o ? [
        ...new Set(o)
    ] : [];
}, $56eaa83c548e19f7$var$k = (t, n)=>{
    if (!n.size) return [];
    const s = [];
    $56eaa83c548e19f7$var$d.lastIndex = 0;
    let o;
    for(; o = $56eaa83c548e19f7$var$d.exec(t);){
        const e = o[1];
        if (n.has(e)) continue;
        const r = e.lastIndexOf("-");
        if (r === -1) continue;
        const a = e.slice(r + 1);
        if (!$56eaa83c548e19f7$var$b.test(a)) continue;
        const c = e.slice(0, r + 1) + a.toUpperCase();
        c !== e && n.has(c) && s.push({
            varName: e,
            corrected: c
        });
    }
    return s;
}, $56eaa83c548e19f7$var$u = new Set, $56eaa83c548e19f7$export$d1c6fbb4befce55d = (t, n, s)=>{
    if (!(0, $dSdIt.isLoudDevRuntime)() || !(0, $czfS0.isString)(n) || !n) return;
    let o;
    try {
        o = (0, $521xJ.getActiveConfig)();
    } catch  {
        return;
    }
    const { knownLetters: e, knownVars: r } = $56eaa83c548e19f7$export$7529bb3ad6b70c12(o);
    if (!e.size && !r.size) return;
    const a = $56eaa83c548e19f7$var$S(n, e), c = $56eaa83c548e19f7$var$k(n, r);
    if (!a.length && !c.length) return;
    const f = s?.__ref?.path ? s.__ref.path.join(".") : s?.key || "?";
    for (const i of a){
        const l = `${f}::${t}::bare::${i}::${n}`;
        $56eaa83c548e19f7$var$u.has(l) || ($56eaa83c548e19f7$var$u.add(l), console.warn(`[smbls/css-in-props] "${t}" on <${f}> looks like it contains an un-wrapped design-system token ("${i}") \u2014 "${t}" has no registered resolver, so its value is forwarded to the browser untouched. A bare letter token there is invalid CSS, so the browser drops the ENTIRE "${t}" declaration (not just this argument). Wrap it in var(--<family>-${i.replace("-", "")}) (or calc(-1 * var(--<family>-${i.replace("-", "")})) for a negative). Value: "${n}"`));
    }
    for (const { varName: i, corrected: l } of c){
        const h = `${f}::${t}::case::${i}::${n}`;
        $56eaa83c548e19f7$var$u.has(h) || ($56eaa83c548e19f7$var$u.add(h), console.warn(`[smbls/css-in-props] "${t}" on <${f}> references ${i}, which the active design system never emits. CSS custom-property names are case-sensitive \u2014 the real variable is ${l}, so this reference silently never resolves. Value: "${n}"`));
    }
};

});


parcelRegister("9qps7", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("8uPKr"))) : import("8uPKr")).then(()=>parcelRequire('kyUG5'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("4nK75", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("fu2rS"))) : import("fu2rS")).then(()=>parcelRequire('eIdwe'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("iSwre", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("4JbYr"))) : import("4JbYr")).then(()=>parcelRequire('i9rtS'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("3Py9H", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("f906J"))) : import("f906J")).then(()=>parcelRequire('iE1bW'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7mtaO", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9Xayq"))) : import("9Xayq")).then(()=>parcelRequire('aWSBL'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hRfYg", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("jtMsB"))) : import("jtMsB")).then(()=>parcelRequire('6pxyb'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("3dQQl", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("1zouj"))) : import("1zouj")).then(()=>parcelRequire('e2MDe'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("kvnPV", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("8UAPF"))) : import("8UAPF")).then(()=>parcelRequire('cJjDi'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("2rYsV", function(module, exports) {

$parcel$export(module.exports, "PAGE_SIZE", () => $1c8d0197eeddcb2e$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "INITIAL_PAGE_SIZE", () => $1c8d0197eeddcb2e$export$90091b93f6cf4241);
$parcel$export(module.exports, "DEFAULT_COLUMN_KEYS", () => $1c8d0197eeddcb2e$export$c56c0834e91b5b02);
$parcel$export(module.exports, "normalizeTicketDoc", () => $1c8d0197eeddcb2e$export$229b9938a094680c);
$parcel$export(module.exports, "fetchColumnPage", () => $1c8d0197eeddcb2e$export$ad42fd312b9b2241);
$parcel$export(module.exports, "fetchTicketsForAnswer", () => $1c8d0197eeddcb2e$export$c6650f9d62b0168);
$parcel$export(module.exports, "fetchRecentTickets", () => $1c8d0197eeddcb2e$export$f6d9f8cf9c405d3a);
$parcel$export(module.exports, "fetchTicketsAssignedTo", () => $1c8d0197eeddcb2e$export$f9bb3c6b9d0a1cb5);
$parcel$export(module.exports, "fetchTicketsForUser", () => $1c8d0197eeddcb2e$export$8f2f3a8caa8ddae0);
$parcel$export(module.exports, "fetchEpicCounts", () => $1c8d0197eeddcb2e$export$d71d89610f6efb87);
$parcel$export(module.exports, "fetchColumnCounts", () => $1c8d0197eeddcb2e$export$b287101829b24124);
$parcel$export(module.exports, "TICKET_TYPE_COUNT_BUCKETS", () => $1c8d0197eeddcb2e$export$30b7064a495b101a);
$parcel$export(module.exports, "fetchTypeCounts", () => $1c8d0197eeddcb2e$export$608a018b3aab186a);
$parcel$export(module.exports, "refreshTicketsCounts", () => $1c8d0197eeddcb2e$export$7373356c854d109a);
$parcel$export(module.exports, "applyTicketsFilterPick", () => $1c8d0197eeddcb2e$export$313883093a7f9f14);
$parcel$export(module.exports, "ticketsAgentAssignables", () => $1c8d0197eeddcb2e$export$c8074394f3eff071);
$parcel$export(module.exports, "ticketsAssignablePool", () => $1c8d0197eeddcb2e$export$57f9330c2556147a);
$parcel$export(module.exports, "ensureTicketsAgentsRoster", () => $1c8d0197eeddcb2e$export$8ba423bdf8c5e525);
$parcel$export(module.exports, "ticketsAssigneePickItems", () => $1c8d0197eeddcb2e$export$a258cfa2d06d0443);
$parcel$export(module.exports, "ticketsIssuerPickItems", () => $1c8d0197eeddcb2e$export$f48efae8309dd5e7);
$parcel$export(module.exports, "ticketsEpicPickItems", () => $1c8d0197eeddcb2e$export$b234c8038d7d3bf7);
$parcel$export(module.exports, "loadEpicsTree", () => $1c8d0197eeddcb2e$export$8301b216684d7136);
$parcel$export(module.exports, "pageColumn", () => $1c8d0197eeddcb2e$export$99ee43af29c56bcc);
$parcel$export(module.exports, "reloadTicketsForRoot", () => $1c8d0197eeddcb2e$export$dd9c63e54367b8f);
$parcel$export(module.exports, "reloadTickets", () => $1c8d0197eeddcb2e$export$b96b5ca5b7717416);
// Single source of truth for the tickets loaders. Bound as
// element methods (`el.call('pageColumn', colKey)` /
// `el.call('reloadTickets')`) plus exported as plain functions for
// page `onCreate` to call directly.
//
// All ticket queries flow through `sdk.tickets.*` (Mongo-backed):
//   • tickets         — sdk.tickets.list/get/create/update
//   • ticket_columns  — sdk.tickets.columns.list  (was /sb/rest/v1/ticket_columns)
//   • epic counts     — sdk.tickets.epicCounts    (was /sb/rest/v1/ticket_epic_counts view)
//
// (The former project_fields Supabase REST holdout was removed — its only
//  reader, fetchProjectFieldOptions, was dead; the table is dropped in 0159.)
// getSDK comes from @symbo-ls/workspace-shared, stubbed by frank's
// EXTERNAL_PACKAGES at serialization time — reached via el.call (or
// this.call, for the two functions below already designed for
// el.call('name') binding) instead of a raw import — see
// TicketDetailModal.js for the full rationale. The six functions below
// that returned data directly now take `el` first; pageColumn /
// reloadTickets / loadEpicsTree already bind `this` via el.call and pass
// it straight through.

var $jXdHE = parcelRequire("jXdHE");
const $1c8d0197eeddcb2e$export$8ec3d08588d2eeda = 16 // per-column page size (per Nika #6 — limit 16)
;
const $1c8d0197eeddcb2e$export$90091b93f6cf4241 = 16;
const $1c8d0197eeddcb2e$export$c56c0834e91b5b02 = [
    'backlog',
    'todo',
    'in_progress',
    'blocked',
    'ready_to_test',
    'review',
    'done'
];
// Normalize a Mongo ticket doc to the flat shape expected by board components.
// Dual-reads camelCase||snake_case fields to handle any API response shape in
// transition. GitHub-mirror-only fields (github_issue_url, github_node_id,
// number, content_type, repository, milestone, iteration_*) are zeroed/nulled
// — they were never migrated to Mongo.
// Legacy GitHub-Projects GUID column ids → semantic state keys. Older
// tickets persisted the GUID as columnKey; normalize at load so My View
// bucketing (isActiveColumn) + status display work (#2321 — same GUID-vs-
// semantic family as #2290).
const $1c8d0197eeddcb2e$var$_GUID_TO_STATE = {
    '4d6ab783': 'in_progress',
    '821cd85d': 'review',
    '20f135e3': 'ready_to_test',
    d677f7ee: 'ready_to_test',
    eede5560: 'done'
};
const $1c8d0197eeddcb2e$var$_normCol = (c)=>$1c8d0197eeddcb2e$var$_GUID_TO_STATE[c] || c || null;
const $1c8d0197eeddcb2e$var$_mongoToTicket = (doc, isPartial = false)=>{
    const t = {
        id: doc._id || doc.id,
        key: String(doc._id || doc.id)
    };
    if (!isPartial || 'title' in doc) t.title = doc.title || '';
    if (!isPartial || 'body' in doc) t.body = doc.body || '';
    if (!isPartial || 'columnKey' in doc || 'column_key' in doc) {
        t.columnKey = $1c8d0197eeddcb2e$var$_normCol(doc.columnKey || doc.column_key);
        t.column_key = $1c8d0197eeddcb2e$var$_normCol(doc.columnKey || doc.column_key);
    }
    if (!isPartial || 'position' in doc) t.position = doc.position || 0;
    if (!isPartial || 'workspace' in doc || 'workspaceId' in doc || 'workspace_id' in doc) t.workspaceId = doc.workspace || doc.workspaceId || doc.workspace_id || null;
    if (!isPartial || 'assigneeEmail' in doc || 'assignee_email' in doc || 'assignees' in doc) {
        const email = (()=>{
            let e = doc.assigneeEmail || doc.assignee_email;
            if (!e && Array.isArray(doc.assignees) && doc.assignees.length > 0) e = doc.assignees.map((a)=>a.email).filter(Boolean).join(', ');
            return e || null;
        })();
        t.assigneeEmail = email;
        t.assignee_email = email;
        t.assignees = doc.assignees || [];
    }
    if (!isPartial || 'assigneeLogins' in doc) t.assigneeLogins = doc.assigneeLogins || [];
    if (!isPartial || 'reporterEmail' in doc || 'reporter_email' in doc) {
        t.reporterEmail = doc.reporterEmail || doc.reporter_email || null;
        t.reporter_email = doc.reporterEmail || doc.reporter_email || null;
    }
    if (!isPartial || 'labels' in doc) t.labels = doc.labels || [];
    if (!isPartial || 'priority' in doc) t.priority = doc.priority || null;
    if (!isPartial || 'state' in doc) t.state = doc.state || null;
    if (!isPartial || 'type' in doc || 'issueType' in (doc.metadata || {})) {
        t.type = doc.type || null;
        t.issueType = doc.type || doc.metadata?.issueType || null;
    }
    if (!isPartial || 'externalId' in doc || 'external_id' in doc) {
        t.external_id = doc.externalId || doc.external_id || null;
        t.externalId = doc.externalId || doc.external_id || null;
    }
    if (!isPartial || 'env' in doc || 'env' in (doc.metadata || {})) t.env = doc.env || doc.metadata?.env || null;
    if (!isPartial || 'metadata' in doc) t.metadata = doc.metadata || {};
    if (!isPartial || 'updatedAt' in doc || 'updated_at' in doc) {
        t.updatedAt = doc.updatedAt || doc.updated_at || null;
        t.updated_at = doc.updatedAt || doc.updated_at || null;
    }
    if (!isPartial || 'createdAt' in doc || 'created_at' in doc) {
        t.createdAt = doc.createdAt || doc.created_at || null;
        t.created_at = doc.createdAt || doc.created_at || null;
    }
    if (!isPartial || 'dueDate' in doc || 'due_date' in doc) t.dueDate = doc.dueDate || doc.due_date || null;
    // The task↔project link (Ticket.project) — the board's ?project= scope
    // reads it on a realtime row (ticketUtils ticketBelongsOnBoard).
    if (!isPartial || 'project' in doc) t.project = doc.project ? String(doc.project) : null;
    if (!isPartial || 'epic' in doc || 'epicName' in doc || 'epic_name' in doc) {
        t.epicName = doc.epic || doc.epicName || doc.epic_name || null;
        t.epic_name = doc.epic || doc.epicName || doc.epic_name || null;
    }
    if (!isPartial || doc.metadata) {
        const meta = doc.metadata || {};
        if (!isPartial || 'severity' in meta) t.severity = meta.severity || null;
        if (!isPartial || 'storyPoints' in meta) t.storyPoints = meta.storyPoints || null;
        if (!isPartial || 'acceptanceCriteria' in meta) t.acceptanceCriteria = meta.acceptanceCriteria || null;
        if (!isPartial || 'reproSteps' in meta || 'stepsToReproduce' in meta) t.stepsToReproduce = meta.reproSteps || meta.stepsToReproduce || null;
        if (!isPartial || 'expectedResult' in meta) t.expectedResult = meta.expectedResult || null;
    }
    if (!isPartial) {
        t.sub_issues_total = 0;
        t.sub_issues_completed = 0;
        t.subIssuesTotal = 0;
        t.subIssuesCompleted = 0;
        t.githubUrl = null;
        t.githubNodeId = null;
        t.number = null;
        t.contentType = null;
        t.repository = null;
        t.milestone = null;
        t.iterationId = null;
        t.iterationTitle = null;
        t.iterationStart = null;
        t.iterationEnd = null;
        t.trackedByCount = 0;
        t.tracksCount = 0;
        t.issueTypeColor = null;
        t.epicOptionId = null;
        t.parentIssueUrl = null;
    }
    return t;
};
const $1c8d0197eeddcb2e$export$229b9938a094680c = $1c8d0197eeddcb2e$var$_mongoToTicket;
// Build a Mongo filter from the column-filter options used by the board.
// workspace_id scope is applied server-side from JWT — do NOT pass it here.
const $1c8d0197eeddcb2e$var$_buildMongoFilter = (filters = {})=>{
    const f = {
        deleted: false
    };
    // Multi-select person picks arrive as ARRAYS of emails (sidebar pickers,
    // 2026-07-25 per Nika "allow multiple selects in assignee and assigned
    // filters"); single strings / categories keep their legacy handling.
    if (Array.isArray(filters.assignee)) {
        if (filters.assignee.length === 1) f.assigneeEmail = filters.assignee[0];
        else if (filters.assignee.length > 1) f.assigneeEmail = {
            $in: filters.assignee
        };
    } else if (filters.assignee && filters.assignee !== 'all') {
        if (filters.assignee === 'me' && filters.currentUserEmail) f.assigneeEmail = filters.currentUserEmail;
        else if (filters.assignee === 'agents') f.assigneeEmail = {
            $regex: '.*-agent@symbols\\.app$'
        };
        else if (filters.assignee === 'team') {
            f.assigneeEmail = {
                $not: {
                    $regex: '.*-agent@symbols\\.app$'
                }
            };
            if (filters.currentUserEmail) f._assigneeNot = filters.currentUserEmail;
        } else f.assigneeEmail = filters.assignee;
    }
    // Issuer = the ticket's reporter (creator). One or more emails filter the
    // board to tickets those people raised. `reporterEmail` is already a
    // first-class Mongo field on tickets (see _mongoToTicket + fetchTicketsForUser),
    // so this needs no server change. (2026-06-15 per Nika: TicketsSidebar Issuer.)
    if (Array.isArray(filters.issuer)) {
        if (filters.issuer.length === 1) f.reporterEmail = filters.issuer[0];
        else if (filters.issuer.length > 1) f.reporterEmail = {
            $in: filters.issuer
        };
    } else if (filters.issuer && filters.issuer !== 'all') f.reporterEmail = filters.issuer;
    if (filters.search) {
        const q = filters.search.replace(/[%*]/g, '').trim();
        if (q) f.title = {
            $regex: q,
            $options: 'i'
        };
    }
    // Epic filter is NAME-based on the first-class Mongo `epic` column (the
    // legacy epicOptionId was a GitHub-Projects GUID that Mongo rows never
    // carry — filtering on it silently matched nothing). Set by the sidebar
    // EPIC picker (2026-07-25 per Nika "add epics in filter sidebar").
    if (filters.epic) f.epic = filters.epic;
    if (filters.issueType) f.type = filters.issueType;
    else f.type = {
        $nin: (0, $jXdHE.BOARD_PLANNING_TYPES)
    };
    // Roadmap-cycle scoping. /tickets/board?cycle=<id> sets root.filterCycleId
    // on mount; filtersFromRoot threads it through every column fetch.
    if (filters.cycleId) f.cycleId = filters.cycleId;
    // The task↔project link (Ticket.project, the project's id): /tasks?project=
    // and the AI-answer view's `project` (the project the ask names, resolved
    // to its id). The server checks the project belongs to the workspace.
    if (filters.project) f.project = filters.project;
    // Priority (P0–P3) — the AI-answer view's `priority`, one place for the
    // list read, the column pages and the column counts alike.
    if (filters.priority) f.priority = filters.priority;
    // Tickets are workspace-scoped server-side (workspaceId required since
    // server@ba9e0d8f). Pass the board's workspace explicitly; the SDK also
    // falls back to its active-workspace context when absent.
    if (filters.workspaceId) f.workspaceId = filters.workspaceId;
    return f;
};
const $1c8d0197eeddcb2e$export$ad42fd312b9b2241 = async (el, colKey, offset, limit, filters = {}, src = '?')=>{
    // Frank's serializer only classifies bare identifiers referenced inside
    // FUNCTION BODIES — an identifier used as a DEFAULT-PARAMETER expression
    // is outside that scan and comes back "resolves to nothing at runtime"
    // once this function is emitted on its own. Default inside the body
    // instead so `PAGE_SIZE` is a plain body read (like the body-only usage a
    // few lines below in `pageColumn`, which already resolves cleanly).
    if (limit == null) limit = $1c8d0197eeddcb2e$export$8ec3d08588d2eeda;
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const filter = {
            ...$1c8d0197eeddcb2e$var$_buildMongoFilter(filters),
            columnKey: colKey
        };
        const result = await tSvc.list(filter, {
            sortBy: 'position',
            sortDir: 'asc',
            limit: limit,
            skip: offset
        });
        const docs = Array.isArray(result) ? result : result.data || [];
        return docs.map($1c8d0197eeddcb2e$var$_mongoToTicket);
    } catch (err) {
        console.warn('[ticketLoaders] page fetch failed for', colKey, 'src:', src, 'ws:', filters?.workspaceId || 'NONE', err?.message || err);
        return [];
    }
};
const $1c8d0197eeddcb2e$export$c6650f9d62b0168 = async (el, filters = {}, limit = 20)=>{
    const cap = Math.min(Math.max(Number(limit) || 20, 1), 50);
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const filter = $1c8d0197eeddcb2e$var$_buildMongoFilter(filters);
        const status = filters.status || 'open';
        if (status === 'open') filter.columnKey = filters.drafts === true ? {
            $ne: 'done'
        } : {
            $nin: [
                'done',
                'draft'
            ]
        };
        else if (status !== 'all') filter.columnKey = status;
        const rowsOf = (res)=>Array.isArray(res) ? res : res && res.data || [];
        const countOf = (res)=>{
            const n = res && !Array.isArray(res) ? Number(res.count) : NaN;
            return Number.isFinite(n) ? n : null;
        };
        const due = filters.due && typeof filters.due === 'object' ? filters.due : null;
        const placed = filters.placed === true;
        if (!due && !placed) {
            const result = await tSvc.list(filter, {
                sortBy: 'updatedAt',
                sortDir: 'desc',
                limit: cap
            });
            const out = rowsOf(result).map((d)=>$1c8d0197eeddcb2e$var$_mongoToTicket(d));
            const total = countOf(result);
            if (total !== null) out.total = total;
            return out;
        }
        // A dated window reads by due date, latest first — a task with no date
        // sorts last — so once a page reaches a day before the window, or a task
        // with no date, nothing after it can match.
        const dated = !!(due && !due.none);
        const dayOf = (t)=>t && t.dueDate ? String(t.dueDate).slice(0, 10) : '';
        const root = el && el.state && el.state.root || null;
        const keep = (t)=>{
            if (due) {
                const day = dayOf(t);
                if (due.none) {
                    if (day) return false;
                } else {
                    if (!day) return false;
                    if (due.from && day < due.from) return false;
                    if (due.to && day > due.to) return false;
                    if (due.open && t.columnKey === 'done') return false;
                }
            }
            return !placed || !!el.call('ticketCanvasPos', root, t);
        };
        const PAGE = 100;
        const PAGES = 5;
        const found = [];
        let skip = 0;
        let complete = false;
        for(let page = 0; page < PAGES; page++){
            const result = await tSvc.list(filter, {
                sortBy: dated ? 'dueDate' : 'updatedAt',
                sortDir: 'desc',
                limit: PAGE,
                skip: skip
            });
            const rows = rowsOf(result).map((d)=>$1c8d0197eeddcb2e$var$_mongoToTicket(d));
            for (const t of rows)if (keep(t)) found.push(t);
            const last = rows[rows.length - 1];
            const more = result && typeof result.hasMore === 'boolean' ? result.hasMore : rows.length === PAGE;
            const passed = dated && !!last && (!dayOf(last) || !!due.from && dayOf(last) < due.from);
            if (!rows.length || !more || passed) {
                complete = true;
                break;
            }
            if (!dated && found.length >= cap) break;
            skip += rows.length;
        }
        // A due window lists the nearest day first (the most overdue first).
        if (dated) found.sort((a, b)=>dayOf(a) < dayOf(b) ? -1 : dayOf(a) > dayOf(b) ? 1 : 0);
        const out = found.slice(0, cap);
        if (complete) {
            // Every match was read: the full count, and per board column.
            out.total = found.length;
            out.byColumn = {};
            for (const t of found){
                const key = t.columnKey || 'backlog';
                out.byColumn[key] = (out.byColumn[key] || 0) + 1;
            }
        }
        return out;
    } catch (err) {
        console.warn('[ticketLoaders] answer fetch failed:', err?.message || err);
        const out = [];
        out.failed = true;
        return out;
    }
};
const $1c8d0197eeddcb2e$export$f6d9f8cf9c405d3a = async (el, limit = 20)=>{
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const result = await tSvc.list({
            deleted: false
        }, {
            sortBy: 'updatedAt',
            sortDir: 'desc',
            limit: limit
        });
        const docs = Array.isArray(result) ? result : result.data || [];
        return docs.map($1c8d0197eeddcb2e$var$_mongoToTicket);
    } catch (_) {
        return [];
    }
};
const $1c8d0197eeddcb2e$export$f9bb3c6b9d0a1cb5 = async (el, email, limit = 100)=>{
    if (!email) return [];
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const result = await tSvc.list({
            assigneeEmail: email,
            deleted: false
        }, {
            sortBy: 'updatedAt',
            sortDir: 'desc',
            limit: limit
        });
        const docs = Array.isArray(result) ? result : result.data || [];
        return docs.map($1c8d0197eeddcb2e$var$_mongoToTicket);
    } catch (_) {
        return [];
    }
};
const $1c8d0197eeddcb2e$export$8f2f3a8caa8ddae0 = async (el, email, limit = 100, { throwOnError: throwOnError = false } = {})=>{
    if (!email) return [];
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const [assignedRes, reportedRes] = await Promise.all([
            tSvc.list({
                assigneeEmail: email,
                deleted: false
            }, {
                sortBy: 'updatedAt',
                sortDir: 'desc',
                limit: limit
            }).catch((err)=>{
                if (throwOnError) throw err;
                return [];
            }),
            tSvc.list({
                reporterEmail: email,
                deleted: false
            }, {
                sortBy: 'updatedAt',
                sortDir: 'desc',
                limit: limit
            }).catch((err)=>{
                if (throwOnError) throw err;
                return [];
            })
        ]);
        const assigned = Array.isArray(assignedRes) ? assignedRes : assignedRes?.data || [];
        const reported = Array.isArray(reportedRes) ? reportedRes : reportedRes?.data || [];
        const byId = new Map();
        for (const doc of [
            ...assigned,
            ...reported
        ]){
            const row = $1c8d0197eeddcb2e$var$_mongoToTicket(doc);
            if (row.id) byId.set(row.id, row);
        }
        return Array.from(byId.values());
    } catch (err) {
        if (throwOnError) throw err;
        return [];
    }
};
const $1c8d0197eeddcb2e$export$d71d89610f6efb87 = async (el, epicNames)=>{
    const out = {};
    for (const name of epicNames || [])out[name] = {
        total: 0,
        byColumn: {}
    };
    // Fast path: SDK-aggregated counts (Mongo-backed).
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const result = await tSvc.epicCounts();
        const rows = Array.isArray(result) ? result : result?.data || [];
        if (rows.length) {
            for (const r of rows){
                const epicName = r.epic_name || r.epicName;
                if (!epicName) continue;
                out[epicName] = {
                    total: r.total || 0,
                    byColumn: r.by_column || r.byColumn || {}
                };
            }
            return out;
        }
    } catch (_) {
    // fall through to client-side aggregation
    }
    // Fallback: aggregate client-side via sdk.tickets.listAll (list() caps at
    // 500 server-side and never read `sort` —
    // WS-TICKET-READS-SILENTLY-CAPPED-AT-500-1).
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const page = await tSvc.listAll({
            deleted: false,
            epic: {
                $ne: null
            }
        }, {
            sortBy: 'updatedAt',
            sortDir: 'desc'
        });
        const tickets = Array.isArray(page?.items) ? page.items : [];
        for (const t of tickets){
            const epicName = t.epic || t.epicName || t.epic_name;
            if (!epicName) continue;
            if (!out[epicName]) out[epicName] = {
                total: 0,
                byColumn: {}
            };
            out[epicName].total += 1;
            const colKey = t.columnKey || t.column_key;
            if (colKey) out[epicName].byColumn[colKey] = (out[epicName].byColumn[colKey] || 0) + 1;
        }
    } catch (_) {}
    return out;
};
const $1c8d0197eeddcb2e$export$b287101829b24124 = async (el, filters = {}, colKeys = null, opts = {})=>{
    const strict = !!(opts && opts.strict);
    let keys = colKeys;
    if (!keys) try {
        const tSvc = await el.call('getSDK').getService('tickets');
        const cols = await tSvc.columns.list();
        const rows = Array.isArray(cols) ? cols : cols?.data || [];
        keys = rows.map((c)=>c.key).filter(Boolean);
    } catch (err) {
        console.warn('[ticketLoaders] columns.list failed:', err?.message || err);
        keys = [];
    }
    const mongoFilter = $1c8d0197eeddcb2e$var$_buildMongoFilter(filters);
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        if (typeof tSvc.columnCounts === 'function') {
            const grouped = await tSvc.columnCounts(mongoFilter);
            if (grouped && typeof grouped === 'object' && !Array.isArray(grouped)) {
                // Zero-fill the known column keys (the aggregation omits empty
                // columns) and keep any extra keys it returned.
                const out = {};
                for (const key of keys)out[key] = grouped[key] || 0;
                for (const k of Object.keys(grouped))if (!(k in out)) out[k] = grouped[k];
                return out;
            }
        }
    } catch (err) {
        console.warn('[ticketLoaders] columnCounts fast path failed, falling back:', err?.message || err);
    }
    if (strict) return null;
    // Legacy fan-out — one count query per column.
    const out = {};
    try {
        const tSvc = await el.call('getSDK').getService('tickets');
        await Promise.all(keys.map(async (key)=>{
            try {
                const result = await tSvc.list({
                    ...mongoFilter,
                    columnKey: key
                }, {
                    limit: 0,
                    includeCount: true
                });
                // SDK may return { data, count } or plain array (older SDK).
                out[key] = typeof result?.count === 'number' ? result.count : Array.isArray(result) ? result.length : 0;
            } catch (err) {
                console.warn('[ticketLoaders] count failed for', key, err?.message || err);
                out[key] = 0;
            }
        }));
    } catch (err) {
        console.warn('[ticketLoaders] count fan-out failed:', err?.message || err);
        for (const key of keys)out[key] = 0;
    }
    return out;
};
const $1c8d0197eeddcb2e$export$30b7064a495b101a = [
    'all',
    'bug',
    'task',
    'user_story'
];
const $1c8d0197eeddcb2e$export$608a018b3aab186a = async (el, filters = {}, boardTotals = null)=>{
    const out = {};
    const rawGrouped = {};
    const boardBucket = filters.issueType || 'all';
    const readBucket = async (bucket)=>{
        if (boardTotals && bucket === boardBucket) return boardTotals;
        const tSvc = await el.call('getSDK').getService('tickets');
        return tSvc.columnCounts($1c8d0197eeddcb2e$var$_buildMongoFilter({
            ...filters,
            issueType: bucket === 'all' ? null : bucket
        }));
    };
    await Promise.all($1c8d0197eeddcb2e$export$30b7064a495b101a.map(async (bucket)=>{
        try {
            const grouped = await readBucket(bucket);
            if (grouped && typeof grouped === 'object' && !Array.isArray(grouped)) {
                rawGrouped[bucket] = grouped;
                // `el.state` is not assumed: an element without it (a teardown, a
                // harness) read `el.state.root` here and failed EVERY bucket — the
                // sidebar showed no counts and the board's tests logged "type count
                // failed … reading 'root'" on every read (2026-09-26 → 09-29).
                const stateRoot = el && el.state && el.state.root || null;
                const excludedCols = stateRoot && stateRoot._excludedCols || {};
                const hiddenCols = stateRoot && stateRoot._hiddenCols || {};
                out[bucket] = Object.entries(grouped).reduce((sum, [colKey, v])=>{
                    if (excludedCols[colKey] || hiddenCols[colKey]) return sum;
                    return sum + (Number(v) || 0);
                }, 0);
            }
        } catch (err) {
            console.warn('[ticketLoaders] type count failed for', bucket, err?.message || err);
        }
    }));
    return {
        totals: out,
        raw: rawGrouped
    };
};
const $1c8d0197eeddcb2e$export$7373356c854d109a = async function refreshTicketsCounts() {
    const el = this;
    const root = el && el.state ? el.state.root || el.state : null;
    if (!root || typeof root.update !== 'function') return false;
    if (root._ticketsBoardLive !== true) return false;
    const queryOf = (f)=>JSON.stringify([
            f.search,
            f.assignee,
            f.issuer,
            f.epic,
            f.issueType,
            f.cycleId,
            f.project,
            f.workspaceId
        ]);
    const same = (a, b)=>{
        const x = a && typeof a === 'object' ? a : {};
        const y = b && typeof b === 'object' ? b : {};
        const keys = Object.keys(x);
        if (keys.length !== Object.keys(y).length) return false;
        return keys.every((k)=>x[k] && typeof x[k] === 'object' ? same(x[k], y[k]) : x[k] === y[k]);
    };
    const filters = $1c8d0197eeddcb2e$var$filtersFromRoot(root);
    const asked = queryOf(filters);
    const colKeys = (root.columns || []).map((c)=>c.key);
    let cols;
    let types;
    try {
        const colsPromise = $1c8d0197eeddcb2e$export$b287101829b24124(el, filters, colKeys.length ? colKeys : null);
        const answers = await Promise.all([
            colsPromise,
            $1c8d0197eeddcb2e$export$608a018b3aab186a(el, filters, colsPromise)
        ]);
        cols = answers[0];
        types = answers[1];
    } catch (err) {
        console.warn('[ticketLoaders] counts refresh failed:', err?.message || err);
        return false;
    }
    if (root._ticketsBoardLive !== true || queryOf($1c8d0197eeddcb2e$var$filtersFromRoot(root)) !== asked) return false;
    const patch = {};
    if (!same(cols, root.totalByColumn)) patch.totalByColumn = cols;
    if (!same(types.totals, root.totalByType)) patch.totalByType = types.totals;
    if (!same(types.raw, root._rawTypeCounts)) patch._rawTypeCounts = types.raw;
    if (!Object.keys(patch).length) return false;
    root.update(patch);
    return true;
};
const $1c8d0197eeddcb2e$var$filtersFromRoot = (root)=>({
        search: root?.searchQuery || '',
        assignee: root?.filterAssignee || 'all',
        issuer: root?.filterIssuer || 'all',
        epic: root?.filterEpic || null,
        issueType: root?.filterIssueType || null,
        cycleId: root?.filterCycleId || null,
        project: root?.filterProjectId || null,
        currentUserEmail: root?.currentUserEmail,
        workspaceId: root?.workspace?.id || null
    });
function $1c8d0197eeddcb2e$export$313883093a7f9f14(action) {
    const root = this?.state?.root;
    if (!root || !action || !action.field) return;
    if (action.multi) {
        const cur = (0, $jXdHE.personFilterEmails)(root[action.field]);
        let next = null;
        if (action.value) {
            next = cur.includes(action.value) ? cur.filter((e)=>e !== action.value) : [
                ...cur,
                action.value
            ];
            if (!next.length) next = null;
        }
        // Re-write the dropdown descriptor with a fresh identity so the menu's
        // children re-run itemsFn and the check marks update in place.
        const dd = root.contextDropdown;
        root.update({
            [action.field]: next,
            contextDropdown: dd ? {
                ...dd
            } : dd
        });
        return;
    }
    root.update({
        [action.field]: action.value || null,
        contextDropdown: null
    });
}
const $1c8d0197eeddcb2e$export$c8074394f3eff071 = (root)=>(Array.isArray(root?._agents) ? root._agents : []).filter((a)=>a && a.email).map((a)=>({
            name: a.name || a.id || a.email,
            email: a.email,
            avatar: a.avatar || '',
            kind: 'agent'
        }));
const $1c8d0197eeddcb2e$export$57f9330c2556147a = (root)=>[
        ...(root?.people || []).filter((p)=>p && p.email),
        ...$1c8d0197eeddcb2e$export$c8074394f3eff071(root)
    ];
async function $1c8d0197eeddcb2e$export$8ba423bdf8c5e525() {
    const root = this?.state?.root;
    const sdk = this?.sdk;
    if (!root || root._ticketsAgentsFetched) return;
    if (Array.isArray(root._agents) && root._agents.length) return;
    if (!sdk || typeof sdk.listAgents !== 'function') return;
    root.update({
        _ticketsAgentsFetched: true
    }, {
        preventFetch: true
    });
    try {
        const orgId = root.org?.id || root.org?._id || null;
        const raw = await sdk.listAgents(orgId);
        const agents = (Array.isArray(raw) ? raw : []).map((u)=>({
                id: u.metadata && u.metadata.seedSlug || u.username || String(u._id || u.id || ''),
                userId: u._id || u.id || null,
                email: u.email || '',
                name: u.name || u.username || 'Agent',
                avatar: u.avatar || u.avatarUrl || '',
                kind: 'agent'
            })).filter((a)=>a.email);
        if (!agents.length) return;
        if (Array.isArray(root._agents) && root._agents.length) return;
        root.update({
            _agents: agents
        }, {
            preventFetch: true
        });
        const dd = root.contextDropdown;
        if (dd && dd.open && /^tickets(Assignee|Issuer)PickItems$/.test(dd.itemsFn || '')) root.update({
            contextDropdown: {
                ...dd
            }
        }, {
            preventFetch: true
        });
    } catch (err) {
        console.warn('[tickets] agents roster fetch failed:', err?.message || err);
    }
}
// Reactive items builders for the multi-select person pickers — passed to the
// shared ContextDropdown as `itemsFn` (re-derived on every menu render, so the
// check marks track the live filter arrays). Humans first (sorted), then a
// separator line, then agents (sorted) — 2026-08-06 per Nika "in filter
// drdopwon make line and list agents below humans".
const $1c8d0197eeddcb2e$var$_personPickItems = function(root, field) {
    const picked = (0, $jXdHE.personFilterEmails)(root?.[field]);
    const people = (root?.people || []).filter((p)=>p && p.email);
    const agents = $1c8d0197eeddcb2e$export$c8074394f3eff071(root);
    const rows = [
        {
            // A bundle KEY — the shared ContextDropdownItem resolves `s.label`
            // through polyglot, and every real person row below carries a name,
            // which polyglot returns verbatim.
            label: 'tickets.filter.anyone',
            icon: 'people',
            checked: !picked.length,
            action: {
                field: field,
                value: null,
                multi: true
            }
        },
        ...people.map((p)=>({
                label: p.name || p.username || p.email,
                avatar: this.call('avatarUrlFor', p.email),
                checked: picked.includes(p.email),
                action: {
                    field: field,
                    value: p.email,
                    multi: true
                }
            })).sort((a, b)=>a.label.localeCompare(b.label, undefined, {
                sensitivity: 'base'
            }))
    ];
    if (agents.length) {
        rows.push({
            key: `${field}-agents-divider`,
            divider: true
        });
        rows.push(...agents.map((a)=>({
                label: a.name,
                avatar: a.avatar || this.call('avatarUrlFor', a.email),
                checked: picked.includes(a.email),
                action: {
                    field: field,
                    value: a.email,
                    multi: true
                }
            })).sort((x, y)=>x.label.localeCompare(y.label, undefined, {
                sensitivity: 'base'
            })));
    }
    return rows;
};
function $1c8d0197eeddcb2e$export$a258cfa2d06d0443(root) {
    return $1c8d0197eeddcb2e$var$_personPickItems.call(this, root, 'filterAssignee');
}
function $1c8d0197eeddcb2e$export$f48efae8309dd5e7(root) {
    return $1c8d0197eeddcb2e$var$_personPickItems.call(this, root, 'filterIssuer');
}
function $1c8d0197eeddcb2e$export$b234c8038d7d3bf7(root) {
    const active = root?.filterEpic || null;
    const names = (0, $jXdHE.ticketsEpicNames)(root);
    return [
        {
            label: 'tickets.filter.anyEpic',
            icon: 'star',
            checked: !active,
            action: {
                field: 'filterEpic',
                value: null
            }
        },
        ...names.map((name)=>({
                label: name,
                checked: active === name,
                // Toggle-clear: picking the active epic again clears the filter.
                action: {
                    field: 'filterEpic',
                    value: active === name ? null : name
                }
            }))
    ];
}
const $1c8d0197eeddcb2e$export$8301b216684d7136 = async function({ force: force = false, root: rootOverride } = {}) {
    const root = rootOverride || this.state?.root;
    if (!root) return;
    if (!force && root.epicsTree?.length) return;
    // Prefer the live, init-deferring `this.sdk` over calling getSDK directly
    // — getSDK() can resolve null this early (mount-time onCreate), and its
    // swallowed throw used to commit an empty result that STUCK — epicsTree
    // looked "loaded" but stayed empty forever. this.sdk resolves once init
    // actually completes (mirrors the 3 call sites this replaces). This
    // function is `this`-bound (invoked via el.call('loadEpicsTree')), so
    // this.call reaches getSDK the same way el.call does elsewhere in this
    // file — no raw import either way.
    const sdk = this.sdk || this.call('getSDK');
    if (!sdk?.getService) return;
    try {
        const svc = await sdk.getService('tickets');
        const page = await svc.listAll({
            type: 'epic',
            deleted: false
        }, {
            sortBy: 'title',
            sortDir: 'asc'
        });
        const rows = Array.isArray(page?.items) ? page.items : [];
        // Only commit a NON-EMPTY result unless force:true — a transient empty
        // response (auth not ready, brief network blip) must never poison an
        // already-populated cache. force:true (post-mutation refresh) always
        // commits, including empty — e.g. deleting the last epic must clear it.
        if (rows.length || force) root.update({
            epicsTree: rows.map($1c8d0197eeddcb2e$var$_mongoToTicket)
        });
    } catch (err) {
        console.warn('[loadEpicsTree] failed:', err?.message || err);
    }
};
const $1c8d0197eeddcb2e$export$99ee43af29c56bcc = async function(colKey) {
    const root = this.state?.root;
    if (!root) return;
    // Offset derives from the rows ACTUALLY in the store, not the
    // loadedByColumn counter — the counter drifts (creates / drag-moves /
    // deletes mutate root.tickets without maintaining it), and a stale-low
    // offset re-fetched rows the column already displayed, appending
    // duplicate cards (2026-07-29 per Nika "after clicking duplicates").
    const loaded = (0, $jXdHE.countTicketsInColumn)(root, colKey);
    const total = (root.totalByColumn || {})[colKey] || 0;
    if (loaded >= total) return;
    if ((root.loadingColumn || {})[colKey]) return;
    root.update({
        loadingColumn: {
            ...root.loadingColumn || {},
            [colKey]: true
        }
    });
    try {
        // fetchColumnPage already returns _mongoToTicket-normalized rows
        const rows = await $1c8d0197eeddcb2e$export$ad42fd312b9b2241(this, colKey, loaded, $1c8d0197eeddcb2e$export$8ec3d08588d2eeda, $1c8d0197eeddcb2e$var$filtersFromRoot(root), 'pageColumn');
        // Dedupe by id no matter what the server returns — offset paging over
        // a mutating, position-sorted collection can always overlap (a ticket
        // moved into the column shifts every offset). Duplicates must be
        // impossible at the append site. String() both sides: optimistic
        // creates carry a numeric Date.now() id until the real id lands.
        const have = new Set((root.tickets || []).map((t)=>String(t?.id)));
        const fresh = rows.filter((t)=>t && !have.has(String(t.id)));
        const patch = {
            tickets: [
                ...root.tickets || [],
                ...fresh
            ],
            loadedByColumn: {
                ...root.loadedByColumn || {},
                [colKey]: loaded + rows.length
            },
            loadingColumn: {
                ...root.loadingColumn || {},
                [colKey]: false
            }
        };
        // Self-heal a stale-high total: an empty page at this offset means the
        // server has no more rows — snap the total down so the More button
        // stops advertising pages that don't exist.
        if (!rows.length) patch.totalByColumn = {
            ...root.totalByColumn || {},
            [colKey]: loaded
        };
        root.update(patch);
    } catch (e) {
        console.error('[pageColumn]', e?.message || e);
        root.update({
            loadingColumn: {
                ...root.loadingColumn || {},
                [colKey]: false
            }
        });
    }
};
const $1c8d0197eeddcb2e$export$dd9c63e54367b8f = async (root, el)=>{
    if (!root) return;
    if (!el || typeof el.call !== 'function') {
        console.warn('[ticketLoaders] reloadTicketsForRoot: no element to read through; board unchanged');
        return;
    }
    const filters = $1c8d0197eeddcb2e$var$filtersFromRoot(root);
    const query = JSON.stringify(filters);
    const stillAsked = ()=>JSON.stringify($1c8d0197eeddcb2e$var$filtersFromRoot(root)) === query;
    const colKeys = (root.columns || []).map((c)=>c.key);
    const heldKeys = Object.keys(root.loadedByColumn || {});
    const totals = await $1c8d0197eeddcb2e$export$b287101829b24124(el, filters, colKeys.length ? colKeys : null);
    if (!stillAsked()) return;
    root.update({
        totalByColumn: totals,
        tickets: [],
        loadedByColumn: {}
    });
    const keys = [
        ...new Set([
            ...Object.keys(totals),
            ...$1c8d0197eeddcb2e$export$c56c0834e91b5b02,
            ...heldKeys
        ])
    ];
    const first = await Promise.all(keys.map(async (colKey)=>{
        if (!totals[colKey]) return {
            colKey: colKey,
            rows: []
        };
        // fetchColumnPage already returns _mongoToTicket-normalized rows
        const rows = await $1c8d0197eeddcb2e$export$ad42fd312b9b2241(el, colKey, 0, $1c8d0197eeddcb2e$export$90091b93f6cf4241, filters, 'reload');
        return {
            colKey: colKey,
            rows: rows
        };
    }));
    if (!stillAsked()) return;
    const merged = [];
    const loaded = {};
    for (const { colKey: colKey, rows: rows } of first){
        merged.push(...rows);
        loaded[colKey] = rows.length;
    }
    root.update({
        tickets: merged,
        loadedByColumn: loaded
    });
};
const $1c8d0197eeddcb2e$export$b96b5ca5b7717416 = async function() {
    return $1c8d0197eeddcb2e$export$dd9c63e54367b8f(this.state?.root, this);
};

});
parcelRegister("jXdHE", function(module, exports) {

$parcel$export(module.exports, "canonicalTaskPath", () => $e86e282c62d0f3f2$export$6781b78238940125);
$parcel$export(module.exports, "PRIORITY_COLOR", () => $e86e282c62d0f3f2$export$5b5b02845d726b92);
$parcel$export(module.exports, "PRIORITY_INK", () => $e86e282c62d0f3f2$export$bbe24d20294a7ed1);
$parcel$export(module.exports, "PRIORITY_LABEL", () => $e86e282c62d0f3f2$export$b62628fba3f14f0);
$parcel$export(module.exports, "priorityLabel", () => $e86e282c62d0f3f2$export$c8636e4b51f96932);
$parcel$export(module.exports, "PRIORITY_OPTIONS", () => $e86e282c62d0f3f2$export$18c0478e36c51c5b);
$parcel$export(module.exports, "ISSUE_TYPE_COLOR", () => $e86e282c62d0f3f2$export$b3ccdd082c7d7e80);
$parcel$export(module.exports, "ISSUE_TYPE_INK", () => $e86e282c62d0f3f2$export$665ab2b2526e8fcb);
$parcel$export(module.exports, "STATE_COLOR", () => $e86e282c62d0f3f2$export$4013ea9a9e0e135b);
$parcel$export(module.exports, "TICKET_STATE_COLOR", () => $e86e282c62d0f3f2$export$fa49b0dc2763b686);
$parcel$export(module.exports, "stateLabelText", () => $e86e282c62d0f3f2$export$4b0157d53e8a2de0);
$parcel$export(module.exports, "formatStateLabel", () => $e86e282c62d0f3f2$export$d70a81c727729581);
$parcel$export(module.exports, "columnLabelText", () => $e86e282c62d0f3f2$export$8e7a8e4000b44d9);
$parcel$export(module.exports, "isTerminalTicketState", () => $e86e282c62d0f3f2$export$403c0896c8463fd7);
$parcel$export(module.exports, "isTicketRowDone", () => $e86e282c62d0f3f2$export$9e63b728ebd00643);
$parcel$export(module.exports, "resolveAssignees", () => $e86e282c62d0f3f2$export$a02f612761bc2ba4);
$parcel$export(module.exports, "resolvePersonDisplay", () => $e86e282c62d0f3f2$export$8cc74e5f3605730);
$parcel$export(module.exports, "columnKeyByLabel", () => $e86e282c62d0f3f2$export$5f50e8c220d4f33e);
$parcel$export(module.exports, "ticketColumnsFetch", () => $e86e282c62d0f3f2$export$666118d589db64fb);
$parcel$export(module.exports, "rowToColumn", () => $e86e282c62d0f3f2$export$599eb21456b62b61);
$parcel$export(module.exports, "pageBoilerplateFetch", () => $e86e282c62d0f3f2$export$bfdc331eea09f8e6);
$parcel$export(module.exports, "rowToTicket", () => $e86e282c62d0f3f2$export$d46a4ac5551c4d19);
$parcel$export(module.exports, "personFilterEmails", () => $e86e282c62d0f3f2$export$50fb4567517e5e85);
$parcel$export(module.exports, "ticketsEpicNames", () => $e86e282c62d0f3f2$export$83415ce094aae2aa);
$parcel$export(module.exports, "BOARD_PLANNING_TYPES", () => $e86e282c62d0f3f2$export$dabffcdc755855cf);
$parcel$export(module.exports, "ticketBelongsOnBoard", () => $e86e282c62d0f3f2$export$65de312705b7976e);
$parcel$export(module.exports, "ticketHiddenFromBoardReason", () => $e86e282c62d0f3f2$export$6e003f925d0f4f8d);
$parcel$export(module.exports, "getTicketsForColumn", () => $e86e282c62d0f3f2$export$f46824493a9d9e8b);
$parcel$export(module.exports, "countTicketsInColumn", () => $e86e282c62d0f3f2$export$7907d9c0775d3471);
$parcel$export(module.exports, "PENDING_CREATE_WINDOW_MS", () => $e86e282c62d0f3f2$export$fc7cd2e94ffc45fa);
$parcel$export(module.exports, "matchPendingCreate", () => $e86e282c62d0f3f2$export$4bd02a0aaa414193);
$parcel$export(module.exports, "positionBetween", () => $e86e282c62d0f3f2$export$b1da032ddb0c4c4a);
$parcel$export(module.exports, "startColumnDrag", () => $e86e282c62d0f3f2$export$e72fa452e68bbaa6);
$parcel$export(module.exports, "startTicketDrag", () => $e86e282c62d0f3f2$export$5d6544467bb847ea);
$parcel$export(module.exports, "DRAFT_COLUMN_KEY", () => $e86e282c62d0f3f2$export$ea82df13963f4500);
$parcel$export(module.exports, "getColumnAccent", () => $e86e282c62d0f3f2$export$c690e53c8b88d20f);
$parcel$export(module.exports, "IN_PROGRESS_COLUMN_KEY", () => $e86e282c62d0f3f2$export$f861c10be393a9b5);
$parcel$export(module.exports, "REVIEW_COLUMN_KEY", () => $e86e282c62d0f3f2$export$89127c3baae95678);
$parcel$export(module.exports, "DONE_COLUMN_KEY", () => $e86e282c62d0f3f2$export$15924ca4d5d3bfac);
$parcel$export(module.exports, "ticketCanvasPos", () => $e86e282c62d0f3f2$export$3a8aeb6ebddeaea8);
$parcel$export(module.exports, "ticketPlacement", () => $e86e282c62d0f3f2$export$c9582ce5b36cd041);
$parcel$export(module.exports, "ticketShareUrl", () => $e86e282c62d0f3f2$export$9b805be627022d44);
$parcel$export(module.exports, "isActiveColumn", () => $e86e282c62d0f3f2$export$3dee54d8f4ee86cf);
$parcel$export(module.exports, "ticketToStoryCard", () => $e86e282c62d0f3f2$export$a76503c6633fec21);
$parcel$export(module.exports, "freshTicket", () => $e86e282c62d0f3f2$export$18662d6c72836307);
$parcel$export(module.exports, "normalizeCommentDoc", () => $e86e282c62d0f3f2$export$914c1c67c09255d8);
$parcel$export(module.exports, "canManageTicketComment", () => $e86e282c62d0f3f2$export$bc7c1faee7e65366);
$parcel$export(module.exports, "decodeTicketEntities", () => $e86e282c62d0f3f2$export$4e4c9be35165ced6);
$parcel$export(module.exports, "ticketBodyMarkdown", () => $e86e282c62d0f3f2$export$6eeb591c7476759b);
$parcel$export(module.exports, "ticketSafeMarkdownLinks", () => $e86e282c62d0f3f2$export$6cb48d788fa7d4b5);
$parcel$export(module.exports, "cleanTicketEditorHtml", () => $e86e282c62d0f3f2$export$431f28959f837854);
$parcel$export(module.exports, "ticketBodyPlainText", () => $e86e282c62d0f3f2$export$ab5cc5672e242b50);
$parcel$export(module.exports, "ticketSafeUrl", () => $e86e282c62d0f3f2$export$19ec74adc469b4de);
$parcel$export(module.exports, "sanitizeTicketHtml", () => $e86e282c62d0f3f2$export$5559eb70efe87b39);

var $bnEwy = parcelRequire("bnEwy");
const $e86e282c62d0f3f2$export$6781b78238940125 = (path)=>{
    const p = String(path || '');
    if (p === '/tickets-page') return '/tasks-page';
    if (p === '/tickets') return '/tasks';
    if (p.startsWith('/tickets/')) return '/tasks/' + p.slice(9);
    if (p.startsWith('/ticket/')) return '/task/' + p.slice(8);
    return p;
};
const $e86e282c62d0f3f2$export$5b5b02845d726b92 = {
    urgent: 'red',
    P0: 'red',
    P1: 'orange',
    high: 'orange',
    medium: 'blue',
    P2: 'blue',
    low: 'caption',
    P3: 'caption'
};
const $e86e282c62d0f3f2$export$bbe24d20294a7ed1 = {
    urgent: 'dangerInk',
    P0: 'dangerInk',
    P1: 'warningInk',
    high: 'warningInk',
    medium: 'accentInk',
    P2: 'accentInk',
    low: 'caption',
    P3: 'caption'
};
const $e86e282c62d0f3f2$export$b62628fba3f14f0 = {
    urgent: 'P0',
    P0: 'P0',
    high: 'P1',
    P1: 'P1',
    medium: 'P2',
    P2: 'P2',
    low: 'P3',
    P3: 'P3'
};
const $e86e282c62d0f3f2$export$c8636e4b51f96932 = (priority)=>{
    if (!priority) return '';
    return $e86e282c62d0f3f2$export$b62628fba3f14f0[priority] || String(priority).toUpperCase();
};
const $e86e282c62d0f3f2$export$18c0478e36c51c5b = [
    {
        value: '',
        text: 'tickets.priority.option.none'
    },
    {
        value: 'P0',
        text: 'tickets.priority.option.p0'
    },
    {
        value: 'P1',
        text: 'tickets.priority.option.p1'
    },
    {
        value: 'P2',
        text: 'tickets.priority.option.p2'
    },
    {
        value: 'P3',
        text: 'tickets.priority.option.p3'
    }
];
const $e86e282c62d0f3f2$export$b3ccdd082c7d7e80 = {
    Bug: 'red',
    Feature: 'green',
    Task: 'blue',
    Enhancement: 'green',
    'User Story': 'purple',
    Epic: 'orange',
    bug: 'red',
    task: 'blue',
    spike: 'blue',
    decision: 'green',
    user_story: 'purple',
    epic: 'orange'
};
const $e86e282c62d0f3f2$export$665ab2b2526e8fcb = {
    Bug: 'dangerInk',
    Feature: 'successInk',
    Task: 'accentInk',
    Enhancement: 'successInk',
    'User Story': 'magentaInk',
    Epic: 'warningInk',
    bug: 'dangerInk',
    task: 'accentInk',
    spike: 'accentInk',
    decision: 'successInk',
    user_story: 'magentaInk',
    epic: 'warningInk'
};
const $e86e282c62d0f3f2$export$4013ea9a9e0e135b = {
    OPEN: 'green',
    CLOSED: 'caption',
    MERGED: 'purple'
};
const $e86e282c62d0f3f2$export$fa49b0dc2763b686 = {
    not_started: 'caption',
    in_progress: 'yellow',
    blocked: 'red',
    awaiting_approval: 'orange',
    ready_to_review: 'purple',
    ready_to_test: 'magenta',
    done: 'green',
    released: 'blue',
    cancelled: 'caption',
    // Legacy alias — historical rows still carry 'CLOSED' until they're
    // re-saved. Resolves to the same cancelled palette.
    CLOSED: 'caption',
    closed: 'caption'
};
// Human-readable labels for all canonical ticket states.
// Falls back to title-cased raw value so new states degrade gracefully.
const $e86e282c62d0f3f2$var$STATE_LABEL = {
    not_started: 'Not Started',
    in_progress: 'In Progress',
    blocked: 'Blocked',
    awaiting_approval: 'Awaiting Approval',
    ready_to_review: 'Ready to Review',
    ready_to_test: 'Ready to Test',
    done: 'Done',
    released: 'Released',
    cancelled: 'Cancelled',
    CLOSED: 'Cancelled',
    closed: 'Cancelled'
};
// The same table as bundle KEYS. `formatStateLabel` answers English and stays
// for callers that have no element (logs, exports). Every label a person reads
// goes through `stateLabelText(el, state)`: the state pill on a card, in the
// detail modal and on the General view read `In Progress` on a Georgian board
// (live walk 2026-09-21).
const $e86e282c62d0f3f2$var$STATE_LABEL_KEY = {
    not_started: 'tickets.state.notStarted',
    in_progress: 'tickets.state.inProgress',
    blocked: 'tickets.state.blocked',
    awaiting_approval: 'tickets.state.awaitingApproval',
    ready_to_review: 'tickets.state.readyToReview',
    ready_to_test: 'tickets.state.readyToTest',
    done: 'tickets.state.done',
    released: 'tickets.state.released',
    cancelled: 'tickets.state.cancelled',
    CLOSED: 'tickets.state.cancelled',
    closed: 'tickets.state.cancelled'
};
const $e86e282c62d0f3f2$export$4b0157d53e8a2de0 = (el, state)=>{
    const key = $e86e282c62d0f3f2$var$STATE_LABEL_KEY[state];
    return key && el && typeof el.call === 'function' ? el.call('polyglot', key) : $e86e282c62d0f3f2$export$d70a81c727729581(state);
};
const $e86e282c62d0f3f2$export$d70a81c727729581 = (state)=>{
    if (!state) return '';
    if ($e86e282c62d0f3f2$var$STATE_LABEL[state]) return $e86e282c62d0f3f2$var$STATE_LABEL[state];
    // Graceful fallback: replace underscores + title-case each word
    return state.replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
};
function $e86e282c62d0f3f2$export$8e7a8e4000b44d9(column) {
    const el = this;
    const col = column || {};
    const own = String(col.label || col.name || '');
    if (col.labelIsSeed !== true || !el || typeof el.call !== 'function') return own;
    // A seeded column's key -> the tickets key that names it.
    const keys = {
        backlog: 'tickets.detail.status.backlog',
        todo: 'tickets.detail.status.todo',
        in_progress: 'tickets.state.inProgress',
        blocked: 'tickets.state.blocked',
        ready_to_test: 'tickets.state.readyToTest',
        review: 'tickets.kanban.column.review',
        done: 'tickets.detail.status.done'
    };
    const key = Object.prototype.hasOwnProperty.call(keys, col.key) ? keys[col.key] : '';
    const source = el.context && el.context.polyglot && el.context.polyglot.defaultLang;
    if (!key || typeof source !== 'string' || !source) return own;
    const lang = el.call('getActiveLang');
    if (!lang || lang === source) return own;
    const text = el.call('polyglot', key);
    // Without the key in the active bundle polyglot answers the key itself or
    // the source language's text: the stored label shows then.
    if (typeof text !== 'string' || !text || text === key) return own;
    return text === el.call('polyglot', key, source) ? own : text;
}
function $e86e282c62d0f3f2$export$403c0896c8463fd7(state) {
    return state === 'done' || state === 'released' || state === 'cancelled';
}
function $e86e282c62d0f3f2$export$9e63b728ebd00643(row) {
    return $e86e282c62d0f3f2$export$403c0896c8463fd7(row.state) || !!row.metadata?.struck;
}
const $e86e282c62d0f3f2$export$a02f612761bc2ba4 = (el, ticket, people)=>{
    const out = [];
    const seen = new Set();
    // Build a one-shot map for the call so the two passes below don't
    // re-walk `people` per assignee. WeakMap caching only kicks in when
    // the caller passes `root.people` directly — this local map handles
    // the smaller per-call list either way.
    const list = people || [];
    const byEmail = new Map();
    const byGithub = new Map();
    for (const p of list){
        if (p.email) byEmail.set(p.email, p);
        if (p.github) byGithub.set(p.github, p);
    }
    if (ticket?.assigneeEmail) {
        const p = byEmail.get(ticket.assigneeEmail);
        out.push({
            key: ticket.assigneeEmail,
            name: p?.name || ticket.assigneeEmail,
            avatar: p?.avatar || el.call('avatarUrl', p?.name || ticket.assigneeEmail),
            login: p?.github
        });
        seen.add(ticket.assigneeEmail);
        if (p?.github) seen.add(p.github);
    }
    for (const login of ticket?.assigneeLogins || []){
        if (!login || seen.has(login)) continue;
        const p = byGithub.get(login);
        if (p?.email && seen.has(p.email)) continue;
        out.push({
            key: login,
            name: p?.name || login,
            avatar: `https://github.com/${login}.png?size=64`,
            login: login
        });
        seen.add(login);
        if (p?.email) seen.add(p.email);
    }
    return out;
};
const $e86e282c62d0f3f2$export$8cc74e5f3605730 = (identifier, people)=>{
    if (!identifier) return null;
    const list = people || [];
    const byEmail = list.find((p)=>p && p.email === identifier);
    if (byEmail) return {
        name: byEmail.name || identifier,
        avatar: byEmail.avatar || '',
        email: byEmail.email
    };
    const byGithub = list.find((p)=>p && p.github === identifier);
    if (byGithub) return {
        name: byGithub.name || identifier,
        avatar: byGithub.avatar || `https://github.com/${identifier}.png?size=64`,
        email: byGithub.email || null
    };
    // No match anywhere — a bare login (no '@') is still a GitHub identity,
    // just for someone not in `people` yet. A real email with no match falls
    // back to initials via avatarUrl at the call site.
    const isGithubLogin = !identifier.includes('@');
    return {
        name: identifier,
        avatar: isGithubLogin ? `https://github.com/${identifier}.png?size=64` : '',
        email: isGithubLogin ? null : identifier
    };
};
const $e86e282c62d0f3f2$export$5f50e8c220d4f33e = (root, label)=>{
    const c = (root?.columns || []).find((c)=>c.label === label);
    return c?.key || null;
};
const $e86e282c62d0f3f2$export$666118d589db64fb = {
    method: 'select',
    from: 'tickets.columns',
    as: '~/columns',
    cache: '5m',
    // WORKSPACE-TICKETS-COLUMNS-TRANSFORM-NONARRAY (/logs 85041/85042).
    // Defensive: when the SDK returns a truthy non-array (error envelope,
    // paginated wrapper) `rows || []` keeps the non-array and `.map`
    // throws at preboot. Array.isArray guard is the only safe coercion.
    transform: (rows)=>({
            columns: Array.isArray(rows) ? rows.map($e86e282c62d0f3f2$export$599eb21456b62b61) : []
        })
};
const $e86e282c62d0f3f2$export$bfdc331eea09f8e6 = [
    ...(0, $bnEwy.appPageBoilerplateFetch),
    $e86e282c62d0f3f2$export$666118d589db64fb
];
const $e86e282c62d0f3f2$var$_foldFieldValues = (fvs)=>{
    const out = {};
    for (const v of fvs || []){
        const name = v.project_fields?.name;
        if (!name) continue;
        let value = null;
        if (v.option_name != null) value = v.option_name;
        else if (v.number_value != null) value = v.number_value;
        else if (v.date_value != null) value = v.date_value;
        else if (v.text_value != null) value = v.text_value;
        if (value != null) out[name] = value;
    }
    return out;
};
const $e86e282c62d0f3f2$export$d46a4ac5551c4d19 = (r)=>{
    const customFields = $e86e282c62d0f3f2$var$_foldFieldValues(r.ticket_field_values);
    return {
        id: r.id,
        title: r.title,
        body: r.body,
        columnKey: r.column_key,
        position: r.position,
        assigneeEmail: r.assignee_email,
        assigneeLogins: r.assignee_logins || [],
        reporterEmail: r.reporter_email,
        labels: r.labels || [],
        // Priority comes from the GitHub Project's custom field — fall back
        // to the column on the tickets table if a future migration adds it.
        priority: customFields.Priority || r.priority || null,
        dueDate: customFields['Due Date'] || r.due_date,
        githubUrl: r.github_issue_url,
        githubNodeId: r.github_node_id,
        // Mirrored Projects v2 metadata (see migrations 0014 / 0016).
        number: r.number,
        contentType: r.content_type,
        state: r.state,
        repository: r.repository,
        milestone: r.milestone,
        iterationId: r.iteration_id,
        iterationTitle: r.iteration_title || customFields.Iteration,
        iterationStart: r.iteration_start,
        iterationEnd: r.iteration_end,
        trackedByCount: r.tracked_by_count || 0,
        tracksCount: r.tracks_count || 0,
        // Issues 2.0 — GitHub native issue type + the project-level Epic field.
        issueType: r.issue_type,
        issueTypeColor: r.issue_type_color,
        epicOptionId: r.epic_option_id,
        epicName: r.epic_name || customFields.Epic,
        parentIssueUrl: r.parent_issue_url,
        subIssuesTotal: r.sub_issues_total || 0,
        subIssuesCompleted: r.sub_issues_completed || 0,
        // Common Projects v2 custom fields, surfaced as first-class props
        // for the card UI. Anything not in this list is still available via
        // `customFields[name]`.
        severity: customFields.Severity || null,
        storyPoints: customFields['Story Points'] || null,
        size: customFields.Size || null,
        estimate: customFields.Estimate || null,
        environment: customFields.Environment || null,
        reviewStatus: customFields['Review Status'] || null,
        customFields: customFields,
        createdAt: r.created_at,
        updatedAt: r.updated_at
    };
};
const $e86e282c62d0f3f2$export$599eb21456b62b61 = (r)=>({
        id: r.id,
        key: r.key,
        label: r.label,
        position: r.position,
        color: r.color,
        description: r.description,
        optionId: r.option_id,
        // The server's mark for a column whose key and label still equal its seed
        // row (columnLabelText reads it). A server that does not send it adds nothing.
        ...typeof r.labelIsSeed === 'boolean' ? {
            labelIsSeed: r.labelIsSeed
        } : {}
    });
// Filter + sort tickets that belong to a given column. Honours the active
// filter slots on root state so the board re-renders reactively when the
// user toggles a chip.
//
// Memoised: a single pass over `root.tickets` builds the entire
// `columnKey → tickets[]` index, cached on a WeakMap keyed off the
// `root.tickets` array identity. Subsequent calls (12 columns × 2 cell
// renderers per render) hit the cache. The cache is invalidated when
// `root.tickets` is replaced wholesale (the smbls update pattern) or
// when the filter signature changes — both cheap O(1) checks.
const $e86e282c62d0f3f2$var$_columnIndexCache = new WeakMap();
const $e86e282c62d0f3f2$var$_EMPTY_LIST = Object.freeze([]);
const $e86e282c62d0f3f2$export$50fb4567517e5e85 = (v)=>{
    if (!v || v === 'all') return $e86e282c62d0f3f2$var$_EMPTY_LIST;
    if (Array.isArray(v)) return v;
    if (v === 'me' || v === 'team' || v === 'agents') return $e86e282c62d0f3f2$var$_EMPTY_LIST;
    return [
        v
    ];
};
const $e86e282c62d0f3f2$export$83415ce094aae2aa = (root)=>{
    const seen = new Map() // lowercase key -> display casing
    ;
    const add = (name)=>{
        const trimmed = (name || '').trim();
        if (!trimmed) return;
        const key = trimmed.toLowerCase();
        if (!seen.has(key)) seen.set(key, trimmed);
    };
    for (const ep of root?.epicsTree || [])add(ep?.title);
    for (const t of root?.tickets || [])add(t?.epicName);
    return Array.from(seen.values()).sort((a, b)=>a.localeCompare(b, undefined, {
            sensitivity: 'base'
        }));
};
const $e86e282c62d0f3f2$var$_filterSignature = (root)=>`${[].concat(root.filterAssignee || []).join(',')}|${[].concat(root.filterIssuer || []).join(',')}|${root.filterLabel || ''}|${root.filterEpic || ''}|${root.filterIssueType || ''}|${(root.searchQuery || '').toLowerCase().trim()}|${root.currentUserEmail || ''}|${root.filterProjectId || ''}`;
const $e86e282c62d0f3f2$export$dabffcdc755855cf = [
    'epic',
    'user_story'
];
const $e86e282c62d0f3f2$export$65de312705b7976e = (root, t)=>{
    if (!root || !t) return false;
    if (root.workspace?.id && t.workspaceId && String(t.workspaceId) !== String(root.workspace.id)) return false;
    // Mongo rows carry the kind on `type` (the legacy Supabase shape's
    // `issueType` is hardcoded null in _mongoToTicket) — checking only
    // t.issueType dropped EVERY server-filtered row client-side, blanking
    // the board whenever a type filter was active.
    const issueType = root.filterIssueType;
    const kind = t.issueType || t.type;
    if (issueType) {
        if (kind !== issueType) return false;
    } else if ($e86e282c62d0f3f2$export$dabffcdc755855cf.includes(kind)) return false;
    const me = root.currentUserEmail;
    const assignee = root.filterAssignee;
    const issuer = root.filterIssuer;
    const assigneeEmails = $e86e282c62d0f3f2$export$50fb4567517e5e85(assignee);
    const issuerEmails = $e86e282c62d0f3f2$export$50fb4567517e5e85(issuer);
    const label = root.filterLabel;
    const epic = root.filterEpic;
    const q = (root.searchQuery || '').trim().toLowerCase();
    if (assigneeEmails.length) {
        if (!assigneeEmails.includes(t.assigneeEmail)) return false;
    } else if (assignee === 'me' && t.assigneeEmail !== me) return false;
    // Issuer (reporter) — one or more people picked in the sidebar.
    if (issuerEmails.length && !issuerEmails.includes(t.reporterEmail)) return false;
    if (label && !(t.labels || []).includes(label)) return false;
    // Epic filter is NAME-based (Mongo `epic` column → epicName) — the old
    // epicOptionId GUID is never set on Mongo rows.
    if (epic && t.epicName !== epic) return false;
    // The project scope (/tasks?project=<id>): a realtime row of another
    // project stays off the board. A row that carries no project field at all
    // (an older normalizer) is the server's read and already scoped.
    const project = root.filterProjectId;
    if (project && t.project !== undefined && String(t.project || '') !== String(project)) return false;
    if (q && !((t.title || '').toLowerCase().includes(q) || (t.body || '').toLowerCase().includes(q))) return false;
    return true;
};
const $e86e282c62d0f3f2$export$6e003f925d0f4f8d = (root, t)=>{
    if (!root || !t) return null;
    if ($e86e282c62d0f3f2$export$65de312705b7976e(root, t)) return null;
    const kind = t.issueType || t.type;
    if (!root.filterIssueType && $e86e282c62d0f3f2$export$dabffcdc755855cf.includes(kind)) return 'planning-type';
    return 'filters';
};
const $e86e282c62d0f3f2$var$_buildColumnIndex = (root)=>{
    const byCol = new Map();
    for (const t of root.tickets || []){
        if (!$e86e282c62d0f3f2$export$65de312705b7976e(root, t)) continue;
        let arr = byCol.get(t.columnKey);
        if (!arr) {
            arr = [];
            byCol.set(t.columnKey, arr);
        }
        arr.push(t);
    }
    for (const arr of byCol.values())arr.sort((a, b)=>(a.position || 0) - (b.position || 0));
    return byCol;
};
function $e86e282c62d0f3f2$export$f46824493a9d9e8b(root, columnKey) {
    if (!root || !root.tickets) return $e86e282c62d0f3f2$var$_EMPTY_LIST;
    let entry = $e86e282c62d0f3f2$var$_columnIndexCache.get(root.tickets);
    const sig = $e86e282c62d0f3f2$var$_filterSignature(root);
    if (!entry || entry.sig !== sig) {
        entry = {
            sig: sig,
            byCol: $e86e282c62d0f3f2$var$_buildColumnIndex(root)
        };
        $e86e282c62d0f3f2$var$_columnIndexCache.set(root.tickets, entry);
    }
    return entry.byCol.get(columnKey) || $e86e282c62d0f3f2$var$_EMPTY_LIST;
}
function $e86e282c62d0f3f2$export$7907d9c0775d3471(root, columnKey) {
    const list = root?.tickets;
    if (!Array.isArray(list)) return 0;
    let n = 0;
    for (const t of list)if (t && t.columnKey === columnKey) n++;
    return n;
}
const $e86e282c62d0f3f2$export$fc7cd2e94ffc45fa = 20000;
function $e86e282c62d0f3f2$export$4bd02a0aaa414193(pendingCreates, row, now = Date.now()) {
    if (!Array.isArray(pendingCreates) || !pendingCreates.length || !row) return null;
    const title = row.title;
    if (!title) return null;
    // Newest first — two quick creates with the SAME title must consume their
    // own breadcrumbs, never the same one twice.
    const candidates = pendingCreates.filter((p)=>p && p.title === title && now - (p.ts || 0) < $e86e282c62d0f3f2$export$fc7cd2e94ffc45fa).sort((a, b)=>(b.ts || 0) - (a.ts || 0));
    return candidates[0] || null;
}
function $e86e282c62d0f3f2$export$b1da032ddb0c4c4a(prev, next) {
    if (prev == null && next == null) return 1000;
    if (prev == null) return next - 1000;
    if (next == null) return prev + 1000;
    return (prev + next) / 2;
}
const $e86e282c62d0f3f2$export$e72fa452e68bbaa6 = function(e, colKey) {
    const headerEl = this && this.node;
    const root = this?.state?.root;
    if (!headerEl || !root || !colKey) return;
    const colEl = headerEl.closest('[data-col-key]');
    if (!colEl) return;
    e.preventDefault();
    // Track the initiating pointer so a second finger landing mid-drag can't
    // hijack the reorder (mouse always reports pointerId 1). POINTER events (not
    // mouse) let a finger reorder columns on iPad too.
    const pointerId = e.pointerId;
    const self = this;
    const startX = e.clientX;
    const startY = e.clientY;
    const rect = headerEl.getBoundingClientRect();
    const offX = startX - rect.left;
    const offY = startY - rect.top;
    const scale = typeof window !== 'undefined' && window.__ticketsPzScale || 1;
    let ghost = null;
    let indicator = null;
    let dragging = false;
    // Insertion indicator — a vertical bar at the edge where the column will
    // land (before/after the hovered column by cursor side), so the drop
    // destination is visible while dragging.
    const _placeIndicator = (ev)=>{
        const under = document.elementFromPoint(ev.clientX, ev.clientY);
        const target = under && under.closest && under.closest('[data-col-key]');
        const targetKey = target && target.getAttribute('data-col-key');
        if (!target || targetKey === colKey) {
            if (indicator) indicator.style.display = 'none';
            return;
        }
        if (!indicator) {
            indicator = document.createElement('div');
            const st = indicator.style;
            st.position = 'fixed';
            st.width = '4px';
            st.borderRadius = '2px';
            st.background = 'var(--color-blue, #3a7bfd)';
            st.boxShadow = '0 0 12px var(--color-blue, #3a7bfd)';
            st.pointerEvents = 'none';
            st.zIndex = '99998';
            document.body.appendChild(indicator);
        }
        const r = target.getBoundingClientRect();
        const after = ev.clientX > r.left + r.width / 2;
        indicator.style.left = Math.round((after ? r.right : r.left) - 2) + 'px';
        indicator.style.top = Math.round(r.top) + 'px';
        indicator.style.height = Math.round(r.height) + 'px';
        indicator.style.display = 'block';
    };
    const onMove = (ev)=>{
        if (ev.pointerId !== pointerId) return;
        if (!dragging) {
            if (Math.abs(ev.clientX - startX) + Math.abs(ev.clientY - startY) < 6) return;
            dragging = true;
            ghost = headerEl.cloneNode(true);
            const gs = ghost.style;
            gs.position = 'fixed';
            gs.margin = '0';
            gs.left = '0';
            gs.top = '0';
            gs.width = headerEl.offsetWidth + 'px';
            gs.pointerEvents = 'none';
            gs.opacity = '0.9';
            gs.zIndex = '99999';
            gs.transformOrigin = 'top left';
            gs.background = 'rgba(20,20,22,0.95)';
            gs.borderRadius = '12px';
            document.body.appendChild(ghost);
            colEl.style.opacity = '0.4';
        }
        if (ghost) {
            ghost.style.transform = 'translate(' + (ev.clientX - offX) + 'px,' + (ev.clientY - offY) + 'px) scale(' + scale + ')';
            _placeIndicator(ev);
        }
    };
    const onUp = (ev)=>{
        if (ev && ev.pointerId !== pointerId) return;
        document.removeEventListener('pointermove', onMove, true);
        document.removeEventListener('pointerup', onUp, true);
        document.removeEventListener('pointercancel', onUp, true);
        if (ghost) {
            ghost.remove();
            ghost = null;
        }
        if (indicator) {
            indicator.remove();
            indicator = null;
        }
        colEl.style.opacity = '';
        if (!dragging) return;
        const under = document.elementFromPoint(ev.clientX, ev.clientY);
        const targetCol = under && under.closest && under.closest('[data-col-key]');
        const targetKey = targetCol && targetCol.getAttribute('data-col-key');
        if (!targetKey || targetKey === colKey) return;
        // Current visual order — live columns by position, or the fallback set.
        const live = (root.columns || []).filter((c)=>c.key !== 'unsynced');
        const ordered = live.length ? live.slice().sort((a, b)=>(a.position || 0) - (b.position || 0)) : Object.keys(root.totalByColumn || {}).filter((k)=>k !== 'unsynced').map((key, i)=>({
                key: key,
                label: key,
                position: i
            }));
        const keys = ordered.map((c)=>c.key);
        const fromIdx = keys.indexOf(colKey);
        const targetIdx = keys.indexOf(targetKey);
        if (fromIdx < 0 || targetIdx < 0) return;
        const tRect = targetCol.getBoundingClientRect();
        const after = ev.clientX > tRect.left + tRect.width / 2;
        let toIdx = targetIdx + (after ? 1 : 0);
        if (fromIdx < toIdx) toIdx--;
        if (toIdx === fromIdx) return;
        const nextKeys = keys.slice();
        nextKeys.splice(fromIdx, 1);
        nextKeys.splice(toIdx, 0, colKey);
        const byKey = {};
        ordered.forEach((c)=>{
            byKey[c.key] = c;
        });
        const nextCols = nextKeys.map((k, i)=>({
                ...byKey[k],
                position: i * 10
            }));
        root.update({
            columns: nextCols
        });
        (async ()=>{
            try {
                const svc = await self.sdk.getService('tickets');
                for (const c of nextCols){
                    const prev = byKey[c.key];
                    if ((prev.position || 0) !== c.position) await svc.columns.update(c.key, {
                        position: c.position
                    });
                }
            } catch (err) {
                console.warn('[startColumnDrag] persist failed:', err?.message || err);
            }
        })();
    };
    document.addEventListener('pointermove', onMove, true);
    document.addEventListener('pointerup', onUp, true);
    document.addEventListener('pointercancel', onUp, true);
};
const $e86e282c62d0f3f2$export$5d6544467bb847ea = function(e, ticketId) {
    if (!ticketId) return;
    const cardEl = this && this.node;
    const root = this && this.state && this.state.root;
    if (!cardEl || !root) return;
    e.preventDefault();
    // Track the initiating pointer so a second finger landing mid-drag can't
    // hijack the drag (mouse always reports pointerId 1). POINTER events (not
    // mouse) let a finger drag a card on iPad too.
    const pointerId = e.pointerId;
    const self = this;
    const startX = e.clientX;
    const startY = e.clientY;
    const rect = cardEl.getBoundingClientRect();
    const offX = startX - rect.left;
    const offY = startY - rect.top;
    const scale = typeof window !== 'undefined' && window.__ticketsPzScale || 1;
    let ghost = null;
    let dragging = false;
    // Drop-target highlight — a clean accent BORDER in the hovered column's OWN
    // status accent (so each lane lights up its colour). Just a border, no shadow
    // (per Nika). `outline` (not `border`) so there's zero layout shift, with a
    // negative offset so it hugs the column edge like a border. Imperative (like
    // the ghost above) so a fast drag never churns root state / re-renders the
    // whole board. Cleared on column change and on drop.
    let hoverCol = null;
    const setHoverCol = (colEl)=>{
        if (colEl === hoverCol) return;
        if (hoverCol) {
            hoverCol.style.outline = '';
            hoverCol.style.outlineOffset = '';
        }
        hoverCol = colEl;
        if (colEl) {
            const token = $e86e282c62d0f3f2$var$COLUMN_ACCENT[colEl.getAttribute('data-col-key')] || 'blue';
            colEl.style.outline = '2px solid var(--color-' + token + ')';
            colEl.style.outlineOffset = '-2px';
        }
    };
    // Attach-target highlight — same outline grammar as the column highlight,
    // on the hovered `data-ref-drop` surface (chat composer / AI prompt), so
    // the gesture reads as "this will ATTACH, not move" before release.
    let hoverAttach = null;
    const setHoverAttach = (elx)=>{
        if (elx === hoverAttach) return;
        if (hoverAttach) {
            hoverAttach.style.outline = '';
            hoverAttach.style.outlineOffset = '';
        }
        hoverAttach = elx;
        if (elx) {
            elx.style.outline = '2px solid var(--color-blue)';
            elx.style.outlineOffset = '-2px';
        }
    };
    const onMove = (ev)=>{
        if (ev.pointerId !== pointerId) return;
        if (!dragging) {
            if (Math.abs(ev.clientX - startX) + Math.abs(ev.clientY - startY) < 5) return;
            dragging = true;
            ghost = cardEl.cloneNode(true);
            const gs = ghost.style;
            gs.position = 'fixed';
            gs.margin = '0';
            gs.left = '0';
            gs.top = '0';
            gs.width = cardEl.offsetWidth + 'px';
            gs.pointerEvents = 'none';
            gs.opacity = '0.9';
            gs.zIndex = '99999';
            gs.transformOrigin = 'top left';
            document.body.appendChild(ghost);
            cardEl.style.opacity = '0.35';
        }
        if (ghost) ghost.style.transform = 'translate(' + (ev.clientX - offX) + 'px,' + (ev.clientY - offY) + 'px) scale(' + scale + ')';
        // Highlight the surface under the cursor (the ghost has
        // pointerEvents:none, so elementFromPoint sees beneath it): an attach
        // target wins over a column — releasing there never moves the card.
        const overEl = document.elementFromPoint(ev.clientX, ev.clientY);
        const attachOver = overEl && overEl.closest && overEl.closest('[data-ref-drop]') || null;
        setHoverAttach(attachOver);
        setHoverCol(attachOver ? null : overEl && overEl.closest && overEl.closest('[data-col-key]') || null);
    };
    const onUp = (ev)=>{
        if (ev && ev.pointerId !== pointerId) return;
        document.removeEventListener('pointermove', onMove, true);
        document.removeEventListener('pointerup', onUp, true);
        document.removeEventListener('pointercancel', onUp, true);
        if (ghost) {
            ghost.remove();
            ghost = null;
        }
        setHoverCol(null);
        setHoverAttach(null);
        cardEl.style.opacity = '';
        if (!dragging) return;
        // A COMPLETED pointer drag still gets a native trailing `click` on
        // whatever sits under the pointer (pointer events don't suppress it the
        // way HTML5 dnd does) — when the drop lands on/near the origin card that
        // click hit the card's onClick and OPENED the just-moved ticket
        // (2026-08-01 per Nika: "drag and drop should only be moving them
        // around — no accidental click"). Swallow exactly one click, capture
        // phase so no handler sees it; the timeout clears the trap when no
        // click follows (drop outside the window, pointercancel).
        const swallowClick = (ce)=>{
            ce.stopPropagation();
            ce.preventDefault();
            document.removeEventListener('click', swallowClick, true);
        };
        document.addEventListener('click', swallowClick, true);
        setTimeout(()=>document.removeEventListener('click', swallowClick, true), 400);
        const under = document.elementFromPoint(ev.clientX, ev.clientY);
        // Attach drop (2026-08-06 per Nika "task drag and drop in chat should
        // not change position of task ticket - it should get attached ... and
        // revert to its original position"): released over a declared ref-drop
        // surface (chat composer / AI prompt — `data-ref-drop`), the gesture is
        // an ATTACH, never a move. Deliver the ticket ref through the target's
        // own native onDrop (the same wire format TicketCard's native dragstart
        // stamps — shared/functions/dragRef.js) and leave the board state
        // UNTOUCHED: nothing was committed during the drag, so the card is
        // already back in its original position the moment the ghost is gone.
        const attachEl = under && under.closest && under.closest('[data-ref-drop]');
        if (attachEl) {
            const t = (root.tickets || []).find((x)=>String(x.id) === String(ticketId)) || {};
            try {
                self.call('dispatchRefDrop', attachEl, {
                    kind: 'ticket',
                    id: ticketId,
                    title: t.title || '',
                    href: `/tasks?ticket=${ticketId}`,
                    meta: {
                        number: t.number,
                        state: t.state
                    }
                }, {
                    clientX: ev.clientX,
                    clientY: ev.clientY
                });
            } catch (err) {
                console.warn('[startTicketDrag] ref attach failed', err?.message || err);
            }
            return;
        }
        const colEl = under && under.closest && under.closest('[data-col-key]');
        const colKey = colEl && colEl.getAttribute('data-col-key');
        if (colKey) {
            // Drop into a column. Clears any freeform placement (the card returns
            // to in-column flow) alongside the column/position move.
            const inCol = (root.tickets || []).filter((t)=>t.columnKey === colKey);
            const lastPos = inCol.length ? Math.max(...inCol.map((t)=>t.position || 0)) : 0;
            const nextPos = $e86e282c62d0f3f2$export$b1da032ddb0c4c4a(lastPos, null);
            const liveMap = {
                ...root._ticketCanvasPos || {}
            };
            delete liveMap[ticketId];
            root.update({
                tickets: (root.tickets || []).map((t)=>t.id === ticketId ? {
                        ...t,
                        columnKey: colKey,
                        position: nextPos,
                        metadata: {
                            ...t.metadata || {},
                            canvasPos: null
                        }
                    } : t),
                _ticketCanvasPos: liveMap
            });
            try {
                // ONE request: moveTicket carries the placement clear with the
                // column move (OUTSIDE A COLUMN ⟺ DRAFT). The old second call could
                // fail alone and leave the position on the server under a real
                // column — the exact shape measured on dev.
                self.call('moveTicket', {
                    ticketId: ticketId,
                    columnKey: colKey,
                    position: nextPos
                });
            } catch (err) {
                console.warn('[startTicketDrag] moveTicket failed', err);
            }
            return;
        }
        // Freeform drop (#32): mode on (the default) + released over the board
        // canvas (not a column) → place the card at the scene position under the
        // cursor. The ticket leaves its column and becomes a DRAFT (columnKey
        // 'draft') — drafts are hidden unless the sidebar Drafts filter is on, so
        // the filter auto-enables here so the just-dropped card never vanishes.
        if (root._ticketsFreeform !== false) {
            const boardEl = cardEl.closest('[data-tickets-board]') || under && under.closest && under.closest('[data-tickets-board]');
            if (!boardEl) return;
            const bRect = boardEl.getBoundingClientRect();
            const liveScale = typeof window !== 'undefined' && window.__ticketsPzScale || scale;
            const x = Math.round((ev.clientX - offX - bRect.left) / liveScale);
            const y = Math.round((ev.clientY - offY - bRect.top) / liveScale);
            // Keep the exact in-column layout width when the card moves to the
            // absolutely-positioned freeform layer. offsetWidth is already in board
            // scene units, unlike getBoundingClientRect() which includes panzoom.
            const canvasPos = {
                x: x,
                y: y,
                width: cardEl.offsetWidth
            };
            const fromCol = ((root.tickets || []).find((t)=>t.id === ticketId) || {}).columnKey;
            const totals = {
                ...root.totalByColumn || {}
            };
            if (fromCol && fromCol !== $e86e282c62d0f3f2$export$ea82df13963f4500) {
                totals[fromCol] = Math.max(0, (totals[fromCol] || 1) - 1);
                totals[$e86e282c62d0f3f2$export$ea82df13963f4500] = (totals[$e86e282c62d0f3f2$export$ea82df13963f4500] || 0) + 1;
            }
            root.update({
                _ticketCanvasPos: {
                    ...root._ticketCanvasPos || {},
                    [ticketId]: canvasPos
                },
                totalByColumn: totals,
                tickets: (root.tickets || []).map((t)=>t.id === ticketId ? {
                        ...t,
                        columnKey: $e86e282c62d0f3f2$export$ea82df13963f4500,
                        column_key: $e86e282c62d0f3f2$export$ea82df13963f4500,
                        metadata: {
                            ...t.metadata || {},
                            canvasPos: canvasPos
                        }
                    } : t)
            });
            try {
                if (root._showDrafts !== true) self.call('setTicketsBoardPref', {
                    _showDrafts: true
                });
                if (fromCol !== $e86e282c62d0f3f2$export$ea82df13963f4500) // ONE request: the column becomes `draft` and the position lands in
                // the same write. As two calls, the column write was refused (400
                // unknown_column — `draft` was not an accepted key) while the
                // position write succeeded: a `todo` card floating on the canvas
                // that the Drafts filter could never hide (9 such rows on dev).
                self.call('moveTicket', {
                    ticketId: ticketId,
                    columnKey: $e86e282c62d0f3f2$export$ea82df13963f4500,
                    position: 0,
                    canvasPos: canvasPos
                });
                else // Already a draft: a pure re-position.
                self.call('setTicketCanvasPos', ticketId, canvasPos);
            } catch (err) {
                console.warn('[startTicketDrag] draft placement failed', err);
            }
        }
    };
    document.addEventListener('pointermove', onMove, true);
    document.addEventListener('pointerup', onUp, true);
    document.addEventListener('pointercancel', onUp, true);
};
// Convert a column key into the brand-aligned colour token used by
// TicketCard's status accent stripe. Hoisted to module scope so the
// hot-path map literal isn't allocated on every call.
const $e86e282c62d0f3f2$var$COLUMN_ACCENT = {
    backlog: 'caption',
    todo: 'blue',
    in_progress: 'orange',
    review: 'purple',
    done: 'green'
};
function $e86e282c62d0f3f2$export$c690e53c8b88d20f(columnKey) {
    return $e86e282c62d0f3f2$var$COLUMN_ACCENT[columnKey] || 'caption';
}
// Semantic board column keys that count as "currently being worked on"
// — used by the My View page to bucket assigned tickets into "active"
// vs "backlog" rails. These are the canonical Mongo column keys (see
// sdk.tickets.columns.list → unsynced/backlog/todo/in_progress/
// ready_to_test/review/done); the old GitHub Status field GUIDs
// ('4d6ab783' etc.) are NOT what the server persists, so matching on
// them silently bucketed every in-progress ticket as "backlog" and made
// "Start on" appear not to stick after refresh. Hoisted so the lookup
// set isn't reallocated on every filter pass.
const $e86e282c62d0f3f2$var$ACTIVE_COLUMN_KEYS = new Set([
    'in_progress',
    'review',
    'ready_to_test'
]);
const $e86e282c62d0f3f2$export$f861c10be393a9b5 = 'in_progress';
const $e86e282c62d0f3f2$export$89127c3baae95678 = 'review';
const $e86e282c62d0f3f2$export$15924ca4d5d3bfac = 'done';
const $e86e282c62d0f3f2$export$ea82df13963f4500 = 'draft';
function $e86e282c62d0f3f2$export$3a8aeb6ebddeaea8(root, ticket) {
    if (!ticket) return null;
    return (root?._ticketCanvasPos || {})[ticket.id] || ticket.metadata?.canvasPos || null;
}
function $e86e282c62d0f3f2$export$c9582ce5b36cd041(root, ticket) {
    if (!ticket) return 'hidden';
    const placed = !!$e86e282c62d0f3f2$export$3a8aeb6ebddeaea8(root, ticket);
    const draft = placed || ticket.columnKey === $e86e282c62d0f3f2$export$ea82df13963f4500;
    if (draft && root?._showDrafts !== true) return 'hidden';
    if (placed) return 'freeform';
    return 'column';
}
const $e86e282c62d0f3f2$export$9b805be627022d44 = function(ref) {
    if (typeof window === 'undefined' || !ref) return '';
    const url = new URL(window.location);
    url.searchParams.set('ticket', ref);
    return url.href;
};
const $e86e282c62d0f3f2$export$3dee54d8f4ee86cf = (columnKey)=>$e86e282c62d0f3f2$var$ACTIVE_COLUMN_KEYS.has(columnKey);
const $e86e282c62d0f3f2$export$a76503c6633fec21 = (cols, t, people)=>{
    const col = (cols || []).find((c)=>c.key === t.column_key) || {};
    let description = t.epic_name ? `${t.repository || ''} \xb7 ${col.label || ''} \xb7 ${t.epic_name}` : `${t.repository || ''} \xb7 ${col.label || ''}`;
    if (people) {
        const who = t.assignee_email ? people.find((p)=>p.email === t.assignee_email)?.name || t.assignee_email : 'Unassigned';
        description = `${description} \xb7 ${who}`;
    }
    return {
        id: t.id,
        title: `#${t.number || t.id} \xb7 ${t.title}`,
        name: `#${t.number || t.id} \xb7 ${t.title}`,
        description: description,
        color: col.color || 'GRAY',
        isTicketCard: true
    };
};
function $e86e282c62d0f3f2$export$18662d6c72836307(overrides = {}) {
    return {
        title: '',
        body: '',
        columnKey: 'backlog',
        assigneeEmail: '',
        labels: [],
        priority: 'medium',
        issueType: '',
        env: '',
        // Was missing entirely — the create-mode Epic <select> wrote to
        // `ticketDraft.epicName`, but with no baseline key here the draft's
        // value read back as `undefined` before the user touched the field
        // (harmless), and _save's create-path ticket object never carried
        // `epicName` at all (real bug, fixed alongside this). Seeded here for
        // the same reason every other free-text field is: a clean baseline so
        // `_draft(root).epicName || ''` is well-defined from the first render.
        epicName: '',
        storyPoints: '',
        acceptanceCriteria: '',
        stepsToReproduce: '',
        expectedResult: '',
        dueDate: '',
        editingTicketId: null,
        agentTest: false,
        // Dependencies picked WHILE composing a new ticket (2026-08-02 per Nika
        // "on add new ticket also show dependency field"). There is no ticket id
        // yet to write `ticket_dependencies`/`refs.dependsOn` against, so picks
        // are held here — shaped exactly like _fetchTicketDeps' `outgoing` rows
        // ({id, external_id, type, title, state, priority, assignee_email,
        // kind:'blocked_by'}) so TicketDependencyMainRow renders a pending pick
        // identically to a persisted one. _save's create branch attaches each
        // one via _addDependency once the real id exists, then clears this.
        _pendingDeps: [],
        ...overrides
    };
}
const $e86e282c62d0f3f2$export$914c1c67c09255d8 = (doc, people = [])=>{
    const authorEmail = doc.authorEmail || doc.author_email || null;
    return {
        ...doc,
        id: doc._id || doc.id,
        ticket_id: doc.ticket || doc.ticket_id || null,
        author_email: authorEmail,
        created_at: doc.createdAt || doc.created_at || null,
        created_at_ts: doc.createdAt || doc.created_at ? +new Date(doc.createdAt || doc.created_at) : null,
        edited_at: doc.editedAt || doc.edited_at || null,
        body: doc.body || '',
        _name: ((people || []).find((p)=>p.email === authorEmail)?.name || authorEmail || '').split(' ')[0]
    };
};
const $e86e282c62d0f3f2$export$bc7c1faee7e65366 = (comment, me)=>{
    if (!comment || !me) return false;
    const id = comment._id || comment.id;
    if (!id || String(id).indexOf('optimistic-') === 0) return false;
    return comment.author_email === me;
};
const $e86e282c62d0f3f2$export$4e4c9be35165ced6 = (text)=>{
    if (typeof text !== 'string') return '';
    if (text.indexOf('&') === -1) return text;
    const NAMED = {
        nbsp: ' ',
        amp: '&',
        lt: '<',
        gt: '>',
        quot: '"',
        apos: "'",
        mdash: "\u2014",
        ndash: "\u2013",
        hellip: "\u2026",
        lsquo: "\u2018",
        rsquo: "\u2019",
        ldquo: "\u201C",
        rdquo: "\u201D",
        laquo: "\xab",
        raquo: "\xbb",
        bull: "\u2022",
        middot: "\xb7",
        copy: "\xa9",
        reg: "\xae",
        trade: "\u2122",
        euro: "\u20AC",
        times: "\xd7"
    };
    // ONE pass, so `&amp;lt;` reads `&lt;` (what was typed), never `<`.
    return text.replace(/&(#[0-9]+|#[xX][0-9a-fA-F]+|[a-zA-Z][a-zA-Z0-9]*);/g, (ref, name)=>{
        if (name.charAt(0) === '#') {
            const hex = name.charAt(1) === 'x' || name.charAt(1) === 'X';
            const code = parseInt(name.slice(hex ? 2 : 1), hex ? 16 : 10);
            // U+00A0 reads as the plain space it stood for, as `&nbsp;` does.
            if (code === 160) return ' ';
            // U+0000, the surrogates and anything past U+10FFFF are no characters.
            if (!(code > 0 && code <= 0x10ffff) || code >= 0xd800 && code <= 0xdfff) return ref;
            return String.fromCodePoint(code);
        }
        const key = name.toLowerCase();
        return Object.prototype.hasOwnProperty.call(NAMED, key) ? NAMED[key] : ref;
    });
};
const $e86e282c62d0f3f2$export$6eeb591c7476759b = (body)=>{
    if (typeof body !== 'string' || !body) return '';
    return $e86e282c62d0f3f2$export$6cb48d788fa7d4b5($e86e282c62d0f3f2$export$4e4c9be35165ced6(body.replace(/<br\s*\/?>/gi, '\n\n').replace(/<div(?:\s[^>]*)?>/gi, '\n\n').replace(/<\/div\s*>/gi, '')).replace(/^\n+/, '').replace(/\s+$/, ''));
};
const $e86e282c62d0f3f2$export$431f28959f837854 = (html)=>{
    if (typeof html !== 'string') return '';
    const out = html.replace(/&nbsp;|&#160;|&#x0*a0;| /gi, ' ').trim();
    const visible = $e86e282c62d0f3f2$export$4e4c9be35165ced6(out.replace(/<[^>]*>/g, '')).trim();
    if (!visible && !/<(?:img|hr)\b/i.test(out)) return '';
    return out;
};
const $e86e282c62d0f3f2$export$ab5cc5672e242b50 = (body)=>{
    if (typeof body !== 'string' || !body) return '';
    return $e86e282c62d0f3f2$export$4e4c9be35165ced6(body.replace(/<br\s*\/?>/gi, '\n').replace(/<li(?:\s[^>]*)?>/gi, "\n\u2022 ").replace(/<(?:div|p|h[1-6]|blockquote)(?:\s[^>]*)?>|<\/(?:p|ul|ol|h[1-6]|blockquote)\s*>/gi, '\n').replace(/<\/?[a-zA-Z][^>]*>/g, '')).replace(/[^\S\n]+\n/g, '\n').replace(/\n\n\n+/g, '\n\n').trim();
};
function $e86e282c62d0f3f2$export$19ec74adc469b4de(url) {
    if (typeof url !== 'string') return '';
    const bare = url.replace(/[\t\n\r]/g, '');
    let start = 0;
    while(start < bare.length && bare.charCodeAt(start) <= 32)start++;
    if (start === bare.length) return '';
    const scheme = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(bare.slice(start));
    if (!scheme) return url;
    const name = scheme[1].toLowerCase();
    return name === 'http' || name === 'https' || name === 'mailto' ? url : '';
}
function $e86e282c62d0f3f2$export$6cb48d788fa7d4b5(text) {
    if (typeof text !== 'string' || !text) return '';
    const unescape = (s)=>s.replace(/\\([!-\/:-@\[-`{-~])/g, '$1');
    const allowed = (target)=>{
        const views = [
            target,
            unescape(target)
        ];
        for (const view of views){
            if (view && !$e86e282c62d0f3f2$export$19ec74adc469b4de(view)) return false;
            if (view.charAt(0) === '<' && view.length > 1 && !$e86e282c62d0f3f2$export$19ec74adc469b4de(view.slice(1))) return false;
        }
        return true;
    };
    // What decides a target's scheme: spaces and controls (a browser skips
    // them), one leading `<`, scheme characters and `\` escapes, up to the
    // first `:`. Any other character ends a scheme, so it ends the look.
    const schemePart = (from)=>{
        let j = from;
        if (text.charAt(j) === '<') j++;
        while(j < text.length){
            const c = text.charAt(j);
            if (c === ':') return text.slice(from, j + 1);
            if (c === '\\' && j + 1 < text.length) {
                j += 2;
                continue;
            }
            if (text.charCodeAt(j) <= 32 || /[a-zA-Z0-9+.-]/.test(c)) {
                j++;
                continue;
            }
            break;
        }
        return text.slice(from, j);
    };
    let out = '';
    let last = 0;
    for(let i = text.indexOf(']('); i !== -1; i = text.indexOf('](', i + 1)){
        if (allowed(schemePart(i + 2))) continue;
        out += text.slice(last, i + 1) + '\\';
        last = i + 1;
    }
    out += text.slice(last);
    return out.replace(/<([a-zA-Z][a-zA-Z0-9+.-]+:)/g, (match, scheme)=>$e86e282c62d0f3f2$export$19ec74adc469b4de(scheme) ? match : '< ' + scheme);
}
function $e86e282c62d0f3f2$export$5559eb70efe87b39(html) {
    if (typeof html !== 'string' || !html) return '';
    const KEEP = {
        a: true,
        b: true,
        blockquote: true,
        br: true,
        code: true,
        del: true,
        div: true,
        em: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        hr: true,
        i: true,
        li: true,
        ol: true,
        p: true,
        pre: true,
        s: true,
        span: true,
        strike: true,
        strong: true,
        table: true,
        tbody: true,
        td: true,
        tfoot: true,
        th: true,
        thead: true,
        tr: true,
        u: true,
        ul: true
    };
    const VOID = {
        br: true,
        hr: true
    };
    const DROP = {
        applet: true,
        frameset: true,
        iframe: true,
        math: true,
        noembed: true,
        noframes: true,
        noscript: true,
        object: true,
        script: true,
        select: true,
        style: true,
        svg: true,
        template: true,
        textarea: true,
        title: true,
        xmp: true
    };
    const has = (map, key)=>Object.prototype.hasOwnProperty.call(map, key);
    const isSpace = (c)=>c === ' ' || c === '\t' || c === '\n' || c === '\r' || c === '\f';
    const isAlpha = (c)=>c >= 'a' && c <= 'z' || c >= 'A' && c <= 'Z';
    const escText = (t)=>t.replace(/&(?!#[0-9]+;|#[xX][0-9a-fA-F]+;|[a-zA-Z][a-zA-Z0-9]*;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const escAttr = (v)=>v.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    // An href as a browser reads the attribute before its URL parser sees it:
    // every numeric reference, with its `;` or without (`&#106avascript:`), the
    // named ones that spell URL syntax (`&colon;` `&Tab;` `&NewLine;` `&plus;`
    // `&period;`), and the ones decodeTicketEntities knows. One pass, so
    // `&amp;#106;` stays `&#106;`.
    const URL_NAMED = {
        colon: ':',
        Tab: '\t',
        NewLine: '\n',
        plus: '+',
        period: '.'
    };
    const decodeHref = (v)=>v.replace(/&(?:#([0-9]+);?|#[xX]([0-9a-fA-F]+);?|([a-zA-Z][a-zA-Z0-9]*);)/g, (ref, dec, hex, name)=>{
            if (name) return has(URL_NAMED, name) ? URL_NAMED[name] : $e86e282c62d0f3f2$export$4e4c9be35165ced6(ref);
            const code = dec ? parseInt(dec, 10) : parseInt(hex, 16);
            if (!(code > 0 && code <= 0x10ffff) || code >= 0xd800 && code <= 0xdfff) return '\uFFFD';
            return String.fromCodePoint(code);
        });
    const n = html.length;
    // Just past the first `close` at or after `from`, or the end of the input.
    const past = (from, close)=>{
        const at = html.indexOf(close, from);
        return at === -1 ? n : at + close.length;
    };
    const open = [];
    let out = '';
    let i = 0;
    while(i < n){
        const lt = html.indexOf('<', i);
        if (lt === -1) {
            out += escText(html.slice(i));
            break;
        }
        out += escText(html.slice(i, lt));
        i = lt;
        const next = html.charAt(i + 1);
        if (next === '!') {
            if (html.startsWith('<!--', i)) {
                // A browser ends `<!-->` and `<!--->` at once, any other comment at
                // the first `-->` or `--!>`.
                if (html.charAt(i + 4) === '>') i += 5;
                else if (html.startsWith('->', i + 4)) i += 6;
                else {
                    const dashes = html.indexOf('-->', i + 4);
                    const bang = html.indexOf('--!>', i + 4);
                    if (dashes === -1 && bang === -1) i = n;
                    else if (dashes === -1 || bang !== -1 && bang < dashes) i = bang + 4;
                    else i = dashes + 3;
                }
                continue;
            }
            i = past(i + 2, '>');
            continue;
        }
        if (next === '?') {
            i = past(i + 2, '>');
            continue;
        }
        const closing = next === '/';
        const nameAt = closing ? i + 2 : i + 1;
        if (!isAlpha(html.charAt(nameAt))) {
            if (closing) {
                // `</>` is nothing; `</` and no letter is a comment to the next `>`.
                i = html.charAt(nameAt) === '>' ? nameAt + 1 : past(nameAt, '>');
                continue;
            }
            // A `<` that opens no tag is text.
            out += '&lt;';
            i += 1;
            continue;
        }
        let k = nameAt;
        while(k < n && !isSpace(html.charAt(k)) && html.charAt(k) !== '/' && html.charAt(k) !== '>')k++;
        const name = html.slice(nameAt, k).toLowerCase();
        // The attributes, read as a browser reads them so the tag ends where its
        // `>` really is; only `href` is kept for later.
        let href = null;
        let selfClosing = false;
        let ended = false;
        while(k < n){
            const c = html.charAt(k);
            if (isSpace(c)) {
                k++;
                continue;
            }
            if (c === '/') {
                if (html.charAt(k + 1) === '>') {
                    selfClosing = true;
                    ended = true;
                    k += 2;
                    break;
                }
                k++;
                continue;
            }
            if (c === '>') {
                ended = true;
                k++;
                break;
            }
            let e = k + 1;
            while(e < n && !isSpace(html.charAt(e)) && '/>='.indexOf(html.charAt(e)) === -1)e++;
            const attrName = html.slice(k, e).toLowerCase();
            k = e;
            while(k < n && isSpace(html.charAt(k)))k++;
            let value = '';
            if (html.charAt(k) === '=') {
                k++;
                while(k < n && isSpace(html.charAt(k)))k++;
                const quote = html.charAt(k);
                if (quote === '"' || quote === "'") {
                    const end = html.indexOf(quote, k + 1);
                    if (end === -1) {
                        k = n;
                        break;
                    }
                    value = html.slice(k + 1, end);
                    k = end + 1;
                } else {
                    let end = k;
                    while(end < n && !isSpace(html.charAt(end)) && html.charAt(end) !== '>')end++;
                    value = html.slice(k, end);
                    k = end;
                }
            }
            if (attrName === 'href' && href === null) href = value;
        }
        // A tag the input ends inside is no tag: a browser drops it and the rest.
        if (!ended) break;
        i = k;
        if (closing) {
            if (!has(KEEP, name) || has(VOID, name)) continue;
            let at = open.length - 1;
            while(at >= 0 && open[at].name !== name)at--;
            if (at < 0) continue;
            while(open.length > at){
                const top = open.pop();
                if (top.shown) out += '</' + top.name + '>';
            }
            continue;
        }
        if (name === 'plaintext') break;
        if (has(DROP, name)) {
            // svg and math honour `/>`, so there is nothing inside to drop.
            if (selfClosing && (name === 'svg' || name === 'math')) continue;
            const endTag = new RegExp('</' + name + '(?=[\\t\\n\\f\\r />])', 'gi');
            endTag.lastIndex = i;
            const found = endTag.exec(html);
            i = found ? past(found.index + 2, '>') : n;
            continue;
        }
        if (!has(KEEP, name)) continue;
        if (has(VOID, name)) {
            out += '<' + name + '>';
            continue;
        }
        if (name === 'a') {
            // A link to a refused scheme keeps its words and loses its link.
            const url = $e86e282c62d0f3f2$export$19ec74adc469b4de(decodeHref(href || ''));
            open.push({
                name: name,
                shown: !!url
            });
            if (url) out += '<a href="' + escAttr(url) + '" target="_blank" rel="noopener noreferrer">';
            continue;
        }
        open.push({
            name: name,
            shown: true
        });
        out += '<' + name + '>';
    }
    while(open.length){
        const top = open.pop();
        if (top.shown) out += '</' + top.name + '>';
    }
    return out;
}

});


parcelRegister("gXXSj", function(module, exports) {

$parcel$export(module.exports, "fetchActivityFeed", () => $c5a099f5f304484e$export$967c92ed76f908b6);
// Chronological activity feed for /tickets/feed.
//
// Merges two streams into a single time-sorted list:
//   1. public.agent_activity_log — agent ship/pick/block/ask-user events
//   2. public.tickets — most recently updated tickets (any assignee)
//
// Returns flat array of feed entries shaped as:
//   {
//     id,                  // stable key for DOMQL keyed render
//     kind,                // 'shipped' | 'picked_up' | 'blocked' | ...
//                          //   | 'ticket_update'   (fallback kind from tickets table)
//     tsISO,               // event time (agent_activity_log.created_at or tickets.updated_at)
//     actorEmail,          // agent_name if activity log; assignee_email otherwise
//     ticketId,            // when present
//     ticketExternalId,
//     ticketTitle,
//     ticketType,
//     ticketState,
//     commitSha,
//     note
//   }
// Phase 7c-bis (2026-05-19): tickets migrated to sdk.tickets.list.
// agent_activity_log migrated off Supabase REST to /core/agent-activity
// (Mongo) on 2026-07-03; Supabase is fully retired, so this is Mongo-only.
// coreHeaders / workspaceApiBase / getSDK come from @symbo-ls/workspace-shared,
// stubbed by frank's EXTERNAL_PACKAGES at serialization time — reached via
// el.call instead of raw imports (see TicketDetailModal.js for the full
// rationale).
const $c5a099f5f304484e$var$WORKSPACE_ID = '69e5911201b0ef47b675463f';
// Named _activityFeedUrl (not _activityUrl) — fetchGeneralTriage.js declares
// its OWN, differently-shaped `_activityUrl(el, wsId)` module-scope const.
// Two same-named private helpers across bundled files silently confused
// frank's globalScope promotion in the past (see GeneralMain.js's
// _approveTicket → _approveTicketRow rename, same fix) — a unique name
// removes the collision outright.
const $c5a099f5f304484e$var$_activityFeedUrl = (el, limit)=>`${el.call('workspaceApiBase')}/core/agent-activity?workspace=${$c5a099f5f304484e$var$WORKSPACE_ID}&limit=${limit}`;
const $c5a099f5f304484e$export$967c92ed76f908b6 = async (el, { limit: limit = 50 } = {})=>{
    const [logs, tickets] = await Promise.all([
        // agent_activity_log — Mongo, via /core/agent-activity.
        fetch($c5a099f5f304484e$var$_activityFeedUrl(el, limit), {
            headers: el.call('coreHeaders')
        }).then((r)=>r.ok ? r.json() : []).catch(()=>[]),
        // tickets → sdk.tickets.list (Mongo-backed).
        (async ()=>{
            try {
                const tSvc = await el.call('getSDK').getService('tickets');
                const result = await tSvc.list({
                    deleted: false
                }, {
                    sortBy: 'updatedAt',
                    sortDir: 'desc',
                    limit: limit
                });
                return Array.isArray(result) ? result : result.data || [];
            } catch (_) {
                return [];
            }
        })()
    ]);
    // Build ticket lookup so we can enrich activity log rows.
    // Mongo docs use _id; dual-key for safety.
    const tById = new Map();
    for (const t of tickets){
        if (t._id) tById.set(t._id, t);
        if (t.id) tById.set(t.id, t);
    }
    const feed = [];
    for (const l of logs){
        const t = l.ticket_id ? tById.get(l.ticket_id) : null;
        feed.push({
            id: `log:${l.id}`,
            kind: l.kind,
            tsISO: l.created_at,
            actorEmail: l.agent_name ? `${l.agent_name.toLowerCase()}-agent@symbols.app` : null,
            actorDisplay: l.agent_name || 'agent',
            ticketId: l.ticket_id,
            ticketExternalId: t ? t.externalId || t.external_id : null,
            ticketTitle: t?.title,
            ticketType: t?.type,
            ticketState: t?.state,
            commitSha: l.commit_sha,
            note: l.note
        });
    }
    // Fold in ticket updates that don't have a matching activity log entry
    // (human edits, external syncs, etc.) so humans aren't invisible.
    const loggedTicketIds = new Set(logs.filter((l)=>l.ticket_id).map((l)=>l.ticket_id));
    for (const t of tickets){
        const tid = t._id || t.id;
        if (!tid || loggedTicketIds.has(tid)) continue;
        const assigneeEmail = t.assigneeEmail || t.assignee_email;
        const reporterEmail = t.reporterEmail || t.reporter_email;
        const createdAt = t.createdAt || t.created_at;
        const updatedAt = t.updatedAt || t.updated_at;
        // A freshly created ticket has updatedAt === createdAt (the create write
        // stamps both). Previously such tickets surfaced as "updated by <assignee>"
        // — a spurious 'updated' entry on creation, misattributed to the assignee
        // instead of the creator. Detect the just-created case (timestamps within a
        // 2s slack to absorb create/persist clock skew) and emit a 'ticket_created'
        // entry attributed to the REPORTER. Edited tickets keep 'ticket_update'.
        const ct = createdAt ? new Date(createdAt).getTime() : 0;
        const ut = updatedAt ? new Date(updatedAt).getTime() : 0;
        const isJustCreated = ct && ut && Math.abs(ut - ct) <= 2000;
        const actorEmail = isJustCreated ? reporterEmail || assigneeEmail : assigneeEmail;
        feed.push({
            id: `ticket:${tid}`,
            kind: isJustCreated ? 'ticket_created' : 'ticket_update',
            tsISO: updatedAt,
            actorEmail: actorEmail,
            actorDisplay: actorEmail?.split('@')[0] || 'someone',
            ticketId: tid,
            ticketExternalId: t.externalId || t.external_id,
            ticketTitle: t.title,
            ticketType: t.type,
            ticketState: t.state,
            commitSha: null,
            note: null
        });
    }
    feed.sort((a, b)=>new Date(b.tsISO || 0) - new Date(a.tsISO || 0));
    return feed.slice(0, limit);
};

});

parcelRegister("7E6nw", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("8jrgp"))) : import("8jrgp")).then(()=>parcelRequire('35x1X'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7v8J3", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("dZtNj"))) : import("dZtNj")).then(()=>parcelRequire('9rGNq'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("frY0s", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6tl2n"))) : import("6tl2n")).then(()=>parcelRequire('3g9q9'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hssOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb5b67f55cbdaf57$export$2e2bcd8739ae039);
// Unified shell context — every page from every sub-app + library lands here.
//
// smbls's auto-router matches `pathname` against `element.routes`, which
// is populated from `context.pages` during preparePages(). All sub-app
// pages get merged into this single map at startup. Sub-apps mounted via
// the dispatch table (canvas, marketplace, preview, logs) keep their own
// DOMQL app definitions, but their page maps merge here.
//
// Domain libraries (tickets, documents, calendar, chat, meet) and auth
// pages flow in through sharedLibraries.
//
// Merge precedence (last writer wins): canvas → logs → workspace (self).
// Marketplace and preview are no longer boot-merged — their routes fold their
// context in lazily (see ./pages/index.js), so shellPages owns every
// /marketplace* and /preview key.
//
// canvas's OWN `'/*': main` catch-all is EXCLUDED from the merge below
// (tickets/workspace.md ASK-USER "should the workspace shell serve project
// CANVAS routes at all?", option 1 — don't serve it here). On this unified
// dev bundle the project DATA loads fine but the SCENE renders empty: the
// canvas editor COMPONENTS are deliberately carved out of this shell's eager
// chunk (#15), and lazily pulling the whole editor graph in on '/*' would
// undo that carve. shellPages registers its OWN `'/*'` (pages/projectRedirect.js)
// that redirects project-shaped paths to the host that runs the full,
// uncarved editor graph instead. Every other canvas page key (dashboard,
// account, signup, studios/:slug, …) is unaffected — they merge exactly as
// before.

var $aHVNx = parcelRequire("aHVNx");

var $MygIX = parcelRequire("MygIX");

var $9c3uh = parcelRequire("9c3uh");

var $bWCLy = parcelRequire("bWCLy");

var $4JxxM = parcelRequire("4JxxM");

var $a1kes = parcelRequire("a1kes");

var $fxtVu = parcelRequire("fxtVu");

var $lb2Ei = parcelRequire("lb2Ei");

var $8BRyL = parcelRequire("8BRyL");

var $1LN0i = parcelRequire("1LN0i");

var $eUYHx = parcelRequire("eUYHx");

var $7m21X = parcelRequire("7m21X");

var $1HN7r = parcelRequire("1HN7r");

var $gA6L3 = parcelRequire("gA6L3");

var $7Hxs6 = parcelRequire("7Hxs6");

var $gzF45 = parcelRequire("gzF45");

var $bO8z3 = parcelRequire("bO8z3");

var $6jWcN = parcelRequire("6jWcN");

var $6WQZS = parcelRequire("6WQZS");

var $ehZst = parcelRequire("ehZst");

var $7uzFM = parcelRequire("7uzFM");

var $aKav5 = parcelRequire("aKav5");

var $gO4wS = parcelRequire("gO4wS");

var $9QZBF = parcelRequire("9QZBF");
parcelRequire("cEpNz");
var $4kTba = parcelRequire("4kTba");
var $afwpn = parcelRequire("afwpn");

var $bOd1d = parcelRequire("bOd1d");
var $4qCA4 = parcelRequire("4qCA4");

var $jg30I = parcelRequire("jg30I");

var $kFXIL = parcelRequire("kFXIL");
const { '/*': $cb5b67f55cbdaf57$var$_canvasCatchAll, ...$cb5b67f55cbdaf57$var$canvasPages } = (0, $4JxxM.default);
// - polyglot: NOT declared here, and deliberately so. `context.polyglot` and
//   the polyglot PLUGIN both arrive from @symbo-ls/workspace-shared, which owns
//   the language registry and the i18n bundles. Declaring either one here means
//   importing it across a package boundary, and frank stubs every such import
//   to `""` at publish — measured on this exact file: the shell published
//   `defaultLang: ""`, `languages: ""` and an English base of 0 keys. Worse,
//   `mergeOneLibrary` could not have repaired it: it fills a consumer key only
//   when the consumer has none, and its stub-phantom rescue does not cover
//   `polyglot`. With no `polyglot` key here, its last branch copies the
//   library's whole real object in instead, and `createDomql` (which runs
//   `prepareSharedLibs` BEFORE its plugin auto-registration) then sees a real
//   config and registers the plugin plus every polyglot function itself.
//   That auto-registration also preserves the ONE collision that matters:
//   polyglot ships its own one-argument `setLang`, but the platform's
//   (shared/functions/setLang.js — it loads the i18n bundles, evicts the stale
//   fetch cache and persists the choice) is already a function in the bag by
//   then, and the loop only fills keys that do not hold one.
// Every route def here becomes the shell router's `content` element
// (@symbo.ls/router route-def merge → element.set), so running each def
// through anchorMainContent (functions/anchorMainContent.js — id + role,
// see that file for the full rationale) makes `#main-content` resolve as a
// real `role="main"` landmark on EVERY route, for the SkipToMain link in
// app.js.
const $cb5b67f55cbdaf57$var$pages = Object.fromEntries(Object.entries({
    ...$cb5b67f55cbdaf57$var$canvasPages,
    ...(0, $bWCLy.default)
}).map(([path, def])=>[
        path,
        (0, $6WQZS.anchorMainContent)(def)
    ]));
var $cb5b67f55cbdaf57$export$2e2bcd8739ae039 = {
    ...(0, $gzF45.default),
    // This project is ALSO pushed and consumed as a shared library (e.g. by
    // workspace-ui's catalog, `packages/workspace-ui/sharedLibraries.js`
    // `workspace-shell/context.js`). `@symbo.ls/utils` `mergeSharedLibraries`
    // copies any key a consumer doesn't already define — including `app` (this
    // project's ENTIRE root-element tree: AppHeader, ModalRoot, VoiceOverlay,
    // onRenderRouter, …) and `functions.router` (the MWT override below, meant
    // to intercept nav for THIS app alone). A consumer with no `app`/`router`
    // of its own (workspace-ui has neither) silently inherited both — that's
    // tickets/opus.md "shared-library pushes serialize app-wiring functions;
    // shell's `router` hijacked every consumer's navigation": every Link click
    // on the catalog threw `Cannot read properties of undefined (reading
    // 'planMwtNav')`.
    //
    // `sharedLibIgnore` is the sanctioned, already-shipped fix for exactly
    // this class (packages/utils/sharedLibraries.js `mergeOneLibrary`, 18/18
    // tests; live in production on company/packages/brand/context.js —
    // `sharedLibIgnore: ['pages']` keeps brand's own site routes out of every
    // consumer the same way). It is self-describing — declared once here, it
    // protects every CURRENT and FUTURE consumer with zero configuration on
    // their side, unlike a per-consumer `useLibraries` ignore entry.
    //
    // `app` is excluded WHOLE (not the narrower `app/onRenderRouter`):
    // mergeOneLibrary wholesale-copies an entire section when the consumer
    // has no object at that key at all (workspace-ui's case) — a nested path
    // only guards the OTHER branch (both sides already objects). `functions`
    // is intentionally NOT excluded whole — only the `router` override is
    // app-identity-specific; the rest of this project's functions are
    // legitimate, wanted shared-library content. `functions/routerHref` (F2,
    // the Link href twin of `router`) is the same app identity: inherited, it
    // would put THIS shell's `/w/<org>/<workspace>` in front of every consumer
    // app's links.
    sharedLibIgnore: [
        'app',
        'functions/router',
        'functions/routerHref'
    ],
    app: $9c3uh.default,
    state: $MygIX.default,
    sharedLibraries: $aHVNx.default,
    globalScope: $7Hxs6,
    files: $bO8z3.default,
    pages: $cb5b67f55cbdaf57$var$pages,
    components: {
        DropdownRoot: // Register the dropdown portal explicitly for the same reason as the
        // windows system below. The pinned smbls runtime does not inject these
        // components before the shell app is prepared, so a bare `DropdownRoot`
        // mount otherwise becomes a plain full-viewport div. Once the shell's
        // interactive-stage `if` mounts that empty div it inherits normal
        // pointer-events and blocks every AppHeader control after the first
        // interaction. Keep both portal and trigger in the registry so the
        // plugin's pointer-events:none root + interactive Panel contract survives.
        $4kTba.DropdownRoot,
        DropdownTrigger: $afwpn.DropdownTrigger,
        // Register the windows system explicitly. Recent smbls builds no longer
        // guarantee that mergeUiSystem has populated the project registry before
        // the deferred shell ModalRoot is prepared; without this, ModalRoot mounts
        // as an empty div and every booking/dialog opener silently has nowhere to
        // render. Project components below retain normal last-writer precedence.
        ...(0, $bOd1d.windowsComponents),
        // The tooltip system, explicitly too — the shell's own pinned
        // @symbo.ls/tooltip (package.json), as the dropdown and windows above. The
        // runtime's merge keeps a project's own definition, so a tooltip release
        // reaches the shell without an smbls bump: the one panel that glides
        // between triggers and the trigger's `tooltipAnchorRect` (3.14.604, Nika
        // 2026-10-25 "make one tooltip sliding") arrived while the shell pinned
        // smbls 3.14.841, whose bundled kit still had neither.
        ...(0, $jg30I.tooltipComponents),
        ...$eUYHx,
        ...$gA6L3,
        ...$a1kes,
        // Host-gated: `{}` on every platform host, so this spread is a no-op
        // there and the object is byte-identical to before white-label existed.
        ...(0, $lb2Ei.isCustomDomainHost)() ? $fxtVu : {}
    },
    functions: {
        ...(0, $4qCA4.windowsFunctions),
        // openTooltip / closeTooltip from the same pinned package as the
        // TooltipRoot above — the panel and its writers must agree on the tip.
        ...(0, $kFXIL.tooltipFunctions),
        // closeDropdown (DropdownRoot's Escape/outside-click dismiss) is
        // shared's registration — a real wrapper over the plugin. The bare plugin
        // import registered here published as "" (frank stubs it).
        ...$7m21X,
        ...$1HN7r,
        ...$8BRyL,
        // Multi-workspace-tabs (Phase 3, §6a) — intercept el.router()/Link nav to
        // emit + consume the `/w/<org-slug>` intranet prefix. Transparent
        // pass-through when the MWT flag is off. Last so it wins over any inherited
        // `router` from the sub-app function maps.
        router: (0, $gO4wS.mwtRouter),
        // F2 — the href a Link RENDERS (smbls r17 Link asks `routerHref` for every
        // in-app `/…` href): the same planMwtNav address the click above writes,
        // so a new-tab click or "Copy link address" opens THIS workspace.
        routerHref: (0, $gO4wS.mwtRouterHref)
    },
    methods: {
        ...$1LN0i
    },
    // Design system tokens (icons, colors, fonts, spacing, …). Must live
    // under the `designSystem` key — smbls's mergeSharedLibraries calls
    // `deepDefaults(context.designSystem, sharedLib.designSystem)`, so
    // brand fills gaps under this exact path. Target wins on conflicts.
    //
    // The RAW source object (shell tokens + the marketplace integration icons
    // folded into the icon set) is defined once in
    // functions/extensionDesignSystem.js, because the extension-iframe render
    // path needs the very same unprocessed object — `create()` replaces
    // `context.designSystem` with the PROCESSED scratch CONFIG at boot, so by
    // the time an extension renders there is no raw source left to read off the
    // context. See that module for the full input-contract note.
    designSystem: (0, $6jWcN.workspaceDesignSystemSource),
    // `workspaceApiUrl` is NOT declared here: it is the DEPLOYMENT's identity,
    // resolved at run time by the boot (shared bootPrepare → workspaceApiBase:
    // host rule → injected channel → fail closed). A module-scope value
    // published as "".
    // Router guards run INSIDE the smbls router before pushState / content
    // mount (see plugins/router runGuards — `true` allows, string redirects).
    // demoRouteGuard blocks isDemo sessions off admin/internal routes pre-mount,
    // so a blocked page never renders, never writes the tab title, and never
    // triggers the re-entrant post-mount bounce (duplicate `content` fallout —
    // tickets/smbls.md).
    // NOTE the key is `router` — smbls createDomql runs
    // `context.routerOptions = initRouter(app, context)` at boot, which DERIVES
    // routerOptions from `context.router` (+ routing defaults) and CLOBBERS any
    // routerOptions set here directly (see workspace/agent.md "write
    // context.router").
    // authRouteGuard: the session gate before mount, on every navigation — the
    // SAME predicate as the parcel cold boot's redirectIfUnauthed
    // (functions/auth.js authRedirectTarget), and the published shell's only
    // gate (mermaid never runs index.js).
    // whitelabelRouteGuard: on a white-label host, a navigation to a URL that
    // names ANOTHER org (/w/<other>, /studio/<other>, /<other>/<project>, the
    // account's personal namespace) lands on this host's home instead
    // (WHITELABEL-STRICT-TENANT-SCOPE-1). A no-op wherever no host pin is set.
    // commRouteGuard: on a comm host (comm.symbols.app — docs/COMM_HOST.md) the
    // bare home lands on /chat and a route the comm profile does not serve opens
    // on the workspace host of the same tier. A no-op on every other host.
    router: {
        guards: [
            (0, $9QZBF.authRouteGuard),
            (0, $ehZst.demoRouteGuard),
            (0, $aKav5.whitelabelRouteGuard),
            (0, $7uzFM.commRouteGuard)
        ]
    },
    // THE PUBLISHED SHELL'S BOOT. Mermaid runs `Smbls.create(app, context)` on
    // the project JSON; index.js and its bootShell never run. This plugin runs
    // the SAME boot sequence bootShell composes (shared bootPrepare /
    // bootResolve / bootApply, through the functions registry):
    //   • beforeCreate (before the first element exists): bootPrepare — the
    //     API base, the polyglot config, the SDK + its 'sdk' fetch adapter and
    //     `context.methods.sdk` (el.sdk on every element);
    //   • then bootResolve, async (auth gate, org + workspace, language) into a
    //     seed; `context.bootReady` holds it. The root's onCreate waits for it,
    //     applies it (bootApply) and only then runs the shell's own auth pass.
    // A parcel boot marks `context.bootMode = 'parcel'` first: nothing runs
    // twice.
    plugins: [
        {
            name: 'workspaceBoot',
            beforeCreate (app, ctx) {
                if (!ctx || ctx.bootMode) return;
                const fns = ctx.functions || {};
                if (typeof fns.bootPrepare !== 'function' || typeof fns.bootResolve !== 'function') {
                    console.warn("[workspaceBoot] the boot steps are not registered \u2014 the shell boots without a session");
                    return;
                }
                ctx.bootMode = 'published';
                const seed = {};
                ctx.bootSeed = seed;
                // Called the way el.call calls a registered function: `this` is an
                // element-shaped receiver, so a published step resolves its helpers
                // through `this.context.globalScope` (the merged library scope).
                const receiver = {
                    context: ctx
                };
                let prep = null;
                try {
                    prep = fns.bootPrepare.call(receiver, ctx, {
                        forceSdk: true
                    });
                } catch (err) {
                    console.warn('[workspaceBoot] bootPrepare failed:', err && err.message || err);
                }
                ctx.bootReady = Promise.resolve(prep && fns.bootResolve.call(receiver, ctx, prep, {
                    state: seed
                })).catch((err)=>{
                    console.warn('[workspaceBoot] bootResolve failed:', err && err.message || err);
                    return null;
                });
            }
        }
    ]
};

});
parcelRegister("aHVNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cbac103b7fa3830$export$2e2bcd8739ae039);

var $1Esic = parcelRequire("1Esic");

var $1X0Je = parcelRequire("1X0Je");

var $eTfcB = parcelRequire("eTfcB");

var $69mEw = parcelRequire("69mEw");

var $1uObP = parcelRequire("1uObP");

var $5Ox5h = parcelRequire("5Ox5h");

var $dpQZB = parcelRequire("dpQZB");

var $4qFYG = parcelRequire("4qFYG");

var $gDjqT = parcelRequire("gDjqT");

var $ktBWQ = parcelRequire("ktBWQ");

var $imWdv = parcelRequire("imWdv");

var $aCYUi = parcelRequire("aCYUi");

var $4fHJf = parcelRequire("4fHJf");

var $dEPsX = parcelRequire("dEPsX");

var $jGnr7 = parcelRequire("jGnr7");

var $g9flU = parcelRequire("g9flU");

var $lXOgQ = parcelRequire("lXOgQ");

var $7ZbKd = parcelRequire("7ZbKd");

var $ibNsv = parcelRequire("ibNsv");

var $7drYW = parcelRequire("7drYW");

var $2SNiS = parcelRequire("2SNiS");

var $6GdlH = parcelRequire("6GdlH");

var $bUwFN = parcelRequire("bUwFN");

var $kSoNb = parcelRequire("kSoNb");

var $cTOvE = parcelRequire("cTOvE");

var $lvolO = parcelRequire("lvolO");

var $eqhiY = parcelRequire("eqhiY");

var $42Wiq = parcelRequire("42Wiq");

var $QSYGF = parcelRequire("QSYGF");

var $9lzH2 = parcelRequire("9lzH2");
const $7cbac103b7fa3830$var$chatEager = {
    functions: {
        ...$69mEw
    },
    state: (0, $1uObP.default)
};
const $7cbac103b7fa3830$var$mailEager = {
    components: {
        ...$5Ox5h
    },
    functions: {
        ...$dpQZB
    },
    state: (0, $4qFYG.default)
};
const $7cbac103b7fa3830$var$ticketsEager = {
    components: {
        ...$gDjqT
    },
    functions: {
        ...$ktBWQ
    },
    state: (0, $imWdv.default)
};
const $7cbac103b7fa3830$var$filesEager = {
    components: {
        FilesAnswerView: $dEPsX.FilesAnswerView
    },
    functions: {
        createCanvasFolder: $aCYUi.createCanvasFolder,
        commitRenameNode: $aCYUi.commitRenameNode,
        deleteCanvasNode: $aCYUi.deleteCanvasNode,
        moveNodesIntoFolder: $aCYUi.moveNodesIntoFolder,
        ...$4fHJf
    }
};
const $7cbac103b7fa3830$var$documentsEager = {
    components: {
        ...$jGnr7
    },
    functions: {
        createNote: $g9flU.createNote,
        createKnowledgeArticle: $lXOgQ.createKnowledgeArticle,
        saveKbArticle: $7ZbKd.saveKbArticle,
        notesNavigate: $ibNsv.notesNavigate,
        forgetDocLists: $7drYW.forgetDocLists,
        documentsAiViews: $2SNiS.documentsAiViews
    }
};
const $7cbac103b7fa3830$var$calendarEager = {
    components: {
        ...$6GdlH
    },
    functions: {
        ...$bUwFN
    },
    state: (0, $kSoNb.default)
};
const $7cbac103b7fa3830$var$meetEager = {
    components: {
        ...$cTOvE
    },
    functions: {
        ...$lvolO
    }
};
const $7cbac103b7fa3830$var$analyticsEager = {
    state: (0, $eqhiY.default)
};
const $7cbac103b7fa3830$var$canvasEager = {
    components: {
        ...$42Wiq
    },
    functions: {
        ...$QSYGF
    },
    methods: {
        ...$9lzH2
    }
};
var // ── shared's `pages` bag is NAME-keyed, and every name becomes a ROUTE ──────
//
// WS-SETTINGS-LEGACY-PLATFORM-PAGE-CLOBBERS-ACCOUNT-1 (2026-09-02, live on
// workspace.localhost + reported by Nika): the avatar menu's "Settings" row
// (shared/functions/accountMenu.js → `router('/settings')`) opened the OLD
// PLATFORM settings page — the "Platform Options" / "Canvas" / "Design system"
// / "Website" / code-editor grid of shared/pages/settings.js — instead of the
// signed-in person's workspace account page.
//
// It is a three-step accident, and no single step is wrong on its own:
//
//   1. `packages/shared/context.js` publishes `pages` as
//      `import * as pages from './pages/index.js'` — a bag keyed by EXPORT
//      NAME (`settings`, `profile`, `login`, `lazyPage`, …), not by route.
//   2. `mergeSharedLibraries` (@symbo.ls/utils sharedLibraries.js
//      `mergeOneLibrary`) fills every key the consumer does not already hold,
//      per key. This shell's own bag is keyed by ROUTE (`'/settings'`), so all
//      71 of shared's bare names read as "missing" and are copied in.
//   3. smbls `preparePages` (packages/smbls/src/prepare.js) then promotes every
//      non-slash key: `pages['/' + name] = pages[name]; delete pages[name]`.
//      That assignment does NOT check whether `'/' + name` is already taken, so
//      shared's legacy `settings` page OVERWROTE this shell's explicit
//      `'/settings': profile` entry (pages/index.js).
//
// Measured live in the running app: `__wsRoot.routes['/settings']` held
// `{ SettingsSection, CanvasSettings, DesignSystemOptions, SyncingSettings,
// WebsiteSettings, CodeEditor, SettingsFooter }`, and four of shared's
// FUNCTION exports were registered as routes too (`/lazyPage`,
// `/lazySharedLib`, `/lazySharedLibPage`, `/foldSharedLibContext`) — the same
// promotion, visible in its harmless form.
//
// The fix is the sanctioned consumer-side merge control: a wrapped entry
// `{ library, ignoreList }` (@symbo.ls/utils `sharedLibrary` / `mergeOneLibrary`
// nested `skip.has('<bag>/<key>')`). `'pages/settings'` withholds exactly ONE
// key, so the shell keeps every other shared page it genuinely routes
// (`/invite`, `/install`, `/account`, the `*-modal` pages …) and `/settings`
// stays this shell's own lazy account route.
//
// Written as an OBJECT LITERAL, never `sharedLibrary(shared, …)`: a value that
// is the RESULT OF CALLING a function reached through an `@symbo-ls/*` import
// is a stub-phantom under frank's publish serializer (the same trap that
// hollowed 172 routes in WS-SHARED-LAZYPAGE-HOLLOW-ROUTES-SWITCH-1, see
// pages/lazyPage.js). A plain literal is inert at module-eval and survives.
// `isWrappedLibrary` accepts it — it discriminates on `ignoreList` being an
// array plus a `library`/`key`/`name` field, both of which are present here.
//
// KNOWN TWIN, deliberately NOT changed here: `login`, `signin`, `signup` and
// `profile` are promoted the same way and also displace this shell's entries.
// Those four resolve to the SAME page the shell's own lazy route would load,
// so the only loss is the route's helmet title and its lazy chunk — a cosmetic
// twin, not a wrong surface. Reported separately rather than folded into a
// user-visible bug fix.
//
// Monaco is opt-in: workspace + canvas need CodePreviewWidget, but
// analytics/marketplace/design-system/preview don't — keeps their bundles
// monaco-free.
$7cbac103b7fa3830$export$2e2bcd8739ae039 = [
    (0, $1Esic.default),
    {
        library: (0, $1X0Je.default),
        ignoreList: [
            'pages/settings'
        ]
    },
    (0, $eTfcB.default),
    $7cbac103b7fa3830$var$ticketsEager,
    $7cbac103b7fa3830$var$filesEager,
    $7cbac103b7fa3830$var$documentsEager,
    $7cbac103b7fa3830$var$calendarEager,
    $7cbac103b7fa3830$var$chatEager,
    $7cbac103b7fa3830$var$mailEager,
    $7cbac103b7fa3830$var$meetEager,
    $7cbac103b7fa3830$var$analyticsEager,
    $7cbac103b7fa3830$var$canvasEager
];

});
parcelRegister("1Esic", function(module, exports) {

$parcel$export(module.exports, "default", () => $133f792c0ba2b229$export$2e2bcd8739ae039);

var $hv3ZE = parcelRequire("hv3ZE");

var $2cRlq = parcelRequire("2cRlq");

var $4rvfo = parcelRequire("4rvfo");

var $3tOqn = parcelRequire("3tOqn");

var $1vdoW = parcelRequire("1vdoW");

var $5Q2yy = parcelRequire("5Q2yy");

var $cf32A = parcelRequire("cf32A");

var $ddnE4 = parcelRequire("ddnE4");

var $TcgWe = parcelRequire("TcgWe");

var $dWVc5 = parcelRequire("dWVc5");

var $liEjg = parcelRequire("liEjg");

var $e0YVI = parcelRequire("e0YVI");
var // `pages` here are the brand SITE's own routes (system--brand.at.symbo.ls /
// brand.symbols.app). This context is also the shared-library entry consumed
// by every shell, and the merge engine would auto-mount any route a consumer
// hasn't defined — `sharedLibIgnore` declares the site routes private (the
// merge guard lives in @symbo.ls/utils mergeSharedLibraries). Site-only
// translations are private too: inheriting this small dictionary must not
// displace a consuming workspace's complete polyglot configuration.
$133f792c0ba2b229$export$2e2bcd8739ae039 = {
    ...(0, $liEjg.default),
    sharedLibIgnore: [
        'pages',
        'polyglot'
    ],
    state: $hv3ZE.default,
    dependencies: $2cRlq.default,
    components: $4rvfo,
    snippets: $3tOqn,
    pages: $1vdoW.default,
    functions: $5Q2yy,
    methods: $cf32A,
    designSystem: $ddnE4.default,
    files: $TcgWe.default,
    sharedLibraries: $dWVc5.default,
    envs: $e0YVI.default
};

});
parcelRegister("hv3ZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd86de97e8d4a95$export$2e2bcd8739ae039);
var $cbd86de97e8d4a95$export$2e2bcd8739ae039 = {};

});

parcelRegister("2cRlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b614e1531fd9cd$export$2e2bcd8739ae039);
var $19b614e1531fd9cd$export$2e2bcd8739ae039 = {
    'js-beautify': '2.0.3',
    'lottie-web': '5.13.0',
    prismjs: '1.30.0'
};

});

parcelRegister("4rvfo", function(module, exports) {

var $6qVvb = parcelRequire("6qVvb");

var $aEjJn = parcelRequire("aEjJn");

var $7Iaw2 = parcelRequire("7Iaw2");

var $fE1QK = parcelRequire("fE1QK");

var $fW3X6 = parcelRequire("fW3X6");

var $gNyVY = parcelRequire("gNyVY");

var $dIoRY = parcelRequire("dIoRY");

var $cKyvt = parcelRequire("cKyvt");

var $3fXuh = parcelRequire("3fXuh");

var $gR6Ze = parcelRequire("gR6Ze");

var $hyPFg = parcelRequire("hyPFg");

var $5MHdM = parcelRequire("5MHdM");

var $3Cyd9 = parcelRequire("3Cyd9");

var $fNkvN = parcelRequire("fNkvN");

var $kbmiw = parcelRequire("kbmiw");

var $9ZvGZ = parcelRequire("9ZvGZ");

var $9KDwT = parcelRequire("9KDwT");

var $fIX3j = parcelRequire("fIX3j");

var $c4aHg = parcelRequire("c4aHg");

var $iJYdD = parcelRequire("iJYdD");

var $eGl5U = parcelRequire("eGl5U");

var $lSwJ7 = parcelRequire("lSwJ7");

var $1YyiB = parcelRequire("1YyiB");

var $i09Uw = parcelRequire("i09Uw");

var $jJGfW = parcelRequire("jJGfW");

var $bQLwk = parcelRequire("bQLwk");

var $gpow1 = parcelRequire("gpow1");

var $dmkwK = parcelRequire("dmkwK");

var $7qS6t = parcelRequire("7qS6t");

var $fuKk1 = parcelRequire("fuKk1");

var $iOGK8 = parcelRequire("iOGK8");

var $eRp7t = parcelRequire("eRp7t");

var $knIv3 = parcelRequire("knIv3");

var $8cX1P = parcelRequire("8cX1P");

var $cYjbq = parcelRequire("cYjbq");

var $iSb3e = parcelRequire("iSb3e");

var $jF0L7 = parcelRequire("jF0L7");

var $fGgIo = parcelRequire("fGgIo");

var $iIPVE = parcelRequire("iIPVE");

var $ip1hK = parcelRequire("ip1hK");

var $ddrsJ = parcelRequire("ddrsJ");

var $4hlmv = parcelRequire("4hlmv");

var $9F8YW = parcelRequire("9F8YW");

var $9swNb = parcelRequire("9swNb");

var $38kCS = parcelRequire("38kCS");

var $jjo6I = parcelRequire("jjo6I");

var $55CkC = parcelRequire("55CkC");

var $ifx2A = parcelRequire("ifx2A");

var $69Qcy = parcelRequire("69Qcy");

var $inOKh = parcelRequire("inOKh");

var $1R7Jw = parcelRequire("1R7Jw");

var $uL3Da = parcelRequire("uL3Da");

var $eeSat = parcelRequire("eeSat");

var $bDJkE = parcelRequire("bDJkE");

var $iVSfk = parcelRequire("iVSfk");

var $4FoC9 = parcelRequire("4FoC9");

var $eukqU = parcelRequire("eukqU");

var $3GegM = parcelRequire("3GegM");

var $86fC6 = parcelRequire("86fC6");

var $ecrsp = parcelRequire("ecrsp");

var $hI2UC = parcelRequire("hI2UC");

var $9pdLI = parcelRequire("9pdLI");

var $9WpDd = parcelRequire("9WpDd");

var $fhFCe = parcelRequire("fhFCe");

var $93qW0 = parcelRequire("93qW0");

var $i2oU0 = parcelRequire("i2oU0");

var $ghile = parcelRequire("ghile");

var $g4jj6 = parcelRequire("g4jj6");

var $gnBLH = parcelRequire("gnBLH");

var $jIO5z = parcelRequire("jIO5z");

var $3mkCv = parcelRequire("3mkCv");

var $fR6PU = parcelRequire("fR6PU");

var $5ef8p = parcelRequire("5ef8p");

var $dHfSx = parcelRequire("dHfSx");

var $lBkIH = parcelRequire("lBkIH");

var $j8vyW = parcelRequire("j8vyW");

var $7q4C7 = parcelRequire("7q4C7");

var $d0NoL = parcelRequire("d0NoL");

var $king0 = parcelRequire("king0");

var $2z9pK = parcelRequire("2z9pK");

var $aQiz0 = parcelRequire("aQiz0");

var $4Up3B = parcelRequire("4Up3B");

var $05egG = parcelRequire("05egG");

var $19XRK = parcelRequire("19XRK");

var $7Grb0 = parcelRequire("7Grb0");

var $hFB4S = parcelRequire("hFB4S");

var $4FmjP = parcelRequire("4FmjP");

var $c8Bwy = parcelRequire("c8Bwy");

var $9Y5HT = parcelRequire("9Y5HT");

var $jG0yo = parcelRequire("jG0yo");

var $dWUfQ = parcelRequire("dWUfQ");

var $2Eo5j = parcelRequire("2Eo5j");

var $hIrTU = parcelRequire("hIrTU");

var $dSzE6 = parcelRequire("dSzE6");

var $k62ol = parcelRequire("k62ol");

var $aRzke = parcelRequire("aRzke");

var $foT5d = parcelRequire("foT5d");

var $ajePO = parcelRequire("ajePO");

var $fYhms = parcelRequire("fYhms");

var $7tsf5 = parcelRequire("7tsf5");

var $aytHs = parcelRequire("aytHs");

var $5t3FV = parcelRequire("5t3FV");

var $gRcJe = parcelRequire("gRcJe");

var $Gf4eK = parcelRequire("Gf4eK");

var $eHbTl = parcelRequire("eHbTl");

var $6PosI = parcelRequire("6PosI");

var $ggVIg = parcelRequire("ggVIg");

var $5OyIv = parcelRequire("5OyIv");

var $6cTCD = parcelRequire("6cTCD");

var $3JZvQ = parcelRequire("3JZvQ");

var $cdxBm = parcelRequire("cdxBm");

var $jhaFU = parcelRequire("jhaFU");

var $6dZA1 = parcelRequire("6dZA1");

var $36THD = parcelRequire("36THD");

var $cPmzs = parcelRequire("cPmzs");

var $dtaGh = parcelRequire("dtaGh");

var $cIcb2 = parcelRequire("cIcb2");

var $kRpYV = parcelRequire("kRpYV");

var $iI67T = parcelRequire("iI67T");

var $iO4ER = parcelRequire("iO4ER");

var $31vTL = parcelRequire("31vTL");

var $aZyHJ = parcelRequire("aZyHJ");

var $3vsUy = parcelRequire("3vsUy");

var $hKah5 = parcelRequire("hKah5");

var $fMu6Z = parcelRequire("fMu6Z");

var $ajSre = parcelRequire("ajSre");

var $2YiV4 = parcelRequire("2YiV4");

var $db0ds = parcelRequire("db0ds");

var $9OLU8 = parcelRequire("9OLU8");

var $dqhDm = parcelRequire("dqhDm");

var $3mf5Q = parcelRequire("3mf5Q");

var $dTyAa = parcelRequire("dTyAa");

var $bELJp = parcelRequire("bELJp");

var $cWryu = parcelRequire("cWryu");

var $i5eUj = parcelRequire("i5eUj");

var $87xoB = parcelRequire("87xoB");

var $45ShX = parcelRequire("45ShX");

var $8cMV9 = parcelRequire("8cMV9");

var $ajzZf = parcelRequire("ajzZf");

var $c52hb = parcelRequire("c52hb");

var $2qs06 = parcelRequire("2qs06");

var $6sah2 = parcelRequire("6sah2");

var $erSkt = parcelRequire("erSkt");

var $jOofb = parcelRequire("jOofb");

var $1f8qV = parcelRequire("1f8qV");

var $dWOOq = parcelRequire("dWOOq");

var $lnBbc = parcelRequire("lnBbc");

var $lT6Yq = parcelRequire("lT6Yq");

var $gUSPz = parcelRequire("gUSPz");

var $c3MC3 = parcelRequire("c3MC3");

var $vkR58 = parcelRequire("vkR58");

var $3wXSk = parcelRequire("3wXSk");

var $jihyg = parcelRequire("jihyg");

var $h0IUv = parcelRequire("h0IUv");

var $eWA6q = parcelRequire("eWA6q");

var $g3PhQ = parcelRequire("g3PhQ");

var $k7liM = parcelRequire("k7liM");

var $9cBCF = parcelRequire("9cBCF");

var $96hfk = parcelRequire("96hfk");

var $cFFWi = parcelRequire("cFFWi");

var $cKlQi = parcelRequire("cKlQi");

var $6V5Tn = parcelRequire("6V5Tn");

var $knweg = parcelRequire("knweg");

var $Qcv4j = parcelRequire("Qcv4j");

var $iSdGG = parcelRequire("iSdGG");

var $972UR = parcelRequire("972UR");

var $rSQe4 = parcelRequire("rSQe4");

var $8z4RY = parcelRequire("8z4RY");

var $FdR85 = parcelRequire("FdR85");

var $eeuOF = parcelRequire("eeuOF");

var $cx3Um = parcelRequire("cx3Um");

var $lEzcS = parcelRequire("lEzcS");

var $jAl0j = parcelRequire("jAl0j");

var $egf2c = parcelRequire("egf2c");

var $lWLGA = parcelRequire("lWLGA");

var $d3BRm = parcelRequire("d3BRm");

var $6yupH = parcelRequire("6yupH");

var $eT1bP = parcelRequire("eT1bP");

var $8jqJs = parcelRequire("8jqJs");

var $b27Ut = parcelRequire("b27Ut");

var $fxcZu = parcelRequire("fxcZu");

var $i88P2 = parcelRequire("i88P2");

var $4xR4n = parcelRequire("4xR4n");

var $je855 = parcelRequire("je855");

var $c96Aa = parcelRequire("c96Aa");

var $e3sdr = parcelRequire("e3sdr");

var $h2C8c = parcelRequire("h2C8c");

var $ez0fT = parcelRequire("ez0fT");

var $jZxUK = parcelRequire("jZxUK");

var $2Hu0Y = parcelRequire("2Hu0Y");

var $giWv6 = parcelRequire("giWv6");

var $cOCNS = parcelRequire("cOCNS");

var $gl7OC = parcelRequire("gl7OC");

var $4u2vB = parcelRequire("4u2vB");

var $47jGf = parcelRequire("47jGf");

var $9aO2N = parcelRequire("9aO2N");

var $3W3FX = parcelRequire("3W3FX");

var $4Y4qt = parcelRequire("4Y4qt");

var $avEgB = parcelRequire("avEgB");

var $2f3Kz = parcelRequire("2f3Kz");
$parcel$exportWildcard(module.exports, $6qVvb);
$parcel$exportWildcard(module.exports, $aEjJn);
$parcel$exportWildcard(module.exports, $7Iaw2);
$parcel$exportWildcard(module.exports, $fE1QK);
$parcel$exportWildcard(module.exports, $fW3X6);
$parcel$exportWildcard(module.exports, $gNyVY);
$parcel$exportWildcard(module.exports, $dIoRY);
$parcel$exportWildcard(module.exports, $cKyvt);
$parcel$exportWildcard(module.exports, $3fXuh);
$parcel$exportWildcard(module.exports, $gR6Ze);
$parcel$exportWildcard(module.exports, $hyPFg);
$parcel$exportWildcard(module.exports, $5MHdM);
$parcel$exportWildcard(module.exports, $3Cyd9);
$parcel$exportWildcard(module.exports, $fNkvN);
$parcel$exportWildcard(module.exports, $kbmiw);
$parcel$exportWildcard(module.exports, $9ZvGZ);
$parcel$exportWildcard(module.exports, $9KDwT);
$parcel$exportWildcard(module.exports, $fIX3j);
$parcel$exportWildcard(module.exports, $c4aHg);
$parcel$exportWildcard(module.exports, $iJYdD);
$parcel$exportWildcard(module.exports, $eGl5U);
$parcel$exportWildcard(module.exports, $lSwJ7);
$parcel$exportWildcard(module.exports, $1YyiB);
$parcel$exportWildcard(module.exports, $i09Uw);
$parcel$exportWildcard(module.exports, $jJGfW);
$parcel$exportWildcard(module.exports, $bQLwk);
$parcel$exportWildcard(module.exports, $gpow1);
$parcel$exportWildcard(module.exports, $dmkwK);
$parcel$exportWildcard(module.exports, $7qS6t);
$parcel$exportWildcard(module.exports, $fuKk1);
$parcel$exportWildcard(module.exports, $iOGK8);
$parcel$exportWildcard(module.exports, $eRp7t);
$parcel$exportWildcard(module.exports, $knIv3);
$parcel$exportWildcard(module.exports, $8cX1P);
$parcel$exportWildcard(module.exports, $cYjbq);
$parcel$exportWildcard(module.exports, $iSb3e);
$parcel$exportWildcard(module.exports, $jF0L7);
$parcel$exportWildcard(module.exports, $fGgIo);
$parcel$exportWildcard(module.exports, $iIPVE);
$parcel$exportWildcard(module.exports, $ip1hK);
$parcel$exportWildcard(module.exports, $ddrsJ);
$parcel$exportWildcard(module.exports, $4hlmv);
$parcel$exportWildcard(module.exports, $9F8YW);
$parcel$exportWildcard(module.exports, $9swNb);
$parcel$exportWildcard(module.exports, $38kCS);
$parcel$exportWildcard(module.exports, $jjo6I);
$parcel$exportWildcard(module.exports, $55CkC);
$parcel$exportWildcard(module.exports, $ifx2A);
$parcel$exportWildcard(module.exports, $69Qcy);
$parcel$exportWildcard(module.exports, $inOKh);
$parcel$exportWildcard(module.exports, $1R7Jw);
$parcel$exportWildcard(module.exports, $uL3Da);
$parcel$exportWildcard(module.exports, $eeSat);
$parcel$exportWildcard(module.exports, $bDJkE);
$parcel$exportWildcard(module.exports, $iVSfk);
$parcel$exportWildcard(module.exports, $4FoC9);
$parcel$exportWildcard(module.exports, $eukqU);
$parcel$exportWildcard(module.exports, $3GegM);
$parcel$exportWildcard(module.exports, $86fC6);
$parcel$exportWildcard(module.exports, $ecrsp);
$parcel$exportWildcard(module.exports, $hI2UC);
$parcel$exportWildcard(module.exports, $9pdLI);
$parcel$exportWildcard(module.exports, $9WpDd);
$parcel$exportWildcard(module.exports, $fhFCe);
$parcel$exportWildcard(module.exports, $93qW0);
$parcel$exportWildcard(module.exports, $i2oU0);
$parcel$exportWildcard(module.exports, $ghile);
$parcel$exportWildcard(module.exports, $g4jj6);
$parcel$exportWildcard(module.exports, $gnBLH);
$parcel$exportWildcard(module.exports, $jIO5z);
$parcel$exportWildcard(module.exports, $3mkCv);
$parcel$exportWildcard(module.exports, $fR6PU);
$parcel$exportWildcard(module.exports, $5ef8p);
$parcel$exportWildcard(module.exports, $dHfSx);
$parcel$exportWildcard(module.exports, $lBkIH);
$parcel$exportWildcard(module.exports, $j8vyW);
$parcel$exportWildcard(module.exports, $7q4C7);
$parcel$exportWildcard(module.exports, $d0NoL);
$parcel$exportWildcard(module.exports, $king0);
$parcel$exportWildcard(module.exports, $2z9pK);
$parcel$exportWildcard(module.exports, $aQiz0);
$parcel$exportWildcard(module.exports, $4Up3B);
$parcel$exportWildcard(module.exports, $05egG);
$parcel$exportWildcard(module.exports, $19XRK);
$parcel$exportWildcard(module.exports, $7Grb0);
$parcel$exportWildcard(module.exports, $hFB4S);
$parcel$exportWildcard(module.exports, $4FmjP);
$parcel$exportWildcard(module.exports, $c8Bwy);
$parcel$exportWildcard(module.exports, $9Y5HT);
$parcel$exportWildcard(module.exports, $jG0yo);
$parcel$exportWildcard(module.exports, $dWUfQ);
$parcel$exportWildcard(module.exports, $2Eo5j);
$parcel$exportWildcard(module.exports, $hIrTU);
$parcel$exportWildcard(module.exports, $dSzE6);
$parcel$exportWildcard(module.exports, $k62ol);
$parcel$exportWildcard(module.exports, $aRzke);
$parcel$exportWildcard(module.exports, $foT5d);
$parcel$exportWildcard(module.exports, $ajePO);
$parcel$exportWildcard(module.exports, $fYhms);
$parcel$exportWildcard(module.exports, $7tsf5);
$parcel$exportWildcard(module.exports, $aytHs);
$parcel$exportWildcard(module.exports, $5t3FV);
$parcel$exportWildcard(module.exports, $gRcJe);
$parcel$exportWildcard(module.exports, $Gf4eK);
$parcel$exportWildcard(module.exports, $eHbTl);
$parcel$exportWildcard(module.exports, $6PosI);
$parcel$exportWildcard(module.exports, $ggVIg);
$parcel$exportWildcard(module.exports, $5OyIv);
$parcel$exportWildcard(module.exports, $6cTCD);
$parcel$exportWildcard(module.exports, $3JZvQ);
$parcel$exportWildcard(module.exports, $cdxBm);
$parcel$exportWildcard(module.exports, $jhaFU);
$parcel$exportWildcard(module.exports, $6dZA1);
$parcel$exportWildcard(module.exports, $36THD);
$parcel$exportWildcard(module.exports, $cPmzs);
$parcel$exportWildcard(module.exports, $dtaGh);
$parcel$exportWildcard(module.exports, $cIcb2);
$parcel$exportWildcard(module.exports, $kRpYV);
$parcel$exportWildcard(module.exports, $iI67T);
$parcel$exportWildcard(module.exports, $iO4ER);
$parcel$exportWildcard(module.exports, $31vTL);
$parcel$exportWildcard(module.exports, $aZyHJ);
$parcel$exportWildcard(module.exports, $3vsUy);
$parcel$exportWildcard(module.exports, $hKah5);
$parcel$exportWildcard(module.exports, $fMu6Z);
$parcel$exportWildcard(module.exports, $ajSre);
$parcel$exportWildcard(module.exports, $2YiV4);
$parcel$exportWildcard(module.exports, $db0ds);
$parcel$exportWildcard(module.exports, $9OLU8);
$parcel$exportWildcard(module.exports, $dqhDm);
$parcel$exportWildcard(module.exports, $3mf5Q);
$parcel$exportWildcard(module.exports, $dTyAa);
$parcel$exportWildcard(module.exports, $bELJp);
$parcel$exportWildcard(module.exports, $cWryu);
$parcel$exportWildcard(module.exports, $i5eUj);
$parcel$exportWildcard(module.exports, $87xoB);
$parcel$exportWildcard(module.exports, $45ShX);
$parcel$exportWildcard(module.exports, $8cMV9);
$parcel$exportWildcard(module.exports, $ajzZf);
$parcel$exportWildcard(module.exports, $c52hb);
$parcel$exportWildcard(module.exports, $2qs06);
$parcel$exportWildcard(module.exports, $6sah2);
$parcel$exportWildcard(module.exports, $erSkt);
$parcel$exportWildcard(module.exports, $jOofb);
$parcel$exportWildcard(module.exports, $1f8qV);
$parcel$exportWildcard(module.exports, $dWOOq);
$parcel$exportWildcard(module.exports, $lnBbc);
$parcel$exportWildcard(module.exports, $lT6Yq);
$parcel$exportWildcard(module.exports, $gUSPz);
$parcel$exportWildcard(module.exports, $c3MC3);
$parcel$exportWildcard(module.exports, $vkR58);
$parcel$exportWildcard(module.exports, $3wXSk);
$parcel$exportWildcard(module.exports, $jihyg);
$parcel$exportWildcard(module.exports, $h0IUv);
$parcel$exportWildcard(module.exports, $eWA6q);
$parcel$exportWildcard(module.exports, $g3PhQ);
$parcel$exportWildcard(module.exports, $k7liM);
$parcel$exportWildcard(module.exports, $9cBCF);
$parcel$exportWildcard(module.exports, $96hfk);
$parcel$exportWildcard(module.exports, $cFFWi);
$parcel$exportWildcard(module.exports, $cKlQi);
$parcel$exportWildcard(module.exports, $6V5Tn);
$parcel$exportWildcard(module.exports, $knweg);
$parcel$exportWildcard(module.exports, $Qcv4j);
$parcel$exportWildcard(module.exports, $iSdGG);
$parcel$exportWildcard(module.exports, $972UR);
$parcel$exportWildcard(module.exports, $rSQe4);
$parcel$exportWildcard(module.exports, $8z4RY);
$parcel$exportWildcard(module.exports, $FdR85);
$parcel$exportWildcard(module.exports, $eeuOF);
$parcel$exportWildcard(module.exports, $cx3Um);
$parcel$exportWildcard(module.exports, $lEzcS);
$parcel$exportWildcard(module.exports, $jAl0j);
$parcel$exportWildcard(module.exports, $egf2c);
$parcel$exportWildcard(module.exports, $lWLGA);
$parcel$exportWildcard(module.exports, $d3BRm);
$parcel$exportWildcard(module.exports, $6yupH);
$parcel$exportWildcard(module.exports, $eT1bP);
$parcel$exportWildcard(module.exports, $8jqJs);
$parcel$exportWildcard(module.exports, $b27Ut);
$parcel$exportWildcard(module.exports, $fxcZu);
$parcel$exportWildcard(module.exports, $i88P2);
$parcel$exportWildcard(module.exports, $4xR4n);
$parcel$exportWildcard(module.exports, $je855);
$parcel$exportWildcard(module.exports, $c96Aa);
$parcel$exportWildcard(module.exports, $e3sdr);
$parcel$exportWildcard(module.exports, $h2C8c);
$parcel$exportWildcard(module.exports, $ez0fT);
$parcel$exportWildcard(module.exports, $jZxUK);
$parcel$exportWildcard(module.exports, $2Hu0Y);
$parcel$exportWildcard(module.exports, $giWv6);
$parcel$exportWildcard(module.exports, $cOCNS);
$parcel$exportWildcard(module.exports, $gl7OC);
$parcel$exportWildcard(module.exports, $4u2vB);
$parcel$exportWildcard(module.exports, $47jGf);
$parcel$exportWildcard(module.exports, $9aO2N);
$parcel$exportWildcard(module.exports, $3W3FX);
$parcel$exportWildcard(module.exports, $4Y4qt);
$parcel$exportWildcard(module.exports, $avEgB);
$parcel$exportWildcard(module.exports, $2f3Kz);

});
parcelRegister("6qVvb", function(module, exports) {

$parcel$export(module.exports, "BrandPageSelect", () => $4af1c67ab3c152cf$export$7c7910ed983b8e58);
// Native navigation keeps every documentation route reachable on small screens.
const $4af1c67ab3c152cf$export$7c7910ed983b8e58 = {
    extends: 'Select',
    name: 'brand-page',
    'aria-label': (el)=>el.call('polyglot', 'brandNavigationLabel'),
    minHeight: 'controlH',
    width: '100%',
    minWidth: '0',
    round: 'radiusControl',
    fontSize: 'Z2',
    padding: '- Z2',
    color: 'title',
    childrenDeps: [
        'routePath'
    ],
    children: (el, s)=>el.call('brandSiteNavigation').map((entry)=>({
                value: entry.href,
                text: entry.label,
                selected: entry.href === (s.root.routePath || '/')
            })),
    onChange: (e, el)=>el.router(e.target.value, el.getRoot())
};

});

parcelRegister("aEjJn", function(module, exports) {

$parcel$export(module.exports, "AccessCodeField", () => $7c0cf1f27a614e01$export$588db2de64f3ad6d);
const $7c0cf1f27a614e01$export$588db2de64f3ad6d = {
    extends: 'GroupField',
    // Moved up from `Grid` (was `Grid.state`) so BOTH `Grid`'s digit children
    // and the hidden mirror `Input` below — now a sibling of `Grid`, not a
    // child of it, see that component's comment — share the SAME state scope.
    // A child with no `state:` of its own inherits its nearest ancestor's, so
    // this is transparent to the digit inputs (`s.value[el.key]` still
    // resolves exactly as before).
    state: {
        value: [
            null,
            null,
            null,
            null,
            null,
            null
        ]
    },
    Title: {
        text: 'Invitation code'
    },
    Grid: {
        position: 'relative',
        // `minmax(0, 1fr)`, not `1fr`. A bare `1fr` track is `minmax(auto, 1fr)`,
        // and that `auto` floor is the item's MIN-CONTENT width — for a native
        // <input> that is its intrinsic ~20-character size, which no amount of
        // `width: 100%` / `min-width: 0` on the child can overcome because the
        // floor lives on the TRACK. Six such tracks always summed wider than the
        // container, so the last digits were cut off in any narrow column.
        columns: 'repeat(6, minmax(0, 1fr))',
        width: '100%',
        height: 'C',
        gap: 'X2',
        childExtends: 'Input',
        childProps: {
            // The Grid is responsive (`repeat(6, 1fr)` at `width: 100%`) but each
            // digit carried a FIXED `boxSize: 'C'`, which overrides its 1fr track —
            // so six fixed boxes plus gaps always summed wider than the container
            // and the last digits were simply cut off in any column narrower than
            // ~6C. Filling the track keeps the row inside its container at ANY width
            // while the fixed height preserves the square digit shape.
            width: '100%',
            minWidth: '0',
            height: 'C',
            // The base `Input` component's default is `padding: 'Z2 B'` — sized for
            // a normal full-width text field, `B` alone is ~27.5px per side. At a
            // single-digit box's actual rendered width (~39-55px at the widths this
            // renders in), that horizontal padding consumes the ENTIRE box
            // (2 × ~27.5px ≈ the whole track), leaving ~0px of content-box room for
            // the glyph — the typed digit rendered fully inside its own padding and
            // was clipped away. A one-character box needs no field padding at all;
            // `textAlign: 'center'` does the centring the padding used to do
            // visually.
            padding: '0',
            textAlign: 'center',
            attr: {
                'aria-label': (el)=>'Code digit ' + (Number(el.key) + 1)
            },
            required: true,
            round: 'Y2',
            minlength: 1,
            maxlength: 1,
            fontFamily: 'Code',
            value: (el, s)=>s.value[el.key] || '',
            onKeyup: (event, element, state)=>{
                const { target: target, keyCode: keyCode } = event;
                const { value: value } = target;
                const next = element.nextElement();
                const previous = element.previousElement();
                const isNumber = keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105;
                const isBackspace = event.keyCode === 8 || event.keyCode === 46;
                target.select();
                if (isNumber && value.length && next) next.node.focus();
                if ((!value.length || isBackspace) && previous) previous.node.focus();
                // Was a bare nested mutation (`state.value[element.key] = value`)
                // with no `state.update()` at all, plus a manual
                // `element.lookup('Input').update({ value: … })` push to the hidden
                // mirror field. BOTH were dead ends: the nested mutation never
                // notified anything, and — separately, confirmed by reading
                // smbls/packages/element/src/update.js — `value` is a
                // framework-reserved key in `REGISTRY`, so the generic
                // "set the property" branch in `update()` unconditionally
                // `continue`s past it; there is no dedicated handler for
                // `params.value` at all, so that `.update({ value })` call was
                // *always* inert, for any element, not just this one. The
                // idiomatic fix is the same shape the digit inputs already use
                // correctly: `Input.value` below is a reactive factory reading
                // this shared state, so a plain `state.update(...)` is all that is
                // needed — the mirror field recomputes itself.
                const codeValue = [
                    ...state.value
                ];
                codeValue[element.key] = value;
                state.update({
                    value: codeValue
                });
            },
            onPaste: (event, element, state)=>{
                event.preventDefault();
                const paste = (event.clipboardData || window.clipboardData).getData('text');
                if (!paste) return;
                const value = paste.split('');
                state.value = value;
                state.update();
            }
        },
        children: [
            {},
            {},
            {},
            {},
            {},
            {}
        ]
    },
    // Was nested INSIDE `Grid`, alongside `Grid.children` (a plain array). A
    // named object key co-declared with an array-form `children` on the SAME
    // element is silently dropped: `renderChildren`'s array branch
    // (smbls/packages/element/src/create.js) only ever walks the `children`
    // array — it never revisits the element's own remaining keys — so this
    // hidden mirror field never materialised in the DOM at all (confirmed live:
    // the rendered Grid had exactly 6 children, keyed "0".."5", no "Input").
    // The original `onKeyup` reached for it via `element.lookup('Input').
    // update(...)`, which ran against `null` and threw on every keystroke — and
    // the field's own submittable concatenated value never populated, which is
    // what actually read as "numbers not inputting": each digit box types fine
    // on its own (verified live, headless Chrome), but the code the field
    // would actually submit never got written anywhere.
    // `type: 'hidden'` renders no box at all regardless of position/inset (per
    // spec, hidden inputs are simply not rendered), so lifting it to a plain
    // sibling of `Grid` has zero visual effect on layout.
    Input: {
        ignoreChildExtends: true,
        type: 'hidden',
        required: true,
        placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022",
        pattern: '[0-9]*',
        minlength: 6,
        maxlength: 6,
        round: 'Y2',
        position: 'absolute',
        inset: '0',
        // A reactive FACTORY (not a manual `.update()` push from `onKeyup`) —
        // `value` is a framework-reserved key (`REGISTRY` in
        // smbls/packages/element/src/registry.js) with no dedicated handler in
        // `update()`'s generic property-assignment loop, so any
        // `element.update({ value: … })` call is silently inert, for any
        // element. Declaring `value` as a function here — exactly like each
        // digit's own `value: (el, s) => s.value[el.key] || ''` — gets it a real
        // tracked effect instead: it re-runs whenever the shared `state.value`
        // array changes (via `state.update(...)` in `onKeyup`) and repaints on
        // its own. `s.value` holds `null` for unfilled digits; `Array.prototype.
        // join` renders `null`/`undefined` entries as `''`, so this is correct
        // from the very first (all-empty) render.
        value: (el, s)=>(s.value || []).join('')
    }
};

});

parcelRegister("7Iaw2", function(module, exports) {

$parcel$export(module.exports, "AddItemButton", () => $59d4cca6abeb4035$export$6cb731ac7be1981a);
const $59d4cca6abeb4035$export$6cb731ac7be1981a = {
    extends: 'ButtonTitle',
    IconButton: {
        tabIndex: '-1',
        align: 'center center',
        round: 'Y1',
        icon: 'plus',
        color: 'lightBlue'
    },
    Caption: {
        text: 'Add item'
    }
};

});

parcelRegister("fE1QK", function(module, exports) {

$parcel$export(module.exports, "AccessibilityCheck", () => $b63c06c649621476$export$1400955c2696b584);
const $b63c06c649621476$export$1400955c2696b584 = {
    extends: 'Group',
    flow: 'y',
    align: 'flex-start flex-start',
    gap: 'A',
    Title: {
        text: 'WCAG accessibility checks'
    },
    Flex: {
        flow: 'row wrap',
        align: 'center flex-start',
        gap: 'A2 B',
        childExtends: {
            extends: 'IconText',
            gap: 'Y',
            icon: 'checkmark',
            Icon: {
                color: 'grassgreen'
            }
        },
        children: [
            {
                text: 'Normal AAA'
            },
            {
                text: 'Large AAA'
            },
            {
                text: 'Large AA'
            },
            {
                text: 'UI Components'
            }
        ]
    }
};

});

parcelRegister("fW3X6", function(module, exports) {

$parcel$export(module.exports, "ArticleHeader", () => $b99f569ef2a8be00$export$c0731e8c4d214bed);
const $b99f569ef2a8be00$export$c0731e8c4d214bed = {
    flow: 'column',
    gap: 'X',
    color: 'title',
    Title: {
        color: 'title',
        // Was '500' (banned display band, design-direction.md §7). This is the
        // shared primitive for ArticleBig/Medium/Small/Tiny/XS's card titles —
        // fixing it here ripples to every size variant that doesn't already
        // override it (ArticleBig already declares its own '700').
        fontWeight: '700',
        margin: '0'
    },
    P: {
        lineHeight: '1.5em',
        margin: '0',
        fontWeight: '400',
        maxWidth: 'I_default',
        color: 'paragraph'
    }
};

});

parcelRegister("gNyVY", function(module, exports) {

$parcel$export(module.exports, "AddRemoveButtons", () => $c3ac522199b853f1$export$10285b88153ac363);
const $c3ac522199b853f1$export$10285b88153ac363 = {
    childExtends: 'IconButton',
    gap: 'Z',
    Remove: {
        icon: 'minus',
        attr: {
            'aria-label': 'Remove'
        }
    },
    Add: {
        icon: 'plus',
        attr: {
            'aria-label': 'Add'
        }
    }
};

});

parcelRegister("dIoRY", function(module, exports) {

$parcel$export(module.exports, "ArrowButton", () => $9fc2acf9be1ccc34$export$15d663f77d176497);
const $9fc2acf9be1ccc34$export$15d663f77d176497 = {
    // The icon-button law (IconButton): a 36px square, the arrow centred.
    extends: [
        'SquareButton',
        'IconButton'
    ],
    round: '100%',
    theme: 'transparent',
    background: 'title.15',
    // theme 'transparent' is static — add explicit hover/press feedback so the
    // control reacts to pointer interaction (keyboard focus is covered by the ring).
    ':hover': {
        background: 'title.25'
    },
    ':active': {
        background: 'title.35'
    }
};

});

parcelRegister("cKyvt", function(module, exports) {

$parcel$export(module.exports, "AddButton", () => $94848c388289b028$export$6d88ebe453be59d7);
const $94848c388289b028$export$6d88ebe453be59d7 = {
    extends: [
        'Link',
        'MenuItem'
    ],
    ignoreChildExtends: true,
    icon: 'plus'
};

});

parcelRegister("3fXuh", function(module, exports) {

$parcel$export(module.exports, "ArticleLink", () => $25f0eabe92b82e83$export$59b71bdbac9390a6);
const $25f0eabe92b82e83$export$59b71bdbac9390a6 = {
    extends: [
        'Link',
        'ClickableButton'
    ],
    padding: 'Z1',
    round: 'Z2',
    flow: 'y',
    align: 'flex-start flex-start',
    theme: null,
    // Was `color: 'gray11'` repeated identically in BOTH the '@dark' and
    // '@light' blocks — a theme-invariant literal, not an adaptive pair, so it
    // read fine on dark and low-contrast on light. `caption` is the adaptive
    // secondary-ink token (design-direction.md's "inherited color + opacity"
    // ink language) and resolves correctly in both schemes.
    color: 'caption',
    // Was a 1px solid outline (stroked-card habit banned by §8). A resting
    // tonal wash + a stronger wash on hover is the same fill-contrast pairing
    // BrandStateDuo demonstrates for clickable rows.
    background: 'overlay',
    ':hover': {
        background: 'hover'
    },
    Caption: {
        fontSize: 'Y',
        color: 'inactive',
        fontWeight: '500',
        textTransform: 'uppercase'
    },
    Title: {
        margin: '0',
        // Was '500' (banned display band, §7) with the same theme-invariant-
        // vs-adaptive mismatch as the root color (dark: gray11, light: gray3 —
        // close to `caption` but off-token). 700 + `caption` match the root fix
        // and the SectionHeader.js title precedent (600→700).
        fontWeight: '700',
        color: 'caption'
    }
};

});

parcelRegister("gR6Ze", function(module, exports) {

$parcel$export(module.exports, "ArticleBig", () => $c45703fa3426a254$export$534e4d733a51b09b);
const $c45703fa3426a254$export$534e4d733a51b09b = {
    extends: 'Article',
    Title: {
        tag: 'h1',
        fontSize: 'E',
        fontWeight: '700'
    }
};

});

parcelRegister("hyPFg", function(module, exports) {

$parcel$export(module.exports, "Breadcrumb", () => $cc8db02467791c4d$export$dabcc1ec9dd9d1cc);
const $cc8db02467791c4d$export$dabcc1ec9dd9d1cc = {
    tag: 'nav',
    childExtends: 'Link',
    display: 'flex',
    align: 'center',
    childProps: {
        fontWeight: '400',
        textDecoration: 'none',
        scrollToTop: false,
        // Emphasis is expressed as a REACTIVE PROP, not an `[href]` attribute
        // selector. Neither selector form ever applied: `&[href]` was dropped
        // outright, and the bare `[href]` the engine nests is a DESCENDANT
        // selector (`.crumb [href]`), which matches nothing here. So every crumb —
        // linked or not — fell through to the base colour, and that base was
        // `line`, the HAIRLINE token (gray13 in light), rendering the whole trail
        // at near-invisible contrast on a light surface. A factory reads the prop
        // directly and works on every runtime.
        // A crumb is atomic: its separator dot is an inline-block followed by a
        // text node, which is a legal line-break point, so in any container too
        // narrow for the whole trail the dot broke onto its own line and that
        // crumb became two lines tall. Siblings without a dot stayed one line,
        // and `alignItems: center` then staggered them — the trail read as two
        // baselines. Measured: 'Docs' h=26 next to 'Components' h=51.
        whiteSpace: 'nowrap',
        color: (el)=>el.href ? 'title' : 'inactive',
        cursor: (el)=>el.href ? 'pointer' : 'default',
        ':hover': {
            textDecoration: 'underline'
        },
        ':not(:first-child):before': {
            content: '""',
            display: 'inline-block',
            // `V` renders a 1.53px dot - at 50% opacity on an already-muted token
            // that is invisible, which is what made crumbs read as running together.
            // `X` (~4px) is a separator you can actually see; the muted `inactive`
            // colour alone carries the de-emphasis, so the extra alpha comes off.
            width: 'X',
            height: 'X',
            round: '100%',
            background: 'inactive',
            // `middle`, not a baseline offset: an inline-block sitting on the text
            // baseline
            // grows the line box of the items that HAVE a separator, so crumb 1 sat
            // visibly higher than crumbs 2-3. Centring the dot on the text leaves
            // every crumb on one baseline.
            verticalAlign: 'middle',
            marginInline: '.65em'
        }
    },
    children: (el, s, ctx2)=>{
        const routeArr = (el.call('sameOriginTop')?.location?.pathname || window.location.pathname).split("/").slice(1);
        return routeArr.map((text, i)=>text === "page" ? {
                href: "/pages",
                text: "Page"
            } : el.getData("pages")?.[`/${text}`] ? {
                href: `/${routeArr.slice(0, i + 1).join("/")}`,
                text: `/${text}`
            } : {
                href: `/${routeArr.slice(0, i + 1).join("/")}`,
                text: i === 0 ? el.call("toTitleCase", text) : text
            }).filter((_, k)=>{
            const v = routeArr[k];
            return !v.includes("-") && !v.includes("editor") && !v.includes("preview");
        });
    }
};

});

parcelRegister("5MHdM", function(module, exports) {

$parcel$export(module.exports, "ArticleTiny", () => $4362f64b65acbbf2$export$408af9d99e452260);
const $4362f64b65acbbf2$export$408af9d99e452260 = {
    extends: 'Article',
    gap: '0',
    Title: {},
    P: {
        fontSize: 'Z'
    }
};

});

parcelRegister("3Cyd9", function(module, exports) {

$parcel$export(module.exports, "ArticleXS", () => $2a2f755341d67913$export$194d2f78c954be33);
const $2a2f755341d67913$export$194d2f78c954be33 = {
    extends: 'Article',
    gap: 'X',
    Title: {
        tag: 'h5',
        fontSize: 'Z1'
    },
    P: {
        fontSize: 'Z1'
    }
};

});

parcelRegister("fNkvN", function(module, exports) {

$parcel$export(module.exports, "ButtonTitle", () => $b7fb57d92a4c3b57$export$c72d460b11e49d5c);
const $b7fb57d92a4c3b57$export$c72d460b11e49d5c = {
    extends: 'Button',
    fontSize: 'A',
    padding: '0',
    background: 'transparent',
    color: 'inactive',
    gap: 'Z',
    width: 'fit-content',
    ':hover > div': {
        background: 'overlayStrong',
        color: 'title'
    },
    // Icon-only: the icon-button law (IconButton.js) sets the square.
    IconButton: {
        round: 'Z2'
    },
    Caption: {
        fontSize: 'Z'
    }
};

});

parcelRegister("kbmiw", function(module, exports) {

$parcel$export(module.exports, "ArticleMedium", () => $eb1621950920fd0a$export$5be88be36b215324);
const $eb1621950920fd0a$export$5be88be36b215324 = {
    extends: 'Article',
    gap: 'X',
    Title: {
        tag: 'h2',
        fontSize: 'B'
    }
};

});

parcelRegister("9ZvGZ", function(module, exports) {

$parcel$export(module.exports, "ArticleSmall", () => $746265018ccd074f$export$1333c742efbe0d63);
const $746265018ccd074f$export$1333c742efbe0d63 = {
    extends: 'Article',
    gap: 'X',
    Title: {
        fontSize: 'A',
        tag: 'h4'
    }
};

});

parcelRegister("9KDwT", function(module, exports) {

$parcel$export(module.exports, "CanvasEmbed", () => $719712ad576c0329$export$f5fbc0b4b0d1945c);
const $719712ad576c0329$export$f5fbc0b4b0d1945c = {
    extends: 'Iframe',
    minWidth: 'none',
    minHeight: 'none',
    border: 'none',
    width: '100%',
    height: 'H2',
    project: '/nikoloza/default',
    src: (el)=>"https://symbols.app/embed" + el.project,
    round: 'Z2'
};

});

parcelRegister("fIX3j", function(module, exports) {

$parcel$export(module.exports, "CancelButton", () => $b728c5aa3c7cd3d2$export$488fee190faedb43);
const $b728c5aa3c7cd3d2$export$488fee190faedb43 = {
    extends: [
        'Link',
        'Button'
    ],
    // A standalone action is a capsule (DESIGN_LANGUAGE §6.2). Was the em
    // letter `D`.
    round: 'radiusPill',
    // THE HOUSE CAPSULE SCALE, the same as its partner CheckButton (the
    // control table, DESIGN_LANGUAGE §6: `minHeight controlH` from Button,
    // padding `- A`). It was `Z1 D1` — 83px of inline padding a side, so a
    // "Cancel" capsule measured 219px beside a 118px CheckButton (never the
    // "equal in size" pair below), and in the equal phone tracks of the shared
    // AppDialogFooter it left a ~4px content box for the label
    // (DESIGN-APPDIALOGFOOT-LONG-ACTIONS-CLIP-AND-OVERFLOW-1).
    padding: '0 A',
    // 600 doesn't exist in this face (see SectionHeader.js) — was silently
    // rendering as 700 anyway.
    fontWeight: '700',
    // THE TONAL SECONDARY (brief K2 and §4.7, 2026-09-24): a grey tonal capsule
    // beside the ink primary (CheckButton), equal in size. Was the retired
    // `secondary` theme: its dark fill gray2.85 is the dialog panel's own gray2,
    // so the button had no visible plate there, and its light fill was a
    // gradient. The fill mixes the button's OWN ink (Rule 67: a tint of
    // currentColor follows the ink per scheme) — 14% at rest, 22% on hover, 30%
    // pressed; every step clears Rule 65's 0.02 luminance floor on the white and
    // the dark panel (tests/brand/cancelButtonTonal).
    color: 'title',
    background: 'color-mix(in srgb, currentColor 14%, transparent)',
    ':hover': {
        background: 'color-mix(in srgb, currentColor 22%, transparent)'
    },
    ':active': {
        background: 'color-mix(in srgb, currentColor 30%, transparent)'
    },
    // THE DISABLED LAW: the field-disabled pair, never opacity (as CheckButton).
    ':disabled': {
        theme: 'field-disabled',
        opacity: '1'
    },
    // THE CAPSULE LAW (overflow law §3b.8, Nika 2026-09-26: "you should also
    // fix modals, dropdowns, widgets cutting ui and buttons and texts in
    // overflow"). The label WRAPS between words instead of running out of the
    // capsule — no nowrap, no ellipsis — and the capsule grows from its
    // `controlH` floor; `lineHeight: 1.2` keeps one line exactly on the 44px
    // floor and gives two lines their leading. The capsule's minimum width is
    // its label's longest word (the flex default), and it is never wider than
    // its container. Words never break: in a slot narrower than the padding
    // leaves room for (an equal-width phone footer track), a word spills into
    // the capsule's own padding — visible, never cut — rather than splitting
    // into letters. The padding stays one `padding` key, so a call site's own
    // padding still replaces it whole (a longhand here would race it by sheet
    // order).
    whiteSpace: 'normal',
    textAlign: 'center',
    lineHeight: '1.2',
    maxWidth: '100%',
    text: 'Read the docs'
};

});

parcelRegister("c4aHg", function(module, exports) {

$parcel$export(module.exports, "CaptionTitle", () => $8c8e27eae22459ad$export$bb64f969ca4371a9);
const $8c8e27eae22459ad$export$bb64f969ca4371a9 = {
    margin: 'W auto - -',
    // `inactive` = [gray6, gray10] — an ADAPTIVE pair, which is the whole point.
    // Was `disabled` (4.37:1 on the light /files rail — fails 4.5 at 11.1px; the
    // WCAG disabled-control exemption does not apply to a static group heading).
    // Was briefly `gray`, which is a FLAT scalar (#57575c, no dark variant) and
    // measured 2.15–2.56:1 on every dark shell ground — strictly worse than what
    // it replaced. `inactive` clears 4.5 on both themes: 5.60–7.08 light,
    // 5.41–6.44 dark. `caption` also passes but at 9.9–14.8 reads louder than
    // the rows it heads.
    color: 'inactive',
    fontSize: 'Y1',
    textTransform: 'uppercase',
    align: 'center',
    Text: {
        text: 'Active Project'
    }
};

});

parcelRegister("iJYdD", function(module, exports) {

$parcel$export(module.exports, "CanvasEmbed.ClickToLoad", () => $da4b242f53733b17$export$f847d78308099bb3);
const $da4b242f53733b17$export$f847d78308099bb3 = {
    position: 'relative',
    // Was `border: '1px solid line'` — the "1px solid line" habit
    // design-direction.md §8 bans by name (crisp stroked outline sitting
    // inside the already-toned `Stage` card, an outlined-container defect).
    // Fix per §8's prescribed remedy: replace with a tonal fill step, not a
    // bare deletion. The live mount (BrandComponentsGrid's catalog cell)
    // nests this directly inside `Stage`, which already carries `theme:
    // 'common-box'` — a flat `background: 'overlay'` wash is the SAME hue
    // as `common-box` composited over itself (5% gray2-over-gray2 in dark
    // resolves to gray2, i.e. zero visible separation), so `common-box`
    // itself would collide too. `common-box-secondary` is the package's own
    // next tonal step (designSystem/theme.js), built for exactly this
    // nested-surface case, and reads distinctly against the parent in both
    // themes.
    theme: 'common-box-secondary',
    round: 'Z2',
    overflow: 'hidden',
    onClick: (e, el)=>{
        el.LoaderRatio.update({
            animation: 'scaleInOut',
            animationDelay: 'F',
            pointerEvents: 'none'
        });
        el.CanvasEmbed.update({
            hide: false,
            show: true
        });
    },
    minHeight: 'G',
    LoaderRatio: {
        align: 'center center',
        position: 'absolute',
        pointerEvents: 'auto',
        Button: {
            position: 'relative',
            zIndex: 3,
            gap: 'X2',
            transform: 'none',
            icon: 'play',
            theme: 'quaternary',
            text: 'Click to preview'
        }
    },
    CanvasEmbed: {
        minWidth: 'auto',
        minHeight: 'auto',
        border: 'none',
        width: '100%',
        height: '100%',
        inset: '0',
        project: '/nikoloza/default',
        src: (el)=>'https://symbols.app/embed' + (el.parent.project || el.project),
        round: 'Z2'
    }
};

});

parcelRegister("eGl5U", function(module, exports) {

$parcel$export(module.exports, "CanvasButton", () => $ab0559cc0f791d45$export$a498b2f163437f5f);
const $ab0559cc0f791d45$export$a498b2f163437f5f = {
    // Was a bare `theme` on a default <div>: not a real button, not keyboard
    // focusable, no accessible name. Extend CircleButton so it renders a real
    // <button> (keyboard-operable, inherits the focus ring) and keep the
    // canvas-chrome look via the navbarButton theme.
    // IconButton second: the icon-button law squares an icon-only canvas button
    // (36px); the text variants (the canvas page and env dropdowns carry a Text
    // child) keep the CircleButton geometry.
    extends: [
        'CircleButton',
        'IconButton'
    ],
    theme: 'navbarButton',
    // Accessible-name bridge: an icon-only button that passes `title` and no
    // name of its own is announced by that title.
    //
    // It is a REACTIVE prop, not a one-shot `onRender` copy. The copy ran once and
    // then refused to touch an `aria-label` that already existed — so the name
    // was whatever the title said on the FIRST render. On a Georgian boot that is
    // English: the language chunk lands after the first paint, the `title`
    // effect re-runs and turns Georgian, and the copied name stayed English for
    // the life of the element (measured live 2026-09-22: `title="აკრეფაზე
    // დაბრუნება"` beside `aria-label="Back to typing"` on the same node; 19 such
    // names on one page). A function reads the same `title` inside its own effect,
    // so it follows the language, the state and a late bundle exactly as the
    // title does. A name the call site declares — flat, camelCase, inside
    // `aria: {}` or inside `attr: {}` — still wins: it replaces this prop, or is
    // mirrored by it.
    'aria-label': (el, s)=>{
        // Every shape a call site may have named the control in, then the title.
        // (A flat `'aria-label'` on the call site never reaches here: it replaces
        // this prop.) Mirroring them keeps the two writers of one attribute in
        // agreement, so neither can erase the other's name.
        const sources = [
            el.attr && el.attr['aria-label'],
            el.aria && el.aria.label,
            el.ariaLabel,
            el.title
        ];
        for (const source of sources){
            const value = typeof source === 'function' ? source(el, s, el.context) : source;
            if (value != null && value !== '') return value;
        }
        return null;
    }
};

});

parcelRegister("lSwJ7", function(module, exports) {

$parcel$export(module.exports, "CheckParagraph", () => $fed806f5d4088cfa$export$e6eb09306d3c871e);
const $fed806f5d4088cfa$export$e6eb09306d3c871e = {
    extends: 'IconText',
    text: (el, s)=>s.value || s.text,
    gap: 'Y',
    color: 'title',
    width: 'fit-content',
    icon: 'checkmark',
    Icon: {
        order: '-1',
        color: 'paragraph'
    }
};

});

parcelRegister("1YyiB", function(module, exports) {

$parcel$export(module.exports, "AccordionItem", () => $1706001c21edf9f8$export$d99097c13d4dac9f);
const $1706001c21edf9f8$export$d99097c13d4dac9f = {
    state: {
        isActive: false
    },
    flow: 'y',
    position: 'relative',
    align: 'flex-start',
    overflow: 'hidden',
    padding: 'Z1 W',
    width: '100%',
    maxWidth: 'H1',
    transition: 'A defaultBezier padding',
    '.isActive': {
        paddingBlockEnd: (el)=>{
            const Section = el.Section.node;
            const height = Section?.getBoundingClientRect?.().height || 0;
            return `calc(${height}px + 1em)`;
        }
    },
    Flex: {
        minWidth: '100%',
        align: 'center space-between',
        cursor: 'pointer',
        userSelect: 'none',
        round: 'radiusControl',
        // Was a 1px top border on the outer item (hairline-as-separator between
        // stacked accordion rows, banned by design-direction.md §8). Stacked
        // items now separate by whitespace (the item's own padding: 'Z1 W')
        // alone, with a hover wash on the clickable header — same fill-contrast
        // device as BrandInkRow's `round` + `:hover: { background: 'hover' }`.
        ':hover': {
            background: 'hover'
        },
        onClick: (event, element, state)=>{
            state.toggle('isActive');
        },
        P: {
            padding: 'X2 -',
            margin: '0',
            text: 'Question text one here',
            color: 'title'
        },
        Icon: {
            icon: 'arrowAngleDown',
            textDecoration: 'none',
            fontSize: 'B',
            '.isActive': {
                transform: 'rotate(180deg)'
            }
        }
    },
    Section: {
        text: 'Use a checkbox when users can select one option, multiple options, or no option from a list of a possible options.',
        position: 'absolute',
        padding: 'Z2 0 W',
        color: 'paragraph',
        cursor: 'default',
        top: 'C',
        transition: 'A defaultBezier',
        transitionProperty: 'margin, opacity',
        '.isActive': {
            opacity: '1'
        },
        '!isActive': {
            opacity: '0'
        }
    }
};

});

parcelRegister("i09Uw", function(module, exports) {

$parcel$export(module.exports, "CanvasEmbed2", () => $d1afea275f715903$export$e2097b38d266dd01);
const $d1afea275f715903$export$e2097b38d266dd01 = {
    Flex: {
        align: 'center center',
        position: 'absolute',
        inset: '0',
        onClick: (e, el)=>{
            el.update({
                animation: 'scaleInOut',
                animationDuration: 'F',
                pointerEvents: 'none'
            });
            el.nextElement().update({
                hide: false,
                show: true
            });
        },
        LoaderRatio: {
            position: 'absolute',
            pointerEvents: 'auto',
            opacity: '0.9',
            zIndex: 2
        },
        Button: {
            position: 'relative',
            zIndex: 3,
            gap: 'X2',
            transform: 'none',
            icon: 'play',
            theme: 'quaternary',
            text: 'Click to Preview'
        }
    },
    CanvasEmbed: {
        minWidth: 'none',
        minHeight: 'none',
        border: 'none',
        width: '100%',
        height: 'H2',
        project: '/nikoloza/default',
        src: (el)=>'https://symbols.app/embed' + (el.parent.project || el.project),
        round: 'Z2'
    },
    position: 'relative',
    minWidth: 'H3',
    round: 'Z2',
    overflow: 'hidden'
};

});

parcelRegister("jJGfW", function(module, exports) {

$parcel$export(module.exports, "ClickableItem", () => $e5e2ff788d226cc6$export$7e5e4c134d7e54da);
// RULE 65 (2026-09-23): a hover is a FILL step, never opacity. This mixin
// rested every user at opacity .85 and hovered to .9 — it dimmed each label by
// 15% (a primary CheckButton read 14.7:1 instead of 20.5:1) and stepped less
// than the 0.02 floor, while masking themes whose own hover fills were dead.
// The fill steps now live in the themes (theme.js); this keeps only the
// tactile scale.
const $e5e2ff788d226cc6$export$7e5e4c134d7e54da = {
    transition: 'B defaultBezier',
    transitionProperty: 'transform',
    theme: 'secondary',
    userSelect: 'none',
    draggable: false,
    ':hover': {
        transform: 'scale(1.005)'
    },
    ':active': {
        transform: 'scale(1.005)'
    },
    '.isActive': {
        theme: (el, s)=>'secondary @' + (s.root.globalTheme || 'dark.active')
    }
};

});

parcelRegister("bQLwk", function(module, exports) {

$parcel$export(module.exports, "ColumnParagraphs", () => $8a0969a16cbcecc9$export$a0e67292cc68ffe7);
const $8a0969a16cbcecc9$export$a0e67292cc68ffe7 = {
    extends: 'Grid',
    childExtends: 'P',
    width: '100%',
    gap: 'C',
    columns: '4fr 7fr 7fr',
    '@mobileM': {
        display: 'flex',
        flow: 'y'
    },
    childProps: {
        maxWidth: 'G+C',
        color: 'paragraph'
    }
};

});

parcelRegister("gpow1", function(module, exports) {

$parcel$export(module.exports, "ConnectionLabel", () => $bf21ff64409990d9$export$36fb156e37af9d72);
const $bf21ff64409990d9$export$36fb156e37af9d72 = {
    gap: 'Z',
    align: 'center',
    color: 'paragraph',
    isActive: true,
    '.isActive': {
        color: 'caption'
    },
    Circle: {
        round: 'A',
        boxSize: 'Z',
        isActive: (el)=>el.parent.isActive,
        '.isActive': {
            background: 'green'
        },
        '!isActive': {
            background: 'shadow'
        }
    },
    Text: {
        text: (el)=>el.parent.isActive ? "Connected" : "Not connected"
    },
    CopyButton: {
        hide: (el)=>!el.parent.isActive,
        value: (el)=>`https://${el.getAppKey()}/`,
        icon: 'copy outline',
        background: 'transparent'
    }
};

});

parcelRegister("dmkwK", function(module, exports) {

$parcel$export(module.exports, "CheckButton", () => $9b9d40b3546ce980$export$c767f14fef25f1ed);
const $9b9d40b3546ce980$export$c767f14fef25f1ed = {
    extends: [
        'Button',
        'ClickableItem'
    ],
    icon: 'checkmark',
    text: 'Okay',
    // THE HOUSE CAPSULE SCALE (DESIGN_LANGUAGE §6, the control table: a primary
    // or secondary button is `fontSize Z2`, `minHeight controlH`, padding
    // `- A` on the x-axis, `radiusPill`). The height comes from Button's
    // `controlH` floor, the inline room is `A`. It was `Z1 B1 Z1 B`, off the
    // scale — and nine call sites (the auth forms, the add / edit modals, the
    // invite page) restated `padding: '0 A'` by hand to get the law back
    // (Rule 68: the control owns its padding; a call site never overrides it).
    // One `padding` key, so a call site that still sets its own replaces it
    // whole (overflow law, the capsule law in CancelButton.js).
    padding: '0 A',
    // The confirm action is a capsule (DESIGN_LANGUAGE §6.2); nine call
    // sites already forced `round: 'radiusPill'` over the old em letter `B`.
    round: 'radiusPill',
    align: 'center center',
    // The confirm action is the primary action: solid ink (Nika 2026-09-23,
    // "primary (Recommended)"). Was the retired `quaternary` (§2.4), whose
    // written alias `card` painted white ink on near-white in light, 1.16:1.
    theme: 'primary',
    gap: 'X2',
    // THE CAPSULE LAW (overflow law §3b.8, CancelButton.js): the label wraps
    // between words instead of running out of the capsule, one line stays on
    // the 44px floor, the minimum width is the longest word, and the capsule is
    // never wider than its container.
    whiteSpace: 'normal',
    textAlign: 'center',
    lineHeight: '1.2',
    maxWidth: '100%',
    // THE DISABLED LAW: a disabled primary gives up its ink fill for the
    // `field-disabled` pair — never opacity (it read 2.73:1 dark / 1.89:1
    // light at .35). `opacity: 1` cancels ClickableItem's resting .85, which
    // would otherwise dim the disabled label to ~4.0:1.
    ':disabled': {
        theme: 'field-disabled',
        opacity: '1'
    }
};

});

parcelRegister("7qS6t", function(module, exports) {

$parcel$export(module.exports, "CheckboxField", () => $5694edf0663f69e5$export$94195a47b94ed396);
// HOUSE REFERENCE for an accessible custom control (A11Y-1 sibling audit,
// 2026-08-15): keep the REAL input in the tree — sr-only via opacity:0 +
// position:absolute (never display:none, which drops it from the tab
// order), the wrapping <label> carries the click, keyboard state flows
// through the native input, and the focus ring lands on the visible
// sibling via the ':checked'/focus sibling selectors below. Building a new
// custom control (switch, radio card, segmented pick)? Start from this
// shape instead of a div-with-onClick — and contrast it with the
// SelectField chevron case: a control that is DECORATIVE gets demoted
// (aria-hidden + tabindex -1), a control that is FUNCTIONAL keeps a real
// native input like this one. Those are the only two correct endpoints.
const $5694edf0663f69e5$export$94195a47b94ed396 = {
    flow: 'x',
    tag: 'label',
    gap: 'Y',
    align: 'center',
    Input: {
        type: 'checkbox',
        checked: (el, s)=>el.parent.checked,
        // sr-only but keyboard-focusable — was display:none, which dropped the box out
        // of the tab order so it could not be toggled with the keyboard. The wrapping
        // label still toggles on click; the visible checkmark shows the focus ring.
        position: 'absolute',
        opacity: '0',
        margin: '0',
        pointerEvents: 'none',
        ':checked': {
            '~ span': {
                opacity: '.85'
            },
            '~ svg': {
                color: 'title'
            }
        },
        // The Input itself is visually hidden (opacity 0), so THE global focus
        // ring (brand reset.js, DESIGN_LANGUAGE §8.2 — one ring, globally) has
        // to land on the visible sibling icon via this selector. `focusRing` is
        // that exact ring as a shadow token (designSystem/shadow.js) — the same
        // double ring every other form element gets from the reset. It was
        // briefly the framework atom's `outline: 'solid X blue.3'`, a SECOND,
        // different ring — the F1 inconsistency (Nika 2026-08-16).
        ':focus-visible': {
            '~ svg': {
                shadow: 'focusRing'
            }
        }
    },
    Icon: {
        // Plain Icon by key auto-extend. It used to also extend the framework
        // `Focusable` atom (resting `outline: 'solid 0 blue.3'`) — that atom is
        // the second ring F1 retired; the ring now arrives from the Input's
        // `:focus-visible ~ svg` rule above as `focusRing`.
        name: 'checkmark',
        round: 'X',
        fontSize: 'A',
        padding: 'W',
        boxSizing: 'content-box',
        cursor: 'pointer',
        background: 'line',
        color: 'disabled.35'
    },
    Span: {
        userSelect: 'none',
        text: 'This is variable font',
        opacity: '.5',
        cursor: 'pointer'
    }
};

});

parcelRegister("fuKk1", function(module, exports) {

$parcel$export(module.exports, "ContinueButton", () => $b47d96ec4361ff5e$export$16aabeb6d5633c80);
const $b47d96ec4361ff5e$export$16aabeb6d5633c80 = {
    extends: [
        'Link',
        'Button'
    ],
    // A standalone action is a capsule (DESIGN_LANGUAGE §6.2). Was the em
    // letter `D`.
    round: 'radiusPill',
    padding: 'Z1 D1',
    // 600 doesn't exist in this face (see SectionHeader.js) — was silently
    // rendering as 700 anyway.
    fontWeight: '700',
    theme: 'primary',
    // Was `color: 'title'` — `title` (['gray1','gray15']) shares the SAME
    // polarity as `theme: 'primary'`'s own background in BOTH directions
    // (@light bg=gray1/@dark bg=white), collapsing ink and ground to the same
    // colour: measured 1:1 light (rgb(4,4,4) on rgb(4,4,4)) and 1.13:1 dark
    // (AA walk 2026-08-09, LMC-4 — the worst site in the whole sweep). Simply
    // deleting the override does NOT fix it — `extends: ['Link', ...]` puts
    // `color: 'currentColor'` in the chain, which just inherits the same
    // broken ambient ink from this button's container instead. `highlight`/
    // `highlight-reversed` (['white','black'] resp. ['black','white']) is the
    // established ink-capsule pairing already used for primary actions
    // elsewhere in this codebase (MemberProfile SaveBtn/MessageBtn) and is
    // the correct REVERSE of `theme: 'primary'`'s own background polarity —
    // verified >=17:1 in both themes against this theme's own background.
    color: 'highlight-reversed',
    // THE CAPSULE LAW (overflow law §3b.8, Nika 2026-09-26: "you should also
    // fix modals, dropdowns, widgets cutting ui and buttons and texts in
    // overflow"). The label WRAPS between words instead of running out of the
    // capsule — no nowrap, no ellipsis — and the capsule grows from its
    // `controlH` floor; `lineHeight: 1.2` keeps one line exactly on the 44px
    // floor and gives two lines their leading. The capsule's minimum width is
    // its label's longest word (the flex default), and it is never wider than
    // its container. Words never break: in a slot narrower than the padding
    // leaves room for (an equal-width phone footer track), a word spills into
    // the capsule's own padding — visible, never cut — rather than splitting
    // into letters. The padding stays one `padding` key, so a call site's own
    // padding still replaces it whole (a longhand here would race it by sheet
    // order).
    whiteSpace: 'normal',
    textAlign: 'center',
    lineHeight: '1.2',
    maxWidth: '100%',
    text: 'Read the docs'
};

});

parcelRegister("iOGK8", function(module, exports) {

$parcel$export(module.exports, "ComingSoon", () => $db2e0d61aa1f443e$export$d92bac9ccf8f112f);
const $db2e0d61aa1f443e$export$d92bac9ccf8f112f = {
    position: 'relative',
    overflow: 'hidden',
    pointerEvents: 'none',
    minWidth: '10ch',
    minHeight: '5ch',
    ':before': {
        pointerEvents: 'auto',
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 999999,
        background: 'document 0.9'
    },
    Span: {
        flow: 'y',
        position: 'absolute',
        transform: 'translate3d(-50%, -50%, 1px)',
        top: '50%',
        left: '50%',
        zIndex: '999999 + 1',
        whiteSpace: 'nowrap',
        lineHeight: 1.1,
        fontWeight: 'bold',
        color: 'disabled',
        textTransform: 'uppercase',
        fontSize: 'X2',
        align: 'center center',
        Strong: {
            flow: 'x',
            align: 'center',
            text: 'Branching'
        },
        Span: {
            fontWeight: 'normal',
            text: 'Coming soon'
        }
    }
};

});

parcelRegister("eRp7t", function(module, exports) {

$parcel$export(module.exports, "CommonFieldLike", () => $ad198027c07c7a23$export$d16d31b2f42ff96);
const $ad198027c07c7a23$export$d16d31b2f42ff96 = {
    tag: 'label',
    flow: 'column',
    align: 'flex-start',
    gap: 'Y1',
    minWidth: 'F',
    Title: {
        text: '',
        color: 'caption',
        userSelect: 'none',
        whiteSpace: 'nowrap'
    },
    element: {
        width: '100%'
    }
};

});

parcelRegister("knIv3", function(module, exports) {

$parcel$export(module.exports, "Contributors", () => $ed68795f7bbf7726$export$5360f064464e9211);
const $ed68795f7bbf7726$export$5360f064464e9211 = {
    flow: 'column',
    align: 'center flex-start',
    gap: 'D',
    position: 'relative',
    maxWidth: 'J1',
    Hgroup: {
        gap: 'B',
        textAlign: 'center',
        width: 'fit-content',
        color: 'title',
        padding: '- B',
        H: {
            text: 'Meet the creators',
            fontWeight: '100',
            fontSize: 'E1',
            margin: '0',
            '@mobileL': {
                lineHeight: 1,
                margin: '- - W'
            }
        },
        P: {
            margin: '0',
            color: 'title',
            text: 'Read our case studies how you can bootstrap, grow and scale your product with Symbols',
            fontSize: 'B',
            maxWidth: 'G2+B2',
            // Thin (100-300) is readable only at >= D-size display type
            // (design-direction.md §7/geex layer); `B` is smaller than `D`. 400 is
            // the compliant body weight at this size.
            fontWeight: '400'
        }
    },
    Flex: {
        gap: 'A2',
        align: 'center center',
        flow: 'x wrap',
        padding: '- B1',
        '@mobileS': {
            padding: '- Z'
        },
        childProps: {
            boxSize: 'C',
            cursor: 'default',
            opacity: '.65',
            transition: 'opacity defaultBezier A',
            ':hover': {
                opacity: '1'
            }
        },
        childExtends: 'Avatar',
        // Every record carries four fields. `alt` is the display name (the
        // landing wall shows it in a hover bubble), `src` the avatar, `platform`
        // the badge the consumer paints ('github' | 'dribbble' | 'linkedin'),
        // `href` the profile the consumer links to.
        //
        // Nika 2026-09-04: "add https://dribbble.com/Tamarashvili
        // https://dribbble.com/IrakliBeridze https://dribbble.com/imlahmacun
        // those randomly in contributors with small dribble logo. others github
        // logo." The three dribbble people sit at indexes 10, 15 and 28, picked
        // with a seeded shuffle (python random.Random(20260904), sample from
        // range(3, 49), re-drawn until no two are adjacent) so the founders in
        // rows 0-2 keep their places. Their pictures are the profiles' own
        // avatars, re-hosted as public brand files — a dribbble CDN URL is
        // signed and expires.
        //
        // `platform` and `href` are inert HERE: neither is a CSS prop and neither
        // is a valid `img` attribute, so the library's own site still renders
        // plain avatars. The landing swaps `childExtends` for a wrapper that
        // reads them (landing components/AboutContributorTip.js).
        children: [
            {
                alt: 'nikoloza',
                src: 'https://avatars.githubusercontent.com/u/962224?s=120&v=4',
                platform: 'github',
                href: 'https://github.com/nikoloza'
            },
            {
                alt: 'svinchy',
                src: 'https://avatars.githubusercontent.com/u/36074573?s=120&v=4',
                platform: 'github',
                href: 'https://github.com/svinchy'
            },
            {
                alt: 'tokoyoung',
                src: 'https://avatars.githubusercontent.com/u/33081308?s=120&v=4',
                platform: 'github',
                href: 'https://github.com/tokoyoung'
            },
            {
                alt: 'gugakatsi',
                src: 'https://avatars.githubusercontent.com/u/9134169?s=120&v=4',
                platform: 'github',
                href: 'https://github.com/gugakatsi'
            },
            {
                alt: 'nikaoto',
                src: 'https://avatars.githubusercontent.com/u/21026339?s=120&v=4',
                platform: 'github',
                href: 'https://github.com/nikaoto'
            },
            {
                alt: 'AlexTogonidze',
                src: 'https://avatars.githubusercontent.com/u/15612347?s=120&v=4',
                platform: 'github',
                href: 'https://github.com/AlexTogonidze'
            },
            {
                alt: 'denismemphis',
                src: 'https://avatars.githubusercontent.com/u/126146345?v=4',
                platform: 'github',
                href: 'https://github.com/denismemphis'
            },
            {
                alt: 'MariamZedginidze',
                src: 'https://avatars.githubusercontent.com/u/66626385?v=4',
                platform: 'github',
                href: 'https://github.com/MariamZedginidze'
            },
            {
                alt: 'rezicosta',
                src: 'https://avatars.githubusercontent.com/u/26996528?v=4',
                platform: 'github',
                href: 'https://github.com/rezicosta'
            },
            {
                alt: 'lberia',
                // Nika 2026-09-04: "whos not having avatar use linkedin avatars".
                // The GitHub account serves an identicon, so the wall carries Luka's
                // own LinkedIn portrait, re-hosted as a public brand file (a LinkedIn
                // media URL is signed and expires). 100x100 is all LinkedIn serves on
                // the profile page; the wall paints 36px.
                src: 'https://api.symbols.app/core/files/public/6a9ad77184ba7692b1239432/download',
                platform: 'github',
                href: 'https://github.com/lberia'
            },
            {
                alt: 'Giga Tamarashvili',
                src: 'https://api.symbols.app/core/files/public/6a9acff984ba7692b12146ee/download',
                platform: 'dribbble',
                href: 'https://dribbble.com/Tamarashvili'
            },
            // Nika 2026-09-04: the GitHub identicon record for Irakli Beridze retired —
            // he is on the wall once, with his Dribbble portrait (below).
            // Nika 2026-09-06: "JoshSymbols also Joshua McMillan from linkedin" —
            // the record names Joshua McMillan and links his LinkedIn profile. The
            // picture is his LinkedIn portrait at 400x400, the size his photo viewer
            // serves, re-hosted as a public brand file the way Chuck Homola's record
            // below is — a LinkedIn media URL is signed and it expires.
            {
                alt: 'Joshua McMillan',
                src: 'https://api.symbols.app/core/files/public/6a9cc43a99101e69014b2822/download',
                platform: 'linkedin',
                href: 'https://www.linkedin.com/in/joshua-mcmillan-49093797/'
            },
            // Nika 2026-09-04: "take picture for Josh, Chuck Humola from linkedin".
            // Chuck's LinkedIn top card names Symbols as his company, which is the
            // tie that put him on the wall. His own profile spells the family name
            // `Homola`, so the wall carries that spelling. The picture is his
            // LinkedIn portrait, re-hosted as a public brand file — a LinkedIn media
            // URL is signed and expires. Index 12 of 49, drawn from the slots that
            // sit after the founders and touch no dribbble record
            // (python random.Random(20260904), the same seed as the dribbble draw).
            {
                alt: 'Chuck Homola',
                src: 'https://api.symbols.app/core/files/public/6a9b1776a27239d2a5c9805a/download',
                platform: 'linkedin',
                href: 'https://www.linkedin.com/in/chuck-homola/'
            },
            {
                alt: 'julianbraha',
                src: 'https://avatars.githubusercontent.com/u/11775551?v=4',
                platform: 'github',
                href: 'https://github.com/julianbraha'
            },
            {
                alt: 'Thomas-sls',
                src: 'https://avatars.githubusercontent.com/u/190420750?v=4',
                platform: 'github',
                href: 'https://github.com/Thomas-sls'
            },
            {
                alt: 'Irakli Beridze',
                src: 'https://api.symbols.app/core/files/public/6a9acffb84ba7692b121485c/download',
                platform: 'dribbble',
                href: 'https://dribbble.com/IrakliBeridze'
            },
            {
                alt: 'gustavo-mvp',
                src: 'https://avatars.githubusercontent.com/u/155124851?v=4',
                platform: 'github',
                href: 'https://github.com/gustavo-mvp'
            },
            {
                alt: 'zajim',
                src: 'https://avatars.githubusercontent.com/u/13951819?v=4',
                platform: 'github',
                href: 'https://github.com/zajim'
            },
            {
                alt: 'elanor',
                src: 'https://avatars.githubusercontent.com/u/1854525?v=4',
                platform: 'github',
                href: 'https://github.com/elanor'
            },
            {
                alt: 'sarmaakondi',
                src: 'https://avatars.githubusercontent.com/u/125581326?v=4',
                platform: 'github',
                href: 'https://github.com/sarmaakondi'
            },
            {
                alt: 'franciso-smbl',
                src: 'https://avatars.githubusercontent.com/u/194151767?v=4',
                platform: 'github',
                href: 'https://github.com/franciso-smbl'
            },
            {
                alt: 'frank0170',
                src: 'https://avatars.githubusercontent.com/u/75906369?v=4',
                platform: 'github',
                href: 'https://github.com/frank0170'
            },
            {
                alt: 'moises921',
                src: 'https://avatars.githubusercontent.com/u/189148078?v=4',
                platform: 'github',
                href: 'https://github.com/moises921'
            },
            {
                alt: 'JerrayChen',
                src: 'https://avatars.githubusercontent.com/u/18450060?v=4',
                platform: 'github',
                href: 'https://github.com/JerrayChen'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?v=4',
                platform: 'github',
                href: 'https://github.com/lekyatummala11'
            },
            {
                alt: 'temo-abuladze',
                // Nika 2026-09-04: Teimuraz's own portrait (brand file
                // teimuraz-abuladze.jpg, public download) instead of the GitHub avatar
                src: 'https://api.symbols.app/core/files/public/6a9ab85e84ba7692b1194c5f/download',
                platform: 'github',
                href: 'https://github.com/temo-abuladze'
            },
            {
                alt: 'ventura-v',
                src: 'https://avatars.githubusercontent.com/u/42718816?v=4',
                platform: 'github',
                href: 'https://github.com/ventura-v'
            },
            {
                alt: 'baronsilver',
                src: 'https://avatars.githubusercontent.com/u/9947568?v=4',
                platform: 'github',
                href: 'https://github.com/baronsilver'
            },
            {
                alt: "Royhan \xae",
                src: 'https://api.symbols.app/core/files/public/6a9acffd84ba7692b1214a1b/download',
                platform: 'dribbble',
                href: 'https://dribbble.com/imlahmacun'
            },
            {
                alt: 'Adeapt-Admin',
                src: 'https://avatars.githubusercontent.com/u/186253875?v=4',
                // renamed on GitHub — the id behind the avatar (186253875) now
                // answers to `joshua-sw`; the old /Adeapt-Admin URL is a 404
                platform: 'github',
                href: 'https://github.com/joshua-sw'
            },
            {
                alt: 'allenbrokeit',
                src: 'https://avatars.githubusercontent.com/u/7524514?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/allenbrokeit'
            },
            {
                alt: 'Rafael-symbols',
                src: 'https://avatars.githubusercontent.com/u/200677621?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/Rafael-symbols'
            },
            {
                alt: 'imadyaici',
                // Nika 2026-09-04: "whos not having avatar use linkedin avatars".
                // The GitHub account serves an identicon, so the wall carries Imad's
                // own LinkedIn portrait, re-hosted as a public brand file (a LinkedIn
                // media URL is signed and expires). 100x100 is all LinkedIn serves on
                // the profile page; the wall paints 36px.
                src: 'https://api.symbols.app/core/files/public/6a9ad78084ba7692b12399ae/download',
                platform: 'github',
                href: 'https://github.com/imadyaici'
            },
            {
                alt: 'Manju134-hub',
                // Nika 2026-09-04: "whos not having avatar use linkedin avatars".
                // The GitHub account serves an identicon, so the wall carries Manju's
                // own LinkedIn portrait, re-hosted as a public brand file (a LinkedIn
                // media URL is signed and expires). 100x100 is all LinkedIn serves on
                // the profile page; the wall paints 36px.
                src: 'https://api.symbols.app/core/files/public/6a9ad77684ba7692b12395e2/download',
                platform: 'github',
                href: 'https://github.com/Manju134-hub'
            },
            {
                alt: 'locngy',
                src: 'https://avatars.githubusercontent.com/u/18193324?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/locngy'
            },
            {
                alt: 'Marina-UX-UI',
                src: 'https://avatars.githubusercontent.com/u/198088652?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/Marina-UX-UI'
            },
            {
                alt: 'saisanjivani07',
                src: 'https://avatars.githubusercontent.com/u/203023761?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/saisanjivani07'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/lekyatummala11'
            },
            {
                alt: 'Lathika9Symbols',
                src: 'https://avatars.githubusercontent.com/u/202271754?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/Lathika9Symbols'
            },
            {
                alt: 'sluther',
                src: 'https://avatars.githubusercontent.com/u/38088?s=60&v=4',
                platform: 'github',
                href: 'https://github.com/sluther'
            },
            {
                alt: 'zacharybetzen',
                // Nika 2026-09-04: "whos not having avatar use linkedin avatars".
                // The GitHub account serves an identicon, so the wall carries Zachary's
                // own LinkedIn portrait, re-hosted as a public brand file (a LinkedIn
                // media URL is signed and expires). 100x100 is all LinkedIn serves on
                // the profile page; the wall paints 36px.
                src: 'https://api.symbols.app/core/files/public/6a9ad77b84ba7692b1239866/download',
                platform: 'github',
                href: 'https://github.com/zacharybetzen'
            },
            {
                alt: 'trevor-ratliff',
                src: 'https://avatars.githubusercontent.com/u/4975372?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/trevor-ratliff'
            },
            {
                alt: 'felgluz',
                src: 'https://avatars.githubusercontent.com/u/6673718?s=60&v=4',
                platform: 'github',
                href: 'https://github.com/felgluz'
            },
            {
                alt: 'leticia-chijo',
                src: 'https://avatars.githubusercontent.com/u/41638060?v=4',
                platform: 'github',
                href: 'https://github.com/leticia-chijo'
            },
            {
                alt: 'meGusztav',
                src: 'https://avatars.githubusercontent.com/u/29795175?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/meGusztav'
            },
            {
                alt: 'Aimenle',
                src: 'https://avatars.githubusercontent.com/u/36975334?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/Aimenle'
            },
            {
                alt: 'ju-Skinner',
                src: 'https://avatars.githubusercontent.com/u/1633290?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/ju-Skinner'
            },
            {
                alt: 'JosephMassie',
                src: 'https://avatars.githubusercontent.com/u/2282073?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/JosephMassie'
            },
            {
                alt: 'RuslanLabza',
                src: 'https://avatars.githubusercontent.com/u/64849926?s=96&v=4',
                platform: 'github',
                href: 'https://github.com/RuslanLabza'
            }
        ]
    }
};

});

parcelRegister("8cX1P", function(module, exports) {

$parcel$export(module.exports, "DesignComponent", () => $5f9d3b9121b099be$export$3544240ca2fd0e90);
const $5f9d3b9121b099be$export$3544240ca2fd0e90 = {
    flow: 'column',
    minWidth: 'F1',
    maxWidth: 'F2',
    round: 'A',
    height: 'fit-content',
    theme: 'common-card-interactive',
    overflow: 'hidden',
    userSelect: 'none',
    DesignComponentHeader: {},
    DesignComponentProperties: {}
};

});

parcelRegister("cYjbq", function(module, exports) {

$parcel$export(module.exports, "DesignComponentHeader", () => $9719f80497366d1f$export$2988b5c0fe8e74eb);
const $9719f80497366d1f$export$2988b5c0fe8e74eb = {
    tag: 'header',
    extends: [
        'DesignElement'
    ],
    minWidth: '100%',
    padding: 'Z1 Z2 Z1',
    flow: 'row',
    round: '0',
    align: 'flex-start',
    pointerEvents: 'none',
    '@dark': {
        background: 'gray3.5'
    },
    // Was a light-mode-only `borderBottom` (hairline-as-divider, banned by
    // design-direction.md §8). The dark half already separates the header band
    // by FILL (`gray3.5`, a lighter tonal step over the card's own gray2.65);
    // `white.5` mirrors that exact relationship in light mode (same magnitude,
    // same direction — a touch lighter than the card's gray16+6 base), matching
    // the precedent already used for this light/dark pairing in Labeled.js.
    '@light': {
        background: 'white.5'
    },
    WiderButton: {
        padding: 'Y2',
        icon: ({ state: state })=>state.icon,
        theme: ({ state: state })=>state.iconTheme
    },
    Hgroup: {
        H: {
            text: ({ state: state })=>state.title,
            // 400 is banned for a card/section title (design-direction.md §7): it's
            // squarely display/content text, not body copy. 700 matches the same
            // header-title role already fixed in SectionHeader.js (600→700).
            fontWeight: '700',
            textTransform: 'capitalize'
        },
        P: {
            text: ({ state: state })=>state.paragraph,
            fontSize: 'Z1',
            maxWidth: 'F1'
        }
    }
};

});

parcelRegister("iSb3e", function(module, exports) {

$parcel$export(module.exports, "DescriptionField", () => $dbd5d7a7d5210cad$export$336230c809f2ec53);
const $dbd5d7a7d5210cad$export$336230c809f2ec53 = {
    extends: 'GroupField',
    Title: {
        text: 'Description'
    },
    Textarea: {
        round: 'Y',
        '@tabletS': {
            maxWidth: '100%'
        }
    }
};

});

parcelRegister("jF0L7", function(module, exports) {

$parcel$export(module.exports, "ContributorsCopy", () => $e5026f65ec466616$export$59043a8163a40b49);
const $e5026f65ec466616$export$59043a8163a40b49 = {
    flow: 'column',
    align: 'center flex-start',
    padding: '- A D',
    gap: 'B2',
    maxWidth: '920ypx',
    position: 'relative',
    Hgroup: {
        gap: '0',
        textAlign: 'center',
        width: 'fit-content',
        color: 'title',
        H: {
            text: 'Contributors',
            fontWeight: '700',
            '@mobileL': {
                lineHeight: 1,
                margin: '- - W'
            }
        },
        P: {
            color: 'inactive',
            text: 'Thanks these folks for the Github contribution'
        }
    },
    Flex: {
        gap: 'A2',
        align: 'center center',
        flow: 'x wrap',
        childProps: {
            boxSize: 'C',
            cursor: 'default',
            opacity: '.65',
            transition: 'opacity defaultBezier A',
            ':hover': {
                opacity: '1'
            }
        },
        childExtends: 'Avatar',
        children: [
            {
                alt: 'nikoloza',
                src: 'https://avatars.githubusercontent.com/u/962224?s=120&v=4'
            },
            {
                alt: 'svinchy',
                src: 'https://avatars.githubusercontent.com/u/36074573?s=120&v=4'
            },
            {
                alt: 'tokoyoung',
                src: 'https://avatars.githubusercontent.com/u/33081308?s=120&v=4'
            },
            {
                alt: 'gugakatsi',
                src: 'https://avatars.githubusercontent.com/u/9134169?s=120&v=4'
            },
            {
                alt: 'nikaoto',
                src: 'https://avatars.githubusercontent.com/u/21026339?s=120&v=4'
            },
            {
                alt: 'AlexTogonidze',
                src: 'https://avatars.githubusercontent.com/u/15612347?s=120&v=4'
            },
            {
                alt: 'denismemphis',
                src: 'https://avatars.githubusercontent.com/u/126146345?v=4'
            },
            {
                alt: 'MariamZedginidze',
                src: 'https://avatars.githubusercontent.com/u/66626385?v=4'
            },
            {
                alt: 'rezicosta',
                src: 'https://avatars.githubusercontent.com/u/26996528?v=4'
            },
            {
                alt: 'lberia',
                src: 'https://avatars.githubusercontent.com/u/17147261?v=4'
            },
            {
                alt: 'irakliberidze',
                src: 'https://avatars.githubusercontent.com/u/60253579?v=4'
            },
            {
                alt: 'burdulixda',
                src: 'https://avatars.githubusercontent.com/u/46271505?v=4'
            },
            {
                alt: 'joshSymbols',
                src: 'https://avatars.githubusercontent.com/u/145069451?v=4'
            },
            {
                alt: 'julianbraha',
                src: 'https://avatars.githubusercontent.com/u/11775551?v=4'
            },
            {
                alt: 'Thomas-sls',
                src: 'https://avatars.githubusercontent.com/u/190420750?v=4'
            },
            {
                alt: 'gustavo-mvp',
                src: 'https://avatars.githubusercontent.com/u/155124851?v=4'
            },
            {
                alt: 'AlexanderOttenhoff',
                src: 'https://avatars.githubusercontent.com/u/4759404?v=4'
            },
            {
                alt: 'zajim',
                src: 'https://avatars.githubusercontent.com/u/13951819?v=4'
            },
            {
                alt: 'elanor',
                src: 'https://avatars.githubusercontent.com/u/1854525?v=4'
            },
            {
                alt: 'sarmaakondi',
                src: 'https://avatars.githubusercontent.com/u/125581326?v=4'
            },
            {
                alt: 'franciso-smbl',
                src: 'https://avatars.githubusercontent.com/u/194151767?v=4'
            },
            {
                alt: 'frank0170',
                src: 'https://avatars.githubusercontent.com/u/75906369?v=4'
            },
            {
                alt: 'moises921',
                src: 'https://avatars.githubusercontent.com/u/189148078?v=4'
            },
            {
                alt: 'JerrayChen',
                src: 'https://avatars.githubusercontent.com/u/18450060?v=4'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?v=4'
            },
            {
                alt: 'ventura-v',
                src: 'https://avatars.githubusercontent.com/u/42718816?v=4'
            },
            {
                alt: 'baronsilver',
                src: 'https://avatars.githubusercontent.com/u/9947568?v=4'
            },
            {
                alt: 'Adeapt-Admin',
                src: 'https://avatars.githubusercontent.com/u/186253875?v=4'
            },
            {
                alt: 'allenbrokeit',
                src: 'https://avatars.githubusercontent.com/u/7524514?s=96&v=4'
            },
            {
                alt: 'Rafael-symbols',
                src: 'https://avatars.githubusercontent.com/u/200677621?s=96&v=4'
            },
            {
                alt: 'imadyaici',
                src: 'https://avatars.githubusercontent.com/u/7004223?s=96&v=4'
            },
            {
                alt: 'Manju134-hub',
                src: 'https://avatars.githubusercontent.com/u/202998880?s=96&v=4'
            },
            {
                alt: 'locngy',
                src: 'https://avatars.githubusercontent.com/u/18193324?s=96&v=4'
            },
            {
                alt: 'Marina-UX-UI',
                src: 'https://avatars.githubusercontent.com/u/198088652?s=96&v=4'
            },
            {
                alt: 'saisanjivani07',
                src: 'https://avatars.githubusercontent.com/u/203023761?s=96&v=4'
            },
            {
                alt: 'lekyatummala11',
                src: 'https://avatars.githubusercontent.com/u/198639204?s=96&v=4'
            },
            {
                alt: 'Lathika9Symbols',
                src: 'https://avatars.githubusercontent.com/u/202271754?s=96&v=4'
            },
            {
                alt: 'sluther',
                src: 'https://avatars.githubusercontent.com/u/38088?s=60&v=4'
            },
            {
                alt: 'zacharybetzen',
                src: 'https://avatars.githubusercontent.com/u/208991695?s=96&v=4'
            },
            {
                alt: 'trevor-ratliff',
                src: 'https://avatars.githubusercontent.com/u/4975372?s=96&v=4'
            },
            {
                alt: 'felgluz',
                src: 'https://avatars.githubusercontent.com/u/6673718?s=60&v=4'
            },
            {
                alt: 'leticia-chijo',
                src: 'https://avatars.githubusercontent.com/u/41638060?v=4'
            },
            {
                alt: 'greg',
                src: ''
            },
            {
                alt: 'elvin',
                src: ''
            },
            {
                alt: 'meGusztav',
                src: 'https://avatars.githubusercontent.com/u/29795175?s=96&v=4'
            },
            {
                alt: 'ju-Skinner',
                src: 'https://avatars.githubusercontent.com/u/1633290?s=96&v=4'
            },
            {
                alt: 'JosephMassie',
                src: 'https://avatars.githubusercontent.com/u/2282073?s=96&v=4'
            },
            {
                alt: 'RuslanLabza',
                src: 'https://avatars.githubusercontent.com/u/64849926?s=96&v=4'
            }
        ]
    }
};

});

parcelRegister("fGgIo", function(module, exports) {

$parcel$export(module.exports, "DocsHgroup", () => $b6a7be7e6d3dd1ea$export$d0bd6a6d5a38dd21);
const $b6a7be7e6d3dd1ea$export$d0bd6a6d5a38dd21 = {
    extends: [
        'Hgroup'
    ],
    flow: 'y',
    gap: 'Z',
    H: {},
    P: {
        maxWidth: '50%'
    }
};

});

parcelRegister("iIPVE", function(module, exports) {

$parcel$export(module.exports, "DesignComponentProperties", () => $da149e11ae8671b1$export$4edbeb6fb8bbc9f9);
const $da149e11ae8671b1$export$4edbeb6fb8bbc9f9 = {
    padding: 'Z2 A',
    flow: 'column',
    gap: 'Z2',
    theme: 'common-box',
    children: (el, s)=>s.properties,
    childrenAs: 'state',
    childExtends: 'Flex',
    childProps: {
        gap: 'B',
        PropertyKey: {
            text: '{{ property }}',
            flex: 1,
            color: 'inactive'
        },
        Value: {
            text: '{{ value }}',
            flex: 1,
            fontWeight: '500'
        }
    }
};

});

parcelRegister("ip1hK", function(module, exports) {

$parcel$export(module.exports, "CopyButton", () => $d65b8f062bbf22dd$export$4f2558dd25106ae2);
const $d65b8f062bbf22dd$export$4f2558dd25106ae2 = {
    extends: 'IconButton',
    icon: 'copy outline',
    background: 'transparent',
    color: 'currentColor',
    isActive: false,
    attr: {
        'aria-label': 'Copy'
    },
    // The 36px square is the icon-button law (IconButton.js); the smaller glyph
    // stays.
    fontSize: 'Z',
    '--spacing-ratio': 1.2,
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        ev.stopPropagation();
        el.update({
            Icon: {
                name: 'checkmark outline'
            }
        });
        const t = setTimeout(()=>{
            el.update({
                Icon: {
                    name: 'copy outline'
                }
            });
            clearTimeout(t);
        }, 1e3);
        el.call('copyStringToClipboard', el.call('exec', el.value || s.value, el, s));
    }
};

});

parcelRegister("ddrsJ", function(module, exports) {

$parcel$export(module.exports, "DesignElement", () => $99f1cab71a107be2$export$364f375b900ae8f8);
const $99f1cab71a107be2$export$364f375b900ae8f8 = {
    extends: [
        'Link'
    ],
    width: '100%',
    flow: 'column',
    href: '/design-system',
    gap: 'Z2',
    padding: 'Z2 A',
    maxWidth: 'F1_default',
    round: 'Z2',
    transition: 'background 250ms',
    ':hover': {
        '@dark': {
            background: 'white.05'
        },
        '@light': {
            background: 'black.05'
        }
    },
    WiderButton: {
        align: 'center center',
        round: 'Z2',
        theme: 'default',
        tabIndex: '-1'
    },
    Hgroup: {
        fontWeight: '400',
        gap: 'X2',
        H: {
            fontSize: 'A',
            color: 'title'
        }
    }
};

});

parcelRegister("4hlmv", function(module, exports) {

$parcel$export(module.exports, "DocsLink", () => $31d951ffba255103$export$e816d7af81d48a79);
const $31d951ffba255103$export$e816d7af81d48a79 = {
    extends: 'Link',
    tag: 'a',
    fontWeight: 500,
    color: 'title',
    whiteSpace: 'nowrap',
    ':hover': {
        textDecoration: 'underline'
    },
    onClick: 'navigateDocs'
};

});

parcelRegister("9F8YW", function(module, exports) {

$parcel$export(module.exports, "DocsSocialLinks", () => $708ee902bd967973$export$524559a3e061ed0f);
const $708ee902bd967973$export$524559a3e061ed0f = {
    extends: 'ArticleSmall',
    maxWidth: 'G2',
    padding: '0 E1 0 0',
    H6: {
        text: 'Discussions'
    },
    P: {
        color: 'paragraph',
        margin: '0 0 A',
        text: 'Join our discussion boards at Github and Discord'
    },
    Flex: {
        tag: 'nav',
        childExtends: 'MenuItem',
        display: 'flex',
        gap: 'Z',
        Discord: {
            target: '_blank',
            href: 'https://discord.com/invite/crdFSkapFY',
            icon: 'discord'
        },
        Github: {
            target: '_blank',
            href: 'https://github.com/symbo-ls/',
            icon: 'github'
        },
        X: {
            target: '_blank',
            href: 'https://twitter.com/symbo_ls',
            icon: 'twitter'
        }
    }
};

});

parcelRegister("9swNb", function(module, exports) {

$parcel$export(module.exports, "DocsDesignElement", () => $6e302a748dd0d85e$export$e03e381bf0ac3ad);
const $6e302a748dd0d85e$export$e03e381bf0ac3ad = {
    flow: 'y',
    gap: 'Y2',
    WiderButton: {
        icon: 'space',
        theme: 'space'
    },
    ExplanatoryParagraph: {
        fontSize: 'Z',
        // `white.6` / `white.85` are FIXED colours (color.js defines `white` as the
        // literal, not an adaptive pair), so this text was white-on-white and
        // completely unreadable on any light surface. `paragraph` and `title` are
        // the adaptive equivalents — gray4/gray1 in light, gray12/gray15 in dark.
        color: 'paragraph',
        maxWidth: 'F1_default',
        lineHeight: 1.4285714285714286,
        margin: '0',
        padding: '0 0 0 V',
        children: [
            'Property of ',
            {
                color: 'title',
                text: 'shape'
            }
        ]
    }
};

});

parcelRegister("38kCS", function(module, exports) {

$parcel$export(module.exports, "DocsSupportLinks", () => $24821e5832dd4df7$export$993b3998c249a588);
const $24821e5832dd4df7$export$993b3998c249a588 = {
    maxWidth: 'G2',
    margin: '- - - auto',
    H6: {
        tag: 'h6',
        text: 'Support'
    },
    P: {
        margin: '0',
        color: 'paragraph',
        childProps: {
            display: 'inline-block',
            margin: '0 X2 0 0'
        },
        children: [
            'Feel free to reach out to us at ',
            {
                DocsLink: {
                    fontWeight: 400,
                    text: 'Discord,',
                    href: 'https://discord.com/invite/crdFSkapFY'
                }
            },
            {
                DocsLink: {
                    fontWeight: 400,
                    text: 'Twitter,',
                    href: 'https://twitter.com/symbo_ls'
                }
            },
            ' or ',
            {
                DocsLink: {
                    fontWeight: 400,
                    text: 'hello@symbo.ls',
                    href: 'mailto:hello@symbo.ls'
                }
            }
        ]
    }
};

});

parcelRegister("jjo6I", function(module, exports) {

$parcel$export(module.exports, "DotCaption", () => $e0f27de29932db10$export$481188a1fb26512f);
const $e0f27de29932db10$export$481188a1fb26512f = {
    tag: 'section',
    align: 'center flex-start',
    Dot: {
        width: 'A1',
        text: "\u2022",
        textDecoration: 'none',
        opacity: '0.35',
        color: 'paragraph'
    },
    Text: {
        ':hover': {
            textDecoration: 'underline'
        }
    }
};

});

parcelRegister("55CkC", function(module, exports) {

$parcel$export(module.exports, "DragNdropUser", () => $3b4b273ce55d6603$export$26843ad08c732b7b);
const $3b4b273ce55d6603$export$26843ad08c732b7b = {
    flow: 'column',
    align: 'center center',
    gap: 'A',
    round: 'A',
    Avatar: {
        boxSize: 'C C',
        src: '{{ src }}'
    },
    Flex: {
        gap: 'Y',
        childProps: {
            padding: '0',
            boxSize: 'B B',
            // `gray4` (#34343a) and `gray7` (#65656f) are FIXED literals, so these
            // action buttons rendered as dark charcoal chips with dim grey glyphs on
            // any light surface — visually detached from the card they sit on, and
            // the glyph/chip contrast only ever worked in dark. `field` is the
            // adaptive control surface; `title` is the adaptive foreground.
            theme: 'field',
            round: 'Y1',
            color: 'title'
        },
        childExtends: 'IconButton',
        childrenAs: 'props',
        children: [
            {
                icon: 'reload'
            },
            {
                icon: 'trash'
            }
        ]
    }
};

});

parcelRegister("ifx2A", function(module, exports) {

$parcel$export(module.exports, "DotCaptionArticle", () => $d49341e756a482b2$export$5d88ac086568f080);
const $d49341e756a482b2$export$5d88ac086568f080 = {
    extends: 'Hgroup',
    gap: 'W1',
    H: {
        extends: [
            'Link',
            'DotCaption'
        ],
        tag: 'strong'
    },
    P: {
        padding: '0 0 0 A1'
    }
};

});

parcelRegister("69Qcy", function(module, exports) {

$parcel$export(module.exports, "DraggableRow", () => $47bc1377b44307a3$export$8f9583e8843556a2);
const $47bc1377b44307a3$export$8f9583e8843556a2 = {
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity',
    // `minWidth` on a letter token is a HARD floor: the component can never
    // shrink below it, so it overflows any container narrower than that —
    // a split pane, a narrow column, a small viewport. The intent is a
    // PREFERRED width, which is `width` + `maxWidth: '100%'`: same size when
    // there is room, shrinks instead of overflowing when there is not.
    width: 'G',
    maxWidth: '100%',
    dragstart: {
        transform: 'scale(0.97)',
        opacity: '0',
        isDragging: true
    },
    onDragstart: (e, el, s)=>{
        e.stopPropagation();
        if (!el.parent.data) el.parent.data = {};
        el.update(el.dragstart);
        el.parent.data.fromIndex = el.key;
        el.parent.data.state = s.parent;
    },
    dragenter: {
        transform: 'scale(0.97)',
        opacity: '0.9'
    },
    onDragenter: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update(el.dragenter);
    },
    onDragover: (e, el, s)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!el.parent.data) return;
        return false;
    },
    dragleave: {
        opacity: '1',
        transform: 'none'
    },
    onDragleave: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update(el.dragenter);
    },
    drop: {
        opacity: '1',
        transform: 'none'
    },
    onDrop: (e, el, s)=>{
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        if (isSame || !isSameGroup) return;
        if (e.stopPropagation) e.stopPropagation();
        const toIndex = el.key;
        s.parent.apply((state)=>el.call('swapItemsInArray', state, el.parent.data.fromIndex, toIndex));
        el.update(el.drop);
    },
    dragend: {
        opacity: '1',
        transform: 'none',
        isDragging: false
    },
    onDragend: (e, el, s)=>{
        el.update(el.dragend);
    },
    ':not(:hover) > footer': {
        pointerEvents: 'none',
        opacity: '0'
    },
    ':hover > footer, &:focus-within > footer': {
        pointerEvents: 'auto',
        opacity: '1'
    },
    draggable: true,
    IteratorFooter: {}
};

});

parcelRegister("inOKh", function(module, exports) {

$parcel$export(module.exports, "DropdownArrow", () => $d621bcf51799bf29$export$3d6d548c35afaaed);
const $d621bcf51799bf29$export$3d6d548c35afaaed = {
    extends: 'Icon',
    fontSize: 'Y1',
    icon: 'arrowAngleDown',
    color: 'disabled'
};

});

parcelRegister("1R7Jw", function(module, exports) {

$parcel$export(module.exports, "DropdownField", () => $15a0bd59ee0f474a$export$9845fd3a57ad4be7);
const $15a0bd59ee0f474a$export$9845fd3a57ad4be7 = {
    // A real <button>: THE global focus ring (brand reset.js, §8.2) applies by
    // selector. It used to extend the framework `FocusableComponent` atom —
    // `outline: 'solid X blue.3'`, a second, different ring (F1, 2026-08-16).
    tag: 'button',
    theme: 'field',
    align: 'center space-between',
    // THE FIELD LAW (admin audit 2026-09-24): a field is a `controlH` control
    // with the control radius. It measured 46px tall (the vertical padding
    // stacked on the arrow button) with a 14.52px em radius (`Z2`); the floor
    // sets the height now and the padding is horizontal only.
    minHeight: 'controlH',
    padding: '0 Y 0 A',
    // `minWidth` on a letter token is a HARD floor: the component can never
    // shrink below it, so it overflows any container narrower than that —
    // a split pane, a narrow column, a small viewport. The intent is a
    // PREFERRED width, which is `width` + `maxWidth: '100%'`: same size when
    // there is room, shrinks instead of overflowing when there is not.
    width: 'F1',
    maxWidth: '100%',
    round: 'radiusControl',
    gap: 'Y',
    // Was tabindex:'-1' — that took the dropdown trigger out of the tab order, so
    // keyboard users could not open it. It's a real <button>, so it is natively
    // focusable. It claims NO popup: most standalone uses (a colour or theme
    // field, a native-select wrapper) open no listbox, and aria-haspopup
    // "listbox" on them announced one that never came (2026-09-24). A control
    // that owns a listbox declares it itself — SelectDropdown's Trigger does.
    StartButtons: {
        flow: 'x',
        gap: 'X1',
        align: 'center',
        // DECORATIVE: the whole field is the <button>. An icon button nested in
        // it is invalid HTML and read as an unnamed control (admin audit,
        // 2026-09-24: "button 33px, no name"), so the icons are hidden spans,
        // on the control radius (was the em letter `Y1`, 8px).
        'aria-hidden': 'true',
        childExtends: 'IconButton',
        childProps: {
            tag: 'span',
            theme: 'field-highlight',
            round: 'radiusControl',
            padding: 'Y1'
        }
    },
    Value: {
        flow: 'x',
        align: 'center flex-start',
        padding: '0 B 0 0',
        gap: 'Y2',
        // The root's `align: 'center space-between'` distributes ALL free space
        // between `StartButtons` / `Value` / `Buttons` — including the share
        // that would sit right after `StartButtons` even when it has no leading
        // icon (the common case: this sample has none). With `Value` staying at
        // its own natural content width, `space-between` still allocates it that
        // full share of empty space, so "default" rendered floating ~48px in
        // from the left edge instead of hugging it (measured: field content
        // starts at x=1034.8, but the value text started at x=1083.3). `flex: 1`
        // lets Value consume exactly that leftover space itself, so its OWN
        // `justifyContent: flex-start` puts the text where it reads correctly —
        // immediately after any leading icon, not adrift in the middle.
        flex: '1',
        Text: {
            text: (el, s)=>s.value || s.defaultValue || 'default'
        },
        Suffix: null
    },
    Buttons: {
        flow: 'x',
        gap: 'X1',
        align: 'center',
        // DECORATIVE: the whole field is the <button>. An icon button nested in
        // it is invalid HTML and read as an unnamed control (admin audit,
        // 2026-09-24: "button 33px, no name"), so the icons are hidden spans,
        // on the control radius (was the em letter `Y1`, 8px).
        'aria-hidden': 'true',
        childExtends: 'IconButton',
        childProps: {
            tag: 'span',
            theme: 'field-highlight',
            round: 'radiusControl',
            padding: 'Y1'
        },
        Arrow: {
            icon: 'arrow angle mirroring vertical'
        }
    },
    Dropdown: {
        top: '110%',
        left: '0'
    }
};

});

parcelRegister("uL3Da", function(module, exports) {

$parcel$export(module.exports, "DropdownHeader", () => $05c74e1b8e0d0d64$export$19b44e77c853705e);
const $05c74e1b8e0d0d64$export$19b44e77c853705e = {
    position: 'sticky',
    top: '0',
    align: 'center flex-start',
    fontSize: 'Z',
    padding: 'Z1 A1',
    zIndex: '1',
    theme: 'field-static',
    backdropFilter: 'blur(3px)',
    text: 'Dropdown title'
};

});

parcelRegister("eeSat", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $a5dc6419b271e6f0$export$931cbfb6bfb85fc);
const $a5dc6419b271e6f0$export$931cbfb6bfb85fc = {
    tag: 'section',
    attr: {
        dropdown: true
    },
    isDropdownRoot: true,
    preventAbsolute: false,
    theme: 'common-box',
    // A popover (white-label spec §4.10, §6.1): the card radius, the `float`
    // elevation (its ring is the edge), and the overlay entrance curve.
    round: 'radiusCard',
    shadow: 'float',
    minWidth: 'F',
    // The CAP and THE ROOM (THE FIT, below): the smaller of the `H` cap and the
    // room measured at open, which lands as the inline `--dropdown-room`. Before
    // the first measurement the viewport is the room. A call site that declares
    // its own max-height replaces this and takes the fit out; to keep the fit
    // under another cap, write `min(G, var(--dropdown-room, 100dvh))`.
    maxHeight: 'min(H, var(--dropdown-room, 100dvh))',
    transition: 'B springBezier',
    transitionProperty: 'visibility, transform, opacity',
    // The panel scrolls INSIDE itself (overflow law §3b.2) and keeps the
    // overscroll: a flick at the end never scrolls the page. The x axis clips
    // only decoration — the half-percent hover scale of a row — while a word
    // too long for the panel breaks (`break-word` leaves the panel's own
    // intrinsic width exactly as it was) instead of being cut at the edge.
    overflow: 'hidden auto',
    overscrollBehavior: 'contain',
    overflowWrap: 'break-word',
    boxSizing: 'border-box',
    zIndex: 1000,
    // Borderless by default — separation comes from the theme background +
    // the `float` elevation above. Every `extends: 'Dropdown'` menu inherits
    // this so dropdowns read as clean floating panels across the suite.
    border: 'none',
    left: '50%',
    transform: 'translate3d(0, calc(-1 * var(--spacing-Z)), 0)',
    position: 'absolute',
    opacity: '0',
    visibility: 'hidden',
    forcedVisible: false,
    '.preventAbsolute': {
        position: 'static'
    },
    '.forcedVisible': {
        opacity: '1',
        visibility: 'visible'
    },
    // THE FIT (overflow law §3b.2, Nika 2026-09-26: "you should also fix
    // modals, dropdowns, widgets cutting ui and buttons and texts in
    // overflow"). Measured when the trigger (the parent) is ENTERED — by the
    // pointer or by keyboard focus. The dropdown is hidden, so it never
    // receives either itself; DOMQL-owned document listeners see the enter
    // instead: an event inside the trigger whose `relatedTarget` came from
    // outside it (FA503 — no raw addEventListener).
    //   * Direction: down unless the panel does not fit below and there is
    //     more room above — then up, `yOffset` (115%) above the trigger. Down is
    //     where the call site placed it (its own `top` / `bottom`, read once),
    //     else `yOffset` below the trigger.
    //   * Room: the space between the trigger and the viewport edge on that
    //     side, minus one `overlayGutter`, floored to 8px steps; the panel
    //     scrolls inside the smaller of the cap and the room. A long list is
    //     never cut by the viewport.
    // It paints through the element's own props — `el.update`, which repaints a
    // static CSS prop since smbls 3.14.811 (0549985fb; it re-emitted nothing
    // before, which is why this fit spent a release on the inline escape hatch).
    // Every distinct room is one atomic rule, so the 8px steps bound the rules
    // at innerHeight / 8.
    // An inline dropdown opens IN PLACE: inside a clipped ancestor (a card or a
    // row with hidden overflow) it is cut whatever its height. Such a surface
    // opens its menu in the top-layer root instead — `el.call('openDropdown',
    // …)` into the shell's DropdownRoot (@symbo.ls/dropdown), never an inline
    // Dropdown.
    scope: {
        fit: (e, el)=>{
            if (el.preventAbsolute) return;
            const dropdown = el.node;
            const trigger = el.parent && el.parent.node;
            if (!dropdown || !trigger) return;
            if (!trigger.contains(e.target) || trigger.contains(e.relatedTarget)) return;
            const view = dropdown.ownerDocument.defaultView;
            const sizes = el.context && el.context.designSystem && el.context.designSystem.sizes || {};
            const gutter = parseFloat(sizes.overlayGutter) || 0;
            const yOffset = el.yOffset || '115%';
            const t = trigger.getBoundingClientRect();
            // `115%` of the trigger from its far edge leaves a 15% gap before the panel.
            const gap = /%$/.test(yOffset) ? t.height * (parseFloat(yOffset) / 100 - 1) : 0;
            const need = Math.max(dropdown.getBoundingClientRect().height, dropdown.scrollHeight);
            const below = view.innerHeight - t.bottom - gap - gutter;
            const above = t.top - gap - gutter;
            const up = need > below && above > below;
            const step = 8;
            const room = Math.max(0, Math.floor((up ? above : below) / step) * step);
            // The call site's own placement, read before the first fit writes over
            // it — DropdownField's 110%, a settings row's 121%, a zoom menu that
            // opens up by design.
            if (!el.scope.home) el.scope.home = {
                top: el.top,
                bottom: el.bottom
            };
            const home = el.scope.home;
            el.update({
                top: up ? 'auto' : home.top || yOffset,
                bottom: up ? yOffset : home.bottom || null,
                '--dropdown-room': room + 'px'
            });
        }
    },
    onDocumentMouseover: (e, el)=>el.scope && el.scope.fit && el.scope.fit(e, el),
    onDocumentFocusin: (e, el)=>el.scope && el.scope.fit && el.scope.fit(e, el)
};

});

parcelRegister("bDJkE", function(module, exports) {

$parcel$export(module.exports, "DropdownItem", () => $8796803f57a88b8f$export$6648d5fa18559e7f);
const $8796803f57a88b8f$export$6648d5fa18559e7f = {
    boxShadow: 'none',
    round: '0',
    // THE HOUSE STATE MODEL (DESIGN_LANGUAGE §8.1; admin audit 2026-09-24, the
    // language list on /admin/workspace-settings): every state is a token fill
    // step, never an opacity and never a raw colour.
    //   rest    transparent, the `caption` ink at full strength (the row used
    //           to rest at opacity .75, and a gray15 plate in light)
    //   hover   the `hover` wash + `title` ink (was a hand-spelled
    //           rgba(0,0,0,.05) / rgba(255,255,255,.07) pair, held until the
    //           served runtime carried the getColor fix smbls be058fb72 — the
    //           brand.symbols.app bundle (3.14.784/786) carries it, and the
    //           workspace shell builds from a newer smbls; read 2026-09-24)
    //   chosen  the `selected` wash + `title`, weight 500 (was a raw
    //           rgba(85,85,93,.15) in dark and white in light). A list keeps
    //           the selection wash; the inversion is for choice controls (D-1).
    background: 'transparent',
    color: 'caption',
    transition: 'A',
    // NO `visibility` here: a row INHERITS the panel's visibility, and a
    // visibility transition held each row hidden for the start of the fade —
    // a row that must take focus the moment the panel opens (the select's
    // listbox) refused it, and in a background tab the fade never advanced
    // (measured on the brand site, 2026-09-24: panel visible, every option
    // still computed `visibility: hidden`). The panel owns the fade.
    transitionProperty: 'color, background',
    onClick: async (ev, el, s, ctx2)=>await el.call('dropdownClick', ev, el, s, ctx2),
    ':hover': {
        background: 'hover',
        color: 'title',
        '& svg': {
            opacity: 0.15
        }
    },
    '.isActive': {
        fontWeight: '500',
        background: 'selected',
        color: 'title',
        '& svg': {
            opacity: 0.5
        },
        ':hover': {
            background: 'selected',
            '& svg': {
                opacity: 0.65
            }
        }
    }
};

});

parcelRegister("iVSfk", function(module, exports) {

$parcel$export(module.exports, "ExplanatoryParagraph", () => $dc87a1091a0dc1f9$export$86867ef7df4224fc);
const $dc87a1091a0dc1f9$export$86867ef7df4224fc = {
    tag: 'p',
    color: 'paragraph',
    margin: 'A 0',
    gap: 'X',
    childProps: {
        tag: 'span'
    }
};

});

parcelRegister("4FoC9", function(module, exports) {

$parcel$export(module.exports, "DropdownCopy", () => $365e15ac88fc35d4$export$76d20b6109009999);
const $365e15ac88fc35d4$export$76d20b6109009999 = {};

});

parcelRegister("eukqU", function(module, exports) {

$parcel$export(module.exports, "FooteLite", () => $a8c3b7970547bea7$export$92c3986a12472dc5);
const $a8c3b7970547bea7$export$92c3986a12472dc5 = {
    tag: 'footer',
    align: 'center space-between',
    padding: 'B 0 0',
    width: '100%',
    margin: '- auto',
    gap: 'B',
    '@tabletL': {
        flow: 'column',
        gap: 'C1'
    },
    childProps: {
        '@tabletL': {
            width: '100%',
            padding: '0'
        }
    },
    Copy: {
        display: 'flex',
        gap: 'X2',
        lineHeight: '1',
        // Was a hand-rolled '@dark'/'@light' gray pair (gray8/gray5) matching no
        // existing token. The ink language is inherited color + opacity
        // (design-direction.md §7/geex layer): `title.55` sits at the secondary
        // floor and adapts correctly in both schemes from one declaration.
        color: 'title.55',
        DocsLink: {
            target: '_blank',
            href: 'https://symbols.app',
            text: 'Symbols'
        },
        Year: {
            text: " \xa9 2026"
        },
        DocsLink_version: {
            text: (el, s, ctx2)=>!ctx2.version ? '' : `TODO: smbls@^${ctx2.version}`,
            href: 'https://www.npmjs.com/smbls',
            target: '_blank',
            margin: '- - - A2',
            // Was gray9/gray6 (dimmer hand-rolled pair). `.45` is the "true meta"
            // floor — this is a nested TODO/version string, one step past the
            // parent copyright line.
            color: 'title.45'
        }
    },
    DocsSocialLinks: {
        textAlign: 'end',
        H6: null,
        P: null,
        onRender: ()=>{}
    }
};

});

parcelRegister("3GegM", function(module, exports) {

$parcel$export(module.exports, "Draggable", () => $2ae05d036d2064cd$export$f2a139e5d18b9882);
const $2ae05d036d2064cd$export$f2a139e5d18b9882 = {
    position: 'relative',
    transition: 'A defaultBezier',
    transitionProperty: 'transform, opacity',
    // `minWidth` on a letter token is a HARD floor: the component can never
    // shrink below it, so it overflows any container narrower than that —
    // a split pane, a narrow column, a small viewport. The intent is a
    // PREFERRED width, which is `width` + `maxWidth: '100%'`: same size when
    // there is room, shrinks instead of overflowing when there is not.
    width: 'G',
    maxWidth: '100%',
    // The footer (IteratorFooter) reveals by opacity and a short rise, never by
    // height (overflow law §3b.6-7): a height reveal is a clip, and at the old
    // `B2` it cut the 36px icon squares of the icon-button law. The footer
    // keeps its own height; only what it shows changes.
    ':not(:hover) > footer': {
        pointerEvents: 'none',
        opacity: '0',
        transform: 'translate3d(0, var(--spacing-X), 0)'
    },
    ':hover': {
        zIndex: 3
    },
    ':hover > footer, &:focus-within > footer': {
        pointerEvents: 'auto',
        opacity: '1',
        transform: 'none'
    },
    onDragstart: (e, el, s)=>{
        e.stopPropagation();
        if (!el.parent.data) el.parent.data = {};
        el.update({
            transform: 'scale(0.97)',
            opacity: '0',
            isDragging: true
        });
        el.parent.data.fromIndex = el.key;
        el.parent.data.state = s.parent;
    },
    onDragover: (e, el, s)=>{
        e.stopPropagation();
        e.preventDefault();
        if (!el.parent.data) return;
        return false;
    },
    onDragenter: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update({
            transform: `scale(0.97)`,
            opacity: '0.9'
        });
    },
    onDragleave: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        const isRootNode = e.target === el.node;
        if (isSame || !isSameGroup || isRootNode) return;
        el.parent.data.active = el.key;
        el.update({
            opacity: '1',
            transform: 'none'
        });
    },
    onDrop: (e, el, s)=>{
        if (!el.parent.data) return;
        const isSame = el.parent.data.fromIndex === el.key;
        const isSameGroup = el.parent.data.state === s.parent;
        if (isSame || !isSameGroup) return;
        if (e.stopPropagation) e.stopPropagation();
        const toIndex = el.key;
        s.parent.apply((state)=>el.call('swapItemsInArray', state, el.parent.data.fromIndex, toIndex));
        el.update({
            opacity: '1',
            transform: 'none'
        });
    },
    onDragend: (e, el, s)=>{
        el.update({
            opacity: '1',
            transform: 'none',
            isDragging: false
        });
    },
    draggable: true,
    IteratorFooter: {}
};

});

parcelRegister("86fC6", function(module, exports) {

$parcel$export(module.exports, "Group", () => $5e5afecb8706cd84$export$eb2fcfdbd7ba97d4);
const $5e5afecb8706cd84$export$eb2fcfdbd7ba97d4 = {
    flow: 'y',
    align: 'flex-start',
    gap: 'Y1',
    minWidth: 'F',
    childProps: {
        width: '100%'
    },
    Title: {
        text: 'Field Title',
        color: 'caption',
        userSelect: 'none',
        whiteSpace: 'nowrap'
    }
};

});

parcelRegister("ecrsp", function(module, exports) {

$parcel$export(module.exports, "GridInDropdown", () => $a5677c1e02c43bcc$export$5b6caed92d26031);
const $a5677c1e02c43bcc$export$5b6caed92d26031 = {
    extends: 'Grid',
    tag: 'nav',
    // Was `gridTemplateRows: 'repeat(1fr, 6)'` — the arguments are inverted.
    // CSS `repeat()` is `repeat(<count>, <track-size>)`, so `repeat(1fr, 6)` is
    // invalid and the whole declaration was dropped; with no column track
    // defined either, every item fell into a single implicit column and the
    // "grid" rendered as a vertical stack. Declaring the COLUMN track is what
    // this component actually wants — a compact row-major grid of icon actions
    // that wraps onto as many rows as the option count needs.
    columns: 'repeat(3, 1fr)',
    padding: 'X2',
    gap: 'Z2',
    children: (el)=>el.call('exec', el.parent.options, el.parent),
    childrenAs: 'state',
    content: {
        ignoreChildProps: true,
        ignoreChildExtends: true
    },
    childExtends: [
        'GridItem'
    ]
};

});

parcelRegister("hI2UC", function(module, exports) {

$parcel$export(module.exports, "GridItem", () => $ce48ce028b23abab$export$9eb849b9b922d396);
// An icon-only tile of a dropdown grid (GridInDropdown): the icon-button law
// (IconButton.js — Nika 2026-09-26, "all icon buttons should have 1/1 aspect
// ratio") makes it a `controlHCompact` square with the glyph centred. It was
// a framework SquareButton padded `Z2` round a 1em glyph: a 46px square off
// the control scale.
const $ce48ce028b23abab$export$9eb849b9b922d396 = {
    extends: [
        'DropdownItem',
        'IconButton'
    ],
    Icon: {
        name: (el, s)=>s.key || el.key
    },
    text: null
};

});

parcelRegister("9pdLI", function(module, exports) {

$parcel$export(module.exports, "H1", () => $6d9121005aa68a20$export$5523b16adee8048);
const $6d9121005aa68a20$export$5523b16adee8048 = {
    extends: 'smbls.H1',
    color: 'title'
};

});

parcelRegister("9WpDd", function(module, exports) {

$parcel$export(module.exports, "GetEarlyAccess", () => $73cd69bda8c89778$export$776c5f5eb4ae3a34);
const $73cd69bda8c89778$export$776c5f5eb4ae3a34 = {
    flow: 'y',
    align: 'start start',
    gap: 'B2',
    padding: '0 A2 0 C2',
    width: 'G2',
    // Was a 1px left border separating this CTA column from its sibling
    // column (divider-line habit banned by design-direction.md §8). A tonal
    // wash reads as "a distinct panel" the same way without a stroke; the
    // existing left padding (`C2`) already gives the fill room to breathe.
    background: 'overlay',
    margin: '0',
    Hgroup: {
        H: {
            tag: 'strong',
            text: 'Get early access'
        },
        P: {
            text: `We're kicking off invite-only. Get early signup to make it to the top.`
        }
    },
    Link: {
        extends: [
            'Link',
            'Button'
        ],
        margin: '0 0 0 -X',
        theme: 'quaternary',
        fontWeight: '500',
        text: 'Join up',
        href: '/signup'
    }
};

});

parcelRegister("fhFCe", function(module, exports) {

$parcel$export(module.exports, "H4", () => $b208b98a50f64375$export$cc5e069d64fda823);
const $b208b98a50f64375$export$cc5e069d64fda823 = {
    extends: 'smbls.H4',
    color: 'title'
};

});

parcelRegister("93qW0", function(module, exports) {

$parcel$export(module.exports, "H5", () => $6979497f81d1da3d$export$88ef9fdaf11f7a1f);
const $6979497f81d1da3d$export$88ef9fdaf11f7a1f = {
    extends: 'smbls.H5',
    color: 'title'
};

});

parcelRegister("i2oU0", function(module, exports) {

$parcel$export(module.exports, "GroupField", () => $d21bbaf4acb5a932$export$8e163d09e82461a2);
const $d21bbaf4acb5a932$export$8e163d09e82461a2 = {
    extends: 'Group',
    tag: 'label'
};

});

parcelRegister("ghile", function(module, exports) {

$parcel$export(module.exports, "H2", () => $bd9c761a516b42c0$export$cb94397127ac9363);
const $bd9c761a516b42c0$export$cb94397127ac9363 = {
    extends: 'smbls.H2',
    color: 'title'
};

});

parcelRegister("g4jj6", function(module, exports) {

$parcel$export(module.exports, "H3", () => $bb2bff0c6f720c4d$export$746be9e3a3dfff1f);
const $bb2bff0c6f720c4d$export$746be9e3a3dfff1f = {
    extends: 'smbls.H3',
    color: 'title'
};

});

parcelRegister("gnBLH", function(module, exports) {

$parcel$export(module.exports, "FooterFull", () => $becc1759c31ed762$export$1f8e959b4ef8ee11);
const $becc1759c31ed762$export$1f8e959b4ef8ee11 = {
    flow: 'y',
    align: 'flex-start flex-start',
    width: '100%',
    padding: '- B2',
    gap: 'C',
    // Was a 1px top border separating the footer from page content above it
    // (divider-line habit banned by design-direction.md §8). The footer's own
    // content (link columns) already reads as a distinct zone; whitespace
    // (this block's own vertical padding) is separation enough without adding
    // a stroke or a new fill layer to a component this widely reused.
    '@mobileL': {
        padding: '- A'
    },
    childProps: {
        minWidth: '100%',
        maxWidth: '100%'
    },
    Flex: {
        align: 'flex-start flex-start',
        padding: 'B1 A - Y',
        '@tabletS': {
            flow: 'y',
            gap: 'B2'
        },
        LinkSet: {
            flow: 'y',
            gap: 'C',
            align: 'flex-start flex-start',
            flex: '1',
            '@tabletS': {
                flow: 'x',
                align: 'center space-between',
                minWidth: '100%',
                maxWidth: '100%'
            },
            '@mobileL': {
                gap: 'B',
                wrap: 'wrap'
            },
            '@mobileM': {
                align: 'center flex-start'
            },
            childExtends: [
                'DocsLink',
                'IconText'
            ],
            childProps: {
                gap: 'X2',
                color: 'title',
                Icon: {
                    name: 'arrowUpRight'
                }
            },
            children: [
                {
                    text: 'Get started',
                    href: '/signup'
                },
                {
                    text: 'Go to dashboard',
                    href: '/signin'
                },
                {
                    text: 'Schedule a demo',
                    href: 'https://cal.com/symbols-josh/early-access',
                    target: '_blank'
                }
            ]
        },
        Product: {
            flow: 'y',
            align: 'flex-start flex-start',
            gap: 'A1',
            flex: '1',
            '@tabletS': {
                gap: 'Z',
                padding: 'A1 - - -'
            },
            Caption: {
                text: 'Product',
                fontWeight: '700',
                lineHeight: '1em',
                color: 'title'
            },
            Flex: {
                flow: 'y',
                align: 'flex-start flex-start',
                gap: 'A1',
                '@tabletS': {
                    flow: 'x',
                    wrap: 'wrap'
                },
                childProps: {
                    cursor: 'pointer',
                    fontWeight: '300',
                    color: 'caption'
                },
                childExtends: 'DocsLink',
                children: [
                    {
                        text: 'Explore (TBA)',
                        href: '/explore'
                    },
                    {
                        text: 'Library (TBA)',
                        href: '/library'
                    },
                    {
                        text: 'Experts (TBA)',
                        href: '/experts'
                    },
                    {
                        text: 'Pricing',
                        href: '/pricing'
                    }
                ]
            }
        },
        Developers: {
            flex: '1',
            flow: 'y',
            align: 'flex-start flex-start',
            gap: 'A1',
            '@tabletS': {
                gap: 'Z',
                padding: '- - A1 -'
            },
            Caption: {
                text: 'Developers',
                fontWeight: '700',
                lineHeight: '1em',
                color: 'title'
            },
            Flex: {
                flow: 'y',
                align: 'flex-start flex-start',
                gap: 'A1',
                '@tabletS': {
                    flow: 'x',
                    wrap: 'wrap'
                },
                '@mobileM': {
                    gap: '0'
                },
                childProps: {
                    cursor: 'pointer',
                    fontWeight: '300',
                    color: 'caption',
                    '@mobileM': {
                        padding: '- A1 X2 -'
                    }
                },
                childExtends: 'DocsLink',
                children: [
                    {
                        text: 'Onboarding',
                        href: '/docs/intro'
                    },
                    {
                        text: 'Building in Symbols',
                        href: '/docs/building-in-symbols'
                    },
                    {
                        text: 'Framework',
                        href: '/docs/framework'
                    },
                    {
                        text: 'SDK',
                        href: '/docs/sdk'
                    },
                    {
                        text: 'CLI',
                        href: '/docs/cli'
                    }
                ]
            }
        },
        Resources: {
            flow: 'y',
            align: 'flex-start flex-start',
            gap: 'A1',
            flex: '1',
            '@tabletS': {
                gap: 'Z',
                padding: 'A1 - - -'
            },
            Caption: {
                text: 'Resources',
                fontWeight: '700',
                lineHeight: '1em',
                color: 'title'
            },
            Flex: {
                flow: 'y',
                align: 'flex-start flex-start',
                gap: 'A1',
                '@tabletS': {
                    flow: 'x',
                    wrap: 'wrap'
                },
                childProps: {
                    cursor: 'pointer',
                    fontWeight: '300',
                    color: 'caption'
                },
                childExtends: 'DocsLink',
                children: [
                    {
                        text: 'Investors',
                        target: '_blank',
                        href: 'https://invest.symbo.ls'
                    },
                    {
                        text: 'Blog',
                        target: '_blank',
                        href: 'https://medium.com/symbolsapp'
                    },
                    {
                        text: 'Contact',
                        target: '_blank',
                        href: 'https://cal.com/symbols-josh/early-access'
                    }
                ]
            }
        },
        Companies: {
            flow: 'x',
            flex: '1',
            align: 'center flex-end',
            gap: 'A',
            '@mobileS': {
                minWidth: '100%',
                maxWidth: '100%',
                align: 'center space-between'
            },
            childProps: {
                target: '_blank'
            },
            childExtends: [
                'Link',
                'IconButton'
            ],
            children: [
                {
                    icon: 'twitter',
                    href: 'https://x.com/symbo_ls'
                },
                {
                    icon: 'medium',
                    href: 'https://medium.com/symbolsapp'
                },
                {
                    icon: 'github',
                    href: 'https://github.com/symbo-ls/'
                },
                {
                    icon: 'discord',
                    href: 'https://discord.com/invite/crdFSkapFY'
                },
                {
                    icon: 'npm',
                    href: 'https://www.npmjs.com/package/smbls'
                }
            ]
        }
    },
    Flex_2: {
        align: 'center flex-start',
        padding: '- Y',
        '@mobileM': {
            display: 'grid',
            columns: 'repeat(2, 1fr)',
            rowGap: 'A'
        },
        childProps: {
            fontWeight: '300',
            color: 'caption'
        },
        DocsLink: {
            text: 'Terms and conditions',
            margin: '- D - -',
            cursor: 'pointer',
            href: '/terms',
            '@mobileM': {
                margin: '- 0 - -',
                whiteSpace: 'nowrap'
            }
        },
        DocsLink_2: {
            text: 'Privacy terms',
            cursor: 'pointer',
            href: '/privacy',
            '@mobileM': {
                whiteSpace: 'nowrap',
                textAlign: 'right'
            }
        },
        P: {
            text: "Symbols \xa9 2020-2026",
            margin: '- - - auto',
            '@mobileM': {
                gridColumn: 'span 2',
                textAlign: 'left',
                margin: '- - - 0'
            }
        }
    }
};

});

parcelRegister("jIO5z", function(module, exports) {

$parcel$export(module.exports, "HeaderBreadcrumb", () => $e5b8fafbbbdc45fe$export$f836de4f99592497);
const $e5b8fafbbbdc45fe$export$f836de4f99592497 = {
    padding: '0',
    fontSize: 'Z2',
    Button_page: {
        extends: [
            'Button',
            'DropdownParentFocus'
        ],
        theme: 'tertiary',
        gap: 'Z',
        flow: 'row-reverse',
        padding: 'Y2 Z2',
        icon: 'arrow angle down',
        color: 'title',
        fontWeight: '400',
        text: (el)=>{
            const path = window.location.pathname.split("/")[1];
            if ([
                "dashboard",
                "governance",
                "tutorials"
            ].includes(path)) return el.call("capitalize", path);
            else if ([
                "docs",
                "developers",
                "api",
                "index",
                "framework"
            ].includes(path)) return "Documentation";
            else return "Canvas";
        },
        Icon: {
            minWidth: 'A'
        },
        Dropdown: {
            ListInDropdown: {
                children: (el)=>[
                        {
                            if: (el2, s)=>el2.isAuthorised(),
                            text: "Dashboard",
                            href: "/dashboard"
                        },
                        {
                            if: (el2, s)=>el2.isAuthorised(),
                            text: "Canvas",
                            href: el.getCanvasPathnameAnyway()
                        },
                        {
                            hide: (el2)=>!el2.getRootState("email")?.endsWith("@symbols.app"),
                            text: "Governance",
                            href: "/governance"
                        },
                        {
                            text: "Documentation",
                            href: "/developers"
                        },
                        {
                            hide: true,
                            text: "Tutorials",
                            href: "/tutorials"
                        },
                        {
                            text: "Examples",
                            href: "/docs/examples"
                        },
                        {
                            text: "Resources",
                            href: "/docs/resources"
                        }
                    ],
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'C1',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Text: null,
                    Caption: null,
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                childExtends: [
                    'Link',
                    'Button'
                ]
            },
            childrenAs: 'state',
            left: '0',
            align: 'start'
        }
    },
    Button_username: {
        extends: [
            'Button',
            'Link'
        ],
        hide: true,
        theme: 'transparent',
        ':hover': {
            theme: 'tertiary'
        },
        gap: 'X2',
        href: (el)=>"/" + el.getRootState("username"),
        flow: 'row-reverse',
        padding: 'Y2 Z2',
        text: (el)=>el.getRootState("username")
    },
    Button_project: {
        if: (el, s)=>el.isAuthorised(),
        extends: [
            'Button',
            'DropdownParentFocus'
        ],
        hide: (el)=>!el.getRootState("appKey") || !el.getRootState("appKey").split(".").length,
        theme: 'tertiary',
        gap: 'Z',
        flow: 'row-reverse',
        padding: 'Y2 Z2',
        icon: 'arrow angle down',
        href: (el, s)=>el.getCanvasPathname(),
        color: 'title',
        fontWeight: '500',
        maxWidth: 'F3',
        Text: {
            color: 'title',
            text: (el)=>{
                var _a;
                return (_a = el.getRootState("appKey")) == null ? void 0 : _a.split(".")[0];
            },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 'bold',
            lineHeight: '1.15',
            padding: '- - - X',
            maxWidth: '100%'
        },
        Icon: {
            minWidth: 'A'
        },
        Dropdown: {
            childrenAs: 'state',
            left: '0',
            align: 'start',
            onChoose: async (ev, el, s, ctx2, callee)=>{
                if (callee.href && !callee.isCanvas) await el.call("openModal", "/settings", {
                    key: callee.href
                });
            },
            ListInDropdown: {
                childProps: {
                    textAlign: 'start',
                    padding: 'Z1 A',
                    color: 'inactive',
                    round: 'C1',
                    theme: null,
                    fontWeight: '400',
                    align: 'center start',
                    Text: null,
                    Caption: null,
                    Icon: {
                        order: 2,
                        margin: '- - - auto'
                    },
                    ':hover': {
                        theme: 'field'
                    },
                    '.isActive': {
                        theme: 'field'
                    }
                },
                childrenAs: 'props',
                children: (el)=>[
                        {
                            extends: [
                                "Link",
                                "Button"
                            ],
                            text: "Go to Canvas",
                            hide: (el2)=>el2.isCanvas(),
                            href: el.getCanvasPathnameAnyway(),
                            isCanvas: true
                        },
                        {
                            text: "Open as URL",
                            onClick: "openInNewTab"
                        },
                        {
                            if: (el2)=>el2.isAdmin(),
                            text: "Project account",
                            href: "/project-account"
                        },
                        {
                            if: (el2)=>el2.isAdmin(),
                            text: "Invite member",
                            href: "/invite"
                        },
                        {
                            if: (el2)=>el2.isEditMode(),
                            text: "Project data",
                            href: "/project-data"
                        },
                        {
                            if: (el2)=>el2.isAdmin(),
                            text: "Connect",
                            href: "/connect"
                        },
                        {
                            text: "Install",
                            href: "/install"
                        },
                        {
                            if: (el2)=>el2.isEditMode(),
                            text: "Shared libraries",
                            href: "/shared-libs"
                        },
                        {
                            if: (el2)=>el2.isOwner(),
                            text: "Pricing",
                            href: "/pricing"
                        },
                        {
                            text: "Settings",
                            href: "/settings"
                        }
                    ]
            }
        }
    }
};

});

parcelRegister("3mkCv", function(module, exports) {

$parcel$export(module.exports, "H6", () => $27236be627618f20$export$a559fb8039b06400);
const $27236be627618f20$export$a559fb8039b06400 = {
    extends: 'smbls.H6',
    color: 'title'
};

});

parcelRegister("fR6PU", function(module, exports) {

$parcel$export(module.exports, "HeaderHeading", () => $b8b11bc564bda5cf$export$206822ae6602dbd6);
const $b8b11bc564bda5cf$export$206822ae6602dbd6 = {
    tag: 'header',
    margin: '- - C2 -',
    Caption: {
        text: `Let's get started`,
        whiteSpace: 'nowrap',
        margin: '0',
        color: 'caption'
    },
    H1: {
        color: 'title',
        text: 'Create a Project',
        fontSize: 'H2',
        fontWeight: '700',
        margin: '0',
        height: 'fit-content'
    }
};

});

parcelRegister("5ef8p", function(module, exports) {

$parcel$export(module.exports, "HelloUser", () => $3ce9fff94e6b6c65$export$ef68763f7b656582);
const $3ce9fff94e6b6c65$export$ef68763f7b656582 = {
    margin: '- auto - -',
    color: 'title',
    text: (el)=>`Welcome ${el.getRootProjects().length > 0 ? " back, " : "to Symbols, "}${el.getRootState("username")} \u{1F44B} `
};

});

parcelRegister("dHfSx", function(module, exports) {

$parcel$export(module.exports, "IconLinkWithPath", () => $9f8b9bb14755b4e8$export$45e3a50a8db50109);
const $9f8b9bb14755b4e8$export$45e3a50a8db50109 = {
    extends: 'Article',
    gap: 'W',
    padding: '0 0 0 A1',
    IconCaption: {
        extends: [
            'IconCaption',
            'DocsLink'
        ],
        href: '{{ href }}',
        margin: '0 0 0 -A1',
        target: '_blank',
        gap: 'X1',
        Icon: {
            icon: 'github'
        },
        Text: {
            text: '{{ title }}',
            color: 'title'
        }
    },
    P: {
        color: 'paragraph',
        margin: '0',
        text: '{{ description }}'
    },
    DocsLink: {
        text: '{{ href }}',
        href: '{{ href }}',
        target: '_blank',
        color: 'grassgreen.85',
        fontWeight: '400'
    }
};

});

parcelRegister("lBkIH", function(module, exports) {

$parcel$export(module.exports, "IconCaption", () => $fb9d203693090822$export$ccdbc3d0432988b9);
const $fb9d203693090822$export$ccdbc3d0432988b9 = {
    align: 'center flex-start',
    gap: 'Y',
    color: 'caption',
    Icon: {
        icon: 'github',
        color: 'paragraph'
    },
    Text: {}
};

});

parcelRegister("j8vyW", function(module, exports) {

$parcel$export(module.exports, "Headline", () => $dee73f58245029fb$export$e1faab0803786bcf);
const $dee73f58245029fb$export$e1faab0803786bcf = {
    extends: 'smbls.Headline',
    color: 'subtitle'
};

});

parcelRegister("7q4C7", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $566e8a516f33aa2e$export$dd2171e2b7d3bc5b);
const $566e8a516f33aa2e$export$dd2171e2b7d3bc5b = {
    extends: 'GroupField',
    Title: {},
    Input: {
        boxSizing: 'border-box',
        theme: 'field',
        display: 'block',
        widthRange: '0 100%',
        padding: 'Z1 A',
        // A text field is a rounded rect at the control height (DESIGN_LANGUAGE
        // §6.2). Was the em letter `Z2` with no height floor.
        round: 'radiusControl',
        minHeight: 'controlH'
    }
};

});

parcelRegister("d0NoL", function(module, exports) {

$parcel$export(module.exports, "ItemAlt", () => $979197f0576fa1f1$export$5bb46e2f94a2fbf6);
const $979197f0576fa1f1$export$5bb46e2f94a2fbf6 = {
    flex: 1,
    gap: 'A2',
    flow: 'column',
    align: 'flex-start space-between',
    padding: 'A2 B B',
    '@mobileL': {
        flow: 'row'
    },
    Flex_header: {
        gap: 'A2',
        align: 'center flex-start',
        Icon: {
            fontSize: 'B2',
            name: 'tree'
        }
    },
    Img: {
        round: 'A',
        margin: '- - - -Z',
        aspectRatio: '16 / 9',
        height: '12em',
        src: 'https://p194.p3.n0.cdn.zight.com/items/rRuDJBlD/7f15d948-1604-4c5f-ad1f-d9aebe607f52.png?v=499b93d980e92921c72e5dc02b7e5ce2'
    },
    Flex_footer: {
        minWidth: 'auto',
        align: 'flex-end space-between',
        gap: 'E',
        ArticleMedium: {
            align: 'flex-start',
            width: '100%',
            maxWidth: 'F1',
            title: {
                text: 'What is Symbols?'
            },
            p: {
                text: 'A minute video explaining how to get started with Symbols'
            }
        }
    }
};

});

parcelRegister("king0", function(module, exports) {

$parcel$export(module.exports, "ImageParagraph", () => $ec6787786b083a9a$export$3a4f115ceb1f5bf1);
const $ec6787786b083a9a$export$3a4f115ceb1f5bf1 = {
    color: 'paragraph',
    align: 'center flex-start',
    gap: 'A',
    Svg: {
        boxSize: 'B1_default C2_default',
        color: 'inactive',
        fill: 'currentColor'
    },
    Paragraph: {
        maxWidth: 'E2_default',
        padding: 'Z 0 0 0'
    }
};

});

parcelRegister("2z9pK", function(module, exports) {

$parcel$export(module.exports, "Hgroup", () => $1de62722fd5ba7a3$export$bd5b3f7ef3b94a4a);
const $1de62722fd5ba7a3$export$bd5b3f7ef3b94a4a = {
    tag: 'hgroup',
    flow: 'y',
    gap: 'Z',
    H: {
        tag: 'h3',
        text: 'Heading',
        lineHeight: '1em',
        color: 'title',
        margin: '0'
    },
    P: {
        text: 'Paragraph',
        margin: '0',
        color: 'paragraph'
    }
};

});

parcelRegister("aQiz0", function(module, exports) {

$parcel$export(module.exports, "ItemHighlight", () => $020980a9744a9271$export$2c1470bef49f6ff);
const $020980a9744a9271$export$2c1470bef49f6ff = {
    extends: 'Item',
    padding: 'B B1 A2 B1',
    round: 'Z2',
    flow: 'y',
    align: 'flex-start space-between',
    '@dark': {
        background: 'lightBlue.065',
        ':hover': {
            background: 'lightBlue.1'
        }
    },
    '@light': {
        theme: 'common-card'
    }
};

});

parcelRegister("4Up3B", function(module, exports) {

$parcel$export(module.exports, "ItemHighlightAlt", () => $392fd4300451d349$export$48f4043b750ac5e8);
const $392fd4300451d349$export$48f4043b750ac5e8 = {
    extends: [
        'ItemHighlight'
    ],
    round: 'Z2',
    flow: 'y',
    align: 'flex-start space-between',
    margin: '- - - auto',
    width: '100%',
    padding: 'B B A',
    available: true,
    '@dark': null,
    '@light': null,
    '@screenM': {
        padding: 'B A A A1'
    },
    '@screenS': {
        gap: 'E1',
        padding: 'B B A'
    },
    '.available': {
        theme: 'common-card-interactive'
    },
    '!available': {
        order: 3,
        // Was a 1px solid outline over a forced-empty background — the same
        // stroked-box habit fixed in ItemOutline.js (design-direction.md §8). A
        // quiet resting fill reads as "not yet available" without a stroke.
        background: 'overlay',
        theme: 'common-card-outline-interactive'
    },
    Icon: {},
    Hgroup: {
        P: {
            height: 'auto'
        }
    }
};

});

parcelRegister("05egG", function(module, exports) {

$parcel$export(module.exports, "LabelTag", () => $00fb891538f88957$export$9dacaafb9baa8abc);
const $00fb891538f88957$export$9dacaafb9baa8abc = {
    extends: 'smbls.LabelTag',
    tag: 'label',
    // A badge is a capsule (DESIGN_LANGUAGE §3: chips/badges → pill). Was
    // the em letter `Y1`.
    round: 'radiusPill',
    theme: 'tertiary',
    text: '-2.902',
    padding: 'X Y',
    lineHeight: '1em'
};

});

parcelRegister("19XRK", function(module, exports) {

$parcel$export(module.exports, "IteratorFooter", () => $0d8511d8f5018324$export$7144a1e5551709a2);
const $0d8511d8f5018324$export$7144a1e5551709a2 = {
    tag: 'footer',
    width: '100%',
    align: 'center space-between',
    transition: 'B defaultBezier',
    // Revealed by opacity and a short rise (Draggable.js), never by a height
    // clip: nothing here hides overflow, so no action is ever cut, and a row
    // too narrow for all six actions wraps them (overflow law §3b.1, §3b.5).
    transitionProperty: 'transform, opacity',
    flexWrap: 'wrap',
    position: 'absolute',
    theme: 'header',
    bottom: 'calc(100% - var(--spacing-X))',
    left: '0',
    padding: 'X',
    gap: 'X',
    '@dark': {
        boxShadow: '--theme-document-dark-background.65 0 Z A -X'
    },
    '@light': {
        boxShadow: '--theme-document-light-background.65 0 Z A -X'
    },
    childProps: {
        theme: 'field'
    },
    // The six actions are icon-only buttons: the icon-button law (IconButton.js)
    // makes each a 36px square. They were framework SquareButtons at a 27.5px em
    // letter size (`B B`), a size that is no control token.
    IconButton_moveUp: {
        isFirst: (el, s)=>parseInt(s.__element.__ref.__state) === 0,
        icon: 'arrowAngleUp',
        round: 'Y1',
        '.isFirst': {
            opacity: '.35',
            pointerEvents: 'none'
        },
        // These handlers referenced a bare `ctx.utils.…` that was never declared
        // as a parameter, so it serialized as a free variable (`__scope.ctx`)
        // resolving to undefined at runtime — every reorder/duplicate click threw
        // instead of moving the row, and frank's verifier blocked publish on it.
        // `el.call` is the registered-function form the house rules mandate; it
        // resolves against context.methods / context.functions / context.utils,
        // and `swapItemsInArray` + `deepClone` come from @symbo.ls/utils, which
        // prepareUtils spreads into context.utils.
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            s.parent.apply((state)=>el.call('swapItemsInArray', state, key, key - 1));
        }
    },
    IconButton_moveDown: {
        icon: 'arrowAngleDown',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            s.parent.apply((state)=>el.call('swapItemsInArray', state, key, key + 1));
        }
    },
    IconButton_drag: {
        icon: 'drag outline',
        round: 'Y1'
    },
    IconButton_plus: {
        margin: '0 0 0 auto',
        icon: 'plus',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            s.parent.apply((state)=>state.splice(key + 1, 0, {}));
        }
    },
    IconButton_trash: {
        icon: 'trash',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = s.__element.key;
            if (window.confirm("Do you want to remove item?")) s.parent.remove(key);
        }
    },
    IconButton_copy: {
        icon: 'copy outline',
        round: 'Y1',
        onClick: (ev, el, s)=>{
            const key = parseInt(s.__element.__ref.__state);
            const value = el.call('deepClone', s.parse());
            s.parent.apply((state)=>state.splice(key + 1, 0, value));
        }
    }
};

});

parcelRegister("7Grb0", function(module, exports) {

$parcel$export(module.exports, "LabeledLight", () => $598189510025dc44$export$b1da5946f36bbf07);
const $598189510025dc44$export$b1da5946f36bbf07 = {
    extends: 'Labeled',
    padding: 'U V',
    // Was a redundant 1px border over an already-filled chip — see Labeled.js.
    '@dark': {
        background: 'gray3.65'
    },
    '@light': {
        background: 'white'
    },
    color: 'paragraph'
};

});

parcelRegister("hFB4S", function(module, exports) {

$parcel$export(module.exports, "Item", () => $cdd306df447a65ae$export$6d08773d2e66f8f2);
const $cdd306df447a65ae$export$6d08773d2e66f8f2 = {
    extends: [
        'Link'
    ],
    width: '100%',
    padding: 'B B1 A2 B1',
    gap: 'D',
    round: 'Z2',
    flow: 'y',
    align: 'flex-start space-between',
    fontWeight: '400',
    href: '{{ href }}',
    '@tabletL': {
        padding: 'B',
        width: '100%',
        maxWidth: 'none'
    },
    state: {
        // was 'tree outline' — no such sprite key exists (unlike dragOutline/
        // copyOutline there is no treeOutline), so the default icon silently
        // rendered nothing at every bare call site
        icon: 'tree',
        title: 'Design System',
        p: 'Organized brand tokens into design and code'
    },
    Icon: {
        fontSize: 'B2',
        icon: '{{ icon }}'
    },
    Hgroup: {
        H: {
            tag: 'h6',
            fontSize: 'A1',
            text: '{{ title }}'
        },
        P: {
            // A floor, never a height (overflow law §3b.6): cards in a row keep one
            // baseline for the usual two lines, and a longer description grows the
            // card instead of running over what follows.
            minHeight: 'C1',
            text: '{{ p }}'
        },
        '@screenL': {
            maxWidth: 'F1'
        }
    }
};

});

parcelRegister("4FmjP", function(module, exports) {

$parcel$export(module.exports, "LandingFooterLite", () => $365c4dca4952006e$export$bf0a8887fa2f2b23);
const $365c4dca4952006e$export$bf0a8887fa2f2b23 = {
    width: '100%',
    padding: 'A B2',
    gap: 'A',
    align: 'center space-between',
    '@mobileL': {
        flow: 'column'
    },
    Flex_nav: {
        gap: 'B',
        childProps: {
            color: 'inactive',
            fontWeight: 'normal',
            ':hover': {
                textDecoration: 'underline'
            }
        },
        Link_access: {
            href: '/signin',
            text: 'Access'
        },
        Link_privacy: {
            href: '/privacy',
            text: 'Privacy'
        },
        Link: {
            href: 'mailto:hello@symbo.ls',
            text: 'Contact'
        }
    },
    Span_copyright: {
        flex: 1,
        textAlign: 'center',
        color: 'inactive',
        text: "2020-2026 \xa9 Symbols.app",
        '@mobileL': {
            order: 3
        }
    },
    Flex_icons: {
        gap: 'Z2',
        childProps: {
            color: 'inactive',
            theme: null,
            background: 'transparent',
            target: '_blank',
            fontSize: 'A2',
            ':hover': {
                color: 'inactive'
            }
        },
        childExtends: [
            'Link',
            'IconButton'
        ],
        children: [
            {
                icon: 'medium',
                href: 'https://symbols.blog/'
            },
            {
                icon: 'discord',
                href: 'https://discord.com/invite/crdFSkapFY'
            },
            {
                icon: 'github',
                href: 'https://github.com/symbo-ls/'
            }
        ],
        childrenAs: 'props'
    }
};

});

parcelRegister("c8Bwy", function(module, exports) {

$parcel$export(module.exports, "LayerSimple", () => $8d6356dd4161b9e8$export$9d44363f0944a5c);
const $8d6356dd4161b9e8$export$9d44363f0944a5c = {
    extends: 'Group',
    padding: 'Z A A A',
    margin: 'C -',
    round: 'Z2',
    gap: 'A',
    width: 'F1',
    // `gray4` is a FIXED #34343a (color.js defines it as a literal, not an
    // adaptive pair), so this panel stayed a dark charcoal slab on light
    // surfaces while its own label text stayed white — the layer list read as a
    // dark rectangle floating on a white page. `common-card` is the adaptive
    // surface that carries a matching foreground in BOTH schemes
    // (gray12-on-gray2.65 dark / gray2-on-gray16+6 light).
    theme: 'common-card',
    Title: {
        text: 'Button'
    },
    Flex: {
        flow: 'y',
        gap: 'A',
        childProps: {
            gap: 'X',
            align: 'center'
        },
        childExtends: {
            Icon: {
                color: 'inactive',
                gap: 'Y1'
            },
            Span: {
                // was `white` (fixed) — unreadable once the panel adapts to light.
                color: 'title',
                padding: '- - - X2'
            }
        },
        children: ()=>[
                {
                    Icon: {
                        icon: 'typography',
                        color: 'purple'
                    },
                    Span: {
                        text: 'Go Dark'
                    }
                },
                {
                    Icon: {
                        icon: 'shapeOutline',
                        color: 'indigo'
                    },
                    Span: {
                        text: 'moon'
                    }
                }
            ]
    }
};

});

parcelRegister("9Y5HT", function(module, exports) {

$parcel$export(module.exports, "LibrariesRow", () => $741e24ec01945456$export$ca484f140c50fdca);
const $741e24ec01945456$export$ca484f140c50fdca = {
    extends: 'TemplatesRow',
    Caption: {
        text: 'Explore our libraries'
    },
    Scrollable: {
        childExtends: 'LibrariesRowItem',
        children: ()=>[
                {
                    poster: "https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download",
                    projectPath: "nikoloza/default",
                    amount: 206,
                    title: "Default"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667c8424350c909ec03d4/download",
                    projectPath: "nikoloza/ecommerce",
                    amount: 271,
                    title: "Ecommerce"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667ac424350c909ec034e/download",
                    projectPath: "nikoloza/forms",
                    amount: 248,
                    title: "Forms"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667c2424350c909ec03a6/download",
                    projectPath: "nikoloza/ai",
                    amount: 213,
                    title: "AI"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667d6424350c909ec0421/download",
                    projectPath: "nikoloza/web3",
                    amount: 85,
                    title: "Web3"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b667db424350c909ec044f/download",
                    projectPath: "nikoloza/content-and-marketing",
                    amount: 275,
                    title: "Content & Marketing"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b66c9b424350c909ec1f66/download",
                    projectPath: "nikoloza/docs",
                    amount: 598,
                    title: "Docs"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b671ef424350c909ec5342/download",
                    projectPath: "nikoloza/charts",
                    amount: 0,
                    title: "Charts"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b66bfb424350c909ec1eb4/download",
                    projectPath: "nikoloza/ui",
                    amount: 0,
                    title: "No-code"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b672ad424350c909ec544b/download",
                    projectPath: "nikoloza/cms",
                    amount: 0,
                    title: "CMS"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b66c19424350c909ec1f0c/download",
                    projectPath: "nikoloza/code",
                    amount: 0,
                    title: "Code"
                },
                {
                    poster: "https://api.symbols.app/core/files/public/68b63fae424350c909ea336e/download",
                    projectPath: "nikoloza/miscellaneous",
                    amount: 0,
                    title: "Miscellaneous"
                }
            ]
    }
};

});

parcelRegister("jG0yo", function(module, exports) {

$parcel$export(module.exports, "KeyValueColumnFields", () => $e5325e8a550f7160$export$cf9d2c7f5d1a7230);
const $e5325e8a550f7160$export$cf9d2c7f5d1a7230 = {
    extends: [
        'DropdownItem',
        'Button'
    ],
    textAlign: 'start',
    align: 'center flex-start',
    padding: 'A',
    fontSize: 'Z1',
    href: '{{ href }}',
    onClick: async (ev, el, s, ctx2)=>await el.call("dropdownClick", ev, el, s, ctx2),
    Icon: {
        name: 'checkmark',
        opacity: '0',
        transition: 'A opacity',
        margin: '- Y1 - W1'
    },
    Text: {
        color: 'title',
        text: (el, s)=>s.text || s.value || s.key || ""
    },
    Caption: {
        marginLeft: 'Z2',
        textTransform: 'capitalize',
        color: 'caption',
        whiteSpace: 'nowrap',
        text: ''
    }
};

});

parcelRegister("dWUfQ", function(module, exports) {

$parcel$export(module.exports, "LibrariesRowItem", () => $029ee8953cd149eb$export$88e8d99c799a782c);
const $029ee8953cd149eb$export$88e8d99c799a782c = {
    extends: [
        'TemplatesRowItem'
    ],
    poster: 'https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download',
    projectPath: 'nikoloza/default',
    amount: 206,
    title: 'Default',
    previewUrl: null,
    Box: {},
    Span: {
        Span: {
            if: (el, s)=>!!s.amount,
            margin: '- - - A',
            // Thin (100-300) is readable only at >= D-size display type
            // (design-direction.md §7/geex layer); `Z2` is tiny meta text, and the
            // geex layer states meta text should be '400', not thin.
            fontWeight: '400',
            fontSize: 'Z2',
            text: ' ({{ amount }} resources)',
            color: 'paragraph'
        }
    }
};

});

parcelRegister("2Eo5j", function(module, exports) {

$parcel$export(module.exports, "Focusable", () => $1ee1ffec02e7eed4$export$35a3bebf7ef2d934);
// Brand override of the framework `Focusable` atom (default-config
// Atoms/InteractiveComponent.js) — the library override pattern (same name,
// `extends` the built-in), so every framework control that extends it —
// Button, SquareButton/CircleButton, Link, Input, Select, and therefore every
// brand button/field built on those — resolves to THIS.
//
// Why: the atom paints its OWN focus ring, `outline: 'solid X blue.3'` at
// `:focus-visible`, and css-in-props emits it at doubled-class specificity
// (`._x._x:focus-visible`), which beats the brand reset's `outline: none`.
// Result, measured live 2026-08-16 on the workspace shell: every button
// showed TWO rings — the house double ring (brand reset.js box-shadow,
// DESIGN_LANGUAGE §8.2 "one ring, globally") PLUS a faint 2px blue outline.
// That was the F1 inconsistency Nika named ("make outline style for all form
// elements consistent"). The house ring stays where it is (reset.js /
// `focusRing` token); this atom simply stops competing with it.
//
// Nothing else changes: `border: 'none'`, the `opacity: 1` focus reveal and
// the `attr.tabIndex` bridge are inherited from the built-in.
const $1ee1ffec02e7eed4$export$35a3bebf7ef2d934 = {
    extends: 'Focusable',
    outline: 'none',
    ':focus-visible': {
        outline: 'none'
    }
};

});

parcelRegister("hIrTU", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $ce5c3036c514f050$export$c25acd513dcc8062);
const $ce5c3036c514f050$export$c25acd513dcc8062 = {
    extends: [
        'SquareButton'
    ],
    theme: 'tertiary',
    position: 'relative',
    round: 'Z2',
    draggable: false,
    // THE ICON-BUTTON LAW (Nika 2026-09-26: "all icon buttons should have 1/1
    // aspect ratio"). An ICON-ONLY button is a square on the control scale:
    // width == height == the control-height token of its size — `controlHCompact`
    // (36px, the toolbar size, the default) or `controlH` (44px, `large: true`,
    // an action plate) — aspect ratio 1 / 1, no padding, never shrunk by a flex
    // row, the glyph centred (Button's inline-flex, align center center). Fixed
    // px on purpose: a control's box must not scale with the font size around
    // it. The law is a conditional block, so it outranks the call site: a
    // per-instance boxSize or padding on an icon-only button is inert — pick a
    // size with `large`, never with px or letters.
    //
    // Icon-only = no label. The label is the `text` prop (IconText's own default
    // `text` is a passthrough that resolves to itself, hence `exec` and the
    // string test), or a child laid out IN FLOW that carries text — the page
    // name in a canvas dropdown, an env name. An absolutely positioned child (an
    // unread badge) is an overlay on the square, not a label. Text + icon
    // buttons keep the SquareButton geometry untouched. NavbarButton and
    // CanvasButton take this law by listing IconButton as a base.
    isIconOnly: (el)=>{
        const label = el.call('exec', el.text, el);
        if ((typeof label === 'string' || typeof label === 'number') && String(label).trim() !== '') return false;
        for(const key in el){
            if (key === 'Icon' || key === 'parent' || !/^[A-Z]/.test(key)) continue;
            const child = el[key];
            if (!child || typeof child !== 'object') continue;
            if (child.position === 'absolute' || child.position === 'fixed') continue;
            if (child.text != null && child.text !== '') return false;
        }
        return true;
    },
    '.isIconOnly': {
        boxSize: 'controlHCompact',
        padding: '0',
        aspectRatio: '1 / 1',
        flexShrink: '0',
        boxSizing: 'border-box'
    },
    isIconOnlyLarge: (el)=>!!el.large && !!el.call('exec', el.isIconOnly, el),
    '.isIconOnlyLarge': {
        boxSize: 'controlH'
    },
    // Touch: 44pt hit area via an invisible TAP-SLOP pseudo, not size floors —
    // mirrors NavbarButton (see its note for the full rationale: em-based
    // floors inflated gauge-pinned chrome to ~51px on iPad; slop grows only
    // the hit area, needs no consumer opt-outs; `tapSlop` is the fixed-px
    // sizes token). Coarse-pointer only.
    '@coarse': {
        ':after': {
            content: '""',
            position: 'absolute',
            inset: 'tapSlop'
        }
    },
    // Accessible-name bridge: an icon-only button that passes `title` and no
    // name of its own is announced by that title.
    //
    // It is a REACTIVE prop, not a one-shot `onRender` copy. The copy ran once and
    // then refused to touch an `aria-label` that already existed — so the name
    // was whatever the title said on the FIRST render. On a Georgian boot that is
    // English: the language chunk lands after the first paint, the `title`
    // effect re-runs and turns Georgian, and the copied name stayed English for
    // the life of the element (measured live 2026-09-22: `title="აკრეფაზე
    // დაბრუნება"` beside `aria-label="Back to typing"` on the same node; 19 such
    // names on one page). A function reads the same `title` inside its own effect,
    // so it follows the language, the state and a late bundle exactly as the
    // title does. A name the call site declares — flat, camelCase, inside
    // `aria: {}` or inside `attr: {}` — still wins: it replaces this prop, or is
    // mirrored by it.
    'aria-label': (el, s)=>{
        // Every shape a call site may have named the control in, then the title.
        // (A flat `'aria-label'` on the call site never reaches here: it replaces
        // this prop.) Mirroring them keeps the two writers of one attribute in
        // agreement, so neither can erase the other's name.
        const sources = [
            el.attr && el.attr['aria-label'],
            el.aria && el.aria.label,
            el.ariaLabel,
            el.title
        ];
        for (const source of sources){
            const value = typeof source === 'function' ? source(el, s, el.context) : source;
            if (value != null && value !== '') return value;
        }
        return null;
    }
};

});

parcelRegister("dSzE6", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $a1abf800cfbfc987$export$de65de8213222d10);
// THE close affordance — one X, one size, for every sidebar, drawer, panel,
// modal and dialog (Nika 2026-08-16, F2: "why all sidebars have different
// size of X buttons? make this button consistent for all sidebars and
// modals"). Before this, ~75 close sites across brand + workspace rolled
// ~15 distinct (box, icon) combinations from three colliding size
// vocabularies — em letters (B/B1/B2), fixed px (iconSm/controlH) and raw
// `fontSize` on a text `×`. Extend THIS; never size a close button locally.
//
// Geometry is FIXED-PX on purpose (sizes.js §3/§6 rationale): a close X is
// device-physical chrome that must not scale with a surface's font size —
// the 36px `controlHCompact` square comes from the icon-button law
// (IconButton.js), the glyph is `iconSm` (16px). Coarse pointers grow
// the HIT area to 44pt through IconButton's tapSlop pseudo, and IconButton's
// title→aria-label bridge is inherited. The declarative name below preserves
// consumer labels and supplies a localized default when none is provided.
//
// A FILLED grey circle (white-label redesign, Nika 2026-09-26 "update them
// in brand"; spec §4.10, references r010 r047 r083): the `layer` plate at
// rest — it reads as a control on a white sheet, a gray3 sheet and the
// page alike — the `selected` wash under the pointer, and a press that
// sinks to 0.94. `caption` ink at rest → `title` on hover. It was quiet
// (no fill at rest), and on the new white sheet an unfilled X read as a
// stray glyph. Focus = the global ring only (§8.2).
const $a1abf800cfbfc987$export$de65de8213222d10 = {
    extends: 'IconButton',
    // The localized default name for a shell that ships no `brandClose` in its
    // dictionary — a scope VALUE (FA204), NEVER a root `state`: a root state gives
    // every element that extends CloseButton a LOCAL store, so a consumer's
    // handler or factory reads the button's store instead of the row it sits in
    // (8348e1a; measured on dev 2026-09-29: the home widget X ran
    // hideWidget(s.id) with `undefined` and did nothing).
    scope: {
        brandCloseFallback: {
            en: 'Close',
            ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
        }
    },
    theme: 'layer',
    type: 'button',
    round: '50%',
    color: 'caption',
    cursor: 'pointer',
    transitionProperty: 'background, color, transform',
    transition: 'A defaultBezier',
    ':hover': {
        background: 'selected',
        color: 'title'
    },
    ':active': {
        background: 'selected',
        color: 'title',
        transform: 'scale(0.94)'
    },
    // The name: whatever the call site declared (any shape — a flat
    // `'aria-label'` simply replaces this prop), else its `title`, else the
    // localized default. FLAT and reactive, the same slot IconButton's
    // title→name bridge uses, so the two are ONE declaration: the old `attr: {}`
    // form was a second writer of the same attribute, and it read
    // `el['aria-label']` — which is the inherited bridge itself now. The default
    // is the dictionary's `brandClose`; a shell that excludes the brand site's
    // dictionary gets the key ECHOED back (polyglot returns a missing key as
    // itself), so an echo falls through to the EN/KA fallback in scope.
    'aria-label': (el, s)=>{
        const sources = [
            el.attr && el.attr['aria-label'],
            el.aria && el.aria.label,
            el.ariaLabel,
            el.title
        ];
        for (const source of sources){
            const value = typeof source === 'function' ? source(el, s, el.context) : source;
            if (value != null && value !== '') return value;
        }
        const key = 'brandClose';
        const translated = el.call('polyglot', key);
        if (translated && translated !== key) return translated;
        const fallback = el.scope && el.scope.brandCloseFallback;
        const lang = el.call('getActiveLang');
        return fallback && (fallback[lang] || fallback.en) || 'Close';
    },
    Icon: {
        // `name`, not `icon`: the framework Icon's render gate reads `el.name`
        // (parent.icon || el.name) — `icon:` on the child never passes it and the
        // glyph is blank (caught by the F2 sweep lane with a jsdom probe).
        name: 'x',
        boxSize: 'iconSm',
        display: 'block',
        flexShrink: '0'
    }
};

});

parcelRegister("k62ol", function(module, exports) {

$parcel$export(module.exports, "ItemOutline", () => $ea163923dcc0c655$export$e215a18fe07277cc);
const $ea163923dcc0c655$export$e215a18fe07277cc = {
    extends: [
        'Item',
        'ClickableItem'
    ],
    hasHref: null,
    padding: 'A B',
    theme: 'common-card-outline-interactive',
    // The shared theme supplies only `borderColor` (no width/style — that's
    // deliberate, see theme.js); the 1px solid stroke that materialized it was
    // declared HERE. Dropping it converts the "unavailable" outline card to a
    // quiet resting fill instead of a stroked box (design-direction.md §8);
    // the theme's own hover/focus/active washes are untouched.
    background: 'overlay',
    '!hasHref': {
        pointerEvents: 'none',
        opacity: 0.35
    }
};

});

parcelRegister("aRzke", function(module, exports) {

$parcel$export(module.exports, "Labeled", () => $7e8a417bb7afabc4$export$fd4dc8aaf4bd92f);
const $7e8a417bb7afabc4$export$fd4dc8aaf4bd92f = {
    tag: 'span',
    whiteSpace: 'nowrap',
    color: 'caption',
    lineHeight: '1',
    padding: '0 W1',
    round: 'X2',
    // Was a 1px border layered ON TOP of an already-filled chip (redundant
    // "1px solid line" habit, banned by design-direction.md §8) — the
    // background fill alone already reads as a distinct inline label.
    '@dark': {
        background: 'gray3'
    },
    '@light': {
        background: 'white.5'
    }
};

});

parcelRegister("foT5d", function(module, exports) {

$parcel$export(module.exports, "LabeledHighlight", () => $b363d33f72304730$export$894c907407a93b5f);
const $b363d33f72304730$export$894c907407a93b5f = {
    extends: 'Labeled',
    padding: 'U V',
    // Was a redundant 1px border over an already-filled chip — see Labeled.js.
    '@dark': {
        background: 'gray3.65'
    },
    '@light': {
        background: 'white'
    },
    color: 'title'
};

});

parcelRegister("ajePO", function(module, exports) {

$parcel$export(module.exports, "LoadingGif", () => $78172f9a105db066$export$6111cf07b0d59153);
const $78172f9a105db066$export$6111cf07b0d59153 = {
    extends: 'Img',
    src: 'https://assets.symbo.ls/loading.gif',
    width: '3.2em',
    pointerEvents: 'none',
    opacity: '.35',
    zIndex: '-1',
    inCenter: true,
    '.inCenter': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate3d(-50%, -50%, 0)'
    }
};

});

parcelRegister("fYhms", function(module, exports) {

$parcel$export(module.exports, "Line", () => $ba09ed2ec859e45d$export$17d680238e50603e);
$parcel$export(module.exports, "Hr", () => $ba09ed2ec859e45d$export$c65504044f62f430);
const $ba09ed2ec859e45d$export$17d680238e50603e = {
    margin: 'D 0',
    padding: '0',
    border: '0',
    theme: 'line',
    background: 'line',
    heightRange: 'hairline',
    // A rule with no declared width collapses to ZERO width in any flex parent
    // that isn't stretching its children (`align: 'center center'`, the common
    // case for a centred column) — the divider was 1px tall and 0px wide, i.e.
    // completely absent, while looking correct in a plain block container.
    // A horizontal rule spans its container by definition.
    width: '100%'
};
const $ba09ed2ec859e45d$export$c65504044f62f430 = {
    extends: 'Line'
};

});

parcelRegister("7tsf5", function(module, exports) {

$parcel$export(module.exports, "LoadingGifSection", () => $57112629be960f06$export$ba2a7fab645f3ee0);
const $57112629be960f06$export$ba2a7fab645f3ee0 = {
    position: 'relative',
    LoadingGif: {}
};

});

parcelRegister("aytHs", function(module, exports) {

$parcel$export(module.exports, "Logo", () => $7af41e27ba52a92e$export$e6ff31bff12b7ff4);
const $7af41e27ba52a92e$export$e6ff31bff12b7ff4 = {
    extends: [
        'SquareButton'
    ],
    icon: 'logov2',
    boxSize: '1.25em',
    aspectRatio: '1 / 1',
    transition: 'B defaultBezier',
    transitionProperty: 'background, color',
    // NO background declaration on the resting state (2026-08-16, NIKA BATCH
    // F3): elements are transparent by default, and the removed literal here —
    // `background: 'transparent 0'` — went through scratch's static-colour
    // token-table resolution on the serve-latest runtime, where it resolved to
    // a solid black fill (the same documented static-colour trap already fixed
    // once in BrandRailLink.js). Invisible on the dark ground (matches the
    // theme), but rendered a solid black circle behind the glyph in light
    // theme — exactly the "surfaces the moment the ground changes" failure
    // mode. `:hover`/`.isActive` below are unaffected — they set real explicit
    // colours inside `@dark`/`@light`, never the bare word `transparent`.
    margin: 'U',
    padding: 'X',
    round: '100%',
    color: 'title',
    zIndex: 9999999,
    position: 'fixed',
    top: 'X2',
    left: 'Y',
    ':focus-within': {
        zIndex: 9990100
    },
    '@dark': {
        color: 'white'
    },
    '@light': {
        color: 'black'
    },
    ':hover': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    '.isActive': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    // isEmbed / isDocs / isDashboard are system/shared METHODS. A site that
    // does not link system/shared (the landing after the W1 weight cut) has
    // none of them, and the bare calls threw `el.isEmbed is not a function`
    // before the click could go home. A missing method answers false, so such
    // a site's Logo goes to '/'. Not `el.call(...)`: call() also resolves
    // FUNCTIONS (the landing's isEmbed is its iframe probe, kept for the Link
    // child below) and logs a dev error for each name it cannot find.
    onClick: (ev, el)=>{
        ev.preventDefault();
        if (typeof el.isEmbed === 'function' && el.isEmbed()) return;
        if (typeof el.isDocs === 'function' && el.isDocs()) {
            el.node.blur();
            return el.router('/developers', el.getRoot());
        }
        if (typeof el.isDashboard !== 'function' || !el.isDashboard()) {
            el.node.blur();
            return el.router('/', el.getRoot());
        }
    },
    Link: {
        if: (el)=>el.call('isEmbed'),
        position: 'absolute',
        inset: '0',
        zIndex: 9,
        href: `'https://symbols.app' + window.location.pathname.split('/embed')[1]`,
        target: '_blank'
    },
    Icon: {
        fontSize: '1.26em'
    },
    Span: {
        animation: 'slideInOut',
        animationDelay: 'B',
        animationDuration: 'K',
        animationTimingFunction: 'defaultBezier',
        position: 'absolute',
        // Was `top: '50%'` + `transform: translate3d(0, 50%, 0)` — a
        // percentage-of-parent anchor with no defined relationship to the
        // glyph's own rendered top edge, so the BETA badge floated at a
        // different height than the Icon (2026-08-16 NIKA BATCH F3, "glyph and
        // text are not aligned at the top"). `Icon` centers in this button's
        // `boxSize: '1.25em'` content-box at `fontSize: '1.26em'` — the glyph is
        // marginally larger than its own box, so centering leaves ~0 slack and
        // the glyph's rendered top edge lands at the button's own padding-top
        // offset. `top: 'X'` reuses that EXACT token (this component's own
        // `padding: 'X'`), so the badge's top edge lands on the glyph's top edge
        // instead of an unrelated percentage.
        top: 'X',
        left: '95%',
        color: 'orange',
        fontWeight: '500',
        fontSize: 'X',
        text: 'BETA',
        opacity: '0'
    }
};

});

parcelRegister("5t3FV", function(module, exports) {

$parcel$export(module.exports, "LogoCopy", () => $3fb28303efd22ac4$export$7dde25639b6e0270);
const $3fb28303efd22ac4$export$7dde25639b6e0270 = {
    extends: [
        'Link',
        'SquareButton'
    ],
    icon: 'logov2',
    isActive: ()=>window.location.pathname === "/dashboard",
    fontSize: 'C',
    text: null,
    href: '/',
    position: 'relative',
    color: 'inactive',
    transition: 'B defaultBezier',
    transitionProperty: 'background, color',
    // NO background declaration on the resting state (2026-08-16, NIKA BATCH
    // F3): elements are transparent by default, and the removed literal here —
    // `background: 'transparent 0'` — went through scratch's static-colour
    // token-table resolution on the serve-latest runtime, where it resolved to
    // a solid black fill (same documented static-colour trap already fixed
    // once in BrandRailLink.js; see the sibling Logo.js fix for the full
    // writeup). `:hover`/`.isActive` below are unaffected — they set real
    // explicit colours inside `@dark`/`@light`, never the bare word
    // `transparent`.
    margin: 'W',
    padding: 'Y',
    round: '100%',
    '@dark': {
        color: 'white'
    },
    '@light': {
        color: 'black'
    },
    ':hover': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    '.isActive': {
        '@dark': {
            color: 'gray15',
            background: 'gray3'
        },
        '@light': {
            color: 'black',
            background: 'white'
        }
    },
    Span: {
        animation: 'slideInOut',
        animationDelay: 'B',
        animationDuration: 'K',
        animationTimingFunction: 'defaultBezier',
        position: 'absolute',
        // Was `top: '50%'` + `transform: translate3d(0, 50%, 0)` — a
        // percentage-of-parent anchor with no defined relationship to the
        // glyph's own rendered top edge (2026-08-16 NIKA BATCH F3, "glyph and
        // text are not aligned at the top" — see the sibling Logo.js fix for the
        // full writeup). This button's `boxSize` is SquareButton's own
        // `fit-content fit-content` (no override here), so it shrink-wraps
        // exactly around the Icon glyph — the glyph's rendered top edge lands at
        // the button's own padding-top offset. `top: 'Y'` reuses that EXACT
        // token (this component's own `padding: 'Y'`), so the badge's top edge
        // lands on the glyph's top edge instead of an unrelated percentage.
        top: 'Y',
        left: '85%',
        color: 'orange',
        fontSize: '.45em',
        fontWeight: '500',
        text: 'BETA',
        opacity: '0'
    }
};

});

parcelRegister("gRcJe", function(module, exports) {

$parcel$export(module.exports, "MadeOnSymbols", () => $c45b7839e556d717$export$6fd487ae10a7b02b);
const $c45b7839e556d717$export$6fd487ae10a7b02b = {
    extends: 'TemplatesRow',
    Caption: {
        text: '#madeonsymbols'
    },
    Scrollable: {
        childProps: {
            href: '{{ href }}'
        },
        children: [
            {
                poster: 'https://api.symbols.app/core/files/public/68b43aac424350c909e4f047/download',
                href: 'https://tech-dash.symbo.ls',
                title: 'TechBrother',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b43e2b424350c909e4fa6f/download',
                href: 'https://mankanet.symbo.ls',
                title: 'Mankanet',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b446dd424350c909e50d4e/download',
                href: 'https://nocost.symbo.ls',
                title: 'NoCost',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b65ee1424350c909ebc8a1/download',
                href: 'https://fresh.symbo.ls',
                title: 'FreshCo',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b66083424350c909ebd66a/download',
                href: 'https://bessi.symbo.ls',
                title: 'Christmas Shop',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b6749b424350c909ec6fcf/download',
                href: 'https://qartool.symbo.ls',
                title: 'Qartool',
                previewUrl: null
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b67552424350c909ec7534/download',
                href: 'https://moll.symbo.ls',
                title: 'Mollie',
                previewUrl: null
            }
        ]
    }
};

});

parcelRegister("Gf4eK", function(module, exports) {

$parcel$export(module.exports, "LogoLoader", () => $07ef9c6aed749dc9$export$aad50578967112e3);
// The Symbols mark for loader surfaces. The mark's BASE state is drawn +
// filled + fully visible — previously the base was the UNDRAWN state
// (stroke-dashoffset 242, transparent fill, opacity .35) revealed by a
// one-shot 500ms onRender update, so any loader that was re-SHOWN after its
// first mount (org/workspace switch, data-load gate) displayed an invisible
// or ghost mark, and the reveal timer raced the loader's own show/hide.
// The first-paint draw-in animation belongs to the surface that owns first
// paint (the inline #boot-spiral in the shell's index.html); the component
// guarantees a complete, always-visible mark in EVERY scenario.
// (2026-07-12 per Nika "fix LoaderRatio/loader fundamentally".)
const $07ef9c6aed749dc9$export$aad50578967112e3 = {
    color: 'title',
    '& svg': {
        opacity: '1',
        // longhand on purpose: the `boxSize` shorthand is dropped silently inside
        // selector blocks, which left every mark at the svg's intrinsic 41px —
        // logo sizing never actually tracked font size until this.
        width: '2.2em',
        height: '2.2em',
        fill: 'currentColor',
        stroke: 'currentColor',
        strokeWidth: '.5px',
        strokeDasharray: '242',
        strokeDashoffset: '0'
    },
    '& path': {},
    // width/height/fill/stroke are INLINE svg attrs on purpose (published-
    // runtime bridge): the `& svg` selector block below is dropped by the
    // published css-in-props builds, which left the mark at its intrinsic
    // 41px with a default-black fill (invisible on dark). Inline attrs render
    // identically on every runtime; the selector block stays as the richer
    // treatment for current builds.
    html: '<svg xmlns="http://www.w3.org/2000/svg" width="2.2em" height="2.2em" fill="currentColor" stroke="currentColor" stroke-width=".5" viewBox="0 0 41 42"><path fill-rule="evenodd" d="M26.6448969,0.699064106 C31.4862479,1.83000067 35.6718819,4.48073656 38.3104478,8.91022511 C40.5212645,12.5974948 41.4936378,17.0951724 40.5085112,21.3679841 C39.7174644,25.0315254 37.8558379,27.853625 34.8002871,29.8369535 C31.9792925,31.7073227 27.90737,32.069064 24.6776501,31.3213124 C23.2887047,30.9944607 20.6411869,29.9775216 19.044333,28.0178349 C17.5928447,26.2365433 17.1250067,23.5192397 17.0461096,22.8419583 C16.9044422,21.6258334 17.1065683,20.249997 17.3800113,19.0276209 C17.9614095,16.4655592 18.9984397,14.7924534 21.1401118,13.3818866 C22.95018,12.1750388 24.6834696,11.8738651 26.7601335,12.3496124 C28.1855093,12.6880929 29.4520072,13.526716 30.3514025,14.7276098 C30.6271426,15.093878 30.8260324,15.4389318 31.059655,15.8362933 L30.9598079,15.7715366 C29.6377659,14.9422902 28.1654404,14.6590001 26.6448969,15.0752526 C25.2996601,15.4486698 24.1453463,16.3687006 23.4390969,17.6304467 C22.6973258,18.9448239 22.4839364,20.5087166 22.8465467,21.9733145 C23.2152637,23.4394215 24.1276197,24.6832715 25.381967,25.429977 C26.7647836,26.2608222 28.5893081,26.47537 30.1320438,26.0161118 C32.0344739,25.4497656 33.5958796,24.1165457 34.5824098,22.3233381 C35.8078311,20.0959926 36.0316242,17.5753145 35.4197363,15.1376991 C34.8712232,12.9726344 33.491011,11.1258939 31.7578503,9.86101942 C28.3978494,7.40873928 23.8145474,6.88014849 19.8961329,8.1555193 C16.9596954,9.11146975 14.399202,11.0657028 12.6221782,13.707146 C10.5375814,16.8894059 9.73736372,20.794518 10.3986926,24.5579956 C10.9302311,27.7327705 12.5716868,31.0242929 14.8485647,33.1339502 C15.5517576,33.7855358 16.0056239,34.2996296 16.8186608,34.9238068 C16.1252729,35.6670587 15.729719,36.1210912 15.0276006,36.8553491 L10.5425168,41.6144377 C8.59431563,40.2572487 6.84060794,38.6181461 5.33246714,36.7448351 C1.65619854,32.1632109 -0.0655234106,26.1858125 0.562658817,20.1851649 C1.1000136,14.4158268 3.81414269,9.08050481 8.0996615,5.36924966 C12.3107417,1.69300072 17.6911238,0.0107792851 23.1108097,0.299129816 C25.006381,0.458182488 26.18441,0.591493918 26.6448969,0.699064106 Z"/></svg>'
};

});

parcelRegister("eHbTl", function(module, exports) {

$parcel$export(module.exports, "MainLoader", () => $ab2e4e48f4c16c08$export$d330003798a27f99);
const $ab2e4e48f4c16c08$export$d330003798a27f99 = {
    attr: {
        id: 'main-loader'
    },
    position: 'fixed',
    boxSize: '100% 100%',
    inset: '0 0 0 0',
    zIndex: 9990099,
    pointerEvents: 'none',
    theme: 'document',
    overflow: 'hidden',
    animation: 'scaleOutIn',
    animationDuration: 'E',
    LoaderRatio: {
        position: 'absolute',
        zIndex: 1
    },
    LogoLoader: {
        zIndex: 2,
        position: 'absolute',
        top: '50%',
        left: '50%',
        fontSize: '1em',
        transform: 'translate3d(-50%, -50%, 0)'
    }
};

});

parcelRegister("6PosI", function(module, exports) {

$parcel$export(module.exports, "ListInDropdown", () => $4f8a7b30478485d5$export$2e1382a2571ac79c);
const $4f8a7b30478485d5$export$2e1382a2571ac79c = {
    tag: 'nav',
    flow: 'y',
    gap: 'W',
    align: 'stretch flex-start',
    children: (el)=>el.call('exec', el.parent.options, el.parent),
    childrenAs: 'state',
    // NO `content` child. A `content: { ignoreChildProps, ignoreChildExtends }`
    // block (from the pre-v3 slot API) rendered as a THIRD, EMPTY row: the
    // childProps and the row chassis reached it anyway, so every list carried
    // an unnamed 46px option that announced itself as the selected one
    // (aria-selected "true": undefined === undefined). Measured on the
    // workspace language list, dev aeb80fc01, 2026-09-24. Nothing reads the
    // slot; the rows come from `children`.
    childExtends: [
        'KeyValueColumnFields'
    ]
};

});

parcelRegister("ggVIg", function(module, exports) {

$parcel$export(module.exports, "LoaderRatio", () => $bd8ae88939727845$export$519dfb4ed033765e);
const $bd8ae88939727845$export$519dfb4ed033765e = {
    position: 'fixed',
    boxSize: '100% 100%',
    inset: '0 0 0 0',
    zIndex: 9990099,
    pointerEvents: 'none',
    theme: 'document',
    overflow: 'hidden',
    animationDuration: 'E',
    // `dim` is [gray9 light, gray7 dark] — an ASYMMETRIC pair for this use. Over
    // the near-black dark document, gray7 is a large step and the spiral reads
    // fine at `opacity: .5`; over the near-white light document, gray9 is a much
    // smaller step and the same 50% wash left the loader looking like a blank
    // panel. `inactive` is [gray6, gray10] — a step of comparable size away from
    // the surface in BOTH schemes, so the spiral carries equal weight either way
    // without changing its opacity (per Nika, "spiral should have opacity").
    // eslint-disable-next-line no-restricted-syntax -- sets `currentColor` for the decorative spinner stroke, not text
    color: 'inactive',
    ':after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '50%',
        left: '50%',
        transform: 'translate3d(-50%, -50%, 0)',
        round: '100%',
        // The vignette is UNCONDITIONAL (dark base + @light override). It was
        // previously declared only inside @dark/@light blocks, which do not
        // resolve on the pseudo-element in every consumer's theme context (the
        // workspace shell computed `background: none`) — the loader showed a bare
        // spiral with no gradient behind the logo, and consumers patched it per
        // instance. Every consumer gets the complete visual from the component
        // itself now (2026-07-12 per Nika "fix LoaderRatio fundamentally").
        background: `radial-gradient(
        circle,
        rgba(5, 5, 5, 0.98) 6.5%,
        rgba(5, 5, 5, 0) 75%
      )`,
        '@light': {
            background: `radial-gradient(
          circle,
          rgba(241, 241, 243, 0.98) 6.5%,
          rgba(241, 241, 243, 0) 75%
        )`
        }
    },
    Spinner: {
        // Spiral renders semi-transparent — matches the old platform Loader's
        // `> svg { opacity: 0.5 }` visual reference (the faint 0.275 read as nearly
        // invisible at full-screen). Per Nika "spiral should have opacity".
        //
        // LMC-F1: `color: 'inactive'` at this opacity composites to 2.51:1 (dark,
        // `rgb(152,152,162)`/`.5` on `rgb(10,10,10)`) and 2.23:1 (light) — both
        // below the 3:1 icon floor, measured live. This is deliberate ambient
        // decoration behind the fully-opaque `LogoLoader` mark (which carries its
        // own `color: 'title'` contrast and is what actually reads as the loading
        // indicator via motion + shape) — not a graphical object "required to
        // understand content" under WCAG 1.4.11. Marked decorative rather than
        // re-tuned, so the intentional faint-spiral look (Nika, 2026-06-22/07-12)
        // is preserved exactly, in both themes, by construction.
        ariaHidden: 'true',
        opacity: '0.5',
        position: 'absolute',
        boxSize: '100%',
        inset: 0,
        display: 'flex',
        align: 'center center',
        '& > svg': {
            // Fill the loader responsively instead of the SVG's intrinsic 2684px,
            // which overflowed every viewport so only the tight center swirl showed.
            // width/height 100% + the markup's viewBox + preserveAspectRatio 'slice'
            // make the spiral scale to cover the full-screen loader (and any embed)
            // while staying round. (2026-06-22 per Nika "Ratio Spiral should be full
            // screen".)
            width: '100%',
            height: '100%',
            transformOrigin: '50% 50%',
            position: 'absolute',
            animation: 'rotate',
            animationDuration: '10.818s',
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite'
        },
        html: '<svg xmlns="http://www.w3.org/2000/svg" width="2684" height="2685" viewBox="0 0 2684 2685" preserveAspectRatio="xMidYMid slice"><g fill="none" fill-rule="evenodd" stroke="currentColor"><path d="M2 1660.694C2 1026.356 516.319 512.123 1150.763 512.123M1861.137 1222.378c0-392.263-318.045-710.255-710.374-710.255M1422.748 1660.694c242.116 0 438.39-196.24 438.39-438.316M1150.763 1389.902c0 149.554 121.258 270.792 270.838 270.792M1150.763 1389.902c0-92.52 75.016-167.524 167.552-167.524M1421.6 1325.646a103.26 103.26 0 0 0-30.251-73.021 103.294 103.294 0 0 0-73.034-30.247M1421.6 1325.646a64.25 64.25 0 0 1-18.823 45.436 64.272 64.272 0 0 1-45.443 18.82"/><path d="M1318.315 1349.742a40.156 40.156 0 0 0 11.765 28.397 40.17 40.17 0 0 0 28.402 11.763M1318.315 1349.742c0-13.308 10.79-24.096 24.1-24.096M1358.482 1341.71c0-8.872-7.194-16.064-16.067-16.064M1358.482 1341.71a8.031 8.031 0 0 1-8.034 8.032M1342.415 1341.71a8.031 8.031 0 0 0 8.033 8.032M1026.488 2c634.338 0 1148.571 514.319 1148.571 1148.763M1464.804 1861.137c392.263 0 710.255-318.045 710.255-710.374M1026.488 1422.748c0 242.116 196.24 438.39 438.316 438.39M1297.28 1150.763c-149.555 0-270.792 121.258-270.792 270.838M1297.28 1150.763c92.52 0 167.524 75.016 167.524 167.552M1361.535 1421.6a103.26 103.26 0 0 0 73.022-30.251 103.294 103.294 0 0 0 30.247-73.034M1361.535 1421.6a64.25 64.25 0 0 1-45.435-18.823 64.272 64.272 0 0 1-18.82-45.443"/><path d="M1337.44 1318.315a40.156 40.156 0 0 0-28.398 11.765 40.17 40.17 0 0 0-11.762 28.402M1337.44 1318.315c13.307 0 24.095 10.79 24.095 24.1M1345.471 1358.482c8.872 0 16.064-7.193 16.064-16.067"/><path d="M1345.472 1358.482a8.031 8.031 0 0 1-8.032-8.034M1345.472 1342.415a8.031 8.031 0 0 0-8.032 8.033M1659.634 2683.06c-634.339 0-1148.572-514.318-1148.572-1148.763M1221.318 823.923c-392.264 0-710.256 318.045-710.256 710.374"/><path d="M1659.633 1262.312c0-242.115-196.24-438.389-438.316-438.389M1388.841 1534.297c149.555 0 270.793-121.258 270.793-270.837M1388.841 1534.297c-92.52 0-167.523-75.015-167.523-167.552M1324.586 1263.46a103.26 103.26 0 0 0-73.022 30.252 103.294 103.294 0 0 0-30.246 73.033M1324.586 1263.46a64.25 64.25 0 0 1 45.435 18.823 64.272 64.272 0 0 1 18.82 45.443"/><path d="M1348.682 1366.745a40.156 40.156 0 0 0 28.397-11.764 40.17 40.17 0 0 0 11.762-28.402M1348.682 1366.745c-13.308 0-24.096-10.79-24.096-24.1M1340.65 1326.579c-8.872 0-16.064 7.193-16.064 16.066M1340.65 1326.579a8.031 8.031 0 0 1 8.032 8.033M1340.65 1342.645a8.031 8.031 0 0 0 8.032-8.033M2682 1024.367c0 634.338-514.319 1148.571-1148.763 1148.571M822.863 1462.683c0 392.263 318.045 710.255 710.374 710.255M1261.252 1024.367c-242.116 0-438.39 196.24-438.39 438.316M1533.237 1295.159c0-149.555-121.258-270.792-270.838-270.792M1533.237 1295.159c0 92.52-75.016 167.524-167.552 167.524M1262.4 1359.414a103.26 103.26 0 0 0 30.251 73.022 103.294 103.294 0 0 0 73.034 30.247M1262.4 1359.414a64.25 64.25 0 0 1 18.823-45.435 64.272 64.272 0 0 1 45.443-18.82"/><path d="M1365.685 1335.319a40.156 40.156 0 0 0-11.765-28.398 40.17 40.17 0 0 0-28.402-11.762"/><path d="M1365.685 1335.318c0 13.308-10.79 24.096-24.1 24.096M1325.518 1343.35c0 8.872 7.193 16.064 16.067 16.064M1325.518 1343.35a8.031 8.031 0 0 1 8.034-8.031M1341.585 1343.35a8.031 8.031 0 0 0-8.033-8.031"/></g></svg>'
    }
};

});

parcelRegister("5OyIv", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $43bc8d4782201fb4$export$f50a68e3694789ee);
const $43bc8d4782201fb4$export$f50a68e3694789ee = {
    align: 'start space-between',
    flow: 'x',
    gap: 'A',
    // The head never shrinks (the sheet law, ModalWindow.js): a long body
    // scrolls inside ModalBody, the title and the Close stay in view. Written
    // as the `flex` SHORTHAND on purpose: the windows plugin's Confirm / Alert /
    // Prompt templates make their ModalHeader the scroller with their own
    // `flex: 1 1 auto` (fw-wl, FW-MODALLAYER-DROPDOWNROOT-OVERFLOW-LAW-1), and
    // one key is replaced whole by theirs — a `flexShrink` longhand here would
    // race their shorthand by stylesheet order.
    flex: '0 0 auto',
    // The dialog title and its one-line subtitle (white-label spec §4.10): the
    // title a real h2 at `B` 700 in `title` ink, the subtitle `Z1` in
    // `inactive` — the quiet ink that holds 4.5:1 on the white and the gray3
    // sheet (7.4 / 6.4), matching the shared AppDialogHead hint. No eyebrow
    // slot here: AppDialogHead (workspace shared) renders its own mono
    // micro-label from an `eyebrow` prop, and a brand slot reading the same
    // prop would paint it twice in every AppDialog head.
    Hgroup: {
        flex: 1,
        H: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            // 600 doesn't exist in this face (see SectionHeader.js) — 700 it is.
            fontWeight: '700',
            lineHeight: '1.25',
            color: 'title'
        },
        P: {
            lineHeight: '1.5em',
            margin: 'X - -',
            fontSize: 'Z1',
            fontWeight: '400',
            maxWidth: 'I_default',
            color: 'inactive'
        }
    },
    Icons: {
        extends: 'NavbarButtonSet',
        padding: '0',
        margin: '-Y2 -Z1 - auto',
        // On a coarse pointer the close button grows a 6px tap slop (IconButton's
        // `:after`, inset tapSlop). Pulled in by Z1, its right edge sat 3.8px from
        // the window's edge inside a phone ModalWindow's `A` padding, so the slop
        // passed the edge and the window — a scroller — scrolled sideways by 2px
        // (measured on the workspace shell, 2026-10-06: 371 wide inside 369 at
        // 393). On a coarse pointer the group pulls in by Y, so the slop ends
        // inside the padding (6.1 + 6 <= 16). A mouse keeps the Z1 alignment.
        '@coarse': {
            marginRight: '-Y'
        },
        Close: {
            // THE house close affordance (CloseButton.js — one X, one size, for
            // every sidebar and modal, F2 2026-08-16). Explicit extends so the
            // NavbarButtonSet childExtends does not size this X like a navbar
            // icon; every `extends: 'ModalWindow'` gets it for free.
            extends: 'CloseButton',
            order: 10,
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('closeModal');
            }
        }
    }
};

});

parcelRegister("6cTCD", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $484f027cd2104517$export$cb540d8b0ef7906c);
// THE SHEET BODY — the one scroll container of a ModalWindow (overflow law
// §3b.3; the brand twin of the shared AppDialogBody). It takes the height the
// head and the foot leave (`flex: 1 1 auto`, `minHeight: 0` — without the zero
// a flex item never shrinks below its content, and the sheet would overflow
// instead), scrolls inside it, and contains its overscroll so a flick at the
// end never scrolls the page behind the veil.
//
//   extends: 'ModalWindow',
//   ModalHeader: { … },
//   ModalBody: { …the form, the list, the long text… },
//   ModalFooter: { CancelButton: {}, CheckButton: {} }
//
// Ring room: a scroll container clips what its children paint outside it —
// the 3px focus ring of a full-width field included. The body therefore
// reaches one `X` into the sheet's own padding and pads itself back by the
// same letter: the content sits exactly where it did and every ring keeps its
// room. One `X`, not the whole sheet padding: a sheet whose call site trims
// its padding (the phone sheet's `A`) must never find the body wider than
// itself.
const $484f027cd2104517$export$cb540d8b0ef7906c = {
    flow: 'y',
    gap: 'A',
    flex: '1 1 auto',
    minWidth: '0',
    minHeight: '0',
    overflow: 'auto',
    overscrollBehavior: 'contain',
    margin: '-X',
    padding: 'X'
};

});

parcelRegister("3JZvQ", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $2b954a324ed0c19e$export$519437715052e656);
const $2b954a324ed0c19e$export$519437715052e656 = {
    margin: '0 -X',
    order: 2,
    align: 'center space-between',
    // THE FOOT (the sheet law, ModalWindow.js): it never shrinks, so a long
    // body never scrolls the actions away, and its actions WRAP onto a second
    // row when the sheet is too narrow for them side by side — a capsule is
    // never pushed out of the sheet or cut at its edge (overflow law §3b.3).
    flexShrink: '0',
    flexWrap: 'wrap',
    gap: 'Z'
};

});

parcelRegister("cdxBm", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $8e50c386f45440c2$export$2ce376c2cc3355c8);
const $8e50c386f45440c2$export$2ce376c2cc3355c8 = {
    extends: [
        'Link',
        'IconButton'
    ],
    round: 'Z2',
    fontSize: 'A',
    // MenuItem extends IconButton for its interaction + geometry, but a menu
    // item is TEXT-first — most are built from `[{ text: 'Overview' }, …]` with
    // no icon at all. The framework's SquareButton (which IconButton extends)
    // ships `icon: 'smile'` as an authoring placeholder, and that default is
    // INHERITED, so every text-only menu item trailed a stray smiley. Opting out
    // of the placeholder here is what makes the inheritance correct: call sites
    // that genuinely want an icon still pass one, and the guard below then shows
    // the slot. (Guarding alone was not enough — `el.parent.icon` is truthy when
    // the inherited placeholder is what filled it.)
    icon: null,
    Icon: {
        show: (el)=>Boolean(el.parent.icon)
    },
    isActive: (el, s)=>{
        const { href: href } = el;
        if (href) {
            const activePage = el.getRootState().activePage;
            const hrefKey = el.call('isString', href) && href.slice(1);
            return activePage === hrefKey;
        }
    }
};

});

parcelRegister("jhaFU", function(module, exports) {

$parcel$export(module.exports, "ModalWindow", () => $e087e2ac1bdd0ad6$export$bb6ccfada3e7d0f7);
const $e087e2ac1bdd0ad6$export$bb6ccfada3e7d0f7 = {
    tag: 'section',
    state: {},
    // Baseline dialog semantics so assistive tech announces modals as dialogs and
    // treats the rest of the page as inert. (Full focus move-in/return + Tab trap
    // belong in the @symbo.ls/windows plugin — ticketed separately.) Static
    // values, so flat attributes (FA105); a consumer's function-valued
    // attribute (aria-labelledby) still goes in its own `attr: {}`.
    role: 'dialog',
    'aria-modal': 'true',
    tabindex: '-1',
    // The overlay SHEET (white-label spec §4.10, §6.2): the opaque `dialog`
    // surface, the sheet radius and the `overlay` elevation (ring + contact +
    // ambient). Every windows-plugin modal and the shared Modal window extend
    // this. It was the `modal` theme at an em `A` radius with no shadow.
    theme: 'dialog',
    shadow: 'overlay',
    padding: 'B',
    round: 'radiusSheet',
    gap: 'C',
    flow: 'column',
    // THE SHEET LAW (overflow law §3b.3, Nika 2026-09-26: "you should also fix
    // modals, dropdowns, widgets cutting ui and buttons and texts in
    // overflow"). The sheet is a flex column that never outgrows the viewport:
    // at most the viewport minus one `overlayGutter` on each side, in both
    // axes. Its head (ModalHeader) and its foot (ModalFooter) never shrink, so
    // a long form never scrolls them away; the body (ModalBody) is the ONE
    // scroll container — it takes the rest of the height and scrolls inside it.
    // `overflow: auto` on the sheet is the fallback for a sheet with no
    // ModalBody (every consumer written before the body existed): the whole
    // sheet scrolls, as it always did — nothing is cut. With a ModalBody the
    // sheet never overflows, so its own scrollbar never shows; the clip only
    // rounds the corners.
    overflow: 'auto',
    overscrollBehavior: 'contain',
    width: 'fit-content',
    height: 'fit-content',
    maxWidth: 'calc(100dvw - 2 * overlayGutter)',
    maxHeight: 'calc(100dvh - 2 * overlayGutter)',
    animationDuration: 'C',
    position: 'relative',
    ModalHeader: {}
};

});

parcelRegister("6dZA1", function(module, exports) {

$parcel$export(module.exports, "MultipleSelect", () => $4883b97660425496$export$f9938396555c8942);
const $4883b97660425496$export$f9938396555c8942 = {
    childExtends: 'IconText',
    theme: 'field',
    width: 'F2',
    flow: 'y',
    align: 'flex-start center',
    round: 'Z2',
    padding: 'Y X',
    overflow: 'auto',
    attr: {
        role: 'listbox',
        'aria-multiselectable': 'true'
    },
    '& svg': {
        opacity: 0
    },
    childProps: {
        width: '100%',
        // IconText's own default is `align: 'center center'` — alignItems AND
        // justifyContent both centered. On a full-width row that means every
        // option's icon+text pair floats centered in the middle of the row
        // instead of reading from a consistent left edge — a listbox is scanned
        // top-to-bottom expecting every label to start at the same x, and a
        // centered row visibly drifts left/right as label length changes between
        // options. `flex-start` keeps alignItems (vertical centering of the
        // icon against the text) and fixes the horizontal reading edge.
        align: 'center flex-start',
        gap: 'Z',
        padding: 'Z',
        cursor: 'pointer',
        attr: {
            role: 'option',
            'aria-selected': (el, s)=>String(!!el.selected)
        },
        // Show the check for selected rows independent of hover so keyboard/AT users
        // can perceive selection state, not just sighted pointer users.
        '.selected': {
            '& svg': {
                opacity: '1'
            }
        },
        Icon: {
            name: 'checkmark',
            opacity: '0'
        },
        ':hover': {
            '& svg': {
                opacity: '1'
            }
        }
    }
};

});

parcelRegister("36THD", function(module, exports) {

$parcel$export(module.exports, "ModalVideo", () => $243d2409dae05300$export$f728d2d975de966f);
const $243d2409dae05300$export$f728d2d975de966f = {
    state: {},
    boxSize: '100% 100%',
    zIndex: '10',
    position: 'fixed',
    // Was 'blur(15px)' — a third, off-scale blur magnitude next to the two
    // the rest of the codebase standardized on (blur(3px) / blur(35px),
    // designSystem/theme.js). Aligned to the "strong" tier for this
    // full-screen modal backdrop.
    backdropFilter: 'blur(35px)',
    '!activeVideo': {
        display: 'none'
    },
    ':after': {
        content: '""',
        position: 'absolute',
        inset: '0',
        zIndex: 1,
        theme: 'document',
        opacity: '.65'
    },
    onClick: (event, el, state)=>{
        el.call("closeModalVideo");
    },
    // THE house close (CloseButton.js — one X, one size, F2): a filled 36px
    // square circle on any ground. It was a hand-rolled IconButton with an em
    // padding and a D-size glyph.
    CloseButton: {
        position: 'absolute',
        top: 'A',
        right: 'A',
        zIndex: 2,
        onClick: (event, el, state)=>{
            el.call("closeModalVideo");
        }
    },
    Iframe: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        objectFit: 'fill',
        aspectRatio: '11 / 7',
        height: '65%',
        border: 'none',
        round: 'A',
        zIndex: 2,
        src: (el, s)=>{
            const withAutoplay = (url)=>{
                if (!url) return url;
                const join = url.includes("?") ? "&" : "?";
                return url + join + "autoplay=1&playsinline=1&controls=1&rel=0";
            };
            return withAutoplay(s.activeVideo);
        },
        allow: 'autoplay; fullscreen; picture-in-picture',
        allowFullscreen: true,
        '@tabletS': {
            minWidth: '90%',
            maxWidth: '90%'
        }
    }
};

});

parcelRegister("cPmzs", function(module, exports) {

$parcel$export(module.exports, "Navbar", () => $956bc18ee87b12bf$export$42cfbb80f7861e77);
const $956bc18ee87b12bf$export$42cfbb80f7861e77 = {
    position: 'sticky',
    top: '0',
    flow: 'x',
    zIndex: 9,
    align: 'center space-between',
    padding: 'Y X2',
    theme: 'canvas-card-glass',
    tag: 'aside'
};

});

parcelRegister("dtaGh", function(module, exports) {

$parcel$export(module.exports, "NavbarTooltip", () => $9ce644ca2b4f6a28$export$ee8c193ddbcd5287);
// DEPRECATED (2026-06-08 per Nika) — legacy per-Navbar tooltip surface.
// Superseded by the @symbo.ls/tooltip plugin: `NavbarButton` now extends
// `TooltipTrigger` and fires `openTooltip` against the single shell-mounted
// `TooltipRoot`. `Navbar` no longer mounts this, and `NavbarButton` no
// longer drives it via `setNavbarTooltipPosition`. Kept only so stray
// imports/mounts don't break; do NOT add new consumers.
const $9ce644ca2b4f6a28$export$ee8c193ddbcd5287 = {
    extends: 'TooltipHidden',
    top: '0',
    left: '0',
    theme: 'navbar',
    tooltipPosition: 'bottom',
    shapeDirection: 'top',
    padding: 'Y Z2',
    fontSize: 'Z2',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    minWidth: 'fit-content',
    lineHeight: 1,
    description: '',
    background: 'highlight-reversed',
    ':before': {
        color: 'highlight-reversed'
    },
    pointerEvents: 'none',
    Title: null,
    P: {
        color: 'highlight',
        fontSize: 'Z2'
    }
};

});

parcelRegister("cIcb2", function(module, exports) {

$parcel$export(module.exports, "NavbarButtonSet", () => $94130a33bce19550$export$6da660d5a2525971);
const $94130a33bce19550$export$6da660d5a2525971 = {
    childExtends: [
        'NavbarButton'
    ],
    gap: 'Y1',
    padding: '- Y1',
    width: 'fit-content',
    flow: 'row',
    align: 'center space-between'
};

});

parcelRegister("kRpYV", function(module, exports) {

$parcel$export(module.exports, "NavbarButton", () => $f2fce9493b6da6f7$export$7510fa6729d59c24);
// New tooltip pattern (2026-06-08 per Nika "use @symbo.ls/tooltip plugin …
// adapt Navbar and NavbarTooltip to new pattern"): hover tooltips now come
// from the plugin's `TooltipTrigger` — it fires `openTooltip` against the
// single shell-mounted `TooltipRoot` — instead of the legacy per-Navbar
// `NavbarTooltip` + imperative `setNavbarTooltipPosition` wiring (removed).
// The tooltip text is the `title` that consumers already pass, and the native
// browser title stays off so it does not double up with the plugin surface:
// both halves live in `TitleTooltipTrigger`, the one bridge every titled
// button shares.
const $f2fce9493b6da6f7$export$7510fa6729d59c24 = {
    // IconButton last: it adds the icon-button law (an icon-only navbar button is
    // a 36px square) while this component's own theme, radius and padding —
    // kept for the text variants, e.g. the zoom presets — still win.
    extends: [
        'CircleButton',
        'TitleTooltipTrigger',
        'IconButton'
    ],
    theme: 'navbarButton',
    position: 'relative',
    padding: 'Y2',
    round: 'C1',
    // iPad/touch: 44pt hit area (Apple HIG) via an invisible TAP-SLOP pseudo,
    // NOT size floors. The previous `minWidth/minHeight: 'C'` floors were
    // em-based, so inside compact-font surfaces (header islands, the canvas
    // composer) they computed to ~51px and inflated gauge-pinned chrome past
    // its 2.26rem pill height (iPad, 2026-08-01 per Nika "navbar looks
    // thick"); consumers then needed per-site opt-outs — two mechanisms for
    // one concern. The slop grows only the HIT area: visual size stays
    // token-natural everywhere, freestanding or inside an island, and no
    // consumer opt-outs exist. `tapSlop` is the fixed-px sizes token (see
    // designSystem/sizes.js for why px is the right unit here and how the
    // magnitude pairs with neighbor gaps). Coarse-pointer only; desktop is
    // unchanged.
    '@coarse': {
        ':after': {
            content: '""',
            position: 'absolute',
            inset: 'tapSlop'
        }
    },
    // Accessible-name bridge: an icon-only button that passes `title` and no
    // name of its own is announced by that title.
    //
    // It is a REACTIVE prop, not a one-shot `onRender` copy. The copy ran once and
    // then refused to touch an `aria-label` that already existed — so the name
    // was whatever the title said on the FIRST render. On a Georgian boot that is
    // English: the language chunk lands after the first paint, the `title`
    // effect re-runs and turns Georgian, and the copied name stayed English for
    // the life of the element (measured live 2026-09-22: `title="აკრეფაზე
    // დაბრუნება"` beside `aria-label="Back to typing"` on the same node; 19 such
    // names on one page). A function reads the same `title` inside its own effect,
    // so it follows the language, the state and a late bundle exactly as the
    // title does. A name the call site declares — flat, camelCase, inside
    // `aria: {}` or inside `attr: {}` — still wins: it replaces this prop, or is
    // mirrored by it.
    'aria-label': (el, s)=>{
        // Every shape a call site may have named the control in, then the title.
        // (A flat `'aria-label'` on the call site never reaches here: it replaces
        // this prop.) Mirroring them keeps the two writers of one attribute in
        // agreement, so neither can erase the other's name.
        const sources = [
            el.attr && el.attr['aria-label'],
            el.aria && el.aria.label,
            el.ariaLabel,
            el.title
        ];
        for (const source of sources){
            const value = typeof source === 'function' ? source(el, s, el.context) : source;
            if (value != null && value !== '') return value;
        }
        return null;
    }
};

});

parcelRegister("iI67T", function(module, exports) {

$parcel$export(module.exports, "TitleTooltipTrigger", () => $d9f116a34d103d15$export$7030df6b56ae2349);
// TitleTooltipTrigger — the house tooltip, fed by the `title` a call site
// already passes. Extend it beside the button base:
//
//   extends: ['CircleButton', 'TitleTooltipTrigger']
//
// No call-site sweep is needed: consumers keep passing `title`, the plugin's
// `TooltipTrigger` shows it on the single shell-mounted `TooltipRoot`, and the
// native browser tooltip stays off so the two surfaces never double up. Hosts
// without a `TooltipRoot` simply never receive `openTooltip`.
//
// It used to be a one-shot copy in `onRender`, pasted verbatim into each
// button that wanted it:
//
//   el.tooltipText = node.getAttribute('title')
//   node.removeAttribute('title')
//
// That froze the tooltip at what the title said on the FIRST render. An
// assignment replaces a custom prop with that static string, and `onRender`
// does not run again. On a Georgian boot the first render is English: the
// language chunk lands after the first paint, the `title` effect re-runs and
// turns Georgian, and the tooltip stayed English for the life of the element
// (measured live 2026-09-22: 55 controls on one page with a Georgian name
// beside an English tooltip). The same re-run wrote the native `title` back,
// so a Georgian user got both tooltips. The copy also overwrote a
// `tooltipText` the call site had declared itself.
const $d9f116a34d103d15$export$7030df6b56ae2349 = {
    extends: 'TooltipTrigger',
    // Read at SHOW time: the framework re-runs a function-valued custom prop on
    // every read, and `TooltipTrigger` reads `el.tooltipText` when the tooltip
    // opens. So the text follows the language, the state and a late bundle
    // exactly as the title does. A `tooltipText` on the call site replaces this.
    tooltipText: (el, s)=>{
        const title = el.title;
        return typeof title === 'function' ? title(el, s, el.context) : title;
    },
    // The native `title` comes off on the first paint here. A reactive `title`
    // writes the attribute again whenever its sources change (a language switch,
    // a late bundle), and nothing re-runs `onRender` then — a component may not
    // take it off in a handler (FA507), and `title` belongs to the call site. The
    // surface that REPLACES the native tooltip is the plugin's `TooltipTrigger`,
    // and since smbls 6096dc0a6 it takes the attribute off on `mouseover`,
    // `focusin` and at open time (tests/brand/titleTooltipFollowsTitle.test.mjs).
    // The accessible name does not depend on the attribute either way: the
    // button bases derive `aria-label` from the declared `title` prop.
    onRender: (el)=>{
        if (el.node) el.node.removeAttribute('title');
    }
};

});

parcelRegister("iO4ER", function(module, exports) {

$parcel$export(module.exports, "NativeSelect", () => $db10827f6804a07a$export$907fa30a18334a59);
const $db10827f6804a07a$export$907fa30a18334a59 = {
    tag: 'select',
    background: 'highlight',
    // reversed, not `title` — this is an INK surface, so the foreground has to
    // invert with it. `title` would be near-black text on the near-black
    // light-mode `highlight`.
    color: 'highlight-reversed',
    width: 'F3',
    padding: 'Y B2 Y A',
    border: 'none',
    outline: 'none',
    children: [
        {
            text: 'about'
        },
        {
            text: 'contact'
        },
        {
            text: 'market research'
        },
        {
            text: 'Recruiting Partner'
        },
        {
            text: 'Recruiting'
        },
        {
            text: 'Recruiting'
        },
        {
            text: 'Refer a Friend'
        }
    ],
    childExtends: {
        tag: 'option'
    }
};

});

parcelRegister("31vTL", function(module, exports) {

$parcel$export(module.exports, "NumbCaptionArticleSmall", () => $233a356f6f9bd1a2$export$5e3237e2d9664dcc);
const $233a356f6f9bd1a2$export$5e3237e2d9664dcc = {
    extends: 'Hgroup',
    gap: 'X',
    H: {
        extends: 'NumbCaption',
        tag: 'strong',
        margin: '0',
        gap: '0',
        text: null,
        Numb: {
            width: 'A2'
        }
    },
    P: {
        margin: '0 - 0 A2'
    }
};

});

parcelRegister("aZyHJ", function(module, exports) {

$parcel$export(module.exports, "NavigationArrows", () => $800a856cbd8d6df4$export$e7e09ea052ba52d);
const $800a856cbd8d6df4$export$e7e09ea052ba52d = {
    gap: 'Z',
    childProps: {
        round: '100%'
    },
    childExtends: 'IconButton',
    children: [
        {
            attr: {
                'aria-label': 'Previous'
            },
            Icon: {
                name: 'chevronLeft'
            }
        },
        {
            attr: {
                'aria-label': 'Next'
            },
            Icon: {
                name: 'chevronRight'
            }
        }
    ]
};

});

parcelRegister("3vsUy", function(module, exports) {

$parcel$export(module.exports, "NumbCaptionArticleBig", () => $28dab17aa719148f$export$c63c869ef496b44c);
const $28dab17aa719148f$export$c63c869ef496b44c = {
    extends: 'Hgroup',
    gap: 'X2',
    H: {
        extends: 'NumbCaption',
        tag: 'strong',
        text: null,
        // Numb had no fixed width, so its column was exactly as wide as the
        // rendered digits ("01" ≈ 18.9px) plus NumbCaption's own `gap: 'Z'`
        // (≈10.5px) before the heading text — a combined ≈29.4px indent that
        // `P`'s hand-picked `A2` padding (≈23.5px) did not match, measured 5.9px
        // short of where the heading text actually starts. Pinning the column to
        // a fixed token (same move as the Small sibling) makes the indent
        // computable instead of a coincidence.
        Numb: {
            width: 'A2'
        }
    },
    P: {
        // `A2` (Numb's width) + `Z` (NumbCaption's Numb-to-Text gap) — the exact
        // distance from the left edge to where the heading TEXT starts, so P
        // lines up with "Design system", not with the numeral column.
        padding: '0 0 0 A2+Z'
    }
};

});

parcelRegister("hKah5", function(module, exports) {

$parcel$export(module.exports, "NumericBulletin", () => $ceaeb3daf48c5150$export$ced53f051015807c);
const $ceaeb3daf48c5150$export$ced53f051015807c = {
    extends: 'NumbCaption',
    align: 'flex-start',
    Numb: {
        color: 'currentColor',
        opacity: '0.5'
    },
    Text: {
        fontWeight: '400'
    }
};

});

parcelRegister("fMu6Z", function(module, exports) {

$parcel$export(module.exports, "OptionToggle", () => $b7d2b2413e1be7b7$export$7d3ab7529747f512);
const $b7d2b2413e1be7b7$export$7d3ab7529747f512 = {
    extends: 'SwitchFieldWithCaption',
    // Was a 1px top border separating stacked toggle rows in a settings list
    // (hairline-as-separator, banned by design-direction.md §8 — "no row
    // hairlines inside rounded sections"). SwitchFieldWithCaption's own hover
    // feedback (':hover > caption') plus this row's padding is separation
    // enough without a stroke.
    padding: 'B1 - -',
    cursor: 'pointer',
    onChange: (ev, el)=>{
        const { key: key } = el;
        const val = ev.target.checked;
        el.setUserSettings(key, val, {
            message: `Set ${key} settings to ${val}`
        });
    },
    Input: {
        checked: (el)=>el.getUserSettings(el.parent.key)
    },
    Caption: {},
    QuestionMarkTooltip: {
        margin: 'X auto - X',
        Icon: {},
        TooltipHidden: {
            description: ({ parent: parent })=>parent.tip
        }
    },
    SwitchField: {}
};

});

parcelRegister("ajSre", function(module, exports) {

$parcel$export(module.exports, "NumericTip", () => $7835e806eae82637$export$82837ec4103f0600);
const $7835e806eae82637$export$82837ec4103f0600 = {
    extends: 'QuickTip',
    gap: 'Z',
    tag: 'nav',
    IconText: {
        icon: 'magicstar'
    },
    Flex: {
        flow: 'y',
        gap: 'X',
        Title: null,
        P: null,
        childrenExtends: 'NumericBulletin'
    }
};

});

parcelRegister("2YiV4", function(module, exports) {

$parcel$export(module.exports, "PasswordField", () => $229fdc65ca0afaef$export$65ed9482db2257fa);
const $229fdc65ca0afaef$export$65ed9482db2257fa = {
    extends: 'InputField',
    position: 'relative',
    state: {
        passwordVisible: false,
        brandPasswordLabel_en: 'Password',
        brandPasswordPlaceholder_en: 'Enter password',
        brandPasswordShow_en: 'Show password',
        brandPasswordHide_en: 'Hide password'
    },
    Title: {
        text: '{{ brandPasswordLabel | polyglot }}'
    },
    Input: {
        placeholder: (el)=>el.call('polyglot', 'brandPasswordPlaceholder'),
        'aria-label': (el)=>el.call('polyglot', 'brandPasswordLabel'),
        type: (el, s)=>s.passwordVisible ? 'text' : 'password',
        minHeight: 'controlH',
        round: 'radiusControl',
        padding: 'Z1 C Z1 A'
    },
    IconButton: {
        type: 'button',
        position: 'absolute',
        bottom: 'W',
        right: 'Y',
        icon: (el, s)=>s.passwordVisible ? 'eyeClosed' : 'eyeOpen',
        'aria-label': (el, s)=>el.call('polyglot', s.passwordVisible ? 'brandPasswordHide' : 'brandPasswordShow'),
        'aria-pressed': (el, s)=>Boolean(s.passwordVisible),
        // The 36px square comes from the icon-button law (IconButton.js).
        theme: null,
        color: 'inactive',
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            s.update({
                passwordVisible: !s.passwordVisible
            }, {
                preventContentUpdate: true
            });
        }
    }
};

});

parcelRegister("db0ds", function(module, exports) {

$parcel$export(module.exports, "ProjectTab", () => $997c78543c31238d$export$bad920a8c2e755c0);
const $997c78543c31238d$export$bad920a8c2e755c0 = {
    extends: [
        'Link'
    ],
    gap: 'Z',
    position: 'relative',
    align: 'center center',
    redirect: true,
    fallbackRoute: '/dashboard',
    Avatar: {
        extends: [
            'Avatar',
            'Clickable'
        ],
        src: (el, s)=>{
            var _a;
            return s.icon && ((_a = s.icon) == null ? void 0 : _a.src) || "https://assets.symbo.ls/logo-colorful.png";
        },
        text: '{{ title }}',
        fontSize: 'A',
        round: 'Z2',
        boxSize: 'D2'
    },
    Text: {
        fontWeight: '400',
        color: 'title',
        fontSize: 'A',
        width: '175%',
        top: '110%',
        left: '50%',
        textAlign: 'center',
        transform: 'translate3d(-50%, 0, 1px)',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        text: '{{ title }}'
    }
};

});

parcelRegister("9OLU8", function(module, exports) {

$parcel$export(module.exports, "NumbCaption", () => $725df1609b75304f$export$238749d86ff415c);
const $725df1609b75304f$export$238749d86ff415c = {
    align: 'center flex-start',
    gap: 'Z',
    Numb: {
        fontWeight: '400',
        opacity: '0.65',
        color: 'paragraph'
    },
    Text: {
        fontWeight: '500'
    }
};

});

parcelRegister("dqhDm", function(module, exports) {

$parcel$export(module.exports, "PackageFeatureItem", () => $9c5b61c7a4cef175$export$b705323d4bb53148);
const $9c5b61c7a4cef175$export$b705323d4bb53148 = {
    tag: 'label',
    flex: 0.24,
    cursor: 'pointer',
    Input: {
        display: 'none',
        type: 'checkbox',
        // Was `outline: '1.5px solid electricBlue'` — a colored outline swap,
        // stacking two banned defects: the outlined-card habit (design-
        // direction.md §8) and a colored selection accent ("selection is
        // monochrome"). `electricBlue` (color.js) is also a fixed,
        // non-adaptive literal, same defect class fixed elsewhere in this
        // package (LayerSimple.js, DragNdropUser.js). `selected` is the
        // house monochrome state-fill token (['gray2.08', 'white.1']) — a
        // solid ink fill, no stroke, no hue.
        ':checked + hgroup': {
            background: 'selected'
        }
    },
    Hgroup: {
        width: '100%',
        padding: 'A1',
        round: 'A1',
        // Was `outline: '1.5px solid line'` — the outlined-card habit
        // design-direction.md §8 bans by name, and it directly contradicted
        // this site's own published "focus contract" law on /accessibility:
        // components never re-implement focus with an outline shorthand.
        // Fix: separation by fill contrast instead. NOT the same `common-box`
        // token BrandComponentCell.Stage uses — this card renders AS Stage's
        // own direct child on /components, so matching its exact token would
        // be an invisible same-color fill on top of itself. `common-box-
        // secondary` is the next tonal step, built for this nested case.
        theme: 'common-box-secondary',
        Icon: {
            order: '-1',
            margin: '- - A2',
            name: 'logov2'
        }
    }
};

});

parcelRegister("3mf5Q", function(module, exports) {

$parcel$export(module.exports, "PathnameBreadcrumb", () => $271f225b794581ae$export$88a2e5f39c946767);
const $271f225b794581ae$export$88a2e5f39c946767 = {
    extends: 'Breadcrumb'
};

});

parcelRegister("dTyAa", function(module, exports) {

$parcel$export(module.exports, "Partner", () => $a1db3cbe49bdf2a9$export$7f6c1cc9c842c5ab);
const $a1db3cbe49bdf2a9$export$7f6c1cc9c842c5ab = {
    extends: 'Picture',
    height: '1em',
    transition: 'opacity B, filter B',
    align: 'center center',
    '@mobileL': {
        margin: '0'
    },
    '@dark': {
        filter: 'grayscale(100%)',
        ':hover': {
            filter: 'grayscale(0%)',
            opacity: '1'
        }
    },
    '@light': {
        filter: 'grayscale(100%)',
        ':hover': {
            filter: 'grayscale(0%)',
            opacity: '.9'
        }
    },
    margin: '0',
    Img: null,
    Div: {
        align: 'center center',
        height: '1em',
        '& svg': {
            minHeight: '1em'
        },
        html: (el)=>el.parent?.src
    }
};

});

parcelRegister("bELJp", function(module, exports) {

$parcel$export(module.exports, "QuickTip", () => $87c87496b04b4cbc$export$51e46e7d69cf7de7);
const $87c87496b04b4cbc$export$51e46e7d69cf7de7 = {
    extends: [
        'Notification'
    ],
    display: 'inline-flex',
    cursor: 'default',
    theme: null,
    background: 'yellow.1',
    color: 'yellow 1 -35',
    align: 'flex-start',
    margin: '0 -X2',
    alignSelf: 'flex-start',
    // `minWidth` on a letter token is a HARD floor: the component can never
    // shrink below it, so it overflows any container narrower than that —
    // a split pane, a narrow column, a small viewport. The intent is a
    // PREFERRED width, which is `width` + `maxWidth: '100%'`: same size when
    // there is room, shrinks instead of overflowing when there is not.
    width: 'G',
    maxWidth: '100%',
    IconText: {
        opacity: '0.65',
        order: '-1',
        margin: 'W',
        icon: 'questionMark'
    },
    Hgroup: {
        H: {
            text: 'Spread across document'
        },
        P: {
            text: 'Explanation simply deeply'
        }
    }
};

});

parcelRegister("cWryu", function(module, exports) {

$parcel$export(module.exports, "PromptTextarea", () => $96c046b596aecdb7$export$a21bf8a7580d70aa);
const $96c046b596aecdb7$export$a21bf8a7580d70aa = {
    boxSize: 'E2 I1+C',
    maxWidth: '100%',
    minHeight: 'E2',
    overflow: 'hidden',
    position: 'relative',
    theme: 'field',
    round: 'B',
    '@tabletM': {
        boxSize: 'E2 I'
    },
    '@tabletS': {
        boxSize: 'E2 100%'
    },
    transition: 'B background defaultBezier',
    '@mobileL': {
        boxSize: 'F1 100%'
    },
    // THE LEADING SLOT. DOMQL mounts children in the merged object's key order
    // and the extended component's keys come first, so a composer extending
    // this one cannot put anything BEFORE Textarea on its own. `Prefix` holds
    // the first place, empty: `null` renders no node and adds no gap. A
    // consumer fills it (the composer's mode chip) and gets DOM order = screen
    // order = Tab order: chip, textarea, actions. Never CSS `order` for this:
    // Tab order would then differ from the screen.
    // (tests/brand/promptTextareaPrefix.test.mjs)
    Prefix: null,
    Textarea: {
        minWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
        theme: 'transparent',
        placeholder: '"How can I create single sign on?"',
        fontSize: 'A1',
        padding: 'A2 A2 - B',
        border: 'none',
        borderWidth: '0',
        borderStyle: 'none',
        '@mobileL': {
            padding: 'B B - B'
        },
        '@mobileM': {
            padding: 'D B - B',
            textAlign: 'center',
            lineHeight: '1.3em'
        }
    },
    Flex: {
        position: 'absolute',
        top: 'A1',
        right: 'B1',
        gap: 'B',
        '@mobileL': {
            right: 'B',
            gap: 'A2'
        },
        '@mobileM': {
            right: 'A1',
            top: 'A'
        },
        childExtends: 'IconButton',
        childProps: {
            padding: 'X',
            theme: 'transparent'
        },
        children: [
            {
                Icon: {
                    name: 'upload'
                }
            },
            {
                Icon: {
                    name: 'chevronUp'
                }
            }
        ]
    },
    Button: {
        text: 'Create a feature',
        position: 'absolute',
        padding: 'Z2 C+X1',
        right: 'A1',
        bottom: 'A1',
        flow: 'row-reverse',
        gap: 'Y2',
        theme: 'blackWhite',
        // 600 is banned by the brand language (DESIGN_LANGUAGE §D8): the register
        // is {400, 500, 700}, system Helvetica Neue has no 600 face and the
        // browser silently snaps it to 700 anyway.
        fontWeight: '700',
        '@mobileM': {
            minWidth: '90%',
            maxWidth: '90%',
            right: '50%',
            transform: 'translate(50%, 0)'
        },
        // Was `chevronUp` rotated 45deg with a hand-tuned negative margin to
        // compensate for the rotation shifting its bounding box. `chevronUp`'s
        // SVG (designSystem/icons.js) is an open 3-point path with `fill:
        // currentColor` — browsers auto-close an open FILLED path with a
        // straight line back to its start, so it paints as a solid triangular
        // wedge, not a two-stroke chevron outline. Rotating a solid wedge 45deg
        // does not read as a "send" arrow, it reads as an unrecognizable blob
        // (confirmed in a rendered screenshot). The design system already ships
        // a purpose-built `send` icon (a feather paper-plane glyph that already
        // points up-and-right) — use it directly; no rotation or compensating
        // margin needed.
        Icon: {
            name: 'send'
        }
    }
};

});

parcelRegister("i5eUj", function(module, exports) {

$parcel$export(module.exports, "QuickStartNumber", () => $d2a441e9b728de2a$export$4368d004ab7c4966);
const $d2a441e9b728de2a$export$4368d004ab7c4966 = {
    width: '1ch',
    text: '1',
    fontSize: 'I1_default',
    lineHeight: '1',
    color: 'black.0',
    display: 'inline',
    fontWeight: '900',
    margin: '0',
    textStroke: '1px gray6',
    userSelect: 'none',
    '@tabletL': {
        margin: 'W 0 0 0'
    },
    '@light': {
        textStroke: '1px gray11'
    }
};

});

parcelRegister("87xoB", function(module, exports) {

$parcel$export(module.exports, "RangeFieldWithTitle", () => $5e98e1e858efbc90$export$2e692472ecf7c282);
const $5e98e1e858efbc90$export$2e692472ecf7c282 = {
    extends: 'GroupField',
    Title: {},
    RangeField: {
        padding: 'X2 0'
    }
};

});

parcelRegister("45ShX", function(module, exports) {

$parcel$export(module.exports, "RangeFieldWithTitleAndIcon", () => $2fb1bd9fa6d30a77$export$a8cca174f32b21c4);
const $2fb1bd9fa6d30a77$export$a8cca174f32b21c4 = {
    extends: 'GroupField',
    tag: 'section',
    Title: {},
    RangeFieldWithIcon: {}
};

});

parcelRegister("8cMV9", function(module, exports) {

$parcel$export(module.exports, "RangeField", () => $5f95645b396927f8$export$b322c47b2525bd34);
const $5f95645b396927f8$export$b322c47b2525bd34 = {
    extends: 'RangeWithButtons',
    align: 'center space-between',
    padding: 'X2',
    round: 'Y2',
    gap: 'Y',
    IconButton_minus: {
        round: 'Y1'
    },
    Value: {
        tag: 'span',
        fontSize: 'Z'
    },
    Range: {
        ':hover': {
            '::-webkit-slider-thumb': {
                borderColor: 'cerulean'
            }
        },
        '::-webkit-slider-thumb': {
            borderColor: 'blue'
        }
    },
    IconButton_plus: {
        round: 'Y1'
    }
};

});

parcelRegister("ajzZf", function(module, exports) {

$parcel$export(module.exports, "Scrollable", () => $782797fb4db585cb$export$fcc7818a78919c8c);
const $782797fb4db585cb$export$fcc7818a78919c8c = {
    flow: 'x',
    gap: 'C',
    maxWidth: '100%',
    overflowY: 'auto',
    '::-webkit-scrollbar': {
        display: 'none'
    },
    '@mobileL': {
        padding: 'A B B B',
        scrollSnapType: 'x mandatory',
        scrollPadding: 'B'
    }
};

});

parcelRegister("c52hb", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $8cb7b7aef6956f6c$export$b94867ecbd698f21);
const $8cb7b7aef6956f6c$export$b94867ecbd698f21 = {
    tag: 'label',
    align: 'center flex-start',
    gap: 'X',
    // A search field is a FIELD: the `field` plate at rest, hover and focus,
    // the same theme its Input atom paints. The button theme it wore
    // (`quaternary`) inverts to a dark plate on a light hover: the hint read
    // 1.67:1 and the value 1:1 there.
    theme: 'field',
    round: 'Y',
    padding: '0 0 0 Z1',
    cursor: 'pointer',
    width: '12.8125em',
    // A bare fixed `width` is the same HARD FLOOR as a `minWidth` letter token —
    // in a container narrower than 12.8125em the pill itself overflows instead
    // of shrinking. `maxWidth: '100%'` keeps the preferred width when there is
    // room and caps it otherwise (same fix already applied to SelectDropdown,
    // DropdownField, SelectField, etc. — eac1ef3).
    maxWidth: '100%',
    height: '2.25em',
    Icon: {
        name: 'search outline'
    },
    Input: {
        border: 'none',
        flex: 1,
        // Was unbounded: typed/placeholder text longer than the pill's own width
        // rendered with the native default (`overflow: clip`, `text-overflow:
        // clip`) — the tail of the text is simply cut off mid-character with no
        // ellipsis, which reads as broken rather than intentionally truncated.
        // `minWidth: 0` lets the flex item actually shrink to the ellipsis point
        // instead of pushing the pill wider than its own declared width.
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        background: 'transparent',
        color: 'paragraph',
        padding: '0',
        outline: 'none'
    }
};

});

parcelRegister("2qs06", function(module, exports) {

$parcel$export(module.exports, "RangeWithButtons", () => $1c43bad594e681e9$export$94c40b3709c521a9);
const $1c43bad594e681e9$export$94c40b3709c521a9 = {
    align: 'center',
    gap: 'Y',
    deps: {
        returnPropertyValue: (el, property, def)=>{
            const val = el[property] ?? (el.state && el.state[property]);
            if (el.call("isFunction", val)) return val(el, el.state);
            if (val === void 0 || val == null) return def ?? 0;
            return val;
        }
    },
    IconButton_minus: {
        icon: 'minus',
        theme: 'field',
        attr: {
            'aria-label': 'Decrease'
        },
        onClick: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onDecrease)) el.parent.onDecrease(ev, el.parent, s);
            else {
                const value = parseFloat(s.value);
                const min = el.parent.deps.returnPropertyValue(el.parent, "min", 1);
                const step = el.parent.deps.returnPropertyValue(el.parent, "step", 1);
                if (value > min) {
                    const decimalPlaces = (step.toString().split(".")[1] || "").length;
                    const newValue = Number((value - step).toFixed(decimalPlaces));
                    el.lookup("Range").node.value = newValue;
                    s.update({
                        value: newValue
                    });
                }
            }
        }
    },
    Value: {
        tag: 'span',
        minWidth: '4ch',
        text: (el, s)=>{
            const unit = el.parent.deps.returnPropertyValue(el.parent, "unit", "");
            return `${s.value ?? s.defaultValue ?? 0}${unit}`;
        }
    },
    Range: {
        attr: {
            value: (el, s)=>parseFloat(s.value ?? s.defaultValue),
            min: (el)=>el.parent.deps.returnPropertyValue(el.parent, "min", 0),
            max: (el)=>el.parent.deps.returnPropertyValue(el.parent, "max", 100),
            step: (el)=>el.parent.deps.returnPropertyValue(el.parent, "step", 1),
            disabled: (el)=>el.parent.deps.returnPropertyValue(el.parent, "disabled", false)
        },
        onInput: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onInput)) el.parent.onInput(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        onChange: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onChange)) el.parent.onChange(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        }
    },
    IconButton_plus: {
        theme: 'field',
        icon: 'plus',
        attr: {
            'aria-label': 'Increase'
        },
        onClick: (ev, el, s)=>{
            if (el.call("isFunction", el.parent.onIncrease)) el.parent.onIncrease(ev, el.parent, s);
            else {
                const value = parseFloat(s.value);
                const max = el.parent.deps.returnPropertyValue(el.parent, "max", 100);
                const step = el.parent.deps.returnPropertyValue(el.parent, "step", 1);
                if (value < max) {
                    const decimalPlaces = (step.toString().split(".")[1] || "").length;
                    const newValue = Number((value + step).toFixed(decimalPlaces));
                    el.lookup("Range").node.value = newValue;
                    s.update({
                        value: newValue
                    });
                }
            }
        }
    }
};

});

parcelRegister("6sah2", function(module, exports) {

$parcel$export(module.exports, "SectionAddButton", () => $4b2d53c639f97f7d$export$7d8ce3aad1b54570);
const $4b2d53c639f97f7d$export$7d8ce3aad1b54570 = {
    extends: [
        'Link',
        'MenuItem'
    ],
    ignoreChildExtends: true,
    icon: 'plus',
    // The Link -> MenuItem -> IconButton -> SquareButton chain carries
    // `aspectRatio: '1/1'`, meant for a lone icon-only glyph button (SquareButton
    // also sets `boxSize: 'fit-content fit-content'`, so both axes size to
    // content — the ratio is what then forces height to match). This is a TEXT
    // button ("Add section" + a trailing icon): once the label forces the
    // fit-content WIDTH well past a bare icon's, the inherited 1:1 ratio drags
    // HEIGHT up to match that same, now much larger, width. Measured: 134.6 x
    // 134.6px for a single 21px line of text — a technically-symmetric (equal
    // padding on every side) but wildly oversized square. A text button needs
    // its natural aspect, not a forced square.
    aspectRatio: 'auto'
};

});

parcelRegister("erSkt", function(module, exports) {

$parcel$export(module.exports, "Scrollbar.scrollable", () => $a84dbaf0b914cdf9$export$1d0e64c2af7fee0b);
const $a84dbaf0b914cdf9$export$1d0e64c2af7fee0b = {
    extends: 'Scrollbar',
    minWidth: '100%',
    maxWidth: '100%',
    TrackContainer: {
        // Drag-to-scroll — the thumb (Track) is a pure output of onFrame
        // (reads Scrollable's scroll position, writes width/transform back),
        // so dragging needs its own input path. Mirrors the established
        // pointer-capture drag idiom (workspace/packages/workspace/app.js
        // ResizeHandle: declarative onPointerDown/Move/Up/Cancel +
        // el.node.setPointerCapture, no document-level addEventListener,
        // no el.node property writes — FA503/FA511-clean) rather than the
        // older imperative document.addEventListener style. Transient drag
        // state lives on `el` itself, never on root (framework convention —
        // see AppAssistant ResizeHandle for the same pattern).
        cursor: 'grab',
        touchAction: 'none',
        ':active': {
            cursor: 'grabbing'
        },
        onPointerDown: (e, el)=>{
            if (e.button !== 0) return;
            const scrollable = el.lookup('Scrollable');
            if (!scrollable?.node) return;
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = scrollable.node;
            const maxScroll = scrollWidth - clientWidth;
            if (maxScroll <= 0) return;
            const ratio = clientWidth / scrollWidth;
            const travelPx = el.node.clientWidth * (1 - ratio);
            if (travelPx <= 0) return;
            e.preventDefault();
            if (el.node?.setPointerCapture && e.pointerId != null) try {
                el.node.setPointerCapture(e.pointerId);
            } catch (_) {}
            el._scrollDragPointerId = e.pointerId;
            el._scrollDragStartX = e.clientX;
            el._scrollDragStartLeft = scrollLeft;
            el._scrollDragMaxScroll = maxScroll;
            el._scrollDragTravelPx = travelPx;
        },
        onPointerMove: (e, el)=>{
            if (el._scrollDragPointerId == null || e.pointerId !== el._scrollDragPointerId) return;
            const scrollable = el.lookup('Scrollable');
            if (!scrollable?.node) return;
            const deltaPx = e.clientX - el._scrollDragStartX;
            const next = el._scrollDragStartLeft + deltaPx * (el._scrollDragMaxScroll / el._scrollDragTravelPx);
            scrollable.node.scrollTo({
                left: Math.max(0, Math.min(el._scrollDragMaxScroll, next))
            });
        },
        onPointerUp: (e, el)=>{
            if (el._scrollDragPointerId == null || e.pointerId !== el._scrollDragPointerId) return;
            if (el.node?.releasePointerCapture) try {
                el.node.releasePointerCapture(e.pointerId);
            } catch (_) {}
            el._scrollDragPointerId = null;
        },
        onPointerCancel: (e, el)=>{
            el._scrollDragPointerId = null;
        },
        Track: {
            background: 'overlay',
            onFrame: (el)=>{
                const scrollable = el.lookup('Scrollable');
                if (!scrollable?.node) return;
                const node = scrollable.node;
                const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = node;
                if (!clientWidth || !scrollWidth) return;
                const ratio = clientWidth / scrollWidth;
                const maxScroll = scrollWidth - clientWidth;
                const scrollOffset = maxScroll > 0 ? scrollLeft / maxScroll * (100 - ratio * 100) : 0;
                el.setNodeStyles({
                    width: `${ratio * 100}%`,
                    transform: `translateX(${scrollOffset}%)`
                });
                const scrollBar = el.lookup('Scrollbar');
                if (scrollBar?.node) scrollBar.node.style.display = clientWidth >= scrollWidth ? 'none' : '';
            }
        }
    },
    NavigationArrows: {
        childProps: {
            theme: 'field',
            onClick: (ev, el)=>{
                const node = el.lookup('Scrollable')?.node;
                if (!node) return;
                const isLeft = el.key === '0';
                node.scrollBy({
                    left: isLeft ? -(node.clientWidth * 0.65) : node.clientWidth * 0.65,
                    behavior: 'smooth'
                });
            },
            Icon: {}
        }
    }
};

});

parcelRegister("jOofb", function(module, exports) {

$parcel$export(module.exports, "SelectDropdown", () => $e6c57e2d833cb109$export$124e49603add0284);
// THE SELECT-ONLY LISTBOX (WAI-ARIA APG "collapsible dropdown listbox";
// defect fix 2026-09-24). It was a <button> (DropdownField) with the panel
// INSIDE it and every option a <button> too — a button inside a button,
// invalid HTML, read as nested unnamed controls — and it opened on CSS
// :hover alone (the framework DropdownParent): no aria-expanded, no keyboard.
//
// Now:
//   * the ROOT is a <div> that keeps the field look (DropdownField: the
//     `field` theme, the 44px `controlH` floor, the control radius) and its
//     decorative parts — StartButtons / Value / Buttons stay DIRECT children,
//     so every consumer override of `SelectDropdown.Value` still lands;
//   * `Trigger` is the ONE button: full-area over the field, aria-haspopup
//     "listbox", aria-expanded, aria-controls → the listbox, named by the
//     field's Title (when the select sits in SelectDropdownWithTitle) and the
//     current Value (aria-labelledby);
//   * `Dropdown` — the panel — is a SIBLING of the trigger, never inside it;
//     its list is the `role="listbox"`, the rows are `role="option"` <div>s
//     with aria-selected, focusable in turn (tabindex -1);
//   * the panel shows by a CSS rule keyed on the trigger's aria-expanded, so
//     the announced state and the painted state are one fact;
//   * the keyboard and the choose path are brand functions
//     (functions/selectDropdown.js): ArrowUp/ArrowDown, Home/End, Enter/Space,
//     Escape (focus returns to the trigger), Tab, typeahead.
// Guarded by tests/brand/selectListboxPattern.test.mjs.
const $e6c57e2d833cb109$export$124e49603add0284 = {
    extends: 'DropdownField',
    tag: 'div',
    isSelectRoot: true,
    position: 'relative',
    // The field keeps its focus fill while focus is on the trigger or inside
    // the open list (the root itself never takes focus).
    ':focus-within': {
        background: 'var(--theme-field-focus-background)',
        color: 'var(--theme-field-focus-color)'
    },
    // DISABLED: a consumer disables the select on its root (`disabled`, a
    // value or a function — InterfaceLanguageField locks the language this
    // way); the root is a <div>, so the TRIGGER takes it (below), and the field
    // paints the `field-disabled` pair while its trigger is disabled — the
    // disabled law, never opacity.
    '&:has(> button:disabled)': {
        background: 'var(--theme-field-disabled-background)',
        color: 'var(--theme-field-disabled-color)',
        cursor: 'not-allowed'
    },
    // Open → the panel shows at once (visibility leaves the transition, so an
    // option can take focus in the same turn); closed → it fades as before.
    '&:has(> button[aria-expanded="true"]) > [dropdown]': {
        opacity: '1',
        visibility: 'visible',
        transform: 'translate3d(0, 0, 0)',
        transitionProperty: 'transform, opacity'
    },
    // Focus left the select (a click outside, Shift+Tab away) → close.
    onFocusout: (ev, el)=>{
        const next = ev && ev.relatedTarget;
        if (next && el.node && el.node.contains(next)) return;
        el.call('selectDropdownSet', false);
    },
    Value: {
        id: (el)=>'sd-' + el.parent.getPath().join('-') + '-value'
    },
    Trigger: {
        tag: 'button',
        type: 'button',
        state: {
            open: false
        },
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%',
        // The control floor, DECLARED: it covers the 44px field by geometry, and
        // the house control law reads every button's declared min-height — the
        // workspace admin page law flagged it "none" (3.14.796).
        minHeight: 'controlH',
        margin: '0',
        padding: '0',
        borderWidth: '0',
        appearance: 'none',
        background: 'transparent',
        round: 'radiusControl',
        cursor: 'pointer',
        ariaHaspopup: 'listbox',
        ariaExpanded: (el, s)=>String(!!s.open),
        // The root's `disabled` (a value, or a function run against the root and
        // its state) — a disabled button takes no click and no focus, so a
        // locked select cannot open.
        disabled: (el)=>{
            const d = el.parent.disabled;
            return d === undefined || d === null ? false : !!el.call('exec', d, el.parent);
        },
        ':disabled': {
            cursor: 'not-allowed'
        },
        ariaControls: (el)=>'sd-' + el.parent.getPath().join('-') + '-list',
        ariaLabelledby: (el)=>{
            const own = 'sd-' + el.parent.getPath().join('-') + '-value';
            const title = el.parent.parent && el.parent.parent.Title;
            return title && title.node ? 'sd-' + title.getPath().join('-') + ' ' + own : own;
        },
        onClick: (ev, el)=>el.call('selectDropdownSet'),
        onKeydown: (ev, el)=>el.call('selectDropdownKeydown', ev)
    },
    Dropdown: {
        // Was a duplicate `width` key (`'F3'` immediately shadowed by `'100%'`
        // below — a `frank`-flagged dead literal from an earlier pass, harmless
        // since the later key always won, but dead code). The panel should be
        // exactly as wide as its trigger button, so `100%` is the one real
        // value; `maxWidth: '100%'` guards it against ever exceeding that even
        // if an ancestor gives it more room.
        maxWidth: '100%',
        left: '0',
        width: '100%',
        top: '110%',
        // NO header by default: the brand DropdownHeader's own text is the
        // placeholder "Dropdown title", and every select that set none showed it
        // (InterfaceLanguageField, the design-system weight select). The field's
        // Title already names the list; a consumer that wants a header sets
        // `DropdownHeader: { text }`.
        DropdownHeader: null,
        ListInDropdown: {
            // The listbox is the LIST, not the panel: the panel also holds the
            // header, and a listbox owns options only. A <div>, not the list's
            // default <nav> — a navigation landmark cannot sit between a listbox
            // and its options.
            tag: 'div',
            role: 'listbox',
            id: (el)=>'sd-' + el.parent.parent.getPath().join('-') + '-list',
            ariaLabelledby: (el)=>{
                const root = el.parent.parent;
                const title = root.parent && root.parent.Title;
                return title && title.node ? 'sd-' + title.getPath().join('-') : 'sd-' + root.getPath().join('-') + '-value';
            },
            childProps: {
                align: 'center flex-start',
                // NO `text:` — the row chassis (KeyValueColumnFields) prints the
                // label in its own `Text` slot (`s.text || s.value || s.key`). A
                // `text: '{{ key }}'` here added the KEY as a second text node, so
                // every option read its code first: "en English", "ka ქართული"
                // (workspace language list, dev aeb80fc01, 2026-09-24).
                //
                // An OPTION, not a button: a <div> (the chassis inherits the Button
                // atom's <button> and its `type`), focusable in turn.
                tag: 'div',
                type: null,
                role: 'option',
                tabindex: '-1',
                // SELECTED = the one truth the row already paints. A consumer that
                // marks its chosen row with `isActive` (the workspace language
                // fields read the root language) is followed exactly — the TabsLink
                // form, `exec` takes the function or its value. Without one, the
                // option is selected when ITS identity (`key` for an object option,
                // `value` for a plain one) equals the SELECT's chosen value, the row
                // state's parent. It compared the row's key with the row's own
                // `value ?? active`, which an option never carries, so no row was
                // ever selected (language list, dev aeb80fc01, 2026-09-24). Every
                // source is read on every run (FA515).
                ariaSelected: (el, s)=>{
                    const p = s.parent || {};
                    const value = p.value;
                    const active = p.active;
                    const own = s.key !== undefined ? s.key : s.value;
                    const marked = el.isActive !== undefined ? el.call('exec', el.isActive, el) : undefined;
                    if (marked !== undefined) return String(!!marked);
                    const chosen = value !== undefined ? value : active;
                    return String(chosen !== undefined && own === chosen);
                },
                // The chosen row is painted by the same fact it is announced by.
                '&[aria-selected="true"]': {
                    fontWeight: '500',
                    background: 'selected',
                    color: 'title'
                },
                // Keyboard focus reads like the pointer: the hover wash (+ the house
                // focus ring from reset.js, which covers [role="option"]).
                ':focus-visible': {
                    background: 'hover',
                    color: 'title'
                },
                onClick: (ev, el)=>el.call('selectDropdownChoose', ev),
                onKeydown: (ev, el)=>el.call('selectDropdownKeydown', ev)
            },
            children: (el, s)=>el.parent.options || s.list,
            childrenAs: 'state'
        }
    }
};

});

parcelRegister("1f8qV", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $0e7dbbd572347438$export$8adb256d999cd5a0);
const $0e7dbbd572347438$export$8adb256d999cd5a0 = {
    tag: 'header',
    gap: 'B',
    align: 'start space-between',
    flow: 'y',
    margin: '0 0 B1',
    Article: {
        extends: 'ArticleSmall',
        flow: 'column',
        flex: 1,
        Title: {
            // 600 is banned by the brand language (DESIGN_LANGUAGE §D8): the product
            // register is {400, 500, 700}, system Helvetica Neue has no 600 face, and
            // the browser silently snaps it to 700 anyway — so this declared a weight
            // that does not exist and rendered as the one below.
            fontWeight: '700',
            show: ({ parent: parent })=>parent.parent.title,
            text: ({ parent: parent, state: state })=>parent.parent.title || state.title
        },
        P: {
            lineHeight: '1.5em',
            margin: 'X - -',
            fontWeight: '400',
            maxWidth: 'I_default',
            color: 'paragraph',
            show: ({ parent: parent })=>parent.parent.p,
            text: ({ parent: parent, state: state })=>parent.parent.p || state.p
        }
    },
    Nav: {
        // Was `flow: 'row-reverse'` with no wrap policy. `row-reverse` is a
        // right-alignment trick that also reverses reading order, and once the
        // items exceed one line the wrapped rows fill from the right, so the nav
        // scrambled and collided with the paragraph above it. `align`'s second
        // slot right-aligns without touching order, and an explicit wrap lets the
        // nav reflow in reading order in a narrow column.
        flow: 'x',
        align: 'center end',
        wrap: 'wrap',
        rowGap: 'Z',
        fontSize: 'A2',
        gap: 'A',
        childProps: {
            scrollToTop: false
        },
        childExtends: [
            'MenuItem'
        ],
        // `Toggle` used to be a named sibling key declared alongside this
        // `children` factory. A named object key co-declared with an array-form
        // `children` on the SAME element is silently dropped by the renderer —
        // `renderChildren`'s array branch (smbls/packages/element/src/create.js)
        // only ever walks the `children` array, it never revisits the element's
        // own remaining keys — so the toggle button never rendered at all
        // (confirmed live: Nav's only DOM children were the 3 nav-item buttons,
        // keyed "0"/"1"/"2" — no "Toggle" anywhere). Folded into the SAME array
        // as an explicitly-keyed entry so it actually materialises, as the
        // trailing element of the same nav row (same bug class, same fix shape,
        // as AccessCodeField's dropped hidden mirror input — see that component).
        //
        // `ignoreChildExtends` + an explicit `extends: 'IconButton'` both matter
        // here: without them this array entry would (a) inherit this Nav's own
        // `childExtends: 'MenuItem'`, wrong for a collapse toggle (MenuItem pulls
        // in Link's navigation semantics, not appropriate for a non-navigating
        // button), and (b) key-auto-extend the framework's UNRELATED
        // `default-config/components/Input/Toggle.js` — a checkbox-style ON/OFF
        // switch — since the bare key "Toggle" independently matches that
        // registered component name.
        children: ({ state: state })=>[
                ...state.nav || [],
                {
                    key: 'Toggle',
                    extends: 'IconButton',
                    ignoreChildExtends: true,
                    if: ({ state: state })=>// eslint-disable-next-line no-undefined
                        state[state.__element.key] || state.toggleShow !== void 0,
                    isActive: ({ state: state })=>!state.toggleShow,
                    Icon: {
                        name: ({ state: state })=>`arrowAngle${state.toggleShow ? 'Up' : 'Down'}`
                    },
                    onClick: (event, element, state)=>{
                        state.update({
                            toggleShow: !state.toggleShow
                        });
                    }
                }
            ]
    }
};

});

parcelRegister("dWOOq", function(module, exports) {

$parcel$export(module.exports, "QuestionMarkTooltip", () => $a2781b69c49e8532$export$c3a1d7b797848fed);
// The (?) help affordance.
//
// TWO PASSES, BOTH ON 2026-09-10, AND THEY FIX DIFFERENT THINGS. This header
// is about the REVEAL — whether the panel opens at all, for whom, and how it
// closes. The panel's own SHAPE — its measure, its spacing, its type, its ink
// and its edge guard — is designed at the `TooltipHidden` block near the
// bottom of this file, under "THE PANEL". Read that one for anything about
// width, padding or colour; nothing here decides those.
//
// Until 2026-09-10 this rendered a bare `div`, so
// NO keyboard user could reach ANY help tooltip in the product: the framework
// `TooltipParent` gates the panel on `':hover, &:focus-visible'`, and a div
// with no tabindex can never match `:focus-visible`. Measured on the emitted
// sheet — the rule reads
//   @media (hover: hover) { ._x:hover [tooltip], ._x:focus-visible [tooltip] { … } }
// so the reveal was ALSO behind `(hover: hover)`, i.e. dead on every coarse
// pointer as well. Two whole input classes, no help.
//
// The root is now a real `<button type="button">` and the panel's visibility
// is STATE-driven (root state `helpTooltipOpenId`, one open tip at a time)
// instead of CSS-hover-driven, because a CSS-only reveal cannot satisfy WCAG
// 1.4.13 "Dismissible" — Escape has to close the panel WITHOUT moving focus,
// and no `:hover`/`:focus-visible` rule can be talked out of matching.
//
// HOW THE REVEAL REACHES THE DOM (rewritten 2026-09-10, second pass).
// The first pass drove the reveal from `'.isShown'` / `'!isShown'` case
// blocks and read `s.root.helpTooltipOpenId` with no declared dependency.
// That shipped as brand 3.14.786 and was DEAD on the real product shell:
// measured live on vault.pr (build f6ce7c87), a real hover wrote the root key
// but the panel's inline style stayed `opacity: 0; visibility: hidden` and
// `aria-expanded` stayed `"false"` forever. Root cause, measured, not guessed:
// `'helpTooltipOpenId' in root.state` was FALSE after a cold load, i.e. the
// signal store never even held a lazy placeholder for the key. A conditional
// block's effect subscribes only to what its predicate READS during the
// effect's first run; that first run happened before the key existed and
// before `s.root` could hand back a trackable signal, so both effects ended
// with ZERO sources — and an effect with no sources is never notified again
// (smbls/packages/element/src/create.js, registerConditionalEffects: "Bailing
// first would end the effect's very first run with ZERO tracked sources, and
// an effect with no sources is never notified again"). Every later write went
// to a signal nobody was listening to. Nothing threw, nothing warned.
//
// The fix is the framework's own remedy for exactly this shape: a reactive
// CSS-prop factory plus a declared `<propName>Deps` array. The framework
// reads every selector in that array FIRST, unconditionally, inside the
// factory's own effect — which is what installs the lazy signal for a key
// that does not exist yet (store.js creates one whenever a reactive effect is
// observing) and therefore what subscribes this element to every future
// write. Same reason `ariaDeps` is declared for `aria.expanded` below.
// Verified live by injecting this definition into the running shell next to
// the dead 3.14.786 instance: `'helpTooltipOpenId' in root` flipped to true
// at mount, and a plain `root.update({ helpTooltipOpenId: id })` opened the
// injected panel and flipped its `aria-expanded` while the shipped instance
// beside it stayed shut.
//
// Pointer geometry is unchanged on purpose. `--spacing-A` is `1em`, so the
// whole component (icon box, panel padding, panel `width: F1`) scales off the
// root's font-size — and a UA `<button>` ships `font: 400 13.333px Arial`,
// which would have shrunk every one of them by ~22%. The `inherit` block
// below hands the box back exactly what the `div` had.
const $a2781b69c49e8532$export$c3a1d7b797848fed = {
    extends: 'TooltipParent',
    tag: 'button',
    type: 'button',
    // THE SQUARE (Nika 2026-09-26: "all icon buttons should have 1/1 aspect
    // ratio"; DESIGN-WL-D1-QMARK-TRIGGER-SQUARE-1). The (?) is an annotation on
    // the row, so its square is the GLYPH's own box, not a control height: a
    // flex box that fits its glyph (the Icon is `A` x `A`, 1em of the row), the
    // glyph centred, never smaller than `A` either way. It was a display:block
    // box round an inline svg — the glyph's 1em wide by the row's 1.5 line box
    // tall (17 x 25.5 in a 17px row), the glyph parked on the text baseline —
    // and every row that held a (?) grew to that line box (the home widget
    // header had to override it back to 1em). `fit-content`, not `auto`: a flex
    // row that stretches its items cannot stretch this one out of square, and
    // a call site that enlarges its glyph (SettingsSection's `A2` refresh icon)
    // gets a square that grows with it. Round, so the house focus ring (a
    // box-shadow, reset.js) hugs the round glyph. Never squeezed.
    // The tooltip panel parks at 112% of THIS box, so its gap is now the same
    // 0.12em + Y under every (?) (it followed each row's line height before).
    display: 'flex',
    align: 'center center',
    width: 'fit-content',
    height: 'fit-content',
    minWidth: 'A',
    minHeight: 'A',
    round: '50%',
    flexShrink: '0',
    // UA button-box neutralisation — see the font-size note above.
    background: 'none',
    border: 'none',
    padding: '0',
    appearance: 'none',
    color: 'inherit',
    font: 'inherit',
    letterSpacing: 'inherit',
    textAlign: 'inherit',
    textTransform: 'inherit',
    textIndent: 'inherit',
    cursor: 'pointer',
    margin: 'X auto - X',
    // Non-reactive per-instance slot for the tap-toggle bookkeeping below.
    // Declared (not assigned in a lifecycle hook) because `el.scope` does not
    // exist until the component declares it — measured, 2026-09-10.
    scope: {
        wasOpen: false
    },
    // Keyboard focus lifts the same way hover does (TooltipParent only raises
    // it inside `@media (hover: hover)`). The RING itself is the house one —
    // brand reset.js paints `button:focus-visible` with the `focusRing` shadow
    // token (DESIGN_LANGUAGE §8.2, "one ring, globally"), which this element
    // now qualifies for by being a real button. Nothing is restated here.
    ':focus-visible': {
        zIndex: 1000,
        '& svg': {
            opacity: '1'
        }
    },
    // Rule 65 — the resting/hover pair is DECLARED here, not left to a call
    // site. It is a separate key from `':hover, &:focus-visible'` on purpose:
    // `TooltipParent.onInit` does `Object.assign(el, { ':hover, &:focus-visible':
    // {...} })`, which REPLACES that exact key. Writing the two states as two
    // keys is what keeps both this rule and the framework's reveal alive.
    ':hover': {
        '& svg': {
            opacity: '1'
        }
    },
    // THE HIT AREA is an invisible slop pseudo, never a bigger box — the house
    // pattern, identical to IconButton and NavbarButton. A fine pointer gets
    // one `X` round the glyph square (~25 x 25 in a 17px row, more than the
    // 17 x 25.5 line box it replaces); a coarse pointer gets the house
    // `tapSlop` (see designSystem/sizes.js for why px is the right unit there).
    // Visual size is untouched, so nothing moves (Rule 66).
    ':after': {
        content: '""',
        position: 'absolute',
        inset: '-X'
    },
    '@coarse': {
        ':after': {
            content: '""',
            position: 'absolute',
            inset: 'tapSlop'
        }
    },
    // One id, derived from the element's own path, used in three places: the
    // panel's `id`, this button's `aria-describedby`, and the open-state
    // comparison. Declared once here and read with `el.call('exec', …)` so the
    // three can never drift.
    helpTipId: (el)=>'help-tip-' + el.getPath().join('-').replace(/[^A-Za-z0-9_-]/g, ''),
    aria: {
        // A NAME for the control. `ariaLabel` wins; otherwise the help copy
        // itself, so a screen-reader user tabbing a page of (?) buttons hears
        // twenty DIFFERENT names instead of twenty "More information"s. Pass
        // `ariaLabel` when the copy is long enough that hearing it as both the
        // name and the description is noise.
        label: (el, s)=>el.call('exec', el.ariaLabel, el) || el.call('exec', el.tip, el) || 'More information',
        describedby: (el, s)=>el.call('exec', el.helpTipId, el),
        expanded: (el, s)=>s.root.helpTooltipOpenId === el.call('exec', el.helpTipId, el) ? 'true' : 'false'
    },
    // Arms the subscription for `aria.expanded`. Without it the attribute is
    // written once at create and never again on any consumer whose root state
    // does not already declare the key — measured on the product shell, where
    // `aria-expanded` stayed `"false"` through every open. `ariaDeps` is the
    // per-sub-key map form the framework reads for nested `aria.X` factories.
    ariaDeps: {
        expanded: [
            (el, s)=>s.root.helpTooltipOpenId
        ]
    },
    onMouseenter: (e, el, s)=>s.root.update({
            helpTooltipOpenId: el.call('exec', el.helpTipId, el)
        }),
    // Don't yank the panel away from a keyboard user just because a pointer
    // happened to cross the icon and leave again.
    onMouseleave: (e, el, s)=>{
        if (el.node && el.node.matches(':focus')) return;
        s.root.update({
            helpTooltipOpenId: null
        });
    },
    onFocus: (e, el, s)=>s.root.update({
            helpTooltipOpenId: el.call('exec', el.helpTipId, el)
        }),
    onBlur: (e, el, s)=>s.root.update({
            helpTooltipOpenId: null
        }),
    // Tap toggles — but ONLY on a touch pointer. A mouse or pen has already
    // opened the panel through `onMouseenter`/`onFocus` before the click ever
    // lands, so a blind toggle CLOSED the tip the same gesture had just opened:
    // measured on the shell, hover → open, then one full click → shut, which
    // reads to a tester as "clicking the (?) does nothing". A coarse pointer
    // has no hover and iOS Safari does not focus a button on tap, so there the
    // toggle is the only way to dismiss and it stays. `el.scope` is the
    // non-reactive per-instance slot for exactly this.
    onPointerdown: (e, el, s)=>{
        el.scope.wasOpen = e.pointerType === 'touch' && s.root.helpTooltipOpenId === el.call('exec', el.helpTipId, el);
    },
    onClick: (e, el, s)=>{
        const id = el.call('exec', el.helpTipId, el);
        s.root.update({
            helpTooltipOpenId: el.scope.wasOpen ? null : id
        });
        el.scope.wasOpen = false;
    },
    // Enter and Space synthesise a click on a native button, and `onPointerdown`
    // never runs for them, so the click above sees `wasOpen === false` and
    // OPENS. That is deliberate: focus already opened the tip, Enter/Space
    // re-assert it, and Escape is the one and only close key. A toggle here
    // made the first Enter close what focus had opened.
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Escape') return;
        // WCAG 1.4.13 Dismissible — close WITHOUT moving focus. Only swallow the
        // key when this tip actually owned the open state, so Escape still
        // reaches a dialog/menu above us when no tip is open.
        if (s.root.helpTooltipOpenId !== el.call('exec', el.helpTipId, el)) return;
        e.stopPropagation();
        s.root.update({
            helpTooltipOpenId: null
        });
    },
    // The HOVER half of WCAG 1.4.13 Dismissible. A panel opened by hover leaves
    // focus wherever it was, so no `keydown` ever reaches this button and the
    // handler above can never fire — measured on the shell: hover a (?), press
    // Escape, the panel stays up because the key went to `document.body`.
    // This listener catches that case. It does NOT stop propagation: the
    // element-level handler above owns the focused path, and a hover dismissal
    // must not swallow an Escape that a dialog or a menu is also waiting for.
    onDocumentKeydown: (e, el, s)=>{
        if (e.key !== 'Escape') return;
        if (s.root.helpTooltipOpenId !== el.call('exec', el.helpTipId, el)) return;
        if (el.node && el.node.matches(':focus')) return;
        s.root.update({
            helpTooltipOpenId: null
        });
    },
    // Tap-outside dismissal for the touch path, where no blur arrives.
    // Declared, not `document.addEventListener` — DOMQL owns the teardown.
    onDocumentPointerdown: (e, el, s)=>{
        const id = el.call('exec', el.helpTipId, el);
        if (s.root.helpTooltipOpenId !== id) return;
        if (el.node && el.node.contains(e.target)) return;
        s.root.update({
            helpTooltipOpenId: null
        });
    },
    // THE GLYPH. Its box is `1em` of whatever the row inherits — measured 17x17
    // beside the 33px Decisions title, which is the right proportion: the (?) is
    // an annotation on the row, not a sibling of the heading. It fills the
    // button's square (THE SQUARE, above); the HIT area is grown by the slop
    // pseudo, never by the box, so the glyph itself stays small.
    //
    // `.35` was invisible. Measured on the deployed shell: `inactive` (gray10 on
    // the dark scheme) at 35% over the page ground reads under 1.6:1, i.e. below
    // the 3:1 WCAG 1.4.11 floor for a control's own graphic. `.5` clears it and
    // still reads as secondary; the hover/focus rules below take it to full
    // strength, which is the Rule 65 half this primitive never had — the panel
    // opening was its ONLY feedback, and a hover that changes nothing on the
    // glyph reads as a dead pixel until the panel arrives.
    Icon: {
        color: 'inactive',
        opacity: '.5',
        name: 'questionMark fill'
    },
    // ── THE PANEL ─────────────────────────────────────────────────────────────
    //
    // Nika 2026-09-10: "fix tooltips width and spacing on (?) (for example for
    // decisions)". MEASURED on the deployed staging shell (f6ce7c87e, brand
    // 3.14.786) on the Decisions page head, 1600x807, dark:
    //
    //   panel            75.39 x 283.3 px   — a column of one or two words,
    //                                         twelve lines deep
    //   width rule       width: F1, max-width: 100%, min-width: D2
    //   body copy        12.55px, gray6 on the panel ground = 2.60:1
    //   padding          8.3 / 13.6 px      line-height 1.5
    //
    // Three separate defects produced that box, and each is fixed on its own
    // line below: a percentage cap measured against a 17px containing block, a
    // hard `min-width` floor that became the used width, and a font-size that
    // was multiplied three times over.
    //
    // ── 1. TYPE: ONE SIZE, ABSOLUTE ──────────────────────────────────────────
    // `fontSize: 'tooltipText'` (designSystem/sizes.js) is `0.8333rem` — the `Z`
    // step of the type scale resolved against the DOCUMENT root instead of the
    // parent. Everything else on this panel is em-based and therefore now
    // resolves against ONE known size (14.17px at the 17px base) in every
    // consumer, instead of against whatever the trigger inherited. That is what
    // makes the padding, the gap and the width cap below mean the same thing on
    // a page head, in a widget header and in a settings row.
    //
    // The framework's `P` re-multiplied by `Z2` (0.936em) on top of that; it is
    // pinned to `A` here. One panel, one text size (Rule 34).
    //
    // ── 2. WIDTH: CONTENT-DRIVEN, CAPPED AT A READING MEASURE ────────────────
    // `width: 'max-content'` + a `max-width` cap is the shrink-to-fit behaviour
    // an out-of-flow panel actually wants: a three-word tip is three words wide,
    // a sentence wraps at the cap. Plain `width: fit-content` (the framework's)
    // resolves "available" against the CONTAINING BLOCK, which for a (?) is the
    // 17px button — that is the 75px sliver.
    //
    // The cap is `G1` = 22.177em = 314px at this panel's own size, ~44 characters
    // per line, and it is `min()`-ed with 92vw so it can never exceed the screen.
    // `minWidth: 'min-content'` replaces the framework's `D2` letter floor: a
    // letter floor is a HARD px number that overflowed every narrow container
    // (it is what the 75px width actually was — the panel collapsed ONTO its
    // floor); `min-content` is the longest word, so the panel can never break a
    // word and can never be wider than it needs.
    //
    // ── 3. GROUND AND INK: A PAIR, NOT A BLACK CHIP ──────────────────────────
    // The framework paints `background: 'black'` with `theme: 'dialog'` ink and
    // a `gray6` body — a theme-INVARIANT chip whose body copy measures 2.84:1 on
    // the light scheme and 2.60:1 on the dark one (measured live, both fail the
    // 4.5:1 floor; FW-TOOLTIP-PANEL-UNREADABLE-ON-LIGHT-THEME-1 is only the
    // light half of it). This panel owns its tokens instead: `overlayStrong` and
    // `title` are both `[light, dark]` pairs, so the panel is an elevated
    // surface of the CURRENT scheme and its ink follows.
    //
    // Named colour tokens, not `theme: 'dialog-elevated'`: a theme name emits
    // `color` AND `background` as two atomic classes of equal specificity, so an
    // explicit `color` beside it wins or loses on emission order. Measured on
    // the tenant, `--theme-dialog-elevated-color` is a FLAT `rgba(241,241,243)`
    // (white ink) while its background is a proper pair — a white-on-white light
    // panel waiting to happen. Two paired colour tokens have no such seam.
    TooltipHidden: {
        id: (el, s)=>el.call('exec', el.parent.helpTipId, el.parent),
        role: 'tooltip',
        shapeDirection: 'bottom',
        title: null,
        fontSize: 'tooltipText',
        lineHeight: '1.45',
        width: 'max-content',
        minWidth: 'min-content',
        maxWidth: 'min(var(--spacing-G1), 92vw)',
        overflowWrap: 'break-word',
        padding: 'Z1 A',
        gap: 'Y',
        textAlign: 'left',
        round: 'radiusControl',
        background: 'overlayStrong',
        color: 'title',
        shadow: 'overlay',
        // The framework's `P` carries `fontSize: 'Z2'` and `color: 'gray6'`; both
        // are overridden, not restated. `caption` is the house ink for secondary
        // prose and is a pair — 11.7:1 dark, 11.8:1 light on this ground.
        P: {
            fontSize: 'A',
            color: 'caption'
        },
        // Only reachable when a consumer passes a `title`; `gray12` would be a
        // theme-invariant grey on a paired ground.
        Title: {
            color: 'currentColor'
        },
        // Default the copy to the parent's `tip`, so a consumer can pass one
        // prop. A consumer that sets `description` itself still wins (own props
        // beat the extends chain) — every existing call site keeps working.
        description: (el, s)=>el.call('exec', el.parent.tip, el.parent),
        isShown: (el, s)=>s.root.helpTooltipOpenId === el.call('exec', el.parent.helpTipId, el.parent),
        // The reveal, the settled offset and the edge guard — one reactive `style`
        // factory, so all three land as INLINE style and beat the framework's
        // hover rule in BOTH directions, including "Escape while the pointer is
        // still on the icon", which a CSS-only reveal can never honour.
        // `styleDeps` is what keeps it alive: see the header note.
        //
        // THE GAP. `TooltipHidden.onInit` parks the panel at `112%` of the
        // CONTAINING BLOCK, so the real gap is a percentage of whatever that block
        // happens to be — measured 3.06px under the Decisions (?) and a different
        // number under every other trigger. One `Y` token is added on whichever
        // side the panel opens, so the gap is the same everywhere (~8.5px there)
        // and the panel clears its own shadow.
        //
        // THE EDGE GUARD. A panel centred on a 17px glyph hangs half its width to
        // each side; at 314px wide that is 157px, and a (?) less than that from
        // the app's edge pushes the panel off it. The shift is computed from the
        // panel's own UNSHIFTED box (the closed branch never clamps, so every open
        // measures from the same origin) and applied in CSS, where the edge gutter
        // stays a token: `clamp(A - slackLeft, 0, slackRight - A)` is zero while
        // there is room, and otherwise exactly the overflow plus one `A`.
        //
        // It runs ONLY when the (?) itself is the containing block. A consumer
        // that supplies a wider positioned ancestor — the workspace widget header
        // makes itself `position: relative` so the panel centres in the CARD — has
        // already told us where the panel may live, and a second opinion measured
        // against the viewport would drag it back out of that box.
        //
        // Written longhand rather than through a module-scope helper: frank
        // serialises a factory as SOURCE TEXT, and a call to a helper that is not
        // in the re-evaluated scope throws on the platform runtime.
        style: (el, s)=>{
            const dir = el.shapeDirection;
            const side = dir === 'left' || dir === 'right';
            if (!el.isShown) return {
                opacity: '0',
                visibility: 'hidden',
                transform: el.transform || (side ? 'translate3d(0%,-50%,0)' : 'translate3d(-50%,0,0)')
            };
            if (side) return {
                opacity: '1',
                visibility: 'visible',
                transform: dir === 'left' ? 'translate3d(calc(-1 * var(--spacing-Y)),-50%,0)' : 'translate3d(var(--spacing-Y),-50%,0)'
            };
            const node = el.node;
            const trigger = el.parent && el.parent.node;
            let x = '-50%';
            if (node && trigger && node.offsetParent === trigger) {
                // THE FRAME IS WALKED, NOT ASKED FOR. `el.getRoot()` is the documented
                // way to reach the app element and it returns UNDEFINED on the product
                // shell — measured live on vault.pr, 2026-09-10, on this very element:
                // `typeof el.getRoot === 'function'` yet `el.getRoot() === undefined`,
                // so the whole guard silently did nothing while every jsdom assertion
                // stayed green. That is the same shape of failure D6 chased (green
                // locally, dead on the shell), and the remedy is to depend on nothing
                // the framework has to hand back: walk up from the trigger to the
                // outermost element and measure THAT. No globals, no `document.`
                // lookup, no root registry.
                let frameNode = trigger;
                while(frameNode.parentElement && frameNode.parentElement.parentElement)frameNode = frameNode.parentElement;
                const frame = frameNode.getBoundingClientRect();
                if (frame.width) {
                    const box = node.getBoundingClientRect();
                    x = 'calc(-50% + clamp(calc(var(--spacing-A) - ' + Math.round(box.left - frame.left) + 'px), 0px, calc(' + Math.round(frame.right - box.right) + 'px - var(--spacing-A))))';
                }
            }
            return {
                opacity: '1',
                visibility: 'visible',
                transform: 'translate3d(' + x + ',' + (dir === 'bottom' ? 'calc(-1 * var(--spacing-Y))' : 'var(--spacing-Y)') + ',0)'
            };
        },
        styleDeps: [
            (el, s)=>s.root.helpTooltipOpenId
        ]
    }
};

});

parcelRegister("lnBbc", function(module, exports) {

$parcel$export(module.exports, "SelectField", () => $f908961147412648$export$d55b50a564d0b931);
const $f908961147412648$export$d55b50a564d0b931 = {
    extends: 'DropdownField',
    // A <div>, not DropdownField's <button>: the native <select> below is the
    // ONE control. A button around it nested one interactive element in
    // another and put two tab stops on one field (2026-09-24).
    tag: 'div',
    // `minWidth` on a letter token is a HARD floor: the component can never
    // shrink below it, so it overflows any container narrower than that —
    // a split pane, a narrow column, a small viewport. The intent is a
    // PREFERRED width, which is `width` + `maxWidth: '100%'`: same size when
    // there is room, shrinks instead of overflowing when there is not.
    width: 'E3',
    maxWidth: '100%',
    // A select is a field: a rounded rect, not a capsule (DESIGN_LANGUAGE
    // §6.2). Was the em letter `C1`.
    round: 'radiusControl',
    padding: '0',
    position: 'relative',
    Dropdown: null,
    Value: null,
    Buttons: {
        position: 'absolute',
        right: 'Z',
        // The chevron had `right` but no vertical anchor, so it fell to the
        // absolute box's static position (the top of the field) and landed ON TOP
        // of the selected value instead of beside it. Centre it on the field's
        // own axis so it tracks any control height.
        top: '50%',
        transform: 'translateY(-50%)',
        align: 'center center',
        pointerEvents: 'none',
        // A11Y-1 item 2: this chevron is pure decoration — the wrapper is
        // pointerEvents:'none' and clicks fall through to the native <select> —
        // yet it rendered as an UNNAMED <button> in the accessibility tree
        // (screen readers announced an unlabeled, inoperable control; it also
        // sat in the tab order). Demote-not-label: a label would advertise a
        // control that cannot be operated. aria-hidden removes it from the
        // tree; tabindex -1 removes it from the tab order (an aria-hidden
        // element that can still receive focus is its own violation).
        // Cross-app blast radius: every SelectField consumer in every app
        // inherits this — that is the point of fixing it here once.
        'aria-hidden': 'true',
        Arrow: {
            theme: 'transparent',
            tabindex: '-1',
            // eslint-disable-next-line no-restricted-syntax -- dropdown chevron glyph, not text
            color: 'inactive',
            icon: 'arrow angle down'
        }
    },
    Select: {
        outline: 'none',
        border: 'none',
        background: 'transparent',
        color: 'currentColor',
        // Right padding must clear the absolutely-positioned chevron, which is
        // out of flow and therefore reserves no space of its own — long values ran
        // straight underneath it. `C` ≈ the chevron box plus its `right: Z` inset.
        padding: 'Z1 C Z1 A2',
        round: 'radiusControl',
        // The height floor sits on the native control, so the <select> fills
        // the whole painted field (the root has no padding of its own).
        minHeight: 'controlH',
        width: '100%',
        appearance: 'none',
        // A UNIQUE id per instance, from the field's own key path (the
        // QuestionMarkTooltip form), so a <label for> reaches ITS select; a
        // consumer that needs a fixed id sets `Select.id`. The form `name` is the
        // consumer's (`Select.name`) — no default, no attribute without one. Both
        // were the literal 'user' on every SelectField: two on one page shared an
        // id and a name, and a label's `for` reached the first (2026-09-24).
        id: (el)=>'select-' + el.parent.getPath().join('-').replace(/[^A-Za-z0-9_-]/g, ''),
        onChange: (ev, el, s, ctx2)=>{
            if (el.parent.onChange) {
                ev.stopPropagation();
                return el.parent.onChange(ev, el, s, ctx2);
            }
        },
        children: (el)=>el.call('exec', el.parent.options, el),
        childrenAs: 'props',
        childProps: {
            tag: 'option',
            attr: {
                selected: (el, s)=>el.node.value === s.visibility
            }
        }
    }
};

});

parcelRegister("lT6Yq", function(module, exports) {

$parcel$export(module.exports, "SectionHeaderWithNav", () => $fef424d24cabbf87$export$9c92103a71b9ac77);
// Was a byte-for-byte re-declaration of SectionHeader's `Article: {}` (a
// no-op) plus a whole second copy of `Nav` — the exact same childExtends /
// children / Toggle logic SectionHeader already has, except frozen at the
// pre-fix state: `flow: 'row-reverse'` with no wrap policy, which is the
// SectionHeader defect this ticket describes (row-reverse reverses reading
// order, so once items wrap they fill from the right and collide with the
// paragraph above). SectionHeader's own Nav was fixed in place; this leaf's
// duplicate silently shadowed that fix for every `SectionHeaderWithNav`
// consumer. Collapsing to a bare `extends` (same move as
// `PathnameBreadcrumb` -> `Breadcrumb`) deletes the duplication and makes
// the ancestor's fix the only surviving behaviour.
const $fef424d24cabbf87$export$9c92103a71b9ac77 = {
    extends: 'SectionHeader'
};

});

parcelRegister("gUSPz", function(module, exports) {

$parcel$export(module.exports, "SectionTitle", () => $c50c689102102c19$export$69bc41ee738923ec);
const $c50c689102102c19$export$69bc41ee738923ec = {
    tag: 'p',
    fontWeight: '500',
    color: 'title'
};

});

parcelRegister("c3MC3", function(module, exports) {

$parcel$export(module.exports, "SimpleOverlay", () => $8c7b794f061aa727$export$9f2eee387f4e49f);
const $8c7b794f061aa727$export$9f2eee387f4e49f = {
    position: 'absolute',
    inset: '0 0 0 0'
};

});

parcelRegister("vkR58", function(module, exports) {

$parcel$export(module.exports, "SelectDropdownWithTitle", () => $05e312c3cb9532fe$export$b2091a6e5b06d936);
const $05e312c3cb9532fe$export$b2091a6e5b06d936 = {
    extends: 'GroupField',
    // A <div>, not GroupField's <label>: the select holds a listbox with
    // focusable options, and a label forwards a click on any plain descendant
    // to its first button (the trigger), so a click on an option or on the
    // panel would re-open or close the list. The Title names the trigger and the listbox through its id
    // (aria-labelledby, SelectDropdown.js) instead of the label element.
    tag: 'div',
    // `minWidth` on a letter token is a HARD floor: the component can never
    // shrink below it, so it overflows any container narrower than that —
    // a split pane, a narrow column, a small viewport. The intent is a
    // PREFERRED width, which is `width` + `maxWidth: '100%'`: same size when
    // there is room, shrinks instead of overflowing when there is not.
    width: 'F1',
    maxWidth: '100%',
    Title: {
        // The Title NAMES the trigger (its id, read by the trigger's
        // aria-labelledby); it takes no click. A handler that moved focus to the
        // trigger made this <div> a click target no keyboard reaches (the
        // workspace admin page law, 3.14.796); before bbf2990 it had none.
        id: (el)=>'sd-' + el.getPath().join('-')
    },
    SelectDropdown: {
        width: '100%'
    }
};

});

parcelRegister("3wXSk", function(module, exports) {

$parcel$export(module.exports, "SizeUnits", () => $2922ce377cd12f7b$export$8ab0a267496de8e9);
const $2922ce377cd12f7b$export$8ab0a267496de8e9 = {
    childExtends: 'Input',
    flow: 'y',
    align: 'center flex-start',
    gap: 'V',
    childProps: {
        outline: 'none',
        border: 'none',
        width: 'A+C',
        textAlign: 'center',
        padding: 'W',
        round: 'W',
        backgroundColor: 'inherit',
        cursor: 'pointer'
    },
    NumberValue: {
        color: 'title',
        fontSize: 'Z1'
    },
    LetterValue: {
        color: 'green',
        fontSize: 'Y',
        fontWeight: '500',
        textTransform: 'uppercase'
    }
};

});

parcelRegister("jihyg", function(module, exports) {

$parcel$export(module.exports, "SuggestionAction", () => $e0bd502cd710c336$export$ebe243338d39c3b8);
const $e0bd502cd710c336$export$ebe243338d39c3b8 = {
    extends: 'Link',
    position: 'relative',
    // `E3` of horizontal padding on a card whose own `maxWidth` is `I` left
    // almost no inner width in any real column — the label wrapped one word per
    // line ("Add / a / page") and the absolutely-positioned caption ran past the
    // frame. `C` keeps the generous feel while leaving the text room to set.
    padding: 'D C D3',
    textAlign: 'center',
    // `regular` is not a CSS font-weight keyword (`normal` is) and not a token,
    // so the declaration was dropped. The brand register is {400, 500, 700}.
    fontWeight: '400',
    round: 'B1',
    scrollToTop: false,
    maxWidth: 'I',
    width: '100%',
    // Was a 1px solid outline (the outlined-button/card habit banned by
    // design-direction.md §8 — an EARLIER fix here made it actually render,
    // but the stroke itself was never the compliant answer). A resting tonal
    // wash + a stronger wash on hover reads as "this is a card you can click"
    // the same way, without a stroke.
    background: 'overlay',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    },
    text: 'Add a page',
    href: ()=>`${window.location.pathname}/add-page`,
    onClick: async (ev, el)=>{
        ev.preventDefault();
        const href = el.call('resolveHref', el.href);
        await el.call('openModal', href == null ? void 0 : href.replace(window.location.pathname, ''));
    },
    IconText: {
        left: '0',
        textAlign: 'center',
        width: '100%',
        gap: 'X2',
        icon: 'click outline',
        position: 'absolute',
        color: 'inactive',
        bottom: 'A1',
        text: 'Click and fill the required fields'
    }
};

});

parcelRegister("h0IUv", function(module, exports) {

$parcel$export(module.exports, "Strong", () => $c6254600b6e75e8e$export$f301627d437cff88);
const $c6254600b6e75e8e$export$f301627d437cff88 = {
    extends: 'smbls.Strong',
    color: 'subtitle'
};

});

parcelRegister("eWA6q", function(module, exports) {

$parcel$export(module.exports, "Subhead", () => $ae127cb2fec5e5b8$export$17e07beff4cf82a6);
const $ae127cb2fec5e5b8$export$17e07beff4cf82a6 = {
    extends: 'smbls.Subhead',
    color: 'subtitle'
};

});

parcelRegister("g3PhQ", function(module, exports) {

$parcel$export(module.exports, "SwitchField", () => $bb14b5a422b17996$export$208c2e617baf9fc3);
const $bb14b5a422b17996$export$208c2e617baf9fc3 = {
    tag: 'label',
    boxSize: 'A2 B2',
    position: 'relative',
    Input: {
        type: 'checkbox',
        // sr-only but keyboard-focusable (was display:none — not tab-reachable). The
        // wrapping label still toggles; the track shows the focus ring on :focus-visible.
        position: 'absolute',
        opacity: '0',
        margin: '0',
        pointerEvents: 'none',
        // Every surface of this control was painted in FIXED `white.*` alphas, so
        // the entire switch — track, knob, and checked state — was invisible on any
        // light surface: `white.06` and `white.1` over a white card are literally
        // nothing. It only ever existed in dark mode. `title` is the adaptive
        // ink (gray1 light / gray15 dark), so `title.<alpha>` is the faithful
        // one-for-one translation of each `white.<alpha>` and preserves the dark
        // appearance exactly while making the control real in light.
        ':checked + span': {
            background: 'title.2',
            ':before': {
                left: '68%',
                background: 'title.85'
            }
        },
        // THE global focus ring (brand reset.js, §8.2) as the `focusRing` shadow
        // token, landed on the visible track sibling because the checkbox itself
        // is visually hidden. Was the framework atom's `outline: 'solid X blue.3'`
        // — a second, different ring (F1, Nika 2026-08-16).
        ':focus-visible + span': {
            shadow: 'focusRing'
        },
        onChange: (ev, el, s)=>{
            ev.stopPropagation();
            el.parent.onChange(ev, el.parent, s);
        }
    },
    // The visible track. Plain span — it used to be KEYED `Focusable` so the
    // framework atom auto-extended it (resting `outline: 'solid 0 blue.3'`);
    // that atom is the second ring F1 retired. The ring now lands here from
    // the Input's `:focus-visible + span` rule as the `focusRing` token.
    Track: {
        tag: 'span',
        boxSize: 'A2 B2',
        position: 'absolute',
        cursor: 'pointer',
        inset: '0 0 0 0',
        // adaptive analog of the old fixed `white.06` (see the note above)
        background: 'hover',
        // A toggle is a capsule and its knob a circle (DESIGN_LANGUAGE §6.2).
        // Both were the em letter `C`.
        round: 'radiusPill',
        transition: 'B',
        ':before': {
            content: '""',
            position: 'absolute',
            height: 'A',
            width: 'A',
            round: 'radiusPill',
            top: '50%',
            left: '32%',
            transform: 'translate3d(-50%, -50%, 0)',
            bottom: 'W',
            // The knob is the state a user reads, so it must clear the 3:1 non-text
            // floor against its track in BOTH schemes. `dim` (a banned, inverted
            // pair) read 2.13:1 dark / 3.18:1 light on the `hover` track; the
            // `inactive` pair reads >= 3.46:1 dark and >= 5.87:1 light over
            // common-box, card and document.
            backgroundColor: 'inactive',
            transition: 'B'
        }
    }
};

});

parcelRegister("k7liM", function(module, exports) {

$parcel$export(module.exports, "StateDesignElement", () => $ea54fc3aa57c352f$export$7549216c76ea904c);
const $ea54fc3aa57c352f$export$7549216c76ea904c = {
    extends: 'DesignElement',
    href: '/docs/{{ categoryType }}',
    margin: 'B -Z2 -Z2',
    gap: 'Y2',
    maxWidth: 'F_default',
    cursor: 'alias',
    // Both slots used to fall back to `s.categoryType` itself, so whenever the
    // state had no categoryType the component composed literal nonsense —
    // `theme: undefined` and `icon: 'undefinedOutline'`, an icon name that
    // cannot exist — and the button rendered blank instead of degrading. Fall
    // back to real, always-valid values instead of to a possibly-absent input.
    // A child key whose VALUE is a function is a factory returning props, which
    // is not how DOMQL composes a child — the element never materialised, so the
    // button was simply absent. A child is an OBJECT whose individual props may
    // be reactive `(el, s) => …` factories; that is the same intent, expressed
    // the way the framework resolves.
    WiderButton: {
        theme: (el, s)=>{
            const COLOR_MAPING = {
                animation: 'default',
                selector: 'default',
                media: 'default'
            };
            const type = s.categoryType;
            return COLOR_MAPING[type] || type || 'default';
        },
        icon: (el, s)=>{
            const ICON_MAPING = {
                animation: 'animationsAlt',
                selector: 'click',
                media: 'deviceMobile'
            };
            const type = s.categoryType;
            // never compose onto a possibly-absent input: `undefined + 'Outline'`
            // produced the literal icon name `undefinedOutline`.
            return ICON_MAPING[type] || (type ? type + 'Outline' : 'shapeOutline');
        }
    },
    Hgroup: {
        H: null,
        P: {
            text: null,
            childProps: {
                tag: 'span'
            },
            children: [
                'Property of ',
                {
                    text: '{{ category }}',
                    '@dark': {
                        color: 'white'
                    },
                    '@light': {
                        color: 'black'
                    }
                }
            ]
        }
    }
};

});

parcelRegister("9cBCF", function(module, exports) {

$parcel$export(module.exports, "TabSet", () => $6b326b1d383126e4$export$fe445cdbdc2880b4);
const $6b326b1d383126e4$export$fe445cdbdc2880b4 = {
    padding: 'V2+V2',
    flow: 'x',
    // A segmented capsule control: track and tabs are pills (DESIGN_LANGUAGE
    // §6.2 "segmented tab → radiusPill"). Was the em letter `D`.
    round: 'radiusPill',
    // The track is a neutral PLATE that must read on any ground: `overlay` (a
    // 5% wash of the ground's own family) read 1.00:1 on a common-box card.
    // `widgetPlate` steps on the sheet, the card and the document.
    background: 'widgetPlate',
    width: 'fit-content',
    childExtends: 'Button',
    children: [
        {
            text: 'build',
            // The active look belongs to the primitive's own `.isActive` below.
            // This sample used to add the retired `dialog-elevated` theme (§2.4) —
            // dead: the `.isActive` block paints inline and always beat it.
            isActive: true
        },
        {
            text: 'test'
        }
    ],
    childProps: {
        Icon: null,
        round: 'radiusPill',
        fontWeight: '400',
        padding: 'Z B1',
        textTransform: 'capitalize',
        // A segmented tab is a CHOICE control: the chosen segment is the full
        // inversion — `highlight` fill + `highlight-reversed` ink (Nika
        // 2026-09-23, D-1). Lists and rows keep the `selected` wash. Was theme
        // `document`, a chip only one fill step off the track.
        '.isActive': {
            background: 'highlight',
            color: 'highlight-reversed'
        },
        theme: 'transparent',
        // The idle label is the FULL ink, `title`, not the theme's 65% white /
        // black: on the bare dark stage the 65% ink read 3.84:1 on the track
        // (measured live on dev, 2026-09-24); `title` reads 5.80. The chosen
        // segment is the inversion, so the idle labels need no quieter second
        // tone to tell them apart (Nika 2026-09-24, choice controls, decision b).
        // The fill stays the theme's `transparent`.
        color: 'title',
        // RULE 65: an idle segment answers the pointer with a FILL step — the
        // `hover` wash under the pointer, the `selected` wash while pressed (Nika
        // 2026-09-24, decision 5a). Each step clears 0.02 luminance on the track
        // on every ground. The chosen segment's `.isActive` inversion paints
        // inline, so it keeps its fill under the pointer.
        ':hover': {
            background: 'hover'
        },
        ':active': {
            background: 'selected'
        }
    }
};

});

parcelRegister("96hfk", function(module, exports) {

$parcel$export(module.exports, "Tag", () => $6a020d517a4af2fb$export$3288d34c523a1192);
const $6a020d517a4af2fb$export$3288d34c523a1192 = {
    extends: 'LabelTag',
    // A chip is a capsule (DESIGN_LANGUAGE §6.2). Was the em letter `A`.
    round: 'radiusPill',
    text: 'Tag',
    // `field-static` merged into `field` (§2.4): the same resting fill and
    // ink, plus the hover state a clickable chip must declare (Rule 65).
    theme: 'field',
    order: (el, s)=>-s.frequency,
    // Safe when the parent holds no `tags` (it threw a TypeError at
    // `.tags.indexOf`, and the conditional never armed).
    isActive: (el, s)=>{
        const tags = s.parent && s.parent.tags;
        return Array.isArray(tags) && tags.includes(s.value);
    },
    // Selection is monochrome — the `selected` wash and `title` ink. This
    // was theme `space`, a blue hue marking selection.
    '.isActive': {
        background: 'selected',
        color: 'title'
    },
    // Toggle this tag in the parent's `tags` and MERGE only that key. It
    // mutated the array in place and called `s.parent.replace({ tags })`,
    // which drops every other key of the parent — on a page whose Tag sits
    // under the root state, a click wiped lang, route and the translations.
    onClick: (ev, el, s)=>{
        const parent = s.parent;
        if (!parent) return;
        const current = Array.isArray(parent.tags) ? [
            ...parent.tags
        ] : [];
        const tags = current.includes(s.value) ? current.filter((t)=>t !== s.value) : [
            ...current,
            s.value
        ];
        parent.update({
            tags: tags
        });
    }
};

});

parcelRegister("cFFWi", function(module, exports) {

$parcel$export(module.exports, "SummaryComponent", () => $9399d8a6e68f1cb6$export$4c31ebe31b6ce6ba);
const $9399d8a6e68f1cb6$export$4c31ebe31b6ce6ba = {
    extends: [
        'Link',
        'ClickableItem',
        'DesignComponent'
    ],
    state: true,
    maxWidth: 'none',
    width: '100%',
    margin: '- - B1',
    fontWeight: '400',
    href: '{{ href }}'
};

});

parcelRegister("cKlQi", function(module, exports) {

$parcel$export(module.exports, "TabsLinkSwitcher", () => $947ab9638f9c8d92$export$ed4804da580f004a);
const $947ab9638f9c8d92$export$ed4804da580f004a = {
    attr: {
        role: 'tablist'
    },
    margin: '- E - -',
    flow: 'x',
    gap: 'Z',
    childExtends: [
        'TabsLink'
    ]
};

});

parcelRegister("6V5Tn", function(module, exports) {

$parcel$export(module.exports, "SwitchFieldWithCaption", () => $509ca2feddb95fdc$export$ed66b65f3525dec0);
const $509ca2feddb95fdc$export$ed66b65f3525dec0 = {
    tag: 'label',
    align: 'center space-between',
    gap: 'Y',
    userSelect: 'none',
    ':hover > caption': {
        color: 'paragraph',
        opacity: 1
    },
    Input: {
        type: 'checkbox',
        // sr-only but keyboard-focusable (was display:none — not tab-reachable). The
        // wrapping label still toggles; the switch shows the focus ring on :focus-visible.
        position: 'absolute',
        opacity: '0',
        margin: '0',
        pointerEvents: 'none',
        ':checked ~ caption': {
            opacity: 1
        },
        ':checked ~ span > span': {
            background: 'dim',
            ':before': {
                left: '68%',
                background: 'caption'
            }
        },
        // THE global focus ring (brand reset.js, §8.2) as the `focusRing` shadow
        // token, landed on the visible switch sibling. Was the framework atom's
        // `outline: 'solid X blue.3'` — a second ring (F1, Nika 2026-08-16).
        ':focus-visible ~ span': {
            shadow: 'focusRing'
        },
        onChange: (ev, el, s, ctx2)=>{
            ev.stopPropagation();
            const hasChange = el.parent.onChange;
            if (hasChange) hasChange(ev, el.parent, s, ctx2);
        }
    },
    SwitchField: {
        // Key auto-extend to SwitchField; the framework `Focusable` atom is no
        // longer mixed in (F1 — one ring, the `focusRing` token above).
        tag: 'span',
        Input: null
    },
    Caption: {
        padding: '0',
        opacity: '.65',
        // Was `inactive` (['gray6','gray10']) — correct token FOR a disabled
        // control, wrong one for a merely de-emphasized (but fully interactive)
        // switch caption: composited with this row's own `.65` opacity it
        // measured 2.98:1 light / 3.49:1 dark (needs 4.5; AA walk 2026-08-09,
        // LMC-4). `caption` (['gray3','gray13']) is the one step darker/lighter
        // neutral pair — same de-emphasized role, same opacity treatment,
        // verified >=4.6 light / >=5.7 dark at this exact .65 opacity.
        color: 'caption',
        text: 'Disable this style',
        transition: 'B defaultBezier',
        transitionProperty: 'color, opacity'
    }
};

});

parcelRegister("knweg", function(module, exports) {

$parcel$export(module.exports, "UploadField", () => $ed5ef4a980047cfb$export$d61c19f03375c53e);
const $ed5ef4a980047cfb$export$d61c19f03375c53e = {
    extends: 'GroupField',
    Title: {
        padding: '- - - X2',
        text: 'Project icon'
    },
    UploadIcon: {
        position: 'relative',
        padding: 'B1 B',
        gap: 'X2',
        boxSize: 'fit-content',
        border: 'none',
        theme: 'field-placeholder',
        Icon: {
            name: 'upload',
            fontSize: 'C1',
            opacity: '1'
        },
        P: {
            text: 'Drag and drop or click',
            maxWidth: 'E',
            textAlign: 'center',
            opacity: '1',
            fontSize: 'Z1',
            Span: null
        },
        Input: {
            type: 'file',
            position: 'absolute',
            inset: '0 0 0 0',
            opacity: '0',
            visibility: 'hidden'
        }
    }
};

});

parcelRegister("Qcv4j", function(module, exports) {

$parcel$export(module.exports, "TabsLink", () => $09ce8db42b907267$export$a258a2358b9c65f7);
const $09ce8db42b907267$export$a258a2358b9c65f7 = {
    extends: 'Button',
    theme: null,
    // Expose the active tab to assistive tech (it was conveyed only visually via
    // .isActive). Mirrors the same isActive signal the visual state reads.
    attr: {
        role: 'tab',
        'aria-selected': (el, s)=>String(!!el.call('exec', el.isActive, el))
    },
    background: 'transparent',
    color: 'paragraph',
    padding: 'Z1 A',
    transition: 'A, defaultBezier',
    transitionProperty: 'color, font-weight',
    round: '0',
    // Was a persistent 1px bottom border under every tab (underline-as-chrome,
    // named-banned by design-direction.md §8), plus a `margin: '0 0 -1px'`
    // hack so adjacent tabs' borders collapsed into one line. Active/inactive
    // is already legible from ink alone (color + weight below) — the geex
    // nav-rail law's "zero boxes/pills, ink + opacity only" applies directly
    // to a text tab list. `zIndex`/`position: relative` were only there to
    // lift the active tab's border above its neighbors' — dead once the
    // border is gone.
    ':hover': {
        color: 'title'
    },
    '.isActive': {
        // 600 doesn't exist in this face (see SectionHeader.js) — was silently
        // rendering as 700 anyway.
        fontWeight: '700',
        color: 'title'
    },
    onClick: (ev, el, s, ctx2)=>{
        if (el.parent.onChoose) return el.parent.onChoose(ev, el, s, ctx2);
    }
};

});

parcelRegister("iSdGG", function(module, exports) {

$parcel$export(module.exports, "TemplatesRow", () => $dbd7e32d61b785fb$export$35f229c51eef48ec);
const $dbd7e32d61b785fb$export$35f229c51eef48ec = {
    flow: 'y',
    gap: 'Z2',
    align: 'flex-start flex-start',
    minWidth: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    minHeight: 'fit-content',
    Caption: {
        text: 'Templates'
    },
    Scrollable: {
        flow: 'x',
        childExtends: 'TemplatesRowItem',
        childrenAs: 'state',
        childProps: {
            onInit: (el, s)=>{
                if (s.length === 0) {
                    el.set({
                        opacity: "0.35"
                    });
                    el.set({
                        pointerEvents: "none"
                    });
                }
            },
            '@mobileL': {
                minWidth: '100%',
                maxWidth: '100%',
                scrollSnapAlign: 'start'
            },
            Img: {
                '@mobileL': {
                    boxSize: 'auto 100%'
                }
            },
            Span: {}
        },
        children: [
            {
                poster: 'https://api.symbols.app/core/files/public/68b43aac424350c909e4f047/download',
                projectPath: 'nikoloza/tech-dash',
                previewUrl: 'https://tech-dash.symbo.ls',
                title: 'TechDashboard'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b43e2b424350c909e4fa6f/download',
                projectPath: 'nikoloza/mankanet',
                previewUrl: 'https://mankanet.symbo.ls',
                title: 'Mankanet'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b446dd424350c909e50d4e/download',
                projectPath: 'nikoloza/nocost',
                previewUrl: 'https://nocost.symbo.ls',
                title: 'NoCost'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b65ee1424350c909ebc8a1/download',
                projectPath: 'nikoloza/fresh',
                previewUrl: 'https://fresh.symbo.ls',
                title: 'FreshCo'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b66083424350c909ebd66a/download',
                projectPath: 'nikoloza/bessi',
                previewUrl: 'https://bessi.symbo.ls',
                title: 'Christmas Shop'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b6749b424350c909ec6fcf/download',
                projectPath: 'nikoloza/qartool',
                previewUrl: 'https://qartool.symbo.ls',
                title: 'Qartool'
            },
            {
                poster: 'https://api.symbols.app/core/files/public/68b67552424350c909ec7534/download',
                projectPath: 'nikoloza/moll',
                previewUrl: 'https://moll.symbo.ls',
                title: 'Mollie'
            }
        ]
    },
    Scrollbar: {
        extends: 'Scrollbar.scrollable'
    }
};

});

parcelRegister("972UR", function(module, exports) {

$parcel$export(module.exports, "TestText", () => $6a270799fa6f5e38$export$da2556a0dd4c5e79);
const $6a270799fa6f5e38$export$da2556a0dd4c5e79 = {
    extends: 'InputField',
    minWidth: 'G2',
    align: 'stretch',
    Title: {
        text: 'Test text:'
    },
    Input: {
        onInput: (ev, el)=>{
            el.getRootState().update({
                sampleText: el.node.value
            }, {
                preventUpdate: [
                    "Canvas",
                    "Modal"
                ]
            });
        },
        theme: 'quaternary',
        padding: 'Z A',
        round: 'Y',
        placeholder: 'Today is a last day of the year',
        value: (el)=>el.getRootState()?.sampleText
    }
};

});

parcelRegister("rSQe4", function(module, exports) {

$parcel$export(module.exports, "TemplatesRowItem", () => $053d1014d8d3e782$export$5423b81ac907e56b);
const $053d1014d8d3e782$export$5423b81ac907e56b = {
    extends: [
        'Link'
    ],
    padding: '0',
    gap: 'Y1',
    flow: 'y',
    widthRange: 'G1',
    round: '0',
    overflow: 'visible',
    ':after': null,
    cursor: 'pointer',
    href: 'https://symbols.app/{{ projectPath }}',
    target: '_blank',
    opacity: '0.75',
    transition: 'A defaultBezier all',
    ':hover': {
        opacity: '1',
        '& .arrow': {
            transform: 'none',
            opacity: '1'
        }
    },
    state: {
        poster: 'https://api.symbols.app/core/files/public/68b43aac424350c909e4f047/download',
        projectPath: 'nikoloza/tech-dash',
        previewUrl: 'https://tech-dash.symbo.ls',
        title: 'TechBrother'
    },
    Box: {
        position: 'relative',
        Flex: {
            extends: 'Link',
            flow: 'x',
            if: (el, s)=>!!s.previewUrl,
            transition: 'A defaultBezier all',
            transform: 'translate3d(var(--spacing-A), calc(-1 * var(--spacing-A)), 0)',
            opacity: '0',
            class: 'arrow',
            position: 'absolute',
            top: 'X2',
            right: 'X2',
            zIndex: '2',
            padding: 'Y1',
            // deliberately FIXED: this chip floats over arbitrary thumbnail imagery,
            // so it must stay a dark scrim in both schemes rather than flip white.
            background: 'black',
            round: 'Z2',
            href: '{{ previewUrl }}',
            onClick: (ev, el, s)=>{
                ev.stopPropagation();
                ev.preventDefault();
                window.open(s.previewUrl, "_blank");
            },
            Icon: {
                fontSize: 'B',
                icon: 'eye'
            }
        },
        Img: {
            round: 'A',
            position: 'relative',
            width: '100%',
            src: '{{ poster }}'
        }
    },
    Span: {
        text: '{{ title }}',
        fontWeight: '400',
        padding: '- - - X2'
    }
};

});

parcelRegister("8z4RY", function(module, exports) {

$parcel$export(module.exports, "TextareaField", () => $63c55e9dca9b48e0$export$c2bf0ac0dd87f3cb);
const $63c55e9dca9b48e0$export$c2bf0ac0dd87f3cb = {
    position: 'relative',
    maxWidth: 'G3',
    maxHeight: 'E3',
    boxSize: '100%',
    boxSizing: 'border-box',
    ':after, &:before': {
        content: '""',
        position: 'absolute',
        zIndex: '10',
        boxSize: 'B 100%',
        pointerEvents: 'none'
    },
    ':before': {
        bottom: '-Z',
        left: '50%',
        transform: 'translate3d(-50%, -20%, 0)',
        background: `linear-gradient(
        to top,
        var(--quaternary-dark-background) 0%,
        var(--quaternary-dark-background) 100%
      )`
    },
    ':after': {
        top: '0',
        left: '0',
        background: `linear-gradient(
        to bottom,
        var(--quaternary-dark-background) 0%,
        var(--quaternary-dark-background) 100%
      )`
    },
    Textarea: {
        variant: 'simple',
        width: '100%',
        height: '100%',
        theme: 'field',
        padding: 'A B A A1',
        fontFamily: 'smbls',
        round: 'A',
        position: 'relative',
        overflow: 'hidden auto',
        resize: 'none',
        scrollBehavior: 'smooth',
        '@mobileXS': {
            fontSize: 'Z2'
        },
        '::-webkit-scrollbar': {
            display: 'none'
        },
        '.simple': {
            theme: 'field'
        }
    }
};

});

parcelRegister("FdR85", function(module, exports) {

$parcel$export(module.exports, "UploadIcon", () => $07be93f2ba5ba029$export$8df90684a752ef81);
const $07be93f2ba5ba029$export$8df90684a752ef81 = {
    // <label> wrapping a hidden file input: the label is not itself focusable,
    // so THE global ring (§8.2, `focusRing` token) lands via :focus-within.
    // It used to extend the framework `Focusable` atom (`outline: solid X
    // blue.3`) — a second ring (F1, 2026-08-16).
    ':focus-within': {
        shadow: 'focusRing'
    },
    tag: 'label',
    position: 'relative',
    theme: 'field',
    flow: 'column',
    align: 'center center',
    round: 'A',
    cursor: 'pointer',
    // Was '1.6px dashed line.1' — off the established hairline/hairline2
    // scale (designSystem/sizes.js). hairline2 (2px) is the closer step.
    border: 'hairline2 dashed line.1',
    padding: 'B B2',
    Input: {
        type: 'file',
        position: 'absolute',
        inset: '0 0 0 0',
        opacity: '0',
        visibility: 'hidden'
    },
    Icon: {
        name: 'upload',
        fontSize: 'B',
        opacity: '.2'
    },
    P: {
        text: ' or click and upload from your computer',
        flow: 'column-reverse',
        align: 'center center',
        opacity: '.22',
        margin: '0',
        Span: {
            text: 'Drag and drop your font file',
            display: 'block'
        }
    }
};

});

parcelRegister("eeuOF", function(module, exports) {

$parcel$export(module.exports, "RangeFieldWithIcon", () => $a5ca46f303748879$export$f27060fef6238b1b);
const $a5ca46f303748879$export$f27060fef6238b1b = {
    gap: 'Y',
    align: 'center flex-start',
    Icon: {
        display: 'block',
        color: 'caption'
    },
    RangeField: {}
};

});

parcelRegister("cx3Um", function(module, exports) {

$parcel$export(module.exports, "Scrollbar", () => $91fb99276e2a40fe$export$9a4e88b92edfce6b);
const $91fb99276e2a40fe$export$9a4e88b92edfce6b = {
    minWidth: 'I',
    display: 'flex',
    TrackContainer: {
        opacity: 1,
        transition: 'A defaultBezier opacity',
        flex: '1',
        margin: '- C1 - -',
        position: 'relative',
        background: 'transparent',
        // Real height so the container IS the drag hit area — `fit-content`
        // collapsed to 0 around the absolutely-positioned Track (prod #2349
        // residue: thumb painted, hit area empty). Plain `height`, not
        // `minHeight`: min-height would beat the thin explicit heights consumers
        // set (CaseStudies 1px, PricingPlans 2px); DOMQL merge lets their
        // `height` override win. `align: 'center'` centers the abs Track.
        height: 'B',
        align: 'center',
        Track: {
            position: 'absolute',
            theme: 'field',
            round: 'A',
            height: 'V',
            background: 'overlay',
            left: '0',
            transformOrigin: 'left'
        }
    },
    NavigationArrows: {
        childProps: {
            padding: 'Z',
            Icon: {
                display: 'block',
                fontSize: 'B1'
            }
        }
    }
};

});

parcelRegister("lEzcS", function(module, exports) {

$parcel$export(module.exports, "UploadAvatar", () => $fc38a4b632c94278$export$c654e0224365d6b5);
const $fc38a4b632c94278$export$c654e0224365d6b5 = {
    extends: [
        'GroupField'
    ],
    Title: {
        text: 'Pick the avatar'
    },
    UploadIcon: {}
};

});

parcelRegister("jAl0j", function(module, exports) {

$parcel$export(module.exports, "TutorialBanner", () => $e421ac146ef50c61$export$e8f6c4f4c0db666);
const $e421ac146ef50c61$export$e8f6c4f4c0db666 = {
    extends: [
        'Link',
        'ArticleMedium',
        'Hoverable'
    ],
    // NOTE: a duplicate ':before' literal used to sit here carrying
    // theme/backgroundImage factories — dead since authoring (the later
    // ':before' key always won at object-literal level), so banners have never
    // rendered s.background this way. Removed as dead code; restoring the
    // backgroundImage behavior is a separate product decision.
    flow: 'column',
    round: 'A',
    // A floor, never a height (overflow law §3b.6): the hidden overflow below
    // clips only the decorative :before / :after layers — a longer title or
    // paragraph grows the banner instead of being cut by it.
    minHeight: 'E2',
    padding: 'A A2',
    href: '{{ href }}',
    gap: '0',
    overflow: 'hidden',
    position: 'relative',
    flex: 1,
    transitionProperty: 'transform, opacity, padding, color, background',
    scrollToTop: false,
    maxWidth: 'H',
    theme: 'common-card-interactive',
    userSelect: 'none',
    '& h2, & p': {
        zIndex: 2
    },
    ':after, &:before': {
        content: '""',
        position: 'absolute',
        zIndex: 0,
        inset: '-W -W -W -W'
    },
    ':before': {
        transition: 'B defaultBezier, A defaultBezier, A defaultBezier',
        transitionProperty: 'opacity, color, background',
        backgroundSize: 'cover',
        '@dark': {
            opacity: '0.5'
        },
        '@light': {
            opacity: '1'
        }
    },
    '.withShadow': {
        ':after': {
            transition: 'B defaultBezier, A defaultBezier, A defaultBezier',
            transitionProperty: 'opacity, color, background',
            background: 'shadow-overlay',
            '@dark': {
                opacity: '0.69'
            },
            '@light': {
                display: 'none'
            }
        }
    },
    ':hover': {
        padding: '- C1 - -',
        ':before': {
            opacity: '1'
        },
        ':after': {
            opacity: '1'
        }
    },
    Icon: {
        opacity: '0.5',
        fontSize: 'A2',
        margin: 'X - - -',
        name: 'play outline'
    },
    Title: {
        margin: 'auto 0 0',
        text: '{{ title }}'
    },
    P: {
        text: '{{ p }}'
    }
};

});

parcelRegister("egf2c", function(module, exports) {

$parcel$export(module.exports, "UploadImage", () => $a61e38d48945da00$export$eaa555e7f7268368);
const $a61e38d48945da00$export$eaa555e7f7268368 = {
    extends: 'IconButton',
    round: 'Z2',
    Icon: {
        name: 'upload'
    }
};

});

parcelRegister("lWLGA", function(module, exports) {

$parcel$export(module.exports, "VerticalLine", () => $ffa4012ecd3f5831$export$ceb1bc6d1dff5ae8);
$parcel$export(module.exports, "Vr", () => $ffa4012ecd3f5831$export$7181d682076581e5);
const $ffa4012ecd3f5831$export$ceb1bc6d1dff5ae8 = {
    margin: '0 D',
    padding: '0',
    theme: 'line',
    widthRange: 'hairline'
};
const $ffa4012ecd3f5831$export$7181d682076581e5 = {
    margin: '0 D',
    padding: '0',
    theme: 'line',
    widthRange: 'hairline'
};

});

parcelRegister("d3BRm", function(module, exports) {

$parcel$export(module.exports, "VideoWrapper", () => $9818ec4fef616859$export$9ec05c6a635ff130);
const $9818ec4fef616859$export$9ec05c6a635ff130 = {
    overflow: 'hidden',
    position: 'relative',
    paddingBlockStart: '56.25%',
    width: '100%',
    round: 'A',
    childProps: {
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%'
    },
    onClick: (e, el)=>{
        el.Picture.update({
            hide: true
        });
        el.Iframe.update({
            hide: false,
            show: true
        });
    },
    Picture: {
        overflow: 'hidden',
        round: 'A',
        objectFit: 'cover',
        cursor: 'pointer',
        src: 'https://img.youtube.com/vi/{{code}}/maxresdefault.jpg',
        opacity: '0.65',
        transition: 'opacity defaultBezier A',
        ':hover': {
            opacity: 1
        },
        Button: {
            text: 'Watch the Video',
            theme: 'document',
            pointerEvents: 'none',
            gap: 'Y',
            fontWeight: '500',
            color: 'title',
            transition: 'letter-spacing B defaultBezier',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: '.65',
            zIndex: 1,
            padding: 'Y2 Z2',
            Icon: {
                name: 'playOutline',
                fontSize: 'B'
            }
        }
    },
    Iframe: {
        minWidth: 'none',
        minHeight: 'none',
        border: 'none',
        round: 'A',
        hide: true,
        src: 'https://www.youtube.com/embed/{{code}}?autoplay=1',
        allowfullscreen: true
    }
};

});

parcelRegister("6yupH", function(module, exports) {

$parcel$export(module.exports, "LabeledCopy", () => $4c5d8290952a76e0$export$560d4c01c6d80887);
const $4c5d8290952a76e0$export$560d4c01c6d80887 = {};

});

parcelRegister("eT1bP", function(module, exports) {

$parcel$export(module.exports, "WatchVideo", () => $ad672003c1335b91$export$c50dda5dcc7bdbae);
const $ad672003c1335b91$export$c50dda5dcc7bdbae = {
    align: 'center flex-start',
    gap: 'B1',
    round: 'A2',
    padding: 'X2 D X2 X1',
    maxWidth: 'fit-content',
    transition: 'transform B defaultBezier',
    cursor: 'pointer',
    // Was a 1px solid outline around the whole row (stroked-container habit,
    // banned by design-direction.md §8). A tonal wash keeps the clickable
    // cluster reading as one card without a stroke.
    background: 'overlay',
    '@mobileL': {
        flow: 'y',
        align: 'center center',
        padding: 'A A B1 A',
        gap: 'C1',
        round: 'B2'
    },
    ':hover': {
        transform: 'scale(1.0085)',
        '& img': {
            transform: 'scale(1.0085)'
        },
        '& button': {
            letterSpacing: 'X'
        }
    },
    onClick: (event, el, s)=>{
        el.call('openModalVideo', `https://www.youtube.com/embed/ko1TXI9pejg?autoplay=1`);
    },
    Img: {
        src: 'video.png',
        // Was `boxSize: 'E F'` — a FIXED width+height with no cap. `E` is a
        // preferred thumbnail width, not a floor: in any real container narrower
        // than `E` (a real content column, a split pane — the gallery's own wide
        // cell never reproduces this), the image held its fixed size and was cut
        // off by the card's own frame instead of shrinking. Longhand `width` +
        // `height` (not the `boxSize` shorthand) so `maxWidth` composes cleanly
        // without a shorthand-vs-longhand ordering fight.
        width: 'E',
        height: 'F',
        maxWidth: '100%',
        transition: 'transform, B, defaultBezier',
        '@mobileL': {
            boxSize: 'F 100%'
        }
    },
    Flex: {
        flow: 'y',
        align: 'flex-start flex-start',
        gap: 'A2',
        P: {
            text: `6 minutes video demonstrating
      11 unique features of Symbols`,
            maxWidth: 'F+C2',
            fontWeight: '300',
            margin: '0'
        },
        Button: {
            text: 'Watch the Video',
            theme: 'transparent',
            padding: '0',
            gap: 'Y',
            fontWeight: '500',
            color: 'title',
            transition: 'letter-spacing B defaultBezier',
            Icon: {
                name: 'playOutline',
                fontSize: 'B'
            }
        },
        '@mobileL': {
            align: 'center flex-start',
            textAlign: 'center'
        }
    }
};

});

parcelRegister("8jqJs", function(module, exports) {

$parcel$export(module.exports, "WiderButton", () => $60d4d58227664639$export$ba47c6c0f99b8a45);
const $60d4d58227664639$export$ba47c6c0f99b8a45 = {
    // Every mount is icon-only (copy / action icons), and an icon-only button is
    // a square (IconButton's law, Nika 2026-09-26) — the wider padding below
    // survives only for a button that carries a label.
    extends: [
        'SquareButton',
        'IconButton'
    ],
    // `quinary` is retired → `tertiary`, the quiet control (§2.4).
    theme: 'tertiary',
    padding: 'Z Z2',
    align: 'center center',
    // A rounded-rect icon button: the Z-cluster collapses to radiusControl
    // (DESIGN_LANGUAGE §3). Was the em letter `Z2`.
    round: 'radiusControl'
};

});

parcelRegister("b27Ut", function(module, exports) {

$parcel$export(module.exports, "BrandEyebrow", () => $8086045ee6689030$export$6b4b50cb62af49a1);
$parcel$export(module.exports, "BrandCode", () => $8086045ee6689030$export$243f836f224e51a3);
$parcel$export(module.exports, "BrandPanel", () => $8086045ee6689030$export$2b9241db9640b25);
$parcel$export(module.exports, "BrandRatioChip", () => $8086045ee6689030$export$9b923a2e38831b28);
$parcel$export(module.exports, "BrandStatusTag", () => $8086045ee6689030$export$fac7a702f52cacc);
// Shared primitives for the brand-language site. Chrome register:
// monochrome, borderless, washes for interaction, weights {400, 500, 700}.
const $8086045ee6689030$export$6b4b50cb62af49a1 = {
    tag: 'span',
    fontSize: 'Y',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '.14em',
    color: 'inactive'
};
const $8086045ee6689030$export$243f836f224e51a3 = {
    tag: 'code',
    fontFamily: 'Code',
    fontSize: 'Z',
    color: 'title',
    background: 'overlay',
    padding: 'W X2',
    round: 'Y',
    whiteSpace: 'nowrap'
};
const $8086045ee6689030$export$2b9241db9640b25 = {
    theme: 'common-box',
    round: 'radiusCard',
    padding: 'B',
    flow: 'y',
    gap: 'A'
};
const $8086045ee6689030$export$9b923a2e38831b28 = {
    tag: 'span',
    fontFamily: 'Code',
    fontSize: 'Y',
    fontWeight: '500',
    flow: 'x',
    align: 'center center',
    gap: 'W',
    padding: 'W Y',
    round: 'radiusPill',
    width: 'C2',
    flexShrink: '0',
    text: (el, s)=>{
        const v = el.stateKey ? s[el.stateKey] : s.ratio;
        return typeof v === 'number' ? v.toFixed(2) : "\u2014";
    },
    isPass: (el, s)=>{
        const v = el.stateKey ? s[el.stateKey] : s.ratio;
        return typeof v === 'number' && v >= 4.5;
    },
    isFail: (el, s)=>{
        const v = el.stateKey ? s[el.stateKey] : s.ratio;
        return typeof v === 'number' && v < 4.5;
    },
    // Hue on its own wash needs the SEMANTIC ink pair (color.js), which flips
    // per scheme by itself: `green-22` on the green wash read 2.89:1 in light,
    // and the nested '@dark' override never applied (dark painted the light ink,
    // 4.44:1) — measured by the AA walk on /color, 2026-09-26.
    '.isPass': {
        background: 'green.15',
        color: 'successInk'
    },
    '.isFail': {
        background: 'red.12',
        color: 'dangerInk'
    }
};
const $8086045ee6689030$export$fac7a702f52cacc = {
    tag: 'span',
    fontSize: 'Y',
    fontWeight: '500',
    padding: 'W Z',
    round: 'radiusPill',
    whiteSpace: 'nowrap',
    alignSelf: 'start',
    width: 'fit-content',
    isShipped: (el)=>el.kind === 'shipped',
    isPending: (el)=>el.kind === 'pending',
    isReserved: (el)=>el.kind === 'reserved',
    // Semantic ink pairs on the washes — see BrandRatioChip above.
    '.isShipped': {
        background: 'green.15',
        color: 'successInk'
    },
    '.isPending': {
        background: 'yellow.18',
        color: 'warningInk'
    },
    '.isReserved': {
        background: 'overlay',
        color: 'inactive'
    }
};

});

parcelRegister("fxcZu", function(module, exports) {

$parcel$export(module.exports, "BrandSection", () => $b4f403c3edcfe085$export$3dccda4e2f521ccd);
$parcel$export(module.exports, "BrandSubhead", () => $b4f403c3edcfe085$export$11839a985950b9d7);
$parcel$export(module.exports, "BrandNote", () => $b4f403c3edcfe085$export$a6ab401c0bb509a6);
// Section scaffold for the brand-language site. Use with flat props:
//   { extends: 'BrandSection', eyebrow: 'Tokens', heading: 'Color',
//     lede: '…', Body: { … } }
const $b4f403c3edcfe085$export$3dccda4e2f521ccd = {
    tag: 'section',
    flow: 'y',
    gap: 'B',
    padding: 'E - - -',
    '@mobileL': {
        padding: 'C - - -'
    },
    Head: {
        flow: 'y',
        gap: 'Z',
        maxWidth: 'H2',
        Eyebrow: {
            extends: 'BrandEyebrow',
            show: (el)=>Boolean(el.parent.parent.eyebrow),
            text: (el)=>el.parent.parent.eyebrow
        },
        Title: {
            tag: 'h2',
            fontSize: 'C',
            fontWeight: '700',
            letterSpacing: '-0.02em',
            lineHeight: '1.1',
            color: 'title',
            text: (el)=>el.parent.parent.heading
        },
        Lede: {
            tag: 'p',
            fontSize: 'A',
            lineHeight: '1.55',
            color: 'paragraph',
            show: (el)=>Boolean(el.parent.parent.lede),
            text: (el)=>el.parent.parent.lede
        }
    }
};
const $b4f403c3edcfe085$export$11839a985950b9d7 = {
    tag: 'h3',
    fontSize: 'A2',
    fontWeight: '700',
    color: 'title',
    letterSpacing: '-0.01em',
    padding: 'A - - -'
};
const $b4f403c3edcfe085$export$a6ab401c0bb509a6 = {
    tag: 'p',
    fontSize: 'Z',
    lineHeight: '1.5',
    color: 'inactive',
    maxWidth: 'H2'
};

});

parcelRegister("i88P2", function(module, exports) {

$parcel$export(module.exports, "BrandRailLink", () => $d32fd1473663baac$export$f8720ffd75ec6454);
$parcel$export(module.exports, "BrandThemeToggle", () => $d32fd1473663baac$export$7af50d40493d8332);
$parcel$export(module.exports, "BrandSiteSearch", () => $d32fd1473663baac$export$f474021bd0bfbcfa);
$parcel$export(module.exports, "BrandRail", () => $d32fd1473663baac$export$24f47f18152ee562);
$parcel$export(module.exports, "BrandSiteShell", () => $d32fd1473663baac$export$4ecd41473a19d305);
// Site shell: left rail navigation + theme toggle + search. The rail is
// quiet chrome — document ground, hover wash, no strokes. Rail entries are
// ROUTES (one page per token family), not scroll anchors.
const $d32fd1473663baac$export$f8720ffd75ec6454 = {
    extends: 'Link',
    flow: 'x',
    align: 'center start',
    gap: 'Z',
    fontSize: 'Z',
    fontWeight: '400',
    color: 'paragraph',
    // No background declaration on the resting state: elements are transparent
    // by default, and the word 'transparent' as a STATIC background goes through
    // scratch's token-table resolution (the documented static-colour trap) — on
    // the serve-latest runtime it resolved to a solid black fill, which was
    // invisible on the dark rail but rendered non-active pills as SOLID BLACK in
    // light theme (2026-08-09 catalog acceptance walk finding).
    textAlign: 'left',
    cursor: 'pointer',
    padding: 'Y Z',
    minHeight: 'controlHCompact',
    round: 'radiusControl',
    transition: 'A defaultBezier',
    transitionProperty: 'background, color',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // same active-detection precedent as brand's own LogoCopy
    isActive: (el)=>{
        const win = el.context.window || window;
        return win.location.pathname === el.href;
    },
    'aria-current': (el, s)=>(s.root.routePath || '/') === el.href ? 'page' : null,
    '.isActive': {
        background: 'selected',
        color: 'title',
        fontWeight: '500'
    },
    text: (el)=>el.label,
    onClick: (e, el)=>{
        e.preventDefault();
        el.call('brandSearchNavigate', el.href, null, 'page');
    }
};
const $d32fd1473663baac$export$7af50d40493d8332 = {
    state: {
        brandThemeLabel_en: 'Switch theme'
    },
    tag: 'button',
    type: 'button',
    'aria-label': (el)=>el.call('polyglot', 'brandThemeLabel'),
    align: 'center center',
    boxSize: 'controlH',
    round: 'radiusPill',
    cursor: 'pointer',
    color: 'paragraph',
    transition: 'A defaultBezier',
    transitionProperty: 'background, color',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    SunIcon: {
        extends: 'Icon',
        name: 'sun',
        fontSize: 'A2',
        display: 'none',
        '@dark': {
            display: 'inline-flex'
        }
    },
    MoonIcon: {
        extends: 'Icon',
        name: 'moon',
        fontSize: 'A2',
        display: 'inline-flex',
        '@dark': {
            display: 'none'
        }
    },
    onClick: (e, el)=>el.call('switchBrandTheme')
};
const $d32fd1473663baac$export$f474021bd0bfbcfa = {
    position: 'relative',
    state: {
        q: '',
        brandSearchLabel_en: 'Search brand pages, tokens and components',
        brandSearchPlaceholder_en: "Search the brand\u2026",
        brandSearchEmpty_en: 'No matching pages, tokens or components.'
    },
    Input: {
        theme: 'field',
        round: 'radiusControl',
        minHeight: 'controlHCompact',
        fontSize: 'Z',
        padding: '- Z2',
        width: '100%',
        type: 'search',
        'aria-label': (el)=>el.call('polyglot', 'brandSearchLabel'),
        placeholder: (el)=>el.call('polyglot', 'brandSearchPlaceholder'),
        value: (el, s)=>s.q || '',
        onInput: (e, el, s)=>s.update({
                q: e.target.value || ''
            }),
        onKeydown: (e, el, s)=>{
            if (e.key === 'Escape') s.update({
                q: ''
            });
        }
    },
    Results: {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        margin: 'Y - - -',
        zIndex: '20',
        theme: 'common-box',
        round: 'radiusCard',
        shadow: 'overlay',
        padding: 'Y',
        flow: 'y',
        gap: 'W',
        overflowY: 'auto',
        maxHeight: 'G',
        show: (el, s)=>Boolean((s.q || '').trim()),
        children: (el, s)=>{
            const q = (s.q || '').trim().toLowerCase();
            if (!q) return [];
            const ds = el.context.designSystem || {};
            const index = [];
            const push = (name, kind, href)=>index.push({
                    name: name,
                    kind: kind,
                    href: href
                });
            el.call('brandSiteNavigation').forEach((p)=>push(p.label, 'page', p.href));
            Object.keys(ds.color || {}).forEach((n)=>push(n, 'color', '/color'));
            Object.keys(ds.theme || {}).forEach((n)=>push(n, 'theme', '/surfaces'));
            Object.keys(ds.sizes || {}).forEach((n)=>push(n, 'size', '/space'));
            Object.keys(ds.gradient || {}).forEach((n)=>push(n, 'gradient', '/gradients'));
            Object.keys(ds.animation || {}).forEach((n)=>push(n, 'animation', '/motion'));
            Object.keys(ds.media || {}).forEach((n)=>push(n, 'breakpoint', '/breakpoints'));
            Object.keys(ds.icons || {}).forEach((n)=>push(n, 'icon', '/icons'));
            (el.call('brandOwnComponents') || []).filter((n)=>n.indexOf('Brand') !== 0).forEach((n)=>push(n, 'component', '/components'));
            const starts = index.filter((e2)=>e2.name.toLowerCase().indexOf(q) === 0);
            const contains = index.filter((e2)=>{
                const i = e2.name.toLowerCase().indexOf(q);
                return i > 0;
            });
            const matches = starts.concat(contains).slice(0, 12);
            if (!matches.length) return [
                {
                    role: 'status',
                    padding: 'Z',
                    fontSize: 'Z',
                    color: 'inactive',
                    text: '{{ brandSearchEmpty | polyglot }}'
                }
            ];
            return matches.map((entry)=>({
                    extends: 'Link',
                    scope: {
                        entry: entry
                    },
                    href: entry.href,
                    flow: 'x',
                    align: 'center space-between',
                    gap: 'Z',
                    padding: 'Y Z',
                    round: 'Y',
                    color: 'paragraph',
                    transition: 'A defaultBezier background',
                    ':hover': {
                        background: 'hover',
                        color: 'title'
                    },
                    onClick: (e, el2, s2)=>{
                        e.preventDefault();
                        s2.update({
                            q: ''
                        });
                        const target = el2.scope.entry;
                        el2.call('brandSearchNavigate', target.href, target.name, target.kind);
                    },
                    Label: {
                        fontSize: 'Z',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        text: entry.name
                    },
                    Kind: {
                        fontSize: 'Y',
                        color: 'inactive',
                        flexShrink: '0',
                        text: entry.kind
                    }
                }));
        }
    }
};
const $d32fd1473663baac$export$24f47f18152ee562 = {
    tag: 'aside',
    flow: 'y',
    gap: 'W',
    width: 'F2',
    flexShrink: '0',
    padding: 'B A2',
    overflowY: 'auto',
    '@tabletS': {
        display: 'none'
    },
    // NOT `Mark:` — that key auto-detects to the HTML <mark> tag, which
    // browsers paint yellow ("logo place is yellow").
    RailHead: {
        flow: 'x',
        align: 'center space-between',
        padding: '- - A2 -',
        Wordmark: {
            extends: 'Link',
            href: '/',
            onClick: (e, el)=>{
                e.preventDefault();
                el.call('brandSearchNavigate', '/', null, 'page');
            },
            flow: 'x',
            align: 'baseline start',
            gap: 'X',
            Ident: {
                text: 'symbols',
                fontWeight: '700',
                fontSize: 'A',
                color: 'title'
            },
            Slash: {
                text: '/ brand',
                fontWeight: '400',
                fontSize: 'A',
                color: 'inactive'
            }
        },
        BrandThemeToggle: {}
    },
    BrandSiteSearch: {
        margin: '- - A -'
    },
    Nav: {
        'aria-label': (el)=>el.call('polyglot', 'brandNavigationLabel'),
        flow: 'y',
        gap: 'W',
        childExtends: 'BrandRailLink',
        children: (el)=>el.call('brandSiteNavigation')
    }
};
const $d32fd1473663baac$export$4ecd41473a19d305 = {
    theme: 'document',
    flow: 'y',
    minHeight: '100dvh',
    maxHeight: '100dvh',
    overflow: 'hidden',
    fontSize: 'A',
    MobileBar: {
        display: 'none',
        '@tabletS': {
            display: 'flex'
        },
        flow: 'x',
        align: 'center space-between',
        padding: 'Z A',
        Wordmark: {
            extends: 'Link',
            href: '/',
            onClick: (e, el)=>{
                e.preventDefault();
                el.call('brandSearchNavigate', '/', null, 'page');
            },
            flow: 'x',
            align: 'baseline start',
            gap: 'X',
            Name: {
                text: 'symbols',
                fontWeight: '700',
                fontSize: 'A',
                color: 'title'
            },
            Slash: {
                text: '/ brand',
                fontWeight: '400',
                fontSize: 'A',
                color: 'inactive'
            }
        },
        BrandThemeToggle: {}
    },
    MobileNavigation: {
        display: 'none',
        '@tabletS': {
            display: 'flex'
        },
        flow: 'x',
        gap: 'Z',
        padding: '- A A A',
        minWidth: '0',
        BrandPageSelect: {
            flex: '1'
        },
        BrandSiteSearch: {
            flex: '1',
            minWidth: '0',
            Input: {
                minHeight: 'controlH'
            }
        }
    },
    Row: {
        flow: 'x',
        // stretch — Main must take the Row's bounded height to be the scroll
        // container (alignItems:start silently kills wheel scrolling).
        align: 'stretch start',
        flex: '1',
        minHeight: '0',
        BrandRail: {},
        Main: {
            tag: 'main',
            flex: '1',
            minWidth: '0',
            minHeight: '0',
            maxHeight: '100%',
            overflow: 'hidden auto',
            padding: '- C E C',
            '@mobileL': {
                padding: '- A C A'
            },
            Container: {
                width: '100%',
                maxWidth: 'I2',
                margin: '- auto',
                flow: 'y'
            }
        }
    }
};

});

parcelRegister("4xR4n", function(module, exports) {

$parcel$export(module.exports, "BrandHero", () => $34f36902d407ac2b$export$296823199a98bcd4);
// Poster-register hero: display extremes, binary ink, generous space.
// The meta row is read live from the registry — the numbers are proof,
// not copy.
const $34f36902d407ac2b$export$296823199a98bcd4 = {
    tag: 'header',
    flow: 'y',
    align: 'start start',
    gap: 'B',
    padding: 'F - E -',
    '@mobileL': {
        padding: 'D - C -'
    },
    MarkRow: {
        fontSize: 'D',
        color: 'title',
        LogoLoader: {}
    },
    Headline: {
        tag: 'h1',
        fontSize: 'G',
        lineHeight: '1.02',
        letterSpacing: '-0.03em',
        color: 'title',
        maxWidth: 'I',
        '@screenS': {
            fontSize: 'F'
        },
        '@mobileL': {
            fontSize: 'E'
        },
        Lead: {
            tag: 'span',
            fontWeight: '200',
            text: 'One language, '
        },
        Payoff: {
            tag: 'span',
            fontWeight: '700',
            text: 'rendered from the tokens.'
        }
    },
    Sub: {
        tag: 'p',
        fontSize: 'A2',
        lineHeight: '1.5',
        color: 'paragraph',
        maxWidth: 'H2',
        text: "This page is generated from designSystem/ at runtime \u2014 every value below is the live token, never a retyped number. If a token changes, this page changes."
    }
};

});

parcelRegister("je855", function(module, exports) {

$parcel$export(module.exports, "BrandSwatch", () => $dff597d5442f789c$export$1cfd1b16b4bab917);
$parcel$export(module.exports, "BrandHueGrid", () => $dff597d5442f789c$export$dec7f6f850bf8e70);
$parcel$export(module.exports, "BrandGrayRamp", () => $dff597d5442f789c$export$d659da6984f511a4);
$parcel$export(module.exports, "BrandIllustrativeRow", () => $dff597d5442f789c$export$99717384ee8bc576);
$parcel$export(module.exports, "BrandWashBoard", () => $dff597d5442f789c$export$73500d9fd309a20b);
$parcel$export(module.exports, "BrandBackdropList", () => $dff597d5442f789c$export$c6c92e445553e18a);
// Color section boards — every swatch enumerates designSystem/color.js at
// runtime. Nothing here is a retyped value. Radii use the named sizes.js
// control-geometry tokens (radiusCard/radiusControl) directly — verified
// resolving via getSequenceValue's CONFIG.sizes lookup (tickets/smbls.md).
const $dff597d5442f789c$export$1cfd1b16b4bab917 = {
    aspectRatio: '4 / 3',
    round: 'radiusCard',
    padding: 'A',
    flow: 'y',
    align: 'start end',
    gap: 'W',
    transition: 'A defaultBezier transform',
    ':hover': {
        transform: 'scale(1.02)'
    },
    Name: {
        fontFamily: 'Code',
        fontSize: 'Y',
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: '.05em',
        text: (el)=>el.parent.name
    },
    Value: {
        fontFamily: 'Code',
        fontSize: 'Y',
        opacity: '.7',
        text: (el)=>el.parent.value
    }
};
const $dff597d5442f789c$export$dec7f6f850bf8e70 = {
    display: 'grid',
    columns: 'repeat(6, 1fr)',
    gap: 'Z',
    '@tabletS': {
        columns: 'repeat(4, 1fr)'
    },
    '@mobileL': {
        columns: 'repeat(2, 1fr)'
    },
    children: (el)=>{
        const colors = el.context.designSystem && el.context.designSystem.color || {};
        const illustrative = [
            'color',
            'typography',
            'space',
            'shape',
            'icons',
            'css',
            'html',
            'padding',
            'margin',
            'sizing',
            'gap',
            'border'
        ];
        const skip = [
            'transparent',
            'black',
            'white'
        ];
        return Object.keys(colors).filter((name)=>{
            const entry = colors[name];
            // A product hue: flat opaque scalar (no adaptive pair), not the gray
            // ramp, not DS-editor illustrative. Values are the processed config's
            // { value, alpha } objects.
            return entry && typeof entry === 'object' && !entry['@light'] && entry.value && (entry.alpha === undefined || entry.alpha >= 1) && name.indexOf('gray') !== 0 && illustrative.indexOf(name) === -1 && skip.indexOf(name) === -1;
        }).map((name)=>{
            const css = colors[name].value;
            const vsBlack = el.call('contrastRatio', '#000000', css) || 0;
            const vsWhite = el.call('contrastRatio', '#ffffff', css) || 0;
            return {
                extends: 'BrandSwatch',
                background: name,
                color: vsBlack >= vsWhite ? 'black' : 'white',
                name: name,
                value: el.call('formatBrandColor', css)
            };
        });
    }
};
const $dff597d5442f789c$export$d659da6984f511a4 = {
    flow: 'y',
    gap: 'Z',
    Ramp: {
        display: 'grid',
        columns: 'repeat(16, 1fr)',
        gap: 'X',
        '@mobileL': {
            columns: 'repeat(8, 1fr)'
        },
        children: (el)=>{
            const colors = el.context.designSystem && el.context.designSystem.color || {};
            const steps = [];
            for(let i = 1; i <= 16; i++){
                const name = 'gray' + i;
                if (!(name in colors)) continue;
                const hex = colors[name] && colors[name].value;
                const vsBlack = el.call('contrastRatio', '#000000', hex) || 0;
                const vsWhite = el.call('contrastRatio', '#ffffff', hex) || 0;
                steps.push({
                    background: name,
                    aspectRatio: '1 / 1.4',
                    round: 'Y',
                    align: 'end center',
                    padding: '- - Y -',
                    Num: {
                        fontFamily: 'Code',
                        fontSize: 'X2',
                        color: vsBlack >= vsWhite ? 'black' : 'white',
                        opacity: '.8',
                        text: String(i)
                    }
                });
            }
            return steps;
        }
    },
    FlatGrayRow: {
        flow: 'x',
        align: 'center start',
        gap: 'Z',
        padding: 'Z - - -',
        Chip: {
            boxSize: 'A2',
            round: 'Y',
            background: 'gray',
            flexShrink: '0'
        },
        Label: {
            extends: 'BrandCode',
            text: (el)=>{
                const colors = el.context.designSystem && el.context.designSystem.color || {};
                return 'gray = ' + el.call('formatBrandColor', colors.gray && colors.gray.value);
            }
        },
        Warn: {
            extends: 'BrandStatusTag',
            kind: 'pending',
            text: "flat scalar \u2014 no dark pair, fails on dark grounds"
        }
    }
};
const $dff597d5442f789c$export$99717384ee8bc576 = {
    flow: 'x',
    wrap: 'wrap',
    gap: 'Y',
    children: (el)=>{
        const colors = el.context.designSystem && el.context.designSystem.color || {};
        const names = [
            'color',
            'typography',
            'space',
            'shape',
            'icons',
            'css',
            'html',
            'padding',
            'margin',
            'sizing',
            'gap',
            'border'
        ];
        return names.filter((name)=>name in colors).map((name)=>({
                flow: 'x',
                align: 'center start',
                gap: 'Y',
                padding: 'W Z',
                round: 'radiusPill',
                background: 'overlay',
                Dot: {
                    boxSize: 'Z',
                    round: 'radiusPill',
                    background: name
                },
                Label: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    color: 'paragraph',
                    text: name
                }
            }));
    }
};
const $dff597d5442f789c$export$73500d9fd309a20b = {
    flow: 'y',
    gap: 'Y',
    maxWidth: 'H2',
    childProps: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Z A',
        round: 'radiusControl',
        transition: 'A defaultBezier background'
    },
    RestRow: {
        Label: {
            text: "Rest \u2014 declared surface, full ink",
            fontSize: 'Z',
            color: 'paragraph'
        },
        Value: {
            extends: 'BrandCode',
            text: 'background: none'
        }
    },
    HoverRow: {
        cursor: 'pointer',
        ':hover': {
            background: 'hover'
        },
        Label: {
            text: "Hover me \u2014 the one pointer wash",
            fontSize: 'Z',
            color: 'paragraph'
        },
        Value: {
            extends: 'BrandCode',
            text: (el)=>'hover = ' + el.call('formatBrandColor', el.call('resolveBrandColor', 'hover', 'light')) + " \xb7 " + el.call('formatBrandColor', el.call('resolveBrandColor', 'hover', 'dark'))
        }
    },
    SelectedRow: {
        background: 'selected',
        Label: {
            text: "Selected \u2014 monochrome, never hue",
            fontSize: 'Z',
            color: 'title',
            fontWeight: '500'
        },
        Value: {
            extends: 'BrandCode',
            text: (el)=>'selected = ' + el.call('formatBrandColor', el.call('resolveBrandColor', 'selected', 'light')) + " \xb7 " + el.call('formatBrandColor', el.call('resolveBrandColor', 'selected', 'dark'))
        }
    }
};
const $dff597d5442f789c$export$c6c92e445553e18a = {
    flow: 'y',
    gap: 'W',
    children: (el)=>{
        const colors = el.context.designSystem && el.context.designSystem.color || {};
        const themes = el.context.designSystem && el.context.designSystem.theme || {};
        const roles = [
            [
                'overlay',
                "generic 5% soft fill \u2014 tonal step inside a surface"
            ],
            [
                'overlayStrong',
                "near-opaque sheet wash \u2014 NOT a state fill"
            ],
            [
                'scrim',
                "the blocking veil \u2014 behind every modal, floating side panel and phone sheet"
            ],
            [
                'scrimSoft',
                "the non-blocking veil \u2014 behind a PageSlot window (a fixed tint by design)"
            ],
            [
                'raised',
                "the lifted fill \u2014 a chosen view-segment thumb, a keycap on a highlighted row; always with float"
            ],
            [
                'shadow',
                'shadow color source'
            ],
            [
                'line',
                'the stroke budget: dense-table hairlines only'
            ],
            [
                'line-faded',
                'quietest separator'
            ],
            [
                'line-highlight',
                'emphasized separator'
            ]
        ];
        // The two veil THEMES — the fill plus a blur, drawn over live ink so the
        // blur shows. Only the veil's opacity ever animates, never its blur.
        const veils = [
            [
                'backdrop',
                'scrim + blur(8px)',
                "THE veil theme for blocking overlays \u2014 one for the whole product"
            ],
            [
                'backdropSoft',
                'scrimSoft + blur(4px)',
                "the PageSlot window veil \u2014 the page stays legible behind it"
            ]
        ];
        const veilRows = veils.filter((v)=>v[0] in themes).map((v)=>({
                flow: 'x',
                align: 'center start',
                gap: 'Z',
                padding: 'Y Z',
                round: 'radiusControl',
                ':hover': {
                    background: 'hover'
                },
                Chip: {
                    display: 'grid',
                    width: 'C',
                    height: 'A2',
                    round: 'Y',
                    overflow: 'hidden',
                    flexShrink: '0',
                    childProps: {
                        gridArea: '1 / 1'
                    },
                    Ink: {
                        align: 'center center',
                        fontSize: 'Z',
                        fontWeight: '700',
                        color: 'title',
                        text: 'Aa'
                    },
                    Veil: {
                        theme: v[0]
                    }
                },
                Name: {
                    fontFamily: 'Code',
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: 'title',
                    width: 'E',
                    flexShrink: '0',
                    text: v[0]
                },
                Value: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    color: 'inactive',
                    width: 'F',
                    flexShrink: '0',
                    '@mobileL': {
                        display: 'none'
                    },
                    text: "theme \xb7 " + v[1]
                },
                Role: {
                    fontSize: 'Y',
                    color: 'paragraph',
                    text: v[2]
                }
            }));
        return roles.filter((r)=>r[0] in colors).map((r)=>{
            const lightVal = el.call('formatBrandColor', el.call('resolveBrandColor', r[0], 'light'));
            const darkVal = el.call('formatBrandColor', el.call('resolveBrandColor', r[0], 'dark'));
            const shown = lightVal === darkVal ? lightVal : lightVal + " \xb7 " + darkVal;
            return {
                flow: 'x',
                align: 'center start',
                gap: 'Z',
                padding: 'Y Z',
                round: 'radiusControl',
                ':hover': {
                    background: 'hover'
                },
                Chip: {
                    width: 'C',
                    height: 'A2',
                    round: 'Y',
                    background: r[0],
                    flexShrink: '0'
                },
                Name: {
                    fontFamily: 'Code',
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: 'title',
                    width: 'E',
                    flexShrink: '0',
                    text: r[0]
                },
                Value: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    color: 'inactive',
                    width: 'F',
                    flexShrink: '0',
                    '@mobileL': {
                        display: 'none'
                    },
                    text: shown
                },
                Role: {
                    fontSize: 'Y',
                    color: 'paragraph',
                    text: r[1]
                }
            };
        }).concat(veilRows);
    }
};

});

parcelRegister("c96Aa", function(module, exports) {

$parcel$export(module.exports, "BrandInkMatrix", () => $8d7b6e65eff33572$export$94983523fb224b5b);
$parcel$export(module.exports, "BrandInkRow", () => $8d7b6e65eff33572$export$6f287167760d0057);
// The contrast law, measured live. Every adaptive ink token is resolved from
// the design system's own emitted CSS (readBrandThemeVars), then measured
// against the two real grounds — document and the raised card surface — in
// both themes. The 4.5:1 floor chips are computed, not asserted.
const $8d7b6e65eff33572$export$94983523fb224b5b = {
    flow: 'y',
    gap: 'W',
    state: {
        rows: [],
        grounds: null
    },
    onRender: (el, s)=>{
        if (s.rows && s.rows.length) return;
        const ds = el.context.designSystem || {};
        const dsColor = ds.color || {};
        const dsTheme = ds.theme || {};
        const light = (name)=>el.call('resolveBrandColor', name, 'light');
        const dark = (name)=>el.call('resolveBrandColor', name, 'dark');
        const fmt = (css)=>el.call('formatBrandColor', css);
        // Grounds: document + the raised surface (common-box), resolved from the
        // live theme definition through the same token grammar the runtime uses.
        const boxDef = dsTheme['common-box'] && dsTheme['common-box'].value || dsTheme['common-box'] || {};
        const grounds = {
            lightDoc: light('document'),
            darkDoc: dark('document'),
            lightCard: el.call('resolveBrandGrammar', boxDef['@light'] && boxDef['@light'].background, 'light'),
            darkCard: el.call('resolveBrandGrammar', boxDef['@dark'] && boxDef['@dark'].background, 'dark')
        };
        const darkness = (val)=>el.call('contrastRatio', val, '#ffffff') || 0;
        const inks = [
            'title',
            'subtitle',
            'caption',
            'paragraph',
            'placeholder',
            'inactive',
            'disabled',
            'dim',
            'highlight',
            'code',
            'gray'
        ];
        const rows = [];
        for(let i = 0; i < inks.length; i++){
            const name = inks[i];
            const entry = dsColor[name];
            if (!entry) continue;
            const lightVal = light(name);
            const darkVal = dark(name);
            if (!lightVal && !darkVal) continue;
            const flat = typeof entry === 'string' || !entry['@light'];
            const inverted = !flat && lightVal && darkVal && darkness(lightVal) < darkness(darkVal);
            rows.push({
                name: name,
                lightVal: fmt(lightVal),
                darkVal: flat ? fmt(lightVal) : fmt(darkVal),
                flat: flat,
                inverted: inverted,
                ratioLightDoc: el.call('contrastRatio', lightVal, grounds.lightDoc),
                ratioLightCard: grounds.lightCard ? el.call('contrastRatio', lightVal, grounds.lightCard, grounds.lightDoc) : null,
                ratioDarkDoc: el.call('contrastRatio', darkVal || lightVal, grounds.darkDoc, '#000000'),
                ratioDarkCard: grounds.darkCard ? el.call('contrastRatio', darkVal || lightVal, grounds.darkCard, grounds.darkDoc) : null
            });
        }
        s.update({
            rows: rows
        });
    },
    HeaderRow: {
        flow: 'x',
        align: 'center start',
        gap: 'Z',
        padding: 'Y Z',
        '@tabletS': {
            display: 'none'
        },
        childProps: {
            fontSize: 'X',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '.06em',
            lineHeight: '1.3',
            color: 'inactive',
            whiteSpace: 'pre-line',
            flexShrink: '0'
        },
        C1: {
            text: 'token',
            width: 'F'
        },
        C2: {
            text: 'light value',
            flex: '1'
        },
        C3: {
            text: 'dark value',
            flex: '1'
        },
        C4: {
            text: 'light\ndoc',
            width: 'C2'
        },
        C5: {
            text: 'light\ncard',
            width: 'C2'
        },
        C6: {
            text: 'dark\ndoc',
            width: 'C2'
        },
        C7: {
            text: 'dark\ncard',
            width: 'C2'
        }
    },
    Rows: {
        flow: 'y',
        gap: 'W',
        childExtends: 'BrandInkRow',
        childrenAs: 'state',
        children: (el, s)=>s.rows || []
    },
    Floor: {
        extends: 'BrandNote',
        padding: 'Z - - -',
        text: 'The floor is 4.5:1 on the surface the text actually sits on, both themes. inactive is the quiet token that clears it everywhere; dim is an inverted pair and fails in both directions; the flat gray has no dark half.'
    }
};
const $8d7b6e65eff33572$export$6f287167760d0057 = {
    flow: 'x',
    align: 'center start',
    gap: 'Z',
    padding: 'Y Z',
    round: 'radiusControl',
    ':hover': {
        background: 'hover'
    },
    '@tabletS': {
        wrap: 'wrap',
        rowGap: 'Y'
    },
    NameCell: {
        flow: 'x',
        align: 'center start',
        gap: 'Y',
        width: 'F',
        flexShrink: '0',
        '@tabletS': {
            width: '100%'
        },
        Swatch: {
            boxSize: 'Z2',
            round: 'Y',
            flexShrink: '0',
            background: (el, s)=>s.name
        },
        Name: {
            fontFamily: 'Code',
            fontSize: 'Z',
            fontWeight: '500',
            color: 'title',
            text: (el, s)=>s.name
        },
        InvertedTag: {
            extends: 'BrandStatusTag',
            kind: 'pending',
            text: 'inverted',
            show: (el, s)=>Boolean(s.inverted)
        },
        FlatTag: {
            extends: 'BrandStatusTag',
            kind: 'reserved',
            text: 'flat',
            show: (el, s)=>Boolean(s.flat)
        }
    },
    LightVal: {
        fontFamily: 'Code',
        fontSize: 'Y',
        color: 'paragraph',
        flex: '1',
        minWidth: '0',
        text: (el, s)=>s.lightVal
    },
    DarkVal: {
        fontFamily: 'Code',
        fontSize: 'Y',
        color: 'paragraph',
        flex: '1',
        minWidth: '0',
        text: (el, s)=>s.darkVal
    },
    RatioLightDoc: {
        extends: 'BrandRatioChip',
        stateKey: 'ratioLightDoc'
    },
    RatioLightCard: {
        extends: 'BrandRatioChip',
        stateKey: 'ratioLightCard'
    },
    RatioDarkDoc: {
        extends: 'BrandRatioChip',
        stateKey: 'ratioDarkDoc'
    },
    RatioDarkCard: {
        extends: 'BrandRatioChip',
        stateKey: 'ratioDarkCard'
    }
};

});

parcelRegister("e3sdr", function(module, exports) {

$parcel$export(module.exports, "BrandGradientBoard", () => $a3b73b8eed687485$export$4478b0f2538ca3d8);
// Gradient tokens, enumerated live. Adaptive (per-theme) gradients are
// tagged — their value objects carry @dark / @light halves.
const $a3b73b8eed687485$export$4478b0f2538ca3d8 = {
    display: 'grid',
    columns: 'repeat(4, 1fr)',
    gap: 'Z',
    '@tabletS': {
        columns: 'repeat(3, 1fr)'
    },
    '@mobileL': {
        columns: 'repeat(2, 1fr)'
    },
    children: (el)=>{
        const gradients = el.context.designSystem && el.context.designSystem.gradient || {};
        return Object.keys(gradients).map((name)=>{
            const entry = gradients[name];
            const adaptive = Boolean(entry && typeof entry === 'object' && entry['@dark']);
            return {
                aspectRatio: '4 / 3',
                round: 'radiusCard',
                padding: 'A',
                flow: 'y',
                align: 'start end',
                gap: 'W',
                background: name,
                Name: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '.05em',
                    color: 'title',
                    text: name
                },
                AdaptiveTag: {
                    extends: 'BrandStatusTag',
                    kind: 'reserved',
                    text: 'adaptive',
                    show: adaptive
                }
            };
        });
    }
};

});

parcelRegister("h2C8c", function(module, exports) {

$parcel$export(module.exports, "BrandThemeSpecimen", () => $c68033a7eb1e389d$export$8396574b99d1e1fa);
$parcel$export(module.exports, "BrandThemeGroupGrid", () => $c68033a7eb1e389d$export$b8861bcc6ce60801);
$parcel$export(module.exports, "BrandThemeBoard", () => $c68033a7eb1e389d$export$f9d95459e92d95cd);
// Every theme in designSystem/theme.js, rendered as itself, grouped by role.
// Enumeration is live — a theme added to the file appears here; nothing is
// hand-listed except the grouping, and ungrouped names still render under
// "Other".
const $c68033a7eb1e389d$export$8396574b99d1e1fa = {
    round: 'radiusCard',
    padding: 'A2',
    minHeight: 'D2',
    flow: 'y',
    align: 'start space-between',
    gap: 'Z',
    Aa: {
        text: 'Aa',
        fontSize: 'C',
        fontWeight: '700',
        lineHeight: '1'
    },
    Name: {
        fontFamily: 'Code',
        fontSize: 'Y',
        fontWeight: '500',
        opacity: '.85',
        text: (el)=>el.parent.name
    }
};
const $c68033a7eb1e389d$export$b8861bcc6ce60801 = {
    display: 'grid',
    columns: 'repeat(4, 1fr)',
    gap: 'Z',
    '@tabletS': {
        columns: 'repeat(3, 1fr)'
    },
    '@mobileL': {
        columns: 'repeat(2, 1fr)'
    },
    children: (el)=>(el.names || []).map((name)=>({
                extends: 'BrandThemeSpecimen',
                theme: name,
                cursor: 'pointer',
                name: name
            }))
};
const $c68033a7eb1e389d$export$f9d95459e92d95cd = {
    flow: 'y',
    gap: 'A',
    children: (el)=>{
        const themes = el.context.designSystem && el.context.designSystem.theme || {};
        const groups = [
            [
                'Surfaces & fields',
                [
                    'document',
                    'card',
                    'dialog',
                    'backdrop',
                    'backdropSoft',
                    'label',
                    'field',
                    'field-placeholder',
                    'field-static',
                    'field-highlight',
                    'field-error',
                    'field-success',
                    'field-disabled',
                    'field-readonly'
                ]
            ],
            [
                'Priority',
                [
                    'primary',
                    'secondary',
                    'secondary-highlight',
                    'tertiary',
                    'quaternary',
                    'quinary'
                ]
            ],
            [
                'Status',
                [
                    'alert',
                    'warning',
                    'error',
                    'success',
                    'info'
                ]
            ],
            [
                'Cards & boxes',
                [
                    'common-card',
                    'common-card-interactive',
                    'common-card-outline',
                    'common-card-outline-interactive',
                    'common-card-child',
                    'common-box',
                    'common-box-secondary',
                    'canvas-card',
                    'canvas-card-glass',
                    'canvas-card-glass-reversed',
                    'dialog-elevated',
                    'modal',
                    'modalFade',
                    'modalPreview',
                    'scene',
                    'scene-preview-interactive',
                    'layer'
                ]
            ],
            [
                "Chrome (legacy \u2014 archetypes own these now)",
                [
                    'header',
                    'navbar',
                    'navbarButton',
                    'navbarButton-active',
                    'navbar-button',
                    'navbar-button-active',
                    'headerCaptions',
                    'headerSidebar'
                ]
            ],
            [
                'Utility & special',
                [
                    'transparent',
                    'text',
                    'default',
                    'property',
                    'stroke',
                    'dots',
                    'transparentPattern',
                    'line',
                    'sepia',
                    'sepia-active'
                ]
            ],
            [
                'DS-editor illustrative (never product chrome)',
                [
                    'color',
                    'theme',
                    'typography',
                    'space',
                    'shape',
                    'icons',
                    'css',
                    'html'
                ]
            ]
        ];
        const assigned = {};
        const out = [];
        for(let g = 0; g < groups.length; g++){
            const names = groups[g][1].filter((n)=>n in themes);
            names.forEach((n)=>{
                assigned[n] = true;
            });
            if (!names.length) continue;
            out.push({
                extends: 'BrandSubhead',
                text: groups[g][0]
            });
            out.push({
                extends: 'BrandThemeGroupGrid',
                names: names
            });
        }
        const rest = Object.keys(themes).filter((n)=>!assigned[n]);
        if (rest.length) {
            out.push({
                extends: 'BrandSubhead',
                text: 'Other'
            });
            out.push({
                extends: 'BrandThemeGroupGrid',
                names: rest
            });
        }
        return out;
    }
};

});

parcelRegister("ez0fT", function(module, exports) {

$parcel$export(module.exports, "BrandSkinBoard", () => $a9a48845f21baa75$export$6847dde5dcd41772);
$parcel$export(module.exports, "BrandSkinSwitch", () => $a9a48845f21baa75$export$b4a0c88b4843f9dd);
$parcel$export(module.exports, "BrandSkinOption", () => $a9a48845f21baa75$export$576b87220ef483f5);
$parcel$export(module.exports, "BrandSkinStage", () => $a9a48845f21baa75$export$7759b8527e72b761);
$parcel$export(module.exports, "BrandSkinPill", () => $a9a48845f21baa75$export$b618b3ce1998bad6);
$parcel$export(module.exports, "BrandSkinCard", () => $a9a48845f21baa75$export$bf6fcb526604e01);
// THE SKINS, shown (Nika 2026-09-26: "also we should support theming. we make
// default exceptionally beautiful, white-label (solid) as secondary"; "make
// full blend"). One token set, two skins: the switch sets `data-skin` on the
// specimen's own subtree — exactly what the shell stamps on <html> — and the
// cards and pills below never read the skin; their themes (`card`, `pill`)
// follow the variables the skin rewrites (designSystem/skins.js). The ground
// is the stage with a dot field in `stageInk`, a stand-in for the dithered
// sky of the ambient home (AmbientBackdrop, workspace).
const $a9a48845f21baa75$export$6847dde5dcd41772 = {
    state: {
        skin: 'ambient'
    },
    flow: 'y',
    gap: 'A',
    BrandSkinSwitch: {},
    BrandSkinStage: {},
    BrandNote: {
        text: 'data-skin="ambient" | "solid" on <html> (the shell, from the workspace setting) or on any subtree; no attribute is solid. Only card and pill change; overlays, menus, sheets and icon plates stay opaque in both skins. Reduced transparency falls back to solid.'
    }
};
const $a9a48845f21baa75$export$b4a0c88b4843f9dd = {
    role: 'radiogroup',
    'aria-label': 'Skin',
    flow: 'x',
    flexWrap: 'wrap',
    gap: 'X',
    padding: 'X',
    width: 'fit-content',
    maxWidth: '100%',
    round: 'radiusPill',
    theme: 'layer',
    childExtends: 'BrandSkinOption',
    children: [
        {
            key: 'ambient',
            skinKey: 'ambient',
            label: "Ambient \u2014 the default"
        },
        {
            key: 'solid',
            skinKey: 'solid',
            label: "Solid \u2014 white-label"
        }
    ]
};
const $a9a48845f21baa75$export$576b87220ef483f5 = {
    tag: 'button',
    type: 'button',
    role: 'radio',
    minHeight: 'controlHCompact',
    padding: '0 A',
    round: 'radiusPill',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z1',
    fontWeight: '500',
    whiteSpace: 'normal',
    textAlign: 'center',
    lineHeight: '1.2',
    transition: 'A defaultBezier',
    transitionProperty: 'background, color',
    background: (el, s)=>s.skin === el.skinKey ? 'selected' : 'transparent',
    color: (el, s)=>s.skin === el.skinKey ? 'title' : 'caption',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    'aria-checked': (el, s)=>s.skin === el.skinKey ? 'true' : 'false',
    text: (el)=>el.label,
    onClick: (e, el, s)=>s.update({
            skin: el.skinKey
        })
};
const $a9a48845f21baa75$export$7759b8527e72b761 = {
    dataSkin: (el, s)=>s.skin,
    flow: 'y',
    gap: 'B',
    padding: 'B',
    round: 'radiusCard',
    background: 'stage',
    backgroundImage: 'radial-gradient(var(--color-stageInk) 1px, transparent 1.5px)',
    backgroundSize: 'var(--spacing-Y) var(--spacing-Y)',
    SkinHeaderPill: {
        extends: 'BrandSkinPill',
        alignSelf: 'center',
        text: "Home \xb7 Tasks \xb7 Calendar \xb7 Chat"
    },
    SkinCards: {
        display: 'grid',
        columns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F)), 1fr))',
        gap: 'A',
        childExtends: 'BrandSkinCard',
        children: [
            {
                key: 'next',
                heading: 'Next up',
                body: 'Design review with the Tbilisi team',
                caption: 'in 42 min',
                meta: "14:30 \u2013 15:00 \xb7 Tbilisi"
            },
            {
                key: 'deals',
                heading: 'Deals',
                body: '12 open, 3 closing this week',
                caption: "\u20BE 86.9K pipeline",
                meta: 'updated 5 min ago'
            },
            {
                key: 'tasks',
                heading: 'Tasks',
                body: 'Review the white-label brief',
                caption: '4 due today',
                meta: '2 overdue'
            }
        ]
    },
    SkinComposer: {
        extends: 'BrandSkinPill',
        alignSelf: 'stretch',
        color: 'inactive',
        text: 'Ask anything, or type / for commands'
    }
};
const $a9a48845f21baa75$export$b618b3ce1998bad6 = {
    theme: 'pill',
    round: 'radiusPill',
    minHeight: 'controlH',
    padding: '0 B',
    flow: 'x',
    align: 'center flex-start',
    fontSize: 'Z1',
    fontWeight: '500',
    maxWidth: '100%'
};
const $a9a48845f21baa75$export$bf6fcb526604e01 = {
    theme: 'card',
    round: 'radiusCard',
    padding: 'A1',
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    SkinCardHeading: {
        fontSize: 'Z1',
        fontWeight: '700',
        color: 'title',
        text: (el)=>el.parent.heading
    },
    SkinCardBody: {
        fontSize: 'Z1',
        color: 'paragraph',
        lineHeight: '1.4',
        text: (el)=>el.parent.body
    },
    SkinCardCaption: {
        fontSize: 'Z',
        color: 'caption',
        text: (el)=>el.parent.caption
    },
    SkinCardMeta: {
        fontFamily: 'Code',
        fontSize: 'Y2',
        color: 'inactive',
        text: (el)=>el.parent.meta
    }
};

});

parcelRegister("jZxUK", function(module, exports) {

$parcel$export(module.exports, "BrandTypeRow", () => $e8de0582c960bd48$export$eb03c9ff60c595de);
$parcel$export(module.exports, "BrandTypeScale", () => $e8de0582c960bd48$export$c58df6cff10e218a);
$parcel$export(module.exports, "BrandWeightLaw", () => $e8de0582c960bd48$export$e4694872bb2eb8c9);
$parcel$export(module.exports, "BrandFamilyBoard", () => $e8de0582c960bd48$export$ac7596d24bd39b50);
$parcel$export(module.exports, "BrandRegisterDuo", () => $e8de0582c960bd48$export$972bf50ffa3ad861);
// Typography — the scale rendered as real specimens, each measured off its
// own rendered node (getComputedStyle), so the printed px follows the live
// viewport sub-sequence exactly.
const $e8de0582c960bd48$export$eb03c9ff60c595de = {
    flow: 'x',
    gap: 'B',
    align: 'baseline start',
    padding: 'Z -',
    ':hover': {
        background: 'hover'
    },
    round: 'radiusControl',
    '@mobileL': {
        gap: 'Z'
    },
    Letter: {
        fontFamily: 'Code',
        fontSize: 'Z',
        fontWeight: '700',
        color: 'title',
        width: 'C2',
        flexShrink: '0',
        text: (el)=>el.parent.letter
    },
    Px: {
        fontFamily: 'Code',
        fontSize: 'Y',
        color: 'inactive',
        width: 'D',
        flexShrink: '0',
        // The scale's own generated value — read from the sequence scratch built
        // out of { base, ratio }, not measured, not retyped.
        text: (el)=>{
            const t = el.context.designSystem && el.context.designSystem.typography;
            const entry = t && t.sequence && t.sequence[el.parent.letter];
            return entry ? Math.round(entry.decimal * 10) / 10 + 'px' : "\u2014";
        }
    },
    Sample: {
        text: 'Interfaces share one language',
        lineHeight: '1.15',
        color: 'title',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: '1',
        minWidth: '0',
        fontSize: (el)=>el.parent.letter
    }
};
const $e8de0582c960bd48$export$c58df6cff10e218a = {
    flow: 'y',
    gap: 'W',
    children: ()=>[
            'Y',
            'Z',
            'A',
            'A2',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H'
        ].map((letter)=>({
                extends: 'BrandTypeRow',
                letter: letter
            })),
    ScaleNote: {
        extends: 'BrandNote',
        padding: 'Z - - -',
        text: (el)=>{
            const t = el.context.designSystem && el.context.designSystem.typography || {};
            return 'Generated from base ' + t.base + ', ratio ' + t.ratio + " (minor third) \u2014 the px values are the scale\u2019s own generated sequence. The specimens themselves are em-fluid and re-tune per breakpoint.";
        }
    }
};
const $e8de0582c960bd48$export$e4694872bb2eb8c9 = {
    flow: 'y',
    gap: 'Z',
    maxWidth: 'H2',
    LawRows: {
        flow: 'y',
        gap: 'Y',
        childProps: {
            flow: 'x',
            align: 'baseline start',
            gap: 'B',
            Weight: {
                fontFamily: 'Code',
                fontSize: 'Y',
                color: 'inactive',
                width: 'C2',
                flexShrink: '0'
            },
            Sample: {
                fontSize: 'B',
                lineHeight: '1.2',
                color: 'title'
            }
        },
        W400: {
            Weight: {
                text: '400'
            },
            Sample: {
                fontWeight: '400',
                text: 'Body reads at four hundred'
            }
        },
        W500: {
            Weight: {
                text: '500'
            },
            Sample: {
                fontWeight: '500',
                text: 'Labels emphasize at five hundred'
            }
        },
        W700: {
            Weight: {
                text: '700'
            },
            Sample: {
                fontWeight: '700',
                text: 'Titles land at seven hundred'
            }
        }
    },
    SnapDemo: {
        flow: 'y',
        gap: 'Y',
        padding: 'A - - -',
        Declared600: {
            flow: 'x',
            align: 'baseline start',
            gap: 'B',
            Weight: {
                fontFamily: 'Code',
                fontSize: 'Y',
                color: 'red',
                width: 'C2',
                flexShrink: '0',
                text: '600'
            },
            Sample: {
                fontSize: 'B',
                fontWeight: '600',
                color: 'title',
                text: 'Six hundred does not exist'
            }
        },
        Declared700: {
            flow: 'x',
            align: 'baseline start',
            gap: 'B',
            Weight: {
                fontFamily: 'Code',
                fontSize: 'Y',
                color: 'inactive',
                width: 'C2',
                flexShrink: '0',
                text: '700'
            },
            Sample: {
                fontSize: 'B',
                fontWeight: '700',
                color: 'title',
                text: 'Six hundred does not exist'
            }
        },
        Verdict: {
            extends: 'BrandNote',
            text: "Both lines above are real: one declares 600, one declares 700 \u2014 the browser snaps them to the same face. The product register is {400, 500, 700}; thin 100\u2013300 is display-only; 600, 800 and 900 are banned until a real face ships (D8)."
        }
    }
};
const $e8de0582c960bd48$export$ac7596d24bd39b50 = {
    flow: 'y',
    gap: 'Z',
    Families: {
        display: 'grid',
        columns: 'repeat(2, 1fr)',
        gap: 'Z',
        maxWidth: 'H2',
        '@mobileL': {
            columns: '1fr'
        },
        children: (el)=>{
            const ds = el.context.designSystem || {};
            const fams = ds.fontFamily || ds.font_family || {};
            return Object.keys(fams).filter((name)=>{
                const def = fams[name];
                // Real families only — the processed config also carries 'default'
                // (a string pointer) and the internal 'system' fallback entry.
                return def && typeof def === 'object' && name !== 'system';
            }).map((name)=>{
                const def = fams[name] || {};
                const stack = Array.isArray(def.arr) ? def.arr.join(', ') : Array.isArray(def.value) ? def.value.join(', ') : String(def.value || '');
                const serifSuspect = name !== 'Code' && (def.type === 'serif' || /(^|,)\s*serif/.test(stack) && stack.indexOf('sans-serif') === -1);
                return {
                    extends: 'BrandPanel',
                    gap: 'Z',
                    Specimen: {
                        fontFamily: name,
                        fontSize: 'D',
                        lineHeight: '1.1',
                        color: 'title',
                        text: name === 'Code' ? '0123 45:67' : 'Aa Gg Rr'
                    },
                    Meta: {
                        flow: 'y',
                        gap: 'W',
                        Name: {
                            fontFamily: 'Code',
                            fontSize: 'Z',
                            fontWeight: '700',
                            color: 'title',
                            text: name
                        },
                        Stack: {
                            fontFamily: 'Code',
                            fontSize: 'Y',
                            color: 'inactive',
                            text: stack
                        },
                        DefaultTag: {
                            extends: 'BrandStatusTag',
                            kind: 'shipped',
                            text: 'default face',
                            show: Boolean(def.isDefault)
                        },
                        TypeWarn: {
                            extends: 'BrandStatusTag',
                            kind: 'pending',
                            text: "serif fallback chain under a sans face \u2014 one-line fix pending",
                            show: serifSuspect
                        }
                    }
                };
            });
        }
    },
    FontStatus: {
        flow: 'x',
        align: 'center start',
        gap: 'Z',
        Tag: {
            extends: 'BrandStatusTag',
            kind: 'reserved',
            text: (el)=>{
                const f = el.context.designSystem && el.context.designSystem.font || {};
                const n = Object.keys(f).length;
                return n === 0 ? "font.js \u2014 empty by decision" : "font.js \u2014 " + n + ' faces';
            }
        },
        Note: {
            extends: 'BrandNote',
            text: 'No web font is loaded: the product renders in system Helvetica Neue with the honest weight set. Loading a real face (with a true 600/800) is decision D8, deferred.'
        }
    }
};
const $e8de0582c960bd48$export$972bf50ffa3ad861 = {
    display: 'grid',
    columns: 'repeat(2, 1fr)',
    gap: 'Z',
    '@mobileL': {
        columns: '1fr'
    },
    ChromePanel: {
        extends: 'BrandPanel',
        minHeight: 'F',
        align: 'start space-between',
        Head: {
            flow: 'y',
            gap: 'W',
            Title: {
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: 'Chrome register'
            },
            Sub: {
                tag: 'div',
                fontSize: 'Z',
                color: 'paragraph',
                text: "Shell, panels, tables, forms \u2014 monochrome, washes for state, solid-ink actions."
            }
        },
        DemoRow: {
            flow: 'x',
            gap: 'Z',
            align: 'center start',
            MockPrimary: {
                theme: 'primary',
                round: 'radiusPill',
                minHeight: 'controlHCompact',
                padding: '- A',
                fontSize: 'Z',
                fontWeight: '500',
                align: 'center center',
                cursor: 'pointer',
                text: 'Primary'
            },
            MockQuiet: {
                theme: 'tertiary',
                round: 'radiusPill',
                minHeight: 'controlHCompact',
                padding: '- A',
                fontSize: 'Z',
                align: 'center center',
                cursor: 'pointer',
                text: 'Quiet'
            }
        }
    },
    PosterPanel: {
        background: 'highlight',
        color: 'highlight-reversed',
        round: 'radiusCard',
        padding: 'B',
        minHeight: 'F',
        flow: 'y',
        align: 'start space-between',
        Numeral: {
            fontSize: 'G',
            lineHeight: '1',
            letterSpacing: '-0.03em',
            Thin: {
                tag: 'span',
                fontWeight: '200',
                text: '4'
            },
            Heavy: {
                tag: 'span',
                fontWeight: '700',
                text: '.5:1'
            }
        },
        Caption: {
            fontSize: 'Z',
            fontWeight: '300',
            opacity: '.65',
            text: "Poster register \u2014 display extremes, binary ink, one statement"
        }
    }
};

});

parcelRegister("2Hu0Y", function(module, exports) {

$parcel$export(module.exports, "BrandSpacingBars", () => $1f76e136741f23ce$export$27c90c4e6707817c);
$parcel$export(module.exports, "BrandRadiusBoard", () => $1f76e136741f23ce$export$8892c043a09b045);
$parcel$export(module.exports, "BrandControlScale", () => $1f76e136741f23ce$export$3b9550df21977b13);
$parcel$export(module.exports, "BrandFixedSizes", () => $1f76e136741f23ce$export$c5162eaca203a1d0);
// Spacing & sizes — bars measured off their own rendered widths, fixed-px
// tokens enumerated live from designSystem/sizes.js.
const $1f76e136741f23ce$export$27c90c4e6707817c = {
    flow: 'y',
    gap: 'Y',
    children: ()=>[
            'W',
            'X',
            'Y',
            'Z',
            'A',
            'B',
            'C',
            'D',
            'E',
            'F'
        ].map((letter)=>({
                flow: 'x',
                gap: 'B',
                align: 'center start',
                letter: letter,
                Letter: {
                    fontFamily: 'Code',
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: 'title',
                    width: 'C',
                    flexShrink: '0',
                    text: letter
                },
                Px: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    color: 'inactive',
                    width: 'C2',
                    flexShrink: '0',
                    // The generated sequence value itself (base × φⁿ), straight from the
                    // processed config.
                    text: (el)=>{
                        const sp = el.context.designSystem && el.context.designSystem.spacing;
                        const entry = sp && sp.sequence && sp.sequence[el.parent.letter];
                        return entry ? Math.round(entry.decimal * 10) / 10 + 'px' : "\u2014";
                    }
                },
                Bar: {
                    width: letter,
                    height: 'Z2',
                    round: 'Y',
                    background: 'inactive',
                    transition: 'A defaultBezier opacity',
                    ':hover': {
                        opacity: '.7'
                    }
                }
            })),
    PhiNote: {
        extends: 'BrandNote',
        padding: 'Z - - -',
        text: (el)=>{
            const sp = el.context.designSystem && el.context.designSystem.spacing || {};
            return 'Golden-ratio scale: base ' + sp.base + ', ratio ' + sp.ratio + ". The scale is em-relative on purpose \u2014 rhythm breathes with type. Control geometry does not ride it (see sizes below).";
        }
    }
};
const $1f76e136741f23ce$export$8892c043a09b045 = {
    display: 'grid',
    columns: 'repeat(4, minmax(0, 1fr))',
    gap: 'Z',
    '@mobileL': {
        columns: 'repeat(2, minmax(0, 1fr))'
    },
    children: (el)=>{
        const ds = el.context.designSystem || {};
        const shape = ds.shape || {};
        const base = ds.typography && ds.typography.base || 17;
        const seq = ds.spacing && ds.spacing.sequence || {};
        const roles = {
            radiusControl: 'buttons, inputs, menu items',
            radiusCard: 'cards, tiles, popover bodies',
            radiusSheet: 'modals, floating side panels, phone sheets',
            radiusPill: 'capsules: pills, toggles, tabs'
        };
        return Object.keys(roles).filter((name)=>name in shape).map((name)=>{
            const value = String(shape[name]);
            const em = /^[\d.]+em$/.test(value) ? parseFloat(value) : null;
            const letter = em === null ? null : Object.keys(seq).find((k)=>seq[k] && Math.abs(seq[k].decimal / base - em) < 0.01);
            return {
                flow: 'y',
                gap: 'Z',
                Tile: {
                    height: 'E',
                    round: name,
                    theme: 'common-box',
                    align: 'center center',
                    Value: {
                        fontFamily: 'Code',
                        fontSize: 'A2',
                        fontWeight: '700',
                        color: 'title',
                        text: em === null ? value : (em * base).toFixed(1) + 'px'
                    }
                },
                Name: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    fontWeight: '500',
                    color: 'title',
                    text: name
                },
                Letter: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    color: 'inactive',
                    text: em === null ? 'fixed' : (letter ? 'letter ' + letter + " \xb7 " : '') + value + " \xb7 at " + base + 'px'
                },
                Role: {
                    fontSize: 'Y',
                    color: 'inactive',
                    text: roles[name]
                }
            };
        });
    }
};
const $1f76e136741f23ce$export$3b9550df21977b13 = {
    flow: 'y',
    gap: 'Z',
    Row: {
        flow: 'x',
        wrap: 'wrap',
        gap: 'Z',
        align: 'center start',
        Standard: {
            theme: 'primary',
            round: 'radiusPill',
            minHeight: 'controlH',
            padding: '- A',
            fontSize: 'Z2',
            fontWeight: '500',
            align: 'center center',
            cursor: 'pointer',
            text: "Standard \xb7 controlH"
        },
        Compact: {
            theme: 'secondary',
            round: 'radiusPill',
            minHeight: 'controlHCompact',
            padding: '- Z2',
            fontSize: 'Z',
            fontWeight: '500',
            align: 'center center',
            cursor: 'pointer',
            text: "Compact \xb7 controlHCompact"
        },
        Input: {
            theme: 'field',
            round: 'radiusControl',
            minHeight: 'controlH',
            fontSize: 'Z2',
            padding: '- Z2',
            placeholder: "Field \xb7 radiusControl"
        }
    },
    ScaleNote: {
        extends: 'BrandNote',
        text: "One control scale: fixed-px minHeight (44px standard \u2014 controlH, 36px compact \u2014 controlHCompact), pinned fontSize, em padding. Capsule controls, rounded-rect fields. Call sites never override padding."
    }
};
const $1f76e136741f23ce$export$c5162eaca203a1d0 = {
    flow: 'y',
    gap: 'B',
    Avatars: {
        flow: 'y',
        gap: 'Z',
        BrandSubhead: {
            text: 'Avatar circles',
            padding: '0'
        },
        Row: {
            flow: 'x',
            align: 'end start',
            gap: 'A',
            wrap: 'wrap',
            children: ()=>[
                    [
                        'avatarXs',
                        '24px'
                    ],
                    [
                        'avatarSm',
                        '36px'
                    ],
                    [
                        'avatarMd',
                        '48px'
                    ],
                    [
                        'avatarLg',
                        '54px'
                    ],
                    [
                        'avatarXl',
                        '72px'
                    ]
                ].map((p)=>({
                        flow: 'y',
                        align: 'center center',
                        gap: 'Y',
                        Circle: {
                            boxSize: p[0],
                            round: 'radiusPill',
                            background: 'overlayStrong'
                        },
                        L: {
                            fontFamily: 'Code',
                            fontSize: 'X2',
                            color: 'inactive',
                            text: p[0] + " \xb7 " + p[1]
                        }
                    }))
        }
    },
    IconBoxes: {
        flow: 'y',
        gap: 'Z',
        BrandSubhead: {
            text: 'Icon containers',
            padding: '0'
        },
        Row: {
            flow: 'x',
            align: 'end start',
            gap: 'A',
            wrap: 'wrap',
            children: ()=>[
                    [
                        'iconXs',
                        '12px'
                    ],
                    [
                        'iconSm',
                        '16px'
                    ],
                    [
                        'iconMd',
                        '20px'
                    ],
                    [
                        'iconLg',
                        '24px'
                    ],
                    [
                        'iconXl',
                        '32px'
                    ]
                ].map((p)=>({
                        flow: 'y',
                        align: 'center center',
                        gap: 'Y',
                        Boxy: {
                            boxSize: p[0],
                            round: 'Y',
                            background: 'overlayStrong'
                        },
                        L: {
                            fontFamily: 'Code',
                            fontSize: 'X2',
                            color: 'inactive',
                            text: p[0] + " \xb7 " + p[1]
                        }
                    }))
        }
    },
    // The floating overlays' geometry (white-label spec §4.5), read live from
    // sizes.js: each width drawn at its real length (capped to the column).
    Overlays: {
        flow: 'y',
        gap: 'Z',
        BrandSubhead: {
            text: 'Overlay geometry',
            padding: '0'
        },
        Widths: {
            flow: 'y',
            gap: 'Z',
            children: (el)=>{
                const sizes = el.context.designSystem && el.context.designSystem.sizes || {};
                return [
                    [
                        'overlaySm',
                        'confirms, small pickers'
                    ],
                    [
                        'overlayMd',
                        'create and edit forms'
                    ],
                    [
                        'overlayLg',
                        'floating side panels'
                    ],
                    [
                        'overlayXl',
                        'wide work surfaces'
                    ]
                ].filter((p)=>p[0] in sizes).map((p)=>({
                        flow: 'y',
                        gap: 'Y',
                        maxWidth: '100%',
                        Bar: {
                            width: p[0],
                            maxWidth: '100%',
                            height: 'Z',
                            round: 'radiusPill',
                            background: 'overlayStrong'
                        },
                        L: {
                            fontFamily: 'Code',
                            fontSize: 'X2',
                            color: 'inactive',
                            text: p[0] + " \xb7 " + sizes[p[0]] + " \u2014 " + p[1]
                        }
                    }));
            }
        },
        Extras: {
            flow: 'x',
            wrap: 'wrap',
            align: 'center start',
            gap: 'B',
            Gutter: {
                flow: 'x',
                align: 'center start',
                gap: 'Y',
                Swatch: {
                    boxSize: 'overlayGutter',
                    round: 'X',
                    background: 'overlayStrong'
                },
                L: {
                    fontFamily: 'Code',
                    fontSize: 'X2',
                    color: 'inactive',
                    text: (el)=>"overlayGutter \xb7 " + ((el.context.designSystem.sizes || {}).overlayGutter || "\u2014") + " \u2014 every floating overlay\u2019s inset from its frame"
                }
            },
            Grabber: {
                flow: 'x',
                align: 'center start',
                gap: 'Y',
                Pill: {
                    width: 'grabberW',
                    height: 'grabberH',
                    round: 'radiusPill',
                    background: 'line'
                },
                L: {
                    fontFamily: 'Code',
                    fontSize: 'X2',
                    color: 'inactive',
                    text: (el)=>{
                        const z = el.context.designSystem.sizes || {};
                        return "grabberW \xd7 grabberH \xb7 " + (z.grabberW || "\u2014") + " \xd7 " + (z.grabberH || "\u2014") + " \u2014 the phone sheet\u2019s grabber";
                    }
                }
            }
        }
    },
    Hairlines: {
        flow: 'y',
        gap: 'Z',
        maxWidth: 'H',
        BrandSubhead: {
            text: 'Hairlines & tap slop',
            padding: '0'
        },
        H1Line: {
            height: 'hairline',
            background: 'line',
            width: '100%'
        },
        H2Line: {
            height: 'hairline2',
            background: 'line',
            width: '100%'
        },
        SlopNote: {
            extends: 'BrandNote',
            text: "hairline 1px \xb7 hairline2 2px \u2014 the stroke budget lives in dense tables only. tapSlop -6px grows a control\u2019s hit area on coarse pointers without growing its visual size \u2014 fixed px because tap slop is device-physical."
        }
    }
};

});

parcelRegister("giWv6", function(module, exports) {

$parcel$export(module.exports, "BrandShadowBoard", () => $bdebb4cfad8bbc73$export$341bd68a64a85430);
$parcel$export(module.exports, "BrandOverlayFrame", () => $bdebb4cfad8bbc73$export$3fd2baf209a6be39);
$parcel$export(module.exports, "BrandOverlayPage", () => $bdebb4cfad8bbc73$export$446861e3965fbb96);
$parcel$export(module.exports, "BrandOverlayPageCard", () => $bdebb4cfad8bbc73$export$628ec2a9e5f7d4bf);
$parcel$export(module.exports, "BrandOverlayVeil", () => $bdebb4cfad8bbc73$export$ec2a32a340bd6d3);
$parcel$export(module.exports, "BrandMicroLabel", () => $bdebb4cfad8bbc73$export$c681693982cb5a08);
$parcel$export(module.exports, "BrandOverlayCenterSheet", () => $bdebb4cfad8bbc73$export$b0b5c4035ba70a9);
$parcel$export(module.exports, "BrandOverlaySidePanel", () => $bdebb4cfad8bbc73$export$9bb04bc340fd71cc);
$parcel$export(module.exports, "BrandOverlayAction", () => $bdebb4cfad8bbc73$export$e8d1f40c748dad6f);
$parcel$export(module.exports, "BrandOverlayFact", () => $bdebb4cfad8bbc73$export$7ed34316b5f83779);
$parcel$export(module.exports, "BrandOverlayPhoneSheet", () => $bdebb4cfad8bbc73$export$f8c50b046ccdda5f);
$parcel$export(module.exports, "BrandOverlayPopover", () => $bdebb4cfad8bbc73$export$4ec1554f497093ca);
$parcel$export(module.exports, "BrandOverlayMenuRow", () => $bdebb4cfad8bbc73$export$ea33238dabd67eed);
$parcel$export(module.exports, "BrandOverlayTrigger", () => $bdebb4cfad8bbc73$export$3671f9da6529d6cb);
$parcel$export(module.exports, "BrandOverlayCenter", () => $bdebb4cfad8bbc73$export$87a59e59c1b08793);
$parcel$export(module.exports, "BrandOverlaySide", () => $bdebb4cfad8bbc73$export$e83f3d25c5b1e370);
$parcel$export(module.exports, "BrandOverlayPhone", () => $bdebb4cfad8bbc73$export$6631d812e6f6adf6);
$parcel$export(module.exports, "BrandOverlayPopoverFrame", () => $bdebb4cfad8bbc73$export$26082d3cc5dbc384);
$parcel$export(module.exports, "BrandOverlaySpecimen", () => $bdebb4cfad8bbc73$export$fbb27857e41ab29d);
// Elevation — the entire vocabulary is two shadows, each ONE token of three
// layers (a 1px ring, a contact shadow, an ambient shadow), shown ON the
// surface each belongs to, over the real stage ground, with the [light, dark]
// values printed live one layer per line. Focus rings live in shadow.js too
// but are not elevation; they are listed on the accessibility page.
const $bdebb4cfad8bbc73$export$341bd68a64a85430 = {
    flow: 'y',
    gap: 'Z',
    Stage: {
        display: 'grid',
        columns: 'repeat(2, minmax(0, 1fr))',
        gap: 'C',
        padding: 'C',
        round: 'radiusSheet',
        background: 'stage',
        '@mobileL': {
            columns: 'minmax(0, 1fr)'
        },
        children: (el)=>{
            const shadows = el.context.designSystem && el.context.designSystem.shadow || {};
            const roles = {
                float: "Things that hover over live content \u2014 popovers, menus, toasts, floating islands, the chosen segment thumb, a card while it is dragged.",
                overlay: "The sheets \u2014 modals, floating side panels, phone sheets. Always on the opaque dialog surface."
            };
            const half = (entry, scheme, i)=>entry['@' + scheme] && entry['@' + scheme].value || (Array.isArray(entry) ? entry[i] : entry.value) || '';
            const layers = (value)=>String(value).split(/,(?![^(]*\))/).map((l)=>l.trim()).filter(Boolean);
            return Object.keys(shadows).filter((name)=>name in roles).map((name)=>{
                const entry = shadows[name] || {};
                const lines = [];
                for (const [scheme, i] of [
                    [
                        'light',
                        0
                    ],
                    [
                        'dark',
                        1
                    ]
                ])layers(half(entry, scheme, i)).forEach((layer, n)=>lines.push({
                        extends: 'BrandCode',
                        fontSize: 'Y',
                        whiteSpace: 'pre',
                        text: (n === 0 ? scheme.padEnd(7) : ' '.repeat(7)) + layer
                    }));
                return {
                    theme: name === 'overlay' ? 'dialog' : 'common-box',
                    round: name === 'overlay' ? 'radiusSheet' : 'radiusCard',
                    shadow: name,
                    padding: 'B',
                    flow: 'y',
                    gap: 'Z',
                    minHeight: 'F',
                    minWidth: '0',
                    align: 'start space-between',
                    Name: {
                        fontFamily: 'Code',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        text: name
                    },
                    Role: {
                        fontSize: 'Z',
                        color: 'paragraph',
                        lineHeight: '1.5',
                        text: roles[name]
                    },
                    Values: {
                        flow: 'y',
                        gap: 'W',
                        maxWidth: '100%',
                        overflow: 'auto',
                        children: lines
                    }
                };
            });
        }
    },
    BrandNote: {
        text: "Two shadow tokens, three layers each: the 1px ring is the edge an elevated surface needs on a ground of its own colour, so in-page cards stay borderless and only floating things carry one. Everything else casts nothing \u2014 stage and raised surfaces separate by fill contrast, not strokes and not glows."
    }
};
const $bdebb4cfad8bbc73$export$3fd2baf209a6be39 = {
    tag: 'figure',
    margin: '0',
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    state: {
        n: 0
    },
    Caption: {
        tag: 'figcaption',
        flow: 'x',
        wrap: 'wrap',
        align: 'center flex-start',
        gap: 'Z',
        Name: {
            fontSize: 'Z1',
            fontWeight: '500',
            color: 'title',
            text: (el)=>el.parent.parent.label
        },
        BrandCode: {
            fontSize: 'Y',
            whiteSpace: 'normal',
            text: (el)=>el.parent.parent.spec
        },
        Button: {
            type: 'button',
            marginLeft: 'auto',
            theme: 'layer',
            color: 'title',
            round: 'radiusPill',
            minHeight: 'controlHCompact',
            padding: '0 A',
            fontSize: 'Z',
            fontWeight: '500',
            cursor: 'pointer',
            transitionProperty: 'background, transform',
            transition: 'A defaultBezier',
            ':hover': {
                background: 'selected'
            },
            ':active': {
                background: 'selected',
                transform: 'scale(0.97)'
            },
            text: 'Replay',
            'aria-label': (el)=>'Replay the ' + String(el.parent.parent.label || '').toLowerCase() + ' entrance',
            onClick: (e, el, s)=>s.update({
                    n: (s.n || 0) + 1
                })
        }
    },
    Viewport: {
        display: 'grid',
        height: 'H',
        overflow: 'hidden',
        round: 'radiusCard',
        background: 'stage',
        attr: {
            inert: ''
        },
        childProps: {
            gridArea: '1 / 1',
            minWidth: '0',
            minHeight: '0'
        },
        BrandOverlayPage: {},
        Layer: {
            display: 'grid',
            childProps: {
                gridArea: '1 / 1'
            }
        }
    }
};
const $bdebb4cfad8bbc73$export$446861e3965fbb96 = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    overflow: 'hidden',
    Bar: {
        flow: 'x',
        align: 'baseline flex-start',
        gap: 'Z',
        Title: {
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: 'Contacts'
        },
        Count: {
            fontSize: 'B',
            fontWeight: '700',
            color: 'inactive',
            fontVariantNumeric: 'tabular-nums',
            text: '301'
        }
    },
    Cards: {
        flow: 'x',
        wrap: 'wrap',
        gap: 'Z',
        childExtends: 'BrandOverlayPageCard',
        children: [
            {
                person: 'Nino Beridze',
                meta: "CEO \xb7 Tbilisi",
                initials: 'NB'
            },
            {
                person: "\u10DA\u10D4\u10D5\u10D0\u10DC \u10D9\u10D0\u10DE\u10D0\u10DC\u10D0\u10EB\u10D4",
                meta: 'Founder',
                initials: "\u10DA\u10D9"
            },
            {
                person: 'Ana Silva',
                meta: 'Head of sales',
                initials: 'AS'
            },
            {
                person: "\u0418\u0432\u0430\u043D \u041F\u0435\u0442\u0440\u043E\u0432",
                meta: 'Investor',
                initials: "\u0418\u041F"
            },
            {
                person: "\u674E\u5A1C",
                meta: 'Partner',
                initials: "\u674E"
            },
            {
                person: 'Saba & Partners',
                meta: 'Company',
                initials: 'SP'
            },
            {
                person: 'Mariam Chikovani',
                meta: 'Designer',
                initials: 'MC'
            },
            {
                person: 'Lukas Weber',
                meta: 'COO',
                initials: 'LW'
            },
            {
                person: 'Tamar Gelashvili',
                meta: 'Lawyer',
                initials: 'TG'
            },
            {
                person: 'Omar Haddad',
                meta: 'Advisor',
                initials: 'OH'
            }
        ]
    }
};
const $bdebb4cfad8bbc73$export$628ec2a9e5f7d4bf = {
    theme: 'card',
    round: 'radiusCard',
    padding: 'Z1 A',
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    flex: '1 1 F',
    minWidth: '0',
    Initials: {
        theme: 'layer',
        boxSize: 'avatarSm',
        round: '100%',
        align: 'center center',
        flexShrink: '0',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'title',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        text: (el)=>el.parent.initials
    },
    Who: {
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        Person: {
            fontSize: 'Z1',
            fontWeight: '500',
            color: 'title',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: (el)=>el.parent.parent.person
        },
        Meta: {
            fontSize: 'Z',
            color: 'inactive',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: (el)=>el.parent.parent.meta
        }
    }
};
const $bdebb4cfad8bbc73$export$ec2a32a340bd6d3 = {
    theme: 'backdrop',
    animationName: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'both',
    '@reduceTransparency': {
        backdropFilter: 'none'
    }
};
const $bdebb4cfad8bbc73$export$c681693982cb5a08 = {
    tag: 'span',
    fontFamily: 'Code',
    fontSize: 'Y',
    fontWeight: '500',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'inactive'
};
const $bdebb4cfad8bbc73$export$b0b5c4035ba70a9 = {
    theme: 'dialog',
    shadow: 'overlay',
    round: 'radiusSheet',
    width: 'overlayMd',
    maxWidth: '100%',
    padding: 'B',
    flow: 'y',
    gap: 'B',
    transformOrigin: 'center',
    animationName: 'modalIn',
    animationDuration: 'D',
    animationTimingFunction: 'springBezier',
    animationFillMode: 'both',
    ModalHeader: {
        Hgroup: {
            flow: 'y',
            gap: 'X',
            BrandMicroLabel: {
                order: '-1',
                text: 'Directory'
            },
            H: {
                text: 'New contact'
            },
            P: {
                margin: '0',
                text: 'A person or a company, with one email.'
            }
        }
    },
    InputField: {
        Title: {
            text: 'Email'
        },
        Input: {
            type: 'email',
            placeholder: 'name@company.com'
        }
    },
    Actions: {
        flow: 'x',
        align: 'center flex-end',
        gap: 'Z',
        CancelButton: {
            text: 'Cancel'
        },
        CheckButton: {
            icon: 'plus',
            text: 'Add contact'
        }
    }
};
const $bdebb4cfad8bbc73$export$9bb04bc340fd71cc = {
    theme: 'dialog',
    shadow: 'overlay',
    round: 'radiusSheet',
    width: 'overlayLg',
    maxWidth: '100%',
    padding: 'B',
    flow: 'y',
    gap: 'B',
    overflow: 'hidden',
    transformOrigin: 'right center',
    animationName: 'panelIn',
    animationDuration: 'D',
    animationTimingFunction: 'springBezier',
    animationFillMode: 'both',
    ModalHeader: {
        Hgroup: {
            flow: 'y',
            gap: 'X',
            BrandMicroLabel: {
                order: '-1',
                text: "Person \xb7 CEO"
            },
            H: {
                text: 'Nino Beridze'
            },
            P: {
                margin: '0',
                text: 'nino@beridze.ge'
            }
        }
    },
    Actions: {
        flow: 'x',
        gap: 'B',
        childExtends: 'BrandOverlayAction',
        children: [
            {
                glyph: 'plus',
                label: 'New deal'
            },
            {
                glyph: 'edit',
                label: 'Log'
            },
            {
                glyph: 'email',
                label: 'Email'
            }
        ]
    },
    Facts: {
        flow: 'y',
        gap: 'Z',
        BrandMicroLabel: {
            text: 'Overview'
        },
        Rows: {
            flow: 'y',
            gap: 'Z',
            childExtends: 'BrandOverlayFact',
            children: [
                {
                    term: 'Interactions',
                    detail: '12'
                },
                {
                    term: 'Outstanding',
                    detail: 'USD 4,800.00'
                },
                {
                    term: 'Bookings',
                    detail: '3'
                }
            ]
        }
    }
};
const $bdebb4cfad8bbc73$export$e8d1f40c748dad6f = {
    flow: 'y',
    align: 'center flex-start',
    gap: 'Y',
    Plate: {
        theme: 'layer',
        boxSize: 'controlH',
        round: '100%',
        align: 'center center',
        color: 'title',
        Icon: {
            name: (el)=>el.parent.parent.glyph,
            boxSize: 'iconMd'
        }
    },
    ActionLabel: {
        fontSize: 'Z',
        color: 'caption',
        text: (el)=>el.parent.label
    }
};
const $bdebb4cfad8bbc73$export$7ed34316b5f83779 = {
    flow: 'x',
    align: 'baseline space-between',
    gap: 'A',
    Term: {
        fontSize: 'Z1',
        color: 'inactive',
        text: (el)=>el.parent.term
    },
    Detail: {
        fontFamily: 'Code',
        fontSize: 'Z1',
        fontWeight: '500',
        color: 'title',
        fontVariantNumeric: 'tabular-nums',
        text: (el)=>el.parent.detail
    }
};
const $bdebb4cfad8bbc73$export$f8c50b046ccdda5f = {
    theme: 'dialog',
    shadow: 'overlay',
    round: 'radiusSheet radiusSheet 0 0',
    padding: 'Z B B',
    flow: 'y',
    gap: 'A',
    transformOrigin: 'bottom center',
    animationName: 'modalInUp',
    animationDuration: 'D',
    animationTimingFunction: 'springBezier',
    animationFillMode: 'both',
    Grabber: {
        width: 'grabberW',
        height: 'grabberH',
        round: 'radiusPill',
        background: 'line',
        alignSelf: 'center',
        'aria-hidden': 'true'
    },
    ModalHeader: {
        Hgroup: {
            H: {
                text: 'Filters'
            },
            P: {
                margin: '0',
                text: 'Kind, role and owner.'
            }
        }
    },
    Choices: {
        flow: 'y',
        gap: 'W',
        childExtends: 'BrandOverlayMenuRow',
        children: [
            {
                label: 'Everyone',
                current: true
            },
            {
                label: 'People'
            },
            {
                label: 'Companies'
            }
        ]
    },
    CheckButton: {
        icon: null,
        text: 'Show 24 contacts',
        width: '100%'
    }
};
const $bdebb4cfad8bbc73$export$4ec1554f497093ca = {
    theme: 'dialog',
    shadow: 'float',
    round: 'radiusCard',
    minWidth: 'F',
    padding: 'X',
    flow: 'y',
    gap: 'W',
    transformOrigin: 'top right',
    animationName: 'dropdownOpen',
    animationDuration: 'B',
    animationTimingFunction: 'springBezier',
    animationFillMode: 'both',
    childExtends: 'BrandOverlayMenuRow',
    children: [
        {
            label: 'Newest first',
            current: true
        },
        {
            label: "Name A\u2013Z"
        },
        {
            label: 'Company'
        }
    ]
};
const $bdebb4cfad8bbc73$export$ea33238dabd67eed = {
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    padding: 'Z A',
    round: 'radiusControl',
    fontSize: 'Z1',
    color: 'title',
    background: (el)=>el.current ? 'selected' : 'transparent',
    RowLabel: {
        text: (el)=>el.parent.label
    },
    Icon: {
        name: 'check',
        boxSize: 'iconSm',
        visibility: (el)=>el.parent.current ? 'visible' : 'hidden'
    }
};
const $bdebb4cfad8bbc73$export$3671f9da6529d6cb = {
    theme: 'layer',
    color: 'title',
    round: 'radiusPill',
    minHeight: 'controlHCompact',
    padding: '0 A',
    flow: 'x',
    align: 'center center',
    gap: 'Y',
    fontSize: 'Z1',
    fontWeight: '500',
    TriggerLabel: {
        text: 'Sort'
    },
    Icon: {
        name: 'chevronDown',
        boxSize: 'iconSm'
    }
};
const $bdebb4cfad8bbc73$export$87a59e59c1b08793 = {
    extends: 'BrandOverlayFrame',
    label: 'Centre sheet',
    spec: "dialog \xb7 overlay \xb7 radiusSheet \xb7 overlayMd \u2014 modalIn D springBezier, out modalOut C",
    Viewport: {
        Layer: {
            children: (el, s)=>[
                    {
                        key: 'veil' + (s.n || 0),
                        extends: 'BrandOverlayVeil'
                    },
                    {
                        key: 'sheet' + (s.n || 0),
                        extends: 'BrandOverlayCenterSheet',
                        placeSelf: 'center',
                        margin: 'overlayGutter'
                    }
                ]
        }
    }
};
const $bdebb4cfad8bbc73$export$e83f3d25c5b1e370 = {
    extends: 'BrandOverlayFrame',
    label: 'Side panel',
    spec: "dialog \xb7 overlay \xb7 radiusSheet \xb7 overlayLg, inset overlayGutter \u2014 panelIn D springBezier, out panelOut C",
    Viewport: {
        Layer: {
            children: (el, s)=>[
                    {
                        key: 'veil' + (s.n || 0),
                        extends: 'BrandOverlayVeil'
                    },
                    {
                        key: 'panel' + (s.n || 0),
                        extends: 'BrandOverlaySidePanel',
                        justifySelf: 'end',
                        alignSelf: 'stretch',
                        margin: 'overlayGutter'
                    }
                ]
        }
    }
};
const $bdebb4cfad8bbc73$export$6631d812e6f6adf6 = {
    extends: 'BrandOverlayFrame',
    label: 'Phone sheet',
    spec: "dialog \xb7 overlay \xb7 radiusSheet top corners \xb7 grabber \u2014 modalInUp D springBezier, out modalOutDown C",
    Viewport: {
        width: '100%',
        maxWidth: 'G1',
        margin: '0 auto',
        Layer: {
            children: (el, s)=>[
                    {
                        key: 'veil' + (s.n || 0),
                        extends: 'BrandOverlayVeil'
                    },
                    {
                        key: 'sheet' + (s.n || 0),
                        extends: 'BrandOverlayPhoneSheet',
                        alignSelf: 'end',
                        justifySelf: 'stretch'
                    }
                ]
        }
    }
};
const $bdebb4cfad8bbc73$export$26082d3cc5dbc384 = {
    extends: 'BrandOverlayFrame',
    label: 'Popover',
    spec: "dialog \xb7 float \xb7 radiusCard, no veil \u2014 dropdownOpen B springBezier",
    Viewport: {
        // The trigger sits in the page's own toolbar line (top right, level with
        // "Contacts 301"); the popover opens under it from its right corner.
        Layer: {
            alignContent: 'start',
            justifyItems: 'end',
            padding: 'B',
            children: (el, s)=>[
                    {
                        key: 'trigger',
                        extends: 'BrandOverlayTrigger',
                        gridArea: '1 / 1'
                    },
                    {
                        key: 'popover' + (s.n || 0),
                        extends: 'BrandOverlayPopover',
                        gridArea: '2 / 1',
                        marginTop: 'Y'
                    }
                ]
        }
    }
};
const $bdebb4cfad8bbc73$export$fbb27857e41ab29d = {
    display: 'grid',
    columns: 'repeat(2, minmax(0, 1fr))',
    gap: 'C B',
    '@tabletS': {
        columns: 'minmax(0, 1fr)'
    },
    BrandOverlayCenter: {
        gridColumn: '1 / -1'
    },
    BrandOverlaySide: {
        gridColumn: '1 / -1'
    },
    BrandOverlayPhone: {},
    BrandOverlayPopoverFrame: {},
    BrandNote: {
        gridColumn: '1 / -1',
        text: 'One veil (the backdrop theme: scrim + 8px blur; only its opacity moves), one opaque sheet (dialog + the overlay elevation + radiusSheet), one spring for every entrance (springBezier) and exits one step faster on defaultBezier. Nothing docks: a side panel floats overlayGutter in from its frame with all four corners rounded; on a phone every blocking overlay becomes the bottom sheet. Popovers keep no veil and carry the lighter float elevation.'
    }
};

});

parcelRegister("cOCNS", function(module, exports) {

$parcel$export(module.exports, "BrandTimingBoard", () => $95484116bf603e95$export$d8141395c107550b);
$parcel$export(module.exports, "BrandBezierPlot", () => $95484116bf603e95$export$8983a0fc2c002b20);
$parcel$export(module.exports, "BrandOverlayMotionBoard", () => $95484116bf603e95$export$cca647a52d89e832);
$parcel$export(module.exports, "BrandOverlayMotionRow", () => $95484116bf603e95$export$d49a3e953872570e);
$parcel$export(module.exports, "BrandMotionStep", () => $95484116bf603e95$export$d5a9bb04a6c49749);
$parcel$export(module.exports, "BrandAnimDot", () => $95484116bf603e95$export$e4fbec7bf19e294b);
$parcel$export(module.exports, "BrandAnimationBoard", () => $95484116bf603e95$export$2fe1f95f337dfa2f);
// Motion — durations you can feel (hover the chips; the transition IS the
// token) and every named keyframe, replayable, enumerated live.
const $95484116bf603e95$export$d8141395c107550b = {
    flow: 'y',
    gap: 'Z',
    Chips: {
        flow: 'x',
        wrap: 'wrap',
        gap: 'Z',
        children: ()=>[
                'Z',
                'A',
                'B',
                'C',
                'D'
            ].map((letter)=>({
                    flow: 'y',
                    align: 'center center',
                    gap: 'Y',
                    padding: 'A2 B',
                    round: 'radiusCard',
                    theme: 'common-box',
                    cursor: 'pointer',
                    letter: letter,
                    transition: letter + ' defaultBezier transform',
                    ':hover': {
                        transform: 'translateY(-8%)'
                    },
                    L: {
                        fontFamily: 'Code',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        text: letter
                    },
                    Ms: {
                        fontFamily: 'Code',
                        fontSize: 'Y',
                        color: 'inactive',
                        text: (el)=>{
                            const t = el.context.designSystem && el.context.designSystem.timing;
                            const entry = t && t.sequence && t.sequence[el.parent.letter];
                            return entry ? Math.round(entry.decimal) + 'ms' : "\u2014";
                        }
                    }
                }))
    },
    // Two curves, each drawn from its own token: `defaultBezier` for exits,
    // hovers and colour; `springBezier` (PageSlot's iOS curve) for overlay
    // entrances only — a fast start and a long, soft settle.
    Curves: {
        flow: 'x',
        wrap: 'wrap',
        gap: 'A',
        childExtends: 'BrandBezierPlot',
        children: [
            {
                token: 'defaultBezier',
                use: "exits, hovers, colour \u2014 every micro-state"
            },
            {
                token: 'springBezier',
                use: "overlay entrances \u2014 sheets, panels, phone sheets, popovers, toasts"
            }
        ]
    },
    BudgetNote: {
        extends: 'BrandNote',
        text: "The motion budget: opacity + transform \u2264 10% travel, nothing else animates, exits one step faster than enters. Hover a chip \u2014 the lift you feel is that letter\u2019s duration."
    }
};
const $95484116bf603e95$export$8983a0fc2c002b20 = {
    flow: 'x',
    align: 'center start',
    gap: 'Z',
    padding: 'Z A Z Z',
    round: 'radiusCard',
    theme: 'common-box',
    minWidth: '0',
    Svg: {
        viewBox: '-4 -4 108 108',
        boxSize: 'C1',
        flexShrink: '0',
        color: 'title',
        'aria-hidden': 'true',
        html: (el)=>{
            const t = el.context.designSystem && el.context.designSystem.timing || {};
            const m = /cubic-bezier\(([^)]+)\)/.exec(String(t[el.parent.token] || ''));
            if (!m) return '';
            const [x1, y1, x2, y2] = m[1].split(',').map((n)=>Number(n));
            const p = (x, y)=>(x * 100).toFixed(1) + ',' + ((1 - y) * 100).toFixed(1);
            return '<path d="M0,100 L100,100 M0,100 L0,0" fill="none" stroke="currentColor" stroke-opacity=".2" stroke-width="1"/><path d="M' + p(0, 0) + ' C' + p(x1, y1) + ' ' + p(x2, y2) + ' ' + p(1, 1) + '" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>';
        }
    },
    Words: {
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        BrandCode: {
            text: (el)=>{
                const t = el.context.designSystem && el.context.designSystem.timing || {};
                return el.parent.parent.token + ' = ' + (t[el.parent.parent.token] || "\u2014");
            }
        },
        Use: {
            fontSize: 'Z',
            color: 'paragraph',
            text: (el)=>el.parent.parent.use
        }
    }
};
const $95484116bf603e95$export$cca647a52d89e832 = {
    flow: 'y',
    gap: 'Z',
    Head: {
        display: 'grid',
        columns: 'repeat(3, minmax(0, 1fr))',
        gap: 'A',
        padding: '0 A',
        '@mobileL': {
            display: 'none'
        },
        BrandMicroLabel_what: {
            text: 'Presentation'
        },
        BrandMicroLabel_enter: {
            text: 'Enter'
        },
        BrandMicroLabel_leave: {
            text: 'Exit'
        }
    },
    Rows: {
        flow: 'y',
        gap: 'W',
        childExtends: 'BrandOverlayMotionRow',
        children: [
            {
                what: 'Centre sheet',
                enter: [
                    'modalIn',
                    'D',
                    'springBezier'
                ],
                leave: [
                    'modalOut',
                    'C',
                    'defaultBezier'
                ],
                origin: 'rises 2.5%, settles from 0.97'
            },
            {
                what: 'Side panel',
                enter: [
                    'panelIn',
                    'D',
                    'springBezier'
                ],
                leave: [
                    'panelOut',
                    'C',
                    'defaultBezier'
                ],
                origin: 'slides 4% from its edge'
            },
            {
                what: 'Phone sheet',
                enter: [
                    'modalInUp',
                    'D',
                    'springBezier'
                ],
                leave: [
                    'modalOutDown',
                    'C',
                    'defaultBezier'
                ],
                origin: 'rises 6.5% from the bottom'
            },
            {
                what: 'Popover',
                enter: [
                    'dropdownOpen',
                    'B',
                    'springBezier'
                ],
                leave: [
                    'fadeOut',
                    'A',
                    'defaultBezier'
                ],
                origin: '6px from its anchor'
            },
            {
                what: 'Toast',
                enter: [
                    'fadeInUpShort',
                    'C',
                    'springBezier'
                ],
                leave: [
                    'modalOutDown',
                    'B',
                    'defaultBezier'
                ],
                origin: 'rises 6.5% above the composer'
            },
            {
                what: 'Veil',
                enter: [
                    'fadeIn',
                    'C',
                    'defaultBezier'
                ],
                leave: [
                    'fadeOut',
                    'B',
                    'defaultBezier'
                ],
                origin: "opacity only \u2014 never the blur"
            }
        ]
    },
    BrandNote: {
        text: 'Entrances ride springBezier one duration letter longer than their exit on defaultBezier. Only opacity and transform move. Under prefers-reduced-motion the reset lands every overlay on its final frame at once.'
    },
    Link: {
        href: '/elevation',
        alignSelf: 'start',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'title',
        text: "See them move at real size \u2192 Elevation \xb7 Overlays"
    }
};
const $95484116bf603e95$export$d49a3e953872570e = {
    display: 'grid',
    columns: 'repeat(3, minmax(0, 1fr))',
    gap: 'A',
    alignItems: 'start',
    padding: 'Z A',
    round: 'radiusControl',
    ':hover': {
        background: 'hover'
    },
    '@mobileL': {
        columns: 'minmax(0, 1fr)',
        gap: 'Y'
    },
    What: {
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        WhatName: {
            fontSize: 'Z1',
            fontWeight: '500',
            color: 'title',
            text: (el)=>el.parent.parent.what
        },
        WhatOrigin: {
            fontSize: 'Z',
            color: 'inactive',
            text: (el)=>el.parent.parent.origin
        }
    },
    BrandMotionStep_enter: {
        motion: (el)=>el.parent.enter
    },
    BrandMotionStep_leave: {
        motion: (el)=>el.parent.leave
    }
};
const $95484116bf603e95$export$d5a9bb04a6c49749 = {
    flow: 'y',
    gap: 'W',
    minWidth: '0',
    StepKeyframe: {
        fontFamily: 'Code',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'title',
        text: (el)=>{
            const [name, letter] = el.parent.motion || [];
            const t = el.context.designSystem && el.context.designSystem.timing || {};
            const entry = t.sequence && t.sequence[letter];
            return name + " \xb7 " + letter + (entry ? ' ' + Math.round(entry.decimal) + 'ms' : '');
        }
    },
    StepCurve: {
        fontFamily: 'Code',
        fontSize: 'Y',
        color: 'inactive',
        text: (el)=>(el.parent.motion || [])[2]
    }
};
const $95484116bf603e95$export$e4fbec7bf19e294b = {
    boxSize: 'B2',
    round: 'radiusControl',
    background: 'title',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'both'
};
const $95484116bf603e95$export$2fe1f95f337dfa2f = {
    flow: 'y',
    gap: 'Z',
    Grid: {
        display: 'grid',
        columns: 'repeat(6, 1fr)',
        gap: 'Z',
        '@screenS': {
            columns: 'repeat(4, 1fr)'
        },
        '@mobileL': {
            columns: 'repeat(2, 1fr)'
        },
        children: (el)=>{
            const animations = el.context.designSystem && el.context.designSystem.animation || {};
            return Object.keys(animations).map((name)=>({
                    flow: 'y',
                    gap: 'Y',
                    padding: 'A2 -',
                    cursor: 'pointer',
                    round: 'radiusCard',
                    state: {
                        n: 0
                    },
                    transition: 'A defaultBezier background',
                    ':hover': {
                        background: 'hover'
                    },
                    onClick: (e, el2, s)=>s.update({
                            n: (s.n || 0) + 1
                        }),
                    Stage: {
                        align: 'center center',
                        minHeight: 'D',
                        overflow: 'hidden',
                        children: (el2, s)=>[
                                {
                                    key: 'run' + (s.n || 0),
                                    extends: 'BrandAnimDot',
                                    animationName: name
                                }
                            ]
                    },
                    Name: {
                        fontFamily: 'Code',
                        fontSize: 'Y',
                        color: 'paragraph',
                        textAlign: 'center',
                        text: name
                    }
                }));
        }
    },
    ReplayNote: {
        extends: 'BrandNote',
        text: (el)=>{
            const animations = el.context.designSystem && el.context.designSystem.animation || {};
            return Object.keys(animations).length + " named keyframes \u2014 the entire vocabulary; no new keyframes without retiring an old one. Click a tile to replay. prefers-reduced-motion collapses all of it globally (the reset owns that guard).";
        }
    }
};

});

parcelRegister("gl7OC", function(module, exports) {

$parcel$export(module.exports, "BrandMediaBoard", () => $be54ab76d01ad802$export$b5f5f419d0d244ac);
// Breakpoints — enumerated live, and ALIVE: each row's dot lights up through
// that token's own media query, so the page demonstrates the breakpoints by
// responding to them. Resize the window and watch the rail change.
const $be54ab76d01ad802$export$b5f5f419d0d244ac = {
    flow: 'y',
    gap: 'W',
    children: (el)=>{
        const media = el.context.designSystem && el.context.designSystem.media || {};
        const themeReserved = [
            'light',
            'dark'
        ];
        return Object.keys(media).map((name)=>{
            const row = {
                flow: 'x',
                gap: 'Z',
                align: 'center start',
                padding: 'Y Z',
                round: 'radiusControl',
                ':hover': {
                    background: 'hover'
                },
                Name: {
                    fontFamily: 'Code',
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: 'title',
                    width: 'D',
                    flexShrink: '0',
                    text: name
                },
                Query: {
                    fontFamily: 'Code',
                    fontSize: 'Y',
                    color: 'inactive',
                    flex: '1',
                    minWidth: '0',
                    text: String(media[name])
                }
            };
            if (themeReserved.indexOf(name) !== -1) row.Status = {
                extends: 'BrandStatusTag',
                kind: 'reserved',
                text: 'theme-routed',
                flexShrink: '0'
            };
            else if (name === 'print') row.Status = {
                text: '',
                display: 'none'
            };
            else {
                row.Dot = {
                    boxSize: 'Z2',
                    round: 'radiusPill',
                    background: 'line',
                    opacity: '.4',
                    flexShrink: '0',
                    transition: 'A defaultBezier',
                    transitionProperty: 'background, opacity'
                };
                row.Dot['@' + name] = {
                    background: 'green',
                    opacity: '1'
                };
            }
            return row;
        });
    },
    LiveNote: {
        extends: 'BrandNote',
        padding: 'Z - - -',
        text: "A green dot means that query matches this viewport right now \u2014 the rows respond through their own tokens. @dark and @light are routed through the theme attribute, never through media queries."
    }
};

});

parcelRegister("4u2vB", function(module, exports) {

$parcel$export(module.exports, "BrandIconCell", () => $343be8f4d1938e47$export$dae45f234b932c5);
$parcel$export(module.exports, "BrandIconBoard", () => $343be8f4d1938e47$export$ad04e283643cf7f4);
// The sprite, complete, divided into pattern-derived categories — enumerated
// live, so the sum of the category counts always equals the sprite count.
const $343be8f4d1938e47$export$dae45f234b932c5 = {
    align: 'center center',
    width: '100%',
    aspectRatio: '1 / 1',
    round: 'radiusControl',
    position: 'relative',
    color: 'paragraph',
    cursor: 'default',
    transition: 'A defaultBezier',
    transitionProperty: 'background, color',
    ':hover': {
        background: 'hover',
        color: 'title',
        zIndex: '5'
    },
    // Tooltip reveal is STATE-driven (mouseenter/leave + a class conditional
    // on the Tip) — deliberately not a compound-pseudo selector: the deployed
    // runtime emits ':hover > span:last-child' rules but fails to attach the
    // generated class to factory-created children (verified live on 3.14.678),
    // so a CSS-only reveal silently dead-ends there. Flat handlers + class
    // conditionals are bedrock on every framework version in the field.
    state: {
        tipOpen: false
    },
    onMouseenter: (e, el, s)=>s.update({
            tipOpen: true
        }),
    onMouseleave: (e, el, s)=>s.update({
            tipOpen: false
        }),
    Icon: {
        fontSize: 'A2',
        name: (el)=>el.parent.iconName
    },
    Tip: {
        tag: 'span',
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        margin: '- - Y -',
        transform: 'translate(-50%, 6.5%)',
        opacity: '0',
        isOpen: (el, s)=>s.tipOpen,
        '.isOpen': {
            opacity: '1',
            transform: 'translate(-50%, 0)'
        },
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        fontFamily: 'Code',
        fontSize: 'Y',
        color: 'title',
        theme: 'common-box',
        shadow: 'overlay',
        round: 'radiusPill',
        padding: 'W Z',
        zIndex: '30',
        transition: 'A defaultBezier',
        transitionProperty: 'opacity, transform',
        text: (el)=>el.parent.iconName
    }
};
const $343be8f4d1938e47$export$ad04e283643cf7f4 = {
    flow: 'y',
    gap: 'B',
    children: (el)=>{
        const cats = el.call('brandIconCategories') || [];
        return cats.map((cat)=>({
                flow: 'y',
                gap: 'Z',
                Head: {
                    flow: 'x',
                    align: 'baseline start',
                    gap: 'Z',
                    CatTitle: {
                        tag: 'h3',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        text: cat.title
                    },
                    CatCount: {
                        fontFamily: 'Code',
                        fontSize: 'Y',
                        color: 'inactive',
                        text: String(cat.names.length)
                    }
                },
                Grid: {
                    display: 'grid',
                    // letter tokens don't resolve inside grid track strings — reference
                    // the scale's own emitted CSS variable instead (same value, one
                    // source). auto-fill + square cells = every category shares one
                    // aligned column rhythm.
                    columns: 'repeat(auto-fill, minmax(var(--spacing-C1), 1fr))',
                    gap: 'X',
                    children: cat.names.map((name)=>({
                            extends: 'BrandIconCell',
                            iconName: name,
                            attr: {
                                'data-icon': name
                            }
                        }))
                }
            }));
    }
};

});

parcelRegister("47jGf", function(module, exports) {

$parcel$export(module.exports, "BrandA11yBoard", () => $2ff715001ba4a686$export$145a03c16928aad5);
$parcel$export(module.exports, "BrandFocusDemo", () => $2ff715001ba4a686$export$1c1ac5a9df75ed3c);
$parcel$export(module.exports, "BrandResetBoard", () => $2ff715001ba4a686$export$299771e8dff1a292);
// Accessibility tokens made tangible: the vision-simulation filters applied
// to a live strip, and the global focus ring on real controls. Radii use the
// named sizes.js control-geometry tokens (radiusControl/radiusPill) directly —
// verified resolving via getSequenceValue's CONFIG.sizes lookup (tickets/smbls.md).
const $2ff715001ba4a686$export$145a03c16928aad5 = {
    flow: 'y',
    gap: 'Z',
    state: {
        filter: 'none'
    },
    // Filter defs come from designSystem/a11y.js itself (svgDefs). This is a
    // functional filter-definition injection from the token source — not an
    // icon (Rule 62 governs icons; the sprite stays untouched).
    FilterDefs: {
        tag: 'svg',
        width: '0',
        height: '0',
        position: 'absolute',
        'aria-hidden': 'true',
        html: (el)=>el.context.designSystem && el.context.designSystem.a11y && el.context.designSystem.a11y.svgDefs || ''
    },
    Options: {
        flow: 'x',
        wrap: 'wrap',
        gap: 'Y',
        children: (el, s)=>{
            const a11y = el.context.designSystem && el.context.designSystem.a11y || {};
            return (a11y.options || []).map((opt)=>({
                    tag: 'button',
                    type: 'button',
                    fontSize: 'Z',
                    padding: 'Y Z2',
                    round: 'radiusPill',
                    cursor: 'pointer',
                    background: 'transparent',
                    color: 'paragraph',
                    transition: 'A defaultBezier',
                    transitionProperty: 'background, color',
                    ':hover': {
                        background: 'hover',
                        color: 'title'
                    },
                    optionKey: opt.key,
                    isActive: (el2, s2)=>s2.filter === el2.optionKey,
                    '.isActive': {
                        background: 'selected',
                        color: 'title',
                        fontWeight: '500'
                    },
                    text: opt.label,
                    onClick: (e, el2, s2)=>s2.update({
                            filter: el2.optionKey
                        })
                }));
        }
    },
    SampleStrip: {
        flow: 'x',
        align: 'center start',
        gap: 'Z',
        padding: 'A2',
        round: 'radiusCard',
        theme: 'common-box',
        wrap: 'wrap',
        filter: (el, s)=>{
            const a11y = el.context.designSystem && el.context.designSystem.a11y || {};
            const f = a11y.filters && a11y.filters[s.filter];
            return s.filter !== 'none' && f ? f : 'none';
        },
        Dots: {
            flow: 'x',
            gap: 'Y',
            children: ()=>[
                    'blue',
                    'green',
                    'red',
                    'yellow',
                    'orange',
                    'purple',
                    'cerulean',
                    'pink'
                ].map((name)=>({
                        boxSize: 'A2',
                        round: 'radiusPill',
                        background: name
                    }))
        },
        Sample: {
            fontSize: 'Z',
            color: 'paragraph',
            text: "Status never rides on color alone \u2014 icon and label always travel with it."
        }
    },
    SimNote: {
        extends: 'BrandNote',
        text: (el)=>{
            const a11y = el.context.designSystem && el.context.designSystem.a11y || {};
            const n = a11y.filters ? Object.keys(a11y.filters).length : 0;
            return n > 0 ? n + ' vision-simulation filters ship in the design system for auditing surfaces under color-vision deficiency, low vision and inversion.' : 'The a11y token namespace (vision-simulation filters) ships in designSystem/a11y.js; this runtime build predates the design-system namespace passthrough, so the interactive simulator is hidden here.';
        }
    }
};
const $2ff715001ba4a686$export$1c1ac5a9df75ed3c = {
    flow: 'y',
    gap: 'Z',
    Row: {
        flow: 'x',
        wrap: 'wrap',
        gap: 'Z',
        align: 'center start',
        BtnA: {
            tag: 'button',
            type: 'button',
            theme: 'primary',
            round: 'radiusPill',
            minHeight: 'controlHCompact',
            padding: '- A',
            fontSize: 'Z',
            fontWeight: '500',
            align: 'center center',
            cursor: 'pointer',
            text: 'Tab to me'
        },
        BtnB: {
            tag: 'button',
            type: 'button',
            theme: 'tertiary',
            round: 'radiusPill',
            minHeight: 'controlHCompact',
            padding: '- A',
            fontSize: 'Z',
            align: 'center center',
            cursor: 'pointer',
            text: 'Then me'
        },
        Input: {
            theme: 'field',
            round: 'radiusControl',
            minHeight: 'controlHCompact',
            fontSize: 'Z',
            padding: '- Z2',
            placeholder: 'Then this field'
        }
    },
    RingNote: {
        extends: 'BrandNote',
        text: "Press Tab. The double ring \u2014 document-colored gap plus highlight \u2014 is the global focus treatment from the brand reset, readable on any surface in both themes. Components never re-implement focus; the outline shorthand with tokens is banned outright."
    }
};
const $2ff715001ba4a686$export$299771e8dff1a292 = {
    flow: 'y',
    gap: 'Y',
    childProps: {
        flow: 'x',
        align: 'start start',
        gap: 'Z',
        padding: 'Z -'
    },
    RingRow: {
        K: {
            extends: 'BrandCode',
            text: ':focus-visible'
        },
        V: {
            fontSize: 'Z',
            color: 'paragraph',
            lineHeight: '1.5',
            text: "One global keyboard ring for every focusable role \u2014 box-shadow, so it hugs each control\u2019s own radius."
        }
    },
    MotionRow: {
        K: {
            extends: 'BrandCode',
            text: 'prefers-reduced-motion'
        },
        V: {
            fontSize: 'Z',
            color: 'paragraph',
            lineHeight: '1.5',
            text: 'Globally enforced: every animation and transition snaps to its final frame (0.01ms, so end-events still fire). Never override it.'
        }
    },
    BaseRow: {
        K: {
            extends: 'BrandCode',
            text: 'html / body'
        },
        V: {
            fontSize: 'Z',
            color: 'paragraph',
            lineHeight: '1.5',
            text: 'Viewport-stable ground: 100dvh minimum, no overscroll bounce, 320px floor.'
        }
    }
};

});

parcelRegister("9aO2N", function(module, exports) {

$parcel$export(module.exports, "BrandLogoBoard", () => $6adbddf7cd7cc9b0$export$e031d42b2b3c6a08);
$parcel$export(module.exports, "BrandAssetBoard", () => $6adbddf7cd7cc9b0$export$a50aa033464ab19b);
// Brand identity — the mark, its rules demonstrated (correct beside
// incorrect), and the shipped asset set rendered from files/.
const $6adbddf7cd7cc9b0$export$e031d42b2b3c6a08 = {
    flow: 'y',
    gap: 'B',
    MarkRow: {
        display: 'grid',
        columns: 'repeat(2, 1fr)',
        gap: 'Z',
        maxWidth: 'H2',
        '@mobileL': {
            columns: '1fr'
        },
        OnDocument: {
            round: 'radiusCard',
            theme: 'common-box',
            align: 'center center',
            minHeight: 'F',
            fontSize: 'D',
            color: 'title',
            LogoLoader: {}
        },
        OnInk: {
            round: 'radiusCard',
            background: 'highlight',
            color: 'highlight-reversed',
            align: 'center center',
            minHeight: 'F',
            fontSize: 'D',
            // The mark must be told the reversed ink explicitly. LogoLoader sets
            // `color: 'title'` on its own root, and the svg paints with
            // `fill="currentColor"` — so an inherited `highlight-reversed` from this
            // box never reached it and the mark rendered in `title` on BOTH themes:
            // near-black (gray1) on the black ink box in light, near-white (gray15)
            // on the white one in dark. Invisible either way. Set at the call site
            // rather than in LogoLoader, which is shared-library surface used by 15
            // consumer shells that legitimately want `title`.
            LogoLoader: {
                color: 'highlight-reversed'
            }
        }
    },
    MarkNote: {
        extends: 'BrandNote',
        text: "The mark is a single ink \u2014 title on surfaces, reversed on solid ink. It scales by font size (em-drawn), so it rides the type scale instead of fighting it."
    },
    SizesRow: {
        flow: 'x',
        align: 'end start',
        gap: 'B',
        wrap: 'wrap',
        childProps: {
            flow: 'y',
            align: 'center center',
            gap: 'Y',
            color: 'title'
        },
        S1: {
            fontSize: 'Z2',
            LogoLoader: {},
            L: {
                fontFamily: 'Code',
                fontSize: 'X2',
                color: 'inactive',
                text: "Z2 \u2014 minimum"
            }
        },
        S2: {
            fontSize: 'B',
            LogoLoader: {},
            L: {
                fontFamily: 'Code',
                fontSize: 'X2',
                color: 'inactive',
                text: 'B'
            }
        },
        S3: {
            fontSize: 'D',
            LogoLoader: {},
            L: {
                fontFamily: 'Code',
                fontSize: 'X2',
                color: 'inactive',
                text: 'D'
            }
        },
        S4: {
            fontSize: 'F',
            LogoLoader: {},
            L: {
                fontFamily: 'Code',
                fontSize: 'X2',
                color: 'inactive',
                text: 'F'
            }
        }
    },
    UsageGrid: {
        display: 'grid',
        columns: 'repeat(4, 1fr)',
        gap: 'Z',
        '@mobileL': {
            columns: 'repeat(2, 1fr)'
        },
        childProps: {
            flow: 'y',
            gap: 'Y',
            Tile: {
                round: 'radiusCard',
                theme: 'common-box',
                align: 'center center',
                minHeight: 'E',
                fontSize: 'C',
                overflow: 'hidden'
            }
        },
        DoTile: {
            Tile: {
                color: 'title',
                LogoLoader: {}
            },
            Verdict: {
                extends: 'BrandStatusTag',
                kind: 'shipped',
                text: 'single ink, clear space'
            }
        },
        DontStretch: {
            Tile: {
                color: 'title',
                LogoLoader: {
                    transform: 'scaleX(1.4)'
                }
            },
            Verdict: {
                extends: 'BrandStatusTag',
                kind: 'pending',
                text: 'never distort'
            }
        },
        // color set ON LogoLoader — its own definition carries color: 'title',
        // which would win over an ancestor tint and quietly turn the "don't"
        // demos into copies of the "do".
        DontHue: {
            Tile: {
                LogoLoader: {
                    color: 'blue'
                }
            },
            Verdict: {
                extends: 'BrandStatusTag',
                kind: 'pending',
                text: 'never tint with hue'
            }
        },
        // Intentional: this is the "don't" example FOR the contrast rule below —
        // it must render the real (failing) `dim` mark to demonstrate the
        // violation it's warning about. Not a text call site (LogoLoader mark,
        // not readable copy) and not part of the workspace.md dim-migration sweep.
        DontFaint: {
            // eslint-disable-next-line no-restricted-syntax -- deliberate "don't" demo of the exact violation this row warns about
            Tile: {
                LogoLoader: {
                    color: 'dim'
                }
            },
            Verdict: {
                extends: 'BrandStatusTag',
                kind: 'pending',
                text: 'never below contrast'
            }
        }
    }
};
const $6adbddf7cd7cc9b0$export$a50aa033464ab19b = {
    flow: 'y',
    gap: 'Z',
    Grid: {
        display: 'grid',
        columns: 'repeat(6, 1fr)',
        gap: 'Z',
        '@tabletS': {
            columns: 'repeat(4, 1fr)'
        },
        '@mobileL': {
            columns: 'repeat(3, 1fr)'
        },
        children: (el)=>{
            const files = el.context.files || {};
            const kindOf = (name)=>{
                if (name.indexOf('favicon') === 0) return 'favicon';
                if (/^(48|72|96|144|192|512)x/.test(name) || name.indexOf('apple-touch') === 0 || name.indexOf('android-chrome') === 0 || name.indexOf('chrome-ext') === 0) return 'app icon';
                if (/^(350|630|1200)/.test(name)) return 'social / OG';
                if (name.indexOf('.gif') !== -1) return 'motion';
                if (name.indexOf('.svg') !== -1) return 'partner mark';
                return 'product media';
            };
            return Object.keys(files).filter((name)=>files[name] && files[name].content && files[name].content.src).sort().map((name)=>({
                    flow: 'y',
                    gap: 'Y',
                    Tile: {
                        round: 'radiusCard',
                        // fixed neutral backing (flat token, both themes): most assets are
                        // dark marks on transparency — on a dark surface they vanish.
                        // Deliberately NOT adaptive; an adaptive backing goes dark in dark
                        // mode and takes every dark mark with it.
                        background: 'gray14',
                        align: 'center center',
                        aspectRatio: '1 / 1',
                        overflow: 'hidden',
                        padding: 'Z',
                        Img: {
                            src: files[name].content.src,
                            alt: name,
                            loading: 'lazy',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                        }
                    },
                    Name: {
                        fontFamily: 'Code',
                        fontSize: 'X2',
                        color: 'paragraph',
                        text: name,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    },
                    Kind: {
                        fontSize: 'X2',
                        color: 'inactive',
                        text: kindOf(name)
                    }
                }));
        }
    },
    AssetNote: {
        extends: 'BrandNote',
        text: (el)=>{
            const files = el.context.files || {};
            const n = Object.keys(files).filter((k)=>files[k] && files[k].content && files[k].content.src).length;
            return n + " brand assets ship with the library \u2014 favicons, app icons at every required size, social frames and product media \u2014 served from the platform asset namespace, one URL for every environment.";
        }
    }
};

});

parcelRegister("3W3FX", function(module, exports) {

$parcel$export(module.exports, "BrandLawsList", () => $2dd9a3cf0db82b2a$export$fda4f4a56972bb);
$parcel$export(module.exports, "BrandBorderlessDuo", () => $2dd9a3cf0db82b2a$export$353615495f5ff403);
$parcel$export(module.exports, "BrandStateDuo", () => $2dd9a3cf0db82b2a$export$4da256290744ab5e);
$parcel$export(module.exports, "BrandDensityCard", () => $2dd9a3cf0db82b2a$export$2492889c386323fe);
$parcel$export(module.exports, "BrandVoiceCard", () => $2dd9a3cf0db82b2a$export$5607ab169e2a8d0c);
// The language itself: ten laws, then the ones that photograph well —
// demonstrated, correct beside the thing they replace.
const $2dd9a3cf0db82b2a$export$fda4f4a56972bb = {
    flow: 'y',
    gap: 'W',
    maxWidth: 'I',
    children: ()=>[
            "Three surface levels \u2014 stage, raised, overlay \u2014 separated by fill contrast, not strokes.",
            'Exactly two elevation shadows, float and overlay; everything else casts nothing.',
            "Four radii \u2014 control 12, card 17, sheet 24, pill \u2014 fixed px, immune to font size.",
            "Two interaction washes \u2014 hover and selected \u2014 theme-mirrored, bound once, used everywhere. Selection is monochrome.",
            'One control scale: fixed-px height, pinned font size, em padding.',
            'Weights {400, 500, 700}; thin is display-only; nothing synthetic.',
            "Focus is the global ring \u2014 components never re-implement it.",
            'Chrome never moves the page: zero layout shift is correctness, not polish.',
            'Feedback is one system \u2014 skeleton mirrors geometry, empty states are the poster moment, "Loading\u2026" strings are illegal.',
            'Every value is a named token; a raw px, hex or rgba in component code is a defect.'
        ].map((law, i)=>({
                flow: 'x',
                align: 'start start',
                gap: 'B',
                padding: 'Z -',
                Num: {
                    fontFamily: 'Code',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'inactive',
                    width: 'C',
                    flexShrink: '0',
                    text: String(i + 1).padStart(2, '0')
                },
                Law: {
                    fontSize: 'A',
                    lineHeight: '1.5',
                    color: 'title',
                    text: law
                }
            }))
};
const $2dd9a3cf0db82b2a$export$353615495f5ff403 = {
    display: 'grid',
    columns: 'repeat(2, 1fr)',
    gap: 'Z',
    maxWidth: 'H2',
    '@mobileL': {
        columns: '1fr'
    },
    DoCard: {
        flow: 'y',
        gap: 'Z',
        DemoCard: {
            theme: 'common-box',
            round: 'radiusCard',
            padding: 'B',
            flow: 'y',
            gap: 'Y',
            T: {
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: 'Fill contrast'
            },
            P: {
                fontSize: 'Z',
                color: 'paragraph',
                lineHeight: '1.5',
                text: 'The surface reads as raised because its fill steps off the stage.'
            }
        },
        Verdict: {
            extends: 'BrandStatusTag',
            kind: 'shipped',
            text: 'separation by fill'
        }
    },
    DontCard: {
        flow: 'y',
        gap: 'Z',
        DemoCard: {
            round: 'radiusCard',
            padding: 'B',
            flow: 'y',
            gap: 'Y',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'line',
            T: {
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: 'Stroked box'
            },
            P: {
                fontSize: 'Z',
                color: 'paragraph',
                lineHeight: '1.5',
                text: "The habit this language retires: outlines doing a fill\u2019s job."
            }
        },
        Verdict: {
            extends: 'BrandStatusTag',
            kind: 'pending',
            text: "retired \u2014 strokes live in dense tables only"
        }
    }
};
const $2dd9a3cf0db82b2a$export$4da256290744ab5e = {
    display: 'grid',
    columns: 'repeat(2, 1fr)',
    gap: 'Z',
    maxWidth: 'H2',
    '@mobileL': {
        columns: '1fr'
    },
    DoSide: {
        flow: 'y',
        gap: 'Z',
        DemoRow: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z A',
            round: 'radiusControl',
            cursor: 'pointer',
            transition: 'A defaultBezier background',
            ':hover': {
                background: 'hover'
            },
            L: {
                fontSize: 'Z',
                color: 'paragraph',
                text: "Hover me \u2014 a fill step"
            },
            C: {
                extends: 'BrandCode',
                text: "background: 'hover'"
            }
        },
        Verdict: {
            extends: 'BrandStatusTag',
            kind: 'shipped',
            text: "wash \u2014 composits over any surface"
        }
    },
    DontSide: {
        flow: 'y',
        gap: 'Z',
        DemoRow: {
            flow: 'x',
            align: 'center space-between',
            padding: 'Z A',
            round: 'radiusControl',
            cursor: 'pointer',
            background: 'overlay',
            transition: 'A defaultBezier opacity',
            ':hover': {
                opacity: '.6'
            },
            L: {
                fontSize: 'Z',
                color: 'paragraph',
                text: "Hover me \u2014 fading opacity"
            },
            C: {
                extends: 'BrandCode',
                text: 'opacity: .6'
            }
        },
        Verdict: {
            extends: 'BrandStatusTag',
            kind: 'pending',
            text: "retired \u2014 opacity dims the ink too"
        }
    }
};
const $2dd9a3cf0db82b2a$export$2492889c386323fe = {
    extends: 'BrandPanel',
    maxWidth: 'H2',
    gap: 'Z',
    T: {
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        text: 'Density is counted, not felt'
    },
    List: {
        flow: 'y',
        gap: 'Y',
        childProps: {
            flow: 'x',
            gap: 'Z',
            align: 'baseline start'
        },
        R1: {
            N: {
                extends: 'BrandCode',
                text: "\u2264 1"
            },
            L: {
                fontSize: 'Z',
                color: 'paragraph',
                text: 'page bar per surface, with at most one primary action'
            }
        },
        R2: {
            N: {
                extends: 'BrandCode',
                text: "\u2264 3"
            },
            L: {
                fontSize: 'Z',
                color: 'paragraph',
                text: "tools per toolbar group \xb7 actions per card"
            }
        },
        R3: {
            N: {
                extends: 'BrandCode',
                text: "\u2264 2"
            },
            L: {
                fontSize: 'Z',
                color: 'paragraph',
                text: 'inline actions per table row, then the overflow menu'
            }
        },
        R4: {
            N: {
                extends: 'BrandCode',
                text: "\u2264 1"
            },
            L: {
                fontSize: 'Z',
                color: 'paragraph',
                text: 'accent moment per viewport'
            }
        }
    },
    Rule: {
        fontSize: 'Z',
        color: 'title',
        fontWeight: '500',
        text: 'If an element is not read or tapped, delete it.'
    }
};
const $2dd9a3cf0db82b2a$export$5607ab169e2a8d0c = {
    extends: 'BrandPanel',
    maxWidth: 'H2',
    gap: 'Z',
    T: {
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        text: 'Voice'
    },
    List: {
        flow: 'y',
        gap: 'Y',
        childProps: {
            fontSize: 'Z',
            color: 'paragraph',
            lineHeight: '1.55'
        },
        V1: {
            text: 'Sentence case everywhere; uppercase belongs to the eyebrow role alone.'
        },
        V2: {
            text: 'Verbs over nouns: Publish, not Publishing options.'
        },
        V3: {
            text: "Numbers are content, not decoration \u2014 a stat earns display type only when it is the point."
        },
        V4: {
            text: 'No filler: if the sentence survives without the word, the word goes.'
        }
    }
};

});

parcelRegister("4Y4qt", function(module, exports) {

$parcel$export(module.exports, "BrandReservedBoard", () => $39e032f47143e5cf$export$afc2b500fdc6562d);
// The empty token namespaces, shown as what they are — defined, reserved,
// counted live. A markdown doc would forget these; the page cannot.
const $39e032f47143e5cf$export$afc2b500fdc6562d = {
    flow: 'y',
    gap: 'W',
    children: (el)=>{
        const ds = el.context.designSystem || {};
        const roles = [
            [
                'shape',
                'geometric presets for the Shape atom'
            ],
            [
                'grid',
                'grid presets'
            ],
            [
                'class',
                'named CSS class shortcuts'
            ],
            [
                'cases',
                'conditional predicates for $X / .X / !X blocks (project-level cases live at the project root)'
            ]
        ];
        return roles.map((r)=>{
            const obj = ds[r[0]] || {};
            const n = Object.keys(obj).length;
            return {
                flow: 'x',
                gap: 'Z',
                align: 'center start',
                padding: 'Y Z',
                round: 'radiusControl',
                ':hover': {
                    background: 'hover'
                },
                Name: {
                    fontFamily: 'Code',
                    fontSize: 'Z',
                    fontWeight: '500',
                    color: 'title',
                    width: 'D',
                    flexShrink: '0',
                    text: r[0] + '.js'
                },
                Role: {
                    fontSize: 'Y',
                    color: 'paragraph',
                    flex: '1',
                    minWidth: '0',
                    text: r[1]
                },
                Count: {
                    extends: 'BrandStatusTag',
                    kind: n === 0 ? 'reserved' : 'shipped',
                    flexShrink: '0',
                    text: n === 0 ? "empty \u2014 reserved" : n + ' entries'
                }
            };
        });
    }
};

});

parcelRegister("avEgB", function(module, exports) {

$parcel$export(module.exports, "BrandComponentCell", () => $7a6c08c8a4c7c908$export$2c198f9265a112dc);
$parcel$export(module.exports, "BrandComponentsGrid", () => $7a6c08c8a4c7c908$export$4d023ed30527f8a5);
$parcel$export(module.exports, "BrandIconButtonSizes", () => $7a6c08c8a4c7c908$export$7dcd9e2dc1dbd1af);
$parcel$export(module.exports, "BrandIconButtonSpecimen", () => $7a6c08c8a4c7c908$export$f0e8f0359e256493);
// The living component index. Names come from the runtime registry
// (brandOwnComponents) — never a hand-kept list — and every cell mounts the
// REAL component with its sample props. Hover, focus and active states are
// the component's own.
const $7a6c08c8a4c7c908$export$2c198f9265a112dc = {
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    Stage: {
        position: 'relative',
        // translateZ creates a containing block, so fixed/absolute-positioned
        // specimens (Logo, overlays, tooltips) stay inside their own cell.
        transform: 'translateZ(0)',
        // hidden stays as the last-resort clip for absolutely-positioned
        // specimens; normal-flow specimens are width-capped below and the stage
        // grows vertically, so nothing in flow gets cut by the frame.
        overflow: 'hidden',
        align: 'center center',
        minHeight: 'F1',
        padding: 'B',
        round: 'radiusCard',
        theme: 'common-box',
        flow: 'y'
    },
    Meta: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        padding: '- Y',
        NameCell: {
            flow: 'x',
            align: 'center start',
            gap: 'Y',
            minWidth: '0',
            Name: {
                fontFamily: 'Code',
                fontSize: 'Z',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el)=>el.parent.parent.parent.compName
            },
            NoteTag: {
                extends: 'BrandStatusTag',
                kind: 'reserved',
                show: (el)=>Boolean(el.parent.parent.parent.noteTag),
                text: (el)=>el.parent.parent.parent.noteTag || ''
            }
        },
        Kind: {
            fontSize: 'Y',
            color: 'inactive',
            flexShrink: '0',
            text: (el)=>el.parent.parent.kindLabel || ''
        }
    }
};
const $7a6c08c8a4c7c908$export$4d023ed30527f8a5 = {
    flow: 'y',
    gap: 'A2',
    state: {
        q: ''
    },
    CountRow: {
        flow: 'x',
        align: 'baseline space-between',
        gap: 'A',
        wrap: 'wrap',
        Count: {
            role: 'status',
            'aria-live': 'polite',
            fontSize: 'Z',
            color: 'paragraph',
            text: (el, s)=>{
                const names = (el.call('brandOwnComponents') || []).filter((n)=>n.indexOf('Brand') !== 0);
                const q = el.call('brandComponentQuery', s.q);
                const shown = q ? names.filter((n)=>n.toLowerCase().indexOf(q) !== -1).length : names.length;
                return (q ? shown + ' of ' + names.length : String(names.length)) + " components \u2014 enumerated and rendered live from the registry";
            }
        },
        Input: {
            theme: 'field',
            round: 'radiusControl',
            minHeight: 'controlHCompact',
            fontSize: 'Z',
            padding: '- Z2',
            width: 'F1',
            maxWidth: '100%',
            type: 'search',
            'aria-label': (el)=>el.call('polyglot', 'brandFilterLabel'),
            placeholder: (el)=>el.call('polyglot', 'brandFilterPlaceholder'),
            onInput: (e, el, s)=>s.update({
                    q: e.target.value || ''
                })
        }
    },
    Grid: {
        display: 'grid',
        columns: 'repeat(4, minmax(0, 1fr))',
        gap: 'B A2',
        '@screenS': {
            columns: 'repeat(3, minmax(0, 1fr))'
        },
        '@tabletS': {
            columns: 'repeat(2, minmax(0, 1fr))'
        },
        '@mobileL': {
            columns: 'minmax(0, 1fr)'
        },
        children: (el, s)=>{
            const manifest = el.call('brandComponentSamples') || {};
            const q = el.call('brandComponentQuery', s.q);
            return (el.call('brandOwnComponents') || []).filter((n)=>n.indexOf('Brand') !== 0).filter((n)=>!q || n.toLowerCase().indexOf(q) !== -1).map((name)=>{
                const entry = manifest[name] || {};
                const cell = {
                    key: name,
                    extends: 'BrandComponentCell',
                    compName: name,
                    kindLabel: entry.kind || '',
                    noteTag: entry.stub ? "authored empty \u2014 stub" : entry.noteTag
                };
                if (entry.wide) cell.column = '1 / -1';
                if (!entry.stub) // maxWidth cap keeps fixed-width specimens inside their frame
                // (they shrink-to-fit instead of getting cropped); samples may
                // override it deliberately.
                cell.Stage = {
                    children: [
                        Object.assign({
                            key: 'spec',
                            extends: name,
                            maxWidth: '100%',
                            minWidth: '0'
                        }, entry.sample || {})
                    ]
                };
                return cell;
            });
        }
    },
    Empty: {
        show: (el, s)=>{
            const q = el.call('brandComponentQuery', s.q);
            return Boolean(q) && !(el.call('brandOwnComponents') || []).some((name)=>!name.startsWith('Brand') && name.toLowerCase().includes(q));
        },
        role: 'status',
        theme: 'common-box',
        round: 'radiusCard',
        padding: 'B',
        color: 'paragraph',
        text: '{{ brandFilterEmpty | polyglot }}'
    }
};
const $7a6c08c8a4c7c908$export$7dcd9e2dc1dbd1af = {
    flow: 'y',
    gap: 'Z',
    BrandSubhead: {
        text: "Icon buttons \u2014 one square per size",
        padding: '0'
    },
    SizesRow: {
        flow: 'x',
        wrap: 'wrap',
        align: 'end flex-start',
        gap: 'B',
        SpecimenCompact: {
            extends: 'BrandIconButtonSpecimen',
            label: "IconButton \xb7 controlHCompact",
            IconButton: {
                icon: 'plus',
                title: 'Add'
            }
        },
        SpecimenLarge: {
            extends: 'BrandIconButtonSpecimen',
            label: "IconButton large \xb7 controlH",
            IconButton: {
                icon: 'plus',
                large: true,
                title: 'Add'
            }
        },
        SpecimenClose: {
            extends: 'BrandIconButtonSpecimen',
            label: 'CloseButton',
            CloseButton: {}
        },
        SpecimenNavbar: {
            extends: 'BrandIconButtonSpecimen',
            label: 'NavbarButton',
            NavbarButton: {
                icon: 'search',
                title: 'Search'
            }
        },
        SpecimenCanvas: {
            extends: 'BrandIconButtonSpecimen',
            label: 'CanvasButton',
            CanvasButton: {
                icon: 'plus',
                title: 'Add'
            }
        },
        SpecimenArrow: {
            extends: 'BrandIconButtonSpecimen',
            label: 'ArrowButton',
            ArrowButton: {
                icon: 'arrowRight',
                title: 'Next'
            }
        },
        SpecimenWider: {
            extends: 'BrandIconButtonSpecimen',
            label: 'WiderButton',
            WiderButton: {
                icon: 'copy outline',
                title: 'Copy'
            }
        }
    },
    BrandNote: {
        text: "An icon-only button is width = height = the control height of its size \u2014 controlHCompact 36px (the default) or controlH 44px (large) \u2014 aspect ratio 1 / 1, no padding, never shrunk by a row, the glyph centred. A call-site size on an icon-only button is inert. A button with a label keeps its own geometry."
    }
};
const $7a6c08c8a4c7c908$export$f0e8f0359e256493 = {
    flow: 'y',
    align: 'center flex-start',
    gap: 'Y',
    SpecimenLabel: {
        order: '2',
        fontFamily: 'Code',
        fontSize: 'Y',
        color: 'inactive',
        text: (el)=>el.parent.label
    }
};

});

parcelRegister("2f3Kz", function(module, exports) {

$parcel$export(module.exports, "BrandLocalisationBoard", () => $1a1fe42b45a701eb$export$c387060864135d75);
// Localisation — the language's rules for copy, and the honest state of the
// pipeline: components ship English strings today; localisation is routed
// through polyglot, and the copy laws below keep strings translatable.
const $1a1fe42b45a701eb$export$c387060864135d75 = {
    flow: 'y',
    gap: 'B',
    StatusRow: {
        flow: 'x',
        wrap: 'wrap',
        gap: 'Y',
        T1: {
            extends: 'BrandStatusTag',
            kind: 'shipped',
            text: "polyglot pipeline \u2014 @symbo.ls/polyglot"
        },
        T2: {
            extends: 'BrandStatusTag',
            kind: 'pending',
            text: 'product surfaces ship English strings today'
        },
        T3: {
            extends: 'BrandStatusTag',
            kind: 'reserved',
            text: "locale rollout \u2014 cross-workspace effort"
        }
    },
    PatternHead: {
        extends: 'BrandSubhead',
        text: 'The pattern',
        padding: '0'
    },
    PatternDuo: {
        display: 'grid',
        columns: 'repeat(2, 1fr)',
        gap: 'Z',
        maxWidth: 'H2',
        '@mobileL': {
            columns: '1fr'
        },
        DoCard: {
            flow: 'y',
            gap: 'Z',
            Demo: {
                extends: 'BrandPanel',
                gap: 'Y',
                L1: {
                    extends: 'BrandCode',
                    text: "text: '{{ dashboard.welcome | polyglot }}'"
                },
                L2: {
                    extends: 'BrandCode',
                    text: "placeholder: el.call('polyglot', 'search.hint')"
                }
            },
            Verdict: {
                extends: 'BrandStatusTag',
                kind: 'shipped',
                text: 'keys flow through polyglot'
            }
        },
        DontCard: {
            flow: 'y',
            gap: 'Z',
            Demo: {
                extends: 'BrandPanel',
                gap: 'Y',
                L1: {
                    extends: 'BrandCode',
                    text: "text: 'Welcome back to your dashboard'"
                },
                L2: {
                    extends: 'BrandCode',
                    text: "title: 'Search across everything'"
                }
            },
            Verdict: {
                extends: 'BrandStatusTag',
                kind: 'pending',
                text: "baked-in copy \u2014 untranslatable"
            }
        }
    },
    LawsHead: {
        extends: 'BrandSubhead',
        text: 'Copy laws that keep strings translatable',
        padding: 'A - - -'
    },
    Laws: {
        flow: 'y',
        gap: 'Y',
        maxWidth: 'I',
        childProps: {
            fontSize: 'Z',
            color: 'paragraph',
            lineHeight: '1.55'
        },
        L1: {
            text: "Sentence case everywhere \u2014 casing is a style token, not baked into the string (uppercase belongs to the eyebrow role via textTransform)."
        },
        L2: {
            text: 'No concatenation-built sentences: a translated fragment glued to a number or name breaks word order in half the languages that matter.'
        },
        L3: {
            text: "Numbers, dates and units render through the Code face as data \u2014 formatting is locale work, not copy work."
        },
        L4: {
            text: "Density caps assume translated strings run ~30% longer than English \u2014 a control that only fits its English label is a defect."
        },
        L5: {
            text: "Icons never carry meaning alone (a11y law) \u2014 which is also what makes them safe across locales."
        }
    },
    Note: {
        extends: 'BrandNote',
        text: "Status is honest: brand components ship plain English strings today (FA701 is advisory in feature packages), and localisation lands as one cross-workspace effort \u2014 these laws exist so that effort is a sweep, not a rewrite."
    }
};

});


parcelRegister("3tOqn", function(module, exports) {

var $5KbJK = parcelRequire("5KbJK");
$parcel$exportWildcard(module.exports, $5KbJK);

});
parcelRegister("5KbJK", function(module, exports) {

$parcel$export(module.exports, "TEMPLATES_DATA", () => $42ea5a59d9c3602d$export$6ead1896ec010550);
const $42ea5a59d9c3602d$export$6ead1896ec010550 = {
    0: {
        poster: 'https://api.symbols.app/core/files/public/68b667ce424350c909ec03f9/download',
        projectPath: 'nikoloza/default',
        amount: 206,
        title: 'Default'
    },
    1: {
        poster: 'https://api.symbols.app/core/files/public/68b667c8424350c909ec03d4/download',
        projectPath: 'nikoloza/ecommerce',
        amount: 271,
        title: 'Ecommerce'
    },
    2: {
        poster: 'https://api.symbols.app/core/files/public/68b667ac424350c909ec034e/download',
        projectPath: 'nikoloza/forms',
        amount: 248,
        title: 'Forms'
    },
    3: {
        poster: 'https://api.symbols.app/core/files/public/68b667c2424350c909ec03a6/download',
        projectPath: 'nikoloza/ai',
        amount: 213,
        title: 'AI'
    },
    4: {
        poster: 'https://api.symbols.app/core/files/public/68b667d6424350c909ec0421/download',
        projectPath: 'nikoloza/web3',
        amount: 85,
        title: 'Web3'
    },
    5: {
        poster: 'https://api.symbols.app/core/files/public/68b667db424350c909ec044f/download',
        projectPath: 'nikoloza/content-and-marketing',
        amount: 275,
        title: 'Content & Marketing'
    },
    6: {
        poster: 'https://api.symbols.app/core/files/public/68b66c9b424350c909ec1f66/download',
        projectPath: 'nikoloza/docs',
        amount: 598,
        title: 'Docs'
    },
    7: {
        poster: 'https://api.symbols.app/core/files/public/68b671ef424350c909ec5342/download',
        projectPath: 'nikoloza/charts',
        amount: 0,
        title: 'Charts'
    },
    8: {
        poster: 'https://api.symbols.app/core/files/public/68b66bfb424350c909ec1eb4/download',
        projectPath: 'nikoloza/ui',
        amount: 0,
        title: 'No-code'
    },
    9: {
        poster: 'https://api.symbols.app/core/files/public/68b672ad424350c909ec544b/download',
        projectPath: 'nikoloza/cms',
        amount: 0,
        title: 'CMS'
    },
    10: {
        poster: 'https://api.symbols.app/core/files/public/68b66c19424350c909ec1f0c/download',
        projectPath: 'nikoloza/code',
        amount: 0,
        title: 'Code'
    },
    11: {
        poster: 'https://api.symbols.app/core/files/public/68b63fae424350c909ea336e/download',
        projectPath: 'nikoloza/miscellaneous',
        amount: 0,
        title: 'Miscellaneous'
    }
};

});


parcelRegister("1vdoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $118314ec5e8c9b7c$export$2e2bcd8739ae039);

var $5QeSR = parcelRequire("5QeSR");

var $iSdic = parcelRequire("iSdic");

var $kQLNb = parcelRequire("kQLNb");

var $j1Rjt = parcelRequire("j1Rjt");

var $l0AuX = parcelRequire("l0AuX");

var $3Gpg1 = parcelRequire("3Gpg1");

var $8ZwGO = parcelRequire("8ZwGO");

var $bbyMg = parcelRequire("bbyMg");

var $4cz6z = parcelRequire("4cz6z");

var $i27nL = parcelRequire("i27nL");

var $dZD5g = parcelRequire("dZD5g");

var $7xm1L = parcelRequire("7xm1L");

var $djKUc = parcelRequire("djKUc");

var $faiON = parcelRequire("faiON");

var $lRCd6 = parcelRequire("lRCd6");
var $118314ec5e8c9b7c$export$2e2bcd8739ae039 = {
    '/': (0, $5QeSR.home),
    '/color': (0, $kQLNb.colorPage),
    '/gradients': (0, $j1Rjt.gradientsPage),
    '/surfaces': (0, $l0AuX.surfacesPage),
    '/typography': (0, $3Gpg1.typographyPage),
    '/space': (0, $8ZwGO.spacePage),
    '/elevation': (0, $bbyMg.elevationPage),
    '/motion': (0, $4cz6z.motionPage),
    '/breakpoints': (0, $i27nL.breakpointsPage),
    '/icons': (0, $dZD5g.iconsPage),
    '/accessibility': (0, $7xm1L.accessibilityPage),
    '/localisation': (0, $djKUc.localisationPage),
    '/language': (0, $faiON.languagePage),
    '/reserved': (0, $lRCd6.reservedPage),
    '/components': (0, $iSdic.componentsPage)
};

});
parcelRegister("5QeSR", function(module, exports) {

$parcel$export(module.exports, "home", () => $440d5ab070629786$export$d12a05a2da93ee73);
// system--brand.at.symbo.ls — overview: the poster hero + a live index into
// the per-family pages. Chrome register; the hero is the poster moment.
const $440d5ab070629786$export$d12a05a2da93ee73 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleHome')
    },
    Row: {
        Main: {
            Container: {
                BrandHero: {},
                SectionIdentity: {
                    extends: 'BrandSection',
                    eyebrow: 'Identity',
                    heading: 'The mark',
                    lede: 'One ink, drawn in ems, adaptive by theme. It rides the type scale and never takes a hue.',
                    BrandLogoBoard: {},
                    AssetsHead: {
                        extends: 'BrandSubhead',
                        text: 'The shipped asset set'
                    },
                    BrandAssetBoard: {}
                },
                IndexHead: {
                    extends: 'BrandSubhead',
                    padding: 'D - - -',
                    text: 'The system, page by page'
                },
                IndexGrid: {
                    display: 'grid',
                    columns: 'repeat(3, 1fr)',
                    gap: 'Z',
                    padding: 'C - - -',
                    '@tabletS': {
                        columns: 'repeat(2, 1fr)'
                    },
                    '@mobileL': {
                        columns: '1fr'
                    },
                    children: (el)=>{
                        const ds = el.context.designSystem || {};
                        const count = (o)=>o ? Object.keys(o).length : 0;
                        const comps = (el.call('brandOwnComponents') || []).filter((n)=>n.indexOf('Brand') !== 0).length;
                        return [
                            [
                                'Color',
                                '/color',
                                count(ds.color) + ' tokens, measured on real grounds'
                            ],
                            [
                                'Gradients',
                                '/gradients',
                                count(ds.gradient) + ' utility fills'
                            ],
                            [
                                'Surfaces',
                                '/surfaces',
                                count(ds.theme) + ' themes rendered as themselves'
                            ],
                            [
                                'Typography',
                                '/typography',
                                'the scale, the weight law, the registers'
                            ],
                            [
                                'Space & sizes',
                                '/space',
                                'em rhythm + fixed-px geometry'
                            ],
                            [
                                'Elevation',
                                '/elevation',
                                count(ds.shadow) + " shadows \u2014 the whole budget"
                            ],
                            [
                                'Motion',
                                '/motion',
                                count(ds.animation) + ' keyframes on one curve'
                            ],
                            [
                                'Breakpoints',
                                '/breakpoints',
                                count(ds.media) + ' queries, answered live'
                            ],
                            [
                                'Icons',
                                '/icons',
                                count(ds.icons) + ' in the sprite'
                            ],
                            [
                                'Accessibility',
                                '/accessibility',
                                'the floor, the ring, reduced motion'
                            ],
                            [
                                'Localisation',
                                '/localisation',
                                'copy laws that keep strings translatable'
                            ],
                            [
                                'The language',
                                '/language',
                                'ten laws, demonstrated'
                            ],
                            [
                                'Reserved',
                                '/reserved',
                                'empty namespaces, documented'
                            ],
                            [
                                'Components',
                                '/components',
                                comps + ' rendered live from the registry'
                            ]
                        ].map((entry)=>({
                                extends: 'Link',
                                href: entry[1],
                                onClick: (e, el2)=>{
                                    e.preventDefault();
                                    el2.call('brandSearchNavigate', entry[1], null, 'page');
                                },
                                theme: 'common-box',
                                round: 'radiusCard',
                                padding: 'A2',
                                flow: 'y',
                                gap: 'Y',
                                minHeight: 'D2',
                                align: 'start space-between',
                                transition: 'A defaultBezier',
                                transitionProperty: 'background, transform',
                                ':hover': {
                                    transform: 'translateY(-2%)'
                                },
                                CardTitle: {
                                    fontSize: 'A2',
                                    fontWeight: '700',
                                    color: 'title',
                                    text: entry[0]
                                },
                                CardSub: {
                                    fontSize: 'Z',
                                    color: 'paragraph',
                                    lineHeight: '1.45',
                                    text: entry[2]
                                }
                            }));
                    }
                },
                Footer: {
                    tag: 'footer',
                    flow: 'x',
                    align: 'baseline space-between',
                    wrap: 'wrap',
                    gap: 'A',
                    padding: 'E - D -',
                    Line1: {
                        fontSize: 'Z',
                        color: 'inactive',
                        text: "Rendered from company/packages/brand/designSystem \u2014 one source, no retyped values."
                    },
                    Line2: {
                        fontSize: 'Z',
                        fontFamily: 'Code',
                        color: 'inactive',
                        text: 'system/brand'
                    }
                }
            }
        }
    }
};

});

parcelRegister("iSdic", function(module, exports) {

$parcel$export(module.exports, "componentsPage", () => $dbd794c8853fe385$export$1fd7d06737e0d181);
// /components — every component in the brand library, live, full-width.
const $dbd794c8853fe385$export$1fd7d06737e0d181 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleComponents')
    },
    Row: {
        Main: {
            Container: {
                maxWidth: '100%',
                SectionComponents: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    padding: 'B - - -',
                    eyebrow: 'The library',
                    heading: 'Components',
                    lede: "Enumerated from the runtime registry and mounted live \u2014 real hover, real focus, real states."
                },
                BrandIconButtonSizes: {
                    padding: 'B - - -'
                },
                BrandComponentsGrid: {
                    padding: 'B - - -'
                }
            }
        }
    }
};

});

parcelRegister("kQLNb", function(module, exports) {

$parcel$export(module.exports, "colorPage", () => $f2ddbc847ebcd075$export$9dbba6142d0f2a05);
const $f2ddbc847ebcd075$export$9dbba6142d0f2a05 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleColor')
    },
    Row: {
        Main: {
            Container: {
                SectionColor: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 color.js",
                    heading: 'Color',
                    lede: "Chrome is monochrome \u2014 the gray ramp plus adaptive ink pairs. Hues are for status and accent moments, never chrome.",
                    HuesHead: {
                        extends: 'BrandSubhead',
                        text: 'Product hues'
                    },
                    BrandHueGrid: {},
                    RampHead: {
                        extends: 'BrandSubhead',
                        text: "The gray ramp \u2014 the material"
                    },
                    BrandGrayRamp: {},
                    InkHead: {
                        extends: 'BrandSubhead',
                        text: "Ink roles \u2014 resolved and measured, both themes"
                    },
                    BrandInkMatrix: {},
                    WashHead: {
                        extends: 'BrandSubhead',
                        text: 'Interaction washes'
                    },
                    BrandWashBoard: {},
                    BackdropHead: {
                        extends: 'BrandSubhead',
                        text: 'Washes & backdrops'
                    },
                    BrandBackdropList: {},
                    IllusHead: {
                        extends: 'BrandSubhead',
                        text: "DS-editor illustrative set \u2014 never product chrome"
                    },
                    BrandIllustrativeRow: {}
                }
            }
        }
    }
};

});

parcelRegister("j1Rjt", function(module, exports) {

$parcel$export(module.exports, "gradientsPage", () => $dda77733b7eb5faf$export$e8e1858bea20fd1b);
const $dda77733b7eb5faf$export$e8e1858bea20fd1b = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleGradients')
    },
    Row: {
        Main: {
            Container: {
                SectionGradients: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 gradient.js",
                    heading: 'Gradients',
                    lede: 'Utility surfaces and pattern fills. Decorative gradients are not part of the product language.',
                    BrandGradientBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("l0AuX", function(module, exports) {

$parcel$export(module.exports, "surfacesPage", () => $f4b5e8d82c041074$export$b602047158835053);
const $f4b5e8d82c041074$export$b602047158835053 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleSurfaces')
    },
    Row: {
        Main: {
            Container: {
                SectionSurfaces: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 theme.js",
                    heading: 'Surfaces & themes',
                    lede: 'Every theme in the file, rendered as itself. Surfaces separate by fill contrast; strokes are not a separation device.',
                    BrandThemeBoard: {}
                },
                SectionSkins: {
                    extends: 'BrandSection',
                    eyebrow: "Tokens \xb7 skins.js \xb7 theme.js \xb7 color.js",
                    heading: 'Skins',
                    lede: "One token set, two skins. Ambient is the default \u2014 glass cards and pills over the stage; solid is the white-label skin, today\u2019s opaque surfaces. Switch it: nothing but card and pill changes.",
                    BrandSkinBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("3Gpg1", function(module, exports) {

$parcel$export(module.exports, "typographyPage", () => $2ae8e2f023647952$export$dd884ff2b47f40b6);
const $2ae8e2f023647952$export$dd884ff2b47f40b6 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleTypography')
    },
    Row: {
        Main: {
            Container: {
                SectionType: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 typography.js \xb7 font_family.js \xb7 font.js",
                    heading: 'Typography',
                    lede: 'A minor-third scale and a weight law decided by what the face can actually draw.',
                    BrandTypeScale: {},
                    WeightHead: {
                        extends: 'BrandSubhead',
                        text: "The weight law \u2014 {400, 500, 700}"
                    },
                    BrandWeightLaw: {},
                    FamiliesHead: {
                        extends: 'BrandSubhead',
                        text: 'Families'
                    },
                    BrandFamilyBoard: {},
                    RegisterHead: {
                        extends: 'BrandSubhead',
                        text: 'The two registers'
                    },
                    BrandRegisterDuo: {}
                }
            }
        }
    }
};

});

parcelRegister("8ZwGO", function(module, exports) {

$parcel$export(module.exports, "spacePage", () => $68bd60ad58f6f936$export$9dc2ac115048c372);
const $68bd60ad58f6f936$export$9dc2ac115048c372 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleSpace')
    },
    Row: {
        Main: {
            Container: {
                SectionSpace: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 spacing.js \xb7 sizes.js",
                    heading: 'Space & sizes',
                    lede: 'Rhythm rides the golden-ratio em scale; control geometry rides fixed-px sizes. Two systems, one law each.',
                    BrandSpacingBars: {},
                    RadiusHead: {
                        extends: 'BrandSubhead',
                        text: "Semantic radii \u2014 the whole vocabulary"
                    },
                    BrandRadiusBoard: {},
                    ControlHead: {
                        extends: 'BrandSubhead',
                        text: 'The control scale'
                    },
                    BrandControlScale: {},
                    FixedHead: {
                        extends: 'BrandSubhead',
                        text: 'Fixed-size tokens'
                    },
                    BrandFixedSizes: {}
                }
            }
        }
    }
};

});

parcelRegister("bbyMg", function(module, exports) {

$parcel$export(module.exports, "elevationPage", () => $824bb2d7788843ea$export$4b858ab6eb53cbc0);
const $824bb2d7788843ea$export$4b858ab6eb53cbc0 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleElevation')
    },
    Row: {
        Main: {
            Container: {
                SectionElevation: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 shadow.js",
                    heading: 'Elevation',
                    lede: 'Two shadows, three layers each. Everything else is flat by law.',
                    BrandShadowBoard: {}
                },
                SectionOverlays: {
                    extends: 'BrandSection',
                    eyebrow: "Tokens \xb7 theme.js \xb7 shadow.js \xb7 shape.js \xb7 sizes.js \xb7 animation.js",
                    heading: 'Overlays',
                    lede: "Everything that floats over the page, at real size. One veil, one sheet, one spring \u2014 and nothing docks.",
                    BrandOverlaySpecimen: {}
                },
                SectionSkins: {
                    extends: 'BrandSection',
                    eyebrow: "Tokens \xb7 skins.js \xb7 theme.js \xb7 color.js",
                    heading: 'Skins',
                    lede: "One token set, two skins. Ambient is the default \u2014 glass cards and pills over the stage; solid is the white-label skin, today\u2019s opaque surfaces. Switch it: nothing but card and pill changes.",
                    BrandSkinBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("4cz6z", function(module, exports) {

$parcel$export(module.exports, "motionPage", () => $30f38389de69b4f2$export$2cd672b8f5edfcd1);
const $30f38389de69b4f2$export$2cd672b8f5edfcd1 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleMotion')
    },
    Row: {
        Main: {
            Container: {
                SectionMotion: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 timing.js \xb7 animation.js",
                    heading: 'Motion',
                    lede: "Opacity and small transforms on two easing curves \u2014 one for every entrance of an overlay, one for everything else. Durations are tokens you can feel.",
                    BrandTimingBoard: {},
                    OverlayHead: {
                        extends: 'BrandSubhead',
                        text: 'Overlay motion'
                    },
                    BrandOverlayMotionBoard: {},
                    AnimHead: {
                        extends: 'BrandSubhead',
                        text: 'Named keyframes'
                    },
                    BrandAnimationBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("i27nL", function(module, exports) {

$parcel$export(module.exports, "breakpointsPage", () => $d20e23dc6b4b32e1$export$6194577007bcc88);
const $d20e23dc6b4b32e1$export$6194577007bcc88 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleBreakpoints')
    },
    Row: {
        Main: {
            Container: {
                SectionMedia: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 media.js",
                    heading: 'Breakpoints',
                    lede: "The queries the product answers to \u2014 and this page answers to them live.",
                    BrandMediaBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("dZD5g", function(module, exports) {

$parcel$export(module.exports, "iconsPage", () => $a2ff4a186030aefb$export$7eb667a40113d951);
const $a2ff4a186030aefb$export$7eb667a40113d951 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleIcons')
    },
    Row: {
        Main: {
            Container: {
                SectionIcons: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 icons.js",
                    heading: 'Icons',
                    lede: "The sprite, complete. Icons render through the Icon component only \u2014 inline SVG is banned.",
                    IconCount: {
                        extends: 'BrandNote',
                        text: (el)=>{
                            const icons = el.context.designSystem && el.context.designSystem.icons || {};
                            return Object.keys(icons).length + ' icons in the sprite. Hover for names.';
                        }
                    },
                    BrandIconBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("7xm1L", function(module, exports) {

$parcel$export(module.exports, "accessibilityPage", () => $57ccb3ad23c10c84$export$641327f50dfbe143);
const $57ccb3ad23c10c84$export$641327f50dfbe143 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleAccessibility')
    },
    Row: {
        Main: {
            Container: {
                SectionA11y: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 a11y.js \xb7 reset.js",
                    heading: 'Accessibility',
                    lede: "The floor is 4.5:1, the ring is global, reduced motion is enforced \u2014 these are tokens and laws, not aspirations.",
                    BrandA11yBoard: {},
                    FocusHead: {
                        extends: 'BrandSubhead',
                        text: 'The focus contract'
                    },
                    BrandFocusDemo: {},
                    ResetHead: {
                        extends: 'BrandSubhead',
                        text: 'What the reset owns'
                    },
                    BrandResetBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("djKUc", function(module, exports) {

$parcel$export(module.exports, "localisationPage", () => $9b216f2582903dc8$export$2576521f62c04402);
const $9b216f2582903dc8$export$2576521f62c04402 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleLocalisation')
    },
    Row: {
        Main: {
            Container: {
                SectionLocalisation: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "The language \xb7 copy",
                    heading: 'Localisation',
                    lede: 'One voice, many locales: the copy laws that keep every string translatable, and the honest state of the pipeline.',
                    BrandLocalisationBoard: {}
                }
            }
        }
    }
};

});

parcelRegister("faiON", function(module, exports) {

$parcel$export(module.exports, "languagePage", () => $b0a66319799bb62e$export$df2a9932286f1ac4);
const $b0a66319799bb62e$export$df2a9932286f1ac4 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleLanguage')
    },
    Row: {
        Main: {
            Container: {
                SectionLaws: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: 'The language',
                    heading: 'Ten laws',
                    lede: 'Decided, not felt. The ones that photograph well are shown against what they replace.',
                    BrandLawsList: {},
                    BorderlessHead: {
                        extends: 'BrandSubhead',
                        text: 'Fill, not strokes'
                    },
                    BrandBorderlessDuo: {},
                    StateHead: {
                        extends: 'BrandSubhead',
                        text: 'State is a fill step, not a fade'
                    },
                    BrandStateDuo: {},
                    PairRow: {
                        display: 'grid',
                        columns: 'repeat(2, 1fr)',
                        gap: 'Z',
                        padding: 'A - - -',
                        '@mobileL': {
                            columns: '1fr'
                        },
                        BrandDensityCard: {},
                        BrandVoiceCard: {}
                    }
                }
            }
        }
    }
};

});

parcelRegister("lRCd6", function(module, exports) {

$parcel$export(module.exports, "reservedPage", () => $feac3001fe6eeba1$export$7c61f40da798bf92);
const $feac3001fe6eeba1$export$7c61f40da798bf92 = {
    extends: 'BrandSiteShell',
    metadata: {
        title: (el)=>el.call('polyglot', 'brandTitleReserved')
    },
    Row: {
        Main: {
            Container: {
                SectionReserved: {
                    extends: 'BrandSection',
                    Head: {
                        Title: {
                            tag: 'h1'
                        }
                    },
                    eyebrow: "Tokens \xb7 shape.js \xb7 grid.js \xb7 class.js \xb7 cases.js",
                    heading: 'Reserved namespaces',
                    lede: "Empty is a state worth documenting \u2014 these files exist, export nothing yet, and this page will notice the day that changes.",
                    BrandReservedBoard: {}
                }
            }
        }
    }
};

});


parcelRegister("5Q2yy", function(module, exports) {

var $gGXbL = parcelRequire("gGXbL");

var $9U7mp = parcelRequire("9U7mp");

var $e99ki = parcelRequire("e99ki");

var $jBtPJ = parcelRequire("jBtPJ");

var $99HQW = parcelRequire("99HQW");

var $lPHvp = parcelRequire("lPHvp");

var $3jW9l = parcelRequire("3jW9l");

var $f5cK6 = parcelRequire("f5cK6");

var $5WKEf = parcelRequire("5WKEf");

var $Jd8tP = parcelRequire("Jd8tP");

var $9y8ED = parcelRequire("9y8ED");

var $27JWn = parcelRequire("27JWn");

var $43NZh = parcelRequire("43NZh");

var $doVUA = parcelRequire("doVUA");

var $a7mqi = parcelRequire("a7mqi");

var $6QfDq = parcelRequire("6QfDq");

var $eq1Vd = parcelRequire("eq1Vd");

var $eHW0W = parcelRequire("eHW0W");

var $8lB2E = parcelRequire("8lB2E");

var $fOWKH = parcelRequire("fOWKH");

var $9J2qZ = parcelRequire("9J2qZ");

var $3RNoo = parcelRequire("3RNoo");

var $iW5EP = parcelRequire("iW5EP");
$parcel$exportWildcard(module.exports, $gGXbL);
$parcel$exportWildcard(module.exports, $9U7mp);
$parcel$exportWildcard(module.exports, $e99ki);
$parcel$exportWildcard(module.exports, $jBtPJ);
$parcel$exportWildcard(module.exports, $99HQW);
$parcel$exportWildcard(module.exports, $lPHvp);
$parcel$exportWildcard(module.exports, $3jW9l);
$parcel$exportWildcard(module.exports, $f5cK6);
$parcel$exportWildcard(module.exports, $5WKEf);
$parcel$exportWildcard(module.exports, $Jd8tP);
$parcel$exportWildcard(module.exports, $9y8ED);
$parcel$exportWildcard(module.exports, $27JWn);
$parcel$exportWildcard(module.exports, $43NZh);
$parcel$exportWildcard(module.exports, $doVUA);
$parcel$exportWildcard(module.exports, $a7mqi);
$parcel$exportWildcard(module.exports, $6QfDq);
$parcel$exportWildcard(module.exports, $eq1Vd);
$parcel$exportWildcard(module.exports, $eHW0W);
$parcel$exportWildcard(module.exports, $8lB2E);
$parcel$exportWildcard(module.exports, $fOWKH);
$parcel$exportWildcard(module.exports, $9J2qZ);
$parcel$exportWildcard(module.exports, $3RNoo);
$parcel$exportWildcard(module.exports, $iW5EP);

});
parcelRegister("gGXbL", function(module, exports) {

$parcel$export(module.exports, "brandSiteNavigation", () => $c26e7b3c75d3de22$export$9118cf4e1193a776);
function $c26e7b3c75d3de22$export$9118cf4e1193a776() {
    return [
        [
            'brandNavOverview',
            '/'
        ],
        [
            'brandNavColor',
            '/color'
        ],
        [
            'brandNavGradients',
            '/gradients'
        ],
        [
            'brandNavSurfaces',
            '/surfaces'
        ],
        [
            'brandNavTypography',
            '/typography'
        ],
        [
            'brandNavSpace',
            '/space'
        ],
        [
            'brandNavElevation',
            '/elevation'
        ],
        [
            'brandNavMotion',
            '/motion'
        ],
        [
            'brandNavBreakpoints',
            '/breakpoints'
        ],
        [
            'brandNavIcons',
            '/icons'
        ],
        [
            'brandNavAccessibility',
            '/accessibility'
        ],
        [
            'brandNavLocalisation',
            '/localisation'
        ],
        [
            'brandNavLanguage',
            '/language'
        ],
        [
            'brandNavReserved',
            '/reserved'
        ],
        [
            'brandNavComponents',
            '/components'
        ]
    ].map(([key, href])=>({
            label: this.call('polyglot', key),
            href: href
        }));
}

});

parcelRegister("9U7mp", function(module, exports) {

$parcel$export(module.exports, "brandComponentQuery", () => $735f0da186922d81$export$91e5819b492f6c13);
// Count, cards and empty-state feedback must share the same search semantics.
function $735f0da186922d81$export$91e5819b492f6c13(query) {
    return String(query || '').trim().toLowerCase();
}

});

parcelRegister("e99ki", function(module, exports) {

$parcel$export(module.exports, "closeModalVideo", () => $a4c923faf1a17e58$export$5687b430cd0199ec);
const $a4c923faf1a17e58$export$5687b430cd0199ec = function closeModalVideo2() {
    this.getRoot("ModalVideo").state.update({
        activeVideo: false
    });
};

});

parcelRegister("jBtPJ", function(module, exports) {

$parcel$export(module.exports, "goToDocsPage", () => $e4589d4ed69a0d25$export$a6d6f0714bb51bb);
const $e4589d4ed69a0d25$export$a6d6f0714bb51bb = function goToDocsPage2(href) {
    if (!this.call("isString", href)) return this.warn("Href to docs link is not defined");
    const isInternal = href.startsWith("/");
    if ((this.call('isCanvas') || this.call('isEmbed')) && isInternal) return this.call('setWindow', "docs", href.replace("/docs", ""));
    this.router(href, this.getRoot());
};

});

parcelRegister("99HQW", function(module, exports) {

$parcel$export(module.exports, "isDocsContextPlatform", () => $6aa6f89a87848087$export$416485bdd3cb86bc);
const $6aa6f89a87848087$export$416485bdd3cb86bc = function isDocsContextPlatform2() {
    return this.getRootState("docsContext") === "Platform";
};

});

parcelRegister("lPHvp", function(module, exports) {

$parcel$export(module.exports, "openModalVideo", () => $fe501bb887adc06e$export$29869b8a2d1d9afd);
const $fe501bb887adc06e$export$29869b8a2d1d9afd = function openModalVideo2(url) {
    this.getRoot("ModalVideo").state.update({
        activeVideo: url
    });
};

});

parcelRegister("3jW9l", function(module, exports) {

$parcel$export(module.exports, "navigateDocs", () => $26b040ca65efede3$export$f1b8f34232a3d56c);
const $26b040ca65efede3$export$f1b8f34232a3d56c = function navigateDocs2(ev) {
    // In-page hash anchors (`#section`) — scroll to the target element.
    // The SPA router would otherwise hijack the click, preventDefault, and
    // call its router which doesn't know about hash anchors → no scroll.
    if (this.href && this.href.charAt(0) === '#') {
        ev.preventDefault();
        const id = this.href.slice(1);
        const target = id && document.getElementById(id);
        if (target) {
            target.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
            window.history.replaceState(null, '', this.href);
        }
        return;
    }
    // External links — absolute URLs (http/https/mailto/tel) or target="_blank" —
    // must use NATIVE browser navigation (open the URL / new tab). The SPA router
    // can't resolve an external URL, so do NOT preventDefault or hijack the click.
    if (this.target === '_blank' || /^(?:https?:|mailto:|tel:)/i.test(this.href || '')) return;
    ev.preventDefault();
    const href = this.call("resolveHref", this.href);
    this.call("goToDocsPage", href);
};

});

parcelRegister("f5cK6", function(module, exports) {

$parcel$export(module.exports, "dropdownClick", () => $afb13514162f1b4e$export$2407ca004622027f);
const $afb13514162f1b4e$export$2407ca004622027f = async function dropdownClick2(event) {
    var _a, _b;
    const element = this;
    const { state: state, context: context } = element;
    if (state.subdropdown) {
        event.stopPropagation();
        const Dropdown3 = element.lookup("Dropdown");
        const SubDropdown = element.lookup("SubDropdown");
        const { top: dropdownTop, left: dropdownLeft } = Dropdown3.node.getBoundingClientRect();
        const { width: width, height: height } = SubDropdown.node.getBoundingClientRect();
        const { top: top, left: left } = element.node.getBoundingClientRect();
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        const topPos = top - dropdownTop;
        const leftPos = left - dropdownLeft;
        const diffX = left + width * 2 > innerWidth ? width * 2 : 0;
        const diffY = top + height > innerHeight ? Math.abs(innerHeight - top - height - 16) : 8;
        SubDropdown.setNodeStyles({
            transform: `translate3d(${leftPos - diffX}px, ${topPos - diffY}px, 1px)`,
            pointerEvents: "auto",
            visibility: "visible",
            opacity: "1"
        });
        return;
    }
    if (state.onClick) return await state.onClick(event, element, state, context);
    const Dropdown2 = element.lookup((el)=>el.isDropdownRoot);
    if (!Dropdown2) return;
    await ((_b = (_a = Dropdown2).onChoose) == null ? void 0 : _b.call(_a, event, Dropdown2, Dropdown2.state, Dropdown2.context, element));
};

});

parcelRegister("5WKEf", function(module, exports) {

$parcel$export(module.exports, "selectDropdownSet", () => $45468de1f32d2b49$export$7abcd133f72d8df4);
$parcel$export(module.exports, "selectDropdownChoose", () => $45468de1f32d2b49$export$86001cefd561a9f9);
$parcel$export(module.exports, "selectDropdownKeydown", () => $45468de1f32d2b49$export$82581a3946043f46);
// THE SELECT-ONLY LISTBOX — the behaviour half of brand SelectDropdown
// (WAI-ARIA APG "collapsible dropdown listbox"): one trigger `button`
// (aria-haspopup="listbox", aria-expanded), a SIBLING listbox, options that
// are `role="option"` and take focus in turn (tabindex -1, roving focus).
//
// `this` is any element inside the select. Every function finds the select
// root (`isSelectRoot`) itself and reads no module-scope helper, so frank can
// serialize each one alone (FA204). The open flag is the TRIGGER's own state
// (`open`): the trigger is a leaf, so that state shadows no consumer state —
// a local state on the root would hide the parent state that consumer
// handlers inside the select read (e.g. `state.tabSize` in settings).
// Open (true) / close (false) / toggle (no argument). Opening moves focus to
// the chosen option (else the first; `{ edge: 'first' | 'last' }` picks an
// end). Closing with `{ refocus: true }` returns focus to the trigger. Focus
// moves in the NEXT TASK: the panel shows by a CSS rule keyed on the
// trigger's aria-expanded, DOMQL writes that attribute in a microtask flush,
// and a browser will not focus an option inside a still-hidden panel
// (measured on the brand site: a focus call one microtask after the update
// ran before the flip and left focus on the trigger). A timeout runs after
// every pending microtask.
const $45468de1f32d2b49$export$7abcd133f72d8df4 = function selectDropdownSet(open, opts) {
    const el = this;
    const root = el && el.isSelectRoot ? el : el && el.lookup ? el.lookup((x)=>x.isSelectRoot) : null;
    const trigger = root && root.Trigger;
    if (!trigger || !trigger.state) return;
    const o = opts || {};
    const next = typeof open === 'boolean' ? open : !trigger.state.open;
    if (!!trigger.state.open !== next) trigger.state.update({
        open: next
    });
    return new Promise((resolve)=>setTimeout(resolve, 0)).then(()=>{
        if (next) {
            const list = root.Dropdown && root.Dropdown.ListInDropdown;
            const node = list && list.node;
            if (!node) return;
            const options = Array.from(node.children).filter((n)=>n.getAttribute('role') === 'option');
            const chosen = options.find((n)=>n.getAttribute('aria-selected') === 'true');
            const target = o.edge === 'last' ? options[options.length - 1] : o.edge === 'first' ? options[0] : chosen || options[0];
            if (target) target.focus();
        } else if (o.refocus && trigger.node) trigger.node.focus();
    });
};
const $45468de1f32d2b49$export$86001cefd561a9f9 = async function selectDropdownChoose(event) {
    const el = this;
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    await el.call('dropdownClick', event, el, el.state, el.context);
    return el.call('selectDropdownSet', false, {
        refocus: true
    });
};
const $45468de1f32d2b49$export$82581a3946043f46 = function selectDropdownKeydown(event) {
    const el = this;
    const root = el && el.isSelectRoot ? el : el && el.lookup ? el.lookup((x)=>x.isSelectRoot) : null;
    if (!root || !root.Trigger || !event) return;
    const key = event.key;
    const open = !!(root.Trigger.state && root.Trigger.state.open);
    if (el === root.Trigger) {
        if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End') {
            event.preventDefault();
            const chosenFirst = key === 'ArrowDown' || key === 'ArrowUp';
            const hasChosen = !!(root.Dropdown && root.Dropdown.ListInDropdown && root.Dropdown.ListInDropdown.node && Array.from(root.Dropdown.ListInDropdown.node.children).some((n)=>n.getAttribute('aria-selected') === 'true'));
            const edge = chosenFirst && hasChosen ? null : key === 'ArrowUp' || key === 'End' ? 'last' : 'first';
            return el.call('selectDropdownSet', true, {
                edge: edge
            });
        }
        if (key === 'Escape' && open) {
            event.preventDefault();
            return el.call('selectDropdownSet', false);
        }
        return;
    }
    const list = root.Dropdown && root.Dropdown.ListInDropdown;
    const options = list && list.node ? Array.from(list.node.children).filter((n)=>n.getAttribute('role') === 'option') : [];
    const at = options.indexOf(el.node);
    const focusAt = (i)=>{
        const n = options[Math.max(0, Math.min(options.length - 1, i))];
        if (n) n.focus();
    };
    if (key === 'ArrowDown') {
        event.preventDefault();
        focusAt(at + 1);
    } else if (key === 'ArrowUp') {
        event.preventDefault();
        focusAt(at - 1);
    } else if (key === 'Home') {
        event.preventDefault();
        focusAt(0);
    } else if (key === 'End') {
        event.preventDefault();
        focusAt(options.length - 1);
    } else if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        return el.call('selectDropdownChoose', event);
    } else if (key === 'Escape') {
        event.preventDefault();
        return el.call('selectDropdownSet', false, {
            refocus: true
        });
    } else if (key === 'Tab') return el.call('selectDropdownSet', false);
    else if (key && key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        const c = key.toLowerCase();
        const order = options.slice(at + 1).concat(options.slice(0, at + 1));
        const hit = order.find((n)=>(n.textContent || '').trim().toLowerCase().startsWith(c));
        if (hit) {
            event.preventDefault();
            hit.focus();
        }
    }
};

});

parcelRegister("Jd8tP", function(module, exports) {

$parcel$export(module.exports, "isDocsContextLocal", () => $087e649343c7c3b6$export$1daf862776050ffe);
const $087e649343c7c3b6$export$1daf862776050ffe = function isDocsContextLocal2() {
    return this.getRootState("docsContext") === "Local";
};

});

parcelRegister("9y8ED", function(module, exports) {

$parcel$export(module.exports, "isValidHTMLTag", () => $01cb529745f42622$export$47415734c66f337d);
const $01cb529745f42622$export$47415734c66f337d = function isValidHTMLTag2(v) {
    const HTML_TAGS = this.context.utils.HTML_TAGS;
    return HTML_TAGS.root.indexOf(v) > -1 || HTML_TAGS.body.indexOf(v) > -1;
};

});

parcelRegister("27JWn", function(module, exports) {

$parcel$export(module.exports, "resolveHref", () => $18bfdf14c7bd8478$export$e98df7762080a54d);
const $18bfdf14c7bd8478$export$e98df7762080a54d = function resolveHref2(href) {
    var _b;
    const execHref = this.call("exec", href || this.href || ((_b = this.state) == null ? void 0 : _b.href));
    if (this.call("isString", href)) {
        if (href.includes("{{")) return this.call("replaceLiteralsWithObjectFields", execHref);
        return execHref;
    } else return this.warn("Href to docs link is not defined");
};

});

parcelRegister("43NZh", function(module, exports) {

$parcel$export(module.exports, "switchBrandTheme", () => $2f4e37abd5d923c4$export$4ecb82c5f198988e);

var $eY4Ct = parcelRequire("eY4Ct");
function $2f4e37abd5d923c4$export$4ecb82c5f198988e() {
    const current = this.context.globalTheme;
    const next = current === 'light' ? 'dark' : 'light';
    (0, $eY4Ct.changeGlobalTheme)(next, this.context.designSystem);
    this.context.globalTheme = next;
}

});

parcelRegister("doVUA", function(module, exports) {

$parcel$export(module.exports, "resolveBrandColor", () => $02848e32e8d97a72$export$8fabfe0957800091);
// Resolves a brand color token name to its concrete CSS value for a theme
// ('light' | 'dark'), reading the PROCESSED design-system config the runtime
// actually uses: adaptive pairs carry { '@light': { value }, '@dark': { value } },
// flat scalars carry { value }.
function $02848e32e8d97a72$export$8fabfe0957800091(name, theme) {
    if (!name) return null;
    const colors = this.context.designSystem && this.context.designSystem.color || {};
    const entry = colors[name];
    if (!entry) return null;
    if (typeof entry === 'string') return entry;
    const themed = entry['@' + theme];
    if (themed && themed.value) return themed.value;
    if (entry.value) return entry.value;
    return null;
}

});

parcelRegister("a7mqi", function(module, exports) {

$parcel$export(module.exports, "contrastRatio", () => $75dbf39ea473baae$export$e73df0c08bfd3ec3);
// WCAG 2.x contrast ratio between two CSS colors, alpha-aware.
// `fg` is composited over `bg`, and `bg` over `ground` (default white) first,
// so wash/alpha tokens measure the way they actually render.
// Accepts #rgb/#rrggbb/#rrggbbaa, rgb()/rgba(), and the keywords
// black/white/transparent. Returns a number (e.g. 7.08) or null.
function $75dbf39ea473baae$export$e73df0c08bfd3ec3(fg, bg, ground) {
    const parse = (str)=>{
        if (!str) return null;
        const v = String(str).trim().toLowerCase();
        if (v === 'black') return [
            0,
            0,
            0,
            1
        ];
        if (v === 'white') return [
            255,
            255,
            255,
            1
        ];
        if (v === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (v[0] === '#') {
            const h = v.slice(1);
            if (h.length === 3 || h.length === 4) {
                const r = parseInt(h[0] + h[0], 16);
                const g = parseInt(h[1] + h[1], 16);
                const b = parseInt(h[2] + h[2], 16);
                const a = h.length === 4 ? parseInt(h[3] + h[3], 16) / 255 : 1;
                return [
                    r,
                    g,
                    b,
                    a
                ];
            }
            if (h.length === 6 || h.length === 8) {
                const r = parseInt(h.slice(0, 2), 16);
                const g = parseInt(h.slice(2, 4), 16);
                const b = parseInt(h.slice(4, 6), 16);
                const a = h.length === 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1;
                return [
                    r,
                    g,
                    b,
                    a
                ];
            }
            return null;
        }
        const m = v.match(/rgba?\(([^)]+)\)/);
        if (m) {
            const parts = m[1].split(/[\s,/]+/).filter(Boolean).map(parseFloat);
            if (parts.length < 3 || parts.some(isNaN)) return null;
            return [
                parts[0],
                parts[1],
                parts[2],
                parts.length > 3 ? parts[3] : 1
            ];
        }
        return null;
    };
    const over = (top, under)=>{
        const a = top[3];
        return [
            top[0] * a + under[0] * (1 - a),
            top[1] * a + under[1] * (1 - a),
            top[2] * a + under[2] * (1 - a),
            1
        ];
    };
    const lum = (c)=>{
        const f = (v)=>{
            const n = v / 255;
            return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
        };
        return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]);
    };
    const fgC = parse(fg);
    const bgC = parse(bg);
    if (!fgC || !bgC) return null;
    const groundC = parse(ground) || [
        255,
        255,
        255,
        1
    ];
    const bgFlat = over(bgC, groundC);
    const fgFlat = over(fgC, bgFlat);
    const l1 = lum(fgFlat);
    const l2 = lum(bgFlat);
    const ratio = (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
    return Math.round(ratio * 100) / 100;
}

});

parcelRegister("6QfDq", function(module, exports) {

$parcel$export(module.exports, "brandOwnComponents", () => $4fb3ba2d711961e4$export$1345f969d853abd4);
// Enumerates the components this brand library itself exports — read live
// from the runtime registry, minus anything merged in from shared libraries
// and the framework's namespaced built-ins. The /components grid renders
// from this list, so it can never drift from the real registry.
function $4fb3ba2d711961e4$export$1345f969d853abd4() {
    const ctx = this.context;
    const all = ctx && ctx.components || {};
    const fromLibs = {};
    const libs = ctx && ctx.sharedLibraries || [];
    for(let i = 0; i < libs.length; i++){
        const comps = libs[i] && libs[i].components;
        if (!comps) continue;
        for(const k in comps)fromLibs[k] = true;
    }
    return Object.keys(all).filter((k)=>!fromLibs[k] && k.indexOf('smbls.') !== 0).sort();
}

});

parcelRegister("eq1Vd", function(module, exports) {

$parcel$export(module.exports, "brandScrollTo", () => $a7f4fc0c05101435$export$606c22361818ea11);
// Smooth-scrolls the brand site to a section by its element key,
// using the framework's lookdown — no DOM queries.
function $a7f4fc0c05101435$export$606c22361818ea11(key) {
    const root = this.getRoot ? this.getRoot() : null;
    const target = root && root.lookdown ? root.lookdown(key) : null;
    if (target && target.node && target.node.scrollIntoView) target.node.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

});

parcelRegister("eHW0W", function(module, exports) {

$parcel$export(module.exports, "brandComponentSamples", () => $ab521544055d3f23$export$cf8349aa1f703807);
// GENERATED from the component catalog (2026-08-07) + hand patches below.
// Per-component sample props that make each brand component render
// meaningfully inside the /components grid. Pure data — the grid merges
// these over { extends: name }. Regenerate: see scripts/merge-catalogs note
// in the site ticket; hand-patches are marked.
function $ab521544055d3f23$export$cf8349aa1f703807() {
    const map = {
        "AccessCodeField": {
            "kind": "field",
            "sample": {},
            "hazards": [
                "window-access"
            ]
        },
        "AccessibilityCheck": {
            "kind": "misc",
            "sample": {}
        },
        "AccordionItem": {
            "kind": "misc",
            "sample": {},
            "hazards": [
                "absolute-position"
            ]
        },
        "AddButton": {
            "kind": "button",
            "sample": {}
        },
        "AddItemButton": {
            "kind": "button",
            "sample": {}
        },
        "AddRemoveButtons": {
            "kind": "button",
            "sample": {}
        },
        "ArrowButton": {
            "kind": "button",
            "sample": {
                "icon": "arrowRight"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ArticleBig": {
            "kind": "article",
            "sample": {
                "Title": {
                    "text": "Build interfaces 10x faster"
                },
                "P": {
                    "text": "A reactive, signal-based engine for teams who ship fast."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ArticleHeader": {
            "kind": "article",
            "sample": {
                "Title": {
                    "text": "The reactive component engine"
                },
                "P": {
                    "text": "Everything you need to build, ship, and scale your product UI."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ArticleLink": {
            "kind": "article",
            "sample": {
                "href": "/blog/acme-case-study",
                "Caption": {
                    "text": "Case study"
                },
                "Title": {
                    "text": "How Acme Corp shipped 3x faster with Symbols"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ArticleMedium": {
            "kind": "article",
            "sample": {
                "Title": {
                    "text": "Design systems that scale"
                },
                "P": {
                    "text": "One source of truth for every product surface."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ArticleSmall": {
            "kind": "article",
            "sample": {
                "Title": {
                    "text": "Ship consistent UI"
                },
                "P": {
                    "text": "Reusable components keep every team aligned."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ArticleTiny": {
            "kind": "article",
            "sample": {
                "Title": {
                    "text": "Fast by default"
                },
                "P": {
                    "text": "Optimized out of the box."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ArticleXS": {
            "kind": "article",
            "sample": {
                "Title": {
                    "text": "Small footprint"
                },
                "P": {
                    "text": "Minimal markup, maximal clarity."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Breadcrumb": {
            "kind": "nav",
            "sample": {
                "children": [
                    {
                        "href": "/docs",
                        "text": "Docs"
                    },
                    {
                        "href": "/docs/components",
                        "text": "Components"
                    },
                    {
                        "href": "/docs/components/button",
                        "text": "Button"
                    }
                ]
            },
            "hazards": [
                "window-access"
            ]
        },
        "ButtonTitle": {
            "kind": "button",
            "sample": {
                "IconButton": {
                    "icon": "plus"
                },
                "Caption": {
                    "text": "Add item"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "CancelButton": {
            "kind": "button",
            "sample": {
                "text": "Cancel"
            }
        },
        "CanvasButton": {
            "kind": "button",
            "sample": {
                "icon": "space",
                "title": "Open canvas"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "CanvasEmbed": {
            "kind": "media",
            "sample": {
                "height": "F2"
            },
            "wide": true,
            "hazards": [
                "iframe",
                "huge"
            ]
        },
        "CanvasEmbed.ClickToLoad": {
            "kind": "media",
            "sample": {},
            "wide": true,
            "hazards": [
                "iframe",
                "absolute-position"
            ]
        },
        "CanvasEmbed2": {
            "kind": "media",
            "sample": {
                "minWidth": "F2",
                "CanvasEmbed": {
                    "height": "F2"
                }
            },
            "wide": true,
            "hazards": [
                "iframe",
                "huge",
                "absolute-position"
            ]
        },
        "CaptionTitle": {
            "kind": "text",
            "sample": {}
        },
        "CheckButton": {
            "kind": "button",
            "sample": {}
        },
        "CheckParagraph": {
            "kind": "text",
            "sample": {
                "state": {
                    "value": "Includes unlimited projects"
                }
            },
            "hazards": [
                "empty-without-props",
                "needs-parent-state:value"
            ]
        },
        "CheckboxField": {
            "kind": "field",
            "sample": {}
        },
        "ClickableItem": {
            "kind": "misc",
            "sample": {
                "text": "Recent project"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ColumnParagraphs": {
            "kind": "layout",
            "sample": {
                "children": [
                    {
                        "text": "Design tokens keep every surface visually consistent across the product."
                    },
                    {
                        "text": "Component contracts define the props and states every implementation must support."
                    },
                    {
                        "text": "Accessibility guidelines are enforced at the component level, not bolted on later."
                    }
                ]
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ComingSoon": {
            "kind": "overlay",
            "sample": {},
            "hazards": [
                "absolute-position"
            ]
        },
        "CommonFieldLike": {
            "kind": "field",
            "sample": {
                "Title": {
                    "text": "Field label"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ConnectionLabel": {
            "kind": "badge",
            "sample": {}
        },
        "ContinueButton": {
            "kind": "button",
            "sample": {
                "text": "Continue"
            }
        },
        "Contributors": {
            "kind": "layout",
            "sample": {
                "Flex": {
                    "children": [
                        {
                            "alt": "nikoloza",
                            "src": "https://avatars.githubusercontent.com/u/962224?s=120&v=4"
                        },
                        {
                            "alt": "svinchy",
                            "src": "https://avatars.githubusercontent.com/u/36074573?s=120&v=4"
                        },
                        {
                            "alt": "tokoyoung",
                            "src": "https://avatars.githubusercontent.com/u/33081308?s=120&v=4"
                        },
                        {
                            "alt": "gugakatsi",
                            "src": "https://avatars.githubusercontent.com/u/9134169?s=120&v=4"
                        }
                    ]
                }
            },
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "ContributorsCopy": {
            "kind": "layout",
            "sample": {
                "Flex": {
                    "children": [
                        {
                            "alt": "nikoloza",
                            "src": "https://avatars.githubusercontent.com/u/962224?s=120&v=4"
                        },
                        {
                            "alt": "svinchy",
                            "src": "https://avatars.githubusercontent.com/u/36074573?s=120&v=4"
                        },
                        {
                            "alt": "tokoyoung",
                            "src": "https://avatars.githubusercontent.com/u/33081308?s=120&v=4"
                        },
                        {
                            "alt": "gugakatsi",
                            "src": "https://avatars.githubusercontent.com/u/9134169?s=120&v=4"
                        }
                    ]
                }
            },
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "CopyButton": {
            "kind": "button",
            "sample": {
                "value": "https://symbols.app/nikoloza/default"
            },
            "hazards": [
                "timer"
            ]
        },
        "DescriptionField": {
            "kind": "field",
            "sample": {
                "Textarea": {
                    "placeholder": "Add a short description\u2026"
                }
            }
        },
        "DesignComponent": {
            "kind": "layout",
            "sample": {
                "DesignComponentHeader": {
                    "state": {
                        "icon": "space",
                        "iconTheme": "quaternary",
                        "title": "Button",
                        "paragraph": "A clickable control that triggers an action."
                    }
                },
                "DesignComponentProperties": {
                    "state": {
                        "properties": [
                            {
                                "property": "size",
                                "value": "medium"
                            },
                            {
                                "property": "variant",
                                "value": "primary"
                            }
                        ]
                    }
                }
            },
            "hazards": [
                "empty-without-props",
                "needs-parent-state:title",
                "needs-parent-state:properties"
            ]
        },
        "DesignComponentHeader": {
            "kind": "heading",
            "sample": {
                "state": {
                    "icon": "space",
                    "iconTheme": "quaternary",
                    "title": "Button",
                    "paragraph": "A clickable control that triggers an action."
                }
            },
            "hazards": [
                "empty-without-props",
                "needs-parent-state:title",
                "needs-parent-state:icon"
            ]
        },
        "DesignComponentProperties": {
            "kind": "layout",
            "sample": {
                "state": {
                    "properties": [
                        {
                            "property": "size",
                            "value": "medium"
                        },
                        {
                            "property": "variant",
                            "value": "primary"
                        },
                        {
                            "property": "disabled",
                            "value": "false"
                        }
                    ]
                }
            },
            "hazards": [
                "empty-without-props",
                "needs-parent-state:properties"
            ]
        },
        "DesignElement": {
            "kind": "nav",
            "sample": {
                "WiderButton": {
                    "icon": "space"
                },
                "Hgroup": {
                    "H": {
                        "text": "Design tokens"
                    }
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "DocsDesignElement": {
            "kind": "misc",
            "sample": {}
        },
        "DocsHgroup": {
            "kind": "heading",
            "sample": {
                "H": {
                    "text": "Getting started"
                },
                "P": {
                    "text": "Everything you need to build your first Symbols project."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "DocsLink": {
            "kind": "nav",
            "sample": {
                "text": "Read the docs",
                "href": "/docs"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "DocsSocialLinks": {
            "kind": "nav",
            "sample": {}
        },
        "DocsSupportLinks": {
            "kind": "text",
            "sample": {}
        },
        "DotCaption": {
            "kind": "text",
            "sample": {
                "Text": {
                    "text": "Design system"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "DotCaptionArticle": {
            "kind": "article",
            "sample": {
                "H": {
                    "href": "/blog/featured",
                    "Text": {
                        "text": "Release notes"
                    }
                },
                "P": {
                    "text": "A quick two-line summary of what shipped this week."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "DragNdropUser": {
            "kind": "misc",
            "sample": {
                "Avatar": {
                    "src": "https://avatars.githubusercontent.com/u/962224?s=120&v=4"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Draggable": {
            "kind": "misc",
            "sample": {
                "text": "Drag to reorder"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "DraggableRow": {
            "kind": "misc",
            "sample": {
                "text": "Drag to reorder"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Dropdown": {
            "kind": "dropdown",
            "sample": {
                "forcedVisible": true,
                "preventAbsolute": true,
                "children": [
                    {
                        "text": "Profile"
                    },
                    {
                        "text": "Settings"
                    },
                    {
                        "text": "Log out"
                    }
                ]
            },
            "hazards": [
                "absolute-position",
                "window-access",
                "empty-without-props"
            ]
        },
        "DropdownArrow": {
            "kind": "misc",
            "sample": {}
        },
        "DropdownCopy": {
            "kind": "misc",
            "sample": {
                "text": "Dropdown copy placeholder"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "DropdownField": {
            "kind": "dropdown",
            "sample": {
                "state": {
                    "value": "All projects"
                }
            }
        },
        "DropdownHeader": {
            "kind": "dropdown",
            "sample": {}
        },
        "DropdownItem": {
            "kind": "dropdown",
            "sample": {
                "text": "Settings"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ExplanatoryParagraph": {
            "kind": "text",
            "sample": {
                "text": "This paragraph explains the concept in plain, approachable language for newcomers."
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "FooteLite": {
            "kind": "layout",
            "sample": {}
        },
        "FooterFull": {
            "kind": "layout",
            "sample": {},
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "GetEarlyAccess": {
            "kind": "article",
            "sample": {
                "width": "100%"
            },
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "GridInDropdown": {
            "kind": "dropdown",
            "sample": {
                "children": [
                    {
                        "key": "search"
                    },
                    {
                        "key": "star"
                    },
                    {
                        "key": "settings"
                    },
                    {
                        "key": "trash"
                    }
                ]
            },
            "hazards": [
                "needs-parent-state:options",
                "empty-without-props"
            ]
        },
        "GridItem": {
            "kind": "dropdown",
            "sample": {
                "state": {
                    "key": "search"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Group": {
            "kind": "layout",
            "sample": {}
        },
        "GroupField": {
            "kind": "field",
            "sample": {}
        },
        "H1": {
            "kind": "heading",
            "sample": {
                "text": "Build faster with Symbols"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "H2": {
            "kind": "heading",
            "sample": {
                "text": "Everything you need to ship"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "H3": {
            "kind": "heading",
            "sample": {
                "text": "Design tokens that scale"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "H4": {
            "kind": "heading",
            "sample": {
                "text": "Component library"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "H5": {
            "kind": "heading",
            "sample": {
                "text": "Getting started"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "H6": {
            "kind": "heading",
            "sample": {
                "text": "Release notes"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "HeaderBreadcrumb": {
            "kind": "nav",
            "sample": {},
            "hazards": [
                "window-access",
                "needs-parent-state:appKey"
            ]
        },
        "HeaderHeading": {
            "kind": "heading",
            "sample": {
                "H1": {
                    "fontSize": "C2"
                }
            },
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "Headline": {
            "kind": "text",
            "sample": {
                "text": "Design once. Ship everywhere."
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "HelloUser": {
            "kind": "text",
            "sample": {
                "text": "Welcome back, Alex \uD83D\uDC4B"
            },
            "hazards": [
                "needs-parent-state:username"
            ]
        },
        "Hgroup": {
            "kind": "heading",
            "sample": {}
        },
        "Hr": {
            "kind": "misc",
            "sample": {}
        },
        "IconButton": {
            "kind": "button",
            "sample": {
                "icon": "github",
                "title": "View on GitHub"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "IconCaption": {
            "kind": "misc",
            "sample": {
                "Text": {
                    "text": "View on GitHub"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "IconLinkWithPath": {
            "wide": true,
            "kind": "article",
            "sample": {
                "state": {
                    "href": "https://github.com/symbo-ls/domql",
                    "title": "domql runtime",
                    "description": "The core DOMQL rendering engine that powers every Symbols app."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ImageParagraph": {
            "kind": "media",
            "sample": {
                "Svg": {
                    "html": "<svg viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"9\" fill=\"currentColor\"/></svg>"
                },
                "Paragraph": {
                    "text": "A short paragraph describing the tokenized image treatment used across the brand."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "InputField": {
            "kind": "field",
            "sample": {
                "Title": {
                    "text": "Full name"
                },
                "Input": {
                    "placeholder": "e.g. Ada Lovelace"
                }
            }
        },
        "Item": {
            "kind": "article",
            "sample": {}
        },
        "ItemAlt": {
            "wide": true,
            "kind": "article",
            "sample": {}
        },
        "ItemHighlight": {
            "kind": "article",
            "sample": {}
        },
        "ItemHighlightAlt": {
            "kind": "article",
            "sample": {}
        },
        "ItemOutline": {
            "kind": "article",
            "sample": {
                "hasHref": true,
                "state": {
                    "icon": "tree"
                }
            }
        },
        "IteratorFooter": {
            "kind": "misc",
            "sample": {
                "position": "relative",
                "top": "0",
                "left": "0",
                "bottom": "0"
            },
            "hazards": [
                "absolute-position",
                "needs-parent-state:__element"
            ]
        },
        "KeyValueColumnFields": {
            "kind": "dropdown",
            "sample": {
                "state": {
                    "text": "Profile settings"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "LabelTag": {
            "kind": "badge",
            "sample": {
                "text": "Beta"
            }
        },
        "Labeled": {
            "kind": "badge",
            "sample": {
                "text": "Draft"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "LabeledCopy": {
            "kind": "badge",
            "sample": {
                "tag": "span",
                "text": "Copy",
                "color": "caption",
                "padding": "0 W1",
                "round": "X2",
                "lineHeight": "1"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "LabeledHighlight": {
            "kind": "badge",
            "sample": {
                "text": "Verified"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "LabeledLight": {
            "kind": "badge",
            "sample": {
                "text": "Draft"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "LandingFooterLite": {
            "kind": "layout",
            "sample": {}
        },
        "LayerSimple": {
            "kind": "misc",
            "sample": {
                "width": "100%"
            },
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "LibrariesRow": {
            "kind": "layout",
            "sample": {},
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "LibrariesRowItem": {
            "kind": "media",
            "sample": {}
        },
        "Line": {
            "kind": "misc",
            "sample": {}
        },
        "ListInDropdown": {
            "kind": "dropdown",
            "sample": {
                "children": [
                    {
                        "text": "Profile"
                    },
                    {
                        "text": "Settings"
                    },
                    {
                        "text": "Sign out"
                    }
                ]
            },
            "hazards": [
                "needs-parent-state:options",
                "empty-without-props"
            ]
        },
        "LoaderRatio": {
            "kind": "loader",
            "sample": {
                "position": "relative",
                "top": "0",
                "left": "0",
                "right": "0",
                "bottom": "0",
                "inset": "auto"
            },
            "hazards": [
                "fixed-position",
                "covers-viewport"
            ]
        },
        "LoadingGif": {
            "kind": "loader",
            "sample": {
                "inCenter": false,
                "position": "relative"
            },
            "hazards": [
                "absolute-position",
                "autoplay-media"
            ]
        },
        "LoadingGifSection": {
            "kind": "loader",
            "sample": {
                "height": "E1"
            },
            "hazards": [
                "autoplay-media"
            ]
        },
        "Logo": {
            "kind": "button",
            "sample": {
                "position": "relative",
                "top": "0",
                "left": "0",
                "right": "0",
                "bottom": "0",
                "inset": "unset"
            },
            "hazards": [
                "fixed-position",
                "router-call"
            ]
        },
        "LogoCopy": {
            "kind": "button",
            "sample": {},
            "hazards": [
                "window-access"
            ]
        },
        "LogoLoader": {
            "kind": "loader",
            "sample": {}
        },
        "MadeOnSymbols": {
            "kind": "layout",
            "sample": {},
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "MainLoader": {
            "kind": "loader",
            "sample": {
                "position": "relative",
                "top": "0",
                "left": "0",
                "right": "0",
                "bottom": "0",
                "inset": "auto"
            },
            "hazards": [
                "fixed-position",
                "covers-viewport"
            ]
        },
        "MenuItem": {
            "kind": "nav",
            "sample": {
                "icon": "home",
                "href": "/dashboard",
                "title": "Home"
            },
            "hazards": [
                "empty-without-props",
                "needs-parent-state:activePage"
            ]
        },
        "ModalBody": {
            "kind": "modal",
            // Hand patch (overflow law §3b.3, 2026-09-26): the body out of its
            // sheet — its reach into the sheet padding is cancelled here.
            "sample": {
                "margin": "0",
                "P_1": {
                    "margin": "0",
                    "text": "The one scroll container of a sheet."
                },
                "P_2": {
                    "margin": "0",
                    "text": "The head and the foot never scroll away."
                }
            }
        },
        "ModalFooter": {
            "kind": "modal",
            "sample": {
                "Button_cancel": {
                    "extends": [
                        "Button"
                    ],
                    "text": "Cancel",
                    "theme": "tertiary"
                },
                "Button_confirm": {
                    "extends": [
                        "Button"
                    ],
                    "text": "Save changes",
                    "theme": "primary"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "ModalHeader": {
            "kind": "modal",
            "sample": {
                "Hgroup": {
                    "H": {
                        "text": "Update your profile"
                    },
                    "P": {
                        "text": "Change your name, avatar, and public bio."
                    }
                }
            },
            "hazards": [
                "empty-without-props",
                "modal-behavior"
            ]
        },
        "ModalVideo": {
            "kind": "overlay",
            "sample": {
                "position": "relative",
                "top": "0",
                "left": "0",
                "right": "0",
                "bottom": "0",
                "inset": "unset",
                "boxSize": "100% 100%",
                "state": {
                    "activeVideo": "https://www.youtube.com/embed/dQw4w9WgXcQ"
                }
            },
            "wide": true,
            "hazards": [
                "fixed-position",
                "covers-viewport",
                "iframe",
                "autoplay-media",
                "empty-without-props"
            ]
        },
        "ModalWindow": {
            "kind": "modal",
            // Hand patch (overflow law §3b.3, 2026-09-26): the full anatomy — the
            // head and the foot stay, the body is the one scroll container.
            "sample": {
                "ModalHeader": {
                    "Hgroup": {
                        "H": {
                            "text": "Confirm deletion"
                        },
                        "P": {
                            "text": "This action cannot be undone."
                        }
                    }
                },
                "ModalBody": {
                    "P_1": {
                        "margin": "0",
                        "text": "Deleting the workspace removes its apps, members and files for everyone."
                    },
                    "P_2": {
                        "margin": "0",
                        "text": "Exports you downloaded stay on your device."
                    }
                },
                "ModalFooter": {
                    "CancelButton": {
                        "text": "Keep the workspace"
                    },
                    "CheckButton": {
                        "text": "Delete"
                    }
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "MultipleSelect": {
            "kind": "field",
            "sample": {
                "children": [
                    {
                        "text": "Option A",
                        "selected": true
                    },
                    {
                        "text": "Option B"
                    },
                    {
                        "text": "Option C"
                    }
                ]
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "NativeSelect": {
            "kind": "field",
            "sample": {}
        },
        "Navbar": {
            "kind": "nav",
            "sample": {
                "position": "relative",
                "top": "0",
                "left": "0",
                "right": "0",
                "bottom": "0",
                "inset": "unset",
                "P": {
                    "text": "Acme Workspace"
                }
            },
            "hazards": [
                "fixed-position",
                "empty-without-props"
            ]
        },
        "NavbarButton": {
            "kind": "button",
            "sample": {
                "title": "Settings",
                "Icon": {
                    "name": "settings"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "NavbarButtonSet": {
            "kind": "nav",
            "sample": {
                "children": [
                    {
                        "title": "Search",
                        "Icon": {
                            "name": "search"
                        }
                    },
                    {
                        "title": "Notifications",
                        "Icon": {
                            "name": "bell"
                        }
                    }
                ]
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "NavbarTooltip": {
            "kind": "overlay",
            "sample": {
                "position": "relative",
                "description": "Deprecated legacy tooltip"
            },
            "hazards": [
                "absolute-position",
                "empty-without-props"
            ]
        },
        "NavigationArrows": {
            "kind": "nav",
            "sample": {}
        },
        "NumbCaption": {
            "kind": "text",
            "sample": {
                "Numb": {
                    "text": "01"
                },
                "Text": {
                    "text": "Getting started"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "NumbCaptionArticleBig": {
            "kind": "heading",
            "sample": {
                "H": {
                    "Numb": {
                        "text": "01"
                    },
                    "Text": {
                        "text": "Design system"
                    }
                },
                "P": {
                    "text": "Tokens keep every surface consistent."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "NumbCaptionArticleSmall": {
            "kind": "heading",
            "sample": {
                "H": {
                    "Numb": {
                        "text": "02"
                    },
                    "Text": {
                        "text": "Design tokens"
                    }
                },
                "P": {
                    "text": "A short supporting line."
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "NumericBulletin": {
            "kind": "text",
            "sample": {
                "Numb": {
                    "text": "03"
                },
                "Text": {
                    "text": "Bulleted numeric note"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "NumericTip": {
            "kind": "badge",
            "sample": {}
        },
        "OptionToggle": {
            "kind": "field",
            "sample": {
                "tip": "Applies to every workspace member."
            },
            "hazards": [
                "needs-parent-state:tip"
            ]
        },
        "PackageFeatureItem": {
            "kind": "field",
            "sample": {
                "Hgroup": {
                    "H": {
                        "text": "Starter"
                    },
                    "P": {
                        "text": "For small teams getting started."
                    }
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Partner": {
            "kind": "media",
            "sample": {
                "src": "<svg viewBox='0 0 24 24' width='24' height='24'><circle cx='12' cy='12' r='10' fill='currentColor'/></svg>"
            },
            "hazards": [
                "empty-without-props",
                "needs-parent-state:src"
            ]
        },
        "PasswordField": {
            "kind": "field",
            "sample": {}
        },
        "PathnameBreadcrumb": {
            "kind": "nav",
            "sample": {},
            "hazards": [
                "window-access",
                "empty-without-props"
            ]
        },
        "ProjectTab": {
            "kind": "nav",
            "sample": {
                "title": "Marketing Site"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "PromptTextarea": {
            "kind": "field",
            "sample": {}
        },
        "QuestionMarkTooltip": {
            "kind": "misc",
            "sample": {}
        },
        "QuickStartNumber": {
            "kind": "text",
            "sample": {}
        },
        "QuickTip": {
            "kind": "badge",
            "sample": {}
        },
        "RangeField": {
            "kind": "field",
            "sample": {
                "value": 50,
                "min": 0,
                "max": 100,
                "step": 1,
                "unit": "%"
            }
        },
        "RangeFieldWithIcon": {
            "kind": "field",
            "sample": {
                "Icon": {
                    "name": "brightness"
                },
                "RangeField": {
                    "value": 40,
                    "unit": "%"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "RangeFieldWithTitle": {
            "kind": "field",
            "sample": {
                "Title": {
                    "text": "Volume"
                },
                "RangeField": {
                    "value": 60,
                    "unit": "%"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "RangeFieldWithTitleAndIcon": {
            "kind": "field",
            "sample": {
                "Title": {
                    "text": "Brightness"
                },
                "RangeFieldWithIcon": {
                    "Icon": {
                        "name": "brightness"
                    },
                    "RangeField": {
                        "value": 70,
                        "unit": "%"
                    }
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "RangeWithButtons": {
            "kind": "field",
            "sample": {
                "value": 50,
                "min": 0,
                "max": 100,
                "step": 1,
                "unit": "%"
            }
        },
        "Scrollable": {
            "kind": "layout",
            "sample": {
                "P_1": {
                    "text": "Card one"
                },
                "P_2": {
                    "text": "Card two"
                },
                "P_3": {
                    "text": "Card three"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Scrollbar": {
            "kind": "layout",
            "sample": {
                "TrackContainer": {
                    "background": "transparent"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Scrollbar.scrollable": {
            "kind": "layout",
            "sample": {},
            "hazards": [
                "timer",
                "needs-parent-state:Scrollable"
            ]
        },
        "SearchField": {
            "kind": "field",
            "sample": {
                "Input": {
                    "placeholder": "Search across everything\u2026"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SectionAddButton": {
            "kind": "button",
            "sample": {
                "text": "Add section"
            }
        },
        "SectionHeader": {
            "kind": "heading",
            "sample": {
                "title": "Product Roadmap",
                "p": "What we are shipping this quarter.",
                "state": {
                    "nav": [
                        {
                            "text": "Overview"
                        },
                        {
                            "text": "Timeline"
                        }
                    ]
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SectionHeaderWithNav": {
            "kind": "heading",
            "sample": {
                "title": "Team Members",
                "p": "Everyone with access to this workspace.",
                "state": {
                    "nav": [
                        {
                            "text": "Invite"
                        }
                    ]
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SectionTitle": {
            "kind": "text",
            "sample": {
                "text": "Getting started"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SelectDropdown": {
            "kind": "dropdown",
            "sample": {
                "open": true,
                "Dropdown": {
                    "options": [
                        "Small",
                        "Medium",
                        "Large"
                    ]
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SelectDropdownWithTitle": {
            "kind": "dropdown",
            "sample": {
                "Title": {
                    "text": "Size"
                },
                "SelectDropdown": {
                    "open": true,
                    "Dropdown": {
                        "options": [
                            "Small",
                            "Medium",
                            "Large"
                        ]
                    }
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SelectField": {
            "kind": "field",
            "sample": {
                "options": [
                    "Admin",
                    "Editor",
                    "Viewer"
                ]
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SimpleOverlay": {
            "kind": "overlay",
            "sample": {
                "position": "relative",
                "top": "0",
                "left": "0",
                "right": "0",
                "bottom": "0",
                "inset": "unset",
                "boxSize": "F F",
                "background": "gray1.1"
            },
            "hazards": [
                "absolute-position",
                "covers-viewport",
                "empty-without-props"
            ]
        },
        "SizeUnits": {
            "kind": "field",
            "sample": {
                "NumberValue": {
                    "text": "16"
                },
                "LetterValue": {
                    "text": "px"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "StateDesignElement": {
            "kind": "article",
            "sample": {
                "state": {
                    "categoryType": "animation",
                    "category": "Animation"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Strong": {
            "kind": "text",
            "sample": {
                "text": "Important note"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Subhead": {
            "kind": "heading",
            "sample": {
                "text": "Subheading text"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SuggestionAction": {
            "kind": "button",
            "sample": {},
            "hazards": [
                "window-access",
                "modal-behavior"
            ]
        },
        "SummaryComponent": {
            "kind": "article",
            "sample": {
                "href": "#",
                "state": {
                    "icon": "space",
                    "iconTheme": "quaternary",
                    "title": "Button",
                    "paragraph": "A clickable control that triggers an action.",
                    "properties": [
                        {
                            "property": "size",
                            "value": "medium"
                        },
                        {
                            "property": "variant",
                            "value": "primary"
                        }
                    ]
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "SwitchField": {
            "kind": "field",
            "sample": {},
            "hazards": [
                "needs-parent-state:onChange"
            ]
        },
        "SwitchFieldWithCaption": {
            "kind": "field",
            "sample": {}
        },
        "TabSet": {
            "kind": "nav",
            "sample": {}
        },
        "TabsLink": {
            "kind": "nav",
            "sample": {
                "text": "Overview"
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "TabsLinkSwitcher": {
            "wide": true,
            "kind": "nav",
            "sample": {
                "children": [
                    {
                        "text": "Overview",
                        "isActive": true
                    },
                    {
                        "text": "Activity"
                    },
                    {
                        "text": "Settings"
                    }
                ]
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "Tag": {
            "kind": "badge",
            "sample": {}
        },
        "TemplatesRow": {
            "kind": "layout",
            "sample": {},
            "wide": true,
            "hazards": [
                "huge"
            ]
        },
        "TemplatesRowItem": {
            "kind": "article",
            "sample": {},
            "hazards": [
                "window-access"
            ]
        },
        "TestText": {
            "kind": "field",
            "sample": {},
            "hazards": [
                "needs-parent-state:sampleText"
            ]
        },
        "TextareaField": {
            "kind": "field",
            "sample": {
                "Textarea": {
                    "placeholder": "Write a short project description\u2026"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "TutorialBanner": {
            "kind": "article",
            "sample": {
                "href": "#",
                "title": "Getting started with Symbols",
                "p": "A 5-minute tour of the editor.",
                "state": {
                    "theme": "dialog",
                    "background": "https://assets.symbo.ls/logo-colorful.png"
                }
            },
            "hazards": [
                "empty-without-props"
            ]
        },
        "UploadAvatar": {
            "kind": "field",
            "sample": {}
        },
        "UploadField": {
            "kind": "field",
            "sample": {}
        },
        "UploadIcon": {
            "kind": "field",
            "sample": {}
        },
        "UploadImage": {
            "kind": "button",
            "sample": {}
        },
        "VerticalLine": {
            "kind": "layout",
            "sample": {}
        },
        "VideoWrapper": {
            "kind": "media",
            "sample": {
                "code": "dQw4w9WgXcQ"
            },
            "wide": true,
            "hazards": [
                "iframe",
                "autoplay-media",
                "empty-without-props"
            ]
        },
        "Vr": {
            "kind": "layout",
            "sample": {}
        },
        "WatchVideo": {
            "wide": true,
            "kind": "media",
            "sample": {},
            "hazards": [
                "modal-behavior",
                "autoplay-media"
            ]
        },
        "WiderButton": {
            "kind": "button",
            "sample": {
                "icon": "arrowRight"
            },
            "hazards": [
                "empty-without-props"
            ]
        }
    };
    // ── hand patches — things JSON can't carry (functions, live-asset lookups)
    // and honesty flags for empty definitions ─────────────────────────────────
    // Logo's onClick calls el.isEmbed()/el.isDocs() methods that only exist in
    // consumer shells; inert in the specimen. Its `icon` prop is consumed by
    // the SquareButton base from system/default — absent in the bare brand
    // app, so the Icon child needs the name directly or the cell shows only
    // the orange BETA span ("yellow place, no logo").
    map.Logo.sample.onClick = ()=>{};
    map.Logo.sample.Icon = {
        name: 'logov2'
    };
    if (map.LogoCopy) map.LogoCopy.sample = Object.assign({}, map.LogoCopy.sample, {
        Icon: {
            name: 'logov2'
        }
    });
    if (map.IconButton) map.IconButton.sample = Object.assign({
        Icon: {
            name: map.IconButton.sample && map.IconButton.sample.icon || 'plus'
        }
    }, map.IconButton.sample);
    // SwitchField's Input forwards to el.parent.onChange unconditionally.
    map.SwitchField.sample.onChange = ()=>{};
    if (map.SwitchFieldWithCaption) map.SwitchFieldWithCaption.sample.onChange = ()=>{};
    // Item family: the source default icon key ('tree outline') has no sprite
    // entry, and the {{ href }} template is unresolved outside a data context.
    const itemState = {
        icon: 'tree',
        title: 'Design system',
        p: 'Organized brand tokens into design and code'
    };
    [
        'Item',
        'ItemAlt',
        'ItemHighlight',
        'ItemHighlightAlt',
        'ItemOutline'
    ].forEach((n)=>{
        if (!map[n]) return;
        map[n].sample = Object.assign({}, map[n].sample, {
            href: null,
            state: itemState
        });
    });
    // Breadcrumb over window.location has nothing to read in a specimen cell.
    map.PathnameBreadcrumb.sample.children = [
        {
            text: 'brand'
        },
        {
            text: 'components'
        }
    ];
    // HeaderBreadcrumb's page dropdown calls shell-only methods
    // (getCanvasPathnameAnyway) from its list factory — inert the dropdown in
    // the specimen, keep the breadcrumb chrome.
    map.HeaderBreadcrumb.sample = Object.assign({}, map.HeaderBreadcrumb.sample, {
        Dropdown: null,
        Button_page: {
            Dropdown: null
        }
    });
    map.HeaderBreadcrumb.noteTag = "page menu needs a shell \u2014 inert here";
    // Video surfaces render their real chrome with the network legs removed —
    // no autoplaying embeds inside a specimen grid. The poster comes from the
    // brand's own files/ asset, live.
    map.VideoWrapper.sample = {
        Iframe: {
            src: null,
            hide: true
        },
        Picture: {
            src: (el)=>el.context.files && el.context.files['video.png'] && el.context.files['video.png'].content.src || null
        }
    };
    map.ModalVideo.sample = {
        position: 'relative',
        inset: 'unset',
        minHeight: 'F1',
        state: {
            activeVideo: true
        },
        Iframe: {
            src: null
        }
    };
    map.ModalVideo.noteTag = "overlay chrome \u2014 embed inert in specimen";
    if (map.CanvasEmbed) {
        map.CanvasEmbed.sample = Object.assign({}, map.CanvasEmbed.sample, {
            Iframe: {
                src: null
            }
        });
        map.CanvasEmbed.noteTag = "iframe inert \u2014 see CanvasEmbed.ClickToLoad for the live one";
    }
    if (map.CanvasEmbed2) {
        map.CanvasEmbed2.sample = Object.assign({}, map.CanvasEmbed2.sample, {
            Iframe: {
                src: null
            }
        });
        map.CanvasEmbed2.noteTag = 'iframe inert in specimen';
    }
    // Authored-empty stubs — shown as what they are, not faked.
    map.DropdownCopy = {
        kind: 'misc',
        sample: {},
        stub: true
    };
    map.LabeledCopy = {
        kind: 'badge',
        sample: {},
        stub: true
    };
    [
        'LandingFooterLite',
        'FooteLite',
        'FooterFull',
        'IteratorFooter'
    ].forEach((n)=>{
        if (map[n]) map[n].wide = true;
    });
    [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6',
        'Headline',
        'HeaderHeading'
    ].forEach((n)=>{
        if (map[n]) map[n].wide = true;
    });
    // Multi-column paragraph layout needs columns AND content.
    map.ColumnParagraphs.wide = true;
    map.ColumnParagraphs.sample = {
        children: [
            {
                text: 'One source of truth for every surface the product ships.'
            },
            {
                text: 'Tokens are rendered live, so the documentation cannot drift from the system it documents.'
            },
            {
                text: "Every value on this site is read from designSystem/ at runtime \u2014 never retyped."
            }
        ]
    };
    // Hgroup-based samples otherwise show the base defaults ('Heading' /
    // 'Paragraph') as literal copy.
    map.DotCaptionArticle.sample = Object.assign({}, map.DotCaptionArticle.sample, {
        H: {
            text: 'Changelog'
        },
        P: {
            text: 'What shipped across the platform this week'
        }
    });
    // Section headers: feed real title/nav state so the MenuItem nav and the
    // toggle icon button render their true shapes.
    const sectionHeaderState = {
        title: 'Latest releases',
        p: 'Everything that landed across the system this cycle.',
        nav: [
            {
                text: 'All'
            },
            {
                text: 'Design'
            },
            {
                text: 'Engineering'
            }
        ],
        toggleShow: false
    };
    map.SectionHeader.sample = Object.assign({}, map.SectionHeader.sample, {
        width: '100%',
        state: sectionHeaderState
    });
    map.SectionHeader.wide = true;
    map.SectionHeaderWithNav.sample = Object.assign({}, map.SectionHeaderWithNav.sample, {
        width: '100%',
        state: sectionHeaderState
    });
    map.SectionHeaderWithNav.wide = true;
    // Deprecated hidden-by-default tooltip bubble — force visible in specimen.
    map.NavbarTooltip.sample = Object.assign({}, map.NavbarTooltip.sample, {
        opacity: '1',
        visibility: 'visible',
        position: 'relative',
        transform: 'none',
        text: 'Tooltip'
    });
    // A backdrop wash IS its render — label it so the quiet cell reads as
    // intentional.
    if (map.SimpleOverlay) map.SimpleOverlay.noteTag = 'backdrop wash';
    if (map.Line) map.Line.noteTag = 'hairline';
    if (map.Hr) map.Hr.noteTag = 'hairline';
    if (map.VerticalLine) map.VerticalLine.noteTag = 'hairline';
    if (map.Vr) map.Vr.noteTag = 'hairline';
    return map;
}

});

parcelRegister("8lB2E", function(module, exports) {

$parcel$export(module.exports, "formatBrandColor", () => $613d049df43a838b$export$24d92f434f658146);
// Compact display form for a resolved CSS color: opaque rgba() → #HEX,
// translucent stays rgba with rounded channels. Display-only.
function $613d049df43a838b$export$24d92f434f658146(css) {
    if (!css) return "\u2014";
    const m = String(css).match(/rgba?\(([^)]+)\)/);
    if (!m) return String(css);
    const parts = m[1].split(/[\s,/]+/).filter(Boolean).map(parseFloat);
    if (parts.length < 3 || parts.some(isNaN)) return String(css);
    const a = parts.length > 3 ? parts[3] : 1;
    const hex = (n)=>Math.round(n).toString(16).padStart(2, '0');
    if (a >= 1) return ('#' + hex(parts[0]) + hex(parts[1]) + hex(parts[2])).toUpperCase();
    return 'rgba(' + Math.round(parts[0]) + ', ' + Math.round(parts[1]) + ', ' + Math.round(parts[2]) + ', ' + a + ')';
}

});

parcelRegister("fOWKH", function(module, exports) {

$parcel$export(module.exports, "resolveBrandGrammar", () => $b849197add732e8a$export$91928ed9ab41c5fe);
// Resolves the simple color-token grammar form `name(.alpha)` — e.g.
// 'gray2', 'white.75' — to a concrete CSS color for a theme, via the
// processed config. Used to compute real surface grounds (theme backgrounds)
// for the live contrast measurements. Tone modifiers (+N/-N/=N) are not
// needed for those grounds and are not handled here.
function $b849197add732e8a$export$91928ed9ab41c5fe(str, theme) {
    if (!str) return null;
    const m = String(str).match(/^([a-zA-Z][\w-]*)(?:\.(\d+))?$/);
    if (!m) return null;
    const base = this.call('resolveBrandColor', m[1], theme);
    if (!base) return null;
    if (!m[2]) return base;
    const alpha = parseFloat('0.' + m[2]);
    const p = String(base).match(/rgba?\(([^)]+)\)/);
    if (!p) return base;
    const parts = p[1].split(/[\s,/]+/).filter(Boolean).map(parseFloat);
    if (parts.length < 3 || parts.some(isNaN)) return base;
    return 'rgba(' + Math.round(parts[0]) + ', ' + Math.round(parts[1]) + ', ' + Math.round(parts[2]) + ', ' + alpha + ')';
}

});

parcelRegister("9J2qZ", function(module, exports) {

$parcel$export(module.exports, "brandSearchNavigate", () => $714a346c8bfa1958$export$f2b2ceeeca4a3d26);
// SPA navigation for search picks and internal links: routes through
// el.router (no full page load) and stashes the picked item on context so
// the target page can scroll to and flash it after mounting.
function $714a346c8bfa1958$export$f2b2ceeeca4a3d26(href, name, kind) {
    const win = this.context.window || window;
    if (kind && kind !== 'page' && name) this.context.brandSearchTarget = {
        name: String(name),
        kind: kind
    };
    const root = this.getRoot();
    if (win.location.pathname !== href) this.router(href, root);
    this.call('brandRevealSearchTarget');
}

});

parcelRegister("3RNoo", function(module, exports) {

$parcel$export(module.exports, "brandRevealSearchTarget", () => $2d0ca2a8becd75e4$export$ddbd661fffad4553);
// Scrolls to and briefly flashes the element matching the last search pick.
// Retries while async boards (ink matrix and friends) finish rendering.
// Read-only node traversal + the Web Animations API — no attributes or
// classes are touched and nothing persists. The flash color is resolved from
// the design system's own `highlight` pair, so it adapts per theme.
function $2d0ca2a8becd75e4$export$ddbd661fffad4553() {
    const ctx = this.context;
    const win = ctx.window || window;
    const rootEl = this.getRoot();
    const callFrom = this;
    const findIn = (node, name, depth)=>{
        if (!node || depth > 26) return null;
        const kids = node.children || [];
        for(let i = 0; i < kids.length; i++){
            const kid = kids[i];
            if (kid.getAttribute && (kid.getAttribute('title') === name || kid.getAttribute('data-icon') === name)) return kid;
            const txt = (kid.textContent || '').trim();
            if (txt === name || txt.indexOf(name + " \xb7") === 0) {
                const deeper = findIn(kid, name, depth + 1);
                return deeper || kid;
            }
            if (txt.indexOf(name) !== -1) {
                const deeper = findIn(kid, name, depth + 1);
                if (deeper) return deeper;
            }
        }
        return null;
    };
    // Fallback pass: some boards (icons) carry the name only in an attribute, with no matching text anywhere on the ancestor chain — the
    // pruned text walk never descends there. Full traversal, attributes only.
    const findTitleIn = (node, name, depth)=>{
        if (!node || depth > 30) return null;
        const kids = node.children || [];
        for(let i = 0; i < kids.length; i++){
            const kid = kids[i];
            if (kid.getAttribute && (kid.getAttribute('title') === name || kid.getAttribute('data-icon') === name)) return kid;
            const deeper = findTitleIn(kid, name, depth + 1);
            if (deeper) return deeper;
        }
        return null;
    };
    let tries = 0;
    const attempt = ()=>{
        const target = ctx.brandSearchTarget;
        if (!target || !target.name) return;
        const host = rootEl && rootEl.node;
        const match = host ? findIn(host, target.name, 0) || findTitleIn(host, target.name, 0) : null;
        if (!match) {
            tries++;
            if (tries < 10) win.setTimeout(attempt, 220);
            else ctx.brandSearchTarget = null;
            return;
        }
        ctx.brandSearchTarget = null;
        const box = match.children && match.children.length ? match : match.parentElement || match;
        box.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        const theme = ctx.globalTheme === 'light' ? 'light' : 'dark';
        const wash = callFrom.call('resolveBrandGrammar', 'highlight.14', theme);
        if (wash && box.animate) box.animate([
            {
                boxShadow: 'inset 0 0 0 999em ' + wash
            },
            {
                boxShadow: 'inset 0 0 0 999em ' + wash,
                offset: 0.4
            },
            {
                boxShadow: 'inset 0 0 0 999em transparent'
            }
        ], {
            duration: 1800,
            easing: 'cubic-bezier(.29, .67, .51, .97)'
        });
    };
    win.setTimeout(attempt, 120);
}

});

parcelRegister("iW5EP", function(module, exports) {

$parcel$export(module.exports, "brandIconCategories", () => $dc92083ef6ed1489$export$f4904503eda309c3);
// Splits the live sprite into display categories by name pattern — ordered
// rules, first match wins, catch-all last. Returns [{ title, names }] with
// source order preserved inside each category, so the board's total always
// equals the sprite count.
function $dc92083ef6ed1489$export$f4904503eda309c3() {
    const icons = this.context.designSystem && this.context.designSystem.icons || {};
    const names = Object.keys(icons);
    const rules = [
        [
            'SF set',
            /^sf[A-Z]|^sfInfo/
        ],
        [
            'Arrows & chevrons',
            /^arrow|^chevron|^back$|^forward$|^return$|^undo$|^redo$/
        ],
        [
            'Keyboard keys',
            /^cmd|^ctrl|^option|^shift$|^shiftAlt/
        ],
        [
            'Accessibility',
            /^accessibility|^colorContrast|^voiceover|^eyeClosed$|^eyeOpen$/
        ],
        [
            'Box model & spacing',
            /^borderRadius|^borderWidth|^borderOpacity|^borderProps|^dimensions|^gap|^height|^margin|^padding|^proportion|^round|^sequence|^space|^width/
        ],
        [
            'Layout & devices',
            /^columns|^rows|^grid|^layout|^list|^device|^displayPreferences|^print$|^printOutline$|^sidebar|^box(Filled|Half)/
        ],
        [
            'Color & theme',
            /^color|^brightness$|^sun$|^sunOutline$|^moon$|^moonOutline$|^theme/
        ],
        [
            'Typography & text',
            /^font|^text|^typography|^language|^align/
        ],
        [
            'Interaction & input',
            /^choose|^click|^cursor|^drag|^focus|^hover|^input|^keyboard$|^mouse$|^notAllowed$|^selection|^switching|^touchscreen|^inspect$/
        ],
        [
            'Code & data',
            /^api|^array|^boolean|^bug|^cdn|^code$|^date|^fork$|^int$|^intOutline$|^object|^properties$|^state|^string|^terminal$|^version|^fn$|^fnOutline$|^flow$|^database/
        ],
        [
            'Brands & tech',
            /^angular$|^discord$|^domql$|^elm$|^figma$|^github|^google|^facebook$|^linkedin$|^twitter$|^xcom$|^medium$|^stackoverflow$|^html$|^jquery$|^js$|^jsOutline$|^ts$|^tsOutline$|^react$|^vue$|^svelte$|^webComponents$|^wordpress$|^sketch$|^xd$|^vscode$|^npm|^pnpm|^yarn|^openSource$|^pdf$/
        ],
        [
            'Actions & status',
            /^check|^crossmark$|^x$|^xCircle|^xRect|^plus|^minus$|^play|^stop$|^refresh|^reload$|^reset$|^shuffle|^sync|^send$|^download|^upload|^install|^save|^unsave|^share$|^logout|^search|^zoom|^expand$|^minimize$|^fullscreen|^target$|^upgrade|^info|^exclMark$|^questionMark|^disabled$|^filter$/
        ]
    ];
    const out = rules.map((r)=>({
            title: r[0],
            names: []
        }));
    const rest = {
        title: 'Product & UI',
        names: []
    };
    for(let i = 0; i < names.length; i++){
        const name = names[i];
        let placed = false;
        for(let r = 0; r < rules.length; r++)if (rules[r][1].test(name)) {
            out[r].names.push(name);
            placed = true;
            break;
        }
        if (!placed) rest.names.push(name);
    }
    const display = out.filter((c)=>c.names.length);
    // Product & UI reads best first; SF set last (it is its own visual dialect)
    const sf = display.find((c)=>c.title === 'SF set');
    const ordered = [
        rest
    ].concat(display.filter((c)=>c !== sf));
    if (sf) ordered.push(sf);
    return ordered.filter((c)=>c.names.length);
}

});


parcelRegister("cf32A", function(module, exports) {

});

parcelRegister("TcgWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a5ea82bf425d0d8$export$2e2bcd8739ae039);

var $eDpQi = parcelRequire("eDpQi");

var $5qAbj = parcelRequire("5qAbj");

var $gpNcs = parcelRequire("gpNcs");

var $cCV3x = parcelRequire("cCV3x");

var $Y07ZP = parcelRequire("Y07ZP");

var $eG153 = parcelRequire("eG153");

var $eBUZ7 = parcelRequire("eBUZ7");

var $7jJda = parcelRequire("7jJda");

var $lUYbb = parcelRequire("lUYbb");

var $zBrum = parcelRequire("zBrum");

var $jGOzc = parcelRequire("jGOzc");

var $4IWMM = parcelRequire("4IWMM");

var $bfe2t = parcelRequire("bfe2t");

var $fggOV = parcelRequire("fggOV");

var $laeW7 = parcelRequire("laeW7");

var $aGlxz = parcelRequire("aGlxz");

var $lBlJh = parcelRequire("lBlJh");

var $2avOc = parcelRequire("2avOc");

var $cGa4H = parcelRequire("cGa4H");

var $lfaSG = parcelRequire("lfaSG");

var $9CugO = parcelRequire("9CugO");

var $j0CIE = parcelRequire("j0CIE");

var $kRcI1 = parcelRequire("kRcI1");

var $j5BSX = parcelRequire("j5BSX");

var $7fmpK = parcelRequire("7fmpK");

var $9tQ7H = parcelRequire("9tQ7H");

var $fYmlq = parcelRequire("fYmlq");

var $8aSEg = parcelRequire("8aSEg");

var $kVKVc = parcelRequire("kVKVc");

var $8SVOM = parcelRequire("8SVOM");

var $a9LeU = parcelRequire("a9LeU");

var $bdhO2 = parcelRequire("bdhO2");

var $74OOx = parcelRequire("74OOx");

var $d7iKX = parcelRequire("d7iKX");

var $C3ewJ = parcelRequire("C3ewJ");

var $jE7Wd = parcelRequire("jE7Wd");

var $gyRxo = parcelRequire("gyRxo");

var $uXWXJ = parcelRequire("uXWXJ");

var $i2dj8 = parcelRequire("i2dj8");

var $iKe4I = parcelRequire("iKe4I");

var $bAU8N = parcelRequire("bAU8N");

var $hWdLw = parcelRequire("hWdLw");

var $3YR9h = parcelRequire("3YR9h");

var $bPHf0 = parcelRequire("bPHf0");

var $bH0MG = parcelRequire("bH0MG");

var $fDjlw = parcelRequire("fDjlw");

var $hAHMx = parcelRequire("hAHMx");

var $2f8n0 = parcelRequire("2f8n0");

var $gs73w = parcelRequire("gs73w");

var $kZHHO = parcelRequire("kZHHO");
var $0a5ea82bf425d0d8$export$2e2bcd8739ae039 = {
    "48x48.png": (0, $eDpQi.default),
    "72x72.png": (0, $5qAbj.default),
    "96x96.png": (0, $gpNcs.default),
    "192x192.png": (0, $cCV3x.default),
    "144x144.png": (0, $Y07ZP.default),
    "512x512.png": (0, $eG153.default),
    "350.png": (0, $eBUZ7.default),
    "630.png": (0, $7jJda.default),
    "350x350.png": (0, $lUYbb.default),
    "apple-touch-icon.png": (0, $zBrum.default),
    "favicon-16x16.png": (0, $jGOzc.default),
    "favicon-32x32.png": (0, $4IWMM.default),
    "favicon.ico": (0, $bfe2t.default),
    "chrome-ext.png": (0, $fggOV.default),
    "shadow.png": (0, $laeW7.default),
    "main.gif": (0, $aGlxz.default),
    "cms.png": (0, $lBlJh.default),
    "dashboard.png": (0, $2avOc.default),
    "android-chrome-192x192.png": (0, $cGa4H.default),
    "google.svg": (0, $lfaSG.default),
    "github.svg": (0, $9CugO.default),
    "loading.gif": (0, $j0CIE.default),
    "1200.png": (0, $kRcI1.default),
    "google.png": (0, $j5BSX.default),
    "chrome-ext-icon.png": (0, $7fmpK.default),
    "intro.gif": (0, $9tQ7H.default),
    "code-preview.gif": (0, $fYmlq.default),
    "library-reuse.gif": (0, $8aSEg.default),
    "video.png": (0, $kVKVc.default),
    "teimuraz-abuladze.jpg": (0, $8SVOM.default),
    "giga-tamarashvili.jpg": (0, $a9LeU.default),
    "irakli-beridze.jpg": (0, $bdhO2.default),
    "royhan.jpg": (0, $74OOx.default),
    "luka-beria.jpg": (0, $d7iKX.default),
    "manju-kanuparthi.jpg": (0, $C3ewJ.default),
    "zachary-betzen.jpg": (0, $jE7Wd.default),
    "imad-yaici.jpg": (0, $gyRxo.default),
    "chuck-homola.jpg": (0, $uXWXJ.default),
    "ha-le.jpg": (0, $i2dj8.default),
    "tao-zhang.jpg": (0, $iKe4I.default),
    "thomas-gazaniga.jpg": (0, $bAU8N.default),
    "zajim-kujovic.jpg": (0, $hWdLw.default),
    "marina-layus.jpg": (0, $3YR9h.default),
    "allen-johnson.jpg": (0, $bPHf0.default),
    "adam-frankl.jpg": (0, $bH0MG.default),
    "lars-vestergaard.jpg": (0, $fDjlw.default),
    "nika-tomadze.jpg": (0, $hAHMx.default),
    "tornike-machavariani.jpg": (0, $2f8n0.default),
    "joshua-mcmillan.jpg": (0, $gs73w.default),
    "tamar-chkhaidze.jpg": (0, $kZHHO.default)
};

});
parcelRegister("eDpQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa78c0f83c9a9305$export$2e2bcd8739ae039);
var $aa78c0f83c9a9305$export$2e2bcd8739ae039 = {
    content: {
        filename: 'Q_4NZQh2OwZH9gGmagM18.png',
        originalName: '48x48.png',
        mimeType: 'image/png',
        size: 2290,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/Q_4NZQh2OwZH9gGmagM18.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc964133f54fc481fb04f6',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:01.782Z',
        updatedAt: '2026-10-24T11:28:01.782Z',
        __v: 0,
        extension: 'png',
        humanSize: '2.24 KB',
        age: 20,
        id: '6adc964133f54fc481fb04f6',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc964133f54fc481fb04f6',
                download: '/core/files/public/6adc964133f54fc481fb04f6/download',
                publicDownload: '/core/files/public/6adc964133f54fc481fb04f6/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc964133f54fc481fb04f6',
                download: 'https://api.symbols.app/core/files/public/6adc964133f54fc481fb04f6/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc964133f54fc481fb04f6/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/Q_4NZQh2OwZH9gGmagM18.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc964133f54fc481fb04f6/download'
    },
    code: '',
    key: '48x48.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("5qAbj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3b725bdfab01b2$export$2e2bcd8739ae039);
var $3f3b725bdfab01b2$export$2e2bcd8739ae039 = {
    content: {
        filename: '0n7_FRt-1Y72ab709nVNI.png',
        originalName: '72x72.png',
        mimeType: 'image/png',
        size: 3296,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/0n7_FRt-1Y72ab709nVNI.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc964733f54fc481fb063f',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:07.453Z',
        updatedAt: '2026-10-24T11:28:07.453Z',
        __v: 0,
        extension: 'png',
        humanSize: '3.22 KB',
        age: 167,
        id: '6adc964733f54fc481fb063f',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc964733f54fc481fb063f',
                download: '/core/files/public/6adc964733f54fc481fb063f/download',
                publicDownload: '/core/files/public/6adc964733f54fc481fb063f/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc964733f54fc481fb063f',
                download: 'https://api.symbols.app/core/files/public/6adc964733f54fc481fb063f/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc964733f54fc481fb063f/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/0n7_FRt-1Y72ab709nVNI.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc964733f54fc481fb063f/download'
    },
    code: '',
    key: '72x72.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("gpNcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf35253808ae1812$export$2e2bcd8739ae039);
var $bf35253808ae1812$export$2e2bcd8739ae039 = {
    content: {
        filename: 'W4ZrnVlXcGGHmM2J-BGnB.png',
        originalName: '96x96.png',
        mimeType: 'image/png',
        size: 4408,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/W4ZrnVlXcGGHmM2J-BGnB.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc964933f54fc481fb069e',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:09.519Z',
        updatedAt: '2026-10-24T11:28:09.519Z',
        __v: 0,
        extension: 'png',
        humanSize: '4.3 KB',
        age: 13,
        id: '6adc964933f54fc481fb069e',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc964933f54fc481fb069e',
                download: '/core/files/public/6adc964933f54fc481fb069e/download',
                publicDownload: '/core/files/public/6adc964933f54fc481fb069e/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc964933f54fc481fb069e',
                download: 'https://api.symbols.app/core/files/public/6adc964933f54fc481fb069e/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc964933f54fc481fb069e/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/W4ZrnVlXcGGHmM2J-BGnB.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc964933f54fc481fb069e/download'
    },
    code: '',
    key: '96x96.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("cCV3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $93154acf7cd60bb4$export$2e2bcd8739ae039);
var $93154acf7cd60bb4$export$2e2bcd8739ae039 = {
    content: {
        filename: 'bvAxCkoGrHh4elFYQTooP.png',
        originalName: '192x192.png',
        mimeType: 'image/png',
        size: 9324,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/bvAxCkoGrHh4elFYQTooP.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc963c33f54fc481fb02bf',
        previousVersions: [],
        createdAt: '2026-10-24T11:27:56.478Z',
        updatedAt: '2026-10-24T11:27:56.478Z',
        __v: 0,
        extension: 'png',
        humanSize: '9.11 KB',
        age: 12,
        id: '6adc963c33f54fc481fb02bf',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc963c33f54fc481fb02bf',
                download: '/core/files/public/6adc963c33f54fc481fb02bf/download',
                publicDownload: '/core/files/public/6adc963c33f54fc481fb02bf/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc963c33f54fc481fb02bf',
                download: 'https://api.symbols.app/core/files/public/6adc963c33f54fc481fb02bf/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc963c33f54fc481fb02bf/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/bvAxCkoGrHh4elFYQTooP.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc963c33f54fc481fb02bf/download'
    },
    code: '',
    key: '192x192.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("Y07ZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b45b41fa3f34edb$export$2e2bcd8739ae039);
var $0b45b41fa3f34edb$export$2e2bcd8739ae039 = {
    content: {
        filename: 'TOnISIPlJxC2ZL7NGYYr5.png',
        originalName: '144x144.png',
        mimeType: 'image/png',
        size: 6451,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/TOnISIPlJxC2ZL7NGYYr5.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc963a33f54fc481fb019a',
        previousVersions: [],
        createdAt: '2026-10-24T11:27:54.537Z',
        updatedAt: '2026-10-24T11:27:54.537Z',
        __v: 0,
        extension: 'png',
        humanSize: '6.3 KB',
        age: 11,
        id: '6adc963a33f54fc481fb019a',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc963a33f54fc481fb019a',
                download: '/core/files/public/6adc963a33f54fc481fb019a/download',
                publicDownload: '/core/files/public/6adc963a33f54fc481fb019a/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc963a33f54fc481fb019a',
                download: 'https://api.symbols.app/core/files/public/6adc963a33f54fc481fb019a/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc963a33f54fc481fb019a/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/TOnISIPlJxC2ZL7NGYYr5.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc963a33f54fc481fb019a/download'
    },
    code: '',
    key: '144x144.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("eG153", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf5d379e266f321$export$2e2bcd8739ae039);
var $aaf5d379e266f321$export$2e2bcd8739ae039 = {
    content: {
        filename: 'AuXA42iY-9zvh1YkHId_Q.png',
        originalName: '512x512.png',
        mimeType: 'image/png',
        size: 32150,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/AuXA42iY-9zvh1YkHId_Q.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc96438ee13493ac14f16a',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:03.560Z',
        updatedAt: '2026-10-24T11:28:03.560Z',
        __v: 0,
        extension: 'png',
        humanSize: '31.4 KB',
        age: 12,
        id: '6adc96438ee13493ac14f16a',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc96438ee13493ac14f16a',
                download: '/core/files/public/6adc96438ee13493ac14f16a/download',
                publicDownload: '/core/files/public/6adc96438ee13493ac14f16a/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc96438ee13493ac14f16a',
                download: 'https://api.symbols.app/core/files/public/6adc96438ee13493ac14f16a/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc96438ee13493ac14f16a/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/AuXA42iY-9zvh1YkHId_Q.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc96438ee13493ac14f16a/download'
    },
    code: '',
    key: '512x512.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("eBUZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa30b95cc3b0ec98$export$2e2bcd8739ae039);
var $aa30b95cc3b0ec98$export$2e2bcd8739ae039 = {
    content: {
        filename: '1Slnmuv_AllXw1d1NNHMo.png',
        originalName: '350.png',
        mimeType: 'image/png',
        size: 40460,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/1Slnmuv_AllXw1d1NNHMo.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc963e33f54fc481fb03bb',
        previousVersions: [],
        createdAt: '2026-10-24T11:27:58.287Z',
        updatedAt: '2026-10-24T11:27:58.287Z',
        __v: 0,
        extension: 'png',
        humanSize: '39.51 KB',
        age: 10,
        id: '6adc963e33f54fc481fb03bb',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc963e33f54fc481fb03bb',
                download: '/core/files/public/6adc963e33f54fc481fb03bb/download',
                publicDownload: '/core/files/public/6adc963e33f54fc481fb03bb/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc963e33f54fc481fb03bb',
                download: 'https://api.symbols.app/core/files/public/6adc963e33f54fc481fb03bb/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc963e33f54fc481fb03bb/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/1Slnmuv_AllXw1d1NNHMo.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc963e33f54fc481fb03bb/download'
    },
    code: '',
    key: '350.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("7jJda", function(module, exports) {

$parcel$export(module.exports, "default", () => $553d60ce5bbbdc7b$export$2e2bcd8739ae039);
var $553d60ce5bbbdc7b$export$2e2bcd8739ae039 = {
    content: {
        filename: 'WFUSoaeyDXEVSt7huEvG9.png',
        originalName: '630.png',
        mimeType: 'image/png',
        size: 18293,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/WFUSoaeyDXEVSt7huEvG9.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc964533f54fc481fb0594',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:05.330Z',
        updatedAt: '2026-10-24T11:28:05.330Z',
        __v: 0,
        extension: 'png',
        humanSize: '17.86 KB',
        age: 13,
        id: '6adc964533f54fc481fb0594',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc964533f54fc481fb0594',
                download: '/core/files/public/6adc964533f54fc481fb0594/download',
                publicDownload: '/core/files/public/6adc964533f54fc481fb0594/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc964533f54fc481fb0594',
                download: 'https://api.symbols.app/core/files/public/6adc964533f54fc481fb0594/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc964533f54fc481fb0594/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/WFUSoaeyDXEVSt7huEvG9.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc964533f54fc481fb0594/download'
    },
    code: '',
    key: '630.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("lUYbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff4d824aa53acf4d$export$2e2bcd8739ae039);
var $ff4d824aa53acf4d$export$2e2bcd8739ae039 = {
    content: {
        filename: 'grw4o2aaLuu3GouLY2B6w.png',
        originalName: '350x350.png',
        mimeType: 'image/png',
        size: 40460,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/grw4o2aaLuu3GouLY2B6w.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc963f8ee13493ac14f0c6',
        previousVersions: [],
        createdAt: '2026-10-24T11:27:59.936Z',
        updatedAt: '2026-10-24T11:27:59.936Z',
        __v: 0,
        extension: 'png',
        humanSize: '39.51 KB',
        age: 13,
        id: '6adc963f8ee13493ac14f0c6',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc963f8ee13493ac14f0c6',
                download: '/core/files/public/6adc963f8ee13493ac14f0c6/download',
                publicDownload: '/core/files/public/6adc963f8ee13493ac14f0c6/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc963f8ee13493ac14f0c6',
                download: 'https://api.symbols.app/core/files/public/6adc963f8ee13493ac14f0c6/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc963f8ee13493ac14f0c6/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/grw4o2aaLuu3GouLY2B6w.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc963f8ee13493ac14f0c6/download'
    },
    code: '',
    key: '350x350.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("zBrum", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b05045ca74476c$export$2e2bcd8739ae039);
var $06b05045ca74476c$export$2e2bcd8739ae039 = {
    content: {
        filename: 'I7hBfKCk6SQDgCJDAYd3g.png',
        originalName: 'apple-touch-icon.png',
        mimeType: 'image/png',
        size: 3382,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/I7hBfKCk6SQDgCJDAYd3g.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc964d33f54fc481fb072f',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:13.595Z',
        updatedAt: '2026-10-24T11:28:13.595Z',
        __v: 0,
        extension: 'png',
        humanSize: '3.3 KB',
        age: 10,
        id: '6adc964d33f54fc481fb072f',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc964d33f54fc481fb072f',
                download: '/core/files/public/6adc964d33f54fc481fb072f/download',
                publicDownload: '/core/files/public/6adc964d33f54fc481fb072f/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc964d33f54fc481fb072f',
                download: 'https://api.symbols.app/core/files/public/6adc964d33f54fc481fb072f/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc964d33f54fc481fb072f/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/I7hBfKCk6SQDgCJDAYd3g.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc964d33f54fc481fb072f/download'
    },
    code: '',
    key: 'apple-touch-icon.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("jGOzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5592a0b5de166f7$export$2e2bcd8739ae039);
var $e5592a0b5de166f7$export$2e2bcd8739ae039 = {
    content: {
        filename: 'u_jWAtQiP-_322Ieox_IL.png',
        originalName: 'favicon-16x16.png',
        mimeType: 'image/png',
        size: 639,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/u_jWAtQiP-_322Ieox_IL.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc965533f54fc481fb07fe',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:21.361Z',
        updatedAt: '2026-10-24T11:28:21.361Z',
        __v: 0,
        extension: 'png',
        humanSize: '639 Bytes',
        age: 12,
        id: '6adc965533f54fc481fb07fe',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc965533f54fc481fb07fe',
                download: '/core/files/public/6adc965533f54fc481fb07fe/download',
                publicDownload: '/core/files/public/6adc965533f54fc481fb07fe/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc965533f54fc481fb07fe',
                download: 'https://api.symbols.app/core/files/public/6adc965533f54fc481fb07fe/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc965533f54fc481fb07fe/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/u_jWAtQiP-_322Ieox_IL.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc965533f54fc481fb07fe/download'
    },
    code: '',
    key: 'favicon-16x16.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("4IWMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3708df1fe2f4d3b1$export$2e2bcd8739ae039);
var $3708df1fe2f4d3b1$export$2e2bcd8739ae039 = {
    content: {
        filename: '_OmubEdaAHY3qTSSgJ0a-.png',
        originalName: 'favicon-32x32.png',
        mimeType: 'image/png',
        size: 919,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/_OmubEdaAHY3qTSSgJ0a-.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc965733f54fc481fb0869',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:23.063Z',
        updatedAt: '2026-10-24T11:28:23.063Z',
        __v: 0,
        extension: 'png',
        humanSize: '919 Bytes',
        age: 11,
        id: '6adc965733f54fc481fb0869',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc965733f54fc481fb0869',
                download: '/core/files/public/6adc965733f54fc481fb0869/download',
                publicDownload: '/core/files/public/6adc965733f54fc481fb0869/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc965733f54fc481fb0869',
                download: 'https://api.symbols.app/core/files/public/6adc965733f54fc481fb0869/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc965733f54fc481fb0869/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/_OmubEdaAHY3qTSSgJ0a-.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc965733f54fc481fb0869/download'
    },
    code: '',
    key: 'favicon-32x32.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("bfe2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $82fbfc44d0f408a8$export$2e2bcd8739ae039);
var $82fbfc44d0f408a8$export$2e2bcd8739ae039 = {
    content: {
        filename: 'nIiOoPB4woDIZl7r_0y82.ico',
        originalName: 'favicon.ico',
        mimeType: 'image/x-icon',
        size: 2004,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/nIiOoPB4woDIZl7r_0y82.ico',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc960833f54fc481fae21c',
        previousVersions: [],
        createdAt: '2026-10-24T11:27:04.177Z',
        updatedAt: '2026-10-24T11:27:04.177Z',
        __v: 0,
        extension: 'ico',
        humanSize: '1.96 KB',
        age: 123,
        id: '6adc960833f54fc481fae21c',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc960833f54fc481fae21c',
                download: '/core/files/public/6adc960833f54fc481fae21c/download',
                publicDownload: '/core/files/public/6adc960833f54fc481fae21c/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc960833f54fc481fae21c',
                download: 'https://api.symbols.app/core/files/public/6adc960833f54fc481fae21c/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc960833f54fc481fae21c/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/nIiOoPB4woDIZl7r_0y82.ico'
        },
        src: 'https://api.symbols.app/core/files/public/6adc960833f54fc481fae21c/download'
    },
    code: '',
    key: 'favicon.ico',
    type: 'files',
    format: 'ico'
};

});

parcelRegister("fggOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c565cd9ef641aa$export$2e2bcd8739ae039);
var $b1c565cd9ef641aa$export$2e2bcd8739ae039 = {
    content: {
        filename: 'st0U7Kd_ElFfQoJEVSVZQ.png',
        originalName: 'chrome-ext.png',
        mimeType: 'image/png',
        size: 9173,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/st0U7Kd_ElFfQoJEVSVZQ.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc964f8ee13493ac14f364',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:15.339Z',
        updatedAt: '2026-10-24T11:28:15.339Z',
        __v: 0,
        extension: 'png',
        humanSize: '8.96 KB',
        age: 11,
        id: '6adc964f8ee13493ac14f364',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc964f8ee13493ac14f364',
                download: '/core/files/public/6adc964f8ee13493ac14f364/download',
                publicDownload: '/core/files/public/6adc964f8ee13493ac14f364/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc964f8ee13493ac14f364',
                download: 'https://api.symbols.app/core/files/public/6adc964f8ee13493ac14f364/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc964f8ee13493ac14f364/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/st0U7Kd_ElFfQoJEVSVZQ.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc964f8ee13493ac14f364/download'
    },
    code: '',
    key: 'chrome-ext.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("laeW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6861e2dc1ae5dea$export$2e2bcd8739ae039);
var $f6861e2dc1ae5dea$export$2e2bcd8739ae039 = {
    content: {
        filename: 'C-7I76eJDnRN44N-qDfST.png',
        originalName: 'shadow.png',
        mimeType: 'image/png',
        size: 553488,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/C-7I76eJDnRN44N-qDfST.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc96648ee13493ac14f668',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:36.972Z',
        updatedAt: '2026-10-24T11:28:36.972Z',
        __v: 0,
        extension: 'png',
        humanSize: '540.52 KB',
        age: 12,
        id: '6adc96648ee13493ac14f668',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc96648ee13493ac14f668',
                download: '/core/files/public/6adc96648ee13493ac14f668/download',
                publicDownload: '/core/files/public/6adc96648ee13493ac14f668/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc96648ee13493ac14f668',
                download: 'https://api.symbols.app/core/files/public/6adc96648ee13493ac14f668/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc96648ee13493ac14f668/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/C-7I76eJDnRN44N-qDfST.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc96648ee13493ac14f668/download'
    },
    code: '',
    key: 'shadow.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("aGlxz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6e8918375ddecd$export$2e2bcd8739ae039);
var $7c6e8918375ddecd$export$2e2bcd8739ae039 = {
    content: {
        filename: '8NGM9-KLWJ4iZymHidoUk.gif',
        originalName: 'main.gif',
        mimeType: 'image/gif',
        size: 2177334,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/8NGM9-KLWJ4iZymHidoUk.gif',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc96628ee13493ac14f5aa',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:34.141Z',
        updatedAt: '2026-10-24T11:28:34.141Z',
        __v: 0,
        extension: 'gif',
        humanSize: '2.08 MB',
        age: 11,
        id: '6adc96628ee13493ac14f5aa',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc96628ee13493ac14f5aa',
                download: '/core/files/public/6adc96628ee13493ac14f5aa/download',
                publicDownload: '/core/files/public/6adc96628ee13493ac14f5aa/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc96628ee13493ac14f5aa',
                download: 'https://api.symbols.app/core/files/public/6adc96628ee13493ac14f5aa/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc96628ee13493ac14f5aa/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/8NGM9-KLWJ4iZymHidoUk.gif'
        },
        src: 'https://api.symbols.app/core/files/public/6adc96628ee13493ac14f5aa/download'
    },
    code: '',
    key: 'main.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("lBlJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9de8a6858a3c42$export$2e2bcd8739ae039);
var $fb9de8a6858a3c42$export$2e2bcd8739ae039 = {
    content: {
        filename: 'xC7YUUj-58wM7iN9MIrv_.png',
        originalName: 'cms.png',
        mimeType: 'image/png',
        size: 128743,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/xC7YUUj-58wM7iN9MIrv_.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc965133f54fc481fb0774',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:17.289Z',
        updatedAt: '2026-10-24T11:28:17.289Z',
        __v: 0,
        extension: 'png',
        humanSize: '125.73 KB',
        age: 11,
        id: '6adc965133f54fc481fb0774',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc965133f54fc481fb0774',
                download: '/core/files/public/6adc965133f54fc481fb0774/download',
                publicDownload: '/core/files/public/6adc965133f54fc481fb0774/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc965133f54fc481fb0774',
                download: 'https://api.symbols.app/core/files/public/6adc965133f54fc481fb0774/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc965133f54fc481fb0774/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/xC7YUUj-58wM7iN9MIrv_.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc965133f54fc481fb0774/download'
    },
    code: '',
    key: 'cms.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("2avOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $194530777bfafa91$export$2e2bcd8739ae039);
var $194530777bfafa91$export$2e2bcd8739ae039 = {
    content: {
        filename: 'rks30xg1K2Kb-YYDPlS9F.png',
        originalName: 'dashboard.png',
        mimeType: 'image/png',
        size: 1616973,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/rks30xg1K2Kb-YYDPlS9F.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc965333f54fc481fb07ac',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:19.466Z',
        updatedAt: '2026-10-24T11:28:19.466Z',
        __v: 0,
        extension: 'png',
        humanSize: '1.54 MB',
        age: 11,
        id: '6adc965333f54fc481fb07ac',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc965333f54fc481fb07ac',
                download: '/core/files/public/6adc965333f54fc481fb07ac/download',
                publicDownload: '/core/files/public/6adc965333f54fc481fb07ac/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc965333f54fc481fb07ac',
                download: 'https://api.symbols.app/core/files/public/6adc965333f54fc481fb07ac/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc965333f54fc481fb07ac/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/rks30xg1K2Kb-YYDPlS9F.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc965333f54fc481fb07ac/download'
    },
    code: '',
    key: 'dashboard.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("cGa4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b138e9ced4fc1b$export$2e2bcd8739ae039);
var $93b138e9ced4fc1b$export$2e2bcd8739ae039 = {
    content: {
        filename: 'LCWyyhtsj4dsKQCaynKwZ.png',
        originalName: 'android-chrome-192x192.png',
        mimeType: 'image/png',
        size: 3547,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/LCWyyhtsj4dsKQCaynKwZ.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc964b8ee13493ac14f30b',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:11.475Z',
        updatedAt: '2026-10-24T11:28:11.475Z',
        __v: 0,
        extension: 'png',
        humanSize: '3.46 KB',
        age: 12,
        id: '6adc964b8ee13493ac14f30b',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc964b8ee13493ac14f30b',
                download: '/core/files/public/6adc964b8ee13493ac14f30b/download',
                publicDownload: '/core/files/public/6adc964b8ee13493ac14f30b/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc964b8ee13493ac14f30b',
                download: 'https://api.symbols.app/core/files/public/6adc964b8ee13493ac14f30b/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc964b8ee13493ac14f30b/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/LCWyyhtsj4dsKQCaynKwZ.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc964b8ee13493ac14f30b/download'
    },
    code: '',
    key: 'android-chrome-192x192.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("lfaSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f773706e589538eb$export$2e2bcd8739ae039);
var $f773706e589538eb$export$2e2bcd8739ae039 = {
    content: {
        filename: 'TCRMSExIX8WvJvzWbzoZm.svg',
        originalName: 'google.svg',
        mimeType: 'image/svg+xml',
        size: 2204,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/TCRMSExIX8WvJvzWbzoZm.svg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc965d33f54fc481fb08bb',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:29.482Z',
        updatedAt: '2026-10-24T11:28:29.482Z',
        __v: 0,
        extension: 'svg',
        humanSize: '2.15 KB',
        age: 14,
        id: '6adc965d33f54fc481fb08bb',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc965d33f54fc481fb08bb',
                download: '/core/files/public/6adc965d33f54fc481fb08bb/download',
                publicDownload: '/core/files/public/6adc965d33f54fc481fb08bb/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc965d33f54fc481fb08bb',
                download: 'https://api.symbols.app/core/files/public/6adc965d33f54fc481fb08bb/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc965d33f54fc481fb08bb/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/TCRMSExIX8WvJvzWbzoZm.svg'
        },
        src: 'https://api.symbols.app/core/files/public/6adc965d33f54fc481fb08bb/download'
    },
    code: '',
    key: 'google.svg',
    type: 'files',
    format: 'svg'
};

});

parcelRegister("9CugO", function(module, exports) {

$parcel$export(module.exports, "default", () => $700f24b5fcf7b492$export$2e2bcd8739ae039);
var $700f24b5fcf7b492$export$2e2bcd8739ae039 = {
    content: {
        filename: 'ojDE_NyPw-2idfycSMv08.svg',
        originalName: 'github.svg',
        mimeType: 'image/svg+xml',
        size: 2666,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/ojDE_NyPw-2idfycSMv08.svg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc96588ee13493ac14f47c',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:24.968Z',
        updatedAt: '2026-10-24T11:28:24.968Z',
        __v: 0,
        extension: 'svg',
        humanSize: '2.6 KB',
        age: 309,
        id: '6adc96588ee13493ac14f47c',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc96588ee13493ac14f47c',
                download: '/core/files/public/6adc96588ee13493ac14f47c/download',
                publicDownload: '/core/files/public/6adc96588ee13493ac14f47c/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc96588ee13493ac14f47c',
                download: 'https://api.symbols.app/core/files/public/6adc96588ee13493ac14f47c/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc96588ee13493ac14f47c/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/ojDE_NyPw-2idfycSMv08.svg'
        },
        src: 'https://api.symbols.app/core/files/public/6adc96588ee13493ac14f47c/download'
    },
    code: '',
    key: 'github.svg',
    type: 'files',
    format: 'svg'
};

});

parcelRegister("j0CIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6c0d3fb26243df$export$2e2bcd8739ae039);
var $dd6c0d3fb26243df$export$2e2bcd8739ae039 = {
    content: {
        filename: '53lTk1npXJSUP7XR3sJUM.gif',
        originalName: 'loading.gif',
        mimeType: 'image/gif',
        size: 95340,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/53lTk1npXJSUP7XR3sJUM.gif',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc965f8ee13493ac14f512',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:31.691Z',
        updatedAt: '2026-10-24T11:28:31.691Z',
        __v: 0,
        extension: 'gif',
        humanSize: '93.11 KB',
        age: 13,
        id: '6adc965f8ee13493ac14f512',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc965f8ee13493ac14f512',
                download: '/core/files/public/6adc965f8ee13493ac14f512/download',
                publicDownload: '/core/files/public/6adc965f8ee13493ac14f512/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc965f8ee13493ac14f512',
                download: 'https://api.symbols.app/core/files/public/6adc965f8ee13493ac14f512/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc965f8ee13493ac14f512/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/53lTk1npXJSUP7XR3sJUM.gif'
        },
        src: 'https://api.symbols.app/core/files/public/6adc965f8ee13493ac14f512/download'
    },
    code: '',
    key: 'loading.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("kRcI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2f29da0b869b5e7$export$2e2bcd8739ae039);
var $f2f29da0b869b5e7$export$2e2bcd8739ae039 = {
    content: {
        filename: 'UIqmYlZSVGlxCu6TKsshb.png',
        originalName: '1200.png',
        mimeType: 'image/png',
        size: 27781,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/UIqmYlZSVGlxCu6TKsshb.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc963833f54fc481fb010d',
        previousVersions: [],
        createdAt: '2026-10-24T11:27:52.522Z',
        updatedAt: '2026-10-24T11:27:52.522Z',
        __v: 0,
        extension: 'png',
        humanSize: '27.13 KB',
        age: 57,
        id: '6adc963833f54fc481fb010d',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc963833f54fc481fb010d',
                download: '/core/files/public/6adc963833f54fc481fb010d/download',
                publicDownload: '/core/files/public/6adc963833f54fc481fb010d/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc963833f54fc481fb010d',
                download: 'https://api.symbols.app/core/files/public/6adc963833f54fc481fb010d/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc963833f54fc481fb010d/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/UIqmYlZSVGlxCu6TKsshb.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc963833f54fc481fb010d/download'
    },
    code: '',
    key: '1200.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("j5BSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $de5bdf3877e638f4$export$2e2bcd8739ae039);
var $de5bdf3877e638f4$export$2e2bcd8739ae039 = {
    content: {
        filename: 'UJRpJSqTrEEdwmbtWvTsE.png',
        originalName: 'google.png',
        mimeType: 'image/png',
        size: 5014,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/UJRpJSqTrEEdwmbtWvTsE.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6adc965b8ee13493ac14f4a6',
        previousVersions: [],
        createdAt: '2026-10-24T11:28:27.382Z',
        updatedAt: '2026-10-24T11:28:27.382Z',
        __v: 0,
        extension: 'png',
        humanSize: '4.9 KB',
        age: 13,
        id: '6adc965b8ee13493ac14f4a6',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6adc965b8ee13493ac14f4a6',
                download: '/core/files/public/6adc965b8ee13493ac14f4a6/download',
                publicDownload: '/core/files/public/6adc965b8ee13493ac14f4a6/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6adc965b8ee13493ac14f4a6',
                download: 'https://api.symbols.app/core/files/public/6adc965b8ee13493ac14f4a6/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6adc965b8ee13493ac14f4a6/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/UJRpJSqTrEEdwmbtWvTsE.png'
        },
        src: 'https://api.symbols.app/core/files/public/6adc965b8ee13493ac14f4a6/download'
    },
    code: '',
    key: 'google.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("7fmpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $546b5222595accae$export$2e2bcd8739ae039);
var $546b5222595accae$export$2e2bcd8739ae039 = {
    content: {
        filename: 'MRpDgK94HecveGH5pWmBr.png',
        originalName: 'chrome-ext-icon.png',
        mimeType: 'image/png',
        size: 3859,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/MRpDgK94HecveGH5pWmBr.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '692d973ad181acc7ae7643df',
        previousVersions: [],
        createdAt: '2025-12-01T13:25:14.028Z',
        updatedAt: '2025-12-01T13:25:14.028Z',
        __v: 0,
        extension: 'png',
        humanSize: '3.77 KB',
        age: 61,
        id: '692d973ad181acc7ae7643df',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/692d973ad181acc7ae7643df',
                download: '/core/files/public/692d973ad181acc7ae7643df/download',
                publicDownload: '/core/files/public/692d973ad181acc7ae7643df/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/692d973ad181acc7ae7643df',
                download: 'https://api.symbols.app/core/files/public/692d973ad181acc7ae7643df/download',
                publicDownload: 'https://api.symbols.app/core/files/public/692d973ad181acc7ae7643df/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/MRpDgK94HecveGH5pWmBr.png'
        },
        src: 'https://api.symbols.app/core/files/public/692d973ad181acc7ae7643df/download'
    },
    code: '',
    key: 'chrome-ext-icon.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("9tQ7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e6f41170a626bb1$export$2e2bcd8739ae039);
var $6e6f41170a626bb1$export$2e2bcd8739ae039 = {
    content: {
        filename: 'sZSxgx8FHB9Ji0btF9RzH.gif',
        originalName: 'CleanShot 2025-12-09 at 19.15.52.gif',
        mimeType: 'image/gif',
        size: 19653178,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/sZSxgx8FHB9Ji0btF9RzH.gif',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '69383d9b3ecb53e4de021350',
        previousVersions: [],
        createdAt: '2025-12-09T15:17:47.711Z',
        updatedAt: '2025-12-09T15:17:47.711Z',
        __v: 0,
        extension: 'gif',
        humanSize: '18.74 MB',
        age: 74,
        id: '69383d9b3ecb53e4de021350',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/69383d9b3ecb53e4de021350',
                download: '/core/files/public/69383d9b3ecb53e4de021350/download',
                publicDownload: '/core/files/public/69383d9b3ecb53e4de021350/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/69383d9b3ecb53e4de021350',
                download: 'https://api.symbols.app/core/files/public/69383d9b3ecb53e4de021350/download',
                publicDownload: 'https://api.symbols.app/core/files/public/69383d9b3ecb53e4de021350/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/sZSxgx8FHB9Ji0btF9RzH.gif'
        },
        src: 'https://api.symbols.app/core/files/public/69383d9b3ecb53e4de021350/download'
    },
    code: '',
    key: 'intro.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("fYmlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0dcac7a34afeac$export$2e2bcd8739ae039);
var $ba0dcac7a34afeac$export$2e2bcd8739ae039 = {
    content: {
        filename: 'hvJXWqY4XAo1LJxmRc2Ir.gif',
        originalName: 'codePreview.gif',
        mimeType: 'image/gif',
        size: 2593793,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/hvJXWqY4XAo1LJxmRc2Ir.gif',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6931d31e6ed27368449c2dc0',
        previousVersions: [],
        createdAt: '2025-12-04T18:29:50.715Z',
        updatedAt: '2025-12-04T18:29:50.715Z',
        __v: 0,
        extension: 'gif',
        humanSize: '2.47 MB',
        age: 44,
        id: '6931d31e6ed27368449c2dc0',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6931d31e6ed27368449c2dc0',
                download: '/core/files/public/6931d31e6ed27368449c2dc0/download',
                publicDownload: '/core/files/public/6931d31e6ed27368449c2dc0/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6931d31e6ed27368449c2dc0',
                download: 'https://api.symbols.app/core/files/public/6931d31e6ed27368449c2dc0/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6931d31e6ed27368449c2dc0/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/hvJXWqY4XAo1LJxmRc2Ir.gif'
        },
        src: 'https://api.symbols.app/core/files/public/6931d31e6ed27368449c2dc0/download'
    },
    code: '',
    key: 'code-preview.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("8aSEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f39a5f4bb8276ac$export$2e2bcd8739ae039);
var $5f39a5f4bb8276ac$export$2e2bcd8739ae039 = {
    content: {
        src: 'https://api.symbols.app/core/files/public/69383fda3ecb53e4de02199f/download'
    },
    code: '',
    key: 'library-reuse.gif',
    type: 'files',
    format: 'gif'
};

});

parcelRegister("kVKVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3cd872d676a09b0$export$2e2bcd8739ae039);
var $f3cd872d676a09b0$export$2e2bcd8739ae039 = {
    content: {
        filename: 'QtlEndzsotxaaAMwACfHb.png',
        originalName: 'video.png',
        mimeType: 'image/png',
        size: 14131,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/QtlEndzsotxaaAMwACfHb.png',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6944ea6b4c0341ca0850df63',
        previousVersions: [],
        createdAt: '2025-12-19T06:02:19.751Z',
        updatedAt: '2025-12-19T06:02:19.751Z',
        __v: 0,
        extension: 'png',
        humanSize: '13.8 KB',
        age: 77,
        id: '6944ea6b4c0341ca0850df63',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6944ea6b4c0341ca0850df63',
                download: '/core/files/public/6944ea6b4c0341ca0850df63/download',
                publicDownload: '/core/files/public/6944ea6b4c0341ca0850df63/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6944ea6b4c0341ca0850df63',
                download: 'https://api.symbols.app/core/files/public/6944ea6b4c0341ca0850df63/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6944ea6b4c0341ca0850df63/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/QtlEndzsotxaaAMwACfHb.png'
        },
        src: 'https://api.symbols.app/core/files/public/6944ea6b4c0341ca0850df63/download'
    },
    code: '',
    key: 'video.png',
    type: 'files',
    format: 'png'
};

});

parcelRegister("8SVOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $67803759d0166447$export$2e2bcd8739ae039);
var $67803759d0166447$export$2e2bcd8739ae039 = {
    content: {
        filename: 'eDIZ_M9VdxZh9jHm-GlCw.jpg',
        originalName: 'teimuraz-abuladze.jpg',
        mimeType: 'image/jpeg',
        size: 21624,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/eDIZ_M9VdxZh9jHm-GlCw.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9ab85e84ba7692b1194c5f',
        previousVersions: [],
        createdAt: '2026-09-04T12:23:58.156Z',
        updatedAt: '2026-09-04T12:23:58.156Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '21.12 KB',
        age: 58,
        id: '6a9ab85e84ba7692b1194c5f',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9ab85e84ba7692b1194c5f',
                download: '/core/files/public/6a9ab85e84ba7692b1194c5f/download',
                publicDownload: '/core/files/public/6a9ab85e84ba7692b1194c5f/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9ab85e84ba7692b1194c5f',
                download: 'https://api.symbols.app/core/files/public/6a9ab85e84ba7692b1194c5f/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9ab85e84ba7692b1194c5f/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/eDIZ_M9VdxZh9jHm-GlCw.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9ab85e84ba7692b1194c5f/download'
    },
    code: '',
    key: 'teimuraz-abuladze.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("a9LeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $764f636be4e6995e$export$2e2bcd8739ae039);
var $764f636be4e6995e$export$2e2bcd8739ae039 = {
    content: {
        filename: 'vvbRL4AlXuermIzMiSuOU.jpg',
        originalName: 'giga-tamarashvili.jpg',
        mimeType: 'image/jpeg',
        size: 34612,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/vvbRL4AlXuermIzMiSuOU.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9acff984ba7692b12146ee',
        previousVersions: [],
        createdAt: '2026-09-04T14:04:41.169Z',
        updatedAt: '2026-09-04T14:04:41.169Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '33.8 KB',
        age: 40,
        id: '6a9acff984ba7692b12146ee',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9acff984ba7692b12146ee',
                download: '/core/files/public/6a9acff984ba7692b12146ee/download',
                publicDownload: '/core/files/public/6a9acff984ba7692b12146ee/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9acff984ba7692b12146ee',
                download: 'https://api.symbols.app/core/files/public/6a9acff984ba7692b12146ee/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9acff984ba7692b12146ee/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/vvbRL4AlXuermIzMiSuOU.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9acff984ba7692b12146ee/download'
    },
    code: '',
    key: 'giga-tamarashvili.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("bdhO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $829eb883313adcbc$export$2e2bcd8739ae039);
var $829eb883313adcbc$export$2e2bcd8739ae039 = {
    content: {
        filename: 'K0zwD9B8XXHQPBd4xT_LZ.jpg',
        originalName: 'irakli-beridze.jpg',
        mimeType: 'image/jpeg',
        size: 56587,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/K0zwD9B8XXHQPBd4xT_LZ.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9acffb84ba7692b121485c',
        previousVersions: [],
        createdAt: '2026-09-04T14:04:43.487Z',
        updatedAt: '2026-09-04T14:04:43.487Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '55.26 KB',
        age: 15,
        id: '6a9acffb84ba7692b121485c',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9acffb84ba7692b121485c',
                download: '/core/files/public/6a9acffb84ba7692b121485c/download',
                publicDownload: '/core/files/public/6a9acffb84ba7692b121485c/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9acffb84ba7692b121485c',
                download: 'https://api.symbols.app/core/files/public/6a9acffb84ba7692b121485c/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9acffb84ba7692b121485c/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/K0zwD9B8XXHQPBd4xT_LZ.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9acffb84ba7692b121485c/download'
    },
    code: '',
    key: 'irakli-beridze.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("74OOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $527052c303b3840b$export$2e2bcd8739ae039);
var $527052c303b3840b$export$2e2bcd8739ae039 = {
    content: {
        filename: 'Pr-NaYlkQz2MCOfNG6h-s.jpg',
        originalName: 'royhan.jpg',
        mimeType: 'image/jpeg',
        size: 15775,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/Pr-NaYlkQz2MCOfNG6h-s.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9acffd84ba7692b1214a1b',
        previousVersions: [],
        createdAt: '2026-09-04T14:04:45.774Z',
        updatedAt: '2026-09-04T14:04:45.774Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '15.41 KB',
        age: 15,
        id: '6a9acffd84ba7692b1214a1b',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9acffd84ba7692b1214a1b',
                download: '/core/files/public/6a9acffd84ba7692b1214a1b/download',
                publicDownload: '/core/files/public/6a9acffd84ba7692b1214a1b/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9acffd84ba7692b1214a1b',
                download: 'https://api.symbols.app/core/files/public/6a9acffd84ba7692b1214a1b/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9acffd84ba7692b1214a1b/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/Pr-NaYlkQz2MCOfNG6h-s.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9acffd84ba7692b1214a1b/download'
    },
    code: '',
    key: 'royhan.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("d7iKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ca7a6f156ea26f$export$2e2bcd8739ae039);
var $98ca7a6f156ea26f$export$2e2bcd8739ae039 = {
    content: {
        filename: 'dKaPZ8DZmEUNKO5ngG1CP.jpg',
        originalName: 'luka-beria.jpg',
        mimeType: 'image/jpeg',
        size: 38096,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/dKaPZ8DZmEUNKO5ngG1CP.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b3822a27239d2a5d5f2a7',
        previousVersions: [],
        createdAt: '2026-09-04T21:29:06.039Z',
        updatedAt: '2026-09-04T21:29:06.039Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '37.2 KB',
        age: 25,
        id: '6a9b3822a27239d2a5d5f2a7',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b3822a27239d2a5d5f2a7',
                download: '/core/files/public/6a9b3822a27239d2a5d5f2a7/download',
                publicDownload: '/core/files/public/6a9b3822a27239d2a5d5f2a7/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b3822a27239d2a5d5f2a7',
                download: 'https://api.symbols.app/core/files/public/6a9b3822a27239d2a5d5f2a7/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b3822a27239d2a5d5f2a7/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/dKaPZ8DZmEUNKO5ngG1CP.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b3822a27239d2a5d5f2a7/download'
    },
    code: '',
    key: 'luka-beria.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("C3ewJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $07260ecac2f563c9$export$2e2bcd8739ae039);
var $07260ecac2f563c9$export$2e2bcd8739ae039 = {
    content: {
        filename: '7vArhUI1cRE4OCZTgQIrM.jpg',
        originalName: 'manju-kanuparthi.jpg',
        mimeType: 'image/jpeg',
        size: 44524,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/7vArhUI1cRE4OCZTgQIrM.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b38eca27239d2a5d62d52',
        previousVersions: [],
        createdAt: '2026-09-04T21:32:28.833Z',
        updatedAt: '2026-09-04T21:32:28.833Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '43.48 KB',
        age: 14,
        id: '6a9b38eca27239d2a5d62d52',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b38eca27239d2a5d62d52',
                download: '/core/files/public/6a9b38eca27239d2a5d62d52/download',
                publicDownload: '/core/files/public/6a9b38eca27239d2a5d62d52/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b38eca27239d2a5d62d52',
                download: 'https://api.symbols.app/core/files/public/6a9b38eca27239d2a5d62d52/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b38eca27239d2a5d62d52/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/7vArhUI1cRE4OCZTgQIrM.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b38eca27239d2a5d62d52/download'
    },
    code: '',
    key: 'manju-kanuparthi.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("jE7Wd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4d7e90ea4a492ae$export$2e2bcd8739ae039);
var $e4d7e90ea4a492ae$export$2e2bcd8739ae039 = {
    content: {
        filename: '2TvjVSVmKeq-u74aXi72Y.jpg',
        originalName: 'zachary-betzen.jpg',
        mimeType: 'image/jpeg',
        size: 27625,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/2TvjVSVmKeq-u74aXi72Y.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b38eaa27239d2a5d62c2f',
        previousVersions: [],
        createdAt: '2026-09-04T21:32:26.535Z',
        updatedAt: '2026-09-04T21:32:26.535Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '26.98 KB',
        age: 14,
        id: '6a9b38eaa27239d2a5d62c2f',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b38eaa27239d2a5d62c2f',
                download: '/core/files/public/6a9b38eaa27239d2a5d62c2f/download',
                publicDownload: '/core/files/public/6a9b38eaa27239d2a5d62c2f/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b38eaa27239d2a5d62c2f',
                download: 'https://api.symbols.app/core/files/public/6a9b38eaa27239d2a5d62c2f/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b38eaa27239d2a5d62c2f/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/2TvjVSVmKeq-u74aXi72Y.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b38eaa27239d2a5d62c2f/download'
    },
    code: '',
    key: 'zachary-betzen.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("gyRxo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e959c0c8e31668$export$2e2bcd8739ae039);
var $c0e959c0c8e31668$export$2e2bcd8739ae039 = {
    content: {
        filename: '335h9LzEEKkQjLGzN3sE1.jpg',
        originalName: 'imad-yaici.jpg',
        mimeType: 'image/jpeg',
        size: 3167,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/335h9LzEEKkQjLGzN3sE1.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9ad78084ba7692b12399ae',
        previousVersions: [],
        createdAt: '2026-09-04T14:36:48.294Z',
        updatedAt: '2026-09-04T14:36:48.294Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '3.09 KB',
        age: 20,
        id: '6a9ad78084ba7692b12399ae',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9ad78084ba7692b12399ae',
                download: '/core/files/public/6a9ad78084ba7692b12399ae/download',
                publicDownload: '/core/files/public/6a9ad78084ba7692b12399ae/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9ad78084ba7692b12399ae',
                download: 'https://api.symbols.app/core/files/public/6a9ad78084ba7692b12399ae/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9ad78084ba7692b12399ae/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/335h9LzEEKkQjLGzN3sE1.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9ad78084ba7692b12399ae/download'
    },
    code: '',
    key: 'imad-yaici.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("uXWXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d14e478689b977$export$2e2bcd8739ae039);
var $05d14e478689b977$export$2e2bcd8739ae039 = {
    content: {
        filename: 'EUvWL4ssryuEqZeA7E6xn.jpg',
        originalName: 'chuck-homola.jpg',
        mimeType: 'image/jpeg',
        size: 43955,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/EUvWL4ssryuEqZeA7E6xn.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b1776a27239d2a5c9805a',
        previousVersions: [],
        createdAt: '2026-09-04T19:09:42.846Z',
        updatedAt: '2026-09-04T19:09:42.846Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '42.92 KB',
        age: 31,
        id: '6a9b1776a27239d2a5c9805a',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b1776a27239d2a5c9805a',
                download: '/core/files/public/6a9b1776a27239d2a5c9805a/download',
                publicDownload: '/core/files/public/6a9b1776a27239d2a5c9805a/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b1776a27239d2a5c9805a',
                download: 'https://api.symbols.app/core/files/public/6a9b1776a27239d2a5c9805a/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b1776a27239d2a5c9805a/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/EUvWL4ssryuEqZeA7E6xn.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b1776a27239d2a5c9805a/download'
    },
    code: '',
    key: 'chuck-homola.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("i2dj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d212bc855ed59f2f$export$2e2bcd8739ae039);
var $d212bc855ed59f2f$export$2e2bcd8739ae039 = {
    content: {
        filename: '0kshN1clVI6pwWzIkteAb.jpg',
        originalName: 'ha-le.jpg',
        mimeType: 'image/jpeg',
        size: 22371,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/0kshN1clVI6pwWzIkteAb.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b384ca27239d2a5d606e3',
        previousVersions: [],
        createdAt: '2026-09-04T21:29:48.871Z',
        updatedAt: '2026-09-04T21:29:48.871Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '21.85 KB',
        age: 15,
        id: '6a9b384ca27239d2a5d606e3',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b384ca27239d2a5d606e3',
                download: '/core/files/public/6a9b384ca27239d2a5d606e3/download',
                publicDownload: '/core/files/public/6a9b384ca27239d2a5d606e3/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b384ca27239d2a5d606e3',
                download: 'https://api.symbols.app/core/files/public/6a9b384ca27239d2a5d606e3/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b384ca27239d2a5d606e3/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/0kshN1clVI6pwWzIkteAb.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b384ca27239d2a5d606e3/download'
    },
    code: '',
    key: 'ha-le.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("iKe4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5770e47f38bf92$export$2e2bcd8739ae039);
var $da5770e47f38bf92$export$2e2bcd8739ae039 = {
    content: {
        filename: 'NdwQyAowaJVB_iJzoDBvt.jpg',
        originalName: 'tao-zhang.jpg',
        mimeType: 'image/jpeg',
        size: 50857,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/NdwQyAowaJVB_iJzoDBvt.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b3857a27239d2a5d60b59',
        previousVersions: [],
        createdAt: '2026-09-04T21:29:59.205Z',
        updatedAt: '2026-09-04T21:29:59.205Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '49.67 KB',
        age: 31,
        id: '6a9b3857a27239d2a5d60b59',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b3857a27239d2a5d60b59',
                download: '/core/files/public/6a9b3857a27239d2a5d60b59/download',
                publicDownload: '/core/files/public/6a9b3857a27239d2a5d60b59/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b3857a27239d2a5d60b59',
                download: 'https://api.symbols.app/core/files/public/6a9b3857a27239d2a5d60b59/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b3857a27239d2a5d60b59/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/NdwQyAowaJVB_iJzoDBvt.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b3857a27239d2a5d60b59/download'
    },
    code: '',
    key: 'tao-zhang.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("bAU8N", function(module, exports) {

$parcel$export(module.exports, "default", () => $870e9ae40152a596$export$2e2bcd8739ae039);
var $870e9ae40152a596$export$2e2bcd8739ae039 = {
    content: {
        filename: '-4_zUZw878-pSJv7nwu4j.jpg',
        originalName: 'thomas-gazaniga.jpg',
        mimeType: 'image/jpeg',
        size: 39874,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/-4_zUZw878-pSJv7nwu4j.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b385da27239d2a5d60e63',
        previousVersions: [],
        createdAt: '2026-09-04T21:30:05.697Z',
        updatedAt: '2026-09-04T21:30:05.697Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '38.94 KB',
        age: 16,
        id: '6a9b385da27239d2a5d60e63',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b385da27239d2a5d60e63',
                download: '/core/files/public/6a9b385da27239d2a5d60e63/download',
                publicDownload: '/core/files/public/6a9b385da27239d2a5d60e63/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b385da27239d2a5d60e63',
                download: 'https://api.symbols.app/core/files/public/6a9b385da27239d2a5d60e63/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b385da27239d2a5d60e63/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/-4_zUZw878-pSJv7nwu4j.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b385da27239d2a5d60e63/download'
    },
    code: '',
    key: 'thomas-gazaniga.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("hWdLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f287feebf277b6$export$2e2bcd8739ae039);
var $d0f287feebf277b6$export$2e2bcd8739ae039 = {
    content: {
        filename: 'X5E-BWPpFeN3lOTSPQxhx.jpg',
        originalName: 'zajim-kujovic.jpg',
        mimeType: 'image/jpeg',
        size: 21505,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/X5E-BWPpFeN3lOTSPQxhx.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b3862a27239d2a5d610ba',
        previousVersions: [],
        createdAt: '2026-09-04T21:30:10.543Z',
        updatedAt: '2026-09-04T21:30:10.543Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '21 KB',
        age: 13,
        id: '6a9b3862a27239d2a5d610ba',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b3862a27239d2a5d610ba',
                download: '/core/files/public/6a9b3862a27239d2a5d610ba/download',
                publicDownload: '/core/files/public/6a9b3862a27239d2a5d610ba/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b3862a27239d2a5d610ba',
                download: 'https://api.symbols.app/core/files/public/6a9b3862a27239d2a5d610ba/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b3862a27239d2a5d610ba/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/X5E-BWPpFeN3lOTSPQxhx.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b3862a27239d2a5d610ba/download'
    },
    code: '',
    key: 'zajim-kujovic.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("3YR9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6033e5d21ee905$export$2e2bcd8739ae039);
var $2e6033e5d21ee905$export$2e2bcd8739ae039 = {
    content: {
        filename: '2VNaKpBhU8CKktvEhSFFi.jpg',
        originalName: 'marina-layus.jpg',
        mimeType: 'image/jpeg',
        size: 38617,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/2VNaKpBhU8CKktvEhSFFi.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b3869a27239d2a5d6156e',
        previousVersions: [],
        createdAt: '2026-09-04T21:30:17.243Z',
        updatedAt: '2026-09-04T21:30:17.243Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '37.71 KB',
        age: 16,
        id: '6a9b3869a27239d2a5d6156e',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b3869a27239d2a5d6156e',
                download: '/core/files/public/6a9b3869a27239d2a5d6156e/download',
                publicDownload: '/core/files/public/6a9b3869a27239d2a5d6156e/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b3869a27239d2a5d6156e',
                download: 'https://api.symbols.app/core/files/public/6a9b3869a27239d2a5d6156e/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b3869a27239d2a5d6156e/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/2VNaKpBhU8CKktvEhSFFi.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b3869a27239d2a5d6156e/download'
    },
    code: '',
    key: 'marina-layus.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("bPHf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d5ffe60f996be7$export$2e2bcd8739ae039);
var $89d5ffe60f996be7$export$2e2bcd8739ae039 = {
    content: {
        filename: 'fLwLdpWGvLHoqem5VsBIg.jpg',
        originalName: 'allen-johnson.jpg',
        mimeType: 'image/jpeg',
        size: 59643,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/fLwLdpWGvLHoqem5VsBIg.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b38e3a27239d2a5d6298b',
        previousVersions: [],
        createdAt: '2026-09-04T21:32:19.940Z',
        updatedAt: '2026-09-04T21:32:19.940Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '58.25 KB',
        age: 15,
        id: '6a9b38e3a27239d2a5d6298b',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b38e3a27239d2a5d6298b',
                download: '/core/files/public/6a9b38e3a27239d2a5d6298b/download',
                publicDownload: '/core/files/public/6a9b38e3a27239d2a5d6298b/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b38e3a27239d2a5d6298b',
                download: 'https://api.symbols.app/core/files/public/6a9b38e3a27239d2a5d6298b/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b38e3a27239d2a5d6298b/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/fLwLdpWGvLHoqem5VsBIg.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b38e3a27239d2a5d6298b/download'
    },
    code: '',
    key: 'allen-johnson.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("bH0MG", function(module, exports) {

$parcel$export(module.exports, "default", () => $8834519b50b89c5c$export$2e2bcd8739ae039);
var $8834519b50b89c5c$export$2e2bcd8739ae039 = {
    content: {
        filename: 'NPzuOUj9Wui7kHwKmd3UP.jpg',
        originalName: 'adam-frankl.jpg',
        mimeType: 'image/jpeg',
        size: 33917,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/NPzuOUj9Wui7kHwKmd3UP.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b38e6a27239d2a5d62a48',
        previousVersions: [],
        createdAt: '2026-09-04T21:32:22.357Z',
        updatedAt: '2026-09-04T21:32:22.357Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '33.12 KB',
        age: 16,
        id: '6a9b38e6a27239d2a5d62a48',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b38e6a27239d2a5d62a48',
                download: '/core/files/public/6a9b38e6a27239d2a5d62a48/download',
                publicDownload: '/core/files/public/6a9b38e6a27239d2a5d62a48/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b38e6a27239d2a5d62a48',
                download: 'https://api.symbols.app/core/files/public/6a9b38e6a27239d2a5d62a48/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b38e6a27239d2a5d62a48/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/NPzuOUj9Wui7kHwKmd3UP.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b38e6a27239d2a5d62a48/download'
    },
    code: '',
    key: 'adam-frankl.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("fDjlw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b619814084691404$export$2e2bcd8739ae039);
var $b619814084691404$export$2e2bcd8739ae039 = {
    content: {
        filename: 'gMjcmjddkzABMfxPIHjYG.jpg',
        originalName: 'lars-vestergaard.jpg',
        mimeType: 'image/jpeg',
        size: 31257,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/gMjcmjddkzABMfxPIHjYG.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9b38e8a27239d2a5d62b05',
        previousVersions: [],
        createdAt: '2026-09-04T21:32:24.475Z',
        updatedAt: '2026-09-04T21:32:24.475Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '30.52 KB',
        age: 16,
        id: '6a9b38e8a27239d2a5d62b05',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9b38e8a27239d2a5d62b05',
                download: '/core/files/public/6a9b38e8a27239d2a5d62b05/download',
                publicDownload: '/core/files/public/6a9b38e8a27239d2a5d62b05/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9b38e8a27239d2a5d62b05',
                download: 'https://api.symbols.app/core/files/public/6a9b38e8a27239d2a5d62b05/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9b38e8a27239d2a5d62b05/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/gMjcmjddkzABMfxPIHjYG.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9b38e8a27239d2a5d62b05/download'
    },
    code: '',
    key: 'lars-vestergaard.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("hAHMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce7c29f8db0679f$export$2e2bcd8739ae039);
var $cce7c29f8db0679f$export$2e2bcd8739ae039 = {
    content: {
        filename: 'gak5NsUmyGGCbroiJXLg0.jpg',
        originalName: 'nika-tomadze.jpg',
        mimeType: 'image/jpeg',
        size: 31344,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/gak5NsUmyGGCbroiJXLg0.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9cc43199101e69014b25c5',
        previousVersions: [],
        createdAt: '2026-09-06T01:38:57.614Z',
        updatedAt: '2026-09-06T01:38:57.614Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '30.61 KB',
        age: 373,
        id: '6a9cc43199101e69014b25c5',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9cc43199101e69014b25c5',
                download: '/core/files/public/6a9cc43199101e69014b25c5/download',
                publicDownload: '/core/files/public/6a9cc43199101e69014b25c5/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9cc43199101e69014b25c5',
                download: 'https://api.symbols.app/core/files/public/6a9cc43199101e69014b25c5/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9cc43199101e69014b25c5/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/gak5NsUmyGGCbroiJXLg0.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9cc43199101e69014b25c5/download'
    },
    code: '',
    key: 'nika-tomadze.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("2f8n0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a23799ff66cdcfe$export$2e2bcd8739ae039);
var $1a23799ff66cdcfe$export$2e2bcd8739ae039 = {
    content: {
        filename: 'OSlzJxw--x322tb-67aBm.jpg',
        originalName: 'tornike-machavariani.jpg',
        mimeType: 'image/jpeg',
        size: 85832,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/OSlzJxw--x322tb-67aBm.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9cc43899101e69014b276f',
        previousVersions: [],
        createdAt: '2026-09-06T01:39:04.842Z',
        updatedAt: '2026-09-06T01:39:04.842Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '83.82 KB',
        age: 16,
        id: '6a9cc43899101e69014b276f',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9cc43899101e69014b276f',
                download: '/core/files/public/6a9cc43899101e69014b276f/download',
                publicDownload: '/core/files/public/6a9cc43899101e69014b276f/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9cc43899101e69014b276f',
                download: 'https://api.symbols.app/core/files/public/6a9cc43899101e69014b276f/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9cc43899101e69014b276f/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/OSlzJxw--x322tb-67aBm.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9cc43899101e69014b276f/download'
    },
    code: '',
    key: 'tornike-machavariani.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("gs73w", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfa4bbfd4001f18a$export$2e2bcd8739ae039);
var $bfa4bbfd4001f18a$export$2e2bcd8739ae039 = {
    content: {
        filename: 'E1696bt-u-e_4_B4ZFRQM.jpg',
        originalName: 'joshua-mcmillan.jpg',
        mimeType: 'image/jpeg',
        size: 46693,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/E1696bt-u-e_4_B4ZFRQM.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9cc43a99101e69014b2822',
        previousVersions: [],
        createdAt: '2026-09-06T01:39:06.410Z',
        updatedAt: '2026-09-06T01:39:06.410Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '45.6 KB',
        age: 15,
        id: '6a9cc43a99101e69014b2822',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9cc43a99101e69014b2822',
                download: '/core/files/public/6a9cc43a99101e69014b2822/download',
                publicDownload: '/core/files/public/6a9cc43a99101e69014b2822/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9cc43a99101e69014b2822',
                download: 'https://api.symbols.app/core/files/public/6a9cc43a99101e69014b2822/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9cc43a99101e69014b2822/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/E1696bt-u-e_4_B4ZFRQM.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9cc43a99101e69014b2822/download'
    },
    code: '',
    key: 'joshua-mcmillan.jpg',
    type: 'files',
    format: 'jpg'
};

});

parcelRegister("kZHHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $03f1bb7c890850eb$export$2e2bcd8739ae039);
var $03f1bb7c890850eb$export$2e2bcd8739ae039 = {
    content: {
        filename: '7zABMdHWaMx_e1EjNgM_U.jpg',
        originalName: 'tamar-chkhaidze.jpg',
        mimeType: 'image/jpeg',
        size: 93665,
        storageUrl: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/7zABMdHWaMx_e1EjNgM_U.jpg',
        bucket: 'smbls-api-media',
        category: 'image',
        tags: [
            'brand-avatar'
        ],
        uploadedBy: '6868484c0cf470c5890933cc',
        project: '688e2195d3646fd6ae415464',
        visibility: 'public',
        status: 'active',
        version: 1,
        downloadCount: 0,
        _id: '6a9d5e396014f831eb776eee',
        previousVersions: [],
        createdAt: '2026-09-06T12:36:09.563Z',
        updatedAt: '2026-09-06T12:36:09.563Z',
        __v: 0,
        extension: 'jpg',
        humanSize: '91.47 KB',
        age: 100,
        id: '6a9d5e396014f831eb776eee',
        urls: {
            api: {
                base: '/core/files',
                file: '/core/files/6a9d5e396014f831eb776eee',
                download: '/core/files/public/6a9d5e396014f831eb776eee/download',
                publicDownload: '/core/files/public/6a9d5e396014f831eb776eee/download'
            },
            absolute: {
                base: 'https://api.symbols.app/core/files',
                file: 'https://api.symbols.app/core/files/6a9d5e396014f831eb776eee',
                download: 'https://api.symbols.app/core/files/public/6a9d5e396014f831eb776eee/download',
                publicDownload: 'https://api.symbols.app/core/files/public/6a9d5e396014f831eb776eee/download'
            },
            storage: 'https://storage.googleapis.com/smbls-api-media/media/projects/688e2195d3646fd6ae415464/users/6868484c0cf470c5890933cc/7zABMdHWaMx_e1EjNgM_U.jpg'
        },
        src: 'https://api.symbols.app/core/files/public/6a9d5e396014f831eb776eee/download'
    },
    code: '',
    key: 'tamar-chkhaidze.jpg',
    type: 'files',
    format: 'jpg'
};

});


parcelRegister("dWVc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27d0ea972631b51$export$2e2bcd8739ae039);
var $a27d0ea972631b51$export$2e2bcd8739ae039 = [];

});

parcelRegister("liEjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f81a8c0f17b867c6$export$2e2bcd8739ae039);
var $f81a8c0f17b867c6$export$2e2bcd8739ae039 = {
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false,
    globalTheme: 'dark',
    polyglot: {
        defaultLang: 'en',
        translations: {
            en: {
                brandTitleGradients: "Gradients \xb7 Symbols brand",
                brandTitleIcons: "Icons \xb7 Symbols brand",
                brandTitleSurfaces: "Surfaces & themes \xb7 Symbols brand",
                brandTitleElevation: "Elevation \xb7 Symbols brand",
                brandTitleTypography: "Typography \xb7 Symbols brand",
                brandTitleHome: 'Symbols brand',
                brandTitleColor: "Color \xb7 Symbols brand",
                brandTitleSpace: "Space & sizes \xb7 Symbols brand",
                brandTitleComponents: "Components \xb7 Symbols brand",
                brandTitleAccessibility: "Accessibility \xb7 Symbols brand",
                brandTitleReserved: "Reserved namespaces \xb7 Symbols brand",
                brandTitleBreakpoints: "Breakpoints \xb7 Symbols brand",
                brandTitleMotion: "Motion \xb7 Symbols brand",
                brandTitleLocalisation: "Localisation \xb7 Symbols brand",
                brandTitleLanguage: "Ten laws \xb7 Symbols brand",
                brandNavigationLabel: 'Choose a brand page',
                brandSearchLabel: 'Search brand pages, tokens and components',
                brandSearchPlaceholder: "Search the brand\u2026",
                brandSearchEmpty: 'No matching pages, tokens or components.',
                brandThemeLabel: 'Switch theme',
                brandFilterLabel: 'Filter components by name',
                brandFilterPlaceholder: 'Filter by name',
                brandPasswordLabel: 'Password',
                brandPasswordPlaceholder: 'Enter password',
                brandPasswordShow: 'Show password',
                brandPasswordHide: 'Hide password',
                brandFilterEmpty: 'No components match this name. Try a different search.',
                brandNavOverview: 'Overview',
                brandNavColor: 'Color',
                brandNavGradients: 'Gradients',
                brandNavSurfaces: 'Surfaces',
                brandNavTypography: 'Typography',
                brandNavSpace: 'Space & sizes',
                brandNavElevation: 'Elevation',
                brandNavMotion: 'Motion',
                brandNavBreakpoints: 'Breakpoints',
                brandNavIcons: 'Icons',
                brandNavAccessibility: 'Accessibility',
                brandNavLocalisation: 'Localisation',
                brandNavLanguage: 'The language',
                brandNavReserved: 'Reserved',
                brandNavComponents: 'Components'
            }
        }
    }
};

});

parcelRegister("e0YVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a340542de141a2d5$export$2e2bcd8739ae039);
var $a340542de141a2d5$export$2e2bcd8739ae039 = {};

});


parcelRegister("eTfcB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad71fe9f55b29c51$export$2e2bcd8739ae039);
// @symbo-ls/workspace-monaco — sharedLibrary context.
//
// Workspace surfaces that need the Monaco-backed code editor (canvas, the
// workspace shell, anywhere CodePreviewWidget is referenced by bare key)
// import this from their `sharedLibraries.js`. Surfaces that DON'T need
// monaco (analytics, design-system, marketplace, preview, the chrome-connect
// panel) stay free of the heavy editor + worker bundles.
//
// CodePreviewWidget lives here (rather than in @symbo-ls/workspace-shared)
// so workspace-shared doesn't drag monaco into every consumer's bundle —
// the widget's `await import('@symbo-ls/workspace-monaco')` only fires when
// the component actually renders.

var $1webl = parcelRequire("1webl");
var $ad71fe9f55b29c51$export$2e2bcd8739ae039 = {
    components: $1webl
};

});
parcelRegister("1webl", function(module, exports) {

var $2LFeA = parcelRequire("2LFeA");
$parcel$exportWildcard(module.exports, $2LFeA);

});
parcelRegister("2LFeA", function(module, exports) {

$parcel$export(module.exports, "CodePreviewWidget", () => $203ff4d2c70bfe73$export$20ad329bbe9c5d2c);


const $203ff4d2c70bfe73$var$Monaco = {
    flex: 1,
    position: 'relative',
    foldLevel: 2,
    opacity: 1,
    height: '100%',
    width: '100%',
    beautify: true,
    debounceDuration: 350,
    data: {},
    fileTab: {
        code: 'export default {}',
        type: 'javascript',
        filename: 'app.js',
        fileTabKey: 'unique-key'
    },
    onCodeEditCallback: (editor, _2, el)=>{
        el.log(editor.getValue());
    },
    onRender: async (el, s)=>{
        // No bare await: a rejected monaco chunk / worker load (the async bundle is
        // ~10MB + a 12MB ts.worker) used to die as an unhandled rejection with the
        // editor never created — surfaced as a permanently blank panel.
        try {
            const { StandaloneMonaco: StandaloneMonaco } = await (parcelRequire("9gaVX"));
            await StandaloneMonaco.onRender(el, s);
        } catch (err) {
            console.warn('[monaco] editor mount failed (self-heals on next update):', err);
        }
    },
    onBeforeUpdate: async (_, el, s, ctx, opts)=>{
        try {
            const { StandaloneMonaco: StandaloneMonaco } = await (parcelRequire("9gaVX"));
            // Self-heal: if the mount-time create failed (rejected monaco chunk,
            // worker error, or a throw while the panel was still display:none at
            // page load), `data.monacoInstance` never exists and StandaloneMonaco's
            // onBeforeUpdate silently DROPS every update (its `!data.monacoInstance`
            // early-return) — the CanvasV2CodeEditor "Edit in Code" panel then opens
            // permanently blank ("opening code editor stucks", 2026-07-06 per Nika).
            // Re-run the create path now: by update time the panel is visible and
            // sized, and el.fileTab already carries the pushed code.
            if (!el.data?.monacoInstance && !el.__monacoRetrying) {
                el.__monacoRetrying = true;
                try {
                    await StandaloneMonaco.onRender(el, s);
                } finally{
                    el.__monacoRetrying = false;
                }
            }
            return StandaloneMonaco.onBeforeUpdate(_, el, s, ctx, opts);
        } catch (err) {
            console.warn('[monaco] editor update failed:', err);
            return false;
        }
    }
};
const $203ff4d2c70bfe73$export$20ad329bbe9c5d2c = {
    display: 'flex',
    flow: 'column',
    position: 'sticky',
    top: '0',
    order: 0,
    widthRange: 'H1',
    Flex_tabs: {},
    Monaco: $203ff4d2c70bfe73$var$Monaco
};

});
parcelRegister("9gaVX", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};

Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = Promise.all([
            (parcelRequire("l6CkT"))(import.meta.resolve("hP3iP")),
            $smblsAttempt ? import($smblsAddress(import.meta.resolve("8lAdj"))) : import("8lAdj")
        ]).then(()=>parcelRequire('bSJtw'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});




parcelRegister("69mEw", function(module, exports) {

$parcel$export(module.exports, "subscribeRealtime", () => (parcelRequire("42oy6")).subscribeRealtime);
$parcel$export(module.exports, "openChatFromToast", () => (parcelRequire("bgpjO")).openChatFromToast);
$parcel$export(module.exports, "chatAiViews", () => (parcelRequire("c6M7D")).chatAiViews);
// Eager slim slice of the chat function barrel (chat bundle-fold, 2026-08-01).
//
// Chat is no longer eager-merged as a whole context: MessengerOverlay mounts
// behind a `_chatCtxFolded` if-latch and the FULL chat context (components +
// functions) folds via the workspace shell's `ensureChatContext` (dynamic
// import + foldSharedLibContext) the first time any opener runs. The fold is
// add-missing, so it never double-registers what this slice already carries.
//
// ONLY the functions that non-chat surfaces reach BEFORE any fold stay here:
//   • subscribeRealtime — el.call'd by the shell root itself at boot
//     (workspace/app.js `_ensureShellRealtime`) so message/notification
//     toasts + the chime work on every route with chat never opened. Also
//     dynamic-imported by loadPrivateData's realtime wave (module-cached —
//     same instance either way).
//   • openChatFromToast — toast click actions carry
//     `{ call: 'openChatFromToast' }` (shared GlobalNotification), fired on
//     ANY route; it ensures the fold itself before opening the drawer.
//   • chatContextItems / personContextItems + their dispatches
//     (channelActions.js) — the workspace sidebar's channel-row "…" menu
//     (SidebarItemMore) builds items SYNCHRONOUSLY on right-click, pre-fold;
//     the dispatches ensure the fold before delegating to lazy actions
//     (openChannelSettings, messageUser, …).
//   • chatUtils — pure helpers the above import; also statically imported by
//     workspace loadPrivateData (people/channel priming), so it is in the
//     eager graph regardless.
// Every OTHER chat function (sendMessage, messageUser, createChannel,
// reactions, uploads, modals, search, …) registers at fold time; cross-route
// callers (aiWorkspaceOps, PersonPopover, AppSidebar, meet applySuggestion,
// pageContext deep-links) ensure the fold first.
//
// Chat's state.js ALSO rides the eager entry in sharedLibraries.js —
// `messages` + `_chatDrawerOpen` are declared ONLY there, and eager surfaces
// write `_chatDrawerOpen` on any route (v3.14 trips on undeclared root keys).

var $4CrGc = parcelRequire("4CrGc");

var $dZIUb = parcelRequire("dZIUb");

var $42oy6 = parcelRequire("42oy6");

var $bgpjO = parcelRequire("bgpjO");

var $c6M7D = parcelRequire("c6M7D");
$parcel$exportWildcard(module.exports, $4CrGc);
$parcel$exportWildcard(module.exports, $dZIUb);

});
parcelRegister("dZIUb", function(module, exports) {

$parcel$export(module.exports, "chatContextItems", () => $a303ce1e9f853743$export$822021a7c732f399);
$parcel$export(module.exports, "chatContextDispatch", () => $a303ce1e9f853743$export$9b82507bdea623ce);
$parcel$export(module.exports, "personContextItems", () => $a303ce1e9f853743$export$915e370836621cd3);
$parcel$export(module.exports, "personContextDispatch", () => $a303ce1e9f853743$export$a1e6cd5624068f69);
$parcel$export(module.exports, "ensureChatContextMenuEscClose", () => $a303ce1e9f853743$export$2e2ed334859f6cce);
$parcel$export(module.exports, "renameChannel", () => $a303ce1e9f853743$export$e46cf03ac68c3181);
$parcel$export(module.exports, "hideDM", () => $a303ce1e9f853743$export$e8e549a6e284ef96);
$parcel$export(module.exports, "leaveChannel", () => $a303ce1e9f853743$export$e6c41c8aa28ddeb9);
$parcel$export(module.exports, "deleteChannel", () => $a303ce1e9f853743$export$6fc450d2cfb14966);
$parcel$export(module.exports, "pinToTop", () => $a303ce1e9f853743$export$53a0e368e2e8a143);
$parcel$export(module.exports, "loadPinnedChannels", () => $a303ce1e9f853743$export$e38c2a0645dc844a);
$parcel$export(module.exports, "addMembersToChannel", () => $a303ce1e9f853743$export$7600fabc09f37639);
$parcel$export(module.exports, "removeMemberFromChannel", () => $a303ce1e9f853743$export$75e1d1e64eaede5c);
$parcel$export(module.exports, "inviteToChannel", () => $a303ce1e9f853743$export$fa7602817427b62d);
$parcel$export(module.exports, "openChannelSettings", () => $a303ce1e9f853743$export$25ae871ac1650689);
$parcel$export(module.exports, "startGroupChat", () => $a303ce1e9f853743$export$9fd7652ba55bf976);
$parcel$export(module.exports, "convertToChannel", () => $a303ce1e9f853743$export$da308ef2483725f2);
// Sidebar dropdown actions for channels, DMs, and group DMs.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $4CrGc = parcelRequire("4CrGc");

var $kUU0b = parcelRequire("kUU0b");
const $a303ce1e9f853743$export$822021a7c732f399 = function(root, cid) {
    if (!root || !cid) return [];
    const ch = (root.channels || []).find((c)=>c.id === cid);
    if (!ch) return [];
    const kind = ch.kind || 'channel';
    const me = root.currentUserEmail;
    const mem = (root.channelMembers || []).find((m)=>m.channel_id === cid && m.member_email === me);
    // Menu rows carry KEYS — the shared ContextDropdown item resolves
    // `s.label` through polyglot at its render site.
    const muteItem = {
        label: mem && mem.muted ? 'chat.menu.unmute' : 'chat.menu.mute',
        action: 'toggle-mute'
    };
    // Label reflects the CURRENT pinned state — root._pinnedChannels is the
    // same array Sidebar.js's PinnedGroup reads and the only thing `pinToTop`
    // below writes. Was a static 'Pin to top' regardless of state, so an
    // already-pinned channel's menu never offered 'Unpin' (the toggle itself
    // worked fine — only this label never re-read the state, INTERACT-1).
    const isPinned = (root._pinnedChannels || []).includes(cid);
    const pinItem = {
        label: isPinned ? 'chat.menu.unpin' : 'chat.menu.pinToTop',
        action: 'pin-to-top'
    };
    if (kind === 'channel') return [
        {
            label: 'chat.menu.invite',
            action: 'invite-channel'
        },
        {
            label: 'chat.menu.rename',
            action: 'rename-channel'
        },
        {
            label: 'chat.menu.settings',
            action: 'channel-settings'
        },
        pinItem,
        muteItem
    ];
    // Settings opens the same ChannelSettingsModal channels use — its
    // "Linked event / call" section (LinkedResources pills + calendar-event
    // picker) is kind-agnostic and the resourceLinks backend has no kind
    // restriction, but DMs/group DMs had NO menu entry to reach the modal, so
    // 1:1 conversations looked like they lacked linked-event/call support
    // entirely (2026-08-06 per Nika "personal (1-1) channels does not have
    // Linked event / call"). The modal itself already hides its channel-only
    // fields (name/topic/privacy/delete/add-members) for dm kinds.
    const settingsItem = {
        label: 'chat.menu.settings',
        action: 'channel-settings'
    };
    if (kind === 'group_dm') return [
        {
            label: 'chat.menu.createChannel',
            action: 'convert-to-channel'
        },
        {
            label: 'chat.menu.rename',
            action: 'rename-channel'
        },
        settingsItem,
        pinItem,
        muteItem,
        {
            label: 'chat.menu.hide',
            action: 'hide-dm'
        },
        {
            label: 'chat.menu.leave',
            action: 'leave-channel',
            color: 'red'
        }
    ];
    // 1:1 DM
    return [
        settingsItem,
        {
            label: 'chat.menu.startGroupChat',
            action: 'start-group-chat'
        },
        pinItem,
        muteItem,
        {
            label: 'chat.menu.hide',
            action: 'hide-dm'
        }
    ];
};
const $a303ce1e9f853743$export$9b82507bdea623ce = async function(action, _item) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const channelId = root.contextDropdown && root.contextDropdown.channelId;
    root.update({
        contextDropdown: null
    });
    if (!action || !channelId) return;
    // Every delegated action below (openRenameModal, openChannelSettings,
    // leaveChannel, …) rides the lazily-folded chat context (bundle-fold) —
    // this dispatch is on the eager slice precisely so it can fold first.
    const ok = await this.call('ensureChatContext');
    if (ok === false) return;
    if (action === 'rename-channel') this.call('openRenameModal', channelId);
    else if (action === 'hide-dm') this.call('hideDM', channelId);
    else if (action === 'leave-channel') this.call('leaveChannel', channelId);
    else if (action === 'pin-to-top') this.call('pinToTop', channelId);
    else if (action === 'invite-channel' || action === 'channel-settings') this.call('openChannelSettings', channelId);
    else if (action === 'start-group-chat') this.call('startGroupChat', channelId);
    else if (action === 'convert-to-channel') this.call('convertToChannel', channelId);
    else if (action === 'toggle-mute') this.call('toggleChannelMute', channelId);
};
const $a303ce1e9f853743$export$915e370836621cd3 = function(root, email) {
    if (!root || !email) return [];
    const items = [
        {
            label: 'chat.menu.message',
            action: 'message',
            icon: 'chat'
        },
        {
            label: 'chat.menu.viewProfile',
            action: 'view-profile'
        }
    ];
    // openNewBookingModal ships from a sibling change in this same wave —
    // guard on registration so the menu is correct regardless of landing
    // order between the two changes.
    if (typeof this?.context?.functions?.openNewBookingModal === 'function') items.push({
        label: 'chat.menu.scheduleMeeting',
        action: 'schedule-meeting'
    });
    return items;
};
const $a303ce1e9f853743$export$a1e6cd5624068f69 = async function(action, _item) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const email = root.contextDropdown && root.contextDropdown.personEmail;
    root.update({
        contextDropdown: null
    });
    if (!action || !email) return;
    if (action === 'message') {
        // messageUser rides the lazily-folded chat context (bundle-fold) — fold
        // first. Only this branch: view-profile / schedule-meeting are shell /
        // calendar functions and must not gate on the chat chunk.
        const ok = await this.call('ensureChatContext');
        if (ok === false) return;
        this.call('messageUser', email).catch((err)=>{
            this.call('openNotification', {
                type: 'error',
                title: this.call('polyglot', 'chat.error.openChatTitle'),
                message: err && err.message || this.call('polyglot', 'chat.error.tryAgain')
            });
        });
    } else if (action === 'view-profile') this.call('openProfileModal', email);
    else if (action === 'schedule-meeting') this.call('openNewBookingModal', {
        invitees: email
    });
};
const $a303ce1e9f853743$export$2e2ed334859f6cce = function() {
    if (typeof window === 'undefined') return;
    const ctx = this && this.context;
    const root = this && this.state && this.state.root;
    if (!ctx || !root) return;
    if (!ctx.__chatCtxDdEscRoot) ctx.__chatCtxDdEscRoot = root;
    if (window.__chatCtxDdEscBound) return;
    window.__chatCtxDdEscBound = true;
    document.addEventListener('keydown', (e)=>{
        if (e.key !== 'Escape') return;
        const r = ctx.__chatCtxDdEscRoot;
        if (r && r.contextDropdown) r.update({
            contextDropdown: null
        }, {
            preventFetch: true
        });
    });
};
const $a303ce1e9f853743$export$e46cf03ac68c3181 = async function(channelId, newName) {
    const root = this?.state?.root;
    if (!root || !channelId || !newName) return;
    const _write = (0, $kUU0b.sameWorkspaceWriter)(root);
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat update
        await (0, $1NxyO.getSDK)().execute('workspaceProject.chat', 'update', {
            id: channelId,
            payload: {
                name: newName
            }
        });
    } catch (err) {
        console.error('[renameChannel]', err);
        return;
    }
    _write({
        channels: (root.channels || []).map((c)=>c.id === channelId ? {
                ...c,
                name: newName
            } : c)
    });
};
const $a303ce1e9f853743$export$e8e549a6e284ef96 = async function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    // Optimistic: remove from local channels list
    const hiddenSet = new Set(root._hiddenChannels || []);
    hiddenSet.add(channelId);
    root.update({
        _hiddenChannels: Array.from(hiddenSet),
        activeChannelId: root.activeChannelId === channelId ? null : root.activeChannelId
    });
};
const $a303ce1e9f853743$export$e6c41c8aa28ddeb9 = async function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    const _write = (0, $kUU0b.sameWorkspaceWriter)(root);
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.members remove
        await (0, $1NxyO.getSDK)().execute('workspaceProject.chat.members', 'remove', {
            channelId: channelId,
            userId: me
        });
    } catch (err) {
        console.error('[leaveChannel]', err);
        return;
    }
    _write({
        channelMembers: (root.channelMembers || []).filter((m)=>!(m.channel_id === channelId && m.member_email === me)),
        channels: (root.channels || []).filter((c)=>c.id !== channelId),
        activeChannelId: root.activeChannelId === channelId ? null : root.activeChannelId
    });
};
const $a303ce1e9f853743$export$6fc450d2cfb14966 = async function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return false;
    const _write = (0, $kUU0b.sameWorkspaceWriter)(root);
    // `messagesByChannel` is the one scoped key chat does not write as a patch,
    // so its guard travels as the captured id — see chatUtils.setChannelMessages.
    const _issuedFor = (0, $kUU0b.wsIdOf)(root);
    try {
        // SDK route: workspaceProject.chat 'remove' → chat.removeChannel →
        // DELETE /chat/channels/:id on the workspace-project worker.
        await (0, $1NxyO.getSDK)().execute('workspaceProject.chat', 'remove', {
            id: channelId
        });
    } catch (err) {
        console.error('[deleteChannel]', err?.message || err);
        return false;
    }
    (0, $4CrGc.deleteChannelMessages)(root, channelId, _issuedFor);
    _write({
        channels: (root.channels || []).filter((c)=>c.id !== channelId),
        channelMembers: (root.channelMembers || []).filter((m)=>m.channel_id !== channelId),
        activeChannelId: root.activeChannelId === channelId ? null : root.activeChannelId,
        showChannelSettings: root.showChannelSettings === channelId ? null : root.showChannelSettings
    });
    return true;
};
// ── Pin to top — toggle pinned, persisted in localStorage ──
// Keyed PER WORKSPACE (workspace isolation — one workspace's pins must not
// bleed into another's sidebar). The legacy un-namespaced key is read once
// as a fallback so existing pins survive the migration.
const $a303ce1e9f853743$var$_LEGACY_PINNED_KEY = 'chat_pinned_channels';
const $a303ce1e9f853743$var$_pinnedKey = (root)=>{
    const ws = (0, $4CrGc.getActiveWorkspaceId)(root);
    return ws ? `${$a303ce1e9f853743$var$_LEGACY_PINNED_KEY}:${ws}` : $a303ce1e9f853743$var$_LEGACY_PINNED_KEY;
};
const $a303ce1e9f853743$var$_loadPinned = (root)=>{
    try {
        const scoped = localStorage.getItem($a303ce1e9f853743$var$_pinnedKey(root));
        if (scoped != null) return JSON.parse(scoped);
        return JSON.parse(localStorage.getItem($a303ce1e9f853743$var$_LEGACY_PINNED_KEY) || '[]');
    } catch  {
        return [];
    }
};
const $a303ce1e9f853743$var$_savePinned = (root, ids)=>{
    try {
        localStorage.setItem($a303ce1e9f853743$var$_pinnedKey(root), JSON.stringify(ids));
    } catch  {
    /* noop */ }
};
const $a303ce1e9f853743$export$53a0e368e2e8a143 = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const current = new Set($a303ce1e9f853743$var$_loadPinned(root));
    if (current.has(channelId)) current.delete(channelId);
    else current.add(channelId);
    const arr = Array.from(current);
    $a303ce1e9f853743$var$_savePinned(root, arr);
    root.update({
        _pinnedChannels: arr
    });
};
const $a303ce1e9f853743$export$e38c2a0645dc844a = function() {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _pinnedChannels: $a303ce1e9f853743$var$_loadPinned(root)
    });
};
const $a303ce1e9f853743$export$7600fabc09f37639 = async function(channelId, emailsToAdd) {
    const root = this?.state?.root;
    if (!root || !channelId || !Array.isArray(emailsToAdd) || !emailsToAdd.length) return false;
    const sdk = (0, $1NxyO.getSDK)();
    const _norm = (e)=>typeof e === 'string' ? e.toLowerCase().trim() : null;
    const mine = (root.channelMembers || []).filter((m)=>m.channel_id === channelId);
    const existingEmails = new Set(mine.map((m)=>m.member_email));
    const existingIds = new Set(mine.map((m)=>m.user_id).filter((v)=>v != null).map(String));
    const keys = emailsToAdd.map(_norm).filter(Boolean);
    const newEmails = keys.filter((k)=>!k.startsWith('uid:') && !existingEmails.has(k));
    const newIds = keys.filter((k)=>k.startsWith('uid:')).map((k)=>emailsToAdd.find((e)=>_norm(e) === k).trim().slice(4)).filter((id)=>id && !existingIds.has(id));
    if (!newEmails.length && !newIds.length) return true;
    // The person and the channel, never a role: the server decides who joins
    // as what (a new row is a member; an existing owner or admin keeps their
    // role). A client-chosen role let any member add people as admins, and a
    // re-add stamped `member` over an owner (the coordinator's 2026-10-28
    // contract with the core fix; a role picker for admins would be a separate,
    // explicit control).
    const rows = [
        ...newEmails.map((email)=>({
                channel_id: channelId,
                member_email: email
            })),
        ...newIds.map((id)=>({
                channel_id: channelId,
                user_id: id
            }))
    ];
    const _write = (0, $kUU0b.sameWorkspaceWriter)(root);
    let answered = [];
    try {
        const results = await Promise.all(rows.map((row)=>sdk.execute('workspaceProject.chat.members', 'create', {
                channelId: channelId,
                payload: row
            }).catch((err)=>{
                const msg = err?.message || '';
                if (/duplicate|already exists|conflict|409|23505/i.test(msg)) return null;
                throw err;
            })));
        answered = results.flatMap((res)=>{
            const data = res && (res.data !== undefined ? res.data : res);
            return (Array.isArray(data) ? data : [
                data
            ]).filter((r)=>r && r.member_email);
        });
    } catch (err) {
        console.error('[addMembersToChannel]', err?.message || err);
        try {
            this.call('openNotification', {
                title: this.call('polyglot', 'chat.error.addMembersTitle'),
                message: err?.message || this.call('polyglot', 'chat.error.networkMessage'),
                type: 'error'
            });
        } catch  {}
        return false;
    }
    // The server's rows first (they carry the email an id resolved to, and
    // user_id), then the email rows we sent; upsert on (channel, email) so a
    // realtime member.insert that landed first is not doubled.
    const now = new Date().toISOString();
    const incoming = [
        ...answered.map((r)=>({
                ...r,
                channel_id: r.channel_id || channelId
            })),
        ...rows.filter((r)=>r.member_email)
    ];
    const next = (root.channelMembers || []).slice();
    const key = (r)=>`${r.channel_id}|${_norm(r.member_email)}`;
    const at = new Map(next.map((r, i)=>[
            key(r),
            i
        ]));
    for (const row of incoming){
        const k = key(row);
        if (at.has(k)) next[at.get(k)] = {
            ...next[at.get(k)],
            ...row
        };
        else {
            at.set(k, next.length);
            next.push({
                ...row,
                last_read_at: now
            });
        }
    }
    _write({
        channelMembers: next
    });
    return true;
};
const $a303ce1e9f853743$export$75e1d1e64eaede5c = async function(channelId, memberEmail) {
    const root = this?.state?.root;
    if (!root || !channelId || !memberEmail) return false;
    const _write = (0, $kUU0b.sameWorkspaceWriter)(root);
    try {
        await (0, $1NxyO.getSDK)().execute('workspaceProject.chat.members', 'remove', {
            channelId: channelId,
            userId: memberEmail
        });
    } catch (err) {
        console.error('[removeMemberFromChannel]', err?.message || err);
        try {
            this.call('openNotification', {
                title: this.call('polyglot', 'chat.error.removeMemberTitle'),
                message: err?.message || this.call('polyglot', 'chat.error.networkMessage'),
                type: 'error'
            });
        } catch  {}
        return false;
    }
    _write({
        channelMembers: (root.channelMembers || []).filter((m)=>!(m.channel_id === channelId && m.member_email === memberEmail))
    });
    return true;
};
const $a303ce1e9f853743$export$fa7602817427b62d = function(channelId) {
    if (!channelId) return;
    this.call('openAddPeopleModal', channelId);
};
const $a303ce1e9f853743$export$25ae871ac1650689 = function(channelId) {
    this.call('openChannelSettingsModal', channelId);
};
const $a303ce1e9f853743$export$9fd7652ba55bf976 = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    const members = (root.channelMembers || []).filter((m)=>m.channel_id === channelId && m.member_email !== me).map((m)=>m.member_email);
    this.call('openNewChannelModal', {
        kind: 'dm',
        members: members
    });
};
const $a303ce1e9f853743$export$da308ef2483725f2 = function(channelId) {
    const root = this?.state?.root;
    if (!root || !channelId) return;
    const me = root.currentUserEmail;
    const members = (root.channelMembers || []).filter((m)=>m.channel_id === channelId && m.member_email !== me).map((m)=>m.member_email);
    this.call('openNewChannelModal', {
        kind: 'channel',
        members: members
    });
};

});

parcelRegister("42oy6", function(module, exports) {

$parcel$export(module.exports, "_chatInScope", () => $2f0a643d2a9d9fce$export$a5461400b919913e);
$parcel$export(module.exports, "_handleTyping", () => $2f0a643d2a9d9fce$export$308dce09e5b48306);
$parcel$export(module.exports, "_handleMessageDelete", () => $2f0a643d2a9d9fce$export$bc6439c9b8de3e06);
$parcel$export(module.exports, "subscribeRealtime", () => $2f0a643d2a9d9fce$export$b812432b8f92ec1e);
// Wires chat realtime to root state. Called once from pages/index.js onCreate
// (`el._chatChannel = el.call('subscribeRealtime')`); cancelled in onRemove.
//
// ── Transport: server SSE (GET /core/chat/stream) ───────────────────────────
// Chat realtime rides the server SSE stream via sdk.realtime.subscribeChatSse
// (_openChatSse) — the canonical chat transport since the 2026-06-18 flip
// (server 72d30f52 + workspace 643b2be8). The SSE re-framer reconstructs the
// Supabase-style `{ eventType, new, old, _kind? }` envelope the shared handler
// bodies (_handleMessageInsert, _handleChannels, …) consume, so the downstream
// consumers (root.messagesByChannel, root.channels, …) update the same way.
//
// The legacy Supabase postgres_changes channel (the old rollback transport +
// its presence track/sync) was RETIRED with the governance Supabase project,
// so there is no longer a transport switch — SSE is the sole path. Presence is
// a separate socket-layer follow-up (spec §4) and is NOT carried on this stream.

var $4CrGc = parcelRequire("4CrGc");

var $h7bUm = parcelRequire("h7bUm");

var $2gzyt = parcelRequire("2gzyt");

var $gy6bi = parcelRequire("gy6bi");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $kUU0b = parcelRequire("kUU0b");
const $2f0a643d2a9d9fce$export$a5461400b919913e = (root, row)=>{
    if (!row) return false;
    const activeWs = (0, $4CrGc.getActiveWorkspaceId)(root);
    if (!activeWs) return true;
    const ws = row.workspace_id;
    if (ws) return ws === activeWs;
    const chId = row.channel_id;
    if (!chId) return true;
    return (root.channels || []).some((c)=>c.id === chId);
};
// Refetch a single chat_messages row via the SDK's curated handler when the
// realtime payload arrives with masked columns. The server SSE stream masks
// per-subscriber CORRECTLY (service-role-complete rows, guard-scoped — §3), so
// these refetch/skip branches are dead on the SSE transport; they stay as
// defensive no-ops (rows always arrive complete there). See SERVER-CHAT-AUTH-1.
const $2f0a643d2a9d9fce$var$_refetchMessage = async (channelId, messageId)=>{
    try {
        const sdk = (0, $1NxyO.getSDK)();
        if (!sdk?.execute) return null;
        const res = await sdk.execute('workspaceProject.chat.messages', 'list', {
            channelId: channelId,
            limit: 1,
            params: {
                id: messageId
            }
        });
        const rows = res?.data || res;
        const row = Array.isArray(rows) ? rows.find((r)=>String(r.id) === String(messageId)) || rows[0] : rows;
        return row && typeof row === 'object' && row.body !== undefined ? row : null;
    } catch (_) {
        return null;
    }
};
// ── Shared handler bodies (transport-agnostic) ──────────────────────────────
// Each takes the live `root` + a Supabase-style payload `{ eventType, new, old }`
// (the SSE re-framer reconstructs the SAME shape, spec §5.2) and mutates root
// state. `me` is the current user email.
// Toast + chime for an incoming message — mirrors the mention-notification
// mute gate (isChannelMuted, kept consistent with _handleMentionInsert below)
// and skips the viewer's own echo. Also skipped when the conversation is
// ALREADY visible (active channel + the messenger/chat surface actually in
// view + the tab focused) — the message bubble appearing in place is
// feedback enough; a toast on top of it would be redundant chrome.
// `el` is the element `subscribeRealtime` was called on (threaded through
// `dispatch` below) — in practice the shell root, since app.js's onCreate
// opens this subscription before any /chat visit, so el.call resolves
// against the always-mounted shell context regardless of what page the
// viewer is currently on.
const $2f0a643d2a9d9fce$var$_notifyNewMessage = (root, msg, el)=>{
    if (!el || typeof el.call !== 'function') return;
    if (!msg?.channelId) return;
    if (msg.authorEmail && msg.authorEmail === root.currentUserEmail) return;
    if ((0, $2gzyt.isChannelMuted)(root, msg.channelId)) return;
    if ((0, $4CrGc.isChatChannelInView)(root, msg.channelId)) return;
    const channel = (root.channels || []).find((c)=>c.id === msg.channelId);
    // chatFindPerson also resolves a peer a non-manager's /people rows list
    // without email (through the chat member rows' user_id).
    const person = msg.authorEmail ? el.call('chatFindPerson', root, msg.authorEmail) : null;
    const senderName = person?.name || (msg.authorEmail || '').split('@')[0] || 'Someone';
    const channelSuffix = channel && channel.kind === 'channel' && channel.name ? ` \xb7 #${channel.name}` : '';
    // The composer stores typed `*_~`[]` as `\*` etc. (htmlToMarkdown) — show
    // them as typed, not as backslashes.
    const snippet = (msg.body || '').replace(/\\([*_~`[\]\\])/g, '$1').replace(/\s+/g, ' ').trim().slice(0, 90);
    try {
        // A message that carries only a file has no text: its line is the chat
        // word for an attachment (the fallback functions/chatAnswer.js uses), never
        // the file name and never an empty line (CL-CHAT-GAPS item 5).
        const hasFile = Array.isArray(msg.attachments) && msg.attachments.length > 0;
        const line = snippet || (hasFile ? String(el.call('polyglot', 'chat.answer.attachment') || '') : '');
        el.call('openNotification', {
            title: senderName + channelSuffix,
            message: line,
            icon: 'chat',
            sound: true,
            action: {
                call: 'openChatFromToast',
                args: [
                    msg.channelId
                ]
            }
        });
    } catch (err) {
        console.warn('[chat-rt] message toast failed:', err?.message || err);
    }
};
// Broadcast mentions (@all/@everyone) never produce a chat_mentions DB row —
// the server-side chat_extract_mentions trigger only matches @handles against
// real member emails (sendMessage.js's notification fan-out is the
// cross-app-bell equivalent for this same case, fired once by the author's
// client). This is the in-chat counterpart: EVERY member's own connected
// client evaluates every incoming message for itself and, if broadcast +
// not-the-author + still-a-member, synthesizes a myMentions row — so the
// sidebar MentionBadge, the "@ Mentions" jump action, and markMentionsRead
// all key off it exactly like a real per-user mention (mute-independent,
// mirroring _handleMentionInsert's own myMentions push above). Doesn't
// survive a reload — no DB row backs it, and the initial
// workspaceProject.chat.mentions bulk fetch can't see it either — only
// live/connected recipients get it.
const $2f0a643d2a9d9fce$var$_handleBroadcastMention = (root, msg)=>{
    const me = root.currentUserEmail;
    if (!msg || !msg.channelId || !msg.id || !me) return;
    if (msg.authorEmail === me) return;
    if (!(0, $4CrGc.isBroadcastMention)(msg.body)) return;
    const isMember = (root.channelMembers || []).some((r)=>r.channel_id === msg.channelId && r.member_email === me);
    if (!isMember) return;
    const cur = root.myMentions || [];
    const syntheticId = `bcast:${msg.id}`;
    if (cur.some((x)=>x.id === syntheticId)) return;
    root.update({
        myMentions: [
            ...cur,
            {
                id: syntheticId,
                channel_id: msg.channelId,
                message_id: msg.id,
                mentioned_email: me,
                read_at: null,
                _broadcast: true
            }
        ]
    });
};
const $2f0a643d2a9d9fce$var$_handleMessageInsert = async (root, payload, el)=>{
    const _issuedFor = (0, $kUU0b.wsIdOf)(root);
    let msg = (0, $4CrGc.rowToMessage)(payload.new);
    const list = root.messagesByChannel[msg.channelId] || [];
    // Skip if we already have it (optimistic id was reconciled in sendMessage).
    if (list.some((m)=>m.id === msg.id)) return;
    // Masked realtime payload: row arrives with `body` undefined. The curated
    // handler is service-role and returns the body. Refetch before rendering so
    // we don't show an empty bubble. (Dead on SSE — rows always arrive complete
    // there.) See SERVER-CHAT-AUTH-1.
    if (msg.body === undefined && msg.channelId && msg.id) {
        const full = await $2f0a643d2a9d9fce$var$_refetchMessage(msg.channelId, msg.id);
        if (full) msg = (0, $4CrGc.rowToMessage)(full);
        // If refetch still failed (genuinely no access), drop the event rather than
        // render an empty bubble.
        if (msg.body === undefined) return;
    }
    // The whole tail is dropped, not just the message write: `myMentions` is
    // workspace-scoped too, and a toast about workspace A's channel is wrong in
    // workspace B even before it is clicked (its click writes activeChannelId).
    if ((0, $kUU0b.wsIdOf)(root) !== _issuedFor) return;
    // `_live`: this row reached the channel by realtime, not by a history read.
    // In a channel nobody has read yet it is the entry's only row, and the
    // channel's history must still be read when it opens (chatUtils
    // hasChannelHistory, functions/loadChannelMessages.js).
    (0, $4CrGc.setChannelMessages)(root, msg.channelId, [
        ...list,
        {
            ...msg,
            _live: true
        }
    ]);
    // The author's message ends their "is typing" line (CHAT-TYPING-1).
    const typing = (0, $gy6bi.chatTypingClear)(root, msg.channelId, msg.authorEmail);
    if (typing) root.update({
        _chatTypists: typing
    });
    $2f0a643d2a9d9fce$var$_handleBroadcastMention(root, msg);
    $2f0a643d2a9d9fce$var$_notifyNewMessage(root, msg, el);
};
const $2f0a643d2a9d9fce$export$308dce09e5b48306 = (root, payload)=>{
    const next = (0, $gy6bi.chatTypingApply)(root, payload && payload.new);
    if (!next) return;
    root.update({
        _chatTypists: next
    });
    setTimeout(()=>{
        const pruned = (0, $gy6bi.chatTypingPrune)(root);
        if (pruned) root.update({
            _chatTypists: pruned
        });
    }, 6100);
};
const $2f0a643d2a9d9fce$export$bc6439c9b8de3e06 = (root, payload)=>{
    const old = payload && payload.old;
    if (!root || !old || old.id == null) return;
    const id = String(old.id);
    const map = root.messagesByChannel || {};
    const chIds = old.channel_id != null ? [
        String(old.channel_id)
    ] : Object.keys(map);
    for (const chId of chIds){
        const list = map[chId];
        if (!Array.isArray(list) || !list.some((m)=>m && String(m.id) === id)) continue;
        (0, $4CrGc.setChannelMessages)(root, chId, list.filter((m)=>m && String(m.id) !== id));
    }
    if (root.activeThreadRootId != null && String(root.activeThreadRootId) === id) root.update({
        activeThreadRootId: null
    });
};
const $2f0a643d2a9d9fce$var$_handleMessageUpdate = async (root, payload)=>{
    const _issuedFor = (0, $kUU0b.wsIdOf)(root);
    let msg = (0, $4CrGc.rowToMessage)(payload.new);
    if (msg.body === undefined && msg.channelId && msg.id) {
        const full = await $2f0a643d2a9d9fce$var$_refetchMessage(msg.channelId, msg.id);
        if (full) msg = (0, $4CrGc.rowToMessage)(full);
        // Don't overwrite a present-body local copy with a body-less realtime
        // payload — keep the locally-rendered text.
        if (msg.body === undefined) return;
    }
    // A channel nobody has read has nothing to update. Mapping over `|| []`
    // wrote `[]` here, which MessageList reads as "loaded and empty" — a
    // "No messages yet" for a channel with history (and a skipped history
    // read, before loadChannelMessages re-validated `[]`).
    const current = (root.messagesByChannel || {})[msg.channelId];
    if (!Array.isArray(current)) return;
    // An updated row keeps the provenance it had (`_live`, chatUtils
    // hasChannelHistory): an edit or a reaction does not turn a streamed row
    // into history, nor history into a streamed row.
    const list = current.map((m)=>m.id === msg.id ? m._live ? {
            ...msg,
            _live: true
        } : msg : m);
    (0, $4CrGc.setChannelMessages)(root, msg.channelId, list, _issuedFor);
};
const $2f0a643d2a9d9fce$var$_handleChannels = (root, payload)=>{
    const next = (0, $4CrGc.rowToChannel)(payload.new || payload.old);
    // Masked payload — primary key blank means we can't safely operate on this
    // event. Skip rather than append `{id: undefined}` to root.channels.
    if (!next.id) return;
    // Read live state — `root.channels` from the closure may be stale.
    const current = root.channels || [];
    const exists = current.find((c)=>c.id === next.id);
    let channels = current;
    if (payload.eventType === 'DELETE') channels = current.filter((c)=>c.id !== next.id);
    else if (exists) channels = current.map((c)=>c.id === next.id ? next : c);
    else channels = [
        ...current,
        next
    ];
    // Only update if the array actually changed.
    if (channels !== current) root.update({
        channels: channels
    });
};
const $2f0a643d2a9d9fce$var$_handleMembers = (root, payload)=>{
    // Apply the delta in-place — full refetch on every membership flip (e.g.
    // every `markRead` write) was downloading the entire join table.
    const cur = root.channelMembers || [];
    const isSameRow = (a, b)=>a.channel_id === b.channel_id && a.member_email === b.member_email;
    // Masked payload — without the composite key we can't dedupe, delete, or
    // update. Skip these events; the next page-level fetch (cache: '30s' on the
    // chat page's chat.members fetch decl) will reconcile.
    const probe = payload.new || payload.old;
    if (!probe?.channel_id || !probe?.member_email) return;
    let next = cur;
    if (payload.eventType === 'INSERT') {
        if (!cur.some((r)=>isSameRow(r, payload.new))) next = [
            ...cur,
            payload.new
        ];
    } else if (payload.eventType === 'UPDATE') next = cur.map((r)=>isSameRow(r, payload.new) ? payload.new : r);
    else if (payload.eventType === 'DELETE') next = cur.filter((r)=>!isSameRow(r, payload.old));
    if (next !== cur) root.update({
        channelMembers: next
    });
};
// `el` is threaded in for the same reason _handleMessageInsert takes it: the
// notification title is a polyglot key that only an element can resolve.
const $2f0a643d2a9d9fce$var$_handleMentionInsert = (root, payload, me, el)=>{
    const row = payload.new;
    if (!row || row.mentioned_email !== me) return;
    const cur = root.myMentions || [];
    if (cur.some((x)=>x.id === row.id)) return;
    root.update({
        myMentions: [
            ...cur,
            row
        ]
    });
    // Skip notification if the viewer muted this conversation.
    if ((0, $2gzyt.isChannelMuted)(root, row.channel_id)) return;
    // Create a notification for the mention
    const msg = (root.messagesByChannel || {})[row.channel_id]?.find((m)=>m.id === row.message_id);
    const senderName = msg?.authorName || msg?.author_email || 'Someone';
    const channelName = (root.channels || []).find((c)=>c.id === row.channel_id)?.name || 'a channel';
    (0, $h7bUm.createNotification).call({
        state: {
            root: root
        }
    }, {
        userEmail: me,
        type: 'mention',
        title: el.call('polyglot', 'chat.notify.mentionedYou').replace('{sender}', senderName).replace('{channel}', channelName),
        body: msg?.body?.substring(0, 100) || '',
        // Query form (not hash) — shared/functions/openInSlot.js's route-
        // support check only ever splits a href on '?', so a hash deep link
        // can never resolve to a PageSlot def and always falls back to a full
        // page nav (the exact "mention notifications don't open in the slot"
        // bug this producer was hitting). pages/index.js's auto-pick timer
        // still reads a legacy '#channel=' hash as a back-compat fallback.
        href: `/chat?channel=${row.channel_id}`,
        // CHAT-NOTIFY-1 (tickets/opus.md) — carry the SAME `payload.kind` +
        // `payload.messageId` shape the server's durable notifier writes
        // (workers/workspace-project/src/chatMessageNotify.js), so this
        // client-only, online-only write and the server's fire-and-forget
        // write for the SAME message collide on Notification's partial
        // unique index (core/models/Notification.js) instead of producing two
        // bell rows for one mention — mirrors the credit-threshold client/
        // server dedupe pattern exactly (creditGuard.js ↔
        // creditThresholdNotifier.js).
        metadata: {
            kind: 'chat_message',
            messageId: row.message_id != null ? String(row.message_id) : null,
            channelId: row.channel_id,
            workspaceId: root.workspace?.id || null
        }
    });
};
// Reconcile sidebar-critical state from a `chat.snapshot` (connect/reconnect).
// The server sends service-role-complete rows; merge channels + members so a
// reconnect after a missed-event gap heals without waiting for the page fetch.
// Messages are NOT snapshotted (the page's fetch decls own bulk hydration).
const $2f0a643d2a9d9fce$var$_handleSnapshot = (root, snap)=>{
    if (!snap || typeof snap !== 'object') return;
    // The server snapshot has the same workspace ∪ membership reach as the
    // bulk REST lists — scope every slice to the active workspace before it
    // touches state (workspace isolation contract, see chatUtils).
    const activeWs = (0, $4CrGc.getActiveWorkspaceId)(root);
    if (Array.isArray(snap.channels) && snap.channels.length) {
        const cur = root.channels || [];
        const byId = new Map(cur.map((c)=>[
                c.id,
                c
            ]));
        for (const r of snap.channels){
            const ch = (0, $4CrGc.rowToChannel)(r);
            if (!ch.id) continue;
            if (activeWs && ch.workspaceId && ch.workspaceId !== activeWs) continue;
            byId.set(ch.id, ch);
        }
        root.update({
            channels: [
                ...byId.values()
            ]
        });
    }
    if (Array.isArray(snap.members)) root.update({
        channelMembers: (0, $4CrGc.scopeMembersToActiveWorkspace)(snap.members, root)
    });
    if (Array.isArray(snap.mentionsUnread)) root.update({
        myMentions: snap.mentionsUnread.filter((r)=>$2f0a643d2a9d9fce$export$a5461400b919913e(root, r))
    });
};
// ── Server-SSE transport ────────────────────────────────────────────────────
// Delegates to the SDK's `realtime.subscribeChatSse`, which owns the
// EventSource client + the SSE→(kind, payload) re-framing into the
// `{ eventType, new, old, _kind? }` envelope the shared handler bodies consume.
//
// getService('workspaceProject') is synchronous once the SDK is initialized,
// but the SDK may not be ready at the instant a subscription is requested.
// Resolve defensively and return a deferred unsub (the same pattern
// subscribeMeetRealtime.js uses) so a not-yet-ready SDK doesn't throw.
//
// `deliver(kind, payload)` is the sink: the shared dispatcher. `chat.snapshot`
// is routed separately by the dispatcher.
const $2f0a643d2a9d9fce$var$_openChatSse = ({ root: root, deliver: deliver, workspaceId: workspaceId })=>{
    let resolvedUnsub = null;
    let cancelled = false;
    // RESOLVE THE SERVICE, NEVER PROBE IT SYNCHRONOUSLY. `getSDK()` hands back
    // the shell's init-await Proxy (packages/shared/functions/sdkClient.js
    // `wrapWithInitAwait`): SYNC_PASS is only {getAuthToken, isReady, getToken,
    // logout}, so every other function property becomes
    // `(...args) => initPromise.then(() => value.apply(target, args))` and
    // `getService('workspaceProject')` answers a PROMISE. A bare
    // `wp?.realtime?.subscribeChatSse` reads `undefined` on it for ever, so the
    // guard below was false on every call and NO chat stream ever opened —
    // silently, because nothing threw (measured live: 0 EventSource, while
    // `await sdk.getService('workspaceProject')` resolved to the real service
    // with subscribeChatSse a function — CHAT-RT-SSE-PROBE-READS-A-PROMISE-1).
    // The deferred unsub below is what makes the async resolve safe: the caller
    // still gets its handle synchronously.
    Promise.resolve((0, $1NxyO.getSDK)()?.getService?.('workspaceProject')).then((wp)=>{
        // Unsubscribed while the service was still resolving: never open.
        if (cancelled) return;
        const sub = wp?.realtime?.subscribeChatSse;
        if (typeof sub !== 'function') return;
        const unsub = sub.call(wp.realtime, {
            workspaceId: workspaceId || undefined
        }, deliver);
        if (cancelled) try {
            unsub?.();
        } catch (_) {}
        else resolvedUnsub = typeof unsub === 'function' ? unsub : null;
    }).catch((err)=>{
        console.warn('[chat-rt] SSE subscribe failed:', err?.message || err);
    });
    return {
        unsubscribe: ()=>{
            cancelled = true;
            if (typeof resolvedUnsub === 'function') try {
                resolvedUnsub();
            } catch (_) {}
            resolvedUnsub = null;
        }
    };
};
const $2f0a643d2a9d9fce$export$b812432b8f92ec1e = async function() {
    const root = this.state.root;
    const me = root.currentUserEmail;
    // SIGNED OUT → NO STREAM. The shell calls this at mount with no session
    // check (workspace app.js); a signed-out shell then opened GET
    // /core/chat/stream and retried it — six 401s on the white-label invite
    // landing (vault.pr, a clean profile, 2026-10-11). Skip when the boot gate
    // decided "signed out" (a stored token the server refused counts), and when
    // there is neither a user nor a token. A signed-in shell whose user has not
    // landed yet still opens it: its token is present
    // (__tests__/chatRealtimeSignedOut.test.js).
    if (this?.context?.bootSignedIn === false) return null;
    if (!me) {
        let token = null;
        try {
            token = (0, $1NxyO.getSDK)()?.getAuthToken?.() || null;
        } catch (_) {
            token = null;
        }
        if (!token) return null;
    }
    const activeWs = (0, $4CrGc.getActiveWorkspaceId)(root);
    // Guard: reuse an existing subscription ONLY while it belongs to the
    // active workspace. On drift (org/workspace switch) the old stream keeps
    // delivering the previous tenant's events — close it and open a fresh
    // one keyed to the new workspace.
    const existing = root._chatRealtimeChannel;
    if (existing) {
        if (existing._wsId === activeWs) return existing;
        try {
            existing.unsubscribe?.();
        } catch (_) {
        /* already closed */ }
        root._chatRealtimeChannel = null;
    }
    // The state dispatcher — routes a (kind, payload) to the shared handler body.
    // Every entity event is workspace-gated HERE (one choke point): the server
    // SSE stream is server-scoped, so cross-workspace events must never reach the
    // state handlers.
    const dispatch = (kind, payload)=>{
        if (kind === 'chat.snapshot') {
            $2f0a643d2a9d9fce$var$_handleSnapshot(root, payload);
            return;
        }
        if (kind === 'chat.channels') {
            const row = payload?.new || payload?.old;
            if (!$2f0a643d2a9d9fce$export$a5461400b919913e(root, row)) return;
            if (payload?._kind === 'member') $2f0a643d2a9d9fce$var$_handleMembers(root, payload);
            else $2f0a643d2a9d9fce$var$_handleChannels(root, payload);
            return;
        }
        if (kind === 'chat.mentions') {
            if (!$2f0a643d2a9d9fce$export$a5461400b919913e(root, payload?.new)) return;
            $2f0a643d2a9d9fce$var$_handleMentionInsert(root, payload, me, this);
            return;
        }
        if (kind === 'chat.typing') {
            if (!$2f0a643d2a9d9fce$export$a5461400b919913e(root, payload?.new)) return;
            $2f0a643d2a9d9fce$export$308dce09e5b48306(root, payload);
            return;
        }
        if (kind === 'chat.messages') {
            const ev = payload?.eventType || 'INSERT';
            // A DELETE frame carries only `old` ({ id, channel_id }) — scope it on
            // that, never on the null `new` (which dropped every delete).
            if (ev === 'DELETE') {
                if (!$2f0a643d2a9d9fce$export$a5461400b919913e(root, payload?.old)) return;
                $2f0a643d2a9d9fce$export$bc6439c9b8de3e06(root, payload);
                return;
            }
            if (!$2f0a643d2a9d9fce$export$a5461400b919913e(root, payload?.new)) return;
            if (ev === 'UPDATE') {
                $2f0a643d2a9d9fce$var$_handleMessageUpdate(root, payload);
                return;
            }
            // INSERT (and any non-UPDATE) append-path. `this` is subscribeRealtime's
            // own `this` (dispatch is an arrow fn, inherits it lexically) — the
            // element el.call('subscribeRealtime') was invoked on, threaded through
            // so _notifyNewMessage can el.call('openNotification', …) without a
            // second element reference.
            $2f0a643d2a9d9fce$var$_handleMessageInsert(root, payload, this);
        }
    };
    // Canonical resolution (chatUtils.getActiveWorkspaceId) — the previous
    // reads (root.activeWorkspaceId / root.workspaceId / root.activeOrganization)
    // were keys nothing ever writes, so the stream always opened unscoped.
    const workspaceId = activeWs || undefined;
    const handle = $2f0a643d2a9d9fce$var$_openChatSse({
        root: root,
        workspaceId: workspaceId,
        deliver: dispatch
    });
    // Key the handle to the workspace it was opened for — the reuse guard
    // above compares this to detect workspace drift and re-open.
    if (handle) handle._wsId = activeWs;
    root._chatRealtimeChannel = handle;
    return handle;
};

});
parcelRegister("2gzyt", function(module, exports) {

$parcel$export(module.exports, "setChannelMute", () => $1a68a7e0287071b5$export$d1702d46558e90d3);
$parcel$export(module.exports, "toggleChannelMute", () => $1a68a7e0287071b5$export$137d41cfd295832b);
$parcel$export(module.exports, "isChannelMuted", () => $1a68a7e0287071b5$export$f5b16b03df95f5f1);
// Toggle the `muted` flag on the current user's chat_channel_members row.
// Muted conversations suppress mention notifications, dim the unread badge,
// and show a bell-slash icon next to the title.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $kUU0b = parcelRequire("kUU0b");
const $1a68a7e0287071b5$export$d1702d46558e90d3 = async function(channelId, muted) {
    const root = this.state.root;
    const me = root?.currentUserEmail;
    if (!channelId || !me) return false;
    // `channelMembers` is workspace-scoped and this reconcile lands after the
    // mute round-trip — captured on the click tick so a mute issued in workspace
    // A cannot rewrite workspace B's membership rows.
    const _write = (0, $kUU0b.sameWorkspaceWriter)(root);
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.chat.members mute
        await (0, $1NxyO.getSDK)().execute('workspaceProject.chat.members', 'mute', {
            channelId: channelId,
            userId: me,
            muted: !!muted
        });
        // Optimistic state reconcile — realtime will deliver the same row.
        const cur = root.channelMembers || [];
        const next = cur.map((r)=>r.channel_id === channelId && r.member_email === me ? {
                ...r,
                muted: !!muted
            } : r);
        _write({
            channelMembers: next
        });
        return true;
    } catch (err) {
        console.error('[setChannelMute]', err);
        return false;
    }
};
const $1a68a7e0287071b5$export$137d41cfd295832b = async function(channelId) {
    const root = this.state.root;
    const me = root?.currentUserEmail;
    const cur = (root?.channelMembers || []).find((r)=>r.channel_id === channelId && r.member_email === me);
    return $1a68a7e0287071b5$export$d1702d46558e90d3.call(this, channelId, !cur?.muted);
};
const $1a68a7e0287071b5$export$f5b16b03df95f5f1 = (root, channelId)=>{
    if (!root || !channelId) return false;
    const me = root.currentUserEmail;
    const row = (root.channelMembers || []).find((r)=>r.channel_id === channelId && r.member_email === me);
    return !!row?.muted;
};

});

parcelRegister("gy6bi", function(module, exports) {

$parcel$export(module.exports, "chatTypingApply", () => $c0c49dc4b7e632c3$export$ea21b17b1f91ce80);
$parcel$export(module.exports, "chatTypingClear", () => $c0c49dc4b7e632c3$export$dbde3b7c0472c800);
$parcel$export(module.exports, "chatTypingPrune", () => $c0c49dc4b7e632c3$export$35f640c345a1c527);
$parcel$export(module.exports, "chatTypingNames", () => $c0c49dc4b7e632c3$export$cd647aba4218f921);
$parcel$export(module.exports, "chatTypingLabel", () => $c0c49dc4b7e632c3$export$86c932f6da00509a);
$parcel$export(module.exports, "chatTypingPing", () => $c0c49dc4b7e632c3$export$cb4c49eafcbbd323);
$parcel$export(module.exports, "chatTypingStop", () => $c0c49dc4b7e632c3$export$61c10b85c7c8f342);
// "Is typing" (CHAT-TYPING-1) — both halves of the hint.
//
// SEND: the composers call chatTypingPing on every input that leaves text in
// the field and chatTypingStop when the text is sent or cleared. A `start`
// goes out at most every 3 s per (channel, thread) — the server drops a repeat
// inside 2 s anyway — and a `stop` only follows a `start` this element sent.
// The server checks the caller may open the channel and stamps the identity
// from the token (POST /chat/channels/:id/typing → the `chat.typing` frame).
//
// RECEIVE: subscribeRealtime hands every `chat.typing` row to chatTypingApply,
// which returns the next root._chatTypists (NOT `chatTyping` — that root key
// is the AI assistant's "working" flag, read by its composer spinner):
//   { [channelId]: { [email]: { email, userId, thread, until } } }
// A `start` (re)arms an entry for 6 s, a `stop` drops it, and the person's
// next message in that channel drops it too (chatTypingClear, from the
// message-insert path). chatTypingPrune drops expired entries, so a lost
// `stop` (a closed tab, a dropped network) heals on its own.
//
// Each function is self-contained (frank serializes them one by one).
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $c0c49dc4b7e632c3$export$ea21b17b1f91ce80 = (root, row, now)=>{
    if (!root || !row || !row.channel_id) return null;
    const email = String(row.user_email || '').trim().toLowerCase();
    const me = String(root.currentUserEmail || '').trim().toLowerCase();
    if (!email || email === me) return null;
    const at = typeof now === 'number' ? now : Date.now();
    const all = root._chatTypists || {};
    const cid = String(row.channel_id);
    const inChannel = {
        ...all[cid] || {}
    };
    if (row.state === 'stop') {
        if (!inChannel[email]) return null;
        delete inChannel[email];
    } else inChannel[email] = {
        email: email,
        userId: row.user_id != null ? String(row.user_id) : null,
        thread: row.thread_parent_id ? String(row.thread_parent_id) : null,
        until: at + 6000
    };
    const next = {
        ...all
    };
    if (Object.keys(inChannel).length) next[cid] = inChannel;
    else delete next[cid];
    return next;
};
const $c0c49dc4b7e632c3$export$dbde3b7c0472c800 = (root, channelId, email)=>{
    const all = root && root._chatTypists || {};
    const cid = channelId != null ? String(channelId) : '';
    const key = String(email || '').trim().toLowerCase();
    if (!cid || !key || !all[cid] || !all[cid][key]) return null;
    const inChannel = {
        ...all[cid]
    };
    delete inChannel[key];
    const next = {
        ...all
    };
    if (Object.keys(inChannel).length) next[cid] = inChannel;
    else delete next[cid];
    return next;
};
const $c0c49dc4b7e632c3$export$35f640c345a1c527 = (root, now)=>{
    const all = root && root._chatTypists || {};
    const at = typeof now === 'number' ? now : Date.now();
    let changed = false;
    const next = {};
    for (const cid of Object.keys(all)){
        const inChannel = {};
        for (const key of Object.keys(all[cid] || {})){
            const entry = all[cid][key];
            if (entry && entry.until > at) inChannel[key] = entry;
            else changed = true;
        }
        if (Object.keys(inChannel).length) next[cid] = inChannel;
    }
    return changed ? next : null;
};
const $c0c49dc4b7e632c3$export$cd647aba4218f921 = function(root, channelId, thread) {
    const r = root || this && this.state && this.state.root;
    const all = r && r._chatTypists || {};
    const inChannel = channelId ? all[String(channelId)] : null;
    if (!inChannel) return [];
    const now = Date.now();
    const want = thread ? String(thread) : null;
    const names = [];
    for (const key of Object.keys(inChannel)){
        const entry = inChannel[key];
        if (!entry || entry.until <= now || (entry.thread || null) !== want) continue;
        let person = null;
        try {
            person = this && typeof this.call === 'function' ? this.call('chatFindPerson', r, key) : null;
        } catch (_) {
            person = null;
        }
        if (!person && entry.userId) person = (r.people || []).find((p)=>p && String(p.userId ?? p.user_id ?? '') === String(entry.userId)) || null;
        names.push(String(person && person.name || key.split('@')[0]));
    }
    return names.sort();
};
const $c0c49dc4b7e632c3$export$86c932f6da00509a = function(channelId, thread) {
    const names = this.call('chatTypingNames', null, channelId, thread) || [];
    if (!names.length) return '';
    if (names.length === 1) return this.call('polyglot', 'chat.typing.one').replace('{name}', names[0]);
    if (names.length === 2) return this.call('polyglot', 'chat.typing.two').replace('{a}', names[0]).replace('{b}', names[1]);
    return this.call('polyglot', 'chat.typing.many');
};
const $c0c49dc4b7e632c3$export$cb4c49eafcbbd323 = function(channelId, thread) {
    if (!channelId || !this || this.__typingOff) return;
    const now = Date.now();
    const last = this.__typingSent;
    const threadId = thread || null;
    if (last && last.channelId === channelId && last.thread === threadId && now - last.at < 3000) return;
    this.__typingSent = {
        channelId: channelId,
        thread: threadId,
        at: now
    };
    const el = this;
    Promise.resolve().then(()=>(0, $1NxyO.getSDK)().execute('workspaceProject.chat', 'typing', {
            channelId: channelId,
            state: 'start',
            threadParentId: threadId || undefined
        })).catch((err)=>{
        const msg = String(err && err.message || '');
        if (/does not support op|not found|404/i.test(msg) || err && err.status === 404) el.__typingOff = true;
    });
};
const $c0c49dc4b7e632c3$export$61c10b85c7c8f342 = function() {
    const last = this && this.__typingSent;
    if (!last) return;
    this.__typingSent = null;
    if (this.__typingOff || Date.now() - last.at > 8000) return;
    Promise.resolve().then(()=>(0, $1NxyO.getSDK)().execute('workspaceProject.chat', 'typing', {
            channelId: last.channelId,
            state: 'stop',
            threadParentId: last.thread || undefined
        })).catch(()=>{});
};

});


parcelRegister("bgpjO", function(module, exports) {

$parcel$export(module.exports, "openChatFromToast", () => $8334d40bfabb2fbf$export$45871850217c3484);
// Click action for a chat-message toast (subscribeRealtime.js's
// _notifyNewMessage: `action: { call: 'openChatFromToast', args: [channelId] }`).
// Opens the Messenger drawer straight to the channel/DM the message landed
// in. Mirrors messageUser.js and pageContext.js's 'channel' case (same
// activeChannelId/activeTab/activeThreadRootId triple) rather than
// introducing a fourth slightly-different "open a channel" implementation.

var $kUU0b = parcelRequire("kUU0b");
const $8334d40bfabb2fbf$export$45871850217c3484 = async function(channelId) {
    if (!channelId) return;
    // The toast can be clicked, the context fold awaited, and the workspace
    // switched before this resolves. `activeChannelId` / `activeThreadRootId`
    // are workspace-scoped, so selecting workspace A's channel inside workspace
    // B would point the whole chat pane at a channel B cannot read.
    const _write = (0, $kUU0b.sameWorkspaceWriter)(this.state.root);
    // Bundle-fold: the MessengerOverlay (and the rest of the chat UI) lives in
    // the lazily-folded context — fold before flipping the drawer flag so the
    // overlay's if-latch can mount it.
    const ok = await this.call('ensureChatContext');
    if (ok === false) return;
    _write({
        _chatDrawerOpen: true,
        activeChannelId: channelId,
        activeThreadRootId: null,
        activeTab: 'conversation'
    });
};

});

parcelRegister("c6M7D", function(module, exports) {

$parcel$export(module.exports, "chatAiViews", () => $8d0b5fa2959bd4fd$export$3015d11095c6a6c2);
$parcel$export(module.exports, "chatAnswerChannels", () => $8d0b5fa2959bd4fd$export$5f21bd69827997ac);
$parcel$export(module.exports, "chatChannelAnswerLoad", () => $8d0b5fa2959bd4fd$export$55052dba306fbcf2);
$parcel$export(module.exports, "chatChannelAnswerModel", () => $8d0b5fa2959bd4fd$export$8bf451ad59a4086e);
// THE TEAM CHAT IN AN AI ANSWER — the `chat-channel` view the assistant
// mounts in its thread and a Fly page places as a section (workspace
// functions/assistantAppViews.js, the `views[]` contract).
//
// chatAiViews() is the PROVIDER, read from the chat EAGER slice; the view's
// component rides the lazy chat context (`fold: 'chat'` — the shell folds it
// through ensureChatContext before a card mounts). One view, three answers,
// in the shell's list frame (workspace components/AssistantViewList.js):
//
//   channel named   that channel's (or direct message's) last messages,
//                   newest first — only the unread ones with `unread`
//   unread          the unread messages of every channel, per channel
//   neither         every channel this member has, with its unread count
//
// The unread count is the sidebar's own (chatUtils unreadCount over the
// workspace's newest messages and the member's last read), so the card and
// the sidebar badges agree. The reads are the chat page's own (channels,
// members, the workspace's newest 500 messages, and the named channel's own
// read — a quiet channel's messages are older than the workspace's newest),
// into the view's OWN state, never root.messagesByChannel. A row opens the
// channel (or the message) in Chat. Nothing here writes — reading a card does
// not mark a channel read.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $8d0b5fa2959bd4fd$export$3015d11095c6a6c2() {
    return {
        app: {
            id: 'system/chat',
            navbar: [
                {
                    label: 'shell.app.chat',
                    route: '/chat',
                    icon: 'chat'
                }
            ],
            apps: [
                {
                    icon: 'chat'
                }
            ]
        },
        fold: 'chat',
        views: [
            {
                id: 'chat-channel',
                title: 'chat.page.chat.title',
                describe: 'Team chat: the last messages of one channel or direct message, the unread messages, or every channel with its unread count.',
                component: 'ChatChannelAnswerView',
                icon: 'chat',
                hue: 'cerulean',
                size: 'l',
                params: {
                    channel: {
                        type: 'string',
                        describe: "a channel name, or a teammate's name for a direct message; empty = every channel"
                    },
                    unread: {
                        type: 'boolean',
                        describe: 'only unread messages',
                        default: false
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 50,
                        default: 12
                    }
                },
                link: {
                    route: '/chat',
                    query: {}
                },
                access: {
                    route: '/chat'
                }
            }
        ]
    };
}
function $8d0b5fa2959bd4fd$export$5f21bd69827997ac(channels, members) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const norm = (e)=>typeof e === 'string' ? e.toLowerCase().trim() : '';
    const me = norm(root.currentUserEmail);
    const rows = Array.isArray(members) ? members : [];
    const list = (Array.isArray(channels) ? channels : []).filter((c)=>c && c.id != null && !c.isArchived);
    const mine = new Map();
    for (const m of rows)if (m && norm(m.member_email) === me && m.channel_id != null) mine.set(String(m.channel_id), m);
    const activeWorkspaceId = el.call('getActiveWorkspaceId', root);
    const people = el.call('peopleByEmail', root) || {};
    // buildDMChannels reads a root; this one carries the card's own rows (as
    // copies — it names a `dm` with several others a `group_dm` in place).
    const scope = {
        currentUserEmail: root.currentUserEmail,
        people: root.people,
        channels: list.map((c)=>({
                ...c
            })),
        channelMembers: rows,
        workspace: root.workspace,
        activeWorkspaceId: root.activeWorkspaceId,
        jwtClaims: root.jwtClaims,
        org: root.org
    };
    const dms = new Map();
    for (const external of [
        false,
        true
    ])for (const c of el.call('buildDMChannels', scope, external) || [])dms.set(String(c.id), c);
    const hidden = new Set((Array.isArray(root._hiddenChannels) ? root._hiddenChannels : []).map(String));
    const out = [];
    for (const c of list){
        const id = String(c.id);
        if (hidden.has(id)) continue;
        const shown = c.kind !== 'channel' ? dms.get(id) : el.call('isChannelVisibleInRail', c, {
            isMember: mine.has(id),
            activeWorkspaceId: activeWorkspaceId
        }) && c;
        if (!shown) continue;
        const name = String(el.call('polyglot', el.call('channelDisplayName', shown, rows, people, root.currentUserEmail)));
        out.push({
            id: id,
            kind: shown.kind,
            display: shown.kind === 'channel' ? '#' + name : name,
            lastReadAt: (mine.get(id) || {}).last_read_at || null
        });
    }
    return out;
}
async function $8d0b5fa2959bd4fd$export$55052dba306fbcf2(el, params) {
    const host = el || this;
    const p = params && typeof params === 'object' ? params : {};
    const root = host && host.state && host.state.root || {};
    const sdk = host && host.sdk || host.call('getSDK');
    const empty = {
        channels: [],
        members: [],
        messages: [],
        focusId: null,
        named: false
    };
    if (!sdk || typeof sdk.execute !== 'function') return {
        data: empty,
        failed: true
    };
    const rowsOf = (res)=>Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
    let failed = false;
    const [chRes, memRes, msgRes] = await Promise.all([
        Promise.resolve().then(()=>sdk.execute('workspaceProject.chat', 'list')).catch(()=>{
            failed = true;
            return [];
        }),
        Promise.resolve().then(()=>sdk.execute('workspaceProject.chat.members', 'list')).catch(()=>[]),
        Promise.resolve().then(()=>sdk.execute('workspaceProject.chat.messages', 'list', {
                options: {
                    limit: 500,
                    order: 'created_at'
                }
            })).catch(()=>[])
    ]);
    const channels = host.call('filterChannelsToActiveWorkspace', rowsOf(chRes).map((r)=>host.call('rowToChannel', r)), host.call('getActiveWorkspaceId', root));
    const members = host.call('scopeMembersToActiveWorkspace', rowsOf(memRes), root) || [];
    const byId = new Map();
    for (const r of rowsOf(msgRes)){
        if (!r || r.id == null || !host.call('rowInActiveWorkspace', root, r)) continue;
        byId.set(String(r.id), host.call('rowToMessage', r));
    }
    const ask = String(p.channel || '').replace(/^[#@]/, '').trim().toLowerCase();
    let focusId = null;
    if (ask) {
        const list = host.call('chatAnswerChannels', channels, members);
        const words = ask.split(/\s+/).filter(Boolean);
        const bare = (c)=>c.display.replace(/^#/, '').toLowerCase();
        const hit = list.find((c)=>bare(c) === ask) || list.find((c)=>words.every((w)=>bare(c).includes(w)));
        focusId = hit ? hit.id : null;
        if (focusId) {
            const own = await Promise.resolve().then(()=>sdk.execute('workspaceProject.chat.messages', 'list', {
                    channelId: focusId
                })).catch(()=>[]);
            for (const r of rowsOf(own))if (r && r.id != null && !byId.has(String(r.id))) byId.set(String(r.id), host.call('rowToMessage', r));
        }
    }
    return {
        data: {
            channels: channels,
            members: members,
            messages: [
                ...byId.values()
            ],
            focusId: focusId,
            named: !!ask
        },
        failed: failed && !channels.length
    };
}
function $8d0b5fa2959bd4fd$export$8bf451ad59a4086e(data, params, failed) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const p = params && typeof params === 'object' ? params : {};
    const say = (key)=>String(el.call('polyglot', key));
    if (failed) return {
        groups: [],
        note: 'chat.answer.failed'
    };
    const limit = Math.max(1, Math.min(50, Math.floor(Number(p.limit)) || 12));
    const onlyUnread = p.unread === true || p.unread === 'true';
    const me = String(root.currentUserEmail || '').toLowerCase();
    const list = el.call('chatAnswerChannels', d.channels, d.members) || [];
    const byChannel = {};
    for (const m of Array.isArray(d.messages) ? d.messages : []){
        if (!m || m.channelId == null) continue;
        const k = String(m.channelId);
        (byChannel[k] = byChannel[k] || []).push(m);
    }
    for (const k of Object.keys(byChannel))byChannel[k] = el.call('sortMessagesByTime', byChannel[k]);
    const hasWords = (m)=>!m.deleted && (typeof m.body === 'string' && m.body.trim() || Array.isArray(m.attachments) && m.attachments.length);
    const isUnread = (m, c)=>{
        if (String(m.authorEmail || '').toLowerCase() === me) return false;
        const cut = c.lastReadAt ? Date.parse(c.lastReadAt) || 0 : 0;
        return (Date.parse(m.createdAt || '') || 0) > cut;
    };
    const unreadOf = (c)=>el.call('unreadCount', byChannel[c.id] || [], c.lastReadAt, root.currentUserEmail);
    const people = el.call('peopleByEmail', root) || {};
    const words = (body)=>String(body || '').replace(/```[\s\S]*?```/g, ' ').replace(/`([^`]*)`/g, '$1').replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/<[^>]+>/g, ' ').replace(/^\s{0,3}(#{1,6}|>+|[-*+]\s|\d+\.\s)\s*/gm, '').replace(/[*_~]{1,3}([^*_~]+)[*_~]{1,3}/g, '$1').replace(/\s+/g, ' ').trim();
    const when = (iso)=>{
        const ms = Date.parse(iso || '');
        if (!Number.isFinite(ms)) return '';
        const sameDay = new Date(ms).toDateString() === new Date().toDateString();
        return String(el.call('localizedDate', new Date(ms), sameDay ? {
            hour: '2-digit',
            minute: '2-digit'
        } : {
            month: 'short',
            day: 'numeric'
        }) || '');
    };
    const messageRow = (m)=>{
        const person = people[m.authorEmail] || null;
        const who = person && person.name || String(m.authorEmail || '').split('@')[0] || '';
        const text = words(m.body);
        return el.call('assistantViewRow', {
            key: 'msg-' + String(m.id).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: text.length > 220 ? text.slice(0, 219).replace(/\s+\S*$/, '') + "\u2026" : text || say('chat.answer.attachment'),
            meta: [
                who,
                when(m.createdAt)
            ].filter(Boolean).join(" \xb7 "),
            src: person && person.avatar || null,
            initials: person && person.avatar ? null : el.call('initials', who) || null,
            open: {
                call: 'openAppPage',
                arg: '/chat?channel=' + encodeURIComponent(m.channelId) + '&message=' + encodeURIComponent(m.id)
            }
        });
    };
    const unreadLabel = (c, n)=>c.display + (n ? " \xb7 " + say('chat.answer.unreadCount').replace('{count}', String(n)) : '');
    if (d.focusId) {
        const c = list.find((x)=>x.id === String(d.focusId));
        if (!c) return {
            groups: [],
            note: 'chat.answer.noChannel'
        };
        const all = (byChannel[c.id] || []).filter(hasWords);
        const timeline = onlyUnread ? all.filter((m)=>isUnread(m, c)) : all.filter((m)=>!m.threadRoot);
        const newest = timeline.slice().reverse();
        const rows = newest.slice(0, limit).map(messageRow);
        return {
            groups: rows.length ? [
                el.call('assistantViewGroup', {
                    key: 'focus',
                    label: unreadLabel(c, unreadOf(c)),
                    rows: rows
                })
            ] : [],
            note: rows.length ? '' : onlyUnread ? 'chat.answer.noUnread' : 'chat.answer.noMessages',
            more: {
                shown: rows.length,
                total: newest.length
            }
        };
    }
    if (d.named) return {
        groups: [],
        note: 'chat.answer.noChannel'
    };
    const lastAt = (c)=>{
        const msgs = byChannel[c.id] || [];
        return msgs.length ? Date.parse(msgs[msgs.length - 1].createdAt || '') || 0 : 0;
    };
    if (onlyUnread) {
        const withUnread = list.map((c)=>({
                c: c,
                msgs: (byChannel[c.id] || []).filter((m)=>hasWords(m) && isUnread(m, c))
            })).filter((x)=>x.msgs.length).sort((a, b)=>lastAt(b.c) - lastAt(a.c));
        const groups = [];
        let budget = limit;
        let shown = 0;
        let total = 0;
        for (const { c: c, msgs: msgs } of withUnread){
            total += msgs.length;
            const rows = msgs.slice().reverse().slice(0, Math.max(0, budget)).map(messageRow);
            budget -= rows.length;
            shown += rows.length;
            if (rows.length) groups.push(el.call('assistantViewGroup', {
                key: 'ch-' + c.id,
                label: unreadLabel(c, unreadOf(c)),
                rows: rows
            }));
        }
        return {
            groups: groups,
            note: groups.length ? '' : 'chat.answer.noUnread',
            more: {
                shown: shown,
                total: total
            }
        };
    }
    const ordered = list.slice().sort((a, b)=>unreadOf(b) - unreadOf(a) || lastAt(b) - lastAt(a));
    const rows = ordered.slice(0, limit).map((c)=>{
        const n = unreadOf(c);
        const last = (byChannel[c.id] || []).slice(-1)[0];
        return el.call('assistantViewRow', {
            key: 'ch-' + String(c.id).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: c.display,
            meta: n ? say('chat.answer.unreadCount').replace('{count}', String(n)) : last ? when(last.createdAt) : '',
            icon: c.kind === 'channel' ? 'chat' : 'people',
            open: {
                call: 'openAppPage',
                arg: '/chat?channel=' + encodeURIComponent(c.id)
            }
        });
    });
    return {
        groups: rows.length ? [
            el.call('assistantViewGroup', {
                key: 'channels',
                label: say('chat.sidebar.conversations'),
                rows: rows
            })
        ] : [],
        note: rows.length ? '' : 'chat.answer.noMessages',
        more: {
            shown: rows.length,
            total: ordered.length
        }
    };
}

});


parcelRegister("1uObP", function(module, exports) {

$parcel$export(module.exports, "default", () => $116f86706d5332cc$export$2e2bcd8739ae039);
// Chat-related root state.
var $116f86706d5332cc$export$2e2bcd8739ae039 = {
    channels: [],
    activeChannelId: null,
    messages: {},
    threadOpen: false,
    threadParentId: null,
    _chatDrawerOpen: false
};

});

parcelRegister("5Ox5h", function(module, exports) {
// Eager slim slice of the mail component barrel.
//
// Mail is a lazy sub-app: the `/mail` route folds the FULL mail context into
// the live shell context on first mount (workspace/pages/index.js →
// lazySharedLibPage), and the header envelope folds it through
// ensureMailContext (workspace/functions/mailFold.js) before opening the
// docked overlay. So the heavy surfaces — and above all `MailOverlay`, which
// the shell mounts post-fold into its MailOverlaySlot — ride the lazy chunk.
//
// The three page-body components stay eager because they are tiny,
// self-contained render closures (no data plane yet) and the page + the
// overlay both reference them by bare key. Each is `export *`-ed from its
// SOURCE file — never through `./index.js`: mail/package.json has no
// `sideEffects: false`, so a re-export through the barrel would NOT
// tree-shake and would drag the overlay into the eager chunk.

var $Pfazy = parcelRequire("Pfazy");

var $ZXRAQ = parcelRequire("ZXRAQ");

var $6hwA2 = parcelRequire("6hwA2");

var $gEh4o = parcelRequire("gEh4o");

var $aoBWA = parcelRequire("aoBWA");
$parcel$exportWildcard(module.exports, $Pfazy);
$parcel$exportWildcard(module.exports, $ZXRAQ);
$parcel$exportWildcard(module.exports, $6hwA2);
$parcel$exportWildcard(module.exports, $gEh4o);
$parcel$exportWildcard(module.exports, $aoBWA);

});
parcelRegister("Pfazy", function(module, exports) {

$parcel$export(module.exports, "MailFolderRow", () => $09a087e2e53a2471$export$de44a1c7330dcf01);
$parcel$export(module.exports, "MailAccountRow", () => $09a087e2e53a2471$export$9adc38d069e765ae);
$parcel$export(module.exports, "MailAccountGroup", () => $09a087e2e53a2471$export$5430c662b032550b);
$parcel$export(module.exports, "MailFolderGroup", () => $09a087e2e53a2471$export$4dbba3578ad4b805);
$parcel$export(module.exports, "MailLabelRow", () => $09a087e2e53a2471$export$54f83dcac025ad5f);
$parcel$export(module.exports, "MailLabelGroup", () => $09a087e2e53a2471$export$61677115b0b41828);
$parcel$export(module.exports, "MailSidebarBody", () => $09a087e2e53a2471$export$97d027c986ce8b1d);
$parcel$export(module.exports, "MailSidebar", () => $09a087e2e53a2471$export$723e6055ae431ab4);
// Mail sidebar — the folder rail of the /mail page (architecture/MAIL.md
// §3.1). Extends the shared AppSidebar shell so the chrome (width, glass
// card, scroll column) is identical to the chat + calendar rails, and nulls
// the same slots ChatSidebar nulls.
//
// The rail body is ONE definition (MailSidebarBody): the desktop rail, the
// phone sheet (MailMobileRail) and the docked drawer all render it, so every
// surface lists the same accounts + folders. Folder rows are STATIC keys —
// their onClick binds normally; only the DYNAMIC account/label rows (minted
// through childExtends + a children factory) ride `data-mail-*` delegation
// (pages/index.js), the v3.14 childExtends/onClick trap.

var $kFsAF = parcelRequire("kFsAF");
const $09a087e2e53a2471$export$de44a1c7330dcf01 = {
    extends: 'SidebarRow',
    MoreBtn: null,
    Icon: {
        boxSize: 'A',
        minWidth: 'A'
    }
};
// Folder rows ride the SAME `data-mail-folder` delegation as the dynamic
// label rows — one door means the page's handler also mirrors the URL and
// closes the phone rail for every row alike (a static onClick here skipped
// both, measured in the headless probe).
const $09a087e2e53a2471$var$_folderRow = (folder, iconName, labelKey)=>({
        extends: 'MailFolderRow',
        subscribeTo: [
            'mailActiveFolder'
        ],
        cursor: 'pointer',
        attr: {
            'data-mail-folder': folder,
            role: 'button',
            tabindex: '0'
        },
        background: (el, s)=>s.root && s.root.mailActiveFolder === folder ? 'hover' : 'transparent',
        Icon: {
            name: iconName
        },
        Label: {
            subscribeTo: [
                'mailActiveFolder'
            ],
            text: `{{ ${labelKey} | polyglot }}`,
            fontWeight: (el, s)=>s.root && s.root.mailActiveFolder === folder ? '700' : '500'
        },
        // The inbox row carries the unread count pill (brand hue — the chat
        // UnreadBadge idiom; 'blue' is a static token by design).
        UnreadBadge: folder === 'inbox' ? {
            subscribeTo: [
                'mailUnreadCounts',
                'mailActiveAccountId'
            ],
            hide: (el, s)=>!(0, $kFsAF.unreadForMailAccount)(s.root, s.root && s.root.mailActiveAccountId),
            tag: 'span',
            padding: 'V Z',
            round: 'radiusPill',
            fontSize: 'Y1',
            fontWeight: '700',
            background: 'blue',
            color: 'fillInk',
            marginLeft: 'auto',
            text: (el, s)=>{
                const n = (0, $kFsAF.unreadForMailAccount)(s.root, s.root && s.root.mailActiveAccountId);
                return n > 99 ? '99+' : String(n);
            }
        } : null
    });
const $09a087e2e53a2471$export$9adc38d069e765ae = {
    extends: 'MailFolderRow',
    attr: {
        'data-mail-account': (el, s)=>s && s.id || '',
        role: 'button',
        tabindex: '0'
    },
    background: (el, s)=>s.root && s.root.mailActiveAccountId === (s && s.id) ? 'hover' : 'transparent',
    Icon: {
        name: 'email'
    },
    Label: {
        text: (el, s)=>s && (s.displayName || s.address) || '',
        fontWeight: (el, s)=>s.root && s.root.mailActiveAccountId === (s && s.id) ? '700' : '500'
    },
    // Needs-attention badge (§3.1 states table): reauth_required / error rows.
    AttentionDot: {
        hide: (el, s)=>{
            const st = s && s.status || '';
            return !(st === 'reauth_required' || st === 'error');
        },
        boxSize: 'W W',
        round: 'circle',
        flexShrink: '0',
        marginLeft: 'auto',
        background: 'red',
        attr: {
            'aria-label': (el)=>el.call('polyglot', 'mail.sidebar.needsAttention')
        }
    }
};
const $09a087e2e53a2471$export$5430c662b032550b = {
    extends: 'AppSidebarGroup',
    subscribeTo: [
        'mailAccounts'
    ],
    hide: (el, s)=>((s.root && s.root.mailAccounts || []).length || 0) < 2,
    label: (el)=>el.call('polyglot', 'mail.sidebar.accounts'),
    List: {
        flow: 'y',
        gap: 'V',
        AllInboxes: {
            extends: 'MailFolderRow',
            subscribeTo: [
                'mailActiveAccountId'
            ],
            cursor: 'pointer',
            // `all` is the sentinel — the delegated handler maps it to null.
            attr: {
                'data-mail-account': 'all',
                role: 'button',
                tabindex: '0'
            },
            background: (el, s)=>s.root && s.root.mailActiveAccountId ? 'transparent' : 'hover',
            Icon: {
                name: 'folder'
            },
            Label: {
                subscribeTo: [
                    'mailActiveAccountId'
                ],
                text: '{{ mail.sidebar.allInboxes | polyglot }}',
                fontWeight: (el, s)=>s.root && s.root.mailActiveAccountId ? '500' : '700'
            }
        },
        Rows: {
            flow: 'y',
            gap: 'V',
            childrenAs: 'state',
            childExtends: 'MailAccountRow',
            childrenDeps: [
                (el, s)=>s.root && s.root.mailAccounts,
                (el, s)=>s.root && s.root.mailActiveAccountId
            ],
            children: (el, s)=>(s.root && s.root.mailAccounts || []).filter((a)=>a && a.status !== 'disabled').map((a)=>({
                        ...a
                    }))
        }
    }
};
const $09a087e2e53a2471$export$4dbba3578ad4b805 = {
    extends: 'AppSidebarGroup',
    label: (el)=>el.call('polyglot', 'mail.sidebar.folders'),
    List: {
        flow: 'y',
        gap: 'V',
        InboxRow: $09a087e2e53a2471$var$_folderRow('inbox', 'email', 'mail.folder.inbox'),
        StarredRow: $09a087e2e53a2471$var$_folderRow('starred', 'star', 'mail.folder.starred'),
        SentRow: $09a087e2e53a2471$var$_folderRow('sent', 'send', 'mail.folder.sent'),
        DraftsRow: $09a087e2e53a2471$var$_folderRow('drafts', 'edit', 'mail.folder.drafts'),
        ArchiveRow: $09a087e2e53a2471$var$_folderRow('archive', 'archive', 'mail.folder.archive'),
        SpamRow: $09a087e2e53a2471$var$_folderRow('spam', 'warning', 'mail.folder.spam'),
        TrashRow: $09a087e2e53a2471$var$_folderRow('trash', 'trash', 'mail.folder.trash')
    }
};
const $09a087e2e53a2471$export$54f83dcac025ad5f = {
    extends: 'MailFolderRow',
    attr: {
        'data-mail-folder': (el, s)=>`label:${s && s.id || ''}`,
        role: 'button',
        tabindex: '0'
    },
    background: (el, s)=>s.root && s.root.mailActiveFolder === `label:${s && s.id || ''}` ? 'hover' : 'transparent',
    Icon: {
        name: 'label'
    },
    Label: {
        text: (el, s)=>s && s.name || ''
    }
};
const $09a087e2e53a2471$var$_labelFolders = (s)=>{
    const id = s.root && s.root.mailActiveAccountId;
    if (!id) return [];
    const account = (s.root && s.root.mailAccounts || []).find((a)=>a && a.id === id);
    return (account && account.folders || []).filter((f)=>f && !f.role && f.id && f.name);
};
const $09a087e2e53a2471$export$61677115b0b41828 = {
    extends: 'AppSidebarGroup',
    subscribeTo: [
        'mailAccounts',
        'mailActiveAccountId'
    ],
    hide: (el, s)=>!$09a087e2e53a2471$var$_labelFolders(s).length,
    label: (el)=>el.call('polyglot', 'mail.sidebar.labels'),
    List: {
        flow: 'y',
        gap: 'V',
        childrenAs: 'state',
        childExtends: 'MailLabelRow',
        childrenDeps: [
            (el, s)=>s.root && s.root.mailAccounts,
            (el, s)=>s.root && s.root.mailActiveAccountId,
            (el, s)=>s.root && s.root.mailActiveFolder
        ],
        children: (el, s)=>$09a087e2e53a2471$var$_labelFolders(s).map((f)=>({
                    ...f
                }))
    }
};
const $09a087e2e53a2471$export$97d027c986ce8b1d = {
    flow: 'y',
    gap: 'B',
    minWidth: '0',
    ComposeButton: {
        extends: 'Button',
        theme: 'primary',
        flexShrink: '0',
        alignSelf: 'start',
        Icon: {
            name: 'edit'
        },
        text: '{{ mail.compose.new | polyglot }}',
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('openMailCompose');
        }
    },
    MailAccountGroup: {},
    MailFolderGroup: {},
    MailLabelGroup: {}
};
const $09a087e2e53a2471$export$723e6055ae431ab4 = {
    extends: 'AppSidebar',
    tag: 'nav',
    'aria-label': (el)=>el.call('polyglot', 'mail.sidebar.folders'),
    PeopleSection: null,
    ViewSwitcher: null,
    Top: null,
    position: 'relative',
    minWidth: 'F3',
    maxWidth: '50dvw',
    // PHONE: the desktop rail steps aside entirely (same gate as ChatSidebar);
    // the same body re-presents in the shared off-canvas sheet
    // (MailMobileRail, state `_mailRailOpen`).
    '@mobileL': {
        display: 'none'
    },
    Middle: {
        flex: '1',
        overflow: 'auto',
        MailSidebarBody: {}
    }
};

});
parcelRegister("kFsAF", function(module, exports) {

$parcel$export(module.exports, "activeMailListKey", () => $f0bdd0776a2b6bec$export$3dd88923f22ce92c);
$parcel$export(module.exports, "mailListQuery", () => $f0bdd0776a2b6bec$export$18e60f7b4dc2e2bf);
$parcel$export(module.exports, "normalizeMailThread", () => $f0bdd0776a2b6bec$export$8e92c23097fbf9b);
$parcel$export(module.exports, "normalizeMailMessage", () => $f0bdd0776a2b6bec$export$5caac992d51af51f);
$parcel$export(module.exports, "normalizeMailThreadPage", () => $f0bdd0776a2b6bec$export$4a03131a5ee17f76);
$parcel$export(module.exports, "applyMailThreadUpsert", () => $f0bdd0776a2b6bec$export$8330b6f4b3af6437);
$parcel$export(module.exports, "applyMailThreadDelete", () => $f0bdd0776a2b6bec$export$8c5bacb60284e3a1);
$parcel$export(module.exports, "patchMailThreadEverywhere", () => $f0bdd0776a2b6bec$export$6ea58f0fddbf74f4);
$parcel$export(module.exports, "findMailThread", () => $f0bdd0776a2b6bec$export$7089e0b4eaeb0f02);
$parcel$export(module.exports, "mailParticipantsLabel", () => $f0bdd0776a2b6bec$export$20ea6799821ed112);
$parcel$export(module.exports, "mailTimeLabel", () => $f0bdd0776a2b6bec$export$54c3d194766d60e1);
$parcel$export(module.exports, "mailAttachmentSizeLabel", () => $f0bdd0776a2b6bec$export$81b2e0617f6922a0);
$parcel$export(module.exports, "unreadForMailAccount", () => $f0bdd0776a2b6bec$export$df81c87d7b1846e4);
$parcel$export(module.exports, "withMailNavUnread", () => $f0bdd0776a2b6bec$export$b70f473be4379ad5);
$parcel$export(module.exports, "mailSelfAddresses", () => $f0bdd0776a2b6bec$export$38e3d186df50f682);
$parcel$export(module.exports, "mailBodyHasQuote", () => $f0bdd0776a2b6bec$export$5a8fe952a00afb0b);
$parcel$export(module.exports, "buildMailBodySrcdoc", () => $f0bdd0776a2b6bec$export$94eadb4163836768);
// Pure helpers of the mail read path (architecture/MAIL.md §3.1, §4) — row
// normalizers, the list-key algebra, membership + upsert reducers and the
// label formatters. PURE on purpose: every rule the list pane and the stream
// handler share lives here once, and the unit suite exercises these directly
// (no DOM, no SDK).
//
// Server shapes (server/src/core/models/MailThread.js / MailMessage.js —
// mirrored, never invented): a thread row carries subject / snippet /
// participants[{ name, email, role }] / lastMessageAt / messageCount /
// unreadCount / attachmentCount / labels[] / folderRoles[] / starred /
// important / snoozedUntil / muted / hasInvite; a message envelope carries
// from/to/cc/bcc/replyTo address lists, sentAt/receivedAt, flags{ read,
// starred, draft, important, pending } and attachments[{ providerAttachmentId,
// filename, mime, size, contentId, inline }].
// The six provider folder roles (MailThread.folderRoles enum) plus the two
// client pseudo-folders the sidebar offers: `starred` (flag view) and
// `label:<id>` (one provider label). `scheduled` arrives with the outbox
// pane, not the thread list.
const $f0bdd0776a2b6bec$export$a84b61f3bef966f9 = [
    'inbox',
    'sent',
    'drafts',
    'archive',
    'spam',
    'trash'
];
const $f0bdd0776a2b6bec$export$5fe7939e2f099ec5 = (folder)=>String(folder || '').startsWith('label:');
const $f0bdd0776a2b6bec$export$3a5790b398cf7c24 = (folder)=>$f0bdd0776a2b6bec$export$5fe7939e2f099ec5(folder) ? String(folder).slice(6) : null;
const $f0bdd0776a2b6bec$export$94f88da6fa033a8e = (accountId, folder)=>`${accountId || 'all'}|${folder || 'inbox'}`;
const $f0bdd0776a2b6bec$export$5c6587da3b993ac8 = (key)=>{
    const raw = String(key || '');
    const at = raw.indexOf('|');
    if (at === -1) return {
        accountId: null,
        folder: raw || 'inbox'
    };
    const account = raw.slice(0, at);
    return {
        accountId: account && account !== 'all' ? account : null,
        folder: raw.slice(at + 1) || 'inbox'
    };
};
const $f0bdd0776a2b6bec$export$3dd88923f22ce92c = (root)=>$f0bdd0776a2b6bec$export$94f88da6fa033a8e(root && root.mailActiveAccountId, root && root.mailActiveFolder);
const $f0bdd0776a2b6bec$export$18e60f7b4dc2e2bf = (root)=>{
    const r = root || {};
    const q = {};
    if (r.mailActiveAccountId) q.accountId = r.mailActiveAccountId;
    const folder = r.mailActiveFolder || 'inbox';
    if (folder === 'starred') q.starred = true;
    else if ($f0bdd0776a2b6bec$export$5fe7939e2f099ec5(folder)) q.label = $f0bdd0776a2b6bec$export$3a5790b398cf7c24(folder);
    else q.folder = folder;
    const f = r.mailFilters || {};
    if (f.unread) q.unread = true;
    if (f.starred) q.starred = true;
    if (f.attachments) q.attachments = true;
    if (f.from) q.from = f.from;
    if (f.label && !q.label) q.label = f.label;
    const query = String(r.mailSearchQuery || '').trim();
    if (query) q.q = query;
    return q;
};
const $f0bdd0776a2b6bec$var$_id = (row)=>{
    const v = row && (row.id || row._id);
    return v ? String(v) : null;
};
const $f0bdd0776a2b6bec$var$_iso = (v)=>{
    if (!v) return null;
    if (typeof v === 'string') return v;
    try {
        return new Date(v).toISOString();
    } catch (_) {
        return null;
    }
};
const $f0bdd0776a2b6bec$var$_addr = (a)=>({
        name: a && a.name || '',
        email: (a && a.email || '').toLowerCase()
    });
const $f0bdd0776a2b6bec$var$_addrList = (list)=>Array.isArray(list) ? list.map($f0bdd0776a2b6bec$var$_addr).filter((a)=>a.email) : [];
const $f0bdd0776a2b6bec$export$8e92c23097fbf9b = (row)=>{
    const r = row || {};
    return {
        id: $f0bdd0776a2b6bec$var$_id(r),
        account: String(r.account || r.accountId || ''),
        workspace: String(r.workspace || r.workspaceId || ''),
        providerThreadId: r.providerThreadId || null,
        subject: r.subject || '',
        snippet: r.snippet || '',
        participants: Array.isArray(r.participants) ? r.participants.map((p)=>({
                ...$f0bdd0776a2b6bec$var$_addr(p),
                role: p && p.role || 'from'
            })) : [],
        firstMessageAt: $f0bdd0776a2b6bec$var$_iso(r.firstMessageAt),
        lastMessageAt: $f0bdd0776a2b6bec$var$_iso(r.lastMessageAt),
        messageCount: Number(r.messageCount || 0),
        unreadCount: Number(r.unreadCount || 0),
        attachmentCount: Number(r.attachmentCount || 0),
        labels: Array.isArray(r.labels) ? r.labels.map(String) : [],
        folderRoles: Array.isArray(r.folderRoles) ? r.folderRoles.map(String) : [],
        starred: !!r.starred,
        important: !!r.important,
        snoozedUntil: $f0bdd0776a2b6bec$var$_iso(r.snoozedUntil),
        muted: !!r.muted,
        hasInvite: !!r.hasInvite,
        links: r.links || {},
        deleted: !!r.deleted
    };
};
const $f0bdd0776a2b6bec$export$5caac992d51af51f = (row)=>{
    const r = row || {};
    const flags = r.flags || {};
    return {
        id: $f0bdd0776a2b6bec$var$_id(r),
        account: String(r.account || r.accountId || ''),
        thread: String(r.thread || r.threadId || ''),
        internetMessageId: r.internetMessageId || null,
        inReplyTo: r.inReplyTo || null,
        from: $f0bdd0776a2b6bec$var$_addr(r.from),
        to: $f0bdd0776a2b6bec$var$_addrList(r.to),
        cc: $f0bdd0776a2b6bec$var$_addrList(r.cc),
        bcc: $f0bdd0776a2b6bec$var$_addrList(r.bcc),
        replyTo: $f0bdd0776a2b6bec$var$_addrList(r.replyTo),
        subject: r.subject || '',
        sentAt: $f0bdd0776a2b6bec$var$_iso(r.sentAt),
        receivedAt: $f0bdd0776a2b6bec$var$_iso(r.receivedAt),
        snippet: r.snippet || '',
        labels: Array.isArray(r.labels) ? r.labels.map(String) : [],
        folderRoles: Array.isArray(r.folderRoles) ? r.folderRoles.map(String) : [],
        flags: {
            read: !!flags.read,
            starred: !!flags.starred,
            draft: !!flags.draft,
            important: !!flags.important,
            pending: !!flags.pending
        },
        attachments: Array.isArray(r.attachments) ? r.attachments.map((a)=>({
                id: a && (a.providerAttachmentId || a.id) || '',
                filename: a && a.filename || '',
                mime: a && a.mime || 'application/octet-stream',
                size: Number(a && a.size || 0),
                contentId: a && a.contentId || null,
                inline: !!(a && a.inline)
            })) : [],
        hasInvite: !!(r.invite && (r.invite.method || r.invite.uid)),
        bodyState: r.bodyState || null
    };
};
const $f0bdd0776a2b6bec$export$4a03131a5ee17f76 = (res)=>{
    const raw = Array.isArray(res) ? {
        rows: res
    } : res && typeof res === 'object' ? res : {};
    const rows = (Array.isArray(raw.rows) ? raw.rows : Array.isArray(raw.threads) ? raw.threads : []).map($f0bdd0776a2b6bec$export$8e92c23097fbf9b).filter((t)=>t.id);
    const cursor = raw.cursor || raw.nextCursor || null;
    return {
        rows: rows,
        cursor: cursor,
        exhausted: raw.exhausted === true || !cursor
    };
};
const $f0bdd0776a2b6bec$export$6434e1a42efe0cf2 = (thread, key)=>{
    const t = thread || {};
    if (!t.id || t.deleted) return false;
    const { accountId: accountId, folder: folder } = $f0bdd0776a2b6bec$export$5c6587da3b993ac8(key);
    if (accountId && String(t.account) !== String(accountId)) return false;
    if (folder === 'starred') return !!t.starred;
    if ($f0bdd0776a2b6bec$export$5fe7939e2f099ec5(folder)) return t.labels.includes($f0bdd0776a2b6bec$export$3a5790b398cf7c24(folder));
    return t.folderRoles.includes(folder);
};
const $f0bdd0776a2b6bec$var$_sortRows = (rows)=>[
        ...rows
    ].sort((a, b)=>String(b.lastMessageAt || '').localeCompare(String(a.lastMessageAt || '')));
const $f0bdd0776a2b6bec$export$8330b6f4b3af6437 = (lists, row)=>{
    const thread = $f0bdd0776a2b6bec$export$8e92c23097fbf9b(row);
    if (!thread.id) return lists || {};
    const src = lists || {};
    let changed = false;
    const next = {};
    for (const key of Object.keys(src)){
        const slot = src[key] || {};
        const rows = Array.isArray(slot.rows) ? slot.rows : [];
        const at = rows.findIndex((r)=>r && r.id === thread.id);
        const belongs = $f0bdd0776a2b6bec$export$6434e1a42efe0cf2(thread, key);
        if (belongs && at === -1) {
            next[key] = {
                ...slot,
                rows: $f0bdd0776a2b6bec$var$_sortRows([
                    thread,
                    ...rows
                ])
            };
            changed = true;
        } else if (belongs && at !== -1) {
            const copy = [
                ...rows
            ];
            copy[at] = thread;
            next[key] = {
                ...slot,
                rows: $f0bdd0776a2b6bec$var$_sortRows(copy)
            };
            changed = true;
        } else if (!belongs && at !== -1) {
            next[key] = {
                ...slot,
                rows: rows.filter((r)=>r && r.id !== thread.id)
            };
            changed = true;
        } else next[key] = slot;
    }
    return changed ? next : src;
};
const $f0bdd0776a2b6bec$export$8c5bacb60284e3a1 = (lists, threadId)=>{
    const id = threadId ? String(threadId) : null;
    const src = lists || {};
    if (!id) return src;
    let changed = false;
    const next = {};
    for (const key of Object.keys(src)){
        const slot = src[key] || {};
        const rows = Array.isArray(slot.rows) ? slot.rows : [];
        if (rows.some((r)=>r && r.id === id)) {
            next[key] = {
                ...slot,
                rows: rows.filter((r)=>r && r.id !== id)
            };
            changed = true;
        } else next[key] = slot;
    }
    return changed ? next : src;
};
const $f0bdd0776a2b6bec$export$6ea58f0fddbf74f4 = (lists, threadId, patch)=>{
    const id = threadId ? String(threadId) : null;
    const src = lists || {};
    if (!id || !patch) return src;
    let changed = false;
    const next = {};
    for (const key of Object.keys(src)){
        const slot = src[key] || {};
        const rows = Array.isArray(slot.rows) ? slot.rows : [];
        const at = rows.findIndex((r)=>r && r.id === id);
        if (at === -1) {
            next[key] = slot;
            continue;
        }
        const copy = [
            ...rows
        ];
        copy[at] = {
            ...copy[at],
            ...patch
        };
        next[key] = {
            ...slot,
            rows: copy
        };
        changed = true;
    }
    return changed ? next : src;
};
const $f0bdd0776a2b6bec$export$7089e0b4eaeb0f02 = (lists, threadId)=>{
    const id = threadId ? String(threadId) : null;
    if (!id) return null;
    for (const slot of Object.values(lists || {})){
        const rows = slot && Array.isArray(slot.rows) ? slot.rows : [];
        const hit = rows.find((r)=>r && r.id === id);
        if (hit) return hit;
    }
    return null;
};
const $f0bdd0776a2b6bec$export$20ea6799821ed112 = (thread, selfAddresses, meLabel)=>{
    const t = thread || {};
    const self = (selfAddresses || []).map((a)=>String(a).toLowerCase());
    const me = meLabel || 'me';
    const seen = new Set();
    const names = [];
    const list = (t.participants || []).filter((p)=>p && p.role === 'from');
    const source = list.length ? list : t.participants || [];
    for (const p of source){
        const email = (p.email || '').toLowerCase();
        if (!email || seen.has(email)) continue;
        seen.add(email);
        if (self.includes(email)) names.push(me);
        else names.push((p.name || '').split(' ')[0] || email.split('@')[0]);
    }
    return names.join(', ');
};
const $f0bdd0776a2b6bec$export$54c3d194766d60e1 = (iso, locale, now, format)=>{
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const ref = now ? new Date(now) : new Date();
    const loc = locale || undefined;
    const text = (options, time)=>typeof format === 'function' && format(d, options) || (time ? d.toLocaleTimeString(loc, options) : d.toLocaleDateString(loc, options));
    if (d.toDateString() === ref.toDateString()) return text({
        hour: '2-digit',
        minute: '2-digit'
    }, true);
    if (d.getFullYear() === ref.getFullYear()) return text({
        day: 'numeric',
        month: 'short'
    });
    return text({
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
    });
};
const $f0bdd0776a2b6bec$export$a09c35fc63e35115 = (nameOrEmail)=>{
    const s = String(nameOrEmail || '').trim();
    if (!s) return '?';
    const at = s.indexOf('@');
    const base = at > 0 ? s.slice(0, at) : s;
    const parts = base.split(/[\s._-]+/).filter(Boolean);
    if (!parts.length) return s[0].toUpperCase();
    const first = parts[0][0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] || '' : '';
    return (first + last).toUpperCase() || '?';
};
const $f0bdd0776a2b6bec$export$81b2e0617f6922a0 = (bytes)=>{
    const n = Number(bytes || 0);
    if (n < 1024) return `${n} B`;
    if (n < 1048576) return `${Math.round(n / 1024)} KB`;
    return `${(n / 1048576).toFixed(1)} MB`;
};
const $f0bdd0776a2b6bec$export$df81c87d7b1846e4 = (root, accountId)=>{
    const counts = root && root.mailUnreadCounts || {};
    if (accountId) return Number(counts[accountId] || 0);
    return Object.values(counts).reduce((sum, n)=>sum + Number(n || 0), 0);
};
const $f0bdd0776a2b6bec$export$e17c6cb665c238c9 = (root, accounts)=>{
    const counts = root && root.mailUnreadCounts || {};
    const list = accounts || root && root.mailAccounts || [];
    let sum = 0;
    for (const a of list){
        if (!a || a.id === undefined || a.id === null) continue;
        sum += Number(counts[String(a.id)] || 0);
    }
    return sum;
};
const $f0bdd0776a2b6bec$export$b70f473be4379ad5 = (root, patch)=>{
    const merged = {
        mailUnreadCounts: patch.mailUnreadCounts || root && root.mailUnreadCounts,
        mailAccounts: patch.mailAccounts || root && root.mailAccounts
    };
    patch.navUnreadCounts = {
        ...root && root.navUnreadCounts || {},
        mail: $f0bdd0776a2b6bec$export$e17c6cb665c238c9(merged)
    };
    return patch;
};
const $f0bdd0776a2b6bec$export$38e3d186df50f682 = (root)=>{
    const out = [];
    for (const a of root && root.mailAccounts || []){
        if (a && a.address) out.push(String(a.address).toLowerCase());
        for (const s of a && a.sendAs || [])if (s && s.address) out.push(String(s.address).toLowerCase());
    }
    return [
        ...new Set(out)
    ];
};
// ── the sandboxed body document (MailMessageBody) ───────────────────────────
// Known quote containers the fold hides (Gmail / Outlook / RFC blockquote).
const $f0bdd0776a2b6bec$var$MAIL_QUOTE_SELECTORS = 'blockquote[type="cite"], .gmail_quote, .gmail_extra, #divRplyFwdMsg, .ms-outlook-mobile-reference-message';
const $f0bdd0776a2b6bec$export$5a8fe952a00afb0b = (html)=>/<blockquote[^>]*type=["']?cite|class=["'][^"']*(gmail_quote|gmail_extra)|id=["']?divRplyFwdMsg/i.test(String(html || ''));
// A CSP source has to be scheme + host and nothing else: it lands inside a
// `content="…"` attribute, where a `"` closes the attribute and a `;` starts
// a new directive. Anything that is not a plain http(s) origin is DROPPED,
// so a bad read makes the policy stricter and never wider.
const $f0bdd0776a2b6bec$var$_cspOrigin = (value)=>{
    const raw = String(value || '').trim();
    if (!raw || /["'; \t\n]/.test(raw)) return '';
    try {
        const u = new URL(raw);
        return u.protocol === 'https:' || u.protocol === 'http:' ? u.origin : '';
    } catch (e) {
        return '';
    }
};
const $f0bdd0776a2b6bec$export$6102b45a86bc247a = (apiOrigin, showImages)=>{
    const origin = $f0bdd0776a2b6bec$var$_cspOrigin(apiOrigin);
    const img = `data:${origin ? ` ${origin}` : ''}${showImages ? ' https:' : ''}`;
    return `default-src 'none'; img-src ${img}; style-src 'unsafe-inline'`;
};
const $f0bdd0776a2b6bec$export$94eadb4163836768 = (body, opts)=>{
    const b = body || {};
    const o = opts || {};
    let html = String(b.html || '');
    if (!html && b.text) html = `<div style="white-space:pre-wrap">${String(b.text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>`;
    if (o.showImages) html = html.replace(/\bdata-mail-src=/g, 'src=');
    const foldCss = o.showQuoted ? '' : `${$f0bdd0776a2b6bec$var$MAIL_QUOTE_SELECTORS} { display: none; }`;
    return '<!doctype html><html><head><meta charset="utf-8">' + // Before <base> and before any markup — a meta policy only governs what
    // the parser has not reached yet.
    `<meta http-equiv="Content-Security-Policy" content="${$f0bdd0776a2b6bec$export$6102b45a86bc247a(o.apiOrigin, o.showImages)}">` + '<base target="_blank">' + '<style>' + 'body{margin:0;padding:0;font:14px/1.55 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:#1f2328;background:transparent;word-break:break-word;overflow-wrap:anywhere}' + 'img{max-width:100%;height:auto}' + 'img.mail-blocked-image{min-width:24px;min-height:24px;background:#f0f1f3;border-radius:4px}' + 'a{color:#0969da}' + 'blockquote{margin:8px 0 8px 8px;padding-left:12px;border-left:2px solid #d0d7de;color:#57606a}' + 'pre{white-space:pre-wrap}' + 'table{max-width:100%}' + foldCss + '</style></head><body>' + html + '</body></html>';
};

});


parcelRegister("ZXRAQ", function(module, exports) {

$parcel$export(module.exports, "MailStatusBanner", () => $0ba4223edc220729$export$d692120ad0d7a64d);
$parcel$export(module.exports, "MailMain", () => $0ba4223edc220729$export$980909422579374c);
// Right-hand main column of the /mail page — the list pane + the thread view
// as flex siblings (architecture/MAIL.md §3.1 three-pane layout). With no
// working mailbox the §3.2a gate owns the pane instead (MailEmptyState mounts
// MailSetupPanel); the gate is the server's `state`, never an account count
// (the MailDrawerEmpty precedent).
const $0ba4223edc220729$export$d692120ad0d7a64d = {
    subscribeTo: [
        'mailAccounts'
    ],
    // One-line banner over the list: backfill progress, or the reconnect ask
    // for a `reauth_required` / `error` account (§3.1 states table).
    hide: (el, s)=>{
        const accounts = s.root && s.root.mailAccounts || [];
        return !accounts.some((a)=>a && (a.status === 'reauth_required' || a.status === 'error' || a.sync && a.sync.status === 'backfill'));
    },
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    margin: 'Z Z1 0 Z1',
    padding: 'Z Z1',
    round: 'radiusControl',
    background: 'hover',
    flexShrink: '0',
    minWidth: '0',
    Note: {
        tag: 'span',
        fontSize: 'Y1',
        color: 'caption',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        subscribeTo: [
            'mailAccounts'
        ],
        text: (el, s)=>{
            const accounts = s.root && s.root.mailAccounts || [];
            const broken = accounts.find((a)=>a && (a.status === 'reauth_required' || a.status === 'error'));
            if (broken) return el.call('polyglot', 'mail.banner.reconnect').replace('{address}', broken.address || '');
            const backfilling = accounts.find((a)=>a && a.sync && a.sync.status === 'backfill');
            const progress = backfilling && backfilling.sync && backfilling.sync.progress;
            return el.call('polyglot', 'mail.banner.backfill').replace('{p}', progress != null ? `${Math.round(Number(progress))}%` : "\u2026");
        }
    },
    ReconnectBtn: {
        subscribeTo: [
            'mailAccounts'
        ],
        hide: (el, s)=>!(s.root && s.root.mailAccounts || []).some((a)=>a && (a.status === 'reauth_required' || a.status === 'error')),
        tag: 'button',
        type: 'button',
        border: 'none',
        cursor: 'pointer',
        background: 'transparent',
        color: 'accentInk',
        fontSize: 'Y1',
        fontWeight: '700',
        padding: 'V Z',
        round: 'radiusControl',
        flexShrink: '0',
        ':hover': {
            background: 'hover'
        },
        text: '{{ mail.banner.reconnectAction | polyglot }}',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const accounts = s.root && s.root.mailAccounts || [];
            const broken = accounts.find((a)=>a && (a.status === 'reauth_required' || a.status === 'error'));
            if (broken) el.call('reconnectMailAccount', broken.id);
        }
    }
};
const $0ba4223edc220729$export$980909422579374c = {
    flow: 'x',
    flex: '1 1 0',
    minWidth: '0',
    minHeight: '0',
    overflow: 'hidden',
    theme: 'document',
    // Light takes the house content surface, so the pane matches the sidebar
    // card beside it — same reasoning as ChatMain (Rule 13).
    '@light': {
        background: 'white'
    },
    '@mobileL': {
        position: 'relative',
        flow: 'y'
    },
    // Not set up → the §3.2a gate (the shipped empty state). `ready` is the
    // ONLY state with a working mailbox (the MailDrawerEmpty precedent) — the
    // read panes and this poster swap on exactly that answer. FA515: the
    // `s.root &&` guard short-circuits, so each gate declares its dep.
    MailEmptyState: {
        hide: (el, s)=>(s && s.root && s.root.mailSetup && s.root.mailSetup.state) === 'ready',
        hideDeps: [
            (el, s)=>s.root && s.root.mailSetup
        ]
    },
    ListPane: {
        hide: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state || '') !== 'ready',
        hideDeps: [
            (el, s)=>s.root && s.root.mailSetup
        ],
        flow: 'y',
        flex: '1 1 0',
        minWidth: '0',
        minHeight: '0',
        MailStatusBanner: {},
        MailThreadList: {}
    },
    MailThreadView: {
        hide: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state || '') !== 'ready',
        hideDeps: [
            (el, s)=>s.root && s.root.mailSetup
        ]
    }
};

});

parcelRegister("6hwA2", function(module, exports) {

$parcel$export(module.exports, "MailEmptyState", () => $492d9a5c89378a4b$export$924505132d49103f);
// The "not connected" state of the mail surface — 0 accessible accounts
// (architecture/MAIL.md §3.1). Same layout as ChatWelcomePrompt, but with a
// real glyph instead of an ambient watermark: the envelope IS the message
// here, so it carries `title` ink, not a de-emphasised wash. No badges, no
// borders, no shadow.
//
// P1 (MAIL-UI-CONNECT-SETTINGS-1): MailSetupPanel mounts below the glyph and
// IS the body once the §3.2a gate has answered. The generic poster lines above
// it are the pre-answer state only — two headings saying the same thing in
// different words is the defect the panel was written to remove, so they step
// aside the moment the server names a state.
const $492d9a5c89378a4b$export$924505132d49103f = {
    flex: '1 1 0',
    minHeight: '0',
    flow: 'y',
    // ⚠️ `justify-content: center` CLIPS an overflowing column at BOTH ends and
    // gives no way to reach the lost part — measured live on /mail 2026-09-05:
    // with the admin `steps` cards mounted, the panel ran 1203px inside an 854px
    // pane and the heading sat at -268px, unreachable (MailMain is
    // `overflow: hidden`, so no ancestor scrolled either). `safe center` centres
    // while it fits and falls back to start-aligned the moment it does not, and
    // `overflow: auto` gives this box its own scroll. `alignItems` is written
    // out rather than folded into the `align` shorthand because the two axes no
    // longer take the same value.
    alignItems: 'center',
    justifyContent: 'safe center',
    overflow: 'auto',
    gap: 'B',
    // `E` (110px) of inset was right for three lines of poster copy; with the
    // gate panel below it, it is a third of the pane before the first word.
    padding: 'C',
    color: 'caption',
    // `flexShrink: 0` is load-bearing, not decoration: a flex child with no
    // intrinsic size shrinks along the MAIN axis, so the moment the panel below
    // makes this column overflow (an admin's six `steps` cards do), the glyph
    // collapsed to height 0 and the surface lost its only image — measured live
    // on /mail 2026-09-05.
    Icon: {
        name: 'email',
        boxSize: 'D D',
        color: 'title',
        flexShrink: '0'
    },
    Heading: {
        // FA515 arming: without the declared selector this `if:` short-circuits on
        // `s.root` and never subscribes to `mailSetup`, so the poster line would
        // stay on screen beside the panel once the gate answers.
        ifDeps: [
            (el, s)=>s.root && s.root.mailSetup
        ],
        if: (el, s)=>!(s.root && s.root.mailSetup),
        tag: 'h2',
        fontSize: 'C',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        textAlign: 'center',
        text: '{{ mail.empty.heading | polyglot }}'
    },
    Body: {
        ifDeps: [
            (el, s)=>s.root && s.root.mailSetup
        ],
        if: (el, s)=>!(s.root && s.root.mailSetup),
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        textAlign: 'center',
        margin: '0',
        maxWidth: 'H',
        lineHeight: '1.5',
        text: '{{ mail.empty.body | polyglot }}'
    },
    // The six-state gate (§3.2a). Its box is centred; its own text stays left,
    // which is what a multi-line instruction plus a row of actions needs.
    MailSetupPanel: {}
};

});

parcelRegister("gEh4o", function(module, exports) {

$parcel$export(module.exports, "MailSetupAction", () => $c1ed9f78be7f088d$export$1c78f064e2a2bd1d);
$parcel$export(module.exports, "MailProviderButton", () => $c1ed9f78be7f088d$export$15bd4157e7de96cf);
$parcel$export(module.exports, "MailSetupStep", () => $c1ed9f78be7f088d$export$3a0486a3e5588ec6);
$parcel$export(module.exports, "MailSetupPanel", () => $c1ed9f78be7f088d$export$e3aaf574ad642640);
// MailSetupPanel — the six-state setup gate of architecture/MAIL.md §3.2a,
// rendered from `sdk.execute('mail.setup', 'get')` and from nothing else.
//
// The server decides the state (off | ready | reauth | connect | link |
// ask-admin); this file only paints it. That is the whole point of §3.2a: one
// panel, three mount points (the /mail empty state, the header drawer, the
// /settings Mail card), and no surface that invents its own idea of whether
// mail is set up.
//
// TWO CONTRACT FACTS THIS FILE IS BUILT ON
//   • `providers[].steps` is served ONLY when `viewerIsAdmin`. A member gets an
//     empty list, and that is NORMAL — the member states render their own copy
//     plus the provider LABEL, never an empty "instructions" box.
//   • The steps are SERVER CONTENT (the scope list, the consent URL, the
//     Exchange command). The server sends each one as English plus stable
//     codes and the org-specific values its sentence names (`params`); the
//     card translates by those codes (functions/serverCopy.js) and paints the
//     server's English only for a code this bundle does not know. The copyable
//     `code` line is a technical artifact and stays verbatim.
//
// Design: flat, borderless, tokens only (design-direction.md §8/§15 and the
// brand-language weight law {400,500,700}). The single accent on the panel is
// the primary action's solid ink; every other surface is the house
// `overlayStrong` card. No dividers, no shadow, no second hue.
// The panel's action control — declared ONCE so the five call sites below
// (Write / Reconnect / Link / Notify / Set up mail) cannot drift into five
// geometries (Rule 61 + Rule 68: the scale belongs to the primitive, never to
// the call site). Capsule + controlH is the house CTA scale (DESIGN_LANGUAGE
// §6.2); `primary` carries hover / active / focus-visible already (Rule 65).
const $c1ed9f78be7f088d$export$1c78f064e2a2bd1d = {
    // The admin kit's solid-ink primary (AdminActionBtnPrimary: the brand
    // `primary` theme, controlH, the pill, Z2 at 700) and its ONE disabled law:
    // the real `disabled` attribute, cursor not-allowed and the `field-disabled`
    // pair, as a `:disabled` pseudo on the primitive (Rule 65). The disabled
    // step was opacity .55, which the brand's disabled law forbids.
    extends: 'AdminActionBtnPrimary',
    flexShrink: '0'
};
const $c1ed9f78be7f088d$export$15bd4157e7de96cf = {
    extends: 'MailSetupAction',
    // Not connectable = disabled, and the primitive's disabled law paints it
    // (the `field-disabled` pair). It switched to an undefined `ghost` theme
    // there.
    disabled: (el, s)=>!s.connectable,
    text: (el, s)=>el.call('polyglot', 'mail.setup.connect.action').replace('{provider}', s.label || s.kind || ''),
    aria: {
        disabled: (el, s)=>s.connectable ? null : 'true'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (!s.connectable) return;
        el.call('startMailConnect', s.kind);
    }
};
const $c1ed9f78be7f088d$export$3a0486a3e5588ec6 = {
    extends: 'CommonCard',
    flow: 'y',
    gap: 'Z',
    StepTitle: {
        tag: 'h4',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>el.call('mailSetupStepTitle', s)
    },
    StepBody: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        fontWeight: '400',
        lineHeight: '1.5',
        color: 'paragraph',
        text: (el, s)=>el.call('mailSetupStepBody', s)
    },
    StepCode: {
        if: (el, s)=>!!s.code,
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        padding: 'Z A',
        round: 'radiusControl',
        background: 'hover',
        CodeText: {
            tag: 'code',
            minWidth: '0',
            flex: '1 1 auto',
            fontSize: 'Y2',
            lineHeight: '1.5',
            color: 'title',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere',
            userSelect: 'text',
            text: (el, s)=>s.code || ''
        },
        // The copy action — the admin kit's compact tonal button
        // (AdminActionBtnCompact: the `overlay` wash at rest, the house hover /
        // press washes, the one disabled law, 36 px). It was `theme: 'ghost'`, a
        // theme the brand does not define (the census on dev 8a4c8af39 read it on
        // every step of the /admin/mail provider cards).
        CopyBtn: {
            extends: 'AdminActionBtnCompact',
            flexShrink: '0',
            text: '{{ mail.setup.step.copy | polyglot }}',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('copyMailSetupCode', s.code);
            }
        }
    }
};
const $c1ed9f78be7f088d$export$e3aaf574ad642640 = {
    flow: 'y',
    gap: 'A',
    width: '100%',
    minWidth: '0',
    // The measure the copy was written for. Spacing letters are em-based, so the
    // panel pins its own type scale first — otherwise `maxWidth: 'H'` resolves
    // against whatever font size the mount site happens to carry.
    fontSize: 'Z2',
    maxWidth: 'H',
    color: 'paragraph',
    // A root-state read inside a factory does NOT auto-subscribe the element, so
    // every root key this panel branches on is declared (the same arming the
    // header's Mail button and MailOverlay carry).
    subscribeTo: [
        'mailSetup',
        'mailSetupLoading',
        'mailSetupError',
        'mailSetupNotice',
        'mailSetupBusy'
    ],
    // ONE read for three mount points — `loadMailSetup` holds the in-flight flag
    // and a 15 s freshness window, so mounting the panel twice (drawer open over
    // /mail) still issues one request.
    onCreate: (el)=>{
        el.call('loadMailSetup');
    },
    // The whole panel is absent when the gate is `off` (the flag is off for this
    // workspace) — §3.2a: "the entry points do not render (no gate)".
    //
    // Every `*Deps` below is FA515 arming, not decoration: a factory's tracked
    // dependency set is only what it actually READ, so a run that short-circuits
    // on `s.root` never subscribes to the key behind it and the element then
    // never re-renders when the gate answers. The declared selectors are read up
    // front, inside the same effect, whatever the control flow.
    ifDeps: [
        (el, s)=>s.root && s.root.mailSetup
    ],
    if: (el, s)=>s.root && s.root.mailSetup ? s.root.mailSetup.state !== 'off' : true,
    // ── The read itself failed (not a state — a fault) ──
    SetupError: {
        ifDeps: [
            (el, s)=>s.root && s.root.mailSetupError
        ],
        if: (el, s)=>!!(s.root && s.root.mailSetupError),
        flow: 'y',
        gap: 'Z',
        ErrorTitle: {
            tag: 'h3',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: '{{ mail.setup.error.title | polyglot }}'
        },
        ErrorBody: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            lineHeight: '1.5',
            color: 'caption',
            textDeps: [
                (el, s)=>s.root && s.root.mailSetupError
            ],
            text: (el, s)=>s.root && s.root.mailSetupError && s.root.mailSetupError.message || ''
        },
        RetryBtn: {
            extends: 'MailSetupAction',
            alignSelf: 'start',
            text: '{{ mail.setup.error.retry | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('loadMailSetup', {
                    force: true
                });
            }
        }
    },
    // ── First read in flight ──
    SetupLoading: {
        ifDeps: [
            (el, s)=>s.root && s.root.mailSetupLoading,
            (el, s)=>s.root && s.root.mailSetup
        ],
        if: (el, s)=>!!(s.root && s.root.mailSetupLoading && !s.root.mailSetup),
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        fontWeight: '400',
        color: 'caption',
        text: '{{ mail.setup.loading | polyglot }}'
    },
    // ── The state the server answered ──
    SetupBody: {
        ifDeps: [
            (el, s)=>s.root && s.root.mailSetup,
            (el, s)=>s.root && s.root.mailSetupError
        ],
        if: (el, s)=>!!(s.root && s.root.mailSetup && !s.root.mailSetupError),
        flow: 'y',
        gap: 'A',
        SetupHeading: {
            tag: 'h3',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            lineHeight: '1.2',
            textDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            text: (el, s)=>{
                const keys = {
                    ready: 'mail.setup.ready.title',
                    reauth: 'mail.setup.reauth.title',
                    connect: 'mail.setup.connect.title',
                    link: 'mail.setup.link.title',
                    'ask-admin': 'mail.setup.askAdmin.title'
                };
                const key = keys[s.root && s.root.mailSetup && s.root.mailSetup.state || ''];
                return key ? el.call('polyglot', key) : '';
            }
        },
        SetupText: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '400',
            lineHeight: '1.5',
            color: 'paragraph',
            textDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            text: (el, s)=>{
                const keys = {
                    ready: 'mail.setup.ready.body',
                    reauth: 'mail.setup.reauth.body',
                    connect: 'mail.setup.connect.body',
                    link: 'mail.setup.link.body',
                    'ask-admin': 'mail.setup.askAdmin.body'
                };
                const key = keys[s.root && s.root.mailSetup && s.root.mailSetup.state || ''];
                return key ? el.call('polyglot', key) : '';
            }
        },
        // The address the reauth / ready states are about — a fact, not chrome, so
        // it is rendered instead of interpolated into a translated sentence.
        SetupAddress: {
            ifDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            if: (el, s)=>{
                const st = s.root && s.root.mailSetup && s.root.mailSetup.state;
                return st === 'ready' || st === 'reauth';
            },
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '500',
            color: 'title',
            overflowWrap: 'anywhere',
            textDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            text: (el, s)=>{
                // Pick the account the STATE is about, not simply the first one the
                // ACL returned. `accounts` includes `disabled` tombstones, so
                // `accounts[0]` could name a mailbox that was disconnected months ago
                // under the words "Reconnect <address> to send" — the person would go
                // and re-authorise the wrong one. `reauth` means "a send-capable
                // account is reauth_required"; `ready` means "a send-capable account
                // is active". Name exactly that account, and print nothing rather
                // than the wrong thing.
                const setup = s.root && s.root.mailSetup || {};
                const wanted = setup.state === 'reauth' ? 'reauth_required' : 'active';
                const sendable = (setup.accounts || []).filter((a)=>a && a.canSend);
                const pick = sendable.find((a)=>a.status === wanted);
                return pick && pick.address || '';
            }
        },
        // ── Actions. One row; each entry gates on the state it belongs to. ──
        SetupActions: {
            flow: 'x',
            gap: 'Z1',
            wrap: 'wrap',
            align: 'center',
            // ready → hand off to THE compose entry point (§3.2a). Until
            // MAIL-UI-COMPOSE-1 lands, `openMailCompose` opens /mail with the draft
            // parked on root.mailComposeDraft.
            ComposeBtn: {
                ifDeps: [
                    (el, s)=>s.root && s.root.mailSetup
                ],
                if: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state) === 'ready',
                extends: 'MailSetupAction',
                text: '{{ mail.setup.ready.action | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('openMailCompose');
                }
            },
            ReconnectBtn: {
                ifDeps: [
                    (el, s)=>s.root && s.root.mailSetup
                ],
                if: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state) === 'reauth',
                extends: 'MailSetupAction',
                text: '{{ mail.setup.reauth.action | polyglot }}',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const accounts = s.root && s.root.mailSetup && s.root.mailSetup.accounts || [];
                    const pick = accounts.find((a)=>a && a.status === 'reauth_required') || accounts[0];
                    el.call('startMailConnect', pick && pick.provider || '');
                }
            },
            LinkBtn: {
                ifDeps: [
                    (el, s)=>s.root && s.root.mailSetup
                ],
                if: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state) === 'link',
                extends: 'MailSetupAction',
                disabledDeps: [
                    (el, s)=>s.root && s.root.mailSetupBusy
                ],
                disabled: (el, s)=>(s.root && s.root.mailSetupBusy) === 'link',
                text: '{{ mail.setup.link.action | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('linkMailMailbox');
                }
            },
            // ask-admin, and the link state's fallback when the directory match
            // fails: a member asks; an admin gets the admin button instead (below).
            NotifyBtn: {
                ifDeps: [
                    (el, s)=>s.root && s.root.mailSetup
                ],
                if: (el, s)=>{
                    const setup = s.root && s.root.mailSetup;
                    if (!setup || setup.viewerIsAdmin) return false;
                    return setup.state === 'ask-admin' || setup.state === 'link';
                },
                // The admin kit's tonal button: in `link` it is the secondary action
                // beside [Link]. In `ask-admin` it is the only way forward, so it takes
                // the solid primary — through a class block, never a reactive theme or
                // fill, so the tonal wash stays static and the framework forces no
                // `!important`. In `link` it was an undefined `ghost` theme.
                extends: 'AdminActionBtn',
                flexShrink: '0',
                // The primary block holds only while the button can act: busy, it is
                // disabled, and the kit's own `:disabled` law paints it (a `:disabled`
                // nested in the class block does not outrank the block's theme).
                isAskAdminPrimary: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state) === 'ask-admin' && (s.root && s.root.mailSetupBusy) !== 'notifyAdmin',
                '.isAskAdminPrimary': {
                    theme: 'primary',
                    fontWeight: '700'
                },
                disabledDeps: [
                    (el, s)=>s.root && s.root.mailSetupBusy
                ],
                disabled: (el, s)=>(s.root && s.root.mailSetupBusy) === 'notifyAdmin',
                text: '{{ mail.setup.askAdmin.action | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('notifyMailAdmin');
                }
            },
            // An admin never asks another admin — they go and do it. But ONLY in
            // the two states whose missing piece IS the tenant connection:
            // `ask-admin` (no tenant, and this viewer may not connect a personal
            // mailbox) and `link` (a tenant exists, this viewer's mailbox is not
            // matched to it). In `connect` the person can just sign in, and in
            // `reauth` the repair is their own re-authorisation — offering "Set up
            // mail" there sends an admin to a tenant console to fix a personal
            // account. `state !== 'ready'` said all four.
            AdminBtn: {
                ifDeps: [
                    (el, s)=>s.root && s.root.mailSetup
                ],
                if: (el, s)=>{
                    const setup = s.root && s.root.mailSetup;
                    if (!setup || !setup.viewerIsAdmin) return false;
                    return setup.state === 'ask-admin' || setup.state === 'link';
                },
                extends: 'MailSetupAction',
                text: '{{ mail.setup.admin.action | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('openMailAdminSetup');
                }
            }
        },
        // ── connect → one button per provider, policy-gated by the server ──
        SetupProviders: {
            ifDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            if: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state) === 'connect',
            flow: 'x',
            gap: 'Z1',
            wrap: 'wrap',
            align: 'center',
            childExtends: 'MailProviderButton',
            childrenAs: 'state',
            childrenDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            children: (el, s)=>{
                const providers = s.root && s.root.mailSetup && s.root.mailSetup.providers || [];
                return providers.map((p)=>({
                        key: p.kind,
                        ...p
                    }));
            }
        },
        // Why the provider buttons cannot act.
        //
        // ⚠️ THE POLICY CANNOT BE THE REASON HERE, AND THE SERVER PROVES IT.
        // `connect` is reached only when `personalAllowed` is TRUE
        // (MailSetupService.computeSetupState) — a policy of `nobody`, or a
        // viewer outside the allowed domains, answers `ask-admin` instead and
        // this element never renders. `connectable` is
        // `personalCheck(provider).ok && platformClient`, so with the policy half
        // already true the only half left is the platform's own client id. The
        // old three-way branch keyed off `policy.allowPersonal` and could
        // therefore print "this workspace does not allow personal mailboxes"
        // directly under two live [Continue with …] buttons — a sentence the
        // server had just contradicted.
        SetupBlocked: {
            ifDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            if: (el, s)=>{
                const setup = s.root && s.root.mailSetup;
                if (!setup || setup.state !== 'connect') return false;
                return !(setup.providers || []).some((p)=>p && p.connectable);
            },
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '400',
            lineHeight: '1.5',
            color: 'caption',
            text: '{{ mail.setup.connect.blockedPlatform | polyglot }}'
        },
        // ── The provider names an admin would have to connect (ask-admin) ──
        SetupProviderNames: {
            ifDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            if: (el, s)=>(s.root && s.root.mailSetup && s.root.mailSetup.state) === 'ask-admin',
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            fontWeight: '500',
            color: 'caption',
            textDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            text: (el, s)=>{
                const providers = s.root && s.root.mailSetup && s.root.mailSetup.providers || [];
                return providers.map((p)=>p.label || p.kind).join(" \xb7 ");
            }
        },
        // ── The outcome of the last action ──
        // `key` is a bundle key; `message` is the SERVER's own sentence (the 501
        // contract line, a refusal) and is rendered under it — in the session
        // language when the notice carries a config-error `code` the bundle knows
        // (functions/serverCopy.js), verbatim otherwise.
        SetupNotice: {
            ifDeps: [
                (el, s)=>s.root && s.root.mailSetupNotice
            ],
            if: (el, s)=>!!(s.root && s.root.mailSetupNotice),
            flow: 'y',
            gap: 'V',
            padding: 'Z A',
            round: 'radiusControl',
            background: 'hover',
            NoticeText: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y2',
                fontWeight: '500',
                lineHeight: '1.5',
                colorDeps: [
                    (el, s)=>s.root && s.root.mailSetupNotice
                ],
                color: (el, s)=>(s.root && s.root.mailSetupNotice && s.root.mailSetupNotice.tone) === 'error' ? 'dangerInk' : 'title',
                textDeps: [
                    (el, s)=>s.root && s.root.mailSetupNotice
                ],
                text: (el, s)=>{
                    const notice = s.root && s.root.mailSetupNotice || {};
                    const text = notice.key ? el.call('polyglot', notice.key) : '';
                    return notice.provider ? text.replace('{provider}', notice.provider) : text;
                }
            },
            NoticeDetail: {
                hideDeps: [
                    (el, s)=>s.root && s.root.mailSetupNotice
                ],
                hide: (el, s)=>!(s.root && s.root.mailSetupNotice && s.root.mailSetupNotice.message),
                tag: 'p',
                margin: '0',
                fontSize: 'Y2',
                fontWeight: '400',
                lineHeight: '1.5',
                color: 'caption',
                textDeps: [
                    (el, s)=>s.root && s.root.mailSetupNotice
                ],
                text: (el, s)=>el.call('mailErrorText', s.root && s.root.mailSetupNotice || {})
            }
        },
        // ── Admin instructions — SERVER CONTENT, admins only ──
        // A member's `steps` is an empty array by contract, so this whole block
        // simply does not render for them. That is the normal case, not an error.
        // The steps are the TENANT setup instructions, so they follow the same
        // two states [Set up mail] does. Without a state guard an admin read
        // "Mail is ready" and then six cards about domain-wide delegation
        // underneath it — the server serves `steps` on every read, so the only
        // thing that ever kept them off a `ready` panel was luck.
        SetupSteps: {
            ifDeps: [
                (el, s)=>s.root && s.root.mailSetup
            ],
            if: (el, s)=>{
                const setup = s.root && s.root.mailSetup;
                if (!setup || !setup.viewerIsAdmin) return false;
                if (setup.state !== 'ask-admin' && setup.state !== 'link') return false;
                return (setup.providers || []).some((p)=>p && (p.steps || []).length);
            },
            flow: 'y',
            gap: 'Z1',
            StepsTitle: {
                tag: 'h4',
                margin: '0',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: '{{ mail.setup.admin.steps | polyglot }}'
            },
            StepsList: {
                flow: 'y',
                gap: 'Z1',
                childExtends: 'MailSetupStep',
                childrenAs: 'state',
                childrenDeps: [
                    (el, s)=>s.root && s.root.mailSetup
                ],
                children: (el, s)=>{
                    const providers = s.root && s.root.mailSetup && s.root.mailSetup.providers || [];
                    const rows = [];
                    for (const provider of providers){
                        const steps = provider && provider.steps || [];
                        steps.forEach((step, i)=>{
                            rows.push({
                                key: `${provider.kind}-${i}`,
                                // The provider leads the title; MailSetupStep composes the
                                // two when it paints, so a translated title keeps it.
                                label: provider.label || provider.kind || '',
                                id: step.id || '',
                                bodyCode: step.bodyCode || '',
                                params: step.params || null,
                                title: step.title || '',
                                body: step.body || '',
                                code: step.code || ''
                            });
                        });
                    }
                    return rows;
                }
            }
        }
    }
};

});

parcelRegister("aoBWA", function(module, exports) {

$parcel$export(module.exports, "MailSettingsAccountRow", () => $7919942359ac92ac$export$dad06978293b64cc);
$parcel$export(module.exports, "MailAccountSettingsCard", () => $7919942359ac92ac$export$8a2d05b9c9c332b0);
// MailAccountSettingsCard — the "Mail" card of the account settings page
// (architecture/MAIL.md §3.4), mounted beside Language / Accessibility /
// Security in `MemberProfile`.
//
// It reads the SAME setup gate the /mail empty state and the drawer read, so a
// person who has no mailbox is taught the setup here too (MailSetupPanel is
// mounted below the list) instead of meeting an empty card. With accounts
// present the card is the account list: address, kind, status, and the two
// per-account fields §3.4 names first — signature and default send-as.
//
// Every write goes through `mail.accounts` update / remove. `remove` is the
// DISCONNECT: the server tombstones the row and purges the local mirror
// behind it, so it asks first through the house confirm — the question says
// what goes for this row (functions/accounts.js `disconnectMailAccount`).
//
// Design: the house card (CommonCard) with SettingRow's row anatomy. No
// dividers between rows — each row's own padding is the separation
// (design-direction.md §8), and the hover wash SettingRow already declares is
// the boundary cue.
// One connected mailbox. Fed `childrenAs: 'state'`, so its state is a
// `mail.accounts list` row: { id, address, kind, provider, status, sendAs,
// signature, settings, … }.
//
// ⚠️ NAMED `MailSettingsAccountRow`, NOT `MailAccountRow` — Rule 63, and it
// was a live P0, not a precaution. `components/Sidebar.js:62` already exports
// a `MailAccountRow` (the sidebar's mailbox row: icon + label + attention
// dot), and BOTH files ride the eager slice, so the two `export *`s collided
// in one barrel. The sidebar's definition won: measured on a direct /profile
// load with two accounts injected, this card's AccountList rendered children
// keyed `Icon` / `Label` / `AttentionDot` — the sidebar row — so the address,
// kind · status sub-line, send-as picker, signature field and Disconnect this
// component defines had never reached the settings page at all. The rename is
// the fix (Rule 63's "rename your new component — do NOT shadow"); the
// sidebar keeps its name and its two references untouched.
const $7919942359ac92ac$export$dad06978293b64cc = {
    flow: 'y',
    gap: 'Z',
    padding: 'A 0',
    Head: {
        extends: 'SettingRow',
        padding: '0',
        ':hover': {
            background: 'transparent'
        },
        Info: {
            Name: {
                text: (el, s)=>s.address || ''
            },
            Sub: {
                // SettingRow's own Sub hides itself when neither `el.description` nor
                // `s.description` is set. This row composes its sub-line from up to
                // three TRANSLATED words instead (kind · status · simulated), which
                // must resolve at render time so a language switch reaches them — so
                // the gate is restated as "always shown" and the text is built here.
                hide: ()=>false,
                text: (el, s)=>{
                    const kindKeys = {
                        personal: 'mail.settings.kind.personal',
                        tenant: 'mail.settings.kind.tenant',
                        shared: 'mail.settings.kind.shared'
                    };
                    const statusKeys = {
                        active: 'mail.settings.status.active',
                        syncing: 'mail.settings.status.syncing',
                        reauth_required: 'mail.settings.status.reauth',
                        disabled: 'mail.settings.status.disabled'
                    };
                    const kind = kindKeys[s.kind] ? el.call('polyglot', kindKeys[s.kind]) : s.kind || '';
                    const status = statusKeys[s.status] ? el.call('polyglot', statusKeys[s.status]) : s.status || '';
                    // A SIMULATED mailbox is seeded demo data — no provider is ever
                    // contacted for it. `serializeAccount` states the fact
                    // (`simulated: boolean`), so it joins the sub-line as a third word
                    // instead of replacing either of the two already there: the row is
                    // genuinely a Company mailbox and genuinely Live, and it is also
                    // not real. All three are true at once.
                    const simulated = s.simulated ? el.call('polyglot', 'mail.settings.simulated') : '';
                    return [
                        kind,
                        status,
                        simulated
                    ].filter(Boolean).join(" \xb7 ");
                }
            }
        },
        Right: {
            // The admin kit's compact tonal button (it was an undefined `ghost`
            // theme).
            ReconnectBtn: {
                if: (el, s)=>s.status === 'reauth_required',
                extends: 'AdminActionBtnCompact',
                text: '{{ mail.settings.action.reconnect | polyglot }}',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('reconnectMailAccount', s.id);
                }
            },
            // [Disconnect] — one control for every row. The house confirm it opens
            // names what goes (functions/accounts.js `disconnectMailAccount`): a
            // real mailbox keeps its mail at the provider, a simulated one is
            // deleted for good. The button itself writes nothing.
            DisconnectBtn: {
                // The admin kit's compact tonal button (it was an undefined `ghost`
                // theme).
                extends: 'AdminActionBtnCompact',
                // The semantic danger INK pair, never a raw hue: `red` is one literal
                // that is wrong on one of the two schemes (DESIGN_LANGUAGE §10
                // raw-hue-ink, pinned by shared/__tests__/designLanguageLocks).
                color: 'dangerInk',
                // FA515 arming — a factory subscribes only to what it actually READ,
                // so a run that short-circuits on `s.root` never tracks the key behind
                // it. The declared selector is read up front inside the same effect.
                disabledDeps: [
                    (el, s)=>s.root && s.root.mailSettingsBusy
                ],
                disabled: (el, s)=>{
                    const busy = s.root && s.root.mailSettingsBusy;
                    return !!(busy && busy.id === s.id);
                },
                text: '{{ mail.settings.action.disconnect | polyglot }}',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('disconnectMailAccount', s.id);
                }
            }
        }
    },
    // ── The two fields §3.4 names first ──
    Fields: {
        flow: 'y',
        gap: 'Z',
        SendAsField: {
            // A native select: `sendAs` is the server's own allowlist and
            // `defaultSendAs` must be one of it, so the control cannot offer a value
            // the PATCH would refuse. Hidden when the mailbox has one address only —
            // a one-option picker is chrome with nothing to choose.
            if: (el, s)=>((s.sendAs || []).length || 0) > 1,
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'label',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                text: '{{ mail.settings.field.sendAs | polyglot }}'
            },
            Select: {
                tag: 'select',
                width: '100%',
                theme: 'field',
                minHeight: 'controlH',
                round: 'radiusControl',
                color: 'title',
                fontSize: 'Z2',
                padding: '0 A',
                // `childrenAs: 'props'` — a native <option> built with
                // `childrenAs: 'state'` carries NO `value` attribute, so
                // `e.target.value` would answer the LABEL instead of the address.
                childrenAs: 'props',
                children: (el, s)=>(s.sendAs || []).map((row)=>({
                            key: row.address,
                            value: row.address,
                            text: row.name ? `${row.name} <${row.address}>` : row.address
                        })),
                childProps: {
                    tag: 'option',
                    selectedDeps: [
                        (el, s)=>s.root && s.root.mailSettingsDraft
                    ],
                    selected: (el, s)=>{
                        const draft = (s.root && s.root.mailSettingsDraft || {})[s.id] || {};
                        const current = draft.defaultSendAs || ((s.sendAs || []).find((r)=>r && r.default) || {}).address || s.address;
                        return String(current || '') === String(el.value || '') ? 'selected' : null;
                    }
                },
                onChange: (e, el, s)=>{
                    el.call('setMailAccountDraft', s.id, {
                        defaultSendAs: e.target.value
                    });
                }
            }
        },
        SignatureField: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'label',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                text: '{{ mail.settings.field.signature | polyglot }}'
            },
            Input: {
                tag: 'textarea',
                rows: '3',
                width: '100%',
                theme: 'field',
                round: 'radiusControl',
                color: 'title',
                fontSize: 'Z2',
                fontWeight: '400',
                lineHeight: '1.5',
                padding: 'Z A',
                resize: 'vertical',
                valueDeps: [
                    (el, s)=>s.root && s.root.mailSettingsDraft
                ],
                value: (el, s)=>{
                    const draft = (s.root && s.root.mailSettingsDraft || {})[s.id] || {};
                    if (typeof draft.signature === 'string') return draft.signature;
                    return s.signature && s.signature.text || '';
                },
                onInput: (e, el, s)=>{
                    el.call('setMailAccountDraft', s.id, {
                        signature: e.target.value
                    });
                }
            }
        },
        RowFooter: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z1',
            // The box is RESERVED, never `if:`-gated: a save button that appears on
            // the first keystroke shoves the next account row down the page
            // (Rule 66). Only visibility and reachability change.
            minHeight: 'controlHCompact',
            RowError: {
                tag: 'p',
                margin: '0',
                minWidth: '0',
                fontSize: 'Y2',
                fontWeight: '400',
                lineHeight: '1.4',
                color: 'dangerInk',
                textDeps: [
                    (el, s)=>s.root && s.root.mailSettingsError
                ],
                text: (el, s)=>{
                    const err = s.root && s.root.mailSettingsError;
                    return err && err.id === s.id ? err.message || '' : '';
                }
            },
            SaveBtn: {
                extends: 'Button',
                theme: 'primary',
                minHeight: 'controlHCompact',
                round: 'radiusPill',
                padding: '0 A',
                fontSize: 'Y2',
                fontWeight: '700',
                flexShrink: '0',
                text: '{{ mail.settings.action.save | polyglot }}',
                visibilityDeps: [
                    (el, s)=>s.root && s.root.mailSettingsDraft
                ],
                visibility: (el, s)=>{
                    const draft = (s.root && s.root.mailSettingsDraft || {})[s.id];
                    return draft && Object.keys(draft).length ? 'visible' : 'hidden';
                },
                pointerEventsDeps: [
                    (el, s)=>s.root && s.root.mailSettingsDraft
                ],
                pointerEvents: (el, s)=>{
                    const draft = (s.root && s.root.mailSettingsDraft || {})[s.id];
                    return draft && Object.keys(draft).length ? 'auto' : 'none';
                },
                tabindexDeps: [
                    (el, s)=>s.root && s.root.mailSettingsDraft
                ],
                tabindex: (el, s)=>{
                    const draft = (s.root && s.root.mailSettingsDraft || {})[s.id];
                    return draft && Object.keys(draft).length ? '0' : '-1';
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('saveMailAccountSettings', s.id);
                }
            }
        }
    }
};
const $7919942359ac92ac$export$8a2d05b9c9c332b0 = {
    // The account page's card shape, mirrored rather than imported: it lives in
    // a module-private `_card()` inside the shared package's MemberProfile.js,
    // which this package must not reach into. Any drift there is a drift here,
    // and __tests__/mailSettingsCardShape.test.js holds the two together: the
    // solid `card` surface, `radiusCard`, inset B (A on a phone or a narrow
    // slot), no measure cap — the settings stack is the cap — and the row gap
    // B of the main-stack cards it sits among.
    flow: 'y',
    padding: 'B',
    round: 'radiusCard',
    theme: 'card',
    minWidth: '0',
    gap: 'B',
    '@mobileL': {
        padding: 'A'
    },
    '@appMobile': {
        padding: 'A'
    },
    // The scroll-nav of the account page matches this attribute against its own
    // entry; the value is an opaque KEY and never goes through polyglot (see the
    // page's `sections` factory).
    attr: {
        'data-content-section': 'Mail'
    },
    subscribeTo: [
        'mailAccounts',
        'mailSetup',
        'mailSettingsDraft',
        'mailSettingsBusy',
        'mailSettingsError'
    ],
    // The full account rows (sendAs, signature) come from `mail.accounts list`;
    // the gate's own summaries carry address + status only.
    onCreate: (el)=>{
        el.call('loadMailAccounts');
    },
    CardTitle: {
        tag: 'h2',
        margin: '0',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        text: '{{ mail.settings.title | polyglot }}'
    },
    CardHint: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        fontWeight: '400',
        lineHeight: '1.45',
        color: 'caption',
        text: '{{ mail.settings.description | polyglot }}'
    },
    // A failure of the LIST itself (`mail.accounts list` refused — a 5xx, an
    // expired session) carries `id: null`, because it belongs to no row. The
    // row renderer matches `err.id === s.id` and therefore showed nothing: the
    // card painted its title, its one-line hint and an empty space, and said
    // not one word about why it was empty. This is where an id-less failure is
    // read out loud.
    CardError: {
        ifDeps: [
            (el, s)=>s.root && s.root.mailSettingsError
        ],
        if: (el, s)=>{
            const err = s.root && s.root.mailSettingsError;
            return !!(err && err.id == null);
        },
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        fontWeight: '500',
        lineHeight: '1.45',
        color: 'dangerInk',
        textDeps: [
            (el, s)=>s.root && s.root.mailSettingsError
        ],
        text: (el, s)=>{
            const err = s.root && s.root.mailSettingsError;
            return err && err.message || el.call('polyglot', 'mail.settings.listFailed');
        }
    },
    AccountList: {
        hide: (el, s)=>!(s.root && s.root.mailAccounts || []).length,
        hideDeps: [
            (el, s)=>s.root && s.root.mailAccounts
        ],
        flow: 'y',
        // The distinctive name, never the collided one — see the component's own
        // header. A bare `MailAccountRow` here resolves to the SIDEBAR's row.
        childExtends: 'MailSettingsAccountRow',
        childrenAs: 'state',
        childrenDeps: [
            (el, s)=>s.root && s.root.mailAccounts
        ],
        children: (el, s)=>(s.root && s.root.mailAccounts || []).map((a)=>({
                    key: a && a.id,
                    ...a
                }))
    },
    // No mailbox yet → the same gate the /mail page and the drawer render, so
    // "connect another account" and "connect your first one" are one panel
    // (§3.4 "[Connect another account] → the same panel as the empty state").
    //
    // A mount-site `if:` REPLACES the base component's own gate, so the base's
    // `off` rule is restated here beside the card's own `ready` rule: with a
    // working mailbox this card is the account LIST, not a setup teacher.
    MailSetupPanel: {
        ifDeps: [
            (el, s)=>s.root && s.root.mailSetup
        ],
        if: (el, s)=>{
            const setup = s.root && s.root.mailSetup;
            if (!setup) return true;
            return setup.state !== 'off' && setup.state !== 'ready';
        },
        // The admin's TENANT instructions do not belong on a member's personal
        // settings page — they are six long cards about a domain-wide delegation,
        // and this card's job is "which mailboxes are mine". The panel's own
        // [Set up mail] button is the way there (it opens the admin surface), so
        // the steps stay on /mail where the app's own empty state teaches them.
        // Measured live 2026-09-05: with the steps mounted this card ran 1697px
        // tall inside a 744px track of otherwise short preference cards.
        SetupBody: {
            SetupSteps: {
                if: ()=>false
            }
        }
    }
};

});


parcelRegister("dpQZB", function(module, exports) {

$parcel$export(module.exports, "mailAiViews", () => (parcelRequire("gBN8h")).mailAiViews);
// Eager slim slice of the mail function barrel.
//
// Mail is a lazy sub-app (see components/eagerSlice.js): the /mail route and
// the header envelope fold the FULL mail context on demand. Only the
// functions non-mail surfaces reach BEFORE any fold stay here:
//   • toggleMailDrawer / openMailDrawer / closeMailDrawer — el.call'd by the
//     shell (the console fallback, future deep-links and toast actions) on
//     ANY route; opening ensures the fold itself, like chat's
//     openChatFromToast.
// Every OTHER mail function registers at fold time.
//
// Mail's state.js ALSO rides the eager entry in sharedLibraries.js — every
// `mail*` key and `_mailDrawerOpen` are declared ONLY there, and the header
// flips `_mailDrawerOpen` on any route (v3.14 trips on undeclared root keys).

var $f03bD = parcelRequire("f03bD");

var $jhlu3 = parcelRequire("jhlu3");

var $axqFA = parcelRequire("axqFA");

var $bW5HI = parcelRequire("bW5HI");

var $gtA8Z = parcelRequire("gtA8Z");

var $iMOuN = parcelRequire("iMOuN");

var $gBN8h = parcelRequire("gBN8h");
$parcel$exportWildcard(module.exports, $f03bD);
$parcel$exportWildcard(module.exports, $jhlu3);
$parcel$exportWildcard(module.exports, $axqFA);
$parcel$exportWildcard(module.exports, $bW5HI);
$parcel$exportWildcard(module.exports, $gtA8Z);
$parcel$exportWildcard(module.exports, $iMOuN);

});
parcelRegister("f03bD", function(module, exports) {

$parcel$export(module.exports, "openMailDrawer", () => $aeb953e5f723a6a8$export$9e00e1ed17471960);
$parcel$export(module.exports, "closeMailDrawer", () => $aeb953e5f723a6a8$export$36d7b42d033281ac);
$parcel$export(module.exports, "toggleMailDrawer", () => $aeb953e5f723a6a8$export$719b56e4762dd2d5);
// Mail drawer toggles — the el.call-addressable open/close/toggle of the
// docked MailOverlay, mirroring chat's collab/drawer.js
// (toggleChatDrawer / openChatDrawer / closeChatDrawer). They ride
// functions/eagerSlice.js so any route can call them BEFORE the mail context
// folds (like chat's openChatFromToast).
//
// The overlay itself lives in the lazily-folded mail context (the shell's
// MailOverlaySlot is filled by ensureMailContext — workspace/functions/
// mailFold.js), so OPENING asks the shell to fold first when a caller reaches
// these through `el.call` (`this` is the element). A bare `openMailDrawer(root)`
// call with no element flips the flag only, exactly like chat's helpers.
//
// Cross-overlay exclusion (closing the Messenger / notifications / assistant
// when Mail opens) is the header button's job through headerOverlayPatch —
// these only own the flag.
const $aeb953e5f723a6a8$var$_kickDrawerData = (el)=>{
    // Post-fold the full function barrel is registered; the drawer list needs
    // the stream + the unified-inbox first page (MAIL-UI-READ-1). Guarded: on
    // a pre-P1 registry (or a failed fold) the drawer still opens empty.
    if (!el || typeof el.call !== 'function') return;
    try {
        el.call('subscribeMailStream');
        el.call('loadMailThreads');
    } catch (_) {}
};
const $aeb953e5f723a6a8$export$9e00e1ed17471960 = async function(root) {
    const r = root || this && this.state && this.state.root;
    if (!r) return;
    if (this && typeof this.call === 'function') {
        const ok = await this.call('ensureMailContext');
        if (ok === false) return;
    }
    r.update({
        _mailDrawerOpen: true
    });
    $aeb953e5f723a6a8$var$_kickDrawerData(this);
};
const $aeb953e5f723a6a8$export$36d7b42d033281ac = function(root) {
    const r = root || this && this.state && this.state.root;
    if (!r) return;
    r.update({
        _mailDrawerOpen: false
    });
};
const $aeb953e5f723a6a8$export$719b56e4762dd2d5 = async function(root) {
    const r = root || this && this.state && this.state.root;
    if (!r) return;
    if (r._mailDrawerOpen) {
        r.update({
            _mailDrawerOpen: false
        });
        return;
    }
    if (this && typeof this.call === 'function') {
        const ok = await this.call('ensureMailContext');
        if (ok === false) return;
    }
    r.update({
        _mailDrawerOpen: true
    });
    $aeb953e5f723a6a8$var$_kickDrawerData(this);
};

});

parcelRegister("jhlu3", function(module, exports) {

$parcel$export(module.exports, "loadMailSetup", () => $e0904516369f3537$export$dbdda54f7d14dade);
$parcel$export(module.exports, "linkMailMailbox", () => $e0904516369f3537$export$610ac6ca5e8896a4);
$parcel$export(module.exports, "notifyMailAdmin", () => $e0904516369f3537$export$3cf558edeb4abb76);
$parcel$export(module.exports, "startMailConnect", () => $e0904516369f3537$export$f5c01102e5a48f04);
$parcel$export(module.exports, "openMailAdminSetup", () => $e0904516369f3537$export$60f12695e6adc310);
$parcel$export(module.exports, "copyMailSetupCode", () => $e0904516369f3537$export$336131456c93e7b6);
// The compose setup gate — architecture/MAIL.md §3.2a.
//
// One read (`mail.setup get`) and four actions drive MailSetupPanel on all
// three of its mount points: the /mail empty state, the header drawer and the
// /settings Mail card. The panel NEVER decides a state itself — the server
// answers one of off | ready | reauth | connect | link | ask-admin and the UI
// renders exactly that.
//
// Two contracts this file is written around, both verified against the shipped
// server (server/src/domains/mail):
//   • `providers[].steps` is served ONLY when `viewerIsAdmin`. An empty list on
//     a member is NORMAL — never an error, never an empty-looking panel.
//   • `POST /setup/link` answers 501 today and `POST /setup/notify-admin`
//     answers 429 once a viewer has already asked inside the 24 h window. Both
//     are REAL UI STATES here: the message the server sends is what the person
//     reads, never a swallowed console warning.
//
// The provider OAuth start (`POST /accounts/connect/:provider`) is NOT
// registered on the server yet — it lands with MAIL-SERVER-GOOGLE-PROVIDER-1
// — so `startMailConnect` says so in the panel instead of firing a request
// that would 404 and read as a server fault.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $4X1w3 = parcelRequire("4X1w3");
const $e0904516369f3537$export$dbdda54f7d14dade = async function(opts) {
    const root = opts && opts.root || this && this.state && this.state.root;
    if (!root) return null;
    if (root.mailSetupLoading) return root.mailSetup;
    const fresh = root.mailSetup && Date.now() - (root.mailSetup.__fetchedAt || 0) < 15000;
    if (fresh && !(opts && opts.force)) return root.mailSetup;
    // Captured BEFORE the await — see functions/sameWorkspaceWriter.js.
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    root.update({
        mailSetupLoading: true,
        mailSetupError: null
    });
    try {
        const data = await (0, $1NxyO.getSDK)().execute('mail.setup', 'get', workspaceId ? {
            workspaceId: workspaceId
        } : {});
        const payload = data && typeof data === 'object' ? data : null;
        // ⚠️ THE LOADING LATCH IS NOT TENANT DATA. When the tenancy guard drops
        // the write below (the workspace changed — or RESOLVED, boot-window —
        // between capture and reply), the DATA must drop but the latch must
        // still clear: a dropped `mailSetupLoading: false` left the flag true
        // for the whole session, and every later gate read short-circuited on
        // it — openMailCompose then taught setup forever with a null state
        // (measured live 2026-09-05, headless probe on /mail direct load).
        // Cleared via a direct root.update on purpose: `false` is the key's
        // reset value, identical for every tenant.
        // ⚠️ `mailAccounts` IS NOT WRITTEN HERE, and that is the point. The gate
        // answers §3.2a SUMMARIES — { id, address, kind, provider, status,
        // canSend } — while `mail.accounts list` answers the FULL rows the
        // /settings card renders (sendAs, signature, settings, folders). Both
        // used to write the same key, both fire on the settings card's mount, and
        // `disconnectMailAccount` re-read them in an order that let the summary
        // land last: every surviving row silently lost its send-as picker and its
        // signature field. ONE key, ONE writer — `loadMailAccounts`. The
        // summaries stay where they are already read from, inside `mailSetup`.
        const landed = write({
            mailSetup: payload ? {
                ...payload,
                __fetchedAt: Date.now()
            } : null,
            mailSetupLoading: false
        });
        if (!landed) {
            root.update({
                mailSetupLoading: false
            });
            // The drop above is usually the BOOT WINDOW: tenancy RESOLVED ('' → id)
            // between capture and reply, so the answer belonged to nobody and the
            // gate stayed null for the whole session — no surface retries it
            // (measured in the 2026-09-06 headless probe: direct /mail boot,
            // setup null / loading false / no error). ONE re-request against the
            // now-hydrated workspace; a second drop means a real mid-flight tenant
            // switch, and the next surface's own load owns that.
            if (!(opts && opts._hydrationRetry)) return $e0904516369f3537$export$dbdda54f7d14dade.call(this, {
                ...opts || {},
                root: root,
                force: true,
                _hydrationRetry: true
            });
        }
        return payload;
    } catch (err) {
        const landed = write({
            mailSetupLoading: false,
            mailSetupError: {
                code: err && err.cause && err.cause.code || null,
                message: err && err.message || ''
            }
        });
        if (!landed) root.update({
            mailSetupLoading: false
        });
        return null;
    }
};
const $e0904516369f3537$export$610ac6ca5e8896a4 = async function() {
    const root = this && this.state && this.state.root;
    if (!root || root.mailSetupBusy) return false;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    root.update({
        mailSetupBusy: 'link',
        mailSetupNotice: null
    });
    try {
        await (0, $1NxyO.getSDK)().execute('mail.setup', 'link', workspaceId ? {
            workspaceId: workspaceId
        } : {});
        write({
            mailSetupBusy: null,
            mailSetupNotice: {
                tone: 'success',
                key: 'mail.setup.link.linked'
            }
        });
        await this.call('loadMailSetup', {
            force: true
        });
        return true;
    } catch (err) {
        // The route's stable code + the values its sentence names ride on the
        // notice: a config error (the tenant's provider or the token vault the
        // platform runs without) then reads in the session language at render
        // time (functions/serverCopy.js); any other refusal keeps its sentence.
        const { code: code, params: params } = this.call('mailErrorOf', err) || {};
        write({
            mailSetupBusy: null,
            mailSetupNotice: {
                // 501 is the pending contract, not a fault — it reads as information.
                tone: err && err.status === 501 ? 'info' : 'error',
                key: err && err.status === 501 ? 'mail.setup.link.pending' : 'mail.setup.link.failed',
                message: err && err.message || '',
                code: code || '',
                params: params || null
            }
        });
        return false;
    }
};
const $e0904516369f3537$export$3cf558edeb4abb76 = async function() {
    const root = this && this.state && this.state.root;
    if (!root || root.mailSetupBusy) return false;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    root.update({
        mailSetupBusy: 'notifyAdmin',
        mailSetupNotice: null
    });
    try {
        await (0, $1NxyO.getSDK)().execute('mail.setup', 'notifyAdmin', workspaceId ? {
            workspaceId: workspaceId
        } : {});
        write({
            mailSetupBusy: null,
            mailSetupNotice: {
                tone: 'success',
                key: 'mail.setup.askAdmin.notified'
            }
        });
        return true;
    } catch (err) {
        const status = err && err.status;
        write({
            mailSetupBusy: null,
            mailSetupNotice: {
                tone: status === 429 || status === 409 ? 'info' : 'error',
                key: status === 429 ? 'mail.setup.askAdmin.already' : status === 409 ? 'mail.setup.askAdmin.youAreAdmin' : 'mail.setup.askAdmin.failed',
                message: status === 429 ? '' : err && err.message || ''
            }
        });
        return false;
    }
};
const $e0904516369f3537$export$f5c01102e5a48f04 = async function(provider) {
    const root = this && this.state && this.state.root;
    if (!root) return false;
    root.update({
        mailSetupBusy: null,
        mailSetupNotice: {
            tone: 'info',
            key: 'mail.setup.connect.pending',
            provider: provider || ''
        }
    });
    return false;
};
const $e0904516369f3537$export$60f12695e6adc310 = function() {
    const pages = this && this.context && this.context.pages || {};
    const route = pages['/admin/mail'] ? '/admin/mail' : '/admin/integrations';
    const root = this && this.state && this.state.root;
    if (root && root._mailDrawerOpen) root.update({
        _mailDrawerOpen: false
    });
    this.call('openAppPage', route);
    return route;
};
const $e0904516369f3537$export$336131456c93e7b6 = async function(code) {
    const text = String(code || '');
    if (!text) return false;
    try {
        if (typeof navigator === 'undefined' || !navigator.clipboard) throw new Error('no clipboard');
        await navigator.clipboard.writeText(text);
        this.call('openNotification', {
            type: 'success',
            title: this.call('polyglot', 'mail.setup.step.copied')
        });
        return true;
    } catch (err) {
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'mail.setup.step.copyFailed')
        });
        return false;
    }
};

});
parcelRegister("4X1w3", function(module, exports) {

$parcel$export(module.exports, "mailWorkspaceId", () => $39add92841a6bd60$export$3e3150c500dc543b);
$parcel$export(module.exports, "mailSameWorkspaceWriter", () => $39add92841a6bd60$export$44daccbb95926094);
// MAIL-LATE-WRITES-NO-TENANT-GUARD — the mail package's copy of the canonical
// "drop a reply that outlived its tenant" writer (chat/functions/
// sameWorkspaceWriter.js, tickets/functions/, workspace/functions/).
//
// WHY MAIL NEEDS ONE. Registering a key as workspace-scoped (the shell's
// state-app.js) wipes it ON the switch. It cannot stop a request ISSUED in
// workspace A from writing its reply into workspace B afterwards. Every setup
// read and every account write in this package writes a workspace-scoped key
// AFTER an `await`: a slow `mail.setup get` in Acme would otherwise paint
// Acme's providers, policy and mailbox addresses inside the workspace the
// person switched to.
//
// DROPPING is right rather than rerouting or retrying: the payload describes a
// workspace the user is no longer looking at, and PHASE-1 of the switch has
// already restored the correct empty for the one they are.
//
// CAPTURE BEFORE THE AWAIT. `sameWorkspaceWriter(root)` must be called on the
// SAME tick as the request, before the first `await` — it snapshots the
// workspace id at call time. Calling it inside the `.then()` snapshots the NEW
// workspace and the guard can never fire.
//
// A SUB-APP MUST NOT IMPORT THE SHELL, which is why this is a fourth copy
// rather than a re-export. Consumers inside this package import THIS module —
// never re-inline it.
// Both id shapes are live on root: `workspace.id` from the SDK's workspace
// payload and `workspace._id` from the raw Mongo document. Stringified so a
// numeric id and its string form never read as two different tenants.
const $39add92841a6bd60$export$3e3150c500dc543b = (root)=>String(root?.workspace?.id || root?.workspace?._id || '');
const $39add92841a6bd60$export$44daccbb95926094 = (root)=>{
    const issuedFor = String(root?.workspace?.id || root?.workspace?._id || '');
    return (patch)=>{
        if (String(root?.workspace?.id || root?.workspace?._id || '') !== issuedFor) return false;
        root.update(patch);
        return true;
    };
};

});


parcelRegister("axqFA", function(module, exports) {

$parcel$export(module.exports, "loadMailAccounts", () => $7ac1ac7ce0af110e$export$fcc548c63bec4fc7);
$parcel$export(module.exports, "setMailAccountDraft", () => $7ac1ac7ce0af110e$export$128dbd00d1892fe8);
$parcel$export(module.exports, "saveMailAccountSettings", () => $7ac1ac7ce0af110e$export$52e835bcf9de5fbe);
$parcel$export(module.exports, "disconnectMailAccount", () => $7ac1ac7ce0af110e$export$4635f30e2026d206);
$parcel$export(module.exports, "reconnectMailAccount", () => $7ac1ac7ce0af110e$export$6b6918816c64b6d8);
// The /settings Mail card's data plane — architecture/MAIL.md §3.4.
//
// `mail.accounts` is the MEMBER surface: list / get / update / remove, ACL'd
// per row, never a token. `remove` is the DISCONNECT — the server tombstones
// the row (status 'disabled') and purges the local mirror behind it, so it
// asks first (disconnectMailAccount below says what goes).
//
// A row the viewer cannot reach answers 404, never 403, so ids cannot be
// probed (§5.11). A 404 from update/remove therefore means "not visible to
// you", not "already gone" — it is surfaced as the server's own message.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $4X1w3 = parcelRequire("4X1w3");

var $kFsAF = parcelRequire("kFsAF");
const $7ac1ac7ce0af110e$export$fcc548c63bec4fc7 = async function(opts) {
    const root = opts && opts.root || this && this.state && this.state.root;
    if (!root) return null;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    try {
        const rows = await (0, $1NxyO.getSDK)().execute('mail.accounts', 'list', workspaceId ? {
            workspaceId: workspaceId
        } : {});
        const list = Array.isArray(rows) ? rows : Array.isArray(rows && rows.data) ? rows.data : [];
        // The account set is HALF the badge sum, and this read is the write that
        // can shrink it: a revoked shared-inbox grant drops the row here while the
        // stream's stale count entry survives. Re-derive `navUnreadCounts.mail` in
        // the same patch so the header dot goes out with the grant (§3.6).
        write((0, $kFsAF.withMailNavUnread)(root, {
            mailAccounts: list
        }));
        return list;
    } catch (err) {
        // `id: null` on purpose — the failure belongs to the LIST, not to a row.
        // The card renders it at card level (SettingsCard `CardError`); the row
        // renderer matches `err.id === s.id` and would have shown nothing at all,
        // leaving a 5xx as an empty card with no words in it.
        write({
            mailSettingsError: {
                id: null,
                message: err && err.message || ''
            }
        });
        return null;
    }
};
const $7ac1ac7ce0af110e$export$128dbd00d1892fe8 = function(id, patch) {
    const root = this && this.state && this.state.root;
    if (!root || !id) return;
    const drafts = root.mailSettingsDraft || {};
    root.update({
        mailSettingsDraft: {
            ...drafts,
            [id]: {
                ...drafts[id] || {},
                ...patch || {}
            }
        }
    });
};
const $7ac1ac7ce0af110e$export$52e835bcf9de5fbe = async function(id) {
    const root = this && this.state && this.state.root;
    if (!root || !id || root.mailSettingsBusy) return false;
    const draft = (root.mailSettingsDraft || {})[id];
    if (!draft || !Object.keys(draft).length) return false;
    const payload = {};
    if (typeof draft.signature === 'string') payload.signature = {
        text: draft.signature
    };
    if (typeof draft.defaultSendAs === 'string' && draft.defaultSendAs) payload.defaultSendAs = draft.defaultSendAs;
    if (typeof draft.displayName === 'string') payload.displayName = draft.displayName;
    if (!Object.keys(payload).length) return false;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    root.update({
        mailSettingsBusy: {
            id: id,
            op: 'save'
        },
        mailSettingsError: null
    });
    try {
        await (0, $1NxyO.getSDK)().execute('mail.accounts', 'update', {
            id: id,
            payload: payload,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const drafts = {
            ...root.mailSettingsDraft || {}
        };
        delete drafts[id];
        write({
            mailSettingsBusy: null,
            mailSettingsDraft: drafts
        });
        await this.call('loadMailAccounts');
        this.call('openNotification', {
            type: 'success',
            title: this.call('polyglot', 'mail.settings.saved')
        });
        return true;
    } catch (err) {
        write({
            mailSettingsBusy: null,
            mailSettingsError: {
                id: id,
                message: err && err.message || ''
            }
        });
        return false;
    }
};
const $7ac1ac7ce0af110e$export$4635f30e2026d206 = function(id) {
    const root = this && this.state && this.state.root;
    if (!root || !id || root.mailSettingsBusy) return Promise.resolve(false);
    const row = (root.mailAccounts || []).find((a)=>a && a.id === id) || {};
    const address = row.address || '';
    const t = (key)=>this.call('polyglot', key);
    return new Promise((resolve)=>{
        this.call('confirmDialog', {
            title: t(row.simulated ? 'mail.confirm.disconnectDemo.title' : 'mail.confirm.disconnect.title').replace('{address}', ()=>address),
            message: t(row.simulated ? 'mail.confirm.disconnectDemo.message' : 'mail.confirm.disconnect.message'),
            confirmText: t(row.simulated ? 'common.action.delete' : 'mail.settings.action.disconnect'),
            cancelText: t('common.action.cancel'),
            confirmTheme: 'primary',
            icon: null,
            onConfirm: ()=>resolve($7ac1ac7ce0af110e$var$_disconnectMailAccountNow.call(this, root, id)),
            onCancel: ()=>resolve(false)
        });
    });
};
const $7ac1ac7ce0af110e$var$_disconnectMailAccountNow = async function(root, id) {
    if (root.mailSettingsBusy) return false;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    root.update({
        mailSettingsBusy: {
            id: id,
            op: 'remove'
        },
        mailSettingsError: null
    });
    try {
        await (0, $1NxyO.getSDK)().execute('mail.accounts', 'remove', {
            id: id,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        write({
            mailSettingsBusy: null
        });
        await this.call('loadMailAccounts');
        await this.call('loadMailSetup', {
            force: true
        });
        this.call('openNotification', {
            type: 'success',
            title: this.call('polyglot', 'mail.settings.disconnected')
        });
        return true;
    } catch (err) {
        write({
            mailSettingsBusy: null,
            mailSettingsError: {
                id: id,
                message: err && err.message || ''
            }
        });
        return false;
    }
};
const $7ac1ac7ce0af110e$export$6b6918816c64b6d8 = async function(id) {
    const root = this && this.state && this.state.root;
    if (!root || !id) return false;
    const account = (root.mailAccounts || []).find((a)=>a && a.id === id);
    const started = await this.call('startMailConnect', account && account.provider || '');
    if (started !== true) {
        const notice = root.mailSetupNotice || {};
        this.call('openNotification', {
            type: 'info',
            title: this.call('polyglot', 'mail.settings.action.reconnect'),
            message: this.call('polyglot', notice.key || 'mail.setup.connect.pending')
        });
    }
    return started;
};

});

parcelRegister("bW5HI", function(module, exports) {

$parcel$export(module.exports, "mailSetupStepTitle", () => $8b09892ff3c612d4$export$c58eb32f2119a722);
$parcel$export(module.exports, "mailSetupStepBody", () => $8b09892ff3c612d4$export$f9e2cfef2901e5a8);
$parcel$export(module.exports, "mailErrorOf", () => $8b09892ff3c612d4$export$8cb59ccbf0f8b641);
$parcel$export(module.exports, "mailErrorText", () => $8b09892ff3c612d4$export$8826311a327cb62d);
$parcel$export(module.exports, "mailAdminRowError", () => $8b09892ff3c612d4$export$16adda1e25d0d21c);
// Server codes → the mail bundle (CORE-MAIL-SETUP-STEPS-AND-ERRORS-NEED-I18N-CODES-1).
//
// The API serves the admin setup steps and the operator-configuration errors
// as customer-safe ENGLISH (server content/setupSteps.js, configErrors.js) —
// and, beside each sentence, a stable code plus `params`, the values that
// sentence names. A Georgian workspace read that English on /admin/mail; the
// code is what it translates by now:
//
//   a step    { id, title, body, bodyCode, params?, code? }
//             `id` names the title, `bodyCode` the exact body sentence,
//             `params` fill its holes; `code` is the copyable line (a scope
//             list, a URL, a command) and is never translated.
//   an error  the route answers { error: <code>, message, params? } and the
//             SDK throws it with that body on `err.cause`; a health row
//             carries sync.lastErrorCode + sync.lastErrorParams beside the
//             stored sync.lastError.
//
// The server's English is the fallback, never an error: a code this bundle
// does not know (a newer server), no code at all (an older one), a key that
// does not resolve (polyglot echoes a missing key) and a hole the params leave
// unfilled all paint the English as it arrived.
//
// LITERAL key maps — the i18n two-way gate (i18nMailKeys.test.js) extracts
// string literals, so a key built from a code would read as an unused bundle
// key (the MAIL_INVITE_STATUS_KEYS idiom in integrations.js).
const $8b09892ff3c612d4$var$MAIL_SETUP_STEP_TITLE_KEYS = {
    google_connect: 'mail.setup.googleConnect.title',
    google_delegation: 'mail.setup.googleDelegation.title',
    google_test: 'mail.setup.googleTest.title',
    microsoft_consent: 'mail.setup.microsoftConsent.title',
    microsoft_policy: 'mail.setup.microsoftPolicy.title',
    microsoft_test: 'mail.setup.microsoftTest.title'
};
const $8b09892ff3c612d4$var$MAIL_SETUP_STEP_BODY_KEYS = {
    google_connect_instructions: 'mail.setup.googleConnect.instructions',
    google_connect_connected: 'mail.setup.googleConnect.connected',
    google_connect_connected_domain: 'mail.setup.googleConnect.connectedDomain',
    google_delegation_instructions: 'mail.setup.googleDelegation.instructions',
    google_delegation_scopes_missing: 'mail.setup.googleDelegation.scopesMissing',
    google_test_instructions: 'mail.setup.googleTest.instructions',
    microsoft_consent_instructions: 'mail.setup.microsoftConsent.instructions',
    microsoft_consent_app_missing: 'mail.setup.microsoftConsent.appMissing',
    microsoft_consent_connected: 'mail.setup.microsoftConsent.connected',
    microsoft_policy_instructions: 'mail.setup.microsoftPolicy.instructions',
    microsoft_policy_app_missing: 'mail.setup.microsoftPolicy.appMissing',
    microsoft_test_instructions: 'mail.setup.microsoftTest.instructions'
};
const $8b09892ff3c612d4$var$MAIL_CONFIG_ERROR_KEYS = {
    provider_not_configured: 'mail.error.providerNotConfigured',
    token_vault_not_configured: 'mail.error.tokenVaultNotConfigured',
    signing_not_configured: 'mail.error.signingNotConfigured',
    push_not_configured: 'mail.error.pushNotConfigured'
};
// provider_not_configured names the provider when the server knows it
// (`params.provider`) and says "this mail provider" when it does not — two
// sentences for one code, so the second one has its own key.
const $8b09892ff3c612d4$var$MAIL_CONFIG_ERROR_UNNAMED_KEYS = {
    provider_not_configured: 'mail.error.providerNotConfiguredGeneric'
};
// One bundle sentence with its `{holes}` filled from `params`, or '' when the
// key does not resolve or a hole has no value — the caller then paints the
// server's English, so a raw `{hole}` never reaches the screen.
const $8b09892ff3c612d4$var$_mailServerCopy = (el, key, params)=>{
    if (!key || !el || typeof el.call !== 'function') return '';
    const raw = el.call('polyglot', key);
    if (typeof raw !== 'string' || !raw || raw === key) return '';
    let unfilled = false;
    const text = raw.replace(/\{(\w+)\}/g, (hole, name)=>{
        const value = params && params[name];
        if (value == null || value === '') {
            unfilled = true;
            return hole;
        }
        return String(value);
    });
    return unfilled ? '' : text;
};
const $8b09892ff3c612d4$export$c58eb32f2119a722 = function(step) {
    const s = step || {};
    const title = $8b09892ff3c612d4$var$_mailServerCopy(this, $8b09892ff3c612d4$var$MAIL_SETUP_STEP_TITLE_KEYS[s.id]) || s.title || '';
    return s.label ? `${s.label} \xb7 ${title}` : title;
};
const $8b09892ff3c612d4$export$f9e2cfef2901e5a8 = function(step) {
    const s = step || {};
    return $8b09892ff3c612d4$var$_mailServerCopy(this, $8b09892ff3c612d4$var$MAIL_SETUP_STEP_BODY_KEYS[s.bodyCode], s.params) || s.body || '';
};
const $8b09892ff3c612d4$export$8cb59ccbf0f8b641 = function(source) {
    const src = source || {};
    const body = src.cause && typeof src.cause === 'object' ? src.cause : null;
    const code = body && typeof body.error === 'string' && body.error || typeof src.code === 'string' && src.code || '';
    const params = body && body.params || src.params;
    return {
        code: code,
        params: params && typeof params === 'object' ? params : null,
        message: typeof src.message === 'string' ? src.message : ''
    };
};
const $8b09892ff3c612d4$export$8826311a327cb62d = function(source) {
    const { code: code, params: params, message: message } = $8b09892ff3c612d4$export$8cb59ccbf0f8b641(source);
    const named = !!(params && params.provider);
    const key = !named && $8b09892ff3c612d4$var$MAIL_CONFIG_ERROR_UNNAMED_KEYS[code] || $8b09892ff3c612d4$var$MAIL_CONFIG_ERROR_KEYS[code];
    return $8b09892ff3c612d4$var$_mailServerCopy(this, key, params) || message;
};
const $8b09892ff3c612d4$export$16adda1e25d0d21c = function(row) {
    const r = row || {};
    const sync = r.sync || {};
    if (sync.lastError) return $8b09892ff3c612d4$export$8826311a327cb62d.call(this, {
        code: sync.lastErrorCode,
        params: sync.lastErrorParams,
        message: sync.lastError
    });
    if (r.lastAuthError) return $8b09892ff3c612d4$export$8826311a327cb62d.call(this, {
        code: r.lastAuthError,
        message: r.lastAuthError
    });
    return '';
};

});

parcelRegister("gtA8Z", function(module, exports) {

$parcel$export(module.exports, "applyMailStreamEvent", () => $bfeb643d664c635e$export$8db33b662b17c7b4);
$parcel$export(module.exports, "applyMailStreamThreadUpsert", () => $bfeb643d664c635e$export$702299dd7f7612d4);
$parcel$export(module.exports, "subscribeMailStream", () => $bfeb643d664c635e$export$fc592750924e98e);
// Mail realtime — the ONE multiplexed SSE stream (GET /core/mail/stream,
// MAIL-SERVER-STREAM-RELAY-1), the house shape of chat's subscribeRealtime:
// app-lifetime handle on `root._mailStream`, workspace-keyed (reused while
// the tenant matches, closed + reopened on drift), NEVER closed by the /mail
// page — the header drawer and the unread counts need it on every route.
//
// Server frames (sdk MailService.subscribeStream): `mail.snapshot`
// { accounts, unread } on open, then `mail.thread.upsert|delete`,
// `mail.account.status|progress`, `mail.outbox.sent|failed`, `mail.unread`
// — each the producer's REST-shaped row with { accountId, workspaceId }
// merged on top.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $4X1w3 = parcelRequire("4X1w3");

var $kFsAF = parcelRequire("kFsAF");
const $bfeb643d664c635e$var$_unreadPatch = (root, rows)=>{
    const counts = {
        ...root.mailUnreadCounts || {}
    };
    const list = Array.isArray(rows) ? rows : rows ? [
        rows
    ] : [];
    for (const r of list)if (r && r.accountId !== undefined) counts[String(r.accountId)] = Number(r.n || r.unread || 0);
    return counts;
};
const $bfeb643d664c635e$var$_patchAccount = (root, accountId, patch)=>{
    const id = accountId ? String(accountId) : null;
    if (!id) return null;
    const list = root.mailAccounts || [];
    const at = list.findIndex((a)=>a && String(a.id) === id);
    if (at === -1) return null;
    const copy = [
        ...list
    ];
    copy[at] = {
        ...copy[at],
        ...patch
    };
    return copy;
};
const $bfeb643d664c635e$export$8db33b662b17c7b4 = function(root, ev) {
    if (!root || !ev || !ev.type) return;
    const type = ev.type;
    if (type === 'mail.snapshot') {
        const patch = {
            mailUnreadCounts: $bfeb643d664c635e$var$_unreadPatch(root, ev.unread)
        };
        // The snapshot's accounts are listAccounts' own rows (ACL-filtered). The
        // /settings card may hold a fresher full read; the snapshot still wins on
        // boot because it is the first producer to run.
        if (Array.isArray(ev.accounts)) patch.mailAccounts = ev.accounts;
        root.update((0, $kFsAF.withMailNavUnread)(root, patch));
        return;
    }
    if (type === 'mail.thread.upsert') {
        const next = (0, $kFsAF.applyMailThreadUpsert)(root.mailThreads, ev.thread || ev.row || ev);
        if (next !== root.mailThreads) root.update({
            mailThreads: next
        });
        return;
    }
    if (type === 'mail.thread.delete') {
        const id = ev.id || ev.threadId || ev.thread && (ev.thread.id || ev.thread._id);
        const next = (0, $kFsAF.applyMailThreadDelete)(root.mailThreads, id);
        const patch = {};
        if (next !== root.mailThreads) patch.mailThreads = next;
        if (id && root.mailActiveThreadId === String(id)) patch.mailActiveThreadId = null;
        if (Object.keys(patch).length) root.update(patch);
        return;
    }
    if (type === 'mail.account.status') {
        const accounts = $bfeb643d664c635e$var$_patchAccount(root, ev.accountId, {
            status: ev.status || ev.account && ev.account.status,
            sync: ev.sync || ev.account && ev.account.sync
        });
        if (accounts) root.update({
            mailAccounts: accounts
        });
        return;
    }
    if (type === 'mail.account.progress') {
        const list = root.mailAccounts || [];
        const at = list.findIndex((a)=>a && String(a.id) === String(ev.accountId));
        if (at === -1) return;
        const copy = [
            ...list
        ];
        copy[at] = {
            ...copy[at],
            sync: {
                ...copy[at].sync || {},
                ...ev.sync || {},
                progress: ev.progress ?? (ev.sync && ev.sync.progress)
            }
        };
        root.update({
            mailAccounts: copy
        });
        return;
    }
    if (type === 'mail.unread') {
        root.update((0, $kFsAF.withMailNavUnread)(root, {
            mailUnreadCounts: $bfeb643d664c635e$var$_unreadPatch(root, ev.counts || ev.unread || ev)
        }));
        return;
    }
    if (type === 'mail.outbox.sent' || type === 'mail.outbox.failed') {
        const row = ev.outbox || ev.row || null;
        const id = row && (row.id || row._id);
        if (!id) return;
        const list = root.mailOutbox || [];
        const at = list.findIndex((o)=>o && String(o.id || o._id) === String(id));
        const copy = [
            ...list
        ];
        if (at === -1) copy.unshift(row);
        else copy[at] = {
            ...copy[at],
            ...row
        };
        root.update({
            mailOutbox: copy
        });
    }
};
const $bfeb643d664c635e$export$702299dd7f7612d4 = function(row) {
    const root = this && this.state && this.state.root;
    if (!root || !row) return;
    const next = (0, $kFsAF.applyMailThreadUpsert)(root.mailThreads, row);
    if (next !== root.mailThreads) root.update({
        mailThreads: next
    });
};
const $bfeb643d664c635e$export$fc592750924e98e = async function() {
    const root = this && this.state && this.state.root;
    if (!root) return null;
    const wsId = (0, $4X1w3.mailWorkspaceId)(root);
    const existing = root._mailStream;
    if (existing) {
        if (existing._wsId === wsId) return existing;
        try {
            existing.unsubscribe?.();
        } catch (_) {}
        root.update({
            _mailStream: null
        });
    }
    // CLAIM THE SLOT BEFORE THE FIRST AWAIT. `getService` suspends (see below),
    // and the page mount (pages/index.js `_initMailPage`) and the drawer
    // (functions/drawer.js `_kickDrawerData`) both call this in one tick: two
    // callers would otherwise pass the check above, open two EventSources, and
    // leave the second one unreachable for ever, because `_mailStream` holds
    // one handle. The unsubscribe is DEFERRED into the handle — it closes the
    // transport whenever it lands, the shape chat's `_openChatSse` uses. Every
    // failure branch RELEASES the slot, so a later call still retries.
    //
    // KEY THE SLOT BY `_wsId`, NEVER BY OBJECT IDENTITY. `root.update` stores a
    // DEEP COPY of a plain object and keeps only function properties by
    // reference (measured live in the shell, v3.14: `s.update({ x: o });
    // s.x === o` is `false`, `s.x.fn === o.fn` is `true`). So
    // `root._mailStream === handle` is false the instant it is written, and an
    // identity guard would drop every frame and never release the slot.
    let unsubscribe = null;
    let cancelled = false;
    const handle = {
        _wsId: wsId,
        unsubscribe: ()=>{
            cancelled = true;
            try {
                if (typeof unsubscribe === 'function') unsubscribe();
            } catch (_) {}
            unsubscribe = null;
        }
    };
    const held = ()=>{
        const cur = root._mailStream;
        return !!cur && cur._wsId === wsId;
    };
    const release = ()=>{
        if (held()) root.update({
            _mailStream: null
        });
    };
    root.update({
        _mailStream: handle
    });
    try {
        // `getSDK()` hands back the shell's init-await Proxy (packages/shared/
        // functions/sdkClient.js `wrapWithInitAwait`): every function property is
        // rewritten to `(...args) => initPromise.then(() => value.apply(...))`,
        // and `getService` is NOT in that wrapper's SYNC_PASS set. So
        // `getService('mail')` answers a PROMISE, and a bare
        // `typeof svc.subscribeStream` reads `undefined` on it FOREVER — the
        // guard below returned null on every call and the stream never opened
        // (measured on /mail: no `GET /core/mail/stream` request, no toast, no
        // console line, while `await sdk.getService('mail')` resolved to the real
        // MailService carrying subscribeStream). Awaiting is correct under BOTH
        // shapes — `await` on a plain value returns it — so this stays right if
        // the wrapper ever passes `getService` through SYNC_PASS.
        const sdk = (0, $1NxyO.getSDK)();
        const svc = sdk && typeof sdk.getService === 'function' ? await sdk.getService('mail') : null;
        if (!svc || typeof svc.subscribeStream !== 'function') {
            release();
            return null;
        }
        const unsub = svc.subscribeStream({
            workspaceId: wsId || undefined
        }, (ev)=>{
            // Tenant guard: a frame from a previous workspace's stream (closed a
            // tick late) must never write into the new tenant's slices. A re-key
            // replaces the slot's `_wsId`, a close nulls the slot — both stop the
            // late frame here.
            if (!held()) return;
            $bfeb643d664c635e$export$8db33b662b17c7b4(root, ev);
        });
        if (cancelled) try {
            unsub?.();
        } catch (_) {}
        else unsubscribe = typeof unsub === 'function' ? unsub : null;
    } catch (err) {
        console.warn('[mail-rt] SSE subscribe failed:', err && err.message || err);
        release();
        return null;
    }
    return handle;
};

});

parcelRegister("iMOuN", function(module, exports) {

$parcel$export(module.exports, "registerMailComposerEditor", () => $dad3e117027ddad9$export$bd3fedda0c33fcdd);
$parcel$export(module.exports, "unregisterMailComposerEditor", () => $dad3e117027ddad9$export$6bcbfaccc5be7360);
$parcel$export(module.exports, "registerMailComposeDock", () => $dad3e117027ddad9$export$d8c6721488d57b4d);
$parcel$export(module.exports, "unregisterMailComposeDock", () => $dad3e117027ddad9$export$cdadea63c1f4693c);
$parcel$export(module.exports, "mailAddress", () => $dad3e117027ddad9$export$991c8cfe3fb90b7b);
$parcel$export(module.exports, "mailAddressList", () => $dad3e117027ddad9$export$49dba393d6bbfa69);
$parcel$export(module.exports, "isMailAddress", () => $dad3e117027ddad9$export$b7a491b69cf952b);
$parcel$export(module.exports, "normalizeMailDraft", () => $dad3e117027ddad9$export$a840e9e8a0f6bb95);
$parcel$export(module.exports, "mailTextToHtml", () => $dad3e117027ddad9$export$52e2359d43459c9f);
$parcel$export(module.exports, "parseMailtoHref", () => $dad3e117027ddad9$export$a4f14ae2c81f47a0);
$parcel$export(module.exports, "buildMailReplyDraft", () => $dad3e117027ddad9$export$1e7a73719bac0abd);
$parcel$export(module.exports, "composeSeedHtml", () => $dad3e117027ddad9$export$7954288041957203);
$parcel$export(module.exports, "mailRecipientMatches", () => $dad3e117027ddad9$export$ec88e673832e374d);
$parcel$export(module.exports, "pickMailComposeAccount", () => $dad3e117027ddad9$export$b0777017cafd266e);
$parcel$export(module.exports, "flushMailComposeHtml", () => $dad3e117027ddad9$export$6eae761ba2c9d17e);
$parcel$export(module.exports, "mailComposePatch", () => $dad3e117027ddad9$export$7d4fa34f95eb83e3);
$parcel$export(module.exports, "saveMailDraft", () => $dad3e117027ddad9$export$92f7a30784bad3dc);
$parcel$export(module.exports, "mailComposeTouch", () => $dad3e117027ddad9$export$37c7a7114f81703e);
$parcel$export(module.exports, "mailComposeSetAccount", () => $dad3e117027ddad9$export$7ddcec3ac6758946);
$parcel$export(module.exports, "openMailCompose", () => $dad3e117027ddad9$export$6c53c52b3814d951);
$parcel$export(module.exports, "openMailComposeFromMailto", () => $dad3e117027ddad9$export$b22c481001c51a73);
$parcel$export(module.exports, "aiMailDraftReply", () => $dad3e117027ddad9$export$c1ccf71a96f7b233);
$parcel$export(module.exports, "closeMailCompose", () => $dad3e117027ddad9$export$e9731667f3215e5a);
$parcel$export(module.exports, "discardMailCompose", () => $dad3e117027ddad9$export$b0e0523da80f8f3d);
$parcel$export(module.exports, "sendMailCompose", () => $dad3e117027ddad9$export$a8ccaa666c1684de);
$parcel$export(module.exports, "undoMailSend", () => $dad3e117027ddad9$export$8d5d232b5b8838b8);
$parcel$export(module.exports, "replyToMailMessage", () => $dad3e117027ddad9$export$926434f974fcb310);
$parcel$export(module.exports, "replyAllToMailMessage", () => $dad3e117027ddad9$export$4d2acaa65280b14b);
$parcel$export(module.exports, "forwardMailMessage", () => $dad3e117027ddad9$export$dbeeb59243aee4b5);
$parcel$export(module.exports, "setMailRecipientQuery", () => $dad3e117027ddad9$export$6a4b717fab2740eb);
$parcel$export(module.exports, "addMailRecipient", () => $dad3e117027ddad9$export$d030ac74201796a2);
$parcel$export(module.exports, "removeMailRecipient", () => $dad3e117027ddad9$export$4846d7377692c834);
// The compose lifecycle — architecture/MAIL.md §3.2 + §3.2a.
//
// ONE draft slot. `root.mailComposeDraft` is the composer's working copy; the
// server `MailDraft` row (created by the 2 s autosave) is its durable twin,
// and `sessionStorage` mirrors the slot per workspace so the draft survives a
// same-tab OAuth round trip and an accidental reload (§3.2a "a draft started
// before setup is never lost"). There is no server draft LIST route (§5.7 —
// "the composer holds its draft"), so the slot + the mirror ARE the recovery
// path until provider draft mirroring lands (P2).
//
// Entry is exactly one function, `openMailCompose(draft?)` (§3.2a): the
// sidebar Compose, the drawer Compose, the person card Email action, the
// mailto: interception, the assistant tool and the `c` shortcut all call it,
// and the SERVER's setup state decides what opens — the dock only in `ready`,
// MailSetupPanel everywhere else. This file rides functions/eagerSlice.js
// because five of those six callers fire on routes where the mail context has
// not folded yet.
//
// Body html lives in the contenteditable DOM while the person types (the
// ChatComposer idiom — state-invisible content), and is flushed into the
// draft on the autosave tick, on close, and before send. The editor node
// registers itself here (registerMailComposerEditor) the way chat's
// registerComposerEditor does.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $4X1w3 = parcelRequire("4X1w3");

var $5iARt = parcelRequire("5iARt");

var $4ixcF = parcelRequire("4ixcF");
// §3.2: "Drafts autosave locally every 2 s (debounced) to MailDraft".
const $dad3e117027ddad9$var$MAIL_AUTOSAVE_MS = 2000;
// ── module state (bundler-scoped, same class as chat's activeMentionEditor) ──
// The live contenteditable node, one composer at a time.
let $dad3e117027ddad9$var$_mailEditorNode = null;
// The autosave debounce. The saves themselves SERIALISE on the compose write
// queue (./composeChain.js) so a create can never race a second create, and
// no keep-list update can interleave an attachment upload.
let $dad3e117027ddad9$var$_autosaveTimer = null;
const $dad3e117027ddad9$export$bd3fedda0c33fcdd = function(node) {
    $dad3e117027ddad9$var$_mailEditorNode = node || null;
};
const $dad3e117027ddad9$export$6bcbfaccc5be7360 = function(node) {
    if ($dad3e117027ddad9$var$_mailEditorNode === node) $dad3e117027ddad9$var$_mailEditorNode = null;
};
// Live MailComposeDock mounts (the dock registers on create, like the editor
// above). `openMailCompose` navigates to /mail ONLY when no dock is mounted:
// forcing `openAppPage('/mail', { preferSlot })` while the full-page /mail
// route is up opened a SECOND /mail inside the PageSlot — two docks over one
// draft (measured live, headless probe 2026-09-05). A mounted-but-hidden
// dock counts: `mailComposeOpen` unhides it right where it is.
let $dad3e117027ddad9$var$_mailDockCount = 0;
const $dad3e117027ddad9$export$d8c6721488d57b4d = function() {
    $dad3e117027ddad9$var$_mailDockCount += 1;
};
const $dad3e117027ddad9$export$cdadea63c1f4693c = function() {
    $dad3e117027ddad9$var$_mailDockCount = Math.max(0, $dad3e117027ddad9$var$_mailDockCount - 1);
};
const $dad3e117027ddad9$export$991c8cfe3fb90b7b = function(input) {
    if (!input) return null;
    if (typeof input === 'string') {
        const email = input.trim();
        return email ? {
            name: '',
            email: email
        } : null;
    }
    const email = String(input.email || input.address || '').trim();
    if (!email) return null;
    return {
        name: String(input.name || ''),
        email: email
    };
};
const $dad3e117027ddad9$export$49dba393d6bbfa69 = function(input) {
    const arr = Array.isArray(input) ? input : input ? [
        input
    ] : [];
    const out = [];
    for (const entry of arr){
        const a = $dad3e117027ddad9$export$991c8cfe3fb90b7b(entry);
        if (a && !out.some((x)=>x.email.toLowerCase() === a.email.toLowerCase())) out.push(a);
    }
    return out;
};
const $dad3e117027ddad9$export$b7a491b69cf952b = function(text) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(text || '').trim());
};
const $dad3e117027ddad9$export$a840e9e8a0f6bb95 = function(input) {
    const d = input && typeof input === 'object' ? input : {};
    const html = typeof d.html === 'string' && d.html ? d.html : typeof d.body === 'string' && d.body ? $dad3e117027ddad9$export$52e2359d43459c9f(d.body) : '';
    return {
        id: d.id || null,
        accountId: d.accountId || d.account || null,
        sendAs: d.sendAs || null,
        to: $dad3e117027ddad9$export$49dba393d6bbfa69(d.to),
        cc: $dad3e117027ddad9$export$49dba393d6bbfa69(d.cc),
        bcc: $dad3e117027ddad9$export$49dba393d6bbfa69(d.bcc),
        subject: typeof d.subject === 'string' ? d.subject : '',
        html: html,
        attachments: Array.isArray(d.attachments) ? d.attachments : [],
        inReplyToMessage: d.inReplyToMessage || null,
        thread: d.thread || null,
        seeded: !!d.seeded
    };
};
const $dad3e117027ddad9$export$52e2359d43459c9f = function(text) {
    return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r\n|\r|\n/g, '<br>');
};
const $dad3e117027ddad9$export$a4f14ae2c81f47a0 = function(href) {
    const raw = String(href || '');
    if (!/^mailto:/i.test(raw)) return null;
    const rest = raw.slice(7);
    const qIdx = rest.indexOf('?');
    const addrPart = qIdx === -1 ? rest : rest.slice(0, qIdx);
    const draft = {
        to: [],
        cc: [],
        bcc: [],
        subject: '',
        html: ''
    };
    const dec = (v)=>{
        try {
            return decodeURIComponent(v.replace(/\+/g, '%20'));
        } catch (e) {
            return v;
        }
    };
    if (addrPart) draft.to = addrPart.split(',').map((a)=>dec(a).trim()).filter(Boolean);
    if (qIdx !== -1) for (const pair of rest.slice(qIdx + 1).split('&')){
        if (!pair) continue;
        const eq = pair.indexOf('=');
        const key = dec(eq === -1 ? pair : pair.slice(0, eq)).toLowerCase();
        const value = eq === -1 ? '' : dec(pair.slice(eq + 1));
        if (key === 'to') draft.to = draft.to.concat(value.split(',').map((a)=>a.trim()));
        else if (key === 'cc') draft.cc = value.split(',').map((a)=>a.trim());
        else if (key === 'bcc') draft.bcc = value.split(',').map((a)=>a.trim());
        else if (key === 'subject') draft.subject = value;
        else if (key === 'body') draft.html = $dad3e117027ddad9$export$52e2359d43459c9f(value);
    }
    return $dad3e117027ddad9$export$a840e9e8a0f6bb95(draft);
};
const $dad3e117027ddad9$export$1e7a73719bac0abd = function(message, opts) {
    const m = message || {};
    const o = opts || {};
    const mode = o.mode === 'replyAll' || o.mode === 'forward' ? o.mode : 'reply';
    const self = (o.selfAddresses || []).map((a)=>String(a).toLowerCase());
    const stripPrefixes = (s)=>String(s || '').replace(/^\s*((re|fwd?|fw)\s*:\s*)+/i, '');
    const from = $dad3e117027ddad9$export$991c8cfe3fb90b7b(m.from);
    const replyTo = $dad3e117027ddad9$export$49dba393d6bbfa69(m.replyTo && m.replyTo.length ? m.replyTo : from ? [
        from
    ] : []);
    const notSelf = (a)=>!self.includes(a.email.toLowerCase());
    const bodyHtml = String(o.bodyHtml || '');
    const who = from ? from.name ? `${from.name} <${from.email}>` : from.email : '';
    const esc = (s)=>String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const draft = {
        accountId: m.account || null,
        to: [],
        cc: [],
        subject: (mode === 'forward' ? 'Fwd: ' : 'Re: ') + stripPrefixes(m.subject),
        html: '',
        inReplyToMessage: mode === 'forward' ? null : m.id || null,
        thread: mode === 'forward' ? null : m.thread || null
    };
    if (mode === 'reply') draft.to = replyTo;
    else if (mode === 'replyAll') {
        draft.to = $dad3e117027ddad9$export$49dba393d6bbfa69([
            ...replyTo,
            ...$dad3e117027ddad9$export$49dba393d6bbfa69(m.to).filter(notSelf)
        ]);
        draft.cc = $dad3e117027ddad9$export$49dba393d6bbfa69(m.cc).filter(notSelf);
    }
    if (mode === 'forward') {
        const line = (label, value)=>value ? `${esc(label)}: ${esc(value)}<br>` : '';
        const toLine = $dad3e117027ddad9$export$49dba393d6bbfa69(m.to).map((a)=>a.name ? `${a.name} <${a.email}>` : a.email).join(', ');
        draft.html = '<br><br>' + `<div>${esc(o.forwardIntro || '---------- Forwarded message ----------')}</div>` + line(o.fromLabel || 'From', who) + line(o.dateLabel || 'Date', m.sentAt || m.receivedAt || '') + line(o.subjectLabel || 'Subject', m.subject || '') + line(o.toLabel || 'To', toLine) + '<br>' + bodyHtml;
    } else if (bodyHtml || who) {
        const intro = String(o.quoteIntro || 'On {date}, {who} wrote:').replace('{date}', esc(m.sentAt || m.receivedAt || '')).replace('{who}', esc(who));
        draft.html = `<br><br><div>${intro}</div><blockquote type="cite">${bodyHtml}</blockquote>`;
    }
    return $dad3e117027ddad9$export$a840e9e8a0f6bb95(draft);
};
const $dad3e117027ddad9$export$7954288041957203 = function(draft, account) {
    const d = draft || {};
    if (d.seeded || d.id) return d.html || '';
    const sig = account && account.signature && account.signature.html || (account && account.signature && account.signature.text ? $dad3e117027ddad9$export$52e2359d43459c9f(account.signature.text) : '');
    if (!sig) return d.html || '';
    return `${d.html || ''}<br><br><div class="mail-signature">${sig}</div>`;
};
const $dad3e117027ddad9$export$ec88e673832e374d = function(root, query, excludeEmails) {
    const rt = root || this && this.state && this.state.root;
    const q = String(query == null ? rt && rt.mailRecipientPicker && rt.mailRecipientPicker.query || '' : query).toLowerCase().trim();
    if (!rt || !q) return [];
    const taken = (excludeEmails || []).map((e)=>String(e).toLowerCase());
    return (rt && rt.people || []).filter((p)=>p && p.email && !taken.includes(p.email.toLowerCase())).filter((p)=>{
        const name = (p.name || '').toLowerCase();
        const local = (p.email || '').split('@')[0].toLowerCase();
        return name.includes(q) || local.includes(q) || p.email.toLowerCase().includes(q);
    }).slice(0, 8);
};
const $dad3e117027ddad9$export$b0777017cafd266e = function(root, draft) {
    const rt = root || this && this.state && this.state.root;
    const accounts = rt && rt.mailSetup && rt.mailSetup.accounts || [];
    const sendable = accounts.filter((a)=>a && a.canSend && a.status === 'active');
    const wanted = draft && (draft.accountId || draft.account);
    if (wanted && sendable.some((a)=>a.id === wanted)) return wanted;
    return sendable[0] && sendable[0].id || null;
};
const $dad3e117027ddad9$export$6eae761ba2c9d17e = function(root) {
    const rt = root || this && this.state && this.state.root;
    const draft = rt && rt.mailComposeDraft;
    if (!rt || !draft || !$dad3e117027ddad9$var$_mailEditorNode) return;
    const html = $dad3e117027ddad9$var$_mailEditorNode.innerHTML || '';
    if (html === draft.html) return;
    rt.update({
        mailComposeDraft: {
            ...draft,
            html: html
        }
    });
};
const $dad3e117027ddad9$export$7d4fa34f95eb83e3 = function(patch) {
    const root = this && this.state && this.state.root;
    if (!root || !root.mailComposeDraft) return;
    if (patch && Object.keys(patch).length) {
        const draft = {
            ...root.mailComposeDraft,
            ...patch
        };
        root.update({
            mailComposeDraft: draft
        });
        (0, $5iARt.writeParkedMailDraft)((0, $4X1w3.mailWorkspaceId)(root), draft);
    }
    if ($dad3e117027ddad9$var$_autosaveTimer) clearTimeout($dad3e117027ddad9$var$_autosaveTimer);
    $dad3e117027ddad9$var$_autosaveTimer = setTimeout(()=>{
        $dad3e117027ddad9$var$_autosaveTimer = null;
        $dad3e117027ddad9$export$92f7a30784bad3dc({
            root: root
        });
    }, $dad3e117027ddad9$var$MAIL_AUTOSAVE_MS);
};
const $dad3e117027ddad9$export$37c7a7114f81703e = function() {
    this.call('mailComposePatch', {});
};
const $dad3e117027ddad9$export$7ddcec3ac6758946 = function(accountId) {
    // Switching From resets the alias — the old alias belongs to the old
    // account and the server would 400 invalid_send_as on it.
    this.call('mailComposePatch', {
        accountId: accountId || null,
        sendAs: null
    });
};
const $dad3e117027ddad9$export$92f7a30784bad3dc = function(opts) {
    const root = opts && opts.root || this && this.state && this.state.root;
    if (!root) return Promise.resolve(null);
    return (0, $4ixcF.enqueueMailComposeWrite)(async ()=>{
        $dad3e117027ddad9$export$6eae761ba2c9d17e(root);
        const draft = root.mailComposeDraft;
        if (!draft) return null;
        const accountId = draft.accountId || $dad3e117027ddad9$export$b0777017cafd266e(root, draft);
        if (!accountId) return null;
        if (!draft.id && !$dad3e117027ddad9$var$mailDraftHasContent(draft)) return null;
        const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
        const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
        root.update({
            mailComposeSaving: true
        });
        const payload = {
            account: accountId,
            to: draft.to,
            cc: draft.cc,
            bcc: draft.bcc,
            subject: draft.subject,
            html: draft.html,
            ...draft.inReplyToMessage ? {
                inReplyToMessage: draft.inReplyToMessage
            } : {},
            ...draft.thread ? {
                thread: draft.thread
            } : {}
        };
        try {
            let saved;
            if (!draft.id) saved = await (0, $1NxyO.getSDK)().execute('mail.drafts', 'create', {
                payload: payload,
                ...workspaceId ? {
                    workspaceId: workspaceId
                } : {}
            });
            else saved = await (0, $1NxyO.getSDK)().execute('mail.drafts', 'update', {
                id: draft.id,
                payload: {
                    ...payload,
                    // The keep-list contract: echo the staged refs still on the
                    // draft; a ref left out is dropped server-side with its blob.
                    attachments: draft.attachments.map((a)=>a && a.storagePath).filter(Boolean)
                },
                ...workspaceId ? {
                    workspaceId: workspaceId
                } : {}
            });
            // Merge ONLY the server-minted facts into the CURRENT slot — the person
            // kept typing during the await, so `saved`'s content is already stale.
            const current = root.mailComposeDraft;
            if (current) {
                const next = {
                    ...current,
                    id: saved && saved.id || current.id,
                    accountId: current.accountId || accountId
                };
                if (write({
                    mailComposeDraft: next,
                    mailComposeSaving: false,
                    mailComposeSavedAt: Date.now()
                })) (0, $5iARt.writeParkedMailDraft)(workspaceId, next);
            } else write({
                mailComposeSaving: false,
                mailComposeSavedAt: Date.now()
            });
            return saved || null;
        } catch (err) {
            write({
                mailComposeSaving: false,
                mailComposeError: {
                    op: 'save',
                    code: err && err.status || null,
                    message: err && err.message || ''
                }
            });
            return null;
        }
    });
};
const $dad3e117027ddad9$var$mailHtmlHasContent = (html)=>!!String(html || '').replace(/<br\s*\/?>/gi, '').replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, '').trim();
// Anything a person typed or attached — the autosave's "worth a server row"
// test, and the discard's "worth asking about" test.
const $dad3e117027ddad9$var$mailDraftHasContent = (draft)=>!!(draft.subject || (draft.to || []).length || (draft.cc || []).length || (draft.bcc || []).length || (draft.attachments || []).length || $dad3e117027ddad9$var$mailHtmlHasContent(draft.html));
const $dad3e117027ddad9$export$6c53c52b3814d951 = async function(draft) {
    const root = this && this.state && this.state.root;
    if (!root) return null;
    // Captured on THIS tick, before the gate read and before the fold — both
    // are awaits, and both of the writes below land after them. A compose
    // intent formed in workspace A must not open A's dock, or A's drawer, over
    // workspace B (see functions/sameWorkspaceWriter.js).
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    const intent = draft ? $dad3e117027ddad9$export$a840e9e8a0f6bb95(draft) : null;
    // Park the intent BEFORE the gate read: §3.2a — the draft must ride across
    // the whole setup journey (OAuth, link, ask-admin) untouched.
    if (intent) {
        root.update({
            mailComposeDraft: intent
        });
        (0, $5iARt.writeParkedMailDraft)(workspaceId, intent);
    }
    const setup = await this.call('loadMailSetup');
    const state = setup && setup.state || root.mailSetup && root.mailSetup.state || null;
    if (state === 'off') return state;
    if (state === 'ready') {
        // Resume order: the slot → the session mirror (a same-tab OAuth return
        // or a reload emptied the slot but not the mirror) → a fresh draft.
        let prepared = root.mailComposeDraft;
        if (!prepared) prepared = (0, $5iARt.readParkedMailDraft)(workspaceId);
        prepared = $dad3e117027ddad9$export$a840e9e8a0f6bb95(prepared || {});
        if (!prepared.accountId) prepared.accountId = $dad3e117027ddad9$export$b0777017cafd266e(root, prepared);
        // The full account rows carry sendAs + signature + undo seconds; the
        // gate summaries do not. Fire-and-forget — the dock renders from the
        // summaries meanwhile.
        if (!(root.mailAccounts || []).length) this.call('loadMailAccounts');
        if (!write({
            _mailDrawerOpen: false,
            mailComposeOpen: true,
            mailComposeDraft: prepared,
            mailComposeError: null
        })) return state;
        (0, $5iARt.writeParkedMailDraft)(workspaceId, prepared);
        if (!$dad3e117027ddad9$var$_mailDockCount) this.call('openAppPage', '/mail', {
            preferSlot: true
        });
        return state;
    }
    const ok = await this.call('ensureMailContext');
    if (ok === false) return state;
    write({
        _mailDrawerOpen: true
    });
    return state;
};
const $dad3e117027ddad9$export$b22c481001c51a73 = function(href) {
    const draft = $dad3e117027ddad9$export$a4f14ae2c81f47a0(href);
    if (!draft) return false;
    this.call('openMailCompose', draft);
    return true;
};
const $dad3e117027ddad9$export$c1ccf71a96f7b233 = async function(to, subject, body) {
    const state = await this.call('openMailCompose', {
        to: to,
        subject: subject || '',
        body: body || ''
    });
    return {
        ok: state === 'ready',
        setupState: state || 'unknown'
    };
};
const $dad3e117027ddad9$export$e9731667f3215e5a = function() {
    const root = this && this.state && this.state.root;
    if (!root) return;
    $dad3e117027ddad9$export$6eae761ba2c9d17e(root);
    $dad3e117027ddad9$export$92f7a30784bad3dc({
        root: root
    });
    root.update({
        mailComposeOpen: false,
        mailRecipientPicker: null,
        _mailComposeMenu: null
    });
};
const $dad3e117027ddad9$export$b0e0523da80f8f3d = function() {
    const root = this && this.state && this.state.root;
    if (!root) return Promise.resolve(false);
    $dad3e117027ddad9$export$6eae761ba2c9d17e(root);
    const draft = root.mailComposeDraft;
    if (!draft || !draft.id && !$dad3e117027ddad9$var$mailDraftHasContent(draft)) return $dad3e117027ddad9$var$_discardMailComposeNow.call(this, root).then(()=>true);
    const subject = String(draft.subject || '').trim();
    return new Promise((resolve)=>{
        this.call('confirmDialog', {
            title: subject ? this.call('polyglot', 'mail.confirm.discard.title').replace('{subject}', ()=>subject) : this.call('polyglot', 'mail.confirm.discard.titleUntitled'),
            message: this.call('polyglot', 'mail.confirm.discard.message'),
            confirmText: this.call('polyglot', 'mail.confirm.discard.button'),
            cancelText: this.call('polyglot', 'common.action.cancel'),
            confirmTheme: 'primary',
            icon: null,
            onConfirm: ()=>resolve($dad3e117027ddad9$var$_discardMailComposeNow.call(this, root).then(()=>true)),
            onCancel: ()=>resolve(false)
        });
    });
};
const $dad3e117027ddad9$var$_discardMailComposeNow = async function(root) {
    const draft = root.mailComposeDraft;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    if ($dad3e117027ddad9$var$_autosaveTimer) {
        clearTimeout($dad3e117027ddad9$var$_autosaveTimer);
        $dad3e117027ddad9$var$_autosaveTimer = null;
    }
    root.update({
        mailComposeOpen: false,
        mailComposeDraft: null,
        mailComposeError: null,
        mailRecipientPicker: null,
        _mailComposeMenu: null
    });
    (0, $5iARt.writeParkedMailDraft)(workspaceId, null);
    if (draft && draft.id) try {
        await (0, $1NxyO.getSDK)().execute('mail.drafts', 'remove', {
            id: draft.id,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
    } catch (err) {
        // The staged blobs outlive the slot; the server's own draft sweep
        // reaps them. Nothing the person can act on — keep the close silent.
        write({});
    }
};
const $dad3e117027ddad9$export$a8ccaa666c1684de = async function(opts) {
    const root = this && this.state && this.state.root;
    if (!root || root.mailComposeBusy) return false;
    const scheduleAt = opts && opts.scheduleAt ? opts.scheduleAt : null;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    const before = root.mailComposeDraft;
    if (!before) return false;
    if (!(before.to.length + before.cc.length + before.bcc.length)) {
        root.update({
            mailComposeError: {
                op: 'send',
                code: 'no_recipients',
                message: ''
            }
        });
        return false;
    }
    root.update({
        mailComposeBusy: 'send',
        mailComposeError: null,
        _mailComposeMenu: null
    });
    // The final flush + save gives the outbox row the exact content on screen.
    await $dad3e117027ddad9$export$92f7a30784bad3dc({
        root: root
    });
    const draft = root.mailComposeDraft;
    if (!draft || !draft.id) {
        write({
            mailComposeBusy: null,
            mailComposeError: root.mailComposeError || {
                op: 'send',
                code: 'save_failed',
                message: ''
            }
        });
        return false;
    }
    try {
        const row = await (0, $1NxyO.getSDK)().execute('mail.outbox', 'send', {
            payload: {
                draftId: draft.id,
                accountId: draft.accountId,
                ...draft.sendAs ? {
                    sendAs: draft.sendAs
                } : {},
                // undoSeconds is OMITTED on purpose: the server reads the account's
                // own settings.undoSeconds (default 10) — §3.4's per-account dial.
                ...scheduleAt ? {
                    scheduleAt: scheduleAt
                } : {}
            },
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        if (write({
            mailComposeOpen: false,
            mailComposeDraft: null,
            mailComposeBusy: null,
            mailRecipientPicker: null,
            mailOutbox: [
                row,
                ...root.mailOutbox || []
            ].slice(0, 20)
        })) (0, $5iARt.writeParkedMailDraft)(workspaceId, null);
        if (scheduleAt) this.call('openNotification', {
            type: 'success',
            title: this.call('polyglot', 'mail.compose.scheduled'),
            message: new Date(scheduleAt).toLocaleString()
        });
        else // The undo affordance (§3.2 "Undo send window"): the toast IS the
        // control — a click cancels the queued row and reopens the draft.
        this.call('openNotification', {
            type: 'info',
            icon: 'email',
            title: this.call('polyglot', 'mail.compose.sending'),
            message: this.call('polyglot', 'mail.compose.undoHint'),
            action: {
                call: 'undoMailSend',
                args: [
                    row && row.id
                ]
            }
        });
        return true;
    } catch (err) {
        // §3.2: "failure → toast + the draft reopens with the error." The dock
        // never closed, so the reopen is the error landing beside the draft.
        write({
            mailComposeBusy: null,
            mailComposeError: {
                op: 'send',
                code: err && err.cause && err.cause.code || err && err.status || null,
                message: err && err.message || ''
            }
        });
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'mail.compose.sendFailed'),
            message: err && err.message || ''
        });
        return false;
    }
};
const $dad3e117027ddad9$export$8d5d232b5b8838b8 = async function(outboxId) {
    const root = this && this.state && this.state.root;
    if (!root || !outboxId) return false;
    const write = (0, $4X1w3.mailSameWorkspaceWriter)(root);
    const workspaceId = (0, $4X1w3.mailWorkspaceId)(root);
    try {
        const res = await (0, $1NxyO.getSDK)().execute('mail.outbox', 'cancel', {
            id: outboxId,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const restored = res && res.draft ? $dad3e117027ddad9$export$a840e9e8a0f6bb95({
            ...res.draft,
            seeded: true
        }) : null;
        const rows = (root.mailOutbox || []).map((r)=>r && r.id === outboxId ? {
                ...r,
                status: 'cancelled'
            } : r);
        if (write({
            mailOutbox: rows,
            ...restored ? {
                mailComposeDraft: restored,
                mailComposeOpen: true
            } : {}
        })) {
            if (restored) (0, $5iARt.writeParkedMailDraft)(workspaceId, restored);
        }
        if (restored && !$dad3e117027ddad9$var$_mailDockCount) this.call('openAppPage', '/mail', {
            preferSlot: true
        });
        return true;
    } catch (err) {
        // 409 not_cancellable — the worker already claimed the row. Late, not
        // broken: say it went out.
        this.call('openNotification', {
            type: err && err.status === 409 ? 'info' : 'error',
            title: this.call('polyglot', err && err.status === 409 ? 'mail.compose.undoLate' : 'mail.compose.undoFailed'),
            message: err && err.status === 409 ? '' : err && err.message || ''
        });
        return false;
    }
};
const $dad3e117027ddad9$export$926434f974fcb310 = async function(message, opts) {
    const root = this && this.state && this.state.root;
    if (!root || !message) return null;
    const mode = opts && opts.mode || 'reply';
    const account = (root.mailAccounts || []).find((a)=>a && a.id === message.account) || (root.mailSetup && root.mailSetup.accounts || []).find((a)=>a && a.id === message.account);
    const selfAddresses = [
        account && account.address,
        ...(account && account.sendAs || []).map((s)=>s && s.address) || []
    ].filter(Boolean);
    const body = root.mailBodies && message.id ? root.mailBodies[message.id] : null;
    const draft = $dad3e117027ddad9$export$1e7a73719bac0abd(message, {
        mode: mode,
        selfAddresses: selfAddresses,
        bodyHtml: body && body.html || '',
        quoteIntro: this.call('polyglot', 'mail.compose.quoteIntro'),
        forwardIntro: this.call('polyglot', 'mail.compose.fwdIntro')
    });
    return this.call('openMailCompose', draft);
};
const $dad3e117027ddad9$export$4d2acaa65280b14b = function(message) {
    return this.call('replyToMailMessage', message, {
        mode: 'replyAll'
    });
};
const $dad3e117027ddad9$export$dbeeb59243aee4b5 = function(message) {
    return this.call('replyToMailMessage', message, {
        mode: 'forward'
    });
};
const $dad3e117027ddad9$export$6a4b717fab2740eb = function(field, query) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    if (query == null || query === '') {
        if (root.mailRecipientPicker) root.update({
            mailRecipientPicker: null
        });
        return;
    }
    root.update({
        mailRecipientPicker: {
            field: field,
            query: String(query)
        }
    });
};
const $dad3e117027ddad9$export$d030ac74201796a2 = function(field, entry) {
    const root = this && this.state && this.state.root;
    const draft = root && root.mailComposeDraft;
    if (!root || !draft) return false;
    const a = $dad3e117027ddad9$export$991c8cfe3fb90b7b(entry);
    if (!a || !$dad3e117027ddad9$export$b7a491b69cf952b(a.email)) return false;
    const key = field === 'cc' || field === 'bcc' ? field : 'to';
    if (draft[key].some((x)=>x.email.toLowerCase() === a.email.toLowerCase())) {
        root.update({
            mailRecipientPicker: null
        });
        return true;
    }
    this.call('mailComposePatch', {
        [key]: [
            ...draft[key],
            a
        ]
    });
    root.update({
        mailRecipientPicker: null
    });
    return true;
};
const $dad3e117027ddad9$export$4846d7377692c834 = function(field, email) {
    const root = this && this.state && this.state.root;
    const draft = root && root.mailComposeDraft;
    if (!root || !draft) return;
    const key = field === 'cc' || field === 'bcc' ? field : 'to';
    const target = String(email || '').toLowerCase();
    this.call('mailComposePatch', {
        [key]: draft[key].filter((x)=>x.email.toLowerCase() !== target)
    });
};

});
parcelRegister("5iARt", function(module, exports) {

$parcel$export(module.exports, "readParkedMailDraft", () => $3dbb3a204a90fee6$export$1ff6a815951cc538);
$parcel$export(module.exports, "writeParkedMailDraft", () => $3dbb3a204a90fee6$export$64cb4eb95fd3c447);
// The compose draft's per-tab mirror — §3.2a "the draft rides across the
// OAuth round trip". `root.mailComposeDraft` is memory: a same-tab OAuth
// redirect (the popup-blocked fallback) and a plain reload both empty it.
// This mirror is the recovery copy, per WORKSPACE per TAB, exactly the
// shared/functions/minimizedSlots.js discipline: sessionStorage (never
// localStorage — a draft is tab-scoped work in progress, not a preference),
// defensive on every read, a `wsId` stamp checked back as the tenant
// backstop, and helpers INLINED in each export (frank.toJSON drops
// module-local helpers — FA204).
//
// NOT re-exported from the function barrels on purpose: these are internal
// primitives of functions/compose.js, not `el.call` targets — the same
// reasoning as ./sameWorkspaceWriter.js.
const $3dbb3a204a90fee6$export$1ff6a815951cc538 = (wsId, storage)=>{
    const store = storage || (typeof sessionStorage === 'undefined' ? null : sessionStorage);
    if (!store) return null;
    try {
        const raw = store.getItem('mailComposeDraft.' + String(wsId || 'default'));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        if (String(parsed.wsId || '') !== String(wsId || '')) return null;
        const draft = parsed.draft;
        return draft && typeof draft === 'object' ? draft : null;
    } catch (e) {
        return null;
    }
};
const $3dbb3a204a90fee6$export$64cb4eb95fd3c447 = (wsId, draft, storage)=>{
    const store = storage || (typeof sessionStorage === 'undefined' ? null : sessionStorage);
    if (!store) return;
    const key = 'mailComposeDraft.' + String(wsId || 'default');
    try {
        if (!draft) {
            store.removeItem(key);
            return;
        }
        // Attachments carry server-minted storagePaths only — a File/Blob never
        // reaches this shape, so the slot always JSON-serialises.
        store.setItem(key, JSON.stringify({
            wsId: String(wsId || ''),
            draft: draft
        }));
    } catch (e) {
    // Quota or privacy mode — the in-memory slot still works; the mirror is
    // best-effort by design.
    }
};

});

parcelRegister("4ixcF", function(module, exports) {

$parcel$export(module.exports, "enqueueMailComposeWrite", () => $3212995d8c21fe65$export$facf100de5708405);
// ONE serial queue for every write that touches the server MailDraft — the
// 2 s autosave (create/update, functions/compose.js) AND the attachment
// staging (functions/attachments.js). They must interleave nowhere: an
// autosave UPDATE echoes the keep-list of staged storagePaths, so one racing
// an in-flight upload would echo a list without the fresh ref and the server
// would drop the blob that just landed. The queue settles even when a step
// throws (steps report their own errors into state; the chain never breaks).
//
// NOT re-exported from the function barrels — an internal primitive, same
// reasoning as ./sameWorkspaceWriter.js.
// The queue's tail starts as `null`, not `Promise.resolve()`: frank carries
// module `let` state in the emitted globalScope's `Smut` holder, which takes
// a literal initial value only - an expression initializer left `_chain`
// unresolvable in the published library (2026-10-07; frank follow-up filed).
// The first write creates the resolved head, so behaviour is unchanged.
let $3212995d8c21fe65$var$_chain = null;
const $3212995d8c21fe65$export$facf100de5708405 = (step)=>{
    $3212995d8c21fe65$var$_chain = ($3212995d8c21fe65$var$_chain || Promise.resolve()).then(()=>step(), ()=>step());
    return $3212995d8c21fe65$var$_chain;
};

});


parcelRegister("gBN8h", function(module, exports) {

$parcel$export(module.exports, "mailAiViews", () => $c17636b951f37e72$export$cf6e63c69f88fed9);
$parcel$export(module.exports, "mailThreadsAnswerLoad", () => $c17636b951f37e72$export$8c853b8eb7db917f);
$parcel$export(module.exports, "mailThreadsAnswerModel", () => $c17636b951f37e72$export$baf16adbd83b0b11);
// THE MAIL IN AN AI ANSWER — the `mail-threads` view the assistant mounts in
// its thread and a Fly page places as a section (workspace functions/
// assistantAppViews.js, the `views[]` contract).
//
// mailAiViews() is the PROVIDER, read from the mail EAGER slice; the view's
// component rides the lazy mail context (`fold: 'mail'` — the shell folds it
// through ensureMailContext before a card mounts). Mail is dark by default
// (the `mail` flag): the view declares the /mail page as its gate
// (`access.route`), so a workspace without mail — or a member without the
// app — is never offered it. One view, in the shell's list frame (workspace
// components/AssistantViewList.js):
//
//   mail-threads   the member's threads, newest first — a folder (inbox by
//                  default, or starred), only the unread ones, or a search;
//                  unread threads first; a row opens the thread in Mail
//
// The read is the mail list's own (GET /mail/threads through `mail.threads`
// list), into the view's OWN state — never root.mailThreads. Nothing here
// writes: opening a card marks nothing read.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $c17636b951f37e72$export$cf6e63c69f88fed9() {
    return {
        app: {
            id: 'system/mail',
            navbar: [
                {
                    label: 'shell.app.mail',
                    route: '/mail',
                    icon: 'email'
                }
            ],
            apps: [
                {
                    icon: 'email'
                }
            ]
        },
        fold: 'mail',
        views: [
            {
                id: 'mail-threads',
                title: 'mail.page.title',
                describe: "The member's mail threads, newest first: a folder (inbox by default), only unread, or a search; unread first.",
                component: 'MailThreadsAnswerView',
                icon: 'email',
                hue: 'red',
                size: 'l',
                params: {
                    folder: {
                        type: 'enum',
                        values: [
                            'inbox',
                            'starred',
                            'sent',
                            'drafts',
                            'archive',
                            'spam',
                            'trash'
                        ],
                        labels: {
                            inbox: 'mail.folder.inbox',
                            starred: 'mail.folder.starred',
                            sent: 'mail.folder.sent',
                            drafts: 'mail.folder.drafts',
                            archive: 'mail.folder.archive',
                            spam: 'mail.folder.spam',
                            trash: 'mail.folder.trash'
                        },
                        default: 'inbox'
                    },
                    unread: {
                        type: 'boolean',
                        describe: 'only unread threads',
                        default: false
                    },
                    search: {
                        type: 'string',
                        describe: 'words to search the mail for'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 50,
                        default: 12
                    }
                },
                link: {
                    route: '/mail',
                    query: {}
                },
                access: {
                    route: '/mail'
                }
            }
        ]
    };
}
async function $c17636b951f37e72$export$8c853b8eb7db917f(el, params) {
    const host = el || this;
    const p = params && typeof params === 'object' ? params : {};
    const root = host && host.state && host.state.root || {};
    const sdk = host && host.sdk || host.call('getSDK');
    if (!sdk || typeof sdk.execute !== 'function') return {
        data: {
            threads: []
        },
        failed: true
    };
    const FOLDERS = [
        'inbox',
        'starred',
        'sent',
        'drafts',
        'archive',
        'spam',
        'trash'
    ];
    const folder = FOLDERS.includes(p.folder) ? p.folder : 'inbox';
    const query = folder === 'starred' ? {
        starred: true
    } : {
        folder: folder
    };
    if (p.unread === true || p.unread === 'true') query.unread = true;
    const words = String(p.search || '').trim();
    if (words) query.q = words;
    const limit = Math.max(1, Math.min(50, Math.floor(Number(p.limit)) || 12));
    const workspaceId = String(root.workspace && (root.workspace.id || root.workspace._id) || '');
    const addr = (a)=>({
            name: a && a.name || '',
            email: String(a && a.email || '').toLowerCase(),
            role: a && a.role || 'from'
        });
    try {
        const res = await sdk.execute('mail.threads', 'list', {
            ...query,
            limit: limit,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const raw = Array.isArray(res) ? {
            rows: res
        } : res && typeof res === 'object' ? res : {};
        const rows = Array.isArray(raw.rows) ? raw.rows : Array.isArray(raw.threads) ? raw.threads : [];
        // The thread fields the rows read (the list's own mapper, mailUtils
        // normalizeMailThread, keeps the same names).
        const threads = rows.filter((r)=>r && (r.id || r._id) && !r.deleted).map((r)=>({
                id: String(r.id || r._id),
                subject: r.subject || '',
                snippet: r.snippet || '',
                participants: Array.isArray(r.participants) ? r.participants.map(addr) : [],
                lastMessageAt: r.lastMessageAt ? String(r.lastMessageAt) : null,
                unreadCount: Number(r.unreadCount || 0)
            }));
        return {
            data: {
                threads: threads,
                folder: folder,
                more: !!(raw.cursor || raw.nextCursor)
            }
        };
    } catch (_) {
        return {
            data: {
                threads: [],
                folder: folder
            },
            failed: true
        };
    }
}
function $c17636b951f37e72$export$baf16adbd83b0b11(data, params, failed) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const p = params && typeof params === 'object' ? params : {};
    const say = (key)=>String(el.call('polyglot', key));
    if (failed) return {
        groups: [],
        note: 'mail.list.loadFailed'
    };
    const threads = Array.isArray(d.threads) ? d.threads : [];
    const me = String(root.currentUserEmail || '').toLowerCase();
    const folder = d.folder || 'inbox';
    const when = (iso)=>{
        const ms = Date.parse(iso || '');
        if (!Number.isFinite(ms)) return '';
        const sameDay = new Date(ms).toDateString() === new Date().toDateString();
        return String(el.call('localizedDate', new Date(ms), sameDay ? {
            hour: '2-digit',
            minute: '2-digit'
        } : {
            month: 'short',
            day: 'numeric'
        }) || '');
    };
    const row = (t)=>{
        const role = folder === 'sent' || folder === 'drafts' ? 'to' : 'from';
        const list = Array.isArray(t.participants) ? t.participants : [];
        const other = list.find((a)=>a.role === role && a.email !== me) || list.find((a)=>a.email !== me) || list[0] || null;
        const who = other ? other.name || other.email.split('@')[0] : say('mail.list.me');
        return el.call('assistantViewRow', {
            key: 't-' + String(t.id).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: t.subject || say('mail.list.noSubject'),
            meta: [
                who,
                when(t.lastMessageAt)
            ].filter(Boolean).join(" \xb7 "),
            initials: el.call('initials', who) || null,
            open: {
                call: 'openAppPage',
                arg: '/mail?thread=' + encodeURIComponent(t.id)
            }
        });
    };
    const unread = threads.filter((t)=>t.unreadCount > 0);
    const rest = threads.filter((t)=>!(t.unreadCount > 0));
    const groups = [];
    if (unread.length) groups.push(el.call('assistantViewGroup', {
        key: 'unread',
        label: say('mail.answer.unread').replace('{count}', String(unread.length)),
        rows: unread.map(row)
    }));
    if (rest.length) groups.push(el.call('assistantViewGroup', {
        key: 'earlier',
        label: unread.length ? say('mail.answer.earlier') : say('mail.folder.' + folder),
        rows: rest.map(row)
    }));
    const note = groups.length ? '' : String(p.search || '').trim() ? 'mail.answer.noMatch' : 'mail.list.emptyFolder';
    return {
        groups: groups,
        note: note,
        more: d.more ? {
            shown: threads.length,
            open: true
        } : null
    };
}

});


parcelRegister("4qFYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $339a2709fbfc9493$export$2e2bcd8739ae039);
// Mail-related root state — merged into the workspace shell via sharedLibraries.
//
// Every key the v1 client writes is declared HERE — and NOT only where it is
// written — because this slice is seeded at boot via the mail eager slice
// (workspace/sharedLibraries.js), and v3.14 root.update() on an undeclared
// key trips the schema check. The shapes follow architecture/MAIL.md §4.2.
var $339a2709fbfc9493$export$2e2bcd8739ae039 = {
    mailAccounts: [],
    mailActiveAccountId: null,
    mailActiveFolder: 'inbox',
    mailFolders: {},
    mailThreads: {},
    mailActiveThreadId: null,
    mailMessages: {},
    mailBodies: {},
    mailUnreadCounts: {},
    mailSelection: [],
    mailFilters: {
        unread: false,
        starred: false,
        attachments: false,
        from: null,
        label: null
    },
    mailSearchQuery: '',
    mailComposeOpen: false,
    mailComposeDraft: null,
    mailOutbox: [],
    // ── The read path (architecture/MAIL.md §3.1, MAIL-UI-READ-1) ──
    // GET /threads/:id in flight for this thread id (the view pane's loading
    // state), and the last thread open the server refused.
    mailThreadLoading: null,
    mailThreadError: null,
    // The list keyboard cursor (`j`/`k`); an id from the ACTIVE list slot.
    _mailCursorId: null,
    // Per-thread expansion map: { [threadId]: { [messageId]: true } } — unread
    // + newest open by default (loadThread.js seeds it).
    _mailMessageOpen: {},
    // Per-message quoted-text unfold: { [messageId]: true }.
    _mailQuotedOpen: {},
    // ── Compose lifecycle (architecture/MAIL.md §3.2, MAIL-UI-COMPOSE-1) ──
    // The 2 s autosave is in flight (the dock's "Saving…" hint).
    mailComposeSaving: false,
    // Epoch ms of the last landed autosave (the dock's "Saved" hint).
    mailComposeSavedAt: null,
    // `{ op: 'save'|'send', code, message }` — the last refused write. A send
    // failure keeps the dock open with the draft intact (§3.2 "the draft
    // reopens with the error").
    mailComposeError: null,
    // 'send' while POST /mail/send is in flight — disables the Send button.
    mailComposeBusy: null,
    // Recipient autocomplete: `{ field: 'to'|'cc'|'bcc', query }` while a
    // suggestion menu is open; null = closed.
    mailRecipientPicker: null,
    // Cc/Bcc rows are folded until asked for (the Gmail idiom).
    _mailComposeCcOpen: false,
    // Which dock menu is open — 'schedule' | 'from' | null.
    _mailComposeMenu: null,
    // ── The setup gate (architecture/MAIL.md §3.2a) ──
    // The whole `sdk.execute('mail.setup', 'get')` payload, plus a `__fetchedAt`
    // stamp the loader reads for its freshness window. Shape:
    //   { state, policy, viewerIsAdmin, accounts, providers, workspace }
    // `state` is one of off | ready | reauth | connect | link | ask-admin.
    // `providers[].steps` is served ONLY to admins — an EMPTY steps list on a
    // member is the contract, never an error.
    mailSetup: null,
    // The `get` is in flight. Three surfaces mount MailSetupPanel (the /mail
    // empty state, the header drawer, the /settings card), so the flag is what
    // keeps them from each firing their own request.
    mailSetupLoading: false,
    // `{ code, message }` when the `get` itself failed — the panel renders a
    // retry, never a blank box.
    mailSetupError: null,
    // The result of an ACTION (link / notifyAdmin / a provider button), as
    // `{ tone: 'info'|'success'|'error', key, message }`. `key` is a
    // `mail.setup.*` bundle key; `message` is a server string (the 501 contract
    // message, a 429 body) rendered verbatim when present.
    mailSetupNotice: null,
    // Which setup action is in flight — 'link' | 'notifyAdmin' | 'connect'.
    mailSetupBusy: null,
    // ── /settings Mail card (§3.4) ──
    // Per-account unsaved edits, `{ [accountId]: { signature, defaultSendAs } }`.
    mailSettingsDraft: {},
    // `{ id, op }` while a PATCH / DELETE is in flight on one account row.
    mailSettingsBusy: null,
    // `{ id, message }` — the last account write that the server refused.
    mailSettingsError: null,
    // ── /admin/mail (§3.5, MAIL-ADMIN-TENANT-POLICY-1) ──
    // Health rows (serializeAdminAccount shape) + the newest mail.* audit rows
    // (serializeAudit shape). `null` = never loaded; `[]` = loaded and empty —
    // the cards branch on that difference for their empty states.
    mailAdminAccounts: null,
    mailAdminAccountsLoading: false,
    mailAdminAccountsError: null,
    mailAdminAudit: null,
    mailAdminAuditLoading: false,
    mailAdminAuditError: null,
    // '<kind>:<op>' while a tenant action runs, 'disconnect:<id>' during a
    // force disconnect — one act at a time, buttons disable off it.
    mailAdminBusy: null,
    // The §6 policy key a save is in flight for — its row's control disables.
    mailPolicySaving: null,
    // ── Deep integrations (§3.7, MAIL-INTEGRATIONS-1) ──
    // Which pane the thread integrations dropdown shows — 'actions' (create
    // ticket / add to calendar / share) or 'share' (the channel picker). The
    // dropdown layer owns open/close; this only routes its content.
    _mailLinkMenuView: 'actions',
    // The share picker's channel filter query.
    _mailShareQuery: '',
    // One integration act at a time — 'ticket' | 'calendar' | 'share:<chId>' |
    // 'rsvp:<messageId>' | 'save:<attachmentId>' | null; buttons guard off it.
    _mailIntegrationBusy: null,
    // Phone rail (the MobileRailSheet presentation, P1) open flag.
    _mailRailOpen: false,
    // Docked MailOverlay open flag — the header envelope flips it on ANY route
    // (before the /mail route ever folds the context), so it must ride the
    // eager slice exactly like chat's `_chatDrawerOpen`.
    _mailDrawerOpen: false,
    // Subscription handle, workspace-keyed like root._chatRealtimeChannel.
    _mailStream: null
};

});

parcelRegister("gDjqT", function(module, exports) {
// Eager slim slice of the tickets component barrel (#16 tickets slim).
//
// The full `./index.js` barrel `export *`s all 24 tickets component files
// (~620KB — the whole board/kanban/triage/roadmap/resolutions UI tree). The
// unified shell used to drag ALL of it into its EAGER chunk by folding the
// tickets context via `sharedLibraries.js` (`import tickets from
// '@symbo-ls/workspace-tickets'` → smbls's mergeSharedLibraries folds the full
// components+functions+state into the boot root context).
//
// Tickets is now a lazy sub-app: the `/tickets*` + `/resolutions*` routes fold
// the FULL tickets context into the live shell context on first mount
// (workspace/pages/index.js → lazySharedLibPage). So every tickets UI key those
// routes reference resolves against the folded context — none of the heavy
// page-body components (GeneralMain ~100KB, ResolutionsMain, DailyUpdate,
// ReleaseMain, MyViewMain, TicketsKanban, StoryDetailModal, TicketCard,
// RoadmapMain, …) needs to be eager.
//
// Only TWO component files stay eager, because non-tickets surfaces reference
// their keys BEFORE any /tickets* route folds the context — and none of those
// surfaces fold tickets on their own. (TicketDetailModal.js left this slice on
// 2026-10-02: the shell root still bare-keys `TicketsDetailModal` behind its
// `if:` latch, but the module is now loaded and folded on first need by
// workspace/functions/ticketDetailModalLoad.js — smbls element >= 3.14.798
// re-merges the parked element with the late-registered component.)
//   • ActivityHeatmap.js — `TicketsActivityHeatmap` is bare-keyed on the HOME
//     dashboard (main.js). Fully self-contained (its childExtends
//     TicketsActivityRow / TicketsHeatmapCell live in-file; no cross-tickets
//     imports).
//   • Sidebar.js — `TicketsSidebar` is bare-keyed by `/tickets/status`
//     (features.js) and `TicketsSidebarGroup` is string-extended by the house
//     sidebar idiom across EAGER + other-lazy surfaces: canvas
//     (CanvasViewSidebar, ProjectCanvasSidebar), infra (InfraSidebar), workspace
//     GreenIG pages (claims/customers/transactions/policies), and shared
//     (CanvasViewNav). Its childExtends (TicketsSidebarItem, TicketsTypeBtn) +
//     extends (TicketsAssigneePicker, TicketsIssuerPicker, TicketsSidebarGroup)
//     all live in-file.
//
// The el.call'd functions these three fire on those non-folding surfaces
// (saveTicket / deleteTicket / moveTicket from the modal;
// reloadTickets from the sidebar; freshTicket from chat's MessageList) ride the
// companion functions/eagerSlice.js. Everything else resolves via the lazy fold.
//
// tickets/package.json has no `sideEffects: false`, so a re-export through
// `./index.js` would NOT tree-shake (referencing it evaluates every sibling
// source file — the whole 620KB barrel). Each key below is therefore `export *`-ed
// from its SOURCE file directly, so only these three modules ride the eager chunk.

var $5quub = parcelRequire("5quub");

var $Ty3kE = parcelRequire("Ty3kE");
$parcel$exportWildcard(module.exports, $5quub);
$parcel$exportWildcard(module.exports, $Ty3kE);

});
parcelRegister("5quub", function(module, exports) {

$parcel$export(module.exports, "_activityRefetchNeeded", () => $3f3707532d991625$export$741722114c558d5e);
$parcel$export(module.exports, "TicketsActivityHeatmap", () => $3f3707532d991625$export$352781c272fbebca);
$parcel$export(module.exports, "TicketsHeatmapCell", () => $3f3707532d991625$export$52a5c40ae49b3f97);
$parcel$export(module.exports, "TicketsActivityRow", () => $3f3707532d991625$export$93b233bf25ccedc5);
// Activity heatmap — shows daily scored activity for the last year.
// Reads `activity_events` (standups, ticket updates, note/KB edits, meet
// calls). Intensity keyed on SUM(score) per day. Standup days keep a ✦
// marker in the tooltip so "did standup today" stays explicit even when
// bundled with other activity.
// getSDK comes from @symbo-ls/workspace-shared, stubbed by frank's
// EXTERNAL_PACKAGES at serialization time — reach it via root.call instead
// of a raw import (see TicketDetailModal.js for the full rationale).
// WS-SWITCH-INCOMPLETE-1 — both fetches below write AFTER an await, so a reply
// issued in workspace A can land in workspace B. Package-local module, not the
// shell's: a sub-app must not import the shell (see the module's own note).

var $4Cvgr = parcelRequire("4Cvgr");
const $3f3707532d991625$export$741722114c558d5e = (el, root)=>{
    const wsId = (0, $4Cvgr.wsIdOf)(root);
    // `workspace` is absent for the first beats of boot. Stamping '' here would
    // make the first REAL workspace look like a change away from a fetched
    // state rather than the first fetch, and onCreate would be skipped.
    if (!wsId || !el) return false;
    if (el._activityWsId === wsId) return false;
    el._activityWsId = wsId;
    return true;
};
const $3f3707532d991625$var$WEEKS = 52;
const $3f3707532d991625$var$DAYS = 7;
const $3f3707532d991625$var$TOTAL = $3f3707532d991625$var$WEEKS * $3f3707532d991625$var$DAYS;
// Scored buckets: intensity ramps on summed points, not raw row count,
// so a single meet call (4pt) outshines two note edits (2pt).
const $3f3707532d991625$var$_intensity = (score, hasStandup)=>{
    // Empty days read as a slight gray fill (2026-06-06 per Nika) —
    // the previous transparent + 1px border rectangles looked like a
    // wireframe grid. Dialed down to .03 ("more slight").
    if (!score && !hasStandup) return 'white.03';
    if (hasStandup && !score) return 'green.15';
    if (score <= 2) return 'green.15';
    if (score <= 5) return 'green.3';
    if (score <= 10) return 'green.5';
    return 'green.7';
};
const $3f3707532d991625$export$352781c272fbebca = {
    flow: 'y',
    gap: 'Z',
    CaptionTitle: {
        fontSize: 'Y2',
        Text: {
            text: '{{ tickets.heatmap.title | polyglot }}'
        }
    },
    Grid: {
        display: 'grid',
        gridTemplateColumns: `repeat(${$3f3707532d991625$var$WEEKS}, 1fr)`,
        gridTemplateRows: `repeat(${$3f3707532d991625$var$DAYS}, 1fr)`,
        gridAutoFlow: 'column',
        gap: 'X2',
        padding: 'Z 0',
        childExtends: 'TicketsHeatmapCell',
        childrenAs: 'state',
        children: (el, s)=>{
            // Past first paint only: the full year is 364 cells (~0.7 s of a cold
            // home mount, dev deploy 31). Until the shell's stage ladder has started
            // (root._shellStage >= 1 - one macrotask after the mount, see the
            // shell's functions/shellStages.js) the grid holds ONE column of hidden
            // cells: same rows, same cell size, so the card keeps its height and
            // nothing moves when the year fills in. Outside the shell (no ladder,
            // no _shellStage) the year renders at once. One-way: never back.
            const stage = s.root?._shellStage;
            if (!el.__heatmapGridReady) {
                if (stage !== undefined && !(stage >= 1)) return Array.from({
                    length: $3f3707532d991625$var$DAYS
                }, ()=>({
                        date: '',
                        score: 0,
                        standups: 0,
                        breakdown: {},
                        placeholder: true
                    }));
                el.__heatmapGridReady = true;
            }
            const data = s.root?._activityData || {};
            const today = new Date();
            const cells = [];
            for(let i = $3f3707532d991625$var$TOTAL - 1; i >= 0; i--){
                const d = new Date(today);
                d.setDate(d.getDate() - i);
                const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                const entry = data[key] || {};
                cells.push({
                    date: key,
                    score: entry.score || 0,
                    standups: entry.standups || 0,
                    breakdown: entry.breakdown || {}
                });
            }
            return cells;
        }
    },
    Legend: {
        tag: 'div',
        flow: 'x',
        gap: 'Z',
        align: 'center right',
        fontSize: 'Y1',
        color: 'caption',
        Less: {
            tag: 'span',
            text: '{{ tickets.heatmap.legendLess | polyglot }}'
        },
        Box_1: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'white.03'
        },
        Box_2: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.15'
        },
        Box_3: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.3'
        },
        Box_4: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.5'
        },
        Box_5: {
            width: 'Y',
            height: 'Y',
            round: 'X',
            background: 'green.7'
        },
        More: {
            tag: 'span',
            text: '{{ tickets.heatmap.legendMore | polyglot }}'
        }
    },
    DetailsCard: {
        hide: (el, s)=>!s.root?._activitySelectedDate,
        flow: 'y',
        gap: 'Z1',
        marginTop: 'Z',
        padding: 'A',
        round: 'radiusCard',
        // Outline removed — banned (design-direction.md §8); `background:
        // 'title.04'` already gives this popover a tonal wash a step off the
        // heatmap's own ground, same precedent as ActivityChart's
        // line-bordered → overlay-fill conversion.
        background: 'title.04',
        Header: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            Title: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const date = s.root?._activitySelectedDate;
                    if (!date) return '';
                    const d = new Date(date + 'T00:00:00');
                    return el.call('localizedDate', d, {
                        weekday: 'long',
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                    });
                }
            },
            CloseBtn: {
                extends: 'CloseButton',
                onClick: (e, el, s)=>s.root?.update({
                        _activitySelectedDate: null,
                        _activityDetails: null
                    })
            }
        },
        Loading: {
            hide: (el, s)=>!s.root?._activitySelectedDate || !!s.root?._activityDetails,
            flow: 'y',
            gap: 'V',
            Row_1: {
                extends: 'SkeletonRow',
                width: '70%'
            },
            Row_2: {
                extends: 'SkeletonRow',
                width: '45%'
            }
        },
        Empty: {
            hide: (el, s)=>{
                const list = s.root?._activityDetails;
                return !Array.isArray(list) || list.length > 0;
            },
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontStyle: 'italic',
            text: '{{ tickets.heatmap.empty | polyglot }}'
        },
        List: {
            hide: (el, s)=>!(s.root?._activityDetails || []).length,
            flow: 'y',
            gap: 'V',
            childExtends: 'TicketsActivityRow',
            childrenAs: 'state',
            children: (el, s)=>s.root?._activityDetails || []
        }
    },
    // Fetch real activity data — ticket updates + standup completions.
    // Re-armed on every workspace change: see _activityRefetchNeeded above.
    onCreate: (el, s)=>$3f3707532d991625$var$_ticketsLoadActivity(el, s.root),
    // WS-SWITCH-INCOMPLETE-1: the widget outlives the switch, so the refetch has
    // to be driven from here. `subscribeTo` is required — the factory alone
    // registers no dependency on `workspace`, and this component's own reads are
    // all of `_activityData`.
    subscribeTo: [
        'workspace'
    ],
    onUpdate: (el, s)=>$3f3707532d991625$var$_ticketsLoadActivity(el, s.root)
};
const $3f3707532d991625$var$_ticketsLoadActivity = async (el, root)=>{
    if (!root) return;
    if (!$3f3707532d991625$export$741722114c558d5e(el, root)) return;
    // ⛔ CAPTURED HERE, BEFORE THE EMAIL POLL AND THE RPC. The reply must be
    // dropped if the user moved on; if it is dropped the tenant stamp above is
    // left pointing at the OLD workspace, so the next onUpdate re-arms and the
    // new tenant's grid still loads. Dropping is self-correcting, not a loss.
    const _write = (0, $4Cvgr.sameWorkspaceWriter)(root);
    let email = root.currentUserEmail;
    if (!email) await new Promise((resolve)=>{
        let attempts = 0;
        const check = setInterval(()=>{
            email = root.currentUserEmail;
            if (email || ++attempts > 30) {
                clearInterval(check);
                resolve();
            }
        }, 200);
    });
    if (!email) return;
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.activity heatmap
        const since = new Date();
        since.setDate(since.getDate() - 365);
        const sinceDate = since.toISOString().slice(0, 10);
        // Single RPC — wrapper aggregates every activity type and scopes
        // by caller's user_email + workspace_id from the JWT.
        const result = await el.call('getSDK').execute('workspaceProject.activity', 'heatmap', {
            filter: {
                user_email: email,
                since: sinceDate,
                select: 'activity_type, score, occurred_on'
            }
        });
        const data = Array.isArray(result?.data) ? result.data : result?.data || result || [];
        const counts = {};
        for (const row of data || []){
            const day = row.occurred_on;
            if (!day) continue;
            if (!counts[day]) counts[day] = {
                score: 0,
                standups: 0,
                breakdown: {}
            };
            counts[day].score += row.score || 0;
            counts[day].breakdown[row.activity_type] = (counts[day].breakdown[row.activity_type] || 0) + 1;
            if (row.activity_type === 'standup') counts[day].standups++;
        }
        _write({
            _activityData: counts
        });
    } catch (err) {
        console.error('[ActivityHeatmap]', err);
    }
};
// KEY-IN-STATE tables (I18N-CONVENTION §1.3): a LITERAL bundle key per
// activity type, and a one / many pair for the day tooltip's counts — Georgian
// keeps a noun singular after a numeral, English does not. An unknown type
// passes through verbatim, which polyglot echoes.
const $3f3707532d991625$var$_typeLabelKey = {
    standup: 'tickets.heatmap.type.standup',
    ticket_update: 'tickets.heatmap.type.ticketUpdate',
    note_edit: 'tickets.heatmap.type.noteEdit',
    kb_edit: 'tickets.heatmap.type.kbEdit',
    meet_call: 'tickets.heatmap.type.meetCall'
};
const $3f3707532d991625$var$_typeCountKeys = {
    ticket_update: [
        'tickets.heatmap.count.ticketUpdateOne',
        'tickets.heatmap.count.ticketUpdateMany'
    ],
    note_edit: [
        'tickets.heatmap.count.noteEditOne',
        'tickets.heatmap.count.noteEditMany'
    ],
    kb_edit: [
        'tickets.heatmap.count.kbEditOne',
        'tickets.heatmap.count.kbEditMany'
    ],
    meet_call: [
        'tickets.heatmap.count.meetCallOne',
        'tickets.heatmap.count.meetCallMany'
    ]
};
const $3f3707532d991625$var$_ticketsTypeLabel = (el, type)=>el.call('polyglot', $3f3707532d991625$var$_typeLabelKey[type] || type || '');
const $3f3707532d991625$var$_counted = (el, pair, n)=>{
    const sentence = el.call('polyglot', pair[n === 1 ? 0 : 1]);
    return sentence.replace('{count}', String(n));
};
// Takes BOTH the element and the root state, deliberately: `.update()` is a
// STATE method and `.call()` is an ELEMENT method. Passing only `s.root` (as
// this did until 2026-08-10) made every `.call('getSDK')` here throw
// "root.call is not a function" — silently, into a catch — so the heatmap
// never loaded a single day of data.
const $3f3707532d991625$var$_loadDetails = async (el, root, date)=>{
    // WS-SWITCH-INCOMPLETE-1: the rows below name workspace A's ticket and note
    // ids (`source_table` / `source_id` / `metadata`), and they are written after
    // an await. Captured before the RPC — see sameWorkspaceWriter's note.
    const _write = (0, $4Cvgr.sameWorkspaceWriter)(root);
    root.update({
        _activitySelectedDate: date,
        _activityDetails: null
    });
    try {
        // migrated 2026-04-27 to SDK route workspaceProject.activity listEvents
        const result = await el.call('getSDK').execute('workspaceProject.activity', 'listEvents', {
            filter: {
                user_email: root.currentUserEmail,
                occurred_on: date,
                select: 'activity_type, score, source_table, source_id, metadata, created_at'
            },
            order: {
                column: 'created_at',
                ascending: true
            }
        });
        const data = Array.isArray(result?.data) ? result.data : result?.data || result || [];
        // ⛔ THE PATCH IS ONE KEY, AND THE DROP IS COMPLETE. Unlike globalSearch,
        // there is no transport flag to settle separately: the panel's `hide:`
        // reads `_activitySelectedDate`, which the switch already wiped to null,
        // so a dropped reply leaves the drill-down CLOSED rather than spinning.
        _write({
            _activityDetails: data || []
        });
    } catch (err) {
        console.error('[ActivityHeatmap details]', err);
        _write({
            _activityDetails: []
        });
    }
};
const $3f3707532d991625$export$52a5c40ae49b3f97 = {
    width: '100%',
    aspectRatio: '1',
    // A placeholder cell (the grid before first paint) holds the row height only.
    visibility: (el, s)=>s.placeholder ? 'hidden' : 'visible',
    round: 'X',
    background: (el, s)=>$3f3707532d991625$var$_intensity(s.score, s.standups > 0),
    border: 'none',
    cursor: (el, s)=>s.score || s.standups ? 'pointer' : 'default',
    transition: 'background Z defaultBezier',
    ':hover': {
        outline: '1px solid var(--color-title)'
    },
    title: (el, s)=>{
        if (!s.score && !s.standups) return s.date;
        const parts = [];
        if (s.standups) parts.push(el.call('polyglot', 'tickets.heatmap.tooltip.standup'));
        const bd = s.breakdown || {};
        for (const [k, n] of Object.entries(bd)){
            if (k === 'standup') continue;
            // A type with no count pair (an unknown one) keeps "n type".
            parts.push($3f3707532d991625$var$_typeCountKeys[k] ? $3f3707532d991625$var$_counted(el, $3f3707532d991625$var$_typeCountKeys[k], n) : `${n} ${$3f3707532d991625$var$_ticketsTypeLabel(el, k)}`);
        }
        const points = $3f3707532d991625$var$_counted(el, [
            'tickets.heatmap.count.pointOne',
            'tickets.heatmap.count.pointMany'
        ], s.score);
        return `${s.date} \xb7 ${points}${parts.length ? " \u2014 " + parts.join(', ') : ''}`;
    },
    onClick: (e, el, s)=>{
        if (!s.score && !s.standups) return;
        $3f3707532d991625$var$_loadDetails(el, s.root, s.date);
    }
};
const $3f3707532d991625$var$_typeColor = (t)=>t === 'standup' ? 'green' : t === 'meet_call' ? 'purple' : t === 'kb_edit' || t === 'note_edit' ? 'cerulean' : 'blue';
const $3f3707532d991625$var$_hhmmss = (ts)=>{
    try {
        return new Date(ts).toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
    } catch  {
        return '';
    }
};
const $3f3707532d991625$var$_detailFor = (s)=>{
    const md = s.metadata || {};
    return md.title || md.summary || md.body || (s.source_id ? `${s.source_table || 'item'}\xb7${s.source_id}` : '');
};
const $3f3707532d991625$export$93b233bf25ccedc5 = {
    flow: 'x',
    gap: 'Z',
    align: 'baseline left',
    padding: 'X Z',
    fontFamily: 'mono',
    fontSize: 'Y2',
    lineHeight: '1.5',
    ':hover': {
        background: 'hover'
    },
    Time: {
        tag: 'span',
        color: 'caption',
        flexShrink: '0',
        text: (el, s)=>$3f3707532d991625$var$_hhmmss(s.created_at)
    },
    Type: {
        tag: 'span',
        flexShrink: '0',
        minWidth: 'C',
        fontWeight: '700',
        color: (el, s)=>$3f3707532d991625$var$_typeColor(s.activity_type),
        // CSS uppercase — `String#toUpperCase` turns a Georgian label into Mtavruli.
        textTransform: 'uppercase',
        text: (el, s)=>$3f3707532d991625$var$_ticketsTypeLabel(el, s.activity_type)
    },
    Detail: {
        tag: 'span',
        flex: '1',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>$3f3707532d991625$var$_detailFor(s)
    }
};

});
parcelRegister("4Cvgr", function(module, exports) {

$parcel$export(module.exports, "wsIdOf", () => $35d2f672db64e9c6$export$2f030010e0ef3300);
$parcel$export(module.exports, "sameWorkspaceWriter", () => $35d2f672db64e9c6$export$a8d9ac2d63d85b3b);
// WS-SWITCH-INCOMPLETE-1 — the tickets package's copy of the canonical "drop a
// reply that outlived its tenant" writer.
//
// THE CLASS IT CLOSES. Registering a key as workspace-scoped (the shell's
// state-app.js) wipes it ON the switch. It cannot stop a request ISSUED in
// workspace A from writing its reply into workspace B afterwards, and that is
// the harder half, because the result looks freshly fetched and the wipe has
// already happened, so nothing corrects it again. Every write that lands after
// an `await` on a workspace-scoped key needs this.
//
// DROPPING is right rather than rerouting or retrying: the payload describes a
// workspace the user is no longer looking at, and PHASE-1 of the switch has
// already restored the correct empty for the one they are.
//
// ⛔ CAPTURE BEFORE THE AWAIT. `sameWorkspaceWriter(root)` must be called on
// the SAME tick as the request, before the first `await` — it snapshots the
// workspace id at call time. Calling it inside the `.then()` snapshots the NEW
// workspace and the guard can never fire.
//
// ⛔ WHY THIS FILE EXISTS TWICE. The shell owns the canonical copy at
// workspace/functions/sameWorkspaceWriter.js. `tickets` is a SUB-APP and must
// not import the shell, so the two are kept byte-identical below the comments
// by __tests__/activityPlaneTenantScope.test.js's drift pin (it strips comments
// and compares code, so documenting each copy in its own words is not a drift).
// Consumers inside this package import THIS module — never re-inline it.
// Both id shapes are live on root: `workspace.id` from the SDK's workspace
// payload and `workspace._id` from the raw Mongo document. Stringified so a
// numeric id and its string form never read as two different tenants.
const $35d2f672db64e9c6$export$2f030010e0ef3300 = (root)=>String(root?.workspace?.id || root?.workspace?._id || '');
const $35d2f672db64e9c6$export$a8d9ac2d63d85b3b = (root)=>{
    // Keep the registered function self-contained when Frank revives its source.
    const idOf = (state)=>String(state?.workspace?.id || state?.workspace?._id || '');
    const issuedFor = idOf(root);
    return (patch)=>{
        if (idOf(root) !== issuedFor) return false;
        root.update(patch);
        return true;
    };
};

});


parcelRegister("Ty3kE", function(module, exports) {

$parcel$export(module.exports, "TicketsFilterGroups", () => $0a6f8d55870db5cc$export$f47be7082a317453);
$parcel$export(module.exports, "TicketsSidebar", () => $0a6f8d55870db5cc$export$c790f45a111bc062);
$parcel$export(module.exports, "TicketsSidebarItem", () => $0a6f8d55870db5cc$export$29ab116f87e5a68f);
$parcel$export(module.exports, "TicketsSidebarGroup", () => $0a6f8d55870db5cc$export$cff5571d7e1f7a50);
$parcel$export(module.exports, "TicketsTypeBtn", () => $0a6f8d55870db5cc$export$f61d282e0a1d1538);
$parcel$export(module.exports, "TicketsTypeGroup", () => $0a6f8d55870db5cc$export$5bfe1dd711893e1b);
$parcel$export(module.exports, "TicketsAssigneePicker", () => $0a6f8d55870db5cc$export$6a04d66493fd5c99);
$parcel$export(module.exports, "TicketsIssuerPicker", () => $0a6f8d55870db5cc$export$82e16e1114f61dbe);
$parcel$export(module.exports, "TicketsDraftsToggle", () => $0a6f8d55870db5cc$export$dc5930b6660f66fd);
$parcel$export(module.exports, "TicketsDraftsGroup", () => $0a6f8d55870db5cc$export$227b58e51f355aa4);
$parcel$export(module.exports, "TicketsEpicPicker", () => $0a6f8d55870db5cc$export$675a4e5cfe0932e);
$parcel$export(module.exports, "TicketsEpicGroup", () => $0a6f8d55870db5cc$export$f5fb14d35d38999c);
$parcel$export(module.exports, "TicketsAssigneeGroup", () => $0a6f8d55870db5cc$export$f77b2e3d9c7e9ce1);
$parcel$export(module.exports, "TicketsIssuerGroup", () => $0a6f8d55870db5cc$export$6eb7e71617804906);
// stripWorkspacePrefix comes from @symbo-ls/workspace-shared, stubbed by
// frank's EXTERNAL_PACKAGES at serialization time — reach it via el.call
// instead of a raw import (see TicketDetailModal.js for the full rationale).

var $jXdHE = parcelRequire("jXdHE");
const $0a6f8d55870db5cc$export$f47be7082a317453 = {
    flow: 'y',
    // Flex child in both hosts — a long picker label (a person's full name, an
    // epic title) must ellipsize, never widen the rail into horizontal overflow.
    minWidth: '0',
    // ── FILTER TYPE — issue-type filters: Features / Improvements / Bugs
    // (2026-06-14 per Nika "change name of APPLICATION to Filter Type"). ──
    TicketsTypeGroup: {},
    // ── ASSIGNEE — pick people to filter the board by assignee (multi). ──
    TicketsAssigneeGroup: {},
    // ── ISSUER — pick people to filter the board by reporter (multi). ──
    TicketsIssuerGroup: {},
    // ── EPIC — filter the board by epic (single-select picker). ──
    TicketsEpicGroup: {},
    // ── DRAFTS — show/hide draft tickets (cards dragged out of columns). ──
    TicketsDraftsGroup: {}
};
const $0a6f8d55870db5cc$export$c790f45a111bc062 = {
    extends: 'AppSidebar',
    tag: 'nav',
    'aria-label': (el)=>el.call('polyglot', 'tickets.sidebar.navLabel'),
    // On the page-sidebar rule (shared functions/pageSidebar.js, Nika
    // 2026-10-29): every tasks page's rail takes the side the navbar does not
    // take and carries the one hide button; all tasks pages share one choice.
    // The pages that float this rail (board.js, epics.js) mirror their own
    // `left` anchor.
    pageSidebar: true,
    // No PeopleSection on tickets
    PeopleSection: null,
    // Top section (WorkspaceSwitcher pinned below the AppHeader) removed —
    // the org switcher already lives in the global AppHeader, so showing
    // a second copy at the top of the tickets sidebar was a redundant
    // control. Set to `null` (not deleted) to override the AppSidebar
    // base which still declares a Top slot.
    Top: null,
    Middle: {
        overflow: 'auto',
        flex: '1',
        minWidth: '0',
        // LIGHT-MODE SURFACE SWAP (2026-08-23 per Nika "in light mode backgrounds
        // are inverted") — mirror of the change in TicketsKanban.js: in light this
        // card wears the surface the kanban columns used to have (gray16.95+6)
        // and the columns wear `overlayStrong`. Since the sidebar card pass (Nika
        // 2026-10-30 "A: navbar glass") that fill comes from the column's sidebar
        // card itself — the brand `navbar` @light fill is the same gray16.95+6 —
        // so this card keeps no copy of it (components/lightSurfaceSwap.test.js).
        // Filter groups — bare key onto the single source above. The phone sheet
        // mounts this exact component, so the two never drift.
        TicketsFilterGroups: {}
    }
};
// ── Sidebar item — extends SidebarRow with route-based active state ──
// Active when this item's view is the one showing in the PageSlot. Sidebar
// items open the selected /tickets/* route in the shell PageSlot by setting
// `root._canvasSlot` (the same slot /studio + /infra use — unified 2026-07-10
// per Nika "use PageSlot for all opening across all pages", replacing the old
// in-canvas TicketsViewHost). The kanban Board is the "no view" base, so the
// Board row is active whenever nothing is selected.
const $0a6f8d55870db5cc$var$_itemActive = (el, s)=>{
    // Everything normalizes to the canonical /tasks form so items match
    // whichever alias (/tasks/* or legacy /tickets/*) the slot/URL carries.
    const view = (0, $jXdHE.canonicalTaskPath)((s.root?._canvasSlot || '').split('?')[0]);
    const href = (0, $jXdHE.canonicalTaskPath)(el.href || '');
    if (href === '/tasks/board') return !view;
    if (view) return view === href;
    return (0, $jXdHE.canonicalTaskPath)(el.call('stripWorkspacePrefix', s.root?.currentPath || s.root?.route || '/')) === href;
};
const $0a6f8d55870db5cc$export$29ab116f87e5a68f = {
    extends: 'SidebarRow',
    // Board is ALWAYS listed. Clicking it clears `_canvasSlot` to return to the
    // kanban base view (see onClick) — a meaningful action regardless of how the
    // Tickets section was reached. The previous hide (Board hidden whenever
    // root.selectedPage matched /tickets) wrongly removed the row when the user
    // navigated in via the apps dropdown/icon — that path sets selectedPage to a
    // /tickets route too, so the Board nav row vanished from the side nav.
    // (ticket 6a331f77 — "Board is missing from the side nav".)
    // Expose the active view to assistive tech alongside the visual wash.
    attr: {
        'aria-current': (el, s)=>$0a6f8d55870db5cc$var$_itemActive(el, s) ? 'page' : undefined
    },
    padding: 'Z A',
    round: 'radiusPill',
    fontSize: 'A',
    // Active state matches the FILTER TYPE rows: frosted white-wash pill + title
    // text. Driven by the .isActive CONDITIONAL CLASS — NOT reactive background/
    // color/fontWeight factories, which emit INLINE node styles that clobber the
    // :hover wash (an inline style beats any :hover class), leaving the row with no
    // visible hover feedback. The class-based active state lets :hover render.
    // (2026-06-15 per Nika "make all active state colors on sidebar just like
    // FILTER TYPE".)
    isActive: (el, s)=>$0a6f8d55870db5cc$var$_itemActive(el, s),
    color: 'caption',
    fontWeight: '500',
    '.isActive': {
        background: 'selected',
        color: 'title',
        fontWeight: '700'
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    Icon: {
        // Fixed square slot, centered glyph — glyph aspect ratios differ per
        // icon, so without the reserved slot every row's label started at a
        // slightly different x (2026-08-06 per Nika "fix filter and + icon
        // alignment in buttons on /tasks").
        boxSize: 'A',
        minWidth: 'A',
        flexShrink: '0',
        align: 'center center',
        color: (el, s)=>$0a6f8d55870db5cc$var$_itemActive(el.parent, s) ? 'title' : 'caption'
    },
    // Open the selected /tickets/* route in the shell PageSlot (unified 2026-07-10
    // per Nika "use PageSlot for all opening across all pages"). Setting
    // `root._canvasSlot` mounts that page in the PageSlot's tickets variant —
    // beside the floating rail (the rail stays the switcher). The kanban Board is
    // the base view, so the Board row clears the slot (back to the kanban).
    onClick: (e, el, s)=>{
        e.preventDefault();
        const root = s.root;
        if (!root) return;
        if ((0, $jXdHE.canonicalTaskPath)(el.href || '') === '/tasks/board') {
            root.update({
                _canvasSlot: null
            });
            return;
        }
        root.update({
            _canvasSlot: el.href
        });
    },
    // Local override of the shared SidebarRow's Label. That component lives in
    // `packages/workspace` and renders `el.parent.label` verbatim, so a row
    // carrying a bundle KEY would ship the raw dotted key. Resolving here keeps
    // the change inside this package (CLAUDE.md: prefer a local override), and
    // polyglot returns a non-key verbatim so a server-supplied label still works.
    Label: {
        text: (el)=>el.call('polyglot', el.parent?.label || '')
    },
    // No row "···" menu — the pin/customize actions belonged to the removed
    // TICKETS nav list (rail simplified to filters-only, 2026-07-25 per Nika).
    MoreBtn: null
};
const $0a6f8d55870db5cc$export$cff5571d7e1f7a50 = {
    flow: 'y',
    gap: 'Z',
    marginBottom: 'A',
    Header: {
        flow: 'x',
        align: 'center left',
        padding: 'V 0',
        CaptionTitle: {
            flex: '1',
            fontSize: 'Y2',
            Text: {
                // The group's `label` is a bundle KEY (this component is extended with
                // static labels only); polyglot returns a non-key verbatim.
                text: (el)=>el.call('polyglot', el.parent?.parent?.parent?.label || '')
            }
        }
    }
};
const $0a6f8d55870db5cc$export$f61d282e0a1d1538 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z A',
    round: 'radiusPill',
    minHeight: 'controlHCompact',
    cursor: 'pointer',
    fontSize: 'A',
    textDecoration: 'none',
    fontWeight: (el, s)=>(s.root?.filterIssueType || 'all') === (el.value || 'all') ? '700' : '500',
    // Active state mirrors the /files FilesSidebar rows (2026-06-14 per Nika
    // "active state matches FilesSidebar"): a frosted white-wash pill + title
    // text when active; caption text + color-only hover otherwise.
    background: (el, s)=>(s.root?.filterIssueType || 'all') === (el.value || 'all') ? 'selected' : 'transparent',
    color: (el, s)=>(s.root?.filterIssueType || 'all') === (el.value || 'all') ? 'title' : 'caption',
    borderWidth: '0',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // Every filter row of the rail eases its hover fill on the same motion
    // token (brand motion budget: hovers on defaultBezier).
    transition: 'background Z defaultBezier',
    // State-only — the board page's subscribed watcher owns the refetch
    // (_loadBoard, sequence-guarded). Calling reloadTickets here as well
    // created dueling async writers whose stale/empty wave could land last
    // and blank the filtered board.
    // Toggle: clicking the active type again clears the filter (no "All" row).
    // Press feedback completes the row's interactive states (hover exists
    // above): a slightly deeper wash while the pointer is down.
    ':active': {
        background: 'selected'
    },
    onClick: (e, el, s)=>{
        const cur = s.root?.filterIssueType || null;
        if (el.value === 'all') s.root.update({
            filterIssueType: null
        });
        else s.root.update({
            filterIssueType: cur === el.value ? null : el.value
        });
    },
    Icon: {
        // A fixed, centered icon slot, so the labels of every row start on one
        // line whatever the glyph's own width.
        icon: (el)=>el.parent?.icon || 'state',
        boxSize: 'A',
        minWidth: 'A',
        flexShrink: '0',
        align: 'center center'
    },
    Label: {
        tag: 'span',
        text: (el)=>el.call('polyglot', el.parent?.label || ''),
        flex: '1'
    },
    Count: {
        tag: 'span',
        text: (el, s)=>{
            const counts = s.root?.totalByType || {};
            const val = el.parent?.value || 'all';
            return counts[val] !== undefined ? String(counts[val]) : '';
        },
        opacity: '0.6',
        fontSize: 'Z2'
    }
};
const $0a6f8d55870db5cc$export$5bfe1dd711893e1b = {
    extends: 'TicketsSidebarGroup',
    label: 'tickets.sidebar.group.filterType',
    List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'TicketsTypeBtn',
        children: [
            {
                value: 'all',
                label: 'tickets.sidebar.type.all',
                icon: 'grid'
            },
            {
                value: 'bug',
                label: 'tickets.sidebar.type.bugs',
                icon: 'bug'
            },
            {
                value: 'task',
                label: 'tickets.sidebar.type.tasks',
                icon: 'check'
            }
        ]
    },
    DividerTop: {
        height: '1px',
        background: 'line',
        margin: 'V 0',
        width: '100%'
    },
    FeaturesBtn: {
        extends: 'TicketsTypeBtn',
        value: 'user_story',
        label: 'tickets.sidebar.type.featuresAndStories',
        icon: 'magicstar',
        padding: 'A',
        margin: 'V 0 0 0'
    },
    DividerBottom: {
        height: '1px',
        background: 'line',
        margin: 'V 0',
        width: '100%'
    }
};
// ── ASSIGNEE / ISSUER filters — MULTI-SELECT person pickers (2026-07-25 per
// Nika "allow multiple selects in assignee and assigned filters"). The row
// shows the picked people ("Anyone" / a name / "Name +N"); clicking opens the
// house ContextDropdown whose rows are built REACTIVELY via the registered
// itemsFn (ticketsAssigneePickItems / ticketsIssuerPickItems) so the check
// marks track the live filter arrays while the menu stays open. Picking
// routes through `applyTicketsFilterPick` which TOGGLES the email in the
// array. The board's subscribed watcher refetches — STATE-ONLY here (a manual
// reloadTickets would race the watcher — same hazard noted on TicketsTypeBtn).
// Explicitly picked emails (array). Category values ('all'/'team'/'agents'/
// 'me', set by other assignee controls) read as "Anyone" here.
const $0a6f8d55870db5cc$var$_pickedEmails = (root, field)=>{
    const v = root?.[field];
    if (Array.isArray(v)) return v;
    if (!v || [
        'all',
        'team',
        'agents',
        'me'
    ].includes(v)) return [];
    return [
        v
    ];
};
const $0a6f8d55870db5cc$var$_pickedPerson = (root, email)=>(root?.people || []).find((p)=>(p.email || '').toLowerCase() === String(email).toLowerCase()) || {
        email: email
    };
// INTERACT-1: the Assignee/Issuer/Epic filter Pickers open the shared
// ContextDropdown (root.contextDropdown), which ALREADY implements full
// keyboard nav — Down/Up/Home/End cycling (Menu.onKeydown → menuLevelNav)
// and Escape-close (same onKeydown) — see packages/shared/components/
// ContextDropdown.js. DOM-verified this menu's keyboard model works
// correctly everywhere else it's used (chat/home/files context menus).
// The bug is narrower than "no keyboard nav": nothing ever moves DOM focus
// INTO the menu when a Picker opens it, so every arrow-key/Escape press
// keeps firing on the still-focused Picker `<button>` instead of bubbling
// through Menu's onKeydown at all — the menu's own handlers never see the
// keystroke. Fixed at the opener (here), not in the shared component: reuse
// the exact bounded-poll "focus the first row once it exists in the DOM"
// technique ContextDropdownItem.scope.openSubmenu already uses for its own
// submenu flyout (same shape of problem — the row doesn't exist until the
// state commit lands and the previously display:none panel paints).
// `[data-key="ContextDropdown"]` is the same selector packages/canvas/
// functions/canvasContextMenu.js already relies on to find this ONE
// globally-mounted instance (it isn't a DOM descendant of the Picker button
// that opens it, so there's no local `el.node` to query from here).
//
// Real DOM focus movement — NOT aria-activedescendant — deliberately
// matches the pattern every other ContextDropdown consumer in this app
// already uses (menuLevelNav moves real focus onto each `[role="menuitem"]`
// row as you arrow through). Layering a parallel aria-activedescendant
// scheme on top would contradict that established, working contract rather
// than reuse it, and is redundant once real focus is already moving through
// the rows — assistive tech gets a real focus event per row either way.
const $0a6f8d55870db5cc$var$_focusContextMenuFirstItem = ()=>{
    if (typeof document === 'undefined') return;
    let tries = 0;
    const tryFocus = ()=>{
        const first = document.querySelector('[data-key="ContextDropdown"] [role="menuitem"]');
        if (first && first.focus) first.focus();
        else if (++tries < 10) window.setTimeout(tryFocus, 30);
    };
    window.setTimeout(tryFocus, 0);
};
const $0a6f8d55870db5cc$var$_personPicker = ({ field: pickerField, itemsFn: pickerItemsFn, glyph: glyph })=>({
        // Factory closure captures — `pickerField` and `pickerItemsFn` are read
        // inside reactive props (background/color/Label.text) and the onClick
        // handler below. Frank strips JS closures at serialization time;
        // `scope: {}` travels the captured values with the element so the bare
        // identifier references stay resolvable at runtime (FA205 —
        // factory-closure).
        //
        // Named `pickerField`/`pickerItemsFn`, NOT the shorter `field`/`itemsFn` —
        // frank's scope-rewriter matches bare-identifier reads against the scope
        // KEY NAME across the whole emitted bundle, not just this component's own
        // subtree. `field` collides with the many unrelated local PARAMETERS
        // named `field` elsewhere in this package (patchTicketField,
        // _showField, _personPickItems, …) and the rewrite corrupted one of
        // those signatures (`function(root, field)` → `function(root, this.field)`)
        // the first time this was tried. Picking collision-proof names sidesteps
        // the bug outright (see tickets/smbls.md for the framework-level report).
        scope: {
            pickerField: pickerField,
            pickerItemsFn: pickerItemsFn
        },
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        width: '100%',
        padding: 'Z A',
        round: 'radiusPill',
        minHeight: 'controlHCompact',
        cursor: 'pointer',
        borderWidth: '0',
        fontSize: 'A',
        textAlign: 'left',
        // FilesSidebar active wash when at least one person is picked.
        background: (el, s)=>$0a6f8d55870db5cc$var$_pickedEmails(s.root, pickerField).length ? 'selected' : 'transparent',
        color: (el, s)=>$0a6f8d55870db5cc$var$_pickedEmails(s.root, pickerField).length ? 'title' : 'caption',
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        // Same hover motion as every filter row (see TicketsTypeBtn).
        transition: 'background Z defaultBezier',
        // First picked person's avatar (when anyone is selected) …
        //
        // The `hide:`/`hide:` pair below is deliberate and stays. An earlier note
        // here justified it by claiming `if:` is inert in this v3.14 build; that
        // claim is stale — smbls create.js evaluates `if:` before `cacheNode`,
        // returns without a node when it is false, and registers a reactive
        // `registerIfEffect` so the element can appear later. It is NOT changed
        // here only because this pair is measured working and a hidden <img>
        // carrying NO src attribute issues no request either.
        //
        // What DID have to change is the `src` fallback. It answered `''` for the
        // nobody-picked case, and an empty src is not "no image": the browser
        // resolves it against the DOCUMENT URL and fires a real, failing request.
        // smbls's attribute effect calls `removeAttribute` when a src factory
        // answers null (create.js), so absence was already handled correctly and
        // the `|| ''` was undoing it. Six catalog specimens reported the resulting
        // image error, all of them this one row (2026-09-20). Pinned by
        // __tests__/pickerAvatarEmptySrc.test.js.
        Avatar: {
            extends: 'Avatar',
            width: 'A',
            height: 'A',
            minWidth: 'A',
            hide: (el, s)=>!($0a6f8d55870db5cc$var$_pickedEmails(s.root, pickerField).length > 0),
            src: (el, s)=>{
                const emails = $0a6f8d55870db5cc$var$_pickedEmails(s.root, pickerField);
                return emails.length ? el.call('avatarUrlFor', emails[0]) : null;
            }
        },
        // … or a generic glyph when showing "Anyone".
        Icon: {
            extends: 'Icon',
            // `name:`, not `icon:` — #234 renamed Icon's prop from `icon` to `name`
            // everywhere else in this file (Chevron below, TicketsEpicPicker's own
            // Icon/Chevron); this dynamic (`glyph` variable, not a literal) case was
            // missed by the mechanical sweep. Under the parent IconText.Icon `if:`
            // gate, `icon: X` never creates the child at all — the people/user glyph
            // silently never rendered.
            name: glyph,
            boxSize: 'A',
            minWidth: 'A',
            color: 'caption',
            hide: (el, s)=>!!$0a6f8d55870db5cc$var$_pickedEmails(s.root, pickerField).length
        },
        Label: {
            tag: 'span',
            flex: '1',
            // Explicit flex-child floor — the picker sits in a G1 rail on desktop and a
            // 86vw sheet on phones; a long full name must ellipsize, never widen either.
            minWidth: '0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'left',
            text: (el, s)=>{
                const emails = $0a6f8d55870db5cc$var$_pickedEmails(s.root, pickerField);
                if (!emails.length) return el.call('polyglot', 'tickets.filter.anyone');
                const first = $0a6f8d55870db5cc$var$_pickedPerson(s.root, emails[0]);
                const name = first.name || first.username || first.email;
                return emails.length > 1 ? `${name} +${emails.length - 1}` : name;
            }
        },
        Chevron: {
            extends: 'Icon',
            name: 'arrowAngleDown',
            boxSize: 'Z1',
            color: 'caption'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const root = s.root;
            if (!root || !el.node) return;
            // Agents list below humans in the picker — the shared roster is empty
            // until /team-and-agents has run, so kick the tickets-side one-shot
            // fill (fire-and-forget; on landing it refreshes the open menu).
            el.call('ensureTicketsAgentsRoster');
            const r = el.node.getBoundingClientRect();
            root.update({
                contextDropdown: {
                    open: true,
                    x: Math.round(r.left),
                    y: Math.round(r.bottom + 6),
                    // Explicit `el.scope.pickerItemsFn` — the scope-rewriter's
                    // bare-identifier rewrite only fires for the CSS-prop-style reads it
                    // statically recognizes (background/color/text); a shorthand object
                    // property buried inside an onClick body is outside that pattern and
                    // is left as a bare, unresolvable read (FA205). Reading it off
                    // `el.scope` directly needs no rewrite at all.
                    itemsFn: el.scope.pickerItemsFn,
                    actionFn: 'applyTicketsFilterPick'
                }
            });
            // INTERACT-1: move real DOM focus into the menu so Down/Up/Home/End +
            // Escape (already implemented on the shared ContextDropdown's Menu) are
            // actually reachable — see _focusContextMenuFirstItem's header comment.
            $0a6f8d55870db5cc$var$_focusContextMenuFirstItem();
        }
    });
const $0a6f8d55870db5cc$export$6a04d66493fd5c99 = $0a6f8d55870db5cc$var$_personPicker({
    field: 'filterAssignee',
    itemsFn: 'ticketsAssigneePickItems',
    glyph: 'people'
});
const $0a6f8d55870db5cc$export$82e16e1114f61dbe = $0a6f8d55870db5cc$var$_personPicker({
    field: 'filterIssuer',
    itemsFn: 'ticketsIssuerPickItems',
    glyph: 'user'
});
const $0a6f8d55870db5cc$export$dc5930b6660f66fd = {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z1',
    padding: 'Z A',
    round: 'radiusPill',
    minHeight: 'controlHCompact',
    cursor: 'pointer',
    fontSize: 'A',
    color: (el, s)=>s.root?._showDrafts ? 'title' : 'caption',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // Same hover motion as every filter row (see TicketsTypeBtn).
    transition: 'background Z defaultBezier',
    onClick: (e, el, s)=>{
        el.call('setTicketsBoardPref', {
            _showDrafts: !s.root?._showDrafts
        });
    },
    Left: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        minWidth: '0',
        Icon: {
            name: 'edit',
            boxSize: 'A',
            minWidth: 'A'
        },
        Label: {
            tag: 'span',
            minWidth: '0',
            text: '{{ tickets.sidebar.drafts.label | polyglot }}'
        }
    },
    Switch: {
        extends: 'SwitchInput',
        // `onCheck` (not isChecked) — v3.14 freezes ordinary function props at
        // create; on*-prefixed props stay callable so the switch's reactive
        // track/knob factories re-dispatch per repaint (SwitchInput contract).
        onCheck: (el, s)=>!!s.root?._showDrafts,
        aria: {
            label: (el)=>el.call('polyglot', 'tickets.sidebar.drafts.aria')
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('setTicketsBoardPref', {
                _showDrafts: !s.root?._showDrafts
            });
        }
    }
};
const $0a6f8d55870db5cc$export$227b58e51f355aa4 = {
    extends: 'TicketsSidebarGroup',
    label: 'tickets.sidebar.group.drafts',
    List: {
        flow: 'y',
        gap: 'V',
        Toggle: {
            extends: 'TicketsDraftsToggle'
        }
    }
};
const $0a6f8d55870db5cc$export$675a4e5cfe0932e = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    width: '100%',
    padding: 'Z A',
    round: 'radiusPill',
    minHeight: 'controlHCompact',
    cursor: 'pointer',
    borderWidth: '0',
    fontSize: 'A',
    textAlign: 'left',
    background: (el, s)=>s.root?.filterEpic ? 'selected' : 'transparent',
    color: (el, s)=>s.root?.filterEpic ? 'title' : 'caption',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // Same hover motion as every filter row (see TicketsTypeBtn).
    transition: 'background Z defaultBezier',
    Icon: {
        extends: 'Icon',
        name: 'star',
        boxSize: 'A',
        minWidth: 'A',
        color: 'caption'
    },
    Label: {
        tag: 'span',
        flex: '1',
        // Same flex-child floor as the person pickers — epic titles are long.
        minWidth: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'left',
        text: (el, s)=>s.root?.filterEpic || el.call('polyglot', 'tickets.filter.anyEpic')
    },
    Chevron: {
        extends: 'Icon',
        name: 'arrowAngleDown',
        boxSize: 'Z1',
        color: 'caption'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const root = s.root;
        if (!root || !el.node) return;
        const r = el.node.getBoundingClientRect();
        // Lazy-load the epic-type ticket rows once (same consolidated loader the
        // detail modal + Manage Epics modal use — see loadEpicsTree). The picker
        // itself always shows the wider ticketsEpicNames union (epicsTree ∪
        // free-text epicName values already on tickets), so this fetch only
        // needs to run when epicsTree hasn't landed yet.
        if (!root.epicsTree?.length) el.call('loadEpicsTree').then(()=>{
            // Refresh the open menu so the fetched rows appear in place.
            const dd = root.contextDropdown;
            if (dd) root.update({
                contextDropdown: {
                    ...dd
                }
            });
        });
        root.update({
            contextDropdown: {
                open: true,
                x: Math.round(r.left),
                y: Math.round(r.bottom + 6),
                itemsFn: 'ticketsEpicPickItems',
                actionFn: 'applyTicketsFilterPick'
            }
        });
        // INTERACT-1: see _focusContextMenuFirstItem's header comment (same fix
        // as TicketsAssigneePicker/TicketsIssuerPicker above).
        $0a6f8d55870db5cc$var$_focusContextMenuFirstItem();
    }
};
const $0a6f8d55870db5cc$export$f5fb14d35d38999c = {
    extends: 'TicketsSidebarGroup',
    label: 'tickets.sidebar.group.epic',
    List: {
        flow: 'y',
        gap: 'V',
        Picker: {
            extends: 'TicketsEpicPicker'
        }
    }
};
const $0a6f8d55870db5cc$export$f77b2e3d9c7e9ce1 = {
    extends: 'TicketsSidebarGroup',
    label: 'tickets.sidebar.group.assignee',
    List: {
        flow: 'y',
        gap: 'V',
        Picker: {
            extends: 'TicketsAssigneePicker'
        }
    }
};
const $0a6f8d55870db5cc$export$6eb7e71617804906 = {
    extends: 'TicketsSidebarGroup',
    label: 'tickets.sidebar.group.issuer',
    List: {
        flow: 'y',
        gap: 'V',
        Picker: {
            extends: 'TicketsIssuerPicker'
        }
    }
};

});


parcelRegister("ktBWQ", function(module, exports) {
// Eager slim slice of the tickets function barrel (#16 tickets slim).
//
// The full `./index.js` barrel re-exports the tickets function surface
// (ticketUtils, saveTicket, ticketLoaders, fetchResolutions,
// ticketStore, cycleStore, …). The unified shell used to drag ALL of it into its
// EAGER chunk by folding the tickets context via `sharedLibraries.js`.
//
// Tickets is now a lazy sub-app: the `/tickets*` + `/resolutions*` routes fold
// the FULL tickets context (components + functions + state) into the live shell
// context on first mount (workspace/pages/index.js → lazySharedLibPage). So the
// eager chunk only needs the tickets functions that get el.call'd from OUTSIDE a
// tickets-mounted component — i.e. on a surface that never folds the tickets
// context.
//
// An exhaustive grep of the whole eager surface (workspace app.js/pages/
// components/functions, shared/**, canvas, and the other lazy sub-apps' eager
// contexts) for `.call('<ticketsFn>')` found exactly these cross-route callers:
//   • saveTicket — el.call'd by the eager TicketsDetailModal (save),
//     the workspace AI layer (functions/aiWorkspaceOps.js aiUpdateTicket /
//     aiCreateTicket) on ANY route, and meet's openSuggestionModal (/meet).
//   • deleteTicket — el.call'd by TicketsDetailModal (delete) + the
//     AI layer (aiWorkspaceOps.js aiDeleteTicket).
//   • moveTicket — el.call'd by TicketsDetailModal (state change) + the AI layer
//     (aiWorkspaceOps.js aiMoveTicket).
//   • reloadTickets — el.call'd by the eager TicketsSidebar (filter apply),
//     which mounts on /tickets/status without folding.
//   • freshTicket — el.call'd by chat's MessageList (/chat) to seed a ticket
//     draft from a message.
// saveTicket.js carries save/delete/move; ticketUtils.js carries
// freshTicket (+ the colour maps / boilerplate fetch the modal & sidebar import
// directly); ticketLoaders.js carries reloadTickets. Every OTHER tickets function
// (getTicketStore, loadCycles, fetchResolutions, fetchGeneralTriage, …) is only
// ever el.call'd from a tickets-mounted component, i.e. AFTER a fold registers
// it — so it rides the lazy chunk, not this one.
//
// Byte note: ticketUtils.js is already eager (statically imported by the eager
// TicketDetailModal.js) and ticketLoaders.js is already eager (statically
// imported by workspace/pages/main.js). Only saveTicket.js is a net
// new eager module (~16KB) — the price of keeping the modal + AI writes + meet
// working from any route. All three import only shell/shared helpers (verified:
// no function file imports a component file), so this slice can never drag a
// heavy tickets component into the eager chunk.
//
// tickets/package.json has no `sideEffects: false`, so re-exporting through
// `./index.js` would NOT tree-shake (it would evaluate the whole barrel + pull
// every component the barrel's siblings touch). Each file below is therefore
// `export *`-ed from its light SOURCE file directly.

var $jXdHE = parcelRequire("jXdHE");

var $jgMXB = parcelRequire("jgMXB");

var $2rYsV = parcelRequire("2rYsV");

var $aQECS = parcelRequire("aQECS");

var $bs9zR = parcelRequire("bs9zR");
$parcel$exportWildcard(module.exports, $jXdHE);
$parcel$exportWildcard(module.exports, $jgMXB);
$parcel$exportWildcard(module.exports, $2rYsV);
$parcel$exportWildcard(module.exports, $aQECS);
$parcel$exportWildcard(module.exports, $bs9zR);

});
parcelRegister("jgMXB", function(module, exports) {

$parcel$export(module.exports, "applyServerTicketPatch", () => $e0757d6dd4a314da$export$5de2bb8bf16f4002);
$parcel$export(module.exports, "saveTicket", () => $e0757d6dd4a314da$export$c3773125d9527fbc);
$parcel$export(module.exports, "deleteTicket", () => $e0757d6dd4a314da$export$da630e27fda1f593);
$parcel$export(module.exports, "setTicketCanvasPos", () => $e0757d6dd4a314da$export$96086cbfb1f59c97);
$parcel$export(module.exports, "moveTicket", () => $e0757d6dd4a314da$export$51d284ec765f2dde);
// Save / delete / move ticket — Mongo-backed (Phase 7 migration).
// Save / delete / move ticket against the main-server `tickets` entity
// (sdk.tickets.* via EntityDispatcher). Filename kept for caller stability;
// `el.call('saveTicket', ticket)` still works.
//
// GH sync is now a server-side cron worker (server/workers/github-sync/)
// triggered by Ticket.dirty=true; no client-side trigger needed.
// isOptimisticId comes from @symbo-ls/workspace-shell, stubbed by frank's
// EXTERNAL_PACKAGES at serialization time — reached via this.call instead
// of a raw import (see TicketDetailModal.js for the full rationale;
// isOptimisticId is a cross-package call the same way, just from
// workspace-shell rather than workspace-shared). Every caller of
// _isUnsavedId below is a `this`-bound function (el.call('saveTicket', …)
// etc.), so `this` threads straight through.

var $2rYsV = parcelRequire("2rYsV");
const $e0757d6dd4a314da$var$TICKETS_ENTITY = 'tickets';
const $e0757d6dd4a314da$var$_logErr = (scope, err)=>console.error(`[${scope}]`, err?.message || err);
// A Mongo ObjectId is a 24-char hex string — isOptimisticId() used to return
// true for any non-number, mis-classifying real Mongo docs as optimistic
// (#2277). Persisting functions must treat Mongo ids / SMBLS-N slugs as REAL.
//
// WS-ROWOPS-OPTIMISTIC-ID-STRING-1 re-evaluation: the base classifier in
// @symbo-ls/workspace-shell/functions/rowOps.js is now correct on its own
// (only an absent id, or a Date.now()-band numeric/numeric-string id, is
// optimistic), so these two short-circuits are REDUNDANT, not load-bearing —
// saveTicket.test.js now delegates its `isOptimisticId` mock to the real
// export to keep proving that. They stay as a local, dependency-free guard:
// this package is also frank-served, where `@symbo-ls/workspace-shell` is
// replaced by an EXTERNAL_PACKAGES stub and `ctx.call('isOptimisticId', …)`
// can resolve to nothing at all.
const $e0757d6dd4a314da$var$_isMongoId = (id)=>typeof id === 'string' && /^[0-9a-f]{24}$/i.test(id);
const $e0757d6dd4a314da$var$_isSlug = (id)=>typeof id === 'string' && /^[A-Z][\w-]+-\d+$/i.test(id);
// True only for genuinely optimistic (not-yet-created) ids. `ctx` is the
// caller's `this` (an element) — needed to reach isOptimisticId via .call.
const $e0757d6dd4a314da$var$_isUnsavedId = (ctx, id)=>!$e0757d6dd4a314da$var$_isMongoId(id) && !$e0757d6dd4a314da$var$_isSlug(id) && ctx.call('isOptimisticId', id);
const $e0757d6dd4a314da$var$_toPayload = (t, currentUserEmail, isUpdate = false)=>{
    const prevMeta = t.metadata && typeof t.metadata === 'object' ? t.metadata : {};
    const metadata = {
        ...prevMeta
    };
    if (t.agentTest !== undefined) metadata.agent_test = !!t.agentTest;
    // Deployment env (development/staging/production) — stored in metadata so it
    // persists through the existing Mixed `metadata` blob with no server schema
    // change. _mongoToTicket surfaces it back as `env`. (2026-06-15 per Nika —
    // match the project-level env model and wire it to tickets.)
    if (t.env !== undefined) metadata.env = t.env || null;
    // Form-collected fields that are NOT first-class columns on the Mongo Ticket
    // schema (storyPoints, acceptanceCriteria, stepsToReproduce, expectedResult).
    // The server create() constructor and the update() `_ALLOWED_UPDATE_FIELDS`
    // allowlist build the doc from an explicit field set and silently DROP any
    // top-level key outside it — so sending these at the top level lost them on
    // every save (create showed them optimistically then they vanished on
    // refresh; edits never persisted them at all). `metadata` is a Mixed blob
    // that IS in both the create constructor AND the update allowlist, so nesting
    // them here persists end-to-end with no server schema change — exactly the
    // pattern `env` already uses. _mongoToTicket reads them back.
    // NOTE: issueType is NOT in this group — it IS the first-class `type` column
    // and is mapped onto payload.type below (#88).
    if (t.storyPoints !== undefined) metadata.storyPoints = t.storyPoints || null;
    if (t.acceptanceCriteria !== undefined) metadata.acceptanceCriteria = t.acceptanceCriteria || null;
    if (t.severity !== undefined) metadata.severity = t.severity || null;
    // Repro steps were tried as a first-class root `reproSteps` column, but the
    // server returned it null — it is NOT in the create constructor / update
    // allowlist, so the top-level key was silently dropped. Store under
    // metadata.reproSteps (Mixed blob, always persists) like the siblings. (#88)
    if (t.stepsToReproduce !== undefined) metadata.reproSteps = t.stepsToReproduce || null;
    if (t.expectedResult !== undefined) metadata.expectedResult = t.expectedResult || null;
    const payload = {
        title: t.title || '(no title)',
        body: t.body || null,
        columnKey: t.columnKey || 'backlog',
        position: t.position || 0,
        assigneeEmail: t.assigneeEmail || null,
        reporterEmail: t.reporterEmail || currentUserEmail,
        labels: t.labels || [],
        priority: t.priority || null,
        dueDate: t.dueDate || null,
        refs: {
            ...t.refs || {},
            github: {
                ...t.refs?.github || {},
                issueUrl: t.githubUrl || t.refs?.github?.issueUrl || null,
                nodeId: t.githubNodeId || t.refs?.github?.nodeId || null
            }
        },
        metadata: metadata,
        dirty: true
    };
    // `state` is a PROTECTED generic-update field server-side
    // (TicketUpdateProtection.PROTECTED_GENERIC_UPDATE_FIELDS) — sending it on a
    // PUT returns HTTP 400 `protected_ticket_update`, which made EVERY edit-save
    // of an existing ticket fail (the edit `updated` object always carries the
    // ticket's current `state`). State transitions flow through the dedicated CTA
    // path (moveTicket / orchestration), so a generic save must NOT send it. On
    // CREATE the server accepts a trusted seed state (not_started / awaiting_-
    // approval / blocked) for TriageQuickCreate-style flows, so keep it there.
    if (!isUpdate && t.state) payload.state = t.state;
    // Issue kind is the first-class Mongo `type` column. The form draft calls it
    // `issueType` (bug/feature/user-story/subtask/…); map it onto root `type` so
    // the board TYPE filter (`f.type = filters.issueType`) and the epic/story
    // exclusion (`f.type: { $nin: [...] }`) actually match — nesting it in
    // metadata.issueType left `type` null and neither server query ever saw it
    // (#88). The form field wins when set; fall back to a pre-existing `t.type`.
    const issueKind = t.issueType || t.type;
    if (issueKind) payload.type = issueKind;
    // env top-level too (forward-compat): harmless today (server drops unknown
    // keys) and persists automatically if a first-class `env` column ever lands.
    // The canonical persisted copy is metadata.env (set above).
    if (t.env !== undefined) payload.env = t.env || null;
    // Epic is editable from the ticket detail sidebar. The first-class Mongo
    // column is `epic` (the server create constructor reads `payload.epic` and
    // `epic` is in the update allowlist) — the form draft calls it `epicName`,
    // so map it onto `epic` so the chosen epic actually persists. Keep `epicName`
    // too for any reader that expects the camel alias.
    if (t.epicName !== undefined) {
        payload.epic = t.epicName || null;
        payload.epicName = t.epicName || null;
    }
    return payload;
};
// Detects no_active_organization from the error object returned by the SDK
// adapter (_settle wraps thrown Errors; the raw JSON body is in .cause).
const $e0757d6dd4a314da$var$_isNoActiveOrg = (err)=>{
    if (!err) return false;
    if (err?.error === 'no_active_organization') return true;
    if (err?.cause?.error === 'no_active_organization') return true;
    const msg = err?.message || '';
    if (msg.includes('no_active_organization')) return true;
    // Also treat HTTP 401 as a recoverable auth error — the token may be
    // stale or the active-org may not be set on the SDK session yet (#2204).
    if (err?.status === 401 || err?.statusCode === 401) return true;
    if (typeof err?.cause?.status === 'number' && err.cause.status === 401) return true;
    return false;
};
// If the server returned no_active_organization, try to set the active org
// from the SDK's cached user data or root state and return true so the
// caller can retry.
const $e0757d6dd4a314da$var$_tryRecoverActiveOrg = async (el)=>{
    try {
        const sdk = el?.sdk || el?.context?.methods?.sdk;
        if (!sdk) return false;
        const me = sdk._currentUser || null;
        // Prefer cached user's activeOrganization, then orgs[0], then root state
        const rootOrgId = el?.state?.root?.org?.id || null;
        const orgId = me?.activeOrganization || me?.orgs?.[0]?.id || rootOrgId || null;
        if (!orgId) return false;
        await sdk.setActiveOrganization(orgId);
        return true;
    } catch (_) {
        return false;
    }
};
// Reconcile ONE ticket's local rows with the server's response after a
// write that could have changed `columnKey`.
//
// Root cause this closes: `state` and `columnKey` are two representations
// of the same workflow status. `state` is a PROTECTED field (see the
// payload comment above) — the CLIENT never sends it and never computes
// it. The SERVER derives it from the new `columnKey` on every update
// (TicketService.update's COLUMN_TO_STATE_DEFAULT / TicketStateMachine
// path) and returns the full updated doc. Every optimistic local patch
// (kanban drag, modal Status-select save, AI apply-updates) only ever
// touches `columnKey` + `position` — `state` was never written back
// anywhere, so it stayed stale forever (until a full board reload
// happened to re-fetch that exact row, which is not guaranteed once a
// page is loaded). That produced three symptoms from ONE cause: the
// moved card's status badge (state-driven) never updated, a realtime
// peer never saw the status change either (same stale field), and
// opening the SAME ticket's read view (state-driven) vs edit view
// (columnKey-driven) could disagree.
//
// Fix: `moveTicket` and `saveTicket`'s update branch are the ONLY two
// places a `columnKey` change reaches the server — both funnel their
// response through this ONE function, so every caller (drag handlers,
// the modal's Save button, AI apply-updates, quick status actions) gets
// the server's authoritative fields back with zero call-site changes.
// `root.tickets` and `root.selectedTicket` are the surfaces that render a
// per-ticket status badge from `state`; `root.myTickets` is My View's own
// cache of the same rows. All three are patched in ONE root.update() so
// they can never render three different answers for the same ticket.
const $e0757d6dd4a314da$var$_applyServerTicketPatch = (root, ticketId, serverDoc)=>{
    if (!root || ticketId == null || !serverDoc || typeof serverDoc !== 'object') return;
    const normalized = (0, $2rYsV.normalizeTicketDoc)(serverDoc, true);
    if (!normalized || normalized.id == null) return;
    const idStr = String(ticketId);
    const patch = {};
    // OUTSIDE A COLUMN ⟺ DRAFT: the session-live placement map is a root
    // sibling of `tickets`, so a wholesale `metadata` replace below never
    // touched it — a stale entry survived a move into a column made by ANY
    // other writer (a second tab, an agent, "Start on") and kept winning the
    // ticketCanvasPos lookup, so the card floated on with a real column until
    // reload. The server's answer is authoritative for both halves: mirror it.
    const live = root._ticketCanvasPos;
    if (live && typeof live === 'object') {
        const serverPos = normalized.metadata && normalized.metadata.canvasPos;
        const isDraft = normalized.columnKey === $e0757d6dd4a314da$var$_DRAFT;
        const wantEntry = isDraft && serverPos ? serverPos : null;
        const haveEntry = live[idStr] || null;
        if (!!wantEntry !== !!haveEntry || wantEntry && haveEntry !== wantEntry) {
            const next = {
                ...live
            };
            if (wantEntry) next[idStr] = wantEntry;
            else delete next[idStr];
            patch._ticketCanvasPos = next;
        }
    }
    const tickets = root.tickets;
    if (Array.isArray(tickets) && tickets.some((t)=>t && String(t.id) === idStr)) patch.tickets = tickets.map((t)=>t && String(t.id) === idStr ? {
            ...t,
            ...normalized
        } : t);
    const sel = root.selectedTicket;
    if (sel && String(sel.id) === idStr) patch.selectedTicket = {
        ...sel,
        ...normalized
    };
    const myTickets = root.myTickets;
    if (Array.isArray(myTickets) && myTickets.some((t)=>t && String(t.id) === idStr)) patch.myTickets = myTickets.map((t)=>t && String(t.id) === idStr ? {
            ...t,
            ...normalized
        } : t);
    if (Object.keys(patch).length) root.update(patch);
};
const $e0757d6dd4a314da$export$5de2bb8bf16f4002 = $e0757d6dd4a314da$var$_applyServerTicketPatch;
const $e0757d6dd4a314da$export$c3773125d9527fbc = async function(ticket) {
    const fetch = this.context?.fetch;
    if (!fetch?.insert || !fetch?.update) {
        $e0757d6dd4a314da$var$_logErr('saveTicket', 'context.fetch missing insert/update');
        return null;
    }
    // Decide insert-vs-update UP FRONT (same guard used below) so the payload can
    // be shaped per-op: an UPDATE must omit the protected `state` field, an INSERT
    // may carry a trusted seed state. (#bug-edit-fails — sending state on PUT 400s.)
    const _isUpdateOp = !(!$e0757d6dd4a314da$var$_isMongoId(ticket.id) && !$e0757d6dd4a314da$var$_isSlug(ticket.id) && (this.call('isOptimisticId', ticket.id) || !ticket.ticketId));
    const payload = $e0757d6dd4a314da$var$_toPayload(ticket, this.state?.root?.currentUserEmail, _isUpdateOp);
    const _doInsert = ()=>fetch.insert({
            from: $e0757d6dd4a314da$var$TICKETS_ENTITY,
            data: payload
        });
    // _packUpdate extracts `id` from params (not `ticketId`) to route the SDK
    // EntityDispatcher's argMaps.idPayload correctly (#2277 / #2273 — updates
    // were silently no-op'd because `_packUpdate` looked for `params.id` but
    // only `params.ticketId` was set; `TicketService.update(undefined, …)` → 404).
    // Pass both keys so any argMap that reads either field works.
    const _updateId = ticket.ticketId || ticket.id;
    const _doUpdate = ()=>fetch.update({
            from: $e0757d6dd4a314da$var$TICKETS_ENTITY,
            params: {
                id: _updateId,
                ticketId: _updateId
            },
            data: payload
        });
    // _isMongoId / _isSlug guards hoisted to module scope (shared with
    // moveTicket + setTicketCanvasPos, which had the same #2277-family bug).
    try {
        if (!_isUpdateOp) {
            let result = await _doInsert();
            // Auto-recover: if the first attempt fails with no_active_organization,
            // call setActiveOrganization and retry once. This handles users whose
            // User.activeOrganization was null at boot (common for new accounts or
            // accounts whose active-org got cleared by an org removal).
            if ($e0757d6dd4a314da$var$_isNoActiveOrg(result?.error)) {
                const recovered = await $e0757d6dd4a314da$var$_tryRecoverActiveOrg(this);
                if (recovered) result = await _doInsert();
            }
            if (result?.error) {
                $e0757d6dd4a314da$var$_logErr('saveTicket:insert', result.error);
                return null;
            }
            // Land the server's authoritative doc onto the OPTIMISTIC row, the same
            // way the update branch and every realtime event do. The insert branch
            // used to skip this, so the client kept its own guess for every
            // server-derived field — most visibly `columnKey` and `state`. A create
            // in Todo that the server stored elsewhere left a card sitting in a
            // column no record backs, and the realtime echo of the real record then
            // rendered a SECOND card (PLATFORM-TICKET-CREATE-COLUMN-DUPLICATE-1).
            // Keyed by the TEMP id — the patch swaps in the server's id too, so the
            // caller's own temp→real swap afterwards is a harmless no-op.
            $e0757d6dd4a314da$var$_applyServerTicketPatch(this.state?.root, ticket.id, result?.data);
            // Prefer the Mongo ObjectId (_id) as the realId so subsequent edits
            // pass the ID guard (_isMongoId) correctly and never re-INSERT (#2277).
            return result?.data?._id ?? result?.data?.ticketId ?? null;
        }
        let result = await _doUpdate();
        if ($e0757d6dd4a314da$var$_isNoActiveOrg(result?.error)) {
            const recovered = await $e0757d6dd4a314da$var$_tryRecoverActiveOrg(this);
            if (recovered) result = await _doUpdate();
        }
        if (result?.error) {
            $e0757d6dd4a314da$var$_logErr('saveTicket:update', result.error);
            return null;
        }
        // Land the server's authoritative doc (state derived from the new
        // columnKey when it changed) back into local state — see
        // _applyServerTicketPatch. Return contract is unchanged (still the id)
        // so no caller needs to change.
        $e0757d6dd4a314da$var$_applyServerTicketPatch(this.state?.root, _updateId, result?.data);
        return ticket.ticketId || ticket.id;
    } catch (e) {
        $e0757d6dd4a314da$var$_logErr('saveTicket', e);
        return null;
    }
};
const $e0757d6dd4a314da$export$da630e27fda1f593 = async function(ticketId, opts) {
    const callerReports = !!(opts && opts.callerReports);
    const fetch = this.context?.fetch;
    if (!fetch?.delete) {
        if (callerReports) throw Object.assign(new Error('context.fetch.delete missing'), {
            code: 'DELETE_UNAVAILABLE'
        });
        $e0757d6dd4a314da$var$_logErr('deleteTicket', 'context.fetch.delete missing');
        return false;
    }
    let result;
    try {
        // The sdk adapter's _packDelete extracts params.id (not params.ticketId),
        // so pass id here so the EntityDispatcher receives the correct identifier
        // (#2266 — delete silently no-op'd because ticketId was never forwarded).
        result = await fetch.delete({
            from: $e0757d6dd4a314da$var$TICKETS_ENTITY,
            params: {
                id: ticketId,
                ticketId: ticketId
            }
        });
    } catch (e) {
        if (callerReports) throw e;
        $e0757d6dd4a314da$var$_logErr('deleteTicket', e);
        return false;
    }
    if (result?.error && callerReports) throw result.error;
    if (callerReports && result?.data?.alreadyDeleted === true) throw Object.assign(new Error(`ticket ${ticketId} was already deleted`), {
        status: 410
    });
    return !result?.error;
};
const $e0757d6dd4a314da$export$96086cbfb1f59c97 = async function(ticketId, pos) {
    const fetch = this.context?.fetch;
    if (!fetch?.update) {
        $e0757d6dd4a314da$var$_logErr('setTicketCanvasPos', 'context.fetch.update missing');
        return false;
    }
    // Skip ONLY genuinely-unsaved optimistic ids — raw isOptimisticId() is true
    // for Mongo hex ids too, which silently skipped persistence for EVERY real
    // ticket (freeform placements never reached the server).
    if ($e0757d6dd4a314da$var$_isUnsavedId(this, ticketId)) return true;
    try {
        const root = this.state?.root;
        const ticket = (root?.tickets || []).find((t)=>t.id === ticketId);
        const metadata = {
            ...ticket?.metadata || {},
            canvasPos: pos || null
        };
        const result = await fetch.update({
            from: $e0757d6dd4a314da$var$TICKETS_ENTITY,
            params: {
                id: ticketId,
                ticketId: ticketId
            },
            data: {
                metadata: metadata
            }
        });
        if (result?.error) {
            $e0757d6dd4a314da$var$_logErr('setTicketCanvasPos', result.error);
            return false;
        }
        return true;
    } catch (e) {
        $e0757d6dd4a314da$var$_logErr('setTicketCanvasPos', e);
        return false;
    }
};
// Mirrors ticketUtils.js DRAFT_COLUMN_KEY. A local literal, not an import:
// this file is frank-served and must stay dependency-free (see _isUnsavedId).
const $e0757d6dd4a314da$var$_DRAFT = 'draft';
const $e0757d6dd4a314da$export$51d284ec765f2dde = async function({ ticketId: ticketId, columnKey: columnKey, position: position, canvasPos: canvasPos }) {
    const fetch = this.context?.fetch;
    if (!fetch?.update) {
        $e0757d6dd4a314da$var$_logErr('moveTicket', 'context.fetch.update missing');
        return false;
    }
    // Same #2277-family guard as setTicketCanvasPos — raw isOptimisticId()
    // skipped persistence for Mongo hex ids, so column drags never saved.
    if ($e0757d6dd4a314da$var$_isUnsavedId(this, ticketId)) return true;
    try {
        const data = {
            columnKey: columnKey,
            position: position
        };
        if (columnKey === $e0757d6dd4a314da$var$_DRAFT) {
            if (canvasPos) data.metadata = {
                canvasPos: canvasPos
            };
        } else data.metadata = {
            canvasPos: null
        };
        // Pass both id and ticketId so _packUpdate can extract params.id correctly
        // (#2273 — moveTicket silently no-op'd because _packUpdate reads params.id,
        // not params.ticketId, same root cause as _doUpdate fix above).
        const result = await fetch.update({
            from: $e0757d6dd4a314da$var$TICKETS_ENTITY,
            params: {
                id: ticketId,
                ticketId: ticketId
            },
            data: data
        });
        if (result?.error) {
            $e0757d6dd4a314da$var$_logErr('moveTicket', result.error);
            return false;
        }
        // The response carries the server-derived `state` for the new column —
        // land it (see _applyServerTicketPatch). Every caller (kanban drag,
        // AI apply-updates) gets this for free; none of them need to change.
        $e0757d6dd4a314da$var$_applyServerTicketPatch(this.state?.root, ticketId, result?.data);
        return true;
    } catch (e) {
        $e0757d6dd4a314da$var$_logErr('moveTicket', e);
        return false;
    }
};

});

parcelRegister("aQECS", function(module, exports) {

$parcel$export(module.exports, "ticketsAiViews", () => $7e5e46353758d4fa$export$322eacbaf2438fe4);
$parcel$export(module.exports, "ticketsAnswerFilters", () => $7e5e46353758d4fa$export$9233780542461cb4);
$parcel$export(module.exports, "ticketsAnswerDueWindow", () => $7e5e46353758d4fa$export$c948c39f409cea0c);
$parcel$export(module.exports, "ticketsAnswerResolve", () => $7e5e46353758d4fa$export$f9a325a2a60fd0b3);
$parcel$export(module.exports, "ticketsAnswerRoute", () => $7e5e46353758d4fa$export$c9c4f777fa1b5431);
$parcel$export(module.exports, "ticketsAnswerBoardColumns", () => $7e5e46353758d4fa$export$3287751ad4e54ec3);
$parcel$export(module.exports, "ticketsAnswerLoad", () => $7e5e46353758d4fa$export$1ef2ab28ae911f8c);
$parcel$export(module.exports, "ticketsAnswerRows", () => $7e5e46353758d4fa$export$902f34af8f04a87c);
$parcel$export(module.exports, "ticketsAnswerColumns", () => $7e5e46353758d4fa$export$622ffd8bba3d1828);
$parcel$export(module.exports, "ticketsAnswerLayout", () => $7e5e46353758d4fa$export$e6961e9e50608996);
$parcel$export(module.exports, "ticketsAnswerCanvasCards", () => $7e5e46353758d4fa$export$63f42ab890e7f4eb);
$parcel$export(module.exports, "ticketsAnswerCanvasBox", () => $7e5e46353758d4fa$export$28b345dcd66bab33);
$parcel$export(module.exports, "ticketsAnswerCanvasFit", () => $7e5e46353758d4fa$export$1d11836dd8698929);
$parcel$export(module.exports, "ticketsAnswerMoreText", () => $7e5e46353758d4fa$export$bbfef1f08207964b);
// TASKS IN AN AI ANSWER — the views the assistant mounts in its thread and a
// Fly page places as sections (workspace functions/assistantAppViews.js, the
// `views[]` contract).
//
// ticketsAiViews() is the tickets view PROVIDER, read from the EAGER slice
// (the tickets package is lazy — the shell folds its context before a view
// mounts, `fold: 'tickets'`). Two views:
//
//   tickets-board    the tasks that match the filters, in one of three
//                    layouts: a LIST (the home widget kit's row: title,
//                    status · priority), a BOARD (every status column the
//                    status covers, each with its full count and its first
//                    cards — the app's own TicketsCard) or the CANVAS (the
//                    tasks where the /tasks board places them on its canvas,
//                    the board's own MyTicketCard, read-only and scaled to the
//                    card). A row or a card opens the task's own detail
//                    sheet; nothing here writes.
//   tickets-roadmap  the cycles and epics on a timeline
//                    (functions/ticketsRoadmapAnswer.js).
//
// The reads are the board's own (ticketLoaders fetchTicketsForAnswer,
// fetchColumnPage, fetchColumnCounts), scoped by the server to the member's
// workspace and grants. The names an ask gives — a project, an epic, a cycle,
// a teammate — resolve to what the reads filter on BEFORE they run; a name
// nothing here answers to matches nothing, never every task. ↗ Open opens the
// /tasks board with the same filters, as far as the board can show them (the
// view's `openRoute`).
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $7e5e46353758d4fa$export$322eacbaf2438fe4() {
    return {
        app: {
            id: 'system/tickets',
            navbar: [
                {
                    label: 'tickets.answer.title',
                    route: '/tasks',
                    icon: 'check'
                }
            ],
            apps: [
                {
                    icon: 'check'
                }
            ]
        },
        fold: 'tickets',
        views: [
            {
                id: 'tickets-board',
                title: 'tickets.answer.title',
                // The ONE line the model matches an ask against (the server caps it at
                // 160 characters).
                describe: 'Tasks as a list, status columns or the board canvas; by status, people, priority, type, project, epic, cycle, due date, title words.',
                component: 'TicketsAnswerView',
                icon: 'check',
                hue: 'tickets',
                size: 'l',
                // Twelve params: the server keeps twelve per view.
                params: {
                    status: {
                        type: 'enum',
                        values: [
                            'open',
                            'all',
                            'draft',
                            'backlog',
                            'todo',
                            'in_progress',
                            'blocked',
                            'ready_to_test',
                            'review',
                            'done'
                        ],
                        default: 'open',
                        describe: 'open = not done and not a draft (default); all = every task; draft = tasks outside a board column'
                    },
                    // Live on dev: "What tasks are due this week?" came back assignee
                    // 'me' — nobody said "my" — and hid the workspace's one open task.
                    assignee: {
                        type: 'string',
                        describe: "'me' only for me, my or mine; 'team', 'agents', or a teammate's name or email; else leave it out"
                    },
                    priority: {
                        type: 'enum',
                        values: [
                            'P0',
                            'P1',
                            'P2',
                            'P3'
                        ]
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'bug',
                            'task',
                            'user_story',
                            'epic'
                        ]
                    },
                    // QA on dev: "What tasks are open for the docs project" matched the
                    // word in the titles — the task↔project link is a filter of its own.
                    project: {
                        type: 'string',
                        describe: "a project's name or key: the tasks linked to that project, never words in a title"
                    },
                    epic: {
                        type: 'string',
                        describe: "an epic's name, only when the ask names one"
                    },
                    cycle: {
                        type: 'string',
                        describe: "a cycle's name, or 'current' for the active cycle"
                    },
                    due: {
                        type: 'enum',
                        values: [
                            'overdue',
                            'today',
                            'thisWeek',
                            'nextWeek',
                            'none'
                        ],
                        // Bundle keys: the catalog sends them as { en, ka } words.
                        labels: {
                            overdue: 'tickets.answer.due.overdue',
                            today: 'tickets.answer.due.today',
                            thisWeek: 'tickets.answer.due.thisWeek',
                            nextWeek: 'tickets.answer.due.nextWeek',
                            none: 'tickets.answer.due.none'
                        },
                        describe: 'a due-date window; a week is Sunday..Saturday; none = no due date'
                    },
                    drafts: {
                        type: 'boolean',
                        describe: 'true adds drafts (tasks outside every board column) to the open tasks'
                    },
                    search: {
                        type: 'string',
                        describe: 'words in the task title'
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'list',
                            'board',
                            'canvas'
                        ],
                        default: 'list',
                        describe: 'board = status columns; canvas = where the /tasks board places each task'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 50,
                        default: 20
                    }
                },
                // Before the view resolves its names (the body's own `openRoute` takes
                // over then): the filters the board's URL carries as they are.
                link: {
                    route: '/tasks',
                    query: {
                        type: 'type',
                        q: 'search'
                    }
                }
            },
            {
                id: 'tickets-roadmap',
                title: 'tickets.roadmapAnswer.title',
                describe: 'The roadmap: cycles and epics on a timeline with their dates and progress; show = cycles, epics or both; search = words in a name.',
                component: 'TicketsRoadmapView',
                icon: 'target',
                hue: 'tickets',
                size: 'l',
                params: {
                    show: {
                        type: 'enum',
                        values: [
                            'all',
                            'cycles',
                            'epics'
                        ],
                        labels: {
                            all: 'tickets.roadmapAnswer.show.all',
                            cycles: 'tickets.roadmapAnswer.show.cycles',
                            epics: 'tickets.roadmapAnswer.show.epics'
                        },
                        default: 'all'
                    },
                    status: {
                        type: 'enum',
                        values: [
                            'current',
                            'all'
                        ],
                        default: 'current',
                        describe: 'current = active and planned cycles, epics not done (default); all = released, archived and done too'
                    },
                    search: {
                        type: 'string',
                        describe: 'words in the cycle or epic name'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 30,
                        default: 12
                    }
                },
                link: {
                    route: '/tasks/roadmap',
                    query: {}
                }
            }
        ]
    };
}
function $7e5e46353758d4fa$export$9233780542461cb4(root, params, now) {
    const el = this;
    const r = root || {};
    const p = params && typeof params === 'object' ? params : {};
    const out = {
        status: typeof p.status === 'string' && p.status ? p.status : 'open'
    };
    const ws = r.workspace && (r.workspace.id || r.workspace._id);
    if (ws) out.workspaceId = String(ws);
    const who = typeof p.assignee === 'string' ? p.assignee.trim() : '';
    if (who) {
        const low = who.toLowerCase();
        if (low === 'me') out.assignee = String(r.currentUserEmail || '') || '\u0000';
        else if (low === 'team' || low === 'agents') {
            // The board's own categories ('team' leaves the member out).
            out.assignee = low;
            if (r.currentUserEmail) out.currentUserEmail = String(r.currentUserEmail);
        } else if (low.includes('@')) out.assignee = low;
        else {
            const people = Array.isArray(r.people) ? r.people : [];
            const hit = people.find((x)=>{
                const name = String(x && (x.name || [
                    x.firstName,
                    x.lastName
                ].filter(Boolean).join(' ')) || '').toLowerCase();
                return name && (name === low || name.split(' ').includes(low));
            });
            out.assignee = hit && hit.email ? String(hit.email) : '\u0000';
        }
    }
    if (typeof p.priority === 'string' && p.priority) out.priority = p.priority;
    if (typeof p.type === 'string' && p.type) out.issueType = p.type;
    if (typeof p.search === 'string' && p.search.trim()) out.search = p.search.trim();
    for (const name of [
        'project',
        'epic',
        'cycle'
    ]){
        const v = typeof p[name] === 'string' ? p[name].trim() : '';
        if (v) out[name + 'Name'] = v;
    }
    if (p.drafts === true) out.drafts = true;
    if (typeof p.due === 'string' && p.due) {
        const window = el && typeof el.call === 'function' ? el.call('ticketsAnswerDueWindow', p.due, now) : null;
        if (window) out.due = window;
    }
    if (p.layout === 'canvas') out.placed = true;
    return out;
}
function $7e5e46353758d4fa$export$c948c39f409cea0c(due, now) {
    const base = now instanceof Date ? now : new Date(Number(now) || Date.now());
    const pad = (n)=>String(n).padStart(2, '0');
    const day = (shift)=>{
        const d = new Date(base.getFullYear(), base.getMonth(), base.getDate() + shift);
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    };
    const sinceStart = base.getDay();
    if (due === 'overdue') return {
        from: null,
        to: day(-1),
        none: false,
        open: true
    };
    if (due === 'today') return {
        from: day(0),
        to: day(0),
        none: false,
        open: false
    };
    if (due === 'thisWeek') return {
        from: day(-sinceStart),
        to: day(6 - sinceStart),
        none: false,
        open: false
    };
    if (due === 'nextWeek') return {
        from: day(7 - sinceStart),
        to: day(13 - sinceStart),
        none: false,
        open: false
    };
    if (due === 'none') return {
        from: null,
        to: null,
        none: true,
        open: false
    };
    return null;
}
async function $7e5e46353758d4fa$export$f9a325a2a60fd0b3(el, filters) {
    const host = el || this;
    const f = {
        ...filters || {}
    };
    const wantProject = f.projectName || '';
    const wantEpic = f.epicName || '';
    const wantCycle = f.cycleName || '';
    delete f.projectName;
    delete f.epicName;
    delete f.cycleName;
    if (!wantProject && !wantEpic && !wantCycle) return {
        filters: f
    };
    const norm = (v)=>String(v || '').trim().toLowerCase();
    const pick = (items, wanted, namesOf)=>{
        const w = norm(wanted);
        const all = (Array.isArray(items) ? items : []).filter(Boolean);
        const by = (test)=>all.filter((it)=>namesOf(it).some((n)=>n && test(norm(n))));
        const same = by((n)=>n === w);
        if (same.length) return same[0];
        const starts = by((n)=>n.startsWith(w));
        if (starts.length === 1) return starts[0];
        const holds = by((n)=>n.includes(w));
        return holds.length === 1 ? holds[0] : null;
    };
    const fns = host && host.context && host.context.functions || {};
    const service = async ()=>{
        const sdk = host.sdk || host.call('getSDK');
        return sdk && typeof sdk.getService === 'function' ? sdk.getService('tickets') : null;
    };
    let failed = false;
    let unknown = false;
    const jobs = [];
    if (wantProject) jobs.push((async ()=>{
        if (typeof fns.canvasAnswerRead !== 'function') {
            failed = true;
            return;
        }
        const res = await host.call('canvasAnswerRead', host);
        if (!res || res.failed || !Array.isArray(res.projects)) {
            failed = true;
            return;
        }
        const hit = pick(res.projects, wantProject, (x)=>[
                x.key,
                x.name
            ]);
        const id = hit && (hit._id || hit.id);
        if (!id) unknown = true;
        else f.project = String(id);
    })());
    if (wantEpic) jobs.push((async ()=>{
        const tSvc = await service();
        if (!tSvc || typeof tSvc.epicCounts !== 'function') {
            failed = true;
            return;
        }
        // `{ [epic name]: { total, done, … } }` — the names the tasks carry.
        const res = await tSvc.epicCounts();
        const bag = res && typeof res === 'object' && !Array.isArray(res) ? res : {};
        const names = Object.keys(bag).filter((n)=>n && n !== '__none__');
        const hit = pick(names, wantEpic, (n)=>[
                n
            ]);
        if (!hit) unknown = true;
        else f.epic = hit;
    })());
    if (wantCycle) jobs.push((async ()=>{
        const tSvc = await service();
        if (!tSvc || !tSvc.cycle || typeof tSvc.cycle.list !== 'function') {
            failed = true;
            return;
        }
        const res = await tSvc.cycle.list();
        const rows = Array.isArray(res) ? res : res && res.data || [];
        const hit = norm(wantCycle) === 'current' ? rows.find((c)=>c && c.status === 'active') || null : pick(rows, wantCycle, (c)=>[
                c.name
            ]);
        const id = hit && (hit._id || hit.id);
        if (!id) unknown = true;
        else f.cycleId = String(id);
    })());
    try {
        await Promise.all(jobs);
    } catch (err) {
        console.warn('[ticketsAnswer] name lookup failed:', err && err.message);
        failed = true;
    }
    return failed ? {
        filters: f,
        failed: true
    } : unknown ? {
        filters: f,
        unknown: true
    } : {
        filters: f
    };
}
function $7e5e46353758d4fa$export$c9c4f777fa1b5431(filters, params) {
    const f = filters && typeof filters === 'object' ? filters : {};
    const p = params && typeof params === 'object' ? params : {};
    const parts = [];
    const add = (key, value)=>{
        if (value == null || value === '') return;
        parts.push(key + '=' + encodeURIComponent(String(value)));
    };
    add('type', f.issueType);
    const said = typeof p.assignee === 'string' ? p.assignee.trim() : '';
    const low = said.toLowerCase();
    if (low === 'me' || low === 'team' || low === 'agents') add('assignee', low);
    else if (said) add('assignee', f.assignee && f.assignee !== '\u0000' ? f.assignee : said);
    add('epic', f.epic || (typeof p.epic === 'string' ? p.epic.trim() : ''));
    add('q', f.search);
    add('cycle', f.cycleId);
    add('project', f.project);
    return '/tasks' + (parts.length ? '?' + parts.join('&') : '');
}
async function $7e5e46353758d4fa$export$3287751ad4e54ec3(el, filters) {
    const host = el || this;
    const root = host && host.state && host.state.root || {};
    const f = filters && typeof filters === 'object' ? filters : {};
    const usable = (c)=>c && c.key && c.key !== 'unsynced' && c.key !== 'draft';
    let cols = (Array.isArray(root.columns) ? root.columns : []).filter(usable);
    if (!cols.length) try {
        const sdk = host.sdk || host.call('getSDK');
        const tSvc = sdk && typeof sdk.getService === 'function' ? await sdk.getService('tickets') : null;
        const res = tSvc && tSvc.columns ? await tSvc.columns.list() : null;
        const rows = Array.isArray(res) ? res : res && res.data || [];
        cols = rows.filter(usable);
    } catch (err) {
        console.warn('[ticketsAnswer] columns read failed:', err && err.message);
        cols = [];
    }
    if (!cols.length) cols = [
        'backlog',
        'todo',
        'in_progress',
        'blocked',
        'ready_to_test',
        'review',
        'done'
    ].map((key, position)=>({
            key: key,
            position: position
        }));
    const list = cols.slice().sort((a, b)=>(Number(a.position) || 0) - (Number(b.position) || 0)).map((c)=>({
            key: String(c.key),
            // A seeded default column reads in the active language.
            label: host.call('columnLabelText', c) || c.label || c.name || host.call('stateLabelText', host, c.key)
        }));
    const draft = {
        key: 'draft',
        label: String(host.call('polyglot', 'tickets.kanban.draftsColumn'))
    };
    const status = f.status || 'open';
    if (status === 'draft') return [
        draft
    ];
    if (status === 'all') return list.concat(draft);
    if (status === 'open') {
        const open = list.filter((c)=>c.key !== 'done');
        return f.drafts === true ? open.concat(draft) : open;
    }
    const one = list.find((c)=>c.key === status);
    return [
        one || {
            key: status,
            label: host.call('stateLabelText', host, status)
        }
    ];
}
async function $7e5e46353758d4fa$export$1ef2ab28ae911f8c(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const root = host.state.root;
    const params = host.scope && host.scope.params || {};
    const layout = host.call('ticketsAnswerLayout', host);
    const limit = Math.max(1, Math.min(50, Math.floor(Number(params.limit)) || 20));
    const asked = host.call('ticketsAnswerFilters', root, params);
    const sig = JSON.stringify([
        asked,
        limit,
        layout
    ]);
    if (host.__ticketsAnswerSig === sig) return null;
    host.__ticketsAnswerSig = sig;
    const current = ()=>host.__ticketsAnswerSig === sig;
    const resolved = await host.call('ticketsAnswerResolve', host, asked) || {
        filters: asked
    };
    if (!current()) return null;
    const filters = resolved.filters || asked;
    const route = host.call('ticketsAnswerRoute', filters, params);
    if (resolved.failed || resolved.unknown) {
        host.state.update({
            tickets: [],
            total: 0,
            columns: null,
            layout: layout,
            limit: limit,
            failed: !!resolved.failed,
            route: route
        });
        return null;
    }
    if (layout === 'board') {
        const cols = await host.call('ticketsAnswerBoardColumns', host, filters);
        if (!current()) return null;
        if (!filters.due) {
            // Each column its own first cards (the board's column read, in the
            // board's order) and its full count under the same filters.
            const per = Math.max(2, Math.min(10, Math.ceil(limit / Math.max(1, cols.length))));
            const [pages, counts] = await Promise.all([
                Promise.all(cols.map((c)=>host.call('fetchColumnPage', host, c.key, 0, per, filters, 'answer'))),
                host.call('fetchColumnCounts', host, filters, cols.map((c)=>c.key), {
                    strict: true
                })
            ]);
            if (!current()) return null;
            const tickets = pages.reduce((all, page)=>all.concat(Array.isArray(page) ? page : []), []);
            const columns = cols.map((c)=>({
                    ...c,
                    count: counts && typeof counts[c.key] === 'number' ? counts[c.key] : null
                }));
            const known = columns.every((c)=>typeof c.count === 'number');
            host.state.update({
                tickets: tickets,
                total: known ? columns.reduce((n, c)=>n + c.count, 0) : null,
                columns: columns,
                layout: layout,
                limit: limit,
                // A column read answers [] on a failure; with no count either, the
                // view cannot tell "nothing matches" — it says the read failed.
                failed: !counts && !tickets.length,
                route: route
            });
            return tickets;
        }
        // A due window is read here, not by the server: its matches, grouped —
        // the counts are the full set when the read reached the end.
        const list = await host.call('fetchTicketsForAnswer', host, filters, limit);
        if (!current()) return null;
        const byColumn = list && list.byColumn;
        const columns = cols.map((c)=>({
                ...c,
                count: byColumn && typeof byColumn === 'object' ? byColumn[c.key] || 0 : null
            }));
        host.state.update({
            tickets: Array.isArray(list) ? list : [],
            total: list && typeof list.total === 'number' ? list.total : null,
            columns: columns,
            layout: layout,
            limit: limit,
            failed: !!(list && list.failed),
            route: route
        });
        return list;
    }
    // The canvas: the tasks the board places on its canvas — drafts by the
    // board's own rule (ticketUtils ticketPlacement: outside a column ⟺ draft).
    const read = layout === 'canvas' && (filters.status === 'open' || filters.status === 'all') ? {
        ...filters,
        status: 'draft'
    } : filters;
    const list = await host.call('fetchTicketsForAnswer', host, read, limit);
    if (!current()) return null;
    host.state.update({
        tickets: Array.isArray(list) ? list : [],
        total: list && typeof list.total === 'number' ? list.total : null,
        columns: null,
        layout: layout,
        limit: limit,
        failed: !!(list && list.failed),
        route: route
    });
    return list;
}
function $7e5e46353758d4fa$export$902f34af8f04a87c(tickets) {
    const el = this;
    const list = Array.isArray(tickets) ? tickets : [];
    const root = el && el.state && el.state.root;
    const columns = root && Array.isArray(root.columns) ? root.columns : [];
    const statusOf = (t)=>{
        if (t.columnKey === 'draft') return el.call('polyglot', 'tickets.kanban.draftsColumn');
        const col = columns.find((c)=>c && c.key === t.columnKey);
        return col && (el.call('columnLabelText', col) || col.label) || el.call('stateLabelText', el, t.state || t.columnKey);
    };
    const initials = (email)=>{
        const name = String(email || '').split('@')[0].split(/[._-]+/).filter(Boolean);
        return name.slice(0, 2).map((w)=>w.charAt(0).toUpperCase()).join('');
    };
    return list.map((t)=>({
            key: String(t.id),
            title: t.title || String(el.call('polyglot', 'tickets.answer.untitled')),
            meta: [
                statusOf(t),
                el.call('priorityLabel', t.priority)
            ].filter(Boolean).join(" \xb7 "),
            ...t.assigneeEmail ? {
                initials: initials(String(t.assigneeEmail).split(',')[0])
            } : {},
            open: {
                call: 'openTicketDetailModal',
                arg: t
            }
        }));
}
function $7e5e46353758d4fa$export$622ffd8bba3d1828(tickets, columns) {
    const el = this;
    const list = Array.isArray(tickets) ? tickets : [];
    const root = el && el.state && el.state.root;
    const known = root && Array.isArray(root.columns) ? root.columns : [];
    const labelOf = (key)=>{
        if (key === 'draft') return el.call('polyglot', 'tickets.kanban.draftsColumn');
        const col = known.find((c)=>c && c.key === key);
        return col && (el.call('columnLabelText', col) || col.label) || el.call('stateLabelText', el, key);
    };
    let cols = Array.isArray(columns) && columns.length ? columns : null;
    if (!cols) {
        const ORDER = [
            'backlog',
            'todo',
            'in_progress',
            'blocked',
            'ready_to_test',
            'review',
            'done',
            'draft'
        ];
        cols = [
            ...new Set(list.map((t)=>t.columnKey || 'backlog'))
        ].sort((a, b)=>{
            const ia = ORDER.indexOf(a);
            const ib = ORDER.indexOf(b);
            return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        }).map((key)=>({
                key: key,
                label: labelOf(key),
                count: null
            }));
    }
    return cols.map((c)=>{
        const items = list.filter((t)=>(t.columnKey || 'backlog') === c.key);
        const full = typeof c.count === 'number';
        return {
            key: c.key,
            label: c.label || labelOf(c.key),
            count: full ? c.count : items.length,
            sample: !full,
            more: full ? Math.max(0, c.count - items.length) : 0,
            tickets: items
        };
    });
}
function $7e5e46353758d4fa$export$e6961e9e50608996(el) {
    const host = el || this;
    const p = host && host.scope && host.scope.params || {};
    return p.layout === 'board' || p.layout === 'canvas' ? p.layout : 'list';
}
function $7e5e46353758d4fa$export$63f42ab890e7f4eb(tickets, canvas) {
    const el = this;
    const root = el && el.state && el.state.root || null;
    const c = canvas && typeof canvas === 'object' ? canvas : {};
    const unit = Number(c.base) > 0 ? Number(c.base) : 16;
    const gap = Number(c.gap) > 0 ? Number(c.gap) : 0;
    const sizes = c.sizes && typeof c.sizes === 'object' ? c.sizes : {};
    const placed = [];
    for (const t of Array.isArray(tickets) ? tickets : []){
        const p = el.call('ticketCanvasPos', root, t);
        const x = p ? Number(p.x) : NaN;
        const y = p ? Number(p.y) : NaN;
        if (!Number.isFinite(x) || !Number.isFinite(y)) continue;
        const w = Number(p.width);
        placed.push({
            t: t,
            x: x,
            y: y,
            w: Number.isFinite(w) && w > 0 ? w : 0
        });
    }
    if (!placed.length) return [];
    const minX = Math.min(...placed.map((p)=>p.x));
    const minY = Math.min(...placed.map((p)=>p.y));
    const round = (v)=>Math.round(v * 100) / 100;
    const items = placed.map(({ t: t, x: x, y: y, w: w })=>{
        const key = String(t.id);
        const size = sizes[key] && typeof sizes[key] === 'object' ? sizes[key] : {};
        const width = w ? round(w / unit) : null;
        return {
            t: t,
            key: key,
            left: round((x - minX) / unit),
            top: round((y - minY) / unit),
            width: width,
            spanW: Number(size.w) > 0 ? Number(size.w) : width || 24,
            spanH: Number(size.h) > 0 ? Number(size.h) : 9
        };
    });
    // One axis: the band each card falls in and its offset inside it.
    const fold = (start, span)=>{
        const band = [];
        const offset = [];
        let index = -1;
        let from = 0;
        let to = 0;
        const order = items.map((it, i)=>i).sort((a, b)=>start(items[a]) - start(items[b]));
        for (const i of order){
            const at = start(items[i]);
            if (index < 0 || at > to + gap) {
                index++;
                from = at;
                to = at + span(items[i]);
            } else to = Math.max(to, at + span(items[i]));
            band[i] = index;
            offset[i] = round(at - from);
        }
        return {
            band: band,
            offset: offset
        };
    };
    const across = fold((it)=>it.left, (it)=>it.spanW);
    const down = fold((it)=>it.top, (it)=>it.spanH);
    return items.map((it, i)=>({
            ...it.t,
            key: it.key,
            canvasCol: across.band[i] + 1,
            canvasRow: down.band[i] + 1,
            canvasLeft: across.offset[i],
            canvasTop: down.offset[i],
            canvasWidth: it.width,
            canvasSpanW: it.spanW,
            canvasSpanH: it.spanH
        })).sort((a, b)=>a.canvasRow - b.canvasRow || a.canvasCol - b.canvasCol || a.canvasTop - b.canvasTop || a.canvasLeft - b.canvasLeft);
}
function $7e5e46353758d4fa$export$28b345dcd66bab33(cards, canvas) {
    const c = canvas && typeof canvas === 'object' ? canvas : {};
    if (c.w > 0 && c.h > 0) return {
        w: c.w,
        h: c.h
    };
    const gap = Number(c.gap) > 0 ? Number(c.gap) : 0;
    const cols = {};
    const rows = {};
    for (const card of Array.isArray(cards) ? cards : []){
        const col = Number(card.canvasCol) || 1;
        const row = Number(card.canvasRow) || 1;
        const right = (Number(card.canvasLeft) || 0) + (Number(card.canvasSpanW) || 24);
        const bottom = (Number(card.canvasTop) || 0) + (Number(card.canvasSpanH) || 9);
        cols[col] = Math.max(cols[col] || 0, right);
        rows[row] = Math.max(rows[row] || 0, bottom);
    }
    const sum = (bands)=>{
        const sizes = Object.values(bands);
        return sizes.reduce((a, b)=>a + b, 0) + Math.max(0, sizes.length - 1) * gap;
    };
    const round = (v)=>Math.round(v * 100) / 100;
    return {
        w: round(sum(cols)) || 24,
        h: round(sum(rows)) || 9
    };
}
function $7e5e46353758d4fa$export$1d11836dd8698929(scene) {
    const el = scene || this;
    const node = el && el.node;
    const s = el && el.state;
    if (!node || !s || typeof s.update !== 'function' || !node.isConnected) return false;
    const view = node.ownerDocument && node.ownerDocument.defaultView;
    const host = el.parent && el.parent.node;
    if (!view || !host || typeof view.getComputedStyle !== 'function') return false;
    const style = view.getComputedStyle(node);
    const base = parseFloat(view.getComputedStyle(host).fontSize) || 0;
    const em = parseFloat(style.fontSize) || 0;
    if (!(base > 0) || !(em > 0) || !node.offsetWidth) return false;
    const round = (v)=>Math.ceil(v * 10) / 10;
    const sizes = {};
    for (const child of typeof el.getChildren === 'function' ? el.getChildren() : []){
        const n = child && child.node;
        const id = child && child.state ? child.state.id : null;
        if (!n || !n.offsetWidth || id === null || id === undefined) continue;
        sizes[String(id)] = {
            w: round(n.offsetWidth / em),
            h: round(n.offsetHeight / em)
        };
    }
    const next = {
        base: base,
        gap: Math.round((parseFloat(style.columnGap) || 0) / em * 100) / 100,
        w: round(node.offsetWidth / em),
        h: round(node.offsetHeight / em),
        sizes: sizes
    };
    const cur = s.canvas || {};
    const near = (a, b)=>Math.abs((Number(a) || 0) - (Number(b) || 0)) < 0.2;
    const known = cur.sizes || {};
    const same = cur.base === next.base && near(cur.gap, next.gap) && near(cur.w, next.w) && near(cur.h, next.h) && Object.keys(sizes).every((id)=>known[id] && near(known[id].w, sizes[id].w) && near(known[id].h, sizes[id].h));
    if (same) return false;
    s.update({
        canvas: next
    });
    return true;
}
function $7e5e46353758d4fa$export$bbfef1f08207964b(el, s) {
    const host = el || this;
    const list = s && Array.isArray(s.tickets) ? s.tickets : null;
    if (!list || s.failed || !list.length || s.layout === 'board') return '';
    if (typeof s.total === 'number') {
        if (s.total <= list.length) return '';
        return String(host.call('polyglot', 'tickets.answer.moreOf')).replace('{n}', String(list.length)).replace('{total}', String(s.total));
    }
    const view = host && host.parent;
    const p = view && view.scope && view.scope.params || {};
    const limit = Number(s.limit) || Number(p.limit) || 20;
    if (list.length < limit) return '';
    return String(host.call('polyglot', 'tickets.answer.more')).replace('{n}', String(list.length));
}

});

parcelRegister("bs9zR", function(module, exports) {

$parcel$export(module.exports, "ticketsAiForms", () => $8569bd1775d3f5de$export$fd288885b5b9a00d);
$parcel$export(module.exports, "ticketsAiFormOpen", () => $8569bd1775d3f5de$export$eaa8787410a2a090);
$parcel$export(module.exports, "ticketsAiFormReport", () => $8569bd1775d3f5de$export$c4d17f72818ddeed);
// THE TASK SHEET IN AN AI ANSWER (workspace functions/assistantAppForms.js).
// The assistant proposes a task — a new one, or an existing task moved to
// another status, given to someone, re-prioritised. The answer's "Review and
// save" calls ticketsAiFormOpen, which opens the tickets' own detail sheet
// (TicketsDetailModal, mounted at the shell root) in create or edit mode,
// seeded with the proposal. Nothing is written until the member saves in the
// sheet; its save then reports the saved task back (the draft's `aiRequest`),
// so the answer shows it as a row that opens the task.
function $8569bd1775d3f5de$export$fd288885b5b9a00d() {
    return {
        app: {
            id: 'system/tickets',
            navbar: [
                {
                    label: 'tickets.answer.title',
                    route: '/tasks',
                    icon: 'check'
                }
            ],
            apps: [
                {
                    icon: 'check'
                }
            ]
        },
        forms: [
            {
                id: 'ticket',
                title: 'tickets.aiForm.title',
                describe: 'Create a task, or change one (recordId = the task id): title, description, status, priority, assignee, type, due date.',
                open: 'ticketsAiFormOpen',
                fields: {
                    title: {
                        type: 'string',
                        label: 'tickets.aiForm.field.title'
                    },
                    body: {
                        type: 'string',
                        label: 'tickets.aiForm.field.body'
                    },
                    columnKey: {
                        type: 'enum',
                        values: [
                            'backlog',
                            'todo',
                            'in_progress',
                            'blocked',
                            'ready_to_test',
                            'review',
                            'done'
                        ],
                        label: 'tickets.aiForm.field.status',
                        // the tickets' own words for each status (the detail sheet's);
                        // `labels` is the key the server reads — the shell's catalog
                        // resolves these bundle keys to { en, ka } before it sends them
                        labels: {
                            backlog: 'tickets.detail.status.backlog',
                            todo: 'tickets.detail.status.todo',
                            in_progress: 'tickets.state.inProgress',
                            blocked: 'tickets.state.blocked',
                            ready_to_test: 'tickets.state.readyToTest',
                            review: 'tickets.state.readyToReview',
                            done: 'tickets.detail.status.done'
                        }
                    },
                    priority: {
                        type: 'enum',
                        values: [
                            'P0',
                            'P1',
                            'P2',
                            'P3'
                        ],
                        label: 'tickets.aiForm.field.priority',
                        labels: {
                            P0: 'tickets.priority.option.p0',
                            P1: 'tickets.priority.option.p1',
                            P2: 'tickets.priority.option.p2',
                            P3: 'tickets.priority.option.p3'
                        }
                    },
                    assignee: {
                        type: 'string',
                        describe: "'me', a teammate name or an email",
                        label: 'tickets.aiForm.field.assignee'
                    },
                    issueType: {
                        type: 'enum',
                        values: [
                            'bug',
                            'task',
                            'user_story'
                        ],
                        label: 'tickets.aiForm.field.type',
                        labels: {
                            bug: 'tickets.detail.type.bug',
                            task: 'tickets.detail.type.task',
                            user_story: 'tickets.detail.type.userStory'
                        }
                    },
                    dueDate: {
                        type: 'date',
                        label: 'tickets.aiForm.field.due'
                    }
                }
            }
        ]
    };
}
async function $8569bd1775d3f5de$export$eaa8787410a2a090(formId, args) {
    const el = this;
    if (formId !== 'ticket') return false;
    const root = el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const a = args && typeof args === 'object' ? args : {};
    const v = a.values && typeof a.values === 'object' ? a.values : {};
    const patch = {};
    for (const k of [
        'title',
        'body',
        'columnKey',
        'priority',
        'issueType',
        'dueDate'
    ])if (v[k] != null && v[k] !== '') patch[k] = String(v[k]);
    const who = typeof v.assignee === 'string' ? v.assignee.trim() : '';
    if (who) {
        const low = who.toLowerCase();
        if (low === 'me' && root.currentUserEmail) patch.assigneeEmail = String(root.currentUserEmail);
        else if (low.includes('@')) patch.assigneeEmail = low;
        else {
            const people = Array.isArray(root.people) ? root.people : [];
            const hit = people.find((x)=>{
                const name = String(x && (x.name || [
                    x.firstName,
                    x.lastName
                ].filter(Boolean).join(' ')) || '').toLowerCase();
                return name && (name === low || name.split(' ').includes(low));
            });
            if (hit && hit.email) patch.assigneeEmail = String(hit.email);
        }
    }
    const aiRequest = a.requestId ? String(a.requestId) : null;
    if (a.recordId == null || a.recordId === '') {
        root.update({
            selectedTicket: {
                _new: true
            },
            ticketEditMode: false,
            ticketDraft: el.call('freshTicket', {
                ...patch,
                aiRequest: aiRequest
            })
        });
        return true;
    }
    const id = String(a.recordId);
    const lists = [
        root.tickets,
        root.myTickets,
        root.recentTickets
    ];
    let t = null;
    for (const list of lists){
        t = (Array.isArray(list) ? list : []).find((x)=>x && String(x.id) === id) || null;
        if (t) break;
    }
    if (!t) try {
        const svc = await el.call('getSDK').getService('tickets');
        const doc = await svc.get(id);
        const raw = doc && doc.data ? doc.data : doc;
        t = raw ? el.call('normalizeTicketDoc', raw) : null;
    } catch (_) {
        t = null;
    }
    if (!t) return false;
    root.update({
        selectedTicket: t,
        ticketEditMode: true,
        // The edit sheet's own seed (TicketsDetailModal's Edit): every field it
        // shows and _save round-trips, then the proposal over it.
        ticketDraft: {
            title: t.title || '',
            body: t.body || '',
            columnKey: t.columnKey || t.column_key || 'backlog',
            priority: t.priority || '',
            assigneeEmail: t.assigneeEmail || t.assignee_email || '',
            issueType: t.issueType || t.metadata && t.metadata.issueType || '',
            severity: t.severity || t.metadata && t.metadata.severity || '',
            env: t.env || t.metadata && t.metadata.env || '',
            epicName: t.epicName || t.epic_name || '',
            storyPoints: t.storyPoints || t.metadata && t.metadata.storyPoints || '',
            dueDate: t.dueDate || '',
            acceptanceCriteria: t.acceptanceCriteria || t.metadata && t.metadata.acceptanceCriteria || '',
            stepsToReproduce: t.stepsToReproduce || t.metadata && t.metadata.stepsToReproduce || '',
            expectedResult: t.expectedResult || t.metadata && t.metadata.expectedResult || '',
            reporterEmail: t.reporterEmail || t.reporter_email || '',
            labels: t.labels || [],
            ...patch,
            aiRequest: aiRequest
        }
    });
    return true;
}
function $8569bd1775d3f5de$export$c4d17f72818ddeed(requestId, t) {
    const el = this;
    if (!requestId || !t || typeof el.context?.functions?.assistantFormSaved !== 'function') return false;
    const id = t.id != null ? String(t.id) : '';
    return el.call('assistantFormSaved', requestId, {
        id: id,
        title: t.title || '',
        meta: el.call('stateLabelText', el, t.state || t.columnKey),
        route: id ? '/tasks?ticket=' + encodeURIComponent(id) : '/tasks'
    });
}

});


parcelRegister("imWdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f770b7a78dd866$export$2e2bcd8739ae039);
// Tickets-related root state. Merged into consumer apps' state via the
// sharedLibraries pipeline. Keep keys camelCase + scoped with `ticket*` or
// `_ticket*` prefixes so they're easy to grep from page/component code.
var $d5f770b7a78dd866$export$2e2bcd8739ae039 = {
    tickets: [],
    myTickets: [],
    columns: [],
    totalByColumn: {},
    // The sidebar TYPE filter's per-bucket counts ({ all, bug, task,
    // user_story }), written with totalByColumn by the board's load wave and
    // its count refreshes — see fetchTypeCounts in functions/ticketLoaders.js.
    totalByType: {},
    // The /tickets board's status: true while the board page is mounted, so its
    // counts are on screen. The board's onCreate / onRemove write it; the
    // registered counts refresh (functions/ticketLoaders.js
    // refreshTicketsCounts) reads nothing while it is false.
    _ticketsBoardLive: false,
    loadedByColumn: {},
    loadingColumn: {},
    selectedTicket: null,
    // Off-canvas filters sheet (phones only — the shared MobileRailSheet on
    // /tickets/board + /tickets/epics). Ephemeral UI, never persisted: the sheet,
    // its bottom-left FAB and the left-edge pull (armEdgeSwipe) all read and
    // write this ONE key, so they can never disagree about the open state.
    // Declared here so it exists at cold boot for subscribeTo to bind to.
    _ticketsRailOpen: false,
    searchQuery: '',
    // Unsent ticket-comment composer text, keyed by ticket id — survives an
    // Esc-close of the detail modal within the same SPA session (TASKS-MICRO-1b:
    // Esc used to drop typed-but-unsent comment text with no warning at all).
    // Explicitly in-memory-only, not persisted across a hard reload.
    _commentDrafts: {},
    // In-flight optimistic ticket creates, keyed by their temp client id —
    // lets the board's realtime INSERT handler correlate a server echo back to
    // the row THIS client just created (temp id vs the server's real id are
    // different values for the same logical ticket until the create promise
    // resolves). See TASKS-DUPE-RENDER-1 in pages/board.js + TicketDetailModal.js.
    _pendingTicketCreates: [],
    filterAssignee: 'all',
    filterEpic: null,
    filterIssueType: null,
    filterLabel: null,
    // The board's project scope — /tasks?project=<id> (the task↔project link;
    // an AI answer's ↗ Open carries it). Read on the board's mount, cleared on
    // its unmount (pages/board.js), as the ?cycle= scope is.
    filterProjectId: null,
    // Epic-TYPE ticket rows (type:'epic'), lazy-loaded by loadEpicsTree (see
    // ticketLoaders.js) and shared by the sidebar EPIC filter, the ticket
    // modal's Epic select, and the Manage Epics modal below — ONE cache, three
    // readers, so they can never disagree about which epics exist. null while
    // never fetched this session, [] once fetched with zero rows. Was already
    // written via root.update() before this declaration existed (the signal
    // store auto-vivifies new keys on first write — see
    // smbls/packages/signal/src/store.js `set()` "New property" branch — so
    // this key was never actually silently dropped); declared here to match
    // the `cycles: null` sibling pattern and document the contract.
    epicsTree: null,
    // Manage Epics modal (2026-08-02 per Nika "add option (manage epics) …
    // modal opens to manage epics (crud)") — opened from the tickets/board "+"
    // create dropdown (ticketsCreateRows). Truthy = open. CRUD operates on
    // epic-TYPE tickets via the existing saveTicket/deleteTicket functions;
    // every mutation reloads epicsTree so the filter + modal picker update
    // without a reload.
    epicsManage: null,
    epicsManageLoading: false,
    epicsManagePending: false,
    epicsManageError: null,
    epicsManageDraft: '',
    epicsManageEditId: null,
    epicsManageEditDraft: '',
    epicsManageCounts: {},
    // Roadmap cycles — populated by /tickets/roadmap onCreate via
    // sdk.tickets.cycle.list. null while loading, [] once loaded with no
    // cycles, array of cycle DTOs otherwise.
    cycles: null,
    // Per-cycle ticket caches keyed by cycle._id. Populated lazily when a
    // cycle card expands.
    cycleTicketsById: {},
    // Form modal state — `cycleEdit` opens the create/edit modal.
    // `null` = closed, `{ mode: 'create' }` = new, `{ mode: 'edit', id }` = edit.
    cycleEdit: null,
    cycleEditDraft: {
        name: '',
        description: '',
        startsAt: '',
        endsAt: ''
    },
    cycleEditPending: false,
    cycleEditError: null,
    // Attach-ticket modal — opens when manager clicks "Add ticket" inside a
    // cycle card. Holds the target cycle id + draft ticketId input.
    cycleAttach: null,
    cycleAttachDraft: '',
    cycleAttachPending: false,
    cycleAttachError: null
};

});

parcelRegister("aCYUi", function(module, exports) {

$parcel$export(module.exports, "createCanvasFolder", () => $7bccb2d4ad6e5b9a$export$b28f9a7bf33cab17);
$parcel$export(module.exports, "commitRenameNode", () => $7bccb2d4ad6e5b9a$export$bd2f87676712be3f);
$parcel$export(module.exports, "deleteCanvasNode", () => $7bccb2d4ad6e5b9a$export$c0bd117a58e7f93a);
$parcel$export(module.exports, "moveNodesIntoFolder", () => $7bccb2d4ad6e5b9a$export$a758b4c9765e966);
// @symbo-ls/workspace-files — the four canvas-node mutation ops that stay EAGER.
//
// createCanvasFolder / commitRenameNode / deleteCanvasNode / moveNodesIntoFolder
// are el.call'd by the workspace AI layer (functions/aiWorkspaceOps.js) as
// aiCreateFolder / aiRenameFile / aiDeleteFile / aiMoveFileToFolder — user
// actions that can fire on ANY route (the assistant is a chat alternative to the
// UI), long before /files is ever opened. So these four must be registered
// eagerly: the shell's sharedLibraries.js imports them directly from here, while
// the REST of files.functions (and every Files* component) defers with the
// package context via `lazySharedLibPage('/files')`.
//
// Their placement + selection-ring closure lives in ./canvasGrid.js so the SAME
// _pendingCells instance backs both these eager ops and the deferred upload/move
// handlers in index.js.

var $561su = parcelRequire("561su");

var $jhJrJ = parcelRequire("jhJrJ");
// Tab-truth-first workspace scope for every `workspaceProject.fileCanvas`
// write below — the tab's own resolved workspace (`root.workspace.id`)
// first, the per-tab pointer as a boot fallback. Threaded EXPLICITLY as
// `payload.workspaceId` on every create/update/remove call rather than left
// to the SDK's ambient `_context.activeWorkspaceId` fallback (WorkspaceProject
// Service's `_fileCanvasWorkspaceId` reads payload.workspaceId FIRST) —
// FILES-RENAME-1 (tickets/sonnet.md): a rename with no explicit workspaceId
// depends entirely on that ambient context being both SET and correct for
// the workspace the tab is actually viewing; when it isn't (MWT off — see
// mwtFlag.js's "stays pinned … FOREVER" note — or a boot race before
// `bootShell`'s `sdk.updateContext` lands), the server's G1 workspace-pin
// guard 404s ("not found"), caught here and only console.error'd — a rename
// that silently reverts on Enter with no toast. Reproduced directly against
// the dev API: `PATCH /file-canvas/:id` with no `?workspaceId=` 404s
// `not_found` for a real, visible row; the identical request WITH the
// explicit param succeeds. Duplicated (not imported) from functions/index.js's
// own `_filesActiveWsId` — same reasoning subscribeFilesRealtime.js's
// `_activeWsIdForRealtime` documents: nodeOps.js is the EAGER slice loaded
// before index.js's DEFERRED slice ever runs, and importing from index.js
// here would cycle back through nodeOps.js's own re-export in that file.
const $7bccb2d4ad6e5b9a$var$_filesActiveWsId = (root)=>{
    if (root?.workspace?.id) return root.workspace.id;
    try {
        return (0, $jhJrJ.getActiveWorkspacePointer)() || null;
    } catch (_) {
        return null;
    }
};
const $7bccb2d4ad6e5b9a$export$b28f9a7bf33cab17 = async function(name) {
    const root = this.state.root;
    const parentId = root.filesOpenFolder || null;
    const requested = name && String(name).trim() || 'New folder';
    // Disambiguate against real siblings + any name claimed by another
    // in-flight create in this same folder — "New folder", "New folder 2",
    // "New folder 3", … instead of stacking duplicates (STUDIO/FILES-MICRO-1).
    const folderName = (0, $561su._uniqueSiblingName)(root, requested, parentId);
    const nameKey = (0, $561su._claimName)(parentId, folderName);
    // Claim + reserve the cell so a second rapid create (or a racing upload)
    // can't resolve the same cell and stack on top of this folder.
    const place = (0, $561su._claimCell)(root);
    const payload = {
        kind: 'folder',
        name: folderName,
        parent_id: parentId,
        x: place.x,
        y: place.y,
        scope: root.filesScope || 'shared',
        created_by: root.currentUserEmail || null,
        workspaceId: $7bccb2d4ad6e5b9a$var$_filesActiveWsId(root)
    };
    try {
        const res = await this.sdk.execute('workspaceProject.fileCanvas', 'create', {
            payload: payload
        });
        const id = (0, $561su._rowId)(res);
        if (!id) return null;
        root.update({
            fileNodes: [
                ...root.fileNodes || [],
                {
                    id: id,
                    kind: 'folder',
                    name: folderName,
                    parentId: payload.parent_id,
                    x: place.x,
                    y: place.y,
                    fileId: null,
                    docId: null,
                    url: null,
                    mime: null,
                    size: null,
                    scope: payload.scope,
                    createdBy: payload.created_by,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString()
                }
            ],
            // Auto-select the just-created folder (per Nika) — it mounts with its
            // ring; _syncRingsAfterRender clears any prior selection's rings.
            filesSelectedIds: [
                id
            ]
        });
        (0, $561su._syncRingsAfterRender)(this, [
            id
        ]);
        return id;
    } catch (err) {
        console.error('[Files] createCanvasFolder failed:', err?.message || err);
        return null;
    } finally{
        // Released after the optimistic fileNodes update above, so occupancy/name
        // uniqueness never drops the reservation between the in-flight claim and
        // the real row landing in root.fileNodes.
        (0, $561su._releaseCell)(place);
        (0, $561su._releaseName)(nameKey);
    }
};
const $7bccb2d4ad6e5b9a$export$bd2f87676712be3f = async function(id, name) {
    const root = this.state.root;
    const sdk = this.sdk;
    const trimmed = (name || '').trim();
    const cur = (root.fileNodes || []).find((n)=>n.id === id);
    if (root.filesRenaming === id) root.update({
        filesRenaming: null
    }, {
        preventFetch: true
    });
    if (!sdk || !cur || !trimmed) return false;
    if (trimmed === cur.name) return true;
    const prevName = cur.name;
    root.update({
        fileNodes: (root.fileNodes || []).map((n)=>n.id === id ? {
                ...n,
                name: trimmed
            } : n)
    }, {
        preventFetch: true
    });
    try {
        await sdk.execute('workspaceProject.fileCanvas', 'update', {
            id: id,
            payload: {
                name: trimmed,
                workspaceId: $7bccb2d4ad6e5b9a$var$_filesActiveWsId(root)
            }
        });
        return true;
    } catch (err) {
        console.error('[Files] rename failed:', err?.message || err);
        // Roll back the optimistic name so the UI + the AI's report stay honest.
        root.update({
            fileNodes: (root.fileNodes || []).map((n)=>n.id === id ? {
                    ...n,
                    name: prevName
                } : n)
        }, {
            preventFetch: true
        });
        // A rename that reverts with no explanation reads as data loss — surface
        // it instead of leaving the user to notice the name silently snapped
        // back (FILES-RENAME-1, tickets/sonnet.md).
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'files.rename.failedTitle'),
            message: err?.message || this.call('polyglot', 'files.rename.failedMessage')
        });
        return false;
    }
};
const $7bccb2d4ad6e5b9a$export$c0bd117a58e7f93a = async function(id) {
    const root = this.state.root;
    const sdk = this.sdk;
    if (!id || !sdk || String(id).indexOf('doc:') === 0) return false;
    const node = (root.fileNodes || []).find((n)=>n.id === id);
    try {
        await sdk.execute('workspaceProject.fileCanvas', 'remove', {
            id: id,
            workspaceId: $7bccb2d4ad6e5b9a$var$_filesActiveWsId(root)
        });
        const pos = {
            ...root._fileNodePos || {}
        };
        delete pos[id];
        root.update({
            fileNodes: (root.fileNodes || []).filter((n)=>n.id !== id),
            _fileNodePos: pos,
            filesSelectedIds: (root.filesSelectedIds || []).filter((x)=>x !== id)
        }, {
            preventFetch: true
        });
        if (node && node.fileId) sdk.execute('workspaceProject.storage', 'remove', {
            bucket: 'workspace-files',
            path: node.fileId
        }).catch((err)=>console.warn('[Files] storage remove failed:', err?.message || err));
        return true;
    } catch (err) {
        console.error('[Files] deleteCanvasNode failed:', err?.message || err);
        // A refused delete says so (2026-10-30, CRUD standard rule 5) — the
        // confirm closed and nothing happened. The desktop drops a node only after
        // the server took the delete, so the item is still where it was.
        const name = node && node.name || this.call('polyglot', 'files.delete.itemFallback');
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'files.delete.failedTitle'),
            message: this.call('polyglot', 'files.delete.failedMessage').replace('{name}', ()=>name)
        });
        return false;
    }
};
const $7bccb2d4ad6e5b9a$export$a758b4c9765e966 = function(ids, folderId) {
    const root = this.state.root;
    const sdk = this.sdk;
    if (!sdk || folderId === undefined || !ids || !ids.length) return;
    const ancestors = (0, $561su._folderAncestors)(root, folderId);
    const list = ids.filter((id)=>id !== folderId && !ancestors.has(id));
    if (!list.length) return;
    const pos = root._fileNodePos || {};
    // A position-less node in the target (a server-created row) counts at its
    // placed cell, so a moved-in node never lands on it.
    const spots = (0, $561su._unpositionedSpots)(root);
    const occ = new Set();
    (root.fileNodes || []).forEach((n)=>{
        if ((n.parentId || null) !== folderId) return;
        const p = (0, $561su._nodeSpot)(root, n, spots);
        const c = (0, $561su.snapToGrid)(p.x, p.y);
        occ.add((0, $561su._cellKey)(c.x, c.y));
    });
    let scan = 0;
    const nextCell = ()=>{
        let p = (0, $561su.gridPlace)(scan++);
        while(occ.has((0, $561su._cellKey)(p.x, p.y)) && scan < 2000)p = (0, $561su.gridPlace)(scan++);
        occ.add((0, $561su._cellKey)(p.x, p.y));
        return p;
    };
    const cellById = {};
    list.forEach((id)=>{
        const cell = nextCell();
        if (String(id).indexOf('doc:') === 0) {
            const docId = String(id).slice(4);
            const doc = (root.fileDocs || []).find((d)=>d.id === docId);
            const payload = {
                kind: 'doc',
                name: doc && doc.title || 'Document',
                parent_id: folderId,
                x: cell.x,
                y: cell.y,
                doc_id: docId,
                scope: root.filesScope || 'shared',
                created_by: root.currentUserEmail || null,
                workspaceId: $7bccb2d4ad6e5b9a$var$_filesActiveWsId(root)
            };
            sdk.execute('workspaceProject.fileCanvas', 'create', {
                payload: payload
            }).then((res)=>{
                const realId = (0, $561su._rowId)(res);
                if (!realId) return;
                root.update({
                    fileNodes: [
                        ...root.fileNodes || [],
                        {
                            id: realId,
                            kind: 'doc',
                            name: payload.name,
                            parentId: folderId,
                            x: cell.x,
                            y: cell.y,
                            fileId: null,
                            docId: docId,
                            url: null,
                            mime: null,
                            size: null,
                            scope: payload.scope,
                            createdBy: payload.created_by
                        }
                    ]
                }, {
                    preventFetch: true
                });
            }).catch((err)=>console.error('[Files] move doc into folder failed:', err?.message || err));
            return;
        }
        cellById[id] = cell;
        sdk.execute('workspaceProject.fileCanvas', 'update', {
            id: id,
            payload: {
                parent_id: folderId,
                x: cell.x,
                y: cell.y,
                workspaceId: $7bccb2d4ad6e5b9a$var$_filesActiveWsId(root)
            }
        }).catch((err)=>console.error('[Files] move into folder failed:', err?.message || err));
    });
    const movedIds = new Set(Object.keys(cellById));
    const nextPos = {
        ...pos
    };
    movedIds.forEach((id)=>{
        nextPos[id] = cellById[id];
    });
    root.update({
        fileNodes: (root.fileNodes || []).map((n)=>movedIds.has(n.id) ? {
                ...n,
                parentId: folderId,
                x: cellById[n.id].x,
                y: cellById[n.id].y
            } : n),
        _fileNodePos: nextPos,
        filesSelectedIds: []
    }, {
        preventFetch: true
    });
};

});
parcelRegister("561su", function(module, exports) {

$parcel$export(module.exports, "gridPlace", () => $3b5ea4ef1fc0a07d$export$949fd90b32ef557f);
$parcel$export(module.exports, "snapToGrid", () => $3b5ea4ef1fc0a07d$export$195604d042fd3f87);
$parcel$export(module.exports, "_cellKey", () => $3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7);
$parcel$export(module.exports, "_pendingCells", () => $3b5ea4ef1fc0a07d$export$fc4a861dafcd05cd);
$parcel$export(module.exports, "_hasStoredSpot", () => $3b5ea4ef1fc0a07d$export$3c5b19b421ca9e51);
$parcel$export(module.exports, "_unpositionedSpots", () => $3b5ea4ef1fc0a07d$export$1c3ad1a56b998408);
$parcel$export(module.exports, "_nodeSpot", () => $3b5ea4ef1fc0a07d$export$6e0987f16fae214);
$parcel$export(module.exports, "_realNodeCells", () => $3b5ea4ef1fc0a07d$export$b8c0630944fc8b32);
$parcel$export(module.exports, "_placedVirtualDocs", () => $3b5ea4ef1fc0a07d$export$b80359a11bbb2eff);
$parcel$export(module.exports, "_occupiedCells", () => $3b5ea4ef1fc0a07d$export$f3e2c98a2fcf9de0);
$parcel$export(module.exports, "_nearestFreeCell", () => $3b5ea4ef1fc0a07d$export$52e34584e20d6bec);
$parcel$export(module.exports, "_freeGridCell", () => $3b5ea4ef1fc0a07d$export$15c814d4077310c1);
$parcel$export(module.exports, "_claimCell", () => $3b5ea4ef1fc0a07d$export$687f8f7b02c6c0c6);
$parcel$export(module.exports, "_releaseCell", () => $3b5ea4ef1fc0a07d$export$f2731cdd63a5c86d);
$parcel$export(module.exports, "_rowId", () => $3b5ea4ef1fc0a07d$export$7505c49438b7266e);
$parcel$export(module.exports, "_ringSyncDom", () => $3b5ea4ef1fc0a07d$export$f7866b9a19cef1f4);
$parcel$export(module.exports, "_syncRingsAfterRender", () => $3b5ea4ef1fc0a07d$export$6ae82cfdc781e723);
$parcel$export(module.exports, "_uniqueSiblingName", () => $3b5ea4ef1fc0a07d$export$44799430df36826);
$parcel$export(module.exports, "_claimName", () => $3b5ea4ef1fc0a07d$export$4dbd24a7d497c008);
$parcel$export(module.exports, "_releaseName", () => $3b5ea4ef1fc0a07d$export$174187b5cd91e339);
$parcel$export(module.exports, "_folderAncestors", () => $3b5ea4ef1fc0a07d$export$4f9cc39dfdd8556b);
// @symbo-ls/workspace-files — grid placement, occupancy, and selection-ring
// helpers for the /files desktop.
//
// This module is the SHARED closure behind BOTH the eager node-mutation ops
// (nodeOps.js — createCanvasFolder/moveNodesIntoFolder need placement) AND the
// deferred /files functions (index.js — upload/move/cleanup/stage gestures).
// It lives on its own so `_pendingCells` (the in-flight-placement reservation
// set) is a SINGLE instance across both: a duplicated copy would let a
// folder-create in the eager slice race an upload in the deferred slice onto the
// same cell — exactly the concurrency bug `_pendingCells` exists to prevent.
//
// Pure module state + geometry only (no DOMQL, no `this`); every function takes
// its `root` / DOM node explicitly.
// ── grid placement ─────────────────────────────────────────────────────────
// Lattice sized for the D1 preview tiles (2026-06-10 per Nika "increase file
// thumbs + gap between files"): roomier cells so tiles breathe. Stored
// positions keep their coords and re-snap to this lattice on next move.
const $3b5ea4ef1fc0a07d$var$GRID_X0 = 48;
const $3b5ea4ef1fc0a07d$var$GRID_Y0 = 48;
const $3b5ea4ef1fc0a07d$var$GRID_DX = 168;
const $3b5ea4ef1fc0a07d$var$GRID_DY = 188;
const $3b5ea4ef1fc0a07d$var$GRID_COLS = 7;
const $3b5ea4ef1fc0a07d$export$949fd90b32ef557f = (i)=>({
        x: $3b5ea4ef1fc0a07d$var$GRID_X0 + i % $3b5ea4ef1fc0a07d$var$GRID_COLS * $3b5ea4ef1fc0a07d$var$GRID_DX,
        y: $3b5ea4ef1fc0a07d$var$GRID_Y0 + Math.floor(i / $3b5ea4ef1fc0a07d$var$GRID_COLS) * $3b5ea4ef1fc0a07d$var$GRID_DY
    });
const $3b5ea4ef1fc0a07d$export$195604d042fd3f87 = (x, y)=>({
        x: Math.max($3b5ea4ef1fc0a07d$var$GRID_X0, $3b5ea4ef1fc0a07d$var$GRID_X0 + Math.round(((x || 0) - $3b5ea4ef1fc0a07d$var$GRID_X0) / $3b5ea4ef1fc0a07d$var$GRID_DX) * $3b5ea4ef1fc0a07d$var$GRID_DX),
        y: Math.max($3b5ea4ef1fc0a07d$var$GRID_Y0, $3b5ea4ef1fc0a07d$var$GRID_Y0 + Math.round(((y || 0) - $3b5ea4ef1fc0a07d$var$GRID_Y0) / $3b5ea4ef1fc0a07d$var$GRID_DY) * $3b5ea4ef1fc0a07d$var$GRID_DY)
    });
const $3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7 = (x, y)=>x + ',' + y;
const $3b5ea4ef1fc0a07d$export$fc4a861dafcd05cd = new Set();
const $3b5ea4ef1fc0a07d$export$3c5b19b421ca9e51 = (n)=>!!n && Number.isFinite(n.x) && Number.isFinite(n.y);
const $3b5ea4ef1fc0a07d$export$1c3ad1a56b998408 = (root)=>{
    const out = {};
    const nodes = root && root.fileNodes || [];
    const unplaced = nodes.filter((n)=>n && n.id && !$3b5ea4ef1fc0a07d$export$3c5b19b421ca9e51(n));
    if (!unplaced.length) return out;
    const pos = root._fileNodePos || {};
    const waiting = unplaced.filter((n)=>!pos[n.id]);
    if (!waiting.length) return out;
    const folderOf = (n)=>n.parentId || '';
    const folders = new Set(waiting.map(folderOf));
    const taken = {};
    const takenIn = (folder)=>taken[folder] || (taken[folder] = new Set($3b5ea4ef1fc0a07d$export$fc4a861dafcd05cd));
    nodes.forEach((n)=>{
        if (!n || !folders.has(folderOf(n))) return;
        const p = n.id && pos[n.id] || ($3b5ea4ef1fc0a07d$export$3c5b19b421ca9e51(n) ? n : null);
        if (!p) return;
        const c = $3b5ea4ef1fc0a07d$export$195604d042fd3f87(p.x, p.y);
        takenIn(folderOf(n)).add($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(c.x, c.y));
    });
    const stable = (a, b)=>String(a.createdAt || '').localeCompare(String(b.createdAt || '')) || String(a.id).localeCompare(String(b.id));
    waiting.slice().sort(stable).forEach((n)=>{
        const occ = takenIn(folderOf(n));
        let i = 0;
        let p = $3b5ea4ef1fc0a07d$export$949fd90b32ef557f(i);
        while(occ.has($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(p.x, p.y)) && i < 5000)p = $3b5ea4ef1fc0a07d$export$949fd90b32ef557f(++i);
        occ.add($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(p.x, p.y));
        out[n.id] = {
            x: p.x,
            y: p.y
        };
    });
    return out;
};
const $3b5ea4ef1fc0a07d$export$6e0987f16fae214 = (root, n, spots)=>{
    const pos = root && root._fileNodePos || {};
    if (n && pos[n.id]) return pos[n.id];
    if ($3b5ea4ef1fc0a07d$export$3c5b19b421ca9e51(n)) return {
        x: n.x,
        y: n.y
    };
    const placed = (spots || $3b5ea4ef1fc0a07d$export$1c3ad1a56b998408(root))[n && n.id];
    return placed || $3b5ea4ef1fc0a07d$export$949fd90b32ef557f(0);
};
const $3b5ea4ef1fc0a07d$export$b8c0630944fc8b32 = (root, excludeId)=>{
    const folder = root.filesOpenFolder || null;
    const spots = $3b5ea4ef1fc0a07d$export$1c3ad1a56b998408(root);
    const occ = new Set();
    (root.fileNodes || []).forEach((n)=>{
        if (n.id === excludeId || (n.parentId || null) !== folder) return;
        const p = $3b5ea4ef1fc0a07d$export$6e0987f16fae214(root, n, spots);
        const c = $3b5ea4ef1fc0a07d$export$195604d042fd3f87(p.x, p.y);
        occ.add($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(c.x, c.y));
    });
    return occ;
};
const $3b5ea4ef1fc0a07d$export$b80359a11bbb2eff = (root)=>{
    if (root.filesOpenFolder || (root.filesScope || 'shared') === 'private') return [];
    // Wait for the real rows before gridding virtuals — placing them against an
    // un-fetched (empty) node list reshuffles them when fileNodes lands (flicker).
    if (!root._fileNodesLoaded) return [];
    const placed = new Set((root.fileNodes || []).filter((n)=>n.kind === 'doc' && n.docId).map((n)=>n.docId));
    const occ = $3b5ea4ef1fc0a07d$export$b8c0630944fc8b32(root, null);
    const out = [];
    let scan = 0;
    (root.fileDocs || []).filter((d)=>d.id && !placed.has(d.id)).forEach((d)=>{
        let p = $3b5ea4ef1fc0a07d$export$949fd90b32ef557f(scan++);
        while(occ.has($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(p.x, p.y)) && scan < 2000)p = $3b5ea4ef1fc0a07d$export$949fd90b32ef557f(scan++);
        occ.add($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(p.x, p.y));
        out.push({
            docId: d.id,
            title: d.title,
            x: p.x,
            y: p.y
        });
    });
    return out;
};
const $3b5ea4ef1fc0a07d$export$f3e2c98a2fcf9de0 = (root, excludeId)=>{
    const occ = $3b5ea4ef1fc0a07d$export$b8c0630944fc8b32(root, excludeId);
    $3b5ea4ef1fc0a07d$export$b80359a11bbb2eff(root).forEach((v)=>occ.add($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(v.x, v.y)));
    $3b5ea4ef1fc0a07d$export$fc4a861dafcd05cd.forEach((k)=>occ.add(k));
    return occ;
};
const $3b5ea4ef1fc0a07d$export$52e34584e20d6bec = (occ, c)=>{
    if (!occ.has($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(c.x, c.y))) return c;
    const col0 = Math.round((c.x - $3b5ea4ef1fc0a07d$var$GRID_X0) / $3b5ea4ef1fc0a07d$var$GRID_DX);
    const row0 = Math.round((c.y - $3b5ea4ef1fc0a07d$var$GRID_Y0) / $3b5ea4ef1fc0a07d$var$GRID_DY);
    for(let r = 1; r < 40; r++){
        for(let dc = -r; dc <= r; dc++)for(let dr = -r; dr <= r; dr++){
            if (Math.max(Math.abs(dc), Math.abs(dr)) !== r) continue;
            const col = col0 + dc;
            const row = row0 + dr;
            if (col < 0 || row < 0) continue;
            const x = $3b5ea4ef1fc0a07d$var$GRID_X0 + col * $3b5ea4ef1fc0a07d$var$GRID_DX;
            const y = $3b5ea4ef1fc0a07d$var$GRID_Y0 + row * $3b5ea4ef1fc0a07d$var$GRID_DY;
            if (!occ.has($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(x, y))) return {
                x: x,
                y: y
            };
        }
    }
    return null;
};
const $3b5ea4ef1fc0a07d$export$15c814d4077310c1 = (root, hint, excludeId, used)=>{
    const occ = $3b5ea4ef1fc0a07d$export$f3e2c98a2fcf9de0(root, excludeId);
    if (used) used.forEach((k)=>occ.add(k));
    if (hint && typeof hint.x === 'number' && typeof hint.y === 'number') {
        const near = $3b5ea4ef1fc0a07d$export$52e34584e20d6bec(occ, $3b5ea4ef1fc0a07d$export$195604d042fd3f87(hint.x, hint.y));
        if (near) return near;
    }
    for(let i = 0; i < 2000; i++){
        const p = $3b5ea4ef1fc0a07d$export$949fd90b32ef557f(i);
        if (!occ.has($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(p.x, p.y))) return p;
    }
    return $3b5ea4ef1fc0a07d$export$949fd90b32ef557f(0);
};
const $3b5ea4ef1fc0a07d$export$687f8f7b02c6c0c6 = (root, hint, excludeId)=>{
    const cell = $3b5ea4ef1fc0a07d$export$15c814d4077310c1(root, hint, excludeId);
    $3b5ea4ef1fc0a07d$export$fc4a861dafcd05cd.add($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(cell.x, cell.y));
    return cell;
};
const $3b5ea4ef1fc0a07d$export$f2731cdd63a5c86d = (cell)=>{
    if (cell) $3b5ea4ef1fc0a07d$export$fc4a861dafcd05cd.delete($3b5ea4ef1fc0a07d$export$f7e19c77bd81b1c7(cell.x, cell.y));
};
const $3b5ea4ef1fc0a07d$export$7505c49438b7266e = (res)=>{
    const row = res?.data || res;
    if (!row) return null;
    return row.id || (Array.isArray(row) ? row[0] && row[0].id : null);
};
const $3b5ea4ef1fc0a07d$export$f7866b9a19cef1f4 = (deskNode, ids)=>{
    if (!deskNode) return;
    const set = new Set(ids || []);
    try {
        deskNode.querySelectorAll('[data-node-id]').forEach((n)=>{
            if (n.firstElementChild) n.firstElementChild.style.display = set.has(n.dataset.nodeId) ? 'block' : 'none';
        });
    } catch (err) {
        console.warn('[Files] ring sync failed:', err);
    }
};
const $3b5ea4ef1fc0a07d$export$6ae82cfdc781e723 = (self, ids)=>{
    setTimeout(()=>{
        const fm = self.FilesMain || self.lookup && self.lookup('FilesMain');
        const desk = fm && fm.Body && fm.Body.Stage && fm.Body.Stage.Board && fm.Body.Stage.Board.FilesDesktop && fm.Body.Stage.Board.FilesDesktop.node;
        $3b5ea4ef1fc0a07d$export$f7866b9a19cef1f4(desk, ids || []);
    }, 60);
};
const $3b5ea4ef1fc0a07d$export$be806c856e6530c5 = new Set();
// Separator can't appear in a resolved name/parentId pair ambiguously enough
// to matter here — worst case is an over-cautious extra numbering, never an
// under-cautious collision.
const $3b5ea4ef1fc0a07d$var$_nameReserveKey = (parentId, name)=>(parentId || 'root') + '::' + String(name).trim().toLowerCase();
const $3b5ea4ef1fc0a07d$export$44799430df36826 = (root, baseName, parentId)=>{
    const base = String(baseName || '').trim() || 'New folder';
    const taken = new Set((root.fileNodes || []).filter((n)=>(n.parentId || null) === (parentId || null)).map((n)=>String(n.name || '').trim().toLowerCase()));
    let candidate = base;
    let i = 1;
    while(taken.has(candidate.toLowerCase()) || $3b5ea4ef1fc0a07d$export$be806c856e6530c5.has($3b5ea4ef1fc0a07d$var$_nameReserveKey(parentId, candidate))){
        i += 1;
        candidate = `${base} ${i}`;
    }
    return candidate;
};
const $3b5ea4ef1fc0a07d$export$4dbd24a7d497c008 = (parentId, name)=>{
    const key = $3b5ea4ef1fc0a07d$var$_nameReserveKey(parentId, name);
    $3b5ea4ef1fc0a07d$export$be806c856e6530c5.add(key);
    return key;
};
const $3b5ea4ef1fc0a07d$export$174187b5cd91e339 = (key)=>{
    if (key) $3b5ea4ef1fc0a07d$export$be806c856e6530c5.delete(key);
};
const $3b5ea4ef1fc0a07d$export$4f9cc39dfdd8556b = (root, folderId)=>{
    const byId = {};
    (root.fileNodes || []).forEach((n)=>{
        byId[n.id] = n;
    });
    const chain = new Set();
    let cur = folderId;
    let guard = 0;
    while(cur && byId[cur] && guard++ < 64){
        chain.add(cur);
        cur = byId[cur].parentId || null;
    }
    return chain;
};

});


parcelRegister("4fHJf", function(module, exports) {

$parcel$export(module.exports, "filesAiViews", () => $318a7bbe7287f77a$export$2c2fc9c338ede9e9);
$parcel$export(module.exports, "filesAnswerKind", () => $318a7bbe7287f77a$export$37fb97137a4046f8);
$parcel$export(module.exports, "filesAnswerRead", () => $318a7bbe7287f77a$export$32c216546c0abd7d);
$parcel$export(module.exports, "filesAnswerLoad", () => $318a7bbe7287f77a$export$6604019394104947);
$parcel$export(module.exports, "filesAnswerRows", () => $318a7bbe7287f77a$export$d085933503f1020);
$parcel$export(module.exports, "filesAnswerOpen", () => $318a7bbe7287f77a$export$77de48a58028701d);
// FILES IN AN AI ANSWER — the `files-recent` view the assistant mounts in its
// thread and a Fly page places as a section (workspace functions/
// assistantAppViews.js, the `views[]` contract).
//
// filesAiViews() is the files view PROVIDER. It rides the shell's EAGER files
// slice WITH its component (workspace sharedLibraries.js), so the view mounts
// at once on any route without folding the files desktop; `fold: 'files'` is
// the safety net for a host that registered the provider alone. One view:
//
//   files-recent   the workspace's files, folders and notes, newest first;
//                  `kind` narrows it, `search` matches the name. A row opens
//                  the item where it lives — the Files window on that node
//                  (`/files?node=<id>`, openFilesDeepLink): a folder entered,
//                  a file in the app that owns its format or the viewer, a
//                  note in the viewer.
//
// The rows come from the files plane's own reads (workspaceProject.fileCanvas
// and docs, `list` — SDK-only) into the view's OWN state, never root.fileNodes.
// Nothing here writes.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $318a7bbe7287f77a$export$2c2fc9c338ede9e9() {
    return {
        app: {
            id: 'system/files',
            navbar: [
                {
                    label: 'shell.app.files',
                    route: '/files',
                    icon: 'folder'
                }
            ],
            apps: [
                {
                    icon: 'folder'
                }
            ]
        },
        fold: 'files',
        views: [
            {
                id: 'files-recent',
                title: 'files.answer.title',
                describe: 'The workspace files, folders and notes, newest first; kind = images, documents (files and notes), media, folders or notes; search = words in the name.',
                component: 'FilesAnswerView',
                icon: 'folder',
                hue: 'documents',
                size: 'l',
                params: {
                    kind: {
                        type: 'enum',
                        values: [
                            'all',
                            'image',
                            'document',
                            'media',
                            'folder',
                            'note'
                        ],
                        // Bundle keys: the catalog sends them as { en, ka } words.
                        labels: {
                            all: 'files.answer.kind.all',
                            image: 'files.answer.kind.image',
                            document: 'files.answer.kind.document',
                            media: 'files.answer.kind.media',
                            folder: 'files.answer.kind.folder',
                            note: 'files.answer.kind.note'
                        },
                        default: 'all'
                    },
                    search: {
                        type: 'string',
                        describe: 'words in the file name'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 50,
                        default: 12
                    }
                },
                link: {
                    route: '/files',
                    query: {}
                }
            }
        ]
    };
}
function $318a7bbe7287f77a$export$37fb97137a4046f8(item) {
    const it = item && typeof item === 'object' ? item : {};
    if (it.kind === 'folder') return 'folder';
    if (it.kind === 'doc' || it.kind === 'note') return 'note';
    const mime = String(it.mime || '').toLowerCase();
    const ext = (String(it.name || '').match(/\.([a-z0-9]{1,8})$/i) || [])[1] || '';
    const e = ext.toLowerCase();
    if (mime.startsWith('image/') || [
        'png',
        'jpg',
        'jpeg',
        'gif',
        'webp',
        'svg',
        'avif',
        'heic'
    ].includes(e)) return 'image';
    if (mime.startsWith('video/') || mime.startsWith('audio/') || [
        'mp4',
        'mov',
        'webm',
        'mp3',
        'wav',
        'm4a',
        'ogg'
    ].includes(e)) return 'media';
    if (mime === 'application/pdf' || mime.startsWith('text/') || mime.includes('document') || mime.includes('sheet') || mime.includes('presentation') || [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'csv',
        'ppt',
        'pptx',
        'txt',
        'md',
        'rtf',
        'key',
        'pages',
        'numbers'
    ].includes(e)) return 'document';
    return 'other';
}
async function $318a7bbe7287f77a$export$32c216546c0abd7d(sdk, params) {
    const el = this;
    const p = params && typeof params === 'object' ? params : {};
    if (!sdk || typeof sdk.execute !== 'function') return {
        items: [],
        failed: true
    };
    const rowsOf = (res)=>Array.isArray(res) ? res : res && Array.isArray(res.data) && res.data || [];
    let failed = false;
    const [nodesRes, docsRes] = await Promise.all([
        Promise.resolve().then(()=>sdk.execute('workspaceProject.fileCanvas', 'list', {})).catch(()=>{
            failed = true;
            return [];
        }),
        Promise.resolve().then(()=>sdk.execute('docs', 'list', {})).catch(()=>[])
    ]);
    const nodes = rowsOf(nodesRes).map((r)=>({
            id: String(r.id),
            kind: r.kind || 'file',
            name: r.name || '',
            mime: r.mime_type || r.mime || null,
            docId: r.doc_id || null,
            at: Date.parse(r.updated_at || r.created_at || '') || 0
        }));
    const placed = new Set(nodes.filter((n)=>n.docId).map((n)=>String(n.docId)));
    const notes = rowsOf(docsRes).map((d)=>({
            id: 'doc:' + String(d.docId || d._id || d.id),
            kind: 'doc',
            name: d.title || '',
            mime: null,
            docId: String(d.docId || d._id || d.id),
            at: Date.parse(d.updatedAt || d.createdAt || '') || 0
        })).filter((d)=>!placed.has(d.docId));
    const kind = typeof p.kind === 'string' && p.kind ? p.kind : 'all';
    const words = String(p.search || '').toLowerCase().split(/\s+/).filter(Boolean);
    const limit = Math.max(1, Math.min(50, Math.floor(Number(p.limit)) || 12));
    // A DOCUMENT is what a person calls one: an office file (a pdf, a sheet…)
    // OR a note — the Notes app keeps its notes as documents. "Find the
    // document about warranty limitations" asked kind 'document' and found
    // nothing while Notes listed that note (Fly QA, BUG-1: the same file was
    // found with kind 'note'). `note` stays the narrow ask: notes only.
    const fits = (it)=>{
        if (kind === 'all') return true;
        const k = el.call('filesAnswerKind', it);
        return k === kind || kind === 'document' && k === 'note';
    };
    const items = nodes.concat(notes).filter(fits).filter((it)=>{
        const name = String(it.name || '').toLowerCase();
        return words.every((w)=>name.includes(w));
    }).sort((a, b)=>b.at - a.at).slice(0, limit);
    return {
        items: items,
        failed: failed
    };
}
async function $318a7bbe7287f77a$export$6604019394104947(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const params = host.scope && host.scope.params || {};
    const sig = JSON.stringify([
        params.kind || 'all',
        params.search || '',
        params.limit || 12
    ]);
    if (host.__filesAnswerSig === sig) return null;
    host.__filesAnswerSig = sig;
    const sdk = host.sdk || host.call('getSDK');
    const res = await host.call('filesAnswerRead', sdk, params);
    if (host.__filesAnswerSig !== sig) return null;
    const items = res && Array.isArray(res.items) ? res.items : [];
    host.state.update({
        files: items,
        failed: !!(res && res.failed) && !items.length
    });
    return res;
}
function $318a7bbe7287f77a$export$d085933503f1020(items) {
    const el = this;
    const list = Array.isArray(items) ? items : [];
    const KIND = {
        image: {
            icon: 'images',
            label: 'files.answer.kind.image'
        },
        media: {
            icon: 'video',
            label: 'files.answer.kind.media'
        },
        document: {
            icon: 'document',
            label: 'files.answer.kind.document'
        },
        folder: {
            icon: 'folder',
            label: 'files.answer.kind.folder'
        },
        note: {
            icon: 'document',
            label: 'files.answer.kind.note'
        },
        other: {
            icon: 'document',
            label: 'files.answer.kind.other'
        }
    };
    return list.map((it)=>{
        const kind = KIND[el.call('filesAnswerKind', it)] || KIND.other;
        const when = it.at ? el.call('localizedDate', new Date(it.at), {
            month: 'short',
            day: 'numeric'
        }) : '';
        return {
            key: 'f-' + String(it.id).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: it.name || String(el.call('polyglot', 'files.answer.untitled')),
            meta: [
                String(el.call('polyglot', kind.label)),
                when
            ].filter(Boolean).join(" \xb7 "),
            icon: kind.icon,
            initials: null,
            src: null,
            progress: null,
            bad: false,
            href: null,
            open: {
                call: 'filesAnswerOpen',
                arg: it.id
            }
        };
    });
}
function $318a7bbe7287f77a$export$77de48a58028701d(id) {
    if (!id) return false;
    this.call('openAppPage', '/files?node=' + encodeURIComponent(String(id)));
    return true;
}

});

parcelRegister("dEPsX", function(module, exports) {

$parcel$export(module.exports, "FilesAnswerView", () => $9f16eedf7ea2005b$export$d2f46cdd7b2cb679);
// FILES IN AN AI ANSWER — the `files-recent` view (functions/filesAnswer.js
// filesAiViews; the shell mounts it in the assistant's thread and on a Fly
// page with scope { params, embedded }). Read-only. Its items live in its OWN
// state (never root.fileNodes), read once per params: the home widget kit's
// rows — the name, "kind · when", an icon by kind; a row opens the item in the
// Files window. While reading: three row stand-ins; no match or a failed read:
// one sentence.
const $9f16eedf7ea2005b$export$d2f46cdd7b2cb679 = {
    flow: 'y',
    gap: 'A',
    minWidth: '0',
    dataFilesAnswer: true,
    state: {
        files: null,
        failed: false
    },
    // EMPTY (the views contract, workspace functions/assistantAppViews.js): the
    // read answered with no item — the one sentence is all the view shows, and
    // a Fly page gives its card one row. null while reading.
    empty: (el, s)=>Array.isArray(s.files) ? s.files.length === 0 : null,
    onRender: (el)=>el.call('filesAnswerLoad', el),
    FilesAnswerSkeleton: {
        flow: 'y',
        gap: 'Y',
        ariaBusy: 'true',
        hide: (el, s)=>Array.isArray(s.files),
        Skeleton_1: {
            height: 'B',
            round: 'radiusControl'
        },
        Skeleton_2: {
            height: 'B',
            round: 'radiusControl'
        },
        Skeleton_3: {
            height: 'B',
            round: 'radiusControl',
            width: '60%'
        }
    },
    FilesAnswerNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!Array.isArray(s.files) || s.files.length > 0,
        text: (el, s)=>{
            s.root.lang;
            return el.call('polyglot', s.failed ? 'files.answer.failed' : 'files.answer.empty');
        }
    },
    FilesAnswerList: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        hide: (el, s)=>!Array.isArray(s.files) || !s.files.length,
        childExtends: 'HomeWidgetRow',
        childrenAs: 'state',
        children: (el, s)=>{
            s.root.lang;
            return el.call('filesAnswerRows', s.files);
        }
    }
};

});

parcelRegister("jGnr7", function(module, exports) {

$parcel$export(module.exports, "DocsBrowseColumn", () => $e5441e8ed4661b3a$export$8a4d92bcd8bf5cd9);
$parcel$export(module.exports, "DocsSidebar", () => $e5441e8ed4661b3a$export$8751c016a98a6ee);
$parcel$export(module.exports, "DocsSectionNav", () => $e5441e8ed4661b3a$export$4a44e8bf20fac92f);
$parcel$export(module.exports, "DocsSectionRow", () => $e5441e8ed4661b3a$export$9613741b5d35c689);
$parcel$export(module.exports, "DocsSubNav", () => $e5441e8ed4661b3a$export$14e88ff1b9aaad8d);
$parcel$export(module.exports, "DocsNotesFilterList", () => $e5441e8ed4661b3a$export$a7103a18e6c2873c);
$parcel$export(module.exports, "DocsNotesFilterRow", () => $e5441e8ed4661b3a$export$63b12fdecf0ad03a);
$parcel$export(module.exports, "DocsFolderList", () => $e5441e8ed4661b3a$export$70c33907be3b2177);
$parcel$export(module.exports, "DocsFolderRow", () => $e5441e8ed4661b3a$export$c707b150d6ff3f70);
$parcel$export(module.exports, "DocsNewFolderRow", () => $e5441e8ed4661b3a$export$576adffd189bf64d);
$parcel$export(module.exports, "DocsKbCategoryList", () => $e5441e8ed4661b3a$export$b4273f6b069f0b7d);
$parcel$export(module.exports, "DocsKbCategoryRow", () => $e5441e8ed4661b3a$export$84ad1e2dd937b41a);
// Notes SIDEBAR closure — extracted EAGER (DashboardRows-style) so the rest
// of the notes context (page bodies + fetch blocks + search utils) can defer
// out of the initial shell bundle via lazySharedLibPage.
//
// WHY this file exists (the carve-out): `DocsSidebar` is referenced OUTSIDE the
// package by three SHARED components that mount on canvas/editor/help
// routes BEFORE /notes is ever visited —
//   • shared/components/ProjectCodeSidebar.js  → extends: 'DocsSidebar'
//   • shared/components/TutorialsPanel.js       → bare-key DocsSidebar: {}
//   • shared/components/TutorialsPanelCopy.js    → bare-key DocsSidebar: {}
// Because those consumers string-extend / bare-key the WHOLE DocsSidebar tree,
// its entire dependency closure (section nav, sub-nav, filter/folder/kb lists +
// rows) must be registered eagerly too. They are moved here verbatim from
// Sidebar.js and re-exported by the component barrel, so:
//   1. sharedLibraries.js imports THIS module (only) to keep the closure eager, and
//   2. the lazy notes context (context.js → components/index.js) still sees
//      them via the barrel — the lazy merge is add-missing, so it no-ops on them.
// Nothing here imports back from a page module (that would re-pin the deferred
// page code into the initial bundle). DocsMobileSidebarBar + DocsMobileRail (the
// phone chrome) stay in Sidebar.js — they have no external consumers and load
// with the pages; only the browse column itself is shared between them.

var $96RcK = parcelRequire("96RcK");
// Slot-aware: stays inside the home PageSlot window when the surface is
// hosted there, routes normally otherwise (functions/notesNavigate.js —
// eager-registered so these EAGER rows can el.call it).
const $e5441e8ed4661b3a$var$_documentsNavigate = (el, path)=>el.call('notesNavigate', path);
const $e5441e8ed4661b3a$export$8a4d92bcd8bf5cd9 = {
    gap: 'X2',
    flow: 'y',
    padding: '0',
    // Sheet cards are only min(86vw, 340px) wide — long folder/category labels
    // must ellipsize inside the column, never widen it.
    minWidth: '0',
    SectionNav: {
        extends: 'DocsSectionNav',
        padding: 'X2'
    },
    // Borderless (design-direction.md §8) — the hairline divider between
    // sections is banned outright; the column's own `gap: 'X2'` already
    // separates SectionNav from DocsSubNav.
    DocsSubNav: {
        padding: 'X2'
    }
};
const $e5441e8ed4661b3a$export$8751c016a98a6ee = {
    extends: 'AppSidebar',
    tag: 'nav',
    'aria-label': (el)=>el.call('polyglot', 'documents.sidebar.navLabel'),
    // Drop the inherited VIEWS switcher — /notes is not a canvas view. Per Nika.
    ViewSwitcher: null,
    // PHONE: the desktop rail steps aside entirely and the browse column is
    // re-presented in the shared off-canvas sheet (DocsMobileRail — see
    // ./Sidebar.js), so the reading/editing surface owns the full phone
    // viewport and /notes answers to the ONE platform gesture (left-edge
    // pull opens; scrim tap, left-flick or Escape closes). CSS-gated, not a JS
    // `hide` factory, so a rotate/resize flips it with no state write — and the
    // off-package consumers of this tree (ProjectCodeSidebar, TutorialsPanel*)
    // keep exactly the phone behaviour they had, since the old `hide` gate also
    // resolved to "hidden" for them.
    '@mobileL': {
        display: 'none'
    },
    Top: null,
    // The section rows start at the card's top: on a page that opts in (each
    // notes page, not the Learn panel), the head band keeps the hide button off
    // the first row (AppSidebar's free corner). Inert anywhere else.
    Middle: {
        extends: 'DocsBrowseColumn',
        'data-sidebar-band': 'true'
    },
    // No PeopleSection on notes — the surface is about finding/editing
    // content, not browsing collaborators. Matches the tickets + meet
    // sidebars which also null this slot.
    PeopleSection: null
};
// ── Section switcher: Notes / Knowledge Base ──
// (The old three-way Documents/Notes/Knowledge Base split collapsed with the
// /documents → /notes rename: the main list IS notes — every non-KB doc type
// renders there — so a separate "Documents" section had nothing distinct left
// to show.)
const $e5441e8ed4661b3a$var$_sections = [
    {
        key: 'notes',
        label: 'documents.section.notes',
        icon: 'edit'
    },
    {
        key: 'knowledge-base',
        label: 'documents.section.knowledgeBase',
        icon: 'library'
    }
];
const $e5441e8ed4661b3a$export$4a44e8bf20fac92f = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsSectionRow',
    childrenAs: 'state',
    children: ()=>$e5441e8ed4661b3a$var$_sections
};
const $e5441e8ed4661b3a$export$9613741b5d35c689 = {
    extends: 'SidebarRow',
    // Active state via a conditional class — a reactive `background`/`color`
    // factory emits an INLINE node style that clobbers ':hover'. The .isActive
    // class keeps :hover alive (verified pattern from TicketsSidebarItem).
    isActive: (el, s)=>s.root.activeSection === s.key,
    // CODEX-M2 mobile targets — same 44px floor as DocsNotesFilterRow (see
    // its note; box growth, not tapSlop, because rows stack adjacently).
    '@coarse': {
        minHeight: 'controlH'
    },
    color: 'caption',
    fontWeight: '700',
    '.isActive': {
        background: 'selected',
        color: 'title'
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    'aria-current': (el, s)=>s.root.activeSection === s.key ? 'page' : undefined,
    // Picking a section dismisses the phone sheet — the chosen surface takes
    // the viewport immediately (same contract on every row below). Flush any
    // pending autosave FIRST (mirrors EditorHeader's BackBtn) — leaving the
    // editor via a section tap must not drop the last debounced keystrokes.
    onClick: async (e, el, s)=>{
        if (s.root.editorMode === 'edit') await el.call('flushNoteAutosave');
        s.root.update({
            activeSection: s.key,
            selectedDocument: null,
            editorDoc: null,
            editorMode: null,
            editorPreview: false,
            _docsRailOpen: false
        });
        $e5441e8ed4661b3a$var$_documentsNavigate(el, s.key === 'notes' ? '/notes' : '/notes/' + s.key);
    },
    Icon: {
        name: (el, s)=>s.icon || 'document'
    },
    Label: {
        text: (el, s)=>el.call('polyglot', s.label || s.key)
    },
    // Section nav doesn't need three-dot menu
    MoreBtn: null
};
const $e5441e8ed4661b3a$export$14e88ff1b9aaad8d = {
    flow: 'y',
    gap: 'V',
    NotesFilterList: {
        extends: 'DocsNotesFilterList',
        if: (el, s)=>s.root.activeSection !== 'knowledge-base'
    },
    // Borderless (design-direction.md §8) — dropped the hairline divider
    // between the filter list and the folder list; the parent's `gap: 'V'`
    // plus each list's own internal `gap` already read as two groups.
    FolderList: {
        extends: 'DocsFolderList',
        if: (el, s)=>s.root.activeSection !== 'knowledge-base'
    },
    // The folder list's own last row — part of the notes sub-nav that swaps
    // with the knowledge-base categories as a whole, the same gate as its
    // siblings.
    NewFolderRow: {
        extends: 'DocsNewFolderRow',
        if: (el, s)=>s.root.activeSection !== 'knowledge-base'
    },
    KbCategoryList: {
        extends: 'DocsKbCategoryList',
        if: (el, s)=>s.root.activeSection === 'knowledge-base'
    }
};
// ── Scope filters (All / Shared / Private / AI) ──
const $e5441e8ed4661b3a$var$_notesFilters = [
    {
        key: 'all',
        label: 'documents.filter.all',
        icon: 'edit'
    },
    {
        key: 'shared',
        label: 'documents.filter.shared',
        icon: 'people'
    },
    {
        key: 'private',
        label: 'documents.filter.private',
        icon: 'lock'
    },
    {
        key: 'ai',
        label: 'documents.filter.ai',
        icon: 'star'
    }
];
// Copy of Main.js's `_matchesFilter` (the eager sidebar carve-out must not
// import the lazy page-component module — see the header). shared/private is
// the files-style privacy scope; legacy rows predate both fields and count
// as shared member notes.
const $e5441e8ed4661b3a$var$_matchesFilter = (row, key)=>{
    if (key === 'ai') return row.source === 'ai';
    if (key === 'private') return row.privacy === 'private';
    if (key === 'shared') return row.privacy !== 'private';
    return true;
};
// NOTES-MICRO-1 item 1 (tickets/sonnet.md) — "note-count/list instability":
// sidebar badge shows a DIFFERENT number than the grid it sits next to on
// the SAME `/notes` view. Root-caused by static tracing (Chrome MCP was
// unavailable this session — see the ticket): `pages/notes.js`'s `NotesMain`
// (a separately-fetched `s.root.notes` array, `type==='note'` only) is NOT
// wired into the shell's route table at all (workspace/packages/workspace/
// pages/index.js — only `pages/index.js`'s `home` → `DocsMain` serves
// `/notes`), so the two-independent-fetches race that hypothesis predicted
// doesn't reach the LIVE grid. The REAL, code-provable divergence: this
// file's `DocsNotesFilterRow.Count` / `DocsFolderRow.Count` counted against
// `s.root.documents` with ONLY the scope filter applied, while
// `Main.js`'s `_filtered` (what the grid actually RENDERS) ALSO narrows by
// `selectedFolder` and `docsQuery` — two root-state values that persist
// across navigation and aren't reset on route change. Whenever either is
// non-default (a folder scoped, or a search term still sitting in the box
// from an earlier visit), the badge showed the GRAND total while the grid
// showed a folder/query-narrowed subset — no network race required, and
// "eventually consistent" once the user cleared the folder/query (e.g. by
// tapping "All notes", which explicitly resets `selectedFolder`). Fix: apply
// the EXACT SAME three-filter pipeline (folder + scope + query) the grid
// uses, so the sidebar number can never disagree with what's on screen. A
// residual, NOT live-confirmed candidate if a mismatch is still observed
// with folder=all/query=empty: the two independent `cache: '30s'` SDK fetches
// (functions/index.js `documentsFetch`/`notesFetch`) don't key their cache by
// workspace/org, so a same-session workspace switch could serve one of them
// a stale cross-workspace snapshot for up to 30s — needs live network-timing
// capture to confirm, left as the next step if this fix doesn't fully close
// the ticket.
const $e5441e8ed4661b3a$var$_documentsMatchesQuery = (row, q)=>(row.title || '').toLowerCase().includes(q) || (row.summary || '').toLowerCase().includes(q) || (row.author || '').toLowerCase().includes(q) || (row._bodyText || '').toLowerCase().includes(q) || (row.tags || []).some((t)=>String(t).toLowerCase().includes(q));
// Shared "current view" doc set for the notes sidebar counts — folder +
// query narrowing, WITHOUT the scope filter (each row applies its own scope
// on top, so "All notes"/"Shared"/"Private"/"AI notes" can each show their
// own count within the same folder/search view).
const $e5441e8ed4661b3a$var$_notesScopedDocs = (s)=>{
    const root = s.root;
    const folder = root.selectedFolder || 'all';
    const q = (root.docsQuery || '').toLowerCase().trim();
    let docs = root.documents || [];
    if (folder !== 'all') docs = docs.filter((d)=>d.folder === folder);
    if (q) docs = docs.filter((d)=>$e5441e8ed4661b3a$var$_documentsMatchesQuery(d, q));
    return docs;
};
// Same idea for the FOLDER rows — scope (notesFilter) + query narrowing,
// WITHOUT the folder filter (each row applies its own folder on top, so
// every folder can show its own count within the same scope/search view).
const $e5441e8ed4661b3a$var$_notesScopeFilteredDocs = (s)=>{
    const root = s.root;
    const scopeFilter = root.notesFilter || 'all';
    const q = (root.docsQuery || '').toLowerCase().trim();
    let docs = root.documents || [];
    if (scopeFilter !== 'all') docs = docs.filter((d)=>$e5441e8ed4661b3a$var$_matchesFilter(d, scopeFilter));
    if (q) docs = docs.filter((d)=>$e5441e8ed4661b3a$var$_documentsMatchesQuery(d, q));
    return docs;
};
const $e5441e8ed4661b3a$export$a7103a18e6c2873c = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsNotesFilterRow',
    childrenAs: 'state',
    children: ()=>$e5441e8ed4661b3a$var$_notesFilters
};
const $e5441e8ed4661b3a$export$63b12fdecf0ad03a = {
    extends: 'SidebarRow',
    isActive: (el, s)=>(s.root.notesFilter || 'all') === s.key,
    // CODEX-M2 mobile targets: SidebarRow's height is emergent from padding
    // (~42-44px, borderline vs the 44px floor). Guarantee the floor on touch
    // by growing the row's OWN box — NOT the tapSlop ::after overlay, which
    // is for isolated chips; negative-inset slop on adjacent stacked rows
    // would overlap neighbours and mis-target taps.
    '@coarse': {
        minHeight: 'controlH'
    },
    color: 'caption',
    '.isActive': {
        background: 'selected',
        color: 'title'
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    'aria-current': (el, s)=>(s.root.notesFilter || 'all') === s.key ? 'page' : undefined,
    // NOTES-MICRO-1 item 2 ("All notes is a no-op from inside a note") — this
    // row is also mounted on the /notes/editor ROUTE (DocsSidebar renders
    // there too, see pages/editor.js), and that route only reads
    // editorDoc/editorMode, never notesFilter/selectedFolder. Clicking it
    // while a note is open used to just write filter state the current route
    // never looks at, so nothing visibly happened. Exit the editor (flushing
    // any pending autosave first, mirroring BackBtn) and navigate back to the
    // list whenever this fires from inside one.
    onClick: async (e, el, s)=>{
        const inEditor = !!(s.root.editorDoc || s.root.editorMode);
        if (s.root.editorMode === 'edit') await el.call('flushNoteAutosave');
        const patch = {
            notesFilter: s.key,
            selectedNoteId: null,
            _docsRailOpen: false
        };
        // "All notes" is the reset row — it clears the folder scope too, so one
        // tap always gets back to the unfiltered list.
        if (s.key === 'all') patch.selectedFolder = 'all';
        if (inEditor) {
            patch.editorDoc = null;
            patch.editorMode = null;
            patch.activeSection = 'notes';
        }
        s.root.update(patch);
        if (inEditor) $e5441e8ed4661b3a$var$_documentsNavigate(el, '/notes');
    },
    // A note card dropped on Shared or Private takes that privacy (2026-10-27
    // per Nika "support to drag and drop notes to sidebar channels"). All notes
    // and AI notes name nothing a person sets, so they take no drop, and nor
    // does the row a note already belongs to. DocsCard marks the drag on the
    // root (`_notesDragId`); the row under it lights through `_notesDropKey`.
    // A drop on Private asks first, the same as the card menu's Make private
    // (functions/noteMenus.js confirmNotePrivacy).
    dataDropTarget: (el, s)=>s.root._notesDropKey === 'scope:' + s.key,
    '&[data-drop-target]': {
        background: 'selected',
        color: 'title',
        outlineWidth: 'hairline2',
        outlineStyle: 'dashed',
        outlineColor: 'title',
        outlineOffset: '0'
    },
    onDragover: (e, el, s)=>{
        const id = s.root._notesDragId;
        if (!id || s.key !== 'shared' && s.key !== 'private') return;
        const note = (s.root.documents || []).find((d)=>d.id === id);
        if (!note || note.privacy === 'private' === (s.key === 'private')) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
        const key = 'scope:' + s.key;
        if (s.root._notesDropKey !== key) s.root.update({
            _notesDropKey: key
        }, {
            preventFetch: true
        });
    },
    onDragleave: (e, el, s)=>{
        // Moving across the row's own icon and label is not leaving it.
        if (el.node && e.relatedTarget && el.node.contains(e.relatedTarget)) return;
        if (s.root._notesDropKey === 'scope:' + s.key) s.root.update({
            _notesDropKey: null
        }, {
            preventFetch: true
        });
    },
    onDrop: (e, el, s)=>{
        const id = s.root._notesDragId;
        if (!id || s.key !== 'shared' && s.key !== 'private') return;
        e.preventDefault();
        s.root.update({
            _notesDragId: null,
            _notesDropKey: null
        }, {
            preventFetch: true
        });
        el.call('confirmNotePrivacy', id, s.key === 'private' ? 'private' : 'team');
    },
    Icon: {
        name: (el, s)=>s.icon || 'edit'
    },
    Label: {
        text: (el, s)=>el.call('polyglot', s.label || s.key)
    },
    Count: {
        tag: 'span',
        // The label's size and the house count weight — the Tasks sidebar's
        // counts (13.3px / 500, measured). It was `Y2`, 11px.
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'caption',
        // NOTES-MICRO-1 item 1 — folder + query narrowed (see the header note
        // above `_notesScopedDocs`), same as the grid it sits beside.
        text: (el, s)=>{
            const docs = $e5441e8ed4661b3a$var$_notesScopedDocs(s);
            return String(docs.filter((n)=>$e5441e8ed4661b3a$var$_matchesFilter(n, s.key)).length);
        }
    },
    MoreBtn: null
};
// ── Folders ──
// The default taxonomy UNION whatever folders the data actually carries — a
// rename writes new folderPath values, and those must keep a row. (The "all"
// pseudo-folder duplicates the "All notes" filter row above.) A folder of the
// person's own making is `custom` (its row offers Delete, not Unfile —
// functions/noteMenus.js notesFolderMenu). The open folder keeps a row while
// it holds no note yet: a folder is the path its notes carry and the server
// keeps no folder record, so one just made with New folder (DocsNewFolderRow)
// exists only as the open folder until a note goes into it.
const $e5441e8ed4661b3a$var$_notesFolderRows = (root)=>{
    const base = (0, $96RcK.DOC_FOLDERS).filter((f)=>f.key !== 'all');
    const known = new Set(base.map((f)=>f.key));
    const extras = [];
    const add = (key)=>{
        if (!key || key === 'all' || known.has(key)) return;
        known.add(key);
        extras.push({
            key: key,
            label: key,
            icon: 'folder',
            custom: true
        });
    };
    for (const d of root.documents || [])add(d.folder);
    add(root.selectedFolder);
    return [
        ...base,
        ...extras
    ];
};
// Open a folder's list ('all' = every note) from wherever the sidebar is. The
// /notes/editor route reads editorDoc/editorMode, never selectedFolder, so from
// inside a note it leaves the note first (flushing a pending autosave, as
// BackBtn does) and returns to the list. DocsFolderRow and DocsNewFolderRow
// share it.
const $e5441e8ed4661b3a$var$_openNotesFolder = async (el, root, key)=>{
    const inEditor = !!(root.editorDoc || root.editorMode);
    if (root.editorMode === 'edit') await el.call('flushNoteAutosave');
    const patch = {
        selectedFolder: key,
        selectedDocument: null,
        _docsRailOpen: false
    };
    if (inEditor) {
        patch.editorDoc = null;
        patch.editorMode = null;
        patch.activeSection = 'notes';
    }
    root.update(patch);
    if (inEditor) $e5441e8ed4661b3a$var$_documentsNavigate(el, '/notes');
};
const $e5441e8ed4661b3a$export$70c33907be3b2177 = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsFolderRow',
    childrenAs: 'state',
    children: (el, s)=>$e5441e8ed4661b3a$var$_notesFolderRows(s.root)
};
const $e5441e8ed4661b3a$export$c707b150d6ff3f70 = {
    extends: 'SidebarRow',
    isActive: (el, s)=>s.root.selectedFolder === s.key,
    // CODEX-M2 mobile targets — same 44px floor as DocsNotesFilterRow (see
    // its note; box growth, not tapSlop, because rows stack adjacently).
    '@coarse': {
        minHeight: 'controlH'
    },
    color: 'caption',
    '.isActive': {
        background: 'selected',
        color: 'title'
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    'aria-current': (el, s)=>s.root.selectedFolder === s.key ? 'page' : undefined,
    // Same root cause + fix as DocsNotesFilterRow above — this row is also
    // mounted on the /notes/editor route and used to no-op from inside a note.
    onClick: (e, el, s)=>{
        if (s.root._renamingFolder === s.key) return;
        // Second tap on the active folder clears the scope back to all.
        return $e5441e8ed4661b3a$var$_openNotesFolder(el, s.root, s.root.selectedFolder === s.key ? 'all' : s.key);
    },
    // Right-click: Rename folder, then Delete folder (one of the person's own)
    // or Unfile its notes (a built-in one) — functions/noteMenus.js.
    // onContextmenu doesn't bind via DOMQL delegation — native listener.
    onCreate: (el, s)=>{
        if (el._cmBound || !el.node) return;
        el._cmBound = true;
        el.node.addEventListener('contextmenu', (e)=>{
            const row = el.state || s;
            el.call('notesFolderMenu', e, row.key, {
                custom: !!row.custom,
                label: row.label
            });
        });
    },
    // A note card dropped here moves into this folder (2026-10-27 per Nika
    // "support to drag and drop notes to sidebar channels") — the same write a
    // folder rename makes per note (functions/noteMenus.js moveNoteToFolder).
    // Same contract as DocsNotesFilterRow's drop: the folder a note is already
    // in takes no drop, and the row under the card lights.
    dataDropTarget: (el, s)=>s.root._notesDropKey === 'folder:' + s.key,
    '&[data-drop-target]': {
        background: 'selected',
        color: 'title',
        outlineWidth: 'hairline2',
        outlineStyle: 'dashed',
        outlineColor: 'title',
        outlineOffset: '0'
    },
    onDragover: (e, el, s)=>{
        const id = s.root._notesDragId;
        if (!id) return;
        const note = (s.root.documents || []).find((d)=>d.id === id);
        if (!note || note.folder === s.key) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
        const key = 'folder:' + s.key;
        if (s.root._notesDropKey !== key) s.root.update({
            _notesDropKey: key
        }, {
            preventFetch: true
        });
    },
    onDragleave: (e, el, s)=>{
        // Moving across the row's own icon and label is not leaving it.
        if (el.node && e.relatedTarget && el.node.contains(e.relatedTarget)) return;
        if (s.root._notesDropKey === 'folder:' + s.key) s.root.update({
            _notesDropKey: null
        }, {
            preventFetch: true
        });
    },
    onDrop: (e, el, s)=>{
        const id = s.root._notesDragId;
        if (!id) return;
        e.preventDefault();
        s.root.update({
            _notesDragId: null,
            _notesDropKey: null
        }, {
            preventFetch: true
        });
        el.call('moveNoteToFolder', id, s.key);
    },
    Icon: {
        name: (el, s)=>s.icon || 'document'
    },
    Label: {
        if: (el, s)=>s.root._renamingFolder !== s.key,
        text: (el, s)=>el.call('polyglot', s.label || s.key)
    },
    // Inline rename input — swapped in for the label while this folder is the
    // rename target. Enter commits (bulk folderPath move via
    // renameNotesFolder), Escape/blur cancels.
    RenameInput: {
        tag: 'input',
        type: 'text',
        if: (el, s)=>s.root._renamingFolder === s.key,
        flex: '1',
        minWidth: '0',
        padding: '0 Y',
        fontSize: 'Z2',
        color: 'title',
        background: 'transparent',
        borderWidth: '0',
        outline: 'none',
        onCreate: (el, s)=>{
            if (!el.node) return;
            el.node.value = el.call('polyglot', s.label || s.key);
            el.node.focus();
            el.node.select();
        },
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: (e, el, s)=>{
            if (e.key === 'Enter') {
                const next = (e.target.value || '').trim();
                if (next && next !== s.key) el.call('renameNotesFolder', s.key, next, s.label);
                else s.root.update({
                    _renamingFolder: null
                });
            }
            if (e.key === 'Escape') s.root.update({
                _renamingFolder: null
            });
        },
        onBlur: (e, el, s)=>{
            if (s.root._renamingFolder === s.key) s.root.update({
                _renamingFolder: null
            });
        }
    },
    Count: {
        tag: 'span',
        // The label's size and the house count weight (see DocsNotesFilterRow).
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'caption',
        // NOTES-MICRO-1 item 1 — scope + query narrowed (see
        // `_notesScopeFilteredDocs`'s header note above), same as the grid.
        text: (el, s)=>{
            const docs = $e5441e8ed4661b3a$var$_notesScopeFilteredDocs(s);
            return String(docs.filter((d)=>d.folder === s.key).length);
        }
    },
    MoreBtn: null
};
const $e5441e8ed4661b3a$export$576adffd189bf64d = {
    extends: 'SidebarRow',
    icon: 'plus',
    color: 'caption',
    // CODEX-M2 mobile targets — the same 44px floor as DocsFolderRow.
    '@coarse': {
        minHeight: 'controlH'
    },
    onClick: (e, el, s)=>{
        const root = s.root;
        el.call('promptDialog', {
            title: el.call('polyglot', 'documents.folderNew.label'),
            message: el.call('polyglot', 'documents.folderNew.message'),
            placeholder: el.call('polyglot', 'documents.folderNew.placeholder'),
            confirmText: el.call('polyglot', 'common.action.create'),
            cancelText: el.call('polyglot', 'common.action.cancel'),
            onConfirm: (value)=>{
                const name = String(value || '').replace(/\s+/g, ' ').trim();
                if (!name) return;
                const lower = name.toLowerCase();
                const same = [
                    ...(0, $96RcK.DOC_FOLDERS),
                    ...$e5441e8ed4661b3a$var$_notesFolderRows(root)
                ].find((f)=>f.key.toLowerCase() === lower || String(el.call('polyglot', f.label || f.key)).toLowerCase() === lower);
                return $e5441e8ed4661b3a$var$_openNotesFolder(el, root, same ? same.key : name);
            }
        });
    },
    Label: {
        text: (el)=>el.call('polyglot', 'documents.folderNew.label')
    },
    MoreBtn: null
};
const $e5441e8ed4661b3a$export$b4273f6b069f0b7d = {
    flow: 'y',
    gap: 'V',
    childExtends: 'DocsKbCategoryRow',
    childrenAs: 'state',
    children: (el, s)=>(0, $96RcK.KB_CATEGORIES)
};
const $e5441e8ed4661b3a$export$84ad1e2dd937b41a = {
    extends: 'SidebarRow',
    isActive: (el, s)=>s.root.selectedCategory === s.key,
    color: 'caption',
    '.isActive': {
        background: 'selected',
        color: 'title'
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    'aria-current': (el, s)=>s.root.selectedCategory === s.key ? 'page' : undefined,
    onClick: (e, el, s)=>{
        s.root.update({
            selectedCategory: s.key,
            _docsRailOpen: false
        });
    },
    Icon: {
        name: (el, s)=>s.icon || 'book'
    },
    Label: {
        text: (el, s)=>el.call('polyglot', s.label || s.key)
    },
    Count: {
        tag: 'span',
        // The label's size and the house count weight (see DocsNotesFilterRow).
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'caption',
        text: (el, s)=>{
            const all = s.root.kbArticles || [];
            if (s.key === 'all') return String(all.length);
            return String(all.filter((a)=>a.category === s.key).length);
        }
    },
    MoreBtn: null
};

});

parcelRegister("g9flU", function(module, exports) {

$parcel$export(module.exports, "createNote", () => $bc196541d16a6796$export$4640c0d5ffcf906e);
// Insert a row into the notes collection. Reused by the header's "+ New
// note"/import actions, chat's "save as note" and meet's applySuggestion so
// the same code path serves every producer.
//
// Returns the new row's id on success, null on failure.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $hml1G = parcelRequire("hml1G");
const $bc196541d16a6796$export$4640c0d5ffcf906e = async function({ title: title = 'Untitled note', content: content = '', tags: tags = [], source: source = 'member', privacy: privacy, folderPath: folderPath } = {}) {
    const root = this.state.root;
    const row = {
        title: title,
        body: content,
        author: root.currentUserEmail || 'Unknown',
        source: source,
        tags: tags,
        ...privacy ? {
            privacy: privacy
        } : {},
        ...folderPath ? {
            folderPath: folderPath
        } : {}
    };
    let data;
    try {
        const result = await (0, $1NxyO.getSDK)().execute('docs.notes', 'create', row);
        data = result?.data || result;
    } catch (err) {
        console.error('[createNote] insert failed', err);
        return null;
    }
    const id = data?.docId || data?._id || data?.id;
    if (!id) return null;
    // Optimistic state merge so the new note appears immediately — in BOTH
    // stores: `documents` feeds the unified /notes grid, `notes` feeds the
    // chat/AI note pickers.
    const parsed = (0, $hml1G._docContent)(content);
    const nowDay = new Date().toISOString().slice(0, 10);
    const docRow = {
        id: id,
        title: title,
        folder: folderPath || '',
        type: 'note',
        source: source,
        privacy: privacy || 'team',
        tags: tags,
        author: row.author,
        summary: '',
        _bodyText: (0, $hml1G._joinBodyText)(parsed),
        _cover: (0, $hml1G._firstImage)(parsed),
        content: parsed,
        updatedAt: new Date().toISOString()
    };
    root.update({
        documents: [
            ...root.documents || [],
            docRow
        ],
        notes: [
            ...root.notes || [],
            {
                id: id,
                title: title,
                content: parsed,
                author: row.author,
                source: source,
                tags: tags,
                createdAt: nowDay
            }
        ],
        selectedNoteId: id
    });
    this.call('forgetDocLists');
    return id;
};

});

parcelRegister("lXOgQ", function(module, exports) {

$parcel$export(module.exports, "resolveKbArticleInput", () => $ffd61a591505e474$export$4c51a81e52f05b1d);
$parcel$export(module.exports, "createKnowledgeArticle", () => $ffd61a591505e474$export$2877207fb722d716);
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $ffd61a591505e474$export$4c51a81e52f05b1d = (opts)=>{
    const input = opts || {};
    const title = input.title === undefined ? 'Untitled article' : input.title;
    const content = typeof input.content === 'string' ? input.content : '';
    return {
        title: title,
        content: content
    };
};
const $ffd61a591505e474$export$2877207fb722d716 = async function(opts) {
    const resolved = $ffd61a591505e474$export$4c51a81e52f05b1d(opts);
    const title = resolved.title;
    const content = resolved.content;
    const root = this.state.root;
    const row = {
        title: title,
        body: content,
        author: root.currentUserEmail || 'Unknown'
    };
    let data;
    try {
        const result = await (0, $1NxyO.getSDK)().execute('docs.kbArticles', 'create', row);
        data = result?.data || result;
    } catch (err) {
        console.error('[createKnowledgeArticle] insert failed', err);
        return null;
    }
    const id = data?.docId || data?._id || data?.id;
    if (!id) return null;
    root.update({
        kbArticles: [
            ...root.kbArticles || [],
            {
                id: id,
                title: title,
                content: content,
                author: row.author,
                createdAt: new Date().toISOString().slice(0, 10)
            }
        ],
        selectedKbArticleId: id
    });
    this.call('forgetDocLists');
    return id;
};

});

parcelRegister("7ZbKd", function(module, exports) {

$parcel$export(module.exports, "saveKbArticle", () => $01801e4ef62c72a2$export$6fb3abb2b7cb3f5);
// Insert or update a knowledge-base article. Used by meet's applySuggestion
// when the transcript extraction routes to the `knowledge_base` bucket.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $hml1G = parcelRequire("hml1G");
const $01801e4ef62c72a2$export$6fb3abb2b7cb3f5 = async function({ id: id = null, title: title = 'Untitled article', category: category = 'general', summary: summary = '', content: content = '' } = {}) {
    const root = this.state.root;
    const row = {
        title: title,
        folderPath: 'knowledge-base',
        type: 'doc',
        author: root.currentUserEmail || 'Unknown',
        summary: summary || '',
        body: typeof content === 'string' ? content : ''
    };
    let data = null;
    try {
        data = id != null ? // Passing (id, row) as positional args #3/#4 makes args=id and loses row entirely.
        await (0, $1NxyO.getSDK)().execute('docs', 'update', {
            id: id,
            payload: row
        }) : await (0, $1NxyO.getSDK)().execute('docs', 'create', row);
    } catch (err) {
        console.error('[saveKbArticle] write failed', err?.message || err);
        return null;
    }
    const newId = data?.docId || data?._id || data?.id;
    if (!newId) {
        console.error('[saveKbArticle] write returned no id');
        return null;
    }
    const existing = root.documents || [];
    // Frozen content + write-time `_bodyText` — same row shape as the
    // documentsFetch transform, so the DocsGrid card stays identity-stable
    // and its Summary factories stay O(1) (see functions/rowIdentity.js).
    const mergedContent = (0, $hml1G._docContent)(data.body || data.content || row.body);
    const merged = {
        id: newId,
        title: data.title || title,
        folder: data.folderPath || data.folder || 'knowledge-base',
        type: data.type || 'doc',
        author: data.author || '',
        updatedAt: new Date().toISOString().slice(0, 10),
        summary: data.summary || summary,
        _bodyText: (0, $hml1G._joinBodyText)(mergedContent),
        content: mergedContent
    };
    const next = existing.some((r)=>r.id === newId) ? existing.map((r)=>r.id === newId ? merged : r) : [
        merged,
        ...existing
    ];
    root.update({
        documents: next
    });
    this.call('forgetDocLists');
    return newId;
};

});

parcelRegister("ibNsv", function(module, exports) {

$parcel$export(module.exports, "notesNavigate", () => $d3df9e8a31627984$export$e8caa7ee3fdd2941);
// Slot-aware navigation for the notes surface (2026-08-06 per Nika: "if its
// open in pageslot - it should keep it, otherwise link to page").
//
// The notes UI mounts in TWO hosts: as the real /notes route, and inside the
// home PageSlot window (root._canvasSlot). Every internal navigation (cards,
// section rows, + New note, back, context-menu open/edit) previously did a
// full router navigation, which tore the user OUT of the window. This one
// registered function is the single navigation path for the whole surface:
//   - slot-hosted → update `_canvasSlot` (the PageSlot re-mounts by
//     pathname) and put any #hash on the REAL URL (the editor's hash
//     restore reads window.location.hash — same mechanism the home
//     DocumentsWidget tiles already use)
//   - route-hosted → the normal MWT router navigation
//
// Slot detection is state-based, not structural: the slot shows a notes
// path while the real route is somewhere else (home). No coupling to
// PageSlot internals, and it works from the EAGER sidebar rows too.

var $9juhh = parcelRequire("9juhh");
const $d3df9e8a31627984$var$_isNotesPath = (p)=>p === '/notes' || p.startsWith('/notes/') || p === '/documents' || p.startsWith('/documents/') || p === '/docs';
const $d3df9e8a31627984$export$e8caa7ee3fdd2941 = function(path, opts) {
    const el = this;
    const root = el.state?.root;
    if (!root) return;
    const [base, hash] = String(path || '/notes').split('#');
    const slot = String(root._canvasSlot || '').split('?')[0];
    const realPath = (0, $9juhh.stripWorkspacePrefix)(root.currentPath ?? (typeof window !== 'undefined' ? window.location.pathname : '/'));
    const inSlot = !!(opts && opts.slot) || $d3df9e8a31627984$var$_isNotesPath(slot) && !$d3df9e8a31627984$var$_isNotesPath(realPath);
    if (inSlot) {
        if (typeof window !== 'undefined') {
            const url = new URL(window.location.href);
            url.hash = hash || '';
            window.history.replaceState(null, '', url.toString());
        }
        root.update({
            _canvasSlot: base
        });
        return;
    }
    let rootEl = el;
    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
    const router = el.context?.utils?.router;
    const replace = !!(opts && opts.replace);
    if (router && rootEl) router(path, rootEl, {}, {
        pushState: true,
        replace: replace,
        scrollToTop: true
    });
};

});

parcelRegister("7drYW", function(module, exports) {

$parcel$export(module.exports, "forgetDocLists", () => $540f73eb502e4d9f$export$9a89415617261a18);
// After a write to the docs domain, forget the cached note lists.
//
// The list queries — documentsFetch / notesFetch / kbArticlesFetch (index.js),
// the home Documents tile and the files desktop's docs — keep their answer for
// 30 s (the KB list 1 m) and hand it to every page that mounts in that window,
// which writes those rows back into the root stores. So a write that patched
// the stores in place was undone by the next mount: the note deleted in the
// editor stood on the list the editor returned to, and a card dropped on a
// folder went back to its old folder, until a reload (measured on dev
// 2026-10-27: back within 3 s of the write).
//
// Removing the entries makes the next mount ask the server; until that answer
// lands, the stores show the rows the write patched. Removal, not
// invalidation: an invalidation also refetches every mounted list at once, and
// the editor's autosave writes every few seconds.
//
// Cache keys start with the query's `from` — `docs:…`, `docs.notes:…`,
// `docs.kbArticles:…` (@symbo.ls/fetch queryCacheKey). `removeQueries` is the
// fetch plugin's registered function; with no fetch plugin there is no cache,
// and `call` returns nothing.
const $540f73eb502e4d9f$export$9a89415617261a18 = function() {
    this.call('removeQueries', /^docs[.:]/);
};

});

parcelRegister("2SNiS", function(module, exports) {

$parcel$export(module.exports, "documentsAiViews", () => $2196de8f1ff01a30$export$d97be2f53bd2a647);
$parcel$export(module.exports, "noteAnswerLoad", () => $2196de8f1ff01a30$export$dd3e9a6ce434dad1);
$parcel$export(module.exports, "noteAnswerModel", () => $2196de8f1ff01a30$export$22df3f13954d0901);
// A NOTE IN AN AI ANSWER — the `note-view` view the assistant mounts in its
// thread and a Fly page places as a section (workspace functions/
// assistantAppViews.js, the `views[]` contract).
//
// documentsAiViews() is the PROVIDER, read from the shell's eager documents
// slice; the view's component rides the lazy documents context (`fold:
// 'documents'` — the shell folds it through ensureDocumentsContext before a
// card mounts). One view, in the shell's list frame (workspace components/
// AssistantViewList.js):
//
//   note-view   one note or knowledge-base article, read-only: its title row
//               (author · updated; it opens the note in Notes) over its words
//               (the shared markdown renderer). `note` = words in the title
//               (the body when no title matches), empty = the newest;
//               `space` = notes, the knowledge base, or both.
//
// The reads are the Notes pages' own (`docs`, `docs.kbArticles`, list — SDK
// only), into the view's OWN state — never root.documents / root.kbArticles.
// Nothing here writes.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $2196de8f1ff01a30$export$d97be2f53bd2a647() {
    return {
        app: {
            id: 'system/documents',
            navbar: [
                {
                    label: 'shell.app.notes',
                    route: '/notes',
                    icon: 'document'
                }
            ],
            apps: [
                {
                    icon: 'document'
                }
            ]
        },
        fold: 'documents',
        views: [
            {
                id: 'note-view',
                title: 'documents.answer.title',
                describe: 'One note or knowledge-base article, read-only, with its words; note = words in its title (empty = the newest); space = notes, the knowledge base, or both.',
                component: 'NoteAnswerView',
                icon: 'document',
                hue: 'documents',
                size: 'l',
                params: {
                    note: {
                        type: 'string',
                        describe: 'words in the note or article title; empty = the newest'
                    },
                    space: {
                        type: 'enum',
                        values: [
                            'all',
                            'notes',
                            'kb'
                        ],
                        labels: {
                            all: 'documents.answer.space.all',
                            notes: 'documents.answer.space.notes',
                            kb: 'documents.answer.space.kb'
                        },
                        default: 'all'
                    }
                },
                link: {
                    route: '/notes',
                    query: {}
                },
                access: {
                    route: '/notes'
                }
            }
        ]
    };
}
async function $2196de8f1ff01a30$export$dd3e9a6ce434dad1(el, params) {
    const host = el || this;
    const p = params && typeof params === 'object' ? params : {};
    const sdk = host && host.sdk || host.call('getSDK');
    if (!sdk || typeof sdk.execute !== 'function') return {
        data: {
            doc: null,
            matches: 0
        },
        failed: true
    };
    const space = p.space === 'notes' || p.space === 'kb' ? p.space : 'all';
    const rowsOf = (res)=>Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
    let failed = false;
    const [docsRes, kbRes] = await Promise.all([
        space === 'kb' ? [] : Promise.resolve().then(()=>sdk.execute('docs', 'list', {})).catch(()=>{
            failed = true;
            return [];
        }),
        space === 'notes' ? [] : Promise.resolve().then(()=>sdk.execute('docs.kbArticles', 'list', {})).catch(()=>{
            if (space === 'kb') failed = true;
            return [];
        })
    ]);
    const shape = (r, kind)=>({
            id: String(r.docId || r._id || r.id || ''),
            kind: kind,
            title: r.title || '',
            author: r.author || '',
            at: Date.parse(r.updatedAt || r.createdAt || '') || 0,
            content: host.call('_parseBody', r.body || r.content)
        });
    // The /notes grid's own rule: KB articles live in their own store, a doc
    // moved to the files desktop lives there.
    const notes = rowsOf(docsRes).filter((r)=>r && r.type !== 'kb_article' && !(r.metadata && r.metadata.movedToFiles)).map((r)=>shape(r, 'note'));
    const articles = rowsOf(kbRes).filter(Boolean).map((r)=>shape(r, 'kb'));
    const all = notes.concat(articles).filter((x)=>x.id);
    const ask = String(p.note || '').trim().toLowerCase();
    const words = ask.split(/\s+/).filter(Boolean);
    const textOf = (x)=>typeof x.content === 'string' ? x.content : String(host.call('_joinBodyText', x.content) || '');
    const score = (x)=>{
        const title = x.title.toLowerCase();
        if (title && title === ask) return 3;
        if (words.every((w)=>title.includes(w))) return 2;
        const body = textOf(x).toLowerCase();
        return words.every((w)=>body.includes(w)) ? 1 : 0;
    };
    const ranked = words.length ? all.map((x)=>({
            x: x,
            s: score(x)
        })).filter((r)=>r.s > 0).sort((a, b)=>b.s - a.s || b.x.at - a.x.at).map((r)=>r.x) : all.slice().sort((a, b)=>b.at - a.at);
    const doc = ranked[0] || null;
    return {
        data: {
            doc: doc,
            matches: ranked.length
        },
        failed: failed && !all.length
    };
}
function $2196de8f1ff01a30$export$22df3f13954d0901(data, params, failed) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const say = (key)=>String(el.call('polyglot', key));
    const doc = d.doc;
    if (!doc) return {
        groups: [],
        note: failed ? 'documents.answer.failed' : 'documents.answer.empty'
    };
    let body = '';
    if (typeof doc.content === 'string') body = doc.content;
    else if (doc.content && typeof doc.content === 'object') {
        try {
            body = String(el.call('_toMarkdown', doc.content) || '');
        } catch (_) {
            body = '';
        }
        if (!body) body = String(el.call('_joinBodyText', doc.content) || '');
    }
    const people = el.call('peopleByEmail', root) || {};
    const author = doc.author ? people[doc.author] && people[doc.author].name || doc.author : '';
    const updated = doc.at ? String(el.call('localizedDate', new Date(doc.at), {
        month: 'short',
        day: 'numeric'
    }) || '') : '';
    const kb = doc.kind === 'kb';
    const row = el.call('assistantViewRow', {
        key: 'd-' + String(doc.id).replace(/[^a-zA-Z0-9_-]/g, ''),
        title: doc.title || say(kb ? 'documents.kb.untitledArticle' : 'documents.notes.untitled'),
        meta: [
            kb ? say('documents.answer.space.kb') : author,
            updated
        ].filter(Boolean).join(" \xb7 "),
        icon: 'document',
        open: {
            call: 'openAppPage',
            arg: (kb ? '/notes/knowledge-base?id=' : '/notes?id=') + encodeURIComponent(doc.id)
        }
    });
    return {
        groups: [
            el.call('assistantViewGroup', {
                key: 'note',
                rows: [
                    row
                ]
            })
        ],
        body: body.trim(),
        note: body.trim() ? '' : 'documents.notes.emptyBody',
        more: Number(d.matches) > 1 ? {
            shown: 1,
            total: Number(d.matches)
        } : null
    };
}

});

parcelRegister("6GdlH", function(module, exports) {

$parcel$export(module.exports, "CalEventDetailModal", () => (parcelRequire("2SPvI")).CalEventDetailModal);
$parcel$export(module.exports, "CalInviteeRow", () => (parcelRequire("2SPvI")).CalInviteeRow);
$parcel$export(module.exports, "CalRsvpButton", () => (parcelRequire("2SPvI")).CalRsvpButton);
// Eager slim slice of the calendar component barrel (#16 calendar slim).
//
// The full `./index.js` barrel `export *`s all 11 calendar component files
// (~200KB — the whole week/month/team/team-now/mini-calendar/sidebar/main/
// quick-create UI tree plus the three modals). The unified shell used to drag
// ALL of it into its EAGER chunk by folding the calendar context via
// `sharedLibraries.js` (`import calendar from '@symbo-ls/workspace-calendar'` →
// smbls's mergeSharedLibraries folds the full components+functions+state into
// the boot root context).
//
// Calendar is now a lazy sub-app: the `/calendar` route folds the FULL calendar
// context into the live shell context on first mount (workspace/pages/index.js →
// lazySharedLibPage). So every calendar UI key that route references resolves
// against the folded context — none of the heavy page-body components (CalMain,
// CalSidebar, CalWeekView, CalMonthView, CalTeamView, CalTeamNowView,
// CalMiniCalendar, CalQuickCreate) needs to be eager.
//
// Only THREE component files stay eager, because non-calendar surfaces reference
// their keys BEFORE the /calendar route folds the context — and none of those
// surfaces fold calendar on their own:
//   • EventDetailModal.js — `CalEventDetailModal` is string-extended on a
//     NON-folding surface: the shell-root opener
//     workspace/functions/eventDetailModal.js's `openEventDetailModal`
//     (`content: { extends: 'CalEventDetailModal' }`, a @symbo.ls/windows
//     custom layer) fires on ANY route — the HOME dashboard's "Coming up" feed
//     (AppSidebar/IntranetRows/LinkedResources event cells), OnlineMembers,
//     /chat, and pageContext.selectPageItem's event case. Its only childExtends
//     (`CalInviteeRow`) lives in-file, so it is a self-contained render closure.
//   • ProfileModal.js — `CalProfileModal` is string-extended by the shell-root
//     opener workspace/functions/profileModal.js's `openProfileModal`, fired on
//     ANY route: HOME OnlineMembers/IntranetRows, /chat, canvas team-and-agents
//     + tagContextMenu, and data.js. Its childExtends (CalProfileTabBtn,
//     CalProfileDetailRow) + its bare-keyed CalAvailabilityGrid and the whole
//     CalAvailability* / CalProfileUnavailRow closure all live in-file.
//   • NewBookingModal.js — `CalNewBookingModal` is string-extended the same
//     way as CalEventDetailModal above: the shell-root opener
//     workspace/functions/newBookingModal.js's `openNewBookingModal`
//     (`content: { extends: 'CalNewBookingModal' }`, a @symbo.ls/windows
//     custom layer) fires on ANY route — the person popover's "Meet" action
//     (workspace/components/PersonPopover.js), meet's openSuggestionModal,
//     and every calendar-native opener now route through it too (migrated
//     2026-08-01, mirroring the 2026-06-01 EventDetailModal/ProfileModal
//     move off the old bare-mount + stateKey Modal pattern). Its childExtends
//     (CalEventTypeBtn, CalMeetingModeBtn, CalInviteePill,
//     CalInviteeSuggestion, CalRecurringBtn, CalRecurringDayBtn) + its
//     siblings CalConfirmMoveModal / CalVisibilityBtn all live in-file.
//
// The el.call'd functions these three fire on those non-folding surfaces
// (saveEvent / deleteEvent / updateSharedEventFields from
// the modals; freshBooking from the edit/new-booking paths) ride the companion
// functions/eagerSlice.js. Everything else resolves via the lazy fold.
//
// Main.js (CalMain/CalHeader/CalViewBtn) is deliberately NOT eager. (Its old
// blocker — a static `rowToEvent` import from ../pages/index.js dragging the
// 31KB page module into the boot chunk — is gone: rowToEvent lives in
// functions/calendarUtils.js now.) CalMain is bare-keyed ONLY by pages/index.js
// (which folds), so it rides the lazy chunk with zero risk either way.
// (OnlineMember/OnlineMembers/CalOnlineAvatar/CalOnlineUsersBar that Main.js
// re-exports live in @symbo-ls/workspace-shell, not calendar — already eager.)
//
// calendar/package.json has no `sideEffects: false`, so a re-export through
// `./index.js` would NOT tree-shake (referencing it evaluates every sibling
// source file — the whole barrel). Each key below is therefore `export *`-ed
// from its SOURCE file directly, so only these three modules ride the eager chunk.

var $2SPvI = parcelRequire("2SPvI");

var $6fL37 = parcelRequire("6fL37");

var $1SaYL = parcelRequire("1SaYL");
$parcel$exportWildcard(module.exports, $6fL37);
$parcel$exportWildcard(module.exports, $1SaYL);

});
parcelRegister("2SPvI", function(module, exports) {

$parcel$export(module.exports, "CalEventDetailModal", () => $219894d45ec929e2$export$1faf52b39b4958b4);
$parcel$export(module.exports, "CalInviteeRow", () => $219894d45ec929e2$export$9d4d43d039f34fc8);
$parcel$export(module.exports, "CalRsvpButton", () => $219894d45ec929e2$export$84e33c81276f87e6);
// Every calendar function arrives through `el.call`, never an import (FA001):
// a relative sibling import is inlined into this component file by the
// bundler, so frank publishes a body whose identifier resolves to nothing, and
// the deep `@symbo-ls/workspace-calendar/functions/calendarUtils.js`
// bare-package subpath self-imports this package's own barrel and throws a
// circular-import TDZ crash (confirmed live via `bun test`) — see
// QuickCreate.js's note. CalEventDetailModal is EAGER and its shell-root
// opener fires on routes that never fold the calendar context, so every key it
// calls is registered by functions/eagerSlice.js as well as functions/index.js.
// dateUtils.js stays the ORIGINAL deep `@symbo-ls/workspace-shared` subpath on purpose:
// switching it to the bare package root pulls in shared's ENTIRE
// components+functions+state barrel, which live-reproduced a SEPARATE
// circular-import TDZ crash against `workspace/functions/featureFlags.js`
// (confirmed via `bun test`, not hypothetical — see the note left on
// tickets/smbls.md). No confirmed prod evidence this deep subpath is
// actually broken (unlike calendarUtils.js, which had 8 live pageerrors) —
// not swapping an unverified maybe-bug for a confirmed one.
// Role helpers come straight from the workspace-shell library, not through
// calendarUtils.js: that module no longer re-exports them (frank FA206
// stub-phantom — a bag re-export of an externalized value publishes as "").

var $aGIjc = parcelRequire("aGIjc");

var $6RzDA = parcelRequire("6RzDA");
// Resolve the viewer's timezone — prefer the user's profile timezone over
// the browser's system clock. Fixes WORKSPACE-CAL-TZ-DISPLAY where a user
// in Asia/Tbilisi (UTC+4) saw event times in UTC because their browser
// timezone didn't match their profile.
const $219894d45ec929e2$var$_userTz = (root)=>{
    const me = (0, $aGIjc.currentUser)(root);
    return me?.timezone || root?.user?.timezone || null;
};
// Format an event's time range using the user's profile timezone when
// available. Falls back to the event's pre-computed startTime/endTime
// (which were converted using whatever TZ was active at fetch time —
// usually the browser's).
const $219894d45ec929e2$var$_formatRange = (ev, tz)=>{
    if (tz && ev.startAt && ev.endAt) return `${(0, $6RzDA.localTime)(new Date(ev.startAt), tz)} \u{2013} ${(0, $6RzDA.localTime)(new Date(ev.endAt), tz)}`;
    return `${ev.startTime || ''} \u{2013} ${ev.endTime || ''}`;
};
const $219894d45ec929e2$var$_formatDate = (ev, tz)=>{
    if (tz && ev.startAt) return (0, $6RzDA.localDate)(new Date(ev.startAt), tz);
    return ev.date || '';
};
const $219894d45ec929e2$var$_eventParticipants = (el, root)=>{
    const ev = root?.selectedEvent;
    if (!ev) return [];
    const emails = new Set(ev.invitees || []);
    const memberKeys = new Set(ev.integrationMetadata?.calendarInviteeMemberKeys || []);
    const people = root.people || [];
    const matchedEmails = new Set();
    const participants = people.filter((person)=>{
        const selected = emails.has(person.email) || memberKeys.has(el.call('calendarTeamMemberKey', person));
        if (selected && person.email) matchedEmails.add(person.email);
        return selected;
    });
    for (const email of emails)if (!matchedEmails.has(email)) participants.push({
        email: email,
        name: email
    });
    return participants;
};
const $219894d45ec929e2$var$_viewerIsParticipant = (el, root)=>{
    const participants = $219894d45ec929e2$var$_eventParticipants(el, root);
    const viewer = (0, $aGIjc.currentUser)(root) || {
        email: root?.currentUserEmail
    };
    const viewerEmail = String(viewer?.email || root?.currentUserEmail || '').toLowerCase();
    const viewerKey = el.call('calendarTeamMemberKey', viewer);
    return participants.some((participant)=>{
        const participantEmail = String(participant?.email || '').toLowerCase();
        if (viewerEmail && participantEmail === viewerEmail) return true;
        return !!viewerKey && el.call('calendarTeamMemberKey', participant) === viewerKey;
    });
};
const $219894d45ec929e2$var$_setRsvpWithScope = (el, root, event, status)=>{
    const recurrence = el.call('inferRecurrence', root?.events, event);
    if (recurrence.recurring === 'none') {
        el.call('setEventRsvp', event, status, 'this');
        return;
    }
    const title = el.call('polyglot', 'calendar.rsvp.scopeHeading');
    el.call('openModal', {
        template: 'custom',
        maxHeight: '90vh',
        title: title,
        content: {
            flow: 'y',
            gap: 'B',
            minWidth: '0',
            overflowX: 'hidden',
            Hgroup: {
                minWidth: '0',
                H: {
                    tag: 'h5',
                    fontSize: 'B',
                    text: title,
                    overflowWrap: 'anywhere'
                },
                P: {
                    text: el.call('polyglot', 'calendar.rsvp.scopeSubtitle'),
                    color: 'inactive',
                    overflowWrap: 'anywhere'
                }
            },
            ModalFooter: {
                flow: 'y',
                gap: 'Z1',
                CancelBtn: {
                    extends: 'Button',
                    theme: 'tertiary',
                    width: '100%',
                    order: '3',
                    text: el.call('polyglot', 'calendar.rsvp.scopeCancel'),
                    onClick: (e, button)=>button.call('closeModal')
                },
                ThisBtn: {
                    extends: 'Button',
                    theme: 'tertiary',
                    width: '100%',
                    order: '1',
                    text: el.call('polyglot', 'calendar.rsvp.scopeThis'),
                    onClick: (e, button)=>{
                        button.call('setEventRsvp', event, status, 'this');
                        button.call('closeModal');
                    }
                },
                FutureBtn: {
                    extends: 'Button',
                    theme: 'primary',
                    width: '100%',
                    order: '2',
                    text: el.call('polyglot', 'calendar.rsvp.scopeFuture'),
                    onClick: (e, button)=>{
                        button.call('setEventRsvp', event, status, 'future');
                        button.call('closeModal');
                    }
                }
            }
        }
    });
};
// For recurring events, inherit missing fields from a sibling instance
const $219894d45ec929e2$var$_inheritFromSeries = (ev, events)=>{
    if (!ev || ev.invitees?.length && ev.description !== undefined) return ev;
    const baseId = ev.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '');
    if (!baseId) return ev;
    const sibling = (events || []).find((e)=>e.id !== ev.id && e.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '') === baseId && (e.invitees?.length || e.description));
    if (!sibling) return ev;
    return {
        ...ev,
        invitees: ev.invitees?.length ? ev.invitees : sibling.invitees,
        description: ev.description ?? sibling.description,
        type: ev.type || sibling.type
    };
};
const $219894d45ec929e2$var$_clearEventHash = (eventId)=>{
    if (typeof window === 'undefined') return;
    // Primary: clear the `?event=` deep-link query param (tickets-style) on
    // any close path — including inline `selectedEvent: null` updates that
    // don't route through closeEventDetailModal's onClose. Only while it names
    // the event that closed: a close that a navigation causes runs on the NEW
    // address, which can already name ANOTHER event (Back / Forward to its
    // link), and that link must stay for its own restore.
    try {
        const url = new URL(window.location.href);
        const named = url.searchParams.get('event');
        if (named !== null && (eventId == null || named === String(eventId))) {
            for (const key of [
                'event',
                'eventSeries',
                'eventFingerprint',
                'eventSnapshot',
                'eventRsvp',
                'eventRsvpScope'
            ])url.searchParams.delete(key);
            window.history.replaceState(null, '', url.toString());
        }
    } catch (_) {}
    // Legacy: older links may still carry `#event=` in the hash.
    const hash = window.location.hash || '';
    if (hash.includes('event=')) {
        const next = '#view=' + (hash.match(/view=([^&]*)/)?.[1] || 'week');
        window.history.replaceState(null, '', next);
    }
};
const $219894d45ec929e2$export$1faf52b39b4958b4 = {
    maxWidth: 'I',
    widthRange: '0 100%',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    padding: 'Z',
    // Explicit viewport close — `position: fixed` so it always lands at the
    // viewport top-right regardless of where the modal body's container lives
    // in the layout. Geometry is the brand CloseButton (F2: one X, one size);
    // only the placement + the floating `overlay` fill/shadow (it sits over the
    // backdrop, not on a panel surface) are local.
    CloseBtn: {
        extends: 'CloseButton',
        position: 'fixed',
        top: 'A',
        right: 'A',
        zIndex: '2100',
        background: 'overlay',
        // Token color, not a raw rgba() literal — same `--color-shadow` idiom as
        // QuickCreate/NewBookingModal's floating panels in this package.
        boxShadow: '0 2px 12px var(--color-shadow)',
        onClick: (e, el)=>{
            e.preventDefault();
            e.stopPropagation();
            el.call('closeEventDetailModal');
        }
    },
    subscribeTo: [
        'selectedEvent'
    ],
    onRender: (el, s)=>{
        const ev = s.root?.selectedEvent;
        if (!ev) return;
        if (el._lastDetailId === ev.id) return;
        // Try inheriting from a sibling immediately for instant display.
        // The previous `if (ev.invitees !== undefined) return` guard was
        // dropped 2026-06-03 because callers now PRE-NORMALIZE invitees
        // to `[]` (and description to `null`) in openEventDetailModal so
        // the skeleton state can't get stuck on summary feeds. The
        // dedup is owned by fetchEventDetails' internal `_detailCache`
        // so re-firing here is cheap.
        const enriched = $219894d45ec929e2$var$_inheritFromSeries(ev, s.root?.events);
        if (enriched !== ev && enriched.invitees?.length) s.root.update({
            selectedEvent: enriched
        });
        el._lastDetailId = ev.id;
        el.call('fetchEventDetails', ev.id, s.root);
    },
    onUpdate: (el, s)=>{
        // Hash sync — clear the URL hash when selectedEvent goes null. We
        // used to ALSO fire `el.call('closeModal', 'cal-event-detail')`
        // here, but that double-closed when the user already triggered
        // close via the X button (closeEventDetailModal pops the layer
        // AND clears selectedEvent → onUpdate then tried to pop again,
        // leaving the windows-plugin stack in a broken state where the
        // backdrop stayed visible). Single source of truth for layer
        // pops: closeEventDetailModal for explicit closes, the
        // ModalLayer's backdrop-dismiss handler for clicks outside.
        if (s.root?.selectedEvent) {
            el._wasOpen = true;
            el._openEventId = s.root.selectedEvent.id;
        } else if (el._wasOpen) {
            el._wasOpen = false;
            $219894d45ec929e2$var$_clearEventHash(el._openEventId);
        }
    },
    ModalHeader: {
        position: 'relative',
        Hgroup: {
            paddingRight: 'E',
            H: {
                text: (el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return '';
                    if (el.call('eventIsPrivateFor', ev, (0, $aGIjc.currentUser)(s.root))) return el.call('polyglot', 'calendar.detail.privateTitle');
                    return ev.title || '';
                }
            },
            P: {
                text: null,
                flow: 'x',
                align: 'center left',
                gap: 'Z1',
                Icon: {
                    name: 'clock'
                },
                Text: {
                    tag: 'span',
                    text: (el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (!ev) return '';
                        const tz = $219894d45ec929e2$var$_userTz(s.root);
                        return `${$219894d45ec929e2$var$_formatDate(ev, tz)} \xb7 ${$219894d45ec929e2$var$_formatRange(ev, tz)}`;
                    }
                }
            }
        },
        Icons: {
            position: 'absolute',
            top: '0',
            right: '0',
            margin: '0',
            gap: 'Y',
            align: 'center right',
            // Override the brand's inherited Close — dispatch the windows-
            // layer close helper which clears selectedEvent + showEventDetail
            // and pops the layer. Replaces the older `closeModalByStateKey`
            // path that depended on a stateKey declaration this component
            // no longer has.
            //
            // Named like Edit / Delete beside it. The override replaces the brand
            // header's own X (a CloseButton that carries "Close"), and an
            // IconButton with no 'aria-label' and no title renders no name at all:
            // a screen reader announced a bare "button".
            Close: {
                extends: 'IconButton',
                'aria-label': (el)=>el.call('polyglot', 'common.action.close'),
                title: (el)=>el.call('polyglot', 'common.action.close'),
                Icon: {
                    name: 'close'
                },
                onClick: (e, el)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    el.call('closeEventDetailModal');
                }
            },
            // Edit and Delete show only to whoever may write the event — its
            // organizer or a platform superadmin (calendarCanWriteEvent mirrors the
            // server rule). An invitee sees neither.
            EditBtn: {
                extends: 'IconButton',
                hide: (el, s)=>!el.call('calendarCanWriteEvent', s.root?.selectedEvent, s.root),
                padding: 'Y2',
                round: 'radiusPill',
                'aria-label': (el)=>el.call('polyglot', 'calendar.detail.edit'),
                title: (el)=>el.call('polyglot', 'calendar.detail.edit'),
                Icon: {
                    name: 'edit'
                },
                onClick: (e, el, s)=>{
                    const raw = s.root?.selectedEvent;
                    if (!raw) return;
                    const ev = $219894d45ec929e2$var$_inheritFromSeries(raw, s.root?.events);
                    // A generated occurrence carries its own date (getEventsForDay
                    // spreads `date: <clicked day>` so DELETION can scope to the
                    // occurrence), but the EDIT form must seed from the SERIES SOURCE
                    // row: Update saves by id onto that row, and seeding the
                    // occurrence date would silently move the whole series anchor on
                    // an unrelated edit. Google-synced rows are their own source
                    // (found by id), so their per-occurrence date is unchanged here.
                    const sourceRow = (s.root?.events || []).find((item)=>item.id === raw.id);
                    // Infer recurrence from sibling instances for Google-synced events
                    const inferred = el.call('inferRecurrence', s.root?.events, ev);
                    // Detect meeting mode from existing event data
                    const desc = ev.description || '';
                    let meetingMode = ev.meetingMode || 'symbols-meet';
                    let meetUrl = ev.meetUrl || '';
                    if (!ev.meetingMode || ev.meetingMode === 'online') {
                        if (desc.includes('/meet#room=')) meetingMode = 'symbols-meet';
                        else if (ev.meetUrl || desc.match(/https?:\/\//)) {
                            meetingMode = 'external-url';
                            if (!meetUrl && desc.match(/https?:\/\/\S+/)) meetUrl = desc.match(/https?:\/\/\S+/)[0];
                        } else meetingMode = 'symbols-meet';
                    }
                    // Close this layer first, then open the new-booking layer with
                    // the edit draft — this fires on ANY route now (CalNewBookingModal
                    // is a global windows-layer modal, not a /calendar-only mount), so
                    // `el.call('openNewBookingModal', overrides)` replaces the old
                    // `root.update({ showNewBooking: true, newBooking: freshBooking(...) })`
                    // pair. Overrides are passed straight through to freshBooking.
                    const booking = {
                        title: ev.title,
                        date: sourceRow?.date ?? ev.date,
                        startTime: ev.startTime,
                        endTime: ev.endTime,
                        startAt: ev.startAt,
                        endAt: ev.endAt,
                        invitees: (ev.invitees || []).join(', '),
                        inviteeMemberKeys: ev.integrationMetadata?.calendarInviteeMemberKeys || [],
                        description: ev.description || '',
                        type: ev.type || 'meeting',
                        meetingMode: meetingMode,
                        meetUrl: meetUrl,
                        recurring: inferred.recurring,
                        recurringDays: inferred.recurringDays,
                        recurrenceEndType: ev.recurrenceEndType || 'after',
                        recurrenceEndCount: ev.recurrenceEndCount || 10,
                        recurrenceEndDate: ev.recurrenceEndDate || '',
                        integrationMetadata: ev.integrationMetadata,
                        // Carry the existing reminder forward so it's not silently
                        // dropped when editing. (#2200)
                        reminderMinutes: ev.reminderMinutes ?? null,
                        editingEventId: ev.id
                    };
                    el.call('closeEventDetailModal');
                    // The windows host reuses preallocated modal slots. Reopening a
                    // custom modal in the same tick can leave that slot between its
                    // hidden and flex states, which makes the edit form align at the
                    // viewport edge and can retain an incomplete header subtree. Let
                    // the detail layer finish closing before mounting the edit layer.
                    requestAnimationFrame(()=>el.call('openNewBookingModal', booking));
                }
            },
            DeleteBtn: {
                extends: 'IconButton',
                hide: (el, s)=>!el.call('calendarCanWriteEvent', s.root?.selectedEvent, s.root),
                padding: 'Y2',
                round: 'radiusPill',
                'aria-label': (el)=>el.call('polyglot', 'calendar.detail.delete'),
                title: (el)=>el.call('polyglot', 'calendar.detail.delete'),
                Icon: {
                    name: 'trash'
                },
                onClick: (e, el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return;
                    el.call('confirmEventDeletion', el, s.root, ev, 'closeEventDetailModal');
                }
            }
        }
    },
    Body: {
        flow: 'y',
        gap: 'A',
        padding: 'Z 0',
        // Linked resources — chat channel(s) / meet room(s) that reference
        // this event. Hidden when there are no links.
        Links: {
            extends: 'LinkedResources',
            type: 'calendar_event',
            id: (el, s)=>s?.root?.selectedEvent?.id || null
        },
        // Edit/Delete actions are in the ModalFooter at the bottom of the Window.
        // Proposal banner — visible only when the open event is a pending
        // proposal. Accept moves the original event to the proposed time and
        // removes the proposal duplicate; Decline just removes the proposal.
        // Both ask first (functions/eventProposal.js). Accept shows to whoever
        // may write the original event; Decline also to the person who proposed.
        ProposalBanner: {
            display: (el, s)=>s.root?.selectedEvent?.isProposal ? 'flex' : 'none',
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            padding: 'Z A',
            round: 'radiusControl',
            background: 'overlay',
            flexWrap: 'wrap',
            Text: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'title',
                flex: '1',
                text: (el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return '';
                    return el.call('polyglot', 'calendar.detail.proposedBy').replace('{name}', ev.proposedBy || el.call('polyglot', 'calendar.detail.proposedByFallback'));
                }
            },
            Actions: {
                flow: 'x',
                gap: 'Y',
                DeclineBtn: {
                    extends: 'Button',
                    theme: 'secondary',
                    hide: (el, s)=>!el.call('calendarCanDeclineProposal', s.root?.selectedEvent, s.root),
                    text: '{{ calendar.detail.decline | polyglot }}',
                    onClick: (e, el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (ev) el.call('declineEventProposal', ev);
                    }
                },
                AcceptBtn: {
                    extends: 'Button',
                    theme: 'primary',
                    hide: (el, s)=>!el.call('calendarCanAcceptProposal', s.root?.selectedEvent, s.root),
                    text: '{{ calendar.detail.accept | polyglot }}',
                    onClick: (e, el, s)=>{
                        const ev = s.root?.selectedEvent;
                        if (ev) el.call('acceptEventProposal', ev);
                    }
                }
            }
        },
        // Creator / organizer row — resolves the creatorEmail to the person's
        // display name (and avatar) via root.people, falls back to the raw
        // email if no profile is loaded.
        CreatorRow: {
            display: (el, s)=>{
                const ev = s.root?.selectedEvent;
                if (!ev?.creatorEmail) return 'none';
                if (el.call('eventIsPrivateFor', ev, (0, $aGIjc.currentUser)(s.root))) return 'none';
                return 'flex';
            },
            flow: 'x',
            align: 'center left',
            gap: 'Z1',
            Avatar: {
                avatarType: 'initials',
                boxSize: 'B B',
                src: (el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return el.call('avatarUrl', null);
                    const creator = el.call('findPerson', ev.creatorEmail);
                    return el.call('avatarUrl', creator && creator.name || ev.creatorEmail);
                }
            },
            Text: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'subtitle',
                text: (el, s)=>{
                    const ev = s.root?.selectedEvent;
                    if (!ev) return '';
                    const creator = el.call('findPerson', ev.creatorEmail);
                    const name = creator && creator.name || ev.creatorEmail;
                    // A function replacement: a name is the person's own text.
                    return el.call('polyglot', 'calendar.detail.createdBy').replace('{name}', ()=>name);
                }
            }
        },
        // Description and Invitees are lazy-loaded by fetchEventDetails when
        // the modal opens. While loading, both show a skeleton; once loaded,
        // empty/undefined fields hide normally.
        Description: {
            display: (el, s)=>{
                const ev = s.root?.selectedEvent;
                if (!ev) return 'none';
                if (el.call('eventIsPrivateFor', ev, (0, $aGIjc.currentUser)(s.root))) return 'none';
                // Loading: description is undefined (not yet fetched)
                if (ev.description === undefined) return 'flex';
                // Loaded: only show if there's content
                return ev.description ? 'flex' : 'none';
            },
            flow: 'x',
            align: 'flex-start left',
            gap: 'Z1',
            Icon: {
                name: 'menu',
                opacity: '.5'
            },
            Text: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'subtitle',
                lineHeight: '1.6',
                // A Google Calendar description is HTML, and this printed its tags
                // (`<p>Global Tech Weekend…`). Read it as TEXT with its paragraphs
                // kept — `pre-line` paints the newlines the helper leaves. Never
                // `html:`: an invitation is somebody else's string.
                whiteSpace: 'pre-line',
                text: (el, s)=>el.call('htmlToPlainText', s.root?.selectedEvent?.description, {
                        breaks: true
                    }) || ''
            },
            Skeleton: {
                hide: (el, s)=>s.root?.selectedEvent?.description !== undefined,
                flex: '1',
                height: 'A',
                round: 'V',
                background: 'overlay',
                opacity: '.6'
            }
        },
        InviteesSection: {
            display: (el, s)=>{
                const ev = s.root?.selectedEvent;
                if (!ev) return 'none';
                if (el.call('eventIsPrivateFor', ev, (0, $aGIjc.currentUser)(s.root))) return 'none';
                // Loading: invitees is undefined
                if (ev.invitees === undefined) return 'flex';
                // Loaded: include privacy-projected Team participants identified by
                // stable member id, even when their email is intentionally absent.
                return $219894d45ec929e2$var$_eventParticipants(el, s.root).length ? 'flex' : 'none';
            },
            flow: 'y',
            gap: 'Z1',
            HeaderRow: {
                flow: 'x',
                align: 'center left',
                gap: 'Z1',
                Icon: {
                    name: 'user'
                },
                // Invitees fetch in flight — Skeleton line instead of a "Loading…"
                // string (DESIGN_LANGUAGE.md §9: "Loading…" strings are illegal;
                // Skeleton mirrors the geometry of the text it replaces).
                LabelSkeleton: {
                    hide: (el, s)=>s.root?.selectedEvent?.invitees !== undefined,
                    extends: 'SkeletonRow',
                    width: 'F'
                },
                Label: {
                    tag: 'span',
                    hide: (el, s)=>s.root?.selectedEvent?.invitees === undefined,
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>{
                        const count = $219894d45ec929e2$var$_eventParticipants(el, s.root).length;
                        return `${count} guest${count !== 1 ? 's' : ''}`;
                    }
                }
            },
            List: {
                hide: (el, s)=>s.root?.selectedEvent?.invitees === undefined,
                flow: 'x',
                align: 'center left',
                flexWrap: 'wrap',
                gap: 'Z',
                childExtends: 'CalInviteeRow',
                childrenAs: 'state',
                children: (el, s)=>$219894d45ec929e2$var$_eventParticipants(el, s.root)
            },
            SkeletonList: {
                hide: (el, s)=>s.root?.selectedEvent?.invitees !== undefined,
                flow: 'y',
                gap: 'Z',
                paddingLeft: 'C',
                Row1: {
                    height: 'B',
                    round: 'V',
                    background: 'overlay',
                    opacity: '.6'
                },
                Row2: {
                    height: 'B',
                    round: 'V',
                    background: 'overlay',
                    opacity: '.4'
                },
                Row3: {
                    height: 'B',
                    round: 'V',
                    background: 'overlay',
                    opacity: '.3'
                }
            }
        },
        RsvpRow: {
            hide: (el, s)=>{
                const ev = s.root?.selectedEvent;
                return !ev || el.call('eventIsPrivateFor', ev, (0, $aGIjc.currentUser)(s.root)) || !$219894d45ec929e2$var$_viewerIsParticipant(el, s.root);
            },
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            flexWrap: 'wrap',
            paddingTop: 'Z',
            Label: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'title',
                text: '{{ calendar.detail.going | polyglot }}'
            },
            Actions: {
                flow: 'x',
                gap: 'Y',
                CalRsvpButton: {
                    rsvpStatus: 'accepted',
                    text: '{{ calendar.detail.rsvpYes | polyglot }}'
                },
                CalRsvpButton_1: {
                    rsvpStatus: 'declined',
                    text: '{{ calendar.detail.rsvpNo | polyglot }}'
                },
                CalRsvpButton_2: {
                    rsvpStatus: 'tentative',
                    text: '{{ calendar.detail.rsvpMaybe | polyglot }}'
                }
            }
        }
    },
    ModalFooter: {
        flow: 'x',
        gap: 'Z1',
        paddingTop: 'A',
        // Cross-app: launch a meet call linked to this calendar event. The
        // event id (bigint) flows into meet_rooms.calendar_event_id, which the
        // meet RLS policies treat as a normal owned room.
        // "Join call" — launches (or rejoins) a meet room linked to this
        // calendar event. Was previously labelled "Save event" which misled
        // users into thinking it would persist edits; edits flow through the
        // EditBtn → CalNewBookingModal pipeline instead. The detail modal is
        // read-only by design. (#2198)
        SaveBtn: {
            extends: 'Button',
            theme: 'primary',
            text: '{{ calendar.detail.joinCall | polyglot }}',
            // Re-entrancy guard against double-clicks during createRoom. Scoped
            // state (vs plain element prop) so the `disabled` binding actually
            // re-evaluates when the flag flips. (#2198)
            state: {
                joining: false
            },
            disabled: (el, s)=>s.joining,
            onClick: async (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                if (s.joining) return;
                const ev = s.root?.selectedEvent;
                if (!ev) return;
                s.update({
                    joining: true
                });
                // Reuse an existing meet_room for this event if present, otherwise
                // create a new one.
                const existing = (s.root.rooms || []).find((r)=>r.calendarEventId === ev.id);
                let id = existing?.id;
                if (!id) id = await el.call('createRoom', {
                    name: ev.title || el.call('polyglot', 'calendar.detail.callName'),
                    kind: 'scheduled',
                    calendarEventId: ev.id,
                    transcribeEnabled: true
                });
                s.update({
                    joining: false
                });
                if (!id) {
                    el.call('openNotification', {
                        type: 'error',
                        title: el.call('polyglot', 'calendar.detail.callFailedTitle'),
                        message: el.call('polyglot', 'calendar.detail.callFailedMessage')
                    });
                    return;
                }
                s.root.update({
                    showEventDetail: false,
                    selectedEvent: null,
                    activeRoomId: id,
                    meetView: 'call'
                });
                if (typeof window !== 'undefined') window.location.hash = `room=${id}&view=call`;
                // Walk up to the page root with the `routes` prop — el.getRoot()
                // doesn't exist in DOMQL v3.14.
                let __root = el;
                while(__root && !__root.routes)__root = __root.parent;
                if (__root) el.router('/meet', __root);
                await el.call('connectCall', id);
            }
        },
        Spacer: {
            flex: '1'
        },
        AskAIBtn: {
            extends: 'Button',
            theme: 'secondary',
            flow: 'x',
            gap: 'Z',
            align: 'center center',
            Icon: {
                name: 'magicstar',
                boxSize: 'Z2'
            },
            text: '{{ calendar.detail.askAi | polyglot }}',
            onClick: (e, el, s)=>{
                const ev = s.root?.selectedEvent;
                if (!ev) return;
                const root = s.root;
                const id = ev.id;
                const when = `${ev.date || ''} ${ev.startTime || ''}${ev.endTime ? ` \u{2013} ${ev.endTime}` : ''}`.trim();
                const evFallback = el.call('polyglot', 'calendar.detail.eventFallback');
                const titleLine = `${ev.title || evFallback}${when ? ` \xb7 ${when}` : ''}`;
                // Modern picked-context path — assistantAttachment was DEAD (nothing in
                // the Simone pipeline read it, so the event never reached the composer).
                // Attach the event as a context chip the transport prepends to the next
                // turn (root.pickedElements, per TicketDetailModal.AskAIBtn); open the
                // assistant and let the user type their question.
                const entry = {
                    // keyPath is DISPLAY only — the shared AiContextChip joins it with
                    // ' › ' for the chip title and matches entries by `pickedAt`.
                    keyPath: [
                        evFallback,
                        titleLine
                    ],
                    key: ev.title || evFallback,
                    tag: 'event',
                    title: titleLine,
                    pickedAt: Date.now(),
                    event: {
                        id: id,
                        title: ev.title || '',
                        date: ev.date || null,
                        startTime: ev.startTime || null,
                        endTime: ev.endTime || null
                    }
                };
                const prev = (root.pickedElements || []).filter((p)=>!(p && p.event && String(p.event.id) === String(id)));
                root.update({
                    assistantOpen: true,
                    pickedElements: [
                        ...prev,
                        entry
                    ]
                });
            }
        }
    }
};
const $219894d45ec929e2$export$9d4d43d039f34fc8 = {
    flow: 'x',
    align: 'center left',
    flex: 'none',
    gap: 'Z1',
    padding: 'Y2 Z',
    round: 'radiusPill',
    background: 'overlay',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: (el, s)=>{
        const status = el.call('calendarEventRsvpStatus', s.root?.selectedEvent, s);
        if (status === 'accepted') return 'green';
        if (status === 'declined') return 'red';
        if (status === 'tentative') return 'yellow';
        return 'line';
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B1 B1',
        src: (el, s)=>el.call('avatarUrl', s.name || s.email)
    },
    Email: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'subtitle',
        text: (el, s)=>s.name || s.email || ''
    }
};
const $219894d45ec929e2$export$84e33c81276f87e6 = {
    extends: 'Button',
    theme: 'secondary',
    minWidth: 'C',
    round: 'radiusPill',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: (el, s)=>{
        const viewer = (s.root?.people || []).find((person)=>person.email === s.root?.currentUserEmail) || s.root?.currentUserEmail;
        const selected = el.call('calendarEventRsvpStatus', s.root?.selectedEvent, viewer);
        if (selected !== el.rsvpStatus) return 'line';
        if (selected === 'accepted') return 'green';
        if (selected === 'declined') return 'red';
        return 'yellow';
    },
    onClick: (event, el, s)=>{
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const selectedEvent = s.root?.selectedEvent;
        if (selectedEvent) $219894d45ec929e2$var$_setRsvpWithScope(el, s.root, selectedEvent, el.rsvpStatus);
    }
};

});

parcelRegister("6fL37", function(module, exports) {

$parcel$export(module.exports, "CalProfileModal", () => $48d8a3c7d1a558f9$export$4798162861403ca4);
$parcel$export(module.exports, "CalProfileTabBtn", () => $48d8a3c7d1a558f9$export$8e04fb1b2685d773);
$parcel$export(module.exports, "CalProfileDetailRow", () => $48d8a3c7d1a558f9$export$254e27c8362214eb);
$parcel$export(module.exports, "CalProfileUnavailRow", () => $48d8a3c7d1a558f9$export$f1d2d1fdf29c68e4);
$parcel$export(module.exports, "CalAvailabilityGrid", () => $48d8a3c7d1a558f9$export$fc88702b5e91882b);
$parcel$export(module.exports, "CalAvailabilityHourHeader", () => $48d8a3c7d1a558f9$export$fce0794b4ecf8225);
$parcel$export(module.exports, "CalAvailabilityDayRow", () => $48d8a3c7d1a558f9$export$d96962d9aac01c25);
$parcel$export(module.exports, "CalAvailabilityCell", () => $48d8a3c7d1a558f9$export$1b163d240ec28289);
// Profile modal — unified Profile / Availability / Settings tabs.
// Opens via `root.profileEmail`. Settings + Availability tabs are only
// editable when viewing your own profile (and gated to admin for some
// fields). Profile tab works for any team member.
// Every calendar function this file needs arrives through `el.call`, never an
// import (FA001). A relative sibling import makes the bundler inline the
// function file into this component file, so frank publishes a body whose
// identifier resolves to nothing; the deep
// `@symbo-ls/workspace-calendar/functions/*` bare-package subpath is not the
// alternative either — it self-imports this package's own barrel and throws a
// circular-import TDZ crash (confirmed live via `bun test`, see
// QuickCreate.js's note). `functions/index.js` registers calendarUtils,
// availabilityShape and availabilityUtils on `context.functions`, and
// `functions/eagerSlice.js` registers all three EAGERLY — which this file
// needs, because `openProfileModal` fires on routes that never fold the
// calendar context.
// The admin predicate is reached through `el.call`, NEVER by a static import
// of `@symbo-ls/workspace-shell/functions/roleHelpers.js`. frank externalizes
// a cross-library import, so the emitted body carries a lookup that resolves
// nowhere on the published plane: measured live on
// system--workspace-ui.at.symbo.ls, this file's `_canEditModal` threw
// `TypeError: this.currentUserIsAdmin is not a function` on every load, and
// the stubbed names it published (`currentUser`, `currentUserIsAdmin` as "")
// also SHADOWED the shell's real ones in the merged globalScope — which is
// what made the shell's own `el.call('currentUserIsAdmin')` sites throw too
// (WS-SHELL-ROLEHELPERS-UNDECLARED-LIB-FLOODS-CONSOLE-1).
// `el.call` reads `context.functions`, where the declared workspace-shell
// library really does land, and it returns `undefined` for a missing key
// instead of throwing — so the affordance fails CLOSED, and the server still
// enforces the real authorization. Same idiom as this file's own
// `el.call('findPerson', …)`.
const $48d8a3c7d1a558f9$var$_isViewingSelf = (root)=>root?.profileEmail && root.profileEmail === root.currentUserEmail;
const $48d8a3c7d1a558f9$var$_canEditModal = (el, root)=>$48d8a3c7d1a558f9$var$_isViewingSelf(root) || !!el.call('currentUserIsAdmin', root);
const $48d8a3c7d1a558f9$var$_formatTime = (el, tz, lang)=>tz ? el.call('formatTzTime', Date.now(), tz, lang) : '';
const $48d8a3c7d1a558f9$var$_timezoneOptions = ()=>{
    const list = typeof Intl !== 'undefined' && Intl.supportedValuesOf ? Intl.supportedValuesOf('timeZone') : null;
    if (list && list.length) return list;
    return [];
};
// Tenure from a start date → "New" / "5 mo" / "2y 3mo". Em-dash when unknown.
const $48d8a3c7d1a558f9$var$_calendarTenure = (startDate)=>{
    if (!startDate) return "\u2014";
    const start = new Date(startDate);
    if (Number.isNaN(start.getTime())) return "\u2014";
    const months = Math.floor((Date.now() - start.getTime()) / 2630016000);
    if (months < 1) return 'calendar.profile.tenureNew';
    if (months < 12) return `${months} mo`;
    const years = Math.floor(months / 12);
    const rem = months % 12;
    return rem ? `${years}y ${rem}mo` : `${years}y`;
};
// City + Country, falling back to the legacy "City, CC" location string.
const $48d8a3c7d1a558f9$var$_location = (p)=>{
    const parts = [
        p?.city,
        p?.country
    ].filter(Boolean);
    if (parts.length) return parts.join(', ');
    return p?.location || "\u2014";
};
// Primary team name from the Mongo-sourced team index on root. id-first —
// a non-mgmt viewer's rows carry no email (server projection), so resolve via
// the stable userId before the email fallback (tickets/fable.md P0 regression).
const $48d8a3c7d1a558f9$var$_teamName = (p, root)=>{
    const byId = p?.userId != null ? root?.teamsByUserId?.[String(p.userId)] : null;
    const rows = Array.isArray(byId) && byId.length && byId || root?.teamsByEmail?.[String(p?.email || '').toLowerCase()] || [];
    return rows[0]?.name || "\u2014";
};
// Org role — root.roles.byUser is authoritative (distinguishes owner/admin);
// legacy person.roles[0] is the fallback, then plain 'member'.
const $48d8a3c7d1a558f9$var$_orgRole = (p, root)=>{
    const byUser = root?.roles?.byUser || {};
    const role = p?.userId && byUser[p.userId] || Array.isArray(p?.roles) && p.roles[0] || 'member';
    return String(role);
};
// Resolve a profile-detail field to a display string, always falling back to
// an em-dash so empty members read as intentional, not broken. Keyed by a
// STRING `field` (not a function prop — see CalProfileDetailRow). `root` is
// threaded through for the fields that live on root state (team, role). The
// Profile tab mirrors the important info on the full /profile page.
const $48d8a3c7d1a558f9$var$_profileFieldValue = (el, field, p, root, lang)=>{
    switch(field){
        case 'position':
            return p?.position || "\u2014";
        case 'team':
            return $48d8a3c7d1a558f9$var$_teamName(p, root);
        case 'role':
            return $48d8a3c7d1a558f9$var$_orgRole(p, root);
        case 'location':
            return $48d8a3c7d1a558f9$var$_location(p);
        case 'tenure':
            return $48d8a3c7d1a558f9$var$_calendarTenure(p?.startDate || p?.start_date);
        case 'localTime':
            {
                const t = $48d8a3c7d1a558f9$var$_formatTime(el, p?.timezone, lang);
                return t ? `${t} \xb7 ${p.timezone}` : "\u2014";
            }
        case 'github':
            return p?.github || "\u2014";
        // Legacy calendar-centric fields (still resolvable for any caller that
        // passes them; the Profile tab itself no longer lists these).
        case 'weeklyHours':
            return p?.weeklyHours != null ? String(p.weeklyHours) : "\u2014";
        case 'workingDays':
            return p?.workingDays || "\u2014";
        case 'workingHours':
            return p?.workingHours ? `${p.workingHours.start} \u{2013} ${p.workingHours.end}` : "\u2014";
        default:
            return "\u2014";
    }
};
// Write against the VIEWED person (root.profileEmail), not the caller — the
// Availability tab is editable by an admin viewing someone else, and the old
// currentUserEmail target silently landed those edits on the admin's own row.
// Settings-tab writes are unaffected (that tab only renders on self, where
// profileEmail === currentUserEmail).
const $48d8a3c7d1a558f9$var$_writeUser = (root, patch)=>{
    const target = root.profileEmail || root.currentUserEmail;
    const next = (root.people || []).map((p)=>p.email === target ? {
            ...p,
            ...patch
        } : p);
    root.update({
        people: next
    });
};
// 7×24 availability grid helpers
const $48d8a3c7d1a558f9$var$_calendarIsAvailableDefault = (el, user, hour)=>{
    const wh = user?.workingHours;
    if (!wh) return true;
    const minute = hour * 60;
    const start = el.call('hhmmToMin', wh.start);
    const end = el.call('hhmmToMin', wh.end);
    return start < end ? minute >= start && minute < end : minute >= start || minute < end;
};
const $48d8a3c7d1a558f9$var$_calendarIsAvailableAt = (el, user, day, hour)=>{
    if (!user) return false;
    const grid = user.availabilityGrid;
    if (grid && grid[day] && typeof grid[day][hour] === 'boolean') return grid[day][hour];
    return $48d8a3c7d1a558f9$var$_calendarIsAvailableDefault(el, user, hour);
};
const $48d8a3c7d1a558f9$var$_toggleCell = (el, root, day, hour)=>{
    const u = (root.people || []).find((p)=>p.email === root.profileEmail) || null;
    // Self OR admin — a member sets their OWN availability from their profile.
    if (!u || !$48d8a3c7d1a558f9$var$_canEditModal(el, root)) return;
    const grid = u.availabilityGrid ? u.availabilityGrid.map((row)=>row.slice()) : Array.from({
        length: 7
    }, ()=>Array.from({
            length: 24
        }, (_, h)=>$48d8a3c7d1a558f9$var$_calendarIsAvailableDefault(el, u, h)));
    grid[day][hour] = !grid[day][hour];
    $48d8a3c7d1a558f9$var$_writeUser(root, {
        availabilityGrid: grid
    });
    // Persist to the server-side AvailabilityRule (debounced, per-user).
    el.call('saveAvailabilityGrid', root, u, grid);
};
const $48d8a3c7d1a558f9$var$_setTab = (root, tab)=>root.update({
        profileModalTab: tab
    });
const $48d8a3c7d1a558f9$export$4798162861403ca4 = {
    width: '100%',
    maxWidth: 'I',
    // #2343 + overflow fix — flex column so the header, tabs, and footer stay
    // PINNED while ONLY the tab panes scroll. A whole-modal `overflowY:auto`
    // scrolled the footer buttons (and the header X) out of view once the tall
    // Availability grid exceeded the cap (verified 2026-07-17: the footer
    // scrolled away past 82dvh). ModalWindow is overflow:visible / maxHeight:null
    // in the windows layer, so this body must self-cap — but the scroll now lives
    // on the inner ScrollArea, not the whole modal.
    display: 'flex',
    flexFlow: 'column',
    maxHeight: '82dvh',
    overflow: 'hidden',
    gap: 'A',
    // Pull the viewed person's server-side AvailabilityRule into root.people so
    // the Availability tab + summary show persisted data, not just local state.
    onCreate: (el, s)=>{
        const person = el.call('findPerson', s.root.profileEmail);
        if (person) el.call('hydratePersonAvailability', s.root, person);
    },
    ModalHeader: {
        flexShrink: '0',
        Avatar: {
            order: -1,
            avatarType: 'initials',
            boxSize: 'D D',
            src: (el, s)=>el.call('avatarUrl', el.call('findPerson', s.root.profileEmail)?.name)
        },
        Hgroup: {
            gap: '0',
            H: {
                margin: '0',
                text: (el, s)=>el.call('findPerson', s.root.profileEmail)?.name || el.call('polyglot', 'calendar.profile.heading')
            },
            P: {
                text: (el, s)=>{
                    const p = el.call('findPerson', s.root.profileEmail);
                    if (!p) return '';
                    const byId = p.userId != null ? s.root?.teamsByUserId?.[String(p.userId)] : null;
                    const email = String(p.email || s.root.profileEmail || '').toLowerCase();
                    const rows = Array.isArray(byId) && byId.length && byId || s.root?.teamsByEmail?.[email] || [];
                    const team = rows[0]?.name;
                    return [
                        p.position,
                        team
                    ].filter(Boolean).join(" \xb7 ");
                }
            },
            Email: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                fontFamily: 'monospace',
                text: (el, s)=>el.call('findPerson', s.root.profileEmail)?.email || ''
            }
        },
        Icons: {
            // Fix the X position + look: the brand ModalHeader.Icons uses negative
            // margins (`-Y2 -Z1`) to pull the button off toward the window corner,
            // where the window's rounded-corner clip ate into the glyph (verified
            // 2026-07-17 on this canvas). Reset the margin and pin the button to the
            // top of the header row so the X sits cleanly inside the padding. The
            // button is already a themed CircleButton (NavbarButton) with a hover
            // state — no restyle needed. Override the inherited Close.onClick to
            // dispatch the windows-layer close (the stateKey walker no-ops now this
            // component dropped its stateKey). Full-page open moved to the footer's
            // explicit "Open profile" button (the bare expand glyph was cryptic).
            margin: '0',
            alignSelf: 'start',
            Close: {
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('closeProfileModal');
                }
            }
        }
    },
    Tabs: {
        flexShrink: '0',
        flow: 'x',
        gap: 'V',
        borderBottomWidth: 'hairline',
        borderBottomColor: 'line',
        borderBottomStyle: 'solid',
        childExtends: 'CalProfileTabBtn',
        children: [
            {
                tab: 'profile',
                label: 'calendar.profile.tabProfile'
            },
            {
                tab: 'availability',
                label: 'calendar.profile.tabAvailability'
            },
            {
                tab: 'settings',
                label: 'calendar.profile.tabSettings',
                hide: (el, s)=>!$48d8a3c7d1a558f9$var$_isViewingSelf(s.root)
            }
        ]
    },
    // Scrollable middle — ONLY the tab panes scroll; header/tabs/footer stay
    // pinned (the overflow-cuts-buttons fix). `minHeight:0` lets this flex child
    // shrink below its content height so `overflowY:auto` actually engages.
    ScrollArea: {
        flow: 'y',
        gap: 'A',
        flex: '1 1 auto',
        minHeight: '0',
        overflowY: 'auto',
        // ── Profile tab ──
        ProfilePane: {
            hide: (el, s)=>(s.root.profileModalTab || 'profile') !== 'profile',
            flow: 'y',
            gap: 'A',
            DetailGrid: {
                flow: 'y',
                gap: 'Z',
                padding: 'Z 0',
                childExtends: 'CalProfileDetailRow',
                // v3.14: a function prop (valueGetter) on a childExtends child is
                // consumed as a reactive factory, NOT stored — so el.parent.valueGetter
                // came back undefined and every Value rendered blank. Pass a STRING
                // `field` key (accessible like `label`) and resolve it in Value.text.
                children: [
                    {
                        label: 'calendar.profile.fieldPosition',
                        field: 'position'
                    },
                    {
                        label: 'calendar.profile.fieldTeam',
                        field: 'team'
                    },
                    {
                        label: 'calendar.profile.fieldRole',
                        field: 'role'
                    },
                    {
                        label: 'calendar.profile.fieldLocation',
                        field: 'location'
                    },
                    {
                        label: 'calendar.profile.fieldLocalTime',
                        field: 'localTime'
                    },
                    {
                        label: 'calendar.profile.fieldGithub',
                        field: 'github'
                    },
                    {
                        label: 'calendar.profile.fieldTenure',
                        field: 'tenure'
                    }
                ]
            }
        },
        // ── Availability tab ──
        AvailabilityPane: {
            hide: (el, s)=>s.root.profileModalTab !== 'availability',
            flow: 'y',
            gap: 'Z',
            Header: {
                flow: 'x',
                align: 'center space-between',
                Title: {
                    tag: 'span',
                    text: '{{ calendar.profile.availabilityHeading | polyglot }}',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'subtitle'
                },
                Hint: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>{
                        if ($48d8a3c7d1a558f9$var$_isViewingSelf(s.root)) return el.call('polyglot', 'calendar.profile.hintToggle');
                        return el.call('polyglot', el.call('currentUserIsAdmin', s.root) ? 'calendar.profile.hintToggleAdmin' : 'calendar.profile.hintReadOnly');
                    }
                }
            },
            // Schedule-derived, tz-honest one-liner — the read-only view for anyone
            // opening another member's profile ("Available now · until 18:00 · …").
            Summary: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'paragraph',
                // `el.call` binds `this` to the element (Rule 8), which is what the
                // helper needs: it translates every word of its answer through the
                // bundles itself, and an unbound call answers raw keys.
                text: (el, s)=>el.call('availabilitySummaryText', el.call('findPerson', s.root.profileEmail))
            },
            CalAvailabilityGrid: {},
            // Every field is the shared field kit (AppField + AppInput/AppSelect,
            // workspace-shared components/AppField.js): the caption label above
            // the control, the brand `field` fill with the hairline edge. The
            // control carries behaviour only; the kit owns the look.
            AvailFields: {
                flow: 'y',
                gap: 'Z1',
                padding: 'Z 0',
                childExtends: 'AppField',
                LocationField: {
                    label: (el)=>el.call('polyglot', 'calendar.profile.locationLabel'),
                    AppInput: {
                        type: 'text',
                        placeholder: (el)=>el.call('polyglot', 'calendar.profile.locationPlaceholder'),
                        readonly: (el, s)=>$48d8a3c7d1a558f9$var$_canEditModal(el, s.root) ? null : true,
                        value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.location || '',
                        onInput: (e, el, s)=>{
                            if (!$48d8a3c7d1a558f9$var$_canEditModal(el, s.root)) return;
                            $48d8a3c7d1a558f9$var$_writeUser(s.root, {
                                location: e.target.value
                            });
                        }
                    }
                },
                TimezoneField: {
                    label: (el)=>el.call('polyglot', 'calendar.profile.timezoneLabel'),
                    AppSelect: {
                        disabled: (el, s)=>$48d8a3c7d1a558f9$var$_canEditModal(el, s.root) ? null : true,
                        value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.timezone || '',
                        onChange: (e, el, s)=>{
                            if (!$48d8a3c7d1a558f9$var$_canEditModal(el, s.root)) return;
                            $48d8a3c7d1a558f9$var$_writeUser(s.root, {
                                timezone: e.target.value
                            });
                        },
                        childExtends: {
                            tag: 'option',
                            value: (el, s)=>s.value,
                            text: (el, s)=>s.text
                        },
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const list = $48d8a3c7d1a558f9$var$_timezoneOptions();
                            return [
                                {
                                    value: '',
                                    text: el.call('polyglot', 'calendar.profile.timezonePlaceholder')
                                },
                                ...list.map((tz)=>({
                                        value: tz,
                                        text: tz
                                    }))
                            ];
                        }
                    }
                },
                WeeklyHoursField: {
                    label: (el)=>el.call('polyglot', 'calendar.profile.weeklyHoursLabel'),
                    AppInput: {
                        type: 'text',
                        readonly: true,
                        value: (el, s)=>{
                            const u = el.call('findPerson', s.root.profileEmail);
                            if (!u) return '0';
                            let count = 0;
                            for(let day = 0; day < 7; day++){
                                for(let h = 0; h < 24; h++)if ($48d8a3c7d1a558f9$var$_calendarIsAvailableAt(el, u, day, h)) count++;
                            }
                            return `${count} h / week`;
                        }
                    }
                }
            }
        },
        // ── Settings tab (self only) ──
        SettingsPane: {
            hide: (el, s)=>s.root.profileModalTab !== 'settings',
            flow: 'y',
            gap: 'Z1',
            childExtends: 'AppField',
            NameField: {
                label: (el)=>el.call('polyglot', 'calendar.profile.displayNameLabel'),
                AppInput: {
                    type: 'text',
                    placeholder: (el)=>el.call('polyglot', 'calendar.profile.displayNamePlaceholder'),
                    value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.name || '',
                    onInput: (e, el, s)=>$48d8a3c7d1a558f9$var$_writeUser(s.root, {
                            name: e.target.value
                        })
                }
            },
            PositionField: {
                label: (el)=>el.call('polyglot', 'calendar.profile.positionLabel'),
                AppInput: {
                    type: 'text',
                    placeholder: (el)=>el.call('polyglot', 'calendar.profile.positionPlaceholder'),
                    value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.position || '',
                    onInput: (e, el, s)=>$48d8a3c7d1a558f9$var$_writeUser(s.root, {
                            position: e.target.value
                        })
                }
            },
            // Read-only team display. Team membership is managed from the
            // profile editor in MemberProfile (with a real picker); the
            // calendar profile popover surfaces it but doesn't edit. A read-only
            // kit input, like WeeklyHoursField above — it was a `div` dressed as
            // a field; the same team name now fills the field's value.
            TeamField: {
                label: (el)=>el.call('polyglot', 'calendar.profile.teamLabel'),
                AppInput: {
                    type: 'text',
                    readonly: true,
                    value: (el, s)=>{
                        const p = el.call('findPerson', s.root.profileEmail);
                        const byId = p?.userId != null ? s.root?.teamsByUserId?.[String(p.userId)] : null;
                        const email = String(p?.email || s.root.profileEmail || '').toLowerCase();
                        const rows = Array.isArray(byId) && byId.length && byId || s.root?.teamsByEmail?.[email] || [];
                        return rows[0]?.name || "\u2014";
                    }
                }
            },
            GitHubField: {
                label: (el)=>el.call('polyglot', 'calendar.profile.githubLabel'),
                AppInput: {
                    type: 'text',
                    placeholder: (el)=>el.call('polyglot', 'calendar.profile.githubPlaceholder'),
                    value: (el, s)=>el.call('findPerson', s.root.profileEmail)?.github || '',
                    onInput: (e, el, s)=>$48d8a3c7d1a558f9$var$_writeUser(s.root, {
                            github: e.target.value
                        })
                }
            }
        }
    },
    // ── Footer — Open profile + Message (others). Right-aligned to match the
    // @symbo.ls/windows footer convention (ConfirmTemplate). Pinned (flexShrink:0)
    // so the action buttons never scroll out of view when the panes overflow. ──
    ModalFooter: {
        flexShrink: '0',
        flow: 'x',
        gap: 'Z1',
        align: 'center end',
        OpenProfileBtn: {
            extends: 'Button',
            theme: 'ghost',
            text: '{{ calendar.profile.openProfile | polyglot }}',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const email = s.root.profileEmail;
                if (!email) return;
                s.root.update({
                    profileEmail: null,
                    profileModalTab: 'profile'
                });
                let rootEl = el;
                while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
                const router = el.context?.utils?.router;
                if (router && rootEl) router(el.call('profilePath', email), rootEl, {}, {
                    pushState: true,
                    scrollToTop: true
                });
            }
        },
        MessageBtn: {
            extends: 'Button',
            theme: 'primary',
            // Only when viewing someone else — you don't DM yourself. A reactive
            // `display` factory (not `hide`) because the default-config Button ships a
            // static `display: 'inline-flex'` that defeats `hide`'s display:none —
            // overriding display directly is what actually toggles it.
            display: (el, s)=>$48d8a3c7d1a558f9$var$_isViewingSelf(s.root) ? 'none' : 'inline-flex',
            text: '{{ calendar.profile.message | polyglot }}',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const email = s.root.profileEmail;
                if (!email) return;
                // Mirror MemberProfile's Message action: stash the pending DM email
                // and route to /chat, which opens (or creates) the direct thread.
                s.root.update({
                    profileEmail: null,
                    profileModalTab: 'profile',
                    _pendingDmEmail: email
                });
                el.call('closeProfileModal');
                el.router('/chat', el.getRoot());
            }
        }
    }
};
const $48d8a3c7d1a558f9$export$8e04fb1b2685d773 = {
    tag: 'button',
    type: 'button',
    padding: 'Z A',
    borderWidth: '0',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: (el, s)=>(s.root.profileModalTab || 'profile') === el.tab ? 'blue' : 'transparent',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: (el, s)=>(s.root.profileModalTab || 'profile') === el.tab ? '700' : '500',
    color: (el, s)=>(s.root.profileModalTab || 'profile') === el.tab ? 'title' : 'caption',
    text: (el)=>el.call('polyglot', el.label || ''),
    marginBottom: '-1px',
    ':hover': {
        color: 'title'
    },
    onClick: (e, el, s)=>$48d8a3c7d1a558f9$var$_setTab(s.root, el.tab)
};
const $48d8a3c7d1a558f9$export$254e27c8362214eb = {
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    padding: 'Z 0',
    borderBottomWidth: 'hairline',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    ':last-child': {
        borderBottomWidth: '0'
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'caption',
        whiteSpace: 'nowrap',
        text: (el)=>el.call('polyglot', el.parent.label || '')
    },
    Value: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        align: 'center right',
        textAlign: 'right',
        // `_calendarTenure` can return a polyglot KEY ('… .tenureNew'); every other value
        // is real data, which translate() passes through unchanged.
        text: (el, s)=>{
            const p = el.call('findPerson', s.root.profileEmail);
            return el.call('polyglot', $48d8a3c7d1a558f9$var$_profileFieldValue(el, el.parent.field, p, s.root, el.call('getActiveLang')));
        }
    }
};
const $48d8a3c7d1a558f9$export$f1d2d1fdf29c68e4 = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'Y Z',
    round: 'radiusControl',
    background: 'red.10',
    TypeBadge: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        textTransform: 'uppercase',
        color: 'red',
        text: (el, s)=>s.type || ''
    },
    Title: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'title',
        flex: '1',
        text: (el, s)=>s.title || el.call('polyglot', 'calendar.profile.noTitle')
    },
    Range: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        fontFamily: 'monospace',
        text: (el, s)=>{
            if (s.endDate && s.endDate !== s.date) return `${s.date} \u{2192} ${s.endDate}`;
            return `${s.date} ${s.startTime || ''}\u{2013}${s.endTime || ''}`;
        }
    }
};
const $48d8a3c7d1a558f9$export$fc88702b5e91882b = {
    display: 'grid',
    // Bare `1fr` × 24 hour-columns floors each at its cell's own min-content
    // width, so the full 24-track row always summed wider than a narrow
    // container. `minmax(0, 1fr)` lets each hour column actually share the
    // available row width.
    gridTemplateColumns: 'auto repeat(24, minmax(0, 1fr))',
    gridTemplateRows: 'auto repeat(7, auto)',
    // `gap`/`padding` were a raw sub-token '1px' (design-system violation —
    // tokens only, no raw px). That wasn't just a token-grammar miss: verified
    // live (puppeteer DOM probe + screenshot) that each hour column renders at
    // ~15px wide holding a 2-char monospace label, so the true visual gap
    // between adjacent "00"/"01"/… cells collapsed to ~1px — legible as a
    // single unbroken run of digits, not 24 separated hour labels. `Y` is the
    // smallest step on the spacing scale — real breathing room between cells
    // without loosening the grid's compact, table-like density. `gridTemplateColumns`
    // itself is untouched (the `minmax(0, 1fr)` comment above is a prior,
    // deliberate overflow fix — don't reintroduce that bug by raising the floor).
    gap: 'Y',
    background: 'line',
    padding: 'Y',
    round: 'radiusControl',
    overflow: 'hidden',
    userSelect: 'none',
    Corner: {
        background: 'modal',
        padding: 'Y'
    },
    HourHeaders: {
        display: 'contents',
        childExtends: 'CalAvailabilityHourHeader',
        childrenAs: 'state',
        children: ()=>Array.from({
                length: 24
            }, (_, h)=>({
                    h: h
                }))
    },
    DayRows: {
        display: 'contents',
        // `DAYS` used to be a module-scope const read by this factory (frank
        // FA204 single-component-const — a value used by exactly one component
        // is better carried as `scope: {}` than a bare module-scope binding, no
        // globalScope indirection needed). See tickets/fable.md "workspace-
        // calendar frank serialization blockers".
        scope: {
            DAYS: [
                'Mon',
                'Tue',
                'Wed',
                'Thu',
                'Fri',
                'Sat',
                'Sun'
            ]
        },
        childExtends: 'CalAvailabilityDayRow',
        childrenAs: 'state',
        children: (el)=>el.scope.DAYS.map((label, day)=>({
                    day: day,
                    label: label
                }))
    }
};
const $48d8a3c7d1a558f9$export$fce0794b4ecf8225 = {
    tag: 'span',
    background: 'modal',
    fontSize: 'Y2',
    color: 'caption',
    fontFamily: 'monospace',
    textAlign: 'center',
    padding: 'Y 0',
    text: (el, s)=>String(s.h).padStart(2, '0')
};
const $48d8a3c7d1a558f9$export$d96962d9aac01c25 = {
    display: 'contents',
    Label: {
        tag: 'span',
        background: 'modal',
        fontSize: 'Y2',
        color: 'caption',
        fontWeight: '700',
        padding: 'Y Z',
        align: 'center right',
        text: (el, s)=>s.label
    },
    Cells: {
        display: 'contents',
        childExtends: 'CalAvailabilityCell',
        childrenAs: 'state',
        children: (el, s)=>Array.from({
                length: 24
            }, (_, h)=>({
                    day: s.day,
                    h: h
                }))
    }
};
const $48d8a3c7d1a558f9$export$1b163d240ec28289 = {
    tag: 'button',
    border: 'none',
    padding: '0',
    height: 'A',
    minHeight: 'A',
    background: (el, s)=>{
        const u = el.call('findPerson', el.state.root.profileEmail);
        return $48d8a3c7d1a558f9$var$_calendarIsAvailableAt(el, u, s.day, s.h) ? 'green' : 'red.15';
    },
    cursor: (el, s)=>$48d8a3c7d1a558f9$var$_canEditModal(el, el.state.root) ? 'pointer' : 'not-allowed',
    // Cell fill IS the data (green/red-tint) — a neutral 'hover' wash would
    // mute the signal, and it's too subtle to read per-cell in a 168-cell
    // grid. Hued-surface exception (§4.3): brightness step, not opacity.
    ':hover': {
        filter: 'brightness(1.12)'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        $48d8a3c7d1a558f9$var$_toggleCell(el, el.state.root, s.day, s.h);
    }
};

});

parcelRegister("1SaYL", function(module, exports) {

$parcel$export(module.exports, "CalNewBookingModal", () => $15d359c810f8105d$export$c2d401d9c416097e);
$parcel$export(module.exports, "CalInviteePill", () => $15d359c810f8105d$export$acc6bf04a7c29c01);
$parcel$export(module.exports, "CalInviteeSuggestion", () => $15d359c810f8105d$export$41615fa952c1c359);
$parcel$export(module.exports, "CalVisibilityBtn", () => $15d359c810f8105d$export$b9957715013c29f9);
$parcel$export(module.exports, "CalRecurringBtn", () => $15d359c810f8105d$export$4f357a2a359e39e2);
$parcel$export(module.exports, "CalEndRepeatSection", () => $15d359c810f8105d$export$c251eba12ab2eccf);
$parcel$export(module.exports, "CalEndRepeatBtn", () => $15d359c810f8105d$export$69609936aa838017);
$parcel$export(module.exports, "CalRecurringDayBtn", () => $15d359c810f8105d$export$a34c15ffbdceb0e0);
$parcel$export(module.exports, "CalEventTypeBtn", () => $15d359c810f8105d$export$6c0e414e73929102);
$parcel$export(module.exports, "CalConfirmMoveModal", () => $15d359c810f8105d$export$3751014e41a4a015);
$parcel$export(module.exports, "CalMeetingModeBtn", () => $15d359c810f8105d$export$508fbd55d4b2b137);
$parcel$export(module.exports, "_genMeetLink", () => $15d359c810f8105d$export$2a59fa0458407049);
// Every calendar function arrives through `el.call`, never an import (FA001):
// a relative sibling import is inlined into this component file by the
// bundler, so frank publishes a body whose identifier resolves to nothing, and
// the deep `@symbo-ls/workspace-calendar/functions/calendarUtils.js`
// bare-package subpath self-imports this package's own barrel and throws a
// circular-import TDZ crash (confirmed live via `bun test`) — see
// QuickCreate.js's note. CalNewBookingModal is EAGER and its shell-root opener
// fires on routes that never fold the calendar context, so every key it calls
// is registered by functions/eagerSlice.js as well as functions/index.js.
// peopleUtils.js/workspacePrefix.js stay the ORIGINAL deep `@symbo-ls/
// workspace-shared` subpaths on purpose: the bare package root pulls in
// shared's ENTIRE components+functions+state barrel, which live-reproduced
// a SEPARATE circular-import TDZ crash against `workspace/functions/
// featureFlags.js` (confirmed via `bun test`) — see EventDetailModal.js's
// note for the full explanation.
// Role helpers come straight from the workspace-shell library, not through
// calendarUtils.js: that module no longer re-exports them (frank FA206
// stub-phantom — a bag re-export of an externalized value publishes as "").

var $aGIjc = parcelRequire("aGIjc");

var $76fm2 = parcelRequire("76fm2");

var $9juhh = parcelRequire("9juhh");
// True when /calendar is the active route (accounting for the optional
// `/w/<org>` Scheme-A prefix). Now that this modal is a global windows-layer
// component, SaveBtn's create path can fire from anywhere — this gates the
// optimistic `root.events` push so it doesn't fabricate a one-item "loaded"
// list on a route where nothing renders it. See its call site below.
const $15d359c810f8105d$var$_onCalendarRoute = (root)=>{
    if (typeof window === 'undefined') return false;
    const path = (0, $9juhh.stripWorkspacePrefix)(root?.currentPath ?? window.location.pathname);
    return path === '/calendar';
};
// Event types shown in the picker. `adminOnly` types are filtered out for
// non-admin users. The picker uses a colored dot (not the full pill bg) so
// it doesn't visually compete with the form fields.
// `label` carries a polyglot KEY — CalEventTypeBtn resolves it at its render
// site (I18N-CONVENTION §5, data-driven labels).
const $15d359c810f8105d$var$EVENT_TYPES = [
    {
        type: 'meeting',
        label: 'calendar.type.meeting',
        color: 'green'
    },
    // Company event ("general") used to be admin-only in the picker, but the
    // role data isn't flowing into root.people yet — gating it here makes the
    // type invisible to everyone, including superadmin. RLS on the calendar
    // table is the real enforcement layer.
    {
        type: 'general',
        label: 'calendar.type.general',
        color: 'blue'
    },
    {
        type: 'busy',
        label: 'calendar.type.busy',
        color: 'red'
    }
];
// Reminder dropdown options. Hoisted so the select doesn't allocate a fresh
// array per render — also keeps the label set in one place if/when the
// `reminder_minutes` server column lands and more presets get added.
const $15d359c810f8105d$var$REMINDER_OPTIONS = [
    {
        value: '',
        label: 'calendar.reminder.none'
    },
    {
        value: '5',
        label: 'calendar.reminder.min5'
    },
    {
        value: '10',
        label: 'calendar.reminder.min10'
    },
    {
        value: '15',
        label: 'calendar.reminder.min15'
    },
    {
        value: '30',
        label: 'calendar.reminder.min30'
    },
    {
        value: '60',
        label: 'calendar.reminder.hour1'
    },
    {
        value: '240',
        label: 'calendar.reminder.hour4'
    },
    {
        value: '480',
        label: 'calendar.reminder.hour8'
    },
    {
        value: '720',
        label: 'calendar.reminder.hour12'
    },
    {
        value: '1440',
        label: 'calendar.reminder.day1'
    }
];
const $15d359c810f8105d$var$INVITEE_SUGGESTION_LIMIT = 6;
const $15d359c810f8105d$var$BOOKING_FORM_MINUTES_PER_HOUR = 60;
const $15d359c810f8105d$var$BOOKING_FORM_HOURS_PER_DAY = 24;
const $15d359c810f8105d$var$BOOKING_FORM_DEFAULT_DURATION_MINUTES = $15d359c810f8105d$var$BOOKING_FORM_MINUTES_PER_HOUR;
const $15d359c810f8105d$var$_notifyInvalidRange = (el)=>{
    el.call('openNotification', {
        type: 'error',
        title: el.call('polyglot', 'calendar.save.invalidRangeTitle'),
        message: el.call('polyglot', 'calendar.save.invalidRangeMessage')
    });
};
const $15d359c810f8105d$var$_notifyPastBooking = (el)=>{
    el.call('openNotification', {
        type: 'error',
        title: el.call('polyglot', 'calendar.save.pastTitle'),
        message: el.call('polyglot', 'calendar.save.pastMessage')
    });
};
// --- Invitees autocomplete helpers -----------------------------------------
// `invitees` is the comma-separated list of accepted emails (each one a pill).
// `inviteeQuery` is the in-progress text in the input — drives suggestions
// but is NOT yet committed.
const $15d359c810f8105d$var$_selectedEmails = (root)=>{
    const inv = root?.newBooking?.invitees || '';
    return inv.split(',').map((x)=>x.trim()).filter(Boolean);
};
const $15d359c810f8105d$var$_selectedPeople = (el, root)=>{
    if (!root) return [];
    const emails = new Set($15d359c810f8105d$var$_selectedEmails(root));
    const memberKeys = new Set(root.newBooking?.inviteeMemberKeys || []);
    return (root.people || []).filter((person)=>emails.has(person.email) || memberKeys.has(el.call('calendarTeamMemberKey', person)));
};
// Filter people by the current query text, excluding already-selected ones.
// With no query, keep the picker useful by showing the first available people.
const $15d359c810f8105d$var$_filterPeople = (el, root, query = root?.newBooking?.inviteeQuery)=>{
    const q = String(query || '').trim().toLowerCase();
    const selected = new Set($15d359c810f8105d$var$_selectedEmails(root).map((email)=>email.toLowerCase()));
    const selectedMemberKeys = new Set(root?.newBooking?.inviteeMemberKeys || []);
    return (root.people || []).filter((p)=>!selected.has(String(p.email || '').toLowerCase()) && !selectedMemberKeys.has(el.call('calendarTeamMemberKey', p)) && (!q || String(p.name || '').toLowerCase().includes(q) || String(p.email || '').toLowerCase().includes(q))).slice(0, $15d359c810f8105d$var$INVITEE_SUGGESTION_LIMIT);
};
// Append a person's email as a pill, clear the in-progress query, keep focus.
const $15d359c810f8105d$var$_addInvitee = (el, root, person)=>{
    if (!person) return;
    const cur = $15d359c810f8105d$var$_selectedEmails(root);
    const memberKey = el.call('calendarTeamMemberKey', person);
    const inviteeMemberKeys = [
        ...root.newBooking?.inviteeMemberKeys || []
    ];
    const email = String(person.email || '').trim();
    if (!email && !memberKey) return;
    if (email && cur.some((selectedEmail)=>selectedEmail.toLowerCase() === email.toLowerCase()) || memberKey && inviteeMemberKeys.includes(memberKey)) return;
    const next = email ? [
        ...cur,
        email
    ].join(', ') : cur.join(', ');
    if (memberKey && !inviteeMemberKeys.includes(memberKey)) inviteeMemberKeys.push(memberKey);
    root.update({
        newBooking: {
            ...root.newBooking,
            invitees: next,
            inviteeMemberKeys: inviteeMemberKeys,
            inviteeQuery: ''
        }
    });
};
// Loose RFC-5322-ish email check — strict enough to reject typos, lax enough
// to accept anything postmaster-shaped.
const $15d359c810f8105d$var$_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const $15d359c810f8105d$var$_isEmail = (s)=>$15d359c810f8105d$var$_EMAIL_RE.test(s.trim());
// Remove a pill by email.
const $15d359c810f8105d$var$_removeInvitee = (root, email, memberKey)=>{
    const next = $15d359c810f8105d$var$_selectedEmails(root).filter((e)=>e !== email).join(', ');
    const inviteeMemberKeys = (root.newBooking?.inviteeMemberKeys || []).filter((key)=>key !== memberKey);
    root.update({
        newBooking: {
            ...root.newBooking,
            invitees: next,
            inviteeMemberKeys: inviteeMemberKeys,
            inviteePickerOpen: false
        }
    });
};
// Backspace on empty input removes the last pill.
const $15d359c810f8105d$var$_popInvitee = (root)=>{
    const cur = $15d359c810f8105d$var$_selectedEmails(root);
    if (!cur.length) return;
    cur.pop();
    root.update({
        newBooking: {
            ...root.newBooking,
            invitees: cur.join(', ')
        }
    });
};
const $15d359c810f8105d$var$_oneHourAfter = (time)=>{
    const [hours = 0, minutes = 0] = String(time || '00:00').split(':').map(Number);
    const next = (hours * $15d359c810f8105d$var$BOOKING_FORM_MINUTES_PER_HOUR + minutes + $15d359c810f8105d$var$BOOKING_FORM_DEFAULT_DURATION_MINUTES) % ($15d359c810f8105d$var$BOOKING_FORM_HOURS_PER_DAY * $15d359c810f8105d$var$BOOKING_FORM_MINUTES_PER_HOUR);
    return `${String(Math.floor(next / $15d359c810f8105d$var$BOOKING_FORM_MINUTES_PER_HOUR)).padStart(2, '0')}:${String(next % $15d359c810f8105d$var$BOOKING_FORM_MINUTES_PER_HOUR).padStart(2, '0')}`;
};
const $15d359c810f8105d$var$_nextDate = (date)=>{
    if (!date) return '';
    const [year, month, day] = date.split('-').map(Number);
    const next = new Date(year, month - 1, day + 1);
    const pad = (value)=>String(value).padStart(2, '0');
    return `${next.getFullYear()}-${pad(next.getMonth() + 1)}-${pad(next.getDate())}`;
};
const $15d359c810f8105d$var$_endAfterStart = (date, startTime)=>{
    const endTime = $15d359c810f8105d$var$_oneHourAfter(startTime);
    return {
        endTime: endTime,
        endDate: endTime <= startTime ? $15d359c810f8105d$var$_nextDate(date) : date
    };
};
const $15d359c810f8105d$var$_inviteeIsUnavailable = (el, root, person)=>{
    const nb = root?.newBooking;
    if (!nb?.date || !nb.startTime || !nb.endTime || !person) return false;
    const startMs = el.call('eventUtcMs', nb.date, nb.startTime);
    let endMs = el.call('eventUtcMs', nb.endDate || nb.date, nb.endTime);
    if (!startMs || !endMs) return false;
    if (endMs <= startMs) endMs += 86400000;
    const durationMinutes = Math.ceil((endMs - startMs) / 60000);
    const events = (root.events || []).filter((event)=>event.id !== nb.editingEventId);
    return el.call('getUnavailableRanges', person, startMs, durationMinutes, 1, events).length > 0;
};
const $15d359c810f8105d$export$c2d401d9c416097e = {
    // Let the parent window's content box determine the width. A forced 100%
    // here was added on top of the window padding and created horizontal
    // overflow at the bottom of the form.
    maxWidth: 'I',
    // The outer @symbo.ls/windows ModalWindow chrome doesn't give the content
    // its own flex layout (unlike the old brand ModalWindow this used to
    // extend via `Window`) — flow:'y' + gap are what stack ModalHeader /
    // Fields / ModalFooter / ScopePicker with breathing room between them.
    flow: 'y',
    // Cap to the viewport + scroll internally so the title (top) and the Save
    // action (bottom) stay reachable. The edit form is tall enough to overflow
    // a fit-content window, which clipped BOTH ends (title cut off, Save below
    // the fold + unreachable, wheel fell through to the page) — 2026-06-10 fix
    // per Nika "fix editing event".
    maxHeight: '88dvh',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingLeft: 'Z',
    paddingRight: 'Z',
    gap: 'Z1',
    ModalHeader: {
        Hgroup: {
            H: {
                text: (el, s)=>el.call('polyglot', s.root?.newBooking?.editingEventId ? 'calendar.booking.headingEdit' : 'calendar.booking.headingNew')
            },
            P: {
                text: (el, s)=>el.call('polyglot', s.root?.newBooking?.editingEventId ? 'calendar.booking.subtitleEdit' : 'calendar.booking.subtitleNew')
            }
        },
        // Override the inherited Close.onClick to dispatch the windows-layer
        // close — this component no longer has a `stateKey` for the generic
        // `closeModal()` walk-up to find, so without this override the X would
        // fall through to "pop whatever's on top of the ModalRoot stack"
        // instead of this specific layer. Same fix as CalProfileModal /
        // CalEventDetailModal.
        Icons: {
            // Brand ModalHeader pulls this set upward/right with negative margins.
            // Keep it inside this scrollable modal so the Close hover wash is not
            // clipped by the content boundary.
            margin: '0 0 - auto',
            // Delete shows on an edit only, and only to whoever may write the
            // event (calendarCanWriteEvent, the server rule). A row this view has
            // not loaded keeps it: the server still refuses a write it does not
            // allow, and a failed delete puts the row back.
            DeleteBtn: {
                extends: 'IconButton',
                display: (el, s)=>{
                    const id = s.root?.newBooking?.editingEventId;
                    if (!id) return 'none';
                    const row = (s.root?.events || []).find((item)=>item.id === id);
                    return !row || el.call('calendarCanWriteEvent', row, s.root) ? 'flex' : 'none';
                },
                padding: 'Y2',
                round: 'radiusPill',
                'aria-label': (el)=>el.call('polyglot', 'calendar.booking.deleteEvent'),
                title: (el)=>el.call('polyglot', 'calendar.booking.deleteEvent'),
                Icon: {
                    name: 'trash'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const id = s.root?.newBooking?.editingEventId;
                    if (!id) return;
                    const event = (s.root?.events || []).find((item)=>item.id === id) || {
                        id: id,
                        title: s.root?.newBooking?.title
                    };
                    // The edit modal edits the SOURCE row and carries no occurrence
                    // context, so its delete is series-scoped: plain confirm, whole
                    // row — never the occurrence/future options (which would exclude
                    // the ANCHOR date or hard-delete the series from it).
                    el.call('confirmEventDeletion', el, s.root, event, 'closeNewBookingModal', {
                        scope: 'series'
                    });
                }
            },
            Close: {
                extends: 'IconButton',
                'aria-label': (el)=>el.call('polyglot', 'calendar.booking.close'),
                title: (el)=>el.call('polyglot', 'calendar.booking.close'),
                Icon: {
                    name: 'close'
                },
                onClick: (e, el)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    el.call('closeNewBookingModal');
                }
            }
        }
    },
    Fields: {
        flow: 'y',
        gap: 'B',
        // Every field is the shared field kit (AppField + AppInput/AppSelect/
        // AppTextarea, workspace-shared components/AppField.js): the caption
        // label above the control, the brand `field` fill with the hairline
        // edge, the global focus ring. The control carries behaviour only —
        // values, handlers, focus logic; the kit owns the look.
        TitleField: {
            extends: 'AppField',
            label: (el)=>el.call('polyglot', 'calendar.booking.fieldTitle'),
            AppInput: {
                type: 'text',
                placeholder: (el)=>el.call('polyglot', 'calendar.booking.titlePlaceholder'),
                autofocus: true,
                value: (el, s)=>s.root?.newBooking?.title || '',
                // The DOM autofocus attribute only fires once on first mount —
                // when the modal re-opens (display flips none→flex) the existing
                // element doesn't refocus. Refocus only on the false→true edge of
                // `showNewBooking` so we don't fight the user when they click out
                // of the title field mid-edit.
                onCreate: (el)=>{
                    el._wasOpen = false;
                    requestAnimationFrame(()=>{
                        el.node?.focus?.();
                    });
                },
                onUpdate: (el, s)=>{
                    const open = !!s.root?.showNewBooking;
                    if (open && !el._wasOpen) requestAnimationFrame(()=>{
                        el.node?.focus?.();
                    });
                    el._wasOpen = open;
                },
                onInput: (e, el, s)=>{
                    s.root.update({
                        newBooking: {
                            ...s.root?.newBooking,
                            title: e.target.value
                        }
                    });
                }
            }
        },
        TypePicker: {
            flow: 'x',
            gap: 'Y',
            align: 'center left',
            flexWrap: 'wrap',
            childExtends: 'CalEventTypeBtn',
            childrenAs: 'state',
            children: (el, s)=>{
                const admin = el.call('isAdmin');
                return $15d359c810f8105d$var$EVENT_TYPES.filter((t)=>admin || !t.adminOnly);
            }
        },
        // No `colorScheme` here, nor on any field below: the native date and time
        // pickers take the theme's own color-scheme, which the framework mirrors
        // onto the document root with every theme (scratch set.js). A `dark` pin
        // from the dark-only era painted the pickers' dark icons and popups on
        // the light `field` fill in the light theme.
        DateRow: {
            flow: 'x',
            gap: 'Z',
            width: 'fit-content',
            maxWidth: '100%',
            DateField: {
                extends: 'AppField',
                flex: '2',
                minWidth: '0',
                label: (el)=>el.call('polyglot', 'calendar.booking.fieldStartDate'),
                AppInput: {
                    type: 'date',
                    min: (el, s)=>s.root?.newBooking?.editingEventId ? undefined : el.call('todayISO'),
                    value: (el, s)=>s.root?.newBooking?.date || '',
                    onInput: (e, el, s)=>{
                        const booking = s.root?.newBooking || {};
                        const endDate = !booking.endDate || booking.endDate === booking.date ? e.target.value : booking.endDate;
                        s.root.update({
                            newBooking: {
                                ...booking,
                                date: e.target.value,
                                endDate: endDate
                            }
                        });
                    }
                }
            },
            TimeRow: {
                flow: 'x',
                flex: '1',
                gap: 'Z',
                width: 'fit-content',
                maxWidth: '100%',
                childExtends: 'AppField',
                StartField: {
                    flex: 'none',
                    minWidth: '0',
                    '@mobileM': {
                        flex: '1',
                        width: 'auto'
                    },
                    label: (el)=>el.call('polyglot', 'calendar.booking.fieldStart'),
                    AppInput: {
                        type: 'time',
                        min: (el, s)=>!s.root?.newBooking?.editingEventId && s.root?.newBooking?.date === el.call('todayISO') ? `${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}` : undefined,
                        value: (el, s)=>s.root?.newBooking?.startTime || '09:00',
                        onInput: (e, el, s)=>{
                            const booking = s.root?.newBooking || {};
                            s.root.update({
                                newBooking: {
                                    ...booking,
                                    startTime: e.target.value,
                                    ...$15d359c810f8105d$var$_endAfterStart(booking.date, e.target.value)
                                }
                            });
                        }
                    }
                },
                EndField: {
                    flex: 'none',
                    minWidth: '0',
                    '@mobileM': {
                        flex: '1',
                        width: 'auto'
                    },
                    label: (el)=>el.call('polyglot', 'calendar.booking.fieldEnd'),
                    AppInput: {
                        type: 'time',
                        value: (el, s)=>s.root?.newBooking?.endTime || '10:00',
                        onInput: (e, el, s)=>{
                            const booking = s.root?.newBooking || {};
                            let endDate = booking.endDate || booking.date;
                            if (e.target.value <= booking.startTime && endDate <= booking.date) endDate = $15d359c810f8105d$var$_nextDate(booking.date);
                            s.root.update({
                                newBooking: {
                                    ...booking,
                                    endTime: e.target.value,
                                    endDate: endDate
                                }
                            });
                        }
                    }
                },
                EndDateField: {
                    flex: '2',
                    minWidth: '0',
                    label: (el)=>el.call('polyglot', 'calendar.booking.fieldEndDate'),
                    AppInput: {
                        type: 'date',
                        min: (el, s)=>s.root?.newBooking?.date || el.call('todayISO'),
                        value: (el, s)=>s.root?.newBooking?.endDate || s.root?.newBooking?.date || '',
                        onInput: (e, el, s)=>{
                            s.root.update({
                                newBooking: {
                                    ...s.root?.newBooking,
                                    endDate: e.target.value
                                }
                            });
                        }
                    }
                },
                '@mobileM': {
                    width: '100%'
                }
            },
            '@mobileM': {
                flow: 'y'
            }
        },
        // Meeting location row — only shown for meeting/general events.
        // Three-option picker: Symbols Meet, External URL, Offline.
        MeetingModeRow: {
            flow: 'y',
            gap: 'Z',
            display: (el, s)=>{
                const t = s.root?.newBooking?.type || 'meeting';
                return t === 'meeting' || t === 'general' ? 'flex' : 'none';
            },
            ModePicker: {
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                childExtends: 'CalMeetingModeBtn',
                childrenAs: 'state',
                children: [
                    {
                        mode: 'symbols-meet',
                        label: 'calendar.mode.symbolsMeet',
                        icon: 'video'
                    },
                    {
                        mode: 'external-url',
                        label: 'calendar.mode.externalUrl',
                        icon: 'link'
                    },
                    {
                        mode: 'offline',
                        label: 'calendar.mode.offline',
                        icon: 'pin'
                    }
                ]
            },
            UrlField: {
                extends: 'AppField',
                display: (el, s)=>{
                    const m = s.root?.newBooking?.meetingMode || 'symbols-meet';
                    return m === 'external-url' ? 'flex' : 'none';
                },
                label: (el)=>el.call('polyglot', 'calendar.booking.fieldMeetingUrl'),
                AppInput: {
                    type: 'url',
                    placeholder: (el)=>el.call('polyglot', 'calendar.booking.urlPlaceholder'),
                    value: (el, s)=>s.root?.newBooking?.meetUrl || '',
                    onInput: (e, el, s)=>{
                        s.root.update({
                            newBooking: {
                                ...s.root?.newBooking,
                                meetUrl: e.target.value
                            }
                        });
                    }
                }
            }
        },
        VisibilityRow: null,
        // Invitees: a plain text input on top, and the selected invitees rendered
        // as a separate grid of cards below. The input never holds pills — picking
        // a suggestion (or pressing Enter) adds the person to the grid and clears
        // the input. The suggestions dropdown is anchored to the input field.
        InviteesField: {
            extends: 'AppField',
            position: 'relative',
            onMousedown: (e, el, s)=>{
                const target = e.target;
                if (el.AppInput?.node?.contains(target) || el.Suggestions?.node?.contains(target)) return;
                s.root.update({
                    newBooking: {
                        ...s.root?.newBooking,
                        inviteePickerOpen: false
                    }
                });
            },
            label: (el)=>el.call('polyglot', 'calendar.booking.fieldInvitees'),
            AppInput: {
                type: 'text',
                'aria-label': '{{ calendar.booking.fieldInvitees | polyglot }}',
                placeholder: (el, s)=>$15d359c810f8105d$var$_selectedEmails(s.root).length ? '' : el.call('polyglot', 'calendar.booking.inviteesPlaceholder'),
                attr: {
                    autocomplete: 'off',
                    spellcheck: 'false'
                },
                value: (el, s)=>s.root?.newBooking?.inviteeQuery || '',
                onFocus: (e)=>{
                    try {
                        e.target.select();
                    } catch (_) {}
                },
                onClick: (e, el, s)=>{
                    if (s.root?.newBooking?.inviteePickerOpen) return;
                    s.root.update({
                        newBooking: {
                            ...s.root?.newBooking,
                            inviteePickerOpen: true
                        }
                    });
                },
                onInput: (e, el, s)=>{
                    s.root.update({
                        newBooking: {
                            ...s.root?.newBooking,
                            inviteeQuery: e.target.value
                        }
                    });
                },
                onKeydown: (e, el, s)=>{
                    const root = s.root;
                    const q = String(e.target?.value ?? root.newBooking?.inviteeQuery ?? '').trim();
                    if ((e.key === 'Backspace' || e.key === 'Delete') && q === '') {
                        e.preventDefault();
                        $15d359c810f8105d$var$_popInvitee(root);
                        return;
                    }
                    if (e.key === 'Tab' || e.key === 'Enter' || e.key === ',') {
                        // Prefer the first autocomplete suggestion (known team member),
                        // otherwise fall back to the raw query if it's a valid email —
                        // that's how external attendees get added.
                        const matches = $15d359c810f8105d$var$_filterPeople(el, root, q);
                        if (matches.length) {
                            e.preventDefault();
                            $15d359c810f8105d$var$_addInvitee(el, root, matches[0]);
                        } else if ($15d359c810f8105d$var$_isEmail(q)) {
                            e.preventDefault();
                            $15d359c810f8105d$var$_addInvitee(el, root, {
                                email: q
                            });
                        }
                    }
                },
                onBlur: (e, el, s)=>{
                    // Commit a pending external email when the user clicks away
                    // without pressing Enter.
                    const q = (s.root?.newBooking?.inviteeQuery || '').trim();
                    if ($15d359c810f8105d$var$_isEmail(q) && !$15d359c810f8105d$var$_filterPeople(el, s.root).length) $15d359c810f8105d$var$_addInvitee(el, s.root, {
                        email: q
                    });
                    s.root.update({
                        newBooking: {
                            ...s.root?.newBooking,
                            inviteePickerOpen: false
                        }
                    });
                }
            },
            // Selected invitees wrap below the input to keep names easy to scan.
            SelectedGrid: {
                display: (el, s)=>$15d359c810f8105d$var$_selectedPeople(el, s.root).length ? 'flex' : 'none',
                flow: 'x',
                align: 'center left',
                flexWrap: 'wrap',
                gap: 'Y',
                marginTop: 'Y',
                SelectedItems: {
                    display: 'contents',
                    childExtends: 'CalInviteePill',
                    childrenAs: 'state',
                    children: (el, s)=>$15d359c810f8105d$var$_selectedPeople(el, s.root),
                    onClick: (e, el, s)=>{
                        s.root.update({
                            newBooking: {
                                ...s.root?.newBooking,
                                inviteePickerOpen: false
                            }
                        });
                    }
                },
                DismissArea: {
                    tag: 'button',
                    type: 'button',
                    flex: '1',
                    alignSelf: 'stretch',
                    minWidth: '0',
                    minHeight: 'B',
                    padding: '0',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'default',
                    tabIndex: -1,
                    'aria-hidden': 'true',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        s.root.update({
                            newBooking: {
                                ...s.root?.newBooking,
                                inviteePickerOpen: false
                            }
                        });
                    }
                }
            },
            Suggestions: {
                display: (el, s)=>s.root?.newBooking?.inviteePickerOpen && $15d359c810f8105d$var$_filterPeople(el, s.root).length ? 'flex' : 'none',
                position: 'absolute',
                top: '100%',
                left: '0',
                right: '0',
                marginTop: 'Y',
                flow: 'y',
                theme: 'modal',
                borderWidth: 'hairline',
                borderColor: 'line',
                borderStyle: 'solid',
                round: 'radiusControl',
                boxShadow: '0 8px 24px var(--color-shadow)',
                maxHeight: 'G',
                overflowY: 'auto',
                zIndex: 10,
                childExtends: 'CalInviteeSuggestion',
                childrenAs: 'state',
                children: (el, s)=>$15d359c810f8105d$var$_filterPeople(el, s.root)
            }
        },
        DescriptionField: {
            extends: 'AppField',
            label: (el)=>el.call('polyglot', 'calendar.booking.fieldDescription'),
            AppTextarea: {
                placeholder: (el)=>el.call('polyglot', 'calendar.booking.descriptionPlaceholder'),
                rows: 4,
                value: (el, s)=>s.root?.newBooking?.description || '',
                onInput: (e, el, s)=>{
                    s.root.update({
                        newBooking: {
                            ...s.root?.newBooking,
                            description: e.target.value
                        }
                    });
                }
            }
        },
        // Reminder picker — minutes before the event when the user wants
        // to be notified. Stored as `reminderMinutes` (number | null) on
        // newBooking; null = no reminder. Server-side persistence depends
        // on a calendar_events.reminder_minutes column not yet shipped —
        // until then this field round-trips through the booking shape but
        // does not survive a page reload. See tickets/server.md for the
        // SERVER ticket "Calendar event reminder_minutes column". (#2200)
        // The select is the kit's AppSelect with its native arrow — the local
        // `appearance: none` + absolutely-placed chevron icon (tuned to the old
        // label height) left with the rest of the local look.
        ReminderField: {
            extends: 'AppField',
            label: (el)=>el.call('polyglot', 'calendar.booking.fieldReminder'),
            AppSelect: {
                value: (el, s)=>{
                    const v = s.root?.newBooking?.reminderMinutes;
                    return v == null ? '' : String(v);
                },
                onChange: (e, el, s)=>{
                    const raw = e.target.value;
                    const next = raw === '' ? null : Number(raw);
                    s.root.update({
                        newBooking: {
                            ...s.root?.newBooking,
                            reminderMinutes: next
                        }
                    });
                },
                // `children` with `state` carries the option list. Using flat
                // children keeps the DOM declarative and avoids hardcoding
                // values in the parent component.
                childExtends: {
                    tag: 'option',
                    value: (el, s)=>s.value,
                    text: (el, s)=>el.call('polyglot', s.label)
                },
                childrenAs: 'state',
                children: $15d359c810f8105d$var$REMINDER_OPTIONS
            }
        },
        // Apple-style recurring picker — segmented presets + day toggles
        // when "Weekly" is selected.
        //
        // The section is a kit field (AppField), so its "Repeat" caption is the
        // kit's caption like every other field's in this modal — it was a local
        // span at the control's own size. A `div`, not the kit's `<label>`: a
        // click on a label caption would press its first preset chip. The chip
        // row is a group named by the same caption. The section keeps its own
        // `Z` row gap between its rows (the kit field's is `Y`).
        RecurringSection: {
            extends: 'AppField',
            tag: 'div',
            gap: 'Z',
            label: (el)=>el.call('polyglot', 'calendar.booking.fieldRepeat'),
            Presets: {
                role: 'group',
                ariaLabel: (el)=>el.call('polyglot', 'calendar.booking.fieldRepeat'),
                flow: 'x',
                gap: 'Y',
                flexWrap: 'wrap',
                childExtends: 'CalRecurringBtn',
                childrenAs: 'state',
                children: [
                    {
                        value: 'none',
                        label: 'calendar.repeat.never'
                    },
                    {
                        value: 'daily',
                        label: 'calendar.repeat.daily'
                    },
                    {
                        value: 'weekly',
                        label: 'calendar.repeat.weekly'
                    },
                    {
                        value: 'biweekly',
                        label: 'calendar.repeat.biweekly'
                    },
                    {
                        value: 'monthly',
                        label: 'calendar.repeat.monthly'
                    },
                    {
                        value: 'yearly',
                        label: 'calendar.repeat.yearly'
                    }
                ]
            },
            // Day-of-week toggles, only visible when Weekly is picked. Allows
            // multi-select like Apple Calendar's custom rule (e.g. Mon/Wed/Fri).
            DayToggles: {
                display: (el, s)=>s.root?.newBooking?.recurring === 'weekly' ? 'flex' : 'none',
                flow: 'x',
                gap: 'Y',
                marginTop: 'Y',
                childExtends: 'CalRecurringDayBtn',
                childrenAs: 'state',
                children: [
                    {
                        dow: 1,
                        label: 'calendar.dayInitial.mon'
                    },
                    {
                        dow: 2,
                        label: 'calendar.dayInitial.tue'
                    },
                    {
                        dow: 3,
                        label: 'calendar.dayInitial.wed'
                    },
                    {
                        dow: 4,
                        label: 'calendar.dayInitial.thu'
                    },
                    {
                        dow: 5,
                        label: 'calendar.dayInitial.fri'
                    },
                    {
                        dow: 6,
                        label: 'calendar.dayInitial.sat'
                    },
                    {
                        dow: 0,
                        label: 'calendar.dayInitial.sun'
                    }
                ]
            },
            EndRepeatSection: {
                extends: 'CalEndRepeatSection'
            }
        }
    },
    ModalFooter: {
        flow: 'x',
        gap: 'Z1',
        padding: '- - A',
        childExtends: 'Button',
        SaveBtn: {
            theme: 'primary',
            padding: 'A B',
            text: (el, s)=>el.call('polyglot', s.root?.newBooking?.editingEventId ? 'calendar.booking.update' : 'calendar.booking.save'),
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const root = s.root;
                // For recurring events, show scope picker before saving
                const nb = root.newBooking || {};
                if (!nb.editingEventId && el.call('calendarBookingStartsInPast', nb)) {
                    $15d359c810f8105d$var$_notifyPastBooking(el);
                    return;
                }
                if (el.call('calendarBookingHasInvalidRange', nb)) {
                    $15d359c810f8105d$var$_notifyInvalidRange(el);
                    return;
                }
                if (nb.editingEventId) {
                    const orig = (root.events || []).find((ev)=>ev.id === nb.editingEventId);
                    const baseId = orig?.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '');
                    const hasSiblings = baseId && (root.events || []).some((ev)=>ev.id !== nb.editingEventId && ev.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '') === baseId);
                    if (hasSiblings && !nb._saveScope) {
                        root.update({
                            newBooking: {
                                ...nb,
                                _showScopePicker: true
                            }
                        });
                        return;
                    }
                }
                // Date is the only hard requirement; title is optional (e.g. for
                // a quick "busy" block where the type is enough context).
                if (!nb.date) return;
                const inviteesArr = (nb.invitees || '').split(',').map((x)=>x.trim()).filter(Boolean);
                const type = nb.type || 'meeting';
                // Busy/unavailable blocks render via the per-user unavailable layer
                // (`getUnavailableRanges`), which only picks up an event if the
                // viewer is in its invitees list. Stamp the creator so the event
                // shows up on their own column without manual self-invite.
                if (type === 'busy' && root.currentUserEmail && !inviteesArr.includes(root.currentUserEmail)) inviteesArr.push(root.currentUserEmail);
                const recurrence = el.call('recurrencePayloadFromBooking', nb);
                const meetingMode = nb.meetingMode || 'symbols-meet';
                // External URL meetings: append the provided link to description.
                // Symbols Meet rooms are created asynchronously after Supabase save.
                let description = nb.description || '';
                if ((type === 'meeting' || type === 'general') && meetingMode === 'external-url') {
                    const link = nb.meetUrl && nb.meetUrl.trim();
                    if (link && !description.includes(link)) description = description ? `${description}\n${link}` : link;
                }
                // Re-use the canonical `freshBooking(overrides)` factory so the
                // reset shape stays in sync with calendar utils (was drifting:
                // the inline copy here needed a manual `reminderMinutes: null`
                // patch for #2200, while `freshBooking` already had it). Date
                // is preserved so a follow-up booking on the same day starts on
                // the same day instead of jumping to the unset baseline.
                const resetBooking = el.call('freshBooking', {
                    date: nb.date
                });
                // Reminder field (#2200) — round-trips through the optimistic
                // event. NOTE: server-side calendar_events table does not yet
                // have a reminder_minutes column, so the value will not survive
                // a page reload until the SERVER ticket lands. saveEvent
                // will surface a clear error in the console if the upsert
                // rejects the field.
                const reminderMinutes = nb.reminderMinutes == null || nb.reminderMinutes === '' ? null : Number(nb.reminderMinutes);
                const payload = {
                    title: nb.title?.trim() || el.call('polyglot', 'calendar.booking.defaultTitle'),
                    date: nb.date,
                    endDate: nb.endDate || nb.date,
                    startTime: nb.startTime || '09:00',
                    endTime: nb.endTime || '10:00',
                    allDay: !!nb.allDay,
                    type: type,
                    meetingMode: meetingMode,
                    ...recurrence,
                    integrationMetadata: {
                        ...nb.integrationMetadata || {},
                        calendarInviteeMemberKeys: nb.inviteeMemberKeys || []
                    },
                    description: description,
                    invitees: inviteesArr,
                    reminderMinutes: reminderMinutes,
                    // Stamp the creator on first save so the move/resize permission
                    // model can tell creator from participant later. Edits keep the
                    // existing creator.
                    creatorEmail: nb.editingEventId ? root.events?.find((ev)=>ev.id === nb.editingEventId)?.creatorEmail || root.currentUserEmail : root.currentUserEmail,
                    // Privacy stamp: superadmin events (except company-wide) and
                    // anything created by an external party are marked private so
                    // other viewers see them as a generic Unavailable block.
                    isPrivate: el.call('shouldStampPrivate', (0, $aGIjc.currentUser)(root) || {
                        email: root.currentUserEmail
                    }, type, root.people || []),
                    // Superadmin "Share with team" override — explicitly publishes
                    // a private event to the team. Defaults to whatever the user
                    // toggled in the modal (false otherwise).
                    isTeamShared: !!nb.isTeamShared,
                    // Opened from an AI answer's form (calendarAiFormOpen): saveEvent
                    // reports the saved event back. _toRow never writes it.
                    ...nb.aiRequest ? {
                        aiRequest: nb.aiRequest
                    } : {}
                };
                if (nb.editingEventId) {
                    const editedOriginal = (root.events || []).find((ev)=>ev.id === nb.editingEventId);
                    if (editedOriginal) {
                        // Normal path — root.events has the original loaded (the usual
                        // /calendar case), so the series-sibling scan + scope
                        // propagation below can run.
                        const geid = editedOriginal?.googleEventId;
                        const baseId = geid?.replace(/_\d{8}T\d{6}Z$/, '');
                        const scope = nb._saveScope || 'this';
                        const sharedFields = {
                            type: payload.type,
                            description: payload.description,
                            invitees: payload.invitees
                        };
                        const shouldUpdate = (ev)=>{
                            if (ev.id === nb.editingEventId) return true;
                            if (scope === 'this') return false;
                            const evBase = ev.googleEventId?.replace(/_\d{8}T\d{6}Z$/, '');
                            if (evBase !== baseId) return false;
                            if (scope === 'all') return true;
                            // 'future': only events on or after the edited event's date
                            return ev.date >= editedOriginal.date;
                        };
                        const updated = (root.events || []).map((ev)=>{
                            if (ev.id === nb.editingEventId) return {
                                ...ev,
                                ...payload
                            };
                            if (shouldUpdate(ev)) return {
                                ...ev,
                                ...sharedFields
                            };
                            return ev;
                        });
                        root.update({
                            events: updated,
                            newBooking: resetBooking
                        });
                        el.call('closeNewBookingModal');
                        const edited = updated.find((ev)=>ev.id === nb.editingEventId);
                        if (edited) {
                            el.call('saveEvent', edited);
                            requestAnimationFrame(()=>el.call('openEventDetailModal', edited));
                        }
                        // Propagate shared fields to siblings in DB based on scope
                        if (scope !== 'this' && edited) el.call('updateSharedEventFields', edited, sharedFields);
                    } else {
                        // EDIT-PATH BUG fix — the modal is global now, so Edit can fire
                        // from a route that never fetched calendar/pages/index.js's
                        // ±14-day `root.events` window (that fetch is route-gated to
                        // /calendar). The old code always looked the original up in
                        // root.events; when it wasn't there, `updated.find(...)` came
                        // back undefined and `saveEvent` silently never fired — a no-op
                        // edit. Build the row straight from the draft and PATCH by id
                        // directly. Recurring scope degrades to 'this' (the series-
                        // sibling scan needs a loaded window it doesn't have here);
                        // saveEvent.js's _toRow omits fields this payload doesn't carry
                        // (google ids, multi-day end date, color) instead of nulling
                        // them, so this PATCH can't clobber data it never saw.
                        const edited = {
                            id: nb.editingEventId,
                            ...payload
                        };
                        root.update({
                            newBooking: resetBooking
                        });
                        el.call('closeNewBookingModal');
                        el.call('saveEvent', edited);
                        requestAnimationFrame(()=>el.call('openEventDetailModal', edited));
                    }
                } else {
                    const newEv = {
                        id: Date.now(),
                        ...payload
                    };
                    // Capture before clearing so the .then closure can reference it.
                    const pending = root.pendingSuggestion;
                    const _meetingMode = meetingMode;
                    // Off /calendar with nothing loaded yet, an optimistic push would
                    // fabricate a one-item "loaded" events list that nothing renders
                    // (the grid isn't mounted) and that a same-session /calendar visit
                    // would then have to reconcile against. saveEvent is the source of
                    // truth either way — the page's own fetch replaces `root.events`
                    // wholesale on the next /calendar visit. Still push when we're ON
                    // /calendar (grid needs it now) or when root.events already has a
                    // real loaded list (append is cheap and correct there).
                    const trackLocally = $15d359c810f8105d$var$_onCalendarRoute(root) || (root.events || []).length > 0;
                    root.update({
                        events: trackLocally ? [
                            ...root.events || [],
                            newEv
                        ] : root.events || [],
                        newBooking: resetBooking
                    });
                    el.call('closeNewBookingModal');
                    // Persist, then patch the optimistic id with the real
                    // autoincrement id once the write returns.
                    el.call('saveEvent', newEv).then(async (realId)=>{
                        if (!realId) return;
                        root.update({
                            events: (root.events || []).map((ev)=>ev.id === newEv.id ? {
                                    ...ev,
                                    id: realId
                                } : ev)
                        });
                        // Symbols Meet: create a room and attach link to event description
                        if (_meetingMode === 'symbols-meet' && (type === 'meeting' || type === 'general')) {
                            const roomId = await el.call('createRoom', {
                                name: payload.title || el.call('polyglot', 'calendar.detail.callName'),
                                kind: 'scheduled',
                                calendarEventId: realId,
                                transcribeEnabled: true
                            });
                            if (roomId) {
                                // Org-prefixed via meetRoomUrl (meet/functions/roomUrl.js) —
                                // a bare /meet link re-resolved to the RECIPIENT's active
                                // org (cross-org invite bug, 2026-07-29). EventDetailModal's
                                // symbols-meet detection matches on the '/meet#room='
                                // substring, which the prefixed URL still contains.
                                const meetLink = el.call('meetRoomUrl', root, roomId);
                                const updatedDesc = payload.description ? `${payload.description}\n${meetLink}` : meetLink;
                                const patched = {
                                    ...payload,
                                    id: realId,
                                    description: updatedDesc
                                };
                                root.update({
                                    events: (root.events || []).map((ev)=>ev.id === realId ? {
                                            ...ev,
                                            description: updatedDesc
                                        } : ev)
                                });
                                el.call('saveEvent', patched);
                            }
                        }
                        // If this save originated from a meet transcript suggestion,
                        // mark it applied so the card shows a checkmark on next visit.
                        if (pending?.bucket === 'calendar_events' && pending?.item) el.call('markSuggestionApplied', pending.bucket, pending.item, realId);
                    });
                }
            }
        }
    },
    // Scope picker overlay — shown when editing a recurring event
    ScopePicker: {
        if: (el, s)=>s.root?.newBooking?._showScopePicker,
        position: 'absolute',
        inset: '0',
        zIndex: '10',
        // Fixed-colour sweep (2026-08-09): a sheet scrim (dims the booking form
        // behind the scope-picker dialog) — same pattern as MobileRailSheet's
        // black.45 -> scrimSoft fix; color.js ships that pair for exactly this.
        background: 'scrimSoft',
        backdropFilter: 'blur(4px)',
        align: 'center center',
        round: 'radiusControl',
        Dialog: {
            padding: 'B1',
            round: 'radiusCard',
            // Borderless (design-direction §8): the `overlay` fill + the parent
            // scrim already separate this dialog — the hairline card outline was
            // redundant belt-and-suspenders separation. Fill contrast alone.
            background: 'overlay',
            flow: 'y',
            gap: 'A',
            width: '100%',
            maxWidth: 'G',
            // Token color, not a raw rgba() literal — same `--color-shadow` idiom
            // used by this file's outer modal panels (see maxHeight/boxShadow above).
            boxShadow: '0 16px 48px -8px var(--color-shadow)',
            Title: {
                tag: 'h3',
                text: '{{ calendar.booking.scopeHeading | polyglot }}',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                margin: '0'
            },
            Subtitle: {
                tag: 'p',
                text: '{{ calendar.booking.scopeSubtitle | polyglot }}',
                fontSize: 'Z1',
                color: 'caption',
                margin: '0'
            },
            Options: {
                flow: 'y',
                gap: 'Z',
                childExtends: {
                    tag: 'button',
                    type: 'button',
                    padding: 'Z1 A',
                    round: 'radiusControl',
                    borderWidth: 'hairline',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    background: 'overlay',
                    color: 'title',
                    fontSize: 'Z1',
                    fontWeight: '700',
                    cursor: 'pointer',
                    textAlign: 'left',
                    text: (el, s)=>el.call('polyglot', s.label),
                    ':hover': {
                        background: 'selected',
                        borderColor: 'caption'
                    }
                },
                childrenAs: 'state',
                children: [
                    {
                        key: 'this',
                        label: 'calendar.booking.scopeThis'
                    },
                    {
                        key: 'future',
                        label: 'calendar.booking.scopeFuture'
                    },
                    {
                        key: 'all',
                        label: 'calendar.booking.scopeAll'
                    }
                ],
                onClick: (e, el, s)=>{
                    const root = s.root;
                    const nb = root.newBooking || {};
                    root.update({
                        newBooking: {
                            ...nb,
                            _showScopePicker: false,
                            _saveScope: s.key
                        }
                    });
                    // Trigger the save by clicking the SaveBtn programmatically. Walk
                    // up from this element until an ancestor exposing
                    // ModalFooter.SaveBtn is found instead of a fixed hop count — the
                    // old `el.parent.parent.parent` depended on the OLD
                    // Modal→Window→ModalFooter nesting and silently breaks the
                    // instant that nesting changes again.
                    let node = el;
                    while(node && !node.ModalFooter?.SaveBtn)node = node.parent;
                    const saveBtn = node?.ModalFooter?.SaveBtn;
                    if (saveBtn?.node) saveBtn.node.click();
                }
            },
            CancelScopeBtn: {
                tag: 'button',
                type: 'button',
                text: '{{ calendar.booking.scopeCancel | polyglot }}',
                padding: 'Z A',
                background: 'none',
                borderWidth: '0',
                color: 'caption',
                fontSize: 'Z1',
                cursor: 'pointer',
                textAlign: 'center',
                onClick: (e, el, s)=>{
                    const root = s.root;
                    const nb = root.newBooking || {};
                    root.update({
                        newBooking: {
                            ...nb,
                            _showScopePicker: false
                        }
                    });
                }
            }
        }
    }
};
const $15d359c810f8105d$export$acc6bf04a7c29c01 = {
    tag: 'div',
    tabindex: '-1',
    flow: 'x',
    align: 'center left',
    flex: 'none',
    width: 'fit-content',
    gap: 'Z',
    padding: 'Y Z',
    round: 'radiusPill',
    background: (el, s)=>$15d359c810f8105d$var$_inviteeIsUnavailable(el, el.state.root, s) ? 'red.07' : 'overlay',
    borderWidth: 'hairline',
    borderColor: (el, s)=>$15d359c810f8105d$var$_inviteeIsUnavailable(el, el.state.root, s) ? 'red' : 'line',
    borderStyle: 'solid',
    onClick: (e, el)=>{
        const root = el.state.root;
        root.update({
            newBooking: {
                ...root.newBooking,
                inviteePickerOpen: false
            }
        });
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B B',
        src: (el, s)=>(0, $76fm2.avatarUrl)(s.name)
    },
    Name: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'title',
        text: (el, s)=>(s.name || '').split(' ')[0]
    },
    Availability: {
        tag: 'span',
        display: (el, s)=>$15d359c810f8105d$var$_inviteeIsUnavailable(el, el.state.root, s) ? 'inline' : 'none',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'red',
        text: '{{ calendar.booking.unavailable | polyglot }}'
    },
    RemoveBtn: {
        tag: 'button',
        text: "\xd7",
        border: 'none',
        background: 'transparent',
        color: 'caption',
        cursor: 'pointer',
        padding: '0',
        fontSize: 'A',
        lineHeight: '1',
        ':hover': {
            color: 'title'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            $15d359c810f8105d$var$_removeInvitee(el.state.root, s.email, el.call('calendarTeamMemberKey', s));
        }
    }
};
const $15d359c810f8105d$export$41615fa952c1c359 = {
    tag: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Z A',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    width: '100%',
    textAlign: 'left',
    ':hover': {
        background: 'hover'
    },
    onMousedown: (e)=>{
        // Keep the input focused so selecting a result does not close the list
        // before the click action adds the person.
        e.preventDefault();
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        const root = el.state.root;
        $15d359c810f8105d$var$_addInvitee(el, root, s);
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B B',
        src: (el, s)=>(0, $76fm2.avatarUrl)(s.name)
    },
    Info: {
        flow: 'y',
        gap: 'Y2',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || ''
        },
        Email: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            fontFamily: 'monospace',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.email || ''
        }
    }
};
const $15d359c810f8105d$export$b9957715013c29f9 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Y',
    padding: 'Y2 Z',
    round: 'radiusPill',
    borderWidth: 'hairline',
    borderStyle: (el, s)=>{
        const cur = !!el.state.root.newBooking?.isTeamShared;
        return cur === s.value ? 'none' : 'dashed';
    },
    borderColor: 'title.35',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    background: (el, s)=>{
        const cur = !!el.state.root.newBooking?.isTeamShared;
        return cur === s.value ? 'line' : 'transparent';
    },
    color: 'title',
    text: (el, s)=>el.call('polyglot', s.label),
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.state.root.update({
            newBooking: {
                ...el.state.root.newBooking,
                isTeamShared: s.value
            }
        });
    }
};
const $15d359c810f8105d$export$4f357a2a359e39e2 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center center',
    padding: 'Y2 A',
    round: 'radiusPill',
    borderWidth: 'hairline',
    borderStyle: 'dashed',
    borderColor: 'title.35',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    background: 'transparent',
    color: 'title',
    isActive: (el, s)=>(el.state.root.newBooking?.recurring || 'none') === s.value,
    ariaPressed: (el, s)=>(el.state.root.newBooking?.recurring || 'none') === s.value ? 'true' : 'false',
    '.isActive': {
        borderStyle: 'none',
        background: 'highlight',
        color: 'highlight-reversed'
    },
    text: (el, s)=>el.call('polyglot', s.label),
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const root = el.state.root;
        const patch = {
            recurring: s.value
        };
        if (s.value !== 'none' && !root.newBooking?.recurrenceEndType) {
            patch.recurrenceEndType = 'after';
            patch.recurrenceEndCount = 10;
        }
        // Switching to Weekly seeds the day-toggles with the event's own day.
        if (s.value === 'weekly' && !root.newBooking?.recurringDays?.length) {
            const d = root.newBooking?.date;
            if (d) {
                const [y, m, dy] = d.split('-').map(Number);
                patch.recurringDays = [
                    new Date(y, m - 1, dy).getDay()
                ];
            }
        }
        root.update({
            newBooking: {
                ...root.newBooking,
                ...patch
            }
        });
    }
};
const $15d359c810f8105d$export$c251eba12ab2eccf = {
    extends: 'AppField',
    tag: 'div',
    display: (el, s)=>s.root?.newBooking?.recurring === 'none' ? 'none' : 'flex',
    gap: 'Z',
    marginTop: 'Z',
    label: (el)=>el.call('polyglot', 'calendar.booking.endRepeat'),
    Modes: {
        role: 'group',
        ariaLabel: (el)=>el.call('polyglot', 'calendar.booking.endRepeat'),
        flow: 'x',
        gap: 'Y',
        flexWrap: 'wrap',
        childExtends: 'CalEndRepeatBtn',
        childrenAs: 'state',
        children: [
            {
                value: 'after',
                label: 'calendar.repeat.endAfter'
            },
            {
                value: 'on',
                label: 'calendar.repeat.endOn'
            }
        ]
    },
    AfterValue: {
        display: (el, s)=>s.root?.newBooking?.recurrenceEndType === 'after' ? 'flex' : 'none',
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        // The shared field kit's control. No visible label sits above it (the
        // "After" mode chip names it), so it takes that chip's name. `width`
        // stays: the count reads as one inline phrase with the unit after it,
        // and the kit's full-column width would push the unit to the far edge.
        AppInput: {
            type: 'text',
            inputMode: 'numeric',
            pattern: '[0-9]*',
            width: 'D2',
            ariaLabel: (el)=>el.call('polyglot', 'calendar.repeat.endAfter'),
            value: (el, s)=>String(s.root?.newBooking?.recurrenceEndCount || 10),
            onClick: (e)=>e.target.select(),
            onContextmenu: (e)=>e.preventDefault(),
            onInput: (e, el, s)=>{
                const count = el.call('normalizeOccurrenceCount', e.target.value);
                s.root.update({
                    newBooking: {
                        ...s.root?.newBooking,
                        recurrenceEndCount: count === '' ? '' : count
                    }
                });
            }
        },
        // The unit after the count, from the bundle: the house one/many key pair,
        // picked by the count itself (it was the English literal "occurrences"
        // in every language). A Georgian noun after a numeral stays singular, so
        // the ka pair holds one word twice. An empty field reads as the default 10.
        Text: {
            text: (el, s)=>{
                const n = Number(s.root?.newBooking?.recurrenceEndCount || 10);
                return el.call('polyglot', n === 1 ? 'calendar.repeat.occurrenceOne' : 'calendar.repeat.occurrenceMany');
            },
            color: 'caption',
            fontSize: 'Z2'
        }
    },
    OnDateValue: {
        display: (el, s)=>s.root?.newBooking?.recurrenceEndType === 'on' ? 'flex' : 'none',
        // The shared field kit's control, named by the "On date" mode chip.
        AppInput: {
            type: 'date',
            ariaLabel: (el)=>el.call('polyglot', 'calendar.repeat.endOn'),
            min: (el, s)=>s.root?.newBooking?.date || '',
            value: (el, s)=>s.root?.newBooking?.recurrenceEndDate || s.root?.newBooking?.date || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    newBooking: {
                        ...s.root?.newBooking,
                        recurrenceEndDate: e.target.value
                    }
                });
            }
        }
    }
};
const $15d359c810f8105d$export$69609936aa838017 = {
    extends: 'CalRecurringBtn',
    isActive: (el, s)=>(el.state.root.newBooking?.recurrenceEndType || 'after') === s.value,
    ariaPressed: (el, s)=>(el.state.root.newBooking?.recurrenceEndType || 'after') === s.value ? 'true' : 'false',
    onClick: (e, el, s)=>{
        e.preventDefault();
        const root = el.state.root;
        const patch = {
            recurrenceEndType: s.value
        };
        if (s.value === 'after') patch.recurrenceEndCount = root.newBooking?.recurrenceEndCount || 10;
        else patch.recurrenceEndDate = root.newBooking?.recurrenceEndDate || root.newBooking?.date || '';
        root.update({
            newBooking: {
                ...root.newBooking,
                ...patch
            }
        });
    }
};
const $15d359c810f8105d$export$a34c15ffbdceb0e0 = {
    tag: 'button',
    width: 'B1',
    height: 'B1',
    padding: '0',
    round: '50%',
    borderWidth: 'hairline',
    borderStyle: (el, s)=>{
        const days = el.state.root.newBooking?.recurringDays || [];
        return days.includes(s.dow) ? 'none' : 'dashed';
    },
    borderColor: 'title.35',
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '700',
    align: 'center center',
    background: (el, s)=>{
        const days = el.state.root.newBooking?.recurringDays || [];
        return days.includes(s.dow) ? 'title' : 'transparent';
    },
    color: (el, s)=>{
        const days = el.state.root.newBooking?.recurringDays || [];
        return days.includes(s.dow) ? 'title-reversed' : 'caption';
    },
    // A multi-select toggle: each day says whether it is on (it said so only
    // through its fill).
    ariaPressed: (el, s)=>(el.state.root.newBooking?.recurringDays || []).includes(s.dow) ? 'true' : 'false',
    text: (el, s)=>el.call('polyglot', s.label),
    onClick: (e, el, s)=>{
        e.preventDefault();
        const root = el.state.root;
        const cur = new Set(root.newBooking?.recurringDays || []);
        if (cur.has(s.dow)) cur.delete(s.dow);
        else cur.add(s.dow);
        root.update({
            newBooking: {
                ...root.newBooking,
                recurringDays: Array.from(cur).sort()
            }
        });
    }
};
const $15d359c810f8105d$export$6c0e414e73929102 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Z',
    padding: 'Y2 A',
    round: 'radiusPill',
    borderWidth: 'hairline',
    borderStyle: (el, s)=>{
        const cur = el.state.root.newBooking?.type || 'meeting';
        return cur === s.type ? 'none' : 'dashed';
    },
    borderColor: 'title.35',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    // §8.5 rule 2/3 — the hue can't be the ink: the selected label painted in
    // `s.color` measured 1.79:1 light / 3.38:1 dark on this pill (2026-08-08
    // walk of the open modal). Selection is the `selected` wash + `title` ink;
    // the Dot below still carries the type hue at full saturation.
    background: (el, s)=>{
        const cur = el.state.root.newBooking?.type || 'meeting';
        return cur === s.type ? 'selected' : 'transparent';
    },
    color: 'title',
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.state.root.update({
            newBooking: {
                ...el.state.root.newBooking,
                type: s.type
            }
        });
    },
    Dot: {
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: (el, s)=>s.color
    },
    Label: {
        tag: 'span',
        text: (el, s)=>el.call('polyglot', s.label || s.type)
    }
};
const $15d359c810f8105d$export$3751014e41a4a015 = {
    display: (el, s)=>s.root?.confirmMove ? 'flex' : 'none',
    position: 'fixed',
    inset: '0',
    zIndex: 2100,
    align: 'center center',
    theme: 'modalFade',
    onClick: (e, el, s)=>{
        if (e.target === el.node) $15d359c810f8105d$var$_cancelConfirmMove(s.root);
    },
    Panel: {
        flow: 'y',
        gap: 'Z1',
        padding: 'A B',
        width: '100%',
        maxWidth: 'H',
        theme: 'modal',
        round: 'radiusControl',
        boxShadow: '0 8px 40px var(--color-shadow)',
        Title: {
            tag: 'h3',
            margin: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: '{{ calendar.booking.moveHeading | polyglot }}'
        },
        Body: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'caption',
            lineHeight: '1.5',
            text: '{{ calendar.booking.moveBody | polyglot }}'
        },
        ModalFooter: {
            flow: 'x',
            align: 'center flex-end',
            gap: 'Z1',
            flexWrap: 'wrap',
            childExtends: 'Button',
            CancelBtn: {
                theme: 'secondary',
                text: '{{ calendar.booking.moveCancel | polyglot }}',
                onClick: (e, el, s)=>$15d359c810f8105d$var$_cancelConfirmMove(s.root)
            },
            ProposeBtn: {
                theme: 'secondary',
                text: '{{ calendar.booking.movePropose | polyglot }}',
                disabled: (el, s)=>$15d359c810f8105d$var$_confirmMoveWritable(el, s.root) ? null : true,
                title: (el, s)=>$15d359c810f8105d$var$_confirmMoveWritable(el, s.root) ? null : el.call('polyglot', 'calendar.booking.moveOrganizerOnly'),
                // A proposal at the new time; the original stays put. The shadow
                // goes away again when the server refuses it.
                onClick: (e, el, s)=>{
                    const cm = s.root?.confirmMove;
                    if (!cm) return;
                    // A click that gets past the disabled state writes nothing.
                    if (!$15d359c810f8105d$var$_confirmMoveWritable(el, s.root)) return;
                    s.root.update({
                        confirmMove: null
                    });
                    el.call('calendarProposeMove', cm.eventId, cm.next);
                }
            },
            UpdateBtn: {
                theme: 'primary',
                text: '{{ calendar.booking.moveUpdate | polyglot }}',
                // Move the event itself for everyone invited (saveEvent pushes it to
                // Google too). The chip goes back when the server refuses the save.
                onClick: (e, el, s)=>{
                    const cm = s.root?.confirmMove;
                    if (!cm) return;
                    s.root.update({
                        confirmMove: null
                    });
                    el.call('calendarCommitMove', cm.eventId, cm.next);
                }
            }
        }
    }
};
const $15d359c810f8105d$var$_cancelConfirmMove = (root)=>{
    // The original event was never mutated — just dismiss.
    root.update({
        confirmMove: null
    });
};
// May the viewer write the event the move dialog is about (the server's write
// rule, calendarCanWriteEvent)? Every key is read before the branch, so the
// reactive props that call this re-run when the dialog opens.
const $15d359c810f8105d$var$_confirmMoveWritable = (el, root)=>{
    if (!root) return false;
    const cm = root.confirmMove;
    const events = root.events || [];
    const row = cm ? events.find((item)=>item.id === cm.eventId) : null;
    return !!row && el.call('calendarCanWriteEvent', row, root) === true;
};
const $15d359c810f8105d$export$508fbd55d4b2b137 = {
    tag: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Z',
    padding: 'Y2 A',
    round: 'radiusPill',
    borderWidth: 'hairline',
    // Unselected: dashed ink.35 (the one sanctioned stroke, design-direction.md
    // §8) instead of a solid `line` outline — same fix as the sibling pickers
    // above. Selected keeps its solid green border unchanged — that one is a
    // deliberate, documented a11y signal (see the §4.3/§8.5 comment below), not
    // the banned default-outline habit.
    borderStyle: (el, s)=>{
        const cur = el.state.root.newBooking?.meetingMode || 'symbols-meet';
        return cur === s.mode ? 'solid' : 'dashed';
    },
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    // §4.3/§8.5 — selection is the `selected` wash + `title` ink; the green
    // border keeps the "picked" signal without a white-on-green fill (2.81:1).
    background: (el, s)=>{
        const cur = el.state.root.newBooking?.meetingMode || 'symbols-meet';
        return cur === s.mode ? 'selected' : 'transparent';
    },
    borderColor: (el, s)=>{
        const cur = el.state.root.newBooking?.meetingMode || 'symbols-meet';
        return cur === s.mode ? 'green' : 'title.35';
    },
    color: 'title',
    text: (el, s)=>el.call('polyglot', s.label),
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.state.root.update({
            newBooking: {
                ...el.state.root.newBooking,
                meetingMode: s.mode
            }
        });
    }
};
// Generate a fake but plausible Google Meet link. We don't talk to a real
// backend here, but the format matches Meet's xxx-yyyy-zzz pattern so it
// reads correctly in the description field.
const $15d359c810f8105d$export$2a59fa0458407049 = ()=>{
    const seg = (n)=>Math.random().toString(36).slice(2, 2 + n);
    return `https://meet.google.com/${seg(3)}-${seg(4)}-${seg(3)}`;
};

});


parcelRegister("bUwFN", function(module, exports) {

$parcel$export(module.exports, "deleteEvent", () => (parcelRequire("iz1Mr")).deleteEvent);
$parcel$export(module.exports, "saveEvent", () => (parcelRequire("iz1Mr")).saveEvent);
$parcel$export(module.exports, "setEventRsvp", () => (parcelRequire("iz1Mr")).setEventRsvp);
$parcel$export(module.exports, "triggerCalendarSync", () => (parcelRequire("iz1Mr")).triggerCalendarSync);
$parcel$export(module.exports, "updateSharedEventFields", () => (parcelRequire("iz1Mr")).updateSharedEventFields);
$parcel$export(module.exports, "DEFAULT_RECURRENCE_DRAFT", () => (parcelRequire("eQSi7")).DEFAULT_RECURRENCE_DRAFT);
$parcel$export(module.exports, "normalizeOccurrenceCount", () => (parcelRequire("eQSi7")).normalizeOccurrenceCount);
$parcel$export(module.exports, "recurrenceFieldsFromMetadata", () => (parcelRequire("eQSi7")).recurrenceFieldsFromMetadata);
$parcel$export(module.exports, "recurrenceMetadataForEvent", () => (parcelRequire("eQSi7")).recurrenceMetadataForEvent);
$parcel$export(module.exports, "recurrencePayloadFromBooking", () => (parcelRequire("eQSi7")).recurrencePayloadFromBooking);
// Eager slim slice of the calendar function barrel (#16 calendar slim).
//
// The full `./index.js` barrel re-exports the whole calendar function surface —
// which is exactly two source files: calendarUtils.js (date/lane/timezone/
// recurrence helpers + the freshBooking factory) and saveEvent.js
// (the event write ops). The unified shell used to drag both into its EAGER
// chunk by folding the calendar context via `sharedLibraries.js`.
//
// Calendar is now a lazy sub-app: the `/calendar` route folds the FULL calendar
// context (components + functions + state) into the live shell context on first
// mount (workspace/pages/index.js → lazySharedLibPage). So the eager chunk only
// needs the calendar functions that get el.call'd (or statically imported) from
// OUTSIDE a calendar-mounted component — i.e. on a surface that never folds the
// calendar context.
//
// An exhaustive grep of the whole eager surface (workspace app.js/pages/
// components/functions, shared/**, chat, meet, canvas, and the other lazy
// sub-apps' eager contexts) for cross-route calendar-function callers found:
//   • saveEvent — el.call'd by chat's MessageList (send-a-message-as-
//     event, /chat), meet (meetUtils.js `applyFn` + applySuggestion, /meet), the
//     workspace AI layer (functions/aiAssistant.js `create_event`) on ANY route,
//     AND the eager CalEventDetailModal (join-call/move) + CalNewBookingModal
//     (save/move).
//   • deleteEvent / updateSharedEventFields — el.call'd by the eager
//     CalEventDetailModal (delete / this-vs-series edit) + CalNewBookingModal.
//   • freshBooking — el.call'd by the eager modals' edit/new paths AND by
//     workspace/functions/newBookingModal.js's `openNewBookingModal` (the
//     shell-root opener CalNewBookingModal is triggered through, fires on
//     ANY route — see components/eagerSlice.js). meet/functions/
//     openSuggestionModal.js used to import it directly; it now routes
//     through `openNewBookingModal` too, so calendarUtils.js's eager
//     registration is what keeps that el.call resolving.
// Every OTHER calendar util (getWeekDays, assignLanes, getMonthDays, getHours,
// pxToTime, eventToTop, getUnavailableRanges, …) is only el.call'd from a
// calendar-mounted grid (WeekView/MonthView/TeamView/TeamNowView/MiniCalendar),
// i.e. AFTER a fold registers it — so it rides the lazy chunk. But it costs
// nothing to register the whole calendarUtils surface eagerly: calendarUtils.js
// is ALREADY eager (statically imported by all three eager modals), so this
// slice adds no byte weight for it and guarantees no el.call('<calendarUtil>')
// from any surface ever misses.
//
// Byte note: saveEvent.js is the only net-new eager module (~9KB) — the
// price of keeping chat/meet/AI event writes + the modal save/delete/move working
// from any route. Both function files import only shell/shared helpers
// (roleHelpers, sdk, config, coreHeaders — verified: no function file imports a
// component file), so this slice can never drag a heavy calendar component into
// the eager chunk.
//
// calendar/package.json has no `sideEffects: false`, so re-exporting through
// `./index.js` would NOT tree-shake. The two source files are `export *`-ed
// directly below (the calendar function surface is exactly these two files, and
// both carry eager-referenced functions), keeping the eager set explicit and
// future-proof against a new /calendar-only function file being added to index.js.

var $8hz4V = parcelRequire("8hz4V");

var $iz1Mr = parcelRequire("iz1Mr");

var $gOkYs = parcelRequire("gOkYs");

var $fIUoo = parcelRequire("fIUoo");

var $6rr2K = parcelRequire("6rr2K");

var $5wPUz = parcelRequire("5wPUz");

var $kPwk0 = parcelRequire("kPwk0");

var $185Mg = parcelRequire("185Mg");

var $eQSi7 = parcelRequire("eQSi7");
$parcel$exportWildcard(module.exports, $8hz4V);
$parcel$exportWildcard(module.exports, $gOkYs);
$parcel$exportWildcard(module.exports, $fIUoo);
$parcel$exportWildcard(module.exports, $6rr2K);
$parcel$exportWildcard(module.exports, $5wPUz);
$parcel$exportWildcard(module.exports, $kPwk0);
$parcel$exportWildcard(module.exports, $185Mg);

});
parcelRegister("8hz4V", function(module, exports) {

$parcel$export(module.exports, "CALENDAR_DEFAULT_TEAM_MEMBER_SELECTORS", () => $607b1f1ae0c009ec$export$e60f091a107fbea0);
$parcel$export(module.exports, "calendarTeamMemberKey", () => $607b1f1ae0c009ec$export$8583c39f8702433);
$parcel$export(module.exports, "calendarParticipantRsvpKeys", () => $607b1f1ae0c009ec$export$80fefd073bb4cd18);
$parcel$export(module.exports, "calendarEventRsvpStatus", () => $607b1f1ae0c009ec$export$ce5ce75591dd82a8);
$parcel$export(module.exports, "calendarEventDeclinedFor", () => $607b1f1ae0c009ec$export$b9e9e5f5390ff69);
$parcel$export(module.exports, "calendarEventForTeamMember", () => $607b1f1ae0c009ec$export$b806e3b4e15b9dff);
$parcel$export(module.exports, "calendarFindTeamMember", () => $607b1f1ae0c009ec$export$8fa301b8b7f39c16);
$parcel$export(module.exports, "calendarUniqueEvents", () => $607b1f1ae0c009ec$export$420e2c7fbcbfb6de);
$parcel$export(module.exports, "calendarBookingStartsInPast", () => $607b1f1ae0c009ec$export$85cc5906243df3d6);
$parcel$export(module.exports, "calendarBookingHasInvalidRange", () => $607b1f1ae0c009ec$export$9d9643e1852dffa0);
$parcel$export(module.exports, "cacheCalendarEventRsvp", () => $607b1f1ae0c009ec$export$f1ab6ee1da6603d7);
$parcel$export(module.exports, "calendarEventRsvpSnapshot", () => $607b1f1ae0c009ec$export$3b838584fa32a25f);
$parcel$export(module.exports, "calendarVisibleTeamMembers", () => $607b1f1ae0c009ec$export$40a1dd44237c5fee);
$parcel$export(module.exports, "calendarTeamMembersWithout", () => $607b1f1ae0c009ec$export$aea462df519fee06);
$parcel$export(module.exports, "calendarTeamMemberSuggestions", () => $607b1f1ae0c009ec$export$999d7ceb0340ba99);
$parcel$export(module.exports, "calendarTeamMembersWith", () => $607b1f1ae0c009ec$export$13cfbf95ba9b2ed2);
$parcel$export(module.exports, "getMonthName", () => $607b1f1ae0c009ec$export$e7af3ee2c84591cc);
$parcel$export(module.exports, "getMonthLabel", () => $607b1f1ae0c009ec$export$5492c4ce9d26d774);
$parcel$export(module.exports, "getMonthYear", () => $607b1f1ae0c009ec$export$f2cf7cfc766f30df);
$parcel$export(module.exports, "getDayNames", () => $607b1f1ae0c009ec$export$d03409b923543a08);
$parcel$export(module.exports, "getMonthDays", () => $607b1f1ae0c009ec$export$214c174a056fc56f);
$parcel$export(module.exports, "isToday", () => $607b1f1ae0c009ec$export$629b0a497aa65267);
$parcel$export(module.exports, "formatDate", () => $607b1f1ae0c009ec$export$3ae94a2503e890a1);
$parcel$export(module.exports, "assignLanes", () => $607b1f1ae0c009ec$export$5e82f59d50595df4);
$parcel$export(module.exports, "getEventsForDay", () => $607b1f1ae0c009ec$export$e2572468fb9b0fd1);
$parcel$export(module.exports, "HOUR_PX", () => $607b1f1ae0c009ec$export$d0e73eb52e587409);
$parcel$export(module.exports, "SLOT_MIN", () => $607b1f1ae0c009ec$export$545d628082486514);
$parcel$export(module.exports, "calendarHour12", () => $607b1f1ae0c009ec$export$53370be9fcf227b9);
$parcel$export(module.exports, "formatTzTime", () => $607b1f1ae0c009ec$export$379b0c9dd9309abd);
$parcel$export(module.exports, "tzClockMinutes", () => $607b1f1ae0c009ec$export$62bbcb44be509390);
$parcel$export(module.exports, "formatTzDate", () => $607b1f1ae0c009ec$export$b64d9bf67c4faac9);
$parcel$export(module.exports, "hhmmToMin", () => $607b1f1ae0c009ec$export$361693031ac6effa);
$parcel$export(module.exports, "minToHHMM", () => $607b1f1ae0c009ec$export$17176dec6259f9c6);
$parcel$export(module.exports, "eventUtcMs", () => $607b1f1ae0c009ec$export$91121fc77411a436);
$parcel$export(module.exports, "getUnavailableRanges", () => $607b1f1ae0c009ec$export$c3f95de39763f5b9);
$parcel$export(module.exports, "weekContainsToday", () => $607b1f1ae0c009ec$export$e4ff15aebfb30c58);
$parcel$export(module.exports, "getWeekDays", () => $607b1f1ae0c009ec$export$69ac73875782844e);
$parcel$export(module.exports, "getTimelineDays", () => $607b1f1ae0c009ec$export$2971bc0866c6e18);
$parcel$export(module.exports, "getHours", () => $607b1f1ae0c009ec$export$257b40f71c07d58f);
$parcel$export(module.exports, "shouldStampPrivate", () => $607b1f1ae0c009ec$export$57c60d6c6403ce2c);
$parcel$export(module.exports, "eventIsPrivateFor", () => $607b1f1ae0c009ec$export$5606210727cdab7d);
$parcel$export(module.exports, "calendarCanWriteEvent", () => $607b1f1ae0c009ec$export$6926fe71ee62ac69);
$parcel$export(module.exports, "eventHue", () => $607b1f1ae0c009ec$export$5e13f77326ed81c8);
$parcel$export(module.exports, "nextUpcomingEvent", () => $607b1f1ae0c009ec$export$9531a1b422a90e8b);
$parcel$export(module.exports, "getMonthEventSummary", () => $607b1f1ae0c009ec$export$96899ba0b3241643);
$parcel$export(module.exports, "inferRecurrence", () => $607b1f1ae0c009ec$export$5ee5e2a16be91d2d);
$parcel$export(module.exports, "freshBooking", () => $607b1f1ae0c009ec$export$37f04dedae96c36c);
$parcel$export(module.exports, "eventToTop", () => $607b1f1ae0c009ec$export$a791c2189f2df0e5);
$parcel$export(module.exports, "eventToHeight", () => $607b1f1ae0c009ec$export$75a7111b83ab7f54);
$parcel$export(module.exports, "pxToTime", () => $607b1f1ae0c009ec$export$1064a26da00eecfc);
$parcel$export(module.exports, "addMinutes", () => $607b1f1ae0c009ec$export$2287e3d29250119e);
$parcel$export(module.exports, "getEventTheme", () => $607b1f1ae0c009ec$export$6f370a2ca055bfeb);
$parcel$export(module.exports, "prevMonth", () => $607b1f1ae0c009ec$export$ef308314adc3ab58);
$parcel$export(module.exports, "nextMonth", () => $607b1f1ae0c009ec$export$387da49966d7e375);
$parcel$export(module.exports, "fetchEventDetails", () => $607b1f1ae0c009ec$export$3aed032d051fb152);
$parcel$export(module.exports, "calendarFetchWindow", () => $607b1f1ae0c009ec$export$277907017aebc8c4);
$parcel$export(module.exports, "CAL_LEAN_SELECT", () => $607b1f1ae0c009ec$export$79281febdf88761e);
$parcel$export(module.exports, "rowToEvent", () => $607b1f1ae0c009ec$export$150323f4a3410297);
$parcel$export(module.exports, "scrollCalendarToNow", () => $607b1f1ae0c009ec$export$bed3d4298c7957fc);
$parcel$export(module.exports, "ensureCalendarWindow", () => $607b1f1ae0c009ec$export$d8844966cb0df706);
$parcel$export(module.exports, "recurrenceAllowsDate", () => (parcelRequire("eQSi7")).recurrenceAllowsDate);

var $eQSi7 = parcelRequire("eQSi7");

var $aGIjc = parcelRequire("aGIjc");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $6RzDA = parcelRequire("6RzDA");
// Month and weekday names are polyglot KEYS, written out one literal per
// entry (never built from an index — I18N-CONVENTION §1.3). Every render site
// resolves them through `el.call('polyglot', …)`; these helpers stay pure and
// element-free, so they remain unit-testable and reusable off the DOM.
const $607b1f1ae0c009ec$var$MONTH_NAMES = [
    'calendar.month.january',
    'calendar.month.february',
    'calendar.month.march',
    'calendar.month.april',
    'calendar.month.may',
    'calendar.month.june',
    'calendar.month.july',
    'calendar.month.august',
    'calendar.month.september',
    'calendar.month.october',
    'calendar.month.november',
    'calendar.month.december'
];
const $607b1f1ae0c009ec$var$DAY_NAMES = [
    'calendar.day.sun',
    'calendar.day.mon',
    'calendar.day.tue',
    'calendar.day.wed',
    'calendar.day.thu',
    'calendar.day.fri',
    'calendar.day.sat'
];
const $607b1f1ae0c009ec$export$e60f091a107fbea0 = [
    'allen@symbols.app',
    'bala@symbols.app',
    'ha@symbols.app',
    'jerry@symbols.app',
    'lekya@symbols.app',
    'luka@symbols.app',
    'manju@symbols.app',
    'marina layus',
    'nikoloza',
    'scott@symbols.app',
    'tengiz@symbols.app',
    'thomas.gazaniga@symbols.app',
    'thomas@symbols.app',
    'svinchy@symbols.app',
    'toko@symbols.app',
    'zachary@symbols.app',
    'zajim@symbols.app'
];
const $607b1f1ae0c009ec$var$_teamText = (value)=>String(value || '').trim().toLowerCase();
const $607b1f1ae0c009ec$var$_teamWords = (value)=>$607b1f1ae0c009ec$var$_teamText(value).replace(/[._-]+/g, ' ').replace(/\s+/g, ' ');
const $607b1f1ae0c009ec$var$_teamSelectorAliases = (selector)=>{
    const local = $607b1f1ae0c009ec$var$_teamText(selector).split('@')[0];
    if (local === 'toko') return [
        'toko',
        'tako'
    ];
    if (local === 'zachary') return [
        'zachary',
        'zach'
    ];
    return [
        local
    ];
};
const $607b1f1ae0c009ec$var$_teamDirectoryNameAliases = {
    josh: 'joshua mcmillan',
    nikoloza: 'nika tomadze',
    svinchy: 'tornike svintradze',
    toko: 'tako',
    zachary: 'zach betzen'
};
const $607b1f1ae0c009ec$var$_teamMemberMatchesSelector = (person, selector, uniqueEmails)=>{
    const raw = $607b1f1ae0c009ec$var$_teamText(selector);
    const aliases = $607b1f1ae0c009ec$var$_teamSelectorAliases(raw).map($607b1f1ae0c009ec$var$_teamWords);
    const email = $607b1f1ae0c009ec$var$_teamText(person?.email);
    if (email && uniqueEmails.has(email) && email === raw) return true;
    const username = $607b1f1ae0c009ec$var$_teamWords(person?.username || person?.slug);
    const name = $607b1f1ae0c009ec$var$_teamWords(person?.name);
    return aliases.some((alias)=>alias && (username === alias || name === alias || name.startsWith(`${alias} `)));
};
function $607b1f1ae0c009ec$export$8583c39f8702433(person) {
    if (!person) return '';
    const id = person.userId ?? person.id;
    if (id != null && String(id)) return `member:id:${String(id)}`;
    const username = $607b1f1ae0c009ec$var$_teamText(person.username || person.slug);
    if (username) return `member:username:${username}`;
    const name = $607b1f1ae0c009ec$var$_teamText(person.name);
    if (name) return `member:name:${name}`;
    const email = $607b1f1ae0c009ec$var$_teamText(person.email);
    return email ? `member:email:${email}` : '';
}
function $607b1f1ae0c009ec$export$80fefd073bb4cd18(person) {
    if (!person) return [];
    const keys = [
        $607b1f1ae0c009ec$export$8583c39f8702433(person)
    ];
    const email = $607b1f1ae0c009ec$var$_teamText(typeof person === 'string' ? person : person.email);
    if (email) keys.push(`member:email:${email}`);
    return [
        ...new Set(keys.filter(Boolean))
    ];
}
function $607b1f1ae0c009ec$export$ce5ce75591dd82a8(event, person) {
    const metadata = event?.integrationMetadata || {};
    const responses = metadata.calendarParticipantResponses || {};
    const occurrenceResponses = metadata.calendarParticipantResponseOverrides?.[event?.date] || {};
    const responseChanges = metadata.calendarParticipantResponseChanges || {};
    for (const key of $607b1f1ae0c009ec$export$80fefd073bb4cd18(person)){
        if (occurrenceResponses[key]) return occurrenceResponses[key];
        const datedResponse = (responseChanges[key] || []).reduce((latest, change)=>{
            if (!change?.from || change.from > event?.date) return latest;
            return !latest || change.from >= latest.from ? change : latest;
        }, null);
        if (datedResponse?.status) return datedResponse.status;
        if (responses[key]) return responses[key];
    }
    return '';
}
function $607b1f1ae0c009ec$export$b9e9e5f5390ff69(event, person) {
    return $607b1f1ae0c009ec$export$ce5ce75591dd82a8(event, person) === 'declined';
}
// Shared consumer domains cannot establish a teammate's identity by name.
// Exact email and stable member-key matches remain valid for these providers.
const $607b1f1ae0c009ec$var$_publicCalendarMailDomains = new Set([
    'gmail.com',
    'googlemail.com',
    'outlook.com',
    'hotmail.com',
    'live.com',
    'msn.com',
    'yahoo.com',
    'ymail.com',
    'rocketmail.com',
    'aol.com',
    'aim.com',
    'icloud.com',
    'me.com',
    'mac.com',
    'proton.me',
    'protonmail.com',
    'pm.me',
    'fastmail.com',
    'fastmail.fm',
    'hey.com',
    'mail.com',
    'email.com',
    'gmx.com',
    'gmx.net',
    'gmx.de',
    'web.de',
    't-online.de',
    'yandex.com',
    'yandex.ru',
    'ya.ru',
    'mail.ru',
    'inbox.ru',
    'list.ru',
    'bk.ru',
    'qq.com',
    'foxmail.com',
    '163.com',
    '126.com',
    'naver.com',
    'daum.net',
    'hanmail.net'
]);
const $607b1f1ae0c009ec$var$_publicCalendarMailDomain = (domain)=>$607b1f1ae0c009ec$var$_publicCalendarMailDomains.has(domain) || /^(?:yahoo|hotmail|outlook|live|msn|aol|gmx|yandex)\.(?:[a-z]{2,3}|co\.[a-z]{2}|com\.[a-z]{2})$/.test(domain);
function $607b1f1ae0c009ec$export$b806e3b4e15b9dff(event, person, people = [], viewerEmail = '') {
    if (!event || !person || $607b1f1ae0c009ec$export$b9e9e5f5390ff69(event, person)) return false;
    const memberKey = $607b1f1ae0c009ec$export$8583c39f8702433(person);
    const roster = people.length ? people : [
        person
    ];
    const domain = (email)=>$607b1f1ae0c009ec$var$_teamText(email).split('@')[1] || '';
    const domains = new Set([
        ...roster.map((member)=>domain(member.email)),
        domain(viewerEmail)
    ].filter(Boolean));
    const matches = (email)=>{
        const normalized = $607b1f1ae0c009ec$var$_teamText(email);
        if (!normalized || !domain(normalized)) return false;
        const exact = roster.filter((member)=>$607b1f1ae0c009ec$var$_teamText(member.email) === normalized);
        if (exact.length === 1) return $607b1f1ae0c009ec$export$8583c39f8702433(exact[0]) === memberKey;
        if ($607b1f1ae0c009ec$var$_publicCalendarMailDomain(domain(normalized)) || !domains.has(domain(normalized))) return false;
        const owner = $607b1f1ae0c009ec$export$8fa301b8b7f39c16(roster, normalized);
        // A known, unique email must never be replaced by a name-based guess.
        const ownerEmail = $607b1f1ae0c009ec$var$_teamText(owner?.email);
        if (ownerEmail && ownerEmail !== normalized && roster.filter((member)=>$607b1f1ae0c009ec$var$_teamText(member.email) === ownerEmail).length === 1) return false;
        return Boolean(memberKey && $607b1f1ae0c009ec$export$8583c39f8702433(owner) === memberKey);
    };
    if (event.googleCalendarId) return matches(event.googleCalendarId);
    return (event.integrationMetadata?.calendarInviteeMemberKeys || []).includes(memberKey) || matches(event.creatorEmail) || (event.invitees || []).some(matches);
}
function $607b1f1ae0c009ec$export$420e2c7fbcbfb6de(events, viewerEmail) {
    const unique = new Map();
    for (const event of events || []){
        const uid = event.googleEventId;
        const key = uid ? JSON.stringify([
            uid,
            event.startAt || event.date,
            event.startTime
        ]) : event;
        const previous = unique.get(key);
        if (!previous || event.googleCalendarId === viewerEmail) unique.set(key, event);
    }
    return [
        ...unique.values()
    ];
}
function $607b1f1ae0c009ec$export$85cc5906243df3d6(booking, now = new Date()) {
    if (!booking?.date) return false;
    const [year, month, day] = String(booking.date).split('-').map(Number);
    const [hours, minutes] = String(booking.allDay ? '00:00' : booking.startTime || '').split(':').map(Number);
    if (![
        year,
        month,
        day,
        hours,
        minutes
    ].every(Number.isFinite)) return false;
    const boundary = new Date(now);
    boundary.setSeconds(0, 0);
    if (booking.allDay) boundary.setHours(0, 0, 0, 0);
    return new Date(year, month - 1, day, hours, minutes).getTime() < boundary.getTime();
}
function $607b1f1ae0c009ec$export$9d9643e1852dffa0(booking) {
    if (booking?.allDay || !booking?.date || !booking?.startTime || !booking?.endTime) return false;
    const endDate = booking.endDate || booking.date;
    if (endDate < booking.date) return true;
    return endDate === booking.date && booking.endTime <= booking.startTime;
}
const $607b1f1ae0c009ec$var$_rsvpSnapshotKey = (eventId)=>`calendar:rsvp:${String(eventId || '')}`;
const $607b1f1ae0c009ec$var$_rsvpEventFingerprint = (event)=>[
        event?.title,
        event?.date,
        event?.startTime,
        event?.endTime
    ].map((value)=>value || '').join('|');
const $607b1f1ae0c009ec$var$_rsvpStorage = ()=>{
    if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;
    if (typeof globalThis !== 'undefined' && globalThis.localStorage) return globalThis.localStorage;
    return null;
};
function $607b1f1ae0c009ec$export$f1ab6ee1da6603d7(event, pendingStatus = '', pendingScope = '') {
    if (!event?.id) return;
    const snapshot = {
        event: event,
        pendingStatus: pendingStatus || '',
        pendingScope: pendingScope || ''
    };
    if (typeof window !== 'undefined' && window.history?.replaceState) try {
        const url = new URL(window.location.href);
        if (pendingStatus) {
            const eventSnapshot = {
                id: event.id,
                title: event.title,
                date: event.date,
                startTime: event.startTime,
                endTime: event.endTime,
                startAt: event.startAt,
                endAt: event.endAt,
                googleEventId: event.googleEventId
            };
            url.searchParams.set('eventSeries', $607b1f1ae0c009ec$var$_baseEventId(event.googleEventId) || '');
            url.searchParams.set('eventFingerprint', $607b1f1ae0c009ec$var$_rsvpEventFingerprint(event));
            url.searchParams.set('eventSnapshot', JSON.stringify(eventSnapshot));
            url.searchParams.set('eventRsvp', pendingStatus);
            url.searchParams.set('eventRsvpScope', pendingScope || 'future');
        }
        window.history.replaceState(null, '', url.toString());
    } catch (_) {}
    const storage = $607b1f1ae0c009ec$var$_rsvpStorage();
    if (!storage) return;
    try {
        storage.setItem($607b1f1ae0c009ec$var$_rsvpSnapshotKey(event.id), JSON.stringify(snapshot));
    } catch (_) {}
}
function $607b1f1ae0c009ec$export$3b838584fa32a25f(eventId) {
    if (!eventId) return null;
    const storage = $607b1f1ae0c009ec$var$_rsvpStorage();
    if (!storage) return null;
    try {
        const snapshot = JSON.parse(storage.getItem($607b1f1ae0c009ec$var$_rsvpSnapshotKey(eventId)) || 'null');
        return snapshot?.event ? snapshot : null;
    } catch (_) {
        return null;
    }
}
function $607b1f1ae0c009ec$export$40a1dd44237c5fee(people, selected = []) {
    const all = Array.isArray(people) ? people : [];
    const selectors = selected.length ? selected : $607b1f1ae0c009ec$export$e60f091a107fbea0;
    // Once the user removes a column, the selection is materialised as stable
    // member keys so two people with the same first name remain independent.
    if (selectors.every((selector)=>$607b1f1ae0c009ec$var$_teamText(selector).startsWith('member:'))) {
        const byKey = new Map(all.map((person)=>[
                $607b1f1ae0c009ec$export$8583c39f8702433(person),
                person
            ]));
        return selectors.map((selector)=>byKey.get(selector)).filter(Boolean);
    }
    const emailCounts = new Map();
    for (const person of all){
        const email = $607b1f1ae0c009ec$var$_teamText(person?.email);
        if (email) emailCounts.set(email, (emailCounts.get(email) || 0) + 1);
    }
    const uniqueEmails = new Set(Array.from(emailCounts.entries()).filter(([, count])=>count === 1).map(([email])=>email));
    return all.filter((person)=>selectors.some((selector)=>$607b1f1ae0c009ec$var$_teamMemberMatchesSelector(person, selector, uniqueEmails)));
}
function $607b1f1ae0c009ec$export$aea462df519fee06(people, selected, person) {
    const removeKey = $607b1f1ae0c009ec$export$8583c39f8702433(person);
    if (!removeKey) return selected || [];
    return $607b1f1ae0c009ec$export$40a1dd44237c5fee(people, selected).map($607b1f1ae0c009ec$export$8583c39f8702433).filter((key)=>key && key !== removeKey);
}
function $607b1f1ae0c009ec$export$8fa301b8b7f39c16(people, query) {
    const all = Array.isArray(people) ? people : [];
    const raw = $607b1f1ae0c009ec$var$_teamText(query);
    if (!raw) return null;
    const local = $607b1f1ae0c009ec$var$_teamWords(raw.split('@')[0]);
    const words = $607b1f1ae0c009ec$var$_teamWords(raw);
    const exactEmailMatches = all.filter((person)=>$607b1f1ae0c009ec$var$_teamText(person?.email) === raw);
    if (exactEmailMatches.length === 1) return exactEmailMatches[0];
    const aliasedName = $607b1f1ae0c009ec$var$_teamDirectoryNameAliases[local];
    if (aliasedName) {
        const aliasedPerson = all.find((person)=>$607b1f1ae0c009ec$var$_teamWords(person?.name) === aliasedName);
        if (aliasedPerson) return aliasedPerson;
    }
    const exactUsername = all.find((person)=>$607b1f1ae0c009ec$var$_teamWords(person?.username || person?.slug) === local);
    if (exactUsername) return exactUsername;
    const exactName = all.find((person)=>{
        const name = $607b1f1ae0c009ec$var$_teamWords(person?.name);
        return name === words || name === local;
    });
    if (exactName) return exactName;
    const firstNameMatches = all.filter((person)=>$607b1f1ae0c009ec$var$_teamWords(person?.name).split(' ')[0] === local);
    return firstNameMatches.length === 1 ? firstNameMatches[0] : null;
}
function $607b1f1ae0c009ec$export$999d7ceb0340ba99(people, query, selected = [], limit = 6) {
    const all = Array.isArray(people) ? people : [];
    const raw = $607b1f1ae0c009ec$var$_teamText(query);
    if (!raw) return [];
    const local = $607b1f1ae0c009ec$var$_teamWords(raw.split('@')[0]);
    const words = $607b1f1ae0c009ec$var$_teamWords(raw);
    const aliasedName = $607b1f1ae0c009ec$var$_teamDirectoryNameAliases[local];
    const visibleKeys = new Set($607b1f1ae0c009ec$export$40a1dd44237c5fee(all, selected).map($607b1f1ae0c009ec$export$8583c39f8702433));
    const emailCounts = new Map();
    for (const person of all){
        const email = $607b1f1ae0c009ec$var$_teamText(person?.email);
        if (email) emailCounts.set(email, (emailCounts.get(email) || 0) + 1);
    }
    return all.map((person, index)=>{
        if (visibleKeys.has($607b1f1ae0c009ec$export$8583c39f8702433(person))) return null;
        const email = $607b1f1ae0c009ec$var$_teamText(person?.email);
        const emailLocal = $607b1f1ae0c009ec$var$_teamWords(email.split('@')[0]);
        const usernameValue = $607b1f1ae0c009ec$var$_teamText(person?.username || person?.slug);
        const username = $607b1f1ae0c009ec$var$_teamWords(usernameValue);
        const name = $607b1f1ae0c009ec$var$_teamWords(person?.name);
        const nameParts = name.split(' ');
        const uniqueEmail = email && emailCounts.get(email) === 1;
        let score = Number.POSITIVE_INFINITY;
        if (uniqueEmail && email === raw) score = 0;
        else if (username && username === local) score = 1;
        else if (aliasedName && name === aliasedName) score = 2;
        else if (name === words || name === local || uniqueEmail && emailLocal === local) score = 3;
        else if (username && username.startsWith(local)) score = 4;
        else if (name.startsWith(words) || name.startsWith(local)) score = 5;
        else if (nameParts.some((part)=>part.startsWith(local))) score = 6;
        else if (uniqueEmail && (email.includes(raw) || emailLocal.includes(local))) score = 7;
        if (!Number.isFinite(score)) return null;
        const identity = usernameValue ? `@${usernameValue}` : uniqueEmail ? email : '';
        return {
            person: {
                ...person,
                _calendarTeamIdentity: identity
            },
            score: score,
            index: index
        };
    }).filter(Boolean).sort((a, b)=>a.score - b.score || a.index - b.index).slice(0, Math.max(0, limit)).map(({ person: person })=>person);
}
function $607b1f1ae0c009ec$export$13cfbf95ba9b2ed2(people, selected, person) {
    const addKey = $607b1f1ae0c009ec$export$8583c39f8702433(person);
    const current = $607b1f1ae0c009ec$export$40a1dd44237c5fee(people, selected).map($607b1f1ae0c009ec$export$8583c39f8702433).filter(Boolean);
    if (!addKey || current.includes(addKey)) return current;
    return [
        ...current,
        addKey
    ];
}
// CalHeader.Title / CalMain's own nav read `getMonthLabel(root.currentYear,
// root.currentMonth)` straight off ROOT state — real usage always has a
// CalMain-family ancestor seed both before this ever renders (TodayBtn's
// onClick, page boot, …). A bare mount (catalog `if:false`-scoped MCP
// probes; SSR/hydration races before that seed lands) has neither, so
// `MONTH_NAMES[undefined]` -> `undefined`, stringifying to the literal
// "undefined undefined" (tickets/sonnet.md CAT-3). "Today" is the only
// honest default for an unset calendar cursor — same defensive-fallback
// class as `getWeekDays` below.
function $607b1f1ae0c009ec$var$_yearOrToday(year) {
    return Number.isFinite(year) ? year : new Date().getFullYear();
}
function $607b1f1ae0c009ec$var$_monthOrToday(month) {
    return Number.isFinite(month) ? month : new Date().getMonth();
}
function $607b1f1ae0c009ec$export$e7af3ee2c84591cc(year, month) {
    return $607b1f1ae0c009ec$var$MONTH_NAMES[$607b1f1ae0c009ec$var$_monthOrToday(month)];
}
function $607b1f1ae0c009ec$export$5492c4ce9d26d774(year, month) {
    return `${$607b1f1ae0c009ec$var$MONTH_NAMES[$607b1f1ae0c009ec$var$_monthOrToday(month)]} ${$607b1f1ae0c009ec$var$_yearOrToday(year)}`;
}
function $607b1f1ae0c009ec$export$f2cf7cfc766f30df(year) {
    return $607b1f1ae0c009ec$var$_yearOrToday(year);
}
function $607b1f1ae0c009ec$export$d03409b923543a08() {
    return $607b1f1ae0c009ec$var$DAY_NAMES;
}
function $607b1f1ae0c009ec$export$214c174a056fc56f(year, month) {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysInPrevMonth = new Date(year, month, 0).getDate();
    const days = [];
    // Normalize previous month (handles January -> December of previous year)
    const prevMonthDate = new Date(year, month - 1, 1);
    const prevYear = prevMonthDate.getFullYear();
    const prevMonth = prevMonthDate.getMonth();
    // Pad start with previous month days
    for(let i = firstDay - 1; i >= 0; i--)days.push({
        day: daysInPrevMonth - i,
        month: prevMonth,
        year: prevYear,
        isOtherMonth: true
    });
    // Current month
    for(let d = 1; d <= daysInMonth; d++)days.push({
        day: d,
        month: month,
        year: year,
        isOtherMonth: false
    });
    // Normalize next month (handles December -> January of next year)
    const nextMonthDate = new Date(year, month + 1, 1);
    const nextYear = nextMonthDate.getFullYear();
    const nextMonth = nextMonthDate.getMonth();
    // Pad end to complete 6 rows (42 cells)
    const remaining = 42 - days.length;
    for(let d = 1; d <= remaining; d++)days.push({
        day: d,
        month: nextMonth,
        year: nextYear,
        isOtherMonth: true
    });
    return days;
}
function $607b1f1ae0c009ec$export$629b0a497aa65267(year, month, day) {
    const t = new Date();
    return t.getFullYear() === year && t.getMonth() === month && t.getDate() === day;
}
function $607b1f1ae0c009ec$export$3ae94a2503e890a1(year, month, day) {
    const m = String(month + 1).padStart(2, '0');
    const d = String(day).padStart(2, '0');
    return `${year}-${m}-${d}`;
}
const $607b1f1ae0c009ec$var$_DAY_MS = 86400000;
// Greedy lane packing — assigns each event a `_lane` (0-indexed column)
// and `_lanes` (total columns its overlap cluster needs). Used by the week
// view to render side-by-side overlapping events without them stacking on
// top of each other. O(n²) but n is small (events on one day).
const $607b1f1ae0c009ec$var$_toMins = (t)=>{
    const [h, m] = (t || '00:00').split(':').map(Number);
    return h * 60 + m;
};
function $607b1f1ae0c009ec$export$5e82f59d50595df4(evs) {
    if (!evs.length) return evs;
    // Shallow-clone every event so we don't mutate the canonical events array.
    const sorted = evs.map((e)=>({
            ...e
        })).sort((a, b)=>$607b1f1ae0c009ec$var$_toMins(a.startTime) - $607b1f1ae0c009ec$var$_toMins(b.startTime));
    // Group into overlap clusters: events that transitively overlap end up in
    // the same cluster and share the same lane count.
    const clusters = [];
    let cur = null;
    let curEnd = -1;
    for (const ev of sorted){
        const s = $607b1f1ae0c009ec$var$_toMins(ev.startTime);
        const e = $607b1f1ae0c009ec$var$_toMins(ev.endTime);
        if (cur && s < curEnd) {
            cur.push(ev);
            if (e > curEnd) curEnd = e;
        } else {
            cur = [
                ev
            ];
            clusters.push(cur);
            curEnd = e;
        }
    }
    for (const cluster of clusters){
        // Assign lanes within the cluster — pack each event into the lowest lane
        // whose last event has already ended.
        const laneEnds = [];
        for (const ev of cluster){
            const s = $607b1f1ae0c009ec$var$_toMins(ev.startTime);
            const e = $607b1f1ae0c009ec$var$_toMins(ev.endTime);
            let lane = laneEnds.findIndex((end)=>end <= s);
            if (lane === -1) {
                lane = laneEnds.length;
                laneEnds.push(e);
            } else laneEnds[lane] = e;
            ev._lane = lane;
        }
        const total = laneEnds.length;
        for (const ev of cluster)ev._lanes = total;
    }
    return sorted;
}
// Cross-midnight tail: an event with `endTime <= startTime` actually runs
// past midnight into the next day. The start day shows the [startTime, 24:00]
// portion (clipped via eventToHeight); this helper produces a synthetic
// [00:00, endTime] piece for the next day.
const $607b1f1ae0c009ec$var$_isCrossMidnight = (ev)=>{
    if (!ev?.startTime || !ev?.endTime) return false;
    const [sh, sm] = ev.startTime.split(':').map(Number);
    const [eh, em] = ev.endTime.split(':').map(Number);
    return eh * 60 + em <= sh * 60 + sm;
};
function $607b1f1ae0c009ec$export$e2572468fb9b0fd1(events, year, month, day) {
    const dateStr = $607b1f1ae0c009ec$export$3ae94a2503e890a1(year, month, day);
    const target = new Date(year, month, day);
    const prevDate = $607b1f1ae0c009ec$export$3ae94a2503e890a1(year, month, day - 1) // JS Date normalizes day=0/-1
    ;
    const out = [];
    for (const ev of events || []){
        // Cross-midnight tail from yesterday → render as a [00:00, endTime] piece.
        if (ev.date === prevDate && $607b1f1ae0c009ec$var$_isCrossMidnight(ev)) {
            // The tail belongs to YESTERDAY's occurrence — if that occurrence is
            // excluded (or otherwise disallowed by the rule), its tail must not
            // render either.
            if (ev.recurring && ev.recurring !== 'none' && !(0, $eQSi7.recurrenceAllowsDate)(ev, new Date(year, month, day - 1))) continue;
            out.push({
                ...ev,
                startTime: '00:00',
                _isCrossTail: true
            });
            continue;
        }
        if (ev.date === dateStr) {
            if (ev.recurring && ev.recurring !== 'none' && !(0, $eQSi7.recurrenceAllowsDate)(ev, target)) continue;
            out.push(ev);
            continue;
        }
        if (!ev.recurring || ev.recurring === 'none') continue;
        if ((0, $eQSi7.recurrenceAllowsDate)(ev, target)) out.push({
            ...ev,
            date: dateStr
        });
    }
    return out;
}
const $607b1f1ae0c009ec$export$d0e73eb52e587409 = 56;
const $607b1f1ae0c009ec$export$545d628082486514 = 15;
// Intl.DateTimeFormat is expensive to construct (one of the slowest things
// in JS). Cache one per timezone so the hot loops in availability/header
// renders don't allocate hundreds per minute tick.
const $607b1f1ae0c009ec$var$_timeFmt = new Map();
const $607b1f1ae0c009ec$var$_dateFmt = new Map();
// WHICH CLOCK. #2265 made every calendar view show ONE clock, and chose the
// 12-hour one. The point was one clock across the views, not AM / PM: in a
// Georgian session `4:00 PM` is Latin text on a Georgian calendar, and a
// 12-hour clock is not how the language tells time. So the clock follows the
// SESSION LANGUAGE — every view still agrees, because every view asks here.
// A caller with no language gets English, which is what it got before.
const $607b1f1ae0c009ec$var$CALENDAR_HOUR12_LANGS = [
    'en'
];
const $607b1f1ae0c009ec$export$53370be9fcf227b9 = (lang)=>$607b1f1ae0c009ec$var$CALENDAR_HOUR12_LANGS.includes(String(lang || 'en').toLowerCase().split('-')[0]);
const $607b1f1ae0c009ec$export$379b0c9dd9309abd = (ms, tz, lang)=>{
    const hour12 = $607b1f1ae0c009ec$export$53370be9fcf227b9(lang);
    const cacheKey = `${tz}|${hour12 ? 12 : 24}`;
    let f = $607b1f1ae0c009ec$var$_timeFmt.get(cacheKey);
    if (!f) {
        f = hour12 ? new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }) : new Intl.DateTimeFormat('en-GB', {
            timeZone: tz,
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23'
        });
        $607b1f1ae0c009ec$var$_timeFmt.set(cacheKey, f);
    }
    return f.format(ms);
};
// The DATA clock of a zone: minutes since local midnight. Read from the h23
// PARTS, never from display text. The availability math used to parse
// `formatTzTime`; when #2265 turned that into `4:00 PM`, `hhmmToMin` answered
// NaN, every comparison went false, and a member with working hours read as
// unavailable for the whole day (availabilityClock.test.js).
const $607b1f1ae0c009ec$var$_clockFmt = new Map();
const $607b1f1ae0c009ec$export$62bbcb44be509390 = (ms, tz)=>{
    let f = $607b1f1ae0c009ec$var$_clockFmt.get(tz);
    if (!f) {
        f = new Intl.DateTimeFormat('en-US', {
            timeZone: tz,
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23'
        });
        $607b1f1ae0c009ec$var$_clockFmt.set(tz, f);
    }
    let hour = 0;
    let minute = 0;
    for (const part of f.formatToParts(ms)){
        if (part.type === 'hour') hour = Number(part.value) % 24;
        else if (part.type === 'minute') minute = Number(part.value);
    }
    return hour * 60 + minute;
};
const $607b1f1ae0c009ec$export$b64d9bf67c4faac9 = (ms, tz)=>{
    let f = $607b1f1ae0c009ec$var$_dateFmt.get(tz);
    if (!f) {
        f = new Intl.DateTimeFormat('en-CA', {
            timeZone: tz,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
        $607b1f1ae0c009ec$var$_dateFmt.set(tz, f);
    }
    // en-CA returns YYYY-MM-DD already
    return f.format(ms).replace(/\u2010|\u2013/g, '-');
};
const $607b1f1ae0c009ec$export$361693031ac6effa = (s)=>{
    if (!s) return 0;
    const [h, m] = s.split(':').map(Number);
    return h * 60 + m;
};
const $607b1f1ae0c009ec$export$17176dec6259f9c6 = (n)=>{
    const total = Math.max(0, Math.min(1440, Math.round(n)));
    const h = Math.floor(total / 60);
    const m = total % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};
const $607b1f1ae0c009ec$export$91121fc77411a436 = (dateStr, timeStr)=>{
    if (!dateStr || !timeStr) return 0;
    const [y, m, d] = dateStr.split('-').map(Number);
    const [h, mm] = timeStr.split(':').map(Number);
    return new Date(y, m - 1, d, h, mm).getTime();
};
// Backwards-compat aliases (private, so existing internal usages don't need a sweep)
const $607b1f1ae0c009ec$var$_formatTzDate = $607b1f1ae0c009ec$export$b64d9bf67c4faac9;
const $607b1f1ae0c009ec$var$_hhmmToMin = $607b1f1ae0c009ec$export$361693031ac6effa;
// Returns null (available), or one of 'static' / 'event' for unavailability.
//   'static' = outside working hours (general off-hours, configured in profile)
//   'event'  = busy/OOO event from the events array (custom, ad-hoc)
//
// Events with type='busy' (intra-day, has startTime/endTime) and type='ooo'
// (full-day, may have endDate) on the events list are read inline so the
// helper has a single source of truth shared by every view.
function $607b1f1ae0c009ec$var$_availabilityType(ms, member, events) {
    if (!member?.timezone) return null;
    const tz = member.timezone;
    const localDate = $607b1f1ae0c009ec$var$_formatTzDate(ms, tz);
    const cur = $607b1f1ae0c009ec$export$62bbcb44be509390(ms, tz);
    // Event-type: busy events from the events array. Busy + OOO are merged
    // into a single 'busy' type. If endDate is set (or differs from date),
    // it's a multi-day full-day block. Otherwise it's an intra-day time range.
    for (const ev of events || []){
        if (ev.type !== 'busy') continue;
        if (!(ev.invitees || []).includes(member.email)) continue;
        const isMultiDay = ev.endDate && ev.endDate !== ev.date;
        if (isMultiDay) {
            if (localDate >= ev.date && localDate <= ev.endDate) return 'event';
        } else {
            if (ev.date !== localDate) continue;
            const s = $607b1f1ae0c009ec$var$_hhmmToMin(ev.startTime || '00:00');
            const e = $607b1f1ae0c009ec$var$_hhmmToMin(ev.endTime || '24:00');
            if (cur >= s && cur < e) return 'event';
        }
    }
    // Static: outside working hours (handles midnight-spanning ranges where end < start)
    const wh = member.workingHours;
    if (wh) {
        const start = $607b1f1ae0c009ec$var$_hhmmToMin(wh.start);
        const end = $607b1f1ae0c009ec$var$_hhmmToMin(wh.end);
        const inHours = start < end ? cur >= start && cur < end : cur >= start || cur < end // wraps midnight
        ;
        if (!inHours) return 'static';
    }
    return null;
}
function $607b1f1ae0c009ec$export$c3f95de39763f5b9(member, baseMs, totalMinutes = 1440, slotMinutes = 15, events = []) {
    if (!member) return [];
    // Day columns can render before their `baseMs` reactive prop resolves
    // (state still rehydrating). Skip those frames — Intl.DateTimeFormat
    // .format(NaN) throws "Invalid time value" and would tear down every
    // DayColumn in the smbls 3.14 week view.
    if (!Number.isFinite(baseMs)) return [];
    const STEP_MS = slotMinutes * 60000;
    const ranges = [];
    let curStart = null;
    let curType = null;
    const steps = Math.ceil(totalMinutes / slotMinutes);
    for(let i = 0; i <= steps; i++){
        const isLast = i >= steps;
        let type = null;
        if (!isLast) type = $607b1f1ae0c009ec$var$_availabilityType(baseMs + i * STEP_MS, member, events);
        if (type !== curType || isLast) {
            if (curType != null && curStart != null) ranges.push({
                startMin: curStart,
                endMin: i * slotMinutes,
                type: curType
            });
            curStart = type ? i * slotMinutes : null;
            curType = type;
        }
    }
    return ranges;
}
function $607b1f1ae0c009ec$export$e4ff15aebfb30c58(year, month, day) {
    const t = new Date();
    const ty = t.getFullYear();
    const tm = t.getMonth();
    const td = t.getDate();
    const ref = new Date(year, month, day);
    const dow = ref.getDay();
    const start = new Date(year, month, day - dow);
    const end = new Date(year, month, day - dow + 6);
    const today = new Date(ty, tm, td);
    return today >= start && today <= end;
}
function $607b1f1ae0c009ec$export$69ac73875782844e(year, month, day) {
    const y = $607b1f1ae0c009ec$var$_yearOrToday(year);
    const m = $607b1f1ae0c009ec$var$_monthOrToday(month);
    const dd = Number.isFinite(day) ? day : new Date().getDate();
    const d = new Date(y, m, dd);
    const dow = d.getDay();
    const days = [];
    for(let i = 0; i < 7; i++){
        const wd = new Date(y, m, dd - dow + i);
        days.push({
            year: wd.getFullYear(),
            month: wd.getMonth(),
            day: wd.getDate(),
            dayName: $607b1f1ae0c009ec$var$DAY_NAMES[i]
        });
    }
    return days;
}
function $607b1f1ae0c009ec$export$2971bc0866c6e18(year, month, day, viewMode) {
    const days = $607b1f1ae0c009ec$export$69ac73875782844e(year, month, day);
    if (viewMode !== 'day') return days;
    const selected = new Date($607b1f1ae0c009ec$var$_yearOrToday(year), $607b1f1ae0c009ec$var$_monthOrToday(month), Number.isFinite(day) ? day : new Date().getDate());
    return days.filter((date)=>date.year === selected.getFullYear() && date.month === selected.getMonth() && date.day === selected.getDate());
}
function $607b1f1ae0c009ec$export$257b40f71c07d58f() {
    const lang = this && typeof this.call === 'function' ? this.call('getActiveLang') : 'en';
    const hour12 = $607b1f1ae0c009ec$export$53370be9fcf227b9(lang);
    const hours = [];
    for(let h = 0; h < 24; h++){
        const label = !hour12 ? `${String(h).padStart(2, '0')}:00` : h === 0 ? '12 AM' : h < 12 ? `${h} AM` : h === 12 ? '12 PM' : `${h - 12} PM`;
        hours.push({
            h: h,
            label: label
        });
    }
    return hours;
}
function $607b1f1ae0c009ec$export$57c60d6c6403ce2c(creator, type, people, root) {
    if (!creator) return false;
    const isExt = (0, $aGIjc.isExternalEmail)(creator.email || creator, people);
    if (isExt) return true;
    if (type === 'general') return false;
    const r = root || this && this.state && this.state.root || null;
    return (0, $aGIjc.hasRole)(creator, 'superadmin', r);
}
function $607b1f1ae0c009ec$export$5606210727cdab7d(event, viewer, root) {
    if (!event?.isPrivate) return false;
    // Superadmin (the only role allowed to do this for now) can publish a
    // private event to the team via `isTeamShared`. Once it's shared, the
    // event renders normally for everyone.
    if (event.isTeamShared) return false;
    if (!viewer) return true;
    if (viewer.email === event.creatorEmail) return false;
    const r = root || this && this.state && this.state.root || null;
    if ((0, $aGIjc.hasRole)(viewer, 'superadmin', r)) return false;
    return true;
}
function $607b1f1ae0c009ec$export$6926fe71ee62ac69(event, root) {
    const r = root || this && this.state && this.state.root || null;
    if (!event || !r) return false;
    const me = String(r.currentUserEmail || '').trim().toLowerCase();
    const organizer = String(event.creatorEmail || '').trim().toLowerCase();
    if (me && organizer && me === organizer) return true;
    if ((r.jwtClaims || {}).symbols_roster_role === 'superadmin') return true;
    return (0, $aGIjc.shellIsSuperAdmin)({
        root: r
    }) === true;
}
const $607b1f1ae0c009ec$export$5e13f77326ed81c8 = (el, s)=>{
    if ($607b1f1ae0c009ec$export$5606210727cdab7d(s, (0, $aGIjc.currentUser)(s?.root), s?.root)) return 'green';
    if (s.type === 'general') return 'blue';
    if (s.type === 'busy') return 'red';
    return 'green';
};
function $607b1f1ae0c009ec$export$9531a1b422a90e8b(events, viewer, root) {
    const r = root || this && this.state && this.state.root || null;
    const now = Date.now();
    let best = null;
    let bestStartMs = Infinity;
    for (const ev of events || []){
        if (!ev || !ev.date) continue;
        if (ev.type && ev.type !== 'meeting' && ev.type !== 'general') continue;
        if ($607b1f1ae0c009ec$export$5606210727cdab7d(ev, viewer, r)) continue;
        const endMs = $607b1f1ae0c009ec$export$91121fc77411a436(ev.endDate || ev.date, ev.endTime || ev.startTime || '23:59');
        if (endMs && endMs < now) continue;
        const startMs = $607b1f1ae0c009ec$export$91121fc77411a436(ev.date, ev.startTime || '00:00');
        if (startMs < bestStartMs) {
            bestStartMs = startMs;
            best = ev;
        }
    }
    return best;
}
function $607b1f1ae0c009ec$export$96899ba0b3241643(events, year, month) {
    const days = $607b1f1ae0c009ec$export$214c174a056fc56f(year, month).filter((d)=>!d.isOtherMonth);
    let daysWithData = 0;
    let total = 0;
    for (const d of days){
        const n = $607b1f1ae0c009ec$export$e2572468fb9b0fd1(events, year, month, d.day).length;
        if (n > 0) daysWithData++;
        total += n;
    }
    return {
        days: daysWithData,
        events: total
    };
}
function $607b1f1ae0c009ec$export$5ee5e2a16be91d2d(events, event) {
    // If the event already has explicit recurrence info, use it.
    if (event?.recurring && event.recurring !== 'none') return {
        recurring: event.recurring,
        recurringDays: event.recurringDays || []
    };
    if (!event?.googleEventId) return {
        recurring: 'none',
        recurringDays: []
    };
    const baseId = $607b1f1ae0c009ec$var$_baseEventId(event.googleEventId);
    // No date suffix → not a recurring instance
    if (!baseId || baseId === event.googleEventId) return {
        recurring: 'none',
        recurringDays: []
    };
    const siblings = (events || []).filter((e)=>$607b1f1ae0c009ec$var$_baseEventId(e.googleEventId) === baseId);
    if (siblings.length < 2) return {
        recurring: 'none',
        recurringDays: []
    };
    // Unique sorted dates and their day-of-week
    const dateSet = new Set(siblings.map((e)=>e.date));
    const dates = [
        ...dateSet
    ].sort();
    const parsed = dates.map((d)=>{
        const [y, m, day] = d.split('-').map(Number);
        return new Date(y, m - 1, day);
    });
    const dows = [
        ...new Set(parsed.map((d)=>d.getDay()))
    ];
    // Consecutive intervals in days
    const intervals = [];
    for(let i = 1; i < parsed.length; i++)intervals.push(Math.round((parsed[i] - parsed[i - 1]) / $607b1f1ae0c009ec$var$_DAY_MS));
    if (!intervals.length) return {
        recurring: 'none',
        recurringDays: []
    };
    // Pattern detection
    if (intervals.every((i)=>i === 1)) return {
        recurring: 'daily',
        recurringDays: []
    };
    if (intervals.every((i)=>i === 7) && dows.length === 1) return {
        recurring: 'weekly',
        recurringDays: dows
    };
    if (intervals.every((i)=>i === 14) && dows.length === 1) return {
        recurring: 'biweekly',
        recurringDays: []
    };
    // Same day-of-month across months
    const doms = [
        ...new Set(parsed.map((d)=>d.getDate()))
    ];
    if (doms.length === 1 && intervals.every((i)=>i >= 28 && i <= 31)) return {
        recurring: 'monthly',
        recurringDays: []
    };
    // Weekday-only pattern (Mon–Fri)
    const allWeekdays = dows.every((d)=>d >= 1 && d <= 5);
    if (allWeekdays && dows.length === 5) return {
        recurring: 'weekdays',
        recurringDays: []
    };
    // Multiple days per week — treat as weekly with specific days
    if (dows.length >= 1 && dows.length <= 5) return {
        recurring: 'weekly',
        recurringDays: dows
    };
    return {
        recurring: 'weekly',
        recurringDays: dows
    };
}
// Fresh newBooking payload — merges any caller-provided overrides on top of
// a clean baseline so previously-typed fields (description, meetUrl, etc.)
// don't leak between modal opens.
const $607b1f1ae0c009ec$var$_nextBookingDate = (date)=>{
    if (!date) return '';
    const [year, month, day] = date.split('-').map(Number);
    const next = new Date(year, month - 1, day + 1);
    return $607b1f1ae0c009ec$export$3ae94a2503e890a1(next.getFullYear(), next.getMonth(), next.getDate());
};
function $607b1f1ae0c009ec$export$37f04dedae96c36c(overrides = {}) {
    const booking = {
        title: '',
        date: '',
        endDate: '',
        startTime: '09:00',
        endTime: '10:00',
        allDay: false,
        invitees: '',
        inviteeQuery: '',
        description: '',
        type: 'meeting',
        meetingMode: 'symbols-meet',
        meetUrl: '',
        recurring: 'none',
        recurringDays: [],
        ...(0, $eQSi7.DEFAULT_RECURRENCE_DRAFT),
        // Minutes-before-event reminder (#2200). `null` = no reminder.
        // Server-side persistence depends on a `reminder_minutes` column on
        // calendar_events — until that lands, the value round-trips through
        // the optimistic event but does not survive a refresh. See
        // tickets/server.md → "Calendar event reminder_minutes column".
        reminderMinutes: null,
        editingEventId: null,
        ...overrides
    };
    if (!booking.date) return booking;
    if (booking.endTime === '24:00') booking.endTime = '00:00';
    if (!booking.endDate) booking.endDate = booking.endTime <= booking.startTime ? $607b1f1ae0c009ec$var$_nextBookingDate(booking.date) : booking.date;
    return booking;
}
function $607b1f1ae0c009ec$export$a791c2189f2df0e5(startTime) {
    // Guard against a not-yet-hydrated event chip (startTime unset) — the
    // real grid always supplies HH:MM, but a bare/mid-optimistic-update chip
    // shouldn't throw inside a reactive CSS factory (was `undefined.split`).
    if (!startTime) return 0;
    const [h, m] = startTime.split(':').map(Number);
    return (h * 60 + m) / 60 * 56;
}
function $607b1f1ae0c009ec$export$75a7111b83ab7f54(startTime, endTime) {
    if (!startTime || !endTime) return 24;
    const [sh, sm] = startTime.split(':').map(Number);
    const [eh, em] = endTime.split(':').map(Number);
    const startMins = sh * 60 + sm;
    // Cross-midnight: clip to end-of-day (24:00). The next-day tail is rendered
    // separately by getEventsForDay's wrap-around branch.
    let endMins = eh * 60 + em;
    if (endMins <= startMins) endMins = 1440;
    return Math.max((endMins - startMins) / 60 * 56, 24);
}
function $607b1f1ae0c009ec$export$1064a26da00eecfc(px) {
    const totalMinutes = Math.max(0, Math.min(1425, Math.round(px / 56 * 60 / 15) * 15));
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
function $607b1f1ae0c009ec$export$2287e3d29250119e(time, mins) {
    const [h, m] = time.split(':').map(Number);
    const total = Math.min(1440, h * 60 + m + mins);
    const nh = Math.floor(total / 60);
    const nm = total % 60;
    return `${String(nh).padStart(2, '0')}:${String(nm).padStart(2, '0')}`;
}
function $607b1f1ae0c009ec$export$6f370a2ca055bfeb(color) {
    const map = {
        blue: 'eventBlue',
        green: 'eventGreen',
        red: 'eventRed',
        purple: 'eventPurple',
        orange: 'eventOrange',
        indigo: 'eventIndigo'
    };
    return map[color] || 'eventBlue';
}
function $607b1f1ae0c009ec$export$ef308314adc3ab58(year, month) {
    if (month === 0) return {
        year: year - 1,
        month: 11
    };
    return {
        year: year,
        month: month - 1
    };
}
function $607b1f1ae0c009ec$export$387da49966d7e375(year, month) {
    if (month === 11) return {
        year: year + 1,
        month: 0
    };
    return {
        year: year,
        month: month + 1
    };
}
// Cache the FETCHED DETAILS (not just a "seen" flag) keyed by event id.
// The home AppWindow pre-mounts /calendar and re-runs the lean events
// fetch on every re-open, which overwrites `root.events` with rows that
// lack description/invitees. The previous `Set` only recorded that an id
// had been fetched once and bailed on re-entry — so re-opening an event
// from `/` (after that lean overwrite) left the modal stuck on the lean
// row forever. Caching the data lets us RE-APPLY it on re-open without a
// network round-trip. `_detailInflight` dedupes concurrent fetches.
const $607b1f1ae0c009ec$var$_detailCache = new Map();
const $607b1f1ae0c009ec$var$_detailInflight = new Set();
// Extract the base recurring event ID (strip the date suffix).
// e.g. "09aql32kefq530bfigjd8gvarc_20260413T193000Z" → "09aql32kefq530bfigjd8gvarc"
const $607b1f1ae0c009ec$var$_baseEventId = (geid)=>geid ? geid.replace(/_\d{8}T\d{6}Z$/, '') : null;
// Merge resolved details into root.events (so every view sees them) and
// into selectedEvent (so the open modal updates).
const $607b1f1ae0c009ec$var$_applyEventDetails = (root, eventId, description, invitees)=>{
    const events = root.events || [];
    const next = events.map((e)=>e.id === eventId ? {
            ...e,
            description: description,
            invitees: invitees
        } : e);
    const updates = {
        events: next
    };
    if (root.selectedEvent?.id === eventId) updates.selectedEvent = {
        ...root.selectedEvent,
        description: description,
        invitees: invitees
    };
    root.update(updates);
};
async function $607b1f1ae0c009ec$export$3aed032d051fb152(eventId, root) {
    if (!eventId || !root) return;
    // An edited row already contains authoritative details. Prefer it over an
    // older lazy-fetch snapshot and refresh the cache before the reopened modal
    // derives participant/RSVP visibility from invitees.
    const local = (root.events || []).find((event)=>event.id === eventId);
    if (local && local.description !== undefined && Array.isArray(local.invitees)) {
        const details = {
            description: local.description,
            invitees: local.invitees
        };
        $607b1f1ae0c009ec$var$_detailCache.set(eventId, details);
        $607b1f1ae0c009ec$var$_applyEventDetails(root, eventId, details.description, details.invitees);
        return;
    }
    // Already resolved — re-apply the cached details. Crucial for re-opens
    // from the home AppWindow, where the lean events fetch has since wiped
    // description/invitees off the row in `root.events`.
    const cached = $607b1f1ae0c009ec$var$_detailCache.get(eventId);
    if (cached) {
        $607b1f1ae0c009ec$var$_applyEventDetails(root, eventId, cached.description, cached.invitees);
        return;
    }
    if ($607b1f1ae0c009ec$var$_detailInflight.has(eventId)) return;
    $607b1f1ae0c009ec$var$_detailInflight.add(eventId);
    try {
        // BY ID — GET /calendar/events/:id answers this event's row (404 for a
        // missing, deleted or unreadable one: the catch below). The `list` read
        // this used before could not select one row: the SDK sends only `filter`
        // (no `limit`, no `columns`) and the server reads only start_at, tags and
        // tenantId from it, so `{ id }` answered EVERY readable event in start
        // order and `result[0]` put the earliest event's description and
        // participants on this one. Only a row whose id IS this event's id may
        // fill its details.
        const row = await (0, $1NxyO.getSDK)().execute('workspaceProject.calendar', 'get', {
            id: eventId
        });
        const data = row && String(row.id) === String(eventId) ? row : null;
        if (!data) return;
        let invitees = data.invitees || [];
        let description = data.description;
        // If this instance has no invitees, inherit from a sibling (same recurring series)
        if (!invitees.length) {
            const ev = (root.events || []).find((e)=>e.id === eventId);
            const baseId = $607b1f1ae0c009ec$var$_baseEventId(ev?.googleEventId);
            if (baseId) {
                const sibling = (root.events || []).find((e)=>e.id !== eventId && e.invitees?.length && $607b1f1ae0c009ec$var$_baseEventId(e.googleEventId) === baseId);
                if (sibling) {
                    invitees = sibling.invitees;
                    if (!description && sibling.description) description = sibling.description;
                }
            }
        }
        $607b1f1ae0c009ec$var$_detailCache.set(eventId, {
            description: description,
            invitees: invitees
        });
        $607b1f1ae0c009ec$var$_applyEventDetails(root, eventId, description, invitees);
    } catch (e) {
        // Surface the failure instead of swallowing it — a silent catch here
        // made "modal stuck on Loading…" impossible to diagnose. Not cached,
        // so the next open retries.
        console.warn('[calendar] fetchEventDetails failed:', eventId, e?.message || e);
    } finally{
        $607b1f1ae0c009ec$var$_detailInflight.delete(eventId);
    }
}
function $607b1f1ae0c009ec$export$277907017aebc8c4(anchor) {
    const a = anchor instanceof Date ? anchor : new Date(anchor || Date.now());
    const monthStart = new Date(a.getFullYear(), a.getMonth(), 1);
    const monthEnd = new Date(a.getFullYear(), a.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
        gte: new Date(monthStart.getTime() - 14 * $607b1f1ae0c009ec$var$_DAY_MS).toISOString(),
        lte: new Date(monthEnd.getTime() + 45 * $607b1f1ae0c009ec$var$_DAY_MS).toISOString()
    };
}
const $607b1f1ae0c009ec$export$79281febdf88761e = 'id,title,date,start_time,end_time,end_date,start_at,end_at,color,type,reminder_minutes,integration_metadata,organizer_email,google_event_id,google_calendar_id';
const $607b1f1ae0c009ec$export$150323f4a3410297 = (r, userTz)=>{
    // Prefer the canonical UTC timestamps when present (synced rows). Fall
    // back to the legacy text fields for any rows created before migration
    // 0005 — those are stored in UTC strings already.
    let date = r.date;
    let startTime = r.start_time;
    let endTime = r.end_time;
    let endDate = r.end_date;
    if (r.start_at) {
        const s = new Date(r.start_at);
        date = (0, $6RzDA.localDate)(s, userTz);
        startTime = (0, $6RzDA.localTime)(s, userTz);
        if (r.end_at) {
            const e = new Date(r.end_at);
            endTime = (0, $6RzDA.localTime)(e, userTz);
            const ed = (0, $6RzDA.localDate)(e, userTz);
            if (ed !== date) endDate = ed;
        }
    }
    const integrationMetadata = r.integration_metadata && typeof r.integration_metadata === 'object' ? r.integration_metadata : {};
    return {
        id: r.id,
        title: r.title,
        date: date,
        startTime: startTime,
        endTime: endTime,
        endDate: endDate,
        startAt: r.start_at || null,
        endAt: r.end_at || null,
        color: r.color,
        type: r.type || 'meeting',
        description: r.description,
        invitees: r.invitees,
        reminderMinutes: r.reminder_minutes ?? null,
        ...(0, $eQSi7.recurrenceFieldsFromMetadata)(integrationMetadata),
        integrationMetadata: integrationMetadata,
        creatorEmail: r.organizer_email,
        googleEventId: r.google_event_id,
        googleCalendarId: r.google_calendar_id
    };
};
function $607b1f1ae0c009ec$export$bed3d4298c7957fc() {
    const stateRoot = this?.state?.root || this?.getRoot?.()?.state?.root;
    const viewKey = {
        week: 'CalWeekView',
        day: 'CalWeekView',
        team: 'CalTeamView',
        'team-now': 'CalTeamNowView'
    }[stateRoot?.viewMode];
    if (!viewKey) return false;
    const rootNode = this?.getRoot?.()?.node || this?.node?.ownerDocument?.body;
    const view = rootNode?.querySelector?.(`[data-key="${viewKey}"]`);
    if (!view) return false;
    const indicators = Array.from(view.querySelectorAll?.('[data-key="NowIndicator"], [data-key="NowLineWrap"]') || []);
    const indicator = indicators.find((node)=>(node.getClientRects?.().length || 0) > 0) || indicators[0];
    if (!indicator) return false;
    const scroll = ()=>{
        let scroller = indicator.parentElement;
        while(scroller && scroller !== view.parentElement){
            if (scroller.clientHeight > 0 && scroller.scrollHeight > scroller.clientHeight) break;
            scroller = scroller.parentElement;
        }
        if (!scroller || scroller === view.parentElement) return;
        const indicatorRect = indicator.getBoundingClientRect();
        const scrollerRect = scroller.getBoundingClientRect();
        const indicatorY = indicatorRect.top - scrollerRect.top + scroller.scrollTop;
        const top = Math.max(0, indicatorY - scroller.clientHeight / 2);
        if (typeof scroller.scrollTo === 'function') scroller.scrollTo({
            top: top,
            behavior: 'smooth'
        });
        else scroller.scrollTop = top;
    };
    // The Today state update can replace the visible week before the indicator
    // moves into today's column. Two frames let DOMQL finish that reactive pass
    // and the browser finish layout before measurements are taken.
    const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : null;
    if (raf) raf(()=>raf(scroll));
    else scroll();
    return true;
}
async function $607b1f1ae0c009ec$export$d8844966cb0df706(root, year, month) {
    const el = this;
    if (!root || year == null || month == null) return {
        ok: false
    };
    const fetcher = el && el.context && el.context.fetch;
    if (!fetcher || typeof fetcher.select !== 'function') return {
        ok: false
    };
    const monthStartISO = new Date(year, month, 1).toISOString();
    const monthEndISO = new Date(year, month + 1, 0, 23, 59, 59, 999).toISOString();
    const w = root._calWindow;
    if (w && w.gte <= monthStartISO && w.lte >= monthEndISO) return {
        ok: true,
        widened: false
    };
    if (root._calWindowLoading) return {
        ok: true,
        widened: false,
        pending: true
    };
    const target = $607b1f1ae0c009ec$export$277907017aebc8c4(new Date(year, month, 15));
    const union = {
        gte: w && w.gte < target.gte ? w.gte : target.gte,
        lte: w && w.lte > target.lte ? w.lte : target.lte
    };
    root.update({
        _calWindowLoading: true
    });
    try {
        const result = await fetcher.select({
            from: 'workspaceProject.calendar',
            select: $607b1f1ae0c009ec$export$79281febdf88761e,
            params: {
                deleted: false,
                start_at: {
                    gte: target.gte,
                    lte: target.lte
                }
            },
            order: 'start_at',
            limit: 2000
        });
        const rows = result && result.data;
        if (!rows) {
            root.update({
                _calWindowLoading: false
            });
            return {
                ok: false,
                widened: false
            };
        }
        const merged = new Map();
        for (const r of rows){
            const ev = $607b1f1ae0c009ec$export$150323f4a3410297(r);
            merged.set(ev.googleEventId || `local-${ev.id}`, ev);
        }
        for (const ev of root.events || []){
            const k = ev.googleEventId || `local-${ev.id}`;
            if (!merged.has(k)) merged.set(k, ev);
        }
        const events = [
            ...merged.values()
        ].sort((a, b)=>String(a.startAt || a.date).localeCompare(String(b.startAt || b.date)));
        root.update({
            events: events,
            _calWindow: union,
            _calWindowLoading: false
        });
        return {
            ok: true,
            widened: true
        };
    } catch (e) {
        console.warn('[calendar] ensureCalendarWindow failed:', e?.message || e);
        root.update({
            _calWindowLoading: false
        });
        return {
            ok: false,
            error: String(e?.message || e)
        };
    }
}

});
parcelRegister("eQSi7", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RECURRENCE_DRAFT", () => $ad00092495fc9667$export$f30d49a7e0bac282);
$parcel$export(module.exports, "normalizeOccurrenceCount", () => $ad00092495fc9667$export$700b2bfd94a28629);
$parcel$export(module.exports, "recurrencePayloadFromBooking", () => $ad00092495fc9667$export$eeca7ad8a15ee007);
$parcel$export(module.exports, "recurrenceFieldsFromMetadata", () => $ad00092495fc9667$export$6c0761231f7b21b2);
$parcel$export(module.exports, "recurrenceMetadataForEvent", () => $ad00092495fc9667$export$eead29cd610c403e);
$parcel$export(module.exports, "recurrenceAllowsDate", () => $ad00092495fc9667$export$4ac17e788b020d26);
const $ad00092495fc9667$var$DAY_MS = 86400000;
const $ad00092495fc9667$var$DEFAULT_OCCURRENCE_COUNT = 10;
const $ad00092495fc9667$var$MAX_OCCURRENCE_COUNT = 999;
const $ad00092495fc9667$var$SHIFTED_DIGITS = {
    ')': '0',
    '!': '1',
    '@': '2',
    '#': '3',
    $: '4',
    '%': '5',
    '^': '6',
    '&': '7',
    '*': '8',
    '(': '9'
};
const $ad00092495fc9667$export$f30d49a7e0bac282 = Object.freeze({
    recurrenceEndType: 'after',
    recurrenceEndCount: $ad00092495fc9667$var$DEFAULT_OCCURRENCE_COUNT,
    recurrenceEndDate: ''
});
const $ad00092495fc9667$var$clampOccurrenceCount = (value, fallback = 1)=>Math.max(1, Math.min($ad00092495fc9667$var$MAX_OCCURRENCE_COUNT, Math.floor(Number(value) || fallback)));
const $ad00092495fc9667$export$700b2bfd94a28629 = (value)=>{
    const digits = String(value ?? '').split('').map((character)=>$ad00092495fc9667$var$SHIFTED_DIGITS[character] || character).join('').replace(/\D/g, '');
    return digits ? $ad00092495fc9667$var$clampOccurrenceCount(digits) : '';
};
const $ad00092495fc9667$export$eeca7ad8a15ee007 = (booking)=>{
    const recurring = booking?.recurring || 'none';
    if (recurring === 'none') return {
        recurring: recurring,
        recurringDays: [],
        recurrenceEndType: null,
        recurrenceEndCount: null,
        recurrenceEndDate: ''
    };
    const recurrenceEndType = booking?.recurrenceEndType === 'on' ? 'on' : 'after';
    return {
        recurring: recurring,
        recurringDays: recurring === 'weekly' ? booking?.recurringDays || [] : [],
        recurrenceEndType: recurrenceEndType,
        recurrenceEndCount: recurrenceEndType === 'after' ? $ad00092495fc9667$var$clampOccurrenceCount(booking?.recurrenceEndCount, $ad00092495fc9667$var$DEFAULT_OCCURRENCE_COUNT) : null,
        recurrenceEndDate: recurrenceEndType === 'on' ? booking?.recurrenceEndDate || booking?.date || '' : ''
    };
};
const $ad00092495fc9667$export$6c0761231f7b21b2 = (metadata)=>{
    const recurrence = metadata?.recurrence && typeof metadata.recurrence === 'object' ? metadata.recurrence : null;
    return {
        recurring: recurrence?.frequency || 'none',
        recurringDays: Array.isArray(recurrence?.days) ? recurrence.days : [],
        recurrenceExcludedDates: Array.isArray(recurrence?.excludedDates) ? recurrence.excludedDates : [],
        recurrenceEndType: recurrence?.end?.type || null,
        recurrenceEndCount: recurrence?.end?.count ?? null,
        recurrenceEndDate: recurrence?.end?.date || ''
    };
};
const $ad00092495fc9667$export$eead29cd610c403e = (event)=>{
    if (event?.recurring === undefined && event?.integrationMetadata === undefined) return undefined;
    const metadata = {
        ...event?.integrationMetadata || {}
    };
    const rule = $ad00092495fc9667$export$eeca7ad8a15ee007(event);
    if (rule.recurring === 'none') {
        delete metadata.recurrence;
        return metadata;
    }
    // metadata.recurrence is REBUILT below, so an exclusion list persisted by
    // an earlier "delete only this event" must be carried forward explicitly.
    // A payload that OMITS recurrenceExcludedDates (an edit from a surface
    // without the events window) means "unchanged", never "cleared" — only an
    // explicit array (even an empty one) overrides the stored list.
    const prevExcluded = Array.isArray(metadata.recurrence?.excludedDates) ? metadata.recurrence.excludedDates : [];
    const excluded = event.recurrenceExcludedDates === undefined ? prevExcluded : event.recurrenceExcludedDates;
    metadata.recurrence = {
        frequency: rule.recurring,
        days: rule.recurringDays,
        ...excluded?.length ? {
            excludedDates: [
                ...new Set(excluded)
            ].sort()
        } : {},
        end: rule.recurrenceEndType === 'on' ? {
            type: 'on',
            date: rule.recurrenceEndDate
        } : {
            type: 'after',
            count: rule.recurrenceEndCount
        }
    };
    return metadata;
};
const $ad00092495fc9667$var$matchesRecurrence = (event, original, target)=>{
    const targetDay = target.getDay();
    switch(event.recurring){
        case 'daily':
            return true;
        case 'weekdays':
            return targetDay >= 1 && targetDay <= 5;
        case 'weekends':
            return targetDay === 0 || targetDay === 6;
        case 'weekly':
            {
                const days = event.recurringDays;
                return Array.isArray(days) && days.length ? days.includes(targetDay) : original.getDay() === targetDay;
            }
        case 'biweekly':
            if (original.getDay() !== targetDay) return false;
            return Math.round((target - original) / $ad00092495fc9667$var$DAY_MS) % 14 === 0;
        case 'monthly':
            return original.getDate() === target.getDate();
        case 'yearly':
            return original.getMonth() === target.getMonth() && original.getDate() === target.getDate();
        default:
            return false;
    }
};
const $ad00092495fc9667$var$weeklyOccurrenceNumber = (original, target, activeDays)=>{
    const difference = Math.round((target - original) / $ad00092495fc9667$var$DAY_MS);
    const fullWeeks = Math.floor(difference / 7);
    const remainder = difference % 7;
    let count = 1 + fullWeeks * activeDays.size;
    for(let offset = 1; offset <= remainder; offset++)if (activeDays.has((original.getDay() + offset) % 7)) count++;
    return count;
};
const $ad00092495fc9667$var$occurrenceNumber = (event, original, target)=>{
    const difference = Math.round((target - original) / $ad00092495fc9667$var$DAY_MS);
    if (event.recurring === 'daily') return difference + 1;
    if (event.recurring === 'biweekly') return Math.floor(difference / 14) + 1;
    if (event.recurring === 'weekly') {
        const configured = Array.isArray(event.recurringDays) ? event.recurringDays : [];
        return $ad00092495fc9667$var$weeklyOccurrenceNumber(original, target, new Set(configured.length ? configured : [
            original.getDay()
        ]));
    }
    if (event.recurring === 'weekdays') return $ad00092495fc9667$var$weeklyOccurrenceNumber(original, target, new Set([
        1,
        2,
        3,
        4,
        5
    ]));
    if (event.recurring === 'weekends') return $ad00092495fc9667$var$weeklyOccurrenceNumber(original, target, new Set([
        0,
        6
    ]));
    if (event.recurring === 'monthly') {
        let count = 1;
        const cursor = new Date(original.getFullYear(), original.getMonth() + 1, 1);
        const targetMonth = target.getFullYear() * 12 + target.getMonth();
        while(cursor.getFullYear() * 12 + cursor.getMonth() <= targetMonth){
            const candidate = new Date(cursor.getFullYear(), cursor.getMonth(), original.getDate());
            if (candidate.getMonth() === cursor.getMonth()) count++;
            cursor.setMonth(cursor.getMonth() + 1);
        }
        return count;
    }
    if (event.recurring === 'yearly') {
        let count = 1;
        for(let year = original.getFullYear() + 1; year <= target.getFullYear(); year++){
            const candidate = new Date(year, original.getMonth(), original.getDate());
            if (candidate.getMonth() === original.getMonth()) count++;
        }
        return count;
    }
    return 1;
};
const $ad00092495fc9667$export$4ac17e788b020d26 = (event, target)=>{
    if (!event?.recurring || event.recurring === 'none' || !(target instanceof Date)) return false;
    const [year, month, day] = String(event.date || '').split('-').map(Number);
    if (!year) return false;
    const original = new Date(year, month - 1, day);
    if (target < original) return false;
    const targetDate = [
        target.getFullYear(),
        target.getMonth() + 1,
        target.getDate()
    ].map((part, index)=>index ? String(part).padStart(2, '0') : String(part)).join('-');
    if (event.recurrenceExcludedDates?.includes(targetDate)) return false;
    if (target.getTime() === original.getTime()) return true;
    if (event.recurrenceEndType === 'on' && event.recurrenceEndDate) {
        const [endYear, endMonth, endDay] = event.recurrenceEndDate.split('-').map(Number);
        const endDate = new Date(endYear, endMonth - 1, endDay);
        if (!endYear || target > endDate) return false;
    }
    if (!$ad00092495fc9667$var$matchesRecurrence(event, original, target)) return false;
    if (event.recurrenceEndType !== 'after') return true;
    return $ad00092495fc9667$var$occurrenceNumber(event, original, target) <= $ad00092495fc9667$var$clampOccurrenceCount(event.recurrenceEndCount);
};

});


parcelRegister("iz1Mr", function(module, exports) {

$parcel$export(module.exports, "triggerCalendarSync", () => $d83ce06966539fda$export$c3218349a9ca87d4);
$parcel$export(module.exports, "saveEvent", () => $d83ce06966539fda$export$d4658265d3309515);
$parcel$export(module.exports, "deleteEvent", () => $d83ce06966539fda$export$95711ec6c6227e9a);
$parcel$export(module.exports, "updateSharedEventFields", () => $d83ce06966539fda$export$839d7a9bac88391c);
$parcel$export(module.exports, "setEventRsvp", () => $d83ce06966539fda$export$782897de76254a81);
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $eQSi7 = parcelRequire("eQSi7");

var $8hz4V = parcelRequire("8hz4V");
// SDK entity path — the workspace fetch plugin is wired to `{ adapter: 'sdk' }`,
// so `from` must be a dotted entity registered in EntityDispatcher (not a raw
// raw table name). New events use `create` (insert); existing events with a
// real DB id use `update`. This mirrors saveTicket.js which had the
// same upsert-rejection issue (#2204 — fetch.upsert dispatched to a route the
// EntityDispatcher rejected before upsertEvent shipped, causing silent data
// loss). Branching on optimistic id guarantees the right HTTP verb and avoids
// any post-conflict ambiguity in the workspace PostgREST passthrough.
const $d83ce06966539fda$var$CALENDAR_ENTITY = 'workspaceProject.calendar';
// Date.now() is 13 digits in 2026; legacy autoincrement ids are <13 digits
// for the foreseeable future. Anything ≥ this is an optimistic local id.
const $d83ce06966539fda$var$OPTIMISTIC_ID_FLOOR = 1000000000000;
// Upper bound of the optimistic band (16 digits). Without it a long all-digit
// server id would read as optimistic — a Mongo ObjectId is 24 hex chars and may
// legally be all digits. Kept identical to the shell's rowOps.js classifier
// (WS-ROWOPS-OPTIMISTIC-ID-STRING-1) so both callers agree.
const $d83ce06966539fda$var$OPTIMISTIC_ID_CEILING = 1000000000000000;
const $d83ce06966539fda$var$_isOptimisticNumber = (n)=>Number.isFinite(n) && n >= $d83ce06966539fda$var$OPTIMISTIC_ID_FLOOR && n < $d83ce06966539fda$var$OPTIMISTIC_ID_CEILING;
// An id is optimistic ONLY when it has the CLIENT's own optimistic shape.
// Every optimistic id this package mints is `Date.now()` (QuickCreate
// _saveQuickCreate, NewBookingModal's create branch + its drag proposal,
// pages/index.js's drag proposal) — a number at or above the floor.
//
// WS-CALENDAR-SAVEEVENT-OPTIMISTIC-ID-DUPES-1: the old test was
// `typeof id !== 'number' || id >= FLOOR`. Post-cutover the server exposes a
// 24-hex ObjectId STRING id (server src/domains/calendar/store/ids.js
// EXPOSED-ID RULE), so "not a number" stopped meaning "optimistic": an UPDATE
// by a real string id was classified optimistic and ran as a CREATE, so one
// New Booking landed TWO rows (and deleteEvent silently no-op'd on a string
// id). A server-exposed id — string or legacy number below the floor — is
// PERSISTED. Only an absent id, or a numeric (or numeric-string) id at/above
// the floor, is the client's own optimistic id.
const $d83ce06966539fda$var$isOptimisticId = (id)=>{
    if (id == null || id === '') return true;
    if (typeof id === 'number') return Number.isFinite(id) ? $d83ce06966539fda$var$_isOptimisticNumber(id) : true;
    if (typeof id === 'string') {
        const trimmed = id.trim();
        // A `Date.now()` id that arrived stringified is still optimistic; any
        // other string (24-hex ObjectId, uuid, …) is a real server-exposed id.
        if (!/^\d+$/.test(trimmed)) return false;
        return $d83ce06966539fda$var$_isOptimisticNumber(Number(trimmed));
    }
    return true;
};
const $d83ce06966539fda$var$nowIso = ()=>new Date().toISOString();
// `date` + `startTime` are local wall-clock (the user dragged "8:30 on Apr 9"
// in their own timezone). Resolve them into a UTC instant via `new Date(...)`,
// which interprets the literal as local. This makes start_at the canonical
// timestamp the rest of the pipeline (Google sync push, _rowToEvent) reads.
const $d83ce06966539fda$var$_localToUtcIso = (date, time)=>{
    if (!date || !time) return null;
    const d = new Date(`${date}T${time}:00`);
    return isNaN(d) ? null : d.toISOString();
};
// Keep an existing canonical timestamp only while it still represents the
// event's current wall-clock fields. Dragging an event changes date/time on
// the optimistic event but deliberately preserves its other fields, including
// startAt/endAt. Trusting those stale instants made the move look successful
// until refresh, when rowToEvent correctly rebuilt the old date from start_at.
const $d83ce06966539fda$var$_canonicalInstant = (stored, date, time)=>{
    const next = $d83ce06966539fda$var$_localToUtcIso(date, time);
    if (!stored || !next) return next;
    const storedMs = new Date(stored).getTime();
    const nextMs = new Date(next).getTime();
    return Number.isFinite(storedMs) && storedMs === nextMs ? stored : next;
};
// Add one calendar day to a 'YYYY-MM-DD' string. Used to compute end_date
// for all-day events (Google represents "1 day all-day" as start.date=X,
// end.date=X+1 — a half-open interval).
const $d83ce06966539fda$var$_addDay = (ymd)=>{
    if (!ymd) return null;
    const [y, m, d] = ymd.split('-').map(Number);
    const next = new Date(y, m - 1, d + 1);
    const pad = (n)=>String(n).padStart(2, '0');
    return `${next.getFullYear()}-${pad(next.getMonth() + 1)}-${pad(next.getDate())}`;
};
// Carry-over-only fields — color and the two Google-sync ids. End date is
// managed by NewBookingModal for timed multi-day spans. Every EXISTING caller
// reaches the remaining fields by spreading the full
// original row (`{ ...ev, ...payload }`) before calling saveEvent — `ev.*`
// is always the real persisted value there. NewBookingModal's off-route edit
// fallback (SaveBtn.onClick, original missing from `root.events`) can't do
// that spread — it builds a bare `{ id, ...payload }` where these keys are
// simply absent (`undefined`). Treat "caller didn't provide this at all" as
// "leave the existing DB value alone" (omit from the UPDATE) rather than
// defaulting to `null` — the old unconditional `ev.field || null` shape
// would otherwise silently sever an event's Google Calendar sync link (or
// collapse a multi-day span to one day) the first time it's edited from
// off /calendar. Every existing caller already passes these fields defined
// (real value or explicit null), so this is a no-op for them.
const $d83ce06966539fda$var$_toRow = (ev, currentUserEmail)=>{
    const allDay = !!ev.allDay;
    const endDate = allDay ? $d83ce06966539fda$var$_addDay(ev.date) : ev.endDate || null;
    const integrationMetadata = (0, $eQSi7.recurrenceMetadataForEvent)(ev);
    return {
        ...typeof ev.id === 'number' && !$d83ce06966539fda$var$isOptimisticId(ev.id) ? {
            id: ev.id
        } : {},
        title: ev.title || '(no title)',
        date: ev.date,
        // All-day events always derive end_date from date (Google's half-open-
        // interval representation) — that direction is unconditional. A timed
        // event's end_date only differs from `date` on a genuine multi-day span;
        // see the carry-over comment above for why this is guarded.
        ...allDay || ev.endDate !== undefined ? {
            end_date: endDate
        } : {},
        // All-day events leave start_time/end_time NULL — the sync server's
        // pushUser keys off `!start_time` to send Google's `start: { date }`
        // shape instead of `dateTime`.
        start_time: allDay ? null : ev.startTime || null,
        end_time: allDay ? null : ev.endTime || null,
        // Preserve original UTC timestamps when available (editing without time change).
        // Re-convert only when missing (new event) or times were actually modified.
        start_at: $d83ce06966539fda$var$_canonicalInstant(ev.startAt, ev.date, allDay ? '00:00' : ev.startTime),
        end_at: $d83ce06966539fda$var$_canonicalInstant(ev.endAt, allDay ? endDate : ev.endDate || ev.date, allDay ? '00:00' : ev.endTime),
        ...ev.color !== undefined ? {
            color: ev.color || null
        } : {},
        type: ev.type || 'meeting',
        description: ev.description || null,
        invitees: ev.invitees || [],
        organizer_email: ev.creatorEmail || currentUserEmail,
        ...ev.googleEventId !== undefined ? {
            google_event_id: ev.googleEventId || null
        } : {},
        ...ev.googleCalendarId !== undefined ? {
            google_calendar_id: ev.googleCalendarId || null
        } : {},
        // Reminder minutes (#2200). Migration 0110 added
        // calendar_events.reminder_minutes to the schema. Omit when null so that
        // events without a reminder don't require the column to be writable — a
        // safe no-op against older DB snapshots and avoids a NOT NULL constraint
        // violation if the column is ever made non-nullable in the future.
        ...ev.reminderMinutes != null ? {
            reminder_minutes: Number(ev.reminderMinutes)
        } : {},
        ...integrationMetadata !== undefined ? {
            integration_metadata: integrationMetadata
        } : {},
        updated_at: $d83ce06966539fda$var$nowIso(),
        deleted: false,
        dirty: true
    };
};
// Fire-and-forget — the UI shouldn't block on the Google round-trip (the
// server enqueues a pass per cursor and returns immediately).
//
// This used to POST the retired `calendar-sync` edge function; the worker route
// now answers 410 — so behind the `.catch(() => {})` every resync had become a
// silent no-op. Google sync is Mongo-native on the main server now:
// POST /core/calendar/sync (tickets/server.md "calendar Google-sync rehome").
// `el` is the calling element; callers inside this module (all already
// `this`-bound via their own el.call contract) pass it explicitly as
// `triggerSync(this)`. Kept as a real parameter rather than an implicit
// `.call(this)` this-binding on purpose: frank's globalScope lift (this
// helper is referenced as a free var from saveEvent/deleteEvent/
// updateSharedEventFields, none of which export it under its bare name)
// only treats `this` as the element ref for CALL_INVOKED_SECTIONS
// (functions/methods bags called positionally via el.call); a private,
// zero-param, globalScope-lifted helper falls through to frank's generic
// "no params → inject el" branch instead, which left a bare `el` free
// identifier with nothing to resolve it to once the sync npm-module
// preamble below started reading `el?.context`. See tickets/fable.md
// "workspace-calendar frank serialization blockers".
const $d83ce06966539fda$export$c3218349a9ca87d4 = async function(el) {
    try {
        const sdk = (0, $1NxyO.getSDK)();
        // sdk._context.activeOrgId is the live source — verified in the browser.
        // sdk._currentUser is NOT populated in the workspace shell (it stays null
        // after boot), so resolving from it silently yielded no org and skipped
        // the sync entirely.
        const root = el?.state?.root;
        const organization = sdk?._context?.activeOrgId || root?.user?.activeOrganization || root?.org?.id;
        if (!organization) {
            $d83ce06966539fda$var$_logErr('triggerCalendarSync', "no active organization \u2014 sync skipped");
            return;
        }
        // The TAB's workspace: the same live SDK context (the scope the calendar
        // write itself was stamped with), then the tab's resolved record. A sync
        // that names no workspace is scoped by the server to the caller's STORED
        // activeWorkspace, which another tab or session can have moved to another
        // org: "workspace does not belong to this organization" (dev 2026-10-29,
        // after an AI Undo of an event). No workspace → the old `{ organization }`
        // body.
        const workspaceId = sdk?._context?.activeWorkspaceId || root?.workspace?.id || root?.workspace?._id;
        await sdk.calendarSync({
            organization: organization,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
    } catch (err) {
        // Still non-fatal: the save itself already succeeded. Log it rather than
        // swallowing — a silent catch is what hid the dead edge function.
        $d83ce06966539fda$var$_logErr('triggerCalendarSync', err);
    }
};
const $d83ce06966539fda$var$_logErr = (scope, err)=>console.error(`[${scope}]`, err?.message || err);
// SILENT-SAVE-FAIL-1 (tickets/opus.md) — every failure path in saveEvent used
// to end at `_logErr` + `return null`, and NOT ONE of its eight call sites
// checks the return value (most are a bare `el.call('saveEvent', ev)`; the two
// that do `.then(realId => ...)` only use it to patch an optimistic id). So a
// write that failed was indistinguishable from one that succeeded: the modal
// closed, the optimistic edit stayed on screen, and the original came back on
// the next reload with no error ever shown. The reported symptom — "change End
// 10:00→10:30, click Update, reload shows the original 09:00–10:00" — is that
// exactly.
//
// A console.error is not a report. Telling the user is the fix that
// generalises across all eight call sites without touching any of them.
// `titleKey`/`fallbackKey` are polyglot KEYS, resolved INSIDE the try below:
// a host with no `call` at all must still reach `_logErr`, which is the whole
// point of the catch (see the last test in saveEventSilentFail.test.js).
const $d83ce06966539fda$var$_writeFailed = (el, { scope: scope, titleKey: titleKey, fallbackKey: fallbackKey }, err, opts)=>{
    if (!opts?.skipLog) $d83ce06966539fda$var$_logErr(scope, err);
    // `hideDetail` keeps a machine-shaped reason (the refusal note below) out of
    // the notification body — the user reads the fallback copy, the console
    // keeps the diagnosis.
    const detail = opts?.hideDetail ? '' : err && (err.message || err.error || err.hint) || (typeof err === 'string' ? err : '');
    try {
        el.call('openNotification', {
            type: 'error',
            title: el.call('polyglot', titleKey),
            message: detail ? String(detail) : el.call('polyglot', fallbackKey)
        });
    } catch (e) {
    // A missing notification host must not swallow the original failure;
    // _logErr above already recorded it.
    }
};
const $d83ce06966539fda$var$_saveFailed = (el, err, opts)=>$d83ce06966539fda$var$_writeFailed(el, {
        scope: 'saveEvent',
        titleKey: 'calendar.save.failedTitle',
        fallbackKey: 'calendar.save.failedMessage'
    }, err, opts);
const $d83ce06966539fda$var$_deleteFailed = (el, err, opts)=>$d83ce06966539fda$var$_writeFailed(el, {
        scope: 'deleteEvent',
        titleKey: 'calendar.delete.failedTitle',
        fallbackKey: 'calendar.delete.failedMessage'
    }, err, opts);
// WS-CALENDAR-FETCH-UPDATE-NOOP-1 — a TARGETED write (the params carry the row
// id) that answers `data: []` wrote NOTHING. The server returns that empty
// shape on purpose for a row the caller cannot read, a row in another
// workspace and an id that does not exist; a row the caller CAN see answers an
// explicit 403 instead (server 7bb8e205), so 403-vs-[] is never an existence
// oracle. Either way the row is unchanged, so the client must read `[]` as a
// refusal — reading it as success is what made an edit and a soft-delete
// silent no-ops. A NON-targeted patch (updateSharedEventFields, matching by
// google_event_id or title+start_at) may legitimately match zero rows and is
// deliberately NOT checked here. A response with no `data` key at all is a
// body-less 200 (the write landed, nothing echoed) — also not a refusal.
const $d83ce06966539fda$var$_refusedTargetedWrite = (result)=>Array.isArray(result?.data) && result.data.length === 0;

const $d83ce06966539fda$export$d4658265d3309515 = async function(ev, opts) {
    const fail = opts && opts.falseOnFail ? false : null;
    if ($d83ce06966539fda$var$isOptimisticId(ev?.id) && this.call?.('calendarBookingStartsInPast', ev) === true) {
        const root = this.state?.root;
        if (root?.update && ev?.id != null) root.update({
            events: (root.events || []).filter((event)=>event.id !== ev.id)
        });
        $d83ce06966539fda$var$_writeFailed(this, {
            scope: 'saveEvent',
            titleKey: 'calendar.save.pastTitle',
            fallbackKey: 'calendar.save.pastMessage'
        }, null, {
            skipLog: true
        });
        return fail;
    }
    const fetch = this.context?.fetch;
    if (!fetch?.insert || !fetch?.update) {
        $d83ce06966539fda$var$_saveFailed(this, 'context.fetch missing insert/update');
        return fail;
    }
    const row = $d83ce06966539fda$var$_toRow(ev, this.state?.root?.currentUserEmail);
    try {
        let result;
        if ($d83ce06966539fda$var$isOptimisticId(ev.id)) {
            // New event — strip the local optimistic id before inserting so
            // PostgreSQL assigns the real autoincrement primary key.
            const { id: id, ...insertRow } = row;
            result = await fetch.insert({
                from: $d83ce06966539fda$var$CALENDAR_ENTITY,
                data: insertRow
            });
        } else // Existing event — update by real DB id.
        result = await fetch.update({
            from: $d83ce06966539fda$var$CALENDAR_ENTITY,
            params: {
                id: ev.id
            },
            data: row
        });
        if (result?.error) {
            $d83ce06966539fda$var$_saveFailed(this, result.error);
            return fail;
        }
        if (!$d83ce06966539fda$var$isOptimisticId(ev.id) && $d83ce06966539fda$var$_refusedTargetedWrite(result)) {
            $d83ce06966539fda$var$_saveFailed(this, `update on id ${ev.id} matched no writable row (200 + [])`, {
                hideDetail: true
            });
            return fail;
        }
        $d83ce06966539fda$export$c3218349a9ca87d4(this);
        // `insert` returns data as a plain object (not an array) from the
        // workspace worker's /calendar/events POST response. `update` returns
        // the patched row similarly. Normalise both into a real numeric id —
        // resolved BEFORE the invite notifications below so they can carry it.
        const data = result?.data;
        const savedId = (Array.isArray(data) ? data[0]?.id : data?.id) ?? null;
        // An event saved from an AI answer's form (calendarAiFormOpen → the
        // booking's `aiRequest`): the answer shows the saved event as a row.
        if (ev.aiRequest && typeof this.context?.functions?.assistantFormSaved === 'function') {
            const savedRef = savedId ?? ($d83ce06966539fda$var$isOptimisticId(ev.id) ? null : ev.id);
            this.call('assistantFormSaved', ev.aiRequest, {
                id: savedRef,
                title: ev.title || '',
                meta: [
                    ev.date,
                    ev.allDay ? '' : ev.startTime
                ].filter(Boolean).join(' '),
                route: savedRef != null ? '/calendar?event=' + encodeURIComponent(savedRef) : '/calendar'
            });
        }
        // Notify invitees about the calendar event
        const me = this.state?.root?.currentUserEmail;
        const invitees = ev.invitees || [];
        if (invitees.length && me) try {
            const { createNotifications: createNotifications } = await Promise.resolve((parcelRequire("h7bUm")));
            // The update path can miss a row id in the response — the caller's
            // real id (never an optimistic one) backfills it.
            const eventId = savedId ?? ($d83ce06966539fda$var$isOptimisticId(ev.id) ? null : ev.id);
            createNotifications.call(this, invitees.filter((e)=>e !== me), {
                type: 'calendar_invite',
                title: `${ev.title || 'New event'} \u{2014} you're invited`,
                body: ev.description?.substring(0, 100) || '',
                // Query-free href — survives the desktop-notification click path,
                // which assigns it straight to a pathname (same rationale as the
                // server's buildTicketHref). The event id rides `metadata` so the
                // in-app click paths can open CalEventDetailModal in place
                // (shared openNotificationTarget.js).
                href: '/calendar',
                ...eventId != null ? {
                    metadata: {
                        eventId: eventId
                    }
                } : {}
            });
        } catch (e) {
            $d83ce06966539fda$var$_logErr('saveEvent:notify', e);
        }
        // NOTE: a missing `data` here is a SUCCESS with no response body (the
        // write landed; the worker just returned nothing to echo), not a failure —
        // so it returns null WITHOUT notifying. Only the three genuine failure
        // paths above and the throw below tell the user.
        if (!data) return null;
        return savedId;
    } catch (e) {
        $d83ce06966539fda$var$_saveFailed(this, e);
        return fail;
    }
};
const $d83ce06966539fda$export$95711ec6c6227e9a = async function(eventId, opts) {
    if ($d83ce06966539fda$var$isOptimisticId(eventId)) return true;
    const el = this;
    const failed = (err, fields, notify)=>{
        if (opts && opts.callerReports) throw fields ? Object.assign(new Error(String(err)), fields) : err;
        $d83ce06966539fda$var$_deleteFailed(el, err, notify);
        return false;
    };
    const fetch = this.context?.fetch;
    if (!fetch?.update) return failed('context.fetch.update missing', {
        code: 'DELETE_UNAVAILABLE'
    }, {
        hideDetail: true
    });
    let result;
    try {
        result = await fetch.update({
            from: $d83ce06966539fda$var$CALENDAR_ENTITY,
            params: {
                id: eventId
            },
            data: {
                deleted: true,
                dirty: true,
                updated_at: $d83ce06966539fda$var$nowIso()
            }
        });
    } catch (e) {
        return failed(e);
    }
    if (result?.error) return failed(result.error);
    if ($d83ce06966539fda$var$_refusedTargetedWrite(result)) return failed(`soft-delete on id ${eventId} matched no writable row (200 + [])`, {
        status: 404
    }, {
        hideDetail: true
    });
    $d83ce06966539fda$export$c3218349a9ca87d4(this);
    return true;
};
const $d83ce06966539fda$export$839d7a9bac88391c = async function(ev, fields) {
    const fetch = this.context?.fetch;
    if (!fetch?.update) return;
    const data = {
        updated_at: $d83ce06966539fda$var$nowIso(),
        dirty: true
    };
    if (fields.type !== undefined) data.type = fields.type;
    if (fields.description !== undefined) data.description = fields.description;
    if (fields.invitees !== undefined) data.invitees = fields.invitees;
    try {
        // Update by google_event_id
        if (ev.googleEventId) await fetch.update({
            from: $d83ce06966539fda$var$CALENDAR_ENTITY,
            params: {
                google_event_id: ev.googleEventId,
                deleted: false
            },
            data: data
        });
        // Also update by title + start_at to catch forwarded copies
        if (ev.title && ev.startAt) await fetch.update({
            from: $d83ce06966539fda$var$CALENDAR_ENTITY,
            params: {
                title: ev.title,
                start_at: ev.startAt,
                deleted: false
            },
            data: data
        });
        $d83ce06966539fda$export$c3218349a9ca87d4(this);
    } catch (e) {
        $d83ce06966539fda$var$_logErr('updateSharedEventFields', e);
    }
};
const $d83ce06966539fda$var$_googleSeriesBase = (id)=>String(id || '').replace(/_\d{8}(?:T\d{6}Z)?$/, '');
const $d83ce06966539fda$export$782897de76254a81 = async function(ev, status, scope = 'future') {
    const root = this.state?.root;
    const fetch = this.context?.fetch;
    const viewer = root?.people?.find((person)=>person.email === root.currentUserEmail) || {
        email: root?.currentUserEmail
    };
    const keys = (0, $8hz4V.calendarParticipantRsvpKeys)(viewer);
    if (!ev || !keys.length || !fetch?.update) return false;
    const baseId = $d83ce06966539fda$var$_googleSeriesBase(ev.googleEventId);
    const googleSeries = !!ev.googleEventId && baseId !== String(ev.googleEventId || '') ? baseId : '';
    const localSeries = ev.recurring && ev.recurring !== 'none';
    const recurring = !!googleSeries || localSeries;
    const sameSeries = (candidate)=>{
        if (candidate?.id === ev.id) return true;
        return !!googleSeries && $d83ce06966539fda$var$_googleSeriesBase(candidate?.googleEventId) === googleSeries;
    };
    const inScope = (candidate)=>{
        if (!sameSeries(candidate)) return false;
        if (!recurring || localSeries || scope === 'this') return candidate?.id === ev.id;
        return String(candidate?.date || '') >= String(ev.date || '');
    };
    const patchEvent = (candidate)=>{
        if (!inScope(candidate)) return candidate;
        const metadata = {
            ...candidate.integrationMetadata || {}
        };
        if (recurring && scope === 'this') {
            const overrides = {
                ...metadata.calendarParticipantResponseOverrides || {}
            };
            const occurrence = {
                ...overrides[ev.date] || {}
            };
            for (const key of keys)occurrence[key] = status;
            overrides[ev.date] = occurrence;
            metadata.calendarParticipantResponseOverrides = overrides;
        } else if (recurring) {
            const changes = {
                ...metadata.calendarParticipantResponseChanges || {}
            };
            for (const key of keys){
                const entries = (changes[key] || []).filter((change)=>change?.from !== ev.date);
                changes[key] = [
                    ...entries,
                    {
                        from: ev.date,
                        status: status
                    }
                ].sort((a, b)=>a.from.localeCompare(b.from));
            }
            metadata.calendarParticipantResponseChanges = changes;
        } else {
            const responses = {
                ...metadata.calendarParticipantResponses || {}
            };
            for (const key of keys)responses[key] = status;
            metadata.calendarParticipantResponses = responses;
        }
        return {
            ...candidate,
            integrationMetadata: metadata
        };
    };
    const previousEvents = root.events || [];
    const previousSelectedEvent = root.selectedEvent;
    const events = previousEvents.map(patchEvent);
    const selectedEvent = {
        ...patchEvent(ev)
    };
    (0, $8hz4V.cacheCalendarEventRsvp)(selectedEvent, status, scope);
    root.update({
        events: events,
        selectedEvent: selectedEvent
    });
    try {
        const metadata = selectedEvent.integrationMetadata;
        const params = googleSeries && scope === 'future' ? {
            google_event_id: {
                like: `${googleSeries}%`
            },
            start_at: {
                gte: ev.startAt || `${ev.date}T00:00:00.000Z`
            },
            deleted: false
        } : {
            id: ev.id
        };
        const result = await fetch.update({
            from: $d83ce06966539fda$var$CALENDAR_ENTITY,
            params: params,
            data: {
                integration_metadata: metadata,
                updated_at: $d83ce06966539fda$var$nowIso()
            }
        });
        if (result?.error || (!googleSeries || scope === 'this') && $d83ce06966539fda$var$_refusedTargetedWrite(result)) throw result?.error || new Error('RSVP update matched no writable event');
        (0, $8hz4V.cacheCalendarEventRsvp)(selectedEvent);
        return true;
    } catch (error) {
        root.update({
            events: previousEvents,
            selectedEvent: previousSelectedEvent
        });
        $d83ce06966539fda$var$_saveFailed(this, error);
        return false;
    }
};

});

parcelRegister("gOkYs", function(module, exports) {

$parcel$export(module.exports, "AVAILABILITY_DAY_LABELS", () => $c3d195df4b9b7457$export$46f8dd24980e175);
$parcel$export(module.exports, "gridRowToDow", () => $c3d195df4b9b7457$export$ddd5c3a7561a6fa);
$parcel$export(module.exports, "dowToGridRow", () => $c3d195df4b9b7457$export$d75ad1a462acd430);
$parcel$export(module.exports, "formatHour", () => $c3d195df4b9b7457$export$86a5557e1d677e29);
$parcel$export(module.exports, "gridToWeekly", () => $c3d195df4b9b7457$export$810aa74d9eab36c);
$parcel$export(module.exports, "weeklyToGrid", () => $c3d195df4b9b7457$export$4b6a2bd382ebde8);
$parcel$export(module.exports, "weeklyHoursFromGrid", () => $c3d195df4b9b7457$export$9a32bf06366ab2cf);
$parcel$export(module.exports, "effectiveGrid", () => $c3d195df4b9b7457$export$82eb137ebc0c4ff9);
$parcel$export(module.exports, "tzGridPosition", () => $c3d195df4b9b7457$export$5402296bbfde715c);
$parcel$export(module.exports, "availabilityStatus", () => $c3d195df4b9b7457$export$1469e91fd986cdf5);
$parcel$export(module.exports, "availabilitySummaryText", () => $c3d195df4b9b7457$export$a8efc806e11a58c1);
// Availability shape helpers — PURE conversions between the profile 7×24
// availability grid and the formalized server-side AvailabilityRule
// (`/core/availability-rules`, WORKSPACE_DATA_MODEL §6.8), plus tz-aware
// summary derivation. No SDK / DOM imports — node-testable
// (availabilityShape.test.js). Persistence lives in availabilityUtils.js.
//
// Grid semantics (matches CalAvailabilityGrid / ProfileAvailabilityGrid):
//   grid[row][hour] — row 0 = Monday … row 6 = Sunday, hour 0-23, boolean.
// Rule semantics (server store): weekly [{ dow, from: 'HH:MM', to: 'HH:MM' }]
// with dow in JS Date#getDay() convention (0 = Sunday … 6 = Saturday).
// `to` is exclusive; a run reaching midnight serializes as to '24:00'.
const $c3d195df4b9b7457$export$46f8dd24980e175 = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun'
];
const $c3d195df4b9b7457$var$_pad2 = (n)=>String(n).padStart(2, '0');
const $c3d195df4b9b7457$var$_hh = (h)=>`${$c3d195df4b9b7457$var$_pad2(h)}:00`;
const $c3d195df4b9b7457$export$ddd5c3a7561a6fa = (row)=>(row + 1) % 7;
const $c3d195df4b9b7457$export$d75ad1a462acd430 = (dow)=>(dow + 6) % 7;
const $c3d195df4b9b7457$export$86a5557e1d677e29 = $c3d195df4b9b7457$var$_hh;
function $c3d195df4b9b7457$export$810aa74d9eab36c(grid) {
    const weekly = [];
    for(let row = 0; row < 7; row++){
        const cells = grid && grid[row] || [];
        let start = null;
        for(let h = 0; h <= 24; h++){
            const on = h < 24 && cells[h] === true;
            if (on && start == null) start = h;
            if (!on && start != null) {
                weekly.push({
                    dow: $c3d195df4b9b7457$export$ddd5c3a7561a6fa(row),
                    from: $c3d195df4b9b7457$var$_hh(start),
                    to: $c3d195df4b9b7457$var$_hh(h)
                });
                start = null;
            }
        }
    }
    return weekly;
}
const $c3d195df4b9b7457$var$_hhmmToMinutes = (s)=>{
    if (typeof s !== 'string') return null;
    const m = /^(\d{1,2}):(\d{2})$/.exec(s);
    if (!m) return null;
    return Number(m[1]) * 60 + Number(m[2]);
};
function $c3d195df4b9b7457$export$4b6a2bd382ebde8(weekly) {
    const grid = Array.from({
        length: 7
    }, ()=>Array.from({
            length: 24
        }, ()=>false));
    for (const w of Array.isArray(weekly) ? weekly : []){
        const dow = Number(w?.dow);
        if (!Number.isInteger(dow) || dow < 0 || dow > 6) continue;
        const from = $c3d195df4b9b7457$var$_hhmmToMinutes(w?.from);
        const to = $c3d195df4b9b7457$var$_hhmmToMinutes(w?.to);
        if (from == null || to == null || to <= from) continue;
        const row = $c3d195df4b9b7457$export$d75ad1a462acd430(dow);
        const startH = Math.max(0, Math.floor(from / 60));
        const endH = Math.min(24, Math.ceil(to / 60));
        for(let h = startH; h < endH; h++)grid[row][h] = true;
    }
    return grid;
}
const $c3d195df4b9b7457$export$9a32bf06366ab2cf = (grid)=>{
    let count = 0;
    for(let row = 0; row < 7; row++){
        const cells = grid && grid[row] || [];
        for(let h = 0; h < 24; h++)if (cells[h] === true) count++;
    }
    return count;
};
function $c3d195df4b9b7457$export$82eb137ebc0c4ff9(person) {
    const grid = person?.availabilityGrid;
    if (Array.isArray(grid) && grid.length === 7) return grid;
    const wh = person?.workingHours;
    const start = $c3d195df4b9b7457$var$_hhmmToMinutes(wh?.start);
    const end = $c3d195df4b9b7457$var$_hhmmToMinutes(wh?.end);
    if (start == null || end == null) return null;
    const out = Array.from({
        length: 7
    }, ()=>Array.from({
            length: 24
        }, ()=>false));
    for(let row = 0; row < 7; row++)for(let h = 0; h < 24; h++){
        const minute = h * 60;
        out[row][h] = start < end ? minute >= start && minute < end : minute >= start || minute < end;
    }
    return out;
}
function $c3d195df4b9b7457$export$5402296bbfde715c(tz, date) {
    date = date || new Date();
    let parts;
    try {
        parts = new Intl.DateTimeFormat('en-US', {
            timeZone: tz || undefined,
            weekday: 'short',
            hour: 'numeric',
            hourCycle: 'h23'
        }).formatToParts(date);
    } catch  {
        parts = new Intl.DateTimeFormat('en-US', {
            weekday: 'short',
            hour: 'numeric',
            hourCycle: 'h23'
        }).formatToParts(date);
    }
    const weekday = parts.find((p)=>p.type === 'weekday')?.value;
    const hour = Number(parts.find((p)=>p.type === 'hour')?.value);
    const row = $c3d195df4b9b7457$export$46f8dd24980e175.indexOf(weekday);
    return {
        row: row < 0 ? 0 : row,
        hour: Number.isFinite(hour) ? hour % 24 : 0
    };
}
function $c3d195df4b9b7457$export$1469e91fd986cdf5(grid, tz, date) {
    date = date || new Date();
    if (!grid) return null;
    const { row: row, hour: hour } = $c3d195df4b9b7457$export$5402296bbfde715c(tz, date);
    const at = (k)=>{
        const idx = (row * 24 + hour + k) % 168;
        const r = Math.floor(idx / 24);
        const h = idx % 24;
        return {
            row: r,
            hour: h,
            on: !!(grid[r] && grid[r][h] === true)
        };
    };
    if (at(0).on) {
        let k = 1;
        while(k < 168 && at(k).on)k++;
        if (k >= 168) return {
            availableNow: true,
            until: null,
            untilHour: null
        };
        // `untilHour` is the DATA hour of the run's end; `until` stays its HH:00
        // text for callers that print it as it is.
        return {
            availableNow: true,
            until: $c3d195df4b9b7457$var$_hh(at(k).hour),
            untilHour: at(k).hour
        };
    }
    let k = 1;
    while(k < 168 && !at(k).on)k++;
    if (k >= 168) return {
        availableNow: false,
        next: null
    };
    const n = at(k);
    return {
        availableNow: false,
        next: {
            row: n.row,
            hour: n.hour
        }
    };
}
// The summary's day names: the calendar's weekday keys (grid row 0 = Mon).
// Their ka values are ICU's short weekday forms, pinned by a test against
// `Intl.DateTimeFormat('ka', { weekday: 'short' })` in bun.
const $c3d195df4b9b7457$var$_availabilitySummaryDayKeys = [
    'calendar.day.mon',
    'calendar.day.tue',
    'calendar.day.wed',
    'calendar.day.thu',
    'calendar.day.fri',
    'calendar.day.sat',
    'calendar.day.sun'
];
function $c3d195df4b9b7457$export$a8efc806e11a58c1(person, now) {
    now = now || new Date();
    const el = this && typeof this.call === 'function' ? this : null;
    const t = (key)=>el ? el.call('polyglot', key) : key;
    const lang = el ? el.call('getActiveLang') : undefined;
    const clock = (hour)=>{
        const label = el ? el.call('formatTzTime', Date.UTC(2000, 0, 3, hour), 'UTC', lang) : null;
        return typeof label === 'string' && label ? label : $c3d195df4b9b7457$var$_hh(hour);
    };
    const grid = $c3d195df4b9b7457$export$82eb137ebc0c4ff9(person);
    if (!grid) return t('calendar.profile.noAvailability');
    const tz = person?.timezone || null;
    const status = $c3d195df4b9b7457$export$1469e91fd986cdf5(grid, tz, now);
    const parts = [];
    if (status.availableNow) {
        parts.push(t('calendar.profile.summary.availableNow'));
        if (status.untilHour != null) parts.push(t('calendar.profile.summary.until').replace('{time}', clock(status.untilHour)));
    } else if (status.next) parts.push(t('calendar.profile.summary.nextAvailable').replace('{day}', t($c3d195df4b9b7457$var$_availabilitySummaryDayKeys[status.next.row])).replace('{time}', clock(status.next.hour)));
    else {
        parts.push(t('calendar.profile.summary.noHours'));
        if (tz) parts.push(tz);
        return parts.join(" \xb7 ");
    }
    parts.push(t('calendar.profile.summary.weeklyHours').replace('{hours}', String($c3d195df4b9b7457$export$9a32bf06366ab2cf(grid))));
    if (tz) parts.push(tz);
    return parts.join(" \xb7 ");
}

});

parcelRegister("fIUoo", function(module, exports) {

$parcel$export(module.exports, "__activeWsIdForTest", () => $b726b571959ec58a$export$50683b3537c6c45);
$parcel$export(module.exports, "fetchAvailabilityRule", () => $b726b571959ec58a$export$76e5eaa267c31bf2);
$parcel$export(module.exports, "hydratePersonAvailability", () => $b726b571959ec58a$export$46d31e81f5eaed77);
$parcel$export(module.exports, "saveAvailabilityGrid", () => $b726b571959ec58a$export$a22a7f03f7bd59d7);
// Availability persistence — bridges the profile 7×24 availability grid to the
// server's formalized AvailabilityRule domain (`/core/availability-rules`,
// WORKSPACE_DATA_MODEL §6.8) via sdk.execute('availabilityRules', …).
// Pure grid ↔ weekly conversions live in availabilityShape.js.
//
// A rule belongs to one Mongo `user`; the server defaults it to the caller on
// create (A2 — a member manages their own availability) and an editor may set
// another member's. Reads are workspace-member gated, writes editor gated —
// a failed write keeps the optimistic local grid and warns, it never throws
// into the UI. workspaceId is resolved server-side from the caller's claims
// (the PartyService contract's claim fallback), so no explicit id is threaded.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $jhJrJ = parcelRequire("jhJrJ");

var $76fm2 = parcelRequire("76fm2");

var $gOkYs = parcelRequire("gOkYs");
// Active workspace this tab is viewing — the tab's own resolved workspace
// FIRST (root.workspace.id, URL/record-derived — matches loadPrivateData.js
// / pages/main.js's TAB-TRUTH-FIRST precedence), then the per-tab pointer as
// a boot fallback only (before root.workspace has landed). Used to pin
// debounced saves to the workspace they were made in.
//
// Pointer-first was the bug (tickets/workspace.md P1 tenant-isolation audit,
// 2026-08-08): with MWT off, `getActiveWorkspacePointer()` reads SHARED
// `localStorage.activeWorkspace` — another tab's switch could flip what this
// function returns for a tab that already knows its own workspace, corrupting
// the enqueue-vs-fire staleness check below (a legitimate save silently
// dropped, or a real switch missed).
const $b726b571959ec58a$var$_calendarActiveWsId = (root)=>{
    if (root?.workspace?.id) return root.workspace.id;
    try {
        return (0, $jhJrJ.getActiveWorkspacePointer)() || null;
    } catch (_) {
        return null;
    }
};
const $b726b571959ec58a$export$50683b3537c6c45 = $b726b571959ec58a$var$_calendarActiveWsId;
const $b726b571959ec58a$var$_patchPerson = (root, userId, patch)=>{
    if (!root || !userId) return;
    root.update({
        people: (0, $76fm2.patchPeopleList)(root.people, userId, patch),
        peopleAll: (0, $76fm2.patchPeopleList)(root.peopleAll, userId, patch)
    });
};
async function $b726b571959ec58a$export$76e5eaa267c31bf2(userId) {
    if (!userId) return null;
    const res = await (0, $1NxyO.getSDK)().execute('availabilityRules', 'list', {
        user: userId
    });
    const rules = Array.isArray(res) ? res : res?.data || [];
    return rules[0] || null;
}
async function $b726b571959ec58a$export$46d31e81f5eaed77(root, person) {
    const userId = person?.userId;
    if (!root || !userId) return null;
    const isSelf = person.email && root.currentUserEmail === person.email;
    const mongoUserId = root.roles?.byUserMongoId?.[userId] || (isSelf && root.currentUserId ? root.currentUserId : userId);
    try {
        const rule = await $b726b571959ec58a$export$76e5eaa267c31bf2(mongoUserId);
        if (!rule) return null;
        const patch = {
            _availabilityRuleId: rule.id
        };
        if (Array.isArray(rule.weekly)) patch.availabilityGrid = (0, $gOkYs.weeklyToGrid)(rule.weekly);
        if (rule.tz && !person.timezone) patch.timezone = rule.tz;
        $b726b571959ec58a$var$_patchPerson(root, userId, patch);
        return rule;
    } catch (e) {
        console.warn('[availability] hydrate failed', e?.message || e);
        return null;
    }
}
// Debounced, per-user serialized save of a member's grid. Grid toggles come in
// bursts — one timer per user collapses them, and the per-user promise chain
// guarantees create-then-update ordering (never two creates racing).
const $b726b571959ec58a$var$_calendarSaveTimers = {};
const $b726b571959ec58a$var$_saveChains = {};
const $b726b571959ec58a$var$_persistGrid = async (root, userId, mongoUserId, grid, tz, knownRuleId)=>{
    const sdk = (0, $1NxyO.getSDK)();
    const payload = {
        weekly: (0, $gOkYs.gridToWeekly)(grid)
    };
    if (tz) payload.tz = tz;
    // Prefer the rule id CAPTURED at enqueue — after a workspace switch the
    // people lists are wiped/replaced, so a fire-time re-read found no rule
    // and CREATED a duplicate for a member who already had one. Fall back to
    // a fire-time re-read only when none was known at enqueue (an earlier
    // create in this chain may have stashed it after the caller captured
    // `person`).
    const current = (root.people || []).find((p)=>p.userId === userId) || (root.peopleAll || []).find((p)=>p.userId === userId);
    const ruleId = knownRuleId || current?._availabilityRuleId;
    if (ruleId) {
        await sdk.execute('availabilityRules', 'update', {
            id: ruleId,
            ...payload
        });
        return;
    }
    const created = await sdk.execute('availabilityRules', 'create', {
        user: mongoUserId,
        ...payload
    });
    if (created?.id) $b726b571959ec58a$var$_patchPerson(root, userId, {
        _availabilityRuleId: created.id
    });
};
function $b726b571959ec58a$export$a22a7f03f7bd59d7(root, person, grid) {
    const userId = person?.userId;
    if (!root || !userId || !Array.isArray(grid)) return;
    const tz = person.timezone || null;
    const isSelf = person.email && root.currentUserEmail === person.email;
    const mongoUserId = root.roles?.byUserMongoId?.[userId] || (isSelf && root.currentUserId ? root.currentUserId : userId);
    // Pin the save to the workspace (and rule) it was made in — the 500ms
    // debounce plus the serialized chain can outlive a workspace switch,
    // and availabilityRules writes scope by the ambient claim.
    const ruleIdAtEnqueue = person?._availabilityRuleId || null;
    const wsAtEnqueue = $b726b571959ec58a$var$_calendarActiveWsId(root);
    clearTimeout($b726b571959ec58a$var$_calendarSaveTimers[userId]);
    $b726b571959ec58a$var$_calendarSaveTimers[userId] = setTimeout(()=>{
        delete $b726b571959ec58a$var$_calendarSaveTimers[userId];
        $b726b571959ec58a$var$_saveChains[userId] = ($b726b571959ec58a$var$_saveChains[userId] || Promise.resolve()).then(()=>{
            // The workspace moved on while this save was queued — drop it.
            const now = $b726b571959ec58a$var$_calendarActiveWsId(root);
            if (wsAtEnqueue && now && now !== wsAtEnqueue) return;
            return $b726b571959ec58a$var$_persistGrid(root, userId, mongoUserId, grid, tz, ruleIdAtEnqueue);
        }).catch((e)=>console.warn('[availability] save failed', e?.message || e));
    }, 500);
}

});

parcelRegister("6rr2K", function(module, exports) {

$parcel$export(module.exports, "calendarAiViews", () => $4b0a3dedf4b97d1a$export$5b58b3ccb63f7e33);
$parcel$export(module.exports, "calendarAgendaRange", () => $4b0a3dedf4b97d1a$export$785396126e6bf9c3);
$parcel$export(module.exports, "calendarAgendaEnsure", () => $4b0a3dedf4b97d1a$export$86fc7fb027b15758);
$parcel$export(module.exports, "calendarAgendaDays", () => $4b0a3dedf4b97d1a$export$84b8d0d168834471);
// THE CALENDAR IN AN AI ANSWER — the agenda view the assistant mounts in its
// thread (workspace functions/assistantAppViews.js, the `views[]` contract).
//
// calendarAiViews() is the calendar's view PROVIDER: the shell reads it from
// the EAGER slice (the calendar package is lazy — the shell folds its context
// before the view mounts, `fold: 'calendar'`). One view:
//
//   calendar-agenda   the events of a date range, day by day — the member's
//                     own, a teammate's, or the whole team's; a row opens the
//                     event's own detail sheet (openEventDetailModal).
//
// The rows come from the calendar's own data: `root.events` (the shell's
// calendar window) widened to the range's months by ensureCalendarWindow, the
// day match by getEventsForDay (recurrences included). Nothing here writes.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $4b0a3dedf4b97d1a$export$5b58b3ccb63f7e33() {
    return {
        app: {
            id: 'system/calendar',
            navbar: [
                {
                    label: 'shell.app.calendar',
                    route: '/calendar',
                    icon: 'date outline'
                }
            ],
            apps: [
                {
                    icon: 'date outline'
                }
            ]
        },
        fold: 'calendar',
        views: [
            {
                id: 'calendar-agenda',
                title: 'calendar.agenda.title',
                describe: 'Calendar events of a date range, day by day; range = the days, who = my events or the team, person = one teammate.',
                component: 'CalAgendaEmbed',
                icon: 'date outline',
                hue: 'calendar',
                size: 'l',
                params: {
                    range: {
                        type: 'range',
                        // Relative presets the server turns into days in the member's
                        // clock (server ai-boards/rangePresets.js); the default is what the
                        // card draws when the ask names no days, so the answer says them.
                        values: [
                            'today',
                            'next7days',
                            'thisWeek',
                            'nextWeek'
                        ],
                        default: 'next7days',
                        describe: 'YYYY-MM-DD..YYYY-MM-DD, or today | next7days | thisWeek | nextWeek; a week is Sunday..Saturday; default the next 7 days'
                    },
                    who: {
                        type: 'enum',
                        values: [
                            'me',
                            'team'
                        ],
                        // Bundle keys: the catalog sends them as { en, ka } words.
                        labels: {
                            me: 'calendar.agenda.who.me',
                            team: 'calendar.agenda.who.team'
                        },
                        default: 'me'
                    },
                    person: {
                        type: 'string',
                        describe: 'a teammate name or email; overrides who'
                    }
                },
                link: {
                    route: '/calendar',
                    query: {
                        date: 'range'
                    }
                }
            }
        ]
    };
}
function $4b0a3dedf4b97d1a$export$785396126e6bf9c3(params, now) {
    const p = params && typeof params === 'object' ? params : {};
    const pad = (n)=>String(n).padStart(2, '0');
    const iso = (d)=>d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    const parse = (s)=>{
        if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
        const [y, m, d] = s.split('-').map(Number);
        const out = new Date(y, m - 1, d);
        return out.getMonth() === m - 1 ? out : null;
    };
    const base = now instanceof Date ? now : new Date(Number(now) || Date.now());
    let from = null;
    let to = null;
    if (typeof p.range === 'string' && p.range.includes('..')) {
        const [a, b] = p.range.split('..');
        from = parse(a);
        to = parse(b);
    } else if (typeof p.range === 'string') {
        // A preset that reaches the view as itself — a Fly page's section (the
        // board path embeds the model's value as it is), an older server — in
        // this device's clock. A WEEK is the app's own week, Sunday..Saturday:
        // the rule of the week grid (calendarUtils.js getWeekDays — the
        // calendarAgendaEmbed test holds the two to the same days). It was
        // Monday-based here: on Sunday 18 Oct Fly's "this week" read 12–18 Oct
        // while the calendar's week was 18–24 (Fly QA round 2, R5).
        const day = new Date(base.getFullYear(), base.getMonth(), base.getDate());
        const sinceStart = day.getDay();
        const at = (n)=>new Date(day.getFullYear(), day.getMonth(), day.getDate() + n);
        const span = {
            today: [
                0,
                0
            ],
            next7days: [
                0,
                6
            ],
            thisWeek: [
                -sinceStart,
                6 - sinceStart
            ],
            nextWeek: [
                7 - sinceStart,
                13 - sinceStart
            ]
        }[p.range];
        if (span) {
            from = at(span[0]);
            to = at(span[1]);
        }
    }
    if (!from || !to || to < from) {
        from = new Date(base.getFullYear(), base.getMonth(), base.getDate());
        to = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 6);
    }
    const max = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 30);
    if (to > max) to = max;
    return {
        from: iso(from),
        to: iso(to)
    };
}
function $4b0a3dedf4b97d1a$export$86fc7fb027b15758(params) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root) return [];
    const { from: from, to: to } = el.call('calendarAgendaRange', params);
    const months = [];
    const [fy, fm] = from.split('-').map(Number);
    const [ty, tm] = to.split('-').map(Number);
    months.push([
        fy,
        fm - 1
    ]);
    if (ty !== fy || tm !== fm) months.push([
        ty,
        tm - 1
    ]);
    return months.map(([y, m])=>el.call('ensureCalendarWindow', root, y, m));
}
function $4b0a3dedf4b97d1a$export$84b8d0d168834471(root, params) {
    const el = this;
    const r = root || el && el.state && el.state.root;
    if (!r || !Array.isArray(r.events)) return null;
    const p = params && typeof params === 'object' ? params : {};
    const { from: from, to: to } = el.call('calendarAgendaRange', p);
    const me = String(r.currentUserEmail || '').toLowerCase();
    // `person` names one teammate: an email, or a name the roster knows.
    let who = null;
    const person = typeof p.person === 'string' ? p.person.trim().toLowerCase() : '';
    if (person) {
        if (person.includes('@')) who = person;
        else {
            const people = Array.isArray(r.people) ? r.people : [];
            const hit = people.find((x)=>{
                const name = String(x && (x.name || [
                    x.firstName,
                    x.lastName
                ].filter(Boolean).join(' ')) || '').toLowerCase();
                return name && (name === person || name.split(' ').includes(person));
            });
            who = hit && hit.email ? String(hit.email).toLowerCase() : '\u0000';
        }
    } else if (p.who !== 'team') who = me;
    const emailsOf = (ev)=>{
        const out = [
            ev.googleCalendarId,
            ev.creatorEmail
        ];
        for (const i of Array.isArray(ev.invitees) ? ev.invitees : [])out.push(typeof i === 'string' ? i : i && i.email);
        return out.filter(Boolean).map((x)=>String(x).toLowerCase());
    };
    const events = who ? r.events.filter((ev)=>ev && emailsOf(ev).includes(who)) : r.events;
    const lang = el.call('getActiveLang') || 'en';
    const time = (ev)=>{
        if (!ev.startTime) return String(el.call('polyglot', 'calendar.agenda.allDay'));
        const clock = (hhmm)=>{
            const [h, m] = String(hhmm).split(':').map(Number);
            if (!Number.isFinite(h)) return String(hhmm);
            return el.call('formatTzTime', new Date(2000, 0, 1, h, m || 0).getTime(), undefined, lang);
        };
        return clock(ev.startTime) + (ev.endTime ? " \u2013 " + clock(ev.endTime) : '');
    };
    const DAYS = [
        'sun',
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat'
    ];
    const MONTHS = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december'
    ];
    const out = [];
    const [fy, fm, fd] = from.split('-').map(Number);
    const [ty, tm, td] = to.split('-').map(Number);
    const end = new Date(ty, tm - 1, td);
    for(let d = new Date(fy, fm - 1, fd); d <= end; d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1)){
        // One meeting synced from several calendars (the organiser's and an
        // invitee's Google calendar) is ONE row: same title, time and place, as
        // the home "Next up" reads it (Fly QA on dev, 2026-10-18: "Team Leads"
        // twice on Mon 19 — records 85 and 330). An untitled event stays as it is.
        const seen = new Set();
        const list = el.call('getEventsForDay', events, d.getFullYear(), d.getMonth(), d.getDate()).filter((ev)=>ev && !ev._isCrossTail).filter((ev)=>{
            if (!ev.title) return true;
            const same = [
                ev.title,
                ev.startTime || '',
                ev.endTime || '',
                ev.location || ''
            ].join('|');
            if (seen.has(same)) return false;
            seen.add(same);
            return true;
        }).sort((a, b)=>String(a.startTime || '').localeCompare(String(b.startTime || '')));
        if (!list.length) continue;
        const key = el.call('formatDate', d.getFullYear(), d.getMonth(), d.getDate());
        const label = el.call('polyglot', 'calendar.day.' + DAYS[d.getDay()]) + ' ' + d.getDate() + ' ' + el.call('polyglot', 'calendar.month.' + MONTHS[d.getMonth()]);
        out.push({
            key: key,
            label: label,
            rows: list.map((ev, i)=>({
                    key: String(ev.id || ev.googleEventId || key + '-' + i) + '@' + key,
                    title: ev.title ? String(ev.title) : String(el.call('polyglot', 'calendar.agenda.untitled')),
                    meta: time(ev),
                    open: {
                        call: 'openEventDetailModal',
                        arg: ev
                    }
                }))
        });
    }
    return out;
}

});

parcelRegister("5wPUz", function(module, exports) {

$parcel$export(module.exports, "calendarAiForms", () => $406835714ce17ba1$export$a1866988087fbdad);
$parcel$export(module.exports, "calendarAiFormOpen", () => $406835714ce17ba1$export$547c2bc0b8324302);
// THE CALENDAR'S OWN BOOKING FORM IN AN AI ANSWER (workspace functions/
// assistantAppForms.js). The assistant proposes an event — a new meeting, or
// an existing event moved to another day and time. The answer's "Review and
// save" calls calendarAiFormOpen, which opens the calendar's own booking sheet
// (CalNewBookingModal through openNewBookingModal) seeded with the proposal.
// Nothing is written until the member saves in the sheet; saveEvent then
// reports the saved event back (the draft's `aiRequest`), so the answer shows
// it as a row that opens the event.
function $406835714ce17ba1$export$a1866988087fbdad() {
    return {
        app: {
            id: 'system/calendar',
            navbar: [
                {
                    label: 'shell.app.calendar',
                    route: '/calendar',
                    icon: 'date outline'
                }
            ],
            apps: [
                {
                    icon: 'date outline'
                }
            ]
        },
        forms: [
            {
                id: 'calendar-event',
                title: 'calendar.aiForm.title',
                describe: 'Create a calendar event, or move / edit one (recordId = the event id): title, date, start, end, invitees, description.',
                open: 'calendarAiFormOpen',
                fields: {
                    title: {
                        type: 'string',
                        label: 'calendar.aiForm.field.title'
                    },
                    date: {
                        type: 'date',
                        label: 'calendar.aiForm.field.date'
                    },
                    startTime: {
                        type: 'string',
                        describe: 'HH:MM',
                        label: 'calendar.aiForm.field.start'
                    },
                    endTime: {
                        type: 'string',
                        describe: 'HH:MM',
                        label: 'calendar.aiForm.field.end'
                    },
                    invitees: {
                        type: 'string',
                        describe: 'emails, comma separated',
                        label: 'calendar.aiForm.field.invitees'
                    },
                    description: {
                        type: 'string',
                        label: 'calendar.aiForm.field.description'
                    }
                }
            }
        ]
    };
}
function $406835714ce17ba1$export$547c2bc0b8324302(formId, args) {
    const el = this;
    if (formId !== 'calendar-event') return false;
    const root = el.state && el.state.root;
    if (!root) return false;
    const a = args && typeof args === 'object' ? args : {};
    const v = a.values && typeof a.values === 'object' ? a.values : {};
    const patch = {};
    for (const k of [
        'title',
        'date',
        'startTime',
        'endTime',
        'description'
    ])if (v[k] != null && v[k] !== '') patch[k] = String(v[k]);
    if (v.invitees != null && v.invitees !== '') patch.invitees = Array.isArray(v.invitees) ? v.invitees.join(', ') : String(v.invitees);
    const aiRequest = a.requestId ? String(a.requestId) : null;
    if (a.recordId != null && a.recordId !== '') {
        const ev = (root.events || []).find((x)=>x && String(x.id) === String(a.recordId));
        if (!ev) return false;
        if (el.call('calendarCanWriteEvent', ev, root) !== true) {
            el.call('openEventDetailModal', ev);
            return true;
        }
        const inferred = el.call('inferRecurrence', root.events, ev) || {};
        const booking = el.call('freshBooking', {
            title: ev.title || '',
            date: ev.date,
            startTime: ev.startTime,
            endTime: ev.endTime,
            invitees: (ev.invitees || []).join(', '),
            description: ev.description || '',
            type: ev.type || 'meeting',
            meetingMode: ev.meetingMode || 'symbols-meet',
            meetUrl: ev.meetUrl || '',
            recurring: inferred.recurring || 'none',
            recurringDays: inferred.recurringDays || [],
            recurrenceEndType: ev.recurrenceEndType || 'after',
            recurrenceEndCount: ev.recurrenceEndCount || 10,
            recurrenceEndDate: ev.recurrenceEndDate || '',
            integrationMetadata: ev.integrationMetadata,
            reminderMinutes: ev.reminderMinutes ?? null,
            editingEventId: ev.id,
            ...patch,
            aiRequest: aiRequest
        });
        el.call('openNewBookingModal', {
            __booking: booking
        });
        return true;
    }
    el.call('openNewBookingModal', {
        ...patch,
        aiRequest: aiRequest
    });
    return true;
}

});

parcelRegister("kPwk0", function(module, exports) {

$parcel$export(module.exports, "confirmEventDeletion", () => $f2a1a475812d4aa6$export$492ba61c6adaf4d7);
// Timed instances end `_YYYYMMDDTHHMMSSZ`; ALL-DAY instances end `_YYYYMMDD`
// (no time part) — both are series-instance shapes Google actually emits.
const $f2a1a475812d4aa6$var$GOOGLE_INSTANCE_SUFFIX = /_\d{8}(T\d{6}Z)?$/;
const $f2a1a475812d4aa6$var$googleSeriesId = (googleEventId)=>googleEventId && $f2a1a475812d4aa6$var$GOOGLE_INSTANCE_SUFFIX.test(googleEventId) ? googleEventId.replace($f2a1a475812d4aa6$var$GOOGLE_INSTANCE_SUFFIX, '') : null;
const $f2a1a475812d4aa6$var$previousDate = (date)=>{
    const [year, month, day] = String(date || '').split('-').map(Number);
    if (!year || !month || !day) return null;
    return new Date(Date.UTC(year, month - 1, day - 1)).toISOString().slice(0, 10);
};
// The recurring dialog's own layer id: its buttons close THIS layer by id,
// never by popping whatever layer is on top.
const $f2a1a475812d4aa6$var$DELETE_LAYER_ID = 'cal-event-delete';
// A failed write puts the optimistic change back (CRUD + confirmation
// standard, rule 5). The write itself already told the person why: saveEvent
// and deleteEvent raise their own error toast. Both helpers read the LIVE
// rows, so a sync that landed meanwhile is never reverted.
const $f2a1a475812d4aa6$var$restoreRows = (root, rows)=>{
    if (!rows.length || typeof root?.update !== 'function') return;
    const live = root.events || [];
    const present = new Set(live.map((item)=>item.id));
    const missing = rows.filter((row)=>!present.has(row.id));
    if (missing.length) root.update({
        events: [
            ...live,
            ...missing
        ]
    });
};
const $f2a1a475812d4aa6$var$restoreRow = (root, row)=>{
    if (typeof root?.update !== 'function') return;
    const live = root.events || [];
    if (!live.some((item)=>item.id === row.id)) return;
    root.update({
        events: live.map((item)=>item.id === row.id ? row : item)
    });
};
// Soft-delete each row; a row whose write fails comes back.
const $f2a1a475812d4aa6$var$deleteOrRestore = (caller, root, rows)=>Promise.all(rows.map((row)=>Promise.resolve(caller.call('deleteEvent', row.id)).then((ok)=>ok === false ? row : null, ()=>row))).then((failed)=>$f2a1a475812d4aa6$var$restoreRows(root, failed.filter(Boolean)));
// Save the changed series row; when the write fails the row before the
// change comes back.
const $f2a1a475812d4aa6$var$saveOrRestore = (caller, root, next, previous)=>Promise.resolve(caller.call('saveEvent', next, {
        falseOnFail: true
    })).then((ok)=>{
        if (ok === false) $f2a1a475812d4aa6$var$restoreRow(root, previous);
    }, ()=>$f2a1a475812d4aa6$var$restoreRow(root, previous));
const $f2a1a475812d4aa6$export$492ba61c6adaf4d7 = (el, root, event, closeFunction, options)=>{
    if (!event?.id) return;
    // Open-time snapshot — used ONLY for dialog-shape decisions below. The
    // delete handlers re-read root.events at confirm time (deleteEvents), so
    // a dialog left open across a sync or another view's edit never reverts
    // what landed in the meantime.
    const events = root.events || [];
    const seriesId = $f2a1a475812d4aa6$var$googleSeriesId(event.googleEventId);
    const seriesEvents = seriesId ? events.filter((item)=>$f2a1a475812d4aa6$var$googleSeriesId(item.googleEventId) === seriesId) : [];
    // A series-shaped instance id is proof of recurrence on its own — the
    // loaded window may hold a single materialized row of a Google series,
    // and the sync writes no per-row `recurring` metadata.
    const isRecurring = event.recurring && event.recurring !== 'none' || Boolean(seriesId) || seriesEvents.length > 1;
    // scope:'series' — the caller acts on the SERIES itself (the edit modal
    // edits the source row and has no occurrence context), so the dialog is
    // the plain confirm and the handler deletes the row outright instead of
    // excluding or truncating at an occurrence date.
    const seriesScope = options?.scope === 'series';
    const scopedRecurring = isRecurring && !seriesScope;
    // ONE string for the modal title and the visible heading — the windows
    // layer points aria-labelledby at the title heading (modal-title-<id>),
    // so a title that differs from what the user sees makes the dialog
    // announce something the screen never shows (label-in-name mismatch,
    // WS-CAL-DELETE-DIALOG-A11Y-1). A function replacement: the title is the
    // person's own text, and `$&` in it is not a pattern.
    const eventTitle = event.title || el.call('polyglot', 'calendar.delete.eventFallback');
    const title = el.call('polyglot', scopedRecurring ? 'calendar.delete.recurringTitle' : 'calendar.delete.confirmTitle').replace('{title}', ()=>eventTitle);
    // Runs only after the person picked a delete. `caller` is the element whose
    // `call` reaches the write functions.
    const deleteEvents = (caller, includeFuture = false)=>{
        // Fresh read — never the open-time snapshot (see note above).
        const liveEvents = root.events || [];
        const sourceEvent = liveEvents.find((item)=>item.id === event.id) || event;
        const isLocalRecurrence = !seriesId && sourceEvent.recurring && sourceEvent.recurring !== 'none';
        if (!seriesScope && !includeFuture && isLocalRecurrence && event.date) {
            const recurrenceExcludedDates = [
                ...new Set([
                    ...sourceEvent.recurrenceExcludedDates || [],
                    event.date
                ])
            ].sort();
            const updatedEvent = {
                ...sourceEvent,
                recurrenceExcludedDates: recurrenceExcludedDates
            };
            root.update({
                events: liveEvents.map((item)=>item.id === sourceEvent.id ? updatedEvent : item)
            });
            $f2a1a475812d4aa6$var$saveOrRestore(caller, root, updatedEvent, sourceEvent);
            if (closeFunction) caller.call(closeFunction);
            return;
        }
        if (!seriesScope && includeFuture && !seriesId && event.date > sourceEvent.date) {
            const recurrenceEndDate = $f2a1a475812d4aa6$var$previousDate(event.date);
            if (recurrenceEndDate) {
                const truncatedEvent = {
                    ...sourceEvent,
                    recurrenceEndType: 'on',
                    recurrenceEndDate: recurrenceEndDate
                };
                root.update({
                    events: liveEvents.map((item)=>item.id === sourceEvent.id ? truncatedEvent : item)
                });
                $f2a1a475812d4aa6$var$saveOrRestore(caller, root, truncatedEvent, sourceEvent);
                if (closeFunction) caller.call(closeFunction);
                return;
            }
        }
        const liveSeriesEvents = seriesId ? liveEvents.filter((item)=>$f2a1a475812d4aa6$var$googleSeriesId(item.googleEventId) === seriesId) : [];
        const targets = includeFuture && liveSeriesEvents.length ? liveSeriesEvents.filter((item)=>item.date >= event.date) : [
            sourceEvent
        ];
        const targetIds = new Set(targets.map((item)=>item.id));
        root.update({
            events: liveEvents.filter((item)=>!targetIds.has(item.id))
        });
        // Google series, future scope: ONE server-side filtered soft-delete over
        // the PERSISTED series — instances outside the loaded window included
        // (CORE-CALENDAR-SERIES-BULK-SOFT-DELETE-1; the dedicated deleteFuture
        // op exists because the update op's argMaps.idPayload drops every filter
        // param, which is how the original bulk attempt died inside the SDK).
        // Feature-detected: a registry sdk that predates the op rejects with an
        // unsupported-op error and the loaded-window per-id loop takes over, so
        // this call site stays safe on sdk 3.14.785. On bulk success the sync
        // pass is kicked so the server-side tombstones reach Google without
        // waiting for the next scheduled pass.
        if (includeFuture && seriesId && typeof caller.context?.methods?.sdk?.execute === 'function') caller.context.methods.sdk.execute('workspaceProject.calendar', 'deleteFuture', {
            seriesId: seriesId,
            fromDate: event.date
        }).then(()=>caller.call('triggerCalendarSync')).catch(()=>$f2a1a475812d4aa6$var$deleteOrRestore(caller, root, targets));
        else $f2a1a475812d4aa6$var$deleteOrRestore(caller, root, targets);
        if (closeFunction) caller.call(closeFunction);
    };
    if (!scopedRecurring) {
        // The house confirm (standard D1). Its Confirm button calls `onConfirm`
        // and closes its own layer; `el` is the Delete button that asked.
        el.call('confirmDialog', {
            title: title,
            message: el.call('polyglot', seriesScope && isRecurring ? 'calendar.delete.bodySeries' : 'calendar.delete.bodySingle'),
            confirmText: el.call('polyglot', 'calendar.delete.confirm'),
            cancelText: el.call('polyglot', 'common.action.cancel'),
            confirmTheme: 'primary',
            icon: null,
            onConfirm: ()=>deleteEvents(el)
        });
        return;
    }
    // The three-choice dialog for one occurrence of a recurring event. Its
    // buttons follow the house confirm: Cancel is the design system's
    // CancelButton, each delete is a primary Button that names its scope.
    const pick = (includeFuture)=>(e, button)=>{
            deleteEvents(button, includeFuture);
            button.call('closeModal', $f2a1a475812d4aa6$var$DELETE_LAYER_ID);
        };
    el.call('openModal', {
        id: $f2a1a475812d4aa6$var$DELETE_LAYER_ID,
        template: 'custom',
        // MODAL-X-OVERFLOW-1: every custom-template layer needs an outer
        // ceiling, or a short viewport pushes the Close X off-screen (the
        // class-level sweep in workspace/__tests__/modalXOverflowSweep.test.js
        // enforces this on every raw openModal({template:'custom'}) site).
        maxHeight: '90vh',
        title: title,
        content: {
            flow: 'y',
            gap: 'B',
            minWidth: '0',
            overflowX: 'hidden',
            Hgroup: {
                minWidth: '0',
                H: {
                    tag: 'h5',
                    fontSize: 'B',
                    // Always the modal title — accessible name === visible heading.
                    text: title,
                    overflowWrap: 'anywhere'
                },
                P: {
                    text: el.call('polyglot', 'calendar.delete.bodyRecurring'),
                    color: 'inactive',
                    overflowWrap: 'anywhere'
                }
            },
            ModalFooter: {
                flow: 'y',
                gap: 'Z1',
                // Cancel comes FIRST in DOM: the windows host focuses the top
                // layer's first focusable after paint (ModalRoot onUpdate, no
                // caller-side focus option), and a dialog must never hand a
                // reflexive Enter to a destructive action. `order` keeps the
                // VISUAL stack unchanged (delete-this, delete-future, cancel);
                // the one-step focus/visual divergence is the deliberate trade
                // for a safe initial default (WS-CAL-DELETE-DIALOG-A11Y-1).
                CancelBtn: {
                    extends: 'CancelButton',
                    width: '100%',
                    order: '3',
                    text: el.call('polyglot', 'common.action.cancel'),
                    onClick: (e, button)=>button.call('closeModal', $f2a1a475812d4aa6$var$DELETE_LAYER_ID)
                },
                DeleteThisBtn: {
                    extends: 'Button',
                    theme: 'primary',
                    width: '100%',
                    order: '1',
                    text: el.call('polyglot', 'calendar.delete.onlyThis'),
                    onClick: pick(false)
                },
                DeleteFutureBtn: {
                    extends: 'Button',
                    theme: 'primary',
                    width: '100%',
                    order: '2',
                    text: el.call('polyglot', 'calendar.delete.allFuture'),
                    onClick: pick(true)
                }
            }
        }
    });
};

});

parcelRegister("185Mg", function(module, exports) {

$parcel$export(module.exports, "calendarCanAcceptProposal", () => $0d2b0511d673ec2d$export$3854b84c055aa14d);
$parcel$export(module.exports, "calendarCanDeclineProposal", () => $0d2b0511d673ec2d$export$8563737d2cb249ba);
$parcel$export(module.exports, "acceptEventProposal", () => $0d2b0511d673ec2d$export$267d2f3eef9f32e5);
$parcel$export(module.exports, "declineEventProposal", () => $0d2b0511d673ec2d$export$adfdb7d573d58af3);
// A pending time proposal — the shadow row a participant's drag leaves at the
// new time (pages/index.js: `isProposal`, `originalEventId`, `proposedBy`).
// Accept moves the ORIGINAL event to the proposed time and deletes the
// shadow; Decline deletes the shadow and leaves the original where it is.
//
// Both ask first through the house confirm (CRUD + confirmation standard,
// rules 3–5): Accept moves an event for everyone invited, Decline deletes the
// proposal. Nothing is written before the person confirms, and a write that
// fails puts the rows back (saveEvent / deleteEvent raise their own error
// toast). Other calendar functions are reached through `this.call`, never by
// an import.
const $0d2b0511d673ec2d$var$_findOriginal = (root, proposal)=>(root.events || []).find((item)=>item.id === proposal.originalEventId) || null;
const $0d2b0511d673ec2d$var$_sameEmail = (a, b)=>{
    const x = String(a || '').trim().toLowerCase();
    return !!x && x === String(b || '').trim().toLowerCase();
};
function $0d2b0511d673ec2d$export$3854b84c055aa14d(proposal, root) {
    const r = root || this && this.state && this.state.root || null;
    if (!r || !proposal || !proposal.isProposal || typeof this?.call !== 'function') return false;
    const original = $0d2b0511d673ec2d$var$_findOriginal(r, proposal);
    return !!original && this.call('calendarCanWriteEvent', original, r) === true;
}
function $0d2b0511d673ec2d$export$8563737d2cb249ba(proposal, root) {
    const r = root || this && this.state && this.state.root || null;
    if (!r || !proposal || !proposal.isProposal || typeof this?.call !== 'function') return false;
    if ($0d2b0511d673ec2d$var$_sameEmail(proposal.proposedBy, r.currentUserEmail)) return true;
    const original = $0d2b0511d673ec2d$var$_findOriginal(r, proposal) || proposal;
    return this.call('calendarCanWriteEvent', original, r) === true;
}
// The event's own title for the question, or the generic "event".
const $0d2b0511d673ec2d$var$_titleOf = (el, root, proposal)=>{
    const original = $0d2b0511d673ec2d$var$_findOriginal(root, proposal);
    return original && original.title || proposal.title || el.call('polyglot', 'calendar.delete.eventFallback');
};
// Put the original row back as it was, and the proposal next to it.
const $0d2b0511d673ec2d$var$_restoreProposal = (root, original, shadow)=>{
    const next = (root.events || []).map((item)=>original && item.id === original.id ? original : item);
    if (shadow && !next.some((item)=>item.id === shadow.id)) next.push(shadow);
    root.update({
        events: next
    });
};
function $0d2b0511d673ec2d$export$267d2f3eef9f32e5(proposal) {
    const root = this && this.state && this.state.root;
    if (!root || !proposal || !proposal.isProposal) return Promise.resolve(false);
    const t = (key)=>this.call('polyglot', key);
    const title = $0d2b0511d673ec2d$var$_titleOf(this, root, proposal);
    return new Promise((resolve)=>{
        this.call('confirmDialog', {
            title: t('calendar.proposal.acceptTitle'),
            // A function replacement: the title is the person's own text.
            message: t('calendar.proposal.acceptMessage').replace('{title}', ()=>title),
            confirmText: t('calendar.detail.accept'),
            cancelText: t('common.action.cancel'),
            confirmTheme: 'primary',
            icon: null,
            onConfirm: ()=>resolve($0d2b0511d673ec2d$var$_acceptNow.call(this, root, proposal)),
            onCancel: ()=>resolve(false)
        });
    });
}
const $0d2b0511d673ec2d$var$_acceptNow = async function(root, proposal) {
    // Live rows, read at confirm time: a sync may have landed meanwhile.
    const live = root.events || [];
    const original = $0d2b0511d673ec2d$var$_findOriginal(root, proposal);
    const shadow = live.find((item)=>item.id === proposal.id) || proposal;
    if (!original) return false;
    const moved = {
        ...original,
        date: shadow.date,
        startTime: shadow.startTime,
        endTime: shadow.endTime
    };
    root.update({
        events: live.filter((item)=>item.id !== shadow.id).map((item)=>item.id === original.id ? moved : item)
    });
    this.call('closeEventDetailModal');
    // The move first: when it fails the proposal must stay, so it can be
    // accepted again.
    const saved = await this.call('saveEvent', moved, {
        falseOnFail: true
    });
    if (saved === false) {
        $0d2b0511d673ec2d$var$_restoreProposal(root, original, shadow);
        return false;
    }
    const deleted = await this.call('deleteEvent', shadow.id);
    if (deleted === false) {
        $0d2b0511d673ec2d$var$_restoreProposal(root, null, shadow);
        return false;
    }
    return true;
};
function $0d2b0511d673ec2d$export$adfdb7d573d58af3(proposal) {
    const root = this && this.state && this.state.root;
    if (!root || !proposal || !proposal.isProposal) return Promise.resolve(false);
    const t = (key)=>this.call('polyglot', key);
    const title = $0d2b0511d673ec2d$var$_titleOf(this, root, proposal);
    return new Promise((resolve)=>{
        this.call('confirmDialog', {
            title: t('calendar.proposal.declineTitle'),
            message: t('calendar.proposal.declineMessage').replace('{title}', ()=>title),
            confirmText: t('calendar.detail.decline'),
            cancelText: t('common.action.cancel'),
            confirmTheme: 'primary',
            icon: null,
            onConfirm: ()=>resolve($0d2b0511d673ec2d$var$_declineNow.call(this, root, proposal)),
            onCancel: ()=>resolve(false)
        });
    });
}
const $0d2b0511d673ec2d$var$_declineNow = async function(root, proposal) {
    const live = root.events || [];
    const shadow = live.find((item)=>item.id === proposal.id) || proposal;
    root.update({
        events: live.filter((item)=>item.id !== shadow.id)
    });
    this.call('closeEventDetailModal');
    const deleted = await this.call('deleteEvent', shadow.id);
    if (deleted === false) {
        $0d2b0511d673ec2d$var$_restoreProposal(root, null, shadow);
        return false;
    }
    return true;
};

});


parcelRegister("kSoNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32c1501cf4632c9$export$2e2bcd8739ae039);
// Calendar-related root state — merged into the workspace shell via sharedLibraries.
var $f32c1501cf4632c9$export$2e2bcd8739ae039 = {
    viewMode: 'week',
    selectedEvent: null,
    calendarEvents: [],
    calendarLoading: false,
    // Team roster customisation is intentionally session-local. These keys
    // never participate in calendar fetch/save payloads.
    teamMembers: [],
    showAddTeammates: false,
    addTeammateQuery: '',
    addTeammateFeedback: '',
    // Phone rail (CalRailSheet) open flag. Declared here — and NOT only where
    // it's written — because this slice is seeded at boot via the calendar eager
    // slice, and v3.14 root.update() on an undeclared key trips the schema
    // check. The sheet, the header's CalRailBtn chip and the left-edge pull all
    // write it.
    _calRailOpen: false
};

});

parcelRegister("cTOvE", function(module, exports) {
// Eager slim slice of the meet component barrel (bundle-fold, 2026-08-01).
//
// The full `./index.js` barrel `export *`s all 16 meet component files — the
// whole call/room/transcript/suggestion UI tree. sharedLibraries.js used to
// drag ALL of it into the shell's EAGER chunk by folding the full meet
// context (`import meet from '@symbo-ls/workspace-meet'`).
//
// Meet is now a lazy sub-app: the `/meet` + `/meet-guest` routes fold the
// FULL meet context into the live shell context on first mount
// (workspace/pages/index.js + pages/main.js → lazySharedLibPage/lazyPage).
// So every meet UI key those routes reference resolves against the folded
// context — none of the heavy page-body components (MeetMain, MeetSidebar,
// MeetRoomList, MeetVideoRoom, MeetParticipantTile, MeetControlBar,
// MeetTranscriptPage/Panel, MeetSuggestionCard, …) needs to be eager.
//
// Three component files stay eager, because non-meet surfaces mount/extend
// their keys BEFORE the /meet route folds the context, and none of those
// surfaces fold meet on their own:
//   • CallWidget.js — `MeetCallWidget` is bare-keyed at the shell root
//     (workspace/app.js), the persistent floating call dock that must stay
//     mounted (and visible) across every route while a call is live.
//   • ControlBarIconButton.js — `MeetCallWidget`'s own mic/return/leave
//     controls `extends: 'MeetControlBarIconButton'`; split out of
//     ControlBar.js (20KB, itself lazy) specifically so this shared base
//     stays tiny and self-contained.
//   • MeetNewRoomModal.js — `MeetNewRoomModal` is opened via a @symbo.ls/windows
//     custom-template layer (`content: { extends: 'MeetNewRoomModal' }`) by
//     `openNewRoomModal` (functions/eagerSlice.js), which the GLOBAL app
//     header's "New meeting" action (shared/components/AppHeader.js +
//     MainNavbar.js) and PersonPopover call from ANY route, long before
//     /meet ever mounts.

var $1jEXZ = parcelRequire("1jEXZ");

var $kUUhE = parcelRequire("kUUhE");

var $7CcEV = parcelRequire("7CcEV");

var $70zqv = parcelRequire("70zqv");

var $d19kx = parcelRequire("d19kx");
$parcel$exportWildcard(module.exports, $1jEXZ);
$parcel$exportWildcard(module.exports, $kUUhE);
$parcel$exportWildcard(module.exports, $7CcEV);
$parcel$exportWildcard(module.exports, $70zqv);
$parcel$exportWildcard(module.exports, $d19kx);

});
parcelRegister("1jEXZ", function(module, exports) {

$parcel$export(module.exports, "MeetCallAudio", () => $0f5757e535b29534$export$8fb7574899b0967c);
// THE CALL'S SOUND — one <audio> per remote member at the shell root, beside
// the dock (workspace app.js mounts `MeetCallAudio` next to MeetCallWidget),
// so a live call keeps playing on every route: the tiles' own <audio>
// unmounted with /meet and a call went silent behind the dock (a Codex review
// of the call theater, 2026-10-18). The element renders nothing on screen; the
// track reaches it from its render (functions/callAudio.js) and from
// connectCall's track events (functions/attachTracks.js). A member who leaves
// takes their element with them; a call that ends empties the list.
const $0f5757e535b29534$export$8fb7574899b0967c = {
    dataMeetCallAudio: true,
    display: 'none',
    ariaHidden: 'true',
    childrenAs: 'state',
    // the call's own list — read here, so the host re-runs on every change
    children: (el, s)=>el.call('meetCallAudioMembers', s.root),
    childrenDeps: [
        'livekitParticipants'
    ],
    childProps: {
        tag: 'audio',
        dataMeetAudioFor: (el, s)=>s && s.identity || null,
        autoplay: 'autoplay',
        onRender: (el, s)=>el.call('meetCallAudioAttach', el, s)
    }
};

});

parcelRegister("kUUhE", function(module, exports) {

$parcel$export(module.exports, "MeetCallWidget", () => $f3a4b2665b4d7ff7$export$493ad18cf0a2276);
// MeetCallWidget — persistent floating call dock mounted ONCE at the shell
// root (packages/workspace/app.js — same pattern as OnlineMembersDock).
// Visible whenever a LiveKit Room is connected AND the user is NOT looking
// at the /meet call view itself, so navigating anywhere in the workspace
// keeps the call alive with a visible, actionable handle back to it.
//
// The LiveKit Room is a module variable in connectCall.js — navigation never
// tears it down. The ONLY disconnect paths are explicit user actions (this
// widget's Leave, ControlBar Leave/End) plus the beforeunload hook.
//
// Bottom-RIGHT corner: OnlineMembersDock owns bottom-left and the
// CanvasPromptTextarea owns bottom-center. On the canvas routes the shell's
// Zoombar shares this corner: the dock sits above it (`--zoombar-clear`, its
// top edge from the viewport bottom: a length the shell registers and
// measures, 0 elsewhere — this dock mounts only at the shell root).
//
// FLY IN A CALL (functions/meetFly.js): while the call's THEATER is open —
// the call's pages on the main layer over the call view — the theater's own
// bar carries the call (workspace AssistantFlyCallView: live dot, people,
// the live caption, mic, Back to call, Leave), so this dock steps aside.
// Off the call, a call with pages offers them here as well.
//
// LAYER: above the main layer (AssistantMainLayer, 1250 — the Fly canvas and
// the theater), below the sheets and popovers (1340+). At 1150 the main layer
// covered the dock's top edge and took the press meant for it: the minimized
// call "would not open back" (Nika 2026-10-23).

var $3lM30 = parcelRequire("3lM30");

var $lCXAE = parcelRequire("lCXAE");

var $7urfU = parcelRequire("7urfU");

var $9juhh = parcelRequire("9juhh");
const $f3a4b2665b4d7ff7$var$_meetMe = (s)=>(s.root?.livekitParticipants || []).find((p)=>p.isLocal);
const $f3a4b2665b4d7ff7$var$_activeRoom = (s)=>(s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId) || null;
const $f3a4b2665b4d7ff7$var$_connectedRoomId = (s)=>{
    const live = (0, $3lM30.getLivekitRoom)();
    return live?._smblsRoomId || s.root?.activeRoomId || null;
};
const $f3a4b2665b4d7ff7$export$493ad18cf0a2276 = {
    // Show whenever a call is live and the user is off the call view. The
    // path check matters: meetView stays 'call' in root state after SPA
    // navigation, so gating on meetView alone kept the widget hidden on
    // every other page (the original "navigating kicks me out" symptom).
    hide: (el, s)=>{
        if (!s.root?.livekitConnected) return true;
        // The theater covers the call view and its bar carries the call.
        if ((0, $7urfU.meetFlyTheaterOpen)(s.root)) return true;
        // The call view on screen in a pane (the meet sheet over another route):
        // the call is already there — two call surfaces read as two calls.
        const inSlot = [
            s.root?._canvasSlot,
            s.root?._canvasSlotSecond
        ].some((r)=>typeof r === 'string' && (0, $9juhh.stripWorkspacePrefix)(r.split('?')[0]) === '/meet');
        if (inSlot && s.root?.meetView === 'call') return true;
        const path = (0, $9juhh.stripWorkspacePrefix)(s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/'));
        return path === '/meet' && s.root?.meetView === 'call';
    },
    // The dock sits at the shell root where nothing else re-renders it —
    // subscribe to the signals that change its visibility or content.
    subscribeTo: [
        'livekitConnected',
        'currentPath',
        'meetView',
        'livekitParticipants',
        'rooms',
        'meetFly',
        '_canvasSlot',
        '_canvasSlotSecond'
    ],
    position: 'fixed',
    bottom: 'calc(var(--spacing-A) + var(--zoombar-clear))',
    right: 'A',
    zIndex: '1300',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z Z1',
    // Floating dock over live content — the `float`-elevation glass island
    // class, per DESIGN_LANGUAGE.md §3's own radiusSheet definition
    // ("modals, sheets, docked panels, floating islands").
    round: 'radiusSheet',
    theme: 'canvas-card-glass',
    LiveDot: {
        tag: 'span',
        boxSize: 'X2',
        minWidth: 'X2',
        round: '100%',
        // the success ink pair (one green per scheme), never a raw hue — the
        // same dot as VideoRoom's LiveLine and the Fly call view's LiveDot
        background: 'successInk'
    },
    Info: {
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        maxWidth: 'F2',
        RoomName: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'title',
            fontWeight: '700',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.call('polyglot', $f3a4b2665b4d7ff7$var$_activeRoom(s)?.name || 'meet.widget.inCall')
        },
        Caption: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                const n = (s.root?.livekitParticipants || []).length;
                const mic = el.call('polyglot', $f3a4b2665b4d7ff7$var$_meetMe(s)?.isMicEnabled ? 'meet.widget.micOn' : 'meet.widget.micOff');
                return el.call('polyglot', 'meet.widget.participantLine').replace('{count}', n || 1).replace('{mic}', mic);
            }
        }
    },
    Controls: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        MicBtn: {
            extends: 'MeetControlBarIconButton',
            width: 'B2',
            height: 'B2',
            fontSize: 'Z1',
            // The bar's own OFF plate (ControlBar MicBtn): the danger ink on its
            // wash, so a muted mic reads at a glance in the dock too.
            theme: 'secondary',
            isOff: (el, s)=>!$f3a4b2665b4d7ff7$var$_meetMe(s)?.isMicEnabled,
            '.isOff': {
                color: 'dangerInk',
                background: 'color-mix(in srgb, currentColor 12%, var(--color-tintBase))'
            },
            ariaPressed: (el, s)=>$f3a4b2665b4d7ff7$var$_meetMe(s)?.isMicEnabled ? 'true' : 'false',
            title: (el)=>el.call('polyglot', 'meet.widget.toggleMic'),
            Icon: {
                icon: (el, s)=>$f3a4b2665b4d7ff7$var$_meetMe(s)?.isMicEnabled ? 'mic' : 'micOff'
            },
            onClick: async (e, el, s)=>{
                const room = (0, $3lM30.getLivekitRoom)();
                if (!room) return;
                const enabled = room.localParticipant.isMicrophoneEnabled;
                await room.localParticipant.setMicrophoneEnabled(!enabled);
            }
        },
        // The call's pages, from anywhere off them (another route, or the call
        // view with the theater closed is the control bar's own button).
        PagesBtn: {
            extends: 'MeetControlBarIconButton',
            width: 'B2',
            height: 'B2',
            fontSize: 'Z1',
            theme: 'secondary',
            hide: (el, s)=>(0, $7urfU.meetFlyTheaterOpen)(s.root) || !(0, $7urfU.meetFlyVisiblePages)((0, $7urfU.meetFlyCallOf)(s.root)).length,
            title: (el)=>el.call('polyglot', 'meet.widget.showPages'),
            ariaLabel: (el)=>el.call('polyglot', 'meet.widget.showPages'),
            Icon: {
                name: 'lnPage'
            },
            onClick: (e, el, s)=>{
                const id = $f3a4b2665b4d7ff7$var$_connectedRoomId(s);
                const call = (0, $7urfU.meetFlyCallOf)(s.root);
                if (!id || !call) return;
                s.root?.update({
                    activeRoomId: id,
                    meetView: 'call',
                    meetFly: {
                        ...call,
                        open: true
                    }
                });
                (0, $lCXAE.routeTo)(el, '/meet');
                if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${id}&view=call`);
            }
        },
        ReturnBtn: {
            extends: 'MeetControlBarIconButton',
            width: 'B2',
            height: 'B2',
            fontSize: 'Z1',
            theme: 'primary',
            title: (el, s)=>el.call('polyglot', (0, $7urfU.meetFlyTheaterOpen)(s.root) ? 'meet.fly.backToCall' : 'meet.widget.returnToCall'),
            Icon: {
                name: 'video'
            },
            onClick: (e, el, s)=>{
                // The theater open over the call: the call comes back in place.
                if ((0, $7urfU.meetFlyTheaterOpen)(s.root)) {
                    const call = (0, $7urfU.meetFlyCallOf)(s.root);
                    if (call) s.root?.update({
                        meetFly: {
                            ...call,
                            open: false
                        }
                    });
                    return;
                }
                const id = $f3a4b2665b4d7ff7$var$_connectedRoomId(s);
                if (!id) return;
                s.root?.update({
                    activeRoomId: id,
                    meetView: 'call'
                });
                (0, $lCXAE.routeTo)(el, '/meet');
                if (typeof window !== 'undefined') history.replaceState(null, '', `#room=${id}&view=call`);
            }
        },
        LeaveBtn: {
            extends: 'MeetControlBarIconButton',
            width: 'B2',
            height: 'B2',
            fontSize: 'Z1',
            theme: null,
            // A fixed brand-hue plate (no `theme:`), so the ink is fixed too — and it is
            // the brand `fillInk` (near-black), not white. White on a raw brand hue read
            // under the 4.5:1 floor in BOTH themes (blue 3.62, red 3.21, green 2.81);
            // near-black reads 5.66 / 6.39 / 7.28. Nika's decision 2026-09-21
            // (treatment 3, design-direction.md §6).
            background: 'red',
            color: 'fillInk',
            title: (el)=>el.call('polyglot', 'meet.widget.leaveCall'),
            Icon: {
                name: 'close'
            },
            onClick: async (e, el, s)=>{
                await el.call('disconnectCall');
                s.root?.update({
                    meetView: 'list'
                });
            }
        }
    }
};

});
parcelRegister("3lM30", function(module, exports) {

$parcel$export(module.exports, "getLivekitRoom", () => $27089a7ea272a698$export$6de9fbdca5e07c80);
$parcel$export(module.exports, "_refreshSpeakers", () => $27089a7ea272a698$export$525392055d097f3d);
$parcel$export(module.exports, "connectCall", () => $27089a7ea272a698$export$3ece0fb79fd8fe03);
$parcel$export(module.exports, "sendMeetChatMessage", () => $27089a7ea272a698$export$52ffc5df72ab54e0);
$parcel$export(module.exports, "disconnectCall", () => $27089a7ea272a698$export$6ce760730bb920ed);
// connectCall — mint a LiveKit token, build a Room, connect, wire events.
// Called from RoomList.MeetRoomRow onClick, Main.Join onClick, NewRoomModal
// submit, etc — anywhere the user enters a call view.
//
// Kept as a registered project function (not a page-level lifecycle hook)
// because DOMQL v3.14 doesn't fire onCreate on `if:`/`extends:` children and
// doesn't fire onUpdate on root state changes. Chat/calendar follow the
// same "imperative action functions, no lifecycle hooks on sub-views"
// pattern.
//
// LiveKit Room instance is stored in a MODULE-LEVEL variable, NOT in
// smbls reactive state. Passing the Room through `root.update({...})`
// strips class methods (the reactive proxy serializes values), so
// `room.disconnect()` fails on subsequent reads. The module variable
// preserves the live instance with methods intact. Components/functions
// that need the Room import `getLivekitRoom()`.

var $8fqQC = parcelRequire("8fqQC");

var $8tejg = parcelRequire("8tejg");

var $lCXAE = parcelRequire("lCXAE");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $29wU0 = parcelRequire("29wU0");

var $5HcyH = parcelRequire("5HcyH");

var $gRr8d = parcelRequire("gRr8d");

var $8iVo8 = parcelRequire("8iVo8");

var $9Rs24 = parcelRequire("9Rs24");
let $27089a7ea272a698$var$_livekitRoom = null;
const $27089a7ea272a698$export$6de9fbdca5e07c80 = ()=>$27089a7ea272a698$var$_livekitRoom;
// Join-phase telemetry — performance marks/measures so a slow join NAMES its
// slow phase (token mint vs module import vs getUserMedia vs connect) instead
// of being one opaque wait. Read via
// performance.getEntriesByType('measure').filter(m => m.name.startsWith('meetjoin:'))
// Same pattern as the wsboot:* marks in
// workspace/functions/loadPrivateData.js. Guarded: no-ops wherever the
// Performance API is absent.
const $27089a7ea272a698$var$_mark = (name)=>{
    try {
        if (typeof performance !== 'undefined') performance.mark(name);
    } catch (_) {
    /* telemetry only */ }
};
const $27089a7ea272a698$var$_measure = (name, from, to)=>{
    try {
        if (typeof performance !== 'undefined') performance.measure(name, from, to);
    } catch (_) {
    /* telemetry only */ }
};
// One-time page-unload hook — LiveKit's server marks an abruptly-closed
// tab as disconnected only after its connection timeout; an explicit
// disconnect() on beforeunload makes the participant leave immediately.
// Module flag guards double-registration (connectCall fires per join).
let $27089a7ea272a698$var$_unloadHookInstalled = false;
const $27089a7ea272a698$var$_installUnloadHook = ()=>{
    if ($27089a7ea272a698$var$_unloadHookInstalled || typeof window === 'undefined') return;
    $27089a7ea272a698$var$_unloadHookInstalled = true;
    window.addEventListener('beforeunload', ()=>{
        try {
            $27089a7ea272a698$var$_livekitRoom?.disconnect();
        } catch (err) {
            console.warn('[connectCall] unload disconnect failed', err);
        }
    });
};
// Filter out the meet-transcriber agent — LiveKit assigns it an identity
// like `agent-AJ_<jobId>` when AgentDispatchClient dispatches a named agent.
// It's listen-only (no tracks published) and should be invisible in the
// human-facing participant grid.
const $27089a7ea272a698$var$_meetIsAgent = (identity)=>typeof identity === 'string' && identity.startsWith('agent-');
// Detect a published screen-share track on a participant. LiveKit
// exposes the source enum as 'screen_share' on the publication; we
// also accept the camelCase form some versions emit. Used both for
// the tile list (one extra tile per active screen-share) and for the
// attach helper (selects the right pub by source).
const $27089a7ea272a698$var$_hasScreenShare = (participant)=>{
    const pubs = typeof participant?.videoTrackPublications?.values === 'function' ? [
        ...participant.videoTrackPublications.values()
    ] : Object.values(participant?.videoTrackPublications || {});
    return pubs.some((p)=>p && p.track && (p.source === 'screen_share' || p.source === 'screenShare'));
};
const $27089a7ea272a698$var$_refreshParticipants = (root, livekitRoom)=>{
    const local = livekitRoom.localParticipant;
    const remoteValues = typeof livekitRoom.remoteParticipants?.values === 'function' ? livekitRoom.remoteParticipants.values() : Object.values(livekitRoom.remoteParticipants || {});
    const remote = Array.from(remoteValues).filter((p)=>!$27089a7ea272a698$var$_meetIsAgent(p.identity));
    // `id` must be stable so smbls can diff the children array and REUSE
    // the existing tile element instead of recreating it on every mic /
    // speaker event. Without a stable id, each refresh spawns fresh
    // <video> DOM nodes and the user sees a flicker every time anyone
    // speaks. Use participant.identity as the id — and append a ':screen'
    // suffix for the virtual screen-share tile so the camera tile and the
    // screen tile diff independently.
    const all = [];
    all.push({
        id: local.identity,
        identity: local.identity,
        name: local.name || local.identity,
        isLocal: true,
        isMicEnabled: local.isMicrophoneEnabled,
        isCameraEnabled: local.isCameraEnabled,
        mediaSource: 'camera',
        isScreen: false
    });
    if ($27089a7ea272a698$var$_hasScreenShare(local)) all.push({
        id: local.identity + ':screen',
        identity: local.identity,
        name: (local.name || local.identity) + ' (screen)',
        isLocal: true,
        isMicEnabled: false,
        isCameraEnabled: true,
        mediaSource: 'screen_share',
        isScreen: true
    });
    for (const p of remote){
        all.push({
            id: p.identity,
            identity: p.identity,
            name: p.name || p.identity,
            isLocal: false,
            isMicEnabled: p.isMicrophoneEnabled,
            isCameraEnabled: p.isCameraEnabled,
            mediaSource: 'camera',
            isScreen: false
        });
        if ($27089a7ea272a698$var$_hasScreenShare(p)) all.push({
            id: p.identity + ':screen',
            identity: p.identity,
            name: (p.name || p.identity) + ' (screen)',
            isLocal: false,
            isMicEnabled: false,
            isCameraEnabled: true,
            mediaSource: 'screen_share',
            isScreen: true
        });
    }
    root.update({
        livekitParticipants: all
    });
    // Re-apply the grid templates + featured-duplicate hide — the TileGrid
    // has no reactive layout path in v3.14 (see tileGridLayout.js).
    (0, $gRr8d.applyTileGridLayout)(root, livekitRoom);
};
const $27089a7ea272a698$export$525392055d097f3d = (root, livekitRoom)=>{
    const speakers = livekitRoom.activeSpeakers || [];
    const set = {};
    for (const p of speakers)set[p.identity] = true;
    root.update({
        livekitSpeakers: set
    });
    // Speaker changes flip featured/filmstrip mode — re-apply imperatively.
    (0, $gRr8d.applyTileGridLayout)(root, livekitRoom);
};


const $27089a7ea272a698$export$3ece0fb79fd8fe03 = async function(roomId, mediaPrefs) {
    const root = this.state.root;
    if (!roomId) roomId = root.activeRoomId;
    if (!roomId) {
        console.error('[connectCall] no roomId');
        return null;
    }
    // Media prefs from the join-preview confirm (MEET-AUTOJOIN-1). Absent →
    // both on, which keeps every non-preview call site (new-call start,
    // in-call retry/reconnect, live-singleton reattach) behaving as before.
    const media = {
        mic: mediaPrefs?.mic !== false,
        cam: mediaPrefs?.cam !== false
    };
    if ($27089a7ea272a698$var$_livekitRoom) {
        // Same room → reuse the live connection. Different room → tear the
        // old one down through the normal disconnect path first (rescopes
        // realtime, clears participant state), then fall through to connect.
        const connectedId = $27089a7ea272a698$var$_livekitRoom._smblsRoomId || $27089a7ea272a698$var$_livekitRoom.name;
        if (connectedId === roomId) {
            // Re-entering the call view for a room we never left (SPA navigation
            // keeps the module-level Room alive). The DOM tiles were torn down
            // with the page, so re-establish the UI side: re-scope realtime back
            // to this room (another page may have narrowed it), refresh the
            // participant state, and re-attach tracks once smbls has re-rendered
            // the tile DOM.
            console.log("[connectCall] already connected \u2014 reattaching UI");
            // CALL-slot subscription — pinned to this room for the life of the
            // call, immune to page-slot re-scopes (see subscribeMeetRealtime.js;
            // idempotent for the same room).
            (0, $9Rs24.subscribeMeetCallRealtime).call(this, roomId);
            root.update({
                livekitConnected: true,
                meetCallInFlight: false
            });
            $27089a7ea272a698$var$_refreshParticipants(root, $27089a7ea272a698$var$_livekitRoom);
            const liveRoom = $27089a7ea272a698$var$_livekitRoom;
            requestAnimationFrame(()=>(0, $8tejg.attachAllParticipantTracks)(liveRoom));
            return $27089a7ea272a698$var$_livekitRoom;
        }
        console.log('[connectCall] switching rooms', connectedId, "\u2192", roomId);
        await this.call('disconnectCall');
    }
    if (root.meetCallInFlight) {
        console.log('[connectCall] already connecting');
        return null;
    }
    root.update({
        meetCallInFlight: true,
        meetCallError: null,
        meetCallErrorName: null,
        meetCallErrorCode: null,
        meetCallErrorReason: null,
        meetCallErrorStatus: null,
        livekitConnected: false
    });
    // MEET-LIVE-CALL-SURVIVES-SWITCH-1 — tenant guard for every write that
    // outlives an await below. Captured HERE, on the same tick as the pre-flight
    // reset and before the first await, so it snapshots the workspace this join
    // was issued for (see functions/sameWorkspaceWriter.js: capturing it inside
    // the completion would snapshot the NEW workspace and never fire).
    //
    // ⛔ THIS GUARD IS ONLY CORRECT BECAUSE THE SWITCH PATH NOW DISCONNECTS
    // FIRST. It was deliberately withheld while `onWorkspaceChange` had no
    // `disconnectCall`: dropping the completion write alone would have left a
    // LIVE LiveKit connection with no state saying so — an invisible active call
    // in B, worse than a stale banner. The completion below therefore treats a
    // DROPPED write as "this connection was born into a dead tenant" and tears
    // the room down; it never just skips the update.
    const _write = (0, $8iVo8.meetSameWorkspaceWriter)(root);
    // CALL-slot realtime — pinned to this room (transcripts + analyses +
    // waiting + rooms) for the WHOLE life of the call, owned here and torn
    // down only by disconnectCall. Previously this rode the single shared
    // page slot, so any page re-scope (visiting the room list mid-call,
    // opening another room's transcript) silently replaced it and live
    // captions + the transcript panel went dead (2026-07-29 per Nika "really
    // fix transcripts not showing up in realtime") — made routine by the
    // persistent-call dock, which keeps calls alive across navigation.
    (0, $9Rs24.subscribeMeetCallRealtime).call(this, roomId);
    // Pre-acquired local tracks (see the prewarm block below) — tracked
    // OUTSIDE the try so every abort path (cross-org redirect, connect
    // failure) can release the devices and kill the camera light.
    let preTracksPromise = null;
    // Kept outside the try so the catch can re-probe the LiveKit edge with
    // the very credentials this attempt dialled (see probeLivekitStatus).
    let _tokenInfo = null;
    const _stopPreTracks = ()=>{
        if (!preTracksPromise) return;
        preTracksPromise.then((tracks)=>{
            if (!Array.isArray(tracks)) return;
            for (const t of tracks)try {
                t.stop();
            } catch (_) {
            /* already stopped */ }
        });
    };
    try {
        $27089a7ea272a698$var$_mark('meetjoin:start');
        // ── Parallel prewarm ────────────────────────────────────────────────
        // The join used to be fully serial: mint (network RTT) → import
        // livekit-client (~250KB gz parse) → connect → mic getUserMedia →
        // camera getUserMedia. Everything that doesn't need the token now
        // starts immediately and runs WHILE the mint round-trips:
        //   - the livekit-client module import + Room construction,
        //   - a DNS/TLS prewarm against the last-known LiveKit host
        //     (room.prepareConnection — the URL is env-stable, cached from the
        //     previous join; a cold cache just skips the prewarm),
        //   - the getUserMedia acquisition for the kinds the user confirmed
        //     (ONE combined permission prompt). Join policy is the preview's
        //     media prefs (MEET-AUTOJOIN-1) — default both-on for non-preview
        //     call sites; tracks are stopped on every abort path so no camera
        //     light leaks.
        $27089a7ea272a698$var$_mark('meetjoin:mint-start');
        const tokenPromise = this.call('mintLivekitToken', roomId);
        const startingCount = (root.liveParticipants?.[roomId] || []).filter((p)=>!p.leftAt).length || 1;
        $27089a7ea272a698$var$_mark('meetjoin:import-start');
        const roomPromise = (0, $8fqQC.buildLivekitRoom)(startingCount).then((room)=>{
            $27089a7ea272a698$var$_mark('meetjoin:import-done');
            $27089a7ea272a698$var$_measure('meetjoin:import', 'meetjoin:import-start', 'meetjoin:import-done');
            try {
                // Keyed by API base (livekitHost.js): a host cached while this
                // origin talked to ANOTHER environment is never prewarmed here.
                const cachedUrl = (0, $5HcyH.readPrewarmHost)(window.localStorage, (0, $29wU0.workspaceApiBase)());
                // ⚠️ DO NOT PASS THE TOKEN AS A SECOND ARGUMENT. It looks like a free
                // optimisation — the SDK docstring recommends it, and with a token
                // LiveKit Cloud also picks the best edge region here. That is exactly
                // what makes it dangerous with a CACHED url.
                //
                // Measured against livekit-client 2.21.0 (`Room.prepareConnection`):
                //   * no token  → `fetch(url, {method:'HEAD'})` only. Pure DNS/TLS
                //     warm. No `regionUrlProvider`, no `this.regionUrl`, no retained
                //     state. A stale cached host warms the wrong DNS entry and is
                //     otherwise INERT — `connect()` below still dials
                //     `tokenInfo.livekitUrl`.
                //   * WITH a token → sets `this.regionUrl`, which OVERRIDES the
                //     connect target. A stale cached host would then genuinely
                //     redirect the connection — a token/URL split created on the
                //     client, the exact shape MEET-LIVEKIT-PROJECT-MISMATCH-1 hunted
                //     server-side and never found.
                //
                // The cache is also self-healing (`rememberPrewarmHost` below
                // rewrites it after every successful mint and reports a move), so
                // staleness only spans a URL change until the next completed join.
                // Both properties are why this is safe TODAY; adding the token
                // silently removes the first one.
                if (cachedUrl) room.prepareConnection(cachedUrl).catch(()=>{});
            } catch (_) {
            /* prewarm only */ }
            return room;
        });
        $27089a7ea272a698$var$_mark('meetjoin:media-start');
        preTracksPromise = (0, $8fqQC.preacquireLocalTracks)(media).then((tracks)=>{
            $27089a7ea272a698$var$_mark('meetjoin:media-acquired');
            $27089a7ea272a698$var$_measure('meetjoin:media-acquire', 'meetjoin:media-start', 'meetjoin:media-acquired');
            return tracks;
        }, // Missing device / permission denied / no mediaDevices — the
        // post-connect fallback path re-runs the per-device taxonomy.
        ()=>null);
        const tokenInfo = await tokenPromise;
        _tokenInfo = tokenInfo;
        $27089a7ea272a698$var$_mark('meetjoin:mint-done');
        $27089a7ea272a698$var$_measure('meetjoin:mint', 'meetjoin:mint-start', 'meetjoin:mint-done');
        // Cross-org room: the mint succeeds on MEMBERSHIP (the server's access
        // gate spans every org the caller belongs to), but this TAB can be
        // scoped to a DIFFERENT org — a bare or foreign-prefixed invite link.
        // Joining here would run the call under the wrong tenant: the room
        // record, participants and transcripts are workspace-scoped reads and
        // all come back empty (live 2026-07-29: a system-org invite opened as
        // /w/natali/meet — user "joined into natali account", no transcripts).
        // Redirect to the room's OWNING org URL instead — a FULL navigation on
        // purpose: switching orgs must run the whole boot pipeline (org pin,
        // workspace resolve, module load, claim convergence), which SPA nav
        // cannot; the hash re-seeds this exact join on arrival. Same class of
        // hard-navigation as signoutAndRedirect.
        //
        // ID-SPACE DISTINCTION (do not regress): `tokenInfo.workspaceId` is the
        // room's WORKSPACE id (meet_rooms.workspace_id) — NOT an org id. Comparing
        // it against root.org ids never matches, which silently disabled this
        // redirect (verified live on dev.my). The server resolves the owning ORG
        // from the Workspace doc and returns it as `organizationId` (null for
        // legacy rooms whose workspace_id resolves to no Workspace) — that is the
        // only value comparable against root.org / root.orgs.
        const _roomOrg = tokenInfo?.organizationId ? String(tokenInfo.organizationId) : null;
        const _activeOrg = String(root.org?.id || root.org?._id || '');
        if (_roomOrg && _activeOrg && _roomOrg !== _activeOrg) {
            const _owning = (root.orgs || []).find((o)=>String(o.id || o._id || '') === _roomOrg);
            const _slug = _owning && (_owning.slug || _owning.username);
            if (_slug && typeof window !== 'undefined') {
                console.warn("[connectCall] room belongs to another org \u2014 redirecting to", _slug);
                _stopPreTracks();
                root.update({
                    meetCallInFlight: false
                });
                // Carry the precise workspace too: boot's workspace resolution
                // accepts a workspace id as the ws-handle fallback, so the redirect
                // lands on the room's exact workspace, not just the org's HQ.
                const _ws = tokenInfo?.workspaceId ? `?ws=${tokenInfo.workspaceId}` : '';
                window.location.assign(`${window.location.origin}/w/${_slug}/meet${_ws}#room=${roomId}&view=call`);
                return null;
            }
        // No membership row for the owning org resolved client-side — proceed
        // with the join (the server already authorized it) rather than strand
        // the user; the call works, only workspace-scoped chrome is degraded.
        }
        // One response, one pair: the token is only valid for the host it was
        // signed with (livekitHost.js). An incomplete or split response refuses
        // here with a named reason instead of reaching the SDK as `connect(
        // undefined, …)` and surfacing as a generic websocket failure.
        const pair = (0, $5HcyH.resolveLivekitPair)(tokenInfo);
        const livekitRoom = await roomPromise;
        // Remember the LiveKit host so the NEXT join can prewarm DNS/TLS in
        // parallel with the mint (see prepareConnection above). Compared against
        // the previous host every mint — a move is the exact diagnostic the
        // production investigation (MEET-LIVEKIT-PROJECT-MISMATCH-1) could not
        // read off the client, so it is logged, never silent.
        const hostCache = (0, $5HcyH.rememberPrewarmHost)(window.localStorage, (0, $29wU0.workspaceApiBase)(), pair.url);
        if (hostCache.changed) console.warn('[connectCall] livekit host moved since the last join', {
            previous: hostCache.previous,
            url: hostCache.url
        });
        // RoomEvent comes from the same lazily-loaded module buildLivekitRoom just
        // imported (cached — this resolves instantly, no extra network round-trip).
        const { RoomEvent: RoomEvent } = await (parcelRequire("8jlbE"));
        // Stamp the workspace roomId on the instance — `room.name` is the
        // LiveKit-side room name which may differ from our meet_rooms id;
        // the room-switch check above reads this stamp first.
        livekitRoom._smblsRoomId = roomId;
        const refresh = ()=>{
            $27089a7ea272a698$var$_refreshParticipants(root, livekitRoom);
            // Schedule the DOM attach pass AFTER smbls has had a chance to
            // (re)render tiles for any newly-arrived participants. Without
            // the rAF deferral, the data-identity selector misses tiles that
            // smbls is still building from the just-updated livekitParticipants
            // array.
            requestAnimationFrame(()=>(0, $8tejg.attachAllParticipantTracks)(livekitRoom));
        };
        // Participant-set events only — events that can change WHO is in the
        // room or what tracks exist.
        livekitRoom.on(RoomEvent.ParticipantConnected, refresh);
        livekitRoom.on(RoomEvent.ParticipantDisconnected, refresh);
        livekitRoom.on(RoomEvent.LocalTrackPublished, refresh);
        livekitRoom.on(RoomEvent.LocalTrackUnpublished, refresh);
        let firstRemoteAudio = false;
        let firstRemoteVideo = false;
        livekitRoom.on(RoomEvent.TrackSubscribed, (track, publication, participant)=>{
            if (!firstRemoteAudio && track?.kind === 'audio') {
                firstRemoteAudio = true;
                $27089a7ea272a698$var$_mark('meetjoin:first-remote-audio');
                $27089a7ea272a698$var$_measure('meetjoin:to-first-remote-audio', 'meetjoin:start', 'meetjoin:first-remote-audio');
            }
            if (!firstRemoteVideo && track?.kind === 'video') {
                firstRemoteVideo = true;
                $27089a7ea272a698$var$_mark('meetjoin:first-remote-video');
                $27089a7ea272a698$var$_measure('meetjoin:to-first-remote-video', 'meetjoin:start', 'meetjoin:first-remote-video');
            }
            // Targeted attach FIRST — when the tile is already in the DOM the
            // media element gets the track THIS tick (remote audio starts playing
            // immediately) instead of waiting out the state-update + rAF
            // choreography. The refresh() below still covers the
            // tile-not-yet-rendered case (its rAF sweep attaches next frame).
            if (participant?.identity) (0, $8tejg.attachParticipantTracks)(livekitRoom, participant.identity, false);
            refresh();
        });
        livekitRoom.on(RoomEvent.TrackUnsubscribed, refresh);
        // Mute toggles change isMicEnabled/isCameraEnabled — also a full
        // refresh. These fire on user action, not per-frame, so the diff
        // stays stable.
        livekitRoom.on(RoomEvent.TrackMuted, refresh);
        livekitRoom.on(RoomEvent.TrackUnmuted, refresh);
        // ActiveSpeakersChanged fires on EVERY spoken syllable. Route to a
        // separate state slot (livekitSpeakers) so updating it doesn't
        // invalidate the livekitParticipants diff and tear down tile DOM.
        livekitRoom.on(RoomEvent.ActiveSpeakersChanged, ()=>$27089a7ea272a698$export$525392055d097f3d(root, livekitRoom));
        livekitRoom.on(RoomEvent.Disconnected, ()=>{
            console.log('[meet] livekit disconnected');
            $27089a7ea272a698$var$_livekitRoom = null;
            // A fly page on the stage belongs to this call (functions/meetFly.js).
            root.update({
                livekitParticipants: [],
                livekitConnected: false,
                meetFly: null
            });
        });
        // FLY IN A CALL (functions/meetFly.js): the call's pages and its Fly
        // switch reach every member on the `symbols.fly` text-stream topic. The
        // listener is LOADED here, never looked up: connectCall rides the eager
        // slice and runs right after a router('/meet') from the new-call modal,
        // the chat composer, the calendar or a deep link — before the full meet
        // context is folded, when `this.call('meetFlyListen')` would be a silent
        // no-op and this member would hear no page and no switch for the whole
        // call. Awaited before connect(): a latecomer's replay arrives right after
        // the join. (The call chat asks again on mount; both are no-ops once
        // listening.)
        try {
            const { meetFlyListen: meetFlyListen } = await (parcelRequire("f868q"));
            meetFlyListen.call(this, livekitRoom);
        } catch (err) {
            console.warn('[meet] fly listener not set:', err?.message || err);
        }
        // In-call text chat — payload is a JSON-encoded {text, senderName, sentAt}
        // object sent via LiveKit's data channel. Messages are appended to
        // root.meetChatMessages so MeetChatPanel can render them reactively.
        livekitRoom.on(RoomEvent.DataReceived, (payload, participant)=>{
            try {
                const text = new TextDecoder().decode(payload);
                const msg = JSON.parse(text);
                if (!msg || typeof msg.text !== 'string') return;
                const current = root.meetChatMessages || [];
                // An AGENT's answer (functions/meetFly.js) carries its name and the flag.
                const agent = msg.agent === true;
                const updates = {
                    meetChatMessages: [
                        ...current,
                        {
                            id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
                            text: msg.text,
                            senderName: msg.senderName || participant?.name || participant?.identity || this.call('polyglot', 'meet.chat.participant'),
                            sentAt: msg.sentAt || new Date().toISOString(),
                            isLocal: false,
                            ...agent ? {
                                isAgent: true
                            } : {}
                        }
                    ]
                };
                // Increment unread badge when the chat panel is closed.
                if (!root.showMeetChat) updates.meetChatUnread = (root.meetChatUnread || 0) + 1;
                root.update(updates);
            } catch (err) {
            // Non-chat data packet — ignore silently.
            }
        });
        $27089a7ea272a698$var$_mark('meetjoin:connect-start');
        await livekitRoom.connect(pair.url, pair.token);
        $27089a7ea272a698$var$_mark('meetjoin:connected');
        $27089a7ea272a698$var$_measure('meetjoin:connect', 'meetjoin:connect-start', 'meetjoin:connected');
        // Flip the UI to connected NOW — remote tiles, remote audio and the
        // call chrome must never wait behind the local getUserMedia/publish
        // leg (it used to: two serial enumerateDevices + two serial
        // getUserMedia calls ran BEFORE livekitConnected flipped, so every
        // already-subscribed remote track waited seconds to paint).
        // Tenant guard (MEET-LIVE-CALL-SURVIVES-SWITCH-1). The user can switch
        // workspaces anywhere in the join above — mint, import, permission prompt,
        // signal connect. A switch ran its own `disconnectCall` for whatever was
        // live AT THAT MOMENT, which cannot be this room: it finished connecting
        // afterwards. So the ONLY teardown this connection will ever get is here.
        // Adopt the module singleton and install the unload hook only AFTER the
        // write lands, so a dead-tenant join never becomes the live room.
        if (!_write({
            livekitConnected: true,
            meetCallInFlight: false,
            meetChatMessages: []
        })) {
            console.warn("[connectCall] workspace changed during the join \u2014 dropping the connection made for the previous tenant");
            _stopPreTracks();
            try {
                await livekitRoom.disconnect();
            } catch (err) {
                console.warn('[connectCall] late-join disconnect failed', err);
            }
            return null;
        }
        $27089a7ea272a698$var$_livekitRoom = livekitRoom;
        $27089a7ea272a698$var$_installUnloadHook();
        $27089a7ea272a698$var$_refreshParticipants(root, livekitRoom);
        // Post-connect attach sweep — covers any remote tracks that were
        // already subscribed before we wired the RoomEvent listeners. Wait
        // a frame so smbls has rendered the tile DOM the selector needs.
        requestAnimationFrame(()=>(0, $8tejg.attachAllParticipantTracks)(livekitRoom));
        // ── Local media ─────────────────────────────────────────────────────
        // Fast path: publish the tracks pre-acquired in parallel with the mint
        // (the Room's publishDefaults — simulcast layers per mode — apply to
        // publishTrack). Fallback (no devices / permission denied / partial
        // hardware): the per-device enable path with its full status taxonomy,
        // now with ONE shared enumerateDevices read and mic+cam enabled in
        // PARALLEL. Track per-device status into state so the call view can
        // surface a banner when the user blocked the browser permission —
        // without it a denied mic looks identical to a quiet mic and silently
        // breaks transcription.
        const _status = {
            mic: 'unknown',
            camera: 'unknown'
        };
        let localPublished = false;
        const preTracks = await preTracksPromise;
        if (Array.isArray(preTracks) && preTracks.length) {
            await Promise.all(preTracks.map(async (track)=>{
                const key = track.kind === 'audio' ? 'mic' : 'camera';
                try {
                    await livekitRoom.localParticipant.publishTrack(track);
                    _status[key] = 'granted';
                    if (!localPublished) {
                        localPublished = true;
                        $27089a7ea272a698$var$_mark('meetjoin:first-local-track');
                    }
                } catch (err) {
                    _status[key] = 'error';
                    try {
                        track.stop();
                    } catch (_) {
                    /* already stopped */ }
                    console.warn(`[connectCall] ${key} publish failed`, err);
                }
            }));
            // A kind absent from the acquired set: the user switched it off in
            // the join preview ('off'), or the device vanished between acquire
            // and publish — same bucket as not present ('unavailable').
            if (_status.mic === 'unknown') _status.mic = media.mic ? 'unavailable' : 'off';
            if (_status.camera === 'unknown') _status.camera = media.cam ? 'unavailable' : 'off';
        } else {
            // Skipping setEnabled when no devices are present avoids a
            // `NotFoundError` surfacing as a hard console.error on every connect
            // from headless browsers, dev VMs, or laptops with the lid closed.
            // Permission + genuinely-unexpected errors still log.
            const devices = await (async ()=>{
                try {
                    return await navigator.mediaDevices?.enumerateDevices?.() || [];
                } catch (err) {
                    console.warn('[connectCall] enumerateDevices failed', err);
                    return [];
                }
            })();
            const _hasDevice = (kind)=>devices.some((d)=>d.kind === kind);
            const _enable = async (label, kind, fn)=>{
                const key = label === 'mic' ? 'mic' : 'camera';
                if (!_hasDevice(kind)) {
                    _status[key] = 'unavailable';
                    return;
                }
                try {
                    await fn();
                    _status[key] = 'granted';
                    if (!localPublished) {
                        localPublished = true;
                        $27089a7ea272a698$var$_mark('meetjoin:first-local-track');
                    }
                } catch (err) {
                    const name = err?.name || '';
                    if (name === 'NotFoundError') {
                        _status[key] = 'unavailable';
                        return;
                    }
                    const reason = name === 'NotAllowedError' ? 'permission denied' : name || 'unknown';
                    _status[key] = name === 'NotAllowedError' ? 'denied' : 'error';
                    console.warn(`[connectCall] ${label} enable failed (${reason})`, err);
                }
            };
            // A kind the user switched off in the join preview is never enabled —
            // no getUserMedia, no permission prompt; its status reads 'off'.
            if (!media.mic) _status.mic = 'off';
            if (!media.cam) _status.camera = 'off';
            await Promise.all([
                media.mic ? _enable('mic', 'audioinput', ()=>livekitRoom.localParticipant.setMicrophoneEnabled(true)) : Promise.resolve(),
                media.cam ? _enable('camera', 'videoinput', ()=>livekitRoom.localParticipant.setCameraEnabled(true)) : Promise.resolve()
            ]);
        }
        // The published tracks now belong to the room (disconnect stops them) —
        // don't let a later failure path stop live media.
        preTracksPromise = null;
        if (localPublished) $27089a7ea272a698$var$_measure('meetjoin:to-first-local-track', 'meetjoin:start', 'meetjoin:first-local-track');
        root.update({
            meetMicStatus: _status.mic,
            meetCameraStatus: _status.camera
        });
        $27089a7ea272a698$var$_mark('meetjoin:local-media-done');
        $27089a7ea272a698$var$_measure('meetjoin:total', 'meetjoin:start', 'meetjoin:local-media-done');
        $27089a7ea272a698$var$_refreshParticipants(root, livekitRoom);
        // Local tile attach — the mic/cam tracks published just above need the
        // same post-render frame wait as the remote sweep.
        requestAnimationFrame(()=>(0, $8tejg.attachAllParticipantTracks)(livekitRoom));
        // Backfill existing utterances for this room so a late-joiner sees
        // the running transcript instead of an empty captions overlay.
        // realtime sub continues to deliver INSERTs after this.
        try {
            const sdk = (0, $1NxyO.getSDK)();
            const res = await sdk.execute('workspaceProject.meet.utterances', 'list', {
                roomId: roomId
            });
            const rows = res?.data || res || [];
            if (Array.isArray(rows) && rows.length) {
                const utts = rows.map((0, $lCXAE.rowToUtterance));
                const existing = root.utterances || [];
                const seen = new Set(existing.map((u)=>u.id));
                const merged = [
                    ...existing
                ];
                for (const u of utts)if (u && !seen.has(u.id)) {
                    seen.add(u.id);
                    merged.push(u);
                }
                root.update({
                    utterances: merged
                });
            }
        } catch (err) {
            console.warn('[connectCall] utterance backfill failed', err?.message || err);
        }
        return livekitRoom;
    } catch (err) {
        // MEET-ERROR-COPY-LIES-1: this already logs the full raw error object
        // (not just the message) — keep it that way.
        //
        // MEET-CALL-SERVER-UNREACHABLE-1: the state carried only message/name/
        // code, and code is a constant 1 for every livekit-client
        // ConnectionError — so the overlay downstream had nothing to classify
        // with and called every failure a "hiccup" with a Retry button. The
        // edge's own verdict (reasonName + the HTTP status it answered
        // /rtc/validate with, e.g. 429 when the call service is at its capacity
        // limit) was on the error object and was thrown away here.
        // `livekitErrorFields` carries it over — it still infers nothing.
        console.error('[connectCall] failed', err);
        _stopPreTracks();
        $27089a7ea272a698$var$_livekitRoom = null;
        let _errFields = (0, $lCXAE.livekitErrorFields)(err);
        // livekit-client drops the edge's HTTP status for every signal failure
        // that is not 404/401/403 — a capacity refusal arrives as a bare
        // ServerUnreachable with no status (measured 2026-08-21). Re-run the
        // SDK's own validate request, ONCE, to recover it. Only the statuses
        // that name a real refusal are adopted: a 404 from the probe only means
        // the room is not live yet, which is not why this join failed.
        if (_errFields.status === null && /signal connection|websocket/i.test(_errFields.message)) {
            const _probed = await (0, $8fqQC.probeLivekitStatus)(_tokenInfo?.livekitUrl, _tokenInfo?.livekitToken);
            if (_probed === 429 || _probed === 401 || _probed === 403) {
                console.warn('[connectCall] livekit edge answered', _probed, 'to the validate probe');
                _errFields = {
                    ..._errFields,
                    status: _probed
                };
            }
        }
        // Same guard, same reason (MEET-LIVE-CALL-SURVIVES-SWITCH-1): a failure
        // from A's room must not paint "Couldn't join: …" over B. The five error
        // keys stay ONE co-written record — the guard drops the whole record or
        // lands the whole record, never half of it. Nothing to disconnect on this
        // path: the connect never completed.
        if (!_write({
            meetCallError: _errFields.message,
            meetCallErrorName: _errFields.name,
            meetCallErrorCode: _errFields.code,
            meetCallErrorReason: _errFields.reasonName,
            meetCallErrorStatus: _errFields.status,
            meetCallInFlight: false,
            livekitConnected: false
        })) console.warn("[connectCall] workspace changed during the join \u2014 dropping the error of the previous tenant");
        return null;
    }
};
const $27089a7ea272a698$export$52ffc5df72ab54e0 = async function(text, opts) {
    const root = this.state.root;
    const room = $27089a7ea272a698$var$_livekitRoom;
    if (!room) {
        console.warn('[sendMeetChatMessage] not connected');
        return;
    }
    const trimmed = (text || '').trim();
    if (!trimmed) return;
    const me = (root.livekitParticipants || []).find((p)=>p.isLocal);
    const agent = !!(opts && opts.agent && opts.as);
    const senderName = agent ? String(opts.as) : me?.name || room.localParticipant?.name || room.localParticipant?.identity || 'Me';
    const sentAt = new Date().toISOString();
    const payload = JSON.stringify({
        text: trimmed,
        senderName: senderName,
        sentAt: sentAt,
        ...agent ? {
            agent: true
        } : {}
    });
    // Optimistic local append
    const current = root.meetChatMessages || [];
    root.update({
        meetChatMessages: [
            ...current,
            {
                id: `local-${Date.now()}-${Math.random().toString(36).slice(2)}`,
                text: trimmed,
                senderName: senderName,
                sentAt: sentAt,
                // An agent's answer is not the sender's own line.
                isLocal: !agent,
                ...agent ? {
                    isAgent: true
                } : {}
            }
        ]
    });
    try {
        const encoded = new TextEncoder().encode(payload);
        await room.localParticipant.publishData(encoded, {
            reliable: true
        });
    } catch (err) {
        console.error('[sendMeetChatMessage] publishData failed', err);
    }
};
const $27089a7ea272a698$export$6ce760730bb920ed = async function() {
    const root = this.state.root;
    // Tear down the CALL-slot subscription — the only place it ends. The
    // page slot (list/transcript views) is untouched; whatever page is on
    // screen keeps its own scope.
    try {
        (0, $9Rs24.unsubscribeMeetCallRealtime)();
    } catch (err) {
        console.warn('[disconnectCall] call-slot unsubscribe failed', err);
    }
    const room = $27089a7ea272a698$var$_livekitRoom;
    if (!room) {
        root.update({
            livekitParticipants: [],
            livekitConnected: false
        });
        return;
    }
    try {
        await room.disconnect();
    } catch (err) {
        console.warn('[disconnectCall] failed', err);
    }
    $27089a7ea272a698$var$_livekitRoom = null;
    root.update({
        livekitParticipants: [],
        livekitConnected: false
    });
};

});
parcelRegister("8fqQC", function(module, exports) {

$parcel$export(module.exports, "preacquireLocalTracks", () => $60148cd447774c0f$export$1a383306c2a9fd47);
$parcel$export(module.exports, "buildLivekitRoom", () => $60148cd447774c0f$export$f1b6c946a1d2d862);
$parcel$export(module.exports, "probeLivekitStatus", () => $60148cd447774c0f$export$dd394e80db4b668f);
// Wraps livekit-client's Room construction with the mode-aware simulcast
// config. Returns the Room instance (not yet connected — caller does
// room.connect(url, token) after wiring listeners). Browser-only — never
// imported from a server-side function.
//
// Mode-driven simulcast: dm publishes 1 layer, grid 2, stage 3. Publishing
// layers nobody subscribes to is pure upload + CPU waste, especially in DMs.

var $lCXAE = parcelRequire("lCXAE");
const $60148cd447774c0f$var$layersForMode = (VideoPresets, mode)=>{
    if (mode === 'dm') return [
        VideoPresets.h720
    ];
    if (mode === 'grid') return [
        VideoPresets.h360,
        VideoPresets.h720
    ];
    return [
        VideoPresets.h180,
        VideoPresets.h360,
        VideoPresets.h720
    ] // stage
    ;
};

const $60148cd447774c0f$export$1a383306c2a9fd47 = async ({ mic: mic = true, cam: cam = true } = {})=>{
    if (!mic && !cam) return [];
    const { createLocalTracks: createLocalTracks, VideoPresets: VideoPresets } = await (parcelRequire("8jlbE"));
    return createLocalTracks({
        audio: mic,
        video: cam ? {
            resolution: VideoPresets.h720.resolution
        } : false
    });
};

const $60148cd447774c0f$export$f1b6c946a1d2d862 = async (initialParticipantCount = 1)=>{
    // Lazy-load livekit-client (WebRTC, ~250KB gz) so it stays OUT of the eager
    // workspace entry — it loads only when a user actually joins a call.
    const { Room: Room, VideoPresets: VideoPresets } = await (parcelRequire("8jlbE"));
    const mode = (0, $lCXAE.getRoomMode)(initialParticipantCount);
    return new Room({
        adaptiveStream: true,
        dynacast: true,
        videoCaptureDefaults: {
            resolution: VideoPresets.h720.resolution
        },
        publishDefaults: {
            simulcast: mode !== 'dm',
            videoSimulcastLayers: $60148cd447774c0f$var$layersForMode(VideoPresets, mode)
        }
    });
};
const $60148cd447774c0f$export$dd394e80db4b668f = async (livekitUrl, token, _fetch)=>{
    const f = _fetch || (typeof window !== 'undefined' ? window.fetch.bind(window) : null);
    if (!f || !livekitUrl || !token) return null;
    let url;
    try {
        const u = new URL(livekitUrl);
        // The dial URL is a websocket URL; the validate endpoint is its HTTP twin.
        u.protocol = u.protocol === 'ws:' ? 'http:' : 'https:';
        u.pathname = `${u.pathname.replace(/\/+$/, '')}/rtc/validate`;
        u.search = '';
        u.searchParams.set('access_token', token);
        url = u.toString();
    } catch (_) {
        return null;
    }
    try {
        const res = await f(url);
        return typeof res?.status === 'number' ? res.status : null;
    } catch (_) {
        // The probe itself could not reach the host. That is genuine
        // unreachability and carries no status — say nothing rather than guess.
        return null;
    }
};

});
parcelRegister("lCXAE", function(module, exports) {

$parcel$export(module.exports, "SUGGESTION_BUCKETS", () => $fbeb5ef39b0fc8dd$export$747e21678b553e83);
$parcel$export(module.exports, "getRoomMode", () => $fbeb5ef39b0fc8dd$export$1937fd3a9924b806);
$parcel$export(module.exports, "rowToRoom", () => $fbeb5ef39b0fc8dd$export$c302b6afd9bf1b94);
$parcel$export(module.exports, "rowToParticipant", () => $fbeb5ef39b0fc8dd$export$f0ab70cd8cf51551);
$parcel$export(module.exports, "rowToUtterance", () => $fbeb5ef39b0fc8dd$export$5ce198ad0db432fd);
$parcel$export(module.exports, "dedupeUtterances", () => $fbeb5ef39b0fc8dd$export$dba4a0a3bc386bb5);
$parcel$export(module.exports, "speakerDisplayName", () => $fbeb5ef39b0fc8dd$export$bbe3900bed2e7ec0);
$parcel$export(module.exports, "routeTo", () => $fbeb5ef39b0fc8dd$export$7464a66e30a44643);
$parcel$export(module.exports, "fingerprintSuggestion", () => $fbeb5ef39b0fc8dd$export$d42092b424920128);
$parcel$export(module.exports, "pruneStaleApplied", () => $fbeb5ef39b0fc8dd$export$8aa9adbb8819c0e0);
$parcel$export(module.exports, "resolveFeaturedParticipant", () => $fbeb5ef39b0fc8dd$export$d86461aaa7a8a037);
$parcel$export(module.exports, "classifyCallError", () => $fbeb5ef39b0fc8dd$export$5d7995a23d0b242c);
$parcel$export(module.exports, "livekitErrorFields", () => $fbeb5ef39b0fc8dd$export$67e179d04c287b9c);
// meet — pure utilities. Row-shape transforms used by fetch blocks (allowed
// imports per the chat pattern), bucket constants, and the room-mode helper.
// Source of truth for the four AI suggestion buckets. Used by:
//   - meet-analyze Edge Function (the LLM prompt + responseSchema)
//   - meet_transcript_analyses.suggestions JSONB keys
//   - applySuggestion dispatcher
//   - SuggestionCard rendering
// Adding a fifth bucket is a one-line change here + the Edge Function schema.
// `label` / `viewLabel` carry polyglot KEYS — every render site resolves them
// through `el.call('polyglot', …)`.
const $fbeb5ef39b0fc8dd$export$747e21678b553e83 = {
    calendar_events: {
        label: 'meet.bucket.calendar',
        viewLabel: 'meet.bucket.calendarView',
        stateKey: 'selectedEventId',
        applyFn: 'saveEvent',
        route: '/calendar'
    },
    tickets: {
        label: 'meet.bucket.tickets',
        viewLabel: 'meet.bucket.ticketsView',
        stateKey: 'selectedTicketId',
        applyFn: 'saveTicket',
        route: '/tasks'
    },
    notes: {
        label: 'meet.bucket.notes',
        viewLabel: 'meet.bucket.notesView',
        stateKey: 'selectedNoteId',
        applyFn: 'createNote',
        route: '/notes'
    },
    knowledge_base: {
        label: 'meet.bucket.knowledgeBase',
        viewLabel: 'meet.bucket.knowledgeBaseView',
        stateKey: 'selectedDocumentId',
        applyFn: 'saveKbArticle',
        route: '/notes/knowledge-base'
    },
    chat_messages: {
        label: 'meet.bucket.chat',
        viewLabel: 'meet.bucket.chatView',
        applyFn: 'messageUser',
        route: '/chat'
    }
};
const $fbeb5ef39b0fc8dd$export$1937fd3a9924b806 = (participantCount)=>{
    if (participantCount < 3) return 'dm';
    if (participantCount < 13) return 'grid';
    return 'stage';
};
const $fbeb5ef39b0fc8dd$export$c302b6afd9bf1b94 = (r)=>({
        id: r.id,
        // A polyglot KEY when the row has no name — every render site resolves
        // `room.name` through polyglot, and translate() passes a real name through.
        name: r.name || 'meet.roomList.untitled',
        topic: r.topic || '',
        kind: r.kind || 'room',
        // visibility supersedes isPrivate (3-state: private/workspace/public).
        // Migration 0149 backfilled from is_private; rows from older clients
        // that didn't set visibility default to 'workspace' at the DB level.
        // isPrivate is kept synced for legacy readers — drop after consumers migrate.
        visibility: r.visibility || (r.is_private ? 'private' : 'workspace'),
        isPrivate: !!r.is_private,
        transcribeEnabled: !!r.transcribe_enabled,
        livekitInitialized: !!r.livekit_initialized,
        createdBy: r.created_by,
        createdAt: r.created_at,
        endedAt: r.ended_at,
        calendarEventId: r.calendar_event_id || null,
        chatChannelId: r.chat_channel_id || null,
        // Guest-join requirements (migration 0019). `guestRequireName` defaults
        // to true; the others default false/null. Read by NewRoomModal /
        // MeetRoomSettingsModal / /meet-guest page.
        guestRequireName: r.guest_require_name !== false,
        guestRequireEmail: !!r.guest_require_email,
        guestPassword: r.guest_password || null,
        guestAutoAdmit: !!r.guest_auto_admit
    });
const $fbeb5ef39b0fc8dd$export$f0ab70cd8cf51551 = (r)=>({
        id: r.id,
        roomId: r.room_id,
        userId: r.user_id,
        identity: r.identity,
        joinedAt: r.joined_at,
        leftAt: r.left_at
    });
const $fbeb5ef39b0fc8dd$export$5ce198ad0db432fd = (r)=>({
        id: r.id,
        roomId: r.room_id,
        userId: r.user_id,
        // The transcriber writes `speaker_name` as whatever LiveKit's
        // `participant.name` is, which in our case is the user's EMAIL (set by
        // meet-token when minting the token). Keep it stored as-is; components
        // resolve the display name via root.people at render time.
        speakerEmail: r.speaker_name || '',
        text: r.text || '',
        startedAt: r.started_at,
        endedAt: r.ended_at,
        confidence: r.confidence
    });
const $fbeb5ef39b0fc8dd$export$dba4a0a3bc386bb5 = (list)=>{
    const rows = (Array.isArray(list) ? list : []).filter((u)=>u && u.id);
    rows.sort((a, b)=>{
        const ta = Date.parse(a.startedAt) || 0;
        const tb = Date.parse(b.startedAt) || 0;
        return ta - tb || String(a.id).localeCompare(String(b.id));
    });
    const out = [];
    const seenIds = new Set();
    for (const u of rows){
        const id = String(u.id);
        if (seenIds.has(id)) continue;
        seenIds.add(id);
        const text = (u.text || '').trim();
        const t = Date.parse(u.startedAt) || 0;
        let crossWorkerDupe = false;
        if (text) // Only the tail can collide (sorted by time; 2s window) — check the
        // last few kept rows, break as soon as we're past the window.
        for(let i = out.length - 1; i >= 0 && i >= out.length - 6; i--){
            const p = out[i];
            const pt = Date.parse(p.startedAt) || 0;
            if (t - pt > 2000) break;
            if ((p.speakerEmail || '') === (u.speakerEmail || '') && (p.text || '').trim() === text) {
                crossWorkerDupe = true;
                break;
            }
        }
        if (!crossWorkerDupe) out.push(u);
    }
    return out;
};
const $fbeb5ef39b0fc8dd$export$bbe3900bed2e7ec0 = (root, speakerEmail, userId)=>{
    const people = root?.people || [];
    const byId = userId ? people.find((p)=>p && p.userId && String(p.userId) === String(userId)) : null;
    if (byId && byId.name) return byId.name;
    if (!speakerEmail) return 'meet.transcript.unknownSpeaker';
    const match = people.find((p)=>p.email === speakerEmail);
    return match?.name || speakerEmail;
};
const $fbeb5ef39b0fc8dd$export$7464a66e30a44643 = (el, path)=>{
    if (!el || !path) return;
    let root = el;
    while(root && !root.routes)root = root.parent;
    if (root) el.router(path, root);
};
const $fbeb5ef39b0fc8dd$export$d42092b424920128 = async (item)=>{
    const text = `${item.title || ''}|${item.description || item.content || item.body || ''}`;
    const buf = new TextEncoder().encode(text);
    const hash = await crypto.subtle.digest('SHA-256', buf);
    const bytes = new Uint8Array(hash).slice(0, 8);
    return Array.from(bytes, (b)=>b.toString(16).padStart(2, '0')).join('');
};
const $fbeb5ef39b0fc8dd$export$8aa9adbb8819c0e0 = async (appliedItems, suggestions)=>{
    if (!appliedItems?.length) return [];
    const liveFingerprints = new Set();
    for (const bucket of Object.keys($fbeb5ef39b0fc8dd$export$747e21678b553e83))for (const item of suggestions?.[bucket] || [])liveFingerprints.add(await $fbeb5ef39b0fc8dd$export$d42092b424920128(item));
    return appliedItems.filter((entry)=>liveFingerprints.has(entry.fingerprint));
};
const $fbeb5ef39b0fc8dd$export$d86461aaa7a8a037 = (s)=>{
    const participants = s.root?.livekitParticipants || [];
    if (participants.length <= 1) return null;
    const pinnedId = s.root?.meetPinnedTileId;
    if (pinnedId) {
        const pinned = participants.find((p)=>(p.id || p.identity) === pinnedId);
        if (pinned) return pinned;
    // Pinned participant left — fall through (stale pin is harmless;
    // the next pin overwrites it).
    }
    const screen = participants.find((p)=>p.isScreen);
    if (screen) return screen;
    if (s.root?.meetLayoutMode === 'speaker') {
        const speakers = s.root?.livekitSpeakers || {};
        const speaking = Object.keys(speakers).filter((id)=>speakers[id]).map((id)=>participants.find((pp)=>pp.identity === id && !pp.isScreen)).filter(Boolean);
        const speakerParticipant = speaking.find((p)=>!p.isLocal) || speaking[0];
        if (speakerParticipant) return speakerParticipant;
        const room = (s.root?.rooms || []).find((r)=>r.id === s.root?.activeRoomId);
        const host = participants.find((p)=>p.identity === room?.createdBy && !p.isScreen);
        if (host) return host;
    }
    return null;
};
const $fbeb5ef39b0fc8dd$export$5d7995a23d0b242c = (e = {})=>{
    const message = e.message || '';
    const status = typeof e.status === 'number' ? e.status : null;
    if (!message && status === null) return {
        kind: 'none',
        titleKey: '',
        hintKey: '',
        params: {},
        retryable: false
    };
    // The service itself refused the join with a status. These are FACTS from
    // the edge, so they may be named — and none of them clears on Retry.
    if (status === 429) return {
        kind: 'capacity',
        titleKey: 'meet.error.capacityTitle',
        hintKey: 'meet.error.capacityHint',
        params: {
            status: 429
        },
        retryable: false
    };
    if (status === 401 || status === 403) return {
        kind: 'denied',
        titleKey: 'meet.error.forbiddenTitle',
        hintKey: 'meet.error.forbiddenHint',
        params: {
            status: status
        },
        retryable: false
    };
    if (status === 404) return {
        kind: 'missing',
        titleKey: 'meet.error.missingTitle',
        hintKey: 'meet.error.missingHint',
        params: {
            status: status
        },
        retryable: false
    };
    if (/livekit config missing/i.test(message)) return {
        kind: 'unconfigured',
        titleKey: 'meet.error.configTitle',
        hintKey: 'meet.error.configHint',
        params: {},
        retryable: false
    };
    // No status: the connection never got an answer to classify. This is the
    // only branch that may honestly say "hiccup" and offer Retry.
    if (/signal connection|websocket/i.test(message)) return {
        kind: 'transient',
        titleKey: 'meet.error.networkTitle',
        hintKey: 'meet.error.networkHint',
        params: {},
        retryable: true
    };
    return {
        kind: 'unknown',
        titleKey: 'meet.error.unknownTitle',
        hintKey: '',
        params: {
            message: message
        },
        retryable: true
    };
};
const $fbeb5ef39b0fc8dd$export$67e179d04c287b9c = (err)=>({
        message: err?.message || 'connect failed',
        name: err?.name ?? null,
        // Kept for logs only. Every ConnectionError has code 1 — see
        // classifyCallError; never branch on it.
        code: err?.code ?? null,
        reasonName: err?.reasonName ?? null,
        status: typeof err?.status === 'number' ? err.status : typeof err?.context?.status === 'number' ? err.context.status : null
    });

});

parcelRegister("8jlbE", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("8dP7c"))) : import("8dP7c")).then(()=>parcelRequire('kup5s'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("8tejg", function(module, exports) {

$parcel$export(module.exports, "attachParticipantTracks", () => $62ac21ca38e83635$export$83566ff06237c7bd);
$parcel$export(module.exports, "attachParticipantAudio", () => $62ac21ca38e83635$export$5c37ac3a7fe6dd48);
$parcel$export(module.exports, "attachAllParticipantTracks", () => $62ac21ca38e83635$export$c864c12c3b595051);
$parcel$export(module.exports, "attachFeaturedVideo", () => $62ac21ca38e83635$export$f5c2b17877ac1ee1);
// Track-attach helpers shared between MeetParticipantTile (first-render
// best-effort attach) and connectCall (per-LiveKit-event attach). Lives
// under functions/ so a frontend component file doesn't have to reach
// across into another component's source — both consumers import from
// here.
//
// DOMQL v3.14's `onRender` doesn't reliably refire on root-state mutations
// (livekitParticipants), so the tile-side attach alone misses every
// remote track that subscribes after first mount AND every local track
// publish (setMicrophoneEnabled / setCameraEnabled run AFTER initial
// _refreshParticipants). The Room-event-driven path in connectCall.js
// covers those — both call `attachParticipantTracks(room, identity, isLocal)`,
// which finds the tile by `data-identity` and attaches if the track
// changed.
// Iterate publications across livekit-client versions (Map or object).
const $62ac21ca38e83635$var$_iterPubs = (obj)=>{
    if (!obj) return [];
    if (typeof obj.values === 'function') return [
        ...obj.values()
    ];
    return Object.values(obj);
};
// Resolve the video publication to attach. `mediaSource` selects between
// the participant's camera track and their screen-share track — the same
// participant can publish both at once (the connectCall.js participant
// list emits a separate virtual tile for the screen track). Falls back
// to whichever pub is present when the preferred source isn't published.
const $62ac21ca38e83635$var$_pickVideoPub = (participant, mediaSource)=>{
    const pubs = $62ac21ca38e83635$var$_iterPubs(participant.videoTrackPublications);
    const wantsScreen = mediaSource === 'screen_share';
    const isScreen = (p)=>p.source === 'screen_share' || p.source === 'screenShare';
    const isCamera = (p)=>p.source === 'camera' || !isScreen(p) && p.kind === 'video';
    // First pass: exact match on requested source.
    for (const pub of pubs){
        if (!pub.track) continue;
        if (wantsScreen && isScreen(pub)) return pub;
        if (!wantsScreen && isCamera(pub)) return pub;
    }
    // Fallback: ANY video pub — better to attach something than nothing.
    for (const pub of pubs)if (pub.track && pub.kind === 'video') return pub;
    return null;
};
const $62ac21ca38e83635$var$_attachVideoTrack = (videoEl, room, identity, isLocal, mediaSource)=>{
    if (!videoEl || !room) return;
    const participant = isLocal ? room.localParticipant : typeof room.remoteParticipants?.get === 'function' ? room.remoteParticipants.get(identity) : room.remoteParticipants?.[identity];
    if (!participant) return;
    const targetPub = $62ac21ca38e83635$var$_pickVideoPub(participant, mediaSource);
    const currentSid = videoEl._lkTrackSid || null;
    const targetSid = targetPub?.trackSid || null;
    if (currentSid === targetSid) return;
    if (videoEl._lkTrack) try {
        videoEl._lkTrack.detach(videoEl);
    } catch (err) {
        console.warn('[meet/attachTracks] video detach failed', err);
    }
    if (targetPub?.track) try {
        targetPub.track.attach(videoEl);
        videoEl._lkTrack = targetPub.track;
        videoEl._lkTrackSid = targetSid;
    } catch (err) {
        console.warn('[meet] video attach failed', err);
    }
    else {
        videoEl._lkTrack = null;
        videoEl._lkTrackSid = null;
    }
};
const $62ac21ca38e83635$var$_attachAudioTrack = (audioEl, room, identity, isLocal)=>{
    if (!audioEl || !room || isLocal) return;
    const participant = typeof room.remoteParticipants?.get === 'function' ? room.remoteParticipants.get(identity) : room.remoteParticipants?.[identity];
    if (!participant) return;
    let targetPub = null;
    for (const pub of $62ac21ca38e83635$var$_iterPubs(participant.audioTrackPublications))if (pub.track) {
        targetPub = pub;
        break;
    }
    const currentSid = audioEl._lkTrackSid || null;
    const targetSid = targetPub?.trackSid || null;
    if (currentSid === targetSid) return;
    if (audioEl._lkTrack) try {
        audioEl._lkTrack.detach(audioEl);
    } catch (err) {
        console.warn('[meet/attachTracks] audio detach failed', err);
    }
    if (targetPub?.track) try {
        targetPub.track.attach(audioEl);
        audioEl._lkTrack = targetPub.track;
        audioEl._lkTrackSid = targetSid;
    } catch (err) {
        console.warn('[meet] audio attach failed', err);
    }
    else {
        audioEl._lkTrack = null;
        audioEl._lkTrackSid = null;
    }
};
const $62ac21ca38e83635$export$83566ff06237c7bd = (room, identity, isLocal, mediaSource = 'camera')=>{
    if (!room || !identity) return;
    const tileId = mediaSource === 'screen_share' ? `${identity}:screen` : identity;
    const safe = String(tileId).replace(/"/g, '\\"');
    const tile = document.querySelector(`[data-tile-id="${safe}"]`);
    const videoEl = tile ? tile.querySelector('video') : null;
    const tileAudio = tile ? tile.querySelector('audio') : null;
    if (videoEl) $62ac21ca38e83635$var$_attachVideoTrack(videoEl, room, identity, isLocal, mediaSource);
    // Audio plays from ONE place, for the camera only (never the screen-share
    // tile — the same mic twice) and never the local one. The shell's
    // call-audio host (components/CallAudio.js) outlives /meet, so a live call
    // keeps its sound on every route — the tiles unmount with /meet, and a call
    // went silent behind the dock. A tile's own <audio> plays only where no
    // host is mounted, and never beside it.
    if (mediaSource === 'screen_share' || isLocal) return;
    const who = String(identity).replace(/"/g, '\\"');
    const hostAudio = document.querySelector(`[data-meet-audio-for="${who}"]`);
    if (hostAudio) {
        if (tileAudio && tileAudio._lkTrack) {
            try {
                tileAudio._lkTrack.detach(tileAudio);
            } catch (err) {
                console.warn('[meet/attachTracks] tile audio detach failed', err);
            }
            tileAudio._lkTrack = null;
            tileAudio._lkTrackSid = null;
        }
        $62ac21ca38e83635$var$_attachAudioTrack(hostAudio, room, identity, false);
    } else if (tileAudio) $62ac21ca38e83635$var$_attachAudioTrack(tileAudio, room, identity, false);
};
const $62ac21ca38e83635$export$5c37ac3a7fe6dd48 = (audioEl, room, identity)=>{
    if (!audioEl || !room || !identity) return;
    $62ac21ca38e83635$var$_attachAudioTrack(audioEl, room, identity, false);
};
const $62ac21ca38e83635$export$c864c12c3b595051 = (room)=>{
    if (!room) return;
    const local = room.localParticipant;
    if (local) {
        $62ac21ca38e83635$export$83566ff06237c7bd(room, local.identity, true, 'camera');
        // Local screen-share — if the local user is sharing, attach it to
        // its dedicated tile too. The local tile is muted by the tile
        // component's `muted: 'muted'` attr to avoid echo, so this is just
        // a visible mirror of what's being broadcast.
        $62ac21ca38e83635$export$83566ff06237c7bd(room, local.identity, true, 'screen_share');
    }
    const remoteValues = typeof room.remoteParticipants?.values === 'function' ? room.remoteParticipants.values() : Object.values(room.remoteParticipants || {});
    for (const p of remoteValues){
        if (typeof p.identity === 'string' && p.identity.startsWith('agent-')) continue;
        $62ac21ca38e83635$export$83566ff06237c7bd(room, p.identity, false, 'camera');
        $62ac21ca38e83635$export$83566ff06237c7bd(room, p.identity, false, 'screen_share');
    }
};
// ── Featured/stage video attach ─────────────────────────────────────
// Moved from components/FeaturedTile.js (2026-06-12): the stage video
// only attached in the component's onRender/onUpdate, which v3.14 does
// NOT fire reliably on root-state changes — when someone started a
// screen-share the stage un-hid but stayed BLACK ('why I dont see when
// someone is sharing screen'). Now ALSO called event-side from
// applyTileGridLayout on every participant/speaker event.
const $62ac21ca38e83635$var$_iterVideoPubs = (participant)=>{
    const pubs = participant.videoTrackPublications;
    if (!pubs) return [];
    if (typeof pubs.values === 'function') return [
        ...pubs.values()
    ];
    return Object.values(pubs);
};
const $62ac21ca38e83635$export$f5c2b17877ac1ee1 = (videoNode, featured, livekitRoom)=>{
    if (!videoNode || !featured || !livekitRoom) return;
    const isLocal = featured.isLocal;
    const identity = featured.identity;
    const mediaSource = featured.mediaSource || (featured.isScreen ? 'screen_share' : 'camera');
    const participant = isLocal ? livekitRoom.localParticipant : typeof livekitRoom.remoteParticipants?.get === 'function' ? livekitRoom.remoteParticipants.get(identity) : livekitRoom.remoteParticipants?.[identity];
    if (!participant) return;
    // Resolve the correct publication.
    const wantsScreen = mediaSource === 'screen_share';
    const isScreenPub = (p)=>p.source === 'screen_share' || p.source === 'screenShare';
    const isCameraPub = (p)=>p.source === 'camera' || !isScreenPub(p) && p.kind === 'video';
    let targetPub = null;
    const pubs = $62ac21ca38e83635$var$_iterVideoPubs(participant);
    for (const pub of pubs){
        if (!pub.track) continue;
        if (wantsScreen && isScreenPub(pub)) {
            targetPub = pub;
            break;
        }
        if (!wantsScreen && isCameraPub(pub)) {
            targetPub = pub;
            break;
        }
    }
    if (!targetPub) {
        for (const pub of pubs)if (pub.track && pub.kind === 'video') {
            targetPub = pub;
            break;
        }
    }
    const currentSid = videoNode._lkFeaturedSid || null;
    const targetSid = targetPub?.trackSid || null;
    if (currentSid === targetSid) return;
    if (videoNode._lkFeaturedTrack) try {
        videoNode._lkFeaturedTrack.detach(videoNode);
    } catch (err) {
        console.warn('[meet/FeaturedTile] video detach failed', err);
    }
    if (targetPub?.track) try {
        targetPub.track.attach(videoNode);
        videoNode._lkFeaturedTrack = targetPub.track;
        videoNode._lkFeaturedSid = targetSid;
    } catch (err) {
        console.warn('[meet/attachTracks] featured video attach failed', err);
    }
    else {
        videoNode._lkFeaturedTrack = null;
        videoNode._lkFeaturedSid = null;
    }
};

});

parcelRegister("5HcyH", function(module, exports) {

$parcel$export(module.exports, "resolveLivekitPair", () => $425ab5c58eb159ef$export$6203e0f1f76ed3ef);
$parcel$export(module.exports, "readPrewarmHost", () => $425ab5c58eb159ef$export$4ba1c716d1ed001f);
$parcel$export(module.exports, "rememberPrewarmHost", () => $425ab5c58eb159ef$export$5b6ab1203279a84);
// Pure helpers around the LiveKit host — the two cheap hardenings that came
// out of the production call investigation (MEET-FEATURES-BUILD-1 item 4;
// origin: the MEET-LIVEKIT-PROJECT-MISMATCH-1 re-diagnosis, tickets/archive/
// 2026-08/opus.md). No DOM, no SDK: callable under node, wired at the call
// sites (connectCall.js / pages/guest.js) the same way pages/index.js wires
// `_resolveMeetSeed`.
//
// (a) resolveLivekitPair — a LiveKit token is only valid for the host it was
//     signed with, so `{ token, url }` must come from ONE response shape,
//     atomically. The server speaks two: the canonical guest shape
//     `{ token, url, identity }` and the member mint `{ livekitToken,
//     livekitUrl }`. The old guest read (`tokenInfo.url || tokenInfo.
//     livekitUrl` next to `tokenInfo.token || tokenInfo.livekitToken`) could
//     cross-pair the halves, or hand `connect()` an undefined url and let the
//     SDK surface it as a generic websocket failure. Now: pair or refuse,
//     with a reason that names the problem.
//
// (b) the prewarm host cache — connectCall prewarms DNS/TLS against the
//     last-known host while the mint round-trips. The cache was one unkeyed
//     localStorage entry shared by every API environment reachable from the
//     same origin, written unconditionally and never compared. Now keyed by
//     API base, compared on every mint (the move is reported so the call
//     site can log it — the exact diagnostic the investigation lacked), and
//     cleared when a mint does not confirm a host.
const $425ab5c58eb159ef$export$9baeda9cc30f1a7c = 'meet:livekitUrl';
const $425ab5c58eb159ef$var$_isHostUrl = (u)=>typeof u === 'string' && /^(wss?|https?):\/\/[^\s/]+/i.test(u);
const $425ab5c58eb159ef$export$6203e0f1f76ed3ef = (tokenInfo)=>{
    if (!tokenInfo || typeof tokenInfo !== 'object') throw new Error('livekit token/url pair missing: empty token response');
    const canonical = tokenInfo.token && tokenInfo.url ? {
        token: tokenInfo.token,
        url: tokenInfo.url
    } : null;
    const legacy = tokenInfo.livekitToken && tokenInfo.livekitUrl ? {
        token: tokenInfo.livekitToken,
        url: tokenInfo.livekitUrl
    } : null;
    if (!canonical && !legacy) {
        const seen = [
            'token',
            'url',
            'livekitToken',
            'livekitUrl'
        ].filter((k)=>tokenInfo[k]).join(',') || 'none';
        throw new Error(`livekit token/url pair missing: incomplete token response (fields: ${seen})`);
    }
    if (canonical && legacy && canonical.url !== legacy.url) throw new Error("livekit token response shapes disagree on the host url \u2014 refusing to dial");
    const pair = canonical || legacy;
    if (!$425ab5c58eb159ef$var$_isHostUrl(pair.url)) throw new Error(`livekit url is not a ws(s)/http(s) host: ${String(pair.url).slice(0, 40)}`);
    return {
        token: pair.token,
        url: pair.url,
        shape: canonical ? 'canonical' : 'legacy'
    };
};
const $425ab5c58eb159ef$var$_normBase = (apiBase)=>String(apiBase || '').trim().replace(/\/+$/, '') || 'default';
const $425ab5c58eb159ef$export$dc02352a59d91d9e = (apiBase)=>`${$425ab5c58eb159ef$export$9baeda9cc30f1a7c}:${$425ab5c58eb159ef$var$_normBase(apiBase)}`;
const $425ab5c58eb159ef$export$4ba1c716d1ed001f = (storage, apiBase)=>{
    try {
        const v = storage?.getItem?.($425ab5c58eb159ef$export$dc02352a59d91d9e(apiBase));
        return $425ab5c58eb159ef$var$_isHostUrl(v) ? v : null;
    } catch (_) {
        return null;
    }
};
const $425ab5c58eb159ef$export$5b6ab1203279a84 = (storage, apiBase, freshUrl)=>{
    const previous = $425ab5c58eb159ef$export$4ba1c716d1ed001f(storage, apiBase);
    const url = $425ab5c58eb159ef$var$_isHostUrl(freshUrl) ? freshUrl : null;
    const key = $425ab5c58eb159ef$export$dc02352a59d91d9e(apiBase);
    try {
        // The unkeyed legacy entry predates environment scoping — drop it so a
        // host cached under another API base can never be read back as ours.
        storage?.removeItem?.($425ab5c58eb159ef$export$9baeda9cc30f1a7c);
        if (url) storage?.setItem?.(key, url);
        else storage?.removeItem?.(key);
    } catch (_) {
    /* prewarm cache only — never block a join on storage */ }
    return {
        changed: previous !== null && previous !== url,
        previous: previous,
        url: url
    };
};

});

parcelRegister("gRr8d", function(module, exports) {

$parcel$export(module.exports, "applyTileGridLayout", () => $c466a4500b3c3d89$export$6c24ef64ade111b0);
// applyTileGridLayout — IMPERATIVE owner of the in-call TileGrid layout.
//
// Why imperative: v3.14 gives the grid no reactive avenue at all —
//   1. reactive gridTemplateColumns/Rows factories FREEZE at mount value
//      (the original cut-off bug: mounted at 1 participant, later joiners
//      stacked into overflow rows under the ControlBar);
//   2. design tokens don't resolve inside composite grid strings, so a
//      static `repeat(auto-fit, minmax(F1, 1fr))` emitted invalid CSS and
//      collapsed to ONE column (the 9px-sliver regression, 2026-06-12);
//   3. conditional `class:` objects only re-evaluate when the element
//      itself re-renders — TileGrid persists for the whole call, so a
//      mode class toggled off root state never updates either.
//
// So the same connectCall events that mirror LiveKit state into root
// (participants sync, active-speaker refresh) call this to write the
// templates straight onto the stable node — the established meet pattern
// (connectCall already drives per-tile <video> attachment by data-tile-id
// for the same v3.14 reasons). rAF defers the write past the smbls render
// pass so freshly added tiles exist before the featured-duplicate pass.
//
// Modes (mirrors the old factory breakpoints):
//   featured (screen-share / speaker / host on stage) → filmstrip: one
//     horizontal row, scrolls sideways when crowded; the featured
//     participant's own strip tile is display:none'd — it was rendering
//     as a duplicate "spare box" above the strip (2026-06-12 per Nika).
//   no featured → N×M grid sharing the height (2/3/4 columns by count).

var $lCXAE = parcelRequire("lCXAE");

var $8tejg = parcelRequire("8tejg");

var $9vw2i = parcelRequire("9vw2i");
const $c466a4500b3c3d89$export$6c24ef64ade111b0 = (root, livekitRoom = null)=>{
    if (typeof document === 'undefined' || typeof requestAnimationFrame === 'undefined') return;
    requestAnimationFrame(()=>{
        const node = document.querySelector('[data-key="TileGrid"]');
        if (!node) return;
        const list = root?.livekitParticipants || [];
        // #2224 — the grid's column/row math tracks what's actually RENDERED
        // (the current page under a tiles-per-screen cap), not the raw
        // participant count — otherwise a capped call would keep reserving grid
        // cells for tiles that paginated away, leaving empty gaps.
        const visible = (0, $9vw2i.paginateTiles)(list, root?._meetTilePage, root?._meetTilesPerScreen);
        const n = visible.length || 1;
        const featured = (0, $lCXAE.resolveFeaturedParticipant)({
            root: root
        });
        const st = node.style;
        if (featured) {
            // FIXED tile size in the strip (2026-06-12 per Nika "maybe we need
            // to make grid tiles fixed") — stretchy 1fr tiles resized on every
            // join/leave; fixed 16:9 boxes keep the strip visually stable and
            // simply scroll sideways as people join.
            st.gridAutoFlow = 'column';
            st.gridAutoColumns = '224px';
            st.gridTemplateColumns = 'none';
            // Row fills the 45%-basis strip (fixed 126px left dead space below
            // the tiles once the strip went flex-basis); column width stays
            // FIXED so the strip is stable across joins/leaves.
            st.gridTemplateRows = 'minmax(0, 1fr)';
            st.justifyContent = 'safe center';
            st.overflowX = 'auto';
            st.overflowY = 'hidden';
        } else {
            const cols = n <= 1 ? 1 : n <= 4 ? 2 : n <= 9 ? 3 : 4;
            const rows = Math.max(1, Math.ceil(n / cols));
            st.gridAutoFlow = '';
            st.gridAutoColumns = '';
            st.gridTemplateColumns = `repeat(${cols}, minmax(0, 1fr))`;
            st.gridTemplateRows = `repeat(${rows}, minmax(0, 1fr))`;
            st.justifyContent = '';
            st.overflowX = '';
            st.overflowY = '';
        }
        // Hide the featured participant's duplicate strip tile (CSS-only —
        // the element stays mounted so its tracks aren't torn down; audio
        // keeps playing through the featured tile's attachment).
        const featuredId = featured ? featured.id || featured.identity : null;
        for (const child of node.children){
            if (!child.getAttribute) continue;
            const tid = child.getAttribute('data-tile-id');
            if (!tid) continue;
            child.style.display = featuredId && tid === featuredId ? 'none' : '';
        }
        // Attach the stage <video> here too — the FeaturedTile's own
        // onRender/onUpdate don't fire reliably on root-state changes
        // (v3.14), so a screen-share used to un-hide a BLACK stage.
        // attachFeaturedVideo is sid-idempotent, safe on every event.
        if (featured && livekitRoom) {
            const stageVideo = document.querySelector('video[data-featured-tile]');
            if (stageVideo) (0, $8tejg.attachFeaturedVideo)(stageVideo, featured, livekitRoom);
        }
    });
};

});
parcelRegister("9vw2i", function(module, exports) {

$parcel$export(module.exports, "TILES_PER_SCREEN_OPTIONS", () => $6ebfdc030f770c5b$export$ca7fb89d76413720);
$parcel$export(module.exports, "tilePageCount", () => $6ebfdc030f770c5b$export$427a6b2a39efecf7);
$parcel$export(module.exports, "clampTilePage", () => $6ebfdc030f770c5b$export$25727e3c34ed2251);
$parcel$export(module.exports, "paginateTiles", () => $6ebfdc030f770c5b$export$750769e6d9e54165);
$parcel$export(module.exports, "setTilesPerScreen", () => $6ebfdc030f770c5b$export$a0a47d4b2bb74f8);
$parcel$export(module.exports, "nextTilePage", () => $6ebfdc030f770c5b$export$26a87dcb6c997f8b);
$parcel$export(module.exports, "prevTilePage", () => $6ebfdc030f770c5b$export$99a30bbab9d7c59e);
// tilePaging.js — #2224 "User tiles should resize to accommodate X number of
// tiles on screen".
//
// The grid ALREADY dynamically resizes by participant count (functions/
// tileGridLayout.js applyTileGridLayout computes cols/rows from `n`) — what
// was missing per the GH acceptance criteria ("the window session should
// have a number of tiles settable to be viewed per screen") is a
// user-settable CAP + pagination once a call exceeds it. `null` (the
// default) means "no cap" — the existing unbounded auto-fit behavior is
// unchanged for every call under the cap, and for every call at all until a
// user opts in.
//
// State:
//   root._meetTilesPerScreen — number|null. null = unlimited (default).
//   root._meetTilePage       — 0-based current page index.
//
// Pure helpers are exported (and unit-tested) separately from the `this`-bound
// el.call handlers so the paging MATH has no framework dependency.
const $6ebfdc030f770c5b$export$ca7fb89d76413720 = [
    {
        value: null,
        label: 'meet.tiles.auto'
    },
    {
        value: 4,
        label: '4'
    },
    {
        value: 9,
        label: '9'
    },
    {
        value: 16,
        label: '16'
    }
];
const $6ebfdc030f770c5b$export$427a6b2a39efecf7 = (total, cap)=>{
    const t = Math.max(0, total | 0);
    if (!cap || cap <= 0 || cap >= t) return 1;
    return Math.max(1, Math.ceil(t / cap));
};
const $6ebfdc030f770c5b$export$25727e3c34ed2251 = (page, total, cap)=>{
    const count = $6ebfdc030f770c5b$export$427a6b2a39efecf7(total, cap);
    const p = Number.isFinite(page) ? Math.trunc(page) : 0;
    return Math.min(Math.max(0, p), count - 1);
};
const $6ebfdc030f770c5b$export$750769e6d9e54165 = (list, page, cap)=>{
    const arr = Array.isArray(list) ? list : [];
    if (!cap || cap <= 0) return arr;
    const p = $6ebfdc030f770c5b$export$25727e3c34ed2251(page, arr.length, cap);
    return arr.slice(p * cap, p * cap + cap);
};
const $6ebfdc030f770c5b$export$a0a47d4b2bb74f8 = function(cap) {
    const root = this.state.root;
    const value = cap == null ? null : Number(cap) || null;
    root.update({
        _meetTilesPerScreen: value,
        _meetTilePage: 0
    });
    this.call('applyTileGridLayout', root);
};
const $6ebfdc030f770c5b$export$26a87dcb6c997f8b = function() {
    const root = this.state.root;
    const total = (root.livekitParticipants || []).length;
    const cap = root._meetTilesPerScreen;
    const next = $6ebfdc030f770c5b$export$25727e3c34ed2251((root._meetTilePage || 0) + 1, total, cap);
    root.update({
        _meetTilePage: next
    });
    this.call('applyTileGridLayout', root);
};
const $6ebfdc030f770c5b$export$99a30bbab9d7c59e = function() {
    const root = this.state.root;
    const total = (root.livekitParticipants || []).length;
    const cap = root._meetTilesPerScreen;
    const prev = $6ebfdc030f770c5b$export$25727e3c34ed2251((root._meetTilePage || 0) - 1, total, cap);
    root.update({
        _meetTilePage: prev
    });
    this.call('applyTileGridLayout', root);
};

});


parcelRegister("8iVo8", function(module, exports) {

$parcel$export(module.exports, "meetSameWorkspaceWriter", () => $60bc8548f8b1afbd$export$65b4cbabecc1f25e);
// MEET-LIVE-CALL-SURVIVES-SWITCH-1 — the meet package's copy of the canonical
// "drop a reply that outlived its tenant" writer.
//
// WHY MEET NEEDED ONE. Registering a key as workspace-scoped (the shell's
// state-app.js) wipes it ON the switch. It cannot stop a request ISSUED in
// workspace A from writing its reply into workspace B afterwards. `connectCall`
// is the longest such request in the app: a token mint, a livekit-client
// import, a getUserMedia prompt and a signal connect, any of which the user can
// switch workspaces through — and its completion write says "you are in a
// call", which is a claim about a tenant, not a banner.
//
// ⛔ THE GUARD IS ONLY SAFE BESIDE DISCONNECT-ON-SWITCH. Dropping the
// completion write ALONE would hide an ACTIVE LiveKit connection in B — a
// worse wedge than a stale banner, which is exactly why this guard was
// withheld until the switch path tore the call down first (see the shell's
// onWorkspaceChange). The caller must therefore treat a dropped write as
// "this connection was born into a tenant that no longer exists" and
// disconnect it, never as a silent no-op.
//
// ⛔ CAPTURE BEFORE THE AWAIT. `sameWorkspaceWriter(root)` must be called on
// the SAME tick as the request, before the first `await` — it snapshots the
// workspace id at call time. Calling it inside the `.then()` snapshots the NEW
// workspace and the guard can never fire.
//
// ⛔ WHY THIS FILE EXISTS AGAIN. The shell owns the canonical copy at
// workspace/functions/sameWorkspaceWriter.js; `tickets` and `chat` keep their
// own. `meet` is a SUB-APP and must not import the shell either, so it keeps
// this one. The CODE below is held identical across the copies (the drift pins
// strip comments and compare code) — documenting each copy in its own words is
// not a drift. Consumers inside this package import THIS module — never
// re-inline it.
// Both id shapes are live on root: `workspace.id` from the SDK's workspace
// payload and `workspace._id` from the raw Mongo document. Stringified so a
// numeric id and its string form never read as two different tenants.
const $60bc8548f8b1afbd$export$2f030010e0ef3300 = (root)=>String(root?.workspace?.id || root?.workspace?._id || '');
const $60bc8548f8b1afbd$export$65b4cbabecc1f25e = (root)=>{
    const issuedFor = $60bc8548f8b1afbd$export$2f030010e0ef3300(root);
    return (patch)=>{
        if ($60bc8548f8b1afbd$export$2f030010e0ef3300(root) !== issuedFor) return false;
        root.update(patch);
        return true;
    };
};

});

parcelRegister("9Rs24", function(module, exports) {

$parcel$export(module.exports, "_meetActiveWsId", () => $01da4da903572def$export$866865cbf5f93bf3);
$parcel$export(module.exports, "_makeDispatch", () => $01da4da903572def$export$76690dd6babd09fb);
$parcel$export(module.exports, "subscribeMeetRealtime", () => $01da4da903572def$export$2ffe1d360773a979);
$parcel$export(module.exports, "subscribeMeetCallRealtime", () => $01da4da903572def$export$b8413ed189a24ba7);
$parcel$export(module.exports, "unsubscribeMeetCallRealtime", () => $01da4da903572def$export$dbece9bc1d26d965);
// Scoped realtime subscription for meet. Different pages need different
// table+filter combinations; passing { tables, roomId } keeps each
// subscription tight so the home page doesn't receive every utterance from
// every active call across the org.
//
// Module-level subscription handle (NOT root state) — DOMQL may create a
// fresh state object on update, so direct property assignments
// (root._meetRealtimeChannel) get lost on the next update and every
// callback fires against the dead state object. Module-level vars stay
// stable across state updates.
//
// All event callbacks re-read `this.state.root` freshly via the captured
// `self` element reference so updates always land on the live root state,
// not a stale snapshot.
//
// Named distinctly from chat's subscribeRealtime to avoid function-registry
// collision. Declared as a regular `function` (not arrow) so this-binding
// from el.call(...) works.
//
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.meet`
// dispatches through the SDK's transport-agnostic provider with a
// per-page `tables` selector. The provider tags each callback by table
// kind ('room'|'participant'|'waiting'|'transcript'|'analysis') so the
// dispatch table below routes events without re-reading the table name.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $jhJrJ = parcelRequire("jhJrJ");

var $gGHbJ = parcelRequire("gGHbJ");

var $lCXAE = parcelRequire("lCXAE");
const $01da4da903572def$export$866865cbf5f93bf3 = (self)=>{
    const rootWs = self?.state?.root?.workspace?.id;
    if (rootWs) return rootWs;
    try {
        return (0, $jhJrJ.getActiveWorkspacePointer)() || null;
    } catch (_) {
        return null;
    }
};
// TWO independent subscription slots (2026-07-29 per Nika "really fix
// transcripts not showing up in realtime — nor on video and also in
// sidebar"):
//
//   PAGE slot — whatever meet surface is on screen (list view broad scope,
//   transcript page narrowed to its room). Pages replace each other's
//   scope freely, as before.
//   CALL slot — pinned to the CONNECTED room for the whole life of the
//   call, owned by connectCall/disconnectCall, NOT by any page.
//
// They used to be ONE module-level slot, so every page re-scope REPLACED
// the in-call subscription: visiting the room list mid-call (broad scope,
// no transcripts) or opening another room's transcript silently killed the
// live captions + transcript panel for the active call — and the
// persistent-call dock (navigation never disconnects, 2026-07-29) made
// mid-call navigation the NORMAL case, so realtime "randomly" died.
let $01da4da903572def$var$_pageUnsub = null;
let $01da4da903572def$var$_pageScope = null;
let $01da4da903572def$var$_callUnsub = null;
let $01da4da903572def$var$_callScope = null;
const $01da4da903572def$var$_rowToWaitingGuest = (r)=>({
        id: r.id,
        roomId: r.room_id,
        guestName: r.guest_name || 'meet.waiting.guest',
        guestEmail: r.guest_email || null,
        requestedAt: r.requested_at,
        admittedAt: r.admitted_at,
        rejectedAt: r.rejected_at
    });
// Apply INSERT/UPDATE/DELETE for an id+roomId-keyed map state slot
// (liveParticipants, waitingRoom). Skips RLS-masked payloads (missing
// id or roomId) — the next page-level fetch reconciles.
const $01da4da903572def$var$_applyKeyedByRoom = (root, stateKey, payload, item)=>{
    if (!item.id || !item.roomId) return;
    const map = {
        ...root[stateKey] || {}
    };
    const list = map[item.roomId] || [];
    if (payload.eventType === 'INSERT') {
        if (!list.some((x)=>x.id === item.id)) map[item.roomId] = [
            ...list,
            item
        ];
    } else if (payload.eventType === 'UPDATE') map[item.roomId] = list.map((x)=>x.id === item.id ? item : x);
    else if (payload.eventType === 'DELETE') map[item.roomId] = list.filter((x)=>x.id !== item.id);
    root.update({
        [stateKey]: map
    });
};
// Reconcile room/transcript/analysis state from a `meet.snapshot` (fires on
// EVERY connect AND every reconnect — MeetStreamController.stream writes it
// unconditionally before wiring the live subscribe, so a fresh EventSource
// always gets a fresh one; verified server-side, not assumed). Before the
// SDK forwarded this frame (tickets/opus.md "`meet` realtime discards the
// server's meet.snapshot, so a reconnect recovers nothing"), a reconnect
// recovered NOTHING: any room/utterance/analysis write that landed
// server-side during the gap — with no matching `meet.room.*` /
// `meet.transcript.insert` / `meet.analysis.*` event ever delivered for it,
// by definition of "the connection was down" — was silently lost. This is
// the exact receiver-side reconcile branch `chat`'s `_handleSnapshot`
// (workspace/packages/chat/functions/subscribeRealtime.js) already has for
// `chat.snapshot`; this mirrors it.
//
// Server shape (MeetStreamController._buildSnapshot) — a key's PRESENCE is
// itself the signal, not its truthiness: a key is included only for the
// kinds THIS subscription requested (see server's `want(kind)`), so an
// ABSENT key means "not requested this scope" and must be left untouched,
// while a PRESENT-but-empty array means "requested, and the answer is none"
// (real state — see the `analysis` branch below):
//   room view  (roomId scope):      { rooms?: [row]|[], transcripts?: [row…], analysis?: [row]|[] }
//   list view  (workspaceId scope): { rooms?: [row…] }   (never transcripts/analysis)
// `waiting` is deliberately never included — it's host-only and not exposed
// via a service-role single-room read; the live `meet.waiting.*` events
// (already handled below) carry the queue, same as the server comment says.
//
// rooms/transcripts use an UPSERT-by-id merge (byId Map, same pattern
// chat's own snapshot handler uses for channels) — never a replace. This
// function is shared by BOTH subscription slots (see the module doc above):
// the CALL slot's snapshot is room-scoped and carries exactly ONE room, so
// replacing root.rooms outright would wipe every other room the broad PAGE
// slot/list-view fetch already loaded. `analysis` is a single derived row
// (not a keyed collection, matching root.analysis's existing contract — see
// TranscriptPage.js's own `transform: (rows) => ({ analysis: list[0] ||
// null } )` REST-refetch, which already overwrites outright), so it's
// written directly, not merged.
//
// Deliberately NO per-row workspace_id filter here — same reasoning
// `_makeDispatch`'s `room` branch already documents for the cross-workspace
// townhall carve-out: the ONLY scope guard that applies is the
// wsId-staleness check already run before this is called (see
// `_makeDispatch` below), never a raw row-level equality check.
const $01da4da903572def$var$_handleMeetSnapshot = (root, snap)=>{
    if (!snap || typeof snap !== 'object') return;
    if (Array.isArray(snap.rooms) && snap.rooms.length) {
        const cur = root.rooms || [];
        const byId = new Map(cur.map((r)=>[
                r.id,
                r
            ]));
        for (const raw of snap.rooms){
            const room = (0, $lCXAE.rowToRoom)(raw || {});
            if (!room.id) continue;
            byId.set(room.id, room);
        }
        root.update({
            rooms: [
                ...byId.values()
            ]
        });
    }
    if (Array.isArray(snap.transcripts) && snap.transcripts.length) {
        const mapped = snap.transcripts.map((raw)=>(0, $lCXAE.rowToUtterance)(raw || {})).filter((u)=>u.id);
        const cur = root.utterances || [];
        root.update({
            utterances: (0, $lCXAE.dedupeUtterances)([
                ...cur,
                ...mapped
            ])
        });
    }
    // Presence (`Array.isArray`), not truthiness — an empty array still means
    // this scope DID request analysis and the answer is none, matching
    // root.analysis's established null-means-resolved contract (pages/index.js
    // gates auto-analyze on `root.analysis === undefined` meaning "still in
    // flight"; `null` is a real, settled answer).
    if (Array.isArray(snap.analysis)) root.update({
        analysis: snap.analysis[0] || null
    });
};
// Map page-level table names to provider-level table kinds.
const $01da4da903572def$var$_tablesToKinds = (tables)=>{
    const map = {
        meet_rooms: 'rooms',
        meet_participants: 'participants',
        meet_waiting_room: 'waiting',
        meet_transcripts: 'transcripts',
        meet_transcript_analyses: 'analyses'
    };
    return tables.map((t)=>map[t]).filter(Boolean);
};
const $01da4da903572def$export$76690dd6babd09fb = (self, wsId)=>function(kind, payload) {
        if (wsId) {
            const cur = $01da4da903572def$export$866865cbf5f93bf3(self);
            if (cur && cur !== wsId) {
                if ((0, $gGHbJ.isLoudDevRuntime)()) console.warn(`[meet realtime] dropped ${kind} event \u{2014} subscription was opened for workspace ${wsId}, tab is now on ${cur}`);
                return;
            }
        }
        const root = self.state.root;
        if (kind === 'meet.snapshot') {
            $01da4da903572def$var$_handleMeetSnapshot(root, payload);
            return;
        }
        if (kind === 'room') {
            const next = (0, $lCXAE.rowToRoom)(payload.new || payload.old || {});
            if (!next.id) return; // RLS-masked payload
            const cur = root.rooms || [];
            if (payload.eventType === 'INSERT') {
                if (!cur.some((r)=>r.id === next.id)) root.update({
                    rooms: [
                        next,
                        ...cur
                    ]
                });
            } else if (payload.eventType === 'UPDATE') root.update({
                rooms: cur.map((r)=>r.id === next.id ? next : r)
            });
            else if (payload.eventType === 'DELETE') root.update({
                rooms: cur.filter((r)=>r.id !== next.id)
            });
            return;
        }
        if (kind === 'participant') {
            $01da4da903572def$var$_applyKeyedByRoom(root, 'liveParticipants', payload, (0, $lCXAE.rowToParticipant)(payload.new || payload.old || {}));
            return;
        }
        if (kind === 'transcript') {
            const u = (0, $lCXAE.rowToUtterance)(payload.new || {});
            if (!u.id) return; // RLS-masked payload
            // Deduped append — rooms/participants always had id guards here;
            // transcripts did NOT, so an SSE reconnect replay or a second
            // transcriber worker duplicated the panel + captions (2026-07-29
            // per Nika). dedupeUtterances also keeps chronological order, so
            // out-of-order delivery can't shuffle the transcript.
            const cur = root.utterances || [];
            root.update({
                utterances: (0, $lCXAE.dedupeUtterances)([
                    ...cur,
                    u
                ])
            });
            // A spoken ask of the local participant ("Simone, …") — functions/meetFly.js.
            try {
                if (self && typeof self.call === 'function') self.call('meetFlyHeard', u);
            } catch (err) {
                console.warn('[meet] fly ask not heard:', err?.message || err);
            }
            // The call's summary builds as the transcript grows (functions/meetLiveRecap.js).
            try {
                if (self && typeof self.call === 'function') self.call('meetLiveRecap', u);
            } catch (err) {
                console.warn('[meet] live recap not counted:', err?.message || err);
            }
            return;
        }
        if (kind === 'analysis') {
            if (payload.new) root.update({
                analysis: payload.new
            });
            return;
        }
        if (kind === 'waiting') $01da4da903572def$var$_applyKeyedByRoom(root, 'waitingRoom', payload, $01da4da903572def$var$_rowToWaitingGuest(payload.new || payload.old || {}));
    };
// Open one SDK meet subscription (deferred-unsub pattern — the SDK may not
// be ready the instant a subscription is requested).
//
// THE SCOPE ON THE WIRE (G-3, 2026-10-28). A room view is scoped by its room
// alone (a cross-workspace room must still stream). A list view names the
// workspace it was opened for: the SDK puts `workspaceId` on the stream URL
// and binds the stream ticket to it only when the caller passes one, and the
// server's fallback for a missing one is the account's STORED active
// organisation — null on a white-label host (the shell resolves the host's
// workspace in memory and never writes that pointer: 400 scope_required,
// retried by the SDK forever), and an ORGANIZATION id elsewhere, while a room
// carries its WORKSPACE id (the list snapshot matched no current room).
const $01da4da903572def$var$_open = (self, { roomId: roomId, kinds: kinds, wsId: wsId })=>{
    let _resolved = null;
    let _cancelled = false;
    const dispatch = $01da4da903572def$export$76690dd6babd09fb(self, wsId);
    const scope = roomId ? {
        roomId: roomId,
        tables: kinds
    } : {
        workspaceId: wsId,
        tables: kinds
    };
    Promise.resolve((0, $1NxyO.getSDK)().getService?.('workspaceProject')).then((wp)=>{
        if (_cancelled || !wp?.realtime?.subscribeMeet) return;
        _resolved = wp.realtime.subscribeMeet(scope, dispatch);
    }).catch((err)=>{
        console.warn('[meet] subscribeMeetRealtime failed:', err?.message || err);
    });
    return ()=>{
        _cancelled = true;
        if (typeof _resolved === 'function') try {
            _resolved();
        } catch (_) {}
    };
};
const $01da4da903572def$export$2ffe1d360773a979 = function(opts = {}) {
    const self = this // stable element reference
    ;
    const { tables: tables = [
        'meet_rooms'
    ], roomId: roomId = null } = opts;
    const wsId = $01da4da903572def$export$866865cbf5f93bf3(self);
    const scopeKey = `${wsId || '*'}:${[
        ...tables
    ].sort().join(',')}:${roomId || '*'}`;
    if ($01da4da903572def$var$_pageScope === scopeKey) return $01da4da903572def$var$_pageUnsub;
    if ($01da4da903572def$var$_pageUnsub) {
        try {
            $01da4da903572def$var$_pageUnsub();
        } catch (_) {}
        $01da4da903572def$var$_pageUnsub = null;
    }
    $01da4da903572def$var$_pageScope = scopeKey;
    const kinds = $01da4da903572def$var$_tablesToKinds(tables);
    if (!kinds.length) return null;
    // A list view with no workspace resolved yet has nothing to scope it to
    // (see _open): open nothing and keep no scope, so the next call once the
    // workspace lands opens it — the shell's route-sync self-heal, the meet
    // list page's onUpdate and a workspace switch all call again.
    if (!roomId && !wsId) {
        $01da4da903572def$var$_pageScope = null;
        return null;
    }
    const unsub = $01da4da903572def$var$_open(self, {
        roomId: roomId,
        kinds: kinds,
        wsId: wsId
    });
    $01da4da903572def$var$_pageUnsub = ()=>{
        unsub();
        $01da4da903572def$var$_pageScope = null;
    };
    return $01da4da903572def$var$_pageUnsub;
};
const $01da4da903572def$export$b8413ed189a24ba7 = function(roomId) {
    const self = this;
    if (!roomId) return null;
    if ($01da4da903572def$var$_callScope === String(roomId)) return $01da4da903572def$var$_callUnsub;
    if ($01da4da903572def$var$_callUnsub) {
        try {
            $01da4da903572def$var$_callUnsub();
        } catch (_) {}
        $01da4da903572def$var$_callUnsub = null;
    }
    $01da4da903572def$var$_callScope = String(roomId);
    const unsub = $01da4da903572def$var$_open(self, {
        roomId: roomId,
        kinds: [
            'rooms',
            'participants',
            'waiting',
            'transcripts',
            'analyses'
        ]
    });
    $01da4da903572def$var$_callUnsub = ()=>{
        unsub();
        $01da4da903572def$var$_callScope = null;
    };
    return $01da4da903572def$var$_callUnsub;
};
const $01da4da903572def$export$dbece9bc1d26d965 = function() {
    if ($01da4da903572def$var$_callUnsub) {
        try {
            $01da4da903572def$var$_callUnsub();
        } catch (_) {}
        $01da4da903572def$var$_callUnsub = null;
    }
    $01da4da903572def$var$_callScope = null;
};

});

parcelRegister("f868q", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("lmXl2"))) : import("lmXl2")).then(()=>parcelRequire('6Arec'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("7urfU", function(module, exports) {

$parcel$export(module.exports, "MEET_FLY_PAGES_MAX", () => $57407a22b5ac5b36$export$db9c476622d54197);
$parcel$export(module.exports, "meetFlyCallOf", () => $57407a22b5ac5b36$export$f8f4ad3ba9f74902);
$parcel$export(module.exports, "meetFlyVisiblePages", () => $57407a22b5ac5b36$export$2412dfd17083d93a);
$parcel$export(module.exports, "meetFlyFocusedPage", () => $57407a22b5ac5b36$export$5a0e966f2592766b);
$parcel$export(module.exports, "meetFlyOnCallView", () => $57407a22b5ac5b36$export$14159617c55f274d);
$parcel$export(module.exports, "meetFlyTheaterOpen", () => $57407a22b5ac5b36$export$27d6ce4404a166ec);
$parcel$export(module.exports, "meetFlyModeOn", () => $57407a22b5ac5b36$export$29752f862f6c985);
$parcel$export(module.exports, "meetFlyConfirmOf", () => $57407a22b5ac5b36$export$61bbbed4afbc6be8);
// meetFlyState.js — the PURE reads of a call's Fly state (functions/meetFly.js
// writes it; workspace docs/FLY_MODE.md §3.3). Its own small file because the
// shell-root dock (components/CallWidget.js) reads the theater's state and
// must stay eager without pulling meetFly.js in (the ControlBarIconButton
// split's reason).
//
// root.meetFly (workspace-scoped, declared in workspace state-app.js):
//   { v: 2, roomId, mode, open, focus, hidden, pages }
//   mode   null, or { on, by: { identity, name }, at } — the room's switch as
//          last set (OFF keeps its time, so an older ON never wins); on: the
//          agent hears its name in anyone's speech
//   open   THIS person's theater shows (the main layer over the call)
//   focus  the key of the page the theater shows
//   hidden keys of pages this person hid (another's page; theirs stops)
//   pages  the call's pages, oldest first (≤ MEET_FLY_PAGES_MAX):
//          { key, roomId, agent: { key, name }, by: { identity, name },
//            mine, prompt, at, page }
//   confirm  null, or { id, prompt, agent: { key, name }, heardAt, at } —
//          THIS person's spoken ask waiting for their yes (meetFly.js
//          meetFlyConfirm); never on the wire

var $9juhh = parcelRequire("9juhh");
const $57407a22b5ac5b36$export$db9c476622d54197 = 12;
const $57407a22b5ac5b36$export$f8f4ad3ba9f74902 = (root)=>{
    const r = root || {};
    const c = r.meetFly;
    if (!c || typeof c !== 'object' || c.v !== 2) return null;
    if (c.roomId && r.activeRoomId && c.roomId !== r.activeRoomId) return null;
    return c;
};
const $57407a22b5ac5b36$export$2412dfd17083d93a = (call)=>{
    if (!call || !Array.isArray(call.pages)) return [];
    const hidden = new Set(Array.isArray(call.hidden) ? call.hidden : []);
    return call.pages.filter((p)=>p && p.key && !hidden.has(p.key));
};
const $57407a22b5ac5b36$export$5a0e966f2592766b = (call)=>{
    const pages = $57407a22b5ac5b36$export$2412dfd17083d93a(call);
    return pages.find((p)=>p.key === (call && call.focus)) || pages[pages.length - 1] || null;
};
const $57407a22b5ac5b36$export$14159617c55f274d = (root)=>{
    const r = root || {};
    const raw = r.currentPath || (typeof window !== 'undefined' && window.location ? window.location.pathname : '/');
    return (0, $9juhh.stripWorkspacePrefix)(raw) === '/meet' && r.meetView === 'call';
};
const $57407a22b5ac5b36$export$27d6ce4404a166ec = (root)=>{
    const r = root || {};
    if (!r.livekitConnected) return false;
    const call = $57407a22b5ac5b36$export$f8f4ad3ba9f74902(r);
    if (!call || call.open !== true || !$57407a22b5ac5b36$export$5a0e966f2592766b(call)) return false;
    return $57407a22b5ac5b36$export$14159617c55f274d(r);
};
const $57407a22b5ac5b36$export$29752f862f6c985 = (root)=>{
    const call = $57407a22b5ac5b36$export$f8f4ad3ba9f74902(root);
    return !!(call && call.mode && call.mode.on);
};
const $57407a22b5ac5b36$export$61bbbed4afbc6be8 = (root)=>{
    const r = root || {};
    if (!r.livekitConnected || !$57407a22b5ac5b36$export$29752f862f6c985(r)) return null;
    const c = $57407a22b5ac5b36$export$f8f4ad3ba9f74902(r).confirm;
    return c && typeof c === 'object' && c.id && c.prompt ? c : null;
};

});


parcelRegister("7CcEV", function(module, exports) {

$parcel$export(module.exports, "MeetFlyConfirm", () => $58b5e6d2e71b8d6e$export$27357f0a734bb951);
// MeetFlyConfirm — the confirm card of a SPOKEN Fly ask in a call
// (functions/meetFly.js meetFlyConfirm; workspace docs/FLY_MODE.md §3.3).
// Nika 2026-10-26: "during call when we mention fly, symbols or simone,
// before rendering fly content it should open confirm prompt of what was
// required to render"; her answer the same night: a card with what was heard,
// Show and Cancel, and a spoken "yes" or "no". The card names the agent and
// what the call heard; Show makes the page, Cancel drops it, and the asker
// may say "yes" or "no" instead. Only the asker sees it — the confirm is this
// client's own state — and it leaves by itself after 30 s.
//
// Mounted ONCE at the shell root (workspace app.js, beside MeetCallWidget):
// the asker can be on the call view, on its theater or on any other route.
// It reads the call through `meetFlyConfirmOf` (functions/meetFlyState.js,
// registered on every route by meet's eager function slice); its two buttons
// reach meetFly.js through the shell context, where the meet context is
// folded by then (a confirm exists only once meetFly.js heard the ask). A
// name that is not registered is skipped quietly.
//
// CHROME: the shell's transient-card family (workspace CallInvitationBanner,
// IncomingCallBanner): `background: 'document'`, `round: 'radiusSheet'`,
// `shadow: 'overlay'`, bottom-centre above the composer — one home for the
// transient shell messages (Nika 2026-09-01). The wrapper is
// `display: 'contents'` so it never becomes a grid child of the shell.
const $58b5e6d2e71b8d6e$export$27357f0a734bb951 = {
    tag: 'div',
    display: 'contents',
    subscribeTo: [
        'meetFly',
        'livekitConnected',
        'activeRoomId'
    ],
    Card: {
        hide: (el, s)=>!el.call('meetFlyConfirmOf', s.root),
        position: 'fixed',
        bottom: 'C1',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '1600',
        background: 'document',
        round: 'radiusSheet',
        shadow: 'overlay',
        flow: 'y',
        gap: 'Z1',
        padding: 'B',
        width: 'H1',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        boxSizing: 'border-box',
        animationName: 'fadeIn',
        animationDuration: 'C',
        animationTimingFunction: 'defaultBezier',
        animationFillMode: 'both',
        role: 'status',
        ariaLive: 'polite',
        'aria-label': (el)=>el.call('polyglot', 'meet.fly.confirmLabel'),
        '@mobileL': {
            left: 'Z',
            right: 'Z',
            transform: 'none',
            width: 'auto',
            maxWidth: 'none'
        },
        Header: {
            flow: 'x',
            align: 'center',
            gap: 'Y1',
            minWidth: '0',
            Icon: {
                name: 'pxFly',
                boxSize: 'A',
                color: 'caption'
            },
            Eyebrow: {
                tag: 'span',
                minWidth: '0',
                fontSize: 'Y',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '.07em',
                color: 'caption',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>{
                    const c = el.call('meetFlyConfirmOf', s.root);
                    return c && c.agent && c.agent.name || el.call('polyglot', 'meet.fly.aiName');
                }
            }
        },
        Heard: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: '{{ meet.fly.confirmHeard | polyglot }}'
        },
        Prompt: {
            tag: 'p',
            margin: '0',
            minWidth: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            lineHeight: '1.3',
            lineClamp: '3',
            overflow: 'hidden',
            overflowWrap: 'anywhere',
            text: (el, s)=>{
                const c = el.call('meetFlyConfirmOf', s.root);
                if (!c) return '';
                // A function, so a "$&" the transcript wrote stays as written.
                return String(el.call('polyglot', 'meet.fly.confirmQuote') || '{prompt}').replace('{prompt}', ()=>c.prompt);
            }
        },
        Footer: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z1',
            marginTop: 'V',
            Hint: {
                tag: 'span',
                minWidth: '0',
                fontSize: 'Z2',
                color: 'caption',
                text: '{{ meet.fly.confirmHint | polyglot }}'
            },
            Actions: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                // Cancel: nothing is made.
                AppCapsuleBtnGhost: {
                    text: '{{ meet.fly.confirmCancel | polyglot }}',
                    onClick: (e, el)=>{
                        e.stopPropagation();
                        const fns = el.context && el.context.functions;
                        if (fns && typeof fns.meetFlyConfirmAnswer === 'function') el.call('meetFlyConfirmAnswer', false);
                    }
                },
                // Show: the page is made, as the asker.
                AppCapsuleBtnPrimary: {
                    text: '{{ meet.fly.confirmShow | polyglot }}',
                    onClick: (e, el)=>{
                        e.stopPropagation();
                        const fns = el.context && el.context.functions;
                        if (fns && typeof fns.meetFlyConfirmAnswer === 'function') el.call('meetFlyConfirmAnswer', true);
                    }
                }
            }
        }
    }
};

});

parcelRegister("70zqv", function(module, exports) {

$parcel$export(module.exports, "MeetControlBarIconButton", () => $51a4037ab22fffd5$export$bb6aa4513123b2a9);
// MeetControlBarIconButton — round icon-button base used by mic/cam/screen/
// captions/share-link/settings (MeetControlBar) AND the shell-root
// MeetCallWidget's mic/return/leave controls. Split out of ControlBar.js
// (bundle-fold, 2026-08-01) so the widget's eager slice doesn't have to pull
// in the whole ~20KB MeetControlBar component tree just for this one shared
// base — registered via key name so `extends: 'MeetControlBarIconButton'`
// resolves through the smbls component registry regardless of which file
// defined it.
// One control height in the bar: the brand `controlH` (44px), the height of
// its text capsules — `C` was 44.5px at this font size. Never shrinks inside
// the row that scrolls. The dock (CallWidget) sets its own smaller size.
const $51a4037ab22fffd5$export$bb6aa4513123b2a9 = {
    tag: 'button',
    padding: 'Z',
    round: '100%',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'A',
    width: 'controlH',
    height: 'controlH',
    flexShrink: '0',
    align: 'center center',
    theme: 'secondary'
};

});

parcelRegister("d19kx", function(module, exports) {

$parcel$export(module.exports, "MeetNewRoomModal", () => $97a29b25a8311702$export$fb09d3947d05850f);
// The New call sheet: a name, AI transcription and who can join, then Start.
// Start calls createRoom (it inserts the row and merges it into root.rooms),
// lands on /meet and stamps the room hash.
//
// IMPORTANT: reactive getters below route through `_meetDraft(s)` so they
// never throw on the first-pass signal evaluation (when root state may
// not have `newRoomDraft` yet). Optional chaining on `s.root?.X` has
// still been observed to throw `Cannot read properties of undefined
// (reading 'newRoomDraft')` inside smbls v3.14 signal effects, which is
// why we explicitly guard with a try-block helper instead of relying on
// `?.` alone.
//
// Every control is the shared kit's: SwitchInput, AppSegmented and the kit
// capsules (frank-audit 2026-10-30: 14 errors, 5 warnings on the old body).
// The sheet used to draw its own switch and segments and paint them from a
// <style> tag it wrote into document.head, because the reactive props of the
// smbls of 2026-06 froze at mount. The kit keeps its state through props
// (aria-checked from `onCheck`, the chosen segment from `isActive`), so the
// tag, its `!important` rules and the hand-written aria-checked are gone.
// MEET-AUTOJOIN-1 related finding (WAVE-J audit, 2026-08-14): a truly empty
// name silently produced the literal string "Unnamed call" for every
// no-name submit — 86 rooms in the audited workspace shared that one name,
// making the room list impossible to scan. Derive a readable per-call
// default (date + time) instead of a shared placeholder string. This
// supersedes the 2026-06-12 "empty name is fine" note below Start — the
// 2026-08-14 audit is the more recent Nika-sourced direction, and deriving a
// name (not blocking Start) satisfies both: no friction, no more collisions.
// `el` first: the name is STORED, so it is written once, in the language of
// the person who starts the call (shared functions/localizedDate.js reads the
// session language; Chrome has no Georgian month names of its own).
const $97a29b25a8311702$var$_deriveRoomName = (el)=>{
    try {
        const d = new Date();
        return el.call('polyglot', 'meet.newRoom.derivedName').replace('{date}', el.call('localizedDate', d, {
            month: 'short',
            day: 'numeric'
        })).replace('{time}', el.call('localizedDate', d, {
            hour: 'numeric',
            minute: '2-digit'
        }));
    } catch (err) {
        return el.call('polyglot', 'meet.room.untitled');
    }
};
const $97a29b25a8311702$var$_meetDraft = (s)=>{
    try {
        if (!s) return {};
        const root = s.root;
        if (!root) return {};
        return root.newRoomDraft || {};
    } catch (err) {
        console.warn('[MeetNewRoomModal] draft read failed', err);
        return {};
    }
};
const $97a29b25a8311702$var$_meetPatch = (s, patch)=>{
    try {
        if (!s || !s.root) return;
        const current = s.root.newRoomDraft || {};
        s.root.update({
            newRoomDraft: {
                ...current,
                ...patch
            }
        });
    } catch (err) {
        console.warn('[MeetNewRoomModal] patch failed', err);
    }
};
const $97a29b25a8311702$export$fb09d3947d05850f = {
    width: '100%',
    maxWidth: '100%',
    minWidth: '0',
    boxSizing: 'border-box',
    gap: 'Z1',
    // The windows ModalLayer content box is tight (see the Icons note below) —
    // an X (4px) side inset keeps children's rounded corners and the global
    // focus ring inside the clip instead of shearing at the modal edges
    // (2026-08-07 per Nika "fix overflow cutting its edges").
    padding: '0 X',
    ModalHeader: {
        // Neutralize the brand ModalHeader Icons bleed (`margin: '-Y2 -Z1 -
        // auto'`) — it compensates the brand ModalWindow's padding, but this
        // modal renders in the @symbo.ls/windows ModalLayer whose content box
        // is tight, so the Close button poked ~13px past the edge and forced a
        // horizontal scrollbar over the footer (2026-07-29 per Nika).
        Icons: {
            margin: '0 0 0 auto'
        },
        Hgroup: {
            H: {
                text: '{{ meet.newRoom.heading | polyglot }}'
            },
            P: {
                text: '{{ meet.newRoom.hint | polyglot }}'
            }
        }
    },
    // Primary field — no label chrome (the placeholder carries the affordance;
    // empty = a derived name). The shared field kit's control
    // (shared/components/AppField.js): AppInput owns the whole surface — the
    // brand `field` fill, the hairline edge, the control scale, the global
    // focus ring — so this key keeps the behaviour only.
    AppInput: {
        // A placeholder is NOT an accessible name (it vanishes on focus and isn't
        // reliably announced) — give the field an explicit label. The flat
        // `ariaLabel`: with no AppField parent it is the one form that replaces
        // the kit's parent-label name.
        type: 'text',
        ariaLabel: (el)=>el.call('polyglot', 'meet.newRoom.nameAria'),
        autocomplete: 'off',
        placeholder: (el)=>el.call('polyglot', 'meet.newRoom.namePlaceholder'),
        value: (el, s)=>$97a29b25a8311702$var$_meetDraft(s).name || '',
        onInput: (e, el, s)=>$97a29b25a8311702$var$_meetPatch(s, {
                name: e.target.value
            })
    },
    // The settings rows, on the sheet itself: content sits on a sheet unboxed,
    // and the rows part by their own padding, not by strokes (the room
    // settings sheet's rule, www-ee item 7). It was one rounded `overlay` card
    // (1.01:1 on the sheet, a box no one sees) with a hairline between the rows
    // in a raw CSS variable.
    SettingsCard: {
        flow: 'y',
        TranscribeRow: {
            flow: 'x',
            align: 'center space-between',
            gap: 'A',
            padding: 'Z1 0',
            Label: {
                flow: 'y',
                gap: 'W',
                flex: '1',
                Title: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    fontWeight: '500',
                    text: '{{ meet.newRoom.transcription | polyglot }}'
                },
                Caption: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: '{{ meet.newRoom.transcriptionHint | polyglot }}'
                }
            },
            // The kit switch (shared components/SwitchInput.js): `onCheck` reads the
            // draft, and the switch writes its own aria-checked and paints each
            // state from it. The row's title names it.
            SwitchInput: {
                'aria-label': (el)=>el.call('polyglot', 'meet.newRoom.transcription'),
                onCheck: (el, s)=>!!$97a29b25a8311702$var$_meetDraft(s).transcribeEnabled,
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    $97a29b25a8311702$var$_meetPatch(s, {
                        transcribeEnabled: !$97a29b25a8311702$var$_meetDraft(s).transcribeEnabled
                    });
                }
            }
        },
        VisibilityRow: {
            flow: 'y',
            gap: 'Z',
            padding: 'Z1 0',
            Head: {
                flow: 'x',
                align: 'center space-between',
                Title: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    fontWeight: '500',
                    text: '{{ meet.newRoom.whoCanJoin | polyglot }}'
                }
            },
            // Who can join — the kit's segmented control in its `choice` strength
            // (a radiogroup, arrow keys, the ink thumb), full width. A pick goes
            // through the registered `meetSetNewRoomVisibility` (functions/
            // newRoomModal.js). Each row carries the value it was derived at, so a
            // pick re-derives the rows and every segment re-reads its own choice
            // (the chat Create sheet's pattern); each keeps its hint as the tooltip.
            AppSegmented: {
                variant: 'choice',
                width: '100%',
                ariaLabel: (el)=>el.call('polyglot', 'meet.newRoom.whoCanJoin'),
                current: (el, s)=>$97a29b25a8311702$var$_meetDraft(s).visibility || 'workspace',
                select: 'meetSetNewRoomVisibility',
                childrenAs: 'state',
                children: (el, s)=>{
                    const chosen = $97a29b25a8311702$var$_meetDraft(s).visibility || 'workspace';
                    return [
                        {
                            key: 'private',
                            text: 'meet.visibility.private',
                            hint: 'meet.visibility.privateHint',
                            value: 'private',
                            chosen: chosen
                        },
                        {
                            key: 'workspace',
                            text: 'meet.visibility.workspace',
                            hint: 'meet.visibility.workspaceHint',
                            value: 'workspace',
                            chosen: chosen
                        },
                        {
                            key: 'public',
                            text: 'meet.visibility.public',
                            hint: 'meet.visibility.publicHint',
                            value: 'public',
                            chosen: chosen
                        }
                    ];
                },
                childProps: {
                    flex: '1 1 auto',
                    isActive: (el, s)=>!!s && s.value === s.chosen,
                    title: (el, s)=>el.call('polyglot', s && s.hint || '')
                }
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                lineHeight: '1.45',
                text: (el, s)=>{
                    const v = $97a29b25a8311702$var$_meetDraft(s).visibility || 'workspace';
                    if (v === 'private') return el.call('polyglot', 'meet.visibility.privateCaption');
                    if (v === 'public') return el.call('polyglot', 'meet.visibility.publicCaption');
                    return el.call('polyglot', 'meet.visibility.workspaceCaption');
                }
            }
        }
    },
    ModalFooter: {
        flow: 'x',
        gap: 'Z1',
        align: 'center right',
        // Neutralize the brand ModalFooter's `margin: '0 -X'` full-bleed — that
        // negative margin compensates the brand ModalWindow's side padding, but
        // THIS modal renders in the @symbo.ls/windows ModalLayer whose content
        // box is narrower, so the footer overflowed ~8px and spawned a
        // horizontal scrollbar strip over the buttons ("overflow cutting the
        // button", 2026-07-29 per Nika).
        margin: 'Z 0 0',
        // The kit's ghost and ink capsules (shared AppField.js) own the control
        // height, the inset, the weight and the states; the call site set them by
        // hand before (Rule 68).
        AppCapsuleBtnGhost: {
            text: '{{ meet.newRoom.cancel | polyglot }}',
            onClick: (e, el)=>{
                e.preventDefault();
                el.call('closeNewRoomModal');
            }
        },
        AppCapsuleBtnPrimary: {
            text: '{{ meet.newRoom.start | polyglot }}',
            onClick: async (e, el, s)=>{
                const d = $97a29b25a8311702$var$_meetDraft(s);
                // No Start-blocking friction, but no more shared "Unnamed call"
                // literal either — derive a distinguishable per-call name from the
                // creation time when the user left the field blank (see
                // _deriveRoomName above).
                const name = (d.name || '').trim() || $97a29b25a8311702$var$_deriveRoomName(el);
                const id = await el.call('createRoom', {
                    name: name,
                    kind: 'room',
                    visibility: d.visibility || 'workspace',
                    transcribeEnabled: !!d.transcribeEnabled
                });
                if (!id) return;
                if (s && s.root) s.root.update({
                    activeRoomId: id,
                    meetView: 'call'
                });
                if (typeof window !== 'undefined') {
                    // The modal opens from ANY route now (navbar NewCall button) —
                    // land on /meet so the call view actually renders, then stamp
                    // the shareable hash. meetView/activeRoomId are already set,
                    // so the page mounts straight into the call. The workspace prefix
                    // comes off through the registry (shared functions/
                    // workspacePrefix.js), not a static import of the shared package.
                    if (el.call('stripWorkspacePrefix', window.location.pathname) !== '/meet') el.router('/meet', el.getRoot());
                    // Hash-only: the address keeps its path, the `/w/<org>/<workspace>`
                    // that the route above (or the open /meet) carries (F2 — a bare
                    // `/meet#…` here dropped it, and a reload opened the call in the
                    // last-used workspace). Raw on purpose, as the shell's callPerson
                    // stamps it: a second el.router would take over the pending /meet
                    // mount while the shell's route-exit motion runs.
                    // frank-allow FA410
                    history.replaceState(null, '', `#room=${id}&view=call`);
                }
                el.call('connectCall', id);
            }
        }
    }
};

});


parcelRegister("lvolO", function(module, exports) {

$parcel$export(module.exports, "connectCall", () => (parcelRequire("3lM30")).connectCall);
$parcel$export(module.exports, "disconnectCall", () => (parcelRequire("3lM30")).disconnectCall);
$parcel$export(module.exports, "meetCallAudioAttach", () => (parcelRequire("e07LX")).meetCallAudioAttach);
$parcel$export(module.exports, "meetCallAudioMembers", () => (parcelRequire("e07LX")).meetCallAudioMembers);
$parcel$export(module.exports, "subscribeMeetRealtime", () => (parcelRequire("9Rs24")).subscribeMeetRealtime);
$parcel$export(module.exports, "openNewRoomModal", () => (parcelRequire("9zsfY")).openNewRoomModal);
$parcel$export(module.exports, "closeNewRoomModal", () => (parcelRequire("9zsfY")).closeNewRoomModal);
$parcel$export(module.exports, "meetSetNewRoomVisibility", () => (parcelRequire("9zsfY")).meetSetNewRoomVisibility);
$parcel$export(module.exports, "createRoom", () => (parcelRequire("dHCia")).createRoom);
$parcel$export(module.exports, "meetRoomUrl", () => (parcelRequire("33v8M")).meetRoomUrl);
$parcel$export(module.exports, "endRoom", () => (parcelRequire("3fWEy")).endRoom);
$parcel$export(module.exports, "addMeetMember", () => (parcelRequire("evIhe")).addMeetMember);
$parcel$export(module.exports, "listMeetMembers", () => (parcelRequire("evIhe")).listMeetMembers);
$parcel$export(module.exports, "meetLiveRecap", () => (parcelRequire("Ay0Wq")).meetLiveRecap);
$parcel$export(module.exports, "meetLiveRecapAsk", () => (parcelRequire("Ay0Wq")).meetLiveRecapAsk);
$parcel$export(module.exports, "meetLiveRecapAsker", () => (parcelRequire("Ay0Wq")).meetLiveRecapAsker);
$parcel$export(module.exports, "meetLiveRecapForce", () => (parcelRequire("Ay0Wq")).meetLiveRecapForce);
$parcel$export(module.exports, "meetLiveRecapOf", () => (parcelRequire("Ay0Wq")).meetLiveRecapOf);
$parcel$export(module.exports, "meetCallSince", () => (parcelRequire("iiSz5")).meetCallSince);
$parcel$export(module.exports, "meetCallChangesLoad", () => (parcelRequire("iiSz5")).meetCallChangesLoad);
$parcel$export(module.exports, "meetCallChangesGroup", () => (parcelRequire("iiSz5")).meetCallChangesGroup);
$parcel$export(module.exports, "meetCallChangesTick", () => (parcelRequire("iiSz5")).meetCallChangesTick);
$parcel$export(module.exports, "meetCallChangesOf", () => (parcelRequire("iiSz5")).meetCallChangesOf);
$parcel$export(module.exports, "analyzeTranscript", () => (parcelRequire("fh61z")).analyzeTranscript);
$parcel$export(module.exports, "markSuggestionApplied", () => (parcelRequire("jzcmH")).markSuggestionApplied);
$parcel$export(module.exports, "meetAiViews", () => (parcelRequire("crFNF")).meetAiViews);
$parcel$export(module.exports, "meetFlyConfirmOf", () => (parcelRequire("7urfU")).meetFlyConfirmOf);
// Eager slim slice of the meet function barrel (bundle-fold, 2026-08-01).
//
// The full `./index.js` barrel re-exports the whole meet function surface —
// call connection, room CRUD, transcript analysis, suggestion handling,
// LiveKit plumbing, realtime subscriptions. sharedLibraries.js used to drag
// ALL of it into the shell's EAGER chunk by folding the full meet context.
//
// Meet is now a lazy sub-app (see components/eagerSlice.js): the `/meet` +
// `/meet-guest` routes fold the FULL meet context (components + functions +
// state) into the live shell context on first mount. So the eager chunk only
// needs the meet functions that get `el.call`'d (or statically imported) from
// OUTSIDE a meet-mounted component — i.e. on a surface that never folds the
// meet context.
//
// An exhaustive grep of the whole eager surface (workspace app.js/pages/
// components/functions, shared/**, chat, calendar, canvas, tickets, and the
// other lazy sub-apps' eager contexts) for cross-route meet-function callers
// found:
//   • connectCall — el.call'd by workspace pageContext.js (deep-link/notif
//     join), PersonPopover.js ("Meet" action), chat Composer.js/Main.js
//     (call button + rejoin), calendar EventDetailModal.js (join-call) — ALL
//     non-meet routes. Also the source of MeetCallWidget's own Return button
//     (static import of getLivekitRoom, not el.call — that whole module is
//     pulled in transitively regardless).
//   • disconnectCall — el.call'd by chat Main.js (leave from the chat call
//     bar) and MeetCallWidget's own Leave button.
//   • openNewRoomModal / closeNewRoomModal — el.call'd by the GLOBAL app
//     header "New meeting" action (shared/components/AppHeader.js,
//     shared/components/MainNavbar.js) and workspace/app.js itself.
//   • meetSetNewRoomVisibility — the `select` of that modal's Who can join
//     segments (AppSegmented el.call's it), which render in the same GLOBAL
//     layer before /meet folds the meet context.
//   • createRoom — el.call'd by PersonPopover.js, chat Composer.js/Main.js
//     ("start a call" from a DM/channel), calendar NewBookingModal.js/
//     EventDetailModal.js (schedule-with-a-call), AND MeetNewRoomModal's own
//     submit handler.
//   • meetRoomUrl — el.call'd by PersonPopover.js + calendar
//     NewBookingModal.js (share/copy a room link before ever opening /meet).
//   • markSuggestionApplied — el.call'd by calendar NewBookingModal.js +
//     tickets TicketDetailModal.js (save-a-prefilled-suggestion through the
//     native modal, without ever mounting a meet surface).
// Every OTHER meet function (subscribeMeetRealtime, muteParticipant,
// analyzeTranscript, applySuggestion, updateRoomSettings, admitGuest, …) is
// only el.call'd from a meet-mounted component, i.e. AFTER a fold registers
// it — so it rides the lazy chunk.
//   • subscribeMeetRealtime — el.call'd by the SHELL ROOT itself
//     (workspace/app.js, right after the notif poll wiring): shell-level meet
//     realtime so the "Start a call" icon can badge an ONGOING call before
//     /meet is ever opened. Missed by the original fold inventory — first
//     live boot logged "subscribeMeetRealtime is not registered" ×5 and the
//     ongoing-call badge died on non-meet routes. Light deps only (sdk getter
//     + pointer + row mappers; livekit-client stays a dynamic import inside
//     connectCall).

var $3lM30 = parcelRequire("3lM30");

var $e07LX = parcelRequire("e07LX");

var $9Rs24 = parcelRequire("9Rs24");

var $9zsfY = parcelRequire("9zsfY");

var $dHCia = parcelRequire("dHCia");

var $33v8M = parcelRequire("33v8M");

var $3fWEy = parcelRequire("3fWEy");

var $evIhe = parcelRequire("evIhe");

var $Ay0Wq = parcelRequire("Ay0Wq");

var $iiSz5 = parcelRequire("iiSz5");

var $fh61z = parcelRequire("fh61z");

var $jzcmH = parcelRequire("jzcmH");

var $crFNF = parcelRequire("crFNF");

var $7urfU = parcelRequire("7urfU");

});
parcelRegister("e07LX", function(module, exports) {

$parcel$export(module.exports, "meetCallAudioAttach", () => $a317183cdec54405$export$a2b840936d22468);
$parcel$export(module.exports, "meetCallAudioMembers", () => $a317183cdec54405$export$eaef87b32a634a42);
// THE CALL'S SOUND at the shell root (components/CallAudio.js): one <audio>
// per remote member, beside the dock, so a live call keeps playing on every
// route — the tiles' own <audio> unmounted with /meet and a call went silent
// behind the dock (a Codex review of the call theater, 2026-10-18). Eager: the
// host mounts before the meet context is folded (components/eagerSlice.js).

var $3lM30 = parcelRequire("3lM30");

var $8tejg = parcelRequire("8tejg");
const $a317183cdec54405$export$a2b840936d22468 = function meetCallAudioAttach(el, s) {
    const node = el && el.node;
    const identity = s && s.identity;
    if (!node || !identity) return false;
    (0, $8tejg.attachParticipantAudio)(node, (0, $3lM30.getLivekitRoom)(), identity);
    return true;
};
const $a317183cdec54405$export$eaef87b32a634a42 = function meetCallAudioMembers(root) {
    const r = root || this && this.state && this.state.root || {};
    const list = Array.isArray(r.livekitParticipants) ? r.livekitParticipants : [];
    return list.filter((p)=>p && !p.isLocal && !p.isScreen && p.identity).map((p)=>({
            key: 'a-' + String(p.identity),
            identity: String(p.identity)
        }));
};

});

parcelRegister("9zsfY", function(module, exports) {

$parcel$export(module.exports, "openNewRoomModal", () => $6f7d4d239d855eda$export$96b376687d3ec8ea);
$parcel$export(module.exports, "closeNewRoomModal", () => $6f7d4d239d855eda$export$50a857a721981bb6);
$parcel$export(module.exports, "meetSetNewRoomVisibility", () => $6f7d4d239d855eda$export$df2da710704edac1);
// New-room modal open/close helpers — registered via context.functions so
// any element can dispatch them with:
//   el.call('openNewRoomModal', initialDraft?)
//   el.call('closeNewRoomModal')
//
// Migrated 2026-06-01 from `root.update({ showNewRoom: true, newRoomDraft })`
// to a @symbo.ls/windows custom-template layer. `root.newRoomDraft` stays
// as the data carrier — the body's reactive reads on it are unchanged.
const $6f7d4d239d855eda$var$NEW_ROOM_LAYER_ID = 'meet-new-room';
const $6f7d4d239d855eda$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
function $6f7d4d239d855eda$export$96b376687d3ec8ea(initialDraft) {
    const root = $6f7d4d239d855eda$var$_rootState(this);
    if (!root) return;
    root.update({
        newRoomDraft: {
            name: '',
            kind: 'room',
            transcribeEnabled: true,
            isPrivate: false,
            ...initialDraft || {}
        }
    });
    // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
    // so the Close X can't be pushed off-screen by tall content / a short
    // viewport (see workspace/packages/shared/functions/openCustomModal.js).
    this.call('openCustomModal', {
        id: $6f7d4d239d855eda$var$NEW_ROOM_LAYER_ID,
        content: {
            extends: 'MeetNewRoomModal'
        }
    });
}
function $6f7d4d239d855eda$export$50a857a721981bb6() {
    const root = $6f7d4d239d855eda$var$_rootState(this);
    root?.update({
        newRoomDraft: null
    });
    this.call('closeModal', $6f7d4d239d855eda$var$NEW_ROOM_LAYER_ID);
}
function $6f7d4d239d855eda$export$df2da710704edac1(visibility) {
    const root = $6f7d4d239d855eda$var$_rootState(this);
    if (!root) return;
    if (visibility !== 'private' && visibility !== 'workspace' && visibility !== 'public') return;
    const draft = root.newRoomDraft || {};
    if (draft.visibility === visibility) return;
    root.update({
        newRoomDraft: {
            ...draft,
            visibility: visibility
        }
    });
}

});

parcelRegister("dHCia", function(module, exports) {

$parcel$export(module.exports, "createRoom", () => $9f9cfe88b97e3ceb$export$4a6fbf23fa252689);
// Create a new meet_rooms row + auto-add the creator as an owning member.
// camelCase API at the boundary; snake_case at the row write — same boundary
// chat's createChannel uses.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (create) +
// workspaceProject.meet.members (create)
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $lCXAE = parcelRequire("lCXAE");
const $9f9cfe88b97e3ceb$export$4a6fbf23fa252689 = async function({ name: name, kind: kind = 'room', visibility: // `visibility` is the new 3-state model (private/workspace/public).
// `isPrivate` kept for back-compat — only consulted when visibility is
// not supplied. Default is 'workspace' (the most common case: a room
// any teammate can join, but not anyone with the URL).
visibility, isPrivate: isPrivate = false, transcribeEnabled: transcribeEnabled = false, calendarEventId: calendarEventId = null, chatChannelId: chatChannelId = null }) {
    const finalVisibility = visibility || (isPrivate ? 'private' : 'workspace');
    const finalIsPrivate = finalVisibility === 'private';
    const root = this.state.root;
    const me = root.currentUserId;
    if (!me) {
        console.error("[createRoom] no currentUserId \u2014 meet requires real auth");
        return null;
    }
    const sdk = (0, $1NxyO.getSDK)();
    try {
        const result = await sdk.execute('workspaceProject.meet.rooms', 'create', {
            payload: {
                name: name || this.call('polyglot', 'meet.room.untitled'),
                kind: kind,
                visibility: finalVisibility,
                // Dual-write is_private until consumers fully migrate to visibility.
                // Drop this once everyone reads `visibility` (see migration 0149 notes).
                is_private: finalIsPrivate,
                transcribe_enabled: transcribeEnabled,
                calendar_event_id: calendarEventId,
                chat_channel_id: chatChannelId,
                created_by: me,
                // Name the workspace the tab is ACTUALLY viewing (URL-derived) — the
                // server membership-validates and stamps the room into it (SERVER-
                // CHAT-WS-SCOPE-EXPLICIT). Without this, rooms stamped the token's
                // possibly-stale active-workspace claim (the exact 'stale
                // workspace_id' case MeetService's visibility docs flag).
                workspace_id: root.workspace?.id ? String(root.workspace.id) : undefined
            }
        });
        // PostgREST returns inserts as an array even when only one row was
        // written. Unwrap to a single row — same shape as the chat surface's
        // create handlers.
        const data = result?.data ?? result;
        let row = Array.isArray(data) ? data[0] : data;
        // Empty-response fallback for RLS-masked SELECT after INSERT — see
        // tickets/server.md SERVER-CHAT-AUTH-1.
        if (!row?.id) try {
            const refetch = await sdk.execute('workspaceProject.meet.rooms', 'list', {
                filter: {
                    created_by: me,
                    kind: kind
                },
                options: {
                    order: {
                        created_at: 'desc'
                    },
                    limit: 5
                }
            });
            const rows = refetch?.data || refetch || [];
            const list = Array.isArray(rows) ? rows : [];
            row = list.find((r)=>r && (name == null || r.name === name)) || null;
        } catch (refetchErr) {
            console.warn('[createRoom] empty-response refetch failed:', refetchErr?.message || refetchErr);
        }
        if (!row?.id) throw new Error('createRoom: empty response, refetch found no row');
        const room = (0, $lCXAE.rowToRoom)(row);
        // Auto-add the creator as the owning member. Other members can self-join
        // via the shareable URL (the meet_members_insert RLS policy allows
        // user_id = auth.uid() inserts).
        //
        // user_id is OMITTED on purpose: `root.currentUserId` is the MONGO _id
        // (dual id-space — see the agents-model memory) while meet_members.user_id
        // is `uuid references auth.users(id)`, so passing `me` failed every
        // insert with `invalid input syntax for type uuid` and rooms ended up
        // with NO owning member row. The server's meet surface stamps user_id
        // from auth.supabaseUserId whenever the body doesn't provide one — the
        // designed self-join path (server surfaces/meet.js).
        try {
            await sdk.execute('workspaceProject.meet.members', 'create', {
                roomId: room.id,
                payload: {
                    role: 'owner'
                }
            });
        } catch (memErr) {
            console.warn('[createRoom] member insert failed', memErr?.message || memErr);
        }
        // Optimistic state merge — realtime will deliver the same row but the
        // user shouldn't have to wait for the round trip.
        const existing = root.rooms || [];
        if (!existing.some((r)=>r.id === room.id)) root.update({
            rooms: [
                room,
                ...existing
            ],
            activeRoomId: room.id
        });
        // Pop the new-room modal layer if it's open. Safe to call when no
        // layer is open — closeModal early-returns when id isn't on the stack.
        try {
            this?.call?.('closeNewRoomModal');
        } catch (err) {
            console.warn('[createRoom] closeNewRoomModal failed:', err);
        }
        return room.id;
    } catch (err) {
        console.error('[createRoom]', err?.message || err);
        return null;
    }
};

});

parcelRegister("33v8M", function(module, exports) {

$parcel$export(module.exports, "meetRoomUrl", () => $2399cec5fa4ae5f8$export$abe9c9b9e5a38242);
// Canonical share/join URLs for a meet room — registered (el.call) so every
// builder (ControlBar share, RoomSettingsModal copy, calendar booking links)
// emits ONE shape.
//
// The workspace link MUST carry the `/w/<org-slug>` prefix of the room's
// OWNING org. A bare `${origin}/meet#room=…` link resolves on the RECIPIENT's
// side to whatever org their boot pins (their last-active org) — which is how
// a system-org call invite landed a user inside /w/natali with the room's
// workspace-scoped surfaces (record, participants, transcripts) reading the
// wrong tenant (2026-07-29, critical). The sharer's ACTIVE org is the room's
// org — the rooms list is workspace-scoped, a sharer can only share rooms of
// the org they're in.
//
// Guest links stay unprefixed — /meet-guest is a public surface with no org
// boot; the guest flow resolves the room server-side.

var $9juhh = parcelRequire("9juhh");

var $g3Ned = parcelRequire("g3Ned");
const $2399cec5fa4ae5f8$export$abe9c9b9e5a38242 = function(root, roomId, opts) {
    if (!roomId || typeof window === 'undefined') return '';
    const origin = window.location.origin;
    if (opts && opts.guest) return `${origin}/meet-guest#room=${roomId}`;
    const org = root && root.org;
    const slug = org && (org.slug || org.username) || null;
    // Scheme A: carry the WORKSPACE segment too (shared rule — non-HQ always).
    // Rooms are workspace-scoped, so an org-only link resolved on the
    // recipient's side to THEIR pointer/HQ workspace of that org — same class
    // of bug as the org mismatch above, one level down.
    const handle = (0, $g3Ned.resolveWorkspaceUrlHandle)({
        workspace: root && root.workspace,
        org: org,
        workspaces: root && Array.isArray(root.workspaces) ? root.workspaces : []
    });
    return `${origin}${(0, $9juhh.withWorkspacePath)(slug, handle, '/meet')}#room=${roomId}&view=call`;
};

});

parcelRegister("3fWEy", function(module, exports) {

$parcel$export(module.exports, "endRoom", () => $25f04514a6e5a83d$export$ded6fd72ce2908d4);
$parcel$export(module.exports, "reopenRoom", () => $25f04514a6e5a83d$export$655a9268b24e505d);
// endRoom / reopenRoom — toggle meet_rooms.ended_at. The meet_rooms_update
// RLS policy allows the room creator (and admins) to update. Other members
// get a silent failure, which is what we want — only owners can close a
// room.
//
// Ending a room doesn't disconnect live participants — it's an advisory
// state flag. Components read it to sort, badge, and hide the call button
// on the room row. If you want to forcibly kick everyone, that's a future
// `RoomServiceClient.deleteRoom` call from a new Edge Function.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (end / reopen)
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $25f04514a6e5a83d$export$ded6fd72ce2908d4 = async function(roomId) {
    const root = this.state.root;
    const id = roomId || root.activeRoomId;
    if (!id) return false;
    const endedAt = new Date().toISOString();
    try {
        await (0, $1NxyO.getSDK)().execute('workspaceProject.meet.rooms', 'end', {
            id: id
        });
    } catch (err) {
        console.error('[endRoom]', err?.message || err);
        return false;
    }
    // Optimistic state merge
    const rooms = (root.rooms || []).map((r)=>r.id === id ? {
            ...r,
            endedAt: endedAt
        } : r);
    root.update({
        rooms: rooms
    });
    return true;
};
const $25f04514a6e5a83d$export$655a9268b24e505d = async function(roomId) {
    const root = this.state.root;
    const id = roomId || root.activeRoomId;
    if (!id) return false;
    try {
        await (0, $1NxyO.getSDK)().execute('workspaceProject.meet.rooms', 'reopen', {
            id: id
        });
    } catch (err) {
        console.error('[reopenRoom]', err?.message || err);
        return false;
    }
    const rooms = (root.rooms || []).map((r)=>r.id === id ? {
            ...r,
            endedAt: null,
            livekitInitialized: false
        } : r);
    root.update({
        rooms: rooms
    });
    return true;
};

});

parcelRegister("evIhe", function(module, exports) {

$parcel$export(module.exports, "listMeetMembers", () => $a9064e6efa4283c9$export$1cac22d22e5368a3);
$parcel$export(module.exports, "addMeetMember", () => $a9064e6efa4283c9$export$776be1a134731c4d);
// Meet member operations — list current members on a room, add one or more
// members by user_id. Server-side RLS (`meet_members_insert` policy) allows
// owner-add and self-join; the surfaces/meet.js handler stamps user_id from
// auth only when the body didn't supply one.
//
// camelCase at the boundary; snake_case on the row. Same boundary chat's
// member helpers use.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $a9064e6efa4283c9$export$1cac22d22e5368a3 = async function(roomId) {
    if (!roomId) return [];
    try {
        const res = await (0, $1NxyO.getSDK)().execute('workspaceProject.meet.members', 'list', {
            roomId: roomId
        });
        const rows = res?.data || res || [];
        return (Array.isArray(rows) ? rows : []).map((r)=>({
                userId: r.user_id,
                role: r.role || 'member',
                roomId: r.room_id
            }));
    } catch (err) {
        console.warn('[listMeetMembers]', err?.message || err);
        return [];
    }
};
const $a9064e6efa4283c9$export$776be1a134731c4d = async function({ roomId: roomId, userId: userId, role: role = 'member' }) {
    if (!roomId || !userId) return false;
    try {
        await (0, $1NxyO.getSDK)().execute('workspaceProject.meet.members', 'create', {
            roomId: roomId,
            payload: {
                user_id: userId,
                role: role
            }
        });
        return true;
    } catch (err) {
        console.warn('[addMeetMember]', err?.message || err);
        return false;
    }
};

});

parcelRegister("Ay0Wq", function(module, exports) {

$parcel$export(module.exports, "meetLiveRecapAsker", () => $06ddbf6a5da715a6$export$ff555e76a68370e9);
$parcel$export(module.exports, "meetLiveRecap", () => $06ddbf6a5da715a6$export$8547ae309cddab36);
$parcel$export(module.exports, "meetLiveRecapAsk", () => $06ddbf6a5da715a6$export$1d3a18f09679566b);
$parcel$export(module.exports, "meetLiveRecapForce", () => $06ddbf6a5da715a6$export$45df3b60dc8c3e1c);
$parcel$export(module.exports, "meetLiveRecapOf", () => $06ddbf6a5da715a6$export$2f235ee5d4d56710);
// meetLiveRecap.js — THE CALL'S SUMMARY BUILDS DURING THE CALL (Nika
// 2026-10-23: "make call ending page summary during the call also realtime -
// so if I catch events, tasks, some workspace additions, it can show up in
// dashboard - so it automatically catches the data events - does not need to
// wait for the call end. but also shows on the end screen of the call").
//
// While a transcribed call runs, its analysis — the summary and what the
// conversation caught: events, tasks, notes, knowledge, messages
// (AiChatService.meetAnalyze, server) — is asked AGAIN as the transcript
// grows: once at least LINES new lines have landed and GAP_MS have passed
// since the last ask, never two at once. The answer is the room's ONE
// analysis row; the server pushes it to everyone in the call on the room's own
// stream (`meet.analysis.update` → root.analysis, subscribeMeetRealtime.js),
// so the call's live summary (MeetLiveRecap, in the transcript drawer) and
// the end screen (MeetTranscriptPage) read the same row — the end screen has
// it the moment the call ends. Leaving asks once more for the last lines
// (meetLiveRecapForce).
//
// ONE participant asks: the room's creator while they are in the call, else
// the live participant whose id sorts first — a room of five makes one model
// call, not five; no coordination needed (everyone computes the same one).
//
// The bookkeeping (lines since the last ask, when it was, one in flight) lives
// on the root under a double-underscore key — never state, never rendered.
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// The participant who asks for this room's analysis, or null.
function $06ddbf6a5da715a6$export$ff555e76a68370e9(root, roomId) {
    const r = root && typeof root === 'object' ? root : {};
    if (!roomId) return null;
    const room = (Array.isArray(r.rooms) ? r.rooms : []).find((x)=>x && x.id === roomId);
    const live = (r.liveParticipants && r.liveParticipants[roomId] || []).filter((p)=>p && !p.leftAt && p.userId);
    const ids = [
        ...new Set(live.map((p)=>String(p.userId)))
    ].sort();
    const creator = room && room.createdBy ? String(room.createdBy) : '';
    if (creator && ids.includes(creator)) return creator;
    return ids[0] || null;
}
function $06ddbf6a5da715a6$export$8547ae309cddab36(u) {
    const root = this.state && this.state.root;
    if (!root || !u || !u.roomId) return false;
    const LINES = 6;
    const GAP_MS = 60000;
    const roomId = u.roomId;
    if (roomId !== root.activeRoomId) return false;
    const room = (Array.isArray(root.rooms) ? root.rooms : []).find((x)=>x && x.id === roomId);
    if (room && room.transcribeEnabled === false) return false;
    const bag = root.__meetLiveRecap = root.__meetLiveRecap || {};
    const rec = bag[roomId] = bag[roomId] || {
        lines: 0,
        at: 0,
        busy: false
    };
    rec.lines += 1;
    // both id forms of this person: a room's created_by and a participant's
    // user_id can carry the legacy one (ControlBar's EndRoomBtn compares both)
    const mine = [
        root.currentUserSupabaseId,
        root.currentUserId
    ].filter(Boolean).map(String);
    if (!mine.includes(String(this.call('meetLiveRecapAsker', root, roomId) || ''))) return false;
    if (rec.busy || rec.lines < LINES || Date.now() - rec.at < GAP_MS) return false;
    return this.call('meetLiveRecapAsk', roomId);
}
function $06ddbf6a5da715a6$export$1d3a18f09679566b(roomId) {
    const root = this.state && this.state.root;
    if (!root || !roomId) return false;
    const bag = root.__meetLiveRecap = root.__meetLiveRecap || {};
    const rec = bag[roomId] = bag[roomId] || {
        lines: 0,
        at: 0,
        busy: false
    };
    if (rec.busy) return false;
    rec.busy = true;
    rec.lines = 0;
    rec.at = Date.now();
    const done = ()=>{
        rec.busy = false;
    };
    try {
        const run = this.call('analyzeTranscript', roomId, true);
        if (run && typeof run.then === 'function') run.then(done, (err)=>{
            done();
            // no transcript yet, a slow model: the next lines ask again
            if (!(err && err.pending)) console.warn('[meet] live recap failed:', err && err.message);
        });
        else done();
    } catch (err) {
        done();
        console.warn('[meet] live recap failed:', err && err.message);
    }
    return true;
}
function $06ddbf6a5da715a6$export$45df3b60dc8c3e1c(roomId) {
    const root = this.state && this.state.root;
    if (!root || !roomId) return false;
    const rec = root.__meetLiveRecap && root.__meetLiveRecap[roomId];
    if (!rec || rec.lines <= 0 || rec.busy) return false;
    const mine = [
        root.currentUserSupabaseId,
        root.currentUserId
    ].filter(Boolean).map(String);
    if (!mine.includes(String(this.call('meetLiveRecapAsker', root, roomId) || ''))) return false;
    rec.lines = 0;
    rec.at = Date.now();
    return true;
}
function $06ddbf6a5da715a6$export$2f235ee5d4d56710(root) {
    const r = root && typeof root === 'object' ? root : {};
    const a = r.analysis;
    const roomId = r.activeRoomId;
    if (!a || !roomId || a.room_id && a.room_id !== roomId || a.roomId && a.roomId !== roomId) return null;
    const sug = a.suggestions && typeof a.suggestions === 'object' && a.suggestions || {};
    // the end screen's bucket order and words (meetUtils.js SUGGESTION_BUCKETS)
    const LABELS = {
        calendar_events: 'meet.bucket.calendar',
        tickets: 'meet.bucket.tickets',
        notes: 'meet.bucket.notes',
        knowledge_base: 'meet.bucket.knowledgeBase',
        chat_messages: 'meet.bucket.chat'
    };
    const counts = Object.keys(LABELS).map((b)=>({
            bucket: b,
            label: LABELS[b],
            count: Array.isArray(sug[b]) ? sug[b].length : 0
        })).filter((x)=>x.count > 0);
    return {
        summary: typeof a.summary === 'string' ? a.summary : '',
        counts: counts,
        total: counts.reduce((n, x)=>n + x.count, 0),
        at: a.generated_at || a.generatedAt || null
    };
}

});

parcelRegister("iiSz5", function(module, exports) {

$parcel$export(module.exports, "meetCallSince", () => $d5343be96ad9bf0b$export$efa19aeaf0c6e47a);
$parcel$export(module.exports, "meetCallChangesLoad", () => $d5343be96ad9bf0b$export$b32b89163db56c68);
$parcel$export(module.exports, "meetCallChangesGroup", () => $d5343be96ad9bf0b$export$80ed58697ac8fa1c);
$parcel$export(module.exports, "meetCallChangesTick", () => $d5343be96ad9bf0b$export$81f9c533911819ff);
$parcel$export(module.exports, "meetCallChangesOf", () => $d5343be96ad9bf0b$export$1215dd5591d92fca);
// meetCallChanges.js — WHAT CHANGED IN THE WORKSPACE DURING THE CALL (Nika
// 2026-10-23: "so if I catch events, tasks, some workspace additions, it can
// show up … so it automatically catches the data events - does not need to
// wait for the call end. but also shows on the end screen of the call").
//
// The call's own summary (functions/meetLiveRecap.js) catches what was SAID;
// this catches what was DONE while the call ran — the workspace's activity
// timeline (ActivityEntry: an app's records, CRM, bookings, … `created` /
// `updated`, server activityEntries) since the call began, grouped by the app
// that owns it: "Merchants · 2 added · 1 updated", a press opens the app. A
// collection no installed app claims is its own group, named for the
// collection ("tc_tasks" → "Tasks"), with nothing to open. The timeline carries
// no titles, so a group is its app (or collection) and its record counts.
//
// Read at most once a minute while the call runs (MeetCallChanges' tick, on
// the shell's 30 s tick) and once more at Leave, so the end screen has it.
// ONE root key, `_callChanges` { roomId, since, at, groups: [{ key, label,
// appKey, route, added, updated }] }; the reading's own bookkeeping lives on
// the root under a double-underscore key (never state).
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
function $d5343be96ad9bf0b$export$efa19aeaf0c6e47a(root, roomId) {
    const r = root && typeof root === 'object' ? root : {};
    const now = Date.now();
    const room = (Array.isArray(r.rooms) ? r.rooms : []).find((x)=>x && x.id === roomId);
    const born = room ? Date.parse(room.createdAt || '') || 0 : 0;
    if (born && now - born < 21600000) return born;
    const joined = (r.liveParticipants && r.liveParticipants[roomId] || []).map((p)=>Date.parse(p && p.joinedAt || '') || 0).filter((t)=>t > 0);
    if (joined.length) return Math.min(...joined);
    const rec = r.__meetLiveRecap && r.__meetLiveRecap[roomId];
    if (rec && rec.firstAt) return rec.firstAt;
    return now - 3600000;
}
async function $d5343be96ad9bf0b$export$b32b89163db56c68(roomId) {
    const root = this.state && this.state.root;
    if (!root || !roomId || typeof root.update !== 'function') return null;
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    if (!workspaceId) return null;
    const memo = root.__meetCallChanges = root.__meetCallChanges || {};
    if (memo.busy) return null;
    memo.busy = true;
    memo.at = Date.now();
    try {
        const since = this.call('meetCallSince', root, roomId);
        const sdk = this.sdk && typeof this.sdk.getService === 'function' ? this.sdk : (0, $1NxyO.getSDK)();
        const svc = await sdk.getService('activityEntries');
        const res = svc && typeof svc.list === 'function' ? await svc.list({
            since: new Date(since).toISOString(),
            limit: 100,
            workspaceId: workspaceId
        }) : null;
        const rows = Array.isArray(res) ? res : res && (res.data || res.rows || res.entries || res.items) || [];
        const groups = this.call('meetCallChangesGroup', root, rows);
        root.update({
            _callChanges: {
                roomId: roomId,
                since: since,
                at: Date.now(),
                groups: groups
            }
        }, {
            preventFetch: true
        });
        return groups;
    } catch (err) {
        console.warn('[meet] call changes not read:', err && err.message);
        return null;
    } finally{
        memo.busy = false;
    }
}
function $d5343be96ad9bf0b$export$80ed58697ac8fa1c(root, rows) {
    const r = root && typeof root === 'object' ? root : {};
    const apps = (Array.isArray(r.workspaceApps) ? r.workspaceApps : []).map((a)=>a && typeof a.parse === 'function' ? a.parse() : a).filter((a)=>a && typeof a === 'object');
    const keyOf = (v)=>String(v == null ? '' : v).trim().toLowerCase();
    // a navbar item carries its route as `route` or `path`
    const navRoute = (n)=>String(n && (n.route || n.path) || '').split('?')[0];
    const mentions = {};
    const byCollection = (key)=>{
        const routed = apps.find((a)=>Array.isArray(a.recordRoutes) && a.recordRoutes.some((rr)=>rr && keyOf(rr.key) === key));
        if (routed) return routed;
        if (mentions[key] === undefined) {
            const named = apps.filter((a)=>{
                try {
                    return JSON.stringify(a).includes('"' + key + '"');
                } catch (_) {
                    return false;
                }
            });
            mentions[key] = named.length === 1 ? named[0] : null;
        }
        return mentions[key];
    };
    const byRoute = (route)=>apps.find((a)=>Array.isArray(a.navbar) && a.navbar.some((n)=>navRoute(n) === route)) || null;
    // "tc_tasks" → "Tasks", "kz_merchants" → "Merchants", "leads" → "Leads"
    const collectionName = (key)=>{
        const parts = key.split(/[_-]+/).filter(Boolean);
        const words = parts.length > 1 && parts[0].length <= 3 ? parts.slice(1) : parts;
        return words.map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    };
    // WHO made it (Nika 2026-10-23: "it shows me 'Changed during the call' but
    // does not show me what" — the automations account's heartbeat, made by no
    // one in the call, read as the call's own change). A row names its actor:
    // only a call member's change counts (an agent acting for one carries that
    // member's e-mail); a background account or a system write is not the
    // call's. A row with no actor (older entries) still counts.
    const members = {};
    const addMember = (v)=>{
        const k = keyOf(v);
        if (k.includes('@')) members[k] = true;
    };
    addMember(r.currentUserEmail);
    for (const p of Array.isArray(r.livekitParticipants) ? r.livekitParticipants : [])addMember(p && (p.email || p.name));
    for (const u of Array.isArray(r.utterances) ? r.utterances : [])if (u && u.roomId === r.activeRoomId) addMember(u.speakerEmail);
    const hasMembers = Object.keys(members).length > 0;
    // A member by name (the people list), else the address's local part — a
    // non-manager sees no peer e-mail there.
    const memberName = (email)=>{
        const p = (Array.isArray(r.people) ? r.people : []).find((x)=>x && keyOf(x.email) === email);
        return p && p.name || email.split('@')[0];
    };
    // "lastRunAt" → "Last run at", "tc_status" → "Tc status"
    const fieldLabel = (key)=>String(key).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[_-]+/g, ' ').toLowerCase().replace(/^./, (c)=>c.toUpperCase());
    const groups = [];
    const seen = {};
    const at = {};
    for (const row of Array.isArray(rows) ? rows : []){
        if (!row || typeof row !== 'object') continue;
        const ev = String(row.eventType || '');
        if (ev !== 'created' && ev !== 'updated') continue;
        const actor = row.actor && typeof row.actor === 'object' ? row.actor : null;
        const actorEmail = keyOf(actor && actor.userEmail || row.createdByEmail || '');
        if (actor && (actor.system === true || hasMembers && !members[actorEmail])) continue;
        const type = String(row.entityRef && row.entityRef.type || '');
        const recordId = String(row.entityRef && row.entityRef.id || row.id || '');
        let app = null;
        let route = '';
        let collection = '';
        if (type.startsWith('record:')) {
            collection = keyOf(type.slice(7));
            if (!collection) continue;
            app = byCollection(collection);
            const rr = app && Array.isArray(app.recordRoutes) && app.recordRoutes.find((x)=>x && keyOf(x.key) === collection && typeof x.route === 'string');
            route = rr && rr.route || '';
        } else if (/^crm/i.test(type)) {
            app = byRoute('/crm');
            route = '/crm';
            if (!app) continue;
        } else continue;
        const nav = app && Array.isArray(app.navbar) ? app.navbar.find((n)=>navRoute(n)) : null;
        const id = app ? String(app.id || app.key || app.appId || route) : 'collection-' + collection;
        if (at[id] === undefined) {
            at[id] = groups.length;
            seen[id] = {
                added: {},
                updated: {},
                who: {},
                fields: {}
            };
            groups.push({
                key: 'changes-' + id.replace(/[^A-Za-z0-9_-]/g, '_'),
                label: app ? String(app.title || app.name || nav && nav.label || collectionName(keyOf(id.split('/').pop()))) : collectionName(collection),
                // The app's RECORD key: the last segment of its `owner/key` id, the
                // key the App Store's copy hangs off — CallChanges.js ChangeApp names
                // the row through storeItemText with it. The whole id folded to a slug
                // no catalogue ships (`systemCommerceApp`), so the row printed the
                // manifest's "Store" where the App Store says "Commerce" (Nika
                // 2026-10-23: "app names = what a person sees in the workspace App
                // Store").
                appKey: app ? String(app.key || app.id || '').split('/').pop() : '',
                route: app ? route || (nav ? navRoute(nav) : '') : '',
                added: 0,
                updated: 0
            });
        }
        const marks = seen[id];
        const mark = recordId || type + ':' + groups[at[id]].added + groups[at[id]].updated;
        if (ev === 'created') {
            marks.added[mark] = true;
            delete marks.updated[mark];
        } else if (!marks.added[mark]) marks.updated[mark] = true;
        const g = groups[at[id]];
        g.added = Object.keys(marks.added).length;
        g.updated = Object.keys(marks.updated).length;
        // WHAT: who changed it and which fields (the entry's own `changed` list).
        if (actorEmail) marks.who[actorEmail] = true;
        const changed = row.payload && Array.isArray(row.payload.changed) ? row.payload.changed : [];
        for (const f of changed)if (typeof f === 'string' && f) marks.fields[f] = true;
        const who = Object.keys(marks.who).map(memberName);
        const fields = Object.keys(marks.fields).slice(0, 4).map(fieldLabel);
        if (who.length) g.who = who;
        if (fields.length) g.fields = fields;
    }
    return groups;
}
function $d5343be96ad9bf0b$export$81f9c533911819ff(el, s) {
    const host = el || this;
    const root = s && s.root || host.state && host.state.root;
    // in a call now (an old call's end screen, opened from the list, reads nothing)
    if (!root || !root.activeRoomId || root.livekitConnected !== true) return false;
    const memo = root.__meetCallChanges || {};
    const cur = root._callChanges;
    const fresh = cur && cur.roomId === root.activeRoomId;
    if (memo.busy || fresh && Date.now() - (memo.at || 0) < 60000) return false;
    host.call('meetCallChangesLoad', root.activeRoomId);
    return true;
}
function $d5343be96ad9bf0b$export$1215dd5591d92fca(root) {
    const r = root && typeof root === 'object' ? root : {};
    const cur = r._callChanges;
    if (!cur || !r.activeRoomId || cur.roomId !== r.activeRoomId) return [];
    return Array.isArray(cur.groups) ? cur.groups : [];
}

});

parcelRegister("fh61z", function(module, exports) {

$parcel$export(module.exports, "analyzeTranscript", () => $b1ed1dd468d3b3f2$export$83038e27eb27b8a3);
// Triggers meet-analyze on a room and returns the analysis row { room_id,
// workspace_id, summary, suggestions, model, generated_at, applied_items? }
// or, when the room has no transcript yet, throws an Error with
// `err.status === 422` and `err.pending === true` so pages/meet.js
// onUpdate can render its existing isPending branch unchanged.
//
// migrated 2026-05-20 — direct Supabase edge-fn fetch replaced with
// `sdk.aiChat.meetAnalyze({ roomId, force })`. The endpoint lives on
// the main server now (Mongo-backed AI surface). Meet_rooms / meet_
// transcripts / meet_transcript_analyses still live in Supabase, but
// the server reads/writes them via the service-role key — UI doesn't
// have to wrangle Supabase auth headers anymore.
//
// 2026-06-02 — swapped the SDK accessor from `aiChat` to the unified
// `ai` namespace. sdk.ai.meetAnalyze is a passthrough that hits the
// same /ai-chat/meet-analyze server route; this keeps every meet/
// tickets/AppAssistant consumer pointed at `sdk.ai.*` for naming
// consistency, even though meet-analyze itself doesn't honor the
// provider-mode picker (the transcript analysis pipeline always
// runs on the server with managed keys).
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
const $b1ed1dd468d3b3f2$export$83038e27eb27b8a3 = async function(roomId, force = false) {
    const ai = await (0, $1NxyO.getSDK)().getService('ai');
    let result;
    try {
        result = await ai.meetAnalyze({
            roomId: roomId,
            force: force
        });
    } catch (err) {
        const status = err?.status || 500;
        const reason = err?.message || (status === 422 ? 'no transcript available yet' : status === 403 ? 'not allowed to read this room' : status === 401 ? "session expired \u2014 please sign in again" : `status ${status}`);
        const e = new Error(reason);
        e.status = status;
        if (status === 422) e.pending = true;
        throw e;
    }
    // Unwrap the SDK's `{ data: row }` envelope — sdk.ai.meetAnalyze wraps
    // the analysis row, but every consumer (TranscriptPage Summary panel,
    // root.analysis readers) expects the BARE row. Without this a freshly
    // generated analysis landed as { data: {...} }, `analysis.summary` read
    // undefined, and the panel stayed on "No analysis yet." even though the
    // server wrote the row (found live 2026-06-12 — the summary appeared
    // only after a reload re-fetched the row through the unwrapping path).
    if (result && result.data !== undefined && result.summary === undefined) result = result.data;
    // Server may return { pending: true, reason: 'no_transcript' } on a
    // fresh room with no transcript yet (200-status, matches legacy edge
    // fn shape). Convert to the Error+status:422 form the page expects.
    if (result?.pending) {
        const reason = result.reason === 'no_transcript' ? 'no transcript available yet' : result.reason || 'analysis pending';
        const e = new Error(reason);
        e.status = 422;
        e.pending = true;
        throw e;
    }
    return result;
};

});

parcelRegister("jzcmH", function(module, exports) {

$parcel$export(module.exports, "markSuggestionApplied", () => $e3eae0a81add1323$export$5835272e445e26f);
// markSuggestionApplied — record that a suggestion was applied without
// calling the creation function. Used by NewTicketModal / NewBookingModal
// after the user saves a pre-filled suggestion through the native modal.
// Shares the fingerprint + applied_items logic with applySuggestion.js but
// skips the actual creation step.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $lCXAE = parcelRequire("lCXAE");
const $e3eae0a81add1323$export$5835272e445e26f = async function(bucket, item, targetId) {
    const root = this.state.root;
    if (!bucket || !item || !targetId) return;
    // Only write if the analysis row exists — otherwise there's no DB row to
    // patch. This can happen if the user opens a suggestion modal while still
    // loading the transcript page.
    if (!root.analysis || !root.activeRoomId) return;
    try {
        const fingerprint = await (0, $lCXAE.fingerprintSuggestion)(item);
        const current = root.analysis?.applied_items || [];
        const pruned = await (0, $lCXAE.pruneStaleApplied)(current, root.analysis?.suggestions);
        // Skip if already marked (e.g. double-save race)
        if (pruned.some((e)=>e.fingerprint === fingerprint)) return;
        const next = [
            ...pruned,
            {
                bucket: bucket,
                fingerprint: fingerprint,
                target_id: String(targetId),
                applied_at: new Date().toISOString()
            }
        ];
        // migrated 2026-04-27 to SDK route workspaceProject.meet.analysisAppliedItems
        try {
            await (0, $1NxyO.getSDK)().execute('workspaceProject.meet.analysisAppliedItems', 'update', {
                roomId: root.activeRoomId,
                payload: {
                    applied_items: next
                }
            });
            root.update({
                analysis: {
                    ...root.analysis,
                    applied_items: next
                }
            });
        } catch (err) {
            console.warn('[markSuggestionApplied] write failed', err?.message || err);
        }
    } catch (err) {
        console.warn('[markSuggestionApplied] skipped', err);
    }
};

});

parcelRegister("crFNF", function(module, exports) {

$parcel$export(module.exports, "meetAiViews", () => $90f86e41d08203cb$export$fbd1d7b711d54e4d);
$parcel$export(module.exports, "meetRoomsAnswerLoad", () => $90f86e41d08203cb$export$a91b9166b2df1c27);
$parcel$export(module.exports, "meetRoomsAnswerModel", () => $90f86e41d08203cb$export$f225cb26a29bc576);
$parcel$export(module.exports, "meetTranscriptAnswerLoad", () => $90f86e41d08203cb$export$e4da13a666d9ec30);
$parcel$export(module.exports, "meetTranscriptAnswerModel", () => $90f86e41d08203cb$export$36619c7971a21ec6);
$parcel$export(module.exports, "meetAnswerOpen", () => $90f86e41d08203cb$export$4f829bd642de90ec);
// THE CALLS IN AN AI ANSWER — the `meet-rooms` and `meet-transcript` views
// the assistant mounts in its thread and a Fly page places as a section
// (workspace functions/assistantAppViews.js, the `views[]` contract).
//
// meetAiViews() is the PROVIDER, read from the meet EAGER slice; the views'
// components ride the lazy meet context (`fold: 'meet'` — the shell folds it
// through ensureMeetContext before a card mounts). Two views, both in the
// shell's list frame (workspace components/AssistantViewList.js):
//
//   meet-rooms       the workspace's calls: live now (a member in it — the
//                    same presence the header's ongoing-call badge reads),
//                    upcoming (a room scheduled for a calendar event still
//                    ahead) and recent; a row opens the room on /meet
//   meet-transcript  one call's transcript and its summary — the named call,
//                    else the most recent call that has a transcript
//
// OPENING A CALL IS NEVER A JOIN (MEET-AUTOJOIN-1): a row opens the room's
// detail pane or its transcript (`/meet#room=<id>`, the page's own guarded
// deep link); only that pane's Join starts media. The reads are the meet
// page's own (workspaceProject.meet.rooms, .transcriptView), into each view's
// OWN state — never root.rooms or root.utterances. Nothing here writes data.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $90f86e41d08203cb$export$fbd1d7b711d54e4d() {
    return {
        app: {
            id: 'system/meet',
            navbar: [
                {
                    label: 'shell.app.meet',
                    route: '/meet',
                    icon: 'video'
                }
            ],
            apps: [
                {
                    icon: 'video'
                }
            ]
        },
        fold: 'meet',
        views: [
            {
                id: 'meet-rooms',
                title: 'meet.answer.rooms.title',
                describe: "The workspace's video calls: live now, upcoming (scheduled for a calendar event) and recent; show narrows it; search = words in the call name.",
                component: 'MeetRoomsAnswerView',
                icon: 'video',
                hue: 'green',
                size: 'l',
                params: {
                    show: {
                        type: 'enum',
                        values: [
                            'all',
                            'live',
                            'upcoming',
                            'recent'
                        ],
                        labels: {
                            all: 'meet.answer.show.all',
                            live: 'meet.roomList.live',
                            upcoming: 'meet.answer.show.upcoming',
                            recent: 'meet.answer.show.recent'
                        },
                        default: 'all'
                    },
                    search: {
                        type: 'string',
                        describe: 'words in the call name'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 30,
                        default: 10
                    }
                },
                link: {
                    route: '/meet',
                    query: {}
                },
                access: {
                    route: '/meet'
                }
            },
            {
                id: 'meet-transcript',
                title: 'meet.transcript.heading',
                describe: "One call's transcript and its summary; room = words in the call name, empty = the most recent call that has a transcript (the last call).",
                component: 'MeetTranscriptAnswerView',
                icon: 'video',
                hue: 'green',
                size: 'l',
                params: {
                    room: {
                        type: 'string',
                        describe: 'words in the call name; empty = the last call with a transcript'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 200,
                        default: 40
                    }
                },
                link: {
                    route: '/meet',
                    query: {}
                },
                access: {
                    route: '/meet'
                }
            }
        ]
    };
}
async function $90f86e41d08203cb$export$a91b9166b2df1c27(el) {
    const host = el || this;
    const sdk = host && host.sdk || host.call('getSDK');
    if (!sdk || typeof sdk.execute !== 'function') return {
        data: {
            rooms: []
        },
        failed: true
    };
    try {
        const res = await sdk.execute('workspaceProject.meet.rooms', 'list');
        const rows = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
        return {
            data: {
                rooms: rows.filter((r)=>r && r.id).map((r)=>host.call('rowToRoom', r))
            }
        };
    } catch (_) {
        return {
            data: {
                rooms: []
            },
            failed: true
        };
    }
}
function $90f86e41d08203cb$export$f225cb26a29bc576(data, params, failed) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const p = params && typeof params === 'object' ? params : {};
    const say = (key)=>String(el.call('polyglot', key));
    if (failed) return {
        groups: [],
        note: 'meet.answer.failed'
    };
    const show = [
        'all',
        'live',
        'upcoming',
        'recent'
    ].includes(p.show) ? p.show : 'all';
    const limit = Math.max(1, Math.min(30, Math.floor(Number(p.limit)) || 10));
    const words = String(p.search || '').toLowerCase().split(/\s+/).filter(Boolean);
    const nameOf = (r)=>say(r.name || 'meet.roomList.untitled');
    const rooms = (Array.isArray(d.rooms) ? d.rooms : []).filter((r)=>r && r.id && words.every((w)=>nameOf(r).toLowerCase().includes(w)));
    const live = root.liveParticipants && typeof root.liveParticipants === 'object' ? root.liveParticipants : {};
    const inCall = (r)=>(Array.isArray(live[r.id]) ? live[r.id] : []).filter((x)=>x && !x.leftAt);
    const mine = (r)=>!!root.livekitConnected && String(root.activeRoomId || '') === String(r.id);
    const isLive = (r)=>!r.endedAt && (inCall(r).length > 0 || mine(r));
    // A room scheduled for a calendar event: the event's start from the shell's
    // calendar window (root.intranetEvents, every workspace) or the calendar's
    // own (root.events).
    const events = [].concat(Array.isArray(root.intranetEvents) ? root.intranetEvents : []).concat(Array.isArray(root.events) ? root.events : []);
    const startOf = (r)=>{
        if (!r.calendarEventId) return 0;
        const ev = events.find((e)=>e && String(e.id) === String(r.calendarEventId));
        if (!ev) return 0;
        const at = Date.parse(ev.startAt || (ev.date ? ev.date + 'T' + (ev.startTime || '00:00') : ''));
        return Number.isFinite(at) ? at : 0;
    };
    const now = Date.now();
    const at = (r)=>Date.parse(r.endedAt || r.createdAt || '') || 0;
    const liveRooms = rooms.filter(isLive);
    const upcoming = rooms.filter((r)=>!r.endedAt && !isLive(r) && startOf(r) > now).sort((a, b)=>startOf(a) - startOf(b));
    const taken = new Set([
        ...liveRooms,
        ...upcoming
    ].map((r)=>r.id));
    const recent = rooms.filter((r)=>!taken.has(r.id)).sort((a, b)=>at(b) - at(a));
    const day = (ms, withTime)=>String(el.call('localizedDate', new Date(ms), withTime ? {
            weekday: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        } : {
            month: 'short',
            day: 'numeric'
        }) || '');
    const open = (r)=>({
            call: 'meetAnswerOpen',
            arg: {
                id: String(r.id),
                view: 'room'
            }
        });
    const key = (r)=>'m-' + String(r.id).replace(/[^a-zA-Z0-9_-]/g, '');
    const liveRow = (r)=>{
        const n = inCall(r).length;
        return el.call('assistantViewRow', {
            key: key(r),
            title: nameOf(r),
            meta: n > 1 ? say('meet.roomList.people').replace('{count}', String(n)) : n === 1 ? say('meet.roomList.onePerson') : say('meet.roomList.live'),
            mark: true,
            open: open(r)
        });
    };
    const upcomingRow = (r)=>el.call('assistantViewRow', {
            key: key(r),
            title: nameOf(r),
            meta: day(startOf(r), true),
            icon: 'date',
            open: open(r)
        });
    const recentRow = (r)=>el.call('assistantViewRow', {
            key: key(r),
            title: nameOf(r),
            meta: at(r) ? day(at(r), false) : '',
            icon: 'video',
            open: open(r)
        });
    const groups = [];
    let budget = limit;
    let shown = 0;
    let total = 0;
    const put = (gkey, labelKey, list, toRow)=>{
        total += list.length;
        const rows = list.slice(0, Math.max(0, budget)).map(toRow);
        budget -= rows.length;
        shown += rows.length;
        if (rows.length) groups.push(el.call('assistantViewGroup', {
            key: gkey,
            label: say(labelKey),
            rows: rows
        }));
    };
    if (show === 'all' || show === 'live') put('live', 'meet.answer.group.live', liveRooms, liveRow);
    if (show === 'all' || show === 'upcoming') put('upcoming', 'meet.answer.group.upcoming', upcoming, upcomingRow);
    if (show === 'all' || show === 'recent') put('recent', 'meet.answer.group.recent', recent, recentRow);
    return {
        groups: groups,
        note: groups.length ? '' : 'meet.answer.empty',
        more: {
            shown: shown,
            total: total
        }
    };
}
async function $90f86e41d08203cb$export$e4da13a666d9ec30(el, params) {
    const host = el || this;
    const p = params && typeof params === 'object' ? params : {};
    const sdk = host && host.sdk || host.call('getSDK');
    const none = (named, failed)=>({
            data: {
                room: null,
                utterances: [],
                summary: '',
                named: named
            },
            failed: failed
        });
    if (!sdk || typeof sdk.execute !== 'function') return none(false, true);
    let rooms = [];
    try {
        const res = await sdk.execute('workspaceProject.meet.rooms', 'list');
        const rows = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
        rooms = rows.filter((r)=>r && r.id).map((r)=>host.call('rowToRoom', r));
    } catch (_) {
        return none(false, true);
    }
    const ask = String(p.room || '').trim();
    const words = ask.toLowerCase().split(/\s+/).filter(Boolean);
    const nameOf = (r)=>String(host.call('polyglot', r.name || 'meet.roomList.untitled')).toLowerCase();
    const at = (r)=>Date.parse(r.endedAt || r.createdAt || '') || 0;
    let candidates = rooms;
    if (words.length) {
        const byId = rooms.filter((r)=>String(r.id) === ask);
        candidates = byId.length ? byId : rooms.filter((r)=>words.every((w)=>nameOf(r).includes(w)));
        if (!candidates.length) return none(true, false);
    }
    const ordered = candidates.slice().sort((a, b)=>Number(!!b.transcribeEnabled) - Number(!!a.transcribeEnabled) || at(b) - at(a)).slice(0, 4);
    const reads = await Promise.all(ordered.map((room)=>Promise.resolve().then(()=>sdk.execute('workspaceProject.meet.transcriptView', 'rpc', {
                roomId: room.id
            })).then((view)=>{
            const raw = view && Array.isArray(view.utterances) ? view.utterances : [];
            const utterances = host.call('dedupeUtterances', raw.map((r)=>host.call('rowToUtterance', r)));
            const analysis = view && view.analysis;
            const summary = analysis && typeof analysis.summary === 'string' ? analysis.summary : '';
            const last = utterances.length ? Date.parse(utterances[utterances.length - 1].startedAt || '') || at(room) : 0;
            return {
                room: room,
                utterances: Array.isArray(utterances) ? utterances : [],
                summary: summary,
                last: last
            };
        }).catch(()=>null)));
    const ok = reads.filter(Boolean);
    if (!ok.length) return none(words.length > 0, true);
    const withLines = ok.filter((r)=>r.utterances.length || r.summary);
    // A named call answers even with no line yet (its own sentence says so).
    const pick = (withLines.length ? withLines : words.length ? ok : []).sort((a, b)=>b.last - a.last || at(b.room) - at(a.room))[0];
    if (!pick) return none(false, false);
    return {
        data: {
            room: pick.room,
            utterances: pick.utterances,
            summary: pick.summary,
            named: words.length > 0
        }
    };
}
function $90f86e41d08203cb$export$36619c7971a21ec6(data, params, failed) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const p = params && typeof params === 'object' ? params : {};
    const say = (key)=>String(el.call('polyglot', key));
    const room = d.room;
    if (!room) return {
        groups: [],
        note: failed ? 'meet.answer.transcript.failed' : d.named ? 'meet.answer.empty' : 'meet.answer.transcript.none'
    };
    const limit = Math.max(1, Math.min(200, Math.floor(Number(p.limit)) || 40));
    const all = (Array.isArray(d.utterances) ? d.utterances : []).filter((u)=>u && String(u.text || '').trim());
    // A standing room keeps every call it ever held: the LAST call is the run
    // of lines after the last silence longer than two hours.
    let start = 0;
    for(let i = 1; i < all.length; i++){
        const prev = Date.parse(all[i - 1].startedAt || '') || 0;
        const cur = Date.parse(all[i].startedAt || '') || 0;
        if (prev && cur && cur - prev > 7200000) start = i;
    }
    const lines = all.slice(start);
    const time = (iso)=>{
        const ms = Date.parse(iso || '');
        return Number.isFinite(ms) ? String(el.call('localizedDate', new Date(ms), {
            hour: '2-digit',
            minute: '2-digit'
        }) || '') : '';
    };
    const open = {
        call: 'meetAnswerOpen',
        arg: {
            id: String(room.id),
            view: 'transcript'
        }
    };
    const rows = lines.slice(0, limit).map((u, i)=>{
        const who = say(el.call('speakerDisplayName', root, u.speakerEmail, u.userId));
        return el.call('assistantViewRow', {
            key: 'u-' + String(u.id || i).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: String(u.text).trim(),
            meta: [
                who,
                time(u.startedAt)
            ].filter(Boolean).join(" \xb7 "),
            initials: el.call('initials', who) || null,
            open: open
        });
    });
    const dayMs = Date.parse(lines[0] && lines[0].startedAt || room.endedAt || room.createdAt || '');
    const dayLabel = Number.isFinite(dayMs) ? String(el.call('localizedDate', new Date(dayMs), {
        month: 'short',
        day: 'numeric'
    }) || '') : '';
    const label = [
        say(room.name || 'meet.roomList.untitled'),
        dayLabel
    ].filter(Boolean).join(" \xb7 ");
    const groups = rows.length ? [
        el.call('assistantViewGroup', {
            key: 'lines',
            label: label,
            rows: rows
        })
    ] : [];
    return {
        lead: d.summary || '',
        groups: groups,
        note: groups.length || d.summary ? '' : 'meet.transcript.empty',
        more: {
            shown: rows.length,
            total: lines.length
        }
    };
}
function $90f86e41d08203cb$export$4f829bd642de90ec(target) {
    const el = this;
    const t = target && typeof target === 'object' ? target : {
        id: target
    };
    const id = t.id == null ? '' : String(t.id);
    if (!id || !el || typeof el.router !== 'function') return false;
    const transcript = t.view === 'transcript';
    const root = el.state && el.state.root;
    const here = String(el.call('stripWorkspacePrefix', String(el.call('readPageRoute') || '')) || '');
    if (root && typeof root.update === 'function' && /^\/meet(\/|$)/.test(here)) {
        const patch = {
            activeRoomId: id,
            meetView: transcript ? 'transcript' : 'list'
        };
        if (String(root.activeRoomId || '') !== id) {
            patch.transcriptLoaded = false;
            patch.analysis = undefined;
            patch.analyzeError = null;
            patch.transcriptPending = false;
            patch._meetAnalyzeInFlight = false;
        }
        root.update(patch);
    }
    el.router('/meet#room=' + encodeURIComponent(id) + (transcript ? '&view=transcript' : ''), el.getRoot());
    return true;
}

});


parcelRegister("eqhiY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a800ead70de7ab55$export$2e2bcd8739ae039);
// Analytics root state.
//   /analytics                    — project / site visitor dashboard
//   /workspace-analytics          — workspace "What's now" dashboard
//   /workspace-analytics/map      — full-screen world map
//   /workspace-analytics/logs/*   — Users / Sessions / Events / Bugs / Network / Verbose tables
//   /workspace-analytics/logs/sessions/:id — session detail
//
// All keys are top-level (smbls v3.14 schema check accepts root.update on
// declared keys); underscore prefixes are framework-internal flags.
var $a800ead70de7ab55$export$2e2bcd8739ae039 = {
    // ── /analytics (+ /analytics/map) ──────────────────────────────────
    _analyticsSessions: null,
    _analyticsActiveUsers: null,
    _analytics: null,
    _analyticsExpanded: null,
    _analyticsMapMode: 'sessions',
    _mapHoveredCountry: null,
    _analyticsInterval: '7d',
    _analyticsServerSource: null,
    _analyticsSampleSize: 0,
    // Re-render signal fired by the async world-atlas loader (map +
    // demographics silhouettes). Was written by both consumers but never
    // DECLARED, so smbls dropped the update and the silhouettes stayed
    // blank until an unrelated state tick — declaring it is the fix.
    _worldAtlasTick: 0,
    // ── /workspace-analytics (workspace usage dashboard) ───────────────
    // Analyzed-chain cards, scoped to the shell's own telemetry
    // (projectId 'workspace'): day-by-day team activity, top bug
    // clusters, and the open-tasks count from tickets.columnCounts.
    _wsaWeekly: null,
    _wsaBugs: null,
    _wsaOpenTasks: null,
    // Active-now roster from the analyzed chain (activeUsers scoped to the
    // shell's own telemetry) — the workspace half of the surface division:
    // "who's active" for TEAM members lives here, not on /analytics.
    _wsaActive: null,
    // HEALTH-FALSE-OK-1 / FALSE-ZERO-1 (tickets/opus.md) — load FAILURES for
    // the two feeds whose emptiness is user-facing prose. Each `_wsa*` feed
    // above is null until its fetch resolves, so null alone cannot tell
    // "still loading" from "the request threw" — and every fetch used to
    // `.catch` into a bare console.warn, leaving the key null forever while
    // the card printed "No errors in the last 7 days" over 139,491 real
    // errors. DECLARED here on purpose: an undeclared key has its update
    // dropped (the `_worldAtlasTick` lesson at the top of this file), which
    // would silently restore the false all-clear.
    _wsaBugsError: null,
    _wsaActiveError: null,
    // Workspace-family `totals` (7 days, projectId 'workspace') — the extra
    // KPI tiles (sessions / page views / events / bugs / avg session) on
    // /workspace-analytics. Same positive-read rule as the two feeds above.
    _wsaTotals: null,
    _wsaTotalsError: null,
    // Per-project scope for the /analytics (project) dashboard.
    //   _analyticsParams      — { owner, key } handed in by the studio
    //                           Analytics button; consumed once to seed the
    //                           selector, then cleared.
    //   _analyticsProjectKey  — the project-selector's current choice
    //                           ('' = All projects). null until first set so
    //                           the seed-from-params step can run.
    _analyticsParams: null,
    _analyticsProjectKey: null,
    // ── Overall totals + expanded gatherings (WS-ANALYTICS-FAMILY-SPLIT-UTC-
    // TOTALS-1) — the three NEW /core/analyzed reads (`totals`, `pages`,
    // `referrers`) the projects overview fetches beside the six rollups.
    //   _analyticsTotals       — the `totals` payload for the selected interval
    //                            (sessions / uniqueVisitors / pageViews / bugs /
    //                            avgDurationMs / countries / allTime); null until
    //                            positively read.
    //   _analyticsTotalsError  — the read FAILED (old server: unknown op / 404).
    //                            Same rule as `_wsaBugsError`: only a positively
    //                            read feed may print a zero.
    //   _analyticsPages        — top paths [{ path, views, sessions }] or null
    //                            (pending / unavailable — the card hides).
    //   _analyticsReferrers    — { rows: [{ host, sessions }], direct } or null.
    //   _analyticsRollupTz     — the zone the `now` response's hour-of-day
    //                            buckets are in (its `tz` field; we always ask
    //                            for the viewer's zone). null when the server
    //                            sent no `tz` → the slots use UTC hours. It
    //                            drives bucketing only and is never printed.
    _analyticsTotals: null,
    _analyticsTotalsError: null,
    _analyticsPages: null,
    _analyticsReferrers: null,
    _analyticsRollupTz: null,
    // ── UTM campaign attribution (WS-ANALYTICS-UTM-CAMPAIGNS-UI-1, Nika
    // 2026-09-14: "track analytics based on referral") — the `campaigns`
    // read (`sdk.execute('analyzed', 'campaigns', { filter: { ...scope,
    // since, groupBy }, options: { limit } })`) the projects overview fetches
    // beside pages / referrers.
    //   _analyticsCampaigns        — { groupBy, direct, rows: [{ key, source,
    //                                medium, campaign, sessions, uniqueVisitors,
    //                                pageViews, bugs }] } | null (pending /
    //                                unavailable). Only a positively read feed
    //                                may print a number — same rule as totals.
    //   _analyticsCampaignsError   — string | null: the read FAILED (published
    //                                SDK: unknown op; old server: 404). The
    //                                card says so instead of faking zeros.
    //   _analyticsCampaignsGroupBy — the card's group-by pill: 'campaign' |
    //                                'source' | 'medium' | 'content' | 'term'.
    //                                Joins the dashboard cache key.
    _analyticsCampaigns: null,
    _analyticsCampaignsError: null,
    _analyticsCampaignsGroupBy: 'campaign',
    // ── Last 12 days (Nika 2026-09-14: "one more section that shows last 12
    // days of similar chart") — the `daily` read (`sdk.execute('analyzed',
    // 'daily', { filter: { ...scope, days: 12, tz } })` → { tz, days: [{ date,
    // visitors, sessions, pageViews }] }) beside the other rollups.
    //   _analyticsDaily       — { tz, days } | null (pending / unavailable)
    //   _analyticsDailyError  — string | null (published SDK: unknown op; old
    //                           server: 404 → "Daily history needs the new
    //                           analytics server"). A positively read empty
    //                           response is 12 honest zero bars.
    _analyticsDaily: null,
    _analyticsDailyError: null,
    // ── /analytics/logs (rewritten 2026-05-23; sections split 2026-08-08) ──
    // One state slot per section's row buffer. Each page's onCreate
    // populates its own slot via el.call('loadLogsX'); the table reads
    // it via childrenAs:'state'. Events / Network / Verbose used to share
    // one slot, which rendered the previous section's rows through the
    // next section's projection on every switch — now one slot each.
    logsUsers: [],
    logsSessions: [],
    logsEvents: [],
    logsNetwork: [],
    logsVerbose: [],
    logsBugs: [],
    // Session detail. Inside the home PageSlot the URL never changes, so
    // the drill-through target rides state (`_logsSessionId`) and the
    // fixed-path /analytics/logs/session route reads it; the real
    // /analytics/logs/sessions/:id URL keeps working via the path param.
    _logsSessionId: null,
    logsSessionDetail: null,
    logsSessionEvents: [],
    // Drill-through filters for the sessions section — the map's country
    // click sets `_logsCountry`, a users-row click sets `_logsUser`; the
    // sessions page reads both into its fetch filter and shows clearable
    // chips.
    _logsCountry: null,
    _logsUser: null,
    // UTM drill-through filters for the PROJECTS sessions list (a campaigns
    // card row click sets the one its group-by names; the sessions page
    // forwards all three to `listSessions` and shows a clearable chip each).
    // Exact, lowercase source/medium; `__none__` on source = sessions with no
    // utmSource. Declared here on purpose: an undeclared key's update is
    // dropped (the `_worldAtlasTick` lesson above).
    _logsUtmSource: null,
    _logsUtmMedium: null,
    _logsUtmCampaign: null,
    // Visitor drill-through (sessions + unique visitors, Nika 2026-09-14): a
    // visitors-row click / the session detail's Visitor chip sets the durable
    // first-party `visitorId`; the sessions list forwards it to `listSessions`
    // and shows a clearable "Visitor: 3f2a…" chip.
    _logsVisitor: null,
    // Expand/collapse — one row open at a time across whichever table
    // the user is currently looking at.
    logsExpandedRowId: null,
    // Loading + error are shared across sections (only one section is
    // visible at a time, so a single slot is enough).
    logsLoading: false,
    logsError: null,
    // Pagination — pages start with a smaller fetch (30 rows) so first
    // paint over the wire is fast; the LoadMore button bumps in 30-row
    // increments. Cap is 300 to avoid runaway memory + localStorage
    // payloads.
    logsLimit: 30
};

});

parcelRegister("42Wiq", function(module, exports) {
// Eager slim slice of the canvas component barrel (#15).
//
// The full `./index.js` barrel `export *`s the heavy canvas editor
// (CanvasEditor, CanvasV2CodeEditor/Monaco, embed/*, CanvasOverlayV2, …) —
// ~800KB that the unified shell dragged into its EAGER chunk via
// `import * from '../canvas/components/index.js'` in workspace/context.js.
//
// Canvas is also a lazy sub-app: canvas/context.js re-registers the FULL
// barrels, but only on canvas-MANIFEST routes (/studio, /dashboard, /profile,
// /:owner/:project). The canvas-kind NON-manifest routes (/team-and-agents,
// /agents, /tickets, /files, /infra), `/`, and the shell-root chrome never load
// canvas/context.js — so every canvas component key they reference must live in
// THIS eager slice.
//
// canvas/package.json has no `sideEffects: false`, so a re-export through
// `./index.js` would NOT tree-shake (referencing it evaluates every sibling
// source file). Each key below is therefore `export *`-ed from its SOURCE file
// directly, so only these light modules ride the eager chunk.
//
//   PageSlot                                         → PageSlot.js
//   SettingsModalBody                                → SettingsModal.js
//   CanvasConnection                                 → CanvasConnection.js
//   MCPConnectorPickerBody, TransportModeBtn, AuthModeBtn → MCPConnectorPickerOverlay.js
//   CanvasPromptTextarea                             → CanvasPromptTextarea.js
//   NewProjectPickerBody, NpTemplateCard             → NewProjectPicker.js
//   ProjectCanvasSidebar, ProjectCanvasFilterRow, …  → ProjectCanvasSidebar.js
//   TeamPersonNode, TeamAgentNode, TeamMemberModal,
//   AgentModal, AgentPermChip, AgentToolRow,
//   AgentAssigneeRow, AgentAssignChip, teamAndAgents → ../pages/team-and-agents.js

var $lTIFc = parcelRequire("lTIFc");

var $aSQTk = parcelRequire("aSQTk");

var $8exyG = parcelRequire("8exyG");

var $7OV1J = parcelRequire("7OV1J");

var $3Tgki = parcelRequire("3Tgki");

var $eSU6Y = parcelRequire("eSU6Y");

var $fhjkT = parcelRequire("fhjkT");

var $gzEr5 = parcelRequire("gzEr5");

var $7gJQ9 = parcelRequire("7gJQ9");

var $domE9 = parcelRequire("domE9");

var $bgOfo = parcelRequire("bgOfo");

var $1E8ax = parcelRequire("1E8ax");

var $eAUrL = parcelRequire("eAUrL");
$parcel$exportWildcard(module.exports, $lTIFc);
$parcel$exportWildcard(module.exports, $aSQTk);
$parcel$exportWildcard(module.exports, $8exyG);
$parcel$exportWildcard(module.exports, $7OV1J);
$parcel$exportWildcard(module.exports, $3Tgki);
$parcel$exportWildcard(module.exports, $eSU6Y);
$parcel$exportWildcard(module.exports, $fhjkT);
$parcel$exportWildcard(module.exports, $gzEr5);
$parcel$exportWildcard(module.exports, $7gJQ9);
$parcel$exportWildcard(module.exports, $domE9);
$parcel$exportWildcard(module.exports, $bgOfo);
$parcel$exportWildcard(module.exports, $1E8ax);
$parcel$exportWildcard(module.exports, $eAUrL);

});
parcelRegister("lTIFc", function(module, exports) {

$parcel$export(module.exports, "_markLiveHost", () => $ff11614ac4f941af$export$b477d10b16ad642f);
$parcel$export(module.exports, "_recordChange", () => $ff11614ac4f941af$export$11bc6e9a1e6d1c31);
$parcel$export(module.exports, "__hostDefForTests", () => $ff11614ac4f941af$export$3f338b78b922a25f);
$parcel$export(module.exports, "__familyHostDefForTests", () => $ff11614ac4f941af$export$ccb8762ae81200ed);
$parcel$export(module.exports, "_moduleKeepPlan", () => $ff11614ac4f941af$export$ed901a0f69cc2c1b);
$parcel$export(module.exports, "_hostPinned", () => $ff11614ac4f941af$export$3758873fd92da5b0);
$parcel$export(module.exports, "_planWithPins", () => $ff11614ac4f941af$export$978d1e4106f714d3);
$parcel$export(module.exports, "_confirmDiscardParked", () => $ff11614ac4f941af$export$4317de27f882b76e);
$parcel$export(module.exports, "_slotUrlNext", () => $ff11614ac4f941af$export$9365b0c7c952745f);
$parcel$export(module.exports, "_writeSlotUrl", () => $ff11614ac4f941af$export$37c9ecc617dfacb6);
$parcel$export(module.exports, "_syncSlotFromUrl", () => $ff11614ac4f941af$export$91a98ef76979ad4);
$parcel$export(module.exports, "__sheetMotionForTests", () => $ff11614ac4f941af$export$17eaef7c1803f802);
$parcel$export(module.exports, "__sidebarMotionForTests", () => $ff11614ac4f941af$export$22979c751afca01);
$parcel$export(module.exports, "PageSlotBackdrop", () => $ff11614ac4f941af$export$e3a027b15aa1ba11);
$parcel$export(module.exports, "PageSkeleton", () => $ff11614ac4f941af$export$6d7d475dd49a348);
$parcel$export(module.exports, "PageSlot", () => $ff11614ac4f941af$export$9287b8cbd399c7e3);
$parcel$export(module.exports, "PageSlotSplitHandle", () => $ff11614ac4f941af$export$5bf65eb33a2d665);
// PageSlot — the shell's single modal layer for opening pages (renamed from
// CanvasPageSlot 2026-07-09 per Nika "use PageSlot for all opening across all
// pages"). Mounted ONCE at the workspace shell root; every surface opens a
// route in it by writing root state — no per-surface variants:
//
//   root._canvasSlot        — the PRIMARY pane's route
//   root._canvasSlotSecond  — the SECOND pane's route (side-by-side split view,
//                             iPad style — 2026-07-12 per Nika)
//   root._slotFullscreen    — edge-to-edge toggle (single-pane only)
//
// ONE geometry for every case (2026-07-12 per Nika "remove edge cases and
// centralize and unify"): a fixed frame above all page chrome, inset X2 left/
// right, and EQUAL live-measured gaps to the navbars — top = --slot-top
// (header-navbar bottom + --nav-gap, ResizeObserver-maintained in app.js) and
// bottom = --slot-bottom (composer top + --nav-gap, same mechanism). The old
// /tickets full-bleed fork is gone.

var $11nI2 = parcelRequire("11nI2");

var $1X0Je = parcelRequire("1X0Je");

var $5ApZL = parcelRequire("5ApZL");

var $bwwwL = parcelRequire("bwwwL");

var $cKTuv = parcelRequire("cKTuv");
const $ff11614ac4f941af$var$canvasStripWorkspacePrefix = (...args)=>(0, $1X0Je.default).functions.stripWorkspacePrefix(...args);
const $ff11614ac4f941af$var$shortSlotTitle = (...args)=>(0, $1X0Je.default).functions.shortSlotTitle(...args);
// Shared title resolution accepts both metadata factories and title
// factories, at every read. Resolving eagerly would freeze the language;
// reading `.metadata.title` directly loses a metadata factory entirely.
const $ff11614ac4f941af$var$canvasFeatureEnabled = (...args)=>(0, $1X0Je.default).functions.featureEnabled(...args);
const $ff11614ac4f941af$var$canvasCleanHref = (...args)=>(0, $1X0Je.default).functions.cleanHref(...args);
const $ff11614ac4f941af$var$hasMinimizedEntry = (...args)=>(0, $1X0Je.default).functions.hasMinimizedEntry(...args);
const $ff11614ac4f941af$var$minimizeEntry = (...args)=>(0, $1X0Je.default).functions.minimizeEntry(...args);
const $ff11614ac4f941af$var$removeMinimizedEntry = (...args)=>(0, $1X0Je.default).functions.removeMinimizedEntry(...args);
const $ff11614ac4f941af$var$writeMinimizedList = (...args)=>(0, $1X0Je.default).functions.writeMinimizedList(...args);
// NOTE: there is deliberately NO per-route override map here anymore (the old
// _CANVAS_SLOT_PAGES = { '/marketplace': marketplace } short-circuit — removed
// tickets/workspace.md "Marketplace PageSlot renders empty content"). It
// bare-mounted canvas/pages/marketplace.js's raw def (`MarketplaceIsland: {}`,
// no `extends`) directly via `el.set`, bypassing the shell's lazy context-fold
// entirely. That was safe back when this component lived inside the CANVAS
// app (canvas/sharedLibraries.js eager-imports the full marketplace context —
// a3e9ab33), but PageSlot moved to the WORKSPACE SHELL root in 94c7b9dd, whose
// own sharedLibraries.js never eager-merges marketplace (only the eager
// install-modal slice does — MarketplaceInstallModal/IntegrationLogo, see
// workspace/context.js). Once `/marketplace` became a properly deferred
// `lazySharedLib` route in workspace/pages/index.js (#16 bundle-slimming),
// `el.context.pages['/marketplace']` started carrying the CORRECT
// context-folding entry — but this override map still won the resolution
// race in `_defFor` below, every time, so that fold never ran: `el.set()`
// mounted `MarketplaceIsland: {}` bare against a context that never learned
// what `MarketplaceIsland` (or any of its children/functions) is → 0
// children, 0 network requests, no marketplace state — exactly the reported
// symptom. Every other lazy sub-app route (/preview, /infra, /documents,
// /files, /chat, /tickets, …) already opens correctly through the plain
// `el.context.pages` fallthrough below with no override — marketplace now
// does too. canvas/pages/marketplace.js itself is untouched and still used
// by canvas's OWN route registry (canvas/pages/index.js), where canvas's
// eager marketplace context makes it resolve correctly on its own.
const $ff11614ac4f941af$var$_defFor = (el, path, root)=>{
    const clean = $ff11614ac4f941af$var$canvasStripWorkspacePrefix($ff11614ac4f941af$var$canvasCleanHref(path));
    if (!clean) return null;
    // Resolution order:
    //   1. root._aiAnswerPages — transient AI answer views (render_answer_ui):
    //      defs the assistant drew live for this session, keyed '/answer/<slug>'.
    //      Session-only by design — never persisted, never in the router registry.
    //   2. root._slotResolve — the resolver the HOME installs (`_appPageFor`:
    //      workspaceProject.pages + the lazy `_APP_WINDOW_PAGES` map, then the
    //      rest of context.pages, so the ?page= URL sync below names every
    //      route this chain mounts). This carries
    //      the home's divergent choices the shared router registry lacks. Absent
    //      on non-home surfaces, so /studio /infra /tickets fall straight through.
    //   3. root._modulePagesLiveGet() — the LIVE, correctly design-system-wrapped
    //      module page map (workspaceProjects.js _wrapModulePages/_installLiveGetter).
    //      Installed by the MODULE LOADER itself, not by the home page, so — unlike
    //      _slotResolve — it survives on every surface a module route can be split
    //      from. A MODULE RECORD ROUTE (moduleRecordRoutes registry — a citation's
    //      "Open in split pane") is registered ONLY here and in workspaceProject
    //      .pages (which _slotResolve already covers when present); without this
    //      tier, a split opened while _slotResolve is absent fell straight through
    //      to the static table below, which a dynamically-installed module route
    //      is never in — the second pane mounted its header chrome and no body
    //      (WS-SPLIT-SECOND-PANE-MODULE-ROUTE-RENDERS-HEADER-ONLY-1).
    //   4. el.context.pages — the shell's merged registry (already lazy via
    //      lazyPage/lazySharedLib, already carries activated workspace-project
    //      pages). This is the ONLY path for /marketplace — its lazySharedLib
    //      entry (workspace/pages/index.js) folds the marketplace context into
    //      the live shell registry on first mount, THEN el.sets the real page.
    const liveModulePages = root && typeof root._modulePagesLiveGet === 'function' ? root._modulePagesLiveGet() : null;
    return root && root._aiAnswerPages && root._aiAnswerPages[clean] || root && root._slotResolve && root._slotResolve(clean) || liveModulePages && liveModulePages[clean] || el.context?.pages?.[clean] || null;
};
// Top-level section of a path ('/tickets/board' → 'tickets'). Used to detect
// a nav-away: when the live route leaves the section the slot was opened in,
// the slot is stale and must be dismissed.
const $ff11614ac4f941af$var$_topSection = (path)=>$ff11614ac4f941af$var$canvasStripWorkspacePrefix(String(path || '')).split('?')[0].split('/').filter(Boolean)[0] || '';
// ── Per-pane navigation state (2026-08-06 per Nika "when we navigate accross
// pageslots - we shuld also support back and forward navigations in
// pageslots… also support sidebar view in pageslot thats quick access for all
// available pageslot apps") ────────────────────────────────────────────────
//
// Each pane owns an independent history + apps-rail flag, keyed off its slot
// key — pane-scoped by construction, so neither surface can ever move the
// sibling pane (the split-view contract). Keys are declared in
// workspace/state-app.js; on roots that don't declare them (canvas
// standalone) the consumers below quietly no-op.
const $ff11614ac4f941af$var$_HIST_KEYS = {
    _canvasSlot: '_slotHistPrimary',
    _canvasSlotSecond: '_slotHistSecond'
};
const $ff11614ac4f941af$var$_RAIL_KEYS = {
    _canvasSlot: '_slotRailPrimary',
    _canvasSlotSecond: '_slotRailSecond'
};
// Record the pane's live path into its per-pane history. Runs from the pane
// Slot's lifecycle on every SLOT_KEY change, whoever wrote it (openAppPage,
// openInSlot, the rail, tickets' in-canvas writers, …) — the ONE choke point
// that sees them all. A back/forward landing needs no guard flag: the arrows
// write the path the cursor already points at, so histRecord returns the same
// reference and nothing is written (which also terminates the
// record→update→record echo). Skips roots that don't declare the key — smbls
// drops writes to undeclared root keys, so recording there would re-attempt
// an update on every render forever. An in-place query patch (see
// `_inPlaceQueryPatch`) REPLACES the cursor entry instead of adding one, in
// both panes: the pane's Back arrow must never land on a link param the page
// already consumed (lane RQ-2).
const $ff11614ac4f941af$var$_recordSlotHist = (s, SLOT_KEY, el)=>{
    const root = s.root;
    const histKey = $ff11614ac4f941af$var$_HIST_KEYS[SLOT_KEY];
    if (!root || !histKey || root[histKey] === undefined) return;
    const path = root[SLOT_KEY];
    if (!path) return;
    const prev = root[histKey];
    const next = $ff11614ac4f941af$var$_inPlaceQueryPatch(el, path, (0, $5ApZL.histCurrent)(prev)) ? (0, $5ApZL.histReplace)(prev, path) : (0, $5ApZL.histRecord)(prev, path);
    if (next !== prev) root.update({
        [histKey]: next
    });
};
const $ff11614ac4f941af$export$b477d10b16ad642f = (root, SLOT_KEY, host, live)=>{
    if (!root || typeof root !== 'object' || !SLOT_KEY) return;
    const map = root.__slotLiveHosts || (root.__slotLiveHosts = {});
    if (live) map[SLOT_KEY] = host;
    else if (map[SLOT_KEY] === host) delete map[SLOT_KEY];
};
// Nearest ancestor pane element — panes stamp `_slotPaneKey` (see _slotPane).
// Replaces the old fixed `el.parent?.parent` reach, which broke the moment
// the pane grew its content row (rail + mount target live one level deeper).
const $ff11614ac4f941af$var$_paneOf = (el)=>{
    let n = el && el.parent;
    let hops = 0;
    while(n && hops < 12){
        if (n._slotPaneKey) return n;
        if (n.parent === n) break;
        n = n.parent;
        hops++;
    }
    return null;
};
// ── Minimize-to-dock (2026-08-06 per Nika "we should support minimize
// feature for apps, to continue exactly where it left off") ────────────────
//
// Mechanism — KEEP-ALIVE HOSTS: the Slot no longer mounts pages via a single
// replaced `content` child. Each opened route gets its own host child
// (`SlotKeep_<route>`), created imperatively through the same
// `context.__create` path `el.set()` uses, with the page def `el.set` INTO
// the host. The host is gated by a reactive `display:` predicate — NEVER
// `hide:` and never `if:` — so a minimized app's element subtree (DOM nodes,
// component state, timers, in-flight work) stays fully mounted and alive
// while invisible; restoring flips the predicate back and reveals the SAME
// element instance. Unmounting is explicit (`host.remove()` → full dispose)
// and happens only in `_sweepHosts`.
//
// With minimize as the explicit "keep it alive" verb, a plain CLOSE is now a
// REAL close: the swept host is fully disposed (the pre-minimize builds kept
// the last route's `el.set` content mounted forever as an accident of the
// single-mount design — that implicit keep is deliberately retired).
//
// Ownership of `root._minimizedSlots` mutations (state-app.js declares the
// key; it is in WORKSPACE_SCOPED_KEYS so the switch wipe resets it):
//   • _minimizeSlot (MinimizeBtn) — parks the open primary route (cap 5,
//     oldest evicted; the sweep unmounts evicted hosts).
//   • _adoptActive — drops a route from the list the moment it becomes the
//     ACTIVE slot again (restore-by-any-path: dock chip, launcher, search
//     all just set `_canvasSlot` and converge here), atomically with the
//     activation so the sweep can never see a restored route as closeable.
//   • MinimizedDock's DismissBtn — explicit close of a parked app.
// Every mutation persists the LIST (never the hosts) per-workspace via
// sessionStorage (shared/functions/minimizedSlots.js) so a reload offers the
// same apps as COLD restores (fresh mount, best-effort continuation).
//
// Workspace isolation (house law): hosts are stamped with the workspace id
// they mounted under; the sweep removes any host whose stamp no longer
// matches the live workspace — so neither the kept-alive DOM nor the dock
// list survives an org/workspace switch.
const $ff11614ac4f941af$var$_canvasWsIdOf = (root)=>root?.activeWorkspaceId || root?.workspace?.id || root?.jwtClaims?.active_workspace_id || null;
const $ff11614ac4f941af$var$_HOST_PREFIX = 'SlotKeep_';
const $ff11614ac4f941af$var$_hostKeyFor = (clean)=>$ff11614ac4f941af$var$_HOST_PREFIX + String(clean || '').replace(/[^A-Za-z0-9]/g, '_');
// AN IN-PLACE QUERY PATCH IS NOT A NAVIGATION (lane RQ-2, the in-place half
// of WS-MODULE-ROUTE-QUERY-NO-HISTORY-ENTRY-1). A module page that consumes a
// link param (Catalog opens its New product form from `?new=1&name=`, then
// clears both) moves its pane route through the shell's
// `setModuleRouteQuery`, which stamps the live host with the new full route
// BEFORE it writes the slot key, so `_mountPane` keeps the page (keep-alive
// hit, no re-mount). Such a write REPLACES the pane's current entry, in the
// address bar (`_writeSlotUrl` without push) and in the pane history
// (`_recordSlotHist`). An added entry is one Back lands on: `_mountPane` then
// meets a route the host does not carry, re-mounts, and the consumed form
// opens a second time.
//
// In place = the same clean route as `prev`, AND the route's own keep-alive
// host already carries this exact path. A skeleton host never carries
// `_slotPath` (_showSkeleton), a deep-link change (room → board) arrives
// before any stamp, and a keep-alive re-open changes the clean route: all
// three stay navigations and push. A family route has no per-route host (one
// host per family, whose Body re-mounts on every route change), so it never
// reads as in place.
const $ff11614ac4f941af$var$_inPlaceQueryPatch = (el, path, prev)=>{
    if (!el || typeof path !== 'string' || typeof prev !== 'string') return false;
    if (!path || path === prev) return false;
    const clean = $ff11614ac4f941af$var$canvasCleanHref(path);
    if (!clean || clean !== $ff11614ac4f941af$var$canvasCleanHref(prev)) return false;
    const host = el[$ff11614ac4f941af$var$_hostKeyFor(clean)];
    return !!(host && host.__ref && host._slotPath === path);
};
// ── Family hosts (2026-08-14, Nika-approved "when switching tabs we can
// partially update ui" — scope 2: shell-wide slot reuse) ────────────────────
//
// Same-FAMILY routes share ONE keep-alive host with a stable two-part
// skeleton: `Chrome` (the family's shared header/controls — mounted once,
// never touched again) and `Body` (the page def — the ONLY thing that swaps
// on an intra-family route change). Chrome DOM nodes keep their identity
// across the switch, so the tab/chip strip never flashes or remounts.
//
// Families are declared by the HOME via `root._slotFamilyFor(clean)` →
// `{ id, chrome }` or null (workspace/pages/main.js, installed beside
// `_slotResolve`). Absent resolver (canvas standalone) or unfamilied route
// → the per-route host path below, byte-for-byte today's behavior.
//
// Known, accepted degradation: parking a family route in the dock and then
// opening a SIBLING route of the same family swaps the shared Body — the
// parked entry falls back to a cold restore (the dock list survives; the
// live subtree doesn't). The dock contract stays intact for everything
// outside the family's own sibling set.
const $ff11614ac4f941af$var$_familyOf = (root, clean)=>{
    const fn = root && root._slotFamilyFor;
    if (typeof fn !== 'function' || !clean) return null;
    try {
        return fn(clean) || null;
    } catch  {
        return null;
    }
};
const $ff11614ac4f941af$var$_familyHostKey = (id)=>$ff11614ac4f941af$var$_HOST_PREFIX + 'family_' + String(id).replace(/[^A-Za-z0-9]/g, '_');
const $ff11614ac4f941af$var$_familyHostDef = (family, SLOT_KEY)=>({
        // Same reactive-`display:` keep-alive gate as _hostDef, keyed on the
        // FAMILY of the active route instead of route identity.
        display: (el, s)=>{
            s.root?._slotNudge;
            const fam = $ff11614ac4f941af$var$_familyOf(s.root, $ff11614ac4f941af$var$canvasCleanHref(s.root?.[SLOT_KEY]));
            const live = !!(fam && fam.id === family.id);
            $ff11614ac4f941af$export$b477d10b16ad642f(s.root, SLOT_KEY, el, live);
            if (live) return 'flex';
            const pane = $ff11614ac4f941af$var$_paneOf(el);
            if (pane && pane._closing) {
                const lastFam = $ff11614ac4f941af$var$_familyOf(s.root, $ff11614ac4f941af$var$canvasCleanHref(el.parent?._lastSlot));
                if (lastFam && lastFam.id === family.id) return 'flex';
            }
            return 'none';
        },
        subscribeTo: [
            SLOT_KEY
        ],
        flex: '1 1 0',
        minWidth: '0',
        minHeight: '0',
        width: '100%',
        flexDirection: 'column',
        overflow: 'hidden',
        // Chrome — set ONCE at first family mount (with the page def's context so
        // the family package's bare keys resolve); persists across Body swaps.
        Chrome: {
            flex: '0 0 auto',
            width: '100%'
        },
        // Body — the swap target. Owns the scroll so the chrome never moves.
        Body: {
            flex: '1 1 0',
            minWidth: '0',
            minHeight: '0',
            width: '100%',
            display: 'flex',
            overflow: 'auto',
            overscrollBehavior: 'contain',
            '& > [data-key]': {
                flex: '1 1 0',
                minWidth: '0',
                minHeight: '0',
                maxWidth: '100%',
                // ONE ground ("keep one bg", 2026-09-01): the page ROOT this host
                // wraps goes transparent by specificity (0,2,0 beats its atomic
                // ground class), so the pane's stage-chain ground is the only sheet.
                background: 'transparent'
            }
        }
    });
// Host wrapper def. The page def is `el.set` into it (same stripping the old
// single-mount used). The host is the Slot's flex item (the Slot is a flex
// box the size of the pane's content row — see the Slot notes below): it
// takes the Slot's `& > [data-key]` sizing and passes the same lever down to
// the page root it hosts.
const $ff11614ac4f941af$var$_hostDef = (clean, SLOT_KEY)=>({
        // KEEP-ALIVE GATE — reactive `display:` (the banked rule: `hide:` would
        // stop re-evaluating once the subtree is out; `if:` would unmount it).
        // Reads `_slotNudge` for the same reason the pane's hide factory does: a
        // pane holds visible through its exit animation via element-local
        // `_closing`, which no signal tracks — the close-finish nudge re-runs this
        // so a minimized route keeps painting INSIDE the pane while it fades out,
        // then goes display:none when the choreography lands.
        display: (el, s)=>{
            s.root?._slotNudge;
            const live = $ff11614ac4f941af$var$canvasCleanHref(s.root?.[SLOT_KEY]) === clean;
            $ff11614ac4f941af$export$b477d10b16ad642f(s.root, SLOT_KEY, el, live);
            if (live) return 'flex';
            const pane = $ff11614ac4f941af$var$_paneOf(el);
            if (pane && pane._closing && $ff11614ac4f941af$var$canvasCleanHref(el.parent?._lastSlot) === clean) return 'flex';
            return 'none';
        },
        subscribeTo: [
            SLOT_KEY
        ],
        // Counts changes inside the page (both events bubble here), so a page the
        // user chose to Keep is asked about again only after it changed again
        // (_confirmDiscardParked).
        onInput: (e, el)=>$ff11614ac4f941af$export$11bc6e9a1e6d1c31(e, el),
        onChange: (e, el)=>$ff11614ac4f941af$export$11bc6e9a1e6d1c31(e, el),
        flex: '1 1 0',
        minWidth: '0',
        minHeight: '0',
        width: '100%',
        overflow: 'auto',
        overscrollBehavior: 'contain',
        // THE HOST SCROLLS, SO IT IS NEVER A STACKING CONTEXT (DESIGN-SHELL-
        // RESPONSIVE-IOS-SAFARI-1, the iOS fixed-layer rule): iOS Safari clips
        // every `position: fixed` layer inside a scroller that is a stacking
        // context to the scroller's box — a module page's fixed sheet, dialog or
        // toast would be cut to the pane, an empty band in its place (found on the
        // iOS 26 Simulator by the public lane: the app root's z-index 0 hid the
        // Ask bar). Desktop WebKit and Chromium never show it. No z-index,
        // isolation, transform, filter, opacity, will-change or paint containment
        // here. WS-SLOT-HOST-ISOLATES-STACKING-1's isolation (a page's z 20/30
        // layers must stay under the apps rail at z 3) lives one level up, on the
        // pane's Slot, which does not scroll.
        '& > [data-key]': {
            flex: '1 1 0',
            minWidth: '0',
            minHeight: '0',
            maxWidth: '100%',
            // ONE ground ("keep one bg", 2026-09-01): the page ROOT this host
            // wraps goes transparent by specificity (0,2,0 beats its atomic
            // ground class), so the pane's stage-chain ground is the only sheet.
            background: 'transparent'
        }
    });
const $ff11614ac4f941af$export$3f338b78b922a25f = $ff11614ac4f941af$var$_hostDef;
const $ff11614ac4f941af$export$ccb8762ae81200ed = $ff11614ac4f941af$var$_familyHostDef;
// Remove every host that is neither the ACTIVE route, nor PARKED in
// `_minimizedSlots` (primary pane only — the split pane never owns parked
// entries), nor stamped for the CURRENT workspace. Runs from the Slot's
// lifecycle on every relevant signal; deferred while the pane's exit
// choreography holds (`_closing`) so a closing sheet never blanks mid-fade —
// the close-finish `_slotNudge` re-fires the Slot and the sweep lands then.
// ── MODULE KEEP-ALIVE (WS-PAGE-SWITCH-SLOW-1, 2026-08-18) ─────────────────
// Measured on the bellforge module (dev shell, hidden-tab lower bounds —
// checkpoint 2 on tickets/opus.md): every intra-module switch DISPOSED the
// previous route's host and re-prepared the next def from scratch — /theses
// 1602 → 1283 → 1986 ms across three visits (revisits pay FULL price), plus
// one data refetch per switch. The reveal path in _mountPane ("Keep-alive
// hit — reveal only") already makes a SURVIVING host free to revisit; the
// whole fix is letting module-route hosts survive the sweep while the user
// stays inside the same module.
//
// WHY DROPPING THE PER-SWITCH DISPOSE IS SAFE — AND WHAT IT WAS DOING.
// The dispose was also BOUNDING a leak: heap grew ~6 MB per switch even
// WITH disposal, so whatever retains per-mount memory was only being
// truncated by the sweep, never fixed. Removing the dispose removes that
// accidental bound, so the keep is CAPPED: at most SLOT_MODULE_KEEP_CAP
// parked module hosts, LRU by `_slotSeenAt` (the ACTIVE route's host is
// never evicted). Membership is decided against the CURRENT live module
// page map (`root._modulePagesLiveGet`, installed by workspaceProjects'
// module loader), so a module or workspace switch naturally evicts every
// host the old module parked — outside a module (getter absent: canvas
// standalone, plain shell routes) the sweep behaves exactly as before.
// ⚠ Heap over the same 5-switch protocol MUST be re-measured beside the
// timings whenever this block changes (tickets/opus.md acceptance).
//
// perf/shell-keepalive (2026-10-10): 6 → 3. Measured on staging
// /w/vault/default: the seven VaultOS pages all stayed mounted (display:none)
// once visited — 9,489 DOM nodes, VaultSchema alone 1,797 and the training
// page 1,310. The kept-alive set is now the ACTIVE page + the 3 most recently
// seen. A parked page is protected ONLY when it DECLARES unsaved work (the
// shell's `hasUnsavedInput`: an `isDirty` hook or a `dirty` flag); such a page
// past the cap is asked about first ("Discard changes?", Keep is the default)
// — see _confirmDiscardParked. No value heuristic, no `keepAlive` pin.
const $ff11614ac4f941af$var$SLOT_MODULE_KEEP_CAP = 3;
const $ff11614ac4f941af$var$_moduleLiveRoutes = (root)=>{
    const get = root && root._modulePagesLiveGet;
    if (typeof get !== 'function') return null;
    try {
        const map = get();
        return map && typeof map === 'object' ? map : null;
    } catch  {
        return null;
    }
};
const $ff11614ac4f941af$export$ed901a0f69cc2c1b = (hosts, { activeClean: activeClean, wsId: wsId, liveRoutes: liveRoutes, cap: cap = $ff11614ac4f941af$var$SLOT_MODULE_KEEP_CAP })=>{
    const keep = [];
    const evict = [];
    const confirm = [];
    const parked = [];
    const activeInModule = !!(liveRoutes && activeClean && activeClean in liveRoutes);
    for (const h of hosts){
        const stale = !!(wsId && h.ws && h.ws !== wsId);
        const inModule = !!(liveRoutes && h.href && h.href in liveRoutes);
        if (!activeInModule || !inModule || stale) {
            evict.push(h);
            continue;
        }
        if (h.href === activeClean) {
            keep.push(h);
            continue;
        }
        parked.push(h);
    }
    const newest = (a, b)=>(b.seenAt || 0) - (a.seenAt || 0);
    const pinned = parked.filter((h)=>h.pinned).sort(newest);
    const free = parked.filter((h)=>!h.pinned).sort(newest);
    const pinnedKept = pinned.slice(0, cap);
    const budget = Math.max(0, cap - pinnedKept.length);
    keep.push(...pinnedKept, ...free.slice(0, budget));
    for (const h of pinned.slice(cap))(h.kept ? keep : confirm).push(h);
    evict.push(...free.slice(budget));
    return {
        keep: keep,
        evict: evict,
        confirm: confirm
    };
};
const $ff11614ac4f941af$export$3758873fd92da5b0 = (host)=>{
    if (!host || typeof host !== 'object') return false;
    const fns = host.context && host.context.functions;
    if (!fns || typeof fns.hasUnsavedInput !== 'function') return false;
    return !!host.call('hasUnsavedInput', host);
};
const $ff11614ac4f941af$export$978d1e4106f714d3 = (hosts, ctx, isPinned)=>{
    const known = new Map();
    const activeInModule = !!(ctx.liveRoutes && ctx.activeClean && ctx.activeClean in ctx.liveRoutes);
    const eligible = (h)=>activeInModule && !(ctx.wsId && h.ws && h.ws !== ctx.wsId) && !!(ctx.liveRoutes && h.href && h.href in ctx.liveRoutes) && h.href !== ctx.activeClean;
    for(;;){
        const plan = $ff11614ac4f941af$export$ed901a0f69cc2c1b(hosts.map((h)=>({
                ...h,
                pinned: known.get(h.key) === true
            })), ctx);
        let changed = false;
        for (const h of plan.evict){
            if (known.has(h.key) || !eligible(h)) continue;
            const pinned = !!isPinned(h);
            known.set(h.key, pinned);
            if (pinned) changed = true;
        }
        if (!changed) return plan;
    }
};
const $ff11614ac4f941af$export$11bc6e9a1e6d1c31 = (e, host)=>{
    if (!host) return;
    host._slotChangeSeq = (host._slotChangeSeq || 0) + 1;
};
// Has the user already answered Keep for this page, with no change since?
const $ff11614ac4f941af$var$_keptUnchanged = (host)=>!!host && host._slotKeptSeq != null && host._slotKeptSeq === (host._slotChangeSeq || 0);
const $ff11614ac4f941af$export$4317de27f882b76e = (slot, host, { wsId: wsId, isActive: isActive, discard: discard } = {})=>{
    if (!host || host._slotAsking || !wsId || $ff11614ac4f941af$var$_keptUnchanged(host)) return false;
    const fns = slot && slot.context && slot.context.functions;
    if (!fns || typeof fns.confirmDiscardChanges !== 'function') return false;
    host._slotAsking = true;
    slot.call('confirmDiscardChanges', {
        onDiscard: ()=>{
            host._slotAsking = false;
            if (typeof isActive === 'function' && isActive()) return;
            if (typeof discard === 'function') discard();
        },
        onKeep: ()=>{
            host._slotAsking = false;
            host._slotKeptSeq = host._slotChangeSeq || 0;
        }
    });
    return true;
};
const $ff11614ac4f941af$var$_sweepHosts = (el, s, SLOT_KEY, primary)=>{
    const _pane = $ff11614ac4f941af$var$_paneOf(el);
    if (_pane && _pane._closing) return;
    const ref = el.__ref;
    if (!ref || !ref.__children) return;
    const root = s.root;
    const wsId = $ff11614ac4f941af$var$_canvasWsIdOf(root);
    const activeClean = $ff11614ac4f941af$var$canvasCleanHref(root?.[SLOT_KEY]);
    const minimized = primary && Array.isArray(root?._minimizedSlots) ? root._minimizedSlots : [];
    const activeFam = $ff11614ac4f941af$var$_familyOf(root, activeClean);
    const liveRoutes = $ff11614ac4f941af$var$_moduleLiveRoutes(root);
    const modCand = [];
    for (const key of [
        ...ref.__children
    ]){
        if (typeof key !== 'string' || !key.startsWith($ff11614ac4f941af$var$_HOST_PREFIX)) continue;
        const host = el[key];
        if (!host || !host.__ref) continue;
        const stale = wsId && host._slotWs && host._slotWs !== wsId;
        // Family hosts survive as long as the ACTIVE route — or any PARKED
        // route — belongs to their family; per-route hosts keep the exact
        // route-identity semantics they always had.
        const keep = host._slotFamily ? !stale && (activeFam && activeFam.id === host._slotFamily || minimized.some((en)=>{
            const f = $ff11614ac4f941af$var$_familyOf(root, $ff11614ac4f941af$var$canvasCleanHref(en && en.href));
            return f && f.id === host._slotFamily;
        })) : !stale && (host._slotHref === activeClean || minimized.some((en)=>$ff11614ac4f941af$var$canvasCleanHref(en && en.href) === host._slotHref));
        if (keep) continue;
        // MODULE KEEP — a host that lost the route-identity keep may still be a
        // parked module page; defer to the capped plan below. Family hosts keep
        // their own contract and never enter the module plan.
        if (!host._slotFamily && liveRoutes) {
            modCand.push({
                key: key,
                host: host
            });
            continue;
        }
        // The in-flight/dedupe guard must not outlive the host it described, or
        // a later same-route open would skip its own mount.
        if ($ff11614ac4f941af$var$canvasCleanHref(el._lastSlot) === host._slotHref) el._lastSlot = null;
        host.remove();
    }
    if (modCand.length) {
        const byKey = new Map(modCand.map((c)=>[
                c.key,
                c.host
            ]));
        const plan = $ff11614ac4f941af$export$978d1e4106f714d3(modCand.map(({ key: key, host: host })=>({
                key: key,
                href: host._slotHref,
                ws: host._slotWs,
                seenAt: host._slotSeenAt,
                kept: $ff11614ac4f941af$var$_keptUnchanged(host)
            })), {
            activeClean: activeClean,
            wsId: wsId,
            liveRoutes: liveRoutes,
            cap: $ff11614ac4f941af$var$SLOT_MODULE_KEEP_CAP
        }, (h)=>$ff11614ac4f941af$export$3758873fd92da5b0(byKey.get(h.key)));
        const confirmKeys = new Set(plan.confirm.map((h)=>h.key));
        for (const { key: key, host: host } of modCand){
            if (!confirmKeys.has(key)) continue;
            $ff11614ac4f941af$export$4317de27f882b76e(el, host, {
                wsId: wsId,
                // the page on screen by the time the user answers is never removed
                isActive: ()=>$ff11614ac4f941af$var$canvasCleanHref(root?.[SLOT_KEY]) === host._slotHref,
                discard: ()=>{
                    if (!host.__ref) return;
                    if ($ff11614ac4f941af$var$canvasCleanHref(el._lastSlot) === host._slotHref) el._lastSlot = null;
                    host.remove();
                }
            });
        }
        const evictKeys = new Set(plan.evict.map((h)=>h.key));
        for (const { key: key, host: host } of modCand){
            if (!evictKeys.has(key)) continue;
            if ($ff11614ac4f941af$var$canvasCleanHref(el._lastSlot) === host._slotHref) el._lastSlot = null;
            host.remove();
        }
    }
};
// Restore-by-any-path: the moment a parked route becomes the active slot
// again, un-park it. Single owner of the restore-side list edit, running in
// the same update pass that activated the route.
const $ff11614ac4f941af$var$_adoptActive = (el, s)=>{
    const root = s.root;
    const list = root?._minimizedSlots;
    if (!Array.isArray(list) || !list.length) return;
    const activeClean = $ff11614ac4f941af$var$canvasCleanHref(root?._canvasSlot);
    if (!activeClean || !$ff11614ac4f941af$var$hasMinimizedEntry(list, activeClean)) return;
    const next = $ff11614ac4f941af$var$removeMinimizedEntry(list, activeClean);
    $ff11614ac4f941af$var$writeMinimizedList($ff11614ac4f941af$var$_canvasWsIdOf(root), next);
    root.update({
        _minimizedSlots: next
    });
};
// Title/icon for a dock chip: the page def's own metadata first, enriched
// from the launcher tile registry when the shell provides it (canvas
// standalone doesn't register it — availability-checked like
// OnlineMembersDock's isActiveMember, never a blind el.call, so the dev
// unresolved-call warning can't fire).
//
// When the title IS the launcher tile's and the tile carries an installed
// app's record key (`appKey` — the shell stamps it on the ONE tile an app
// contributes, workspace functions/workspaceConfigs.js), the key rides on the
// entry too: the chip names the app by it (MinimizedDockChip), the App Store's
// name, where the tile's own title is the app manifest's word ("Store" for
// Commerce). A page's own title has no key — it names the page, not the app.
const $ff11614ac4f941af$var$_slotEntryMeta = (el, root, clean, def)=>{
    let title = $ff11614ac4f941af$var$shortSlotTitle(el.call('resolvePageMetadataTitle', def?.metadata)) || null;
    let icon = def?.metadata?.icon || null;
    let appKey = null;
    if (!title || !icon) {
        const groupsFn = el.context?.functions?.searchAppGroupsFor || el.context?.methods?.searchAppGroupsFor;
        if (typeof groupsFn === 'function') try {
            const groups = groupsFn.call(el, root) || [];
            for (const g of groups){
                const tile = (g?.apps || []).find((a)=>a && a.route === clean);
                if (tile) {
                    if (!title && tile.appKey) appKey = tile.appKey;
                    title = title || tile.title;
                    icon = icon || tile.icon;
                    break;
                }
            }
        } catch (_) {
        /* enrichment is best-effort */ }
    }
    return {
        title: title || clean,
        icon: icon || 'layers',
        ...appKey ? {
            appKey: appKey
        } : {}
    };
};
// Park the open PRIMARY route: append/refresh its dock entry (cap 5, oldest
// evicted — the sweep unmounts the evicted host), then close the pane with
// the SAME promote semantics the CloseBtn uses — all in ONE root.update so
// the host sweep and the pane choreography see a consistent world.
const $ff11614ac4f941af$var$_minimizeSlot = (el, root)=>{
    const path = root?._canvasSlot;
    if (!path) return;
    const clean = $ff11614ac4f941af$var$canvasCleanHref(path);
    const def = $ff11614ac4f941af$var$_defFor(el, clean, root);
    const wsId = $ff11614ac4f941af$var$_canvasWsIdOf(root);
    const meta = $ff11614ac4f941af$var$_slotEntryMeta(el, root, clean, def);
    const entry = {
        href: path,
        title: meta.title,
        icon: meta.icon,
        ...meta.appKey ? {
            appKey: meta.appKey
        } : {},
        wsId: wsId,
        minimizedAt: Date.now()
    };
    const { list: list } = $ff11614ac4f941af$var$minimizeEntry(root._minimizedSlots || [], entry);
    $ff11614ac4f941af$var$writeMinimizedList(wsId, list);
    root.update({
        _slotPinned: (0, $cKTuv.slotPinAfterPrimaryLeaves)(root),
        _minimizedSlots: list,
        _canvasSlot: root._canvasSlotSecond || null,
        _canvasSlotSecond: null,
        // null, not false — closes and minimizes reset to "no explicit choice"
        // so the next open re-resolves pref → module default (B1 tri-state,
        // slotFullscreenActive in the shell's workspaceProjects.js).
        _slotFullscreen: null,
        _slotHistSecond: null,
        _slotRailPrimary: false,
        _slotRailSecond: false
    });
};
// Close the slot wholesale — the ONE place the "always reset fullscreen"
// invariant lives. `promote: true` implements the iPad semantics: closing the
// primary hands its frame to the surviving second pane.
//
// Navigation-state policy on close: both apps rails reset (an open rail must
// never greet the next open), the SECOND pane's history dies with its pane
// (the next split is a fresh lineage), and the PRIMARY's history survives —
// re-opening the slot keeps Back working across the close, the same
// continuity contract minimize-to-dock set. On promote, the recorder files
// the promoted route into the primary history, so Back returns to the app
// the primary showed before the close.
const $ff11614ac4f941af$var$_closeSlot = (root, opts)=>{
    if (!root) return;
    if (opts && opts.promote && root._canvasSlotSecond) {
        root.update({
            // the pin follows the right pane into the left place (functions/slotPin.js)
            _slotPinned: (0, $cKTuv.slotPinAfterPrimaryLeaves)(root),
            _canvasSlot: root._canvasSlotSecond,
            _canvasSlotSecond: null,
            _slotFullscreen: null,
            _slotHistSecond: null,
            _slotRailPrimary: false,
            _slotRailSecond: false
        });
        return;
    }
    root.update({
        _canvasSlot: null,
        _canvasSlotSecond: null,
        // null (tri-state) — "always reset fullscreen" now means "always drop
        // back to the resolved default", not "always windowed" (B1).
        _slotFullscreen: null,
        _slotHistSecond: null,
        _slotRailPrimary: false,
        _slotRailSecond: false,
        _slotPinned: null
    });
};
// The ONE dismissal a pane has, whichever pane it is: the primary promotes a
// surviving split pane through _closeSlot (iPad semantics), the split pane
// clears itself AND any in-progress split intent. Extracted from the header
// CloseBtn so the phone drag-to-dismiss gesture below can route through the
// EXACT same path instead of inventing a second close (which would miss the
// promotion, the fullscreen reset and the ?page= URL sync hanging off it).
const $ff11614ac4f941af$var$_dismissPane = (root, primary)=>{
    if (!root) return;
    if (primary) {
        $ff11614ac4f941af$var$_closeSlot(root, {
            promote: true
        });
        return;
    }
    root.update({
        _canvasSlotSecond: null,
        _slotSplitIntent: false,
        _slotHistSecond: null,
        _slotRailSecond: false,
        _slotPinned: (0, $cKTuv.slotPinAfterSecondLeaves)(root)
    });
};
// Persist the open PRIMARY slot as ?page=<route> so a reload restores it — but
// ONLY on the home route ('/'), where the URL would otherwise stay '/' and lose
// the open sub-app. Other surfaces open the slot from within a real route whose
// own URL already identifies it. An opening/changing route pushes (Back steps
// back through it); a close or a same-URL re-render replaces — see
// `_writeSlotUrl`'s own comment. The home onCreate reads ?page= back on load
// (workspaceProjects.js re-applies it once a workspace-module's pages exist).
// The split pane is transient — not persisted.
const $ff11614ac4f941af$var$SLOT_URL_PARAM = 'page';
// The query a slot ROUTE carries, as key/value pairs. A module opens one of
// its own records by passing the params that identify it
// (`/vault-rooms?tenant=longbow&item=<id>`), and those params must reach
// `location.search` — a module page reads them there, and that is the ONLY
// way a slot open and a cold load of the same route look identical to it
// (A1-06). Nesting them inside the `?page=` value is not enough: nothing
// reads a query-inside-a-query.
const $ff11614ac4f941af$var$_slotRouteQuery = (routeStr)=>{
    const qs = String(routeStr || '').split('?')[1];
    if (!qs) return [];
    return [
        ...new URLSearchParams(qs.split('#')[0]).entries()
    ].filter(([k])=>k && k !== $ff11614ac4f941af$var$SLOT_URL_PARAM);
};
const $ff11614ac4f941af$export$9365b0c7c952745f = (href, path, trackable)=>{
    const url = new URL(href);
    const hadParam = url.searchParams.has($ff11614ac4f941af$var$SLOT_URL_PARAM);
    if (!trackable && !hadParam) return null;
    // Retire the params mirrored for the PREVIOUS slot route before writing
    // the new ones. The outgoing `?page=` value is the exact record of what
    // this function put there last time, so the cleanup needs no extra state
    // and can never delete a param some other surface owns.
    for (const [k] of $ff11614ac4f941af$var$_slotRouteQuery(url.searchParams.get($ff11614ac4f941af$var$SLOT_URL_PARAM)))url.searchParams.delete(k);
    if (trackable) {
        url.searchParams.set($ff11614ac4f941af$var$SLOT_URL_PARAM, path);
        for (const [k, v] of $ff11614ac4f941af$var$_slotRouteQuery(path))url.searchParams.set(k, v);
    } else url.searchParams.delete($ff11614ac4f941af$var$SLOT_URL_PARAM);
    return url.pathname + url.search + url.hash;
};
const $ff11614ac4f941af$export$37c9ecc617dfacb6 = (path, root, opts)=>{
    if (typeof window === 'undefined') return;
    const onHome = $ff11614ac4f941af$var$canvasStripWorkspacePrefix(root?.currentPath || window.location.pathname) === '/';
    try {
        const clean = path && path.split('?')[0];
        const trackable = onHome && !!clean && !!(root && root._slotResolve && root._slotResolve(clean));
        const next = $ff11614ac4f941af$export$9365b0c7c952745f(window.location.href, path, trackable);
        if (next === null) return;
        // NO-OP writes must not touch history: this runs from the slot's reactive
        // render pass, so with a slot open it re-fires on every root update. The
        // AppShell history patch dispatches `locationchange` on EVERY
        // replaceState — identical URL included — and the shell's
        // _closeOnNav listener closes any open dropdown layer on that event.
        // Without this guard, no dropdown could stay open while a PageSlot was
        // open: the search/apps launcher opened and was closed by the very next
        // slot render (~200ms), measured live 2026-08-06 (the "searchdropdown
        // is not opening when pageslot is open" bug — stack: _writeSlotUrl →
        // patched replaceState → locationchange → _closeOnNav → closeDropdown).
        const current = window.location.pathname + window.location.search + window.location.hash;
        if (next === current) return;
        if (opts && opts.push && path) window.history.pushState(window.history.state, '', next);
        else window.history.replaceState(window.history.state, '', next);
    } catch (err) {
        console.warn('[PageSlot] url sync failed:', err);
    }
};
const $ff11614ac4f941af$export$91a98ef76979ad4 = (root)=>{
    if (typeof window === 'undefined' || !root) return;
    const onHome = $ff11614ac4f941af$var$canvasStripWorkspacePrefix(root.currentPath || window.location.pathname) === '/';
    if (!onHome) return;
    const pageParam = new URLSearchParams(window.location.search).get($ff11614ac4f941af$var$SLOT_URL_PARAM);
    const clean = pageParam && pageParam.split('?')[0];
    const trackable = !!clean && !!(root._slotResolve && root._slotResolve(clean));
    if (trackable) {
        if (root._canvasSlot !== pageParam) root.update({
            _canvasSlot: pageParam
        });
        return;
    }
    // No (or an unresolvable) `?page=` — popped past every open into the bare
    // grid. Full close, the same reset the X button uses, so nothing survives
    // half-open (fullscreen, the split pane, the rail flags).
    if (root._canvasSlot || root._canvasSlotSecond) $ff11614ac4f941af$var$_closeSlot(root);
};
// The tab title belongs to the PRIMARY pane while any slot is open. Helmet
// only writes on a fresh page mount, which leaves two stale-title holes the
// keep-alive design creates: (1) a same-route re-open skips the mount, so
// nothing re-writes the title the close handed back to the owning page;
// (2) a second-pane mount writes ITS title, which must revert to the
// primary's when that pane closes (or immediately after it mounts — the
// primary owns the URL, so it owns the title).
const $ff11614ac4f941af$var$_syncSlotTitle = (el, root)=>{
    if (typeof document === 'undefined' || !root || !root._canvasSlot) return;
    const def = $ff11614ac4f941af$var$_defFor(el, root._canvasSlot, root);
    const title = el.call('resolvePageMetadataTitle', def?.metadata);
    if (title && document.title !== title) (0, $11nI2.applyMetadata)({
        title: title
    }, document);
};
// The router keeps its live page under this key. Capture the ELEMENT when
// a primary pane opens, not its title: metadata must resolve with that page's
// local state and the current language/brand when the pane closes.
const $ff11614ac4f941af$var$_routeTitleOwner = (el)=>{
    const routed = el.getRoot?.();
    return routed?.[routed.__ref?.contentElementKey || 'content'] || null;
};
const $ff11614ac4f941af$var$_restoreRouteTitle = (el)=>{
    const owner = el.__slotTitleOwner;
    el.__slotTitleOwner = null;
    // Expand/full-page navigation may already have replaced the underlying
    // route. Its new Helmet owns the title; never overwrite it with the page
    // that happened to sit behind the pane before navigation.
    if (!owner || owner !== $ff11614ac4f941af$var$_routeTitleOwner(el) || typeof owner.call !== 'function') return;
    const title = owner.call('resolvePageMetadataTitle', owner.metadata);
    const doc = owner.context?.document || typeof document !== 'undefined' && document;
    if (title && doc && doc.title !== title) (0, $11nI2.applyMetadata)({
        title: title
    }, doc);
};
// Clear a stale slot when the user navigates away from the section that opened
// it (ticket 6a32d411 — the overlay lingered after navigating out of the
// owning section). Record the route present when the slot opened
// (el._slotRoute) and dismiss BOTH panes once currentPath's top section
// differs. Re-opening on the SAME section never clears.
const $ff11614ac4f941af$var$_dismissStaleSlot = (el, s)=>{
    const root = s.root;
    if (!root) return;
    const route = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '');
    if (!root._canvasSlot && !root._canvasSlotSecond) {
        // A split intent with BOTH panes empty is always stale: the split can
        // only be armed from an open slot's header, so nothing legitimate
        // arrives here with the intent still raised. Left set, it kept the
        // empty "New pane / Choose an app for this pane" placeholders painted
        // over the page after a slot-page navigation (investor audit
        // 2026-08-14: ?page=/admin → ?page=/overview stranded two pickers).
        if (root._slotSplitIntent) root.update({
            _slotSplitIntent: false
        });
        el._slotRoute = null;
        return;
    }
    if (el._slotRoute == null) {
        el._slotRoute = route;
        return;
    }
    if ($ff11614ac4f941af$var$_topSection(route) === $ff11614ac4f941af$var$_topSection(el._slotRoute)) return;
    el._slotRoute = null;
    $ff11614ac4f941af$var$_closeSlot(root);
};
// ── Open/close choreography ────────────────────────────────────────────────
//
// Driven IMPERATIVELY via the Web Animations API, for three verified reasons:
// (1) the entrance must be armed BEFORE the first visible paint (the no-blink
// inline-opacity hold below) and WAAPI gives explicit control of that moment;
// (2) the exit needs finish/cancel hooks to hold the pane through the
// animation and then land the keep-alive display:none — declarative CSS can't
// signal completion into the close choreography (and el.update({}) can't
// re-apply `hide` afterwards — see the OPEN el.update({}) ticket in
// tickets/smbls.md); (3) hide-driven display flips re-attach nodes, which
// restarts declarative animations from frame 0 (the closed animation-restart
// forensics in tickets/smbls.md concede exactly the node re-create case).
// `node.animate()` is one-shot and owned here, immune to all of it.
//
// iOS feel (2026-07-12 per Nika "smooth like iOS"): Apple's sheet curve
// cubic-bezier(0.32, 0.72, 0, 1), a gentle rise + settle in, a quick drop out.
//
// ONE RECIPE (DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1 — DESIGN_SPEC §6.4 "Center
// sheet", HOME_AMBIENT_SKIN_SPEC §6): every open rises the same way — opacity
// 0 → 1 with a 2.5 % rise and a 0.97 settle, timing `D` on `springBezier`,
// grown from the sheet's bottom edge (it sits on the dock) — and every close
// is the same keyframes back, one letter faster (`C`) on `defaultBezier`. The
// iPad zoom-from-the-tapped-icon entrance is retired: a home widget, the
// search, a notification and a deep link now open ONE sheet the ONE way, so
// the sheet never lands from a different place depending on who asked.
//
// WAAPI takes numbers, not tokens, so the literals below ARE the tokens: the
// brand timing sequence is base 150 ms × the perfect fourth (1.333) per
// letter — C = 266.5 ms, D = 355.3 ms — and the two curves are the brand's
// springBezier / defaultBezier. __tests__/pageSlotSheetMotion.test.js locks
// every number to the brand token it stands for (and
// pageSlotOverlayLanguage.test.js keeps its lock on `_IOS_EASE`).
//
// NO-BLINK contract: the pane is pre-hidden with an INLINE opacity 0 in the
// same synchronous effect that flips it visible (before the browser paints),
// so it can never flash fully-opaque before the entrance starts.
//
// FRAME-INDEPENDENCE contract (2026-07-12, root cause of "opening sometimes
// does not work"): WAAPI finish/cancel events are dispatched by the "update
// animations and send events" step of RENDERING — a document that produces no
// frames (hidden tab, occluded window, starved main thread) NEVER fires them.
// Verified live: a ?page= restore in a background tab left the pane display:
// flex with the inline pre-hide stuck at 0 — the old stuck-guard cancelled the
// play-pending entrance and its cleanup was itself hostage to the frame-gated
// oncancel. State said "open", so same-route clicks deduped to nothing: the
// slot looked dead until a close healed it. Therefore correctness NEVER rides
// on animation events here:
//   • every run is token-owned (el._runSeq) — starting a new run detaches the
//     old run's handlers, cancels its animation + timer, so no stale callback
//     can act on a superseded state;
//   • every run arms a plain setTimeout backstop that settles the choreography
//     directly (timers fire — merely clamped — where animation events don't);
//     onfinish is only the fast path;
//   • a document that isn't rendering (visibilityState 'hidden') or prefers
//     reduced motion skips animation entirely and lands the final state
//     synchronously — animating for nobody is pure risk;
//   • the hide factory self-heals: an open pane with no run in flight is
//     asserted back to base styles (clears any stranded inline pre-hide).
const $ff11614ac4f941af$var$_IOS_EASE = 'cubic-bezier(0.32, 0.72, 0, 1)' // springBezier — entrances
;
const $ff11614ac4f941af$var$_EXIT_EASE = 'cubic-bezier(0.29, 0.67, 0.51, 0.97)' // defaultBezier — exits
;
const $ff11614ac4f941af$var$_SHEET_ENTER_MS = 355 // timing D
;
const $ff11614ac4f941af$var$_SHEET_EXIT_MS = 267 // timing C
;
// The backstops settle a run whose animation events never arrive (a document
// that renders no frames) — the run's own length plus the slack the old
// numbers carried.
const $ff11614ac4f941af$var$_SHEET_ENTER_BACKSTOP_MS = $ff11614ac4f941af$var$_SHEET_ENTER_MS + 250;
const $ff11614ac4f941af$var$_SHEET_EXIT_BACKSTOP_MS = $ff11614ac4f941af$var$_SHEET_EXIT_MS + 150;
const $ff11614ac4f941af$var$_PANE_ENTER = [
    {
        opacity: 0,
        transform: 'translate3d(0, 2.5%, 0) scale(0.97)'
    },
    {
        opacity: 1,
        transform: 'none'
    }
];
const $ff11614ac4f941af$var$_PANE_EXIT = [
    {
        opacity: 1,
        transform: 'none'
    },
    {
        opacity: 0,
        transform: 'translate3d(0, 2.5%, 0) scale(0.97)'
    }
];
const $ff11614ac4f941af$export$17eaef7c1803f802 = {
    enter: {
        keyframes: $ff11614ac4f941af$var$_PANE_ENTER,
        duration: $ff11614ac4f941af$var$_SHEET_ENTER_MS,
        easing: $ff11614ac4f941af$var$_IOS_EASE
    },
    exit: {
        keyframes: $ff11614ac4f941af$var$_PANE_EXIT,
        duration: $ff11614ac4f941af$var$_SHEET_EXIT_MS,
        easing: $ff11614ac4f941af$var$_EXIT_EASE
    },
    backstop: {
        enter: $ff11614ac4f941af$var$_SHEET_ENTER_BACKSTOP_MS,
        exit: $ff11614ac4f941af$var$_SHEET_EXIT_BACKSTOP_MS
    }
};
// Asked at each use, never at module load (canvas case 2, 2026-11-01): frank
// evaluates module scope in its build sandbox and emits the value it got there
// as data, so a module-load MediaQueryList froze `matches: false` and the
// served canvas animated for a person who asked for reduced motion. A function
// is emitted as a function (the `_canvasIsPhone` shape below).
const $ff11614ac4f941af$var$_prefersReducedMotion = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ff11614ac4f941af$var$_clearInline = (el)=>{
    if (el.node && el.node.style) {
        el.node.style.opacity = '';
        // …and the inline translate the phone drag-to-dismiss gesture parks on the
        // pane. A run's settle IS the gesture's self-heal: a committed dismissal
        // must never leave the sheet translated for its next open.
        el.node.style.transform = '';
    }
};
// A pane animates only when someone can see it AND wants motion.
const $ff11614ac4f941af$var$_canAnimate = (el)=>!!(el.node && typeof el.node.animate === 'function') && typeof document !== 'undefined' && document.visibilityState !== 'hidden' && !$ff11614ac4f941af$var$_prefersReducedMotion();
// ── Focus in, focus back (DESIGN_SPEC §6.6) ─────────────────────────────────
//
// Opening a window moves focus INTO it and closing it hands focus back to
// what held it before: the widget title, the launcher tile, the search
// result's return target. (The window is not a modal dialog — see the note on
// the frame — so Tab still reaches the composer floating over it.) The PANE takes the focus
// (`tabindex: -1`, labelled by its title), so a screen reader names the window
// first; a page that focuses its own field when it mounts (a composer, a
// search box) still wins, because it mounts after.
//
// It never steals: not while the header search is open (a split pick is typed
// there), not for the split pane's placeholder (no route yet — the search owns
// the keyboard), and not when focus already sits inside the pane. And it never
// hands focus back INTO a field: a field's own focus handler can open
// something (the header search's launcher does), and no sheet is opened from
// one.
const $ff11614ac4f941af$var$_isField = (n)=>{
    if (!n || n.nodeType !== 1) return false;
    const tag = String(n.tagName || '').toLowerCase();
    return !!(n.isContentEditable || tag === 'input' || tag === 'textarea' || tag === 'select' || typeof n.getAttribute === 'function' && [
        'textbox',
        'combobox',
        'searchbox'
    ].includes(n.getAttribute('role')));
};
// What held focus at a pane's open edge — the target focus returns to.
const $ff11614ac4f941af$var$_focusOrigin = (el)=>{
    if (typeof document === 'undefined') return null;
    const a = document.activeElement;
    if (!a || a === document.body || $ff11614ac4f941af$var$_isField(a)) return null;
    if (el.node && typeof el.node.contains === 'function' && el.node.contains(a)) return null;
    return a;
};
const $ff11614ac4f941af$var$_focusPaneIn = (el)=>{
    const node = el.node;
    if (!node || typeof node.focus !== 'function' || typeof document === 'undefined') return;
    const rootEl = el.getRoot && el.getRoot();
    const root = rootEl && rootEl.state;
    if (!root || !root[el.scope?.SLOT_KEY] || root._headerSearchOpen) return;
    const active = document.activeElement;
    if (active && active !== document.body && node.contains(active)) return;
    try {
        node.focus({
            preventScroll: true
        });
    } catch (_) {
    /* a detached node takes no focus — nothing to move */ }
};
// Only when the keyboard is IN the closing pane (or nowhere): focus that has
// already moved on (the X of the surviving pane, the header) stays put.
const $ff11614ac4f941af$var$_returnPaneFocus = (el, root)=>{
    const target = el._returnFocus;
    el._returnFocus = null;
    if (typeof document === 'undefined') return;
    const node = el.node;
    const active = document.activeElement;
    const lost = !active || active === document.body;
    if (!lost && !(node && typeof node.contains === 'function' && node.contains(active))) return;
    const usable = (n)=>!!n && n.isConnected !== false && typeof n.focus === 'function' && !$ff11614ac4f941af$var$_isField(n) && !(node && node.contains(n));
    if (usable(target)) try {
        target.focus({
            preventScroll: true
        });
        return;
    } catch (_) {
    /* fall through to the surviving pane */ }
    // The split pane closing (its X, Escape, a veil press) with the primary still
    // open: the keyboard goes to the window that stays.
    const frame = el.parent;
    const other = frame && (el.scope?.primary ? frame.PaneSecond : frame.PanePrimary);
    const otherOpen = other && root && root[other.scope?.SLOT_KEY];
    if (otherOpen && other.node && typeof other.node.focus === 'function') try {
        other.node.focus({
            preventScroll: true
        });
    } catch (_) {
    /* noop */ }
};
// ── Phone sheet (≤ mobileL) ────────────────────────────────────────────────
//
// On a phone the slot stops being a floating card and becomes an iOS sheet: it
// owns the screen edge-to-edge, keeps a thin reveal of the scrimmed app above
// it so it still reads as a LAYER (not a new screen), and answers to the
// platform's phone gesture vocabulary — the same verbs the left-edge rail pull
// teaches (shared/functions/edgeSwipe.js): follow the finger with a
// transform-only write, commit past a fraction or a flick, otherwise settle
// back on the iOS curve. Geometry is CSS-gated at `@mobileL` (desktop/tablet
// bytes unchanged); the gesture is additionally gated coarse-pointer, so a
// touchscreen laptop above 768 never arms it either.
const $ff11614ac4f941af$var$_PHONE_MQ = '(max-width: 768px)';
// Sheet top inset = notch/status-bar inset + a ~10px reveal (spacing Z) of the
// page behind. Same env()+token form the shell's own --shell-top uses (app.js:
// `calc(var(--spacing-C1) + 3px + env(safe-area-inset-top))`), so the sheet
// clears hardware exactly the way every other chrome island does — and the
// reveal is a TOKEN, not a magic pixel count.
const $ff11614ac4f941af$var$_PHONE_TOP = 'calc(env(safe-area-inset-top) + var(--spacing-Z))';
const $ff11614ac4f941af$var$_canvasIsPhone = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia($ff11614ac4f941af$var$_PHONE_MQ).matches;
// THE PHONE SHEET OWNS EVERY STATE. The four conditional blocks on PageSlot
// (.isSlotFullscreen, .isSlotRailEdge, .isSlotExpanded, .isSlotRailInset)
// paint INLINE, so the '@mobileL' rule that collapses each of them to the
// sheet never outranks them: measured on dev (Bellforge, 390px), the admin's
// expanded default kept `bottom: var(--slot-bottom)` inline and the sheet
// stopped 74px short of the screen edge. On a phone none of them applies.
// `_isPhoneViewport` is the shell's answer (its phone dock and rail sheets
// publish it); a host that never publishes it falls back to the query.
const $ff11614ac4f941af$var$_slotOnPhone = (root)=>root?._isPhoneViewport === true || root?._isPhoneViewport == null && $ff11614ac4f941af$var$_canvasIsPhone();
// Commit thresholds. The fraction is the sheet's own height (25% per the phone
// sheet grammar); the flick velocity mirrors edgeSwipe's FLICK_PX_PER_MS so a
// quick throw feels the same everywhere. The axis slop matches it too — below
// it nothing moves, so a tap on a header button is never a drag.
const $ff11614ac4f941af$var$_DRAG_COMMIT_FRACTION = 0.25;
const $ff11614ac4f941af$var$_DRAG_FLICK_PX_PER_MS = 0.35;
const $ff11614ac4f941af$var$_DRAG_AXIS_SLOP = 8;
// The grip regions: the grabber pill and the pane header. The sheet BODY is
// left alone — it scrolls.
const $ff11614ac4f941af$var$_GRIP_SELECTOR = '[data-sheet-grip]';
// Read the pane's live translateY, so an interrupted settle is picked up
// exactly where it was rather than snapping to 0. Read BEFORE cancelling the
// animation — computed style carries the animated value only while it runs.
const $ff11614ac4f941af$var$_currentTranslateY = (node)=>{
    try {
        const t = window.getComputedStyle(node).transform;
        if (!t || t === 'none') return 0;
        return new window.DOMMatrixReadOnly(t).m42 || 0;
    } catch (_) {
        return 0;
    }
};
// Tear down a settle run (animation + backstop timer) WITHOUT touching the
// inline transform — the caller decides where the sheet should sit next.
// Handlers are detached before cancel, same frame-independence discipline the
// open/close runs use above.
const $ff11614ac4f941af$var$_cancelDragAnim = (el)=>{
    if (el._dragT) {
        clearTimeout(el._dragT);
        el._dragT = null;
    }
    const anim = el._dragAnim;
    el._dragAnim = null;
    if (anim) {
        anim.onfinish = null;
        anim.oncancel = null;
        try {
            if (anim.playState !== 'finished') anim.cancel();
        } catch (_) {
        /* noop */ }
    }
};
// Released below the commit threshold → ride back to rest. Interruptible (a new
// grab cancels it and continues from the live offset), and — like every run in
// this file — never dependent on the animation event: a timer backstop clears
// the inline transform even in a document that stops producing frames, and a
// reduced-motion / hidden document lands it instantly.
const $ff11614ac4f941af$var$_dragSettleBack = (el)=>{
    const node = el.node;
    $ff11614ac4f941af$var$_cancelDragAnim(el);
    if (!node || !node.style) return;
    const from = node.style.transform;
    const done = ()=>{
        $ff11614ac4f941af$var$_cancelDragAnim(el);
        if (el.node && el.node.style) el.node.style.transform = '';
    };
    if (!from || !$ff11614ac4f941af$var$_canAnimate(el)) return done();
    let anim = null;
    try {
        anim = node.animate([
            {
                transform: from
            },
            {
                transform: 'none'
            }
        ], {
            duration: 260,
            easing: $ff11614ac4f941af$var$_IOS_EASE
        });
    } catch (_) {
    /* fall through to an instant snap back */ }
    if (!anim) return done();
    el._dragAnim = anim;
    anim.onfinish = done;
    anim.oncancel = done;
    el._dragT = setTimeout(done, 420);
};
// Drag-to-dismiss on a phone pane. The four pointer handlers are DECLARED on
// the pane (see `onPointerdown` / `onPointermove` / `onPointerup` /
// `onPointercancel` in `_slotPane`); this factory builds them once per pane
// element and caches them on `el.__sheetDrag`.
//
// They used to be four raw `node.addEventListener(..., { passive: true })`
// calls armed from `onRender` behind a `node.__sheetDragArmed` flag, removed
// nowhere (FA503). Nothing about the GESTURE changed — only who owns the
// registration. Two things got better on the way:
//   • the handlers now read `el.node` LIVE instead of closing over one node,
//     so a node re-creation (keep-alive slot re-mount) can no longer leave the
//     gesture pointing at a dead node;
//   • `pointercancel` is not in smbls's DELEGATED_EVENTS, so it becomes a real
//     node listener that dispose() removes — the one whose absence strands a
//     half-dragged sheet mid-screen.
//
// Listeners stay PASSIVE-safe: `touch-action: none` on the grip regions stops
// the browser claiming the vertical pan, so nothing here ever needs
// preventDefault.
//
// `undefined` = not decided yet; `null` = decided NO (a fine pointer), cached
// so a desktop pointermove never re-asks.
const $ff11614ac4f941af$var$_sheetDragHandlers = (el)=>{
    if (el.__sheetDrag !== undefined) return el.__sheetDrag;
    const node = el.node;
    if (!node) return null // no node yet — decide on the next event, don't cache
    ;
    // Coarse pointers only — desktop/tablet-with-mouse keeps the header's Close
    // button as its single dismissal.
    if (typeof el.call === 'function' && !el.call('isCoarsePointer')) {
        el.__sheetDrag = null;
        return null;
    }
    const primary = el.scope?.primary;
    const slotKey = el.scope?.SLOT_KEY;
    // Transient gesture state — closure-local, never reactive (the edgeSwipe /
    // longPress idiom: a mid-gesture y coordinate has no business in signals).
    let tracking = false;
    let captured = false;
    let base = 0;
    let startX = 0;
    let startY = 0;
    let startTs = 0;
    let lastY = 0;
    let lastTs = 0;
    let axis = null;
    const rootState = ()=>typeof el.getRootState === 'function' ? el.getRootState() : el.state && el.state.root;
    const paint = (y)=>{
        if (!el.node || !el.node.style) return;
        el.node.style.transform = y > 0 ? `translateY(${Math.round(y)}px)` : '';
    };
    const stop = (e)=>{
        tracking = false;
        el._dragging = false;
        if (!captured) return;
        captured = false;
        try {
            el.node.releasePointerCapture(e.pointerId);
        } catch (_) {
        /* noop */ }
    };
    const onDown = (e)=>{
        if (e.pointerType === 'mouse' || !$ff11614ac4f941af$var$_canvasIsPhone()) return;
        const t = e.target;
        if (!t || typeof t.closest !== 'function' || !t.closest($ff11614ac4f941af$var$_GRIP_SELECTOR)) return;
        // Never fight the open/close choreography — a run owns the transform while
        // it is in flight.
        if (el._anim || el._enterQueued || el._closing) return;
        // Interruptible: a new grab picks the sheet up wherever the settle left it.
        base = el._dragAnim ? Math.max(0, $ff11614ac4f941af$var$_currentTranslateY(el.node)) : 0;
        $ff11614ac4f941af$var$_cancelDragAnim(el);
        tracking = true;
        el._dragging = true;
        captured = false;
        axis = null;
        startX = e.clientX;
        startY = lastY = e.clientY;
        startTs = lastTs = e.timeStamp;
    };
    const onMove = (e)=>{
        if (!tracking) return;
        const dy = e.clientY - startY;
        const dx = e.clientX - startX;
        if (!axis) {
            if (Math.abs(dy) < $ff11614ac4f941af$var$_DRAG_AXIS_SLOP && Math.abs(dx) < $ff11614ac4f941af$var$_DRAG_AXIS_SLOP) return;
            // A horizontal intent on the header is not a dismissal — drop the
            // gesture rather than fighting whatever owns that axis.
            axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'veto';
            if (axis === 'y') {
                // Capture only once it IS a drag: capturing on pointerdown would
                // swallow taps on the header's own buttons.
                captured = true;
                try {
                    el.node.setPointerCapture(e.pointerId);
                } catch (_) {
                    captured = false;
                }
            }
        }
        if (axis !== 'y') {
            stop(e);
            return;
        }
        lastY = e.clientY;
        lastTs = e.timeStamp;
        // Downward only; an upward pull holds the sheet at rest (no rubber band —
        // there is nothing above it to reveal).
        paint(Math.max(0, base + dy));
    };
    const onUp = (e)=>{
        if (!tracking) return;
        const wasAxis = axis;
        if (typeof e.clientY === 'number') lastY = e.clientY;
        lastTs = e.timeStamp;
        stop(e);
        if (wasAxis !== 'y') return;
        const travel = Math.max(0, base + (lastY - startY));
        const height = el.node.getBoundingClientRect().height || 1;
        const dt = Math.max(1, lastTs - startTs);
        const flick = (lastY - startY) / dt;
        if (travel < height * $ff11614ac4f941af$var$_DRAG_COMMIT_FRACTION && flick < $ff11614ac4f941af$var$_DRAG_FLICK_PX_PER_MS) {
            $ff11614ac4f941af$var$_dragSettleBack(el);
            return;
        }
        // Committed. Hand the finger's offset to the EXISTING exit choreography so
        // the sheet keeps moving from where it was let go, then close through the
        // ONE dismissal path (_dismissPane — the header CloseBtn's own).
        $ff11614ac4f941af$var$_cancelDragAnim(el);
        el._dragFrom = travel;
        const root = rootState();
        $ff11614ac4f941af$var$_dismissPane(root, primary);
        // …except when that path PROMOTES instead of closing: dismissing a primary
        // that has a split pane open hands it the surviving route, so this pane
        // stays mounted and never runs an exit. Ride the offset back to rest rather
        // than stranding the sheet mid-screen.
        if (root && root[slotKey]) {
            el._dragFrom = 0;
            $ff11614ac4f941af$var$_dragSettleBack(el);
        }
    };
    el.__sheetDrag = {
        onDown: onDown,
        onMove: onMove,
        onUp: onUp
    };
    return el.__sheetDrag;
};
// Begin a choreography run: invalidate the previous run (its settle becomes a
// no-op via the token), detach its handlers BEFORE cancelling (so no event can
// fire for it even when frames resume later), and clear its backstop timer.
const $ff11614ac4f941af$var$_startRun = (el)=>{
    const token = el._runSeq = (el._runSeq || 0) + 1;
    if (el._runT) {
        clearTimeout(el._runT);
        el._runT = null;
    }
    const prev = el._anim;
    el._anim = null;
    if (prev) {
        prev.onfinish = null;
        prev.oncancel = null;
        try {
            prev.cancel();
        } catch (_) {
        /* noop */ }
    }
    return token;
};
// The ONE idempotent settle for a run: tears down the animation, restores base
// styles, then runs the transition's tail work. Safe from any caller — event,
// backstop timer, or synchronous skip — and inert once superseded.
const $ff11614ac4f941af$var$_finishRun = (el, token, tail)=>()=>{
        if (el._runSeq !== token) return;
        if (el._runT) {
            clearTimeout(el._runT);
            el._runT = null;
        }
        const anim = el._anim;
        el._anim = null;
        if (anim) {
            anim.onfinish = null;
            anim.oncancel = null;
            try {
                if (anim.playState !== 'finished') anim.cancel();
            } catch (_) {
            /* noop */ }
        }
        $ff11614ac4f941af$var$_clearInline(el);
        if (tail) tail();
    };
const $ff11614ac4f941af$var$_paneEnter = (el)=>{
    const token = $ff11614ac4f941af$var$_startRun(el);
    el._closing = false;
    const settle = $ff11614ac4f941af$var$_finishRun(el, token);
    // Focus moves IN (DESIGN_SPEC §6.6) before the entrance — the sheet is
    // modal, so the keyboard follows the eye. Independent of the animation: a
    // document that renders no frames (or prefers reduced motion) lands the
    // final state at once and still gets the focus.
    $ff11614ac4f941af$var$_focusPaneIn(el);
    if (!$ff11614ac4f941af$var$_canAnimate(el)) return settle();
    let anim = null;
    try {
        // The inline opacity 0 was already applied by the hide factory
        // (pre-paint); the enter keyframes take over from that same value.
        anim = el.node.animate($ff11614ac4f941af$var$_PANE_ENTER, {
            duration: $ff11614ac4f941af$var$_SHEET_ENTER_MS,
            easing: $ff11614ac4f941af$var$_IOS_EASE
        });
    } catch (_) {
    /* fall through to instant show */ }
    if (!anim) return settle();
    el._anim = anim;
    anim.onfinish = settle;
    anim.oncancel = settle;
    el._runT = setTimeout(settle, $ff11614ac4f941af$var$_SHEET_ENTER_BACKSTOP_MS);
};
// A drag-committed dismissal continues from the finger's last offset and throws
// the sheet off the bottom edge, instead of snapping back to 0 and fading in
// place (what _PANE_EXIT does for a click-close). Same duration/easing, so the
// close choreography, its backstop and its tail work are untouched — only the
// keyframes differ, and only when a drag set _dragFrom.
const $ff11614ac4f941af$var$_paneThrow = (from)=>[
        {
            opacity: 1,
            transform: `translateY(${Math.round(from)}px)`
        },
        {
            opacity: 0,
            transform: 'translateY(100%)'
        }
    ];
const $ff11614ac4f941af$var$_paneExit = (el, root)=>{
    const token = $ff11614ac4f941af$var$_startRun(el);
    el._closing = true;
    // Consume the gesture's offset exactly once — a later click-close must get
    // the plain exit back.
    const dragFrom = el._dragFrom;
    el._dragFrom = 0;
    const settle = $ff11614ac4f941af$var$_finishRun(el, token, ()=>{
        el._closing = false;
        // Re-run the hide effect via a STATE nudge — `el.update({})` does not
        // re-evaluate reactive props, and effects only re-run on signals READ in
        // the factory (see the two OPEN tickets in tickets/smbls.md), so the
        // factory reads _slotNudge.
        try {
            root && root.update && root.update({
                _slotNudge: (root._slotNudge || 0) + 1
            });
        } catch (_) {
        /* torn down mid-close */ }
    });
    // Focus goes back where it was before the pane opened (DESIGN_SPEC §6.6),
    // at the START of the close — the pane is on its way out, and a keyboard
    // user must not sit inside a fading sheet.
    $ff11614ac4f941af$var$_returnPaneFocus(el, root);
    if (!$ff11614ac4f941af$var$_canAnimate(el)) return settle();
    let anim = null;
    try {
        anim = el.node.animate(dragFrom ? $ff11614ac4f941af$var$_paneThrow(dragFrom) : $ff11614ac4f941af$var$_PANE_EXIT, {
            duration: $ff11614ac4f941af$var$_SHEET_EXIT_MS,
            easing: $ff11614ac4f941af$var$_EXIT_EASE
        });
    } catch (_) {
    /* fall through to instant hide */ }
    if (!anim) return settle();
    el._anim = anim;
    anim.onfinish = settle;
    anim.oncancel = settle;
    el._runT = setTimeout(settle, $ff11614ac4f941af$var$_SHEET_EXIT_BACKSTOP_MS);
};
// Schedule the entrance from the hide factory itself. A microtask runs after
// the whole update pass (display applied, node attached) but BEFORE the next
// paint — so the inline pre-hide still can't flash, and the enter no longer
// depends on onCreate/onUpdate ordering. (Verified live 2026-07-12: on repeat
// opens the hide effect can run AFTER the element's own update hooks — or as
// an isolated signal effect with no hooks at all — so a "pending" flag flushed
// from onUpdate strands the pane at the inline opacity 0.) The _paneShown
// check makes a same-tick close cancel the queued entrance.
const $ff11614ac4f941af$var$_queueEnter = (el)=>{
    if (el._enterQueued) return;
    el._enterQueued = true;
    queueMicrotask(()=>{
        el._enterQueued = false;
        if (el._paneShown) $ff11614ac4f941af$var$_paneEnter(el);
    });
};
// Mount the pane's page def into its per-route KEEP-ALIVE HOST (see the
// minimize-to-dock section above). A route whose host already exists is a
// keep-alive hit: NO re-mount — the host's display predicate reveals the
// SAME element instance, which is the whole minimize/restore contract. A
// same-route open with a DIFFERENT query re-mounts fresh (`_slotPath`),
// matching the old single-mount semantics for deep links. The heavy page
// prep stays DEFERRED past the next paint: smbls element preparation is
// synchronous and super-linear in page size, so setting inline at click
// blocked the frame — the sheet appeared late and "blinked" (2026-07-12 per
// Nika "opening is slow and blinks"). `_lastSlot` doubles as the in-flight
// dedupe guard; the seq guards a rapid route switch from a stale late set;
// the timer is the fallback for throttled tabs where rAF crawls.
// Release the in-flight/dedupe guard when a DEFERRED apply() bails without
// producing a host.
//
// `_lastSlot` is written the moment a mount is REQUESTED, but the host is
// only created a frame later inside apply(). Every early return in there —
// no `context.__create`, a `__create` that produced no `__ref`, a page def
// that throws inside `set()` — used to leave `_lastSlot` naming a host that
// does not exist. From then on `_mountPane`'s own `if (el._lastSlot === path)
// return` refused every later attempt at that route, so the pane stayed
// EMPTY FOREVER — it rendered its apps rail and nothing else, with no
// `_slotPath` host under it, and none of the retry subscriptions
// (`workspaceProject`, `_minimizedSlots`, `_slotNudge`) could heal it because
// they all funnel through that same guard. Exactly the shape of the
// second-pane mount gap the D2 split-pane pass reported.
//
// Only the apply that still OWNS the mount-seq may release it: a newer
// request has already re-pointed `_lastSlot` at its own route and must not
// have its guard cleared by a superseded predecessor.
const $ff11614ac4f941af$var$_releaseMountGuard = (el, path, seq)=>{
    if (seq !== el._mountSeq) return;
    if (el._lastSlot === path) el._lastSlot = null;
};
// Run `fn` AFTER the next paint, never before it. A rAF callback runs BEFORE
// its own frame's paint, so the old `requestAnimationFrame(apply)` prepared
// the page inside the very frame that should have SHOWN the window — the
// window (and its entrance) waited for the whole page. A rAF queued from a
// rAF runs in the FOLLOWING frame, after the first one painted the window and
// its skeleton. The plain timer is the backstop for a document that renders
// no frames (a hidden tab, where rAF never fires) — the 120 ms the mount
// always carried. `apply` itself is idempotent and seq-guarded, so whichever
// fires first wins and the other is a no-op.
const $ff11614ac4f941af$var$_afterPaint = (fn, setFallback)=>{
    if (typeof requestAnimationFrame !== 'function') return fn();
    requestAnimationFrame(()=>requestAnimationFrame(fn));
    setFallback(setTimeout(fn, 120));
};
// The skeleton first (see `PageSkeleton`): create the route's keep-alive host
// NOW — cheap, one small subtree — with the skeleton as its content. The host
// is stamped for the sweep (its route, workspace and pane, so it is the
// ACTIVE host and survives) but NOT with `_slotPath`: that stamp means "the
// page is mounted", which is what the keep-alive fast path reveals. Instead
// `_slotPending` names the route whose page is on its way. Best-effort: with
// no skeleton registered (a context without the canvas slice) or no create
// path, the window opens exactly as before and the page lands on its own.
const $ff11614ac4f941af$var$_showSkeleton = (el, s, SLOT_KEY, clean, path)=>{
    if (!el.context?.components?.PageSkeleton) return;
    const createFn = el.context?.__create;
    if (!createFn) return;
    const hostKey = $ff11614ac4f941af$var$_hostKeyFor(clean);
    try {
        if (!el[hostKey] || !el[hostKey].__ref) createFn($ff11614ac4f941af$var$_hostDef(clean, SLOT_KEY), el, hostKey);
        const host = el[hostKey];
        if (!host || !host.__ref || typeof host.set !== 'function') return;
        host._slotHref = clean;
        host._slotWs = $ff11614ac4f941af$var$_canvasWsIdOf(s.root);
        host._slotPaneKey = SLOT_KEY;
        host._slotPending = path;
        host.set({
            extends: 'PageSkeleton'
        });
    } catch (_) {
    /* the page's own mount still lands */ }
};
// A family host's first mount gets the same skeleton, in its Body (the swap
// target); its Chrome stays empty until the apply mounts it once.
const $ff11614ac4f941af$var$_showFamilySkeleton = (el, s, SLOT_KEY, clean, family, hostKey)=>{
    if (!el.context?.components?.PageSkeleton) return;
    const createFn = el.context?.__create;
    if (!createFn || el[hostKey] && el[hostKey].__ref) return;
    try {
        createFn($ff11614ac4f941af$var$_familyHostDef(family, SLOT_KEY), el, hostKey);
        const host = el[hostKey];
        if (!host || !host.__ref || !host.Body || typeof host.Body.set !== 'function') return;
        host._slotHref = clean;
        host._slotFamily = family.id;
        host._slotWs = $ff11614ac4f941af$var$_canvasWsIdOf(s.root);
        host._slotPaneKey = SLOT_KEY;
        host.Body.set({
            extends: 'PageSkeleton'
        });
    } catch (_) {
    /* the page's own mount still lands */ }
};
const $ff11614ac4f941af$var$_mountPane = (el, s, SLOT_KEY)=>{
    const path = s.root?.[SLOT_KEY];
    if (!path) return;
    const clean = $ff11614ac4f941af$var$canvasCleanHref(path);
    // Family routes take the shared-host path: Chrome persists, Body swaps.
    const family = $ff11614ac4f941af$var$_familyOf(s.root, clean);
    if (family && family.id) {
        $ff11614ac4f941af$var$_mountFamilyPane(el, s, SLOT_KEY, path, clean, family);
        return;
    }
    const hostKey = $ff11614ac4f941af$var$_hostKeyFor(clean);
    const live = el[hostKey];
    if (live && live.__ref) {
        if (live._slotPath === path) {
            // Keep-alive hit — reveal only. Nothing here (or anywhere) re-creates
            // the element, so scroll, inputs, timers and in-flight work persist.
            // LRU stamp: a reveal counts as use (module keep-alive eviction order).
            live._slotSeenAt = Date.now();
            el._lastSlot = path;
            return;
        }
        // The skeleton is up for THIS route and its page is on the way (the
        // deferred apply below owns it): a re-render in between waits for it
        // instead of tearing the skeleton down and starting over.
        if (live._slotPending === path && el._lastSlot === path) return;
        // Same route, different query — a deep-link change re-mounts, exactly
        // like the pre-host `el.set` replacement did.
        if ($ff11614ac4f941af$var$canvasCleanHref(el._lastSlot) === clean) el._lastSlot = null;
        live.remove();
    }
    if (el._lastSlot === path) return;
    const def = $ff11614ac4f941af$var$_defFor(el, path, s.root);
    if (!def) return;
    el._lastSlot = path;
    const seq = el._mountSeq = (el._mountSeq || 0) + 1;
    // THE SHELL FIRST: the host exists now, with the skeleton as its content,
    // so the window paints a page-shaped skeleton in the very next frame.
    $ff11614ac4f941af$var$_showSkeleton(el, s, SLOT_KEY, clean, path);
    let applied = false;
    let fallbackT = null;
    const apply = ()=>{
        if (applied || seq !== el._mountSeq) return;
        applied = true;
        if (fallbackT) clearTimeout(fallbackT);
        try {
            // Create the keep-alive host through the same context `__create` path
            // `el.set()` uses internally (methods.js), then mount the page INTO it
            // — `set` keeps its contentManaged semantics per host.
            const createFn = el.context?.__create;
            if (!createFn) return $ff11614ac4f941af$var$_releaseMountGuard(el, path, seq);
            if (!el[hostKey] || !el[hostKey].__ref) createFn($ff11614ac4f941af$var$_hostDef(clean, SLOT_KEY), el, hostKey);
            const host = el[hostKey];
            if (!host || !host.__ref) return $ff11614ac4f941af$var$_releaseMountGuard(el, path, seq);
            // Workspace stamp + full-path identity — consumed by the sweep and the
            // query-change re-mount above.
            host._slotHref = clean;
            host._slotPath = path;
            host._slotPending = null;
            host._slotWs = $ff11614ac4f941af$var$_canvasWsIdOf(s.root);
            // LRU stamp for the module keep-alive plan (_moduleKeepPlan).
            host._slotSeenAt = Date.now();
            // Pane identity for the split-view pane-scoping contract: openers fired
            // from INSIDE a mounted page resolve their origin pane by walking to
            // this stamp (shared/functions/slotPane.js slotPaneKeyFor), so an
            // in-pane navigation targets its OWN pane's slot key — never the
            // sibling's.
            host._slotPaneKey = SLOT_KEY;
            // Strip page-grid placement (gridRow/gridColumn target the shell's
            // content row, not a slot) and make the def fill the host — unless it
            // is a content-sized page (an answer view, slotPageFill.js).
            host.set({
                ...def,
                // `context` explicitly: workspace-module defs carry a NON-ENUMERABLE
                // design-system context (workspaceProjects.js _wrapModulePages) and
                // spread copies only enumerable props — without this line the module
                // page mounts against the SHELL config and every module token
                // resolves wrong ("navy" → CSS keyword, "paper" drops).
                context: def.context,
                tag: 'div',
                // A pane is a labelled region (the frame's role="region"), never a
                // second main: the route-level stamps a def carries (workspace
                // context.js anchorMainContent — role main + #main-content) step back
                // here, and a lazy page's placeholder drops its page's own the same
                // way (pages/lazyPage.js lazyPageUnanchor reads this host's
                // `_slotPaneKey`). WS-SHELL-APP-ROUTES-NO-MAIN-LANDMARK-1.
                ...def.role === 'main' ? {
                    role: null
                } : {},
                ...def.id === 'main-content' ? {
                    id: null
                } : {},
                ...def.attr && def.attr.id === 'main-content' ? {
                    attr: {
                        ...def.attr,
                        id: null
                    }
                } : {},
                gridRow: null,
                gridColumn: null,
                ...(0, $bwwwL.slotPageFillProps)(def)
            });
            // The mounted page's helmet just wrote ITS title — hand it back to the
            // primary (a second-pane mount must not keep the tab title).
            $ff11614ac4f941af$var$_syncSlotTitle(el, s.root);
        } catch (err) {
            console.warn('[PageSlot] mount failed:', err);
            // A HALF-MOUNTED host is worse than no host at all. The stamps land
            // BEFORE `set()` on purpose (the page's own onCreate/onRender run
            // inside `set` and read `_slotPath` — that is the "read the deep-link
            // param AT MOUNT" contract), so a def that throws in `set` leaves a
            // host whose stamps already claim the route with nothing inside it.
            // The keep-alive fast path at the top of `_mountPane` would then match
            // `live._slotPath === path` and REVEAL that empty host on every later
            // open of the route, forever. Drop it, then release the guard.
            try {
                const halfMounted = el[hostKey];
                if (halfMounted && halfMounted.__ref) halfMounted.remove();
            } catch (_) {
            /* already detached */ }
            $ff11614ac4f941af$var$_releaseMountGuard(el, path, seq);
        }
    };
    $ff11614ac4f941af$var$_afterPaint(apply, (t)=>{
        fallbackT = t;
    });
};
// Family-host mount — _mountPane's sibling for family routes. Mirrors its
// dedupe guard, mount-seq race guard and rAF deferral; differs in the swap:
// a same-family route change re-`set`s ONLY `host.Body`, leaving the
// Chrome subtree (and its DOM nodes) untouched.
//
// "Nothing to do" is decided from `el._lastSlot` ALONE — updated
// synchronously below, on every request. The live host's OWN `_slotPath`
// stamp is NOT a safe substitute for that check: it only updates once a
// DEFERRED apply() actually runs (rAF, or the setTimeout fallback), so on
// a family host — where two DIFFERENT routes share one `hostKey` — a
// second request arriving before the first one's apply() has fired would
// read that STALE stamp as "already showing this" and return early
// WITHOUT invalidating the in-flight mount-seq. Reproduced live
// (packages/canvas/__tests__/pageSlotFamilyHost.test.js "a rapid second
// navigation…"): settle on route A, click to sibling route B (left
// in-flight, not yet applied), then click BACK to A before B's apply()
// runs — B's request matches the host's not-yet-updated `_slotPath` from
// before A ever applied, so the click-back-to-A request returned early,
// A's mount-seq bump never happened, and B's stale apply() won the race
// and landed in Body instead of A.
const $ff11614ac4f941af$var$_mountFamilyPane = (el, s, SLOT_KEY, path, clean, family)=>{
    if (el._lastSlot === path) return;
    const hostKey = $ff11614ac4f941af$var$_familyHostKey(family.id);
    const def = $ff11614ac4f941af$var$_defFor(el, path, s.root);
    if (!def) return;
    el._lastSlot = path;
    const seq = el._mountSeq = (el._mountSeq || 0) + 1;
    // The skeleton first, as for a per-route host — but only for a family's
    // FIRST mount: a sibling route swaps an already-painted Body in place.
    $ff11614ac4f941af$var$_showFamilySkeleton(el, s, SLOT_KEY, clean, family, hostKey);
    let applied = false;
    let fallbackT = null;
    const apply = ()=>{
        if (applied || seq !== el._mountSeq) return;
        applied = true;
        if (fallbackT) clearTimeout(fallbackT);
        try {
            const createFn = el.context?.__create;
            if (!createFn) return $ff11614ac4f941af$var$_releaseMountGuard(el, path, seq);
            if (!el[hostKey] || !el[hostKey].__ref) createFn($ff11614ac4f941af$var$_familyHostDef(family, SLOT_KEY), el, hostKey);
            const host = el[hostKey];
            if (!host || !host.__ref) return $ff11614ac4f941af$var$_releaseMountGuard(el, path, seq);
            host._slotHref = clean;
            host._slotPath = path;
            host._slotFamily = family.id;
            host._slotWs = $ff11614ac4f941af$var$_canvasWsIdOf(s.root);
            host._slotPaneKey = SLOT_KEY;
            // Chrome mounts ONCE per host — the family contract: intra-family
            // route swaps must not touch these DOM nodes. The chrome def resolves
            // through the SAME `_defFor` channel as pages (`chromePath` — a
            // pseudo-page the family package registers), so it stays in the
            // family's lazy chunk and folds its context exactly like a page.
            // "Once" is the host's own stamp, not "the host is new": the skeleton
            // may have created the host a frame before this apply.
            const chromeDef = family.chromePath ? $ff11614ac4f941af$var$_defFor(el, family.chromePath, s.root) : family.chrome || null;
            if (!host._slotChromeSet && chromeDef && host.Chrome) {
                host.Chrome.set({
                    ...chromeDef,
                    context: chromeDef.context || def.context,
                    tag: 'div'
                });
                host._slotChromeSet = true;
            }
            if (host.Body) host.Body.set({
                ...def,
                context: def.context,
                tag: 'div',
                gridRow: null,
                gridColumn: null,
                height: '100%',
                minHeight: '100%'
            });
            $ff11614ac4f941af$var$_syncSlotTitle(el, s.root);
        } catch (err) {
            console.warn('[PageSlot] family mount failed:', err);
            // Same recovery as the per-route host above: a family host whose
            // Chrome or Body threw is stamped for a route it never rendered, and
            // the fast path would keep revealing it. Drop the whole host — a
            // retry re-mounts Chrome and Body together.
            try {
                const halfMounted = el[hostKey];
                if (halfMounted && halfMounted.__ref) halfMounted.remove();
            } catch (_) {
            /* already detached */ }
            $ff11614ac4f941af$var$_releaseMountGuard(el, path, seq);
        }
    };
    $ff11614ac4f941af$var$_afterPaint(apply, (t)=>{
        fallbackT = t;
    });
};
// ── Header left cluster + apps rail (2026-08-06 per Nika "when we navigate
// accross pageslots - we shuld also support back and forward navigations in
// pageslots. add it on the left side before pageslot title. also support
// sidebar view in pageslot thats quick access for all available pageslot
// apps. so left arrpw, right arrow, sidebar toggle that opens new pageslot
// sidebar that has navigation floating above it for pageslot apps — make it
// smooth and beautiful") ───────────────────────────────────────────────────
// One recipe for both arrows — the right cluster's PageSlotHeaderBtn
// geometry, quieted to a dimmed no-op when its direction has no history
// (kept in the layout so the cluster never reflows). Disabled = opacity +
// pointerEvents + aria-disabled; the native `disabled` attr is deliberately
// avoided (it drops the button from the tab order and mutes the tooltip).
// STRICTLY PANE-SCOPED: reads/writes THIS pane's history + slot key only.
//
// FRANK-SAFE BY CONSTRUCTION (2026-08-12, tickets/opus.md "~800 project-side
// Frankability defects" — canvas's PageSlot factory-closure-capture class):
// `HIST_KEY`/`SLOT_KEY`/`back` used to be plain JS closures over THIS
// factory's own params/locals. A closure over a factory param/local doesn't
// survive frank.toJSON — it lifts every reactive prop into a standalone
// function, and a free variable that is neither that function's own
// parameter nor a module-scope const resolves to nothing at eval-revival
// time (a guaranteed ReferenceError/undefined the moment PageSlot is served
// through frank's runtime — verified via `smbls frank to-json .`, 62
// unresolvable-scope-read + 2 unresolvable-identifier findings rooted in
// this file, all cleared by this rewrite). Fixed the FA204 way: values that
// only vary per PANE (SLOT_KEY/RAIL_KEY/HIST_KEY/primary/placeholderKey) live
// in the pane's own `scope:` (declared once in `_slotPane`, inherited by
// every descendant that doesn't redeclare it — see element/src/create.js's
// scope-chain comment); values that vary per NODE within one pane (`back` —
// BackBtn vs ForwardBtn share a pane but need different directions) get
// their OWN `scope:` override on top. `_histCan` reads only its own `(el,
// s)` params + a real top-level import — no closure, so it's liftable to
// `globalScope` (or emitted inline) with no free-variable defect, unlike the
// old shared `can` local (which frank tried to lift to `globalScope.can` and
// then flagged `back`/`HIST_KEY` as unresolvable on it).
const $ff11614ac4f941af$var$_histCan = (el, s)=>el.scope.back ? (0, $5ApZL.histCanBack)(s.root?.[el.scope.HIST_KEY]) : (0, $5ApZL.histCanForward)(s.root?.[el.scope.HIST_KEY]);
const $ff11614ac4f941af$var$_histBtn = (SLOT_KEY, dir)=>{
    const back = dir === 'back';
    return {
        extends: 'PageSlotHeaderBtn',
        subscribeTo: [
            SLOT_KEY,
            $ff11614ac4f941af$var$_HIST_KEYS[SLOT_KEY]
        ],
        // Per-node override on top of the pane's shared scope — `back` differs
        // between this factory's two call sites (BackBtn vs ForwardBtn) even
        // though they share one pane's SLOT_KEY/HIST_KEY.
        scope: {
            back: back
        },
        // Absent (not disabled) where the shell doesn't declare slot history —
        // canvas standalone mounts this pane recipe too.
        hide: (el, s)=>s.root?.[el.scope.HIST_KEY] === undefined,
        'aria-label': (el)=>el.call('polyglot', el.scope.back ? 'canvas.pageSlot.back' : 'canvas.pageSlot.forward'),
        title: (el)=>el.call('polyglot', el.scope.back ? 'canvas.pageSlot.back' : 'canvas.pageSlot.forward'),
        'aria-disabled': (el, s)=>$ff11614ac4f941af$var$_histCan(el, s) ? 'false' : 'true',
        disabled: (el, s)=>!$ff11614ac4f941af$var$_histCan(el, s),
        theme: (el, s)=>$ff11614ac4f941af$var$_histCan(el, s) ? 'transparent' : 'field-disabled',
        cursor: (el, s)=>$ff11614ac4f941af$var$_histCan(el, s) ? 'pointer' : 'not-allowed',
        Icon: {
            name: back ? 'chevronLeft' : 'chevronRight'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const root = s.root;
            if (!root) return;
            const step = el.scope.back ? (0, $5ApZL.histBack)(root[el.scope.HIST_KEY]) : (0, $5ApZL.histForward)(root[el.scope.HIST_KEY]);
            if (!step) return;
            // ONE atomic write: cursor + route move together, and the recorder
            // recognises the landing by cursor equality — no re-push, no flag.
            root.update({
                [el.scope.HIST_KEY]: step.hist,
                [el.scope.SLOT_KEY]: step.path
            });
        }
    };
};
// ── The window's SIDEBAR toggle (DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1 —
// Nika 2026-09-28: "one consistent sidebar for every page that shows a left
// nav inside a slot … plus a hide/show toggle (the slot header sidebar icon),
// remembered per user") ──────────────────────────────────────────────────────
//
// ONE icon, ONE concept — the window's sidebar:
//   • a page that shows its own left nav (every such nav is the house
//     AppSidebar, which marks itself `data-app-sidebar` — the account
//     settings rail is the reference) → the icon hides and shows THAT nav.
//     The choice is the PERSON's and the PAGE's (Nika 2026-10-29: "Hide
//     fully, remember per page" — shared functions/pageSidebar.js): one key
//     per page, kept in their look (`homeLook.sidebarHidden`), the same one
//     the sidebar's own button and its reopen tab write, so the window and
//     the page at its own URL always agree. The session answers first, so a
//     press lands at once even before the row has loaded;
//   • a page with no nav of its own → the icon opens the apps rail below (the
//     in-window app switcher, Nika 2026-08-06), exactly as before.
// Motion (DESIGN_SPEC §6.4): the nav leaves with opacity + a 4 % slide
// towards its own edge on `C` defaultBezier and returns on `D` springBezier —
// opacity and transform only; the page reflows once, when the nav folds down
// to its reopen tab. Reduced motion and a hidden document land the final
// state at once.
// The active page's own navs in this pane: AppSidebar instances (the
// attribute is AppSidebar's own, `attr: { 'data-app-sidebar': '' }`) inside
// the keep-alive host that shows the pane's route. A DOMQL tree walk, never a
// DOM query; parked hosts (minimized pages) are left alone.
const $ff11614ac4f941af$var$_pageSidebarsOf = (el, root)=>{
    const pane = $ff11614ac4f941af$var$_paneOf(el);
    const slot = pane && pane.Body && pane.Body.Slot;
    const ref = slot && slot.__ref;
    if (!ref || !ref.__children) return [];
    const active = $ff11614ac4f941af$var$canvasCleanHref(root && root[el.scope.SLOT_KEY]);
    const out = [];
    for (const key of ref.__children){
        if (typeof key !== 'string' || !key.startsWith($ff11614ac4f941af$var$_HOST_PREFIX)) continue;
        const host = slot[key];
        if (!host || host._slotHref !== active || typeof host.lookdownAll !== 'function') continue;
        host.lookdownAll((c)=>!!(c && c.attr && Object.prototype.hasOwnProperty.call(c.attr, 'data-app-sidebar')), out);
    }
    return out;
};
// THE PAGE'S OWN CHOICE (shared functions/pageSidebar.js, Nika 2026-10-29:
// "Hide fully, remember per page"): the window's page and the same page at
// its own URL share one key, so this icon and the sidebar's own button (and
// its reopen tab) always agree. `el` is inside the pane, so the read keys on
// the pane's route. `nav` — the page's own sidebar, when the caller has it —
// answers the SIDE: a page that has not opted into the side rule
// (`pageSidebar: true`) keeps its sidebar on the left, and so do the glyph
// and the slide. A bundle without the reader (an embed) has no choice to
// show: the sidebar stays.
const $ff11614ac4f941af$var$_sidebarPosture = (el, root, nav)=>{
    if (!root || typeof el?.context?.functions?.pageSidebarRead !== 'function') return {
        hidden: false,
        side: 'left',
        toggleable: false,
        key: null
    };
    return el.call('pageSidebarRead', root, nav || el) || {
        hidden: false,
        side: 'left'
    };
};
const $ff11614ac4f941af$var$_sidebarHidden = (el, root)=>!!$ff11614ac4f941af$var$_sidebarPosture(el, root).hidden;
// Write the person's choice for the pane's page — through the look's one
// writer (pageSidebarSet → homeLookSet: this session at once, the record per
// page). Never a copy of the preferences row in the state.
const $ff11614ac4f941af$var$_writeSidebarHidden = (el, root, hidden)=>{
    const now = $ff11614ac4f941af$var$_sidebarPosture(el, root);
    if (!now.toggleable || !now.key) return;
    el.call('pageSidebarSet', now.key, hidden);
};
// The slide goes towards the sidebar's own edge: left for a left sidebar,
// right for one mirrored beside a left navbar (functions/navbarLayout.js).
const $ff11614ac4f941af$var$_sidebarOut = (side)=>[
        {
            opacity: 1,
            transform: 'none'
        },
        {
            opacity: 0,
            transform: side === 'right' ? 'translate3d(4%, 0, 0)' : 'translate3d(-4%, 0, 0)'
        }
    ];
const $ff11614ac4f941af$var$_sidebarIn = (side)=>[
        {
            opacity: 0,
            transform: side === 'right' ? 'translate3d(4%, 0, 0)' : 'translate3d(-4%, 0, 0)'
        },
        {
            opacity: 1,
            transform: 'none'
        }
    ];
const $ff11614ac4f941af$var$_SIDEBAR_OUT = $ff11614ac4f941af$var$_sidebarOut('left');
const $ff11614ac4f941af$var$_SIDEBAR_IN = $ff11614ac4f941af$var$_sidebarIn('left');
const $ff11614ac4f941af$export$22979c751afca01 = {
    out: {
        keyframes: $ff11614ac4f941af$var$_SIDEBAR_OUT,
        duration: $ff11614ac4f941af$var$_SHEET_EXIT_MS,
        easing: $ff11614ac4f941af$var$_EXIT_EASE
    },
    in: {
        keyframes: $ff11614ac4f941af$var$_SIDEBAR_IN,
        duration: $ff11614ac4f941af$var$_SHEET_ENTER_MS,
        easing: $ff11614ac4f941af$var$_IOS_EASE
    },
    outRight: {
        keyframes: $ff11614ac4f941af$var$_sidebarOut('right')
    },
    inRight: {
        keyframes: $ff11614ac4f941af$var$_sidebarIn('right')
    }
};
// Hide: the navs leave first, THEN the choice lands (the attribute takes them
// out of the flow — a display flip mid-animation would cut it). Show: the
// choice lands first (they re-enter the flow), then they arrive. Every run
// settles by its own backstop timer, never by an animation event alone.
const $ff11614ac4f941af$var$_toggleSidebar = (el, root)=>{
    const navs = $ff11614ac4f941af$var$_pageSidebarsOf(el, root);
    const posture = $ff11614ac4f941af$var$_sidebarPosture(el, root, navs[0]);
    if (!posture.toggleable) return;
    const hide = !posture.hidden;
    const side = posture.side;
    const nodes = navs.map((c)=>c.node).filter((n)=>n && typeof n.animate === 'function');
    const motion = nodes.length > 0 && typeof document !== 'undefined' && document.visibilityState !== 'hidden' && !$ff11614ac4f941af$var$_prefersReducedMotion();
    if (!hide) {
        $ff11614ac4f941af$var$_writeSidebarHidden(el, root, false);
        if (motion) {
            for (const n of nodes)try {
                n.animate($ff11614ac4f941af$var$_sidebarIn(side), {
                    duration: $ff11614ac4f941af$var$_SHEET_ENTER_MS,
                    easing: $ff11614ac4f941af$var$_IOS_EASE
                });
            } catch (_) {
            /* shown already — the motion is decoration */ }
        }
        return;
    }
    if (!motion) {
        $ff11614ac4f941af$var$_writeSidebarHidden(el, root, true);
        return;
    }
    let done = false;
    const held = [];
    // The hidden sidebar keeps its reopen tab on screen (shared AppSidebar), so
    // the held last frame (opacity 0) is released once the choice has landed —
    // the cards are gone by then and the tab shows at full strength.
    const land = ()=>{
        if (done) return;
        done = true;
        $ff11614ac4f941af$var$_writeSidebarHidden(el, root, true);
        const release = ()=>{
            for (const a of held)try {
                a.cancel();
            } catch (_) {
            /* already gone */ }
        };
        if (typeof requestAnimationFrame === 'function') requestAnimationFrame(release);
        else release();
    };
    for (const n of nodes)try {
        const a = n.animate($ff11614ac4f941af$var$_sidebarOut(side), {
            duration: $ff11614ac4f941af$var$_SHEET_EXIT_MS,
            easing: $ff11614ac4f941af$var$_EXIT_EASE,
            fill: 'forwards'
        });
        held.push(a);
        a.onfinish = land;
    } catch (_) {
    /* the backstop lands it */ }
    setTimeout(land, $ff11614ac4f941af$var$_SHEET_EXIT_BACKSTOP_MS);
};
// Which sidebar this icon speaks for right now — read at every factory run
// (the pane's route, the person's choice and the rail each re-run it).
const $ff11614ac4f941af$var$_sidebarMode = (el, s)=>$ff11614ac4f941af$var$_pageSidebarsOf(el, s.root).length ? 'page' : 'rail';
const $ff11614ac4f941af$var$_railToggleBtn = (SLOT_KEY)=>{
    // RAIL_KEY read via `el.scope.RAIL_KEY` below (pane-level scope, see
    // _slotPane) instead of closing over this local — see _histBtn's note.
    return {
        extends: 'PageSlotHeaderBtn',
        subscribeTo: [
            $ff11614ac4f941af$var$_RAIL_KEYS[SLOT_KEY],
            SLOT_KEY,
            'userPrefs',
            '_homeLook',
            '_isPhoneViewport',
            '_slotNudge'
        ],
        // Needs the launcher's app-group source (workspace shell registers
        // searchAppGroupsFor; canvas standalone doesn't) AND the rail key
        // declared — hidden where either is absent, the _slotEntryMeta
        // availability idiom.
        hide: (el, s)=>{
            // Immersive module members never see the apps switcher — the module IS
            // their app (2026-08-14 per Nika, same directive as SplitBtn). First +
            // unconditional so the persona flip stays a tracked dep.
            const imm = el.context?.functions?.moduleImmersiveActive;
            if (typeof imm === 'function' && imm(s.root)) return true;
            return s.root?.[el.scope.RAIL_KEY] === undefined || typeof (el.context?.functions?.searchAppGroupsFor || el.context?.methods?.searchAppGroupsFor) !== 'function';
        },
        'aria-label': (el, s)=>el.call('polyglot', $ff11614ac4f941af$var$_sidebarMode(el, s) === 'page' ? $ff11614ac4f941af$var$_sidebarHidden(el, s.root) ? 'canvas.pageSlot.sidebarShow' : 'canvas.pageSlot.sidebarHide' : 'canvas.pageSlot.appsSidebarAria'),
        title: (el, s)=>el.call('polyglot', $ff11614ac4f941af$var$_sidebarMode(el, s) === 'page' ? $ff11614ac4f941af$var$_sidebarHidden(el, s.root) ? 'canvas.pageSlot.sidebarShow' : 'canvas.pageSlot.sidebarHide' : 'canvas.pageSlot.appsSidebar'),
        // Expanded = the sidebar this icon speaks for is on screen.
        'aria-expanded': (el, s)=>($ff11614ac4f941af$var$_sidebarMode(el, s) === 'page' ? !$ff11614ac4f941af$var$_sidebarHidden(el, s.root) : !!s.root?.[el.scope.RAIL_KEY]) ? 'true' : 'false',
        // The house active look (selected fill + title ink) marks the OPEN apps
        // rail — an overlay you close again. A page's nav is part of the page,
        // so the icon stays quiet while it shows.
        background: (el, s)=>$ff11614ac4f941af$var$_sidebarMode(el, s) === 'rail' && s.root?.[el.scope.RAIL_KEY] ? 'selected' : 'transparent',
        color: (el, s)=>$ff11614ac4f941af$var$_sidebarMode(el, s) === 'rail' && s.root?.[el.scope.RAIL_KEY] ? 'title' : 'inactive',
        // A page's own sidebar: the window with its column on the sidebar's side
        // (right beside a left navbar — functions/navbarLayout.js — when the page
        // opted into the side rule; its own sidebar answers).
        Icon: {
            subscribeTo: [
                '_homeLook',
                'userPrefs',
                '_isPhoneViewport',
                SLOT_KEY,
                '_slotNudge'
            ],
            name: (el, s)=>{
                const navs = $ff11614ac4f941af$var$_pageSidebarsOf(el.parent, s.root);
                return navs.length && $ff11614ac4f941af$var$_sidebarPosture(el, s.root, navs[0]).side === 'right' ? 'sidebarRightFill' : 'sidebarLeftFill';
            }
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const root = s.root;
            if (!root) return;
            if ($ff11614ac4f941af$var$_pageSidebarsOf(el, root).length) {
                $ff11614ac4f941af$var$_toggleSidebar(el, root);
                return;
            }
            root.update({
                [el.scope.RAIL_KEY]: !root[el.scope.RAIL_KEY]
            });
        }
    };
};
// The rail's data: the SAME app-group source the search dropdown uses
// (searchAppGroupsFor — availability-checked like _slotEntryMeta, so canvas
// standalone simply shows no rail), filtered to routes the slot can actually
// host: canvas surfaces and full-page settings surfaces gate out through the
// registered isCanvasRoute/isFullPageRoute classifiers — the same predicate
// pair searchAppTileMenu's "Open in side view" row uses.
const $ff11614ac4f941af$var$_railGroups = (el, root)=>{
    const fns = el.context?.functions || {};
    const methods = el.context?.methods || {};
    const groupsFn = fns.searchAppGroupsFor || methods.searchAppGroupsFor;
    if (typeof groupsFn !== 'function') return [];
    let groups = [];
    try {
        groups = groupsFn.call(el, root) || [];
    } catch (_) {
        return [];
    }
    const isCanvas = fns.isCanvasRoute || methods.isCanvasRoute;
    const isFull = fns.isFullPageRoute || methods.isFullPageRoute;
    const hostable = (route)=>{
        if (!route) return false;
        try {
            if (typeof isCanvas === 'function' && isCanvas.call(el, route)) return false;
            if (typeof isFull === 'function' && isFull.call(el, route)) return false;
        } catch (_) {
            return false;
        }
        return true;
    };
    return groups.map((g)=>({
            label: g?.label || '',
            apps: (g?.apps || []).filter((a)=>a && hostable(a.route))
        })).filter((g)=>g.apps.length);
};
// One rail row — the launcher tile's { title, icon, iconBg, route } contract
// as a compact list row: gradient squircle + label. Active (this pane's
// current path) gets the house `selected` + title pattern. Clicking opens
// the app IN THIS PANE — pane-scoped by construction — and the pane Slot's
// recorder files it into this pane's history.
const $ff11614ac4f941af$var$_railRow = (SLOT_KEY)=>{
    return {
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center',
        gap: 'Z2',
        padding: 'Y Z2',
        round: 'radiusControl',
        width: '100%',
        border: 'none',
        cursor: 'pointer',
        textAlign: 'left',
        // No transition on the background — it's a reactive factory (subscribeTo
        // re-runs it every tick the slot key changes), and a `background`
        // transition on a factory-driven row background gets restarted on every
        // re-application (framework constraint, DESIGN_LANGUAGE.md §7.7 / §11.3).
        transition: '140ms defaultBezier color',
        subscribeTo: [
            SLOT_KEY
        ],
        // Deliberately inlined twice rather than a shared `active(el, s)` local —
        // frank tries to lift a locally-declared helper referenced from more
        // than one serialized factory in this same returned object, and (unlike
        // the plain data reads elsewhere in this file) that lift path doesn't
        // resolve calls through `el.scope` cleanly. Same call already made for
        // `prompt.js`'s 4 copies of `_formatCodeBlock` — small, deliberate
        // duplication beats a frank-hostile shared closure.
        background: (el, s)=>!!s.route && $ff11614ac4f941af$var$canvasCleanHref(s.root?.[el.scope.SLOT_KEY]) === $ff11614ac4f941af$var$canvasCleanHref(s.route) ? 'selected' : 'transparent',
        color: (el, s)=>!!s.route && $ff11614ac4f941af$var$canvasCleanHref(s.root?.[el.scope.SLOT_KEY]) === $ff11614ac4f941af$var$canvasCleanHref(s.route) ? 'title' : 'caption',
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        // `s.title` is a polyglot KEY carried in state (shell.launcher.*.title), so
        // it has to be RESOLVED before it reaches the label — interpolating it raw
        // shipped `Open shell.launcher.notes.title` to the a11y tree on eleven
        // tiles. The verb comes from its own key with a {name} hole, never
        // concatenated: a translation orders those two parts its own way.
        //
        // The name in it is the Label's own (below): THE store-copy resolver.
        'aria-label': (el, s)=>s.title ? el.call('polyglot', 'canvas.slot.openApp').replace('{name}', el.call('storeItemText', {
                key: s.appKey,
                name: s.title
            }, 'name')) : el.call('polyglot', 'canvas.slot.openAppGeneric'),
        // THE calm app glyph (the shell's AppGlyphTile — 9A, "calm glyph tiles
        // instead of bright gradients"): the same plate the search dropdown and
        // the home App strip wear, at the row's compact size. The raw-hex
        // gradient squircles this row used to paint are gone.
        Tile: {
            extends: 'AppGlyphTile',
            boxSize: 'B1',
            minWidth: 'B1',
            Icon: {
                name: (el, s)=>s.icon || 'layers',
                boxSize: 'Z'
            }
        },
        // The app's NAME — primary text, never cut (the overflow law,
        // HOME_AMBIENT_SKIN_SPEC §3b rule 8): it wraps beside its tile.
        Label: {
            tag: 'span',
            flex: '1 1 auto',
            minWidth: '0',
            overflowWrap: 'anywhere',
            fontSize: 'Z',
            fontWeight: '700',
            // i18n — resolved through THE store-copy resolver
            // (shared/functions/storeItemText.js), the call the navbar tab and the
            // apps launcher make, so an app has one name on every surface (Nika
            // 2026-10-23: "app names = what a person sees in the workspace App
            // Store"). marcus's 390 px walk (2026-10-24) read this rail as "Store,
            // Catalog, CMS, Analytics, Warehouse" — each app manifest's tile title —
            // beside an App Store that says Commerce, Products, Content, Insights,
            // Inventory. Its source order serves every tile with no branch here:
            //   • an INSTALLED APP's tile carries `appKey` and reads the store's name;
            //   • a HOUSE tile's title is a polyglot key (the VIEWS rows printed
            //     `shell.viewNav.apps` before a resolver call landed here) and
            //     resolves at the resolver's last source, which is polyglot;
            //   • an extension's or a customer's own title passes through unchanged.
            text: (el, s)=>el.call('storeItemText', {
                    key: s.appKey,
                    name: s.title || ''
                }, 'name')
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const root = s.root;
            if (!root || !s.route) return;
            root.update({
                [el.scope.SLOT_KEY]: s.route
            });
        }
    };
};
// ── The apps rail — in-sheet quick access to every slot-hostable app ───────
//
// A slide-over INSIDE the sheet: absolutely positioned over the pane's
// content row, glass like the slot chrome, borderless (fill-contrast
// separation per design-direction — no hairline, no second shadow), sliding
// on a 200ms defaultBezier transform/opacity pair. It stays MOUNTED while
// closed (transform + opacity + pointerEvents quiet it) so the slide can
// play both ways — a `hide:` gate would display:none it mid-exit. Its own
// header floats sticky above the scrolling list on a backdrop blur ("
// navigation floating above it").
const $ff11614ac4f941af$var$_slotRail = (SLOT_KEY)=>{
    const RAIL_KEY = $ff11614ac4f941af$var$_RAIL_KEYS[SLOT_KEY];
    return {
        // Immersive module members never get the apps switcher (matches the
        // RailToggleBtn gate above) — a persisted open RAIL_KEY must not render
        // a panel whose toggle is hidden.
        hide: (el, s)=>{
            const imm = el.context?.functions?.moduleImmersiveActive;
            return typeof imm === 'function' && imm(s.root);
        },
        position: 'absolute',
        top: '0',
        left: '0',
        bottom: '0',
        zIndex: '3',
        width: 'G',
        minWidth: '0',
        maxWidth: '82%',
        flow: 'y',
        overflow: 'auto',
        overscrollBehavior: 'contain',
        theme: 'dialog',
        round: 'radiusCard',
        shadow: 'float',
        margin: 'Z',
        borderWidth: '0',
        transition: 'B defaultBezier transform, B defaultBezier opacity',
        // RAIL_KEY read via `el.scope.RAIL_KEY` (pane-level scope) rather than
        // closing over the local above — see _histBtn's note.
        transform: (el, s)=>s.root?.[el.scope.RAIL_KEY] ? 'translateX(0)' : 'translateX(-108%)',
        opacity: (el, s)=>s.root?.[el.scope.RAIL_KEY] ? '1' : '0',
        pointerEvents: (el, s)=>s.root?.[el.scope.RAIL_KEY] ? 'auto' : 'none',
        // Offscreen controls must leave keyboard navigation too. Inert preserves
        // the slide animation and mounted state while excluding every descendant.
        inert: (el, s)=>!s.root?.[el.scope.RAIL_KEY],
        'aria-hidden': (el, s)=>s.root?.[el.scope.RAIL_KEY] ? 'false' : 'true',
        subscribeTo: [
            RAIL_KEY,
            SLOT_KEY,
            'workspaceProject',
            'workspaceSettings'
        ],
        // The floating navigation strip: sticky over the list, backdrop glass.
        RailHead: {
            position: 'sticky',
            top: '0',
            zIndex: '1',
            flexShrink: '0',
            flow: 'x',
            align: 'center',
            padding: 'A A Z A',
            theme: 'dialog',
            Label: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: '{{ canvas.pageSlot.apps | polyglot }}'
            }
        },
        Groups: {
            flow: 'y',
            gap: 'A',
            padding: 'Z A A A',
            // The children-factory OWNER subscribes to the signals its rows read:
            // SLOT_KEY drives each row's active paint (verified live 2026-08-06 —
            // with the subscription only on the outer rail, a slot change never
            // re-ran the rows and the active highlight went stale), and the
            // workspace signals refresh the group list itself when a module's
            // apps land/change.
            subscribeTo: [
                SLOT_KEY,
                'workspaceProject',
                'workspaceSettings'
            ],
            childrenAs: 'state',
            children: (el, s)=>$ff11614ac4f941af$var$_railGroups(el, s.root),
            childExtends: {
                flow: 'y',
                gap: 'Y',
                GroupLabel: {
                    tag: 'span',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    color: 'caption',
                    textTransform: 'uppercase',
                    letterSpacing: '0.08em',
                    paddingLeft: 'Z',
                    // i18n — the rail reads the SAME group data the apps launcher does
                    // (searchAppGroupsFor), so it needs the same one call: a shipped
                    // house group carries a polyglot KEY, while the workspace group's
                    // label is the customer's workspace NAME. `translate()` resolves the
                    // first and returns the second unchanged.
                    text: (el, s)=>el.call('polyglot', s.label || '')
                },
                Rows: {
                    flow: 'y',
                    gap: 'V',
                    childrenAs: 'state',
                    children: (el, s)=>s.apps || [],
                    childExtends: $ff11614ac4f941af$var$_railRow(SLOT_KEY)
                }
            }
        }
    };
};
// ── Pane factory ───────────────────────────────────────────────────────────
//
// Both panes are instances of this one recipe — the only differences are which
// state key drives them and the primary's extra duties (?page= URL sync,
// fullscreen toggle, second-pane promotion on close).
// ── The window's WIDTH (Nika 2026-09-29: "why did you decrease width of
// pageslot? maybe increase a bit so at least it takes up to 60-70% and add
// option to resize in full") ─────────────────────────────────────────────────
//
// Pick 10 A (4e67753e2) capped one floating window at the brand's wide overlay
// (`overlayXl`, 880 px) on the FRAME: at 1440 px the page went from the whole
// band (~1416 px) to 880 px, at 2560 px to a third of the screen. Now the
// frame stays the band — --slot-top, --slot-bottom, the X2 gutters and every
// shell rule that moves them — and the SHEET (one window in the default
// floating state) is a share of that band, sized on the pane:
//   • the full available width by default (`_SHEET_DEFAULT_PCT`);
//   • never narrower than the brand's `overlayXl` while the band has room for
//     it (the old sheet is the floor), never wider than the band;
//   • the resize handle on its right edge changes the share live, by pointer
//     or keyboard; a double-click or Enter on it returns to the default;
//   • the header's full-screen control still takes it edge to edge.
// A split, a full-screen window, the module presentations and the second pane
// keep filling their share of the band; a phone keeps its full-bleed sheet
// (the band is narrower than the floor there, so the sheet is the band).
//
// THE SHARE IS THE PERSON'S (user_preferences `slotSheetWidth`, a percent of
// the band — the same share on every screen): this session's decision
// (`root._slotSheetWidth`) first, then the record once its row has loaded,
// then this device's copy (it paints before the row arrives), then the
// default. The shell writes it (workspace functions/slotSheetWidth.js) under
// the home-prefs durability law; a bundle without that writer keeps the
// choice for the session.
const $ff11614ac4f941af$var$_SHEET_DEFAULT_PCT = 100;
const $ff11614ac4f941af$var$_SHEET_MIN_PCT = 30;
const $ff11614ac4f941af$var$_SHEET_STEP_PCT = 2;
const $ff11614ac4f941af$var$_SHEET_BIG_STEP_PCT = 10;
const $ff11614ac4f941af$var$_SHEET_CACHE_KEY = 'symbols_slot_sheet_w';
const $ff11614ac4f941af$var$_sheetPctOk = (v)=>typeof v === 'number' && isFinite(v) && v >= $ff11614ac4f941af$var$_SHEET_MIN_PCT && v <= 100;
// One window in the default floating state — the only state the share sizes.
const $ff11614ac4f941af$var$_isSheet = (el, root)=>{
    const m = $ff11614ac4f941af$var$_slotModes(el, root);
    return !m.split && !m.fullscreen && !m.imm && !m.rail;
};
const $ff11614ac4f941af$var$_sheetPct = (root)=>{
    if (!root) return $ff11614ac4f941af$var$_SHEET_DEFAULT_PCT;
    if ($ff11614ac4f941af$var$_sheetPctOk(root._slotSheetWidth)) return root._slotSheetWidth;
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    if (prefs) return $ff11614ac4f941af$var$_sheetPctOk(prefs.slotSheetWidth) ? prefs.slotSheetWidth : $ff11614ac4f941af$var$_SHEET_DEFAULT_PCT;
    try {
        const raw = typeof localStorage !== 'undefined' ? localStorage.getItem($ff11614ac4f941af$var$_SHEET_CACHE_KEY) : null;
        const v = raw == null || raw === '' ? NaN : Number(raw);
        if ($ff11614ac4f941af$var$_sheetPctOk(v)) return v;
    } catch (_) {
    /* no device copy — the default */ }
    return $ff11614ac4f941af$var$_SHEET_DEFAULT_PCT;
};
// The floor: the brand's wide overlay, read from the design system the shell
// runs (the brand fills `sizes` through the shared-library merge) — a token
// value, never a literal here. Without it (a bundle without the brand sizes)
// the share alone applies.
const $ff11614ac4f941af$var$_sheetFloor = (el)=>{
    const sizes = el && el.context && el.context.designSystem && el.context.designSystem.sizes;
    const v = sizes && sizes.overlayXl;
    return typeof v === 'string' && /^\d+(\.\d+)?(px|rem|em)$/.test(v.trim()) ? v.trim() : null;
};
// The pane's width as a sheet: the share, lifted to the floor while the band
// has room for it, never past the band.
const $ff11614ac4f941af$var$_sheetWidthCss = (el, root)=>{
    const pct = $ff11614ac4f941af$var$_sheetPct(root);
    const floor = $ff11614ac4f941af$var$_sheetFloor(el);
    return floor ? `min(100%, max(${floor}, ${pct}%))` : `${pct}%`;
};
// The band the share is measured against: the frame, the handle's pane's
// parent. A layout read, for a drag and a key only.
const $ff11614ac4f941af$var$_sheetBand = (handle)=>{
    const node = handle && handle.parent && handle.parent.parent && handle.parent.parent.node;
    const w = node && typeof node.getBoundingClientRect === 'function' ? node.getBoundingClientRect().width : 0;
    return w > 0 ? w : 0;
};
const $ff11614ac4f941af$var$_sheetMinPct = (handle, band)=>{
    const floor = $ff11614ac4f941af$var$_sheetFloor(handle);
    const px = floor && /px$/.test(floor) ? parseFloat(floor) : 0;
    const floorPct = band > 0 && px > 0 ? Math.min(100, px / band * 100) : 0;
    return Math.max($ff11614ac4f941af$var$_SHEET_MIN_PCT, floorPct);
};
const $ff11614ac4f941af$var$_sheetClamp = (pct, min)=>Math.round(Math.max(min, Math.min(100, pct)) * 10) / 10;
// Save the person's choice through the shell's writer — this session at once,
// then the record. A bundle without it keeps the choice for this session, on
// the session key only (never on a copy of the preferences row).
const $ff11614ac4f941af$var$_saveSheetPct = (el, root, value)=>{
    if (typeof el.context?.functions?.setSlotSheetWidth === 'function') {
        el.call('setSlotSheetWidth', value);
        return;
    }
    root.update({
        _slotSheetWidth: value
    }, {
        preventFetch: true
    });
};
// A drag: the pointer is captured on the handle, so every move and the release
// land here. The leading edge stays fixed; the width follows the pointer
// one for one. The share updates live on the session key; the
// release remembers it once. A cancel (Escape, a lost capture) puts back the
// share the drag started from.
const $ff11614ac4f941af$var$_sheetDragStart = (e, el, s)=>{
    if (!e || e.button !== 0 || !s.root) return;
    const band = $ff11614ac4f941af$var$_sheetBand(el);
    const pane = el.parent && el.parent.node;
    const w = pane && typeof pane.getBoundingClientRect === 'function' ? pane.getBoundingClientRect().width : 0;
    if (!(band > 0) || !(w > 0)) return;
    e.preventDefault();
    e.stopPropagation();
    el._sheetDrag = {
        x: e.clientX,
        w: w,
        band: band,
        min: $ff11614ac4f941af$var$_sheetMinPct(el, band),
        was: s.root._slotSheetWidth,
        moved: false,
        id: e.pointerId
    };
    try {
        if (el.node && e.pointerId != null) el.node.setPointerCapture(e.pointerId);
    } catch (_) {
    /* no capture — the moves still land while the pointer is on the handle */ }
};
const $ff11614ac4f941af$var$_sheetDragMove = (e, el, s)=>{
    const d = el._sheetDrag;
    if (!d || !s.root) return;
    e.stopPropagation();
    const pct = $ff11614ac4f941af$var$_sheetClamp((d.w + e.clientX - d.x) / d.band * 100, d.min);
    if (pct === s.root._slotSheetWidth) return;
    d.moved = true;
    s.root.update({
        _slotSheetWidth: pct
    }, {
        preventFetch: true
    });
};
const $ff11614ac4f941af$var$_sheetDragEnd = (e, el, s, cancelled)=>{
    const d = el._sheetDrag;
    if (!d) return;
    el._sheetDrag = null;
    try {
        if (el.node && d.id != null) el.node.releasePointerCapture(d.id);
    } catch (_) {
    /* already released */ }
    if (!s.root || !d.moved) return;
    if (cancelled) {
        s.root.update({
            _slotSheetWidth: d.was == null ? null : d.was
        }, {
            preventFetch: true
        });
        return;
    }
    $ff11614ac4f941af$var$_saveSheetPct(el, s.root, s.root._slotSheetWidth);
};
// The keys (WAI-ARIA window splitter): Left / Right step the share, Shift a
// longer step, Home / End to the bounds, Enter back to the default. Escape
// cancels a drag in flight and is spent; with no drag it is the window's own.
const $ff11614ac4f941af$var$_sheetKey = (e, el, s)=>{
    const root = s.root;
    if (!root || !e) return;
    if (e.key === 'Escape') {
        if (!el._sheetDrag) return;
        e.preventDefault();
        e.stopPropagation();
        $ff11614ac4f941af$var$_sheetDragEnd(e, el, s, true);
        return;
    }
    if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        $ff11614ac4f941af$var$_saveSheetPct(el, root, null);
        return;
    }
    const band = $ff11614ac4f941af$var$_sheetBand(el);
    const min = $ff11614ac4f941af$var$_sheetMinPct(el, band);
    // Step from the share on screen: a choice under the floor shows the floor.
    const cur = Math.max($ff11614ac4f941af$var$_sheetPct(root), min);
    const step = e.shiftKey ? $ff11614ac4f941af$var$_SHEET_BIG_STEP_PCT : $ff11614ac4f941af$var$_SHEET_STEP_PCT;
    let next;
    if (e.key === 'ArrowRight') next = cur + step;
    else if (e.key === 'ArrowLeft') next = cur - step;
    else if (e.key === 'Home') next = min;
    else if (e.key === 'End') next = 100;
    else return;
    e.preventDefault();
    e.stopPropagation();
    next = $ff11614ac4f941af$var$_sheetClamp(next, min);
    if (next !== cur) $ff11614ac4f941af$var$_saveSheetPct(el, root, next);
};
const $ff11614ac4f941af$var$_slotPane = (SLOT_KEY, { primary: primary, placeholderKey: placeholderKey } = {})=>({
        // Runtime-visible mirror of this factory's own closure params (2026-08-12,
        // tickets/opus.md "~800 project-side Frankability defects" — canvas's
        // PageSlot factory-closure-capture class, 62 unresolvable-scope-read + 2
        // unresolvable-identifier findings via `smbls frank to-json .`). Every
        // nested prop-factory in this pane's whole subtree (Header, BackBtn,
        // ForwardBtn, RailToggleBtn, AppsRail + its rows, Slot, SplitPlaceholder…)
        // reads SLOT_KEY/RAIL_KEY/HIST_KEY/primary/placeholderKey from
        // `el.scope` — inherited by every descendant that doesn't declare its own
        // `scope` (element/src/create.js's scope-chain: own → parent.scope → … →
        // globalScope) — instead of closing over these JS locals. A closure over a
        // factory param/local doesn't survive frank.toJSON: it lifts each reactive
        // prop into a standalone function, and a free variable that is neither
        // that function's own parameter nor a module-scope const resolves to
        // nothing at eval-revival time — a guaranteed ReferenceError/undefined the
        // moment PageSlot is served through frank's runtime. `scope:` is the
        // framework's sanctioned fix for exactly this (same mechanism as the
        // FA204 precedent in CanvasPromptTextarea.js's `scope.SIZES`), declared
        // ONCE here so every descendant factory below can read it.
        scope: {
            SLOT_KEY: SLOT_KEY,
            RAIL_KEY: $ff11614ac4f941af$var$_RAIL_KEYS[SLOT_KEY],
            HIST_KEY: $ff11614ac4f941af$var$_HIST_KEYS[SLOT_KEY],
            primary: !!primary,
            placeholderKey: placeholderKey || null
        },
        // The frame is pointerEvents:none so closed/empty regions never block the
        // page — each pane re-enables interaction for itself.
        pointerEvents: 'auto',
        role: 'region',
        'aria-labelledby': (el)=>`page-slot-title-${el.scope.SLOT_KEY}`,
        // The skip link's target while this pane holds a route (workspace
        // functions/skipToMainHref.js): the shell's first tab stop jumps into the
        // window on screen, not to the page behind it.
        id: (el)=>`page-slot-pane-${el.scope.SLOT_KEY}`,
        // The pane takes the keyboard when it opens (`_focusPaneIn`) — focusable by
        // script, never a tab stop of its own. The brand reset's [tabindex]
        // :focus-visible ring is a box-shadow that would REPLACE the window's float
        // elevation after a keyboard open, so the sheet keeps its own shadow there
        // (AppDialog's Panel makes the same call).
        tabindex: '-1',
        ':focus-visible': {
            boxShadow: 'var(--shadow-float)'
        },
        // The one motion recipe grows the sheet from its bottom edge — it sits on
        // the dock and rises from it (`_PANE_ENTER`). Static: it only matters while
        // a WAAPI run or the phone drag carries a transform.
        transformOrigin: 'center bottom',
        flex: '1 1 0',
        minWidth: '0',
        minHeight: '0',
        flow: 'y',
        overflow: 'hidden',
        // The window is an overlay-level sheet (white-label redesign, DESIGN_SPEC
        // §6.1 "Window"): `radiusSheet` on all four corners — the same radius as
        // every modal, side panel and phone sheet, one clean step above the
        // in-page `radiusCard`.
        round: 'radiusSheet',
        // ONE ground, very consistent (Nika 2026-09-01): the pane paints the
        // SAME `var(--stage-bg, var(--color-stage))` chain the shell root,
        // MainColumn, the main page and every canvas Stage paint
        // (canvasBackground.js STAGE_BACKGROUND, BF-WIDGET-INK-1) — the pane can
        // never differ from the board beside it, in either scheme.
        // 'pane-ground' (brand) carries the chrome only: inks + blur + the one
        // float shadow — it paints no background.
        // The pane ground IS the content-surface family (Nika 2026-09-01 "make
        // it darker, and pageslot and content inside should have same bg"):
        // page sheets paint gray2-family fills in dark and gray16-family in
        // light, so the pane paints the same pair and the frame, gutters and
        // content read as ONE surface — while the stage board (gray5/milk)
        // frames it with real contrast.
        // THE PAIR IS A LIGHT BASE + A '@dark' BLOCK (2026-09-30, Nika
        // "background missing on other Windows devices"). It used to be ONE inline
        // declaration built on the CSS function that picks by colour scheme;
        // Chrome / Edge before 123 do not know that function and drop the WHOLE
        // declaration, so the window had no ground at all. The scheme block
        // compiles to `[data-theme="dark"] .cls` — the root attribute the
        // framework stamps for light, dark and auto — with no browser-version
        // dependency (workspace/__tests__/noLightDarkInShellStyles.test.js). The
        // two tokens are plain colours, not a scheme pair, so nothing splits them.
        // '--stage-bg' rides the inline style (custom props in a style object
        // hit the DOM style attribute directly — the `vars:` spelling measurably
        // never reached the node). Dissolving the chain's first var here resolves the
        // AppPage-family wrappers' own INLINE `var(--stage-bg, ...)` paints to
        // transparent for every descendant — an inline paint beats any
        // slot-scoped class rule, but its var still resolves through the
        // cascade, so the pane sheet becomes the one ground (measured
        // 2026-09-01: a 1896x779 gray5 wrapper behind CalMain). Modules' custom
        // --stage-bg boards flatten to the sheet inside the pane too — intended.
        //
        // THE SHARE OF THE BAND (the width block above): as the one floating window
        // the primary pane fills the available band by default. A chosen narrower
        // width keeps its leading edge beside the navigation; in every other state
        // (a split, full screen, the module presentations) and as the second pane
        // it fills its flex share as before. Per-key factories — each one its own
        // live effect — so a drag moves the width on every step.
        background: 'gray16',
        '@dark': {
            background: 'gray2'
        },
        style: {
            '--stage-bg': 'transparent',
            flex: (el, s)=>{
                if (el.scope.primary && $ff11614ac4f941af$var$_isSheet(el, s.root)) return '0 0 auto';
                if (!s.root?._canvasSlotSecond && !s.root?._slotSplitIntent) return '1 1 0';
                const ratio = $ff11614ac4f941af$var$_splitRatio(s.root);
                return `${(el.scope.primary ? ratio : 100 - ratio) / 50} 1 0`;
            },
            width: (el, s)=>el.scope.primary && $ff11614ac4f941af$var$_isSheet(el, s.root) ? $ff11614ac4f941af$var$_sheetWidthCss(el, s.root) : 'auto',
            marginLeft: ()=>'0',
            marginRight: (el, s)=>el.scope.primary && $ff11614ac4f941af$var$_isSheet(el, s.root) ? 'auto' : '0'
        },
        // The containing block of the resize handle (its right edge).
        position: 'relative',
        theme: 'pane-ground',
        borderWidth: '0',
        shadow: 'float',
        // Phone: the pane fills a full-bleed frame, so only the TOP corners round —
        // the other three edges ARE the viewport (iOS sheet). Compound media rules
        // are emitted after flat ones by @symbo.ls/css, so this always wins the
        // cascade over the flat `round` above at ≤768.
        //
        // …and the bottom edge IS the home indicator's swipe zone on an iPhone
        // without a home button (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): a
        // TRANSPARENT bottom border the size of the inset keeps the page's last row
        // and its actions above it, while the pane's own ground paints under the
        // border to the edge (background-clip is the border box). 0 wherever the
        // device reports no inset — the same rule as the AppDialog phone sheet.
        '@mobileL': {
            round: 'radiusSheet radiusSheet 0 0',
            borderBottomWidth: 'env(safe-area-inset-bottom)',
            borderBottomStyle: 'solid',
            borderBottomColor: 'transparent'
        },
        // Pane identity stamp — the anchor slotPaneKeyFor (shared/functions/
        // slotPane.js) and the local _paneOf walk to, replacing fixed parent hops.
        // onCreate lands it before any child (or keep-alive host) can ask;
        // onRender re-stamps defensively (idempotent one-liner).
        onCreate: (el)=>{
            el._slotPaneKey = el.scope.SLOT_KEY;
        },
        onRender: (el)=>{
            el._slotPaneKey = el.scope.SLOT_KEY;
        },
        // Phone drag-to-dismiss. DOMQL owns all four registrations (FA503); the
        // gesture itself is built lazily by `_sheetDragHandlers` on the first
        // event, which is also where the coarse-pointer gate runs (a fine pointer
        // caches a `null` and never re-asks). `?.` — a desktop pane has no
        // handlers, and every one of these fires on every pointer event there.
        onPointerdown: (e, el)=>$ff11614ac4f941af$var$_sheetDragHandlers(el)?.onDown(e),
        onPointermove: (e, el)=>$ff11614ac4f941af$var$_sheetDragHandlers(el)?.onMove(e),
        onPointerup: (e, el)=>$ff11614ac4f941af$var$_sheetDragHandlers(el)?.onUp(e),
        onPointercancel: (e, el)=>$ff11614ac4f941af$var$_sheetDragHandlers(el)?.onUp(e),
        // Visibility + transition interception. The factory is the only hook that
        // provably runs BEFORE the display flip (onUpdate fires after display:none
        // is applied; onBeforeUpdate does not fire on subscribeTo-driven re-renders
        // — see the OPEN tickets in tickets/smbls.md), so open/close choreography
        // hangs off it:
        //   • closed→open: mark shown + pre-hide inline (no-blink) — the entrance
        //     itself starts in onUpdate/onCreate once the node exists.
        //   • open→closed: kick the exit and HOLD the pane via `el._closing`.
        // The `_slotNudge` read subscribes this effect to the close-finish nudge —
        // element-local `_closing` can't re-trigger it on its own.
        hide: (el, s)=>{
            s.root?._slotNudge;
            // "Open" for a real mounted route OR, on the split pane, while a split is
            // being armed (placeholderKey) — the empty pane then shows a placeholder so
            // the split telegraphs before an app is picked (2026-07-16 per Nika).
            const route = s.root?.[el.scope.SLOT_KEY];
            const hasRoute = !!route;
            const open = hasRoute || (el.scope.placeholderKey ? !!s.root?.[el.scope.placeholderKey] : false);
            // A placeholder pane whose route just ARRIVED (the split pick landed):
            // the pane was already shown, so no open edge fires — read here, before
            // the edges below move `_paneShown`.
            const routeArrived = !!el._paneShown && open && hasRoute && !el._hadRoute;
            const routeChanged = !!el._paneShown && hasRoute && route !== el._focusRoute;
            el._hadRoute = open && hasRoute;
            el._focusRoute = route;
            if (routeArrived) el._returnFocus = $ff11614ac4f941af$var$_focusOrigin(el);
            if (routeChanged) // After the pick's own writes settle (the search closes and hands focus
            // back first), the keyboard follows the new window. This also covers
            // restoring from the dock over an already-open pane: its chip disappears,
            // but there is no open edge. Keep the original return target; focus
            // already inside the pane and an open header search still win.
            queueMicrotask(()=>$ff11614ac4f941af$var$_focusPaneIn(el));
            if (open && !el._paneShown) {
                el._paneShown = true;
                // Where the keyboard goes back to when this pane closes — read at the
                // open edge, before anything moves focus. Not for the split pane's
                // placeholder: that open belongs to the search, which holds focus.
                el._returnFocus = hasRoute ? $ff11614ac4f941af$var$_focusOrigin(el) : null;
                if (el.node && el.node.style) el.node.style.opacity = '0';
                $ff11614ac4f941af$var$_queueEnter(el);
            } else if (!open && el._paneShown) {
                el._paneShown = false;
                $ff11614ac4f941af$var$_paneExit(el, s.root);
            } else if (open && el._paneShown && !el._enterQueued && !el._anim && !el._closing && // …and not while a finger owns the transform: the self-heal below clears
            // inline styles, which mid-drag would snap the sheet out from under it.
            !el._dragging) // Self-heal invariant: an open pane with no run in flight sits at base
            // styles — clears an inline pre-hide stranded by any path the runs
            // didn't cover, so a stuck state can never outlive the next state touch.
            $ff11614ac4f941af$var$_clearInline(el);
            return !open && !el._closing;
        },
        // The open/close choreography is driven entirely from the hide factory (the
        // factory auto-tracks every signal it reads — _slotNudge included); the
        // element-level subscription just guarantees a re-render applies the flip.
        subscribeTo: [
            SLOT_KEY,
            '_slotSplitRatio',
            ...placeholderKey ? [
                placeholderKey
            ] : []
        ],
        // iOS grabber — the phone sheet's drag affordance, centred on its top edge.
        // Decorative by design: the header's Close button is the accessible,
        // keyboard-reachable dismissal, so the pill stays out of the a11y tree
        // instead of duplicating it. Hidden off-phone by a flat `display: none` that
        // the `@mobileL` compound rule overrides (flat rules are emitted first by
        // @symbo.ls/css, compound second — the media query always wins).
        GrabHandle: {
            attr: {
                'data-sheet-grip': ''
            },
            'aria-hidden': 'true',
            display: 'none',
            flexShrink: '0',
            align: 'center center',
            padding: 'Y 0 0 0',
            cursor: 'grab',
            // touchAction rides the same phone gate as the Header's: without it the
            // browser claims the vertical pan and the sheet never follows the finger.
            '@mobileL': {
                display: 'flex',
                touchAction: 'none'
            },
            // House tap-slop: grow the HIT area to a thumb without growing the pill.
            '@coarse': {
                position: 'relative',
                ':after': {
                    content: '""',
                    position: 'absolute',
                    inset: 'tapSlop'
                }
            },
            Grip: {
                width: 'B2',
                height: 'X1',
                round: 'X',
                background: 'caption.35'
            }
        },
        Header: {
            // Immersive module chrome: the pane utility bar (back/fwd/title/close)
            // is shell chrome too — hidden with the rest of it; the module's own
            // rail owns navigation and there is nothing behind to close back to
            // (the close path reopens the landing anyway, see main.js _slotOnClose).
            // EXCEPT with a persistent module rail (chrome.rail): the rail keeps a
            // landing to return to, and immersive members would otherwise have NO
            // way to close an open page (2026-08-14 per Nika "keep pageslot header
            // for non-admin so we can close the page") — rail-active modules keep
            // the header for every persona.
            hide: (el, s)=>{
                const railFn = el.context?.functions?.moduleRailActive;
                if (typeof railFn === 'function' && railFn(s.root)) return false;
                const imm = el.context?.functions?.moduleImmersiveActive;
                return typeof imm === 'function' && imm(s.root);
            },
            // The whole header is grip too — a downward flick anywhere on it dismisses,
            // so the gesture doesn't demand a 36px target.
            attr: {
                'data-sheet-grip': ''
            },
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center',
            minWidth: '0',
            maxWidth: '100%',
            // Compact bar (2026-08-31 per Nika "reduce size of pageSlot header,
            // narrow spacings"; second pass 2026-09-01 "make it less space
            // consuming"): the 36px button circle is pinned by the F2
            // one-close-button contract (shared PageSlotHeaderBtn), so compactness
            // comes from the bar's own inset + gap, not the control scale. Zero
            // vertical inset makes the circle define the bar height outright
            // (44px → 36px); the icon's own 10px ring inside the transparent
            // circle keeps the visual breathing room at the pane's top edge.
            // Third pass 2026-09-23 per Nika "add same padding top on pageslot header
            // as left and right": the top inset now equals the side inset (Y); the
            // bottom stays zero so the bar keeps its compact height below the title.
            gap: 'Y',
            padding: 'Z Z Y',
            flexShrink: '0',
            // Phone only: the grabber above now owns the sheet's top padding, and the
            // header must yield the vertical pan to the dismissal gesture.
            '@mobileL': {
                paddingTop: 'X',
                touchAction: 'none'
            },
            // ── Left cluster: back · forward · apps rail — BEFORE the title
            // (2026-08-06 per Nika "add it on the left side before pageslot title…
            // so left arrpw, right arrow, sidebar toggle"). Same PageSlotHeaderBtn
            // recipe as the right cluster; strictly pane-scoped (this pane's
            // history/slot/rail keys only — the split-view contract).
            BackBtn: $ff11614ac4f941af$var$_histBtn(SLOT_KEY, 'back'),
            ForwardBtn: $ff11614ac4f941af$var$_histBtn(SLOT_KEY, 'forward'),
            RailToggleBtn: $ff11614ac4f941af$var$_railToggleBtn(SLOT_KEY),
            Title: {
                tag: 'h1',
                id: (el)=>`page-slot-title-${el.scope.SLOT_KEY}`,
                fontSize: 'Z1',
                fontWeight: '700',
                color: 'title',
                margin: '0',
                flex: '1 1 0',
                minWidth: '0',
                // The window's NAME — primary text, never cut (overflow law rule 8):
                // it wraps, and the bar (flex-wrap, no fixed height) grows with it.
                overflowWrap: 'anywhere',
                // A phone needs a readable app name as well as touch-sized controls.
                // Keep the title above the actions; every control can still wrap when
                // the available pane width is smaller than their combined targets.
                '@mobileL': {
                    order: '-1',
                    flexBasis: '100%',
                    padding: 'X Y 0'
                },
                text: (el, s)=>{
                    const path = s.root?.[el.scope.SLOT_KEY];
                    if (!path && el.scope.placeholderKey && s.root?.[el.scope.placeholderKey]) return el.call('polyglot', 'canvas.pageSlot.newPane');
                    const def = $ff11614ac4f941af$var$_defFor(el, path, s.root);
                    // Short form in the slot chrome; document.title keeps the full
                    // helmet form (see shortSlotTitle's note). An idle pane with no
                    // resolvable def falls back to the same 'New pane' label the
                    // placeholder-armed branch above uses, instead of an empty h1
                    // (A11Y-1: two empty h1s on a fresh Home load).
                    return $ff11614ac4f941af$var$shortSlotTitle(el.call('resolvePageMetadataTitle', def?.metadata)) || path || el.call('polyglot', 'canvas.pageSlot.newPane');
                }
            },
            // Open this pane's route as a full page — leaves the slot entirely.
            ExpandBtn: {
                extends: 'PageSlotHeaderBtn',
                'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.openAsFullPage'),
                title: (el)=>el.call('polyglot', 'canvas.pageSlot.openAsFullPage'),
                Icon: {
                    name: 'arrowUpRightRect'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    // Definition lookups normalize routes; navigation preserves the
                    // selected app surface, record, filters and anchor verbatim.
                    const path = s.root?.[el.scope.SLOT_KEY] || '';
                    // One-shot reopen suppression — the SAME handshake the CloseBtn's
                    // rail case and moduleGoHome use. Without it, on an immersive-module
                    // workspace the slot-close watcher's landing reopen fires a tick
                    // after this deliberate leave and re-opens the LANDING pane over the
                    // full page (measured live on app.bellforge.eu 2026-09-02: /theses
                    // full-page + the reopened /assess slot = doubled layout, and the
                    // landing def's onInit then re-set the module view to the persona
                    // default, which read as "open in new page shows the wrong page").
                    if (s.root) s.root._slotSkipReopenOnce = true;
                    $ff11614ac4f941af$var$_closeSlot(s.root);
                    if (path) el.router(path, el.getRoot());
                }
            },
            // Split-view + fullscreen toggles — single-pane primary only (once a
            // second pane is open the split button is done and fullscreen is moot,
            // so both hide, and the second pane never ships them at all).
            ...primary ? {
                // Open a SECOND pane beside this one (iPad-style split view). Arms
                // `_slotSplitIntent` so the NEXT pick lands in `_canvasSlotSecond`,
                // and opens THE GLOBAL SEARCH to choose it — the header search the
                // whole shell uses, with its own dropdown, rows and keys (Nika
                // 2026-09-28: "it should activate search dropdown, not its own - so
                // we make it consistent"). Every pick spends the intent: an app row
                // through openAppPage, a record row through openInSlot (the one
                // opener). Shown ACTIVE (not hidden) once split so the icon carries
                // the on-state; hidden only on transient AI answer views (nothing to
                // split them against).
                SplitBtn: {
                    extends: 'PageSlotHeaderBtn',
                    // Shown only where a split can open. Below SPLIT_MIN_WIDTH_PX
                    // (1024, functions/searchApps.js) the shell folds every split into
                    // the primary pane, so the button would promise a second pane the
                    // pick then refuses — a lying control. The shell's
                    // `splitBelowFloor` media token is that floor's exact complement
                    // (a phone is inside it too: one full-width sheet).
                    '@splitBelowFloor': {
                        display: 'none'
                    },
                    // Re-render this button when the split signals change so its ON-state
                    // paint factories re-run. A plain-button conditional-class (.isActive)
                    // needs the InteractiveComponent base PageSlotHeaderBtn lacks, so we
                    // paint the fill directly — plain prop factories DO re-run on
                    // subscribeTo (the placeholder proves it), unlike the class effect.
                    subscribeTo: [
                        '_canvasSlotSecond',
                        '_slotSplitIntent'
                    ],
                    // Stays visible while split so the icon can carry the ON state; only
                    // hidden on transient answer views (nothing to split against) —
                    // or when split view / split panes are off at /flags.
                    hide: (el, s)=>{
                        // Immersive module members get a page, not a workspace — split
                        // view is shell furniture, admins only (2026-08-14 per Nika
                        // "hide app switcher and split view for non admins from
                        // pageslot header"). Read FIRST, unconditionally, so the
                        // persona flip re-runs this factory (short-circuit ordering
                        // would drop the tracked dep).
                        const imm = el.context?.functions?.moduleImmersiveActive;
                        if (typeof imm === 'function' && imm(s.root)) return true;
                        return !$ff11614ac4f941af$var$canvasFeatureEnabled(s.root, 'splitView') || !$ff11614ac4f941af$var$canvasFeatureEnabled(s.root, 'splitView.splitPane') || String(s.root?._canvasSlot || '').startsWith('/answer/');
                    },
                    // ON state — the house active look (`selected` fill + title text)
                    // whenever a second pane is open OR a split is being armed.
                    background: (el, s)=>s.root?._canvasSlotSecond || s.root?._slotSplitIntent ? 'selected' : 'transparent',
                    color: (el, s)=>s.root?._canvasSlotSecond || s.root?._slotSplitIntent ? 'title' : 'inactive',
                    'aria-pressed': (el, s)=>s.root?._canvasSlotSecond || s.root?._slotSplitIntent ? 'true' : 'false',
                    'aria-label': (el, s)=>el.call('polyglot', s.root?._canvasSlotSecond || s.root?._slotSplitIntent ? 'canvas.splitView.close' : 'canvas.splitView.open'),
                    title: (el, s)=>el.call('polyglot', s.root?._canvasSlotSecond || s.root?._slotSplitIntent ? 'canvas.splitView.close' : 'canvas.splitView.open'),
                    Icon: {
                        name: 'columns'
                    },
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        // Toggle: exit an open (or arming) split, else start one and ask
                        // the global search for the second page.
                        if (s.root?._canvasSlotSecond || s.root?._slotSplitIntent) {
                            s.root.update({
                                _canvasSlotSecond: null,
                                _slotSplitIntent: false,
                                _slotPinned: (0, $cKTuv.slotPinAfterSecondLeaves)(s.root)
                            });
                            return;
                        }
                        // THE SEARCHBTN OPEN, plus the intent: the same two writes the
                        // header's own search button makes (shared HeaderTabs SearchBtn
                        // `openHeaderSearchMorph`) — remember where focus returns, open
                        // the search. The header search then focuses its input on that
                        // edge (or on the intent's own arrival while it is already
                        // open, AppHeader `focusSearchOnOpen`), and the input's focus
                        // opens the search dropdown under the pill: the launcher on an
                        // empty field, the results on typed text. No dropdown of this
                        // button's own — the picker anchored HERE was a second search
                        // surface with its own position and width.
                        //
                        // Cancelling is the search's: Escape and an outside dismissal
                        // clear the unused intent (closeNavSearch, the launcher's
                        // onClose), which removes the empty pane; this trigger gets
                        // focus back.
                        //
                        // A launcher that was open when this button was pressed has just
                        // been closed by that press (the dropdown's outside-press
                        // close), and its dismissal stamp would make the search's focus
                        // read as that close's own restore and open nothing. This press
                        // is a deliberate open, so the stamp goes first. The function is
                        // the shell's (functions/searchApps.js): absent elsewhere.
                        if (typeof el.context?.functions?.forgetSearchAppsDismissed === 'function') el.call('forgetSearchAppsDismissed');
                        if (el.node) s.root.__headerSearchReturnFocusTo = el.node;
                        s.root.update({
                            _slotSplitIntent: true,
                            _slotFullscreen: null,
                            _headerSearchOpen: true
                        });
                    }
                },
                FullscreenBtn: {
                    extends: 'PageSlotHeaderBtn',
                    // The mobile frame is already edge-to-edge in either state.
                    '@mobileL': {
                        display: 'none'
                    },
                    // B9 (tickets/bellforge.md): immersive members are ALWAYS
                    // edge-to-edge (slotFullscreenActive returns true regardless of
                    // the flag), so the expand toggle is a lying control for them —
                    // hidden. Admins (rail-only chrome) keep it; an admin PREVIEWING
                    // a non-admin persona (view-as) gets the truthful immersive
                    // chrome and loses it too, same contract as the navbars.
                    hide: (el, s)=>{
                        const fns = el.context?.functions || {};
                        const imm = typeof fns.moduleImmersiveActive === 'function' && fns.moduleImmersiveActive(s.root);
                        if (imm) {
                            // B9 rev (Nika 2026-08-16 admin-immersive default): immersive
                            // still hides the lying control for MEMBERS and for an admin
                            // PREVIEWING a member (view-as) — but a REAL admin's default
                            // is now immersive too, and this button is their ONE way to
                            // toggle the shell chrome back. Keep it for them.
                            const isAdmin = typeof fns.currentUserIsAdmin === 'function' && fns.currentUserIsAdmin(s.root);
                            const preview = typeof fns.moduleViewAsActive === 'function' && fns.moduleViewAsActive(s.root);
                            if (!isAdmin || preview) return true;
                        }
                        return !$ff11614ac4f941af$var$canvasFeatureEnabled(s.root, 'splitView') || !$ff11614ac4f941af$var$canvasFeatureEnabled(s.root, 'splitView.fullscreenMode') || !!s.root?._canvasSlotSecond || !!s.root?._slotSplitIntent;
                    },
                    // ONE name for the toggle (its state rides aria-pressed); the
                    // tooltip says what a press does now.
                    'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.toggleFullscreen'),
                    title: (el, s)=>{
                        const imm = el.context?.functions?.moduleImmersiveActive;
                        const on = typeof imm === 'function' && imm(s.root) || s.root?._slotFullscreen === true;
                        return el.call('polyglot', on ? 'canvas.pageSlot.fullscreenExit' : 'canvas.pageSlot.fullscreenEnter');
                    },
                    'aria-pressed': (el, s)=>{
                        const imm = el.context?.functions?.moduleImmersiveActive;
                        return typeof imm === 'function' && imm(s.root) || s.root?._slotFullscreen === true ? 'true' : 'false';
                    },
                    Icon: {
                        // Exit icon whenever the view is actually edge-to-edge: the
                        // rail-admin's immersive DEFAULT (chrome hidden — the toggle
                        // exits it) or an explicit fullscreen elsewhere.
                        name: (el, s)=>{
                            const fns = el.context?.functions || {};
                            const imm = typeof fns.moduleImmersiveActive === 'function' && fns.moduleImmersiveActive(s.root);
                            return imm || s.root?._slotFullscreen === true ? 'fullscreenExit' : 'fullscreen';
                        }
                    },
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        const fns = el.context?.functions || {};
                        const railOn = typeof fns.moduleRailActive === 'function' && fns.moduleRailActive(s.root);
                        const isAdmin = typeof fns.currentUserIsAdmin === 'function' && fns.currentUserIsAdmin(s.root);
                        const preview = typeof fns.moduleViewAsActive === 'function' && fns.moduleViewAsActive(s.root);
                        if (railOn && isAdmin && !preview) {
                            // Nika 2026-08-16: for a rail-workspace ADMIN this button
                            // toggles the CHROME — immersive default (navbar hidden,
                            // everything edge-to-edge, slot open or not) ⇄ shell chrome
                            // back. Persisted per workspace; _slotFullscreen resets so
                            // the chrome-on state resumes its own defaults.
                            const imm = typeof fns.moduleImmersiveActive === 'function' && fns.moduleImmersiveActive(s.root);
                            const nextPref = imm ? 'shell' : null;
                            if (typeof fns.writeModuleChromePref === 'function') fns.writeModuleChromePref(s.root, nextPref);
                            s.root.update({
                                _moduleChromePref: nextPref,
                                _slotFullscreen: null
                            });
                            return;
                        }
                        // Elsewhere: the explicit-fullscreen toggle (BF-PAGESLOT-EXPAND-1).
                        const explicit = s.root?._slotFullscreen === true;
                        const next = explicit ? null : true;
                        const writePref = el.context?.functions?.writeSlotFullscreenPref;
                        if (typeof writePref === 'function') writePref(s.root, next);
                        s.root.update({
                            _slotFullscreen: next
                        });
                    }
                }
            } : {},
            // Add-to-Workspace — ONLY on an app-build preview (/x-preview/* route,
            // opened by openExtensionPreview when the AI builds an app away from
            // /add-app) whose build is already persisted (metadata.__extensionApp
            // carries the projectId). Promotes the previewed app into the workspace's
            // additive apps: shared + navbar tab + launcher tile
            // (addExtensionToWorkspace owns the confirm + settings write).
            AddToWorkspaceBtn: {
                extends: 'PageSlotHeaderBtn',
                // display-FACTORY, not hide: — the gated hide provably mounted on the
                // element while the button still rendered (route said hidden too), so
                // hide: is not applied for this instance in this runtime. The dock's
                // reactive display pattern is the proven mechanism. Fail-CLOSED +
                // FA515 force-track of the claim keys.
                display: (el, s)=>{
                    s.root?.jwtClaims;
                    s.root?.user;
                    s.root?.org;
                    const fns = el.context?.functions || {};
                    let isAdmin = false;
                    let preview = false;
                    try {
                        isAdmin = typeof fns.currentUserIsAdmin === 'function' && fns.currentUserIsAdmin(s.root);
                        preview = typeof fns.moduleViewAsActive === 'function' && fns.moduleViewAsActive(s.root);
                    } catch (_) {
                        isAdmin = false;
                    }
                    if (!isAdmin || preview) return 'none';
                    const route = String(s.root?.[el.scope.SLOT_KEY] || '');
                    if (!route.startsWith('/x-preview/')) return 'none';
                    const def = $ff11614ac4f941af$var$_defFor(el, route, s.root);
                    return !def?.metadata?.__extensionApp?.projectId ? 'none' : 'flex';
                },
                'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.addToWorkspace'),
                title: (el)=>el.call('polyglot', 'canvas.pageSlot.addToWorkspace'),
                Icon: {
                    name: 'plus'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const def = $ff11614ac4f941af$var$_defFor(el, s.root?.[el.scope.SLOT_KEY], s.root);
                    const app = def?.metadata?.__extensionApp;
                    try {
                        el.call('addExtensionToWorkspace', app);
                    } catch (err) {
                        console.warn('[PageSlot] add-to-workspace failed:', err);
                    }
                }
            },
            // Save-as-app — ONLY on a transient AI answer view (/answer/* route). Promotes
            // the drawn view into a persisted /add-app extension (the bridge from
            // draw-on-fly UI to a workspace app). saveAnswerViewAsApp recovers the source
            // from the answer def's metadata.__source, creates the extension, and opens
            // /add-app where it renders. `hide` re-evaluates on route switch via the
            // pane's subscribeTo:[SLOT_KEY].
            SaveAsAppBtn: {
                extends: 'PageSlotHeaderBtn',
                // display-factory — same conversion + reasoning as AddToWorkspaceBtn.
                display: (el, s)=>{
                    s.root?.jwtClaims;
                    s.root?.user;
                    s.root?.org;
                    const fns = el.context?.functions || {};
                    let isAdmin = false;
                    let preview = false;
                    try {
                        isAdmin = typeof fns.currentUserIsAdmin === 'function' && fns.currentUserIsAdmin(s.root);
                        preview = typeof fns.moduleViewAsActive === 'function' && fns.moduleViewAsActive(s.root);
                    } catch (_) {
                        isAdmin = false;
                    }
                    if (!isAdmin || preview) return 'none';
                    return !String(s.root?.[el.scope.SLOT_KEY] || '').startsWith('/answer/') ? 'none' : 'flex';
                },
                'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.saveAsApp'),
                title: (el)=>el.call('polyglot', 'canvas.pageSlot.saveAsApp'),
                Icon: {
                    name: 'save'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    const route = s.root?.[el.scope.SLOT_KEY];
                    try {
                        el.call('saveAnswerViewAsApp', route);
                    } catch (err) {
                        console.warn('[PageSlot] save-as-app failed:', err);
                    }
                }
            },
            // Minimize — park the open app into the MinimizedDock, keep-alive: its
            // host stays mounted (display:none via the reactive predicate) so the
            // dock restore reveals the EXACT same element — scroll, inputs and
            // in-flight work intact. Primary pane only (v1): parked entries always
            // restore into the primary frame, so the split pane keeps its single
            // Close dismissal.
            ...primary ? {
                MinimizeBtn: {
                    extends: 'PageSlotHeaderBtn',
                    // Immersive member ON the module landing: parking the landing
                    // just re-opens it (the landing redirect owns `/`), so the
                    // control is circular there — hidden, same rationale as
                    // CloseBtn below.
                    hide: (el, s)=>{
                        const imm = el.context?.functions?.moduleImmersiveActive;
                        if (!(typeof imm === 'function' && imm(s.root))) return false;
                        const landFn = el.context?.functions?.moduleImmersiveLanding;
                        const landing = typeof landFn === 'function' ? landFn(s.root) : null;
                        if (!landing) return false;
                        return String(s.root?.[el.scope.SLOT_KEY] || '').split('?')[0] === landing;
                    },
                    'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.minimize'),
                    title: (el)=>el.call('polyglot', 'canvas.pageSlot.minimize'),
                    Icon: {
                        name: 'minus'
                    },
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        $ff11614ac4f941af$var$_minimizeSlot(el, s.root);
                    }
                }
            } : {},
            // KEEP THIS PANE OPEN — the opt-in pane pin (Nika 2026-10-10: "Yes, opt-in
            // pin"). In BOTH panes. A pinned pane is kept: a navbar or launcher open
            // lands BESIDE it, replacing the other pane (shell functions/searchApps.js
            // openAppPage). The house header button, the brand `pin` glyph, the
            // house on-state paint (same as SplitBtn). Shown only where it can work:
            // two panes fit (the `splitBelowFloor` complement), split view is on, and
            // the pane shows something. The pin moves with its pane on close and
            // minimise (functions/slotPin.js).
            PinBtn: {
                extends: 'PageSlotHeaderBtn',
                '@splitBelowFloor': {
                    display: 'none'
                },
                subscribeTo: [
                    '_slotPinned',
                    '_canvasSlot',
                    '_canvasSlotSecond'
                ],
                hide: (el, s)=>{
                    // Read FIRST, unconditionally (same reason as SplitBtn's hide).
                    const imm = el.context?.functions?.moduleImmersiveActive;
                    if (typeof imm === 'function' && imm(s.root)) return true;
                    return !$ff11614ac4f941af$var$canvasFeatureEnabled(s.root, 'splitView') || !$ff11614ac4f941af$var$canvasFeatureEnabled(s.root, 'splitView.splitPane') || !s.root?.[el.scope.SLOT_KEY];
                },
                background: (el, s)=>s.root?._slotPinned === el.scope.SLOT_KEY ? 'selected' : 'transparent',
                color: (el, s)=>s.root?._slotPinned === el.scope.SLOT_KEY ? 'title' : 'inactive',
                'aria-pressed': (el, s)=>s.root?._slotPinned === el.scope.SLOT_KEY ? 'true' : 'false',
                'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.keepPane'),
                title: (el)=>el.call('polyglot', 'canvas.pageSlot.keepPane'),
                Icon: {
                    name: 'pin'
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    s.root.update({
                        _slotPinned: (0, $cKTuv.slotPinToggle)(s.root, el.scope.SLOT_KEY)
                    });
                }
            },
            CloseBtn: {
                // THE house close affordance (brand CloseButton — one X, one size, for
                // every sheet, panel and window; F2 2026-08-16), not the quiet toolbar
                // circle the other header controls share: the window's X is the filled
                // close of the overlay language (DESIGN_SPEC §5.1 / §4.10), so it moves
                // with every modal's X when the brand restyles it. The tooltip trigger
                // stays; on a coarse pointer the box grows to the touch control, like
                // its toolbar neighbours, so adjacent targets never overlap.
                extends: [
                    'CloseButton',
                    'TitleTooltipTrigger'
                ],
                marginLeft: 'auto',
                '@coarse': {
                    boxSize: 'controlH',
                    ':after': {
                        inset: '0'
                    }
                },
                // Always visible — the X is a permanent affordance (2026-08-15 per Nika
                // "pageslot should have X icon dont hide it, and it should close to get
                // back on dashboard"). It never hides, on any page or persona.
                'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.close'),
                title: (el)=>el.call('polyglot', 'canvas.pageSlot.close'),
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    // Immersive member: there is no home board behind the slot — the slot
                    // IS their whole view — so Close means "back to the dashboard/landing"
                    // (Nika). Route the slot straight to the module's landing instead of
                    // _dismissPane's dismiss-to-`/` (which re-triggered the landing
                    // redirect and read as a no-op ON the landing). On the landing this is
                    // a same-value no-op — harmless, and the X stays present.
                    //
                    // EXCEPT an admin PREVIEWING a non-admin persona (moduleViewAsActive):
                    // their real shell still exists behind the sheet, and the landing
                    // routing left them with no exit at all ("after choosing different
                    // non-admin role — cant close pageslot", Nika 2026-08-15). For the
                    // preview, X REALLY closes — one press, sheet gone; the persistent
                    // module rail stays for re-entry and the persona switch back.
                    // Interrogate the TOP state, not this pane's `s.root` — measured live
                    // (bellf-qa, 2026-08-15): on PageSlot's s.root, currentUserIsAdmin
                    // resolves FALSE while the real root says TRUE, so moduleViewAsActive
                    // (admin-gated) read false here and the preview kept dead-ending on
                    // the landing. moduleImmersiveActive only "worked" on the partial
                    // root via its not-admin→immersive branch — the same wrong answer
                    // with a lucky sign. getRootState() is the element API the rest of
                    // canvas already uses for top-state reads.
                    const rs = typeof el.getRootState === 'function' && el.getRootState() || s.root;
                    const imm = el.context?.functions?.moduleImmersiveActive;
                    if (typeof imm === 'function' && imm(rs)) {
                        const va = el.context?.functions?.moduleViewAsActive;
                        const previewing = typeof va === 'function' && va(rs);
                        // X CLOSES for immersive members too, when the module declares a
                        // rail (Nika: "allow non-admins to close pageslot"). This used to
                        // re-route to the module landing for everyone non-admin, on the
                        // reasoning that a chromeless member closing the page would be
                        // stranded on a bare board with no way back. That reasoning still
                        // holds for a module with NO rail — so those keep the re-route
                        // untouched — but not for one that declares `chrome.rail`: the
                        // shell mounts that rail on every route INCLUDING '/', so the board
                        // they land on is fully navigable. Bellforge is the rail case.
                        const railFn = el.context?.functions?.moduleRailActive;
                        const hasRail = typeof railFn === 'function' && railFn(rs);
                        if (!previewing && !hasRail) {
                            const landFn = el.context?.functions?.moduleImmersiveLanding;
                            const landing = typeof landFn === 'function' ? landFn(rs) : null;
                            if (landing) {
                                s.root.update({
                                    [el.scope.SLOT_KEY]: landing
                                });
                                return;
                            }
                        }
                        if (!previewing && hasRail) // One-shot reopen suppression — the SAME handshake moduleGoHome
                        // uses (workspaceProjects.js). `_slotOnClose`'s immersive landing
                        // reopen is a second writer that would otherwise undo this close a
                        // tick later (measured at 11ms), so without this flag the X reads
                        // as doing nothing at all. Falls through to the real dismiss below.
                        rs._slotSkipReopenOnce = true;
                    }
                    // Non-immersive (admin): iPad semantics on the primary (closing
                    // promotes the remaining pane); the split pane closes itself and
                    // cancels an in-progress split. Shared with the phone drag-to-dismiss
                    // gesture — see _dismissPane.
                    $ff11614ac4f941af$var$_dismissPane(s.root, el.scope.primary);
                }
            }
        },
        // ── Content row: apps rail + mount target ─────────────────────────────
        // The rail slides OVER the page (absolutely positioned inside this box),
        // so the box is the positioning + clipping context. The Slot is this row's
        // flex item and the keep-alive hosts are the Slot's — the same sizing lever
        // as before, one level down (_paneOf and slotPaneKeyFor walk by pane stamp,
        // so every pane reach stays correct). The Slot is the hosted pages'
        // stacking context; a host scrolls, so it may never become one (see the
        // Slot and _hostDef notes — the iOS fixed-layer rule).
        Body: {
            flex: '1 1 0',
            minWidth: '0',
            minHeight: '0',
            width: '100%',
            flow: 'x',
            overflow: 'hidden',
            position: 'relative',
            // (The person's sidebar choice is the page's own now — shared
            // functions/pageSidebar.js, one key per page: a hidden AppSidebar folds
            // itself down to its reopen tab, in a window exactly as at its own URL,
            // so this box carries no rule of its own.)
            // Container breakpoints follow this pane's width, including split
            // views, independently of the browser viewport.
            // Reset the module-rail clearance for everything INSIDE the slot: the
            // slot pane itself already insets left by the rail's width (the
            // .isSlotFullscreen class), so module pages that pad-left by the same
            // var on ROUTE mounts must resolve it to 0 here or they double-inset.
            style: {
                containerType: 'inline-size',
                containerName: 'app-surface',
                '--module-rail-clear': 'calc(var(--spacing-A) * 0)'
            },
            AppsRail: $ff11614ac4f941af$var$_slotRail(SLOT_KEY),
            // The mount target — keep-alive per pane, el.set(pageDef).
            Slot: {
                // On the split pane, collapse the mount target while the placeholder shows
                // (no route yet) so the EmptyState fills the pane. The primary Slot is
                // always present — its onUpdate owns the ?page= URL sync.
                hide: (el, s)=>el.scope.placeholderKey ? !s.root?.[el.scope.SLOT_KEY] : false,
                // A REAL BOX, AND THE PANE'S ONE STACKING CONTEXT FOR ITS PAGES. The key
                // renders a `<slot>` element, whose UA style is `display: contents` — so
                // until 2026-10-05 this generated no box and the keep-alive hosts were the
                // content row's flex items. It now declares its display and carries
                // WS-SLOT-HOST-ISOLATES-STACKING-1's isolation (a module page's own z 20 /
                // z 30 layers stay under the apps rail, z 3, this box's positioned
                // sibling). The isolation moved here from the host because the host
                // SCROLLS, and iOS Safari clips every fixed layer inside a scroller that
                // is a stacking context (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1). So this box
                // never scrolls — no `overflow` — and the hosts below never isolate.
                // Its box is the content row's (flex 1 1 0, full width, no padding), so
                // every host keeps its size.
                display: 'flex',
                flex: '1 1 0',
                minWidth: '0',
                minHeight: '0',
                width: '100%',
                // A flat prop: `isolation` is in css-in-props' property list, and the
                // shell root's own flat `isolation` computes `isolate` live (dev,
                // 2026-10-05). The host's old `style` route answered a socials 1.7.1
                // reading of `auto` on an imperatively created host.
                isolation: 'isolate',
                // No own ground since the 2026-09-01 gray-pane pass: the PANE's
                // 'pane-ground' gray IS the sheet's ground, and the symmetric gutter
                // below lets it frame the mounted page. A painted 'document' fill here
                // would cover the gray.
                // The mounted page root must fill the space REMAINING under the pane
                // Header — not the whole pane.
                //
                // History (when this element was `display: contents` and the content row
                // did not exist yet): the page root was a direct flex child of
                // PanePrimary. Page roots carry
                // `min-height: 100%`, which then resolved against the PANE (794px) rather
                // than the leftover space, so every slot page laid out as
                // `Header (47px) + page (794px) = 841px` inside a 794px pane whose overflow
                // is hidden — silently clipping the bottom ~47px of EVERY page opened in
                // the sheet, with no way to scroll to it.
                //
                // Sizing the child as a flex item makes it take the remaining height, at
                // which point the page's own scroll container works as designed. Anchored
                // through the slot scope, the same lever the sidebar rules below use,
                // because the page def can't be edited from here (`el.set` re-creates it).
                //
                // `[data-key]` rather than `*` is load-bearing: the page root's own
                // `min-height: 100%` comes from an atomic CLASS, so a `& > *` selector ties
                // it on specificity (0,1,0) and the winner falls to stylesheet order — it
                // lost, and the page stayed pinned to full pane height. The attribute
                // selector takes it to (0,2,0) so the override is deterministic. Every
                // mounted page root carries a data-key.
                // margin 'Y' = the symmetric content gutter (2026-09-01 per Nika
                // "keep paddings symmetrical for all pageslot content"): the host
                // sheet insets equally on all four sides — Y under the header, Y at
                // both edges (matching the header's own '0 Y' inset), Y at the
                // bottom. background transparent = ONE ground: this (0,2,0) rule
                // outweighs a page root's own atomic ground class, so every page in
                // the slot sits directly on the pane's stage-chain ground instead of
                // painting a second document-family sheet over it ("keep one bg" /
                // "very consistent"). Page content SURFACES (cards, grids) keep
                // their own fills. Phone keeps the edge-to-edge sheet (the @mobileL
                // block below zeroes the margin).
                '& > [data-key]': {
                    flex: '1 1 0',
                    minWidth: '0',
                    minHeight: '0',
                    maxWidth: 'calc(100% - var(--spacing-Y) * 2)',
                    margin: 'Y',
                    background: 'transparent'
                },
                // The page's INNER 'content' wrappers (AppPage / the router mount
                // convention) paint the stage chain for STANDALONE renders — inside
                // the pane that re-painted gray5 patches over the unified sheet
                // (measured 2026-09-01: a 1896x779 stage-colored wrapper behind
                // CalMain). Inside the slot, grounds belong to the pane alone.
                '& [data-key="content"]': {
                    background: 'transparent'
                },
                // Split panes need the same width bounds as phones: wide tables and
                // unbroken text must scroll inside their host, not widen the frame.
                // Only the phone's edge-to-edge content removes the desktop gutter.
                '@mobileL': {
                    '& > [data-key]': {
                        maxWidth: '100%',
                        margin: '0'
                    }
                },
                // Hide the mounted page's OWN nav rail inside the sheet — the sheet is a
                // focused modal and these rails duplicate switchers owned by their canvas
                // surface. The rail can't be stripped from the pre-extended page def via
                // el.set (key-based auto-extend re-creates it — verified 2026-06-15), so a
                // scope-anchored descendant rule is the reliable lever.
                '& [data-key="TicketsSidebar"]': {
                    display: 'none'
                },
                '& [data-key="ResolutionsSidebar"]': {
                    display: 'none'
                },
                // workspaceProject is a REAL dependency of the mount: module routes only
                // resolve once the loader injects the module's pages. Subscribing to it
                // makes the mount order-independent — if the ?page= restore (or any
                // opener) sets the slot key BEFORE injection, the injection tick retries
                // _mountPane and the sheet fills the moment the def exists (previously a
                // pre-injection open stayed an empty sheet forever: the re-apply write is
                // same-value → deduped, so nothing re-fired this effect).
                // `_minimizedSlots` re-fires the host sweep on dock closes / evictions;
                // `_slotNudge` re-fires it after a close choreography lands (the sweep
                // defers while the pane holds `_closing` so a fading sheet never blanks).
                subscribeTo: [
                    SLOT_KEY,
                    'workspaceProject',
                    '_minimizedSlots',
                    '_slotNudge'
                ],
                // Back/forward reopens (or closes) the slot the URL describes — the read
                // half of `_writeSlotUrl`'s pushState in onCreate below.
                //
                // This was a raw `window.addEventListener('popstate', …)` latched on a
                // `window.__slotPopstateWired` GLOBAL — a Rule 64 window write AND an
                // anonymous handler nothing could ever remove. The latch existed only
                // because the registration had no owner; a declared prop has one, so
                // both are gone. PRIMARY still owns the URL: the secondary pane must
                // never sync it, which is why the guard moved into the handler rather
                // than into the registration.
                onWindowPopstate: (ev, el, s)=>{
                    if (!el.scope?.primary) return;
                    $ff11614ac4f941af$export$91a98ef76979ad4(s.root);
                },
                onCreate: (el, s)=>{
                    // Primary only (re)affirms the URL on mount when a slot is ALREADY open.
                    // NEVER write on the initial null mount — the slot is always mounted, so
                    // an unconditional write would DELETE a ?page= param on page load before
                    // the home onCreate reads it back, breaking reload-restore.
                    if (el.scope.primary && s.root?._canvasSlot) $ff11614ac4f941af$export$37c9ecc617dfacb6(s.root._canvasSlot, s.root);
                    // The read half of the pushState above is DECLARED — see
                    // `onWindowPopstate` below.
                    // Baseline for onUpdate's edge-triggers below (URL sync + close
                    // notify) — must mirror the mount-time value just acted on above, or
                    // their FIRST update pass (often fired by the workspaceProject
                    // subscription above, before any real slot change) reads as a
                    // spurious transition.
                    if (el.scope.primary) {
                        el.__lastSlotPath = s.root?._canvasSlot || null;
                        if (el.__lastSlotPath) el.__slotTitleOwner = $ff11614ac4f941af$var$_routeTitleOwner(el);
                    }
                    // File the already-open route into this pane's history (reload restore
                    // mounts with the slot key pre-set, so onCreate is its first sighting).
                    $ff11614ac4f941af$var$_recordSlotHist(s, el.scope.SLOT_KEY, el);
                    $ff11614ac4f941af$var$_mountPane(el, s, el.scope.SLOT_KEY);
                    if (el.scope.primary) $ff11614ac4f941af$var$_adoptActive(el, s);
                    $ff11614ac4f941af$var$_sweepHosts(el, s, el.scope.SLOT_KEY, el.scope.primary);
                },
                onUpdate: (el, s)=>{
                    if (el.scope.primary) {
                        const path = s.root?._canvasSlot || null;
                        const was = el.__lastSlotPath;
                        el.__lastSlotPath = path;
                        if (path && !was) el.__slotTitleOwner = $ff11614ac4f941af$var$_routeTitleOwner(el);
                        // URL sync on the SLOT_KEY's OWN transitions only — never merely
                        // because a SIBLING subscription re-rendered this pane.
                        // `workspaceProject` sits in subscribeTo above so a mid-boot module
                        // publish retries `_mountPane` (see the comment on that array);
                        // before this guard, that same publish re-ran this write on every
                        // pass, and while a cold-load ?page= restore hadn't landed yet
                        // (_canvasSlot still null across the publish) it read as "the user
                        // just closed the slot" and deleted the boot ?page= param before
                        // _restorePageParam (workspaceProjects.js) ever got a chance to
                        // read it back (WS-MODULE-PAGE-DEEPLINK-DROPPED-ON-COLD-LOAD-1).
                        // push — a room, a board, an item are each a real open the user
                        // did; back steps through them (WS-MODULE-ROUTE-QUERY-NO-HISTORY-
                        // ENTRY-1). An in-place query patch is not an open: the page stays
                        // and only its route changes, so it REPLACES the entry (see
                        // `_inPlaceQueryPatch`; Back must never land on the `?new=1` the
                        // page already consumed). _writeSlotUrl itself still replaces on a
                        // close (path falsy) or a no-op (URL unchanged) — see its own comment.
                        if (path !== was) $ff11614ac4f941af$export$37c9ecc617dfacb6(path, s.root, {
                            push: !$ff11614ac4f941af$var$_inPlaceQueryPatch(el, path, was)
                        });
                        // The home callback owns its immersive close/reopen behavior. Every
                        // dedicated route must also reclaim its current Helmet title: the
                        // underlying page stays mounted, so Helmet does not run on close.
                        // EDGE-TRIGGERED (2026-08-16): this hook used to fire on EVERY
                        // update pass while the slot stayed null, so any root churn in the
                        // closed window re-invoked it — which defeated one-shot guards
                        // inside (measured: moduleGoHome's _slotSkipReopenOnce was
                        // consumed by pass 1 and pass 2 ran the immersive reopen anyway).
                        // Notify only on the non-null → null TRANSITION (`was` above is
                        // the shared edge state the URL sync also reads).
                        if (!path && was && s.root) {
                            if (s.root._slotOnClose) s.root._slotOnClose();
                            if (!s.root._canvasSlot) $ff11614ac4f941af$var$_restoreRouteTitle(el);
                        }
                    }
                    // Per-pane history recorder — the one choke point every slot writer
                    // flows through (see _recordSlotHist). Before the mount guard, so the
                    // arrows' disabled state settles in the same pass as the route, and
                    // so a re-mount's fresh host (stamped with the NEW route once its
                    // apply lands) can never read as an in-place patch here.
                    $ff11614ac4f941af$var$_recordSlotHist(s, el.scope.SLOT_KEY, el);
                    $ff11614ac4f941af$var$_mountPane(el, s, el.scope.SLOT_KEY);
                    // Un-park a restored route, then unmount whatever is neither active,
                    // nor parked, nor stamped for the live workspace (see _sweepHosts).
                    if (el.scope.primary) $ff11614ac4f941af$var$_adoptActive(el, s);
                    $ff11614ac4f941af$var$_sweepHosts(el, s, el.scope.SLOT_KEY, el.scope.primary);
                    // After the mount guard: a keep-alive re-open (mount skipped, helmet
                    // silent) and a second-pane close both land here needing the primary's
                    // title re-asserted.
                    $ff11614ac4f941af$var$_syncSlotTitle(el, s.root);
                }
            },
            // Split-pane placeholder — the moment a split is armed (before an app is
            // picked) the empty second pane shows this instead of blank space, so the
            // split telegraphs (2026-07-16 per Nika "display placeholder section").
            // Reuses the house EmptyState; only the split pane ships it (placeholderKey).
            ...placeholderKey ? {
                SplitPlaceholder: {
                    extends: 'EmptyState',
                    subscribeTo: [
                        SLOT_KEY,
                        placeholderKey
                    ],
                    hide: (el, s)=>!!s.root?.[el.scope.SLOT_KEY] || !s.root?.[el.scope.placeholderKey],
                    flex: '1 1 0',
                    minHeight: '0',
                    icon: 'columns',
                    // KEY on `heading` / `hintText` — the shared EmptyState resolves
                    // both through polyglot (docs/I18N-CONVENTION.md §1.2).
                    heading: 'canvas.pageSlot.placeholder.heading',
                    hintText: 'canvas.pageSlot.placeholder.hint'
                }
            } : {}
        },
        // THE RESIZE HANDLE (the width block above): the sheet's right edge, a
        // focusable vertical separator with its value. A drag, the arrow keys (Shift
        // for a longer step), Home / End and Enter; a double-click returns to the
        // default. Only on the one floating window, and not where the sheet is
        // already the whole band (a tablet, a phone). The reset's focus ring shows
        // on keyboard focus; the strip tints on hover and focus.
        SheetResizeHandle: {
            hide: (el, s)=>!el.scope.primary || !$ff11614ac4f941af$var$_isSheet(el, s.root),
            position: 'absolute',
            top: '0',
            right: '0',
            bottom: '0',
            width: 'Y',
            zIndex: '3',
            cursor: 'col-resize',
            touchAction: 'none',
            userSelect: 'none',
            background: 'transparent',
            transition: 'background-color A defaultBezier',
            ':hover': {
                background: 'selected'
            },
            ':focus-visible': {
                background: 'selected'
            },
            '@tabletS': {
                display: 'none'
            },
            role: 'separator',
            tabindex: '0',
            'aria-orientation': 'vertical',
            'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.resizeWindow'),
            'aria-valuemin': String($ff11614ac4f941af$var$_SHEET_MIN_PCT),
            'aria-valuemax': '100',
            'aria-valuenow': (el, s)=>String(Math.round($ff11614ac4f941af$var$_sheetPct(s.root))),
            'aria-valuetext': (el, s)=>`${Math.round($ff11614ac4f941af$var$_sheetPct(s.root))}%`,
            onPointerdown: (e, el, s)=>$ff11614ac4f941af$var$_sheetDragStart(e, el, s),
            onPointermove: (e, el, s)=>$ff11614ac4f941af$var$_sheetDragMove(e, el, s),
            onPointerup: (e, el, s)=>$ff11614ac4f941af$var$_sheetDragEnd(e, el, s, false),
            onPointercancel: (e, el, s)=>$ff11614ac4f941af$var$_sheetDragEnd(e, el, s, true),
            onLostpointercapture: (e, el, s)=>$ff11614ac4f941af$var$_sheetDragEnd(e, el, s, true),
            onKeydown: (e, el, s)=>$ff11614ac4f941af$var$_sheetKey(e, el, s),
            onDblclick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                if (s.root) $ff11614ac4f941af$var$_saveSheetPct(el, s.root, null);
            }
        }
    });
// ── The window's presentation (DESIGN-WL-PAGESLOT-OPEN-SPLIT-SEARCH-1) ────────
//
// Nika's pick 10 A (2026-09-28, AI_ASSISTANT_SPEC §11): app pages open as an
// iPad SHEET above the composer dock — the aihouse pattern (templates/aihouse
// PropertyModal): a blurred veil, a card anchored above the dock with the dock
// reserved, full screen on a phone, closed by Escape (the shell keyboard
// registry presses the window's own X — shortcutsDefault closeAppWindow) or a
// press on the veil. Unlike aihouse, where the ask bar lives INSIDE the modal,
// the shell composer floats over the window, so the window is no modal
// dialog (see the note on the frame). The frame's band is unchanged (--slot-top to
// --slot-bottom, X2 gutters — every shell rule that moves it for a drawer or a
// dock still applies); a SINGLE pane in the default floating state is the
// person's share of that band, aligned to its leading edge (the width block
// above `_slotPane`). A split (two windows side by side) and the module presentations — fullscreen,
// the admin's expanded view, the rail inset, immersive members — keep the
// whole band exactly as before.
//
// One read for every consumer (the frame's classes and attributes, the veil,
// the Tab trap). Every dependency is read up front and unconditionally, so a
// factory that calls this re-runs on any of them — a short-circuit would drop
// a tracked read (the persona flip, a fullscreen toggle).
const $ff11614ac4f941af$var$_slotModes = (el, root)=>{
    const fns = el.context?.functions || {};
    const primary = !!root?._canvasSlot;
    const second = !!root?._canvasSlotSecond;
    const arming = !!root?._slotSplitIntent;
    const imm = typeof fns.moduleImmersiveActive === 'function' && !!fns.moduleImmersiveActive(root);
    const rail = typeof fns.moduleRailActive === 'function' && !!fns.moduleRailActive(root);
    const fsFn = fns.slotFullscreenActive;
    const fullscreen = typeof fsFn === 'function' ? !!fsFn(root) : (!!root?._slotFullscreen || imm) && !second && !arming;
    return {
        open: primary || second,
        split: second || arming,
        imm: imm,
        rail: rail,
        fullscreen: fullscreen
    };
};
// The veil closes the window only where the veil is the page behind a
// floating sheet. An immersive member's window IS their surface (its close is
// a route to the module landing, the X's job), and a fullscreen window leaves
// no page to press.
const $ff11614ac4f941af$var$_veilCloses = (el, root)=>{
    const m = $ff11614ac4f941af$var$_slotModes(el, root);
    return m.open && !m.imm && !m.fullscreen;
};
const $ff11614ac4f941af$export$e3a027b15aa1ba11 = {
    subscribeTo: [
        '_canvasSlot',
        '_canvasSlotSecond',
        '_slotSplitIntent',
        '_slotFullscreen'
    ],
    hide: (el, s)=>!(s.root?._canvasSlot || s.root?._canvasSlotSecond),
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '20',
    // A PRESS ON THE VEIL CLOSES THE WINDOW (pick 10 A — the aihouse sheet:
    // "Esc or the veil closes it"). The veil only covers the PAGE: every piece
    // of chrome — the header, the composer, the rails — sits above z 20 and
    // stays live, so the press that closes is a press on the page behind, never
    // on a control. Where the veil must not close (an immersive member's
    // window, a fullscreen one) it stays click-through as before.
    pointerEvents: (el, s)=>$ff11614ac4f941af$var$_veilCloses(el, s.root) ? 'auto' : 'none',
    onClick: (e, el, s)=>{
        if (!$ff11614ac4f941af$var$_veilCloses(el, s.root)) return;
        e.preventDefault();
        $ff11614ac4f941af$var$_closeSlot(s.root);
    },
    // Tuned down over several passes (per Nika: "a bit more grayish" → "make more
    // lighter" → "maybe make it lighter" → "add more opacity so background is a
    // bit visible"). Two independent dials, and by the end the TINT was already
    // near nothing — gray7 (rgba(101,101,111)) at 0.12 — so the thing still
    // hiding the page was the BLUR, not the colour. Hence 4px rather than 8px:
    // at this radius the page behind stays legible in outline (you can see what
    // you left open) while the slot's glass panes still read as the focused
    // layer. Softening the blur is what actually makes the background visible;
    // dropping the tint alone would only have shifted its colour.
    //
    // Fixed-colour sweep: kept — this veils WHATEVER app page happens to be
    // open behind the slot (arbitrary, theme-unknown from here by
    // construction), not this component's own chrome. A neutral fixed tint
    // dims any page by a consistent amount regardless of its theme.
    //
    // THE WINDOW VEIL IS NOW A NAMED THEME (DESIGN_SPEC §6.1 "Window", §6.3):
    // brand 3.14.798's `backdropSoft` IS this hand-tuned veil byte for byte —
    // `scrimSoft` = gray7.12 in BOTH schemes + blur(4px) — so adopting it
    // changes nothing on screen in either scheme, and the tuning now lives in
    // the one place every non-blocking veil reads. Under reduced transparency
    // the blur goes (§6.5).
    theme: 'backdropSoft',
    '@reduceTransparency': {
        backdropFilter: 'none'
    }
};
const $ff11614ac4f941af$export$6d7d475dd49a348 = {
    flow: 'y',
    gap: 'A',
    padding: 'B C',
    width: '100%',
    minWidth: '0',
    minHeight: '0',
    boxSizing: 'border-box',
    // A loading region: busy, and named for assistive technology.
    role: 'status',
    'aria-busy': 'true',
    'aria-label': (el)=>el.call('polyglot', 'common.state.loading'),
    '@mobileL': {
        padding: 'A'
    },
    SkeletonRow_title: {
        width: '40%',
        height: 'B',
        marginBottom: 'Z'
    },
    SkeletonRow_1: {
        width: '60%'
    },
    SkeletonRow_2: {
        width: '100%'
    },
    SkeletonRow_3: {
        width: '85%'
    },
    SkeletonRow_4: {
        width: '70%'
    },
    SkeletonRow_5: {
        width: '90%'
    }
};
const $ff11614ac4f941af$export$9287b8cbd399c7e3 = {
    // Fixed frame above every page surface — canvas rails + overlay chrome sit
    // at 900/950 (globalScope.js's "Canvas layering contract", both below the
    // platform AppHeader on purpose); ModalRoot (10500) and notifications stay
    // above. pointerEvents:none so the frame never blocks the page when a pane
    // is closed; panes re-enable.
    position: 'fixed',
    zIndex: '1300',
    pointerEvents: 'none',
    // Equal live-measured gaps: --slot-top = header-navbar bottom + --nav-gap,
    // --slot-bottom = composer top + --nav-gap (ResizeObserver-maintained in
    // app.js). Bare custom-property names — scratch wraps a bare --name in var()
    // exactly once (inline var()/calc() would re-wrap and void the rule).
    top: '--slot-top',
    bottom: '--slot-bottom',
    left: 'X2',
    right: 'X2',
    flow: 'x',
    gap: 'Z',
    // THE SHEET (pick 10 A — see `_slotModes`) is sized on the PANE, as a
    // share of this band (the width block above `_slotPane`): the frame itself
    // stays the band in every state — top, bottom and the X2 gutters, and every
    // shell rule that moves them for a drawer or a dock — so the sheet stays
    // anchored above the dock and every layer that reads the band is untouched.
    // NOT a modal dialog, on purpose. The composer floats OVER the window (the
    // shell's 1400 layer, canvas CanvasPromptTextarea F2: "so a person can
    // prompt over an open app"), and the shell keyboard registry treats a window
    // as a SURFACE, not an overlay (functions/shortcuts.js — `/` reaches the
    // composer, G-sequences navigate, Esc presses the window's own X through
    // closeAppWindow). `role="dialog"` / `aria-modal` would hide the composer
    // from assistive technology, trap Tab away from it and silence every
    // binding while focus sits in the window. So each pane stays a labelled
    // region (`_slotPane`), focus still moves in on open and back on close, and
    // Esc and a press on the veil close it.
    // Edge-to-edge fullscreen (single-pane primary). A conditional CLASS — not
    // reactive layout factories, which garbage when re-run on a class-toggle
    // re-render in v3.14 (verified 2026-07-11).
    isSlotFullscreen: (el, s)=>{
        if ($ff11614ac4f941af$var$_slotOnPhone(s.root)) return false;
        // Immersive module chrome (workspace module manifest `chrome.immersive`,
        // resolved by the shell's moduleImmersiveActive): these members have no
        // shell header/composer, so the slot runs edge-to-edge by default — the
        // module page IS the app surface. Reactivity rides the _canvasSlot
        // re-render (the immersive landing is opened in the same pass that
        // publishes workspaceProject).
        //
        // A rail alone (chrome.rail, admins included) deliberately does NOT
        // force fullscreen anymore: for admins the shell navbar + composer are
        // still live chrome, and an edge-to-edge sheet ran UNDER the navbar and
        // let the composer float over slot content (measured live 2026-08-14,
        // per Nika "fix sidebar + pageslot positions when signed with admin so
        // it does not overlap them"). Admins keep the floating card, inset
        // beside the rail by the .isSlotRailInset class below; immersive
        // members (no navbar/composer) keep edge-to-edge.
        const imm = el.context?.functions?.moduleImmersiveActive;
        const immersive = typeof imm === 'function' && imm(s.root);
        const fsFn = el.context?.functions?.slotFullscreenActive;
        const active = typeof fsFn === 'function' ? fsFn(s.root) : (!!s.root?._slotFullscreen || immersive) && !s.root?._canvasSlotSecond && !s.root?._slotSplitIntent;
        // Edge-to-edge for immersive chrome AND for an EXPLICIT user toggle
        // (BF-PAGESLOT-EXPAND-1: with edge-to-edge reserved to immersive, an
        // admin's expand click changed the slot by 12 TOTAL pixels — gutters
        // only — which Nika read, correctly, as "expand does not work". The
        // DEFAULT expanded state keeps the chrome clearances below; the
        // explicit toggle is the user's own call to cover the chrome, which
        // the 2026-08-14 no-overlap complaint — about a FORCED structural
        // fullscreen — never prohibited).
        return active && immersive || s.root?._slotFullscreen === true && active;
    },
    // Left edge insets by the immersive module rail's live width
    // (--module-rail-clear, 0 whenever no rail renders) — the slot opens
    // BESIDE the module's persistent nav, never under it.
    '.isSlotFullscreen': {
        // Nika 2026-08-16: the expanded view keeps LITTLE top/bottom offsets —
        // never flush to the screen edge. Z is the small desk step; the rail
        // matches it (app.js ModuleRailHost base geometry) so the two stay on
        // one band.
        top: 'Z',
        // SHELL-ASSISTANT-RESERVE-1: a `.case` block lands INLINE, so these
        // edges outrank the shell's attribute-keyed `[data-key="PageSlot"]`
        // dock rules — the sheet slid UNDER the docked AI drawer. Add the
        // shell-published per-side inset (`--assistant-inset-*`, 0px when
        // nothing is docked on that side, the clamped drawer reserve when it
        // is) so the slot always clears the drawer in every state.
        left: 'calc(var(--module-rail-clear, 0px) + var(--assistant-inset-left, 0px))',
        right: 'var(--assistant-inset-right, 0px)',
        bottom: 'Z'
    },
    // Expanded (B1, tickets/bellforge.md): the ADMIN's fullscreen — maximal
    // within live chrome. Vertical band stays --slot-top/--slot-bottom (navbar
    // + composer remain usable, per the 2026-08-14 no-overlap contract); the
    // horizontal gutters drop, flush to the module rail on the left and the
    // viewport on the right. Module workspaces open in THIS state by default
    // (slotFullscreenActive's tri-state default); the header toggle records an
    // explicit choice that persists per workspace.
    // Rail-edge frame (2026-09-02, bellforge lane relaying Nika "left is
    // correct margin — right and bottom and top is not, fix proportions those
    // in pageslot"): in the fullscreen state WITH a module rail the slot's
    // left edge sits one Z off the rail while its right edge touched the
    // window (measured on app.bellforge.eu: rail band x 10..262, slot left
    // 272, right 0, top/bottom Z). The frame now reads Z on all four sides:
    // right gains the same Z the rail keeps on the left (plus the assistant
    // inset, as before). Declared AFTER '.isSlotFullscreen' so it wins the
    // cascade at equal specificity; no-rail fullscreen keeps right 0.
    isSlotRailEdge: (el, s)=>{
        if ($ff11614ac4f941af$var$_slotOnPhone(s.root)) return false;
        const railFn = el.context?.functions?.moduleRailActive;
        if (!(typeof railFn === 'function' && railFn(s.root))) return false;
        return !!el.isSlotFullscreen?.(el, s);
    },
    '.isSlotRailEdge': {
        right: 'calc(var(--spacing-Z) + var(--assistant-inset-right, 0px))'
    },
    isSlotExpanded: (el, s)=>{
        if ($ff11614ac4f941af$var$_slotOnPhone(s.root)) return false;
        const imm = el.context?.functions?.moduleImmersiveActive;
        const immersive = typeof imm === 'function' && imm(s.root);
        const fsFn = el.context?.functions?.slotFullscreenActive;
        const active = typeof fsFn === 'function' ? fsFn(s.root) : !!s.root?._slotFullscreen && !s.root?._canvasSlotSecond && !s.root?._slotSplitIntent;
        // The chrome-cleared band is the DEFAULT expanded state only — an
        // explicit toggle escalates to the edge-to-edge class above.
        return active && !immersive && s.root?._slotFullscreen !== true;
    },
    // S4 (tickets/sonnet.md, NIKA BATCH 2026-08-16): top was --slot-top (live
    // AppHeader-measured: --nav-clear + --nav-gap) while every sidebar this
    // view sits beside — ProjectCanvasSidebar, CanvasViewSidebar, InfraSidebar,
    // CanvasV2CodeEditor, VersionDetailPanel, VersionHistoryPanel — uses
    // --shell-top (px-pinned @property: spacing-C1 + 3px + safe-area-inset-top).
    // Two different mechanisms computing what's supposed to be the same edge
    // never guaranteed the same pixel value. Expanded is the ADMIN's flush,
    // beside-the-rail view specifically, so it now shares the sidebars' own
    // top var instead of the floating-card's live-measured one (the BASE
    // isSlotFullscreen/default states keep --slot-top/-bottom untouched — that
    // symmetry is deliberate for the floating card, unrelated to this bug).
    '.isSlotExpanded': {
        top: '--shell-top',
        // Same inline-case rule as `.isSlotFullscreen` above: keep clear of a
        // docked AI drawer on either side (SHELL-ASSISTANT-RESERVE-1) — and of
        // the navbar where the person put it on a side (`--nav-inset-*`, 0px at
        // the top; the shell's "THE NAVBAR'S PLACE" rules). max() on the left: a
        // module rail beside a left navbar already reaches past it.
        left: 'calc(max(var(--module-rail-clear, 0px), var(--nav-inset-left, 0px)) + var(--assistant-inset-left, 0px))',
        right: 'calc(var(--assistant-inset-right, 0px) + var(--nav-inset-right, 0px))',
        bottom: '--slot-bottom'
    },
    // Persistent module rail WITHOUT fullscreen (the admin default): the
    // floating card keeps its navbar/composer clearances (--slot-top/-bottom)
    // and only the LEFT edge moves — beside the rail with the same X2 gutter
    // the right edge keeps, so the card never sits under the rail ("pageslots
    // open right to the sidebar", overlap-free for admins).
    isSlotRailInset: (el, s)=>{
        if ($ff11614ac4f941af$var$_slotOnPhone(s.root)) return false;
        const railFn = el.context?.functions?.moduleRailActive;
        if (!(typeof railFn === 'function' && railFn(s.root))) return false;
        const imm = el.context?.functions?.moduleImmersiveActive;
        const immersive = typeof imm === 'function' && imm(s.root);
        const fsFn = el.context?.functions?.slotFullscreenActive;
        const fullscreen = typeof fsFn === 'function' ? fsFn(s.root) : (!!s.root?._slotFullscreen || immersive) && !s.root?._canvasSlotSecond && !s.root?._slotSplitIntent;
        return !fullscreen;
    },
    '.isSlotRailInset': {
        // + the left-dock inset (SHELL-ASSISTANT-RESERVE-1) — the right edge in
        // this state is the base X2 gutter, which the shell's dock rule outranks.
        left: 'calc(var(--module-rail-clear, 0px) + var(--spacing-X2) + var(--assistant-inset-left, 0px))'
    },
    // ── Phone: the frame becomes an iOS sheet ────────────────────────────────
    //
    // FULL-BLEED — left/right/bottom 0 (the X2 chrome gutters are a desktop
    // island idea; a phone sheet owns the screen edge) and the composer
    // clearance is deliberately SUSPENDED: --slot-bottom exists to keep a
    // floating card off the s1m0ne composer, but a sheet is allowed to cover it,
    // the same way an iOS sheet covers the tab bar. Top keeps _PHONE_TOP so a
    // strip of the scrimmed app behind stays visible (see SheetReveal) — that
    // sliver is what makes it read as a layer rather than a navigation.
    //
    // Emitted as a compound rule, so it outranks the flat top/left/right/bottom
    // above at ≤768 by insertion order (@symbo.ls/css emits flat first). The
    // nested `&.isSlotFullscreen` re-states it at the conditional class's own
    // specificity so an edge-to-edge toggle carried in from a wider viewport
    // cannot re-flatten the reveal strip: on a phone the sheet is already
    // fullscreen, so the toggle has nothing left to add.
    '@mobileL': {
        top: $ff11614ac4f941af$var$_PHONE_TOP,
        left: '0',
        right: '0',
        bottom: '0',
        '&.isSlotFullscreen': {
            top: $ff11614ac4f941af$var$_PHONE_TOP,
            left: '0',
            right: '0',
            bottom: '0'
        },
        // The expanded (admin) geometry collapses to the same phone sheet — a
        // phone sheet is already maximal, and --slot-top/--slot-bottom belong to
        // the desktop chrome band.
        '&.isSlotExpanded': {
            top: $ff11614ac4f941af$var$_PHONE_TOP,
            left: '0',
            right: '0',
            bottom: '0'
        },
        // The rail-inset class must not survive onto the phone sheet either —
        // full-bleed wins for the same reason as the fullscreen re-statement.
        '&.isSlotRailInset': {
            left: '0'
        }
    },
    // Section-nav-away dismissal for both panes (ticket 6a32d411). `_slotSplitIntent`
    // is here so the container re-renders when a split is armed/cancelled — the
    // placeholder pane appears/collapses on that signal.
    // `_isPhoneViewport`: the four state blocks above stand down on a phone.
    subscribeTo: [
        'currentPath',
        '_canvasSlot',
        '_canvasSlotSecond',
        '_slotSplitIntent',
        '_isPhoneViewport'
    ],
    onCreate: $ff11614ac4f941af$var$_dismissStaleSlot,
    onUpdate: $ff11614ac4f941af$var$_dismissStaleSlot,
    // The reveal strip's scrim — a light veil over the band of app left visible
    // above the phone sheet, so the strip reads as the layer BEHIND rather than a
    // hole punched in the screen. Only the strip is veiled; the page below it is
    // already handled by PageSlotBackdrop.
    //
    // Its own element rather than a `:before` on the frame or a pane, for two
    // reasons: (1) `hide` + `subscribeTo` is the gate proven to re-evaluate at
    // shell-root scope here (a conditional-class effect on a plain div is not —
    // see the SplitBtn note above), and (2) a pane carries a transform while it
    // animates or a finger drags it, which would make it the containing block for
    // a fixed child and drag the veil along (and clip it against the pane's
    // `overflow: hidden`). As a sibling INSIDE the frame's stacking context it
    // still paints above the app chrome, and it stays put while the sheet moves.
    // position:fixed keeps it out of the frame's flex flow.
    SheetReveal: {
        subscribeTo: [
            '_canvasSlot',
            '_canvasSlotSecond'
        ],
        hide: (el, s)=>!(s.root?._canvasSlot || s.root?._canvasSlotSecond),
        display: 'none',
        '@mobileL': {
            display: 'block'
        },
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        height: $ff11614ac4f941af$var$_PHONE_TOP,
        // Fixed-colour sweep: kept — same "veils arbitrary page content behind
        // the slot" contract as PageSlotBackdrop above.
        background: 'black.25',
        pointerEvents: 'none'
    },
    // Parked-apps chips (canvas/components/MinimizedDock.js). Lives INSIDE the
    // frame so it rides the slot layer's stacking context with no extra shell
    // mount; declared BEFORE the panes so the phone full-bleed sheet paints
    // ABOVE the chips by DOM order alone.
    MinimizedDock: {},
    PanePrimary: $ff11614ac4f941af$var$_slotPane('_canvasSlot', {
        primary: true
    }),
    PageSlotSplitHandle: {},
    PaneSecond: $ff11614ac4f941af$var$_slotPane('_canvasSlotSecond', {
        placeholderKey: '_slotSplitIntent'
    })
};
// Split sizing belongs to the frame, never to app state or the route. Updating
// just this number keeps both live hosts, histories, editors and scroll intact.
const $ff11614ac4f941af$var$_splitRatio = (root)=>{
    const value = root?._slotSplitRatio;
    return typeof value === 'number' && Number.isFinite(value) ? Math.max(30, Math.min(70, value)) : 50;
};
const $ff11614ac4f941af$export$5bf65eb33a2d665 = {
    role: 'separator',
    tabindex: '0',
    'aria-orientation': 'vertical',
    'aria-controls': 'page-slot-pane-_canvasSlot page-slot-pane-_canvasSlotSecond',
    'aria-label': (el)=>el.call('polyglot', 'canvas.pageSlot.resizeSplit'),
    'aria-valuemin': '30',
    'aria-valuemax': '70',
    'aria-valuenow': (el, s)=>$ff11614ac4f941af$var$_splitRatio(s.root),
    title: (el)=>el.call('polyglot', 'canvas.pageSlot.resizeSplitHint'),
    subscribeTo: [
        '_canvasSlot',
        '_canvasSlotSecond',
        '_slotSplitIntent',
        '_slotSplitRatio'
    ],
    hide: (el, s)=>!s.root?._canvasSlot || !(s.root?._canvasSlotSecond || s.root?._slotSplitIntent),
    '@splitBelowFloor': {
        display: 'none'
    },
    width: 'Z',
    minWidth: 'Z',
    margin: '0 -Y',
    flex: '0 0 auto',
    pointerEvents: 'auto',
    cursor: 'col-resize',
    touchAction: 'none',
    align: 'center',
    round: 'radiusPill',
    background: 'transparent',
    ':hover': {
        background: 'hover'
    },
    Grip: {
        width: 'W',
        height: 'C',
        round: 'radiusPill',
        background: 'caption'
    },
    onPointerdown: (e, el, s)=>{
        if (e.button !== 0 || !s.root) return;
        const rect = el.parent?.node?.getBoundingClientRect();
        if (!rect?.width) return;
        e.preventDefault();
        e.stopPropagation();
        el._splitDrag = {
            x: e.clientX,
            width: rect.width,
            ratio: $ff11614ac4f941af$var$_splitRatio(s.root),
            id: e.pointerId
        };
        el.node?.setPointerCapture?.(e.pointerId);
    },
    onPointermove: (e, el, s)=>{
        const drag = el._splitDrag;
        if (!drag || !s.root || e.pointerId !== drag.id) return;
        const ratio = Math.max(30, Math.min(70, drag.ratio + (e.clientX - drag.x) / drag.width * 100));
        s.root.update({
            _slotSplitRatio: Math.round(ratio * 10) / 10
        }, {
            preventFetch: true
        });
    },
    onPointerup: (e, el)=>{
        const drag = el._splitDrag;
        el._splitDrag = null;
        if (drag && el.node?.hasPointerCapture?.(drag.id)) el.node.releasePointerCapture(drag.id);
    },
    onPointercancel: (e, el, s)=>{
        const drag = el._splitDrag;
        el._splitDrag = null;
        if (drag) s.root.update({
            _slotSplitRatio: drag.ratio
        }, {
            preventFetch: true
        });
    },
    onDblclick: (e, el, s)=>{
        e.preventDefault();
        s.root.update({
            _slotSplitRatio: 50
        }, {
            preventFetch: true
        });
    },
    onKeydown: (e, el, s)=>{
        let ratio = $ff11614ac4f941af$var$_splitRatio(s.root);
        const step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft') ratio -= step;
        else if (e.key === 'ArrowRight') ratio += step;
        else if (e.key === 'Home') ratio = 30;
        else if (e.key === 'End') ratio = 70;
        else if (e.key === 'Enter') ratio = 50;
        else if (e.key === 'Escape' && el._splitDrag) {
            ratio = el._splitDrag.ratio;
            const id = el._splitDrag.id;
            el._splitDrag = null;
            if (el.node?.hasPointerCapture?.(id)) el.node.releasePointerCapture(id);
        } else return;
        e.preventDefault();
        e.stopPropagation();
        s.root.update({
            _slotSplitRatio: Math.max(30, Math.min(70, ratio))
        }, {
            preventFetch: true
        });
    }
};

});
parcelRegister("11nI2", function(module, exports) {

$parcel$export(module.exports, "applyMetadata", () => $0be846a2e66db698$export$961d8bb4ed050676);
parcelRequire("byww3");
var $eLA0f = parcelRequire("eLA0f");
var $2C0hZ = parcelRequire("2C0hZ");
var $dc7wk = parcelRequire("dc7wk");
var $czfS0 = parcelRequire("czfS0");
var $cdzjF = parcelRequire("cdzjF");
var $7gmTd = parcelRequire("7gmTd");
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

const $0be846a2e66db698$var$y = {
    title: {
        tag: "title"
    },
    description: {
        tag: "meta",
        attr: "name",
        key: "description"
    },
    keywords: {
        tag: "meta",
        attr: "name",
        key: "keywords"
    },
    robots: {
        tag: "meta",
        attr: "name",
        key: "robots"
    },
    author: {
        tag: "meta",
        attr: "name",
        key: "author"
    },
    canonical: {
        tag: "link",
        attr: "rel",
        key: "canonical",
        valueAttr: "href"
    },
    image: {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    url: {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    siteName: {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    type: {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    locale: {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "og:title": {
        tag: "meta",
        attr: "property",
        key: "og:title"
    },
    "og:description": {
        tag: "meta",
        attr: "property",
        key: "og:description"
    },
    "og:image": {
        tag: "meta",
        attr: "property",
        key: "og:image"
    },
    "og:url": {
        tag: "meta",
        attr: "property",
        key: "og:url"
    },
    "og:type": {
        tag: "meta",
        attr: "property",
        key: "og:type"
    },
    "og:site_name": {
        tag: "meta",
        attr: "property",
        key: "og:site_name"
    },
    "og:locale": {
        tag: "meta",
        attr: "property",
        key: "og:locale"
    },
    "twitter:card": {
        tag: "meta",
        attr: "name",
        key: "twitter:card"
    },
    "twitter:title": {
        tag: "meta",
        attr: "name",
        key: "twitter:title"
    },
    "twitter:description": {
        tag: "meta",
        attr: "name",
        key: "twitter:description"
    },
    "twitter:image": {
        tag: "meta",
        attr: "name",
        key: "twitter:image"
    },
    "twitter:site": {
        tag: "meta",
        attr: "name",
        key: "twitter:site"
    },
    "theme-color": {
        tag: "meta",
        attr: "name",
        key: "theme-color"
    }
}, $0be846a2e66db698$var$h = (t)=>{
    if (t.tag === "link") return `link[${t.attr}="${t.key}"]`;
    if (t.tag && !t.attr && !t.key) return t.tag;
    if (t.tag && t.attr && t.key) {
        const e = `${t.tag}[${t.attr}="${t.key}"]`;
        return t.key === "theme-color" ? `${e}:not([data-smbls-theme-color])` : e;
    }
}, $0be846a2e66db698$var$J = (t)=>(0, $2C0hZ.deepDestringifyFunctions)({
        v: t
    }).v, $0be846a2e66db698$var$z = (t, e, r, i)=>{
    try {
        return (0, $2C0hZ.exec)(t, e, r);
    } catch (s) {
        console.warn(`[helmet] metadata factory for "${i}" threw; treating as unset:`, s && s.message || s);
        return;
    }
}, $0be846a2e66db698$var$S = Object.freeze({
    authored: !0
}), $0be846a2e66db698$var$$ = (t, e)=>!t || typeof $dc7wk.evaluateText != "function" ? {
        value: e(),
        ready: !0
    } : $dc7wk.evaluateText(e), $0be846a2e66db698$export$d2032d3864484f3 = (t, e, r, i)=>{
    if (!t) return {};
    const s = i?.pending instanceof Set ? i.pending : null;
    let n = t;
    (0, $czfS0.isString)(n) && (0, $2C0hZ.hasFunction)(n) && (n = $0be846a2e66db698$var$J(n));
    const a = (0, $czfS0.isFunction)(n), o = !a && i?.authored === !0;
    let l = !0, u;
    if (a) {
        const c = $0be846a2e66db698$var$$(s, ()=>$0be846a2e66db698$var$z(n, e, r, "metadata"));
        u = c.value, l = c.ready;
    } else u = (0, $czfS0.isObject)(n) ? {
        ...n
    } : {};
    if (!(0, $czfS0.isObject)(u)) return {};
    if (!l) for(const c in u)s.add(c);
    for(const c in u){
        let f = u[c];
        const _ = o && (0, $czfS0.isString)(f) && !(0, $2C0hZ.hasFunction)(f);
        if ((0, $czfS0.isString)(f) && (0, $2C0hZ.hasFunction)(f) && (f = $0be846a2e66db698$var$J(f)), (0, $czfS0.isFunction)(f)) {
            const m = f, b = $0be846a2e66db698$var$$(s, ()=>$0be846a2e66db698$var$z(m, e, r, c));
            f = b.value, b.ready || s.add(c);
        } else (0, $czfS0.isString)(f) && (0, $2C0hZ.hasFunction)(f) && (f = void 0);
        if ((0, $czfS0.isString)(f) && f.includes("{{") && e?.call) {
            const m = f, b = $0be846a2e66db698$var$$(s, ()=>_ ? e.call("replaceLiteralsWithObjectFields", m, r, $0be846a2e66db698$var$S) : e.call("replaceLiteralsWithObjectFields", m, r));
            f = b.value, b.ready || s.add(c);
        }
        u[c] = f;
    }
    return u;
}, $0be846a2e66db698$var$bt = (t)=>!!t && typeof t == "object" && (t.notFound === !0 || t.metadata?.notFound === !0), $0be846a2e66db698$var$St = (t, e, r)=>{
    if (Object.prototype.hasOwnProperty.call(t, e)) return t[e];
    if ((0, $czfS0.isString)(r) && Object.prototype.hasOwnProperty.call(t, r)) return t[r];
    if (t["/*"]) return t["/*"];
    if (t["*"]) return t["*"];
    for(const i in t)if ($0be846a2e66db698$var$bt(t[i])) return t[i];
}, $0be846a2e66db698$var$vt = (t, e)=>{
    const r = $cdzjF.routeEntryMetadata;
    if (typeof r != "function") return e.metadata || e.helmet;
    const i = $7gmTd.sharedLibraryBagEntry, s = typeof i == "function" ? (n)=>i("components", n, t.components, t.sharedLibraries) : t.components;
    return r(e, s);
}, $0be846a2e66db698$export$ff8c3ec904fd95bb = (t, e = "/", r, i, s)=>{
    const n = t.pages || {}, a = $0be846a2e66db698$var$St(n, e, i?.route);
    let o = {};
    if (t.integrations?.seo && (o = {
        ...t.integrations.seo
    }), t.app?.metadata) {
        const c = $0be846a2e66db698$export$d2032d3864484f3(t.app.metadata, r, i, $0be846a2e66db698$var$S);
        o = {
            ...o,
            ...c
        };
    }
    const l = new Set;
    if (a) {
        const c = $0be846a2e66db698$var$vt(t, a) || {}, f = s ? $0be846a2e66db698$export$d2032d3864484f3(c, s, s.state, $0be846a2e66db698$var$S) : $0be846a2e66db698$export$d2032d3864484f3(c, r, i, $0be846a2e66db698$var$S);
        for(const _ in f)l.add(_);
        o = {
            ...o,
            ...f
        }, !o.title && a.state?.title && (o.title = a.state.title, l.add("title")), !o.description && a.state?.description && (o.description = a.state.description, l.add("description"));
    }
    o.title || (o.title = t.name || "Symbols"), o.title && (l.has("title") || !o["og:title"]) && (l.has("og:title") || (o["og:title"] = o.title)), o.description && (l.has("description") || !o["og:description"]) && (l.has("og:description") || (o["og:description"] = o.description)), o.title && !o["twitter:title"] && (o["twitter:title"] = o.title), o.description && !o["twitter:description"] && (o["twitter:description"] = o.description);
    const u = l.has("og:url") ? o["og:url"] : l.has("url") ? o.url : void 0;
    if (u) o["og:url"] = u;
    else if (o["og:url"] || o.url) {
        const c = (o["og:url"] || o.url || "").replace(/\/$/, "");
        if (c && e && e !== "/") {
            const f = e.startsWith("/") ? e : "/" + e;
            o["og:url"] = c + f;
        }
    }
    return (0, $eLA0f.resolveFileReferences)(o, (0, $7gmTd.sharedLibraryFiles)(t.files, t.sharedLibraries));
}, $0be846a2e66db698$var$Q = (t, e, r)=>(0, $eLA0f.resolveFileReferences)($0be846a2e66db698$export$d2032d3864484f3(t, e, e.state, r ? {
        pending: r
    } : void 0), e.context?.files), $0be846a2e66db698$var$O = (t)=>t.context?.document || typeof document < "u" && document, $0be846a2e66db698$var$X = (t)=>Object.prototype.hasOwnProperty.call($0be846a2e66db698$var$y, t), $0be846a2e66db698$var$R = new Map;
for(const t in $0be846a2e66db698$var$y){
    const e = $0be846a2e66db698$var$h($0be846a2e66db698$var$y[t]);
    $0be846a2e66db698$var$R.has(e) || $0be846a2e66db698$var$R.set(e, $0be846a2e66db698$var$y[t]);
}
const $0be846a2e66db698$var$P = (t)=>t.head || t.querySelector("head"), $0be846a2e66db698$var$k = (t, e)=>{
    const r = $0be846a2e66db698$var$P(t);
    return r ? r.querySelector(e) : null;
}, $0be846a2e66db698$var$w = (t, e)=>e.tag === "title" ? t.textContent : t.getAttribute(e.valueAttr || "content"), $0be846a2e66db698$var$E = (t, e, r)=>{
    e.tag === "title" ? t.textContent = r : t.setAttribute(e.valueAttr || "content", r);
}, $0be846a2e66db698$var$C = (t, e)=>{
    const r = $0be846a2e66db698$var$P(e);
    if (!r) return null;
    const i = e.createElement(t.tag);
    return t.attr && i.setAttribute(t.attr, t.key), r.appendChild(i), i;
}, $0be846a2e66db698$var$A = (t, e, r, i)=>{
    const s = t.head || t.querySelector("head");
    if (!s) return;
    const n = new Map;
    for (const o of s.querySelectorAll(`[${e}]`))n.set(o.getAttribute(e), o);
    const a = new Map;
    r.forEach((o, l)=>{
        a.has(o) || a.set(o, l);
    });
    for (const [o, l] of n)a.has(o) || l.remove();
    for (const o of r){
        if (n.has(o)) continue;
        const l = i(o, a.get(o));
        l && (l.setAttribute(e, o), s.appendChild(l));
    }
}, $0be846a2e66db698$var$Z = (t, e)=>{
    const i = (e || []).filter((n)=>n != null).map((n)=>(0, $czfS0.isString)(n) ? n : JSON.stringify(n)), s = i.map((0, $eLA0f.hashContent));
    $0be846a2e66db698$var$A(t, "data-smbls-jsonld", s, (n, a)=>{
        const o = t.createElement("script");
        return o.setAttribute("type", "application/ld+json"), o.textContent = i[a], o;
    });
}, $0be846a2e66db698$var$tt = (t, e)=>{
    const r = (e || []).filter((s)=>s != null && String(s).trim()), i = r.map((0, $eLA0f.hashContent));
    $0be846a2e66db698$var$A(t, "data-smbls-style", i, (s, n)=>{
        const a = t.createElement("style");
        return a.textContent = String(r[n]), a;
    });
}, $0be846a2e66db698$var$et = (t)=>(t || []).filter((e)=>e && ((0, $czfS0.isString)(e) ? e.trim() : e.src)), $0be846a2e66db698$var$rt = (t)=>(0, $czfS0.isString)(t) ? t : String(t.src), $0be846a2e66db698$var$nt = (t, e)=>{
    const r = t.createElement("script");
    return (0, $czfS0.isString)(e) ? r.setAttribute("src", e) : (e.src && r.setAttribute("src", e.src), e.type && r.setAttribute("type", e.type), e.async && (r.async = !0), e.defer && (r.defer = !0), e.integrity && r.setAttribute("integrity", e.integrity), e.crossorigin && r.setAttribute("crossorigin", e.crossorigin), e.referrerpolicy && r.setAttribute("referrerpolicy", e.referrerpolicy), e.nomodule && (r.noModule = !0), e.body && (r.textContent = String(e.body))), r;
}, $0be846a2e66db698$var$kt = (t, e)=>{
    const r = $0be846a2e66db698$var$et(e), i = r.map($0be846a2e66db698$var$rt);
    $0be846a2e66db698$var$A(t, "data-smbls-script", i, (s, n)=>$0be846a2e66db698$var$nt(t, r[n]));
}, $0be846a2e66db698$var$st = (t, e)=>{
    const r = (e || []).filter((s)=>(0, $czfS0.isObject)(s)), i = r.map((0, $eLA0f.alternateLinkKey));
    $0be846a2e66db698$var$A(t, "data-smbls-alternate", i, (s, n)=>{
        const a = t.createElement("link");
        a.setAttribute("rel", "alternate");
        for (const [o, l] of Object.entries(r[n]))a.setAttribute(o, l);
        return a;
    });
}, $0be846a2e66db698$var$it = (t, e)=>{
    const r = (e || []).filter((s)=>s != null), i = r.map((0, $eLA0f.faviconLinkKey));
    $0be846a2e66db698$var$A(t, "data-smbls-favicon", i, (s, n)=>{
        const a = r[n], o = t.createElement("link");
        if (o.setAttribute("rel", "icon"), (0, $czfS0.isObject)(a)) for (const [l, u] of Object.entries(a))o.setAttribute(l, u);
        else o.setAttribute("href", String(a));
        return o;
    });
}, $0be846a2e66db698$var$ot = (t, e)=>{
    const r = e ? String(e) : "", i = r.endsWith(".svg") ? "image/svg+xml" : r.endsWith(".png") ? "image/png" : "";
    $0be846a2e66db698$var$A(t, "data-smbls-single-icon", r ? [
        r
    ] : [], (s)=>{
        const n = t.createElement("link");
        return n.setAttribute("rel", "icon"), n.setAttribute("href", s), i && n.setAttribute("type", i), n;
    });
}, $0be846a2e66db698$var$at = (t, e)=>{
    const r = (e || []).filter((s)=>(0, $czfS0.isObject)(s)), i = r.map((0, $eLA0f.themeColorKey));
    $0be846a2e66db698$var$A(t, "data-smbls-theme-color", i, (s, n)=>{
        const a = r[n], o = t.createElement("meta");
        return o.setAttribute("name", "theme-color"), a.content !== void 0 && o.setAttribute("content", a.content), a.media !== void 0 && o.setAttribute("media", a.media), o;
    });
}, $0be846a2e66db698$export$961d8bb4ed050676 = (t, e)=>{
    if (!(!(0, $czfS0.isObject)(t) || !e)) {
        for(const r in t){
            const i = t[r];
            if (i == null || !$0be846a2e66db698$var$X(r) || r === "theme-color" && Array.isArray(i)) continue;
            const s = $0be846a2e66db698$var$y[r], n = $0be846a2e66db698$var$k(e, $0be846a2e66db698$var$h(s)) || $0be846a2e66db698$var$C(s, e);
            n && $0be846a2e66db698$var$gt(n, s, i) && $0be846a2e66db698$var$E(n, s, i);
        }
        Array.isArray(t.jsonLd) && $0be846a2e66db698$var$Z(e, t.jsonLd), Array.isArray(t.styles) && $0be846a2e66db698$var$tt(e, t.styles), Array.isArray(t.scripts) && $0be846a2e66db698$var$kt(e, t.scripts), Array.isArray(t.alternate) && $0be846a2e66db698$var$st(e, t.alternate), Array.isArray(t.favicons) && $0be846a2e66db698$var$it(e, t.favicons), (t.icon || t.favicon) && $0be846a2e66db698$var$ot(e, t.icon || t.favicon), Array.isArray(t["theme-color"]) && $0be846a2e66db698$var$at(e, t["theme-color"]);
    }
}, $0be846a2e66db698$var$W = new WeakMap, $0be846a2e66db698$var$x = new WeakMap, $0be846a2e66db698$var$M = (t)=>{
    const e = t.location;
    return e && (0, $czfS0.isString)(e.pathname) ? e.pathname : null;
}, $0be846a2e66db698$var$wt = 'meta[name="smbls-head"][content="served"]', $0be846a2e66db698$var$Et = 'meta[name="brender"], meta[name="brender-stamp"], ' + $0be846a2e66db698$var$wt, $0be846a2e66db698$var$Tt = (t)=>{
    try {
        return !!$0be846a2e66db698$var$k(t, $0be846a2e66db698$var$Et);
    } catch  {
        return !1;
    }
}, $0be846a2e66db698$var$ct = (t)=>!!t && t.__ref?.root === t, $0be846a2e66db698$var$lt = (t)=>{
    let e = $0be846a2e66db698$var$W.get(t);
    return e || (e = {
        doc: t,
        built: $0be846a2e66db698$var$Tt(t),
        layers: [],
        servedPath: $0be846a2e66db698$var$M(t),
        originals: new Map,
        owned: new Set,
        lists: new Set,
        firstPage: void 0,
        firstPageWatched: !1
    }, $0be846a2e66db698$var$W.set(t, e)), e;
}, $0be846a2e66db698$var$Lt = (t, e)=>{
    if (!t || $0be846a2e66db698$var$M(e) === null || t.context && t.context.router === !1 || typeof t.onRenderRouter != "function") return !1;
    const r = t.routes;
    if (!r || typeof r != "object") return !1;
    for(const i in r)return !0;
    return !1;
}, $0be846a2e66db698$var$ft = (t, e)=>{
    t.firstPage === void 0 && (t.firstPage = $0be846a2e66db698$var$Lt(e && e.__ref && e.__ref.root, t.doc) ? "held" : "open");
}, $0be846a2e66db698$var$ut = (t)=>{
    if (t.firstPage === "held") {
        t.firstPage = "shown";
        try {
            $0be846a2e66db698$var$N(t);
        } catch (e) {
            console.warn("[helmet] could not render the head after the first page:", e && e.message || e);
        }
    }
}, $0be846a2e66db698$var$$t = (t, e)=>{
    const r = $0be846a2e66db698$var$lt(e);
    $0be846a2e66db698$var$ft(r, t), !(r.firstPage !== "held" || r.firstPageWatched) && (r.firstPageWatched = !0, queueMicrotask(()=>{
        const i = t.context && t.context.__firstNavigation, s = ()=>$0be846a2e66db698$var$ut(r);
        i && typeof i.then == "function" ? i.then(s, s) : s();
    }));
}, $0be846a2e66db698$var$Ot = (t, e)=>{
    for(let r = e.parent; r && r !== r.parent; r = r.parent)if (r === t) return !0;
    return !1;
}, $0be846a2e66db698$var$dt = (t)=>{
    try {
        return JSON.stringify(t === void 0 ? null : t) ?? null;
    } catch  {
        return null;
    }
}, $0be846a2e66db698$var$Rt = (t)=>{
    if (!(0, $czfS0.isObject)(t)) return !0;
    for(const e in t)if (t[e] !== void 0 && t[e] !== null) return !1;
    return !0;
}, $0be846a2e66db698$var$Pt = (t, e)=>{
    const r = $0be846a2e66db698$var$x.get(t);
    if (r) return r;
    const i = $0be846a2e66db698$var$lt(e);
    $0be846a2e66db698$var$ft(i, t);
    const s = {
        element: t,
        values: null,
        pending: null,
        signature: $0be846a2e66db698$var$dt(null),
        disposed: !1,
        root: $0be846a2e66db698$var$ct(t),
        firstReady: null,
        defaultsHeld: !0,
        effects: [],
        set (a, o) {
            if (s.disposed) return;
            const l = o && o.size ? o : null, u = $0be846a2e66db698$var$dt(a), c = u === null ? null : l ? u + "\0" + [
                ...l
            ].sort().join("\0") : u;
            s.values = a, s.pending = l, s.root && !l && u !== null && (s.firstReady === null ? s.firstReady = u : u !== s.firstReady && (s.defaultsHeld = !1)), !(c !== null && c === s.signature) && (s.signature = c, $0be846a2e66db698$var$N(i));
        },
        dispose () {
            if (s.disposed) return;
            s.disposed = !0;
            const a = i.layers.indexOf(s);
            if (a !== -1 && i.layers.splice(a, 1), !$0be846a2e66db698$var$Rt(s.values)) try {
                $0be846a2e66db698$var$N(i);
            } catch (o) {
                console.warn("[helmet] could not re-render the head after an element left:", o && o.message || o);
            }
        }
    };
    let n = i.layers.length;
    for(let a = 0; a < i.layers.length; a++)if ($0be846a2e66db698$var$Ot(t, i.layers[a].element)) {
        n = a;
        break;
    }
    return i.layers.splice(n, 0, s), $0be846a2e66db698$var$x.set(t, s), s;
}, $0be846a2e66db698$var$B = (t, e, r, i)=>{
    const s = $0be846a2e66db698$var$Pt(t, e), n = (0, $4VQqJ.createEffect)(()=>{
        const o = new Set, l = r(o);
        s.set(l, o), i && i(l);
    });
    s.effects.push({
        effect: n,
        onResolved: i
    });
    const a = t.__ref?.__effects;
    a && a.push(n, s);
}, $0be846a2e66db698$var$K = new WeakMap, $0be846a2e66db698$var$xt = (t, e, r)=>(0, $eLA0f.resolveFileReferences)($0be846a2e66db698$export$d2032d3864484f3(t, e, e.state, r ? {
        pending: r,
        authored: !0
    } : $0be846a2e66db698$var$S), e.context?.files), $0be846a2e66db698$var$Mt = (t, e)=>{
    const r = t.__ref?.__effects, i = [];
    for (const { effect: n, onResolved: a } of e.effects){
        n.dispose(), a && i.push(a);
        const o = r ? r.indexOf(n) : -1;
        o !== -1 && r.splice(o, 1);
    }
    e.effects.length = 0;
    const s = (0, $4VQqJ.createEffect)(()=>{
        const n = new Set, a = $0be846a2e66db698$var$H(t, n);
        e.set(a, n);
        for (const o of i)o(a);
    });
    e.effects.push({
        effect: s,
        onResolved: null
    }), r && r.push(s);
}, $0be846a2e66db698$var$Dt = $0be846a2e66db698$var$h($0be846a2e66db698$var$y.title), $0be846a2e66db698$var$Ht = $0be846a2e66db698$var$h($0be846a2e66db698$var$y.description), $0be846a2e66db698$var$Ft = $0be846a2e66db698$var$h($0be846a2e66db698$var$y["og:title"]), $0be846a2e66db698$var$It = $0be846a2e66db698$var$h($0be846a2e66db698$var$y["og:description"]), $0be846a2e66db698$var$Ct = $0be846a2e66db698$var$h($0be846a2e66db698$var$y["twitter:title"]), $0be846a2e66db698$var$Wt = $0be846a2e66db698$var$h($0be846a2e66db698$var$y["twitter:description"]), $0be846a2e66db698$var$pt = (t, e, r, i)=>{
    const s = t.get(e);
    if (!s || !s.value) return;
    const n = t.get(r);
    (!n || !n.value || n.rank < s.rank) && t.set(r, s);
    const a = t.get(i);
    (!a || !a.value) && t.set(i, s);
}, $0be846a2e66db698$var$D = {
    jsonLd: $0be846a2e66db698$var$Z,
    styles: $0be846a2e66db698$var$tt,
    alternate: $0be846a2e66db698$var$st,
    favicons: $0be846a2e66db698$var$it,
    icon: $0be846a2e66db698$var$ot,
    "theme-color": $0be846a2e66db698$var$at
}, $0be846a2e66db698$var$Bt = Object.keys($0be846a2e66db698$var$D).filter((t)=>t !== "icon"), $0be846a2e66db698$var$Kt = (t)=>{
    const e = new Map, r = {}, i = [];
    for(let s = 0; s < t.length; s++){
        const n = t[s].values;
        if (!(0, $czfS0.isObject)(n)) continue;
        const a = t[s].pending;
        for(const l in n){
            const u = n[l];
            u == null || !$0be846a2e66db698$var$X(l) || l === "theme-color" && Array.isArray(u) || e.set($0be846a2e66db698$var$h($0be846a2e66db698$var$y[l]), {
                value: String(u),
                rank: s,
                waiting: !!(a && a.has(l))
            });
        }
        for (const l of $0be846a2e66db698$var$Bt)Array.isArray(n[l]) && (r[l] = n[l]);
        const o = n.icon || n.favicon;
        o && (r.icon = o), Array.isArray(n.scripts) && i.push(...n.scripts);
    }
    return $0be846a2e66db698$var$pt(e, $0be846a2e66db698$var$Dt, $0be846a2e66db698$var$Ft, $0be846a2e66db698$var$Ct), $0be846a2e66db698$var$pt(e, $0be846a2e66db698$var$Ht, $0be846a2e66db698$var$It, $0be846a2e66db698$var$Wt), {
        tags: e,
        lists: r,
        scripts: i
    };
}, $0be846a2e66db698$var$Nt = "data-smbls-host", $0be846a2e66db698$var$yt = (t)=>!!t && typeof t.getAttribute == "function" && t.getAttribute($0be846a2e66db698$var$Nt) === "forced", $0be846a2e66db698$var$Ut = /(^|[\s,])(noindex|none)($|[\s,])/i, $0be846a2e66db698$var$gt = (t, e, r)=>!$0be846a2e66db698$var$yt(t) || e.key === "robots" && $0be846a2e66db698$var$Ut.test(String(r)), $0be846a2e66db698$var$jt = (t, e, r)=>{
    const { doc: i, originals: s } = t, n = $0be846a2e66db698$var$R.get(e);
    let a = $0be846a2e66db698$var$k(i, e), o = s.get(e);
    if (o || (o = {
        value: a ? $0be846a2e66db698$var$w(a, n) : null,
        rendered: !1
    }, s.set(e, o)), o.value === r && (o.rendered = !0), a || (a = $0be846a2e66db698$var$C(n, i)), !!a) {
        if (!$0be846a2e66db698$var$gt(a, n, r)) {
            o.value !== null && $0be846a2e66db698$var$w(a, n) !== o.value && $0be846a2e66db698$var$E(a, n, o.value), t.owned.add(e);
            return;
        }
        $0be846a2e66db698$var$w(a, n) !== r && $0be846a2e66db698$var$E(a, n, r), t.owned.add(e);
    }
}, $0be846a2e66db698$var$Gt = (t, e)=>{
    const { doc: r } = t;
    t.owned.delete(e);
    const i = $0be846a2e66db698$var$R.get(e), s = $0be846a2e66db698$var$k(r, e), n = t.originals.get(e);
    if ($0be846a2e66db698$var$yt(s)) {
        n && n.value !== null && $0be846a2e66db698$var$w(s, i) !== n.value && $0be846a2e66db698$var$E(s, i, n.value);
        return;
    }
    if (n && n.value !== null && !n.rendered && $0be846a2e66db698$var$M(r) === t.servedPath) {
        const o = s || $0be846a2e66db698$var$C(i, r);
        o && $0be846a2e66db698$var$w(o, i) !== n.value && $0be846a2e66db698$var$E(o, i, n.value);
    } else s && s.remove();
}, $0be846a2e66db698$var$Vt = (t, e)=>{
    const r = $0be846a2e66db698$var$et(e);
    if (!r.length) return;
    const i = $0be846a2e66db698$var$P(t), s = new Set;
    for (const n of i.querySelectorAll("[data-smbls-script]"))s.add(n.getAttribute("data-smbls-script"));
    for (const n of r){
        const a = $0be846a2e66db698$var$rt(n);
        if (s.has(a)) continue;
        const o = $0be846a2e66db698$var$nt(t, n);
        o.setAttribute("data-smbls-script", a), i.appendChild(o), s.add(a);
    }
}, $0be846a2e66db698$var$Yt = (t, e, r)=>{
    const i = t.layers[r];
    return !t.built || !i || !i.root || !i.defaultsHeld || t.owned.has(e) || $0be846a2e66db698$var$M(t.doc) !== t.servedPath ? !1 : !!$0be846a2e66db698$var$k(t.doc, e);
}, $0be846a2e66db698$var$N = (t)=>{
    const { doc: e } = t;
    if (t.firstPage === "held" || !$0be846a2e66db698$var$P(e)) return;
    const { tags: r, lists: i, scripts: s } = $0be846a2e66db698$var$Kt(t.layers);
    for (const n of [
        ...t.owned
    ])r.has(n) || $0be846a2e66db698$var$Gt(t, n);
    for (const [n, { value: a, rank: o, waiting: l }] of r)l || $0be846a2e66db698$var$Yt(t, n, o) || $0be846a2e66db698$var$jt(t, n, a);
    for(const n in $0be846a2e66db698$var$D)i[n] !== void 0 ? ($0be846a2e66db698$var$D[n](e, i[n]), t.lists.add(n)) : t.lists.delete(n) && $0be846a2e66db698$var$D[n](e, null);
    $0be846a2e66db698$var$Vt(e, s);
}, $0be846a2e66db698$export$ebea745cf9b6b083 = (t)=>{
    const e = [
        '<meta charset="UTF-8">'
    ], r = new Set([
        "charset",
        "jsonLd",
        "styles",
        "scripts"
    ]);
    let i = !1;
    for (const [s, n] of Object.entries(t)){
        if (!n && n !== 0 && n !== !1 || r.has(s) || typeof n == "function") continue;
        if (s === "title") {
            e.push(`<title>${(0, $eLA0f.escapeHtml)(n)}</title>`);
            continue;
        }
        if (s === "viewport") {
            i || (e.push(`<meta name="viewport" content="${(0, $eLA0f.escapeHtml)(n)}">`), i = !0);
            continue;
        }
        if (s === "canonical") {
            e.push(`<link rel="canonical" href="${(0, $eLA0f.escapeHtml)(n)}">`);
            continue;
        }
        if (s === "icon" || s === "favicon") {
            const c = (0, $eLA0f.escapeHtml)(n), f = c.endsWith(".svg") ? ' type="image/svg+xml"' : c.endsWith(".png") ? ' type="image/png"' : "";
            e.push(`<link rel="icon" href="${c}"${f} data-smbls-single-icon="${c}">`);
            continue;
        }
        if (s === "favicons" && Array.isArray(n)) {
            n.forEach((c)=>{
                if ((0, $czfS0.isObject)(c)) {
                    const f = Object.entries(c).map(([_, m])=>`${_}="${(0, $eLA0f.escapeHtml)(m)}"`).join(" ");
                    e.push(`<link rel="icon" ${f} data-smbls-favicon="${(0, $eLA0f.escapeHtml)((0, $eLA0f.faviconLinkKey)(c))}">`);
                } else typeof c == "string" && e.push(`<link rel="icon" href="${(0, $eLA0f.escapeHtml)(c)}" data-smbls-favicon="${(0, $eLA0f.escapeHtml)((0, $eLA0f.faviconLinkKey)(c))}">`);
            });
            continue;
        }
        if (s === "alternate" && Array.isArray(n)) {
            n.forEach((c)=>{
                if ((0, $czfS0.isObject)(c)) {
                    const f = Object.entries(c).map(([_, m])=>`${_}="${(0, $eLA0f.escapeHtml)(m)}"`).join(" ");
                    e.push(`<link rel="alternate" ${f} data-smbls-alternate="${(0, $eLA0f.escapeHtml)((0, $eLA0f.alternateLinkKey)(c))}">`);
                }
            });
            continue;
        }
        if (s === "theme-color" && Array.isArray(n)) {
            n.forEach((c)=>{
                if (!(0, $czfS0.isObject)(c)) return;
                const f = [
                    'name="theme-color"'
                ];
                c.content !== void 0 && f.push(`content="${(0, $eLA0f.escapeHtml)(c.content)}"`), c.media !== void 0 && f.push(`media="${(0, $eLA0f.escapeHtml)(c.media)}"`), f.push(`data-smbls-theme-color="${(0, $eLA0f.escapeHtml)((0, $eLA0f.themeColorKey)(c))}"`), e.push(`<meta ${f.join(" ")}>`);
            });
            continue;
        }
        const a = [
            "og:",
            "article:",
            "product:",
            "fb:",
            "profile:",
            "book:",
            "business:",
            "music:",
            "video:"
        ], o = [
            "twitter:",
            "DC:",
            "DCTERMS:"
        ], l = a.some((c)=>s.startsWith(c)), u = o.some((c)=>s.startsWith(c));
        if (s.startsWith("http-equiv:")) {
            const c = s.replace("http-equiv:", "");
            e.push(`<meta http-equiv="${(0, $eLA0f.escapeHtml)(c)}" content="${(0, $eLA0f.escapeHtml)(n)}">`);
        } else if (s.startsWith("itemprop:")) {
            const c = s.replace("itemprop:", "");
            e.push(`<meta itemprop="${(0, $eLA0f.escapeHtml)(c)}" content="${(0, $eLA0f.escapeHtml)(n)}">`);
        } else l ? Array.isArray(n) ? n.forEach((c)=>e.push(`<meta property="${(0, $eLA0f.escapeHtml)(s)}" content="${(0, $eLA0f.escapeHtml)(c)}">`)) : e.push(`<meta property="${(0, $eLA0f.escapeHtml)(s)}" content="${(0, $eLA0f.escapeHtml)(n)}">`) : u ? e.push(`<meta name="${(0, $eLA0f.escapeHtml)(s)}" content="${(0, $eLA0f.escapeHtml)(n)}">`) : Array.isArray(n) ? n.forEach((c)=>e.push(`<meta name="${(0, $eLA0f.escapeHtml)(s)}" content="${(0, $eLA0f.escapeHtml)(c)}">`)) : (typeof n == "string" || typeof n == "number" || typeof n == "boolean") && e.push(`<meta name="${(0, $eLA0f.escapeHtml)(s)}" content="${(0, $eLA0f.escapeHtml)(n)}">`);
    }
    return i || e.splice(1, 0, '<meta name="viewport" content="width=device-width, initial-scale=1">'), e.push(...(0, $eLA0f.generateHeadArrayTags)(t)), e.join(`
`);
}, $0be846a2e66db698$export$dcef8f9bb9a41431 = {
    define: {
        metadata: (t, e)=>{
            $0be846a2e66db698$export$8fd6ae4ffd34091a(t, e, (r)=>{
                const i = e.state?.root;
                (0, $czfS0.isObject)(i) && (i.$helmet = r);
            });
        }
    }
}, $0be846a2e66db698$export$8fd6ae4ffd34091a = (t, e, r)=>{
    const i = $0be846a2e66db698$var$O(e);
    i && $0be846a2e66db698$var$B(e, i, (s)=>$0be846a2e66db698$var$Q(t, e, s), r);
}, $0be846a2e66db698$var$H = (t, e)=>{
    if ($0be846a2e66db698$var$K.has(t)) {
        const n = $0be846a2e66db698$var$K.get(t);
        return n ? $0be846a2e66db698$var$xt(n, t, e) : null;
    }
    const { value: r, ready: i } = $0be846a2e66db698$var$$(e, ()=>t.metadata);
    if (!r) return null;
    const s = $0be846a2e66db698$var$Q(r, t, e);
    if (!i && e && (0, $czfS0.isObject)(s)) for(const n in s)e.add(n);
    return s;
}, $0be846a2e66db698$export$4f83b73c16715677 = {
    name: "helmet",
    create (t) {
        const e = $0be846a2e66db698$var$ct(t);
        if (!t.metadata && !e) return;
        const r = $0be846a2e66db698$var$O(t);
        r && (e && $0be846a2e66db698$var$$t(t, r), t.metadata && $0be846a2e66db698$var$B(t, r, (i)=>$0be846a2e66db698$var$H(t, i)));
    },
    routeChanged (t) {
        const e = $0be846a2e66db698$var$O(t), r = e && $0be846a2e66db698$var$W.get(e);
        r && $0be846a2e66db698$var$ut(r);
    },
    update (t) {
        const e = $0be846a2e66db698$var$x.get(t);
        if (!e) return $0be846a2e66db698$export$4f83b73c16715677.create(t);
        if (!e.disposed) {
            const r = new Set;
            e.set($0be846a2e66db698$var$H(t, r), r);
        }
    },
    routeHead (t, e) {
        if (!t || !t.__ref) return;
        const r = $0be846a2e66db698$var$O(t);
        if (!r) return;
        $0be846a2e66db698$var$K.set(t, e === void 0 ? null : e);
        const i = $0be846a2e66db698$var$x.get(t);
        if (!i) {
            e && $0be846a2e66db698$var$B(t, r, (s)=>$0be846a2e66db698$var$H(t, s));
            return;
        }
        i.disposed || $0be846a2e66db698$var$Mt(t, i);
    }
};
var $0be846a2e66db698$export$2e2bcd8739ae039 = $0be846a2e66db698$export$dcef8f9bb9a41431;

});

parcelRegister("5ApZL", function(module, exports) {

$parcel$export(module.exports, "SLOT_HISTORY_CAP", () => $41147aa7dc9a37cc$export$2c716f1c60d68514);
$parcel$export(module.exports, "histInit", () => $41147aa7dc9a37cc$export$c57cd3121ea404b4);
$parcel$export(module.exports, "histCurrent", () => $41147aa7dc9a37cc$export$657986aebdfe7b4f);
$parcel$export(module.exports, "histRecord", () => $41147aa7dc9a37cc$export$c3eef008a3dd6140);
$parcel$export(module.exports, "histReplace", () => $41147aa7dc9a37cc$export$55ccaf2c962c14cc);
$parcel$export(module.exports, "histCanBack", () => $41147aa7dc9a37cc$export$ea5376ba467e9179);
$parcel$export(module.exports, "histCanForward", () => $41147aa7dc9a37cc$export$82e79c81e71a101d);
$parcel$export(module.exports, "histBack", () => $41147aa7dc9a37cc$export$1c2a7f5d00352cf8);
$parcel$export(module.exports, "histForward", () => $41147aa7dc9a37cc$export$3a375b8750627467);
// slotHistory — pure per-pane back/forward history for the shell PageSlot
// (2026-08-06 per Nika "when we navigate accross pageslots - we shuld also
// support back and forward navigations in pageslots").
//
// One history per PANE: the primary (`root._canvasSlot` ↔ `root._slotHistPrimary`)
// and the split second (`root._canvasSlotSecond` ↔ `root._slotHistSecond`) each
// own an independent { stack, index }, so back/forward in one pane can never
// move the other — the same pane-scoping contract the split-view targeting fix
// enforces on every opener.
//
// Pure data → data, zero DOM — the same testability rule
// shared/functions/minimizedSlots.js follows. The REACTIVE side lives in
// canvas/components/PageSlot.js: the pane Slot's lifecycle records every slot
// path change through `histRecord` (a back/forward landing is recognised by
// CURSOR EQUALITY — the arrows write the path the cursor already points at —
// so no "navigating" guard flag exists to drift or desync), an in-place query
// patch through `histReplace` (the page stays, only its route changes), and
// the header arrows drive `histBack`/`histForward`.
//
// Shape: { stack: [href, …], index } — FULL hrefs, query included, matching
// the slot state values verbatim (PageSlot re-mounts on a query change, so a
// deep link is a distinct entry). `index` points at the CURRENT entry.
const $41147aa7dc9a37cc$export$2c716f1c60d68514 = 50;
const $41147aa7dc9a37cc$export$c57cd3121ea404b4 = ()=>({
        stack: [],
        index: -1
    });
const $41147aa7dc9a37cc$var$_valid = (h)=>!!(h && typeof h === 'object' && Array.isArray(h.stack) && Number.isInteger(h.index) && h.index >= -1 && h.index < h.stack.length);
const $41147aa7dc9a37cc$export$657986aebdfe7b4f = (h)=>$41147aa7dc9a37cc$var$_valid(h) && h.index >= 0 ? h.stack[h.index] : null;
const $41147aa7dc9a37cc$export$c3eef008a3dd6140 = (h, path, cap = $41147aa7dc9a37cc$export$2c716f1c60d68514)=>{
    if (!path || typeof path !== 'string') return h;
    const base = $41147aa7dc9a37cc$var$_valid(h) ? h : $41147aa7dc9a37cc$export$c57cd3121ea404b4();
    if ($41147aa7dc9a37cc$export$657986aebdfe7b4f(base) === path) return h === base ? h : base;
    const max = Number.isFinite(cap) && cap > 0 ? cap : $41147aa7dc9a37cc$export$2c716f1c60d68514;
    const stack = [
        ...base.stack.slice(0, base.index + 1),
        path
    ];
    const dropped = Math.max(0, stack.length - max);
    return {
        stack: stack.slice(dropped),
        index: stack.length - 1 - dropped
    };
};
const $41147aa7dc9a37cc$export$55ccaf2c962c14cc = (h, path)=>{
    if (!path || typeof path !== 'string') return h;
    if (!$41147aa7dc9a37cc$var$_valid(h) || h.index < 0) return $41147aa7dc9a37cc$export$c3eef008a3dd6140(h, path);
    if (h.stack[h.index] === path) return h;
    const stack = h.stack.slice();
    stack[h.index] = path;
    return {
        stack: stack,
        index: h.index
    };
};
const $41147aa7dc9a37cc$export$ea5376ba467e9179 = (h)=>$41147aa7dc9a37cc$var$_valid(h) && h.index > 0;
const $41147aa7dc9a37cc$export$82e79c81e71a101d = (h)=>$41147aa7dc9a37cc$var$_valid(h) && h.index < h.stack.length - 1;
const $41147aa7dc9a37cc$export$1c2a7f5d00352cf8 = (h)=>{
    if (!$41147aa7dc9a37cc$export$ea5376ba467e9179(h)) return null;
    const index = h.index - 1;
    return {
        hist: {
            stack: h.stack,
            index: index
        },
        path: h.stack[index]
    };
};
const $41147aa7dc9a37cc$export$3a375b8750627467 = (h)=>{
    if (!$41147aa7dc9a37cc$export$82e79c81e71a101d(h)) return null;
    const index = h.index + 1;
    return {
        hist: {
            stack: h.stack,
            index: index
        },
        path: h.stack[index]
    };
};

});

parcelRegister("bwwwL", function(module, exports) {

$parcel$export(module.exports, "slotPageFillProps", () => $863bea225589ef06$export$5042daa29d71e422);
// slotPageFill.js — how a page mounted in a PageSlot host sizes
// (ANSWER-VIEW-CONTENT-SIZED-1).
//
// A page FILLS its host (height / min-height 100%) — except a CONTENT-SIZED
// page: an AI answer view, which canvas answerUi registers with
// `metadata.contentSized`. Measured on dev 2026-10-04 (Storm): forced to fill,
// an answer of three stat tiles drew three ~1000 px tiles, empty below the
// numbers. A content-sized page keeps its own height (the host scrolls).
const $863bea225589ef06$export$5042daa29d71e422 = (def)=>def && def.metadata && def.metadata.contentSized === true ? {
        height: 'auto',
        minHeight: '0'
    } : {
        height: '100%',
        minHeight: '100%'
    };

});

parcelRegister("cKTuv", function(module, exports) {

$parcel$export(module.exports, "slotPinAfterPrimaryLeaves", () => $9494d345fdee489a$export$63322eb65c82bb29);
$parcel$export(module.exports, "slotPinAfterSecondLeaves", () => $9494d345fdee489a$export$e5ce23e1e5578572);
$parcel$export(module.exports, "slotPinToggle", () => $9494d345fdee489a$export$bdfc2e545794189c);
// THE OPT-IN PANE PIN — how `root._slotPinned` follows its pane (Nika
// 2026-10-10: "Yes, opt-in pin"). The pin names a PageSlot pane
// ('_canvasSlot' | '_canvasSlotSecond'); the shell's openAppPage opens a
// navbar/launcher pick beside it instead of over it. A pin belongs to a pane
// that shows something: when its pane leaves, it leaves with it; when the
// left pane leaves and the right one moves into its place (close with
// promotion, minimise), a pin on the right pane moves left with it. Pure —
// PageSlot writes the answers in the same update as the pane change.
// The pin after the LEFT (primary) pane leaves and a right pane, if any, takes
// its place.
const $9494d345fdee489a$export$63322eb65c82bb29 = (root)=>root && root._slotPinned === '_canvasSlotSecond' && root._canvasSlotSecond ? '_canvasSlot' : null;
const $9494d345fdee489a$export$e5ce23e1e5578572 = (root)=>root && root._slotPinned === '_canvasSlot' ? '_canvasSlot' : null;
const $9494d345fdee489a$export$bdfc2e545794189c = (root, key)=>{
    const now = root && root._slotPinned || null;
    if (key !== '_canvasSlot' && key !== '_canvasSlotSecond') return now;
    if (now === key) return null;
    return root && root[key] ? key : now;
};

});


parcelRegister("aSQTk", function(module, exports) {

$parcel$export(module.exports, "MinimizedDockChip", () => $7ec7f9a965a9b67b$export$86b8bc3c13189562);
$parcel$export(module.exports, "MinimizedDock", () => $7ec7f9a965a9b67b$export$53afcd7f3a9ebb3a);
// MinimizedDock — the parked-apps chips cluster for the shell PageSlot's
// minimize feature (2026-08-06 per Nika "we should support minimize feature
// for apps, to continue exactly where it left off").
//
// Renders one compact chip per `root._minimizedSlots` entry (icon + title +
// dismiss ✕). Clicking a chip RESTORES the app: it re-opens the route through
// the ONE opener (`el.call('openInSlot')` — shared/functions/openInSlot.js),
// which sets `root._canvasSlot`; the PageSlot's keep-alive host for that
// route (canvas/components/PageSlot.js `_mountPane`) then reveals the SAME
// mounted element — scroll, inputs and in-flight work intact. After a reload
// the hosts are gone (keep-alive is in-memory by nature) but the LIST is
// seeded back from per-workspace sessionStorage below, so the same chips
// offer COLD restores (fresh mount, best-effort continuation).
//
// Mounted INSIDE the PageSlot frame (canvas/components/PageSlot.js), not at
// the shell root: the frame is the feature's stacking context (1300) and is
// always mounted, the dock inherits its paint band without a new app.js
// mount, and declaring it BEFORE the panes keeps the phone full-bleed sheet
// painting ABOVE the chips with zero media hacks (same-context DOM order).
//
// Geometry: bottom-left, one step above the presence dock's baseline —
// OnlineMembersDock owns `left: A / bottom: X2` (the composer's own baseline,
// see its 2026-07-29 note), so the chips sit at `bottom: C` to clear that
// ~40px band with tokens only. The frame is pointerEvents:none; the dock
// re-enables interaction for itself, exactly like the panes do.
// Bare shared-library import, not a deep functions/minimizedSlots.js subpath
// — a per-file deep specifier into @symbo-ls/workspace-shared cannot resolve
// through the platform's public importmap (tickets/execution-board.md §1,
// same fix as workspace/app.js). Deferred call wrappers, not a module-scope
// destructure, per the a5d0a2aa barrel-cycle lesson.

var $1X0Je = parcelRequire("1X0Je");
const $7ec7f9a965a9b67b$var$readMinimizedList = (...args)=>(0, $1X0Je.default).functions.readMinimizedList(...args);
const $7ec7f9a965a9b67b$var$removeMinimizedEntry = (...args)=>(0, $1X0Je.default).functions.removeMinimizedEntry(...args);
const $7ec7f9a965a9b67b$var$shortSlotTitle = (...args)=>(0, $1X0Je.default).functions.shortSlotTitle(...args);
const $7ec7f9a965a9b67b$var$writeMinimizedList = (...args)=>(0, $1X0Je.default).functions.writeMinimizedList(...args);
// The workspace identity every consumer of the minimize feature shares —
// the AppAssistantThreadPicker resolution chain (workspace record → claims).
const $7ec7f9a965a9b67b$var$_canvasWsIdOf = (root)=>root?.activeWorkspaceId || root?.workspace?.id || root?.jwtClaims?.active_workspace_id || null;
// Cold seeding: once per workspace per dock instance, when live state carries
// no entries (fresh boot OR the post-switch registry wipe), offer the
// persisted list for THAT workspace. Runs from onCreate + onUpdate — the
// `workspace`/`activeWorkspaceId` subscription re-fires it after a switch,
// and the `_seededWs` latch keeps it once-per-tenant so a user emptying the
// dock by hand doesn't get the stale storage list re-imposed.
const $7ec7f9a965a9b67b$var$_seedFromStorage = (el, s)=>{
    const root = s.root;
    const wsId = $7ec7f9a965a9b67b$var$_canvasWsIdOf(root);
    if (!wsId || el._seededWs === wsId) return;
    el._seededWs = wsId;
    const live = root?._minimizedSlots;
    if (Array.isArray(live) && live.length) return;
    const persisted = $7ec7f9a965a9b67b$var$readMinimizedList(wsId);
    if (persisted.length && root && typeof root.update === 'function') root.update({
        _minimizedSlots: persisted
    });
};
const $7ec7f9a965a9b67b$export$86b8bc3c13189562 = {
    flow: 'x',
    align: 'center',
    gap: 'V',
    padding: 'X',
    round: 'radiusPill',
    theme: 'dialog',
    shadow: 'float',
    flexShrink: '0',
    minWidth: '0',
    maxWidth: 'G',
    AppCapsuleBtnToolbar: {
        compact: true,
        theme: 'transparent',
        minWidth: '0',
        gap: 'Z',
        'aria-label': (el, s)=>`${el.call('polyglot', 'canvas.minimizedDock.restore')} ${$7ec7f9a965a9b67b$var$shortSlotTitle(el.call('storeItemText', {
                key: s.appKey,
                name: s.title || ''
            }, 'name')) || s.href || ''}`,
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            if (s.href) el.call('openInSlot', s.href, el);
        },
        Icon: {
            name: (el, s)=>s.icon || 'layers',
            boxSize: 'iconSm'
        },
        Text: {
            minWidth: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>$7ec7f9a965a9b67b$var$shortSlotTitle(el.call('storeItemText', {
                    key: s.appKey,
                    name: s.title || ''
                }, 'name')) || s.href || ''
        }
    },
    DismissBtn: {
        extends: 'PageSlotHeaderBtn',
        'aria-label': (el)=>el.call('polyglot', 'canvas.minimizedDock.closeAria'),
        title: (el)=>el.call('polyglot', 'canvas.minimizedDock.close'),
        Icon: {
            name: 'close'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const root = s.root;
            const next = $7ec7f9a965a9b67b$var$removeMinimizedEntry(root?._minimizedSlots || [], s.href);
            $7ec7f9a965a9b67b$var$writeMinimizedList($7ec7f9a965a9b67b$var$_canvasWsIdOf(root), next);
            if (root && typeof root.update === 'function') root.update({
                _minimizedSlots: next
            });
        }
    }
};
const $7ec7f9a965a9b67b$export$53afcd7f3a9ebb3a = {
    position: 'fixed',
    // BF-MINIMIZED-DOCK-OVER-RAIL-1 (repeat report, 2026-08-16): B6's
    // rail-parking branch is DELETED. Its justification — "the one band page
    // content provably never occupies" — was true of page content and false
    // of THE RAIL ITSELF: the band is empty precisely because the sidebar is
    // there, so the chips sat on the rail's own controls at every width (the
    // phone gate only hid the widest case). ONE placement now, the plain-
    // workspace right-edge stack, which already satisfied B6's brief ("move
    // them right", width never grows with count) and overlays nothing — the
    // right edge is content-inset territory on every surface.
    // Coordination (tasks-guy, 2026-08-16): ai is publishing an
    // --assistant-inset-right for the AI drawer — a fixed right-edge element
    // that ignores it lands UNDER the drawer, the same overlay class this
    // fix removes. Additive with a 0px fallback, so nothing changes until
    // ai's var ships.
    right: 'calc(var(--assistant-inset-right, 0px) + var(--spacing-A))',
    bottom: 'calc(var(--slot-bottom, var(--spacing-C)) + var(--spacing-Z))',
    pointerEvents: 'auto',
    flow: 'x',
    alignItems: 'center',
    gap: 'Z',
    maxWidth: 'calc(100vw - var(--module-rail-clear, 0px) - var(--assistant-inset-right, 0px) - var(--spacing-B))',
    overflowX: 'auto',
    overscrollBehavior: 'contain',
    padding: 'Z',
    '@mobileL': {
        bottom: 'calc(env(safe-area-inset-bottom) + var(--spacing-A))'
    },
    // Tombstones — the deleted rail-parking branch (a stored payload would
    // otherwise resurrect the class block on merge-shaped surfaces; inert
    // here in the bundled shell, kept for grep-ability + the record).
    isDockInRail: null,
    '.isDockInRail': null,
    // Reactive `display:` gate (house keep-alive law — never `hide:` around
    // kept-alive surfaces; the dock follows the same grammar for consistency):
    // present in the tree always, painted only while something is parked.
    // Phone + open AI drawer: the drawer (min-width 320px) covers the whole
    // free band — at 500px it even overlaps the module rail — so there is no
    // legal place for chips; measured 2026-08-18: capped chips collapsed to
    // 18px slivers UNDER both surfaces. The dock hides for that combination
    // and returns the moment the drawer closes.
    display: (el, s)=>{
        if (!(s.root?._minimizedSlots || []).length) return 'none';
        const phone = s.root?._isPhoneViewport;
        const phoneNow = phone === true || phone == null && typeof matchMedia === 'function' && matchMedia('(max-width: 768px)').matches;
        if (phoneNow && s.root?.assistantOpen) return 'none';
        return 'flex';
    },
    // workspaceProject: the rail-column placement (isDockInRail) must
    // re-resolve when the module manifest lands after boot.
    subscribeTo: [
        '_minimizedSlots',
        'workspace',
        'activeWorkspaceId',
        'workspaceProject',
        '_isPhoneViewport',
        // phone×drawer display gate above — declared lists are the contract.
        'assistantOpen'
    ],
    onCreate: $7ec7f9a965a9b67b$var$_seedFromStorage,
    onUpdate: $7ec7f9a965a9b67b$var$_seedFromStorage,
    childrenAs: 'state',
    children: (el, s)=>s.root?._minimizedSlots || [],
    childExtends: 'MinimizedDockChip'
};

});

parcelRegister("8exyG", function(module, exports) {

$parcel$export(module.exports, "SettingsModalBody", () => $5fe9a989630097aa$export$a0dd27cdc3468a93);
// Unified Settings modal (workspace + project canvas + tickets), extracted from
// pages/studios.js as Stage 1 of the studios barrel-split (#11). It must stay
// EAGER: the /tickets Sidebar + TicketsKanban and workspace/app.js all open it
// via `extends: 'SettingsModalBody'`, and those surfaces never load the studios
// page chunk. Kept self-contained — the only studios-page dependencies were the
// live board-engine calls (drag mode + auto-layout), which are decoupled here
// via `el.call` so they run only when the studios page has registered them (on
// /studio) and gracefully no-op everywhere else.
//
// This module does NOT import pages/studios.js — that edge would re-pin the
// board/panzoom/connection engine into the initial bundle and defeat Stage 2.
// Factory for SettingsModal tabs — left-rail button that picks a section.
// Reuses the house MenuPanelItem row (button chrome, padding, title color,
// theme-aware hover); active state is the same `selected` wash every other
// active item in the suite uses (DESIGN_LANGUAGE.md §4.3 — overlayStrong is
// retired from state duty).
//
// The tab key rides on the tab's own `scope`, and `isActive` and `onClick`
// read `el.scope.tabKey`: frank serializes each handler from its own source
// text, so a handler that read the `tabKey` parameter carried a free name into
// the emitted record (no tab showed active, a click could not leave Workspace).
// The `.isActive` conditional block marks the open tab and follows
// `root.settingsTab` on its own, inside this custom modal too: the key is
// absent until the Settings button writes it, and such a block stays live
// (smbls bf7d72268). A click only writes the tab; no handler moves a class
// (__tests__/settingsModalNoHandToggle.test.js).
function $5fe9a989630097aa$var$settingsTab(tabKey, label, hint) {
    return {
        extends: 'MenuPanelItem',
        scope: {
            tabKey: tabKey
        },
        // `text` takes the template form; `title` is an HTML attribute, so its
        // caller passes the FUNCTION form (docs/I18N-CONVENTION.md §1).
        text: label,
        title: hint,
        isActive: (el, s)=>(s.root?.settingsTab || 'workspace') === el.scope?.tabKey,
        '.isActive': {
            background: 'selected',
            color: 'title',
            fontWeight: '700'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root?.update({
                settingsTab: el.scope?.tabKey
            });
        }
    };
}
// `_settingsSwitchIsOn`/`_settingsSwitchToggle` are the generic read/write
// dispatch for `iosSwitch` below (2026-08-13, tickets/opus.md "~800
// project-side Frankability defects" — SettingsModal's
// factory-closure-capture class, 8 unresolvable-scope-read findings via
// `smbls frank to-json .`). `iosSwitch` used to take `{isOn, onToggle,
// disabledHint}` as params and close over them directly inside `onClick`/
// `onRender` — the SAME frank-fatal shape as CanvasOverlayV2's
// `handle`/`ruler`, except the captured value was a FUNCTION, not a
// primitive (the harder case that ticket flags): `onToggle` itself closed
// over `settingsCanvasRow`'s own `opts` (`opts.patchSnap`/`opts.call`/
// `opts.patch`/`opts.checked`), so putting the closure itself on `scope:`
// would only move the same free-variable problem one level down, onto
// `opts`. Traced every one of the 8 call sites instead of assuming this was
// unfixable: all 8 reduce to exactly 3 primitive dispatch shapes — read
// `root|snap` × `strict|truthy`, write `call|patch|patchSnap` — so the
// closures were genuinely eliminable, not an exception. These two functions
// are real top-level declarations (never received through a factory's own
// params) that read ONLY their own `(el, s)` params + `el.scope` — the same
// shape as PageSlot's `_histCan(el, s)` fix.
function $5fe9a989630097aa$var$_settingsSwitchIsOn(el) {
    try {
        const v2 = el.call?.('getCanvasV2');
        const key = el.scope?.key;
        if (!v2 || !key) return false;
        const value = el.scope?.group === 'snap' ? v2.snap?.[key] : v2[key];
        return el.scope?.mode === 'strict' ? value === true : !!value;
    } catch (err) {
        return false;
    }
}
function $5fe9a989630097aa$var$_settingsSwitchToggle(v, el) {
    try {
        if (!el.call?.('getCanvasV2')) return false;
        const key = el.scope?.key;
        if (el.scope?.action === 'call') el.call?.(el.scope.callFn);
        else if (el.scope?.action === 'patchSnap') el.call?.('patchSnap', {
            [key]: v
        });
        else if (el.scope?.action === 'patch') el.call?.('patchCanvas', {
            [key]: v
        });
    } catch (err) {
        console.warn('[settings] canvas patch failed:', err);
        return false;
    }
}
// iOS-style switch — pill track + white knob. The conditional `.isOn` block
// drives the on-state (track fill + knob side) and follows the setting on its
// own: `isOn` reads root `canvas` through getCanvasV2, so the root write a
// toggle makes re-runs it. A click takes the next value from the setting
// itself, never from the node. `scope` carries the per-row dispatch
// primitives (`group`/`key`/`mode`/`action`/`callFn`) that
// `_settingsSwitchIsOn`/`_settingsSwitchToggle` above read via `el.scope`.
function $5fe9a989630097aa$var$iosSwitch(scope) {
    return {
        tag: 'button',
        type: 'button',
        width: '44px',
        minWidth: '44px',
        height: '27px',
        round: 'radiusPill',
        borderWidth: '0',
        cursor: 'pointer',
        padding: '2px',
        display: 'flex',
        align: 'center left',
        transition: 'background 160ms ease',
        // Fixed-colour sweep: kept — track (gray8.36) + on-state fill (#34c759)
        // + Knob (white below) together form the universal iOS-style switch,
        // deliberately theme-independent regardless of app theme or track
        // colour, same convention already established for workspace's
        // SwitchInput.Knob.
        background: 'gray8.36',
        scope: scope,
        isOn: (el, s)=>$5fe9a989630097aa$var$_settingsSwitchIsOn(el, s),
        '.isOn': {
            background: '#34c759',
            align: 'center right'
        },
        title: (el)=>el.call('polyglot', 'canvas.settings.switchTitle'),
        Knob: {
            tag: 'span',
            width: '23px',
            height: '23px',
            round: '50%',
            background: 'white',
            pointerEvents: 'none'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            $5fe9a989630097aa$var$_settingsSwitchToggle(!$5fe9a989630097aa$var$_settingsSwitchIsOn(el, s), el, s);
        }
    };
}
// Grouped-list row chrome (iOS inset list): label + hint left, control right.
// Was a `borderBottomWidth: 'hairline'` separator between rows (plus a raw
// CSS-var borderBottomColor instead of a token) — row-separator-as-stroke,
// banned by design-direction.md §8 / DESIGN_LANGUAGE §2.5 (same fix as
// workspace-shell's SettingRow.js/FlagRow.js). Each row's own top+bottom
// `Z1` padding already spaces adjacent rows regardless of the pane's own
// `gap: '0'` (flex padding is never collapsed away by a parent gap), so
// dropping the line changes nothing geometrically; the hover wash is the
// fill-contrast replacement for the boundary cue.
const $5fe9a989630097aa$var$_settingsRowChrome = {
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    padding: 'Z1 0',
    transition: 'Z defaultBezier background',
    ':hover': {
        background: 'hover'
    },
    '@mobileL': {
        flow: 'y',
        align: 'stretch flex-start',
        gap: 'Y'
    }
};
const $5fe9a989630097aa$var$_settingsPaneChrome = {
    flow: 'y',
    gap: '0',
    round: 'radiusCard',
    padding: '0 A A',
    // Fixed-colour sweep: white.04 -> title.04, same alpha. SettingsModalBody
    // is opened via el.call('openModal', ...) and rendered inside the brand
    // ModalWindow, which carries an adaptive `theme: 'modal'`
    // (background:'gray2' dark / 'gray16' light) — a fixed white wash on this
    // grouped-list pane was already near-invisible on the light-mode gray16
    // surface, same "subtle wash card on an adaptive modal" bug already fixed
    // in tickets/ (ActivityHeatmap, DailyUpdate, TicketDetailModal).
    background: 'title.04'
};
const $5fe9a989630097aa$var$_ticketsSegmentedControlChrome = {
    flow: 'x',
    gap: '0',
    round: 'radiusPill',
    padding: 'W',
    background: 'line-faded',
    childExtends: 'Button',
    childProps: {
        minHeight: 'controlHCompact',
        padding: '0 Y',
        fontSize: 'Z',
        round: 'radiusPill',
        cursor: 'pointer',
        borderWidth: '0',
        background: 'transparent',
        color: 'caption',
        '.isActive': {
            background: 'selected',
            color: 'title',
            fontWeight: '700'
        }
    }
};
// Factory for canvas-scoped settings rows. Always rendered — without an open
// project the switch reads off and explains itself via title; the patch calls
// are guarded no-ops. `opts` is now plain data (`group`/`key`/`mode`/
// `action`/`callFn`) — no functions — so it rides on `iosSwitch`'s `scope:`
// intact (see `_settingsSwitchIsOn`/`_settingsSwitchToggle` above for why).
function $5fe9a989630097aa$var$settingsCanvasRow(label, hint, opts = {}) {
    return {
        ...$5fe9a989630097aa$var$_settingsRowChrome,
        Label: {
            flow: 'y',
            gap: 'V',
            flexGrow: '1',
            Name: {
                tag: 'span',
                text: label,
                fontWeight: '700',
                color: 'title'
            },
            Hint: {
                tag: 'span',
                text: hint,
                fontSize: 'Z',
                color: 'caption'
            }
        },
        Control: $5fe9a989630097aa$var$iosSwitch({
            group: opts.group === 'snap' ? 'snap' : 'root',
            key: opts.key,
            mode: opts.mode === 'strict' ? 'strict' : 'truthy',
            action: opts.action,
            callFn: opts.callFn || null
        })
    };
}
// Factory for SettingsModal content rows — label + hint on the left, a control
// (toggle, button, input) on the right. Takes the control def directly so
// callers own its state/handlers.
function $5fe9a989630097aa$var$settingsBlockRow(label, hint, control) {
    return {
        ...$5fe9a989630097aa$var$_settingsRowChrome,
        Label: {
            flow: 'y',
            gap: 'V',
            flexGrow: '1',
            minWidth: '0',
            Name: {
                tag: 'span',
                text: label,
                fontWeight: '700',
                color: 'title'
            },
            Hint: {
                tag: 'span',
                text: hint,
                fontSize: 'Z',
                color: 'caption'
            }
        },
        Control: {
            ...control,
            flexShrink: '0'
        }
    };
}
// ── Tickets-section helpers ──────────────────────────────────────────────
// The /tickets board keeps its per-column UI prefs on root: `_colCount`
// (cards per row, default 2) and `_hiddenCols` (columns hidden via the column
// "⋯" menu). Column keys come from root.columns with the same fallback
// derivation the kanban itself uses.
const $5fe9a989630097aa$var$ticketsColKeys = (root)=>{
    const cols = (root?.columns || []).map((c)=>c.key);
    if (cols.length) return cols;
    const counted = Object.keys(root?.totalByColumn || {});
    if (counted.length) return counted;
    return [
        ...new Set((root?.tickets || []).map((t)=>t.columnKey).filter(Boolean))
    ];
};
// A column's name as the board header shows it: the tickets package's
// registered columnLabelText, reached through el.call like this tab's other
// tickets functions (setTicketsBoardPref, refreshTicketsCounts). A column the
// server marks `labelIsSeed` reads in the active language; any other column
// shows its stored label, and so does every column while columnLabelText is
// not registered. A key with no column row title-cases, as before.
const $5fe9a989630097aa$var$ticketsColLabel = (el, root, key)=>{
    const col = (root?.columns || []).find((c)=>c.key === key);
    return col && (el.call('columnLabelText', col) || col.label) || String(key).replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
};
const $5fe9a989630097aa$var$ticketsHiddenKeys = (root)=>{
    const hidden = root?._hiddenCols || {};
    return Object.keys(hidden).filter((k)=>hidden[k]);
};
const $5fe9a989630097aa$var$ticketsCardsPerRow = (root)=>{
    const m = root?._colCount || {};
    const keys = $5fe9a989630097aa$var$ticketsColKeys(root);
    return keys.length && keys.every((k)=>m[k] === 1) ? 1 : 2;
};
// Persist through the tickets package's registered setTicketsBoardPref
// (root.update + localStorage) so the choice survives reloads (2026-07-25
// per Nika "make sure settings changes persist after reload").
const $5fe9a989630097aa$var$setTicketsCardsPerRow = (el, root, n)=>{
    const m = {};
    $5fe9a989630097aa$var$ticketsColKeys(root).forEach((k)=>{
        m[k] = n;
    });
    el.call('setTicketsBoardPref', {
        _colCount: m
    });
};
const $5fe9a989630097aa$export$a0dd27cdc3468a93 = {
    position: 'relative',
    flow: 'y',
    gap: 'B',
    minWidth: '0',
    // Brand window header — its Close icon (data-key="Close") is dismissed by
    // the ModalRoot's document delegate.
    ModalHeader: {
        position: 'relative',
        Hgroup: {
            H: {
                text: '{{ canvas.settings.title | polyglot }}'
            },
            P: {
                text: '{{ canvas.settings.subtitle | polyglot }}'
            }
        },
        Icons: {
            Close: {
                position: 'absolute',
                top: '0',
                right: '0',
                margin: '0'
            }
        }
    },
    SettingsBody: {
        flow: 'x',
        gap: 'B',
        flexGrow: '1',
        maxHeight: '72vh',
        overflow: 'hidden',
        WsSettingsNav: {
            flow: 'y',
            width: 'E',
            minWidth: 'E',
            gap: 'Y',
            NavItemWorkspace: $5fe9a989630097aa$var$settingsTab('workspace', '{{ canvas.settings.tabWorkspace.label | polyglot }}', (el)=>el.call('polyglot', 'canvas.settings.tabWorkspace.hint')),
            NavItemProject: $5fe9a989630097aa$var$settingsTab('project', '{{ canvas.settings.tabProject.label | polyglot }}', (el)=>el.call('polyglot', 'canvas.settings.tabProject.hint')),
            NavItemTickets: $5fe9a989630097aa$var$settingsTab('tickets', '{{ canvas.settings.tabTasks.label | polyglot }}', (el)=>el.call('polyglot', 'canvas.settings.tabTasks.hint'))
        },
        SettingsContent: {
            flexGrow: '1',
            flexBasis: '0',
            flow: 'y',
            minWidth: '0',
            overflowX: 'hidden',
            overflowY: 'auto',
            gap: 'A',
            WorkspacePane: {
                ...$5fe9a989630097aa$var$_settingsPaneChrome,
                display: (el, s)=>(s.root?.settingsTab || 'workspace') === 'workspace' ? 'flex' : 'none',
                // iOS grouped inset list — the pane is the rounded group card, rows
                // separate by their own padding + a hover wash (see
                // _settingsRowChrome).
                DragModeRow: $5fe9a989630097aa$var$settingsBlockRow('{{ canvas.settings.dragMode.label | polyglot }}', '{{ canvas.settings.dragMode.hint | polyglot }}', {
                    flow: 'x',
                    gap: '0',
                    round: 'radiusPill',
                    padding: 'W',
                    background: 'line-faded',
                    childExtends: 'Button',
                    childProps: {
                        minHeight: 'controlHCompact',
                        padding: '0 Y',
                        fontSize: 'Z',
                        round: 'radiusPill',
                        cursor: 'pointer',
                        borderWidth: '0',
                        background: 'transparent',
                        color: 'caption',
                        '.isActive': {
                            background: 'selected',
                            color: 'title'
                        }
                    },
                    // Drag mode reads/writes the studios board's live state. Off-studio
                    // (studios page unmounted) el.call('getDragMode') returns undefined
                    // → default to 'grid' so the segmented control still shows a
                    // sensible active state instead of both segments dark.
                    FreeformBtn: {
                        text: '{{ canvas.settings.dragMode.free | polyglot }}',
                        isActive: (el, s)=>(el.call('getDragMode', s.root) || 'grid') === 'freeform',
                        onClick: (e, el, s)=>{
                            s.root.update({
                                dragMode: 'freeform'
                            });
                        }
                    },
                    GridBtn: {
                        text: '{{ canvas.settings.dragMode.grid | polyglot }}',
                        isActive: (el, s)=>(el.call('getDragMode', s.root) || 'grid') === 'grid',
                        onClick: (e, el, s)=>{
                            s.root.update({
                                dragMode: 'grid'
                            });
                        }
                    }
                }),
                AutoLayoutRow: $5fe9a989630097aa$var$settingsBlockRow('{{ canvas.settings.autoLayout.label | polyglot }}', '{{ canvas.settings.autoLayout.hint | polyglot }}', {
                    tag: 'button',
                    type: 'button',
                    minHeight: 'controlHCompact',
                    padding: '0 Z',
                    round: 'radiusPill',
                    borderWidth: '0',
                    background: 'line-faded',
                    color: 'title',
                    fontSize: 'Z',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    text: '{{ canvas.settings.autoLayout.run | polyglot }}',
                    ':hover': {
                        background: 'line-highlight'
                    },
                    '@mobileL': {
                        alignSelf: 'flex-start'
                    },
                    onClick: (e, el, s)=>{
                        e.stopPropagation();
                        const root = s.root;
                        if (!Array.isArray(root?.nodes)) return;
                        // Auto-layout drives the studio board's live panzoom/layout +
                        // canvas-layout persistence engine, which exists only while the
                        // studios page is mounted (it registers these fns on /studio).
                        // Off-studio el.call returns undefined → guard to a no-op so this
                        // never throws on /tickets or the project canvas (and never asks
                        // for a rearrange that cannot run).
                        if (!el.call('layoutPositions', root.nodes)) return;
                        // It replaces every hand-placed position in the workspace-shared
                        // layout (every member sees it) and the board has no undo: the
                        // house confirm first (CRUD + confirm standard rule 4). Nothing
                        // moves before the verb.
                        el.call('confirmDialog', {
                            title: el.call('polyglot', 'canvas.settings.autoLayout.confirmTitle'),
                            message: el.call('polyglot', 'canvas.settings.autoLayout.confirmMessage'),
                            confirmText: el.call('polyglot', 'canvas.settings.autoLayout.confirmButton'),
                            cancelText: el.call('polyglot', 'common.action.cancel'),
                            confirmTheme: 'primary',
                            icon: null,
                            onConfirm: ()=>{
                                const newPositions = el.call('layoutPositions', root.nodes);
                                if (!newPositions) return;
                                root.update({
                                    positions: newPositions
                                });
                                el.call('persistPositions', {
                                    nodes: root.nodes,
                                    positions: newPositions,
                                    orgId: root.orgId
                                }, root.nodes.map((n)=>n.id));
                            }
                        });
                    }
                })
            },
            ProjectPane: {
                ...$5fe9a989630097aa$var$_settingsPaneChrome,
                display: (el, s)=>(s.root?.settingsTab || 'workspace') === 'project' ? 'flex' : 'none',
                // Canvas v2 settings — ALWAYS rendered; without an open project the
                // switches read off and patches are guarded no-ops; the footnote below
                // explains the scope.
                ShowDesignSystemRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.showDesignSystem.label | polyglot }}', '{{ canvas.settings.showDesignSystem.hint | polyglot }}', {
                    key: 'showDesignSystem',
                    mode: 'strict',
                    action: 'call',
                    callFn: 'toggleCanvasDesignSystem'
                }),
                ShowComponentsRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.showComponents.label | polyglot }}', '{{ canvas.settings.showComponents.hint | polyglot }}', {
                    key: 'showComponents',
                    mode: 'strict',
                    action: 'call',
                    callFn: 'toggleCanvasComponents'
                }),
                ShowRulersRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.showRulers.label | polyglot }}', '{{ canvas.settings.showRulers.hint | polyglot }}', {
                    key: 'showRulers',
                    mode: 'truthy',
                    action: 'patch'
                }),
                ShowMinimapRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.showMinimap.label | polyglot }}', '{{ canvas.settings.showMinimap.hint | polyglot }}', {
                    key: 'showMinimap',
                    mode: 'truthy',
                    action: 'patch'
                }),
                SnapRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.snap.label | polyglot }}', '{{ canvas.settings.snap.hint | polyglot }}', {
                    group: 'snap',
                    key: 'enabled',
                    mode: 'truthy',
                    action: 'patchSnap'
                }),
                SnapGridRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.snapGrid.label | polyglot }}', '{{ canvas.settings.snapGrid.hint | polyglot }}', {
                    group: 'snap',
                    key: 'toGrid',
                    mode: 'truthy',
                    action: 'patchSnap'
                }),
                SnapItemsRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.snapItems.label | polyglot }}', '{{ canvas.settings.snapItems.hint | polyglot }}', {
                    group: 'snap',
                    key: 'toItems',
                    mode: 'truthy',
                    action: 'patchSnap'
                }),
                SnapGuidesRow: $5fe9a989630097aa$var$settingsCanvasRow('{{ canvas.settings.snapGuides.label | polyglot }}', '{{ canvas.settings.snapGuides.hint | polyglot }}', {
                    group: 'snap',
                    key: 'toGuides',
                    mode: 'truthy',
                    action: 'patchSnap'
                }),
                // iOS-style group footnote — scope hint, shown only when no project
                // canvas is open (the switches above still render).
                ProjectScopeNote: {
                    hide: (el)=>{
                        try {
                            return !!el.call?.('getCanvasV2');
                        } catch (err) {
                            return false;
                        }
                    },
                    tag: 'span',
                    padding: 'Z 0',
                    fontSize: 'Z',
                    color: 'caption',
                    text: '{{ canvas.settings.projectScopeNote | polyglot }}'
                }
            },
            TicketsPane: {
                ...$5fe9a989630097aa$var$_settingsPaneChrome,
                display: (el, s)=>(s.root?.settingsTab || 'workspace') === 'tickets' ? 'flex' : 'none',
                CardsPerRowRow: $5fe9a989630097aa$var$settingsBlockRow('{{ canvas.settings.cardsPerRow.label | polyglot }}', '{{ canvas.settings.cardsPerRow.hint | polyglot }}', {
                    ...$5fe9a989630097aa$var$_ticketsSegmentedControlChrome,
                    OneColBtn: {
                        text: '1',
                        isActive: (el, s)=>$5fe9a989630097aa$var$ticketsCardsPerRow(s.root) === 1,
                        onClick: (e, el, s)=>$5fe9a989630097aa$var$setTicketsCardsPerRow(el, s.root, 1)
                    },
                    TwoColBtn: {
                        text: '2',
                        isActive: (el, s)=>$5fe9a989630097aa$var$ticketsCardsPerRow(s.root) === 2,
                        onClick: (e, el, s)=>$5fe9a989630097aa$var$setTicketsCardsPerRow(el, s.root, 2)
                    }
                }),
                // Freeform card placement — when on, cards can be dragged out of their
                // column and placed anywhere on the board canvas; dropping a freeform
                // card back onto a column returns it to in-column flow.
                CardPlacementRow: $5fe9a989630097aa$var$settingsBlockRow('{{ canvas.settings.cardPlacement.label | polyglot }}', '{{ canvas.settings.cardPlacement.hint | polyglot }}', {
                    ...$5fe9a989630097aa$var$_ticketsSegmentedControlChrome,
                    // Freeform is the DEFAULT mode (2026-07-25 per Nika) — an unset
                    // flag reads as ON; both buttons persist via setTicketsBoardPref
                    // so the mode survives reloads.
                    InColumnsBtn: {
                        text: '{{ canvas.settings.cardPlacement.inColumns | polyglot }}',
                        isActive: (el, s)=>s.root?._ticketsFreeform === false,
                        onClick: (e, el, s)=>el.call('setTicketsBoardPref', {
                                _ticketsFreeform: false
                            })
                    },
                    FreeformBtn: {
                        text: '{{ canvas.settings.cardPlacement.freeform | polyglot }}',
                        isActive: (el, s)=>s.root?._ticketsFreeform !== false,
                        onClick: (e, el, s)=>el.call('setTicketsBoardPref', {
                                _ticketsFreeform: true
                            })
                    }
                }),
                HiddenColsBlock: {
                    padding: 'Z1 0',
                    flow: 'y',
                    gap: 'Y',
                    HiddenColsLabel: {
                        flow: 'y',
                        gap: 'V',
                        Name: {
                            tag: 'span',
                            text: '{{ canvas.settings.hiddenCols.label | polyglot }}',
                            fontWeight: '700',
                            color: 'title'
                        },
                        Hint: {
                            tag: 'span',
                            text: '{{ canvas.settings.hiddenCols.hint | polyglot }}',
                            fontSize: 'Z',
                            color: 'caption'
                        }
                    },
                    HiddenColsEmpty: {
                        hide: (el, s)=>$5fe9a989630097aa$var$ticketsHiddenKeys(s.root).length > 0,
                        tag: 'span',
                        fontSize: 'Z',
                        color: 'caption',
                        text: '{{ canvas.settings.hiddenCols.empty | polyglot }}'
                    },
                    HiddenColsList: {
                        hide: (el, s)=>!$5fe9a989630097aa$var$ticketsHiddenKeys(s.root).length,
                        flow: 'y',
                        gap: 'Y',
                        childrenAs: 'state',
                        children: (el, s)=>$5fe9a989630097aa$var$ticketsHiddenKeys(s.root).map((key)=>({
                                    key: key,
                                    label: $5fe9a989630097aa$var$ticketsColLabel(el, s.root, key)
                                })),
                        childExtends: {
                            flow: 'x',
                            align: 'center space-between',
                            gap: 'A',
                            padding: 'Y Z1',
                            round: 'radiusControl',
                            background: 'line-faded',
                            ColName: {
                                tag: 'span',
                                fontSize: 'Z1',
                                color: 'title',
                                text: (el, s)=>s.label
                            },
                            ShowColBtn: {
                                tag: 'button',
                                type: 'button',
                                text: '{{ canvas.settings.hiddenCols.show | polyglot }}',
                                minHeight: 'controlHCompact',
                                padding: '0 Z',
                                round: 'radiusPill',
                                borderWidth: '0',
                                background: 'transparent',
                                color: 'title',
                                cursor: 'pointer',
                                fontSize: 'Z',
                                ':hover': {
                                    background: 'line-highlight'
                                },
                                onClick: (e, el, s)=>{
                                    const hidden = {
                                        ...s.root?._hiddenCols || {}
                                    };
                                    delete hidden[s.key];
                                    el.call('setTicketsBoardPref', {
                                        _hiddenCols: hidden
                                    });
                                    const raw = s.root?._rawTypeCounts;
                                    if (raw) {
                                        const nextTypes = {};
                                        for(const bucket in raw)nextTypes[bucket] = Object.entries(raw[bucket]).reduce((sum, [cKey, v])=>{
                                            if (s.root._excludedCols?.[cKey] || hidden[cKey]) return sum;
                                            return sum + (Number(v) || 0);
                                        }, 0);
                                        s.root.update({
                                            totalByType: nextTypes
                                        });
                                    }
                                    // The board re-reads its counts (the registered tickets
                                    // function; it reads nothing while no board is on screen).
                                    el.call('refreshTicketsCounts');
                                }
                            }
                        }
                    }
                },
                ExcludedColsBlock: {
                    padding: 'Z1 0',
                    flow: 'y',
                    gap: 'Y',
                    state: {
                        hasChanges: false
                    },
                    ExcludedColsHeader: {
                        flow: 'x',
                        align: 'start space-between',
                        gap: 'A',
                        ExcludedColsLabel: {
                            flow: 'y',
                            gap: 'V',
                            Name: {
                                tag: 'span',
                                text: '{{ canvas.settings.excludedCols.label | polyglot }}',
                                fontWeight: '700',
                                color: 'title'
                            },
                            Hint: {
                                tag: 'span',
                                text: '{{ canvas.settings.excludedCols.hint | polyglot }}',
                                fontSize: 'Z',
                                color: 'caption'
                            }
                        },
                        SaveBtn: {
                            extends: 'Button',
                            theme: 'primary',
                            text: '{{ common.action.save | polyglot }}',
                            flexShrink: '0',
                            ':disabled': {
                                theme: 'field-disabled',
                                cursor: 'not-allowed'
                            },
                            disabled: (el, s)=>!s.hasChanges,
                            onClick: (e, el, s)=>{
                                if (!s.hasChanges) return;
                                const root = s.root;
                                const raw = root._rawTypeCounts;
                                if (raw) {
                                    const nextTypes = {};
                                    for(const bucket in raw)nextTypes[bucket] = Object.entries(raw[bucket]).reduce((sum, [colKey, v])=>{
                                        if (root._excludedCols?.[colKey] || root._hiddenCols?.[colKey]) return sum;
                                        return sum + (Number(v) || 0);
                                    }, 0);
                                    root.update({
                                        totalByType: nextTypes
                                    });
                                }
                                el.call('refreshTicketsCounts');
                                s.update({
                                    hasChanges: false
                                });
                            }
                        }
                    },
                    ExcludedColsList: {
                        flow: 'y',
                        gap: 'Y',
                        childrenAs: 'state',
                        children: (el, s)=>$5fe9a989630097aa$var$ticketsColKeys(s.root).map((key)=>({
                                    key: key,
                                    label: $5fe9a989630097aa$var$ticketsColLabel(el, s.root, key)
                                })),
                        childExtends: {
                            tag: 'label',
                            flow: 'x',
                            align: 'center flex-start',
                            gap: 'A',
                            padding: 'Y Z1',
                            round: 'radiusControl',
                            background: 'line-faded',
                            cursor: 'pointer',
                            NativeCheckbox: {
                                tag: 'input',
                                attr: {
                                    type: 'checkbox',
                                    checked: (el, s)=>!!(s.root?._excludedCols || {})[s.key]
                                },
                                margin: '0',
                                cursor: 'pointer',
                                onInput: (e, el, s)=>{
                                    const excluded = {
                                        ...s.root?._excludedCols || {}
                                    };
                                    if (e.target.checked) excluded[s.key] = true;
                                    else delete excluded[s.key];
                                    el.call('setTicketsBoardPref', {
                                        _excludedCols: excluded
                                    });
                                    const block = el.lookup('ExcludedColsBlock');
                                    block?.state?.update({
                                        hasChanges: true
                                    });
                                }
                            },
                            ColName: {
                                tag: 'span',
                                fontSize: 'Z1',
                                color: 'title',
                                userSelect: 'none',
                                text: (el, s)=>s.label
                            }
                        }
                    }
                }
            }
        }
    }
};

});

parcelRegister("7OV1J", function(module, exports) {

$parcel$export(module.exports, "CanvasConnection", () => $5b19704bcd88fb8b$export$df6f33015f82810e);
// CanvasConnection — single shared edge renderer for the canvas
// panzoom surfaces (/studios, /team-and-agents, future canvas pages).
//
// Each connection mounts as a `<g>` with two paths:
//   1. HitArea — a fat transparent stroke that catches clicks /
//      hover; `pointer-events: stroke` so only the line catches
//      events, leaving the rest of the SVG transparent for panzoom.
//   2. Visible — the thin stroke the user sees.
//
// Bezier math defers to `el.call('bezierBetweenNodes', …)` so both
// pages agree on the curve shape — no per-page math drift.
//
// Wire shape (child state when used with childrenAs:'state'):
//   {
//     from: nodeId, to: nodeId,
//     // optional: per-edge styling overrides (selected/hover state
//     // is read from root via the state keys the page configures
//     // through scope below)
//     shared?: [teamNames],     // co-membership tooltip
//     kind?: 'integration',     // visual variant
//     // Plus: the page's scope-injected helpers:
//     getPath:    (root, from, to, el) => 'M…' SVG path
//     selectedKey?: (root) => 'from→to' key of the selected edge
//     hoverKey?:    (root) => 'from→to' key of the hovered edge
//     onSelect?:    (e, el, s) => …   click handler
//   }
//
// Pages pass per-instance config via the `scope: { … }` prop on the
// parent Connections container (smbls v3.14 FA204 — one-shot consts
// live in scope, not in mutable state). Children inherit through
// state, so each connection's reactive factories see them as `s.X`.
const $5b19704bcd88fb8b$export$df6f33015f82810e = {
    tag: 'g',
    attr: {
        'data-connection-from': (el, s)=>s.from,
        'data-connection-to': (el, s)=>s.to,
        'data-shared-count': (el, s)=>Array.isArray(s.shared) ? String(s.shared.length) : '0'
    },
    title: (el, s)=>Array.isArray(s.shared) && s.shared.length > 0 ? `Shared teams: ${s.shared.join(', ')}` : '',
    style: {
        cursor: 'pointer',
        pointerEvents: 'visiblePainted'
    },
    HitArea: {
        tag: 'path',
        attr: {
            d: (el, s)=>typeof s.getPath === 'function' ? s.getPath(s.root, s.from, s.to, el) : '',
            stroke: 'transparent',
            'stroke-width': '14',
            fill: 'none',
            'pointer-events': 'stroke',
            'vector-effect': 'non-scaling-stroke'
        },
        onClick: (e, el, s)=>{
            if (typeof s.onSelect === 'function') s.onSelect(e, el, s);
        },
        onMouseenter: (e, el, s)=>{
            if (typeof s.onHover === 'function') s.onHover(e, el, s, true);
        },
        onMouseleave: (e, el, s)=>{
            if (typeof s.onHover === 'function') s.onHover(e, el, s, false);
        }
    },
    Visible: {
        tag: 'path',
        attr: {
            d: (el, s)=>typeof s.getPath === 'function' ? s.getPath(s.root, s.from, s.to, el) : '',
            stroke: (el, s)=>{
                if (typeof s.getStroke === 'function') return s.getStroke(s.root, s);
                return 'rgba(255,255,255,0.5)';
            },
            'stroke-width': (el, s)=>{
                if (typeof s.getStrokeWidth === 'function') return String(s.getStrokeWidth(s.root, s));
                return '1.5';
            },
            'stroke-dasharray': (el, s)=>{
                if (typeof s.getDash === 'function') return s.getDash(s.root, s) || '0';
                return '0';
            },
            fill: 'none',
            'pointer-events': 'none',
            'vector-effect': 'non-scaling-stroke',
            'stroke-linecap': 'round'
        }
    }
};

});

parcelRegister("3Tgki", function(module, exports) {

$parcel$export(module.exports, "TransportModeBtn", () => $2d532c3c73b46318$export$387cbfbdfffbdfd6);
$parcel$export(module.exports, "AuthModeBtn", () => $2d532c3c73b46318$export$d8eaf47ea8b703ae);
$parcel$export(module.exports, "MCPConnectorPickerBody", () => $2d532c3c73b46318$export$b2541e03d70a3e22);
// MCPConnectorPickerBody — first-class MCP connector creation modal.
//
// @symbo.ls/windows body-only modal (migrated 2026-06-10 with its sibling
// integration/library/new-project pickers — same recipe). Openers seed the
// draft then `el.call('openModal', { id: 'mcpConnectorPicker', template:
// 'custom', width: '510px', content: { extends: 'MCPConnectorPickerBody' },
// onClose: <clear draft> })`. This also un-dangles the /studio create-menu
// trigger — the old fixed overlay was only mounted on the project canvas
// (CanvasEditor) and the admin page, never on /studio.
// Root state contract:
//   root._mcpConnectorDraft       object  — form draft state
//   root._mcpConnectorSaving      boolean — in-flight flag
//
// On submit: calls el.call('saveMcpConnector', draft) — registered by the
// host page. Server discovers capabilities (tools/list + resources/list)
// and caches in the capabilities jsonb column.
//
// Design tokens and v3.14 syntax per CLAUDE.md:
//   - No raw CSS values — all tokens.
//   - Flat props access. Event handlers: onClick, onInput, onRender, onDestroy.
//   - placeholder: directly on input elements (no attr wrapper).
//   - Reactive CSS uses prop functions: background: (el, s) => ...
//   - State flag naming mirrors _genericIntFormOpen / _genericIntDraft.
const $2d532c3c73b46318$var$_DRAFT_KEY = '_mcpConnectorDraft';
// Derive a default connector name from a URL (hostname without www).
const $2d532c3c73b46318$var$_nameFromUrl = (url)=>{
    try {
        const host = new URL(url).hostname.replace(/^www\./, '');
        return host.charAt(0).toUpperCase() + host.slice(1);
    } catch  {
        return '';
    }
};
// Toast helper — mirrors IntegrationConfigureForm pattern.
const $2d532c3c73b46318$var$_toast = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (err) {
        console.warn('[mcp-connector]', payload.title, payload.message || '', err);
    }
};
// Submit handler. Delegates to registered project function 'saveMcpConnector'.
const $2d532c3c73b46318$var$_canvasSubmit = async (el, s)=>{
    const draft = s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY] || {};
    if (!draft.url) {
        $2d532c3c73b46318$var$_toast(el, {
            title: el.call('polyglot', 'canvas.mcp.error.urlRequiredTitle'),
            message: el.call('polyglot', 'canvas.mcp.error.urlRequiredMessage'),
            type: 'error'
        });
        return;
    }
    s.root.update({
        _mcpConnectorSaving: true
    });
    try {
        await el.call('saveMcpConnector', draft);
        s.root.update({
            [$2d532c3c73b46318$var$_DRAFT_KEY]: null,
            _mcpConnectorSaving: false
        });
        el.call('closeModal', 'mcpConnectorPicker');
        $2d532c3c73b46318$var$_toast(el, {
            title: el.call('polyglot', 'canvas.mcp.connected').replace('{name}', draft.name || $2d532c3c73b46318$var$_nameFromUrl(draft.url)),
            type: 'success'
        });
        // Reload connector list if host exposes a loader.
        try {
            await el.call('reloadMcpConnectors');
        } catch  {}
    } catch (err) {
        s.root.update({
            _mcpConnectorSaving: false
        });
        $2d532c3c73b46318$var$_toast(el, {
            title: el.call('polyglot', 'canvas.mcp.error.connectFailedTitle'),
            message: err?.message || el.call('polyglot', 'canvas.mcp.error.unknown'),
            type: 'error'
        });
    }
};
// ── Transport mode buttons ────────────────────────────────────────────────────
const $2d532c3c73b46318$var$_transportModes = [
    'sse',
    'websocket',
    'http'
];
const $2d532c3c73b46318$var$_transportLabels = {
    sse: 'SSE',
    websocket: 'WebSocket',
    http: 'HTTP'
};
const $2d532c3c73b46318$export$387cbfbdfffbdfd6 = {
    tag: 'button',
    type: 'button',
    minHeight: 'controlHCompact',
    padding: '0 Z',
    round: 'radiusPill',
    fontSize: 'Y2',
    fontWeight: '700',
    cursor: 'pointer',
    'aria-pressed': (el, s)=>{
        const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.transport || 'sse') === s._mode;
        return String(active);
    },
    'aria-label': (el, s)=>`Transport: ${s._label || s._mode || ''}`,
    // Fill-contrast segmented control (was a static `line` border on every
    // mode, border-habit sweep, design-direction.md §8). Inactive rest was
    // `transparent` (the outlined-ghost habit, since the border was its only
    // boundary) — now `overlay` + a hover wash, same conversion as
    // IntegrationScopeModeBtn. Active keeps the existing `blue` fill.
    background: (el, s)=>{
        const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.transport || 'sse') === s._mode;
        return active ? 'blue' : 'overlay';
    },
    color: (el, s)=>{
        const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.transport || 'sse') === s._mode;
        return active ? 'white' : 'title';
    },
    ':hover': {
        background: (el, s)=>{
            const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.transport || 'sse') === s._mode;
            return active ? 'blue' : 'hover';
        }
    },
    text: (el, s)=>s._label || '',
    onClick: (e, el, s)=>{
        s.root.update({
            [$2d532c3c73b46318$var$_DRAFT_KEY]: {
                ...s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY] || {},
                transport: s._mode
            }
        });
    }
};
// ── Auth kind mode buttons ────────────────────────────────────────────────────
const $2d532c3c73b46318$var$_authModes = [
    'none',
    'bearer',
    'api-key',
    'oauth'
];
const $2d532c3c73b46318$var$_authLabels = {
    none: 'None',
    bearer: 'Bearer',
    'api-key': 'API key',
    oauth: 'OAuth'
};
const $2d532c3c73b46318$export$d8eaf47ea8b703ae = {
    tag: 'button',
    type: 'button',
    minHeight: 'controlHCompact',
    padding: '0 Z',
    round: 'radiusPill',
    fontSize: 'Y2',
    fontWeight: '700',
    cursor: 'pointer',
    'aria-pressed': (el, s)=>{
        const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authKind || 'none') === s._mode;
        return String(active);
    },
    'aria-label': (el, s)=>`Authentication: ${s._label || s._mode || ''}`,
    // Fill-contrast segmented control — same conversion as TransportModeBtn
    // above (border-habit sweep, design-direction.md §8).
    background: (el, s)=>{
        const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authKind || 'none') === s._mode;
        return active ? 'blue' : 'overlay';
    },
    color: (el, s)=>{
        const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authKind || 'none') === s._mode;
        return active ? 'white' : 'title';
    },
    ':hover': {
        background: (el, s)=>{
            const active = (s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authKind || 'none') === s._mode;
            return active ? 'blue' : 'hover';
        }
    },
    text: (el, s)=>s._label || '',
    onClick: (e, el, s)=>{
        s.root.update({
            [$2d532c3c73b46318$var$_DRAFT_KEY]: {
                ...s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY] || {},
                authKind: s._mode
            }
        });
    }
};
const $2d532c3c73b46318$export$b2541e03d70a3e22 = {
    // Body-only: the windows ModalWindow owns positioning, backdrop, ESC and
    // the header Close (brand ModalHeader delegate). onClose passed by the
    // openers clears the draft on every dismiss path.
    flow: 'y',
    gap: 'Z1',
    textAlign: 'start',
    ModalHeader: {
        Hgroup: {
            H: {
                text: '{{ canvas.mcp.title | polyglot }}'
            },
            P: {
                text: '{{ canvas.mcp.subtitle | polyglot }}'
            }
        },
        Icons: {
            // Brand ModalHeader pulls this group into the corner with a negative
            // right margin and adds horizontal group padding. Keep the vertical
            // alignment while lining the visible X up with the content below.
            margin: '-Y2 0 - auto',
            padding: '0',
            Close: {
                padding: 'Y2 0 Y2 Y2'
            }
        }
    },
    // One-click pre-fill for Symbols MCP — the primary novel design element.
    // Background cerulean.1 (cerulean accent per design brief).
    SymbolsMcpSuggest: {
        tag: 'button',
        type: 'button',
        flow: 'x',
        gap: 'Z',
        align: 'center',
        minHeight: 'controlHCompact',
        padding: '0 Z',
        round: 'radiusPill',
        background: 'cerulean.1',
        color: 'cerulean',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'cerulean',
        fontSize: 'Y2',
        fontWeight: '700',
        cursor: 'pointer',
        title: (el)=>el.call('polyglot', 'canvas.mcp.suggest.title'),
        Icon: {
            tag: 'span',
            text: "\u26A1",
            fontSize: 'Y2'
        },
        Label: {
            tag: 'span',
            text: '{{ canvas.mcp.suggest.label | polyglot }}',
            fontSize: 'Y2'
        },
        Hint: {
            tag: 'span',
            text: 'mcp.symbols.app',
            fontSize: 'Y1',
            color: 'cerulean',
            opacity: '0.75'
        },
        onClick: (e, el, s)=>{
            s.root.update({
                [$2d532c3c73b46318$var$_DRAFT_KEY]: {
                    ...s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY] || {},
                    url: 'https://mcp.symbols.app',
                    name: 'Symbols MCP',
                    transport: 'sse',
                    authKind: 'oauth'
                }
            });
        }
    },
    // ── Name field ──────────────────────────────────────────────────────
    NameField: {
        flow: 'y',
        gap: 'V',
        NameLabel: {
            tag: 'label',
            for: 'mcp-connector-name',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: '{{ canvas.mcp.field.name | polyglot }}'
        },
        NameInput: {
            tag: 'input',
            id: 'mcp-connector-name',
            type: 'text',
            width: '100%',
            minHeight: 'controlH',
            padding: '0 Z2',
            round: 'radiusControl',
            theme: 'field',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: (el)=>el.call('polyglot', 'canvas.mcp.field.namePlaceholder'),
            value: (el, s)=>s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.name || '',
            // Imperatively sync DOM input.value on every render so controlled-input
            // reactivity works in v3.14 (state-driven value updates are not automatically
            // reflected by the browser's input.value property without an explicit write).
            onRender: (el, s)=>{
                if (el.node && document.activeElement !== el.node) el.node.value = s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.name || '';
            },
            onInput: (e, el, s)=>{
                s.root.update({
                    [$2d532c3c73b46318$var$_DRAFT_KEY]: {
                        ...s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY] || {},
                        name: e.target.value
                    }
                });
            }
        }
    },
    // ── URL field ───────────────────────────────────────────────────────
    UrlField: {
        flow: 'y',
        gap: 'V',
        UrlLabel: {
            tag: 'label',
            for: 'mcp-connector-url',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: '{{ canvas.mcp.field.url | polyglot }}'
        },
        UrlInput: {
            tag: 'input',
            id: 'mcp-connector-url',
            type: 'url',
            width: '100%',
            minHeight: 'controlH',
            padding: '0 Z2',
            round: 'radiusControl',
            theme: 'field',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            // An example URL, not copy.
            placeholder: 'https://mcp.symbols.app',
            value: (el, s)=>s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.url || '',
            // Imperatively sync DOM input.value on every render so controlled-input
            // reactivity works in v3.14 (state-driven value updates are not automatically
            // reflected by the browser's input.value property without an explicit write).
            onRender: (el, s)=>{
                if (el.node && document.activeElement !== el.node) el.node.value = s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.url || '';
            },
            onInput: (e, el, s)=>{
                const url = e.target.value;
                const draft = s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY] || {};
                // Auto-derive name from URL if the user hasn't set one yet.
                const autoName = draft.name || $2d532c3c73b46318$var$_nameFromUrl(url);
                s.root.update({
                    [$2d532c3c73b46318$var$_DRAFT_KEY]: {
                        ...draft,
                        url: url,
                        name: autoName
                    }
                });
            }
        }
    },
    // ── Transport picker ────────────────────────────────────────────────
    TransportField: {
        flow: 'y',
        gap: 'V',
        TransportLabel: {
            tag: 'label',
            id: 'mcp-transport-label',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: '{{ canvas.mcp.field.transport | polyglot }}'
        },
        TransportModes: {
            flow: 'x',
            gap: 'Z',
            role: 'group',
            'aria-labelledby': 'mcp-transport-label',
            childExtends: 'TransportModeBtn',
            childrenAs: 'state',
            children: $2d532c3c73b46318$var$_transportModes.map((m)=>({
                    _mode: m,
                    _label: $2d532c3c73b46318$var$_transportLabels[m]
                }))
        }
    },
    // ── Auth kind picker ────────────────────────────────────────────────
    AuthField: {
        flow: 'y',
        gap: 'V',
        AuthLabel: {
            tag: 'label',
            id: 'mcp-auth-label',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: '{{ canvas.mcp.field.auth | polyglot }}'
        },
        AuthModes: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            role: 'group',
            'aria-labelledby': 'mcp-auth-label',
            childExtends: 'AuthModeBtn',
            childrenAs: 'state',
            children: $2d532c3c73b46318$var$_authModes.map((m)=>({
                    _mode: m,
                    _label: $2d532c3c73b46318$var$_authLabels[m]
                }))
        }
    },
    // ── Auth token input (visible for bearer/api-key) ───────────────────
    AuthTokenField: {
        flow: 'y',
        gap: 'V',
        hide: (el, s)=>{
            const kind = s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authKind || 'none';
            return kind !== 'bearer' && kind !== 'api-key';
        },
        TokenLabel: {
            tag: 'label',
            for: 'mcp-connector-auth-token',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            text: (el, s)=>{
                const kind = s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authKind || 'none';
                return kind === 'bearer' ? 'Bearer token' : 'API key';
            }
        },
        TokenInput: {
            tag: 'input',
            id: 'mcp-connector-auth-token',
            type: 'password',
            width: '100%',
            minHeight: 'controlH',
            padding: '0 Z2',
            round: 'radiusControl',
            theme: 'field',
            borderWidth: 'hairline',
            borderStyle: 'solid',
            borderColor: 'line',
            color: 'title',
            fontSize: 'Z2',
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
            value: (el, s)=>s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authToken || '',
            onRender: (el, s)=>{
                if (el.node && document.activeElement !== el.node) el.node.value = s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY]?.authToken || '';
            },
            onInput: (e, el, s)=>{
                s.root.update({
                    [$2d532c3c73b46318$var$_DRAFT_KEY]: {
                        ...s.root?.[$2d532c3c73b46318$var$_DRAFT_KEY] || {},
                        authToken: e.target.value
                    }
                });
            }
        }
    },
    // ── Scope picker — reuses IntegrationScopePicker verbatim ───────────
    IntegrationScopePicker: {
        draftKey: $2d532c3c73b46318$var$_DRAFT_KEY,
        defaultScopeType: 'workspace'
    },
    // ── Actions row ─────────────────────────────────────────────────────
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-end',
        marginTop: 'Z',
        CancelBtn: {
            tag: 'button',
            type: 'button',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            // Ghost fill (was `transparent` + `line` outline — the outlined-button
            // habit, border-habit sweep, design-direction.md §8). Rest = `overlay`,
            // hover = the house `hover` wash — same conversion as
            // AiActionConfirmCard's RejectBtn (wave 1 precedent).
            background: 'overlay',
            color: 'title',
            fontSize: 'Z2',
            cursor: 'pointer',
            ':hover': {
                background: 'hover'
            },
            text: '{{ canvas.mcp.cancel | polyglot }}',
            onClick: (e, el, s)=>{
                s.root.update({
                    [$2d532c3c73b46318$var$_DRAFT_KEY]: null
                });
                el.call('closeModal', 'mcpConnectorPicker');
            }
        },
        ConnectBtn: {
            tag: 'button',
            type: 'button',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            // A fixed brand-hue plate (no `theme:`), so the ink is fixed too — and it is
            // the brand `fillInk` (near-black), not white. White on a raw brand hue read
            // under the 4.5:1 floor in BOTH themes (blue 3.62, red 3.21, green 2.81);
            // near-black reads 5.66 / 6.39 / 7.28. Nika's decision 2026-09-21
            // (treatment 3, design-direction.md §6).
            background: 'blue',
            color: 'fillInk',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            border: 'none',
            disabled: (el, s)=>!!s.root?._mcpConnectorSaving,
            text: (el, s)=>el.call('polyglot', s.root?._mcpConnectorSaving ? 'canvas.mcp.connecting' : 'canvas.mcp.connect'),
            onClick: async (e, el, s)=>{
                await $2d532c3c73b46318$var$_canvasSubmit(el, s);
            }
        }
    }
};

});

parcelRegister("eSU6Y", function(module, exports) {

$parcel$export(module.exports, "CanvasPromptTextarea", () => $ad61a26507ba656c$export$99d37c5a2e6ee365);
// Bare shared-library import, not per-file deep functions/components subpaths
// — a per-file deep specifier into @symbo-ls/workspace-shared cannot resolve
// through the platform's public importmap (tickets/execution-board.md §1,
// same fix as workspace/app.js). Deferred call/getter wrappers, not a
// module-scope destructure, per the a5d0a2aa barrel-cycle lesson.

var $1X0Je = parcelRequire("1X0Je");

var $9GdJK = parcelRequire("9GdJK");
const $ad61a26507ba656c$var$installKeyboardAvoidance = (...args)=>(0, $1X0Je.default).functions.installKeyboardAvoidance(...args);
const $ad61a26507ba656c$var$getHeaderIslandMinHeight = ()=>(0, $1X0Je.default).components.HEADER_ISLAND_MIN_HEIGHT;
// A touch screen — the shell's registered capability switch (shared/functions/
// pointerCapability.js `isCoarsePointer`: the coarse primary pointer, or touch
// points). False in a host that registers none (the composer then keeps the
// desktop pill). A JS read, not an '@coarse' block, on purpose: the pill's
// geometry lives in the reactive `.isSmall` / size props, which the live shell
// applies inline, and a nested media block there did not reliably re-attach on
// a size flip (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1).
const $ad61a26507ba656c$var$_touchScreen = (el)=>{
    const fn = el && el.context && el.context.functions && el.context.functions.isCoarsePointer;
    return typeof fn === 'function' && !!fn();
};
// Content-reference mention machinery (shared/functions/mentionRefs.js —
// the AI-composer mirror of chat's trigger grammar; see its header).
const $ad61a26507ba656c$var$_detectMentionRefTrigger = (...a)=>(0, $1X0Je.default).functions.detectMentionRefTrigger(...a);
const $ad61a26507ba656c$var$_mentionRefSyncOptions = (...a)=>(0, $1X0Je.default).functions.mentionRefSyncOptions(...a);
const $ad61a26507ba656c$var$_fetchMentionRefOptions = (...a)=>(0, $1X0Je.default).functions.fetchMentionRefOptions(...a);
const $ad61a26507ba656c$var$_mentionRefRowLabel = (...a)=>(0, $1X0Je.default).functions.mentionRefRowLabel(...a);
// THE house keyboard model for menus (shared/functions/menuKeyboard.js — the
// same helpers the AI model switcher, the AI settings panel and the assistant
// Sessions menu use). Deferred wrappers, never a module-scope destructure,
// per the a5d0a2aa barrel-cycle lesson above.
const $ad61a26507ba656c$var$_menuArrowNav = (...a)=>(0, $1X0Je.default).functions.menuArrowNav(...a);
const $ad61a26507ba656c$var$_menuActivateRow = (...a)=>(0, $1X0Je.default).functions.menuActivateRow(...a);
const $ad61a26507ba656c$var$_armNamedMenuFocus = (...a)=>(0, $1X0Je.default).functions.armNamedMenuFocus(...a);
const $ad61a26507ba656c$var$_releaseMenuFocus = (...a)=>(0, $1X0Je.default).functions.releaseMenuFocus(...a);
const $ad61a26507ba656c$var$_restoreMenuFocus = (...a)=>(0, $1X0Je.default).functions.restoreMenuFocus(...a);
// THE pre-send key model of this composer — the attach-menu arrow branch and
// the whole mention-picker traversal (shared/functions/aiComposerKeys.js).
// It lives in shared, not here, because the SHELL mounts this component and
// REPLACES `Textarea.onKeydown` at the mount site (workspace/app.js): both
// mounts delegate to this one function, so a branch can never exist on one
// mount and be missing on the other.
const $ad61a26507ba656c$var$_aiComposerKeydown = (...a)=>(0, $1X0Je.default).functions.aiComposerKeydown(...a);
const $ad61a26507ba656c$var$_applyAiMention = (...a)=>(0, $1X0Je.default).functions.applyAiMentionPick(...a);
// ── the '+' attach menu's focus lifecycle lives at its CALL SITES ─────────
// (2026-09-02, after the first cut of this wiring shipped dead.)
//
// `AttachMenu` is `if:`-gated, and smbls fires NO lifecycle hook on an
// if-gated element's open or close edge:
//   • an element whose `if:` is false at creation returns from `create()`
//     inside the `if (!ref.__if)` branch — BEFORE the
//     `triggerLifecycle('Render' | 'Create' | 'Complete')` calls further down
//     (smbls/packages/element/src/create.js);
//   • `registerIfEffect`'s first-activation branch rebuilds the node and
//     queues `onMounted`, but never Render/Create/Complete, and its
//     re-activation branch only re-attaches the existing node — no hook at all;
//   • the close edge is a bare `element.node.remove()` with no `dispose()`,
//     and `onRemove` only ever fires from `dispose()`.
// So `onRender: focusOnOpen` / `onRemove: focusBack` on this panel were both
// unreachable: the menu opened correctly and focus never entered it, at every
// open including the first. (Filed for the framework separately — the sibling
// menus in this pass are all always-mounted panels whose `onRender` +
// `subscribeTo`/`onUpdate` hooks DO fire, so this panel was the only casualty.)
//
// The fix is not a retry: whoever flips `attachOpen` IS the edge, so it arms
// the panel's focus directly. The reach is `armNamedMenuFocus` (shared) —
// `el.lookup('AttachMenu')` resolves the panel from anywhere in the composer,
// because `create()` publishes an if-hidden child on its parent under its own
// key and `lookup` checks each ancestor's named children. The SHELL's mount of
// this composer overrides `Textarea.onKeydown` wholesale
// (workspace/app.js CanvasPromptTextarea > Textarea), so it calls the same
// shared helper — one implementation, two call sites, no drift.
const $ad61a26507ba656c$var$_attachPanelOf = (el)=>el && typeof el.lookup === 'function' ? el.lookup('AttachMenu') : null;
const $ad61a26507ba656c$var$_armAttachFocus = (el, opts)=>$ad61a26507ba656c$var$_armNamedMenuFocus(el, 'AttachMenu', opts);
// ONE PANEL AT A TIME (finding 3 of the 2026-10-01 frames): the "+" menu is this composer's LOCAL `attachOpen`, but
// the AI focus panel (shared SimoneSuggestions) yields to it through the ROOT (`_promptMenuOpen`, read beside the
// dropdown layer's `_dropdownLayer` — design-d2 8673ce440). Every site that flips `attachOpen` goes through here, so
// the mirror can never drift from the menu; the composer's unmount clears a mirror left up.
const $ad61a26507ba656c$var$_attachUpdate = (s, patch)=>{
    s.update(patch);
    const root = s && s.root;
    const open = !!s.attachOpen;
    if (root && typeof root.update === 'function' && !!root._promptMenuOpen !== open) root.update({
        _promptMenuOpen: open
    }, {
        preventFetch: true
    });
};
// Human-readable file size for a dropped-file chip's tooltip + the context
// line _sendPrompt appends to the prompt body. No registered `formatBytes`
// reaches this project (chat's usage of it resolves through the WORKSPACE
// project's own functions/formatUtils.js — chat is mounted inside the
// workspace shell's context, not a sibling package; canvas's own
// sharedLibraries.js doesn't list workspace), so this is a small local
// formatter rather than duplicating a cross-package dependency that doesn't
// actually reach here.
const $ad61a26507ba656c$var$_fmtBytes = (n)=>{
    if (n == null || Number.isNaN(n)) return '';
    if (n < 1024) return `${n} B`;
    if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / 1048576).toFixed(1)} MB`;
};
// Internal helper — read the textarea draft + any dropped/pasted
// files/refs/images from state and dispatch freestyleSend. Used by both the
// CircleButton onClick and the Textarea onKeydown Enter path. Reads/clears
// via state (no el.node.value access) to comply with FA511.
const $ad61a26507ba656c$var$_sendPrompt = (el)=>{
    const st = el.state;
    const draft = (st && st.draft || '').trim();
    const files = st && st.files || [];
    const refs = st && st.refs || [];
    // state.images (dropped/pasted/uploaded pictures) used to be read nowhere
    // in this function at all — they sat in the gallery, never reached
    // freestyleSend, and were never even cleared on send. Now read + included
    // like files/refs below (see the freestyleSend attachments param + its
    // header comment in freestyleBridge.js for exactly what does/doesn't
    // happen to them once sent).
    const images = st && st.images || [];
    if (!draft && !files.length && !refs.length && !images.length) return;
    // Build mode (root._aiBuildMode, the '+' menu toggle): the send runs the
    // addapp build pipeline instead of the freestyle answer path —
    // forceBuildApp sends headlessly and its watcher opens the generated
    // page as a PageSlot overlay when the output lands. Attachments stay in
    // the composer (the build pipeline carries text only today).
    const root = el.state && el.state.root;
    if (root && root._aiBuildMode && draft) try {
        el.call('forceBuildApp', draft);
        // the emptied draft re-measures through the framework (see _resetTextareaAutosize)
        if (st && st.update) st.update({
            draft: ''
        });
        return;
    } catch (_) {
    /* fall through to the normal send when no host registers the fn */ }
    // freestyleSend (freestyleBridge.js) ships `{type:'user_message', text,
    // context, attachments}` over the local-agent WebSocket. `attachments` is a
    // real structured field that DOES reach the bridge process — but the
    // receiving side doesn't forward it to the agent yet (framework-owned, see
    // freestyleSend's header comment). Until that lands, a readable context
    // line is the only thing guaranteed to reach the agent, so every
    // attachment ALSO gets one here, same treatment refs/files already get:
    // refs use the shared dragRefToText markdown-link format (the agent gets a
    // working deep link back to the ticket/project/page), files/images surface
    // name/type/size only — never raw bytes in the TEXT body (images' actual
    // bytes ride the separate `attachments` array below instead).
    const contextLines = [
        ...refs.map((ref)=>el.call('dragRefToText', ref)),
        ...files.map((f)=>`[Attached file: ${f.name} (${f.mime}, ${$ad61a26507ba656c$var$_fmtBytes(f.size)})]`),
        ...images.map((img)=>`[Attached image: ${img.name} (${img.mime}, ${$ad61a26507ba656c$var$_fmtBytes(img.size)})]`)
    ];
    const body = contextLines.length ? [
        draft,
        ...contextLines
    ].filter(Boolean).join('\n') : draft;
    const attachments = images.map((img)=>({
            name: img.name,
            mime: img.mime,
            size: img.size,
            dataUrl: img.dataUrl
        }));
    // ONE send, ONE generation: the prompt goes to the agent and nowhere else
    // (Nika 2026-10-28 — the parallel blind page generator that a "create/build"
    // prompt used to start beside it is gone).
    el.call('freestyleSend', body, attachments);
    // No hand height clear: the framework re-measures the emptied draft on this
    // state write (set 10 — see _resetTextareaAutosize).
    if (st && st.update) st.update({
        draft: '',
        files: [],
        refs: [],
        images: []
    });
};
// Clears the autoGrow HEIGHT pin before a SIZE FLIP. The framework's
// `autoGrow` owns content growth in the small AND normal states (see the
// Textarea's `autoGrow`) and writes an inline px `height`. `s.size` flipping
// between small/normal/large (Expand/Minimize/fullscreen-toggle below) would
// leave the PREVIOUS state's px height on the node — an inline style always
// wins over the new state's floor, the "textarea autogrow vs [state] race" the
// voice-UX sweep this file landed with flagged by name (the settle's fit,
// below, then measures the new state frame by frame).
//
// NOT on a send (2026-10-02). A send empties the draft through state, and
// framework set 10 (smbls 3.14.818 / element 3.14.794) re-measures on that
// state write — measured live on dev (composer-heights matrix): an emptied
// draft settles at 39 px in the pill and at the E2 floor expanded, and a
// draft written through state grows to its content. The send's old hand clear
// was worse than redundant: landing after the framework's measure, it dropped
// the textarea to the brand Textarea's class height (E1, 153 px) — an empty
// pill four rows tall.
//
// ONLY `height`, NEVER `minHeight` (2026-09-29 per Nika "when we expand
// canvaschattextarea and start typing it shrinks the height"). The inline
// min-height IS the framework's reactive size floor (small auto / normal E2
// / large 75dvh), and its effect re-runs on a size change only: a clear here
// — a send from the expanded composer — left the box at one row under its
// own floor until the next size change. This component no longer writes
// a min-height anywhere, so there is no stale one to clear.
//
// Resolves the textarea NODE the same way the original send-time reset did
// (keydown passes the Textarea element itself; a toolbar button reaches it
// through the composer node) — walking the element graph for `.Textarea`
// silently no-ops here (verified live 2026-07-24 — the handler's `el`
// resolves children differently than the devtools element ref).
const $ad61a26507ba656c$var$_resetTextareaAutosize = (el)=>{
    const node = el.node;
    const taNode = node && node.tagName === 'TEXTAREA' && node || node?.closest?.('[data-key="CanvasPromptTextarea"]')?.querySelector?.('textarea') || el.parent?.node?.querySelector?.('textarea');
    if (taNode && taNode.style) taNode.style.height = '';
};
// The size-change settle (2026-09-02 per Nika "fix why after expand,
// minimize of promptTextarea does not get correct size"; THE FIT since
// 2026-09-29, design-d2's review of the expand/type fix). The pre-update
// _resetTextareaAutosize alone is sequenced wrong: the update then re-runs
// the `autoGrow` factory, whose framework resize writes a fresh
// `style.height = scrollHeight + 'px'` measured under the OLD cascade — the
// min-height floor and the paddings are still at their start values when a
// size flip begins, and they ease for the whole B step. That stale pixel
// height is inline, so it outranks the new state's floor.
//
// THE FIT, the same step on every frame from the click through 420 ms (the
// B morph and its settle), and once more by timer at 420 ms — a hidden tab
// runs no frames: collapse the height to `auto`, read the content
// (scrollHeight), and pin it ONLY when the content is taller than the box
// the easing floor gives it (clientHeight); otherwise leave `auto`, so the
// floor carries the box. A multi-line draft therefore never drops below its
// start or end height: Expand grows it with the easing paddings, Minimize
// shrinks it to the pill's content height, Exit fullscreen follows the floor
// down and stops on the content. Two older shapes, both measured, and why
// they are gone:
//   • a plain first-frame CLEAR + a 420 ms re-pin (2026-09-02 to 09-29):
//     with `height` out of the Textarea's transition list both steps are
//     instant, so a draft taller than one row dipped to one row and jumped
//     back at 420 ms (design-d2's model, E2 162 px, B 200 ms: Expand a
//     5-line pill 141 → 47 → 162 → 189; Minimize 10 lines 317 → 38.5 → 268;
//     Exit fullscreen 902 → 162 → 317);
//   • ALWAYS pinning scrollHeight mid-morph (before 2026-09-02): the read
//     was floored by the still-large box, so the pin froze a shrink.
// The fit writes `height` and nothing else — never the min-height floor (the
// framework's inline write, see the Textarea's `minHeight`), never 0 px (a
// node without layout reads 0, which is not taller than 0, so it keeps
// `auto`).
const $ad61a26507ba656c$var$_settleTextareaSize = (el)=>{
    const taOf = ()=>{
        const node = el.node;
        return node && node.tagName === 'TEXTAREA' && node || node?.closest?.('[data-key="CanvasPromptTextarea"]')?.querySelector?.('textarea') || el.parent?.node?.querySelector?.('textarea');
    };
    const fit = ()=>{
        const taNode = taOf();
        if (!taNode || !taNode.style) return;
        taNode.style.height = 'auto';
        const h = taNode.scrollHeight;
        if (h > taNode.clientHeight) taNode.style.height = h + 'px';
    };
    const until = Date.now() + 420;
    const frame = ()=>{
        fit();
        if (Date.now() < until) $ad61a26507ba656c$var$_raf(frame);
    };
    $ad61a26507ba656c$var$_raf(frame);
    setTimeout(fit, 420);
};
// ── Mention typeahead driver (2026-09-02 per Nika "it could be also
// mentioned by @ ++ # and etc just like we have in chat") ─────────────────
// Runs on every input: detect a trigger at the caret (plain-text textarea —
// value + selectionStart), resolve options (person/channel synchronously
// from root state; ticket/event/reference via the shared SDK fetchers), and
// hold the picker on the COMPOSER's own state (`mentionPicker`) — never a
// root key, so the standalone canvas host takes no undeclared-root-key
// writes. The dropdown + keyboard nav read the same state.
const $ad61a26507ba656c$var$_refreshAiMention = (el, s)=>{
    const node = el.node;
    if (!node || typeof node.selectionStart !== 'number') return;
    const trig = $ad61a26507ba656c$var$_detectMentionRefTrigger(node.value || '', node.selectionStart);
    if (!trig) {
        if (s.mentionPicker) s.update({
            mentionPicker: null
        });
        return;
    }
    const base = {
        type: trig.type,
        query: trig.query,
        start: trig.start,
        end: trig.end,
        activeIndex: 0
    };
    const sync = $ad61a26507ba656c$var$_mentionRefSyncOptions(trig.type, trig.query, s.root);
    if (sync) {
        s.update({
            mentionPicker: {
                ...base,
                options: sync
            }
        });
        return;
    }
    // Async types: open empty (position settles), fill when the fetch lands —
    // guarded against a stale response (type/query moved on).
    s.update({
        mentionPicker: {
            ...base,
            options: []
        }
    });
    $ad61a26507ba656c$var$_fetchMentionRefOptions(trig.type, trig.query).then((opts)=>{
        const cur = el.state && el.state.mentionPicker;
        if (!cur || cur.type !== trig.type || cur.query !== trig.query) return;
        el.state.update({
            mentionPicker: {
                ...cur,
                options: opts
            }
        });
    }).catch(()=>{});
};
// Applying a picked option (splice the insert text over the [start, end)
// trigger span, close the picker, restore the caret) is `applyAiMentionPick`
// in shared/functions/aiComposerKeys.js — aliased as `_applyAiMention` at the
// top of this file. It moved there with the key model it serves, so the shell
// mount's overridden keydown reaches the SAME implementation this file's
// dropdown rows use.
// rAF that survives a windowless runtime (bun test, bypass mode) — a bare
// requestAnimationFrame reference THROWS there, which turned a picker
// Enter into an aborted handler in the suite. Falls to a 16ms tick.
const $ad61a26507ba656c$var$_raf = (fn)=>typeof requestAnimationFrame === 'function' ? requestAnimationFrame(fn) : setTimeout(fn, 16);
// T18 — is THIS composer the live voice host? True while voice is open and
// root.voiceHost names the canvas prompt (the VoiceBtn below writes it before
// voicePttPress — full contract in shared/components/VoiceStrip.js; the
// voiceMinimized axis is deliberately ignored while a composer hosts). Every
// voice-hosting hide/if gate and the height/maxHeight factories read this
// one predicate.
const $ad61a26507ba656c$var$_voiceHosting = (s)=>!!(s && s.root && s.root.voiceOpen && s.root.voiceHost === 'canvas');
// THE MODE CHIP STANDS DOWN WHERE THE HOME'S TABS ARE THE MODE (Nika
// 2026-10-23: "instead of [fly,dashboard,agent] rename [Main, Dashboard, Chat,
// Present, Build] … so therefore we might be able to remove dropdown from
// chatpromptarea on canvas and only keep in sidebar and other places"): both
// chip mounts — the pill's `Prefix` and the row's `AssistantModeChip` — hide
// while the home's tabs are on screen (the shell's workspace
// functions/homeView.js homeTabsOnScreen: the home itself, no pane over it).
// A mount's `hide` REPLACES the kit chip's own, so its rule is restated
// first: no mode writer here, no chip (the chip's scope reader, guarded — a
// host without the kit chip has none). The sidebar's chip and the composer's
// focus panel keep the mode switch; every other route keeps this chip.
const $ad61a26507ba656c$var$_modeChipHidden = (el, s)=>{
    const offered = !!el && !!el.scope && typeof el.scope.modeChipOffered === 'function' && !!el.scope.modeChipOffered(el, s);
    const fns = el && el.context && el.context.functions;
    const tabs = !!fns && typeof fns.homeTabsOnScreen === 'function' && !!el.call('homeTabsOnScreen', s && s.root);
    return !offered || tabs;
};
const $ad61a26507ba656c$export$99d37c5a2e6ee365 = {
    extends: 'PromptTextarea',
    // FA204 / frank trap — SIZES used to be a bare module-scope object read
    // via bracket access (`SIZES[s.size]`) from inside the height/maxHeight
    // reactive factories below; it silently resolves to `undefined[...]`
    // (a throw, not just a dropped value) once this component is
    // frank.toJSON'd for platform delivery — the same
    // project_frank_drops_module_local_helpers class every VoiceOverlay/
    // VoiceControls/VoiceLog/VoiceStrip sibling in this file family has
    // already been swept for. Moved into scope, read via `el.scope.SIZES`.
    // the "+" menu's root mirror never outlives the composer (see _attachUpdate)
    onRemove: (el, s)=>{
        if (s && s.root && s.root._promptMenuOpen && typeof s.root.update === 'function') s.root.update({
            _promptMenuOpen: false
        }, {
            preventFetch: true
        });
    },
    scope: {
        // Per-size layout tokens. Width stays static at H across all three
        // states so the chrome doesn't reflow horizontally when expanding/
        // collapsing — only the vertical dimensions change.
        SIZES: {
            small: {
                height: 'auto',
                maxHeight: 'auto'
            },
            normal: {
                height: 'auto',
                maxHeight: '35dvh'
            },
            large: {
                height: '75dvh',
                maxHeight: '75dvh'
            }
        }
    },
    // Labeled complementary landmark: the composer floats at the shell root,
    // OUTSIDE every page landmark, so its content (Textarea, FreestyleThinking)
    // tripped axe `region` ("content not contained by landmarks") on every
    // route — MARKETPLACE-AUDIT residue, tickets/fable.md 2026-08-09. A
    // landmark role (not a widget role) never presentational-izes children,
    // and the unique label keeps `landmark-unique` clean. Same aria+attr
    // idiom as the file's ExpandBtn/SendBtn labels.
    role: 'complementary',
    aria: {
        label: (el)=>el.call('polyglot', 'canvas.prompt.aria')
    },
    pointerEvents: 'auto',
    // Always a horizontal flex row (2026-06-08 per Nika "the flex is off,
    // its children should be horizontal"). Previously ONLY the conditional
    // `.isSmall` class set `flow: 'x'`; the moment that class didn't apply
    // — a reactive-class timing hiccup on the global shell-mounted home
    // instance, or any non-small size — the card fell back to
    // `display: block`, dropping the textarea + toolbar + send out of
    // their horizontal row (they stacked). A STATIC `flow` (not a reactive
    // factory — only static `flow` compiles to the `display:flex` classes
    // at create time; a factory just writes an inert style) guarantees
    // `display:flex; flex-direction:row` in EVERY state. Safe for the
    // expanded canvas composer too: there the toolbar + send are all
    // `position:absolute`, so the lone in-flow textarea simply fills the
    // row and the absolute buttons overlay exactly as before.
    flow: 'x',
    state: {
        size: 'small',
        images: [],
        draft: '',
        files: [],
        refs: [],
        dragOver: false,
        mentionPicker: null,
        attachOpen: false,
        buildArmed: false
    },
    position: 'absolute',
    bottom: 'X2',
    // Center horizontally: anchor both edges at 50% then pull back by half
    // the element's own width. Using `transform` (vs `left:0;right:0;margin:auto`)
    // keeps centering correct as the width animates between size states.
    left: '50%',
    // Horizontal centering (translateX) is combined with the virtual-keyboard
    // lift (translateY) in a SINGLE transform — two `transform` keys can't
    // coexist. `--kbd-inset` defaults to 0px (published by keyboardAvoidance.js on
    // focus) so this is an exact no-op on desktop and whenever the soft keyboard
    // is down; on iPad it raises the whole composer just above the keyboard. The
    // card's transition below names `transform` beside the size morph, so the
    // lift eases in on the same line — no second, size-animation-clobbering
    // transition line.
    transform: 'translateX(-50%) translateY(calc(-1 * var(--kbd-inset, 0px)))',
    zIndex: 10,
    // F2 — UNDER EVERY MODAL (current-2a 2026-09-28; the audit: "the composer
    // (z-index 1400) stays bright and clickable above the dimmed page behind
    // EVERY modal; its textarea takes focus outside the dialog"). The shell
    // mounts this composer as a fixed layer at 1400 — over the PageSlot window
    // (1300) on purpose — so a modal inside a page or a window, painting in THAT
    // layer's stacking context, could never lay its veil over it. The composer
    // answers "is a modal open" itself, from the kit's own markup: an AppDialog
    // or legacy Modal root carries [data-open] while open and its dialog carries
    // aria-modal="true" (a view stating data-open="false", the assistant board,
    // never counts). While one is open the composer drops to its own base z (10:
    // over the page, under the window backdrop (20), every modal veil and the
    // PageSlot sheet) and takes no pointer; both kits trap Tab in the dialog.
    // A declarative :has() rule — no listener, no state flag to keep in step.
    ':root:has([data-open]:not([data-open="false"]) [aria-modal="true"]) &': {
        zIndex: '10',
        pointerEvents: 'none'
    },
    // The home composer is the header's twin: the skins' `pill` theme
    // (HOME_AMBIENT_SKIN_SPEC §1, DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-
    // WHITELABEL-1) — the navbar glass in the solid skin, the card glass in
    // the ambient one. No border: the longhand zero stays from the
    // canvas-card-glass days (a base's border must not come back).
    theme: 'pill',
    borderWidth: '0',
    // THE CARD IS NOT A BACKDROP ROOT (dropdowns spec §7.2, measured live on dev 2ffb10c23): the `pill` theme puts
    // its blur ON this card, and an element with a backdrop-filter is a backdrop root for everything inside it —
    // the AI focus dropdown above (PromptBand -> SimoneSuggestions) then blurred only this card's own empty
    // surface and showed the page sharp through its glass. The card keeps the pill fill and ink; the SAME skin
    // blur moves to a layer under the content (the card is its own stacking context: position + zIndex), so the
    // card still frosts the page behind it and the dropdown's own glass reaches the page too.
    backdropFilter: 'none',
    '::before': {
        content: '""',
        position: 'absolute',
        inset: '0',
        borderRadius: 'inherit',
        zIndex: '-1',
        pointerEvents: 'none',
        backdropFilter: 'var(--theme-pill-backdropFilter)'
    },
    minHeight: 'auto',
    boxSize: 'auto',
    // MUST stay visible: PromptGallery (dropped refs/files) and
    // FreestyleThinking both float ABOVE this card via position:absolute +
    // bottom:100% — i.e. entirely OUTSIDE this element's box. A root
    // `overflow: hidden` (the founding value) clipped every pixel of both:
    // a dropped ticket ref updated state, laid out at full size, and showed
    // nothing (live-measured 2026-08-06: rect 493×32 at bottom:100%,
    // opacity 1, zero paint). Scroll clipping belongs to the inner boxes,
    // which already own it (textarea + history list).
    overflow: 'visible',
    // THE MOTION, NAMED (DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1):
    // the size morph between small / normal / large — height, max-height,
    // min-height, width, min-width, padding, the capsule round — and the
    // keyboard lift (transform), on the B step. Never `all`: with `all` a skin
    // stamp that landed after first paint EASED the fill and the blur from the
    // solid pill to the ambient glass (measured on /files at 390, bad4186b3)
    // while the header pills beside it snapped. A skin or a scheme is a
    // surface, not a state change — fill, blur, ink, opacity and shadow snap.
    transition: "B height defaultBezier, B max-height defaultBezier, B min-height defaultBezier, B width defaultBezier, B min-width defaultBezier, B padding defaultBezier, B border-radius defaultBezier, B transform defaultBezier",
    // Size states swap `auto` for a token (card maxHeight auto→35dvh, the
    // Textarea's minHeight auto→E2 / height auto→100%). A transition cannot
    // interpolate to or from `auto`, so `B all` above animated ONLY the
    // paddings and radii while the box itself SNAPPED: measured live
    // 2026-09-02, 39px→124px at t=0 on Expand, paddings creeping for the
    // next 200ms (per Nika "fix canvasprompttextarea expand/minimize
    // animation"). `interpolate-size: allow-keywords` (CSS Values 5) makes
    // the auto↔length pairs interpolable, so the same `B all` now carries
    // the height too; engines without it keep today's snap. Inline `style`
    // (the AppPage.js precedent): css-in-props has no prop for it yet — FW
    // ticket FW-CSS-IN-PROPS-INTERPOLATE-SIZE-PROP-1.
    style: {
        interpolateSize: 'allow-keywords'
    },
    // Base width H (~524px) — shared footprint with the collapsed pill
    // (`.isSmall` minWidth below matches). The `large` composer widens to
    // `I` via the `.isLarge` conditional class — NOT a reactive `width`
    // factory: reactive LAYOUT props (width/flow) don't re-apply on a state
    // change in v3.14 (computed once at mount), whereas a conditional class
    // toggles a real className reactively, the same mechanism `.isSmall`
    // relies on.
    //
    // MUST be a bare spacing token, NOT `calc(var(--spacing-X) * N)`:
    // smbls' atomic CSS generator emits an EMPTY rule for a calc() width
    // string (`._w-<hash> { }` with no declaration), so the width silently
    // never applies and the element falls back to its ~344px content width.
    // That footgun is exactly why every multiplier tweak this session was a
    // no-op. Bare tokens (`G1`, `I`, …) compile to a real `width: var(--…)`
    // rule. Step the token to resize (G1 400 / G2 424 / G3 448 / H 524).
    width: 'H',
    // While the voice strip hosts (T18) the expanded card heights would leave a
    // mostly-empty 35/75dvh shell around a one-line strip — collapse to content
    // height for the hosting duration; the size state itself is untouched.
    height: (el, s)=>$ad61a26507ba656c$var$_voiceHosting(s) ? 'auto' : el.scope.SIZES[s.size].height,
    maxHeight: (el, s)=>$ad61a26507ba656c$var$_voiceHosting(s) ? 'auto' : el.scope.SIZES[s.size].maxHeight,
    '@mobileL': {
        left: 'A',
        right: 'A',
        bottom: 'A',
        width: 'auto',
        minWidth: '0',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        // Full-width at this breakpoint (left/right A), so no translateX centering —
        // but the keyboard lift still applies (phones raise a keyboard too).
        transform: 'translateY(calc(-1 * var(--kbd-inset, 0px)))'
    },
    // Connect to the local-agent bridge on mount. Idempotent — reconnects
    // automatically with a 2.5s backoff (see functions/freestyleBridge.js).
    onInit: (el)=>{
        // Publish --kbd-inset so the translateY above tracks the soft keyboard on
        // touch devices. Idempotent singleton — the chat composer installs the same
        // one; calling from both is safe.
        $ad61a26507ba656c$var$installKeyboardAvoidance();
        el.call('freestyleConnect');
        // Plain instance counter (NOT state — purely internal bookkeeping, never
        // rendered) tracking native dragenter/dragleave nesting depth across the
        // composer's descendants. See onDragenter/onDragleave below for why a
        // counter is required instead of a single boolean.
        //
        // A DIRECT property on the element, not `el.scope.*`: `scope` is a
        // declared DOMQL feature, not a general-purpose bag, and it is undefined
        // on this component — writing through it threw
        // "Cannot set properties of undefined (setting 'dragDepth')" out of
        // onDrop, which killed the whole drop path before it read anything
        // (verified live in the console). Same instance-property technique as
        // ContextDropdown's `_ddSize`.
        el._dragDepth = 0;
    },
    // Drag-and-drop attach — drop image file(s), any OTHER file, or a dragged
    // Symbols entity ref (ticket / project / project page / file — the shared
    // contract in shared/functions/dragRef.js) anywhere on the composer.
    //
    // Three payload shapes land in three different state buckets:
    //   - image files → state.images (data URL, rendered as a thumbnail — the
    //                    original behaviour, unchanged)
    //   - other files  → state.files (name/type/size ONLY — see the onDrop
    //                    comment below for why bytes are never read)
    //   - entity refs  → state.refs (the ref object itself)
    //
    // onDragenter/onDragover MUST preventDefault for a recognised drag (Files,
    // or our custom ref MIME) so the browser accepts the drop instead of
    // navigating to / opening the dragged content. hasDragFiles/hasDragRef are
    // TYPES-based checks (shared/functions/dragRef.js) — DataTransfer protected
    // mode blocks getData() until drop, but `types` is always readable, which is
    // why gating happens on types here; the actual ref/file payload is only
    // read in onDrop. A small (pill) composer does NOT expand on drop — the
    // PromptGallery floats above the composer in every size, so the dropped
    // thumbnail/chip is visible without resizing anything.
    //
    // dragDepth (a plain instance prop, NOT state — see onInit) implements the standard
    // enter/leave counter: moving onto a DESCENDANT (Textarea, PromptButtons,
    // …) fires a dragleave-on-parent + dragenter-on-child pair that both bubble
    // to these handlers (neither is stopped anywhere in the tree), so a naive
    // boolean would flip off while the pointer is still over the composer.
    // Counting nesting depth and only toggling the reactive `dragOver` state
    // flag at the 0⇄1 transition keeps the drop affordance (`isDragOver` /
    // `.isDragOver` below) stable for the whole hover, in every size.
    // Declared ref-drop target (shared/functions/dragRef.js REF_DROP_ATTR):
    // pointer-drag sources (the tickets board) hit-test for this attribute on
    // pointerup and deliver their ref through the native onDrop below via a
    // synthetic DragEvent — attach instead of committing their own move.
    'data-ref-drop': 'prompt',
    onDragenter: (e, el, s)=>{
        if (!(el.call('hasDragFiles', e) || el.call('hasDragRef', e))) return;
        e.preventDefault();
        el._dragDepth = (el._dragDepth || 0) + 1;
        if (!s.dragOver) s.update({
            dragOver: true
        });
    },
    onDragover: (e, el)=>{
        if (!(el.call('hasDragFiles', e) || el.call('hasDragRef', e))) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
    },
    onDragleave: (e, el, s)=>{
        el._dragDepth = Math.max(0, (el._dragDepth || 0) - 1);
        if (el._dragDepth === 0 && s.dragOver) s.update({
            dragOver: false
        });
    },
    onDrop: (e, el, s)=>{
        el._dragDepth = 0;
        if (s.dragOver) s.update({
            dragOver: false
        });
        // Entity ref first — a Symbols source (ticket/project/page/file card)
        // stamped this via el.call('setDragRef', …); readDragRef only resolves on
        // drop (protected mode) and returns null for any other kind of drag, so
        // falling through to the file handling below is always safe.
        const ref = el.call('readDragRef', e);
        if (ref) {
            e.preventDefault();
            const key = `${ref.kind}:${ref.id}`;
            const existing = s.refs || [];
            if (existing.some((r)=>r.key === key)) return;
            s.update({
                refs: [
                    ...existing,
                    {
                        ...ref,
                        key: key
                    }
                ]
            });
            return;
        }
        const files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        // MUST preventDefault as soon as we know we're handling this drop. The
        // previous image-only version deferred preventDefault until AFTER
        // filtering to images, so dropping a non-image file (0 images matched)
        // skipped preventDefault entirely and the browser fell through to its
        // native default action for an un-prevented drop — navigating the tab to
        // the dropped file — losing the whole canvas.
        e.preventDefault();
        const isImage = (f)=>!!(f && f.type && f.type.indexOf('image') !== -1);
        const imgs = Array.prototype.filter.call(files, isImage);
        const others = Array.prototype.filter.call(files, (f)=>!isImage(f));
        if (imgs.length) // Capture name/mime/size alongside the data URL — matches the `files`
        // bucket's shape (`{key, name, mime, size}`) below, and is what lets
        // _sendPrompt describe an attached image in the prompt's text context
        // instead of silently dropping it (see that function's comment).
        Promise.all(imgs.map((file)=>new Promise((res)=>{
                const reader = new FileReader();
                reader.onloadend = ()=>res({
                        file: file,
                        dataUrl: reader.result
                    });
                reader.readAsDataURL(file);
            }))).then((results)=>{
            const existingImages = s.images || [];
            const additions = [];
            for (const { file: file, dataUrl: dataUrl } of results){
                if (!dataUrl) continue;
                const key = `${file.name}:${file.size}:${file.lastModified}`;
                if (existingImages.some((ex)=>ex.key === key)) continue;
                if (additions.some((ex)=>ex.key === key)) continue;
                additions.push({
                    key: key,
                    name: file.name,
                    mime: file.type || 'image/*',
                    size: file.size,
                    dataUrl: dataUrl
                });
            }
            if (additions.length) s.update({
                images: [
                    ...existingImages,
                    ...additions
                ]
            });
        });
        if (others.length) {
            // Metadata only — NOT a data URL. Unlike images (see the imgs.length
            // branch above), non-image files have no bridge-side consumer even in
            // principle today — freestyleSend's `attachments` field is read by
            // nothing downstream yet for ANY kind (see its header comment), and
            // reading a large drop (a 50MB PDF) into a base64 data URL would just
            // burn memory for a payload nothing will use. name/type/size is enough
            // to surface the file as real context text on send.
            const existingFiles = s.files || [];
            const additions = [];
            for(let i = 0; i < others.length; i++){
                const f = others[i];
                const key = `${f.name}:${f.size}:${f.lastModified}`;
                if (existingFiles.some((ex)=>ex.key === key)) continue;
                if (additions.some((ex)=>ex.key === key)) continue;
                additions.push({
                    key: key,
                    name: f.name,
                    mime: f.type || 'application/octet-stream',
                    size: f.size
                });
            }
            if (additions.length) s.update({
                files: [
                    ...existingFiles,
                    ...additions
                ]
            });
        }
    },
    isSmall: (el, s)=>s.size === 'small',
    '.isSmall': {
        flow: 'x',
        align: 'center start',
        gap: '0',
        padding: '0',
        // Resting pill = a chrome island: share the header islands' exact gauge
        // (HEADER_ISLAND_MIN_HEIGHT, the HeaderLeft/Tabs/Right minHeight) and
        // their round family (radiusPill, the IconNavbar/HeaderTabs pill round)
        // instead of a content-driven ~3px-shorter bar on PromptTextarea's card
        // round (radiusCard). radiusPill clamps to the same capsule today, but
        // keeps capsule parity with the pills if the bar ever grows past the
        // card round's clamp range (iPad, 2026-08-01 per Nika "canvas prompt
        // textarea not consistent with others"). Expanded sizes keep the
        // inherited card round — a pill radius on the 35dvh card would clip the
        // Z-inset corner buttons under overflow:hidden.
        //
        // ON A TOUCH SCREEN THE PILL IS A 44pt TARGET (DESIGN-SHELL-RESPONSIVE-IOS-
        // SAFARI-1; decided 2026-10-05: 'make the composer pill 44 px on touch
        // screens', desktop unchanged). The 36px gauge left a 33px field: a tap a
        // little above or below the text missed it on a phone. On touch the pill
        // floors at `controlH` and its field grows to fill it (the Textarea's own
        // vertical inset, below), so the whole pill between its buttons is the
        // field.
        minHeight: (el)=>$ad61a26507ba656c$var$_touchScreen(el) ? 'controlH' : $ad61a26507ba656c$var$getHeaderIslandMinHeight(),
        boxSize: 'auto',
        minWidth: 'H',
        '@mobileL': {
            minWidth: '0',
            width: 'auto'
        }
    },
    // Capsule round only while the minimized pill is ONE line (2026-09-02 per
    // Nika "fix round when minimized ai textarea has multiple lines - make
    // max round just like it has on expanded"). `.isSmall` used to pin
    // radiusPill (999px) unconditionally; the browser clamps that to half the
    // box height — right for the one-line resting pill, but as the
    // small-state autoGrow grows the box with a multi-line draft, the 999px
    // kept clamping to half of an ever-taller box and the capsule turned into
    // a stadium/oval. The pill round now lives in ITS OWN conditional class
    // gated on single-line content, so the multi-line pill simply INHERITS
    // the brand PromptTextarea card round — the exact radius the expanded
    // sizes show (no new radius literal here, per the design-language lock).
    // The newline test re-evaluates on every draft update; the line-height
    // probe catches wrapped long lines with no newline in them.
    // THE WRAP PROBE IS A LAYOUT READ, and a conditional class is re-read on
    // EVERY render pass of this element — including passes that have nothing to
    // do with the composer. `clientHeight` + `getComputedStyle` in the middle of
    // a pass flush style and layout for the whole page: MEASURED on dev
    // 2026-10-02 (/w/vault/default, Chrome MCP) at 204 ms on a loaded box and
    // 33-38 ms on a quiet one — one of three full relayouts the first board
    // submit paid for before its skeleton reached the DOM
    // (DESIGN-WL-ASSISTANT-BOARD-SUBMIT-BLOCKS-THE-MAIN-THREAD-FOR-A-SECOND-1).
    // So the probe answers from the draft wherever the draft already decides it,
    // and measures at most ONCE per draft:
    //   • an EMPTY box is one line — exact, no measurement (this is the submit
    //     case: the send clears the draft, so every submit used to re-measure);
    //   • a draft with a newline is multi-line — exact, as before;
    //   • anything else keeps the last verdict for that exact draft, answered
    //     before the node is touched, so an unrelated pass reads nothing. A
    //     keystroke is still measured — the only thing that re-wraps the line.
    isPillRound: (el, s)=>{
        if (s.size !== 'small') return false;
        const draft = s.draft || '';
        if (/\n/.test(draft)) return false;
        if (!draft) return true;
        const kept = el.__pillRoundFor;
        if (kept && kept.draft === draft) return kept.round;
        const ta = el.node && el.node.querySelector && el.node.querySelector('textarea');
        // ONE read of the box, not two: `clientHeight` is a layout read, and the
        // guard and the line test both used to ask for it.
        const box = ta ? ta.clientHeight : 0;
        if (!box) return true;
        const lh = parseFloat(window.getComputedStyle(ta).lineHeight);
        const round = !(lh && box > lh * 1.6);
        el.__pillRoundFor = {
            draft: draft,
            round: round
        };
        return round;
    },
    '.isPillRound': {
        round: 'radiusPill',
        // The line pill's centring, declared HERE as well as in .isSmall's
        // `align`: a case that turns off clears the inline keys it owns, and a
        // still-on case (.isSmall) is not re-run to put its value back
        // (FW-ELEMENT-CASE-TURN-OFF-CLEARS-A-STILL-ON-CASES-KEY-1). On the small
        // pill .isPillRound is the exact complement of .isPillWrapped, so the two
        // flip in the same flush and this one re-writes `center` — live on dev
        // a0d036b a cleared wrapped draft (every long send) left `align-items:
        // normal`: the send 0px from the pill's top, 3.1px from its bottom.
        alignItems: 'center'
    },
    // A WRAPPED PILL keeps its controls on its bottom line (Nika 2026-10-18,
    // "improve UI of chat textarea"): a draft that wraps grows the small pill
    // around the text, and the row's centre alignment left the mode chip and
    // the buttons floating at the middle of the grown box (measured live: a
    // 191px pill, controls at its centre). Anchored to the bottom, `X` above
    // the edge — the same inset the chip keeps from the start and send from the
    // end — they stay where the eye left them, like the expanded composer's
    // docked row. Reads isPillRound's kept verdict for this exact draft (no
    // second layout read); the exec fallback covers a pass that reads this case
    // first.
    isPillWrapped: (el, s)=>{
        if (s.size !== 'small') return false;
        const draft = s.draft || '';
        if (!draft) return false;
        if (/\n/.test(draft)) return true;
        const kept = el && el.__pillRoundFor;
        if (kept && kept.draft === draft) return !kept.round;
        if (!el || typeof el.call !== 'function') return false;
        return !el.call('exec', el.isPillRound, el);
    },
    '.isPillWrapped': {
        alignItems: 'flex-end',
        paddingBottom: 'X'
    },
    // `large` widens the prompt a little (G1 → I) via a conditional class
    // (reliable across the size change — see the width comment above).
    isLarge: (el, s)=>s.size === 'large',
    '.isLarge': {
        width: 'I',
        minWidth: 'I',
        '@mobileL': {
            width: 'auto',
            minWidth: '0',
            height: '58dvh',
            maxHeight: '58dvh'
        }
    },
    // Drop affordance while a recognised drag (file or entity ref) is over the
    // composer, in EVERY size (independent of .isSmall/.isLarge, which only
    // touch width/round — this block composes fine alongside either).
    //
    // Fill-contrast, not a ring (design-direction.md §8 — borders/outlines are
    // banned outright, separation is fill contrast alone; the only sanctioned
    // stroke is the dashed inactive-state ring, and a drag target is an ACTIVE
    // state, which the same law spells out as a SOLID fill, never a stroke).
    // `selected` — the SAME semantic "this is engaged" wash VoiceBtn.isActive
    // and CvSelectionChip already use in this exact file, not a bespoke hue:
    // a raw `blue.12` here was caught by the raw-hue-ink lock
    // (shared/__tests__/designLanguageLocks.scan.js, Rule 69 — a raw CHROMATIC
    // hue as background needs a semantic reach first) and reusing the house
    // active-state token is BOTH the fix and the better call — the composer's
    // "something is engaged here" language now reads identically whether it's
    // voice or a drop target, one grammar instead of two.
    isDragOver: (el, s)=>!!s.dragOver,
    '.isDragOver': {
        background: 'selected'
    },
    // ── THE BAND — one owner of the strip above the composer card (O1, opus.md).
    // Before: four absolutely-positioned siblings (PromptGallery, SelectionChips,
    // FreestyleThinking, FreestyleStatus) + the shell's position:fixed
    // SimoneSuggestions all fought for the same strip in three visual grammars.
    // Now ONE positioned band holds the awareness bar and the suggestion row as
    // ORDERED children: image thumbnails (bytes never leave the browser — the bar
    // labels them "not sent") · AiContextBar (scope line + focus/attached chips,
    // one grammar) · SimoneSuggestions (in-flow here, no longer fixed over the
    // composer). Still anchored bottom:100% so the composer's own rect — which
    // the shell's --prompt-clear ResizeObserver measures — is unchanged.
    PromptBand: {
        position: 'absolute',
        bottom: '100%',
        left: '0',
        right: '0',
        marginBottom: 'Y',
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        pointerEvents: 'none',
        // Children take pointer events back; the band itself must not eat clicks
        // on whatever sits behind its empty area.
        childProps: {
            pointerEvents: 'auto'
        },
        ImageThumbs: {
            show: (el, s)=>(s.images || []).length > 0,
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            children: (el, s)=>(s.images || []).map((img)=>({
                        key: img.key,
                        tag: 'img',
                        src: img.dataUrl,
                        title: img.name
                    })),
            childProps: {
                boxSize: 'D',
                round: 'radiusCard',
                objectFit: 'cover',
                background: 'overlay'
            }
        },
        // The AI ISLAND — ONE glass surface unifying the scope line, the
        // awareness chips (it hosts AiContextBar itself, scope-line off) and the
        // suggestion capsules (2026-08-26 per Nika "unify suggestions and
        // path"). Focus-gated paint, composer width, in-flow. The band no
        // longer mounts AiContextBar separately — the island owns the whole
        // strip except the image thumbs above.
        SimoneSuggestions: {}
    },
    VoiceStrip: {
        hostKey: 'canvas',
        minHeight: ()=>$ad61a26507ba656c$var$getHeaderIslandMinHeight()
    },
    // THE PILL'S MODE CHIP — ONE row: [mode chip] [textarea] [send] (the
    // anatomy agreed with the dropdowns lane, 2026-10-01). DOMQL mounts children
    // in the MERGED key order and the brand PromptTextarea's keys come first, so
    // the chip fills the brand's leading slot `Prefix` (brand 3.14.801, design-
    // d2's 5934886): DOM order = screen order = Tab order — never a CSS `order`.
    // (With an older brand there is no slot and the key mounts after the
    // inherited Textarea: still reachable, just later.) It is the kit chip
    // (`extends`: the key names no component) in its compact form (glyph +
    // caret, "Mode: <mode>"); it shows only in the small pill — the normal /
    // large composer keeps the chip first in its docked button row below, and
    // that one stands down in the pill. Each still hides itself without the
    // mode writer (no mount-site gate).
    // ONE TRIGGER FOR CONTEXT + MODE (Nika 2026-10-07: "merge two dashboard and
    // context switcher dropdowns into one in aipropttextarea"): both chip mounts
    // ask the kit for its merged form (`withContext`) — the glyph plate, the
    // context's short name, the caret; one menu, Context then Mode. The context
    // pill that sat after the text (AiScopePill) is gone. Without the shell's
    // context readers the chip stays the compact mode chip.
    Prefix: {
        extends: 'AssistantModeChip',
        withContext: true,
        // the home's tabs are the mode there (see `_modeChipHidden`)
        hide: (el, s)=>$ad61a26507ba656c$var$_modeChipHidden(el, s),
        // A mount-site class object REPLACES the kit chip's own, so its
        // `isCompact` (the glyph + caret form) is restated here — compact only
        // where no context is named (the merged form shows the context's name).
        // The kit's reader is guarded: a host that mounts this composer without
        // the kit chip registered has no such scope method, and a throw here
        // broke the whole composer (canvasPromptExpandedFloor, 10 tests).
        class: {
            // Not while the call strip hosts: the bar is the call then, and the
            // chip's context and mode say nothing about it.
            isPillSlot: (el, s)=>s.size === 'small' && !$ad61a26507ba656c$var$_voiceHosting(s),
            isCompact: (el, s)=>s.size === 'small' && !(el.scope && typeof el.scope.modeChipContextRow === 'function' && el.scope.modeChipContextRow(el, s))
        },
        display: 'none',
        '&.isPillSlot': {
            display: 'flex'
        },
        flexShrink: '0',
        marginLeft: 'X'
    },
    Textarea: {
        // Hidden (not unmounted) while the voice strip hosts this composer — a
        // reactive `hide` on a mounted-open child, the UploadBtn precedent.
        hide: (el, s)=>$ad61a26507ba656c$var$_voiceHosting(s),
        // Return-to-typing entrance, symmetric with VoiceStrip's own
        // `animation: 'fadeInUpShort'` — see that file's comment for why an
        // `animation` (not `transition`) is the fix for a display:none-gated
        // swap. Plain `fadeIn` (opacity only, no rise) here: this is the
        // familiar "home" state reappearing, not a new surface arriving, so a
        // quieter entrance than the strip's is the right asymmetry.
        animation: 'fadeIn',
        minWidth: (el, s)=>s.size === 'small' ? 'auto' : '100%',
        resize: 'none',
        rows: 1,
        // App composer is a chat input, not the landing hero: the brand
        // PromptTextarea centers text at @mobileM (≤560px) for the marketing
        // page — on iPhone that centered the "Whats up?" placeholder
        // (2026-08-02 per Nika "make whats up align left"). Left at every
        // width here; the landing keeps its own centering. The hero's phone
        // padding stands down here too — see the '@mobileL' block below.
        textAlign: 'left',
        '@mobileM': {
            textAlign: 'left',
            padding: null
        },
        // Focus mirror for the SimoneSuggestions focus-gated chips (2026-08-06
        // per Nika — chips show on focus, not as a standing overlay). Blur
        // clears on a 250ms delay so a chip click (blur fires at its
        // pointerdown, the click ~100-150ms later) still sees the flag up;
        // refocus within the window cancels the clear.
        onFocus: (e, el, s)=>{
            if (el.parent && el.parent._blurT) {
                clearTimeout(el.parent._blurT);
                el.parent._blurT = null;
            }
            if (s.root && !s.root._promptFocused) s.root.update({
                _promptFocused: true
            });
            // A fresh focus brings back a panel put away (shared functions/
            // aiPanelFocus.js: Escape writes the flag AFTER handing focus here).
            if (s.root && s.root._aiPanel === 'dismissed') s.root.update({
                _aiPanel: null
            }, {
                preventFetch: true
            });
        },
        // The focus panel's way in, said to assistive technology: ↑ in an empty
        // field opens it (shared functions/aiComposerKeys.js).
        ariaDescription: (el)=>el.call('polyglot', 'ai.panel.fieldHint'),
        onBlur: (e, el, s)=>{
            const host = el.parent;
            if (!host) return;
            if (host._blurT) clearTimeout(host._blurT);
            host._blurT = setTimeout(()=>{
                host._blurT = null;
                if (s.root && s.root._promptFocused) s.root.update({
                    _promptFocused: false
                });
                // Close the mention picker on a settled blur — the 250ms window is
                // exactly what lets a dropdown-row click land first (its
                // onPointerdown preventDefault keeps focus in most cases; this is
                // the belt for the ones where it doesn't).
                if (s.mentionPicker) s.update({
                    mentionPicker: null
                });
            }, 250);
        },
        // Bind value to state.draft so _sendPrompt reads/clears via state (FA511).
        value: (el, s)=>s.draft || '',
        // No `height` factory (2026-09-29, design-d2's review): `height` has ONE
        // owner — the framework's `autoGrow` below, with `_settleTextareaSize`
        // fitting it through a size flip. The old `small ? 'auto' : '100%'`
        // factory was a second writer whose value never survived: autoGrow
        // re-measured it away in small/normal, and in `large` the 75dvh
        // min-height floor already fills the 75dvh card.
        // `auto` in every size (2026-10-01, the composer-heights matrix): the
        // pill's `hidden` clipped a draft past the max-height cap (12 lines at
        // 1440: 265 px shown of 299) with NO way to scroll to the rest — and a
        // height the autosize did not re-measure (a programmatic draft, a width
        // change) clipped the same way. Below the cap autoGrow pins the exact
        // content height, so no scrollbar shows.
        overflow: 'auto',
        // THE SIZE MORPH, NAMED — `height` left out on purpose (2026-09-29).
        // `height` belongs to `autoGrow` below, which collapses the box to
        // `auto` and reads `scrollHeight` in the SAME tick. Under the `B all`
        // this line used to be, that write started a height transition, and a
        // transitioning height (interpolate-size makes auto interpolable) still
        // holds its OLD value at that read: the measure was floored by the
        // current box, so the box could grow but never shrink (measured on
        // dev.my: the small pill 39→140 px on five lines, still 140 px after
        // deleting every line). A size flip changes min-height, max-height,
        // min-width, the paddings and flex-grow on this box — those keep the B
        // step, so Expand/Minimize is the same motion; content growth is
        // instant, like any chat input. Named, never `all`: a skin switch does
        // not ease this ink either (the card's own law, above).
        transition: "B min-height defaultBezier, B max-height defaultBezier, B min-width defaultBezier, B padding defaultBezier, B flex-grow defaultBezier",
        // Same interpolate-size opt-in as the card (see its comment): this is
        // the box whose minHeight auto↔E2 actually drives the card's height.
        style: {
            interpolateSize: 'allow-keywords'
        },
        // THE FLOOR. `normal` E → E2 (2026-09-02 per Nika "when expanded, make
        // it a little bit taller"): one step up the spacing scale, 162 px live.
        // `large` stays on its viewport fraction. A reactive factory, so the
        // framework writes it INLINE and re-writes it on a size change only —
        // no project code may write or clear this box's min-height. The old
        // normal/large onInput growth cleared it on every keystroke: expand,
        // type one character, and the card fell from 162 px to one row
        // (2026-09-29 per Nika "when we expand canvaschattextarea and start
        // typing it shrinks the height").
        minHeight: (el, s)=>({
                small: 'auto',
                normal: 'E2',
                large: '75dvh'
            })[s.size],
        maxHeight: (el, s)=>({
                small: '35dvh',
                normal: '35dvh',
                large: '75dvh'
            })[s.size],
        // Content growth is the framework's declarative `autoGrow` (reactive
        // form — tickets/fable.md "no declarative primitive for textarea
        // auto-grow"), armed in `small` AND `normal`: its input listener sets
        // height to the content's scrollHeight, and the cascade bounds it — the
        // `minHeight` floor above (auto / E2) and the `maxHeight` cap (35dvh).
        // It writes `height` only, so the floor survives every keystroke and a
        // shrinking draft returns the box to the floor, never below it. `large`
        // is a fixed 75dvh box that scrolls, so it stays disarmed. On a size
        // change the factory re-runs: leaving for `large` DISARMS and clears the
        // behavior's own inline height; coming back re-arms and re-measures.
        autoGrow: (el, s)=>s.size !== 'large',
        // THE PLACEHOLDER NEVER SIZES THE BOX. An EMPTY textarea's scrollHeight
        // includes its placeholder laid out across lines: measured live on dev
        // 63151a91f, a placeholder wider than the field took the empty pill from
        // 37 px to 132-156 px, and `autoGrow` pins exactly that scrollHeight —
        // the "weird heights" of an empty composer (any language, any size,
        // whenever the shown line is wider than the field: before the measured
        // fit runs on the first render, a field that narrowed, a late font).
        // One line, never wrapped: the empty box is one row tall in every case.
        // Not a cut: the line is chosen to fit the field
        // (shared functions/assistantModePlaceholder.js assistantModePlaceholderFit).
        '::placeholder': {
            whiteSpace: 'nowrap'
        },
        // NEVER STRETCHED BY THE CARD (2026-10-01, the composer-heights matrix).
        // The card is a flex ROW whose only in-flow child is this textarea, and a
        // row stretches its items to its own height. autoGrow reads scrollHeight
        // with `height: auto` — on a stretched item that is the CARD's height, not
        // the text's — and writes it back: measured live on 1a2612ab9 at 614 px,
        // an EMPTY normal composer read 219 px with `height: auto` (7.2 lines)
        // while the same box with no stretch measured 144 px (its E2 floor). A
        // box that writes back its own stretched size can only keep it or grow.
        // `flex-start` takes the card out of the measure: the height is the text
        // + padding, bounded by the min-height floor and the max-height cap.
        alignSelf: 'flex-start',
        // The resting pill's field: `Y` above and below on a desktop (the 36px
        // header gauge), `Z1` on a touch screen — a 20.8px line + 2 x 12.2px fills
        // the 44pt pill (the card's `.isSmall` floor) in proportion, text centred
        // (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1). The expanded sizes keep theirs.
        paddingTop: (el, s)=>s.size === 'small' ? $ad61a26507ba656c$var$_touchScreen(el) ? 'Z1' : 'Y' : 'A',
        paddingBottom: (el, s)=>s.size === 'small' ? $ad61a26507ba656c$var$_touchScreen(el) ? 'Z1' : 'Y' : 'C',
        paddingLeft: (el, s)=>s.size === 'small' ? 'A' : 'A',
        paddingRight: (el, s)=>s.size === 'small' ? 'A' : 'A2',
        // Match the global Search input's text size (1.0625rem) so the prompt
        // and the header search read at exactly the same size (2026-06-09 per
        // Nika "set same size to text to Search and CanvasPromptTextarea").
        // Fixed, not size-reactive — they should match in every prompt state.
        fontSize: '1.0625rem',
        // A typed draft in the title ink: the field's inherited text ink
        // (rgba(0,0,0,.65)) read like its placeholder (rgb(85,85,93)). The
        // placeholder keeps its own rule.
        color: 'title',
        flexGrow: (el, s)=>s.size === 'small' ? '1' : undefined,
        // THE SIZE FACTORIES ABOVE OWN THE PADDING AT EVERY WIDTH. The brand
        // PromptTextarea pads its hero field `B B - B` at @mobileL and `D B - B`
        // at @mobileM. A media block that states a property this element writes
        // inline (the reactive longhands above, shorthand family included) is
        // emitted `!important` by the framework, so on a phone the hero padding
        // beat the pill's: measured on dev 2026-10-18 at 390 px, the field padded
        // 67.8 / 25.9 / 6.1 px, the open composer stood 95 px tall and its text
        // sat under the mode chip and the buttons (Nika: "it looks too big and
        // ugly now"). `null` keeps the inherited declaration out — this
        // component's key wins the extends merge and a CSS block skips a null.
        '@mobileL': {
            fontSize: '1rem',
            minWidth: '0',
            padding: null
        },
        onInput: (e, el, s)=>{
            // Persist the draft to state so _sendPrompt can read it without touching el.node.
            s.update({
                draft: e.target.value
            });
            // Mention typeahead — after the draft write so the picker's splice
            // math and the state body agree (see _refreshAiMention).
            $ad61a26507ba656c$var$_refreshAiMention(el, s);
        // No height work here, in any size: the declarative `autoGrow` above
        // owns content growth through its own input listener, and the
        // `minHeight` floor and `maxHeight` cap bound it. The normal/large
        // branch that lived here (FA511 el.node writes) cleared
        // `el.node.style.minHeight` on every keystroke — the framework's
        // inline E2 floor — so the expanded composer shrank to one row on the
        // first character (2026-09-29 per Nika).
        },
        // The open panels get every key FIRST — the '+' attach menu's arrows and
        // the whole mention-picker traversal (Arrow/Home/End/Enter/Tab/Escape).
        // That model is `aiComposerKeydown` in shared, not inline here, because
        // the shell mount of this composer REPLACES this handler wholesale
        // (workspace/app.js) and has to run the identical branches — see the
        // `_aiComposerKeydown` note at the top of this file.
        //
        // It returns true when it consumed the key. Enter is consumed ONLY while a
        // picker with options is open (it inserts the mention), so with no picker
        // open Enter still falls through to the send below — one send, never two.
        // Shift+Enter inserts a newline, as before.
        onKeydown: (e, el, s)=>{
            if ($ad61a26507ba656c$var$_aiComposerKeydown(e, el, s)) return;
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                $ad61a26507ba656c$var$_sendPrompt(el);
            }
        },
        onPaste: (e, el, s)=>{
            const items = e.clipboardData?.items;
            if (!items) return;
            for(let i = 0; i < items.length; i++)if (items[i].type.indexOf('image') !== -1) {
                e.preventDefault();
                const blob = items[i].getAsFile();
                if (!blob) continue;
                // Capture name/mime/size alongside the data URL — same shape as
                // the onDrop images branch above (see its comment).
                const mime = blob.type || items[i].type || 'image/png';
                const name = blob.name || `pasted-image.${(mime.split('/')[1] || 'png').split('+')[0]}`;
                const size = blob.size;
                const reader = new FileReader();
                reader.onloadend = ()=>{
                    const key = `${name}:${size}:${Date.now()}`;
                    const images = [
                        ...s.images || [],
                        {
                            key: key,
                            name: name,
                            mime: mime,
                            size: size,
                            dataUrl: reader.result
                        }
                    ];
                    s.update({
                        images: images
                    });
                };
                reader.readAsDataURL(blob);
            }
        }
    },
    // Reasoning-log panel — slides in above the prompt while freestyleBusy is true.
    // Streams accumulated assistant_delta text from s.root.freestyleStream.
    // Height is always E (~108px); collapsed to height:0/opacity:0 when idle so
    // the entrance animation triggers on every new turn without a remount.
    FreestyleThinking: {
        position: 'absolute',
        bottom: '100%',
        left: '0',
        right: '0',
        marginBottom: 'Y',
        theme: 'canvas-card',
        borderRadius: 'A',
        padding: 'Z',
        fontSize: 'X2',
        color: 'paragraph',
        // Streaming reasoning log — role=log (implicit polite live region) with
        // a label, so the focusable scroll panel has an accessible name.
        role: 'log',
        aria: {
            label: (el)=>el.call('polyglot', 'canvas.prompt.reasoningAria')
        },
        // Busy-COUPLED focusability (axe `scrollable-region-focusable`, serious —
        // MARKETPLACE-AUDIT residue, tickets/fable.md 2026-08-09): the panel is
        // height-0/opacity-0 when idle, so a STATIC tabindex would mint an
        // invisible tab stop. `0` only while freestyleBusy makes it actually
        // scrollable/visible; `-1` when idle is never a tab stop but keeps the
        // attribute's reactive lifecycle simple (same freestyleBusy predicate the
        // height/opacity/transform factories below already re-run on).
        tabindex: (el, s)=>s.root?.freestyleBusy ? '0' : '-1',
        // collapsed → expanded driven by freestyleBusy
        height: (el, s)=>s.root?.freestyleBusy ? 'E' : '0',
        opacity: (el, s)=>s.root?.freestyleBusy ? '1' : '0',
        // starts ~42px (C) below final position, slides up on enter
        // var(--spacing-C) form required — DOMQL token resolver does not reach
        // inside CSS function args (calc/clip-path/translateY use var() form).
        // UPPERCASE: the DS emits `--spacing-C` and custom-property names are
        // case-sensitive, so the lowercase form this used resolved to the empty
        // string and `translateY()` was invalid — measured, the whole transform
        // computed to `none`, so this never actually slid.
        transform: (el, s)=>s.root?.freestyleBusy ? 'translateY(0)' : 'translateY(var(--spacing-C))',
        transition: 'B all defaultBezier',
        // Scrollable only while OPEN — same busy predicate as tabindex above.
        // Idle, the height-0 box still had scrollHeight > clientHeight, so axe's
        // scrollable-region matcher saw an invisible scrollable region regardless
        // of tabindex; a collapsed panel has no business scrolling at all.
        overflow: (el, s)=>s.root?.freestyleBusy ? 'hidden auto' : 'hidden',
        pointerEvents: (el, s)=>s.root?.freestyleBusy ? 'auto' : 'none',
        text: (el, s)=>s.root?.freestyleStream || el.call('polyglot', 'canvas.prompt.thinking'),
        // Auto-scroll to bottom as new delta text arrives. `.scrollTo()` (a
        // method call), not a `.scrollTop =` assignment — FA511 treats el.node
        // as read-only from project code; `.focus()`/`.blur()`/`.scrollTo()`/
        // `.setPointerCapture()` are the sanctioned exceptions. Behaviourally
        // identical (no `behavior: 'smooth'`, so this is still an instant jump,
        // exactly as before) — a safe swap, not a rewrite of the mechanism.
        onRender: (el)=>{
            if (el.node) el.node.scrollTo(0, el.node.scrollHeight);
        }
    },
    // Thinking sheen — a subtle shimmer that sweeps the composer while the AI is
    // working: a GENERAL assistant turn (s.root.chatTyping) OR the build/bridge flow
    // (freestyleBusy). Makes the input itself feel alive, not just the pill above
    // it. The gradient + keyframe live in app.js's injected shell CSS keyed on
    // [data-key="ThinkingSheen"] — a raw gradient/animation string empty-rules
    // through the DOMQL atomic compiler (same footgun as the pill's `bottom`).
    // pointerEvents:none so it never blocks typing a follow-up mid-turn; the
    // composer's overflow:hidden clips it to the card radius.
    ThinkingSheen: {
        // `chatTyping ||` short-circuits away `freestyleBusy` whenever chatTyping
        // is truthy, and `s.root &&` can drop both — so the sheen could stick on
        // or never appear depending on which flag moved first. FA515.
        hideDeps: [
            'chatTyping',
            'freestyleBusy'
        ],
        hide: (el, s)=>!(s.root && (s.root.chatTyping || s.root.freestyleBusy)),
        pointerEvents: 'none'
    },
    // Bridge-down hint — shown when the agent is not busy but the bridge is
    // disconnected or errored. Separate from the panel so the hint stays visible
    // in the collapsed state.
    FreestyleStatus: {
        tag: 'span',
        hide: (el, s)=>s.root?.freestyleBusy || !s.root?.freestyleError && s.root?.freestyleStatus !== 'disconnected' && s.root?.freestyleStatus !== 'error',
        position: 'absolute',
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        marginBottom: 'Y',
        fontSize: 'X2',
        color: (el, s)=>s.root?.freestyleError || s.root?.freestyleStatus === 'error' ? 'error' : 'paragraph',
        opacity: '.75',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        // The error branch is the FIRST read, so any run that returns before it
        // (or with `s.root` unset) leaves `freestyleError` untracked — the hint
        // then never updates when an error actually arrives, which reads to the
        // user as the app silently doing nothing. FA515.
        textDeps: [
            'freestyleError'
        ],
        text: (el, s)=>{
            if (s.root?.freestyleError) return s.root.freestyleError;
            if (s.root?.freestyleStatus === 'disconnected' || s.root?.freestyleStatus === 'error') return el.call('polyglot', 'canvas.prompt.bridgeDown');
            return '';
        }
    },
    PromptButtons: {
        // Hidden while the voice strip hosts (T18) — the strip carries its own
        // controls. NOTE: hiding mid-PTT-hold is safe — the VoiceBtn's pointer
        // capture keeps routing pointerup/pointercancel to the captured target
        // while it stays in the document (display:none does not release capture).
        hide: (el, s)=>$ad61a26507ba656c$var$_voiceHosting(s),
        // Return-to-typing entrance, symmetric with Textarea's — see its
        // comment above.
        animation: 'fadeIn',
        flow: 'x',
        align: 'center start',
        fontSize: 'Z1',
        transition: 'B all defaultBezier',
        childExtends: 'NavbarButton',
        childProps: {
            // Was a `s.size === 'small' ? 'Y' : 'Y2'` factory — frozen at mount
            // like the layout five below, so a small-mounted composer always
            // rendered Y anyway. Static Y keeps today's rendered look in every
            // state; per-size button padding can come back as a case on the
            // buttons themselves if the design wants it.
            padding: 'Y',
            transition: 'B all defaultBezier',
            // A thumb target on a phone: the row's buttons measured 27px in a 390px
            // frame (QA mobile pass, 2026-09-23) against the 36px compact control.
            '@mobileL': {
                minWidth: 'controlHCompact',
                minHeight: 'controlHCompact'
            }
        },
        // VOICE-TALK-ONLY-SIMONE-1 part 1 (Nika: "fix PromptViewButtons … when
        // its expanded"): these five were `(el, s) => (s.size === 'small' ? … : …)`
        // FACTORIES. Registry components freeze reactive layout factories at
        // mount in v3.14 — the exact rule this file's own width comment (~200)
        // cites for using `.isSmall`/`.isLarge` conditional classes instead — so
        // a composer that mounted small kept `position: static` forever: on
        // expand the toolbar stayed IN-FLOW inside the flex row, crushed against
        // the textarea, instead of docking to the card's bottom-left. Same
        // conditional-case mechanism as the root card now: base = the small-pill
        // geometry, `.isDocked` = every non-small size. (gap/padding smalls
        // ride along so the docked toolbar gets its roomier spacing too.)
        isDocked: (el, s)=>s.size !== 'small',
        position: 'static',
        marginRight: 'Y',
        gap: 'X',
        '.isDocked': {
            position: 'absolute',
            bottom: 'Z',
            left: 'A',
            // The row ENDS one X before MinimizeBtn — its offset (D), its box
            // (controlHCompact) and a gap, on the same em (both are fontSize Z1),
            // so no tool can sit under minimize or send at any width. `C2` reached
            // inside minimize: at 390 the AI settings click landed on it (design-d2,
            // dev 3691a9c28). Tools that do not fit MOVE (Upload → the + menu;
            // Inspect off the phone row) — never overlap, never cut.
            right: 'calc(D + controlHCompact + X)',
            marginRight: '0',
            gap: 'Z',
            // Phones: the docked row keeps the pill's X gap. The Z gap applied only
            // when the row was CREATED docked (the expanded composer) and cost a
            // project page's 390 row 5 × 5.8 px it does not have (design-d2's joint
            // pass: 260.9 px row, 237.6 needed at X). This media step emits with the
            // conditional class doubled, so it holds in both docked states.
            '@mobileL': {
                gap: 'X'
            }
        },
        flexShrink: '0',
        // THE MODE CHIP — the bar's LEFT edge names what the AI makes
        // (AI_ASSISTANT_SPEC §8 "left: mode switch (Assistant · Dashboard ·
        // Apps)", Nika's pick 5B): the kit's AssistantModeChip (shared) opens the
        // mode menu and writes through the shell's setAssistantMode. FIRST here,
        // in the component: a key the shell mount adds renders AFTER this row's
        // own children, and a flex `order` would leave the Tab order behind the
        // pixels. It hides itself without the writer (another host has none) and
        // in the small pill — no gate here, which would replace its own. Out of
        // the row's NavbarButton like the shell's ModelBtn, and the row's
        // childProps padding (Y) outranks the kit's, so its geometry is re-stated.
        // The key names the kit component, so it extends it by key (FA806).
        // RIGID: the kit chip never shrinks (e0fe2a39d) and nothing here overrides
        // that — the mode word is never cut. The row fits every language at every
        // width since the compact model button (789772f71, b37eac652; measured
        // budget in __tests__/composerToolRowGeometry.test.js).
        AssistantModeChip: {
            ignoreChildExtends: true,
            // the merged form: context + mode in this one trigger (see `Prefix`)
            withContext: true,
            // the home's tabs are the mode there (see `_modeChipHidden`)
            hide: (el, s)=>$ad61a26507ba656c$var$_modeChipHidden(el, s),
            padding: 'Y Z2',
            // the small pill carries its own chip FIRST (the brand `Prefix` slot)
            class: {
                isRowInPill: (el, s)=>s.size === 'small',
                isCompact: (el, s)=>s.size === 'small'
            },
            '&.isRowInPill': {
                display: 'none'
            }
        },
        // Content-attach entry (2026-09-02 per Nika "add + icon where you
        // select different content - like ticket, member, note etc ... but also
        // add option in + dropdown (build app)"). Toggles the AttachMenu panel
        // (component-local state — works without the dropdown plugin on the
        // standalone canvas host).
        PlusBtn: {
            // Armed build mode is carried by the GLYPH, not a wash: conditional
            // classes never attach on these childExtends row buttons (measured
            // live — the node carried no isActive class while armed, across
            // class/factory/subscribeTo variants), but CONTENT props re-apply
            // reliably (VoiceBtn's mic swap is the precedent). While armed the +
            // becomes the build glyph, the tooltip says how to disarm, and the
            // textarea placeholder names what the next send does.
            icon: (el, s)=>s.buildArmed ? 'layers' : 'plus',
            aria: {
                label: (el)=>el.call('polyglot', 'canvas.prompt.attach.aria'),
                haspopup: 'menu',
                expanded: (el, s)=>s.attachOpen ? 'true' : 'false'
            },
            title: (el, s)=>el.call('polyglot', s.buildArmed ? 'canvas.prompt.attach.armedTitle' : 'canvas.prompt.attach.aria'),
            // ArrowDown/ArrowUp open the menu (the menu-button contract) and hand
            // focus to its first/last row. ArrowUp landing on the LAST row is the
            // menu-button convention. Enter and Space need no branch — NavbarButton
            // is a real <button>, so both already fire the onClick toggle below.
            //
            // The arm happens HERE, not on the panel: see the _armAttachFocus note
            // at the top of this file for why an `if:`-gated panel gets no open-edge
            // lifecycle hook of its own. Arming on an already-open menu is correct
            // too — the arrow keys must reach the rows whichever way focus was lost.
            onKeydown: (e, el, s)=>{
                if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
                e.preventDefault();
                e.stopPropagation();
                if (!s.attachOpen) $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: true
                });
                $ad61a26507ba656c$var$_armAttachFocus(el, {
                    last: e.key === 'ArrowUp'
                });
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const next = !s.attachOpen;
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: next
                });
                // Opening by pointer moves focus into the menu too (the ARIA
                // menu-button pattern) so the arrows work without a second click.
                // Closing by pointer drops the stored return target instead of
                // restoring it — focus is already on this button.
                if (next) $ad61a26507ba656c$var$_armAttachFocus(el);
                else $ad61a26507ba656c$var$_releaseMenuFocus($ad61a26507ba656c$var$_attachPanelOf(el));
            }
        },
        InspectBtn: {
            icon: 'sf cursor',
            title: (el)=>el.call('polyglot', 'canvas.prompt.inspect'),
            onClick: (ev, el)=>{
                el.call('setCanvasMode', 'inspectMode');
            }
        },
        // Voice input — click toggles the full-screen listening overlay, holding
        // (≥280ms) is true push-to-talk: speak while held, release to execute.
        // Renders only when a VoiceOverlay host announced itself (voiceHostReady).
        // `display: null` clears NavbarButton's inline display so the reactive
        // `show` can win (the UploadBtn pattern below). Own `scope` so the PTT
        // hold timer never collides with the inherited composer scope.
        VoiceBtn: {
            scope: {},
            display: null,
            // `s.root &&` short-circuits, so on any run where `s.root` is not yet
            // populated this factory finishes with `voiceHostReady` UNTRACKED and
            // (per the zero-tracked-sources rule) is never notified again — the mic
            // button then stays hidden for the rest of the session even after a
            // VoiceOverlay host announces itself. Declaring the dep makes the
            // subscription independent of control flow. FA515.
            showDeps: [
                'voiceHostReady'
            ],
            show: (el, s)=>!!(s.root && s.root.voiceHostReady),
            icon: (el, s)=>s.root && s.root.voiceOpen ? 'mic' : 'micOutline',
            // VOICE-TALK-ONLY-SIMONE-1 part 2: a plain CLICK opens TALK (the
            // conversation — voiceStart's default now); HOLDING keeps the one-shot
            // spoken-command pipeline (explicit mode below on the press only).
            title: (el)=>el.call('polyglot', 'canvas.prompt.voice'),
            isActive: (el, s)=>!!(s.root && s.root.voiceOpen),
            '.isActive': {
                background: 'selected',
                color: 'title'
            },
            onPointerdown: (e, el, s)=>{
                if (e.button !== 0) return;
                // Capture on the BUTTON, not `e.target`. e.target is whatever sits
                // under the pointer — normally the inner icon — and `icon` is a
                // reactive prop that swaps the instant `voiceOpen` flips, i.e.
                // exactly when a PTT hold starts. Capture dies with the node it was
                // taken on, so capturing the icon could drop `pointerup` mid-hold,
                // leaving `_vpttHeld` true and making the NEXT click commit-and-close
                // instead of toggling. The button itself survives the icon swap (and
                // survives `PromptButtons` hiding while a strip hosts — display:none
                // does not remove it from the document, which is what releases capture).
                const capture = el.node || e.target;
                if (capture && capture.setPointerCapture && e.pointerId !== undefined) try {
                    capture.setPointerCapture(e.pointerId);
                } catch (_) {}
                // Announce this composer as the voice host BEFORE the engine opens —
                // root.voiceHost contract (shared/components/VoiceStrip.js): the
                // in-place strip renders here instead of the full-screen overlay.
                // UI-only root write → preventFetch.
                if (s.root && s.root.update) s.root.update({
                    voiceHost: 'canvas'
                }, {
                    preventFetch: true
                });
                el.call('voicePttPress', {
                    mode: 'command'
                });
            },
            onPointerup: (e, el)=>{
                if (e.button !== 0) return;
                // No mode on the release path: a quick click falls through to
                // voiceToggle → voiceStart, whose default is TALK. The press keeps
                // `mode: 'command'` so the ≥280ms HOLD (one-shot command) is the
                // only way to reach the one-shot pipeline.
                el.call('voicePttRelease');
            },
            onPointercancel: (e, el)=>el.call('voicePttCancel')
        },
        UploadBtn: {
            // `extends: 'UploadThreadImageIcon'` pointed at a non-existent
            // component → the button rendered with no icon and the wrong
            // box-model. NavbarButton (inherited via PromptButtons.childExtends)
            // already gives us the toolbar style; we just add an upload icon
            // and a hidden file input layered on top of the button surface.
            tag: 'label',
            icon: 'uploadOutline',
            title: (el)=>el.call('polyglot', 'canvas.prompt.uploadImage'),
            // ON THE ROW ONLY IN THE WIDE `large` COMPOSER. With the mode chip the
            // resting composer (width H) is at capacity — measured on dev
            // 3691a9c28 at 1440: the tools need 349 px of 347 in English, ~373 in
            // Georgian — and a phone has less; there Upload lives in the + menu,
            // whose "Photo or file" row clicks THIS button's file input (it stays in
            // the DOM, display:none — MDN's hidden-input pattern). Hidden in the
            // small pill as before. `display: null` clears the NavbarButton inline
            // `display` so the reactive `hide` can win (the InspectBtn pattern).
            display: null,
            hide: (el, s)=>s.size !== 'large',
            '@mobileM': {
                display: 'none'
            },
            position: 'relative',
            cursor: 'pointer',
            Input: {
                tag: 'input',
                type: 'file',
                ariaLabel: (el)=>el.call('polyglot', 'canvas.prompt.uploadImage'),
                accept: 'image/*',
                position: 'absolute',
                inset: '0',
                opacity: '0',
                cursor: 'pointer',
                onChange: (e, el)=>{
                    const file = e.target.files[0];
                    if (!file || !file.type.startsWith('image/')) return;
                    // Walk up to the CanvasPromptTextarea element to reach its component
                    // state (state.images). The FileReader callback fires after an async
                    // hop, so we capture both `st` (component state) and `el.node` refs
                    // synchronously before yielding.
                    let promptEl = el.parent // Input → UploadBtn
                    ;
                    while(promptEl && promptEl.parent && !promptEl.state?.images)promptEl = promptEl.parent;
                    const st = promptEl?.state;
                    if (!st) return;
                    const nodeRef = el.node;
                    const reader = new FileReader();
                    reader.onloadend = ()=>{
                        // Capture name/mime/size alongside the data URL — same shape as
                        // the composer's onDrop/onPaste image capture (see onDrop above).
                        const key = `${file.name}:${file.size}:${file.lastModified}`;
                        const existing = st.images || [];
                        if (st.update && !existing.some((ex)=>ex.key === key)) st.update({
                            images: [
                                ...existing,
                                {
                                    key: key,
                                    name: file.name,
                                    mime: file.type || 'image/*',
                                    size: file.size,
                                    dataUrl: reader.result
                                }
                            ]
                        });
                        if (nodeRef) nodeRef.value = '';
                    };
                    reader.readAsDataURL(file);
                }
            }
        },
        ExpandBtn: {
            icon: 'arrowAngleUp',
            // Icon-only control — same audit class as 59a72b64: without a label
            // it announces NOTHING to screen readers.
            aria: {
                label: (el)=>el.call('polyglot', 'canvas.prompt.expandBar')
            },
            title: (el)=>el.call('polyglot', 'canvas.prompt.expandBar'),
            show: (el, s)=>s.size === 'small',
            // PHONES: Expand leaves the pill row for the + menu (design-d2's ruling
            // 2026-10-01: the 390 pill had 136 px of text room beside five
            // controls; Voice stays). The SAME narrow-row rule as UploadBtn
            // (`@mobileM`); the + menu's ExpandRow appears exactly when this button
            // is hidden by it (it reads this node's computed display). `display:
            // null` clears the NavbarButton inline display so the media rule wins.
            display: null,
            '@mobileM': {
                display: 'none'
            },
            onClick: (e, el, s)=>{
                // Clear the small-state autosize height BEFORE it can fight
                // 'normal's declarative sizing — see _resetTextareaAutosize's own
                // comment for the full stale-inline-height race — then settle
                // again AFTER the new cascade applies (_settleTextareaSize: the
                // update itself re-arms a stale height via the autoGrow resize).
                $ad61a26507ba656c$var$_resetTextareaAutosize(el);
                s.update({
                    size: 'normal'
                });
                $ad61a26507ba656c$var$_settleTextareaSize(el);
            }
        }
    },
    Flex: null,
    Button: null,
    // ── Mention typeahead dropdown ──────────────────────────────────────────
    // Anchored above the composer (the SimoneMentionDropdown posture —
    // absolute, bottom:100%), driven off the component-local `mentionPicker`
    // state _refreshAiMention maintains. Rows are per-option child STATES; a
    // row's `s.parent` is the composer state, which is how a click reaches
    // the picker's splice coordinates.
    AiMentionDropdown: {
        if: (el, s)=>!!(s.mentionPicker && s.mentionPicker.options && s.mentionPicker.options.length),
        position: 'absolute',
        bottom: '100%',
        left: 'A',
        marginBottom: 'Y',
        zIndex: '40',
        flow: 'y',
        gap: 'V',
        padding: 'Y',
        minWidth: 'G',
        maxWidth: 'H',
        round: 'radiusCard',
        theme: 'common-card',
        boxShadow: 'var(--shadow-float)',
        overflow: 'hidden',
        // A typeahead list, NOT a menu: DOM focus stays in the textarea (moving
        // it would drop the caret and the query the user is still typing), and
        // the highlight travels as `mentionPicker.activeIndex` state. So the
        // roles are listbox/option — the keys themselves (Arrow/Enter/Tab/Escape,
        // plus Home/End as of this pass) already live on the textarea's own
        // onKeydown above and are deliberately NOT rebuilt here.
        role: 'listbox',
        aria: {
            label: (el)=>el.call('polyglot', 'canvas.prompt.mentionSuggestions')
        },
        // Section header — the SAME CaptionTitle voice the sidebars head their
        // groups with (chat Sidebar.js: `CaptionTitle` at Y2 over CHANNELS /
        // DIRECT MESSAGES), so a dropdown list and a rail list read as one
        // grammar (2026-09-02 per Nika "in both AI dropdowns - use CaptionTitle
        // just like we use in sidebars - with same color and size"). Names the
        // trigger's type (People / Channels / Tickets / Events / Notes & docs).
        // Function-form text: this element has no state of its own, so `s` IS
        // the composer state and re-runs on every picker update.
        Heading: {
            extends: 'CaptionTitle',
            // X2, not the sidebar's literal Y2: the type scale is em-based and the
            // chat rail runs at base Z (17px / 1.2 = 14.17px), where Y2 renders
            // 11.05px; this dropdown runs at the composer's 17px base, where Y2
            // renders 13.26px. X2 = Y2 / 1.2, so X2 here IS the sidebar's 11.05px
            // (measured live 2026-09-02 — "same color and size" is a rendered
            // contract, not a token name).
            fontSize: 'X2',
            margin: '0',
            padding: 'Y Z',
            align: 'center flex-start',
            role: 'presentation',
            Text: {
                // Literal keys, never `'canvas.prompt.mention.' + type` — the canvas
                // i18n audit (canvasI18n test) refuses concatenated keys because it
                // cannot prove they exist in both bundles.
                text: (el, s)=>{
                    const type = s.mentionPicker && s.mentionPicker.type || 'person';
                    const key = {
                        person: 'canvas.prompt.mention.person',
                        channel: 'canvas.prompt.mention.channel',
                        ticket: 'canvas.prompt.mention.ticket',
                        event: 'canvas.prompt.mention.event',
                        reference: 'canvas.prompt.mention.reference'
                    }[type] || 'canvas.prompt.mention.person';
                    return el.call('polyglot', key);
                }
            }
        },
        // The option rows live one level down so the header can sit beside a
        // `children` list without inheriting its childExtends. `Rows` declares
        // no state, so it INHERITS the composer's state object (smbls
        // state/create.js "No state defined - inherit parent's state"): each
        // row's `s.parent` is still the composer state, exactly what
        // _applyAiMention and the activeIndex readers below expect.
        Rows: {
            flow: 'y',
            gap: 'V',
            role: 'presentation',
            childrenAs: 'state',
            children: (el, s)=>(s.mentionPicker && s.mentionPicker.options || []).map((o, i)=>({
                        ...o,
                        __i: i,
                        __type: s.mentionPicker.type,
                        key: String(o.id || o.email || o.name || o.title || i)
                    })),
            childExtends: {
                flow: 'x',
                align: 'center space-between',
                gap: 'Z',
                padding: 'Y Z',
                round: 'radiusControl',
                cursor: 'pointer',
                role: 'option',
                ariaSelected: (el, s)=>s.parent && s.parent.mentionPicker && (s.parent.mentionPicker.activeIndex || 0) === s.__i ? 'true' : 'false',
                background: (el, s)=>s.parent && s.parent.mentionPicker && (s.parent.mentionPicker.activeIndex || 0) === s.__i ? 'selected' : 'transparent',
                ':hover': {
                    background: 'hover'
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Z1',
                    color: 'title',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    text: (el, s)=>$ad61a26507ba656c$var$_mentionRefRowLabel(s.__type, s).label
                },
                Caption: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    flexShrink: '0',
                    text: (el, s)=>$ad61a26507ba656c$var$_mentionRefRowLabel(s.__type, s).caption
                },
                // preventDefault on pointerdown keeps focus in the textarea so the
                // blur-close belt never races the pick.
                onPointerdown: (e)=>e.preventDefault(),
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    if (s.parent) $ad61a26507ba656c$var$_applyAiMention(el, s.parent, s);
                }
            }
        }
    },
    // ── '+' attach menu ─────────────────────────────────────────────────────
    // Same posture as the mention dropdown; static row set. Content rows
    // insert their trigger prefix at the end of the draft and hand off to the
    // typeahead; Build app forces the /add-app build flow (shell-registered
    // forceBuildApp — the row hides where no host registers it, e.g. the
    // standalone canvas).
    AttachMenu: {
        if: (el, s)=>!!s.attachOpen,
        position: 'absolute',
        bottom: '100%',
        left: 'A',
        marginBottom: 'Y',
        zIndex: '40',
        flow: 'y',
        gap: 'V',
        padding: 'Y',
        minWidth: 'F',
        round: 'radiusCard',
        theme: 'common-card',
        boxShadow: 'var(--shadow-float)',
        // ── keyboard (2026-09-02 per Nika "add keyboard navigation when ai
        // chatbot dropdowns open") ─────────────────────────────────────────────
        // Before this the whole menu was click-only: it could not be opened from
        // the keyboard, arrowed through, or dismissed.
        //
        // The rows stay <div>s with `role="menuitem"` + `tabindex="-1"` (the ARIA
        // menu pattern) rather than becoming <button>s. Two reasons, both
        // measured on this file: a <button> does not inherit the app font, so
        // every row's Label/Caption would have fallen back to the UA default; and
        // roving `tabindex="-1"` is CORRECT here (unlike the AI settings panel) —
        // this is a transient menu whose only entry point is the '+' button, so
        // its rows must not mint six extra tab stops in the composer toolbar.
        // Because the rows are not buttons, Enter/Space are activated explicitly
        // by `menuActivateRow`, which clicks the focused row (a real bubbling
        // click — exactly what DOMQL's delegated onClick listens for).
        //
        // `if:`-gated, so the node exists ONLY while open. That keeps six rows out
        // of the DOM while the menu is shut, but it also means this panel gets NO
        // lifecycle hook on either edge — the focus arm/return lives at the call
        // sites that flip `attachOpen` (see the _armAttachFocus note at the top of
        // this file), and the close branches below own the return leg.
        role: 'menu',
        tabindex: '-1',
        aria: {
            label: (el)=>el.call('polyglot', 'canvas.prompt.attach.aria')
        },
        onKeydown: (e, el, s)=>{
            if ($ad61a26507ba656c$var$_menuArrowNav(e, el.node)) return;
            if ($ad61a26507ba656c$var$_menuActivateRow(e, el.node)) return;
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: false
                });
                // Escape hands focus back to '+' — the ARIA menu contract, and the
                // only way a keyboard user gets back to the toolbar. `el` IS the panel
                // here, which is where the arm stored the return target.
                $ad61a26507ba656c$var$_restoreMenuFocus(el);
                return;
            }
            // Tab leaves the menu — close on the way out, without preventDefault so
            // the browser still moves focus onward. The return target is dropped
            // first: the close path would otherwise pull focus back to '+' and
            // fight the Tab the user just pressed.
            if (e.key === 'Tab') {
                $ad61a26507ba656c$var$_releaseMenuFocus(el);
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: false
                });
            }
        },
        scope: {
            insertTrigger (el, s, prefix) {
                const body = s.draft || '';
                const sep = body && !/\s$/.test(body) ? ' ' : '';
                const next = body + sep + prefix;
                // This path OWNS where focus goes (the textarea, caret at the end),
                // so the menu's stored return target is dropped and any arm poll
                // still in flight is cancelled — otherwise a fast keyboard pick would
                // race the 300ms handoff below and park focus back on '+'.
                $ad61a26507ba656c$var$_releaseMenuFocus($ad61a26507ba656c$var$_attachPanelOf(el));
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    draft: next,
                    attachOpen: false
                });
                // 300ms, not a rAF: the menu-close re-render repaints the textarea
                // value a beat later and the Textarea's onBlur belt (250ms) clears
                // a picker opened before it settles — measured live: '@' landed but
                // focus and the picker were both gone by +800ms on a rAF handoff.
                setTimeout(()=>{
                    const ta = el.node?.closest?.('[data-key="CanvasPromptTextarea"]')?.querySelector?.('textarea');
                    if (!ta) return;
                    ta.focus();
                    try {
                        ta.setSelectionRange(next.length, next.length);
                    } catch (_) {}
                    const taEl = {
                        node: ta,
                        state: el.state
                    };
                    $ad61a26507ba656c$var$_refreshAiMention(taEl, s);
                }, 300);
            }
        },
        childExtends: {
            flow: 'x',
            align: 'center flex-start',
            gap: 'Z',
            padding: 'Y Z',
            round: 'radiusControl',
            cursor: 'pointer',
            background: 'transparent',
            // Keyboard row contract (see the panel note above): `menuitem` is what
            // the arrow walker collects, `-1` keeps the rows out of the tab order
            // while still allowing programmatic focus. Focus is visible through the
            // same `hover` wash the pointer gets, so a keyboarded row is never a
            // silent selection.
            role: 'menuitem',
            tabindex: '-1',
            ':hover': {
                background: 'hover'
            },
            ':focus-visible': {
                background: 'hover',
                outline: 'none'
            },
            onPointerdown: (e)=>e.preventDefault()
        },
        // Section header — same CaptionTitle voice as the sidebars' group
        // titles and the mention dropdown above (2026-09-02 per Nika). It
        // inherits the row childExtends (menuitem role, hover wash, pointer),
        // so it opts back out: `presentation` keeps it out of the arrow walker
        // (which collects `[role="menuitem"]`), and the washes are cleared.
        Heading: {
            extends: 'CaptionTitle',
            // X2 = the sidebar's rendered Y2 at this 17px base — see the mention
            // dropdown's Heading above.
            fontSize: 'X2',
            margin: '0',
            padding: 'Y Z',
            align: 'center flex-start',
            role: 'presentation',
            tabindex: null,
            cursor: 'default',
            ':hover': {
                background: 'transparent'
            },
            ':focus-visible': {
                background: 'transparent'
            },
            Text: {
                text: '{{ canvas.prompt.attach.heading | polyglot }}'
            }
        },
        // FLY'S ADD SECTION (Nika 2026-10-23: "I'm not sure about these buttons …
        // maybe we move them somewhere else?"): the Fly canvas carries no toolbar;
        // while it is on screen, the "+" adds a live widget to its page — the
        // shell's section picker (workspace functions/assistantFlyWorkspace.js
        // assistantFlySectionOffered / assistantFlyWorkspacePicker). A host without
        // Fly registers neither, so the row is never there.
        FlySectionRow: {
            if: (el, s)=>typeof el.context?.functions?.assistantFlySectionOffered === 'function' && !!el.call('assistantFlySectionOffered', s.root),
            Icon: {
                name: 'columns',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.attach.section | polyglot }}'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                // The picker's dialog takes focus next and returns it to whatever had
                // it when it opened: focus goes back to '+' first (Escape's path), so
                // '+' is where the closed dialog lands — this row leaves with the menu.
                $ad61a26507ba656c$var$_restoreMenuFocus($ad61a26507ba656c$var$_attachPanelOf(el));
                el.call('assistantFlyWorkspacePicker', 'section');
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: false
                });
            }
        },
        // TOGGLE, not a navigation (2026-09-02 per Nika "buld app should not
        // open /add-app section but should be toggle which runs this
        // functionality and opens that generated page after output"): arming
        // flips root._aiBuildMode; the NEXT sends run the build pipeline from
        // right here, and the generated page opens as a PageSlot overlay when
        // the output lands (functions/forceBuildApp.js + watchAiBuildOutput).
        BuildAppRow: {
            if: (el)=>typeof el.context?.functions?.forceBuildApp === 'function',
            background: (el, s)=>s.root && s.root._aiBuildMode ? 'selected' : 'transparent',
            Icon: {
                name: 'layers',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.attach.buildApp | polyglot }}'
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>el.call('polyglot', s.root && s.root._aiBuildMode ? 'canvas.prompt.attach.buildAppArmed' : 'canvas.prompt.attach.buildAppHint')
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                const next = !(s.root && s.root._aiBuildMode);
                // Nothing else takes focus on this path — the menu just closes — so
                // hand it back to '+' the way Escape does. Without this a keyboard
                // activation (Enter on the focused row) drops focus to <body>.
                $ad61a26507ba656c$var$_restoreMenuFocus($ad61a26507ba656c$var$_attachPanelOf(el));
                // buildArmed mirrors the root flag for the PlusBtn paint (see its
                // isActive note); the root flag stays the behavioural truth.
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: false,
                    buildArmed: next
                });
                if (s.root && s.root.update) s.root.update({
                    _aiBuildMode: next
                }, {
                    preventFetch: true
                });
            }
        },
        UploadRow: {
            Icon: {
                name: 'uploadOutline',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.attach.photoOrFile | polyglot }}'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                // The OS file picker takes focus next — drop the return target so the
                // menu's close path never pulls it back to '+' behind the dialog.
                $ad61a26507ba656c$var$_releaseMenuFocus($ad61a26507ba656c$var$_attachPanelOf(el));
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: false
                });
                const input = el.node?.closest?.('[data-key="CanvasPromptTextarea"]')?.querySelector?.('input[type="file"]');
                if (input) input.click();
            }
        },
        // EXPAND on phones (see PromptButtons.ExpandBtn): offered only while the
        // pill's own Expand button is hidden by the narrow-row rule — read off
        // that button's computed display when the menu opens (the menu mounts
        // on open), so the row and the button are never both shown or both gone.
        ExpandRow: {
            if: (el, s)=>{
                if (s.size !== 'small') return false;
                const row = el.parent && el.parent.parent && el.parent.parent.PromptButtons;
                const node = row && row.ExpandBtn && row.ExpandBtn.node;
                if (!node || typeof getComputedStyle !== 'function') return false;
                return getComputedStyle(node).display === 'none';
            },
            Icon: {
                name: 'arrowAngleUp',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.expandBar | polyglot }}'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                $ad61a26507ba656c$var$_attachUpdate(s, {
                    attachOpen: false
                });
                // the Expand button's own path: the autosize reset, the size, the settle
                $ad61a26507ba656c$var$_resetTextareaAutosize(el);
                s.update({
                    size: 'normal'
                });
                $ad61a26507ba656c$var$_settleTextareaSize(el);
            }
        },
        TicketRow: {
            Icon: {
                name: 'checkOval',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.attach.ticket | polyglot }}'
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: '##'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                el.scope.insertTrigger(el, s, '##');
            }
        },
        MemberRow: {
            Icon: {
                name: 'user',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.attach.member | polyglot }}'
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: '@'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                el.scope.insertTrigger(el, s, '@');
            }
        },
        EventRow: {
            Icon: {
                name: 'dateOutline',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.attach.event | polyglot }}'
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: '@@'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                el.scope.insertTrigger(el, s, '@@');
            }
        },
        NoteRow: {
            Icon: {
                name: 'document',
                boxSize: 'Z',
                color: 'title',
                flexShrink: '0'
            },
            Label: {
                tag: 'span',
                fontSize: 'Z1',
                color: 'title',
                text: '{{ canvas.prompt.attach.note | polyglot }}'
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: '+'
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                el.scope.insertTrigger(el, s, '+');
            }
        }
    },
    ExpandCornerBtn: {
        extends: 'NavbarButton',
        if: (el, s)=>s.size !== 'small' && !$ad61a26507ba656c$var$_voiceHosting(s),
        // Arrows point INWARD when large (fullscreenExit = collapse) and
        // OUTWARD when normal (fullscreen = expand) — 2026-06-08 per Nika
        // "arrows should point inwards when it's large".
        icon: (el, s)=>s.size === 'large' ? 'fullscreenExit' : 'fullscreen',
        aria: {
            label: (el, s)=>el.call('polyglot', s.size === 'large' ? 'canvas.prompt.collapseComposer' : 'canvas.prompt.expandComposer')
        },
        title: (el, s)=>el.call('polyglot', s.size === 'large' ? 'canvas.prompt.collapseComposer' : 'canvas.prompt.expandComposer'),
        position: 'absolute',
        top: 'Z',
        right: 'Z',
        padding: 'Y2',
        fontSize: 'Z1',
        opacity: '.5',
        ':hover': {
            opacity: '1'
        },
        onClick: (e, el, s)=>{
            // Same stale-inline-height race as ExpandBtn — see
            // _resetTextareaAutosize's own comment; post-update settle per
            // _settleTextareaSize.
            $ad61a26507ba656c$var$_resetTextareaAutosize(el);
            if (s.size === 'normal') s.update({
                size: 'large'
            });
            else s.update({
                size: 'normal'
            });
            $ad61a26507ba656c$var$_settleTextareaSize(el);
        }
    },
    // Open the same conversation in the assistant sidebar (2026-09-02 per
    // Nika "add open in sidebar icon in canvasPromptTextarea when its
    // expanded... near fullscreen icon"). Sits in the top-right corner
    // cluster beside ExpandCornerBtn (`right: 'D'` — the same second-corner
    // offset MinimizeBtn uses on the bottom edge). Opens the drawer with the
    // canonical ReasoningPill/AppAssistantToggle patch and collapses the
    // composer back to the resting pill — the sidebar is now the working
    // surface; the draft stays in the composer state untouched.
    OpenSidebarBtn: {
        extends: 'NavbarButton',
        if: (el, s)=>s.size !== 'small' && !$ad61a26507ba656c$var$_voiceHosting(s),
        icon: 'sidebarRightFill',
        aria: {
            label: (el)=>el.call('polyglot', 'canvas.prompt.openInSidebar')
        },
        title: (el)=>el.call('polyglot', 'canvas.prompt.openInSidebar'),
        position: 'absolute',
        top: 'Z',
        right: 'D',
        padding: 'Y2',
        fontSize: 'Z1',
        // Muted-ink rest state + full-ink hover (the Chat.js session-menu
        // recipe) — NOT the neighbours' opacity fade, which the design-language
        // lock retired for new code (opacity-hover).
        color: 'caption',
        ':hover': {
            color: 'title'
        },
        onClick: (e, el, s)=>{
            // The shell's ONE "Open in sidebar" (workspace functions/
            // assistantMainThread.js assistantThreadToSidebar): in Page mode an
            // OPENER opens the main thread (AI_ASSISTANT_SPEC §12.2), but this button
            // names the SIDEBAR — the drawer on the last side for the session, the
            // thread closed, closing the drawer returns to Page. A host without the
            // shell's writer (the standalone canvas) opens the drawer as before.
            const fns = el.context && el.context.functions;
            if (fns && typeof fns.assistantThreadToSidebar === 'function') {
                el.call('assistantThreadToSidebar');
                if (s.root._assistantPillHandle) s.root.update({
                    _assistantPillHandle: false
                });
            } else {
                const patch = {
                    assistantOpen: true
                };
                if (s.root._assistantPillHandle) patch._assistantPillHandle = false;
                if (s.root.assistantDock === 'minimized') patch.assistantDock = 'right';
                s.root.update(patch);
            }
            $ad61a26507ba656c$var$_resetTextareaAutosize(el);
            s.update({
                size: 'small'
            });
            $ad61a26507ba656c$var$_settleTextareaSize(el);
        }
    },
    MinimizeBtn: {
        extends: 'NavbarButton',
        if: (el, s)=>s.size !== 'small' && !$ad61a26507ba656c$var$_voiceHosting(s),
        icon: 'arrowAngleDown',
        aria: {
            label: (el)=>el.call('polyglot', 'canvas.prompt.minimizeBar')
        },
        title: (el)=>el.call('polyglot', 'canvas.prompt.minimizeBar'),
        position: 'absolute',
        bottom: 'Z',
        right: 'D',
        // The icon-button square (the kit's IconButton law), named here because
        // the docked tool row reserves exactly this box: `right: calc(D +
        // controlHCompact + X)` on PromptButtons.
        boxSize: 'controlHCompact',
        padding: 'Y2',
        fontSize: 'Z1',
        onClick: (e, el, s)=>{
            // Same stale-inline-height race as ExpandBtn/ExpandCornerBtn — see
            // _resetTextareaAutosize's own comment. The post-update settle is
            // what actually fixes the "minimize keeps the expanded size" bug:
            // the update's own autoGrow resize re-pins a height measured under
            // the still-expanded cascade, so it must be cleared and re-measured
            // AFTER the small cascade applies (_settleTextareaSize).
            $ad61a26507ba656c$var$_resetTextareaAutosize(el);
            s.update({
                size: 'small'
            });
            $ad61a26507ba656c$var$_settleTextareaSize(el);
        }
    },
    CircleButton: {
        // The house icon button (36px, 1/1 — the brand's icon-button law), the
        // same square as the row's buttons beside it. It was a bare CircleButton:
        // a 30px disc in a row of 36px buttons (measured live 2026-10-18).
        extends: 'NavbarButton',
        // Hidden while the voice strip hosts (T18) — sends come from the voice
        // flow, not the text send button.
        hide: (el, s)=>$ad61a26507ba656c$var$_voiceHosting(s),
        // Return-to-typing entrance, symmetric with Textarea's — see its
        // comment above.
        animation: 'fadeIn',
        // Icon-only send control — carried NO accessible name at all: a <button>
        // whose only content is an svg glyph announces NOTHING to screen readers,
        // and was the last remaining CRITICAL axe `button-name` node on every
        // route this composer mounts on (2026-08-08 marketplace sweep,
        // tickets/fable.md MARKETPLACE-AUDIT). Same aria+title pair as
        // ExpandBtn/MinimizeBtn/ExpandCornerBtn above — static aria.X flattens
        // to a real `aria-label` attribute (attrs-in-props
        // filterAttributesByTagName).
        aria: {
            label: (el)=>el.call('polyglot', 'canvas.prompt.send')
        },
        title: (el)=>el.call('polyglot', 'canvas.prompt.send'),
        position: (el, s)=>s.size === 'small' ? 'relative' : 'absolute',
        bottom: (el, s)=>s.size === 'small' ? 'auto' : 'Z',
        right: (el, s)=>s.size === 'small' ? 'auto' : 'Z',
        // CONCENTRIC IN THE PILL'S RIGHT CAP. The send is the 36 px house icon
        // button now (NavbarButton above), so on the 39 px mouse pill `V` (1.53 px)
        // leaves the same 1.5 px on its right as above and below it (as a 30 px
        // disc it sat 2 px from the edge with 4.5 px above and below). On a touch
        // screen the pill stands 45 px: `X1` (4.66 px) sits the circle concentric
        // in the cap, the way the mode plate sits in the left one (measured at
        // 390, 2026-10-18). A WRAPPED pill is a box, not a cap: it anchors its
        // controls `X` above its bottom edge (.isPillWrapped), and the send keeps
        // the same `X` from the end — the corner the chip keeps at the start (it
        // kept `V`: 1.5 px from the right, 4 px from the bottom, live on dev
        // 7227774). The pill's own verdict: smbls keeps a case's EVALUATED value
        // on the element (a boolean at runtime — measured on dev 3103cfd, where a
        // function check missed it; the definition's function in a unit test).
        // The draft read subscribes this factory to the edits that flip it, and
        // the pill's case re-runs first (effects run parent before child).
        marginRight: (el, s)=>{
            if (s.size !== 'small') return undefined;
            if ($ad61a26507ba656c$var$_touchScreen(el)) return 'X1';
            s.draft;
            const pill = el && el.parent;
            const verdict = pill ? pill.isPillWrapped : false;
            const wrapped = typeof verdict === 'function' ? !!(typeof el.call === 'function' && el.call('exec', verdict, pill)) : !!verdict;
            return wrapped ? 'X' : 'V';
        },
        flexShrink: '0',
        // The send arrow in every state — the drawer's arrow (Chat.js SendButton),
        // and no longer the paper plane the Fly mode chip paints. A send in flight
        // swaps it for the house spinner: the sprite has no `loading` glyph, so
        // that name painted `#noIcon`, a hatched square.
        icon: 'arrowUp',
        Icon: {
            hideDeps: [
                (el, s)=>s.root && s.root.freestyleBusy
            ],
            hide: (el, s)=>!!(s && s.root && s.root.freestyleBusy)
        },
        LoadingSpinner: {
            hideDeps: [
                (el, s)=>s.root && s.root.freestyleBusy
            ],
            hide: (el, s)=>!(s && s.root && s.root.freestyleBusy)
        },
        opacity: (el, s)=>s.root?.freestyleBusy ? '.5' : '1',
        pointerEvents: (el, s)=>s.root?.freestyleBusy ? 'none' : 'auto',
        padding: (el, s)=>s.size === 'small' ? 'Y' : 'Z',
        theme: 'canvas-card-glass-reversed',
        // The same thumb target as the row's buttons (30px measured). Border-box:
        // this is a content-box button, so a bare 36 px min-width floor added the
        // padding on top — a 56 px send that reached into minimize (dev
        // 3691a9c28, 390: send [312, 368] against minimize [280, 316]).
        '@mobileL': {
            minWidth: 'controlHCompact',
            minHeight: 'controlHCompact',
            boxSizing: 'border-box'
        },
        // A finger's target — the 44pt FLOOR (shared/components/_touchTarget.js).
        // Send is the composer's most-used control and measured 25 x 25 on an
        // 834px iPad, 28 x 28 at 1032+ and 36 x 36 on phones (dev DFI, touch
        // simulated, DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1). The button is already
        // positioned (relative / absolute by size), so no position here.
        '@coarse': {
            ...(0, $9GdJK.touchFloor)
        },
        onClick: (e, el)=>{
            $ad61a26507ba656c$var$_sendPrompt(el);
        }
    }
};

});

parcelRegister("fhjkT", function(module, exports) {

$parcel$export(module.exports, "NpTemplateCard", () => $b1f77143a3aad45f$export$e064f253df89e441);
$parcel$export(module.exports, "NewProjectPickerBody", () => $b1f77143a3aad45f$export$d6fd931deea4cae5);
// "New project" creation picker, extracted from pages/studios.js as Stage 1 of
// the studios barrel-split (#11). It must stay EAGER: the home page's
// EmptyProjectCard / ProjectStarter open it via `content: { extends:
// 'NewProjectPickerBody' }` (bridged through workspace/components/index.js), and
// home never loads the studios page chunk.
//
// Fully portable — the create flow is SDK + cache + router, no board engine. The
// list-cache helpers come from ./studioShared.js so this module never imports
// pages/studios.js (that edge would re-pin the board engine eager, defeating
// Stage 2).
// Bare shared-library import, not per-file deep functions/*.js subpaths — a
// per-file deep specifier into @symbo-ls/workspace-shared cannot resolve
// through the platform's public importmap (tickets/execution-board.md §1,
// same fix as workspace/app.js — NewProjectPicker rides the EAGER chunk per
// the header note above, so this is a reached path). Deferred call wrappers,
// not a module-scope destructure, per the a5d0a2aa barrel-cycle lesson.

var $1X0Je = parcelRequire("1X0Je");

var $3zdQG = parcelRequire("3zdQG");

var $dQqPr = parcelRequire("dQqPr");
const $b1f77143a3aad45f$var$canvasGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// Per-file delegate names (frank flat globalScope: studios.js and
// studioShared.js read the same shared functions under their own names; a
// components-file EXPORT of them was a `dropped-export`).
const $b1f77143a3aad45f$var$_npBuildProjectUrls = (...args)=>(0, $1X0Je.default).functions.buildProjectUrls(...args);
const $b1f77143a3aad45f$var$_npProjectHref = (...args)=>(0, $1X0Je.default).functions.projectHref(...args);
// ─── Featured template definitions ──────────────────────────────────────────
// Each entry defines page stubs passed as `pages` content when creating a
// project from a template. `templateProjectKey` — when set, the server
// deep-clones pages/components/designSystem from that project's ProjectData
// instead of using the inline `pages` stub. Format: "owner/key".
// ─── newProjectPicker submit ──────────────────────────────────────────────────
// Dismissal is owned by the @symbo.ls/windows layer: header Close / backdrop /
// ESC route through the ModalRoot delegate; explicit buttons call
// el.call('closeModal', 'newProjectPicker').
async function $b1f77143a3aad45f$var$submitNewProjectPicker(root, rootEl) {
    const p = root?.newProjectPicker;
    if (!p || p.creating) return;
    const name = (p.name || '').trim();
    if (!name) {
        root.update({
            newProjectPicker: {
                ...p,
                error: 'canvas.newProject.error.nameRequired'
            }
        });
        return;
    }
    // Determine template source:
    //  - tab === 'library' → user picked a specific project key to scaffold from
    //  - tab === 'featured' → use FEATURED_TEMPLATES entry (may have templateProjectKey)
    const tab = p.tab || 'featured';
    const tpl = (0, $3zdQG.FEATURED_TEMPLATES).find((t)=>t.id === p.templateId) || (0, $3zdQG.FEATURED_TEMPLATES)[0];
    // Library tab requires a project selection before submitting.
    if (tab === 'library' && !p.templateProject) {
        root.update({
            newProjectPicker: {
                ...p,
                error: 'canvas.newProject.error.pickSource'
            }
        });
        return;
    }
    const slugRaw = String(name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-+|-+$)/g, '').slice(0, 40) || `project-${Math.random().toString(36).slice(2, 6)}`;
    root.update({
        newProjectPicker: {
            ...p,
            creating: true,
            error: null
        }
    });
    const sdk = $b1f77143a3aad45f$var$canvasGetSDK();
    if (!sdk?.createProject && !sdk?.createOrgProject) {
        root.update({
            newProjectPicker: {
                ...p,
                creating: false,
                error: 'canvas.newProject.error.noSdk'
            }
        });
        return;
    }
    // Resolve org id from slug. `orgIdForSlug` walks the localStorage caches AND
    // falls back to `sdk.listOrganizations()` if neither is populated.
    const slug = p.ownerSlug || root.userSlug || root.activeWorkspace || root.slug || '';
    const isPersonalOwner = !!root.userSlug && slug === root.userSlug;
    let orgId = null;
    if (!isPersonalOwner) try {
        orgId = await (0, $dQqPr.orgIdForSlug)(slug);
    } catch (orgErr) {
        console.warn('[submitNewProjectPicker] orgIdForSlug failed:', orgErr?.message || orgErr);
    }
    if (!isPersonalOwner && !orgId) {
        root.update({
            newProjectPicker: {
                ...p,
                creating: false,
                error: 'canvas.newProject.error.noOrg'
            }
        });
        return;
    }
    try {
        // Resolve projectType. Order:
        //  1. Library tab → always 'library' (server schema enum)
        //  2. Labs-navbar quick-create intent (p.projectType) wins when set
        //  3. Featured-template type (tpl.projectType — when user picked a card)
        //  4. Default to 'app'
        // Never send 'project' — it is NOT in the allowed list and the server
        // rejects after a long validation round-trip.
        const payload = {
            name: name,
            projectType: tab === 'library' ? 'library' : p.projectType || tpl.projectType || 'website',
            slug: slugRaw
        };
        // Determine the templateProject key to send for server-side deep-clone.
        if (tab === 'library' && p.templateProject) payload.templateProject = p.templateProject;
        else if (tpl.templateProjectKey) {
            payload.templateProject = tpl.templateProjectKey;
            if (tpl.pages) payload.pages = tpl.pages;
        } else if (tpl.pages) payload.pages = tpl.pages;
        if (tpl.components) payload.components = tpl.components;
        if (tpl.canvas) payload.canvas = tpl.canvas;
        const project = isPersonalOwner ? await sdk.createProject(payload) : await sdk.createOrgProject(orgId, payload);
        if (tpl.id === 'blank') {
            const projectId = project?._id || project?.id;
            if (!projectId) throw new Error('Created project is missing an id');
            await (0, $3zdQG.replaceGeneratedProjectData)(sdk, projectId, tpl);
        }
        // Optimistically insert into the shared projects cache so the workspace
        // board and dashboard sidebar reflect the new project without a reload.
        (0, $dQqPr.prependProjectToCache)(project);
        // Pop the windows layer — its onClose clears the carrier state.
        rootEl?.call?.('closeModal', 'newProjectPicker');
        const owner = slug || project?.owner?.slug;
        const key = project?.key || slugRaw;
        const urls = $b1f77143a3aad45f$var$_npBuildProjectUrls(owner, key);
        // Open the fresh project on the workspace-scoped form when it was created
        // inside the active org; personal/cross-org creates keep the legacy path.
        if (urls) rootEl.router($b1f77143a3aad45f$var$_npProjectHref(root, urls.safeOwner, urls.safeKey), rootEl.getRoot());
    } catch (err) {
        root.update({
            newProjectPicker: {
                ...p,
                creating: false,
                error: err?.message || 'Create failed.'
            }
        });
    }
}
const $b1f77143a3aad45f$export$e064f253df89e441 = {
    tag: 'button',
    type: 'button',
    subscribeTo: [
        'newProjectPicker'
    ],
    flow: 'y',
    gap: 'Z',
    round: 'radiusControl',
    padding: 'B',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    // Selection is monochrome (DESIGN_LANGUAGE.md §1/§4.3) — the old 'blue.1'
    // accent fill marked selection with hue.
    background: (el, s)=>(s.root?.newProjectPicker?.templateId || 'blank') === s._tplId ? 'selected' : 'transparent',
    'aria-pressed': (el, s)=>(s.root?.newProjectPicker?.templateId || 'blank') === s._tplId ? 'true' : 'false',
    // No transition on background — it's a reactive factory (subscribeTo
    // re-runs it on every newProjectPicker update), and the runtime re-applies
    // background per tick on factory-driven props, restarting a CSS transition
    // on it every time (framework constraint, DESIGN_LANGUAGE.md §7.7 / §11.3).
    ':hover': {
        background: 'hover'
    },
    // Bare design-system icon (no tile wrapper, default size) — inherits the
    // card's neutral `color: 'title'` via the Icon's `fill: currentColor`.
    Icon: {
        icon: (el, s)=>s._tplIcon || 'star'
    },
    NpCardLabel: {
        tag: 'span',
        text: (el, s)=>s._tplLabel ? el.call('polyglot', s._tplLabel) : '',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title'
    },
    NpCardHint: {
        tag: 'p',
        text: (el, s)=>s._tplHint ? el.call('polyglot', s._tplHint) : '',
        margin: '0',
        fontSize: 'Y',
        lineHeight: '1.4',
        color: 'caption'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const p = s.root?.newProjectPicker || {};
        s.root?.update({
            newProjectPicker: {
                ...p,
                templateId: s._tplId,
                projectType: s._tplProjectType || 'website'
            }
        });
    }
};
const $b1f77143a3aad45f$export$d6fd931deea4cae5 = {
    // No custom card chrome — the @symbo.ls/windows ModalWindow (CustomTemplate)
    // owns the surface (background / radius / shadow / width via the openModal
    // `width` option), exactly like AppCreateOrgModal.
    flow: 'column',
    maxHeight: 'min(90vh, 680px)',
    overflow: 'hidden',
    // Brand window header — its Close icon (data-key="Close") is dismissed by the
    // ModalRoot's document delegate. Populate H + P so the brand's placeholder
    // slots don't show leftover 'Heading / Paragraph' text.
    ModalHeader: {
        padding: 'A B',
        Hgroup: {
            H: {
                text: '{{ canvas.newProject.title | polyglot }}',
                fontWeight: '700'
            },
            P: {
                text: '{{ canvas.newProject.subtitle | polyglot }}'
            }
        }
    },
    // Project name row — uses brand InputField (Title label + themed Input).
    NpNameRow: {
        padding: 'V B',
        paddingTop: 'X',
        NpName: {
            extends: 'InputField',
            Title: {
                text: '{{ canvas.newProject.nameLabel | polyglot }}',
                fontSize: 'Z',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '0.06em'
            },
            Input: {
                type: 'text',
                placeholder: (el)=>el.call('polyglot', 'canvas.newProject.namePlaceholder'),
                onRender: (el, s)=>{
                    if (el.__npFocused) return;
                    el.__npFocused = true;
                    setTimeout(()=>el.node?.focus?.(), 60);
                },
                onInput: (e, el, s)=>{
                    const p = s.root?.newProjectPicker || {};
                    s.root?.update({
                        newProjectPicker: {
                            ...p,
                            name: e.target.value,
                            error: null
                        }
                    });
                },
                onKeydown: (e, el, s)=>{
                    // ESC dismiss is owned by the ModalRoot's document-level handler — an
                    // explicit closeModal here would double-pop when modals stack.
                    if (e.key === 'Enter') $b1f77143a3aad45f$var$submitNewProjectPicker(s.root, el.getRoot());
                }
            }
        }
    },
    // Featured templates grid — 3 columns spanning the panel body.
    NpFeaturedGrid: {
        display: 'grid',
        style: {
            gridTemplateColumns: 'repeat(3, 1fr)'
        },
        gap: 'V',
        padding: 'A B',
        overflow: 'auto',
        children: ()=>(0, $3zdQG.FEATURED_TEMPLATES).map((tpl)=>({
                    _tplId: tpl.id,
                    _tplLabel: tpl.label,
                    _tplHint: tpl.hint,
                    _tplIcon: tpl.icon,
                    _tplProjectType: tpl.projectType
                })),
        childrenAs: 'state',
        childExtends: 'NpTemplateCard'
    },
    NpFooter: {
        padding: 'V B',
        // Was `borderTop: 'hairline solid line'` — divider-as-chrome. The house
        // ModalFooter primitive (company/packages/brand/components/ModalFooter.js)
        // separates by spacing alone (no border); this bespoke footer now matches.
        flow: 'y',
        gap: 'V',
        // Error row — full-width above the actions. Long server messages wrap
        // cleanly and the Create button stays the same shape regardless of length.
        NpError: {
            tag: 'p',
            hide: (el, s)=>!s.root?.newProjectPicker?.error,
            // Key-in-state — a raw SDK message passes through polyglot unchanged.
            text: (el, s)=>s.root?.newProjectPicker?.error ? el.call('polyglot', s.root.newProjectPicker.error) : '',
            fontSize: 'Y2',
            lineHeight: '1.4',
            color: 'red',
            margin: '0',
            wordBreak: 'break-word'
        },
        // THE APP SPLIT (docs/APP_SPLIT.md): this modal makes things you PUBLISH.
        // A tool for the team is a workspace app — it has its own flow on /apps.
        NpToWorkspaceApps: {
            extends: 'Link',
            href: '/apps',
            alignSelf: 'flex-start',
            fontSize: 'Z2',
            color: 'caption',
            textDecoration: 'underline',
            ':hover': {
                color: 'title'
            },
            ':active': {
                color: 'title'
            },
            text: '{{ canvas.newProject.toWorkspaceApps | polyglot }}',
            onClick: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('closeModal', 'newProjectPicker');
                el.call('openAppPage', '/apps');
            }
        },
        NpActions: {
            flow: 'row',
            gap: 'Z1',
            align: 'center flex-end',
            // Brand Buttons — the same secondary/primary pair the tickets modal uses.
            NpCancel: {
                extends: 'Button',
                theme: 'secondary',
                type: 'button',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                fontSize: 'Z2',
                text: '{{ canvas.newProject.cancel | polyglot }}',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('closeModal', 'newProjectPicker');
                }
            },
            NpCreate: {
                extends: 'Button',
                theme: 'primary',
                type: 'button',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                fontSize: 'Z2',
                fontWeight: '700',
                disabled: (el, s)=>!!s.root?.newProjectPicker?.creating,
                text: (el, s)=>el.call('polyglot', s.root?.newProjectPicker?.creating ? 'canvas.newProject.creating' : 'canvas.newProject.create'),
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    $b1f77143a3aad45f$var$submitNewProjectPicker(s.root, el.getRoot());
                }
            }
        }
    }
};

});
parcelRegister("3zdQG", function(module, exports) {

$parcel$export(module.exports, "FEATURED_TEMPLATES", () => $298f6206a03b4da6$export$f2bbe12af6742c1d);
$parcel$export(module.exports, "projectDataChangesForTemplate", () => $298f6206a03b4da6$export$20285eff6db3a283);
$parcel$export(module.exports, "replaceGeneratedProjectData", () => $298f6206a03b4da6$export$3d48733294d1cdea);

var $f20YC = parcelRequire("f20YC");
// Pure builders for a starter template's canvas-tile content — mirrors
// blank's own components+canvas.items shape (FEATURED_TEMPLATES[0] below)
// instead of leaving mobile/app/service canvas-blank. `pages` stays the
// served-app route stubs; these derive the SEPARATE canvas-preview
// component set from that same list, so the two can never drift apart.
const $298f6206a03b4da6$var$cap = (s)=>s.charAt(0).toUpperCase() + s.slice(1);
// A template's real content pages — every `pages` entry that carries its
// own `text` (excludes an `index: { extends: '<home>' }` route alias, which
// has no separate tile of its own).
const $298f6206a03b4da6$var$realPageEntries = (pages)=>Object.entries(pages).filter(([, def])=>typeof def.text === 'string').map(([key, def])=>[
            key,
            def.text
        ]);
const $298f6206a03b4da6$var$templateNav = (entries)=>Object.fromEntries(entries.map(([key, text])=>[
            $298f6206a03b4da6$var$cap(key) + 'Link',
            {
                extends: 'Link',
                href: '/' + key,
                text: text
            }
        ]));
const $298f6206a03b4da6$var$templateComponents = (entries)=>Object.fromEntries(entries.map(([key, text])=>[
            key,
            {
                Heading: {
                    tag: 'h1',
                    text: text
                },
                Nav: {
                    flow: 'row',
                    ...$298f6206a03b4da6$var$templateNav(entries)
                }
            }
        ]));
// Same single-cluster grid math as canvas/autoLayout.js (ITEM_W/ITEM_GAP,
// alphabetical within the cluster) — every template here has ≤4 real pages
// and no '/'-prefixed route keys, so it always resolves to one row.
const $298f6206a03b4da6$var$templateCanvasItems = (entries)=>{
    const sorted = [
        ...entries
    ].sort(([a], [b])=>a.localeCompare(b));
    return Object.fromEntries(sorted.map(([key], i)=>[
            key,
            {
                x: i * ((0, $f20YC.ITEM_W) + (0, $f20YC.ITEM_GAP)),
                y: 0,
                w: (0, $f20YC.ITEM_W),
                h: (0, $f20YC.ITEM_W),
                pageKey: key
            }
        ]));
};
const $298f6206a03b4da6$var$MOBILE_PAGES = {
    index: {
        extends: 'home'
    },
    home: {
        tag: 'div',
        text: 'Home'
    },
    settings: {
        tag: 'div',
        text: 'Settings'
    }
};
const $298f6206a03b4da6$var$MOBILE_REAL_PAGES = $298f6206a03b4da6$var$realPageEntries($298f6206a03b4da6$var$MOBILE_PAGES);
const $298f6206a03b4da6$var$APP_PAGES = {
    index: {
        extends: 'dashboard'
    },
    dashboard: {
        tag: 'div',
        text: 'Dashboard'
    },
    settings: {
        tag: 'div',
        text: 'Settings'
    },
    login: {
        tag: 'div',
        text: 'Login'
    }
};
const $298f6206a03b4da6$var$APP_REAL_PAGES = $298f6206a03b4da6$var$realPageEntries($298f6206a03b4da6$var$APP_PAGES);
// THE APP SPLIT (docs/APP_SPLIT.md): this modal creates the things you
// PUBLISH — websites first. A website starts with the three pages every site
// has; a workspace app is never created here (that is /add-app).
const $298f6206a03b4da6$var$WEBSITE_PAGES = {
    index: {
        extends: 'home'
    },
    home: {
        tag: 'div',
        text: 'Home'
    },
    about: {
        tag: 'div',
        text: 'About'
    },
    contact: {
        tag: 'div',
        text: 'Contact'
    }
};
const $298f6206a03b4da6$var$WEBSITE_REAL_PAGES = $298f6206a03b4da6$var$realPageEntries($298f6206a03b4da6$var$WEBSITE_PAGES);
const $298f6206a03b4da6$var$SERVICE_PAGES = {
    index: {
        extends: 'overview'
    },
    overview: {
        tag: 'div',
        text: 'Overview'
    },
    api: {
        tag: 'div',
        text: 'API'
    },
    health: {
        tag: 'div',
        text: 'Health'
    }
};
const $298f6206a03b4da6$var$SERVICE_REAL_PAGES = $298f6206a03b4da6$var$realPageEntries($298f6206a03b4da6$var$SERVICE_PAGES);
const $298f6206a03b4da6$export$f2bbe12af6742c1d = [
    {
        id: 'blank',
        // `label`/`hint` hold bundle KEYS — NpTemplateCard resolves them through
        // polyglot (`text: (el, s) => s._tplLabel` reads them off state).
        label: 'canvas.newProject.templateBlank.label',
        hint: 'canvas.newProject.templateBlank.hint',
        icon: 'plus',
        // An empty WEBSITE (the app split: everything this modal makes is published).
        projectType: 'website',
        pages: {},
        components: {
            home: {
                Heading: {
                    tag: 'h1',
                    text: 'Hello World'
                }
            }
        },
        canvas: {
            showDesignSystem: false,
            initialFocus: 'home',
            items: {
                home: {
                    x: 0,
                    y: 0,
                    w: 1722,
                    h: 1722,
                    pageKey: 'home'
                }
            }
        }
    },
    {
        id: 'website',
        label: 'canvas.newProject.templateWebsite.label',
        hint: 'canvas.newProject.templateWebsite.hint',
        icon: 'globe',
        projectType: 'website',
        pages: $298f6206a03b4da6$var$WEBSITE_PAGES,
        components: $298f6206a03b4da6$var$templateComponents($298f6206a03b4da6$var$WEBSITE_REAL_PAGES),
        canvas: {
            items: $298f6206a03b4da6$var$templateCanvasItems($298f6206a03b4da6$var$WEBSITE_REAL_PAGES)
        }
    },
    {
        id: 'mobile',
        label: 'canvas.newProject.templateMobile.label',
        hint: 'canvas.newProject.templateMobile.hint',
        icon: 'deviceMobile',
        projectType: 'mobile',
        pages: $298f6206a03b4da6$var$MOBILE_PAGES,
        components: $298f6206a03b4da6$var$templateComponents($298f6206a03b4da6$var$MOBILE_REAL_PAGES),
        canvas: {
            items: $298f6206a03b4da6$var$templateCanvasItems($298f6206a03b4da6$var$MOBILE_REAL_PAGES),
            previewSize: 'mobileXS'
        }
    },
    {
        id: 'app',
        label: 'canvas.newProject.templateApp.label',
        hint: 'canvas.newProject.templateApp.hint',
        icon: 'deviceSmallScreen',
        projectType: 'app',
        pages: $298f6206a03b4da6$var$APP_PAGES,
        components: $298f6206a03b4da6$var$templateComponents($298f6206a03b4da6$var$APP_REAL_PAGES),
        canvas: {
            items: $298f6206a03b4da6$var$templateCanvasItems($298f6206a03b4da6$var$APP_REAL_PAGES)
        }
    },
    {
        id: 'deck',
        label: 'canvas.newProject.templateDeck.label',
        hint: 'canvas.newProject.templateDeck.hint',
        icon: 'play',
        projectType: 'deck',
        templateProjectKey: 'commercials/deck',
        pages: {
            index: {
                extends: 'slide0'
            },
            slide0: {
                tag: 'div',
                text: 'Slide 1'
            },
            slide1: {
                tag: 'div',
                text: 'Slide 2'
            },
            slide2: {
                tag: 'div',
                text: 'Slide 3'
            },
            slide3: {
                tag: 'div',
                text: 'Slide 4'
            },
            slide4: {
                tag: 'div',
                text: 'Slide 5'
            },
            slide5: {
                tag: 'div',
                text: 'Slide 6'
            },
            slide6: {
                tag: 'div',
                text: 'Slide 7'
            },
            slide7: {
                tag: 'div',
                text: 'Slide 8'
            },
            slide8: {
                tag: 'div',
                text: 'Slide 9'
            },
            slide9: {
                tag: 'div',
                text: 'Slide 10'
            },
            slide10: {
                tag: 'div',
                text: 'Slide 11'
            },
            slide11: {
                tag: 'div',
                text: 'Slide 12'
            },
            slide12: {
                tag: 'div',
                text: 'Slide 13'
            }
        }
    },
    {
        id: 'library',
        label: 'canvas.newProject.templateLibrary.label',
        hint: 'canvas.newProject.templateLibrary.hint',
        icon: 'layers',
        projectType: 'library',
        pages: null
    },
    {
        id: 'service',
        label: 'canvas.newProject.templateService.label',
        hint: 'canvas.newProject.templateService.hint',
        icon: 'api',
        projectType: 'app',
        pages: $298f6206a03b4da6$var$SERVICE_PAGES,
        components: $298f6206a03b4da6$var$templateComponents($298f6206a03b4da6$var$SERVICE_REAL_PAGES),
        canvas: {
            items: $298f6206a03b4da6$var$templateCanvasItems($298f6206a03b4da6$var$SERVICE_REAL_PAGES)
        }
    }
];
const $298f6206a03b4da6$export$20285eff6db3a283 = (template)=>[
        [
            'set',
            [
                'pages'
            ],
            template.pages || {}
        ],
        [
            'set',
            [
                'components'
            ],
            template.components || {}
        ],
        [
            'set',
            [
                'canvas'
            ],
            template.canvas || {}
        ]
    ];
const $298f6206a03b4da6$var$hasExpectedProjectData = (snapshot)=>{
    const data = snapshot?.data || snapshot || {};
    return Object.keys(data.pages || {}).length === 0 && Object.keys(data.components || {}).length === 1 && !!data.components?.home;
};
async function $298f6206a03b4da6$export$3d48733294d1cdea(sdk, projectId, template) {
    const changes = $298f6206a03b4da6$export$20285eff6db3a283(template);
    for(let attempt = 0; attempt < 3; attempt++){
        await sdk.applyProjectChanges(projectId, changes, {
            message: 'Initialize blank project'
        });
        const snapshot = await sdk.getProjectData(projectId);
        if ($298f6206a03b4da6$var$hasExpectedProjectData(snapshot)) return snapshot;
        if (attempt < 2) await new Promise((resolve)=>setTimeout(resolve, 150 * (attempt + 1)));
    }
    throw new Error('Blank project initialization did not persist');
}

});
parcelRegister("f20YC", function(module, exports) {

$parcel$export(module.exports, "ITEM_W", () => $af17cce2956f1d52$export$730bb9c685e90d2c);
$parcel$export(module.exports, "ITEM_GAP", () => $af17cce2956f1d52$export$277844099f49037);
$parcel$export(module.exports, "autoLayout", () => $af17cce2956f1d52$export$bbaa3df4f15e0faf);
// Cluster items by route prefix and tile into a clean grid. Each
// cluster (e.g. `/admin/*`) gets its own block; clusters lay out in
// rows of 4 cluster-columns. Items inside a cluster tile in 4 columns.
// Exported: functions/autoPlaceCanvasItem.js imports these instead of
// re-declaring its own identical pair. Two same-named module-scope consts in
// one bundle make esbuild rename one set (`ITEM_W2`), and frank lifts the
// renamed name into globalScope where the read can no longer be traced to a
// declaration in its own file.
const $af17cce2956f1d52$export$730bb9c685e90d2c = 1722;
const $af17cce2956f1d52$export$277844099f49037 = 256;
const $af17cce2956f1d52$var$CLUSTER_GAP = 640;
const $af17cce2956f1d52$var$ITEMS_PER_ROW = 4;
function $af17cce2956f1d52$var$clusterKey(pageKey) {
    if (!pageKey) return '';
    // `/admin/users` → `/admin`; `/dashboard` → `/dashboard`; non-routes use `'_components'`.
    if (!pageKey.startsWith('/')) return '_components';
    const parts = pageKey.split('/').filter(Boolean);
    return parts.length > 1 ? '/' + parts[0] : pageKey;
}
function $af17cce2956f1d52$export$bbaa3df4f15e0faf() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const entries = Object.entries(v2.items || {});
    if (!entries.length) return;
    // Bucket by cluster key, sorted alphabetically within each.
    const buckets = new Map();
    for (const [key, it] of entries){
        const ck = $af17cce2956f1d52$var$clusterKey(it.pageKey || key);
        if (!buckets.has(ck)) buckets.set(ck, []);
        buckets.get(ck).push([
            key,
            it
        ]);
    }
    for (const arr of buckets.values())arr.sort((a, b)=>a[0].localeCompare(b[0]));
    // Lay clusters out left-to-right; wrap to a new cluster-row when the
    // running width exceeds a sensible page width (~6 items wide).
    const clusterKeys = Array.from(buckets.keys()).sort();
    let cursorX = 0;
    let cursorY = 0;
    let rowMaxH = 0;
    const ROW_WRAP_X = 4 * ($af17cce2956f1d52$export$730bb9c685e90d2c + $af17cce2956f1d52$export$277844099f49037) * 2 // ~8 items wide before wrap
    ;
    for (const ck of clusterKeys){
        const arr = buckets.get(ck);
        const cols = Math.min($af17cce2956f1d52$var$ITEMS_PER_ROW, arr.length);
        const rows = Math.ceil(arr.length / $af17cce2956f1d52$var$ITEMS_PER_ROW);
        const blockW = cols * $af17cce2956f1d52$export$730bb9c685e90d2c + (cols - 1) * $af17cce2956f1d52$export$277844099f49037;
        const blockH = rows * $af17cce2956f1d52$export$730bb9c685e90d2c + (rows - 1) * $af17cce2956f1d52$export$277844099f49037;
        if (cursorX > 0 && cursorX + blockW > ROW_WRAP_X) {
            cursorX = 0;
            cursorY += rowMaxH + $af17cce2956f1d52$var$CLUSTER_GAP;
            rowMaxH = 0;
        }
        arr.forEach(([key], i)=>{
            const col = i % $af17cce2956f1d52$var$ITEMS_PER_ROW;
            const row = Math.floor(i / $af17cce2956f1d52$var$ITEMS_PER_ROW);
            const it = v2.items[key];
            it.x = cursorX + col * ($af17cce2956f1d52$export$730bb9c685e90d2c + $af17cce2956f1d52$export$277844099f49037);
            it.y = cursorY + row * ($af17cce2956f1d52$export$730bb9c685e90d2c + $af17cce2956f1d52$export$277844099f49037);
            it.w = $af17cce2956f1d52$export$730bb9c685e90d2c;
            it.h = $af17cce2956f1d52$export$730bb9c685e90d2c;
            // Imperative DOM update for the item so the change is visible
            // without forcing a children re-render.
            const node = document.querySelector(`[data-canvas-item="${CSS.escape(key)}"]`);
            if (node) {
                node.style.left = it.x + 'px';
                node.style.top = it.y + 'px';
                node.style.width = it.w + 'px';
                node.style.height = it.h + 'px';
            }
        });
        cursorX += blockW + $af17cce2956f1d52$var$CLUSTER_GAP;
        if (blockH > rowMaxH) rowMaxH = blockH;
    }
    // Refresh chrome + persist + frame the result.
    this.call('refreshCanvasChrome');
    this.call('pushHistory');
    this.call('persistCanvasLayout');
    // Select all, fit to selection, then clear.
    const allKeys = Object.keys(v2.items);
    this.call('selectMany', allKeys);
    this.call('fitToSelection');
    this.call('clearSelection');
}

});


parcelRegister("dQqPr", function(module, exports) {

$parcel$export(module.exports, "orgIdForSlug", () => $a144f151d36f0c81$export$9f39ded08cbb3268);
$parcel$export(module.exports, "getWorkspacesForOwnerCached", () => $a144f151d36f0c81$export$2c72a7bac067dba9);
$parcel$export(module.exports, "readCachedAllProjects", () => $a144f151d36f0c81$export$474e40175dc976b6);
$parcel$export(module.exports, "patchCachedProject", () => $a144f151d36f0c81$export$af87bf05f17a426d);
$parcel$export(module.exports, "prependProjectToCache", () => $a144f151d36f0c81$export$fdf2d64c97cb6b39);
$parcel$export(module.exports, "appendOrgToCache", () => $a144f151d36f0c81$export$482845c065c9d77c);
$parcel$export(module.exports, "withOwnerScopedProjects", () => $a144f151d36f0c81$export$2282d58691092423);
$parcel$export(module.exports, "getAllProjectsCached", () => $a144f151d36f0c81$export$3f49101abffe0b8c);
$parcel$export(module.exports, "CANVAS_NODE_W", () => $a144f151d36f0c81$export$2a96b86dd7844315);
$parcel$export(module.exports, "CANVAS_NODE_H", () => $a144f151d36f0c81$export$1ee360fd15a63953);
$parcel$export(module.exports, "COL_GAP", () => $a144f151d36f0c81$export$7e244b51fe9b8780);
$parcel$export(module.exports, "GRID_STEP", () => $a144f151d36f0c81$export$c411aa4259282652);
$parcel$export(module.exports, "snapUp", () => $a144f151d36f0c81$export$b7bc7a4867410ae6);
$parcel$export(module.exports, "COL_STRIDE", () => $a144f151d36f0c81$export$32785373082a3ade);
$parcel$export(module.exports, "ROW_STRIDE", () => $a144f151d36f0c81$export$92187ea6070659f4);
$parcel$export(module.exports, "integrationColor", () => $a144f151d36f0c81$export$eae8e4eb62e669c5);
$parcel$export(module.exports, "integrationGlyph", () => $a144f151d36f0c81$export$e844cac080698137);
$parcel$export(module.exports, "normalizeProject", () => $a144f151d36f0c81$export$c3a812d5f16d9905);
$parcel$export(module.exports, "persistSharedLibraries", () => $a144f151d36f0c81$export$c5547a413bd113b2);
$parcel$export(module.exports, "sdkBridge", () => $a144f151d36f0c81$export$d0e376acd38c2894);
$parcel$export(module.exports, "saveIntegrationFromPicker", () => $a144f151d36f0c81$export$288075e7cb5b3443);
// Project / org / workspace list-cache cluster, extracted from
// pages/studios.js so the /studio + /canvas page module can later be
// lazy-loaded (its own async chunk) while these low-dependency cache
// helpers stay eagerly available. The dashboard page (pages/dashboard.js)
// and the canvas component barrel (canvas/components/index.js, via
// pages/studios.js re-exports) both consume these — importing them from
// here severs the dashboard -> studios static coupling. The studios page
// imports the helpers it still uses back from this module; nothing here
// imports from studios.js (that would re-pin the page module into the
// initial bundle). Stage 0 of the studios barrel-split (#11) — a pure,
// behavior-preserving move: no logic changes. See DashboardRows.js for the
// same extraction pattern.
// Bare shared-library import, not a deep functions/sdk.js subpath — a
// per-file deep specifier into @symbo-ls/workspace-shared cannot resolve
// through the platform's public importmap (tickets/execution-board.md §1,
// same fix as workspace/app.js — this module rides the workspace-shell EAGER
// chunk via NewProjectPicker.js/studioShared imports, so it is a reached
// path). Deferred call wrapper, not a module-scope destructure, per the
// a5d0a2aa barrel-cycle lesson.

var $1X0Je = parcelRequire("1X0Je");
const $a144f151d36f0c81$var$canvasGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $a144f151d36f0c81$var$ownerSlug = (...args)=>(0, $1X0Je.default).functions.ownerSlug(...args);
const $a144f151d36f0c81$var$projectKey = (...args)=>(0, $1X0Je.default).functions.projectKey(...args);
const $a144f151d36f0c81$var$canvasProjectScreenshotUrl = (...args)=>(0, $1X0Je.default).functions.projectScreenshotUrl(...args);
const $a144f151d36f0c81$var$sanitizeStoredThumbnail = (...args)=>(0, $1X0Je.default).functions.sanitizeStoredThumbnail(...args);
const $a144f151d36f0c81$var$getScreenshotCdnReady = ()=>(0, $1X0Je.default).functions.SCREENSHOT_CDN_READY;
// Resolve an org's UUID from its slug via the SDK. Cached at module level
// AND in localStorage to survive reloads — `listOrganizations` is
// heavily rate-limited (HTTP 429) if hammered. Persisting across browser
// sessions (vs sessionStorage) lets the dashboard render its sidebar
// instantly on cold reload.
const $a144f151d36f0c81$var$ORG_ID_BY_SLUG = new Map();
const $a144f151d36f0c81$var$ORG_CACHE_KEY = '__canvas_orgs_v1';
const $a144f151d36f0c81$var$ORG_CACHE_TTL_MS = 300000;
let $a144f151d36f0c81$var$ORG_LIST_PROMISE = null;
function $a144f151d36f0c81$var$readOrgCache() {
    try {
        const raw = localStorage.getItem($a144f151d36f0c81$var$ORG_CACHE_KEY);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry?.at || !Array.isArray(entry.data)) return null;
        return entry;
    } catch  {
        return null;
    }
}
function $a144f151d36f0c81$var$writeOrgCache(list) {
    try {
        localStorage.setItem($a144f151d36f0c81$var$ORG_CACHE_KEY, JSON.stringify({
            at: Date.now(),
            data: list
        }));
    } catch  {}
}
async function $a144f151d36f0c81$export$9f39ded08cbb3268(slug) {
    if (!slug) return null;
    if ($a144f151d36f0c81$var$ORG_ID_BY_SLUG.has(slug)) return $a144f151d36f0c81$var$ORG_ID_BY_SLUG.get(slug);
    const cached = $a144f151d36f0c81$var$readOrgCache();
    if (cached && Date.now() - cached.at < $a144f151d36f0c81$var$ORG_CACHE_TTL_MS) {
        for (const o of cached.data)if (o?.slug) $a144f151d36f0c81$var$ORG_ID_BY_SLUG.set(o.slug, o.id);
        if ($a144f151d36f0c81$var$ORG_ID_BY_SLUG.has(slug)) return $a144f151d36f0c81$var$ORG_ID_BY_SLUG.get(slug);
    }
    // Fallback A: the shared `__canvas_user_orgs_v1` cache populated by
    // `listOrganizationsCached` in shared/functions/sdk.js. The studios
    // page maintains its own `__canvas_orgs_v1` cache (set by writeOrgCache
    // above), but the dashboard / sidebar / workspace-switcher all use the
    // shared key — so when the user has been bouncing around the rest of
    // the app, their personal/active-workspace org id sits in the shared
    // cache, but the studios-local cache is still empty. Without this
    // fallback the `+new app` submit went straight to `sdk.listOrganizations`
    // every first-time-into-studio path; when that endpoint was 429-rate-
    // limited (common just after sign-in), `orgIdForSlug` returned `null`
    // and the create flow short-circuited with "Could not resolve org for
    // this workspace" (#2174). Reading the shared cache here covers the
    // common path without a second network round-trip.
    try {
        const rawShared = localStorage.getItem('__canvas_user_orgs_v1');
        if (rawShared) {
            const entry = JSON.parse(rawShared);
            const data = Array.isArray(entry?.data) ? entry.data : [];
            for (const o of data)if (o?.slug) $a144f151d36f0c81$var$ORG_ID_BY_SLUG.set(o.slug, o._id || o.id);
            // Mirror the data forward into the studios-local cache too so
            // subsequent `readOrgCache` hits short-circuit at the top.
            if (data.length) $a144f151d36f0c81$var$writeOrgCache(data.map((o)=>({
                    ...o,
                    id: o._id || o.id
                })));
            if ($a144f151d36f0c81$var$ORG_ID_BY_SLUG.has(slug)) return $a144f151d36f0c81$var$ORG_ID_BY_SLUG.get(slug);
        }
    } catch  {}
    // Fallback B: derive org id from cached project list's owner refs. Each
    // project carries `{ owner: { slug, id, type } }` — enough to recover
    // org UUIDs when `listOrganizations` is 429-throttled and the user is
    // on a workspace whose org we've never explicitly fetched.
    try {
        const rawProjects = localStorage.getItem('__canvas_projects_v1');
        if (rawProjects) {
            const entry = JSON.parse(rawProjects);
            for (const p of entry?.data || []){
                const o = p?.owner;
                if (o?.slug && o?.id && o?.type === 'organization') $a144f151d36f0c81$var$ORG_ID_BY_SLUG.set(o.slug, o.id);
            }
            if ($a144f151d36f0c81$var$ORG_ID_BY_SLUG.has(slug)) return $a144f151d36f0c81$var$ORG_ID_BY_SLUG.get(slug);
        }
    } catch  {}
    if (!$a144f151d36f0c81$var$ORG_LIST_PROMISE) $a144f151d36f0c81$var$ORG_LIST_PROMISE = (async ()=>{
        try {
            const sdk = $a144f151d36f0c81$var$canvasGetSDK();
            if (!sdk.isReady?.()) await sdk.initialize({});
            const orgs = await sdk.listOrganizations();
            if (Array.isArray(orgs)) $a144f151d36f0c81$var$writeOrgCache(orgs);
            return orgs || [];
        } catch (err) {
            console.warn('[workspace] orgIdForSlug failed:', err?.message || err);
            return cached?.data || [];
        }
    })();
    const orgs = await $a144f151d36f0c81$var$ORG_LIST_PROMISE;
    for (const o of orgs || [])if (o?.slug) $a144f151d36f0c81$var$ORG_ID_BY_SLUG.set(o.slug, o._id || o.id);
    return $a144f151d36f0c81$var$ORG_ID_BY_SLUG.get(slug) || null;
}
// Workspace-list cache. Keyed by org UUID, stored in sessionStorage so it
// survives page navigations within the tab but is cleared on close. 5-min
// TTL mirrors the project-list TTL — rate-limited endpoint.
// Shape: { at: <epoch ms>, data: Array<{ _id, slug, displayName }> }
const $a144f151d36f0c81$var$WORKSPACE_LIST_CACHE_KEY_PREFIX = '__canvas_workspaces_v1_';
const $a144f151d36f0c81$var$WORKSPACE_LIST_TTL_MS = 300000;
const $a144f151d36f0c81$var$WORKSPACE_LIST_PROMISES = new Map();
function $a144f151d36f0c81$var$readWorkspaceCache(orgId) {
    try {
        const raw = sessionStorage.getItem($a144f151d36f0c81$var$WORKSPACE_LIST_CACHE_KEY_PREFIX + orgId);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry?.at || !Array.isArray(entry.data)) return null;
        return entry;
    } catch  {
        return null;
    }
}
function $a144f151d36f0c81$var$writeWorkspaceCache(orgId, list) {
    try {
        sessionStorage.setItem($a144f151d36f0c81$var$WORKSPACE_LIST_CACHE_KEY_PREFIX + orgId, JSON.stringify({
            at: Date.now(),
            data: list
        }));
    } catch  {}
}
async function $a144f151d36f0c81$export$2c72a7bac067dba9(orgId) {
    if (!orgId) return [];
    const cached = $a144f151d36f0c81$var$readWorkspaceCache(orgId);
    if (cached && Date.now() - cached.at < $a144f151d36f0c81$var$WORKSPACE_LIST_TTL_MS) return cached.data;
    if ($a144f151d36f0c81$var$WORKSPACE_LIST_PROMISES.has(orgId)) return $a144f151d36f0c81$var$WORKSPACE_LIST_PROMISES.get(orgId);
    const sdk = $a144f151d36f0c81$var$canvasGetSDK();
    if (!sdk.isReady?.()) await sdk.initialize({});
    const p = sdk.listWorkspaces({
        organization: orgId,
        limit: 200
    }).then((r)=>{
        // SDK's _call unwraps {success,data} envelopes — r is the data object
        // which the WorkspaceController returns as { items, total, page, limit }.
        const items = Array.isArray(r) ? r : r?.items || [];
        const list = items.filter((w)=>w && w.slug).map((w)=>({
                _id: String(w._id || w.id),
                slug: w.slug,
                displayName: w.displayName || w.slug
            }));
        $a144f151d36f0c81$var$writeWorkspaceCache(orgId, list);
        return list;
    }).catch((err)=>{
        console.warn('[workspace] getWorkspacesForOwnerCached failed:', err?.message || err);
        return cached?.data || [];
    }).finally(()=>{
        $a144f151d36f0c81$var$WORKSPACE_LIST_PROMISES.delete(orgId);
    });
    $a144f151d36f0c81$var$WORKSPACE_LIST_PROMISES.set(orgId, p);
    return p;
}
// Shared project-list cache — one `/projects?limit=1000` is heavy and
// filtering runs client-side per owner slug. Reuse across org switches
// and across dashboard ↔ workspace navigation; persist to localStorage
// so a reload (even days later) reuses the previous fetch (avoids HTTP
// 429 + eliminates dashboard empty-state flicker on cold reload).
const $a144f151d36f0c81$var$PROJECT_LIST_TTL_MS = 300000;
const $a144f151d36f0c81$var$PROJECT_LIST_KEY = '__canvas_projects_v1';
let $a144f151d36f0c81$var$PROJECT_LIST_PROMISE = null;
function $a144f151d36f0c81$var$readCacheEntry() {
    try {
        const raw = localStorage.getItem($a144f151d36f0c81$var$PROJECT_LIST_KEY);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry?.at || !Array.isArray(entry.data)) return null;
        return entry;
    } catch  {
        return null;
    }
}
function $a144f151d36f0c81$var$writeCache(list) {
    try {
        localStorage.setItem($a144f151d36f0c81$var$PROJECT_LIST_KEY, JSON.stringify({
            at: Date.now(),
            data: list
        }));
    } catch  {}
}
function $a144f151d36f0c81$export$474e40175dc976b6() {
    return $a144f151d36f0c81$var$readCacheEntry()?.data || null;
}
function $a144f151d36f0c81$export$af87bf05f17a426d(projectDbId, patch) {
    const entry = $a144f151d36f0c81$var$readCacheEntry();
    if (!entry?.data) return;
    let changed = false;
    const next = entry.data.map((p)=>{
        if (p?._id !== projectDbId && p?.id !== projectDbId) return p;
        changed = true;
        return {
            ...p,
            ...patch
        };
    });
    if (!changed) return;
    try {
        localStorage.setItem($a144f151d36f0c81$var$PROJECT_LIST_KEY, JSON.stringify({
            at: entry.at,
            data: next
        }));
    } catch  {}
}
function $a144f151d36f0c81$export$fdf2d64c97cb6b39(rawProject) {
    if (!rawProject) return;
    try {
        const entry = $a144f151d36f0c81$var$readCacheEntry();
        const existing = entry?.data || [];
        // De-dup: if a project with the same _id already landed (e.g. from a
        // concurrent background refetch) don't add a second copy.
        const id = rawProject._id || rawProject.id;
        if (id && existing.some((p)=>(p?._id || p?.id) === id)) return;
        const next = [
            rawProject,
            ...existing
        ];
        const serialised = JSON.stringify({
            at: Date.now(),
            data: next
        });
        localStorage.setItem($a144f151d36f0c81$var$PROJECT_LIST_KEY, serialised);
        // Reset in-flight promise so the next getAllProjectsCached() call
        // triggers a fresh network fetch instead of resolving a stale promise.
        $a144f151d36f0c81$var$PROJECT_LIST_PROMISE = null;
        // Cross-tab broadcast — other tabs listening to the `storage` event
        // will re-read the cache and can update their own in-memory state.
        try {
            window.dispatchEvent(new StorageEvent('storage', {
                key: $a144f151d36f0c81$var$PROJECT_LIST_KEY,
                newValue: serialised,
                storageArea: localStorage
            }));
        } catch  {}
    } catch  {}
}
function $a144f151d36f0c81$export$482845c065c9d77c(rawOrg) {
    if (!rawOrg) return;
    try {
        const entry = $a144f151d36f0c81$var$readOrgCache();
        const existing = entry?.data || [];
        const id = rawOrg._id || rawOrg.id;
        if (id && existing.some((o)=>(o?._id || o?.id) === id)) return;
        const next = [
            rawOrg,
            ...existing
        ];
        localStorage.setItem($a144f151d36f0c81$var$ORG_CACHE_KEY, JSON.stringify({
            at: Date.now(),
            data: next
        }));
        // Also warm the in-memory slug→id map so orgIdForSlug resolves
        // the new org immediately without a network round-trip.
        if (rawOrg.slug) $a144f151d36f0c81$var$ORG_ID_BY_SLUG.set(rawOrg.slug, id);
        try {
            const serialised = JSON.stringify({
                at: Date.now(),
                data: next
            });
            window.dispatchEvent(new StorageEvent('storage', {
                key: $a144f151d36f0c81$var$ORG_CACHE_KEY,
                newValue: serialised,
                storageArea: localStorage
            }));
        } catch  {}
    } catch  {}
}
async function $a144f151d36f0c81$export$2282d58691092423(list, ownerSlug) {
    const base = Array.isArray(list) ? list : [];
    if (!ownerSlug) return base;
    try {
        const sdk = $a144f151d36f0c81$var$canvasGetSDK();
        const res = await sdk.getProjects({
            owner: ownerSlug,
            limit: 200
        });
        const own = res?.data || res || [];
        if (!Array.isArray(own) || !own.length) return base;
        const seen = new Set(base.map((p)=>String(p?._id || p?.id)));
        const extra = own.filter((p)=>!seen.has(String(p?._id || p?.id)));
        return extra.length ? base.concat(extra) : base;
    } catch (err) {
        console.warn('[studio] owner-scoped project merge failed:', err?.message || err);
        return base;
    }
}
async function $a144f151d36f0c81$export$3f49101abffe0b8c() {
    const entry = $a144f151d36f0c81$var$readCacheEntry();
    const fresh = entry && Date.now() - entry.at < $a144f151d36f0c81$var$PROJECT_LIST_TTL_MS;
    if (fresh) return entry.data;
    if ($a144f151d36f0c81$var$PROJECT_LIST_PROMISE) return $a144f151d36f0c81$var$PROJECT_LIST_PROMISE;
    const sdk = $a144f151d36f0c81$var$canvasGetSDK();
    if (!sdk.isReady?.()) await sdk.initialize({});
    $a144f151d36f0c81$var$PROJECT_LIST_PROMISE = sdk.getProjects({
        limit: 1000
    }).then((r)=>{
        const list = r?.data || r || [];
        $a144f151d36f0c81$var$writeCache(list);
        return list;
    }).catch((err)=>{
        // On 429 (or any error), keep whatever we have in sessionStorage —
        // stale data beats an empty board. Propagate the error only when
        // we have nothing cached at all.
        if (entry?.data) return entry.data;
        throw err;
    }).finally(()=>{
        $a144f151d36f0c81$var$PROJECT_LIST_PROMISE = null;
    });
    return $a144f151d36f0c81$var$PROJECT_LIST_PROMISE;
}
const $a144f151d36f0c81$export$2a96b86dd7844315 = 416;
const $a144f151d36f0c81$export$1ee360fd15a63953 = 240;
const $a144f151d36f0c81$export$7e244b51fe9b8780 = 64;
const $a144f151d36f0c81$export$c411aa4259282652 = 24;
const $a144f151d36f0c81$export$b7bc7a4867410ae6 = (n)=>Math.ceil(n / $a144f151d36f0c81$export$c411aa4259282652) * $a144f151d36f0c81$export$c411aa4259282652;
const $a144f151d36f0c81$export$32785373082a3ade = $a144f151d36f0c81$export$b7bc7a4867410ae6($a144f151d36f0c81$export$2a96b86dd7844315 + $a144f151d36f0c81$export$7e244b51fe9b8780);
const $a144f151d36f0c81$export$92187ea6070659f4 = $a144f151d36f0c81$export$b7bc7a4867410ae6($a144f151d36f0c81$export$1ee360fd15a63953 + $a144f151d36f0c81$export$7e244b51fe9b8780);
// Fallback type inference for projects that don't yet carry a `projectType`
// field in Mongo. Keyed by project `key`. Matches the user's mental model
// (`brand` is a library, `deck` / `presentation` / `brand-doc` are slide
// decks) until the canonical types are written into project metadata.
const $a144f151d36f0c81$var$PROJECT_TYPE_BY_KEY = {
    brand: 'library',
    deck: 'presentation',
    presentation: 'presentation',
    'brand-doc': 'presentation'
};
const $a144f151d36f0c81$var$inferProjectType = (key)=>$a144f151d36f0c81$var$PROJECT_TYPE_BY_KEY[key] || null;
// Integration category → accent color. `integration_kinds.category` drives the
// look so new kinds inherit their category's color automatically. Used by the
// extracted IntegrationKindRow AND (imported back) by the studios board's
// IntegrationNode / IntegrationChip / rails.
const $a144f151d36f0c81$var$INTEGRATION_CATEGORY_COLOR = {
    data: '#3ecf8e',
    dev: '#d0d7de',
    workspace: '#f0b85a',
    ai: '#b88cff',
    messaging: '#54aeff',
    analytics: '#ff9f5a',
    automation: '#ff7a9c',
    custom: '#8ab4ff'
};
// Glyph fallbacks by kind prefix — used when `icon` is absent or the icon name
// isn't a known token. One character, drawn inside a rounded color tile.
const $a144f151d36f0c81$var$INTEGRATION_KIND_GLYPH = {
    supabase_project: 'S',
    github: 'G',
    google_workspace: 'W',
    google_analytics: 'A',
    npm: 'N',
    n8n: "\u2699",
    custom_http: "\u25C6"
};
function $a144f151d36f0c81$export$eae8e4eb62e669c5(category) {
    return $a144f151d36f0c81$var$INTEGRATION_CATEGORY_COLOR[category] || $a144f151d36f0c81$var$INTEGRATION_CATEGORY_COLOR.custom;
}
function $a144f151d36f0c81$export$e844cac080698137(kind) {
    if ($a144f151d36f0c81$var$INTEGRATION_KIND_GLYPH[kind]) return $a144f151d36f0c81$var$INTEGRATION_KIND_GLYPH[kind];
    return (kind || '?').charAt(0).toUpperCase();
}
function $a144f151d36f0c81$export$c3a812d5f16d9905(p, localPositions, { page: page = 'root' } = {}) {
    const owner = $a144f151d36f0c81$var$ownerSlug(p);
    const key = $a144f151d36f0c81$var$projectKey(p);
    const explicitImage = p?.icon && typeof p.icon === 'object' && p.icon.src || $a144f151d36f0c81$var$sanitizeStoredThumbnail(p?.thumbnail) || null;
    const screenshotDev = $a144f151d36f0c81$var$getScreenshotCdnReady() ? $a144f151d36f0c81$var$canvasProjectScreenshotUrl(p, {
        page: page,
        env: 'development'
    }) : null;
    const screenshot = $a144f151d36f0c81$var$getScreenshotCdnReady() ? $a144f151d36f0c81$var$canvasProjectScreenshotUrl(p, {
        page: page
    }) : null;
    // Real dependency graph lives on `useLibraries` (array of project _id refs)
    // returned by the list endpoint. Fall back to `sharedLibraries` for older
    // project shapes so seeded arrows still appear.
    const useLibraries = Array.isArray(p?.useLibraries) ? p.useLibraries : [];
    const legacySharedLibs = p?.sharedLibraries && typeof p.sharedLibraries === 'object' ? Object.keys(p.sharedLibraries) : Array.isArray(p?.sharedLibraries) ? p.sharedLibraries : [];
    // Position priority:
    //   1. canvasPosition from the list response (won't appear today because
    //      the server's getProjects projection drops it — but if the server
    //      ever starts including it, we pick it up transparently).
    //   2. locally-cached canvasPosition keyed by project _id (instant
    //      rehydrate on reload within the same origin).
    const dbId = p?._id || p?.id || null;
    const fromPayload = p?.canvasPosition && typeof p.canvasPosition === 'object' ? {
        x: +p.canvasPosition.x,
        y: +p.canvasPosition.y
    } : null;
    const fromLocal = dbId && localPositions && localPositions[dbId] ? {
        x: +localPositions[dbId].x,
        y: +localPositions[dbId].y
    } : null;
    const canvasPosition = fromPayload && Number.isFinite(fromPayload.x) && Number.isFinite(fromPayload.y) ? fromPayload : fromLocal && Number.isFinite(fromLocal.x) && Number.isFinite(fromLocal.y) ? fromLocal : null;
    return {
        id: `${owner}/${key}`,
        _id: dbId,
        owner: owner,
        key: key,
        name: p?.name || key || 'Untitled',
        icon: explicitImage,
        screenshot: screenshot,
        screenshotDev: screenshotDev,
        useLibraries: useLibraries,
        legacySharedLibs: legacySharedLibs,
        canvasPosition: canvasPosition,
        canvasGroup: p?.canvasGroup || null,
        canvasGroupName: p?.canvasGroupName || null,
        type: p?.type || null,
        projectType: p?.projectType || $a144f151d36f0c81$var$inferProjectType(key),
        // Last-edited stamp for the gallery card (STUDIO/FILES-MICRO-1) — the
        // Project schema carries Mongoose `timestamps: true`, so every project
        // doc has `updatedAt`; `createdAt` covers the (rare) doc missing it.
        // Rendered via the house `timeAgo` helper at the card, never formatted
        // here (DATE-FMT-1 precedent — format once, at the render boundary).
        updatedAt: p?.updatedAt || p?.createdAt || null
    };
}
// Compute the `useLibraries` array for one project node from the current
// connection graph — libraries are the `from` side (library → project edge).
function $a144f151d36f0c81$var$computeSharedLibs(projectNodeId, connections, nodes) {
    const nodeById = Object.fromEntries(nodes.map((n)=>[
            n.id,
            n
        ]));
    const libs = [];
    for (const c of connections){
        if (c.to !== projectNodeId) continue;
        const libNode = nodeById[c.from];
        if (libNode?._id) libs.push(libNode._id);
    }
    return libs;
}
// `/projects/:id/libraries` validates that targets are active *shared*
// libraries and 404s otherwise — too strict for arbitrary project→project
// arrows on the workspace. `PATCH /projects/:id` with `useLibraries` just
// persists the ref list, which is what we want. Private debounce state below.
const $a144f151d36f0c81$var$PERSIST_DEBOUNCE_MS = 500;
const $a144f151d36f0c81$var$PERSIST_TIMERS = new Map();
const $a144f151d36f0c81$var$LAST_SIGNATURE = new Map();
function $a144f151d36f0c81$export$c5547a413bd113b2(root, projectNodeIds) {
    const nodes = root?.nodes || [];
    const connections = root?.connections || [];
    const ids = Array.from(new Set(projectNodeIds)).filter(Boolean);
    for (const nodeId of ids){
        const node = nodes.find((n)=>n.id === nodeId);
        if (!node?._id) continue;
        const libs = $a144f151d36f0c81$var$computeSharedLibs(nodeId, connections, nodes);
        const signature = libs.slice().sort().join('|');
        if (!$a144f151d36f0c81$var$LAST_SIGNATURE.has(nodeId)) $a144f151d36f0c81$var$LAST_SIGNATURE.set(nodeId, (node.useLibraries || []).slice().sort().join('|'));
        if ($a144f151d36f0c81$var$LAST_SIGNATURE.get(nodeId) === signature) continue;
        const prev = $a144f151d36f0c81$var$LAST_SIGNATURE.get(nodeId);
        clearTimeout($a144f151d36f0c81$var$PERSIST_TIMERS.get(nodeId));
        $a144f151d36f0c81$var$PERSIST_TIMERS.set(nodeId, setTimeout(async ()=>{
            $a144f151d36f0c81$var$PERSIST_TIMERS.delete(nodeId);
            $a144f151d36f0c81$var$LAST_SIGNATURE.set(nodeId, signature);
            try {
                await $a144f151d36f0c81$var$canvasGetSDK().updateProject(node._id, {
                    useLibraries: libs
                });
                $a144f151d36f0c81$export$af87bf05f17a426d(node._id, {
                    useLibraries: libs
                });
            } catch (err) {
                $a144f151d36f0c81$var$LAST_SIGNATURE.set(nodeId, prev);
                console.warn('[workspace] persist sharedLibraries failed:', node.id, err?.message || err);
            }
        }, $a144f151d36f0c81$var$PERSIST_DEBOUNCE_MS));
    }
}
async function $a144f151d36f0c81$export$d0e376acd38c2894() {
    try {
        // The shared functions bag carries the integrations module's whole public
        // surface (barrelImports.test.js); a subpath import of
        // functions/integrations/index.js is refused at publish (frank 4ed5a2372:
        // the bag does not carry its `_internals`).
        return (0, $1X0Je.default).functions;
    } catch  {
        return null;
    }
}
async function $a144f151d36f0c81$export$288075e7cb5b3443(root, el) {
    const p = root?.integrationPicker;
    if (!p || p.saving) return;
    const kind = p.selectedKind;
    if (!kind) return;
    const orgId = await $a144f151d36f0c81$export$9f39ded08cbb3268(root.slug);
    if (!orgId) {
        root.update({
            integrationPicker: {
                ...p,
                // `el` is the SaveBtn — resolve here so the slug can be substituted.
                error: el.call('polyglot', 'canvas.integrationPicker.error.noOrgId').replace('{slug}', root.slug)
            }
        });
        return;
    }
    const form = p.form || {};
    const slug = (form.__slug || '').trim() || 'default';
    const scope = form.__scope || kind.default_scope || 'org';
    const scopeId = scope === 'project' ? form.__scopeId : scope === 'workspace' ? form.__scopeId : null;
    if (scope === 'project' && !scopeId) {
        root.update({
            integrationPicker: {
                ...p,
                error: 'canvas.integrationPicker.error.pickProject'
            }
        });
        return;
    }
    const config = {};
    for (const [k, v] of Object.entries(form)){
        if (k.startsWith('__')) continue;
        config[k] = v;
    }
    root.update({
        integrationPicker: {
            ...p,
            saving: true,
            error: null
        }
    });
    try {
        const bridge = await $a144f151d36f0c81$export$d0e376acd38c2894();
        if (!bridge?.saveIntegration) throw new Error('sdk-bridge not available');
        const res = await bridge.saveIntegration({
            orgId: orgId,
            kind: kind.kind,
            slug: slug,
            scopeType: scope,
            scopeId: scopeId,
            displayName: form.__displayName || config.display_name || null,
            config: config,
            secret: form.__secret || undefined
        });
        if (!res?.ok) {
            root.update({
                integrationPicker: {
                    ...p,
                    saving: false,
                    error: res?.body?.error || 'save failed'
                }
            });
            return;
        }
        root.update({
            integrationPicker: {
                open: false
            }
        });
        el?.call?.('closeModal', 'integrationPicker');
        // Re-pull integrations so the new row is reflected on shelf / canvas. The
        // studios page registers `refreshIntegrations` on mount (it closes over the
        // live board module-state + connection engine); off-studio el.call returns
        // undefined and this is a graceful no-op — the integration is still saved.
        await el?.call?.('refreshIntegrations', root);
    } catch (err) {
        root.update({
            integrationPicker: {
                ...p,
                saving: false,
                error: err?.message || 'save failed'
            }
        });
    }
}

});


parcelRegister("gzEr5", function(module, exports) {

$parcel$export(module.exports, "ProjectCanvasFilterRow", () => $c10f47f363f11ddf$export$39ac760ebd886a74);
$parcel$export(module.exports, "ProjectCanvasPageRow", () => $c10f47f363f11ddf$export$59a7f8f8737a3096);
$parcel$export(module.exports, "ProjectCanvasEntityRow", () => $c10f47f363f11ddf$export$19140372a0b71780);
$parcel$export(module.exports, "ProjectCanvasEnvPicker", () => $c10f47f363f11ddf$export$7546a2b9834fd5e0);
$parcel$export(module.exports, "ProjectCanvasSidebar", () => $c10f47f363f11ddf$export$a3ba45a28a0d377e);
// Project-canvas left rail — the SAME fixed glass-card shell + grouped rows as
// the /infra sidebar (InfraSidebar): a category FILTER for what shows on the
// canvas, an ENVIRONMENT picker, and PROJECT actions incl. a Publish button.
// (2026-06-17 per Nika "similar sidebar as we have on /infra on project canvas
// page, where we can filter stuff, switch environments, publish button etc".)
//
// Reactivity follows InfraSidebar's proven model: filter/env children read the
// driving state and return a NEW array each run (childrenAs re-evaluates), and
// active styling is an `.isActive` CONDITIONAL CLASS read fresh from root (paint
// factories freeze on a childrenAs in-place update).
// Bare shared-library import, not a deep components/_activeHighlight.js
// subpath — a per-file deep specifier into @symbo-ls/workspace-shared cannot
// resolve through the platform's public importmap (tickets/execution-board.md
// §1, same fix as workspace/app.js). Read through a call-time getter, not a
// module-scope destructure — `rowBase` below is a static object evaluated at
// import time, so an eager `_wsShared.components.activeHighlight` read here
// risks the same barrel-cycle-order crash the deferred-wrapper fix class
// exists to avoid (a5d0a2aa).

var $1X0Je = parcelRequire("1X0Je");

var $fzbiH = parcelRequire("fzbiH");
const $c10f47f363f11ddf$var$getActiveHighlight = ()=>(0, $1X0Je.default).components.activeHighlight;
const $c10f47f363f11ddf$var$canvasActiveFilter = (s)=>s.root?._canvasFilter || 'all';
const $c10f47f363f11ddf$var$activeEnv = (s)=>s.root?._canvasEnv || 'production';
// `label` on every FILTER_DEF holds a bundle KEY — ProjectCanvasFilterRow's
// `text: (el, s) => s.label` reads it off STATE, where neither a template nor a
// function value survives, so the row resolves it through polyglot instead.
const $c10f47f363f11ddf$var$CANVAS_FILTER_DEFS = [
    {
        key: 'all',
        label: 'canvas.sidebar.filter.all',
        icon: 'grid'
    },
    {
        key: 'pages',
        label: 'canvas.sidebar.filter.pages',
        icon: 'copy'
    },
    {
        key: 'components',
        label: 'canvas.sidebar.filter.components',
        icon: 'library'
    },
    {
        key: 'ds',
        label: 'canvas.sidebar.filter.designSystem',
        icon: 'tree'
    }
];
const $c10f47f363f11ddf$var$filterChildren = (el, s)=>{
    const f = $c10f47f363f11ddf$var$canvasActiveFilter(s);
    return $c10f47f363f11ddf$var$CANVAS_FILTER_DEFS.map((d)=>({
            ...d,
            _k: f
        }));
};
// `name` holds a bundle KEY — resolved by envName() / envMenuRows() below.
const $c10f47f363f11ddf$var$ENV_DEFS = [
    {
        id: 'production',
        name: 'canvas.sidebar.env.production'
    },
    {
        id: 'staging',
        name: 'canvas.sidebar.env.staging'
    },
    {
        id: 'development',
        name: 'canvas.sidebar.env.development'
    }
];
// `name` on every ENV_DEF holds a bundle KEY (see ENV_DEFS above).
const $c10f47f363f11ddf$var$envName = (s)=>$c10f47f363f11ddf$var$ENV_DEFS.find((e)=>e.id === $c10f47f363f11ddf$var$activeEnv(s))?.name || 'canvas.sidebar.env.production';
// `el` is threaded in from the opener so the rows resolve at open time — the
// menu is transient, and CanvasCreateMenuItem reads `label`/`hint` off a value.
const $c10f47f363f11ddf$var$canvasEnvMenuRows = (root, el)=>{
    const rows = {};
    $c10f47f363f11ddf$var$ENV_DEFS.forEach((env, i)=>{
        rows[`Env${i}`] = {
            extends: 'CanvasCreateMenuItem',
            label: el.call('polyglot', env.name),
            hint: el.call('polyglot', env.id === (root?._canvasEnv || 'production') ? 'canvas.sidebar.env.current' : 'canvas.sidebar.env.switchTo'),
            iconName: 'server',
            onClick: (ev, it)=>{
                it.call('closeDropdown');
                it.call('switchCanvasEnv', env.id);
            }
        };
    });
    return rows;
};
// A nav row in the InfraSidebar idiom (SidebarRow + padding Z A / round C).
const $c10f47f363f11ddf$var$item = (extra)=>({
        extends: 'SidebarRow',
        padding: 'Z A',
        round: 'radiusPill',
        fontSize: 'A',
        // Left-align the label — the sidebar inherits text-align:center from the
        // centered canvas overlay container, which would otherwise center the row
        // labels away from their leading icon (ProjectCanvasEnvPicker overrides the
        // same inheritance the same way).
        textAlign: 'left',
        MoreBtn: null,
        ...extra
    });
const $c10f47f363f11ddf$var$actionItem = (label, icon, onClick)=>$c10f47f363f11ddf$var$item({
        icon: icon,
        label: label,
        onClick: onClick
    });
const $c10f47f363f11ddf$var$rowBase = {
    extends: 'SidebarRow',
    padding: 'Z A',
    round: 'radiusPill',
    fontSize: 'A',
    // Left-align the label against its leading icon — overrides the text-align:
    // center inherited from the centered canvas overlay container (same override
    // ProjectCanvasEnvPicker already applies).
    textAlign: 'left',
    MoreBtn: null,
    color: 'subtitle',
    // `hover` is the theme-mirrored interaction wash (DESIGN_LANGUAGE.md §4.3) —
    // proven to read in both themes here against this identical canvas-card-glass
    // theme, same as CanvasNavbar / CanvasMainNavbar.
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // House active/selected recipe — `selected` fill + title text, the SAME
    // `activeHighlight` AppNavbar's active route, the workspace switcher and the
    // settings rail all use (2026-08-02 per Nika "fix ui of selected navbar" —
    // the previous rgba(255,255,255,0.1) was a raw, non-token, non-theme-aware
    // value copy-pasted from /tickets + /infra rather than the house pattern;
    // `_activeHighlight.js` itself later moved off the near-opaque `overlayStrong`
    // wash per DESIGN_LANGUAGE.md §4.3 — this spread picks that up for free).
    // fontWeight is this row's own addition on top of the shared recipe.
    '.isActive': ()=>({
            ...$c10f47f363f11ddf$var$getActiveHighlight()['.isActive'],
            fontWeight: '700'
        })
};
const $c10f47f363f11ddf$export$39ac760ebd886a74 = {
    ...$c10f47f363f11ddf$var$rowBase,
    isActive: (el, s)=>$c10f47f363f11ddf$var$canvasActiveFilter(s) === s.key,
    Icon: {
        icon: (el, s)=>s.icon,
        boxSize: 'A1 A1',
        color: 'caption',
        isActive: (el, s)=>$c10f47f363f11ddf$var$canvasActiveFilter(s) === s.key,
        '.isActive': {
            color: 'title'
        }
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>el.call('polyglot', s.label)
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('setCanvasFilter', s.key);
    }
};
// PAGES list: the board pages (Figma-style, Nika 2026-08-01), each followed by
// the project's own pages whose tiles it holds, then the project pages on no
// board page (Nika 2026-10-31) — rows from canvasPagesGroupRows
// (functions/projectCanvasSidebar.js). A board page row switches the active
// page (swapping the board's item set); a project page row shows its tile.
const $c10f47f363f11ddf$var$pageChildren = (el)=>{
    const rows = el.call('canvasPagesGroupRows') || [];
    // Trailing "Add page" row — a synthetic entry so it renders alongside the
    // dynamic pages under `childrenAs: 'state'` (a static sibling key is dropped
    // by the state-children reconcile). It holds every key the other rows hold:
    // a key a row lacks reads through to ROOT state.
    // Its words resolve HERE, in the session language: the row's Label reads
    // `s.name` off STATE (where neither a template nor a function value
    // survives), and a board page's `name` is saved data that must never pass
    // through polyglot. This builder runs in an effect, so the polyglot read
    // (root `lang`) re-runs it on a language switch.
    return [
        ...rows,
        {
            key: '__add',
            id: '__add',
            name: el.call('polyglot', 'canvas.sidebar.pages.add'),
            _active: false,
            _isAdd: true,
            _route: '',
            _nested: false
        }
    ];
};
const $c10f47f363f11ddf$export$59a7f8f8737a3096 = {
    ...$c10f47f363f11ddf$var$rowBase,
    isActive: (el, s)=>!!s._active,
    // A project page row under the board page that holds its tile indents so its
    // icon lines up with that board page's label: the row's own padding (A) +
    // icon box (A1) + icon-label gap (Z1), all in the row's em. Nesting reads
    // from the left padding alone — no guide line (design-direction.md §8).
    isNested: (el, s)=>!!s._nested,
    '.isNested': {
        paddingLeft: 'calc(A + A1 + Z1)'
    },
    Icon: {
        // `'file'` is not a registered icon name (brand/designSystem icons — 553
        // entries, no `file`; verified live in this catalog and confirmed the
        // real canvas rail's page rows render the identical blank glyph, so this
        // is a real component bug, not a catalog artifact: fable CAT-5 #7's
        // "empty pill" is `Icon` painting nothing plus `Label.text: s.name`
        // reading empty state on the bare catalog mount, stacked in one cell).
        // `'document'` is the registered name for this exact page/file glyph.
        // A project page row (`_route`) takes `'copy'` — the glyph of the FILTER
        // group's "Pages" row, the same project-page bucket.
        icon: (el, s)=>s._isAdd ? 'plus' : s._route ? 'copy' : 'document',
        boxSize: 'A1 A1',
        color: 'caption',
        isActive: (el, s)=>!!s._active,
        '.isActive': {
            color: 'title'
        }
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.name,
        // Swaps out for the inline rename input. Reactive `display:` predicate —
        // NOT `hide:` (a mounted-hidden element short-circuits and never comes
        // back) and not a `style: {}` wrapper (FA108: display is a flat CSS prop).
        display: (el, s)=>s.root._canvasPageRenaming === s.id ? 'none' : 'block'
    },
    // Inline rename editor. Shown only for the row being renamed; seeds + focuses
    // itself on the render the flag triggers, so no lookup/querySelector reach-in.
    RenameInput: {
        tag: 'input',
        type: 'text',
        flex: '1',
        minWidth: '0',
        fontSize: 'Z2',
        color: 'title',
        background: 'overlayStrong',
        borderWidth: '0',
        round: 'radiusControl',
        padding: 'V Y',
        // Reveal + focus are scheduled from THIS factory rather than an `onRender`
        // hook: v3.14 fires onRender on the initial render only, so the flag flip
        // that reveals the editor never ran it and the field opened unfocused. The
        // factory re-runs on every state change, and the microtask defers the
        // focus until after this display value has actually been applied (focusing
        // a still-`display: none` node is a silent no-op). Guarded on
        // activeElement so re-renders while typing never steal the caret back to a
        // full selection.
        display: (el, s)=>{
            const renaming = s.root._canvasPageRenaming === s.id;
            if (renaming) queueMicrotask(()=>{
                if (!el.node || s.root._canvasPageRenaming !== s.id) return;
                if (typeof document !== 'undefined' && document.activeElement === el.node) return;
                el.node.focus();
                el.node.select();
            });
            return renaming ? 'block' : 'none';
        },
        // Controlled by state, never `el.node.value = …` (FA511). The draft lives in
        // `_canvasPageRenameDraft` so a re-render mid-edit re-renders what the user
        // typed instead of resetting the field to the page's stored name.
        value: (el, s)=>s.root._canvasPageRenaming === s.id ? s.root._canvasPageRenameDraft || '' : s.name || '',
        onInput: (e, el)=>el.call('setBoardPageRenameDraft', el.node.value),
        // Keep the row's click (switch page) from firing while editing.
        onClick: (e)=>e.stopPropagation(),
        onPointerdown: (e)=>e.stopPropagation(),
        onKeydown: (e, el, s)=>{
            e.stopPropagation();
            if (e.key === 'Enter') el.call('commitRenameBoardPage', s.id);
            else if (e.key === 'Escape') el.call('cancelRenameBoardPage');
        },
        onBlur: (e, el, s)=>{
            if (s.root._canvasPageRenaming === s.id) el.call('commitRenameBoardPage', s.id);
        }
    },
    // A project page row shows its tile: opens the board page holding it, then
    // centres + selects it (focusProjectPage).
    onClick: (e, el, s)=>{
        e.preventDefault();
        if (s._isAdd) el.call('addBoardPage');
        else if (s._route) el.call('focusProjectPage', s._route);
        else el.call('switchBoardPage', s.id);
    },
    onContextmenu: (e, el, s)=>el.call('boardPageContextmenu', e, s)
};
// ── ITEMS — the entity (data-item) nodes on the ACTIVE board page ──────────
// Spec §3.4. Reads the same `boardEntityItems()` list the AI attachment and the
// expander use, so the rail can never disagree with what is on the board. Click
// centres the node at the live zoom and selects it (focusCanvasEntity), which
// is the same action the assistant's source chips fire.
const $c10f47f363f11ddf$var$entityChildren = (el)=>{
    const rows = el.call('boardEntityItems') || [];
    const v2 = el.call('getCanvasV2');
    const primary = v2 && v2.selection && v2.selection.primary || null;
    return rows.map((r)=>({
            ...r,
            _active: r.key === primary
        }));
};
const $c10f47f363f11ddf$export$19140372a0b71780 = {
    ...$c10f47f363f11ddf$var$rowBase,
    isActive: (el, s)=>!!s._active,
    Icon: {
        icon: (el, s)=>s.icon || 'document',
        boxSize: 'A1 A1',
        color: 'caption',
        isActive: (el, s)=>!!s._active,
        '.isActive': {
            color: 'title'
        }
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // A resolved entity title, or the bare ref while the card is still
        // loading. A DATA value either way — never routed through polyglot.
        text: (el, s)=>s.title
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('focusCanvasEntity', s.key);
    }
};
const $c10f47f363f11ddf$export$7546a2b9834fd5e0 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    width: '100%',
    padding: 'Z A',
    round: 'radiusPill',
    fontSize: 'A',
    cursor: 'pointer',
    borderWidth: '0',
    textAlign: 'left',
    background: 'transparent',
    color: 'subtitle',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    // Press and keyboard focus take the SidebarRow states (workspace
    // components/SidebarRow.js), so the picker reads like the rows beside it.
    ':active': {
        background: 'selected',
        color: 'title'
    },
    ':focus-visible': {
        background: 'selected',
        color: 'title'
    },
    subscribeTo: [
        '_canvasEnv'
    ],
    Dot: {
        boxSize: 'X',
        minWidth: 'X',
        round: '100%',
        background: 'caption'
    },
    Label: {
        tag: 'span',
        flex: '1',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>el.call('polyglot', $c10f47f363f11ddf$var$envName(s))
    },
    Chevron: {
        extends: 'Icon',
        name: 'chevronDown',
        boxSize: 'Z1',
        color: 'caption'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        el.call('openDropdown', {
            id: 'projectCanvasEnv',
            anchorEl: el,
            placement: 'bottom-start',
            content: {
                extends: 'CanvasCreateMenuBody',
                aria: {
                    label: (el)=>el.call('polyglot', 'canvas.sidebar.env.group')
                },
                ...$c10f47f363f11ddf$var$canvasEnvMenuRows(s.root, el)
            }
        });
    }
};
const $c10f47f363f11ddf$export$a3ba45a28a0d377e = {
    // THE PAGE-SIDEBAR RULE (Nika 2026-10-29: "… move sidebar at the right - if
    // navbar is at the left, and opposite … make them consistent and make them
    // toggleable"; the pick "Hide fully, remember per page"; 21:42 "Same rule
    // for all"): the rail is the shared AppSidebar column — the page-nav mark,
    // the side rule, the one hide button in its card's corner and the reopen
    // tab (shared functions/pageSidebar.js). Its own x, the left-edge reopen
    // island and the session flag `_sidebarsHidden` that drove them are gone.
    // The project page opts its DESKTOP mount in (pages/main.js); the phone
    // sheet shows the same rail inline.
    extends: 'AppSidebar',
    position: 'fixed',
    // Clear of a drawer the assistant docks on the left, as the mirror below
    // clears one on the right (`--assistant-inset-left`).
    left: 'calc(var(--assistant-inset-left, calc(var(--spacing-A) * 0)) + var(--spacing-X2))',
    // THE MIRROR (the infra rail's form — infra components/InfraSidebar.js):
    // beside a left navbar the rail takes the right edge, clear of a drawer the
    // assistant docks there (`--assistant-inset-right`, zero when nothing is
    // docked or outside the shell — the token-only zero fallback). The column
    // hosts one card and no chrome, so the shared mirror's turned padding and
    // its step over the AppMain gutter stay off.
    '&[data-sidebar-side="right"]': {
        left: 'auto',
        right: 'calc(var(--assistant-inset-right, calc(var(--spacing-A) * 0)) + var(--spacing-X2))',
        padding: '0',
        marginLeft: '0',
        '@mobileL': {
            padding: '0'
        },
        '@appMobile': {
            padding: '0'
        }
    },
    // --shell-top — the shared canvas-rail top inset (px-pinned via @property
    // in app.js); was a stale 'D1' ~16px below every other rail. (2026-07-06
    // per Nika "make sure sidebar positions are consistent".)
    top: '--shell-top',
    width: 'G1',
    minWidth: 'G1',
    maxWidth: 'G1',
    // S4 (tickets/sonnet.md, NIKA BATCH 2026-08-16): was a hardcoded
    // `calc(100vh - 120px)` approximating the composer's live clearance.
    // Bottom now tracks the SAME --slot-bottom CanvasPageSlot itself uses.
    bottom: '--slot-bottom',
    // Docked rail band — below the platform AppHeader on purpose (was 1200,
    // which outranked it; see globalScope.js's "Canvas layering contract",
    // Nika 2026-08-02).
    zIndex: (0, $fzbiH.CANVAS_RAIL),
    // A column of one card (no chrome on the column itself): the card carries
    // the glass, the column only places it.
    flow: 'y',
    padding: '0',
    // Match TicketsSidebar / InfraSidebar scale (em-based tokens otherwise render
    // ~1.2× bigger off a plain object root).
    fontSize: 'Z',
    '@mobileL': {
        padding: '0',
        overflow: 'visible'
    },
    // A narrow app surface keeps the rail's own fixed posture (the shared
    // column's narrow rule would make a fixed rail the viewport's width).
    '@appMobile': {
        width: 'G1',
        minWidth: 'G1',
        maxWidth: 'G1',
        maxHeight: 'none',
        padding: '0',
        overflow: 'visible'
    },
    // No view switcher on the project canvas (the shared one hides itself off
    // its own routes; null says so here).
    ViewSwitcher: null,
    // THE HIDE BUTTON: one Y inside the card's corner on both sides (the shared
    // offsets add a column's padding; this column has none). The card's first
    // row is the PAGES caption, so the corner is free.
    SidebarToggle: {
        top: 'Y',
        right: 'Y',
        '&[data-side="right"]': {
            right: 'Y'
        }
    },
    // ── The rail's one card: the glass, and the groups inside it ──
    // The surface is the column's sidebar card (shared AppSidebar childExtends
    // AppSidebarCard, Nika 2026-10-30 "A: navbar glass").
    RailCard: {
        // hidden (was auto): the whole card used to scroll, so on any project with
        // more than ~a dozen pages the ENVIRONMENT + PROJECT groups (Preview /
        // Version history / Publish) sat entirely below the fold with zero
        // affordance — users never saw them at all (2026-08-08 per Nika "add
        // publish, preview in left sidebar" — they were already here, just buried).
        // Now PAGES is the internal scroll region and the action groups stay
        // pinned; see PagesGroup below.
        overflow: 'hidden',
        flow: 'y',
        minHeight: '0',
        // ── PAGES — Figma-style board pages (Nika 2026-08-01) + the project's own
        // pages under the board page holding each tile (Nika 2026-10-31) ──
        PagesGroup: {
            extends: 'AppSidebarGroup',
            label: (el)=>el.call('polyglot', 'canvas.sidebar.group.pages'),
            // THE scroll region: the card is content-height (it hugs its groups), so
            // pages get a BOUNDED viewport-share and scroll internally — the groups
            // after them (FILTER / ENVIRONMENT / PROJECT with Preview / Version
            // history / Publish) always stay on screen. A pure flex:1 collapses here
            // (auto-height flex parent → basis 0 → ~2 rows), hence the vh bound.
            List: {
                overflow: 'auto',
                maxHeight: '34vh',
                flow: 'y',
                gap: 'V',
                // `_canvasPageRenaming` too — entering/leaving rename mode must re-render
                // the rows so the Label↔RenameInput display factories re-evaluate.
                // `data` — the project's pages (root.data.pages) change on an AI write,
                // a manual add and a remote rename or delete. `_cvSelectionTick` — a
                // project page row highlights while its tile is the primary selection,
                // and a selection write mutates canvas.selection in place, bumping only
                // this tick (functions/canvas/selection.js).
                subscribeTo: [
                    'canvas',
                    '_canvasPageRenaming',
                    'data',
                    '_cvSelectionTick'
                ],
                childExtends: 'ProjectCanvasPageRow',
                children: $c10f47f363f11ddf$var$pageChildren,
                childrenAs: 'state'
            }
        },
        // ── ITEMS — entity (data-item) nodes on this board page (spec §3.4) ──
        // Mounted ALWAYS but reactively hidden while the board has none, so a normal
        // project canvas looks exactly as it did (`hide` is the one prop that
        // reactively toggles in v3.14; `subscribeTo: ['canvas']` wakes it when a node
        // is added or a board page is switched).
        ItemsGroup: {
            extends: 'AppSidebarGroup',
            label: (el)=>el.call('polyglot', 'canvas.entity.group.items'),
            subscribeTo: [
                'canvas'
            ],
            hide: (el)=>!(el.call('boardEntityItems') || []).length,
            List: {
                overflow: 'auto',
                maxHeight: '24vh',
                flow: 'y',
                gap: 'V',
                subscribeTo: [
                    'canvas'
                ],
                childExtends: 'ProjectCanvasEntityRow',
                children: $c10f47f363f11ddf$var$entityChildren,
                childrenAs: 'state'
            }
        },
        // ── FILTER — what shows on the canvas ──
        FilterGroup: {
            extends: 'AppSidebarGroup',
            label: (el)=>el.call('polyglot', 'canvas.sidebar.group.filter'),
            List: {
                flow: 'y',
                gap: 'V',
                subscribeTo: [
                    '_canvasFilter'
                ],
                childExtends: 'ProjectCanvasFilterRow',
                children: $c10f47f363f11ddf$var$filterChildren,
                childrenAs: 'state'
            }
        },
        // ── ENVIRONMENT — a select picker ──
        EnvGroup: {
            extends: 'AppSidebarGroup',
            label: (el)=>el.call('polyglot', 'canvas.sidebar.group.environment'),
            List: {
                flow: 'y',
                gap: 'V',
                Picker: {
                    extends: 'ProjectCanvasEnvPicker'
                }
            }
        },
        // ── PROJECT — actions + Publish ──
        ProjectGroup: {
            extends: 'AppSidebarGroup',
            label: (el)=>el.call('polyglot', 'canvas.sidebar.group.project'),
            List: {
                flow: 'y',
                gap: 'V',
                Preview: $c10f47f363f11ddf$var$actionItem((el)=>el.call('polyglot', 'canvas.sidebar.action.preview'), 'eye', (e, el)=>{
                    e.preventDefault();
                    el.call('openProjectPreviewPane');
                }),
                Settings: $c10f47f363f11ddf$var$actionItem((el)=>el.call('polyglot', 'canvas.sidebar.action.projectSettings'), 'settings', (e, el, s)=>{
                    e.preventDefault();
                    s.root.update({
                        settingsTab: 'project',
                        _canvasRailOpen: false
                    });
                    el.call('openCustomModal', {
                        id: 'settings',
                        width: 'overlayLg',
                        content: {
                            extends: 'SettingsModalBody'
                        }
                    });
                }),
                // Version history rail — list / preview / restore project versions (the
                // legacy platform's Versions aside, rebuilt — VersionHistoryPanel).
                Versions: $c10f47f363f11ddf$var$actionItem((el)=>el.call('polyglot', 'canvas.sidebar.action.versionHistory'), 'clockOutline', (e, el)=>{
                    e.preventDefault();
                    el.call('toggleVersionHistory');
                }),
                // Prominent publish button → the publish modal (shows the diff + publishes
                // to staging/production; the `smbls publish` equivalent).
                PublishBtn: {
                    extends: 'Button',
                    theme: 'primary',
                    type: 'button',
                    width: '100%',
                    margin: 'V 0 0',
                    text: '{{ canvas.sidebar.action.publish | polyglot }}',
                    onClick: (e, el)=>{
                        e.preventDefault();
                        el.call('openPublishModal');
                    }
                }
            }
        }
    }
};

});
parcelRegister("fzbiH", function(module, exports) {

$parcel$export(module.exports, "resolveTopWindow", () => $b552e3fb6aaf14cf$export$d32a259a84a71c23);
$parcel$export(module.exports, "MODES", () => $b552e3fb6aaf14cf$export$240b20df485e8ed6);
$parcel$export(module.exports, "HANDLE_NAMES", () => $b552e3fb6aaf14cf$export$386b472623695903);
$parcel$export(module.exports, "CANVAS_RAIL", () => $b552e3fb6aaf14cf$export$c1350ceaaed0d828);
$parcel$export(module.exports, "CANVAS_OVERLAY", () => $b552e3fb6aaf14cf$export$16e01d472f603adf);
$parcel$export(module.exports, "default", () => $b552e3fb6aaf14cf$export$2e2bcd8739ae039);
// Shared via top-level window so both editor and canvas iframe bundles
// reference the same object (Parcel creates separate module instances,
// and iframe has its own window).
// Walk up to the topmost same-origin ancestor so cross-origin embed
// (landing → editor → canvas) still shares scope between editor chrome
// and canvas iframe.
// Walk to the topmost same-origin ancestor window. Exported so other
// modules (state.js, methods/index.js) don't redefine it.
const $b552e3fb6aaf14cf$export$d32a259a84a71c23 = ()=>{
    if (typeof window === 'undefined') return globalThis;
    let w = window;
    while(w.parent && w.parent !== w)try {
        w.parent.document;
        w = w.parent;
    } catch  {
        break;
    }
    return w;
};
const $b552e3fb6aaf14cf$var$topWindow = $b552e3fb6aaf14cf$export$d32a259a84a71c23();
const $b552e3fb6aaf14cf$export$240b20df485e8ed6 = Object.freeze({
    DEFAULT: 'default',
    PAN: 'pan',
    INSPECT: 'inspect',
    INTERACT: 'interact'
});
const $b552e3fb6aaf14cf$export$386b472623695903 = Object.freeze([
    'CvHandleNW',
    'CvHandleN',
    'CvHandleNE',
    'CvHandleE',
    'CvHandleSE',
    'CvHandleS',
    'CvHandleSW',
    'CvHandleW'
]);
const $b552e3fb6aaf14cf$export$b3a44e16ee78df45 = 1100;
const $b552e3fb6aaf14cf$export$c1350ceaaed0d828 = 1000;
const $b552e3fb6aaf14cf$export$16e01d472f603adf = 950;
// Live v2 viewport mirror — written by state.js applyViewport, read by
// the panzoom shim below so the outer chrome's animation-frame loop
// always sees fresh values without waiting for component init.
if (typeof $b552e3fb6aaf14cf$var$topWindow !== 'undefined' && !$b552e3fb6aaf14cf$var$topWindow.__cvViewport) $b552e3fb6aaf14cf$var$topWindow.__cvViewport = {
    x: 40,
    y: 40,
    scale: 0.35
};
if (!$b552e3fb6aaf14cf$var$topWindow.__canvasGlobalScope) $b552e3fb6aaf14cf$var$topWindow.__canvasGlobalScope = {
    // Panzoom (v1)
    panningMode: false,
    isPanning: false,
    isGrabbing: false,
    positions: {
        x: 0,
        y: 0,
        scale: 0.35
    },
    panzoomInstance: null,
    // Selection state (element refs — NOT stored in reactive store)
    selected: null,
    selectedKey: null,
    hovered: null,
    hoveredKey: null,
    canvasElement: null,
    // Modes (v1)
    defaultMode: true,
    inspectMode: false,
    editorActive: true,
    // Inspect layers
    hoverLayer: null,
    activeLayer: null,
    layerHostComponent: null,
    inContext: null,
    // Canvas v2 feature flag — v2 state itself lives on reactive root
    // state (see functions/canvas/state.js). This scope only carries the
    // flag because it's read by both editor chrome and iframe.
    // Canvas v2 is now the default. Legacy gridstack canvas (v1) is
    // opt-in via `?canvasOld=true` or `?canvasV2=0`; also kept
    // overridable via localStorage `canvasOld` for stable bookmarks.
    canvasV2: (()=>{
        try {
            if (typeof window === 'undefined') return true;
            const sp = new URLSearchParams(window.location.search);
            if (sp.get('canvasV2') === '1') return true;
            if (sp.get('canvasV2') === '0') return false;
            if (sp.get('canvasOld') === 'true' || sp.get('canvasOld') === '1') return false;
            if (window.localStorage?.getItem('canvasOld')) return false;
            return true;
        } catch  {
            return true;
        }
    })()
};
// Install the v1-shaped panzoom shim eagerly when v2 is on so the
// shared Zoombar's per-frame loop always has something to read. The
// shim reads `topWindow.__cvViewport`, which `applyViewport` keeps
// fresh.
if ($b552e3fb6aaf14cf$var$topWindow.__canvasGlobalScope.canvasV2 && !$b552e3fb6aaf14cf$var$topWindow.__canvasGlobalScope.panzoomInstance?.__v2) {
    // Resolves the window itself rather than closing over the module-scope
    // `topWindow` const. frank lifts this named local into `globalScope.vp` as a
    // standalone function; `topWindow` is a module binding whose value is a
    // runtime call (`resolveTopWindow()`), so it is not serializable and does not
    // travel with the lift — the emitted `vp` read a free `topWindow` and threw
    // ReferenceError on the Zoombar's very first frame at a frank-served runtime.
    // `resolveTopWindow` is an exported FUNCTION, so it lifts cleanly.
    const vp = ()=>$b552e3fb6aaf14cf$export$d32a259a84a71c23().__cvViewport || {
            x: 40,
            y: 40,
            scale: 0.35
        };
    // Write path (ZOOMBAR-PRESET-DROPDOWN-DEAD-1): the mutators route through
    // the v2 camera bridge (functions/canvas/state.js installV2CameraBridge,
    // bound to the live CanvasSurface) whenever one is installed — that is the
    // real applyViewport pipeline, so the board actually moves. Writing only
    // `__cvViewport` (the pre-bridge behaviour, kept as the fallback for the
    // window before any surface has mounted) changed the Zoombar label and
    // nothing else. Same lift-safety as `vp`: resolved per call, not closed
    // over. The fallback WRITES resolve the window per call too: frank (since
    // 3.14.799) keeps this module's default export when it rebuilds
    // globalScope, so the shim's methods are emitted standalone and a write to
    // the module `topWindow` was a free name there (PUBLISH BLOCKED, 5
    // unresolvable-identifier findings on moveTo/moveBy/zoomAbs/smoothZoom/
    // smoothZoomAbs).
    const cam = ()=>$b552e3fb6aaf14cf$export$d32a259a84a71c23().__cvCamera;
    $b552e3fb6aaf14cf$var$topWindow.__canvasGlobalScope.panzoomInstance = {
        __v2: true,
        getTransform: ()=>({
                ...vp()
            }),
        moveTo: (x, y)=>{
            if (cam()) return cam().moveTo(x, y);
            $b552e3fb6aaf14cf$export$d32a259a84a71c23().__cvViewport = {
                ...vp(),
                x: x,
                y: y
            };
        },
        moveBy: (dx, dy)=>{
            if (cam()) return cam().moveBy(dx, dy);
            const v = vp();
            $b552e3fb6aaf14cf$export$d32a259a84a71c23().__cvViewport = {
                ...v,
                x: v.x + dx,
                y: v.y + dy
            };
        },
        zoomAbs: (_x, _y, scale)=>{
            if (cam()) return cam().zoomTo(scale);
            $b552e3fb6aaf14cf$export$d32a259a84a71c23().__cvViewport = {
                ...vp(),
                scale: scale
            };
        },
        smoothZoom: (cx, cy, factor)=>{
            if (cam()) return cam().zoomBy(factor);
            const v = vp();
            const ns = Math.max(0.035, Math.min(2.5, v.scale * factor));
            $b552e3fb6aaf14cf$export$d32a259a84a71c23().__cvViewport = {
                x: cx - (cx - v.x) * (ns / v.scale),
                y: cy - (cy - v.y) * (ns / v.scale),
                scale: ns
            };
        },
        smoothZoomAbs: (_x, _y, scale)=>{
            if (cam()) return cam().zoomTo(scale);
            $b552e3fb6aaf14cf$export$d32a259a84a71c23().__cvViewport = {
                ...vp(),
                scale: scale
            };
        },
        on: ()=>{},
        off: ()=>{},
        dispose: ()=>{}
    };
}
var $b552e3fb6aaf14cf$export$2e2bcd8739ae039 = $b552e3fb6aaf14cf$var$topWindow.__canvasGlobalScope;

});


parcelRegister("7gJQ9", function(module, exports) {

$parcel$export(module.exports, "CvEntityCard", () => $54ad95f278dc6ae5$export$41c557e183a9574e);
$parcel$export(module.exports, "CvEntityCardAction", () => $54ad95f278dc6ae5$export$ec2acfcfa8c7500b);
// CvEntityCard — what a canvas item renders when its key is an entity ref
// (`ref:<type>:<id>`) instead of a project page / component key.
//
// It sits exactly where `CvFrame` sits for a page tile: as the ONE child of
// CanvasItem, filling the item box. CanvasItem still owns the geometry, the
// pointer gestures (select / drag / marquee), the context menu and the
// selection chrome — this component only paints, so an entity node behaves
// like every other node on the board for free.
//
// ── WHY IT DOES NOT DECLARE ITS OWN `state` ───────────────────────────────
// It shares CanvasItem's ITEM state — the per-tile slice CvItems seeds through
// `childrenAs: 'state'` (`{ key, pageKey, type, _cvType, … }`) — and writes the
// resolved entity back onto it under `__entity` / `__entityLoading` /
// `__entityFailed`.
//
// This is not a style choice; the first cut declared `state: { entity, … }` and
// the card NEVER RENDERED. A child that declares its own `state` gets a NEW
// store, so `s._cvType` inside this component's `if:` read `undefined`, the
// gate evaluated false, and the element was never created — silently, with the
// item box, the hidden iframe and zero console output (measured live
// 2026-09-07: `CvEntityCard.__ref.__if === false` on a tile whose item state
// carried `_cvType: 'entity'`).
//
// Sharing the item state also gets the isolation the separate slice was for:
// the item state is PER TILE, not the root store, so a resolve repaints one
// card. The shared `canvas.entities` cache is written quietly alongside it
// (`preventUpdate`) because that is what the sidebar, Expand and the AI
// attachment read synchronously.
//
// The `__`-prefixed names mark fields the CARD owns on a state slice the
// SURFACE builds: CvItems' children factory returns fresh objects on every
// re-map, so a remount drops them — which is correct, because `onRender`
// re-resolves (from cache, synchronously) on the new element.
//
// ── POINTER RULES ─────────────────────────────────────────────────────────
// Everything except the two action buttons is inert (`pointerEvents: 'none'`
// on the text column) so a drag started anywhere on the card still reaches
// CanvasItem's `onPointerDown`. The buttons re-enable events for themselves
// and stop propagation on `pointerdown`, otherwise pressing Open would begin a
// drag and the click would never land.
// Every prop reads the SAME item state, so the two reads are folded into one
// helper each rather than repeated per prop.
const $54ad95f278dc6ae5$var$_entity = (s)=>s && s.__entity || null;
const $54ad95f278dc6ae5$var$_key = (s)=>s && s.key || '';
const $54ad95f278dc6ae5$export$41c557e183a9574e = {
    tag: 'div',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    flow: 'y',
    gap: 'Y',
    padding: 'Z A',
    overflow: 'hidden',
    theme: 'document',
    boxSizing: 'border-box',
    // Resolve on mount, mirror onto the item state. Guarded against the
    // double-init every canvas tile hits (Rule 15) — onRender can fire again
    // when the viewport windowing remounts a tile.
    //
    // Seeds SYNCHRONOUSLY from the shared cache first: a tile that scrolls back
    // into view, or a node placed by Expand, is already resolved, and waiting a
    // microtask to paint a value we already hold would flash 'Loading' for one
    // frame on every re-entry.
    onRender: (el, s)=>{
        if (el.__cvEntityLoaded) return;
        el.__cvEntityLoaded = true;
        const key = $54ad95f278dc6ae5$var$_key(s);
        if (!key) return;
        const cached = el.call('getCanvasEntity', key);
        if (cached && cached.data) {
            s.update({
                __entity: cached.data,
                __entityLoading: false,
                __entityFailed: !!cached.error
            });
            return;
        }
        s.update({
            __entityLoading: true
        });
        Promise.resolve(el.call('resolveCanvasEntity', key)).then((entry)=>{
            if (!el.node) return;
            s.update({
                __entity: entry && entry.data || null,
                __entityLoading: false,
                __entityFailed: !!(entry && entry.error)
            });
        }).catch(()=>{
            if (!el.node) return;
            s.update({
                __entityLoading: false,
                __entityFailed: true
            });
        });
    },
    Head: {
        flow: 'x',
        gap: 'Y',
        align: 'center left',
        pointerEvents: 'none',
        // Kind badge. The icon comes from the ref TYPE; the label is the row's own
        // `kind` field (a data value — a code identifier when the row carries
        // none), so it is deliberately not routed through polyglot.
        KindBadge: {
            extends: 'Badge',
            theme: 'transparent',
            flow: 'x',
            gap: 'X',
            align: 'center left',
            fontSize: 'Y',
            padding: 'X Y',
            Icon: {
                boxSize: 'Z1 Z1',
                color: 'caption',
                name: (el, s)=>el.call('entityRefIcon', $54ad95f278dc6ae5$var$_key(s))
            },
            Label: {
                tag: 'span',
                color: 'caption',
                whiteSpace: 'nowrap',
                text: (el, s)=>{
                    const e = $54ad95f278dc6ae5$var$_entity(s);
                    return e && e.kind || '';
                }
            }
        },
        // "Sample data" marker — the truth boundary made visible. Present only
        // when the row itself carries `data.sample`.
        SampleTag: {
            extends: 'Badge',
            theme: 'warning',
            fontSize: 'Y',
            padding: 'X Y',
            text: '{{ canvas.entity.sample | polyglot }}',
            hide: (el, s)=>{
                const e = $54ad95f278dc6ae5$var$_entity(s);
                return !(e && e.sample);
            }
        }
    },
    Title: {
        tag: 'span',
        fontSize: 'Z1',
        fontWeight: '700',
        color: 'title',
        lineHeight: '1.3',
        pointerEvents: 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>{
            const e = $54ad95f278dc6ae5$var$_entity(s);
            if (e && e.title) return e.title;
            return s.__entityLoading ? el.call('polyglot', 'common.state.loading') : el.call('polyglot', 'canvas.entity.untitled');
        }
    },
    // Up to three lines of summary.
    Summary: {
        tag: 'p',
        margin: '0',
        flex: '1',
        minHeight: '0',
        fontSize: 'Y',
        color: 'subtitle',
        lineHeight: '1.45',
        overflow: 'hidden',
        pointerEvents: 'none',
        // `display` is a registered flat CSS prop and must NOT be smuggled through
        // `style:` (FA108). Only the two unregistered `-webkit-` keys need the raw
        // escape hatch — they are the only way to clamp to a LINE COUNT (a
        // max-height in em drifts with the resolved font size).
        display: '-webkit-box',
        style: {
            WebkitLineClamp: '3',
            WebkitBoxOrient: 'vertical'
        },
        text: (el, s)=>{
            const e = $54ad95f278dc6ae5$var$_entity(s);
            if (e && e.summary) return e.summary;
            return s.__entityFailed ? el.call('polyglot', 'canvas.entity.loadFailed') : '';
        }
    },
    // status · effectiveDate · collection — the separator is punctuation, not
    // copy, and the three values are record fields.
    Meta: {
        tag: 'span',
        fontSize: 'Y',
        color: 'caption',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        pointerEvents: 'none',
        text: (el, s)=>{
            const e = $54ad95f278dc6ae5$var$_entity(s);
            if (!e) return '';
            return [
                e.status,
                e.effectiveDate,
                e.collection
            ].filter(Boolean).join(" \xb7 ");
        }
    },
    Actions: {
        flow: 'x',
        gap: 'Y',
        align: 'center left',
        childExtends: 'CvEntityCardAction',
        OpenBtn: {
            Icon: {
                name: 'arrowUpRight'
            },
            title: (el)=>el.call('polyglot', 'common.action.open'),
            aria: {
                label: (el)=>el.call('polyglot', 'common.action.open')
            },
            // No route → the control is visibly inert rather than silently doing
            // nothing when pressed (a record whose module stamped no href, or a
            // canvas ref this package cannot resolve to an /<owner>/<key> route).
            // `null`, never `false`: an attribute prop that returns false still
            // RENDERS the attribute (SYNTAX — only null/undefined remove it).
            disabled: (el, s)=>el.call('entityRefHref', $54ad95f278dc6ae5$var$_key(s)) ? null : true,
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('openCanvasEntity', $54ad95f278dc6ae5$var$_key(s));
            }
        },
        ExpandBtn: {
            Icon: {
                name: 'expand'
            },
            title: (el)=>el.call('polyglot', 'canvas.entity.expand'),
            aria: {
                label: (el)=>el.call('polyglot', 'canvas.entity.expand')
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('expandCanvasEntity', $54ad95f278dc6ae5$var$_key(s));
            }
        }
    }
};
const $54ad95f278dc6ae5$export$ec2acfcfa8c7500b = {
    tag: 'button',
    type: 'button',
    pointerEvents: 'auto',
    flow: 'x',
    align: 'center center',
    gap: 'X',
    width: 'B1',
    height: 'B1',
    round: 'radiusControl',
    borderWidth: '0',
    background: 'transparent',
    color: 'caption',
    cursor: 'pointer',
    lineHeight: '1',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    ':active': {
        background: 'selected'
    },
    ':focus-visible': {
        outline: '2px solid currentColor',
        outlineOffset: '2px'
    },
    ':disabled': {
        opacity: '0.35',
        pointerEvents: 'none'
    },
    // CanvasItem starts a drag from `onPointerDown`; without this the press that
    // begins a click on this button also begins a drag of the whole node, and the
    // click never arrives.
    onPointerdown: (e)=>e.stopPropagation(),
    // The glyph itself is set per call site (`Icon: { name: 'expand' }`); this
    // pins the SIZE once so the two actions can never drift apart.
    Icon: {
        boxSize: 'Z2 Z2'
    }
};

});

parcelRegister("domE9", function(module, exports) {

$parcel$export(module.exports, "CvEntityPickerRow", () => $9bff1563da118bf4$export$39c2b893b502dfdd);
$parcel$export(module.exports, "CvEntityPickerBody", () => $9bff1563da118bf4$export$8fc605b44865e324);
// "Data item" picker — body-only content for the @symbo.ls/windows custom
// layer (id 'cvEntityPicker'), opened from the canvas create island.
//
// Search → `sdk.execute('search', 'workspace', { query, limit: 20 })` through
// `el.call('searchCanvasEntities', …)`; picking a row adds an entity node at
// the viewport centre. The same shape as LibraryPickerBody (ModalHeader +
// sticky search header + scrolling results), with ONE deliberate difference:
// the query and the results live on THIS COMPONENT'S state, not on root.
//
// Why local state: smbls 3.14 DROPS writes to undeclared root keys, and this
// package's root-state declaration (`state.js`) is only the standalone canvas
// app's — the same picker also runs inside the workspace shell, whose root
// state this package does not own. A component-local slice cannot be dropped
// by either host and needs no cross-package declaration.
const $9bff1563da118bf4$export$39c2b893b502dfdd = {
    tag: 'button',
    type: 'button',
    width: '100%',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Y Z',
    round: 'radiusControl',
    borderWidth: '0',
    background: 'transparent',
    textAlign: 'left',
    color: 'title',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    },
    ':focus-visible': {
        outline: '2px solid currentColor',
        outlineOffset: '2px'
    },
    Icon: {
        boxSize: 'A1 A1',
        color: 'caption',
        name: (el, s)=>el.call('entityRefIcon', s.key || '')
    },
    Info: {
        flow: 'y',
        // 'W' (~2.5px) — the spacing rung nearest the hairline gap this row
        // wants. A raw px literal is an FA304 violation and the scale (base 17,
        // phi) has a rung for it: W sits one step below X.
        gap: 'W',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.title || s.key
        },
        Snippet: {
            tag: 'span',
            fontSize: 'Z',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.snippet || ''
        }
    },
    // The surface the hit came from ('documents', 'mail', …) — a code-ish
    // routing identifier the search endpoint returns, not UI copy.
    Surface: {
        tag: 'span',
        fontSize: 'Z',
        color: 'caption',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.surface || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        el.call('addCanvasEntityItem', s.key);
        el.call('closeModal', 'cvEntityPicker');
    }
};
const $9bff1563da118bf4$export$8fc605b44865e324 = {
    position: 'relative',
    // Fills its windows-kit window: the opener sizes the window (overlayMd,
    // the same as the library and integration pickers).
    width: '100%',
    maxHeight: '60vh',
    theme: 'dialog',
    round: 'radiusSheet',
    shadow: 'overlay',
    flow: 'y',
    overflow: 'hidden',
    padding: 'B',
    state: {
        query: '',
        rows: [],
        loading: false,
        searched: false
    },
    ModalHeader: {
        Hgroup: {
            H: {
                text: '{{ canvas.entity.picker.title | polyglot }}'
            },
            P: {
                text: '{{ canvas.entity.picker.subtitle | polyglot }}'
            }
        }
    },
    Header: {
        padding: 'A 0',
        flow: 'y',
        gap: 'V',
        background: 'overlay',
        SearchInput: {
            tag: 'input',
            type: 'text',
            placeholder: (el)=>el.call('polyglot', 'canvas.entity.picker.placeholder'),
            theme: 'field',
            minHeight: 'controlH',
            padding: '0 Z2',
            round: 'radiusControl',
            border: 'hairline solid line',
            color: 'title',
            fontSize: 'Z2',
            value: (el, s)=>s.query || '',
            onRender: (el)=>{
                if (el.__autofocused) return;
                el.__autofocused = true;
                setTimeout(()=>el.node?.focus?.(), 50);
            },
            // Debounced through `el.scope` (non-reactive per-instance storage — the
            // documented home for a timer handle). Typing writes the query
            // immediately so the field stays controlled; only the network call waits.
            onInput: (e, el, s)=>{
                const value = el.node.value;
                s.update({
                    query: value
                });
                if (el.scope.timer) clearTimeout(el.scope.timer);
                el.scope.timer = setTimeout(()=>{
                    el.scope.timer = null;
                    if (!el.node) return;
                    s.update({
                        loading: true
                    });
                    Promise.resolve(el.call('searchCanvasEntities', value)).then((rows)=>{
                        if (!el.node) return;
                        s.update({
                            rows: rows || [],
                            loading: false,
                            searched: true
                        });
                    }).catch(()=>{
                        if (!el.node) return;
                        s.update({
                            rows: [],
                            loading: false,
                            searched: true
                        });
                    });
                }, 250);
            }
        }
    },
    Results: {
        flow: 'y',
        gap: 'V',
        overflow: 'auto',
        flexGrow: '1',
        padding: 'V',
        childExtends: 'CvEntityPickerRow',
        childrenAs: 'state',
        children: (el, s)=>Array.isArray(s.rows) ? s.rows : []
    },
    // Kept MOUNTED and toggled by visibility rather than `if:`-gated, so the
    // panel's height does not jump between "searching" and "no results"
    // (Rule 66 — chrome must never move what is already on screen).
    Empty: {
        tag: 'p',
        margin: '0',
        padding: 'Z A B',
        fontSize: 'Z1',
        color: 'caption',
        text: '{{ canvas.entity.picker.empty | polyglot }}',
        visibility: (el, s)=>s.searched && !s.loading && !s.rows.length ? 'visible' : 'hidden',
        height: (el, s)=>s.searched && !s.loading && !s.rows.length ? 'auto' : '0',
        overflow: 'hidden'
    }
};

});

parcelRegister("bgOfo", function(module, exports) {

$parcel$export(module.exports, "teamAndAgents", () => $83482a6ad78aef6f$export$1017e348726566fa);
$parcel$export(module.exports, "TeamPersonNode", () => $83482a6ad78aef6f$export$b0ae750a70300393);
$parcel$export(module.exports, "TeamAgentNode", () => $83482a6ad78aef6f$export$a39a2925c6f6277c);
$parcel$export(module.exports, "TeamMemberModal", () => $83482a6ad78aef6f$export$7bd57608fd0456fe);
$parcel$export(module.exports, "AgentModal", () => $83482a6ad78aef6f$export$9e01ca19610ab51c);
$parcel$export(module.exports, "AgentPermChip", () => $83482a6ad78aef6f$export$9c52fa2b6d6e98f2);
$parcel$export(module.exports, "AgentToolRow", () => $83482a6ad78aef6f$export$b191a533745f07ad);
$parcel$export(module.exports, "AgentAssigneeRow", () => $83482a6ad78aef6f$export$f2dbf3051bab3e04);
$parcel$export(module.exports, "AgentAssignChip", () => $83482a6ad78aef6f$export$79a32f1afddeb210);
// /team-and-agents — agentic + people orchestration canvas.
//
// Same panzoom + Board + Dots + Connections stack /studios uses, but
// the nodes are People + Agents instead of project tiles. Modeled on
// canvas/pages/studios.js so a future refactor can lift the shared
// panzoom shell out into one base component.
//
// Surface:
//   - Panzoom canvas (mouse-wheel pan, ⌘/ctrl + wheel zoom, drag-pan
//     when the cursor isn't on a node).
//   - Person cards (avatar + name + role/email) — draggable.
//   - Agent cards (◆ glyph + name + caption) — draggable.
//   - SVG connections layer between nodes, derived from
//     `agent.boundTo` defaults + user-added `root._tagConnections`.
//   - Click a node → opens TeamMemberModal / AgentModal with details.
//     Agent modal renders the full `skills/agents/<id>.md` instructions
//     (bundled in canvas/functions/agentInstructions.js).
//   - Connect mode: header toggle → click first node → click second
//     node → adds a `{from,to}` pair to `root._tagConnections`.
//
// State surface on root:
//   - _tagPositions: { [id]: { x, y } }    — per-node coords
//   - _tagConnections: [{ from, to }]      — user-added links
//   - _tagConnectMode: boolean             — header toggle
//   - _tagConnectFrom: string | null       — first picked node
//   - _selectedTeamMember: person | null   — TeamMemberModal target
//   - _selectedAgent: agent | null         — AgentModal target
// initPanzoomBoard + the geom helpers (pointInRect / nodeUnderPoint /
// groupBbox / bezierBetweenNodes) live in canvas/functions/ and are
// registered as `el.call(...)` methods via canvas/context.js. We invoke
// them through the function registry rather than importing — keeps
// /team-and-agents on the same reuse contract every other canvas page
// follows (studios, embed/CanvasScene, /analytics/map).
//
// The agent personas (`AGENT_INSTRUCTIONS`, ~80 KB of markdown) load on
// demand: only provisioning and the agent editor read them, never a render.
// A static import put them in the shell's EAGER entry (this page rides
// canvas/components/eagerSlice.js), so every cold boot downloaded them;
// workspace/__tests__/entryBoundary.test.js holds the boundary.

var $d3gaB = parcelRequire("d3gaB");

var $5xbNK = parcelRequire("5xbNK");

var $6ocCI = parcelRequire("6ocCI");

var $kcLMl = parcelRequire("kcLMl");
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $cnoxk = parcelRequire("cnoxk");

var $29wU0 = parcelRequire("29wU0");

var $bQFOG = parcelRequire("bQFOG");

var $eY4Ct = parcelRequire("eY4Ct");

const $83482a6ad78aef6f$var$_agentInstructions = ()=>(parcelRequire("lHfYz")).then((m)=>m.AGENT_INSTRUCTIONS || {});
// Create-menu rows (New human / New agent) — shared by the floating "+" island
// AND the background right-click cascade menu (single source). `root` captured
// from the opener (the dropdown portal doesn't inherit page state);
// `closeDropdown()` with no id closes the top layer, so both openers work.
const $83482a6ad78aef6f$var$tagCreateRows = (root)=>{
    const rows = {};
    // /agents is agents-only — the "Human" create row is hidden there (only on
    // /team-and-agents + /my-agents can you invite a teammate).
    if (!root?._canvasAgentsOnly) rows.NewHuman = {
        extends: 'CanvasCreateMenuItem',
        label: (el)=>el.call('polyglot', 'canvas.team.create.humanLabel'),
        hint: (el)=>el.call('polyglot', 'canvas.team.create.humanHint'),
        iconName: 'user',
        onClick: (ev, it)=>{
            it.call('closeDropdown');
            root?.update({
                _createMemberOpen: true,
                _createMemberError: null
            });
        }
    };
    rows.NewAgent = {
        extends: 'CanvasCreateMenuItem',
        label: (el)=>el.call('polyglot', 'canvas.team.create.agentLabel'),
        hint: (el)=>el.call('polyglot', 'canvas.team.create.agentHint'),
        iconName: 'star',
        onClick: (ev, it)=>{
            it.call('closeDropdown');
            root?.update({
                _createAgentOpen: true,
                _createAgentError: null
            });
        }
    };
    // Activate agents — provision the whole seed roster as real, assignable,
    // chainable Mongo agents in one click (idempotent). Hidden once every seed
    // agent is already real (nothing left to provision).
    if (($83482a6ad78aef6f$var$_agents(root) || []).some((a)=>a && a.id && !a.userId)) rows.ActivateAgents = {
        extends: 'CanvasCreateMenuItem',
        label: (el)=>el.call('polyglot', 'canvas.team.create.activateLabel'),
        hint: (el)=>el.call('polyglot', 'canvas.team.create.activateHint'),
        iconName: 'zap',
        onClick: (ev, it)=>{
            it.call('closeDropdown');
            if (root?._agentsProvisioning) return;
            root?.update({
                _agentsProvisioning: true
            });
            $83482a6ad78aef6f$var$_provisionSeedAgents(root).then((r)=>root?.update({
                    _agentsProvisioning: false,
                    _tagToast: {
                        kind: 'ok',
                        text: r.created ? it.call('polyglot', r.created === 1 ? 'canvas.team.toast.activatedOne' : 'canvas.team.toast.activatedMany').replace('{count}', r.created) : it.call('polyglot', 'canvas.team.toast.allActive')
                    }
                })).catch((err)=>root?.update({
                    _agentsProvisioning: false,
                    _tagToast: {
                        kind: 'error',
                        text: err && err.message || 'canvas.team.toast.activationFailed'
                    }
                }));
        }
    };
    // Run chain — execute the user-connected agents as a Simone-driven chain.
    // Shown only once the user has drawn at least one agent→agent link.
    if ($83482a6ad78aef6f$var$_agentChainEdges(root).length > 0) rows.RunChain = {
        extends: 'CanvasCreateMenuItem',
        label: (el)=>el.call('polyglot', 'canvas.team.create.runChainLabel'),
        hint: (el)=>el.call('polyglot', 'canvas.team.create.runChainHint'),
        iconName: 'play',
        onClick: (ev, it)=>{
            it.call('closeDropdown');
            $83482a6ad78aef6f$var$_runAgentChain(root, it);
        }
    };
    return rows;
};
// ─── Constants ────────────────────────────────────────────────
const $83482a6ad78aef6f$var$PERSON_W = 220;
const $83482a6ad78aef6f$var$PERSON_H = 96;
const $83482a6ad78aef6f$var$AGENT_W = 220;
const $83482a6ad78aef6f$var$AGENT_H = 110;
const $83482a6ad78aef6f$var$ROW_GAP = 40;
const $83482a6ad78aef6f$var$COL_GAP = 56;
// Person avatars use the shared built-in Avatar (DiceBear image via
// el.call('avatarUrlFor', email)) — no local color/initials helpers.
// ─── Team category (§unified-perms PR #9) ─────────────────────
//
// Canvas can't import from @symbo-ls/workspace-shell (would create a
// circular dep — shell re-exports canvas), so the small bits of the
// 5-category model needed for color/cluster live inline. Keep these in
// lockstep with workspace/packages/workspace/functions/permissions.js.
const $83482a6ad78aef6f$var$CATEGORIES = [
    'manager',
    'active',
    'passive',
    'external',
    'archived'
];
const $83482a6ad78aef6f$var$_effectiveCategory = (teams)=>{
    if (!teams || !teams.length) return 'none';
    const set = new Set(teams.map((t)=>t && t.category).filter(Boolean));
    for (const cat of $83482a6ad78aef6f$var$CATEGORIES)if (set.has(cat)) return cat;
    return 'none';
};
// Color map for category-based node coloring. Picks colors from the
// design-system palette so dark/light themes both work. `none` stays
// neutral so unassigned people don't visually compete with team rows.
const $83482a6ad78aef6f$var$_categoryColor = (cat)=>{
    if (cat === 'manager') return 'purple';
    if (cat === 'active') return 'blue';
    if (cat === 'passive') return 'gray';
    if (cat === 'external') return 'orange';
    if (cat === 'archived') return 'red';
    return 'line';
};
// Resolve a person's dominant category. `root.teamsByUserId[p.userId]` (id-first)
// or `root.teamsByEmail[email]` (fallback) ships per-row `category` (loadAllTeams
// synthesizes it from root.teams), so no second lookup is needed.
// id-first (resolves for non-mgmt viewers whose rows carry no email), email
// fallback (mgmt viewers + optimistic writes) — tickets/fable.md P0 regression.
const $83482a6ad78aef6f$var$_personCategory = (root, p)=>{
    if (!p) return 'none';
    const byId = p.userId != null ? root?.teamsByUserId?.[String(p.userId)] : null;
    const memberships = Array.isArray(byId) && byId.length && byId || p.email && root?.teamsByEmail?.[String(p.email).toLowerCase()] || null;
    return $83482a6ad78aef6f$var$_effectiveCategory(memberships);
};
// Categories that count as INACTIVE for the /my-agents lens. Everything
// else (active, manager, unassigned) is treated as an active member — so
// the personalized view keeps managers + uncategorized teammates but drops
// the explicitly inactive ones.
const $83482a6ad78aef6f$var$_INACTIVE_CATEGORIES = new Set([
    'passive',
    'external',
    'archived'
]);
const $83482a6ad78aef6f$var$_isActiveMember = (root, p)=>!$83482a6ad78aef6f$var$_INACTIVE_CATEGORIES.has($83482a6ad78aef6f$var$_personCategory(root, p));
// ─── Presence helpers ─────────────────────────────────────────
//
// Person nodes show an online dot when their email appears in
// root.onlineUsers (populated by useOnlinePresence — see
// shared/functions/presence.js). Agent nodes pulse when their slug
// matches a recent root.triage.agentPresence entry (last_heartbeat
// within 5 minutes — same threshold the /tickets dashboard uses).
//
// Both gracefully degrade when their source state isn't loaded yet
// (presence not subscribed, triage not fetched): the indicators just
// don't show.
// The peer's live presence status, read from `root.presenceById` — a per-id
// reactive map (lowercased email → 'online' | 'idle') maintained by
// useOnlinePresence ALONGSIDE the canonical `onlineUsers` array (see
// shared/functions/presence.js). Reading `presenceById[email]` subscribes each
// dot to ITS OWN id's signal, so a presence tick repaints only the node whose
// status changed — not all ~508. Absent key === offline.
//
// This replaced a linear `.find()` over `onlineUsers`: because every dot read
// the one shared array, any user's presence change re-ran every dot's `hide`
// factory (a full-board tick that janked on iPad).
const $83482a6ad78aef6f$var$_personStatus = (root, email)=>{
    if (!email) return null;
    const byId = root?.presenceById;
    if (!byId) return null;
    return byId[String(email).toLowerCase()] || null;
};
// Online = present AND not flagged idle. A present peer with no status is
// tracked as 'online' by presence.js, so this never regresses to invisible.
const $83482a6ad78aef6f$var$_isPersonOnline = (root, email)=>{
    const status = $83482a6ad78aef6f$var$_personStatus(root, email);
    return !!status && status !== 'idle';
};
// Idle = present AND explicitly flagged idle. Mutually exclusive with
// _isPersonOnline; both are false when the peer isn't present at all.
const $83482a6ad78aef6f$var$_isPersonIdle = (root, email)=>$83482a6ad78aef6f$var$_personStatus(root, email) === 'idle';
const $83482a6ad78aef6f$var$AGENT_PULSE_MS = 300000;
const $83482a6ad78aef6f$var$_isAgentPulsing = (root, agentSlug)=>{
    if (!agentSlug) return false;
    // Two state slots are checked so we don't depend on /tickets having
    // been visited first: the canonical `root.triage.agentPresence` (set
    // by ticketStore on /tickets) or `root._tagAgentPresence` (set by
    // the lightweight standalone fetch below).
    const presence = root?.triage?.agentPresence || root?._tagAgentPresence;
    if (!Array.isArray(presence) || presence.length === 0) return false;
    const slug = String(agentSlug).toLowerCase();
    const now = Date.now();
    for (const p of presence){
        if (String(p?.agent_name || '').toLowerCase() !== slug) continue;
        if (!p?.last_heartbeat) continue;
        const age = now - new Date(p.last_heartbeat).getTime();
        if (age >= 0 && age < $83482a6ad78aef6f$var$AGENT_PULSE_MS) return true;
    }
    return false;
};
const $83482a6ad78aef6f$var$AGENT_IDLE_MS = 1800000;
// Idle = the heartbeat has gone quiet (past the 5-min online window) but is
// still within 30 min — the agent is present but not actively pulsing. Cards
// show online (green pulse) vs idle (amber dot). (2026-06-19 per Nika "cards
// should show if members are online or idle".)
const $83482a6ad78aef6f$var$_isAgentIdle = (root, agentSlug)=>{
    if (!agentSlug) return false;
    const presence = root?.triage?.agentPresence || root?._tagAgentPresence;
    if (!Array.isArray(presence) || presence.length === 0) return false;
    const slug = String(agentSlug).toLowerCase();
    const now = Date.now();
    for (const p of presence){
        if (String(p?.agent_name || '').toLowerCase() !== slug) continue;
        if (!p?.last_heartbeat) continue;
        const age = now - new Date(p.last_heartbeat).getTime();
        if (age >= $83482a6ad78aef6f$var$AGENT_PULSE_MS && age < $83482a6ad78aef6f$var$AGENT_IDLE_MS) return true;
    }
    return false;
};
// Live "working now" check — reads the in-turn `root.activeProcesses[]` populated
// by the Simone chat transport (delegate_tasks / chain_agents → onProcessActive),
// which is on the SAME workspace app root as this canvas. True when a delegated
// sub-agent matching this slug is currently RUNNING, so the canvas lights up the
// agents Simone is actively using THIS turn. Matches by seedSlug (canonical) or
// agentName. Independent of the heartbeat/presence path (dormant — Option B, the
// long-running ticket-work viz, is a separate later phase).
const $83482a6ad78aef6f$var$_isAgentWorking = (root, agentSlug)=>{
    if (!agentSlug) return false;
    const list = root?.activeProcesses;
    if (!Array.isArray(list) || list.length === 0) return false;
    const slug = String(agentSlug).toLowerCase();
    for (const p of list){
        if (p?.status !== 'running') continue;
        if (String(p?.seedSlug || '').toLowerCase() === slug || String(p?.agentName || '').toLowerCase() === slug) return true;
    }
    return false;
};
// Lightweight agent-presence poll for /team-and-agents. Mirrors the
// presence-only slice of `fetchGeneralTriage` — same Supabase REST
// endpoint, no ticket fetch — so the canvas can render the pulse
// indicator without paying the full triage round-trip every minute.
// WORKSPACE_ID matches the hard-coded id used by fetchGeneralTriage;
// a multi-tenant refactor is a follow-up shared between both pages.
// Symbols System workspace id — the workspace whose agentic flow used to load
// globally. Now used only to (a) key the Symbols-only epic seed + connections
// and (b) target presence when the Symbols workspace itself is active.
const $83482a6ad78aef6f$var$SYMBOLS_WS_ID = '69e5911201b0ef47b675463f';
// Active workspace id (drift-corrected: prefer the resolved workspace over the
// JWT claim, which lags org switches — mirrors scopedClient.activeWorkspaceId).
const $83482a6ad78aef6f$var$_canvasActiveWsId = (root)=>root?.workspace?.id || root?.jwtClaims?.active_workspace_id || null;
const $83482a6ad78aef6f$var$_TAG_PRESENCE_POLL_MS = 30000;
// agent_presence — Mongo, via /core/agent-presence (workspace-scoped, flat
// wire shape). Migrated off Supabase REST on 2026-07-03; mirrors the reader
// in tickets/functions/fetchGeneralTriage.js.
const $83482a6ad78aef6f$var$_tagPresenceUrl = (wsId)=>`${(0, $29wU0.workspaceApiBase)()}/core/agent-presence?workspace=${wsId}`;
const $83482a6ad78aef6f$var$_fetchTagAgentPresence = async (root)=>{
    if (!root?.update) return;
    // Per-workspace presence — query the ACTIVE workspace, not a hard-coded one
    // (2026-06-17 per Nika "agentic flow per workspace, not global").
    const wsId = $83482a6ad78aef6f$var$_canvasActiveWsId(root);
    if (!wsId) return;
    try {
        const res = await fetch($83482a6ad78aef6f$var$_tagPresenceUrl(wsId), {
            headers: (0, $cnoxk.coreHeaders)()
        });
        if (!res.ok) return;
        const list = await res.json();
        if (Array.isArray(list)) root.update({
            _tagAgentPresence: list
        });
    } catch (err) {
        /* network blip — try again next tick */ console.warn('[team-and-agents] presence poll failed', err);
    }
};
// Resolve a team-group's category. `groupId` is `'team:NAME'`. We join
// against `root.teams` by name (the group id IS the team name).
const $83482a6ad78aef6f$var$_teamGroupCategory = (root, groupId)=>{
    if (!groupId || !groupId.startsWith('team:')) return 'none';
    const name = groupId.slice(5);
    const team = (root && root.teams || []).find((t)=>t && t.name === name);
    return team && team.category || 'active';
};
// ─── Agent registry ───────────────────────────────────────────
//
// Canonical set, matching /Users/nikoloza/www/current/skills/agents/.
// Each entry maps to one of the bundled .md keys in
// AGENT_INSTRUCTIONS so the modal renders the full instructions.
// Canonical agent set — mirrors skills/HIERARCHY.md.
//
// Tier 0 — platform (cross-tenant)
//   simone
// Tier 1 — per-tenant brain
//   chuvak
// Tier 2 — siblings under chuvak
//   temo (PM / router), caesar (creative / design ops), watcher (analytics)
// Tier 3 — cross-epic helpers (paired with epic agents)
//   ux, ui-design, qa
// Tier 4 — epic subagents under temo (one per epic scope: sdk, server,
//   smbls, dompiler, extensions, design, infra, papuna, …)
//
// Future: replace this static seed with `sdk.users.list({ type: 'agent' })`
// once Mongo agent-user records land server-side. Until then, the page
// renders every agent in this list as a TeamAgentNode.
// MAIN_AGENTS — the universal default shown in EVERY workspace (per Nika
// 2026-06-17 "leave only main agents for all workspaces"). Caesar is the infra
// agent; Ochopintre is the studio agent. The Symbols-specific epic subagents
// are NOT global — they seed only the Symbols workspace (see below).
const $83482a6ad78aef6f$var$MAIN_AGENTS = [
    // Tier 0 / 1
    {
        id: 'simone',
        name: 's1m0ne',
        caption: 'canvas.team.agentCaption.platform',
        kind: 'platform'
    },
    {
        id: 'chuvak',
        name: 'Chuvak',
        caption: 'canvas.team.agentCaption.brain',
        kind: 'brain'
    },
    // Tier 2 — siblings under chuvak
    {
        id: 'temo',
        name: 'Temo',
        caption: 'canvas.team.agentCaption.router',
        kind: 'router'
    },
    {
        id: 'caesar',
        name: 'Caesar',
        caption: 'canvas.team.agentCaption.infra',
        kind: 'infra'
    },
    {
        id: 'watcher',
        name: 'Watcher',
        caption: 'canvas.team.agentCaption.observer',
        kind: 'observer'
    },
    {
        id: 'ochopintre',
        name: 'Ochopintre',
        caption: 'canvas.team.agentCaption.studio',
        kind: 'studio'
    },
    // Tier 3 — cross-epic helpers
    {
        id: 'ux',
        name: 'UX',
        caption: 'canvas.team.agentCaption.helper',
        kind: 'helper'
    },
    {
        id: 'ui-design',
        name: 'UI Design',
        caption: 'canvas.team.agentCaption.helper',
        kind: 'helper'
    },
    {
        id: 'qa',
        name: 'QA',
        caption: 'canvas.team.agentCaption.helper',
        kind: 'helper'
    }
];
// SYMBOLS_EPIC_AGENTS — per-epic subagents that are Symbols-System-workspace
// data, NOT a global default (infra folded into Caesar). They seed only when
// the Symbols workspace is active; every other workspace shows MAIN_AGENTS
// plus its own real (Mongo) agents.
const $83482a6ad78aef6f$var$SYMBOLS_EPIC_AGENTS = [
    {
        id: 'sdk',
        name: 'SDK',
        caption: 'canvas.team.agentCaption.epicSdk',
        kind: 'epic'
    },
    {
        id: 'server',
        name: 'Server',
        caption: 'canvas.team.agentCaption.epicServer',
        kind: 'epic'
    },
    {
        id: 'smbls',
        name: 'Smbls',
        caption: 'canvas.team.agentCaption.epicSmbls',
        kind: 'epic'
    },
    {
        id: 'dompiler',
        name: 'Dompiler',
        caption: 'canvas.team.agentCaption.epicDompiler',
        kind: 'epic'
    },
    {
        id: 'extensions',
        name: 'Extensions',
        caption: 'canvas.team.agentCaption.epicExtensions',
        kind: 'epic'
    },
    {
        id: 'design',
        name: 'Design',
        caption: 'canvas.team.agentCaption.epicDesign',
        kind: 'epic'
    },
    {
        id: 'papuna',
        name: 'Papuna',
        caption: 'canvas.team.agentCaption.epicPapuna',
        kind: 'epic'
    },
    {
        id: 'symbolize',
        name: 'Symbolize',
        caption: 'canvas.team.agentCaption.epicSymbolize',
        kind: 'epic'
    },
    {
        id: 'company',
        name: 'Company',
        caption: 'canvas.team.agentCaption.epicCompany',
        kind: 'epic'
    }
];
// Effective seed for the active workspace: MAIN everywhere, plus the Symbols
// epics only inside the Symbols workspace. This is what makes the agentic flow
// per-workspace instead of the old global Symbols hierarchy.
// Every seed row is a PLATFORM default until the org holds its own agent row
// (canvasAgentRoster — WL-7: own agents first, platform ones labelled).
const $83482a6ad78aef6f$var$_seedAgents = (root)=>(0, $5xbNK.canvasAgentRoster)($83482a6ad78aef6f$var$_canvasActiveWsId(root) === $83482a6ad78aef6f$var$SYMBOLS_WS_ID ? [
        ...$83482a6ad78aef6f$var$MAIN_AGENTS,
        ...$83482a6ad78aef6f$var$SYMBOLS_EPIC_AGENTS
    ] : $83482a6ad78aef6f$var$MAIN_AGENTS);
// ─── Agent registry — Mongo-backed (§unified-perms PR #10) ────
//
// SEED_AGENTS above is the canonical hierarchy/topology metadata
// (caption, kind, connection edges) — it's static config, not identity.
// Mongo carries identity for any agent provisioned with `User.kind ===
// 'agent'`; the two compose:
//
//   - `_agents(root)` returns the effective agent list. When Mongo has
//     entries for usernames matching a SEED_AGENTS id, the Mongo
//     identity (id = user._id, name, avatar) overrides SEED defaults
//     while preserving the caption + kind from SEED. New Mongo agents
//     without a SEED entry render with a generic caption.
//   - On cold boot or when listAgents fails, SEED_AGENTS is the
//     fallback so /team-and-agents always renders something.
//
// Boot fetch lives in the page's onCreate hook (one call per session,
// guarded by root._agentsLoaded). Future: re-fetch on revocation event
// once the user-channel emits 'agent.created' / 'agent.removed'.
const $83482a6ad78aef6f$var$_agentsFromMongo = (mongoAgents, root, lang)=>{
    const seed = $83482a6ad78aef6f$var$_seedAgents(root);
    if (!Array.isArray(mongoAgents) || mongoAgents.length === 0) return seed;
    const seedBySlug = new Map(seed.map((a)=>[
            a.id,
            a
        ]));
    const seenSlugs = new Set();
    const merged = [];
    for (const u of mongoAgents){
        // Join a Mongo agent back to its client seed on the per-org idempotence key
        // (metadata.seedSlug), NOT the org-namespaced username ('symbols-simone'),
        // which never equals the seed id ('simone') — that mismatch rendered the
        // built-in twice (the 's1m0ne' seed card + the 'Simone' Mongo card). A
        // matched agent keeps the seed's canonical id (so the hierarchy edges in
        // _baseConnections still connect) + its brand name/caption/kind, and carries
        // the Mongo userId/email so it stays assignable + chainable — collapsing the
        // two into ONE card. Falls back to the raw username for custom (non-seed)
        // agents and legacy non-namespaced usernames.
        const seedSlug = String(u.metadata?.seedSlug || '').toLowerCase();
        const rawSlug = String(u.username || u.id || u._id || '').toLowerCase();
        const seedEntry = seedSlug && seedBySlug.get(seedSlug) || seedBySlug.get(rawSlug) || null;
        const key = seedEntry ? seedEntry.id : rawSlug;
        if (!key) continue;
        seenSlugs.add(key);
        merged.push({
            id: key,
            // A server-seeded default (the Personal Assistant) carries its name per
            // language on metadata.nameI18n — shown in the active interface language.
            name: seedEntry?.name || (0, $d3gaB.canvasAgentDisplayName)(u, lang) || key,
            // A seed entry carries a bundle KEY; a custom (non-seed) Mongo agent has
            // no caption of its own, so it carries the generic key and the raw
            // username separately — the render site substitutes {name}. Building
            // 'Agent · ' + username here would be an untranslatable concatenation.
            // A row the platform seeded with no client seed of its own (the
            // Personal Assistant) is a built-in agent: the platform caption, never
            // "Agent · <org-username>".
            caption: seedEntry?.caption || (seedSlug ? 'canvas.team.agentCaption.platform' : 'canvas.team.agentCaption.custom'),
            captionName: seedEntry || seedSlug ? null : u.username || key,
            kind: seedEntry?.kind || 'agent',
            avatar: u.avatar || null,
            userId: u.id || u._id || null,
            email: u.email || null,
            // the record's per-language names, kept on the roster row (the
            // contract's shape, shared/_simone/mention.js agentsFromMongo) so the
            // chat's @-mention picker names the agent in the active language too
            nameI18n: u.metadata?.nameI18n || null,
            // the per-org key the platform seeded it under — canvasAgentRoster keeps
            // such a row in the platform block (persona round 5, tomas)
            seedSlug: seedSlug || null
        });
    }
    for (const s of seed)if (!seenSlugs.has(s.id)) merged.push(s);
    // The org's own agents first; a seed with no row here is a platform default
    // (WL-7 — tomas's new workspace listed nine agents he never made).
    return (0, $5xbNK.canvasAgentRoster)(merged);
};
// The canvas paints only its OWN roster shape (canvasRosterShaped): the lean
// roster the home or the Simone composer wrote under the same key falls back
// to the seed until the canvas's own load lands.
const $83482a6ad78aef6f$var$_agents = (root)=>{
    const fromState = root && root._agents;
    if ((0, $5xbNK.canvasRosterShaped)(fromState)) return fromState;
    return $83482a6ad78aef6f$var$_seedAgents(root);
};
// One load per session — unless another surface claimed the shared
// `_agentsLoaded` gate with its lean roster (persona round 5, tomas: the canvas
// returned at once on that gate and painted the lean list raw). The canvas's
// own claim is `__canvasAgentsLoading` while its read is out.
const $83482a6ad78aef6f$var$_loadAgents = async (root, lang = root?.lang || null)=>{
    if (!root || root.__canvasAgentsLoading) return;
    if (root._agentsLoaded && (0, $5xbNK.canvasRosterShaped)(root._agents)) return;
    root._agentsLoaded = true;
    root.__canvasAgentsLoading = true;
    try {
        const sdk = (0, $1NxyO.getSDK)();
        if (!sdk || typeof sdk.listAgents !== 'function') return;
        // Org-scoped roster (2026-06-06) — agents belong to the active org.
        const raw = await sdk.listAgents(root?.jwtClaims?.workspace_org_id);
        const list = Array.isArray(raw) ? raw : raw && raw.data || [];
        const merged = $83482a6ad78aef6f$var$_agentsFromMongo(list, root, lang);
        root.update({
            _agents: merged
        });
    } catch (err) {
        root._agentsLoaded = false;
        console.warn('[team-and-agents] listAgents failed:', err && err.message);
    } finally{
        root.__canvasAgentsLoading = false;
    }
};
// Provision the seed roster into Mongo: for every seed agent that is not yet a
// real (Mongo-backed) agent, create it via the SDK keyed by (org, seedSlug).
// This turns chuvak/temo/ux/qa/… from static topology into assignable,
// delegatable, CHAINABLE identities. Idempotent end-to-end — the server's
// createAgent returns an existing agent for a known (org, seedSlug) instead of
// duplicating, so the "Activate agents" button is safe to click repeatedly.
const $83482a6ad78aef6f$var$_provisionSeedAgents = async (root)=>{
    const sdk = (0, $1NxyO.getSDK)();
    const org = root?.jwtClaims?.workspace_org_id;
    if (!sdk || typeof sdk.createAgent !== 'function' || !org) throw new Error('Agent provisioning is unavailable (no SDK or workspace org).');
    const missing = $83482a6ad78aef6f$var$_agents(root).filter((a)=>a && a.id && !a.userId);
    const instructions = missing.length ? await $83482a6ad78aef6f$var$_agentInstructions() : {};
    let created = 0;
    for (const a of missing)try {
        await sdk.createAgent({
            name: a.name || a.id,
            username: a.id,
            seedSlug: a.id,
            organization: org,
            instructions: instructions[a.id] || '',
            userRole: 'editor'
        });
        created += 1;
    } catch (err) {
        console.warn('[team-and-agents] provision ' + a.id + ' failed:', err && err.message);
    }
    // Re-fetch so the now-real agents pick up their Mongo userId + avatar and the
    // nodes flip from seed-only to live (delegatable/chainable).
    root._agentsLoaded = false;
    await $83482a6ad78aef6f$var$_loadAgents(root);
    return {
        created: created,
        missing: missing.length
    };
};
// Topo-order a set of agent→agent edges into a linear execution sequence.
// Returns null on a cycle (no valid order). Pure — no state reads.
const $83482a6ad78aef6f$var$_orderAgentsByConnection = (edges)=>{
    if (!Array.isArray(edges) || edges.length === 0) return [];
    const out = new Map();
    const indeg = new Map();
    const nodes = new Set();
    for (const e of edges){
        const from = String(e && e.from || '').toLowerCase();
        const to = String(e && e.to || '').toLowerCase();
        if (!from || !to || from === to) continue;
        if (!out.has(from)) out.set(from, []);
        out.get(from).push(to);
        indeg.set(to, (indeg.get(to) || 0) + 1);
        nodes.add(from);
        nodes.add(to);
    }
    for (const n of nodes)if (!indeg.has(n)) indeg.set(n, 0);
    const queue = [
        ...nodes
    ].filter((n)=>indeg.get(n) === 0);
    const ordered = [];
    while(queue.length){
        const cur = queue.shift();
        ordered.push(cur);
        for (const nxt of out.get(cur) || []){
            indeg.set(nxt, indeg.get(nxt) - 1);
            if (indeg.get(nxt) === 0) queue.push(nxt);
        }
    }
    return ordered.length === nodes.size ? ordered : null;
};
// The user-drawn edges between two AGENTS — the only edges that form a runnable
// chain (the base org hierarchy + agent↔person assignments are not execution
// chains). Shared by the "Run chain" row's visibility guard and the runner.
const $83482a6ad78aef6f$var$_agentChainEdges = (root)=>{
    const ids = new Set(($83482a6ad78aef6f$var$_agents(root) || []).map((a)=>a && a.id).filter(Boolean));
    const drawn = Array.isArray(root?._tagConnections) ? root._tagConnections : [];
    return drawn.filter((e)=>e && ids.has(String(e.from || '').toLowerCase()) && ids.has(String(e.to || '').toLowerCase()));
};
// Run the connected agents as a Simone-driven chain. Reuses the workspace
// sendPrompt flow end-to-end: opens the assistant drawer and dispatches a
// prompt instructing Simone to call chain_agents on the ordered agents. The
// chain streams in the drawer AND lights up the canvas via the existing
// activeProcesses / onProcessActive plumbing (_isAgentWorking).
const $83482a6ad78aef6f$var$_runAgentChain = (root, el)=>{
    const edges = $83482a6ad78aef6f$var$_agentChainEdges(root);
    if (edges.length === 0) {
        root?.update({
            _tagToast: {
                kind: 'error',
                text: 'canvas.team.toast.chainNeedsTwo'
            }
        });
        return;
    }
    const ordered = $83482a6ad78aef6f$var$_orderAgentsByConnection(edges);
    if (!ordered || ordered.length < 2) {
        root?.update({
            _tagToast: {
                kind: 'error',
                text: 'canvas.team.toast.chainCycle'
            }
        });
        return;
    }
    const byId = new Map(($83482a6ad78aef6f$var$_agents(root) || []).map((a)=>[
            a.id,
            a
        ]));
    const names = ordered.map((id)=>byId.get(id) && byId.get(id).name || id);
    const prompt = 'Run an agent chain with these agents, in this exact order: ' + names.join(" \u2192 ") + ". Use the chain_agents tool \u2014 one step per agent, passing each step's output to the next. " + 'Give each agent a task that fits its role and advances the chain. If you need the objective, ask me.';
    try {
        root?.update({
            assistantOpen: true
        });
        el.call('sendPrompt', prompt);
        root?.update({
            _tagToast: {
                kind: 'ok',
                text: el.call('polyglot', 'canvas.team.toast.chainRunning').replace('{names}', names.join(" \u2192 "))
            }
        });
    } catch (err) {
        root?.update({
            _tagToast: {
                kind: 'error',
                text: err && err.message || 'canvas.team.toast.chainFailed'
            }
        });
    }
};
// ─── Viewer-scoped visibility (the /my-agents lens) ───────────────
//
// /my-agents renders THIS canvas verbatim (it `extends: 'teamAndAgents'`)
// but filters the visible people + agents to the signed-in viewer's
// reach. The lens is gated entirely on `root._canvasScope === 'mine'`,
// which /my-agents sets in onCreate and clears on unmount. When the flag
// is unset — /team-and-agents and the home AgentsWidget embed — every
// accessor below returns the FULL set, so those surfaces are byte-for-
// byte unchanged.
//
// Tiers (Nika 2026-06-04), derived from the same chain the rest of the
// workspace uses (JWT claims, org-member roles, team-maintainer rows):
//   admin   — owner | co-owner | admin org role, `admin.teams` perm, or
//             jwt is_owner → sees EVERYONE (identical to unscoped).
//   manager — leads ≥1 team (team-maintainer in teamsByEmail) → self +
//             the people on teams they lead + every agent assigned to any
//             of them.
//   member  — self + the agents assigned to self. (Anyone who leads
//             people is promoted to manager by the team-chain check.)
const $83482a6ad78aef6f$var$_ADMIN_ROLES = [
    'owner',
    'co-owner',
    'admin',
    'superadmin'
];
const $83482a6ad78aef6f$var$_viewerTier = (root)=>{
    // Gate-A claim cutover: OFF (default) → root.jwtClaims verbatim; ON → is_owner
    // / permissions from the Mongo-sourced active-org row. See claimResolver.js.
    const claims = (0, $kcLMl.canvasResolveClaims)(root);
    const role = (root?.roles && root.roles.byUser || {})[root?.currentUserId] || null;
    const perms = Array.isArray(claims.permissions) ? claims.permissions : [];
    // admin.teams is the canonical "can manage the team canvas" permission
    // (same gate as the agent-assignment + team-member mutations).
    if (claims.is_owner || $83482a6ad78aef6f$var$_ADMIN_ROLES.includes(String(role || '')) || perms.includes('admin.teams')) return 'admin';
    const email = String(root?.currentUserEmail || '').toLowerCase();
    const myId = root?.currentUserId != null ? String(root.currentUserId) : '';
    // id-first (resolves for non-mgmt viewers whose rows carry no email),
    // email fallback (mgmt viewers + optimistic writes) — tickets/fable.md P0 regression
    const myByIdTeams = myId ? root?.teamsByUserId?.[myId] : null;
    const myTeams = Array.isArray(myByIdTeams) && myByIdTeams.length && myByIdTeams || email && root?.teamsByEmail?.[email] || [];
    if (myTeams.some((t)=>/maintainer|manager|lead/i.test(String(t.role || '')))) return 'manager';
    return 'member';
};
// People on teams the viewer leads (manager tier); [] otherwise.
const $83482a6ad78aef6f$var$_canvasPeopleUnderViewer = (root)=>{
    const email = String(root?.currentUserEmail || '').toLowerCase();
    const myId = root?.currentUserId != null ? String(root.currentUserId) : '';
    // id-first (resolves for non-mgmt viewers whose rows carry no email),
    // email fallback (mgmt viewers + optimistic writes) — tickets/fable.md P0 regression
    const myByIdTeams = myId ? root?.teamsByUserId?.[myId] : null;
    const myTeams = Array.isArray(myByIdTeams) && myByIdTeams.length && myByIdTeams || email && root?.teamsByEmail?.[email] || [];
    const leadIds = myTeams.filter((t)=>/maintainer|manager|lead/i.test(String(t.role || ''))).map((t)=>String(t.id));
    if (!leadIds.length) return [];
    const byUserId = root?.teamsByUserId || {};
    const byEmail = root?.teamsByEmail || {};
    const out = [];
    for (const p of root?.people || []){
        const pid = p?.userId != null ? String(p.userId) : '';
        const pe = String(p?.email || '').toLowerCase();
        if (pid ? pid === myId : pe === email) continue;
        const pByIdTeams = pid ? byUserId[pid] : null;
        const pTeams = Array.isArray(pByIdTeams) && pByIdTeams.length && pByIdTeams || pe && byEmail[pe] || [];
        if (pTeams.some((t)=>leadIds.includes(String(t.id)))) out.push(p);
    }
    return out;
};
// Agents assigned to a person (by their User _id), resolved against the
// roster so we get the full {id, name, caption, …} node shape.
const $83482a6ad78aef6f$var$_agentsAssignedToPerson = (root, assigneeUserId)=>{
    if (!assigneeUserId) return [];
    const rows = (root?.agentAssignmentsByAssignee || {})[assigneeUserId] || [];
    const roster = $83482a6ad78aef6f$var$_agents(root);
    const out = [];
    for (const r of rows){
        const a = roster.find((x)=>String(x.userId) === String(r.agent));
        if (a) out.push(a);
    }
    return out;
};
// Full person roster when unscoped or admin; the viewer's slice otherwise.
const $83482a6ad78aef6f$var$_visiblePeople = (root)=>{
    // /agents (agents-only) hides every human node — and, since the team swim-lane
    // frames derive from the visible people, the frames empty out too.
    if (root?._canvasAgentsOnly) return [];
    const all = Array.isArray(root?.people) ? root.people : [];
    const myId = String(root?.currentUserId || '');
    const myEmail = String(root?.currentUserEmail || '').toLowerCase();
    const isMe = (p)=>String(p.userId) === myId || String(p.email || '').toLowerCase() === myEmail;
    // Read-only-inactive (`status: 'inactive'`) and departed (`'left'`) members
    // are hidden from the board everywhere — including the full team-and-agents
    // view — while the viewer themselves is always kept.
    const activeStatus = (p)=>p.status !== 'left' && p.status !== 'inactive';
    if (root?._canvasScope !== 'mine') return all.filter((p)=>isMe(p) || activeStatus(p));
    // /my-agents shows only ACTIVE members (per Nika). The category pill is
    // hidden on this page, so passive/external/archived members would be
    // indistinguishable from active ones — drop them too. The viewer is always
    // kept, regardless of their own category/status.
    const keep = (p)=>isMe(p) || activeStatus(p) && $83482a6ad78aef6f$var$_isActiveMember(root, p);
    const tier = $83482a6ad78aef6f$var$_viewerTier(root);
    if (tier === 'admin') return all.filter(keep);
    const me = all.filter(isMe);
    if (tier !== 'manager') return me;
    const seen = new Set();
    const merged = [];
    for (const p of [
        ...me,
        ...$83482a6ad78aef6f$var$_canvasPeopleUnderViewer(root)
    ]){
        const id = p.userId || p.email;
        if (seen.has(id)) continue;
        seen.add(id);
        merged.push(p);
    }
    return merged.filter(keep);
};
// The agent ids assigned to the signed-in viewer (the "My agents" set on
// /agents). Resolved directly off the assignment map so it's independent of the
// people roster (which is empty in agents-only mode).
const $83482a6ad78aef6f$var$_myAgents = (root, all)=>{
    const mine = $83482a6ad78aef6f$var$_agentsAssignedToPerson(root, root?.currentUserId);
    const ids = new Set(mine.map((a)=>a.id));
    return all.filter((a)=>ids.has(a.id));
};
// Every agent userId that appears as an assignee's assignment (for the
// assigned/unassigned filter). Built once per call.
const $83482a6ad78aef6f$var$_assignedAgentUserIds = (root)=>{
    const byAssignee = root?.agentAssignmentsByAssignee || {};
    const ids = new Set();
    for (const k of Object.keys(byAssignee)){
        for (const r of byAssignee[k] || [])if (r?.agent != null) ids.add(String(r.agent));
    }
    return ids;
};
// Apply the /agents toolbar filters (Status / Type / Assignment) to a set.
const $83482a6ad78aef6f$var$_applyAgentFilters = (root, agents)=>{
    let out = agents;
    const status = root?._agentsStatus;
    if (status === 'active') out = out.filter((a)=>$83482a6ad78aef6f$var$_isAgentPulsing(root, a.id));
    else if (status === 'idle') out = out.filter((a)=>!$83482a6ad78aef6f$var$_isAgentPulsing(root, a.id));
    const type = root?._agentsType;
    if (type && type !== 'all') out = out.filter((a)=>String(a.kind || '') === type);
    const assign = root?._agentsAssign;
    if (assign === 'assigned' || assign === 'unassigned') {
        const assigned = $83482a6ad78aef6f$var$_assignedAgentUserIds(root);
        out = out.filter((a)=>assigned.has(String(a.userId)) === (assign === 'assigned'));
    }
    return out;
};
// Full agent roster when unscoped or admin; otherwise the deduped union
// of agents assigned to the viewer's visible people.
const $83482a6ad78aef6f$var$_visibleAgents = (root)=>{
    const all = $83482a6ad78aef6f$var$_agents(root);
    // /agents (agents-only): scope by the My/All toolbar, then apply the
    // Status/Type/Assignment filters. /team-and-agents + /my-agents below are
    // unchanged.
    if (root?._canvasAgentsOnly) {
        const base = root?._agentsScope === 'mine' ? $83482a6ad78aef6f$var$_myAgents(root, all) : all;
        return $83482a6ad78aef6f$var$_applyAgentFilters(root, base);
    }
    if (root?._canvasScope !== 'mine') return all;
    if ($83482a6ad78aef6f$var$_viewerTier(root) === 'admin') return all;
    const seen = new Set();
    const out = [];
    for (const p of $83482a6ad78aef6f$var$_visiblePeople(root))for (const a of $83482a6ad78aef6f$var$_agentsAssignedToPerson(root, p.userId)){
        if (seen.has(a.id)) continue;
        seen.add(a.id);
        out.push(a);
    }
    return out;
};
// Visible node-id set (people + agents) for edge filtering. Returns null
// when unscoped / admin — meaning "no filter, show every edge".
const $83482a6ad78aef6f$var$_visibleNodeIds = (root)=>{
    if (root?._canvasScope !== 'mine' || $83482a6ad78aef6f$var$_viewerTier(root) === 'admin') return null;
    const ids = new Set();
    const people = $83482a6ad78aef6f$var$_visiblePeople(root);
    for(let i = 0; i < people.length; i++)ids.add($83482a6ad78aef6f$var$_personId(people[i], i));
    for (const a of $83482a6ad78aef6f$var$_visibleAgents(root))ids.add(a.id);
    return ids;
};
// ─── Layout helpers ───────────────────────────────────────────
//
// People are grouped by team — each team becomes a horizontal "swim
// lane" with a label header and its members laid out in a grid below.
// People with no team membership land in an "Other" lane at the end.
// Agents get their own lane below the team lanes.
//
// Team grouping reads from `root.teamsByEmail` (populated by
// workspace/functions/teams.js → loadAllTeams). Same selector as
// peopleGroups.js's `groupKeyOf` — keeps the team labels consistent
// with /people and the AI assistant.
// Studios-style grouping: studios uses `root.groupMap[nodeId] = ws`
// to OPT a node INTO a group; most nodes are ungrouped and sit free
// on the canvas. We mirror that here:
//
//   - People with a known team are grouped under that team. A team
//     frame renders only when 2+ members share it (matches studios:
//     `nodesOfGroup.length >= 2`). Solo-team people just sit free.
//   - Agents are NEVER auto-grouped. Each agent is a free node on the
//     canvas — the hierarchy is shown via the SVG connection edges
//     (simone → chuvak → temo → epic agents), not via a frame around
//     a "kind" cluster. This matches studios where unrelated projects
//     don't get auto-wrapped in a frame.
//
// Frame drag-to-rejoin / drag-to-leave behavior from studios.js is a
// follow-up — the structure here matches; the interaction hooks need
// the same `detectDropTarget` + `restackGroup` glue.
//
// Constants
const $83482a6ad78aef6f$var$GROUP_PAD = 24 // padding around bbox
;
// The platform frame's head (PlatformFrame): the "Platform" label and its one
// line under it (canvas.team.platformNote — persona round 3, W5), in canvas
// units like every frame box here. The block of cards starts below it.
const $83482a6ad78aef6f$var$PLATFORM_HEAD_H = 56;
// Room above the platform agents' block for its frame head (PlatformFrame).
const $83482a6ad78aef6f$var$PLATFORM_LABEL_H = $83482a6ad78aef6f$var$PLATFORM_HEAD_H + $83482a6ad78aef6f$var$GROUP_PAD;
const $83482a6ad78aef6f$var$GROUP_COLS = 4 // members per row in default layout
;
const $83482a6ad78aef6f$var$GROUP_GAP_X = 80 // horizontal gap between groups
;
const $83482a6ad78aef6f$var$GROUP_GAP_Y = 120 // vertical gap between group rows
;
const $83482a6ad78aef6f$var$GROUPS_PER_ROW = 2 // how many groups stack horizontally
;
const $83482a6ad78aef6f$var$MIN_GROUP_MEMBERS = 2 // hide frames for solo teams (studios convention)
;
// Returns the group id for a given person, or null when the person
// should sit ungrouped on the canvas. Agents always return null —
// they ride the connection edges, not a frame.
const $83482a6ad78aef6f$var$_groupFor = (entry, root)=>{
    if ($83482a6ad78aef6f$var$_agents(root).some((a)=>a.id === entry.id)) return null;
    const email = String(entry.email || '').toLowerCase();
    // `entry.id` is userId-first (see _canvasEmailOf: "people use userId-or-email as
    // data-node-id"), so it doubles as the id-first lookup key here — falls
    // through to the email fallback when it's actually an email/synthetic id.
    // id-first (resolves for non-mgmt viewers whose rows carry no email), email
    // fallback (mgmt viewers + optimistic writes) — tickets/fable.md P0 regression
    const byId = entry.id != null ? root?.teamsByUserId?.[String(entry.id)] : null;
    const teams = Array.isArray(byId) && byId.length && byId || root?.teamsByEmail?.[email] || [];
    const name = teams[0]?.name;
    if (!name) return null;
    return 'team:' + name;
};
const $83482a6ad78aef6f$var$_groupLabel = (groupId)=>{
    if (!groupId) return '';
    return groupId.slice(5);
};
// Studios-style group model — rewritten 2026-06-04. Replaces the
// previous two-track (team groups + ad-hoc groups) model with the
// same one /studios uses: a flat `_tagGroupMap[nodeId] = slot` plus
// `_tagGroupNames[slot] = label`, where `slot` is one of the
// pre-allocated `groupN` keys (group1..group50). Frames render via
// `groupN`-indexed children that derive their bbox from member
// positions; persistence rides the workspace-shared canvas-layout
// `groups` field, same as /studios projects.
//
// Team groups are NO LONGER a separate render surface — `teamsByEmail`
// rows seed the group map at hydration time (one slot per team with
// ≥2 members), but from that point forward they're just groups in
// the unified map. Drag-into-frame still triggers the team-membership
// SDK roundtrip when the destination slot was seeded from a team row;
// drag-out triggers the leave-team roundtrip. Drag-collision between
// two free nodes forms a brand-new ad-hoc group.
// Slot-map primitives shared with /studio — canvas/functions/
// slotGroups.js (extracted 2026-06-06 per Nika). Wrappers below bind
// them to this page's `_tag*` state keys.
const $83482a6ad78aef6f$var$_groupMap = (root)=>root && typeof root._tagGroupMap === 'object' && root._tagGroupMap || {};
const $83482a6ad78aef6f$var$_groupNames = (root)=>root && typeof root._tagGroupNames === 'object' && root._tagGroupNames || {};
// Which group slot (groupN | null) contains a given node id.
const $83482a6ad78aef6f$var$_currentGroupOf = (root, nodeId)=>(0, $6ocCI.slotOf)($83482a6ad78aef6f$var$_groupMap(root), nodeId);
// Member node-ids of a given slot. Stable order: people first (by
// row index), then agents (alphabetical) — matches the on-canvas
// layout's natural reading order.
const $83482a6ad78aef6f$var$_membersOfGroup = (root, slot)=>{
    const map = $83482a6ad78aef6f$var$_groupMap(root);
    const out = [];
    for (const p of $83482a6ad78aef6f$var$_visiblePeople(root)){
        const id = p.userId || p.email;
        if (id && map[id] === slot) out.push(id);
    }
    for (const a of $83482a6ad78aef6f$var$_visibleAgents(root))if (a.id && map[a.id] === slot) out.push(a.id);
    return out;
};
// Pick the next free `groupN` slot.
const $83482a6ad78aef6f$var$_nextGroupSlot = (root)=>(0, $6ocCI.nextFreeSlot)($83482a6ad78aef6f$var$_groupMap(root));
// Default label for a slot — uses the persisted name if present,
// falls back to "Group N" or the team name when the slot was seeded
// from a team membership row (team:Name → "Name").
const $83482a6ad78aef6f$var$_slotLabel = (root, slot)=>{
    const persisted = $83482a6ad78aef6f$var$_groupNames(root)[slot];
    if (persisted) return persisted;
    const map = $83482a6ad78aef6f$var$_groupMap(root);
    const members = Object.entries(map).filter(([, v])=>v === slot).map(([k])=>k);
    if (!members.length) return slot;
    // If every member shares the same team, label the slot after that
    // team (until the user renames it via the on-frame inline edit).
    const teamGroupId = $83482a6ad78aef6f$var$_groupFor({
        id: members[0],
        email: $83482a6ad78aef6f$var$_canvasEmailOf(root, members[0])
    }, root);
    if (teamGroupId) return teamGroupId.slice(5);
    return 'Group';
};
// Seed the slot map from `root.teamsByEmail` — one slot per team with
// ≥2 visible people. Used by `_hydrateLayoutFromPrefs` when the canvas
// has never been saved before, so members opening a fresh workspace
// land with their team frames already drawn.
// REAL teams only for a person — org-scoped, system permission groups
// (Admin / Members / … — every org member is in Members, which would
// collapse the whole canvas into one giant frame) excluded. Mirrors
// peopleGroups.js's _realTeams.
// id-first (resolves for non-mgmt viewers whose rows carry no email), email
// fallback (mgmt viewers + optimistic writes) — tickets/fable.md P0 regression
const $83482a6ad78aef6f$var$_personRealTeams = (root, p)=>{
    const byId = p?.userId != null ? root?.teamsByUserId?.[String(p.userId)] : null;
    const rows = Array.isArray(byId) && byId.length && byId || root?.teamsByEmail?.[String(p?.email || '').toLowerCase()] || [];
    const orgId = root?.jwtClaims?.workspace_org_id;
    return rows.filter((r)=>r?.id && !r.isSystem && (!orgId || String(r.orgId) === String(orgId)));
};
const $83482a6ad78aef6f$var$_seedGroupsFromTeams = (root)=>{
    const map = {};
    const names = {};
    const teamCounts = {} // teamId → member count in the visible set
    ;
    const teamLabels = {} // teamId → team.name
    ;
    for (const p of $83482a6ad78aef6f$var$_visiblePeople(root)){
        const t = $83482a6ad78aef6f$var$_personRealTeams(root, p)[0];
        if (!t) continue;
        teamCounts[t.id] = (teamCounts[t.id] || 0) + 1;
        if (t.name && !teamLabels[t.id]) teamLabels[t.id] = t.name;
    }
    let slotIdx = 0;
    const teamToSlot = {};
    for (const [tid, count] of Object.entries(teamCounts)){
        if (count < $83482a6ad78aef6f$var$MIN_GROUP_MEMBERS) continue;
        const slot = (0, $6ocCI.GROUP_SLOTS)[slotIdx++] || 'group' + slotIdx;
        teamToSlot[tid] = slot;
        if (teamLabels[tid]) names[slot] = teamLabels[tid];
    }
    for (const p of $83482a6ad78aef6f$var$_visiblePeople(root)){
        const tid = $83482a6ad78aef6f$var$_personRealTeams(root, p)[0]?.id;
        const slot = tid && teamToSlot[tid];
        if (!slot) continue;
        const nodeId = p.userId || p.email;
        if (nodeId) map[nodeId] = slot;
    }
    return {
        map: map,
        names: names
    };
};
// Merge the team seed into an EXISTING group map — saved canvases
// (which skip the fresh-canvas seed) still gain team frames for
// members nobody grouped manually. Manual placement always wins; new
// members land in the slot whose label matches their team name when
// one exists, otherwise in the next free slot. Returns null when
// nothing changed.
const $83482a6ad78aef6f$var$_mergeTeamSeed = (root)=>{
    const seeded = $83482a6ad78aef6f$var$_seedGroupsFromTeams(root);
    if (!Object.keys(seeded.map).length) return null;
    const map = {
        ...$83482a6ad78aef6f$var$_groupMap(root)
    };
    const names = {
        ...$83482a6ad78aef6f$var$_groupNames(root)
    };
    const used = new Set(Object.values(map));
    const labelToSlot = {};
    for (const [slot, label] of Object.entries(names))labelToSlot[label] = slot;
    // Bucket unassigned seeded nodes by seeded slot.
    const bySlot = {};
    for (const [id, slot] of Object.entries(seeded.map)){
        if (map[id]) continue;
        if (!bySlot[slot]) bySlot[slot] = [];
        bySlot[slot].push(id);
    }
    let changed = false;
    for (const [slot, ids] of Object.entries(bySlot)){
        const label = seeded.names[slot];
        let target = label && labelToSlot[label];
        if (!target) {
            // A brand-new frame needs enough members to render.
            if (ids.length < $83482a6ad78aef6f$var$MIN_GROUP_MEMBERS) continue;
            target = (0, $6ocCI.GROUP_SLOTS).find((s)=>!used.has(s));
            if (!target) break;
            used.add(target);
            if (label) {
                names[target] = label;
                labelToSlot[label] = target;
            }
        }
        for (const id of ids){
            map[id] = target;
            changed = true;
        }
    }
    return changed ? {
        map: map,
        names: names
    } : null;
};
// `[{ id (slot), label, memberIds }]` describing every visible group
// on the canvas. Filtered to slots with ≥2 members (studios convention
// — solo "groups" never render a frame).
const $83482a6ad78aef6f$var$_allGroups = (root)=>{
    const slots = new Map();
    const map = $83482a6ad78aef6f$var$_groupMap(root);
    for (const [nodeId, slot] of Object.entries(map)){
        if (!slot) continue;
        if (!slots.has(slot)) slots.set(slot, {
            id: slot,
            memberIds: [],
            label: $83482a6ad78aef6f$var$_slotLabel(root, slot)
        });
        slots.get(slot).memberIds.push(nodeId);
    }
    const arr = [
        ...slots.values()
    ].filter((g)=>g.memberIds.length >= $83482a6ad78aef6f$var$MIN_GROUP_MEMBERS);
    arr.sort((a, b)=>(a.label || a.id).localeCompare(b.label || b.id));
    return arr;
};
// People/agents NOT in any group (team or ad-hoc) — laid out as free
// nodes below the group row.
const $83482a6ad78aef6f$var$_ungroupedEntries = (root)=>{
    const people = $83482a6ad78aef6f$var$_visiblePeople(root);
    const groups = $83482a6ad78aef6f$var$_allGroups(root);
    const inGroup = new Set();
    for (const g of groups)for (const id of g.memberIds)inGroup.add(id);
    const out = [];
    for(let i = 0; i < people.length; i++){
        const p = people[i];
        const id = p.userId || p.email || 'p-' + i;
        if (inGroup.has(id)) continue;
        out.push({
            id: id,
            kind: 'person',
            w: $83482a6ad78aef6f$var$PERSON_W,
            h: $83482a6ad78aef6f$var$PERSON_H
        });
    }
    for (const a of $83482a6ad78aef6f$var$_visibleAgents(root)){
        if (inGroup.has(a.id)) continue;
        out.push({
            id: a.id,
            kind: 'agent',
            w: $83482a6ad78aef6f$var$AGENT_W,
            h: $83482a6ad78aef6f$var$AGENT_H
        });
    }
    return out;
};
// Bounding box around a group slot's current member positions.
// Reads from `_tagGroupMap` directly (not via _allGroups → slot
// filter) so this stays O(slot members) instead of O(all slots).
// Returns `null` when the slot has fewer than 2 members on canvas or
// `el` isn't available (pre-mount).
const $83482a6ad78aef6f$var$_groupBbox = (root, slot, el)=>{
    if (!el?.call) return null;
    const memberIds = $83482a6ad78aef6f$var$_membersOfGroup(root, slot);
    if (memberIds.length < $83482a6ad78aef6f$var$MIN_GROUP_MEMBERS) return null;
    // Use the complete merged map (grid defaults overlaid with persisted) so
    // a member that hasn't been dragged/saved yet still contributes to the
    // frame bbox instead of being read as {0,0}.
    const positions = $83482a6ad78aef6f$var$_initialPositions(root);
    return el.call('bboxOfNodeIds', {
        ids: memberIds,
        positions: positions,
        sizeOf: $83482a6ad78aef6f$var$_sizeOfBound(root)
    });
};
// The frame around the platform agents (WL-7): the bbox of their current
// positions (dragged ones included), null when no platform agent is visible.
const $83482a6ad78aef6f$var$_platformBbox = (root, el)=>{
    if (!el?.call) return null;
    const ids = (0, $5xbNK.canvasPlatformAgents)($83482a6ad78aef6f$var$_visibleAgents(root)).map((a)=>a.id);
    if (!ids.length) return null;
    return el.call('bboxOfNodeIds', {
        ids: ids,
        positions: $83482a6ad78aef6f$var$_initialPositions(root),
        sizeOf: $83482a6ad78aef6f$var$_sizeOfBound(root)
    });
};
const $83482a6ad78aef6f$var$_initialPositions = (root)=>{
    // Always compute the deterministic default grid for the FULL roster so
    // every node has a slot, THEN overlay persisted coords at the end
    // (persisted wins). The old short-circuit returned the persisted map
    // verbatim when non-empty — so any node missing from it (a freshly
    // loaded agent, a changed id, or the agents-vs-positions hydrate race)
    // fell through _posFor to {0,0}, stacking cards in the top-left corner.
    // Computing the grid unconditionally makes the on-load layout
    // deterministic no matter which async source (positions / agents)
    // resolves first — fixes "items not always arranged correctly on load".
    const positions = {};
    const groups = $83482a6ad78aef6f$var$_allGroups(root);
    // 1. Lay team groups out first, 2-up grid, members in GROUP_COLS.
    let rowMaxH = 0;
    let gx = 80;
    let gy = 80;
    let colInRow = 0;
    let lastRowBottom = 80;
    for (const group of groups){
        const nodeW = $83482a6ad78aef6f$var$PERSON_W;
        const nodeH = $83482a6ad78aef6f$var$PERSON_H;
        const cols = Math.min($83482a6ad78aef6f$var$GROUP_COLS, Math.max(1, group.memberIds.length));
        const rows = Math.ceil(group.memberIds.length / cols);
        const groupW = cols * nodeW + (cols - 1) * $83482a6ad78aef6f$var$COL_GAP;
        const groupH = rows * nodeH + (rows - 1) * $83482a6ad78aef6f$var$ROW_GAP;
        group.memberIds.forEach((id, i)=>{
            const col = i % cols;
            const row = Math.floor(i / cols);
            positions[id] = {
                x: gx + col * (nodeW + $83482a6ad78aef6f$var$COL_GAP),
                y: gy + row * (nodeH + $83482a6ad78aef6f$var$ROW_GAP)
            };
        });
        rowMaxH = Math.max(rowMaxH, groupH);
        lastRowBottom = gy + rowMaxH;
        colInRow++;
        if (colInRow >= $83482a6ad78aef6f$var$GROUPS_PER_ROW) {
            colInRow = 0;
            gx = 80;
            gy += rowMaxH + $83482a6ad78aef6f$var$GROUP_GAP_Y;
            rowMaxH = 0;
        } else gx += groupW + $83482a6ad78aef6f$var$GROUP_GAP_X;
    }
    // 2. Free nodes (ungrouped people + all agents) below the groups.
    //    Studios convention: free nodes are not auto-laid-out in a grid —
    //    they sit on the canvas where the user placed them. For first
    //    paint though, we need SOME default coords so they don't all
    //    stack at (0,0). Lay them out in a 5-column grid below the last
    //    group row.
    const freeStartY = groups.length ? lastRowBottom + $83482a6ad78aef6f$var$GROUP_GAP_Y * 2 : 80;
    const free = $83482a6ad78aef6f$var$_ungroupedEntries(root);
    const FREE_COLS = 5;
    // The platform agents (canvasAgentRoster) start their OWN block below the
    // people and the workspace's own agents, with room above it for the
    // "Platform" frame label (PlatformFrame) — WL-7.
    const platformIds = new Set((0, $5xbNK.canvasPlatformAgents)($83482a6ad78aef6f$var$_visibleAgents(root)).map((a)=>a.id));
    const ownFree = free.filter((entry)=>!platformIds.has(entry.id));
    const platformFree = free.filter((entry)=>platformIds.has(entry.id));
    let blockBottom = freeStartY;
    ownFree.forEach((entry, i)=>{
        const col = i % FREE_COLS;
        const row = Math.floor(i / FREE_COLS);
        const y = freeStartY + row * (entry.h + $83482a6ad78aef6f$var$ROW_GAP);
        positions[entry.id] = {
            x: 80 + col * (entry.w + $83482a6ad78aef6f$var$COL_GAP),
            y: y
        };
        blockBottom = Math.max(blockBottom, y + entry.h);
    });
    const platformStartY = ownFree.length ? blockBottom + $83482a6ad78aef6f$var$GROUP_GAP_Y + $83482a6ad78aef6f$var$PLATFORM_LABEL_H : freeStartY + $83482a6ad78aef6f$var$PLATFORM_LABEL_H;
    platformFree.forEach((entry, i)=>{
        const col = i % FREE_COLS;
        const row = Math.floor(i / FREE_COLS);
        positions[entry.id] = {
            x: 80 + col * (entry.w + $83482a6ad78aef6f$var$COL_GAP),
            y: platformStartY + row * (entry.h + $83482a6ad78aef6f$var$ROW_GAP)
        };
    });
    // Overlay persisted coords last — a dragged/saved position always wins
    // over the computed grid slot; nodes with no saved coord keep their
    // deterministic grid slot rather than collapsing to {0,0}.
    const persisted = root?._tagPositions;
    if (persisted && typeof persisted === 'object') {
        for (const [id, p] of Object.entries(persisted))if (p && typeof p.x === 'number' && typeof p.y === 'number') positions[id] = p;
    }
    // De-conflict default slots against the persisted coords. A node with NO saved
    // position (a newly-added member, or one whose id changed since the layout was
    // saved) gets a deterministic grid slot — but that slot can land EXACTLY on a
    // saved node's persisted coordinate (both are grid-aligned), stacking two cards
    // on top of each other. Any connector drawn to the buried node then reads as
    // pointing at empty space. Saved nodes are authoritative and never move; nudge
    // each colliding unsaved node straight down to the next free grid cell so every
    // node owns a distinct coordinate. (2026-06-29 per Nika — "humans not positioned
    // correctly, beziers connect to empty space".)
    const isSaved = (id)=>persisted && typeof persisted === 'object' && persisted[id] && typeof persisted[id].x === 'number' && typeof persisted[id].y === 'number';
    // Bbox de-confliction (not just exact-coordinate): a saved node may sit at an
    // off-grid coordinate, so an unsaved node nudged onto the next grid cell could
    // still visually overlap it. Compare full card boxes and bump straight down by
    // a grid row until the box is clear of every already-placed card.
    const rowStep = $83482a6ad78aef6f$var$PERSON_H + $83482a6ad78aef6f$var$ROW_GAP;
    const taken = [];
    const collides = (x, y)=>taken.some((t)=>Math.abs(t.x - x) < $83482a6ad78aef6f$var$PERSON_W && Math.abs(t.y - y) < $83482a6ad78aef6f$var$PERSON_H);
    for (const id of Object.keys(positions))if (isSaved(id)) taken.push({
        x: positions[id].x,
        y: positions[id].y
    });
    for (const id of Object.keys(positions)){
        if (isSaved(id)) continue;
        let { x: x, y: y } = positions[id];
        let guard = 0;
        while(collides(x, y) && guard++ < 500)y += rowStep;
        positions[id] = {
            x: x,
            y: y
        };
        taken.push({
            x: x,
            y: y
        });
    }
    return positions;
};
const $83482a6ad78aef6f$var$_personId = (p, idx)=>p?.userId || p?.email || 'p-' + idx;
// Resolve a node-id back to a person row. Used by suggest-team selection
// expansion and _onNodeClick; the two-line scan was duplicated.
const $83482a6ad78aef6f$var$_personById = (root, id)=>{
    const people = root?.people || [];
    for(let i = 0; i < people.length; i++){
        if ($83482a6ad78aef6f$var$_personId(people[i], i) === id) return people[i];
    }
    return null;
};
const $83482a6ad78aef6f$var$_posFor = (root, id)=>{
    // Merge persisted positions with freshly-computed defaults so people
    // that landed AFTER the user first dragged something around still
    // get a grid slot — previously the persisted map was treated as
    // authoritative and any id missing from it fell through to (0,0),
    // stacking new cards on top of each other in the corner.
    const persisted = root?._tagPositions;
    if (persisted && persisted[id]) return persisted[id];
    const defaults = $83482a6ad78aef6f$var$_initialPositions(root);
    return defaults[id] || {
        x: 0,
        y: 0
    };
};
// ─── Connections ──────────────────────────────────────────────
const $83482a6ad78aef6f$var$_baseConnections = (root)=>{
    // skills/HIERARCHY.md role tree:
    //   simone → chuvak
    //   chuvak → { temo, caesar, watcher }                 (direct siblings only)
    //   temo   → { ux, ui-design, qa }                     (cross-epic helpers
    //                                                       — Temo dispatches
    //                                                       them, so Chuvak
    //                                                       doesn't double-link)
    //   temo   → { sdk, server, smbls, dompiler, extensions,
    //              design, infra, papuna, symbolize, company } (per-epic
    //              subagents)
    const main = [
        {
            from: 'simone',
            to: 'chuvak'
        },
        // chuvak's direct siblings only — chuvak doesn't connect to any
        // agent that Temo is already routing to (avoids visual double-lines
        // and reflects the actual dispatch path).
        {
            from: 'chuvak',
            to: 'temo'
        },
        {
            from: 'chuvak',
            to: 'caesar'
        },
        {
            from: 'chuvak',
            to: 'watcher'
        },
        {
            from: 'chuvak',
            to: 'ochopintre'
        },
        // temo dispatches to the cross-epic helpers (present in every workspace)
        {
            from: 'temo',
            to: 'ux'
        },
        {
            from: 'temo',
            to: 'ui-design'
        },
        {
            from: 'temo',
            to: 'qa'
        }
    ];
    // The per-epic subagent edges are Symbols-workspace-only flow (they used to
    // render in every workspace); temo dispatches to each epic, gated on the
    // active workspace so other workspaces show only the main hierarchy.
    if ($83482a6ad78aef6f$var$_canvasActiveWsId(root) !== $83482a6ad78aef6f$var$SYMBOLS_WS_ID) return main;
    return [
        ...main,
        {
            from: 'temo',
            to: 'sdk'
        },
        {
            from: 'temo',
            to: 'server'
        },
        {
            from: 'temo',
            to: 'smbls'
        },
        {
            from: 'temo',
            to: 'dompiler'
        },
        {
            from: 'temo',
            to: 'extensions'
        },
        {
            from: 'temo',
            to: 'design'
        },
        {
            from: 'temo',
            to: 'papuna'
        },
        {
            from: 'temo',
            to: 'symbolize'
        },
        {
            from: 'temo',
            to: 'company'
        }
    ];
};
// (Removed 2026-06-06 per Nika: _teamCoMembershipEdges. It drew an
// edge between EVERY pair of people sharing a team — after the
// Members-system-team backfill every org member shares one team, so
// the canvas rendered a complete graph (~N²/2 lines) that read as a
// rendering mistake. Team relationships are conveyed by the team
// GroupFrames (see _seedGroupsFromTeams/_mergeTeamSeed); edges are
// reserved for the agent hierarchy, agent⇄person assignments and
// user-drawn connections.)
// Example assignment shipped as a default edge: the PM agent (Temo) is
// connected to Gusztav so the canvas demonstrates an agent⇄person
// assignment out of the box (the "connect PM agent to Gusztav" ask).
// Resolved dynamically from root.people so the endpoint matches whatever
// id (_personId) Gusztav's node renders with; if no Gusztav is in the
// roster the edge simply doesn't appear. Removable like any base edge
// (select it → Remove writes to _tagConnectionsRemoved).
const $83482a6ad78aef6f$var$_exampleConnections = (root)=>{
    const people = Array.isArray(root?.people) ? root.people : [];
    for(let i = 0; i < people.length; i++){
        const p = people[i];
        const hay = `${p?.name || ''} ${p?.email || ''}`.toLowerCase();
        if (hay.includes('gusztav')) return [
            {
                from: 'temo',
                to: $83482a6ad78aef6f$var$_personId(p, i)
            }
        ];
    }
    return [];
};
// Server-backed assignment edges (agent⇄person), sourced from
// root.agentAssignmentsByAgent (loaded by loadAllAgentAssignments). Agent
// node id = username slug; person node id = the assignee's User _id (==
// the person's _personId when they have a userId). Carries assignmentId so
// the edit bar can unassign through the server.
const $83482a6ad78aef6f$var$_assignmentConnections = (root)=>{
    const byAgent = root?.agentAssignmentsByAgent;
    if (!byAgent || typeof byAgent !== 'object') return [];
    const agents = $83482a6ad78aef6f$var$_agents(root);
    const out = [];
    for (const agentUserId of Object.keys(byAgent)){
        const agent = agents.find((a)=>String(a.userId) === String(agentUserId));
        const slug = agent?.id;
        if (!slug) continue;
        for (const a of byAgent[agentUserId] || []){
            if (!a?.assignee) continue;
            out.push({
                from: slug,
                to: String(a.assignee),
                assignment: true,
                assignmentId: a.id,
                agentUserId: String(agentUserId),
                assigneeUserId: String(a.assignee),
                relationship: a.relationship || null
            });
        }
    }
    return out;
};
const $83482a6ad78aef6f$var$_allConnections = (root)=>{
    const base = $83482a6ad78aef6f$var$_baseConnections(root);
    const example = $83482a6ad78aef6f$var$_exampleConnections(root);
    const assignments = $83482a6ad78aef6f$var$_assignmentConnections(root);
    const user = Array.isArray(root?._tagConnections) ? root._tagConnections : [];
    const removed = Array.isArray(root?._tagConnectionsRemoved) ? root._tagConnectionsRemoved : [];
    const removedSet = new Set(removed.map($83482a6ad78aef6f$var$_connectionKey));
    const seen = new Map();
    // Merge order matters for which edge "wins" on dedup: base first
    // (agent hierarchy), then user-added.
    // assignments BEFORE example so a real server assignment wins dedup
    // (keeps its assignmentId) over the local example edge for the same pair.
    // (Team co-membership edges removed 2026-06-06 — team frames carry
    // that relationship now.)
    for (const c of [
        ...base,
        ...assignments,
        ...example,
        ...user
    ]){
        const k = $83482a6ad78aef6f$var$_connectionKey(c);
        if (removedSet.has(k)) continue;
        if (seen.has(k)) continue;
        seen.set(k, {
            ...c
        });
    }
    const merged = [
        ...seen.values()
    ];
    // /agents (agents-only) is a flat grid of agent cards — every edge would
    // dangle to a now-hidden person, so drop them all.
    if (root?._canvasAgentsOnly) return [];
    // Under the /my-agents lens, drop edges whose endpoints aren't both
    // visible so no edge dangles to a filtered-out node. null = unscoped /
    // admin → keep every edge (unchanged for /team-and-agents).
    const visible = $83482a6ad78aef6f$var$_visibleNodeIds(root);
    if (!visible) return merged;
    return merged.filter((c)=>visible.has(c.from) && visible.has(c.to));
};
// Size lookup used by the shared `bezierBetweenNodes` /
// `nodeUnderPoint` / `groupBbox` helpers. Single source of truth so
// every reuse site agrees on which node ids get which dimensions.
// `root` is optional: callers without root context (legacy/early-boot)
// fall back to the SEED list, which is a strict subset of the merged
// Mongo-backed registry — meaning any agent in SEED is always
// classified correctly; only Mongo-only agents that haven't been added
// to SEED yet get person-sized geometry (acceptable visual drift, no
// functional break).
const $83482a6ad78aef6f$var$_canvasIsAgent = (id, root)=>{
    const src = root ? $83482a6ad78aef6f$var$_agents(root) : $83482a6ad78aef6f$var$MAIN_AGENTS;
    return src.some((a)=>a.id === id);
};
const $83482a6ad78aef6f$var$_nodeWidth = (id, root)=>$83482a6ad78aef6f$var$_canvasIsAgent(id, root) ? $83482a6ad78aef6f$var$AGENT_W : $83482a6ad78aef6f$var$PERSON_W;
const $83482a6ad78aef6f$var$_nodeHeight = (id, root)=>$83482a6ad78aef6f$var$_canvasIsAgent(id, root) ? $83482a6ad78aef6f$var$AGENT_H : $83482a6ad78aef6f$var$PERSON_H;
// `root` is optional — without it, _canvasIsAgent falls back to SEED_AGENTS,
// which misclassifies any Mongo-only agent as a person. The two helper
// call sites here both have root available, so they pass the bound
// closure via _sizeOfBound below; the bare _sizeOf is kept for any
// boot-time path that runs before root state is ready.
const $83482a6ad78aef6f$var$_sizeOf = (id, root)=>({
        w: $83482a6ad78aef6f$var$_nodeWidth(id, root),
        h: $83482a6ad78aef6f$var$_nodeHeight(id, root)
    });
const $83482a6ad78aef6f$var$_sizeOfBound = (root)=>(id)=>$83482a6ad78aef6f$var$_sizeOf(id, root);
// SVG path from one node center to another — defers to the shared
// `bezierBetweenNodes` helper so the math doesn't drift from studios'
// connection routing. `_posFor` resolves positions identically to
// the bbox helper, then we hand off.
const $83482a6ad78aef6f$var$_linePath = (root, fromId, toId, el)=>{
    // Merge persisted + default positions so the helper sees a complete
    // map for both endpoints.
    const positions = {
        ...root?._tagPositions || {},
        ...$83482a6ad78aef6f$var$_initialPositions(root) || {}
    };
    // When `el` is available (DOMQL factory), prefer el.call so the
    // helper resolution goes through the function registry. Otherwise
    // (called from a pure module helper) we'd have to import — but
    // every call site here has el, so the el.call path is always taken.
    return el?.call?.('bezierBetweenNodes', {
        fromId: fromId,
        toId: toId,
        positions: positions,
        sizeOf: $83482a6ad78aef6f$var$_sizeOfBound(root)
    }) || '';
};
// ─── Node click + drag handlers ───────────────────────────────
//
// Module-level "just dragged" flag — set by the mousedown drag handler
// when the cursor crossed the 3px threshold during a press. The click
// handler checks it and bails so a drag-release doesn't also open the
// modal. Cleared on the next mousedown so successive clicks work.
let $83482a6ad78aef6f$var$_justDragged = false;
const $83482a6ad78aef6f$var$_onNodeClick = (e, el, s, kind)=>{
    // Suppress click handling immediately after a drag — the DOM still
    // fires `click` after mouseup even if mousemove moved the element,
    // so we use this flag to differentiate "tap" from "drag-release".
    if ($83482a6ad78aef6f$var$_justDragged) {
        $83482a6ad78aef6f$var$_justDragged = false;
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    const root = s.root;
    const id = el.node?.dataset?.nodeId;
    if (!id) return;
    if (root._tagConnectMode) {
        e.preventDefault();
        e.stopPropagation();
        const first = root._tagConnectFrom;
        if (!first) {
            root.update({
                _tagConnectFrom: id
            });
            return;
        }
        if (first === id) {
            root.update({
                _tagConnectFrom: null
            });
            return;
        }
        const existing = Array.isArray(root._tagConnections) ? root._tagConnections : [];
        root.update({
            _tagConnections: [
                ...existing,
                {
                    from: first,
                    to: id
                }
            ],
            _tagConnectFrom: null
        });
        return;
    }
    // Normal click:
    //  - Agent → open AgentModal (no `/agent-profile` route exists yet).
    //  - Person → open the shared profile modal (same one OnlineMembers /
    //    IntranetRows / avatar chips open). Replaces the prior
    //    PersonDetailModal hop per Nika's 2026-06-03 ask — that modal's
    //    Icons.Close was rendering off-viewport on this canvas and the
    //    avatar-click profile modal is the canonical "view this member"
    //    surface across the workspace.
    if (kind === 'agent') {
        const agent = $83482a6ad78aef6f$var$_agents(root).find((a)=>a.id === id);
        if (agent) $83482a6ad78aef6f$var$_openAgentEditor(root, agent);
        return;
    }
    const person = $83482a6ad78aef6f$var$_personById(root, id);
    if (!person?.email) return;
    el.call('openProfileModal', person.email);
};
// Which NON-self node is the dragged card centered over? Used for
// drag-collision-to-form-group (studios pattern). Delegates the rect
// test to the shared `nodeUnderPoint` helper via el.call, so the
// collision math is the same one every other canvas surface uses.
// Skips agents (they ride connection edges, not group frames).
const $83482a6ad78aef6f$var$_hoveredNode = (el, root, draggedId, draggedW, draggedH)=>{
    // Complete map (default grid + persisted overlay) — `_tagPositions`
    // alone is a sparse user-drag map and misses un-dragged nodes.
    const positions = $83482a6ad78aef6f$var$_initialPositions(root);
    const p = positions[draggedId];
    if (!p) return null;
    const cx = p.x + draggedW / 2;
    const cy = p.y + draggedH / 2;
    const candidates = (root?.people || []).map((person)=>person.userId || person.email).filter(Boolean).map((id)=>({
            id: id,
            w: $83482a6ad78aef6f$var$PERSON_W,
            h: $83482a6ad78aef6f$var$PERSON_H
        }));
    return el?.call?.('nodeUnderPoint', {
        candidates: candidates,
        positions: positions,
        cx: cx,
        cy: cy,
        ignoreId: draggedId
    }) || null;
};
// Which team group's frame is the cursor (center of the dragged card)
// currently over? Returns the group id ('team:Name') or null. Skips
// the dragged node's OWN group so the user never gets a "join current
// group" no-op.
const $83482a6ad78aef6f$var$_hoveredGroup = (el, root, draggedId, draggedW, draggedH)=>{
    // Complete map (default grid + persisted overlay) — `_tagPositions`
    // alone is a sparse user-drag map and misses un-dragged nodes.
    const positions = $83482a6ad78aef6f$var$_initialPositions(root);
    const p = positions[draggedId];
    if (!p) return null;
    const cx = p.x + draggedW / 2;
    const cy = p.y + draggedH / 2;
    const ownGroup = $83482a6ad78aef6f$var$_groupFor({
        id: draggedId,
        email: $83482a6ad78aef6f$var$_canvasEmailOf(root, draggedId)
    }, root);
    for (const g of $83482a6ad78aef6f$var$_allGroups(root)){
        if (g.id === ownGroup) continue;
        const bb = $83482a6ad78aef6f$var$_groupBbox(root, g.id, el);
        if (!bb) continue;
        // Match the frame's painted rect (includes GROUP_PAD on every side
        // and an extra 28px label gutter above). Defers the rect test to
        // the shared `pointInRect` helper.
        const expanded = {
            x: bb.x - $83482a6ad78aef6f$var$GROUP_PAD,
            y: bb.y - $83482a6ad78aef6f$var$GROUP_PAD - 28,
            w: bb.w + $83482a6ad78aef6f$var$GROUP_PAD * 2,
            h: bb.h + $83482a6ad78aef6f$var$GROUP_PAD * 2 + 28
        };
        if (el?.call?.('pointInRect', cx, cy, expanded)) return g.id;
    }
    return null;
};
// Email lookup for a person id (people use userId-or-email as data-node-id).
const $83482a6ad78aef6f$var$_canvasEmailOf = (root, id)=>{
    const people = root?.people || [];
    for(let i = 0; i < people.length; i++){
        const p = people[i];
        if ((p.userId || p.email || 'p-' + i) === id) return p.email;
    }
    return null;
};
// Find the SDK Team row matching a frame's group id ('team:NAME').
const $83482a6ad78aef6f$var$_teamForGroupId = (root, groupId)=>{
    if (!groupId) return null;
    const label = groupId.slice(5);
    return (root?.teams || []).find((t)=>t.name === label) || null;
};
// Create or extend a group via drag-collision (studios pattern,
// 2026-06-04 rewrite). Mutates `_tagGroupMap` (the flat
// nodeId → slot map) instead of the previous adhoc-array model.
//   - draggedId currently free + targetId free   → new slot containing both
//   - draggedId free + targetId already in slot  → draggedId joins
//     that existing slot
//   - draggedId already in slot + targetId free  → targetId joins
//     draggedId's slot
//   - both in different slots                    → no-op (would need
//     a merge prompt; studios behaves the same).
const $83482a6ad78aef6f$var$_formGroupOnDrop = (root, draggedId, targetId)=>{
    if (!root || !draggedId || !targetId || draggedId === targetId) return;
    const draggedSlot = $83482a6ad78aef6f$var$_currentGroupOf(root, draggedId);
    const targetSlot = $83482a6ad78aef6f$var$_currentGroupOf(root, targetId);
    if (draggedSlot && targetSlot && draggedSlot !== targetSlot) return;
    const map = {
        ...$83482a6ad78aef6f$var$_groupMap(root)
    };
    if (!draggedSlot && targetSlot) {
        map[draggedId] = targetSlot;
        root.update({
            _tagGroupMap: map
        });
        return;
    }
    if (draggedSlot && !targetSlot) {
        map[targetId] = draggedSlot;
        root.update({
            _tagGroupMap: map
        });
        return;
    }
    if (!draggedSlot && !targetSlot) {
        const slot = $83482a6ad78aef6f$var$_nextGroupSlot(root);
        map[draggedId] = slot;
        map[targetId] = slot;
        root.update({
            _tagGroupMap: map
        });
    }
};
// Drop a person card outside every team frame → leave their team.
//
// The team is the one the slot's frame is named after, among the person's
// REAL teams (system groups and other orgs excluded), and only a viewer who
// may manage team members (admin tier — the same gate as the agent
// assignments) gets the leave. null → the drop is layout only (an ad-hoc
// group, a renamed frame, a viewer below admin).
//
// Slot ids are `groupN`, never `team:NAME`: the old `_teamForGroupId(slot)`
// lookup matched no team, so before this the leave never reached the server
// and the frame re-seeded the person on the next load.
const $83482a6ad78aef6f$var$_leavableTeam = (root, personId, slot)=>{
    if (!slot || $83482a6ad78aef6f$var$_viewerTier(root) !== 'admin') return null;
    const person = $83482a6ad78aef6f$var$_personById(root, personId);
    if (!person?.userId) return null;
    const label = $83482a6ad78aef6f$var$_slotLabel(root, slot);
    return $83482a6ad78aef6f$var$_personRealTeams(root, person).find((t)=>t.name === label) || null;
};
const $83482a6ad78aef6f$var$_personLabel = (el, person)=>person?.name || String(person?.email || '').split('@')[0] || el.call('polyglot', 'canvas.team.toast.memberFallback');
// Put the card back where the drag started (Cancel changes nothing).
const $83482a6ad78aef6f$var$_putCardBack = (el, root, personId, start)=>{
    root.update({
        _tagPositions: {
            ...root._tagPositions || {},
            [personId]: {
                x: start.x,
                y: start.y
            }
        }
    });
    $83482a6ad78aef6f$var$_saveLayoutToPrefs(el, root);
};
const $83482a6ad78aef6f$var$_removeFromSlot = (root, personId)=>{
    const map = {
        ...$83482a6ad78aef6f$var$_groupMap(root)
    };
    delete map[personId];
    root.update({
        _tagGroupMap: map
    });
};
// The house confirm names the person and the team (CRUD + confirm standard
// rule 4); nothing changes before the verb. Every way out but the verb puts
// the card back.
const $83482a6ad78aef6f$var$_askLeaveTeamOnDrop = (el, root, personId, slot, team, start)=>{
    const person = $83482a6ad78aef6f$var$_personById(root, personId);
    el.call('confirmTeamLeave', {
        name: $83482a6ad78aef6f$var$_personLabel(el, person),
        team: team,
        onConfirm: ()=>$83482a6ad78aef6f$var$_leaveTeamOnDrop(el, root, personId, slot, team, start),
        onCancel: ()=>$83482a6ad78aef6f$var$_putCardBack(el, root, personId, start)
    });
};
// Confirmed: the card leaves the frame and the membership follows
// (runTeamLeave: optimistic, SDK, rollback of the membership rows). A failed
// removal puts the card back in its frame and says so (rule 5).
const $83482a6ad78aef6f$var$_leaveTeamOnDrop = async (el, root, personId, slot, team, start)=>{
    const person = $83482a6ad78aef6f$var$_personById(root, personId);
    if (!person?.userId) return;
    $83482a6ad78aef6f$var$_removeFromSlot(root, personId);
    $83482a6ad78aef6f$var$_saveLayoutToPrefs(el, root);
    const left = await el.call('runTeamLeave', root, {
        team: team,
        userId: person.userId,
        email: person.email
    });
    if (left === true) return;
    if (!$83482a6ad78aef6f$var$_currentGroupOf(root, personId)) root.update({
        _tagGroupMap: {
            ...$83482a6ad78aef6f$var$_groupMap(root),
            [personId]: slot
        }
    });
    $83482a6ad78aef6f$var$_putCardBack(el, root, personId, start);
    root.update({
        _tagToast: {
            kind: 'error',
            text: el.call('polyglot', 'canvas.team.toast.leaveFailed').replace('{name}', ()=>$83482a6ad78aef6f$var$_personLabel(el, person)).replace('{team}', ()=>team.name)
        }
    });
};
// Optimistic teamsByEmail mutation. Studios calls back to the SDK on
// drop; we do the same here via `el.call('addMemberToTeam', …)` so the
// server-side `Team` + `TeamMember` records reflect the new assignment
// across every surface. On SDK failure the optimistic update reverts.
const $83482a6ad78aef6f$var$_joinTeamOnDrop = async (el, root, personId, fromGroupId, toGroupId)=>{
    const team = $83482a6ad78aef6f$var$_teamForGroupId(root, toGroupId);
    if (!team) return;
    const email = $83482a6ad78aef6f$var$_canvasEmailOf(root, personId);
    if (!email) return;
    const person = (root.people || []).find((p)=>(p.userId || p.email) === personId);
    const userId = person?.userId;
    if (!userId) return;
    // Optimistic local merge — add the new team entry for this email so
    // _allGroups / _groupBbox / _ungroupedEntries re-derive immediately.
    const prev = root.teamsByEmail || {};
    const key = String(email).toLowerCase();
    const existing = (prev[key] || []).filter((e)=>e.id !== team.id);
    // Carry category + status forward so the optimistic membership row
    // looks identical to one produced by loadAllTeamMembers — without
    // these, TeamPersonNode's category-color border reverts to
    // "unknown" until the next refresh.
    const nextEntries = [
        ...existing,
        {
            id: team.id,
            name: team.name,
            slug: team.slug,
            orgId: team.orgId,
            role: 'member',
            category: team.category || null,
            status: team.category === 'passive' ? 'passive' : 'active'
        }
    ];
    root.update({
        teamsByEmail: {
            ...prev,
            [key]: nextEntries
        }
    });
    try {
        await el.call('addMemberToTeam', root, {
            orgId: team.orgId,
            teamId: team.id,
            userId: userId,
            email: email
        });
    } catch (err) {
        // Revert the optimistic merge — `addMemberToTeam` itself optimistically
        // writes to teamsByEmail on success, so a failure means we never
        // recorded the entry server-side. Restore the prior shape.
        root.update({
            teamsByEmail: prev
        });
        console.warn('[team-and-agents] join-team drop failed:', err?.message || err);
    }
};
// ─── Persistence (workspace-shared canvas layout) ────────────────
//
// 2026-06-04: migrated from per-user `workspaceProject.userPreferences`
// to the workspace-shared `sdk.canvasLayout` surface (same Mongo-backed
// `/workspaces/:wsId/canvas-layout` endpoint /studios uses for project
// tile positions). Every member sees and updates the same node map —
// drag a card and the new position appears for everyone in the org.
//
// Storage strategy:
//   - `positions` map is namespaced with the `ta:` prefix so it can
//     coexist with /studios' project ids and /my-agents' `ma:` prefix
//     in the same workspace layout document.
//   - Live broadcast: `sdk.subscribeWorkspaceCanvasLayout` fires on
//     every PATCH from any client; the page absorbs incoming positions
//     into `_tagPositions` so drags from another tab/member reflect
//     without a refresh.
//   - Per-user state (`_tagConnections`, `_tagConnectionsRemoved`,
//     `_tagAdHocGroups`) stays in `workspaceProject.userPreferences`
//     for now — the canvas-layout schema is `{positions, groups}`
//     only; promoting those to workspace-shared needs a server-side
//     schema extension (follow-up).
const $83482a6ad78aef6f$var$_TA_PREFIX = 'ta:';
const $83482a6ad78aef6f$var$_PREFS_KEY = 'team_and_agents_layout';
// Resolve the workspace id every canvas-layout call needs. The
// canvas-layout endpoint is keyed by WORKSPACE id (Mongo `_id` of the
// active workspace inside the active org), NOT the org id — verified
// 2026-06-04 by trial: `workspace_org_id` returns "Workspace not
// found", whereas `jwtClaims.active_workspace_id` resolves. Prefer
// the JWT claim (refreshed on every login + switch) with `root.workspace.id`
// as a fallback for SPA paths where state.workspace hydrates before
// the next JWT mint.
const $83482a6ad78aef6f$var$_wsId = (root)=>root?.jwtClaims?.active_workspace_id || root?.workspace?.id || null;
// Strip the `ta:` prefix from a positions object received from the
// server back into the bare node id space the rest of this page reads.
const $83482a6ad78aef6f$var$_unprefixPositions = (positions)=>{
    const out = {};
    if (!positions || typeof positions !== 'object') return out;
    for (const [k, v] of Object.entries(positions)){
        if (!k.startsWith($83482a6ad78aef6f$var$_TA_PREFIX)) continue;
        if (v && typeof v === 'object' && typeof v.x === 'number' && typeof v.y === 'number') out[k.slice($83482a6ad78aef6f$var$_TA_PREFIX.length)] = {
            x: v.x,
            y: v.y
        };
    }
    return out;
};
// Reconstruct the flat group model from canvas-layout's groups field.
// Returns { map: { nodeId: slot }, names: { slot: label } } or null
// if there are no `ta:`-namespaced groups in the document.
const $83482a6ad78aef6f$var$_unprefixGroups = (groups)=>{
    if (!groups || typeof groups !== 'object') return null;
    const map = {};
    const names = {};
    let touched = false;
    for (const [k, v] of Object.entries(groups)){
        if (!k.startsWith($83482a6ad78aef6f$var$_TA_PREFIX)) continue;
        if (!v || typeof v !== 'object') continue;
        // `{ key, name? }` — the server's canvas-layout group-entry contract
        // (WorkspaceCanvasLayout groupSchema). Any other shape is dropped by
        // the PATCH merge server-side, so it can never appear in a stored doc.
        const slot = v.key;
        if (slot) {
            map[k.slice($83482a6ad78aef6f$var$_TA_PREFIX.length)] = slot;
            if (v.name) names[slot] = v.name;
            touched = true;
        }
    }
    return touched ? {
        map: map,
        names: names
    } : null;
};
// Build the canvas-layout groups payload from the flat _tagGroupMap +
// _tagGroupNames shape. One entry per member node, namespaced with
// the `ta:` prefix.
const $83482a6ad78aef6f$var$_prefixGroups = (groupMap, groupNames)=>{
    const out = {};
    if (!groupMap || typeof groupMap !== 'object') return out;
    const names = groupNames && typeof groupNames === 'object' ? groupNames : {};
    for (const [nodeId, slot] of Object.entries(groupMap)){
        if (!slot) continue;
        // `{ key, name? }` per the server contract — entries shaped any other
        // way are silently dropped by the PATCH merge (how groups vanished).
        out[$83482a6ad78aef6f$var$_TA_PREFIX + nodeId] = {
            key: slot,
            ...names[slot] ? {
                name: names[slot]
            } : {}
        };
    }
    return out;
};
// Imperatively re-apply node positions to the mounted DOM. v3.14
// layout-prop factories can freeze at their mount value (reactive
// layout props don't re-apply); the per-key style{left,top} form the
// nodes use is the working dynamic form, but when the async
// canvas-layout GET lands AFTER the People/Agents children mounted, a
// missed tick leaves already-mounted cards at their default grid
// slots. This loop is the same imperative write pattern the page uses
// for the board transform (applyBoardTransform): scoped to THIS
// board's node, rAF'd, and a no-op for nodes that aren't mounted yet
// (those read the fresh _tagPositions via _posFor at mount anyway).
const $83482a6ad78aef6f$var$_applyPositionsToDom = (root, el)=>{
    if (typeof window === 'undefined') return;
    const board = el?.AppMain?.Body?.Stage?.Board?.node;
    if (!board || !board.querySelectorAll) return;
    window.requestAnimationFrame(()=>{
        const positions = $83482a6ad78aef6f$var$_initialPositions(root);
        for (const node of board.querySelectorAll('[data-node-id]')){
            const p = positions[node.dataset.nodeId];
            if (!p || typeof p.x !== 'number' || typeof p.y !== 'number') continue;
            node.style.left = p.x + 'px';
            node.style.top = p.y + 'px';
        }
    });
};
// ─── Viewport windowing (render only on-screen nodes) ─────────────
//
// The board holds ~508 person/agent cards. Mounting all of them on first
// paint builds ~508 card subtrees and decodes ~508 avatars — the iPad
// first-paint cost. Windowing renders only the nodes whose board-space AABB
// intersects the panzoom viewport (+ margin), mounting/unmounting as the
// camera pans. The reactive contract is deliberately narrow:
//
//   • The People/Agents children factory filters on `root._tagVisibleIds`
//     (a plain { [id]: 1 } map) and NOTHING else position-related. It must
//     never read `_tagPositions` — that signal is rewritten on every drag
//     pointermove (see _onNodePointerdown), so subscribing the factory to it
//     would unmount+remount every node on every move (a reconcile storm).
//   • `_tagVisibleIds` is (re)computed OUTSIDE any reactive effect — in an
//     rAF driven by the panzoom transform (+ roster / position / fit hooks) —
//     and written via root.update, which re-runs the factory exactly once per
//     membership change (the set-diff gate below drops no-op writes).
//
// Hysteresis (MOUNT_MARGIN < KEEP_MARGIN): a node mounts when it enters the
// inner MOUNT band and stays until it leaves the wider KEEP band, so nodes
// hovering the edge don't thrash mount/unmount on tiny pans.
const $83482a6ad78aef6f$var$_TEAM_WINDOW_MOUNT_MARGIN = 420 // board-px past the viewport edge to MOUNT
;
const $83482a6ad78aef6f$var$_TEAM_WINDOW_KEEP_MARGIN = 900 // board-px past the viewport edge to KEEP mounted
;
// Uniform windowing box: person + agent cards share width (220); heights are
// 96 / 110, so the max (110) over-includes a person's box by 14px — which only
// ever errs toward MOUNTING (never wrongly unmounts a visible node) and keeps
// the intersection test O(n) with no per-node agent lookup.
const $83482a6ad78aef6f$var$_WIN_NODE_W = $83482a6ad78aef6f$var$PERSON_W;
const $83482a6ad78aef6f$var$_WIN_NODE_H = Math.max($83482a6ad78aef6f$var$PERSON_H, $83482a6ad78aef6f$var$AGENT_H);
// Node ids pinned into the visible set regardless of viewport — the node being
// position-dragged and the link-drag source. Module-level, matching
// _justDragged / _activeDrag: only one drag runs at a time globally, and a
// pinned id with no matching node in a given board is just an inert map entry.
const $83482a6ad78aef6f$var$_pinnedIds = new Set();
// Resolve the page root store from any element defensively (mirrors the
// onCreate/onRemove derivation — `state` isn't always threaded through the
// home-embed extend chain).
const $83482a6ad78aef6f$var$_tagRootOf = (el)=>{
    const state = el?.state || (typeof el?.getRoot === 'function' ? el.getRoot().state : null);
    return state?.root || null;
};
// Walk up from any node / link-handle element to the teamAndAgents PAGE
// element — the one that owns __tagPzInstance + the windowing recompute state.
// Follows THIS element's own parent chain (el.parent is already used at the
// LinkHandle), so a second embedded board is never cross-driven.
const $83482a6ad78aef6f$var$_tagPageElOf = (el)=>{
    let n = el;
    let guard = 0;
    while(n && guard++ < 16){
        if (n.__tagPzInstance) return n;
        n = n.parent;
    }
    return null;
};
// Invert the panzoom matrix (screen = board*scale + translate) to the visible
// board-space rect, padded by `margin` board-px on each side.
const $83482a6ad78aef6f$var$_boardRectFromCamera = (t, vw, vh, margin)=>{
    const s = t.scale || 1;
    return {
        left: -t.x / s - margin,
        top: -t.y / s - margin,
        right: (vw - t.x) / s + margin,
        bottom: (vh - t.y) / s + margin
    };
};
// Ids whose uniform card box overlaps `rect`. Pure O(n) — no reactive reads,
// no per-node size lookup (see _WIN_NODE_*). `snap` is an id→{x,y} map.
const $83482a6ad78aef6f$var$_teamIdsIntersectingRect = (snap, rect)=>{
    const out = new Set();
    for(const id in snap){
        const p = snap[id];
        // Fail-safe: a node with no known coords (never positioned → empty {} in
        // _tagPositions) has no box to test for overlap. NEVER drop it — always
        // include it, otherwise windowing permanently unmounts un-positioned cards
        // (they render at their computed layout slot but vanish once the recompute
        // takes over). Correctness over the tiny cost of always-mounting the few
        // cards that lack saved coords.
        if (!p || typeof p.x !== 'number' || typeof p.y !== 'number') {
            out.add(id);
            continue;
        }
        if (p.x <= rect.right && p.x + $83482a6ad78aef6f$var$_WIN_NODE_W >= rect.left && p.y <= rect.bottom && p.y + $83482a6ad78aef6f$var$_WIN_NODE_H >= rect.top) out.add(id);
    }
    return out;
};
// Cached position snapshot for the recompute. `_initialPositions` is O(n²)
// (bbox de-confliction), so it must NOT run per pan frame — rebuild only when
// the _tagPositions object identity OR the roster length changes. During a
// board pan _tagPositions is stable (only node drags rewrite it, and a node
// drag doesn't pan), so the snapshot stays cached across every pan frame.
// Stored on the page el.
const $83482a6ad78aef6f$var$_windowPosSnapshot = (root, el)=>{
    const posId = root?._tagPositions;
    const rosterLen = ($83482a6ad78aef6f$var$_visiblePeople(root)?.length || 0) + ($83482a6ad78aef6f$var$_visibleAgents(root)?.length || 0);
    const cache = el.__tagPosSnapshot;
    if (cache && cache.posId === posId && cache.rosterLen === rosterLen) return cache.snap;
    const base = $83482a6ad78aef6f$var$_initialPositions(root);
    // Every node in _tagPositions MUST be represented in the snap, or it's invisible
    // to _idsIntersectingRect and gets permanently dropped once windowing engages.
    // _initialPositions omits never-positioned nodes (empty {} coords), so union any
    // missing raw entry in; _idsIntersectingRect fail-safe-includes coord-less nodes
    // so they always render. Copy (don't mutate _initialPositions' return).
    const snap = base ? {
        ...base
    } : {};
    const rawPos = root?._tagPositions;
    if (rawPos) {
        for(const id in rawPos)if (!(id in snap)) snap[id] = rawPos[id] || {};
    }
    el.__tagPosSnapshot = {
        posId: posId,
        rosterLen: rosterLen,
        snap: snap
    };
    return snap;
};
// Steady-state window gate — reads ONLY `_tagVisibleIds` (never
// `_tagPositions`). Fail-open before the first recompute exists; the factory's
// first-paint path supplies a real seed set so we don't actually mount all 508
// in that window.
const $83482a6ad78aef6f$var$_inWindow = (root, id)=>{
    const vis = root?._tagVisibleIds;
    return vis ? !!vis[id] : true;
};
// First-paint seed: before any recompute has written `_tagVisibleIds`, window
// against the seed-camera rect ({ x:40, y:40, scale:1 } — the panzoom seed;
// the Stage isn't laid out yet so use window.inner*). Positions are read inside
// an UNTRACKED region so the factory effect never subscribes to `_tagPositions`
// (a subscription would remount every node per drag move). Cached on the
// container el and keyed by roster length, so it recomputes when nodes arrive
// (no "0 nodes" flash on cold load) but never per frame.
const $83482a6ad78aef6f$var$_teamEnsureInitialWindow = (root, el)=>{
    if (typeof window === 'undefined') return null;
    const prev = (0, $eY4Ct.getObserver)();
    (0, $eY4Ct.setObserver)(null);
    try {
        const rosterLen = ($83482a6ad78aef6f$var$_visiblePeople(root)?.length || 0) + ($83482a6ad78aef6f$var$_visibleAgents(root)?.length || 0);
        if (el.__tagInitialWindow && el.__tagInitialWindowLen === rosterLen) return el.__tagInitialWindow;
        const snap = $83482a6ad78aef6f$var$_initialPositions(root);
        const rect = $83482a6ad78aef6f$var$_boardRectFromCamera({
            x: 40,
            y: 40,
            scale: 1
        }, window.innerWidth || 1280, window.innerHeight || 800, $83482a6ad78aef6f$var$_TEAM_WINDOW_MOUNT_MARGIN);
        const set = $83482a6ad78aef6f$var$_teamIdsIntersectingRect(snap, rect);
        el.__tagInitialWindow = set;
        el.__tagInitialWindowLen = rosterLen;
        return set;
    } finally{
        (0, $eY4Ct.setObserver)(prev);
    }
};
// Filter mapped children to the viewport window. Reads `_tagVisibleIds` once
// (tracked → the factory re-runs when the recompute rewrites it); on the very
// first paint (no recompute yet) it windows against the untracked seed set
// instead of failing open to the whole roster.
const $83482a6ad78aef6f$var$_teamWindowFilter = (root, el, nodes, idOf)=>{
    // Steady state: the recompute has written `_tagVisibleIds` → gate on it
    // (reads ONLY that signal, never `_tagPositions`).
    if (root?._tagVisibleIds) return nodes.filter((n)=>$83482a6ad78aef6f$var$_inWindow(root, idOf(n)));
    // First paint (no recompute yet): window against the untracked seed set
    // instead of failing open to the whole roster.
    const seed = $83482a6ad78aef6f$var$_teamEnsureInitialWindow(root, el);
    return seed ? nodes.filter((n)=>seed.has(idOf(n))) : nodes;
};
// rAF-coalesced recompute scheduler. Multiple triggers in one frame (pan tick +
// roster tick + drag release) collapse to a single run.
const $83482a6ad78aef6f$var$scheduleTeamWindowRecompute = (el, root)=>{
    if (!el || !root || typeof window === 'undefined') return;
    if (el.__tagVizRaf) return;
    el.__tagVizRaf = window.requestAnimationFrame(()=>{
        el.__tagVizRaf = null;
        $83482a6ad78aef6f$var$_teamRunWindowRecompute(el, root);
    });
};
// Compute the new visible set from the live camera and, ONLY when membership
// actually changed, write it to `_tagVisibleIds`. The set-diff gate is what
// stops a fast pan from firing a root.update — and thus a reconcile — every
// frame. Always runs in an rAF (outside any reactive effect), so its reactive
// reads subscribe nothing.
const $83482a6ad78aef6f$var$_teamRunWindowRecompute = (el, root)=>{
    if (!el || !root || typeof window === 'undefined') return;
    const pz = el.__tagPzInstance;
    const stage = el.AppMain?.Body?.Stage?.node;
    if (!pz || !stage || typeof pz.getTransform !== 'function') return;
    let t;
    try {
        t = pz.getTransform();
    } catch (_) {
        return;
    }
    if (!t) return;
    const vw = stage.clientWidth || stage.getBoundingClientRect().width;
    const vh = stage.clientHeight || stage.getBoundingClientRect().height;
    if (!vw || !vh) return;
    const snap = $83482a6ad78aef6f$var$_windowPosSnapshot(root, el);
    const newSet = $83482a6ad78aef6f$var$_teamIdsIntersectingRect(snap, $83482a6ad78aef6f$var$_boardRectFromCamera(t, vw, vh, $83482a6ad78aef6f$var$_TEAM_WINDOW_MOUNT_MARGIN));
    // Hysteresis — keep previously-visible nodes that still fall inside the wider
    // KEEP band so edge nodes don't thrash mount/unmount on small pans.
    const prev = el.__tagLastVisibleSet;
    if (prev && prev.size) {
        const keepSet = $83482a6ad78aef6f$var$_teamIdsIntersectingRect(snap, $83482a6ad78aef6f$var$_boardRectFromCamera(t, vw, vh, $83482a6ad78aef6f$var$_TEAM_WINDOW_KEEP_MARGIN));
        for (const id of prev)if (keepSet.has(id)) newSet.add(id);
    }
    // Never unmount a node being dragged / linked from.
    for (const id of $83482a6ad78aef6f$var$_pinnedIds)newSet.add(id);
    // Set-diff gate: identical membership → no root.update, no reconcile.
    const key = newSet.size ? [
        ...newSet
    ].sort().join('|') : '';
    if (key === el.__tagLastVisibleKey) return;
    el.__tagLastVisibleKey = key;
    el.__tagLastVisibleSet = newSet;
    const map = {};
    for (const id of newSet)map[id] = 1;
    root.update({
        _tagVisibleIds: map
    });
    // Freshly-mounted nodes read their saved coords via _posFor at mount, but a
    // v3.14 reactive-layout freeze can leave them at the default grid slot;
    // re-apply positions imperatively (same pattern the snap poll uses).
    $83482a6ad78aef6f$var$_applyPositionsToDom(root, el);
};
// Hydrate _tagPositions from the workspace-shared canvas layout AND
// the per-user prefs for the still-per-user fields. Idempotent: an
// empty server response leaves whatever the user already has on root.
const $83482a6ad78aef6f$var$_hydrateLayoutFromPrefs = async (root, el)=>{
    // Serialize hydrate passes — onCreate, the prefs-landed re-run AND
    // the wsId-landed re-run (both in onUpdate) can each kick this;
    // overlapping GETs would race each other's _tagPositions writes.
    if (el?._tagHydrateInFlight) return;
    if (el) el._tagHydrateInFlight = true;
    // 1) Per-user connection state from userPreferences — same shape as
    //    pre-migration. Read here so a legacy `positions` blob inside
    //    user prefs still seeds the canvas on the first load after the
    //    migration ships (treated as fallback only).
    const prefs = root?.userPrefs || {};
    const legacy = prefs[$83482a6ad78aef6f$var$_PREFS_KEY] || {};
    const userOnly = {};
    if (Array.isArray(legacy.connections)) userOnly._tagConnections = legacy.connections;
    if (Array.isArray(legacy.connectionsRemoved)) userOnly._tagConnectionsRemoved = legacy.connectionsRemoved;
    // Migrate legacy adhoc arrays into the studios-style flat map on
    // first hydration after the 2026-06-04 refactor — discarded after
    // the next save commits the new shape to canvas-layout.groups.
    if (Array.isArray(legacy.adHocGroups) && legacy.adHocGroups.length) {
        const map = {};
        const names = {};
        let slotIdx = 0;
        for (const g of legacy.adHocGroups){
            const memberIds = Array.isArray(g?.memberIds) ? g.memberIds : [];
            if (memberIds.length < $83482a6ad78aef6f$var$MIN_GROUP_MEMBERS) continue;
            const slot = (0, $6ocCI.GROUP_SLOTS)[slotIdx++] || 'group' + slotIdx;
            for (const id of memberIds)map[id] = slot;
            if (g.label) names[slot] = g.label;
        }
        if (Object.keys(map).length) {
            userOnly._tagGroupMap = map;
            if (Object.keys(names).length) userOnly._tagGroupNames = names;
        }
    }
    if (Object.keys(userOnly).length) root?.update?.(userOnly);
    // 2) Workspace-shared positions from sdk.canvasLayout. Fall back to
    //    the legacy per-user positions on miss/error so a tenant whose
    //    server worker hasn't deployed the workspace-shared schema yet
    //    still sees their prior drags.
    const wsId = $83482a6ad78aef6f$var$_wsId(root);
    const sdk = (0, $1NxyO.getSDK)();
    let serverPositions = null;
    let serverGroups = null;
    let attempted = false;
    let getSucceeded = false;
    if (sdk?.getCanvasLayout && wsId) {
        attempted = true;
        try {
            const layout = await sdk.getCanvasLayout(wsId);
            getSucceeded = true;
            const strippedPos = $83482a6ad78aef6f$var$_unprefixPositions(layout?.positions);
            if (Object.keys(strippedPos).length) serverPositions = strippedPos;
            // Groups shape on canvas-layout: { [prefixedNodeId]:
            // { key, name? } }. Reconstruct the flat
            // `_tagGroupMap` + `_tagGroupNames` shape from it.
            const strippedGroups = $83482a6ad78aef6f$var$_unprefixGroups(layout?.groups);
            if (strippedGroups) serverGroups = strippedGroups;
            if (layout?.version != null) root.__tagLayoutVersion = layout.version;
        } catch (err) {
            console.warn('[team-and-agents] getCanvasLayout failed:', err?.message || err);
        }
    }
    // Remember which workspace this pass ran for — onUpdate re-runs the
    // hydrate when the resolvable wsId differs (the onCreate pass can
    // fire before jwtClaims/workspace land, skipping the GET entirely;
    // without this re-run the saved layout never loads and the canvas
    // stays on the default grid for the whole session). Recorded even
    // when the GET path is unavailable so onUpdate doesn't re-kick on
    // every tick.
    if (el && wsId) el._tagLayoutWsLoaded = wsId;
    if (serverPositions) // Merge UNDER any in-session local drags — `_tagPositions` only
    // ever holds persisted coords + this session's user drags now (the
    // drag handler no longer bakes the default grid in), so local keys
    // are always fresher user intent than the GET snapshot. A plain
    // replace here clobbered a drag made while the GET was in flight.
    root?.update?.({
        _tagPositions: {
            ...serverPositions,
            ...root._tagPositions || {}
        }
    });
    else if (legacy.positions && typeof legacy.positions === 'object') root?.update?.({
        _tagPositions: {
            ...legacy.positions,
            ...root._tagPositions || {}
        }
    });
    if (serverGroups) root?.update?.({
        _tagGroupMap: serverGroups.map,
        _tagGroupNames: serverGroups.names
    });
    // Team grouping (2026-06-06, per Nika): humans are grouped by their
    // REAL teams on every hydrate — fresh canvases get the full seed,
    // and saved canvases gain frames for team members nobody grouped
    // manually (_mergeTeamSeed never moves a node out of a slot the
    // user placed it in). Subsequent drags persist the result back to
    // canvas-layout for everyone.
    const teamMerged = $83482a6ad78aef6f$var$_mergeTeamSeed(root);
    if (teamMerged) root?.update?.({
        _tagGroupMap: teamMerged.map,
        _tagGroupNames: teamMerged.names
    });
    // Flag so the onUpdate save-gate can arm itself off this signal
    // (the legacy gate keyed on userPrefs which may never land for a
    // workspace whose only persistence path is canvas-layout). Without
    // this the save NEVER fires — verified 2026-06-04: 71 default
    // positions in _tagPositions but workspace layout stayed empty.
    //
    // Only set once the canvas-layout GET was actually ATTEMPTED (wsId
    // resolved) or there is genuinely nothing to load through (no SDK
    // method). A pass that skipped the GET because wsId hadn't landed
    // yet must NOT arm the save-gate — saves fired before the first
    // real load completes are exactly the race that persisted default
    // positions over the saved layout.
    //
    // Arm the save-gate ONLY after a SUCCESSFUL load (or when there's genuinely
    // no GET path) — NEVER after a FAILED GET (e.g. the backend was restarting,
    // which is exactly how "humans positions failed to load" happens). Arming
    // on a failed attempt let the canvas persist its fallback/default coords
    // over the real, still-unloaded layout.
    if (el && (getSucceeded || !sdk?.getCanvasLayout)) el._tagLayoutHydrated = true;
    // A transient backend outage makes the GET fail; the wsId-gate in onUpdate
    // stays satisfied (we recorded _tagLayoutWsLoaded above), so without an
    // explicit retry the canvas would sit on fallback coords for the WHOLE
    // session — saved positions never load even after the server recovers.
    // Schedule a backoff retry so the layout self-heals (capped to avoid a
    // storm; reset on success). The in-flight guard at the top of this fn
    // serializes it against any onUpdate-driven pass.
    if (el && attempted && !getSucceeded) {
        el._tagLayoutRetries = (el._tagLayoutRetries || 0) + 1;
        if (el._tagLayoutRetries <= 6 && typeof window !== 'undefined') {
            const delay = Math.min(10000, Math.round(800 * Math.pow(1.7, el._tagLayoutRetries - 1)));
            clearTimeout(el._tagLayoutRetryTimer);
            el._tagLayoutRetryTimer = window.setTimeout(()=>{
                $83482a6ad78aef6f$var$_hydrateLayoutFromPrefs(root, el);
            }, delay);
        }
    } else if (getSucceeded) el._tagLayoutRetries = 0;
    // Snap already-mounted nodes to the freshly-resolved coordinates (see
    // _applyPositionsToDom — covers the mount-before-load ordering for
    // positions AND the default-grid reshuffle a group seed/merge causes).
    if (el) $83482a6ad78aef6f$var$_applyPositionsToDom(root, el);
    if (el) el._tagHydrateInFlight = false;
};
// Debounced workspace-layout patch. Drag ticks rapidly mutate
// _tagPositions; coalesce 600ms of writes into one PATCH so the
// canvas-layout endpoint sees O(1) calls per gesture instead of N.
const $83482a6ad78aef6f$var$_canvasSaveTimers = new WeakMap();
// Tracks the active document-level drag listeners keyed off root so the
// page's onRemove can unwind them when the user navigates away mid-drag.
// onUp clears its own entry on natural release; only the unmount path
// needs this WeakMap.
const $83482a6ad78aef6f$var$_activeDrag = new WeakMap();
const $83482a6ad78aef6f$var$_prefixPositions = (positions)=>{
    const out = {};
    if (!positions || typeof positions !== 'object') return out;
    for (const [k, v] of Object.entries(positions))if (v && typeof v === 'object' && typeof v.x === 'number' && typeof v.y === 'number') out[$83482a6ad78aef6f$var$_TA_PREFIX + k] = {
        x: v.x,
        y: v.y
    };
    return out;
};
const $83482a6ad78aef6f$var$_saveLayoutToPrefs = (el, root)=>{
    if (!root) return;
    clearTimeout($83482a6ad78aef6f$var$_canvasSaveTimers.get(root));
    $83482a6ad78aef6f$var$_canvasSaveTimers.set(root, setTimeout(async ()=>{
        const wsId = $83482a6ad78aef6f$var$_wsId(root);
        const sdk = (0, $1NxyO.getSDK)();
        // Per-user connection state still rides userPreferences. Empty
        // arrays write through so members can also REMOVE a base edge and
        // have the removal persist across reloads.
        const prefs = root.userPrefs || {};
        const layoutBag = {
            // positions: kept in legacy slot too — graceful fallback for
            // any client that hasn't shipped the canvas-layout migration
            // (older builds reading user prefs still see the positions).
            positions: root._tagPositions || {},
            connections: Array.isArray(root._tagConnections) ? root._tagConnections : [],
            connectionsRemoved: Array.isArray(root._tagConnectionsRemoved) ? root._tagConnectionsRemoved : []
        };
        root.update({
            userPrefs: {
                ...prefs,
                [$83482a6ad78aef6f$var$_PREFS_KEY]: layoutBag
            }
        });
        try {
            if (sdk?.execute) // PER-PATH PATCH — names only `team_and_agents_layout`.  `user_id`
            // is server-stamped and never client-sent: a PATCH REFUSES a
            // reserved key outright (reserved_pref_key), where the old whole-
            // row PUT silently stripped it (CORE-USERPREFS-PATCH-PER-PATH-1).
            await sdk.execute('workspaceProject.userPreferences', 'patch', {
                patch: {
                    set: {
                        [$83482a6ad78aef6f$var$_PREFS_KEY]: layoutBag
                    }
                }
            });
        } catch (err) {
            console.warn('[team-and-agents] user-prefs save failed:', err?.message || err);
        }
        // Workspace-shared positions + groups. Send only the namespaced
        // subset so /studios + /my-agents project/agent keys in the same
        // document aren't touched. expectedVersion guards concurrent
        // edits — 409 re-queues the next debounce write with the freshest
        // local map.
        if (sdk?.patchCanvasLayout && wsId) {
            const partial = {
                positions: $83482a6ad78aef6f$var$_prefixPositions(root._tagPositions || {}),
                groups: $83482a6ad78aef6f$var$_prefixGroups(root._tagGroupMap, root._tagGroupNames)
            };
            if (root.__tagLayoutVersion != null) partial.expectedVersion = root.__tagLayoutVersion;
            try {
                const result = await sdk.patchCanvasLayout(wsId, partial);
                if (result?.version != null) root.__tagLayoutVersion = result.version;
            } catch (err) {
                // 409 conflict → drop the stale version so the next debounce
                // doesn't include it; the live socket sub will pull in the
                // peer's writes between now and then.
                if (String(err?.message || '').includes('409')) root.__tagLayoutVersion = null;
                console.warn('[team-and-agents] patchCanvasLayout failed:', err?.message || err);
            }
        }
    }, 600));
};
// Subscribe to live canvas-layout broadcasts so a drag in one tab /
// member fans out to every other member's canvas without a refresh.
// Returns a Promise<unsubscribe>; the caller is responsible for
// awaiting + storing the resolved function so onRemove can release
// the socket cleanly.
//
// Why the Promise:
// `getSDK()` returns a Proxy that defers EVERY method to
// `initPromise.then(() => value.apply(target, args))` (see
// shared/functions/sdk.js wrapWithInitAwait). So the immediate return
// of `sdk.subscribeWorkspaceCanvasLayout(...)` is a Promise wrapping
// the actual unsub. Without awaiting we'd store a Promise as the
// unsub and onRemove's `if (typeof fn === 'function')` would skip
// teardown — the socket leaks for the lifetime of the tab, and a
// re-mount would open a second one.
const $83482a6ad78aef6f$var$_subscribeCanvasLayout = async (root, el)=>{
    const wsId = $83482a6ad78aef6f$var$_wsId(root);
    if (!wsId) return null;
    const sdk = (0, $1NxyO.getSDK)();
    if (!sdk?.subscribeWorkspaceCanvasLayout) return null;
    return sdk.subscribeWorkspaceCanvasLayout(wsId, (payload)=>{
        const next = {};
        if (payload?.positions) {
            const incomingPos = $83482a6ad78aef6f$var$_unprefixPositions(payload.positions);
            if (Object.keys(incomingPos).length) next._tagPositions = {
                ...root._tagPositions || {},
                ...incomingPos
            };
        }
        if (payload?.groups) {
            const incomingGroups = $83482a6ad78aef6f$var$_unprefixGroups(payload.groups);
            if (incomingGroups) {
                // Replace, don't merge — a member dragged OUT of a group on
                // another tab shouldn't come back via stale local map state.
                next._tagGroupMap = incomingGroups.map;
                next._tagGroupNames = incomingGroups.names;
            }
        }
        if (Object.keys(next).length) {
            root?.update?.(next);
            // Same mount-vs-update freeze guard as the hydrate path — snap
            // mounted nodes to the incoming coords imperatively.
            if (el) $83482a6ad78aef6f$var$_applyPositionsToDom(root, el);
        }
        if (payload?.version != null) root.__tagLayoutVersion = payload.version;
    });
};
// ─── Connection click-to-remove ─────────────────────────────────
//
// Default + user-added edges are merged in `_baseConnections` /
// `_allConnections`. Removing a default edge writes a negative entry
// into `root._tagConnectionsRemoved` so the merge keeps it out across
// reloads.
const $83482a6ad78aef6f$var$_connectionKey = (c)=>`${c?.from || ''}\u{2192}${c?.to || ''}`;
const $83482a6ad78aef6f$var$_isUserConnection = (root, c)=>{
    const user = Array.isArray(root?._tagConnections) ? root._tagConnections : [];
    return user.some((u)=>$83482a6ad78aef6f$var$_connectionKey(u) === $83482a6ad78aef6f$var$_connectionKey(c));
};
const $83482a6ad78aef6f$var$_removeConnection = (root, c)=>{
    if (!root || !c) return;
    const key = $83482a6ad78aef6f$var$_connectionKey(c);
    const user = Array.isArray(root._tagConnections) ? root._tagConnections : [];
    const removed = Array.isArray(root._tagConnectionsRemoved) ? root._tagConnectionsRemoved : [];
    // User-added edge → just drop from the user list.
    if (user.some((u)=>$83482a6ad78aef6f$var$_connectionKey(u) === key)) {
        root.update({
            _tagConnections: user.filter((u)=>$83482a6ad78aef6f$var$_connectionKey(u) !== key),
            _tagSelectedConnection: null
        });
        return;
    }
    // Default edge → record a removal entry so `_allConnections` filters
    // it out on every render.
    if (!removed.some((r)=>$83482a6ad78aef6f$var$_connectionKey(r) === key)) root.update({
        _tagConnectionsRemoved: [
            ...removed,
            {
                from: c.from,
                to: c.to
            }
        ],
        _tagSelectedConnection: null
    });
};
const $83482a6ad78aef6f$var$_onNodePointerdown = (e, el, s)=>{
    // Reset the drag-suppress flag at the START of every press so an
    // earlier drag doesn't permanently swallow clicks on subsequent
    // taps. Click handler will set it back to true via the moved-guard
    // below if the user actually drags.
    $83482a6ad78aef6f$var$_justDragged = false;
    // Drag — only kicks in when the user isn't in connect-mode. POINTER events
    // (not mouse), so a finger drags a node on iPad too. Panzoom's beforeMouseDown
    // gates the desktop mouse pan on `data-node-id`, and initPanzoomBoard's touch
    // guard pauses panzoom on a single-finger node touch, so the board never pans
    // while we drag a node with either input.
    if (s.root._tagConnectMode) return;
    const id = el.node?.dataset?.nodeId;
    if (!id) return;
    e.stopPropagation();
    // Pin the dragged node into the viewport window so a pan-driven (or the
    // release) recompute never unmounts it mid-drag. Released in onUp.
    $83482a6ad78aef6f$var$_pinnedIds.add(id);
    // Track the initiating pointer so a second finger landing mid-drag can't
    // hijack the move (mouse always reports pointerId 1).
    const pointerId = e.pointerId;
    const root = s.root;
    // Read view: _initialPositions is the COMPLETE map (default grid with
    // persisted coords overlaid) — never the sparse persisted map alone,
    // which misses ids that haven't been dragged yet (start = {0,0} bug).
    const positions = $83482a6ad78aef6f$var$_initialPositions(root);
    const start = positions[id] || {
        x: 0,
        y: 0
    };
    const startX = e.clientX;
    const startY = e.clientY;
    const scale = typeof window !== 'undefined' && window.__tagPzScale || 1;
    let moved = false;
    // People (not agents) can join team groups by dropping onto a frame.
    // Track which frame the cursor is currently over so the frame can
    // visually highlight (`root._tagHoverGroup`) and so onUp can mutate
    // the team membership on drop.
    const isAgent = $83482a6ad78aef6f$var$_canvasIsAgent(id, root);
    const nodeW = isAgent ? $83482a6ad78aef6f$var$AGENT_W : $83482a6ad78aef6f$var$PERSON_W;
    const nodeH = isAgent ? $83482a6ad78aef6f$var$AGENT_H : $83482a6ad78aef6f$var$PERSON_H;
    const onMove = (ev)=>{
        if (ev.pointerId !== pointerId) return;
        const dx = (ev.clientX - startX) / scale;
        const dy = (ev.clientY - startY) / scale;
        if (Math.abs(dx) + Math.abs(dy) > 3) moved = true;
        // Write ONLY the dragged node's coordinate into the persisted map.
        // The old `{ ...positions, [id]: … }` spread baked the ENTIRE
        // default grid into _tagPositions on the first drag of a session —
        // and because _saveLayoutToPrefs PATCHes every key it holds (the
        // server partial-merges per node id), one early drag (before the
        // async canvas-layout GET resolved) permanently overwrote every
        // member's SAVED position with the default grid slot. That is the
        // root cause of "humans render at default positions on first load":
        // the saved layout itself had been replaced by defaults. Un-dragged
        // nodes keep resolving through _posFor → _initialPositions, so
        // nothing visual changes — only what gets persisted does.
        const next = {
            ...root._tagPositions || {},
            [id]: {
                x: start.x + dx,
                y: start.y + dy
            }
        };
        root.update({
            _tagPositions: next
        });
        if (!isAgent) {
            const hover = $83482a6ad78aef6f$var$_hoveredGroup(el, root, id, nodeW, nodeH);
            if (hover !== root._tagHoverGroup) root.update({
                _tagHoverGroup: hover
            });
            // Node-over-node detection (studios collision = new group).
            // Only when no team-frame is hovered — frame join takes
            // precedence so users dragging INTO a team frame don't
            // accidentally form an ad-hoc group with the closest member.
            const hoverNode = hover ? null : $83482a6ad78aef6f$var$_hoveredNode(el, root, id, nodeW, nodeH);
            if (hoverNode !== root._tagHoverNode) root.update({
                _tagHoverNode: hoverNode
            });
        }
    };
    const entry = {};
    const onUp = (ev)=>{
        if (ev && ev.pointerId !== pointerId) return;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
        if ($83482a6ad78aef6f$var$_activeDrag.get(root) === entry) $83482a6ad78aef6f$var$_activeDrag.delete(root);
        // Drag settled — release the pin and re-window against the final camera +
        // positions (the dragged node may have moved out of / into the viewport).
        $83482a6ad78aef6f$var$_pinnedIds.delete(id);
        const pageEl = $83482a6ad78aef6f$var$_tagPageElOf(el);
        if (pageEl) $83482a6ad78aef6f$var$scheduleTeamWindowRecompute(pageEl, root);
        const hoverGroup = root._tagHoverGroup;
        const hoverNode = root._tagHoverNode;
        if (hoverGroup) root.update({
            _tagHoverGroup: null
        });
        if (hoverNode) root.update({
            _tagHoverNode: null
        });
        if (moved) {
            $83482a6ad78aef6f$var$_justDragged = true;
            $83482a6ad78aef6f$var$_saveLayoutToPrefs(el, root);
            if (!isAgent) {
                const fromGroupId = $83482a6ad78aef6f$var$_groupFor({
                    id: id,
                    email: $83482a6ad78aef6f$var$_canvasEmailOf(root, id)
                }, root);
                // Priority: drop on a frame → join that slot. Drop on another
                // free node → form (or extend) a slot. Drop in empty space
                // while currently in a slot → leave that slot. The studios
                // model is purely visual — slot membership lives in
                // `_tagGroupMap`. Team-membership SDK round-trips piggyback
                // off the slot transitions when the slot was seeded from a
                // team row (looked up via _teamForSlot / _teamForGroupId).
                const currentSlot = $83482a6ad78aef6f$var$_currentGroupOf(root, id);
                if (hoverGroup && currentSlot !== hoverGroup) {
                    const map = {
                        ...$83482a6ad78aef6f$var$_groupMap(root),
                        [id]: hoverGroup
                    };
                    root.update({
                        _tagGroupMap: map
                    });
                    // Team membership side-effect — only when both slots resolve
                    // back to teams the SDK knows about.
                    if (!isAgent) {
                        const toTeamId = $83482a6ad78aef6f$var$_teamForGroupId(root, currentSlot ? `team:${$83482a6ad78aef6f$var$_slotLabel(root, hoverGroup)}` : null);
                        if (toTeamId) $83482a6ad78aef6f$var$_joinTeamOnDrop(el, root, id, currentSlot, hoverGroup);
                    }
                } else if (hoverNode) $83482a6ad78aef6f$var$_formGroupOnDrop(root, id, hoverNode);
                else if (!hoverGroup && currentSlot) {
                    // Out of a team's frame → that team loses the member, after the
                    // house confirm (Cancel puts the card back). Any other slot is
                    // layout only and leaves at once.
                    const team = $83482a6ad78aef6f$var$_leavableTeam(root, id, currentSlot);
                    if (team) $83482a6ad78aef6f$var$_askLeaveTeamOnDrop(el, root, id, currentSlot, team, start);
                    else $83482a6ad78aef6f$var$_removeFromSlot(root, id);
                }
            }
        }
    };
    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
    document.addEventListener('pointercancel', onUp);
    entry.onMove = onMove;
    entry.onUp = onUp;
    $83482a6ad78aef6f$var$_activeDrag.set(root, entry);
};
// ─── Drag-to-assign (studios-style link handle) ───────────────
//
// Mirrors canvas/pages/studios.js `startLink`: press the small handle on
// a node's right edge, drag onto another node, release to add a
// { from, to } edge into root._tagConnections (the assignment graph that
// _allConnections renders + _saveLayoutToPrefs persists). This is the
// primary "assign items to each other" gesture now that the Suggest-team
// panel is gone — the same affordance /studios uses to wire projects to
// integrations.
// Center point (board coords) of the link-drag source node — feeds the
// LinkGhost path while a drag is in flight.
const $83482a6ad78aef6f$var$_linkGhostFrom = (root)=>{
    const lk = root?._tagLinking;
    if (!lk?.fromId) return {
        x: 0,
        y: 0
    };
    const positions = {
        ...root?._tagPositions || {},
        ...$83482a6ad78aef6f$var$_initialPositions(root) || {}
    };
    const p = positions[lk.fromId];
    if (!p) return {
        x: 0,
        y: 0
    };
    const sz = $83482a6ad78aef6f$var$_sizeOf(lk.fromId, root);
    return {
        x: p.x + sz.w / 2,
        y: p.y + sz.h / 2
    };
};
// Topmost node under the cursor (excluding the drag source).
// elementsFromPoint walks the z-stack so the pointerEvents:none ghost /
// dots layers don't mask the card beneath.
const $83482a6ad78aef6f$var$_nodeIdAtPoint = (clientX, clientY, fromId)=>{
    if (typeof document === 'undefined') return null;
    const stack = document.elementsFromPoint(clientX, clientY);
    for (const node of stack){
        const host = node.closest && node.closest('[data-node-id]');
        if (host && host.dataset.nodeId && host.dataset.nodeId !== fromId) return host.dataset.nodeId;
    }
    return null;
};
const $83482a6ad78aef6f$var$_startLink = (e, el, root, fromId)=>{
    if (e.button !== 0 || !fromId) return;
    // Pin the link source so a recompute can't unmount it while we drag a
    // connection from it. Released in onUp.
    $83482a6ad78aef6f$var$_pinnedIds.add(fromId);
    // Swallow the event so the node's own mousedown (position drag) and the
    // panzoom pan don't also fire.
    e.stopPropagation();
    e.preventDefault();
    // Resolve THIS board's rect + scale so the ghost tracks the cursor in
    // board coordinates. el.node.closest finds the correct Board even when
    // the home dashboard embeds a second canvas instance.
    const board = el.node && el.node.closest('[data-tag-board]');
    const toBoardPoint = (clientX, clientY)=>{
        if (!board) return {
            x: 0,
            y: 0
        };
        const r = board.getBoundingClientRect();
        const scale = typeof window !== 'undefined' && window.__tagPzScale || 1;
        return {
            x: (clientX - r.left) / scale,
            y: (clientY - r.top) / scale
        };
    };
    const seed = toBoardPoint(e.clientX, e.clientY);
    root.update({
        _tagLinking: {
            fromId: fromId,
            toId: null,
            x: seed.x,
            y: seed.y
        },
        _tagConnectFrom: fromId
    });
    const onMove = (ev)=>{
        const p = toBoardPoint(ev.clientX, ev.clientY);
        const toId = $83482a6ad78aef6f$var$_nodeIdAtPoint(ev.clientX, ev.clientY, fromId);
        root.update({
            _tagLinking: {
                fromId: fromId,
                toId: toId,
                x: p.x,
                y: p.y
            },
            _tagHoverNode: toId || null
        });
    };
    const onUp = (ev)=>{
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        // Release the link-source pin and re-window (a node may have entered /
        // left the viewport, and the source no longer needs to stay mounted).
        $83482a6ad78aef6f$var$_pinnedIds.delete(fromId);
        const pageEl = $83482a6ad78aef6f$var$_tagPageElOf(el);
        if (pageEl) $83482a6ad78aef6f$var$scheduleTeamWindowRecompute(pageEl, root);
        const toId = $83482a6ad78aef6f$var$_nodeIdAtPoint(ev.clientX, ev.clientY, fromId);
        if (toId && toId !== fromId) {
            const key = $83482a6ad78aef6f$var$_connectionKey({
                from: fromId,
                to: toId
            });
            const revKey = $83482a6ad78aef6f$var$_connectionKey({
                from: toId,
                to: fromId
            });
            const already = $83482a6ad78aef6f$var$_allConnections(root).some((c)=>{
                const k = $83482a6ad78aef6f$var$_connectionKey(c);
                return k === key || k === revKey;
            });
            if (!already) {
                // Agent⇄person pair → a real, server-backed assignment. Resolve
                // the agent's User _id (from the roster) + the person's User _id
                // (from root.people). When both resolve, write the assignment
                // through the SDK; the edge then renders from _assignmentConnections.
                const fromIsAgent = $83482a6ad78aef6f$var$_canvasIsAgent(fromId, root);
                const toIsAgent = $83482a6ad78aef6f$var$_canvasIsAgent(toId, root);
                const agentNode = fromIsAgent ? fromId : toIsAgent ? toId : null;
                const personNode = fromIsAgent ? toIsAgent ? null : toId : toIsAgent ? fromId : null;
                const agent = agentNode && $83482a6ad78aef6f$var$_agents(root).find((a)=>a.id === agentNode);
                const person = personNode && $83482a6ad78aef6f$var$_personById(root, personNode);
                const agentUserId = agent && agent.userId;
                const assigneeUserId = person && person.userId;
                if (agentNode && personNode && agentUserId && assigneeUserId) {
                    const orgId = root?.jwtClaims?.workspace_org_id || root?.jwtClaims?.orgs && root.jwtClaims.orgs[0]?.id || null;
                    const who = person.name || (person.email || '').split('@')[0] || el.call('polyglot', 'canvas.team.toast.memberFallback');
                    el.call('assignAgentToUser', root, {
                        orgId: orgId,
                        agentUserId: agentUserId,
                        assigneeUserId: assigneeUserId
                    }).then(()=>root.update({
                            _tagToast: {
                                kind: 'ok',
                                text: el.call('polyglot', 'canvas.team.toast.assigned').replace('{agent}', agent.name || agentNode).replace('{person}', who)
                            }
                        })).catch((err)=>root.update({
                            _tagToast: {
                                kind: 'error',
                                text: err && err.message || 'canvas.team.toast.assignFailed'
                            }
                        }));
                    root.update({
                        _tagLinking: null,
                        _tagConnectFrom: null,
                        _tagHoverNode: null
                    });
                    return;
                }
                // Fallback: local visual edge (agent⇄agent, person⇄person, or an
                // endpoint with no Mongo user id to assign server-side).
                const user = Array.isArray(root._tagConnections) ? root._tagConnections : [];
                const removed = Array.isArray(root._tagConnectionsRemoved) ? root._tagConnectionsRemoved : [];
                // Drop any prior removal of this pair so the freshly-drawn edge sticks.
                const nextRemoved = removed.filter((r)=>{
                    const k = $83482a6ad78aef6f$var$_connectionKey(r);
                    return k !== key && k !== revKey;
                });
                root.update({
                    _tagConnections: [
                        ...user,
                        {
                            from: fromId,
                            to: toId
                        }
                    ],
                    _tagConnectionsRemoved: nextRemoved
                });
                $83482a6ad78aef6f$var$_saveLayoutToPrefs(el, root);
            }
        }
        root.update({
            _tagLinking: null,
            _tagConnectFrom: null,
            _tagHoverNode: null
        });
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
};
// Shared link handle added to every node (person + agent). Hidden until
// the card is hovered — the reveal rule lives on each node
// (':hover > [data-tag-linkhandle]'). Factory (not a shared object) so the
// two nodes don't collide on one DOMQL element reference.
const $83482a6ad78aef6f$var$_linkHandle = ()=>({
        attr: {
            'data-tag-linkhandle': ''
        },
        position: 'absolute',
        right: '-9px',
        top: '50%',
        marginTop: '-9px',
        width: '18px',
        height: '18px',
        round: '50%',
        background: 'white',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: 'document',
        cursor: 'crosshair',
        opacity: '0',
        transform: 'scale(0.6)',
        transition: 'A opacity defaultBezier, A transform defaultBezier',
        zIndex: '4',
        title: (el)=>el.call('polyglot', 'canvas.team.linkHandle.title'),
        ':hover': {
            transform: 'scale(1.3)'
        },
        // Node drag starts on pointerdown (_onNodePointerdown); stop it bubbling to
        // the node so pressing the link handle draws a connection (mouse-only)
        // instead of ALSO starting a node-reposition drag. Without this guard the
        // two drags race — the card follows the cursor and the link never lands
        // (the studios link handle ships the same guard; see studios.js LinkHandle).
        onPointerdown: (e)=>e.stopPropagation(),
        onMousedown: (e, el, s)=>$83482a6ad78aef6f$var$_startLink(e, el, s.root, el.parent?.node?.dataset?.nodeId),
        // A click on the handle shouldn't open the node's detail modal.
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        }
    });
// ─── Fit-to-visible (the /my-agents zoom-in + home embed) ─────
//
// The canvas's node positions are the SHARED full-org-map coordinates and
// the camera only ever seeds the top-left origin. Two surfaces need that
// framed instead of left at the origin:
//   • /my-agents (non-admin) — the viewer's filtered subset keeps its
//     full-map coords, so the handful of nodes land scattered, usually
//     fully off-screen (the "blank /my-agents" a team member saw).
//   • the home AgentsWidget embed — the full roster rendered into the
//     small widget showed only the top-left cards; the rest overflowed.
// `_fitMode` decides which (the dedicated /team-and-agents route opts out,
// keeping its free pan). We frame the relevant node set: its bbox via the
// shared `bboxOfNodeIds` helper, then a pan/zoom that centres it. The
// MIN_SCALE floor means the wide+short home widget lands on a readable,
// centred band of the roster (pan for the rest) rather than a postage-stamp
// fit-everything. Driven by the bounded poll in onCreate (the reactive
// onUpdate does NOT reliably tick for this page element); one-shot per mount
// (`el.__tagFitted`) so a later drag doesn't yank the camera away.
const $83482a6ad78aef6f$var$_FIT_PAD = 140 // scene-px breathing room around the set
;
const $83482a6ad78aef6f$var$_FIT_MAX_SCALE = 1 // never zoom past 100% (e.g. a lone self-node)
;
const $83482a6ad78aef6f$var$_FIT_MIN_SCALE = 0.25 // floor: keep cards readable; pan for the rest
;
// Which surface (if any) wants an auto-fit, and over which node set:
//   'subset' — /my-agents non-admin → the viewer's filtered nodes
//   'all'    — the home embed (canvas mounted off its dedicated routes)
//   null     — /team-and-agents (+ admin /my-agents): free pan, no fit
const $83482a6ad78aef6f$var$_fitMode = (root)=>{
    if (!root) return null;
    // /agents — fit the camera to the (filtered) agent set.
    if (root._canvasAgentsOnly) return 'subset';
    if (root._canvasScope === 'mine') return $83482a6ad78aef6f$var$_viewerTier(root) === 'admin' ? null : 'subset';
    const path = root.currentPath || root.route || '';
    if (path !== '/team-and-agents' && path !== '/my-agents') return 'all';
    return null;
};
// The node ids to frame. `_visiblePeople` / `_visibleAgents` already return
// the filtered subset under `_canvasScope === 'mine'` and the full roster
// otherwise, so this is the right set for BOTH the subset and 'all' modes.
const $83482a6ad78aef6f$var$_fitNodeIds = (root)=>{
    const ids = new Set();
    const people = $83482a6ad78aef6f$var$_visiblePeople(root);
    for(let i = 0; i < people.length; i++)ids.add($83482a6ad78aef6f$var$_personId(people[i], i));
    for (const a of $83482a6ad78aef6f$var$_visibleAgents(root))ids.add(a.id);
    return ids;
};
const $83482a6ad78aef6f$var$_fitToVisible = (root, el)=>{
    if (!root || el.__tagFitted) return;
    if (!$83482a6ad78aef6f$var$_fitMode(root)) return;
    const ids = $83482a6ad78aef6f$var$_fitNodeIds(root);
    if (!ids || !ids.size) return;
    const scene = el.AppMain?.Body?.Stage?.Board?.node;
    const stage = el.AppMain?.Body?.Stage?.node;
    // el.__tagPzInstance is the live instance initPanzoomBoard returned.
    // NB: window.__canvasGlobalScope.panzoomInstance can be a STALE instance
    // left by a prior canvas page (its transform doesn't drive this Board),
    // so never reach for it here. Not mounted yet → bail; the poll retries.
    const pz = el.__tagPzInstance || scene?.__tagPanzoomAttached;
    if (!pz || !scene || !stage) return;
    const positions = {
        ...$83482a6ad78aef6f$var$_initialPositions(root) || {},
        ...root._tagPositions || {}
    };
    const bbox = el.call('bboxOfNodeIds', {
        ids: [
            ...ids
        ],
        positions: positions,
        sizeOf: $83482a6ad78aef6f$var$_sizeOfBound(root)
    });
    if (!bbox || !bbox.w || !bbox.h) return;
    const vw = stage.clientWidth || stage.getBoundingClientRect().width;
    const vh = stage.clientHeight || stage.getBoundingClientRect().height;
    if (!vw || !vh) return;
    const scale = Math.max($83482a6ad78aef6f$var$_FIT_MIN_SCALE, Math.min($83482a6ad78aef6f$var$_FIT_MAX_SCALE, vw / (bbox.w + $83482a6ad78aef6f$var$_FIT_PAD * 2), vh / (bbox.h + $83482a6ad78aef6f$var$_FIT_PAD * 2)));
    // panzoom maps scene→screen as `scene * scale + translate`; solve the
    // translate that lands the bbox centre on the viewport centre. Same
    // zoomAbs(0,0) + moveTo pairing initPanzoomBoard uses to seed the view.
    const cx = bbox.x + bbox.w / 2;
    const cy = bbox.y + bbox.h / 2;
    try {
        pz.zoomAbs(0, 0, scale);
        pz.moveTo(vw / 2 - cx * scale, vh / 2 - cy * scale);
        // Force the transform to the DOM — the home embed's panzoom doesn't fire
        // the `transform` event that normally flushes it, so moveTo alone updates
        // the instance but leaves the board pinned at the seed (see
        // initPanzoomBoard). Redundant-but-harmless on the routes.
        if (typeof pz.applyBoardTransform === 'function') pz.applyBoardTransform();
    } catch (_) {
        return;
    }
    el.__tagFitted = true;
    // Window to the freshly-fitted camera. On the home embed the panzoom
    // `transform` event never fires, so this (and the applyBoardTransform →
    // onTransform bridge in initPanzoomBoard) are the reliable recompute
    // triggers there.
    $83482a6ad78aef6f$var$scheduleTeamWindowRecompute(el, root);
};
const $83482a6ad78aef6f$var$_scheduleTeamPanzoomBoot = (el)=>{
    if (typeof window === 'undefined' || el.__tagBooted || el.__tagPzRaf) return;
    const attempts = el.__tagPzAttempts = (el.__tagPzAttempts || 0) + 1;
    if (attempts > 120) {
        console.warn('[team-and-agents] panzoom boot gave up waiting for Board');
        return;
    }
    el.__tagPzRaf = requestAnimationFrame(()=>{
        el.__tagPzRaf = null;
        $83482a6ad78aef6f$var$_bootTeamPanzoom(el);
    });
};
const $83482a6ad78aef6f$var$_bootTeamPanzoom = (el)=>{
    if (el.__tagBooted || typeof window === 'undefined') return;
    const scene = el.AppMain?.Body?.Stage?.Board?.node;
    const dots = el.AppMain?.Body?.Stage?.Dots?.node;
    if (!scene || !dots) {
        $83482a6ad78aef6f$var$_scheduleTeamPanzoomBoot(el);
        return;
    }
    el.__tagBooted = true;
    // Reuse the shared panzoom boot helper via the function registry
    // (NOT a direct import — same reuse model the rest of the canvas
    // pages follow). Cancel token lets onRemove halt the RAF retry
    // chain if the page unmounts before the scene mounts. The returned
    // pz instance is captured for dispose-on-unmount.
    el.__tagPzCancel = {
        canceled: false
    };
    el.__tagPzInstance = el.call('initPanzoomBoard', {
        getScene: ()=>scene,
        getDots: ()=>dots,
        initial: {
            x: 40,
            y: 40,
            scale: 1
        },
        attachKey: '__tagPanzoomAttached',
        cancelToken: el.__tagPzCancel,
        onTransform: (t)=>{
            if (typeof window === 'undefined') return;
            window.__tagPzScale = t.scale;
            // Mirror into the shared canvas globalScope so the shell Zoombar
            // can read/drive this canvas — same pattern as /tickets (#32).
            const gs = window.__canvasGlobalScope = window.__canvasGlobalScope || {};
            gs.positions = gs.positions || {
                x: 0,
                y: 0
            };
            gs.positions.x = t.x;
            gs.positions.y = t.y;
            gs.scale = t.scale;
            // Viewport windowing: the camera moved → recompute which nodes intersect
            // it. rAF-coalesced + set-diff-gated inside, so a fast pan costs at most
            // one root.update per membership change and none when it's unchanged.
            const winRoot = $83482a6ad78aef6f$var$_tagRootOf(el);
            if (winRoot) $83482a6ad78aef6f$var$scheduleTeamWindowRecompute(el, winRoot);
        }
    });
    if (!el.__tagPzInstance) {
        el.__tagBooted = false;
        $83482a6ad78aef6f$var$_scheduleTeamPanzoomBoot(el);
        return;
    }
    el.__tagPzAttempts = 0;
    const gs = window.__canvasGlobalScope = window.__canvasGlobalScope || {};
    gs.panzoomInstance = el.__tagPzInstance;
    gs.positions = gs.positions || {
        x: 0,
        y: 0
    };
    // Seed the initial viewport window now the camera exists — hands the
    // first-paint seed set off to the reactive _tagVisibleIds without waiting
    // for the user's first pan.
    const bootRoot = $83482a6ad78aef6f$var$_tagRootOf(el);
    if (bootRoot) $83482a6ad78aef6f$var$scheduleTeamWindowRecompute(el, bootRoot);
};
// ─── /agents filter toolbar helpers ───────────────────────────
// The toolbar is inline in the Stage (not a registered component) to dodge the
// canvas childExtends-bridge requirement; these module helpers back it.
// `label` on every option below is a bundle KEY, resolved through polyglot at
// each render site — a `{{ … }}` template cannot be used because the value is
// also returned from a `text:` FUNCTION (`_agentOptLabel`), where a template
// string would render its own braces.
const $83482a6ad78aef6f$var$_AGENT_STATUS_OPTS = [
    {
        key: 'all',
        label: 'canvas.team.filter.statusAll'
    },
    {
        key: 'active',
        label: 'canvas.team.filter.statusActive'
    },
    {
        key: 'idle',
        label: 'canvas.team.filter.statusIdle'
    }
];
const $83482a6ad78aef6f$var$_AGENT_ASSIGN_OPTS = [
    {
        key: 'all',
        label: 'canvas.team.filter.assignAll'
    },
    {
        key: 'assigned',
        label: 'canvas.team.filter.assignAssigned'
    },
    {
        key: 'unassigned',
        label: 'canvas.team.filter.assignUnassigned'
    }
];
// Type options are derived from the kinds actually present in the roster.
const $83482a6ad78aef6f$var$_agentTypeOpts = (root)=>{
    const kinds = [
        ...new Set($83482a6ad78aef6f$var$_agents(root).map((a)=>a.kind).filter(Boolean))
    ].sort();
    return [
        {
            key: 'all',
            label: 'canvas.team.filter.typeAll'
        },
        // Derived from roster `kind` slugs — data, not copy. polyglot returns a
        // non-key verbatim, so these pass straight through.
        ...kinds.map((k)=>({
                key: k,
                label: k.charAt(0).toUpperCase() + k.slice(1)
            }))
    ];
};
const $83482a6ad78aef6f$var$_agentOptLabel = (opts, key)=>(opts.find((o)=>o.key === (key || 'all')) || opts[0]).label;
// The option list a filter row names by its scope key ('status' / 'type' /
// 'assign'): a top-level helper, the path `_agentOptLabel` takes through frank.
const $83482a6ad78aef6f$var$_agentFilterOpts = (key, root)=>key === 'type' ? $83482a6ad78aef6f$var$_agentTypeOpts(root) : key === 'assign' ? $83482a6ad78aef6f$var$_AGENT_ASSIGN_OPTS : $83482a6ad78aef6f$var$_AGENT_STATUS_OPTS;
// A full-width sidebar filter row ("<Title> … <value> ⌄") — opens a MenuPanel
// of options that write `stateKey` on root. The value label is a reactive text
// factory (content props update on state change; only paint/layout freeze).
const $83482a6ad78aef6f$var$_agentsFilterRow = (title, stateKey, optsKey)=>({
        // The factory args ride on `scope`: frank serializes each handler on its
        // own, without this closure, so a bare `stateKey` read published as a read
        // off the shared globalScope. The option list rides as a KEY, never a
        // closure: a scope-bag function with free names cannot cross the transport,
        // so on a pushed canvas the rows lost their options (canvas case 4,
        // 2026-11-01). `_agentFilterOpts` resolves the key at each read.
        scope: {
            title: title,
            stateKey: stateKey,
            optsKey: optsKey
        },
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center space-between',
        gap: 'V',
        width: '100%',
        padding: 'Z A',
        round: 'radiusPill',
        borderWidth: '0',
        background: 'transparent',
        color: 'subtitle',
        cursor: 'pointer',
        fontSize: 'Z2',
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        Title: {
            tag: 'span',
            color: 'caption',
            text: title
        },
        Val: {
            flow: 'x',
            align: 'center center',
            gap: 'V',
            Current: {
                tag: 'span',
                color: 'title',
                fontWeight: '700',
                text: (el, s)=>el.call('polyglot', $83482a6ad78aef6f$var$_agentOptLabel($83482a6ad78aef6f$var$_agentFilterOpts(el.scope.optsKey, s.root), s.root?.[el.scope.stateKey]))
            },
            Caret: {
                extends: 'Icon',
                name: 'arrowAngleDown',
                boxSize: 'Y2',
                color: 'caption'
            }
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const root = s.root;
            const opts = $83482a6ad78aef6f$var$_agentFilterOpts(el.scope.optsKey, root);
            const body = {
                extends: 'MenuPanel',
                aria: {
                    label: el.scope.title
                }
            };
            opts.forEach((o, i)=>{
                body['Opt_' + i] = {
                    extends: 'MenuPanelItem',
                    text: (el2)=>el2.call('polyglot', o.label),
                    isActive: (el2, s2)=>(s2.root?.[el.scope.stateKey] || 'all') === o.key,
                    onClick: (ev, it)=>{
                        it.call('closeDropdown', 'agentsFilter');
                        root?.update({
                            [el.scope.stateKey]: o.key
                        });
                    }
                };
            });
            el.call('openDropdown', {
                id: 'agentsFilter',
                anchorEl: el,
                placement: 'bottom-start',
                content: body
            });
        }
    });
// The /agents filter card — lives in the left CanvasViewRail (below the VIEWS
// nav), shown only on /agents. subscribeTo the filter keys so this page-root
// subtree re-renders its active states + value labels on change (page-root
// children otherwise freeze); the Stage AgentNodes re-render via _visibleAgents
// independently. Replaces the old floating AgentsFilterBar.
const $83482a6ad78aef6f$var$_agentsFilterCard = ()=>({
        hide: (el, s)=>!s.root?._canvasAgentsOnly,
        subscribeTo: [
            '_canvasAgentsOnly',
            '_agentsScope',
            '_agentsStatus',
            '_agentsType',
            '_agentsAssign'
        ],
        // Its OWN glass card below the VIEWS card (2026-06-19 per Nika "split the
        // /agents sidebar into 2 different cards") — the rail's sidebar card
        // (CanvasViewRail childExtends AppSidebarCard, Nika 2026-10-30 "A: navbar
        // glass"), so it carries no surface of its own; in the phone sheet it sits
        // on the sheet unboxed, as the VIEWS group above it does.
        flexShrink: '0',
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'span',
            text: '{{ canvas.team.rail.agents | polyglot }}',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            padding: 'Y A'
        },
        // All agents / My agents — full-width rows, active = frosted wash (VIEWS idiom).
        Scope: {
            flow: 'y',
            gap: 'V',
            childrenAs: 'state',
            children: ()=>[
                    {
                        key: 'all',
                        label: 'canvas.team.scope.all'
                    },
                    {
                        key: 'mine',
                        label: 'canvas.team.scope.mine'
                    }
                ],
            childExtends: {
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center left',
                width: '100%',
                padding: 'Z A',
                round: 'radiusPill',
                borderWidth: '0',
                background: 'transparent',
                color: 'subtitle',
                cursor: 'pointer',
                fontSize: 'Z2',
                fontWeight: '700',
                isActive: (el, s)=>(s.root?._agentsScope || 'all') === s.key,
                // Same white-wash bug as the /files switcher: theme-invariant, so the
                // ACTIVE tab had no visible background on the light shell. (:hover below
                // already had its @light counterpart — the active state was missed.)
                '.isActive': {
                    background: 'selected',
                    color: 'title'
                },
                ':hover': {
                    background: 'hover',
                    color: 'title'
                },
                // `label` carries a bundle KEY (see the `Scope.children` list above).
                text: (el, s)=>el.call('polyglot', s.label),
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root?.update({
                        _agentsScope: s.key
                    });
                }
            }
        },
        // Status / Type / Assignment — dropdown rows.
        Filters: {
            flow: 'y',
            gap: 'V',
            marginTop: 'V',
            StatusRow: $83482a6ad78aef6f$var$_agentsFilterRow((el)=>el.call('polyglot', 'canvas.team.filter.titleStatus'), '_agentsStatus', 'status'),
            TypeRow: $83482a6ad78aef6f$var$_agentsFilterRow((el)=>el.call('polyglot', 'canvas.team.filter.titleType'), '_agentsType', 'type'),
            AssignRow: $83482a6ad78aef6f$var$_agentsFilterRow((el)=>el.call('polyglot', 'canvas.team.filter.titleAssignment'), '_agentsAssign', 'assign')
        }
    });
const $83482a6ad78aef6f$export$1017e348726566fa = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    // Fill the shell grid's content row (2026-06-08). The shell grid is
    // `<header-row> <1fr-content-row>`; on this canvas surface the header
    // floats (position:absolute), so its grid row collapses to ~6px. With
    // no explicit placement the <main> AUTO-PLACED into that collapsed
    // ~6px row 1 instead of the 1fr content row 2 — the whole canvas
    // (viewport → plane → nodes) was then clipped to 6px tall and the page
    // rendered blank even though every node was in the DOM at the right
    // position. The shell grid is a single `1fr` row now (AppHeader is an
    // absolute overlay, 2026-06-09), so `gridRow: '1'` lands the page in that
    // content track and #main-content fills the viewport; the legacy
    // `gridRow: '2'` stranded it in an implicit 0-height row 2 (canvas
    // invisible). Inert in the home AgentsWidget embed — that mounts
    // CanvasEmbed in a flex widget body (not a grid), where its own
    // height:100%/flex govern.
    gridRow: '1',
    gridColumn: '1 / -1',
    minHeight: '0',
    metadata: (el)=>({
            title: el.call('pageTitle', 'canvas.page.teamAndAgents.title')
        }),
    // Persistent left rail — the shared Frontend/Infra/Tasks/Agents view switcher
    // (this is the Agents view). 2026-06-18 per Nika "add this sidebar to
    // /team-and-agents page".
    // The board shows no title, so this is its one `h1`: announced, never seen
    // (workspace design-direction.md §3). /agents and /my-agents extend this page
    // and name themselves by overriding the text.
    PageSrTitle: {
        text: '{{ canvas.page.teamAndAgents.title | polyglot }}'
    },
    CanvasViewRail: {
        '@mobileL': {
            display: 'none'
        },
        AgentsFilterCard: $83482a6ad78aef6f$var$_agentsFilterCard()
    },
    CanvasControlsSheet: {
        Card: {
            Content: {
                AgentsFilterCard: $83482a6ad78aef6f$var$_agentsFilterCard()
            }
        }
    },
    // Init panzoom on the Board via the shared helper
    // (canvas/functions/initPanzoomBoard.js). The helper handles:
    //   - panzoom + beforeMouseDown gate on [data-node-id]
    //   - wheel pan + ⌘/Ctrl pinch zoom
    //   - dots layer position + size on every transform
    //   - --canvas-scale CSS var on the scene
    //   - idempotent attach
    // What stays here: drag-position scale lookup (window.__tagPzScale)
    // and the initial offset that matches the page's coordinate system.
    onCreate: (el, s)=>{
        // `s` may be undefined when teamAndAgents is embedded into another
        // surface (the home's AgentsWidget uses `extends: 'teamAndAgents'`)
        // — DOMQL doesn't always thread the state argument through the
        // extend chain. Same fallback shape as onRemove below; bail
        // silently if root is unreachable rather than throwing.
        const state = s || el?.state || (typeof el?.getRoot === 'function' ? el.getRoot().state : null);
        const root = state?.root;
        if (!root) return;
        // The lens a page that extends this one names on its scope (/agents:
        // 'agents', /my-agents: 'mine'), applied HERE, before the boot below reads
        // it (`_fitMode`, the agents-only node set). Those pages carry no hook of
        // their own and never read this page OBJECT: a function that read it made
        // frank copy the whole page into globalScope (canvas case 3, 2026-11-01).
        const lens = el.scope?.canvasLens;
        if (lens === 'agents') {
            root._canvasAgentsOnly = true;
            if (root._agentsScope == null) root._agentsScope = 'all';
            if (root._agentsStatus == null) root._agentsStatus = 'all';
            if (root._agentsType == null) root._agentsType = 'all';
            if (root._agentsAssign == null) root._agentsAssign = 'all';
        } else if (lens === 'mine') root._canvasScope = 'mine';
        // Hydrate persisted layout: workspace-shared positions from
        // sdk.canvasLayout, per-user connection state from user prefs.
        // The call is async but we don't await — the canvas renders with
        // default positions immediately and snaps to the server's map as
        // soon as the GET resolves. userPrefs may be `null` on cold mount;
        // the onUpdate hook below re-runs once loadPrivateData fills it.
        $83482a6ad78aef6f$var$_hydrateLayoutFromPrefs(root, el);
        if (!el._tagHydrateAttempted) el._tagHydrateAttempted = true;
        // Live workspace-canvas-layout subscription — a drag on another
        // tab or by another member fans the new positions through this
        // socket and merges them into _tagPositions. Stash the unsubscribe
        // on `el` so onRemove tears the socket down.
        if (!el.__tagLayoutUnsub) {
            // Mark eagerly so a re-entrant onCreate (smbls fires the hook
            // multiple times during teardown chains) doesn't open a second
            // socket while the first one's promise is still resolving.
            el.__tagLayoutUnsub = true;
            $83482a6ad78aef6f$var$_subscribeCanvasLayout(root, el).then((unsub)=>{
                if (typeof unsub === 'function') el.__tagLayoutUnsub = unsub;
                else el.__tagLayoutUnsub = null;
            });
        }
        // §unified-perms PR #10 — fetch the Mongo-backed agent roster
        // once per session. _loadAgents is idempotent (root._agentsLoaded
        // guard); failure silently falls back to SEED_AGENTS, so the
        // canvas always renders. The active interface language names the
        // server-seeded defaults (agentDisplayName).
        $83482a6ad78aef6f$var$_loadAgents(root, el.call('getActiveLang'));
        // Load server-backed agent↔person assignments once per session
        // (feature-detected — a no-op until the assignment API is live).
        if (!root._agentAssignmentsLoaded) {
            root._agentAssignmentsLoaded = true;
            try {
                el.call('loadAllAgentAssignments', root);
            } catch (_) {
            /* fn not in scope */ }
        }
        // `root.onlineUsers` (canonical array) and `root.presenceById` (per-id
        // reactive map) are both populated by the shell-level useOnlinePresence
        // subscription in app.js — no per-page subscription needed here. Person
        // nodes' OnlineDot/IdleDot read `presenceById[email]` (via _personStatus),
        // so a presence tick repaints only the changed node's dot, not the board.
        //
        // Lightweight agent-presence poll: first hit now, then every 30s
        // while the page is mounted. Cleaned up by onRemove. Keeps the
        // pulse indicator live without needing /tickets to be the
        // canonical loader.
        if (!el._tagPresencePollStarted) {
            el._tagPresencePollStarted = true;
            $83482a6ad78aef6f$var$_fetchTagAgentPresence(root);
            el._tagPresencePoll = setInterval(()=>$83482a6ad78aef6f$var$_fetchTagAgentPresence(root), $83482a6ad78aef6f$var$_TAG_PRESENCE_POLL_MS);
        }
        // Re-snap nodes to their SAVED coords as they mount AND as positions
        // hydrate. People load async AFTER this onCreate's first hydrate, and the
        // reactive style.left/top freezes at the mount-time default grid (v3.14
        // reactive-layout freeze) while this page's onUpdate doesn't reliably tick
        // — so without this, humans render on the default grid and never move to
        // their saved positions ("cards don't populate to correct positions on
        // initial render"; lines drawn between them then point at empty space).
        // The existing fit-poll only runs for _fitMode (my-agents/embed), NOT
        // /team-and-agents — so this page had nothing re-applying. Bounded poll on
        // the (node-count + position-count + layout-version) signature; re-applies
        // imperatively on any change, settles ~1.2s after it stops growing (or a
        // 20s ceiling). Cleared in onRemove.
        if (!el.__tagSnapPoll) {
            let snapSig = '';
            let snapStable = 0;
            let snapTicks = 0;
            el.__tagSnapPoll = setInterval(()=>{
                snapTicks++;
                const board = el?.AppMain?.Body?.Stage?.Board?.node;
                const n = board ? board.querySelectorAll('[data-node-id]').length : 0;
                const sig = n + '|' + Object.keys(root._tagPositions || {}).length + '|' + (root.__tagLayoutVersion == null ? '' : root.__tagLayoutVersion);
                if (sig !== snapSig) {
                    snapSig = sig;
                    snapStable = 0;
                    $83482a6ad78aef6f$var$_applyPositionsToDom(root, el);
                } else snapStable++;
                // Don't settle until the layout GET has actually resolved
                // (`_tagLayoutHydrated`). On SPA nav from home the people are ALREADY
                // loaded, so the node count stabilises in ~1.2s — BEFORE the fresh
                // getCanvasLayout GET returns. Without this gate the poll cleared on
                // that early stability and the saved positions (arriving moments later)
                // never re-applied, leaving humans on the default grid (the "wrong
                // positions on navbar nav" bug). On a hard refresh everything loads
                // slowly together, so the count kept changing and the poll naturally
                // stayed alive — which is why hard refresh worked but SPA nav didn't.
                // The snapTicks ceiling still bounds the poll if the GET never lands.
                if (n > 0 && snapStable >= 6 && el._tagLayoutHydrated || snapTicks >= 100) {
                    clearInterval(el.__tagSnapPoll);
                    el.__tagSnapPoll = null;
                    $83482a6ad78aef6f$var$_applyPositionsToDom(root, el);
                }
            }, 200);
        }
        //
        // Inject the `@keyframes ttag-pulse` rule once per document so
        // TeamAgentNode.PulseDot can pulse. Cheap (idempotent guard via
        // element id) and avoids needing a design-system keyframe entry.
        if (typeof document !== 'undefined' && !document.getElementById('ttag-pulse-css')) {
            const style = document.createElement('style');
            style.id = 'ttag-pulse-css';
            style.textContent = '@keyframes ttag-pulse{0%{box-shadow:0 0 0 0 rgba(80,200,120,0.7),0 0 0 2px var(--color-card);}70%{box-shadow:0 0 0 10px rgba(80,200,120,0),0 0 0 2px var(--color-card);}100%{box-shadow:0 0 0 0 rgba(80,200,120,0),0 0 0 2px var(--color-card);}}';
            document.head.appendChild(style);
        }
        // /my-agents + the home embed: poll until the node set has loaded and
        // settled, then frame it (see _fitToVisible / _fitMode). Driven by a
        // bounded poll rather than the reactive onUpdate so the camera move
        // doesn't depend on a state tick landing after data + panzoom are ready.
        // No-op on /team-and-agents (and admin /my-agents).
        if ($83482a6ad78aef6f$var$_fitMode(root) && !el.__tagFitPoll) {
            let lastSig = null;
            el.__tagFitPoll = setInterval(()=>{
                if (el.__tagFitted || (el.__tagFitPollN = (el.__tagFitPollN || 0) + 1) > 60) {
                    clearInterval(el.__tagFitPoll);
                    el.__tagFitPoll = null;
                    return;
                }
                const ids = $83482a6ad78aef6f$var$_fitNodeIds(root);
                const sig = ids && ids.size ? [
                    ...ids
                ].sort().join(',') : '';
                // Fit once the set is non-empty AND unchanged since the previous
                // tick — the staged loads (people, then assigned agents) have
                // stopped growing it.
                if (sig && sig === lastSig) $83482a6ad78aef6f$var$_fitToVisible(root, el);
                lastSig = sig;
            }, 180);
        }
        $83482a6ad78aef6f$var$_bootTeamPanzoom(el);
    },
    onUpdate: (el, s)=>{
        $83482a6ad78aef6f$var$_bootTeamPanzoom(el);
        // Same defensive derivation as onCreate / onRemove — `s` is
        // undefined along the embedded-page teardown / update paths.
        const state = s || el?.state || (typeof el?.getRoot === 'function' ? el.getRoot().state : null);
        const root = state?.root;
        if (!root) return;
        // Re-hydrate once user prefs lands (cold mount path). Skipped while
        // another hydrate pass is in flight (it would be swallowed by the
        // in-flight guard and the flag would block the retry) — a later
        // onUpdate tick picks it up.
        if (!el._tagPrefsHydrated && !el._tagHydrateInFlight && root?.userPrefs && Object.keys(root.userPrefs).length > 0) {
            el._tagPrefsHydrated = true;
            $83482a6ad78aef6f$var$_hydrateLayoutFromPrefs(root, el);
        }
        // Re-hydrate when the workspace id becomes resolvable (or changes).
        // The onCreate hydrate can run before jwtClaims/workspace land —
        // wsId is null then and the canvas-layout GET is skipped entirely,
        // leaving the canvas on the default grid with no other trigger to
        // load the saved layout. _tagLayoutWsLoaded records which wsId the
        // last pass actually attempted; the in-flight guard inside
        // _hydrateLayoutFromPrefs serializes overlapping kicks.
        const wsIdNow = $83482a6ad78aef6f$var$_wsId(root);
        if (wsIdNow && el._tagLayoutWsLoaded !== wsIdNow) $83482a6ad78aef6f$var$_hydrateLayoutFromPrefs(root, el);
        // Save when the user-mutated keys change. Diff-gated so we don't
        // PATCH on every reactive cycle. The debounce inside
        // _saveLayoutToPrefs absorbs rapid sequential updates.
        const posSig = root?._tagPositions;
        const conSig = root?._tagConnections;
        const remSig = root?._tagConnectionsRemoved;
        const grpSig = root?._tagGroupMap;
        const namSig = root?._tagGroupNames;
        if (el._tagLastSavedPos !== posSig || el._tagLastSavedCon !== conSig || el._tagLastSavedRem !== remSig || el._tagLastSavedGrp !== grpSig || el._tagLastSavedNam !== namSig) {
            // Arm ONLY off the canvas-layout hydration flag — set when a
            // hydrate pass that could actually reach the server completed
            // (_hydrateLayoutFromPrefs sets it after the awaited GET). The
            // old gate also armed off `_tagPrefsHydrated`, which onUpdate
            // sets SYNCHRONOUSLY before its async hydrate pass resolves —
            // so saves could fire while the saved layout was still in
            // flight, persisting pre-load state over it (the first-load
            // default-positions race).
            if (el._tagLayoutHydrated) {
                if (el._tagSaveArmed) $83482a6ad78aef6f$var$_saveLayoutToPrefs(el, root);
                el._tagSaveArmed = true;
            }
            el._tagLastSavedPos = posSig;
            el._tagLastSavedCon = conSig;
            el._tagLastSavedRem = remSig;
            el._tagLastSavedGrp = grpSig;
            el._tagLastSavedNam = namSig;
        }
        // ── Viewport windowing re-triggers ────────────────────────────
        // Recompute the visible set when the roster changed (late-arriving nodes
        // should appear in-viewport without a manual pan) or when node positions
        // changed from a NON-drag source (layout hydrate, live collab move). Both
        // signature-gated; the position trigger is SKIPPED while a local drag is
        // in flight — the dragged node is pinned and onUp recomputes on release,
        // so per-pointermove _tagPositions writes never rebuild the window (the
        // reconcile storm this windowing exists to avoid).
        const winRosterSig = ($83482a6ad78aef6f$var$_visiblePeople(root)?.length || 0) + ':' + ($83482a6ad78aef6f$var$_visibleAgents(root)?.length || 0);
        const winPosId = root?._tagPositions;
        const winDragging = !!$83482a6ad78aef6f$var$_activeDrag.get(root);
        let winNeed = false;
        if (el.__tagWinRosterSig !== winRosterSig) {
            el.__tagWinRosterSig = winRosterSig;
            winNeed = true;
        }
        if (!winDragging && el.__tagWinPosId !== winPosId) {
            el.__tagWinPosId = winPosId;
            winNeed = true;
        }
        if (winNeed) $83482a6ad78aef6f$var$scheduleTeamWindowRecompute(el, root);
    },
    onRender: (el, s)=>{
        $83482a6ad78aef6f$var$_bootTeamPanzoom(el);
        // The empty-area right-click menu used to be a RAW
        // `node.addEventListener('contextmenu', …)` armed here behind a
        // `__tagCtxBound` node flag, removed nowhere (FA503). It is DECLARED as
        // `onContextmenu` on this page root now, so DOMQL registers it with the
        // node and tears it down in dispose().
        //
        // The comment that justified the raw call — "DOMQL doesn't delegate
        // onContextmenu" — was STALE: `contextmenu` is a member of smbls's
        // DELEGATED_EVENTS set (element/src/registry.js). See
        // `__tests__/globalListenerLifecycle.test.js` for the receipt.
        //
        // The long-press shim still arms here: it is a one-shot synthesiser, not
        // a listener this page owns, and it needs the node to exist.
        //
        // iPad: synthesize the missing long-press contextmenu at the stage root;
        // it bubbles from the touched tile, so one arm covers every person/agent
        // node (tagNodeContextmenu) + the empty-canvas menu below. Panzoom is
        // unaffected — pointer travel past the shim's tolerance cancels the press.
        //
        // NO latch of our own — see the same call in pages/studios.js: the shim is
        // idempotent per NODE, and an element-level flag outlives a node swap.
        el.call('armLongPress');
    },
    // Empty-area right-click → the shared cascade context menu ("New ▸" → the
    // create flyout). Mirrors the /studio background menu.
    onContextmenu: (ev, el, s)=>{
        if (ev.target.closest?.('input, textarea, [data-smbls-dropdown="panel"], [data-key="ModalRoot"]')) return;
        // Empty canvas only — not a node tile, the sidebar, the + island, or a control.
        if (ev.target.closest?.('[data-node-id], button, a, [data-key="AppSidebar"], [data-key="TagCreateNav"]')) return;
        ev.preventDefault();
        el.call('openDropdown', {
            id: 'tagContext',
            anchorRect: {
                left: ev.clientX,
                top: ev.clientY,
                right: ev.clientX,
                bottom: ev.clientY,
                width: 0,
                height: 0
            },
            placement: 'bottom-start',
            content: (0, $bQFOG.cascadeMenu)([
                {
                    label: (el)=>el.call('polyglot', 'canvas.boardMenu.new.label'),
                    icon: 'plus',
                    ariaLabel: (el)=>el.call('polyglot', 'canvas.team.create.aria'),
                    submenuBody: $83482a6ad78aef6f$var$tagCreateRows(s.root)
                }
            ])
        });
    },
    // Tear down everything the page leaked onto root, document, window,
    // and the scene node so back-and-forth nav doesn't drag "old stuff"
    // into the next mount of either this page or studios. Mirrors the
    // five leak surfaces flagged in the code review (#13):
    //   1. pending save debounce (_canvasSaveTimers WeakMap)
    //   2. in-flight panzoom RAF retry (cancelToken)
    //   3. panzoom instance event listeners (pz.dispose)
    //   4. mid-drag document mousemove/mouseup (_activeDrag WeakMap)
    //   5. page-scoped root state (hover/connect/selection)
    onRemove: (el, s)=>{
        // `s` is undefined when this page's onRemove fires during a teardown
        // triggered by an EMBEDDING surface (the home's AgentsWidget embeds
        // teamAndAgents via `extends`, and DOMQL's dispose walker enters this
        // hook with `(el, undefined)` along that path). Falling back to
        // `el.state` / `el.getRoot()` keeps cleanup working both when the
        // user navigates AWAY from `/team-and-agents` (s passed normally) and
        // when the page is being detached as a child of another element
        // (s undefined). Without this, every navigation off the home that
        // tears down the embedded canvas logs a smbls onRemove TypeError and
        // skips the rest of cleanup — leaving panzoom listeners, drag
        // handlers, and root state slots leaked into the next mount.
        const state = s || el?.state || (typeof el?.getRoot === 'function' ? el.getRoot().state : null);
        const root = state?.root;
        if (root) {
            clearTimeout($83482a6ad78aef6f$var$_canvasSaveTimers.get(root));
            $83482a6ad78aef6f$var$_canvasSaveTimers.delete(root);
        }
        if (el._tagPresencePoll) {
            clearInterval(el._tagPresencePoll);
            el._tagPresencePoll = null;
            el._tagPresencePollStarted = false;
        }
        // Stop the fit poll so it can't fire against a disposed panzoom after
        // unmount; reset the one-shot so a re-mount re-frames.
        if (el.__tagFitPoll) {
            clearInterval(el.__tagFitPoll);
            el.__tagFitPoll = null;
        }
        el.__tagFitted = false;
        el.__tagFitPollN = 0;
        // Stop the position re-snap poll on unmount.
        if (el.__tagSnapPoll) {
            clearInterval(el.__tagSnapPoll);
            el.__tagSnapPoll = null;
        }
        // Stop + reset viewport-windowing state so a re-mount recomputes cleanly.
        if (el.__tagVizRaf) {
            cancelAnimationFrame(el.__tagVizRaf);
            el.__tagVizRaf = null;
        }
        el.__tagLastVisibleKey = null;
        el.__tagLastVisibleSet = null;
        el.__tagPosSnapshot = null;
        el.__tagWinRosterSig = null;
        el.__tagWinPosId = null;
        $83482a6ad78aef6f$var$_pinnedIds.clear();
        if (el.__tagPzRaf) {
            cancelAnimationFrame(el.__tagPzRaf);
            el.__tagPzRaf = null;
        }
        // Release the workspace-canvas-layout socket — leaks otherwise on
        // every back-and-forth between this page and another.
        if (typeof el.__tagLayoutUnsub === 'function') {
            try {
                el.__tagLayoutUnsub();
            } catch (_) {}
            el.__tagLayoutUnsub = null;
        }
        if (el.__tagPzCancel) el.__tagPzCancel.canceled = true;
        const scene = el.AppMain?.Body?.Stage?.Board?.node;
        const pz = el.__tagPzInstance || scene?.__tagPanzoomAttached;
        if (pz && typeof pz.dispose === 'function') try {
            pz.dispose();
        } catch (_) {
        /* idempotent */ }
        if (scene && scene.__tagPanzoomAttached) delete scene.__tagPanzoomAttached;
        el.__tagPzInstance = null;
        // Release the shared Zoombar mirror so it doesn't point at a disposed pz.
        if (typeof window !== 'undefined' && window.__canvasGlobalScope && window.__canvasGlobalScope.panzoomInstance === pz) window.__canvasGlobalScope.panzoomInstance = null;
        if (root) {
            const drag = $83482a6ad78aef6f$var$_activeDrag.get(root);
            if (drag) {
                if (drag.onMove) document.removeEventListener('pointermove', drag.onMove);
                if (drag.onUp) {
                    document.removeEventListener('pointerup', drag.onUp);
                    document.removeEventListener('pointercancel', drag.onUp);
                }
                $83482a6ad78aef6f$var$_activeDrag.delete(root);
            }
            if (root._tagHoverGroup || root._tagHoverNode || root._tagSelectedConnection || root._tagConnectMode || root._tagConnectFrom || root._tagLinking || root._tagVisibleIds) root.update({
                _tagHoverGroup: null,
                _tagHoverNode: null,
                _tagSelectedConnection: null,
                _tagConnectMode: false,
                _tagConnectFrom: null,
                _tagLinking: null,
                // Clear the window set so a re-mount's first paint takes the fresh
                // seed path rather than filtering against a stale set.
                _tagVisibleIds: null
            });
            // Drop the lens a page that extends this one named (see onCreate), so
            // /team-and-agents and the home embed, which share this root, show the
            // full set again.
            const lens = el.scope?.canvasLens;
            if (lens === 'agents') root._canvasAgentsOnly = null;
            else if (lens === 'mine') root._canvasScope = null;
        }
        if (typeof window !== 'undefined') window.__tagPzScale = 1;
    },
    // Sidebar removed — the canvas fills the whole content area. The
    // help text moves into a floating HelpBox anchored bottom-right of
    // the canvas (see AppMain.Body.Canvas.HelpBox below).
    AppSidebar: null,
    AppMain: {
        flex: '1 1 0',
        flow: 'y',
        minHeight: '0',
        // Page-level zero padding — the canvas + sidebar already occupy
        // the whole content area, no AppMain padding needed around them.
        padding: '0',
        // Full-bleed square canvas — AppMain extends CommonCard (ships margin +
        // round); reset both like tickets/files/infra so the board isn't clipped
        // into rounded corners. (2026-06-19 per Nika "remove canvas border radius".)
        margin: '0',
        round: '0',
        Body: {
            flex: '1 1 0',
            flow: 'y',
            padding: '0',
            overflow: 'hidden',
            // Viewport: panzoom mounts on the inner Board; this is the
            // overflow-hidden clipper that contains the transformed scene.
            Stage: {
                position: 'relative',
                flex: '1 1 0',
                width: '100%',
                height: '100%',
                minHeight: '70vh',
                overflow: 'hidden',
                // Canvas surface matches /tickets (+ the home dashboard): `gray5`
                // (rgb(69,69,75)) — the `--canvas-surface-bg` @dark chain resolved to
                // near-black, diverging from /tickets. The Zoombar's `--canvas-bg` pick
                // still overrides when set. (2026-06-17 per Nika "same background on
                // canvas as /tickets" — extended to /team-and-agents.)
                style: {
                    background: 'var(--canvas-bg, var(--stage-bg, var(--color-stage)))'
                },
                cursor: (el, s)=>s.root?._tagConnectMode ? 'crosshair' : 'default',
                // Floating "+" create-island — the shared CanvasCreateIsland (the
                // /studio StudioNavbar chrome) with the page's two actions. The
                // menu opens through the dropdown plugin (placement, outside-click,
                // ESC) — the old state-toggled CreateMenu + TagCreateBackdrop are
                // gone. Viewport-anchored (in Stage, not the Board) so it stays put
                // while the canvas pans/zooms.
                TagCreateNav: {
                    // The one solid-ink create FAB (DATE-FMT-1-REMAINDERS-1) — same
                    // look as /studio, the project canvas and the tickets board.
                    extends: 'CanvasPrimaryCreateIsland',
                    AddBtn: {
                        title: (el)=>el.call('polyglot', 'canvas.team.create.addTitle'),
                        aria: {
                            label: (el)=>el.call('polyglot', 'canvas.team.create.aria')
                        },
                        // Content is built HERE (the opener) with `root` captured, the
                        // same pattern as /tickets — the dropdown portal doesn't inherit
                        // page state (cf. dropdown-panel-content-reactivity), and the
                        // island-prop indirection didn't resolve for inline (non-
                        // registered) islands.
                        onClick: (e, el, s)=>{
                            e.stopPropagation();
                            el.call('openDropdown', {
                                id: 'tagCreate',
                                anchorEl: el,
                                placement: 'left-start',
                                content: {
                                    extends: 'CanvasCreateMenuBody',
                                    aria: {
                                        label: (el)=>el.call('polyglot', 'canvas.team.create.menuAria')
                                    },
                                    ...$83482a6ad78aef6f$var$tagCreateRows(s.root)
                                }
                            });
                        }
                    }
                },
                // (The /agents filters moved from a floating Stage bar into a card in
                // the left CanvasViewRail — see _agentsFilterCard / CanvasViewRail.)
                // Floating help pill — bottom-right corner of the canvas. The
                // chrome (card surface, hairline border, radius, padding, the
                // dismiss ×) is the shared CanvasMessage; this consumer supplies
                // only the content: the shared `Lottie` (the same swipe-right
                // animation `DragParagraph` uses inside the studio insert panel,
                // shared/components/DragParagraph.js) plus the three help lines
                // that used to live in the sidebar. `dismissKey` wires the ×: a
                // click sets `_tagHelpDismissed` on root, persisted across SPA nav
                // back to this page. CanvasMessage already defaults to the
                // bottom-right corner, so no positioning override is needed.
                HelpBox: {
                    // CanvasHelpCard = the glassy, lifted help-card chrome (was the flat
                    // CanvasMessage). This consumer supplies only the content below —
                    // the swipe Lottie now ships with the base card.
                    extends: 'CanvasHelpCard',
                    dismissKey: '_tagHelpDismissed',
                    Line1: {
                        tag: 'span',
                        text: '{{ canvas.team.help.drag | polyglot }}'
                    },
                    Line2: {
                        tag: 'span',
                        text: (el)=>el.call('panZoomHint')
                    },
                    Line3: {
                        tag: 'span',
                        text: '{{ canvas.team.help.click | polyglot }}'
                    }
                },
                // (Suggest-team panel removed — node-to-node assignment is now a
                // studios-style drag from each card's link handle; see _startLink
                // + the LinkHandle child on TeamPersonNode / TeamAgentNode.)
                // Toast — transient feedback for assign / unassign (+ errors).
                // Viewport-anchored: lives in Stage, not the transformed Board.
                Toast: {
                    hide: (el, s)=>!s.root?._tagToast,
                    position: 'absolute',
                    left: '50%',
                    bottom: 'B',
                    transform: 'translateX(-50%)',
                    zIndex: '6',
                    padding: 'V A',
                    round: 'C',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'white',
                    borderWidth: 'hairline',
                    borderStyle: 'solid',
                    borderColor: 'line',
                    shadow: 'overlay',
                    background: (el, s)=>s.root?._tagToast?.kind === 'error' ? 'red' : 'rgba(38, 40, 47, 0.96)',
                    // Key-in-state: the carrier holds a bundle KEY (or an already-composed
                    // sentence / raw SDK message, which polyglot returns verbatim on a miss).
                    text: (el, s)=>s.root?._tagToast?.text ? el.call('polyglot', s.root._tagToast.text) : '',
                    // Auto-dismiss ~3.2s after the toast last changed.
                    onUpdate: (el, s)=>{
                        const t = s.root?._tagToast;
                        if (!t || el.__toastFor === t) return;
                        el.__toastFor = t;
                        if (el.__toastTimer) clearTimeout(el.__toastTimer);
                        el.__toastTimer = setTimeout(()=>s.root?.update?.({
                                _tagToast: null
                            }), 3200);
                    }
                },
                // Dots layer — shared CanvasDots grid, re-positioned on every
                // panzoom transform tick (initPanzoomBoard's updateDots).
                Dots: {
                    extends: 'CanvasDots'
                },
                // Board is the transformed scene panzoom owns. Inner Connections
                // SVG + nodes ride this transform.
                Board: {
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '6000px',
                    height: '4000px',
                    transformOrigin: '0 0',
                    // Marker so _startLink resolves THIS board's rect + scale via
                    // el.node.closest — works for the dedicated page AND the home
                    // embed, which each mount their own Board.
                    attr: {
                        'data-tag-board': ''
                    },
                    // Live "ghost" line shown while dragging a connection from a
                    // node's link handle (_startLink writes root._tagLinking). One
                    // dashed segment from the source node's center to the cursor,
                    // in board coordinates. pointerEvents:none so it never eats the
                    // drop hit-test.
                    LinkGhost: {
                        tag: 'svg',
                        position: 'absolute',
                        inset: '0',
                        width: '6000px',
                        height: '4000px',
                        overflow: 'visible',
                        zIndex: '1',
                        style: {
                            pointerEvents: 'none'
                        },
                        attr: {
                            viewBox: '0 0 6000 4000',
                            preserveAspectRatio: 'none'
                        },
                        hide: (el, s)=>!s.root?._tagLinking,
                        GhostLine: {
                            tag: 'path',
                            attr: {
                                d: (el, s)=>{
                                    const f = $83482a6ad78aef6f$var$_linkGhostFrom(s.root);
                                    const lk = s.root?._tagLinking;
                                    const x2 = lk?.x ?? f.x;
                                    const y2 = lk?.y ?? f.y;
                                    return `M ${f.x} ${f.y} L ${x2} ${y2}`;
                                },
                                fill: 'none',
                                stroke: 'rgba(140, 170, 255, 0.95)',
                                'stroke-width': '2',
                                'stroke-dasharray': '6 5',
                                'stroke-linecap': 'round'
                            }
                        }
                    },
                    // Connections SVG — covers the same coordinate space as the
                    // Board, sits underneath the cards. `overflow: visible` matches
                    // studios.js (buildConnectionsSVG ~line 1724): SVG elements
                    // default to overflow:hidden in CSS, which clips any bezier
                    // arc whose control points fall outside the viewBox bounds.
                    // Connections layer — uses the shared `CanvasConnection`
                    // component (canvas/components/CanvasConnection.js) for the
                    // per-edge HitArea + Visible <g>. Page-specific styling +
                    // event handlers are passed as state via `getPath` /
                    // `getStroke` / etc. callbacks so the renderer stays
                    // page-agnostic.
                    Connections: {
                        tag: 'svg',
                        position: 'absolute',
                        inset: '0',
                        width: '6000px',
                        height: '4000px',
                        overflow: 'visible',
                        style: {
                            pointerEvents: 'none'
                        },
                        attr: {
                            viewBox: '0 0 6000 4000',
                            preserveAspectRatio: 'none'
                        },
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const root = s.root;
                            const conns = $83482a6ad78aef6f$var$_allConnections(root);
                            // Inject the per-page callbacks each shared
                            // CanvasConnection child consumes from its state.
                            return conns.map((c)=>({
                                    ...c,
                                    getPath: (root, from, to, e)=>$83482a6ad78aef6f$var$_linePath(root, from, to, e),
                                    getStroke: (root, st)=>{
                                        // Live: an edge to/from an agent currently running a delegated
                                        // task glows blue — lighting the Simone→agent→Temo flow as it
                                        // runs (reads root.activeProcesses via _isAgentWorking).
                                        if ($83482a6ad78aef6f$var$_isAgentWorking(root, st.to) || $83482a6ad78aef6f$var$_isAgentWorking(root, st.from)) return 'rgba(120, 150, 255, 0.95)';
                                        const key = $83482a6ad78aef6f$var$_connectionKey({
                                            from: st.from,
                                            to: st.to
                                        });
                                        if (root?._tagSelectedConnection && $83482a6ad78aef6f$var$_connectionKey(root._tagSelectedConnection) === key) return 'rgba(255,120,120,0.95)';
                                        if (root?._tagHoverConnection === key) return 'rgba(255,255,255,0.95)';
                                        if (st.from === root?._tagConnectFrom || st.to === root?._tagConnectFrom) return 'rgba(180,120,216,0.85)';
                                        return 'rgba(255,255,255,0.5)';
                                    },
                                    getStrokeWidth: (root, st)=>{
                                        if ($83482a6ad78aef6f$var$_isAgentWorking(root, st.to) || $83482a6ad78aef6f$var$_isAgentWorking(root, st.from)) return 2.5;
                                        const key = $83482a6ad78aef6f$var$_connectionKey({
                                            from: st.from,
                                            to: st.to
                                        });
                                        if (root?._tagSelectedConnection && $83482a6ad78aef6f$var$_connectionKey(root._tagSelectedConnection) === key) return 2.5;
                                        const sharedCount = Array.isArray(st.shared) ? st.shared.length : 0;
                                        if (sharedCount >= 3) return 2.5;
                                        if (sharedCount === 2) return 2.0;
                                        if (sharedCount === 1) return 1.5;
                                        return 1.5;
                                    },
                                    onSelect: (e, el, st)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (st.root?._tagConnectMode) return;
                                        // Studios-style direct removal — a click on a
                                        // connection drops it immediately, no intermediate
                                        // EditBar. Mirrors /studios' click-to-remove pattern
                                        // (canvas/pages/studios.js:6841 — `path.closest
                                        // [data-connection-id]` handler that filters the
                                        // edge out of root.connections + persists). Three
                                        // edge classes are handled here:
                                        //   1. Server-backed assignment edge → SDK unassign.
                                        //   2. User-added edge → drop from _tagConnections.
                                        //   3. Base/co-membership edge → record removal in
                                        //      _tagConnectionsRemoved so re-renders keep it
                                        //      hidden across reloads.
                                        // (Relationship picker that previously lived in the
                                        // ConnectionEditBar moved to the agent profile modal
                                        // — track via the agent's _selectedAgent flow.)
                                        const c = {
                                            from: st.from,
                                            to: st.to,
                                            assignment: st.assignment,
                                            assignmentId: st.assignmentId,
                                            agentUserId: st.agentUserId,
                                            assigneeUserId: st.assigneeUserId,
                                            relationship: st.relationship || null
                                        };
                                        if (c.assignment && c.assignmentId) {
                                            // A server-backed assignment: the same gate as the agent
                                            // editor's Remove, and the house confirm first (CRUD +
                                            // confirm standard rule 4) — the unassign runs only on
                                            // the verb.
                                            const root = st.root;
                                            if (!$83482a6ad78aef6f$var$_canManageAgents(root)) return;
                                            const orgId = root?.jwtClaims?.workspace_org_id || root?.jwtClaims?.orgs && root.jwtClaims.orgs[0]?.id || null;
                                            const agent = $83482a6ad78aef6f$var$_agents(root).find((a)=>a.id === c.from);
                                            el.call('confirmAgentUnassign', {
                                                agent: agent && agent.name || c.from,
                                                person: $83482a6ad78aef6f$var$_personNameByUserId(root, c.assigneeUserId) || el.call('polyglot', 'canvas.team.assignee.fallback'),
                                                onConfirm: ()=>Promise.resolve(el.call('unassignAgentFromUser', root, {
                                                        orgId: orgId,
                                                        assignmentId: c.assignmentId,
                                                        agentUserId: c.agentUserId,
                                                        assigneeUserId: c.assigneeUserId
                                                    })).then(()=>root?.update?.({
                                                            _tagToast: {
                                                                kind: 'ok',
                                                                text: 'canvas.team.toast.assignmentRemoved'
                                                            }
                                                        })).catch((err)=>root?.update?.({
                                                            _tagToast: {
                                                                kind: 'error',
                                                                text: err && err.message || 'canvas.team.toast.removeFailed'
                                                            }
                                                        }))
                                            });
                                            return;
                                        }
                                        $83482a6ad78aef6f$var$_removeConnection(st.root, c);
                                    },
                                    onHover: (e, el, st, entering)=>{
                                        const key = $83482a6ad78aef6f$var$_connectionKey({
                                            from: st.from,
                                            to: st.to
                                        });
                                        if (entering) st.root?.update?.({
                                            _tagHoverConnection: key
                                        });
                                        else if (st.root?._tagHoverConnection === key) st.root?.update?.({
                                            _tagHoverConnection: null
                                        });
                                    }
                                }));
                        },
                        // Bare-key — DOMQL auto-extends the shared component
                        // registered by canvas/components/CanvasConnection.js.
                        childExtends: 'CanvasConnection'
                    },
                    // ConnectionEditBar removed 2026-06-04 — clicks on the
                    // connection lines now fire removal directly (studios-style,
                    // see CanvasConnection.onSelect above). The relationship
                    // picker that lived here moved into the AgentModal's
                    // assignment row so it's accessible from the agent's full
                    // detail surface instead of an ephemeral floating toolbar.
                    // Studios-style group frames — one absolute-positioned rect
                    // per `groupN` slot (matches /studios `GroupFrame_<ws>`
                    // children). Pre-allocates frames for all 50 slots; only
                    // slots with ≥2 members render visible (`display:block`).
                    // Sits BEHIND the nodes (zIndex 1; nodes are zIndex 2) so the
                    // person/agent cards stack on top of the frame chrome.
                    //
                    // Drag the frame body → moves every member (delegates to the
                    // node mousedown of the first member, same trick studios uses
                    // — onMousedown finds the first slot member and pretends the
                    // drag started on its node).
                    // Double-click the label → editable; blur/Enter commits the
                    // new name via the canvas-layout groups field so every member
                    // sees it.
                    GroupFrames: {
                        position: 'absolute',
                        inset: '0',
                        pointerEvents: 'none',
                        zIndex: '1',
                        childrenAs: 'state',
                        children: ()=>(0, $6ocCI.GROUP_SLOTS).map((slot)=>({
                                    id: slot
                                })),
                        childExtends: {
                            attr: {
                                'data-group-id': (el, s)=>s.id
                            },
                            position: 'absolute',
                            pointerEvents: 'auto',
                            cursor: 'grab',
                            display: (el, s)=>{
                                const bb = $83482a6ad78aef6f$var$_groupBbox(s.root, s.id, el);
                                return bb && $83482a6ad78aef6f$var$_membersOfGroup(s.root, s.id).length >= $83482a6ad78aef6f$var$MIN_GROUP_MEMBERS ? 'block' : 'none';
                            },
                            style: {
                                left: (el, s)=>{
                                    const bb = $83482a6ad78aef6f$var$_groupBbox(s.root, s.id, el);
                                    return bb ? bb.x - $83482a6ad78aef6f$var$GROUP_PAD + 'px' : '-9999px';
                                },
                                top: (el, s)=>{
                                    const bb = $83482a6ad78aef6f$var$_groupBbox(s.root, s.id, el);
                                    return bb ? bb.y - $83482a6ad78aef6f$var$GROUP_PAD - $83482a6ad78aef6f$var$PLATFORM_HEAD_H + 'px' : '-9999px';
                                },
                                width: (el, s)=>{
                                    const bb = $83482a6ad78aef6f$var$_groupBbox(s.root, s.id, el);
                                    return bb ? bb.w + $83482a6ad78aef6f$var$GROUP_PAD * 2 + 'px' : '0px';
                                },
                                height: (el, s)=>{
                                    const bb = $83482a6ad78aef6f$var$_groupBbox(s.root, s.id, el);
                                    return bb ? bb.h + $83482a6ad78aef6f$var$GROUP_PAD * 2 + $83482a6ad78aef6f$var$PLATFORM_HEAD_H + 'px' : '0px';
                                }
                            },
                            round: 'radiusControl',
                            borderWidth: (el, s)=>s.root?._tagHoverGroup === s.id ? '2px' : '1px',
                            borderStyle: 'solid',
                            borderColor: (el, s)=>s.root?._tagHoverGroup === s.id ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255,0.15)',
                            background: (el, s)=>s.root?._tagHoverGroup === s.id ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.03)',
                            transition: 'A background defaultBezier, A border defaultBezier',
                            // Group label — sits above the frame's top edge.
                            // Double-click to rename; blur or Enter commits.
                            Label: {
                                tag: 'span',
                                position: 'absolute',
                                top: '-28px',
                                left: '4px',
                                padding: 'V Z',
                                round: 'radiusPill',
                                fontSize: 'Y2',
                                fontWeight: '700',
                                letterSpacing: '.08em',
                                textTransform: 'uppercase',
                                color: 'caption',
                                cursor: 'text',
                                pointerEvents: 'auto',
                                title: (el)=>el.call('polyglot', 'canvas.team.group.renameTitle'),
                                style: {
                                    outline: 'none'
                                },
                                ':focus-visible': {
                                    shadow: 'none'
                                },
                                // Group-label hover wash. Was a fixed white alpha on the FLIPPING stage
                                // (milk light / gray5 dark), so it painted white-on-milk — invisible — in
                                // light. `hover` is the §4.3 wash pair (black.05 light / white.07 dark).
                                ':hover': {
                                    background: 'hover'
                                },
                                text: (el, s)=>{
                                    if (el._editing) return el.node?.textContent ?? $83482a6ad78aef6f$var$_slotLabel(s.root, s.id);
                                    return $83482a6ad78aef6f$var$_slotLabel(s.root, s.id);
                                },
                                onMousedown: (e)=>e.stopPropagation(),
                                onClick: (e)=>e.stopPropagation(),
                                onDblclick: (e, el)=>{
                                    e.stopPropagation();
                                    e.preventDefault();
                                    el._editing = true;
                                    if (!el.node) return;
                                    el.node.contentEditable = 'true';
                                    el.node.focus();
                                    const doc = el.context?.document || document;
                                    const win = el.context?.window || window;
                                    const range = doc.createRange();
                                    range.selectNodeContents(el.node);
                                    const sel = win.getSelection();
                                    sel.removeAllRanges();
                                    sel.addRange(range);
                                },
                                onBlur: (e, el, s)=>{
                                    if (!el._editing) return;
                                    el._editing = false;
                                    if (!el.node) return;
                                    el.node.contentEditable = 'false';
                                    const name = (el.node.textContent || '').trim();
                                    const slot = s.id;
                                    const next = {
                                        ...s.root?._tagGroupNames || {}
                                    };
                                    if (name) next[slot] = name;
                                    else delete next[slot];
                                    s.root?.update?.({
                                        _tagGroupNames: next
                                    });
                                },
                                onKeydown: (e, el)=>{
                                    if (e.key === 'Enter' || e.key === 'Escape') {
                                        e.preventDefault();
                                        el.node?.blur();
                                    }
                                }
                            }
                        }
                    },
                    // The platform agents' frame (WL-7; Nika 2026-10-25 "Own agents,
                    // platform ones labeled"): the seed agents with no row in this org
                    // sit in their own block under a fixed "Platform" label, after the
                    // workspace's own agents. Display chrome only — it follows the
                    // cards (bbox of their positions) and takes no pointer, so drags
                    // and clicks reach the cards and the board as before.
                    PlatformFrame: {
                        dataPlatformFrame: true,
                        position: 'absolute',
                        pointerEvents: 'none',
                        zIndex: '1',
                        display: (el, s)=>$83482a6ad78aef6f$var$_platformBbox(s.root, el) ? 'block' : 'none',
                        left: (el, s)=>{
                            const bb = $83482a6ad78aef6f$var$_platformBbox(s.root, el);
                            return bb ? bb.x - $83482a6ad78aef6f$var$GROUP_PAD + 'px' : '-9999px';
                        },
                        top: (el, s)=>{
                            const bb = $83482a6ad78aef6f$var$_platformBbox(s.root, el);
                            return bb ? bb.y - $83482a6ad78aef6f$var$GROUP_PAD - $83482a6ad78aef6f$var$PLATFORM_HEAD_H + 'px' : '-9999px';
                        },
                        width: (el, s)=>{
                            const bb = $83482a6ad78aef6f$var$_platformBbox(s.root, el);
                            return bb ? bb.w + $83482a6ad78aef6f$var$GROUP_PAD * 2 + 'px' : '0px';
                        },
                        height: (el, s)=>{
                            const bb = $83482a6ad78aef6f$var$_platformBbox(s.root, el);
                            return bb ? bb.h + $83482a6ad78aef6f$var$GROUP_PAD * 2 + $83482a6ad78aef6f$var$PLATFORM_HEAD_H + 'px' : '0px';
                        },
                        round: 'radiusControl',
                        borderWidth: '1px',
                        borderStyle: 'dashed',
                        borderColor: 'line',
                        // The label and, under it, what these agents are: Symbols' own,
                        // in every workspace (persona round 3, W5) — one line, cut with
                        // an ellipsis where the block is narrower than the words.
                        PlatformHead: {
                            position: 'absolute',
                            top: 'Z',
                            left: 'Z',
                            right: 'Z',
                            flow: 'y',
                            gap: 'X',
                            minWidth: '0',
                            Label: {
                                tag: 'span',
                                fontSize: 'Y2',
                                fontWeight: '700',
                                letterSpacing: '.08em',
                                textTransform: 'uppercase',
                                color: 'caption',
                                text: '{{ canvas.tileFrame.platform | polyglot }}'
                            },
                            PlatformNote: {
                                tag: 'span',
                                fontSize: 'Z',
                                lineHeight: '1.4',
                                color: 'caption',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                text: '{{ canvas.team.platformNote | polyglot }}'
                            }
                        }
                    },
                    // People nodes. `_visiblePeople` is the full roster on
                    // /team-and-agents (no scope flag) and the viewer's slice under
                    // the /my-agents lens.
                    People: {
                        childrenAs: 'state',
                        // #2315 — inject a STABLE per-person id into each child's state.
                        // TeamPersonNode previously computed its id via (s._nodeId || _personId(s, 0))
                        // (hardcoded idx=0), so every person lacking a userId collapsed to
                        // 'p-0' — colliding positions/highlights and rendering the wrong
                        // info. Carry the correctly-indexed id as _nodeId instead.
                        children: (el, s)=>$83482a6ad78aef6f$var$_teamWindowFilter(s.root, el, $83482a6ad78aef6f$var$_visiblePeople(s.root).map((p, i)=>({
                                    ...p,
                                    _nodeId: $83482a6ad78aef6f$var$_personId(p, i),
                                    // Stable reconciler key. Without it the reconciler keys array
                                    // children by POSITIONAL INDEX (create.js:2360), so windowing
                                    // the array would patch the WRONG node's state. _personId uses
                                    // the FULL-roster index i, computed here BEFORE the window
                                    // filter so a windowed-out person never shifts anyone's id.
                                    key: $83482a6ad78aef6f$var$_personId(p, i)
                                })), (x)=>x._nodeId),
                        childExtends: 'TeamPersonNode'
                    },
                    // Agent nodes — sourced from Mongo via sdk.listAgents (§unified-perms
                    // PR #10), with SEED_AGENTS as the boot/offline fallback.
                    // `_visibleAgents` filters to the viewer's assigned agents under
                    // the /my-agents lens; full roster otherwise.
                    Agents: {
                        childrenAs: 'state',
                        children: (el, s)=>$83482a6ad78aef6f$var$_teamWindowFilter(s.root, el, // Stable reconciler key by agent id (see People above — agents
                            // carry `.id` but had no `.key`, so the reconciler fell back to
                            // positional index).
                            $83482a6ad78aef6f$var$_visibleAgents(s.root).map((a)=>({
                                    ...a,
                                    key: a.id
                                })), (x)=>x.id),
                        childExtends: 'TeamAgentNode'
                    }
                }
            }
        }
    },
    // Modals — mount at the page level so they can overlay the canvas
    // unconstrained. Hidden until their `*` state key is truthy.
    TeamMemberModal: {},
    AgentModal: {},
    // Create modal for the "+" menu's New human. Page-level so it overlays the
    // canvas unconstrained; hidden until `_createMemberOpen` is truthy. (New
    // agent's CreateAgentModal is the shell-root single instance —
    // workspace/app.js — since 2026-09-26: this page opens as a window over
    // home, whose own mount made one "+ → Agent" open two dialogs.)
    CreateMemberModal: {}
};
const $83482a6ad78aef6f$export$b0ae750a70300393 = {
    position: 'absolute',
    width: $83482a6ad78aef6f$var$PERSON_W + 'px',
    flow: 'y',
    gap: 'V',
    padding: 'A',
    round: 'radiusCard',
    // Borderless blue surface (2026-06-12 per Nika "make human background
    // blue, agent gray, remove borders"). The border used to carry the
    // connect/hover affordances — those move to a box-shadow ring so the
    // function survives without permanent card chrome. (Category border
    // coloring retired with the border itself.)
    background: 'document',
    backdropFilter: 'var(--shadow-float)',
    borderWidth: '0',
    boxShadow: (el, s)=>{
        const id = s._nodeId || $83482a6ad78aef6f$var$_personId(s, 0);
        // Link-drag source: the node you started dragging a connection from.
        if (s.root?._tagConnectFrom === id) return '0 0 0 2px var(--color-purple)';
        // Drag-collision / link-target: an in-flight link or card is over it.
        if (s.root?._tagHoverNode === id) return '0 0 0 2px var(--color-cyan)';
        return 'var(--shadow-float)';
    },
    cursor: (el, s)=>s.root?._tagConnectMode ? 'pointer' : 'grab',
    userSelect: 'var(--shadow-float)',
    zIndex: '2',
    shadow: 'float',
    transition: 'transform B defaultBezier',
    ':hover': {
        transform: 'translateY(-2px)'
    },
    ':hover > [data-tag-linkhandle]': {
        opacity: '1',
        transform: 'scale(1)'
    },
    attr: {
        'data-node-id': (el, s)=>s._nodeId || $83482a6ad78aef6f$var$_personId(s, 0),
        role: 'button',
        tabindex: '0'
    },
    // FLAT prop, FUNCTION form — an attribute inside `attr:` never re-resolves
    // a polyglot lookup (docs/I18N-CONVENTION.md §1).
    'aria-label': (el, s)=>el.call('polyglot', 'canvas.team.node.openAria').replace('{name}', s.name || s.title || el.call('polyglot', 'canvas.team.node.personFallback')),
    style: {
        left: (el, s)=>$83482a6ad78aef6f$var$_posFor(s.root, s._nodeId || $83482a6ad78aef6f$var$_personId(s, 0)).x + 'px',
        top: (el, s)=>$83482a6ad78aef6f$var$_posFor(s.root, s._nodeId || $83482a6ad78aef6f$var$_personId(s, 0)).y + 'px'
    },
    onPointerdown: $83482a6ad78aef6f$var$_onNodePointerdown,
    onClick: (e, el, s)=>$83482a6ad78aef6f$var$_onNodeClick(e, el, s, 'person'),
    onContextmenu: (e, el, s)=>el.call('tagNodeContextmenu', e, s, 'person'),
    onKeydown: (e, el, s)=>{
        if (e.target !== el.node || e.defaultPrevented) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $83482a6ad78aef6f$var$_onNodeClick(e, el, s, 'person');
        }
    },
    // Drag-to-assign handle (studios-style) — reveals on hover; drag onto
    // another card to draw a connection/assignment edge.
    LinkHandle: $83482a6ad78aef6f$var$_linkHandle(),
    // Online indicator (green dot, top-right) — visible when the user's
    // email is in root.onlineUsers (Supabase presence subscription, see
    // shared/functions/presence.js).
    OnlineDot: {
        position: 'absolute',
        top: 'V',
        right: 'V',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'green',
        boxShadow: '0 0 0 2px var(--color-card)',
        zIndex: '3',
        pointerEvents: 'var(--shadow-float)',
        hide: (el, s)=>!$83482a6ad78aef6f$var$_isPersonOnline(s.root, s.email)
    },
    // Idle indicator (amber, static) when the user is present but inactive
    // (5 min no activity / tab hidden — see idleState.js). Mirrors the agent
    // IdleDot; mutually exclusive with the green OnlineDot. Both hide when the
    // person isn't present at all. (2026-06-19 per Nika "online or idle".)
    IdleDot: {
        position: 'absolute',
        top: 'V',
        right: 'V',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'orange',
        boxShadow: '0 0 0 2px var(--color-card)',
        zIndex: '3',
        pointerEvents: 'var(--shadow-float)',
        hide: (el, s)=>!$83482a6ad78aef6f$var$_isPersonIdle(s.root, s.email)
    },
    Head: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        Avatar: {
            boxSize: 'B',
            round: '50%',
            align: 'center center',
            flexShrink: '0',
            src: (el, s)=>el.call('avatarUrlFor', s.email || s.name)
        },
        Info: {
            flow: 'y',
            gap: '0',
            flex: '1',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.name || (s.email || '').split('@')[0] || 'Member'
            },
            Role: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.position || s.role || (s.email || '').split('@')[0] || ''
            }
        }
    }
};
const $83482a6ad78aef6f$export$a39a2925c6f6277c = {
    position: 'absolute',
    width: $83482a6ad78aef6f$var$AGENT_W + 'px',
    flow: 'y',
    gap: 'V',
    padding: 'A',
    round: 'radiusCard',
    // Borderless neutral surface (2026-06-12 per Nika — humans blue, agents
    // neutral, no borders); connect affordance moves to a box-shadow ring.
    // §8.5: `gray4` was STATIC, so on the light canvas every adaptive ink on
    // the card collapsed — agent names 1.66:1, role captions 1.25:1 (2026-08-08
    // walk; dark measured clean, the signature of a static ground). The
    // `overlayStrong` pair keeps the same neutral-against-canvas reading on
    // both themes.
    background: 'document',
    borderWidth: '0',
    boxShadow: (el, s)=>$83482a6ad78aef6f$var$_isAgentWorking(s.root, s.id) ? '0 0 0 2px var(--color-blue), var(--shadow-float)' : s.root?._tagConnectFrom === s.id ? '0 0 0 2px var(--color-purple)' : 'var(--shadow-float)',
    cursor: (el, s)=>s.root?._tagConnectMode ? 'pointer' : 'grab',
    userSelect: 'var(--shadow-float)',
    zIndex: '2',
    shadow: 'float',
    transition: 'transform B defaultBezier',
    ':hover': {
        transform: 'translateY(-2px)'
    },
    ':hover > [data-tag-linkhandle]': {
        opacity: '1',
        transform: 'scale(1)'
    },
    attr: {
        'data-node-id': (el, s)=>s.id,
        role: 'button',
        tabindex: '0'
    },
    // FLAT prop, FUNCTION form — see TeamPersonNode.
    'aria-label': (el, s)=>el.call('polyglot', 'canvas.team.node.openAria').replace('{name}', s.name || s.title || el.call('polyglot', 'canvas.team.node.agentFallback')),
    style: {
        left: (el, s)=>$83482a6ad78aef6f$var$_posFor(s.root, s.id).x + 'px',
        top: (el, s)=>$83482a6ad78aef6f$var$_posFor(s.root, s.id).y + 'px'
    },
    onPointerdown: $83482a6ad78aef6f$var$_onNodePointerdown,
    onClick: (e, el, s)=>$83482a6ad78aef6f$var$_onNodeClick(e, el, s, 'agent'),
    onContextmenu: (e, el, s)=>el.call('tagNodeContextmenu', e, s, 'agent'),
    onKeydown: (e, el, s)=>{
        if (e.target !== el.node || e.defaultPrevented) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $83482a6ad78aef6f$var$_onNodeClick(e, el, s, 'agent');
        }
    },
    // Drag-to-assign handle (studios-style) — reveals on hover; drag onto
    // another card to draw a connection/assignment edge.
    LinkHandle: $83482a6ad78aef6f$var$_linkHandle(),
    // Pulsing indicator (green dot + ring, top-right) — visible when
    // the agent has a recent heartbeat in root.triage.agentPresence
    // (last 5 min). Animation lives in the `ttag-pulse` keyframe
    // injected by the page's onCreate.
    PulseDot: {
        position: 'absolute',
        top: 'V',
        right: 'V',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'green',
        boxShadow: '0 0 0 2px var(--color-card)',
        zIndex: '3',
        pointerEvents: 'var(--shadow-float)',
        style: {
            animation: 'ttag-pulse 1.6s ease-out infinite'
        },
        hide: (el, s)=>!$83482a6ad78aef6f$var$_isAgentPulsing(s.root, s.id)
    },
    // Idle indicator (amber, static — no pulse) when the agent heartbeat has gone
    // quiet but is still recent. Mutually exclusive with the green online pulse.
    // (2026-06-19 per Nika "cards should show online or idle".)
    IdleDot: {
        position: 'absolute',
        top: 'V',
        right: 'V',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'orange',
        boxShadow: '0 0 0 2px var(--color-card)',
        zIndex: '3',
        pointerEvents: 'var(--shadow-float)',
        hide: (el, s)=>!$83482a6ad78aef6f$var$_isAgentIdle(s.root, s.id)
    },
    // Live "working now" — a blue pulsing dot (top-LEFT, so it never collides with
    // the green/amber heartbeat dots top-right) shown while Simone is running a
    // delegated/chained task on this agent THIS turn (root.activeProcesses). Reuses
    // the ttag-pulse keyframe; independent of the dormant heartbeat presence.
    WorkingDot: {
        position: 'absolute',
        top: 'V',
        left: 'V',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'blue',
        boxShadow: '0 0 0 2px var(--color-card)',
        zIndex: '3',
        pointerEvents: 'var(--shadow-float)',
        style: {
            animation: 'ttag-pulse 1.2s ease-out infinite'
        },
        hide: (el, s)=>!$83482a6ad78aef6f$var$_isAgentWorking(s.root, s.id)
    },
    Head: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        Glyph: {
            width: 'B',
            height: 'B',
            round: 'radiusControl',
            align: 'center center',
            flexShrink: '0',
            // §4.4 pale/deep — `purple.3` composites to a PALE plate (#C0B2D3 on
            // light), so white ink on it measured 1.99:1 (2026-08-08 walk). A pale
            // hue plate takes dark ink; the hue still reads as the identity.
            background: 'overlayStrong',
            color: 'title',
            fontSize: 'A',
            fontWeight: '700',
            text: "\u25C6"
        },
        Info: {
            flow: 'y',
            gap: '0',
            flex: '1',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.name || s.id
            },
            Caption: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                // KEY-IN-STATE: `s.caption` holds a bundle key for a seeded agent and a
                // server-supplied string for a custom one. polyglot returns a non-key
                // verbatim, so both pass through the same call.
                text: (el, s)=>el.call('polyglot', s.caption || 'canvas.team.agent.fallback').replace('{name}', s.captionName || '')
            }
        }
    }
};
const $83482a6ad78aef6f$export$7bd57608fd0456fe = {
    extends: 'Modal',
    stateKey: '_selectedTeamMember',
    pointerEvents: (el, s)=>s.root?._selectedTeamMember ? 'auto' : 'none',
    Window: {
        width: 'I',
        maxWidth: '92vw',
        gap: 'A',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>{
                        const m = s.root?._selectedTeamMember;
                        return m?.name || (m?.email || '').split('@')[0] || 'Member';
                    }
                },
                P: {
                    text: (el, s)=>{
                        const m = s.root?._selectedTeamMember;
                        return m?.position || m?.role || m?.email || '';
                    }
                }
            }
        },
        HeaderAvatar: {
            extends: 'Avatar',
            boxSize: 'C',
            round: '50%',
            align: 'center center',
            src: (el, s)=>el.call('avatarUrlFor', s.root?._selectedTeamMember?.email || s.root?._selectedTeamMember?.name)
        },
        Detail: {
            flow: 'y',
            gap: 'V',
            fontSize: 'Z1',
            color: 'title',
            Email: {
                tag: 'p',
                margin: '0',
                text: (el, s)=>el.call('polyglot', 'canvas.team.member.email').replace('{value}', s.root?._selectedTeamMember?.email || "\u2014")
            },
            Location: {
                tag: 'p',
                margin: '0',
                text: (el, s)=>el.call('polyglot', 'canvas.team.member.location').replace('{value}', s.root?._selectedTeamMember?.location || "\u2014")
            },
            Timezone: {
                tag: 'p',
                margin: '0',
                text: (el, s)=>el.call('polyglot', 'canvas.team.member.timezone').replace('{value}', s.root?._selectedTeamMember?.timezone || "\u2014")
            }
        }
    }
};
// ─── Agent settings editor (the /my-agents modal) ─────────────────
//
// The agent modal is a 4-tab editor over the agent's DB record:
//   Instructions — system prompt / persona (metadata.instructions)
//   Permissions  — access preset + permission set (metadata.userRole /
//                  metadata.permissions)
//   Tools        — runtime capability allowlist (metadata.capabilities),
//                  rendered from the live capability/tool catalog
//                  (sdk.getAgentToolCatalog → agent-core)
//   Assignment   — the people this agent is assigned to (AgentAssignment)
//
// _selectedAgent carries only the lean roster fields; opening the modal
// fetches the full record (sdk.getAgent) into _agentDetail and seeds the
// editable _agentDraft. Save PATCHes via sdk.updateAgent. Assignment edits
// route through the workspace agentAssignments functions via el.call.
const $83482a6ad78aef6f$var$AGENT_ACCESS_PRESETS = [
    {
        value: 'guest',
        label: 'canvas.team.agentAccess.guestLabel',
        permissions: [
            'read'
        ],
        hint: 'canvas.team.agentAccess.guestHint'
    },
    {
        value: 'editor',
        label: 'canvas.team.agentAccess.editorLabel',
        permissions: [
            'read',
            'write'
        ],
        hint: 'canvas.team.agentAccess.editorHint'
    },
    {
        value: 'admin',
        label: 'canvas.team.agentAccess.adminLabel',
        permissions: [
            'read',
            'write',
            'manage'
        ],
        hint: 'canvas.team.agentAccess.adminHint'
    }
];
const $83482a6ad78aef6f$var$_accessPreset = (v)=>$83482a6ad78aef6f$var$AGENT_ACCESS_PRESETS.find((p)=>p.value === v) || $83482a6ad78aef6f$var$AGENT_ACCESS_PRESETS[1];
const $83482a6ad78aef6f$var$_agentToolCatalog = (root)=>Array.isArray(root?._agentToolCatalog) ? root._agentToolCatalog : [];
// Fetch the capability/tool catalog once per session and cache on root.
const $83482a6ad78aef6f$var$_loadAgentToolCatalog = async (root)=>{
    if (!root || root._agentToolCatalogLoaded) return;
    root._agentToolCatalogLoaded = true;
    try {
        const sdk = (0, $1NxyO.getSDK)();
        if (!sdk || typeof sdk.getAgentToolCatalog !== 'function') {
            root._agentToolCatalogLoaded = false;
            return;
        }
        const res = await sdk.getAgentToolCatalog();
        const data = res && res.data || res || {};
        root.update({
            _agentToolCatalog: Array.isArray(data.catalog) ? data.catalog : []
        });
    } catch (err) {
        root._agentToolCatalogLoaded = false;
        console.warn('[agent-editor] tool catalog failed:', err && err.message);
    }
};
// Open the editor for an agent: reset tab/draft state, fetch the full
// record + tool catalog, seed the editable draft. Falls back to the
// bundled persona for instructions when the DB record has none (so seeded
// agents present their canonical persona as the editable starting point).
const $83482a6ad78aef6f$var$_openAgentEditor = (root, agent)=>{
    if (!root || !agent) return;
    root.update({
        _selectedAgent: agent,
        _agentTab: 'instructions',
        _agentDetail: null,
        _agentDetailFor: agent.id,
        _agentDraft: null,
        _agentSavePending: false,
        _agentSaveError: null,
        _agentSaveSavedAt: null
    });
    $83482a6ad78aef6f$var$_loadAgentToolCatalog(root);
    const seed = (personas)=>({
            instructions: personas[agent.id] || '',
            userRole: 'editor',
            permissions: [
                'read',
                'write'
            ],
            capabilities: [],
            capabilitiesRestricted: false
        });
    // Seed-only agent (no Mongo record yet) — show the bundled persona;
    // saving is gated off until the agent is provisioned.
    if (!agent.userId) {
        $83482a6ad78aef6f$var$_agentInstructions().then((personas)=>{
            if (root._agentDetailFor !== agent.id) return;
            root.update({
                _agentDetail: {
                    _seedOnly: true
                },
                _agentDraft: seed(personas)
            });
        }, (err)=>{
            console.warn('[agent-editor] persona load failed:', err && err.message);
            if (root._agentDetailFor !== agent.id) return;
            root.update({
                _agentDetail: {
                    _seedOnly: true
                },
                _agentDraft: seed({})
            });
        });
        return;
    }
    (async ()=>{
        const personas = await $83482a6ad78aef6f$var$_agentInstructions().catch(()=>({}));
        try {
            const sdk = (0, $1NxyO.getSDK)();
            const detail = await sdk.getAgent(agent.userId);
            const d = detail && detail.data || detail || {};
            // Guard against a fast modal switch — only seed if still this agent.
            if (root._agentDetailFor !== agent.id) return;
            root.update({
                _agentDetail: d,
                _agentDraft: {
                    instructions: d.instructions || personas[agent.id] || '',
                    userRole: d.userRole || 'editor',
                    permissions: Array.isArray(d.permissions) && d.permissions.length ? d.permissions : $83482a6ad78aef6f$var$_accessPreset(d.userRole).permissions,
                    capabilities: Array.isArray(d.capabilities) ? d.capabilities : [],
                    capabilitiesRestricted: d.capabilitiesRestricted === true
                }
            });
        } catch (err) {
            console.warn('[agent-editor] getAgent failed:', err && err.message);
            if (root._agentDetailFor !== agent.id) return;
            root.update({
                _agentDetail: {
                    _error: true
                },
                _agentDraft: seed(personas)
            });
        }
    })();
};
const $83482a6ad78aef6f$var$_patchAgentDraft = (root, patch)=>{
    const draft = root && root._agentDraft || {};
    root.update({
        _agentDraft: {
            ...draft,
            ...patch
        },
        _agentSaveSavedAt: null
    });
};
const $83482a6ad78aef6f$var$_setAgentAccess = (root, value)=>{
    const preset = $83482a6ad78aef6f$var$_accessPreset(value);
    $83482a6ad78aef6f$var$_patchAgentDraft(root, {
        userRole: preset.value,
        permissions: preset.permissions
    });
};
const $83482a6ad78aef6f$var$_agentHasCap = (root, cap)=>{
    const caps = root && root._agentDraft && root._agentDraft.capabilities;
    return Array.isArray(caps) && caps.includes(cap);
};
const $83482a6ad78aef6f$var$_toggleAgentCapability = (root, cap)=>{
    const caps = root && root._agentDraft && Array.isArray(root._agentDraft.capabilities) ? root._agentDraft.capabilities : [];
    $83482a6ad78aef6f$var$_patchAgentDraft(root, {
        capabilities: caps.includes(cap) ? caps.filter((c)=>c !== cap) : [
            ...caps,
            cap
        ]
    });
};
// "Restrict to selected tools" master switch. OFF (default) = the agent is
// unrestricted (inherits the runtime default) and the per-capability toggles
// below are just a saved pre-selection; ON = the agent's runs are capped to
// exactly the selected capabilities (empty selection = deny-all). This keeps
// enforcement opt-in, so checking a capability never silently locks an agent.
const $83482a6ad78aef6f$var$_agentRestricted = (root)=>!!(root && root._agentDraft && root._agentDraft.capabilitiesRestricted);
const $83482a6ad78aef6f$var$_toggleAgentRestricted = (root)=>$83482a6ad78aef6f$var$_patchAgentDraft(root, {
        capabilitiesRestricted: !$83482a6ad78aef6f$var$_agentRestricted(root)
    });
// Persist Instructions + Permissions + Tools via sdk.updateAgent. On
// success patches the local detail; surfaces pending / saved / error in
// the footer.
const $83482a6ad78aef6f$var$_saveAgentSettings = async (root)=>{
    const agent = root && root._selectedAgent;
    const draft = root && root._agentDraft;
    if (!agent || !draft) return;
    if (!agent.userId) {
        root.update({
            _agentSaveError: 'canvas.team.agentModal.errorBuiltIn'
        });
        return;
    }
    root.update({
        _agentSavePending: true,
        _agentSaveError: null
    });
    try {
        const sdk = (0, $1NxyO.getSDK)();
        const updated = await sdk.updateAgent(agent.userId, {
            instructions: draft.instructions || '',
            userRole: draft.userRole || 'editor',
            permissions: Array.isArray(draft.permissions) ? draft.permissions : [],
            capabilities: Array.isArray(draft.capabilities) ? draft.capabilities : [],
            capabilitiesRestricted: !!draft.capabilitiesRestricted
        });
        const d = updated && updated.data || updated || {};
        root.update({
            _agentSavePending: false,
            _agentSaveSavedAt: Date.now(),
            _agentDetail: d && d.id ? d : root._agentDetail
        });
    } catch (err) {
        root.update({
            _agentSavePending: false,
            _agentSaveError: err && err.message || 'canvas.team.agentModal.errorSaveFailed'
        });
    }
};
// ─ Assignment helpers ─ read the org-scoped AgentAssignment maps the
// workspace boot already populates (root.agentAssignmentsByAgent), and
// route mutations through the workspace agentAssignments functions via
// el.call (optimistic local update + SDK write). Gated on the admin tier
// (the server requires admin.teams for assignment writes).
const $83482a6ad78aef6f$var$_agentAssignees = (root)=>{
    const uid = root && root._selectedAgent && root._selectedAgent.userId;
    if (!uid) return [];
    const rows = root.agentAssignmentsByAgent && root.agentAssignmentsByAgent[uid];
    return Array.isArray(rows) ? rows : [];
};
const $83482a6ad78aef6f$var$_canManageAgents = (root)=>$83482a6ad78aef6f$var$_viewerTier(root) === 'admin';
const $83482a6ad78aef6f$var$_personNameByUserId = (root, uid)=>{
    if (!uid) return null;
    const p = (Array.isArray(root && root.people) ? root.people : []).find((x)=>String(x.userId) === String(uid));
    return p && (p.name || p.email) || null;
};
// The person an assignment row names (the row's text and the unassign ask).
const $83482a6ad78aef6f$var$_assigneeLabel = (el, s)=>s.assigneeName || $83482a6ad78aef6f$var$_personNameByUserId(s.root, s.assignee) || s.assignee || el.call('polyglot', 'canvas.team.assignee.fallback');
const $83482a6ad78aef6f$var$_assignablePeople = (root)=>{
    const people = Array.isArray(root && root.people) ? root.people : [];
    const taken = new Set($83482a6ad78aef6f$var$_agentAssignees(root).map((r)=>String(r.assignee)));
    return people.filter((p)=>p && p.userId && !taken.has(String(p.userId)));
};
const $83482a6ad78aef6f$var$_orgIdForAssign = (root)=>root && root.jwtClaims && root.jwtClaims.workspace_org_id || root && root.jwtClaims && Array.isArray(root.jwtClaims.orgs) && root.jwtClaims.orgs[0] && root.jwtClaims.orgs[0].id || root && root.workspace && root.workspace.id || null;
// Tab + access button factories (called at modal-literal eval time, so
// they must be defined above the AgentModal export). Active state uses the
// reactive `.isActive` conditional-class (createEffect-wrapped) rather than
// a reactive `background` factory, which freezes at mount in v3.14.
const $83482a6ad78aef6f$var$agentTabButton = (key, label)=>({
        scope: {
            key: key
        },
        tag: 'button',
        type: 'button',
        text: label,
        minHeight: 'controlHCompact',
        padding: '0 A',
        round: 'radiusPill',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'Z2',
        fontWeight: '700',
        background: 'transparent',
        color: 'caption',
        isActive: (el, s)=>(s.root && s.root._agentTab || 'instructions') === el.scope.key,
        '.isActive': {
            background: 'selected',
            color: 'title'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            s.root.update({
                _agentTab: el.scope.key
            });
        }
    });
const $83482a6ad78aef6f$var$agentAccessButton = (value, label)=>({
        scope: {
            value: value
        },
        tag: 'button',
        type: 'button',
        text: label,
        flex: '1 1 0',
        minHeight: 'controlHCompact',
        padding: '0 A',
        round: 'radiusPill',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'Z2',
        fontWeight: '700',
        background: 'overlay',
        color: 'title',
        isActive: (el, s)=>(s.root && s.root._agentDraft && s.root._agentDraft.userRole || 'editor') === el.scope.value,
        '.isActive': {
            background: 'blue',
            color: 'white'
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            $83482a6ad78aef6f$var$_setAgentAccess(s.root, el.scope.value);
        }
    });
const $83482a6ad78aef6f$export$9e01ca19610ab51c = {
    extends: 'Modal',
    stateKey: '_selectedAgent',
    pointerEvents: (el, s)=>s.root?._selectedAgent ? 'auto' : 'none',
    // Clear editor drafts when the modal closes (backdrop / Escape). The
    // shared Modal merges extraClose into its close update.
    extraClose: {
        _agentTab: 'instructions',
        _agentDetail: null,
        _agentDetailFor: null,
        _agentDraft: null,
        _agentSavePending: false,
        _agentSaveError: null,
        _agentSaveSavedAt: null
    },
    Window: {
        width: 'I',
        maxWidth: '94vw',
        height: '82dvh',
        maxHeight: '92dvh',
        flow: 'y',
        gap: 'V',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: (el, s)=>s.root?._selectedAgent && (s.root._selectedAgent.name || s.root._selectedAgent.id) || el.call('polyglot', 'canvas.team.agent.fallback')
                },
                P: {
                    text: (el, s)=>{
                        const agent = s.root?._selectedAgent;
                        if (!agent?.caption) return '';
                        return el.call('polyglot', agent.caption).replace('{name}', agent.captionName || '');
                    }
                }
            }
        },
        // ─ Tab bar ─
        TabBar: {
            flexShrink: '0',
            flow: 'x',
            gap: 'V',
            align: 'center',
            TabInstructions: $83482a6ad78aef6f$var$agentTabButton('instructions', 'Instructions'),
            TabPermissions: $83482a6ad78aef6f$var$agentTabButton('permissions', 'Permissions'),
            TabTools: $83482a6ad78aef6f$var$agentTabButton('tools', 'Tools'),
            TabAssignment: $83482a6ad78aef6f$var$agentTabButton('assignment', 'Assignment')
        },
        // ─ Instructions ─
        InstructionsPanel: {
            hide: (el, s)=>(s.root && s.root._agentTab || 'instructions') !== 'instructions',
            flow: 'y',
            gap: 'V',
            flex: '1 1 0',
            minHeight: '0',
            Label: {
                tag: 'span',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'caption',
                text: '{{ canvas.team.agentModal.instructionsLabel | polyglot }}'
            },
            InstructionsArea: {
                tag: 'textarea',
                name: 'agent-instructions',
                placeholder: (el)=>el.call('polyglot', 'canvas.team.agentModal.instructionsPlaceholder'),
                flex: '1 1 0',
                minHeight: '0',
                width: '100%',
                padding: 'A',
                round: 'radiusControl',
                theme: 'document',
                color: 'title',
                fontSize: 'Z1',
                lineHeight: '1.5',
                border: 'none',
                resize: 'none',
                fontFamily: 'inherit',
                value: (el, s)=>s.root && s.root._agentDraft && s.root._agentDraft.instructions || '',
                onInput: (e, el, s)=>{
                    $83482a6ad78aef6f$var$_patchAgentDraft(s.root, {
                        instructions: el.node.value
                    });
                }
            }
        },
        // ─ Permissions ─
        PermissionsPanel: {
            hide: (el, s)=>(s.root && s.root._agentTab || 'instructions') !== 'permissions',
            flow: 'y',
            gap: 'A',
            flex: '1 1 0',
            minHeight: '0',
            overflow: 'auto',
            AccessLabel: {
                tag: 'span',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'caption',
                text: '{{ canvas.team.agentModal.accessLabel | polyglot }}'
            },
            AccessRow: {
                flow: 'x',
                gap: 'V',
                AccessGuest: $83482a6ad78aef6f$var$agentAccessButton('guest', '{{ canvas.team.agentAccess.guestLabel | polyglot }}'),
                AccessEditor: $83482a6ad78aef6f$var$agentAccessButton('editor', '{{ canvas.team.agentAccess.editorLabel | polyglot }}'),
                AccessAdmin: $83482a6ad78aef6f$var$agentAccessButton('admin', '{{ canvas.team.agentAccess.adminLabel | polyglot }}')
            },
            AccessHint: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y',
                lineHeight: '1.4',
                color: 'caption',
                // `hint` on the preset holds a bundle KEY — resolved here so a language
                // switch re-renders it.
                text: (el, s)=>el.call('polyglot', $83482a6ad78aef6f$var$_accessPreset(s.root && s.root._agentDraft && s.root._agentDraft.userRole).hint)
            },
            PermsLabel: {
                tag: 'span',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'caption',
                text: '{{ canvas.team.agentModal.permsLabel | polyglot }}'
            },
            PermsChips: {
                flow: 'x',
                gap: 'V',
                flexWrap: 'wrap',
                childrenAs: 'state',
                children: (el, s)=>(s.root && s.root._agentDraft && s.root._agentDraft.permissions || []).map((p)=>({
                            perm: p
                        })),
                childExtends: 'AgentPermChip'
            }
        },
        // ─ Tools ─
        ToolsPanel: {
            hide: (el, s)=>(s.root && s.root._agentTab || 'instructions') !== 'tools',
            flow: 'y',
            gap: 'V',
            flex: '1 1 0',
            minHeight: '0',
            overflow: 'auto',
            // Master switch — enforcement is opt-in. OFF = unrestricted (the toggles
            // below are a saved pre-selection); ON = runs capped to the selection.
            RestrictRow: {
                flexShrink: '0',
                flow: 'x',
                align: 'center',
                justifyContent: 'space-between',
                gap: 'V',
                padding: 'V',
                round: 'radiusControl',
                theme: 'card',
                Meta: {
                    flow: 'y',
                    gap: 'V',
                    Title: {
                        tag: 'span',
                        fontSize: 'Z2',
                        fontWeight: '700',
                        color: 'title',
                        text: '{{ canvas.team.agentModal.restrictTitle | polyglot }}'
                    },
                    Desc: {
                        tag: 'span',
                        fontSize: 'Y',
                        lineHeight: '1.4',
                        color: 'caption',
                        text: (el, s)=>el.call('polyglot', $83482a6ad78aef6f$var$_agentRestricted(s.root) ? 'canvas.team.agentModal.restrictDescOn' : 'canvas.team.agentModal.restrictDescOff')
                    }
                },
                RestrictToggle: {
                    tag: 'button',
                    type: 'button',
                    flexShrink: '0',
                    minHeight: 'controlHCompact',
                    padding: '0 A',
                    round: 'radiusPill',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'Y',
                    fontWeight: '700',
                    background: 'overlay',
                    color: 'caption',
                    isOn: (el, s)=>$83482a6ad78aef6f$var$_agentRestricted(s.root),
                    '.isOn': {
                        background: 'blue',
                        color: 'white'
                    },
                    text: (el, s)=>el.call('polyglot', $83482a6ad78aef6f$var$_agentRestricted(s.root) ? 'canvas.team.agentModal.toggleOn' : 'canvas.team.agentModal.toggleOff'),
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        $83482a6ad78aef6f$var$_toggleAgentRestricted(s.root);
                    }
                }
            },
            Intro: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y',
                lineHeight: '1.4',
                color: 'caption',
                text: (el, s)=>el.call('polyglot', $83482a6ad78aef6f$var$_agentRestricted(s.root) ? 'canvas.team.agentModal.toolsIntroOn' : 'canvas.team.agentModal.toolsIntroOff')
            },
            Empty: {
                hide: (el, s)=>$83482a6ad78aef6f$var$_agentToolCatalog(s.root).length > 0,
                flow: 'y',
                gap: 'V',
                Row_1: {
                    extends: 'SkeletonCard'
                },
                Row_2: {
                    extends: 'SkeletonCard'
                }
            },
            List: {
                flow: 'y',
                gap: 'V',
                // Muted when not enforcing — the selection is informational until the
                // master switch is on. Reactive via the conditional class (raw
                // reactive `opacity` would freeze at mount in v3.14).
                isMuted: (el, s)=>!$83482a6ad78aef6f$var$_agentRestricted(s.root),
                '.isMuted': {
                    opacity: '0.6'
                },
                childrenAs: 'state',
                children: (el, s)=>$83482a6ad78aef6f$var$_agentToolCatalog(s.root).map((c)=>({
                            ...c
                        })),
                childExtends: 'AgentToolRow'
            }
        },
        // ─ Assignment ─
        AssignmentPanel: {
            hide: (el, s)=>(s.root && s.root._agentTab || 'instructions') !== 'assignment',
            flow: 'y',
            gap: 'A',
            flex: '1 1 0',
            minHeight: '0',
            overflow: 'auto',
            AssignedLabel: {
                tag: 'span',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'caption',
                text: '{{ canvas.team.agentModal.assignedLabel | polyglot }}'
            },
            AssignedEmpty: {
                hide: (el, s)=>$83482a6ad78aef6f$var$_agentAssignees(s.root).length > 0,
                tag: 'p',
                margin: '0',
                fontSize: 'Y',
                color: 'caption',
                text: '{{ canvas.team.agentModal.assignedEmpty | polyglot }}'
            },
            AssignedList: {
                flow: 'y',
                gap: 'V',
                childrenAs: 'state',
                children: (el, s)=>$83482a6ad78aef6f$var$_agentAssignees(s.root).map((r)=>({
                            ...r
                        })),
                childExtends: 'AgentAssigneeRow'
            },
            AddLabel: {
                hide: (el, s)=>!$83482a6ad78aef6f$var$_canManageAgents(s.root),
                tag: 'span',
                fontSize: 'Y',
                fontWeight: '700',
                color: 'caption',
                text: '{{ canvas.team.agentModal.addLabel | polyglot }}'
            },
            AddEmpty: {
                hide: (el, s)=>!$83482a6ad78aef6f$var$_canManageAgents(s.root) || $83482a6ad78aef6f$var$_assignablePeople(s.root).length > 0,
                tag: 'p',
                margin: '0',
                fontSize: 'Y',
                color: 'caption',
                text: '{{ canvas.team.agentModal.addEmpty | polyglot }}'
            },
            AddChips: {
                hide: (el, s)=>!$83482a6ad78aef6f$var$_canManageAgents(s.root),
                flow: 'x',
                gap: 'V',
                flexWrap: 'wrap',
                childrenAs: 'state',
                children: (el, s)=>$83482a6ad78aef6f$var$_assignablePeople(s.root).map((p)=>({
                            userId: p.userId,
                            name: p.name || p.email || 'Member',
                            email: p.email || ''
                        })),
                childExtends: 'AgentAssignChip'
            }
        },
        // ─ Footer ─ save (Instructions/Permissions/Tools) + talk.
        AgentFooter: {
            flexShrink: '0',
            flow: 'x',
            align: 'center',
            justifyContent: 'space-between',
            gap: 'V',
            Status: {
                tag: 'span',
                fontSize: 'Y',
                color: 'caption',
                isError: (el, s)=>!!(s.root && s.root._agentSaveError),
                '.isError': {
                    color: 'red'
                },
                text: (el, s)=>{
                    const r = s.root || {};
                    // Key-in-state — `_agentSaveError` holds a bundle KEY, or a raw SDK
                    // message that polyglot returns verbatim on a miss.
                    if (r._agentSaveError) return el.call('polyglot', r._agentSaveError);
                    if (r._agentSavePending) return el.call('polyglot', 'canvas.team.agentModal.saving');
                    if (r._agentSaveSavedAt) return el.call('polyglot', 'canvas.team.agentModal.saved');
                    return '';
                }
            },
            Actions: {
                flow: 'x',
                gap: 'V',
                align: 'center',
                SaveBtn: {
                    tag: 'button',
                    type: 'button',
                    hide: (el, s)=>!(s.root && s.root._selectedAgent && s.root._selectedAgent.userId),
                    minHeight: 'controlH',
                    padding: '0 A',
                    round: 'radiusPill',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    background: 'overlay',
                    color: 'title',
                    disabled: (el, s)=>!!(s.root && s.root._agentSavePending),
                    opacity: (el, s)=>s.root && s.root._agentSavePending ? '0.6' : '1',
                    text: (el, s)=>el.call('polyglot', s.root && s.root._agentSavePending ? 'canvas.team.agentModal.saving' : 'canvas.team.agentModal.saveChanges'),
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        $83482a6ad78aef6f$var$_saveAgentSettings(s.root);
                    }
                },
                TalkBtn: {
                    tag: 'button',
                    type: 'button',
                    minHeight: 'controlH',
                    padding: '0 A',
                    round: 'radiusPill',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'fillInk',
                    background: 'blue',
                    text: (el, s)=>`Talk to ${s.root && s.root._selectedAgent && s.root._selectedAgent.name || 'agent'}`,
                    // Open THIS agent's own thread, resumed if it has one
                    // (AI-TALK-TO-AGENT-REUSES-OPEN-THREAD-1, answer C). The button used
                    // to write the routing target only, so the drawer kept whatever
                    // thread was last open and merely aimed the next message at the
                    // agent — measured on production 2026-08-30 06:47.
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        const a = s.root && s.root._selectedAgent;
                        s.root.update({
                            _selectedAgent: null,
                            _agentDraft: null,
                            _agentDetail: null,
                            assistantOpen: true
                        });
                        el.call('openAgentThread', a ? {
                            userId: a.userId,
                            id: a.id,
                            name: a.name
                        } : null);
                    }
                }
            }
        }
    }
};
const $83482a6ad78aef6f$export$9c52fa2b6d6e98f2 = {
    tag: 'span',
    padding: 'V',
    round: 'radiusControl',
    background: 'overlay',
    color: 'title',
    fontSize: 'Y',
    fontWeight: '700',
    text: (el, s)=>s.perm || ''
};
const $83482a6ad78aef6f$export$b191a533745f07ad = {
    flow: 'y',
    gap: 'V',
    padding: 'V',
    round: 'radiusControl',
    theme: 'card',
    Head: {
        flow: 'x',
        align: 'center',
        justifyContent: 'space-between',
        gap: 'V',
        Meta: {
            flow: 'y',
            gap: 'V',
            Title: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.label || s.capability || ''
            },
            Desc: {
                tag: 'span',
                fontSize: 'Y',
                lineHeight: '1.4',
                color: 'caption',
                text: (el, s)=>s.description || ''
            }
        },
        ToolToggle: {
            tag: 'button',
            type: 'button',
            flexShrink: '0',
            minHeight: 'controlHCompact',
            padding: '0 A',
            round: 'radiusPill',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'Y',
            fontWeight: '700',
            background: 'overlay',
            color: 'caption',
            isOn: (el, s)=>$83482a6ad78aef6f$var$_agentHasCap(s.root, s.capability),
            '.isOn': {
                background: 'blue',
                color: 'white'
            },
            text: (el, s)=>$83482a6ad78aef6f$var$_agentHasCap(s.root, s.capability) ? 'On' : 'Off',
            onClick: (e, el, s)=>{
                e.preventDefault();
                $83482a6ad78aef6f$var$_toggleAgentCapability(s.root, s.capability);
            }
        }
    },
    Tools: {
        hide: (el, s)=>!(Array.isArray(s.tools) && s.tools.length),
        tag: 'span',
        fontSize: 'Y',
        lineHeight: '1.4',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', 'canvas.team.agentModal.toolsList').replace('{tools}', (s.tools || []).join("  \xb7  "))
    }
};
const $83482a6ad78aef6f$export$f2dbf3051bab3e04 = {
    flow: 'x',
    align: 'center',
    justifyContent: 'space-between',
    gap: 'V',
    padding: 'V',
    round: 'radiusControl',
    theme: 'card',
    Name: {
        tag: 'span',
        fontSize: 'Z2',
        color: 'title',
        text: (el, s)=>$83482a6ad78aef6f$var$_assigneeLabel(el, s)
    },
    RemoveBtn: {
        hide: (el, s)=>!$83482a6ad78aef6f$var$_canManageAgents(s.root),
        tag: 'button',
        type: 'button',
        text: '{{ canvas.team.assignee.remove | polyglot }}',
        minHeight: 'controlHCompact',
        padding: '0 Z',
        round: 'radiusPill',
        border: 'none',
        cursor: 'pointer',
        fontSize: 'Y',
        fontWeight: '700',
        background: 'overlay',
        color: 'red',
        // The house confirm first (CRUD + confirm standard rule 4); the unassign
        // runs only on the verb. A failure shows in the editor's status line.
        onClick: (e, el, s)=>{
            e.preventDefault();
            const root = s.root;
            if (!$83482a6ad78aef6f$var$_canManageAgents(root)) return;
            const agent = root && root._selectedAgent;
            const orgId = s.orgId || $83482a6ad78aef6f$var$_orgIdForAssign(root);
            const assignment = {
                id: s.id,
                assignee: s.assignee
            };
            el.call('confirmAgentUnassign', {
                agent: agent && (agent.name || agent.id) || el.call('polyglot', 'canvas.team.agent.fallback'),
                person: $83482a6ad78aef6f$var$_assigneeLabel(el, s),
                onConfirm: ()=>Promise.resolve(el.call('unassignAgentFromUser', root, {
                        orgId: orgId,
                        assignmentId: assignment.id,
                        agentUserId: agent && agent.userId,
                        assigneeUserId: assignment.assignee
                    })).catch((err)=>{
                        console.warn('[agent-editor] unassign failed:', err && err.message);
                        root.update({
                            _agentSaveError: err && err.message || 'canvas.team.toast.removeFailed'
                        });
                    })
            });
        }
    }
};
const $83482a6ad78aef6f$export$79a32f1afddeb210 = {
    tag: 'button',
    type: 'button',
    padding: 'V',
    round: 'radiusControl',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Y',
    fontWeight: '700',
    background: 'overlay',
    color: 'title',
    text: (el, s)=>'+ ' + (s.name || 'Member'),
    onClick: (e, el, s)=>{
        e.preventDefault();
        const agent = s.root && s.root._selectedAgent;
        const orgId = $83482a6ad78aef6f$var$_orgIdForAssign(s.root);
        if (!agent || !agent.userId || !s.userId || !orgId) return;
        try {
            el.call('assignAgentToUser', s.root, {
                orgId: orgId,
                agentUserId: agent.userId,
                assigneeUserId: s.userId
            });
        } catch (err) {
            console.warn('[agent-editor] assign failed:', err && err.message);
        }
    }
};

});
parcelRegister("d3gaB", function(module, exports) {

$parcel$export(module.exports, "canvasAgentDisplayName", () => $98081933240e65b6$export$549d416df6d66e6);

var $1X0Je = parcelRequire("1X0Je");
'use strict';
const $98081933240e65b6$export$549d416df6d66e6 = (...args)=>(0, $1X0Je.default).functions.agentDisplayName(...args);

});

parcelRegister("5xbNK", function(module, exports) {

$parcel$export(module.exports, "canvasAgentRoster", () => $407930539ab9ab05$export$5b34672c42115cef);
$parcel$export(module.exports, "canvasRosterShaped", () => $407930539ab9ab05$export$5ea75ac58d82f1be);
$parcel$export(module.exports, "canvasPlatformAgents", () => $407930539ab9ab05$export$c5ff97cd96a255b9);
// The /team-and-agents roster order (WL-7, persona audit round 1, tomas; Nika
// 2026-10-25 21:20: "Own agents, platform ones labeled").
//
// A workspace's OWN agents are the ones with an agent row in its org (the
// roster's Mongo identity: `userId`). A seed agent with no row there is a
// PLATFORM default (s1m0ne, Chuvak, Temo …): the page still shows it — it can
// be activated into the org — but after the workspace's own agents and marked
// `platform: true`, so the canvas draws it under the "Platform" label.
//
// A row the PLATFORM made is built in too, row or not (persona round 5, tomas:
// a new workspace listed Personal Assistant, Simone and Temo as his own). The
// server's org seeder stamps its defaults into every team org, and the
// canvas's "Activate agents" provisions the seeds; both key the row by its
// `seedSlug`. So a row with a seedSlug stays in the platform block — it keeps
// its `userId`, so it stays assignable and chainable. Only an agent the org
// made itself (a row with no seedSlug) is the workspace's own.
//
// Pure: no state, no element. The relative order inside each group is kept.
const $407930539ab9ab05$export$5b34672c42115cef = (agents)=>{
    const list = Array.isArray(agents) ? agents : [];
    const own = [];
    const platform = [];
    for (const a of list){
        if (!a || typeof a !== 'object') continue;
        const seeded = a.seedSlug != null && a.seedSlug !== '';
        if (a.userId != null && a.userId !== '' && !seeded) own.push(a.platform ? {
            ...a,
            platform: false
        } : a);
        else platform.push(a.platform === true ? a : {
            ...a,
            platform: true
        });
    }
    return own.concat(platform);
};
const $407930539ab9ab05$export$5ea75ac58d82f1be = (agents)=>Array.isArray(agents) && agents.length > 0 && agents.every((a)=>a && typeof a === 'object' && typeof a.caption === 'string' && !!a.caption);
const $407930539ab9ab05$export$c5ff97cd96a255b9 = (agents)=>(Array.isArray(agents) ? agents : []).filter((a)=>a && a.platform === true);

});

parcelRegister("6ocCI", function(module, exports) {

$parcel$export(module.exports, "GROUP_SLOTS", () => $4a6ec6ba8d2abe2f$export$86d90d5fe4fb787a);
$parcel$export(module.exports, "nextFreeSlot", () => $4a6ec6ba8d2abe2f$export$b2150b4386ff36b3);
$parcel$export(module.exports, "slotOf", () => $4a6ec6ba8d2abe2f$export$237466b926e29c8d);
$parcel$export(module.exports, "membersOfSlot", () => $4a6ec6ba8d2abe2f$export$3187749880e1511f);
$parcel$export(module.exports, "bboxOfMembers", () => $4a6ec6ba8d2abe2f$export$a0049f7159d1961e);
$parcel$export(module.exports, "restackSlot", () => $4a6ec6ba8d2abe2f$export$42bab81130d4f159);
// Slot-map grouping core — the generic primitives behind the
// "studios-style" canvas grouping (flat `{ [nodeId]: 'groupN' }` map +
// `{ [slot]: label }` names), shared by /studio (studios.js) and
// /team-and-agents (team-and-agents.js). Extracted 2026-06-06 per
// Nika ("reuse grouping functionality from /studio") — both pages
// previously carried byte-similar copies of these.
//
// Pages keep their own thin wrappers for page-specific concerns
// (state key names, member ordering, label fallbacks, drag-exclusion
// sets); everything here is shape-agnostic: a slot map is a plain
// object, positions are `{ [id]: { x, y, w, h } }`.
const $4a6ec6ba8d2abe2f$export$86d90d5fe4fb787a = Array.from({
    length: 50
}, (_, i)=>'group' + (i + 1));
const $4a6ec6ba8d2abe2f$export$b2150b4386ff36b3 = (map)=>{
    const used = new Set(Object.values(map || {}));
    for (const slot of $4a6ec6ba8d2abe2f$export$86d90d5fe4fb787a)if (!used.has(slot)) return slot;
    return 'group' + Date.now();
};
const $4a6ec6ba8d2abe2f$export$237466b926e29c8d = (map, nodeId)=>(map || {})[nodeId] || null;
const $4a6ec6ba8d2abe2f$export$3187749880e1511f = (map, slot)=>{
    const out = [];
    for (const [id, s] of Object.entries(map || {}))if (s === slot) out.push(id);
    return out;
};
const $4a6ec6ba8d2abe2f$export$a0049f7159d1961e = (memberIds, positions, { exclude: exclude } = {})=>{
    const items = [];
    for (const id of memberIds || []){
        if (exclude && exclude.has(id)) continue;
        const p = positions?.[id];
        if (p) items.push(p);
    }
    if (!items.length) return null;
    const minX = Math.min(...items.map((p)=>p.x));
    const minY = Math.min(...items.map((p)=>p.y));
    const maxX = Math.max(...items.map((p)=>p.x + (p.w || 0)));
    const maxY = Math.max(...items.map((p)=>p.y + (p.h || 0)));
    return {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY
    };
};
const $4a6ec6ba8d2abe2f$export$42bab81130d4f159 = (memberIds, positions, { perRow: perRow, colStride: colStride, rowStride: rowStride })=>{
    const next = {
        ...positions
    };
    const members = (memberIds || []).filter((id)=>next[id]);
    if (!members.length) return next;
    const minX = Math.min(...members.map((id)=>next[id].x));
    const minY = Math.min(...members.map((id)=>next[id].y));
    members.forEach((id, i)=>{
        const col = i % perRow;
        const row = Math.floor(i / perRow);
        next[id] = {
            ...next[id],
            x: minX + col * colStride,
            y: minY + row * rowStride
        };
    });
    return next;
};

});

parcelRegister("kcLMl", function(module, exports) {

$parcel$export(module.exports, "canvasResolveClaims", () => $eb59fd7dc35c4c0f$export$fa11aed9f846ae31);
// Capstone GATE A (supabase-mongo-auth-capstone.md §3) — canvas-local mirror
// of `workspace/packages/workspace/functions/claimResolver.js`, for the
// team-and-agents `_viewerTier` gate.
//
// WHY a local copy instead of importing
// `workspace/packages/workspace/functions/claimResolver.js`: this file lives
// in `packages/canvas` — a sibling consumer package that cannot reach into
// `packages/workspace/functions/*` without inverting the dependency
// direction. That is the exact cross-package barrier already documented at
// `agentAssignments.js:57`. So this is a tiny, self-contained reader that
// mirrors the workspace resolver's shape.
//
// Mongo-sourced: `is_owner` / `permissions` are sourced from the active-org
// row (`root.org`), server-enriched by `/auth/me` (org.isOwner /
// org.permissions), falling back to whatever's already on `root.jwtClaims`
// when that enrichment is absent. Was flag-gated behind
// `__USE_MONGO_CLAIMS__` during the Gate A cutover (2026-07-03); collapsed to
// Mongo-only 2026-07-31 — the governance JWT read-dependency (the flag's OFF
// branch) had no live data source since the server stopped minting
// `app_metadata` claims on 2026-07-28.
//
// SCOPE NOTE: the canvas tier reads only `is_owner` + `permissions`, so only
// those two are re-sourced here (every other claim field is preserved via the
// spread). The workspace resolver additionally derives `org_role` /
// `symbols_role` and re-computes the full permission union
// (`_unionPermissions`) on the unenriched fallback path. This mirror
// deliberately does NOT triplicate that permission model — when `root.org` is
// server-enriched (the common path) the two resolvers are identical; when it
// is not, this side falls back to the current jwtClaims permissions rather
// than re-deriving the union in a third location.
// Active-org row — mirrors the workspace resolver's `_activeOrg`: prefer
// `root.org` (populated by subscribeAuthSession / the `/auth/me` scope fetch),
// else look up `workspace_org_id` in `root.orgs`, else the first org.
const $eb59fd7dc35c4c0f$var$_activeOrg = (root)=>{
    if (!root) return null;
    if (root.org) return root.org;
    const activeId = root.jwtClaims?.workspace_org_id;
    const orgs = Array.isArray(root.orgs) ? root.orgs : [];
    return activeId && orgs.find((o)=>o && o.id === activeId) || orgs[0] || null;
};
const $eb59fd7dc35c4c0f$export$fa11aed9f846ae31 = (root)=>{
    const base = root && root.jwtClaims || {};
    const org = $eb59fd7dc35c4c0f$var$_activeOrg(root);
    const isOwner = org && typeof org.isOwner === 'boolean' ? org.isOwner : !!base.is_owner;
    let permissions;
    if (org && Array.isArray(org.permissions)) permissions = org.permissions;
    else if (org && Array.isArray(org.intranetPermissions)) permissions = org.intranetPermissions;
    else permissions = Array.isArray(base.permissions) ? base.permissions : [];
    return {
        ...base,
        is_owner: isOwner,
        permissions: permissions
    };
};

});

parcelRegister("lHfYz", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("g2nYi"))) : import("g2nYi")).then(()=>parcelRequire('e88sQ'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("1E8ax", function(module, exports) {

$parcel$export(module.exports, "CanvasProjectsView", () => $132fdd0bd06d2892$export$3883c5199481ee80);
$parcel$export(module.exports, "CanvasProjectsCard", () => $132fdd0bd06d2892$export$3ca1bcdf737a89ed);
$parcel$export(module.exports, "CanvasProjectsCardAction", () => $132fdd0bd06d2892$export$1c32b87c19fd82d7);
// THE WORKSPACE'S PROJECTS IN AN AI ANSWER — the `canvas-projects` view
// (functions/canvasAnswer.js canvasAiViews; the shell mounts it in the
// assistant's thread and on a Fly page with scope { params, embedded }).
// Read-only: the shared ProjectCard grid the home Projects widget and /studio
// draw. A card opens the project's LIVE PREVIEW (the sheet; ⌘ / Ctrl: a
// split), never the canvas origin; its row of actions (CanvasProjectsCard)
// opens the preview, the canvas or the analytics; its "Open in Websites"
// shortcut the Websites board. Its projects live in its OWN state, read once
// per params. While reading: three card stand-ins; none, or a failed read:
// one sentence.
const $132fdd0bd06d2892$export$3883c5199481ee80 = {
    flow: 'y',
    gap: 'A',
    minWidth: '0',
    dataCanvasProjects: true,
    state: {
        projects: null,
        total: 0,
        failed: false
    },
    // EMPTY (the views contract, workspace functions/assistantAppViews.js): the
    // read answered with no project — the one sentence is all the view shows,
    // and a Fly page gives its card one row. null while reading.
    empty: (el, s)=>Array.isArray(s.projects) ? s.projects.length === 0 : null,
    onRender: (el)=>el.call('canvasAnswerLoad', el),
    CanvasProjectsSkeleton: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-F2)), 1fr))',
        gap: 'A',
        ariaBusy: 'true',
        hide: (el, s)=>Array.isArray(s.projects),
        Skeleton_1: {
            height: 'E',
            round: 'radiusControl'
        },
        Skeleton_2: {
            height: 'E',
            round: 'radiusControl'
        },
        Skeleton_3: {
            height: 'E',
            round: 'radiusControl'
        }
    },
    CanvasProjectsNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!Array.isArray(s.projects) || s.projects.length > 0,
        text: (el, s)=>{
            s.root.lang;
            return el.call('polyglot', s.failed ? 'canvas.answer.failed' : 'canvas.answer.empty');
        }
    },
    CanvasProjectsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-F2)), 1fr))',
        gap: 'A',
        minWidth: '0',
        hide: (el, s)=>!Array.isArray(s.projects) || !s.projects.length,
        childExtends: 'CanvasProjectsCard',
        childrenAs: 'state',
        children: (el, s)=>Array.isArray(s.projects) ? s.projects : []
    },
    // The newest N of more: says so, never a silent cut — and nothing at all for
    // an empty view (one rule, functions/canvasAnswer.js canvasAnswerMoreText).
    CanvasProjectsMore: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!el.call('canvasAnswerMoreText', s),
        text: (el, s)=>{
            s.root.lang;
            return el.call('canvasAnswerMoreText', s);
        }
    }
};
const $132fdd0bd06d2892$export$3ca1bcdf737a89ed = {
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    ProjectCard: {
        ariaLabel: (el, s)=>{
            s.root.lang;
            return String(el.call('polyglot', 'canvas.answer.action.previewOf')).replace('{name}', ()=>s.name || s.key || '');
        },
        onClick: (e, el, s)=>{
            // The Studio button stops its own click; the guard is the base card's.
            if (e.target?.closest?.('[data-studio-btn]')) return;
            el.call('canvasAnswerOpen', s, 'preview', e);
        }
    },
    CanvasProjectsCardActions: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        minWidth: '0',
        childExtends: 'CanvasProjectsCardAction',
        // Keys that name no HTML tag and no registered component (`Canvas` would
        // be both).
        OpenPreview: {
            icon: 'eye',
            openAs: 'preview',
            labelKey: 'canvas.answer.action.preview'
        },
        OpenCanvas: {
            icon: 'layers',
            openAs: 'canvas',
            labelKey: 'canvas.answer.action.canvas'
        },
        OpenAnalytics: {
            icon: 'analytics',
            openAs: 'analytics',
            labelKey: 'canvas.answer.action.analytics'
        }
    }
};
const $132fdd0bd06d2892$export$1c32b87c19fd82d7 = {
    extends: 'CompactIconButton',
    ariaLabel: (el, s)=>{
        s.root.lang;
        return String(el.call('polyglot', el.labelKey || '')).replace('{name}', ()=>s.name || s.key || '');
    },
    title: (el, s)=>{
        s.root.lang;
        return String(el.call('polyglot', el.labelKey || '')).replace('{name}', ()=>s.name || s.key || '');
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('canvasAnswerOpen', s, el.openAs, e);
    }
};

});

parcelRegister("eAUrL", function(module, exports) {

$parcel$export(module.exports, "ProjectStatusView", () => $aa0036aa71c2e5ad$export$ba6daa8bc75dfd97);
$parcel$export(module.exports, "ProjectStatusSiteRow", () => $aa0036aa71c2e5ad$export$ca6ebc6b26a661ff);
$parcel$export(module.exports, "ProjectStatusRow", () => $aa0036aa71c2e5ad$export$563bde8f18689963);
// THE WEBSITES' STATE IN AN AI ANSWER — the `project-status` view
// (functions/canvasAnswer.js canvasAiViews, functions/canvasStatus.js; the
// shell mounts it in the assistant's thread and on a Fly page with scope
// { params, embedded }). Read-only. EVERY website (no project named and no
// website on screen: more than one website, or a project on screen that is
// not a website, an app canvas, whose only website never stands in for it):
// one row per site, its name and its production state chip (the house status
// chip — live, never published, not available); a row opens the site in the
// card, Back returns. ONE website (a project named, the website on screen,
// or, with nothing on screen, the workspace's only website): the site and
// whether a visitor gets it, what each environment serves, the newest
// versions. No publish control: a change is the page's "Do it". While
// reading: three row stand-ins; no such site, or no website at all: one
// sentence — for a name that is a project of the workspace but not a
// website, or an App Store app that is no project here, the sentence says so
// with its name.
const $aa0036aa71c2e5ad$export$ba6daa8bc75dfd97 = {
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    height: '100%',
    minHeight: '0',
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    dataProjectStatus: true,
    state: {
        site: null,
        sites: null,
        total: 0,
        pick: null,
        live: null,
        envs: null,
        versions: null,
        failed: false,
        none: false,
        // The asked name when it is no website (functions/canvasAnswer.js
        // canvasAnswerNamed): a project of this workspace that is not a website
        // (an app, a module, a library), or an App Store app that is no project
        // here.
        notWebsite: null,
        storeApp: null
    },
    // EMPTY (the views contract, workspace functions/assistantAppViews.js): no
    // such site, or no website at all — the one sentence is all the view shows.
    empty: (el, s)=>s.failed ? true : s.site || Array.isArray(s.sites) ? false : null,
    // RESOLVED PARAMS (the views contract, workspace functions/
    // assistantAppViews.js): the site the card SHOWS — a Fly page's next ask
    // carries it, so a follow-up stays on this site. null while reading and
    // while the list of every website shows (no one site is picked).
    resolvedParams: (el, s)=>s.site ? {
            project: s.site.key
        } : null,
    onRender: (el)=>el.call('canvasStatusLoad', el),
    // The installed apps decide which projects are websites, and the project
    // list can land after the view (a page restored at boot): the read runs
    // again when either changes — its own signature keeps it to once per list.
    // The App Store list can land after the view too: when it (or the project
    // list) changes what the asked name means, the read runs again
    // (canvasAnswerNamedMoved).
    subscribeTo: [
        'workspaceApps',
        '_projectsForActiveOrg',
        '_wsAppsCatalog'
    ],
    onUpdate: (el)=>el.call('canvasStatusLoad', el),
    ProjectStatusSkeleton: {
        flow: 'y',
        gap: 'Z',
        ariaBusy: 'true',
        hide: (el, s)=>!!s.site || !!s.failed || Array.isArray(s.sites),
        Skeleton_1: {
            width: '60%',
            height: 'B',
            round: 'radiusControl'
        },
        Skeleton_2: {
            height: 'C',
            round: 'radiusControl'
        },
        Skeleton_3: {
            height: 'C',
            round: 'radiusControl'
        }
    },
    ProjectStatusNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!s.failed,
        text: (el, s)=>{
            s.root.lang;
            if (s.notWebsite) return String(el.call('polyglot', 'canvas.status.notWebsite')).replace('{name}', ()=>s.notWebsite);
            if (s.storeApp) return String(el.call('polyglot', 'canvas.status.storeApp')).replace('{name}', ()=>s.storeApp);
            return el.call('polyglot', s.none ? 'canvas.status.none' : 'canvas.status.missing');
        }
    },
    ProjectStatusHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>!s.site,
        ProjectStatusTitle: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            // Back to every website — only when a row of the list opened this one.
            CompactIconButton: {
                icon: 'arrowLeft',
                hide: (el, s)=>!s.pick,
                ariaLabel: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'canvas.status.back');
                },
                title: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'canvas.status.back');
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('canvasStatusPick', el, null);
                }
            },
            ProjectStatusName: {
                tag: 'h4',
                margin: '0',
                minWidth: '0',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.site ? s.site.name : ''
            }
        },
        // "Is our site live?" — what a visitor of the production site gets: the
        // house status chip, its state the answer (a new answer is a new chip;
        // the live region around it is there before it changes).
        ProjectStatusLive: {
            flexShrink: '0',
            role: 'status',
            childExtends: 'AppStatusChip',
            childrenAs: 'state',
            children: (el, s)=>{
                const live = s.live || {
                    status: null,
                    label: 'canvas.status.live.checking'
                };
                return [
                    {
                        key: 'live-' + String(live.label).split('.').pop(),
                        status: live.status,
                        label: live.label
                    }
                ];
            }
        }
    },
    // EVERY WEBSITE: one row per site — its name and its production state.
    ProjectStatusSites: {
        tag: 'ul',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        gap: 'X',
        hide: (el, s)=>!!s.site || !Array.isArray(s.sites) || !s.sites.length,
        childrenAs: 'state',
        childExtends: 'ProjectStatusSiteRow',
        children: (el, s)=>(Array.isArray(s.sites) ? s.sites : []).map((r)=>({
                    key: 'site-' + r.key,
                    siteKey: r.key,
                    name: r.name,
                    live: r.live
                }))
    },
    // The first SITES_MAX of more: says so, never a silent cut.
    ProjectStatusMore: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!!s.site || !Array.isArray(s.sites) || !(s.total > s.sites.length),
        text: (el, s)=>{
            s.root.lang;
            return String(el.call('polyglot', 'canvas.status.more')).replace('{n}', String(Array.isArray(s.sites) ? s.sites.length : 0)).replace('{total}', String(s.total || 0));
        }
    },
    ProjectStatusEnvs: {
        tag: 'ul',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        gap: 'X',
        hide: (el, s)=>!s.site || !Array.isArray(s.envs),
        childrenAs: 'state',
        childExtends: 'ProjectStatusRow',
        childProps: {
            tag: 'li'
        },
        children: (el, s)=>(Array.isArray(s.envs) ? s.envs : []).map((e)=>({
                    key: 'env-' + e.key,
                    title: e.label,
                    meta: e.serves,
                    value: e.value,
                    on: e.on
                }))
    },
    ProjectStatusVersionsTitle: {
        tag: 'h5',
        margin: 'Z 0 0',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'caption',
        hide: (el, s)=>!s.site || !Array.isArray(s.versions) || !s.versions.length,
        text: '{{ canvas.status.versions | polyglot }}'
    },
    ProjectStatusVersions: {
        tag: 'ul',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        gap: 'X',
        hide: (el, s)=>!s.site || !Array.isArray(s.versions) || !s.versions.length,
        childrenAs: 'state',
        childExtends: 'ProjectStatusRow',
        childProps: {
            tag: 'li'
        },
        children: (el, s)=>(Array.isArray(s.versions) ? s.versions : []).map((v)=>({
                    key: v.key,
                    title: v.message || v.value,
                    meta: [
                        v.value,
                        v.author,
                        v.at ? el.call('timeAgo', v.at) : ''
                    ].filter(Boolean).join(" \xb7 "),
                    value: '',
                    on: true
                }))
    }
};
const $aa0036aa71c2e5ad$export$ca6ebc6b26a661ff = {
    tag: 'li',
    ProjectStatusSiteOpen: {
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        width: '100%',
        minWidth: '0',
        padding: 'Y Z',
        border: 'none',
        round: 'radiusControl',
        background: 'overlay',
        color: 'title',
        fontSize: 'Z',
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'background-color A defaultBezier',
        ':hover': {
            background: 'hover'
        },
        ':active': {
            background: 'selected'
        },
        ariaLabel: (el, s)=>{
            s.root.lang;
            return String(el.call('polyglot', 'canvas.status.openSite')).replace('{name}', ()=>s.name || '');
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('canvasStatusPick', el, s.siteKey);
        },
        ProjectStatusSiteName: {
            tag: 'span',
            minWidth: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || ''
        },
        ProjectStatusSiteLive: {
            flexShrink: '0',
            childExtends: 'AppStatusChip',
            childrenAs: 'state',
            children: (el, s)=>{
                const live = s.live || {
                    status: null,
                    label: 'canvas.status.live.checking'
                };
                return [
                    {
                        key: 'live-' + String(live.label).split('.').pop(),
                        status: live.status,
                        label: live.label
                    }
                ];
            }
        }
    }
};
const $aa0036aa71c2e5ad$export$563bde8f18689963 = {
    flow: 'x',
    align: 'baseline space-between',
    gap: 'Z',
    minWidth: '0',
    padding: 'Y Z',
    round: 'radiusControl',
    background: 'overlay',
    fontSize: 'Z',
    isOff: (el, s)=>s.on === false,
    '.isOff': {
        opacity: '0.6'
    },
    ProjectStatusRowTitle: {
        tag: 'span',
        minWidth: '0',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>{
            s.root.lang;
            return el.call('polyglot', s.title || '');
        }
    },
    ProjectStatusRowMeta: {
        tag: 'span',
        flexShrink: '0',
        maxWidth: '60%',
        color: 'caption',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>{
            s.root.lang;
            return String(el.call('polyglot', s.meta || '')).replace('{value}', ()=>s.value || '');
        }
    }
};

});


parcelRegister("QSYGF", function(module, exports) {

$parcel$export(module.exports, "histInit", () => (parcelRequire("5ApZL")).histInit);
$parcel$export(module.exports, "histCurrent", () => (parcelRequire("5ApZL")).histCurrent);
$parcel$export(module.exports, "histRecord", () => (parcelRequire("5ApZL")).histRecord);
$parcel$export(module.exports, "histCanBack", () => (parcelRequire("5ApZL")).histCanBack);
$parcel$export(module.exports, "histCanForward", () => (parcelRequire("5ApZL")).histCanForward);
$parcel$export(module.exports, "histBack", () => (parcelRequire("5ApZL")).histBack);
$parcel$export(module.exports, "histForward", () => (parcelRequire("5ApZL")).histForward);
// Eager slim slice of the canvas function barrel (#15). See
// components/eagerSlice.js for the full rationale — same carve: the shell
// imports this instead of `../canvas/functions/index.js` so the heavy
// canvas-editor function graph stays out of the eager chunk.
//
// Each source file below is light (no CanvasEditor/Scene/Monaco imports) and is
// `export *`-ed from source, never through `./index.js` (which fans out to the
// whole editor). Because canvas has no `sideEffects: false`, referencing any
// export of a source file bundles that whole (small) module regardless, so
// `export *` costs no more than a named re-export while re-exposing a strict
// superset of the keys the eager routes need — minimising the "missing key
// silently breaks a bare-key extends/child" risk.
//
// Required keys and their source files:
//   toggleSidebars, getSelectionAiContext                          → projectCanvasSidebar.js
//   renderAnswerUi                                                 → answerUi.js
//   injectPageInApp                                                → injectPageInApp.js
//   parseFreestyleSource                                           → freestyle.js
//   initPanzoomBoard                                               → initPanzoomBoard.js
//   registerCanvasPanzoom, unregisterCanvasPanzoom                 → registerCanvasPanzoom.js
//   bboxOfNodeIds, bezierBetweenNodes                              → sharedGeom.js
//   tagNodeContextmenu, tagNodeContextItems, tagNodeContextAction  → tagContextMenu.js
//   isCanvasV2                                                     → canvas/state.js
//   confirmTeamLeave, runTeamLeave                                 → teamLeave.js
//   confirmAgentUnassign                                           → agentUnassign.js
//
// tagNodeContextItems + tagNodeContextAction are string-dispatched through
// `root.contextDropdown` in tagContextMenu.js (invisible to static analysis but
// required by the /team-and-agents + /agents node context menu).

var $fQTxe = parcelRequire("fQTxe");

var $gmD43 = parcelRequire("gmD43");

var $Oq65v = parcelRequire("Oq65v");

var $7niY9 = parcelRequire("7niY9");

var $3o5o3 = parcelRequire("3o5o3");

var $3Tdk0 = parcelRequire("3Tdk0");

var $5L6sk = parcelRequire("5L6sk");

var $9dqhI = parcelRequire("9dqhI");

var $8RRzz = parcelRequire("8RRzz");

var $dctxD = parcelRequire("dctxD");

var $aChNU = parcelRequire("aChNU");

var $gYZyC = parcelRequire("gYZyC");

var $d2hlu = parcelRequire("d2hlu");

var $18kiP = parcelRequire("18kiP");

var $gHwNh = parcelRequire("gHwNh");

var $3HSmu = parcelRequire("3HSmu");

var $f7G7i = parcelRequire("f7G7i");

var $5ApZL = parcelRequire("5ApZL");
$parcel$exportWildcard(module.exports, $fQTxe);
$parcel$exportWildcard(module.exports, $gmD43);
$parcel$exportWildcard(module.exports, $Oq65v);
$parcel$exportWildcard(module.exports, $7niY9);
$parcel$exportWildcard(module.exports, $3o5o3);
$parcel$exportWildcard(module.exports, $3Tdk0);
$parcel$exportWildcard(module.exports, $5L6sk);
$parcel$exportWildcard(module.exports, $9dqhI);
$parcel$exportWildcard(module.exports, $8RRzz);
$parcel$exportWildcard(module.exports, $dctxD);
$parcel$exportWildcard(module.exports, $aChNU);
$parcel$exportWildcard(module.exports, $gYZyC);
$parcel$exportWildcard(module.exports, $d2hlu);
$parcel$exportWildcard(module.exports, $18kiP);
$parcel$exportWildcard(module.exports, $gHwNh);
$parcel$exportWildcard(module.exports, $3HSmu);
$parcel$exportWildcard(module.exports, $f7G7i);

});
parcelRegister("fQTxe", function(module, exports) {

$parcel$export(module.exports, "setCanvasFilter", () => $b8a6ca6b552220ee$export$12c261402b13b80b);
$parcel$export(module.exports, "switchCanvasEnv", () => $b8a6ca6b552220ee$export$a72d9b66e01bb0dc);
$parcel$export(module.exports, "openProjectLive", () => $b8a6ca6b552220ee$export$1d1ebe8db14f0f53);
$parcel$export(module.exports, "openProjectPreviewPane", () => $b8a6ca6b552220ee$export$426e277238d311fe);
$parcel$export(module.exports, "openProjectPreview", () => $b8a6ca6b552220ee$export$c0742014b7714cc5);
$parcel$export(module.exports, "toggleSidebars", () => $b8a6ca6b552220ee$export$d5ea87ee66039aa6);
$parcel$export(module.exports, "canvasPagesGroupRows", () => $b8a6ca6b552220ee$export$ebc4b486754a9e86);
$parcel$export(module.exports, "focusProjectPage", () => $b8a6ca6b552220ee$export$4d87f48c3618637f);
$parcel$export(module.exports, "buildSelectionContext", () => $b8a6ca6b552220ee$export$a53baadd87106ed5);
$parcel$export(module.exports, "getSelectionAiContext", () => $b8a6ca6b552220ee$export$e733bac9aa4eacfe);
// Project-canvas left rail actions (ProjectCanvasSidebar) — filter the canvas
// items, switch the active environment, and open the project live / preview.
// Modeled on the /infra sidebar's infraSetFilter / infraSwitchEnv helpers.
// (2026-06-17 per Nika "similar sidebar as we have on /infra on project canvas
// page, where we can filter stuff, switch environments, publish button etc".)
// Bare shared-library import, not per-file deep functions/*.js subpaths — a
// per-file deep specifier into @symbo-ls/workspace-shared cannot resolve
// through the platform's public importmap (tickets/execution-board.md §1,
// same fix as workspace/app.js). Deferred call wrappers, not a module-scope
// destructure, per the a5d0a2aa barrel-cycle lesson.

var $1X0Je = parcelRequire("1X0Je");
const $b8a6ca6b552220ee$var$buildProjectUrls = (...args)=>(0, $1X0Je.default).functions.buildProjectUrls(...args);
const $b8a6ca6b552220ee$var$_canvasRoot = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || null;
// owner/key from the /:owner/:key route (the canvas project path).
const $b8a6ca6b552220ee$var$_canvasOwnerKey = ()=>{
    const segs = (typeof window !== 'undefined' ? window.location.pathname : '').split('/').filter(Boolean);
    return {
        owner: segs[0],
        key: segs[1]
    };
};
function $b8a6ca6b552220ee$export$12c261402b13b80b(filter) {
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    if (!root) return;
    root.update({
        _canvasFilter: filter || 'all'
    });
    // Re-draw screen-space chrome (item titles, selection box) so it hides for the
    // now-filtered-out items. CvItems re-renders via its own subscribeTo.
    if (this.call) this.call('refreshCanvasChrome');
}
function $b8a6ca6b552220ee$export$a72d9b66e01bb0dc(env) {
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    if (!root) return;
    root.update({
        _canvasEnv: env || 'production'
    });
}
function $b8a6ca6b552220ee$export$1d1ebe8db14f0f53() {
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    const { owner: owner, key: key } = $b8a6ca6b552220ee$var$_canvasOwnerKey();
    if (!owner || !key) return;
    const env = root?._canvasEnv || 'production';
    const urls = $b8a6ca6b552220ee$var$buildProjectUrls(owner, key, env);
    const url = env === 'staging' ? urls?.directStaging : env === 'development' ? urls?.directDev : urls?.directProd;
    if (url && typeof window !== 'undefined') window.open(url, '_blank', 'noopener');
}
function $b8a6ca6b552220ee$export$426e277238d311fe() {
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    if (!root) return;
    const cur = (root._canvasSlot || '').split('?')[0];
    root.update({
        _canvasSlot: cur === '/preview' ? null : '/preview'
    });
}
function $b8a6ca6b552220ee$export$c0742014b7714cc5() {
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    const { owner: owner, key: key } = $b8a6ca6b552220ee$var$_canvasOwnerKey();
    if (!owner || !key) return;
    const env = root?._canvasEnv || 'production';
    const urls = $b8a6ca6b552220ee$var$buildProjectUrls(owner, key, env);
    if (urls?.preview && typeof window !== 'undefined') window.open(urls.preview, '_blank', 'noopener');
}
function $b8a6ca6b552220ee$export$d5ea87ee66039aa6() {
    const fns = this && this.context && this.context.functions || {};
    if (typeof fns.pageSidebarToggle !== 'function') return null;
    return this.call('pageSidebarToggle');
}
// ── PAGES group: the board pages AND the project's own pages ───────────────
// Nika 2026-10-31 — "Yes, separate lane (Recommended)" to "Must the PAGES group
// also show the project pages?" — after W4 on dev (2026-10-30): the AI added a
// page to Velvet Lantern, its tile landed on the board, and PAGES still listed
// only "Page 1". The group lists the Figma-style board pages (Nika 2026-08-01)
// and, under each, the project pages (the site routes in `root.data.pages`)
// whose tiles that board page holds.
//
// A project page's tile is the board item whose KEY is the route — the one
// identity syncCanvasItemsFromPages, the "Pages" filter and the on-board tile
// titles already use (a duplicate is a different key and lists nowhere). Key
// tests use `in`, as those readers do: `root.data` is a state store, and `in`
// is the membership test its contract names.
// The board page that holds a project page's tile: the ACTIVE page's live
// `items` first (its `pageItems` snapshot is stale while it is open), then each
// parked page in board order. '' = the tile is on no board page.
const $b8a6ca6b552220ee$var$_projectPageHolderId = (v2, route)=>{
    const boardPages = Array.isArray(v2.pages) ? v2.pages : [];
    const active = boardPages.some((p)=>p.id === v2.activePageId) ? v2.activePageId : '';
    if (active && v2.items && route in v2.items) return active;
    const parked = v2.pageItems || {};
    for (const p of boardPages){
        if (p.id === active) continue;
        const items = parked[p.id] && parked[p.id].items;
        if (items && route in items) return p.id;
    }
    return '';
};
function $b8a6ca6b552220ee$export$ebc4b486754a9e86() {
    const v2 = this.call && this.call('getCanvasV2') || {};
    const boardPages = Array.isArray(v2.pages) ? v2.pages : [];
    // No board page yet = the board is not initialised (a board always keeps one
    // page once it is): there is no board to hold or show a tile, so list nothing.
    if (!boardPages.length) return [];
    const active = v2.activePageId;
    const primary = v2.selection && v2.selection.primary || null;
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    const routes = Object.keys(root && root.data && root.data.pages || {});
    const held = {};
    for (const route of routes){
        const holder = $b8a6ca6b552220ee$var$_projectPageHolderId(v2, route);
        if (!held[holder]) held[holder] = [];
        held[holder].push(route);
    }
    // A project page row highlights while its tile is the primary selection,
    // which only the open board page has.
    const projectPageRow = (route, holder)=>({
            key: 'route:' + route,
            id: 'route:' + route,
            name: route,
            _active: !!holder && holder === active && route === primary,
            _isAdd: false,
            _route: route,
            _nested: !!holder
        });
    const rows = [];
    for (const p of boardPages){
        rows.push({
            key: p.id,
            id: p.id,
            name: p.name || '',
            _active: p.id === active,
            _isAdd: false,
            _route: '',
            _nested: false
        });
        for (const route of held[p.id] || [])rows.push(projectPageRow(route, p.id));
    }
    for (const route of held[''] || [])rows.push(projectPageRow(route, ''));
    return rows;
}
function $b8a6ca6b552220ee$export$4d87f48c3618637f(route) {
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    const pages = root && root.data && root.data.pages;
    if (!route || !pages || !(route in pages)) return false;
    const v2 = this.call('getCanvasV2');
    if (!v2) return false;
    const holder = $b8a6ca6b552220ee$var$_projectPageHolderId(v2, route);
    if (!holder) this.call('syncCanvasItemsFromPages');
    else if (holder !== v2.activePageId) this.call('switchBoardPage', holder);
    const filter = root._canvasFilter || 'all';
    if (filter !== 'all' && filter !== 'pages') this.call('setCanvasFilter', 'all');
    return this.call('focusCanvasEntity', route) === true;
}
// ── Selection-aware AI prompting (2026-08-08 per Nika "ai should understand
// selected artboards") ──
//
// buildSelectionContext(v2, data) — PURE, side-effect-free. Resolves the
// canvas v2 selection (`v2.selection.ids`) against a `{ pages, components }`
// map into the shape the shell composer's send threads through (a compact
// "Selected artboards: …" text prefix + the structured `attached` payload —
// workspace app.js CanvasPromptTextarea → homeAiSend). Returns the exact
// byte-identical OFF-state (`{ selectedItems: [], promptPrefix: '' }`) when
// there's no v2 or nothing selected — every call site below relies on that
// to keep the no-selection path untouched.
//
// `title` mirrors the ONE existing "item title" convention in this codebase
// (refreshCanvasChromeNow's CvItemTitles labels, functions/canvas/state.js):
// a real page/component key has no separate title field anywhere in the
// project schema (page/component defs are bare DOMQL objects), so the key
// IS the title — except the built-in `__ds/<route>` design-system frames,
// which get the same friendly "Design system · Colors" label those on-canvas
// titles already use. `type` is deliberately the 'page'|'component' union
// the ticket asks for (not a 3rd 'ds' bucket) — a selected design-system tile
// falls back to 'component', the closest bucket, same default direction
// CanvasSurface's own `cvType` resolution uses for "other" keys.
const $b8a6ca6b552220ee$var$_DS_PREFIX = '__ds/';
const $b8a6ca6b552220ee$var$_ENTITY_PREFIX = 'ref:';
// Caps from spec §3.8. A board can hold hundreds of nodes; a turn prompt
// cannot. Truncation is deterministic (board order, then the connections whose
// BOTH endpoints survived) so the same board always attaches the same slice.
const $b8a6ca6b552220ee$var$_ATTACH_MAX_NODES = 60;
const $b8a6ca6b552220ee$var$_ATTACH_MAX_CONNECTIONS = 120;
// The ATTACHED canvas payload (spec §3.8) — PURE, built from the same
// (v2, data) pair as the selection below.
//
// Scope: the SELECTED entity items when the selection contains any, else the
// WHOLE active board. Returns null when the board carries no entity node at
// all, which is what keeps both results below byte-identical for every
// page/component board — i.e. every board that existed before entity nodes.
const $b8a6ca6b552220ee$var$_attachedCanvas = (v2, data, ids)=>{
    const items = v2 && v2.items || {};
    const entities = data && data.entities || v2 && v2.entities || {};
    const isEntity = (k)=>typeof k === 'string' && k.indexOf($b8a6ca6b552220ee$var$_ENTITY_PREFIX) === 0;
    const selected = (ids || []).filter(isEntity);
    const pool = selected.length ? selected : Object.keys(items).filter(isEntity);
    if (!pool.length) return null;
    const keys = pool.slice(0, $b8a6ca6b552220ee$var$_ATTACH_MAX_NODES);
    const inSet = new Set(keys);
    // The ref string IS the key. The fields come from the resolve cache when a
    // card has already loaded that node and degrade to the bare ref when it has
    // not — a half-resolved board must still attach something usable.
    const nodes = keys.map((key)=>{
        const d = entities[key] && entities[key].data || {};
        return {
            key: key,
            ref: key,
            title: d.title || key,
            kind: d.kind || '',
            status: d.status || '',
            effectiveDate: d.effectiveDate || '',
            summary: d.summary || ''
        };
    });
    const connections = [];
    for (const c of v2 && v2.connections || []){
        if (connections.length >= $b8a6ca6b552220ee$var$_ATTACH_MAX_CONNECTIONS) break;
        if (!inSet.has(c.from) || !inSet.has(c.to)) continue;
        connections.push({
            from: c.from,
            to: c.to,
            kind: c.kind || '',
            label: c.label || ''
        });
    }
    const boardPageId = v2 && v2.activePageId || '';
    const page = (v2 && Array.isArray(v2.pages) && v2.pages || []).find((p)=>p.id === boardPageId);
    return {
        canvas: {
            projectId: data && data.projectId || '',
            boardPageId: boardPageId,
            title: page && page.name || '',
            nodes: nodes,
            connections: connections
        }
    };
};
function $b8a6ca6b552220ee$export$a53baadd87106ed5(v2, data) {
    const ids = v2 && v2.selection && Array.isArray(v2.selection.ids) && v2.selection.ids || [];
    // `attached` is ADDITIVE and only ever present when the board actually holds
    // entity nodes — so both the no-selection off-state and the page/component
    // selection result stay byte-identical to what every existing call site (and
    // __tests__/buildSelectionContext.test.js) asserts.
    const attached = $b8a6ca6b552220ee$var$_attachedCanvas(v2, data, ids);
    if (!ids.length) return attached ? {
        selectedItems: [],
        promptPrefix: '',
        attached: attached
    } : {
        selectedItems: [],
        promptPrefix: ''
    };
    const pages = data && data.pages || {};
    const components = data && data.components || {};
    const selectedItems = ids.map((key)=>{
        const isDs = typeof key === 'string' && key.indexOf($b8a6ca6b552220ee$var$_DS_PREFIX) === 0;
        const type = key in pages ? 'page' : 'component';
        const title = isDs ? "Design system \xb7 " + key.slice($b8a6ca6b552220ee$var$_DS_PREFIX.length).replace(/^\w/, (c)=>c.toUpperCase()) : key;
        return {
            key: key,
            type: type,
            title: title
        };
    });
    const label = selectedItems.map((it)=>it.title).join(', ');
    const promptPrefix = `Selected artboards: ${label} \u{2014} apply the request to these unless stated otherwise` + '\n\n';
    return attached ? {
        selectedItems: selectedItems,
        promptPrefix: promptPrefix,
        attached: attached
    } : {
        selectedItems: selectedItems,
        promptPrefix: promptPrefix
    };
}
function $b8a6ca6b552220ee$export$e733bac9aa4eacfe() {
    const root = $b8a6ca6b552220ee$var$_canvasRoot(this);
    if (!root) return {
        selectedItems: [],
        promptPrefix: ''
    };
    const v2 = this.call ? this.call('getCanvasV2') : null;
    const pages = root.data?.pages || {};
    const components = root.data?.components || {};
    // `projectId` + `entities` feed the ADDITIVE `attached.canvas` payload
    // (spec §3.8). Both are optional in buildSelectionContext, so the pure
    // function keeps working for every existing caller that passes only
    // `{ pages, components }`.
    return $b8a6ca6b552220ee$export$a53baadd87106ed5(v2, {
        pages: pages,
        components: components,
        projectId: root.data?._id || root.data?.id || root.projectId || '',
        entities: v2 && v2.entities || {}
    });
}

});

parcelRegister("gmD43", function(module, exports) {

$parcel$export(module.exports, "renderAnswerUi", () => $be9d00cfe1b63434$export$7fc32f825e2dffe1);
$parcel$export(module.exports, "answerViewContentSized", () => $be9d00cfe1b63434$export$b98a1d62e528c1d3);
// Live "answer view" renderer — the client half of the `render_answer_ui`
// workspace tool. Simone answers a data question by DRAWING a small DOMQL view
// instead of (or alongside) prose: the AI-authored source is statically
// audited (auditExtensionSource — the same gate every extension mount runs),
// parsed through the same guarded freestyle parser the canvas injectors use,
// registered as a TRANSIENT answer page on root._aiAnswerPages, and opened in
// the shell PageSlot — the same split sheet every app page opens in, so the
// user keeps chatting beside it. Nothing persists: answer views live only in root state
// for this session; asking again renders a fresh route.
//
// Route shape: '/answer/<slug>-<seq>' — seq keeps every render unique so the
// PageSlot keep-alive (same-path remounts are skipped) can never pin a stale
// view when the same question is asked twice. The map is pruned to the last
// few entries so a long chat session can't grow root state unboundedly.
// SANDBOX (ISOLATED-RUNTIME-PLAN §8, flag appsSandbox, default off): the
// workspace decides; the def comes from its registered builder (canvas cannot
// import workspace). Flag on with no builder registered: fail closed.
const $be9d00cfe1b63434$var$_sandboxOn = (el)=>{
    const root = el.getRootState && el.getRootState() || el.state && (el.state.root || el.state);
    return el.call('generatedAppSandboxOn', root) === true;
};
const $be9d00cfe1b63434$var$MAX_ANSWER_PAGES = 8;
let $be9d00cfe1b63434$var$_answerSeq = 0;
const $be9d00cfe1b63434$var$_canvasSlug = (title)=>String(title || 'answer').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || 'answer';
function $be9d00cfe1b63434$export$7fc32f825e2dffe1(payload = {}) {
    // el.call convention: `this` is the calling element; direct-call convention
    // (unit tests): first arg is the element, second the payload.
    const el = this && this.getRoot ? this : arguments[0];
    const args = this && this.getRoot ? payload : arguments[1] || {};
    const title = String(args.title || 'Answer').trim() || 'Answer';
    const source = String(args.source || '');
    if (!source.trim()) return {
        ok: false,
        error: 'source is required'
    };
    // SECURITY GATE — the same static audit every sibling AI-mount path runs
    // BEFORE model-authored source is eval'd (buildInlineExtensionDef /
    // buildInlineMultiPageDef / renderExtensionInPane / renderMultiPageApp in
    // workspace/functions/index.js): reject source reaching for raw network/
    // storage/eval/realm-escape primitives. Answer views mount into the LIVE
    // SHELL realm (live context + design system + root state), so this boundary
    // matters MORE here, not less. auditExtensionSource is registered by the
    // workspace functions barrel — canvas cannot import it (cross-app eslint
    // boundary); el.call is the house resolution mechanism, exactly how
    // parseFreestyleSource is reached below. FAIL CLOSED: if the auditor is not
    // registered in this context (standalone canvas wires no AI transport, so
    // renderAnswerUi has no caller there today), refuse the mount rather than
    // mounting unaudited source. The { ok: false, error, violations } refusal
    // shape is the sibling contract — simoneAiTransport returns it to the model
    // so it can self-correct, the same loop create_app uses.
    const audit = el.call('auditExtensionSource', source);
    if (!audit || audit.ok !== true) return {
        ok: false,
        error: audit && audit.error || "security audit unavailable in this context \u2014 refusing to mount unaudited source",
        violations: audit && audit.violations || [
            'audit unavailable'
        ]
    };
    const root = el.getRootState?.() || el.state?.root || el.getRoot?.()?.state;
    if (!root || typeof root.update !== 'function') return {
        ok: false,
        error: "no root state \u2014 cannot render the answer view"
    };
    // CONTAINMENT GATE (Nika 2026-10-01 "Cut access now") — the AST gate the
    // workspace registers (parseGeneratedAppSource, generatedAppContainment.js):
    // the answer view mounts in the LIVE shell, so the page may call only the
    // allowlisted functions and reach nothing of the shell. FAIL CLOSED like
    // the audit above: no registered gate → no mount.
    if ($be9d00cfe1b63434$var$_sandboxOn(el)) {
        const built = el.call('buildSandboxedAppDef', {
            name: title,
            source: source
        });
        if (!built || typeof built !== 'object') return {
            ok: false,
            error: "sandbox builder unavailable \u2014 refusing to mount",
            violations: [
                'gate unavailable'
            ]
        };
        if (built.blocked) return {
            ok: false,
            blocked: true,
            error: built.error,
            violations: built.violations,
            ...built.hint ? {
                hint: built.hint
            } : {}
        };
        if (!built.ok) return {
            ok: false,
            error: `source failed to parse: ${built.error}`
        };
        return $be9d00cfe1b63434$var$_registerAnswerPage(el, root, title, source, built.def, args);
    }
    let parsed;
    try {
        // `lint` — an answer view is also refused for a bare-number size or a
        // colour the design system does not have (both render nothing), with a
        // hint naming each (GENERATED-VIEW-STYLE-LINT-1).
        parsed = el.call('parseGeneratedAppSource', source, {
            lint: true
        });
    } catch (err) {
        return {
            ok: false,
            error: `source failed to parse: ${err?.message || err}`
        };
    }
    if (!parsed || typeof parsed !== 'object') return {
        ok: false,
        error: "containment gate unavailable in this context \u2014 refusing to mount unaudited source",
        violations: [
            'gate unavailable'
        ]
    };
    if (parsed.blocked) return {
        ok: false,
        blocked: true,
        error: parsed.error,
        violations: parsed.violations,
        ...parsed.hint ? {
            hint: parsed.hint
        } : {}
    };
    if (!parsed.ok) return {
        ok: false,
        error: `source failed to parse: ${parsed.error}`
    };
    const def = parsed.def;
    if (!def || typeof def !== 'object') return {
        ok: false,
        error: 'source parsed to nothing renderable'
    };
    // Accept the freestyler wrapper shape ({ components, icons, page }) as well
    // as a bare page def. Wrapper components register ADDITIVELY — an answer view
    // may bring a small helper component, but it must never shadow a registered
    // one (that would break every other consumer of that name).
    const page = def.page && typeof def.page === 'object' ? def.page : def;
    if (def.components && typeof def.components === 'object') {
        const ctx = el.context || el.getRoot?.()?.context;
        if (ctx && ctx.components) {
            for (const key of Object.keys(def.components))if (!ctx.components[key]) ctx.components[key] = def.components[key];
        }
    }
    return $be9d00cfe1b63434$var$_registerAnswerPage(el, root, title, source, page, args);
}
// An answer view is a CARD OF CONTENT, never a full-window app
// (ANSWER-VIEW-CONTENT-SIZED-1). The PageSlot host is a row flex box that
// stretches its page root to the window's height, and models often put
// `height` / `minHeight: '100%'` on the root too — measured on dev 2026-10-04:
// three stat tiles drawn as a flex row grew to ~1000 px tall, empty below the
// numbers. The registered ROOT sizes to its content: it does not stretch
// (alignSelf flex-start, unless the view sets its own), and a height or
// min-height that only means "fill the window" (a percentage or a viewport
// unit) becomes auto / 0. The inline thread mount normalizes the same way
// (assistantBlockMountView). Children keep every size they declare.
const $be9d00cfe1b63434$var$_fillsWindow = (v)=>typeof v === 'string' && /^\s*\d+(\.\d+)?\s*(%|vh|dvh|svh|lvh)\s*$/.test(v);
const $be9d00cfe1b63434$export$b98a1d62e528c1d3 = (page)=>{
    const out = {
        ...page
    };
    if ($be9d00cfe1b63434$var$_fillsWindow(out.height)) out.height = 'auto';
    if ($be9d00cfe1b63434$var$_fillsWindow(out.minHeight)) out.minHeight = '0';
    if (out.alignSelf == null) out.alignSelf = 'flex-start';
    return out;
};
function $be9d00cfe1b63434$var$_registerAnswerPage(el, root, title, source, page, args) {
    const route = `/answer/${$be9d00cfe1b63434$var$_canvasSlug(title)}-${++$be9d00cfe1b63434$var$_answerSeq}`;
    const entries = Object.entries(root._aiAnswerPages || {}).slice(-($be9d00cfe1b63434$var$MAX_ANSWER_PAGES - 1));
    // Stash the raw source in metadata so the PageSlot "Save as app" button can
    // recover the exact DOMQL to persist as an extension (the parsed def alone
    // can't be re-serialized). __source is inert on the mounted def.
    entries.push([
        route,
        {
            ...$be9d00cfe1b63434$export$b98a1d62e528c1d3(page),
            // `contentSized` — the PageSlot keeps this page's own height instead of
            // forcing it to fill the window (PageSlot _pageFillProps).
            metadata: {
                ...page.metadata || {},
                title: title,
                __source: source,
                contentSized: true
            }
        }
    ]);
    // `open: false` — registered, not opened: the caller draws the view inline
    // (the assistant's main thread, AI_ASSISTANT_SPEC v1 §3), so no split pane
    // takes the home while that thread is on screen; "Open in split" is the
    // block's own action.
    const open = args.open !== false;
    root.update({
        _aiAnswerPages: Object.fromEntries(entries),
        ...open ? {
            _canvasSlot: route,
            _slotFullscreen: null
        } : {}
    }, {
        preventFetch: true
    });
    return {
        ok: true,
        opened: route,
        title: title,
        ...open ? {} : {
            inline: true
        }
    };
}

});

parcelRegister("Oq65v", function(module, exports) {

$parcel$export(module.exports, "injectPageInApp", () => $0978e9fc03d84636$export$2edd1f0f93f829e9);
// Full-page in-app render — mirrors freestyler's injectGenerated (see
// smbls/plugins/freestyler/index.js ~L709-760) but runs client-side via
// el.call, dispatched from freestyleBridge.js when mode === 'app'.
//
// On a canvas_tool_call { tool:'render_component', args:{name,source} }
// this function:
//   1. Parses the DOMQL object-literal source string via parseFreestyleSource.
//   2. Finds the router root (walks el.parent for a node with .routes + .context).
//   3. Registers def.icons / def.components into ctx (mirrors freestyler).
//   4. Wraps def.onRender so any [data-back] nodes route to '/' (defensive).
//   5. Derives a unique slug-route from `name`, deduped against existing ctx.pages.
//   6. Registers the page on ctx.pages[route] and calls routerRoot.router(route).
//   7. Returns { ok:true, route } on success or { ok:false, error } for agent
//      self-correction (same contract as injectOnCanvas).
//
// Signature matches the el.call convention: `this` is the element when called
// via el.call('injectPageInApp', args). Also handles the direct-call case
// (first arg = el, second arg = args) for unit-test compatibility.
// Slugify a name string into a URL-safe path segment.
// Mirrors the pattern freestyler uses for routeKey: lowercase, words joined
// by '-', leading '/' prepended.
function $0978e9fc03d84636$var$_canvasSlugify(name) {
    return '/' + (name || 'generated').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 64);
}
// Walk el.parent upward to find the first element that has BOTH .routes and
// .context — that is the router root. Mirrors freestyler's findRouterRoot.
// Falls back to el.getRoot() if the walk exhausts.
// SANDBOX (ISOLATED-RUNTIME-PLAN §8, flag appsSandbox, default off): the
// workspace decides; the def comes from its registered builder (canvas cannot
// import workspace). Flag on with no builder registered: fail closed.
const $0978e9fc03d84636$var$_sandboxOn = (el)=>{
    const root = el.getRootState && el.getRootState() || el.state && (el.state.root || el.state);
    return el.call('generatedAppSandboxOn', root) === true;
};
function $0978e9fc03d84636$var$_findRouterRoot(el) {
    let node = el;
    while(node){
        if (node.routes && node.context) return node;
        node = node.parent;
    }
    return el.getRoot ? el.getRoot() : null;
}
function $0978e9fc03d84636$export$2edd1f0f93f829e9({ name: name, source: source } = {}) {
    // el.call convention: `this` is bound to the element. Also accept the
    // direct-call signature (injectPageInApp(el, args)) for test compat.
    const el = this && this.getRoot ? this : arguments[0];
    const args = this && this.getRoot ? {
        name: name,
        source: source
    } : arguments[1] || {};
    const _name = args.name || name;
    const _source = args.source || source;
    if (!_name || !_source) return {
        ok: false,
        error: 'name and source are required'
    };
    // Parse the DOMQL object-literal source.
    // CONTAINMENT GATE (Nika 2026-10-01 "Cut access now") — the same AST gate
    // every generated-app path uses (workspace functions/
    // generatedAppContainment.js parseGeneratedAppSource, reached by el.call:
    // canvas may not import workspace modules). FAIL CLOSED: no gate, no parse.
    if ($0978e9fc03d84636$var$_sandboxOn(el)) {
        const built = el.call('buildSandboxedAppDef', {
            name: _name,
            source: _source
        });
        if (!built || typeof built !== 'object') return {
            ok: false,
            error: "sandbox builder unavailable \u2014 refusing to mount"
        };
        if (built.blocked) return {
            ok: false,
            blocked: true,
            error: built.error,
            violations: built.violations
        };
        if (!built.ok) return {
            ok: false,
            error: built.error
        };
        return $0978e9fc03d84636$var$_routePage(el, _name, built.def, {
            sandboxed: true
        });
    }
    let parsed;
    try {
        parsed = el.call('parseGeneratedAppSource', _source);
    } catch (e) {
        return {
            ok: false,
            error: 'parse: ' + (e && e.message || String(e))
        };
    }
    if (!parsed || typeof parsed !== 'object') return {
        ok: false,
        error: "containment gate unavailable \u2014 refusing to evaluate unaudited source"
    };
    if (parsed.blocked) return {
        ok: false,
        blocked: true,
        error: parsed.error,
        violations: parsed.violations
    };
    if (!parsed.ok) return {
        ok: false,
        error: parsed.error
    };
    const def = parsed.def;
    if (!def || typeof def !== 'object') return {
        ok: false,
        error: 'source did not evaluate to an object'
    };
    return $0978e9fc03d84636$var$_routePage(el, _name, def, {
        sandboxed: false
    });
}
function $0978e9fc03d84636$var$_routePage(el, _name, def, { sandboxed: sandboxed }) {
    // Find the router root — the element that owns .routes + .context.
    const routerRoot = $0978e9fc03d84636$var$_findRouterRoot(el);
    if (!routerRoot) return {
        ok: false,
        error: 'no router root found'
    };
    const ctx = routerRoot.context;
    if (!ctx) return {
        ok: false,
        error: 'router root has no context'
    };
    // Register icons — merge into ctx.designSystem.icons (skip existing keys).
    // Unlike injectOnCanvas, in-app rendering shares the same design system
    // context as the shell, so icon merging works here directly.
    if (def.icons && typeof def.icons === 'object') {
        if (!ctx.designSystem) ctx.designSystem = {};
        if (!ctx.designSystem.icons) ctx.designSystem.icons = {};
        for (const [k, v] of Object.entries(def.icons))if (!ctx.designSystem.icons[k]) ctx.designSystem.icons[k] = v;
    }
    // Register supplementary components from the agent's output.
    if (def.components && typeof def.components === 'object') {
        if (!ctx.components) ctx.components = {};
        for (const [k, v] of Object.entries(def.components))if (!ctx.components[k]) ctx.components[k] = v;
    }
    // The page definition is either def.page or the def itself (mirrors
    // freestyler's `const pageDef = result.page || result`).
    const pageDef = def.page || def;
    // Wrap onRender so [data-back] nodes route back to '/' defensively,
    // mirroring freestyler L726-731. The agent is instructed to include a
    // back button but we make it work regardless of element naming.
    const originalOnRender = pageDef.onRender;
    // a sandboxed page's DOM lives in its opaque frame: nothing to wire here
    if (!sandboxed) pageDef.onRender = function(pageEl, s) {
        // Wire any [data-back] nodes to navigate to '/'.
        try {
            if (pageEl && pageEl.node) pageEl.node.querySelectorAll('[data-back]').forEach((btn)=>{
                btn.addEventListener('click', (e)=>{
                    e.preventDefault();
                    const rr = $0978e9fc03d84636$var$_findRouterRoot(pageEl);
                    if (rr) rr.router('/', rr);
                });
            });
        } catch (_) {}
        // Call the original onRender from the agent's output.
        if (typeof originalOnRender === 'function') originalOnRender(pageEl, s);
    };
    // Merge any top-level state from the agent's result.
    if (def.state && typeof def.state === 'object') pageDef.state = {
        ...pageDef.state || {},
        ...def.state
    };
    // Derive a unique route from the name. Dedupe '-2', '-3', ... against
    // existing ctx.pages (mirrors freestyler L750-756).
    if (!ctx.pages) ctx.pages = {};
    const baseRoute = $0978e9fc03d84636$var$_canvasSlugify(_name);
    let finalRoute = baseRoute;
    let i = 2;
    while(ctx.pages[finalRoute]){
        finalRoute = baseRoute + '-' + i;
        i++;
    }
    // Register the page and navigate.
    ctx.pages[finalRoute] = pageDef;
    try {
        routerRoot.router(finalRoute, routerRoot);
    } catch (err) {
        return {
            ok: false,
            error: 'router: ' + (err && err.message || String(err))
        };
    }
    return {
        ok: true,
        route: finalRoute
    };
}

});

parcelRegister("7niY9", function(module, exports) {

$parcel$export(module.exports, "parseFreestyleSource", () => $55e96546c3260187$export$c58685be55660242);
$parcel$export(module.exports, "auditFreestyleSource", () => $55e96546c3260187$export$d2bb7fa0be6f90c2);
$parcel$export(module.exports, "canvasStateSnapshot", () => $55e96546c3260187$export$85ebd3340894fb06);
// freestyle.js — shared parser + canvas state snapshot for the freestyler pipeline.
//
// parseFreestyleSource:
//   Tries to import parseJSObject from @symbo.ls/freestyler. If the export is
//   unavailable (parallel smbls agent hasn't shipped B1 yet, or the dist is stale),
//   falls back to an inline equivalent with identical behaviour: strip markdown fences,
//   locate ({...}) or {...}, normalise to a JS expression, eval via new Function.
//
// canvasStateSnapshot:
//   Returns a minimal, JSON-safe snapshot of the current canvas state for the agent
//   to read via get_canvas_state. Includes tile keys/types, registered component names,
//   and a design-system summary (token set names only — not the raw values).
// --- parseFreestyleSource ---------------------------------------------------
//
// Previously this attempted a dynamic `import('@symbo.ls/freestyler')` to pick
// up the canonical parser when available. That sibling package isn't published
// to npm yet so it's absent from CI's node_modules — Parcel's bundler then
// fails to statically resolve the import even though it's wrapped in
// try/catch, breaking `bun run build` on every PR (a `Failed to resolve
// '@symbo.ls/freestyler'` error). And once the import is "hidden" via string
// indirection, Parcel's bundleInfoMap chokes on the unresolvable specifier
// with `bundleInfoMap[bundleId] is not iterable`.
//
// The inline `parseJSObjectFallback` below is functionally identical to
// freestyler's parseJSObject (same fence-stripping, same eval-via-Function),
// so just use it directly and drop the dynamic-import dance entirely. When
// freestyler ships to npm we can swap back to a normal static import.

var $eY4Ct = parcelRequire("eY4Ct");
// Normalise raw model output to a bare JS expression: strip markdown fences and
// trailing commas. Extracted so the JSON-authored detection below tests the
// EXACT text the eval sees (a fenced ```json block is still JSON-authored).
//
// The language tag is matched as `[a-z]*`, NOT as `(?:javascript|js|json)?`.
// That alternation is ordered, so on a ```json fence it matched `js` first and
// left a stray `on` glued to the front of the source — every ```json-fenced
// source then died in eval with "on is not defined" and the whole view failed
// to render. Anchored right after the backticks with the object literal
// following, `[a-z]*` cannot over-consume.
function $55e96546c3260187$var$normalizeSourceText(raw) {
    return (raw || '').trim().replace(/^```[a-z]*[ \t]*\r?\n?/i, '').replace(/\s*```\s*$/m, '').trim()// Remove trailing commas before closing braces/brackets (common AI output).
    // Safe on arrow bodies: only a comma IMMEDIATELY before `}`/`]` is dropped.
    .replace(/,(\s*[}\]])/g, '$1');
}
// Inline fallback — mirrors freestyler parseJSObject behaviour.
// Accepts arrow-function handlers intact (eval, not JSON.parse).
//
// CRITICAL — do NOT extract the object by scanning for the first `({` in the
// text. A concise arrow object-return `(t) => ({ ... })` CONTAINS `({`, so the
// old `indexOf('({')` heuristic sliced out the arrow's inner object and eval'd
// it standalone, throwing "t is not defined". That single line silently broke
// EVERY freestyle source using the standard row-mapping idiom
// `children: (el, s) => rows.map((r) => ({ key: r.id, … }))` — the drawn-answer
// views, canvas tile injects, and create_extension alike. The whole source is
// a JS object literal; only unwrap an OUTER `({…})` the model added around the
// whole thing, then eval it AS-IS (the arrows stay functions, never evaluated).
// (freestyler's own parseJSObject likely carries the same bug — see
// tickets/smbls.md.)
// The EXACT expression text the parser evaluates (`return <expr>`), derived
// once so an audit hook and the eval can never see different code.
function $55e96546c3260187$var$freestyleExpressionText(raw) {
    let text = $55e96546c3260187$var$normalizeSourceText(raw);
    if (text.startsWith('({') && text.endsWith('})')) // Already a parenthesized object expression — eval verbatim.
    return text;
    // Bare `{ … }` — wrap the whole object (first `{` to last `}`) in parens so it
    // parses as an expression, not a block. Inner `({…})` arrow returns are left
    // untouched because we never slice mid-body.
    const braceStart = text.indexOf('{');
    const braceEnd = text.lastIndexOf('}');
    if (braceStart >= 0 && braceEnd > braceStart) text = text.slice(braceStart, braceEnd + 1);
    return '(' + text + ')';
}
// `audit(expressionText)` (REQUIRED) runs on exactly the text about to be
// evaluated and throws to refuse it — the generated-app containment gate
// (workspace functions/generatedAppContainment.js). The audit sees the WHOLE
// text, so string-held handlers of a JSON-authored source (destringified and
// evaluated below) are audited as part of it.
function $55e96546c3260187$var$auditedExpressionText(raw, audit) {
    const expr = $55e96546c3260187$var$freestyleExpressionText(raw);
    // REQUIRED (core-wl v2): no audit, no evaluation. A caller that forgets the
    // hook gets the containment refusal, never an unaudited eval.
    if (typeof audit !== 'function') {
        const err = new Error('parseFreestyleSource: an audit hook is required');
        err.code = 'generated_app_blocked';
        err.violations = [
            {
                rule: 'audit-unavailable',
                at: null,
                detail: 'no audit hook'
            }
        ];
        throw err;
    }
    audit(expr);
    return expr;
}
function $55e96546c3260187$var$parseJSObjectFallback(raw, audit) {
    return new Function('return ' + $55e96546c3260187$var$auditedExpressionText(raw, audit))();
}
// A source is JSON-AUTHORED when the whole text parses as strict JSON. JSON has
// no function type, so every DOMQL factory in such a source arrived as a QUOTED
// STRING (`"text": "(el, s) => …"`). `new Function('return (…)')` happily evals
// JSON — it IS valid JS — so the def comes back structurally correct but with
// every factory still a string: DOMQL then renders `text` as the literal source
// text on screen and never fires `onInit`/`children` (verified live 2026-07-27
// on /w/natali — "what's our total stock value?" drew a pane whose value read
// `(el, s) => (s.stockTotal || 0).toLocaleString() + ' GEL'` and whose breakdown
// stayed empty because its onInit loader never ran).
//
// Tool-call arguments ARE JSON, so an AI-authored `source` round-tripping as
// JSON is a first-class input shape, not a malformed one — it needs the same
// revive every other JSON-borne DOMQL payload in the platform already gets
// (project data, workspace modules, InsertPanelLibrary, loadProjectData all
// call deepDestringifyFunctions). This parser was the one path that skipped it.
//
// Gated on JSON-parseability rather than on per-value shape ON PURPOSE: a
// healthy JS-object-literal source is left completely untouched, so a data
// string that merely happens to read like an arrow (`'Draft => Review'`) can
// never be eval'd into a function on the normal path.
function $55e96546c3260187$var$isJsonAuthored(text) {
    if (!text || text[0] !== '{' && text[0] !== '[') return false;
    try {
        JSON.parse(text);
        return true;
    } catch (_) {
        return false;
    }
}
function $55e96546c3260187$export$c58685be55660242(source, opts) {
    const audit = opts && typeof opts.audit === 'function' ? opts.audit : null;
    const def = $55e96546c3260187$var$parseJSObjectFallback(source, audit);
    if (!def || typeof def !== 'object') return def;
    if (!$55e96546c3260187$var$isJsonAuthored($55e96546c3260187$var$normalizeSourceText(source))) return def;
    // deepDestringifyFunctions writes into the container it's handed and only
    // touches strings that read like a function (smbls `hasFunction`), leaving a
    // failed eval as the original string with a console warning.
    return (0, $eY4Ct.deepDestringifyFunctions)(def, Array.isArray(def) ? [] : {});
}
function $55e96546c3260187$export$d2bb7fa0be6f90c2(source, opts) {
    const audit = opts && typeof opts.audit === 'function' ? opts.audit : null;
    const expr = $55e96546c3260187$var$auditedExpressionText(source, audit);
    return {
        expr: expr,
        jsonAuthored: $55e96546c3260187$var$isJsonAuthored($55e96546c3260187$var$normalizeSourceText(source))
    };
}
function $55e96546c3260187$export$85ebd3340894fb06() {
    // DOMQL function — `this` is the element when called via el.call.
    const el = this;
    // ctx lives on the element (or root element's context); canvas state lives on
    // root STATE — use getCanvasV2 so existing tiles are read correctly.
    const ctx = el.context || el.getRoot && el.getRoot().context || {};
    const v2 = el.call && el.call('getCanvasV2') || {};
    const items = v2.items || {};
    const ds = ctx.designSystem || {};
    // Tiles: just the key, pageKey, and position — no internals.
    // pageKey is what embedComponent uses to look up the component in
    // root.data.components or root.data.pages — report it so the agent
    // can reference the correct key when composing follow-up calls.
    const tiles = Object.entries(items).map(([key, it])=>({
            key: key,
            pageKey: it.pageKey || key,
            x: it.x,
            y: it.y,
            w: it.w,
            h: it.h
        }));
    // Report the keys from root STATE data.components — the project-data registry
    // that the tile iframe renderer actually reads via embedComponent. This is the
    // reactive state object (not el.getRoot().data which is the element's .data
    // property — a different object). injectOnCanvas writes here via root.update().
    const rootState = el.getRootState?.() || el.state?.root || el.getRoot && el.getRoot()?.state || {};
    const dataComponents = Object.keys((rootState.data || {}).components || {});
    // Also include shell-context components for completeness (e.g. framework built-ins
    // the agent might reference), deduped with data registry entries.
    const ctxComponents = Object.keys(ctx.components || {});
    const componentNames = [
        ...new Set([
            ...dataComponents,
            ...ctxComponents
        ])
    ];
    // Design-system summary: top-level token group names only.
    const dsKeys = Object.keys(ds).filter((k)=>k !== 'icons' && k !== 'components');
    // --- Reusable component registry (for freestyle agent) --------------------
    // Full live registry: framework built-ins + shared libraries + brand library
    // + project components — everything the agent can reference by PascalCase key.
    const allCtxComponents = Object.keys(ctx.components || {});
    const REUSABLE_CAP = 250;
    const reusableComponents = allCtxComponents.slice(0, REUSABLE_CAP);
    const reusableComponentsTruncated = allCtxComponents.length > REUSABLE_CAP ? allCtxComponents.length : undefined;
    // --- Design-system token-group key summary (for freestyle agent) ----------
    // For each well-known group, return just the key names (not values) so the
    // agent knows which tokens exist without receiving a potentially huge object.
    const DS_GROUPS = [
        'color',
        'colors',
        'typography',
        'spacing',
        'theme',
        'themes',
        'icons'
    ];
    const DS_GROUP_CAP = 60;
    const designSystem = {};
    for (const group of DS_GROUPS){
        const groupVal = ds[group];
        if (!groupVal || typeof groupVal !== 'object') continue;
        const keys = Object.keys(groupVal);
        if (keys.length === 0) continue;
        designSystem[group] = keys.slice(0, DS_GROUP_CAP);
        if (keys.length > DS_GROUP_CAP) designSystem[group + 'Truncated'] = keys.length;
    }
    return {
        tiles: // Back-compat fields
        tiles,
        componentNames: componentNames,
        // Separate field so the agent can distinguish renderable data-registry
        // components from shell-only context entries.
        dataComponentNames: dataComponents,
        designSystemKeys: dsKeys,
        tileCount: tiles.length,
        reusableComponents: // New: full reusable registry — agent MUST check these before building new markup.
        reusableComponents,
        ...reusableComponentsTruncated !== undefined && {
            reusableComponentsTruncated: reusableComponentsTruncated
        },
        // New: token-group key summary — agent MUST use these DS tokens, not raw values.
        designSystem: Object.keys(designSystem).length ? designSystem : undefined
    };
}

});

parcelRegister("3o5o3", function(module, exports) {

$parcel$export(module.exports, "initPanzoomBoard", () => $2777cabbd6e4d7b5$export$3f27f58df4a6ab4f);
// Shared panzoom + dots + transform wiring for canvas-style pages
// (/studios, /team-and-agents). Lifts the inline panzoom setup from
// canvas/pages/studios.js (around line 7060) into a single helper so
// non-project canvas pages don't have to copy the same boilerplate.
//
// What this owns:
//   - panzoom(scene) with sensible defaults + `beforeMouseDown` gate
//     so dragging a `[data-node-id]` child doesn't pan the canvas.
//   - Wheel handling: plain wheel → pan, ⌘/Ctrl+wheel → zoom.
//   - Safari trackpad pinch (gesturestart/gesturechange/gestureend) →
//     zoom through the same zoom-at-point path as ⌘/Ctrl+wheel, with
//     native PAGE zoom suppressed over the board only (never globally).
//   - Dots layer position + size update on every transform tick.
//   - `--canvas-scale` CSS var on the scene element so children can
//     counter-scale (overlays / handles that should stay viewport-sized).
//   - Idempotent attach (no double-binding on re-render).
//
// What this DOESN'T own (intentionally):
//   - Connection drawing — page-specific (different node shapes / data).
//   - Drag handlers per node — page-specific.
//   - Initial position + persistence — page picks its own storage key.
//   - GlobalScope mirroring — used to be wired here for the Zoombar but
//     keeping it page-side avoids cross-page leakage.
//
// Usage from a page's onRender:
//   import { initPanzoomBoard } from '../functions/initPanzoomBoard.js'
//   onRender: (el, s) => {
//     if (el.__pzBooted) return
//     el.__pzBooted = true
//     initPanzoomBoard({
//       getScene: () => el.MyBoard?.node,
//       getDots:  () => el.MyDots?.node,
//       initial:  { x: 40, y: 40, scale: 1 },
//       attachKey: '__myPagePanzoom',   // marker so re-render doesn't re-attach
//       onTransform: (t) => { window.__myPageScale = t.scale }
//     })
//   }
//
// Returns the panzoom instance (or null when scene wasn't ready yet —
// the helper auto-retries via requestAnimationFrame).

var $gBVY4 = parcelRequire("gBVY4");

var $1X0Je = parcelRequire("1X0Je");
const $2777cabbd6e4d7b5$var$applyCanvasDotMetrics = (...args)=>(0, $1X0Je.default).functions.applyCanvasDotMetrics(...args);
// Read through this getter, never as a bare `CANVAS_DOT_VISIBILITY_FLOOR` —
// the constant is NOT imported into this file, so a bare reference is an
// undeclared free variable: a ReferenceError on every pan/zoom repaint in the
// ordinary bundle, and an `unresolvable-scope-read` (`__scope.CANVAS_DOT_
// VISIBILITY_FLOOR`, guaranteed `undefined`) once frank serializes the board
// initializer. The getter existed for exactly this reason and the one call
// site had drifted off it.
const $2777cabbd6e4d7b5$var$getCanvasDotVisibilityFloor = ()=>(0, $1X0Je.default).functions.CANVAS_DOT_VISIBILITY_FLOOR;
const $2777cabbd6e4d7b5$var$DEFAULT_BASE_DOT = 24;
// Safari (macOS + iPadOS WKWebView) is the only engine that dispatches the
// non-standard gesturestart/gesturechange/gestureend events for trackpad
// pinches. Detected once at module load — on every other browser this stays
// false and the gesture wiring below never attaches (zero cost).
const $2777cabbd6e4d7b5$var$HAS_GESTURE_EVENTS = typeof window !== 'undefined' && (typeof window.GestureEvent !== 'undefined' || 'ongesturestart' in window);
function $2777cabbd6e4d7b5$export$3f27f58df4a6ab4f(opts = {}) {
    const { getScene: getScene, getDots: getDots, initial: initial = {
        x: 40,
        y: 40,
        scale: 1
    }, attachKey: attachKey = '__panzoomAttached', baseDotSize: baseDotSize = $2777cabbd6e4d7b5$var$DEFAULT_BASE_DOT, dotPeriod: // Optional dot-grid overrides forwarded to applyCanvasDotMetrics —
    // `dotPeriod` stretches the zoom-recursion cycle (grid re-folds every
    // ×period of zoom; default 3), `dotInkDivisor` shrinks the dot radius
    // relative to spacing (default 40). Undefined → canvas-wide defaults,
    // so every existing board is untouched.
    dotPeriod, dotInkDivisor: dotInkDivisor, beforeMouseDown: beforeMouseDown, beforeWheel: // Optional page-supplied wheel gate. When omitted, the default below
    // (plain wheel → pan, ⌘/Ctrl+wheel → zoom) is used. /studio supplies
    // its own so nested scrollable surfaces (dropdown panels) can own the
    // wheel before the canvas pan layer sees it.
    beforeWheel, onTransform: onTransform, minZoom: minZoom = 0.3, maxZoom: maxZoom = 2, zoomSpeed: zoomSpeed = 0.8, disableKeyboardInteraction: // Forwarded to panzoom(). /studio sets this true so panzoom doesn't
    // force tabindex="0" on the scene's owner element (the Studios root),
    // which otherwise steals focus from buttons on click. Defaults to
    // panzoom's own default (false) so existing callers are unaffected.
    disableKeyboardInteraction = false, maxRetries: maxRetries = 120, cancelToken: // Optional `{ canceled: boolean }` token — pass from the caller so
    // it can flip `.canceled = true` on page unmount and cancel the
    // pending RAF chain. Without this, getScene() returning null
    // forever would mean an indefinite per-frame retry loop.
    cancelToken } = opts;
    // Internal retry counter — if the caller doesn't supply a token,
    // we still cap at maxRetries (~2s at 60fps) so a misconfigured
    // getScene path can't burn frames forever.
    const _attempts = opts._attempts || 0;
    // The calling ELEMENT (every board invokes this via `el.call`, binding
    // `this`). Preserved across the RAF retry chain via opts — a plain
    // recursive call would drop it, and the live-cursors attach below needs it.
    const _callerEl = (this && typeof this.call === 'function' ? this : null) || opts.__callerEl || null;
    if (cancelToken?.canceled) return null;
    const scene = typeof getScene === 'function' ? getScene() : null;
    if (!scene) {
        if (_attempts >= maxRetries) {
            if (typeof console !== 'undefined') console.warn('[initPanzoomBoard] gave up after', maxRetries, "frames \u2014 scene never mounted");
            return null;
        }
        requestAnimationFrame(()=>{
            $2777cabbd6e4d7b5$export$3f27f58df4a6ab4f({
                ...opts,
                __callerEl: _callerEl,
                _attempts: _attempts + 1
            });
        });
        return null;
    }
    if (scene[attachKey]) return scene[attachKey];
    // The node gate — "don't pan when the press starts on a draggable node" — is
    // caller-supplied (each board names its own [data-*] node markers, e.g.
    // [data-ticket-id]/[data-col-header] on the tickets board) with a
    // [data-node-id] default. Resolve it ONCE so panzoom's mouse gate AND the
    // touch guard below share the SAME predicate — otherwise the touch guard only
    // recognizes [data-node-id] boards and pans the board while a finger drags a
    // ticket card / studios node / etc. Every board gate is target-only, so it's
    // safe to evaluate on a touchstart event.
    const nodeGate = typeof beforeMouseDown === 'function' ? beforeMouseDown : (e)=>!!e.target.closest?.('[data-node-id]');
    // Shared between the default beforeWheel below and the Safari gesture
    // handlers further down: while a trackpad pinch is driving the zoom via
    // gesture events (base != null), the ctrl+wheel echo some Safari builds
    // emit for the SAME physical pinch must be swallowed — letting panzoom's
    // wheel zoom also run would double-apply every step. lastTs bounds the
    // gate so a gesture that never delivered its gestureend (element torn
    // down mid-pinch) can't mute ⌘/Ctrl+wheel zoom forever.
    const gestureState = {
        base: null,
        lastTs: 0
    };
    // TDZ guard — panzoom() can fire wheel events synchronously inside
    // its constructor; split declaration so beforeWheel sees `undefined`
    // (not a ReferenceError) until pz binds. Mirrors studios.js.
    let pz;
    pz = (0, (/*@__PURE__*/$parcel$interopDefault($gBVY4)))(scene, {
        minZoom: minZoom,
        maxZoom: maxZoom,
        zoomSpeed: zoomSpeed,
        zoomDoubleClickSpeed: 1,
        disableKeyboardInteraction: disableKeyboardInteraction,
        // Allow page-supplied gate; default is "panzoom catches everything
        // except clicks on [data-node-id]" — same convention studios.js uses
        // and /team-and-agents already follows.
        beforeMouseDown: nodeGate,
        beforeWheel: typeof beforeWheel === 'function' ? (e)=>beforeWheel(e, pz) : (e)=>{
            if (!pz) return;
            const isPinch = e.metaKey || e.ctrlKey;
            if (isPinch) {
                // A Safari gesture (handlers below) is already driving this
                // pinch — swallow the wheel echo so the step isn't applied
                // twice. Returning true makes panzoom skip its wheel zoom;
                // preventDefault keeps the browser's own ctrl+wheel page
                // zoom out too.
                if (gestureState.base != null && Date.now() - gestureState.lastTs < 250) {
                    e.preventDefault();
                    return true;
                }
                return false;
            }
            e.preventDefault();
            const { x: x, y: y } = pz.getTransform();
            pz.moveTo(x - e.deltaX, y - e.deltaY);
            return true;
        }
    });
    scene[attachKey] = pz;
    // ── iPad / coarse-pointer touch hardening (once per scene) ───────────────
    // The canvas owns pan + pinch, so the browser must not scroll/zoom the PAGE
    // over it (touch-action: none). And panzoom drives its touch pan from a bare
    // single-finger touchstart with NO node gate — its beforeMouseDown gate above
    // is mouse-only — so a one-finger drag STARTING on a [data-node-id] would pan
    // the whole board, and panzoom's preventDefault would swallow the synthesized
    // tap-to-open click.
    //
    // Fix once, at the shared layer, for every board: a CAPTURE-phase touchstart
    // guard on the scene runs BEFORE panzoom's bubble listener (which binds to
    // scene.parentElement). When a single finger lands on a node, pause() panzoom
    // — releaseEvents() removes its touchstart listener before the bubble reaches
    // it, so it never starts a pan and never preventDefaults the tap — then
    // resume() when the touch ends. Per-board node drag handlers then own the
    // gesture. Multi-finger pinch is left alone so zoom still works over a node.
    if (!scene.__pzTouchHardened) {
        scene.__pzTouchHardened = true;
        scene.style.touchAction = 'none';
        // Selection hardening (iPad, 2026-08-01 per Nika "when dragging around
        // on canvas prevent selections"): a touch-drag pan across board tiles
        // starts iOS TEXT SELECTION + the magnifier callout on any text it
        // crosses — the board is a gesture surface (Figma/Freeform model), not
        // prose, so selection is never a canvas gesture. Same rationale as the
        // home-grid rule shipped in wave 2. Owner-scoped (not global), and
        // editable descendants re-enable selection below so inline renames /
        // editors keep native caret + selection behavior.
        const pzOwnerSel = scene.parentElement || scene;
        pzOwnerSel.style.userSelect = 'none';
        pzOwnerSel.style.webkitUserSelect = 'none';
        pzOwnerSel.style.webkitTouchCallout = 'none';
        for (const ed of scene.querySelectorAll('input, textarea, [contenteditable]')){
            ed.style.userSelect = 'text';
            ed.style.webkitUserSelect = 'text';
        }
        // Late-mounted editables (rename inputs appear on demand): re-assert on
        // focusin — one delegated listener instead of observing the whole tree.
        pzOwnerSel.addEventListener('focusin', (e)=>{
            const t = e.target;
            if (t && (t.matches?.('input, textarea, [contenteditable]') || t.isContentEditable)) {
                t.style.userSelect = 'text';
                t.style.webkitUserSelect = 'text';
            }
        }, {
            passive: true
        });
        const resumePz = ()=>{
            if (pz.isPaused()) pz.resume();
            document.removeEventListener('touchend', resumePz);
            document.removeEventListener('touchcancel', resumePz);
        };
        scene.addEventListener('touchstart', (e)=>{
            if (e.touches.length !== 1 || pz.isPaused()) return;
            if (!nodeGate(e)) return;
            pz.pause();
            document.addEventListener('touchend', resumePz);
            document.addEventListener('touchcancel', resumePz);
        }, {
            capture: true,
            passive: true
        });
    }
    // ── Safari trackpad pinch → board zoom (gesture events, once per scene) ──
    // On iPadOS with a Magic Keyboard trackpad (and on macOS Safari), pinch
    // never reaches the wheel path — WebKit dispatches the non-standard
    // gesturestart/gesturechange/gestureend events carrying a cumulative
    // e.scale, and when nothing preventDefaults them WKWebView performs native
    // PAGE zoom: the whole app scales instead of the board (touch-action does
    // not cover trackpad gestures). Handle them on panzoom's own input layer —
    // the owner element (scene.parentElement) all other board input
    // (wheel/mouse/touch) already binds to — so the suppression is scoped to
    // the board surface: gestures starting anywhere else in the app (settings
    // pages, text) keep Safari's default behavior, and no global
    // viewport/user-scalable hack is involved (browser zoom stays available
    // off-canvas — accessibility stays intact).
    //
    // Direct-touch pinches ALSO fire gesture events, but those already work:
    // panzoom's own touchmove handler drives them (and preventDefaults the
    // page zoom), so an active touch skips this path entirely to avoid
    // double-driving the transform. Listener teardown rides owner-node
    // teardown on page unmount — the same lifecycle the touch hardening above
    // and panzoom's own owner-bound listeners follow.
    if ($2777cabbd6e4d7b5$var$HAS_GESTURE_EVENTS && !scene.__pzGestureAttached) {
        scene.__pzGestureAttached = true;
        const pzOwner = scene.parentElement || scene;
        // Zoom-at-point shared with the ⌘/Ctrl+wheel path. Wheel pinches zoom
        // via panzoom's INTERNAL wheel handler (the default beforeWheel above
        // returns false for them), which anchors at owner-relative offsets —
        // its getOffsetXY is clientXY − owner.getBoundingClientRect(). Feeding
        // pz.zoomAbs the same conversion drives the exact same zoomByRatio
        // engine (min/max clamped, same transform tick → dots/scale-var/DOM
        // writes), so both input paths stay on one zoom implementation instead
        // of duplicating the math here.
        const zoomAtClientPoint = (clientX, clientY, absScale)=>{
            const rect = pzOwner.getBoundingClientRect();
            const cx = typeof clientX === 'number' ? clientX : rect.left + rect.width / 2;
            const cy = typeof clientY === 'number' ? clientY : rect.top + rect.height / 2;
            pz.zoomAbs(cx - rect.left, cy - rect.top, absScale);
        };
        let touchActive = 0;
        const trackTouch = (e)=>{
            touchActive = e.touches.length;
        };
        const onGestureStart = (e)=>{
            if (touchActive > 0) return;
            e.preventDefault();
            gestureState.base = pz.getTransform().scale;
            gestureState.lastTs = Date.now();
        };
        const onGestureChange = (e)=>{
            if (gestureState.base == null) return;
            e.preventDefault();
            gestureState.lastTs = Date.now();
            zoomAtClientPoint(e.clientX, e.clientY, gestureState.base * (e.scale || 1));
        };
        const onGestureEnd = (e)=>{
            if (gestureState.base == null) return;
            e.preventDefault();
            gestureState.base = null;
        };
        pzOwner.addEventListener('touchstart', trackTouch, {
            passive: true
        });
        pzOwner.addEventListener('touchend', trackTouch, {
            passive: true
        });
        pzOwner.addEventListener('touchcancel', trackTouch, {
            passive: true
        });
        // Non-passive on purpose — preventDefault is the whole point (Safari
        // treats gesture listeners as non-passive by default, but be explicit).
        pzOwner.addEventListener('gesturestart', onGestureStart, {
            passive: false
        });
        pzOwner.addEventListener('gesturechange', onGestureChange, {
            passive: false
        });
        pzOwner.addEventListener('gestureend', onGestureEnd, {
            passive: false
        });
        // ── Native-shell trackpad pinch (symbols:native-pinch) ────────────────
        // In the Tauri iOS shell WKWebView delivers trackpad pinches to the
        // NATIVE gesture system only — no gesture events, no ctrl+wheel — so the
        // shell's UIPinchGestureRecognizer (native/ipad src-tauri lib.rs)
        // forwards phase/scale/centroid as this window CustomEvent. Drive the
        // SAME zoomAtClientPoint/gestureState machinery as the Safari gesture
        // path above. Browser sessions never receive the event — zero cost.
        // Containment is decided at gesture START (a pinch that begins over the
        // board keeps zooming while the centroid drifts, like native canvases);
        // direct-touch pinches skip via the same touchActive counter. The
        // listener is window-level (the event targets no node), so it self-
        // prunes when this board's owner leaves the DOM.
        let nativeIgnored = false;
        const onNativePinch = (e)=>{
            if (!pzOwner.isConnected) {
                window.removeEventListener('symbols:native-pinch', onNativePinch);
                return;
            }
            const d = e.detail || {};
            if (d.phase === 'start') {
                nativeIgnored = touchActive > 0 || !pzOwner.contains(document.elementFromPoint(d.x || 0, d.y || 0));
                if (nativeIgnored) return;
                gestureState.base = pz.getTransform().scale;
                gestureState.lastTs = Date.now();
                return;
            }
            if (nativeIgnored) {
                if (d.phase === 'end' || d.phase === 'cancel') nativeIgnored = false;
                return;
            }
            if (gestureState.base == null) return;
            if (d.phase === 'change') {
                gestureState.lastTs = Date.now();
                zoomAtClientPoint(d.x, d.y, gestureState.base * (d.scale || 1));
                return;
            }
            if (d.phase === 'end' || d.phase === 'cancel') gestureState.base = null;
        };
        window.addEventListener('symbols:native-pinch', onNativePinch);
    }
    // Size/position only — both theme-agnostic, so stamping them inline is
    // safe. The dots' backgroundImage is owned by CanvasDots' '@dark'/'@light'
    // CSS; never write it inline here (inline would freeze the theme).
    const updateDots = ()=>{
        const dots = typeof getDots === 'function' ? getDots() : null;
        if (!dots) return;
        const t = pz.getTransform();
        // Shared dot-grid invariant (canvasBackground.canvasDotMetrics): spacing
        // folds into a bounded band and the dot radius tracks it, so the texture
        // reads identically at every zoom. The old `size = scale * baseDotSize`
        // was unbounded in BOTH directions — at scale 3 it drew a 0.6px dot on
        // 72px spacing (~0.02% ink, effectively invisible) and far out it packed
        // the dots into a solid wash. Same defect the project canvas hit as
        // "sometimes during scroll dots disappear" (2026-08-08), fixed once here
        // rather than per board.
        // minRadius: CANVAS_DOT_VISIBILITY_FLOOR — CODEX-V8 row 3 (2026-08-13 QA):
        // this helper's own DEFAULT_BASE_DOT (24) combined with the canvas-wide
        // CANVAS_DOT_INK_DIVISOR (40) folds down to a mathematically-correct-but-
        // invisible 0.6px radius at scale 1 (the exact seed every board booted
        // through this helper uses), confirmed via a controlled screenshot A/B/C
        // — 0.6px produced zero visible dots in three crop regions, 1px was
        // barely visible, 4px clearly visible. The ink-density ratio formula
        // (canvasDotMetrics, canvasDotMetrics.test.js) stays mathematically pure
        // — this floor is opt-in via applyCanvasDotMetrics' `minRadius` and only
        // ever raises a too-small radius, never lowers a healthy one.
        $2777cabbd6e4d7b5$var$applyCanvasDotMetrics(dots, t.scale, t.x, t.y, baseDotSize, {
            period: dotPeriod,
            inkDivisor: dotInkDivisor,
            minRadius: $2777cabbd6e4d7b5$var$getCanvasDotVisibilityFloor()
        });
    };
    const writeScaleVar = ()=>{
        const t = pz.getTransform();
        scene.style.setProperty('--canvas-scale', String(t.scale));
    };
    // DOMQL v3.14's CSS_PROPS registry doesn't include `transform` /
    // `transformOrigin`, so panzoom-seeded values won't reach the DOM on
    // first paint unless we write them directly to scene.style. Mirrors
    // studios.js (~line 7194) where the same write is done via
    // `el.Board.update({ style: { transform } })`. Without this, panzoom
    // holds the offset/scale internally but the board stays at identity
    // until the first user wheel/drag triggers a transform write.
    const writeTransform = ()=>{
        const t = pz.getTransform();
        scene.style.transformOrigin = '0 0';
        scene.style.transform = `matrix(${t.scale}, 0, 0, ${t.scale}, ${t.x}, ${t.y})`;
    };
    pz.on('transform', ()=>{
        updateDots();
        writeScaleVar();
        writeTransform();
        if (typeof onTransform === 'function') onTransform(pz.getTransform());
    });
    // Seed initial transform — `pz.moveTo` + `zoomAbs` together so the
    // first paint isn't pinned to (0, 0, 1).
    if (initial) {
        if (typeof initial.scale === 'number') pz.zoomAbs(0, 0, initial.scale);
        if (initial.x != null || initial.y != null) pz.moveTo(initial.x || 0, initial.y || 0);
    }
    updateDots();
    writeScaleVar();
    writeTransform();
    // ── Offscreen-content auto-refit (phones / small viewports) ─────────────
    // Two board classes shipped desktop-shaped cameras that leave a phone
    // viewport EMPTY (iPhone audit 2026-08-02): tickets seeds a hardcoded
    // `initial.x: 370` (clears the DESKTOP filters rail — at 390px that pushes
    // every column past the right edge), and studios restores tile positions
    // dragged on desktop (content bbox can start ~1000px out with the camera
    // at origin). Rather than patching each board's seed, detect the failure
    // itself: once children exist, if the content bbox does not intersect the
    // owner viewport, pan the camera so the content's near corner lands at a
    // small margin. Runs only until first user input (their camera, their
    // rules), only pans (never rescales), and no-ops on every board whose
    // content is already visible — desktop stays byte-identical.
    {
        const pzOwnerFit = scene.parentElement || scene;
        let userDrove = false;
        const markDriven = ()=>{
            userDrove = true;
        };
        pzOwnerFit.addEventListener('pointerdown', markDriven, {
            passive: true,
            once: true
        });
        pzOwnerFit.addEventListener('wheel', markDriven, {
            passive: true,
            once: true
        });
        let attempts = 0;
        const tryFit = ()=>{
            if (userDrove || !pzOwnerFit.isConnected) return;
            if (attempts++ > 120) return; // ~2s of frames — content never arrived
            const kids = scene.children;
            if (!kids.length) {
                requestAnimationFrame(tryFit);
                return;
            }
            let L = Infinity;
            let T = Infinity;
            let R = -Infinity;
            let B = -Infinity;
            const cap = Math.min(kids.length, 200);
            for(let i = 0; i < cap; i++){
                const r = kids[i].getBoundingClientRect();
                if (!r.width && !r.height) continue;
                if (r.left < L) L = r.left;
                if (r.top < T) T = r.top;
                if (r.right > R) R = r.right;
                if (r.bottom > B) B = r.bottom;
            }
            if (L === Infinity) {
                requestAnimationFrame(tryFit);
                return;
            }
            const o = pzOwnerFit.getBoundingClientRect();
            // Per-axis visible slice. A bare intersection test is too lenient —
            // the live tickets board showed a 16px sliver of a 2547px-wide board
            // "intersecting" a 390px phone viewport while reading as blank. Refit
            // an axis when under 80px of it is visible AND there is meaningfully
            // more content hidden beyond (so a small board that simply IS narrow
            // never gets yanked to the margin).
            const visW = Math.max(0, Math.min(R, o.right) - Math.max(L, o.left));
            const visH = Math.max(0, Math.min(B, o.bottom) - Math.max(T, o.top));
            const needX = visW < 80 && R - L - visW > 40;
            const needY = visH < 80 && B - T - visH > 40;
            if (!needX && !needY) return;
            const margin = 24;
            const t = pz.getTransform();
            const dx = needX ? o.left + margin - L : 0;
            const dy = needY ? o.top + margin - T : 0;
            pz.moveTo(t.x + dx, t.y + dy);
            updateDots();
            writeScaleVar();
            writeTransform();
        };
        requestAnimationFrame(tryFit);
    }
    // Expose a manual transform flush. DOMQL v3.14 never writes `transform`
    // itself (see writeTransform above), and a programmatic `pz.moveTo` only
    // reaches the DOM through the panzoom `transform` event — which does NOT
    // fire on the home AgentsWidget embed (the board stays pinned to the seed).
    // Callers that move the camera in code (the /my-agents + home-embed
    // fit-to-visible) call this to force the write; redundant-but-harmless on
    // the routes where the event fires normally.
    pz.applyBoardTransform = ()=>{
        updateDots();
        writeScaleVar();
        writeTransform();
        // A manual flush IS a transform change — notify onTransform subscribers so
        // consumers driven off it stay in sync on the embed / fit paths where
        // panzoom's own `transform` event never fires (e.g. team-and-agents'
        // viewport-windowing recompute, and the globalScope scale mirror). Guarded
        // so a caller without onTransform is unaffected; idempotent for the scale
        // mirrors that already run on every real transform event.
        if (typeof onTransform === 'function') onTransform(pz.getTransform());
    };
    // ── Live cursors (shared across every panzoom board) ─────────────────────
    // The project canvas has always shown collaborators' cursors
    // (CollabService → root.clients → ViewSvitcher OverlayPeers); this extends
    // the same functionality to EVERY board that boots through this helper —
    // tickets board/epics, /studios, /team-and-agents, /files, /infra, the
    // analytics map — with zero per-page wiring. Transport is the /user-socket
    // presence relay (shared/functions/liveCursors.js), scoped per
    // workspace + path. Every call site invokes this helper via
    // `el.call('initPanzoomBoard', …)`, so `this` is the calling element;
    // a bare-import caller just skips cursors.
    if (_callerEl) try {
        $2777cabbd6e4d7b5$var$_attachLiveCursors(_callerEl, scene, pz, cancelToken);
    } catch (err) {
        console.warn('[initPanzoomBoard] live cursors attach failed:', err?.message || err);
    }
    return pz;
}
// Imperative cursor layer INSIDE the panzoom scene — peers are positioned in
// CONTENT coordinates so the board transform places them for free; sprites
// counter-scale so they stay viewport-sized. Same imperative altitude as the
// dots/transform plumbing above: peer moves at ~20/s must never touch
// reactive state.
const $2777cabbd6e4d7b5$var$_cursorHue = (key)=>{
    let h = 0;
    const str = String(key || '');
    for(let i = 0; i < str.length; i++)h = (h * 31 + str.charCodeAt(i)) % 360;
    return h;
};
function $2777cabbd6e4d7b5$var$_attachLiveCursors(el, scene, pz, cancelToken) {
    if (!el || !scene || scene.__liveCursorsAttached) return;
    scene.__liveCursorsAttached = true;
    const layer = document.createElement('div');
    layer.className = 'live-cursors-layer';
    layer.style.cssText = 'position:absolute;left:0;top:0;width:0;height:0;overflow:visible;pointer-events:none;z-index:80;';
    scene.appendChild(layer);
    const nodes = new Map() // peerId -> { node, img, label }
    ;
    const last = new Map() // peerId -> peer (for zoom-time repaint)
    ;
    const _scale = ()=>parseFloat(scene.style.getPropertyValue('--canvas-scale')) || 1;
    const _place = (entry, peer)=>{
        entry.node.style.transform = `translate3d(${peer.x}px, ${peer.y}px, 0) scale(${1 / _scale()})`;
    };
    const paint = (peerId, peer)=>{
        if (!peer) {
            const entry = nodes.get(peerId);
            if (entry) {
                entry.node.remove();
                nodes.delete(peerId);
            }
            last.delete(peerId);
            return;
        }
        let entry = nodes.get(peerId);
        if (!entry) {
            const hue = $2777cabbd6e4d7b5$var$_cursorHue(peer.userKey || peerId);
            const node = document.createElement('div');
            node.style.cssText = "position:absolute;left:0;top:0;display:flex;align-items:flex-start;gap:4px;transform-origin:0 0;transition:transform 80ms linear;will-change:transform;";
            // Pointer glyph + avatar + name chip. Peer-controlled text goes in via
            // textContent ONLY (never markup). The glyph is the brand sprite's
            // `cursor` symbol — the `<use>` markup the Icon atom renders — tinted
            // through currentColor; the viewBox crops the 24-unit symbol to its
            // pointer, so the tip sits on the peer's point.
            node.innerHTML = `<svg width="13" height="20" viewBox="5.5 2.5 13 20" aria-hidden="true" style="flex-shrink:0;color:hsl(${hue} 75% 55%);filter:drop-shadow(0 1px 2px rgba(0,0,0,0.35))" stroke="white" stroke-width="1"><use xlink:href="#cursor" width="24" height="24"/></svg>` + `<span style="display:flex;align-items:center;gap:5px;margin-top:10px;padding:2px 7px 2px 3px;border-radius:999px;background:hsl(${hue} 75% 45%);box-shadow:0 1px 4px rgba(0,0,0,0.3)">` + `<img alt="" style="width:16px;height:16px;border-radius:50%;display:block"/>` + `<span style="font-size:11px;font-weight:700;color:#fff;white-space:nowrap;line-height:1.4"></span>` + '</span>';
            layer.appendChild(node);
            entry = {
                node: node,
                img: node.querySelector('img'),
                label: node.querySelector('span span')
            };
            nodes.set(peerId, entry);
        }
        if (peer.name && entry.label.textContent !== peer.name) entry.label.textContent = peer.name;
        if (peer.userKey && !entry.img.__src) {
            entry.img.__src = true;
            try {
                entry.img.src = el.call('avatarUrlFor', peer.userKey) || '';
            } catch (_) {
                entry.img.style.display = 'none';
            }
        }
        last.set(peerId, peer);
        _place(entry, peer);
    };
    // `let` + a rejoin path: the channel scope derives from root.currentPath,
    // which canonicalizes ASYNC during boot ('/' → '/w/<ws>' → the page path) —
    // a join made mid-boot lands on a stale scope and would never hear the
    // peers on the real one. The lifecheck below re-joins when the surface
    // scope drifts (also covers the signed-out-at-attach case: scope null →
    // joins once auth lands).
    let ch = el.call('liveCursorsJoin', paint) || {
        scope: null,
        send: ()=>{},
        leave: ()=>{}
    };
    // Zoom changes must counter-scale existing sprites even when no peer moved.
    pz.on('transform', ()=>{
        for (const [peerId, peer] of last){
            const entry = nodes.get(peerId);
            if (entry) _place(entry, peer);
        }
    });
    // Broadcast my pointer in CONTENT coordinates. The scene's bounding rect is
    // the transformed content box, so (client - rect) / scale needs no matrix
    // math and no panzoom internals.
    const vp = scene.parentElement || scene;
    const onMove = (e)=>{
        const rect = scene.getBoundingClientRect();
        const scale = rect.width / (scene.offsetWidth || 1);
        ch.send({
            x: (e.clientX - rect.left) / scale,
            y: (e.clientY - rect.top) / scale
        });
    };
    const onLeave = ()=>ch.send({
            gone: true
        });
    vp.addEventListener('pointermove', onMove, {
        passive: true
    });
    vp.addEventListener('pointerleave', onLeave, {
        passive: true
    });
    // Lifecycle without per-page wiring: when the board unmounts (scene leaves
    // the DOM) or the page cancels its panzoom boot, release everything —
    // the channel ref-count closes the socket with the last board. The same
    // tick heals scope drift: if the surface scope the root NOW resolves to
    // differs from the channel's (mid-boot path canonicalization, workspace
    // switch), leave and re-join so the overlay always listens on the scope
    // peers are actually sending to.
    const lifecheck = setInterval(()=>{
        if (cancelToken?.canceled || !scene.isConnected) {
            clearInterval(lifecheck);
            vp.removeEventListener('pointermove', onMove);
            vp.removeEventListener('pointerleave', onLeave);
            try {
                ch.leave();
            } catch (_) {}
            layer.remove();
            scene.__liveCursorsAttached = false;
            return;
        }
        const want = el.call('liveCursorsScope');
        if (want && want !== ch.scope) {
            try {
                ch.leave();
            } catch (_) {}
            for (const entry of nodes.values())entry.node.remove();
            nodes.clear();
            last.clear();
            ch = el.call('liveCursorsJoin', paint) || ch;
        }
    }, 2000);
}

});
parcelRegister("gBVY4", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                'use strict';
                /**
 * Allows to drag and zoom svg elements
 */ var wheel = require1('wheel');
                var animate = require1('amator');
                var eventify = require1('ngraph.events');
                var kinetic = require1('./lib/kinetic.js');
                var createTextSelectionInterceptor = require1('./lib/makeTextSelectionInterceptor.js');
                var domTextSelectionInterceptor = createTextSelectionInterceptor();
                var fakeTextSelectorInterceptor = createTextSelectionInterceptor(true);
                var Transform = require1('./lib/transform.js');
                var makeSvgController = require1('./lib/makeSvgController.js');
                var makeDomController = require1('./lib/makeDomController.js');
                var defaultZoomSpeed = 1;
                var defaultDoubleTapZoomSpeed = 1.75;
                var doubleTapSpeedInMS = 300;
                var clickEventTimeInMS = 200;
                module1.exports = createPanZoom;
                /**
 * Creates a new instance of panzoom, so that an object can be panned and zoomed
 *
 * @param {DOMElement} domElement where panzoom should be attached.
 * @param {Object} options that configure behavior.
 */ function createPanZoom(domElement, options) {
                    options = options || {};
                    var panController = options.controller;
                    if (!panController) {
                        if (makeSvgController.canAttach(domElement)) panController = makeSvgController(domElement, options);
                        else if (makeDomController.canAttach(domElement)) panController = makeDomController(domElement, options);
                    }
                    if (!panController) throw new Error('Cannot create panzoom for the current type of dom element');
                    var owner = panController.getOwner();
                    // just to avoid GC pressure, every time we do intermediate transform
                    // we return this object. For internal use only. Never give it back to the consumer of this library
                    var storedCTMResult = {
                        x: 0,
                        y: 0
                    };
                    var isDirty = false;
                    var transform = new Transform();
                    if (panController.initTransform) panController.initTransform(transform);
                    var filterKey = typeof options.filterKey === 'function' ? options.filterKey : noop;
                    // TODO: likely need to unite pinchSpeed with zoomSpeed
                    var pinchSpeed = typeof options.pinchSpeed === 'number' ? options.pinchSpeed : 1;
                    var bounds = options.bounds;
                    var maxZoom = typeof options.maxZoom === 'number' ? options.maxZoom : Number.POSITIVE_INFINITY;
                    var minZoom = typeof options.minZoom === 'number' ? options.minZoom : 0;
                    var boundsPadding = typeof options.boundsPadding === 'number' ? options.boundsPadding : 0.05;
                    var zoomDoubleClickSpeed = typeof options.zoomDoubleClickSpeed === 'number' ? options.zoomDoubleClickSpeed : defaultDoubleTapZoomSpeed;
                    var beforeWheel = options.beforeWheel || noop;
                    var beforeMouseDown = options.beforeMouseDown || noop;
                    var speed = typeof options.zoomSpeed === 'number' ? options.zoomSpeed : defaultZoomSpeed;
                    var transformOrigin = parseTransformOrigin(options.transformOrigin);
                    var textSelection = options.enableTextSelection ? fakeTextSelectorInterceptor : domTextSelectionInterceptor;
                    validateBounds(bounds);
                    if (options.autocenter) autocenter();
                    var frameAnimation;
                    var lastTouchEndTime = 0;
                    var lastTouchStartTime = 0;
                    var pendingClickEventTimeout = 0;
                    var lastMouseDownedEvent = null;
                    var lastMouseDownTime = new Date();
                    var lastSingleFingerOffset;
                    var touchInProgress = false;
                    // We only need to fire panstart when actual move happens
                    var panstartFired = false;
                    // cache mouse coordinates here
                    var mouseX;
                    var mouseY;
                    // Where the first click has happened, so that we can differentiate
                    // between pan and click
                    var clickX;
                    var clickY;
                    var pinchZoomLength;
                    var smoothScroll;
                    if ('smoothScroll' in options && !options.smoothScroll) // If user explicitly asked us not to use smooth scrolling, we obey
                    smoothScroll = rigidScroll();
                    else // otherwise we use forward smoothScroll settings to kinetic API
                    // which makes scroll smoothing.
                    smoothScroll = kinetic(getPoint, scroll, options.smoothScroll);
                    var moveByAnimation;
                    var zoomToAnimation;
                    var multiTouch;
                    var paused = false;
                    listenForEvents();
                    var api = {
                        dispose: dispose,
                        moveBy: internalMoveBy,
                        moveTo: moveTo,
                        smoothMoveTo: smoothMoveTo,
                        centerOn: centerOn,
                        zoomTo: publicZoomTo,
                        zoomAbs: zoomAbs,
                        smoothZoom: smoothZoom,
                        smoothZoomAbs: smoothZoomAbs,
                        showRectangle: showRectangle,
                        pause: pause,
                        resume: resume,
                        isPaused: isPaused,
                        getTransform: getTransformModel,
                        getMinZoom: getMinZoom,
                        setMinZoom: setMinZoom,
                        getMaxZoom: getMaxZoom,
                        setMaxZoom: setMaxZoom,
                        getTransformOrigin: getTransformOrigin,
                        setTransformOrigin: setTransformOrigin,
                        getZoomSpeed: getZoomSpeed,
                        setZoomSpeed: setZoomSpeed
                    };
                    eventify(api);
                    var initialX = typeof options.initialX === 'number' ? options.initialX : transform.x;
                    var initialY = typeof options.initialY === 'number' ? options.initialY : transform.y;
                    var initialZoom = typeof options.initialZoom === 'number' ? options.initialZoom : transform.scale;
                    if (initialX != transform.x || initialY != transform.y || initialZoom != transform.scale) zoomAbs(initialX, initialY, initialZoom);
                    return api;
                    function pause() {
                        releaseEvents();
                        paused = true;
                    }
                    function resume() {
                        if (paused) {
                            listenForEvents();
                            paused = false;
                        }
                    }
                    function isPaused() {
                        return paused;
                    }
                    function showRectangle(rect) {
                        // TODO: this duplicates autocenter. I think autocenter should go.
                        var clientRect = owner.getBoundingClientRect();
                        var size = transformToScreen(clientRect.width, clientRect.height);
                        var rectWidth = rect.right - rect.left;
                        var rectHeight = rect.bottom - rect.top;
                        if (!Number.isFinite(rectWidth) || !Number.isFinite(rectHeight)) throw new Error('Invalid rectangle');
                        var dw = size.x / rectWidth;
                        var dh = size.y / rectHeight;
                        var scale = Math.min(dw, dh);
                        transform.x = -(rect.left + rectWidth / 2) * scale + size.x / 2;
                        transform.y = -(rect.top + rectHeight / 2) * scale + size.y / 2;
                        transform.scale = scale;
                    }
                    function transformToScreen(x, y) {
                        if (panController.getScreenCTM) {
                            var parentCTM = panController.getScreenCTM();
                            var parentScaleX = parentCTM.a;
                            var parentScaleY = parentCTM.d;
                            var parentOffsetX = parentCTM.e;
                            var parentOffsetY = parentCTM.f;
                            storedCTMResult.x = x * parentScaleX - parentOffsetX;
                            storedCTMResult.y = y * parentScaleY - parentOffsetY;
                        } else {
                            storedCTMResult.x = x;
                            storedCTMResult.y = y;
                        }
                        return storedCTMResult;
                    }
                    function autocenter() {
                        var w; // width of the parent
                        var h; // height of the parent
                        var left = 0;
                        var top = 0;
                        var sceneBoundingBox = getBoundingBox();
                        if (sceneBoundingBox) {
                            // If we have bounding box - use it.
                            left = sceneBoundingBox.left;
                            top = sceneBoundingBox.top;
                            w = sceneBoundingBox.right - sceneBoundingBox.left;
                            h = sceneBoundingBox.bottom - sceneBoundingBox.top;
                        } else {
                            // otherwise just use whatever space we have
                            var ownerRect = owner.getBoundingClientRect();
                            w = ownerRect.width;
                            h = ownerRect.height;
                        }
                        var bbox = panController.getBBox();
                        if (bbox.width === 0 || bbox.height === 0) // we probably do not have any elements in the SVG
                        // just bail out;
                        return;
                        var dh = h / bbox.height;
                        var dw = w / bbox.width;
                        var scale = Math.min(dw, dh);
                        transform.x = -(bbox.left + bbox.width / 2) * scale + w / 2 + left;
                        transform.y = -(bbox.top + bbox.height / 2) * scale + h / 2 + top;
                        transform.scale = scale;
                    }
                    function getTransformModel() {
                        // TODO: should this be read only?
                        return transform;
                    }
                    function getMinZoom() {
                        return minZoom;
                    }
                    function setMinZoom(newMinZoom) {
                        minZoom = newMinZoom;
                    }
                    function getMaxZoom() {
                        return maxZoom;
                    }
                    function setMaxZoom(newMaxZoom) {
                        maxZoom = newMaxZoom;
                    }
                    function getTransformOrigin() {
                        return transformOrigin;
                    }
                    function setTransformOrigin(newTransformOrigin) {
                        transformOrigin = parseTransformOrigin(newTransformOrigin);
                    }
                    function getZoomSpeed() {
                        return speed;
                    }
                    function setZoomSpeed(newSpeed) {
                        if (!Number.isFinite(newSpeed)) throw new Error('Zoom speed should be a number');
                        speed = newSpeed;
                    }
                    function getPoint() {
                        return {
                            x: transform.x,
                            y: transform.y
                        };
                    }
                    function moveTo(x, y) {
                        transform.x = x;
                        transform.y = y;
                        keepTransformInsideBounds();
                        triggerEvent('pan');
                        makeDirty();
                    }
                    function moveBy(dx, dy) {
                        moveTo(transform.x + dx, transform.y + dy);
                    }
                    function keepTransformInsideBounds() {
                        var boundingBox = getBoundingBox();
                        if (!boundingBox) return;
                        var adjusted = false;
                        var clientRect = getClientRect();
                        var diff = boundingBox.left - clientRect.right;
                        if (diff > 0) {
                            transform.x += diff;
                            adjusted = true;
                        }
                        // check the other side:
                        diff = boundingBox.right - clientRect.left;
                        if (diff < 0) {
                            transform.x += diff;
                            adjusted = true;
                        }
                        // y axis:
                        diff = boundingBox.top - clientRect.bottom;
                        if (diff > 0) {
                            // we adjust transform, so that it matches exactly our bounding box:
                            // transform.y = boundingBox.top - (boundingBox.height + boundingBox.y) * transform.scale =>
                            // transform.y = boundingBox.top - (clientRect.bottom - transform.y) =>
                            // transform.y = diff + transform.y =>
                            transform.y += diff;
                            adjusted = true;
                        }
                        diff = boundingBox.bottom - clientRect.top;
                        if (diff < 0) {
                            transform.y += diff;
                            adjusted = true;
                        }
                        return adjusted;
                    }
                    /**
   * Returns bounding box that should be used to restrict scene movement.
   */ function getBoundingBox() {
                        if (!bounds) return; // client does not want to restrict movement
                        if (typeof bounds === 'boolean') {
                            // for boolean type we use parent container bounds
                            var ownerRect = owner.getBoundingClientRect();
                            var sceneWidth = ownerRect.width;
                            var sceneHeight = ownerRect.height;
                            return {
                                left: sceneWidth * boundsPadding,
                                top: sceneHeight * boundsPadding,
                                right: sceneWidth * (1 - boundsPadding),
                                bottom: sceneHeight * (1 - boundsPadding)
                            };
                        }
                        return bounds;
                    }
                    function getClientRect() {
                        var bbox = panController.getBBox();
                        var leftTop = client(bbox.left, bbox.top);
                        return {
                            left: leftTop.x,
                            top: leftTop.y,
                            right: bbox.width * transform.scale + leftTop.x,
                            bottom: bbox.height * transform.scale + leftTop.y
                        };
                    }
                    function client(x, y) {
                        return {
                            x: x * transform.scale + transform.x,
                            y: y * transform.scale + transform.y
                        };
                    }
                    function makeDirty() {
                        isDirty = true;
                        frameAnimation = window.requestAnimationFrame(frame);
                    }
                    function zoomByRatio(clientX, clientY, ratio) {
                        if (isNaN(clientX) || isNaN(clientY) || isNaN(ratio)) throw new Error('zoom requires valid numbers');
                        var newScale = transform.scale * ratio;
                        if (newScale < minZoom) {
                            if (transform.scale === minZoom) return;
                            ratio = minZoom / transform.scale;
                        }
                        if (newScale > maxZoom) {
                            if (transform.scale === maxZoom) return;
                            ratio = maxZoom / transform.scale;
                        }
                        var size = transformToScreen(clientX, clientY);
                        transform.x = size.x - ratio * (size.x - transform.x);
                        transform.y = size.y - ratio * (size.y - transform.y);
                        // TODO: https://github.com/anvaka/panzoom/issues/112
                        if (bounds && boundsPadding === 1 && minZoom === 1) {
                            transform.scale *= ratio;
                            keepTransformInsideBounds();
                        } else {
                            var transformAdjusted = keepTransformInsideBounds();
                            if (!transformAdjusted) transform.scale *= ratio;
                        }
                        triggerEvent('zoom');
                        makeDirty();
                    }
                    function zoomAbs(clientX, clientY, zoomLevel) {
                        var ratio = zoomLevel / transform.scale;
                        zoomByRatio(clientX, clientY, ratio);
                    }
                    function centerOn(ui) {
                        var parent = ui.ownerSVGElement;
                        if (!parent) throw new Error('ui element is required to be within the scene');
                        // TODO: should i use controller's screen CTM?
                        var clientRect = ui.getBoundingClientRect();
                        var cx = clientRect.left + clientRect.width / 2;
                        var cy = clientRect.top + clientRect.height / 2;
                        var container = parent.getBoundingClientRect();
                        var dx = container.width / 2 - cx;
                        var dy = container.height / 2 - cy;
                        internalMoveBy(dx, dy, true);
                    }
                    function smoothMoveTo(x, y) {
                        internalMoveBy(x - transform.x, y - transform.y, true);
                    }
                    function internalMoveBy(dx, dy, smooth) {
                        if (!smooth) return moveBy(dx, dy);
                        if (moveByAnimation) moveByAnimation.cancel();
                        var from = {
                            x: 0,
                            y: 0
                        };
                        var to = {
                            x: dx,
                            y: dy
                        };
                        var lastX = 0;
                        var lastY = 0;
                        moveByAnimation = animate(from, to, {
                            step: function(v) {
                                moveBy(v.x - lastX, v.y - lastY);
                                lastX = v.x;
                                lastY = v.y;
                            }
                        });
                    }
                    function scroll(x, y) {
                        cancelZoomAnimation();
                        moveTo(x, y);
                    }
                    function dispose() {
                        releaseEvents();
                    }
                    function listenForEvents() {
                        owner.addEventListener('mousedown', onMouseDown, {
                            passive: false
                        });
                        owner.addEventListener('dblclick', onDoubleClick, {
                            passive: false
                        });
                        owner.addEventListener('touchstart', onTouch, {
                            passive: false
                        });
                        owner.addEventListener('keydown', onKeyDown, {
                            passive: false
                        });
                        // Need to listen on the owner container, so that we are not limited
                        // by the size of the scrollable domElement
                        wheel.addWheelListener(owner, onMouseWheel, {
                            passive: false
                        });
                        makeDirty();
                    }
                    function releaseEvents() {
                        wheel.removeWheelListener(owner, onMouseWheel);
                        owner.removeEventListener('mousedown', onMouseDown);
                        owner.removeEventListener('keydown', onKeyDown);
                        owner.removeEventListener('dblclick', onDoubleClick);
                        owner.removeEventListener('touchstart', onTouch);
                        if (frameAnimation) {
                            window.cancelAnimationFrame(frameAnimation);
                            frameAnimation = 0;
                        }
                        smoothScroll.cancel();
                        releaseDocumentMouse();
                        releaseTouches();
                        textSelection.release();
                        triggerPanEnd();
                    }
                    function frame() {
                        if (isDirty) applyTransform();
                    }
                    function applyTransform() {
                        isDirty = false;
                        // TODO: Should I allow to cancel this?
                        panController.applyTransform(transform);
                        triggerEvent('transform');
                        frameAnimation = 0;
                    }
                    function onKeyDown(e) {
                        var x = 0, y = 0, z = 0;
                        if (e.keyCode === 38) y = 1; // up
                        else if (e.keyCode === 40) y = -1; // down
                        else if (e.keyCode === 37) x = 1; // left
                        else if (e.keyCode === 39) x = -1; // right
                        else if (e.keyCode === 189 || e.keyCode === 109) // DASH or SUBTRACT
                        z = 1; // `-` -  zoom out
                        else if (e.keyCode === 187 || e.keyCode === 107) // EQUAL SIGN or ADD
                        z = -1; // `=` - zoom in (equal sign on US layout is under `+`)
                        if (filterKey(e, x, y, z)) // They don't want us to handle the key: https://github.com/anvaka/panzoom/issues/45
                        return;
                        if (x || y) {
                            e.preventDefault();
                            e.stopPropagation();
                            var clientRect = owner.getBoundingClientRect();
                            // movement speed should be the same in both X and Y direction:
                            var offset = Math.min(clientRect.width, clientRect.height);
                            var moveSpeedRatio = 0.05;
                            var dx = offset * moveSpeedRatio * x;
                            var dy = offset * moveSpeedRatio * y;
                            // TODO: currently we do not animate this. It could be better to have animation
                            internalMoveBy(dx, dy);
                        }
                        if (z) {
                            var scaleMultiplier = getScaleMultiplier(z * 100);
                            var offset = transformOrigin ? getTransformOriginOffset() : midPoint();
                            publicZoomTo(offset.x, offset.y, scaleMultiplier);
                        }
                    }
                    function midPoint() {
                        var ownerRect = owner.getBoundingClientRect();
                        return {
                            x: ownerRect.width / 2,
                            y: ownerRect.height / 2
                        };
                    }
                    function onTouch(e) {
                        // let them override the touch behavior
                        beforeTouch(e);
                        clearPendingClickEventTimeout();
                        if (e.touches.length === 1) return handleSingleFingerTouch(e, e.touches[0]);
                        else if (e.touches.length === 2) {
                            // handleTouchMove() will care about pinch zoom.
                            pinchZoomLength = getPinchZoomLength(e.touches[0], e.touches[1]);
                            multiTouch = true;
                            startTouchListenerIfNeeded();
                        }
                    }
                    function beforeTouch(e) {
                        // TODO: Need to unify this filtering names. E.g. use `beforeTouch`
                        if (options.onTouch && !options.onTouch(e)) // if they return `false` from onTouch, we don't want to stop
                        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/12
                        return;
                        e.stopPropagation();
                        e.preventDefault();
                    }
                    function beforeDoubleClick(e) {
                        clearPendingClickEventTimeout();
                        // TODO: Need to unify this filtering names. E.g. use `beforeDoubleClick``
                        if (options.onDoubleClick && !options.onDoubleClick(e)) // if they return `false` from onTouch, we don't want to stop
                        // events propagation. Fixes https://github.com/anvaka/panzoom/issues/46
                        return;
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    function handleSingleFingerTouch(e) {
                        lastTouchStartTime = new Date();
                        var touch = e.touches[0];
                        var offset = getOffsetXY(touch);
                        lastSingleFingerOffset = offset;
                        var point = transformToScreen(offset.x, offset.y);
                        mouseX = point.x;
                        mouseY = point.y;
                        clickX = mouseX;
                        clickY = mouseY;
                        smoothScroll.cancel();
                        startTouchListenerIfNeeded();
                    }
                    function startTouchListenerIfNeeded() {
                        if (touchInProgress) // no need to do anything, as we already listen to events;
                        return;
                        touchInProgress = true;
                        document.addEventListener('touchmove', handleTouchMove);
                        document.addEventListener('touchend', handleTouchEnd);
                        document.addEventListener('touchcancel', handleTouchEnd);
                    }
                    function handleTouchMove(e) {
                        if (e.touches.length === 1) {
                            e.stopPropagation();
                            var touch = e.touches[0];
                            var offset = getOffsetXY(touch);
                            var point = transformToScreen(offset.x, offset.y);
                            var dx = point.x - mouseX;
                            var dy = point.y - mouseY;
                            if (dx !== 0 && dy !== 0) triggerPanStart();
                            mouseX = point.x;
                            mouseY = point.y;
                            internalMoveBy(dx, dy);
                        } else if (e.touches.length === 2) {
                            // it's a zoom, let's find direction
                            multiTouch = true;
                            var t1 = e.touches[0];
                            var t2 = e.touches[1];
                            var currentPinchLength = getPinchZoomLength(t1, t2);
                            // since the zoom speed is always based on distance from 1, we need to apply
                            // pinch speed only on that distance from 1:
                            var scaleMultiplier = 1 + (currentPinchLength / pinchZoomLength - 1) * pinchSpeed;
                            var firstTouchPoint = getOffsetXY(t1);
                            var secondTouchPoint = getOffsetXY(t2);
                            mouseX = (firstTouchPoint.x + secondTouchPoint.x) / 2;
                            mouseY = (firstTouchPoint.y + secondTouchPoint.y) / 2;
                            if (transformOrigin) {
                                var offset = getTransformOriginOffset();
                                mouseX = offset.x;
                                mouseY = offset.y;
                            }
                            publicZoomTo(mouseX, mouseY, scaleMultiplier);
                            pinchZoomLength = currentPinchLength;
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    }
                    function clearPendingClickEventTimeout() {
                        if (pendingClickEventTimeout) {
                            clearTimeout(pendingClickEventTimeout);
                            pendingClickEventTimeout = 0;
                        }
                    }
                    function handlePotentialClickEvent(e) {
                        // we could still be in the double tap mode, let's wait until double tap expires,
                        // and then notify:
                        if (!options.onClick) return;
                        clearPendingClickEventTimeout();
                        var dx = mouseX - clickX;
                        var dy = mouseY - clickY;
                        var l = Math.sqrt(dx * dx + dy * dy);
                        if (l > 5) return; // probably they are panning, ignore it
                        pendingClickEventTimeout = setTimeout(function() {
                            pendingClickEventTimeout = 0;
                            options.onClick(e);
                        }, doubleTapSpeedInMS);
                    }
                    function handleTouchEnd(e) {
                        clearPendingClickEventTimeout();
                        if (e.touches.length > 0) {
                            var offset = getOffsetXY(e.touches[0]);
                            var point = transformToScreen(offset.x, offset.y);
                            mouseX = point.x;
                            mouseY = point.y;
                        } else {
                            var now = new Date();
                            if (now - lastTouchEndTime < doubleTapSpeedInMS) {
                                // They did a double tap here
                                if (transformOrigin) {
                                    var offset = getTransformOriginOffset();
                                    smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
                                } else // We want untransformed x/y here.
                                smoothZoom(lastSingleFingerOffset.x, lastSingleFingerOffset.y, zoomDoubleClickSpeed);
                            } else if (now - lastTouchStartTime < clickEventTimeInMS) handlePotentialClickEvent(e);
                            lastTouchEndTime = now;
                            triggerPanEnd();
                            releaseTouches();
                        }
                    }
                    function getPinchZoomLength(finger1, finger2) {
                        var dx = finger1.clientX - finger2.clientX;
                        var dy = finger1.clientY - finger2.clientY;
                        return Math.sqrt(dx * dx + dy * dy);
                    }
                    function onDoubleClick(e) {
                        beforeDoubleClick(e);
                        var offset = getOffsetXY(e);
                        if (transformOrigin) // TODO: looks like this is duplicated in the file.
                        // Need to refactor
                        offset = getTransformOriginOffset();
                        smoothZoom(offset.x, offset.y, zoomDoubleClickSpeed);
                    }
                    function onMouseDown(e) {
                        clearPendingClickEventTimeout();
                        // if client does not want to handle this event - just ignore the call
                        if (beforeMouseDown(e)) return;
                        lastMouseDownedEvent = e;
                        lastMouseDownTime = new Date();
                        if (touchInProgress) {
                            // modern browsers will fire mousedown for touch events too
                            // we do not want this: touch is handled separately.
                            e.stopPropagation();
                            return false;
                        }
                        // for IE, left click == 1
                        // for Firefox, left click == 0
                        var isLeftButton = e.button === 1 && window.event !== null || e.button === 0;
                        if (!isLeftButton) return;
                        smoothScroll.cancel();
                        var offset = getOffsetXY(e);
                        var point = transformToScreen(offset.x, offset.y);
                        clickX = mouseX = point.x;
                        clickY = mouseY = point.y;
                        // We need to listen on document itself, since mouse can go outside of the
                        // window, and we will loose it
                        document.addEventListener('mousemove', onMouseMove);
                        document.addEventListener('mouseup', onMouseUp);
                        textSelection.capture(e.target || e.srcElement);
                        return false;
                    }
                    function onMouseMove(e) {
                        // no need to worry about mouse events when touch is happening
                        if (touchInProgress) return;
                        triggerPanStart();
                        var offset = getOffsetXY(e);
                        var point = transformToScreen(offset.x, offset.y);
                        var dx = point.x - mouseX;
                        var dy = point.y - mouseY;
                        mouseX = point.x;
                        mouseY = point.y;
                        internalMoveBy(dx, dy);
                    }
                    function onMouseUp() {
                        var now = new Date();
                        if (now - lastMouseDownTime < clickEventTimeInMS) handlePotentialClickEvent(lastMouseDownedEvent);
                        textSelection.release();
                        triggerPanEnd();
                        releaseDocumentMouse();
                    }
                    function releaseDocumentMouse() {
                        document.removeEventListener('mousemove', onMouseMove);
                        document.removeEventListener('mouseup', onMouseUp);
                        panstartFired = false;
                    }
                    function releaseTouches() {
                        document.removeEventListener('touchmove', handleTouchMove);
                        document.removeEventListener('touchend', handleTouchEnd);
                        document.removeEventListener('touchcancel', handleTouchEnd);
                        panstartFired = false;
                        multiTouch = false;
                        touchInProgress = false;
                    }
                    function onMouseWheel(e) {
                        // if client does not want to handle this event - just ignore the call
                        if (beforeWheel(e)) return;
                        smoothScroll.cancel();
                        var delta = e.deltaY;
                        if (e.deltaMode > 0) delta *= 100;
                        var scaleMultiplier = getScaleMultiplier(delta);
                        if (scaleMultiplier !== 1) {
                            var offset = transformOrigin ? getTransformOriginOffset() : getOffsetXY(e);
                            publicZoomTo(offset.x, offset.y, scaleMultiplier);
                            e.preventDefault();
                        }
                    }
                    function getOffsetXY(e) {
                        var offsetX, offsetY;
                        // I tried using e.offsetX, but that gives wrong results for svg, when user clicks on a path.
                        var ownerRect = owner.getBoundingClientRect();
                        offsetX = e.clientX - ownerRect.left;
                        offsetY = e.clientY - ownerRect.top;
                        return {
                            x: offsetX,
                            y: offsetY
                        };
                    }
                    function smoothZoom(clientX, clientY, scaleMultiplier) {
                        var fromValue = transform.scale;
                        var from = {
                            scale: fromValue
                        };
                        var to = {
                            scale: scaleMultiplier * fromValue
                        };
                        smoothScroll.cancel();
                        cancelZoomAnimation();
                        zoomToAnimation = animate(from, to, {
                            step: function(v) {
                                zoomAbs(clientX, clientY, v.scale);
                            },
                            done: triggerZoomEnd
                        });
                    }
                    function smoothZoomAbs(clientX, clientY, toScaleValue) {
                        var fromValue = transform.scale;
                        var from = {
                            scale: fromValue
                        };
                        var to = {
                            scale: toScaleValue
                        };
                        smoothScroll.cancel();
                        cancelZoomAnimation();
                        zoomToAnimation = animate(from, to, {
                            step: function(v) {
                                zoomAbs(clientX, clientY, v.scale);
                            },
                            done: triggerZoomEnd
                        });
                    }
                    function getTransformOriginOffset() {
                        var ownerRect = owner.getBoundingClientRect();
                        return {
                            x: ownerRect.width * transformOrigin.x,
                            y: ownerRect.height * transformOrigin.y
                        };
                    }
                    function publicZoomTo(clientX, clientY, scaleMultiplier) {
                        smoothScroll.cancel();
                        cancelZoomAnimation();
                        return zoomByRatio(clientX, clientY, scaleMultiplier);
                    }
                    function cancelZoomAnimation() {
                        if (zoomToAnimation) {
                            zoomToAnimation.cancel();
                            zoomToAnimation = null;
                        }
                    }
                    function getScaleMultiplier(delta) {
                        var sign = Math.sign(delta);
                        var deltaAdjustedSpeed = Math.min(0.25, Math.abs(speed * delta / 128));
                        return 1 - sign * deltaAdjustedSpeed;
                    }
                    function triggerPanStart() {
                        if (!panstartFired) {
                            triggerEvent('panstart');
                            panstartFired = true;
                            smoothScroll.start();
                        }
                    }
                    function triggerPanEnd() {
                        if (panstartFired) {
                            // we should never run smooth scrolling if it was multiTouch (pinch zoom animation):
                            if (!multiTouch) smoothScroll.stop();
                            triggerEvent('panend');
                        }
                    }
                    function triggerZoomEnd() {
                        triggerEvent('zoomend');
                    }
                    function triggerEvent(name) {
                        api.fire(name, api);
                    }
                }
                function parseTransformOrigin(options) {
                    if (!options) return;
                    if (typeof options === 'object') {
                        if (!isNumber(options.x) || !isNumber(options.y)) failTransformOrigin(options);
                        return options;
                    }
                    failTransformOrigin();
                }
                function failTransformOrigin(options) {
                    console.error(options);
                    throw new Error([
                        'Cannot parse transform origin.',
                        'Some good examples:',
                        '  "center center" can be achieved with {x: 0.5, y: 0.5}',
                        '  "top center" can be achieved with {x: 0.5, y: 0}',
                        '  "bottom right" can be achieved with {x: 1, y: 1}'
                    ].join('\n'));
                }
                function noop() {}
                function validateBounds(bounds) {
                    var boundsType = typeof bounds;
                    if (boundsType === 'undefined' || boundsType === 'boolean') return; // this is okay
                    // otherwise need to be more thorough:
                    var validBounds = isNumber(bounds.left) && isNumber(bounds.top) && isNumber(bounds.bottom) && isNumber(bounds.right);
                    if (!validBounds) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
                }
                function isNumber(x) {
                    return Number.isFinite(x);
                }
                // IE 11 does not support isNaN:
                function isNaN(value) {
                    if (Number.isNaN) return Number.isNaN(value);
                    return value !== value;
                }
                function rigidScroll() {
                    return {
                        start: noop,
                        stop: noop,
                        cancel: noop
                    };
                }
                function autoRun() {
                    if (typeof document === 'undefined') return;
                    var scripts = document.getElementsByTagName('script');
                    if (!scripts) return;
                    var panzoomScript;
                    for(var i = 0; i < scripts.length; ++i){
                        var x = scripts[i];
                        if (x.src && x.src.match(/\bpanzoom(\.min)?\.js/)) {
                            panzoomScript = x;
                            break;
                        }
                    }
                    if (!panzoomScript) return;
                    var query = panzoomScript.getAttribute('query');
                    if (!query) return;
                    var globalName = panzoomScript.getAttribute('name') || 'pz';
                    var started = Date.now();
                    tryAttach();
                    function tryAttach() {
                        var el = document.querySelector(query);
                        if (!el) {
                            var now = Date.now();
                            var elapsed = now - started;
                            if (elapsed < 2000) {
                                // Let's wait a bit
                                setTimeout(tryAttach, 100);
                                return;
                            }
                            // If we don't attach within 2 seconds to the target element, consider it a failure
                            console.error('Cannot find the panzoom element', globalName);
                            return;
                        }
                        var options = collectOptions(panzoomScript);
                        console.log(options);
                        window[globalName] = createPanZoom(el, options);
                    }
                    function collectOptions(script) {
                        var attrs = script.attributes;
                        var options = {};
                        for(var j = 0; j < attrs.length; ++j){
                            var attr = attrs[j];
                            var nameValue = getPanzoomAttributeNameValue(attr);
                            if (nameValue) options[nameValue.name] = nameValue.value;
                        }
                        return options;
                    }
                    function getPanzoomAttributeNameValue(attr) {
                        if (!attr.name) return;
                        var isPanZoomAttribute = attr.name[0] === 'p' && attr.name[1] === 'z' && attr.name[2] === '-';
                        if (!isPanZoomAttribute) return;
                        var name = attr.name.substr(3);
                        var value = JSON.parse(attr.value);
                        return {
                            name: name,
                            value: value
                        };
                    }
                }
                autoRun();
            },
            {
                "./lib/kinetic.js": 2,
                "./lib/makeDomController.js": 3,
                "./lib/makeSvgController.js": 4,
                "./lib/makeTextSelectionInterceptor.js": 5,
                "./lib/transform.js": 6,
                "amator": 7,
                "ngraph.events": 9,
                "wheel": 10
            }
        ],
        2: [
            function(require1, module1, exports) {
                /**
 * Allows smooth kinetic scrolling of the surface
 */ module1.exports = kinetic;
                function kinetic(getPoint, scroll, settings) {
                    if (typeof settings !== 'object') // setting could come as boolean, we should ignore it, and use an object.
                    settings = {};
                    var minVelocity = typeof settings.minVelocity === 'number' ? settings.minVelocity : 5;
                    var amplitude = typeof settings.amplitude === 'number' ? settings.amplitude : 0.25;
                    var cancelAnimationFrame1 = typeof settings.cancelAnimationFrame === 'function' ? settings.cancelAnimationFrame : getCancelAnimationFrame();
                    var requestAnimationFrame1 = typeof settings.requestAnimationFrame === 'function' ? settings.requestAnimationFrame : getRequestAnimationFrame();
                    var lastPoint;
                    var timestamp;
                    var timeConstant = 342;
                    var ticker;
                    var vx, targetX, ax;
                    var vy, targetY, ay;
                    var raf;
                    return {
                        start: start,
                        stop: stop,
                        cancel: dispose
                    };
                    function dispose() {
                        cancelAnimationFrame1(ticker);
                        cancelAnimationFrame1(raf);
                    }
                    function start() {
                        lastPoint = getPoint();
                        ax = ay = vx = vy = 0;
                        timestamp = new Date();
                        cancelAnimationFrame1(ticker);
                        cancelAnimationFrame1(raf);
                        // we start polling the point position to accumulate velocity
                        // Once we stop(), we will use accumulated velocity to keep scrolling
                        // an object.
                        ticker = requestAnimationFrame1(track);
                    }
                    function track() {
                        var now = Date.now();
                        var elapsed = now - timestamp;
                        timestamp = now;
                        var currentPoint = getPoint();
                        var dx = currentPoint.x - lastPoint.x;
                        var dy = currentPoint.y - lastPoint.y;
                        lastPoint = currentPoint;
                        var dt = 1000 / (1 + elapsed);
                        // moving average
                        vx = 0.8 * dx * dt + 0.2 * vx;
                        vy = 0.8 * dy * dt + 0.2 * vy;
                        ticker = requestAnimationFrame1(track);
                    }
                    function stop() {
                        cancelAnimationFrame1(ticker);
                        cancelAnimationFrame1(raf);
                        var currentPoint = getPoint();
                        targetX = currentPoint.x;
                        targetY = currentPoint.y;
                        timestamp = Date.now();
                        if (vx < -minVelocity || vx > minVelocity) {
                            ax = amplitude * vx;
                            targetX += ax;
                        }
                        if (vy < -minVelocity || vy > minVelocity) {
                            ay = amplitude * vy;
                            targetY += ay;
                        }
                        raf = requestAnimationFrame1(autoScroll);
                    }
                    function autoScroll() {
                        var elapsed = Date.now() - timestamp;
                        var moving = false;
                        var dx = 0;
                        var dy = 0;
                        if (ax) {
                            dx = -ax * Math.exp(-elapsed / timeConstant);
                            if (dx > 0.5 || dx < -0.5) moving = true;
                            else dx = ax = 0;
                        }
                        if (ay) {
                            dy = -ay * Math.exp(-elapsed / timeConstant);
                            if (dy > 0.5 || dy < -0.5) moving = true;
                            else dy = ay = 0;
                        }
                        if (moving) {
                            scroll(targetX + dx, targetY + dy);
                            raf = requestAnimationFrame1(autoScroll);
                        }
                    }
                }
                function getCancelAnimationFrame() {
                    if (typeof cancelAnimationFrame === 'function') return cancelAnimationFrame;
                    return clearTimeout;
                }
                function getRequestAnimationFrame() {
                    if (typeof requestAnimationFrame === 'function') return requestAnimationFrame;
                    return function(handler) {
                        return setTimeout(handler, 16);
                    };
                }
            },
            {}
        ],
        3: [
            function(require1, module1, exports) {
                module1.exports = makeDomController;
                module1.exports.canAttach = isDomElement;
                function makeDomController(domElement, options) {
                    var elementValid = isDomElement(domElement);
                    if (!elementValid) throw new Error('panzoom requires DOM element to be attached to the DOM tree');
                    var owner = domElement.parentElement;
                    domElement.scrollTop = 0;
                    if (!options.disableKeyboardInteraction) owner.setAttribute('tabindex', 0);
                    var api = {
                        getBBox: getBBox,
                        getOwner: getOwner,
                        applyTransform: applyTransform
                    };
                    return api;
                    function getOwner() {
                        return owner;
                    }
                    function getBBox() {
                        // TODO: We should probably cache this?
                        return {
                            left: 0,
                            top: 0,
                            width: domElement.clientWidth,
                            height: domElement.clientHeight
                        };
                    }
                    function applyTransform(transform) {
                        // TODO: Should we cache this?
                        domElement.style.transformOrigin = '0 0 0';
                        domElement.style.transform = 'matrix(' + transform.scale + ', 0, 0, ' + transform.scale + ', ' + transform.x + ', ' + transform.y + ')';
                    }
                }
                function isDomElement(element) {
                    return element && element.parentElement && element.style;
                }
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                module1.exports = makeSvgController;
                module1.exports.canAttach = isSVGElement;
                function makeSvgController(svgElement, options) {
                    if (!isSVGElement(svgElement)) throw new Error('svg element is required for svg.panzoom to work');
                    var owner = svgElement.ownerSVGElement;
                    if (!owner) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
                    if (!options.disableKeyboardInteraction) owner.setAttribute('tabindex', 0);
                    var api = {
                        getBBox: getBBox,
                        getScreenCTM: getScreenCTM,
                        getOwner: getOwner,
                        applyTransform: applyTransform,
                        initTransform: initTransform
                    };
                    return api;
                    function getOwner() {
                        return owner;
                    }
                    function getBBox() {
                        var boundingBox = svgElement.getBBox();
                        return {
                            left: boundingBox.x,
                            top: boundingBox.y,
                            width: boundingBox.width,
                            height: boundingBox.height
                        };
                    }
                    function getScreenCTM() {
                        var ctm = owner.getCTM();
                        if (!ctm) // This is likely firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=873106
                        // The code below is not entirely correct, but still better than nothing
                        return owner.getScreenCTM();
                        return ctm;
                    }
                    function initTransform(transform) {
                        var screenCTM = svgElement.getCTM();
                        // The above line returns null on Firefox
                        if (screenCTM === null) screenCTM = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix();
                        transform.x = screenCTM.e;
                        transform.y = screenCTM.f;
                        transform.scale = screenCTM.a;
                        owner.removeAttributeNS(null, 'viewBox');
                    }
                    function applyTransform(transform) {
                        svgElement.setAttribute('transform', 'matrix(' + transform.scale + ' 0 0 ' + transform.scale + ' ' + transform.x + ' ' + transform.y + ')');
                    }
                }
                function isSVGElement(element) {
                    return element && element.ownerSVGElement && element.getCTM;
                }
            },
            {}
        ],
        5: [
            function(require1, module1, exports) {
                /**
 * Disallows selecting text.
 */ module1.exports = makeTextSelectionInterceptor;
                function makeTextSelectionInterceptor(useFake) {
                    if (useFake) return {
                        capture: noop,
                        release: noop
                    };
                    var dragObject;
                    var prevSelectStart;
                    var prevDragStart;
                    var wasCaptured = false;
                    return {
                        capture: capture,
                        release: release
                    };
                    function capture(domObject) {
                        wasCaptured = true;
                        prevSelectStart = window.document.onselectstart;
                        prevDragStart = window.document.ondragstart;
                        window.document.onselectstart = disabled;
                        dragObject = domObject;
                        dragObject.ondragstart = disabled;
                    }
                    function release() {
                        if (!wasCaptured) return;
                        wasCaptured = false;
                        window.document.onselectstart = prevSelectStart;
                        if (dragObject) dragObject.ondragstart = prevDragStart;
                    }
                }
                function disabled(e) {
                    e.stopPropagation();
                    return false;
                }
                function noop() {}
            },
            {}
        ],
        6: [
            function(require1, module1, exports) {
                module1.exports = Transform;
                function Transform() {
                    this.x = 0;
                    this.y = 0;
                    this.scale = 1;
                }
            },
            {}
        ],
        7: [
            function(require1, module1, exports) {
                var BezierEasing = require1('bezier-easing');
                // Predefined set of animations. Similar to CSS easing functions
                var animations = {
                    ease: BezierEasing(0.25, 0.1, 0.25, 1),
                    easeIn: BezierEasing(0.42, 0, 1, 1),
                    easeOut: BezierEasing(0, 0, 0.58, 1),
                    easeInOut: BezierEasing(0.42, 0, 0.58, 1),
                    linear: BezierEasing(0, 0, 1, 1)
                };
                module1.exports = animate;
                module1.exports.makeAggregateRaf = makeAggregateRaf;
                module1.exports.sharedScheduler = makeAggregateRaf();
                function animate(source, target, options) {
                    var start = Object.create(null);
                    var diff = Object.create(null);
                    options = options || {};
                    // We let clients specify their own easing function
                    var easing = typeof options.easing === 'function' ? options.easing : animations[options.easing];
                    // if nothing is specified, default to ease (similar to CSS animations)
                    if (!easing) {
                        if (options.easing) console.warn('Unknown easing function in amator: ' + options.easing);
                        easing = animations.ease;
                    }
                    var step = typeof options.step === 'function' ? options.step : noop;
                    var done = typeof options.done === 'function' ? options.done : noop;
                    var scheduler = getScheduler(options.scheduler);
                    var keys = Object.keys(target);
                    keys.forEach(function(key) {
                        start[key] = source[key];
                        diff[key] = target[key] - source[key];
                    });
                    var durationInMs = typeof options.duration === 'number' ? options.duration : 400;
                    var durationInFrames = Math.max(1, durationInMs * 0.06) // 0.06 because 60 frames pers 1,000 ms
                    ;
                    var previousAnimationId;
                    var frame = 0;
                    previousAnimationId = scheduler.next(loop);
                    return {
                        cancel: cancel
                    };
                    function cancel() {
                        scheduler.cancel(previousAnimationId);
                        previousAnimationId = 0;
                    }
                    function loop() {
                        var t = easing(frame / durationInFrames);
                        frame += 1;
                        setValues(t);
                        if (frame <= durationInFrames) {
                            previousAnimationId = scheduler.next(loop);
                            step(source);
                        } else {
                            previousAnimationId = 0;
                            setTimeout(function() {
                                done(source);
                            }, 0);
                        }
                    }
                    function setValues(t) {
                        keys.forEach(function(key) {
                            source[key] = diff[key] * t + start[key];
                        });
                    }
                }
                function noop() {}
                function getScheduler(scheduler) {
                    if (!scheduler) {
                        var canRaf = typeof window !== 'undefined' && window.requestAnimationFrame;
                        return canRaf ? rafScheduler() : timeoutScheduler();
                    }
                    if (typeof scheduler.next !== 'function') throw new Error('Scheduler is supposed to have next(cb) function');
                    if (typeof scheduler.cancel !== 'function') throw new Error('Scheduler is supposed to have cancel(handle) function');
                    return scheduler;
                }
                function rafScheduler() {
                    return {
                        next: window.requestAnimationFrame.bind(window),
                        cancel: window.cancelAnimationFrame.bind(window)
                    };
                }
                function timeoutScheduler() {
                    return {
                        next: function(cb) {
                            return setTimeout(cb, 1000 / 60);
                        },
                        cancel: function(id) {
                            return clearTimeout(id);
                        }
                    };
                }
                function makeAggregateRaf() {
                    var frontBuffer = new Set();
                    var backBuffer = new Set();
                    var frameToken = 0;
                    return {
                        next: next,
                        cancel: next,
                        clearAll: clearAll
                    };
                    function clearAll() {
                        frontBuffer.clear();
                        backBuffer.clear();
                        cancelAnimationFrame(frameToken);
                        frameToken = 0;
                    }
                    function next(callback) {
                        backBuffer.add(callback);
                        renderNextFrame();
                    }
                    function renderNextFrame() {
                        if (!frameToken) frameToken = requestAnimationFrame(renderFrame);
                    }
                    function renderFrame() {
                        frameToken = 0;
                        var t = backBuffer;
                        backBuffer = frontBuffer;
                        frontBuffer = t;
                        frontBuffer.forEach(function(callback) {
                            callback();
                        });
                        frontBuffer.clear();
                    }
                    function cancel(callback) {
                        backBuffer.delete(callback);
                    }
                }
            },
            {
                "bezier-easing": 8
            }
        ],
        8: [
            function(require1, module1, exports) {
                /**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
                var NEWTON_ITERATIONS = 4;
                var NEWTON_MIN_SLOPE = 0.001;
                var SUBDIVISION_PRECISION = 0.0000001;
                var SUBDIVISION_MAX_ITERATIONS = 10;
                var kSplineTableSize = 11;
                var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
                var float32ArraySupported = typeof Float32Array === 'function';
                function A(aA1, aA2) {
                    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
                }
                function B(aA1, aA2) {
                    return 3.0 * aA2 - 6.0 * aA1;
                }
                function C(aA1) {
                    return 3.0 * aA1;
                }
                // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
                function calcBezier(aT, aA1, aA2) {
                    return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
                }
                // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
                function getSlope(aT, aA1, aA2) {
                    return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
                }
                function binarySubdivide(aX, aA, aB, mX1, mX2) {
                    var currentX, currentT, i = 0;
                    do {
                        currentT = aA + (aB - aA) / 2.0;
                        currentX = calcBezier(currentT, mX1, mX2) - aX;
                        if (currentX > 0.0) aB = currentT;
                        else aA = currentT;
                    }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
                    return currentT;
                }
                function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
                    for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                        var currentSlope = getSlope(aGuessT, mX1, mX2);
                        if (currentSlope === 0.0) return aGuessT;
                        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                        aGuessT -= currentX / currentSlope;
                    }
                    return aGuessT;
                }
                function LinearEasing(x) {
                    return x;
                }
                module1.exports = function bezier(mX1, mY1, mX2, mY2) {
                    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error('bezier x values must be in [0, 1] range');
                    if (mX1 === mY1 && mX2 === mY2) return LinearEasing;
                    // Precompute samples table
                    var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
                    for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
                    function getTForX(aX) {
                        var intervalStart = 0.0;
                        var currentSample = 1;
                        var lastSample = kSplineTableSize - 1;
                        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                        --currentSample;
                        // Interpolate to provide an initial guess for t
                        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
                        var guessForT = intervalStart + dist * kSampleStepSize;
                        var initialSlope = getSlope(guessForT, mX1, mX2);
                        if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                        else if (initialSlope === 0.0) return guessForT;
                        else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
                    }
                    return function BezierEasing(x) {
                        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                        if (x === 0) return 0;
                        if (x === 1) return 1;
                        return calcBezier(getTForX(x), mY1, mY2);
                    };
                };
            },
            {}
        ],
        9: [
            function(require1, module1, exports) {
                module1.exports = function eventify(subject) {
                    validateSubject(subject);
                    var eventsStorage = createEventsStorage(subject);
                    subject.on = eventsStorage.on;
                    subject.off = eventsStorage.off;
                    subject.fire = eventsStorage.fire;
                    return subject;
                };
                function createEventsStorage(subject) {
                    // Store all event listeners to this hash. Key is event name, value is array
                    // of callback records.
                    //
                    // A callback record consists of callback function and its optional context:
                    // { 'eventName' => [{callback: function, ctx: object}] }
                    var registeredEvents = Object.create(null);
                    return {
                        on: function(eventName, callback, ctx) {
                            if (typeof callback !== 'function') throw new Error('callback is expected to be a function');
                            var handlers = registeredEvents[eventName];
                            if (!handlers) handlers = registeredEvents[eventName] = [];
                            handlers.push({
                                callback: callback,
                                ctx: ctx
                            });
                            return subject;
                        },
                        off: function(eventName, callback) {
                            var wantToRemoveAll = typeof eventName === 'undefined';
                            if (wantToRemoveAll) {
                                // Killing old events storage should be enough in this case:
                                registeredEvents = Object.create(null);
                                return subject;
                            }
                            if (registeredEvents[eventName]) {
                                var deleteAllCallbacksForEvent = typeof callback !== 'function';
                                if (deleteAllCallbacksForEvent) delete registeredEvents[eventName];
                                else {
                                    var callbacks = registeredEvents[eventName];
                                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i].callback === callback) callbacks.splice(i, 1);
                                }
                            }
                            return subject;
                        },
                        fire: function(eventName) {
                            var callbacks = registeredEvents[eventName];
                            if (!callbacks) return subject;
                            var fireArguments;
                            if (arguments.length > 1) fireArguments = Array.prototype.splice.call(arguments, 1);
                            for(var i = 0; i < callbacks.length; ++i){
                                var callbackInfo = callbacks[i];
                                callbackInfo.callback.apply(callbackInfo.ctx, fireArguments);
                            }
                            return subject;
                        }
                    };
                }
                function validateSubject(subject) {
                    if (!subject) throw new Error('Eventify cannot use falsy object as events subject');
                    var reservedWords = [
                        'on',
                        'fire',
                        'off'
                    ];
                    for(var i = 0; i < reservedWords.length; ++i){
                        if (subject.hasOwnProperty(reservedWords[i])) throw new Error("Subject cannot be eventified, since it already has property '" + reservedWords[i] + "'");
                    }
                }
            },
            {}
        ],
        10: [
            function(require1, module1, exports) {
                /**
 * This module used to unify mouse wheel behavior between different browsers in 2014
 * Now it's just a wrapper around addEventListener('wheel');
 *
 * Usage:
 *  var addWheelListener = require('wheel').addWheelListener;
 *  var removeWheelListener = require('wheel').removeWheelListener;
 *  addWheelListener(domElement, function (e) {
 *    // mouse wheel event
 *  });
 *  removeWheelListener(domElement, function);
 */ module1.exports = addWheelListener;
                // But also expose "advanced" api with unsubscribe:
                module1.exports.addWheelListener = addWheelListener;
                module1.exports.removeWheelListener = removeWheelListener;
                function addWheelListener(element, listener, useCapture) {
                    element.addEventListener('wheel', listener, useCapture);
                }
                function removeWheelListener(element, listener, useCapture) {
                    element.removeEventListener('wheel', listener, useCapture);
                }
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});

});


parcelRegister("3Tdk0", function(module, exports) {

$parcel$export(module.exports, "registerCanvasPanzoom", () => $2d50d78d119e1462$export$76a36b085688a4c1);
$parcel$export(module.exports, "unregisterCanvasPanzoom", () => $2d50d78d119e1462$export$ff4008ae07d89055);
// registerCanvasPanzoom / unregisterCanvasPanzoom — the ONE documented way for a pan/zoom canvas, a shell page or
// an installed workspace MODULE's canvas page (manifest `canvasRoutes`), to drive the shell Zoombar.
//
// The root-mounted Zoombar (shared/components/Zoombar.js → ZoomInNavbar.js) reads the live canvas every frame from
// window.__canvasGlobalScope = { panzoomInstance, positions, scale }. The shell boards wrote that global
// themselves (tickets/pages/board.js onTransform …). A module never touches `window` (module publish audit, frank
// serialization), so it registers the instance it got from initPanzoomBoard instead:
//
//   const pz = el.call('initPanzoomBoard', { getScene, getDots, … })
//   el.call('registerCanvasPanzoom', pz, { fit: () => el.call('myFit') })   // −, %, +, presets and Fit drive pz
//   …
//   el.call('unregisterCanvasPanzoom', pz)                                    // in onBeforeRemove
//
// `fit` (optional) is what the Zoombar's Fit preset runs. It rides on the INSTANCE (`pz.__fit`, next to the v2
// project canvas's `pz.__v2` marker), never on the global scope: a board that writes __canvasGlobalScope itself
// (tickets, studios) replaces the instance and with it the fit, so the Zoombar can never offer a stale Fit that
// belongs to a canvas no longer on screen (ZoomInNavbar: a registered `__fit` wins over fitToSelection). Registering
// mirrors pz's transform into `positions` / `scale` — the % label and the presets read them — and returns the
// unregister function. Unregistering clears the scope only while `pz` is still the registered instance, so a canvas
// mounted after this one keeps its registration.
//
// Self-contained exports (FA204 / frank trap): no module-scope consts, no sibling calls.
function $2d50d78d119e1462$export$76a36b085688a4c1(pz, opts = {}) {
    if (typeof window === 'undefined' || !pz || typeof pz.getTransform !== 'function') return ()=>{};
    const gs = window.__canvasGlobalScope = window.__canvasGlobalScope || {};
    const sync = ()=>{
        const t = pz.getTransform();
        if (!gs.positions) gs.positions = {
            x: 0,
            y: 0
        };
        gs.positions.x = t.x;
        gs.positions.y = t.y;
        gs.scale = t.scale;
    };
    if (gs.panzoomInstance && gs.panzoomInstance !== pz) {
        const prev = gs.panzoomInstance;
        if (prev.__zoombarSync && typeof prev.off === 'function') prev.off('transform', prev.__zoombarSync);
        prev.__zoombarSync = null;
    }
    gs.panzoomInstance = pz;
    pz.__fit = opts && typeof opts.fit === 'function' ? opts.fit : null;
    pz.__zoombarSync = sync;
    sync();
    if (typeof pz.on === 'function') pz.on('transform', sync);
    return ()=>{
        const live = window.__canvasGlobalScope;
        if (!live || live.panzoomInstance !== pz) return;
        if (typeof pz.off === 'function') pz.off('transform', sync);
        pz.__zoombarSync = null;
        pz.__fit = null;
        live.panzoomInstance = null;
    };
}
function $2d50d78d119e1462$export$ff4008ae07d89055(pz) {
    if (typeof window === 'undefined' || !pz) return;
    const live = window.__canvasGlobalScope;
    if (!live || live.panzoomInstance !== pz) return;
    if (pz.__zoombarSync && typeof pz.off === 'function') pz.off('transform', pz.__zoombarSync);
    pz.__zoombarSync = null;
    pz.__fit = null;
    live.panzoomInstance = null;
}

});

parcelRegister("5L6sk", function(module, exports) {

$parcel$export(module.exports, "pointInRect", () => $4316598d05f5dfe4$export$ee6b921fdc6f9dbe);
$parcel$export(module.exports, "nodeUnderPoint", () => $4316598d05f5dfe4$export$6777de736bbdf484);
$parcel$export(module.exports, "bboxOfNodeIds", () => $4316598d05f5dfe4$export$e74063c01d0c8dc0);
$parcel$export(module.exports, "bezierPath", () => $4316598d05f5dfe4$export$9f6af2d830d44dad);
$parcel$export(module.exports, "bezierBetweenNodes", () => $4316598d05f5dfe4$export$9843c976fb215ccc);
// Stateless geometry helpers shared between canvas surfaces.
//
// These run against a positions map + a size lookup function — they
// don't read root.canvas.items[] like canvas/functions/canvas/geom.js
// does, so they work for /team-and-agents (which has its own
// `_tagPositions` + per-id PERSON_W/AGENT_W sizing) and any future
// canvas-style surface that doesn't adopt the v2 item state shape.
//
// What goes here vs canvas/geom.js:
//   - sharedGeom.js  : pure (positions, sizes) → result
//   - canvas/geom.js : reads root.canvas.* — tied to canvas v2 state.
// Studios still uses its own inline versions for now; we'll DRY those
// in a follow-up once the shared helpers prove out here.
// Inclusive point-in-rect test. Rect shape: `{ x, y, w, h }`.
const $4316598d05f5dfe4$export$ee6b921fdc6f9dbe = (x, y, rect)=>!!rect && x >= rect.x && x <= rect.x + rect.w && y >= rect.y && y <= rect.y + rect.h;
const $4316598d05f5dfe4$export$6777de736bbdf484 = ({ candidates: candidates, positions: positions, cx: cx, cy: cy, ignoreId: ignoreId = null })=>{
    if (!Array.isArray(candidates) || !positions) return null;
    for (const c of candidates){
        if (!c?.id || c.id === ignoreId) continue;
        const p = positions[c.id];
        if (!p) continue;
        if ($4316598d05f5dfe4$export$ee6b921fdc6f9dbe(cx, cy, {
            x: p.x,
            y: p.y,
            w: c.w,
            h: c.h
        })) return c.id;
    }
    return null;
};
const $4316598d05f5dfe4$export$e74063c01d0c8dc0 = ({ ids: ids, positions: positions, sizeOf: sizeOf })=>{
    if (!Array.isArray(ids) || !ids.length || !positions || typeof sizeOf !== 'function') return null;
    const rects = [];
    for (const id of ids){
        const p = positions[id];
        if (!p) continue;
        const { w: w, h: h } = sizeOf(id) || {};
        if (!w || !h) continue;
        rects.push({
            x: p.x,
            y: p.y,
            w: w,
            h: h
        });
    }
    if (!rects.length) return null;
    const minX = Math.min(...rects.map((r)=>r.x));
    const minY = Math.min(...rects.map((r)=>r.y));
    const maxX = Math.max(...rects.map((r)=>r.x + r.w));
    const maxY = Math.max(...rects.map((r)=>r.y + r.h));
    return {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY
    };
};
const $4316598d05f5dfe4$export$9f6af2d830d44dad = (fx, fy, tx, ty)=>{
    const cy = (fy + ty) / 2;
    return `M ${fx} ${fy} C ${fx} ${cy}, ${tx} ${cy}, ${tx} ${ty}`;
};
const $4316598d05f5dfe4$export$9843c976fb215ccc = ({ fromId: fromId, toId: toId, positions: positions, sizeOf: sizeOf })=>{
    const fp = positions?.[fromId];
    const tp = positions?.[toId];
    if (!fp || !tp) return '';
    const fs = sizeOf(fromId) || {};
    const ts = sizeOf(toId) || {};
    if (!fs.w || !ts.w) return '';
    const fx = fp.x + fs.w / 2;
    const fy = fp.y + fs.h / 2;
    const tx = tp.x + ts.w / 2;
    const ty = tp.y + ts.h / 2;
    return $4316598d05f5dfe4$export$9f6af2d830d44dad(fx, fy, tx, ty);
};

});

parcelRegister("9dqhI", function(module, exports) {

$parcel$export(module.exports, "tagNodeContextmenu", () => $01bb40e565a704f3$export$a647d49f7c54618b);
$parcel$export(module.exports, "tagNodeContextItems", () => $01bb40e565a704f3$export$a0fb18e9aa1cd96e);
$parcel$export(module.exports, "tagNodeContextAction", () => $01bb40e565a704f3$export$db8bce53ffcc7dee);
// Right-click context menu for /team-and-agents (+ /agents, which extends it)
// person + agent nodes. Opens the shared house ContextDropdown — the SAME
// component /files and the project canvas use, mounted globally in
// workspace/app.js. Registered in canvas/functions/index.js; the nodes call
// `tagNodeContextmenu` via el.call from their onContextmenu.
//
// Self-contained on purpose: the build-critical exports live here, NOT in the
// (large, frequently-edited) team-and-agents.js page, so a concurrent edit to
// the page can't break the functions re-export. The node click already opens
// the profile/agent editor; this menu adds the secondary actions.
// (2026-06-19 per Nika "add context menu on humans and agents".)
const $01bb40e565a704f3$var$_canvasRoot = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || null;
const $01bb40e565a704f3$export$a647d49f7c54618b = function(e, s, kind) {
    const root = $01bb40e565a704f3$var$_canvasRoot(this);
    if (!root) return;
    e.preventDefault();
    if (e.stopPropagation) e.stopPropagation();
    const id = this?.node?.dataset?.nodeId || s && (s._nodeId || s.id) || null;
    root.update({
        contextDropdown: {
            open: true,
            x: e.clientX,
            y: e.clientY,
            kind: kind,
            nodeId: id,
            email: s && (s.email || s.handle) || null,
            name: s && (s.name || s.title) || null,
            itemsFn: 'tagNodeContextItems',
            actionFn: 'tagNodeContextAction'
        }
    }, {
        preventFetch: true
    });
};
const $01bb40e565a704f3$export$a0fb18e9aa1cd96e = function(root) {
    const cm = root && root.contextDropdown;
    if (!cm || !cm.open) return [];
    // Resolved here, not at the render site — see canvasContextMenu.js for why.
    const connect = {
        key: 'connect',
        action: 'connect',
        label: this.call('polyglot', 'canvas.team.contextMenu.connect')
    };
    const copy = {
        key: 'copyEmail',
        action: 'copyEmail',
        label: this.call('polyglot', 'canvas.team.contextMenu.copyEmail')
    };
    if (cm.kind === 'agent') // Agents open on click (the node's _onNodeClick opens the agent editor),
    // so the menu carries the secondary actions.
    return [
        connect,
        copy
    ];
    return [
        {
            key: 'open',
            action: 'open',
            label: this.call('polyglot', 'canvas.team.contextMenu.openProfile')
        },
        connect,
        copy
    ];
};
const $01bb40e565a704f3$export$db8bce53ffcc7dee = function(action) {
    const root = $01bb40e565a704f3$var$_canvasRoot(this);
    if (!root) return;
    const cm = root.contextDropdown || {};
    const { nodeId: nodeId, email: email } = cm;
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    if (action === 'open') // Person profile modal — the same surface avatar chips / OnlineMembers open.
    {
        if (email) this.call('openProfileModal', email);
    } else if (action === 'connect') // Start a connection from this node — mirrors the node's connect-mode click.
    {
        if (nodeId) root.update({
            _tagConnectMode: true,
            _tagConnectFrom: nodeId
        });
    } else if (action === 'copyEmail') {
        if (email && typeof navigator !== 'undefined' && navigator.clipboard) navigator.clipboard.writeText(email).catch((err)=>console.warn('[tag-ctx] copy', err));
    }
};

});

parcelRegister("8RRzz", function(module, exports) {

$parcel$export(module.exports, "DS_ITEM_KEYS", () => $674cd45eab5b7d8d$export$3da481080d1962a4);
$parcel$export(module.exports, "isDsItemKey", () => $674cd45eab5b7d8d$export$fe81cfcdc7230c2a);
$parcel$export(module.exports, "isEntityItemKey", () => $674cd45eab5b7d8d$export$8a775cb3663f773);
$parcel$export(module.exports, "shouldShowDesignSystem", () => $674cd45eab5b7d8d$export$d41541d22010f1e7);
$parcel$export(module.exports, "shouldShowComponents", () => $674cd45eab5b7d8d$export$cae3de431c40dad3);
$parcel$export(module.exports, "patchCanvas", () => $674cd45eab5b7d8d$export$c6060c797f7285e8);
$parcel$export(module.exports, "patchSnap", () => $674cd45eab5b7d8d$export$e8e5bb5e0085bdab);
$parcel$export(module.exports, "patchCanvasItem", () => $674cd45eab5b7d8d$export$fc74201dfb2fdf44);
$parcel$export(module.exports, "persistCanvasLayout", () => $674cd45eab5b7d8d$export$53fec6eb7cf69810);
$parcel$export(module.exports, "getCanvasV2", () => $674cd45eab5b7d8d$export$652848ce464c7201);
$parcel$export(module.exports, "getDragMode", () => $674cd45eab5b7d8d$export$1573697aa58c2814);
$parcel$export(module.exports, "isCanvasV2", () => $674cd45eab5b7d8d$export$23addae0858e64b6);
$parcel$export(module.exports, "getCanvasItem", () => $674cd45eab5b7d8d$export$d431ee287d504f08);
$parcel$export(module.exports, "getCanvasSelection", () => $674cd45eab5b7d8d$export$3c60c95440d052ea);
$parcel$export(module.exports, "getCanvasMode", () => $674cd45eab5b7d8d$export$202b2cd3c1634e12);
$parcel$export(module.exports, "setCanvasV2Mode", () => $674cd45eab5b7d8d$export$bce0c42665baf125);
$parcel$export(module.exports, "toggleCanvasSettings", () => $674cd45eab5b7d8d$export$4216e9bb03ab4201);
$parcel$export(module.exports, "setCanvasSettings", () => $674cd45eab5b7d8d$export$d81c309e40ced94b);
$parcel$export(module.exports, "setViewport", () => $674cd45eab5b7d8d$export$c1fc9211e25f81c5);
$parcel$export(module.exports, "applyViewport", () => $674cd45eab5b7d8d$export$b978854ee8173e4d);
$parcel$export(module.exports, "canvasToScreen", () => $674cd45eab5b7d8d$export$74ce37ffcd467e42);
$parcel$export(module.exports, "screenToCanvas", () => $674cd45eab5b7d8d$export$fe6875ec1b5fc6b6);
$parcel$export(module.exports, "refreshCanvasChrome", () => $674cd45eab5b7d8d$export$32d404dd66fcf9d6);
$parcel$export(module.exports, "canvasConnectionStroke", () => $674cd45eab5b7d8d$export$ef444694672dc067);
$parcel$export(module.exports, "canvasConnectionDash", () => $674cd45eab5b7d8d$export$4595bd090c3d38f6);
$parcel$export(module.exports, "resetCanvasView", () => $674cd45eab5b7d8d$export$2ba1bffa7d2b4003);
$parcel$export(module.exports, "zoomAroundCenter", () => $674cd45eab5b7d8d$export$d58457c5b6099869);
$parcel$export(module.exports, "zoomToScale", () => $674cd45eab5b7d8d$export$eda81de7742ad8e7);
$parcel$export(module.exports, "installV2CameraBridge", () => $674cd45eab5b7d8d$export$b2e73825371036db);
$parcel$export(module.exports, "bboxForItems", () => $674cd45eab5b7d8d$export$8fe66b9599e67f1a);
$parcel$export(module.exports, "computeFitToContentViewport", () => $674cd45eab5b7d8d$export$f5cc6e3e3398401e);
$parcel$export(module.exports, "fitToSelection", () => $674cd45eab5b7d8d$export$fc2e72651871d0dd);
$parcel$export(module.exports, "fitCanvasToContent", () => $674cd45eab5b7d8d$export$ef9019283f52cc4f);
$parcel$export(module.exports, "addConnection", () => $674cd45eab5b7d8d$export$3d65ce36f6b7b45d);
$parcel$export(module.exports, "removeConnection", () => $674cd45eab5b7d8d$export$c4b227a68608c05e);
$parcel$export(module.exports, "toggleShortcutsOverlay", () => $674cd45eab5b7d8d$export$15cf46b46ecd97d0);
$parcel$export(module.exports, "initCanvasV2", () => $674cd45eab5b7d8d$export$94a74e8616390e7c);
$parcel$export(module.exports, "migrateBoardPages", () => $674cd45eab5b7d8d$export$ef6300950d2aa1f9);
$parcel$export(module.exports, "subscribeMarketplaceInstalls", () => $674cd45eab5b7d8d$export$8ba1149148a88441);
$parcel$export(module.exports, "syncCanvasItemsFromPages", () => $674cd45eab5b7d8d$export$bb6fede81bb8b328);
$parcel$export(module.exports, "toggleCanvasDesignSystem", () => $674cd45eab5b7d8d$export$f233ab617fbc1d35);
$parcel$export(module.exports, "toggleCanvasComponents", () => $674cd45eab5b7d8d$export$ecee4283e4da2118);
$parcel$export(module.exports, "switchBoardPage", () => $674cd45eab5b7d8d$export$dd95c804a72966c);
$parcel$export(module.exports, "addBoardPage", () => $674cd45eab5b7d8d$export$4f571f3b3c303fe6);
$parcel$export(module.exports, "renameBoardPage", () => $674cd45eab5b7d8d$export$de2f4a2c9a2982c4);
$parcel$export(module.exports, "getBoardPageMeta", () => $674cd45eab5b7d8d$export$c8279f5eac99a83d);
$parcel$export(module.exports, "setBoardPageMeta", () => $674cd45eab5b7d8d$export$66dbbdb461204f81);
$parcel$export(module.exports, "deleteBoardPage", () => $674cd45eab5b7d8d$export$95fcfcb6bd6ace66);
// Canvas v2 state. Lives on the root reactive store so prop functions
// re-evaluate on mutation. Writes funnel through `patchCanvas` so the
// backing store can later swap to project.settings.canvas without
// touching components.

var $fzbiH = parcelRequire("fzbiH");

var $1X0Je = parcelRequire("1X0Je");

var $aj1Eh = parcelRequire("aj1Eh");
const $674cd45eab5b7d8d$var$canvasResolveProjectParams = (...args)=>(0, $1X0Je.default).functions.resolveProjectParams(...args);
const $674cd45eab5b7d8d$var$applyCanvasDotMetrics = (...args)=>(0, $1X0Je.default).functions.applyCanvasDotMetrics(...args);
const $674cd45eab5b7d8d$var$canvasDotMetrics = (...args)=>(0, $1X0Je.default).functions.canvasDotMetrics(...args);
// Built-in design-system pages shown on every project canvas — OUR DS showcase
// (DesignSystemScene) rendered with the USER's data, so users see their own
// design system. Item keys are `__ds/<route>`; CanvasItem routes these through
// embedDesignSystem. (2026-06-17 per Nika "show design system pages here on
// canvas … display users design system by our design system pages".)
const $674cd45eab5b7d8d$var$DS_PAGE_ROUTES = [
    '/colors',
    '/typography',
    '/spacing',
    '/icons',
    '/transitions',
    '/layout',
    '/misc'
];
const $674cd45eab5b7d8d$export$3da481080d1962a4 = $674cd45eab5b7d8d$var$DS_PAGE_ROUTES.map((r)=>'__ds' + r);
const $674cd45eab5b7d8d$export$fe81cfcdc7230c2a = (k)=>typeof k === 'string' && k.indexOf('__ds/') === 0;
const $674cd45eab5b7d8d$export$8a775cb3663f773 = (k)=>typeof k === 'string' && k.indexOf('ref:') === 0;
function $674cd45eab5b7d8d$export$d41541d22010f1e7(root) {
    // OFF by default (Nika 2026-08-01) — the design-system frames only seed onto
    // the board when the user explicitly toggles them on (toggleCanvasDesignSystem).
    // The board defaults to just the project's pages; DS + components are opt-in.
    // Read the LIVE flag first (root.canvas, set by a toggle) so a toggle takes
    // effect immediately; fall back to the persisted flag (root.data.canvas) at
    // init before root.canvas is populated. Absent anywhere ⇒ off.
    const live = root?.canvas?.showDesignSystem;
    if (typeof live === 'boolean') return live;
    // Persisted flag is only authoritative when the doc was saved under the new
    // default-off logic — detected by the presence of `showComponents` (which only
    // the new persist writes). OLD docs auto-persisted showDesignSystem:true for
    // everyone (the pre-2026-08-01 `!== false` default), so treat those as OFF —
    // otherwise every existing board would ignore the new default. A real user
    // toggle re-saves with showComponents present, and is then honoured.
    const c = root?.data?.canvas;
    if (c && typeof c.showComponents === 'boolean') return c.showDesignSystem === true;
    return false;
}
function $674cd45eab5b7d8d$export$cae3de431c40dad3(root) {
    // OFF by default (Nika 2026-08-01) — component frames are opt-in, same as DS.
    const live = root?.canvas?.showComponents;
    if (typeof live === 'boolean') return live;
    return root?.data?.canvas?.showComponents === true;
}
// A NEW board page's default name, in the session language: the canvas
// bundle's `canvas.boardPage.defaultName` ("Page {n}" / "გვერდი {n}") with the
// page's number. Called ONLY where a page is minted — addBoardPage, and the
// first page of a board that has none (the fresh seed, a doc saved before board
// pages or from a template, the pre-init patch, the persist fallback). A saved
// name is data and never comes back through here: a board saved with "Page 1"
// keeps "Page 1" in a Georgian session. `el` is any element of the app (polyglot
// reads the root `lang`); with no polyglot the name is the number, never empty.
const $674cd45eab5b7d8d$var$boardPageDefaultName = (el, n)=>{
    const words = el?.call?.('polyglot', 'canvas.boardPage.defaultName');
    return typeof words === 'string' && words.includes('{n}') ? words.replace('{n}', String(n)) : String(n);
};
// `firstPageName` (boardPageDefaultName(el, 1)) names the board's first page.
// Every caller that STORES the result passes it; a caller that reads one field
// (`DEFAULTS().viewport`, `.guides`) does not.
const $674cd45eab5b7d8d$var$DEFAULTS = (firstPageName)=>({
        viewport: {
            x: 40,
            y: 40,
            scale: 0.35
        },
        items: {},
        groups: {},
        guides: {
            horizontal: [],
            vertical: []
        },
        selection: {
            ids: [],
            primary: null
        },
        marquee: null,
        mode: 'default',
        snap: {
            enabled: true,
            threshold: 6,
            toGrid: true,
            gridStep: 64,
            toItems: true,
            toGuides: true
        },
        // Per-tile iframes are the only render path now: native window/document
        // isolation per artboard, so scratch's FACTORY, designSystem, and state
        // tree never bleed between tiles or into the canvas chrome. The earlier
        // same-document inline mount was dropped — same-document mounting can't
        // honestly isolate window globals or document-level mutations. The
        // `frameMode` toggle that used to gate between the two paths is gone.
        // Visual connections between items — arrows from one item to another.
        // Stored as `[{ from: key, to: key, label?: string, kind?: string }]`.
        // Rendered by `refreshCanvasChrome` into the `CvConnectors` SVG layer.
        // `kind` is OPTIONAL and additive (entity nodes, spec §3.3): a connection
        // without one renders exactly as it always did — same stroke, no label.
        connections: [],
        // Entity-node cache — `{ [refKey]: { loading, data, error } }` (spec §3.1).
        // Deliberately NOT in `_livePageSlice` and NOT in persistCanvasLayout's
        // payload: it is a per-tab READ CACHE of rows the backend owns, so it must
        // survive a board-page switch (patchCanvas merges, so it does) and must
        // never be written into the project document (which would freeze a stale
        // copy of somebody else's record into the canvas layout).
        entities: {},
        // Off by default. Toggled from the settings modal.
        showRulers: false,
        showMinimap: false,
        settingsOpen: false,
        session: null,
        // Figma-style board PAGES (Nika 2026-08-01). The ACTIVE page's layout always
        // lives in the top-level live fields above (items/guides/groups/viewport/
        // connections) so CanvasSurface / chrome / drag stay page-agnostic; inactive
        // pages are parked as snapshots in `pageItems[id]`. A board always has ≥1 page.
        pages: [
            {
                id: 'page-1',
                name: firstPageName
            }
        ],
        activePageId: 'page-1',
        pageItems: {}
    });
function $674cd45eab5b7d8d$var$rootState(el) {
    return el?.state?.root || el?.getRootState?.() || el?.getRoot?.()?.state;
}
const $674cd45eab5b7d8d$var$CANVAS_STORAGE_KEY = 'cv2_settings';
function $674cd45eab5b7d8d$var$loadStored() {
    try {
        return JSON.parse(window.localStorage?.getItem($674cd45eab5b7d8d$var$CANVAS_STORAGE_KEY) || '{}');
    } catch  {
        return {};
    }
}
function $674cd45eab5b7d8d$var$persistSettings(canvas) {
    try {
        const slim = {
            snap: canvas.snap,
            showRulers: canvas.showRulers,
            showMinimap: canvas.showMinimap
        };
        window.localStorage?.setItem($674cd45eab5b7d8d$var$CANVAS_STORAGE_KEY, JSON.stringify(slim));
    } catch  {}
}
function $674cd45eab5b7d8d$export$c6060c797f7285e8(patch, opts) {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    if (!root?.update) return;
    const prev = root.canvas || $674cd45eab5b7d8d$var$DEFAULTS($674cd45eab5b7d8d$var$boardPageDefaultName(this, 1));
    const next = {
        ...prev,
        ...patch
    };
    root.update({
        canvas: next
    }, opts);
    if ('snap' in patch || 'showRulers' in patch || 'showMinimap' in patch) $674cd45eab5b7d8d$var$persistSettings(next);
    // refreshCanvasChromeNow only computes the minimap's content while
    // showMinimap is true (perf gate — see there), so flipping it off→on needs
    // one explicit refresh here or the panel would stay blank until the next
    // drag/pan/selection change happened to run one.
    if (patch.showMinimap === true && !prev.showMinimap) this.call('refreshCanvasChrome');
}
function $674cd45eab5b7d8d$export$e8e5bb5e0085bdab(patch) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    this.call('patchCanvas', {
        snap: {
            ...v2.snap,
            ...patch
        }
    });
}
function $674cd45eab5b7d8d$export$fc74201dfb2fdf44(key, itemPatch) {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    const canvas = root?.canvas;
    if (!canvas || !key) return;
    canvas.items = canvas.items || {};
    canvas.items[key] = {
        ...canvas.items[key] || {},
        ...itemPatch
    };
}
// Debounced project write. The `canvas` field is a recognized
// contentField — the server stores it in the ProjectData document and
// includes it in subsequent project reads. `settings` is also a
// contentField but many project reads strip it, so we keep the layout
// at the top level to match Workspace's `canvasPosition` pattern.
//
// The pending write is `{ projectId, timer, write }`: the latest layout of ONE
// project's board. The debounce folds that project's writes only. A write
// still pending for ANOTHER project (the board switched inside the 800 ms) is
// that board's last edit: it is sent at once, never cancelled. Cancelling it
// lost the edit whenever the next board saved first.
let $674cd45eab5b7d8d$var$_persistTimer = null;
function $674cd45eab5b7d8d$export$53fec6eb7cf69810() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ctx = this.context || this.getRootContext?.() || {};
    const sdk = ctx.methods?.sdk;
    if (!sdk?.isReady?.()) return;
    const el = this;
    const root = $674cd45eab5b7d8d$var$rootState(this);
    const data = root?.data;
    const projectId = data?._id;
    if (!projectId) return;
    // Board pages: the top-level items/guides/… ARE the active page's layout
    // (kept for backward-compat + the loader's persisted.items read); pageItems
    // holds every page's snapshot with the active one refreshed from the live
    // fields. (Nika 2026-08-01)
    const activePageId = v2.activePageId || 'page-1';
    const pages = Array.isArray(v2.pages) && v2.pages.length ? v2.pages : [
        {
            id: activePageId,
            name: $674cd45eab5b7d8d$var$boardPageDefaultName(this, 1)
        }
    ];
    const pageItems = {
        ...v2.pageItems || {},
        [activePageId]: $674cd45eab5b7d8d$var$_livePageSlice(v2)
    };
    const payload = {
        items: v2.items,
        guides: v2.guides,
        groups: v2.groups,
        viewport: v2.viewport,
        connections: v2.connections,
        pages: pages,
        activePageId: activePageId,
        pageItems: pageItems,
        // Both default OFF now — persist the explicit flag (=== true) so an
        // untoggled board stays off across reloads instead of the old !== false
        // (which defaulted an undefined flag back ON). (Nika 2026-08-01)
        showDesignSystem: v2.showDesignSystem === true,
        showComponents: v2.showComponents === true
    };
    const write = async ()=>{
        // Mark this as a LOCAL write so the remote-update watcher doesn't surface the
        // version it creates as an external/AI edit (functions/canvas/remoteUpdates.js).
        // Stamp BEFORE the write — the version event can arrive before this resolves.
        try {
            el.call('markSelfWrite', root);
        } catch (_) {}
        try {
            await sdk.updateProject(projectId, {
                canvas: payload
            });
        } catch (err) {
            console.warn('[canvas v2] persist failed', err?.message || err);
        }
    };
    const pending = $674cd45eab5b7d8d$var$_persistTimer;
    if (pending) clearTimeout(pending.timer);
    if (pending && pending.projectId !== projectId) pending.write();
    const next = {
        projectId: projectId,
        write: write,
        timer: null
    };
    next.timer = setTimeout(()=>{
        if ($674cd45eab5b7d8d$var$_persistTimer === next) $674cd45eab5b7d8d$var$_persistTimer = null;
        write();
    }, 800);
    $674cd45eab5b7d8d$var$_persistTimer = next;
}
function $674cd45eab5b7d8d$export$652848ce464c7201() {
    return $674cd45eab5b7d8d$var$rootState(this)?.canvas;
}
function $674cd45eab5b7d8d$export$1573697aa58c2814(root) {
    return root?.dragMode || 'grid';
}
function $674cd45eab5b7d8d$export$23addae0858e64b6() {
    // The flag's canonical home is the canvas globalScope (globalScope.js —
    // "this scope only carries the flag because it's read by both editor
    // chrome and iframe"). Reading it ONLY through the Canvas element
    // (`getCanvasScope()` = getCanvas()?.scope) made the answer depend on
    // mount ORDER: the `if:` gates on Canvas's own children (CanvasSurface vs
    // the legacy CanvasScene) evaluate while Canvas is still being created,
    // before `getCanvas()` can find it — so in the unified shell the v2 gate
    // read `undefined?.canvasV2` → false, mounted the LEGACY empty gridstack
    // scene, and never re-evaluated (the gate has zero reactive reads). Fall
    // back to context.globalScope, which exists from the first evaluation.
    const scope = this.call('getCanvasScope');
    if (scope && 'canvasV2' in scope) return !!scope.canvasV2;
    return !!this.context?.globalScope?.canvasV2;
}
function $674cd45eab5b7d8d$export$d431ee287d504f08(key) {
    return this.call('getCanvasV2')?.items?.[key];
}
function $674cd45eab5b7d8d$export$3c60c95440d052ea() {
    return this.call('getCanvasV2')?.selection || {
        ids: [],
        primary: null
    };
}
function $674cd45eab5b7d8d$export$202b2cd3c1634e12() {
    return this.call('getCanvasV2')?.mode || 'default';
}
function $674cd45eab5b7d8d$export$bce0c42665baf125(mode) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    v2.mode = mode;
    const scope = this.call('getCanvasScope');
    if (scope) {
        scope.defaultMode = mode === 'default';
        scope.inspectMode = mode === 'inspect';
        scope.panningMode = mode === 'pan';
    }
    // Re-render the modes bar + inspect overlay (uses reactive `show:`).
    this.call('patchCanvas', {
        mode: mode
    });
    this.call('refreshCanvasChrome');
}
function $674cd45eab5b7d8d$export$4216e9bb03ab4201() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    this.call('patchCanvas', {
        settingsOpen: !v2.settingsOpen
    });
}
function $674cd45eab5b7d8d$export$d81c309e40ced94b(open) {
    this.call('patchCanvas', {
        settingsOpen: !!open
    });
}
function $674cd45eab5b7d8d$export$c1fc9211e25f81c5(patch) {
    const canvas = $674cd45eab5b7d8d$var$rootState(this)?.canvas;
    if (!canvas) return;
    canvas.viewport = {
        ...canvas.viewport || {},
        ...patch
    };
}
function $674cd45eab5b7d8d$export$b978854ee8173e4d(viewport) {
    this.call('setViewport', viewport);
    const scope = this.call('getCanvasScope');
    if (scope) scope.positions = {
        ...scope.positions,
        x: viewport.x,
        y: viewport.y,
        scale: viewport.scale
    };
    try {
        (0, $fzbiH.resolveTopWindow)().__cvViewport = {
            x: viewport.x,
            y: viewport.y,
            scale: viewport.scale
        };
    } catch  {}
    const root = this.getRoot?.();
    // Per-tick camera writes go STRAIGHT to the nodes — a full DOMQL
    // el.update() cycle per pointer-move tick (×2: scene + grid) was the
    // single biggest per-frame cost of pan/zoom (2026-08-08 per Nika "make
    // canvas zooming panning more smooth - it feels heavy now"). Writing
    // node.style still mutates the style ATTRIBUTE, so the viewport-windowing
    // MutationObserver contract (observes CvScene's style attr) is untouched.
    const scene = root?.lookdown?.('CvScene');
    if (scene?.node) scene.node.style.transform = `translate3d(${viewport.x}px, ${viewport.y}px, 0) scale(${viewport.scale})`;
    else if (scene?.update) scene.update({
        style: {
            transform: `translate3d(${viewport.x}px, ${viewport.y}px, 0) scale(${viewport.scale})`
        }
    });
    const grid = root?.lookdown?.('CvGrid');
    if (grid?.node) // Spacing + dot radius together (canvasBackground.canvasDotMetrics): the
    // recursive fold keeps spacing in a bounded band, and the radius tracks it
    // so ink density is CONSTANT at every zoom. Radius used to be pinned while
    // spacing swept 3x, which faded the grid out and popped it back mid-gesture
    // — "sometimes during scroll dots disappear" (2026-08-08 per Nika).
    $674cd45eab5b7d8d$var$applyCanvasDotMetrics(grid.node, viewport.scale, viewport.x, viewport.y);
    else if (grid?.update) {
        // No node yet (element declared but not mounted) — spacing/position only;
        // the radius keeps its CSS fallback until the node exists and the branch
        // above takes over.
        const { spacing: spacing } = $674cd45eab5b7d8d$var$canvasDotMetrics(viewport.scale);
        const px = (viewport.x % spacing + spacing) % spacing;
        const py = (viewport.y % spacing + spacing) % spacing;
        grid.update({
            style: {
                backgroundSize: `${spacing}px ${spacing}px`,
                backgroundPosition: `${px}px ${py}px`
            }
        });
    }
    this.call('refreshCanvasChrome');
// The `this.call('syncCanvas')` that used to sit here (pure overhead on
// the camera's hottest path — every pointermove during pan/pinch, every
// coalesced wheel flush) is gone along with the rest of the dead
// `syncCanvas` machinery — see `methods/index.js` for the full removal
// note (tickets/opus.md, 2026-08-09 investigation: zero reads repo-wide,
// all other call sites audited and either already re-rendered via
// `refreshCanvasChrome`/`.update()` or had a real reactive replacement).
}
function $674cd45eab5b7d8d$export$74ce37ffcd467e42(cx, cy) {
    const vp = this.call('getCanvasV2')?.viewport || {
        x: 0,
        y: 0,
        scale: 1
    };
    return {
        x: cx * vp.scale + vp.x,
        y: cy * vp.scale + vp.y
    };
}
function $674cd45eab5b7d8d$export$fe6875ec1b5fc6b6(sx, sy) {
    const vp = this.call('getCanvasV2')?.viewport || {
        x: 0,
        y: 0,
        scale: 1
    };
    return {
        x: (sx - vp.x) / vp.scale,
        y: (sy - vp.y) / vp.scale
    };
}
// --- chrome updater -----------------------------------------------------
// rAF-coalesces: callers tag the chrome dirty; the actual layout work
// runs once per browser frame even if called 100×/frame during gesture.
// Cache last applied geom per element so unchanged frames skip the
// `el.update` (a no-op write still allocates DOMQL diff overhead).
let $674cd45eab5b7d8d$var$_chromeRafId = null;
let $674cd45eab5b7d8d$var$_chromeLastEl = null;
// The app root captured at SCHEDULE time. The scheduling element can unmount
// before the deferred frame runs — e.g. an AiContextChip's RemoveBtn dispatches
// toggleSelection, setSel bumps `_cvSelectionTick`, the chip list re-renders
// and that very button is removed (owned state destroyed, parent nulled).
// refreshCanvasChromeNow then saw `getRoot()` → undefined and returned early,
// leaving the selection box + handles painted over an EMPTY selection — and the
// stale box ate every later pointerdown on the artboard (AI-CONTEXT-AWARENESS-
// O1-1, live 2026-08-21). Run against this root instead when that happens.
let $674cd45eab5b7d8d$var$_chromeLastRoot = null;
const $674cd45eab5b7d8d$var$_lastGeom = new WeakMap();
// SelectedNavbar host positioning (below) needs the live rail width to avoid
// drawing underneath it. `root.lookdown('ProjectCanvasSidebar')` (a tree walk)
// + `node.getBoundingClientRect()` (a forced synchronous layout read) both used
// to run unconditionally on EVERY refreshCanvasChrome tick — i.e. every
// pointermove while dragging/resizing an item, the highest-frequency path in
// this file (up to 60×/sec) — sandwiched between the selection-box/handle
// style WRITES just above and the host style WRITE just below. That write →
// forced-read → write order is textbook layout thrash: the browser can't
// answer getBoundingClientRect from the already-stale layout after the writes
// above, so it forces a synchronous reflow, which the writes below
// immediately invalidate again. The rail is a single stable element for a
// canvas page's whole lifetime and its width is DS-token-pinned (G1), so
// cache both the element lookup and the measured width; a ResizeObserver
// invalidates the cached width on the rare occasions it actually changes
// (viewport resize, the page sidebar's hide / show — the hidden rail shrinks
// to its reopen tab) instead of re-measuring on every frame. The rail's SIDE
// is read per pass, not cached: the page-sidebar rule (shared
// functions/pageSidebar.js) puts it on the right beside a left navbar, and a
// move between the sides keeps its width.
// One `const` holder mutated in place, not four `let` bindings — reassigned
// module-scope `let`s can't ride frank's globalScope lift, so at a
// frank-served runtime `_sidebarWidthFor` read four guaranteed-undefined
// identifiers (gate: unresolvable-identifier, surfaced through the
// workspace-shell merge). A const object lifts as data and property
// mutation keeps the cache semantics identical.
const $674cd45eab5b7d8d$var$_sidebarWidthState = {
    el: null,
    width: 0,
    node: null,
    ro: null
};
function $674cd45eab5b7d8d$var$_sidebarWidthFor(root) {
    let sidebarEl = $674cd45eab5b7d8d$var$_sidebarWidthState.el;
    if (!sidebarEl?.node?.isConnected) {
        sidebarEl = root?.lookdown?.('ProjectCanvasSidebar') || null;
        $674cd45eab5b7d8d$var$_sidebarWidthState.el = sidebarEl;
    }
    const node = sidebarEl?.node;
    if (!node) return 0;
    if (node !== $674cd45eab5b7d8d$var$_sidebarWidthState.node) {
        $674cd45eab5b7d8d$var$_sidebarWidthState.node = node;
        $674cd45eab5b7d8d$var$_sidebarWidthState.width = node.getBoundingClientRect().width || 0;
        $674cd45eab5b7d8d$var$_sidebarWidthState.ro?.disconnect();
        if (typeof ResizeObserver !== 'undefined') {
            $674cd45eab5b7d8d$var$_sidebarWidthState.ro = new ResizeObserver((entries)=>{
                const w = entries[0]?.contentRect?.width;
                if (typeof w === 'number') $674cd45eab5b7d8d$var$_sidebarWidthState.width = w;
            });
            $674cd45eab5b7d8d$var$_sidebarWidthState.ro.observe(node);
        }
    }
    return $674cd45eab5b7d8d$var$_sidebarWidthState.width;
}
// CANVAS-ARTBOARD-OFFSET-1 — the ONE shared container-origin term (analytics
// root cause, 2026-08-18): every chrome writer below emits `board*scale + vp`
// as overlay-local left/top, but the ARTBOARDS render inside the
// CanvasSurface container, whose top-left is NOT the overlay's origin on the
// shell's project-canvas page (the shell band offsets it). Pointer input
// (`toCanvas`, pointer.js) already subtracts the surface rect, so hits were
// correct while every chrome box (selection, handles, titles, groups,
// connectors, marquee, snap lines, guides) sat shifted by exactly that
// CONSTANT — zoom never touches it. The origin is measured RELATIVE TO THE
// OVERLAY's own rect (surfaceRect − overlayRect): identical to the absolute
// surface origin when the overlay is at the viewport origin (the standalone
// canvas app — term 0, nothing changes) and still correct if the overlay's
// fixed containing block is itself offset by a transformed ancestor. Element
// lookups cached in a const holder (same frank-lift reasoning as
// _sidebarWidthState above); rects are read ONCE per refresh/write pass —
// callers pass the result down, never re-measure per handle.
const $674cd45eab5b7d8d$var$_chromeOriginState = {
    surfEl: null
};
function $674cd45eab5b7d8d$var$chromeOriginFor(root, overlay) {
    let surfEl = $674cd45eab5b7d8d$var$_chromeOriginState.surfEl;
    if (!surfEl?.node?.isConnected) {
        surfEl = root?.lookdown?.('CanvasSurface') || null;
        $674cd45eab5b7d8d$var$_chromeOriginState.surfEl = surfEl;
    }
    const surfNode = surfEl?.node;
    const overNode = overlay?.node;
    if (!surfNode?.getBoundingClientRect || !overNode?.getBoundingClientRect) return {
        x: 0,
        y: 0
    };
    const sRect = surfNode.getBoundingClientRect();
    const oRect = overNode.getBoundingClientRect();
    // `w`: the overlay's own width, for a clamp against its right edge.
    return {
        x: sRect.left - oRect.left,
        y: sRect.top - oRect.top,
        w: oRect.width
    };
}
function $674cd45eab5b7d8d$var$geomChanged(el, next) {
    const prev = $674cd45eab5b7d8d$var$_lastGeom.get(el);
    if (!prev) {
        $674cd45eab5b7d8d$var$_lastGeom.set(el, next);
        return true;
    }
    for(const k in next)if (next[k] !== prev[k]) {
        $674cd45eab5b7d8d$var$_lastGeom.set(el, next);
        return true;
    }
    return false;
}
function $674cd45eab5b7d8d$export$32d404dd66fcf9d6() {
    $674cd45eab5b7d8d$var$_chromeLastEl = this;
    const rootNow = this?.getRoot?.();
    if (rootNow) $674cd45eab5b7d8d$var$_chromeLastRoot = rootNow;
    if ($674cd45eab5b7d8d$var$_chromeRafId) return;
    const pending = {};
    const run = ()=>{
        if ($674cd45eab5b7d8d$var$_chromeRafId !== pending) return;
        $674cd45eab5b7d8d$var$_chromeRafId = null;
        if (typeof cancelAnimationFrame === 'function') cancelAnimationFrame(pending.raf);
        clearTimeout(pending.timer);
        try {
            // A detached scheduler (see _chromeLastRoot) can no longer resolve the
            // root; the captured root element is a valid `this` for the refresh —
            // getRoot() is itself, state.root is the store, call() has the graph.
            const target = $674cd45eab5b7d8d$var$_chromeLastEl?.getRoot?.() ? $674cd45eab5b7d8d$var$_chromeLastEl : $674cd45eab5b7d8d$var$_chromeLastRoot;
            if (!target) return;
            $674cd45eab5b7d8d$var$refreshCanvasChromeNow.call(target);
        } catch (err) {
            console.error('[canvas v2] refreshCanvasChrome error', err);
        }
    };
    $674cd45eab5b7d8d$var$_chromeRafId = pending;
    pending.raf = typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame(run) : setTimeout(run, 16);
    pending.timer = setTimeout(run, 100);
}
// Is an item shown under the active ProjectCanvasSidebar filter? Mirrors the
// CanvasSurface CvItems filter so the chrome (titles / selection box) hides for
// filtered-out items too. (2026-06-17 per Nika "when filtering canvas, its
// related UI should also disappear".)
function $674cd45eab5b7d8d$var$itemVisibleUnderFilter(rs, key) {
    const filter = rs?._canvasFilter || 'all';
    if (filter === 'all') return true;
    // Entity nodes (`ref:<type>:<id>`) are exempt from every type filter. The
    // filter buckets are PROJECT-SCHEMA buckets — pages, components, design
    // system — and a data item is none of them, so bucketing it
    // as 'other' would make any non-'all' filter blank a board whose content is
    // entirely entity nodes. They belong to the BOARD PAGE, which is already the
    // only membership that scopes them (`canvas.items` holds the active page's
    // set; parked pages live in `pageItems`).
    if ($674cd45eab5b7d8d$export$8a775cb3663f773(key)) return true;
    if (filter === 'ds') return $674cd45eab5b7d8d$export$fe81cfcdc7230c2a(key);
    if (filter === 'pages') return key in (rs?.data?.pages || {});
    if (filter === 'components') return key in (rs?.data?.components || {});
    return true;
}
// ── Connection stroke by relation KIND (spec §3.3) ─────────────────────────
// The SVG connector layer is drawn imperatively (it is one <path> per
// connection recomputed per frame, which no declarative form can express
// cheaply), so the per-kind styling has to be plain attribute writes too.
//
// Raw rgba here, not design tokens, for the SAME reason every other value in
// this renderer is raw: these attributes are written onto SVG nodes with
// setAttribute, which never resolves a token, and the whole connector layer
// already paints canvas-tool chrome over arbitrary user content at a fixed
// contrast (see the `ruler()` note in CanvasOverlayV2). The two accents mirror
// the existing default so the family reads as one.
//
// A connection with NO `kind` takes the default branch and is byte-identical
// to what shipped before entity nodes existed.
const $674cd45eab5b7d8d$var$_CONN_DASHED = [
    'supersedes',
    'amends'
];
const $674cd45eab5b7d8d$var$_CONN_ACCENT = [
    'because_of',
    'variation_of'
];
function $674cd45eab5b7d8d$export$ef444694672dc067(kind) {
    if (kind && $674cd45eab5b7d8d$var$_CONN_ACCENT.indexOf(kind) !== -1) return 'rgba(255,159,64,0.9)';
    if (kind && $674cd45eab5b7d8d$var$_CONN_DASHED.indexOf(kind) !== -1) return 'rgba(180,142,255,0.9)';
    return 'rgba(64,156,255,0.85)';
}
function $674cd45eab5b7d8d$export$4595bd090c3d38f6(kind) {
    return kind && $674cd45eab5b7d8d$var$_CONN_DASHED.indexOf(kind) !== -1 ? '6 4' : null;
}
function $674cd45eab5b7d8d$var$refreshCanvasChromeNow() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const root = this.getRoot?.();
    if (!root) return;
    const overlay = root.lookdown?.('CanvasOverlayV2');
    if (!overlay) return;
    const el = this;
    // Guard against an empty/partial viewport (e.g. a persisted `{}`) — a missing
    // scale would make every screen-space position NaN and the chrome would float
    // off the items / vanish. Fall back to the canonical default transform.
    const vp = v2.viewport && v2.viewport.scale != null ? v2.viewport : {
        x: 40,
        y: 40,
        scale: 0.35
    };
    const rs = $674cd45eab5b7d8d$var$rootState(this);
    // ONE container-origin read per refresh pass (see chromeOriginFor above).
    const origin = $674cd45eab5b7d8d$var$chromeOriginFor(root, overlay);
    // Selection box + handles — only when at least one selected item is visible
    // under the current filter (a filtered-out item is unrendered, so its box +
    // handles + SelectedNavbar must hide too).
    const box = overlay.CvSelectionBox;
    const ids = v2.selection.ids.filter((id)=>$674cd45eab5b7d8d$var$itemVisibleUnderFilter(rs, id));
    if (ids.length && box?.update) {
        const bbox = el.call('bboxForSelection');
        if (bbox) {
            const x = bbox.x * vp.scale + vp.x + origin.x;
            const y = bbox.y * vp.scale + vp.y + origin.y;
            const w = bbox.w * vp.scale;
            const h = bbox.h * vp.scale;
            box.update({
                style: {
                    display: 'block',
                    left: x + 'px',
                    top: y + 'px',
                    width: w + 'px',
                    height: h + 'px'
                }
            });
            // Handles — only for single selection
            const showHandles = ids.length === 1;
            const handlePoints = [
                [
                    (0, $fzbiH.HANDLE_NAMES)[0],
                    x,
                    y
                ],
                [
                    (0, $fzbiH.HANDLE_NAMES)[1],
                    x + w / 2,
                    y
                ],
                [
                    (0, $fzbiH.HANDLE_NAMES)[2],
                    x + w,
                    y
                ],
                [
                    (0, $fzbiH.HANDLE_NAMES)[3],
                    x + w,
                    y + h / 2
                ],
                [
                    (0, $fzbiH.HANDLE_NAMES)[4],
                    x + w,
                    y + h
                ],
                [
                    (0, $fzbiH.HANDLE_NAMES)[5],
                    x + w / 2,
                    y + h
                ],
                [
                    (0, $fzbiH.HANDLE_NAMES)[6],
                    x,
                    y + h
                ],
                [
                    (0, $fzbiH.HANDLE_NAMES)[7],
                    x,
                    y + h / 2
                ]
            ];
            for (const [name, hx, hy] of handlePoints){
                const h = overlay[name];
                if (!h?.update) continue;
                const next = {
                    display: showHandles ? 'block' : 'none',
                    left: hx,
                    top: hy
                };
                if (!$674cd45eab5b7d8d$var$geomChanged(h, next)) continue;
                h.update({
                    style: {
                        display: next.display,
                        left: hx + 'px',
                        top: hy + 'px',
                        transform: 'translate(-50%, -50%)'
                    }
                });
            }
            // SelectedNavbar host — only when exactly 1 selected
            const host = overlay.CvSelectedHost;
            if (host?.update) {
                const sidebarWidth = $674cd45eab5b7d8d$var$_sidebarWidthFor(root);
                // Clear the rail on ITS side: a rail on the right (beside a left
                // navbar) holds the host's right edge back, as a left rail holds its
                // left edge.
                const rail = $674cd45eab5b7d8d$var$_sidebarWidthState.el;
                const railRight = !!rail && typeof rail.call === 'function' && (rail.call('pageSidebarRead', rs, rail) || {}).side === 'right';
                const safeLeft = railRight ? origin.w > 0 ? Math.min(x, origin.w - sidebarWidth - 24 - w) : x : Math.max(x, sidebarWidth + 24);
                host.update({
                    style: showHandles ? {
                        display: 'block',
                        left: safeLeft + 'px',
                        top: y + 'px',
                        width: w + 'px',
                        height: h + 'px',
                        zIndex: '2'
                    } : {
                        display: 'none'
                    }
                });
            }
        }
    } else {
        box?.update?.({
            style: {
                display: 'none'
            }
        });
        for (const name of (0, $fzbiH.HANDLE_NAMES))overlay[name]?.update?.({
            style: {
                display: 'none'
            }
        });
        overlay.CvSelectedHost?.update?.({
            style: {
                display: 'none'
            }
        });
    }
    // Marquee
    const marq = overlay.CvDragAreaClip?.CvMarquee || overlay.CvMarquee;
    if (marq?.update) {
        const m = v2.marquee;
        if (m) marq.update({
            style: {
                display: 'block',
                left: m.x * vp.scale + vp.x + origin.x + 'px',
                top: m.y * vp.scale + vp.y + origin.y + 'px',
                width: m.w * vp.scale + 'px',
                height: m.h * vp.scale + 'px'
            }
        });
        else marq.update({
            style: {
                display: 'none'
            }
        });
    }
    // Connector arrows — render as bezier paths in CvConnectors SVG.
    const conn = overlay.CvConnectors;
    const connNode = conn?.node;
    if (connNode) {
        const list = v2.connections || [];
        const dom = connNode.ownerDocument;
        while(connNode.firstChild)connNode.removeChild(connNode.firstChild);
        if (list.length) {
            // Marker for arrowhead.
            const defs = dom.createElementNS('http://www.w3.org/2000/svg', 'defs');
            defs.innerHTML = '<marker id="cvArrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse"><path d="M0,0 L10,5 L0,10 z" fill="rgba(64,156,255,0.9)"/></marker>';
            connNode.appendChild(defs);
            for (const c of list){
                const a = v2.items[c.from];
                const b = v2.items[c.to];
                if (!a || !b) continue;
                const ax = (a.x + a.w) * vp.scale + vp.x + origin.x;
                const ay = (a.y + a.h / 2) * vp.scale + vp.y + origin.y;
                const bx = b.x * vp.scale + vp.x + origin.x;
                const by = (b.y + b.h / 2) * vp.scale + vp.y + origin.y;
                const cx = (ax + bx) / 2;
                const path = dom.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', `M${ax},${ay} C${cx},${ay} ${cx},${by} ${bx},${by}`);
                path.setAttribute('fill', 'none');
                path.setAttribute('stroke', $674cd45eab5b7d8d$export$ef444694672dc067(c.kind));
                path.setAttribute('stroke-width', '2');
                const dash = $674cd45eab5b7d8d$export$4595bd090c3d38f6(c.kind);
                if (dash) path.setAttribute('stroke-dasharray', dash);
                path.setAttribute('marker-end', 'url(#cvArrow)');
                connNode.appendChild(path);
                // Relation label at the bezier MIDPOINT. A cubic with these two
                // control points has its t=0.5 point at (ax+bx)/2 horizontally and the
                // average of the two endpoint heights vertically — the closed form,
                // not a sampled approximation, so the label cannot drift off the curve
                // at any zoom. Only drawn when the connection carries a `label`, which
                // is what keeps page/component connections pixel-identical to before.
                if (!c.label) continue;
                const label = dom.createElementNS('http://www.w3.org/2000/svg', 'text');
                label.setAttribute('x', String((ax + bx) / 2));
                label.setAttribute('y', String((ay + by) / 2 - 4));
                label.setAttribute('text-anchor', 'middle');
                label.setAttribute('fill', $674cd45eab5b7d8d$export$ef444694672dc067(c.kind));
                label.setAttribute('font-size', '11');
                label.setAttribute('paint-order', 'stroke');
                label.setAttribute('stroke', 'rgba(0,0,0,0.55)');
                label.setAttribute('stroke-width', '3');
                label.setAttribute('stroke-linejoin', 'round');
                label.textContent = String(c.label);
                connNode.appendChild(label);
            }
        }
    }
    // Group dashed outlines — one screen-space rect per group.
    const groupsHost = overlay.CvGroupsLayer;
    const groupsNode = groupsHost?.node;
    if (groupsNode) {
        const groups = v2.groups || {};
        const existing = new Map();
        Array.from(groupsNode.children).forEach((c)=>{
            const k = c.getAttribute('data-group-for');
            if (k) existing.set(k, c);
        });
        const seen = new Set();
        for (const [gid, g] of Object.entries(groups)){
            seen.add(gid);
            const bbox = el.call('bboxForGroup', gid);
            if (!bbox) continue;
            let box = existing.get(gid);
            if (!box) {
                box = groupsNode.ownerDocument.createElement('div');
                box.setAttribute('data-group-for', gid);
                box.style.position = 'absolute';
                box.style.border = '1px dashed rgba(64,156,255,0.85)';
                box.style.borderRadius = '4px';
                box.style.pointerEvents = 'none';
                groupsNode.appendChild(box);
            }
            const sx = bbox.x * vp.scale + vp.x + origin.x;
            const sy = bbox.y * vp.scale + vp.y + origin.y;
            box.style.left = sx - 4 + 'px';
            box.style.top = sy - 4 + 'px';
            box.style.width = bbox.w * vp.scale + 8 + 'px';
            box.style.height = bbox.h * vp.scale + 8 + 'px';
        }
        for (const [gid, box] of existing)if (!seen.has(gid)) box.remove();
    }
    // Minimap — render items + viewport rect in a 180x120 box. Gate on
    // `showMinimap` (off by default) before doing ANY of this: `show:`/`hide:`
    // in this framework only ever toggle CSS `display` (see
    // smbls/packages/element/src/create.js — the CSS_PROPS_REGISTRY branch for
    // `show`/`hide` writes `node.style.display`, it never removes the node), so
    // `mmNode` stays truthy the whole time the minimap panel is merely hidden.
    // Without this gate, EVERY refresh — up to 60×/sec during any drag, resize,
    // pan or marquee, whether or not the minimap was ever opened — paid for a
    // forced-synchronous-layout `getBoundingClientRect()` read plus a full
    // Object.values(v2.items) bbox scan plus a full per-item dot create/update
    // pass, for a panel that's off in the overwhelming majority of sessions.
    const minimap = overlay.CvMinimap;
    const mmNode = minimap?.node;
    if (mmNode && v2.showMinimap) {
        const surf = root.lookdown?.('CanvasSurface')?.node;
        const rect = surf?.getBoundingClientRect();
        let mmMinX = Infinity, mmMinY = Infinity, mmMaxX = -Infinity, mmMaxY = -Infinity;
        for (const it of Object.values(v2.items)){
            if (it.x < mmMinX) mmMinX = it.x;
            if (it.y < mmMinY) mmMinY = it.y;
            if (it.x + it.w > mmMaxX) mmMaxX = it.x + it.w;
            if (it.y + it.h > mmMaxY) mmMaxY = it.y + it.h;
        }
        if (Number.isFinite(mmMinX) && rect) {
            const PAD = 8;
            const W = mmNode.clientWidth - PAD * 2;
            const H = mmNode.clientHeight - PAD * 2;
            const cw = mmMaxX - mmMinX;
            const ch = mmMaxY - mmMinY;
            const mScale = Math.min(W / cw, H / ch);
            const ox = PAD - mmMinX * mScale;
            const oy = PAD - mmMinY * mScale;
            const dom = mmNode.ownerDocument;
            const have = new Map();
            Array.from(mmNode.children).forEach((c)=>{
                const k = c.getAttribute('data-mm-for');
                if (k) have.set(k, c);
            });
            const seen = new Set();
            for (const [key, it] of Object.entries(v2.items)){
                seen.add(key);
                let dot = have.get(key);
                if (!dot) {
                    dot = dom.createElement('div');
                    dot.setAttribute('data-mm-for', key);
                    dot.style.position = 'absolute';
                    dot.style.background = 'rgba(255,255,255,0.6)';
                    dot.style.borderRadius = '1px';
                    mmNode.appendChild(dot);
                }
                dot.style.left = it.x * mScale + ox + 'px';
                dot.style.top = it.y * mScale + oy + 'px';
                dot.style.width = it.w * mScale + 'px';
                dot.style.height = it.h * mScale + 'px';
            }
            for (const [key, dot] of have)if (!seen.has(key) && key !== '__viewport__') dot.remove();
            // Viewport rect in canvas-space: [-vp.x/scale, -vp.y/scale] sized [rect.w/scale, rect.h/scale]
            let vpEl = have.get('__viewport__');
            if (!vpEl) {
                vpEl = dom.createElement('div');
                vpEl.setAttribute('data-mm-for', '__viewport__');
                vpEl.style.position = 'absolute';
                vpEl.style.border = '1px solid rgba(64,156,255,0.95)';
                vpEl.style.background = 'rgba(64,156,255,0.15)';
                vpEl.style.pointerEvents = 'none';
                mmNode.appendChild(vpEl);
            }
            const vx = -vp.x / vp.scale;
            const vy = -vp.y / vp.scale;
            const vw = rect.width / vp.scale;
            const vh = rect.height / vp.scale;
            vpEl.style.left = vx * mScale + ox + 'px';
            vpEl.style.top = vy * mScale + oy + 'px';
            vpEl.style.width = vw * mScale + 'px';
            vpEl.style.height = vh * mScale + 'px';
        }
    }
    // Item titles — one screen-space label per item, positioned just above.
    const titlesHost = overlay.CvItemTitles;
    const titlesNode = titlesHost?.node;
    if (titlesNode) {
        const existing = new Map();
        Array.from(titlesNode.children).forEach((c)=>{
            const k = c.getAttribute('data-title-for');
            if (k) existing.set(k, c);
        });
        const seen = new Set();
        for (const [key, it] of Object.entries(v2.items)){
            // Filtered-out items aren't rendered → drop their title too (left out of
            // `seen`, so the cleanup pass below removes any stale label).
            if (!$674cd45eab5b7d8d$var$itemVisibleUnderFilter(rs, key)) continue;
            seen.add(key);
            let lbl = existing.get(key);
            if (!lbl) {
                lbl = titlesNode.ownerDocument.createElement('div');
                lbl.setAttribute('data-title-for', key);
                lbl.style.position = 'absolute';
                lbl.style.color = 'white';
                lbl.style.fontSize = '11px';
                lbl.style.fontWeight = '500';
                lbl.style.padding = '2px 6px';
                lbl.style.background = 'rgba(0,0,0,0.6)';
                lbl.style.borderRadius = '3px';
                lbl.style.transform = 'translateY(-100%)';
                lbl.style.marginTop = '-4px';
                lbl.style.pointerEvents = 'none';
                lbl.style.whiteSpace = 'nowrap';
                // Friendly label for built-in design-system frames (`__ds/colors` →
                // "Design system · Colors") instead of the raw key.
                lbl.textContent = $674cd45eab5b7d8d$export$fe81cfcdc7230c2a(key) ? "Design system \xb7 " + key.slice(5).replace(/^\w/, (c)=>c.toUpperCase()) : key;
                titlesNode.appendChild(lbl);
            }
            const sx = it.x * vp.scale + vp.x + origin.x;
            const sy = it.y * vp.scale + vp.y + origin.y;
            lbl.style.left = sx + 'px';
            lbl.style.top = sy + 'px';
        }
        // Remove labels for items that no longer exist.
        for (const [key, lbl] of existing)if (!seen.has(key)) lbl.remove();
    }
}
function $674cd45eab5b7d8d$export$2ba1bffa7d2b4003() {
    this.call('applyViewport', {
        x: 40,
        y: 40,
        scale: 0.35
    });
}
function $674cd45eab5b7d8d$export$d58457c5b6099869(factor) {
    if (!Number.isFinite(factor) || factor <= 0) return;
    const v2 = this.call('getCanvasV2');
    if (!v2?.viewport) return;
    const surf = this.getRoot?.()?.lookdown?.('CanvasSurface');
    const rect = surf?.node?.getBoundingClientRect?.();
    if (!rect || !rect.width || !rect.height) return;
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const sv = v2.viewport;
    const newScale = Math.max(0.035, Math.min(2.5, sv.scale * factor));
    const worldX = (cx - sv.x) / sv.scale;
    const worldY = (cy - sv.y) / sv.scale;
    this.call('applyViewport', {
        x: cx - worldX * newScale,
        y: cy - worldY * newScale,
        scale: newScale
    });
}
function $674cd45eab5b7d8d$export$eda81de7742ad8e7(scale) {
    if (!Number.isFinite(scale) || scale <= 0) return;
    const v2 = this.call('getCanvasV2');
    if (!v2?.viewport?.scale) return;
    this.call('zoomAroundCenter', scale / v2.viewport.scale);
}
function $674cd45eab5b7d8d$export$b2e73825371036db() {
    const self = this;
    const tw = (0, $fzbiH.resolveTopWindow)();
    if (!tw) return;
    tw.__cvCamera = {
        zoomBy: (factor)=>self.call('zoomAroundCenter', factor),
        zoomTo: (scale)=>self.call('zoomToScale', scale),
        moveTo: (x, y)=>{
            const v2 = self.call('getCanvasV2');
            if (!v2?.viewport) return;
            self.call('applyViewport', {
                ...v2.viewport,
                x: x,
                y: y
            });
        },
        moveBy: (dx, dy)=>{
            const v2 = self.call('getCanvasV2');
            if (!v2?.viewport) return;
            self.call('applyViewport', {
                ...v2.viewport,
                x: v2.viewport.x + dx,
                y: v2.viewport.y + dy
            });
        }
    };
}
function $674cd45eab5b7d8d$export$8fe66b9599e67f1a(items) {
    const values = Object.values(items || {});
    if (!values.length) return null;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const it of values){
        if (it.x < minX) minX = it.x;
        if (it.y < minY) minY = it.y;
        if (it.x + it.w > maxX) maxX = it.x + it.w;
        if (it.y + it.h > maxY) maxY = it.y + it.h;
    }
    return Number.isFinite(minX) && Number.isFinite(minY) && Number.isFinite(maxX) && Number.isFinite(maxY) ? {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY
    } : null;
}
function $674cd45eab5b7d8d$export$f5cc6e3e3398401e(bbox, rect, opts = {}) {
    const { pad: pad = 120, minScale: minScale = 0.02, maxScale: maxScale = 1, fallback: fallback = {
        x: 40,
        y: 40,
        scale: 0.35
    } } = opts;
    if (!bbox || !Number.isFinite(bbox.w) || !Number.isFinite(bbox.h) || bbox.w <= 0 || bbox.h <= 0) return fallback;
    if (!rect || !Number.isFinite(rect.width) || !Number.isFinite(rect.height) || rect.width <= 0 || rect.height <= 0) return fallback;
    const sx = (rect.width - 2 * pad) / bbox.w;
    const sy = (rect.height - 2 * pad) / bbox.h;
    const rawScale = Math.min(sx, sy);
    if (!Number.isFinite(rawScale) || rawScale <= 0) return fallback;
    const scale = Math.max(minScale, Math.min(maxScale, rawScale));
    const x = (rect.width - bbox.w * scale) / 2 - bbox.x * scale;
    const y = (rect.height - bbox.h * scale) / 2 - bbox.y * scale;
    return {
        x: x,
        y: y,
        scale: scale
    };
}
function $674cd45eab5b7d8d$export$fc2e72651871d0dd() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ids = v2.selection.ids;
    const bbox = ids.length ? this.call('bboxForSelection') : (()=>{
        const all = Object.keys(v2.items);
        if (!all.length) return null;
        return this.call('bboxForGroup', '__all__') || (()=>{
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
            for (const it of Object.values(v2.items)){
                if (it.x < minX) minX = it.x;
                if (it.y < minY) minY = it.y;
                if (it.x + it.w > maxX) maxX = it.x + it.w;
                if (it.y + it.h > maxY) maxY = it.y + it.h;
            }
            return Number.isFinite(minX) ? {
                x: minX,
                y: minY,
                w: maxX - minX,
                h: maxY - minY
            } : null;
        })();
    })();
    if (!bbox) return;
    const root = this.getRoot?.();
    const surf = root?.lookdown?.('CanvasSurface');
    const rect = surf?.node?.getBoundingClientRect();
    if (!rect) return;
    const PAD = 60;
    const sx = (rect.width - 2 * PAD) / bbox.w;
    const sy = (rect.height - 2 * PAD) / bbox.h;
    const scale = Math.max(0.05, Math.min(2, Math.min(sx, sy)));
    const x = (rect.width - bbox.w * scale) / 2 - bbox.x * scale;
    const y = (rect.height - bbox.h * scale) / 2 - bbox.y * scale;
    this.call('applyViewport', {
        x: x,
        y: y,
        scale: scale
    });
}
function $674cd45eab5b7d8d$export$ef9019283f52cc4f() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const bbox = this.call('bboxForItems', v2.items);
    if (!bbox) return;
    const root = this.getRoot?.();
    const surf = root?.lookdown?.('CanvasSurface');
    const rect = surf?.node?.getBoundingClientRect();
    if (!rect) return;
    const viewport = this.call('computeFitToContentViewport', bbox, rect, {
        fallback: v2.viewport || $674cd45eab5b7d8d$var$DEFAULTS().viewport
    });
    this.call('applyViewport', viewport);
}
function $674cd45eab5b7d8d$export$3d65ce36f6b7b45d(from, to, label, kind) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !from || !to) return;
    const next = [
        ...v2.connections || [],
        kind ? {
            from: from,
            to: to,
            label: label,
            kind: kind
        } : {
            from: from,
            to: to,
            label: label
        }
    ];
    this.call('patchCanvas', {
        connections: next
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
}
function $674cd45eab5b7d8d$export$c4b227a68608c05e(from, to) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const next = (v2.connections || []).filter((c)=>!(c.from === from && c.to === to));
    this.call('patchCanvas', {
        connections: next
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
}
function $674cd45eab5b7d8d$export$15cf46b46ecd97d0() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    this.call('patchCanvas', {
        shortcutsOpen: !v2.shortcutsOpen
    });
}
// The eager panzoom shim lives in globalScope.js. It reads from
// `topWindow.__cvViewport`, which `applyViewport` writes on every
// viewport change — no second installation needed here.
// Per-tab-session "already seeded" memory for the previewSize seed below —
// keyed by project IDENTITY (owner/key: a bare key is not unique across
// owners), not by whether `root.canvas.items` happened to be empty (a
// template that also pre-seeds real canvas.items, e.g. mobile, never takes
// the items-empty branch, so that flag can't double as this guard). Module
// scope, not component scope: it must survive the SPA re-mounting
// CanvasSurface on every project navigation within one tab, and reset only
// on a real page load (a fresh module instance).
// The device-preview breakpoint a project type opens at. Only `mobile` forces
// one — app/service/deck/library keep the unforced default. `mobileXS` is the
// named 375x768 entry in DeviceButtonSet's own size vocabulary
// (shared/components/DeviceButtonSet.js); never a raw width here.
const $674cd45eab5b7d8d$var$PREVIEW_SIZE_BY_PROJECT_TYPE = {
    mobile: 'mobileXS'
};
const $674cd45eab5b7d8d$var$previewSizeSeededProjects = new Set();
function $674cd45eab5b7d8d$export$94a74e8616390e7c() {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    // Camera bridge first — it must exist even while the pre-load guard below
    // keeps bailing, so outer-chrome zoom works from the first painted frame.
    // Direct same-module invocation, not `this.call`: the guard's contract is
    // "touch nothing" (newProjectPicker.test pins zero registry calls on a
    // bail), and the bridge writes only the top-window hook, never state.
    $674cd45eab5b7d8d$export$b2e73825371036db.call(this);
    // Pre-load guard — CanvasSurface.onRender calls this synchronously while
    // `main` mounts, which races `ensureProjectLoaded`'s async fetch: at that
    // instant `context.projectPages` is still `{}` and `root.data` is either
    // unset (first project opened this session) or stale (a previously-viewed
    // project). Seeding from either produces bogus items — the premature call
    // sees 0 pages + 0 components, which doesn't match the "minimal blank"
    // shape, so `shouldShowDesignSystem` defaults to true and seeds the 7
    // built-in `__ds/*` placeholder tiles into `root.canvas.items`.
    // `ensureProjectLoaded` then re-invokes this function once real data
    // lands, but by then `root.canvas.items` is already non-empty, so THIS
    // premature seed — not the real one — wins: the reconcile branch below
    // deletes the placeholder DS tiles and re-adds the real pages/components,
    // but positions them via a free-slot scan corrupted by the placeholders'
    // stale grid occupancy, and never re-fits the viewport. For a brand-new
    // "blank" project (exactly one `home` component) the result is a single
    // tile stranded far outside the default viewport — a blank screen. Bail
    // out here (without touching `root.canvas` at all) until `root.data`
    // actually matches the URL's project; the seed still runs exactly once,
    // from real data, when `ensureProjectLoaded`'s follow-up call lands.
    const { owner: urlOwner, key: urlKey } = $674cd45eab5b7d8d$var$canvasResolveProjectParams();
    if (urlOwner && urlKey) {
        const loadedKey = root?.data?.key || root?.data?.projectKey;
        if (loadedKey !== urlKey) return;
    }
    // The board belongs to its project. root.canvas lives on the SHELL root, and
    // a project switch keeps it: navigation.js swaps root.data in place and calls
    // this again. After A -> B, root.canvas still held A's board, the board-pages
    // guard below took it for B's own, reconciled B's pages INTO it and persisted
    // it to B's id (persistCanvasLayout writes root.data._id): B's saved layout
    // never loaded and was overwritten with A's. Where a board is restored or
    // seeded below, it carries its project's id (`projectId`; never persisted —
    // persistCanvasLayout writes named fields only). A board of another project
    // is no board here: every branch below reads `board`, so B restores or seeds
    // its own, and that write replaces root.canvas as a whole. (history.js keeps
    // its undo stack per board the same way.)
    const board = root?.canvas && root.canvas.projectId === root?.data?._id ? root.canvas : null;
    // Idempotency guard (Nika 2026-08-01, board pages). CanvasSurface.onRender
    // fires initCanvasV2 on EVERY render, so once the board is initialised (has
    // pages) this must NOT restore-from-persisted or re-seed — an empty `items`
    // is no longer "uninitialised", it's a legitimately-empty new board page, and
    // reseeding would clobber a just-added page (reverting pages/activePageId).
    // Reconcile missing project pages only onto a NON-empty active page (never
    // auto-fill an intentional blank page), then return.
    // Paint the restored camera BEFORE any early return. The persisted viewport
    // is restored into STATE, but nothing wrote it to the DOM: CvScene keeps its
    // declared placeholder transform `translate3d(40px, 40px, 0) scale(0.35)`
    // until applyViewport runs, and every early return below skipped it — the
    // board-pages guard immediately after this is the one real boards actually
    // take. Result: a board saved at any other camera painted every tile at the
    // wrong place. Measured 2026-08-08 on natali/shop — state camera
    // {x: 702, y: -6192, scale: 0.2308} vs a scene still on 40/40/0.35, putting
    // all six mounted tiles at y≈9040-10434px in a 963px window: in the DOM,
    // visible, opacity 1, just ~9000px below the fold. The first pan called
    // applyViewport and everything snapped in — the "canvas items don't appear
    // until I pan" report (per Nika, "it's a rendering issue and you're not
    // fixing the right thing"; he was right). Idempotent: applyViewport is a
    // pure write of transform + grid + screen-space chrome from the camera it's
    // handed, so re-running it with the live camera changes nothing.
    if (board?.viewport && typeof board.viewport.scale === 'number') this.call('applyViewport', board.viewport);
    if (Array.isArray(board?.pages) && board.pages.length) {
        if (Object.keys(board.items || {}).length) this.call('syncCanvasItemsFromPages');
        this.call('subscribeMarketplaceInstalls');
        return;
    }
    const ctx = this.context || this.getRootContext?.() || {};
    const pages = ctx.projectPages || {};
    const components = root?.data?.components || {};
    // The two flags read the live board first. A board of another project holds
    // no flag of this one: read this project's saved flags.
    const flagsFrom = board ? root : {
        data: root?.data
    };
    const showDesignSystem = $674cd45eab5b7d8d$export$d41541d22010f1e7(flagsFrom);
    const showComponents = $674cd45eab5b7d8d$export$cae3de431c40dad3(flagsFrom);
    // Restore previously persisted layout from the top-level `canvas`
    // field, with fallbacks for older saves. Only honour it if it
    // actually has items — a bare `canvas: {}` falls through to seed.
    const persistedRaw = root?.data?.canvas || root?.data?.canvasLayout || root?.data?.settings?.canvas;
    // Honour a persisted doc that carries BOARD STATE, not just one with tiles.
    // Gating this on `items` alone silently discarded every added page on reload:
    // `pages`/`activePageId` persist fine, but a board whose ACTIVE page has no
    // tiles read as "never initialised" and fell through to the fresh-seed path
    // below, which writes `...DEFAULTS()` — and DEFAULTS carries the single
    // `page-1`. That's the real cause of the "add-page reverts" symptom: a
    // just-added page is empty by construction, and since #203 made the
    // design-system + component frames default OFF, an empty active page is the
    // common case rather than a corner. A legacy pre-pages doc has no `pages`
    // key, so it keeps the old items-only behaviour exactly. (Nika 2026-08-02.)
    const hasPersistedBoard = !!persistedRaw && (Object.keys(persistedRaw.items || {}).length > 0 || Array.isArray(persistedRaw.pages) && persistedRaw.pages.length > 0);
    const persisted = hasPersistedBoard ? persistedRaw : null;
    // Seed the device-preview default on this project's first open, so a mobile
    // project does not open on whatever breakpoint a previously-viewed project
    // left active. Runs once per project per tab-session, from every branch
    // below that can own a fresh load. previewSize has no persisted slot of its
    // own (a session cookie plus the canvas scope), so this mirrors the same
    // pair DeviceButtonSet writes.
    //
    // TWO sources, in this order:
    //
    //   1. the persisted board's own `previewSize`, for a project that has one;
    //   2. the PROJECT TYPE, which is the one that actually fires on a fresh
    //      create.
    //
    // Source 2 is not a fallback for tidiness — without it this seed was dead
    // code on the path it was written for. `persistedRaw` reads
    // `root.data.canvas`, and `root.data` on the canvas route is the PROJECT
    // RECORD: measured live 2026-09-04 on a just-created mobile project
    // (workspace.localhost:1355/nikoloza/ws-mobile-live-check-4), `root.data`
    // carries forkedFrom/_id/name/key/projectType/environments/… and NO
    // `canvas` key at all, so `persisted` was null and this returned on its
    // first line every time — no cookie, no scope write. The tiles still landed
    // in the right places, which is what hid it: autoLayout derives the same
    // positions from the page list, so the board looked correct while the
    // breakpoint leg silently did nothing.
    //
    // The project type is the honest source anyway. A `mobile` project should
    // preview at a mobile breakpoint because of what it IS, not because one
    // template remembered to say so — and `projectType` is on the record every
    // consumer already reads. `mobileXS` is the named 375x768 size in the
    // DeviceButtonSet vocabulary. Only `mobile` maps: app/service/deck keep
    // today's unforced default, exactly as the spec asks.
    const seedPreviewSizeOnce = ()=>{
        if (!urlKey) return;
        const size = persisted?.previewSize || $674cd45eab5b7d8d$var$PREVIEW_SIZE_BY_PROJECT_TYPE[root?.data?.projectType];
        if (!size) return;
        const seedKey = `${urlOwner}/${urlKey}`;
        if ($674cd45eab5b7d8d$var$previewSizeSeededProjects.has(seedKey)) return;
        $674cd45eab5b7d8d$var$previewSizeSeededProjects.add(seedKey);
        this.call('setCookie', 'previewSize', size);
        const canvasScope = this.call('getCanvasScope');
        if (canvasScope) canvasScope.previewSize = size;
    };
    if (persisted && root?.update && !Object.keys(board?.items || {}).length) {
        const stored = $674cd45eab5b7d8d$var$loadStored();
        const base = $674cd45eab5b7d8d$var$DEFAULTS();
        if (stored.snap) base.snap = {
            ...base.snap,
            ...stored.snap
        };
        const initialFocus = persisted.initialFocus;
        const shouldFocus = !!(initialFocus && persisted.items?.[initialFocus]);
        const items = Object.fromEntries(Object.entries(persisted.items || {}).filter(([key, item])=>{
            if (!showDesignSystem && $674cd45eab5b7d8d$export$fe81cfcdc7230c2a(key)) return false;
            // Only prune items explicitly marked as auto-seeded component-showcase
            // frames (`_componentShowcase`, stamped by the gallery-seed paths
            // below and in syncCanvasItemsFromPages) — NOT every item whose key
            // happens to match a project component. A component can also BE a
            // project's sole board/page tile: the Blank template's only content
            // is `components: { home }` with no pages, and its `home` tile must
            // never be pruned just because "home" is also a component name.
            if (!showComponents && item?._componentShowcase) return false;
            return true;
        }));
        root.update({
            canvas: {
                ...base,
                // Board pages: honour a persisted pages list, else migrate this legacy
                // single-board doc — its `items` below become the first page (Nika
                // 2026-08-01), named in the session language. The name resolves only
                // for a doc with no pages; `base`'s own page is replaced here either way.
                ...$674cd45eab5b7d8d$export$ef6300950d2aa1f9(persisted, ()=>$674cd45eab5b7d8d$var$boardPageDefaultName(this, 1)),
                items: items,
                guides: persisted.guides || base.guides,
                groups: persisted.groups || {},
                showDesignSystem: showDesignSystem,
                showComponents: showComponents,
                selection: shouldFocus ? {
                    ids: [
                        initialFocus
                    ],
                    primary: initialFocus
                } : base.selection,
                // A persisted `{}` viewport is truthy but has no scale → the screen-space
                // chrome (selection box, SelectedNavbar) computes NaN positions and
                // floats off the items. Only honour a persisted viewport that actually
                // carries a scale; otherwise fall back to the default. (2026-06-17.)
                viewport: persisted.viewport && persisted.viewport.scale != null ? persisted.viewport : base.viewport,
                projectId: root.data._id
            }
        });
        // Paint the restored camera. On a first open the scene's mount poll
        // (CanvasSurface CvScene) paints it too, but on a project switch that poll
        // has already stopped on the last board's camera.
        this.call('applyViewport', root.canvas.viewport);
        seedPreviewSizeOnce();
        if (shouldFocus) {
            const focus = ()=>{
                this.call('fitToSelection');
                // The persisted rewrite intentionally omits `initialFocus`, making this
                // a first-open behavior rather than resetting the user's viewport later.
                this.call('persistCanvasLayout');
            };
            if (typeof requestAnimationFrame === 'function') requestAnimationFrame(focus);
            else setTimeout(focus, 0);
        }
        this.call('pushHistory');
        this.call('subscribeMarketplaceInstalls');
        return;
    }
    if (!root?.update) return;
    if (board && Object.keys(board.items || {}).length) {
        // Heal a viewport that was persisted/left as `{}` (no scale) — otherwise the
        // screen-space chrome positions at NaN and the selection box / SelectedNavbar
        // float off the items. (2026-06-17.)
        if (!root.canvas.viewport || root.canvas.viewport.scale == null) this.call('applyViewport', {
            x: 40,
            y: 40,
            scale: 0.35
        });
        else // …and APPLY a valid restored one. Restoring the persisted camera into
        // STATE (the `root.update({ …viewport })` above) never touched the DOM:
        // CvScene keeps its declared placeholder transform
        // `translate3d(40px, 40px, 0) scale(0.35)` until something calls
        // applyViewport, so a board saved at any other camera painted every tile
        // at the WRONG place — measured 2026-08-08 on natali/shop: state camera
        // {x: 702, y: -6192, scale: 0.2308} while the scene still read the 40/40/
        // 0.35 default, putting all six mounted tiles at y≈9040-10434px in a
        // 963px window (in the DOM, visible, opacity 1 — just ~9000px below the
        // fold). The first pan called applyViewport and everything snapped in,
        // which is exactly the "canvas items don't appear until I pan" report
        // (per Nika: "it's a rendering issue and you're not fixing the right
        // thing" — he was right). Also re-syncs the dot grid + screen-space
        // chrome, which were stale for the same reason.
        this.call('applyViewport', root.canvas.viewport);
        // Reconcile so canvases created before pages/components/design-system frames
        // shipped pick them up (no-op when nothing's missing).
        this.call('syncCanvasItemsFromPages');
        // A template that ships its own real canvas.items (mobile) lands HERE on
        // first open, not in the persisted-restore branch above — its items are
        // never empty, so that branch's `!items.length` gate never lets it in.
        seedPreviewSizeOnce();
        this.call('subscribeMarketplaceInstalls');
        return;
    }
    // Also seed the project's COMPONENTS as frames — a CanvasItem renders ANY
    // project key through embedComponent, not just pages, so a component-only
    // project (pages: {}, components: { … }) is no longer blank. (2026-06-17 per
    // Nika "also show components on project canvas".)
    // Built-in design-system pages — appended so they sit after the user's own
    // pages/components in the grid. Each renders the user's design system.
    const dsEntries = showDesignSystem ? $674cd45eab5b7d8d$export$3da481080d1962a4.map((k)=>[
            k,
            {
                _ds: true
            }
        ]) : [];
    const componentEntries = showComponents ? Object.entries(components) : [];
    const entries = [
        ...Object.entries(pages),
        ...componentEntries,
        ...dsEntries
    ];
    // Keys added ONLY via the opt-in component-gallery seed above (not a page
    // that happens to share a key with a component). Stamped onto the item
    // below so a future prune (showComponents toggled off, here or in
    // syncCanvasItemsFromPages) can tell a showcase frame apart from a
    // component that's also the project's actual page/board content.
    const pageKeySet = new Set(Object.keys(pages));
    const componentShowcaseKeys = new Set(componentEntries.map(([key])=>key).filter((key)=>!pageKeySet.has(key)));
    // 4-col layout at 1722×1722 canvas-space px per thumbnail with 256 gap.
    const W = 1722;
    const GAP = 256;
    const COLS = 4;
    const items = {};
    entries.forEach(([key, v], i)=>{
        const col = i % COLS;
        const row = Math.floor(i / COLS);
        const saved = v?.settings?.gridOptions || {};
        const usingSaved = saved.x != null && saved.y != null;
        items[key] = {
            x: usingSaved ? saved.x * (W + GAP) / 3 : col * (W + GAP),
            y: usingSaved ? saved.y * (W + GAP) / 3 : row * (W + GAP),
            w: usingSaved ? (saved.w || 3) * (W / 3) : W,
            h: usingSaved ? (saved.h || 3) * (W / 3) : W,
            pageKey: key,
            ...componentShowcaseKeys.has(key) ? {
                _componentShowcase: true
            } : {}
        };
    });
    // Restore persisted snap + ruler/minimap visibility settings. A fresh board's
    // first page takes its name in the session language.
    const stored = $674cd45eab5b7d8d$var$loadStored();
    const base = $674cd45eab5b7d8d$var$DEFAULTS($674cd45eab5b7d8d$var$boardPageDefaultName(this, 1));
    if (stored.snap) base.snap = {
        ...base.snap,
        ...stored.snap
    };
    if (typeof stored.showRulers === 'boolean') base.showRulers = stored.showRulers;
    if (typeof stored.showMinimap === 'boolean') base.showMinimap = stored.showMinimap;
    root.update({
        canvas: {
            ...base,
            items: items,
            showDesignSystem: showDesignSystem,
            showComponents: showComponents,
            projectId: root.data?._id
        }
    });
    // Paint the seeded camera (a project switch: see the restore branch above).
    // fitCanvasToContent below re-paints it when there is content to fit.
    this.call('applyViewport', root.canvas.viewport);
    // THE branch a freshly created project actually takes. The two calls above
    // both sit behind a gate a new project fails — one needs a persisted board
    // (`root.data.canvas`, which the canvas route never carries), the other
    // needs `root.canvas.items` already populated — so before this call the
    // seed could not run on a create at all. Measured live 2026-09-04: a new
    // mobile project opened with no previewSize cookie and no scope write.
    seedPreviewSizeOnce();
    // Zoom to fit — ONLY on this fresh-seed path (tickets/nika.md "PRODUCT CALL",
    // 2026-08-16). Reached only when `hasPersistedBoard` was false, i.e. the
    // project has no saved arrangement at all: no items AND no pages. A board
    // with a saved camera returns from the `persisted` branch far above and
    // never arrives here, so its viewport is untouched by construction — that
    // is the regression this must not cause, and the control flow, not a
    // conditional here, is what prevents it.
    //
    // Ordered BEFORE pushHistory so the fitted camera is the first history
    // entry rather than an immediate undo target — otherwise a user's first
    // ctrl-Z would throw them back to the unfitted 0.35 default.
    //
    // Safe no-op if CanvasSurface has no rect yet or there are no items: the
    // `root.update` above already seeded a valid fallback camera synchronously,
    // so doing nothing leaves a working board, never a blank one.
    this.call('fitCanvasToContent');
    this.call('pushHistory');
    this.call('subscribeMarketplaceInstalls');
}
// ── Marketplace-install subscription (#2048, modal-install half) ──
//
// `initCanvasV2` seeds v2.items once from context.projectPages and
// never re-syncs.  When a user installs a template/library via the
// modal flow (not the drag-drop flow), the server creates a new
// project page and the marketplace broadcasts a postMessage telling
// the canvas tab to sync.  Drag-drop installs already patch v2.items
// directly via installMarketplaceItem — this subscription only covers
// the modal/button-install path that the drag-drop doesn't touch.
//
// Self-guarded: a top-level flag prevents duplicate listeners across
// HMR reloads, and the listener no-ops when the canvas root isn't
// mounted.
let $674cd45eab5b7d8d$var$_marketplaceInstallSubscribed = false;
let $674cd45eab5b7d8d$var$_canvasOwner = null;
function $674cd45eab5b7d8d$export$8ba1149148a88441() {
    if (typeof window === 'undefined') return;
    $674cd45eab5b7d8d$var$_canvasOwner = this;
    if ($674cd45eab5b7d8d$var$_marketplaceInstallSubscribed) return;
    $674cd45eab5b7d8d$var$_marketplaceInstallSubscribed = true;
    window.addEventListener('message', (ev)=>{
        if (ev?.data?.type !== 'symbols:marketplace-installed') return;
        // a first-party sender only — a user-code tile on this page cannot spam it
        if (!(0, $aj1Eh.isTrustedInstallMessage)(ev)) return;
        const owner = $674cd45eab5b7d8d$var$_canvasOwner;
        if (!owner) return;
        // Small delay so the server-side mutation lands in
        // context.projectPages before we re-scan it.  600ms mirrors the
        // existing `symbols:integration-installed` listener in
        // canvas/pages/studios.js.
        setTimeout(()=>{
            try {
                owner.call?.('syncCanvasItemsFromPages');
            } catch (err) {
                console.warn('[canvas v2] post-install sync failed:', err?.message || err);
            }
        }, 600);
    });
}
// Every item key that exists ANYWHERE on the board — the active page's live
// `items` plus every parked page's `pageItems[id].items` snapshot (board
// pages, Nika 2026-08-01). A key absent from the ACTIVE page alone is not
// necessarily new: it may simply be divided onto another page.
// syncCanvasItemsFromPages used to check `v2.items` alone, so it re-added
// every parked key onto whichever page happened to be open on the very next
// toggle / add-page / remote-op — silently re-merging a deliberately divided
// board back into one page. (applyRemoteOps.js's `removeTile` had the
// mirror-image deletion bug — fixed there too.)
const $674cd45eab5b7d8d$var$_allBoardItemKeys = (v2)=>{
    const keys = new Set(Object.keys(v2.items || {}));
    const pageItems = v2.pageItems || {};
    for(const id in pageItems){
        const parked = pageItems[id]?.items;
        if (!parked) continue;
        for(const key in parked)keys.add(key);
    }
    return keys;
};
function $674cd45eab5b7d8d$export$bb6fede81bb8b328() {
    const v2 = this.call('getCanvasV2');
    if (!v2) return;
    const ctx = this.context || this.getRootContext?.() || {};
    const pages = ctx.projectPages || {};
    const root = $674cd45eab5b7d8d$var$rootState(this);
    const components = root?.data?.components || {};
    const showDesignSystem = $674cd45eab5b7d8d$export$d41541d22010f1e7(root);
    const showComponents = $674cd45eab5b7d8d$export$cae3de431c40dad3(root);
    const existingKeys = $674cd45eab5b7d8d$var$_allBoardItemKeys(v2);
    const W = 1722;
    const GAP = 256;
    const COLS = 4;
    const next = {
        ...v2.items
    };
    let changed = 0;
    if (!showDesignSystem) for (const key of Object.keys(next)){
        if (!$674cd45eab5b7d8d$export$fe81cfcdc7230c2a(key)) continue;
        delete next[key];
        changed++;
    }
    // Prune component-showcase frames when components are toggled off (mirrors
    // the DS prune above). Only items explicitly marked `_componentShowcase`
    // (stamped by the gallery-seed paths — this function's own reconcile block
    // below, and initCanvasV2's fresh seed) are eligible — NOT every item whose
    // key happens to match a project component. A component can also BE a
    // project's sole board/page tile (e.g. the Blank template, whose only
    // content is `components: { home }` with no pages), and must never be
    // pruned just because its key is a component name.
    if (!showComponents) for (const key of Object.keys(next)){
        if (!next[key]?._componentShowcase) continue;
        delete next[key];
        changed++;
    }
    // Find the next available grid slot by scanning existing positions
    // — keeps new tiles roughly in-grid with the seed layout.
    const usedSlots = new Set();
    for (const it of Object.values(v2.items || {})){
        if (typeof it.x !== 'number' || typeof it.y !== 'number') continue;
        const col = Math.round(it.x / (W + GAP));
        const row = Math.round(it.y / (W + GAP));
        if (col >= 0 && row >= 0) usedSlots.add(`${col},${row}`);
    }
    let probeCol = 0;
    let probeRow = 0;
    const nextFreeSlot = ()=>{
        while(usedSlots.has(`${probeCol},${probeRow}`)){
            probeCol++;
            if (probeCol >= COLS) {
                probeCol = 0;
                probeRow++;
            }
        }
        const slot = {
            col: probeCol,
            row: probeRow
        };
        usedSlots.add(`${probeCol},${probeRow}`);
        probeCol++;
        if (probeCol >= COLS) {
            probeCol = 0;
            probeRow++;
        }
        return slot;
    };
    for (const [key, value] of Object.entries(pages)){
        if (existingKeys.has(key)) continue;
        // Honour any saved gridOptions the page already carries.  Mirrors
        // initCanvasV2's seeding math so resync tiles align with the
        // existing layout.
        const saved = value?.settings?.gridOptions || {};
        const usingSaved = saved.x != null && saved.y != null;
        let x, y, w, h;
        if (usingSaved) {
            x = saved.x * (W + GAP) / 3;
            y = saved.y * (W + GAP) / 3;
            w = (saved.w || 3) * (W / 3);
            h = (saved.h || 3) * (W / 3);
        } else {
            const { col: col, row: row } = nextFreeSlot();
            x = col * (W + GAP);
            y = row * (W + GAP);
            w = W;
            h = W;
        }
        next[key] = {
            x: x,
            y: y,
            w: w,
            h: h,
            pageKey: key
        };
        changed++;
    }
    // Also reconcile the project's COMPONENTS as frames (mirrors the seed in
    // initCanvasV2) so a component added after init shows up too (2026-06-17) —
    // only when components are toggled on (default off, Nika 2026-08-01).
    if (showComponents) for (const key of Object.keys(components)){
        if (existingKeys.has(key) || next[key]) continue;
        const { col: col, row: row } = nextFreeSlot();
        next[key] = {
            x: col * (W + GAP),
            y: row * (W + GAP),
            w: W,
            h: W,
            pageKey: key,
            _componentShowcase: true
        };
        changed++;
    }
    // Built-in design-system pages (mirrors the seed) — so they appear on canvases
    // created before this shipped, too.
    if (showDesignSystem) for (const key of $674cd45eab5b7d8d$export$3da481080d1962a4){
        if (existingKeys.has(key) || next[key]) continue;
        const { col: col, row: row } = nextFreeSlot();
        next[key] = {
            x: col * (W + GAP),
            y: row * (W + GAP),
            w: W,
            h: W,
            pageKey: key
        };
        changed++;
    }
    if (!changed) return;
    this.call('patchCanvas', {
        items: next
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
}
function $674cd45eab5b7d8d$export$f233ab617fbc1d35() {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    this.call('patchCanvas', {
        showDesignSystem: !$674cd45eab5b7d8d$export$d41541d22010f1e7(root)
    });
    this.call('syncCanvasItemsFromPages');
    this.call('persistCanvasLayout');
}
function $674cd45eab5b7d8d$export$ecee4283e4da2118() {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    this.call('patchCanvas', {
        showComponents: !$674cd45eab5b7d8d$export$cae3de431c40dad3(root)
    });
    this.call('syncCanvasItemsFromPages');
    this.call('persistCanvasLayout');
}
// ── Board pages (Figma-style) — Nika 2026-08-01 ─────────────────────────────
// The ACTIVE page's layout lives in the top-level live canvas fields; inactive
// pages are parked as snapshots in `canvas.pageItems[id]`. Switching swaps the
// two. A board always keeps ≥1 page.
// The live-field slice that makes up one page's layout.
const $674cd45eab5b7d8d$var$_livePageSlice = (v2)=>({
        items: v2.items || {},
        guides: v2.guides || $674cd45eab5b7d8d$var$DEFAULTS().guides,
        groups: v2.groups || {},
        viewport: v2.viewport || $674cd45eab5b7d8d$var$DEFAULTS().viewport,
        connections: v2.connections || []
    });
function $674cd45eab5b7d8d$export$ef6300950d2aa1f9(canvas, firstPageName) {
    if (Array.isArray(canvas?.pages) && canvas.pages.length) return {
        pages: canvas.pages,
        activePageId: canvas.activePageId && canvas.pages.some((p)=>p.id === canvas.activePageId) ? canvas.activePageId : canvas.pages[0].id,
        pageItems: canvas.pageItems || {}
    };
    const name = typeof firstPageName === 'function' && firstPageName() || '1';
    return {
        pages: [
            {
                id: 'page-1',
                name: name
            }
        ],
        activePageId: 'page-1',
        pageItems: canvas?.pageItems || {}
    };
}
function $674cd45eab5b7d8d$export$dd95c804a72966c(id) {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    const v2 = root?.canvas;
    if (!v2 || !id || id === v2.activePageId) return;
    const pages = Array.isArray(v2.pages) ? v2.pages : [];
    if (!pages.some((p)=>p.id === id)) return;
    const pageItems = {
        ...v2.pageItems || {}
    };
    // Snapshot the outgoing page's live layout.
    if (v2.activePageId) pageItems[v2.activePageId] = $674cd45eab5b7d8d$var$_livePageSlice(v2);
    // Hydrate the incoming page (empty defaults for a never-visited page).
    const snap = pageItems[id] || {};
    this.call('patchCanvas', {
        activePageId: id,
        pageItems: pageItems,
        items: snap.items || {},
        guides: snap.guides || $674cd45eab5b7d8d$var$DEFAULTS().guides,
        groups: snap.groups || {},
        viewport: snap.viewport || $674cd45eab5b7d8d$var$DEFAULTS().viewport,
        connections: snap.connections || [],
        selection: {
            ids: [],
            primary: null
        }
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
}
function $674cd45eab5b7d8d$export$4f571f3b3c303fe6(name) {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    const v2 = root?.canvas;
    if (!v2) return;
    const pages = Array.isArray(v2.pages) ? v2.pages : [];
    const existing = new Set(pages.map((p)=>p.id));
    let n = pages.length + 1;
    let id = `page-${n}`;
    while(existing.has(id)){
        n++;
        id = `page-${n}`;
    }
    const pageName = name && String(name).trim() || $674cd45eab5b7d8d$var$boardPageDefaultName(this, pages.length + 1);
    // Add the page, snapshot the current one, and activate the new empty page — all
    // in ONE patch. Successive patchCanvas calls read stale state under the signal
    // store's batched update, so a separate switchBoardPage would see pages without
    // the just-added entry and bail.
    const pageItems = {
        ...v2.pageItems || {}
    };
    if (v2.activePageId) pageItems[v2.activePageId] = $674cd45eab5b7d8d$var$_livePageSlice(v2);
    this.call('patchCanvas', {
        pages: [
            ...pages,
            {
                id: id,
                name: pageName
            }
        ],
        pageItems: pageItems,
        activePageId: id,
        items: {},
        guides: $674cd45eab5b7d8d$var$DEFAULTS().guides,
        groups: {},
        viewport: $674cd45eab5b7d8d$var$DEFAULTS().viewport,
        connections: [],
        selection: {
            ids: [],
            primary: null
        }
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
}
function $674cd45eab5b7d8d$export$de2f4a2c9a2982c4(id, name) {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    const v2 = root?.canvas;
    if (!v2 || !id) return;
    const trimmed = name && String(name).trim() || '';
    if (!trimmed) return;
    const pages = (Array.isArray(v2.pages) ? v2.pages : []).map((p)=>p.id === id ? {
            ...p,
            name: trimmed
        } : p);
    this.call('patchCanvas', {
        pages: pages
    });
    this.call('persistCanvasLayout');
}
function $674cd45eab5b7d8d$export$c8279f5eac99a83d(pageId) {
    const v2 = this.call('getCanvasV2');
    if (!v2) return {};
    const id = pageId || v2.activePageId;
    const page = (Array.isArray(v2.pages) ? v2.pages : []).find((p)=>p.id === id);
    return page && page.meta || {};
}
function $674cd45eab5b7d8d$export$66dbbdb461204f81(pageId, patch) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !patch) return false;
    const id = pageId || v2.activePageId;
    const pages = Array.isArray(v2.pages) ? v2.pages : [];
    if (!pages.some((p)=>p.id === id)) return false;
    const next = pages.map((p)=>{
        if (p.id !== id) return p;
        const meta = {
            ...p.meta || {},
            ...patch
        };
        for (const k of Object.keys(meta))if (meta[k] === undefined) delete meta[k];
        return {
            ...p,
            meta: meta
        };
    });
    this.call('patchCanvas', {
        pages: next
    });
    this.call('persistCanvasLayout');
    return true;
}
function $674cd45eab5b7d8d$export$95fcfcb6bd6ace66(id) {
    const root = $674cd45eab5b7d8d$var$rootState(this);
    const v2 = root?.canvas;
    if (!v2 || !id) return;
    const pages = Array.isArray(v2.pages) ? v2.pages : [];
    if (pages.length <= 1) return;
    const remaining = pages.filter((p)=>p.id !== id);
    if (remaining.length === pages.length) return;
    const pageItems = {
        ...v2.pageItems || {}
    };
    delete pageItems[id];
    if (v2.activePageId === id) {
        // Deleting the active page: switch to the first remaining, then drop it.
        const fallback = remaining[0].id;
        const snap = pageItems[fallback] || {};
        this.call('patchCanvas', {
            pages: remaining,
            pageItems: pageItems,
            activePageId: fallback,
            items: snap.items || {},
            guides: snap.guides || $674cd45eab5b7d8d$var$DEFAULTS().guides,
            groups: snap.groups || {},
            viewport: snap.viewport || $674cd45eab5b7d8d$var$DEFAULTS().viewport,
            connections: snap.connections || [],
            selection: {
                ids: [],
                primary: null
            }
        });
        this.call('refreshCanvasChrome');
    } else this.call('patchCanvas', {
        pages: remaining,
        pageItems: pageItems
    });
    this.call('persistCanvasLayout');
}

});
parcelRegister("aj1Eh", function(module, exports) {

$parcel$export(module.exports, "isTrustedInstallMessage", () => $780cf51fa71453f4$export$24abea874efcc70b);
// USER-CODE-ORIGIN security review 8 / r2 note 5: the canvas listens for two
// install notices on `window` ('symbols:marketplace-installed',
// 'symbols:integration-installed'). Their only senders are the marketplace
// functions of THIS app, which post to their OWN window
// (`window.postMessage(…, '*')` in marketplace/functions/index.js). A
// user-code tile is a sandboxed frame on this page and can `parent
// .postMessage` too (origin "null"), and a published *.symbo.ls site runs user
// code. So a notice counts only when it comes from this very window, on this
// very origin. Self-contained (frank serializes it alone).
function $780cf51fa71453f4$export$24abea874efcc70b(ev) {
    if (typeof window === 'undefined' || !ev) return false;
    if (ev.source !== window) return false;
    const here = window.location && window.location.origin;
    return typeof ev.origin === 'string' && !!here && ev.origin === here;
}

});


parcelRegister("dctxD", function(module, exports) {

$parcel$export(module.exports, "ENTITY_ITEM_W", () => $99c34fac68484218$export$ce159b7b44de21);
$parcel$export(module.exports, "ENTITY_ITEM_H", () => $99c34fac68484218$export$32365c9b62596e2b);
$parcel$export(module.exports, "ENTITY_RELATION_DIRECTION", () => $99c34fac68484218$export$7972266835acba56);
$parcel$export(module.exports, "layoutEntityFan", () => $99c34fac68484218$export$112ed80be6f76a93);
// layoutEntityFan — the PURE placement half of "Expand" (spec §3.2).
//
// Given the focus node's rect and the neighbours the relations endpoint
// returned, decide where each new entity node goes. No state reads, no DOM, no
// clock, no randomness: the same input always produces the same output, which
// is what makes an expand idempotent (expand → collapse → expand puts the same
// node back in the same place) and what makes it unit-testable.
//
// ── DIRECTION BY RELATION ─────────────────────────────────────────────────
// The compass is semantic, not decorative — it is how a reader scans a thread:
//
//   south  reply_to                              a conversation reads downward
//   east   attached_to                           what hangs off this thing
//   north  governs · cites                       the law-like thing ABOVE it
//   west   references · amends · supersedes      what it points back at
//          · party_to
//   ring   everything else (relates_to,          spread into the four
//          derived_from, variation_of,           diagonal columns
//          because_of, unknown relations)
//
// ── WHY THE BANDS CANNOT OVERLAP ──────────────────────────────────────────
// Each bucket owns an axis-aligned band that no other bucket can enter:
//
//   • north / south stack in ONE column centred on the focus, so their x band
//     is [cx - W/2, cx + W/2].
//   • east starts at max(focus.right, cx + W/2) + GAP — strictly right of that
//     band, even when the focus is NARROWER than a node (the case a naive
//     `focus.right + GAP` gets wrong, because a centred column overhangs a
//     narrow focus on both sides).
//   • west mirrors it.
//   • the ring uses a SECOND east/west column (one more W + GAP outward), so a
//     long east column and a long ring can never meet — the bug you get from
//     putting the diagonals in the first column and letting both grow.
//
// Within a column, consecutive slots are H + GAP_Y apart, so they cannot
// overlap each other either. `__tests__/entityLayout.test.js` asserts both
// properties over a generated fan rather than trusting this comment.
// Default entity-node geometry, in CANVAS space (the same coordinate space
// `canvas.items[key] = { x, y, w, h }` already stores page/component tiles in
// — plain numbers, not CSS, so design tokens do not apply here).
const $99c34fac68484218$export$ce159b7b44de21 = 280;
const $99c34fac68484218$export$32365c9b62596e2b = 160;
const $99c34fac68484218$var$GAP_X = 120;
const $99c34fac68484218$var$GAP_Y = 64;
const $99c34fac68484218$export$7972266835acba56 = {
    reply_to: 'south',
    attached_to: 'east',
    governs: 'north',
    cites: 'north',
    references: 'west',
    amends: 'west',
    supersedes: 'west',
    party_to: 'west'
};
// The four ring slots, cycled in this order so the first four "other"
// neighbours land in four different quadrants instead of stacking in one.
const $99c34fac68484218$var$RING_ORDER = [
    'ne',
    'sw',
    'nw',
    'se'
];
// Normalise the `taken` argument — a Set, an array of keys, or an items MAP
// (`canvas.items`) all mean the same thing here: keys already on the board.
const $99c34fac68484218$var$_takenSet = (taken)=>{
    if (!taken) return new Set();
    if (taken instanceof Set) return taken;
    if (Array.isArray(taken)) return new Set(taken);
    if (typeof taken === 'object') return new Set(Object.keys(taken));
    return new Set();
};
// The item key for a neighbour. Accepts the string form directly and the
// EntityRef object form; anything else has no key and is skipped.
const $99c34fac68484218$var$_keyOf = (ref)=>{
    if (!ref) return '';
    if (typeof ref === 'string') return ref.indexOf('ref:') === 0 ? ref : '';
    const id = ref.id != null ? String(ref.id) : '';
    return ref.type && id ? 'ref:' + ref.type + ':' + id : '';
};
const $99c34fac68484218$export$112ed80be6f76a93 = (focusRect, neighbors, opts)=>{
    const list = Array.isArray(neighbors) ? neighbors : [];
    if (!list.length) return [];
    const focus = focusRect || {};
    const fx = Number(focus.x) || 0;
    const fy = Number(focus.y) || 0;
    const fw = Number(focus.w) || $99c34fac68484218$export$ce159b7b44de21;
    const fh = Number(focus.h) || $99c34fac68484218$export$32365c9b62596e2b;
    const W = opts && Number(opts.w) || $99c34fac68484218$export$ce159b7b44de21;
    const H = opts && Number(opts.h) || $99c34fac68484218$export$32365c9b62596e2b;
    const taken = $99c34fac68484218$var$_takenSet(opts && opts.taken);
    const cx = fx + fw / 2;
    const cy = fy + fh / 2;
    const colX = cx - W / 2;
    // Push east/west clear of BOTH the focus box and the centred north/south
    // column — see the band proof in the header.
    const eastX = Math.max(fx + fw, colX + W) + $99c34fac68484218$var$GAP_X;
    const westX = Math.min(fx, colX) - $99c34fac68484218$var$GAP_X - W;
    const ringEastX = eastX + W + $99c34fac68484218$var$GAP_X;
    const ringWestX = westX - W - $99c34fac68484218$var$GAP_X;
    // Bucket first, place second. Bucketing in a separate pass is what keeps the
    // per-bucket indices (and therefore the coordinates) independent of how the
    // endpoint happened to interleave relations in its response.
    const buckets = {
        north: [],
        east: [],
        south: [],
        west: [],
        ring: []
    };
    const seen = new Set();
    for (const n of list){
        if (!n) continue;
        const key = $99c34fac68484218$var$_keyOf(n.ref);
        if (!key || taken.has(key) || seen.has(key)) continue;
        seen.add(key);
        const relation = n.relation || 'relates_to';
        const dir = $99c34fac68484218$export$7972266835acba56[relation] || 'ring';
        buckets[dir].push({
            key: key,
            ref: n.ref,
            relation: relation,
            direction: n.direction === 'in' ? 'in' : 'out'
        });
    }
    const northY = (i)=>fy - (i + 1) * (H + $99c34fac68484218$var$GAP_Y);
    const southY = (i)=>fy + fh + $99c34fac68484218$var$GAP_Y + i * (H + $99c34fac68484218$var$GAP_Y);
    const sideY = (i)=>cy - H / 2 + i * (H + $99c34fac68484218$var$GAP_Y);
    const out = [];
    buckets.north.forEach((n, i)=>out.push({
            ...n,
            x: colX,
            y: northY(i),
            w: W,
            h: H
        }));
    buckets.east.forEach((n, i)=>out.push({
            ...n,
            x: eastX,
            y: sideY(i),
            w: W,
            h: H
        }));
    buckets.south.forEach((n, i)=>out.push({
            ...n,
            x: colX,
            y: southY(i),
            w: W,
            h: H
        }));
    buckets.west.forEach((n, i)=>out.push({
            ...n,
            x: westX,
            y: sideY(i),
            w: W,
            h: H
        }));
    // Ring: cycle the four diagonal columns, stepping one row further out each
    // time a quadrant comes round again. `ring` never enters the first east/west
    // column, so a long east column and a long ring cannot collide.
    buckets.ring.forEach((n, i)=>{
        const slot = $99c34fac68484218$var$RING_ORDER[i % $99c34fac68484218$var$RING_ORDER.length];
        const step = Math.floor(i / $99c34fac68484218$var$RING_ORDER.length);
        const x = slot === 'ne' || slot === 'se' ? ringEastX : ringWestX;
        const y = slot === 'ne' || slot === 'nw' ? northY(step) : southY(step);
        out.push({
            ...n,
            x: x,
            y: y,
            w: W,
            h: H
        });
    });
    return out;
};

});

parcelRegister("aChNU", function(module, exports) {

$parcel$export(module.exports, "normalizeCanvasEntity", () => $7bab437d70927a5c$export$edfa7a611b408750);
$parcel$export(module.exports, "getCanvasEntity", () => $7bab437d70927a5c$export$32f7528054800a01);
$parcel$export(module.exports, "patchCanvasEntity", () => $7bab437d70927a5c$export$9018bce3273fb98f);
$parcel$export(module.exports, "resolveCanvasEntity", () => $7bab437d70927a5c$export$f488f946a3fe50d4);
$parcel$export(module.exports, "addCanvasEntityItem", () => $7bab437d70927a5c$export$3c9bb081d41524b7);
$parcel$export(module.exports, "focusCanvasEntity", () => $7bab437d70927a5c$export$5363e13515b34848);
$parcel$export(module.exports, "openCanvasEntity", () => $7bab437d70927a5c$export$feb1d3e190ee51e8);
$parcel$export(module.exports, "fetchCanvasEntityRelations", () => $7bab437d70927a5c$export$b8d20748fde0c502);
$parcel$export(module.exports, "expandCanvasEntity", () => $7bab437d70927a5c$export$d25e13b0ccfbd3a7);
$parcel$export(module.exports, "searchCanvasEntities", () => $7bab437d70927a5c$export$e4e5a0ffc13e2910);
$parcel$export(module.exports, "boardEntityItems", () => $7bab437d70927a5c$export$c038cb326e9ceff9);
$parcel$export(module.exports, "openCanvasEntityComments", () => $7bab437d70927a5c$export$6cefc00564c68015);
$parcel$export(module.exports, "makeCanvasEntityVariation", () => $7bab437d70927a5c$export$8c08bdc768f10fe5);
$parcel$export(module.exports, "openCanvasEntityEditor", () => $7bab437d70927a5c$export$2cb94708dff087a9);
$parcel$export(module.exports, "saveCanvasEntityEdits", () => $7bab437d70927a5c$export$a42058b8f6714c42);
// Entity nodes on the project canvas — the imperative half (spec §3.1–3.6).
//
// An entity node is a canvas item whose KEY is an entity ref string
// (`ref:<type>:<id>` — the shared contract, `el.call('parseEntityRef', …)`,
// `@symbo-ls/workspace-shared/functions/entityRef.js`). Everything else is the
// canvas you already have: the same `canvas.items[key] = { x, y, w, h }`
// geometry, the same board pages, the same selection/drag/marquee chrome, the
// same `connections` array, the same `sdk.updateProject(id, { canvas })`
// persistence. The only new pieces are here:
//
//   resolveCanvasEntity(key)      read the entity behind a ref, cache it
//   getCanvasEntity(key)          synchronous cache read (safe in a prop)
//   expandCanvasEntity(key)       relations → new nodes + connections
//   addCanvasEntityItem(ref, at)  place one node
//   focusCanvasEntity(key)        centre + select (the assistant's source chip)
//   openCanvasEntity(key)         route to the entity's own surface
//   searchCanvasEntities(query)   the picker's data source
//   boardEntityItems()            the sidebar's Items list
//   openCanvasEntityComments(key) the Comments sheet
//   makeCanvasEntityVariation(k)  duplicate a record as a variation
//
// ── NOTHING HERE IS VAULT-SPECIFIC ────────────────────────────────────────
// The package knows about ref TYPES (record/doc/mail/ticket/…) and RELATION
// names, both of which are platform vocabulary. It knows nothing about
// tenants, training records, or any collection name. A module supplies those
// through the record row's own `data` bag and through `boardPage.meta`.
//
// ── SDK ACCESS ────────────────────────────────────────────────────────────
// `el.sdk` (the boot singleton), the canvas's canonical accessor — the same
// one sessionOverlay.js / projectPublish.js / versionHistory.js use. Reads go
// through `sdk.execute(<entity>, <op>, args)`, the EntityDispatcher surface.
// Every read is feature-detected and every failure is caught: a canvas whose
// backend cannot answer must still render its nodes (with an error state on
// the card), never throw out of a lifecycle handler.
//
// ── ROUTES THIS PACKAGE CODES AGAINST BUT DOES NOT OWN ────────────────────
//   sdk.execute('refs', 'relations', { ref, depth })
//        → { ref, neighbors: [{ ref, relation, direction }] }
//   sdk.execute('search', 'workspace', { query, limit })
//        → [{ ref, title, snippet, surface }]
//
// TODO(vaultos-v2, core lane / L1): both routes are ABSENT from the SDK's
// ENTITY_ROUTES table as of 2026-09-07 — `sdk.execute` THROWS SYNCHRONOUSLY
// for an unknown entity, before it returns a promise. Nothing in this file
// needs to change when they land; the ONLY action is to repoint the
// `@symbo.ls/sdk` link so the new route table is the one that loads. Until
// then every call here resolves to an empty result (see _execute) — Expand
// reports "nothing to add", the picker shows its empty state, and the console
// stays clean. `__tests__/entitySdkDegradation.test.js` pins that against all
// three failure shapes (sync throw / rejected promise / `{ error }` envelope)
// and carries a positive control for its own console capture.
const $7bab437d70927a5c$var$_canvasRoot = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || null;
const $7bab437d70927a5c$var$_canvasSdk = (el)=>{
    const sdk = el?.sdk || $7bab437d70927a5c$var$_canvasRoot(el)?.sdk || null;
    return sdk && typeof sdk.execute === 'function' ? sdk : null;
};
// In-flight de-duplication for resolveCanvasEntity. Module-scope mutable
// state, the same shape functions/canvas/state.js already keeps for
// `_persistTimer` / `_chromeRafId` / `previewSizeSeededProjects`: it is a
// per-tab request ledger, never rendered and never persisted, so it must NOT
// live on the reactive store (a store write per in-flight request would
// re-render the board once per node on load).
const $7bab437d70927a5c$var$_inflight = new Map();
// Unwrap a RESPONSE ENVELOPE — and only an envelope.
//
// ⚠ `hasOwnProperty('data')` is NOT the test. A workspace RECORD row owns its
// own `data` bag right next to `id` / `collection` / `name`, so unwrapping on
// the mere presence of the key hands every caller the record's payload with
// the row — and therefore the ROW ID — stripped off. Measured live on dev
// 2026-09-07: `sdk.execute('workspaceProject.records', 'create', …)` answered
// 201 with `{ id, collection, name, data, … }`, the old unwrap returned the
// `data` bag, `created.id` read `undefined`, and `makeCanvasEntityVariation`
// returned null — after the server had already written the row. The user saw
// nothing happen and every retry minted another orphan record.
//
// An envelope is recognised by what it does NOT carry: either an explicit
// `success` flag, or nothing outside the envelope vocabulary. A row always
// carries at least one key from its own domain, so the two can never be
// confused in either direction.
const $7bab437d70927a5c$var$_ENVELOPE_KEYS = [
    'data',
    'success',
    'error',
    'count',
    'total',
    'page',
    'pageSize',
    'limit',
    'offset',
    'meta',
    'nextCursor'
];
const $7bab437d70927a5c$var$_unwrap = (res)=>{
    if (!res || typeof res !== 'object' || Array.isArray(res)) return res;
    if (!Object.prototype.hasOwnProperty.call(res, 'data')) return res;
    if (Object.prototype.hasOwnProperty.call(res, 'success')) return res.data;
    return Object.keys(res).every((k)=>$7bab437d70927a5c$var$_ENVELOPE_KEYS.indexOf(k) !== -1) ? res.data : res;
};
// One guarded `sdk.execute`. Returns null for "this route does not exist yet"
// AND for "the call failed" — both mean the same thing to every caller here:
// render the empty/error state, never throw.
const $7bab437d70927a5c$var$_execute = async (sdk, entity, op, args)=>{
    if (!sdk) return null;
    try {
        const res = await sdk.execute(entity, op, args);
        if (res && res.error) return null;
        return $7bab437d70927a5c$var$_unwrap(res);
    } catch (_) {
        return null;
    }
};
// Pick the first non-empty string among candidates. Used to fold the many
// title-ish field names the four entity surfaces use (name / title / subject)
// into one card field without a per-type branch at every read site.
const $7bab437d70927a5c$var$_first = (...vals)=>{
    for (const v of vals){
        if (typeof v === 'string' && v.trim()) return v.trim();
        if (typeof v === 'number') return String(v);
    }
    return '';
};
// Clamp a summary to something a 3-line card can hold without the layout
// deciding for us. 240 chars ≈ 3 lines at the card's width; the card still
// clamps visually with -webkit-line-clamp, this only stops a 40 KB document
// body travelling into the AI attachment payload (spec §3.8 caps).
const $7bab437d70927a5c$var$_clip = (text, max)=>{
    const s = String(text || '').replace(/\s+/g, ' ').trim();
    return s.length > max ? s.slice(0, max - 1) + "\u2026" : s;
};
const $7bab437d70927a5c$export$edfa7a611b408750 = (ref, row)=>{
    const r = row || {};
    const data = (r.data && typeof r.data === 'object' ? r.data : r) || {};
    const title = $7bab437d70927a5c$var$_first(data.title, r.title, r.name, r.subject, data.name, data.subject, ref && ref.title, ref && ref.id);
    return {
        type: ref && ref.type || '',
        id: ref && ref.id || '',
        title: title,
        // `kind` is the record's own classification when it has one; otherwise the
        // ref TYPE, which is a code identifier and stays untranslated (glossary
        // rule 5) rather than being routed through polyglot as UI copy.
        kind: $7bab437d70927a5c$var$_first(data.kind, r.kind, ref && ref.kind, ref && ref.type),
        status: $7bab437d70927a5c$var$_first(data.status, r.status, r.state),
        effectiveDate: $7bab437d70927a5c$var$_first(data.effectiveDate, r.effectiveDate, data.date, r.date),
        // A record ref is SELF-DESCRIBING: its id is '<collectionKey>/<recordId>',
        // so the collection is derivable from the ref alone. The shared
        // `parseEntityRef` does not split it out (it is a canvas-side reading of
        // a record id, not part of the ref grammar), so the split happens here —
        // which also keeps the meta row correct when the row read FAILED and
        // there is no `r.collection` to fall back on.
        collection: $7bab437d70927a5c$var$_first(r.collection, ref && ref.collection, ref && ref.type === 'record' && String(ref.id || '').indexOf('/') > 0 ? String(ref.id).slice(0, String(ref.id).indexOf('/')) : '', data.tenantId, r.folder),
        summary: $7bab437d70927a5c$var$_clip($7bab437d70927a5c$var$_first(data.summary, r.summary, data.snippet, r.snippet, data.body, r.body, r.preview), 240),
        sample: !!(data.sample || r.sample),
        authority: typeof data.authority === 'number' ? data.authority : null,
        data: data
    };
};
// Read ONE entity from whichever service owns its type. Returns the raw row or
// null. Split out of resolveCanvasEntity so the per-type routing is readable
// and testable on its own.
const $7bab437d70927a5c$var$_readEntity = async (sdk, ref)=>{
    if (!sdk || !ref) return null;
    if (ref.type === 'record') {
        // `<collectionKey>/<recordId>` — the collection is part of the ref so the
        // node is self-describing, but the records `get` route keys on the row id
        // alone (EntityDispatcher `workspaceProject.records` → `records.get`).
        const slash = ref.id.indexOf('/');
        const id = slash > 0 ? ref.id.slice(slash + 1) : ref.id;
        const collection = slash > 0 ? ref.id.slice(0, slash) : undefined;
        const row = await $7bab437d70927a5c$var$_execute(sdk, 'workspaceProject.records', 'get', {
            id: id
        });
        return row && collection && !row.collection ? {
            ...row,
            collection: collection
        } : row;
    }
    if (ref.type === 'doc') return $7bab437d70927a5c$var$_execute(sdk, 'docs', 'get', {
        id: ref.id
    });
    if (ref.type === 'ticket') return $7bab437d70927a5c$var$_execute(sdk, 'tickets', 'get', {
        id: ref.id
    });
    if (ref.type === 'mail') {
        // The mail service is not on the EntityDispatcher yet. Feature-detect both
        // shapes rather than assuming either: a bare service method (`sdk.mail
        // .thread`) or a dispatcher route. A miss is not an error — the card falls
        // back to the ref's own title.
        const threadId = ref.id.split('#')[0];
        if (sdk.mail && typeof sdk.mail.thread === 'function') try {
            const res = await sdk.mail.thread(threadId);
            return res && res.data || res || null;
        } catch (_) {
            return null;
        }
        return $7bab437d70927a5c$var$_execute(sdk, 'mail.threads', 'get', {
            id: threadId
        });
    }
    return null;
};
function $7bab437d70927a5c$export$32f7528054800a01(key) {
    const v2 = this.call('getCanvasV2');
    return v2 && v2.entities && v2.entities[key] || null;
}
function $7bab437d70927a5c$export$9018bce3273fb98f(key, patch) {
    const v2 = this.call('getCanvasV2');
    if (!v2 || !key) return null;
    const prev = v2.entities && v2.entities[key] || {};
    const next = {
        ...prev,
        ...patch
    };
    this.call('patchCanvas', {
        entities: {
            ...v2.entities || {},
            [key]: next
        }
    }, {
        preventUpdate: true
    });
    return next;
}
async function $7bab437d70927a5c$export$f488f946a3fe50d4(key) {
    const el = this;
    const ref = el.call('parseEntityRef', key);
    if (!ref) return {
        loading: false,
        data: null,
        error: 'ref'
    };
    const cached = el.call('getCanvasEntity', key);
    if (cached && !cached.loading && (cached.data || cached.error)) return cached;
    const pending = $7bab437d70927a5c$var$_inflight.get(key);
    if (pending) return pending;
    const run = (async ()=>{
        el.call('patchCanvasEntity', key, {
            loading: true,
            error: null
        });
        const sdk = $7bab437d70927a5c$var$_canvasSdk(el);
        const row = await $7bab437d70927a5c$var$_readEntity(sdk, ref);
        // A ref we cannot read is still a node: it renders with the id as its
        // title and an error flag, so the board never shows a blank card.
        const entry = row ? {
            loading: false,
            data: $7bab437d70927a5c$export$edfa7a611b408750(ref, row),
            error: null
        } : {
            loading: false,
            data: $7bab437d70927a5c$export$edfa7a611b408750(ref, null),
            error: 'unresolved'
        };
        el.call('patchCanvasEntity', key, entry);
        $7bab437d70927a5c$var$_inflight.delete(key);
        return entry;
    })();
    $7bab437d70927a5c$var$_inflight.set(key, run);
    return run;
}
function $7bab437d70927a5c$export$3c9bb081d41524b7(refOrKey, at) {
    const key = this.call('formatEntityRef', refOrKey);
    if (!key) return null;
    const v2 = this.call('getCanvasV2');
    if (!v2) return null;
    if (v2.items && v2.items[key]) {
        this.call('focusCanvasEntity', key);
        return key;
    }
    const W = 280;
    const H = 160;
    let point = at;
    if (!point || typeof point.x !== 'number') {
        const surf = this.getRoot?.()?.lookdown?.('CanvasSurface');
        const rect = surf?.node?.getBoundingClientRect?.();
        point = rect ? this.call('screenToCanvas', rect.width / 2, rect.height / 2) : {
            x: v2.viewport?.x || 0,
            y: v2.viewport?.y || 0
        };
    }
    const items = {
        ...v2.items || {},
        [key]: {
            x: Math.round(point.x - W / 2),
            y: Math.round(point.y - H / 2),
            w: W,
            h: H
        }
    };
    this.call('patchCanvas', {
        items: items
    });
    this.call('selectOne', key);
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
    this.call('resolveCanvasEntity', key);
    return key;
}
function $7bab437d70927a5c$export$5363e13515b34848(key) {
    const v2 = this.call('getCanvasV2');
    const item = v2 && v2.items && v2.items[key];
    if (!item) return false;
    this.call('selectOne', key);
    const surf = this.getRoot?.()?.lookdown?.('CanvasSurface');
    const rect = surf?.node?.getBoundingClientRect?.();
    const scale = v2.viewport && v2.viewport.scale != null ? v2.viewport.scale : null;
    if (rect && scale) this.call('applyViewport', {
        x: rect.width / 2 - (item.x + item.w / 2) * scale,
        y: rect.height / 2 - (item.y + item.h / 2) * scale,
        scale: scale
    });
    else this.call('fitToSelection');
    this.call('refreshCanvasChrome');
    return true;
}
function $7bab437d70927a5c$export$feb1d3e190ee51e8(key) {
    const ref = this.call('parseEntityRef', key);
    if (!ref) return false;
    // A module stamps its own route on the ROW (`data.href`); that beats any
    // per-type default this package could invent — see entityRefHref.
    const entry = this.call('getCanvasEntity', key);
    const rowHref = entry && entry.data && entry.data.data && entry.data.data.href;
    const href = this.call('entityRefHref', rowHref ? {
        ...ref,
        meta: {
            href: rowHref
        }
    } : ref);
    if (!href) return false;
    this.router(href, this.getRoot());
    return true;
}
async function $7bab437d70927a5c$export$b8d20748fde0c502(key, opts) {
    const sdk = $7bab437d70927a5c$var$_canvasSdk(this);
    const res = await $7bab437d70927a5c$var$_execute(sdk, 'refs', 'relations', {
        ref: key,
        depth: opts && opts.depth || 1
    });
    const neighbors = res && Array.isArray(res.neighbors) && res.neighbors || [];
    return {
        ref: key,
        neighbors: neighbors
    };
}
async function $7bab437d70927a5c$export$d25e13b0ccfbd3a7(key, opts) {
    const v2 = this.call('getCanvasV2');
    const focus = v2 && v2.items && v2.items[key];
    if (!focus) return {
        added: 0,
        linked: 0
    };
    const { neighbors: neighbors } = await this.call('fetchCanvasEntityRelations', key, opts);
    if (!neighbors.length) return {
        added: 0,
        linked: 0
    };
    const live = this.call('getCanvasV2') || v2;
    const placed = this.call('layoutEntityFan', focus, neighbors, {
        taken: live.items || {}
    });
    const items = {
        ...live.items || {}
    };
    for (const p of placed)items[p.key] = {
        x: p.x,
        y: p.y,
        w: p.w,
        h: p.h
    };
    const connections = [
        ...live.connections || []
    ];
    let linked = 0;
    for (const n of neighbors){
        const nk = this.call('formatEntityRef', n && n.ref);
        if (!nk || nk === key || !items[nk]) continue;
        const relation = n && n.relation || 'relates_to';
        const from = n && n.direction === 'in' ? nk : key;
        const to = n && n.direction === 'in' ? key : nk;
        if (connections.some((c)=>c.from === from && c.to === to && c.label === relation)) continue;
        connections.push({
            from: from,
            to: to,
            label: relation,
            kind: relation
        });
        linked++;
    }
    this.call('patchCanvas', {
        items: items,
        connections: connections
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
    for (const p of placed)this.call('resolveCanvasEntity', p.key);
    return {
        added: placed.length,
        linked: linked
    };
}
async function $7bab437d70927a5c$export$e4e5a0ffc13e2910(query) {
    const q = String(query || '').trim();
    if (!q) return [];
    const sdk = $7bab437d70927a5c$var$_canvasSdk(this);
    const res = await $7bab437d70927a5c$var$_execute(sdk, 'search', 'workspace', {
        query: q,
        limit: 20
    });
    const rows = Array.isArray(res) ? res : res && Array.isArray(res.results) && res.results || [];
    const out = [];
    for (const row of rows){
        const key = this.call('formatEntityRef', row && row.ref);
        if (!key) continue;
        out.push({
            key: key,
            ref: row.ref,
            title: $7bab437d70927a5c$var$_first(row.title, key),
            snippet: $7bab437d70927a5c$var$_clip(row.snippet, 160),
            surface: row.surface || ''
        });
    }
    return out;
}
function $7bab437d70927a5c$export$c038cb326e9ceff9() {
    const v2 = this.call('getCanvasV2');
    const items = v2 && v2.items || {};
    const rows = [];
    for (const key of Object.keys(items)){
        if (!this.call('isEntityRef', key)) continue;
        const it = items[key] || {};
        const entry = this.call('getCanvasEntity', key);
        const ref = this.call('parseEntityRef', key);
        rows.push({
            id: key,
            key: key,
            x: Number(it.x) || 0,
            y: Number(it.y) || 0,
            title: entry && entry.data && entry.data.title || ref && ref.id || key,
            icon: this.call('entityRefIcon', key)
        });
    }
    rows.sort((a, b)=>a.y - b.y || a.x - b.x || (a.key < b.key ? -1 : 1));
    return rows;
}
// Open a transient page def in the primary PageSlot pane.
//
// The `root._aiAnswerPages` registry is PageSlot's documented escape hatch for
// a def that exists only for this session (components/PageSlot.js `_defFor`
// resolution order, step 1) — the same mechanism functions/answerUi.js uses.
// Reusing it is what lets an entity sheet be a real slot (back/forward,
// minimise, split) instead of a bespoke overlay.
const $7bab437d70927a5c$var$_openEntitySheet = (el, route, title, def)=>{
    const root = $7bab437d70927a5c$var$_canvasRoot(el);
    if (!root || typeof root.update !== 'function') return false;
    const entries = Object.entries(root._aiAnswerPages || {}).slice(-11);
    entries.push([
        route,
        {
            ...def,
            metadata: {
                ...def.metadata || {},
                title: title
            }
        }
    ]);
    root.update({
        _aiAnswerPages: Object.fromEntries(entries),
        _canvasSlot: route,
        _slotFullscreen: null
    }, {
        preventFetch: true
    });
    return true;
};
// A route is an opaque slot id — the ref is encoded so two different entities
// never collide on one sheet, and re-opening the same entity reuses its route.
const $7bab437d70927a5c$var$_sheetRoute = (prefix, key)=>prefix + encodeURIComponent(key);
function $7bab437d70927a5c$export$6cefc00564c68015(key) {
    const ref = this.call('parseEntityRef', key);
    if (!ref) return false;
    const entry = this.call('getCanvasEntity', key);
    const title = entry && entry.data && entry.data.title || ref.id;
    return $7bab437d70927a5c$var$_openEntitySheet(this, $7bab437d70927a5c$var$_sheetRoute('/entity-comments/', key), title, {
        flow: 'y',
        gap: 'A',
        padding: 'B',
        Heading: {
            tag: 'h2',
            fontSize: 'B',
            color: 'title',
            text: title
        },
        CommentThread: {
            entityRef: ref,
            flex: '1',
            minHeight: '0'
        }
    });
}
async function $7bab437d70927a5c$export$8c08bdc768f10fe5(key) {
    const ref = this.call('parseEntityRef', key);
    if (!ref || ref.type !== 'record') return null;
    const v2 = this.call('getCanvasV2');
    const focus = v2 && v2.items && v2.items[key];
    if (!focus) return null;
    const sdk = $7bab437d70927a5c$var$_canvasSdk(this);
    if (!sdk) return null;
    const entry = await this.call('resolveCanvasEntity', key) || {};
    const source = entry.data || {};
    const slash = ref.id.indexOf('/');
    const collection = slash > 0 ? ref.id.slice(0, slash) : ref.collection || '';
    const title = this.call('polyglot', 'canvas.entity.variation.title').replace('{title}', source.title || ref.id);
    const created = await $7bab437d70927a5c$var$_execute(sdk, 'workspaceProject.records', 'create', {
        collection: collection,
        name: title,
        data: {
            ...source.data || {},
            title: title,
            variationOf: key,
            rationale: ''
        }
    });
    const newId = created && (created._id || created.id);
    if (!newId) return null;
    const newKey = this.call('formatEntityRef', {
        type: 'record',
        id: collection ? collection + '/' + newId : String(newId)
    });
    if (!newKey) return null;
    const live = this.call('getCanvasV2') || v2;
    const items = {
        ...live.items || {},
        [newKey]: {
            x: focus.x + focus.w + 120,
            y: focus.y,
            w: 280,
            h: 160
        }
    };
    // The relation NAME is both the edge's `kind` and its rendered label, and it
    // is never translated: it is platform vocabulary (spec §2), the same
    // identifier the relations endpoint returns for every OTHER edge on the
    // board. Translating the one edge this package mints locally would make it
    // read differently from its identical server-supplied neighbours. Named once
    // here for the same reason expandCanvasEntity names its own `relation`.
    const relation = 'variation_of';
    const connections = [
        ...live.connections || [],
        {
            from: newKey,
            to: key,
            label: relation,
            kind: relation
        }
    ];
    this.call('patchCanvas', {
        items: items,
        connections: connections
    });
    this.call('refreshCanvasChrome');
    this.call('persistCanvasLayout');
    await this.call('resolveCanvasEntity', newKey);
    this.call('openCanvasEntityEditor', newKey);
    return newKey;
}
function $7bab437d70927a5c$export$2cb94708dff087a9(key) {
    const ref = this.call('parseEntityRef', key);
    if (!ref) return false;
    const entry = this.call('getCanvasEntity', key);
    const cur = entry && entry.data || {};
    const heading = cur.title || ref.id;
    // `labelTemplate` is the FULL polyglot template, never a key concatenated
    // into one: `text:` needs the TEMPLATE form (docs/I18N-CONVENTION.md §1) and
    // a key assembled with `+` is invisible to the extraction audit.
    const field = (labelTemplate, stateKey, tag)=>({
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'span',
                fontSize: 'Z',
                color: 'caption',
                text: labelTemplate
            },
            Input: {
                tag: tag || 'input',
                type: tag ? null : 'text',
                width: '100%',
                minHeight: tag ? 'E' : null,
                padding: 'Z A',
                fontSize: 'Z1',
                color: 'title',
                background: 'overlayStrong',
                borderWidth: '0',
                round: 'radiusControl',
                value: (el, s)=>s.form && s.form[stateKey] || '',
                onInput: (e, el, s)=>s.update({
                        form: {
                            ...s.form || {},
                            [stateKey]: el.node.value
                        }
                    })
            }
        });
    return $7bab437d70927a5c$var$_openEntitySheet(this, $7bab437d70927a5c$var$_sheetRoute('/entity-editor/', key), heading, {
        state: {
            entityKey: key,
            form: {
                title: cur.title || '',
                body: cur.data && cur.data.body || '',
                rationale: cur.data && cur.data.rationale || ''
            }
        },
        flow: 'y',
        gap: 'A',
        padding: 'B',
        Title: field('{{ canvas.entity.variation.titleLabel | polyglot }}', 'title'),
        Rationale: field('{{ canvas.entity.variation.rationaleLabel | polyglot }}', 'rationale'),
        Body: field('{{ canvas.entity.variation.bodyLabel | polyglot }}', 'body', 'textarea'),
        SaveBtn: {
            extends: 'Button',
            theme: 'primary',
            type: 'button',
            margin: 'V 0 0',
            text: '{{ common.action.save | polyglot }}',
            onClick: (e, el, s)=>{
                e.preventDefault();
                el.call('saveCanvasEntityEdits', s.entityKey, s.form);
            }
        }
    });
}
async function $7bab437d70927a5c$export$a42058b8f6714c42(key, form) {
    const ref = this.call('parseEntityRef', key);
    if (!ref || ref.type !== 'record') return false;
    const sdk = $7bab437d70927a5c$var$_canvasSdk(this);
    if (!sdk) return false;
    const slash = ref.id.indexOf('/');
    const id = slash > 0 ? ref.id.slice(slash + 1) : ref.id;
    const entry = this.call('getCanvasEntity', key);
    const prev = entry && entry.data && entry.data.data || {};
    const patch = form || {};
    const res = await $7bab437d70927a5c$var$_execute(sdk, 'workspaceProject.records', 'update', {
        id: id,
        name: patch.title || entry && entry.data && entry.data.title || '',
        data: {
            ...prev,
            title: patch.title,
            body: patch.body,
            rationale: patch.rationale
        }
    });
    if (!res) return false;
    this.call('patchCanvasEntity', key, {
        loading: false,
        error: null,
        data: null
    });
    await this.call('resolveCanvasEntity', key);
    return true;
}

});

parcelRegister("gYZyC", function(module, exports) {

$parcel$export(module.exports, "parseVoiceCommand", () => $c5d1ffed9a852021$export$c5498d413f5b63b5);
$parcel$export(module.exports, "voiceProjectCommand", () => $c5d1ffed9a852021$export$40378f447bed163d);
// Canvas voice-command routing — the project layer behind the shared voice
// session (shared/functions/voiceSession.js → el.call('voiceProjectCommand',
// transcript) in command mode; architecture/VOICE_COMMANDS.md).
//
// Two stages:
//   1. parseVoiceCommand(text) — pure grammar (unit-tested in
//      voiceCommands.test.js) mapping utterances to canvas intents.
//   2. voiceProjectCommand(text) — executes an intent against the REGISTERED
//      canvas functions (applyViewport / fitToSelection / undo / addBoardPage
//      / toggle* …), guarding each target so surfaces without it (shell
//      routes off-canvas, pre-board-pages builds) fall through gracefully.
//      Unmatched speech goes to the freestyle build pipeline when the local
//      `smbls claude` bridge is connected; otherwise `{ handled: false }`
//      lets the caller hand it to the assistant thread.
const $c5d1ffed9a852021$var$_canvasNorm = (text)=>(text || '').toLowerCase().replace(/[.,!?;:'"]+/g, ' ').replace(/\s+/g, ' ').trim();
const $c5d1ffed9a852021$var$_title = (s)=>s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
const $c5d1ffed9a852021$export$c5498d413f5b63b5 = (text)=>{
    const t = $c5d1ffed9a852021$var$_canvasNorm(text);
    if (!t) return null;
    // view — fit / reset / zoom
    if (/\b(fit (the )?(canvas|view|screen|board|selection|everything|all)|zoom to fit|fit to (view|screen))\b/.test(t)) return {
        intent: 'fit'
    };
    if (/\b(reset (the )?(zoom|view|canvas)|zoom (to )?(100( percent| %)?|a hundred( percent)?)|actual size)\b/.test(t)) return {
        intent: 'resetView'
    };
    {
        const m = t.match(/^zoom( in| out| closer| further| away| back)?$/);
        if (m) return {
            intent: 'zoom',
            dir: / out| further| away| back/.test(m[1] || '') ? -1 : 1
        };
    }
    // history
    if (/^undo( that| last( change)?| it)?$/.test(t)) return {
        intent: 'undo'
    };
    if (/^redo( that| it)?$/.test(t)) return {
        intent: 'redo'
    };
    // board pages
    {
        const m = t.match(/^(?:create|add|make|start) (?:a |another |new )*page(?: (?:called|named|titled) (.+))?$/);
        if (m) return {
            intent: 'addPage',
            name: m[1] ? $c5d1ffed9a852021$var$_title(m[1]) : ''
        };
    }
    {
        const m = t.match(/^(?:open|go to|switch to|show) (?:the )?page (.+)$/) || t.match(/^(?:open|go to|switch to) (?:the )?(.+) page$/);
        if (m) return {
            intent: 'openPage',
            name: m[1]
        };
    }
    // panels + chrome
    if (/^(open|show|toggle|close|hide) (the )?design system( panel)?$/.test(t)) return {
        intent: 'toggleDesignSystem'
    };
    if (/^(open|show|toggle|close|hide) (the )?components?( panel)?$/.test(t)) return {
        intent: 'toggleComponents'
    };
    if (/^(open|show|toggle|close|hide) (the )?side ?bars?$/.test(t)) return {
        intent: 'toggleSidebars'
    };
    if (/^(open|show|toggle|close|hide) (the )?(canvas )?settings$/.test(t)) return {
        intent: 'toggleSettings'
    };
    if (/^(open|show|toggle|close|hide) (the )?(keyboard )?shortcuts$/.test(t)) return {
        intent: 'toggleShortcuts'
    };
    // theme — anchored so a build prompt merely MENTIONING "dark mode" never
    // hijacks ("make the hero background blue in dark mode" → freestyle).
    {
        const m = t.match(/^(?:(?:switch|change|set|turn|go|please|enable|use|make it)\s+)*(?:it\s+)?(?:on\s+|to\s+|into\s+)?(?:the\s+)?(dark|light)\s+(?:mode|theme)$/);
        if (m) return {
            intent: 'theme',
            value: m[1]
        };
    }
    if (/^toggle (the )?theme$/.test(t)) return {
        intent: 'theme',
        value: 'toggle'
    };
    // selection
    if (/^(clear|deselect)( the| all)?( selection)?$|^deselect everything$/.test(t)) return {
        intent: 'clearSelection'
    };
    if (/^delete (the )?(selection|selected( items?| tiles?)?)$/.test(t)) return {
        intent: 'deleteSelection'
    };
    if (/^duplicate (the )?(selection|selected( items?| tiles?)?|this)$/.test(t)) return {
        intent: 'duplicateSelection'
    };
    return null;
};
function $c5d1ffed9a852021$export$40378f447bed163d(text) {
    const fns = this.context && this.context.functions || {};
    const root = this.state && (this.state.root || this.state);
    const cmd = $c5d1ffed9a852021$export$c5498d413f5b63b5(text);
    if (!cmd) {
        // Free-form speech — a build/edit instruction for the canvas agent when
        // the local bridge is live; otherwise let the shared layer hand it to
        // the assistant thread.
        if (fns.freestyleSend && root && root.freestyleStatus === 'connected') {
            this.call('freestyleSend', text);
            return {
                handled: true,
                awaiting: 'freestyle'
            };
        }
        return {
            handled: false
        };
    }
    const methods = this.context && this.context.methods || {};
    switch(cmd.intent){
        case 'zoom':
            // House v2-aware zoom steppers (canvas/methods/index.js) — never
            // reimplement the viewport math here.
            if (!methods.zoomIn || !methods.zoomOut) return {
                handled: false
            };
            this.call(cmd.dir > 0 ? 'zoomIn' : 'zoomOut');
            return {
                handled: true,
                label: this.call('polyglot', cmd.dir > 0 ? 'canvas.voice.zoomedIn' : 'canvas.voice.zoomedOut')
            };
        case 'fit':
            if (!fns.fitToSelection) return {
                handled: false
            };
            this.call('fitToSelection');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.fitToView')
            };
        case 'resetView':
            if (methods.zoomReset) this.call('zoomReset');
            else if (fns.resetCanvasView) this.call('resetCanvasView');
            else return {
                handled: false
            };
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.viewReset')
            };
        case 'undo':
            if (!fns.undo) return {
                handled: false
            };
            this.call('undo');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.undone')
            };
        case 'redo':
            if (!fns.redo) return {
                handled: false
            };
            this.call('redo');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.redone')
            };
        case 'addPage':
            if (!fns.addBoardPage) return {
                handled: false
            };
            this.call('addBoardPage', cmd.name || undefined);
            return {
                handled: true,
                label: cmd.name ? this.call('polyglot', 'canvas.voice.addedPageNamed').replace('{name}', cmd.name) : this.call('polyglot', 'canvas.voice.addedPage')
            };
        case 'openPage':
            {
                if (!fns.getCanvasV2 || !fns.switchBoardPage) return {
                    handled: false
                };
                const v2 = this.call('getCanvasV2');
                const pages = v2 && v2.pages || [];
                const want = $c5d1ffed9a852021$var$_canvasNorm(cmd.name);
                const page = pages.find((p)=>$c5d1ffed9a852021$var$_canvasNorm(p.name) === want) || pages.find((p)=>$c5d1ffed9a852021$var$_canvasNorm(p.name).includes(want));
                if (!page) return {
                    handled: true,
                    label: this.call('polyglot', 'canvas.voice.noPageCalled').replace('{name}', cmd.name)
                };
                this.call('switchBoardPage', page.id);
                return {
                    handled: true,
                    label: this.call('polyglot', 'canvas.voice.opened').replace('{name}', page.name)
                };
            }
        case 'toggleDesignSystem':
            if (!fns.toggleCanvasDesignSystem) return {
                handled: false
            };
            this.call('toggleCanvasDesignSystem');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.designSystem')
            };
        case 'toggleComponents':
            if (!fns.toggleCanvasComponents) return {
                handled: false
            };
            this.call('toggleCanvasComponents');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.components')
            };
        case 'toggleSidebars':
            if (!fns.toggleSidebars) return {
                handled: false
            };
            this.call('toggleSidebars');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.sidebars')
            };
        case 'toggleSettings':
            if (!fns.toggleCanvasSettings) return {
                handled: false
            };
            this.call('toggleCanvasSettings');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.canvasSettings')
            };
        case 'toggleShortcuts':
            if (!fns.toggleShortcutsOverlay) return {
                handled: false
            };
            this.call('toggleShortcutsOverlay');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.shortcuts')
            };
        case 'theme':
            {
                const current = this.context && this.context.globalTheme || 'dark';
                const value = cmd.value === 'toggle' ? current === 'dark' ? 'light' : 'dark' : cmd.value;
                if (value === current) return {
                    handled: true,
                    label: this.call('polyglot', 'canvas.voice.alreadyMode').replace('{mode}', this.call('polyglot', current === 'dark' ? 'canvas.voice.darkMode' : 'canvas.voice.lightMode'))
                };
                // Canvas toggleTheme also syncs the board background; changeGlobalTheme
                // (shell) is the fallback off-canvas.
                if (methods.toggleTheme) this.call('toggleTheme');
                else if (fns.changeGlobalTheme) this.call('changeGlobalTheme', value);
                else return {
                    handled: false
                };
                return {
                    handled: true,
                    label: this.call('polyglot', value === 'dark' ? 'canvas.voice.darkMode' : 'canvas.voice.lightMode')
                };
            }
        case 'clearSelection':
            if (!fns.clearSelection) return {
                handled: false
            };
            this.call('clearSelection');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.selectionCleared')
            };
        case 'deleteSelection':
            if (!fns.deleteSelection) return {
                handled: false
            };
            this.call('deleteSelection');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.deleted')
            };
        case 'duplicateSelection':
            if (!fns.duplicateSelection) return {
                handled: false
            };
            this.call('duplicateSelection');
            return {
                handled: true,
                label: this.call('polyglot', 'canvas.voice.duplicated')
            };
        default:
            return {
                handled: false
            };
    }
}

});

parcelRegister("d2hlu", function(module, exports) {

$parcel$export(module.exports, "canvasAiViews", () => $97d8eabf47939ce7$export$6cc193efc7b36758);
$parcel$export(module.exports, "canvasAnswerProjects", () => $97d8eabf47939ce7$export$a27acb35c1b7e66d);
$parcel$export(module.exports, "canvasAnswerRead", () => $97d8eabf47939ce7$export$2562f9027109c90c);
$parcel$export(module.exports, "canvasAnswerSites", () => $97d8eabf47939ce7$export$13bb4e0f6e6c055c);
$parcel$export(module.exports, "canvasAnswerInstalled", () => $97d8eabf47939ce7$export$d487e3943aa9a2eb);
$parcel$export(module.exports, "canvasAnswerOnScreen", () => $97d8eabf47939ce7$export$fc989014dfb16e14);
$parcel$export(module.exports, "canvasAnswerPickSite", () => $97d8eabf47939ce7$export$8eced70b80b3043c);
$parcel$export(module.exports, "canvasAnswerStoreApps", () => $97d8eabf47939ce7$export$c2f221de4ee6f946);
$parcel$export(module.exports, "canvasAnswerNamed", () => $97d8eabf47939ce7$export$8ccefd996ac6000f);
$parcel$export(module.exports, "canvasAnswerNamedRead", () => $97d8eabf47939ce7$export$5ddf55ba4b8ec02c);
$parcel$export(module.exports, "canvasAnswerNamedMoved", () => $97d8eabf47939ce7$export$86d0f9d502dea1c7);
$parcel$export(module.exports, "canvasAnswerStoreLink", () => $97d8eabf47939ce7$export$65878d5b77d30c58);
$parcel$export(module.exports, "canvasAnswerProjectParam", () => $97d8eabf47939ce7$export$1259e59bd10a9d67);
$parcel$export(module.exports, "canvasAnswerLoad", () => $97d8eabf47939ce7$export$7cb75d3a65faa1e7);
$parcel$export(module.exports, "canvasAnswerMatchCount", () => $97d8eabf47939ce7$export$f3a587c8d53b3790);
$parcel$export(module.exports, "canvasAnswerMoreText", () => $97d8eabf47939ce7$export$b8685e068fcbcde7);
$parcel$export(module.exports, "canvasAnswerCards", () => $97d8eabf47939ce7$export$149ac6f7f591af70);
$parcel$export(module.exports, "canvasAnswerOpen", () => $97d8eabf47939ce7$export$393b510607c37de8);
// THE WORKSPACE'S PROJECTS IN AN AI ANSWER — the `canvas-projects` and
// `project-status` views the assistant mounts in its thread and a Fly page
// places as sections (workspace functions/assistantAppViews.js, the `views[]`
// contract).
//
// canvasAiViews() is the view PROVIDER. Unlike calendar / tickets it needs no
// fold: its components (components/CanvasProjectsView.js, ProjectStatusView.js)
// ride the canvas EAGER slice with these functions, so `fold` is null and the
// card mounts them at once.
//
//   canvas-projects   the workspace's WEBSITES (the app split, docs/APP_SPLIT.md:
//                     never a workspace app, never a library), newest
//                     first; `search` matches the name or key, `env` is the
//                     environment a card's live preview opens. A card opens
//                     that project's LIVE PREVIEW in the sheet (⌘ / Ctrl: in a
//                     split); its row of actions opens the canvas or the
//                     project's analytics; its Studio button opens the editor.
//   project-status    the websites' state (functions/canvasStatus.js): with no
//                     project named, EVERY website and whether each is live,
//                     never published or off (QA 2026-10-19: "What is the
//                     status of our sites?" showed one site beside a projects
//                     list with no state); with `project`, one site — what
//                     each environment serves, its recent versions. The
//                     projects view carries no state: its describe says
//                     where the state is.
//
// The projects are the home Projects widget's own: the active org's projects
// (`root._projectsForActiveOrg`, read by the home) kept to the active
// workspace — or, when no home read them yet, the same SDK call, whose list
// then lands on that root key for every other reader (one read per org). The
// site views of the preview package read the same list through
// canvasAnswerRead / canvasAnswerSites, and what an asked name means through
// canvasAnswerNamed (their loads: canvasAnswerNamedRead, which reads the App
// Store list once when no exact name matches, and canvasAnswerNamedMoved,
// which decides again when a list lands after the card answered).
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $97d8eabf47939ce7$export$6cc193efc7b36758() {
    const el = this && typeof this.call === 'function' ? this : null;
    const root = el && el.state && el.state.root || null;
    // The site a status names: one of the workspace's websites, as the site
    // views take it (an enum of their names once the list is known).
    let project = {
        type: 'string',
        describe: 'a website (project) name or key; the project on screen, else the newest website'
    };
    if (el && root) try {
        const own = el.call('canvasAnswerProjectParam', root);
        if (own && typeof own === 'object') project = own;
    } catch (_) {
    /* the string form stays */ }
    return {
        app: {
            id: 'system/canvas',
            navbar: [
                {
                    label: 'shell.app.studio',
                    route: '/studio',
                    icon: 'layers'
                }
            ],
            apps: [
                {
                    icon: 'layers'
                }
            ]
        },
        fold: null,
        views: [
            {
                id: 'canvas-projects',
                title: 'canvas.answer.title',
                describe: "The workspace's websites (never its installed apps) as cards, newest first; search = words in the name. A card opens its live preview. State: project-status.",
                component: 'CanvasProjectsView',
                icon: 'layers',
                hue: 'purple',
                size: 'l',
                params: {
                    search: {
                        type: 'string',
                        describe: 'words in the project name or key'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 24,
                        default: 6
                    },
                    env: {
                        type: 'enum',
                        values: [
                            'production',
                            'staging',
                            'development'
                        ],
                        labels: {
                            production: 'canvas.sidebar.env.production',
                            staging: 'canvas.sidebar.env.staging',
                            development: 'canvas.sidebar.env.development'
                        },
                        default: 'production',
                        describe: 'the environment a live preview opens'
                    }
                },
                link: {
                    route: '/studio',
                    query: {}
                }
            },
            {
                id: 'project-status',
                title: 'canvas.status.title',
                describe: "Whether the workspace's websites are live, never published or off: every website, or with project one site's environments and recent versions. Read-only.",
                component: 'ProjectStatusView',
                icon: 'version',
                hue: 'purple',
                size: 'l',
                params: {
                    // Left out: EVERY website (functions/canvasStatus.js).
                    project: {
                        ...project,
                        describe: 'one website of this workspace; leave it out to show every website'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 10,
                        default: 5,
                        describe: 'recent versions shown'
                    }
                },
                link: {
                    route: '/studio',
                    call: 'canvasStatusLink'
                }
            }
        ]
    };
}
function $97d8eabf47939ce7$export$a27acb35c1b7e66d(root, list) {
    const r = root && typeof root === 'object' ? root : {};
    const all = Array.isArray(list) ? list : Array.isArray(r._projectsForActiveOrg) ? r._projectsForActiveOrg : null;
    if (!all) return null;
    const claims = r.jwtClaims || {};
    const ws = r.workspace || {};
    const activeWsId = claims.active_workspace_id || ws.id || ws._id || null;
    if (!activeWsId) return all.filter(Boolean);
    return all.filter((p)=>{
        const w = p && p.workspace;
        const wsId = w && (w.id || w._id) || w;
        return String(wsId) === String(activeWsId);
    });
}
async function $97d8eabf47939ce7$export$2562f9027109c90c(el) {
    const host = el || this;
    const root = host && host.state && host.state.root || {};
    const have = host.call('canvasAnswerProjects', root);
    if (have) return {
        projects: have,
        failed: false
    };
    const claims = root.jwtClaims || {};
    const orgs = claims.orgs || root.orgs || [];
    const orgId = claims.workspace_org_id || Array.isArray(root.orgs) && root.orgs[0] && root.orgs[0].id;
    const org = (Array.isArray(orgs) ? orgs : []).find((o)=>o && o.id === orgId);
    const sdk = host.sdk || host.call('getSDK');
    if (!org || !org.slug || !sdk || typeof sdk.getProjects !== 'function') return {
        projects: [],
        failed: true
    };
    let rootEl = null;
    try {
        rootEl = typeof host.getRoot === 'function' ? host.getRoot() : null;
    } catch (_) {
        rootEl = null;
    }
    const memo = rootEl && rootEl.scope && typeof rootEl.scope === 'object' ? rootEl.scope : null;
    const slot = memo && memo.canvasAnswerReadInFlight;
    let pending = slot && slot.org === org.slug ? slot.promise : null;
    if (!pending) {
        pending = sdk.getProjects({
            owner: org.slug,
            limit: 500
        }).then((res)=>{
            const raw = Array.isArray(res) ? res : res && (res.data || res.items) || [];
            const now = root.jwtClaims || {};
            const stillOrg = (now.workspace_org_id || Array.isArray(root.orgs) && root.orgs[0] && root.orgs[0].id) === orgId;
            if (stillOrg && typeof root.update === 'function' && !root._projectsForActiveOrg) root.update({
                _projectsForActiveOrg: raw
            }, {
                preventFetch: true
            });
            return raw;
        });
        if (memo) {
            memo.canvasAnswerReadInFlight = {
                org: org.slug,
                promise: pending
            };
            const clear = ()=>{
                if (memo.canvasAnswerReadInFlight && memo.canvasAnswerReadInFlight.promise === pending) memo.canvasAnswerReadInFlight = null;
            };
            pending.then(clear, clear);
        }
    }
    try {
        const raw = await pending;
        return {
            projects: host.call('canvasAnswerProjects', root, raw) || [],
            failed: false
        };
    } catch (_) {
        return {
            projects: [],
            failed: true
        };
    }
}
function $97d8eabf47939ce7$export$13bb4e0f6e6c055c(projects, apps) {
    const slugOf = (v)=>{
        if (!v) return '';
        if (typeof v === 'string') return /^[a-f0-9]{24}$/i.test(v) ? '' : v;
        return v.slug || v.key || '';
    };
    const installed = new Set((Array.isArray(apps) ? apps : []).filter(Boolean).map(String));
    // THE APP SPLIT (docs/APP_SPLIT.md): a site view shows WEBSITES only, and
    // the shared projectKind decides — with the workspace's own signals (its
    // installed apps, its AI-built apps, the App Store apps), so an App Store
    // module that is NOT installed here is still never "our website". With no
    // element at hand (a direct call), the installed ids and the library flag
    // are the rule.
    const el = this && typeof this.call === 'function' ? this : null;
    const kindRoot = el && el.state && el.state.root;
    let kindCtx = null;
    if (el && kindRoot) try {
        const own = el.call('projectKindContext', kindRoot) || {};
        kindCtx = {
            installed: [
                ...installed,
                ...own.installed || []
            ],
            extensions: own.extensions || [],
            modules: own.modules || []
        };
    } catch (_) {
        kindCtx = null;
    }
    const at = (x)=>Date.parse(x.updatedAt || x.updated_at || x.createdAt || x.created_at || '') || 0;
    const rows = [];
    for (const p of Array.isArray(projects) ? projects : []){
        if (!p || !p.key) continue;
        if (p.isSharedLibrary === true || p.projectType === 'library') continue;
        const owner = slugOf(p.owner) || slugOf(p.workspace && p.workspace.organization);
        if (installed.has(owner + '/' + String(p.key))) continue;
        if (kindCtx) {
            // An unregistered classifier answers nothing — the row then stays.
            const kind = el.call('projectKind', p, kindCtx);
            if (typeof kind === 'string' && kind !== 'website') continue;
        }
        rows.push({
            key: String(p.key),
            name: typeof p.name === 'string' && p.name.trim() ? p.name.trim() : String(p.key),
            owner: owner,
            id: p._id || p.id || null,
            projectType: p.projectType || null,
            updatedAt: p.updatedAt || p.updated_at || p.createdAt || p.created_at || null,
            at: at(p)
        });
    }
    rows.sort((a, b)=>{
        const wa = a.projectType === 'website' ? 0 : 1;
        const wb = b.projectType === 'website' ? 0 : 1;
        return wa - wb || b.at - a.at;
    });
    return rows.map(({ at: _at, ...row })=>row);
}
function $97d8eabf47939ce7$export$d487e3943aa9a2eb(root) {
    const r = root && typeof root === 'object' ? root : {};
    const ids = [];
    const wp = r.workspaceProject;
    if (wp && wp.id) ids.push(String(wp.id));
    for (const a of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])if (a && a.id) ids.push(String(a.id));
    return ids;
}
function $97d8eabf47939ce7$export$fc989014dfb16e14(root) {
    const r = root && typeof root === 'object' ? root : {};
    const clean = (v)=>typeof v === 'string' && v.trim() ? v.trim() : '';
    const p = r._previewParams;
    if (p && clean(p.owner) && clean(p.key)) return {
        owner: clean(p.owner),
        key: clean(p.key)
    };
    const fns = this && this.context && this.context.functions;
    if (fns && typeof fns.readPageParam === 'function') {
        let owner = '';
        let key = '';
        try {
            owner = clean(this.call('readPageParam', 'owner'));
            key = clean(this.call('readPageParam', 'key'));
        } catch (_) {
            owner = '';
            key = '';
        }
        if (owner && key) return {
            owner: owner,
            key: key
        };
    }
    const path = clean(r.currentPath);
    const d = r.data && typeof r.data === 'object' ? r.data : null;
    const key = d ? clean(d.key) || clean(d.projectKey) : '';
    if (!key || !path || !this || typeof this.call !== 'function') return null;
    let route = null;
    try {
        route = this.call('resolveProjectParams', {
            loc: {
                pathname: path,
                search: '',
                hostname: ''
            }
        });
    } catch (_) {
        route = null;
    }
    const routeKey = route && typeof route === 'object' ? clean(route.key) : '';
    if (!routeKey || routeKey.split('.')[0] !== key.split('.')[0]) return null;
    const slug = (v)=>v && !/^[a-f0-9]{24}$/i.test(v) ? v : '';
    const o = d.owner;
    const own = clean(typeof o === 'string' ? o : o && (o.slug || o.username));
    const owner = slug(clean(route.owner)) || slug(own);
    return owner ? {
        owner: owner,
        key: key
    } : null;
}
function $97d8eabf47939ce7$export$8eced70b80b3043c(sites, query, onScreen, how) {
    const list = (Array.isArray(sites) ? sites : []).filter((x)=>x && x.key);
    const low = (v)=>String(v == null ? '' : v).trim().toLowerCase();
    const q = low(query);
    const names = (x)=>[
            low(x.key),
            low(x.name),
            low(x.label)
        ];
    if (q) {
        if (how !== 'part' && how !== 'span') {
            const exact = list.find((x)=>names(x).includes(q));
            if (exact || how === 'exact') return exact || null;
        }
        const ENDINGS = [
            '',
            "\u10E1",
            "\u10D8\u10E1",
            "\u10D8\u10D7",
            "\u10D0\u10D3",
            "\u10DB\u10D0",
            "\u10DB",
            "\u10E8\u10D8",
            "\u10D6\u10D4",
            "\u10D7\u10D0\u10DC",
            "\u10E1\u10D7\u10D0\u10DC",
            "\u10D3\u10D0\u10DC",
            "\u10D8\u10D3\u10D0\u10DC",
            "\u10DB\u10D3\u10D4",
            "\u10D0\u10DB\u10D3\u10D4",
            "\u10E1\u10D7\u10D5\u10D8\u10E1",
            "\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
            "\u10E1\u10D2\u10D0\u10DC",
            "\u10D8\u10E1\u10D2\u10D0\u10DC",
            "\u10E1\u10D9\u10D4\u10DC",
            "\u10D8\u10E1\u10D9\u10D4\u10DC",
            "\u10D5\u10D8\u10D7",
            "\u10D8\u10D5\u10D8\u10D7",
            "\u10D4\u10D1\u10D8",
            "\u10D4\u10D1\u10E1",
            "\u10D4\u10D1\u10D8\u10E1",
            "\u10D4\u10D1\u10D8\u10D7",
            "\u10D4\u10D1\u10D0\u10D3",
            "\u10D4\u10D1\u10DB\u10D0",
            "\u10D4\u10D1\u10E8\u10D8",
            "\u10D4\u10D1\u10D6\u10D4",
            "\u10D4\u10D1\u10D7\u10D0\u10DC",
            "\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC",
            "\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
            "\u10D4\u10D1\u10D8\u10E1\u10D2\u10D0\u10DC"
        ];
        // Does the word `n` name the word `w`? The same word; or, for a word of
        // Georgian letters only, 3+ letters: `w` = the word or its stem (no final
        // ი / ა, 3+ letters) + one ending of the list.
        const wordNames = (n, w)=>{
            if (n === w) return true;
            const chars = [
                ...n
            ];
            if (chars.length < 3 || !/^[Ⴀ-ჿᲐ-Ჿ]+$/u.test(n)) return false;
            const stems = [
                n
            ];
            const last = chars[chars.length - 1];
            if ((last === "\u10D8" || last === "\u10D0") && chars.length > 3) stems.push(chars.slice(0, -1).join(''));
            return stems.some((b)=>w.startsWith(b) && ENDINGS.includes(w.slice(b.length)));
        };
        // The same word, either way round — ONE test, ONE list (the concierge's
        // pick, 2026-10-31): an asked "სახლის" names "დიდი სახლი" as an asked
        // "სახლი" names "სახლის საიტი".
        const same = (a, b)=>wordNames(a, b) || wordNames(b, a);
        // The words of a text: its runs of letters and digits.
        const words = (v)=>v.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
        // The words of `needle`, in order, inside the words of `hay`: the index
        // of the word of `hay` it starts at, else -1; a needle of under 3 letters
        // never.
        const inside = (needle, hay)=>{
            const nw = words(needle);
            const hw = words(hay);
            if (!nw.length || [
                ...nw.join('')
            ].length < 3) return -1;
            for(let i = 0; i + nw.length <= hw.length; i++){
                if (nw.every((n, k)=>same(n, hw[i + k]))) return i;
            }
            return -1;
        };
        // A row's span: `[from, to)` in the words of the asked text — all of them
        // when the asked text sits inside its key, name or label; that name's
        // words, where they sit, when the name sits inside the asked text — the
        // longest of its names; null when no part matches.
        const asked = words(q).length;
        const spanOf = (x)=>{
            let best = null;
            for (const n of names(x)){
                if (!n) continue;
                const at = inside(n, q);
                const found = [
                    inside(q, n) >= 0 ? [
                        0,
                        asked
                    ] : null,
                    at >= 0 ? [
                        at,
                        at + words(n).length
                    ] : null
                ];
                for (const s of found)if (s && (!best || s[1] - s[0] > best[1] - best[0])) best = s;
            }
            return best;
        };
        // The longest span wins; a tie keeps the list order.
        let best = null;
        let span = null;
        for (const x of list){
            const s = spanOf(x);
            if (s && (!span || s[1] - s[0] > span[1] - span[0])) {
                best = x;
                span = s;
            }
        }
        if (how === 'span') return best ? {
            row: best,
            from: span[0],
            to: span[1]
        } : null;
        return best;
    }
    if (how === 'span') return null;
    const on = onScreen && typeof onScreen === 'object' ? onScreen : null;
    if (on && on.key) {
        const k = String(on.key).split('.')[0];
        const hit = list.find((x)=>String(x.key).split('.')[0] === k && (!on.owner || !x.owner || x.owner === on.owner));
        return hit || null;
    }
    return list[0] || null;
}
function $97d8eabf47939ce7$export$c2f221de4ee6f946(root) {
    const el = this && typeof this.call === 'function' ? this : null;
    const r = root && typeof root === 'object' ? root : {};
    const fns = el && el.context && el.context.functions;
    const named = !!fns && typeof fns.storeItemText === 'function';
    const rows = [];
    const seen = new Set();
    const split = (id)=>{
        const s = typeof id === 'string' ? id : '';
        const at = s.indexOf('/');
        return at > 0 ? [
            s.slice(0, at),
            s.slice(at + 1)
        ] : [
            '',
            ''
        ];
    };
    const add = (owner, key, name)=>{
        const k = typeof key === 'string' ? key.trim() : '';
        if (!k) return;
        const o = typeof owner === 'string' ? owner.trim() : '';
        const id = (o + '/' + k).toLowerCase();
        if (seen.has(id)) return;
        seen.add(id);
        const row = {
            key: k,
            name: typeof name === 'string' && name.trim() ? name.trim() : k,
            owner: o
        };
        if (named) {
            let label = '';
            try {
                label = el.call('storeItemText', {
                    key: k,
                    name: row.name
                }, 'name');
            } catch (_) {
                label = '';
            }
            if (typeof label === 'string' && label.trim()) row.label = label.trim();
        }
        rows.push(row);
    };
    for (const a of Array.isArray(r._wsAppsCatalog) ? r._wsAppsCatalog : []){
        if (!a || typeof a !== 'object') continue;
        const [owner, key] = split(a.id);
        add(a.owner || owner, a.key || key, a.name);
    }
    let ctx = null;
    if (el) try {
        ctx = el.call('projectKindContext', r);
    } catch (_) {
        ctx = null;
    }
    for (const id of ctx && Array.isArray(ctx.modules) ? ctx.modules : []){
        const [owner, key] = split(id);
        add(owner, key, '');
    }
    return rows;
}
function $97d8eabf47939ce7$export$8ccefd996ac6000f(sites, projects, query, onScreen, root) {
    const el = this;
    const q = String(query == null ? '' : query).trim();
    const web = (Array.isArray(sites) ? sites : []).filter((x)=>x && x.key);
    const pick = (rows, how)=>el.call('canvasAnswerPickSite', rows, q, onScreen, how);
    const as = (kind, row, match)=>row ? {
            kind: kind,
            site: kind === 'website' ? row : null,
            name: row.label || row.name || String(row.key),
            match: match,
            ...kind === 'storeApp' ? {
                app: {
                    owner: row.owner || '',
                    key: String(row.key)
                }
            } : {}
        } : null;
    const nothing = {
        kind: null,
        site: null,
        name: '',
        match: null
    };
    const known = Array.isArray(projects) ? projects.filter((p)=>p && p.key) : null;
    if (!q) return as('website', pick(web), null) || nothing;
    if (!known) return as('website', pick(web, 'exact'), 'exact') || as('website', pick(web, 'part'), 'part') || nothing;
    const slugOf = (v)=>{
        if (!v) return '';
        if (typeof v === 'string') return /^[a-f0-9]{24}$/i.test(v) ? '' : v;
        return v.slug || v.key || '';
    };
    const lc = (v)=>String(v || '').toLowerCase();
    const ownerOf = (p)=>slugOf(p.owner) || slugOf(p.workspace && p.workspace.organization);
    const siteKeys = new Set(web.map((x)=>String(x.key)));
    const listed = el.call('canvasAnswerStoreApps', root);
    const storeRows = (Array.isArray(listed) ? listed : []).filter((a)=>a && a.key);
    const installed = el.call('canvasAnswerInstalled', root);
    const installedIds = new Set((Array.isArray(installed) ? installed : []).map(lc));
    // The workspace's other projects, named as a person sees them (never an
    // id); an App Store app installed here by its App Store name too.
    const others = known.filter((p)=>!siteKeys.has(String(p.key))).map((p)=>{
        const row = {
            key: String(p.key),
            name: typeof p.name === 'string' && p.name.trim() ? p.name.trim() : String(p.key)
        };
        const id = lc(ownerOf(p) + '/' + p.key);
        const app = installedIds.has(id) ? storeRows.find((a)=>a.label && lc(a.owner + '/' + a.key) === id) : null;
        return app ? {
            ...row,
            label: app.label
        } : row;
    });
    // An App Store app that is a project here is that project: the same key, and
    // the same owner when both are known.
    const here = known.map((p)=>({
            key: lc(p.key),
            owner: lc(ownerOf(p))
        }));
    const store = storeRows.filter((a)=>!here.some((h)=>h.key === lc(a.key) && (!h.owner || !a.owner || h.owner === lc(a.owner))));
    const exact = as('website', pick(web, 'exact'), 'exact') || as('project', pick(others, 'exact'), 'exact') || as('storeApp', pick(store, 'exact'), 'exact');
    if (exact) return exact;
    // `a` holds `b`: its span covers b's and more.
    const holds = (a, b)=>a.from <= b.from && a.to >= b.to && a.to - a.from > b.to - b.from;
    const webPart = pick(web, 'span');
    const projectPart = pick(others, 'span');
    if (projectPart && (!webPart || holds(projectPart, webPart))) return as('project', projectPart.row, 'part');
    if (webPart) return as('website', webPart.row, 'part');
    const storePart = pick(store, 'span');
    return storePart && as('storeApp', storePart.row, 'part') || nothing;
}
async function $97d8eabf47939ce7$export$5ddf55ba4b8ec02c(sites, projects, query, onScreen, root, waitMs) {
    const el = this;
    const nothing = {
        kind: null,
        site: null,
        name: '',
        match: null
    };
    const r = root && typeof root === 'object' ? root : null;
    const asked = String(query == null ? '' : query).trim();
    const kept = (meant)=>{
        if (el && typeof el === 'object') el.__canvasNamed = {
            query: asked,
            answer: JSON.stringify([
                meant.kind || null,
                meant.site ? String(meant.site.key) : null,
                meant.name || ''
            ]),
            projects: r ? r._projectsForActiveOrg : undefined,
            catalog: r ? r._wsAppsCatalog : undefined
        };
        return meant;
    };
    let first = nothing;
    try {
        first = el.call('canvasAnswerNamed', sites, projects, query, onScreen, root) || nothing;
    } catch (_) {
        return nothing;
    }
    if (first.match === 'exact' || !asked || !r || !Array.isArray(projects)) return kept(first);
    if (r._wsAppsCatalogLoaded === true) return kept(first);
    const fns = el && el.context && el.context.functions;
    if (!fns || typeof fns.loadWorkspaceAppsCatalog !== 'function') return kept(first);
    try {
        await el.call('loadWorkspaceAppsCatalog');
        const end = Date.now() + (Number(waitMs) > 0 ? Number(waitMs) : 8000);
        while(r._wsAppsCatalogLoading === true && r._wsAppsCatalogLoaded !== true){
            if (Date.now() >= end) return kept(first);
            await new Promise((resolve)=>setTimeout(resolve, 100));
        }
        if (r._wsAppsCatalogLoaded !== true) return kept(first);
        return kept(el.call('canvasAnswerNamed', sites, projects, query, onScreen, r) || first);
    } catch (_) {
        return kept(first);
    }
}
function $97d8eabf47939ce7$export$86d0f9d502dea1c7(el, query) {
    const host = el || this;
    if (!host || typeof host !== 'object' || typeof host.call !== 'function') return 0;
    const epoch = Number(host.__canvasNamedEpoch) || 0;
    const was = host.__canvasNamed;
    const root = host.state && host.state.root;
    const asked = String(query == null ? '' : query).trim();
    if (!was || !root || typeof root !== 'object' || was.query !== asked) return epoch;
    if (was.projects === root._projectsForActiveOrg && was.catalog === root._wsAppsCatalog) return epoch;
    was.projects = root._projectsForActiveOrg;
    was.catalog = root._wsAppsCatalog;
    let meant = null;
    try {
        const list = host.call('canvasAnswerProjects', root);
        if (!Array.isArray(list)) return epoch;
        const sites = host.call('canvasAnswerSites', list, host.call('canvasAnswerInstalled', root));
        const onScreen = host.call('canvasAnswerOnScreen', root);
        meant = host.call('canvasAnswerNamed', sites, list, asked, onScreen, root);
    } catch (_) {
        return epoch;
    }
    const m = meant && typeof meant === 'object' ? meant : {};
    const answer = JSON.stringify([
        m.kind || null,
        m.site ? String(m.site.key) : null,
        m.name || ''
    ]);
    if (answer === was.answer) return epoch;
    host.__canvasNamedEpoch = epoch + 1;
    return epoch + 1;
}
function $97d8eabf47939ce7$export$65878d5b77d30c58(app) {
    const a = app && typeof app === 'object' ? app : {};
    return this.call('appStoreItemLink', a.owner, a.key);
}
function $97d8eabf47939ce7$export$1259e59bd10a9d67(root) {
    let describe = 'a website (project) of this workspace; the project on screen, else the newest website';
    const list = this.call('canvasAnswerProjects', root);
    if (!Array.isArray(list)) return {
        type: 'string',
        describe: describe
    };
    const sites = this.call('canvasAnswerSites', list, this.call('canvasAnswerInstalled', root));
    const on = this.call('canvasAnswerOnScreen', root);
    if (on && on.key && !this.call('canvasAnswerPickSite', sites, '', on)) describe = 'a website (project) of this workspace; the project on screen is not one, so none shows when left out';
    if (!sites.length) return {
        type: 'string',
        describe: describe
    };
    const values = [];
    const labels = {};
    for (const s of sites){
        if (values.includes(s.key)) continue;
        values.push(s.key);
        labels[s.key] = s.name;
    }
    return {
        type: 'enum',
        values: values,
        labels: labels,
        valuesLive: true,
        describe: describe
    };
}
async function $97d8eabf47939ce7$export$7cb75d3a65faa1e7(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const params = host.scope && host.scope.params || {};
    const sig = JSON.stringify([
        params.search || '',
        params.limit || 6,
        params.env || ''
    ]);
    if (host.__canvasAnswerSig === sig) return null;
    host.__canvasAnswerSig = sig;
    const res = await host.call('canvasAnswerRead', host);
    if (host.__canvasAnswerSig !== sig) return null;
    const list = host.call('canvasAnswerCards', res && res.projects, params);
    const total = host.call('canvasAnswerMatchCount', res && res.projects, params);
    host.state.update({
        projects: list,
        total: total,
        failed: !!(res && res.failed) && !list.length
    });
    return res;
}
function $97d8eabf47939ce7$export$f3a587c8d53b3790(projects, params) {
    const p = params && typeof params === 'object' ? params : {};
    const words = String(p.search || '').toLowerCase().split(/\s+/).filter(Boolean);
    return (Array.isArray(projects) ? projects : []).filter((x)=>{
        if (!x || !x.key) return false;
        const hay = (String(x.name || '') + ' ' + String(x.key)).toLowerCase();
        return words.every((w)=>hay.includes(w));
    }).length;
}
function $97d8eabf47939ce7$export$b8685e068fcbcde7(s) {
    const list = s && Array.isArray(s.projects) ? s.projects : null;
    const total = Number(s && s.total) || 0;
    if (!list || !list.length || !(total > list.length)) return '';
    return String(this.call('polyglot', 'canvas.answer.more')).replace('{n}', String(list.length)).replace('{total}', String(total));
}
function $97d8eabf47939ce7$export$149ac6f7f591af70(projects, params) {
    const el = this;
    const p = params && typeof params === 'object' ? params : {};
    const list = Array.isArray(projects) ? projects.filter(Boolean) : [];
    const slugOf = (v)=>{
        if (!v) return '';
        if (typeof v === 'string') return /^[a-f0-9]{24}$/i.test(v) ? '' : v;
        return v.slug || v.key || '';
    };
    const root = el && el.state && el.state.root || {};
    const claims = root.jwtClaims || {};
    const orgs = claims.orgs || root.orgs || [];
    const org = (Array.isArray(orgs) ? orgs : []).find((o)=>o && o.id === claims.workspace_org_id);
    const ownerSlug = org && org.slug || '';
    const wsId = claims.active_workspace_id || root.workspace && root.workspace.id || null;
    const wsList = Array.isArray(claims.workspaces) ? claims.workspaces : [];
    const wsEntry = wsList.find((w)=>w && w.id === wsId);
    const wsSlug = wsEntry && wsEntry.slug || '';
    const words = String(p.search || '').toLowerCase().split(/\s+/).filter(Boolean);
    const limit = Math.max(1, Math.min(24, Math.floor(Number(p.limit)) || 6));
    const env = [
        'production',
        'staging',
        'development'
    ].includes(p.env) ? p.env : 'production';
    const at = (x)=>Date.parse(x.updatedAt || x.updated_at || x.createdAt || x.created_at || '') || 0;
    // THE APP SPLIT (docs/APP_SPLIT.md): this view is the WEBSITES view — a
    // workspace app (a module, an AI-built app) and a library never become a
    // card here (the shared projectKind, with the workspace's own signals).
    let kindCtx = null;
    if (el && typeof el.call === 'function' && el.state && el.state.root) try {
        kindCtx = el.call('projectKindContext', el.state.root) || null;
    } catch (_) {
        kindCtx = null;
    }
    return list.filter((x)=>{
        if (!x.key) return false;
        if (kindCtx) {
            // An unregistered classifier answers nothing — the card then stays.
            const kind = el.call('projectKind', x, kindCtx);
            if (typeof kind === 'string' && kind !== 'website') return false;
        }
        const hay = (String(x.name || '') + ' ' + String(x.key)).toLowerCase();
        return words.every((w)=>hay.includes(w));
    }).sort((a, b)=>at(b) - at(a)).slice(0, limit).map((x)=>({
            key: String(x.key || ''),
            name: x.name || '',
            description: x.description || '',
            icon: x.icon || null,
            owner: slugOf(x.owner) || slugOf(x.workspace && x.workspace.organization) || ownerSlug,
            workspace: x.workspace || null,
            workspaceSlug: slugOf(x.workspaceSlug) || wsSlug,
            env: env
        }));
}
function $97d8eabf47939ce7$export$393b510607c37de8(row, action, event) {
    const el = this;
    const s = row && typeof row === 'object' ? row : {};
    const owner = typeof s.owner === 'string' ? s.owner : '';
    const key = typeof s.key === 'string' ? s.key.split('.')[0] : '';
    if (!el || !owner || !key) return false;
    const root = el.state && el.state.root;
    if (action === 'preview') {
        const env = [
            'production',
            'staging',
            'development'
        ].includes(s.env) ? s.env : null;
        el.call('previewAnswerOpenSite', {
            owner: owner,
            key: key,
            env: env
        }, event);
        return true;
    }
    if (action === 'canvas') return el.call('studioOpenProject', {
        owner: owner,
        key: key,
        _id: s._id
    }) === true;
    if (action === 'analytics') {
        if (!root || typeof root.update !== 'function') return false;
        root.update({
            _analyticsParams: {
                owner: owner,
                key: key
            },
            _analyticsProjectKey: key
        });
        const split = !!(event && (event.metaKey || event.ctrlKey));
        el.call('openAppPage', '/analytics', split ? {
            split: true
        } : undefined);
        return true;
    }
    return false;
}

});

parcelRegister("18kiP", function(module, exports) {

$parcel$export(module.exports, "canvasStatusLoad", () => $0d3649809212bdff$export$7c78eadaf4551e57);
$parcel$export(module.exports, "canvasStatusLive", () => $0d3649809212bdff$export$50d228b1d5259bf0);
$parcel$export(module.exports, "canvasStatusEnvs", () => $0d3649809212bdff$export$e90ebb4eaa3d320f);
$parcel$export(module.exports, "canvasStatusVersions", () => $0d3649809212bdff$export$3ddd4fa0ea427b99);
$parcel$export(module.exports, "canvasStatusLink", () => $0d3649809212bdff$export$55a74a4e4d619cc0);
$parcel$export(module.exports, "canvasStatusPick", () => $0d3649809212bdff$export$f2e9ebc6dc0c6c36);
// THE WEBSITES' STATE IN AN AI ANSWER — the `project-status` view
// (functions/canvasAnswer.js canvasAiViews; components/ProjectStatusView.js).
// Nika 2026-10-18: "fly should cover all functionality that would be possible
// otherwise" — "Is our site live?" is answered by this card (QA 2026-10-18).
//
// Two modes, one card:
//   every website  no project named and no website on screen: more than one
//                  website, or a project on screen that is not a website (an
//                  app canvas — its only website never stands in for it):
//                  each website (the first SITES_MAX, in canvasAnswerSites'
//                  order) with its production state chip — live, never
//                  published, not available. QA on dev 2026-10-19: "What is
//                  the status of our sites?" composed ONE site's card beside
//                  a projects list with no state, so "Never published"
//                  (content-and-marketing, bi-app) stood nowhere on the page.
//                  A row opens that site's detail in the card; Back returns.
//   one website    a project named (the params, or the card's own row pick),
//                  the website on screen, or (nothing on screen) the
//                  workspace's only website.
//
// Read-only. One website's three reads, into the view's OWN state:
//   live      what the production site's ADDRESS serves — the project's
//             environments and its published release, read as a member (the
//             preview package's previewSiteHosting + previewEnvServes): live,
//             never published (it serves the latest saved version), not
//             available (switched off); the public data read
//             (previewSiteRead) only when the environments cannot be read,
//             else unknown. Never the project's visibility: the render worker
//             serves a private project's site to every visitor (dev
//             2026-10-19: system/invest read "Private" while its address
//             answered 200 to an anonymous visitor).
//   envs      what each environment serves (the same environments): off, the
//             published release (or never published), a pinned version, the
//             latest of a branch
//   versions  the newest versions of the main branch (`sdk.getProjectVersions`,
//             canvas functions/versionHistory.js's list call)
// Publishing is never this card's: a change the ask asks for is the page's
// "Do it" (the assistant's Tools, with its confirm card — docs/FLY_MODE.md).
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
// The view's read, once per params, the card's own pick, the installed apps
// and the project on screen. `{ site, sites, total, live, envs, versions,
// failed, none, notWebsite, storeApp }` in its own state: `sites` (the
// every-website rows, each `{ key, name, owner, live }`) or `site` (one
// website), never both; `notWebsite` / `storeApp` the name the one sentence
// says when the asked name is no website.
async function $0d3649809212bdff$export$7c78eadaf4551e57(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const params = host.scope && host.scope.params || {};
    const root = host.state.root || {};
    const installed = host.call('canvasAnswerInstalled', root);
    const onScreen = host.call('canvasAnswerOnScreen', root);
    const limit = Math.max(1, Math.min(10, Math.floor(Number(params.limit)) || 5));
    const pick = typeof host.state.pick === 'string' ? host.state.pick.trim() : '';
    const named = pick || (typeof params.project === 'string' ? params.project.trim() : '');
    // A list that landed after the card answered (the project list, the App
    // Store list) can change what the name means: canvasAnswerNamedMoved decides
    // again and moves the counter in this signature when the answer moved.
    const moved = host.call('canvasAnswerNamedMoved', host, named);
    const sig = JSON.stringify([
        named,
        limit,
        installed,
        onScreen ? onScreen.owner + '/' + onScreen.key : '',
        moved
    ]);
    if (host.__canvasStatusSig === sig) return null;
    host.__canvasStatusSig = sig;
    const read = await host.call('canvasAnswerRead', host);
    if (host.__canvasStatusSig !== sig) return null;
    const sites = host.call('canvasAnswerSites', read && read.projects, installed);
    const settle = (p)=>Promise.resolve(p).then((r)=>r, ()=>null);
    const base = (k)=>String(k || '').split('.')[0];
    const shown = !named && onScreen && onScreen.key ? sites.find((x)=>base(x.key) === base(onScreen.key) && (!onScreen.owner || !x.owner || x.owner === onScreen.owner)) : null;
    // A project on screen that is not one of the websites (an app canvas): the
    // card never puts the only website in its place, in silence (dev
    // 2026-10-31, the Velvet Lantern canvas) — it lists every website.
    const away = !named && !shown && !!(onScreen && onScreen.key);
    // EVERY WEBSITE: no name and no website on screen — more than one website,
    // or any website at all beside a project on screen that is not one.
    if (!named && !shown && (sites.length > 1 || away && sites.length > 0)) {
        const SITES_MAX = 8;
        const rows = sites.slice(0, SITES_MAX);
        host.state.update({
            site: null,
            sites: rows.map((r)=>({
                    key: r.key,
                    name: r.name,
                    owner: r.owner,
                    live: null
                })),
            total: sites.length,
            live: null,
            envs: null,
            versions: null,
            failed: false,
            none: false,
            notWebsite: null,
            storeApp: null
        });
        const reads = await Promise.all(rows.map((r)=>settle(host.call('previewSiteHosting', {
                owner: r.owner,
                key: r.key,
                id: r.id || null
            }))));
        if (host.__canvasStatusSig !== sig) return null;
        host.state.update({
            sites: rows.map((r, i)=>({
                    key: r.key,
                    name: r.name,
                    owner: r.owner,
                    live: host.call('canvasStatusLive', host.call('previewEnvServes', reads[i], 'production'), null)
                }))
        });
        return rows;
    }
    // ONE WEBSITE — what the name means (canvasAnswerNamed, the rule of every
    // website card): a website; else a project of this workspace that is not a
    // website, or an App Store app that is no project here — the one sentence
    // names it, never "no match" (items 1, 2, 3 — 2026-10-31). Its load step
    // canvasAnswerNamedRead reads the App Store list once when nothing matches
    // and the shell has not read it yet.
    const meant = await host.call('canvasAnswerNamedRead', sites, read && !read.failed ? read.projects : null, named, onScreen, root) || {};
    if (host.__canvasStatusSig !== sig) return null;
    const site = meant.kind === 'website' ? meant.site : null;
    if (!site) {
        host.state.update({
            site: null,
            sites: null,
            live: null,
            envs: null,
            versions: null,
            failed: true,
            none: !named && !!read && !read.failed && !sites.length,
            notWebsite: meant.kind === 'project' ? meant.name : null,
            storeApp: meant.kind === 'storeApp' ? meant.name : null
        });
        return null;
    }
    host.state.update({
        site: {
            key: site.key,
            name: site.name,
            owner: site.owner
        },
        sites: null,
        live: null,
        envs: null,
        versions: null,
        failed: false,
        none: false,
        notWebsite: null,
        storeApp: null
    });
    const sdk = host.sdk || host.call('getSDK');
    const data = (v)=>v && typeof v === 'object' && 'data' in v && v.success ? v.data : v;
    const hostingRead = settle(host.call('previewSiteHosting', {
        owner: site.owner,
        key: site.key,
        id: site.id || null
    }));
    const versionsOf = (id)=>id && sdk && typeof sdk.getProjectVersions === 'function' ? sdk.getProjectVersions(id, {
            branch: 'main',
            page: 1,
            limit: limit,
            fields: 'value,message,createdAt,user,versionNumber'
        }).then(data, ()=>null) : Promise.resolve(null);
    const versionRead = site.id ? versionsOf(site.id) : hostingRead.then((h)=>versionsOf(h && h.id));
    const liveRead = settle(host.call('previewSiteRead', {
        owner: site.owner,
        key: site.key,
        env: 'production'
    }));
    const [hosting, versionRes, liveRes] = await Promise.all([
        hostingRead,
        versionRead,
        liveRead
    ]);
    if (host.__canvasStatusSig !== sig) return null;
    const serves = {};
    for (const env of [
        'production',
        'staging',
        'development'
    ])serves[env] = host.call('previewEnvServes', hosting, env);
    host.state.update({
        live: host.call('canvasStatusLive', serves.production, liveRes),
        envs: host.call('canvasStatusEnvs', hosting && hosting.known ? hosting.environments : null, {
            production: serves.production === 'never' || !!(liveRes && liveRes.never),
            staging: serves.staging === 'never',
            development: serves.development === 'never'
        }),
        versions: host.call('canvasStatusVersions', versionRes, limit)
    });
    return site;
}
function $0d3649809212bdff$export$50d228b1d5259bf0(serves, read) {
    const r = read && typeof read === 'object' && !read.error ? read : null;
    if (serves === 'off') return {
        status: 'danger',
        label: 'canvas.status.live.unavailable'
    };
    if (serves === 'never' || r && r.never) return {
        status: 'warning',
        label: 'canvas.status.live.never'
    };
    if (serves) return {
        status: 'success',
        label: 'canvas.status.live.live'
    };
    if (r && r.published) return {
        status: 'success',
        label: 'canvas.status.live.live'
    };
    return {
        status: null,
        label: 'canvas.status.live.unknown'
    };
}
function $0d3649809212bdff$export$e90ebb4eaa3d320f(map, never) {
    const envs = map && typeof map === 'object' ? map : null;
    if (!envs) return null;
    const nothing = never && typeof never === 'object' ? never : {};
    const LABELS = {
        production: 'canvas.sidebar.env.production',
        staging: 'canvas.sidebar.env.staging',
        development: 'canvas.sidebar.env.development'
    };
    return [
        'production',
        'staging',
        'development'
    ].map((key)=>{
        const cfg = envs[key] && typeof envs[key] === 'object' ? envs[key] : null;
        const on = !!cfg && cfg.enabled !== false;
        const branch = cfg && typeof cfg.branch === 'string' && cfg.branch || 'main';
        const version = cfg && typeof cfg.version === 'string' && cfg.version || '';
        let serves = 'canvas.status.env.off';
        let value = '';
        if (on && cfg.mode === 'version' && version) {
            serves = 'canvas.status.env.version';
            value = version;
        } else if (on && cfg.mode === 'published') serves = nothing[key] ? 'canvas.status.env.never' : 'canvas.status.env.published';
        else if (on && cfg.mode === 'branch') {
            serves = 'canvas.status.env.branch';
            value = branch;
        } else if (on) {
            serves = 'canvas.status.env.latest';
            value = branch;
        }
        return {
            key: key,
            label: LABELS[key],
            serves: serves,
            value: value,
            on: on
        };
    });
}
function $0d3649809212bdff$export$3ddd4fa0ea427b99(res, limit) {
    const list = Array.isArray(res) ? res : res && Array.isArray(res.versions) ? res.versions : res && Array.isArray(res.items) ? res.items : null;
    if (!list) return null;
    const n = Math.max(1, Math.min(10, Math.floor(Number(limit)) || 5));
    return list.filter((v)=>v && typeof v === 'object' && v.value).slice(0, n).map((v, i)=>{
        const who = v.author || v.user || null;
        const author = who && typeof who === 'object' ? String(who.name || who.username || '').trim() : '';
        return {
            key: 'v-' + String(v._id || v.id || i),
            value: String(v.value),
            message: typeof v.message === 'string' ? v.message.trim().slice(0, 140) : '',
            at: v.createdAt || v.created_at || null,
            author: author
        };
    });
}
function $0d3649809212bdff$export$55a74a4e4d619cc0(params, root) {
    const r = root && typeof root === 'object' ? root : {};
    const p = params && typeof params === 'object' ? params : {};
    const list = this.call('canvasAnswerProjects', r);
    if (!Array.isArray(list)) return null;
    const sites = this.call('canvasAnswerSites', list, this.call('canvasAnswerInstalled', r));
    const onScreen = this.call('canvasAnswerOnScreen', r);
    const named = typeof p.project === 'string' ? p.project.trim() : '';
    const base = (k)=>String(k || '').split('.')[0];
    const shown = !named && onScreen && onScreen.key ? sites.find((x)=>base(x.key) === base(onScreen.key) && (!onScreen.owner || !x.owner || x.owner === onScreen.owner)) : null;
    // The every-website list (canvasStatusLoad's own rule).
    const away = !named && !shown && !!(onScreen && onScreen.key);
    if (!named && !shown && (sites.length > 1 || away && sites.length > 0)) return null;
    // The card's own rule (canvasAnswerNamed): a project that is not a website
    // links nowhere, as its card shows no site; an App Store app that is no
    // project here links to its App Store page (canvasAnswerStoreLink).
    const meant = this.call('canvasAnswerNamed', sites, list, named, onScreen, r) || {};
    if (meant.kind === 'storeApp') return this.call('canvasAnswerStoreLink', meant.app);
    const site = meant.kind === 'website' ? meant.site : null;
    if (!site || !site.owner || !site.key) return null;
    return '/' + encodeURIComponent(site.owner) + '/' + encodeURIComponent(site.key.split('.')[0]);
}
function $0d3649809212bdff$export$f2e9ebc6dc0c6c36(el, key) {
    const view = el && el.dataProjectStatus === true ? el : el && typeof el.lookup === 'function' ? el.lookup((e)=>e.dataProjectStatus === true) : null;
    const s = view && view.state;
    if (!s || typeof s.update !== 'function') return false;
    s.update({
        pick: typeof key === 'string' && key ? key : null
    });
    return true;
}

});

parcelRegister("gHwNh", function(module, exports) {

$parcel$export(module.exports, "isStudioAiBuiltApp", () => $c28a19a90650a13e$export$5102a7ff35a9ad83);
$parcel$export(module.exports, "studioOpenProject", () => $c28a19a90650a13e$export$7568a2ed63535852);
// ONE WAY TO OPEN A PROJECT FROM THE STUDIO (lane FU2c, 2026-10-31 —
// concierge 13:06: "one open function shared by the tile and the menu row").
// Every "open the project" entry opens a project HERE, so each one lands
// where the /studio tile's double-click (and Enter) lands:
//   an AI-built app (create_app / create_extension) → its rendered preview in
//     /add-app. It renders from SOURCE: the website editor has nothing to
//     show for it (docs/APP_SPLIT.md — a workspace app never opens there);
//   every other project → its route (projectHref: the workspace-scoped form
//     inside the owner's org, else /<owner>/<key>).
// Callers: the tile and the project menu's "Open in app" (pages/studios.js),
// the Studio card's "Open canvas" (pages/dashboard.js), the dashboard rows
// (components/DashboardRows.js) and the AI answer card's "Open canvas"
// (functions/canvasAnswer.js). The rows whose job is the EDITOR itself (the
// env-pinned open, Publish, Version history) keep their own route.
//
// The /add-app hand-off is the shell's window bridge exactly as the tile has
// always used it: `window.__addAppOpenId` (read once by the /add-app page,
// consumeAddAppOpenId) and `window.__wsRoot.call('openAppPage', '/add-app')`.
// Outside the shell (no `window.__wsRoot`), or when it throws, the project
// route is the fallback. FA204: each export is self-contained; siblings
// through this.call.
// el.call('isStudioAiBuiltApp', project, aiAppIds) — is the project an
// AI-built app? It has a db `_id` (the /add-app hand-off selects the app by
// it), and that `_id` is in `aiAppIds` (the caller's own list, a Set or an
// array: the /studio board passes the ids it reads from ai.listExtensions on
// each load), or in the workspace's app-split signals
// (projectKindContext(root).extensions, the shared classifier's list), or the
// board said so when the project was selected (`aiBuilt: true` on
// root._studioSelected — the Studio card cannot read the board's list). The
// Studio card's label reads this same answer, so its words and its open agree.
function $c28a19a90650a13e$export$5102a7ff35a9ad83(project, aiAppIds) {
    const el = this;
    const p = project && typeof project === 'object' ? project : {};
    const id = p._id ? String(p._id) : '';
    if (!id) return false;
    if (p.aiBuilt === true) return true;
    if (aiAppIds && typeof aiAppIds.has === 'function' && aiAppIds.has(id)) return true;
    if (Array.isArray(aiAppIds) && aiAppIds.some((x)=>String(x) === id)) return true;
    if (!el || typeof el.call !== 'function') return false;
    let root = el.state && el.state.root || null;
    if (!root && typeof el.getRoot === 'function') {
        const rootEl = el.getRoot();
        root = rootEl && rootEl.state || null;
    }
    let ctx = null;
    try {
        ctx = el.call('projectKindContext', root);
    } catch (_) {
        ctx = null;
    }
    const want = id.trim().toLowerCase();
    return !!(ctx && Array.isArray(ctx.extensions) && ctx.extensions.some((x)=>String(x).trim().toLowerCase() === want));
}
function $c28a19a90650a13e$export$7568a2ed63535852(project, aiAppIds) {
    const el = this;
    const p = project && typeof project === 'object' ? project : {};
    if (!el || typeof el.call !== 'function' || !p.owner || !p.key) return false;
    const id = p._id ? String(p._id) : '';
    if (id && el.call('isStudioAiBuiltApp', p, aiAppIds) === true && typeof window !== 'undefined' && window.__wsRoot && typeof window.__wsRoot.call === 'function') try {
        window.__addAppOpenId = id;
        window.__wsRoot.call('openAppPage', '/add-app');
        return true;
    } catch (_) {
    /* fall through to the project route */ }
    const urls = el.call('buildProjectUrls', p.owner, p.key);
    if (!urls) return false;
    const rootEl = typeof el.getRoot === 'function' ? el.getRoot() : null;
    const root = el.state && el.state.root || rootEl && rootEl.state || null;
    el.router(el.call('projectHref', root, urls.safeOwner, urls.safeKey), rootEl);
    return true;
}

});

parcelRegister("3HSmu", function(module, exports) {

$parcel$export(module.exports, "confirmTeamLeave", () => $2b2f8e5f4c46f8ae$export$ec3003ea86460d2a);
$parcel$export(module.exports, "runTeamLeave", () => $2b2f8e5f4c46f8ae$export$514cbb0f7e25cb18);
// Team canvas (/team-and-agents): a person card dropped outside every team
// frame removes that person from the team (CRUD + confirm standard rule 4:
// removing a member is a sensitive action; audit row "team canvas — Team
// membership").
//
// el.call('confirmTeamLeave', { name, team, onConfirm, onCancel }) opens the
// house confirm (confirmDialog) that names the person and the team. Nothing
// changes before the verb: the page's own leave runs only in onConfirm, and
// every other way out (Cancel, Escape, the backdrop, the X, a programmatic
// close) runs onCancel once, so the page can put the card back.
//
// el.call('runTeamLeave', root, { team, userId, email }) is the leave itself:
// the membership indexes drop the team row at once (the frame redraws), the
// SDK removes the member, and a failure puts this person's rows back and
// resolves false (rule 5: the page then rolls the card back and says so).
// It never throws.
// Fill one {token} with a literal value. A function replacer, so a `$&` or a
// `$$` inside a person or team name is never read as a replacement pattern.
const $2b2f8e5f4c46f8ae$var$_teamLeaveFill = (text, token, value)=>String(text).replace(token, ()=>String(value));
// One person's rows in a membership index (`teamsByEmail` /
// `teamsByUserId`), without the given team. Returns the same object when the
// index has no such row.
const $2b2f8e5f4c46f8ae$var$_teamLeaveDropRow = (index, key, teamId)=>{
    if (!key || !index || !Array.isArray(index[key])) return index;
    const rows = index[key].filter((row)=>!row || row.id !== teamId);
    if (rows.length === index[key].length) return index;
    const next = {
        ...index
    };
    if (rows.length) next[key] = rows;
    else delete next[key];
    return next;
};
// Put one person's rows back as they were in `before` (rollback). Only that
// key changes, so a refresh of anyone else's rows in the meantime survives.
const $2b2f8e5f4c46f8ae$var$_teamLeaveRestoreRows = (index, key, before)=>{
    if (!key) return index;
    const next = {
        ...index || {}
    };
    if (before && Array.isArray(before[key])) next[key] = before[key];
    else delete next[key];
    return next;
};
const $2b2f8e5f4c46f8ae$export$ec3003ea86460d2a = function(ask) {
    const { name: name, team: team, onConfirm: onConfirm, onCancel: onCancel } = ask || {};
    if (!team || !team.id || typeof onConfirm !== 'function') return;
    const fill = (key)=>$2b2f8e5f4c46f8ae$var$_teamLeaveFill($2b2f8e5f4c46f8ae$var$_teamLeaveFill(this.call('polyglot', key), '{name}', name), '{team}', team.name);
    let confirmed = false;
    this.call('confirmDialog', {
        title: fill('canvas.team.leave.title'),
        message: fill('canvas.team.leave.message'),
        confirmText: this.call('polyglot', 'canvas.team.leave.confirm'),
        cancelText: this.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: ()=>{
            confirmed = true;
            onConfirm();
        },
        // onClose runs after every way out, a programmatic closeModal included
        // (onCancel alone misses that one), and after onConfirm too — hence the
        // flag.
        onClose: ()=>{
            if (!confirmed && typeof onCancel === 'function') onCancel();
        }
    });
};
const $2b2f8e5f4c46f8ae$export$514cbb0f7e25cb18 = async function(root, leave) {
    const { team: team, userId: userId, email: email } = leave || {};
    if (!root || !team || !team.id || !userId) return false;
    const emailKey = String(email || '').toLowerCase();
    const idKey = String(userId);
    const byEmail = root.teamsByEmail || {};
    const byUserId = root.teamsByUserId || {};
    root.update({
        teamsByEmail: $2b2f8e5f4c46f8ae$var$_teamLeaveDropRow(byEmail, emailKey, team.id),
        teamsByUserId: $2b2f8e5f4c46f8ae$var$_teamLeaveDropRow(byUserId, idKey, team.id)
    });
    try {
        await this.call('removeMemberFromTeam', root, {
            orgId: team.orgId,
            teamId: team.id,
            userId: userId,
            email: email
        });
        return true;
    } catch (err) {
        root.update({
            teamsByEmail: $2b2f8e5f4c46f8ae$var$_teamLeaveRestoreRows(root.teamsByEmail, emailKey, byEmail),
            teamsByUserId: $2b2f8e5f4c46f8ae$var$_teamLeaveRestoreRows(root.teamsByUserId, idKey, byUserId)
        });
        console.warn('[team-and-agents] leave-team drop failed:', err?.message || err);
        return false;
    }
};

});

parcelRegister("f7G7i", function(module, exports) {

$parcel$export(module.exports, "confirmAgentUnassign", () => $b0282df0daf1f23f$export$311073c331641e89);
// Team canvas (/team-and-agents): unassigning an agent from a person asks
// first (CRUD + confirm standard rule 4; audit row "team canvas — Agent
// assignment"). Two triggers reach it: a click on the agent → person edge on
// the board, and the Remove button in the agent editor's Assignment tab. Both
// used to unassign on the click.
//
// el.call('confirmAgentUnassign', { agent, person, onConfirm }) opens the house
// confirm (confirmDialog) that names the agent and the person. The caller's
// unassign runs only in onConfirm; nothing changes before the verb.
// Fill one {token} with a literal value. A function replacer, so a `$&` or a
// `$$` inside a name is never read as a replacement pattern.
const $b0282df0daf1f23f$var$_agentUnassignFill = (text, token, value)=>String(text).replace(token, ()=>String(value));
const $b0282df0daf1f23f$export$311073c331641e89 = function(ask) {
    const { agent: agent, person: person, onConfirm: onConfirm } = ask || {};
    if (!agent || !person || typeof onConfirm !== 'function') return;
    const fill = (key)=>$b0282df0daf1f23f$var$_agentUnassignFill($b0282df0daf1f23f$var$_agentUnassignFill(this.call('polyglot', key), '{agent}', agent), '{person}', person);
    this.call('confirmDialog', {
        title: fill('canvas.team.unassign.title'),
        message: fill('canvas.team.unassign.message'),
        confirmText: this.call('polyglot', 'canvas.team.unassign.confirm'),
        cancelText: this.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: onConfirm
    });
};

});


parcelRegister("9lzH2", function(module, exports) {

$parcel$export(module.exports, "bridgeSetWindow", () => (parcelRequire("7iuuF")).bridgeSetWindow);
$parcel$export(module.exports, "openKeyboardShortcuts", () => (parcelRequire("7iuuF")).openKeyboardShortcuts);
// Eager slim slice of the canvas method barrel (#15).
//
// The shell imports this instead of `../canvas/methods/index.js` so
// context.methods no longer merges the full ~30-method canvas surface into the
// EAGER chunk. The shell-root Zoombar (mounted on every route — app.js) is the
// only eager consumer of canvas-package methods, and it calls exactly two:
// `bridgeSetWindow` and `openKeyboardShortcuts`.
//
// PREMISE CORRECTION (Rule 63 fix, tickets/workspace.md "duplicate export
// names" #5, 2026-07-27): this used to re-export a function literally named
// `setWindow`, on the claim that shared doesn't already provide one
// ("shared/methods/canvas.js" was checked — it doesn't define it there). That
// premise was FALSE: the real `setWindow` primitive lives in
// `shared/methods/windows.js` and IS exported from the shared barrel
// (`shared/methods/index.js` → `export * from './windows'`). Re-exporting a
// same-named canvas function here meant `workspace/packages/workspace/
// context.js`'s `methods: { ...canvasMethods, ...shellMethods }` baked
// canvas's copy into context.methods.setWindow BEFORE shared's methods ever
// get a chance to fill it in via mergeSharedLibraries (which only adds keys
// the target doesn't already have) — so canvas's narrow v1→v2 bridge shim
// permanently shadowed the real primitive shell-wide, breaking every
// `el.setWindow(...)` call that expected real window state
// (openWindow/closeWindow/toggleWindow, docs/explorer/componentEditor panels
// across shared/components/*). Renamed to `bridgeSetWindow` so it can never
// collide with the real export name again; see the naming note atop
// canvas/methods/index.js for the full explanation + who should call which.
//
// methods/index.js is a single self-contained module (all methods defined
// inline; it does NOT `export *` a fan-out of source files), so a named
// re-export from it pulls no extra editor code.

var $7iuuF = parcelRequire("7iuuF");

});
parcelRegister("7iuuF", function(module, exports) {

$parcel$export(module.exports, "canvasGetCanvasScope", () => $5501de4434b0643d$export$2467e009eca481dd);
$parcel$export(module.exports, "canvasGetCanvasPositions", () => $5501de4434b0643d$export$4ce908c3db28e57d);
$parcel$export(module.exports, "canvasZoomToNode", () => $5501de4434b0643d$export$89581f6adaadffac);
$parcel$export(module.exports, "zoomIn", () => $5501de4434b0643d$export$3b71758b3ed5255f);
$parcel$export(module.exports, "zoomOut", () => $5501de4434b0643d$export$9fdb0a49c6b4b521);
$parcel$export(module.exports, "zoomReset", () => $5501de4434b0643d$export$4caffb2cc31472b8);
$parcel$export(module.exports, "getZoomLevel", () => $5501de4434b0643d$export$deb0f277a5f91a79);
$parcel$export(module.exports, "findBoxByRoute", () => $5501de4434b0643d$export$dbd9a7c480819872);
$parcel$export(module.exports, "navigateCanvas", () => $5501de4434b0643d$export$4a86703d82697c4d);
$parcel$export(module.exports, "canvasActivateHovered", () => $5501de4434b0643d$export$b3cf2cec3f5ed87d);
$parcel$export(module.exports, "canvasActivateSelected", () => $5501de4434b0643d$export$a66ffb416fbd18ea);
$parcel$export(module.exports, "canvasGetSelected", () => $5501de4434b0643d$export$f22fe545e27b2961);
$parcel$export(module.exports, "canvasGetSelectedKey", () => $5501de4434b0643d$export$99686f672b41b384);
$parcel$export(module.exports, "canvasGetHoveredKey", () => $5501de4434b0643d$export$43324cbd4b4cba08);
$parcel$export(module.exports, "canvasIsCanvasMode", () => $5501de4434b0643d$export$fbcd7ce4ca59b650);
$parcel$export(module.exports, "canvasSetCanvasMode", () => $5501de4434b0643d$export$bc477a8a2570c1e9);
$parcel$export(module.exports, "openKeyboardShortcuts", () => $5501de4434b0643d$export$bcb7ebbe82ecdf67);
$parcel$export(module.exports, "bridgeSetWindow", () => $5501de4434b0643d$export$8340954925d75c96);
$parcel$export(module.exports, "canvasOpenArtboardItem", () => $5501de4434b0643d$export$ad7df4c6f75ba82e);
$parcel$export(module.exports, "canvasOpenItem", () => $5501de4434b0643d$export$c48afcb9c26cfd7c);
$parcel$export(module.exports, "canvasActivateChosen", () => $5501de4434b0643d$export$804dea44282a09f2);
$parcel$export(module.exports, "canvasActivateFunction", () => $5501de4434b0643d$export$3923011d0c791c1c);
$parcel$export(module.exports, "canvasSetSidebarContent", () => $5501de4434b0643d$export$59fa69fb8cfc0bb4);
$parcel$export(module.exports, "canvasActivateContext", () => $5501de4434b0643d$export$92486bdf26c5c038);
$parcel$export(module.exports, "canvasRefreshComponentOnCanvas", () => $5501de4434b0643d$export$8b93eb1f3d77688e);
$parcel$export(module.exports, "toggleTheme", () => $5501de4434b0643d$export$f543642fc33c1018);
$parcel$export(module.exports, "setCookie", () => $5501de4434b0643d$export$110700823644f4a6);
$parcel$export(module.exports, "canvasGetCanvasCollection", () => $5501de4434b0643d$export$e93a7b09eae81752);
$parcel$export(module.exports, "canvasGetChosen", () => $5501de4434b0643d$export$3f7ee42101d00a54);
$parcel$export(module.exports, "canvasGetChosenKey", () => $5501de4434b0643d$export$8d4cbe7c860e9433);
$parcel$export(module.exports, "canvasGetInContextKey", () => $5501de4434b0643d$export$79a18e47a61c9942);
// Reads top-window scope so the editor chrome and canvas iframe share
// the same source (DOMQL clones context.globalScope per create()).

var $eY4Ct = parcelRequire("eY4Ct");

var $1X0Je = parcelRequire("1X0Je");

var $fzbiH = parcelRequire("fzbiH");
const $5501de4434b0643d$var$canvasSyncCanvasBackgroundForTheme = (...args)=>(0, $1X0Je.default).functions.syncCanvasBackgroundForTheme(...args);
function $5501de4434b0643d$export$2467e009eca481dd(childKey) {
    const topWindow = (0, $fzbiH.resolveTopWindow)();
    const scope = topWindow?.__canvasGlobalScope || this.context?.globalScope;
    return childKey ? scope?.[childKey] : scope;
}
function $5501de4434b0643d$export$4ce908c3db28e57d() {
    const scope = this.call('getCanvasScope');
    return scope?.positions || {
        x: 0,
        y: 0,
        scale: 0.35
    };
}
// Zoom methods. When the canvas v2 surface is active these branch off
// to the v2 viewport pipeline so the existing outer chrome (shared
// Zoombar, command bar, etc.) drives v2 transparently.
// The math lives in functions/canvas/state.js `zoomAroundCenter` (one
// source — the panzoom shim's camera bridge and the Zoombar presets use the
// same function); this is the thin method-side entry.
function $5501de4434b0643d$var$v2ZoomAroundCenter(el, factor) {
    return el.call('zoomAroundCenter', factor);
}
function $5501de4434b0643d$export$89581f6adaadffac(targetNode, opts = {}) {
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance || !targetNode) return;
    const panzoom = scope.panzoomInstance;
    if (opts.useZoom) {
        const { x: x, y: y } = panzoom.getTransform();
        panzoom.zoomAbs(x, y, opts.zoom || 0.65);
    }
    setTimeout(()=>{
        const node = targetNode.node || targetNode;
        const { x: x, y: y, width: width, height: height } = node.getBoundingClientRect();
        const panToX = x - (window.innerWidth - width) / 2;
        const panToY = y - (window.innerHeight - height) / 2;
        panzoom.moveBy(-panToX, -panToY, true);
    }, 50);
}
function $5501de4434b0643d$export$3b71758b3ed5255f() {
    if (this.call('isCanvasV2')) return $5501de4434b0643d$var$v2ZoomAroundCenter(this, 1.25);
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance) return;
    const { x: x, y: y } = scope.positions;
    scope.panzoomInstance.smoothZoom(x + window.innerWidth / 2, y + window.innerHeight / 2, 1.25);
}
function $5501de4434b0643d$export$9fdb0a49c6b4b521() {
    if (this.call('isCanvasV2')) return $5501de4434b0643d$var$v2ZoomAroundCenter(this, 0.8);
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance) return;
    const { x: x, y: y } = scope.positions;
    scope.panzoomInstance.smoothZoom(x + window.innerWidth / 2, y + window.innerHeight / 2, 0.75);
}
function $5501de4434b0643d$export$4caffb2cc31472b8() {
    if (this.call('isCanvasV2')) return this.call('resetCanvasView');
    const scope = this.call('getCanvasScope');
    if (!scope?.panzoomInstance) return;
    const { x: x, y: y } = scope.positions;
    scope.panzoomInstance.smoothZoomAbs(x + window.innerWidth / 2, y + window.innerHeight / 2, 1);
}
function $5501de4434b0643d$export$deb0f277a5f91a79() {
    if (this.call('isCanvasV2')) return this.call('getCanvasV2')?.viewport?.scale || 0.35;
    const scope = this.call('getCanvasScope');
    return scope?.positions?.scale || 0.35;
}
function $5501de4434b0643d$export$dbd9a7c480819872(route) {
    const root = this.__ref?.root || this;
    const collection = root?.CanvasScene?.Collection;
    if (!collection?.node) return null;
    const key = route === '/' ? '/' : '/' + route.split('/').filter(Boolean)[0];
    const children = collection.node.children;
    for(let i = 0; i < children.length; i++){
        if (children[i].ref?.scope?.key === key) return children[i].ref;
    }
    return null;
}
function $5501de4434b0643d$export$4a86703d82697c4d(path) {
    const box = this.call('findBoxByRoute', path);
    if (box) this.call('zoomToNode', box);
}
function $5501de4434b0643d$export$b3cf2cec3f5ed87d(key) {
    const scope = this.call('getCanvasScope');
    if (!scope) return;
    if (key === null) {
        scope.hovered = null;
        scope.hoveredKey = null;
    } else {
        scope.hovered = this;
        scope.hoveredKey = typeof key === 'string' ? key : this.state?.key;
    }
}
function $5501de4434b0643d$export$a66ffb416fbd18ea(key) {
    if (this.call('isCanvasV2')) {
        if (key === null) this.call('clearSelection');
        else this.call('selectOne', typeof key === 'string' ? key : this.state?.key);
        return;
    }
    const scope = this.call('getCanvasScope');
    if (!scope) return;
    if (key === null) {
        scope.selected = null;
        scope.selectedKey = null;
    } else {
        scope.selected = this;
        scope.selectedKey = typeof key === 'string' ? key : this.state?.key;
    }
}
function $5501de4434b0643d$export$f22fe545e27b2961() {
    if (this.call('isCanvasV2')) {
        const key = this.call('getCanvasV2')?.selection?.primary;
        if (!key) return null;
        const items = this.getRoot?.()?.lookdown?.('CvItems');
        if (!items) return null;
        for (const child of Object.values(items)){
            if (child?.state?.key === key) return child;
        }
        return null;
    }
    const scope = this.call('getCanvasScope');
    return scope?.selected;
}
function $5501de4434b0643d$export$99686f672b41b384() {
    if (this.call('isCanvasV2')) return this.call('getCanvasV2')?.selection?.primary || null;
    const scope = this.call('getCanvasScope');
    return scope?.selectedKey;
}
function $5501de4434b0643d$export$43324cbd4b4cba08() {
    const scope = this.call('getCanvasScope');
    return scope?.hoveredKey;
}
// The shared chrome speaks the v1 mode names (inspectMode / panningMode
// / defaultMode). When v2 is active we map each to the v2 mode and also
// mirror the v1 flags on scope so any polling consumer stays in sync.
const $5501de4434b0643d$var$V1_TO_V2 = {
    inspectMode: 'inspect',
    panningMode: 'pan',
    defaultMode: 'default',
    interactMode: 'interact'
};
function $5501de4434b0643d$export$fbcd7ce4ca59b650(mode) {
    if (this.call('isCanvasV2')) {
        const target = $5501de4434b0643d$var$V1_TO_V2[mode];
        if (!target) return false;
        return this.call('getCanvasV2')?.mode === target;
    }
    const scope = this.call('getCanvasScope');
    return scope?.[mode] || false;
}
function $5501de4434b0643d$export$bc477a8a2570c1e9(mode) {
    if (this.call('isCanvasV2')) {
        const target = $5501de4434b0643d$var$V1_TO_V2[mode] || mode;
        this.call('setCanvasV2Mode', target);
        return;
    }
    const scope = this.call('getCanvasScope');
    if (!scope) return;
    scope.defaultMode = mode === 'defaultMode';
    scope.inspectMode = mode === 'inspectMode';
    scope.panningMode = mode === 'panningMode';
}
function $5501de4434b0643d$export$bcb7ebbe82ecdf67() {
    if (this.call('isCanvasV2')) this.call('toggleShortcutsOverlay');
}
function $5501de4434b0643d$export$8340954925d75c96(window1, arg) {
    if (this.call('isCanvasV2')) {
        if (window1 === 'explorer' && arg && typeof arg === 'string') {
            // `arg` may be a page/component key or `'search:<query>'`.
            if (arg === 'onboarding') {
                this.call('toggleShortcutsOverlay');
                return;
            }
            if (arg.startsWith('search:')) return;
            this.call('selectOne', arg);
            this.call('fitToSelection');
            this.call('clearSelection');
        }
        // In v2 canvas there is no code-editor or sidebar panel.
        // Map componentEditor requests to a fit-to-selection so the user gets
        // visual feedback (the artboard zooms into view) instead of a silent
        // no-op (#2244). The caller (CanvasContextMenu onChoose) calls
        // activateSelected(key) immediately after bridgeSetWindow — defer
        // fitToSelection one microtask so the selection is committed before we zoom.
        if (window1 === 'componentEditor') {
            const self = this;
            Promise.resolve().then(()=>{
                const key = self.call('getSelectedKey');
                if (key) self.call('fitToSelection');
            });
        }
    }
}
function $5501de4434b0643d$export$ad7df4c6f75ba82e(type, key) {
    if (this.call('isCanvasV2') && key) {
        this.call('selectOne', key);
        this.call('fitToSelection');
    }
}
function $5501de4434b0643d$export$c48afcb9c26cfd7c(type, key) {
    this.call('openArtboardItem', type, key);
}
function $5501de4434b0643d$export$804dea44282a09f2(key, type) {
    this.call('openArtboardItem', type, key);
}
function $5501de4434b0643d$export$3923011d0c791c1c(_key) {
/* no-op in v2 canvas */ }
function $5501de4434b0643d$export$59fa69fb8cfc0bb4(_kind) {
    if (this.call('isCanvasV2')) this.call('toggleCanvasSettings');
}
function $5501de4434b0643d$export$92486bdf26c5c038(ev, key) {
    if (!this.call('isCanvasV2')) return;
    this.call('canvasStageContextmenu', ev, key || this.call('getSelectedKey'));
}
function $5501de4434b0643d$export$8b93eb1f3d77688e(key) {
    if (!this.call('isCanvasV2')) return;
    const k = key || this.call('getSelectedKey');
    const root = this.state?.root || this.getRoot?.()?.state?.root;
    const vis = root?._cvVisibleIds;
    if (!k || !root?.update || !vis || !vis[k]) return;
    const without = {
        ...vis
    };
    delete without[k];
    root.update({
        _cvVisibleIds: without
    }, {
        preventFetch: true
    });
    const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (cb)=>setTimeout(cb, 16);
    raf(()=>{
        // Re-read live: the windowing recompute may have rewritten the set (and
        // possibly already re-added the key — the remount happened either way).
        const cur = root._cvVisibleIds || {};
        if (!cur[k]) root.update({
            _cvVisibleIds: {
                ...cur,
                [k]: 1
            }
        }, {
            preventFetch: true
        });
    });
}
function $5501de4434b0643d$export$f543642fc33c1018(target) {
    const doc = this.context?.document || document;
    const cur = doc.documentElement.getAttribute('data-theme') || 'dark';
    const next = target || (cur === 'dark' ? 'light' : 'dark');
    (0, $eY4Ct.changeGlobalTheme)(next, this.context?.designSystem);
    $5501de4434b0643d$var$canvasSyncCanvasBackgroundForTheme(next, doc);
}
function $5501de4434b0643d$export$110700823644f4a6(name, value) {
    try {
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=31536000`;
    } catch  {}
}
function $5501de4434b0643d$export$e93a7b09eae81752() {
    const root = this?.getRoot?.();
    const scene = root?.lookdown?.((el)=>el.key === 'CanvasScene');
    return scene?.Collection || scene;
}
function $5501de4434b0643d$export$3f7ee42101d00a54() {
    return null;
}
function $5501de4434b0643d$export$8d4cbe7c860e9433() {
    return null;
}
function $5501de4434b0643d$export$79a18e47a61c9942() {
    return null;
} // No getRootState / getRootContext here: both are FRAMEWORK element methods,
 // and a library copy is refused (WS-SHARED-METHODS-SHADOW-FRAMEWORK-ELEMENT-
 // METHODS-1; locked by packages/workspace/__tests__/
 // sharedLibraryMethodsDoNotShadowBuiltins.test.js).

});



parcelRegister("9c3uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b17f08f738443dc$export$2e2bcd8739ae039);
// Bare shared-library import (NOT a deep `.../functions/workspacePrefix.js`
// subpath) — a per-file deep specifier into @symbo-ls/workspace-shared (a
// restricted/private-registry package) cannot resolve through the platform's
// public importmap and threw an uncaught "Failed to resolve module
// specifier" that killed the entire workspace-shell catalog page (P0,
// tickets/catalog-fixall.md). The bare package root IS resolvable (same
// pattern already proven by sharedLibraries.js across every consumer).

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $gOQVi = parcelRequire("gOQVi");
parcelRequire("qJ3f5");
var $kuISg = parcelRequire("kuISg");
var $qJ3f5 = parcelRequire("qJ3f5");

var $jZ5ZE = parcelRequire("jZ5ZE");

var $79OEu = parcelRequire("79OEu");

var $7ytvD = parcelRequire("7ytvD");

var $984mC = parcelRequire("984mC");

var $ehZst = parcelRequire("ehZst");

var $9ocWj = parcelRequire("9ocWj");

var $gO4wS = parcelRequire("gO4wS");

var $8WfZd = parcelRequire("8WfZd");

var $dbWbc = parcelRequire("dbWbc");

var $lb2Ei = parcelRequire("lb2Ei");

var $2C7Li = parcelRequire("2C7Li");

var $ly0mS = parcelRequire("ly0mS");

var $hkFDz = parcelRequire("hkFDz");

var $5Vf2y = parcelRequire("5Vf2y");

var $dp7M8 = parcelRequire("dp7M8");

var $ik7KJ = parcelRequire("ik7KJ");

var $kosYS = parcelRequire("kosYS");

var $14aeZ = parcelRequire("14aeZ");

var $1nnHq = parcelRequire("1nnHq");

var $cKmtB = parcelRequire("cKmtB");

var $bShA0 = parcelRequire("bShA0");

var $hO9x8 = parcelRequire("hO9x8");

var $caKf8 = parcelRequire("caKf8");

var $iI0D7 = parcelRequire("iI0D7");

var $iJIxS = parcelRequire("iJIxS");

var $azpxa = parcelRequire("azpxa");

var $htRH6 = parcelRequire("htRH6");

var $fDn7k = parcelRequire("fDn7k");

var $4skhB = parcelRequire("4skhB");

var $debL2 = parcelRequire("debL2");
// Deferred-call wrappers, not a module-scope destructure — app.js is the
// entry point (nothing imports it), but Parcel's bundle execution order is
// not provably identical to ESM import order, and two OTHER "provably
// safe" files (functions/searchApps.js's VIEW_NAV, functions/
// externalData.js's stripWorkspacePrefix) already crashed the production
// build this exact way. No exceptions, per batch-2's own lesson.
const $6b17f08f738443dc$var$isGuestAllowedPath = (...args)=>(0, $1X0Je.default).functions.isGuestAllowedPath(...args);
const $6b17f08f738443dc$var$applyA11yPrefs = (...args)=>(0, $1X0Je.default).functions.applyA11yPrefs(...args);
const $6b17f08f738443dc$var$commAssistantMode = (...args)=>(0, $1X0Je.default).functions.commAssistantMode(...args);
const $6b17f08f738443dc$var$shellFeatureEnabled = (...args)=>(0, $1X0Je.default).functions.featureEnabled(...args);
const $6b17f08f738443dc$var$shellNavItemVisible = (...args)=>(0, $1X0Je.default).functions.navItemVisible(...args);
const $6b17f08f738443dc$var$shellIsMwtEnabled = (...args)=>(0, $1X0Je.default).functions.isMwtEnabled(...args);
const $6b17f08f738443dc$var$shellSyncWorkspaceUrl = (...args)=>(0, $1X0Je.default).functions.syncWorkspaceUrl(...args);
const $6b17f08f738443dc$var$shellSetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspacePointer(...args);
const $6b17f08f738443dc$var$findWorkspaceInOrg = (...args)=>(0, $1X0Je.default).functions.findWorkspaceInOrg(...args);
const $6b17f08f738443dc$var$moduleRoutesFromRoot = (...args)=>(0, $1X0Je.default).functions.moduleRoutesFromRoot(...args);
const $6b17f08f738443dc$var$shellWorkspaceApiBase = (...args)=>(0, $1X0Je.default).functions.workspaceApiBase(...args);
const $6b17f08f738443dc$var$shellIsModuleRoute = (...args)=>(0, $1X0Je.default).functions.isModuleRoute(...args);
const $6b17f08f738443dc$var$shellIsModuleCanvasRoute = (...args)=>(0, $1X0Je.default).functions.isModuleCanvasRoute(...args);
const $6b17f08f738443dc$var$syncPointerCapability = (...args)=>(0, $1X0Je.default).functions.syncPointerCapability(...args);
const $6b17f08f738443dc$var$getPref = (...args)=>(0, $1X0Je.default).functions.getPref(...args);
const $6b17f08f738443dc$var$workspaceSettingsOf = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
const $6b17f08f738443dc$var$registerWorkspaceHandleResolver = (...args)=>(0, $1X0Je.default).functions.registerWorkspaceHandleResolver(...args);
const $6b17f08f738443dc$var$shellGetWorkspacePrefixSlug = (...args)=>(0, $1X0Je.default).functions.getWorkspacePrefixSlug(...args);
// "the active workspace just became a FULL record" — the ONE event every
// workspace-change path funnels through (see the language-policy subscription
// in onCreate). Same call-time indirection as every shared read above: a
// module-scope read of a shared-library value publishes as a stub under frank.
const $6b17f08f738443dc$var$onActiveWorkspaceFull = (...args)=>(0, $1X0Je.default).functions.onActiveWorkspaceFull(...args);
// Deferred getters, NOT a module-scope destructure — proven necessary live
// (smbls push build failure: "Cannot destructure property 'appShellStyles'
// of '...default.components' as it is undefined", tickets/execution-
// board.md §1). app.js being the entry point does NOT make it safe: the
// same class of failure already hit two files reached only indirectly
// (functions/searchApps.js's VIEW_NAV, functions/externalData.js's
// stripWorkspacePrefix). shellApp below reads through these via per-key
// reactive CSS prop factories (called at render time, never at module
// scope) instead of a `...appShellStyles` spread.
const $6b17f08f738443dc$var$getOrgSwitcherInternals = ()=>(0, $1X0Je.default).components.__orgSwitcherInternals;
// Leave any MODULE route SYNCHRONOUSLY at tenant-switch entry, BEFORE the
// scoped-state wipe: module routes belong to the outgoing workspace's
// manifest, and a mounted module page re-rendering against the wiped (null)
// module bag can spin the renderer — observed live as a hard-frozen tab on
// an aihouse /users → greenig switch (2026-08-01). Home is the one safe,
// predictable parking spot for a tenant swap, and the hop happens behind
// the switch loader. Static intranet routes and canvas paths never bounce.
const $6b17f08f738443dc$var$_leaveModuleRouteForSwitch = (el, s, oldModuleRoutes)=>{
    try {
        const win = typeof window !== 'undefined' ? window : null;
        if (!win?.location) return;
        const pathOnly = (0, $7iFOV.shellStripWorkspacePrefix)(win.location.pathname || '/').split(/[?#]/)[0];
        if (pathOnly === '/' || !$6b17f08f738443dc$var$shellIsModuleRoute(pathOnly, oldModuleRoutes)) return;
        el.router((0, $iJIxS.withLiveQuery)('/'), el);
    } catch (err) {
        console.warn('[shell] module-route leave failed:', err?.message || err);
    }
};
const $6b17f08f738443dc$var$NOTIF_POLL_MS = 300000;
// CALL-INVITATION (tickets/fable.md) — cadence for the CallInvitationBanner
// self-expire nudge (`_meetingInviteTick`, wired in onCreate below). 30s
// keeps a stale "meeting ended" banner from lingering more than half a
// minute past its own endAt without adding real timer pressure.
const $6b17f08f738443dc$var$MEETING_INVITE_TICK_MS = 30000;
// Every top-row island AppHeader can render — HeaderLeft included. It used to
// be excluded here: a stale "HeaderLeft is a vertical side rail on tablet"
// rationale that no longer applies (that mode is fully retired — see
// AppHeader.js HeaderLeft, no tabletS flex-direction override remains).
// Primarily a @tabletS (769–1024px) concern now — see
// _measureHeaderNavClear below, which bypasses this array entirely at
// @mobileL in favor of measuring the merged "one deck" header's own rect —
// but excluding HeaderLeft was ALSO the direct cause of the pre-fix phone
// under-measurement this array existed to prevent (live-measured 62.6px
// header bottom vs a 43px --nav-clear) before the @mobileL bypass existed,
// so it stays included for @tabletS correctness (HeaderLeft can still be the
// tallest of the four floating islands there).
const $6b17f08f738443dc$var$HEADER_TOP_ISLAND_KEYS = [
    'HeaderLeft',
    'HeaderSearch',
    'HeaderTabs',
    'HeaderRight'
];
// Live-call count for the NewCall "ongoing call" badge: rooms in THIS workspace
// still open (no endedAt), that I'm not already in (activeRoomId), with at least
// one still-connected participant who isn't me. Derives from the shell-level meet
// realtime (root.rooms + root.liveParticipants) and self-clears as those update.
// `currentUserSupabaseId` is the participant id-space (auth uuid, not the Mongo id).
const $6b17f08f738443dc$var$_liveCallCount = (root)=>{
    const rooms = root?.rooms || [];
    const live = root?.liveParticipants || {};
    const activeRoomId = root?.activeRoomId;
    const me = root?.currentUserSupabaseId;
    return rooms.filter((r)=>r && !r.endedAt && r.id !== activeRoomId && (live[r.id] || []).some((p)=>!p.leftAt && p.userId !== me)).length;
};
// Shell DOMQL — AppHeader + smbls-default content + TranslationWatcher.
//
// AppHeader: persistent top header. Hidden on auth routes via `hide:`.
// content: smbls router renders the matched page here automatically —
//   no explicit Slot element needed. The default router places content
//   as row 2 (1fr) in the AppShell grid.
// TranslationWatcher: hidden i18n subscription (position:fixed, no grid row).
//
// AppShell grid (from appShellStyles):
//   gridTemplateRows: 'auto 1fr'
//   AppHeader → row 1 (auto). smbls content → row 2 (1fr, fills viewport).
//   When AppHeader is hidden (display:none on auth routes) it leaves the
//   grid — content expands to fill the full viewport automatically.
// Derived from the canonical guest-only route list (functions/auth.js
// AUTH_PATHS) so this shell gate (header hide + route-kind classification)
// can't drift from the redirect logic. `(\/|$)` boundary matches an exact
// auth path or a sub-path, same regex as before.
// ── Live-measured CSS-var maintenance ────────────────────────────────────
// One recipe for every "pin a chrome edge into a :root var" need (--nav-clear
// from the AppHeader, --prompt-clear from the composer): a ResizeObserver on
// the element + a window-resize re-apply + a post-mount settle pass, writing
// documentElement ONLY when the value changed (a same-value setProperty still
// risks recalc on some engines, and a changed write invalidates every
// var() consumer). Extracted 2026-07-12 (/simplify): the two inline copies had
// already diverged — one had the settle machinery, the other did not.
// Per-workspace stage colour writer (chrome.stage → --stage-bg on <html>).
// SAME pattern as _trackClearVar below and for the SAME reason: root-level
// element props do NOT re-evaluate when late root state (workspaceProject)
// lands — a background factory on shellApp painted its boot-time value
// forever (measured live 2026-08-16: stage "#F2EDE3" present in state,
// shell root still rgba(0,0,0,0)). The var IS the reactivity: this writer
// runs on every ModuleRailHost render/update (subscribeTo workspaceProject,
// and `hide` keeps that node mounted), and every ground references the
// var statically through ONE chain — `var(--stage-bg, var(--color-stage))`
// (shared/functions/canvasBackground.js STAGE_BACKGROUND; BF-WIDGET-INK-1).
// A workspace with no chrome.stage REMOVES the property, so every ground
// falls back to the design-system `stage` token together — root, content
// host, home page/board and canvas Stages can no longer disagree, because
// none of them holds a value of its own.
// ── Module rail geometry predicates (ONE definition each — the class
// factories, the chrome-inset negation and the `railFlush` prop the mounted
// rail receives all read these; a second copy of "is the rail on the edge"
// is exactly the duplicated-precedence drift this shell has paid for
// before). Edge state = the PageSlot's own isSlotFullscreen decision:
// immersive members, or an admin's edge-to-edge toggle.
const $6b17f08f738443dc$var$_railEdgeState = (root)=>(0, $7ytvD.moduleImmersiveActive)(root) && (0, $7ytvD.slotFullscreenActive)(root) || root?._slotFullscreen === true;
// Flush = the manifest opted in (chrome.railEdge) AND the host really runs
// the edge state now. Bellforge's BfNav drops its corner radius on this
// prop (bellforge-ui lane, 2026-09-02) — the rail renders inside the
// module's state scope and cannot see shell root keys itself.
const $6b17f08f738443dc$var$_railFlush = (root)=>(0, $7ytvD.moduleRailEdge)(root) && $6b17f08f738443dc$var$_railEdgeState(root);
// THE PHONE DRAWER. On a phone with the dock (functions/phoneNavigation.js —
// a workspace, no immersive chrome) the rail stops being a column beside the
// page: it leaves the screen and opens OVER the page from the dock's Page
// button (`_moduleRailOpen`), so it never insets the page (--module-rail-clear
// reads 0) and never covers it at rest. Immersive members keep the column —
// the rail IS their chrome there, and no dock exists to open a drawer.
const $6b17f08f738443dc$var$_moduleRailDrawer = (root)=>root?._isPhoneViewport === true && !!root.workspace && !(0, $7ytvD.moduleImmersiveActive)(root);
const $6b17f08f738443dc$var$_moduleRailDrawerShut = (root)=>$6b17f08f738443dc$var$_moduleRailDrawer(root) && !root._moduleRailOpen;
// Push a CHANGED flush value to the mounted rail (Body.content — the
// element `elm.set(def)` created). Runs on every host render/update; the
// host already subscribes to the keys that flip the edge state
// (_slotFullscreen, workspaceProject, currentPath…). Same-value calls
// return early so the rail never re-renders for nothing.
const $6b17f08f738443dc$var$_pushRailFlush = (el, s)=>{
    const flush = $6b17f08f738443dc$var$_railFlush(s.root);
    if (el.__railFlush === flush) return;
    el.__railFlush = flush;
    const rail = el.Body && el.Body.content;
    if (rail && typeof rail.update === 'function') try {
        rail.update({
            railFlush: flush
        }, {
            preventFetch: true
        });
    } catch (_) {
    /* rail not mounted yet — the mount def carries the current value */ }
};
const $6b17f08f738443dc$var$_setStageVar = (el, s)=>{
    if (typeof document === 'undefined') return;
    // Var half delegated to the shared writer (workspaceProjects.applyStageVar)
    // so this render-path write and the settle-point repairs can never drift.
    (0, $7ytvD.applyStageVar)(s?.root);
    // ALSO paint the shell root node inline — with the CHAIN, never a colour.
    // The declared background on shellApp loses to its `theme: 'document'`
    // class rule (measured 2026-08-16: computed rgb(10,10,10) in dark / white
    // in light over the var() declaration — that surface is exactly the
    // "black behind the sidebar" and the white after a theme flip). An inline
    // style wins over the theme's class rule with no !important; the chain is
    // theme-agnostic (var() re-resolves on every flip), so writing it once is
    // canvasBackground.js rule 1 compliant, and it never has to be cleared:
    // the ground is ALWAYS the stage — the module override or the token.
    const CHAIN = 'var(--stage-bg, var(--color-stage))';
    const rootEl = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
    const node = rootEl && rootEl.node;
    if (node && node.style && node.style.background !== CHAIN) node.style.background = CHAIN;
    // The router's `content` host paints the THEME's page surface over the
    // root (measured rgb(69,69,75) between the beige root and the page
    // cards) — so the stage was visible only in the rail strip, never on
    // home/studio/tickets. Same chain, same reason.
    const contentEl = rootEl && rootEl.content;
    const contentNode = contentEl && contentEl.node;
    if (contentNode && contentNode.style && contentNode.style.background !== CHAIN) contentNode.style.background = CHAIN;
};
const $6b17f08f738443dc$var$_stopClearVar = (el, flag)=>{
    // Invalidate queued deliveries before disconnecting: an observer callback
    // already in the delivery queue must not read a removed/replacement node.
    el[flag + 'Apply'] = null;
    el[flag]?.disconnect();
    if (el[flag + 'Frame'] != null) cancelAnimationFrame(el[flag + 'Frame']);
    if (el[flag + 'Timer'] != null) clearTimeout(el[flag + 'Timer']);
    el[flag] = null;
    el[flag + 'Node'] = null;
    el[flag + 'Frame'] = null;
    el[flag + 'Timer'] = null;
    el[flag + 'Last'] = null;
    el[flag + 'ExtraLast'] = null;
};
// A SECOND variable measured off the same observer (`extra` of _trackClearVar:
// { varName, measure(rect, el) }), deduped on its own last value. Written
// BEFORE the primary, so the primary stays the newest write of every pass.
const $6b17f08f738443dc$var$_writeClearExtra = (el, flag, varName, value)=>{
    if (el[flag + 'ExtraLast'] === value) return;
    el[flag + 'ExtraLast'] = value;
    document.documentElement.style.setProperty(varName, value);
};
// The composer's width for the island docked above it — the resting pill only
// (null = keep the last value while the composer is expanded, like
// --prompt-clear).
const $6b17f08f738443dc$var$_PROMPT_WIDTH = {
    varName: '--prompt-w',
    measure: (r, el)=>el.state && el.state.size && el.state.size !== 'small' ? null : r.width
};
// THE COMPOSER'S STACK TOP — the resting pill, or the highest row DOCKED on it
// while one shows: the thread chips and the attached context (the shell mount's
// PromptBand). The band stands above the pill (absolute, `bottom: 100%`), so
// the pill's own top counted none of its rows, and every --slot-bottom
// consumer ended under them (fly-onboarding, ai-nino 2026-10-28: the saved
// board's name chip covered the board's last cards; the composer read 43px
// with the chips up). Never the AI island (it paints on focus only and stays
// laid out while it is invisible) nor a draft's image thumbs above it.
const $6b17f08f738443dc$var$_COMPOSER_DOCKED_ROWS = [
    'AssistantThreadChips',
    'AiContextBar'
];
const $6b17f08f738443dc$var$_composerStackTop = (el, r)=>{
    const band = el.PromptBand || {};
    let top = r.top;
    for (const key of $6b17f08f738443dc$var$_COMPOSER_DOCKED_ROWS){
        const node = band[key] && band[key].node;
        if (!node || typeof node.getBoundingClientRect !== 'function') continue;
        const row = node.getBoundingClientRect();
        if (row.height > 0 && row.top < top) top = row.top;
    }
    return top;
};
const $6b17f08f738443dc$var$_settleClearVar = (el, flag)=>{
    const apply = el[flag + 'Apply'];
    if (!apply) return;
    // Preserve the immediate measurement and both settle opportunities, while
    // bounding boot/update storms to one pending callback of each kind.
    if (el[flag + 'Frame'] == null) el[flag + 'Frame'] = requestAnimationFrame(()=>{
        if (el[flag + 'Apply'] !== apply) return;
        el[flag + 'Frame'] = null;
        apply();
    });
    // Follow the LAST render: a position-only transition can finish after the
    // first render's deadline without emitting a ResizeObserver size change.
    if (el[flag + 'Timer'] != null) clearTimeout(el[flag + 'Timer']);
    el[flag + 'Timer'] = setTimeout(()=>{
        if (el[flag + 'Apply'] !== apply) return;
        el[flag + 'Timer'] = null;
        apply();
    }, 300);
};
// An island's top edge from the viewport bottom (a bottom-docked island's
// clearance).
const $6b17f08f738443dc$var$_clearFromTop = (r)=>window.innerHeight - r.top;
// `watch` (optional): one more node the same observer watches — a size change
// there re-measures too (the composer's band: a row docked on the pill grows
// the band, never the pill).
const $6b17f08f738443dc$var$_trackClearVar = (el, flag, varName, measure, extra, watch)=>{
    if (typeof ResizeObserver === 'undefined' || !el.node) return;
    // Re-arm on node identity change. Boot storms and hide-cycles can
    // RE-CREATE the element's DOM node; the old one-shot guard left the
    // ResizeObserver watching the dead node, which never resizes again — so
    // the var froze at its last write (measured live 2026-08-14: rail
    // rendered 273px wide with --module-rail-clear stuck at 0px, whole-shell
    // inset lost until a window resize happened to re-fire apply). Same-node
    // calls RE-MEASURE instead of returning: RO delivery around a
    // hidden→visible flip mid-boot-storm proved unreliable in practice
    // (observer verified armed on the live laid-out node, callback never
    // fired), so every lifecycle touch runs the value-deduped apply as the
    // guaranteed path — RO stays as the size-change fast path. Window resize
    // is owned by each component's onWindowResize lifecycle prop.
    if (el[flag] && el[flag + 'Node'] === el.node) {
        const reapply = el[flag + 'Apply'];
        if (reapply) {
            reapply();
            $6b17f08f738443dc$var$_settleClearVar(el, flag);
        }
        return;
    }
    $6b17f08f738443dc$var$_stopClearVar(el, flag);
    el[flag + 'Node'] = el.node;
    el[flag + 'Last'] = null;
    el[flag + 'ExtraLast'] = null;
    const apply = ()=>{
        if (el[flag + 'Apply'] !== apply || !el.node) return;
        const r = el.node.getBoundingClientRect();
        if (!r.height) {
            // Distinguish "not laid out yet" (keep the last value — the settle
            // pass will re-measure) from "chrome HIDDEN" (hide: → display:none):
            // a hidden chrome edge must ZERO its var, or content stays inset
            // below a navbar that no longer exists (immersive module chrome,
            // auth routes). Guarded on computed display so pre-layout zero-rects
            // never write.
            let hidden = false;
            try {
                hidden = el.node.isConnected && getComputedStyle(el.node).display === 'none';
            } catch (_) {}
            if (!hidden) return;
            if (extra) $6b17f08f738443dc$var$_writeClearExtra(el, flag, extra.varName, '0px');
            if (el[flag + 'Last'] === '0px') return;
            el[flag + 'Last'] = '0px';
            document.documentElement.style.setProperty(varName, '0px');
            return;
        }
        if (extra) {
            const more = extra.measure(r, el);
            if (more !== null && more !== undefined) $6b17f08f738443dc$var$_writeClearExtra(el, flag, extra.varName, Math.round(more) + 'px');
        }
        const measured = measure(r);
        // `null` = "not a measurable state right now, keep the last value"
        // (the composer's expanded overlay — see its onRender).
        if (measured === null || measured === undefined) return;
        const v = Math.round(measured) + 'px';
        if (el[flag + 'Last'] === v) return;
        el[flag + 'Last'] = v;
        document.documentElement.style.setProperty(varName, v);
    };
    el[flag + 'Apply'] = apply;
    el[flag] = new ResizeObserver(apply);
    el[flag].observe(el.node);
    if (watch) el[flag].observe(watch);
    // The window-resize half is DECLARED by each of the three callers as
    // `onWindowResize: (e, el) => el._<flag>Apply?.()`. It used to be a raw
    // `window.addEventListener('resize', apply)` here behind an
    // `el[flag + 'Win']` latch, removed nowhere (FA503) — one permanent window
    // listener per element, each holding a closure over that element for the
    // life of the tab. Reading through `el[flag + 'Apply']` keeps the original
    // property that made the latch safe: `apply` reads `el.node` LIVE, so a
    // re-arm on a new node re-points the SAME declared handler.
    // Settle pass — fonts/layout can shift the rect just after mount.
    $6b17f08f738443dc$var$_settleClearVar(el, flag);
    apply();
};
// Below @tabletS (desktop, incl. 1440px) this ALWAYS returns fallbackRect.bottom
// (the early return right below) — HEADER_TOP_ISLAND_KEYS is never even read at
// those widths, so including/excluding HeaderLeft there cannot change the
// desktop measurement; no extra phone-width gate needed on top of this one.
//
// At @tabletS (769–1024px), AppHeader's islands are still separate floating
// pills that can render TALLER than the header's own naive box in ways a
// single fallbackRect doesn't capture — so measure each visible top-row
// island's own bottom edge and take the max there, rather than trusting one
// bounding rect.
//
// At @mobileL (≤768px) the "one deck" merge (AppHeader.js) makes this
// unnecessary AND less accurate: every island is now vertically CENTERED
// inside ONE uniform-height box with its own top/bottom padding, so the
// tallest CHILD's bottom edge sits *above* the deck's own visual bottom by
// that padding amount — measured live, the per-child max read 39px against
// the deck's real 44.5px bottom. The deck's own fallbackRect IS the accurate
// boundary here, exactly like the desktop case above.
const $6b17f08f738443dc$var$_measureHeaderNavClear = (el, fallbackRect)=>{
    if (typeof window === 'undefined') return fallbackRect.bottom;
    // A navbar moved off the top (a rail or a bottom bar — shared
    // functions/navbarLayout.js) leaves no navbar to clear at the top: 0, and
    // the injected sheet's place rules set the top clearances to the edge gap.
    if ($6b17f08f738443dc$var$_navPlace(el) !== 'top') return 0;
    // @mobileL keeps the deck's own rect (see the note above). Every WIDER
    // width now measures the ISLANDS' real bottom edge, desktop included:
    // the old desktop early-return trusted the mount box (48px), but the
    // floating islands END ~5px above it (measured 43.1px, 2026-09-01) —
    // the row's empty remainder inflated the PageSlot's top gap to ~15px
    // while the composer-side gap (same --nav-gap) stayed 10px. Nika:
    // "make top space between pageslot and top navs same as the bottom one."
    if (window.matchMedia((0, $debL2.default).mobileL).matches) return fallbackRect.bottom;
    const topIslandBottoms = $6b17f08f738443dc$var$HEADER_TOP_ISLAND_KEYS.map((key)=>el.node?.querySelector(`:scope > [data-key="${key}"]`)).filter((node)=>node && window.getComputedStyle(node).display !== 'none').map((node)=>node.getBoundingClientRect()).filter((rect)=>rect.width > 0 && rect.height > 0).map((rect)=>rect.bottom);
    return topIslandBottoms.length ? Math.max(...topIslandBottoms) : fallbackRect.bottom;
};
// Where the person put the navbar (shared functions/navbarLayout.js — 'top'
// on a phone and on a host without the look). Read through the registered
// function so the factories that call it subscribe to the look keys.
const $6b17f08f738443dc$var$_navPlace = (el)=>{
    const nav = el && typeof el.call === 'function' ? el.call('navbarLayoutRead', el.state && el.state.root) : null;
    return nav && nav.position || 'top';
};
// --nav-edge: how far the navbar reaches in from ITS OWN screen edge — a
// rail's far side (left: its right edge; right: the viewport width less its
// left edge), a bottom bar's islands' top from the viewport bottom; 0 at the
// top (--nav-clear measures that one). The injected sheet adds --nav-gap to
// make the frame's inset on that side (--nav-inset-left/right/bottom). A
// rail IS the header box (the shared rail rules zero its padding); at the
// bottom the box keeps its X2 padding, so the islands' own tops are read, as
// _measureHeaderNavClear reads their bottoms at the top.
const $6b17f08f738443dc$var$_measureHeaderNavEdge = (el, r)=>{
    if (typeof window === 'undefined') return 0;
    const place = $6b17f08f738443dc$var$_navPlace(el);
    let edge = 0;
    if (place === 'left') edge = r.right;
    else if (place === 'right') edge = window.innerWidth - r.left;
    else if (place === 'bottom') {
        const islandTops = $6b17f08f738443dc$var$HEADER_TOP_ISLAND_KEYS.map((key)=>el.node?.querySelector(`:scope > [data-key="${key}"]`)).filter((node)=>node && window.getComputedStyle(node).display !== 'none').map((node)=>node.getBoundingClientRect()).filter((rect)=>rect.width > 0 && rect.height > 0).map((rect)=>rect.top);
        edge = window.innerHeight - (islandTops.length ? Math.min(...islandTops) : r.top);
    }
    $6b17f08f738443dc$var$_composerFollowsNavEdge(el, Math.round(edge));
    return edge;
};
// The composer sits on a bottom bar (the injected sheet lifts it by
// --nav-inset-bottom) and drops back when the bar leaves — a position change,
// which fires no ResizeObserver, so its --prompt-clear (the foot of the
// PageSlot and of every sheet) kept the old place (measured on dev 68d0bfe57:
// the composer at 92px from the bottom, --prompt-clear still 45px, the open
// window under it). When this edge changes, the composer — a sibling mount on
// the shell root — re-measures once the new value has landed: its own
// tracker, then its settle passes.
const $6b17f08f738443dc$var$_composerFollowsNavEdge = (el, edge)=>{
    if (el.__navEdgeSeen === edge) return;
    el.__navEdgeSeen = edge;
    const composer = el.parent && el.parent.CanvasPromptTextarea;
    if (!composer || typeof requestAnimationFrame === 'undefined') return;
    requestAnimationFrame(()=>{
        if (typeof composer._pcObsApply !== 'function') return;
        composer._pcObsApply();
        $6b17f08f738443dc$var$_settleClearVar(composer, '_pcObs');
    });
};
const $6b17f08f738443dc$export$8b0815123dda44b2 = (root)=>{
    if (!root) return false;
    const path = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
    const slug = $6b17f08f738443dc$var$shellGetWorkspacePrefixSlug(path) || (0, $2C7Li.urlOrgSlug)(path, root);
    if (!slug) return false;
    // YOUR OWN NAMESPACE IS NEVER FOREIGN — checked BEFORE the `orgs` scan
    // (2026-09-02 per Nika "orgs is failing to load and it just shows
    // 'Organization' in orgswitcher without dropdown").
    //
    // `root.orgs` lists TEAM organizations only; a user's personal namespace
    // is never a member of it. Measured live on my.symbols.app at
    // /w/nikoloza/ws_603boj34rdryhf/studio: root.orgs held 13 orgs, every one
    // type 'team' (gita, fractyco, bellforge, … system), while the URL slug and
    // root.org.slug were both 'nikoloza'. The scan below therefore found no
    // match and declared the user's OWN workspace foreign, which neutralized
    // the switcher — bare "Organization", no dropdown, on every personal-
    // namespace URL. It read as "orgs failed to load" but the orgs were
    // loaded; only the membership test was wrong.
    const own = root.org;
    if (own && (own.slug === slug || own.username === slug)) return false;
    if (slug && slug === root.currentUserUsername) return false;
    // Orgs list not loaded yet — unknown, not foreign. Never flag on a guess.
    if (!Array.isArray(root.orgs) || !root.orgs.length) return false;
    // Same rule for a list we cannot match against: a claims-minted `orgs` row
    // can arrive with NO `slug`/`username` (personal orgs are dropped at JWT
    // mint time, and a token-decoded session carries no Mongo `organizations`
    // at all). Matching a slug against rows that have none is a guaranteed
    // miss, which would neutralize the switcher for a org the user really is
    // in. Only a list with at least one matchable row can prove foreignness.
    if (!root.orgs.some((o)=>o && (o.slug || o.username))) return false;
    return !root.orgs.some((o)=>o && (o.slug === slug || o.username === slug));
};
// Shared gate for BOTH AppOrgSwitcher mounts' demo + foreign-URL lockdown —
// see the HeaderLeft/HeaderRight override comments below for the full
// reasoning. One function so the two mounts (+ their aria-label/Label
// siblings) can never drift on which condition neutralizes the switcher.
const $6b17f08f738443dc$var$_neutralizeOrgSwitcher = (root)=>!!root?.isDemo || $6b17f08f738443dc$export$8b0815123dda44b2(root);
// Returns a bundle KEY; the two mount sites below resolve it. This shell
// OVERRIDES the shared AppOrgSwitcher.Trigger's own `aria-label`, so
// translating the shared component alone changed nothing on screen (measured
// live on the natali board, 2026-09-03: the trigger still read "Switch
// organization" inside a fully Georgian session).
const $6b17f08f738443dc$var$_orgSwitcherAriaLabel = (root)=>{
    if (root?.isDemo) return 'shell.orgSwitcher.ariaDemo';
    if ($6b17f08f738443dc$export$8b0815123dda44b2(root)) return 'shell.orgSwitcher.ariaForeign';
    return 'shell.orgSwitcher.switchAria';
};
// Visible Trigger label. Demo keeps showing the (single, real) demo org's
// name — that org genuinely IS the active session, nothing to hide. The
// foreign-URL case is different: `root.org` is YOUR org, not the URL's, so
// showing its name would just relocate the lie from "switchable" to
// "read-only" — swap to the shared component's own generic "no org
// resolved" fallback instead (same word it already shows itself before an
// active org resolves), never a real org name from either party.
// The generic word is the shared component's own bundle key
// (`shell.orgSwitcher.orgLabel`), so the trigger reads "ორგანიზაცია" on a
// Georgian board where it read the English word "Organization".
const $6b17f08f738443dc$var$_orgSwitcherLabel = (el, root)=>{
    const generic = ()=>el.call('polyglot', 'shell.orgSwitcher.orgLabel');
    if ($6b17f08f738443dc$export$8b0815123dda44b2(root)) return generic();
    return $6b17f08f738443dc$var$getOrgSwitcherInternals().activeOrg(root)?.name || generic();
};
// Matches the dashboard canvas surfaces — /studio AND the /canvas
// duplicate (2026-06-09) — so both get the 'canvas' route-kind (no app
// header-offset, header is a full-bleed overlay) and surface the Zoombar.
const $6b17f08f738443dc$var$_isStudioCanvasPath = (p)=>/^\/(studio|canvas)(\/|$)/.test(p || '');
// /files is a full-bleed desktop canvas too — same 'canvas' route-kind so the
// AppHeader stays a pure overlay and the desktop fills the whole viewport.
const $6b17f08f738443dc$var$_isFilesCanvasPath = (p)=>/^\/files(\/|$)/.test((0, $7iFOV.shellStripWorkspacePrefix)(p || ''));
// /tickets board is a full-bleed pan/zoom canvas too (2026-06-10 per Nika
// "make tickets canvas fullscreen and header absolute, just like /studio").
// BOTH board routes — /tickets AND its /tickets/board alias map to the same
// canvas page (pages/index.js), so both must classify 'canvas'; the exact
// `=== '/tickets'` match left /tickets/board on the 'app' kind and the whole
// canvas shifted 48px below the header (2026-07-25 per Nika "content on
// /tickets page has a padding top"). Query/hash stripped for the same reason
// — a currentPath carrying ?drafts=1 must still match. Other /tickets/*
// subpages (feed, epics, …) stay 'app'.
const $6b17f08f738443dc$var$_isTicketsCanvasPath = (p)=>{
    const path = (0, $7iFOV.shellStripWorkspacePrefix)(p || '').split(/[?#]/)[0];
    return path === '/tickets' || path === '/tickets/board' || path === '/tasks' || path === '/tasks/board';
};
// /team-and-agents (+ /my-agents lens) is a pan/zoom canvas too — surfaces
// the Zoombar there (2026-06-10 per Nika "make /team canvas similar to
// /studio"); its page mirrors the panzoom into __canvasGlobalScope.
const $6b17f08f738443dc$var$_isTeamCanvasPath = (p)=>/^\/(team-and-agents|agents|my-agents)(\/|$)/.test((0, $7iFOV.shellStripWorkspacePrefix)(p || ''));
// /infra is the full-bleed Railway-style deployment canvas — same 'canvas'
// route-kind so the AppHeader stays a pure overlay (no 48px offset).
const $6b17f08f738443dc$var$_isInfraCanvasPath = (p)=>(0, $7iFOV.shellStripWorkspacePrefix)(p || '') === '/infra';
// An installed module's CANVAS page (its manifest `canvasRoutes`, e.g. the
// validators app's /validators/intel) — the same 'canvas' route-kind and the
// root Zoombar, which drives the instance the page registers
// (canvas/functions/registerCanvasPanzoom.js). Only routes the module serves.
const $6b17f08f738443dc$var$_isModuleCanvasPath = (p, root)=>$6b17f08f738443dc$var$shellIsModuleCanvasRoute((0, $7iFOV.shellStripWorkspacePrefix)(p || '').split(/[?#]/)[0], root);
// SINGLE open path for the composer's model menu — shared by ModelBtn's click
// AND its ArrowDown/ArrowUp keyboard open (2026-09-02 keyboard-navigation
// pass), so the two modalities can never drift the way a copied openDropdown
// call would. Geometry matches THE AI menu system (AiMenu.js AiMenuPanel):
// minWidth G / radiusCard / 60vh cap — the same shape as the ParamsBtn
// dropdown and the assistant's inline panels.
const $6b17f08f738443dc$var$_openAiModelDropdown = (el)=>{
    // Refresh live per-provider diagnostics on open — cheap + best-effort (the
    // same contract as the assistant header trigger).
    try {
        el.call('fetchAiProviderDiagnostics');
    } catch (_) {}
    el.call('openDropdown', {
        id: 'aiModel',
        anchorEl: el,
        placement: 'top-end',
        minWidth: 'G',
        maxHeight: '60vh',
        round: 'radiusCard',
        // Shell paint opt-in — AiModelSwitcherBody paints no card of its own; the
        // plugin Panel is chromeless by default
        // (FW-DROPDOWN-PANEL-STALE-SHELL-PAINT-1).
        theme: 'canvas-card-glass',
        shadow: 'overlay',
        content: {
            extends: 'AiModelSwitcherBody',
            padding: 'Z'
        }
    });
};
// SINGLE SOURCE for "is the global AI composer visible right now" — shared by
// the CanvasPromptTextarea hide factory AND _syncShellRoute's <html
// data-prompt> mirror (the latter drives the app-page bottom-padding CSS
// rule below), so the two can never drift. `path` is the RAW (unstripped)
// currentPath — this strips it itself, matching what the hide factory always
// passed in. `el` is only used to resolve `el.context.methods.isActiveMember`
// (an el.call-style function-lookup, not a component `s`) — both call sites
// have an element handy (the factory's own `el`, _syncShellRoute's own `el`
// param), so this needed no new plumbing. `{ root }` reconstructs the shape
// isActiveMember expects (`s.root`) since neither caller holds a real
// component state object here.
//
// Two halves: `_composerAllowed` answers "may this route compose at all", and
// `_composerVisible` adds the phone dock's park — on a phone viewport with a
// workspace the composer waits behind the dock's AI button
// (functions/phoneNavigation.js phoneNavigationAssistant) until the member
// opens it. The dock asks the ALLOWED half, so the park never hides the very
// button that lifts it, and the hide factory and the <html data-prompt> mirror
// keep asking the visible half — one answer, no stylesheet override beside it.
//
// A composer that HOSTS a voice call (the in-composer call strip, root.voiceHost
// 'canvas') is never parked: the strip is the call's only surface, and parking
// it left a live microphone with nothing on screen to show or end it.
const $6b17f08f738443dc$var$_composerVisible = (root, path, el)=>$6b17f08f738443dc$var$_composerAllowed(root, path, el) && !(root?._isPhoneViewport === true && root.workspace && !root._phoneComposerOpen && !(root.voiceOpen && root.voiceHost === 'canvas'));
const $6b17f08f738443dc$var$_composerAllowed = (root, path, el)=>{
    if (!$6b17f08f738443dc$var$shellFeatureEnabled(root, 'aiAssistant') || !$6b17f08f738443dc$var$shellFeatureEnabled(root, 'aiAssistant.composer')) return false;
    // Immersive module chrome (manifest `chrome.immersive`) hides the bottom
    // prompt bar along with the header — the module owns the whole viewport
    // for these members. Same gate AppHeader/presence dock use.
    if ((0, $7ytvD.moduleImmersiveActive)(root)) return false;
    // A module page that shows its OWN composer asked the shell to hide this
    // one (el.call('setShellComposer', false) — functions/moduleShellComposer.js).
    // The latch is route-bound: it reads false the moment the member leaves
    // that page or the pane that hosts it, so it can never leak to another
    // page or module. Header and every other chrome stay as they are.
    if ((0, $984mC.moduleComposerHiddenLive)(root)) return false;
    const p = (0, $7iFOV.shellStripWorkspacePrefix)(path || (typeof window !== 'undefined' ? window.location.pathname : '/'));
    if ((0, $kuISg.isChromelessShellPath)(p) || p === '/add-app' || p === '/chat') return false;
    // THE HOME'S BUILD TAB is the app builder — the /add-app page on the home
    // (functions/homeBuild.js; Nika 2026-10-23: "build tab should reuse ui/ux of
    // /add-apps"): its own conversation composer is the prompt there, as on
    // /add-app, so this one stands down while the tab shows (and the phone
    // dock's AI button opens the sidebar instead — PhoneNavigation canCompose).
    const buildShown = el?.context?.functions?.homeBuildShown;
    if (typeof buildShown === 'function' && el.call('homeBuildShown', root)) return false;
    // /meet-guest stays hidden: anonymous guests have no workspace AI.
    if (p === '/meet-guest') return false;
    // While the assistant drawer's composer hosts the voice strip
    // (voiceHost === 'chat'), the global bottom prompt is a redundant second
    // prompt beside the very surface running the conversation — the residual
    // the voice⟷chat exclusivity wave (bee2f26c) flagged for this predicate.
    if (root?.voiceOpen && root?.voiceHost === 'chat') return false;
    // AIUX-CHROME item 3 (tickets/sonnet.md, live-verified 2026-08-13) — the
    // AssistantDrawer (below, `hide: !assistantOpen || assistantDock ===
    // 'minimized'`) has its OWN "Describe a change…" composer; without this
    // check the global "What's up?" bar stayed visible underneath it too — two
    // prompt inputs on screen at once. Mirrors the drawer's own visibility
    // predicate exactly (inverse), so the two can never show together or both
    // hide together.
    if (root?.assistantOpen && root?.assistantDock !== 'minimized') return false;
    // Members only — same gate the header actions + presence dock use; absent
    // gate fn (no-backend shells) keeps the composer visible.
    const isActiveFn = el?.context?.methods?.isActiveMember;
    if (typeof isActiveFn === 'function' && !isActiveFn.call(el, {
        root: root
    })) return false;
    return true;
};
// Self-healing chat + notifications realtime, run opportunistically from
// _syncShellRoute (every route/state sync). Both underlying calls are
// internally guarded and workspace/user-keyed — subscribeRealtime reuses its
// existing SSE connection while `existing._wsId === activeWorkspaceId` and
// re-opens on drift (see chat/functions/subscribeRealtime.js:~310);
// subscribeNotifications no-ops once `root._notifChannel` is set — so
// calling them again here is a cheap no-op on the common path and a real
// re-subscribe exactly when either goes stale (a workspace switch racing the
// mount-time boot call in onCreate, or that boot call firing before
// `currentUserEmail`/`root.workspace` resolved). Throttled so a burst of
// route syncs (chat-drawer toggle, assistant dock drag) doesn't pay the
// guard-check cost on every tick.
// Mail realtime, flag-gated (architecture/MAIL.md §3.6). Split out because
// BOTH the mount-time boot and the route-sync self-heal need the identical
// gate + guard, and because the gate is not the same one chat's stream has:
// `navItemVisible(root, '/mail')` is the mail feature flag AND the app-access
// ACL — the predicate the header envelope itself hides on. A workspace with
// mail off never opens the connection.
//
// `subscribeMailStream` is registered by the mail EAGER slice (mail/functions/
// eagerSlice.js), so it resolves before any fold — that is the whole point,
// since the badge is a header surface on every route. `el.call` still throws
// on a shell where mail is not merged at all (a no-backend host), so the call
// stays guarded like its two siblings.
const $6b17f08f738443dc$var$_ensureMailRealtime = (el, root)=>{
    if (!root || !$6b17f08f738443dc$var$shellNavItemVisible(root, '/mail')) return;
    try {
        el.call?.('subscribeMailStream');
    } catch (err) {
        console.warn('[shell] subscribeMailStream ensure failed:', err?.message || err);
    }
};
// The shell's meet channel — the "Start a call" badge's feed (root.rooms,
// root.liveParticipants). Opens ONLY for a signed-in person whose workspace is
// known (functions/sessionStreams.js meetRealtimeScope, persona audit OV-2): a
// signed-out page used to open it at boot and the server answered 401 six to
// eighteen times; a signed-in boot opened it before the workspace landed
// (400). subscribeMeetRealtime is scope-keyed, so a repeat call is a no-op and
// a workspace switch re-scopes it. Returns the subscription's teardown, or
// null when nothing was opened.
const $6b17f08f738443dc$var$_ensureMeetRealtime = (el, root)=>{
    if (!el?.call?.('meetRealtimeScope', root)) return null;
    try {
        return el.call?.('subscribeMeetRealtime', {
            tables: [
                'meet_rooms',
                'meet_participants'
            ]
        });
    } catch (err) {
        console.warn('[shell] meet realtime ensure failed:', err?.message || err);
        return null;
    }
};
let $6b17f08f738443dc$var$_lastRealtimeEnsureAt = 0;
const $6b17f08f738443dc$var$_ensureShellRealtime = (el, root)=>{
    if (!root?.currentUserEmail) return;
    const now = Date.now();
    if (now - $6b17f08f738443dc$var$_lastRealtimeEnsureAt < 5000) return;
    $6b17f08f738443dc$var$_lastRealtimeEnsureAt = now;
    try {
        el.call?.('subscribeRealtime');
    } catch (err) {
        console.warn('[shell] subscribeRealtime ensure failed:', err?.message || err);
    }
    try {
        el.call?.('subscribeNotifications');
    } catch (err) {
        console.warn('[shell] subscribeNotifications ensure failed:', err?.message || err);
    }
    $6b17f08f738443dc$var$_ensureMailRealtime(el, root);
    $6b17f08f738443dc$var$_ensureMeetRealtime(el, root);
    // Due-time reminder notifications — the sweep throttles itself (~1/min)
    // and no-ops when nothing is due, so riding this ensure keeps reminders
    // firing on ANY route while the app is open (2026-08-01 per Nika:
    // reminders should send notifications).
    try {
        el.call?.('reminderDueSweep');
    } catch (err) {
        console.warn('[shell] reminderDueSweep ensure failed:', err?.message || err);
    }
};
// THE SKIN — <html data-skin="ambient|solid"> beside data-shell-route
// (DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1, HOME_AMBIENT_SKIN_SPEC
// §1). The rule — the workspace's own `settings.appearance.skin`, else solid
// on a white-label host or a workspace with its own ground, else ambient —
// lives in functions/workspaceSkin.js, shared with the admin card on
// /admin/workspace-settings so the two never disagree. While the record is
// on its way the rule answers null and the stamp stays as it is: no
// attribute is today's look (solid), so a cold boot never flashes a guess.
const $6b17f08f738443dc$var$_syncShellSkin = (root)=>{
    if (typeof document === 'undefined') return;
    const r = (0, $htRH6.untrackedState)(root);
    const { skin: skin } = (0, $5Vf2y.resolveWorkspaceSkin)(r, {
        info: $6b17f08f738443dc$var$workspaceSettingsOf(r),
        brandedHost: (0, $lb2Ei.isCustomDomainHost)()
    });
    if (!skin) return;
    const html = document.documentElement;
    if (html.getAttribute('data-skin') === skin) return;
    html.setAttribute('data-skin', skin);
    // Keep this scope's warm-boot row in step, so the NEXT warm boot stamps the
    // skin before its first paint (index.js → functions/bootSnapshot.js).
    (0, $ly0mS.recordBootSnapshotSkin)({
        userId: r?.currentUserId,
        workspaceId: r?.workspace?.id,
        skin: skin
    });
};
// Route-kind synced to a <html data-shell-route> attribute so the injected
// content CSS can offset the right pages below the absolute AppHeader:
//   • 'app'    → tickets/chat/calendar/etc. flow BELOW the 48px header
//                (their own top toolbars otherwise collide with it).
//   • 'home'   → self-offsets via MainColumn padding — left untouched.
//   • 'canvas' → /studio, /canvas + project canvases keep the header as a
//                pure full-bleed overlay (no offset, no gap).
//   • 'auth'   → header is hidden anyway.
// (2026-06-09 per Nika "fix layout for all similar pages" — /tickets.)
// Tracks assistantOpen across _syncShellRoute runs so the reveal-on-open
// promotion below fires only on the false→true edge (an opener), never on an
// explicit minimize (which keeps assistantOpen true).
let $6b17f08f738443dc$var$_prevAssistantOpen = false;
const $6b17f08f738443dc$var$_syncShellRoute = (root, el)=>{
    if (typeof document === 'undefined') return;
    root = (0, $htRH6.untrackedState)(root);
    // Normalize past any `/w/<org-slug>` prefix so the intranet home (`p === '/'`)
    // + every canvas-kind check below classify correctly under multi-workspace
    // tabs (§6d). No-op until Phase 3 emits the prefix.
    const p = (0, $7iFOV.shellStripWorkspacePrefix)(root?.currentPath || window.location.pathname || '/');
    let kind = 'app';
    if ((0, $kuISg.isChromelessShellPath)(p)) kind = 'auth';
    else if (p === '/') kind = 'home';
    else if ($6b17f08f738443dc$var$_isStudioCanvasPath(p) || $6b17f08f738443dc$var$_isFilesCanvasPath(p) || $6b17f08f738443dc$var$_isTicketsCanvasPath(p) || $6b17f08f738443dc$var$_isTeamCanvasPath(p) || $6b17f08f738443dc$var$_isInfraCanvasPath(p) || (0, $2C7Li.isProjectCanvasPath)(p, root) || $6b17f08f738443dc$var$_isModuleCanvasPath(p, root)) kind = 'canvas';
    document.documentElement.setAttribute('data-shell-route', kind);
    // A module canvas page keeps its own page head (title, tabs) in flow: the
    // marker lets the canvas-kind rule below clear the floating header for it.
    document.documentElement.setAttribute('data-module-canvas', kind === 'canvas' && $6b17f08f738443dc$var$_isModuleCanvasPath(p, root) ? 'true' : 'false');
    // Messenger (chat drawer) open → offset the left page rails (CSS above) so
    // they clear the floating chat list. (2026-06-18 per Nika.) The docked
    // MailOverlay (mail drawer, 2026-09-05) floats in the SAME left band with
    // the same geometry, so it drives the same attribute — one styled hook for
    // "a left docked drawer is open", not a second attribute nothing styles.
    document.documentElement.setAttribute('data-chat-drawer', root?._chatDrawerOpen || root?._mailDrawerOpen ? 'open' : 'closed');
    // Where the navbar sits (shared functions/navbarLayout.js: the person's own
    // look, 'top' by default and always on a phone) → <html data-nav-place>,
    // the hook of the injected sheet's "THE NAVBAR'S PLACE" rules: the header
    // turns into a rail or a bottom bar and the frame clears it. ShellRouteSync
    // listens to the look keys.
    document.documentElement.setAttribute('data-nav-place', $6b17f08f738443dc$var$_navPlace(el));
    // Composer visibility mirror — feeds the app-page bottom-padding CSS rule
    // below (`html[data-shell-route="app"][data-prompt="shown"] …`). Shares
    // _composerVisible with CanvasPromptTextarea's own `hide` factory so the
    // padding gate can never drift from where the composer actually renders,
    // and — since it's gated on this attribute — also self-clears once the
    // composer hides even though _trackClearVar (below) deliberately RETAINS
    // the last live --prompt-clear measurement (a ResizeObserver has nothing to
    // observe once its node unmounts, so the var would otherwise keep the old
    // reading forever).
    // A module's "hide the shell composer" latch whose page is gone (route
    // change, pane closed) is cleared here, so returning to that page shows the
    // composer until the module asks again (functions/moduleShellComposer.js).
    // ShellRouteSync listens to currentPath and both pane keys — every way a
    // latch can go stale.
    (0, $984mC.releaseStaleModuleComposerLatch)(root);
    document.documentElement.setAttribute('data-prompt', $6b17f08f738443dc$var$_composerVisible(root, root?.currentPath, el) ? 'shown' : 'hidden');
    // A PageSlot window is open (either pane) → <html data-slot="open">. The
    // injected sheet reads it at phone width, where the window is an iOS sheet
    // that COVERS the composer (PageSlot's phone rule); see the rule below.
    document.documentElement.setAttribute('data-slot', root?._canvasSlot || root?._canvasSlotSecond ? 'open' : 'closed');
    // Dockable AI assistant → reflect the effective dock onto <html
    // data-assistant-dock> so the injected shell CSS can (a) reserve a grid
    // column on [data-key="smblsapp"] to SHRINK the content instead of
    // overlaying it, (b) place the fixed drawer on the correct edge, and (c)
    // inset the viewport-fixed chrome (AppHeader / PageSlot / composer). Driven
    // here — NOT via reactive layout-prop factories on the drawer — because
    // width/left/right/grid factories freeze at mount in v3.14 (mirrors the
    // data-shell-route + data-chat-drawer mechanism above). Effective value:
    //   closed     → assistant not open (content full width, drawer hidden)
    //   right/left → docked, content shrinks
    //   minimized  → open but collapsed to the SimoneReasoningPill
    // Reveal-on-open: any opener that flips assistantOpen false→true while the dock
    // is 'minimized' should reveal the drawer, not open into the invisible
    // minimized chip. The star + pill promote themselves; this covers EVERY OTHER
    // opener (calendar Ask AI, ticket mention, deep-links, DailyUpdate, …) centrally
    // so none of them needs to know about the dock. Session-only (root.update, NOT
    // setAssistantDock) so it never overwrites the user's persisted 'minimized'.
    // Guarded on the false→true edge so it never fires on an explicit minimize
    // (which keeps assistantOpen true); the re-entrant run sees _prevAssistantOpen
    // already true and the now-'right' dock, so it can't recurse or double-fire.
    //
    // Page mode ('main') opens the MAIN THREAD over the current page instead
    // (AI_ASSISTANT_SPEC §12.2 — the drawer stays shut); with a page sheet open
    // in the PageSlot it promotes to the LAST side like before, and remembers it
    // came from Page so the close edge returns there — an opener asks for the
    // conversation, never for a new mode. The rules and the stamp live in
    // functions/assistantDock.js.
    const _openNow = !!root?.assistantOpen;
    const _justOpened = _openNow && !$6b17f08f738443dc$var$_prevAssistantOpen;
    const _justClosed = !_openNow && $6b17f08f738443dc$var$_prevAssistantOpen;
    $6b17f08f738443dc$var$_prevAssistantOpen = _openNow;
    if (_justOpened && root.update) {
        // The conversation an opener shows: with an empty chat in Fly, the Fly
        // session's thread (functions/assistantMainThread.js assistantOpenThread).
        // Read BEFORE the placement moves, so the view is the one opened from.
        if (el && typeof el.call === 'function') el.call('assistantOpenThread', root);
        // An opener inside a DIALOG (a ticket or event detail "Ask AI") sits over
        // the main area — the thread would open UNDER it — so it docks the sidebar
        // for the session instead, like a page sheet (design-d2's review, D3). The
        // dialog is read the way the shell keyboard guard reads an overlay: the
        // shell's overlay reader, or focus inside a dialog carrier.
        let _overlay = false;
        let _opener = null;
        try {
            const _layer = el && typeof el.call === 'function' ? el.call('shellOverlayOpen') : null;
            _opener = typeof document !== 'undefined' ? document.activeElement : null;
            const _inDialog = !!(_opener && typeof _opener.closest === 'function' && _opener.closest('[role="dialog"],[role="alertdialog"],[aria-modal="true"]'));
            _overlay = _layer === 'modalRoot' || _inDialog;
        } catch (_) {
            _overlay = false;
        }
        const promote = (0, $dp7M8.promoteAssistantDockForOpen)(root, (0, $dp7M8.lastAssistantSide)(), {
            overlay: _overlay
        });
        if (promote) root.update(promote);
        // Focus returns to the OPENER when Esc closes the thread it opened
        // (functions/assistantMainThread.js assistantMainThreadClose).
        const _app = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
        if (_app && promote && promote._homeThreadOpen === true) _app.__mainThreadOpener = _opener;
    } else if (_justClosed && root.update) {
        const restore = (0, $dp7M8.restoreAssistantDockOnClose)(root);
        if (restore) root.update(restore);
    }
    const _dockStamp = (0, $dp7M8.assistantDockStamp)(root);
    document.documentElement.setAttribute('data-assistant-dock', _dockStamp);
    // Publish the sidebar width used by BOTH the reserved grid column AND the
    // drawer's own width so they stay in lockstep (a raw var() on `width`
    // compiles to an empty DOMQL atomic rule, so the drawer width lives in the
    // stylesheet keyed on the attribute — see the injected CSS). Clamp to the
    // same 320..50vw bounds the ResizeHandle drag enforces so the reserved
    // column can never diverge from the rendered drawer.
    if (typeof window !== 'undefined') {
        const _w = Number(root?.assistantWidth);
        const _half = Math.floor(window.innerWidth * 0.5);
        const _px = Math.max(320, Math.min(_half, Number.isFinite(_w) && _w > 0 ? _w : 640));
        document.documentElement.style.setProperty('--assistant-width', _px + 'px');
        // Per-side INSET vars for viewport-fixed chrome whose geometry lands
        // INLINE (SHELL-ASSISTANT-RESERVE-1, PageSlot half): a conditional
        // `.case` block compiles to inline style, so PageSlot's expanded /
        // fullscreen states (`right: 0`, `left: rail-clear`) outrank the
        // attribute-keyed `[data-key="PageSlot"]` rules below and the slot slid
        // UNDER the docked drawer. The slot's case blocks read these vars
        // instead: 0px whenever nothing is docked on that side, the same clamped
        // reserve as the grid column when the drawer is open on it — one number
        // for the column, the drawer and every inset, so none can diverge.
        // The stamp names the open drawer's edge ('right' | 'left') and nothing
        // else docked — Page mode ('main') and Minimized reserve no side.
        const _reserve = 'min(var(--assistant-width),50vw)';
        document.documentElement.style.setProperty('--assistant-inset-right', _dockStamp === 'right' ? _reserve : '0px');
        document.documentElement.style.setProperty('--assistant-inset-left', _dockStamp === 'left' ? _reserve : '0px');
    }
    // Publish the messenger sidebar's real rendered right edge so the PageSlot can
    // dock one gutter beside it (consumed by the `[data-key="PageSlot"]` rule in
    // shellApp's injected CSS). The sidebar inherits a smaller font-size than the
    // shell root, so its em-based `width:G1` can't be reconstructed with
    // root-context tokens — measure it instead. computedLeft+computedWidth is
    // transform-independent, so it's correct while the sidebar is mid-slide AND
    // while it's parked off-screen when closed (MessengerList stays mounted, just
    // translated away). Scoped to the root element's node via el.getRoot()
    // (mirrors the chat overlay's own lookup) rather than a global document query.
    // The mail drawer (MailOverlay → MailDrawer) shares the messenger's left
    // band and geometry; measure whichever of the two is laid out. A hidden
    // (display:none) panel computes a non-numeric width, so it is skipped.
    const rootNode = el?.getRoot?.()?.node;
    const dockedNodes = rootNode?.querySelectorAll?.('[data-key="MessengerList"], [data-key="MailDrawer"]');
    for (const dockedNode of dockedNodes || []){
        const mcs = window.getComputedStyle(dockedNode);
        const right = parseFloat(mcs.left) + parseFloat(mcs.width);
        if (right > 0) {
            document.documentElement.style.setProperty('--chat-sidebar-right', `${right}px`);
            break;
        }
    }
    // BACKSTOP ONLY — this block does NOT run on a View-as click.
    // `ShellRouteSync` (the invisible component whose onUpdate calls
    // `_syncShellRoute`) is `subscribeTo`-gated to exactly
    // `['currentPath', '_chatDrawerOpen', 'assistantOpen', 'assistantDock',
    // 'assistantWidth']` — a persona's `bfPersonaOverride`/`bfView` write and
    // `moduleOpenPage`'s own `_canvasSlot` write touch NEITHER, so this never
    // fires on the actual gesture (Chrome-MCP-confirmed live, 2026-08-14:
    // `?page=` updated every switch, `?viewAs=` never once across ten — this
    // code looked plausible and was inert). `subscribeTo`'s key list is also
    // resolved ONCE at element-create time (smbls `registerSubscribeToEffects`),
    // before any module — and its `chrome.viewAsKey` — has loaded, so a
    // dynamic function-form `subscribeTo` can't fix this either: it would
    // still freeze on the pre-module-load empty key.
    //
    // The PRIMARY, deterministic `?viewAs=` sync now lives in
    // `functions/moduleOpenBridge.js` (`_syncViewAsUrl`, called imperatively
    // from `moduleOpenPage` — the one bridge every View-as switch and every
    // other module-page-open funnels through). This block is left as a
    // same-shape, harmless backstop: it re-applies whenever `ShellRouteSync`
    // DOES fire for its own listed reasons (route/chat-drawer/assistant
    // changes), so the URL can't drift stale across those either. Idempotent
    // (no-op-diff guarded) — safe to run twice. Generic: keyed off
    // `chrome.viewAsKey`, never a module-specific name — see
    // `_restoreViewAsParam` (workspaceProjects.js) for the read/restore half
    // (RAIL-TRANSITION, tickets/fable.md).
    const _viewAsKey = (0, $7ytvD.moduleViewAsKey)(root);
    if (_viewAsKey && typeof window !== 'undefined') try {
        const url = new URL(window.location.href);
        const cur = url.searchParams.get('viewAs');
        const val = root?.[_viewAsKey];
        const next = typeof val === 'string' && val && val !== 'admin' ? val : null;
        if (next !== cur) {
            if (next) url.searchParams.set('viewAs', next);
            else url.searchParams.delete('viewAs');
            const nextUrl = url.pathname + url.search + url.hash;
            const current = window.location.pathname + window.location.search + window.location.hash;
            if (nextUrl !== current) window.history.replaceState(window.history.state, '', nextUrl);
        }
    } catch (err) {
        console.warn('[shell] viewAs url sync failed:', err?.message || err);
    }
    $6b17f08f738443dc$var$_ensureShellRealtime(el, root);
    // The shell call panel's voice session (functions/calls/workspaceCall.js) —
    // idempotent and workspace-keyed, so a route sync is a no-op on the common
    // path, re-scopes after a workspace switch and stops after a sign-out. NOT
    // inside _ensureShellRealtime: that one is gated on a signed-in user, and the
    // sign-out half needs this call too.
    try {
        el.call?.('ensureWorkspaceVoice');
    } catch (err) {
        console.warn('[shell] ensureWorkspaceVoice failed:', err?.message || err);
    }
};
// DEMO LOCKDOWN — routes a demo session may NOT visit. These are the
// admin / cross-org / other-org-people / internal-features surfaces; a demo
// visitor is locked to their single demo org, so any of these is redirected
// home. The regex lives in functions/demoRouteGuard.js — the SAME source also
// powers the smbls router guard (context.routerOptions.guards) that blocks
// these routes pre-mount on every SPA navigation; this sentinel is the
// fallback for isDemo resolving true while already ON a blocked route.
// Redirect an isDemo session off a blocked route. No-op for real users
// (isDemo false) and until auth has resolved (so we don't bounce on the
// pre-auth '/' default). el.router keeps it a clean SPA redirect.
//
// The redirect is DEFERRED to a microtask: this guard fires from the
// `currentPath` signal flush, which the router runs SYNCHRONOUSLY in the
// middle of mounting the blocked route's content. Calling el.router
// re-entrantly from inside that flush let the inner '/' navigation finish
// and then the OUTER (blocked-route) set continue — appending the blocked
// page as a SECOND `content` child at the shell root: the grid split into
// two ~half-viewport rows (home on top, /admin below) and the dead page's
// helmet re-wrote the tab title. A microtask runs after the router's
// synchronous render completes but BEFORE paint, so the bounce is a normal
// non-re-entrant navigation and the blocked page never flashes.
const $6b17f08f738443dc$var$_guardDemoRoute = (el, s)=>{
    const root = s.root;
    if (!root || !root.isDemo) return;
    const path = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
    if ((0, $ehZst.DEMO_BLOCKED_ROUTE_RE).test(path)) queueMicrotask(()=>{
        // Re-check — another navigation may have landed while queued.
        const now = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
        if (!(0, $ehZst.DEMO_BLOCKED_ROUTE_RE).test(now)) return;
        try {
            el.router((0, $iJIxS.withLiveQuery)('/'), el.getRoot());
        } catch (err) {
            console.warn('[shell] demo route guard redirect failed:', err?.message || err);
        }
    });
};
// MainLoader covers the viewport while ANY "block the UI" flag is set:
//   • `loading`        — generic `applyLoader({value:true})` channel
//   • `_wsSwitching`   — org switch in flight (federated or otherwise)
//   • `_wpSwitching`   — workspace-project federation switch in flight
//   • `_loginLoading`  — auth submit / token round-trip
//   • `_langOwed`      — a sign-in ON this page has not applied the session's
//     interface language yet (functions/shellLangPolicy.js). It holds only a
//     signed-in shell whose workspace can still decide the language: with no
//     workspace, or a record that will never complete, nothing is coming.
// `s.loading` is the canonical global loader signal — pages that need
// a feature-scoped indicator (e.g. studios' node hydration) MUST use
// their own flag (`_labLoading`), never poach `s.loading`.
const $6b17f08f738443dc$var$_isLoaderActive = (s)=>!!(s.loading || s._wsSwitching || s._wpSwitching || s._loginLoading || s._dataLoading || s._langOwed === true && s.signedIn === true && !!s.workspace && !!(s.workspace.id || s.workspace._id) && !s.workspace._completionUnreachable);
// Boot-timeline mark — the same performance.mark channel loadPrivateData's
// `wsboot:*` marks use, so one getEntriesByType('mark') read shows the data
// passes AND the loader edges side by side. Never throws (no Performance
// API in tests / SSR).
const $6b17f08f738443dc$var$_bootMark = (name)=>{
    try {
        performance.mark(name);
    } catch (_) {
    /* noop */ }
};
// Native startup owns the first visual. The shell still owns truthful status
// and the stable-ready gate while its own visual stays hidden underneath it.
// The status is a PHASE, never copy: the pre-bundle overlay (index.html)
// carries its own lines because no bundle can load before it paints, and the
// runtime loader renders translated copy from the i18n bundles.
const $6b17f08f738443dc$var$_loaderStatus = (s)=>{
    // Stages describe completed prerequisites, not an estimated percentage.
    const step = s._loginLoading || !s._authReady ? 1 : 2;
    if (s._wsSwitching || s._wpSwitching) return {
        phase: 'switching',
        step: step
    };
    if (s._loginLoading || !s._authReady) return {
        phase: 'session',
        step: step
    };
    if (s._wsAppsActivating && $6b17f08f738443dc$var$_isLoaderActive(s)) return {
        phase: 'apps',
        step: step
    };
    if (s._dataLoading) return {
        phase: 'workspace',
        step: step
    };
    if (s.loading) return {
        phase: 'loading',
        step: step
    };
    // Only the language an in-page sign-in owes holds it now: the last of the
    // workspace's own prerequisites, so the fill never steps back a stage.
    if ($6b17f08f738443dc$var$_isLoaderActive(s)) return {
        phase: 'workspace',
        step: step
    };
    return null;
};
// The loader's fill — the mountain range, and the rising mark — moves to REAL
// milestones only (DESIGN-WL-BOOT-LOADER-MOTION-1): 1 while the session is
// checked, 2 once it is (the workspace and apps load), 3 when the loader is
// off (ready). MainLoader stamps it as data-stage; the injected sheet below
// turns each stage into a creep that stops short of the next milestone, the
// same numbers as the pre-bundle overlay in index.html.
const $6b17f08f738443dc$var$_loaderFillStage = (s)=>{
    if (!$6b17f08f738443dc$var$_isLoaderActive(s)) return 3;
    return $6b17f08f738443dc$var$_loaderStatus(s)?.step === 2 ? 2 : 1;
};
// NO JUMP AT A STAGE CHANGE (Nika 2026-10-08 "fix loader animation"). Each
// stage's keyframes used to start at a FIXED point: a workspace switch (raised
// straight at stage 2) popped the range in a third full, and every later
// stage jumped to its own start. The fill is tracked here on the timing the
// sheet runs (target, duration, cubic-bezier per stage — the overlay's own
// numbers in index.html), and a stage starts from the CURRENT position,
// handed to the keyframes as --ws-loader-from (1 empty, 0 full). A fresh
// raise starts empty. Pure bookkeeping on the element: no DOM read.
const $6b17f08f738443dc$var$_LOADER_MOTION = {
    1: [
        0.7,
        12000,
        [
            0.1,
            0.7,
            0.2,
            1
        ]
    ],
    2: [
        0.34,
        24000,
        [
            0.1,
            0.7,
            0.2,
            1
        ]
    ],
    3: [
        0,
        480,
        [
            0,
            0,
            0.58,
            1
        ]
    ]
};
const $6b17f08f738443dc$var$_loaderClock = ()=>typeof performance !== 'undefined' && performance && typeof performance.now === 'function' ? performance.now() : Date.now();
const $6b17f08f738443dc$var$_loaderBezier = (c, x)=>{
    let lo = 0;
    let hi = 1;
    let t = x;
    for(let i = 0; i < 30; i++){
        t = (lo + hi) / 2;
        const xt = 3 * (1 - t) * (1 - t) * t * c[0] + 3 * (1 - t) * t * t * c[2] + t * t * t;
        if (xt < x) lo = t;
        else hi = t;
    }
    return 3 * (1 - t) * (1 - t) * t * c[1] + 3 * (1 - t) * t * t * c[3] + t * t * t;
};
const $6b17f08f738443dc$var$_loaderFillNow = (m)=>{
    const spec = $6b17f08f738443dc$var$_LOADER_MOTION[m.stage];
    const x = Math.min(1, Math.max(0, ($6b17f08f738443dc$var$_loaderClock() - m.at) / spec[1]));
    return Math.min(1, Math.max(0, m.from + (spec[0] - m.from) * $6b17f08f738443dc$var$_loaderBezier(spec[2], x)));
};
const $6b17f08f738443dc$var$_trackLoaderMotion = (el, stage, shown)=>{
    const m = el._loaderMotion;
    if (!shown) {
        el._loaderMotion = {
            stage: 3,
            from: 0,
            at: $6b17f08f738443dc$var$_loaderClock(),
            shown: false
        };
        return;
    }
    if (!m || !m.shown) {
        el._loaderMotion = {
            stage: stage,
            from: 1,
            at: $6b17f08f738443dc$var$_loaderClock(),
            shown: true
        };
        return;
    }
    if (m.stage !== stage && $6b17f08f738443dc$var$_LOADER_MOTION[stage]) el._loaderMotion = {
        stage: stage,
        from: $6b17f08f738443dc$var$_loaderFillNow(m),
        at: $6b17f08f738443dc$var$_loaderClock(),
        shown: true
    };
};
const $6b17f08f738443dc$var$_loaderFrom = (el)=>{
    const m = el._loaderMotion;
    return m && m.shown ? String(Math.round(m.from * 10000) / 10000) : '1';
};
// The resolved session language, handed to the PRE-BUNDLE boot overlay
// (index.html) — WS-BOOT-LOADER-PAINTS-ENGLISH-ONLY-BEFORE-THE-BUNDLE-1.
//
// That overlay carries its own copy, because it paints before any bundle and
// so before any i18n catalog. It resolves a language for its FIRST frame from
// signals that bind to the arrival (a `?lang=` hint, the per-workspace boot
// cache, the tenant brand). A COLD arrival has none of those, so it paints
// English and this is what corrects it: the shell publishes the language the
// moment it resolves, and the overlay retranslates the line on screen, the
// recovery notice, its accessible name and the Reload label.
//
// It also records the answer for the NEXT load's first frame. That write is
// per host AND per workspace scope (functions/bootLang.js carries the law it
// obeys), never account-wide: a workspace renders in the language IT is set
// to, and a scope with no entry reads English rather than inheriting another
// workspace's language.
//
// The shipped set is INLINED, not read off `_wsShared`, for the same reason
// every helper around it is self-contained: `__tests__/bootLoaderHandoff.
// test.js` evals this whole region in a bare VM with no module bindings, so a
// delegate here would throw on every render it tests. Drift is pinned instead
// — `__tests__/bootLoaderLanguage.test.js` holds this list against
// `PLATFORM_LANGUAGES`, so a third language reds the suite.
const $6b17f08f738443dc$var$_publishBootLang = (lang)=>{
    const SHIPPED = [
        'en',
        'ka'
    ];
    if (typeof window === 'undefined' || SHIPPED.indexOf(lang) === -1) return;
    if (window.__smblsBootLangPublished === lang) return;
    window.__smblsBootLangPublished = lang;
    (0, $hkFDz.writeBootLangHint)(lang, window);
    // Only when the overlay's own guess differs: an arrival that already
    // painted the right language needs no event and no re-render.
    if (window.__smblsBootLang === lang) return;
    window.__smblsBootLang = lang;
    try {
        window.dispatchEvent(new CustomEvent('smbls:boot-lang', {
            detail: {
                lang: lang
            }
        }));
    } catch (_) {
    /* The cached value also serves a pre-bundle consumer. */ }
};
const $6b17f08f738443dc$var$_publishBootStatus = (status)=>{
    if (!status || typeof window === 'undefined') return;
    // The label never steps back within one boot: apps and the rest of the
    // workspace data share step two, and _dataLoading can outlive the apps pass,
    // so "Opening apps" used to fall back to "Loading workspace" (peer sweep,
    // deploy 11: 7.5 s workspace, 10.2 s apps, 11.0 s workspace). A switch, a
    // session reset, ready or an error starts a new sequence.
    const last = window.__smblsBootStatus;
    if (last?.phase === 'apps' && status.phase === 'workspace' && status.step === last.step && !status.message) return;
    if (window.__smblsBootStatus?.phase === status.phase && window.__smblsBootStatus?.step === status.step) return;
    window.__smblsBootStatus = status;
    try {
        if (typeof performance !== 'undefined' && performance?.mark) {
            const name = 'wsboot:loader:' + status.phase;
            // Keep one mark per phase, including across repeated workspace switches.
            performance.clearMarks?.(name);
            performance.mark(name);
        }
    } catch (_) {
    /* Diagnostics cannot block the loader. */ }
    try {
        window.dispatchEvent(new CustomEvent('smbls:boot-status', {
            detail: status
        }));
    } catch (_) {
    /* The cached status also serves pre-bundle consumers. */ }
};
const $6b17f08f738443dc$var$_bootLoaderOwnerAlive = (el, owner)=>{
    if (!owner || el.__destroyed || el.__ref === null || el._bootReadyOwner !== owner) return false;
    const rootEl = el.getRoot?.() || owner.root.__element;
    const liveRoot = el.state?.root || el.state;
    const boundRoot = rootEl?.state?.root || rootEl?.state;
    return rootEl === owner.rootEl && !rootEl?.__destroyed && rootEl?.__ref !== null && (!liveRoot || liveRoot === owner.root) && (!boundRoot || boundRoot === owner.root) && (!owner.root.__element || owner.root.__element === rootEl) && (!owner.node || el.node === owner.node) && (typeof window === 'undefined' || window.__smblsBootOwner === owner.token);
};
const $6b17f08f738443dc$var$_cancelBootReady = (el)=>{
    if (el._bootReadyTimer != null) clearTimeout(el._bootReadyTimer);
    el._bootReadyTimer = null;
    $6b17f08f738443dc$var$_dropReadyHold(el);
};
// THE READY HOLD (Nika 2026-10-01 "why loading mountains dont fully reveal?").
// The runtime loader used to leave (display none) in the same render that set
// its stage 3, so on a workspace switch or a sign-in its ready fill never
// showed. At the ready edge it now stays on screen for the fill with
// pointer-events none (the page takes input at once) and leaves on the front's
// own animationend (wsLoaderFrontReady) or a 700 ms cap. Reduced motion leaves
// at once. A new load during the hold drops it; the owner guard drops it with
// the loader. `_loaderReadyHold` on the root is only the re-render signal.
const $6b17f08f738443dc$var$_READY_HOLD_CAP_MS = 700;
const $6b17f08f738443dc$var$_loaderMotionReduced = (root)=>!!root?.a11yMotion || typeof window !== 'undefined' && typeof window.matchMedia === 'function' && !!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $6b17f08f738443dc$var$_dropReadyHold = (el)=>{
    if (el._readyHoldTimer != null) clearTimeout(el._readyHoldTimer);
    el._readyHoldTimer = null;
    el._readyHold = false;
};
const $6b17f08f738443dc$var$_endReadyHold = (el, root)=>{
    if (!el._readyHold) return;
    $6b17f08f738443dc$var$_dropReadyHold(el);
    try {
        root?.update?.({
            _loaderReadyHold: (root._loaderReadyHold || 0) + 1
        }, {
            preventFetch: true
        });
    } catch (_) {
    /* the next root update re-reads the props */ }
};
// True while the loader holds for its fill, or in the render that crosses the
// ready edge before display (which runs the sync) has started the hold.
const $6b17f08f738443dc$var$_loaderHolding = (el, s)=>{
    const root = s.root || s;
    root._loaderReadyHold;
    if (el._readyHold) return true;
    return el._loaderMarked === true && !$6b17f08f738443dc$var$_isLoaderActive(root) && !$6b17f08f738443dc$var$_loaderMotionReduced(root);
};
// BOOT LOADER MAXIMUM (work.astio.ai 2026-10-08: signed in, the overlay sat on
// "Switching workspace" for ever — a loader flag raised and never lowered,
// after the boot gate had answered, so the gate's own deadline never saw it).
// A loader still up _LOADER_MAX_MS into a boot that is not ready publishes the
// error phase, its reason naming the stuck flags: the pre-bundle overlay then
// shows its error line, the Reload button and the step. Nothing is forced
// down — a flag nobody lowers is a defect to see, not to hide.
const $6b17f08f738443dc$var$_LOADER_MAX_MS = 45000;
const $6b17f08f738443dc$var$_LOADER_FLAGS = [
    'loading',
    '_wsSwitching',
    '_wpSwitching',
    '_loginLoading',
    '_dataLoading',
    '_langOwed'
];
const $6b17f08f738443dc$var$_clearLoaderMax = (el)=>{
    if (el._loaderMaxTimer != null) clearTimeout(el._loaderMaxTimer);
    el._loaderMaxTimer = null;
    el._loaderStuck = false;
};
const $6b17f08f738443dc$var$_armLoaderMax = (el, owner)=>{
    if (el._loaderMaxTimer != null || el._loaderStuck) return;
    const timer = setTimeout(()=>{
        if (el._loaderMaxTimer !== timer) return;
        el._loaderMaxTimer = null;
        if (!$6b17f08f738443dc$var$_bootLoaderOwnerAlive(el, owner)) return;
        if (typeof window !== 'undefined' && window.__smblsBootReady) return;
        const r = owner.root;
        if (!$6b17f08f738443dc$var$_isLoaderActive(r)) return;
        el._loaderStuck = true;
        $6b17f08f738443dc$var$_bootMark('wsboot:loader:stuck');
        $6b17f08f738443dc$var$_publishBootStatus({
            phase: 'error',
            step: $6b17f08f738443dc$var$_loaderStatus(r)?.step || 1,
            reason: 'loader_stuck:' + $6b17f08f738443dc$var$_LOADER_FLAGS.filter((k)=>r[k]).join('+')
        });
    }, $6b17f08f738443dc$var$_LOADER_MAX_MS);
    el._loaderMaxTimer = timer;
};
const $6b17f08f738443dc$var$_syncBootLoader = (el, s)=>{
    const root = s.root || s;
    const rootEl = el.getRoot?.() || root.__element;
    // Validate the binding before claiming global ownership. A late read from
    // a dead tree must not invalidate the healthy replacement's timer.
    const boundRoot = rootEl?.state?.root || rootEl?.state;
    const liveRoot = el.state?.root || el.state;
    if (el.__destroyed || el.__ref === null || rootEl?.__destroyed || rootEl?.__ref === null || boundRoot && boundRoot !== root || liveRoot && liveRoot !== root || root.__element && root.__element !== rootEl) {
        $6b17f08f738443dc$var$_cancelBootReady(el);
        return false;
    }
    let owner = el._bootReadyOwner;
    if (!owner || owner.root !== root || owner.rootEl !== rootEl || owner.node !== el.node) {
        $6b17f08f738443dc$var$_cancelBootReady(el);
        owner = el._bootReadyOwner = {
            root: root,
            rootEl: rootEl,
            node: el.node,
            token: {}
        };
        el._loaderSeenActive = false;
        if (typeof window !== 'undefined') window.__smblsBootOwner = owner.token;
    }
    if (!$6b17f08f738443dc$var$_bootLoaderOwnerAlive(el, owner)) {
        $6b17f08f738443dc$var$_cancelBootReady(el);
        return false;
    }
    const active = $6b17f08f738443dc$var$_isLoaderActive(root);
    const wasActive = el._loaderMarked === true;
    const nativeVisible = typeof window !== 'undefined' && !window.__smblsBootReady && window.__smblsBootOverlay === true;
    if (active) $6b17f08f738443dc$var$_dropReadyHold(el);
    else if (wasActive && el._loaderSeenActive && !nativeVisible && !$6b17f08f738443dc$var$_loaderMotionReduced(root)) {
        $6b17f08f738443dc$var$_dropReadyHold(el);
        el._readyHold = true;
        const holdTimer = setTimeout(()=>{
            if (el._readyHoldTimer !== holdTimer) return;
            el._readyHoldTimer = null;
            if (!$6b17f08f738443dc$var$_bootLoaderOwnerAlive(el, owner)) {
                $6b17f08f738443dc$var$_dropReadyHold(el);
                return;
            }
            $6b17f08f738443dc$var$_endReadyHold(el, owner.root);
        }, $6b17f08f738443dc$var$_READY_HOLD_CAP_MS);
        el._readyHoldTimer = holdTimer;
    }
    // Boot timeline marks (read with performance.getEntriesByType('mark')):
    // one per EDGE, so a boot can be audited after the fact — which flag
    // armed the loader, when it fell, and whether it re-armed after the
    // spiral handoff (2026-09-02 per Nika "spiral loader loads twice").
    if (el._loaderMarked !== active) {
        el._loaderMarked = active;
        $6b17f08f738443dc$var$_bootMark(active ? 'wsboot:loader:on:' + [
            'loading',
            '_wsSwitching',
            '_wpSwitching',
            '_loginLoading',
            '_dataLoading',
            '_langOwed'
        ].filter((k)=>root[k]).join('+') : 'wsboot:loader:off');
    }
    if (active) el._loaderSeenActive = true;
    $6b17f08f738443dc$var$_trackLoaderMotion(el, $6b17f08f738443dc$var$_loaderFillStage(root), active || el._readyHold === true);
    // Before the status, and before the stuck-error return below: the overlay's
    // own copy is useless to a Georgian workspace until it knows the language.
    $6b17f08f738443dc$var$_publishBootLang(root.lang);
    const bootReady = typeof window !== 'undefined' && !!window.__smblsBootReady;
    if (active && !bootReady) $6b17f08f738443dc$var$_armLoaderMax(el, owner);
    else $6b17f08f738443dc$var$_clearLoaderMax(el);
    // the stuck error stays on screen until the loader comes down
    if (el._loaderStuck) return active;
    $6b17f08f738443dc$var$_publishBootStatus($6b17f08f738443dc$var$_loaderStatus(root));
    if (active || !root._authReady) $6b17f08f738443dc$var$_cancelBootReady(el);
    else if (typeof window !== 'undefined' && window.__smblsBootReady) $6b17f08f738443dc$var$_publishBootStatus({
        phase: 'ready',
        step: 3
    });
    else if (typeof window !== 'undefined' && !window.__smblsBootReady && (el._loaderSeenActive || root._authReady) && el._bootReadyTimer == null) {
        const timer = setTimeout(()=>{
            // A cancelled callback may already be queued. It cannot clear a newer timer.
            if (el._bootReadyTimer !== timer) return;
            el._bootReadyTimer = null;
            if (!$6b17f08f738443dc$var$_bootLoaderOwnerAlive(el, owner) || window.__smblsBootReady) return;
            if ($6b17f08f738443dc$var$_isLoaderActive(owner.root) || !owner.root._authReady) return;
            window.__smblsBootReady = true;
            if (typeof performance !== 'undefined' && performance?.now) window.__smblsBootReadyAt = performance.now();
            $6b17f08f738443dc$var$_bootMark('wsboot:boot-ready');
            $6b17f08f738443dc$var$_publishBootStatus({
                phase: 'ready',
                step: 3
            });
            try {
                window.dispatchEvent(new Event('smbls:boot-ready'));
            } catch (_) {
            /* noop */ }
        }, 400);
        el._bootReadyTimer = timer;
    }
    return active;
};
// The shell root's base styles come from packages/shared/components/
// AppShell.js `appShellStyles` — the single source of truth — resolved BY
// KEY through the DOMQL extends chain, deliberately not by module-scope
// spread and not by per-key factories:
//   • NOT `...appShellStyles` — that spread evaluates at module scope and
//     crashed the PRODUCTION BUILD ("Cannot destructure property
//     'appShellStyles' of '...default.components' as it is undefined",
//     smbls push, tickets/execution-board.md §1): workspace-shell's own
//     identity-index.js → pages/admin/* cycle can leave `_wsShared`
//     mid-construction when Parcel runs this module's top level.
//   • NOT per-key factories (`gridTemplateColumns: () => getAppShellStyles()
//     .gridTemplateColumns`, the 2026-08-13 f85b5f557 shape) — a factory-
//     valued CSS prop is applied INLINE by the framework, and an inline
//     `grid-template-columns: 1fr` outranks the attribute-keyed stylesheet
//     rule `html[data-assistant-dock] [data-key="smblsapp"]{grid-template-
//     columns:1fr min(var(--assistant-width),50vw)}` (injected below) that
//     reserves the AI-drawer column. From that commit on the drawer only
//     OVERLAID the content — SHELL-ASSISTANT-RESERVE-1 (Nika 2026-08-16:
//     "opening ai sidebar does not shift content on / page anymore").
//     Same for `transition` (inline `margin-right 200ms` beat the injected
//     `grid-template-columns .22s` shrink).
// `extends: ['appShellStyles']` is read from `context.components` at CREATE
// time (the shared library registers it under exactly that key —
// mergeSharedLibraries copies every components key), long after every
// module finished loading, and merges the values as STATIC props → atomic
// classes, which the attribute rules outrank again. `marginRight` stays the
// reactive factory it always was inside appShellStyles. ARRAY form on
// purpose: smbls normalises the ROOT app's `extends` through
// `initializeExtend` (createDomql.js → syncExtend.js), which keeps only an
// object-like value and drops a bare string to `[]` — measured live: the
// string form left the shell root `display: block` with no width/theme.
// ── Deferred shell subtrees (WS-SHELL-MOUNT-TREE-BUILD-2700MS-1) ─────────
// The shell boot builds ONE synchronous element tree. Measured on
// workspace.localhost/w/system/hq (imac-ws-39, in-framework phase profiler):
// 4012 elements, LINEAR at ~2 ms each, 2727 ms in a single task. Three
// top-level subtrees are 991 of those elements and 1848 ms of that task —
// and NONE of them is on screen at first paint:
//   TicketsDetailModal  620 ms / 457 el
//   AssistantDrawer     760 ms / 288 el
//   ModalRoot           468 ms / 246 el
//
// They now carry an `if:` latch. smbls `create()` returns EARLY on a false
// `if:` — before createChildren / registerEffects / applyStaticMixins — so
// the subtree is never built, while `registerIfEffect` keeps the element
// reactive so the FIRST true evaluation runs the full creation in place,
// under the same key and the same parent chain (no slot, no `set()`
// indirection, so bare-key resolution and `resolveModalRoot`'s tree walk
// are both unchanged).
//
// Every latch is ONE-WAY: once a subtree has been built it stays built, and
// its pre-existing `hide:` predicate owns visibility from then on. So after
// the first open the runtime shape is byte-identical to the eager mount —
// no re-create on close, no lost chat scroll, no lost modal state.
const $6b17f08f738443dc$var$_latchOnce = (el, flag, need)=>{
    if (el[flag]) return true;
    if (!need) return false;
    el[flag] = true;
    return true;
};
// TicketsDetailModal's `if:` is functions/ticketDetailModalLoad.js
// `needTicketDetailModal`. Need = a seeded `selectedTicket`, the /ticket/:id
// full page, or a `?ticket=<id>` deep link (its own onCreate owns the URL
// restore, so a boot that carries the param must build it). Not reactive by
// itself: the `_routeNudge` selector in its `ifDeps` re-evaluates it on a
// client-side navigation. The modal's MODULE is loaded and folded on first
// need, and the latch opens once `_ticketModalReady` flips - smbls >= 3.14.798
// re-merges the parked element with the now-registered component. Same
// one-way `__wsDeferredMounted` latch as the others.
// ── Staged mount ladder (WS-SHELL-BOOT-TASK-LOAF-ACCEPTANCE-1) ───────────
// The three latches above take a subtree out of the boot task ENTIRELY, until
// a user action asks for it. That is the right trade for a modal or a drawer,
// and it is not the right trade for shell chrome that must simply BE there —
// the dropdown/tooltip hosts, the toast host, the presence dock, the gates.
// Those keep their eager semantics; they only stop being built in the SAME
// task as the rest of the shell.
//
// `_shellStage` is the ladder's counter (functions/shellStages.js): the shell
// root's onCreate starts it, and it steps 1 → 2 → 3 one macrotask apart right
// after the mount. Reading `s.root._shellStage` inside `if:` is what registers
// the dependency, so each step builds exactly that stage's subtrees and
// nothing else — one long task becomes four bounded ones.
//
// The latch is ONE-WAY, exactly like the three above: once a subtree is built
// its own `hide:` predicate owns visibility again, so past the ladder the
// runtime shape is identical to an eager mount.
//
// MEASURED, so the next reader does not re-derive it (dev.my.symbols.app,
// visible tab, /w/silverbreeze-labs, 2026-08-28): the mounted shell tree is
// 2532 DOM nodes, of which the route content is 1569 (62%) and AppHeader 70.
// The stageable chrome below is the rest. Route content is NOT stageable —
// smbls' router renders the entry route inside the same `create()` call
// (workspace/index.js dispatches no initial route of its own), so cutting
// that last block needs `createChildren` itself to yield — the framework half
// this ticket family already tracks separately.
const $6b17f08f738443dc$var$_atStage = (stage)=>(el, s)=>$6b17f08f738443dc$var$_latchOnce(el, '__wsDeferredMounted', (s?.root?._shellStage || 0) >= stage);
// ── SPA-navigation guards (FA503) ──────────────────────────────────────────
// Both of these ran as raw `window.addEventListener('locationchange' |
// 'popstate', …)` pairs armed from shellApp.onCreate, each parked on an
// element latch nothing ever removed. They are module-scope functions now,
// driven by the shell root's declared `onWindowLocationchange` /
// `onWindowPopstate`. ONE declared prop can carry ONE handler per event, so
// the two guards are composed there, in their original registration order:
// the dropdown closer ran first (onCreate armed it first) and still does.
// Close any open dropdown layer on SPA navigation — the DropdownRoot lives at
// the shell root, so an open menu otherwise SURVIVES route changes as a stale
// (now-empty) glass panel (observed 2026-06-10 on /studio → /team-and-agents
// with the create menu open). AppShell's patched history dispatches
// `locationchange` on push/replace; `popstate` covers back/forward.
//
// Close on REAL navigation only — a PATHNAME change. `locationchange` fires on
// EVERY patched push/replaceState; same-URL no-op writes are guarded at their
// sources now, but slot-hosted pages also legitimately edit the QUERY/HASH in
// place (?page= slot sync, tickets ?ticket=, chat ?channel=, notes #note=) —
// in-route state, not navigation. An open dropdown must survive those;
// outside-click + ESC (owned by DropdownRoot) handle within-route dismissal.
// The full-href version of this guard still let every param edit dismiss
// chrome dropdowns whenever a PageSlot was active (2026-08-06, the "dropdowns
// are having problems opening when PageSlot is active" class).
//
// `_lastNavPath` was a closure variable; a declared prop has no closure, so it
// lives on the element — same value, same lifetime, no module-scope state that
// two shells in one process would share.
const $6b17f08f738443dc$var$_closeDropdownOnNav = (el)=>{
    if (typeof window === 'undefined' || !el?.node) return; // FA210 — bypass render
    const path = window.location.pathname;
    if (path === el.__lastNavPath) return;
    el.__lastNavPath = path;
    try {
        el.call('closeDropdown');
    } catch (err) {
        console.warn('[shell] closeDropdown on nav failed:', err);
    }
};
const $6b17f08f738443dc$var$_authRouteGuardTick = (el, s)=>{
    if (typeof window === 'undefined') return; // FA210 — bypass render
    try {
        if ((0, $kuISg.hasSessionToken)()) return;
        // Auth is TRI-STATE here, and "not resolved yet" is NOT "signed out".
        // `signedIn` is a plain boolean defaulting to false (state.js), so
        // before the seed lands it is indistinguishable from a real sign-out
        // — which is exactly how a signed-in deep link bounced through
        // /login: this guard's mount-time run used to execute ~30 lines
        // BEFORE the `preResolvedAuth` seed, so it read `signedIn: false` on
        // a fully authed session and hard-redirected. `_authReady` is the
        // flag that says the getMe snapshot has been applied; until it flips
        // there is nothing to decide on, so bail.
        //
        // Trusting the seed over a transient synchronous token read also
        // keeps the earlier fix intact: on slow devices hasSessionToken()
        // can miss DURING boot (the MWT canonicalize `replaceState` fires a
        // `locationchange` before the credential settles), and bouncing a
        // KNOWN-authed user then caused a `/`↔`/login` reload loop (the
        // reverted 2026-07-20 default-on incident; iPad-only). A real
        // sign-out clears `signedIn` with `_authReady` still true, so
        // genuine unauth still redirects.
        if (!s?._authReady) return;
        if (s.signedIn) return;
        const path = window.location.pathname;
        if ($6b17f08f738443dc$var$isGuestAllowedPath(path)) return;
        // /s/<token> — the public share-link viewer (PUBLIC-SHARE-LINKS-1).
        // The canonical guest allowlist lives in the SHARED package
        // (guestRoutes.js) and this squad does not own it, so the shell
        // exempts its own public route here — the same place the shell
        // already decides what its chrome does on a nav. The recipient of a
        // shared file or note has no account by design: the token IS the
        // credential, so a bounce here makes every shared link unopenable
        // for exactly the people it was created for. Kept byte-identical in
        // shape to the entry gate's prefix (index.js publicPathPrefixes) so
        // the two cannot disagree about what a share URL looks like.
        if ((0, $1nnHq.isPublicShareViewPath)(path)) return;
        // LOGINLOOP-1 (Nika 2026-08-16, mobile): this used to be
        //   encodeURIComponent(path + window.location.search)
        // which appended the CURRENT search verbatim. When that search
        // already carried a `next`, the value got wrapped instead of reused,
        // so every bounce nested one level deeper:
        //   /?next=%2F  ->  /login?next=%2F%3Fnext%3D%252F  ->  …
        // On mobile the boot race this guard already documents (a
        // `locationchange` fires before the credential settles) makes the
        // guard run repeatedly mid-boot, so the nesting became a visible
        // reload/loading loop.
        //
        // Two rules, owned by the TESTED helper every other /login bounce already
        // calls (shared functions/resolveAuthNext.js — bootShell.js ×3,
        // functions/auth.js). This guard carried the last inline copy of it:
        //   1. an existing `next` is REUSED, never re-wrapped — and unwrapped
        //      REPEATEDLY, because the reported URL was already nested two deep;
        //   2. bare `/` produces a plain `/login` with no noise `?next=/`.
        // Only the URL arithmetic moved. WHEN this guard fires (`_authReady`,
        // `signedIn`, the public-path exits above) is untouched — that timing has
        // its own reverted-loop precedent (2026-07-20, iPad).
        const next = (0, $1X0Je.default).functions.resolveAuthNext(path, window.location.search);
        window.location.replace(next ? `/login?next=${encodeURIComponent(next)}` : '/login');
    } catch (err) {
        console.warn('[shell] auth route guard failed:', err);
    }
};
// Close the calendar event popover when a navigation leaves its event. The
// popover is a global windows layer like the dropdown, so it SURVIVED route
// changes: Back from `/calendar?event=A` to the AI thread left event A open
// over the thread. Runs on popstate (Back / Forward, same path or not) and on
// a PATHNAME change; never on an in-route replaceState — the calendar writes
// its own `#date=` / `?event=` sync that way. The helper keeps the popover
// while `?event=` still names the open event
// (functions/eventDetailModal.js `closeStaleEventDetailModal`).
const $6b17f08f738443dc$var$_closeEventPopoverOnNav = (e, el, pathChanged)=>{
    if (typeof window === 'undefined' || !el?.node) return; // FA210 — bypass render
    if (e?.type !== 'popstate' && !pathChanged) return;
    try {
        el.call('closeStaleEventDetailModal');
    } catch (err) {
        console.warn('[shell] event popover close on nav failed:', err);
    }
};
// ONE handler for both SPA navigation events (`locationchange` from the
// patched history, `popstate` for back/forward): close the open dropdown and
// a stale event popover, then run the auth guard — in that order. It was
// written out twice.
const $6b17f08f738443dc$var$_onSpaNavigation = (e, el, s)=>{
    // The dropdown closer re-seeds `__lastNavPath` on a pathname change only,
    // so a moved value IS the path change — one reader of the path for both.
    const fromPath = el?.__lastNavPath;
    $6b17f08f738443dc$var$_closeDropdownOnNav(el);
    $6b17f08f738443dc$var$_closeEventPopoverOnNav(e, el, el?.__lastNavPath !== fromPath);
    $6b17f08f738443dc$var$_authRouteGuardTick(el, s);
};
// The shell root's create pass — the shell's own auth subscription, data
// load, analytics and listeners. app.onCreate below runs it at once on a
// parcel boot (bootShell settled the boot before create()), and after the
// boot settles on the published shell (see app.onCreate).
const $6b17f08f738443dc$var$_shellOnCreate = (el, s)=>{
    // Boot segment G (BOOT-8S.md): the shell root is being created.
    (0, $iI0D7.bootMark)('wsboot:shell:create');
    // Scheme A URL parsing (`/w/<org>/<ws-handle>/<route…>`): segment 2 is a
    // workspace IFF the session knows a workspace of that org by that handle
    // — this resolver is that knowledge, reading the LIVE root each call so
    // claims refreshes are picked up automatically. Registered before any
    // route dispatch (bootShell dispatches after create()); until claims
    // land, unmatched segments read as routes on the HQ — the legacy
    // interpretation — and the boot canonicalizer re-stamps once they do.
    $6b17f08f738443dc$var$registerWorkspaceHandleResolver((orgSlug, seg)=>{
        const root = s.root;
        const want = String(seg ?? '').toLowerCase();
        if (!want) return false;
        // Fast path, list-independent: the ACTIVE workspace record itself. On a
        // 2-segment boot the segment IS the active workspace by construction
        // (boot resolved it from the URL), and root.workspace is a full record
        // — so this recognizes the handle even when the workspaces lists are
        // still empty (SDK-only sessions fill them late, and ticks can wipe
        // them).
        const aw = root?.workspace;
        const rOrg = root?.org;
        if (aw && rOrg && (rOrg.slug === orgSlug || rOrg.username === orgSlug)) {
            const awOrgId = String(aw.org_id ?? aw.organization ?? '');
            const rOrgId = String(rOrg.id ?? rOrg._id ?? '');
            if (!awOrgId || !rOrgId || awOrgId === rOrgId) {
                const own = [
                    aw.slug,
                    aw.key,
                    aw.id ?? aw._id
                ].filter(Boolean).map((v)=>String(v).toLowerCase());
                if (own.includes(want)) return true;
            }
        }
        const orgs = Array.isArray(root?.orgs) ? root.orgs : [];
        const org = orgs.find((o)=>o && (o.slug === orgSlug || o.username === orgSlug));
        if (!org) return false;
        const oid = String(org.id ?? org._id ?? '');
        const fromMap = root?.orgWorkspaces?.[oid];
        const list = Array.isArray(fromMap) ? fromMap : Array.isArray(root?.workspaces) ? root.workspaces : [];
        return !!$6b17f08f738443dc$var$findWorkspaceInOrg(oid, list, seg);
    });
    // Feature flags: mirror the cached per-workspace overrides onto root
    // state before children render, so navigation gates resolve on first
    // paint (server truth takes over when root.workspace lands).
    // KEPT EAGER (iPad P1 boot audit): pre-first-paint by DESIGN — nav
    // gates read these on their first render; deferring re-introduces the
    // gate flash. Cost is one localStorage read + JSON.parse (marks prove
    // it's sub-ms — check the wsboot:feature-flags measure).
    (0, $iI0D7.bootMark)('wsboot:feature-flags:start');
    (0, $gOQVi.hydrateFeatureFlags)(s.root);
    (0, $iI0D7.bootMark)('wsboot:feature-flags:end');
    (0, $iI0D7.bootMeasure)('wsboot:feature-flags', 'wsboot:feature-flags:start', 'wsboot:feature-flags:end');
    el.call?.('installAppShellSync', s);
    // Start the staged-mount ladder (WS-SHELL-BOOT-TASK-LOAF-ACCEPTANCE-1).
    // Scheduled from HERE on purpose: `onCreate` runs while the root is being
    // created, so the first tick it queues cannot possibly run until the whole
    // synchronous mount has drained — the exact task boundary the stages need.
    // Every stage is a macrotask of its own, so the boot's one long build
    // becomes several bounded ones. See functions/shellStages.js.
    (0, $hO9x8.startShellStageLadder)(s.root);
    // Register the shell state root so reactivateWorkspaceModule (driven from
    // the marketplace's isolated window-layer, which can't reach this root via
    // the element tree) can hot-activate installs/uninstalls live — without it
    // the navbar only updated on reload.
    (0, $79OEu.registerShellRoot)(s.root);
    // Both SPA-navigation guards below — the dropdown closer and the auth
    // route guard — are DECLARED on this root as `onWindowLocationchange` /
    // `onWindowPopstate` (see above). They used to be four raw
    // `window.addEventListener` calls fired from here behind two element
    // latches (`el.__dropdownNavCloser`, `el.__authRouteGuard`) that nothing
    // ever removed — the latches existed only because the registration had no
    // owner. A declared prop has one, so both are gone (FA503).
    //
    // Seed the closer's "last path" the way the old closure did at arm time
    // (`let _lastNavPath = window.location.pathname`). Without the seed the
    // FIRST same-path `replaceState` of the boot would read as a real
    // navigation and fire one extra closeDropdown.
    if (typeof window !== 'undefined') el.__lastNavPath = window.location.pathname;
    // Synchronously seed auth state from bootShell's pre-resolved
    // snapshot (computed off `sdk.getMe()` BEFORE create()). This
    // makes the shell mount with `signedIn / jwtClaims / orgs /
    // workspace / org / currentUserEmail / ...` already populated, so
    // every reactive consumer (NoOrgOverlay, AppHeader chrome, …) gets
    // the correct frame on its FIRST render instead of flashing
    // empty/default values between mount and the async
    // subscribeAuthSession registration. `_authReady` flips here so
    // gates that need an explicit "auth resolved" signal can wait.
    // Anonymous boot (no user): no snapshot, but we still flip
    // `_authReady` immediately — the modal hides on `!signedIn` anyway,
    // and consumers shouldn't block waiting for an auth event that
    // will never fire.
    // Seed the live route synchronously, alongside the auth snapshot.
    // `currentPath` defaults to '/' in the state schema (state.js) and is
    // only synced to the real URL by the smbls router AFTER first paint.
    // So on a hard load of an auth route (/login, /signup, …) the
    // AppHeader's route-based `hide:` first evaluated against '/' — not an
    // AUTH_PATH_RE match → the dashboard chrome SHOWED — then the router
    // corrected `currentPath` to /login and the chrome hid. That one-frame
    // chrome flash reads as "loading dashboard → login screen".
    //
    // onCreate runs before any child renders (same guarantee the
    // preResolvedAuth seed below relies on — see the AppHeader chrome note
    // above), so seeding the real path here makes every route-dependent
    // binding paint the correct frame first. The router sets the same
    // value on its own init, so this is idempotent (no extra dispatch).
    const _livePath = typeof window !== 'undefined' ? window.location.pathname : '/';
    const _liveSearch = typeof window !== 'undefined' ? window.location.search : '';
    const _preAuth = el.context?.preResolvedAuth || null;
    if (_preAuth) {
        s.root.update({
            ..._preAuth,
            currentPath: _livePath,
            currentSearch: _liveSearch,
            _authReady: true,
            // A session exists → the data load WILL run. Arm the loader gate NOW,
            // synchronously at mount: loadPrivateData only fires from the async
            // subscribeAuthSession callback, and in that window the gate read
            // inactive — firing the boot-ready handoff prematurely and unveiling
            // the second loader (the boot double-load flicker). loadPrivateData's
            // finally clears it. Anonymous boots skip this (no data load — the
            // spiral hands off to /login immediately).
            _dataLoading: true
        });
        // Kick the private-data load NOW, synchronously at mount. It used to
        // fire only from subscribeAuthSession's async INITIAL_SESSION callback,
        // which lands seconds after mount (measured 2.9s of dead boot time
        // locally: loadPrivateData started at t=9.8s with the shell mounted at
        // ~6.9s). The claims are already seeded in this very update; the
        // _loadInFlight latch inside loadPrivateData turns the later
        // subscribe-driven call into a no-op instead of a duplicate, and its
        // own no-active-workspace canary keeps the anonymous/cold cases safe.
        try {
            (0, $jZ5ZE.loadPrivateData)(s.root, el.sdk || el.context?.methods?.sdk, {
                bootPayload: el.context?.bootPayload || null
            });
        } catch (err) {
            console.warn('[shell] early loadPrivateData kick failed:', err?.message || err);
        }
    } else s.root.update({
        currentPath: _livePath,
        currentSearch: _liveSearch,
        _authReady: true
    });
    // A FLY ARRIVAL, read HERE — before any page strips `fly` from the address
    // (functions/onboarding.js onboardingNoteFlyArrival): the mark keeps the
    // new-account hold down and the full wizard closed for this load. It
    // writes no decision; Fly's own `pending` record is what owes the ready
    // screen.
    try {
        el.call?.('onboardingNoteFlyArrival', s.root, _liveSearch);
    } catch (err) {
        console.warn('[shell] fly arrival mark failed:', err?.message || err);
    }
    // NOW run the mount-time auth check — `_authReady` is true and `signedIn`
    // carries the server-verified answer, so the guard decides on real state
    // instead of on schema defaults. (Registration happened above; this is the
    // deferred one-shot run.)
    $6b17f08f738443dc$var$_authRouteGuardTick(el, s);
    // Seed the member roster at shell mount from the composite response, or
    // the legacy entry prime. The response must still belong to this workspace;
    // a legacy promise must also match the URL org and cannot land after a
    // tenant switch. Peek, don't consume: loadPrivateData shares the result.
    try {
        const rosterWorkspaceId = String(s.root.workspace?.id || s.root.workspace?._id || '');
        const rosterOrgId = String(s.root.org?.id || s.root.org?._id || '');
        const bootPayload = el.context?.bootPayload;
        const urlOrgSlug = (/^\/w\/([^/]+)/.exec(_livePath) || [])[1]?.toLowerCase() || null;
        const earlyRoster = rosterWorkspaceId && String(bootPayload?.workspaceId || '') === rosterWorkspaceId && Array.isArray(bootPayload?.members) ? Promise.resolve(bootPayload.members) : !urlOrgSlug || (0, $cKmtB.primedOrgSlug)() === urlOrgSlug ? (0, $cKmtB.peekPrimedPeople)() : null;
        earlyRoster?.then((rows)=>{
            if (String(s.root.workspace?.id || s.root.workspace?._id || '') === rosterWorkspaceId && String(s.root.org?.id || s.root.org?._id || '') === rosterOrgId && Array.isArray(rows) && !(s.root.people || []).length) {
                const mapped = rows.map((0, $jZ5ZE._person));
                s.root.update({
                    peopleAll: mapped,
                    people: mapped,
                    peopleLoaded: true,
                    peopleError: null
                });
            }
        }).catch(()=>{});
    } catch (_) {
    /* prime not active */ }
    // Resolve the unified AI service once at boot and cache it in the
    // shared aiService singleton. DOMQL factories (CanvasPromptTextarea
    // ParamsBtn picker, AppAssistant, ticket AI surfaces) read it back
    // synchronously via `getAiService()`. Storing it on root state
    // doesn't work — smbls' state clone strips the class prototype,
    // leaving plain own properties that lose getMode() / dispatch() /
    // setMode() etc.
    //
    // After resolution we bump `_aiSvcReady` in root state so reactive
    // factories that gate on the service's availability re-fire once
    // it's mounted.
    try {
        const _sdk = el.sdk;
        if (_sdk && typeof _sdk.getService === 'function') // `resolveAiService` reads straight off the `_wsShared` bare import
        // already at the top of this file — no separate dynamic import of a
        // deep aiService.js subpath needed (that subpath can't resolve
        // through the platform's public importmap once this package is
        // pushed as a library, tickets/execution-board.md §1 P0; the whole
        // package is already loaded by the time this async tail runs).
        Promise.resolve((0, $1X0Je.default).functions.resolveAiService(_sdk)).then(()=>{
            s.root?.update?.({
                _aiSvcReady: true
            });
            // Install the simone-bridge → sdk.ai adapter so the
            // workspace Chat surface can dispatch through the unified
            // SDK without needing a real local bridge. This flips
            // `bridgeStatus` to 'open' so the composer enables its
            // Send button.
            el.call?.('installSimoneAiTransport', el);
            // `?aiChatSession=<threadId>` deep-link — opened by the
            // chrome-connect extension's logo/avatar click (see
            // `extensions/packages/ext-ui/symbols/pages/home.js`'s
            // `_openSessionOnSymbolsApp`). Hydrates the matching thread
            // into the AppAssistant drawer and opens it. Best fired
            // after `_aiSvcReady` so `sdk.getService('aiChat')` is up.
            try {
                const _qs = typeof URLSearchParams !== 'undefined' ? new URLSearchParams(_liveSearch || '') : null;
                const _sessionId = _qs ? _qs.get('aiChatSession') : null;
                if (_sessionId) {
                    s.root.update({
                        assistantOpen: true,
                        _aiThreadId: _sessionId
                    });
                    // el.call, not a relative import() — frank cannot rebuild a
                    // project-local dynamic import (shellPublishedEmission.test.js).
                    Promise.resolve(el.call('aiChatLoadThread', s.root, _sessionId)).catch((err)=>console.warn('[shell] aiChatSession hydrate failed:', err?.message || err));
                }
            } catch (err) {
                console.warn('[shell] aiChatSession parse threw:', err?.message || err);
            }
            // `?aiConversation=<id>` — a shared workspace-conversation link
            // (Share in the sessions menu). Opens the drawer and loads the
            // thread through the SAME server-backed switch the history menu
            // uses; a non-owner member can read it when its owner flipped
            // `shared` (the server's one widened read path). Fired here, after
            // `_aiSvcReady`, because switchSession needs the live AI service.
            try {
                const _cq = typeof URLSearchParams !== 'undefined' ? new URLSearchParams(_liveSearch || '') : null;
                const _convId = _cq ? _cq.get('aiConversation') : null;
                if (_convId) {
                    const _openPatch = {
                        assistantOpen: true
                    };
                    if (s.root.assistantDock === 'minimized') _openPatch.assistantDock = 'right';
                    s.root.update(_openPatch);
                    el.call?.('switchSession', _convId);
                }
            } catch (err) {
                console.warn('[shell] aiConversation link threw:', err?.message || err);
            }
            // `?prompt=<text>` landing hand-off
            // (WS-WORKSPACE-CONSUMES-THE-PROMPT-QUERY-FROM-THE-LANDING-HERO-
            // COMPOSER-1, supersedes this block's original WS-LANDING-PROMPT-
            // HANDOFF behaviour) — the marketing hero (company/landing
            // PromptBar + RevealEndCard) redirects to
            // `my.symbols.app/?prompt=<encoded>`. PREFILL the shell composer
            // with it — cursor at the end, nothing sent on the visitor's
            // behalf — via the bridge CanvasPromptTextarea's own onCreate
            // registers (this handler runs in the shell root's state scope,
            // a DIFFERENT DOMQL scope than that component's local `draft`).
            // The UNAUTHed path needs no code here — the security guard above
            // captures `path + search` into `?next=`, stashOAuthNext survives
            // the provider hop, and the callback replaces back to
            // `/?prompt=…` authed, so this same handler fires post-login for
            // new signups too.
            //
            // ORDER IS THE WHOLE FIX. This block used to strip the param
            // FIRST and call the bridge second, with a `?.` — and the bridge
            // belongs to CanvasPromptTextarea, which mounts 716 ms LATER
            // (measured on the signed-in dev.my seat 2026-09-23). The call
            // no-opped onto an absent bridge while the strip had already
            // deleted the only copy of the visitor's sentence. So now:
            // deliver, park when nobody took it, and strip only once the text
            // is held (functions/inboundPrompt.js owns that contract; the
            // composer drains the park on its own mount, below).
            //
            // On the APP BUILDER's route the prompt is the builder's
            // (`/add-app?prompt=` — functions/addAppPrompt.js starts a new
            // build thread with it): the home composer never also takes it.
            try {
                const _promptForBuilder = (0, $azpxa.inboundPromptForBuilder)(_livePath);
                let _promptStore = null;
                try {
                    _promptStore = typeof window !== 'undefined' ? window.sessionStorage : null;
                } catch (_) {
                /* sandboxed frame — no park available, and receiveInboundPrompt
                   then KEEPS `?prompt=` rather than eating it */ }
                const _inbound = _promptForBuilder ? {
                    nextHref: null
                } : (0, $azpxa.receiveInboundPrompt)({
                    search: _liveSearch,
                    href: typeof window !== 'undefined' ? window.location.href : '',
                    deliver: (text)=>s.root._prefillHomePrompt?.(text) === true,
                    storage: _promptStore
                });
                if (_inbound.nextHref) try {
                    window.history.replaceState(window.history.state, '', _inbound.nextHref);
                } catch (_) {
                /* replaceState can throw in sandboxed frames — non-fatal */ }
            } catch (err) {
                console.warn('[shell] landing prompt hand-off threw:', err?.message || err);
            }
        }).catch((err)=>console.warn('[shell] resolve sdk.ai failed:', err?.message || err));
    } catch (err) {
        console.warn('[shell] sdk.ai resolve threw:', err?.message || err);
    }
    // Persist the resolved active-org back to Mongo on first boot when
    // `User.activeOrganization` is null OR differs from the shell's
    // resolved pick. The unified-auth-boot snapshot already picked a
    // default (Mongo → gov JWT → orgs[0]) via _resolveAuthSnapshot, but
    // that pick lives in-memory; without persistence every subsequent
    // server scope check (e.g. /core/analyzed/ingest's `scopedAnalyzed`,
    // which falls back to `req.user.activeOrganization`) keeps seeing
    // the stale/null value and 400s or 401s.
    //
    // The "differs" branch covers the root cause of GH #2238: when
    // `User.activeOrganization` is set to a personal org that has no
    // associated Workspace document (or no federated home workspace),
    // the SDK-Mongo auth path returns "no active workspace for user" →
    // 401 for tickets/chat/documents/etc. The shell's snapshot resolver
    // picks the correct TEAM org (governance JWT → orgs[0] fallback), so
    // writing it back to Mongo before `loadPrivateData` fires ensures the
    // userResolver finds the right workspace on the FIRST request — not
    // only after an explicit org switch.
    //
    // Fire-and-forget — `sdk.setActiveOrganization` PATCHes
    // /auth/me/active-org, hydrates `_currentUser.activeOrganization`,
    // and best-effort refreshes federation claims. Failures don't
    // block boot (and the next /auth/me re-derives the snapshot
    // anyway), but the happy path makes the user's active-org choice
    // sticky from this moment on.
    try {
        const _me = el.sdk?._currentUser || null;
        const _resolvedOrgId = _preAuth?.org?.id || null;
        const _mongoOrgId = _me?.activeOrganization ? String(_me.activeOrganization) : null;
        // Only persist on a trustworthy membership list (never a gov-only fallback
        // guess). Still persists the #2238 correction — the team org is in
        // user.organizations. Without this, _resolvedOrgId can be an orgs[0] guess
        // from a partial list, and persisting that rotates the active org on reload.
        // WHITELABEL-STRICT-TENANT-SCOPE-1 — never from a white-label host: there
        // the resolved org is the HOST's binding (the boot states it in memory),
        // not the account's choice, and persisting it would move the account's
        // my.symbols tabs onto the customer's workspace after one visit.
        const _needsPersist = _resolvedOrgId && _me && _mongoOrgId !== _resolvedOrgId && (0, $qJ3f5.hasTrustedOrgList)(_me) && !(0, $lb2Ei.isCustomDomainHost)();
        if (_needsPersist) Promise.resolve(el.sdk.setActiveOrganization(_resolvedOrgId)).catch((err)=>console.warn('[shell] persist activeOrganization failed:', err?.message || err));
    } catch (err) {
        console.warn('[shell] persist activeOrganization threw:', err?.message || err);
    }
    // Hydrate follow list from localStorage so the same follow-state
    // surfaces across workspace + marketplace navigation.
    try {
        const raw = typeof localStorage !== 'undefined' ? localStorage.getItem('marketplace.follows') : null;
        const list = raw ? JSON.parse(raw) : [];
        if (Array.isArray(list) && list.length) s.root.update({
            followingEmails: list.map((e)=>(e || '').toLowerCase())
        });
    } catch (err) {
        console.warn('[shell] follow-list hydrate failed:', err?.message || err);
    }
    // Hydrate the AI assistant dock (right | left | minimized | main) from
    // localStorage so the user's choice survives reloads. Written by
    // setAssistantDock (functions/assistantDock.js); the user record
    // reconciles it once the prefs row lands (loadPrivateData). Invalid /
    // absent → keep the state default ('main', Page — Nika's pick 6 A).
    try {
        const dock = (0, $dp7M8.readStoredAssistantDock)();
        if (dock) s.root.update({
            assistantDock: dock
        });
    } catch (err) {
        console.warn('[shell] assistant-dock hydrate failed:', err?.message || err);
    }
    // The assistant's MODE (fly | assistant | dashboard | …) paints the same
    // way: the stored choice first, the user record reconciles it once the
    // prefs row lands (loadPrivateData). Absent → the state default ('fly',
    // Nika 2026-10-22: "ok make fly default view").
    try {
        // A comm host shows only its own modes (docs/COMM_HOST.md).
        const mode = (0, $ik7KJ.readStoredAssistantMode)();
        if (mode) s.root.update({
            assistantMode: $6b17f08f738443dc$var$commAssistantMode(mode)
        });
    } catch (err) {
        console.warn('[shell] assistant-mode hydrate failed:', err?.message || err);
    }
    // Agent mode (functions/agentMode.js) paints the same way: this device's
    // choice first, the record reconciles it at the prefs load; a
    // `?mode=agent` link enters it for this visit without a write.
    try {
        const agent = (0, $kosYS.readStoredAgentMode)();
        const link = (0, $kosYS.agentModeFromSearch)(typeof window !== 'undefined' ? window.location.search : '');
        if (agent !== null || link) s.root.update({
            ...agent !== null ? {
                agentMode: agent
            } : {},
            ...link ? {
                _agentModeLink: true
            } : {}
        });
    } catch (err) {
        console.warn('[shell] agent-mode hydrate failed:', err?.message || err);
    }
    // The sidebar's remembered width (functions/assistantWidth.js), the same
    // way: this device's copy first, the record reconciles it at the prefs load.
    try {
        const width = (0, $14aeZ.readStoredAssistantWidth)();
        if (width) s.root.update({
            assistantWidth: width
        });
    } catch (err) {
        console.warn('[shell] assistant-width hydrate failed:', err?.message || err);
    }
    // Checks for tips dismissal and updates state accordingly.
    const dismissedTips = [
        '_homeCtxTipDismissed',
        '_studioHelpDismissed',
        '_ticketsHelpDismissed',
        '_tagHelpDismissed' // /team-and-agents + /agents HelpBox
    ].filter((key)=>$6b17f08f738443dc$var$getPref(key) === '1');
    if (dismissedTips.length) s.root.update(Object.fromEntries(dismissedTips.map((key)=>[
            key,
            true
        ])));
    // The person's accessibility choices, read out of localStorage into root
    // state HERE — the shell's own onCreate, before any page renders — so a
    // person who chose larger type or high contrast never sees a frame of the
    // base scale first (2026-09-04 per Nika "add same accessibility options as
    // we have in landing"). `_syncShellRoute` mirrors the result onto <html>
    // and the injected sheet below carries the rules.
    $6b17f08f738443dc$var$applyA11yPrefs(s.root);
    // The smbls default router mounts pages into a 'content' div that sits in
    // the grid's 1fr row. That div has display:flex with overflow:visible by
    // default — it expands beyond the grid cell and the shell clips it, making
    // pages unscrollable. overflow:auto + min-height:0 constrain content to
    // the grid cell so the user can scroll within it.
    //
    // `:where(…)` keeps these defaults at specificity 0 so any page that
    // declares its own overflow (e.g. full-bleed panzoom canvases like
    // /studio/<slug> with `overflow:'hidden'`) wins via its class rule.
    if (typeof document !== 'undefined' && !document.getElementById('__shell-content-scroll')) {
        const s = document.createElement('style');
        s.id = '__shell-content-scroll';
        s.textContent = // Single source of truth for the navbar-clearance top inset shared by
        // the app-route content padding (below) AND the canvas chrome that must
        // line up with a page opened in the CanvasPageSlot (the slot itself,
        // CanvasSidebarIsland, InfraSidebar — all reference var(--shell-top)
        // for their `top`). = spacing token C1 + a 3px navbar-gap nudge —
        // tightened 2026-07-01 (per Nika "big offset top from navbar, make it
        // shared"): was D1 (≈92px, ~2× the 48px header) which left a big empty
        // band; C1 (≈58px) clears the header snugly and, since this is the single
        // source, every aligned surface (app pages, PageSlot, canvas islands)
        // follows in lockstep. Defined here (raw CSS) because a DOMQL component
        // `top: 'calc(var(--spacing-D1) + 3px)'` compiles to an EMPTY atomic rule
        // (`._t-<hash>{}`) and silently never applies — a bare var() reference,
        // by contrast, resolves cleanly (`._t-var--shell-top{top:var(…)}`).
        // Keep the name SHORT: the atomic-CSS engine hashes any prop VALUE longer
        // than 20 chars (`var(--shell-top)` = 16 ✓), and the hashed path also drops
        // the rule body — so a longer var name reintroduces the empty-rule bug.
        // Change the +3px in ONE place here and every aligned surface follows.
        // Register --shell-top as a <length> so its em-based calc COMPUTES AT
        // :root (html font-size) and inherits as a fixed px value. Unregistered,
        // var() substitution re-resolves the calc's `1em` against EACH consumer's
        // own font-size — the canvas rails run fontSize:Z, so the "same"
        // --shell-top gave 49px on InfraSidebar vs 58px on the app content pad
        // (and the D1 rails sat at 74px): three different "aligned" tops.
        // (2026-07-03 per Nika "make sure layout is consistent" across
        // /studio /infra /tickets /agents.)
        '@property --shell-top{syntax:"<length>";inherits:true;initial-value:58px}:root{--shell-top:calc(var(--spacing-C1) + 3px + env(safe-area-inset-top))}@property --prompt-clear{syntax:"<length>";inherits:true;initial-value:56px}:root{--prompt-clear:56px}@property --nav-gap{syntax:"<length>";inherits:true;initial-value:10px}:root{--nav-gap:10px}@property --module-rail-clear{syntax:"<length>";inherits:true;initial-value:0px}:root{--module-rail-clear:0px}@property --toast-clear{syntax:"<length>";inherits:true;initial-value:0px}:root{--toast-clear:0px}:root{--stack-line:calc(var(--prompt-clear) + var(--nav-gap));--slot-bottom:calc(var(--stack-line) + var(--toast-clear))}[data-key="SimoneReasoningPill"],[data-key="SimoneSuggestions"]{bottom:var(--slot-bottom)}@media (min-width:769px){[data-key="SimoneReasoningPill"][data-gauge="composer"]{width:max(var(--prompt-w,0px),var(--spacing-H))!important}}@property --chip-row{syntax:"<length>";inherits:true;initial-value:0px}:root{--chip-row:0px}@property --zoombar-clear{syntax:"<length>";inherits:true;initial-value:0px}:root{--zoombar-clear:0px}@property --calldock-clear{syntax:"<length>";inherits:true;initial-value:0px}:root{--calldock-clear:0px}@media (max-width:768px){:root{--chip-row:calc(var(--spacing-C) + var(--nav-gap))}}@media (max-width:768px){html[data-slot="open"] [data-key="CanvasPromptTextarea"]{z-index:60}}@keyframes simoneSheen{0%{background-position:250% 0}100%{background-position:-120% 0}}[data-key="ThinkingSheen"]{position:absolute;inset:0;border-radius:inherit;background:linear-gradient(100deg,transparent 40%,rgba(255,255,255,0.10) 50%,transparent 60%);background-size:250% 100%;animation:simoneSheen 1.7s ease-in-out infinite}@property --nav-clear{syntax:"<length>";inherits:true;initial-value:48px}:root{--nav-clear:48px}:root{--slot-top:calc(var(--nav-clear) + var(--nav-gap))}:root{--chat-hdr-cap:calc(50% - var(--spacing-F) - var(--spacing-A))}:where([data-key="content"]){overflow:auto;min-height:0}html[data-skin="ambient"] [data-key="smblsapp"] > [data-key="AmbientBackdrop"]{display:block}html[data-motion="reduced"] [data-key="AmbientBackdrop"] > [data-key="SkyNear"],html[data-motion="reduced"] [data-key="AmbientBackdrop"] > [data-key="SkyFar"]{animation:none}html[data-skin="ambient"][data-shell-route="home"] [data-key="smblsapp"] > [data-key="AmbientGround"]{display:block}@keyframes wsGroundRise{from{transform:translateY(100%)}to{transform:translateY(0)}}@keyframes wsSkyAway{from{transform:scaleY(-1)}to{transform:translateY(calc(min(66.667vw, 60vh) * -1)) scaleY(-1)}}@supports (animation-timeline:scroll()){html[data-shell-route="home"] [data-key="smblsapp"]{timeline-scope:--wsHomeScroll}html[data-shell-route="home"] [data-home-board]{scroll-timeline:--wsHomeScroll block}html[data-shell-route="home"] [data-key="smblsapp"] > [data-key="AmbientBackdrop"][data-sky-layout="top"]{animation:wsSkyAway linear both;animation-timeline:--wsHomeScroll;animation-range:0 min(66.667vw, 60vh)}[data-key="smblsapp"] > [data-key="AmbientGround"] > [data-key="Rise"]{animation:wsGroundRise linear both;animation-timeline:--wsHomeScroll;animation-range:max(0px, calc(100% - 40vh)) 100%}html[data-motion="reduced"] [data-key="smblsapp"] > [data-key="AmbientGround"] > [data-key="Rise"]{animation-timing-function:step-end}@media (prefers-reduced-motion:reduce){[data-key="smblsapp"] > [data-key="AmbientGround"] > [data-key="Rise"]{animation-timing-function:step-end}}}@supports not (animation-timeline:scroll()){[data-key="smblsapp"] > [data-key="AmbientBackdrop"][data-sky-layout="top"]{transition:opacity .48s ease-out}html[data-shell-route="home"] [data-key="smblsapp"] > [data-key="AmbientBackdrop"][data-sky-layout="top"][data-sky-away="true"]{opacity:0}html[data-motion="reduced"] [data-key="smblsapp"] > [data-key="AmbientBackdrop"]{transition:none}@media (prefers-reduced-motion:reduce){[data-key="smblsapp"] > [data-key="AmbientBackdrop"]{transition:none}}[data-key="smblsapp"] > [data-key="AmbientGround"] > [data-key="Rise"]{transition:transform .48s ease-out}[data-key="smblsapp"] > [data-key="AmbientGround"][data-ground="in"] > [data-key="Rise"]{transform:translateY(0)}html[data-motion="reduced"] [data-key="smblsapp"] > [data-key="AmbientGround"] > [data-key="Rise"]{transition:none}@media (prefers-reduced-motion:reduce){[data-key="smblsapp"] > [data-key="AmbientGround"] > [data-key="Rise"]{transition:none}}}html[data-skin="ambient"]:not([data-whitelabel]) #main-loader > [data-key="LoaderRange"]{display:block}#main-loader[data-stage="1"] > [data-key="LoaderRange"] > [data-key="RangeFront"]{animation:wsLoaderFrontSession 12s cubic-bezier(.1,.7,.2,1) forwards}#main-loader[data-stage="1"] > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"]{animation:wsLoaderArtSession 12s cubic-bezier(.1,.7,.2,1) forwards}#main-loader[data-stage="2"] > [data-key="LoaderRange"] > [data-key="RangeFront"]{animation:wsLoaderFrontWorkspace 24s cubic-bezier(.1,.7,.2,1) forwards}#main-loader[data-stage="2"] > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"]{animation:wsLoaderArtWorkspace 24s cubic-bezier(.1,.7,.2,1) forwards}#main-loader[data-stage="3"] > [data-key="LoaderRange"] > [data-key="RangeFront"]{transform:translateY(0);animation:wsLoaderFrontReady .48s ease-out forwards}#main-loader[data-stage="3"] > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"]{transform:translateY(0);animation:wsLoaderArtReady .48s ease-out forwards}@keyframes wsLoaderFrontSession{from{transform:translateY(calc(var(--ws-loader-from, 1) * 100%))}to{transform:translateY(70%)}}@keyframes wsLoaderArtSession{from{transform:translateY(calc((55vh + 44px) * -1 * var(--ws-loader-from, 1)))}to{transform:translateY(calc((55vh + 44px) * -0.7))}}@keyframes wsLoaderFrontWorkspace{from{transform:translateY(calc(var(--ws-loader-from, 0.65) * 100%))}to{transform:translateY(34%)}}@keyframes wsLoaderArtWorkspace{from{transform:translateY(calc((55vh + 44px) * -1 * var(--ws-loader-from, 0.65)))}to{transform:translateY(calc((55vh + 44px) * -0.34))}}@keyframes wsLoaderFrontReady{from{transform:translateY(calc(var(--ws-loader-from, 0.3) * 100%))}to{transform:translateY(0)}}@keyframes wsLoaderArtReady{from{transform:translateY(calc((55vh + 44px) * -1 * var(--ws-loader-from, 0.3)))}to{transform:translateY(0)}}html[data-loader="rise"] #main-loader[data-stage="1"] > [data-key="LogoLoader_1"]{animation:wsLoaderFillSession 12s cubic-bezier(.1,.7,.2,1) forwards}html[data-loader="rise"] #main-loader[data-stage="2"] > [data-key="LogoLoader_1"]{animation:wsLoaderFillWorkspace 24s cubic-bezier(.1,.7,.2,1) forwards}html[data-loader="rise"] #main-loader[data-stage="3"] > [data-key="LogoLoader_1"]{clip-path:inset(0 0 0 0);animation:wsLoaderFillReady .48s ease-out forwards}@keyframes wsLoaderFillSession{from{clip-path:inset(calc(var(--ws-loader-from, 1) * 100%) 0 0 0)}to{clip-path:inset(70% 0 0 0)}}@keyframes wsLoaderFillWorkspace{from{clip-path:inset(calc(var(--ws-loader-from, 0.65) * 100%) 0 0 0)}to{clip-path:inset(34% 0 0 0)}}@keyframes wsLoaderFillReady{from{clip-path:inset(calc(var(--ws-loader-from, 0.3) * 100%) 0 0 0)}to{clip-path:inset(0 0 0 0)}}#main-loader > [data-key="LogoLoader"] svg path{fill-opacity:.14;stroke:currentColor;stroke-width:.7;stroke-linejoin:round;stroke-dasharray:242;stroke-dashoffset:242}#main-loader[data-stage="1"] > [data-key="LogoLoader"] svg path{animation:wsLoaderDrawSession 12s cubic-bezier(.1,.7,.2,1) forwards,wsLoaderMarkShimmer 2.4s ease-in-out infinite}#main-loader[data-stage="2"] > [data-key="LogoLoader"] svg path{animation:wsLoaderDrawWorkspace 24s cubic-bezier(.1,.7,.2,1) forwards,wsLoaderMarkShimmer 2.4s ease-in-out infinite}#main-loader[data-stage="3"] > [data-key="LogoLoader"] svg path{stroke-dashoffset:0;fill-opacity:1;animation:wsLoaderDrawReady .48s ease-out forwards}@keyframes wsLoaderDrawSession{from{stroke-dashoffset:calc(242px * var(--ws-loader-from, 1))}to{stroke-dashoffset:169.4}}@keyframes wsLoaderDrawWorkspace{from{stroke-dashoffset:calc(242px * var(--ws-loader-from, 0.65))}to{stroke-dashoffset:82.28}}@keyframes wsLoaderDrawReady{from{stroke-dashoffset:calc(242px * var(--ws-loader-from, 0.3));fill-opacity:.14}to{stroke-dashoffset:0;fill-opacity:1}}@keyframes wsLoaderMarkShimmer{0%,100%{fill-opacity:.1}50%{fill-opacity:.24}}html[data-loader="rise"] #main-loader > [data-key="LogoLoader_1"]{display:block}html[data-loader="rise"] #main-loader > [data-key="LogoLoader"]{opacity:.2}html[data-loader="rise"] #main-loader > [data-key="LogoLoader"] svg path{fill-opacity:1;stroke:none;animation:none}@media (prefers-reduced-motion:reduce){#main-loader > [data-key="LoaderRange"] > [data-key="RangeFront"],#main-loader > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"],#main-loader > [data-key="LogoLoader_1"],#main-loader > [data-key="LogoLoader"] svg path{animation:none}#main-loader[data-stage="2"] > [data-key="LoaderRange"] > [data-key="RangeFront"]{transform:translateY(65%)}#main-loader[data-stage="2"] > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"]{transform:translateY(calc((55vh + 44px) * -0.65))}#main-loader[data-stage="2"] > [data-key="LogoLoader_1"]{clip-path:inset(65% 0 0 0)}#main-loader[data-stage="3"] > [data-key="LoaderRange"] > [data-key="RangeFront"],#main-loader[data-stage="3"] > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"]{transform:translateY(0)}#main-loader[data-stage="3"] > [data-key="LogoLoader_1"]{clip-path:inset(0 0 0 0)}#main-loader[data-stage="2"] > [data-key="LogoLoader"] svg path{stroke-dashoffset:157.3}#main-loader[data-stage="3"] > [data-key="LogoLoader"] svg path{stroke-dashoffset:0;fill-opacity:1}}html[data-motion="reduced"] #main-loader > [data-key="LoaderRange"] > [data-key="RangeFront"],html[data-motion="reduced"] #main-loader > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"],html[data-motion="reduced"] #main-loader > [data-key="LogoLoader_1"],html[data-motion="reduced"] #main-loader > [data-key="LogoLoader"] svg path{animation:none}html[data-motion="reduced"] #main-loader[data-stage="2"] > [data-key="LoaderRange"] > [data-key="RangeFront"]{transform:translateY(65%)}html[data-motion="reduced"] #main-loader[data-stage="2"] > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"]{transform:translateY(calc((55vh + 44px) * -0.65))}html[data-motion="reduced"] #main-loader[data-stage="2"] > [data-key="LogoLoader_1"]{clip-path:inset(65% 0 0 0)}html[data-motion="reduced"] #main-loader[data-stage="3"] > [data-key="LoaderRange"] > [data-key="RangeFront"],html[data-motion="reduced"] #main-loader[data-stage="3"] > [data-key="LoaderRange"] > [data-key="RangeFront"] > [data-key="RangeArt"]{transform:translateY(0)}html[data-motion="reduced"] #main-loader[data-stage="3"] > [data-key="LogoLoader_1"]{clip-path:inset(0 0 0 0)}html[data-motion="reduced"] #main-loader[data-stage="2"] > [data-key="LogoLoader"] svg path{stroke-dashoffset:157.3}html[data-motion="reduced"] #main-loader[data-stage="3"] > [data-key="LogoLoader"] svg path{stroke-dashoffset:0;fill-opacity:1}html[data-skin="ambient"][data-shell-route="home"] [data-key="smblsapp"] > [data-key="content"]{--stage-bg:transparent}html[data-shell-route="canvas"][data-module-canvas="true"] [data-key="smblsapp"] > [data-key="content"]{padding-top:var(--slot-top);box-sizing:border-box;height:100dvh;min-height:0;position:static;--app-band-left:calc(max(var(--module-rail-clear, 0px), var(--nav-inset-left)) + var(--assistant-inset-left));--app-band-right:calc(var(--nav-inset-right) + var(--assistant-inset-right));--app-dialog-inset:var(--slot-top) var(--app-band-right) var(--nav-inset-bottom) var(--app-band-left)}html[data-shell-route="canvas"][data-module-canvas="true"][data-prompt="shown"] [data-key="smblsapp"] > [data-key="content"]{--app-dialog-inset:var(--slot-top) var(--app-band-right) var(--slot-bottom) var(--app-band-left)}@media (max-width:768px){html[data-shell-route="canvas"][data-module-canvas="true"] [data-key="smblsapp"] > [data-key="content"]{--app-dialog-inset:var(--slot-top) 0 var(--slot-bottom)}}@media (max-width:768px){html[data-shell-route="canvas"][data-module-canvas="true"][data-prompt="shown"] [data-key="smblsapp"] > [data-key="content"]{--app-dialog-inset:var(--slot-top) 0 var(--slot-bottom)}}html[data-shell-route="app"] [data-key="smblsapp"] > [data-key="content"]{--stage-bg:var(--color-gray16);border-radius:17px;box-shadow:var(--shadow-float);margin:var(--slot-top) var(--spacing-X2) var(--nav-gap);width:auto;height:calc(100dvh - var(--slot-top) - var(--nav-gap));position:static;--app-band-left:calc(max(var(--module-rail-clear, 0px), var(--nav-inset-left)) + var(--assistant-inset-left) + var(--spacing-X2));--app-band-right:calc(var(--nav-inset-right) + var(--assistant-inset-right) + var(--spacing-X2));--app-dialog-inset:var(--slot-top) var(--app-band-right) var(--nav-gap) var(--app-band-left);min-height:0;container-type:inline-size;container-name:app-surface;overflow:auto}html[data-theme="dark"][data-shell-route="app"] [data-key="smblsapp"] > [data-key="content"]{--stage-bg:var(--color-gray2)}@media (max-width:768px){html[data-shell-route="app"] [data-key="smblsapp"] > [data-key="content"]{margin:var(--slot-top) 0 0;border-radius:17px 17px 0 0;box-shadow:none;--app-dialog-inset:var(--slot-top) 0 0;min-height:0;height:calc(100dvh - var(--slot-top))}}html[data-shell-route="app"][data-prompt="shown"] [data-key="smblsapp"] > [data-key="content"]{margin-bottom:var(--slot-bottom);--app-dialog-inset:var(--slot-top) var(--app-band-right) var(--slot-bottom) var(--app-band-left);min-height:0;height:calc(100dvh - var(--slot-top) - var(--slot-bottom))}@media (max-width:768px){html[data-shell-route="app"][data-prompt="shown"] [data-key="smblsapp"] > [data-key="content"]{--app-dialog-inset:var(--slot-top) 0 var(--slot-bottom)}}[data-key="smblsapp"]:has(> [data-key="AssistantMainLayer"][data-open="true"]) > [data-key="content"]{visibility:hidden;content-visibility:hidden}html[data-shell-route="home"][data-prompt="shown"] [data-key="content"] [data-key="MainColumn"]{padding-bottom:max(var(--spacing-G),var(--slot-bottom))}@media (max-width:768px){html[data-shell-route="home"] [data-key="content"] [data-key="MainColumn"][data-customizing="open"]{padding-bottom:calc(50dvh + var(--spacing-D1))}}html[data-header-left-compact="true"] [data-key="PageSlot"]{left:var(--spacing-X2)}html[data-chat-drawer="open"] [data-key="TicketsSidebar"]:not([data-sidebar-side="right"]),html[data-chat-drawer="open"] [data-key="InfraSidebar"]:not([data-sidebar-side="right"]),html[data-chat-drawer="open"] [data-key="CanvasViewRail"],html[data-chat-drawer="open"] [data-key="FilesSidebar"]:not([data-sidebar-side="right"]),html[data-chat-drawer="open"] [data-key="ProjectCanvasSidebar"]:not([data-sidebar-side="right"]){left:calc(var(--spacing-X2) * 2 + var(--spacing-G1) + var(--nav-inset-left, 0px)) !important;transition:left .2s ease}html[data-chat-drawer="open"] [data-key="PageSlot"]{left:calc(var(--chat-sidebar-right, calc(var(--spacing-X2) + var(--spacing-G1))) + var(--spacing-X2)) !important}[data-key="SectionNav"] > [aria-current="true"]{background:var(--color-selected);color:var(--color-title)}html[data-shell-route="auth"] [data-key="LoginWindow"] [data-key="Close"]{display:none!important}:root{--assistant-width:640px;--assistant-inset-right:0px;--assistant-inset-left:0px}[data-key="smblsapp"]{transition:grid-template-columns .22s cubic-bezier(0.4,0,0.2,1)}[data-key="AppHeader"]{transition:left .22s cubic-bezier(0.4,0,0.2,1),right .22s cubic-bezier(0.4,0,0.2,1)}html[data-assistant-dock="right"] [data-key="smblsapp"]{grid-template-columns:minmax(0,1fr) min(var(--assistant-width),50vw)}html[data-assistant-dock="left"] [data-key="smblsapp"]{grid-template-columns:min(var(--assistant-width),50vw) minmax(0,1fr)}html[data-assistant-dock="left"] [data-key="smblsapp"] > [data-key="content"]{grid-column:2}html[data-assistant-dock="right"] [data-key="AssistantDrawer"]{right:0;left:auto;width:var(--assistant-width);min-width:320px;max-width:50vw}html[data-assistant-dock="left"] [data-key="AssistantDrawer"]{left:0;right:auto;width:var(--assistant-width);min-width:320px;max-width:50vw}html[data-assistant-dock="right"] [data-key="CreditPillDock"][data-credit-dock="cover"],html[data-assistant-dock="left"] [data-key="CreditPillDock"][data-credit-dock="cover"]{top:0;bottom:0;height:100dvh;transform:none;width:var(--assistant-width);min-width:320px;max-width:50vw;z-index:10001;background:var(--color-document);align-items:center;justify-content:center;padding:var(--spacing-B)}html[data-assistant-dock="right"] [data-key="CreditPillDock"][data-credit-dock="cover"]{right:0;left:auto;box-shadow:var(--shadow-overlay)}html[data-assistant-dock="left"] [data-key="CreditPillDock"][data-credit-dock="cover"]{left:0;right:auto;box-shadow:var(--shadow-overlay)}html[data-assistant-dock="right"] [data-key="CreditPillDock"][data-credit-dock="cover"] > *,html[data-assistant-dock="left"] [data-key="CreditPillDock"][data-credit-dock="cover"] > *{width:100%;max-width:var(--spacing-H);flex-direction:column;align-items:center;text-align:center;gap:var(--spacing-A);background:transparent;box-shadow:none;backdrop-filter:none;-webkit-backdrop-filter:none}html[data-assistant-dock="right"] [data-key="CreditPillDock"][data-credit-dock="pill"]{transform:translateX(calc(-50% - var(--assistant-width) / 2))}html[data-assistant-dock="left"] [data-key="CreditPillDock"][data-credit-dock="pill"]{transform:translateX(calc(-50% + var(--assistant-width) / 2))}html[data-assistant-dock="left"] [data-key="AssistantDrawer"] [data-key="ResizeHandle"]{left:auto;right:0}html[data-assistant-dock="right"] [data-key="AppHeader"]{right:calc(env(safe-area-inset-right) + var(--assistant-width))}html[data-assistant-dock="left"] [data-key="AppHeader"]{left:calc(env(safe-area-inset-left) + var(--assistant-width))}html[data-assistant-dock="right"] [data-key="PageSlot"]{right:calc(var(--spacing-X2) + var(--assistant-width))}html[data-assistant-dock="left"] [data-key="PageSlot"]{left:calc(var(--spacing-X2) + var(--assistant-width))}html[data-assistant-dock="right"] [data-key="CanvasPromptTextarea"]{transform:translateX(calc(-50% - var(--assistant-width) / 2))}html[data-assistant-dock="left"] [data-key="CanvasPromptTextarea"]{transform:translateX(calc(-50% + var(--assistant-width) / 2))}@media ' + (0, $debL2.default).tabletS + '{' + '[data-key="CanvasPromptTextarea"]{' + 'position:fixed!important;' + // max(…, --nav-inset-*): beside a navbar rail or above a bottom bar
        // ("THE NAVBAR'S PLACE" below) the edge is the bar's, 0px elsewhere.
        'left:calc(env(safe-area-inset-left) + max(var(--spacing-X2), var(--nav-inset-left)))!important;' + 'right:calc(env(safe-area-inset-right) + max(var(--spacing-X2), var(--nav-inset-right)))!important;' + 'bottom:var(--composer-bottom,max(var(--spacing-X2), var(--nav-inset-bottom)))!important;' + 'width:auto!important;max-width:none!important;' + 'min-width:0!important;transform:none!important}' + '[data-key="CanvasPromptTextarea"] textarea{' + 'width:100%!important;max-width:100%!important;min-width:0!important}}' + '@media ' + (0, $debL2.default).mobileL + '{' + // Docked assistant becomes a full-width OVERLAY on phones instead of
        // shrinking content — a reserved column can't coexist with a usable
        // content track on a ~360px viewport (it would crush content to a sliver,
        // and the drawer's own min-width:320px would exceed a 50vw column). Drop
        // the reservation, overlay the drawer full-width, clear the chrome insets.
        // (Later than the desktop rules in the sheet, same specificity → wins.)
        'html[data-assistant-dock="left"] [data-key="smblsapp"],' + 'html[data-assistant-dock="right"] [data-key="smblsapp"]{grid-template-columns:minmax(0,1fr)}' + 'html[data-assistant-dock="left"] [data-key="smblsapp"]>[data-key="content"]{grid-column:1}' + 'html[data-assistant-dock="left"] [data-key="AssistantDrawer"],' + 'html[data-assistant-dock="right"] [data-key="AssistantDrawer"]{width:100vw;max-width:100vw;min-width:0}' + 'html[data-assistant-dock="left"] [data-key="AppHeader"],' + 'html[data-assistant-dock="right"] [data-key="AppHeader"]{left:0;right:0}' + 'html[data-assistant-dock="left"] [data-key="PageSlot"],' + 'html[data-assistant-dock="right"] [data-key="PageSlot"]{left:var(--spacing-X2);right:var(--spacing-X2)}' + // The out-of-credits cover follows the drawer it covers: full width
        // here, since the drawer itself is a full-width overlay on a phone
        // (rule above). The desktop clamp (var width, min 320, max 50vw)
        // would leave a 320px strip beside an uncovered dead chat.
        'html[data-assistant-dock="left"] [data-key="CreditPillDock"][data-credit-dock="cover"],' + 'html[data-assistant-dock="right"] [data-key="CreditPillDock"][data-credit-dock="cover"]' + '{width:100vw;max-width:100vw;min-width:0}' + // …and the LOW/CRITICAL pill drops the desktop content-band shift:
        // there is no reserved column to re-center against, and the dock's
        // own @mobileL block already pins it edge-to-edge (left/right A,
        // transform none) — an attribute-scoped rule would outrank that
        // single-class atomic media rule, so it is restated here.
        'html[data-assistant-dock="left"] [data-key="CreditPillDock"][data-credit-dock="pill"],' + 'html[data-assistant-dock="right"] [data-key="CreditPillDock"][data-credit-dock="pill"]' + '{transform:none}' + // …and then every chrome-offset stands down entirely on a phone. At
        // ≤768 the PageSlot is no longer a floating island beside the chrome —
        // it is a FULL-BLEED iOS sheet (canvas/components/PageSlot.js
        // '@mobileL': left/right/bottom 0, top = safe-area + a reveal strip).
        // Nothing sits beside it to clear: the assistant drawer is a
        // full-width overlay here (rule above) and the messenger drawer is the
        // same story, so an inset would only leave a dead gutter beside a sheet
        // that is supposed to own the screen edge.
        //
        // It has to be stated here rather than in the component: these three
        // rules are attribute-scoped descendants ((0,2,1)) and the chat-drawer
        // one is `!important` — both outrank the component's single-class
        // atomic media rule, so PageSlot.js's own '@mobileL' geometry loses to
        // them on specificity every time the drawer/dock state is live.
        // `!important` only to match the chat-drawer declaration it must
        // override; the rest is plain cascade order inside this same block.
        'html[data-chat-drawer="open"] [data-key="PageSlot"],' + 'html[data-assistant-dock="left"] [data-key="PageSlot"],' + 'html[data-assistant-dock="right"] [data-key="PageSlot"],' + 'html[data-header-left-compact="true"] [data-key="PageSlot"]' + '{left:0!important;right:0!important}}' + // ── THE NAVBAR'S PLACE ─────────────────────────────────────────────
        // Nika 2026-10-24: "on both workspaces - com and normal make sidebar
        // optional to be positioned at the top left right or bottom. for
        // normal workspace keep as is"; 2026-10-27: "also make navbar left
        // by default" (shared functions/navbarLayout.js — the person's own
        // look; the avatar menu's "Navbar" row). <html data-nav-place>
        // (written in _syncShellRoute) names the place; 'top' — a person's
        // choice, and always on a phone — matches no rule below, so the top
        // navbar's frame is exactly as before. On a rail
        // (left / right) or at the bottom the AppHeader floats at the X2 edge
        // gap and the shared header turns itself into the rail
        // (`data-nav-rail` rules in shared AppHeader.js); the frame clears
        // it instead of a top navbar. --nav-edge is the bar's reach from its
        // own screen edge (live-measured on the AppHeader mount,
        // _measureHeaderNavEdge); + --nav-gap it is that side's inset, the
        // same gap a sheet keeps from the top navbar. The top clearances
        // drop to the X2 edge gap. The same reacts-in-CSS idiom as the
        // assistant-dock rules above, and AFTER them in this sheet, so on a
        // shared side the navbar stays outermost.
        '@property --nav-edge{syntax:"<length>";inherits:true;initial-value:0px}' + ':root{--nav-edge:0px;--nav-inset-left:0px;--nav-inset-right:0px;--nav-inset-bottom:0px}' + 'html[data-nav-place="left"]{--nav-inset-left:calc(var(--nav-edge) + var(--nav-gap))}' + 'html[data-nav-place="right"]{--nav-inset-right:calc(var(--nav-edge) + var(--nav-gap))}' + // At the bottom the sheets' foot clears the bar even while the
        // composer (which rises above the bar, below) is hidden: the stack's
        // LINE moves (--slot-bottom derives from it, above).
        'html[data-nav-place="bottom"]{--nav-inset-bottom:calc(var(--nav-edge) + var(--nav-gap));' + '--stack-line:calc(max(var(--prompt-clear), var(--nav-edge)) + var(--nav-gap))}' + 'html[data-nav-place="left"],html[data-nav-place="right"],html[data-nav-place="bottom"]' + '{--shell-top:calc(var(--spacing-X2) + env(safe-area-inset-top));' + '--slot-top:calc(var(--spacing-X2) + env(safe-area-inset-top))}' + // The bar itself: a rail runs the screen's height at the X2 gap, a
        // bottom bar is the top navbar's box moved to the foot (its own X2
        // padding keeps the islands off the edge).
        'html[data-nav-place="left"] [data-key="AppHeader"],html[data-nav-place="right"] [data-key="AppHeader"]' + '{position:fixed;top:calc(env(safe-area-inset-top) + var(--spacing-X2));' + 'bottom:calc(env(safe-area-inset-bottom) + var(--spacing-X2))}' + 'html[data-nav-place="left"] [data-key="AppHeader"]{left:calc(env(safe-area-inset-left) + var(--spacing-X2));right:auto}' + 'html[data-nav-place="right"] [data-key="AppHeader"]{right:calc(env(safe-area-inset-right) + var(--spacing-X2));left:auto}' + 'html[data-nav-place="bottom"] [data-key="AppHeader"]{top:auto;bottom:env(safe-area-inset-bottom)}' + // Every in-flow page: the shell root's padding, as the module rail's
        // (shellApp paddingLeft) — max(), because a module rail beside a
        // left navbar already reaches past it (its clearance is measured
        // from the screen edge).
        'html[data-nav-place="left"] [data-key="smblsapp"]{padding-left:max(var(--module-rail-clear, 0px), var(--nav-inset-left))}' + 'html[data-nav-place="right"] [data-key="smblsapp"]{padding-right:var(--nav-inset-right)}' + 'html[data-nav-place="bottom"] [data-key="smblsapp"]{padding-bottom:var(--nav-inset-bottom)}' + 'html[data-nav-place="left"] [data-key="ModuleRailHost"]{left:var(--nav-edge)}' + // The home sets its own top (pages/main.js MainColumn: a static D1 —
        // the floating top navbar plus its gap; the 'home' route self-offsets,
        // _syncShellRoute's note). With the bar off the top that D1 is empty
        // space over the page (Nika 2026-10-25: "when navbar at the left,
        // reduce top size on content"; 89px on dev 579269d80): the board's
        // own side gutter instead, C. The MainColumn compound out-specifies
        // the component's single-class padding, as the composer rule does.
        'html[data-nav-place="left"] [data-key="content"] [data-key="MainColumn"],' + 'html[data-nav-place="right"] [data-key="content"] [data-key="MainColumn"],' + 'html[data-nav-place="bottom"] [data-key="content"] [data-key="MainColumn"]' + '{padding-top:calc(var(--spacing-C) + env(safe-area-inset-top))}' + // The PageSlot band, alone and beside a docked drawer on the same side
        // (the drawer sits between the bar and the sheet).
        'html[data-nav-place="left"] [data-key="PageSlot"]{left:var(--nav-inset-left)}' + 'html[data-nav-place="right"] [data-key="PageSlot"]{right:var(--nav-inset-right)}' + 'html[data-nav-place="left"][data-assistant-dock="left"] [data-key="PageSlot"]' + '{left:calc(var(--nav-inset-left) + var(--assistant-inset-left) + var(--spacing-X2))}' + 'html[data-nav-place="right"][data-assistant-dock="right"] [data-key="PageSlot"]' + '{right:calc(var(--nav-inset-right) + var(--assistant-inset-right) + var(--spacing-X2))}' + // The docked assistant and its out-of-credits cover: beside the bar.
        'html[data-nav-place="left"][data-assistant-dock="left"] [data-key="AssistantDrawer"],' + 'html[data-nav-place="left"][data-assistant-dock="left"] [data-key="CreditPillDock"][data-credit-dock="cover"]' + '{left:var(--nav-inset-left)}' + 'html[data-nav-place="right"][data-assistant-dock="right"] [data-key="AssistantDrawer"],' + 'html[data-nav-place="right"][data-assistant-dock="right"] [data-key="CreditPillDock"][data-credit-dock="cover"]' + '{right:var(--nav-inset-right)}' + // The composer and the credit pill above it: centred in the band the
        // bar and a docked drawer leave (the dock rules' shift, plus the bar),
        // and above a bottom bar.
        'html[data-nav-place="left"] [data-key="CanvasPromptTextarea"],' + 'html[data-nav-place="left"] [data-key="CreditPillDock"][data-credit-dock="pill"]' + '{transform:translateX(calc(-50% + (var(--nav-inset-left) + var(--assistant-inset-left) - var(--assistant-inset-right)) / 2))}' + 'html[data-nav-place="right"] [data-key="CanvasPromptTextarea"],' + 'html[data-nav-place="right"] [data-key="CreditPillDock"][data-credit-dock="pill"]' + '{transform:translateX(calc(-50% + (var(--assistant-inset-left) - var(--assistant-inset-right) - var(--nav-inset-right)) / 2))}' + 'html[data-nav-place="bottom"] [data-key="CanvasPromptTextarea"]{bottom:var(--nav-inset-bottom)}' + // The page rails and the docked chat / mail lists: off the bar. (A
        // page rail on the shared side rule — the tasks, files, infra and
        // project canvas rails, and the infra detail drawer that opens at its
        // rail's place — never shares an edge with a rail navbar: it moves to
        // the right beside a left one, shared functions/navbarLayout.js
        // `sidebarSide`.)
        'html[data-nav-place="left"] [data-key="CanvasViewRail"],' + 'html[data-nav-place="left"] [data-key="MessengerList"],' + 'html[data-nav-place="left"] [data-key="MailDrawer"]' + '{left:var(--nav-inset-left)}' + // The view rail beside a drawer docked on the bar's side: the drawer
        // sits between the bar and the rail (the PageSlot rule's shape).
        'html[data-nav-place="left"][data-assistant-dock="left"] [data-key="CanvasViewRail"]' + '{left:calc(var(--nav-inset-left) + var(--assistant-inset-left) + var(--spacing-X2))}' + 'html[data-nav-place="right"] [data-key="VersionHistoryPanel"],' + 'html[data-nav-place="right"] [data-key="CanvasV2CodeEditor"],' + 'html[data-nav-place="right"] [data-key="CustomizeDrawer"]' + '{right:var(--nav-inset-right)}' + 'html[data-nav-place="right"] [data-key="VersionDetailPanel"]' + '{right:calc(var(--nav-inset-right) + var(--spacing-X2) + var(--spacing-G1))}' + // The project canvas's tool panels take the side its rail does not
        // (canvas VersionHistoryPanel / VersionDetailPanel / CanvasV2CodeEditor
        // ask for the side): beside a left navbar the rail is on the right, so
        // they sit on the left, off the bar, and clear the docked chat list
        // there as the left rails do. (`data-nav-place` in the chat rules
        // outranks the bar rules above them; no !important.)
        'html[data-nav-place="left"] [data-key="VersionHistoryPanel"][data-sidebar-side="right"],' + 'html[data-nav-place="left"] [data-key="CanvasV2CodeEditor"][data-sidebar-side="right"]' + '{left:var(--nav-inset-left)}' + 'html[data-nav-place="left"] [data-key="VersionDetailPanel"][data-sidebar-side="right"]' + '{left:calc(var(--nav-inset-left) + var(--spacing-X2) + var(--spacing-G1))}' + // …and clear of a drawer the assistant docks on their side, on both
        // sides (the PageSlot rules' shape: the drawer sits at the edge or
        // beside the bar, the panel one X2 after it; the detail card one G1
        // and one X2 further on). Before the chat-list rules, which keep
        // their place when the list is open.
        'html[data-assistant-dock="right"] [data-key="VersionHistoryPanel"]:not([data-sidebar-side="right"]),' + 'html[data-assistant-dock="right"] [data-key="CanvasV2CodeEditor"]:not([data-sidebar-side="right"])' + '{right:calc(var(--assistant-inset-right) + var(--spacing-X2))}' + 'html[data-assistant-dock="right"] [data-key="VersionDetailPanel"]:not([data-sidebar-side="right"])' + '{right:calc(var(--assistant-inset-right) + var(--spacing-X2) * 2 + var(--spacing-G1))}' + 'html[data-nav-place="right"][data-assistant-dock="right"] [data-key="VersionHistoryPanel"],' + 'html[data-nav-place="right"][data-assistant-dock="right"] [data-key="CanvasV2CodeEditor"]' + '{right:calc(var(--nav-inset-right) + var(--assistant-inset-right) + var(--spacing-X2))}' + 'html[data-nav-place="right"][data-assistant-dock="right"] [data-key="VersionDetailPanel"]' + '{right:calc(var(--nav-inset-right) + var(--assistant-inset-right) + var(--spacing-X2) * 2 + var(--spacing-G1))}' + 'html[data-nav-place="left"][data-assistant-dock="left"] [data-key="VersionHistoryPanel"][data-sidebar-side="right"],' + 'html[data-nav-place="left"][data-assistant-dock="left"] [data-key="CanvasV2CodeEditor"][data-sidebar-side="right"]' + '{left:calc(var(--nav-inset-left) + var(--assistant-inset-left) + var(--spacing-X2))}' + 'html[data-nav-place="left"][data-assistant-dock="left"] [data-key="VersionDetailPanel"][data-sidebar-side="right"]' + '{left:calc(var(--nav-inset-left) + var(--assistant-inset-left) + var(--spacing-X2) * 2 + var(--spacing-G1))}' + 'html[data-nav-place="left"][data-chat-drawer="open"] [data-key="VersionHistoryPanel"][data-sidebar-side="right"],' + 'html[data-nav-place="left"][data-chat-drawer="open"] [data-key="CanvasV2CodeEditor"][data-sidebar-side="right"]' + '{left:calc(var(--spacing-X2) * 2 + var(--spacing-G1) + var(--nav-inset-left))}' + 'html[data-nav-place="left"][data-chat-drawer="open"] [data-key="VersionDetailPanel"][data-sidebar-side="right"]' + '{left:calc(var(--spacing-X2) * 3 + var(--spacing-G1) * 2 + var(--nav-inset-left))}' + // The online members beside the composer's baseline (bottom left).
        'html[data-nav-place="left"] [data-key="OnlineMembersDock"]{left:var(--nav-inset-left)}' + 'html[data-nav-place="bottom"] [data-key="OnlineMembersDock"]{bottom:var(--nav-inset-bottom)}' + // The right-edge docks: parked windows and the call.
        'html[data-nav-place="right"] [data-key="MinimizedDock"]' + '{right:calc(var(--assistant-inset-right, 0px) + var(--spacing-A) + var(--nav-inset-right))}' + 'html[data-nav-place="bottom"] [data-key="MinimizedDock"]{bottom:calc(var(--spacing-C) + var(--nav-inset-bottom))}' + 'html[data-nav-place="right"] [data-key="MeetCallWidget"]{right:calc(var(--spacing-A) + var(--nav-inset-right))}' + 'html[data-nav-place="bottom"] [data-key="MeetCallWidget"]' + '{bottom:calc(var(--spacing-A) + var(--zoombar-clear) + var(--nav-inset-bottom))}' + // Phone header scroll-condense (2026-08-02) — the ONE deck (AppHeader,
        // merged @mobileL — see AppHeader.js) slides fully off-screen while
        // <html data-nav-condensed="true">, written by ONE document-level
        // capture-phase scroll listener (packages/shared/functions/
        // navCondense.js, armed from AppHeader's onCreate). Same attribute-
        // reacts-in-CSS idiom as html[data-chat-drawer] above: this is a pure
        // selector + transform, no component-level reactive prop, so toggling
        // the attribute costs one style recalc, never a re-render. The
        // transition itself lives on the component (AppHeader.js '@mobileL'
        // transition: '240ms defaultBezier transform') so it goes through the
        // normal token pipeline; only the conditional VALUE needs the
        // attribute-selector this raw sheet provides. Clears the safe-area
        // inset too (translateY alone would leave the bottom edge sitting
        // exactly at the inset boundary) plus a small Z buffer so the glass
        // surface's own box-shadow/blur fully leaves the viewport.
        '@media ' + (0, $debL2.default).mobileL + '{' + 'html[data-nav-condensed="true"] [data-key="AppHeader"]{' + 'transform:translateY(calc(-100% - env(safe-area-inset-top) - var(--spacing-Z)))}}' + // iOS zoom-on-focus guard — Safari auto-zooms the page when a focused
        // input/textarea/select computes a font-size below 16px, and the
        // workspace type scale drops under 16px at @tabletS (≤1024). max(16px,1em)
        // floors an inherited field size at 16px without ever shrinking a
        // larger one. Workspace-local, applies only ≤1024px; desktop untouched.
        '@media ' + (0, $debL2.default).tabletS + '{input,textarea,select{font-size:max(16px,1em)}}' + // …and on a TOUCH screen at every width, where the zoom happens — and
        // here the floor must outrank a field's OWN size. The rule above is
        // (0,0,1): every field that names a size (one atomic class, 0,1,0)
        // beat it, so it only ever covered unstyled fields. Measured on dev
        // DFI 2026-10-05 (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): the composer
        // at 14.875px on an 834px iPad (14px root), the AppField kit at `Z2`
        // (≈15.3px at a phone's 16px root, ≈13.4px at the iPad's) and the
        // AppSelect under 16px at @tabletS — a zoom on every form field
        // focus. `:root :is(…)` (0,1,1) outranks the field's own size; 1em is
        // the parent's size, so a field never drops below its surroundings.
        // `any-pointer`, not `pointer`: an iPad with a trackpad attached still
        // has its touch screen. A field that shows DISPLAY-size text (at least
        // 16px at every root, so it never zooms) opts out with
        // `data-display-text`, or the floor would cut it to its parent's size.
        '@media (any-pointer:coarse){' + ':root :is(input,textarea,select):not([data-display-text]){font-size:max(16px,1em)}}' + // ——— iPad/touch native-feel + a11y floor (2026-07-31 per Nika "review
        // ipad use … native-like + motion, touch gestures, accessibility") ———
        // Body rubber-band: the shell is app chrome — every surface owns its own
        // scroller, so a chained overscroll bounce on <body> (WKWebView pulls the
        // whole page revealing the backdrop) reads as "website", never "app".
        // Inner scrollers keep their native momentum + bounce.
        'html,body{overscroll-behavior:none}' + // Reduced-motion floor (WCAG 2.3.3): when the OS asks, clamp EVERY CSS
        // animation/transition. ~21 components ship curated reduced variants
        // already — those still apply; this is the global floor so no surface is
        // left animating. WAAPI surfaces (PageSlot) self-gate on the same query.
        '@media (prefers-reduced-motion:reduce){*,*::before,*::after{animation-duration:.01ms!important;animation-iteration-count:1!important;transition-duration:.01ms!important;scroll-behavior:auto!important}}' + // Keyboard-focus floor (iPad hardware keyboards + desktop tabbing): a
        // ZERO-specificity :where() ring so any focusable reached by keyboard is
        // visible. The ~24 components with curated :focus-visible styles win by
        // ordinary cascade (real specificity beats :where's zero).
        ':where(a,button,[role="button"],[role="tab"],[role="menuitem"],input,select,textarea,[tabindex]):focus-visible{outline:2px solid var(--color-blue);outline-offset:2px}' + // Placeholder floor: unstyled fields leak Chrome\'s UA default gray
        // (#757575 — measured 3.9:1 on the composer, needs 4.5). Zero-
        // specificity :where() + the adaptive `placeholder` token pair; the
        // ~4 components with curated ::placeholder colors win by cascade.
        // opacity:1 defeats the UA\'s extra placeholder dimming.
        ':where(input,textarea)::placeholder{color:var(--color-placeholder);opacity:1}' + // (Coarse tap-slop selectors removed 2026-08-01 per Nika "why such
        // selectors … go with frank rules": the 44pt tap affordance now lives
        // INSIDE the brand buttons — NavbarButton/IconButton '@coarse'
        // ':after' with the `tapSlop` sizes token — replacing both their old
        // size floors and this block. HeaderTabs' bespoke tab buttons carry
        // the same slop declaratively in HeaderTabs.js.)
        // Home-indicator clearance: the composer is fixed at a token bottom with
        // no safe-area component (measured live: bottom 15.9px, padding 0). In
        // the iPad/iPhone shell (viewport-fit=cover) the home-indicator inset
        // would swallow that gap. margin-bottom lifts the fixed box by exactly
        // the inset; env()=0 everywhere else so web is untouched. The
        // --prompt-clear ResizeObserver reads r.top, so PageSlot clearance
        // follows automatically.
        '[data-key="CanvasPromptTextarea"]{margin-bottom:env(safe-area-inset-bottom,0px)}' + // ——— ACCESSIBILITY PREFERENCES (2026-09-04 per Nika "add same
        // accessibility options as we have in landing") ———
        // The four personal choices from shared/functions/a11yPrefs.js, which
        // _syncShellRoute mirrors onto <html>. Same attribute names and same
        // effects as the public site's designSystem/reset.js, so the two
        // products answer a preference identically.
        //
        // TYPE SCALE. One number, `--a11y-type-scale`, multiplied into the
        // root font-size — every `em` token in the design system is derived
        // from it, so one declaration moves the whole product. No attribute is
        // written at the base step, which is why the var carries a `1`
        // fallback rather than a `[data-font-scale="md"]` rule.
        'html[data-font-scale="sm"]{--a11y-type-scale:.9;font-size:calc(var(--font-size-A) * var(--a11y-type-scale))}' + 'html[data-font-scale="lg"]{--a11y-type-scale:1.15;font-size:calc(var(--font-size-A) * var(--a11y-type-scale))}' + // HIGH CONTRAST. The quiet inks become the ink. Token-level, not a
        // per-component sweep: `caption` and `inactive` are the two adaptive
        // quiet greys the whole product reads for secondary text, so
        // repointing them at `title` lifts every surface at once and nothing
        // has to opt in. The line token firms up with them so borders do not
        // vanish against the raised text.
        'html[data-contrast="high"]{--color-caption:var(--color-title);--color-inactive:var(--color-title);--color-placeholder:var(--color-title);--color-line:var(--color-title)}' + // REDUCED MOTION. The SAME declaration the OS floor above already
        // ships for `prefers-reduced-motion`, now also reachable by choice —
        // a person on a device that cannot express the OS setting (or who
        // wants it for this app only) gets the identical result.
        'html[data-motion="reduced"] *,html[data-motion="reduced"] *::before,html[data-motion="reduced"] *::after{animation-duration:.01ms!important;animation-iteration-count:1!important;transition-duration:.01ms!important;scroll-behavior:auto!important}' + // UNDERLINE LINKS. WCAG 1.4.1: never colour alone. Scoped to real
        // anchors with an href — the product routes plenty of BUTTONS that
        // look like links, and underlining those would be noise, not help.
        'html[data-links="underline"] a[href]{text-decoration:underline}' + el.call('phoneNavigationStyles');
        document.head.appendChild(s);
        // Native shell only: pin the page scale so a Magic-Keyboard TRACKPAD
        // pinch cannot zoom the whole app — WKWebView performs that
        // magnification at the native scroll-view layer, BEFORE any cancelable
        // JS event, so the canvas gesture handlers never get a say (verified on
        // device 2026-08-01: screen pinch zooms the canvas correctly via the
        // touch path; trackpad pinch zoomed the app). WKWebView respects
        // maximum-scale (unlike Safari, which ignores it for accessibility);
        // native apps don't page-zoom, and iPadOS system a11y zoom still works.
        // Browsers never hit this branch — web pinch-zoom stays untouched.
        if (el.call('isNativeShell')) {
            const vp = document.querySelector('meta[name="viewport"]');
            if (vp && !/maximum-scale/.test(vp.content)) vp.content += ', maximum-scale=1';
        }
    }
    const resolveSdk = ()=>el.sdk || el.context?.methods?.sdk || null;
    // Boot the analyzing singleton FIRST so any error fired by the auth /
    // workspace-load chain below is captured + shipped. createAnalyzing's
    // pre-boot window listeners catch errors that fire before plugin.activate;
    // the singleton's user identification kicks in once this call returns.
    // The transport routes through sdk.execute('workspaceProject.analyzed',
    // 'ingest', …) — a deprecated alias that delegates to the main API
    // server's Mongo-backed POST /core/analyzed/ingest route, which stamps
    // workspace_id from the caller's JWT / envelope, so the shell never has
    // to ship org context.
    //
    // KEPT EAGER (iPad P1 boot audit) — deliberately NOT deferIdleBoot'd:
    //   1. The window error/rejection listeners are installed BY
    //      createAnalyzing (not at module import). Deferring blinds
    //      telemetry to exactly the boot-window errors this singleton
    //      exists to catch — the auth/workspace-load chain right below.
    //   2. reidentifyOnOrgSwitch reads the module-level `_instance` at
    //      CALL time and returns a permanent no-op when it isn't booted
    //      yet (analyzing.js) — the two calls are ordering-coupled.
    // Cost is tracked by the wsboot:analyzing measure below; if it ever
    // shows up in the long-task profile, fix it inside @symbo.ls/analyzing
    // (buffer pre-boot events), not by deferring this call.
    (0, $iI0D7.bootMark)('wsboot:analyzing:start');
    try {
        // Workspace id is workspace-scope data — the analyzing client
        // declares it per envelope rather than letting the server
        // re-derive it from `req.user.activeOrganization` (which 400s
        // for any user whose Mongo activeOrg is null). Per-tenant by
        // design — embeds / standalones pass their own id.
        (0, $caKf8.bootAnalyzing)({
            sdk: resolveSdk(),
            // Same resolver as onWorkspaceChange + the orgSwitched handler, so
            // the boot stamp and the first post-boot stamp AGREE (a stamp
            // change rotates the session — ANALYZING-SESSION-ROTATE-1). Falls
            // back to the pre-auth org id only when no workspace id is known.
            workspaceId: (0, $caKf8.resolveAnalyzingScopeId)({
                sdk: resolveSdk(),
                root: s?.root
            }) || _preAuth?.org?.id || null
        });
        // identifyFromSdk is fired by `subscribeAuthSession` below — its
        // onSignIn callback runs on first sign-in AND on initial-session
        // restoration (the page-reload-with-stored-token path), so the
        // eager mount-time call would only ever fire when there's no
        // token in storage. That spammed /logs with `fetch.error
        // /core/auth/me` + `identifyFromSdk failed` warnings on every
        // anonymous /login + / visit
        // (WORKSPACE-ANALYZING-IDENTIFY-PRE-AUTH-NOISE).
        el._unsubAnalyzingOrgSwitch = (0, $caKf8.reidentifyOnOrgSwitch)(resolveSdk(), ()=>s.root);
    } catch (err) {
        console.warn('[shell] analyzing boot failed:', err?.message || err);
    }
    (0, $iI0D7.bootMark)('wsboot:analyzing:end');
    (0, $iI0D7.bootMeasure)('wsboot:analyzing', 'wsboot:analyzing:start', 'wsboot:analyzing:end');
    el._unsubShellAuth = (0, $qJ3f5.subscribeAuthSession)(s.root, (signin)=>{
        // Boot segment G: the session tick that starts loadPrivateData below.
        (0, $iI0D7.bootMark)('wsboot:shell:signin');
        // A sign-in ON this page (the boot answered signed out) owes the
        // session its interface language: the loader, and its word, wait for
        // the workspace language (functions/shellLangPolicy.js). Before the
        // data load raises the loader, so its first frame has no English word.
        // Wrapped: a throw here must never starve loadPrivateData below.
        try {
            el.call('markShellLangOwed');
        } catch (err) {
            console.warn('[shell] language debt mark failed:', err?.message || err);
        }
        // Re-stamp user on auth refresh — the user record can change shape
        // (email verified, plan upgraded, etc.) between subscribeAuthSession
        // fires; we want telemetry to reflect the latest traits. The tick's
        // own session user rides along so identify never re-fetches /auth/me
        // for traits the boot already holds (was a 1.7s duplicate mid-boot).
        try {
            (0, $caKf8.identifyFromSdk)(resolveSdk(), signin?.user);
        } catch (_) {}
        // Multi-workspace-tabs cross-org (Phase 5): if this tab's URL pins an org
        // different from the one boot resolved, client-only switch to it so the
        // tab shows the org named in its `/w/<org-slug>` URL. Guarded + no-op when
        // the MWT flag is off. Wrapped so a synchronous throw here can NEVER starve
        // the loadPrivateData call below — that's what seeds people / avatar /
        // workspace data, and skipping it leaves every surface blank.
        // WHITELABEL-1: a white-label host (app.bellforge.eu) names its org in
        // DNS, not the URL — resolve host → /w/<org>/<ws> and hand off to the
        // existing machinery. Fired, never awaited: root.orgs is populated by
        // loadPrivateData below, so awaiting here would deadlock the ladder on
        // the very data it waits for. Only the URL reconcile is sequenced
        // behind it — otherwise its bare-path canonicalize stamps the ACTIVE
        // org's URL first and the white-label path looks already-scoped.
        // Platform hosts resolve 'none' synchronously, so their reconcile
        // timing is unchanged apart from one microtask.
        (0, $dbWbc.bootCustomDomainScope)(s.root, el, {
            // WS-WHITELABEL-ORG-PIN-INERT-WITH-MWT-OFF-1 — with the MWT flag off
            // the `/w/<org>` handoff below is inert (nothing consumes the prefix),
            // so the boot states the host's org through the SDK's client-only
            // rescope instead. Same sdk instance the reconcile uses.
            sdk: resolveSdk(),
            apiBase: $6b17f08f738443dc$var$shellWorkspaceApiBase(),
            fetchImpl: typeof window !== 'undefined' && typeof window.fetch === 'function' ? window.fetch.bind(window) : null
        }).then(()=>{
            try {
                (0, $gO4wS.reconcileMwtOrgFromUrl)(s.root, resolveSdk(), el, 0, {
                    // Lets the reconcile see the org named by a project-canvas or
                    // /studio URL, not just a `/w/<org>` prefix — see _urlOrgSlug.
                    ownerSlugForPath: (p)=>(0, $2C7Li.urlOrgSlug)(p, s.root)
                });
            } catch (err) {
                console.warn('[shell] reconcileMwtOrgFromUrl failed:', err?.message || err);
            }
        });
        return (0, $jZ5ZE.loadPrivateData)(s.root, resolveSdk());
    }, (claims)=>(0, $jZ5ZE.onWorkspaceChange)(s.root, resolveSdk(), claims));
    // External org-switch propagation. Anyone calling `sdk.switchOrg(id)`
    // (the AppOrgSwitcherItem dropdown, future cross-tab storage syncs,
    // programmatic switches) emits `sdk.orgSwitched` on the SDK root bus.
    // We mirror the new org into `root.org` + `root.jwtClaims.workspace_org_id`
    // so every consumer keyed off those fields (filterToActiveOrg,
    // _loadRoles, AppNavbar's `/studio/<slug>` resolver, _person mapper,
    // …) re-keys in place, then refire the workspace-change refetch
    // pipeline so people / teams / roles / announcements / stories /
    // resource-links / user-docs / org-notifications / calendar all
    // reload for the new org. No reload required.
    //
    // The bus is `el.sdk.rootBus` — DOMQL wires the SDK onto every element
    // before any onCreate hook runs (bootShell sets `context.methods.sdk`
    // BEFORE `create()`), and `sdk.rootBus` is set on SDK construction
    // (before initialize()), so the chain is safe to read synchronously.
    el._handleOrgSwitched = async ({ newOrgId: newOrgId, previousOrgId: previousOrgId, workspaceHop: workspaceHop } = {})=>{
        if (!newOrgId) return;
        // Bus replays the last payload to late subscribers — SYNCHRONOUSLY,
        // inside rootBus.on (sdk rootEventBus keeps lastPayloads). A remount
        // of this element after a real switch therefore re-receives that
        // switch's payload during onCreate. The claims stamp below is
        // synchronous in this handler's prelude, so "claims already read
        // newOrgId" means the switch is SETTLED — replay or duplicate, skip.
        // (The previous guard also required previousOrgId === newOrgId,
        // which only catches self-echoes: a replayed REAL switch carries
        // previousOrgId ≠ newOrgId and sailed through into a full spurious
        // onWorkspaceChange — observed as a module teardown-after-mount,
        // and the pre-hardening root.call TypeError came from this same
        // replay running mid-createDomqlElement.)
        if (s.root.jwtClaims?.workspace_org_id === newOrgId) return;
        // The address bar still holds the OUTGOING org's URL, so segment 2 is
        // the OUTGOING workspace's handle. Capture that scope NOW: the refetch
        // pipeline below re-scopes `root.workspace` / `root.workspaces` to the
        // new org, and syncWorkspaceUrl's stale-segment strip can only drop a
        // SLUG handle (`hq`) when it is given a workspace record that carries
        // it. Passing only the new org's list left `/w/system/hq/tasks` →
        // `/w/bellforge/ws_UYAOhQyNjm/hq/tasks` — two workspace segments
        // (WS-ORG-SWITCH-URL-DOUBLE-WORKSPACE-SEGMENT-1, measured live).
        const outgoingWorkspace = s.root.workspace || null;
        const outgoingWorkspaces = Array.isArray(s.root.workspaces) ? s.root.workspaces : [];
        // Loader up at the ABSOLUTE entry (echo guards above are the only thing
        // allowed to skip it): every prelude below — cache invalidation, claims
        // stamp, URL sync — runs with the old tenant still painted, and
        // onWorkspaceChange's own raise lands only after this handler yields to
        // it. Raised via the ownership epoch (beginDataLoad) so a concurrently
        // finishing boot loadPrivateData can't clear it in the gap before
        // onWorkspaceChange re-raises — that gap was a visible mid-teardown
        // reveal (BOOT-RESHUFFLE F3).
        (0, $jZ5ZE.beginDataLoad)(s.root);
        // Park OFF any module route of the outgoing manifest NOW — before the
        // pipeline's wipe can null the module bag under a mounted module page
        // (see _leaveModuleRouteForSwitch).
        $6b17f08f738443dc$var$_leaveModuleRouteForSwitch(el, s, $6b17f08f738443dc$var$moduleRoutesFromRoot(s.root));
        // Invalidate every cached fetch BEFORE the refetch pipeline runs.
        // Without this, page-level `fetch: [{ ..., cache: 'Ns' }]` declarations
        // (calendar events, ticket lists, channel rosters, …) serve the
        // previous org's cached payload right back into state, so the UI
        // "refreshes" with stale rows. queryClient is the @symbo.ls/fetch
        // adapter-level cache shared across every fetch in the app.
        try {
            (0, $4skhB.queryClient).invalidateQueries();
        } catch (err) {
            console.warn('[shell] queryClient.invalidate failed:', err?.message || err);
        }
        const orgs = s.root.orgs || s.root.jwtClaims?.orgs || [];
        const newOrg = orgs.find((o)=>o.id === newOrgId);
        const nextClaims = {
            ...s.root.jwtClaims || {},
            workspace_org_id: newOrgId
        };
        // Update state.org when we can resolve the row from membership claims;
        // when claims haven't refreshed yet, jwtClaims.workspace_org_id is the
        // canonical pointer the rest of the app reads. Either way, fire the
        // refetch pipeline — bailing on missing newOrg was leaving stale data
        // on screen for any switch that happened before /auth/me hydrated.
        const stateDelta = {
            jwtClaims: nextClaims
        };
        if (newOrg) stateDelta.org = newOrg;
        // Cross-org: the target WORKSPACE isn't known synchronously (it resolves
        // inside onWorkspaceChange), but the previous scope is definitively DEAD
        // — leaving it in place let elements mounting mid-switch read + write
        // the fetch cache under the old tenant's keys (isolation audit #9). A
        // per-switch sentinel can't collide with any real workspace id, so
        // those transitional fetches stay tenant-clean; onWorkspaceChange
        // writes the real id once the workspace record settles.
        stateDelta.__fetchScope = `switching-org:${String(newOrgId)}`;
        s.root.update(stateDelta);
        // Cross-org `?ws=` + pointer sync, as ONE idempotent pass that runs the
        // instant this switch's identity is known — see the WHY block on
        // `orgSwitchUrlWorkspace`. It is invoked three times, deliberately:
        //   1. NOW, in the same tick as the `root.org` re-scope, for a pass that
        //      already holds a new-org workspace record;
        //   2. from `onWorkspaceChange`'s `onWorkspaceResolved` callback, at the
        //      workspace-record adoption — one fetch into the pipeline, not
        //      after all ~18 of them (this is the ~9 s the URL used to lie for);
        //   3. after the pipeline, as the corrective pass.
        // Every later call is a NO-OP when the URL is already correct
        // (`syncWorkspaceUrl` returns null when `next === current`) and the
        // pointer write is idempotent.
        //
        // A cross-org switch to a NON-HQ workspace (org switcher drill-down →
        // e.g. GreenIG) federates via switchOrg, whose inner workspaceSwitched
        // event this shell DEFERS on (`__switchingOrg`) — so the workspace-switch
        // handler's pointer/URL sync never runs on this path, the address bar
        // kept naming only the org, and the next reload resolved it back to the
        // org's HQ: layout read from the WRONG workspace's row + the module never
        // loading — Nika's "sign in to greenig, widgets rearranged / data not
        // loading" (2026-07-30).
        const syncOrgSwitchedUrl = (candidate)=>{
            try {
                const org = s.root.org;
                const orgId = String(org?.id ?? org?._id ?? '');
                // `rewriteOrg` stamps `org.slug`, so the org ROW must already be the
                // new org. When claims never carried it, `stateDelta.org` was never
                // set and the state org is still the OUTGOING one — rewriting there
                // would stamp the OLD slug onto the NEW workspace, a worse lie than
                // the stale URL. Leave it to the claims tick / boot canonicalizer.
                if (!orgId || orgId !== String(newOrgId)) return;
                const resolved = (0, $9ocWj.orgSwitchUrlWorkspace)(candidate, newOrgId);
                if (!resolved) return;
                const wsId = String(resolved.id ?? resolved._id ?? '');
                if (wsId) $6b17f08f738443dc$var$shellSetActiveWorkspacePointer(wsId);
                // PROGRAMMATIC org switches (sdk.switchOrg from AI tools, cross-tab
                // convergence, tests) never route — only the switcher's own router
                // nav rewrites the URL. Left stale, the address bar names the
                // PREVIOUS org while state runs the new one, and the next reload
                // reconciles back to the URL's org — a flip-flop. `rewriteOrg` is
                // THE one caller allowed to move the org segment: state is settled
                // to the new org here, so the URL is the stale party. (Everywhere
                // else a path-vs-state org mismatch means a cross-org deep-link
                // whose reconcile hasn't run — sync no-ops there.) syncWorkspaceUrl's
                // parse also strips the OLD path's workspace segment against the
                // OLD org's own list, which the retired manual prefix-splice got
                // wrong when the resolver missed.
                $6b17f08f738443dc$var$shellSyncWorkspaceUrl({
                    workspace: resolved,
                    org: org,
                    // Incoming list + the outgoing org's scope, so the OLD
                    // workspace segment in the URL is recognisable as stale
                    // whether it is a raw `ws_` id or a plain slug.
                    workspaces: (0, $9ocWj.orgSwitchStaleWorkspaces)(outgoingWorkspace, outgoingWorkspaces, Array.isArray(s.root.workspaces) ? s.root.workspaces : [])
                }, {
                    rewriteOrg: true
                });
            } catch (err) {
                console.warn('[shell] org-switch workspace URL sync failed:', err?.message || err);
            }
        };
        // SAME TICK as the `root.org` re-scope on the REAL user path: the org
        // switcher hands `sdk.switchOrg` a `homeWorkspaceId`, whose workspace hop
        // completes BEFORE this event is emitted — so the switch already KNOWS
        // its target workspace, and `payload.workspaceHop.workspaceId` is that
        // identity. Stamping it here needs no fetch at all: a raw `ws_<id>`
        // handle is a first-class URL handle (the resolver + the stale-segment
        // strip both read it by shape), and the callback below refines it to the
        // workspace's slug for free once the record lands. Without this the URL
        // waited on the workspace RESOLVE (one to two round trips, measured
        // 0.9-3.4 s on the dev box) even when nothing needed resolving.
        // A programmatic `sdk.switchOrg(id)` with no hop carries no target, so it
        // falls back to the state record and heals on the callback below.
        // `sdk.switchWorkspace` returns `newWorkspaceId` on a real hop and
        // `workspaceId` on its unchanged early return — read BOTH, or the
        // same-tick stamp silently never fires (measured: it fell back to the
        // list-row callback, +990 ms).
        const hopWorkspaceId = workspaceHop && workspaceHop.ok !== false ? String(workspaceHop.newWorkspaceId || workspaceHop.workspaceId || '') : '';
        const hopWorkspace = hopWorkspaceId ? (0, $9ocWj.orgSwitchHopWorkspace)(hopWorkspaceId, [
            s.root.orgWorkspaces?.[String(newOrgId)],
            s.root.orgWorkspaces?.[newOrgId],
            s.root.workspaces
        ]) : null;
        syncOrgSwitchedUrl(hopWorkspace || s.root.workspace);
        try {
            await (0, $jZ5ZE.onWorkspaceChange)(s.root, resolveSdk(), nextClaims, {
                onWorkspaceResolved: syncOrgSwitchedUrl
            });
        } catch (err) {
            console.warn('[shell] onWorkspaceChange threw:', err?.message || err);
            // The pipeline threw before its reveal — clear whatever raise is
            // current so the loader can't wedge (home grid waits on it for 120s).
            (0, $jZ5ZE.endDataLoadFailsafe)(s.root);
        }
        // Corrective pass — a no-op whenever the callback above already landed
        // the right URL, and the healer when the pipeline resolved the workspace
        // on a path that never called back (early return, superseded pass).
        syncOrgSwitchedUrl(s.root.workspace);
    };
    try {
        el.sdk.rootBus.on('sdk.orgSwitched', el._handleOrgSwitched);
    } catch (err) {
        console.warn('[shell] orgSwitched listener init failed:', err?.message || err);
    }
    // Workspace-only switch propagation. A same-org workspace pick goes through
    // sdk.switchWorkspace (NOT switchOrg, which no-ops on an unchanged org), so
    // it emits `sdk.workspaceSwitched` rather than `sdk.orgSwitched`. Mirror the
    // org-switch handler: invalidate the fetch cache, advance the active-workspace
    // claim optimistically, and refire the in-place refetch so the UI re-scopes to
    // the new workspace WITHOUT a reload. Without this, switchWorkspace re-mints
    // the JWT but the UI keeps showing the previous workspace's data.
    el._handleWorkspaceSwitched = async ({ newWorkspaceId: newWorkspaceId, previousWorkspaceId: previousWorkspaceId } = {})=>{
        if (!newWorkspaceId || newWorkspaceId === previousWorkspaceId) return;
        // A cross-org switch federates via switchOrg → inner switchWorkspace, which
        // emits BOTH workspaceSwitched and orgSwitched. The org switcher flags that
        // window so we defer to the orgSwitched handler here and don't double-refetch.
        if (el.sdk?.__switchingOrg) return;
        // Same replay-settled guard as the org handler above: the claims stamp
        // is synchronous below (line ~1990), so claims already naming the
        // target workspace means this event is a bus replay (remount) or a
        // duplicate — never a fresh switch, which always arrives with the OLD
        // workspace still in claims.
        if (s.root.jwtClaims?.active_workspace_id === newWorkspaceId) return;
        // Loader up at the ABSOLUTE entry (see the org-switch handler note),
        // then park off any outgoing-manifest module route before the wipe.
        // Epoch-owned raise — see the org-switch handler.
        (0, $jZ5ZE.beginDataLoad)(s.root);
        $6b17f08f738443dc$var$_leaveModuleRouteForSwitch(el, s, $6b17f08f738443dc$var$moduleRoutesFromRoot(s.root));
        try {
            (0, $4skhB.queryClient).invalidateQueries();
        } catch (err) {
            console.warn('[shell] queryClient.invalidate failed:', err?.message || err);
        }
        const nextClaims = {
            ...s.root.jwtClaims || {},
            active_workspace_id: newWorkspaceId
        };
        // `__fetchScope` advances WITH the claim, not a network round-trip later
        // (isolation audit #9): onWorkspaceChange used to write it only after
        // its awaited getWorkspace resolved, so any element mounting in that
        // window built fetch-cache keys with the PREVIOUS tenant's scope — a
        // two-way poison (old rows painted into the new workspace, new rows
        // cached under the old tenant's key and served on a switch-back). The
        // id is known synchronously here; onWorkspaceChange re-writing the same
        // value later is a no-op.
        s.root.update({
            jwtClaims: nextClaims,
            __fetchScope: String(newWorkspaceId)
        });
        // Name the new workspace in the address bar. `/w/<org-slug>` identifies
        // only the ORG, so in a multi-workspace org the URL stayed identical
        // across the switch — and the next reload resolved it back to the org's
        // HQ workspace, silently undoing the pick. Resolved from `workspaces`
        // rather than `root.workspace`, which the refetch pipeline has not
        // advanced yet at this point.
        try {
            // Advance THIS tab's pointer. `sdk.switchWorkspace` writes only the
            // shared `localStorage` key, but under MWT the per-tab pointer lives in
            // sessionStorage — so without this the tab kept reporting the PREVIOUS
            // workspace to every pointer reader (sdk.js's activeWorkspaceId
            // resolver, the next boot's fallback) after a switch.
            $6b17f08f738443dc$var$shellSetActiveWorkspacePointer(newWorkspaceId);
            // Best-effort IMMEDIATE stamp — instant address-bar feedback when the
            // target is already present in the (possibly not-yet-refreshed)
            // governance-claims `workspaces` list. See the corrective re-sync
            // below for when it isn't.
            const list = Array.isArray(s.root.workspaces) ? s.root.workspaces : [];
            const next = list.find((w)=>String(w.id ?? w._id ?? '') === String(newWorkspaceId));
            if (next) $6b17f08f738443dc$var$shellSyncWorkspaceUrl({
                workspace: next,
                org: s.root.org,
                workspaces: list
            });
        } catch (err) {
            console.warn('[shell] workspace URL sync failed:', err?.message || err);
        }
        try {
            await (0, $jZ5ZE.onWorkspaceChange)(s.root, resolveSdk(), nextClaims);
        } catch (err) {
            console.warn('[shell] onWorkspaceChange (workspace switch) threw:', err?.message || err);
            (0, $jZ5ZE.endDataLoadFailsafe)(s.root);
        }
        // Corrective re-sync from the DEFINITIVELY-resolved workspace record.
        // The pre-emptive stamp above reads `s.root.workspaces` (the governance-
        // claims list) SYNCHRONOUSLY, the instant `sdk.workspaceSwitched` fires —
        // when the target isn't in that list yet (a workspace this session
        // hasn't seen, or a claims list still scoped to a stale org), `next` is
        // `undefined` and the `if (next)` guard silently skips the sync
        // entirely, leaving the address bar's `?ws=` naming the PREVIOUS
        // workspace. Live-confirmed: switching the same-org HQ → GreenIG left
        // `?ws=<raw HQ id>` in the URL (2026-07-30) — a stale handle a reload,
        // bookmark, or shared link then resolves straight back to (bootShell's
        // `resolveActiveWorkspace` reads the URL first), re-seeding every
        // workspace-scoped boot read (dashboard prefs, local cache) from the
        // WRONG workspace before anything corrects it. `onWorkspaceChange` has,
        // by this point, fetched + adopted the exact target record onto
        // `s.root.workspace` (its own `getWorkspaceCached` call, cross-org
        // guarded) — re-deriving the handle from THAT instead of the list
        // lookup can't miss. The identity check guards the generation race
        // (`onWorkspaceChange`'s own supersession guard can no-op this call if
        // a newer switch started meanwhile — `s.root.workspace` would then
        // already reflect the NEWER target, not this one, and the newer
        // switch's own invocation owns re-syncing it). Idempotent no-op when
        // the pre-emptive stamp above already got it right.
        try {
            const resolved = s.root.workspace;
            if (resolved && String(resolved.id ?? resolved._id ?? '') === String(newWorkspaceId)) $6b17f08f738443dc$var$shellSyncWorkspaceUrl({
                workspace: resolved,
                org: s.root.org,
                workspaces: Array.isArray(s.root.workspaces) ? s.root.workspaces : []
            });
        } catch (err) {
            console.warn('[shell] workspace URL re-sync failed:', err?.message || err);
        }
    };
    try {
        el.sdk.rootBus.on('sdk.workspaceSwitched', el._handleWorkspaceSwitched);
    } catch (err) {
        console.warn('[shell] workspaceSwitched listener init failed:', err?.message || err);
    }
    // WORKSPACE-ENFORCED INTERFACE LANGUAGE — re-resolve on every workspace
    // upgrade, not on any one switch path.
    //
    // A workspace whose admin set `settings.languagePolicy: 'enforced'` owns
    // the interface language inside itself, which makes that level of the
    // precedence the ONLY one that can change without a reload: it belongs to
    // a workspace, not to the person. bootShell resolves once, for whichever
    // workspace was active at boot — so without this, enforcement applied to
    // that workspace and no other.
    //
    // Subscribed to `onActiveWorkspaceFull` rather than to
    // `sdk.workspaceSwitched` beside it, DELIBERATELY. There are four ways the
    // active workspace changes (this handler, the org-switch handler,
    // switchOrg's inner switchWorkspace, and the cross-tab storage echo) plus
    // a fifth non-switch case that needs the same correction — the boot
    // record arriving AFTER bootShell already resolved. All five funnel
    // through `setActiveWorkspaceRecord`, which is what publishes this event,
    // so one subscription covers them and nothing has to be kept in step with
    // a list of switch paths.
    //
    // `applyWorkspaceLangPolicy` recomputes the WHOLE precedence and no-ops
    // when the answer is unchanged, so a redundant fire costs nothing and
    // LEAVING an enforced workspace restores the normal order for free.
    // Stable identity (a named element property, not an inline arrow) because
    // `onActiveWorkspaceFull` de-dupes by function identity.
    // Through `applyShellLangPolicy` (functions/shellLangPolicy.js): a
    // signed-out shell has no workspace, and the policy's English answer
    // overwrote the public language bootShell stamped for /login.
    el._applyLangPolicyOnWorkspace = ()=>{
        Promise.resolve(el.call('applyShellLangPolicy')).catch((err)=>console.warn('[shell] workspace language policy failed:', err?.message || err));
    };
    try {
        el._unsubLangPolicy = $6b17f08f738443dc$var$onActiveWorkspaceFull(el._applyLangPolicyOnWorkspace);
        // The event announces an UPGRADE, so it does not fire for a workspace
        // that was already full when this listener attached (a remount, or a
        // boot whose record landed first). Run once now for that case; the
        // no-op guard makes it free when boot already got it right.
        el._applyLangPolicyOnWorkspace();
    } catch (err) {
        console.warn('[shell] language policy listener init failed:', err?.message || err);
    }
    // Per-user socket subscription. When `sdk.setActiveOrganization`
    // fires in ANY session for this user (this tab, another tab,
    // another device), the core server's `PATCH /auth/me/active-org`
    // handler broadcasts `active-org-changed` on the user-socket
    // `user:<id>` room. We mirror it locally by calling
    // `sdk.switchOrg(newOrgId)` — which trips the same rootBus
    // pipeline as a local click, refetching org-scoped data.
    //
    // Transport (socket.io-client) lives inside the SDK as
    // `sdk.subscribeUserEvents(handlers)`. The workspace shell never
    // imports `socket.io-client` directly. The SDK's auth-aware
    // `getAuthToken()` + base URL resolution handle the handshake.
    //
    // The `sdk.switchOrg` guard inside the bus handler (skip when
    // `currentOrgId === newOrgId`) makes the echo to the originating
    // tab a no-op; only other sessions actually re-key.
    //
    // IDLE-DEFERRED (iPad P1 boot audit): the socket.io construct +
    // handshake ran inside the first-paint boot task for an event that
    // only matters AFTER boot. Dropping ≤2.5s is safe by transport
    // semantics — the server broadcasts `active-org-changed` to the
    // `user:<id>` room (server/packages/socket/user.js); socket.io has
    // NO replay for clients not yet in the room, so an event in the
    // deferral gap is simply not delivered. Consequence: a cross-session
    // org switch fired in that exact window doesn't converge this tab —
    // but boot itself just read the Mongo active-org truth via getMe, any
    // LATER switch event still arrives, and the pre-deferral connect
    // handshake had the same-class blind window anyway. The SDK reads the
    // auth token at call time (fail-soft no-op unsub when absent), so
    // late invocation is strictly fresher.
    el._unsubUserRealtime = (0, $iI0D7.deferIdleBoot)('user-realtime', ()=>el.sdk.subscribeUserEvents({
            'active-org-changed': ({ orgId: orgId } = {})=>{
                if (!orgId) return;
                // I6 (§6c): under MWT every tab is pinned to its own org from boot, so it
                // ignores a cross-device org switch. Gate on the flag itself, NOT the URL:
                // the `/w/<slug>` prefix is absent during the pre-canonicalize boot window,
                // so a URL check would let a concurrent socket event yank a freshly-loaded
                // tab off its org (the boot-window race). No-op while the flag is off.
                if ($6b17f08f738443dc$var$shellIsMwtEnabled()) return;
                // WHITELABEL-STRICT-TENANT-SCOPE-1 — a white-label tab is bound to its
                // HOST's tenant. This event is the ACCOUNT's pointer moving on another
                // host (an org switch on my.symbols reaches every socket of the user);
                // following it would move a customer's domain onto that org — and
                // custom domains run with MWT off, so the guard above never fires
                // there.
                if ((0, $lb2Ei.isCustomDomainHost)()) return;
                if (el.sdk._context?.activeOrgId === String(orgId)) return;
                try {
                    el.sdk.switchOrg(String(orgId));
                } catch (err) {
                    console.warn('[shell] socket-driven switchOrg failed:', err?.message || err);
                }
            }
        }));
    // Notification permission + realtime subscribe + initial fetch — this
    // trio previously only ran from IntranetAppHeader's onRender, but that
    // component is dead code (nothing mounts `IntranetAppHeader` — the shell
    // renders the shared `AppHeader` directly; see components/index.js's
    // barrel export vs. this file's actual AppHeader slot below), so no
    // notification ever subscribed and the browser-permission prompt never
    // fired. `currentUserEmail` isn't populated synchronously at shell mount
    // (it lands async via loadPrivateData/subscribeAuthSession), so poll
    // briefly rather than firing on an empty user — same wait-for-value
    // idiom tickets/pages/index.js's _ensureLoaded uses. One-shot: clears
    // itself once it fires (or gives up).
    {
        let _notifBootAttempts = 0;
        el._notifBootTimer = setInterval(()=>{
            const email = s.root?.currentUserEmail;
            if (!email && ++_notifBootAttempts < 30) return;
            clearInterval(el._notifBootTimer);
            el._notifBootTimer = null;
            if (!email) return;
            try {
                el.call('requestBrowserPermission');
                el.call('subscribeNotifications');
                el.call('fetchNotifications');
            } catch (err) {
                console.warn('[shell] notifications boot failed:', err?.message || err);
            }
        }, 200);
    }
    // Chat realtime at shell scope — previously the SSE stream only opened
    // once /chat was visited (chat/pages/index.js onCreate), so a message in
    // a channel the user never opened this session raised no toast anywhere
    // else in the app. subscribeRealtime is idempotent + workspace-keyed
    // (root._chatRealtimeChannel, guarded on the active workspace id) so
    // calling it here and again from /chat's own onCreate is a safe no-op
    // once the first call has a live connection. Firing at mount — before
    // `root.workspace` may have resolved — can open the stream unscoped;
    // _ensureShellRealtime below (wired into _syncShellRoute) detects that
    // drift the same way a real workspace switch does and re-opens it
    // correctly scoped, so this doesn't need to wait on anything either.
    try {
        el.call('subscribeRealtime');
    } catch (err) {
        console.warn('[shell] subscribeRealtime boot failed:', err?.message || err);
    }
    // Mail realtime at shell scope, the SAME correction as chat's above and
    // for the same reason: the mail SSE stream used to open only from the
    // /mail route or the header drawer, so `navUnreadCounts.mail` — the count
    // the envelope's dot and the navbar badge both read — had no producer on
    // any other route, and an unread inbox showed nothing anywhere
    // (MAIL-BADGE-NOTIFICATIONS-WIDGET-1, architecture/MAIL.md §3.6).
    // subscribeMailStream is idempotent + workspace-keyed on root._mailStream,
    // so this call and /mail's own are a no-op once one connection is live.
    // FLAG-GATED on the SAME predicate as the header envelope
    // (AppHeader HeaderActions.Mail `hide`): a workspace with mail off must
    // not pay for a stream nothing can read.
    $6b17f08f738443dc$var$_ensureMailRealtime(el, s.root);
    // Online-presence subscription at shell scope so CalOnlineUsersBar
    // in AppHeader shows online team members on EVERY route — including
    // workspace-shell pages (/dashboard, /data/*, /admin/*, /marketplace)
    // where no sub-app or per-page subscribe runs. useOnlinePresence is
    // ref-counted, so canvas/app.js's own subscribe and per-page calls
    // in /calendar, /tickets/board, /documents add themselves to the
    // same channel without re-subscribing. The shell holds the first
    // reference and only releases it on session teardown — so navigating
    // away from /chat doesn't kill presence for /dashboard.
    //
    // IDLE-DEFERRED (iPad P1 boot audit): opens a second /user-socket
    // connection — pure post-boot chrome data. Loss-free by protocol:
    // every `presence:sync` carries the FULL roster (presence.js
    // re-derives onlineUsers from the complete state each sync), so
    // joining ≤2.5s late misses nothing — the first sync catches up
    // entirely. Cost is cosmetic: presence dots (and our own "online"
    // announce to peers) appear up to 2.5s later. _bootChannel already
    // self-retries (60×1s) waiting for sdk/auth, so it is designed for
    // late invocation; ref-count symmetry is order-independent.
    el._presenceUnsub = (0, $iI0D7.deferIdleBoot)('presence', ()=>el.call?.('useOnlinePresence', {
            app: 'shell'
        }));
    // Background notification-count polling. Initial value comes from
    // loadPrivateData; this interval keeps the badges fresh between
    // sign-in and the next org switch. Cross-org by design — not reset
    // on workspace switch.
    el._notifPollTimer = setInterval(()=>{
        (0, $bShA0.fetchOrgNotifCount)(s.root).catch((e)=>console.warn('[shell] notif-poll fetch failed', e));
    }, $6b17f08f738443dc$var$NOTIF_POLL_MS);
    // CALL-INVITATION (tickets/fable.md) — a cheap root-state nudge so
    // CallInvitationBanner's wall-clock-only conditions (an event's endAt
    // quietly passing while the banner is already showing, with no other
    // state change in between) get re-evaluated even on an otherwise-idle
    // tab. The banner's "appear" moment needs NO timer at all — the
    // realtime `notification-created` push (subscribeNotifications.js)
    // already lands new rows straight into `root.notifs`, which is
    // reactive on its own; this is purely the self-expire polish.
    // Visibility-gated (hidden tabs throttle timers anyway — this is a
    // deliberate skip, not a hope): a backgrounded tab does no work here.
    el._meetingInviteTickTimer = setInterval(()=>{
        if (typeof document !== 'undefined' && document.hidden) return;
        s.root?.update?.({
            _meetingInviteTick: Date.now()
        }, {
            preventFetch: true
        });
    }, $6b17f08f738443dc$var$MEETING_INVITE_TICK_MS);
    // Shell-level meet realtime so the "Start a call" icon can badge an ONGOING
    // call in this workspace even before /meet is opened. subscribeMeetRealtime
    // is idempotent (scope-guarded) — /meet's own subscribe reuses the channel.
    // The room-INSERT branch and the meet.snapshot branch both fill
    // root.rooms; the participant branch fills root.liveParticipants; the
    // NewCall OngoingCallBadge derives the count.
    //
    // IDLE-DEFERRED (iPad P1 boot audit): subscribeMeetRealtime itself is
    // still deferred by up to 2.5s here for boot-perf reasons (unchanged).
    // What USED to follow from that — "a room INSERT during the gap is
    // missed" — no longer holds: FIXED (tickets/opus.md "`meet` realtime
    // discards the server's meet.snapshot, so a reconnect recovers
    // nothing", 2026-08-09). The server's connect-time `meet.snapshot`
    // frame used to be swallowed outright by the SDK's event map
    // (WorkspaceProjectService.subscribeMeetSse), with no dispatch branch
    // on this side either; both are fixed now, so the moment this deferred
    // subscribe finally opens, its first frame is a fresh snapshot of
    // whatever rooms exist AT THAT INSTANT — including any created during
    // the pre-subscribe idle-defer window. The badge no longer needs a
    // live room event or a /meet visit to pick those up. (`liveParticipants`
    // is unaffected either way: the server never streams a `participant`
    // kind at all, snapshot or live — D6, see subscribeMeetSse's own doc
    // comment — so the participant count still only updates from a live
    // join/leave.) Errors are caught + warned by the deferIdleBoot runner.
    // (The workspace-switch re-scope in loadPrivateData.js re-invokes the
    // same scope-keyed subscribe and composes with this via its own
    // idempotence.)
    //
    // SESSION-GATED (persona audit OV-2): `_ensureMeetRealtime` opens nothing
    // without a session and a workspace. A boot that is not there yet at the
    // idle moment opens the channel when the full workspace record lands
    // (`onActiveWorkspaceFull` — a sign-in on this page included) or at the
    // next route sync (`_ensureShellRealtime`).
    el._meetRealtimeUnsub = (0, $iI0D7.deferIdleBoot)('meet-realtime', ()=>$6b17f08f738443dc$var$_ensureMeetRealtime(el, s.root));
    el._ensureMeetOnWorkspace = ()=>$6b17f08f738443dc$var$_ensureMeetRealtime(el, s.root);
    try {
        el._unsubMeetOnWorkspace = $6b17f08f738443dc$var$onActiveWorkspaceFull(el._ensureMeetOnWorkspace);
    } catch (err) {
        console.warn('[shell] meet realtime listener init failed:', err?.message || err);
    }
    // TEMP probe — for browser-side modal verification.
    if (typeof window !== 'undefined') {
        window.__win = {
            call: (fn, arg)=>el.call(fn, arg),
            modalRoot: ()=>el?.getRoot?.()?.ModalRoot,
            stack: ()=>el?.getRoot?.()?.ModalRoot?.state?.stack
        };
        // Live root element for AI-driven platform actions (cloud client tools).
        // simoneAiTransport's onToolCall calls window.__wsRoot.call(fn, …args) to
        // run navigate/theme/search/confirm in the workspace UI. Refreshed here on
        // every (re)mount so it never goes stale after an auth/shell remount.
        window.__wsRoot = el;
    }
    // Marketplace install modal — windows-API watcher. Pushes / pops
    // the ModalRoot layer when `root.installModal` flips non-null/null.
    // All existing setters across shared/functions/installable.js,
    // MarketplaceIsland.js, canvas/functions/canvas/installMarketplaceItem.js
    // still write `host.update({ installModal: … })` — this watcher is
    // the bridge between that state and the @symbo.ls/windows API,
    // replacing the previous shell-root `MarketplaceInstallModal: {}`
    // slot whose own reactive `display:` factory toggled visibility.
    //
    // Polled at 100ms — cheap, no signal-subscription plumbing needed,
    // matches the pattern used by calendar's hash sync timers. The
    // install modal opens infrequently (clicking install on a catalog
    // tile) so the polling cost is negligible.
    let _installLayerOpen = false;
    el._installModalTimer = setInterval(()=>{
        const open = !!s.root?.installModal;
        if (open && !_installLayerOpen) {
            _installLayerOpen = true;
            // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default
            // maxHeight so the Close X can't be pushed off-screen.
            el.call('openCustomModal', {
                id: 'marketplace-install',
                content: {
                    extends: 'MarketplaceInstallModal'
                },
                dismissOnBackdrop: true,
                onCancel: ()=>{
                    try {
                        el.call('closeInstallModal', s.root);
                    } catch (_) {}
                }
            });
        } else if (!open && _installLayerOpen) {
            _installLayerOpen = false;
            el.call('closeModal', 'marketplace-install');
        }
    }, 100);
};
const $6b17f08f738443dc$var$shellApp = {
    extends: [
        'appShellStyles'
    ],
    // Docked module rail (chrome.rail — bellforge et al): the SHELL root
    // insets left by the rail's live width, so EVERY in-flow page — home,
    // route mounts, future surfaces — sits beside the rail like the chat
    // sidebar column, with zero per-page clearance code (2026-08-14 per Nika
    // "fix the layout on all pages for bellforge sidebar - just like … chat
    // sidebar … make workspace more abstract and modular to allow such
    // tweaks"). Fixed chrome (navbar, composer, docks, PageSlot) ignores
    // root padding by construction — the slot keeps its own
    // --module-rail-clear insets. Deliberately STATIC, not a factory: the
    // var IS the reactivity — ModuleRailHost's ResizeObserver maintains it
    // (rail width when rendered, 0px when hidden/absent, :root initial 0px),
    // so no signal tracking is involved and non-module workspaces pay 0px.
    paddingLeft: 'var(--module-rail-clear, 0px)',
    // Per-workspace stage colour (chrome.stage — the second module chrome
    // key after chrome.rail; contract note in workspaceProjects.js
    // moduleStageColor). When the ACTIVE workspace's module declares a stage
    // colour, the shell root paints it, so the strip behind the floating
    // module rail AND every in-flow shell page (home, studio, tickets, route
    // mounts) share ONE per-workspace surface (2026-08-16 per Nika: "root bg
    // should match workspace bg — consistent and manageable").
    // STATIC var reference ON PURPOSE — the first cut used a background
    // FACTORY here and it painted its boot-time value forever, because
    // root-level props do not re-evaluate when workspaceProject lands late
    // (measured live 2026-08-16). Same lesson as paddingLeft above: the var
    // IS the reactivity — _setStageVar maintains it from ModuleRailHost's
    // workspaceProject subscription, and a var() string passes the
    // css-in-props token table untouched.
    // ONE chain for every ground (BF-WIDGET-INK-1): `--stage-bg` is the
    // per-workspace override, `--color-stage` the design-system default. The
    // home page/board and every canvas Stage read the SAME chain
    // (canvasBackground.js STAGE_BACKGROUND), so the root can never differ
    // from what sits on it. This declaration loses to `theme: 'document'`'s
    // class rule — _setStageVar writes the same chain inline; kept here so
    // the contract is visible at the paint site and holds pre-hydration.
    background: 'var(--stage-bg, var(--color-stage))',
    height: '100dvh',
    overflow: 'hidden',
    // A stacking context of its own, so AmbientBackdrop (zIndex -1, below)
    // paints ABOVE this ground and BELOW every page layer — the order
    // HOME_AMBIENT_SKIN_SPEC §2 names (under the page stage, above the ground).
    // Every overlay mounts inside this root, so their z-order is unchanged;
    // only nodes appended to <body> itself (drag ghosts) now always sit above
    // the whole shell, which is where a drag ghost belongs.
    isolation: 'isolate',
    // Multi-workspace-tabs (Phase 3) — the initial hard-load render bypasses
    // context.functions.router (smbls calls the default router directly), so strip
    // the `/w/<org-slug>` prefix here too, so a deep-linked /w/acme/tickets matches
    // /tickets. No-op when the MWT flag is off (mirrors smbls' default
    // onRouterRenderDefault behavior).
    onRenderRouter: (0, $gO4wS.mwtOnRenderRouter),
    // SEARCH-1 (2026-08-14): @symbo.ls/router's router() dispatches its own
    // `routeChanged` DOMQL event (`onRouteChanged`) on the routes-bearing
    // element UNCONDITIONALLY, on every el.router() call — including the
    // client-side navigations openInSlot.js fires for forced routes (tickets/
    // tasks) and the search dropdown's navigateSearchResult. This is the shell
    // root (the element `app.routes` gets attached to by smbls' createDomql),
    // so it's the ONE place that sees every navigation regardless of which
    // page or slot ends up handling it. Bumping a counter here (rather than
    // duplicating URL-parsing logic per consumer) gives any single-shell-root-
    // instance component — TicketsDetailModal chief among them, see its
    // _restoreTicketFromRouteChange — a reactive "the URL may have changed"
    // signal to re-check against, the same problem PageSlot's own `_slotNudge`
    // solves for its keep-alive hosts.
    onRouteChanged: (el, s)=>{
        s.root.update({
            _routeNudge: (s.root._routeNudge || 0) + 1
        });
        // D2 §5 (P1): a context menu is anchored to viewport coordinates on the
        // surface it was opened from. Measured on staging, the home widget menu
        // survived TWO page changes and sat over the module's rail. Closing here
        // covers every navigation, because this event is the router's own and
        // fires unconditionally. See functions/homeContextMenu.js.
        el.call('closeContextMenuOnRouteChange');
        // Page/route motion (HOME_AMBIENT_SKIN_SPEC §6): a NEW page root rises in —
        // fadeInUpShort at C on springBezier (functions/routeTransition.js; skips the
        // boot route, a query-only change, reduced motion and a hidden tab).
        el.call('routeTransitionEnter', el);
    },
    // Page/route EXIT motion (HOME_AMBIENT_SKIN_SPEC §6; smbls 07c4b483b,
    // FW-ROUTER-PRE-SWAP-HOOK-FOR-EXIT-MOTION-1): the router calls this BEFORE
    // the swap with the page that is leaving and awaits the returned promise
    // for at most `exitTimeout` (300 ms); it skips the hook itself under reduced
    // motion and in a hidden tab. The leaving page fades (functions/
    // routeTransition.js routeTransitionExit: opacity only, B on defaultBezier,
    // resolves on finish or cancel); the new page then rises in through
    // onRouteChanged above.
    onRouteExit: (el, s, ctx, exit)=>exit && exit.page ? el.call('routeTransitionExit', exit.page) : undefined,
    // THE shell's ONE document keydown listener (HOME_AMBIENT_SKIN_SPEC §5),
    // declared here so DOMQL owns its lifecycle — registered once when the
    // shell root takes its node, torn down on dispose, never a raw
    // document.addEventListener (FA503). Bubble phase: a surface's own key
    // handling (a card's onKeyDown, an AppDialog's Esc) runs first and claims
    // the key with preventDefault, which the registry honours. Two steps, in
    // the order the two listeners ran before the registry's raw line moved
    // here from wireGlobalListeners.js:
    //   1. Escape for the shared ContextDropdown singleton. The panel's own
    //      Escape lives on `Menu.onKeydown`, a DELEGATED handler — it only ever
    //      sees a keystroke when focus is already INSIDE the menu, which is a
    //      bounded-poll race (`focusHomeContextMenu`). Measured on staging:
    //      Escape did not close the stray menu. The shell root is mounted on
    //      every route, so this backstop is armed everywhere.
    //   2. The keyboard registry (functions/shortcuts.js): the guard, both
    //      switches and every binding. No state snapshot — the handler reads
    //      the shell's LIVE root state itself.
    onDocumentKeydown: (e, el)=>{
        el.call('closeContextMenuOnEscape', e);
        el.call('handleShortcutKeydown', el, null, e);
    },
    // mailto: — the in-app composer is the DEFAULT action of a plain mailto
    // click (functions/mailtoComposeDefault.js). The same shape as the keyboard
    // above: ONE bubble-phase document listener DOMQL owns, so a surface's own
    // onClick runs first and claims the click with preventDefault (the CRM
    // contact dialog's Email action opens the CRM composer), which the shell
    // honours. It used to be a raw capture listener in wireGlobalListeners.js
    // that took every mailto click before any surface saw it.
    onDocumentClick: (e, el)=>el.call('mailtoComposeDefault', e),
    // D2 §8.4 — below SPLIT_MIN_WIDTH_PX there is no split, and a WINDOW that
    // gets narrow is one of the ways to be below it. `openAppPage`'s width
    // guard only ever gated the opening of a second pane, so a split armed on a
    // wide window survived a resize: measured on the deployed staging shell at
    // a verified `window.innerWidth` of 1000, PanePrimary 491px + PaneSecond
    // 491px, while the module's own `vaultCanSplit()` answered false beside it.
    // Folding it here, at the shell root, covers the resize the same way the
    // opener covers a gesture — ONE floor, both directions. The function
    // self-guards (it writes only when something is actually open), so a resize
    // drag folds once and every later tick is a no-op. DOMQL owns the
    // listener's lifecycle — registered once, torn down on dispose, never a raw
    // window.addEventListener (FA503), same contract as the Escape backstop
    // above.
    onWindowResize: (e, el)=>el.call('foldSplitOnResize'),
    // SPA navigation — BOTH guards, in their original arming order. AppShell's
    // patched history dispatches `locationchange` on push/replaceState;
    // `popstate` covers back/forward. One declared prop carries one handler per
    // event, so the composition lives here rather than in two registrations.
    // DOMQL owns both listeners: registered once with the node, torn down on
    // dispose — never a raw window.addEventListener (FA503), the same contract
    // as the Escape backstop and the resize fold above.
    onWindowLocationchange: $6b17f08f738443dc$var$_onSpaNavigation,
    onWindowPopstate: $6b17f08f738443dc$var$_onSpaNavigation,
    // THE ROOT WAITS FOR THE ONE BOOT. A parcel boot (bootShell) settled the
    // boot sequence before create(), so the shell's create pass runs at once,
    // exactly as before. On the published shell the boot plugin
    // (context.js `workspaceBoot`) started it in beforeCreate: the root applies
    // it first (bootApply — the session, org, workspace and language land on
    // the live root) and only then runs its own create pass, which reads
    // `context.preResolvedAuth` and the four synchronous SDK reads.
    onCreate: (el, s)=>{
        const ctx = el.context || {};
        if (ctx.bootMode !== 'published' || !ctx.bootReady) return $6b17f08f738443dc$var$_shellOnCreate(el, s);
        // Three outcomes (one-boot review D2, D9):
        //  • the boot NAVIGATED away (a rejected session: logout + /login, or the
        //    fresh-token reload): the page is leaving — no create pass, nothing
        //    signed in runs or renders from a stored token the server refused;
        //  • the boot FAILED (a step threw: bootReady settled null): fail closed —
        //    signed out, no create pass;
        //  • otherwise the create pass runs — signed in after bootApply, or a
        //    signed-out visitor who stays (a guest on /login, an invite, a soft
        //    bounce), whose session subscription an in-place sign-in needs.
        return ctx.bootReady.then((res)=>{
            if (!res) {
                ctx.bootSignedIn = false;
                console.error("[shell] the boot failed \u2014 the shell stays signed out");
                return null;
            }
            // the session check never answered (bootDeadline.js): the loader shows
            // its error + reload state; nothing signed in runs
            if (res.navigated || res.failed) return null;
            return Promise.resolve(res.aborted ? null : el.call('bootApply', el, res, {
                seed: ctx.bootSeed
            })).catch((err)=>console.warn('[shell] bootApply failed:', err && err.message || err)).then(()=>$6b17f08f738443dc$var$_shellOnCreate(el, s));
        });
    },
    onRemove: (el)=>{
        el.call?.('uninstallAppShellSync');
        if (typeof el._unsubShellAuth === 'function') try {
            el._unsubShellAuth();
        } catch (_) {}
        try {
            if (el._handleOrgSwitched) el.sdk?.rootBus?.off?.('sdk.orgSwitched', el._handleOrgSwitched);
            if (el._handleWorkspaceSwitched) el.sdk?.rootBus?.off?.('sdk.workspaceSwitched', el._handleWorkspaceSwitched);
        } catch (_) {}
        try {
            el._unsubLangPolicy?.();
        } catch (_) {}
        try {
            el._unsubUserRealtime?.();
        } catch (_) {}
        try {
            el._presenceUnsub?.();
        } catch (_) {}
        try {
            el._unsubAnalyzingOrgSwitch?.();
        } catch (_) {}
        if (el._notifPollTimer) {
            clearInterval(el._notifPollTimer);
            el._notifPollTimer = null;
        }
        if (el._notifBootTimer) {
            clearInterval(el._notifBootTimer);
            el._notifBootTimer = null;
        }
        try {
            el._meetRealtimeUnsub?.();
            el._meetRealtimeUnsub = null;
        } catch (_) {}
        try {
            el._unsubMeetOnWorkspace?.();
            el._unsubMeetOnWorkspace = null;
        } catch (_) {}
        if (el._installModalTimer) {
            clearInterval(el._installModalTimer);
            el._installModalTimer = null;
        }
        if (el._meetingInviteTickTimer) {
            clearInterval(el._meetingInviteTickTimer);
            el._meetingInviteTickTimer = null;
        }
        try {
            el.call?.('stopWorkspaceVoice');
        } catch (_) {}
    },
    // A11y skip-link — keyboard-first nav past the chrome. FIRST child (first
    // tab stop): a skip link that tabs in after the content it skips is
    // useless, and axe's `region` skip-link exemption additionally requires
    // (a) the `#main-content` fragment target to RESOLVE (stamped on every
    // route def — context.js `_anchorMainContent`) and (b) the link to precede
    // the first page link in DOM order (axe `_isSkipLink`). Both verified live
    // (MARKETPLACE-AUDIT residue, tickets/fable.md 2026-08-09).
    // position:absolute — out of flow, so being first child changes no layout.
    // The target follows the open window (functions/skipToMainHref.js): with
    // the primary PageSlot pane open the link jumps into the pane, never to the
    // page behind it. `subscribeTo` re-renders the link when the pane's route
    // changes (the house gate for a root-key read here, PageSlot SplitBtn).
    SkipToMain: {
        tag: 'a',
        subscribeTo: [
            '_canvasSlot'
        ],
        href: (el, s)=>el.call('skipToMainHref', s.root),
        text: '{{ workspace.a11y.skipToMain | polyglot }}',
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '99999',
        padding: 'Y B',
        background: 'document',
        color: 'title',
        fontSize: 'Z1',
        fontWeight: '700',
        transform: 'translateY(-100%)',
        ':focus': {
            transform: 'translateY(0)'
        }
    },
    // The ambient sky (DESIGN-WL-AMBIENT-SKIN-BACKDROP-1): one static,
    // aria-hidden, pointer-less layer under the page stage. Shown only under
    // the ambient skin by the injected sheet above; its own off switches (the
    // record's sky, reduced transparency, a ground override, the files-plane
    // mask) live in the component, on `hide:` — the component declares no
    // `if:`, so this mount's `if:` clobbers nothing.
    //
    // Staged at INTERACTIVE, not eager (the boot-task budget,
    // __tests__/shellStageLadder.test.js): the sky can never show before the
    // skin stamp that gates it, and ShellSkinSync lands at the same stage.
    //
    // THE TOP SKY + THE GROUND (DESIGN-WL-HOME-SKY-TOP-GROUND-1, Nika
    // 2026-10-01): the sky hangs from the top edge (`fadeTo: 'top'` — the
    // horizon band mirrored, fading out downward behind the greeting), and the
    // bottom belongs to AmbientGround — the loader's mountain range, which
    // rises into view over the last stretch of the home scroll (the sheet's
    // scroll-driven rules above). The sky paints on the home only in practice
    // (every app route's content host paints its own sheet over it), so one
    // placement serves every route. The ground's gate is the home route. The
    // band stops at the greeting's summary (`fadeAnchor`, measured — the clear
    // edge), and the person may keep the bottom band instead (Personalise →
    // Background; functions/ambientBackdrop.js ambientSkyPlacement). With the
    // head off (the greeting hidden, an app-mode workspace's default) the edge
    // is the first home row that has a box: the App strip, the boards row, the
    // grid (pages/main.js MainColumn order) — never the whole band behind them.
    AmbientBackdrop: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE),
        fadeTo: 'top',
        fadeAnchor: [
            'HomeTopSummary',
            'HomeAppStrip',
            'AssistantBoardsRow',
            'GridContainer'
        ]
    },
    AmbientGround: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    PhoneNavigation: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE),
        canCompose: (el, s)=>$6b17f08f738443dc$var$_composerAllowed(s.root, s.root?.currentPath, el),
        Dock: {
            onRender: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_phoneObs', '--phone-clear', (r)=>window.innerHeight - r.top),
            onWindowResize: (e, el)=>el._phoneObsApply?.(),
            onBeforeRemove: (el)=>$6b17f08f738443dc$var$_stopClearVar(el, '_phoneObs')
        }
    },
    AppHeader: {
        hide: (el, s)=>{
            // Immersive module chrome: the module manifest opts matched members
            // out of the shell header entirely (chrome.immersive — admins always
            // keep it). Reactive via subscribeTo 'workspaceProject' below: the
            // key is absent until the module loads, so the factory alone would
            // register no dependency on it.
            if ((0, $7ytvD.moduleImmersiveActive)(s.root)) return true;
            const path = s.root?.currentPath;
            return (0, $kuISg.isChromelessShellPath)(typeof path === 'string' ? path : typeof window !== 'undefined' ? window.location.pathname : '/');
        },
        // Search dropdown over an open PageSlot (2026-08-07 per Nika "search
        // suggestions dropdown should be above pageslot"). The header is a 1100
        // stacking context BY DESIGN — fullscreen slots (PageSlot 1300, top:0)
        // must cover it — so no zIndex on the dropdown itself can ever escape
        // the cap. Instead the WHOLE header lifts into the popover band
        // (> Suggestions 1349 / ReasoningPill 1350) only while a header search
        // is open: that state cannot co-occur with a fullscreen slot, because
        // under one the header is unreachable (pointer-blocked below 1300), so
        // the fullscreen-covers-header contract is never violated. Local mount
        // override — same surgical no-shared-edit pattern as NewCall below.
        // _moduleChromePref: the admin chrome toggle's reactive mirror — the
        // declared list is the binding contract, so without it the header never
        // remounts when an admin toggles the shell chrome back (measured).
        // 'currentPath' — item 11: moduleImmersiveActive is route-gated now, so
        // the header must re-resolve when navigating between the module surface
        // ('/') and own-sidebar routes (/studio, /infra) or it stays hidden.
        subscribeTo: [
            '_navSearchOpen',
            '_headerSearchOpen',
            'workspaceProject',
            '_moduleChromePref',
            'currentPath',
            // the navbar's place: both measurements below re-run when it moves (a
            // top → bottom move keeps the box size, so no ResizeObserver fires)
            '_homeLook',
            'userPrefs',
            '_isPhoneViewport'
        ],
        zIndex: (el, s)=>s.root?._navSearchOpen || s.root?._headerSearchOpen ? '1360' : '1100',
        // Maintain --nav-clear: viewport TOP → this header-navbar's BOTTOM edge.
        // --slot-top derives from it (+ --nav-gap), so the PageSlot's top gap to
        // the navbar EQUALS its bottom gap to the composer — both live-measured,
        // never an approximated constant (2026-07-12 per Nika "equal top and
        // bottom gaps from navbars").
        // …and --nav-edge, off the SAME observer (the tracker's second variable):
        // the navbar's reach from its own edge once the person moves it to a side
        // or the bottom (_measureHeaderNavEdge; 0 at the top). onUpdate re-runs
        // both when the place moves — a top → bottom move keeps the box size, so
        // the observer alone never fires.
        onRender: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_ncObs', '--nav-clear', (r)=>$6b17f08f738443dc$var$_measureHeaderNavClear(el, r), {
                varName: '--nav-edge',
                measure: (r)=>$6b17f08f738443dc$var$_measureHeaderNavEdge(el, r)
            }),
        onUpdate: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_ncObs', '--nav-clear', (r)=>$6b17f08f738443dc$var$_measureHeaderNavClear(el, r), {
                varName: '--nav-edge',
                measure: (r)=>$6b17f08f738443dc$var$_measureHeaderNavEdge(el, r)
            }),
        // The resize half of the measurement above (FA503 — framework-owned).
        onWindowResize: (e, el)=>el._ncObsApply?.(),
        // Preserve the shared AppHeader.onRemove (its island observer cleanup).
        onBeforeRemove: (el)=>$6b17f08f738443dc$var$_stopClearVar(el, '_ncObs'),
        // Ongoing-call badge on the "Start a call" icon — lit when there's a LIVE
        // call in THIS workspace the user hasn't joined (shell-level meet realtime,
        // see onCreate). Local override of the shared NewCall (same surgical pattern
        // as the demo lockdown below — no shared-library edit). Clones
        // Messenger.UnreadBadge's red pill; NewCall extends IconButton
        // (position:relative) so the absolute badge anchors. subscribeTo re-renders
        // NewCall when the room/participant signals change so the badge tracks live.
        // NOTE: a single HeaderLeft key — DOMQL merges nested objects, but this is
        // a plain JS object LITERAL: two top-level `HeaderLeft:` keys in the same
        // AppHeader override would silently clobber each other (last one wins),
        // not merge. The ongoing-call badge below and the demo-lockdown mirror
        // further down both have to live in this ONE block.
        HeaderLeft: {
            // The logo opens a FRESH Fly on the home in Fly mode (Nika 2026-10-23:
            // "clicking logo or home icon should be opening fresh fly screen";
            // functions/assistantFlyWorkspace.js assistantFlyHomeFresh). It stays
            // a link: a modified or middle click opens the home in a new tab.
            Logo: {
                onClick: (e, el)=>el.call('assistantFlyHomeClick', e)
            },
            HeaderActions: {
                // Unread-mail dot on the header envelope (architecture/MAIL.md §3.6).
                // Local override of the shared Mail button — the same surgical
                // no-shared-edit pattern as NewCall's badge below.
                //
                // The AppNavbarButton.UnreadBadge idiom EXACTLY (shared/components/
                // AppNavbar.js): a bare red dot, not a count. A dot carries no text,
                // so the 3:1 non-text contrast floor applies and brand `red` clears
                // it — the deepened `redDeep` that Messenger/NotificationBell must use
                // is only needed because those badges print a NUMBER on the plate.
                // Mail is deliberately the quieter signal: an inbox count is noise
                // beside a chat mention, and the exact number is one click away in
                // the drawer's own sidebar pill.
                //
                // `subscribeTo` sits on the BADGE, not on Mail. The shared button
                // already declares its own list ('_featureFlags', 'workspace',
                // '_mailDrawerOpen') and an array does not merge — restating it here
                // to append one key would silently freeze if that list ever changed.
                // The child subscribes to what only the child reads, which is the
                // idiom mail's own MailFolderRow.UnreadBadge uses.
                //
                // Mail extends IconButton (position: relative), so the absolute dot
                // anchors to the button, exactly as OngoingCallBadge does on NewCall.
                Mail: {
                    MailUnreadBadge: {
                        subscribeTo: [
                            'navUnreadCounts'
                        ],
                        hide: (el, s)=>!Number(s.root?.navUnreadCounts?.mail || 0),
                        // The dot is decorative to the eye and load-bearing to a screen
                        // reader — the button's own label says only "Mail". `role:
                        // 'status'` announces the change when the count first arrives.
                        role: 'status',
                        aria: {
                            label: (el)=>el.call('polyglot', 'workspace.header.mail.unread')
                        },
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        width: 'Y',
                        height: 'Y',
                        round: '50%',
                        background: 'red',
                        pointerEvents: 'none'
                    }
                },
                // Human/Agent mode is selected in the account menu.
                // Chat has one shell surface: the MessengerOverlay. Keep the header
                // entry point from creating a second chat in the PageSlot when a
                // workspace navbar also exposes /chat.
                Messenger: {
                    onClick: async (e, el, s)=>{
                        e.stopPropagation();
                        const root = s && s.root;
                        if (!root) return;
                        const opening = !root._chatDrawerOpen;
                        if (opening) {
                            const okFold = await el.call('ensureChatContext');
                            if (okFold === false) return;
                            root.update({
                                _canvasSlot: null,
                                _canvasSlotSecond: null,
                                _slotFullscreen: null,
                                _chatDrawerOpen: true,
                                activeChannelId: null
                            });
                            return;
                        }
                        root.update({
                            _chatDrawerOpen: false
                        });
                    }
                },
                NewCall: {
                    subscribeTo: [
                        'rooms',
                        'liveParticipants',
                        'activeRoomId'
                    ],
                    OngoingCallBadge: {
                        if: (el, s)=>$6b17f08f738443dc$var$_liveCallCount(s.root) > 0,
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        minWidth: 'Z',
                        height: 'Z',
                        padding: '0 V',
                        round: 'radiusPill',
                        background: 'red',
                        color: 'fillInk',
                        fontSize: 'W',
                        fontWeight: '700',
                        lineHeight: '1',
                        align: 'center center',
                        pointerEvents: 'none',
                        text: (el, s)=>{
                            const n = $6b17f08f738443dc$var$_liveCallCount(s.root);
                            return n > 9 ? '9+' : String(n);
                        }
                    }
                }
            },
            // DEMO LOCKDOWN mirror — the phone "one deck" merge (2026-08-02) mounts
            // a SECOND AppOrgSwitcher as this island's mobile leading-zone identity
            // affordance (AppHeader.js). Same isDemo + foreign-URL neutralization as
            // HeaderRight's instance below, restated here because it's a genuinely
            // separate mount (its own Trigger/InviteBtn DOM), not reachable through
            // the HeaderRight override path — without this a demo session, or a
            // visit to a URL naming an org you're not a member of, could still
            // org-switch (or show YOUR org's name) from the leading zone.
            AppOrgSwitcher: {
                Trigger: {
                    pointerEvents: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) ? 'none' : null,
                    cursor: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) ? 'default' : 'pointer',
                    'aria-haspopup': (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) ? null : 'menu',
                    'aria-label': (el, s)=>el.call('polyglot', $6b17f08f738443dc$var$_orgSwitcherAriaLabel(s.root)),
                    // + the navbar rail's narrow posture: a monogram, no chevron
                    // (shared functions/navbarLayout.js navbarRailLabel)
                    Icon: {
                        hide: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) || (el.call('navbarLayoutRead', s.root) || {}).railMode === 'narrow'
                    },
                    Label: {
                        text: (el, s)=>el.call('navbarRailLabel', $6b17f08f738443dc$var$_orgSwitcherLabel(el, s.root), s.root)
                    }
                },
                InviteBtn: {
                    hide: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root)
                }
            }
        },
        // The home icon, like the logo: a fresh Fly on the home in Fly mode.
        HeaderTabs: {
            HomeBtn: {
                onClick: (e, el)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    el.call('assistantFlyHomeFresh');
                }
            },
            // Apply the action to real tab rows; a HeaderTab child here renders
            // an empty extra button beside the app launcher.
            Tabs: {
                childProps: {
                    scope: {
                        openTab: async (e, el, s)=>{
                            if (s.placeholder || !s.path || s.root?._navbarReorder) return;
                            e.preventDefault();
                            if (s.path !== '/chat') {
                                el.call('openAppPage', s.path, {
                                    preferSlot: true,
                                    split: e.metaKey || e.ctrlKey
                                });
                                return;
                            }
                            s.root.update({
                                _chatDrawerOpen: false
                            });
                            el.call('openAppPage', s.path, {
                                preferSlot: true,
                                split: e.metaKey || e.ctrlKey
                            });
                        }
                    }
                }
            },
            MobileTabs: {
                scope: {
                    openTab: async (e, el, s)=>{
                        if (s.placeholder || !s.path || s.root?._navbarReorder) return;
                        e.preventDefault();
                        if (s.path !== '/chat') {
                            el.call('openAppPage', s.path, {
                                preferSlot: true,
                                split: e.metaKey || e.ctrlKey
                            });
                            return;
                        }
                        s.root.update({
                            _chatDrawerOpen: false
                        });
                        el.call('openAppPage', s.path, {
                            preferSlot: true,
                            split: e.metaKey || e.ctrlKey
                        });
                    }
                }
            }
        },
        // DEMO LOCKDOWN + FOREIGN-URL NEUTRALIZATION — lock the org-identity
        // chrome to a static, non-interactive label whenever it would otherwise
        // lie about whose org you're looking at:
        //   • `root.isDemo` — lock the workspace to the single demo org so a demo
        //     visitor can ONLY ever see their own demo org.
        //   • `_foreignOrgUrl(root)` — the URL names an org you're not a member
        //     of (tickets/workspace.md "neutral chrome…", residual from
        //     9deb1386). `root.org` still holds YOUR active org (no switch is
        //     possible — `mwtOrgToReconcile` correctly refuses it), so left alone
        //     the Trigger would show YOUR org's name beside a stranger's content.
        // The shared AppOrgSwitcher's dropdown is what exposes switch-to-other-
        // org / + Create organization / Delete organization / Admin; the
        // InviteBtn exposes invite/join. We neutralize BOTH here, surgically and
        // reactively, WITHOUT editing the shared component:
        //   • Trigger → render as a STATIC, generic label: drop pointer-events
        //     (its onClick that opens the dropdown can't fire), reset the
        //     cursor, hide the chevron, clear the menu a11y hints, and swap the
        //     visible label for the shared component's own "no specific org
        //     resolved" fallback string ('Organization') — reusing existing
        //     product copy rather than inventing new text, and never showing
        //     either party's actual org name in the foreign-URL case (see
        //     `_orgSwitcherLabel`'s comment for why NOT read-only owner
        //     branding). Neither gate touches the other's session (every
        //     override reactively re-derives from live root state).
        //   • InviteBtn → hidden.
        // Real, non-demo sessions on a URL naming their OWN org (or no org at
        // all) keep the full switcher + invite affordances, unchanged.
        HeaderRight: {
            AppOrgSwitcher: {
                Trigger: {
                    pointerEvents: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) ? 'none' : null,
                    cursor: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) ? 'default' : 'pointer',
                    'aria-haspopup': (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) ? null : 'menu',
                    'aria-label': (el, s)=>el.call('polyglot', $6b17f08f738443dc$var$_orgSwitcherAriaLabel(s.root)),
                    // Chevron signals "opens a menu" — hide it so the static label
                    // doesn't imply a switcher.
                    // + the navbar rail's narrow posture: a monogram, no chevron
                    // (shared functions/navbarLayout.js navbarRailLabel)
                    Icon: {
                        hide: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root) || (el.call('navbarLayoutRead', s.root) || {}).railMode === 'narrow'
                    },
                    Label: {
                        text: (el, s)=>el.call('navbarRailLabel', $6b17f08f738443dc$var$_orgSwitcherLabel(el, s.root), s.root)
                    }
                },
                InviteBtn: {
                    hide: (el, s)=>$6b17f08f738443dc$var$_neutralizeOrgSwitcher(s.root)
                }
            }
        }
    },
    // DEMO LOCKDOWN — route guard. Even with the org-switcher dropdown
    // neutralized, a demo visitor could still reach admin / other-org / cross-org
    // surfaces by typing the URL (or via a stale history entry). This invisible
    // route-reactive sentinel redirects `root.isDemo` sessions away from those
    // entry points back to `/`. Gated strictly on isDemo, so real users are
    // never bounced. Uses el.router (SPA, framework-correct) — no full reload.
    DemoRouteGuard: {
        tag: 'div',
        display: 'none',
        subscribeTo: [
            'currentPath',
            'isDemo',
            '_authReady'
        ],
        onCreate: (el, s)=>$6b17f08f738443dc$var$_guardDemoRoute(el, s),
        onUpdate: (el, s)=>$6b17f08f738443dc$var$_guardDemoRoute(el, s)
    },
    // Invisible route-kind sync — keeps <html data-shell-route> current so
    // the injected content CSS offsets app pages below the AppHeader.
    // subscribeTo + onUpdate is the reliable route-reactive path; a reactive
    // style/grid wouldn't re-apply on navigation in v3.14.
    ShellRouteSync: {
        tag: 'div',
        display: 'none',
        // `workspaceApps` + `workspaceProject`: the route kind reads the INSTALLED
        // app routes (_isProjectCanvasPath → moduleRoutesFromRoot), and on a cold
        // load they arrive after the first sync. Without these keys a deep link to
        // a 2-segment app page (/validators/networks) stayed classified as an
        // <owner>/<project> canvas — full-bleed under the header — until some
        // other key moved (Storm on dev, 2026-10-04).
        // `_moduleComposerHidden`: a module page's composer latch moves the
        // <html data-prompt> mirror below (functions/moduleShellComposer.js).
        // `_isPhoneViewport` + `_phoneComposerOpen`: the phone dock's park moves
        // the same mirror (_composerVisible). `assistantMode` + `_homeThreadOpen`:
        // the home's Build tab — the app builder — stands the composer down too
        // (functions/homeBuild.js homeBuildShown).
        subscribeTo: [
            'currentPath',
            'workspaceApps',
            'workspaceProject',
            '_moduleComposerHidden',
            '_isPhoneViewport',
            '_phoneComposerOpen',
            'assistantMode',
            '_homeThreadOpen',
            '_chatDrawerOpen',
            '_mailDrawerOpen',
            'assistantOpen',
            'assistantDock',
            'assistantWidth',
            '_canvasSlot',
            '_canvasSlotSecond',
            // the navbar's place (<html data-nav-place>, read through the look)
            '_homeLook',
            'userPrefs'
        ],
        onCreate: (el, s)=>{
            // Reflect device pointer type onto <html data-pointer="coarse|fine"> once
            // at shell mount, so touch CSS + the @coarse/@touch media tokens resolve
            // from first paint. Idempotent (wires its media listener once).
            $6b17f08f738443dc$var$syncPointerCapability();
            $6b17f08f738443dc$var$_syncShellRoute(s.root, el);
        },
        onUpdate: (el, s)=>$6b17f08f738443dc$var$_syncShellRoute(s.root, el)
    },
    // Invisible skin sync — keeps <html data-skin> on the workspace's choice
    // (see _syncShellSkin): the record arriving, a workspace switch, the admin
    // card's write, a branded host resolving, a workspace module (and its own
    // ground) loading. Staged at INTERACTIVE, not eager
    // (the boot-task budget, __tests__/shellStageLadder.test.js): the record it
    // waits for lands after first paint anyway, and one macrotask later costs
    // the stamp nothing.
    ShellSkinSync: {
        tag: 'div',
        display: 'none',
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE),
        subscribeTo: [
            'workspace',
            'workspaceSettings',
            'whitelabelBrand',
            'workspaceProject'
        ],
        onCreate: (el, s)=>$6b17f08f738443dc$var$_syncShellSkin(s.root),
        onUpdate: (el, s)=>$6b17f08f738443dc$var$_syncShellSkin(s.root)
    },
    // Invisible thread-URL sync — every main-thread conversation has its own
    // URL, `?ai=<conversationId>`: a pasted link, a reload and Back / Forward
    // open that thread, and the thread writes its URL (components/
    // AssistantThreadUrlSync.js + functions/assistantThreadUrl.js hold the rule).
    // Staged at INTERACTIVE: a link waits for the AI service and the workspace
    // anyway, and both land after first paint.
    AssistantThreadUrlSync: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // Compact "AI is thinking" pill — shown above the composer when a GENERAL
    // Simone turn is live but the assistant drawer is closed (e.g. a PageSlot /
    // split page is open), so the user still sees what the AI is doing without the
    // full chat. Clicking it opens the drawer. One row at the control height: its
    // words float above it as bubbles, with a step that waits for the person's OK
    // nearest the bar, and a landed answer turns its head into "Answer ready" +
    // Open in main / Open in sidebar (functions/assistantAnswerPopover.js — the
    // separate answer capsule that used to stack over it is gone). (Home +
    // /add-app render the timeline inline in their own surfaces.)
    SimoneReasoningPill: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME)
    },
    // INSPECT & ASK's layer over the page (components/AiInspectLayer.js,
    // functions/aiInspect.js; DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1).
    // It gates itself on the mode (`if:` — its document listeners exist only
    // while inspecting); a mount-site gate here would replace that one.
    AiInspectLayer: {},
    // SimoneSuggestions — the IDLE companion to the pill — is NO LONGER mounted
    // here as a position:fixed sibling (O1, opus.md 2026-08-16): it now renders
    // IN-FLOW inside CanvasPromptTextarea.PromptBand, the one owner of the strip
    // above the composer, ordered after the AiContextBar. Same gating
    // (_promptFocused / assistantOpen / running turn); no longer paints over the
    // composer subtree at zIndex 1449.
    // AI prompt — GLOBAL (2026-06-06 per Nika): the bare
    // CanvasPromptTextarea mounted once at the shell root — no
    // BottomPrompt gradient band — so it shows on EVERY page, canvas
    // pages included (their own mounts were removed; CanvasEditor +
    // studios now rely on this one). Hidden only on auth routes.
    // position:fixed (native is absolute) anchors it to the viewport
    // regardless of the shell's scroll state.
    CanvasPromptTextarea: {
        // Delegates to _composerVisible (module scope, above) — the SAME
        // predicate _syncShellRoute mirrors onto <html data-prompt> for the
        // app-page bottom-padding CSS rule, so the two can never drift. Strips
        // the multi-workspace-tabs `/w/<slug>` prefix internally BEFORE
        // route-matching — on `/w/bellforge/add-app` the raw path never equals
        // '/add-app', so the composer floated over that page's own prompt
        // (verified live 2026-07-24). Hidden on auth routes and on surfaces that
        // already have their OWN conversation composer, where the global
        // CanvasPrompt is a redundant second prompt that overlaps the page's own
        // input (/add-app — Simone chat in the left column; /chat — the
        // channel/DM message composer at the bottom of the conversation), on
        // /meet-guest (anonymous guests have no workspace AI), and for signed-in
        // non-members (2026-07-29 per Nika "canvas prompt is only visible for
        // members" — same gate the header actions + presence dock use).
        hide: (el, s)=>!$6b17f08f738443dc$var$_composerVisible(s.root, s.root?.currentPath, el),
        // Immersive-chrome reactivity: _composerVisible reads
        // root.workspaceProject.chrome, a key absent until the module loads —
        // the factory alone registers no dependency on it. Same for a module
        // page's composer latch (`_moduleComposerHidden`, read behind earlier
        // returns) and the pane routes it is bound to. The phone dock's park
        // (`_isPhoneViewport`, `_phoneComposerOpen`) is read last, behind every
        // other return. The home's Build tab (`assistantMode`, `_homeThreadOpen` —
        // functions/homeBuild.js homeBuildShown) is read behind the route checks.
        subscribeTo: [
            'workspaceProject',
            '_moduleComposerHidden',
            '_canvasSlot',
            '_canvasSlotSecond',
            '_isPhoneViewport',
            '_phoneComposerOpen',
            'assistantMode',
            '_homeThreadOpen'
        ],
        // DESIGN-WL-ASSISTANT-MAIN-VIEW-1 — the recent boards as chips in the
        // strip above the composer (the PromptBand owns that strip), bottom-most
        // so they sit on the composer. They gate themselves (Page mode on the
        // home, a board to go back to): no `if:`/`hide:` here — a mount-site gate
        // REPLACES the component's own.
        PromptBand: {
            AssistantThreadChips: {},
            // What the member HANDED the assistant — an inspected region, a dropped
            // ref, a picked record — right above the field, focused or not (the
            // context itself lives in the focus panel; DESIGN-COMPOSER-FOCUS-
            // POPOVER-CONTEXT-INSPECT-1). Last, so it sits on the composer. The
            // strip floats over the page, so it sits on the composer's own `pill`
            // plate like AssistantThreadChips: a chip's wash alone let a table row
            // read through the "Fleet health" chip (measured on dev 2026-10-04).
            AiContextBar: {
                attachedOnly: true,
                theme: 'pill',
                round: 'radiusPill',
                padding: 'X',
                alignSelf: 'flex-start',
                maxWidth: '100%'
            }
        },
        // Bridge for the landing hand-off (WS-WORKSPACE-CONSUMES-THE-PROMPT-
        // QUERY-FROM-THE-LANDING-HERO-COMPOSER-1). The shell root's own onCreate
        // (WS-LANDING-PROMPT-HANDOFF, above this component in the tree) already
        // owns reading/stripping/capping `?prompt=` — it must stay the ONE
        // reader, or a second independent read races it and strips the param out
        // from under whichever loses. That handler runs the AI transport in a
        // DIFFERENT DOMQL state scope than this composer's own local `draft`
        // (declared on THIS component, canvas/components/CanvasPromptTextarea.js
        // `state: { draft: '', … }`), so it reaches in through this one function
        // instead of a competing URL read. Registered directly on root (not
        // `s.root.update`) because a function is dropped by state's clone.
        // This component still never reads the URL — it reads the PARK the root
        // writes when it finds no bridge, which keeps the single-reader rule and
        // fixes the 716 ms the root used to lose the sentence in.
        onCreate: (el, s)=>{
            const prefill = (text)=>{
                if (!text) return false;
                s.update({
                    draft: text
                });
                // Deferred a frame: the textarea node for this fresh s.update isn't
                // guaranteed painted yet (same reasoning as aiComposerKeys.js's
                // applyAiMentionPick caret restore, and the same windowless-runtime
                // fallback — a bare requestAnimationFrame reference throws under bun
                // test / bypass mode).
                const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (fn)=>setTimeout(fn, 16);
                raf(()=>{
                    const ta = el.node && el.node.querySelector && el.node.querySelector('textarea');
                    if (!ta) return;
                    ta.focus();
                    try {
                        ta.setSelectionRange(text.length, text.length);
                    } catch (_) {}
                });
                return true;
            };
            s.root._prefillHomePrompt = prefill;
            // DRAIN. The shell root reads `?prompt=` ~716 ms before this component
            // exists (measured, dev.my 2026-09-23), so the bridge above is almost
            // always registered too late for that read. The root parks the sentence
            // when nobody takes it; this is where the composer picks it up. One
            // shot — `takeParkedInboundPrompt` removes the row as it reads it, so a
            // reload never prefills twice.
            let _parkStore = null;
            try {
                _parkStore = typeof window !== 'undefined' ? window.sessionStorage : null;
            } catch (_) {
            /* sandboxed frame — nothing was parked either */ }
            prefill((0, $azpxa.takeParkedInboundPrompt)(_parkStore));
        },
        position: 'fixed',
        // Above the PageSlot frame (1300) so the composer never sits under the
        // slot sheet's shadow scrim (2026-08-06 per Nika "make sure chattexarea
        // is higher zIndex as pageslot ... means zIndex not position"); still
        // under Modal (2000) and every dropdown/window layer.
        zIndex: '1400',
        // Maintain --prompt-clear (registered with the @property vars above): the
        // distance from the viewport bottom to this composer's TOP edge, so the
        // PageSlot's bottom lands exactly on the textarea line. A ResizeObserver
        // (not a one-shot) because the textarea grows with multiline input; the
        // value is height + bottom-inset, so window resizes don't change it.
        // documentElement.style is shell-owned here (same file already injects the
        // shell <style>); skip while hidden (rect collapses to 0).
        // Maintain --prompt-clear: viewport BOTTOM → this composer's TOP edge
        // (value = height + bottom inset, so window resizes don't move it; the
        // resize re-apply covers textarea reflow on width changes).
        //
        // RESTING pill only (2026-09-02 per Nika "when canvastextarea is
        // expanded, lets not resize sidebars and pageSlot - lets textarea
        // increase above them"): an Expand used to push --prompt-clear to the
        // expanded card's top, and every --slot-bottom consumer (PageSlot, the
        // module rail, the app sheet, the messenger list) shrank with it. The
        // expanded card is a transient overlay — it sits at z 1400, above the
        // slot band — so the measurement now returns `null` (= keep the last
        // resting value) while `size` is not 'small'. Minimize re-measures the
        // pill through the same RO. A multi-line SMALL draft still grows the
        // clearance: that is the pill itself getting taller, not an overlay.
        //
        // The SAME observer also publishes the resting pill's WIDTH as --prompt-w
        // (the fifth argument, _PROMPT_WIDTH): the island docked above the composer
        // takes it (the shell rule on [data-gauge="composer"]); the same null keeps
        // the resting value while the composer is expanded.
        //
        // The clearance reaches the top of the composer's STACK: the rows docked
        // on the pill count while they show (_composerStackTop), and the band is
        // watched too (the sixth argument) — a row coming or going resizes the
        // band, never the pill.
        onRender: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_pcObs', '--prompt-clear', (r)=>el.state && el.state.size && el.state.size !== 'small' ? null : window.innerHeight - $6b17f08f738443dc$var$_composerStackTop(el, r), $6b17f08f738443dc$var$_PROMPT_WIDTH, el.PromptBand && el.PromptBand.node),
        // The resize half of the measurement above (FA503 — framework-owned).
        onWindowResize: (e, el)=>el._pcObsApply?.(),
        onBeforeRemove: (el)=>$6b17f08f738443dc$var$_stopClearVar(el, '_pcObs'),
        // Resting shadow comes from the canvas-card-glass theme — the SAME
        // layer the HeaderLeft/Tabs/Right islands and the HeaderSearch pill
        // rest on — instead of the old custom '0 12px 32px rgba(0,0,0,0.35)'
        // override, which read heavier than the islands and dropped the
        // theme's glass inset ridge (iPad, 2026-08-01 per Nika "canvas prompt
        // textarea not consistent with others"). Nika's resting drop shadow
        // (2026-06 "lost when the BottomPrompt wrapper went away") is still
        // there — it's the theme's own drop layer now. Focus swaps in the
        // ring stack below exactly like HeaderSearch's :focus-within.
        // Soft focus glow on the WHOLE prompt card when the textarea
        // inside is focused — reads cleaner than the default
        // browser outline drawn only around the textarea node. Two
        // stacked shadows:
        //   • inner 1px ring in `blue` at 35% opacity for the
        //     accent edge
        //   • outer 24px halo in the same blue at 16% opacity for
        //     the diffuse glow that fades into the page background
        // Plus the existing canvas-card-glass drop shadow underneath
        // (kept via the layered comma — DOMQL replaces `boxShadow`
        // wholesale, so the base shadow has to be re-stated here).
        // Transition: the 160ms ease smooths the glow on/off; the rest is
        // the component's own motion list (canvas CanvasPromptTextarea.js),
        // re-stated because DOMQL replaces `transition` wholesale too. Never
        // `all`: a skin is a surface, not a state change — `B all` here eased
        // the fill and the blur from the solid to the glass values after a
        // reload (DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1;
        // composerNoSkinFade.test.js holds the two lists equal).
        transition: "160ms defaultBezier box-shadow, B height defaultBezier, B max-height defaultBezier, B min-height defaultBezier, B width defaultBezier, B min-width defaultBezier, B padding defaultBezier, B border-radius defaultBezier, B transform defaultBezier",
        ':focus-within': {
            boxShadow: '0 0 0 1px rgba(57, 124, 255, 0.45), 0 0 0 6px rgba(57, 124, 255, 0.16), 0 12px 32px rgba(0, 0, 0, 0.35)'
        },
        // Override the canvas-mode toolbar for the home prompt. The
        // canvas Inspect button (`sf cursor` glyph, dispatches
        // `setCanvasMode('inspectMode')`) doesn't apply outside the
        // studio, so we hide it. In its place we surface a
        // `ParamsBtn` (`params` glyph) declared AFTER the inherited
        // children so DOMQL's merge places it at the end of the
        // toolbar — last icon in the row.
        PromptButtons: {
            // Inspect (sf cursor → setCanvasMode('inspectMode')) only makes
            // sense over a live PROJECT canvas. Gate strictly on the path
            // being `/<owner>/<project>` — exactly two segments whose first
            // isn't a reserved app route (2026-06-08 per Nika: "InspectBtn
            // should be only visible on project canvas /*/*"). Path-based
            // rather than the old `_projectCanvasOpen` flag, which could leak
            // true after navigating away and showed the button on /studio etc.
            InspectBtn: {
                display: null,
                // Not on phones: a project page's expanded 390 row
                // is 260.9 px and needs 311.7 with Inspect + Sidebars (design-d2's
                // joint pass, 2026-09-29) — picking an element on a phone canvas is
                // not the phone's job. `display: null` leaves no inline display for
                // the rule to fight.
                '@mobileL': {
                    display: 'none'
                },
                hide: (el, s)=>{
                    const p = s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
                    return !(0, $2C7Li.isProjectCanvasPath)(p, s.root);
                }
            },
            // Quick model switcher — THE shared AiModelSwitcherTrigger (one
            // implementation with the assistant header's AiModelSwitcher;
            // shared/components/AiModelSwitcher.js — 2026-08-12 per Nika
            // "canvasPromptTextarea and ai assistant should be using same model
            // switcher and settings buttons"). Same display/hide pattern as
            // ParamsBtn below; also hidden in local mode (the simone-bridge agent
            // ignores modelMode). The shell has the dropdown plugin, so the
            // trigger's default self-anchored toggle is overridden with the house
            // openDropdown panel hosting the same AiModelSwitcherBody.
            ModelBtn: {
                extends: 'AiModelSwitcherTrigger',
                // Opt OUT of the row's childExtends (NavbarButton): its square
                // icon-button geometry turned the old TEXT pill into a 79×79 block
                // beside 27px siblings (2026-08-18 per Nika "fix '✦ Auto' button
                // size in CanvasPromptTextarea"). Since design-d2's 789772f71 the kit
                // button is "✦" + caret on every width, so it takes the row's square
                // (the childProps padding Y) — the label-era `padding: 'Y Z2'` that
                // widened it to ~50 px is gone.
                ignoreChildExtends: true,
                display: null,
                // The inherited trigger's open state reads root._modelMenuOpen — the
                // SELF-ANCHORED composite's flag (the assistant header). This host
                // opens the plugin dropdown instead, so without this pin the
                // composer pill lit up whenever the DRAWER's picker opened
                // (cross-surface leak, verified live 2026-08-13).
                isOpen: ()=>false,
                // Same cross-surface reasoning as `isOpen` above, for the ARIA half
                // (2026-09-02): the inherited trigger reports `aria-expanded` from
                // root._modelMenuOpen — the DRAWER composite's flag, which this host
                // never writes. Reporting it here would announce "expanded" whenever
                // the assistant's own picker opened. The plugin panel owns (and
                // announces) its lifecycle; `aria-haspopup="menu"` still ships.
                ariaExpanded: ()=>null,
                // Local mode no longer hides the pill (2026-09-02): the switcher
                // body carries the Provider group with the Local-agent row — the
                // one exit from local mode — so hiding it here would trap the mode.
                hide: (el, s)=>s.size === 'small',
                // ArrowDown/ArrowUp open the menu — the menu-button keyboard
                // contract. The inherited trigger's own openByKey drives the
                // SELF-ANCHORED flag this host does not use, so it is replaced here
                // with the same plugin open the click path runs. Enter/Space need no
                // branch: this is a real <button>, so both fire onClick already.
                onKeydown: (e, el)=>{
                    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
                    e.preventDefault();
                    e.stopPropagation();
                    $6b17f08f738443dc$var$_openAiModelDropdown(el);
                },
                onClick: (e, el)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    $6b17f08f738443dc$var$_openAiModelDropdown(el);
                }
            },
            // THE shared AiSettingsButton (one implementation with the assistant
            // header's SettingsBtn — shared/components/AiSettingsButton.js).
            // No Chat ancestor here, so its context-aware onClick opens the house
            // @symbo.ls/dropdown panel with the SAME AiSettingsPanel body the
            // sidebar assistant's SettingsDrawer renders — both surfaces identical
            // by construction. Key stays `ParamsBtn` (legacy data-key anchor).
            ParamsBtn: {
                extends: 'AiSettingsButton',
                // Hidden in the super-minimized (small) pill — returns on expand.
                // `display: null` clears the NavbarButton inline `display` so the
                // reactive `hide` can win (same pattern as InspectBtn above).
                // Reversible: drop these two lines (2026-06-14 per Nika).
                display: null,
                hide: (el, s)=>s.size === 'small'
            },
            // ── The project canvas's sidebar toggle — project canvas only ──
            // Same path-gate + `display: null` + reactive `hide` pattern as InspectBtn
            // (a bare hide loses to NavbarButton's inline display). Hidden in the
            // minimized `small` pill too. ADDITIVE: absent on every non-project route,
            // so the closed-canvas toolbar is unchanged. THE PAGE-SIDEBAR RULE (Nika
            // 2026-10-29, "Same rule for all"): it drives the project page's one
            // per-page choice (shared functions/pageSidebar.js), like the rail's own
            // hide button and the call bar's sidebar button (meet ControlBar.js) —
            // pressed while the rail shows, the glyph on the rail's side, gone where
            // nothing can remember the choice.
            SidebarsBtn: {
                display: null,
                subscribeTo: [
                    '_homeLook',
                    'userPrefs',
                    '_isPhoneViewport',
                    'currentPath',
                    '_canvasSlot',
                    '_canvasSlotSecond'
                ],
                hide: (el, s)=>{
                    const now = el.call('pageSidebarRead', s.root, el) || {};
                    if (s.size === 'small' || !now.toggleable) return true;
                    const p = s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
                    return !(0, $2C7Li.isProjectCanvasPath)(p, s.root);
                },
                icon: (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).side === 'right' ? 'lnSidebarRight' : 'lnSidebarLeft',
                title: (el, s)=>el.call('polyglot', (el.call('pageSidebarRead', s.root, el) || {}).hidden ? 'workspace.navbar.sidebars.show' : 'workspace.navbar.sidebars.hide'),
                'aria-label': (el)=>el.call('polyglot', 'workspace.navbar.sidebars.toggle'),
                'aria-pressed': (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).hidden ? 'false' : 'true',
                onClick: (e, el)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    el.call('pageSidebarToggle');
                }
            }
        },
        pointerEvents: 'auto',
        // Skip freestyleConnect — the home prompt routes through
        // sdk.ai.dispatch (homeAiSend) which honors the user's
        // provider mode (simone/providers/local). The SDK opens the
        // local bridge WebSocket itself when mode='local'; cloud
        // modes don't need a local connection. /studio still calls
        // freestyleConnect('canvas') for the legacy canvas-tool path.
        onInit: ()=>{},
        // CircleButton (the chevron send affordance) — override the
        // inherited onClick so it dispatches homeAiSend instead of
        // freestyleSend. Same draft-read / draft-clear contract as
        // CanvasPromptTextarea._sendPrompt; just routes through the
        // unified AI surface.
        CircleButton: {
            onClick: (e, el)=>{
                const st = el.state;
                // Dropped files / entity refs / images are part of the prompt. This
                // handler used to read `st.draft` alone and clear only the draft, so a
                // dropped chip rendered, was silently discarded on send, and then sat
                // in the gallery as if it had gone. buildPromptPayload is the shared
                // serialiser (shared/functions/promptAttachments.js) — the canvas
                // composer's own _sendPrompt builds the identical body.
                const { body: body, attachments: attachments, isEmpty: isEmpty } = el.call('buildPromptPayload', el, st);
                if (isEmpty) return;
                // ONE send, ONE generation (Nika 2026-10-28): the prompt goes to the
                // agent (homeAiSend) and nowhere else — the parallel blind page
                // generator a "create/build" prompt used to start is gone.
                //
                // Selection-aware prompting (2026-08-08 per Nika "ai should understand
                // selected artboards"): prepend a compact "Selected artboards: …" line
                // to the dispatched text so the general AI surface (homeAiSend →
                // simoneAiTransport → sdk.ai.dispatch) reads the canvas selection
                // (canvas functions/projectCanvasSidebar.js). getSelectionAiContext is
                // canvas's eager-slice fn — reachable here because this mount already
                // needs getCanvasV2/setCanvasMode from the same slice (InspectBtn
                // above). Byte-identical to `body` when nothing is selected —
                // promptPrefix is '' off-canvas or with an empty selection.
                const selection = el.call('getSelectionAiContext');
                const dispatchBody = (selection?.promptPrefix || '') + body;
                // `selection.attached` (spec §3.8) is the canvas lane's STRUCTURED
                // payload for this turn — the selected nodes + connections, or the
                // whole active board when nothing is selected. Optional: the field
                // does not exist off-canvas, and it is passed through UNTOUCHED (that
                // lane owns its own caps). Fourth slot — see homeAiSend's signature
                // note for why it sits after the boot-race counter.
                el.call('homeAiSend', dispatchBody, attachments, 0, selection?.attached || null);
                // The emptied composer returns to its resting height on its own — one
                // row in the pill, the E2 floor when expanded (2026-07-24 per Nika
                // "prompt textarea should get back relative initial height"): framework
                // set 10 (element 3.14.794) re-measures the autoGrow height on this
                // state write. The hand `style.height = ''` that stood here (a state
                // write used to fire no re-measure) is gone (2026-10-02, measured live:
                // a late clear dropped the pill to the brand Textarea's E1 class
                // height, 153 px). Never touch the min-height either: it is the
                // composer's own size floor, written inline by the framework
                // (canvas/components/CanvasPromptTextarea.js, 2026-09-29).
                if (st && st.update) st.update(el.call('clearedPromptState'));
            }
        },
        Textarea: {
            // The field names what a send makes — one short line per AI mode
            // (AI_ASSISTANT_SPEC §8: "placeholder per mode, never wrapping"); the
            // kit's assistantModePlaceholder picks the key from root.assistantMode.
            // NEVER CUT (design-d2's review of deploy 8): the long line when it fits
            // the field's measured text room, else the mode's short line
            // (assistantModePlaceholderFit) — re-chosen once the field has a box
            // and on every resize.
            placeholder: (el, s)=>el.call('assistantModePlaceholderFit', s.root),
            onWindowResize: (e, el, s)=>el.call('assistantModePlaceholderRefit', s.root),
            // Suppress the browser's default focus outline on the
            // textarea node — the CanvasPromptTextarea wrapper above
            // owns the focus signal now via :focus-within glow.
            outline: 'none',
            ':focus': {
                outline: 'none',
                boxShadow: 'none'
            },
            // NO rows / height node-write here, ever (`el.node` reads, never
            // manipulates — FA511). The component declares `rows: 1` (canvas
            // CanvasPromptTextarea.js) and the framework emits that attribute since
            // smbls 3.14.811 (FW-TEXTAREA-ROWS-ATTR-HIJACKED-BY-GRID-ALIAS-1), so
            // the old mount-site `onRender` — `if (el.node.rows !== 1) { rows = 1;
            // style.height = 'auto' }`, a workaround for the attribute bug — stopped
            // firing. That dead write was the ONLY thing overwriting autoGrow's
            // create-time `height: 0px`, and the composer booted with a 14px box
            // under a 26px line box for every member
            // (WS-COMPOSER-TEXTAREA-HEIGHT-ZERO-AFTER-BOOT-1). The component owns NO
            // `height` factory either (design-d2's review, 2026-09-29 — a second
            // writer never survived autoGrow's own re-measure): autoGrow itself now
            // writes no height before the node has layout, and measures on the
            // post-attach flush, since smbls 3.14.812
            // (FW-AUTOGROW-FIRST-MEASURE-WRITES-ZERO-ON-DETACHED-NODE-1).
            // onRender keeps the one call that is still live here: now and once the
            // composer row has settled (the field's room is final only after it
            // lays out — shared assistantModePlaceholderSettle).
            onRender: (el, s)=>el.call('assistantModePlaceholderSettle', s && s.root),
            // Enter submits via homeAiSend instead of freestyleSend.
            // Mirrors the CanvasPromptTextarea.Textarea.onKeydown shape
            // (read draft from state, dispatch, clear) so the inherited
            // onInput draft binding and the component's autoGrow stay untouched.
            //
            // ⚠ This override REPLACES the composer's own onKeydown — a mount-site
            // handler wins outright, DOMQL never chains the two. So every key branch
            // the composer declares is dead in the SHELL mount. Measured live
            // 2026-09-02 on /login (the composer renders on every route): pressing
            // ArrowDown in the textarea with the '+' attach menu open did nothing,
            // and Arrow/Enter/Escape with the '@' mention list open did nothing,
            // because the composer's own branches never ran.
            //
            // Re-declaring branches here is what let the two mounts drift, so this
            // override DELEGATES instead: `aiComposerKeydown`
            // (shared/functions/aiComposerKeys.js) owns every key that belongs to an
            // open panel — the '+' attach menu's arrows and the whole mention-picker
            // traversal — and reports whether it consumed the keystroke. The
            // composer's own onKeydown (canvas/components/CanvasPromptTextarea.js)
            // calls the SAME function behind the same guard, so a new panel key is
            // added once and both mounts get it.
            //
            // Only the send leg differs, and it stays below: the delegate consumes
            // Enter ONLY while a mention picker with options is open (that Enter
            // inserts the mention). With no picker open it returns false and Enter
            // reaches homeAiSend exactly as before — one send, never two.
            onKeydown: (e, el)=>{
                if ((0, $1X0Je.default).functions.aiComposerKeydown(e, el, el.state)) return;
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    const st = el.state;
                    // Same shared serialiser as the CircleButton path above — see the
                    // comment there for why draft-only was wrong.
                    const { body: body, attachments: attachments, isEmpty: isEmpty } = el.call('buildPromptPayload', el, st);
                    if (isEmpty) return;
                    // ONE send, ONE generation (see the CircleButton path above).
                    // Selection-aware prompting — same prefix as the CircleButton path
                    // above (see its comment for the full rationale).
                    const selection = el.call('getSelectionAiContext');
                    const dispatchBody = (selection?.promptPrefix || '') + body;
                    // Same structured-attachment forward as the CircleButton path above.
                    el.call('homeAiSend', dispatchBody, attachments, 0, selection?.attached || null);
                    // The emptied composer re-measures through the framework — no hand
                    // height clear (see the CircleButton path above).
                    if (st && st.update) st.update(el.call('clearedPromptState'));
                }
            }
        }
    },
    // Zoombar — mounted at the shell root (2026-06-08 per Nika "make
    // Zoombar in the root, present on all pages"). It's the shared/global
    // zoom control: its +/- buttons drive whichever canvas is active via
    // the canvas global-scope per-frame loop (canvas/globalScope.js), so a
    // single root mount serves every canvas surface (project canvas,
    // studios board, legacy). The per-canvas mounts (CanvasEditor /
    // CanvasLegacy / studios) are removed in favor of this one. Shows on
    // every page (inert % readout on non-canvas surfaces); hidden only on
    // auth routes. `position: fixed` (vs the per-page `absolute`) anchors
    // it to the viewport bottom-right regardless of the page's layout.
    Zoombar: {
        // Staged out of the boot task — canvas chrome, never the first pixel of a
        // shell boot, and its `hide:` below still owns visibility once built.
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME),
        subscribeTo: [
            'currentPath',
            '_isPhoneViewport',
            '_phoneNavPanel',
            '_canvasRailOpen',
            '_ticketsRailOpen',
            '_filesRailOpen',
            '_moduleRailOpen'
        ],
        // Show ONLY on the studios board (/studio) and live project canvases
        // (/<owner>/<project>) — hidden on home, tickets, chat, etc. (2026-06-08
        // per Nika "show ZoomInNavbar only on /studio and project canvas
        // screens"). Was previously shown on every non-auth page.
        hide: (el, s)=>{
            if (s.root?._isPhoneViewport && (s.root._phoneNavPanel || s.root._canvasRailOpen || s.root._ticketsRailOpen || s.root._filesRailOpen || s.root._moduleRailOpen)) return true;
            const p = s.root?.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
            if ((0, $kuISg.isChromelessShellPath)(p)) return true;
            return !($6b17f08f738443dc$var$_isStudioCanvasPath(p) || $6b17f08f738443dc$var$_isTicketsCanvasPath(p) || $6b17f08f738443dc$var$_isTeamCanvasPath(p) || // /infra is a pan/zoom canvas like the rest — it was the only one
            // missing the shared zoom control (2026-07-03 per Nika "same canvas
            // functionality" across /studio /infra /tickets /agents).
            $6b17f08f738443dc$var$_isInfraCanvasPath(p) || (0, $2C7Li.isProjectCanvasPath)(p, s.root) || $6b17f08f738443dc$var$_isModuleCanvasPath(p, s.root));
        },
        fontSize: 'Z1',
        position: 'fixed',
        bottom: 'X2',
        right: 'X2',
        top: 'auto',
        left: 'auto',
        width: 'auto',
        // INVISIBLE-OVERLAY-EATS-CLICKS-1 #2: CreditBlocker's full-viewport gate
        // (zIndex 10300) used to sit ABOVE this bar, so a credit-exhausted
        // workspace visually showed live, enabled zoom controls that no click
        // could ever reach — every click fed the gate's own backdrop-dismiss
        // handler instead. Pan/zoom cost nothing (CreditBlocker's own header:
        // "pure reads... AI, builds and metered actions are paused"), so the fix
        // is NOT a route exemption — that would also un-gate editing/saving/AI
        // on the same route, a billing hole. It's narrower: let this pure-read
        // control sit reachable ABOVE the gate while the gate itself, and
        // everything it actually exists to block, is untouched. 10310 sits
        // between CreditBlocker (10300) and ModalRoot (10500, workspace/
        // components/CreditBlocker.js's own documented ladder) — an auth/account
        // modal still correctly covers this bar; the credit gate no longer does.
        zIndex: '10310',
        pointerEvents: 'auto',
        borderWidth: '0',
        // --zoombar-clear (root CSS above): the bar's top from the viewport
        // bottom, zeroed while `hide` keeps it display:none.
        onRender: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_zbObs', '--zoombar-clear', $6b17f08f738443dc$var$_clearFromTop),
        onWindowResize: (e, el)=>el._zbObsApply?.(),
        onBeforeRemove: (el)=>$6b17f08f738443dc$var$_stopClearVar(el, '_zbObs'),
        '@mobileL': {
            left: '50%',
            right: 'auto',
            // Clear the composer AND the phone chip row above it — see --chip-row.
            // (Was a flat D1, which landed the bar inside the chips' band.)
            bottom: 'calc(var(--slot-bottom) + var(--chip-row))',
            transform: 'translateX(-50%)',
            // Preserves the pre-existing base<mobile relationship (was 60/80)
            // one step above the new base, same reasoning as above.
            zIndex: '10320'
        },
        NavbarButtonSet: {
            Settings: {
                onClick: (ev, el, s)=>{
                    ev.stopPropagation();
                    const root = s.root;
                    if (!root) return;
                    // Studios board → Workspace tab; tickets board → Tickets tab;
                    // project canvas → Project tab. Always recomputed fresh from the
                    // CURRENT board path — SETTINGS-WRONG-CONTENT-1: falling back to
                    // `root.settingsTab` here reused whichever tab a PRIOR board
                    // context last left behind (it's never reset on modal close), so
                    // opening Settings on the studios board after having opened it on
                    // a project canvas showed the stale Project tab instead of
                    // Workspace. `root.settingsTab` is still written below so
                    // SettingsModalBody's own in-modal tab switcher keeps working for
                    // this open instance.
                    const p = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '/');
                    const tab = $6b17f08f738443dc$var$_isTicketsCanvasPath(p) ? 'tickets' : $6b17f08f738443dc$var$_isStudioCanvasPath(p) || $6b17f08f738443dc$var$_isModuleCanvasPath(p, root) ? 'workspace' : 'project';
                    root.update({
                        settingsTab: tab
                    });
                    // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default
                    // maxHeight so the Close X can't be pushed off-screen.
                    el.call('openCustomModal', {
                        id: 'settings',
                        width: 'overlayXl',
                        content: {
                            extends: 'SettingsModalBody'
                        }
                    });
                }
            }
        }
    },
    TranslationWatcher: {
        visibility: 'hidden',
        position: 'fixed',
        pointerEvents: 'none',
        width: '0',
        height: '0',
        overflow: 'hidden',
        fetch: {
            from: 'i18n.translations',
            method: 'subscribe',
            params: (el, s)=>({
                    lang: s.root?.lang || 'en',
                    namespace: 'all'
                })
        }
    },
    WorkspaceActivationStatus: {},
    // One visual through startup, the in-app twin of the pre-bundle overlay
    // (index.html #boot-spiral): the same mountain range filling from its base
    // to its summit on the real stages, the same mark above it, the same
    // concept switch (<html data-loader>). Later blocking operations (a
    // workspace switch, sign-in) reuse it. The motion lives in the injected
    // sheet (see THE LOADER there), keyed on the data-stage this stamps.
    MainLoader: {
        display: (el, s)=>{
            const active = $6b17f08f738443dc$var$_syncBootLoader(el, s);
            // The native overlay announces itself (index.html sets the flag while it
            // is on screen and clears it the moment its ready fade starts), so this
            // visual stays hidden underneath it without querying the document.
            const nativeVisible = typeof window !== 'undefined' && !window.__smblsBootReady && window.__smblsBootOverlay === true;
            return (active || el._readyHold) && !nativeVisible ? 'flex' : 'none';
        },
        // The ready fill's end lets the held loader leave (other layers' ends do not).
        onAnimationend: (e, el, s)=>{
            if (e && e.animationName === 'wsLoaderFrontReady' && el._readyHold) $6b17f08f738443dc$var$_endReadyHold(el, s && (s.root || s) || el._bootReadyOwner?.root);
        },
        onRemove: (el)=>{
            $6b17f08f738443dc$var$_cancelBootReady(el);
            $6b17f08f738443dc$var$_clearLoaderMax(el);
            if (typeof window !== 'undefined' && window.__smblsBootOwner === el._bootReadyOwner?.token) window.__smblsBootOwner = null;
            el._bootReadyOwner = null;
            el._loaderSeenActive = false;
        },
        opacity: (el, s)=>$6b17f08f738443dc$var$_isLoaderActive(s) || $6b17f08f738443dc$var$_loaderHolding(el, s) ? '1' : '0',
        pointerEvents: (el, s)=>$6b17f08f738443dc$var$_isLoaderActive(s) ? 'auto' : 'none',
        visibility: (el, s)=>$6b17f08f738443dc$var$_isLoaderActive(s) || $6b17f08f738443dc$var$_loaderHolding(el, s) ? 'visible' : 'hidden',
        animation: 'none',
        transform: 'none',
        overflow: 'auto',
        transition: 'opacity A ease',
        '@reducedMotion': {
            transition: 'none'
        },
        attr: {
            'data-stage': (el, s)=>$6b17f08f738443dc$var$_loaderFillStage(s.root || s)
        },
        // where the current stage's fill starts (see _trackLoaderMotion); set by
        // `display` above in the same render
        '--ws-loader-from': (el)=>$6b17f08f738443dc$var$_loaderFrom(el),
        // Pure black in dark mode, pure white in light mode (Nika 2026-09-29):
        // the `loaderGround` token pair. Inline on purpose: the brand
        // MainLoader's `theme: 'document'` class would win over a static
        // declaration (the shell root's note on the same kind of ground).
        background: ()=>'loaderGround',
        // THE RANGE — the progress. The ambient mountains mask through the files
        // plane, the loader's ink token, the bottom band of the screen. Display
        // none by itself: the injected sheet shows it under the ambient skin and
        // never on a tenant host. The clip is the stage-1 milestone (nothing);
        // the sheet moves it.
        LoaderRange: {
            display: 'none',
            position: 'absolute',
            inset: 'auto 0 0 0',
            height: 'loaderRange',
            pointerEvents: 'none',
            overflow: 'hidden',
            aria: {
                hidden: 'true'
            },
            // The front: one feather taller than the band, its top fading in over
            // the feather; the sheet slides it up by transform (the base hides it).
            RangeFront: {
                position: 'absolute',
                left: '0',
                right: '0',
                top: 'loaderFrontTop',
                height: 'loaderFrontHeight',
                maskImage: 'linear-gradient(to bottom, transparent 0, black 44px)',
                transform: 'translateY(100%)',
                // The art counter-moves inside the front, so it stays put while the
                // feathered edge rises through it.
                RangeArt: {
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    top: 'loaderFront',
                    bottom: '0',
                    background: 'loaderInk',
                    maskImage: (el)=>el.call('ambientMaskImage', el.call('ambientSkyUrl', 'mountains')),
                    maskSize: 'auto 100%',
                    maskRepeat: 'repeat-x',
                    maskPosition: 'center bottom',
                    transform: 'translateY(calc((55vh + 44px) * -1))'
                }
            }
        },
        // The brand spiral gives way to the range.
        LoaderRatio: {
            hide: true,
            display: 'none'
        },
        LogoLoader: {
            width: 'loaderMark',
            height: 'loaderMark',
            fontSize: 'loaderLogoFont',
            top: 'loaderCenter',
            animation: 'none',
            aria: {
                hidden: 'true'
            }
        },
        // "rise": a second LogoLoader — the solid mark over the first one's faint
        // silhouette, filled from the bottom at the range's rate. Display none
        // unless <html data-loader="rise"> (the sheet).
        LogoLoader_1: {
            display: 'none',
            position: 'absolute',
            top: 'loaderCenter',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 0)',
            zIndex: 3,
            width: 'loaderMark',
            height: 'loaderMark',
            fontSize: 'loaderLogoFont',
            clipPath: 'inset(100% 0 0 0)',
            aria: {
                hidden: 'true'
            }
        },
        Text: {
            role: 'status',
            aria: {
                live: 'polite',
                atomic: 'true'
            },
            position: 'absolute',
            top: 'loaderStatusTop',
            left: '0',
            width: '100%',
            padding: '0 B',
            textAlign: 'center',
            color: 'title',
            opacity: '0.8',
            fontSize: 'loaderStatusFont',
            lineHeight: 20 / 13,
            // One translated line from the shared bundle while any phase is active.
            // None while an in-page sign-in owes the session language: the word
            // would speak the sign-in page's language, not the workspace's.
            text: (el, s)=>$6b17f08f738443dc$var$_loaderStatus(s.root || s) && (s.root || s)._langOwed !== true ? el.call('polyglot', 'common.state.loading') : ''
        }
    },
    // Full-viewport "Switching to <org>…" overlay. Mounted at shell scope
    // (not inside a sub-app) so it covers the entire UI during the JWT
    // refresh round-trip. Driven by `root._wsSwitching`.
    AppOrgSwitchOverlay: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // Toast container for `el.call('openNotification', …)`. Mounted at
    // SHELL scope (not inside the workspace-project sub-app) so toasts
    // also render on auth pages — /login, /signup, /reset-password —
    // which are reached during the auth-bounce path before any sub-app
    // is mounted into Slot. Reads from `s.notifications`. The auth-bounce
    // codepath in workspace/index.js seeds `state.notifications = []`
    // when missing, but the shell context's `state` (composed in
    // workspace/context.js) already inherits `notifications: []` from
    // wpState so this is just a defensive backstop.
    //
    // A ROW OF THE COMPOSER'S STACK: the stack docks ON the stack line (the
    // composer's top and its docked rows + the gap — never --slot-bottom, which
    // it lifts: a toast on it would chase its own clearance). Its box holds the
    // room it takes: the call panel under the toasts (--call-clear, so a toast
    // never covers Accept / Decline) and one --nav-gap over them. The box's
    // HEIGHT is --toast-clear while it holds a toast (0 while it holds none:
    // the empty box keeps its padding), so every sheet and view ends one gap
    // above the toasts (--slot-bottom, the root CSS above). The box paints
    // nothing and takes no pointer (the shared component's container).
    GlobalNotification: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE),
        bottom: 'var(--stack-line)',
        paddingTop: 'var(--nav-gap)',
        paddingBottom: 'var(--call-clear, 0%)',
        onRender: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_tcObs', '--toast-clear', (r)=>{
                const list = el.state && el.state.notifications;
                return Array.isArray(list) && list.length ? r.height : 0;
            }),
        // The resize half of the measurement above (FA503 — framework-owned).
        onWindowResize: (e, el)=>el._tcObsApply?.(),
        onBeforeRemove: (el)=>$6b17f08f738443dc$var$_stopClearVar(el, '_tcObs')
    },
    // THE ticket detail modal — the ONLY mounted instance (2026-08-06
    // consolidation; was page-mounted 14× across home/chat/meet/inbox + the
    // tickets pages, so any route WITHOUT a mount — calendar, documents,
    // files, studio, admin/* — silently no-op'd a ticket open, e.g. a
    // GlobalNotification toast click for a ticket while on /calendar).
    //
    // TicketsDetailModal extends Modal with stateKey 'selectedTicket':
    // openTicketDetailModal (functions/ticketDetailModal.js) ONLY seeds the
    // carrier and this instance flips visible reactively — an instant display
    // flip on every route. Modal stateKey semantics make ANY second mounted
    // instance a double-open (both react to the same carrier), so pages must
    // NOT re-mount it.
    //
    // Why a bare key mount, not @symbo.ls/windows and not a lazy context fold:
    //   • windows' Slot.set(content) re-prepares the ~4,000-line def
    //     synchronously on EVERY open — a measured 15-40s main-thread freeze
    //     (framework ticket: tickets/smbls.md). Banned path.
    //   • the def already ships in the tickets EAGER slice
    //     (sharedLibraries.js) — laziness here saves zero bundle, and a bare
    //     key cannot defer to a context fold anyway (extends resolves at
    //     parent parse time — see MessengerOverlaySlot below).
    //   • prepare cost = ONE page-mount-equivalent hit, and REMOVED from every
    //     subsequent page navigation (home re-paid it on every home load since
    //     2026-06-08). Since WS-SHELL-MOUNT-TREE-BUILD-2700MS-1 that one hit is
    //     no longer paid at app create either — the `if:` latch below defers it
    //     to the first open, so a boot that never opens a ticket never pays it.
    //
    // The ?ticket=<id> URL restore (loaded-row poll + 5s SDK-fetch fallback)
    // lives in the component's own onCreate, so deep links restore on EVERY
    // route — /w/<org>?ticket=<id> included. /ticket/:id (tickets/pages/
    // view.js) reuses this same instance via root._ticketFullPage.
    TicketsDetailModal: {
        // Built on FIRST NEED, not at boot — see the deferred-shell-subtrees
        // note at the top of this file. Need = the `selectedTicket` carrier is
        // seeded (openTicketDetailModal, every toast/menu/page opener), OR the
        // /ticket/:id full-page route flipped `_ticketFullPage`, OR the URL
        // already carries a `?ticket=<id>` deep link at this evaluation.
        if: (0, $8WfZd.needTicketDetailModal),
        // `_routeNudge` is bumped by the shell's own route watcher; reading it
        // re-runs the predicate on every client-side navigation, so an in-app
        // deep link to `?ticket=<id>` mounts the modal exactly like a cold boot.
        ifDeps: [
            (el, s)=>s?.root?._routeNudge
        ]
    },
    // THE create-agent modal — the ONLY mounted instance (2026-09-26). It was
    // page-mounted twice on one carrier (`_createAgentOpen`): the home page
    // (pages/main.js) and the agents canvas (canvas/pages/team-and-agents.js).
    // /agents also opens as a PageSlot WINDOW over home (_APP_WINDOW_PAGES), so
    // both pages were mounted at once and one "+ → Agent" opened TWO dialogs
    // (the close-audit counted two non-nested "Create agent" dialogs). Same law
    // as TicketsDetailModal above: Modal stateKey semantics make any second
    // mounted instance a double-open, so pages must NOT re-mount it. Every
    // opener (the home header +, the Your-agents create tile, the agents "+"
    // menu) only sets the carrier.
    CreateAgentModal: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // The ? keyboard sheet (HOME_AMBIENT_SKIN_SPEC §5) — ONE shell-root instance,
    // AppDialog v2 centre (components/ShortcutsOverlay.js). Opened by `?` through
    // the shortcut registry (functions/shortcuts*.js) or the palette's row; the
    // dialog owns its Esc, veil and Close.
    ShortcutsOverlay: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // Install / configure modal for canvas integration/library/mcp/plugin
    // (Removed 2026-06-01: MarketplaceInstallModal moved to @symbo.ls/windows.
    // The shellApp.onCreate now polls `root.installModal` at 100ms and
    // pushes / pops the ModalRoot layer when it flips. All existing
    // setters via `el.call('openInstallableModal', opts)` keep writing
    // `host.update({ installModal: … })` unchanged.)
    // (Removed 2026-06-10: NewProjectPickerOverlay moved to @symbo.ls/windows.
    // Openers — home's EmptyProjectCard / ProjectStarter, StudioNavbar's
    // "+ New project" menu, the studios empty-board tutorial — seed the
    // `root.newProjectPicker` carrier and push a custom-template layer whose
    // content extends `NewProjectPickerBody` (canvas/pages/studios.js, bridged
    // via workspace/components/index.js) with openModal id 'newProjectPicker';
    // the layer onClose clears the carrier. ModalRoot below owns visibility.)
    // (Removed 2026-06-01: AppCreateOrgModal moved to @symbo.ls/windows.
    // Callers dispatch via `el.call('openCreateOrgModal')` — the helper
    // resets the `_createOrg*` draft fields (kept as data carriers) and
    // pushes a custom-template layer whose content extends
    // `AppCreateOrgModal` (now body-only). Close: `closeCreateOrgModal`.)
    // Unified modal/dialog system — @symbo.ls/windows. Shell-scope mount
    // because the wp sub-app wrapper never instantiates under the 3.14
    // auto-router, so any modal/dialog needs to live at this shell level
    // to render across every route. ModalRoot owns a 5-layer stack and
    // registers an ESC handler scoped to its lifecycle (not module-side-
    // effect). Templates + helpers arrive via sharedLibraries → shared/
    // components + shared/functions re-exports.
    //
    // Callers use `el.call('openModal' | 'confirmDialog' | 'alertDialog' |
    // 'promptDialog', opts)` instead of writing per-modal state fields.
    // Migrated 2026-06-01 from the legacy `root.confirmAction` /
    // ConfirmModal pattern — every former trigger site now routes through
    // confirmDialog (see git history for the old shape).
    //
    // zIndex override (local — the windows lib is read-only): the shared
    // `Modal` base ships at zIndex 2000, the SAME as ModalRoot's host. Equal
    // z-index → DOM paint order decides, so a page modal mounted after the
    // shell (e.g. TicketDetailModal) painted OVER the dialog host and a
    // confirmDialog opened from inside it rendered invisibly behind the modal
    // (#113). Bespoke page modals climb as high as 10001 (TicketMentionModal),
    // so lift the global dialog host above that whole interactive band — it's
    // a blocking interrupt and must always be top-most. Stays below the
    // transient drag overlays (99998/99999, pointer-events:none, never
    // co-occur with a dialog). The ModalLayer slots add their own +N*10 on top.
    ModalRoot: {
        // Be explicit here instead of relying on bare-key auto-extension. The
        // deferred `if:` mount is prepared after boot and recent smbls builds can
        // otherwise materialise only this local override, producing an empty host
        // with none of the windows ModalLayer children or lifecycle hooks.
        extends: 'ShellModalRoot',
        zIndex: '10500',
        // The deferred shell override can mount before the windows library's
        // base props are merged, leaving an empty host as a normal hit-testing
        // block. Keep the host transparent to input; visible ModalLayer children
        // opt back into pointer events when a dialog is actually open.
        pointerEvents: 'none',
        // Built right AFTER first paint, not inside the boot task — see the
        // deferred-shell-subtrees note at the top of this file. `openModal` is a
        // CALL, not a state carrier, and smbls flushes effects on a microtask, so
        // a first-open latch could not materialise the host synchronously for the
        // `resolveModalRoot` that the same call makes. bootShell flips
        // `_modalHostReady` on its bounded `yieldToPaint` immediately after the
        // shell mounts — before any input and before any SDK continuation that
        // could push a layer — which takes the 246 elements out of the boot task
        // without changing a single opener.
        if: (el, s)=>$6b17f08f738443dc$var$_latchOnce(el, '__wsDeferredMounted', !!s?.root?._modalHostReady)
    },
    // Voice input — full-screen Apple-style listening overlay behind the mic
    // buttons on CanvasPromptTextarea + the assistant composer (shared
    // VoiceOverlay; session engine in shared/functions/voiceSession.js —
    // architecture/VOICE_COMMANDS.md). One band above ModalRoot: an active
    // voice session is always top-most. Inline fixed-position defense per the
    // shell-root grid-overlay rule.
    VoiceOverlay: {
        position: 'fixed',
        inset: '0',
        zIndex: '10600',
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS)
    },
    // Fixed bottom-left presence dock (moved from the AppHeader right cluster,
    // 2026-07-25 per Nika) — active members online on every route; overflow
    // dropdown opens upward. Self-gating (signed-in / active-member / auth
    // routes) inside the component.
    OnlineMembersDock: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME)
    },
    // ── Immersive module rail (workspace-abstraction: a module REPLACES shell
    // chrome for its members) ────────────────────────────────────────────────
    // When the active module's chrome manifest declares a `rail` component and
    // the caller is in immersive mode (chrome.immersive matches — admins never
    // are), the shell mounts that module component as a PERSISTENT left rail
    // on EVERY route including '/' — the module's nav IS the app chrome for
    // these members; the immersive PageSlot opens BESIDE it (its left edge
    // insets by --module-rail-clear, live-measured below). The component
    // resolves from the module's injected components by bare-key extends and
    // carries the module's OWN design-system context (same getter-closure
    // contract as the home board's widget bodies — root._moduleDsCtxGet).
    ModuleRailHost: {
        // Always-on once the module declares chrome.rail — admins included
        // (immersive only governs the top/bottom chrome, not the rail). A comm
        // host (comm.symbols.app, docs/COMM_HOST.md) never shows it: the module's
        // pages open on the workspace host.
        hide: (el, s)=>el.call('isCommHost') || !(0, $7ytvD.moduleRailActive)(s.root),
        subscribeTo: [
            'workspaceProject',
            'themeMode',
            // themeResolved: the LIVE dark/light resolution (watchThemeResolved).
            // themeMode stays the string 'auto' across an OS scheme flip, so
            // without this key the rail (and _setStageVar riding its renders)
            // never repaints the stage on an OS flip (BF-THEME-SURFACES-1).
            'themeResolved',
            '_slotFullscreen',
            '_canvasSlotSecond',
            '_slotSplitIntent',
            // Item 11 route gate: moduleRailActive now reads root.currentPath
            // (rail only on the workspace surface — never over /studio, /infra
            // or other own-sidebar routes). Declared lists are the binding
            // contract — without this key the hide: factory never re-runs on a
            // route change.
            'currentPath',
            // The phone drawer (_moduleRailDrawer): the viewport answer, the
            // dock's open flag, and the workspace the dock waits for.
            '_isPhoneViewport',
            '_moduleRailOpen',
            'workspace'
        ],
        position: 'fixed',
        left: '0',
        // The phone drawer at rest: out of sight, out of the hit test and of the
        // tab order. Body slides its last 6.5% in (below) — never this host, whose
        // transform would become the containing block of the fixed RailScrim.
        // Every other state inherits, exactly as before the drawer existed.
        dataRailDrawer: (el, s)=>$6b17f08f738443dc$var$_moduleRailDrawer(s.root),
        visibility: (el, s)=>$6b17f08f738443dc$var$_moduleRailDrawerShut(s.root) ? 'hidden' : 'inherit',
        pointerEvents: (el, s)=>$6b17f08f738443dc$var$_moduleRailDrawerShut(s.root) ? 'none' : 'inherit',
        // Little top/bottom offsets in the edge (immersive/expanded) state —
        // matches PageSlot's .isSlotFullscreen Z band (Nika 2026-08-16: "do
        // not put on the edge"). The chrome-inset class below still wins when
        // the shell chrome is live.
        top: 'Z',
        bottom: 'Z',
        // Per-module reversal of the 2026-08-16 offsets (Nika 2026-09-02 via
        // the bellforge lane: "put navbar to the edge"): a module whose
        // manifest sets `chrome.railEdge` ships a flat full-height band, so
        // its EDGE state runs flush — 0/0 vertical, no left gutter (the right
        // Z stays as the content gutter). The class attaches ONLY when the
        // rail is genuinely flush — railEdge AND the edge state (the same
        // predicate isRailChromeInset negates below): with the shell chrome
        // live, top/bottom keep the --slot band AND the left gutter keeps Z,
        // otherwise a rounded rail card sat flush-left with an inset top and
        // bottom and showed paper in its left corners (bellforge lane's
        // measurement, 2026-09-02). _railFlush is also what the mounted rail
        // receives as its `railFlush` prop (Body.__mountModuleRail below).
        isRailEdge: (el, s)=>$6b17f08f738443dc$var$_railFlush(s.root),
        '.isRailEdge': {
            top: '0',
            bottom: '0',
            padding: '0 Z 0 0'
        },
        // Vertical geometry contract (2026-08-14 per Nika "sidebar and pageslot
        // should have same height and top and bottom positions"): whenever the
        // shell's top/bottom chrome is LIVE (admin, non-fullscreen), the rail
        // shares the PageSlot card's exact vertical band — top --slot-top
        // (navbar bottom + --nav-gap), bottom --slot-bottom (composer top +
        // --nav-gap) — so it can never run under the navbar or composer.
        // The predicate mirrors PageSlot's isSlotFullscreen decision verbatim:
        // immersive members and an admin's edge-to-edge toggle drop to the
        // base full-height geometry, exactly when the slot itself goes 0/0.
        isRailChromeInset: (el, s)=>{
            // Full-height ONLY for edge-to-edge (immersive) fullscreen. An admin's
            // EXPANDED slot (B1 default) keeps --slot-top/--slot-bottom, so the
            // rail keeps sharing that exact band — the 2026-08-14 "same height and
            // top and bottom" contract holds in the expanded state too.
            return !$6b17f08f738443dc$var$_railEdgeState(s.root);
        },
        '.isRailChromeInset': {
            top: '--slot-top',
            bottom: '--slot-bottom'
        },
        // Below the PageSlot band (1300) — the slot never overlaps (it insets
        // left by this rail's live width), and slot popovers may still float
        // over the rail edge.
        zIndex: '1290',
        display: 'flex',
        // Horizontal padding ONLY (was 'Z' on all four sides). The vertical
        // padding inset the rail card INSIDE the --slot-top/--slot-bottom band
        // while the PageSlot card sits FLUSH at those edges — so the two never
        // aligned (2026-08-16 per Nika: "the sidebar alignment does not align
        // with pageslot — remove those paddings or add them to pageslot").
        // Zero vertical padding puts the rail's top and bottom on the exact
        // same lines as the slot card in every chrome state.
        padding: '0 Z',
        overflow: 'hidden',
        // NO background at all (2026-08-15 per Nika "remove bg behind sidebar
        // should be transparent"): the host paints nothing, so the padding gap
        // around the floating rail shows whatever page is genuinely behind it —
        // the immersive paper desk for members, the dark shell board for
        // admins — with no strip in either theme. Deliberately the ABSENT prop
        // rather than a 'transparent'/null value: an unknown colour word can be
        // token-table-mangled and a null factory can leave the previous painted
        // fill behind on re-render; an element that never declares a background
        // is transparent by construction. (Supersedes the earlier
        // gray16/document two-stage fill from "remove black bg behind
        // sidebar" — the rail card itself carries its own surface.)
        // Live-measured left clearance — same RO recipe as --nav-clear; zeroes
        // when hidden so admin fullscreen slots stay edge-to-edge. The phone
        // drawer floats over the page, so it never insets it: 0 there as well.
        onRender: (el, s)=>{
            $6b17f08f738443dc$var$_setStageVar(el, s);
            $6b17f08f738443dc$var$_trackClearVar(el, '_mrObs', '--module-rail-clear', (r)=>$6b17f08f738443dc$var$_moduleRailDrawer(s.root) ? 0 : r.right);
            $6b17f08f738443dc$var$_pushRailFlush(el, s);
        },
        // The resize half of the measurement above (FA503 — framework-owned).
        onWindowResize: (e, el)=>el._mrObsApply?.(),
        // Belt for the re-arm: node re-creation can land in an UPDATE pass
        // (subscribeTo workspaceProject) — same-node calls return early.
        onUpdate: (el, s)=>{
            $6b17f08f738443dc$var$_setStageVar(el, s);
            $6b17f08f738443dc$var$_trackClearVar(el, '_mrObs', '--module-rail-clear', (r)=>$6b17f08f738443dc$var$_moduleRailDrawer(s.root) ? 0 : r.right);
            $6b17f08f738443dc$var$_pushRailFlush(el, s);
        },
        onBeforeRemove: (el)=>$6b17f08f738443dc$var$_stopClearVar(el, '_mrObs'),
        // Escape closes the open phone drawer — only when it is the top layer
        // (shared/functions/shellOverlayOpen.js answers 'mobileRail' for it).
        onDocumentKeydown: (e, el, s)=>{
            if (e.key !== 'Escape' || e.defaultPrevented) return;
            if (!$6b17f08f738443dc$var$_moduleRailDrawer(s.root) || !s.root._moduleRailOpen) return;
            if (el.call('shellOverlayOpen') !== 'mobileRail') return;
            e.preventDefault();
            s.root.update({
                _moduleRailOpen: false
            }, {
                preventFetch: true
            });
        },
        // The drawer's veil: the whole viewport under the rail card (fixed, and
        // behind the card inside the host's own layer), tap closes. Same token
        // and fade as the MobileRailSheet scrim.
        RailScrim: {
            // Per-element subscriptions: the host's list re-runs the host's own
            // factories, not this child's.
            subscribeTo: [
                '_isPhoneViewport',
                '_moduleRailOpen',
                'workspace',
                'workspaceProject'
            ],
            hide: (el, s)=>!$6b17f08f738443dc$var$_moduleRailDrawer(s.root),
            position: 'fixed',
            inset: '0',
            zIndex: '-1',
            background: 'scrimSoft',
            opacity: (el, s)=>s.root._moduleRailOpen ? '1' : '0',
            transition: 'opacity B defaultBezier',
            onClick: (e, el, s)=>s.root.update({
                    _moduleRailOpen: false
                }, {
                    preventFetch: true
                })
        },
        Body: {
            display: 'flex',
            minHeight: '0',
            // The phone drawer's motion: the brand budget (6.5% travel, the
            // MobileRailSheet card's own), in on D along the spring, out on C.
            transform: (el, s)=>$6b17f08f738443dc$var$_moduleRailDrawerShut(s.root) ? 'translateX(-6.5%)' : 'none',
            dataRailDrawerOpen: (el, s)=>$6b17f08f738443dc$var$_moduleRailDrawer(s.root) && !!s.root._moduleRailOpen,
            transition: 'transform C defaultBezier',
            '&[data-rail-drawer-open]': {
                transition: 'transform D springBezier'
            },
            // The stash arrives AFTER first render on a cold boot, so a one-shot
            // onRender mount left the rail permanently empty (measured live
            // 2026-08-14: host in DOM, railActive true, zero children). Mount on
            // BOTH render and update — subscribeTo re-fires onUpdate when
            // workspaceProject publishes; the __railSig guard keeps it idempotent.
            // The drawer keys re-run the motion factories above.
            subscribeTo: [
                'workspaceProject',
                '_isPhoneViewport',
                '_moduleRailOpen',
                'workspace'
            ],
            onRender: (el, s)=>{
                const mount = el.__mountModuleRail;
                if (mount) mount(el, s);
            },
            onUpdate: (el, s)=>{
                const mount = el.__mountModuleRail;
                if (mount) mount(el, s);
            },
            onInit: (el)=>{
                el.__mountModuleRail = (elm, s)=>{
                    const wp = s.root?.workspaceProject;
                    const rail = wp && wp.chrome && wp.chrome.rail;
                    if (!rail || elm.__railSig === rail) return;
                    elm.__railSig = rail;
                    // `railFlush`: the host's resolved flush state, handed to the rail
                    // as a prop (see _railFlush). The def is set once per rail
                    // signature, so later flips ride ModuleRailHost's onRender/
                    // onUpdate (_pushRailFlush) instead of a re-mount.
                    const def = {
                        extends: rail,
                        height: '100%',
                        railFlush: $6b17f08f738443dc$var$_railFlush(s.root)
                    };
                    // Keep the host's last-pushed value in step with what the mount
                    // carries, so a flip back to this value is never skipped as
                    // "unchanged" by _pushRailFlush.
                    if (elm.parent) elm.parent.__railFlush = def.railFlush;
                    // WS-MODULE-STATE-SCOPE-1: the module context also carries the
                    // module's STATE scope now (a plugin on `modCtx`), so the rail
                    // renders inside the module's own state root with no def change —
                    // see functions/moduleStateScope.js.
                    const modCtx = s.root?._moduleDsCtxGet?.(wp.id);
                    if (modCtx) def.context = modCtx;
                    try {
                        elm.set(def);
                    } catch (err) {
                        elm.__railSig = null;
                        console.warn('[shell] module rail mount failed:', rail, err?.message);
                    }
                };
            }
        }
    },
    // Unified dropdown system — @symbo.ls/dropdown. Single panel mounted
    // at shell root reads `root._dropdown` and renders whichever caller
    // last opened. Same shell-mount rationale as ModalRoot: position:fixed
    // panels need viewport-space coords, which a transformed ancestor
    // would otherwise clip (see the old AiModePicker overflow bug for the
    // exact failure mode). Callers route via
    //   el.call('openDropdown', { anchorEl: el, content: {...} })
    // or the declarative `extends: 'DropdownTrigger'` wrapper.
    //
    // zIndex override (local — the plugin default is 1500, "above app
    // chrome"): bespoke page surfaces in this shell climb far past that
    // (drawers, gridstack drag shadows, page modals up to 10001), so a
    // dropdown opened from the header — the notification center being the
    // daily case — painted UNDER them. A dropdown is always the most recent
    // user intent; it beats every persistent surface. 10000 keeps it below
    // the blocking-interrupt dialog host (ModalRoot 10500) and the transient
    // drag overlays (99998+), which must stay supreme. 10010, not a flat
    // 10000: the AssistantDrawer host sits AT 10000, and an equal z-index
    // hands the win to DOM paint order (#113's exact failure shape) — a
    // dropdown is the most recent click, so it outranks the persistent
    // drawer by a hair.
    //
    // The org switcher's Panel pins to the viewport's right edge — see
    // functions/orgSwitcherPanelPin.js (every other dropdown is unchanged).
    DropdownRoot: {
        zIndex: '10010',
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE),
        PanelHost: {
            Panel: (0, $fDn7k.orgSwitcherPanelPin)
        }
    },
    // Local-AI connect modal — shell-root overlay opened from either AI-settings
    // surface (canvas ParamsBtn dropdown / sidebar SettingsDrawer) when the user
    // picks the Local agent. Mounted here (not inline in the dropdown) because the
    // dropdown Panel's transform+overflow would clip a fixed child and inline
    // growth shifts the dropdown; gated on root._aiBridgeSetupOpen.
    //
    // NO STAGE LATCH HERE, deliberately (AI-BRIDGE-MODAL-BLOCKS-SIGNED-OUT-1).
    // A mount-site `if:` DISCARDS the component's own `if:`, it does not AND
    // with it: smbls create() runs applyExtends first (the component's gate
    // lands on `element.if`), then `if (definition.if !== undefined) element.if
    // = definition.if` overwrites it. With `if: _atStage(OVERLAYS)` here — a
    // ONE-WAY latch — the modal's own gate (`_aiBridgeSetupOpen && local`) was
    // gone, so this fixed inset:0 z-index:10600 scrim mounted on EVERY load,
    // signed out included, swallowed every click underneath (a mouse-only
    // visitor could not reach Sign in) and its Done button was a silent no-op.
    // The latch buys nothing here anyway: create() returns early on a false
    // `if:`, so the component's own boot-false gate ALREADY costs zero elements,
    // and registerIfEffect builds the subtree when the flag flips. A staged
    // subtree that must gate itself uses `hide:` instead — different key, no
    // clobber (AiActionConfirmCard, same OVERLAYS stage).
    AiBridgeModal: {},
    // Unified tooltip system — @symbo.ls/tooltip. Same shell-mount
    // rationale as DropdownRoot. Replaces the workspace's prior pattern of
    // a per-app `NavbarTooltip` element + imperative
    // `setNavbarTooltipPosition` updater. Hover triggers route through
    // `el.call('openTooltip', { anchorEl, text })` or extend
    // `TooltipTrigger`. Mounted with no callers initially — existing
    // NavbarTooltip / setNavbarTooltipPosition keep working until the
    // call-site migration sweep lands.
    //
    // zIndex (local, the DropdownRoot reasoning above): the plugin's 2500 sits
    // under every layer of this shell that carries tooltip triggers — the
    // AssistantDrawer (10000, its header AssistantIconButtons), dropdown panels
    // (10010, the QuickAdd NavbarButtons), dialogs (10500) — so those tooltips
    // painted BEHIND the surface that owns their trigger. A tooltip is the most
    // transient surface there is and never takes a pointer: 10700 clears the
    // voice overlay (10600) and stays under the drag overlays (99998+) and the
    // toast host.
    //
    // Panel — the brand's floating chrome: components/ShellTooltipRoot.js.
    TooltipRoot: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE),
        zIndex: '10700',
        extends: 'ShellTooltipRoot'
    },
    // THE MAIN AREA OVER A PAGE (AI_ASSISTANT_SPEC §12.2, main thread =
    // "Everywhere"): the main thread, a generated board or a live deck over the
    // page sheet of every route but the home (the home keeps them in its grid
    // area). Below the PageSlot (1300) and the composer (1400); the page stays
    // mounted underneath. Built on the FIRST main view, not at boot (the
    // deferred-subtree latch above) — a one-way latch, like the drawer's. A
    // call's Fly state (`meetFly`, meet functions/meetFly.js) counts too: the
    // call's theater is a main view, and a page asked in the call chat, by voice
    // or by another participant opens it in a tab that never opened a thread, a
    // board, a deck or a Fly canvas.
    AssistantMainLayer: {
        // Inline fixed-position defense at the mount site (the shell-root
        // grid-overlay rule — CanvasSplitView, ModalRoot and the drawer do the same).
        position: 'fixed',
        if: (el, s)=>$6b17f08f738443dc$var$_latchOnce(el, '__wsDeferredMounted', !!(s?.root?._homeThreadOpen || s?.root?._aiBoard || s?.root?._aiDeck || s?.root?._aiFly || s?.root?.meetFly))
    },
    // One local picker for both Fly hosts. Its lightweight lifecycle opens an
    // empty Fly workspace on mode entry, before any model request exists — and,
    // Fly being the home's default view, on the first arrival on the home
    // (the route) where the person can ask (the flags).
    AssistantFlyWorkspace_picker: {
        presentation: 'picker',
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE),
        // homeModeSync first (BLD-13): the home tab's mode on the home, the
        // person's own pick anywhere else — then the canvas follows that mode.
        subscribeTo: [
            'workspace',
            'assistantMode',
            '_aiFly',
            'currentPath',
            '_featureFlags',
            '_homeMode'
        ],
        onMounted: (el, s)=>{
            el.call('homeModeSync');
            el.call('assistantFlyWorkspaceMounted', el, s);
        },
        onUpdate: (el, s)=>{
            el.call('homeModeSync');
            el.call('assistantFlyWorkspaceMounted', el, s);
        }
    },
    AssistantFlyWorkspace_return: {
        presentation: 'return',
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // Blur layer for an open PageSlot. A SIBLING of the slot, not a child: the
    // slot's own z-index makes it a stacking context, so a descendant backdrop
    // could only ever blur the chrome too. See PageSlotBackdrop for the z map.
    PageSlotBackdrop: {},
    // The shell modal layer — all geometry/behavior lives in the component
    // (canvas/components/PageSlot.js); opened via root._canvasSlot(/Second).
    PageSlot: {},
    // A home widget's "+" form as a modal sheet over the board — never the
    // app's whole page (components/HomeWidgetFormHost.js, pick 10 C).
    HomeWidgetFormHost: {},
    // AI action confirmation card — shown when sdk.ai.dispatch returns
    // intent:'action' in authMode='ask'. Reads root._aiActionProposals;
    // Confirm fires sdk.ai.executeActions. Mounted once at the shell
    // root so every consumer (home prompt, AppAssistant, ticket AI
    // editor) surfaces a consistent confirmation UI.
    AiActionConfirmCard: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS)
    },
    // (Removed 2026-06-03: AiModePicker legacy shell-mount migrated to
    // the centralized @symbo.ls/dropdown DropdownRoot above. ParamsBtn
    // now dispatches `el.call('openDropdown', { content: { extends:
    // 'AiModePickerBody' } })` and the plugin's single Panel renders
    // the body. State carriers _aiModePickerTick (for active-checkmark
    // re-render) + _aiSvcReady (for SDK-ready gate) stay in state-app
    // because AiPickerRow.onClick still bumps the tick. The legacy
    // shell mount is unmounted; AiModePickerBody is the new entry
    // point (shared/components/AiModePicker.js).)
    // (Removed 2026-06-01: PersonDetailModal moved to @symbo.ls/windows.
    // Callers dispatch via `el.call('openPersonDetailModal', person)` —
    // the helper writes the person to `root._personDetail` (kept as data
    // carrier; the body's `_person(s.root)`, `_teamsFor`, etc. still read
    // from it) and pushes a custom-template layer. Close:
    // `closePersonDetailModal` — also clears `_personDetailShowAdd` +
    // `_personDetailAddTeamId` (the inline Add-to-Team panel state).)
    // Simone assistant drawer — shell-scope mount rationale matches
    // ConfirmModal / AppCreateOrgModal above. AppAssistantToggle lives in
    // AppHeader (mounted at shell scope) and flips `root.assistantOpen`;
    // the AppAssistant drawer reads that flag to slide in. wp/app.js still
    // declares an AppAssistant slot, but the wp sub-app wrapper never
    // instantiates under the 3.14 auto-router, so without this shell-scope
    // mount the toggle was a no-op visually (state flipped, nothing on
    // screen). `aiStream` resolution still flows through the merged
    // context.functions (wp registers it), so the drawer's Send path
    // works once mounted.
    // Workspace AI drawer = simone's Chat component (imported via
    // shared/components/assistantSimone.js from extensions/packages/simone).
    // Single source of truth for the chat UI across the chrome extension
    // and the workspace shell. Its composer reads `chatInput`, its message
    // list reads `chatMessages`, its composer dispatches `sendPrompt(text)`
    // which calls `window.__simoneSendOverBridge` — workspace installs
    // that handle to route through sdk.ai (see installSimoneAiTransport).
    //
    // We anchor it via a wrapping container that pins it to the right
    // edge as a drawer and gates visibility on `assistantOpen` so existing
    // openers (the magic-star toggle button, homeAiSend's auto-open) work
    // unchanged. Simone's Chat itself takes 100%/100% of the wrapper.
    AssistantDrawer: {
        // Built on FIRST OPEN, not at boot — see the deferred-shell-subtrees
        // note at the top of this file. Every opener in the monorepo (the
        // magic-star toggle, homeAiSend, ReasoningPill, Suggestions, the ticket
        // and event detail modals, YourAgentCard, aiAssistant's askUser path)
        // writes `assistantOpen: true` on the root state, so ONE latch on that
        // carrier covers all of them with zero opener changes. The latch is
        // one-way: after the first open the `hide:` predicate below owns
        // visibility again, exactly as before.
        if: (el, s)=>$6b17f08f738443dc$var$_latchOnce(el, '__wsDeferredMounted', !!s?.root?.assistantOpen),
        // Visible only when the assistant is open AND not minimized. 'minimized'
        // collapses it into the SimoneReasoningPill above the composer (the pill's
        // own hide rule is dock-aware). Closed → hidden entirely. Feature flag:
        // aiAssistant off at /flags kills the drawer wholesale.
        hide: (el, s)=>!$6b17f08f738443dc$var$shellFeatureEnabled(s.root, 'aiAssistant') || !s.root?.assistantOpen || s.root?.assistantDock === 'minimized',
        // THE DOCKED SIDEBAR (Nika 2026-09-26: "make assistant looking as it was
        // back as sidebar with no rounds" — this reverses the floating panel of
        // DESIGN_SPEC §9 / Q7 A): flush to the screen edge from the top of the
        // viewport to the bottom, exactly over the column the shell reserves for
        // it, square corners. It appears with the content column's own reflow
        // (the grid track eases over .22s) and no motion of its own, as it did.
        // The one change kept from the redesign is not about the shape: the
        // divider and the depth are the `overlay` elevation token (a 1px ring,
        // which is the edge line against the content, plus two soft layers), not
        // a hairline border and a raw `-16px 0 32px rgba(0,0,0,.35)` shadow.
        position: 'fixed',
        top: '0',
        height: '100dvh',
        shadow: 'overlay',
        // Dock EDGE and WIDTH are driven by the injected shell CSS keyed on <html
        // data-assistant-dock> — NOT by props here — because v3.14 freezes
        // reactive layout-prop factories (width/left/right) at mount, and the
        // drawer width must reference the shared --assistant-width var so it stays
        // in lockstep with the content's reserved grid column (a raw var() on
        // `width` also empty-rules in the atomic compiler). The user drags the
        // ResizeHandle to override the width; the dragged value persists across
        // re-renders via root.assistantWidth and is republished to
        // --assistant-width by _syncShellRoute. Default 640px lives in the CSS
        // (:root var fallback).
        zIndex: '10000',
        // GLASS (AI_ASSISTANT_SPEC v1 §8 blur policy, Nika's pick 7 A): the house
        // floating-glass recipe — the brand `canvas-card-glass` theme (a
        // translucent fill + backdrop blur, the same one the menus and popovers
        // wear) instead of the opaque `document` sheet; the docked edge keeps
        // the `overlay` ring above, so no second border.
        theme: 'canvas-card-glass',
        borderWidth: '0',
        color: 'title',
        flow: 'y',
        // Cursor + select lock during drag — same trick the legacy
        // AppAssistant used: reactive prop on the drawer root flips to
        // col-resize / none while dragging, so the cursor stays correct
        // even when the pointer escapes the handle's bounding box.
        cursor: (el, s)=>s.root?.assistantResizing ? 'col-resize' : '',
        userSelect: (el, s)=>s.root?.assistantResizing ? 'none' : '',
        // Drag handle — narrow column on the LEFT edge, col-resize cursor,
        // pointer-captured during drag so the mousemove + mouseup land here
        // even when the pointer leaves the handle's bounding box. Min/max
        // clamps match the drawer's minWidth/maxWidth so the resize stays
        // visually consistent with the layout constraints.
        ResizeHandle: {
            tag: 'div',
            position: 'absolute',
            left: '0',
            top: '0',
            bottom: '0',
            width: '6px',
            cursor: 'col-resize',
            background: 'transparent',
            zIndex: '1',
            ':hover': {
                background: 'selected'
            },
            // A real control (AI_ASSISTANT_SPEC v1 §8 "adjustable width"): a focusable
            // vertical separator with its value, moved by the Arrow keys (Shift for
            // a longer step), Home / End to the bounds (functions/assistantWidth.js
            // assistantWidthForKey). The width is REMEMBERED per person when a drag
            // or a key ends (setAssistantWidth).
            role: 'separator',
            tabindex: '0',
            ariaOrientation: 'vertical',
            ariaLabel: (el)=>el.call('polyglot', 'workspace.assistant.resize'),
            ariaValuemin: '320',
            ariaValuenow: (el, s)=>String(Number(s.root?.assistantWidth) > 0 ? s.root.assistantWidth : 640),
            ':focus-visible': {
                background: 'selected',
                outline: 'none'
            },
            onKeydown: (e, el, s)=>{
                const root = s.root;
                if (!root) return;
                const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
                const current = Number(root.assistantWidth) > 0 ? root.assistantWidth : 640;
                const next = el.call('assistantWidthForKey', current, e.key, {
                    dock: root.assistantDock,
                    shift: !!e.shiftKey,
                    vw: vw
                });
                if (next == null) return;
                e.preventDefault();
                if (next !== current) el.call('setAssistantWidth', next);
            },
            onPointerdown: (e, el, s)=>{
                e.preventDefault();
                const parentRect = el.parent?.node?.getBoundingClientRect?.();
                el._dragStartX = e.clientX;
                el._dragStartW = parentRect ? parentRect.width : 640;
                s.root?.update?.({
                    assistantResizing: true
                });
                if (el.node?.setPointerCapture && e.pointerId != null) try {
                    el.node.setPointerCapture(e.pointerId);
                } catch (_) {}
            },
            onPointermove: (e, el, s)=>{
                if (!s.root?.assistantResizing) return;
                if (el._dragStartX == null) return;
                // Handle sits on the drawer's INNER edge. Right dock → handle on the
                // left edge, dragging LEFT widens (dx = start - clientX). Left dock →
                // handle on the right edge, dragging RIGHT widens (dx = clientX -
                // start). Flip the sign by the current dock so both feel natural.
                const leftDock = s.root?.assistantDock === 'left';
                const dx = leftDock ? e.clientX - el._dragStartX : el._dragStartX - e.clientX;
                const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
                const next = Math.max(320, Math.min(Math.floor(vw * 0.5), el._dragStartW + dx));
                if (next === s.root.assistantWidth) return;
                s.root.update({
                    assistantWidth: next
                });
            },
            onPointerup: (e, el, s)=>{
                if (!s.root?.assistantResizing) return;
                el._dragStartX = null;
                el._dragStartW = null;
                s.root.update({
                    assistantResizing: false
                });
                // The drag ends: remember the width for this person.
                if (Number(s.root.assistantWidth) > 0) el.call('setAssistantWidth', s.root.assistantWidth);
                if (el.node?.releasePointerCapture && e.pointerId != null) try {
                    el.node.releasePointerCapture(e.pointerId);
                } catch (_) {}
            },
            onPointercancel: (e, el, s)=>{
                if (!s.root?.assistantResizing) return;
                el._dragStartX = null;
                el._dragStartW = null;
                s.root.update({
                    assistantResizing: false
                });
            }
        },
        // Workspace AI drawer = simone's canonical Chat, reused wholesale. The
        // modern 3-section header (Sessions ▾ · TargetSwitcher · Provider ▾ +
        // Avatar) and the composer toolbar now live in simone's Chat.js as the
        // single source of truth — NO inline header override here (the old copy
        // duplicated ext-ui's home.js and overlapped in the narrow drawer).
        // `inspectorTools` stays false in workspace state, so the composer's
        // Pick/Inspect buttons (chrome-extension only) stay hidden.
        // Slot override (sanctioned consumer pattern — same as ext-ui's
        // Title.Icon.onClick): append a close X at the far right of the header's
        // Actions cluster. Drawer-specific affordance, workspace app ONLY —
        // standalone simone and the extension panels are full-surface and have
        // no drawer to close, so this never lands in the shared Chat component.
        Chat: {
            Header: {
                // Drawer width can be narrow on any viewport. Keep every control
                // reachable by wrapping the header and its action group locally.
                flexWrap: 'wrap',
                Title: {
                    Icon: null,
                    flex: '1 1 auto',
                    minWidth: '0',
                    maxWidth: '100%',
                    Sessions: {
                        minWidth: '0',
                        Trigger: {
                            minWidth: '0',
                            maxWidth: '100%',
                            Label: {
                                minWidth: '0',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }
                        }
                    }
                },
                // THE HEAD KEEPS FOUR CONTROLS IN VIEW (the AI overhaul, sidebar
                // finding 2, 2026-10-28 — it carried eight): Chat history (the
                // Sessions trigger above), the mode chip, Minimize and Close. The
                // other four — Switch AI model, Open in main, Dock left/right, AI
                // settings — are the rows of ONE overflow menu
                // (AssistantIconButton_more below); each row runs the handler its old
                // button ran and keeps its label and glyph.
                Actions: {
                    flexWrap: 'wrap',
                    maxWidth: '100%',
                    minWidth: '0',
                    // The shared Chat head's AI-settings button leaves the drawer head:
                    // its menu row opens the same settings sheet.
                    SettingsBtn: null,
                    // THE MODEL MENU'S ONE HOST stays: the composite's picker, opened by
                    // `root._modelMenuOpen` — the flag the menu row writes, and the chat
                    // error row's "Switch model" too. Its trigger leaves the head, and
                    // the composite draws no box of its own: an empty flex item would
                    // add one more gap to the row, and its picker would hang from a
                    // 0 × 0 box. The picker anchors to the HEAD instead (the shared
                    // Chat header is the positioned parent; this row is not), its right
                    // edge inset by the head's own inline padding (Z), so it hangs
                    // under the row's right end on a wide drawer. On the 390 px sheet
                    // the four-control row is ~170 px wide and the head is the sheet's
                    // width: anchored to the row, the picker was squeezed to the row's
                    // width (169 px, two lines a row); anchored to the head it takes
                    // its full width inside the screen (222 px, measured live).
                    AiModelSwitcher: {
                        display: 'contents',
                        AiModelSwitcherTrigger: null,
                        Picker: {
                            right: 'Z'
                        }
                    },
                    // THE MODE CHIP (design-d2's AssistantModeChip, pick 5 B): Assistant ·
                    // Dashboard · Apps — reads root.assistantMode, writes through
                    // setAssistantMode, hides itself while the writer is absent. The
                    // drawer IS a thread surface (the concierge for Nika 2026-10-28:
                    // "when a thread is on screen, the chip names the view"): an ask
                    // typed here stays in this chat, so the chip names Chat over a
                    // stored Dashboard; Apps keeps its name (its thread is Build).
                    AssistantModeChip: {
                        flexShrink: '0',
                        threadSurface: true
                    },
                    // THE OVERFLOW — the assistant chrome's icon button by its key: icon
                    // only (the house ••• `moreHorizontal`), a menu button
                    // (aria-haspopup="menu", aria-expanded while its menu is open), its
                    // name and tooltip from the bundle. Enter and Space click the real
                    // <button>; ArrowDown / ArrowUp open the menu too (the menu-button
                    // contract); a second click closes it. The dropdown layer owns
                    // Escape, the outside press and the focus return to this button.
                    AssistantIconButton_more: {
                        icon: 'moreHorizontal',
                        title: (el)=>el.call('polyglot', 'common.action.moreActions'),
                        ariaLabel: (el)=>el.call('polyglot', 'common.action.moreActions'),
                        ariaHaspopup: 'menu',
                        ariaExpanded: 'false',
                        flexShrink: '0',
                        // the open menu: the `selected` wash while aria-expanded (the
                        // mode chip's trigger state)
                        '&[aria-expanded="true"]': {
                            background: 'selected',
                            color: 'title'
                        },
                        scope: {
                            // The four rows, built when the menu opens, so each label is
                            // read in the live language:
                            //   • Switch AI model — opens the model menu's one host (the
                            //     composite's picker above) and refreshes the providers'
                            //     diagnostics, as its trigger did;
                            //   • Open in main (AI_ASSISTANT_SPEC v1 §1, §12.2) — the SAME
                            //     thread moves to the main area of the page the person is on
                            //     (functions/assistantMainThread.js). ALWAYS offered — every
                            //     route, an empty chat too (Nika 2026-09-30: "why I dont see
                            //     move to main when ai is in sidebar"). Its glyph is the
                            //     workspace set's `lnGrid` (shared designSystem/icons.js), a
                            //     shell-registered icon, so no device renders it blank;
                            //   • Dock left / right — ONE side toggle (2026-08-12 per Nika
                            //     "remove two sidebar (left/right) icons in assistant and
                            //     keep only that does the action"): the row names the side
                            //     the drawer will MOVE TO — docked right → "Dock left";
                            //     docked left → "Dock right". setAssistantDock persists it;
                            //   • AI settings — the shared AiSettingsButton's toggle in a
                            //     Chat surface: Chat's own settings sheet.
                            // A row carries DATA only — its `act`, a flat string. A
                            // lowercase prop holding a function is wrapped into a getter
                            // that RUNS it on every read (Rule 70), and the handler reads
                            // the act off the ROW, never a variable captured from this map
                            // (frank FA205).
                            headerMoreRows (el, s) {
                                const left = !!(s && s.root && s.root.assistantDock === 'left');
                                const rows = [
                                    [
                                        'model',
                                        'ai.settings.switchModel',
                                        'magicstar'
                                    ],
                                    [
                                        'main',
                                        'workspace.assistant.openInMain',
                                        'lnGrid'
                                    ],
                                    left ? [
                                        'right',
                                        'workspace.assistant.dock.right',
                                        'sidebarRightFill'
                                    ] : [
                                        'left',
                                        'workspace.assistant.dock.left',
                                        'sidebarLeftFill'
                                    ],
                                    [
                                        'settings',
                                        'ai.settings.panelLabel',
                                        'preferences'
                                    ]
                                ];
                                return rows.map((r)=>({
                                        key: r[0],
                                        act: r[0],
                                        text: el.call('polyglot', r[1]),
                                        Icon: {
                                            name: r[2]
                                        },
                                        onClick: (ev, row)=>{
                                            row.call('closeDropdown', 'assistantHeaderMore');
                                            const root = row.state && row.state.root;
                                            const act = row.act;
                                            if (act === 'main') return row.call('assistantThreadToMain');
                                            if (act === 'left' || act === 'right') return row.call('setAssistantDock', act);
                                            if (!root || typeof root.update !== 'function') return;
                                            if (act === 'settings') return root.update({
                                                showSettings: !root.showSettings
                                            });
                                            if (act !== 'model') return;
                                            root.update({
                                                _modelMenuOpen: true
                                            });
                                            try {
                                                row.call('fetchAiProviderDiagnostics');
                                            } catch (_) {}
                                        }
                                    }));
                            },
                            // aria-expanded follows the dropdown layer: its onOpen once the
                            // layer is up, its onClose on every close — a row, Escape, an
                            // outside press, or another dropdown replacing this one. Written
                            // through the element's own update as `attr` (the mode chip's
                            // path: the flat key is applied once, at create).
                            headerMoreExpanded (el, open) {
                                if (!el || !el.node) return;
                                el.update({
                                    attr: {
                                        'aria-expanded': open ? 'true' : 'false'
                                    }
                                });
                            },
                            // THE HOUSE MENU (MenuPanel rows, its keyboard model and focus
                            // arming) in the shell's dropdown layer, painted like the mode
                            // chip's menu beside it: the glass and the elevation on the
                            // layer, a body that paints nothing (the opaque `dialog`
                            // surface under reduced transparency).
                            headerMoreOpen (el, s) {
                                el.call('openDropdown', {
                                    anchorEl: el,
                                    id: 'assistantHeaderMore',
                                    placement: 'bottom-end',
                                    round: 'radiusCard',
                                    theme: 'search-glass',
                                    shadow: 'overlay',
                                    onOpen: ()=>el.scope.headerMoreExpanded(el, true),
                                    onClose: ()=>el.scope.headerMoreExpanded(el, false),
                                    content: {
                                        extends: 'MenuPanel',
                                        theme: null,
                                        background: 'transparent',
                                        backdropFilter: 'none',
                                        shadow: 'none',
                                        ':focus-visible': {
                                            boxShadow: 'none'
                                        },
                                        '@reduceTransparency': {
                                            theme: 'dialog'
                                        },
                                        ariaLabel: el.call('polyglot', 'common.action.moreActions'),
                                        childExtends: 'MenuPanelItem',
                                        children: this.headerMoreRows(el, s)
                                    }
                                });
                            }
                        },
                        onKeydown: (e, el, s)=>{
                            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
                            e.preventDefault();
                            e.stopPropagation();
                            el.scope.headerMoreOpen(el, s);
                        },
                        onClick: (e, el, s)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            // a second click closes it (the dropdown plugin's own trigger
                            // toggles the same way); the open layer's id is on the root
                            // (the shared openDropdown's `_dropdownLayer` mirror)
                            if (s && s.root && s.root._dropdownLayer === 'assistantHeaderMore') return el.call('closeDropdown', 'assistantHeaderMore');
                            el.scope.headerMoreOpen(el, s);
                        }
                    },
                    MinimizeBtn: {
                        extends: 'AssistantIconButton',
                        icon: 'minimize',
                        title: (el)=>el.call('polyglot', 'workspace.assistant.minimize'),
                        flexShrink: '0',
                        onClick: (e, el, s)=>(0, $dp7M8.setAssistantDock)(s.root, 'minimized', el.sdk)
                    },
                    CloseBtn: {
                        extends: 'AssistantIconButton',
                        icon: 'crossmark',
                        title: (el)=>el.call('polyglot', 'workspace.assistant.close'),
                        flexShrink: '0',
                        onClick: (e, el, s)=>s.root?.update?.({
                                assistantOpen: false
                            })
                    }
                }
            }
        }
    },
    // Messenger — the AppHeader Messenger button flips `root._chatDrawerOpen`
    // (and bootstraps chat state). MessengerOverlay (from @symbo-ls/workspace-chat)
    // reads that flag and renders the floating chat list on the left — the same
    // glass float the /studio AppSidebar uses — plus a right-side conversation
    // window (like CanvasPageSlot) once a channel/DM is opened. Replaces the old
    // right-edge ChatDrawer slide-in / rail dock.
    // Chat bundle-fold (2026-08-01): the MessengerOverlay definition lives in
    // the lazily-folded chat context. A bare-key child here CANNOT defer to the
    // fold — DOMQL captures the extends resolution at PARENT parse time, so a
    // pre-fold mount instantiates an empty unknown-key div even if the fold
    // registers the component before an `if:` latch flips (verified live).
    // Instead this is an inert slot that ensureChatContext fills ONCE, post-
    // fold, via `slot.set({ extends: 'MessengerOverlay', … })` — the same
    // deferred-resolution mechanism lazyPage uses for route bodies. The set
    // definition restates the drawer + feature-flag hide (a mount-level hide
    // REPLACES the base component's own — verified live 2026-07-25).
    MessengerOverlaySlot: {
        display: 'contents',
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME)
    },
    // Mail — the AppHeader envelope flips `root._mailDrawerOpen` (through
    // headerOverlayPatch, so the Messenger / notifications / assistant close).
    // MailOverlay (from @symbo-ls/workspace-mail) reads that flag and renders
    // the docked mail list in the same left glass float the Messenger uses.
    // Same deferred-resolution shape as MessengerOverlaySlot above: the
    // definition lives in the lazily-folded mail context, so this is an inert
    // slot that ensureMailContext (functions/mailFold.js) fills ONCE, post-fold,
    // via `slot.set({ extends: 'MailOverlay', … })`.
    MailOverlaySlot: {
        display: 'contents',
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME)
    },
    // The App Store's remove dialog for the shell's own Remove (/add-app
    // "Installed apps"). Same deferred-resolution shape as MailOverlaySlot: the
    // dialog (MarketplaceUninstallDependentsDialog) lives in the lazily-folded
    // marketplace context, so this inert slot is filled ONCE, post-fold, by
    // ensureMarketplaceUninstallDialog (functions/marketplaceUninstallDialog.js).
    // The slot is the dialog's HOST: `_marketplaceHost` binds the store's
    // marketplaceHostOf here, and its own state keeps the store's flow
    // (uninstallDepsModal, the installed-apps cache) off the shell root.
    MarketplaceUninstallSlot: {
        display: 'contents',
        _marketplaceHost: true,
        state: {
            uninstallDepsModal: null,
            _activeWsApp: null
        },
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // Global right-click context menu (the /files menu, promoted to shared).
    // Driven by root.contextDropdown — files + chat both write it.
    ContextDropdown: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // (Removed 2026-06-16: CapTableGrantModal + grant functions moved to /financials/
    // backup directory — no longer part of the active app.)
    // (Removed 2026-06-01: AppLightbox moved to @symbo.ls/windows. Callers
    // dispatch via `el.call('openLightbox', { url, mime, name })` — the
    // helper writes the descriptor to `root.lightbox` and pushes a
    // custom-template layer whose content extends `AppLightbox` (now a
    // body-only component). No shell-root slot needed.)
    // Onboarding overlay shown to signed-in users without a team-org. Intranet
    // is an org-level surface; solo users belong on canvas/marketplace.
    NoOrgOverlay: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // WHITE-LABEL HOSTS ONLY — the signed-in non-member gate (branded
    // "Request an invitation" screen; Nika 2026-08-30, option A). The key
    // resolves from the whitelabel barrel context.js spreads behind
    // isCustomDomainHost(), and the SAME classifier gates the mount here so
    // a platform host never even mounts the element — my.symbols.app stays
    // bit-identical. Its own hide:/display: pair does the membership gating.
    WhitelabelRequestAccess: {
        if: (el, s)=>(0, $lb2Ei.isCustomDomainHost)() && $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)(el, s)
    },
    // Invitee onboarding nudge — opens the light "pick your username" prompt
    // once after an invite acceptance (never org creation for invitees; see
    // NoOrgOverlay's invite suppression + functions/usernamePrompt.js).
    UsernamePromptGate: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    // THE NEW-ACCOUNT WELCOME (functions/onboarding.js). The gate holds the
    // setup surface over a new account's first load while its record is read,
    // then opens the wizard on it once, after the gates above have had their
    // turn; the surface is built on FIRST NEED (the hold or the flow) and stays
    // built; the tour's layer exists only while the tour runs — it makes the
    // page inert while it does.
    OnboardingGate: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    OnboardingWizard: {
        if: (el, s)=>$6b17f08f738443dc$var$_latchOnce(el, '__onboardingBuilt', !!(s?.root?._onboardingFlow || s?.root?._onboardingHold))
    },
    OnboardingTour: {
        if: (el, s)=>!!s?.root?._onboardingTour
    },
    // Credit guard (tickets/fable.md, 2026-08-13): the out-of-credits
    // full-viewport blocker + the admin low-credits corner pill, both fed by
    // `_creditGuard` (functions/creditGuard.js — sdk.getCreditBalance on boot
    // + workspace switch). `display:'contents'` wrappers + fixed descendants,
    // same shell-grid-box hazard DemoClaimBanner below documents. Inert until
    // the balance loads; a metering error never blocks.
    CreditBlocker: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).INTERACTIVE)
    },
    CreditBanner: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME)
    },
    // Demo-session conversion bar — a slim bottom-left chrome bar shown ONLY to
    // unclaimed demo accounts (gated on root.isDemo, seeded by bootShell). Its
    // "Claim this workspace" button opens a self-contained claim Modal that
    // calls sdk.claimDemoAccount; on success it clears root.isDemo (the bar
    // retracts) + fires a success toast. Invisible to every real user.
    // position:fixed (own its viewport anchor), so it sits outside the AppShell
    // grid and never disturbs the AppHeader/content rows.
    DemoClaimBanner: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME)
    },
    // "Viewing as <role>" exit pill (tickets/fable.md PERSONA-6). Sibling of
    // routed content, never inside AppHeader/nav chrome, so a restricted
    // persona role can't take the exit down with it if its own chrome fails
    // to render. `display:'contents'` wrapper — same shell-grid-box hazard
    // DemoClaimBanner above documents. Inert today: `hide:`-gated on
    // `_personaSession`, which nothing writes yet (opus.md PERSONA-1/2,
    // sonnet.md PERSONA-4/5 — both still open) — landing this changes nothing
    // for any current session until that state exists.
    PersonaPill: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).CHROME),
        // The pill's own mount asks the persona oracle (GET /persona) at once —
        // also on a signed-out page, where the server answers 401 (persona audit
        // OV-2). This mount-site `onRender` replaces the shared pill's (a function
        // is never merged): the same ask, only with a session and its workspace
        // (functions/sessionStreams.js). The signed-in boot asks anyway, once its
        // workspace lands (loadPrivateData), so nothing is lost.
        onRender: (el, s)=>{
            if (el.call('personaOracleReady', s.root)) el.call('refreshPersonaSession', {
                mount: true
            });
        }
    },
    // Picture-in-picture mini widget for an active meet call. Fixed-position,
    // hidden unless a LiveKit Room is connected and the user is off the call
    // view. Persists across route navigation because the Room lives as a
    // module variable in functions/meet/connectCall.js.
    // --calldock-clear (root CSS): its top edge from the viewport bottom. The
    // dock moves with --zoombar-clear without a size change, so every update
    // re-measures (the tracker settles a position-only move).
    MeetCallWidget: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS),
        onRender: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_cdObs', '--calldock-clear', $6b17f08f738443dc$var$_clearFromTop),
        onUpdate: (el)=>$6b17f08f738443dc$var$_trackClearVar(el, '_cdObs', '--calldock-clear', $6b17f08f738443dc$var$_clearFromTop),
        onWindowResize: (e, el)=>el._cdObsApply?.(),
        onBeforeRemove: (el)=>$6b17f08f738443dc$var$_stopClearVar(el, '_cdObs')
    },
    // The call's sound, beside the dock: one <audio> per remote member at the
    // shell root, so a live call keeps playing on every route (the tiles'
    // <audio> unmounted with /meet — meet components/CallAudio.js).
    MeetCallAudio: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS)
    },
    // A spoken Fly ask in a call waits for its yes (Nika 2026-10-26): the card
    // with what the call heard, Show and Cancel — the asker's own, on every
    // route (meet components/MeetFlyConfirm.js, functions/meetFly.js).
    MeetFlyConfirm: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS)
    },
    // Call-invitation banner (tickets/fable.md, Nika 2026-08-13): a
    // beautiful, time-triggered, app-wide banner when a scheduled meeting
    // reaches its due window — fed by `notifs` (the durable, server-swept
    // `meeting_starting` notification, see
    // server/.../meetingStartingScheduler.js) via functions/notifications/
    // meetingInviteBanner.js's `activeMeetingInvite`. `display:'contents'`
    // wrapper + fixed descendant, same shell-grid-box hazard DemoClaimBanner
    // above documents. Fixed top-right — the one corner not already claimed
    // by CreditBanner/DemoClaimBanner/PersonaPill (bottom-left),
    // GlobalNotification (bottom-center) or MeetCallWidget (bottom-right).
    CallInvitationBanner: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS)
    },
    // The person called rings (Fly's People, "call <name>", the person card's
    // Call — functions/callPerson.js): the invite's own card with the caller,
    // Join call and Decline (components/IncomingCallBanner.js).
    IncomingCallBanner: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS)
    },
    // THE shell call panel (comms-phone v2 — calls inside the workspace, Nika
    // 2026-10-01). One instance, here, so a call survives every route change;
    // hidden while `root._callPanel` is null. Docked bottom-right on the
    // composer-top line — clear of the toast stack (bottom-centre) and the
    // CallInvitationBanner. The voice session behind it starts from
    // _syncShellRoute (ensureWorkspaceVoice) and stops on a workspace switch
    // (loadPrivateData.js) and in onRemove below.
    WorkspaceCallPanel: {
        if: $6b17f08f738443dc$var$_atStage((0, $hO9x8.SHELL_STAGE).OVERLAYS)
    },
    // AGENT MODE (WS-AGENT-MODE-1): the workspace TUI as the whole shell — a
    // fixed, opaque frame over the header, the rail and the page
    // (components/AgentModeFrame.js). Mounted only while it is on, for a
    // signed-in person: a shell that never enters it builds no element of it
    // and never loads the shared model package (functions/agentModeRuntime.js).
    AgentModeFrame: {
        // Every key read up front: a short-circuit would leave one untracked.
        if: (el, s)=>{
            const signedIn = s.root.signedIn === true;
            const chosen = s.root.agentMode === true;
            const link = s.root._agentModeLink === true;
            return signedIn && (chosen || link);
        }
    }
};
var $6b17f08f738443dc$export$2e2bcd8739ae039 = $6b17f08f738443dc$var$shellApp;

});
parcelRegister("qJ3f5", function(module, exports) {

$parcel$export(module.exports, "whitelabelHostScopeForRoot", () => $0505601246d7c320$export$8bb20d34e8b438e9);
$parcel$export(module.exports, "resolveActiveOrgId", () => $0505601246d7c320$export$3b2f5c28f93f6ed8);
$parcel$export(module.exports, "hasTrustedOrgList", () => $0505601246d7c320$export$a767f9f5069cb25f);
$parcel$export(module.exports, "clearLoginBounceCount", () => $0505601246d7c320$export$2528bb41c06a4057);
$parcel$export(module.exports, "armLoginBounceClearOnGesture", () => $0505601246d7c320$export$9712d8571917f630);
$parcel$export(module.exports, "redirectIfUnauthed", () => $0505601246d7c320$export$2b286f8a5e41ae5);
$parcel$export(module.exports, "workspaceClaimChanged", () => $0505601246d7c320$export$aeacd7eff53dd464);
$parcel$export(module.exports, "preferLiveWorkspaceOnDrift", () => $0505601246d7c320$export$5a700c6c87736f3a);
$parcel$export(module.exports, "subscribeAuthSession", () => $0505601246d7c320$export$6aaad40b0d5ceb3e);
$parcel$export(module.exports, "signInWithPassword", () => $0505601246d7c320$export$1509ad863a77c4a4);
$parcel$export(module.exports, "hasSessionToken", () => (parcelRequire("kuISg")).hasSessionToken);
$parcel$export(module.exports, "AUTH_PATHS", () => (parcelRequire("kuISg")).AUTH_PATHS);
$parcel$export(module.exports, "authRedirectTarget", () => (parcelRequire("kuISg")).authRedirectTarget);
$parcel$export(module.exports, "isChromelessShellPath", () => (parcelRequire("kuISg")).isChromelessShellPath);
// Bare shared-library import, not a deep subpath — a per-file deep specifier
// into @symbo-ls/workspace-shared (a restricted/private-registry package)
// cannot resolve through the platform's public importmap once this package
// is pushed as a library (tickets/execution-board.md §1 P0). Deferred-call
// wrapper, not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");

var $7ytvD = parcelRequire("7ytvD");

var $g7CNh = parcelRequire("g7CNh");

var $1jHTS = parcelRequire("1jHTS");

var $gNttC = parcelRequire("gNttC");

var $lb2Ei = parcelRequire("lb2Ei");

var $iJIxS = parcelRequire("iJIxS");

var $jZ5ZE = parcelRequire("jZ5ZE");
var $6QCFv = parcelRequire("6QCFv");

var $7muxD = parcelRequire("7muxD");

var $kuISg = parcelRequire("kuISg");
const $0505601246d7c320$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $0505601246d7c320$var$shellGetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.getActiveWorkspacePointer(...args);
const $0505601246d7c320$var$shellSetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspacePointer(...args);
const $0505601246d7c320$var$shellIsMwtEnabled = (...args)=>(0, $1X0Je.default).functions.isMwtEnabled(...args);
const $0505601246d7c320$var$shellConsumeOAuthNext = (...args)=>(0, $1X0Je.default).functions.consumeOAuthNext(...args);
const $0505601246d7c320$var$shellSetActiveWorkspaceRecord = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspaceRecord(...args);
const $0505601246d7c320$var$shellStampWorkspaceShape = (...args)=>(0, $1X0Je.default).functions.stampWorkspaceShape(...args);
const $0505601246d7c320$var$shellNotifyWorkspaceIdentityCorrected = (...args)=>(0, $1X0Je.default).functions.notifyWorkspaceIdentityCorrected(...args);
// Deferred wrapper, never a module-scope destructure and NEVER a deep subpath
// import — `@symbo-ls/workspace-shared` is a restricted-registry package whose
// per-file specifiers cannot resolve through the platform's public importmap;
// a deep import of this exact shape once killed the whole shell catalog page
// (see the header of app.js). Bare package + `.functions.X`, like every other
// borrowed helper in this file.
//
// `shell`-prefixed like the rest of this block, never shared's own name: frank
// hoists a module helper into the library's ONE flat globalScope under its
// name, and shared hoists its real `scopeWorkspaceListToWhitelabelHost` there
// too — two definitions of one name in the catalog, resolved by merge order
// (globalScopeNameCensus).
const $0505601246d7c320$var$shellScopeClaimsToWhitelabelHost = (...args)=>(0, $1X0Je.default).functions.scopeClaimsToWhitelabelHost(...args);
const $0505601246d7c320$var$shellScopeWorkspaceListToWhitelabelHost = (...args)=>(0, $1X0Je.default).functions.scopeWorkspaceListToWhitelabelHost(...args);
const $0505601246d7c320$var$shellStampWorkspaceListShape = (...args)=>(0, $1X0Je.default).functions.stampWorkspaceListShape(...args);
const $0505601246d7c320$var$shellWorkspaceDisplayName = (...args)=>(0, $1X0Je.default).functions.workspaceDisplayName(...args);
const $0505601246d7c320$var$shellGetWorkspacePrefixSlug = (...args)=>(0, $1X0Je.default).functions.getWorkspacePrefixSlug(...args);
// Cross-origin auth handoff (authHandoff.js in workspace-shared). Same
// deferred-call wrapper shape as the rest of this block. Used by
// `redirectIfUnauthed`'s `authed && onAuthPage` branch — see the comment
// there (PREVIEW-AUTH-HANDOFF-NO-RETURN-LOCAL-1).
const $0505601246d7c320$var$shellIsTrustedHandoffTarget = (...args)=>(0, $1X0Je.default).functions.isTrustedHandoffTarget(...args);
const $0505601246d7c320$var$shellClassifyHandoffTarget = (...args)=>(0, $1X0Je.default).functions.classifyHandoffTarget(...args);
const $0505601246d7c320$var$shellEncodeHandoffPayload = (...args)=>(0, $1X0Je.default).functions.encodeHandoffPayload(...args);
const $0505601246d7c320$var$shellAppendHandoffFragment = (...args)=>(0, $1X0Je.default).functions.appendHandoffFragment(...args);
const $0505601246d7c320$export$8bb20d34e8b438e9 = (root)=>{
    const binding = root ? root.whitelabelHostScope : null;
    const pinned = (0, $gNttC.getHostScopeOrgId)();
    if (binding && binding.organizationId && (!pinned || pinned === binding.organizationId)) return binding;
    const brand = root ? root.whitelabelBrand : null;
    const orgId = pinned || brand && brand.organizationId || null;
    if (orgId) {
        const fromBinding = binding && binding.organizationId === orgId ? binding.workspaceId : '';
        const fromBrand = brand && brand.organizationId === orgId ? brand.workspaceId : '';
        return {
            organizationId: orgId,
            workspaceId: fromBinding || fromBrand || ''
        };
    }
    return binding === false ? false : null;
};
const $0505601246d7c320$export$3b2f5c28f93f6ed8 = (root, orgsList, mongoActiveOrgId, govActiveOrgId)=>{
    const list = Array.isArray(orgsList) ? orgsList : [];
    const has = (id)=>!!id && !!list.find((o)=>o.id === id);
    const pending = root?._pendingActiveOrgId;
    if (has(pending)) return pending;
    // Multi-workspace-tabs: a tab's URL `/w/<org-slug>` PINS its org — it wins over
    // the Mongo/claim active org so no auth tick reverts a URL-scoped tab off the
    // org it's showing (I6). After the optimistic switch pick (which the switcher's
    // URL rewrite converges on anyway). No-op when the flag is off (no `/w/` URLs).
    if ($0505601246d7c320$var$shellIsMwtEnabled() && typeof window !== 'undefined') {
        const slug = $0505601246d7c320$var$shellGetWorkspacePrefixSlug(window.location?.pathname || '');
        const urlOrg = slug && list.find((o)=>o.slug === slug);
        if (urlOrg && has(urlOrg.id)) return urlOrg.id;
    }
    // A WHITE-LABEL HOST PINS ITS ORG, and auth stands down
    // (WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1, the switchOrg race).
    //
    // Same principle as the MWT branch directly above, and deliberately the SAME
    // SLOT in the ladder: a pin that names this tab's tenant outranks the ambient
    // stored choice (Mongo/claims), but never the user's explicit in-tab switch
    // (`_pendingActiveOrgId`, handled first). The customer's own domain states
    // the tenant just as authoritatively as a `/w/<org>` URL does — it simply
    // states it through the hostname, which is why the MWT branch could not
    // cover it (that path is inert with the flag off, which is the common case
    // on these hosts).
    //
    // This is what makes the boot's `sdk.switchOrg` pin STICK. Without it, this
    // resolver kept returning the my.symbols active org, the drift-correction
    // block below it then re-minted the token to that org, and the two
    // un-awaited writes raced — 1 wrong of 5 loads measured on work.astio.ai
    // even after the structural fix. Standing down here means the wrong org is
    // never written at all, rather than written and then corrected, which
    // matters because a briefly-visible wrong tenant on a customer's branded
    // domain IS the defect.
    //
    // `has()` still gates it: a host naming an org this user does not belong to
    // falls through to the normal ladder instead of ghost-activating.
    const hostOrg = (0, $gNttC.getHostScopeOrgId)();
    if (has(hostOrg)) return hostOrg;
    if (has(mongoActiveOrgId)) return mongoActiveOrgId;
    if (has(govActiveOrgId)) return govActiveOrgId;
    // Last rung: the first org a list OFFERS, not orgs[0] — /auth/me lists the
    // empty personal org first (POB r5; shared functions/visibleOrgs.js). Twin
    // of shared bootResolve.js resolveAuthSnapshot: change both or neither.
    return (0, $1X0Je.default).functions.visibleOrgs(list)[0]?.id || null;
};
const $0505601246d7c320$export$a767f9f5069cb25f = (user)=>Array.isArray(user?.organizations) && user.organizations.length > 0;
const $0505601246d7c320$var$_matchesAuthPath = (path, authPaths)=>{
    for (const ap of authPaths){
        if (path === ap || path.startsWith(ap + '/') || path.startsWith(ap + '?')) return true;
    }
    return false;
};
// Canonical SDK token key list. Swept on stale-token detection so the
// next fresh sign-in starts from a clean slate. Intentionally broad:
// a key we clear unnecessarily only costs one extra sign-in; a key we
// leave behind risks the redirect loop indefinitely.
const $0505601246d7c320$var$_SDK_TOKEN_KEYS = [
    'symbols_access_token',
    'symbols_refresh_token',
    'symbols_expires_at',
    'symbols_user',
    'symbols_organization',
    'symbols_workspace',
    'gov_access_token',
    'symbols_session'
];
// Defensive stale-token sweep. Runs ONLY when we are about to bounce an
// unauthed user to /signin AND `symbols_access_token` is present in
// localStorage — which means hasSessionToken() already returned false
// (either exp is past, or exp is missing/zero and the token is degenerate).
//
// The combination "token key present but hasSessionToken false" is the
// dirty-token state that causes the redirect loop: the user lands on
// /signin, redirectIfUnauthed sees hasSessionToken() returns false (expired)
// so it lets them through — but then something else in the boot chain reads
// the raw `symbols_access_token` value (non-expired shape but zero exp),
// treats the user as authed, and bounces them back to /. Clearing here
// breaks the loop.
//
// Does NOT run on the happy path:
//   - cleanly authed user  → hasSessionToken() = true  → we never reach here
//   - cleanly unauthed     → no SDK token at all        → nothing to clear
const $0505601246d7c320$var$_clearStaleTokens = ()=>{
    if (typeof window === 'undefined') return;
    try {
        const sym = window.localStorage.getItem('symbols_access_token');
        if (!sym) return; // nothing to clear — cleanly unauthed
        const exp = +window.localStorage.getItem('symbols_expires_at');
        // Token is stale when exp is missing (0 after +null), zero, or in the past.
        if (exp && exp > Date.now()) return; // token is valid — leave it alone
        // Must mirror hasSessionToken's refresh-token exemption. Without it this
        // sweep wipes the refresh token that makes an expired access token
        // recoverable — re-breaking the >1h-idle reload the exemption just fixed,
        // one layer down.
        if (window.localStorage.getItem('symbols_refresh_token')) return;
        console.warn('[redirectIfUnauthed] clearing stale tokens before /signin bounce');
        for (const key of $0505601246d7c320$var$_SDK_TOKEN_KEYS)window.localStorage.removeItem(key);
    } catch (_) {
    /* localStorage may throw in sandboxed contexts — safe to swallow */ }
};
const $0505601246d7c320$export$2528bb41c06a4057 = ()=>{
    try {
        window.sessionStorage.removeItem('symbols_login_bounce');
    } catch (_) {
    /* sandboxed context */ }
};
const $0505601246d7c320$export$9712d8571917f630 = ()=>{
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    const onGesture = (e)=>{
        if (e && e.isTrusted === false) return;
        window.removeEventListener('pointerdown', onGesture, true);
        window.removeEventListener('keydown', onGesture, true);
        $0505601246d7c320$export$2528bb41c06a4057();
    };
    window.addEventListener('pointerdown', onGesture, true);
    window.addEventListener('keydown', onGesture, true);
};
const $0505601246d7c320$export$2b286f8a5e41ae5 = ({ loginPath: loginPath = '/login', homePath: homePath = '/', authPaths: authPaths = (0, $kuISg.AUTH_PATHS), publicPathPrefixes: publicPathPrefixes = [], isPublicPath: isPublicPath = null } = {})=>{
    if (typeof window === 'undefined') return false;
    const path = window.location.pathname;
    if (publicPathPrefixes.some((p)=>path === p || path.startsWith(p + '/') || path.startsWith(p + '?')) || typeof isPublicPath === 'function' && isPublicPath(path)) return false;
    const authed = (0, $kuISg.hasSessionToken)();
    const onAuthPage = $0505601246d7c320$var$_matchesAuthPath(path, authPaths);
    const target = (0, $kuISg.authRedirectTarget)({
        path: path,
        search: window.location.search || '',
        authed: authed,
        demoHost: (0, $1jHTS.isDemoHost)(),
        loginPath: loginPath,
        authPaths: authPaths,
        publicPathPrefixes: publicPathPrefixes,
        isPublicPath: isPublicPath
    });
    if (target) {
        // Before bouncing, sweep any stale SDK token keys that could cause a
        // redirect loop on the next page load.
        $0505601246d7c320$var$_clearStaleTokens();
        window.location.replace(target);
        return true;
    } else if (!authed && onAuthPage && (0, $1jHTS.isDemoHost)() && path !== '/demo' && !path.startsWith('/demo/') && !path.startsWith('/demo?')) {
        // On a demo host the ONLY auth surface is the branded /demo email gate; the
        // real /login // signin pages are reachable only via the Claim modal (the
        // inline LoginWindow). A reauth bounce (bootShell _forceLogoutAndReauth →
        // full replace('/login') on a stale/GC'd demo session) or a stale link must
        // re-land the visitor on the email gate, never the signin page.
        $0505601246d7c320$var$_clearStaleTokens();
        window.location.replace('/demo');
        return true;
    } else if (authed && onAuthPage) {
        // LOGIN-BOUNCE CIRCUIT BREAKER (2026-09-02) — renderer OOM crash at
        // /login?next=…: an expired-access + refresh-token pair reads as authed
        // here (hasSessionToken's recoverable-session exemption), the app boot
        // then loses the single-use refresh rotation (another tab of this origin
        // rotated it first — fleet worker tabs share the origin all day),
        // _forceLogoutAndReauth purges and bounces back to /login — and the
        // healthy tab's SDK re-writes fresh tokens before this tab's next guard
        // pass, so the forward fires again. Every hop re-evaluates the full dev
        // bundle in the SAME renderer; Chrome has no client-redirect loop
        // detection, so after enough rounds the renderer OOMs (four crash dumps,
        // 2026-09-01 21:11-21:20 + 2026-09-02 11:41, each matching worker
        // browser activity). sessionStorage is PER-TAB, so the counter sees only
        // this tab's own bounces. Three forwards inside 30s is a machine loop,
        // never a human: stop forwarding, drop this tab's token copy (it is loop
        // fuel — the healthy tab holds its session in memory and re-writes at
        // will), and fall through so the login form renders.
        try {
            const _bk = 'symbols_login_bounce';
            const _now = Date.now();
            let _b = null;
            try {
                _b = JSON.parse(window.sessionStorage.getItem(_bk) || 'null');
            } catch (_) {}
            // WINDOW = 5 MINUTES, not 30s (2026-09-02, Nika: "sometimes still
            // goes 'Aw, snap'" — dumps at 13:18 + 13:58, AFTER the breaker
            // landed). Each loop cycle re-evaluates the full dev bundle TWICE
            // (login boot + app boot), which on this stack takes 30-40s — so
            // three forwards never fit inside a 30s window: the counter reset on
            // every pass and the "breaker" never tripped on exactly the slow
            // loops that OOM the renderer. Five minutes covers cycle times up to
            // ~100s with margin. False-positive safety: the counter is cleared
            // by bootShell on every SUCCESSFUL authed boot (see
            // clearLoginBounceCount), so a human legitimately landing on /login
            // a few times across five minutes never accumulates — only
            // uninterrupted machine loops do.
            if (!_b || typeof _b.t !== 'number' || _now - _b.t > 300000) _b = {
                n: 0,
                t: _now
            };
            _b.n += 1;
            window.sessionStorage.setItem(_bk, JSON.stringify(_b));
            if (_b.n > 3) {
                console.warn('[redirectIfUnauthed] login bounce loop broken after', _b.n - 1, "forwards in 5min \u2014 clearing this tab's tokens, showing the form");
                for (const key of $0505601246d7c320$var$_SDK_TOKEN_KEYS)window.localStorage.removeItem(key);
                window.sessionStorage.removeItem(_bk);
                return false;
            }
        } catch (_) {
        /* sessionStorage unavailable (sandboxed context) — keep old behavior */ }
        // CROSS-ORIGIN HANDOFF FIRST (PREVIEW-AUTH-HANDOFF-NO-RETURN-LOCAL-1).
        // A consumer surface on ANOTHER origin (preview, gazer) that needs a
        // session bounces the user here as `/signin?redirect=<its own URL>`
        // (PreviewErrorBoundary._redirectToWorkspaceLogin → buildLoginRedirectUrl).
        // The two existing minters — signin.js's `onInit` and authGuard.js's
        // `maybeMintHandoffFromGuard` — both live BELOW this guard: this function
        // runs at module load in index.js, before any page mounts, and its home
        // bounce below is a HARD `window.location.replace`. So for an ALREADY
        // signed-in user the shell parked on its own home carrying a dead
        // `?redirect=` (measured: `/w/<org>/<ws>?redirect=<previewUrl>`) and the
        // consumer origin never received a token. Mint the one-shot fragment here
        // instead — the same payload, the same trust gate (`isTrustedHandoffTarget`
        // restricts targets to same-origin / same-plane shell + preview-app hosts /
        // — from a LOCAL shell only — localhost), so nothing new is exposed.
        //
        // AUTH-HANDOFF-NARROW-TARGETS: a target that renders a USER PROJECT (a
        // `<owner>--<key>` preview host) is not trusted here — this guard is
        // synchronous and runs before the SDK exists, so it cannot ask the
        // server. It returns false instead: the shell boots onto /signin and
        // signin.js `onInit` runs `confirmHandoffTarget` (project private AND
        // readable by this user) before it mints or sends the user home.
        //
        // Tokens come from localStorage rather than an SDK handle: this guard runs
        // before the SDK is constructed, and `hasSessionToken()` above already
        // proved the credential is live under these exact canonical keys.
        try {
            const redirectParam = new URLSearchParams(window.location.search || '').get('redirect');
            if (redirectParam && $0505601246d7c320$var$shellIsTrustedHandoffTarget(redirectParam)) {
                const accessToken = window.localStorage.getItem('symbols_access_token') || window.localStorage.getItem('symbols_bridge_access_token');
                if (accessToken) {
                    const payload = $0505601246d7c320$var$shellEncodeHandoffPayload({
                        accessToken: accessToken,
                        refreshToken: window.localStorage.getItem('symbols_refresh_token') || '',
                        expiresAt: parseInt(window.localStorage.getItem('symbols_expires_at') || '0', 10) || 0,
                        expiresIn: parseInt(window.localStorage.getItem('symbols_expires_in') || '0', 10) || 0
                    });
                    window.location.replace($0505601246d7c320$var$shellAppendHandoffFragment(redirectParam, payload));
                    return true;
                }
            }
            if (redirectParam && $0505601246d7c320$var$shellClassifyHandoffTarget(redirectParam).verdict === 'confirm') return false;
        } catch (_) {
        /* malformed query / localStorage unavailable — fall through to the
         normal home bounce; the consumer surface still renders its
         signed-out state rather than a broken redirect. */ }
        // Honour `?next=` — the auth guard encodes the route it bounced away from
        // there. Dropping it is why a bounced deep link came back to the dashboard
        // instead of the page that was asked for. `consumeOAuthNext` applies the
        // same-origin clamp the OAuth callback uses, so a hand-crafted
        // `?next=https://evil.com` can't turn this into an open redirect; it
        // returns '/' for anything unsafe, which we treat as "no usable target".
        let target = homePath;
        let usedNext = false;
        try {
            const next = new URLSearchParams(window.location.search || '').get('next');
            if (next) {
                const safe = $0505601246d7c320$var$shellConsumeOAuthNext(next);
                if (safe && safe !== '/') {
                    target = safe;
                    usedNext = true;
                }
            }
        } catch (_) {
        /* malformed query — fall back to homePath */ }
        // tickets/sonnet.md "auth-page redirects still drop the query, and
        // ?claim=credits is exactly what they drop" — measured live: a
        // signed-in visitor hitting `/signup?claim=credits` bounced to
        // `homePath` with `location.search` wiped. This is the same
        // bare-path-redirect class the router ticket fixed at the shell
        // boundary (opus.md, workspace 6d146d9a) — one more instance of it,
        // in the auth guard rather than a page component. Only applied when
        // `next` wasn't used: `safe` is already a fully-resolved destination
        // in its own right, and appending the OUTGOING location's query on
        // top of it would duplicate/garble whatever `next` itself encodes.
        if (!usedNext) target = (0, $iJIxS.withLiveQuery)(target);
        window.location.replace(target);
        return true;
    }
    return false;
};
// Subscribe to auth state changes. Accepts two callbacks:
//   onSignIn(user)            — fired once per new user session (new id)
//   onWorkspaceChange(claims) — fired when active_workspace_id changes
//                               for the same user (e.g. org switch).
//                               NOT called on initial sign-in (onSignIn
//                               covers that path).
//
// Both are optional. Returns an unsubscribe function (sync — see the
// cancel-token shim below for the SDK-proxy reason).
//
// SDK's onAuthStateChange keeps the legacy (event, session) callback shape,
// so subscriber bodies read the same as they always did.
// String-normalize a workspace-id cursor before comparing. `nextActiveWs`
// comes straight off the JWT claim (`nextClaims.active_workspace_id`, line
// ~648) with NO normalization, and a routine `TOKEN_REFRESHED` re-mint can
// hand back the SAME logical workspace in a different literal form (Mongo
// ObjectId vs UUID string, incidental whitespace) — this file already
// documents the identical drift for the sibling `nextId`/`lastUserId` pair
// (see `_loadInFlight`'s comment above) and a prior fix (workspace ab5cef23,
// "PERF-1 vector 3") closed the BOOT-time instance of THIS exact branch by
// gating it on `_loadInFlight`. That guard only covers the narrow window
// while `onSignIn`'s `loadPrivateData` is still executing — a refresh that
// lands minutes into a live session (well past `_loadInFlight`, well past
// `isInitialClaimLanding`) was never covered, and the raw `!==` below fired
// a full `onWorkspaceChange` re-hydration for a workspace that never
// actually changed (RAIL-TRANSITION, tickets/fable.md — the View-as
// loader-spiral: a same-workspace format-drift tick raises the MainLoader,
// PHASE-1-wipes `workspaceProject` mid-render — while `_canvasSlot` still
// names a persona route, so the slot 404s until republish completes — and
// the storm was intermittent because it only fires when a background
// refresh tick's timing lands mid-session, never on the very first switch).
const $0505601246d7c320$var$_wsIdStr = (v)=>v == null ? '' : String(v).trim();
const $0505601246d7c320$export$aeacd7eff53dd464 = (nextActiveWs, lastActiveWorkspaceId)=>!!nextActiveWs && $0505601246d7c320$var$_wsIdStr(nextActiveWs) !== $0505601246d7c320$var$_wsIdStr(lastActiveWorkspaceId);
const $0505601246d7c320$export$5a700c6c87736f3a = (liveWs, fallbackWs, inActiveOrg)=>liveWs && liveWs.id && typeof inActiveOrg === 'function' && inActiveOrg(liveWs) ? liveWs : fallbackWs;
const $0505601246d7c320$export$6aaad40b0d5ceb3e = (root, onSignIn, onWorkspaceChange)=>{
    if (!root) return ()=>{};
    // See the import-site note above — root.call reaches the live singletons
    // (module-private WeakMap / dedup cache) instead of a raw cross-file import
    // frank cannot resolve once this function is serialized.
    const getWorkspaceCached = (...args)=>typeof root.call === 'function' ? root.call('getWorkspaceCached', ...args) : typeof (0, $7muxD.getWorkspaceCached) === 'function' ? (0, $7muxD.getWorkspaceCached)(...args) : Promise.resolve(null);
    const beginPostAuthWorkspaceReveal = (...args)=>typeof root.call === 'function' ? root.call('beginPostAuthWorkspaceReveal', ...args) : typeof (0, $jZ5ZE.beginPostAuthWorkspaceReveal) === 'function' ? (0, $jZ5ZE.beginPostAuthWorkspaceReveal)(...args) : null;
    const endPostAuthWorkspaceReveal = (...args)=>typeof root.call === 'function' ? root.call('endPostAuthWorkspaceReveal', ...args) : typeof (0, $jZ5ZE.endPostAuthWorkspaceReveal) === 'function' ? (0, $jZ5ZE.endPostAuthWorkspaceReveal)(...args) : false;
    // The session end (WS-SIGNIN-DOES-NOT-SUPERSEDE-INFLIGHT-SWITCH-1) reaches
    // the shell's registry through the root state's element, the way
    // workspaceConfigs.js reaches `applyWorkspaceLangPolicy`: the root STATE
    // carries no `.call`, its back-pointer element does. No sibling import: a
    // new one is a frank FA001 error, and a free identifier under frank
    // revival. With no element there (it is transiently absent while a switch
    // replaces the root state) the end is skipped: the behaviour before this
    // fix, never a throw.
    const endWorkspaceSession = (...args)=>{
        const el = root.__element;
        return typeof el?.call === 'function' ? el.call('endWorkspaceSession', ...args) : undefined;
    };
    let lastUserId = null;
    // The signed-in person's email, beside `lastUserId`: the same person can
    // come back under another id format (see `_loadInFlight`), never under
    // another email, so a session change compares this one.
    let lastUserEmail = null;
    let lastActiveWorkspaceId = null;
    let lastClaimsKey = null;
    // Cache the last `activeOrgId` we wrote to Mongo via the drift-heal
    // below so TOKEN_REFRESHED replays + identical claim ticks don't
    // re-PATCH /auth/me/active-org. Reset on heal-failure so retries are
    // possible on the next tick.
    let lastHealedActiveOrgId = null;
    // Guards the cross-org workspace token re-mint (switchOrg) below — fires
    // once per drifted active org per session, never in a loop. Reset on
    // sign-in / sign-out alongside lastHealedActiveOrgId.
    let _lastRemintedOrgId = null;
    // Guards the SDK workspaces-list fallback below — one fetch per active org.
    // RE-ARMED on failure/empty (see the fallback's catch): this is the only
    // workspace-scope source for a claims-less session, so consuming it on a
    // transient blip left the whole session scope-less and the identity chrome
    // empty (my.symbols.app sign-in, 2026-07-30).
    let _wsListFetchedOrgId = null;
    // One-shot watchdog: the identity chain (orgs → org → workspace) fails
    // SILENTLY by design — every fallback is a swallowed warn — which made
    // Nika's empty-chrome boot unattributable in telemetry. One error-level
    // breadcrumb when the chain is still unresolved well after sign-in gives
    // the analyzed pipeline something to catch.
    let _identityWatchdogArmed = false;
    const _armIdentityWatchdog = (root)=>{
        if (_identityWatchdogArmed) return;
        _identityWatchdogArmed = true;
        const t = setTimeout(()=>{
            try {
                const orgsOk = Array.isArray(root.orgs) && root.orgs.length > 0;
                const orgOk = !!(root.org && (root.org.id || root.org._id));
                const wsOk = !!(root.workspace && (root.workspace.id || root.workspace._id));
                if (root.signedIn && (!orgsOk || !orgOk || !wsOk)) console.error('[auth] identity chain unresolved 10s after sign-in', {
                    orgsOk: orgsOk,
                    orgOk: orgOk,
                    wsOk: wsOk
                });
            } catch  {
            /* watchdog must never throw */ }
        }, 10000);
        if (t && typeof t.unref === 'function') t.unref();
    };
    // PERF-3 vector-2: in-flight dedup guard for loadPrivateData (called
    // from onSignIn). When a TOKEN_REFRESHED event fires while onSignIn is
    // still executing, the refreshed token may carry a user object whose
    // `u.id` differs in format from the original `u._id` (Mongo ObjectId
    // string vs the legacy external UUID). That makes `nextId !== lastUserId`
    // true even though the user
    // hasn't changed, and a second onSignIn call fires concurrently.
    // The in-flight guard is strictly additive to the _authStateDelivered
    // PERF-1 guard above (which suppresses the warm-boot double-fire);
    // this covers the TOKEN_REFRESHED race that PERF-1 cannot catch because
    // _authStateDelivered is already true by the time the refresh fires.
    // It holds the in-flight call's own token, so an old call's settle never
    // releases a newer one's latch, and a session change releases it (see the
    // session end below): the old person's onSignIn may run on, but the next
    // person's must fire (WS-SIGNIN-DOES-NOT-SUPERSEDE-INFLIGHT-SWITCH-1).
    let _loadInFlight = null;
    // Post-sign-in workspace-MODULE (re)load. onSignIn (loadPrivateData) can fire
    // on the FIRST auth tick BEFORE the active workspace resolves — the SDK emits
    // onAuthStateChange the moment `symbols_access_token` lands, AHEAD of the
    // governance JWT that carries `active_workspace_id` + `workspaces[]` (see the
    // fresh-login race note in loadPrivateData.js). With no `root.workspace`,
    // loadWorkspaceProject no-ops, so the active workspace's MODULE (its pages /
    // nav / home-widgets) never injects — and because onSignIn only fires once per
    // user (`lastUserId` guard) and the initial claim-landing below only advanced
    // the cursor, the module used to load ONLY after a full page reload (which
    // boots with the workspace already resolved). When the workspace resolves on a
    // LATER tick we must re-run the module load. loadWorkspaceProject is idempotent
    // — monotonic `_loadSeq` (a newer load wins, older bails post-await) plus the
    // `_activeProjectId` dedup (same module never re-injects) — so a redundant call
    // over an already-loaded module is a cheap no-op, never a double-inject. Keyed
    // by workspace id so it fires at most once per workspace per session; org
    // switches go through onWorkspaceChange (which loads the module itself), never
    // this path. Reset on sign-out so a re-sign-in re-loads.
    let _moduleLoadedForWsId = null;
    const _ensureWorkspaceModule = (wsId)=>{
        if (!wsId || _moduleLoadedForWsId === wsId) {
            // Nothing left that could inject routes on this boot — no workspace in
            // scope (e.g. a stale `?ws=` handle from another org resolved to null),
            // or the module already loaded. Either way the latch MUST still settle:
            // this early return previously skipped it, leaving `_appRoutesSettled`
            // unset forever, which kept the '/*' NotFoundBody hidden — a genuinely
            // nonexistent path showed a blank page instead of its 404 (measured on
            // /w/natali/definitely-not-a-page with a mismatched ws pointer).
            root.update({
                _appRoutesSettled: true
            }, {
                preventFetch: true
            });
            return;
        }
        _moduleLoadedForWsId = wsId;
        // The first auth event can precede the workspace claim/list. Once that
        // workspace lands, keep the original loader epoch alive through the
        // corrective module/apps/config AND dashboard-prefs reads. Otherwise the
        // shell reveals default chrome/layout, then repaints two or three times as
        // each late result lands.
        const reveal = beginPostAuthWorkspaceReveal(root, wsId);
        // Suppress the shell catch-all's "Not found" CONTENT while module/app
        // routes are still being injected. A hard load on an injected route (e.g.
        // /w/natali/crm) hits the router at BOOT, before these loaders have run,
        // so nothing matches and it falls through to '/*' — which rendered a
        // fully-styled 404 for the entire activation window (~12s measured).
        // `_rerouteIfStranded` already recovers once the pages exist; this only
        // stops the false 404 from being SHOWN meanwhile. Cleared on every exit
        // path (including failure) so a genuinely nonexistent path still 404s.
        // A "settled" LATCH, not a pending flag. A pending flag races: `_authReady`
        // flips true a tick before this function runs, so there was a window where
        // neither gate held and the 404 rendered anyway (measured). The latch has
        // no such gap — it is absent from boot and set exactly once, so the gate is
        // simply "token-bearing user, routes not injected yet".
        const _settle = ()=>root.update({
                _appRoutesSettled: true
            }, {
                preventFetch: true
            });
        // The claim can arrive while a warm snapshot is still painted or while
        // its list-shaped workspace is fetching a full record. Do not let that
        // provisional record load a System/default module and then suppress the
        // full-record converge that would correct it. The entire corrective chain
        // is intentionally pinned to the claim's exact, authoritative workspace.
        // Boot fix step 2: the post-claim reveal waits for the takeover module and,
        // on a deep link, the one app whose page the URL names — never for apps
        // the page does not show. They keep setting up after the reveal.
        let _releaseModuleReveal = ()=>{};
        const moduleReveal = new Promise((resolve)=>{
            _releaseModuleReveal = resolve;
        });
        const moduleChain = Promise.resolve((0, $6QCFv.awaitInitialWorkspace)(root, {
            workspaceId: wsId
        })).then(async (ready)=>{
            if (!ready || !(0, $6QCFv.hasAuthoritativeWorkspace)(root, wsId)) return false;
            // `boot: true` — this chain is one of three boot entrants for the same
            // scope; a later entrant reuses a settled pass instead of re-running it.
            await (0, $7ytvD.loadWorkspaceProject)(root, $0505601246d7c320$var$shellGetSDK(), {
                boot: true
            });
            const appsRun = (0, $7ytvD.loadWorkspaceApps)(root, $0505601246d7c320$var$shellGetSDK(), {
                boot: true
            });
            (0, $7ytvD.whenAppRouteReady)(root).then(()=>{
                try {
                    (0, $g7CNh.applyWorkspaceConfig)(root);
                } catch (e) {
                    console.warn('[auth] post-sign-in applyWorkspaceConfig (reveal) failed:', e?.message || e);
                }
                _releaseModuleReveal();
            });
            await appsRun;
            (0, $g7CNh.applyWorkspaceConfig)(root);
            return true;
        }).then((loaded)=>{
            // The bounded authority wait timed out or was superseded. Do not run
            // any workspace-scoped side effect against a provisional record; the
            // full-record listener / next auth tick will own a later retry.
            if (!loaded) {
                if (_moduleLoadedForWsId === wsId) _moduleLoadedForWsId = null;
                return;
            }
            // The chain RESOLVED, but either loader may have settled only
            // TRANSIENTLY: 'unresolved' (workspace/org scope wasn't determinable
            // on that pass — the cold-boot convergence window) or 'error' (a
            // referenced module's / every installed app's fetch failed). The
            // loaders schedule their own converge retry for those; ALSO re-arm
            // this latch so a later auth tick can drive a fresh load if that
            // bounded retry window closes first. Definitive outcomes ('active' /
            // 'no-module' / 'refused' / 'empty') keep the latch — those must not
            // re-load on every tick. BOTH outcomes are consulted: a workspace
            // running only additive apps is definitively 'no-module' on the
            // takeover side even when 0 of its N installed apps loaded (the
            // natali empty-dashboard bug) — the apps outcome is what says so.
            const outcome = (0, $7ytvD.getModuleLoadOutcome)();
            const appsOutcome = (0, $7ytvD.getAppsLoadOutcome)();
            const transient = outcome === 'unresolved' || outcome === 'error' || appsOutcome === 'unresolved' || appsOutcome === 'partial' || appsOutcome === 'error';
            // Settle the 404-suppression latch only on definitive passes. A
            // transient pass keeps it unset so the '/*' catch-all stays covered
            // while the converge retry re-runs the loaders — the retry (or its
            // bounded give-up) settles it.
            if (!transient) _settle();
            if (transient && _moduleLoadedForWsId === wsId) _moduleLoadedForWsId = null;
        }).catch((err)=>{
            _settle();
            // Allow a retry on a later tick if the load genuinely failed.
            if (_moduleLoadedForWsId === wsId) _moduleLoadedForWsId = null;
            console.warn('[auth] post-sign-in workspace module load failed:', err?.message || err);
        });
        // Re-run the home-dashboard-prefs GET (grid_layout / hidden_widgets),
        // explicitly pinned to `wsId` — the workspace this function just resolved.
        // loadPrivateData's OWN `_prefsChain` already ran once on the FIRST auth
        // tick (see the block comment above), and on THAT tick `root.workspace` was
        // frequently still unset (or, with a stale/foreign `?ws=` URL handle, briefly
        // resolved to the WRONG workspace — see workspaceUrlSync.js / bootShell's
        // `resolveActiveWorkspace`) — so that first fetch pinned to 'default'/null/
        // the wrong workspace, or found nothing. Nothing else in the app ever
        // re-fetches `userDashboardPrefs` outside `loadPrivateData` (boot) and
        // `onWorkspaceChange` (org switch) — and THIS path (workspace resolves on a
        // LATER sign-in tick) is neither of those — so without this call the grid's
        // saved layout for the CORRECT workspace was never fetched for the rest of
        // the session: pages/main.js `_initGridstack` would boot (and permanently
        // stay) on whatever the wrong-scope/empty first read left behind, i.e. each
        // widget's raw manifest position instead of the user's saved arrangement
        // (2026-07-30 "widgets rearranged to different positions" — GreenIG). Pure
        // GET + `root.update`, no mutation, so firing it again here is always safe
        // even when the first fetch happened to already have the right scope.
        // This belongs to the same post-claim reveal transaction as the module
        // chain above. The route latch still settles independently, but the main
        // loader remains until the correct workspace's layout row has landed.
        // `write` refuses a stale write — mirrors `_savePrefsPatch`'s own
        // scope-still-current guard in pages/main.js: by the time this GET
        // resolves, a DIFFERENT workspace resolution may have already superseded
        // `wsId` (both callers of `_ensureWorkspaceModule` set `root.workspace`
        // to their target synchronously, in the same tick, right before calling
        // it — so a live mismatch here means something newer already won).
        const prefsChain = Promise.all((0, $jZ5ZE._dashboardPrefsFetches)(root, $0505601246d7c320$var$shellGetSDK(), {
            tag: 'post-sign-in: ',
            workspaceId: wsId,
            write: (patch)=>{
                if (root.workspace?.id && String(root.workspace.id) !== String(wsId)) return;
                root.update(patch);
            }
        })).catch((err)=>console.warn('[auth] post-sign-in dashboard-prefs fetch failed:', err?.message || err));
        // Both branches swallow their own operational errors so an unavailable
        // backend cannot wedge the UI. The epoch guard in endDataLoad means a
        // newer org/workspace switch still owns its own loader/reveal.
        moduleChain.finally(()=>_releaseModuleReveal());
        Promise.all([
            moduleReveal,
            prefsChain
        ]).finally(()=>endPostAuthWorkspaceReveal(root, reveal));
    };
    const handler = (_event, session)=>{
        const u = session?.user;
        // A user-less tick is AMBIGUOUS under Mongo-token auth: the SDK's
        // session mirrors its TokenManager, and `user` hydrates only via
        // getMe()/login()/boot() — a subscriber can receive `session.user:
        // null` while every REST call authenticates fine. Treating that as
        // sign-out wiped the bootShell-seeded identity (signedIn / orgs /
        // org / workspace → the recurring empty-chrome boot: org switcher
        // gone, no active-workspace session info). Real sign-outs clear
        // tokens BEFORE emitting SIGNED_OUT (AuthService.logout, both
        // paths), and token rejections force-logout in bootShell — both
        // reach here token-less and still tear down below. Token present +
        // no user → hold current state and wait for the hydrated tick
        // (USER_UPDATED from adoptSessionUser / getMe).
        if (!u && (0, $kuISg.hasSessionToken)()) return;
        const nextEmail = u?.email || '';
        const nextId = u?.id || u?._id || '';
        // Canonical Mongo `User.username` — surfaced on root state so
        // surfaces that persist or route on a user-handle (community posts,
        // author chips, `/user/<slug>` deep links) can prefer the canonical
        // value over an email-prefix fallback. Without this, every consumer
        // ended up using `email.split('@')[0]` which silently diverged from
        // the user's real handle (e.g. nika@symbols.app → "nika" vs the
        // actual username "nikoloza", causing /user/nika to 404).
        const nextUsername = u?.username || '';
        // Legacy external auth UUID — carried on the Mongo user record
        // as `supabaseUserId` (nothing mints new ones; migrated rows key on it).
        // Surfaced on root state so host-only gates on rows keyed by
        // `auth.uid()` (meet_rooms.created_by, etc.) can match the active
        // user without the Mongo _id mismatch.
        const nextSupabaseId = u?.supabaseUserId || '';
        const nextSignedIn = !!u;
        // A session change ends every pass of the old session before anything of
        // the next one starts (WS-SIGNIN-DOES-NOT-SUPERSEDE-INFLIGHT-SWITCH-1):
        // the signed-in person signs out (no user and no token: the hold above
        // returned on an ambiguous tick), or another person's session replaces
        // theirs. The cross-tab sign-out keeps this page and the next sign-in is
        // an SPA one, so an old switch's late answers would land in the next
        // person's root. The same person under another id format keeps the
        // session (same email); the first sign-in of a page has no old session.
        // The old onSignIn's latch goes with the session: the next person's
        // onSignIn below must fire while the old one still runs.
        if (lastUserId && (!u || nextId && nextId !== lastUserId && !!lastUserEmail && !!nextEmail && String(lastUserEmail).toLowerCase() !== String(nextEmail).toLowerCase())) {
            endWorkspaceSession(root);
            _loadInFlight = null;
        }
        // Org membership lives in Mongo on `user.organizations` (returned by
        // the SDK getSession / /core/auth/me) — that's the source of truth.
        // `app_metadata` claims (active_workspace_id, workspaces[],
        // workspace_org_id) are OPTIONAL enrichment; orgs still resolve when
        // they're absent so AppWorkspaceSwitcher renders the user's org list
        // either way.
        const mongoOrgs = Array.isArray(u?.organizations) ? u.organizations : null;
        const nextClaims = {
            ...u?.app_metadata || {}
        };
        // Prefer Mongo's `user.organizations` when the legacy claims'
        // `app_metadata.orgs` is missing OR present-but-empty. The federation
        // bridge's mint can land an empty `orgs: []` when claims are synthesized
        // before OrgMember rows are joined — Mongo is the canonical membership
        // source, so an empty legacy claims array shouldn't shadow it. Without this
        // guard, AppWorkspaceSwitcher hides because `_orgs(root)` reads
        // `root.jwtClaims.orgs` (the federated value), even though
        // `root.orgs` (state-level, derived from Mongo) has real entries.
        const claimsHasOrgs = Array.isArray(nextClaims.orgs) && nextClaims.orgs.length > 0;
        if (!claimsHasOrgs && Array.isArray(mongoOrgs) && mongoOrgs.length > 0) nextClaims.orgs = mongoOrgs;
        else if (claimsHasOrgs && Array.isArray(mongoOrgs)) {
            // Drift defense: a legacy `app_metadata.orgs` claim
            // can carry entries the user is no longer a member of (server-side
            // bridge SERVER-AUTH-ORGS-DRIFT-1 has been fixed for new mints,
            // but EXISTING sessions keep their stale JWT until next sign-in).
            // Without this intersect, every consumer that fans out per-org
            // (loadAllTeams → listOrgMembers + listTeams, dashboard org tiles,
            // mention lookups) fires a request per stale org and the browser
            // logs a 403 per request — a multi-second console wall on every
            // page load. Mongo's `user.organizations` is the canonical source
            // (derived from `OrgMember.find({user})` server-side); intersect
            // against it to drop drift entries before any downstream consumer
            // sees them. Drops zero real memberships — if an org is in Mongo
            // elsewhere, it'd already be missing from `nextClaims.orgs`
            // and the missing-fallback branch above would have used Mongo.
            const mongoIds = new Set(mongoOrgs.map((o)=>String(o?.id || o?._id || '')).filter(Boolean));
            const filtered = nextClaims.orgs.filter((o)=>mongoIds.has(String(o?.id || o?._id || '')));
            if (filtered.length !== nextClaims.orgs.length) {
                const dropped = nextClaims.orgs.map((o)=>String(o?.id || o?._id || '')).filter((id)=>id && !mongoIds.has(id));
                console.warn('[auth] dropped stale orgs from JWT claims (federation drift):', dropped, "\u2014 resign in to mint a fresh JWT and clear this warning permanently.");
            }
            // Backfill Mongo-only orgs (governance bridge narrows app_metadata.orgs
            // to team-only before minting the JWT, so personal orgs never reach
            // claims even though the user owns them server-side). Union the
            // drift-filtered JWT orgs with any Mongo entries the bridge stripped —
            // canonical membership lives in OrgMember, so anything Mongo has is
            // legitimate. Without this, AppWorkspaceSwitcher / NoOrgOverlay /
            // every other consumer reading `root.orgs` only sees team orgs and
            // personal-org users are invisible to the workspace UI.
            const jwtIds = new Set(filtered.map((o)=>String(o?.id || o?._id || '')).filter(Boolean));
            const mongoOnly = mongoOrgs.filter((o)=>!jwtIds.has(String(o?.id || o?._id || '')));
            nextClaims.orgs = mongoOnly.length ? [
                ...filtered,
                ...mongoOnly
            ] : filtered;
        }
        // localStorage.activeWorkspace is the user's explicit choice + the canonical
        // pointer. The JWT's active_workspace_id is NOT re-minted on a workspace
        // switch (nor when switching to a brand-new workspace not yet in
        // claims.workspaces), so it goes stale and would otherwise win here and
        // overwrite the user's selection on every auth tick. Override the stale
        // claim with the LS pointer BEFORE deriving nextActiveWs / claimsKey /
        // activeWorkspace, so the whole resolution (and the persisted claimsKey
        // change-detection) reflects the chosen workspace. Mirrors the same
        // override in bootShell `_resolveAuthSnapshot` — keep the two in sync.
        try {
            const _lsAws = $0505601246d7c320$var$shellGetActiveWorkspacePointer() || '';
            if (_lsAws && String(_lsAws) !== String(nextClaims.active_workspace_id)) nextClaims.active_workspace_id = _lsAws;
        } catch (_) {}
        // `let` — the cross-org convergence below re-stamps this when the claimed
        // workspace turns out to belong to another org, so the sign-in /
        // workspace-change cursors record the CONVERGED id (recording the foreign
        // one made the next tick's comparison fire a spurious full reload).
        let nextActiveWs = nextClaims?.active_workspace_id || '';
        const userChanged = root.signedIn !== nextSignedIn || root.currentUserEmail !== nextEmail || root.currentUserId !== nextId || root.currentUserUsername !== nextUsername || root.currentUserSupabaseId !== nextSupabaseId;
        // Full-payload diff so TOKEN_REFRESHED ticks that re-mint an
        // identical claim set are no-ops, but ANY claim change (orgs,
        // permissions, workspaces, tier, role, ...) still propagates.
        // Stringify is ~50µs on a 2kB JWT vs the cost of stale role/perm
        // gates — correctness wins.
        const claimsKey = JSON.stringify(nextClaims);
        const claimsChanged = claimsKey !== lastClaimsKey;
        // Derive shell-scope state from claims so the OrgSwitcher / shell chrome
        // doesn't have to wait on a separate `/orgs` round-trip — the JWT
        // already carries the user's org membership + active workspace.
        // WS-WHITELABEL-TENANT-SCOPE-1 (auth-tick half) — narrow the CLAIMS to the
        // host's tenant before anything is derived from them.
        //
        // This tick rebuilds `nextClaims.orgs` from Mongo (above) and then writes
        // `{ orgs, workspaces, org, jwtClaims }` to root in ONE update. That
        // overwrote the scoped BOOT snapshot with the account-wide list: measured
        // on gita.pr.symbols.app after the boot fix shipped, `root.workspace` was
        // correctly GITA while `root.orgs.length` was 17 and
        // `jwtClaims.active_workspace_id` still named another org's workspace.
        //
        // Scoping HERE, before `orgsList` / `workspacesAll` / `activeOrgId` /
        // `activeOrg` are derived, covers all four plus the `jwtClaims` write with
        // one intervention that cannot drift apart. `resolveActiveOrgId` already
        // honours the host pin for WHICH org is active; this narrows WHICH ORGS
        // EXIST, which is the half the switcher reads.
        //
        // Source of the pin: `getHostScopeOrgId()` is canonical and fails closed.
        // WHITELABEL-STRICT-TENANT-SCOPE-1: it is now set PRE-MOUNT by
        // seedWhitelabelHostScope (whitelabelBrand.js), independent of branding,
        // with the same fact mirrored on `root.whitelabelHostScope`; the brand's
        // ids stay the last fallback for an entry that predates that seed. The
        // old sources were the brand (null for an UNBRANDED host — Unreal's org
        // has `branding: {}`) and customDomainBoot (which skipped /studio and
        // every deep link), so on unreal.pr.symbols.app this block never ran and
        // the tick resolved the account's stored org (Keepz).
        // `root.whitelabelHostScope === false` is the seed's "this customer host
        // could not prove its tenant" verdict: scope the claims to NO org.
        //
        // Written back onto `nextClaims` FIELD BY FIELD rather than rebound: the
        // binding is `const` (761) and this file already states its claim changes
        // by mutation (771, 809), so this matches the surrounding contract instead
        // of introducing a second one.
        const _hostScope = $0505601246d7c320$export$8bb20d34e8b438e9(root);
        if (_hostScope !== null) {
            const _scopedClaims = $0505601246d7c320$var$shellScopeClaimsToWhitelabelHost(nextClaims, _hostScope);
            if (_scopedClaims !== nextClaims) {
                if (Array.isArray(_scopedClaims.orgs)) nextClaims.orgs = _scopedClaims.orgs;
                if (Array.isArray(_scopedClaims.workspaces)) nextClaims.workspaces = _scopedClaims.workspaces;
                if (_scopedClaims.active_workspace_id) nextClaims.active_workspace_id = _scopedClaims.active_workspace_id;
                if (_scopedClaims.workspace_org_id) nextClaims.workspace_org_id = _scopedClaims.workspace_org_id;
            }
        }
        const orgsList = Array.isArray(nextClaims.orgs) ? nextClaims.orgs : [];
        const workspacesAll = Array.isArray(nextClaims.workspaces) ? nextClaims.workspaces : [];
        // List-shaped (JWT claims row — no `settings`). THIS is the exact object
        // that used to be handed straight to `root.update({ workspace: ... })`
        // below and silently downgrade a full record bootShell had already
        // resolved for the SAME id — the defect
        // tickets/spec-workspace-record-shape.md fixes. Stamped so the guarded
        // setter at the bottom of this tick can tell it apart from a complete
        // record; committing it now goes through `setActiveWorkspaceRecord`
        // instead of a bare `root.update`.
        let activeWorkspace = $0505601246d7c320$var$shellStampWorkspaceShape(workspacesAll.find((w)=>w.id === nextActiveWs) || null, 'list');
        // When claims carry no workspaces (SDK-only session, gov JWT not minted),
        // keep whatever the SDK workspaces-list fallback below already resolved —
        // otherwise a later claims tick overwrites root.workspace back to null.
        // BUT only when root.workspace agrees with the chosen pointer (nextActiveWs,
        // LS-overridden above). On the first auth tick the governance claims haven't
        // loaded (workspacesAll empty) and root.workspace is still the Phase-1 seed
        // (the stale JWT workspace); adopting it here would resolve activeWorkspace
        // to the WRONG workspace, suppress the listWorkspaces fallback, and mirror
        // the stale id back to localStorage — silently reverting a switch to a
        // freshly-created workspace on refresh. When they disagree, leave it null so
        // the fallback fetches the org's real list and resolves the chosen one.
        if (!activeWorkspace && !workspacesAll.length && root.workspace?.id && (!nextActiveWs || String(root.workspace.id) === String(nextActiveWs))) activeWorkspace = root.workspace;
        // The chosen workspace (nextActiveWs, now LS-overridden) may not be in the
        // JWT's claims.workspaces (a freshly-created workspace). bootShell's
        // pre-mount getWorkspace already resolved it into root.workspace, so PRESERVE
        // that here instead of nulling root.workspace on this tick (the SDK
        // workspaces-list fallback below still fills it when root.workspace lags).
        if (!activeWorkspace && root.workspace?.id && String(root.workspace.id) === String(nextActiveWs)) activeWorkspace = root.workspace;
        // Active org id resolves through the layered chain (pending → persisted
        // → governance → orgs[0]); see `resolveActiveOrgId` for full rationale.
        // We mirror the resolved id back into `nextClaims.workspace_org_id` so
        // every downstream consumer that already reads that field
        // (`filterToActiveOrg`, `_loadRoles`, etc.) re-keys without needing to
        // know about the localStorage path. Governance-derived value still
        // wins when present because the resolver checks it after the user-pick
        // layers but before the orgs[0] fallback.
        const govActiveOrgId = activeWorkspace?.org_id || nextClaims.workspace_org_id || null;
        const mongoActiveOrgId = u?.activeOrganization ? String(u.activeOrganization) : null;
        const activeOrgId = $0505601246d7c320$export$3b2f5c28f93f6ed8(root, orgsList, mongoActiveOrgId, govActiveOrgId);
        if (activeOrgId) nextClaims.workspace_org_id = activeOrgId;
        const activeOrg = activeOrgId ? orgsList.find((o)=>o.id === activeOrgId) : null;
        // Cross-org workspace drift defense — `nextClaims.active_workspace_id`
        // and `nextClaims.workspaces` are JWT-scoped, NOT re-minted on every
        // `sdk.setActiveOrganization`. Mongo's `User.activeOrganization`
        // updates first; the JWT lags until refresh. In that window the
        // JWT's `active_workspace_id` can point at a workspace IN THE
        // PREVIOUS ORG, and `claims.workspaces` carries workspaces from
        // every org the user has ever touched. Surfacing either under the
        // resolved active org leaks foreign-org data into every consumer
        // that scopes by `workspace.id` (loadPrivateData,
        // _activeWorkspaceProjects, the workspace switcher, …). Scope
        // `workspaces` to the active org, and re-resolve activeWorkspace
        // against the scoped list; fall back to its first entry when the
        // JWT pointer is stale.
        const inActiveOrg = (w)=>!activeOrgId || w && String(w.org_id || w.organization_id || w.organization) === String(activeOrgId);
        let workspacesList = $0505601246d7c320$var$shellStampWorkspaceListShape(activeOrgId ? workspacesAll.filter(inActiveOrg) : workspacesAll);
        // `claims.workspaces` exists ONLY in the governance JWT, so an SDK-only
        // session (OAuth, or any session before federation lands) carries NONE and
        // this list is routinely empty — and writing it into root wiped the real
        // list boot resolved from the SDK, which is why the workspace switcher
        // reported "no workspaces to load" and why the URL could not name a
        // workspace. An empty claims list is ABSENCE OF INFORMATION, not evidence
        // that the user has no workspaces: keep what root already holds. Mirrors
        // the same preserve-don't-clobber rule already applied to activeWorkspace.
        if (!workspacesList.length && Array.isArray(root.workspaces) && root.workspaces.length) workspacesList = activeOrgId ? root.workspaces.filter(inActiveOrg) : root.workspaces;
        if (activeWorkspace && !inActiveOrg(activeWorkspace)) {
            // Same preserve-don't-clobber rule as the two root.workspace branches
            // above; the live record keeps its own `_shape` provenance. A live
            // workspace that is itself foreign (genuine cross-org switch mid-
            // flight) fails `inActiveOrg` and still falls back to the list guess.
            // Rationale + reboot post-mortem on `preferLiveWorkspaceOnDrift`.
            activeWorkspace = $0505601246d7c320$export$5a700c6c87736f3a(root.workspace, $0505601246d7c320$var$shellStampWorkspaceShape(workspacesList[0] || null, 'list', {
                clone: false
            }), inActiveOrg);
            // ONE identity: the claim mirror must follow the workspace this tab just
            // RESOLVED. Leaving the foreign id in `active_workspace_id` kept every
            // claim-reading consumer (fetch scope, chat scoping, dashboard-prefs
            // pinning) on the OTHER org's workspace even though root.workspace was
            // already corrected — the /w/<slug> cross-tenant dashboard leak
            // (2026-07-27). nextActiveWs re-stamps too so the cursors below record
            // the converged id, not the drifted one.
            if (activeWorkspace?.id) {
                nextClaims.active_workspace_id = String(activeWorkspace.id);
                nextActiveWs = String(activeWorkspace.id);
            }
            // We fixed the CLIENT `workspace` above, but the JWT still carries an
            // `active_workspace_id` from a workspace in the PREVIOUS org. Server-side
            // org-scoped fetches that ignore client args resolve the org FROM THE
            // TOKEN — most importantly `users.members.list` (loadPrivateData's people
            // list) — so they keep returning the wrong org's members, leaving /people
            // and the team-and-agents canvas empty. setActiveOrganization does NOT
            // re-mint the token; switchOrg does. Guarded so it fires once per drifted
            // org (after the re-mint the token's workspace is in-org and this branch
            // stops matching → no loop).
            if (activeOrgId && nextSignedIn && _lastRemintedOrgId !== activeOrgId) {
                _lastRemintedOrgId = activeOrgId;
                const _sdk = $0505601246d7c320$var$shellGetSDK();
                if (_sdk && typeof _sdk.switchOrg === 'function') // WHITELABEL-STRICT-TENANT-SCOPE-1 — on a white-label host the
                // re-mint is THIS tab's lens onto the host's tenant: never persist it
                // to the account's stored active org (switchOrg PATCHes Mongo unless
                // told not to), or one visit to a customer's domain moves the
                // account's my.symbols tabs onto that customer's workspace.
                Promise.resolve((0, $lb2Ei.isCustomDomainHost)() ? _sdk.switchOrg(activeOrgId, {
                    skipPersist: true
                }) : _sdk.switchOrg(activeOrgId)).catch((err)=>{
                    console.warn('[auth] cross-org workspace token re-mint failed:', err?.message || err);
                });
            }
        }
        if (nextSignedIn) _armIdentityWatchdog(root);
        // SDK-only sessions (no governance JWT yet) carry ZERO workspaces in
        // claims → activeWorkspace stays null and every workspace-scoped read
        // (tickets list/counts/…) 400s with workspace_id_required, rendering
        // boards/feeds empty. Resolve the active org's workspaces straight from
        // the SDK once per org and seed root — the next tick's mirror block then
        // propagates the scope to the SDK context + storage.
        //
        // WS-AUTH-TICK-EMPTIES-WORKSPACES-1 — `!workspacesList.length` joined the
        // trigger: with claims carrying no list, the scoped derivation above can
        // legitimately come up EMPTY while the active WORKSPACE still resolves.
        // Branded host: boot seeds the MONGO active org's list, the host pin
        // scopes this tick to the brand org, `inActiveOrg` drops every row — and
        // the update below then writes `workspaces: []`. Gated on
        // `!activeWorkspace` alone, this fetch never ran (the workspace HAD
        // resolved), so nothing ever refilled the list: measured on
        // gita.pr.symbols.app — length 1 at boot, 0 after the tick, stable.
        // When the workspace is already resolved the fetch runs in LIST-ONLY
        // mode (`_wsListOnly`): it may fill `root.workspaces`, never converge
        // pointers — repointing the session because a LIST fetch answered would
        // let a list-membership blip switch the user's workspace.
        const _wsListOnly = !!activeWorkspace;
        if ((!activeWorkspace || !workspacesList.length) && nextSignedIn && activeOrgId && _wsListFetchedOrgId !== activeOrgId) {
            _wsListFetchedOrgId = activeOrgId;
            // Claim cursor at fetch time — the async resolve below compares against
            // it so a REAL switch that happened while the list was in flight is
            // never overwritten.
            const _tickWs = nextActiveWs;
            const _sdkW = $0505601246d7c320$var$shellGetSDK();
            if (_sdkW && typeof _sdkW.listWorkspaces === 'function') Promise.resolve(_sdkW.listWorkspaces({
                organization: activeOrgId
            })).then((res)=>{
                // Server shape: { data: { items, total, page, limit } } — the SDK
                // may pre-unwrap `data`, so resolve both forms.
                const rows = res && (res.items || res.data?.items || res.data || res.workspaces || res) || [];
                // WHITELABEL-STRICT-TENANT-SCOPE-1 — the ORG's list, narrowed to
                // the bound host's ONE workspace (identity on platform hosts), so
                // this fallback can never seed or converge onto a sibling
                // workspace the host does not serve.
                const list = $0505601246d7c320$var$shellScopeWorkspaceListToWhitelabelHost((Array.isArray(rows) ? rows : []).map((w)=>({
                        id: String(w._id || w.id || ''),
                        // `displayName` FIRST — see workspaceDisplayName's own
                        // comment in workspace-shared/functions/activeWorkspaceRecord.js.
                        name: $0505601246d7c320$var$shellWorkspaceDisplayName(w),
                        slug: w.slug,
                        type: w.type,
                        org_id: String(w.organization || activeOrgId),
                        role: w.role || 'member',
                        // List row — no `settings`. See
                        // tickets/spec-workspace-record-shape.md.
                        _shape: 'list'
                    })).filter((w)=>w.id), $0505601246d7c320$export$8bb20d34e8b438e9(root));
                if (!list.length) {
                    // Re-arm on a transient empty answer. This fallback is the ONLY
                    // workspace-scope source for a claims-less session (Supabase
                    // claims are gone server-side) — consuming the per-org latch on
                    // a blip left the session permanently scope-less: no
                    // activeWorkspaceId ever reached the SDK, every workspace-scoped
                    // read 400'd (workspace_id_required), and the identity chrome
                    // (name/avatar/org switcher) rendered empty with zero errors —
                    // Nika's 2026-07-30 my.symbols.app sign-in failure.
                    if (_wsListFetchedOrgId === activeOrgId) _wsListFetchedOrgId = null;
                    return;
                }
                if (_wsListOnly) {
                    // The workspace was already resolved when this fetch was
                    // dispatched — fill the LIST and stop. No pointer convergence,
                    // no claim mirror, no setActiveWorkspaceRecord, no module load:
                    // all of that describes the resolved WORKSPACE, which this
                    // fetch knows nothing about. Guards: the scope may have moved
                    // while the fetch was in flight (org switch, claims tick) —
                    // write only while the fetched org is still the resolved one —
                    // and never clobber a list a newer tick already filled.
                    const _stillScoped = String(root.jwtClaims?.workspace_org_id || '') === String(activeOrgId);
                    const _stillEmpty = !(Array.isArray(root.workspaces) && root.workspaces.length);
                    if (_stillScoped && _stillEmpty) root.update({
                        workspaces: list
                    });
                    return;
                }
                // Honor the chosen workspace (nextActiveWs — the LS pointer) when
                // it's in the freshly-fetched list; this is the path that resolves a
                // brand-new workspace missing from the JWT's claims.workspaces. Only
                // fall back to the org's hq / first when there's no valid choice.
                const hq = list.find((w)=>String(w.id) === String(nextActiveWs)) || list.find((w)=>w.type === 'hq') || list[0];
                // Mirror the scope IMMEDIATELY — the claims-tick mirror below only
                // runs on the next auth event, which may never come this session.
                try {
                    _sdkW.updateContext?.({
                        activeWorkspaceId: hq.id
                    });
                    $0505601246d7c320$var$shellSetActiveWorkspacePointer(hq.id);
                } catch (err) {
                    console.warn('[auth] workspaces fallback mirror failed:', err);
                }
                // Converge the CLAIM mirror + the workspace-change cursor to the
                // resolved workspace too. This async path runs outside any auth
                // tick, so without these the claim kept the drifted (possibly
                // foreign-org) id until the next token event — every claim-first
                // consumer (dashboard-prefs pinning, chat scoping, fetch scope)
                // read the wrong workspace for up to an hour, and the NEXT tick's
                // cursor comparison fired a spurious full workspace-change reload.
                const _claims = root.jwtClaims;
                const _claimStale = _claims && String(_claims.active_workspace_id || '') !== String(hq.id);
                root.update({
                    workspaces: list,
                    ..._claimStale ? {
                        jwtClaims: {
                            ..._claims,
                            active_workspace_id: String(hq.id)
                        }
                    } : {}
                });
                // Guarded setter, not a bare `workspace: hq` in the update above —
                // `hq` is list-shaped; if a full record for this SAME id is
                // already held (e.g. this fallback re-arms after a transient
                // failure and bootShell's fetch already landed), the setter
                // refuses the downgrade and the auto-scheduled fetch below is a
                // no-op cache hit. See tickets/spec-workspace-record-shape.md.
                $0505601246d7c320$var$shellSetActiveWorkspaceRecord(root, hq, {
                    reason: 'auth-tick:sdk-only-fallback',
                    sdk: _sdkW,
                    getWorkspaceCached: getWorkspaceCached
                });
                if (lastActiveWorkspaceId === _tickWs) lastActiveWorkspaceId = String(hq.id);
                // SDK-only sessions resolve their workspace HERE (no gov claims tick),
                // bypassing the initial-claim-landing branch below — so load the
                // module now too, else it'd wait for a manual reload just like the
                // federated path. Idempotent (see `_ensureWorkspaceModule`).
                _ensureWorkspaceModule(hq.id);
            }).catch((err)=>{
                // Re-arm — same reasoning as the empty-list branch above: a failed
                // fetch must not permanently consume the only scope source.
                if (_wsListFetchedOrgId === activeOrgId) _wsListFetchedOrgId = null;
                console.warn('[auth] SDK workspaces fallback failed:', err?.message || err);
            });
        }
        // Normalize `active_workspace_id` across auth providers — mirrors the
        // backfill in bootShell `_resolveAuthSnapshot` (keep the two in sync).
        // Google/OAuth users land in the sdk_only state where the governance
        // claim is empty, so `nextClaims.active_workspace_id` is '' and the
        // home's `_wsScope` keys its dashboard cache to a DIFFERENT scope
        // ('default') than email/password users — same user, different home
        // (#auth-provider-home-diff). Backfill from the resolved workspace or
        // the canonical localStorage pointer so every provider resolves the
        // same scope. Done before claimsKey/mirror so the change propagates and
        // a later identical tick stays a no-op.
        if (!nextClaims.active_workspace_id) {
            let lsActiveWs = '';
            try {
                lsActiveWs = $0505601246d7c320$var$shellGetActiveWorkspacePointer() || '';
            } catch (_) {
                lsActiveWs = '';
            }
            const normalizedWs = activeWorkspace && activeWorkspace.id || lsActiveWs || '';
            if (normalizedWs) nextClaims.active_workspace_id = normalizedWs;
        }
        // Mirror the resolved active workspace into the SDK's ambient context +
        // the persisted `activeWorkspace` storage key, so workspace-scoped reads
        // (tickets list/counts/resolutions — workspaceId REQUIRED since
        // server@ba9e0d8f) resolve their scope without every caller threading the
        // id. Light touch: updateContext only — NOT sdk.switchWorkspace (no
        // federation round-trip, no claims invalidation).
        if (activeWorkspace?.id) {
            const _sdkWs = $0505601246d7c320$var$shellGetSDK();
            if (_sdkWs && _sdkWs._context?.activeWorkspaceId !== activeWorkspace.id) {
                _sdkWs.updateContext?.({
                    activeWorkspaceId: activeWorkspace.id
                });
                try {
                    $0505601246d7c320$var$shellSetActiveWorkspacePointer(activeWorkspace.id);
                } catch (err) {
                    console.warn('[auth] activeWorkspace persist failed:', err);
                }
            }
        }
        // Drift self-heal: when the resolver picks an id different from
        // Mongo's `User.activeOrganization`, persist it. Without this,
        // Mongo stays stale (e.g. zachary@symbols.app pointing at a
        // personal org that has no governance backing → UI displays the
        // fallback `Symbols System` with a checkmark, but the server's
        // ReleaseController._getOrg / AnalyzedReadService._resolveWorkspaceId
        // both read Mongo and scope to the stale personal org → empty
        // page). The OrgSwitcher click path already calls
        // setActiveOrganization for explicit picks (`_pendingActiveOrgId`
        // matches), so skip in that case to avoid a redundant PATCH race.
        const usedPending = root?._pendingActiveOrgId && root._pendingActiveOrgId === activeOrgId;
        // Require an actual Mongo user object before firing the PATCH — the
        // heal only makes sense when we KNOW we have a Mongo user record (the
        // thing whose `activeOrganization` we're trying to update). Without
        // this guard, a not-fully-authed tick (no /auth/me response yet, or
        // token rejected by the current env) would fire
        // PATCH /auth/me/active-org → 401 in the network console.
        const driftHeal = !!u && nextSignedIn && activeOrgId && activeOrgId !== mongoActiveOrgId && activeOrgId !== lastHealedActiveOrgId && !usedPending && // Only heal on a trustworthy membership list (never a gov-only fallback
        // guess). Still heals #2238 — the team org is in user.organizations.
        $0505601246d7c320$export$a767f9f5069cb25f(u) && // WHITELABEL-STRICT-TENANT-SCOPE-1 — a white-label host's org is the
        // HOST's binding, not a drift of the account's choice: "healing" it
        // would PATCH the stored active org to the customer's org from their
        // domain. The stored choice belongs to the platform host.
        !(0, $lb2Ei.isCustomDomainHost)();
        if (driftHeal) {
            // Mark BEFORE the async call so concurrent ticks don't double-fire.
            // On failure we deliberately do NOT clear this — a 403 / network
            // wedge would otherwise infinitely retry against every claim
            // tick. Sign-in / sign-out resets clear it for the legit retry
            // paths (different user, fresh session).
            lastHealedActiveOrgId = activeOrgId;
            Promise.resolve($0505601246d7c320$var$shellGetSDK().setActiveOrganization(activeOrgId)).catch((err)=>{
                console.warn('[auth] active-org self-heal failed:', err?.message || err);
            });
        }
        // `workspace` is deliberately NOT in either `root.update` call below — it
        // goes through `setActiveWorkspaceRecord` instead, which is the ONLY
        // thing allowed to write `root.workspace` post-mount. A bare
        // `root.update({ workspace: activeWorkspace })` here is exactly the bug
        // tickets/spec-workspace-record-shape.md fixes: `activeWorkspace` is
        // frequently list-shaped (JWT claims row, no `settings`) and would
        // silently downgrade a full record bootShell already resolved for the
        // same id. The setter accepts `null` too (explicit sign-out / no-match
        // clear — same as the old unconditional overwrite in that case).
        //
        // WARM BOOT: while `_bootFromCache` is true the root holds the snapshot's
        // LIST placeholder and bootShell's `boot-warm-reconcile` is about to
        // write the composite boot's FULL record. Handing the setter the same
        // list row here started its list->full upgrade — one GET
        // /core/workspaces/:id for a record the boot already answered (measured
        // on dev deploy 27, BOOT-AFTER.md). Leave that write to the reconcile;
        // index.js converges whatever is still list-shaped once bootShell returns
        // (functions/convergeBootWorkspace.js). A DIFFERENT workspace, or a full
        // row, still goes through the setter.
        const _wsIdOf = (w)=>w ? String(w.id || w._id || '') : '';
        const _warmPlaceholderHeld = root._bootFromCache === true && !!activeWorkspace && activeWorkspace._shape !== 'full' && !!root.workspace && root.workspace._shape !== 'full' && _wsIdOf(root.workspace) === _wsIdOf(activeWorkspace);
        if (userChanged) {
            root.update({
                signedIn: nextSignedIn,
                currentUserEmail: nextEmail,
                currentUserId: nextId,
                currentUserUsername: nextUsername,
                currentUserSupabaseId: nextSupabaseId,
                jwtClaims: nextClaims,
                orgs: orgsList,
                workspaces: workspacesList,
                org: activeOrg
            });
            if (!_warmPlaceholderHeld) $0505601246d7c320$var$shellSetActiveWorkspaceRecord(root, activeWorkspace, {
                reason: 'auth-tick:userChanged',
                sdk: $0505601246d7c320$var$shellGetSDK(),
                getWorkspaceCached: getWorkspaceCached
            });
            lastClaimsKey = claimsKey;
        } else if (nextSignedIn && claimsChanged) {
            root.update({
                jwtClaims: nextClaims,
                orgs: orgsList,
                workspaces: workspacesList,
                org: activeOrg
            });
            if (!_warmPlaceholderHeld) $0505601246d7c320$var$shellSetActiveWorkspaceRecord(root, activeWorkspace, {
                reason: 'auth-tick:claimsChanged',
                sdk: $0505601246d7c320$var$shellGetSDK(),
                getWorkspaceCached: getWorkspaceCached
            });
            lastClaimsKey = claimsKey;
        }
        if (nextId && nextId !== lastUserId) {
            // New sign-in: fire onSignIn and record the starting workspace.
            lastUserId = nextId;
            lastUserEmail = nextEmail;
            lastActiveWorkspaceId = nextActiveWs;
            // Reset the drift-heal cache so a different user signing into
            // the same tab can heal their own activeOrganization on first tick.
            lastHealedActiveOrgId = null;
            _lastRemintedOrgId = null;
            if (typeof onSignIn === 'function' && !_loadInFlight) {
                const signInLoad = {};
                _loadInFlight = signInLoad;
                // Carry the FULL session user through — the tick already holds it
                // (getSession / onAuthStateChange payload, no network), so consumers
                // like the telemetry identify don't have to re-fetch /auth/me for
                // traits the boot fetched seconds ago (a measured 1.7s duplicate
                // mid-boot, tickets/workspace.md boot ticket #3).
                Promise.resolve(onSignIn({
                    id: nextId,
                    email: nextEmail,
                    user: u || null
                })).finally(()=>{
                    if (_loadInFlight === signInLoad) _loadInFlight = null;
                });
            }
        } else if (nextId && $0505601246d7c320$export$aeacd7eff53dd464(nextActiveWs, lastActiveWorkspaceId)) {
            // Same user, workspace claim changed. Distinguish two cases:
            //   1. The governance bridge JWT landed AFTER `onSignIn` already
            //      ran (empty → 'X'). `loadPrivateData` is mid-flight against
            //      the same workspace, so a second pipeline here would
            //      duplicate every fetch (people, announcements, stories,
            //      loadAllTeams fan-out, …). Only update the cursor.
            //   2. The user actively switched orgs in another tab/device
            //      ('X' → 'Y'). That IS a re-hydration trigger — fire
            //      `onWorkspaceChange` so workspace-scoped tables refresh
            //      without a full page reload.
            const isInitialClaimLanding = !lastActiveWorkspaceId;
            lastActiveWorkspaceId = nextActiveWs;
            if (!isInitialClaimLanding && !_loadInFlight && typeof onWorkspaceChange === 'function') onWorkspaceChange(nextClaims);
            else if (isInitialClaimLanding) // onSignIn (loadPrivateData) already ran with an EMPTY workspace (the
            // gov JWT hadn't landed yet), so its loadWorkspaceProject call no-op'd
            // and the workspace MODULE never injected. Now that the workspace claim
            // has landed and `root.workspace` is resolved (set by the root.update
            // above), load the module — the piece that previously required a manual
            // reload. Idempotent (see `_ensureWorkspaceModule`).
            _ensureWorkspaceModule(activeWorkspace?.id || nextActiveWs);
            else if (_loadInFlight) {
                // The workspace claim CORRECTED ITSELF (cross-org drift swap above, a
                // stale ?ws=/pointer resolving, a re-mint landing) while the boot's
                // loadPrivateData is still mid-flight. The full onWorkspaceChange
                // re-hydration is deliberately suppressed (it would duplicate every
                // in-flight boot fetch) — but the MODULE load for the corrected
                // workspace must not be dropped with it: the boot chain already ran
                // loadWorkspaceProject against the PREVIOUS (wrong) workspace, the
                // cursor above has advanced, and no later tick will re-fire this
                // branch — the corrected workspace's module (navbar/pages/widgets/
                // seeds) stayed unloaded for the whole session (GreenIG cold-boot
                // "widgets empty" bug). _ensureWorkspaceModule is wsId-keyed +
                // seq-deduped, so this is a cheap no-op whenever the boot chain DID
                // load the right module.
                _ensureWorkspaceModule(activeWorkspace?.id || nextActiveWs);
                // WS-COLD-BOOT-IDENTITY-CORRECTION-KEEPS-PROVISIONAL-WORKSPACE-ROWS-1
                // — a BUILT-IN page mounted during the provisional window (History,
                // /admin/logs, /admin/usage) already read against the WRONG id and
                // will not read again on its own: each only listens for
                // `onActiveWorkspaceFull` while it has no id at all. Tell every such
                // loader the identity just corrected so it re-scopes to the real one.
                // NOT `onActiveWorkspaceFull` itself — a deliberate switch already
                // fires that one and re-hydrates its own mounted surfaces (PHASE 2);
                // reusing it here would read them twice on every deliberate switch.
                $0505601246d7c320$var$shellNotifyWorkspaceIdentityCorrected(root, activeWorkspace);
            }
        } else if (!nextId) {
            lastUserId = null;
            lastUserEmail = null;
            lastActiveWorkspaceId = null;
            lastHealedActiveOrgId = null;
            _lastRemintedOrgId = null;
            // Re-arm the post-sign-in module load so a re-sign-in in this tab reloads
            // the workspace module (onWorkspaceChange owns the org-switch path).
            _moduleLoadedForWsId = null;
        }
    };
    // The SDK proxy in shared/functions/sdk.js wraps method calls so they
    // auto-await SDK init — `getSDK().onAuthStateChange(cb)` therefore
    // returns Promise<unsub> instead of a sync unsub. Use a cancel-token
    // shim so callers (workspace-project app onCreate) can safely call
    // the returned unsub from onRemove without storing a Promise.
    let unsub = null;
    let cancelled = false;
    // PERF-1: dedup double-boot-fetch guard. Both `sdk.onAuthStateChange`
    // and the manual `sdk.getSession()` prime below resolve concurrently on
    // a warm boot (stored token). Without coordination, both calls reach the
    // `nextId !== lastUserId` check before either has set `lastUserId = nextId`
    // — so BOTH fire `onSignIn` → `loadPrivateData` runs twice, doubling
    // every boot fetch. Track whether the live auth-state subscription has
    // already delivered a non-empty userId so the manual prime becomes a
    // no-op on warm boots while still covering the cold-JWT path (expired
    // gov token, no INITIAL_SESSION event).
    let _authStateDelivered = false;
    const _trackingHandler = (_event, session)=>{
        if (session?.user?.id || session?.user?._id) _authStateDelivered = true;
        return handler(_event, session);
    };
    const sdk = $0505601246d7c320$var$shellGetSDK();
    Promise.resolve(sdk.onAuthStateChange(_trackingHandler)).then((sub)=>{
        if (cancelled) {
            if (typeof sub === 'function') try {
                sub();
            } catch (_) {}
            return;
        }
        unsub = typeof sub === 'function' ? sub : null;
    }).catch(()=>{});
    // Initial-session priming.
    //
    // The SDK's onAuthStateChange keeps its legacy event contract — it does
    // NOT replay an `INITIAL_SESSION` event for callers who subscribe after
    // the SDK has already booted. When the session was already live before
    // this subscriber registered, no auth event ever fires, so the handler
    // never runs and `root.currentUserEmail` stays
    // empty. That left WeekView / TeamView grids rendering zero events
    // because they filter by `ev.googleCalendarId === root.currentUserEmail`.
    //
    // Synchronously prime the handler with whatever the SDK already knows
    // about the active session. Safe to call even when nothing's signed in —
    // the handler treats `session?.user == null` as a no-op via its
    // `userChanged` diff (lastUserId starts null, nextId stays '').
    //
    // PERF-1: skip the manual prime when `onAuthStateChange` already fired
    // with a live user — the auth-state subscription is authoritative on
    // warm boots and a second handler invocation races to fire `onSignIn`
    // a second time (both see lastUserId===null before either writes it).
    // We use a 0-delay microtask yield to let any synchronously-resolved
    // `onAuthStateChange` callbacks land first; the check is then accurate
    // for all synchronous SDK implementations. For truly async SDKs where
    // `onAuthStateChange` won't fire before the microtask, `_authStateDelivered`
    // is still false → we fall through and prime normally (the cold-JWT path).
    Promise.resolve().then(()=>sdk.getSession()).then((session)=>{
        if (cancelled) return;
        if (_authStateDelivered) return;
        try {
            handler('INITIAL_SESSION', session);
        } catch (err) {
            console.warn('[auth] initial-session prime failed:', err?.message || err);
        }
    }).catch(()=>{});
    return ()=>{
        cancelled = true;
        if (typeof unsub === 'function') try {
            unsub();
        } catch (_) {}
    };
};
const $0505601246d7c320$export$1509ad863a77c4a4 = async function(_email, _password) {
    // The SDK login upstream already established the session; return it in the
    // legacy-shaped envelope existing callers expect. (The old governance
    // federation `loginAll` hop was a no-op once federation was disabled and is
    // gone with the removed governance auth plane.)
    const session = await $0505601246d7c320$var$shellGetSDK().getSession();
    return {
        data: {
            user: session?.user || null,
            session: session || null,
            projects: []
        },
        error: null
    };
};

});
parcelRegister("1jHTS", function(module, exports) {

$parcel$export(module.exports, "isDemoHost", () => $0f599e7561d958be$export$7b98aa18d5d22832);
// Hostname gate for the demo shell.
//
// The workspace shell serves my.symbols.app for real, signed-in users AND
// demo.symbols.app / dev.demo.symbols.app for unauthed visitors who want a
// live tour. The ONLY difference is the auth bounce: on a demo host an
// unauthed visitor lands on the branded `/demo` email-gate instead of the
// real /login. `isDemoHost()` is the single signal that switches that
// behavior — read by `redirectIfUnauthed` (auth.js) and the shell entry.
//
// SSR-guarded (returns false when there's no `window`) and dependency-free so
// it's safe to call at module-load time during the initial parse, before any
// component mounts.
//
// Local simulation (no DNS needed): set `localStorage.symbols_force_demo='1'`
// (persists across reloads) OR append `?demo=1` to any URL (one visit). Either
// makes the shell behave exactly as it would on demo.symbols.app.
const $0f599e7561d958be$export$7b98aa18d5d22832 = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        // Real demo hostnames — matches BOTH `demo.symbols.app` and the dev
        // subdomain `dev.demo.symbols.app` (the `(^|\.)` prefix covers any
        // leading label, anchored to `.demo.symbols.app` at the end).
        const host = window.location.hostname || '';
        if (/(^|\.)demo\.symbols\.app$/.test(host)) return true;
        // Test overrides — let any host simulate the demo gate locally.
        if (window.localStorage.getItem('symbols_force_demo') === '1') return true;
        if ((window.location.search || '').includes('demo=1')) return true;
    } catch (_) {
    // localStorage / location may throw in sandboxed contexts — treat as
    // "not a demo host" so production my.symbols.app is never gated by accident.
    }
    return false;
};

});

parcelRegister("gNttC", function(module, exports) {

$parcel$export(module.exports, "setHostScopeOrgId", () => $c3a8166c45231318$export$c1be3bb8d8fb58a);
$parcel$export(module.exports, "getHostScopeOrgId", () => $c3a8166c45231318$export$c8705a1d3ef93c29);
// ── hostScopePin.js — "this tab is on a customer's own domain" ────────────
//
// WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1, the THIRD defect: the switchOrg
// race. Measured on work.astio.ai as 4 wrong of 8 loads before any fix, and
// still 1 wrong of 5 after the structural fix shipped as 78f9fe5bb.
//
// THE RACE. On a white-label host with the MWT flag off, TWO un-awaited
// writers state an org into the same SDK context on the same tick:
//   · customDomainBoot's pinned path — sdk.switchOrg(<the HOST's org>,
//     { skipPersist: true }), which is correct for this tab; and
//   · auth.js's drift-correction re-mint — sdk.switchOrg(<the MONGO/claim
//     active org>), which is the org my.symbols last used and is correct
//     everywhere EXCEPT here.
// Neither awaits the other, so whichever settles last wins, and the customer
// sees another tenant's workspace under their own domain about a third of the
// time. That is the exact class WHITELABEL-1 exists to prevent.
//
// WHY A STAND-DOWN AND NOT AN ORDERING. Three options were on the table.
// Sequencing the boot after auth, and re-asserting the pin after the re-mint,
// BOTH still let auth write the wrong org first — so the wrong tenant is
// briefly VISIBLE, and on a customer's branded domain a visible wrong tenant
// IS the defect, not a transient. Only standing auth down never writes the
// wrong value at all. relman made this argument and it is the deciding one.
//
// WHY ITS OWN MODULE. auth.js must read this pin, and customDomainBoot.js
// must write it. Importing customDomainBoot from auth would couple the auth
// tick to the whole boot ladder (and to `_wsShared`) for one string. Same
// reason whitelabelBrand.js sits beside customDomainBoot rather than inside
// it. A leaf module with no imports also stays trivially testable.
// Module-level, not on `window`: this is per-DOCUMENT state and must not be
// reachable by, or shared with, anything outside the bundle. It is also NOT
// persisted — the pin is re-derived from the hostname on every load, so a
// stale pin cannot outlive the page that earned it.
let $c3a8166c45231318$var$_hostScopeOrgId = null;
const $c3a8166c45231318$export$c1be3bb8d8fb58a = (orgId)=>{
    $c3a8166c45231318$var$_hostScopeOrgId = orgId ? String(orgId) : null;
};
const $c3a8166c45231318$export$c8705a1d3ef93c29 = ()=>$c3a8166c45231318$var$_hostScopeOrgId;
const $c3a8166c45231318$export$6843949e806db4ea = ()=>{
    $c3a8166c45231318$var$_hostScopeOrgId = null;
};

});

parcelRegister("iJIxS", function(module, exports) {

$parcel$export(module.exports, "withLiveQuery", () => $da3efbbf6df33b8b$export$40d5b7467a62dc5b);
$parcel$export(module.exports, "queryHashTail", () => $da3efbbf6df33b8b$export$d47955cebdb9df5b);
// bootRedirectQuery.js — preserve the live query string + hash across the
// shell's boot-time / SPA-nav bounce-to-'/' redirects.
//
// tickets/opus.md "the router STRIPS the query string during boot redirect"
// — root cause: `window.location.pathname` never carries `?…`/`#…`, so any
// redirect that rebuilds its target purely from pathname silently drops
// every query param (the analyze-debug lever `?analyze=debug`, a claim flow
// `?claim=credits`, anything hand-appended for repro). Confirmed against the
// smbls router plugin (smbls/plugins/router/index.js `router()`): the
// target path handed to `el.router(...)` is parsed with
// `new URL(origin + path)` and `search`/`hash` are read straight off that
// parse, then threaded into both `state.query` and the `pushState` URL — so
// a query-bearing path round-trips correctly with no extra history re-apply
// step needed. `el.router()` DOES accept (and preserve) a query-bearing
// path; it just has to be GIVEN one.
//
// There were THREE call sites in this package rebuilding a bare `'/'` on a
// boot/session bounce, all fixed the same way (see functions/
// bootRedirectQuery.test.js for the acceptance shape of each):
//   • app.js `_leaveModuleRouteForSwitch` — module-route leave on tenant
//     switch (`el.router('/', el)`).
//   • app.js `_guardDemoRoute` — the reactive demo-lockdown fallback
//     (`el.router('/', el.getRoot())`).
//   • functions/demoRouteGuard.js `demoRouteGuard` — the pre-mount smbls
//     router GUARD (returns a redirect STRING, not an `el.router()` call —
//     same bug class, different shape, so it reattaches `query`/`hash` from
//     its own `guardContext` instead of `window.location`).
// Used by the two `el.router()` call sites — reads the OUTGOING (current)
// window location, since the navigation target is a bare `'/'` and the
// query/hash being preserved is whatever the visitor already had on the
// address bar.
const $da3efbbf6df33b8b$export$40d5b7467a62dc5b = (path, win = typeof window !== 'undefined' ? window : null)=>{
    if (!win?.location) return path;
    return path + (win.location.search || '') + (win.location.hash || '');
};
const $da3efbbf6df33b8b$export$d47955cebdb9df5b = (query, hash)=>{
    const qs = query && Object.keys(query).length ? '?' + new URLSearchParams(query).toString() : '';
    return qs + (hash || '');
};

});

parcelRegister("jZ5ZE", function(module, exports) {

$parcel$export(module.exports, "beginDataLoad", () => $e8c85d000cc7c6c2$export$8d30e891c453caff);
$parcel$export(module.exports, "endDataLoad", () => $e8c85d000cc7c6c2$export$4b5c0a90ed16927c);
$parcel$export(module.exports, "beginPostAuthWorkspaceReveal", () => $e8c85d000cc7c6c2$export$114e4498dfc6aa82);
$parcel$export(module.exports, "endPostAuthWorkspaceReveal", () => $e8c85d000cc7c6c2$export$6a224fdb8fa20cab);
$parcel$export(module.exports, "endDataLoadFailsafe", () => $e8c85d000cc7c6c2$export$bb633b0d6435d6a4);
$parcel$export(module.exports, "_person", () => $e8c85d000cc7c6c2$export$f65a76329791bc8a);
$parcel$export(module.exports, "_dashboardPrefsFetches", () => $e8c85d000cc7c6c2$export$5dd6614217005c03);
$parcel$export(module.exports, "registerWorkspaceConfigConverge", () => $e8c85d000cc7c6c2$export$59bf87e5615462ae);
$parcel$export(module.exports, "loadPrivateData", () => $e8c85d000cc7c6c2$export$e3141ac8004c427e);
$parcel$export(module.exports, "scopeGen", () => $e8c85d000cc7c6c2$export$254ef76a6207537d);
$parcel$export(module.exports, "scopeStale", () => $e8c85d000cc7c6c2$export$ca6d91143d80876a);
$parcel$export(module.exports, "endWorkspaceSession", () => $e8c85d000cc7c6c2$export$70f2175d97f1a1d8);
$parcel$export(module.exports, "onWorkspaceChange", () => $e8c85d000cc7c6c2$export$430bd0b9e6ef441d);
$parcel$export(module.exports, "retryWorkspaceActivation", () => $e8c85d000cc7c6c2$export$e2ce85a0cbd4d3ae);
$parcel$export(module.exports, "awaitInitialWorkspace", () => (parcelRequire("6QCFv")).awaitInitialWorkspace);
$parcel$export(module.exports, "hasAuthoritativeWorkspace", () => (parcelRequire("6QCFv")).hasAuthoritativeWorkspace);
// Workspace-project private-data loader.
//
// Drives the workspace-project app's data hydration in response to auth
// transitions. Extracted from the app.js root onCreate closure because
// the smbls 3.14 auto-router mounts page DOMQL components directly into
// `Slot` from the shell's pages registry — the workspace-project wrapper
// never instantiates, so its `onCreate` never fires. The shell's
// `subscribeAuthSession` runs these callbacks instead. Kept as plain
// functions (not lifecycle hooks) so either entry point — shell auth
// subscription or sub-app onCreate when run standalone — can invoke them.
//
// `loadPrivateData` runs once per sign-in transition and hydrates
// people/teams/roles/userDocs/userPrefs + financials. `onWorkspaceChange`
// runs when the JWT's `active_workspace_id` flips for the same user
// (org switch); it re-fetches workspace-scoped tables in place + rebinds
// realtime channels so the UI never has to full-page-reload.
// Module-level in-flight guard. JS single-threaded execution model makes
// the check-then-set atomic — no microtask race possible regardless of how
// the caller schedules the invocation (onAuthStateChange callback, getSession
// prime, or direct call from a page onCreate). This closes vector 4 of the
// WORKSPACE-PERF-1 series: _authStateDelivered in auth.js still had a
// microtask-ordering race where initPromise.then(onAuthStateChange) and
// initPromise.then(getSession) resolve in the same tick but onAuthStateChange
// fires through a nested async chain, leaving _authStateDelivered false when
// the getSession prime's check runs and allowing a second loadPrivateData to
// start concurrently. The call-site guards in auth.js are left in place for
// defense-in-depth — they cost nothing and catch races at the dispatch layer.
parcelRequire("8BRyL");
var $aGIjc = parcelRequire("aGIjc");

var $dp7M8 = parcelRequire("dp7M8");

var $ik7KJ = parcelRequire("ik7KJ");

var $kosYS = parcelRequire("kosYS");

var $14aeZ = parcelRequire("14aeZ");

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $6QCFv = parcelRequire("6QCFv");

var $df0As = parcelRequire("df0As");

var $ly0mS = parcelRequire("ly0mS");

var $5Vf2y = parcelRequire("5Vf2y");

var $lb2Ei = parcelRequire("lb2Ei");

var $cKmtB = parcelRequire("cKmtB");

var $g7CNh = parcelRequire("g7CNh");

var $7ytvD = parcelRequire("7ytvD");

var $1gcj7 = parcelRequire("1gcj7");

var $7muxD = parcelRequire("7muxD");

var $2Od7Q = parcelRequire("2Od7Q");

var $7nvlv = parcelRequire("7nvlv");

var $1OhIx = parcelRequire("1OhIx");

var $fJThD = parcelRequire("fJThD");

var $kg2OA = parcelRequire("kg2OA");

var $jn5Js = parcelRequire("jn5Js");

var $bShA0 = parcelRequire("bShA0");

var $caKf8 = parcelRequire("caKf8");

var $2rYsV = parcelRequire("2rYsV");

var $gXXSj = parcelRequire("gXXSj");

var $4CrGc = parcelRequire("4CrGc");
let $e8c85d000cc7c6c2$var$_shellLoadInFlight = null;
let $e8c85d000cc7c6c2$var$_bootLoadGeneration = 0;
let $e8c85d000cc7c6c2$var$_bootRevealBudgetMs = 7000;
const $e8c85d000cc7c6c2$export$fd11d6a04b3a7351 = (ms)=>{
    $e8c85d000cc7c6c2$var$_bootRevealBudgetMs = ms;
};
// Scope fingerprint captured when the running pass started + a one-slot rerun
// queue. A changed scope needs a corrected pass, and a same-scope replacement
// root needs its OWN hydration. Retain the latest caller and its loader epoch;
// a newer workspace switch or reveal owner cancels that pending handoff.
let $e8c85d000cc7c6c2$var$_loadScopeAtStart = null;
let $e8c85d000cc7c6c2$var$_loadRerunQueued = null;
// _dataLoading OWNERSHIP EPOCH (BOOT-RESHUFFLE F3). The flag is raised by three
// independent drivers — boot loadPrivateData, the org/workspace-switch handlers
// (app.js), and onWorkspaceChange — but was cleared unconditionally by
// whichever finished first: the boot pass's `finally` routinely dropped the
// MainLoader in the middle of an org-switch teardown, revealing half-wiped UI
// (the "multiple refreshes" landing). Every raise bumps the epoch; a clear is
// honored only while its epoch is still the newest raise. The inverse wedge
// (supersession early-returns leaving the flag true forever, wedging the home
// grid's 120s init gate) is covered by the same invariant: whichever run
// raised last is the one whose clear path runs.
let $e8c85d000cc7c6c2$var$_dataLoadEpoch = 0;
let $e8c85d000cc7c6c2$var$_dataLoadClearedFor = 0;
// Queue acceptance needs to distinguish a switch on the old shell from a
// switch that already owns the queued root. Weak keys retain no removed roots.
// Clears still use the existing global epoch contract below.
const $e8c85d000cc7c6c2$var$_dataLoadEpochByRoot = new WeakMap();
const $e8c85d000cc7c6c2$export$8d30e891c453caff = (root, patch = {})=>{
    const epoch = ++$e8c85d000cc7c6c2$var$_dataLoadEpoch;
    try {
        $e8c85d000cc7c6c2$var$_dataLoadEpochByRoot.set(root, epoch);
        root.update({
            _dataLoading: true,
            ...patch
        });
    } catch (_) {
    /* torn down mid-raise */ }
    return epoch;
};
const $e8c85d000cc7c6c2$export$4b5c0a90ed16927c = (root, epoch, patch = {})=>{
    if (epoch !== $e8c85d000cc7c6c2$var$_dataLoadEpoch) return false;
    if ($e8c85d000cc7c6c2$var$_dataLoadClearedFor === epoch) {
        // Idempotent per epoch — a safety-net clear after the real reveal must not
        // re-dispatch `_dataLoading:false`; still deliver any patch keys.
        if (Object.keys(patch).length) try {
            root.update(patch);
        } catch (_) {}
        return true;
    }
    $e8c85d000cc7c6c2$var$_dataLoadClearedFor = epoch;
    try {
        root.update({
            _dataLoading: false,
            ...patch
        });
    } catch (_) {
    /* torn down mid-clear */ }
    return true;
};
// A first sign-in can receive the SDK session before the workspace claim/list
// arrives. auth.js owns the short post-claim module/apps/config + dashboard-prefs
// reconciliation for that case. Keep it in the SAME loader epoch as the
// initial private-data pass, so the shell never reveals a default workspace and
// then visibly repaints it once the real workspace arrives.
//
// The marker is module-private (rather than another reactive root key): it is
// coordination metadata, not user-visible state. The full-record listener
// below uses it to avoid launching a competing config-converge pass while the
// post-auth reconciliation already owns that exact workspace.
//
// PLAIN top-level functions + a module-scope WeakMap, NOT the coordinator
// factory's bound closure. `createPostAuthWorkspaceRevealCoordinator` (below,
// still exported for `initialWorkspaceReveal.test.js`'s dependency-injected
// unit test) returns `begin`/`isActive`/`end` closures over ITS OWN
// `beginDataLoad`/`endDataLoad` parameters — and once those closures are
// individually reachable (`beginPostAuthWorkspaceReveal` etc., referenced from
// auth.js's `subscribeAuthSession`), frank auto-lifts them into `globalScope`
// standalone. A lifted closure cannot resolve a factory PARAMETER at revival —
// renaming the parameter (`_beginDataLoad`/`_endDataLoad`, tried previously)
// only changes which name fails to resolve, not whether it resolves. Measured
// on the current gate: `globalScope.beginPostAuthWorkspaceReveal` /
// `globalScope.endPostAuthWorkspaceReveal` both threw ReferenceError on
// every first-sign-in reveal at a frank-served runtime. Calling this file's
// OWN top-level `beginDataLoad`/`endDataLoad` directly (same identifiers
// `onWorkspaceChange` already calls successfully, no injection) removes the
// captured-parameter free variable entirely.
const $e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending = new WeakMap();
const $e8c85d000cc7c6c2$var$_dashboardPrefsReads = new WeakMap();
const $e8c85d000cc7c6c2$export$114e4498dfc6aa82 = (root, workspaceId)=>{
    if (!root || !workspaceId) return null;
    const id = String(workspaceId);
    const held = $e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending.get(root);
    if (held && held.workspaceId === id) return held;
    const token = {
        workspaceId: id,
        epoch: $e8c85d000cc7c6c2$export$8d30e891c453caff(root),
        timer: null
    };
    $e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending.set(root, token);
    (0, $7ytvD.updateWorkspaceActivation)(root, 'reconcile', {
        state: 'loading'
    });
    token.timer = setTimeout(()=>{
        if ($e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending.get(root) !== token || token.epoch !== $e8c85d000cc7c6c2$var$_dataLoadEpoch) return;
        // This raise is still the NEWEST, so nobody else can clear the flag: an org
        // switch that moved the workspace meanwhile raised EARLIER and had its own
        // clear refused. Release our claim whatever workspace is current — the old
        // early return left the loader up for good (dev 2026-09-29, /aihouse/site
        // at 390 px). Only the "still loading" notice is scoped to the workspace
        // this reveal was for.
        if (String(root.workspace?.id || root.workspace?._id || '') === id) (0, $7ytvD.updateWorkspaceActivation)(root, 'reconcile', {
            state: 'slow'
        });
        $e8c85d000cc7c6c2$export$4b5c0a90ed16927c(root, token.epoch);
    }, $e8c85d000cc7c6c2$var$_bootRevealBudgetMs);
    token.timer?.unref?.();
    return token;
};
const $e8c85d000cc7c6c2$export$d65e4ac87a9be3f4 = (root, workspaceId)=>{
    const held = root && $e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending.get(root);
    return !!held && held.workspaceId === String(workspaceId || '');
};
const $e8c85d000cc7c6c2$export$6a224fdb8fa20cab = (root, token)=>{
    if (!root || !token || $e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending.get(root) !== token) return false;
    $e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending.delete(root);
    clearTimeout(token.timer);
    if (String(root.workspace?.id || root.workspace?._id || '') === token.workspaceId) (0, $7ytvD.updateWorkspaceActivation)(root, 'reconcile', {
        state: 'ready'
    });
    return $e8c85d000cc7c6c2$export$4b5c0a90ed16927c(root, token.epoch);
};
const $e8c85d000cc7c6c2$export$bb633b0d6435d6a4 = (root)=>$e8c85d000cc7c6c2$export$4b5c0a90ed16927c(root, $e8c85d000cc7c6c2$var$_dataLoadEpoch);
// Boot-phase telemetry — performance marks/measures so a slow boot NAMES its
// slow phase instead of being one opaque 30s spiral. Read them in the console
// (or a QA run) via performance.getEntriesByType('measure') filtered on
// 'wsboot:'. Guarded: no-ops wherever the Performance API is absent.
const $e8c85d000cc7c6c2$var$_mark = (name)=>{
    try {
        if (typeof performance !== 'undefined') performance.mark(name);
    } catch (_) {
    /* telemetry only */ }
};
const $e8c85d000cc7c6c2$var$_measure = (name, from, to)=>{
    try {
        if (typeof performance !== 'undefined') performance.measure(name, from, to);
    } catch (_) {
    /* telemetry only */ }
};
// Supersession guard for onWorkspaceChange. Switches are fire-and-forget AND
// dual-triggered (sdk.orgSwitched rootBus + the auth subscription's
// active_workspace_id change), each running a multi-second async refetch.
// Without a generation guard an OLDER switch's late writes land after a NEWER
// switch and win — the "switched to B, still showing A" bug. Every run captures
// a generation; once a newer run starts, the older run stops writing and cedes
// the loader.
let $e8c85d000cc7c6c2$var$_wsChangeGen = 0;
// FABLE P1 (2026-08-10) — `_dataLoading` permanently stuck true after a
// cross-org switch, root-caused. onWorkspaceChange's own pipeline awaits a
// chain of real network calls (getWorkspaceCached → sdk.getWorkspace,
// listOrgMembers, loadAllTeams, loadWorkspaceProject's settings fetch, the
// dashboard-prefs batch) with NO per-call timeout anywhere in that chain. A
// request that never settles (a stalled/queued round-trip — this dev
// environment's shared checkout routinely starves the browser's ~6-connection
// HTTP/1.1 pool across concurrent tabs/probes, see
// project_two_tab_localhost_connection_starvation.md — or any genuinely wedged
// backend call) parks the `await` forever: no throw, so the surrounding
// try/catch never fires and `endDataLoad` (the ONLY place this pipeline clears
// the flag, at the reveal below) is simply never reached. Reproduced
// identically on two unrelated orgs (not org-specific) — consistent with a
// generic unguarded-await defect rather than a per-tenant data issue.
//
// The UI org-switcher's OWN 12s "genuinely stuck" reload fallback
// (AppOrgSwitcher.js `_wsFallbackTimer`) does NOT cover this: it is
// disarmed by `clearWorkspaceSwitchFallback()` on onWorkspaceChange's very
// FIRST line — the instant the pipeline STARTS, not when it FINISHES — so a
// stall anywhere inside the pipeline (which is exactly where this bug lives)
// runs completely unguarded. It also only exists for the org-switcher's own
// commit flow — the auth-subscription's direct claims-change trigger and
// programmatic `sdk.switchOrg`/`switchWorkspace` callers (AI tools, cross-tab
// convergence, tests) invoke `onWorkspaceChange` with no fallback timer at
// all.
//
// Fix: a per-run watchdog scoped to THIS run's own `_dataLoading` epoch
// (armed right after `beginDataLoad`, self-cancelling the instant a newer
// switch supersedes the epoch or this run reaches its own reveal). It doesn't
// try to un-stick the underlying stalled request — there is no generic way to
// abort an arbitrary in-flight SDK call from here — it guarantees the LOADER
// itself always resolves within a bounded window either way: converge (the
// normal path) or fail loud + release (this path), never a silent infinite
// spinner. Set comfortably under the org-switcher's 12s reload fallback so
// the UI-driven flow gets a clean error+release instead of a jarring full
// reload; kept as a named export so tests can shrink it.
let $e8c85d000cc7c6c2$var$_wsChangeWatchdogMs = 10000;
const $e8c85d000cc7c6c2$export$b419d95b03778a1 = (ms)=>{
    $e8c85d000cc7c6c2$var$_wsChangeWatchdogMs = ms;
};
// Bound on the LiveKit teardown the switch awaits before its PHASE-1 wipe
// (MEET-LIVE-CALL-SURVIVES-SWITCH-1). A `room.disconnect()` normally settles in
// well under a second; this only exists so a signal socket that never answers
// cannot hold the PREVIOUS tenant's data on screen — past the bound the wipe
// proceeds and the failure is logged loudly, never swallowed. Comfortably under
// the switch watchdog above so the two can never race for the same symptom.
// Named export so tests can shrink it.
let $e8c85d000cc7c6c2$var$_livekitTeardownBoundMs = 2000;
const $e8c85d000cc7c6c2$export$48cfc75a223a2ef6 = (ms)=>{
    $e8c85d000cc7c6c2$var$_livekitTeardownBoundMs = ms;
};
// ── Switch-pipeline phase instrumentation + reveal budget ───────────────────
//
// WS-SWITCH-ONWORKSPACECHANGE-BOUNDED-WINDOW-TRIP-1. The watchdog above tells
// us the pipeline did not settle, but never WHICH await stalled — a live
// cross-org switch (Symbols System → Bellforge, dev) tripped it with no way to
// name the offender. Every pre-reveal await is now run through `_phase`,
// which:
//   1. stamps its duration (performance.now) into a per-run table published on
//      `root.__wsSwitchPhases` — readable live from the console/Chrome MCP,
//      and NOT a state key (no `root.update`), so instrumentation can never
//      repaint the UI or race the epoch-guarded writes;
//   2. BOUNDS the await against a single shared REVEAL BUDGET. Per-phase
//      timeouts alone do not bound the pipeline (n phases × n bounds can still
//      exceed the watchdog); one budget shared by all phases guarantees the
//      reveal is reached inside the watchdog window on ANY stall.
// A bounded-out phase is NON-FATAL: the pass continues with its fallback value
// and the underlying promise keeps running (a slow module still applies when
// it lands, see the `loadWorkspaceProject` continuation below). The watchdog
// stays as the safety net for a stall OUTSIDE these phases — and now prints
// the phase table when it fires.
//
// Budget sits well under `_wsChangeWatchdogMs` so a healthy-but-slow switch
// reveals instead of tripping the loud error (the live symptom: a cold parcel
// module chunk on dev takes longer than the whole window).
let $e8c85d000cc7c6c2$var$_switchRevealBudgetMs = 7000;
const $e8c85d000cc7c6c2$export$799cd6f54ca8bf45 = (ms)=>{
    $e8c85d000cc7c6c2$var$_switchRevealBudgetMs = ms;
};
// Verbose per-phase logging is opt-in (`root.__wsSwitchDebug = true` in the
// console). A phase that BOUNDS OUT is always logged — that is the finding the
// ticket exists for and it must never need a flag to be visible.
// Sentinel resolved by a phase's bound — never a legal phase VALUE.
const $e8c85d000cc7c6c2$var$_BOUNDED = Symbol('ws-switch-phase-bounded');
const $e8c85d000cc7c6c2$var$_nowMs = ()=>typeof performance !== 'undefined' && typeof performance.now === 'function' ? performance.now() : Date.now();
// Opaque tenant token for the @symbo.ls/fetch cache + dedup keys (read by the
// plugin's resolveScope off root.__fetchScope). Isolates every declarative
// fetch cache entry per org+workspace so a page mounted right after a switch
// never serves the previous tenant's cached rows.
const $e8c85d000cc7c6c2$var$_fetchScope = (root, sdk)=>{
    // org id: bootShell seeds root.org / jwtClaims.workspace_org_id but does NOT
    // populate sdk._context.activeOrgId until an explicit switchOrg, so prefer
    // root — otherwise the token is empty at boot and never isolates orgs.
    const org = root?.org?.id || root?.jwtClaims?.workspace_org_id || sdk?._context?.activeOrgId || '';
    // ws id: switchWorkspace writes sdk._context.activeWorkspaceId (authoritative);
    // fall back to the JWT claim / resolved workspace record.
    const ws = sdk?._context?.activeWorkspaceId || root?.jwtClaims?.active_workspace_id || root?.activeWorkspaceId || root?.workspace?.id || root?.workspace?._id || '';
    return `${org}.${ws}`;
};
const $e8c85d000cc7c6c2$var$shellGetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.getActiveWorkspacePointer(...args);
const $e8c85d000cc7c6c2$var$shellSetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspacePointer(...args);
// The comm host (docs/COMM_HOST.md) never shows the home dashboard or the
// documents list — their reads are skipped there.
const $e8c85d000cc7c6c2$var$shellIsCommHost = ()=>(0, $1X0Je.default).functions.isCommHost();
const $e8c85d000cc7c6c2$var$shellListOrgMembers = (...args)=>(0, $1X0Je.default).functions.listOrgMembers(...args);
const $e8c85d000cc7c6c2$var$invalidateOrgMembers = (...args)=>(0, $1X0Je.default).functions.invalidateOrgMembers(...args);
const $e8c85d000cc7c6c2$var$shellSetActiveWorkspaceRecord = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspaceRecord(...args);
// Theme-mode record helpers (shared/functions/themeMode.js) — same
// `_wsShared.functions.*` indirection as the workspace-pointer helpers above.
const $e8c85d000cc7c6c2$var$reconcileThemeModeFromPrefs = (...args)=>(0, $1X0Je.default).functions.reconcileThemeModeFromPrefs(...args);
const $e8c85d000cc7c6c2$var$persistThemeModeToUser = (...args)=>(0, $1X0Je.default).functions.persistThemeModeToUser(...args);
const $e8c85d000cc7c6c2$var$shellReadStoredThemeMode = (...args)=>(0, $1X0Je.default).functions.readStoredThemeMode(...args);
const $e8c85d000cc7c6c2$var$shellReadTenantBootThemeMode = (...args)=>(0, $1X0Je.default).functions.readTenantBootThemeMode?.(...args);
const $e8c85d000cc7c6c2$var$shellWorkspaceThemeModeOf = (...args)=>(0, $1X0Je.default).functions.workspaceThemeModeOf?.(...args);
const $e8c85d000cc7c6c2$var$shellWriteStoredThemeMode = (...args)=>(0, $1X0Je.default).functions.writeStoredThemeMode(...args);
const $e8c85d000cc7c6c2$var$shellStampWorkspaceShape = (...args)=>(0, $1X0Je.default).functions.stampWorkspaceShape(...args);
const $e8c85d000cc7c6c2$var$onActiveWorkspaceFull = (...args)=>(0, $1X0Je.default).functions.onActiveWorkspaceFull(...args);
const $e8c85d000cc7c6c2$var$shellWorkspaceSettings = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
const $e8c85d000cc7c6c2$var$shellClearWorkspaceSwitchFallback = (...args)=>(0, $1X0Je.default).components.clearWorkspaceSwitchFallback(...args);
// Deferred to call time — an eager module-scope destructure of the barrel's
// default crashes the shell boot inside the shared-barrel init cycle.
const $e8c85d000cc7c6c2$var$shellGetWorkspaceRawSegments = (...args)=>(0, $1X0Je.default).functions.getWorkspaceRawSegments(...args);
const $e8c85d000cc7c6c2$var$shellGetWorkspaceQueryParam = (...args)=>(0, $1X0Je.default).functions.getWorkspaceQueryParam(...args);
// PERSONA-5 — purge the sessionStorage persona blob (personaSession.js,
// PERSONA-2) in lockstep with the state wipe below. `_personaSession` is
// registered in WORKSPACE_SCOPED_KEYS so `workspaceScopedWipe()` nulls the
// STATE reflection, but that state key was never derived FROM the
// sessionStorage blob (nothing calls `readPersonaSession()` — the pill
// restores from the server oracle instead), so the blob is a second,
// independent copy that the state wipe alone never touches. Left alone it
// would keep naming the OLD workspace after the switch — harmless for auth
// (readPersonaWorkspaceToken's own workspace-mismatch guard refuses it, and
// the SDK already ended the session server-side via PersonaService's
// switchWorkspace/switchOrg hooks by the time this runs) but exactly the
// stale-second-copy hazard the isolation registry exists to close.
const $e8c85d000cc7c6c2$var$shellClearPersonaSession = (...args)=>(0, $1X0Je.default).functions.clearPersonaSession(...args);
const $e8c85d000cc7c6c2$export$f65a76329791bc8a = (r)=>({
        userId: r.user_id,
        email: r.email,
        // No invented display name: a nameless member reads as their email here,
        // and each render site owns its own translated fallback
        // (`workspace.person.unknown`) for a row with neither.
        name: r.name || r.email || '',
        // avatar carries a URL or NOTHING — never letters. The old
        // falling back to initials(r.name) overloaded one field with URL-or-letters,
        // and every hide-guarded <img> still FETCHED the letters: `hide:` is
        // display:none only (css-in-props block.js), and a browser requests the
        // src of a hidden image — so /N-style paths 404ed on every page for every
        // person without a photo (measured on app.bellforge.eu + the shell,
        // 2026-09-01). Letters live in their own `initials` field; consumers
        // branch on two honest fields, so AVATAR-URL-LEAK-1 stays fixed too
        // (nothing paints a URL as text, nothing fetches letters). A STORED value
        // that is not a URL (letters an older client saved: dev 2026-10-18, "NT"
        // fetched /w/system/NT from a tasks card) reads as nothing too.
        avatar: typeof r.avatar === 'string' && /^(https?:|\/)/.test(r.avatar) ? r.avatar : '',
        initials: (0, $aGIjc.initials)(r.name),
        position: r.position,
        location: r.location,
        // city/country are the canonical split of the legacy `location` string
        // (migration 0145). MemberProfile's _countryOf/_cityOf read person.country/
        // person.city first; carry them so a saved Country/City survives a shell
        // re-hydrate without falling back to parsing `location`.
        country: r.country,
        city: r.city,
        timezone: r.timezone,
        github: r.github || r.github_username,
        linkedin: r.linkedin,
        twitter: r.twitter,
        birthday: r.birthday,
        start_date: r.start_date,
        end_date: r.end_date,
        status: r.status,
        bio: r.bio,
        pronouns: r.pronouns,
        startDate: r.start_date,
        endDate: r.end_date
    });
const $e8c85d000cc7c6c2$var$filterToActiveOrg = (peopleAll, root)=>{
    const orgMembersByOrgId = root?.orgMembersByOrgId || {};
    const activeOrgId = root?.org?.id || root?.jwtClaims?.workspace_org_id;
    const memberSet = activeOrgId ? orgMembersByOrgId[activeOrgId] : null;
    if (memberSet && typeof memberSet === 'object') {
        const set = memberSet instanceof Set ? memberSet : new Set(Object.keys(memberSet));
        if (set.size > 0) {
            const lower = new Set(Array.from(set).map((e)=>String(e || '').toLowerCase()));
            return peopleAll.filter((p)=>lower.has(String(p?.email || '').toLowerCase()));
        }
    }
    // No usable member set for the active org — return the FULL list unchanged.
    //
    // `peopleAll` is `users.members`, which is ALREADY org-scoped server-side
    // (see the call site comment near root.update({ peopleAll, people })), so the
    // whole list IS the active-org roster — there's nothing to narrow. The old
    // self-only fallback was actively harmful: orgMembersByOrgId is keyed by the
    // org ids loadAllTeams iterated, which don't always match `activeOrgId`
    // (jwtClaims.workspace_org_id ↔ org.id are different id-spaces per org), so
    // this branch fired on a normal boot and COLLAPSED root.people from the full
    // roster down to just the current user (or [] before currentUserEmail
    // lands). loadPrivateData sets people=full first, then loadAllTeams().then()
    // re-filtered through here and shrank it — which is exactly the home greeting
    // flicker "Good morning nikoloza → there → nikoloza" (findMe → root.people
    // empties then refills) and the "assignee picker shows only me" bug. Never
    // shrink a populated roster on a missing/mismatched member set.
    return peopleAll;
};
const $e8c85d000cc7c6c2$export$369b2b325a258b20 = async (root, sdk)=>{
    const land = (maps)=>{
        const prev = root.roles || {
            byUser: {},
            byUserMemberId: {},
            byUserMongoId: {},
            version: 0
        };
        root.update({
            roles: {
                ...prev,
                ...maps,
                version: (prev.version || 0) + 1
            }
        });
    };
    try {
        const orgId = root?.jwtClaims?.workspace_org_id;
        if (!orgId) return land({});
        const rows = await sdk.listOrgMembers(orgId).catch(()=>null) || [];
        const emailToUserId = {};
        for (const p of root.peopleAll || [])if (p.email && p.userId) emailToUserId[p.email.toLowerCase()] = p.userId;
        const byUser = {};
        const byUserMemberId = {};
        const byUserMongoId = {};
        for (const m of rows){
            const email = m.user && m.user.email || m.email;
            const uid = emailToUserId[(email || '').toLowerCase()];
            if (!uid) continue;
            byUser[uid] = m.role;
            byUserMemberId[uid] = m._id || m.id;
            if (m.user && (m.user._id || m.user.id)) byUserMongoId[uid] = m.user._id || m.user.id;
        }
        land({
            byUser: byUser,
            byUserMemberId: byUserMemberId,
            byUserMongoId: byUserMongoId
        });
    } catch (e) {
        console.warn('[workspace-project] member-roles fetch failed', e);
        try {
            land({});
        } catch (_) {
        /* the root cannot take the write — nothing left to land it on */ }
    }
};
const $e8c85d000cc7c6c2$export$5dd6614217005c03 = (root, sdk, { tag: tag = '', workspaceId: workspaceId = null, write: write = null, primed: primed = null, onError: onError = null } = {})=>{
    // A comm host has no home dashboard: no layout row, no widget definitions,
    // and nothing for the reveal to wait on (all three callers await this list).
    if ($e8c85d000cc7c6c2$var$shellIsCommHost()) return [];
    // Boot, post-auth reconciliation and manual retry can all read the same
    // row concurrently. Only the latest request may publish its layout.
    const request = {};
    $e8c85d000cc7c6c2$var$_dashboardPrefsReads.set(root, request);
    // Pin the read to the workspace the TAB IS SHOWING — record → per-tab
    // pointer → claim, the same precedence as pages/main.js `_wsScope` (the
    // WRITE path), so the read and the write can never target two different
    // rows. The claim used to come FIRST here, but it is SESSION-global and
    // not re-minted by a URL-pinned boot: a /w/<slug> load while another
    // org's workspace was still active in the claim pulled THAT workspace's
    // row into this dashboard (cross-tenant hidden/layout leak, observed
    // live on /w/system 2026-07-27). Switch callers pass the target
    // workspace explicitly — root.workspace can still be the previous
    // record when the switch's getWorkspace refetch failed.
    const wsId = workspaceId || root?.workspace?.id || root?.workspace?._id || $e8c85d000cc7c6c2$var$shellGetActiveWorkspacePointer() || root?.jwtClaims?.active_workspace_id || null;
    // A dashboard row belongs to the workspace that issued its request, not to
    // whichever root happens to be live when the network response returns. The
    // switch path supplies its own epoch-guarded writer below; the ordinary boot
    // path needs the same ownership boundary or a late System response can
    // overwrite the newly-resolved workspace's layout immediately before reveal.
    // `workspace` wins here for the same "tab is showing" precedence used to
    // choose `wsId` above. If the shell no longer has a concrete workspace, the
    // response is deliberately dropped rather than guessed into an unscoped
    // dashboard.
    const writeForCapturedWorkspace = (patch)=>{
        if (!wsId) {
            root.update(patch);
            return true;
        }
        const liveWorkspaceId = root?.workspace?.id || root?.workspace?._id || null;
        if (!liveWorkspaceId || String(liveWorkspaceId) !== String(wsId)) return false;
        root.update(patch);
        return true;
    };
    // `write` lets the workspace-switch path route through its epoch-guarded
    // `put` so a superseded switch's late row never repaints the newer one.
    const put = (patch)=>{
        if ($e8c85d000cc7c6c2$var$_dashboardPrefsReads.get(root) !== request) return false;
        return (write || writeForCapturedWorkspace)(patch);
    };
    // AI-CREATED home widgets (tickets/opus.md "Per-workspace AI-CREATED
    // widgets") ride this SAME chain, deliberately: they are per-(user,
    // workspace) content exactly like the dashboard prefs, so they must re-scope
    // on every workspace switch through the same epoch-guarded `put` and the
    // same "tab is showing" workspace pin. Adding a separate fetch elsewhere
    // would be a second place to get the switch isolation wrong.
    //
    // Each row carries its own `workspaceId` and the CALLER's own
    // `viewerCapability` (resolved server-side for whoever is asking, never the
    // creator) — `functions/aiWidgets.js aiWidgetsFor` filters to the live
    // workspace on read, so even a superseded response cannot paint the next
    // tenant's board. A failure leaves the plane empty rather than stale: the
    // home board simply shows no AI widgets, which is the correct degrade.
    // Kicked BEFORE the prefs prime check below so the primed path fetches it
    // too — /core/boot has no widget-def section to prime from.
    //
    // SKIPPED ENTIRELY without a resolved workspace. Unlike the prefs read below
    // — whose unscoped form still returns the caller's own row — an unscoped
    // widget-def list resolves against the TOKEN CLAIM's workspace, which during
    // a URL-pinned boot is routinely a DIFFERENT workspace than the tab is
    // showing. That call returns that workspace's widgets (usually none) and,
    // because `writeForCapturedWorkspace` cannot compare an id it never
    // captured, its `put` writes UNCONDITIONALLY — so a boot-time claim-scoped
    // empty answer landed on top of the URL workspace's real plane and the board
    // showed no AI widgets at all (observed live on /w/natali/natali-backup,
    // 2026-08-13). Every call site re-runs this chain once the workspace
    // resolves (the workspace-change fan-out and auth.js's `_ensureWorkspaceModule`
    // re-fetch), so skipping here costs nothing and removes the whole race.
    const aiWidgets = wsId ? sdk.execute('workspaceProject.widgetDefs', 'list', {
        workspaceId: wsId
    }).then((rows)=>{
        put({
            workspaceAiWidgets: Array.isArray(rows) ? rows : []
        });
    }).catch((e)=>{
        console.warn(`[workspace-project] ${tag}ai widget defs fetch failed`, e);
        if ($e8c85d000cc7c6c2$var$_dashboardPrefsReads.get(root) === request) onError?.('widgets');
    }) : Promise.resolve();
    // Composite-boot prime: /core/boot's `prefs` section replays the EXACT
    // SAME handler (PrefsController.getHomeDashboard, via runSection) this GET
    // itself hits — server/src/domains/boot/controllers/BootController.js and
    // sdk/src/services/WorkspaceProjectService.js both terminate at GET
    // /core/prefs/home-dashboard. Plane equivalence (tickets/workspace.md
    // "home-dashboard prefs are NOT primed…") is proven, not assumed: a live
    // same-session comparison (2026-08-08) of `/core/boot`'s `data.prefs`
    // against a direct `/core/prefs/home-dashboard` call, same user+workspace,
    // both with and without an explicit `workspaceId`, returned BYTE-IDENTICAL
    // JSON both times — there is only one store.
    // Still only trusted when NON-null AND scoped to the SAME workspace this
    // call resolves to (a fast in-app switch can race a still-in-flight boot).
    // A null section is deliberately NOT treated as "confirmed empty": boot's
    // `Promise.allSettled` collapses a genuinely-empty row and a
    // rejected/errored section to the same `data.prefs: null` — trusting that
    // as empty would repaint the user's real saved layout with defaults on a
    // masked error, the exact regression class this file exists to prevent.
    // Falls through to the network read below in every other case.
    if (primed && primed.prefs && primed.workspaceId && wsId && String(primed.workspaceId) === String(wsId)) {
        put({
            _dashPrefsReadOk: true,
            userDashboardPrefs: primed.prefs
        });
        return [
            aiWidgets
        ];
    }
    // One bounded retry — a single transient failure (API restarting under
    // nodemon, cold pool) otherwise leaves the whole boot on the stale local
    // cache, which is the top source of "widgets differ after reload".
    const read = (attempt = 0)=>sdk.execute('workspaceProject.homeDashboardPrefs', 'get', wsId ? {
            workspaceId: wsId
        } : {}).catch((e)=>{
            if (attempt < 1) return new Promise((r)=>setTimeout(r, 400)).then(()=>read(attempt + 1));
            throw e;
        });
    return [
        read().then((data)=>{
            // `_dashPrefsReadOk` flips on ANY successful read — including an
            // empty one (user genuinely has no row yet). The grid boot gates its
            // default-seed persist on it, so a FAILED read can never end with
            // defaults written over the user's real row.
            put({
                _dashPrefsReadOk: true,
                ...data ? {
                    userDashboardPrefs: data
                } : {}
            });
        }).catch((e)=>{
            console.warn(`[workspace-project] ${tag}home_dashboard_prefs fetch failed`, e);
            if ($e8c85d000cc7c6c2$var$_dashboardPrefsReads.get(root) === request) onError?.('dashboard');
        }),
        aiWidgets
    ];
};
// ── §6 — LATE ARRIVAL MUST RE-RENDER ─────────────────────────────────────────
// (tickets/spec-workspace-record-shape.md §6.)
//
// §4c guarantees the full workspace record is always FETCHED once any id is
// resolved, on any route. It does not make anything repaint when it lands, and
// the navbar is the case that proves why that gap matters:
//
//   root.workspace.settings.navbar          (source of truth, async)
//     → resolveWorkspaceConfig              (workspaceConfigs.js)
//       → applyWorkspaceConfig              (publishes the DERIVED bag)
//         → root.workspaceSettings.navbar   (what HeaderTabs actually reads)
//
// HeaderTabs never reads the record. It reads the derived bag. So a record
// arriving after applyWorkspaceConfig last ran changes NOTHING on screen — the
// bare DEFAULT_NAVBAR that the early lean-boot pass published stays painted,
// indefinitely, over a workspace that has a configured navbar. That is exactly
// the reported "/add-app shows the default navbar" symptom, and it survives
// every part of §4 on its own.
//
// The activation chain is re-run on the upgrade edge. All three steps, not just
// applyWorkspaceConfig: on a lean boot the chain's first pass ran with NO
// workspace id at all (loadPrivateData's `_wsReady` only waits when a URL slug
// forces the workspace, which is precisely why the non-/w/* routes lose this
// race), so `root.workspaceProject` and `root.workspaceApps` are unresolved too
// — and they are precedence 1 and the navbar-append source in
// resolveWorkspaceConfig. Both loaders carry their own in-flight dedup keyed by
// a signature that INCLUDES the settings bag (`_loaderFlightKey`), so the
// pre-arrival pass and this post-arrival pass key differently and this one
// genuinely re-runs rather than joining the stale flight.
//
// applyWorkspaceConfig then corrects itself without further help: its
// `savedNavbarIsBareDefault` guard already exists so a previously-published
// bare default loses to a preset that carries a real navbar. It was only ever
// missing this trigger.
let $e8c85d000cc7c6c2$var$_convergeRegistered = false;
let $e8c85d000cc7c6c2$var$_convergeSdk = null;
let $e8c85d000cc7c6c2$var$_convergeSeq = 0;
const $e8c85d000cc7c6c2$export$59bf87e5615462ae = (sdk)=>{
    if (sdk) $e8c85d000cc7c6c2$var$_convergeSdk = sdk;
    if ($e8c85d000cc7c6c2$var$_convergeRegistered) return;
    $e8c85d000cc7c6c2$var$_convergeRegistered = true;
    $e8c85d000cc7c6c2$var$onActiveWorkspaceFull((root, ws)=>{
        const wsId = String(ws && (ws.id || ws._id) || '');
        if (!root || !wsId || !$e8c85d000cc7c6c2$var$_convergeSdk) return;
        // auth.js has already started the module/apps/config + prefs chain for
        // this exact late-claim workspace and owns the loader reveal. Starting a
        // second converge pass here races the same reactive config publication and
        // is the source of the extra post-sign-in chrome/layout shuffle.
        if ($e8c85d000cc7c6c2$export$d65e4ac87a9be3f4(root, wsId)) return;
        // Last-upgrade-wins: a workspace switch landing while this chain is in
        // flight must not have the older workspace's config applied over it.
        const seq = ++$e8c85d000cc7c6c2$var$_convergeSeq;
        const stale = ()=>seq !== $e8c85d000cc7c6c2$var$_convergeSeq || String(root.workspace && (root.workspace.id || root.workspace._id) || '') !== wsId;
        Promise.resolve().then(async ()=>{
            // Boot entrant (see auth.js's post-sign-in chain): reuse a settled pass.
            await (0, $7ytvD.loadWorkspaceProject)(root, $e8c85d000cc7c6c2$var$_convergeSdk, {
                boot: true
            });
            if (stale()) return;
            await (0, $7ytvD.loadWorkspaceApps)(root, $e8c85d000cc7c6c2$var$_convergeSdk, {
                boot: true
            });
            if (stale()) return;
            (0, $g7CNh.applyWorkspaceConfig)(root);
        }).catch((e)=>console.warn('[workspace-project] full-record converge: applyWorkspaceConfig failed', e));
    });
};


const $e8c85d000cc7c6c2$export$e3141ac8004c427e = async (root, sdk, _opts = {})=>{
    if (!root || !sdk) return;
    // Detached nodes are normal during mount. Only explicit disposal markers
    // reject a root; keep its element identity so a queued pass cannot revive
    // a removed element or an older binding of the same state object.
    const _loadElement = root.__element || null;
    if (_loadElement?.__destroyed || _loadElement?.__ref === null) return;
    // `getWorkspaceCached` (functions/getWorkspaceCached.js) closes over its own
    // module-scope `_inflight`/`_cache` dedup state — a raw cross-file `import`
    // reference to it is a free identifier once this function is serialized and
    // revived standalone (frank can't lift a closure with private module state
    // into globalScope; it leaves the reference unresolved instead — confirmed:
    // `functions.loadPrivateData`/`functions.onWorkspaceChange` both threw
    // ReferenceError at a frank-served runtime, silently breaking the boot data
    // load AND every workspace-switch refetch). `root.call` reaches the SAME
    // live singleton via `context.functions` (populated at runtime, not
    // re-evaluated), so the cache/dedup state stays intact.
    // HARDENED (P1 lead, 2026-08-15): `root.call` is ABSENT on some state
    // objects mid-switch — bellf-qa captured the TypeError thrown from THIS
    // wrapper synchronously inside onCreate (rootBus replays orgSwitched to a
    // late subscriber during createDomqlElement), and an uncaught lifecycle
    // throw aborts element creation mid-tree, leaving later handlers unbound.
    // Fallback: the direct import reaches the SAME in-bundle singleton (cache
    // intact); under frank revival the import vanishes but `typeof` of the
    // free identifier is safely 'undefined' and we degrade to a null read
    // instead of a throw.
    const getWorkspaceCached = (...args)=>typeof root.call === 'function' ? root.call('getWorkspaceCached', ...args) : typeof (0, $7muxD.getWorkspaceCached) === 'function' ? (0, $7muxD.getWorkspaceCached)(...args) : Promise.resolve(null);
    // Register BEFORE the early-return guards below: a duplicate/queued pass
    // still has to leave the late-arrival reaction armed, and the record can
    // land during a pass this one dropped.
    $e8c85d000cc7c6c2$export$59bf87e5615462ae(sdk);
    const _scopeNow = $e8c85d000cc7c6c2$var$_fetchScope(root, sdk);
    if ($e8c85d000cc7c6c2$var$_shellLoadInFlight) {
        if ($e8c85d000cc7c6c2$var$_shellLoadInFlight.root === root && $e8c85d000cc7c6c2$var$_shellLoadInFlight.element === _loadElement && (_scopeNow === $e8c85d000cc7c6c2$var$_loadScopeAtStart || $e8c85d000cc7c6c2$var$_shellLoadInFlight.generation !== $e8c85d000cc7c6c2$export$254ef76a6207537d())) // A switch that already superseded this root's boot owns its new scope
        // and reveal. A late auth callback must not take the switch's epoch.
        return;
        const sameQueuedRoot = $e8c85d000cc7c6c2$var$_loadRerunQueued?.root === root && $e8c85d000cc7c6c2$var$_loadRerunQueued.element === _loadElement;
        if (sameQueuedRoot && ($e8c85d000cc7c6c2$var$_dataLoadEpochByRoot.get(root) !== $e8c85d000cc7c6c2$var$_loadRerunQueued.epoch || $e8c85d000cc7c6c2$var$_loadRerunQueued.generation === $e8c85d000cc7c6c2$export$254ef76a6207537d() && $e8c85d000cc7c6c2$var$_loadRerunQueued.scope === _scopeNow)) // A newer reveal on THIS root owns its hydration. Otherwise only a
        // current-generation duplicate can share the queued request: a switch
        // on the old root must not discard this replacement's later request.
        return;
        const queued = {
            root: root,
            sdk: sdk,
            // Auth can repeat a request without its original composite payload.
            // Retain that payload when renewing this root's same-scope handoff.
            opts: sameQueuedRoot && $e8c85d000cc7c6c2$var$_loadRerunQueued.scope === _scopeNow ? {
                ...$e8c85d000cc7c6c2$var$_loadRerunQueued.opts,
                ..._opts
            } : _opts,
            element: _loadElement,
            scope: _scopeNow,
            generation: $e8c85d000cc7c6c2$export$254ef76a6207537d(),
            epoch: null
        };
        // Publish before update(): a synchronous subscriber may queue an even
        // newer root. Its record and epoch must win over this caller's return.
        $e8c85d000cc7c6c2$var$_loadRerunQueued = queued;
        queued.epoch = $e8c85d000cc7c6c2$export$8d30e891c453caff(root);
        return;
    }
    // Also cancels a previously scheduled handoff when a fresh call arrives in
    // the gap after the old pass finishes but before its handoff task runs.
    $e8c85d000cc7c6c2$var$_loadRerunQueued = null;
    // This pass's own latch record: a session end (endWorkspaceSession) can
    // release it while the pass runs, and the next session's pass then holds
    // its own.
    const _loadLatch = {
        root: root,
        element: _loadElement,
        generation: $e8c85d000cc7c6c2$export$254ef76a6207537d()
    };
    $e8c85d000cc7c6c2$var$_shellLoadInFlight = _loadLatch;
    $e8c85d000cc7c6c2$var$_loadScopeAtStart = _scopeNow;
    const _loadWsGen = _loadLatch.generation;
    const _bootGeneration = ++$e8c85d000cc7c6c2$var$_bootLoadGeneration;
    const _bootUser = root.currentUserId;
    let _bootWorkspace = null;
    let _bootOrg = null;
    const _bootCurrent = ()=>_bootGeneration === $e8c85d000cc7c6c2$var$_bootLoadGeneration && !$e8c85d000cc7c6c2$export$ca6d91143d80876a(_loadWsGen) && root.signedIn !== false && root.currentUserId === _bootUser && (_bootWorkspace === null || String(root.workspace?.id || root.workspace?._id || '') === _bootWorkspace) && (_bootOrg === null || String(root.org?.id || root.org?._id || '') === _bootOrg);
    // The stamp of the core entry this pass wrote last. Every settle below acts
    // on that entry only, never on a newer owner's.
    let _coreStamp = 0;
    // A pass that stops being current while NOTHING replaced it must not leave
    // its entry behind: nobody else will ever finish it. An identity re-stamp
    // mid-boot is such a shape (activationNoticeSettles.test.js): auth's tick
    // moves `currentUserId` and its `lastUserId`, but starts no second pass while
    // this one is in flight, so "still loading" (or a retry's "Retrying…") stayed
    // up for good. The entry turns into the retryable failure, so Retry runs a
    // pass that is current. A successor owns the status (a newer pass writes core
    // as it starts; a switch wipes it), so a superseded pass leaves it alone.
    const _releaseCore = ()=>{
        if (_bootGeneration !== $e8c85d000cc7c6c2$var$_bootLoadGeneration || $e8c85d000cc7c6c2$export$ca6d91143d80876a(_loadWsGen)) return;
        (0, $7ytvD.settleWorkspaceActivation)(root, 'core', _coreStamp, {
            state: 'error'
        });
    };
    const _bootErrors = [];
    // Roster + team adoption also require that the SDK has not moved to ANOTHER
    // workspace since the roster was read (captured in the people chain once
    // the workspace resolves). The SDK's own mirror of the viewed workspace
    // (auth's updateContext) is not a move, and neither is no change.
    let _rosterCaptured = false;
    let _rosterWs = null;
    let _rosterSdkWs = null;
    const _sdkWs = ()=>sdk?._context?.activeWorkspaceId ? String(sdk._context.activeWorkspaceId) : null;
    const _rosterCurrent = ()=>{
        if (!_bootCurrent()) return false;
        if (!_rosterCaptured) return true;
        const now = _sdkWs();
        return !now || now === _rosterWs || now === _rosterSdkWs;
    };
    const _retryReconciliation = $e8c85d000cc7c6c2$var$_postAuthWorkspaceRevealPending.get(root);
    // SHELL-USER-KEY-1: warm-start boots can carry currentUser* from the
    // cached snapshot while the full root.user record never landed (getMe
    // failed ambiguously and nothing retried the stamp). One-shot,
    // non-blocking heal — full rationale + tests in healUserRecord.js.
    (0, $1gcj7.healUserRecord)(root, sdk);
    // Keep the boot loader (MainLoader, gated by `_dataLoading` in _isLoaderActive)
    // up until the awaited CORE workspace data lands — people + the workspace
    // project (skin/navbar/panels/seed records) + the resolved config. The inline
    // #boot-spiral only covers up to shell MOUNT; without this the shell renders
    // empty-then-fills while data is still loading. Cleared in `finally` (covers
    // the no-active-workspace early return too, so the loader never sticks on
    // /login) — via the ownership epoch, so a boot pass finishing mid-org-switch
    // can no longer drop the loader the switch raised. The secondary fan-out
    // below stays non-blocking.
    const _dlEpoch = $e8c85d000cc7c6c2$export$8d30e891c453caff(root, {
        __fetchScope: _scopeNow,
        ..._opts.background ? {
            _dataLoading: false
        } : {}
    });
    _coreStamp = (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
        state: 'loading',
        visible: !!_opts.background
    });
    $e8c85d000cc7c6c2$var$_mark('wsboot:priv:start');
    // Hoisted so `finally` can hold a queued root handoff until they settle.
    let _projectChain = null;
    // Boot fix step 2: the part of the project chain the REVEAL waits for —
    // the takeover module plus, on a deep link, the one app whose page the URL
    // names (see whenAppRouteReady). The rest of the apps keep setting up
    // after the page shows; `_projectChain` still covers all of it for the
    // activation status (core 'ready' only after every app settled).
    let _projectReveal = null;
    let _prefsChain = null;
    let _peopleChain = null;
    try {
        // A legacy federated JWT remnant is OPTIONAL noise — when present, the
        // wrapper fast-paths via the `workspace_id` claim; when absent, the
        // wrapper verifies the SDK Mongo token with the symbols-server
        // secret and resolves `workspace_id` from `User.activeOrganization`
        // via the Express-injected Mongo userResolver. Either path works,
        // so we don't gate the data load on federation anymore — every
        // signed-in user gets full data.
        //
        // We still wait briefly for the workspace-project JWT so the
        // fast-path is preferred when federation is in flight (saves the
        // wrapper a Mongo lookup per request). 500ms ceiling — either path
        // works fine; no need to block the full data load for 2s on cold start.
        // Run people fetch in parallel with the JWT wait so the two don't
        // stack: people data is ready as soon as the longer of the two finishes.
        //
        // The people fetch doubles as a canary: when the user has no active
        // workspace yet (cold /login, mid-org-switch), the server replies
        // `{ error: 'no active workspace for user' }` (auth.js:302). Every
        // subsequent fetch in the fan-out below would fail with the same
        // error and each .catch would surface as its own /logs bug row — we
        // observed 10+ identical warns per /login page load
        // (WORKSPACE-LOGS-PRIVATEDATA-PREAUTH-1). Detect that case and
        // short-circuit; subscribeAuthSession will re-fire loadPrivateData
        // the moment a valid session + active_workspace_id lands.
        let _peopleErr = null;
        // Consume the entry-primed roster (fired in index.js at page entry, in
        // parallel with the entire auth+mount boot) so the people list no longer
        // waits on the boot waterfall. The roster is authed by the SDK Mongo token +
        // org-scoped server-side. Falls back to a fresh fetch when
        // the prime is absent/failed (zero-regression worst case).
        // Multi-tab drift guard: the prime is trustworthy ONLY when it was itself
        // scoped to the tab's viewed org — peoplePrime sends the /w/<slug> org
        // segment as `orgSlug` (membership-verified server-side) and records it.
        // A prime scoped to a DIFFERENT slug (or an unscoped prime on a /w/ URL)
        // planted the token-org's roster and must be skipped in favor of the
        // explicitly scoped fetch below. NOTE: comparing against the SDK's
        // client-side activeWorkspaceId mirror is NOT proof — auth.js mirrors the
        // resolved workspace into it while the prime's response was scoped by the
        // SERVER-side claim (learned live, 2026-07-22).
        const _urlSlug = (/^\/w\/([^/]+)/.exec(globalThis.location?.pathname || '') || [])[1]?.toLowerCase() || null;
        const _primeSafe = !_urlSlug || (0, $cKmtB.primedOrgSlug)() === _urlSlug;
        const _primedPeople = _primeSafe ? (0, $cKmtB.consumePrimedPeople)() : null;
        // Composite-boot members: /core/boot's `members` section is byte-
        // equivalent to the /core/users/members rows this path fetches, and
        // bootShell initially scope-checks this payload, but a queued load can
        // reuse its options after the workspace changes. Re-check the workspace
        // after _wsReady below before adopting any composite rows.
        // An empty array is an authoritative empty roster, not a missing section.
        const _bootMembers = Array.isArray(_opts?.bootPayload?.members) ? _opts.bootPayload.members : null;
        // Composite-boot prefs — plane equivalence proven (see
        // _dashboardPrefsFetches's own comment for the live-verified proof);
        // handed to _dashboardPrefsFetches below as `primed`, which re-checks
        // the workspace scope itself before trusting it.
        const _bootPrefsPrime = _opts?.bootPayload?.prefs ? {
            workspaceId: _opts.bootPayload.workspaceId,
            prefs: _opts.bootPayload.prefs
        } : null;
        // Keep the initial loader up until the known workspace lands on BOTH
        // URL-scoped and ordinary post-sign-in boots. The helper degrades after a
        // bounded wait when there is no organization/workspace to resolve.
        const _wsReady = (0, $6QCFv.awaitInitialWorkspace)(root, {
            urlScoped: !!_urlSlug
        }).then(()=>{
            if (!_bootCurrent()) return;
            _bootWorkspace = String(root.workspace?.id || root.workspace?._id || '');
            _bootOrg = String(root.org?.id || root.org?._id || '');
            _coreStamp = (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
                state: 'loading',
                visible: !!_opts.background
            });
        });
        // The persona oracle (GET /persona) rides the data wave instead of waiting
        // for the stage-CHROME PersonaPill mount (dev 1061f366e: 3253 ms, after the
        // module data). It asks once the boot holds its workspace, through the
        // pill's own gate (functions/sessionStreams.js personaOracleReady): the
        // worker authenticates /persona against the session's active workspace,
        // so a signed-in boot with none got a 401 "no active workspace for user"
        // (staging 2026-10-31: a new member's first boot, on the invite page before
        // the accept writes the org). `_wsReady` settles at once when the boot
        // already holds its workspace, so the ask still starts with the data wave.
        // Fire-and-forget; fails safe; the pill's mount call is then a no-op
        // (shared/functions/persona.js).
        if (!_opts.background && _loadElement && typeof _loadElement.call === 'function') _wsReady.then(()=>{
            if (!_bootCurrent() || !_loadElement.call('personaOracleReady', root)) return;
            _loadElement.call('refreshPersonaSession', {
                boot: true
            });
        }).catch(()=>{});
        // WORKSPACE-BOOT-PERF: start the project/apps/config chain NOW, in
        // parallel with the people fetch — it never needed the roster (the
        // onWorkspaceChange switch path has run them concurrently for a while;
        // boot lagged behind and serialized people → project → apps, which is
        // exactly the late-navbar window HeaderTabs.js documents). Awaited
        // below before the loader drops, so the contract (loader covers
        // people + project + config) is unchanged — only the wall-clock is
        // now max(people, project+apps) instead of the sum.
        let _releaseProjectReveal = ()=>{};
        _projectReveal = new Promise((resolve)=>{
            _releaseProjectReveal = resolve;
        });
        _projectChain = _wsReady.then(async ()=>{
            if (!_bootCurrent()) return;
            $e8c85d000cc7c6c2$var$_mark('wsboot:module:ws-ready');
            // A comm host loads no workspace module and no apps: their routes open
            // on the workspace host (docs/COMM_HOST.md), and a communication boot
            // must not wait on them (measured 0.95 s on dev, 2026-10-23).
            if ($e8c85d000cc7c6c2$var$shellIsCommHost()) {
                _releaseProjectReveal();
                try {
                    (0, $g7CNh.applyWorkspaceConfig)(root);
                } catch (e) {
                    console.warn('[workspace-project] applyWorkspaceConfig (comm) failed', e);
                }
                return;
            }
            // Boot entrant: an earlier entrant's settled pass is reused, not re-run.
            await (0, $7ytvD.loadWorkspaceProject)(root, sdk, {
                boot: true
            });
            if (!_bootCurrent()) return;
            $e8c85d000cc7c6c2$var$_mark('wsboot:module:project-done');
            const _appsRun = (0, $7ytvD.loadWorkspaceApps)(root, sdk, {
                boot: true
            });
            // The reveal gate: the takeover is in, and the page the URL names is
            // routable (the home needs no app). Config applies here for the
            // takeover and again below once the apps have published.
            (0, $7ytvD.whenAppRouteReady)(root).then(()=>{
                if (!_bootCurrent()) return _releaseProjectReveal();
                $e8c85d000cc7c6c2$var$_mark('wsboot:module:route-ready');
                try {
                    (0, $g7CNh.applyWorkspaceConfig)(root);
                } catch (e) {
                    console.warn('[workspace-project] applyWorkspaceConfig (reveal) failed', e);
                }
                _releaseProjectReveal();
            });
            await _appsRun;
            if (!_bootCurrent()) return;
            $e8c85d000cc7c6c2$var$_mark('wsboot:module:apps-done');
            (0, $g7CNh.applyWorkspaceConfig)(root);
            $e8c85d000cc7c6c2$var$_measure('wsboot:ws-resolve', 'wsboot:priv:start', 'wsboot:module:ws-ready');
            $e8c85d000cc7c6c2$var$_measure('wsboot:module-project', 'wsboot:module:ws-ready', 'wsboot:module:project-done');
            $e8c85d000cc7c6c2$var$_measure('wsboot:module-apps', 'wsboot:module:project-done', 'wsboot:module:apps-done');
        }).catch((e)=>{
            console.warn('[workspace-project] applyWorkspaceConfig (boot) failed', e);
            _bootErrors.push('module');
        }).finally(()=>_releaseProjectReveal());
        // First-paint prefs — the home grid layout + hidden-widget set
        // (userDashboardPrefs) decide the FIRST visible frame. They used to
        // ride the post-boot fan-out below, which
        // fires at the exact boot-ready falling edge — measured live, the row
        // landed ~340ms AFTER the loader dropped, so the home grid assembled on
        // cache/spec defaults and visibly re-shuffled on every boot (2026-07-27
        // per Nika "widgets bounce after loading … should get initial data
        // during initial load and render accordingly"). Start them the moment
        // the workspace resolves and await them WITH the project chain so the
        // layout and saved widget definitions are ready together.
        _prefsChain = _wsReady.then(()=>{
            if (!_bootCurrent()) return;
            return Promise.all($e8c85d000cc7c6c2$export$5dd6614217005c03(root, sdk, {
                primed: _bootPrefsPrime,
                write: (patch)=>{
                    if (_bootCurrent()) root.update(patch);
                },
                onError: (phase)=>_bootErrors.push(phase)
            }));
        }).catch((error)=>{
            console.warn('[workspace-project] dashboard preferences failed', error);
            _bootErrors.push('dashboard');
        });
        // Account preferences refresh behind the ready workspace. The bounded
        // boot theme preflight/cache already owns first paint; waiting for this
        // second read used to keep the full-screen loader over otherwise-ready
        // pages for the duration of a slow /prefs/user request. The saved dashboard
        // layout above remains a reveal prerequisite so widgets do not reshuffle.
        const _prefsUserAtStart = root.currentUserId;
        const _prefsThemeAtStart = root.themeMode;
        const _prefsStoredThemeAtStart = $e8c85d000cc7c6c2$var$shellReadStoredThemeMode();
        const _prefsThemeUnchanged = ()=>root.themeMode === _prefsThemeAtStart && $e8c85d000cc7c6c2$var$shellReadStoredThemeMode() === _prefsStoredThemeAtStart;
        // The assistant dock rides the same row with the same discipline
        // (ASSISTANT_BOARD_MODE_SPEC §1, functions/assistantDock.js): a dock the
        // user moves while the read is pending is newer than its result.
        const _prefsDockAtStart = root.assistantDock;
        const _prefsStoredDockAtStart = (0, $dp7M8.readStoredAssistantDock)();
        const _prefsDockUnchanged = ()=>root.assistantDock === _prefsDockAtStart && (0, $dp7M8.readStoredAssistantDock)() === _prefsStoredDockAtStart;
        // The assistant's MODE rides the same row (functions/assistantMode.js).
        const _prefsModeAtStart = root.assistantMode;
        const _prefsStoredModeAtStart = (0, $ik7KJ.readStoredAssistantMode)();
        const _prefsModeUnchanged = ()=>root.assistantMode === _prefsModeAtStart && (0, $ik7KJ.readStoredAssistantMode)() === _prefsStoredModeAtStart;
        // …and Agent mode (functions/agentMode.js).
        const _prefsAgentAtStart = root.agentMode;
        const _prefsStoredAgentAtStart = (0, $kosYS.readStoredAgentMode)();
        const _prefsAgentUnchanged = ()=>root.agentMode === _prefsAgentAtStart && (0, $kosYS.readStoredAgentMode)() === _prefsStoredAgentAtStart;
        // …and the sidebar's width (functions/assistantWidth.js).
        const _prefsWidthAtStart = root.assistantWidth;
        const _prefsStoredWidthAtStart = (0, $14aeZ.readStoredAssistantWidth)();
        const _prefsWidthUnchanged = ()=>root.assistantWidth === _prefsWidthAtStart && (0, $14aeZ.readStoredAssistantWidth)() === _prefsStoredWidthAtStart;
        _wsReady.then(async ()=>{
            // Capture the resolved scope at request time: the initial auth tick
            // can precede the authoritative workspace record.
            const prefsScope = $e8c85d000cc7c6c2$var$_fetchScope(root, sdk);
            const prefsWorkspace = String(root.workspace?.id || root.workspace?._id || '');
            const _accountPrefsCurrent = ()=>_bootGeneration === $e8c85d000cc7c6c2$var$_bootLoadGeneration && !$e8c85d000cc7c6c2$export$ca6d91143d80876a(_loadWsGen) && $e8c85d000cc7c6c2$var$_fetchScope(root, sdk) === prefsScope && String(root.workspace?.id || root.workspace?._id || '') === prefsWorkspace && root.currentUserId === _prefsUserAtStart && root.signedIn !== false;
            if (!_accountPrefsCurrent()) return;
            const data = await sdk.execute('workspaceProject.userPreferences', 'get');
            if (!_accountPrefsCurrent()) return;
            // A choice made while the read was pending is newer than its result.
            // Preserve it in BOTH the runtime mode and the mirrored account row.
            const themeUnchanged = _prefsThemeUnchanged();
            // A NEW account has no row yet — the server answers null. The read
            // still FINISHED: the row is loaded and empty (`{}`), the same value
            // every writer composes on (functions/homeLook.js). `null` keeps
            // meaning "not read yet", which readers of the record wait on — the
            // new-account welcome among them (functions/onboarding.js).
            const row = data && typeof data === 'object' ? data : {};
            root.update({
                userPrefs: themeUnchanged ? row : {
                    ...row,
                    themeMode: root.themeMode
                }
            });
            if (_prefsDockUnchanged()) {
                const dockDecision = (0, $dp7M8.reconcileAssistantDockFromPrefs)(root.assistantDock, data, (0, $dp7M8.readStoredAssistantDock)());
                if (dockDecision?.apply) {
                    root.update({
                        assistantDock: dockDecision.apply,
                        _assistantDockPromotedFrom: null
                    });
                    try {
                        localStorage.setItem('symbols_assistant_dock', dockDecision.apply);
                        // the record holds a person's choice: marked on this device too,
                        // so the next boot paints it at once (functions/assistantDock.js)
                        localStorage.setItem('symbols_assistant_dock_explicit', '1');
                    } catch (_) {
                    /* storage unavailable — the state still follows the record */ }
                } else if (dockDecision?.migrate) // Through the one writer, record only (the state and this device
                // already hold the choice): single-flight on the shared prefs
                // queue, the payload composed from the live row at send time.
                (0, $dp7M8.setAssistantDock)(root, dockDecision.migrate, sdk, {
                    recordOnly: true
                });
            }
            if (_prefsModeUnchanged()) {
                const modeDecision = (0, $ik7KJ.reconcileAssistantModeFromPrefs)(root.assistantMode, data, (0, $ik7KJ.readStoredAssistantMode)());
                if (modeDecision?.apply) {
                    // A comm host SHOWS a comm mode for the account's choice; the
                    // stored copy below keeps the account's own value.
                    root.update({
                        assistantMode: (0, $1X0Je.default).functions.commAssistantMode(modeDecision.apply)
                    });
                    try {
                        localStorage.setItem('symbols_assistant_mode', modeDecision.apply);
                    } catch (_) {
                    /* storage unavailable — the state still follows the record */ }
                } else if (modeDecision?.migrate) // Through the one writer: single-flight on the shared prefs
                // queue, the payload composed from the live row at send time.
                (0, $ik7KJ.setAssistantMode)(root, modeDecision.migrate, sdk);
            }
            if (_prefsAgentUnchanged()) {
                const agentDecision = (0, $kosYS.reconcileAgentModeFromPrefs)(root.agentMode, data, (0, $kosYS.readStoredAgentMode)());
                if (agentDecision && 'apply' in agentDecision) {
                    root.update({
                        agentMode: agentDecision.apply
                    });
                    try {
                        localStorage.setItem('symbols_agent_mode', agentDecision.apply ? '1' : '0');
                    } catch (_) {
                    /* storage unavailable — the state still follows the record */ }
                } else if (agentDecision && 'migrate' in agentDecision) // Through the one writer: single-flight on the shared prefs queue.
                (0, $kosYS.setAgentMode)(root, agentDecision.migrate, sdk);
            }
            if (_prefsWidthUnchanged()) {
                const widthDecision = (0, $14aeZ.reconcileAssistantWidthFromPrefs)(root.assistantWidth, data, (0, $14aeZ.readStoredAssistantWidth)());
                if (widthDecision?.apply) {
                    root.update({
                        assistantWidth: widthDecision.apply
                    });
                    try {
                        localStorage.setItem('symbols_assistant_width', String(widthDecision.apply));
                    } catch (_) {
                    /* storage unavailable — the state still follows the record */ }
                } else if (widthDecision?.migrate) (0, $14aeZ.setAssistantWidth)(root, widthDecision.migrate, sdk);
            }
            if (!themeUnchanged) return;
            // The TENANT default the boot seeded: the workspace record's own
            // (`settings.theme` — GreenIG's dark) before the brand's, the same
            // order bootResolve seeds them. Without it, an account row that only
            // carries 'auto' (= no preference) undid the seeded default here.
            const decision = $e8c85d000cc7c6c2$var$reconcileThemeModeFromPrefs(root.themeMode, data, $e8c85d000cc7c6c2$var$shellReadStoredThemeMode(), $e8c85d000cc7c6c2$var$shellWorkspaceThemeModeOf(root.workspace) || $e8c85d000cc7c6c2$var$shellReadTenantBootThemeMode());
            if (decision?.apply) {
                const { changeGlobalTheme: changeGlobalTheme } = await Promise.resolve((parcelRequire("eY4Ct")));
                if (!_accountPrefsCurrent() || !_prefsThemeUnchanged()) return;
                root.update({
                    themeMode: decision.apply
                });
                $e8c85d000cc7c6c2$var$shellWriteStoredThemeMode(decision.apply);
                changeGlobalTheme(decision.apply);
            } else if (decision?.migrate) $e8c85d000cc7c6c2$var$persistThemeModeToUser(root, sdk, decision.migrate);
        }).catch((e)=>console.warn('[workspace-project] user_preferences fetch failed', e));
        _peopleChain = (async ()=>{
            await _wsReady;
            if (!_bootCurrent()) return;
            // Read identity AFTER initial resolution so a cold boot's pending
            // workspace is not mistaken for a switch. _bootCurrent() keeps the
            // load-start generation: onWorkspaceChange owns the replacement roster
            // if a switch ran meanwhile, including A → B → A where the final ids
            // match this older request's scope. The SDK scope joins it: a request
            // the SDK has moved away from can no longer name this roster.
            const _viewedWs = String(root.workspace?.id || root.workspace?._id || '') || null;
            _rosterWs = _viewedWs;
            _rosterSdkWs = _sdkWs();
            _rosterCaptured = true;
            let peopleData = null;
            if (_bootMembers) {
                if (_viewedWs && String(_opts.bootPayload.workspaceId || '') === _viewedWs) peopleData = _bootMembers;
            } else if (_primedPeople) peopleData = await _primedPeople;
            if (!peopleData && _rosterCurrent()) peopleData = await $e8c85d000cc7c6c2$var$shellListOrgMembers(sdk, _viewedWs).catch((e)=>{
                _peopleErr = e;
                return null;
            });
            // The scoped request can finish after a newer workspace load has already
            // put its roster. Neither old rows nor old failures may replace it.
            if (!_rosterCurrent()) return;
            if (_peopleErr) {
                const msg = _peopleErr?.message || String(_peopleErr);
                _bootErrors.push('people');
                if (/no active workspace for user/i.test(msg)) return;
                console.warn('[workspace-project] people fetch failed', _peopleErr);
                // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — record it: `peopleError` is what
                // lets the Home People count render '!' instead of the same 0 an empty
                // workspace shows.
                root.update({
                    peopleError: msg
                });
            }
            if (peopleData) {
                const all = peopleData.map($e8c85d000cc7c6c2$export$f65a76329791bc8a);
                // #2309 — `users.members` is already org-scoped server-side, so the full
                // list IS the active-org roster. filterToActiveOrg here raced ahead of
                // orgMembersByOrgId loading and hit its self-only fallback, leaving the
                // assignee picker with just the current user. Use the full list directly.
                root.update({
                    peopleAll: all,
                    people: all,
                    peopleLoaded: true,
                    peopleError: null
                });
            }
            $e8c85d000cc7c6c2$var$_mark('wsboot:priv:people-done');
        })();
        const _coreWork = Promise.all([
            _projectChain,
            _prefsChain,
            _peopleChain
        ]).then(()=>{
            if (!_bootCurrent()) return _releaseCore();
            $e8c85d000cc7c6c2$var$_mark('wsboot:priv:project-done');
            $e8c85d000cc7c6c2$var$_mark('wsboot:priv:prefs-done');
            (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
                state: _bootErrors.length ? 'error' : 'ready',
                failed: [
                    ...new Set(_bootErrors)
                ]
            });
            // A successful explicit refresh replaces the stalled post-auth read
            // too; its obsolete promise must not keep a permanent slow notice.
            if (_opts.background && !_bootErrors.length && _retryReconciliation?.workspaceId === _bootWorkspace) $e8c85d000cc7c6c2$export$6a224fdb8fa20cab(root, _retryReconciliation);
        }).catch((error)=>{
            console.warn('[workspace-project] core workspace load failed', error);
            if (_bootCurrent()) (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
                state: 'error'
            });
            else _releaseCore();
        });
        // Resolve the tab's workspace before revealing anything from its scope.
        // After that, a slow module/layout/roster must not lock every shell action.
        // The work keeps its guarded continuations: pending is never stamped as an
        // empty result, saved layout is retained, and late success clears the notice.
        await _wsReady;
        if (!_bootCurrent()) return;
        let _revealTimer;
        try {
            // The reveal waits for the workspace's own essentials only — the
            // takeover (+ the URL's app), the saved layout and the roster — never
            // for apps the page does not show (boot fix step 2).
            const _revealWork = Promise.all([
                _projectReveal,
                _prefsChain,
                _peopleChain
            ]);
            const ready = await Promise.race([
                _revealWork.then(()=>true),
                new Promise((resolve)=>{
                    _revealTimer = setTimeout(()=>resolve(false), $e8c85d000cc7c6c2$var$_bootRevealBudgetMs);
                })
            ]);
            if (!ready && _bootCurrent()) {
                const _slowStamp = (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
                    state: 'slow'
                });
                _coreStamp = _slowStamp;
                console.warn('[workspace-project] boot reveal budget elapsed; scoped data continues loading');
                // The notice speaks for the page, never for apps still setting up
                // behind it (boot fix step 2). It waited for `_coreWork` — every app,
                // three payloads at a time — so a page that was ready kept saying
                // "still loading" until the last background app answered. Once the
                // reveal set lands, 'slow' steps back to the quiet loading state that
                // the final ready/error write replaces.
                _revealWork.then(()=>_bootCurrent() ? (0, $7ytvD.settleWorkspaceActivation)(root, 'core', _slowStamp, {
                        state: 'loading',
                        visible: !!_opts.background
                    }) : _releaseCore(), ()=>{});
            }
        } finally{
            clearTimeout(_revealTimer);
        }
        if (!_bootCurrent()) return;
        if (_peopleErr && /no active workspace for user/i.test(_peopleErr?.message || String(_peopleErr))) return;
        // Team helpers also publish partial results before their promises settle.
        // Keep those writes under this load's ownership, including member maps.
        // Capture claims so a switch during SDK initialization cannot change the
        // request's org set after loadAllTeams has chosen its cache key. Read the
        // maps live so concurrent member responses still merge with one another.
        const _teamRoot = {
            jwtClaims: {
                workspace_org_id: root.jwtClaims?.workspace_org_id,
                orgs: (root.jwtClaims?.orgs || []).map((org)=>({
                        ...org
                    }))
            },
            get teams () {
                return root.teams;
            },
            get teamsByEmail () {
                return root.teamsByEmail;
            },
            get teamsByUserId () {
                return root.teamsByUserId;
            },
            get teamMembersLoaded () {
                return root.teamMembersLoaded;
            },
            update: (patch)=>{
                if (_rosterCurrent()) root.update(patch);
            }
        };
        // A person's `status` is cap-table / HR state — the equity vesting trigger
        // (migration 0128) flips it to 'left' for class-B holders past vesting_end.
        // It is NOT a workspace-membership signal. Workspace access is gated by auth
        // (the getMe auth gate), so we must NOT log the user out based on cap-table
        // status: doing so signed out active members (incl. a founder marked 'left'
        // by vesting) and caused an iPad refresh loop. The 'left'/'inactive' status
        // only affects the people / cap-table views (peopleGroups, peopleUtils).
        // Non-blocking boot: fire the secondary fan-out and DON'T await it. Every
        // call self-hydrates via .then(root.update) and nothing downstream uses the
        // results, so awaiting only delayed boot completion by the slowest call
        // (~10s each on a cold backend). Returning here lets the shell + sidebar
        // render in ~1s and each section fills in as its data lands, instead of a
        // blank/"Thinking…" gate for the whole fan-out. (`_shellLoadInFlight` resets on
        // function exit below — acceptable; loadPrivateData only re-fires on auth
        // events, and the roster fetch above is deduped in listOrgMembers.)
        Promise.all([
            $e8c85d000cc7c6c2$export$369b2b325a258b20(root, sdk),
            // Credit guard — powers CreditBlocker/CreditBanner + the admin
            // threshold notifications. Self-hydrates `_creditGuard`; errors are
            // swallowed into an { error } payload (a metering outage must never
            // gate the workspace).
            (0, $2Od7Q.loadCreditGuard)(root, sdk),
            sdk.execute('workspaceProject.announcements', 'list', {
                order: 'date'
            }).then((data)=>{
                if (!data) return;
                root.update({
                    announcements: data.map((r)=>({
                            id: r.id,
                            title: r.title,
                            author: r.author,
                            // Same split as _person's avatar: URL-or-empty, letters in
                            // their own field (a non-URL authorAvatar 404ed via the
                            // byline <img> src on every render; a stored non-URL reads as
                            // nothing).
                            authorAvatar: typeof r.author_avatar === 'string' && /^(https?:|\/)/.test(r.author_avatar) ? r.author_avatar : '',
                            authorInitials: (0, $aGIjc.initials)(r.author),
                            authorRole: r.author_role,
                            date: r.date,
                            readTime: r.read_time,
                            tag: r.tag,
                            cover: r.cover,
                            excerpt: r.excerpt,
                            body: r.body,
                            reactions: r.reactions || {},
                            audience: r.audience === 'external' ? 'external' : 'internal',
                            externalUrl: r.external_url || r.externalUrl || ''
                        }))
                });
            }).catch((e)=>console.warn('[workspace-project] announcements fetch failed', e)),
            // intranet `stories` removed — the StoriesWidget renderer was deleted
            // 2026-06-02; root.stories had no consumer left (dead boot fetch). Table
            // dropped via 0162_drop_dead_stories.sql.
            // resource_links migrated to Mongo at /resource-links/*.
            sdk.execute('resourceLinks', 'list', {}).then((res)=>{
                const data = Array.isArray(res) ? res : res?.data || [];
                if (data?.length) root.update({
                    resourceLinks: data
                });
            }).catch((e)=>console.warn('[workspace-project] resource_links fetch failed', e)),
            (_rosterCurrent() ? (0, $kg2OA.loadAllTeams)(_teamRoot) : Promise.resolve(null)).then((result)=>{
                if (!_rosterCurrent()) return;
                const { teams: teams = [], orgMembersByOrgId: orgMembersByOrgId = {} } = result || {};
                const people = $e8c85d000cc7c6c2$var$filterToActiveOrg(root.peopleAll || [], {
                    ...root,
                    orgMembersByOrgId: orgMembersByOrgId
                });
                // Refresh the cheap, always-current bits every fire. We deliberately
                // do NOT overwrite `teamsByEmail` here: loadAllTeams returns it EMPTY
                // (it defers the per-team member fetch), so spreading it used to WIPE
                // the populated map on every loadPrivateData fire — and loadPrivateData
                // re-fires on every auth event (sign-in, ~hourly token refresh) via
                // subscribeAuthSession. Combined with the now-working `teamMembersLoaded`
                // guard, dropping the wipe means the per-team member fan-out below runs
                // ONCE and is skipped on subsequent fires (instead of storming
                // GET /organizations/:org/teams/:team/members each time). An org switch
                // wipes teamsByEmail + teamMembersLoaded in onWorkspaceChange, so the
                // new org still re-fans-out.
                _teamRoot.update({
                    teams: teams,
                    orgMembersByOrgId: orgMembersByOrgId,
                    people: people
                });
                // loadAllTeams returns teams + org-membership, but NOT the member→team
                // mapping (teamsByEmail). Without it, /people shows every member as
                // "Uncategorized" and /team-and-agents can't render team GroupFrames.
                // Each loadTeamMembers is idempotent via `teamMembersLoaded`, so this
                // only hits the network for teams not yet loaded this session.
                if (!_rosterCurrent()) return;
                return (0, $kg2OA.loadAllTeamMembers)(_teamRoot).then(()=>{
                    if (_rosterCurrent()) root.update({
                        teamsByEmailLoaded: true
                    });
                });
            }).catch((e)=>console.warn('[workspace-project] teams load failed', e)),
            // user_documents migrated to Mongo as `docs` with type='user_document'.
            // sdk.docs.userDocs.list() returns {data, count} envelope.
            $e8c85d000cc7c6c2$var$shellIsCommHost() ? null : sdk.execute('docs.userDocs', 'list', {}).then((res)=>{
                const data = Array.isArray(res) ? res : res?.data || [];
                if (data?.length) root.update({
                    userDocs: data
                });
            }).catch((e)=>console.warn('[workspace-project] user_documents fetch failed', e)),
            // Dashboard prefs gate reveal above; account prefs refresh concurrently.
            (0, $bShA0.fetchOrgNotifCount)(root).catch((e)=>console.warn('[workspace-project] org-notifications fetch failed', e)),
            // Calendar window: ±1 day past, +14 days future. Mirrors the
            // onWorkspaceChange refetch — without it, cold sign-in leaves
            // intranetEvents empty until the user switches orgs.
            (()=>{
                const min = new Date(Date.now() - 86400000).toISOString();
                const max = new Date(Date.now() + 1209600000).toISOString();
                return sdk.execute('workspaceProject.calendar', 'list', {
                    filter: {
                        deleted: false,
                        start_at: {
                            gte: min,
                            lte: max
                        }
                    },
                    order: 'start_at',
                    limit: 500
                }).then((data)=>{
                    if (!data) return;
                    const me = root.currentUserEmail || '';
                    const byKey = new Map();
                    for (const r of data){
                        const key = r.google_event_id || `local-${r.id}`;
                        const existing = byKey.get(key);
                        if (!existing) {
                            byKey.set(key, r);
                            continue;
                        }
                        if (r.google_calendar_id === me && existing.google_calendar_id !== me) byKey.set(key, r);
                    }
                    root.update({
                        intranetEvents: [
                            ...byKey.values()
                        ].map((r)=>({
                                id: r.id,
                                title: r.title,
                                startAt: r.start_at,
                                endAt: r.end_at,
                                location: r.description ? r.description.slice(0, 60) : '',
                                // Carry the FULL description + invitees through so the home
                                // "Coming up" event modal shows them directly. The modal's
                                // lazy fetchEventDetails 404s on home (no GET
                                // /calendar/events/:id route — only `list` exists) and
                                // root.events is empty here, so this seed is the only source
                                // (2026-06-08 per Nika "data not loading in Coming up event
                                // modals"). The list response already includes both fields.
                                description: r.description ?? null,
                                invitees: Array.isArray(r.invitees) ? r.invitees : [],
                                attendees: Array.isArray(r.invitees) ? r.invitees : [],
                                organizerEmail: r.organizer_email,
                                googleEventId: r.google_event_id
                            })),
                        // The window answered: an empty list is now a real "nothing"
                        // (the home Next up widget's empty sentence waits for this).
                        intranetEventsLoaded: true,
                        intranetEventsError: false
                    });
                }).catch((e)=>{
                    console.warn('[workspace-project] calendar fetch failed', e);
                    root.update({
                        intranetEventsError: true
                    });
                });
            })(),
            // birthdays: roster-derived (the dedicated table was retired, mig 0160)
            // — derived from the
            // roster's person.birthday, no network (the home widget already
            // filters against root.people). Shared with onWorkspaceChange's roster
            // put (WS-SWITCH-INCOMPLETE-1 step 8): `birthdays` is a PROJECTION of
            // the scoped roster, so it is wiped with it and re-derived wherever the
            // roster is re-put.
            Promise.resolve().then(function() {
                return Promise.resolve((parcelRequire("eY4Ct")));
            }).then((res)=>{
                root.update({
                    birthdays: $e8c85d000cc7c6c2$var$_deriveBirthdays(root.people || root.peopleAll)
                });
            }),
            // company info: Mongo workspace.settings.companyInfo is the home now
            // (the dedicated company_info table is retired with the
            // workspace-project org; admins write it via updateWorkspaceSettings).
            // Kept as an array for the /company page's legacy row shape.
            Promise.resolve().then(async ()=>{
                // §5 RENDER site (the /company page paints these rows). Read through
                // THE accessor so a list-shaped record cannot pass as "loaded, this
                // workspace simply has no company info" — the direct `?.settings` read
                // made those indistinguishable, and the difference decides whether the
                // fetch fallback below runs at all. `ready === false` now positively
                // triggers the fetch instead of relying on `settings` happening to be
                // undefined.
                const { settings: heldSettings, ready: ready, id: heldId } = $e8c85d000cc7c6c2$var$shellWorkspaceSettings(root);
                let settings = ready ? heldSettings : null;
                const wsId = heldId;
                if (!settings && wsId && typeof sdk.getWorkspace === 'function') try {
                    const ws = await getWorkspaceCached(sdk, wsId);
                    settings = ws?.settings;
                } catch (e) {
                    console.warn('[workspace-project] company-info settings fetch failed', e);
                }
                const info = settings?.companyInfo;
                const rows = Array.isArray(info) ? info : info ? [
                    info
                ] : [];
                root.update({
                    companyInfo: rows
                });
            })
        ]);
        // Warm-start snapshot write (tickets/workspace.md "boot: scope-keyed
        // warm-start snapshot"). Only at a FULLY settled boot — workspaceReady
        // means `root.workspace` is the complete record (not a list/claims-shaped
        // stub, see activeWorkspaceRecord.js), and `!scopeStale(_loadWsGen)`
        // means no NEWER switch has superseded this pass. Writing from a
        // superseded pass would tag content loaded for one scope under whatever
        // (org, workspace) happens to be live on `root` by the time this runs —
        // skip entirely rather than risk a mismatched write; the pass that
        // actually owns the current scope will write its own snapshot when IT
        // settles. See bootSnapshot.js for the isolation contract; the
        // consuming (paint-from-cache) half is wired too now — see that
        // file's `resolveWarmBootSnapshot` and bootShell.js's warm-start
        // block (tickets/opus.md "boot: the scope-keyed warm-start snapshot's
        // PAINT half was never built").
        if (!$e8c85d000cc7c6c2$export$ca6d91143d80876a(_loadWsGen) && root.workspaceReady && root.org?.id && root.workspace?.id) try {
            (0, $ly0mS.writeBootSnapshot)({
                userId: root.currentUserId,
                orgId: root.org.id,
                workspaceId: root.workspace.id,
                currentUserEmail: root.currentUserEmail,
                currentUserUsername: root.currentUserUsername,
                org: root.org,
                orgs: root.orgs,
                workspace: root.workspace,
                workspaces: root.workspaces,
                members: root.peopleAll,
                // The skin the shell stamps for this scope — the SAME rule as app.js
                // _syncShellSkin — so the next warm boot stamps it before its first
                // paint (index.js applyWarmBootSkin). Null (a configured module not
                // loaded yet) keeps the row's last skin.
                workspaceSkin: (0, $5Vf2y.resolveWorkspaceSkin)(root, {
                    info: $e8c85d000cc7c6c2$var$shellWorkspaceSettings(root),
                    brandedHost: (0, $lb2Ei.isCustomDomainHost)()
                }).skin
            });
        } catch (err) {
            console.warn('[loadPrivateData] boot-snapshot write failed:', err?.message || err);
        }
    } finally{
        // Release the pass the moment its own reveal settles: the reveal budget
        // above and retryWorkspaceActivation both rely on a direct call starting
        // a fresh pass while slow chains keep their guarded continuations. A pass
        // whose latch a session end already released leaves the latch and the
        // rerun queue alone: they belong to the next session's pass.
        const _ownsLatch = $e8c85d000cc7c6c2$var$_shellLoadInFlight === _loadLatch;
        if (_ownsLatch) $e8c85d000cc7c6c2$var$_shellLoadInFlight = null;
        $e8c85d000cc7c6c2$export$4b5c0a90ed16927c(root, _dlEpoch);
        $e8c85d000cc7c6c2$var$_mark('wsboot:priv:end');
        $e8c85d000cc7c6c2$var$_measure('wsboot:people', 'wsboot:priv:start', 'wsboot:priv:people-done');
        $e8c85d000cc7c6c2$var$_measure('wsboot:project-extra-wait', 'wsboot:priv:people-done', 'wsboot:priv:project-done');
        $e8c85d000cc7c6c2$var$_measure('wsboot:prefs-extra-wait', 'wsboot:priv:project-done', 'wsboot:priv:prefs-done');
        $e8c85d000cc7c6c2$var$_measure('wsboot:total', 'wsboot:priv:start', 'wsboot:priv:end');
        // endDataLoad can synchronously start another accepted pass. That pass
        // owns any queue it creates, so this old finally must leave it alone.
        if (_ownsLatch && $e8c85d000cc7c6c2$var$_loadRerunQueued && !$e8c85d000cc7c6c2$var$_shellLoadInFlight) {
            const queued = $e8c85d000cc7c6c2$var$_loadRerunQueued;
            const stillCurrent = ()=>$e8c85d000cc7c6c2$var$_loadRerunQueued === queued && queued.generation === $e8c85d000cc7c6c2$export$254ef76a6207537d() && queued.epoch === $e8c85d000cc7c6c2$var$_dataLoadEpoch && (!queued.element || queued.root.__element === queued.element && !queued.element.__destroyed && queued.element.__ref !== null);
            if (!stillCurrent()) $e8c85d000cc7c6c2$var$_loadRerunQueued = null;
            else if (queued.root !== root || queued.element !== _loadElement || $e8c85d000cc7c6c2$var$_fetchScope(queued.root, queued.sdk) !== $e8c85d000cc7c6c2$var$_loadScopeAtStart) {
                // Hand off only after this pass's already-started chains settle, so
                // two passes never register modules or reconcile preferences at once.
                // A direct call in the meantime replaces the queued record (above).
                const chains = [
                    _projectChain,
                    _prefsChain,
                    _peopleChain
                ];
                const dropped = ()=>{
                    if (!stillCurrent() || $e8c85d000cc7c6c2$var$_shellLoadInFlight) {
                        if ($e8c85d000cc7c6c2$var$_loadRerunQueued === queued) $e8c85d000cc7c6c2$var$_loadRerunQueued = null;
                        return true;
                    }
                    return false;
                };
                setTimeout(async ()=>{
                    if (dropped()) return;
                    await Promise.allSettled(chains);
                    if (dropped()) return;
                    $e8c85d000cc7c6c2$var$_loadRerunQueued = null;
                    return $e8c85d000cc7c6c2$export$e3141ac8004c427e(queued.root, queued.sdk, queued.opts).catch((err)=>console.warn('[workspace-project] queued private-data load failed', err));
                }, 0);
            } else {
                // A same-root scope correction returned to the accepted scope before
                // completion. No duplicate load is needed, but its held epoch is ours.
                $e8c85d000cc7c6c2$var$_loadRerunQueued = null;
                $e8c85d000cc7c6c2$export$4b5c0a90ed16927c(queued.root, queued.epoch);
            }
        }
    }
};
const $e8c85d000cc7c6c2$export$254ef76a6207537d = ()=>$e8c85d000cc7c6c2$var$_wsChangeGen;
const $e8c85d000cc7c6c2$export$ca6d91143d80876a = (gen)=>gen !== $e8c85d000cc7c6c2$var$_wsChangeGen;
const $e8c85d000cc7c6c2$export$70f2175d97f1a1d8 = (root)=>{
    $e8c85d000cc7c6c2$var$_wsChangeGen++;
    if (!root) return;
    if ($e8c85d000cc7c6c2$var$_shellLoadInFlight?.root === root) $e8c85d000cc7c6c2$var$_shellLoadInFlight = null;
    if ($e8c85d000cc7c6c2$var$_loadRerunQueued?.root === root) $e8c85d000cc7c6c2$var$_loadRerunQueued = null;
    $e8c85d000cc7c6c2$export$4b5c0a90ed16927c(root, $e8c85d000cc7c6c2$var$_dataLoadEpoch);
};
// `birthdays` is a projection of the roster (person.birthday), no network. One
// derivation, two call sites: the boot load above and the switch's roster put
// below (WS-SWITCH-INCOMPLETE-1 step 8 — the key is WORKSPACE_SCOPED, wiped in
// PHASE 1 with its source, so PHASE 2 must re-derive it or the home widget
// stays empty until a full remount).
const $e8c85d000cc7c6c2$var$_deriveBirthdays = (list)=>(list || []).filter((p)=>p && p.birthday).map((p)=>({
            name: p.name,
            email: p.email,
            birthday: p.birthday
        })).sort((a, b)=>(a.name || '').localeCompare(b.name || ''));








const $e8c85d000cc7c6c2$export$430bd0b9e6ef441d = async (root, sdk, _newClaims, opts = {})=>{
    if (!root || !sdk) return;
    // See loadPrivateData's identical wrapper above — root.call keeps this
    // reaching the one live getWorkspaceCached singleton instead of a raw
    // cross-file import frank cannot resolve once serialized.
    // HARDENED (P1 lead, 2026-08-15): `root.call` is ABSENT on some state
    // objects mid-switch — bellf-qa captured the TypeError thrown from THIS
    // wrapper synchronously inside onCreate (rootBus replays orgSwitched to a
    // late subscriber during createDomqlElement), and an uncaught lifecycle
    // throw aborts element creation mid-tree, leaving later handlers unbound.
    // Fallback: the direct import reaches the SAME in-bundle singleton (cache
    // intact); under frank revival the import vanishes but `typeof` of the
    // free identifier is safely 'undefined' and we degrade to a null read
    // instead of a throw.
    const getWorkspaceCached = (...args)=>typeof root.call === 'function' ? root.call('getWorkspaceCached', ...args) : typeof (0, $7muxD.getWorkspaceCached) === 'function' ? (0, $7muxD.getWorkspaceCached)(...args) : Promise.resolve(null);
    // Supersession guard — see _wsChangeGen. A newer switch increments the
    // generation; this (older) run then stops writing at its next checkpoint and
    // cedes the loader, so last-SWITCH-wins instead of last-WRITE-wins.
    const myGen = ++$e8c85d000cc7c6c2$var$_wsChangeGen;
    const superseded = ()=>myGen !== $e8c85d000cc7c6c2$var$_wsChangeGen;
    // Hand the switch's resolved workspace identity to the caller the INSTANT
    // this pass owns it — see the `onWorkspaceResolved` note on this function.
    // Idempotent by contract (the shell's URL sync no-ops on an already-correct
    // URL), so the two call sites below — the bare-org list row and the record
    // adoption — may both fire; the earlier one is what removes an RTT from the
    // window in which the address bar still names the OLD org.
    const notifyWorkspaceResolved = (ws)=>{
        if (superseded() || typeof opts?.onWorkspaceResolved !== 'function') return;
        try {
            opts.onWorkspaceResolved(ws || null);
        } catch (err) {
            console.warn('[shell] onWorkspaceResolved callback failed:', err?.message || err);
        }
    };
    // Epoch-guarded state write: a superseded run drops its patch so an in-flight
    // PHASE-2 fetch from an older switch can't repaint stale data over the current.
    const put = (patch)=>{
        if (superseded()) return;
        try {
            root.update(patch);
        } catch (_) {
        /* torn down mid-switch */ }
    };
    // Keep the boot-style MainLoader up for the WHOLE reload. `_wsSwitching`
    // (raised by _startSwitching) is cleared by _endSwitching the instant
    // sdk.switchOrg resolves — long before this refetch finishes — so without a
    // flag this function owns, the UI sits idle over stale/empty data for the
    // 2-6s hydration (the "takes long to load" symptom). `_dataLoading` is
    // already in _isLoaderActive; raise it now via the ownership epoch — a boot
    // loadPrivateData's `finally` landing mid-switch can no longer clear it —
    // and only the current (non-superseded) switch clears it at the reveal.
    const _dlEpoch = $e8c85d000cc7c6c2$export$8d30e891c453caff(root);
    $e8c85d000cc7c6c2$var$shellClearWorkspaceSwitchFallback();
    // Per-run phase table + bounded-phase runner — see the instrumentation note
    // above `_switchRevealBudgetMs`. `_t0` is this pass's origin; every phase
    // draws from the SAME remaining budget, so the reveal is always reached
    // before the watchdog can fire on a stalled await inside a phase.
    const _t0 = $e8c85d000cc7c6c2$var$_nowMs();
    const _phases = [];
    const _publishPhases = ()=>{
        try {
            // Direct assignment, never `root.update` — a diagnostic must not
            // schedule a render or collide with the epoch-guarded writes.
            root.__wsSwitchPhases = _phases;
        } catch (_) {
        /* frozen/torn-down root — diagnostics are never load-bearing */ }
    };
    const _phaseTable = ()=>_phases.map((p)=>p.phase + '=' + Math.round(p.ms) + (p.boundedOut ? '(BOUNDED)' : p.error ? '(ERR)' : '')).join(' ');
    const _remainingBudget = ()=>Math.max(0, $e8c85d000cc7c6c2$var$_switchRevealBudgetMs - ($e8c85d000cc7c6c2$var$_nowMs() - _t0));
    // Runs `thunk`, records its duration, and resolves with `fallback` if the
    // remaining reveal budget elapses first. NEVER throws: a phase failure is a
    // recorded, non-fatal continuation, exactly like the try/catch each of these
    // awaits already carried.
    const _phase = async (label, thunk, fallback = null)=>{
        const started = $e8c85d000cc7c6c2$var$_nowMs();
        const record = (extra)=>{
            const row = {
                phase: label,
                ms: $e8c85d000cc7c6c2$var$_nowMs() - started,
                at: started - _t0,
                ...extra
            };
            _phases.push(row);
            _publishPhases();
            if (row.boundedOut) console.warn('[shell] workspace-switch phase "' + label + '" exceeded the reveal budget after ' + Math.round(row.ms) + "ms \u2014 continuing without it (the request keeps running). " + 'Phases so far: ' + _phaseTable());
            else if (root.__wsSwitchDebug) console.debug('[shell] workspace-switch phase', label, Math.round(row.ms) + 'ms', extra?.error || '');
            return row;
        };
        let work;
        try {
            work = Promise.resolve(thunk());
        } catch (err) {
            record({
                error: err?.message || String(err)
            });
            return fallback;
        }
        // A bounded-out phase's promise keeps running — swallow its late rejection
        // so it can never surface as an unhandled rejection after we moved on.
        work.catch(()=>{});
        const budget = _remainingBudget();
        let timer = null;
        const bounded = new Promise((resolve)=>{
            timer = setTimeout(()=>resolve($e8c85d000cc7c6c2$var$_BOUNDED), budget);
            if (timer && typeof timer.unref === 'function') timer.unref();
        });
        let out;
        try {
            out = await Promise.race([
                work,
                bounded
            ]);
        } catch (err) {
            clearTimeout(timer);
            record({
                error: err?.message || String(err)
            });
            return fallback;
        }
        clearTimeout(timer);
        if (out === $e8c85d000cc7c6c2$var$_BOUNDED) {
            // Log the late settle too — the next reader learns the real duration of
            // the offending call, not just "over budget".
            const _lateStart = started;
            work.then(()=>console.warn('[shell] workspace-switch phase "' + label + '" finally settled after ' + Math.round($e8c85d000cc7c6c2$var$_nowMs() - _lateStart) + 'ms'), ()=>{});
            record({
                boundedOut: true
            });
            return fallback;
        }
        record({});
        return out;
    };
    // Bounded watchdog — see the FABLE P1 note above `_wsChangeGen`. Fires purely
    // off the epoch (not off this function's own execution), so a stalled await
    // ANYWHERE below can't block it. No-ops the instant a newer switch supersedes
    // this epoch, or once this run's own reveal clears it below — `endDataLoad`'s
    // existing epoch + `_dataLoadClearedFor` checks make a redundant/late fire
    // here a harmless no-op, so nothing needs to explicitly disarm it on every
    // early-return path.
    const _wsChangeWatchdog = setTimeout(()=>{
        if ($e8c85d000cc7c6c2$var$_dataLoadEpoch !== _dlEpoch || $e8c85d000cc7c6c2$var$_dataLoadClearedFor === _dlEpoch) return;
        console.error('[shell] onWorkspaceChange exceeded its bounded window (' + $e8c85d000cc7c6c2$var$_wsChangeWatchdogMs + "ms) without settling \u2014 forcing the loader clear + surfacing an error " + 'instead of wedging. Activation is still incomplete; a pending request or ' + 'delayed main-thread timer may have exceeded the budget. Phases: ' + (_phaseTable() || "(none recorded \u2014 the stall is BEFORE the first instrumented phase)"));
        $e8c85d000cc7c6c2$export$4b5c0a90ed16927c(root, _dlEpoch, {
            _workspaceSwitchError: true
        });
        try {
            root.call?.('openNotification', {
                title: root.call?.('polyglot', 'workspace.switch.slow'),
                message: root.call?.('polyglot', 'workspace.switch.slowBody'),
                type: 'error'
            });
        } catch (_) {
        /* the notification surface isn't reachable from this context */ }
    }, $e8c85d000cc7c6c2$var$_wsChangeWatchdogMs);
    if (_wsChangeWatchdog && typeof _wsChangeWatchdog.unref === 'function') _wsChangeWatchdog.unref();
    // Close the previous workspace's chat realtime stream — it keeps
    // delivering the OLD tenant's events otherwise (the handle is workspace-
    // keyed; subscribeRealtime re-opens it for the new workspace on the next
    // chat surface touch). Direct teardown, no chat-package import needed.
    const chatRt = root._chatRealtimeChannel;
    if (chatRt) {
        try {
            chatRt.unsubscribe?.();
        } catch (_) {
        /* already closed */ }
        root._chatRealtimeChannel = null;
    }
    // The org-members cache + in-flight promise are not org-keyed — a switch
    // within the 15s TTL (or during an in-flight fetch under the old token)
    // would repopulate root.people with the PREVIOUS org's roster.
    $e8c85d000cc7c6c2$var$invalidateOrgMembers();
    // P2/P3 — start the two most-visible, module-INDEPENDENT reads NOW, in
    // parallel with getWorkspace + the module load below, instead of dead last.
    // The roster (home greeting / avatars / assignee pickers) and teams are what
    // the UI reveals with; both need only the active-org context switchOrg already
    // set (listOrgMembers is org-keyed + just invalidated; loadAllTeams reads only
    // jwtClaims.orgs and is cached). Awaited + put post-wipe as the ESSENTIAL
    // set below, so the loader clears once they land — the switch reveals in ~1 RTT
    // instead of waiting on the slowest of ~18 fetches.
    if (superseded()) return;
    // The shared helpers publish early teams and delayed member maps directly.
    // Guard those writes with the same generation as the final result. Capture
    // claims before the SDK await so the helper's cache key and org reads agree.
    // Keep maps live so current responses merge and loaded-team guards still work.
    const _teamRoot = {
        jwtClaims: {
            workspace_org_id: root.jwtClaims?.workspace_org_id,
            orgs: (root.jwtClaims?.orgs || []).map((org)=>({
                    ...org
                }))
        },
        get teams () {
            return root.teams;
        },
        get teamsByEmail () {
            return root.teamsByEmail;
        },
        get teamsByUserId () {
            return root.teamsByUserId;
        },
        get teamMembersLoaded () {
            return root.teamMembersLoaded;
        },
        update: put
    };
    const _peoplePromise = $e8c85d000cc7c6c2$var$shellListOrgMembers(sdk, root.workspace?.id ? String(root.workspace.id) : null).catch(()=>null);
    const _teamsPromise = (0, $kg2OA.loadAllTeams)(_teamRoot).catch(()=>({}));
    // Stamp the workspace into the analyzing tracker so subsequent
    // envelopes ship with workspace_id set. Without this, the tracker's
    // beforeSend (which drops envelopes with no scope) silently swallows
    // every event on signed-in pages until the user explicitly switches
    // orgs — `reidentifyOnOrgSwitch` only fires on sdk.orgSwitched, not
    // on initial sign-in. Read the workspace id from the freshly-resolved
    // JWT claims first, fall back to root.org for safety.
    // ONE resolver, shared with boot + the orgSwitched handler
    // (ANALYZING-SESSION-ROTATE-1): sdk._context.activeWorkspaceId first (the
    // authoritative local truth — `_newClaims.active_workspace_id` can be a
    // STALE re-mint from the previous org, see activeWsId below), then the
    // tab's workspace, then claims, then the org id. A stamp change rotates
    // the analyzing session, so all writers must agree on the id.
    const wsId = (0, $caKf8.resolveAnalyzingScopeId)({
        sdk: sdk,
        root: root,
        claims: _newClaims
    }) || _newClaims?.workspace_id || null;
    if (wsId) (0, $caKf8.setAnalyzingWorkspace)(wsId);
    // Snapshot which optional caches were previously populated. The wipe
    // below sets these to their schema empty state, so the in-place
    // conditional refetches in PHASE 2 wouldn't otherwise know whether
    // to fire (eg. tickets/myTickets/feedItems and chat caches are only
    // populated when the user has visited that page this session).
    const hadTicketsBoard = Array.isArray(root.tickets) && root.tickets.length > 0;
    const hadMyTickets = Array.isArray(root.myTickets);
    const hadFeedItems = Array.isArray(root.feedItems);
    const hadChannels = Array.isArray(root.channels) && root.channels.length > 0;
    const hadChatMessages = root.messagesByChannel && Object.keys(root.messagesByChannel).length > 0;
    // aiChat threads are WORKSPACE-scoped (2026-07-14 per Nika: "aiChat
    // threads are WORKSPACE-scoped" — mirrors the chat isolation switch
    // above). Snapshot BEFORE `root.replace` wipes `_aiThreads` to its
    // schema empty state below, so PHASE 2 knows whether to refetch for
    // the NEW workspace. Also true when the assistant panel is open even
    // with zero threads yet (matches the chatSurfaceActive convention).
    const hadAiThreads = Array.isArray(root._aiThreads) && root._aiThreads.length > 0 || !!root.assistantOpen;
    // WS-SWITCH-INCOMPLETE-1 step 8 (bucket E): the SIMONE conversation core
    // (`sessions`/`chatMessages`/`activeSessionId`/…) and the ASK-USER decision
    // rows are WORKSPACE-scoped and wiped in PHASE 1 below. Both are seeded by
    // their surfaces ON MOUNT only (Chat.onCreate → hydrateServerSessions;
    // AppAssistant → fetchAskUserDecisions), so a same-route switch with the
    // assistant open would leave them empty until a full remount. Snapshot
    // BEFORE the wipe, same convention as `hadAiThreads` above.
    const hadSimoneSessions = root.sessions && Object.keys(root.sessions).length > 0 || Array.isArray(root.chatMessages) && root.chatMessages.length > 0 || !!root.assistantOpen;
    const hadAskUserDecisions = Array.isArray(root.askUserDecisions) && root.askUserDecisions.length > 0 || !!root.assistantOpen;
    // Route comparisons below run on the STRIPPED path (BOOT-RESHUFFLE F7):
    // MWT URLs carry the /w/<org>[/<ws-handle>] prefix, so comparing the raw
    // pathname against '/chat' / '/tickets' / … was dead on every prefixed tab —
    // a user sitting on /w/acme/tickets read as "not on tickets" and the switch
    // never refetched the very surface they were looking at.
    const _rawPath = typeof window !== 'undefined' ? window.location.pathname : '';
    const _path = (0, $7iFOV.shellStripWorkspacePrefix)(_rawPath) || '/';
    const _slot = root._canvasSlot ? String(root._canvasSlot) : '';
    // The home dashboard is a surface too (F7): its widgets read channels and
    // documents straight off root — after the PHASE-1 wipe they stayed empty
    // until a full remount because home never counted as "active". (Tickets and
    // projects are excluded: the home page's own onUpdate refetches those on an
    // org change already.)
    const homeSurfaceActive = _path === '/' || _path === '';
    // A user sitting ON the chat surface must get the new workspace's chat
    // even when the previous workspace had ZERO channels (hadChannels false
    // used to gate the refetch off entirely — switching into a workspace
    // from an empty-chat one left the sidebar blank until a full remount).
    const chatSurfaceActive = _path === '/chat' || root._canvasSlot === '/chat';
    // Calendar / Meet page caches (separate from the workspace-shell's
    // `intranetEvents` summary — these are the page-level state slots
    // populated by the pages' own `fetch: [...]` declarations on mount).
    const hadCalendarEvents = Array.isArray(root.events) && root.events.length > 0;
    const hadMeetRooms = Array.isArray(root.rooms) && root.rooms.length > 0;
    const hadMeetWaitingRoom = Array.isArray(root.waitingRoom);
    // P4 — tickets/calendar/meet get the SAME route-active escape hatch chat has:
    // a same-route SPA switch never remounts the page, so gating the refetch purely
    // on `had*` (was the PREVIOUS workspace populated) leaves the surface BLANK
    // after switching INTO a workspace that has data. If the user is sitting on the
    // surface, always refetch. (_path/_slot declared with the chat block above.)
    const ticketsSurfaceActive = _path.startsWith('/tickets') || _path.startsWith('/tasks') || _slot.startsWith('/tickets') || _slot.startsWith('/tasks');
    const calendarSurfaceActive = _path === '/calendar' || _slot === '/calendar';
    const meetSurfaceActive = _path === '/meet' || _slot === '/meet';
    // Documents / files desktop (2026-07-30 isolation audit #2): these keys
    // joined the wipe registry, so a mounted surface needs the same
    // had-or-active refetch convention — the fetch plugin is create-only and
    // would otherwise leave the page BLANK after the wipe until a remount.
    const hadDocuments = !!root._documentsLoaded || Array.isArray(root.documents) && root.documents.length > 0 || Array.isArray(root.notes) && root.notes.length > 0 || Array.isArray(root.kbArticles) && root.kbArticles.length > 0;
    const documentsSurfaceActive = _path === '/documents' || _path.startsWith('/documents/') || _slot.startsWith('/documents');
    const hadFileNodes = !!root._fileNodesLoaded || Array.isArray(root.fileNodes) && root.fileNodes.length > 0;
    const filesSurfaceActive = _path === '/files' || _slot === '/files';
    const hadUserPrefs = root.userPrefs != null;
    const hadCompanyInfo = Array.isArray(root.companyInfo) && root.companyInfo.length > 0;
    const companySurfaceActive = _path === '/company' || _slot === '/company';
    // Profile surface (`/user/:slug`, `/u/:slug`). The PHASE-1 wipe drains
    // `_profileViewed` + `_profileActivity` (workspace/scopes.js bucket ⑦ — a
    // roster row and a per-workspace heatmap, both tenant data), and a
    // SAME-ROUTE switch never remounts the page, so without this pair the page
    // kept its empty shell until a navigation re-ran `onCreate`. Same
    // had-or-active convention as every surface above; there is no `had*` term
    // because the wipe already ran when this is read — the route IS the signal.
    const profileSurfaceActive = (0, $jn5Js.isUserProfilePath)(_path) || (0, $jn5Js.isUserProfilePath)(_slot);
    // History app (/history): its audit-log rows, load marker and error key are
    // wiped in PHASE 1 (state-app.js) and read imperatively from the page's own
    // onCreate, which a same-route switch never re-runs. Same route-is-the-signal
    // convention as the surfaces above — and either pane of a split can host it.
    const historySurfaceActive = [
        _path,
        _slot,
        root._canvasSlotSecond
    ].some((0, $7nvlv.isHistoryPath));
    // Getting started → Team (/getting-started/team, POB S9): the found people,
    // the owner's drafts and the domain switch are wiped in PHASE 1 and read
    // from the page's own onCreate — the History case exactly.
    const gettingStartedSurfaceActive = [
        _path,
        _slot,
        root._canvasSlotSecond
    ].some((href)=>(0, $1OhIx.gettingStartedSurfaceFor)(href) === 'team');
    // Getting started → Imports (/getting-started/imports, POB S10): the same
    // rule for the found sources, the review and the run.
    const gettingStartedImportsActive = [
        _path,
        _slot,
        root._canvasSlotSecond
    ].some((href)=>(0, $1OhIx.gettingStartedSurfaceFor)(href) === 'imports');
    // Warm-start snapshot purge (tickets/workspace.md "boot: scope-keyed
    // warm-start snapshot") — the OUTGOING (userId, workspaceId) scope's cached
    // chrome is dropped BEFORE the wipe below touches `root.workspace`, mirroring
    // every other PHASE-1 wipe's "clear before the network round trip" timing.
    // Belt-and-suspenders: a different tenant reads a DIFFERENT storage key by
    // construction and could never paint this one, but "switching tenants
    // purges it" is an explicit acceptance line — honor it literally, not just
    // by relying on the key never colliding.
    if (root.currentUserId && root.workspace?.id) try {
        (0, $ly0mS.purgeBootSnapshot)({
            userId: root.currentUserId,
            workspaceId: root.workspace.id
        });
    } catch (_) {
    /* best-effort */ }
    // LIVEKIT TEARDOWN — RUNS BEFORE PHASE 1, AND THE ORDER IS THE FIX
    // (MEET-LIVE-CALL-SURVIVES-SWITCH-1). The LiveKit `Room` is a MODULE
    // singleton in meet/functions/connectCall.js, outside state, so it survives
    // every state operation: without this, a call joined in workspace A kept
    // publishing microphone and camera into A's room while B's UI was on screen.
    // The four keys that MIRROR that singleton (`livekitConnected`,
    // `livekitParticipants`, `livekitSpeakers`, `meetChatMessages`) were held OUT
    // of the wipe registry for exactly that reason — wiping the mirror first
    // hides CallWidget over a room that is still live, which is the wrong state,
    // not a fix. They join the registry in the SAME diff as this teardown and
    // only make sense together; neither half may ship alone.
    //
    // `disconnectCall` rides meet's EAGER function slice (meet/functions/
    // eagerSlice.js), so it is el.call-able from every route, not just /meet, and
    // it is idempotent: with no room it just resets the mirror keys. It is
    // reached through `root.__element` — the root STATE carries no `.call`, its
    // back-pointer element does (same handle the SIMONE PHASE-2 hydrate below
    // uses); a state-only `root.call` would resolve nothing and fail silently.
    //
    // BOUNDED await: the teardown is awaited so the room stops publishing BEFORE
    // the mirror is cleared, but a LiveKit `disconnect()` that never settles must
    // not hold the previous tenant's data on screen — that would trade this leak
    // for a worse one. Past the bound we log loudly and proceed; the disconnect
    // keeps running on its own.
    const _meetEl = root.__element;
    if (_meetEl && typeof _meetEl.call === 'function') try {
        const _torn = _meetEl.call('disconnectCall');
        if (_torn && typeof _torn.then === 'function') {
            let _t = null;
            const _bounded = new Promise((resolve)=>{
                _t = setTimeout(()=>{
                    console.error('[shell] disconnectCall did not settle within ' + $e8c85d000cc7c6c2$var$_livekitTeardownBoundMs + "ms of a workspace switch \u2014 wiping the call mirror anyway. The " + 'LiveKit room may still be publishing into the previous tenant.');
                    resolve();
                }, $e8c85d000cc7c6c2$var$_livekitTeardownBoundMs);
            });
            await _phase('livekit-teardown', ()=>Promise.race([
                    _torn.then(()=>clearTimeout(_t)).catch(()=>clearTimeout(_t)),
                    _bounded
                ]));
        }
    } catch (err) {
        console.warn('[shell] disconnectCall on workspace switch failed:', err?.message || err);
    }
    // VOICE TEARDOWN — the shell call panel's session (functions/calls/
    // workspaceCall.js) is a module singleton like the LiveKit room above: stop
    // it BEFORE the wipe clears `_callPanel`, so a call on the previous
    // workspace's number never stays connected behind the next tenant's UI.
    // Synchronous and idempotent; the next route sync starts the new
    // workspace's session.
    if (_meetEl && typeof _meetEl.call === 'function') try {
        _meetEl.call('stopWorkspaceVoice');
    } catch (err) {
        console.warn('[shell] stopWorkspaceVoice on workspace switch failed:', err?.message || err);
    }
    // PHASE 1 — EARLY, SYNCHRONOUS wipe: every org/workspace/workspace-project-
    // scoped slot resets to its schema empty state NOW, before the workspace-
    // record fetch below ever hits the network (per Nika 2026-08-01: "loading
    // old apps, personalized mongo or ai threads is super malicious"). The wipe
    // used to run AFTER that fetch (+ the bare-org list resolve), so for a full
    // network round-trip the PREVIOUS tenant's module apps, records and AI
    // threads stayed live in state behind (or worse, without) the loader. The
    // loader (_dataLoading) is already up — the user sees a clean transition,
    // never the old tenant.
    //
    // `root.replace` (vs `root.update`) does "remove old, change with new"
    // semantics — it clears every own prop then writes the new bag, so nested
    // objects like `teamsByEmail` and `orgMembersByOrgId` actually drop their
    // previous-org keys. We spread `root.parse()` first to preserve USER-scope
    // state (currentUserEmail, themeMode, lang, jwtClaims, signedIn, etc.) and
    // UI-only filter inputs so the user stays signed in and their view
    // configuration carries across the switch. `root.workspace` deliberately
    // carries through (not in the registry): blanking the active-workspace
    // record breaks chrome guards; the fetched record is adopted via `put`
    // right after the fetch resolves, before applyWorkspaceConfig reads it.
    root.replace({
        ...root.parse(),
        // Re-assert the fetch scope: smbls `parse()` omits `__`-prefixed keys, so
        // the `...root.parse()` spread above would otherwise DROP __fetchScope and
        // leave the cache tenant-blind for the rest of the session. Set it here to
        // the NEW tenant (root.org is already the new org, sdk._context the new ws).
        __fetchScope: $e8c85d000cc7c6c2$var$_fetchScope(root, sdk),
        // Every org/workspace/project-scoped slot resets to its empty schema value,
        // derived from the SINGLE-SOURCE registry (scopes.js `workspaceScopedWipe`).
        // Add NEW scoped keys THERE, never inline here — an un-wiped scoped key
        // leaks the previous org's data across the switch. UI-only filter inputs are
        // intentionally absent from the registry so they carry through via the
        // `...root.parse()` spread above.
        // MODULE-declared scoped keys (manifest `scopedKeys`, WS-MODULE-SCOPED-
        // KEYS-CONTRACT-1) ride the same registry — `root` is passed so a
        // `prefix*` family resolves against the live keys.
        ...(0, $df0As.workspaceScopedWipe)(root)
    });
    // PERSONA-5: purge the sessionStorage persona blob in the SAME synchronous
    // beat as the state wipe above — see the `clearPersonaSession` wrapper's
    // doc comment for why the state registry entry alone doesn't reach it.
    // Best-effort: a storage exception here must never abort the switch.
    try {
        $e8c85d000cc7c6c2$var$shellClearPersonaSession();
    } catch (_) {
    /* locked storage — the workspace-mismatch guard in
       readPersonaWorkspaceToken still refuses the stale blob on read */ }
    // Refetch the workspace we're switching INTO so `root.workspace` (and its
    // Mongo `settings` bag — the source of truth for the personalized skin +
    // navbar) matches the active workspace BEFORE applyWorkspaceConfig resolves.
    // Without this, root.workspace stays stale at the previous workspace and the
    // re-theme resolves the WRONG config — the switch persists in Mongo + re-mints
    // the JWT but the UI keeps the previous workspace's skin/navbar (the GreenIG
    // "it doesn't switch" bug). On fetch failure we keep the stale record rather
    // than blank the workspace.
    // Resolve the active workspace id. Prefer `sdk._context.activeWorkspaceId` —
    // `switchWorkspace` sets it (and persists it to Mongo) as the AUTHORITATIVE
    // local truth. The passed `_newClaims.active_workspace_id` can be a STALE
    // federation claim: a lagging/failed re-mint fires onWorkspaceChange a second
    // time carrying an old workspace id (we saw it land on a workspace from a
    // PREVIOUS org — "Symbols Intranet" / org 69fd0898 — after a clean switch into
    // GreenIG). Context-first means both the Mongo-native and the federated pass
    // resolve the same, correct workspace.
    const activeWsId = sdk._context?.activeWorkspaceId || _newClaims?.active_workspace_id || root.jwtClaims?.active_workspace_id || null;
    // Mirror the authoritative id into state IMMEDIATELY — chat scoping
    // (chatUtils.getActiveWorkspaceId) and the realtime stream key read
    // root.activeWorkspaceId first, so every PHASE 2 refetch + page fetch
    // that races the (possibly never-landing) federated JWT re-mint still
    // scopes to the workspace actually switched into. This is also the key
    // subscribeRealtime historically expected but nothing ever wrote.
    if (activeWsId) // Also stamp the fetch scope so the @symbo.ls/fetch cache + dedup keys
    // re-scope to the new tenant BEFORE any PHASE-2 or freshly-mounted-page
    // fetch runs — otherwise the tenant-blind cache serves the previous org's
    // rows back into the new view.
    put({
        activeWorkspaceId: activeWsId,
        __fetchScope: $e8c85d000cc7c6c2$var$_fetchScope(root, sdk)
    });
    // Re-open chat realtime for the NEW workspace when the user is on a chat
    // surface — the teardown at the top closed the old stream, and the chat
    // page only wires the subscription in onCreate (no remount on switch).
    // subscribeRealtime is workspace-keyed + idempotent, so a racing call
    // from the page is harmless. Dynamic import avoids a static cycle.
    if (chatSurfaceActive) Promise.resolve((parcelRequire("42oy6"))).then((m)=>m.subscribeRealtime.call({
            state: {
                root: root
            }
        })).catch(()=>{});
    let nextWorkspace = null;
    if (activeWsId && typeof sdk.getWorkspace === 'function') try {
        const ws = await _phase('workspace-record', ()=>getWorkspaceCached(sdk, activeWsId));
        // Cross-org stale-workspace guard. `root.org` updates reliably on a switch;
        // only adopt the fetched record when it BELONGS to the active org, so a
        // stale id that resolves to another org's workspace can never leak its
        // skin/navbar/settings in. Mismatch → keep the previous record.
        const orgId = root.org?.id || root.org?._id;
        const wsOrg = ws?.organization || ws?.organizationId || ws?.org;
        if (ws && (!orgId || !wsOrg || String(wsOrg) === String(orgId))) // getWorkspaceCached always returns the full server record — see
        // tickets/spec-workspace-record-shape.md.
        nextWorkspace = $e8c85d000cc7c6c2$var$shellStampWorkspaceShape(ws, 'full', {
            clone: false
        });
        else if (ws) console.warn('[workspace-project] workspace-change: ignoring cross-org workspace', {
            wsOrg: wsOrg,
            orgId: orgId,
            ws: ws?.displayName || ws?.name
        });
    } catch (e) {
        console.warn('[workspace-project] workspace-change: getWorkspace refetch failed', e);
    }
    // BARE ORG SWITCH resolution (org picked without a workspace target — the
    // switcher's org row, sdk.switchOrg, a /w/<other-org> deep link): the claims
    // and sdk-context still carry the PREVIOUS org's workspace until the token
    // re-mint lands, so `activeWsId` either resolved to a foreign-org record
    // (rejected by the guard above — correctly) or to nothing. The session then
    // sat workspace-less — no module, no data, no URL — until a later auth tick
    // ran the workspaces-list fallback, which is exactly the "switch to an org
    // and it half-loads" flavor of the isolation bug. Resolve the NEW org's
    // list right here and default to its HQ, so every org switch lands
    // deterministically in the same pass.
    if (!nextWorkspace && root.org && typeof sdk.listWorkspaces === 'function') {
        const newOrgId = String(root.org.id || root.org._id || '');
        const staleWs = String(activeWsId || '') // may be the previous org's ws
        ;
        try {
            const res = await _phase('org-workspaces-list', ()=>sdk.listWorkspaces({
                    organization: newOrgId
                }));
            const rows = res && (res.items || res.data?.items || res.data || res.workspaces || res) || [];
            const list = Array.isArray(rows) ? rows : [];
            // The tab's URL may NAME the target workspace — scheme A path segment 2
            // (`/w/<org>/<handle>/…`) or a legacy `?ws=` deep link. That's the
            // user's EXPLICIT intent and beats every default below; without it a
            // cross-org `?ws=` deep link reconciled the org fine but then landed on
            // the org's HQ, silently dropping the named workspace. Matched
            // slug → key → id against the freshly-listed rows (the list is already
            // org-scoped by the query, so no org filter needed here).
            const urlIntent = (()=>{
                try {
                    if (typeof window === 'undefined' || !window.location) return null;
                    const { orgSlug: orgSlug, seg2: seg2 } = $e8c85d000cc7c6c2$var$shellGetWorkspaceRawSegments(window.location.pathname || '');
                    const rootSlug = root.org?.slug || root.org?.username || null;
                    const fromPath = orgSlug && rootSlug && orgSlug === rootSlug ? seg2 : null;
                    return fromPath || $e8c85d000cc7c6c2$var$shellGetWorkspaceQueryParam(window.location.search || '') || null;
                } catch  {
                    return null;
                }
            })();
            const wantH = urlIntent ? String(urlIntent).toLowerCase() : null;
            const eqH = (v)=>String(v ?? '').toLowerCase() === wantH;
            const intent = wantH ? list.find((w)=>w?.slug && eqH(w.slug)) || list.find((w)=>w?.key && eqH(w.key)) || list.find((w)=>eqH(w?._id || w?.id)) : null;
            const hq = intent || list.find((w)=>String(w?._id || w?.id || '') === staleWs) || list.find((w)=>w?.type === 'hq') || list[0];
            const hqId = hq ? String(hq._id || hq.id || '') : '';
            if (hqId && !superseded()) {
                // URL-first: the LIST row already carries this switch's identity
                // (slug/key/id + org), and the address bar needs nothing more. Telling
                // the caller here — before the full-record fetch below — cuts a whole
                // round trip off the window in which the URL still names the OLD org
                // (measured live: this bare-org arm is the SLOW one, two RTTs to
                // adoption). Org-verified with the same check the adoption uses, so a
                // foreign row can never be stamped.
                const hqOrg = hq?.organization || hq?.organizationId || hq?.org || hq?.org_id;
                if (!hqOrg || String(hqOrg) === newOrgId) notifyWorkspaceResolved(hq);
                // Full record (settings bag — the module ref lives there); fall back
                // to the lean row when the fetch fails so the pass still scopes. The
                // `listWorkspaces` row (`hq`) is stamped `list` even though the wire
                // payload can carry `settings` too — this code path already treats it
                // as a fallback, not the authoritative fetch; keeping the stamp
                // conservative means a failed `full` fetch still gets picked up by
                // `setActiveWorkspaceRecord`'s auto-retry instead of being trusted as
                // complete. See tickets/spec-workspace-record-shape.md.
                let full = null;
                try {
                    const raw = await _phase('hq-record', ()=>getWorkspaceCached(sdk, hqId));
                    full = raw ? $e8c85d000cc7c6c2$var$shellStampWorkspaceShape(raw, 'full', {
                        clone: false
                    }) : null;
                } catch (_) {
                /* lean fallback below */ }
                const rec = full || $e8c85d000cc7c6c2$var$shellStampWorkspaceShape(hq, 'list');
                const recOrg = rec?.organization || rec?.organizationId || rec?.org;
                if (!recOrg || String(recOrg) === newOrgId) {
                    nextWorkspace = rec;
                    // Mirror the resolved scope everywhere the immediate path does
                    // (sdk context, per-tab pointer, fetch scope) — the claims tick
                    // converges later and finds itself in agreement.
                    try {
                        sdk.updateContext?.({
                            activeWorkspaceId: hqId
                        });
                    } catch (_) {
                    /* context mirror is best-effort */ }
                    $e8c85d000cc7c6c2$var$shellSetActiveWorkspacePointer(hqId);
                    put({
                        activeWorkspaceId: hqId,
                        __fetchScope: `${newOrgId}.${hqId}`
                    });
                }
            }
        } catch (e) {
            console.warn('[workspace-project] workspace-change: org workspaces resolve failed', e);
        }
    }
    // A newer switch started while the workspace record was in flight — abandon
    // before adopting/refetching so late writes can't clobber the newer switch.
    if (superseded()) return;
    // Adopt the freshly-fetched workspace record POST-wipe (PHASE 1 ran EARLY,
    // right after the snapshots — see above): applyWorkspaceConfig below must
    // resolve THIS workspace's Mongo settings. On fetch failure the previous
    // record stays — never blank the active workspace. Guarded setter (not
    // `put({ workspace: ... })`) so a list-shaped fallback row can never
    // downgrade a full record already held for this id, and so a genuinely
    // list-shaped adoption schedules its own full-record fetch — see
    // tickets/spec-workspace-record-shape.md. `superseded()` mirrors `put`'s
    // own guard since the setter writes `root.update` directly.
    if (nextWorkspace && !superseded()) $e8c85d000cc7c6c2$var$shellSetActiveWorkspaceRecord(root, nextWorkspace, {
        reason: 'onWorkspaceChange',
        sdk: sdk,
        getWorkspaceCached: getWorkspaceCached
    });
    // The switch's identity is resolved NOW — tell the caller (see the
    // `onWorkspaceResolved` note on this function). `root.workspace` is read
    // back rather than `nextWorkspace` passed blind, so a rejected downgrade
    // (setActiveWorkspaceRecord's list-over-full guard) hands out the record
    // actually held. A null resolve still calls back: the handler's own
    // validator decides, and a no-candidate pass simply no-ops there.
    notifyWorkspaceResolved(root.workspace || nextWorkspace || null);
    // Re-scope the SHELL-LEVEL meet realtime channel to the new workspace
    // (isolation audit #7). The shell subscribes once at mount (app.js — the
    // OngoingCallBadge feed) and nothing re-invoked it on a switch, so the old
    // workspace's channel kept streaming into root.rooms/liveParticipants. The
    // subscription is workspace-keyed + re-entrant since 245f9761 — this call
    // tears the stale channel down and opens the new workspace's. Runs AFTER
    // the replace above so its workspace-first scope resolver reads the NEW
    // record. Always (not surface-gated): the badge is shell chrome. Same
    // element-shim calling convention as the chat re-open above.
    Promise.resolve((parcelRequire("9Rs24"))).then((m)=>m.subscribeMeetRealtime.call({
            state: {
                root: root
            }
        }, {
            tables: [
                'meet_rooms',
                'meet_participants'
            ]
        })).catch(()=>{});
    // Files desktop realtime — page-level channel; re-scope only when it exists
    // (or the user is sitting on /files). subscribeFilesRealtime tears down a
    // cross-workspace channel and resubscribes under the active one (245f9761).
    if (root._filesRealtimeUnsub || _path === '/files' || _slot === '/files') (parcelRequire("7E6nw")).then((m)=>m.subscribeFilesRealtime.call({
            state: {
                root: root
            }
        })).catch(()=>{});
    // Dashboard prefs for the NEW workspace — started now (post-wipe, so the
    // replace above can't clobber the landed row) and AWAITED in the essential
    // set below: the home grid re-converges from this row, so revealing before
    // it lands re-shuffles the dashboard in front of the user (the boot bounce,
    // switch flavor — 2026-07-27 per Nika). Pinned to activeWsId explicitly
    // (root.workspace keeps the PREVIOUS record when the refetch above failed)
    // and routed through the epoch-guarded `put` so a superseded switch's late
    // row never repaints the newer switch's dashboard.
    const _switchErrors = [];
    (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
        state: 'loading'
    });
    const _prefsPromise = Promise.all($e8c85d000cc7c6c2$export$5dd6614217005c03(root, sdk, {
        tag: 'workspace-change: ',
        workspaceId: activeWsId,
        write: put,
        onError: (phase)=>_switchErrors.push(phase)
    }));
    // Keep the completion path attached after the reveal budget expires. A
    // pending roster/team read is neither confirmed empty nor disposable.
    const _essentialsWork = Promise.all([
        _peoplePromise,
        _teamsPromise,
        _prefsPromise
    ]).then(([_peopleData, _teamsRes])=>{
        if (superseded()) return;
        if (Array.isArray(_peopleData)) {
            const all = _peopleData.map($e8c85d000cc7c6c2$export$f65a76329791bc8a);
            const _people = $e8c85d000cc7c6c2$var$filterToActiveOrg(all, root);
            put({
                peopleAll: all,
                people: _people,
                peopleLoaded: true,
                birthdays: $e8c85d000cc7c6c2$var$_deriveBirthdays(_people)
            });
        }
        if (_teamsRes) {
            const { teams: teams = [], teamsByEmail: teamsByEmail = {}, orgMembersByOrgId: orgMembersByOrgId = {} } = _teamsRes;
            put({
                teams: teams,
                teamsByEmail: teamsByEmail,
                orgMembersByOrgId: orgMembersByOrgId
            });
        }
    });
    // Unpack the NEW workspace's project (skin/navbar/panels/apps + records) into
    // context, THEN apply its config. On a switch this runs AFTER the replace()
    // above reset root.workspaceSettings AND repointed root.workspace at the new
    // record, so the previous workspace's project + skin are cleared and the new
    // one's are applied — the deactivate-old / activate-new cycle. A workspace with
    // no project (and no Mongo settings) reverts to the framework default.
    //
    // BOUNDED (WS-SWITCH-ONWORKSPACECHANGE-BOUNDED-WINDOW-TRIP-1): the module
    // load is the one pre-reveal phase that legitimately runs for many seconds —
    // it fetches the published module and its chunks, and a COLD dev chunk fetch
    // alone outran the whole 10s watchdog window on a Bellforge activation (see
    // the prewarm note in workspaceProjects.js). Waiting for it is a preference
    // (reveal on a fully-applied module), never a requirement: the loader must
    // not hang on it. Past the budget the pass reveals with the workspace data it
    // already has, and the module applies itself when it lands — the same
    // epoch/staleness guards the loaders already enforce.
    //
    // The page the person waits for is the takeover plus the app the URL names
    // (whenAppRouteReady; the home needs none). Config applies at that gate, as
    // on boot, and again once every app has published. `_moduleWork` still
    // covers every app for the final ready/error, and the loader still waits
    // for it up to the budget.
    let _releaseModuleReveal = ()=>{};
    const _moduleReveal = new Promise((resolve)=>{
        _releaseModuleReveal = resolve;
    });
    const _moduleWork = (async ()=>{
        await (0, $7ytvD.loadWorkspaceProject)(root, sdk);
        if (superseded()) return;
        const _appsRun = (0, $7ytvD.loadWorkspaceApps)(root, sdk);
        (0, $7ytvD.whenAppRouteReady)(root).then(()=>{
            if (!superseded()) try {
                (0, $g7CNh.applyWorkspaceConfig)(root);
            } catch (e) {
                console.warn('[workspace-project] workspace-change: applyWorkspaceConfig (reveal) failed', e);
            }
            _releaseModuleReveal();
        });
        await _appsRun;
        if (superseded()) return;
        (0, $g7CNh.applyWorkspaceConfig)(root);
    })();
    _moduleWork.then(_releaseModuleReveal, _releaseModuleReveal);
    // The notice speaks for that page and the essential set, never for apps
    // still setting up in the background (boot fix step 2). It waited for every
    // app, so a switch into a workspace with many apps said "still loading" over
    // a ready home until the last app answered. 'slow' is now written only while
    // this set is out, and steps back once it lands.
    let _revealSetIn = false;
    const _revealSet = Promise.all([
        _moduleReveal,
        _essentialsWork
    ]);
    _revealSet.then(()=>{
        _revealSetIn = true;
    }, ()=>{});
    Promise.all([
        _moduleWork,
        _essentialsWork
    ]).then(()=>{
        if (!superseded()) (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
            state: _switchErrors.length ? 'error' : 'ready',
            failed: [
                ...new Set(_switchErrors)
            ]
        });
    }, (error)=>{
        console.warn('[workspace-project] workspace-change: activation failed', error);
        if (!superseded()) (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
            state: 'error'
        });
    });
    const _moduleRow = await _phase('module-activate', ()=>_moduleWork, $e8c85d000cc7c6c2$var$_BOUNDED);
    // A newer switch superseded this one during the workspace/module resolve —
    // stop before writing/revealing so its late writes never repaint stale data.
    if (superseded()) return;
    // ESSENTIAL set — await the roster + teams (both already in flight from the
    // top, so this resolves the moment the module load above finishes) plus the
    // new workspace's dashboard-prefs row, and put them post-wipe
    // (epoch-guarded). These are what the UI reveals with.
    const _essentialRow = await _phase('essential-set', ()=>_essentialsWork, $e8c85d000cc7c6c2$var$_BOUNDED);
    if ((_moduleRow === $e8c85d000cc7c6c2$var$_BOUNDED || _essentialRow === $e8c85d000cc7c6c2$var$_BOUNDED) && !_revealSetIn && !superseded()) {
        const _slowStamp = (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
            state: 'slow'
        });
        _revealSet.then(()=>{
            if (!superseded()) (0, $7ytvD.settleWorkspaceActivation)(root, 'core', _slowStamp, {
                state: 'loading'
            });
        }, ()=>{});
    }
    // REVEAL — clear the switch loader now that the essential data landed (only the
    // current, non-superseded switch clears it — endDataLoad's epoch check is the
    // same invariant for the flag itself). Everything else fills in behind the
    // revealed UI via the non-blocking tail below.
    if (superseded()) return;
    // The switch flags are THIS pipeline's to clear even when a newer
    // _dataLoading raise owns the flag itself (endDataLoad → false): deliver
    // them via the epoch-guarded put so the loader can't wedge on _wsSwitching.
    const _revealPatch = {
        _wsSwitching: null,
        _pendingActiveOrgId: null
    };
    if (!$e8c85d000cc7c6c2$export$4b5c0a90ed16927c(root, _dlEpoch, _revealPatch)) put(_revealPatch);
    // Reached the reveal normally — the watchdog above is now moot; clearing it
    // (rather than relying solely on its own no-op check) means a genuinely slow
    // but successful switch never risks a spurious loud error landing after the
    // fact.
    clearTimeout(_wsChangeWatchdog);
    // A synchronous state subscriber can start another switch during reveal.
    if (superseded()) return;
    // NON-BLOCKING TAIL (P1) — the remaining workspace-scoped refetches, fired like
    // boot's fan-out (void Promise.all, NOT awaited): each self-hydrates via the
    // epoch-guarded put, nothing downstream reads them synchronously, so they fill
    // in behind the already-revealed UI instead of pinning the loader on the
    // slowest of them (chat.messages limit 500 / calendar limit 2000 on a cold
    // backend was the 8-10s switch).
    //
    // The tickets entries below read through an ELEMENT: every tickets loader
    // starts with `el.call('getSDK')` (the frank-safe call), and the root STATE
    // has no `call`, so they take the state's back-pointer element (FA001; the
    // same handle `disconnectCall` uses above). Handed the state, every read
    // failed at once ("el.call is not a function") and My tickets and the
    // activity feed came back empty after each switch.
    const _ticketsEl = root.__element;
    Promise.all([
        // Member→team mapping + member→role mapping — the essential set above put
        // `teamsByEmail: {}` (loadAllTeams always returns it empty — the per-team
        // fetch is deferred, same as cold boot) and never refreshed `root.roles`
        // at all. Cold boot's fan-out chains loadAllTeamMembers after loadAllTeams
        // resolves and calls _loadRoles once; this switch path did NEITHER, so
        // after ANY org/workspace switch, /people and /admin permanently grouped
        // every member under "No team"/"Unassigned" (teamsByEmail never filled in
        // for the new org) and role badges kept showing the PREVIOUS org's
        // member-role mapping (`root.roles.byUser` is keyed by the global userId,
        // not scoped per-org, and nothing re-ran the fetch) — see tickets/
        // sonnet.md TEAM-GROUPING-1 / ROLE-FLIP-1. `loadAllTeamMembers` no-ops
        // safely if `root.teams` isn't populated yet (guarded internally).
        _essentialsWork.then(()=>{
            if (!superseded()) return (0, $kg2OA.loadAllTeamMembers)(_teamRoot);
        }).then(()=>put({
                teamsByEmailLoaded: true
            })).catch((e)=>console.warn('[workspace-project] workspace-change: team members failed', e)),
        $e8c85d000cc7c6c2$export$369b2b325a258b20(root, sdk).catch((e)=>console.warn('[workspace-project] workspace-change: member-roles fetch failed', e)),
        sdk.execute('workspaceProject.announcements', 'list', {
            order: 'date'
        }).then((data)=>{
            if (!data) return;
            put({
                announcements: data.map((r)=>({
                        id: r.id,
                        title: r.title,
                        author: r.author,
                        // Same split as _person's avatar: URL-or-empty, letters in
                        // their own field.
                        authorAvatar: typeof r.author_avatar === 'string' && /^(https?:|\/)/.test(r.author_avatar) ? r.author_avatar : '',
                        authorInitials: (0, $aGIjc.initials)(r.author),
                        authorRole: r.author_role,
                        date: r.date,
                        readTime: r.read_time,
                        tag: r.tag,
                        cover: r.cover,
                        excerpt: r.excerpt,
                        body: r.body,
                        reactions: r.reactions || {},
                        audience: r.audience === 'external' ? 'external' : 'internal',
                        externalUrl: r.external_url || r.externalUrl || ''
                    }))
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: announcements fetch failed', e)),
        (()=>{
            const min = new Date(Date.now() - 86400000).toISOString();
            const max = new Date(Date.now() + 1209600000).toISOString();
            return sdk.execute('workspaceProject.calendar', 'list', {
                filter: {
                    deleted: false,
                    start_at: {
                        gte: min,
                        lte: max
                    }
                },
                order: 'start_at',
                limit: 500
            }).then((data)=>{
                if (!data) return;
                const me = root.currentUserEmail || '';
                const byKey = new Map();
                for (const r of data){
                    const key = r.google_event_id || `local-${r.id}`;
                    const existing = byKey.get(key);
                    if (!existing) {
                        byKey.set(key, r);
                        continue;
                    }
                    if (r.google_calendar_id === me && existing.google_calendar_id !== me) byKey.set(key, r);
                }
                put({
                    intranetEvents: [
                        ...byKey.values()
                    ].map((r)=>({
                            id: r.id,
                            title: r.title,
                            startAt: r.start_at,
                            endAt: r.end_at,
                            location: r.description ? r.description.slice(0, 60) : '',
                            // Carry the FULL description + invitees through so the home
                            // "Coming up" event modal shows them directly. The modal's
                            // lazy fetchEventDetails 404s on home (no GET
                            // /calendar/events/:id route — only `list` exists) and
                            // root.events is empty here, so this seed is the only source
                            // (2026-06-08 per Nika "data not loading in Coming up event
                            // modals"). The list response already includes both fields.
                            description: r.description ?? null,
                            invitees: Array.isArray(r.invitees) ? r.invitees : [],
                            attendees: Array.isArray(r.invitees) ? r.invitees : [],
                            organizerEmail: r.organizer_email,
                            googleEventId: r.google_event_id
                        })),
                    intranetEventsLoaded: true,
                    intranetEventsError: false
                });
            }).catch((e)=>{
                console.warn('[workspace-project] workspace-change: calendar_events fetch failed', e);
                put({
                    intranetEventsError: true
                });
            });
        })(),
        // intranet `stories` removed — dead boot fetch (StoriesWidget deleted
        // 2026-06-02, no root.stories consumer). See 0162_drop_dead_stories.sql.
        // resource_links migrated to Mongo at /resource-links/*.
        sdk.execute('resourceLinks', 'list', {}).then((res)=>{
            const data = Array.isArray(res) ? res : res?.data || [];
            if (data?.length) put({
                resourceLinks: data
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: resource_links fetch failed', e)),
        // user_documents migrated to Mongo as `docs` with type='user_document'.
        $e8c85d000cc7c6c2$var$shellIsCommHost() ? null : sdk.execute('docs.userDocs', 'list', {}).then((res)=>{
            const data = Array.isArray(res) ? res : res?.data || [];
            if (data?.length) put({
                userDocs: data
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: user_documents fetch failed', e)),
        // (homeDashboardPrefs moved OUT of this tail into the awaited essential
        // set above — the reveal must show the new workspace's real dashboard.)
        (0, $bShA0.fetchOrgNotifCount)(root).catch((e)=>console.warn('[workspace-project] workspace-change: org-notifications fetch failed', e)),
        // Tickets re-fetches — only fire when the corresponding state slot
        // was populated BEFORE the wipe (i.e., user is currently on or has
        // visited a tickets page this session). The `had*` snapshot is
        // captured at the top of this function before `root.replace` clears
        // these slots; checking the post-wipe `root.X` directly would always
        // return empty and skip the refetches. On a cold mount of /tickets
        // the page's own onCreate handles the first fetch.
        //
        // The BOARD itself is not reloaded here: the board page's own loader
        // (tickets pages/board.js `_loadBoard`, sequence-guarded) watches
        // `workspace` and every filter key and reloads on a real switch, and a
        // board that is not mounted loads on its next mount. The tail used to run
        // a second board reload (reloadTicketsForRoot) that wrote through
        // root.update, outside the epoch-guarded put and outside the board's
        // sequence guard. Since 819543f10 it failed before its first read and
        // then wrote empty counts and an empty board over the page's own wave; a
        // working copy would race that wave, and after a quick double switch could
        // paint the previous workspace's rows. So the tail only re-seeds the prefs.
        hadTicketsBoard || ticketsSurfaceActive ? Promise.resolve().then(function() {
            return (parcelRequire("7E6nw"));
        }).then((res)=>{
            // Board prefs went per-workspace (245f9761): the wipe re-armed
            // the seed latch, so re-seed from the NEW workspace's storage
            // blob before the board repaints (a mounted board never
            // remounts, so nothing else would). The seed's filter writes and
            // the new `workspace` record start the board's own reload.
            // el.call through the root element (see `_ticketsEl` above): a
            // bare call of the library import as its own statement shipped
            // unresolved in the frank payload.
            if (_ticketsEl && typeof _ticketsEl.call === 'function') _ticketsEl.call('seedTicketsBoardPrefs', root);
        }).catch((e)=>console.warn('[workspace-project] workspace-change: tickets prefs seed failed', e)) : Promise.resolve(),
        hadMyTickets && root.currentUserEmail ? (0, $2rYsV.fetchTicketsAssignedTo)(_ticketsEl, root.currentUserEmail, 100).then((rows)=>put({
                myTickets: rows
            })).catch((e)=>console.warn('[workspace-project] workspace-change: myTickets fetch failed', e)) : Promise.resolve(),
        hadFeedItems ? (0, $gXXSj.fetchActivityFeed)(_ticketsEl, {
            limit: 80
        }).then((items)=>put({
                feedItems: items
            })).catch((e)=>console.warn('[workspace-project] workspace-change: feedItems fetch failed', e)) : Promise.resolve(),
        // Documents / files desktop (isolation audit #2) — these keys joined the
        // wipe registry; the same had-or-active convention refetches them for the
        // NEW workspace so a mounted surface never strands blank (the fetch
        // plugin is create-only). Reloaders live in the OWNING packages and reuse
        // the pages' declarative transforms; dynamic import mirrors the chat
        // subscribeRealtime pattern (no static cross-package cycle).
        hadDocuments || documentsSurfaceActive || homeSurfaceActive ? (parcelRequire("7v8J3")).then((m)=>m.reloadDocsAfterSwitch(root, sdk, put)).catch((e)=>console.warn('[workspace-project] workspace-change: documents reload failed', e)) : Promise.resolve(),
        hadFileNodes || filesSurfaceActive ? (parcelRequire("frY0s")).then((m)=>m.reloadFilesAfterSwitch(root, sdk, put)).catch((e)=>console.warn('[workspace-project] workspace-change: files reload failed', e)) : Promise.resolve(),
        // Credit guard — wiped by the registry (workspace-scoped balance);
        // refetch UNCONDITIONALLY: the blocker/banner are policy gates that must
        // re-evaluate for the NEW tenant whether or not the old one had data.
        (0, $2Od7Q.loadCreditGuard)(root, sdk).catch((e)=>console.warn('[workspace-project] workspace-change: credit guard fetch failed', e)),
        // userPrefs was wiped by the registry but never refetched on a switch
        // (the inverse leak — preferences went BLANK after every switch; audit
        // runners-up). Same call the boot chain makes.
        hadUserPrefs ? sdk.execute('workspaceProject.userPreferences', 'get').then((data)=>{
            // No row (a new account) is a loaded, empty row — see the boot read.
            put({
                userPrefs: data && typeof data === 'object' ? data : {}
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: user_preferences fetch failed', e)) : Promise.resolve(),
        // companyInfo joined the wipe registry (org financial identity must not
        // bleed across orgs) — re-derive from the NEW workspace's settings bag
        // when the surface used it (root.workspace was repointed by the replace
        // above, so this reads the fresh record).
        hadCompanyInfo || companySurfaceActive ? Promise.resolve().then(function() {
            return (parcelRequire("frY0s"));
        }).then(async (res)=>{
            // §5 RENDER site. Unlike the boot path above, this one had no fetch
            // fallback at all — it is a post-switch re-derive off whatever record
            // the switch just adopted. When that adoption was the LEAN fallback
            // row (onWorkspaceChange's `full || stampWorkspaceShape(hq, 'list')`
            // path), `settings.companyInfo` was `undefined` and this published
            // `[]` — rendering "this org has no company info" over an org that
            // has some, permanently: nothing re-derives companyInfo later, and
            // §6's converge covers the config chain, not this row.
            //
            // So mirror the boot path and complete the read. `getWorkspaceCached`
            // is the same coalescer §4c's auto-fetch rides, so this joins that
            // in-flight request rather than adding a second one.
            const { settings: heldSettings, ready: ready, id: wsId } = $e8c85d000cc7c6c2$var$shellWorkspaceSettings(root);
            let settings = ready ? heldSettings : null;
            if (!settings && wsId && typeof sdk.getWorkspace === 'function') try {
                settings = (await getWorkspaceCached(sdk, wsId))?.settings;
            } catch (e) {
                console.warn('[workspace-project] workspace-change: company-info fetch failed', e);
            }
            const info = settings?.companyInfo;
            const rows = Array.isArray(info) ? info : info ? [
                info
            ] : [];
            put({
                companyInfo: rows
            });
        }) : Promise.resolve(),
        // Chat — same conditional-refetch convention as tickets above.
        // Only fire when the user was previously on /chat (`channels` is
        // populated by the page's mount-time fetch declarations). A cold
        // mount of /chat later still re-fetches via the page's own
        // `fetch: [...]` blocks; this only keeps the in-memory cache
        // consistent for users currently looking at the chat surface
        // when the switch happened.
        hadChannels || chatSurfaceActive || homeSurfaceActive ? sdk.execute('workspaceProject.chat', 'list').then((data)=>{
            if (!data) return;
            const list = Array.isArray(data) ? data : data?.data || [];
            // Scope to the NEW workspace — the server list is the
            // workspace ∪ membership union; writing it verbatim right
            // after the PHASE 1 wipe restored the cross-tenant rows.
            put({
                channels: (0, $4CrGc.filterChannelsToActiveWorkspace)(list.map((0, $4CrGc.rowToChannel)), (0, $4CrGc.getActiveWorkspaceId)(root))
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: chat.channels fetch failed', e)) : Promise.resolve(),
        hadChannels || chatSurfaceActive ? sdk.execute('workspaceProject.chat.members', 'list').then((data)=>{
            if (!data) return;
            const list = Array.isArray(data) ? data : data?.data || [];
            put({
                channelMembers: (0, $4CrGc.scopeMembersToActiveWorkspace)(list, root)
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: chat.members fetch failed', e)) : Promise.resolve(),
        // Mentions were wiped in PHASE 1 (myMentions) but never refetched —
        // badges stayed empty until a full /chat remount. Refetch alongside
        // the other chat slices, scoped to the new workspace.
        hadChannels || chatSurfaceActive ? sdk.execute('workspaceProject.chat.mentions', 'list', {
            options: {
                order: 'created_at'
            }
        }).then((data)=>{
            if (!data) return;
            const rows = Array.isArray(data) ? data : data?.data || [];
            put({
                myMentions: rows.filter((r)=>(0, $4CrGc.rowInActiveWorkspace)(root, r))
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: chat.mentions fetch failed', e)) : Promise.resolve(),
        hadChatMessages || chatSurfaceActive ? sdk// `ascending: false` used to sit alongside `order` here. Dropped
        // 2026-09-22: this endpoint ignores sorting options altogether
        // (verified against dev.api.symbols.app — see chat/functions/collab/
        // queries.js `listMessages` for the full account) and always answers
        // oldest row first. Keeping a dead key around invites the next reader
        // to trust it.
        .execute('workspaceProject.chat.messages', 'list', {
            options: {
                limit: 500,
                order: 'created_at'
            }
        }).then((data)=>{
            if (!data) return;
            const rows = Array.isArray(data) ? data : data?.data || [];
            const byCh = {};
            for (const r of rows){
                // Workspace-scope each row — the bulk read spans every
                // RLS-visible channel across workspaces.
                if (!(0, $4CrGc.rowInActiveWorkspace)(root, r)) continue;
                const m = (0, $4CrGc.rowToMessage)(r);
                if (!byCh[m.channelId]) byCh[m.channelId] = [];
                byCh[m.channelId].push(m);
            }
            // Sort oldest → newest, the one order ChatMessageList renders.
            // This `put` writes the whole container, bypassing chatUtils
            // `setChannelMessages`, so it has to apply the invariant itself.
            // The `.reverse()` it replaces assumed the server answered
            // newest-first; it answers oldest-first, so the reverse was
            // actively creating the inverted channel Jerry reported.
            for(const k in byCh)byCh[k] = (0, $4CrGc.sortMessagesByTime)(byCh[k]);
            put({
                messagesByChannel: byCh
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: chat.messages fetch failed', e)) : Promise.resolve(),
        // AI Assistant threads — same conditional-refetch convention as chat
        // above (only when the user had threads, or the panel was open, in
        // the previous workspace). Through the root element's el.call (the
        // registered aiChatListThreads; this = root element), NOT a relative
        // `import('./aiAssistantThreads.js')`: frank cannot rebuild a
        // project-local dynamic import, so the published switch threw on the
        // bundler's leftover export wiring and never refetched
        // (shellPublishedEmission.test.js). `root.activeWorkspaceId` was
        // already mirrored from `sdk._context.activeWorkspaceId` above, so the
        // SDK call scopes to the workspace actually switched into.
        hadAiThreads ? Promise.resolve().then(()=>{
            const hostEl = root.__element;
            if (hostEl && typeof hostEl.call === 'function') return hostEl.call('aiChatListThreads', root);
        }).catch((e)=>console.warn('[workspace-project] workspace-change: aiChat threads fetch failed', e)) : Promise.resolve(),
        // SIMONE conversation core — PHASE-2 pair for the bucket-E drain
        // (WS-SWITCH-INCOMPLETE-1 step 8). `hydrateServerSessions` is the SAME
        // function Chat.onCreate runs on mount; it pins the AI service to the
        // active workspace itself (pinWorkspace), so it lists the NEW workspace's
        // member conversations. Runs on the root element via `el.call` (this =
        // root element, `state.root` = root) — `root.__element` is the state's
        // own back-pointer, no fake host. General scope only: the add-app thread
        // (`_ax_*`) hangs off `_addAppProjectId`, which the wipe nulls, and
        // re-hydrates when the page selects an extension again.
        hadSimoneSessions ? Promise.resolve().then(()=>{
            const hostEl = root.__element;
            if (hostEl && typeof hostEl.call === 'function') return hostEl.call('hydrateServerSessions', 'general');
        }).catch((e)=>console.warn('[workspace-project] workspace-change: simone sessions hydrate failed', e)) : Promise.resolve(),
        // ASK-USER decision rows — same pair. `fetchAskUserDecisions` RETURNS the
        // filtered rows (it does not write root), so `put` lands them
        // epoch-guarded like every other PHASE-2 slice. Dynamic import for the
        // same static-cycle reason as aiAssistantThreads above.
        hadAskUserDecisions ? Promise.resolve((parcelRequire("cGe9G"))).then(({ fetchAskUserDecisions: fetchAskUserDecisions })=>fetchAskUserDecisions(root)).then((rows)=>{
            if (Array.isArray(rows)) put({
                askUserDecisions: rows
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: ask-user decisions fetch failed', e)) : Promise.resolve(),
        // Calendar / Meet page caches — same shape as chat above. Only
        // refetched when the user was on /calendar or /meet (page's own
        // `fetch: [...]` declaration only fires on mount).
        //
        // CALENDAR-PAGE-CACHE-WINDOW (2026-05-22): the previous code called
        // `sdk.execute('workspaceProject.calendar', 'list')` with NO args
        // and wrote the raw response straight into `root.events`. Two bugs
        // compounded:
        //   1. Without filter + limit, the server returned its default page
        //      (1000 oldest-first rows by start_time ASC) — the cache write
        //      CLOBBERED the page's own filtered ±14d fetch with March-2026
        //      data that contained nothing in the current week.
        //   2. The raw Supabase rows use snake_case (`google_calendar_id`,
        //      `start_at`, ...) but the calendar grid views filter on the
        //      camelCase shape `rowToEvent` produces (`googleCalendarId`,
        //      `startAt`, ...). Even when a row matched the current week,
        //      the filter never matched the user's email.
        // Mirror the page declaration: same window, same limit, and shape
        // every row through the same camelCase mapping as `rowToEvent` in
        // the calendar page. Inlined here (not imported) because the
        // workspace-shell must not depend on the calendar package.
        hadCalendarEvents || calendarSurfaceActive ? (()=>{
            const min = new Date(Date.now() - 1209600000).toISOString();
            const max = new Date(Date.now() + 1209600000).toISOString();
            return sdk.execute('workspaceProject.calendar', 'list', {
                filter: {
                    deleted: false,
                    start_at: {
                        gte: min,
                        lte: max
                    }
                },
                order: 'start_at',
                limit: 2000
            }).then((data)=>{
                if (!data) return;
                const list = Array.isArray(data) ? data : data?.data || [];
                const mapped = list.map((r)=>({
                        id: r.id,
                        title: r.title,
                        date: r.date,
                        startTime: r.start_time,
                        endTime: r.end_time,
                        endDate: r.end_date,
                        startAt: r.start_at || null,
                        endAt: r.end_at || null,
                        color: r.color,
                        type: r.type || 'meeting',
                        description: r.description,
                        invitees: r.invitees,
                        reminderMinutes: r.reminder_minutes ?? null,
                        creatorEmail: r.organizer_email,
                        googleEventId: r.google_event_id,
                        googleCalendarId: r.google_calendar_id
                    }));
                put({
                    events: mapped
                });
            }).catch((e)=>console.warn('[workspace-project] workspace-change: calendar.events fetch failed', e));
        })() : Promise.resolve(),
        // Profile page — re-resolve the viewed user against the NEW tenant's
        // roster and refetch its activity heatmap + public projects. `put` is the
        // epoch-guarded writer, so a superseded switch drops its patch exactly
        // like every other PHASE-2 slice. The roster (`peopleAll`) is re-put by
        // this same pass; `hydrateUserProfile` re-fetches it itself when it is
        // still empty at that moment, so the two orders both resolve.
        profileSurfaceActive ? (0, $jn5Js.hydrateUserProfile)(root, {
            write: put
        }).catch((e)=>console.warn('[workspace-project] workspace-change: user profile rehydrate failed', e)) : Promise.resolve(),
        // History app — the log slice was wiped in PHASE 1 and the page's own read
        // ran once, at mount. Read the NEW workspace's log through the caller's SDK
        // and the epoch-guarded `put`, so a superseded switch never lands its rows
        // (functions/history.js loadHistoryEvents also drops a reply that outlived
        // its workspace).
        historySurfaceActive ? (0, $7nvlv.loadHistoryEvents)(root, {
            sdk: sdk,
            write: put
        }).catch((e)=>console.warn('[workspace-project] workspace-change: history reload failed', e)) : Promise.resolve(),
        // Getting started → Team — the NEW workspace's found people, through the
        // caller's SDK and the epoch-guarded `put` (the loader also drops a reply
        // that outlived its workspace).
        gettingStartedSurfaceActive ? (0, $1OhIx.loadGettingStartedTeam)(root, {
            sdk: sdk,
            write: put
        }).catch((e)=>console.warn('[workspace-project] workspace-change: getting-started team reload failed', e)) : Promise.resolve(),
        // Getting started → Imports — the NEW workspace's found sources, the
        // same way.
        gettingStartedImportsActive ? (0, $fJThD.loadGettingStartedImports)(root, {
            sdk: sdk,
            write: put
        }).catch((e)=>console.warn('[workspace-project] workspace-change: getting-started imports reload failed', e)) : Promise.resolve(),
        hadMeetRooms || meetSurfaceActive ? sdk.execute('workspaceProject.meet.rooms', 'list').then((data)=>{
            if (!data) return;
            const list = Array.isArray(data) ? data : data?.data || [];
            put({
                rooms: list
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: meet.rooms fetch failed', e)) : Promise.resolve(),
        hadMeetWaitingRoom ? sdk.execute('workspaceProject.meet.waitingRoom', 'list').then((data)=>{
            if (!data) return;
            const list = Array.isArray(data) ? data : data?.data || [];
            put({
                waitingRoom: list
            });
        }).catch((e)=>console.warn('[workspace-project] workspace-change: meet.waitingRoom fetch failed', e)) : Promise.resolve()
    ]);
};
async function $e8c85d000cc7c6c2$export$e2ce85a0cbd4d3ae() {
    const root = this.state?.root || this.state;
    if (!root || root.signedIn === false) return;
    const generation = $e8c85d000cc7c6c2$export$254ef76a6207537d();
    const workspaceId = String(root.workspace?.id || root.workspace?._id || '');
    try {
        const sdk = this.sdk || (0, $1X0Je.default).functions.getSDK();
        return await $e8c85d000cc7c6c2$export$e3141ac8004c427e(root, sdk, {
            background: true
        });
    } catch (error) {
        console.warn('[workspace-project] activation retry failed', error);
        if (!$e8c85d000cc7c6c2$export$ca6d91143d80876a(generation) && String(root.workspace?.id || root.workspace?._id || '') === workspaceId) (0, $7ytvD.updateWorkspaceActivation)(root, 'core', {
            state: 'error'
        });
    }
}

});
parcelRegister("8BRyL", function(module, exports) {

$parcel$export(module.exports, "homeContextAction", () => $019e1e3f0a85c670$export$142a1380a75551d);
$parcel$export(module.exports, "focusContextMenu", () => $019e1e3f0a85c670$export$f45f0c1633185f6b);
$parcel$export(module.exports, "focusHomeContextMenu", () => $019e1e3f0a85c670$export$1e5010e2fb47abf7);
$parcel$export(module.exports, "homeContextMenuAllowed", () => $019e1e3f0a85c670$export$816fa6275d9a9abe);
$parcel$export(module.exports, "closeContextMenuOnEscape", () => $019e1e3f0a85c670$export$d828ab43b0b127a);
$parcel$export(module.exports, "closeContextMenuOnRouteChange", () => $019e1e3f0a85c670$export$b218a894899859d6);
$parcel$export(module.exports, "homeWidgetAiTarget", () => $019e1e3f0a85c670$export$ff218d764e4648ea);
$parcel$export(module.exports, "homeWidgetChangeWithAi", () => $019e1e3f0a85c670$export$a7af41eaaba8bf85);
$parcel$export(module.exports, "startOAuthFlow", () => $019e1e3f0a85c670$export$a0675cce39901380);
$parcel$export(module.exports, "mountSandboxedApp", () => $019e1e3f0a85c670$export$a8697a476f6e84cd);
$parcel$export(module.exports, "generatedAppBlockedDef", () => $019e1e3f0a85c670$export$95f420f8bbfa37e6);
$parcel$export(module.exports, "buildInlineExtensionDef", () => $019e1e3f0a85c670$export$98c43e9a748fcd98);
$parcel$export(module.exports, "buildInlineMultiPageDef", () => $019e1e3f0a85c670$export$cc37101470185811);
$parcel$export(module.exports, "renderExtensionInPane", () => $019e1e3f0a85c670$export$45cb414de673c07c);
$parcel$export(module.exports, "renderMultiPageApp", () => $019e1e3f0a85c670$export$e828463b5aae626a);
$parcel$export(module.exports, "loadAddAppExtensions", () => $019e1e3f0a85c670$export$81eb6ebceb4f41a9);
$parcel$export(module.exports, "selectAddAppExtension", () => $019e1e3f0a85c670$export$1d5afaa8f1a16c00);
$parcel$export(module.exports, "consumeAddAppOpenId", () => $019e1e3f0a85c670$export$1baf68ec7d4b98f3);
$parcel$export(module.exports, "hydrateAddAppThread", () => $019e1e3f0a85c670$export$5a82f96512292191);
$parcel$export(module.exports, "ensureChatContext", () => (parcelRequire("hcWAT")).ensureChatContext);
$parcel$export(module.exports, "openMessenger", () => (parcelRequire("hcWAT")).openMessenger);
$parcel$export(module.exports, "ensureMailContext", () => (parcelRequire("lXQF7")).ensureMailContext);
$parcel$export(module.exports, "ensureDocumentsContext", () => (parcelRequire("4v0cn")).ensureDocumentsContext);
$parcel$export(module.exports, "ensureMeetContext", () => (parcelRequire("9Lsv8")).ensureMeetContext);
$parcel$export(module.exports, "ensureMarketplaceUninstallDialog", () => (parcelRequire("4B6D0")).ensureMarketplaceUninstallDialog);
$parcel$export(module.exports, "redirectIfExternalOnly", () => (parcelRequire("eb4QA")).redirectIfExternalOnly);
$parcel$export(module.exports, "initials", () => (parcelRequire("aGIjc")).initials);
$parcel$export(module.exports, "formatTime", () => (parcelRequire("8z3sU")).formatTime);
$parcel$export(module.exports, "formatMonthShort", () => (parcelRequire("8z3sU")).formatMonthShort);
$parcel$export(module.exports, "formatShortDate", () => (parcelRequire("8z3sU")).formatShortDate);
$parcel$export(module.exports, "shellSendPrompt", () => (parcelRequire("4QxwL")).sendPrompt);
$parcel$export(module.exports, "buildExtensionDataBridge", () => (parcelRequire("gvbDt")).buildExtensionDataBridge);
$parcel$export(module.exports, "auditExtensionSource", () => (parcelRequire("gvbDt")).auditExtensionSource);
$parcel$export(module.exports, "declaredEntitiesFromSpec", () => (parcelRequire("gvbDt")).declaredEntitiesFromSpec);
$parcel$export(module.exports, "extensionEntitySupport", () => (parcelRequire("gvbDt")).extensionEntitySupport);
$parcel$export(module.exports, "BACKED_RECORD_ENTITIES", () => (parcelRequire("gvbDt")).BACKED_RECORD_ENTITIES);
$parcel$export(module.exports, "saveExtension", () => (parcelRequire("jw8v7")).saveExtension);
$parcel$export(module.exports, "requestShareExtension", () => (parcelRequire("jw8v7")).requestShareExtension);
$parcel$export(module.exports, "confirmShareExtension", () => (parcelRequire("jw8v7")).confirmShareExtension);
$parcel$export(module.exports, "saveAnswerViewAsApp", () => (parcelRequire("jw8v7")).saveAnswerViewAsApp);
$parcel$export(module.exports, "addAppSavePress", () => (parcelRequire("jw8v7")).addAppSavePress);
$parcel$export(module.exports, "addAppSaveStatus", () => (parcelRequire("jw8v7")).addAppSaveStatus);
$parcel$export(module.exports, "_toChatMessages", () => (parcelRequire("3YHy5"))._toChatMessages);
$parcel$export(module.exports, "ensureActiveSession", () => (parcelRequire("3YHy5")).ensureActiveSession);
$parcel$export(module.exports, "shellHydrateServerSessions", () => (parcelRequire("3YHy5")).hydrateServerSessions);
$parcel$export(module.exports, "shellNewSession", () => (parcelRequire("3YHy5")).newSession);
$parcel$export(module.exports, "openAgentThread", () => (parcelRequire("3YHy5")).openAgentThread);
$parcel$export(module.exports, "shellRestoreActiveThread", () => (parcelRequire("3YHy5")).restoreActiveThread);
$parcel$export(module.exports, "markThreadTurn", () => (parcelRequire("3YHy5")).markThreadTurn);
$parcel$export(module.exports, "shellSwitchSession", () => (parcelRequire("3YHy5")).switchSession);
$parcel$export(module.exports, "shellDeleteSession", () => (parcelRequire("3YHy5")).deleteSession);
$parcel$export(module.exports, "toggleSessionMenu", () => (parcelRequire("3YHy5")).toggleSessionMenu);
$parcel$export(module.exports, "persistActiveSession", () => (parcelRequire("3YHy5")).persistActiveSession);
$parcel$export(module.exports, "refreshSessionsAfterTurn", () => (parcelRequire("3YHy5")).refreshSessionsAfterTurn);
$parcel$export(module.exports, "toggleStarSession", () => (parcelRequire("3YHy5")).toggleStarSession);
$parcel$export(module.exports, "shareSession", () => (parcelRequire("3YHy5")).shareSession);
$parcel$export(module.exports, "sessionContextItems", () => (parcelRequire("3YHy5")).sessionContextItems);
$parcel$export(module.exports, "sessionContextAction", () => (parcelRequire("3YHy5")).sessionContextAction);
$parcel$export(module.exports, "generatedNotifyHref", () => (parcelRequire("79dxh")).generatedNotifyHref);
$parcel$export(module.exports, "crmLeadsVisitorLine", () => (parcelRequire("XpvS7")).crmLeadsVisitorLine);
$parcel$export(module.exports, "ensureWorkspaceVoice", () => (parcelRequire("lkMHI")).ensureWorkspaceVoice);
$parcel$export(module.exports, "stopWorkspaceVoice", () => (parcelRequire("lkMHI")).stopWorkspaceVoice);
$parcel$export(module.exports, "acceptWorkspaceCall", () => (parcelRequire("lkMHI")).acceptWorkspaceCall);
$parcel$export(module.exports, "declineWorkspaceCall", () => (parcelRequire("lkMHI")).declineWorkspaceCall);
$parcel$export(module.exports, "hangUpWorkspaceCall", () => (parcelRequire("lkMHI")).hangUpWorkspaceCall);
$parcel$export(module.exports, "toggleWorkspaceCallMute", () => (parcelRequire("lkMHI")).toggleWorkspaceCallMute);
$parcel$export(module.exports, "toggleWorkspaceCallHold", () => (parcelRequire("lkMHI")).toggleWorkspaceCallHold);
$parcel$export(module.exports, "toggleWorkspaceCallKeypad", () => (parcelRequire("lkMHI")).toggleWorkspaceCallKeypad);
$parcel$export(module.exports, "pressWorkspaceCallDigit", () => (parcelRequire("lkMHI")).pressWorkspaceCallDigit);
$parcel$export(module.exports, "requestEndWorkspaceCall", () => (parcelRequire("lkMHI")).requestEndWorkspaceCall);
$parcel$export(module.exports, "cancelEndWorkspaceCall", () => (parcelRequire("lkMHI")).cancelEndWorkspaceCall);
$parcel$export(module.exports, "dismissWorkspaceCall", () => (parcelRequire("lkMHI")).dismissWorkspaceCall);
$parcel$export(module.exports, "workspaceCallEyebrow", () => (parcelRequire("lkMHI")).workspaceCallEyebrow);
$parcel$export(module.exports, "workspaceCallTitle", () => (parcelRequire("lkMHI")).workspaceCallTitle);
$parcel$export(module.exports, "workspaceCallClock", () => (parcelRequire("lkMHI")).workspaceCallClock);
$parcel$export(module.exports, "workspaceCallMeta", () => (parcelRequire("lkMHI")).workspaceCallMeta);
$parcel$export(module.exports, "workspaceCallMissed", () => (parcelRequire("lkMHI")).workspaceCallMissed);
$parcel$export(module.exports, "workspaceCallRingMayTakeFocus", () => (parcelRequire("lkMHI")).workspaceCallRingMayTakeFocus);
$parcel$export(module.exports, "workspaceCallClear", () => (parcelRequire("lkMHI")).workspaceCallClear);
$parcel$export(module.exports, "startWorkspaceCall", () => (parcelRequire("lkMHI")).startWorkspaceCall);
$parcel$export(module.exports, "workspaceCallAvailability", () => (parcelRequire("lkMHI")).workspaceCallAvailability);
$parcel$export(module.exports, "featureFlagGroupsWithFlags", () => (parcelRequire("gOQVi")).featureFlagGroupsWithFlags);
$parcel$export(module.exports, "AI_AWARENESS_PAGES", () => (parcelRequire("gzr3m")).AI_AWARENESS_PAGES);
$parcel$export(module.exports, "moduleRouteTitle", () => (parcelRequire("gzr3m")).moduleRouteTitle);
$parcel$export(module.exports, "buildSuggestions", () => (parcelRequire("gzr3m")).buildSuggestions);
$parcel$export(module.exports, "buildPageContext", () => (parcelRequire("gzr3m")).buildPageContext);
$parcel$export(module.exports, "shellBuildAiAwareness", () => (parcelRequire("gzr3m")).buildAiAwareness);
$parcel$export(module.exports, "selectPageItem", () => (parcelRequire("gzr3m")).selectPageItem);
$parcel$export(module.exports, "AI_ATTACHED_REF_CAP", () => (parcelRequire("i2kG6")).AI_ATTACHED_REF_CAP);
$parcel$export(module.exports, "readAiAttached", () => (parcelRequire("i2kG6")).readAiAttached);
$parcel$export(module.exports, "attachAiRef", () => (parcelRequire("i2kG6")).attachAiRef);
$parcel$export(module.exports, "detachAiRef", () => (parcelRequire("i2kG6")).detachAiRef);
$parcel$export(module.exports, "attachAiCanvas", () => (parcelRequire("i2kG6")).attachAiCanvas);
$parcel$export(module.exports, "clearAiAttached", () => (parcelRequire("i2kG6")).clearAiAttached);
$parcel$export(module.exports, "parseGeneratedAppSource", () => (parcelRequire("ggoif")).parseGeneratedAppSource);
$parcel$export(module.exports, "auditGeneratedAppSource", () => (parcelRequire("ggoif")).auditGeneratedAppSource);
$parcel$export(module.exports, "generatedAppAllowlist", () => (parcelRequire("ggoif")).generatedAppAllowlist);
$parcel$export(module.exports, "generatedAppSandboxOn", () => (parcelRequire("7qVzJ")).generatedAppSandboxOn);
$parcel$export(module.exports, "buildSandboxedAppDef", () => (parcelRequire("7qVzJ")).buildSandboxedAppDef);
$parcel$export(module.exports, "setWorkspaceModuleDev", () => (parcelRequire("7ytvD")).setWorkspaceModuleDev);
$parcel$export(module.exports, "clearWorkspaceModuleDev", () => (parcelRequire("7ytvD")).clearWorkspaceModuleDev);
$parcel$export(module.exports, "getAppsLoadOutcome", () => (parcelRequire("7ytvD")).getAppsLoadOutcome);
$parcel$export(module.exports, "getModuleLoadOutcome", () => (parcelRequire("7ytvD")).getModuleLoadOutcome);
$parcel$export(module.exports, "loadWorkspaceProject", () => (parcelRequire("7ytvD")).loadWorkspaceProject);
$parcel$export(module.exports, "loadWorkspaceApps", () => (parcelRequire("7ytvD")).loadWorkspaceApps);
$parcel$export(module.exports, "whenAppRouteReady", () => (parcelRequire("7ytvD")).whenAppRouteReady);
$parcel$export(module.exports, "updateWorkspaceActivation", () => (parcelRequire("7ytvD")).updateWorkspaceActivation);
$parcel$export(module.exports, "settleWorkspaceActivation", () => (parcelRequire("7ytvD")).settleWorkspaceActivation);
$parcel$export(module.exports, "workspaceActivationView", () => (parcelRequire("7ytvD")).workspaceActivationView);
$parcel$export(module.exports, "moduleRailActive", () => (parcelRequire("7ytvD")).moduleRailActive);
$parcel$export(module.exports, "moduleImmersiveActive", () => (parcelRequire("7ytvD")).moduleImmersiveActive);
$parcel$export(module.exports, "moduleImmersiveLanding", () => (parcelRequire("7ytvD")).moduleImmersiveLanding);
$parcel$export(module.exports, "moduleViewAsKey", () => (parcelRequire("7ytvD")).moduleViewAsKey);
$parcel$export(module.exports, "moduleViewAsActive", () => (parcelRequire("7ytvD")).moduleViewAsActive);
$parcel$export(module.exports, "readSlotFullscreenPref", () => (parcelRequire("7ytvD")).readSlotFullscreenPref);
$parcel$export(module.exports, "writeSlotFullscreenPref", () => (parcelRequire("7ytvD")).writeSlotFullscreenPref);
$parcel$export(module.exports, "slotFullscreenActive", () => (parcelRequire("7ytvD")).slotFullscreenActive);
$parcel$export(module.exports, "readModuleChromePref", () => (parcelRequire("7ytvD")).readModuleChromePref);
$parcel$export(module.exports, "writeModuleChromePref", () => (parcelRequire("7ytvD")).writeModuleChromePref);
$parcel$export(module.exports, "handleBridgePayload", () => (parcelRequire("cwTCb")).handleBridgePayload);
$parcel$export(module.exports, "handleAgentEvent", () => (parcelRequire("cwTCb")).handleAgentEvent);
$parcel$export(module.exports, "wsTransport", () => (parcelRequire("cwTCb")).wsTransport);
$parcel$export(module.exports, "createDirectWsPort", () => (parcelRequire("cwTCb")).createDirectWsPort);
$parcel$export(module.exports, "MAX_SNAPSHOT_AGE_MS", () => (parcelRequire("ly0mS")).MAX_SNAPSHOT_AGE_MS);
$parcel$export(module.exports, "MAX_SNAPSHOT_ENTRIES", () => (parcelRequire("ly0mS")).MAX_SNAPSHOT_ENTRIES);
$parcel$export(module.exports, "decodeAccessTokenUserId", () => (parcelRequire("ly0mS")).decodeAccessTokenUserId);
$parcel$export(module.exports, "_snapshotKey", () => (parcelRequire("ly0mS"))._snapshotKey);
$parcel$export(module.exports, "writeBootSnapshot", () => (parcelRequire("ly0mS")).writeBootSnapshot);
$parcel$export(module.exports, "readBootSnapshot", () => (parcelRequire("ly0mS")).readBootSnapshot);
$parcel$export(module.exports, "purgeBootSnapshot", () => (parcelRequire("ly0mS")).purgeBootSnapshot);
$parcel$export(module.exports, "purgeAllBootSnapshots", () => (parcelRequire("ly0mS")).purgeAllBootSnapshots);
$parcel$export(module.exports, "_snapshotMatchesUrlScope", () => (parcelRequire("ly0mS"))._snapshotMatchesUrlScope);
$parcel$export(module.exports, "resolveWarmBootSnapshot", () => (parcelRequire("ly0mS")).resolveWarmBootSnapshot);
$parcel$export(module.exports, "readSessionBootOrgs", () => (parcelRequire("ly0mS")).readSessionBootOrgs);
$parcel$export(module.exports, "CANVAS_REDIRECT_RESERVED_SEGMENTS", () => (parcelRequire("9StQo")).CANVAS_REDIRECT_RESERVED_SEGMENTS);
$parcel$export(module.exports, "isCanvasProjectPath", () => (parcelRequire("9StQo")).isCanvasProjectPath);
$parcel$export(module.exports, "orgSwitchStaleWorkspaces", () => (parcelRequire("9ocWj")).orgSwitchStaleWorkspaces);
$parcel$export(module.exports, "orgSwitchUrlWorkspace", () => (parcelRequire("9ocWj")).orgSwitchUrlWorkspace);
$parcel$export(module.exports, "orgSwitchHopWorkspace", () => (parcelRequire("9ocWj")).orgSwitchHopWorkspace);
$parcel$export(module.exports, "selectNonCoreMembers", () => (parcelRequire("crAoO")).selectNonCoreMembers);
$parcel$export(module.exports, "deactivateNonCoreMembers", () => (parcelRequire("crAoO")).deactivateNonCoreMembers);
$parcel$export(module.exports, "adminDangerRoleBlock", () => (parcelRequire("d1ihk")).adminDangerRoleBlock);
$parcel$export(module.exports, "isDemoHost", () => (parcelRequire("1jHTS")).isDemoHost);
$parcel$export(module.exports, "isPlatformHost", () => (parcelRequire("lb2Ei")).isPlatformHost);
$parcel$export(module.exports, "isCustomDomainHost", () => (parcelRequire("lb2Ei")).isCustomDomainHost);
$parcel$export(module.exports, "authWrapperTitle", () => (parcelRequire("eMdOt")).authWrapperTitle);
$parcel$export(module.exports, "isPlatformHostname", () => (parcelRequire("dbWbc")).isPlatformHostname);
$parcel$export(module.exports, "pathNamesOrg", () => (parcelRequire("dbWbc")).pathNamesOrg);
$parcel$export(module.exports, "resolveCustomDomainPath", () => (parcelRequire("dbWbc")).resolveCustomDomainPath);
$parcel$export(module.exports, "bootCustomDomainScope", () => (parcelRequire("dbWbc")).bootCustomDomainScope);
$parcel$export(module.exports, "DEMO_BLOCKED_ROUTE_RE", () => (parcelRequire("ehZst")).DEMO_BLOCKED_ROUTE_RE);
$parcel$export(module.exports, "demoRouteGuard", () => (parcelRequire("ehZst")).demoRouteGuard);
$parcel$export(module.exports, "commRouteGuard", () => (parcelRequire("7uzFM")).commRouteGuard);
$parcel$export(module.exports, "SEED_DENY_KEYS", () => (parcelRequire("hROPr")).SEED_DENY_KEYS);
$parcel$export(module.exports, "SEED_DENY_RE", () => (parcelRequire("hROPr")).SEED_DENY_RE);
$parcel$export(module.exports, "referencedRootKeys", () => (parcelRequire("hROPr")).referencedRootKeys);
$parcel$export(module.exports, "buildRootStateSeed", () => (parcelRequire("hROPr")).buildRootStateSeed);
$parcel$export(module.exports, "workspaceDesignSystemSource", () => (parcelRequire("6jWcN")).workspaceDesignSystemSource);
$parcel$export(module.exports, "extensionDesignSystemSource", () => (parcelRequire("6jWcN")).extensionDesignSystemSource);
$parcel$export(module.exports, "setLastRenderedExtension", () => (parcelRequire("jw8v7")).setLastRenderedExtension);
$parcel$export(module.exports, "getLastRenderedExtension", () => (parcelRequire("jw8v7")).getLastRenderedExtension);
$parcel$export(module.exports, "USE_FINANCIALS_PROJECT", () => (parcelRequire("gOQVi")).USE_FINANCIALS_PROJECT);
$parcel$export(module.exports, "USE_MULTITENANT", () => (parcelRequire("gOQVi")).USE_MULTITENANT);
$parcel$export(module.exports, "DUAL_WRITE_FINANCIALS", () => (parcelRequire("gOQVi")).DUAL_WRITE_FINANCIALS);
$parcel$export(module.exports, "USE_PROFILES_OVERLAY", () => (parcelRequire("gOQVi")).USE_PROFILES_OVERLAY);
$parcel$export(module.exports, "USE_ONBOARDING_GATE", () => (parcelRequire("gOQVi")).USE_ONBOARDING_GATE);
$parcel$export(module.exports, "hydrateFeatureFlags", () => (parcelRequire("gOQVi")).hydrateFeatureFlags);
$parcel$export(module.exports, "setFeatureFlag", () => (parcelRequire("gOQVi")).setFeatureFlag);
$parcel$export(module.exports, "setAppAccessEnforced", () => (parcelRequire("gOQVi")).setAppAccessEnforced);
$parcel$export(module.exports, "getWorkspaceCached", () => (parcelRequire("7muxD")).getWorkspaceCached);
$parcel$export(module.exports, "invalidateWorkspaceCache", () => (parcelRequire("7muxD")).invalidateWorkspaceCache);
$parcel$export(module.exports, "hasUnsavedInput", () => (parcelRequire("gqVTy")).hasUnsavedInput);
$parcel$export(module.exports, "confirmDiscardChanges", () => (parcelRequire("bq0U5")).confirmDiscardChanges);
$parcel$export(module.exports, "markPageSaved", () => (parcelRequire("5wIx1")).markPageSaved);
$parcel$export(module.exports, "creditGuardState", () => (parcelRequire("2Od7Q")).creditGuardState);
$parcel$export(module.exports, "creditBlockerShown", () => (parcelRequire("2Od7Q")).creditBlockerShown);
$parcel$export(module.exports, "creditShortState", () => (parcelRequire("2Od7Q")).creditShortState);
$parcel$export(module.exports, "askAdminsForCredits", () => (parcelRequire("2Od7Q")).askAdminsForCredits);
$parcel$export(module.exports, "creditPillVisible", () => (parcelRequire("2Od7Q")).creditPillVisible);
$parcel$export(module.exports, "creditDockMode", () => (parcelRequire("2Od7Q")).creditDockMode);
$parcel$export(module.exports, "loadCreditGuard", () => (parcelRequire("2Od7Q")).loadCreditGuard);
$parcel$export(module.exports, "notifyCreditThreshold", () => (parcelRequire("2Od7Q")).notifyCreditThreshold);
$parcel$export(module.exports, "notifyCreditsExhaustedFromMessage", () => (parcelRequire("2Od7Q")).notifyCreditsExhaustedFromMessage);
$parcel$export(module.exports, "CREDITS_EXHAUSTED_ERROR_CODES", () => (parcelRequire("2Od7Q")).CREDITS_EXHAUSTED_ERROR_CODES);
$parcel$export(module.exports, "creditBlockerDismissedStorageKey", () => (parcelRequire("2Od7Q")).creditBlockerDismissedStorageKey);
$parcel$export(module.exports, "readCreditBlockerDismissed", () => (parcelRequire("2Od7Q")).readCreditBlockerDismissed);
$parcel$export(module.exports, "writeCreditBlockerDismissed", () => (parcelRequire("2Od7Q")).writeCreditBlockerDismissed);
$parcel$export(module.exports, "isCreditsError", () => (parcelRequire("amofj")).isCreditsError);
$parcel$export(module.exports, "creditsShortfall", () => (parcelRequire("amofj")).creditsShortfall);
$parcel$export(module.exports, "creditsErrorText", () => (parcelRequire("amofj")).creditsErrorText);
$parcel$export(module.exports, "applyCreditsError", () => (parcelRequire("amofj")).applyCreditsError);
$parcel$export(module.exports, "creditsRefusalRow", () => (parcelRequire("amofj")).creditsRefusalRow);
$parcel$export(module.exports, "creditsRefusalRows", () => (parcelRequire("amofj")).creditsRefusalRows);
$parcel$export(module.exports, "resolveHomePanelSet", () => (parcelRequire("5BDlp")).resolveHomePanelSet);
$parcel$export(module.exports, "appDefaultWidgetIds", () => (parcelRequire("5BDlp")).appDefaultWidgetIds);
$parcel$export(module.exports, "untrackedState", () => (parcelRequire("htRH6")).untrackedState);
$parcel$export(module.exports, "bootMark", () => (parcelRequire("iI0D7")).bootMark);
$parcel$export(module.exports, "bootMeasure", () => (parcelRequire("iI0D7")).bootMeasure);
$parcel$export(module.exports, "IDLE_BOOT_TIMEOUT_MS", () => (parcelRequire("iI0D7")).IDLE_BOOT_TIMEOUT_MS);
$parcel$export(module.exports, "deferIdleBoot", () => (parcelRequire("iI0D7")).deferIdleBoot);
$parcel$export(module.exports, "hasAuthoritativeWorkspace", () => (parcelRequire("6QCFv")).hasAuthoritativeWorkspace);
$parcel$export(module.exports, "awaitInitialWorkspace", () => (parcelRequire("6QCFv")).awaitInitialWorkspace);
$parcel$export(module.exports, "createPostAuthWorkspaceRevealCoordinator", () => (parcelRequire("6QCFv")).createPostAuthWorkspaceRevealCoordinator);
$parcel$export(module.exports, "LAUNCHER_FALLBACK_ICON", () => (parcelRequire("kO6Bt")).LAUNCHER_FALLBACK_ICON);
$parcel$export(module.exports, "LAUNCHER_ICON_BGS", () => (parcelRequire("kO6Bt")).LAUNCHER_ICON_BGS);
$parcel$export(module.exports, "titleFromRoute", () => (parcelRequire("kO6Bt")).titleFromRoute);
$parcel$export(module.exports, "normalizeLauncherTile", () => (parcelRequire("kO6Bt")).normalizeLauncherTile);
$parcel$export(module.exports, "fillLauncherTileFrom", () => (parcelRequire("kO6Bt")).fillLauncherTileFrom);
$parcel$export(module.exports, "beginDataLoad", () => (parcelRequire("jZ5ZE")).beginDataLoad);
$parcel$export(module.exports, "endDataLoad", () => (parcelRequire("jZ5ZE")).endDataLoad);
$parcel$export(module.exports, "endDataLoadFailsafe", () => (parcelRequire("jZ5ZE")).endDataLoadFailsafe);
$parcel$export(module.exports, "_person", () => (parcelRequire("jZ5ZE"))._person);
$parcel$export(module.exports, "_dashboardPrefsFetches", () => (parcelRequire("jZ5ZE"))._dashboardPrefsFetches);
$parcel$export(module.exports, "registerWorkspaceConfigConverge", () => (parcelRequire("jZ5ZE")).registerWorkspaceConfigConverge);
$parcel$export(module.exports, "loadPrivateData", () => (parcelRequire("jZ5ZE")).loadPrivateData);
$parcel$export(module.exports, "retryWorkspaceActivation", () => (parcelRequire("jZ5ZE")).retryWorkspaceActivation);
$parcel$export(module.exports, "scopeGen", () => (parcelRequire("jZ5ZE")).scopeGen);
$parcel$export(module.exports, "scopeStale", () => (parcelRequire("jZ5ZE")).scopeStale);
$parcel$export(module.exports, "endWorkspaceSession", () => (parcelRequire("jZ5ZE")).endWorkspaceSession);
$parcel$export(module.exports, "onWorkspaceChange", () => (parcelRequire("jZ5ZE")).onWorkspaceChange);
$parcel$export(module.exports, "MODULE_ACTION_FN_NAMES", () => (parcelRequire("6lGuT")).MODULE_ACTION_FN_NAMES);
$parcel$export(module.exports, "buildModuleActionFns", () => (parcelRequire("6lGuT")).buildModuleActionFns);
$parcel$export(module.exports, "moduleRecordRoutes", () => (parcelRequire("15Bho")).moduleRecordRoutes);
$parcel$export(module.exports, "moduleRecordRoute", () => (parcelRequire("15Bho")).moduleRecordRoute);
$parcel$export(module.exports, "moduleRecordRow", () => (parcelRequire("9hgTz")).moduleRecordRow);
$parcel$export(module.exports, "buildModuleAiBridge", () => (parcelRequire("8Oeas")).buildModuleAiBridge);
$parcel$export(module.exports, "buildModuleAiStreamBridge", () => (parcelRequire("8Oeas")).buildModuleAiStreamBridge);
$parcel$export(module.exports, "buildModuleAiAdminBridge", () => (parcelRequire("8Oeas")).buildModuleAiAdminBridge);
$parcel$export(module.exports, "buildModuleRegistryBridge", () => (parcelRequire("dk5k7")).buildModuleRegistryBridge);
$parcel$export(module.exports, "buildModuleCalendarBridge", () => (parcelRequire("aKkqm")).buildModuleCalendarBridge);
$parcel$export(module.exports, "buildModuleNotifyBridge", () => (parcelRequire("duW2E")).buildModuleNotifyBridge);
$parcel$export(module.exports, "buildModuleNotifyCloseBridge", () => (parcelRequire("duW2E")).buildModuleNotifyCloseBridge);
$parcel$export(module.exports, "buildModuleDataBridge", () => (parcelRequire("f18a7")).buildModuleDataBridge);
$parcel$export(module.exports, "tileModuleDataBridge", () => (parcelRequire("izGzx")).tileModuleDataBridge);
$parcel$export(module.exports, "buildModuleFileListBridge", () => (parcelRequire("jqUS6")).buildModuleFileListBridge);
$parcel$export(module.exports, "buildModuleFileReadBridge", () => (parcelRequire("jqUS6")).buildModuleFileReadBridge);
$parcel$export(module.exports, "buildModuleFileBridge", () => (parcelRequire("jqUS6")).buildModuleFileBridge);
$parcel$export(module.exports, "buildModuleFileCreateBridge", () => (parcelRequire("jqUS6")).buildModuleFileCreateBridge);
$parcel$export(module.exports, "buildModuleFileUpdateBridge", () => (parcelRequire("jqUS6")).buildModuleFileUpdateBridge);
$parcel$export(module.exports, "_storageRefFromUrl", () => (parcelRequire("jqUS6"))._storageRefFromUrl);
$parcel$export(module.exports, "resolveModuleUrl", () => (parcelRequire("i8Ov5")).resolveModuleUrl);
$parcel$export(module.exports, "resolveAssetUrl", () => (parcelRequire("i8Ov5")).resolveAssetUrl);
$parcel$export(module.exports, "normalizeDependencies", () => (parcelRequire("i8Ov5")).normalizeDependencies);
$parcel$export(module.exports, "peerPins", () => (parcelRequire("i8Ov5")).peerPins);
$parcel$export(module.exports, "buildModuleImportBridge", () => (parcelRequire("i8Ov5")).buildModuleImportBridge);
$parcel$export(module.exports, "buildModuleMountBridge", () => (parcelRequire("i8Ov5")).buildModuleMountBridge);
$parcel$export(module.exports, "buildModuleApiBridge", () => (parcelRequire("i8Ov5")).buildModuleApiBridge);
$parcel$export(module.exports, "buildModuleTokenBridge", () => (parcelRequire("i8Ov5")).buildModuleTokenBridge);
$parcel$export(module.exports, "buildModuleUnmountBridge", () => (parcelRequire("i8Ov5")).buildModuleUnmountBridge);
$parcel$export(module.exports, "buildModuleAssetUrlBridge", () => (parcelRequire("i8Ov5")).buildModuleAssetUrlBridge);
$parcel$export(module.exports, "buildModuleThemeBridge", () => (parcelRequire("i8Ov5")).buildModuleThemeBridge);
$parcel$export(module.exports, "buildModuleOpenBridge", () => (parcelRequire("atmQm")).buildModuleOpenBridge);
$parcel$export(module.exports, "cleanRoute", () => (parcelRequire("lG24I")).cleanRoute);
$parcel$export(module.exports, "normalizePages", () => (parcelRequire("lG24I")).normalizePages);
$parcel$export(module.exports, "buildNav", () => (parcelRequire("lG24I")).buildNav);
$parcel$export(module.exports, "buildAppShell", () => (parcelRequire("lG24I")).buildAppShell);
$parcel$export(module.exports, "mwtRouter", () => (parcelRequire("gO4wS")).mwtRouter);
$parcel$export(module.exports, "reconcileMwtOrgFromUrl", () => (parcelRequire("gO4wS")).reconcileMwtOrgFromUrl);
$parcel$export(module.exports, "mwtOnRenderRouter", () => (parcelRequire("gO4wS")).mwtOnRenderRouter);
$parcel$export(module.exports, "NotificationWrapper", () => (parcelRequire("df4OW")).NotificationWrapper);
$parcel$export(module.exports, "primePeople", () => (parcelRequire("cKmtB")).primePeople);
$parcel$export(module.exports, "primedOrgSlug", () => (parcelRequire("cKmtB")).primedOrgSlug);
$parcel$export(module.exports, "peekPrimedPeople", () => (parcelRequire("cKmtB")).peekPrimedPeople);
$parcel$export(module.exports, "consumePrimedPeople", () => (parcelRequire("cKmtB")).consumePrimedPeople);
$parcel$export(module.exports, "APP_ACCESS_VERBS", () => (parcelRequire("eb4QA")).APP_ACCESS_VERBS);
$parcel$export(module.exports, "APP_ACCESS_APPS", () => (parcelRequire("eb4QA")).APP_ACCESS_APPS);
$parcel$export(module.exports, "APP_PERMISSIONS", () => (parcelRequire("eb4QA")).APP_PERMISSIONS);
$parcel$export(module.exports, "PERMISSIONS", () => (parcelRequire("eb4QA")).PERMISSIONS);
$parcel$export(module.exports, "PERMISSION_KEYS", () => (parcelRequire("eb4QA")).PERMISSION_KEYS);
$parcel$export(module.exports, "PERMISSION_GROUPS", () => (parcelRequire("eb4QA")).PERMISSION_GROUPS);
$parcel$export(module.exports, "ORG_ROLE_PERMISSIONS", () => (parcelRequire("eb4QA")).ORG_ROLE_PERMISSIONS);
$parcel$export(module.exports, "SYSTEM_TEAMS", () => (parcelRequire("eb4QA")).SYSTEM_TEAMS);
$parcel$export(module.exports, "SYSTEM_TEAM_SLUGS", () => (parcelRequire("eb4QA")).SYSTEM_TEAM_SLUGS);
$parcel$export(module.exports, "CATEGORIES", () => (parcelRequire("eb4QA")).CATEGORIES);
$parcel$export(module.exports, "CATEGORY_PERMISSION_TEMPLATES", () => (parcelRequire("eb4QA")).CATEGORY_PERMISSION_TEMPLATES);
$parcel$export(module.exports, "teamMatchesTemplate", () => (parcelRequire("eb4QA")).teamMatchesTemplate);
$parcel$export(module.exports, "dominantCategory", () => (parcelRequire("eb4QA")).dominantCategory);
$parcel$export(module.exports, "LEGACY_ORG_IDS", () => (parcelRequire("eb4QA")).LEGACY_ORG_IDS);
$parcel$export(module.exports, "PERMISSIONS_BY_GROUP", () => (parcelRequire("eb4QA")).PERMISSIONS_BY_GROUP);
$parcel$export(module.exports, "hasPerm", () => (parcelRequire("eb4QA")).hasPerm);
$parcel$export(module.exports, "claimsIsActiveMember", () => (parcelRequire("eb4QA")).claimsIsActiveMember);
$parcel$export(module.exports, "isInTeam", () => (parcelRequire("eb4QA")).isInTeam);
$parcel$export(module.exports, "claimsIsOwner", () => (parcelRequire("eb4QA")).claimsIsOwner);
$parcel$export(module.exports, "claimsIsAdmin", () => (parcelRequire("eb4QA")).claimsIsAdmin);
$parcel$export(module.exports, "canAccessGovUI", () => (parcelRequire("eb4QA")).canAccessGovUI);
$parcel$export(module.exports, "effectiveCategory", () => (parcelRequire("eb4QA")).effectiveCategory);
$parcel$export(module.exports, "permLabel", () => (parcelRequire("eb4QA")).permLabel);
$parcel$export(module.exports, "permDescription", () => (parcelRequire("eb4QA")).permDescription);
$parcel$export(module.exports, "permGroup", () => (parcelRequire("eb4QA")).permGroup);
$parcel$export(module.exports, "PERMISSION_GROUP_KEYS", () => (parcelRequire("eb4QA")).PERMISSION_GROUP_KEYS);
$parcel$export(module.exports, "permLabelText", () => (parcelRequire("eb4QA")).permLabelText);
$parcel$export(module.exports, "permDescriptionText", () => (parcelRequire("eb4QA")).permDescriptionText);
$parcel$export(module.exports, "permGroupText", () => (parcelRequire("eb4QA")).permGroupText);
$parcel$export(module.exports, "activeWorkspaceId", () => (parcelRequire("9ZTVI")).activeWorkspaceId);
$parcel$export(module.exports, "hasActiveWorkspace", () => (parcelRequire("9ZTVI")).hasActiveWorkspace);
$parcel$export(module.exports, "buildUiCatalog", () => (parcelRequire("c4Noe")).buildUiCatalog);
$parcel$export(module.exports, "DEFAULT_NAVBAR", () => (parcelRequire("g7CNh")).DEFAULT_NAVBAR);
$parcel$export(module.exports, "DEFAULT_DESIGN_SYSTEM", () => (parcelRequire("g7CNh")).DEFAULT_DESIGN_SYSTEM);
$parcel$export(module.exports, "DEFAULT_CONFIG", () => (parcelRequire("g7CNh")).DEFAULT_CONFIG);
$parcel$export(module.exports, "deepEqual", () => (parcelRequire("g7CNh")).shellDeepEqual);
$parcel$export(module.exports, "resolveWorkspaceConfig", () => (parcelRequire("g7CNh")).resolveWorkspaceConfig);
$parcel$export(module.exports, "applyWorkspaceConfig", () => (parcelRequire("g7CNh")).applyWorkspaceConfig);
$parcel$export(module.exports, "resolveDesignSystemVars", () => (parcelRequire("g7CNh")).resolveDesignSystemVars);
$parcel$export(module.exports, "watchDesignSystemTheme", () => (parcelRequire("g7CNh")).watchDesignSystemTheme);
$parcel$export(module.exports, "installedAppRefs", () => (parcelRequire("g7CNh")).installedAppRefs);
$parcel$export(module.exports, "homeWidgetHue", () => (parcelRequire("6p65M")).homeWidgetHue);
$parcel$export(module.exports, "homeWidgetSurfaceHue", () => (parcelRequire("6p65M")).homeWidgetSurfaceHue);
$parcel$export(module.exports, "homeWidgetColorOptions", () => (parcelRequire("6p65M")).homeWidgetColorOptions);
$parcel$export(module.exports, "homeWidgetAppColorOption", () => (parcelRequire("6p65M")).homeWidgetAppColorOption);
$parcel$export(module.exports, "posterFamilyEntry", () => (parcelRequire("6p65M")).posterFamilyEntry);
$parcel$export(module.exports, "POSTER_FAMILY_KEYS", () => (parcelRequire("6p65M")).POSTER_FAMILY_KEYS);
$parcel$export(module.exports, "POSTER_FAMILY_LABELS", () => (parcelRequire("6p65M")).POSTER_FAMILY_LABELS);
$parcel$export(module.exports, "rowHueRotation", () => (parcelRequire("6p65M")).rowHueRotation);
$parcel$export(module.exports, "homeWidgetColorsKey", () => (parcelRequire("74YUs")).homeWidgetColorsKey);
$parcel$export(module.exports, "readHomeWidgetColors", () => (parcelRequire("74YUs")).readHomeWidgetColors);
$parcel$export(module.exports, "homeGridMetrics", () => (parcelRequire("aJYU4")).homeGridMetrics);
$parcel$export(module.exports, "homeWidgetSpan", () => (parcelRequire("aJYU4")).homeWidgetSpan);
$parcel$export(module.exports, "homeWidgetSpanAt", () => (parcelRequire("aJYU4")).homeWidgetSpanAt);
$parcel$export(module.exports, "homeSpanVarsFor", () => (parcelRequire("aJYU4")).homeSpanVarsFor);
$parcel$export(module.exports, "homeSpanFitWords", () => (parcelRequire("aJYU4")).homeSpanFitWords);
$parcel$export(module.exports, "homeSpanVar", () => (parcelRequire("aJYU4")).homeSpanVar);
$parcel$export(module.exports, "homeSpanFitCss", () => (parcelRequire("aJYU4")).homeSpanFitCss);
$parcel$export(module.exports, "homeWidgetSizeForCell", () => (parcelRequire("aJYU4")).homeWidgetSizeForCell);
$parcel$export(module.exports, "homeSparkGeom", () => (parcelRequire("4gSNJ")).homeSparkGeom);
$parcel$export(module.exports, "homeSlotText", () => (parcelRequire("4gSNJ")).homeSlotText);
$parcel$export(module.exports, "homeHelpTipPlace", () => (parcelRequire("io6d9")).homeHelpTipPlace);
$parcel$export(module.exports, "homeHelpTipReserve", () => (parcelRequire("io6d9")).homeHelpTipReserve);
$parcel$export(module.exports, "homeWidgetHelpTipMeasure", () => (parcelRequire("io6d9")).homeWidgetHelpTipMeasure);
$parcel$export(module.exports, "homeWidgetHelpTipForget", () => (parcelRequire("io6d9")).homeWidgetHelpTipForget);
$parcel$export(module.exports, "homeWidgetHelpTipStyle", () => (parcelRequire("io6d9")).homeWidgetHelpTipStyle);
$parcel$export(module.exports, "homeWidgetHelpTipClose", () => (parcelRequire("io6d9")).homeWidgetHelpTipClose);
$parcel$export(module.exports, "homeWidgetHelpOpen", () => (parcelRequire("io6d9")).homeWidgetHelpOpen);
$parcel$export(module.exports, "homeWidgetAccent", () => (parcelRequire("1Qr8P")).homeWidgetAccent);
$parcel$export(module.exports, "homeWidgetAccentVars", () => (parcelRequire("1Qr8P")).homeWidgetAccentVars);
$parcel$export(module.exports, "homeWidgetAccentOnSurfaceVars", () => (parcelRequire("1Qr8P")).homeWidgetAccentOnSurfaceVars);
$parcel$export(module.exports, "homeWidgetIsApp", () => (parcelRequire("1Qr8P")).homeWidgetIsApp);
$parcel$export(module.exports, "homeWidgetDefaultSize", () => (parcelRequire("1Qr8P")).homeWidgetDefaultSize);
$parcel$export(module.exports, "homeWidgetFrameSize", () => (parcelRequire("1Qr8P")).homeWidgetFrameSize);
$parcel$export(module.exports, "homeWidgetBaseSize", () => (parcelRequire("1Qr8P")).homeWidgetBaseSize);
$parcel$export(module.exports, "homeWidgetSpanAtOf", () => (parcelRequire("1Qr8P")).homeWidgetSpanAtOf);
$parcel$export(module.exports, "homeWidgetSpanFor", () => (parcelRequire("1Qr8P")).homeWidgetSpanFor);
$parcel$export(module.exports, "homeWidgetSpanVars", () => (parcelRequire("1Qr8P")).homeWidgetSpanVars);
$parcel$export(module.exports, "homeWidgetSpanFit", () => (parcelRequire("1Qr8P")).homeWidgetSpanFit);
$parcel$export(module.exports, "homeWidgetFrameStyle", () => (parcelRequire("1Qr8P")).homeWidgetFrameStyle);
$parcel$export(module.exports, "homeWidgetFrameOrder", () => (parcelRequire("1Qr8P")).homeWidgetFrameOrder);
$parcel$export(module.exports, "homeWidgetFrameHidden", () => (parcelRequire("1Qr8P")).homeWidgetFrameHidden);
$parcel$export(module.exports, "homeWidgetUnderView", () => (parcelRequire("1Qr8P")).homeWidgetUnderView);
$parcel$export(module.exports, "homeWidgetOpenRoute", () => (parcelRequire("1Qr8P")).homeWidgetOpenRoute);
$parcel$export(module.exports, "homeWidgetActionOf", () => (parcelRequire("1Qr8P")).homeWidgetActionOf);
$parcel$export(module.exports, "homeWidgetOpen", () => (parcelRequire("1Qr8P")).homeWidgetOpen);
$parcel$export(module.exports, "homeWidgetRunAction", () => (parcelRequire("1Qr8P")).homeWidgetRunAction);
$parcel$export(module.exports, "openHomeWidgetForm", () => (parcelRequire("1Qr8P")).openHomeWidgetForm);
$parcel$export(module.exports, "mountHomeWidgetForm", () => (parcelRequire("1Qr8P")).mountHomeWidgetForm);
$parcel$export(module.exports, "homeWidgetHelpOf", () => (parcelRequire("1Qr8P")).homeWidgetHelpOf);
$parcel$export(module.exports, "homeWidgetHideLabel", () => (parcelRequire("1Qr8P")).homeWidgetHideLabel);
$parcel$export(module.exports, "homeWidgetParams", () => (parcelRequire("1Qr8P")).homeWidgetParams);
$parcel$export(module.exports, "homeWidgetSizeRows", () => (parcelRequire("1Qr8P")).homeWidgetSizeRows);
$parcel$export(module.exports, "homeWidgetSizeMenuRow", () => (parcelRequire("1Qr8P")).homeWidgetSizeMenuRow);
$parcel$export(module.exports, "homeWidgetSetSize", () => (parcelRequire("1Qr8P")).homeWidgetSetSize);
$parcel$export(module.exports, "homeWidgetDragStart", () => (parcelRequire("68PIQ")).homeWidgetDragStart);
$parcel$export(module.exports, "homeWidgetDragMove", () => (parcelRequire("68PIQ")).homeWidgetDragMove);
$parcel$export(module.exports, "homeWidgetDragEnd", () => (parcelRequire("68PIQ")).homeWidgetDragEnd);
$parcel$export(module.exports, "homeWidgetKeyMove", () => (parcelRequire("68PIQ")).homeWidgetKeyMove);
$parcel$export(module.exports, "homeWidgetResizeSizes", () => (parcelRequire("krR5z")).homeWidgetResizeSizes);
$parcel$export(module.exports, "homeWidgetResizeBox", () => (parcelRequire("krR5z")).homeWidgetResizeBox);
$parcel$export(module.exports, "homeWidgetResizeSnap", () => (parcelRequire("krR5z")).homeWidgetResizeSnap);
$parcel$export(module.exports, "homeWidgetResizeStep", () => (parcelRequire("krR5z")).homeWidgetResizeStep);
$parcel$export(module.exports, "homeWidgetResizeMetrics", () => (parcelRequire("krR5z")).homeWidgetResizeMetrics);
$parcel$export(module.exports, "homeWidgetResizeStepBy", () => (parcelRequire("krR5z")).homeWidgetResizeStepBy);
$parcel$export(module.exports, "homeWidgetResizeStart", () => (parcelRequire("krR5z")).homeWidgetResizeStart);
$parcel$export(module.exports, "homeWidgetResizeMove", () => (parcelRequire("krR5z")).homeWidgetResizeMove);
$parcel$export(module.exports, "homeWidgetResizeEnd", () => (parcelRequire("krR5z")).homeWidgetResizeEnd);
$parcel$export(module.exports, "homeWidgetResizeKey", () => (parcelRequire("krR5z")).homeWidgetResizeKey);
$parcel$export(module.exports, "homeWidgetResizeTitle", () => (parcelRequire("krR5z")).homeWidgetResizeTitle);
$parcel$export(module.exports, "homeWidgetMotionAllowed", () => (parcelRequire("cKLMf")).homeWidgetMotionAllowed);
$parcel$export(module.exports, "homeWidgetFlipDelta", () => (parcelRequire("cKLMf")).homeWidgetFlipDelta);
$parcel$export(module.exports, "homeWidgetFlipStart", () => (parcelRequire("cKLMf")).homeWidgetFlipStart);
$parcel$export(module.exports, "homeWidgetFlipCapture", () => (parcelRequire("cKLMf")).homeWidgetFlipCapture);
$parcel$export(module.exports, "homeWidgetFlipPlay", () => (parcelRequire("cKLMf")).homeWidgetFlipPlay);
$parcel$export(module.exports, "homeWidgetFlip", () => (parcelRequire("cKLMf")).homeWidgetFlip);
$parcel$export(module.exports, "homeWidgetExit", () => (parcelRequire("cKLMf")).homeWidgetExit);
$parcel$export(module.exports, "homeWidgetReveal", () => (parcelRequire("cKLMf")).homeWidgetReveal);
$parcel$export(module.exports, "persistableHiddenMap", () => (parcelRequire("76atT")).persistableHiddenMap);
$parcel$export(module.exports, "resolveSavedPrefsSource", () => (parcelRequire("hkMuP")).resolveSavedPrefsSource);
$parcel$export(module.exports, "homeWidgetCatalog", () => (parcelRequire("dDuP2")).homeWidgetCatalog);
$parcel$export(module.exports, "homeDefaultVisibleWidgets", () => (parcelRequire("dDuP2")).homeDefaultVisibleWidgets);
$parcel$export(module.exports, "homePanelRows", () => (parcelRequire("dDuP2")).homePanelRows);
$parcel$export(module.exports, "isAppModeWorkspace", () => (parcelRequire("8Zc6q")).isAppModeWorkspace);
$parcel$export(module.exports, "appModeModuleRef", () => (parcelRequire("8Zc6q")).appModeModuleRef);
$parcel$export(module.exports, "takeoverModuleRef", () => (parcelRequire("8Zc6q")).takeoverModuleRef);
$parcel$export(module.exports, "houseDefaultHiddenMap", () => (parcelRequire("8Zc6q")).houseDefaultHiddenMap);
$parcel$export(module.exports, "panelSetHiddenMap", () => (parcelRequire("8Zc6q")).panelSetHiddenMap);
$parcel$export(module.exports, "sameWorkspaceWriter", () => (parcelRequire("iNbdw")).sameWorkspaceWriter);
$parcel$export(module.exports, "homeCompactNumber", () => (parcelRequire("iU3AQ")).homeCompactNumber);
$parcel$export(module.exports, "homeMoney", () => (parcelRequire("iU3AQ")).homeMoney);
$parcel$export(module.exports, "homeBoardUrlRead", () => (parcelRequire("a8Zn1")).homeBoardUrlRead);
$parcel$export(module.exports, "homeBoardUrlSync", () => (parcelRequire("a8Zn1")).homeBoardUrlSync);
$parcel$export(module.exports, "homeBoardUrlOpen", () => (parcelRequire("a8Zn1")).homeBoardUrlOpen);
$parcel$export(module.exports, "homeBoardUrlTick", () => (parcelRequire("a8Zn1")).homeBoardUrlTick);
$parcel$export(module.exports, "homeNextUpEvents", () => (parcelRequire("5oufH")).homeNextUpEvents);
$parcel$export(module.exports, "homeNextUpHero", () => (parcelRequire("5oufH")).homeNextUpHero);
$parcel$export(module.exports, "homeNextUpTime", () => (parcelRequire("5oufH")).homeNextUpTime);
$parcel$export(module.exports, "homeNextUpRows", () => (parcelRequire("5oufH")).homeNextUpRows);
$parcel$export(module.exports, "homeNextUpAction", () => (parcelRequire("5oufH")).homeNextUpAction);
$parcel$export(module.exports, "homeNextUpActionArg", () => (parcelRequire("5oufH")).homeNextUpActionArg);
$parcel$export(module.exports, "homeNextUpOpen", () => (parcelRequire("5oufH")).homeNextUpOpen);
$parcel$export(module.exports, "homeNextUpNormalize", () => (parcelRequire("5oufH")).homeNextUpNormalize);
$parcel$export(module.exports, "homeNextUpProviders", () => (parcelRequire("5oufH")).homeNextUpProviders);
$parcel$export(module.exports, "homeNextUpCollect", () => (parcelRequire("5oufH")).homeNextUpCollect);
$parcel$export(module.exports, "homeNextUpItems", () => (parcelRequire("5oufH")).homeNextUpItems);
$parcel$export(module.exports, "homeNextUpAppsKnown", () => (parcelRequire("5oufH")).homeNextUpAppsKnown);
$parcel$export(module.exports, "homeNextUpProviderSig", () => (parcelRequire("5oufH")).homeNextUpProviderSig);
$parcel$export(module.exports, "homeNextUpClock", () => (parcelRequire("5oufH")).homeNextUpClock);
$parcel$export(module.exports, "homeNextUpClockStop", () => (parcelRequire("5oufH")).homeNextUpClockStop);
$parcel$export(module.exports, "homePinnedBlock", () => (parcelRequire("dTMvK")).homePinnedBlock);
$parcel$export(module.exports, "homePinnedHostRow", () => (parcelRequire("dTMvK")).homePinnedHostRow);
$parcel$export(module.exports, "userCodeRuntimeText", () => (parcelRequire("lKVGb")).userCodeRuntimeText);

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");
parcelRequire("byww3");
var $2C0hZ = parcelRequire("2C0hZ");

var $9ZTVI = parcelRequire("9ZTVI");

var $gvbDt = parcelRequire("gvbDt");

var $hROPr = parcelRequire("hROPr");

var $ggoif = parcelRequire("ggoif");
var $7iHfb = parcelRequire("7iHfb");

var $7qVzJ = parcelRequire("7qVzJ");

var $6jWcN = parcelRequire("6jWcN");

var $lG24I = parcelRequire("lG24I");

var $jw8v7 = parcelRequire("jw8v7");

var $79dxh = parcelRequire("79dxh");

var $XpvS7 = parcelRequire("XpvS7");

var $gFf4Y = parcelRequire("gFf4Y");

var $2EI10 = parcelRequire("2EI10");

var $hcWAT = parcelRequire("hcWAT");

var $lXQF7 = parcelRequire("lXQF7");

var $4v0cn = parcelRequire("4v0cn");

var $9Lsv8 = parcelRequire("9Lsv8");

var $4B6D0 = parcelRequire("4B6D0");

var $eb4QA = parcelRequire("eb4QA");

var $aGIjc = parcelRequire("aGIjc");

var $k3hwI = parcelRequire("k3hwI");

var $8z3sU = parcelRequire("8z3sU");

var $cGe9G = parcelRequire("cGe9G");

var $17MWq = parcelRequire("17MWq");

var $qJ3f5 = parcelRequire("qJ3f5");

var $2aopH = parcelRequire("2aopH");

var $bnEwy = parcelRequire("bnEwy");

var $25fky = parcelRequire("25fky");

var $4u35b = parcelRequire("4u35b");

var $dp7M8 = parcelRequire("dp7M8");

var $ik7KJ = parcelRequire("ik7KJ");

var $14aeZ = parcelRequire("14aeZ");

var $5Vf2y = parcelRequire("5Vf2y");

var $azpxa = parcelRequire("azpxa");

var $aO3dH = parcelRequire("aO3dH");

var $4QxwL = parcelRequire("4QxwL");

var $oolN6 = parcelRequire("oolN6");

var $3YHy5 = parcelRequire("3YHy5");

var $6hzqH = parcelRequire("6hzqH");

var $11oY6 = parcelRequire("11oY6");

var $fAXoF = parcelRequire("fAXoF");

var $kKK1U = parcelRequire("kKK1U");

var $2Ew84 = parcelRequire("2Ew84");

var $5nFIo = parcelRequire("5nFIo");

var $6u4gB = parcelRequire("6u4gB");

var $iiC3b = parcelRequire("iiC3b");

var $pSCVI = parcelRequire("pSCVI");

var $l6XrB = parcelRequire("l6XrB");

var $l3wtL = parcelRequire("l3wtL");

var $2nxDN = parcelRequire("2nxDN");

var $exs7L = parcelRequire("exs7L");

var $9nZUz = parcelRequire("9nZUz");

var $6lzOV = parcelRequire("6lzOV");

var $f0QVc = parcelRequire("f0QVc");

var $1JE4a = parcelRequire("1JE4a");

var $11fgE = parcelRequire("11fgE");

var $hrwvV = parcelRequire("hrwvV");

var $1DBpJ = parcelRequire("1DBpJ");

var $1nnHq = parcelRequire("1nnHq");

var $iQSJg = parcelRequire("iQSJg");

var $48wyv = parcelRequire("48wyv");

var $aJk2q = parcelRequire("aJk2q");

var $j3mi5 = parcelRequire("j3mi5");

var $5UN4H = parcelRequire("5UN4H");

var $lY4w0 = parcelRequire("lY4w0");

var $F8Fzk = parcelRequire("F8Fzk");

var $bopKf = parcelRequire("bopKf");

var $e1ZLm = parcelRequire("e1ZLm");

var $9x78k = parcelRequire("9x78k");

var $k99Sk = parcelRequire("k99Sk");

var $3aYah = parcelRequire("3aYah");

var $dVAG8 = parcelRequire("dVAG8");

var $lLLtZ = parcelRequire("lLLtZ");

var $8BLCC = parcelRequire("8BLCC");

var $11u4Q = parcelRequire("11u4Q");

var $6yYb9 = parcelRequire("6yYb9");

var $kpQ55 = parcelRequire("kpQ55");

var $eOUFv = parcelRequire("eOUFv");

var $5ML7q = parcelRequire("5ML7q");

var $fRtNs = parcelRequire("fRtNs");

var $7nvlv = parcelRequire("7nvlv");

var $1OhIx = parcelRequire("1OhIx");

var $fJThD = parcelRequire("fJThD");

var $fxEFw = parcelRequire("fxEFw");

var $24hpk = parcelRequire("24hpk");

var $lkMHI = parcelRequire("lkMHI");

var $gOQVi = parcelRequire("gOQVi");

var $b6fDZ = parcelRequire("b6fDZ");

var $jfwUK = parcelRequire("jfwUK");

var $4qZU8 = parcelRequire("4qZU8");

var $87igY = parcelRequire("87igY");

var $eKWOV = parcelRequire("eKWOV");

var $79OEu = parcelRequire("79OEu");

var $hv8sj = parcelRequire("hv8sj");

var $3lK1C = parcelRequire("3lK1C");

var $L8D7m = parcelRequire("L8D7m");

var $D8RKl = parcelRequire("D8RKl");

var $9cDO9 = parcelRequire("9cDO9");

var $k0i6b = parcelRequire("k0i6b");

var $5MRhO = parcelRequire("5MRhO");

var $j97dQ = parcelRequire("j97dQ");

var $3GI9o = parcelRequire("3GI9o");

var $cY3NJ = parcelRequire("cY3NJ");

var $cZH4f = parcelRequire("cZH4f");

var $gzr3m = parcelRequire("gzr3m");

var $i2kG6 = parcelRequire("i2kG6");

var $7uQG1 = parcelRequire("7uQG1");

var $02uje = parcelRequire("02uje");

var $7ytvD = parcelRequire("7ytvD");

var $cwTCb = parcelRequire("cwTCb");

var $ly0mS = parcelRequire("ly0mS");

var $9StQo = parcelRequire("9StQo");

var $9ocWj = parcelRequire("9ocWj");

var $crAoO = parcelRequire("crAoO");

var $d1ihk = parcelRequire("d1ihk");

var $a8wem = parcelRequire("a8wem");

var $1jHTS = parcelRequire("1jHTS");

var $lb2Ei = parcelRequire("lb2Ei");

var $eMdOt = parcelRequire("eMdOt");

var $dbWbc = parcelRequire("dbWbc");

var $ehZst = parcelRequire("ehZst");

var $7uzFM = parcelRequire("7uzFM");

var $7muxD = parcelRequire("7muxD");

var $gqVTy = parcelRequire("gqVTy");

var $bq0U5 = parcelRequire("bq0U5");

var $5wIx1 = parcelRequire("5wIx1");

var $2Od7Q = parcelRequire("2Od7Q");

var $amofj = parcelRequire("amofj");

var $5BDlp = parcelRequire("5BDlp");

var $htRH6 = parcelRequire("htRH6");

var $iI0D7 = parcelRequire("iI0D7");

var $6QCFv = parcelRequire("6QCFv");

var $kO6Bt = parcelRequire("kO6Bt");

var $jZ5ZE = parcelRequire("jZ5ZE");

var $6lGuT = parcelRequire("6lGuT");

var $15Bho = parcelRequire("15Bho");

var $9hgTz = parcelRequire("9hgTz");

var $8Oeas = parcelRequire("8Oeas");

var $dk5k7 = parcelRequire("dk5k7");

var $aKkqm = parcelRequire("aKkqm");

var $duW2E = parcelRequire("duW2E");

var $f18a7 = parcelRequire("f18a7");

var $izGzx = parcelRequire("izGzx");

var $jqUS6 = parcelRequire("jqUS6");

var $i8Ov5 = parcelRequire("i8Ov5");

var $atmQm = parcelRequire("atmQm");

var $gO4wS = parcelRequire("gO4wS");

var $df4OW = parcelRequire("df4OW");

var $cKmtB = parcelRequire("cKmtB");

var $c4Noe = parcelRequire("c4Noe");

var $g7CNh = parcelRequire("g7CNh");

var $6p65M = parcelRequire("6p65M");

var $74YUs = parcelRequire("74YUs");

var $aJYU4 = parcelRequire("aJYU4");

var $4gSNJ = parcelRequire("4gSNJ");

var $io6d9 = parcelRequire("io6d9");

var $1Qr8P = parcelRequire("1Qr8P");

var $68PIQ = parcelRequire("68PIQ");

var $krR5z = parcelRequire("krR5z");

var $cKLMf = parcelRequire("cKLMf");

var $76atT = parcelRequire("76atT");

var $hkMuP = parcelRequire("hkMuP");

var $dDuP2 = parcelRequire("dDuP2");

var $8Zc6q = parcelRequire("8Zc6q");

var $bBsgH = parcelRequire("bBsgH");

var $iNbdw = parcelRequire("iNbdw");

var $in9xh = parcelRequire("in9xh");

var $l7TnK = parcelRequire("l7TnK");

var $41OOS = parcelRequire("41OOS");

var $a54EB = parcelRequire("a54EB");

var $ljZYp = parcelRequire("ljZYp");

var $PjK35 = parcelRequire("PjK35");

var $bBP8k = parcelRequire("bBP8k");

var $jrMGk = parcelRequire("jrMGk");

var $dHbyA = parcelRequire("dHbyA");

var $h9R4P = parcelRequire("h9R4P");

var $8MHsf = parcelRequire("8MHsf");

var $18lRJ = parcelRequire("18lRJ");

var $2sLUA = parcelRequire("2sLUA");

var $19CFn = parcelRequire("19CFn");

var $6rBuB = parcelRequire("6rBuB");

var $grJbt = parcelRequire("grJbt");

var $3DPx5 = parcelRequire("3DPx5");

var $j2K1B = parcelRequire("j2K1B");

var $arFJU = parcelRequire("arFJU");

var $42k1m = parcelRequire("42k1m");

var $kja5T = parcelRequire("kja5T");

var $exGAm = parcelRequire("exGAm");

var $jpKCL = parcelRequire("jpKCL");

var $eyLou = parcelRequire("eyLou");

var $1jEjH = parcelRequire("1jEjH");

var $gv0iu = parcelRequire("gv0iu");

var $B2MdJ = parcelRequire("B2MdJ");

var $jbjvY = parcelRequire("jbjvY");

var $gX2iF = parcelRequire("gX2iF");

var $ghE7d = parcelRequire("ghE7d");

var $b72sS = parcelRequire("b72sS");

var $afTTM = parcelRequire("afTTM");

var $kosYS = parcelRequire("kosYS");

var $1fM2q = parcelRequire("1fM2q");

var $jGOZx = parcelRequire("jGOZx");

var $7BIh5 = parcelRequire("7BIh5");

var $gwiue = parcelRequire("gwiue");

var $4iFeZ = parcelRequire("4iFeZ");

var $8amd9 = parcelRequire("8amd9");

var $i9IdK = parcelRequire("i9IdK");

var $5AXvC = parcelRequire("5AXvC");

var $lOgtZ = parcelRequire("lOgtZ");

var $ai0fh = parcelRequire("ai0fh");

var $4nRwn = parcelRequire("4nRwn");

var $hHHSG = parcelRequire("hHHSG");

var $7vPqO = parcelRequire("7vPqO");

var $gtYd7 = parcelRequire("gtYd7");

var $2NBeW = parcelRequire("2NBeW");

var $8KqSV = parcelRequire("8KqSV");

var $30rQH = parcelRequire("30rQH");

var $jGgpa = parcelRequire("jGgpa");

var $ioeg9 = parcelRequire("ioeg9");

var $iU3AQ = parcelRequire("iU3AQ");

var $fXdfQ = parcelRequire("fXdfQ");

var $g2MQt = parcelRequire("g2MQt");

var $j9FGY = parcelRequire("j9FGY");

var $4lCqq = parcelRequire("4lCqq");

var $2VLCm = parcelRequire("2VLCm");

var $a8Zn1 = parcelRequire("a8Zn1");

var $5oufH = parcelRequire("5oufH");

var $dTMvK = parcelRequire("dTMvK");

var $bkUUf = parcelRequire("bkUUf");

var $gDIGr = parcelRequire("gDIGr");

var $iEkVj = parcelRequire("iEkVj");

var $khsuc = parcelRequire("khsuc");

var $kZu9w = parcelRequire("kZu9w");

var $lKVGb = parcelRequire("lKVGb");

var $diDcA = parcelRequire("diDcA");

var $a1COj = parcelRequire("a1COj");

var $hSLcD = parcelRequire("hSLcD");

var $iJL0D = parcelRequire("iJL0D");

var $eE7tm = parcelRequire("eE7tm");

var $dKgR9 = parcelRequire("dKgR9");

var $dL10z = parcelRequire("dL10z");
// shared's OWN registered functions (peopleUtils, dateUtils, avatarUrl,
// canvasUrl, slugify, profilePath, applyLoader, closeModalByStateKey, …)
// are NOT re-registered here. `shared` is a declared library of the shell
// (sharedLibraries.js), so its functions bag is already merged into every
// shell context and `el.call('findPerson')` reaches shared's own function
// with `this` = the element. A shell-side delegate under the SAME key was a
// second definition: in a catalog page that merges both libraries the merge
// order picked one, and when the shell's delegate won, its
// `_wsShared.functions.<name>` lookup could resolve back to itself.
//
// HOUSE PATTERN — every deferred-call wrapper here MUST be a `function`
// expression forwarding via `.apply(this, args)`, NEVER an arrow. el.call
// invokes registered functions with `this` = the element
// (smbls element/src/methods.js `method.call(this, ...args)`), and several
// shared impls fall back to `this.state.root` when called with no args
// (peopleByEmail, findPerson, isSelf, avatarUrlFor, activeMembers) or use
// `this.getRoot()` outright (applyLoader). An arrow wrapper silently
// rebinds `this` to `_wsShared.functions`, so the zero-arg fallback
// resolved no root and e.g. `el.call('peopleByEmail')` returned {} —
// AvatarBundle rendered zero avatars against a populated root.people
// (found live 2026-08-13). Same convention as `closeModal` (./closeModal.js).
const $019e1e3f0a85c670$var$shellCreateIframeApp = function(...args) {
    return (0, $1X0Je.default).functions.createIframeApp.apply(this, args);
};
const $019e1e3f0a85c670$var$shellInjectSprites = function(...args) {
    return (0, $1X0Je.default).functions.injectSprites.apply(this, args);
};
const $019e1e3f0a85c670$export$142a1380a75551d = (0, $gFf4Y.homeContextAction);
const $019e1e3f0a85c670$export$f45f0c1633185f6b = (0, $2EI10.focusContextMenu);
const $019e1e3f0a85c670$export$1e5010e2fb47abf7 = (0, $gFf4Y.focusHomeContextMenu);
const $019e1e3f0a85c670$export$816fa6275d9a9abe = (0, $gFf4Y.homeContextMenuAllowed);
const $019e1e3f0a85c670$export$d828ab43b0b127a = (0, $gFf4Y.closeContextMenuOnEscape);
const $019e1e3f0a85c670$export$b218a894899859d6 = (0, $gFf4Y.closeContextMenuOnRouteChange);
const $019e1e3f0a85c670$export$ff218d764e4648ea = (0, $gFf4Y.homeWidgetAiTarget);
const $019e1e3f0a85c670$export$a7af41eaaba8bf85 = (0, $gFf4Y.homeWidgetChangeWithAi);
const $019e1e3f0a85c670$export$a0675cce39901380 = (kind, { scopeType: scopeType, scopeId: scopeId, slug: slug } = {})=>{
    console.warn(`[startOAuthFlow] stub \u{2014} kind=${kind} scope=${scopeType}:${scopeId ?? 'null'} slug=${slug ?? 'default'}`);
    throw new Error(`OAuth flow not wired yet for ${kind} \u{2014} coming in follow-up once DOMAIN's first OAuth2 provider (Cloudflare registrar) ships.`);
};
// contactsDirectory.js (el.call action helpers over the Party Directory
// services) moved to the system/crm-app marketplace module — the shell no
// longer bundles a second copy.
// renderExtensionInPane(iframeNode, { name, source }) — mount an AI-generated
// WORKSPACE EXTENSION into an <iframe> (the /add-app right pane, the home
// dashboard split-pane slot — pages/main.js _mountSplitExtension — and any
// other caller that hands us an iframe node). The cloud agentic loop's
// render_extension_page client tool reaches here via window.__addAppHost →
// injectPageInApp (see simoneAiTransport.js). We parse the model's DOMQL
// source, then boot it as its OWN smbls app inside the iframe via
// createIframeApp.
//
// Still an iframe, and still fully router-isolated — an iframe realm
// physically cannot reach the shell router, so a throwing/misbehaving
// generated page (the AI rebuilds this content on every turn) can never
// blank the workspace (unlike injectPageInApp on the shell root). That
// containment is unchanged.
//
// What DOES change: this is not a foreign embed. Because the iframe is
// same-origin, it's the same JS heap as the shell — so we hand the iframe app
// the WORKSPACE SHELL's full component registry + full function registry via
// createIframeApp's `contextOverrides` (passed BY REFERENCE, no clone — see
// embedComponent.js `shareContext` for the established precedent of this
// exact passthrough; components/functions are never boot-mutated downstream,
// confirmed by reading prepareComponents/prepareContext, so sharing them live
// is safe). The design system is different: we hand over the shell's RAW
// design-system SOURCE (`extensionDesignSystemSource()`, a fresh object every
// render), NOT the shell's live processed CONFIG — see
// functions/extensionDesignSystem.js for the framework input contract that
// makes this the only correct shape, and for why a live reference is unsafe
// on top of that (short version: it wedged the shell in testing). The
// generated DOMQL can therefore extend house components by bare key
// (`extends: 'AppPage'`, brand components), resolve the same workspace design
// tokens the shell resolves (processed once, inside the iframe, against the
// iframe's own document), and call
// house functions via `el.call` — the SAME trust surface a runtime workspace
// module gets (see workspaceProjects.js's context injection). The
// extension's OWN AI-authored components/functions still go through
// createIframeApp's normal clone + rerealm path (isolated, realm-adapted).
//
// This enrichment is opt-in AT THIS CALL SITE ONLY — createIframeApp itself
// is untouched, so canvas embeds / preview / project-app generation (which
// never pass this shape of contextOverrides) resolve byte-identical
// behavior: their own design system, their own context, no workspace
// registry leakage. Scope: workspace-extension rendering only.
//
// The two security gates are unchanged: auditExtensionSource (below) statically
// blocks raw network/storage/eval before the source is ever eval'd, and
// buildExtensionDataBridge scopes the extension's declarative `fetch:` surface
// to exactly its declared workspaceProject.* entities. Returns
// { ok, rendered } / { ok:false, error } so the model can self-correct bad DOMQL.
//
// DESIGN SYSTEM FOR AN EXTENSION IFRAME — two separate hazards, both closed by
// handing over the RAW source (`extensionDesignSystemSource()`), never anything
// derived from the shell's live `ctx.designSystem`.
//
// 1. WRONG INPUT TYPE (2026-07-27). `ctx.designSystem` is the PROCESSED scratch
//    CONFIG; `create()` expects a RAW source and processes it itself. Feeding a
//    processed config back in re-derived every suffix from an already-derived
//    value — the iframe got `--color-black-var`, `--theme-document-background-
//    background`, 3607 var definitions against the host's 1702, and
//    `--theme-document-background` resolving to a
//    `var(--theme-document-<scheme>-background)` that nothing defines, so every
//    `theme:` prop inside an extension was dead. `injectSprites` double-
//    converted the same way (`convertSvgToSymbol` over `<symbol>` strings).
//    See functions/extensionDesignSystem.js for the full contract note and for
//    why the fix belongs here rather than in scratch's transformers.
//
// 2. LIVE-REFERENCE WEDGE (2026-07-13 live test). An earlier version passed the
//    shell's live CONFIG object itself. That wedged the shell into a permanent
//    full-viewport MainLoader the moment an extension was injected
//    (body.smblsapp backref lost, reload required), because `deepClone`
//    (@symbo.ls/utils, packages/utils/object.js) is DELIBERATE about DOM nodes
//    — `if (isDOMNode(value)) { dest[key] = value; continue }` — so the CONFIG's
//    two live DOM bindings, `.themeRoot` (what changeGlobalTheme stamps
//    `data-theme` onto) and `.document`, survived every clone/merge step of
//    smbls' own prepareDesignSystem → createConfig pipeline as opaque leaves.
//    `result.context.designSystem.themeRoot = appEl` (shared/iframeApp/
//    createIframeApp.js) then reached back toward the shell's own theme target.
//    That was patched by stripping the two fields after cloning; the raw source
//    carries neither field to begin with, so the hazard is now absent by
//    construction and the strip is gone with the clone it guarded.
//
// The shell's ACTIVE THEME is still read off the live CONFIG below — but only
// as the `globalTheme` scalar, which is a plain string and carries no DOM
// binding. Everything structural comes from the raw source.
//
// Components/functions are NOT put through this — prepareComponents does a
// plain shallow spread (`{...UIkitWithPrefix(), ...context.components}`, no
// clone) and context.functions is a straight pass-through; neither is
// boot-mutated anywhere in the traced pipeline, so sharing them live is safe.
// The shell's currently active theme name, read off the live scratch CONFIG
// (`changeGlobalTheme` mutates exactly this field — see smbls/CLAUDE.md
// "Global theme handling"), so a user who forced light/dark sees the extension
// pane match rather than just the OS preference.
const $019e1e3f0a85c670$var$_activeGlobalTheme = (ds)=>ds && typeof ds === 'object' && ds.globalTheme || 'auto';
// Resolve the live workspace root state off the root element, then build the
// iframe seed via the pure helper (functions/extensionDataSeed.js — see there
// for the full why/safety/semantics). Uses smbls deepClone for clone fidelity.
const $019e1e3f0a85c670$var$_seedFromWorkspaceRoot = (source, wsRoot)=>{
    const rootState = wsRoot && wsRoot.getRootState && wsRoot.getRootState() || wsRoot && wsRoot.state && (wsRoot.state.root || wsRoot.state) || wsRoot && wsRoot.getRoot && wsRoot.getRoot() && wsRoot.getRoot().state || null;
    return (0, $hROPr.buildRootStateSeed)(source, rootState, {
        clone: (0, $2C0hZ.deepClone)
    });
};
// PLATFORM SURFACE — give an AI-generated app the page LAYOUT and the visual
// SURFACE of a native workspace module (fill the frame, comfortable padding,
// scroll, house background + text color) so it doesn't render as cramped bare
// content floating transparent on the build canvas.
//
// The surface is a design-system `theme:` like every other workspace page —
// which is only possible now that the iframe resolves real theme vars. Two
// separate reasons it previously could not: the framework did not inject the
// theme-var block into an embed iframe at all (fixed in smbls 6eb671bc8 +
// 5acd20774), and this file then fed the iframe a double-processed design
// system so the block it did inject named the wrong vars (fixed above). While
// both were broken a `theme:` here resolved to undefined vars — transparent bg
// + black text — and a `_paintHostSurface` helper copied the host's computed
// background/color onto the iframe body instead. That workaround is
// retired: it only ever approximated the surface (it could not touch any OTHER
// `theme:` in the source, which stayed dead), and it tracked the host document
// rather than the extension's own resolved theme.
//
// Merges additively onto the MOUNTED ROOT (only where the source didn't set the
// prop). Mutates + returns the same root object (it IS the shell root;
// wrapping would re-parent its state and break `s.root`/`~/` data binding).
const $019e1e3f0a85c670$var$_applyPlatformSurface = (root)=>{
    if (!root || typeof root !== 'object' || Array.isArray(root)) return root;
    // House page surface — same token the native workspace pages render on.
    // Respect an app that picked its own theme.
    if (root.theme === undefined) root.theme = 'document';
    // Fill the iframe body (html/body are 100% height) and scroll long content.
    if (root.minHeight === undefined) root.minHeight = '100%';
    if (root.overflowY === undefined && root.overflow === undefined) root.overflowY = 'auto';
    if (root.boxSizing === undefined) root.boxSizing = 'border-box';
    // Comfortable page padding matching workspace pages; respect an app that
    // already manages its own edge spacing.
    if (root.padding === undefined) root.padding = 'C';
    // Stack content vertically by default so a bare page reads top-to-bottom
    // (only when the app didn't pick its own layout direction/display).
    if (root.flow === undefined && root.display === undefined && root.tag !== 'form') root.flow = 'y';
    return root;
};
// Empty-list defaults for every `as: '~/key'` fetch target declared in an
// extension source — pre-declared on the mounted page's state so reactive
// readers (children factories above all) TRACK the key from first render and
// re-fire when the fetch lands. A regex false positive merely pre-declares an
// unused [] key; extension-declared state always wins the merge.
// ── IN-SHELL extension rendering (2026-07-25 per Nika: "it does not have to
// be in iframe … building workspace apps should strictly follow workspace
// design system, brand and workspace components … the viewer should render in
// workspace accepted view", same for /add-app) ──────────────────────────────
// Builds a directly-mountable page def from an AI-built app source — NO
// iframe. In-shell mounting is what makes a built app NATIVE: the live design
// system (tokens, themes, dark/light), the house components (Input, Button,
// Select, Flex …) and the active workspace module's components all resolve
// exactly like any workspace page — none of that reached the isolated iframe
// realm (bare unstyled inputs over a transparent surface). Same trust model
// as render_answer_ui, which has always mounted AI-authored defs in-shell:
//   • the static audit gate stays (auditExtensionSource — no raw network/
//     storage/eval/realm-escape primitives);
//   • data access stays ENTITY-SCOPED: every `fetch:` decl in the def is
//     rewritten to carry the extension data bridge's per-decl executor
//     (adapter 'sdk'), so reads/writes still route ONLY through
//     workspaceProject.<declared-entity> — never the full SDK surface;
//   • `as: '~/key'` targets are rewritten to element-local `as: 'key'` —
//     in-shell, `~/` would write the WORKSPACE SHELL's root state (the iframe
//     had its own root). Local `as` writes the page element's state, which is
//     the same state its children factories read (fetch plugin
//     updateElementState). `s.root.<key>` reads now resolve against the LIVE
//     workspace root — no seed copy needed.
// Rewrites, per fetch decl:
//   • `from: 'records'` → `from: 'workspaceProject.records'` — the app
//     vocabulary uses bare entity names; in-shell the decl resolves through
//     the SHELL's sdk adapter, whose dispatcher only knows namespaced routes
//     (verified live: bare 'records' → "[sdk.execute] Unknown entity"). A
//     per-decl scoped executor does NOT work here — the fetch plugin builds
//     the named adapter once and reuses it, so decl-level executor/adapter
//     options are ignored. workspaceProject.* is workspace-pinned +
//     RLS-enforced server-side; trust model = render_answer_ui (in-shell,
//     audit-gated).
//   • `as: '~/key'` → `as: 'key'` — element-local state, not the shell root.
const $019e1e3f0a85c670$var$_rewriteFetchDecls = (definition, seen = new Set(), factories = new WeakMap())=>{
    if (!definition || typeof definition !== 'object' || seen.has(definition)) return;
    seen.add(definition);
    if (Array.isArray(definition)) {
        for (const n of definition)$019e1e3f0a85c670$var$_rewriteFetchDecls(n, seen, factories);
        return;
    }
    if (definition.fetch && typeof definition.fetch === 'object') {
        const arr = Array.isArray(definition.fetch) ? definition.fetch : [
            definition.fetch
        ];
        definition.fetch = arr.map((d)=>{
            if (!d || typeof d !== 'object') return d;
            const out = {
                ...d
            };
            if (typeof out.from === 'string' && out.from && !out.from.includes('.')) out.from = `workspaceProject.${out.from}`;
            if (typeof out.as === 'string' && out.as.startsWith('~/')) out.as = out.as.slice(2);
            // A notification the app sends opens the app (functions/
            // generatedNotifyHref.js; persona round 5, marcus: a tap on "New
            // open-house lead" opened nothing — the form's data carries no href).
            // The app's own transform runs first; an href it set is kept.
            const entity = typeof out.from === 'string' ? out.from.split('.').pop() : '';
            const method = String(out.method || '').toLowerCase();
            if (entity === 'notifications' && [
                'insert',
                'create',
                'upsert'
            ].includes(method)) {
                const own = typeof out.transform === 'function' ? out.transform : null;
                out.transform = function(data, element, state) {
                    const shaped = own ? own.call(this, data, element, state) : data;
                    return (0, $79dxh.generatedNotifyHref)(shaped, $019e1e3f0a85c670$var$_rootStateOf(element));
                };
            }
            return out;
        });
    }
    for(const k in definition){
        if (k === 'state' || k === 'fetch') continue;
        const v = definition[k];
        if (k === 'children' && typeof v === 'function') {
            // Row definitions exist only when the framework invokes the factory.
            // Keep it lazy and rewrite each result before the framework mounts it.
            let wrapped = factories.get(v);
            if (!wrapped) {
                wrapped = function(...args) {
                    const children = v.apply(this, args);
                    $019e1e3f0a85c670$var$_rewriteFetchDecls(children, new Set(), factories);
                    return children;
                };
                factories.set(v, wrapped);
                factories.set(wrapped, wrapped);
            }
            definition[k] = wrapped;
        } else if (v && typeof v === 'object') $019e1e3f0a85c670$var$_rewriteFetchDecls(v, seen, factories);
    }
};
// ── GENERATED-APP CONTAINMENT (Nika 2026-10-01 "Cut access now") ──────────
// Every AI-generated page is parsed through parseGeneratedAppSource: the AST
// gate (functions/generatedAppContainment.js, rules in generatedAppRules.js —
// the server reads the same file) runs inside parseFreestyleSource on the
// EXACT text it evaluates. A refused page never evaluates and never mounts in
// part; viewers mount generatedAppBlockedDef instead ("This app uses a blocked
// feature" + "Ask AI to rebuild"). auditExtensionSource stays as the second
// line. FAIL CLOSED: if the parser did not run the hook (an older parser that
// ignores the option), the page is refused.
const $019e1e3f0a85c670$var$_rootStateOf = (el)=>el && el.getRootState && el.getRootState() || el && el.state && (el.state.root || el.state) || el && el.getRoot && el.getRoot() && el.getRoot().state || null;

function $019e1e3f0a85c670$export$a8697a476f6e84cd(...args) {
    return (parcelRequire("cJlgS")).then((m)=>m.mountSandboxedApp.apply(this, args));
}
const $019e1e3f0a85c670$export$95f420f8bbfa37e6 = ({ name: name, violations: violations } = {})=>({
        extends: 'GeneratedAppBlocked',
        state: {
            appName: String(name || ''),
            blockedReasons: (Array.isArray(violations) ? violations : []).map((v)=>v && v.rule + (v.detail ? ': ' + v.detail : '') || '').filter(Boolean).slice(0, 12)
        }
    });
// The regex audit (auditExtensionSource, the second line) refuses with
// strings; a refusal from either line is the same blocked state.
const $019e1e3f0a85c670$var$_regexRefusal = (audit)=>({
        violations: (audit.violations || []).map((v)=>({
                rule: 'audit',
                at: null,
                detail: String(v)
            }))
    });
const $019e1e3f0a85c670$var$_blocked = (name, res, prefix = '')=>({
        ok: false,
        blocked: true,
        error: prefix + (0, $7iHfb.GENERATED_APP_BLOCKED),
        violations: res.violations,
        def: $019e1e3f0a85c670$export$95f420f8bbfa37e6({
            name: name,
            violations: res.violations
        })
    });
function $019e1e3f0a85c670$export$98c43e9a748fcd98(args = {}) {
    const el = this && this.call ? this : arguments[0];
    const a = (this && this.call ? args : arguments[1]) || {};
    const source = String(a.source || '');
    const audit = (0, $gvbDt.auditExtensionSource)(source);
    if (!audit.ok) return {
        ...$019e1e3f0a85c670$var$_blocked(a.name, $019e1e3f0a85c670$var$_regexRefusal(audit)),
        error: audit.error
    };
    // SANDBOX (ISOLATED-RUNTIME-PLAN §8.1, flag `appsSandbox`, default off):
    // the same gate on the exact text the frame evaluates; nothing evaluates
    // here. The data surface is the caller's (the stored manifest), never the
    // source's own `entities`.
    if ((0, $7qVzJ.generatedAppSandboxOn)($019e1e3f0a85c670$var$_rootStateOf(el))) {
        const built = (0, $7qVzJ.buildSandboxedAppDef).call(el, {
            name: a.name || 'Extension',
            source: source,
            crmLeads: a.crmLeads
        });
        if (built.blocked) return $019e1e3f0a85c670$var$_blocked(a.name, built);
        if (!built.ok) return {
            ok: false,
            error: built.error
        };
        const def = built.def;
        (0, $jw8v7.setLastRenderedExtension)({
            name: a.name || 'Extension',
            source: source,
            entities: def.sandboxApp.entities
        });
        return {
            ok: true,
            sandboxed: true,
            def: def,
            entities: def.sandboxApp.entities
        };
    }
    const parsed = (0, $ggoif.parseGeneratedAppSource).call(el, source);
    if (parsed.blocked) return $019e1e3f0a85c670$var$_blocked(a.name, parsed);
    if (!parsed.ok) return {
        ok: false,
        error: parsed.error
    };
    const def = parsed.def;
    if (!def || typeof def !== 'object') return {
        ok: false,
        error: 'source did not evaluate to an object'
    };
    const pageDef = def.page && typeof def.page === 'object' ? def.page : def;
    const ownState = pageDef.state && typeof pageDef.state === 'object' && !Array.isArray(pageDef.state) ? pageDef.state : {};
    pageDef.state = {
        ...(0, $7qVzJ.pageStateSeed)(source),
        ...ownState
    };
    const entities = [
        ...new Set((0, $gvbDt.declaredEntitiesFromSpec)(def).concat(Array.isArray(a.entities) ? a.entities : []))
    ];
    const bridge = (0, $gvbDt.buildExtensionDataBridge)(entities);
    $019e1e3f0a85c670$var$_rewriteFetchDecls(pageDef);
    // the visitor line under a sign-up form, only while CRM sending is on
    // (the server's row flag; functions/crmLeadsVisitorLine.js)
    (0, $XpvS7.crmLeadsVisitorLine)(pageDef, a.crmLeads);
    $019e1e3f0a85c670$var$_applyPlatformSurface(pageDef);
    (0, $jw8v7.setLastRenderedExtension)({
        name: a.name || 'Extension',
        source: source,
        entities: entities
    });
    return {
        ok: true,
        def: pageDef,
        entities: bridge.allowed,
        support: bridge.support
    };
}
function $019e1e3f0a85c670$export$cc37101470185811(args = {}) {
    const el = this && this.call ? this : arguments[0];
    const a = (this && this.call ? args : arguments[1]) || {};
    // The root page's fallback title and the brand word for an unnamed app are the
    // shell's own copy, rendered in the shell — resolved here, where polyglot is.
    const pages = (0, $lG24I.normalizePages)(a.pages, {
        home: el.call('polyglot', 'shell.app.home')
    });
    if (!pages.length) return {
        ok: false,
        error: 'at least one page with non-empty source is required'
    };
    // SANDBOX (ISOLATED-RUNTIME-PLAN §8.1): every page through the same gate on
    // its exact text; nothing evaluates here; the frame builds the nav shell.
    if ((0, $7qVzJ.generatedAppSandboxOn)($019e1e3f0a85c670$var$_rootStateOf(el))) {
        const sandboxPages = [];
        const sandboxEntities = new Set();
        let combinedSource = '';
        for (const p of pages){
            const audit = (0, $gvbDt.auditExtensionSource)(p.source);
            if (!audit.ok) return {
                ...$019e1e3f0a85c670$var$_blocked(a.name, $019e1e3f0a85c670$var$_regexRefusal(audit)),
                error: `page ${p.route}: ${audit.error}`
            };
            const checked = (0, $ggoif.auditGeneratedAppSource).call(el, p.source);
            if (checked.blocked) return $019e1e3f0a85c670$var$_blocked(a.name, checked, `page ${p.route}: `);
            if (!checked.ok) return {
                ok: false,
                error: `page ${p.route} ${checked.error}`
            };
            const refused = (0, $7qVzJ.sandboxComponentRefusals)(checked.expr);
            if (refused.length) return $019e1e3f0a85c670$var$_blocked(a.name, {
                violations: refused
            }, `page ${p.route}: `);
            for (const e of (0, $7qVzJ.sandboxWrapperEntities)(checked.expr))sandboxEntities.add(e);
            sandboxPages.push({
                route: p.route,
                title: p.title,
                expr: checked.expr,
                jsonAuthored: checked.jsonAuthored
            });
            combinedSource += '\n' + p.source;
        }
        const def = (0, $7qVzJ.sandboxAppDef)({
            name: a.name,
            // the union of every page's OWN wrapper; the caller's list is ignored
            entities: [
                ...sandboxEntities
            ].sort(),
            stateSeed: (0, $7qVzJ.pageStateSeed)(combinedSource),
            pages: sandboxPages,
            appLabel: el.call('polyglot', 'workspace.apps.nameFallback'),
            crmLeads: a.crmLeads
        });
        (0, $jw8v7.setLastRenderedExtension)(null);
        return {
            ok: true,
            sandboxed: true,
            def: def,
            entities: def.sandboxApp.entities
        };
    }
    const pageDefs = {};
    const declared = new Set(Array.isArray(a.entities) ? a.entities : []);
    let combined = '';
    for (const p of pages){
        const audit = (0, $gvbDt.auditExtensionSource)(p.source);
        if (!audit.ok) return {
            ...$019e1e3f0a85c670$var$_blocked(a.name, $019e1e3f0a85c670$var$_regexRefusal(audit)),
            error: `page ${p.route}: ${audit.error}`
        };
        const parsed = (0, $ggoif.parseGeneratedAppSource).call(el, p.source);
        if (parsed.blocked) return $019e1e3f0a85c670$var$_blocked(a.name, parsed, `page ${p.route}: `);
        if (!parsed.ok) return {
            ok: false,
            error: `page ${p.route} ${parsed.error}`
        };
        const def = parsed.def;
        if (!def || typeof def !== 'object') return {
            ok: false,
            error: `page ${p.route} did not evaluate to an object`
        };
        for (const e of (0, $gvbDt.declaredEntitiesFromSpec)(def))declared.add(e);
        pageDefs[p.route] = def.page || def;
        combined += '\n' + p.source;
    }
    const bridge = (0, $gvbDt.buildExtensionDataBridge)([
        ...declared
    ]);
    for (const route of Object.keys(pageDefs)){
        $019e1e3f0a85c670$var$_rewriteFetchDecls(pageDefs[route]);
        (0, $XpvS7.crmLeadsVisitorLine)(pageDefs[route], a.crmLeads);
    }
    const appShell = (0, $lG24I.buildAppShell)({
        name: a.name,
        nav: (0, $lG24I.buildNav)(pages),
        pageDefs: pageDefs,
        seedState: (0, $7qVzJ.pageStateSeed)(combined),
        appLabel: el.call('polyglot', 'workspace.apps.nameFallback')
    });
    (0, $jw8v7.setLastRenderedExtension)(null);
    return {
        ok: true,
        def: appShell,
        entities: bridge.allowed,
        support: bridge.support
    };
}
async function $019e1e3f0a85c670$export$45cb414de673c07c(iframeNode, args = {}) {
    const source = args && args.source;
    if (!iframeNode || !source) return {
        ok: false,
        error: 'iframe node and source are required'
    };
    const wsRoot = typeof window !== 'undefined' && window.__wsRoot || null;
    if (!wsRoot || typeof wsRoot.call !== 'function') return {
        ok: false,
        error: 'no workspace root available'
    };
    // SANDBOX (appsSandbox): no in-shell iframe mount of generated source.
    if ((0, $7qVzJ.generatedAppSandboxOn)($019e1e3f0a85c670$var$_rootStateOf(wsRoot))) return {
        ok: false,
        error: 'sandbox: the in-shell mount is off with appsSandbox; use the builders'
    };
    // SECURITY GATE #1 — static audit BEFORE the source is eval'd. Reject any
    // generated extension reaching for raw network/storage/eval/shell-escape
    // primitives (it should only use the declarative fetch: surface). Returns the
    // violations to the caller so the cloud model can self-correct.
    const audit = (0, $gvbDt.auditExtensionSource)(source);
    if (!audit.ok) return {
        ok: false,
        error: audit.error,
        violations: audit.violations
    };
    const parsed = wsRoot.call('parseGeneratedAppSource', source);
    if (parsed && parsed.blocked) return $019e1e3f0a85c670$var$_blocked(args.name, parsed);
    if (!parsed || !parsed.ok) return {
        ok: false,
        error: parsed && parsed.error || 'parse failed'
    };
    const def = parsed.def;
    if (!def || typeof def !== 'object') return {
        ok: false,
        error: 'source did not evaluate to an object'
    };
    const ctx = wsRoot.context || wsRoot.getRoot && wsRoot.getRoot() && wsRoot.getRoot().context || {};
    const pageDef = def.page || def;
    // LIVE-DATA SEED — a drawn answer view reads `s.root.<stateKey>`; the iframe's
    // root state starts empty, so seed the referenced (non-sensitive) workspace
    // root keys into the page def's state before mount. Without this a saved
    // answer view renders blank (see _seedFromWorkspaceRoot). Extension-declared
    // state wins over the seed on a key collision.
    const { seed: seed, seeded: seeded, missing: missing } = $019e1e3f0a85c670$var$_seedFromWorkspaceRoot(source, wsRoot);
    if (seeded.length || missing.length) {
        const ownState = pageDef.state && typeof pageDef.state === 'object' && !Array.isArray(pageDef.state) ? pageDef.state : {};
        pageDef.state = {
            ...seed,
            ...ownState
        };
    }
    // FETCH-TARGET STATE PRE-DECLARATION — v3.14 children factories re-run only
    // for state keys PRESENT at first render (the absent-key signal gap,
    // tickets/smbls.md "nested children factory never re-fires…"). An app whose
    // rows land via `fetch: { …, as: '~/suppliers' }` starts with NO `suppliers`
    // key, so the fetch completion filled state that no list re-read — the app
    // rendered an empty table over live data (verified 2026-07-25: iframe state
    // suppliers:3, zero rendered rows). Declare every fetch target up front so
    // the first render tracks the key — the same contract the shell itself
    // relies on (state-app.js declares every reactive key).
    const fetchDefaults = (0, $7qVzJ.pageStateSeed)(source);
    if (Object.keys(fetchDefaults).length) {
        const ownState = pageDef.state && typeof pageDef.state === 'object' && !Array.isArray(pageDef.state) ? pageDef.state : {};
        pageDef.state = {
            ...fetchDefaults,
            ...ownState
        };
    }
    // Render on the native workspace app-surface (theme/padding/scroll) so the
    // generated app looks like a real module page, not bare content on the
    // canvas. Applied to the mounted root so state binding (`s.root`/`~/`) is
    // untouched.
    $019e1e3f0a85c670$var$_applyPlatformSurface(pageDef);
    // SECURITY GATE #2 — capability-scoped data access. Build a narrowed SDK
    // fetch executor limited to the entities this extension DECLARED (def.entities
    // / spec entities), all forced into the workspace-pinned workspaceProject.*
    // namespace and routed through sdk.execute (RLS-enforced). The extension's
    // declarative `fetch: [{ from: 'policies', method: 'list' }]` resolves through
    // THIS executor — it never sees a raw data client or the full SDK.
    const declaredEntities = [
        ...new Set((0, $gvbDt.declaredEntitiesFromSpec)(def).concat(Array.isArray(args.entities) ? args.entities : []))
    ];
    const bridge = (0, $gvbDt.buildExtensionDataBridge)(declaredEntities);
    // Mount the page ONLY as the create() shell (3rd arg). Do NOT also put it in
    // data.app / data.pages['/'] — createIframeApp would then mount both the app
    // shell and the '/' page (the same def) and the extension renders twice.
    //
    // `data` carries ONLY the extension's own (untrusted, AI-authored) content —
    // this is what createIframeApp clones + rerealms into the iframe realm, so
    // any accidental window./document. reference inside an AI-generated factory
    // binds to the IFRAME's globals, never the shell's.
    // The shell's RAW design-system source — a fresh object per render, never
    // anything derived from the live ctx.designSystem CONFIG. See the
    // "DESIGN SYSTEM FOR AN EXTENSION IFRAME" note above. Computed once and
    // reused below so the contextOverrides value and the icon-sprite injection
    // agree on the exact same object.
    const isolatedDesignSystem = (0, $6jWcN.extensionDesignSystemSource)();
    const data = {
        icons: def.icons || {},
        // Scoped data adapter — the ONLY data channel the extension iframe gets.
        fetch: bridge.fetch,
        // Match the shell's CURRENT active theme (not just OS 'auto').
        globalTheme: $019e1e3f0a85c670$var$_activeGlobalTheme(ctx.designSystem)
    };
    // WORKSPACE-EXTENSION ENRICHMENT — opt-in at THIS call site only (see the
    // function doc-comment above). `contextOverrides` is createIframeApp's
    // existing generic passthrough; nothing in shared/iframeApp changes.
    // components/functions: same-origin iframe = same JS heap, handed over BY
    // REFERENCE — no clone, no rerealm needed (rerealming a trusted shell
    // function would silently re-eval it from source text in the iframe realm,
    // losing its module closure — only extension-authored code in `data` needs
    // that treatment; neither registry is boot-mutated downstream). designSystem:
    // the RAW source computed above, never the live processed CONFIG.
    //
    // Extension-declared components/functions (rare — most generated sources
    // only declare a page) still win on a name collision, mirroring the
    // project-tier-wins-over-shared-tier precedent used everywhere else in this
    // codebase (framework built-ins → shared libraries → project).
    // FUNCTIONS: the allowlisted registry only (generatedAppContainment.js),
    // never the shell's whole ctx.functions — a page that reached
    // `el.call('getSDK')` got the member's full SDK. The page's own audited
    // functions still register.
    const contextOverrides = {
        designSystem: isolatedDesignSystem,
        components: {
            ...ctx.components || {},
            ...def.components || {}
        },
        functions: {
            ...(0, $ggoif.scopeGeneratedAppFunctions)(ctx.functions, parsed.allow),
            ...def.functions || {}
        }
    };
    try {
        const result = await $019e1e3f0a85c670$var$shellCreateIframeApp(iframeNode, data, pageDef, {
            path: '/',
            resetDocument: true,
            contextOverrides: contextOverrides
        });
        if (result) {
            // House icon sprite (Icon component's `icon: 'name'` → <use href="#…">)
            // injected explicitly against the raw design-system source — read-only
            // (confirmed: injectSprites only reads .icons/.svg, never writes back)
            // and RAW is the shape it needs: `convertSvgToSymbol` expects the
            // original `<svg>` body, and scratch's own `setSvgIcon` has already
            // rewritten those to `<symbol>` in a processed CONFIG. `data` no longer
            // carries `designSystem` (moved to contextOverrides above to skip
            // cloning the full registry on every render), so createIframeApp's own
            // internal sprite injection has nothing to key off; do it here instead.
            $019e1e3f0a85c670$var$shellInjectSprites(iframeNode.contentDocument, isolatedDesignSystem);
            // Stash what's now on screen so the Save / Share actions know what to
            // persist (the cloud agent may not have created a Project yet).
            (0, $jw8v7.setLastRenderedExtension)({
                name: args.name || def.name || 'Extension',
                source: source,
                entities: declaredEntities
            });
        }
        return result ? {
            ok: true,
            rendered: true,
            entities: bridge.allowed,
            support: bridge.support,
            seededKeys: seeded,
            missingKeys: missing
        } : {
            ok: false,
            error: 'createIframeApp returned null'
        };
    } catch (e) {
        return {
            ok: false,
            error: 'render: ' + (e && e.message || String(e))
        };
    }
}
async function $019e1e3f0a85c670$export$e828463b5aae626a(iframeNode, args = {}) {
    if (!iframeNode) return {
        ok: false,
        error: 'iframe node is required'
    };
    const wsRoot = typeof window !== 'undefined' && window.__wsRoot || null;
    if (!wsRoot || typeof wsRoot.call !== 'function') return {
        ok: false,
        error: 'no workspace root available'
    };
    // SANDBOX (appsSandbox): no in-shell iframe mount of generated source.
    if ((0, $7qVzJ.generatedAppSandboxOn)($019e1e3f0a85c670$var$_rootStateOf(wsRoot))) return {
        ok: false,
        error: 'sandbox: the in-shell mount is off with appsSandbox; use the builders'
    };
    const pages = (0, $lG24I.normalizePages)(args.pages, {
        home: wsRoot.call('polyglot', 'shell.app.home')
    });
    if (!pages.length) return {
        ok: false,
        error: 'at least one page with non-empty source is required'
    };
    const ctx = wsRoot.context || wsRoot.getRoot && wsRoot.getRoot() && wsRoot.getRoot().context || {};
    // Parse + audit each page; assemble the route→pageDef map + merged registries.
    // Audit gate runs per page (SECURITY GATE #1) — every page's source must pass
    // the same raw-network/storage/eval/shell-escape scan as a single extension.
    const pageDefs = {};
    const mergedComponents = {
        ...ctx.components || {}
    };
    // The allowlisted registry only — never the shell's whole ctx.functions.
    const mergedFunctions = (0, $ggoif.scopeGeneratedAppFunctions)(ctx.functions, (0, $ggoif.generatedAppAllowlist)($019e1e3f0a85c670$var$_rootStateOf(wsRoot)));
    const mergedIcons = {};
    const declaredEntities = new Set(Array.isArray(args.entities) ? args.entities : []);
    let combinedSource = '';
    for (const p of pages){
        const audit = (0, $gvbDt.auditExtensionSource)(p.source);
        if (!audit.ok) return {
            ok: false,
            error: `page ${p.route}: ${audit.error}`,
            violations: audit.violations
        };
        const parsed = wsRoot.call('parseGeneratedAppSource', p.source);
        if (parsed && parsed.blocked) return $019e1e3f0a85c670$var$_blocked(args.name, parsed, `page ${p.route}: `);
        if (!parsed || !parsed.ok) return {
            ok: false,
            error: `page ${p.route} ${parsed && parsed.error || 'parse failed'}`
        };
        const def = parsed.def;
        if (!def || typeof def !== 'object') return {
            ok: false,
            error: `page ${p.route} did not evaluate to an object`
        };
        pageDefs[p.route] = def.page || def;
        // Supplementary components/functions/icons register ADDITIVELY (a page may
        // bring a helper) but never SHADOW a registered one — mirrors renderAnswerUi.
        if (def.components) {
            for(const k in def.components)if (!mergedComponents[k]) mergedComponents[k] = def.components[k];
        }
        if (def.functions) {
            for(const k in def.functions)if (!mergedFunctions[k]) mergedFunctions[k] = def.functions[k];
        }
        if (def.icons) {
            for(const k in def.icons)if (!mergedIcons[k]) mergedIcons[k] = def.icons[k];
        }
        for (const e of (0, $gvbDt.declaredEntitiesFromSpec)(def))declaredEntities.add(e);
        combinedSource += '\n' + p.source;
    }
    // Shared root-state seed — every page mounts under ONE app root, so seed the
    // UNION of the workspace keys any page references (see _seedFromWorkspaceRoot),
    // onto the app-shell's state (= the iframe root state all pages read via
    // `s.root.<key>`). Fetch `as:` targets from EVERY page pre-declare alongside
    // (same absent-key tracking gap as the single-page path — see
    // _pageStateSeed); real seeds win over its defaults on collision.
    const { seed: seed, seeded: seeded, missing: missing } = $019e1e3f0a85c670$var$_seedFromWorkspaceRoot(combinedSource, wsRoot);
    const seedState = {
        ...(0, $7qVzJ.pageStateSeed)(combinedSource),
        ...seed
    };
    const nav = (0, $lG24I.buildNav)(pages);
    // The shell embeds the parsed page defs as hide-gated children and switches on
    // root `_appRoute` (state-based nav — the framework URL router doesn't fire
    // through this embed path; see multiPageApp.js). The seed rides on the shell's
    // root state so every page's `s.root.<key>` reads resolve.
    const appShell = (0, $lG24I.buildAppShell)({
        name: args.name,
        nav: nav,
        pageDefs: pageDefs,
        seedState: seedState,
        appLabel: wsRoot.call('polyglot', 'workspace.apps.nameFallback')
    });
    const bridge = (0, $gvbDt.buildExtensionDataBridge)([
        ...declaredEntities
    ]);
    const isolatedDesignSystem = (0, $6jWcN.extensionDesignSystemSource)();
    const data = {
        icons: mergedIcons,
        // Scoped data adapter — the ONLY data channel the app iframe gets.
        fetch: bridge.fetch,
        globalTheme: args.theme && String(args.theme) || $019e1e3f0a85c670$var$_activeGlobalTheme(ctx.designSystem)
    };
    const contextOverrides = {
        designSystem: isolatedDesignSystem,
        components: mergedComponents,
        functions: mergedFunctions
    };
    try {
        const result = await $019e1e3f0a85c670$var$shellCreateIframeApp(iframeNode, data, appShell, {
            path: '/',
            resetDocument: true,
            contextOverrides: contextOverrides
        });
        if (result) $019e1e3f0a85c670$var$shellInjectSprites(iframeNode.contentDocument, isolatedDesignSystem);
        return result ? {
            ok: true,
            rendered: true,
            routes: pages.map((p)=>p.route),
            entities: bridge.allowed,
            support: bridge.support,
            seededKeys: seeded,
            missingKeys: missing
        } : {
            ok: false,
            error: 'createIframeApp returned null'
        };
    } catch (e) {
        return {
            ok: false,
            error: 'render: ' + (e && e.message || String(e))
        };
    }
}
async function $019e1e3f0a85c670$export$81eb6ebceb4f41a9(root, _attempt = 0) {
    if (!root || typeof root.update !== 'function') return;
    try {
        const ai = (0, $7iFOV.shellGetAiService)();
        const wsId = (0, $9ZTVI.activeWorkspaceId)(root);
        // On mount the shell may still be wiring the SDK / resolving the active
        // workspace from the governance JWT claims. Without BOTH, listExtensions
        // comes back empty and the sidebar looks permanently appless (created
        // extensions silently missing). Retry briefly until both are ready rather
        // than settling on an empty list. ~12 × 400ms ≈ 5s before giving up.
        if (!ai || typeof ai.listExtensions !== 'function' || !wsId) {
            if (_attempt < 12) {
                setTimeout(()=>{
                    $019e1e3f0a85c670$export$81eb6ebceb4f41a9(root, _attempt + 1);
                }, 400);
                return;
            }
            root.update({
                _userApps: []
            });
            return;
        }
        if (typeof ai.updateContext === 'function') ai.updateContext({
            activeWorkspaceId: wsId
        });
        const exts = await ai.listExtensions({
            workspaceId: wsId
        });
        const arr = Array.isArray(exts) ? exts : [];
        // The apps rail is a page sidebar (pages/add-app.js): it shows unless the
        // person hid it for the page, so the list is all this sets.
        root.update({
            _userApps: arr
        });
    } catch (err) {
        console.warn('[add-app] loadAddAppExtensions failed', err);
        // A transient failure (e.g. token not primed yet) — retry before settling.
        if (_attempt < 12) {
            setTimeout(()=>{
                $019e1e3f0a85c670$export$81eb6ebceb4f41a9(root, _attempt + 1);
            }, 400);
            return;
        }
        root.update({
            _userApps: []
        });
    }
}
async function $019e1e3f0a85c670$export$1d5afaa8f1a16c00(ext) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || !ext || !ext.id) return;
    // Stamp the id we're hydrating BEFORE any async work starts — a plain root
    // property, not root.update (bookkeeping, not reactive UI state; same
    // convention as root._slotResolve/_slotOnClose in pages/main.js). Lets
    // hydrateAddAppThread (below) and the URL-sync reactor in pages/add-app.js
    // tell "already hydrated this id" apart from "a bare _addAppProjectId write
    // that still needs hydrating" — without it, a deep-link/Edit-menu arrival
    // that lands here would redundantly re-poll + re-select the same extension.
    root.__addAppHydratedThreadId = String(ext.id);
    // `_addAppSwitching` drives a LOADING state (skeleton) in both panes for the
    // duration of the switch — instead of flashing the empty "renders here"
    // placeholder + empty chat while the thread + source load. Cleared when the
    // render settles (AppRender host callback) or immediately here when the
    // selected extension has no source to render. Reset _addAppRendered so the
    // stale previous frame doesn't linger. _addAppScope follows the extension's
    // OWN scope so a deep-linked/Edit-menu SHARED extension lands with the
    // Shared tab active (and itself visible in that filtered sidebar list)
    // instead of silently sitting under a tab that filters it out.
    root.update({
        _addAppProjectId: String(ext.id),
        _addAppScope: ext.scope || 'private',
        _addAppSwitching: true,
        _ax_chatMessages: [],
        _ax_activeSessionId: null,
        _addAppRendered: false
    });
    // Load the extension's project-scoped conversation list into _ax_sessions.
    try {
        await el.call('hydrateServerSessions', 'addapp');
    } catch (_) {}
    // Open the most-recent thread — load its messages into the _ax_ buffer.
    try {
        const sess = root._ax_sessions || {};
        const top = Object.values(sess).filter((v)=>v && typeof v === 'object').sort((a, b)=>(b.ts || 0) - (a.ts || 0))[0];
        const ai = (0, $7iFOV.shellGetAiService)();
        if (top && top.id && ai && typeof ai.getConversation === 'function') {
            const data = await ai.getConversation(top.id, {
                projectId: String(ext.id)
            });
            // The same reader a reload uses (_simone/sessions.js restoreActiveThread):
            // a saved tool call folds into its NAMED timeline row with its result —
            // the bare per-message rows this used to build turned every saved
            // `role: 'tool'` result into a step read out as "Tool", fourteen times
            // over (sam, round 1b) — machine trailers and the builder's own notes
            // stay out of the bubbles, and a turn the server refused for credits
            // reads as the shell's own sentence (functions/creditsRefusal.js).
            const rows = el.call('_toChatMessages', data && data.messages || []) || [];
            const worded = el.call('creditsRefusalRows', rows, root);
            const msgs = Array.isArray(worded) ? worded : rows;
            root.update({
                _ax_chatMessages: msgs,
                _ax_activeSessionId: top.id
            });
        }
    } catch (_) {
    /* fresh / empty thread */ }
    // Re-render the selected app in the build pane. Multi-page apps (create_app)
    // re-render via renderMultiPageApp with their persisted pages; single-page
    // extensions via injectPageInApp with their source.
    let willRender = false;
    try {
        const host = typeof window !== 'undefined' && window.__addAppHost;
        if (ext.appKind === 'multipage' && Array.isArray(ext.pages) && ext.pages.length && host) {
            willRender = true;
            window.__addAppHost.call('renderMultiPageApp', {
                name: ext.name,
                pages: ext.pages,
                theme: ext.theme || null
            });
        } else if (ext.source && host) {
            willRender = true;
            window.__addAppHost.call('injectPageInApp', {
                name: ext.name,
                source: ext.source
            });
        }
    } catch (err) {
        willRender = false;
        console.warn('[add-app] render selected extension failed', err);
    }
    // Nothing will render (no source / no host) → settle the loading state now;
    // otherwise the AppRender host callback clears it when the frame mounts.
    if (!willRender) root.update({
        _addAppSwitching: false
    });
}
function $019e1e3f0a85c670$export$1baf68ec7d4b98f3(root) {
    if (typeof window === 'undefined' || !window.__addAppOpenId) return;
    const self = this;
    let attempt = 0;
    const tryOpen = ()=>{
        const id = window.__addAppOpenId;
        if (!id) return;
        const ext = (root && root._userApps || []).find((a)=>String(a.id) === String(id));
        if (ext) {
            window.__addAppOpenId = null;
            try {
                self.call('selectAddAppExtension', ext);
            } catch (_) {
            /* best-effort */ }
            return;
        }
        attempt += 1;
        if (attempt < 25) setTimeout(tryOpen, 300);
        else window.__addAppOpenId = null // give up — the app isn't in this list
        ;
    };
    tryOpen();
}
function $019e1e3f0a85c670$export$5a82f96512292191(root, opts) {
    if (!root) return;
    const self = this;
    const useUrl = !(opts && opts.url === false);
    let attempt = 0;
    const tryHydrate = ()=>{
        const fromUrl = useUrl && typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('thread') : null;
        const wanted = root._addAppProjectId && String(root._addAppProjectId) || fromUrl;
        if (!wanted || root.__addAppHydratedThreadId === wanted) return;
        const ext = (root._userApps || []).find((a)=>a && String(a.id) === wanted);
        if (ext) {
            try {
                self.call('selectAddAppExtension', ext);
            } catch (err) {
                console.warn('[add-app] hydrateAddAppThread select failed', err);
            }
            return;
        }
        attempt += 1;
        if (attempt < 25) {
            setTimeout(tryHydrate, 300);
            return;
        }
        // Give up — only clear if nothing else (a click elsewhere during the
        // poll) already moved root on to a different id.
        if (String(root._addAppProjectId || '') === wanted && root.update) root.update({
            _addAppProjectId: null
        });
        if (useUrl && typeof window !== 'undefined') try {
            const url = new URL(window.location.href);
            if (url.searchParams.get('thread') === wanted) {
                url.searchParams.delete('thread');
                window.history.replaceState(null, '', url.toString());
            }
        } catch (err) {
            console.warn('[add-app] hydrateAddAppThread url clear failed', err);
        }
    };
    tryHydrate();
}
$parcel$exportWildcard(module.exports, $aGIjc);
$parcel$exportWildcard(module.exports, $k3hwI);
$parcel$exportWildcard(module.exports, $cGe9G);
$parcel$exportWildcard(module.exports, $17MWq);
$parcel$exportWildcard(module.exports, $qJ3f5);
$parcel$exportWildcard(module.exports, $2aopH);
$parcel$exportWildcard(module.exports, $bnEwy);
$parcel$exportWildcard(module.exports, $25fky);
$parcel$exportWildcard(module.exports, $4u35b);
$parcel$exportWildcard(module.exports, $dp7M8);
$parcel$exportWildcard(module.exports, $ik7KJ);
$parcel$exportWildcard(module.exports, $14aeZ);
$parcel$exportWildcard(module.exports, $5Vf2y);
$parcel$exportWildcard(module.exports, $azpxa);
$parcel$exportWildcard(module.exports, $aO3dH);
$parcel$exportWildcard(module.exports, $oolN6);
$parcel$exportWildcard(module.exports, $6hzqH);
$parcel$exportWildcard(module.exports, $11oY6);
$parcel$exportWildcard(module.exports, $fAXoF);
$parcel$exportWildcard(module.exports, $kKK1U);
$parcel$exportWildcard(module.exports, $2Ew84);
$parcel$exportWildcard(module.exports, $5nFIo);
$parcel$exportWildcard(module.exports, $6u4gB);
$parcel$exportWildcard(module.exports, $iiC3b);
$parcel$exportWildcard(module.exports, $pSCVI);
$parcel$exportWildcard(module.exports, $l6XrB);
$parcel$exportWildcard(module.exports, $l3wtL);
$parcel$exportWildcard(module.exports, $2nxDN);
$parcel$exportWildcard(module.exports, $exs7L);
$parcel$exportWildcard(module.exports, $9nZUz);
$parcel$exportWildcard(module.exports, $6lzOV);
$parcel$exportWildcard(module.exports, $f0QVc);
$parcel$exportWildcard(module.exports, $1JE4a);
$parcel$exportWildcard(module.exports, $11fgE);
$parcel$exportWildcard(module.exports, $hrwvV);
$parcel$exportWildcard(module.exports, $1DBpJ);
$parcel$exportWildcard(module.exports, $1nnHq);
$parcel$exportWildcard(module.exports, $iQSJg);
$parcel$exportWildcard(module.exports, $48wyv);
$parcel$exportWildcard(module.exports, $aJk2q);
$parcel$exportWildcard(module.exports, $j3mi5);
$parcel$exportWildcard(module.exports, $5UN4H);
$parcel$exportWildcard(module.exports, $lY4w0);
$parcel$exportWildcard(module.exports, $F8Fzk);
$parcel$exportWildcard(module.exports, $bopKf);
$parcel$exportWildcard(module.exports, $e1ZLm);
$parcel$exportWildcard(module.exports, $9x78k);
$parcel$exportWildcard(module.exports, $k99Sk);
$parcel$exportWildcard(module.exports, $3aYah);
$parcel$exportWildcard(module.exports, $dVAG8);
$parcel$exportWildcard(module.exports, $lLLtZ);
$parcel$exportWildcard(module.exports, $8BLCC);
$parcel$exportWildcard(module.exports, $11u4Q);
$parcel$exportWildcard(module.exports, $6yYb9);
$parcel$exportWildcard(module.exports, $kpQ55);
$parcel$exportWildcard(module.exports, $eOUFv);
$parcel$exportWildcard(module.exports, $5ML7q);
$parcel$exportWildcard(module.exports, $fRtNs);
$parcel$exportWildcard(module.exports, $7nvlv);
$parcel$exportWildcard(module.exports, $1OhIx);
$parcel$exportWildcard(module.exports, $fJThD);
$parcel$exportWildcard(module.exports, $fxEFw);
$parcel$exportWildcard(module.exports, $24hpk);
$parcel$exportWildcard(module.exports, $b6fDZ);
$parcel$exportWildcard(module.exports, $jfwUK);
$parcel$exportWildcard(module.exports, $4qZU8);
$parcel$exportWildcard(module.exports, $87igY);
$parcel$exportWildcard(module.exports, $eKWOV);
$parcel$exportWildcard(module.exports, $79OEu);
$parcel$exportWildcard(module.exports, $hv8sj);
$parcel$exportWildcard(module.exports, $3lK1C);
$parcel$exportWildcard(module.exports, $L8D7m);
$parcel$exportWildcard(module.exports, $D8RKl);
$parcel$exportWildcard(module.exports, $9cDO9);
$parcel$exportWildcard(module.exports, $k0i6b);
$parcel$exportWildcard(module.exports, $5MRhO);
$parcel$exportWildcard(module.exports, $j97dQ);
$parcel$exportWildcard(module.exports, $3GI9o);
$parcel$exportWildcard(module.exports, $cY3NJ);
$parcel$exportWildcard(module.exports, $cZH4f);
$parcel$exportWildcard(module.exports, $7uQG1);
$parcel$exportWildcard(module.exports, $02uje);
$parcel$exportWildcard(module.exports, $a8wem);
$parcel$exportWildcard(module.exports, $bBsgH);
$parcel$exportWildcard(module.exports, $in9xh);
$parcel$exportWildcard(module.exports, $l7TnK);
$parcel$exportWildcard(module.exports, $41OOS);
$parcel$exportWildcard(module.exports, $a54EB);
$parcel$exportWildcard(module.exports, $ljZYp);
$parcel$exportWildcard(module.exports, $PjK35);
$parcel$exportWildcard(module.exports, $bBP8k);
$parcel$exportWildcard(module.exports, $jrMGk);
$parcel$exportWildcard(module.exports, $dHbyA);
$parcel$exportWildcard(module.exports, $h9R4P);
$parcel$exportWildcard(module.exports, $8MHsf);
$parcel$exportWildcard(module.exports, $18lRJ);
$parcel$exportWildcard(module.exports, $2sLUA);
$parcel$exportWildcard(module.exports, $19CFn);
$parcel$exportWildcard(module.exports, $6rBuB);
$parcel$exportWildcard(module.exports, $grJbt);
$parcel$exportWildcard(module.exports, $3DPx5);
$parcel$exportWildcard(module.exports, $j2K1B);
$parcel$exportWildcard(module.exports, $arFJU);
$parcel$exportWildcard(module.exports, $42k1m);
$parcel$exportWildcard(module.exports, $kja5T);
$parcel$exportWildcard(module.exports, $exGAm);
$parcel$exportWildcard(module.exports, $jpKCL);
$parcel$exportWildcard(module.exports, $eyLou);
$parcel$exportWildcard(module.exports, $1jEjH);
$parcel$exportWildcard(module.exports, $gv0iu);
$parcel$exportWildcard(module.exports, $B2MdJ);
$parcel$exportWildcard(module.exports, $jbjvY);
$parcel$exportWildcard(module.exports, $gX2iF);
$parcel$exportWildcard(module.exports, $ghE7d);
$parcel$exportWildcard(module.exports, $b72sS);
$parcel$exportWildcard(module.exports, $afTTM);
$parcel$exportWildcard(module.exports, $kosYS);
$parcel$exportWildcard(module.exports, $1fM2q);
$parcel$exportWildcard(module.exports, $jGOZx);
$parcel$exportWildcard(module.exports, $7BIh5);
$parcel$exportWildcard(module.exports, $gwiue);
$parcel$exportWildcard(module.exports, $4iFeZ);
$parcel$exportWildcard(module.exports, $8amd9);
$parcel$exportWildcard(module.exports, $i9IdK);
$parcel$exportWildcard(module.exports, $5AXvC);
$parcel$exportWildcard(module.exports, $lOgtZ);
$parcel$exportWildcard(module.exports, $ai0fh);
$parcel$exportWildcard(module.exports, $4nRwn);
$parcel$exportWildcard(module.exports, $hHHSG);
$parcel$exportWildcard(module.exports, $7vPqO);
$parcel$exportWildcard(module.exports, $gtYd7);
$parcel$exportWildcard(module.exports, $2NBeW);
$parcel$exportWildcard(module.exports, $8KqSV);
$parcel$exportWildcard(module.exports, $30rQH);
$parcel$exportWildcard(module.exports, $jGgpa);
$parcel$exportWildcard(module.exports, $ioeg9);
$parcel$exportWildcard(module.exports, $fXdfQ);
$parcel$exportWildcard(module.exports, $g2MQt);
$parcel$exportWildcard(module.exports, $j9FGY);
$parcel$exportWildcard(module.exports, $4lCqq);
$parcel$exportWildcard(module.exports, $2VLCm);
$parcel$exportWildcard(module.exports, $bkUUf);
$parcel$exportWildcard(module.exports, $gDIGr);
$parcel$exportWildcard(module.exports, $iEkVj);
$parcel$exportWildcard(module.exports, $khsuc);
$parcel$exportWildcard(module.exports, $kZu9w);
$parcel$exportWildcard(module.exports, $diDcA);
$parcel$exportWildcard(module.exports, $a1COj);
$parcel$exportWildcard(module.exports, $hSLcD);
$parcel$exportWildcard(module.exports, $iJL0D);
$parcel$exportWildcard(module.exports, $eE7tm);
$parcel$exportWildcard(module.exports, $dKgR9);
$parcel$exportWildcard(module.exports, $dL10z);

});
parcelRegister("hROPr", function(module, exports) {

$parcel$export(module.exports, "SEED_DENY_KEYS", () => $d01ed0728d941327$export$3d2c9e9e7850b1a4);
$parcel$export(module.exports, "SEED_DENY_RE", () => $d01ed0728d941327$export$27fa6c3272530be);
$parcel$export(module.exports, "referencedRootKeys", () => $d01ed0728d941327$export$4f536291ec9442a3);
$parcel$export(module.exports, "buildRootStateSeed", () => $d01ed0728d941327$export$a5a92c785aa4919d);
// extensionDataSeed.js — pure live-data seed for AI-drawn answer views saved as
// extensions. Kept dependency-free (no smbls / no iframe / no DOM) so it's unit-
// testable under `node --test` and can't drag browser-only deps into a test run.
//
// WHY THIS EXISTS
// A view Simone DRAWS as a live answer (render_answer_ui) reads its data from the
// workspace root — `s.root.<stateKey>`. In the split pane that resolves because
// the view mounts on the LIVE workspace root. But a SAVED extension renders in an
// ISOLATED iframe (createIframeApp) whose root state starts EMPTY (smbls create.js
// gives a root element with no non-empty `state` a plain `{}`), so every
// `s.root.<key>` read comes back undefined and the saved view renders BLANK.
// That silent-failure is the one gap the isolation model opened for the
// render_answer_ui → "Save as app" bridge.
//
// THE SEED
// renderExtensionInPane (functions/index.js) snapshots the exact root keys the
// source references and seeds them into the iframe page def's `state` before
// mount, so a saved answer view renders with the same data it was drawn against —
// instant, no re-fetch (matches "reuse in-memory workspace data").
//
// SAFETY
//   1. Only keys the source LITERALLY references are seeded (referencedRootKeys).
//   2. Credential / auth-claim / org-identity keys are NEVER seeded (deny sets
//      below) — the scoped data bridge (extensionDataBridge) is the only
//      sanctioned channel for anything beyond referenced display collections.
//   3. Values are DEEP-CLONED so the iframe can never mutate live workspace
//      state by reference.
//
// SEMANTICS
// A snapshot re-taken on every render — re-opening a saved view while its data is
// loaded reflects current data. A referenced-but-not-loaded key is seeded as []
// so the dominant collection idiom (`s.root.<key>.map`/`.length`) renders an
// EMPTY view instead of throwing on undefined — honest degradation, not a blank
// pane. A view meant to ALWAYS show fresh data should inline literal rows or
// declare a `fetch:` surface (both cross the iframe boundary intact).
// Root keys never seeded into an extension iframe — credentials, auth claims,
// and org/workspace identity structures.
const $d01ed0728d941327$export$3d2c9e9e7850b1a4 = new Set([
    'jwtClaims',
    'orgs',
    'org',
    'workspaces',
    'workspace',
    'userPrefs',
    'roles',
    'orgMembersByOrgId'
]);
const $d01ed0728d941327$export$27fa6c3272530be = /token|secret|jwt|claim|credential|password|apikey|auth|session/i;
const $d01ed0728d941327$var$isDenied = (key)=>$d01ed0728d941327$export$3d2c9e9e7850b1a4.has(key) || $d01ed0728d941327$export$27fa6c3272530be.test(key);
const $d01ed0728d941327$export$4f536291ec9442a3 = (source)=>{
    const text = String(source || '');
    const keys = new Set();
    const dot = /\.root(?:\?\.|\.)([A-Za-z_$][\w$]*)/g;
    const bracket = /\.root(?:\?\.)?\s*\[\s*['"]([A-Za-z_$][\w$]*)['"]\s*\]/g;
    let m;
    while(m = dot.exec(text))keys.add(m[1]);
    while(m = bracket.exec(text))keys.add(m[1]);
    return keys;
};
const $d01ed0728d941327$var$defaultClone = (v)=>{
    try {
        if (typeof structuredClone === 'function') return structuredClone(v);
    } catch (_) {
    /* fall through */ }
    try {
        return JSON.parse(JSON.stringify(v));
    } catch (_) {
        return v;
    }
};
const $d01ed0728d941327$export$a5a92c785aa4919d = (source, rootState, { clone: clone = $d01ed0728d941327$var$defaultClone } = {})=>{
    const refs = $d01ed0728d941327$export$4f536291ec9442a3(source);
    const seed = {};
    const seeded = [];
    const missing = [];
    for (const key of refs){
        if ($d01ed0728d941327$var$isDenied(key)) continue;
        const live = rootState ? rootState[key] : undefined;
        if (typeof live === 'function') continue;
        if (live === undefined || live === null) {
            seed[key] = [];
            missing.push(key);
            continue;
        }
        seed[key] = clone(live);
        seeded.push(key);
    }
    return {
        seed: seed,
        seeded: seeded,
        missing: missing
    };
};

});

parcelRegister("jw8v7", function(module, exports) {

$parcel$export(module.exports, "setLastRenderedExtension", () => $e357999bbc9d73ee$export$ab27b353a9c4bb34);
$parcel$export(module.exports, "getLastRenderedExtension", () => $e357999bbc9d73ee$export$2dc3b03640aee167);
$parcel$export(module.exports, "saveExtension", () => $e357999bbc9d73ee$export$8d094c2443b2a0e4);
$parcel$export(module.exports, "saveAnswerViewAsApp", () => $e357999bbc9d73ee$export$6917240a0c7c461a);
$parcel$export(module.exports, "requestShareExtension", () => $e357999bbc9d73ee$export$551f6badb8c97a5a);
$parcel$export(module.exports, "confirmShareExtension", () => $e357999bbc9d73ee$export$be293f154a1ae9a1);
$parcel$export(module.exports, "addAppSavePress", () => $e357999bbc9d73ee$export$e600bfd29caeeff8);
$parcel$export(module.exports, "addAppSaveStatus", () => $e357999bbc9d73ee$export$bb9f0ebe79665149);
// extensionSaveShare.js — Save / Share-to-members actions for the /add-app
// extension builder (Phase 1 frontend slice, per Nika "save as extension and
// reuse/share to internal members").
//
// SAFETY GATE (per Nika "make it safe and secure"): SHARING an extension makes
// it visible + installable to EVERY workspace member, so it must be an explicit,
// human-confirmed action — never implicit. saveExtension (private) needs no
// confirm; shareExtension flips scope to 'shared' ONLY after the user confirms.
//
// Extensions are persisted through the AiService (sdk.ai.createExtension /
// updateExtension), the same store loadAddAppExtensions reads. We never write a
// shared extension without going through confirmShareExtension first.
// Bare shared-library import, not a deep aiService.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0). Deferred-call
// wrapper, not a module-scope destructure — see app.js's circular-init note.

var $7iFOV = parcelRequire("7iFOV");

var $9ZTVI = parcelRequire("9ZTVI");
const $e357999bbc9d73ee$export$ab27b353a9c4bb34 = (info)=>{
    if (typeof window === 'undefined') return;
    window.__addAppLastRender = info && info.source ? {
        name: info.name || 'Extension',
        source: info.source,
        entities: info.entities || []
    } : null;
};
const $e357999bbc9d73ee$export$2dc3b03640aee167 = ()=>typeof window !== 'undefined' && window.__addAppLastRender || null;
// Resolve the payload to persist: prefer the explicitly-passed extension, else
// the last-rendered one. Returns null when there's nothing to save.
const $e357999bbc9d73ee$var$_resolvePayload = (ext)=>{
    const e = ext && ext.source ? ext : $e357999bbc9d73ee$export$2dc3b03640aee167();
    if (!e || !e.source) return null;
    return {
        name: e.name || 'Extension',
        source: e.source,
        entities: e.entities || []
    };
};
// The app the builder is bound to — a Project the build itself already stored
// (create_app / create_extension persist on every build) — or null. Its name is
// the one Your apps lists. A built MULTI-PAGE app leaves no single-page payload
// (buildInlineMultiPageDef clears it: a multi-page app has no one source), and
// neither does a sandboxed render, so a built app is known by this binding,
// not by the last single-page render (persona round 5, lina: Save on a built
// app said "Nothing to save — build an app first").
const $e357999bbc9d73ee$var$_boundApp = (root)=>{
    const id = root && root._addAppProjectId ? String(root._addAppProjectId) : '';
    if (!id) return null;
    const apps = Array.isArray(root._userApps) ? root._userApps : [];
    const row = apps.find((a)=>a && String(a.id) === id);
    const name = row && typeof row.name === 'string' ? row.name.trim() : '';
    return {
        id: id,
        name: name
    };
};
// Persist the current extension at the given scope. `scope` is 'private' |
// 'shared'. When the active builder is already bound to a Project
// (root._addAppProjectId), UPDATE it; otherwise CREATE. Returns
// { ok, id, scope } / { ok:false, error }.
const $e357999bbc9d73ee$var$_persist = async (root, scope, ext)=>{
    const ai = (0, $7iFOV.shellGetAiService)();
    if (!ai || typeof ai.createExtension !== 'function' && typeof ai.updateExtension !== 'function') return {
        ok: false,
        error: 'workspace.addApp.saveError.storeUnavailable'
    };
    const payload = $e357999bbc9d73ee$var$_resolvePayload(ext);
    const bound = $e357999bbc9d73ee$var$_boundApp(root);
    if (!payload && !bound) return {
        ok: false,
        error: 'workspace.addApp.saveError.nothingToSave'
    };
    const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root);
    if (!workspaceId) return {
        ok: false,
        error: 'workspace.addApp.saveError.noWorkspace'
    };
    // A built app with no single-page payload (a multi-page app, a sandboxed
    // render): its pages are stored already, so Save / Share set its scope
    // only — the server's update takes a scope without a source and keeps the
    // stored pages (persona round 5, lina: "Nothing to save — build an app
    // first" over a built app).
    //
    // A save never moves an app OUT of the workspace (persona round 5, aiko:
    // Save on her stored app showed nothing): a bound app that is shared
    // already stays shared, nothing is written, and the line says where it is
    // (`kept`; saveExtension picks workspace.addApp.save.savedShared). A
    // private app's Save writes its scope; a Share moves only its place.
    if (!payload) {
        const row = Array.isArray(root && root._userApps) && root._userApps.find((a)=>a && String(a.id) === bound.id) || null;
        const place = (row && row.scope || root && root._addAppScope) === 'shared' ? 'shared' : 'private';
        if (scope !== 'shared' && place === 'shared') return {
            ok: true,
            id: bound.id,
            scope: place,
            name: bound.name,
            kept: true
        };
        if (typeof ai.updateExtension !== 'function') return {
            ok: false,
            error: 'workspace.addApp.saveError.storeUnavailable'
        };
        try {
            await ai.updateExtension(bound.id, {
                workspaceId: workspaceId,
                scope: scope
            });
            if (root && root.update) root.update({
                _addAppScope: scope
            });
            return {
                ok: true,
                id: bound.id,
                scope: scope,
                name: bound.name
            };
        } catch (err) {
            return {
                ok: false,
                error: err && err.message || String(err)
            };
        }
    }
    const existingId = root && root._addAppProjectId ? String(root._addAppProjectId) : null;
    const body = {
        workspaceId: workspaceId,
        name: payload.name,
        source: payload.source,
        entities: payload.entities,
        scope: scope
    };
    try {
        let res;
        if (existingId && typeof ai.updateExtension === 'function') res = await ai.updateExtension(existingId, body);
        else if (typeof ai.createExtension === 'function') res = await ai.createExtension(body);
        else // No create method but we have an id-less extension — can't persist.
        return {
            ok: false,
            error: 'workspace.addApp.saveError.cannotCreate'
        };
        const id = res && (res.id || res._id) || existingId || null;
        // Re-bind the builder to the (possibly new) Project + refresh the sidebar so
        // the saved extension appears under the right Visibility scope. A NEW id
        // is a bind, not a switch: the chat holds the conversation that built it,
        // so it is marked hydrated first and hydrateAddAppThread leaves it on
        // screen (simoneAiTransport injectPageInApp has the same mark).
        if (root && root.update) {
            if (id && String(id) !== String(existingId || '')) root.__addAppHydratedThreadId = String(id);
            root.update({
                _addAppProjectId: id ? String(id) : root._addAppProjectId,
                _addAppScope: scope
            });
        }
        // The (possibly large) DOMQL source now lives in the persisted extension —
        // drop the transient copy off `window` so it isn't held for the page's life.
        $e357999bbc9d73ee$export$ab27b353a9c4bb34(null);
        return {
            ok: true,
            id: id,
            scope: scope,
            name: payload.name
        };
    } catch (err) {
        return {
            ok: false,
            error: err && err.message || String(err)
        };
    }
};
// One-shot auto-dismiss for the transient save/share toast. Armed when the
// notice is SET (below) — a single setTimeout, not an always-on poll — and
// re-armed on each new notice so the latest message gets the full dwell. A
// line that carries the way to open the app (functions/addAppSaved.js — BLD-28:
// a 3.5 s toast was missed, "no message shows") stays 10 s; its link leaves
// with it.
let $e357999bbc9d73ee$var$_noticeDismissTimer = null;
const $e357999bbc9d73ee$var$_armNoticeDismiss = (root, message)=>{
    if (typeof window === 'undefined' || !root || !root.update) return;
    if ($e357999bbc9d73ee$var$_noticeDismissTimer) clearTimeout($e357999bbc9d73ee$var$_noticeDismissTimer);
    const link = root._addAppSaveLink;
    const linked = !!(link && link.notice === message);
    $e357999bbc9d73ee$var$_noticeDismissTimer = window.setTimeout(()=>{
        $e357999bbc9d73ee$var$_noticeDismissTimer = null;
        // Only clear if this same message is still showing (a newer notice owns it).
        if (root._addAppSaveNotice === message) root.update({
            _addAppSaveNotice: null,
            _addAppSaveLink: null
        });
    }, linked ? 10000 : 3500);
};
// Shared post-persist UI hand-off: toast the outcome (+ any extra state patch on
// success), arm the auto-dismiss, and refresh the apps sidebar. Used by both
// save + confirm-share so the notice/refresh flow lives in one place.
const $e357999bbc9d73ee$var$_notifyPersistResult = (thisEl, root, res, successKey, extra = {})=>{
    if (!root || !root.update) return;
    const message = res.ok ? (0, $7iFOV.shellSay)(thisEl, successKey) : (0, $7iFOV.shellSay)(thisEl, 'workspace.addApp.save.failed').replace('{reason}', ()=>{
        // a refusal of our own is a bundle key; the server's is its own text,
        // shown as it is (never looked up as a key)
        const reason = String(res.error || '');
        return /^workspace\.[A-Za-z0-9.]+$/.test(reason) ? (0, $7iFOV.shellSay)(thisEl, reason) : reason;
    });
    if (res.ok && Object.keys(extra).length) root.update(extra);
    const app = res.ok && res.id ? {
        id: res.id,
        name: res.name,
        scope: res.scope
    } : null;
    if (app) // the app stands in Your apps now, under its own place (BLD-28)
    try {
        thisEl.call('addAppSavedRow', root, app);
    } catch (_) {}
    let linked = false;
    try {
        linked = !!thisEl.call('addAppSavedNotice', root, message, app);
    } catch (_) {
        linked = false;
    }
    if (!linked && root._addAppSaveNotice !== message) root.update({
        _addAppSaveNotice: message,
        _addAppSaveLink: null
    });
    $e357999bbc9d73ee$var$_armNoticeDismiss(root, message);
    // A refusal also takes the kit's error toast (the shell's openNotification,
    // the one every Save in the workspace raises on a failure): the builder's
    // line leaves in 3.5 s, and a failed save must say why where the person
    // looks (W16b live check: two Save presses, no visible answer at all).
    if (!res.ok) try {
        thisEl.call('openNotification', {
            title: message,
            type: 'error'
        });
    } catch (_) {
    /* the builder's line above still says it */ }
    try {
        thisEl.call('loadAddAppExtensions', root);
    } catch (_) {}
};
async function $e357999bbc9d73ee$export$8d094c2443b2a0e4(ext) {
    const root = this && this.state && (this.state.root || this.state) || null;
    const res = await $e357999bbc9d73ee$var$_persist(root, 'private', ext);
    // a stored app that stays shared says where it is, not "private apps"
    const key = res && res.kept && res.scope === 'shared' ? 'workspace.addApp.save.savedShared' : 'workspace.addApp.save.savedPrivate';
    $e357999bbc9d73ee$var$_notifyPersistResult(this, root, res, key);
    return res;
}
async function $e357999bbc9d73ee$export$6917240a0c7c461a(route) {
    const root = this && this.state && (this.state.root || this.state) || null;
    if (!root || !root.update) return {
        ok: false,
        error: 'no_root'
    };
    const r = String(route || root._canvasSlot || '');
    const def = root._aiAnswerPages && root._aiAnswerPages[r] || null;
    const source = def && def.metadata && def.metadata.__source;
    const name = def && def.metadata && def.metadata.title || 'Saved view';
    if (!source) {
        const nothingHere = (0, $7iFOV.shellSay)(this, 'workspace.addApp.save.nothingHere');
        root.update({
            _addAppSaveNotice: nothingHere
        });
        $e357999bbc9d73ee$var$_armNoticeDismiss(root, nothingHere);
        return {
            ok: false,
            error: 'no_source'
        };
    }
    const ai = (0, $7iFOV.shellGetAiService)();
    const workspaceId = (0, $9ZTVI.activeWorkspaceId)(root);
    if (!ai || typeof ai.createExtension !== 'function' || !workspaceId) {
        const unavailable = (0, $7iFOV.shellSay)(this, 'workspace.addApp.save.failed').replace('{reason}', ()=>(0, $7iFOV.shellSay)(this, 'workspace.addApp.saveError.storeUnavailable'));
        root.update({
            _addAppSaveNotice: unavailable
        });
        $e357999bbc9d73ee$var$_armNoticeDismiss(root, unavailable);
        return {
            ok: false,
            error: 'store_unavailable'
        };
    }
    try {
        const res = await ai.createExtension({
            workspaceId: workspaceId,
            name: name,
            source: source,
            scope: 'private'
        });
        const id = res && (res.projectId || res.id || res._id) || null;
        // Queue the render + navigate to /add-app. Cross-page nav destroys and
        // re-creates the addApp page, so AppRender.onCreate re-fires and flushes this
        // queue (it polls the iframe to readiness before rendering — the flush used
        // to fire against an unconnected contentWindow and silently no-op, which is
        // why a saved app only landed in the sidebar). Bind the builder to the new
        // Project + close the transient answer view.
        if (typeof window !== 'undefined') window.__addAppPendingRender = {
            name: name,
            source: source,
            entities: []
        };
        const savedAsApp = (0, $7iFOV.shellSay)(this, 'workspace.addApp.save.savedAsApp').replace('{name}', ()=>name);
        root.update({
            _addAppProjectId: id ? String(id) : null,
            _addAppRendered: false,
            _canvasSlot: null,
            _canvasSlotSecond: null,
            _slotFullscreen: null,
            _addAppSaveNotice: savedAsApp,
            _addAppSaveLink: null
        });
        // the new app stands in Your apps now, and the line opens it (BLD-28)
        if (id) try {
            this.call('addAppSavedRow', root, {
                id: id,
                name: name,
                scope: 'private'
            });
            this.call('addAppSavedNotice', root, savedAsApp, {
                id: id,
                name: name,
                scope: 'private'
            });
        } catch (_) {}
        $e357999bbc9d73ee$var$_armNoticeDismiss(root, savedAsApp);
        try {
            this.call('openAppPage', '/add-app');
        } catch (_) {}
        try {
            this.call('loadAddAppExtensions', root);
        } catch (_) {}
        return {
            ok: true,
            id: id
        };
    } catch (err) {
        const msg = err && err.message || String(err);
        const failedNote = (0, $7iFOV.shellSay)(this, 'workspace.addApp.save.failed').replace('{reason}', ()=>msg);
        root.update({
            _addAppSaveNotice: failedNote
        });
        $e357999bbc9d73ee$var$_armNoticeDismiss(root, failedNote);
        return {
            ok: false,
            error: msg
        };
    }
}
function $e357999bbc9d73ee$export$551f6badb8c97a5a() {
    const root = this && this.state && (this.state.root || this.state) || null;
    if (!root || !root.update) return {
        ok: false
    };
    const payload = $e357999bbc9d73ee$var$_resolvePayload();
    const bound = payload ? null : $e357999bbc9d73ee$var$_boundApp(root);
    if (!payload && !bound) {
        const buildFirst = (0, $7iFOV.shellSay)(this, 'workspace.addApp.save.buildFirst');
        root.update({
            _addAppSaveNotice: buildFirst
        });
        $e357999bbc9d73ee$var$_armNoticeDismiss(root, buildFirst);
        return {
            ok: false,
            error: 'nothing_to_share'
        };
    }
    // a built app known by its binding: the name Your apps lists, else the
    // share confirm's own words for an app without one ("This app")
    const name = payload ? payload.name : bound.name || (0, $7iFOV.shellSay)(this, 'workspace.addApp.share.thisExtension');
    const el = this;
    el.call('confirmDialog', {
        title: (0, $7iFOV.shellSay)(el, 'workspace.addApp.share.title'),
        message: (0, $7iFOV.shellSay)(el, 'workspace.addApp.share.body').replace('{name}', ()=>name),
        cancelText: (0, $7iFOV.shellSay)(el, 'workspace.addApp.share.keepPrivate'),
        confirmText: (0, $7iFOV.shellSay)(el, 'workspace.addApp.share.confirm'),
        // the title and the button say "share": no glyph beside the dialog's Close
        icon: null,
        onConfirm: ()=>el.call('confirmShareExtension')
    });
    return {
        ok: true,
        name: name
    };
}
async function $e357999bbc9d73ee$export$be293f154a1ae9a1(ext) {
    const root = this && this.state && (this.state.root || this.state) || null;
    const res = await $e357999bbc9d73ee$var$_persist(root, 'shared', ext);
    // toast + sidebar refresh via the shared helper (success message; failures
    // fall back to the helper's "Save failed")
    $e357999bbc9d73ee$var$_notifyPersistResult(this, root, res, 'workspace.addApp.save.sharedAll');
    return res;
}
async function $e357999bbc9d73ee$export$e600bfd29caeeff8() {
    const el = this;
    const s = el && el.state;
    if (!s || typeof s.update !== 'function' || s.saving) return null;
    s.update({
        saving: true,
        savedId: ''
    });
    let res = null;
    try {
        res = await el.call('saveExtension');
    } catch (_) {
        res = null;
    }
    s.update({
        saving: false,
        savedId: res && res.ok && res.id ? String(res.id) : ''
    });
    return res;
}
function $e357999bbc9d73ee$export$bb9f0ebe79665149(s) {
    const saving = !!(s && s.saving);
    const savedId = String(s && s.savedId || '');
    const bound = String(s && s.root && s.root._addAppProjectId || '');
    if (saving) return 'saving';
    return savedId && savedId === bound ? 'saved' : 'idle';
}

});

parcelRegister("79dxh", function(module, exports) {

$parcel$export(module.exports, "generatedNotifyHref", () => $5343df9b904b4ecf$export$7a8cae268206c8ab);
// generatedNotifyHref.js — where a BUILT app's notification opens (persona
// round 5, marcus, shot 032: "New open-house lead: Dana Whitfield" arrived in
// his Inbox, and a tap only marked it read).
//
// A built app notifies with a declarative fetch — `{ method: 'insert', from:
// 'notifications', on: 'submit' }` — so the payload is the form's data: a
// title and a body, never an `href`. The server stores `href: payload.href ??
// null`, and the shared rule (notificationHrefOf) opens nothing for a row with
// no href. The app itself is the place the news is about, so a notification
// with no href of its own gets the app's page: the path it was sent from (its
// own `/x/<key>` route once installed), or — in the builder's preview — the
// build thread (`/add-app?thread=<id>`, never a blank builder). An href the app
// set itself is kept; the server still checks it is an in-app path.
//
// Pure: (data, root) → data, never mutated. Called from functions/index.js
// _rewriteFetchDecls, which wraps the decl's `transform`.
const $5343df9b904b4ecf$export$7a8cae268206c8ab = (data, root)=>{
    if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
    if (typeof data.href === 'string' && data.href.trim()) return data;
    const r = root && typeof root === 'object' ? root : {};
    const path = String(r.currentPath || '').split(/[?#]/)[0];
    if (!path || path.charAt(0) !== '/' || path.startsWith('//')) return data;
    const thread = r._addAppProjectId ? String(r._addAppProjectId) : '';
    const href = /\/add-app$/.test(path) && thread ? path + '?thread=' + encodeURIComponent(thread) : path;
    return {
        ...data,
        href: href
    };
};

});

parcelRegister("gFf4Y", function(module, exports) {

$parcel$export(module.exports, "homeContextMenuAllowed", () => $c21c2c1d0c757026$export$816fa6275d9a9abe);
$parcel$export(module.exports, "closeContextMenuOnEscape", () => $c21c2c1d0c757026$export$d828ab43b0b127a);
$parcel$export(module.exports, "closeContextMenuOnRouteChange", () => $c21c2c1d0c757026$export$b218a894899859d6);
$parcel$export(module.exports, "homeContextAction", () => $c21c2c1d0c757026$export$142a1380a75551d);
$parcel$export(module.exports, "focusHomeContextMenu", () => $c21c2c1d0c757026$export$1e5010e2fb47abf7);
$parcel$export(module.exports, "homeWidgetAiTarget", () => $c21c2c1d0c757026$export$ff218d764e4648ea);
$parcel$export(module.exports, "homeWidgetChangeWithAi", () => $c21c2c1d0c757026$export$a7af41eaaba8bf85);
// Home dashboard right-click context menus. The empty-area menu
// (pages/main.js) is [Refresh, Customize dashboard]. The per-widget menu
// (components/HomeWidgetFrame.js) is Refresh, [Change with AI…],
// Add/Change color, [Widget size — touch only], Hide "<title>",
// [Share to workspace / Make personal — an AI-made widget the member may
// edit], Customize dashboard, and LAST [Delete "<title>" — an AI-made widget
// the member may delete] (CRUD standard rule 7: Delete is the last item). No
// menu offers Autolayout now; the dispatcher's `autolayout` /
// `undoAutolayout` branches below remain from it. Both menus open the shared
// house ContextDropdown (`root.contextDropdown`) with
// `actionFn: 'homeContextAction'` — the EXACT shape the account menu + /files
// context menu use (MenuPanel / MenuPanelItem).
//
// The data-heavy operations (refetch every widget's data, hide a specific
// widget gap-free) live on the home page (pages/main.js) where the loaders +
// Gridstack are, and are exposed to this dispatcher through `root._homeOps` — a
// hook bag the page stashes on mount, mirroring how it already stashes
// `el.__homeGrid` / `gridEl.__homeApplyMode` for cross-tree access. `customize`
// needs no page state, so it flips `_homeCustomizeMode` directly (identical to
// shared/functions/accountMenu.js's "Customize dashboard" action).
//
// `this` is the clicked ContextDropdownItem element (el.call binds it), so
// `this.state.root` is the app root — same contract as accountMenuAction /
// chatContextDispatch.
// ── SCOPE + CLOSE (D2 §5, P1) ─────────────────────────────────────────────
//
// MEASURED (D2, staging 1.33.1): with a workspace-module page open in the
// shell PageSlot, a right-click produced the HOME dashboard's widget menu —
// `Refresh · Add color · Hide "Team and agents" · Customize dashboard` — for a
// widget that was not even on screen; Escape did not close it, and it survived
// two page changes sitting over the module's own rail.
//
// Two independent shell defects, and both are fixed here:
//
// 1. THE HOME BOARD ANSWERS WHILE IT IS NOT THE SURFACE. The PageSlot frame is
//    inset (`left/right: X2`, `top: --slot-top`, `bottom: --slot-bottom`) and
//    `PageSlotBackdrop` is `pointerEvents: 'none'` by design, so every pixel
//    around the open pane is click-through to the dashboard behind it. A
//    right-click that misses the pane by a few px lands on a home widget and
//    opens ITS menu — which reads, correctly, as "the module page opened the
//    home menu". While a slot page is open the board is not the surface the
//    user is pointing at, so it must not answer at all.
//
// 2. ESCAPE ONLY WORKS IF FOCUS IS INSIDE THE MENU. The shared ContextDropdown
//    closes on Escape from `Menu.onKeydown`, a DELEGATED handler — smbls'
//    delegate walks the DOM ancestor chain of `event.target`
//    (smbls/packages/element/src/delegate.js installDelegatedEvent), so a
//    keystroke never reaches it unless focus actually moved into the panel.
//    `focusHomeContextMenu` below is that nudge, and it is a bounded poll that
//    can lose (a competing focus write, a menu that never paints). Escape is
//    the universal dismiss for a transient layer; it cannot depend on a race.
//    `closeContextMenuOnEscape` is the document-level backstop, wired on the
//    SHELL ROOT (app.js `onDocumentKeydown`) so it is armed on every route.
//
// A route change closes it too (app.js `onRouteChanged`): a menu is anchored
// to viewport coordinates on a surface that no longer exists.

var $2EI10 = parcelRequire("2EI10");
const $c21c2c1d0c757026$export$816fa6275d9a9abe = function(e, root) {
    const r = root || this?.state?.root;
    if (!r) return false;
    if (r._canvasSlot || r._canvasSlotSecond) return false;
    // Text fields keep the native menu (the check every opener carried inline).
    const t = e && e.target;
    if (t && t.closest && t.closest('input, textarea, [contenteditable]')) return false;
    return true;
};
const $c21c2c1d0c757026$export$d828ab43b0b127a = function(e) {
    if (!e || e.key !== 'Escape') return;
    const root = this?.state?.root;
    if (!root) return;
    const patch = {};
    if (root.contextDropdown) patch.contextDropdown = null;
    if (root._homeColorPicker) patch._homeColorPicker = null;
    if (!Object.keys(patch).length) return;
    // This Escape is spent: every later listener (the shortcut registry, the
    // customize drawer) yields to a handled key — the top overlay closes, alone.
    if (typeof e.preventDefault === 'function') e.preventDefault();
    root.update(patch, {
        preventFetch: true
    });
};
const $c21c2c1d0c757026$export$b218a894899859d6 = function() {
    const root = this?.state?.root;
    if (!root || !root.contextDropdown && !root._homeColorPicker) return;
    root.update({
        contextDropdown: null,
        _homeColorPicker: null
    }, {
        preventFetch: true
    });
};
const $c21c2c1d0c757026$export$142a1380a75551d = function(action, item) {
    const root = this.state.root;
    if (!root) return;
    // Close the menu first — every branch here is terminal.
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    const ops = root._homeOps || {};
    if (action === 'refresh') // Refetch every dashboard widget's data in place — no page reload.
    {
        if (typeof ops.refresh === 'function') ops.refresh();
    } else if (action === 'customize') // Enter customize mode (slides in the CustomizeDrawer).
    root.update({
        _homeCustomizeMode: true
    }, {
        preventFetch: true
    });
    else if (action === 'widgetSize') // A size row from the widget's menu on a touch screen
    // (functions/homeWidgetFrame.js homeWidgetSizeMenuRow) — the same durable
    // write as the edit-mode picker and the corner handle.
    {
        if (item && item.widgetId && item.size && typeof ops.setWidgetSize === 'function') ops.setWidgetSize(item.widgetId, item.size);
    } else if (action === 'widgetColor') // "Add color" / "Change color" — the SECOND step of a two-step menu
    // (2026-09-02, Nika: "add in context menu 'Add color' option so users can
    // customize widget colors + suggested colors").
    //
    // It opens `HomeWidgetColorPicker` (components/), a swatch palette, and
    // NOT a chained `root.contextDropdown`. The reason is measured, not
    // stylistic: a ContextDropdown row cannot carry a colour. Its ink is
    // `(el, s) => (s?.danger || s?.color === 'red' ? 'red' : 'title')` — a
    // two-value branch — and its only leading slots are an `Icon` painted by
    // that same ink and an `Avatar` fed a `src` URL. A palette of fourteen
    // suggested colours rendered as fourteen identically-black rows is not a
    // colour picker, and widening the shared component is a change in
    // packages/shared, which this ticket does not own.
    //
    // `item.x` / `item.y` are the cursor coords the OPENER stamped on the row
    // (pages/main.js, both `onContextmenu` sites): the dispatcher receives no
    // event, so the palette would otherwise open in a corner instead of where
    // the menu was.
    // `item.appHue` — the module's OWN manifest hue, when this widget has one.
    // It stopped painting by default on 2026-09-02 (Nika: "pipeline still has
    // color and set to no color also does not change it. fix it fundamentally
    // for also all app-store related apps and widgets too"), so it travels
    // here instead and the palette offers it as its first swatch. `null` on
    // the static plane, which hides that row.
    root.update({
        _homeColorPicker: {
            widgetId: item && item.widgetId,
            x: item && item.x || 0,
            y: item && item.y || 0,
            appHue: item && item.appHue || null
        }
    }, {
        preventFetch: true
    });
    else if (action === 'hideWidget') // Hide the right-clicked widget (restorable from the customize drawer).
    {
        if (typeof ops.hideWidget === 'function') ops.hideWidget(item && item.widgetId);
    } else if (action === 'shareAiWidget' || action === 'unshareAiWidget') // AI-CREATED plane only — server re-checks ownership on every call
    // (viewerCanEdit is a STAMPED read of that same gate, never a client
    // decision; see functions/aiWidgets.js's "Manage mutations" header).
    {
        if (typeof ops.setAiWidgetVisibility === 'function' && item && item.widget) ops.setAiWidgetVisibility(item.widget, action === 'shareAiWidget' ? 'workspace' : 'personal');
    } else if (action === 'deleteAiWidget') // Asks first (CRUD standard rule 3, D1): the def is removed for good, and
    // a widget shared to the workspace goes for every member who sees it — the
    // message says so. Its visibility is read off the def row itself
    // (root.workspaceAiWidgets), the same row the delete then drops.
    {
        if (typeof ops.deleteAiWidget === 'function' && item && item.widget) {
            const widget = item.widget;
            const rows = Array.isArray(root.workspaceAiWidgets) ? root.workspaceAiWidgets : [];
            const row = rows.find((w)=>w && w.id === widget.id);
            const title = widget.title || this.call('polyglot', 'workspace.widget.untitled');
            this.call('confirmDialog', {
                title: this.call('polyglot', 'workspace.widget.deleteTitle').replace('{title}', ()=>title),
                // A personal widget takes the framework's own default message ("This
                // action cannot be undone.", en + ka).
                ...row && row.visibility === 'workspace' ? {
                    message: this.call('polyglot', 'workspace.widget.deleteSharedMessage')
                } : {},
                confirmText: this.call('polyglot', 'common.action.delete'),
                cancelText: this.call('polyglot', 'common.action.cancel'),
                confirmTheme: 'primary',
                // `null` is the explicit opt-out; OMITTING the key takes the template's
                // 'warning' default.
                icon: null,
                onConfirm: ()=>ops.deleteAiWidget(widget)
            });
        }
    } else if (action === 'changeWidgetWithAi') // "Change with AI…" (HOME-WIDGET-CHANGE-WITH-AI-1): the card rides to the
    // composer; the member says what to change, the assistant does it.
    this.call('homeWidgetChangeWithAi', item && item.widget);
    else if (action === 'autolayout') // Rearrange the board (GridStack .compact()) — the same primitive the
    // boot-time re-sync already calls, guarded there against overwriting a
    // saved arrangement; here IS that arrangement, by explicit request.
    {
        if (typeof ops.autolayout === 'function') ops.autolayout();
    } else if (action === 'undoAutolayout') {
        if (typeof ops.undoAutolayout === 'function') ops.undoAutolayout();
    }
};
const $c21c2c1d0c757026$export$1e5010e2fb47abf7 = function(...args) {
    return (0, $2EI10.focusContextMenu).apply(this, args);
};
const $c21c2c1d0c757026$export$ff218d764e4648ea = function homeWidgetAiTarget(s, title) {
    if (!s || typeof s !== 'object' || !s.id) return null;
    const name = String(title || s.title || s.id);
    if (typeof s.pinnedFrom === 'string' && s.pinnedFrom) {
        // A nested DOMQL state hands its plain values over through parse().
        const raw = s.params && typeof s.params === 'object' ? s.params : {};
        const params = typeof raw.parse === 'function' ? raw.parse() : {
            ...raw
        };
        return {
            card: s.id,
            ref: s.pinnedFrom,
            kind: 'pinned',
            title: name,
            params: params
        };
    }
    if (s.aiGenerated) return s.viewerCanEdit ? {
        card: s.id,
        ref: s.id,
        kind: 'ai',
        title: name
    } : null;
    if (s.moduleId) {
        const key = String(s.moduleId).split('/').pop().replace(/-app$/, '');
        return {
            card: s.id,
            ref: key + '.' + s.id,
            kind: 'app',
            title: name
        };
    }
    return null;
};
const $c21c2c1d0c757026$export$a7af41eaaba8bf85 = function homeWidgetChangeWithAi(target) {
    const t = target && typeof target === 'object' ? target : null;
    const root = this && this.state && this.state.root;
    if (!t || !t.card || !root || typeof root.update !== 'function') return false;
    const title = String(t.title || t.card);
    const params = t.params && typeof t.params === 'object' ? t.params : {};
    const paramText = Object.keys(params).length ? " \xb7 " + Object.entries(params).map(([k, v])=>k + '=' + (v && typeof v === 'object' ? JSON.stringify(v) : String(v))).join(', ') : '';
    const refText = t.ref && t.ref !== t.card ? " \xb7 widget " + t.ref : '';
    const text = ('card ' + t.card + refText + paramText).slice(0, 80);
    const entry = {
        keyPath: [
            'Widget',
            title
        ],
        key: String(this.call('polyglot', 'workspace.widget.changeWithAiKey')).replace('{title}', title),
        tag: 'widget',
        title: title,
        text: text,
        pickedAt: Date.now(),
        homeWidget: {
            card: t.card,
            ref: t.ref || t.card,
            kind: t.kind || 'app',
            params: params
        }
    };
    const prev = (Array.isArray(root.pickedElements) ? root.pickedElements : []).filter((p)=>!(p && p.homeWidget && p.homeWidget.card === t.card));
    root.update({
        pickedElements: [
            ...prev,
            entry
        ]
    });
    const draft = String(this.call('polyglot', 'workspace.widget.changeWithAiPrefix')).replace('{title}', title);
    try {
        const top = typeof this.getRoot === 'function' ? this.getRoot() : null;
        const composer = top && top.lookdown ? top.lookdown('CanvasPromptTextarea') : null;
        if (composer && composer.state && typeof composer.state.update === 'function') composer.state.update({
            draft: draft
        });
        const field = composer && composer.lookdown ? composer.lookdown('Textarea') : null;
        const node = field && field.node;
        if (node && typeof node.focus === 'function') {
            node.focus();
            if (typeof node.setSelectionRange === 'function') node.setSelectionRange(draft.length, draft.length);
        }
    } catch (_) {
    /* the chip is attached either way; the member can type in the composer */ }
    return true;
};

});
parcelRegister("2EI10", function(module, exports) {

$parcel$export(module.exports, "focusContextMenu", () => $1ef175b0ad5bfc81$export$f45f0c1633185f6b);
// Move DOM focus into the freshly-opened ContextDropdown panel.
//
// WHY IT EXISTS (INTERACT-1, 2026-08-14). The shared ContextDropdown closes on
// Escape from `Menu.onKeydown`, a DELEGATED handler — smbls' delegate walks the
// DOM ancestor chain of `event.target` (smbls/packages/element/src/delegate.js
// installDelegatedEvent), so a keystroke never reaches it unless focus actually
// moved into the panel. Nothing moves focus there on its own: a right-click
// leaves focus wherever it was. This function is that nudge.
//
// Bounded poll, not a single microtask check: the panel does not exist in the
// DOM until the opener's render commits and the previously-`display:none`
// panel paints — the same shape as `ContextDropdownItem.scope.openSubmenu`'s
// own `focusFirst` option polling for its submenu's first row.
//
// Scoped to `[data-key="ContextDropdown"]` (DOMQL stamps every element's OWN
// key as `data-key` — smbls/packages/element/src/create.js) rather than a bare
// `[role="menuitem"]` query: ContextDropdown is a single global singleton so
// this is normally unambiguous either way, but naming its subtree precisely
// means it can never accidentally grab a row from an unrelated open menu (e.g.
// an `@symbo.ls/dropdown` DropdownRoot panel, a different mechanism used
// elsewhere in this app).
//
// ── WHY THE NAME IS NEUTRAL ───────────────────────────────────────────────
// This shipped as `focusHomeContextMenu` inside functions/homeContextMenu.js,
// because Home's three openers were the first callers. The panel it focuses is
// the SHELL-WIDE `root.contextDropdown` singleton, though — every surface that
// opens one needs the identical nudge, and an installed workspace MODULE
// already calls it from its own pages (VaultOS 1.38.1, measured 2026-09-10).
// A Home-scoped name on a shell-wide affordance reads as "this only works on
// Home", which was never true, and it makes a module author guess.
//
// `focusHomeContextMenu` stays exported from functions/homeContextMenu.js (and
// from functions/index.js) as a thin alias forwarding `this` + arguments here,
// so every existing caller — the three Home openers in pages/main.js, any
// installed module that already wrote `el.call('focusHomeContextMenu')` —
// keeps working with no change on their side.
const $1ef175b0ad5bfc81$export$f45f0c1633185f6b = ()=>{
    if (typeof document === 'undefined') return;
    let tries = 0;
    const tick = ()=>{
        const first = document.querySelector('[data-key="ContextDropdown"] [role="menuitem"]');
        if (first && typeof first.focus === 'function') {
            first.focus();
            return;
        }
        if (++tries < 8) window.setTimeout(tick, 30);
    };
    window.setTimeout(tick, 0);
};

});


parcelRegister("hcWAT", function(module, exports) {

$parcel$export(module.exports, "ensureChatContext", () => $c8710237c1c4100b$export$e4f51da0e17e8c50);
$parcel$export(module.exports, "openMessenger", () => $c8710237c1c4100b$export$aedff3a2e5de7a56);
// Imperative chat-context fold (chat bundle-fold, 2026-08-01).
//
// Chat's ~215KB component tree used to ride the EAGER shell bundle because
// MessengerOverlay was `hide`-mounted at the shell root — created on every
// boot, on every route, drawer open or not. It now mounts behind a
// `_chatCtxFolded` if-latch (workspace/app.js) and the full chat context
// folds HERE, on demand, through the same add-missing mechanism the lazy
// route folds use (foldSharedLibContext — shared/pages/lazyPage.js).
//
// Every opener funnels through these two functions (or ensures first):
// the header Messenger button, openChatFromToast, the sidebar channel-menu
// dispatches, pageContext deep-links, PersonPopover/AppSidebar messageUser,
// meet applySuggestion, and aiWorkspaceOps' headless createChannel /
// sendMessage.

var $1X0Je = parcelRequire("1X0Je");
const $c8710237c1c4100b$var$shellFeatureEnabled = (...args)=>(0, $1X0Je.default).functions.featureEnabled(...args);
const $c8710237c1c4100b$var$shellFoldSharedLibContext = (...args)=>(0, $1X0Je.default).pages.foldSharedLibContext(...args);
let $c8710237c1c4100b$var$_chatFoldInFlight = null;
// Fill the shell-root MessengerOverlaySlot with the real overlay AFTER the
// fold registered its definition. DOMQL resolves bare-key extends at parent
// parse time, so app.js cannot mount `MessengerOverlay: {}` directly — the
// slot + post-fold `set` is the same deferred-resolution mechanism lazyPage
// uses for route bodies. Idempotent via the slot's own marker.
const $c8710237c1c4100b$var$_mountMessengerOverlay = (rootEl)=>{
    const slot = rootEl?.MessengerOverlaySlot;
    if (!slot || typeof slot.set !== 'function' || slot.__messengerMounted) return;
    slot.__messengerMounted = true;
    slot.set({
        extends: 'MessengerOverlay',
        // Restates the base component's `_chatDrawerOpen` gate + the /flags
        // feature gates — a mount-level `hide` REPLACES the base hide
        // (verified live 2026-07-25; predicate moved verbatim from app.js).
        hide: (el, s)=>!s.root?._chatDrawerOpen || !$c8710237c1c4100b$var$shellFeatureEnabled(s.root, 'chat') || !$c8710237c1c4100b$var$shellFeatureEnabled(s.root, 'chat.messengerOverlay')
    });
};

const $c8710237c1c4100b$export$e4f51da0e17e8c50 = async function() {
    // TWO roots, deliberately distinct: foldSharedLibContext registers into the
    // ELEMENT root's `.context` (same contract as the lazyPage route folds,
    // which pass `el.getRoot()`), while the latch lives on the STATE root.
    // Passing the state root to the fold silently registers nothing — its
    // `.context` is undefined, so both add-missing loops skip (caught live:
    // foldOk=true, zero components registered, the overlay mounting as an
    // empty unknown-key div).
    const rootEl = typeof this?.getRoot === 'function' ? this.getRoot() : this;
    const stateRoot = this?.state?.root || rootEl?.state?.root || rootEl?.state || null;
    if (!rootEl || !stateRoot) return false;
    if (stateRoot._chatCtxFolded) return true;
    if (!$c8710237c1c4100b$var$_chatFoldInFlight) $c8710237c1c4100b$var$_chatFoldInFlight = (parcelRequire("jPn99")).then((mod)=>{
        const lib = mod?.default || mod;
        if (!lib || !lib.components && !lib.functions) throw new Error("chat context resolved empty \u2014 stale/mismatched bundle");
        $c8710237c1c4100b$var$shellFoldSharedLibContext(rootEl, lib);
        $c8710237c1c4100b$var$_mountMessengerOverlay(rootEl);
        // Latch flips ONCE per app lifetime — the registry keeps the folded
        // components across tenant switches, so this key is deliberately NOT
        // in the workspace-scoped wipe registry.
        stateRoot.update({
            _chatCtxFolded: true
        }, {
            preventFetch: true
        });
        return true;
    }).catch((err)=>{
        $c8710237c1c4100b$var$_chatFoldInFlight = null;
        console.error('[chat] context fold failed:', err?.message || err);
        return false;
    });
    return $c8710237c1c4100b$var$_chatFoldInFlight;
};
const $c8710237c1c4100b$export$aedff3a2e5de7a56 = async function(channelId) {
    const ok = await this.call('ensureChatContext');
    if (!ok) return;
    const root = this.state.root;
    root.update({
        _chatDrawerOpen: true,
        ...channelId ? {
            activeChannelId: channelId
        } : {}
    });
};

});

parcelRegister("lXQF7", function(module, exports) {

$parcel$export(module.exports, "ensureMailContext", () => $ffd7f548d3e64a72$export$f3aacce19ab7d957);
// Imperative mail-context fold — the mail twin of chatFold.js.
//
// Mail (@symbo-ls/workspace-mail, the built-in email client —
// architecture/MAIL.md) is a lazy sub-app: only a slim eager slice rides
// sharedLibraries.js, and the FULL context (components + functions) folds
// HERE, on demand, through the same add-missing mechanism the lazy route
// folds use (foldSharedLibContext — shared/pages/lazyPage.js). The docked
// MailOverlay mounts behind the shell-root MailOverlaySlot (workspace/app.js)
// that this fold fills once its definition is registered.
//
// Every opener funnels through ensureMailContext (or ensures first): the
// header envelope (shared/components/AppHeader.js), the mail package's own
// openMailDrawer / toggleMailDrawer, and future deep-links / toast actions.

var $1X0Je = parcelRequire("1X0Je");
const $ffd7f548d3e64a72$var$shellFeatureEnabled = (...args)=>(0, $1X0Je.default).functions.featureEnabled(...args);
const $ffd7f548d3e64a72$var$shellFoldSharedLibContext = (...args)=>(0, $1X0Je.default).pages.foldSharedLibContext(...args);
let $ffd7f548d3e64a72$var$_mailFoldInFlight = null;
// Fill the shell-root MailOverlaySlot with the real overlay AFTER the fold
// registered its definition. DOMQL resolves bare-key extends at parent parse
// time, so app.js cannot mount `MailOverlay: {}` directly — the slot +
// post-fold `set` is the same deferred-resolution mechanism lazyPage uses for
// route bodies. Idempotent via the slot's own marker.
const $ffd7f548d3e64a72$var$_mountMailOverlay = (rootEl)=>{
    const slot = rootEl?.MailOverlaySlot;
    if (!slot || typeof slot.set !== 'function' || slot.__mailOverlayMounted) return;
    slot.__mailOverlayMounted = true;
    slot.set({
        extends: 'MailOverlay',
        // Restates the base component's `_mailDrawerOpen` gate + the /flags
        // feature gate — a mount-level `hide` REPLACES the base hide (verified
        // live on the Messenger slot, 2026-07-25).
        hide: (el, s)=>!s.root?._mailDrawerOpen || !$ffd7f548d3e64a72$var$shellFeatureEnabled(s.root, 'mail')
    });
};

const $ffd7f548d3e64a72$export$f3aacce19ab7d957 = async function() {
    // TWO roots, deliberately distinct: foldSharedLibContext registers into the
    // ELEMENT root's `.context` (same contract as the lazyPage route folds,
    // which pass `el.getRoot()`), while the latch lives on the STATE root.
    // Passing the state root to the fold silently registers nothing — its
    // `.context` is undefined, so both add-missing loops skip (caught live on
    // the chat fold: foldOk=true, zero components registered, the overlay
    // mounting as an empty unknown-key div).
    const rootEl = typeof this?.getRoot === 'function' ? this.getRoot() : this;
    const stateRoot = this?.state?.root || rootEl?.state?.root || rootEl?.state || null;
    if (!rootEl || !stateRoot) return false;
    if (stateRoot._mailCtxFolded) return true;
    if (!$ffd7f548d3e64a72$var$_mailFoldInFlight) $ffd7f548d3e64a72$var$_mailFoldInFlight = (parcelRequire("gOp2u")).then((mod)=>{
        const lib = mod?.default || mod;
        if (!lib || !lib.components && !lib.functions) throw new Error("mail context resolved empty \u2014 stale/mismatched bundle");
        $ffd7f548d3e64a72$var$shellFoldSharedLibContext(rootEl, lib);
        $ffd7f548d3e64a72$var$_mountMailOverlay(rootEl);
        // Latch flips ONCE per app lifetime — the registry keeps the folded
        // components across tenant switches, so this key is deliberately NOT
        // in the workspace-scoped wipe registry (mirrors _chatCtxFolded).
        stateRoot.update({
            _mailCtxFolded: true
        }, {
            preventFetch: true
        });
        return true;
    }).catch((err)=>{
        $ffd7f548d3e64a72$var$_mailFoldInFlight = null;
        console.error('[mail] context fold failed:', err?.message || err);
        return false;
    });
    return $ffd7f548d3e64a72$var$_mailFoldInFlight;
};

});

parcelRegister("4v0cn", function(module, exports) {

$parcel$export(module.exports, "ensureDocumentsContext", () => $346a36211dab20f0$export$57b9f49c6ea88671);
// Imperative documents-context fold.
//
// The documents package is deferred out of the eager shell bundle — its page
// bodies, fetch blocks and the Crepe editor only matter on /documents, so the
// routes fold it via lazySharedLibPage. But the /files desktop now opens a .md
// in that same editor (2026-08-08 per Nika: "md files can be opened in notes
// editor (in modal)"), and it does so from a route that never folds documents.
//
// Same shape as ensureChatContext, and the same reason for it: one add-missing
// fold, single-flight, retryable, latched on the state root. Nothing here
// mounts anything — the caller decides where the editor goes, because /files
// puts it in the viewer window rather than on a page.
// Bare shared-library import, not a deep pages/lazyPage.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0). Deferred-call
// wrapper, not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $346a36211dab20f0$var$shellFoldSharedLibContext = (...args)=>(0, $1X0Je.default).pages.foldSharedLibContext(...args);
let $346a36211dab20f0$var$_documentsFoldInFlight = null;

const $346a36211dab20f0$export$57b9f49c6ea88671 = async function() {
    // TWO roots, deliberately distinct: foldSharedLibContext registers into the
    // ELEMENT root's `.context`, while the latch lives on the STATE root. Passing
    // the state root registers NOTHING and reports success — the trap chatFold
    // documents from having been caught live.
    const rootEl = typeof this?.getRoot === 'function' ? this.getRoot() : this;
    const stateRoot = this?.state?.root || rootEl?.state?.root || rootEl?.state || null;
    if (!rootEl || !stateRoot) return false;
    if (stateRoot._documentsCtxFolded) return true;
    if (!$346a36211dab20f0$var$_documentsFoldInFlight) $346a36211dab20f0$var$_documentsFoldInFlight = (parcelRequire("aNDji")).then((mod)=>{
        const lib = mod?.default || mod;
        if (!lib || !lib.components && !lib.functions) throw new Error("documents context resolved empty \u2014 stale/mismatched bundle");
        $346a36211dab20f0$var$shellFoldSharedLibContext(rootEl, lib);
        // Latches ONCE per app lifetime: the registry keeps folded components
        // across tenant switches, so this key is deliberately NOT in the
        // workspace-scoped wipe registry.
        stateRoot.update({
            _documentsCtxFolded: true
        }, {
            preventFetch: true
        });
        return true;
    }).catch((err)=>{
        $346a36211dab20f0$var$_documentsFoldInFlight = null;
        console.error('[documents] context fold failed:', err?.message || err);
        return false;
    });
    return $346a36211dab20f0$var$_documentsFoldInFlight;
};

});

parcelRegister("9Lsv8", function(module, exports) {

$parcel$export(module.exports, "ensureMeetContext", () => $71be9c948c81dea5$export$9ecbc1d654c919b);
// Imperative meet-context fold (bundle tranche T3 follow-up, 2026-08-02).
//
// The meet fold (925bda76) deferred meet's ~280KB call/room/video/transcript
// tree behind the `/meet` + `/meet-guest` routes, keeping only a slim eager
// slice registered (MeetCallWidget + MeetControlBarIconButton +
// MeetNewRoomModal, and the connectCall/createRoom/meetRoomUrl/… functions).
// That inventory covered every EAGER caller — but it missed one caller that
// lives in ANOTHER LAZY package: chat's channel header opens the group call
// as a `@symbo.ls/windows` modal whose body is `extends: 'MeetVideoRoom'`
// (packages/chat/components/Main.js). Folding chat does NOT fold meet, so on
// /chat — with meet never visited — that key resolved against nothing and the
// modal opened EMPTY (DOMQL resolves a string `extends` at parse time, so a
// later meet fold cannot repair an already-parsed element).
//
// This is the meet-side twin of `ensureChatContext` (./chatFold.js): the same
// single-flight, idempotent, retry-on-failure fold through the one shared
// mechanism (`foldSharedLibContext`, shared/pages/lazyPage.js). Any surface
// that needs a meet component key it does not already have registered calls
// `el.call('ensureMeetContext')` and awaits it BEFORE mounting.
//
// Unlike the chat fold there is no slot to fill: meet has no always-mounted
// overlay that has to be materialised post-fold — the eager slice's
// MeetCallWidget is registered from boot, so the shell-root call dock is
// unaffected either way.

var $1X0Je = parcelRequire("1X0Je");
const $71be9c948c81dea5$var$shellFoldSharedLibContext = (...args)=>(0, $1X0Je.default).pages.foldSharedLibContext(...args);
let $71be9c948c81dea5$var$_meetFoldInFlight = null;

const $71be9c948c81dea5$export$9ecbc1d654c919b = async function() {
    // Same two-root split as ensureChatContext: foldSharedLibContext registers
    // into the ELEMENT root's `.context` (the contract every lazyPage route fold
    // uses), while the latch lives on the STATE root. Passing the state root to
    // the fold silently registers nothing.
    const rootEl = typeof this?.getRoot === 'function' ? this.getRoot() : this;
    const stateRoot = this?.state?.root || rootEl?.state?.root || rootEl?.state || null;
    if (!rootEl) return false;
    if (stateRoot?._meetCtxFolded) return true;
    if (!$71be9c948c81dea5$var$_meetFoldInFlight) $71be9c948c81dea5$var$_meetFoldInFlight = (parcelRequire("l9i79")).then((mod)=>{
        const lib = mod?.default || mod;
        if (!lib || !lib.components && !lib.functions) throw new Error("meet context resolved empty \u2014 stale/mismatched bundle");
        $71be9c948c81dea5$var$shellFoldSharedLibContext(rootEl, lib);
        // Latch flips ONCE per app lifetime — the registry keeps the folded
        // components across tenant switches, so this key is deliberately NOT
        // in the workspace-scoped wipe registry (mirrors _chatCtxFolded).
        stateRoot?.update?.({
            _meetCtxFolded: true
        }, {
            preventFetch: true
        });
        return true;
    }).catch((err)=>{
        $71be9c948c81dea5$var$_meetFoldInFlight = null;
        console.error('[meet] context fold failed:', err?.message || err);
        return false;
    });
    return $71be9c948c81dea5$var$_meetFoldInFlight;
};

});

parcelRegister("4B6D0", function(module, exports) {

$parcel$export(module.exports, "ensureMarketplaceUninstallDialog", () => $358fc25af5aae8ba$export$e51049ea11bf37a3);
// The App Store's remove dialog, reached from the shell's own Remove.
//
// /add-app's "Installed apps" list removes one app at a time, and that removal
// is the App Store's: its remove dialog (marketplace
// MarketplaceUninstallDependentsDialog) names every other installed app whose
// manifest declares the app and what each one loses, its Remove is the atomic
// DELETE with the server's dependency guard (sdk.removeWorkspaceApp, never
// `force`), and a 409 turns it into the blocked dialog. One removal, one
// dialog: the shell keeps no second copy of either.
//
// The dialog and its functions live in the marketplace package, which the
// shell folds lazily (pages/index.js lazySharedLib, on the first /marketplace*
// visit). So the first Remove folds the SAME context here, through the same
// add-missing fold the route folds and the chat/mail/meet folds use
// (foldSharedLibContext, shared/pages/lazyPage.js), from the same chunk a
// /marketplace visit loads: a visit before or after costs nothing twice. Then
// it mounts the dialog ONCE into the shell-root MarketplaceUninstallSlot
// (app.js). A bare key there could not resolve before the fold: DOMQL takes a
// child's extends at parent parse time (the MailOverlaySlot note in app.js),
// so the slot is filled by `set` after it.
//
// The slot is the dialog's HOST: it carries `_marketplaceHost` and its own
// state, so marketplaceHostOf binds there and every write of the store's flow
// (uninstallDepsModal, the installed-apps cache) stays on that slice, never on
// the shell root. Its finish hot-deactivates through reactivateWorkspaceModule
// (functions/workspaceApps.js), the path the store's own Uninstall takes.
//
// Returns `{ host }` (the host state, what the store's openAppUninstallDialog
// takes), or `{ reason }`: 'notReady' while the slot is not built yet,
// 'loadFailed' when the fold failed or registered no dialog. A failed fold is
// retried by the next call. `loader` is for tests; the runtime passes none.
//
// Frank note: the in-flight fold lives on the slot (one per shell root), not
// on a module binding (FA204), and the default loader is written in the body,
// not as a default parameter over a module const (ticketDetailModalLoad.js).

var $1X0Je = parcelRequire("1X0Je");
const $358fc25af5aae8ba$var$shellFoldSharedLibContext = (...args)=>(0, $1X0Je.default).pages.foldSharedLibContext(...args);


const $358fc25af5aae8ba$export$e51049ea11bf37a3 = async function(loader) {
    const el = this;
    const rootEl = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
    const slot = rootEl && rootEl.MarketplaceUninstallSlot;
    // A slot whose `if:` latch has not opened yet is parked with no node.
    if (!slot || !slot.node || typeof slot.set !== 'function' || !slot.state) return {
        reason: 'notReady'
    };
    if (slot.__mktUninstallMounted) return {
        host: slot.state
    };
    // The dialog and its opener, as the live registry holds them (a published
    // registry can carry the `smbls.` prefix).
    const registered = ()=>{
        const ctx = rootEl.context || {};
        const has = (reg, k)=>!!reg && !!(reg[k] || reg['smbls.' + k]);
        return has(ctx.components, 'MarketplaceUninstallDependentsDialog') && has(ctx.functions, 'openAppUninstallDialog');
    };
    if (!registered()) {
        const load = typeof loader === 'function' ? loader : ()=>(parcelRequire("17dat"));
        if (!slot.__mktUninstallFold) slot.__mktUninstallFold = Promise.resolve().then(function() {
            return (parcelRequire("17dat"));
        }).then((res)=>load()).then((mod)=>{
            const lib = mod && mod.default ? mod.default : mod;
            if (!lib || !lib.components && !lib.functions) throw new Error('marketplace context resolved empty (stale or mismatched bundle)');
            $358fc25af5aae8ba$var$shellFoldSharedLibContext(rootEl, lib);
        }).catch((err)=>{
            console.warn('[marketplaceUninstallDialog] fold failed:', err && err.message);
        }).finally(()=>{
            slot.__mktUninstallFold = null;
        });
        await slot.__mktUninstallFold;
        if (!registered()) return {
            reason: 'loadFailed'
        };
    }
    if (!slot.__mktUninstallMounted) {
        slot.__mktUninstallMounted = true;
        slot.set({
            extends: 'MarketplaceUninstallDependentsDialog'
        });
    }
    return {
        host: slot.state
    };
};

});

parcelRegister("k3hwI", function(module, exports) {

$parcel$export(module.exports, "allRoles", () => $e991aee68e92aaca$export$34e53dc58297a06);
$parcel$export(module.exports, "roleOf", () => $e991aee68e92aaca$export$18940861040fad6d);
$parcel$export(module.exports, "memberIdOf", () => $e991aee68e92aaca$export$f1128c9aad76983);
$parcel$export(module.exports, "currentRole", () => $e991aee68e92aaca$export$6e14c2db638aade1);
$parcel$export(module.exports, "roleMeta", () => $e991aee68e92aaca$export$fefb98939145397d);
$parcel$export(module.exports, "roleColor", () => $e991aee68e92aaca$export$c2844249c9ada549);
$parcel$export(module.exports, "roleLabel", () => $e991aee68e92aaca$export$ec59b59d53da5a56);
$parcel$export(module.exports, "roleIsCore", () => $e991aee68e92aaca$export$352d4eb3fe50bbbd);
$parcel$export(module.exports, "roleLabelKey", () => $e991aee68e92aaca$export$711869e6ac8f0cad);
$parcel$export(module.exports, "isCoreMember", () => $e991aee68e92aaca$export$e377f8f4015a2bc7);
$parcel$export(module.exports, "isOwnPersonRow", () => $e991aee68e92aaca$export$30281c4700e9f4f9);
$parcel$export(module.exports, "confirmPersonRoleChange", () => $e991aee68e92aaca$export$79f54079ad5de4b1);
// Role helpers — extracted from functions/index.js (2026-08-12) so leaf
// consumers (AdminChrome and other components reachable from the
// workspace-shared components barrel) can import them WITHOUT pulling the
// whole shell functions barrel. The barrel re-exports everything here, so
// `el.call('roleOf', …)` and existing barrel imports are unchanged.
//
// Why this matters: shared context.js → shared components barrel →
// IdentityAdminComponents → AdminChrome ran DURING the shared package's own
// module init. When AdminChrome imported the shell functions barrel, every
// module-scope `_wsShared.functions` read in that barrel executed against a
// still-initializing shared barrel (default export undefined) and crashed
// the entire shell boot. Keeping AdminChrome on this leaf module keeps the
// shell functions barrel out of the shared init cycle.
const $e991aee68e92aaca$var$_rolesByName = (s)=>{
    const list = s && s.root && s.root.roles && s.root.roles.available;
    if (!list || !list.length) return {};
    const map = {};
    for (const r of list)map[r.name] = r;
    return map;
};
const $e991aee68e92aaca$export$34e53dc58297a06 = (s)=>s && s.root && s.root.roles && s.root.roles.available || [];
const $e991aee68e92aaca$export$18940861040fad6d = (s, userId)=>s && s.root && s.root.roles && s.root.roles.byUser && s.root.roles.byUser[userId] || null;
const $e991aee68e92aaca$export$f1128c9aad76983 = (s, userId)=>s && s.root && s.root.roles && s.root.roles.byUserMemberId && s.root.roles.byUserMemberId[userId] || null;
const $e991aee68e92aaca$export$6e14c2db638aade1 = (s)=>$e991aee68e92aaca$export$18940861040fad6d(s, s && s.root && s.root.currentUserId);
const $e991aee68e92aaca$export$fefb98939145397d = (s, role)=>$e991aee68e92aaca$var$_rolesByName(s)[role] || null;
const $e991aee68e92aaca$export$c2844249c9ada549 = (s, role)=>$e991aee68e92aaca$export$fefb98939145397d(s, role)?.color || 'gray';
const $e991aee68e92aaca$export$ec59b59d53da5a56 = (s, role)=>$e991aee68e92aaca$export$fefb98939145397d(s, role)?.label || (role ? role.replace(/^./, (c)=>c.toUpperCase()) : '');
const $e991aee68e92aaca$export$352d4eb3fe50bbbd = (s, role)=>!!$e991aee68e92aaca$export$fefb98939145397d(s, role)?.is_core;
// The bundle KEY of a SYSTEM role, or null for a tenant-defined one. The role
// chips read `Owner` / `Co-owner` / `Member` on a Georgian page (measured live
// on /people and /admin): `roleLabel` above has no element, so it cannot reach
// polyglot, and it answered the server's English label. The strings already
// ship in both languages — shared MemberProfile resolves the same keys. A
// render site resolves the key; a role a workspace invented has no key and
// keeps the label its admin wrote. Literal keys, never concatenated
// (docs/I18N-CONVENTION.md §1.3).
const $e991aee68e92aaca$var$ROLE_LABEL_KEYS = {
    owner: 'account.member.role.owner',
    'co-owner': 'account.member.role.coOwner',
    superadmin: 'account.member.role.superadmin',
    admin: 'account.member.role.admin',
    manager: 'account.member.role.manager',
    member: 'account.member.role.member',
    editor: 'account.member.role.editor',
    viewer: 'account.member.role.viewer',
    guest: 'account.member.role.guest'
};
const $e991aee68e92aaca$export$711869e6ac8f0cad = (role)=>{
    const key = $e991aee68e92aaca$var$ROLE_LABEL_KEYS[role];
    return typeof key === 'string' ? key : null;
};
const $e991aee68e92aaca$export$e377f8f4015a2bc7 = (s)=>{
    const role = $e991aee68e92aaca$export$6e14c2db638aade1(s);
    if (!role) return false;
    return $e991aee68e92aaca$export$352d4eb3fe50bbbd(s, role);
};
const $e991aee68e92aaca$export$30281c4700e9f4f9 = (person, root)=>{
    const r = root || person && person.root;
    if (!person || !r) return false;
    if (person.userId && r.currentUserId) return person.userId === r.currentUserId;
    return !!person.email && person.email === r.currentUserEmail;
};
function $e991aee68e92aaca$export$79f54079ad5de4b1(person, role, showRole) {
    const root = person && person.root || this?.state?.root;
    const s = {
        root: root
    };
    const prev = root && person && $e991aee68e92aaca$export$18940861040fad6d(s, person.userId) || 'member';
    const show = (value)=>{
        if (typeof showRole === 'function') showRole(value);
    };
    const back = ()=>show(prev);
    if (!root || !person?.userId || !role || role === prev) {
        back();
        return;
    }
    const t = (key)=>this.call('polyglot', key);
    if ($e991aee68e92aaca$export$30281c4700e9f4f9(person, root)) {
        back();
        this.call('openNotification', {
            type: 'warning',
            title: t('members.role.changeFailed'),
            message: t('workspace.person.roleChange.self')
        });
        return;
    }
    const name = person.name || person.email || t('members.roleUpdated.fallbackName');
    const labelKey = $e991aee68e92aaca$export$711869e6ac8f0cad(role);
    const label = labelKey ? t(labelKey) : $e991aee68e92aaca$export$ec59b59d53da5a56(s, role);
    const failed = (err)=>{
        back();
        this.call('openNotification', {
            type: 'error',
            title: t('members.role.changeFailed'),
            message: err && err.message || ''
        });
    };
    this.call('confirmDialog', {
        title: t('workspace.person.roleChange.title').replace('{name}', ()=>name).replace('{role}', ()=>label),
        message: t('workspace.person.roleChange.message'),
        confirmText: t('workspace.person.roleChange.confirm'),
        cancelText: t('common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onCancel: back,
        onConfirm: async ()=>{
            // memberId = OrgMember._id (not the user id): what
            // sdk.updateOrgMember(orgId, memberId, { role }) PATCHes.
            const orgId = root.jwtClaims?.workspace_org_id;
            const memberId = $e991aee68e92aaca$export$f1128c9aad76983(s, person.userId);
            if (!orgId || !memberId || !this.sdk?.updateOrgMember) return failed(null);
            try {
                await this.sdk.updateOrgMember(orgId, memberId, {
                    role: role
                });
            } catch (err) {
                return failed(err);
            }
            // Applied only AFTER a confirmed success: the row never shows a role
            // the PATCH did not persist.
            const prev = root.roles || {
                available: [],
                byUser: {},
                byUserMemberId: {},
                version: 0
            };
            root.update({
                roles: {
                    ...prev,
                    byUser: {
                        ...prev.byUser || {},
                        [person.userId]: role
                    },
                    version: (prev.version || 0) + 1
                }
            });
            show(role);
            this.call('openNotification', {
                type: 'success',
                title: t('members.roleUpdated.title'),
                message: t('members.roleUpdated.message').replace('{name}', ()=>name).replace('{role}', ()=>label)
            });
            return true;
        }
    });
}

});

parcelRegister("17MWq", function(module, exports) {

$parcel$export(module.exports, "isOptimisticId", () => $0d1c689f4d6b8f89$export$896acb2e77110797);
$parcel$export(module.exports, "upsertRow", () => $0d1c689f4d6b8f89$export$68670caa4128ccb4);
$parcel$export(module.exports, "softDeleteRow", () => $0d1c689f4d6b8f89$export$cb43d73b439578d7);
// rowOps — generic row upsert/soft-delete helpers (renamed from supabaseRow.js;
// the transport has been SDK-only since the Supabase-era pattern it replaced). Bind via .call('upsertRow', ...)
// from any DOMQL element so the active fetch context (config.fetch — the SDK
// adapter, see config.js) is reused.
const $0d1c689f4d6b8f89$var$_logErr = (scope, err)=>console.error(`[${scope}]`, err?.message || err);
// Date.now() is 13 digits in 2026; legacy autoincrement ids are <13 digits for
// the foreseeable future. Anything in [FLOOR, CEILING) is a client-minted
// optimistic id. The CEILING (16 digits) keeps the numeric-string branch from
// swallowing a long all-digit server id — a Mongo ObjectId is 24 hex chars and
// may legally be all digits.
const $0d1c689f4d6b8f89$var$OPTIMISTIC_ID_FLOOR = 1000000000000;
const $0d1c689f4d6b8f89$var$OPTIMISTIC_ID_CEILING = 1000000000000000;
// WS-ROWOPS-OPTIMISTIC-ID-STRING-1 (mirrors the calendar fix in
// packages/calendar/functions/saveEvent.js —
// WS-CALENDAR-SAVEEVENT-OPTIMISTIC-ID-DUPES-1): the old test was
// `typeof id !== 'number' || id >= FLOOR`. Post-cutover the server exposes a
// 24-hex ObjectId STRING id, so "not a number" stopped meaning "optimistic":
// `upsertRow` stripped the id off a real row (INSERTing a duplicate) and
// `softDeleteRow` returned true without writing. A server-exposed id — string,
// or legacy number below the floor — is PERSISTED. An id is optimistic ONLY in
// the CLIENT's own shape: absent, or a numeric (or numeric-string) Date.now()
// value inside the optimistic band.
const $0d1c689f4d6b8f89$var$_isOptimisticNumber = (n)=>Number.isFinite(n) && n >= $0d1c689f4d6b8f89$var$OPTIMISTIC_ID_FLOOR && n < $0d1c689f4d6b8f89$var$OPTIMISTIC_ID_CEILING;
const $0d1c689f4d6b8f89$export$896acb2e77110797 = (id)=>{
    if (id == null || id === '') return true;
    if (typeof id === 'number') return Number.isFinite(id) ? $0d1c689f4d6b8f89$var$_isOptimisticNumber(id) : true;
    if (typeof id === 'string') {
        const trimmed = id.trim();
        // A Date.now() id that arrived stringified is still optimistic; any other
        // string (24-hex ObjectId, uuid, SMBLS-N slug, …) is a real server id.
        if (!/^\d+$/.test(trimmed)) return false;
        return $0d1c689f4d6b8f89$var$_isOptimisticNumber(Number(trimmed));
    }
    return true;
};
const $0d1c689f4d6b8f89$export$68670caa4128ccb4 = async function({ from: from, row: row }) {
    const fetch = this.context?.fetch;
    if (!fetch?.upsert) {
        $0d1c689f4d6b8f89$var$_logErr('upsertRow', 'context.fetch.upsert missing');
        return null;
    }
    const data = $0d1c689f4d6b8f89$export$896acb2e77110797(row?.id) ? {
        ...row,
        id: undefined
    } : row;
    try {
        const result = await fetch.upsert({
            from: from,
            data: data
        });
        if (result?.error) {
            $0d1c689f4d6b8f89$var$_logErr('upsertRow', result.error);
            return null;
        }
        return result?.data?.[0]?.id ?? null;
    } catch (e) {
        $0d1c689f4d6b8f89$var$_logErr('upsertRow', e);
        return null;
    }
};
const $0d1c689f4d6b8f89$export$cb43d73b439578d7 = async function({ from: from, id: id }) {
    if ($0d1c689f4d6b8f89$export$896acb2e77110797(id)) return true;
    const fetch = this.context?.fetch;
    if (!fetch?.update) {
        $0d1c689f4d6b8f89$var$_logErr('softDeleteRow', 'context.fetch.update missing');
        return false;
    }
    try {
        const result = await fetch.update({
            from: from,
            params: {
                id: id
            },
            data: {
                deleted: true,
                dirty: true,
                updated_at: new Date().toISOString()
            }
        });
        if (result?.error) {
            $0d1c689f4d6b8f89$var$_logErr('softDeleteRow', result.error);
            return false;
        }
        return true;
    } catch (e) {
        $0d1c689f4d6b8f89$var$_logErr('softDeleteRow', e);
        return false;
    }
};

});

parcelRegister("2aopH", function(module, exports) {

$parcel$export(module.exports, "loadSignInSession", () => $193f73ee922ce9f8$export$651ba050f18bb47a);
$parcel$export(module.exports, "confirmSignInSession", () => $193f73ee922ce9f8$export$9d98a9533aa5ea3f);
// /sign-in-session — the explicit Continue step for a CLI / plugin sign-in
// link (server CORE-AUTH-TAKEOVER-PATHS D9). A device (smbls CLI, Figma
// plugin) starts a session and opens `/login?session=<id>`; the server no
// longer arms it for whoever opens the link. This step shows when and from
// where the sign-in was started and which client asks, asks for the code
// the device shows when the server requires it, and arms the session for
// the signed-in account only on Continue.
// Read the session facts once per page. Read only. `error` / `codeError`
// hold the full polyglot key of the message to show.
const $193f73ee922ce9f8$export$651ba050f18bb47a = async function loadSignInSession() {
    const s = this.state;
    if (s.requested) return;
    s.update({
        requested: true
    });
    const sessionId = new URLSearchParams(window.location.search).get('session') || '';
    if (!sessionId) {
        s.update({
            loading: false,
            error: 'workspace.signInSession.error.expired'
        });
        return;
    }
    try {
        const info = await this.sdk.getSignInSessionInfo(sessionId);
        if (!info || info.status !== 'pending') {
            s.update({
                loading: false,
                error: 'workspace.signInSession.error.expired'
            });
            return;
        }
        s.update({
            loading: false,
            sessionId: sessionId,
            createdAt: info.createdAt || '',
            requesterIp: info.requesterIp || '',
            client: info.client || '',
            codeRequired: !!info.codeRequired
        });
    } catch (error) {
        const status = error?.cause?.status;
        s.update({
            loading: false,
            error: status === 404 ? 'workspace.signInSession.error.expired' : 'workspace.signInSession.error.failed'
        });
    }
};
const $193f73ee922ce9f8$export$9d98a9533aa5ea3f = async function confirmSignInSession() {
    const s = this.state;
    if (s.submitting || !s.sessionId) return;
    if (s.codeRequired && !String(s.code || '').trim()) {
        s.update({
            codeError: 'workspace.signInSession.codeError.missing'
        });
        return;
    }
    s.update({
        submitting: true,
        codeError: null
    });
    try {
        await this.sdk.activateSignInSession(s.sessionId, s.codeRequired ? String(s.code).trim() : undefined);
        s.update({
            submitting: false,
            done: true
        });
    } catch (error) {
        const status = error?.cause?.status;
        if (status === 403) {
            s.update({
                submitting: false,
                codeError: 'workspace.signInSession.codeError.wrong'
            });
            return;
        }
        s.update({
            submitting: false,
            error: status === 410 ? 'workspace.signInSession.error.locked' : status === 404 || status === 409 ? 'workspace.signInSession.error.expired' : 'workspace.signInSession.error.failed'
        });
    }
};

});

parcelRegister("4u35b", function(module, exports) {

$parcel$export(module.exports, "homeAiSend", () => $343c5ae67e662b7a$export$302aee1b865f8b6a);
// homeAiSend(text) — entry point for the home page's CanvasPromptTextarea.
//
// Replaces the direct `freestyleSend(text)` call (which always opens a
// local WebSocket to ws://127.0.0.1:8765 regardless of the user's
// provider mode). Routes through sdk.ai.dispatch so:
//
//   - mode='simone' / 'providers' → POST /core/ai-chat/dispatch (or
//     fallback to /ai-chat/stream until the dispatch endpoint ships)
//   - mode='local'                → WebSocket to simone-bridge through
//                                   the SDK's AiService instead of the
//                                   workspace's freestyleBridge module
//
// Intent routing (the LLM picks one of three):
//
//   - 'build'   → write the spec to root.freestyleBuildSpec and toggle
//                 root.freestyleBusy so the canvas / page-builder picks
//                 it up. (Today this is a stub — the actual freestyler
//                 hand-off lands when the server endpoint emits the
//                 spec shape; until then BUILD falls back to ANSWER.)
//   - 'answer'  → open AppAssistant drawer + push the streamed text as
//                 the latest assistant turn.
//   - 'action'  → write proposals to root._aiActionProposals so the
//                 shell-mounted AiActionConfirmCard renders. In
//                 authMode='auto' the SDK auto-executes; we write the
//                 resolved results to _aiActionResults instead.
//
// Per-intent state writes — see workspace/state-app.js for declarations.
// `attachments` is the optional image-bytes payload built by the shared
// buildPromptPayload serialiser (shared/functions/promptAttachments.js). It is
// a REAL second parameter, not the retry counter — the counter moved to the
// third slot when attachments were added, because the composer now calls
// homeAiSend(body, attachments) and passing an array where `_attempt` used to
// sit would have silently corrupted the boot-race retry below.
//
// Note the honest limit: the description of every attachment is already inside
// `text` (buildPromptPayload appends context lines), which is what actually
// reaches the agent today. Threading the bytes further is blocked downstream —
// see promptAttachments.js's header.
// `attached` is the OPTIONAL structured-attachment payload the canvas
// composer forwards from `getSelectionAiContext().attached`
// (`{ refs?, canvas? }`, spec §3.8/§4.1). It rides in the FOURTH slot, after
// the boot-race counter, on purpose: `_attempt` has been the third parameter
// since attachments were added, the retry below re-calls this function
// positionally, and moving it again is the same silent corruption the
// `attachments` note above records. Passed through UNTOUCHED — the canvas lane
// owns the payload's own caps, and simoneAiTransport merges it with the
// persistent `root.aiAttached` bag at the one place that builds the wire.
// `opts` (fifth slot, after `attached` for the same positional reason) —
// `{ mode }`: the ONE ask's output when the composer's focus panel names it
// (functions/aiPanel.js — "Summarize" answers, "Build a board" builds). It
// routes and rides this send only; the person's mode is never written
// (functions/assistantMode.js: an explicit choice wins over every default).
async function $343c5ae67e662b7a$export$302aee1b865f8b6a(text, attachments = null, _attempt = 0, attached = null, opts = null) {
    const el = this;
    const root = el?.state?.root || el?.getRoot?.()?.state?.root;
    const trimmed = String(text || '').trim();
    if (!trimmed) return;
    const modes = [
        'assistant',
        'dashboard',
        'tools',
        'apps',
        'presentation',
        'fly'
    ];
    // INSPECT & ASK: an ask that carries a region the member pointed at (a
    // picked entry with `inspect` facts, functions/aiInspect.js) is a QUESTION
    // about it. It is ANSWERED — the chat agent reads the region's facts
    // (`context.inspected`) — never turned into a board or a deck by the
    // person's Dashboard / Presentation mode: on dev 2026-10-04 "why is this
    // amber?" built a generic board that never saw the region
    // (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1). One ask only; the
    // person's mode is never written.
    // An element picked in a WEBSITE's frame (a Fly site card's Inspect — the
    // preview picker's sanitized pick, `untrusted: true`) is the same kind of
    // pointing: the ask is about that element (Nika 2026-10-18, "inspect modes"
    // in Fly; preview functions/_simone/pickElement.js).
    // FLY keeps a REGION of the workspace in Fly (Fly train 2): the page
    // answers about it — its facts ride the fly ask as `context.inspected`
    // (functions/assistantFlyContext.js; the server's fly INSPECTED line, its
    // figures ON SCREEN facts of the opening). A website element still goes to
    // the chat, as the sites lane routes it.
    const picked = Array.isArray(root?.pickedElements) ? root.pickedElements : [];
    const fly = root?.assistantMode === 'fly';
    const asksAboutRegion = picked.some((p)=>p && (p.untrusted === true || p.inspect && !fly)) && (root?.assistantMode === 'dashboard' || root?.assistantMode === 'presentation' || fly);
    const askMode = opts && modes.includes(opts.mode) ? opts.mode : asksAboutRegion ? 'assistant' : null;
    const effectiveMode = askMode || root?.assistantMode;
    const fns = el && el.context && el.context.functions || {};
    // THE ASK ROUTER (functions/assistantAskRoute.js): ONE decision per ask —
    // the view is the default, a clear intent switches (a dashboard → a Fly
    // page, an app → the builder, slides → a deck, a document, an open or an
    // action → the chat, the tour → the tour), and a switch says so. An
    // explicit ask mode (the focus panel) and a question about a picked region
    // keep the routes below, and so does a host without the router.
    let decision = !askMode && root && typeof fns.assistantAskRoute === 'function' ? el.call('assistantAskRoute', root, trimmed) : null;
    // A page or slides need the board service's answer (`_aiBoardsAvailable`):
    // asked on EVERY ask that needs it while it is not a yes — a service that
    // came back since the last ask is used at once — then decided again.
    if (decision && decision.probe) {
        try {
            await el.call('assistantBoardProbe', root, el.sdk || el.call('getSDK'));
        } catch (_) {
        /* no service here — the chat answers, and says so */ }
        decision = el.call('assistantAskRoute', root, trimmed, {
            probed: true
        });
    }
    // An explicit app build belongs to the builder even when Ask, Fly or
    // Present is selected. Dashboard keeps its board-generation meaning.
    const buildApp = decision ? decision.surface === 'app' : effectiveMode !== 'dashboard' && /^(?:(?:please|can you|could you|would you)\s+)*(?:build|make|create)\b[\s\S]*\b(?:app|application|extension|plugin|mini-app|board|tracker|portal)\b/i.test(trimmed);
    // MODE × PLACEMENT (AI_ASSISTANT_SPEC v1 §1, v1.1 §12; DESIGN-WL-ASSISTANT-
    // MAIN-VIEW-1 — the routing hunk of this file, cleared to current-23 by ws-w2
    // 2026-09-28). With the main placement (`assistantDock === 'main'`) on ANY
    // route (§12.2, main thread = "Everywhere"), a DASHBOARD ask builds a
    // generated board in the main area — `assistantBoardGenerate`, the
    // ai.boards stream, the drawer shut — while an ASSISTANT, TOOLS or APPS ask
    // becomes the MAIN THREAD: the same general-scope turn the sidebar runs,
    // over the home's grid area or the page (functions/assistantMainThread.js
    // `assistantSendRoute`). Another placement, a page sheet open in the
    // PageSlot, or a shell without that function takes the path below, as
    // today. The board route runs ahead of the transport readiness wait on
    // purpose: a board never touches the chat bridge.
    // PRESENTATION (§12.1) is the same path's second shape: a LIVE DECK
    // (functions/assistantDeck.js `assistantDeckGenerate`) — one fast call, no
    // tools, never the chat bridge; the deck takes the view like a board.
    let route = decision ? decision.route : buildApp ? 'app' : root && typeof fns.assistantSendRoute === 'function' ? el.call('assistantSendRoute', root, askMode) : null;
    // A BOARD or a DECK needs the board service's answer (`_aiBoardsAvailable`),
    // which a board view asks when it MOUNTS — the home's. On a page where none
    // has mounted yet (a cold boot on /crm, §12.2), a Dashboard or Presentation
    // ask asks it first — once per workspace for this composer — then routes.
    // FLY needs the same answer on ANY placement (its canvas is the main area
    // whatever the dock): a fly ask with no route yet asks the probe first too.
    // Asked again on every such ask while the answer is not a yes (it was once
    // per composer: a cold boot's "no" stuck for the whole session).
    if (!decision && (route === 'thread' || route === null) && root && (effectiveMode === 'fly' || route === 'thread' && root.assistantDock === 'main' && (effectiveMode === 'dashboard' || effectiveMode === 'presentation')) && root._aiBoardsAvailable !== true && typeof fns.assistantBoardProbe === 'function') {
        try {
            await el.call('assistantBoardProbe', root, el.sdk || el.call('getSDK'));
        } catch (_) {
        /* no service here — the ask stays a thread turn */ }
        route = el.call('assistantSendRoute', root, askMode);
    }
    // THE TOUR (functions/aiStartTour.js) from any view — never a page about
    // it. A tour that cannot start here leaves the ask to the chat.
    if (route === 'tour') {
        let tour = null;
        try {
            tour = await el.call('aiStartTour');
        } catch (_) {
            tour = null;
        }
        if (tour && tour.ok) return tour;
        const pane = !!(root._canvasSlot || root._canvasSlotSecond);
        route = !pane && root.assistantDock === 'main' ? 'thread' : null;
        decision = {
            ...decision,
            surface: route ? 'thread' : 'drawer',
            route: route,
            switched: false
        };
    }
    // A WEBSITE goes to the site builder the sites lane registers
    // (functions/assistantOpenSiteBuilder.js: the text, then the image bag and
    // the turn's attachment).
    if (route === 'site') {
        el.call('assistantAskNotify', decision);
        return el.call('assistantOpenSiteBuilder', trimmed, {
            images: attachments,
            attached: attached
        });
    }
    // FLY (docs/FLY_MODE.md): the ask becomes the next page of the session —
    // never the chat bridge (one fast call; a board on a server without the
    // fly shape).
    if (route === 'fly') {
        // In a call with Fly on, on the call: the ask is the CALL's — its page
        // goes to everyone's theater (meet functions/meetFly.js).
        // An ask with files stays the person's own (a call's page carries no
        // attachments).
        const hasFiles = Array.isArray(attachments) && attachments.length > 0 || Array.isArray(attached) && attached.length > 0;
        if (!hasFiles && fns && typeof fns.meetFlyComposerShared === 'function' && el.call('meetFlyComposerShared', root)) return el.call('meetFlyAsk', {
            prompt: trimmed
        });
        // FLY CALLS (Nika 2026-10-23: "add calling mode into fly so you can call
        // to anyone in workspace"): an ask that names ONE member — "call Nika" —
        // calls them (functions/assistantFlyPeople.js); any other ask composes
        // its page.
        if (!hasFiles && fns && typeof fns.assistantFlyCallIntent === 'function') {
            const callee = el.call('assistantFlyCallIntent', root, trimmed);
            if (callee) return el.call('assistantFlyCallPerson', callee);
        }
        if (decision) el.call('assistantAskNotify', decision);
        return el.call('assistantFlyGenerate', {
            prompt: trimmed,
            attachments: attachments,
            attached: attached
        });
    }
    if (route === 'board' || route === 'deck') {
        // In a call with Fly on, on the call: a Dashboard or Presentation ask is
        // the CALL's too — its board (as a page) or its slides go to everyone's
        // theater, like a Fly page (Nika 2026-10-18, "main mode is theater in
        // different modes"). An ask with files stays the person's own.
        const views = el.context && el.context.functions;
        const withFiles = Array.isArray(attachments) && attachments.length > 0 || Array.isArray(attached) && attached.length > 0;
        if (!withFiles && views && typeof views.meetFlyComposerShared === 'function' && el.call('meetFlyComposerShared', root)) return el.call('meetFlyAsk', {
            prompt: trimmed,
            kind: route
        });
        try {
            el.call('assistantMainThreadClose');
        } catch (_) {
        /* no thread view on this surface — nothing to step aside */ }
        // A call's theater steps aside too (one view holds the main layer).
        if (views && typeof views.meetFlyTheater === 'function') el.call('meetFlyTheater', false);
        if (decision) el.call('assistantAskNotify', decision);
        return el.call(route === 'deck' ? 'assistantDeckGenerate' : 'assistantBoardGenerate', {
            prompt: trimmed,
            attachments: attachments,
            attached: attached
        });
    }
    // Boot race — a prompt sent in the first seconds after load could hit a
    // root that isn't wired yet (or a transport that hasn't installed) and was
    // SILENTLY DROPPED: the composer cleared, nothing happened (verified live
    // 2026-07-24 on /w/bellforge — the first prompt after reload vanished).
    // User input is never disposable: retry briefly until the shell is ready
    // instead of eating the message. ~8 × 500ms ≈ 4s covers the boot window.
    const ready = root && typeof root.update === 'function' && typeof window !== 'undefined' ? typeof window.__simoneSendOverBridge === 'function' : false;
    if (!ready) {
        if (_attempt < 8) setTimeout(()=>{
            try {
                $343c5ae67e662b7a$export$302aee1b865f8b6a.call(el, trimmed, attachments, _attempt + 1, attached, opts);
            } catch (_) {
            /* element torn down — nothing to retry against */ }
        }, 500);
        else console.warn("[homeAiSend] dropped prompt \u2014 shell/transport never became ready:", trimmed);
        return;
    }
    if (buildApp) {
        // ON THE HOME the Build tab IS the builder (functions/homeBuild.js): the
        // home's view moves there first — the tabs' local form, nothing persists —
        // so the build shows from its first line. Only with the main placement (a
        // tab would move the placement too).
        if (decision && root.assistantDock === 'main' && typeof fns.homeTabsOnScreen === 'function' && typeof fns.homeViewSelect === 'function' && el.call('homeTabsOnScreen', root)) el.call('homeViewSelect', 'build');
        if (decision) el.call('assistantAskNotify', decision);
        return el.call('forceBuildApp', trimmed, attachments, attached);
    }
    // The ask's own mode for a chat turn: the panel's, or the router's (a turn
    // that leaves a page, a board or a deck view answers as the Assistant).
    const turnMode = decision ? decision.mode : askMode;
    // THE MAIN THREAD: the turn renders in the MainColumn, never the drawer —
    // the thread view is up before the user message lands, so the reasoning
    // pill and the suggestion island step aside for it (`_homeThreadOpen`).
    if (route === 'thread') {
        try {
            el.call('assistantMainThreadShow');
            if (decision) el.call('assistantAskNotify', decision);
            el.call('sendPrompt', trimmed, undefined, undefined, attached, turnMode ? {
                mode: turnMode
            } : undefined);
        } catch (err) {
            console.warn('[homeAiSend] main-thread send failed:', err?.message || err);
        }
        return;
    }
    // Open the AssistantDrawer + dispatch through simone's sendPrompt.
    // That function builds the user message, snapshots it into
    // root.chatMessages, flips chatTyping:true, and calls
    // window.__simoneSendOverBridge — which workspace's
    // installSimoneAiTransport adapter routes to sdk.ai.dispatch with the
    // active provider mode (simone / providers / local) + intent
    // classification. The transport adapter also handles the action /
    // build / answer intent fan-out (writing _aiActionProposals for the
    // confirmation card, freestyleBuildSpec for the freestyler) so this
    // function stays a thin entry point.
    //
    // The legacy `assistantMessages` slot stays declared in state for
    // back-compat but is no longer written here — simone Chat reads
    // chatMessages exclusively.
    // The docked AssistantDrawer (left / right / minimized) is the single AI
    // surface on EVERY route including home (per Nika 2026-07-19 — the inline
    // dashboard thread is retired). A page open in the PageSlot suppresses the
    // drawer so the compact SimoneReasoningPill surfaces the turn above the
    // composer, over the page; otherwise the docked drawer opens (or, when the
    // user left it minimized, the pill shows the turn). Either way the turn runs
    // in the general scope, so the drawer's Chat + the pill both surface it. Clear
    // any lingering inline-thread flag so the retired thread can't re-appear.
    try {
        const pageSlotOpen = !!(root._canvasSlot || root._canvasSlotSecond);
        // ...but never force-CLOSE a drawer the user already has open — sending
        // should append to it, not collapse it mid-conversation. Only pageSlot-
        // suppress the OPEN when the drawer isn't already showing.
        const suppressed = pageSlotOpen && !root.assistantOpen;
        // When the drawer IS suppressed the pill is the turn's only surface, so it
        // has to become a PERSISTENT handle for it. The pill's own visibility rule
        // is "show while the turn is live, or while the assistant is open+minimized"
        // — neither held here, so the pill disappeared the moment the turn finished
        // and the message the user had just sent (plus the answer) became
        // unreachable: no thread entry, no error, nothing (natali QA 2026-07-27).
        // This flag is the third handle case, and it is what makes the suppression
        // an intentional SMALL surface rather than no surface at all.
        root.update({
            assistantOpen: root.assistantOpen || !pageSlotOpen,
            _assistantPillHandle: suppressed || root._assistantPillHandle,
            _homeThreadOpen: false
        });
        if (decision) el.call('assistantAskNotify', decision);
        // `undefined` for scope + images: this entry point has no picker and the
        // turn is general-scoped. Named positionally so `attached` lands in
        // sendPrompt's fourth slot (see its signature note); the ask's own mode
        // (opts above) rides the fifth.
        el.call('sendPrompt', trimmed, undefined, undefined, attached, turnMode ? {
            mode: turnMode
        } : undefined);
    } catch (err) {
        console.warn('[homeAiSend] sendPrompt failed:', err?.message || err);
    }
}

});

parcelRegister("dp7M8", function(module, exports) {

$parcel$export(module.exports, "setAssistantDock", () => $9c23a4342af0d1fd$export$af9e03f4a27a82eb);
$parcel$export(module.exports, "setAssistantAnswersMode", () => $9c23a4342af0d1fd$export$3e59129eef5f613f);
$parcel$export(module.exports, "lastAssistantSide", () => $9c23a4342af0d1fd$export$97a1f7422a34bcbe);
$parcel$export(module.exports, "readStoredAssistantDock", () => $9c23a4342af0d1fd$export$5193e27f66e7f028);
$parcel$export(module.exports, "answersModeOf", () => $9c23a4342af0d1fd$export$bfceabc89ef73da4);
$parcel$export(module.exports, "dockForAnswersMode", () => $9c23a4342af0d1fd$export$f9c6f718ff58c196);
$parcel$export(module.exports, "reconcileAssistantDockFromPrefs", () => $9c23a4342af0d1fd$export$8122ab6c54c993cb);
$parcel$export(module.exports, "assistantDockStamp", () => $9c23a4342af0d1fd$export$7319a9272edbf5fc);
$parcel$export(module.exports, "promoteAssistantDockForOpen", () => $9c23a4342af0d1fd$export$c952793aa6908a75);
$parcel$export(module.exports, "restoreAssistantDockOnClose", () => $9c23a4342af0d1fd$export$e5ebc30c5c44a0d);
// assistantDock.js — WHERE THE ASSISTANT'S ANSWERS GO (ASSISTANT_BOARD_MODE_SPEC
// §1; WS-W2-ASSISTANT-PAGE-MODE-DOCK-1, umbrella DESIGN-WL-ASSISTANT-MAIN-MODE-1;
// Nika 2026-09-27 "go all recommended").
//
// ONE state key, `root.assistantDock`:
//   'right' | 'left'  SIDEBAR — the flat docked drawer on that edge
//   'minimized'       MINIMIZED — the bottom pill
//   'main'            PAGE — the main thread over the home's grid area (the
//                     DEFAULT, Nika's pick 6 A; AI_ASSISTANT_SPEC v1 §1), never
//                     in the drawer; nothing reserves a column. A placement:
//                     it needs no board service — only the Dashboard MODE does
// The UI speaks in three ANSWER MODES — Page · Sidebar · Minimized — so the
// sidebar's SIDE is its own small memory (the last edge the user docked to).
//
// PERSISTED PER USER with the theme mode's discipline (shared themeMode.js):
// localStorage paints first (`symbols_assistant_dock`, `symbols_assistant_side`);
// the `user_preferences` row (`assistantDock`) follows the user to every
// device. The record wins once it has loaded; a local choice with no record
// migrates up — only a CHOICE: a person's pick marks itself on the device
// (`symbols_assistant_dock_explicit`), and an unmarked stored value is an old
// default the shell once kept (before Page became the default) that neither
// paints nor copies up (Nika 2026-09-30: on a second device the sidebar won
// over the empty record and would have spread to every device). With no
// record and no marked choice the placement is the default, 'main' — never
// written up. The prefs `update` REPLACES the row, so every write obeys the
// home-prefs durability law (functions/homeLook.js; setAssistantMode): single-
// flight on the queue every writer of the row shares, the payload composed
// from the LIVE row at send time, an unloaded row READ first, the newest
// decision last — and never a partial copy of the row in the state.
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained — the few literals are restated.
// setAssistantDock(value) via el.call — or setAssistantDock(root, value, sdk)
// from shell code. Writes the state key, remembers the side, persists the
// choice locally and to the user record. An explicit choice also ends a
// session promotion (see promoteAssistantDockForOpen). Returns the record
// write (a promise; null on failure) when an SDK is at hand.
// The shell form takes `{ recordOnly: true }` fourth: the boot migrate, where
// the state and this device already hold the choice — only the record write
// runs (a live session promotion stays untouched).
function $9c23a4342af0d1fd$export$af9e03f4a27a82eb(a, b, c, d) {
    const docks = [
        'right',
        'left',
        'minimized',
        'main'
    ];
    const viaCall = typeof a === 'string' || a == null;
    const value = viaCall ? a : b;
    const self = this && typeof this === 'object' ? this : null;
    const root = viaCall ? self && self.state && self.state.root || null : a;
    const sdk = viaCall ? self && (self.sdk || self.context && self.context.sdk) || null : c || null;
    const recordOnly = !viaCall && !!(d && d.recordOnly);
    if (!docks.includes(value)) {
        // AI-308 — a silent ignore cost a live-test cycle once (a caller passed
        // 'docked' and nothing moved, with no signal why).
        console.warn(`[shell] setAssistantDock ignored invalid value "${String(value)}" \u{2014} ` + "accepted values: 'left' | 'right' | 'minimized' | 'main'");
        return;
    }
    if (!root || typeof root.update !== 'function') return;
    // The loaded copy follows at once — ONLY when the row has loaded. A partial
    // `{ assistantDock }` copy of an unloaded row would read as the whole row to
    // the next writer, which sends it and erases every other stored preference
    // (the data-loss defect: a cold boot, or the window after a workspace switch
    // wipes `userPrefs`).
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    if (!recordOnly) {
        const patch = {
            assistantDock: value,
            _assistantDockPromotedFrom: null
        };
        if (prefs && prefs.assistantDock !== value) patch.userPrefs = {
            ...prefs,
            assistantDock: value
        };
        root.update(patch, {
            preventFetch: true
        });
        try {
            if (typeof localStorage !== 'undefined') {
                localStorage.setItem('symbols_assistant_dock', value);
                // the MARK: a person chose this (readStoredAssistantDock reads only
                // marked values; the boot migrate copies only them up)
                localStorage.setItem('symbols_assistant_dock_explicit', '1');
                if (value === 'left' || value === 'right') localStorage.setItem('symbols_assistant_side', value);
            }
        } catch (err) {
            console.warn('[shell] assistant-dock persist failed:', err && err.message);
        }
    }
    // Every explicit choice is SENT, the active value included: the loaded copy
    // can be stale (a boot read that predates an earlier write lands after it),
    // so "the copy already says so" proves nothing about the record. The write
    // is idempotent; a burst collapses to its newest decision below.
    if (!sdk || typeof sdk.execute !== 'function') return;
    // The queue every user_preferences writer shares, keyed as they key it.
    const w = root.workspace;
    const key = String(w && (w.id || w._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '') || 'user';
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    root.__assistantDockSeq = (root.__assistantDockSeq || 0) + 1;
    const seq = root.__assistantDockSeq;
    const prior = queue.get(key) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        // A decision superseded while it waited sends nothing.
        if (seq !== root.__assistantDockSeq) return null;
        // PER-PATH PATCH — names only `assistantDock`, so a second tab's write
        // to any OTHER key is never overwritten (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: {
                set: {
                    assistantDock: value
                }
            }
        });
        // Adopt the confirmed row only when no newer decision waits.
        if (seq === root.__assistantDockSeq) {
            const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
            root.update({
                userPrefs: now ? {
                    ...now,
                    assistantDock: value
                } : row && typeof row === 'object' ? row : {
                    assistantDock: value
                }
            }, {
                preventFetch: true
            });
        }
        return row;
    });
    queue.set(key, task);
    return task.catch((err)=>{
        console.warn('[shell] user_preferences assistantDock save failed:', err && err.message);
        return null;
    });
}
function $9c23a4342af0d1fd$export$3e59129eef5f613f(mode) {
    let side = 'right';
    try {
        const store = typeof localStorage !== 'undefined' ? localStorage : null;
        if (store && store.getItem('symbols_assistant_side') === 'left') side = 'left';
    } catch (_) {
        side = 'right';
    }
    const dock = mode === 'page' ? 'main' : mode === 'minimized' ? 'minimized' : side;
    if (this && typeof this.call === 'function') return this.call('setAssistantDock', dock);
}
const $9c23a4342af0d1fd$export$97a1f7422a34bcbe = (storage)=>{
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const side = store ? store.getItem('symbols_assistant_side') : null;
        return side === 'left' ? 'left' : 'right';
    } catch (_) {
        return 'right';
    }
};
const $9c23a4342af0d1fd$export$5193e27f66e7f028 = (storage)=>{
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        if (!store || store.getItem('symbols_assistant_dock_explicit') !== '1') return null;
        const v = store.getItem('symbols_assistant_dock');
        return [
            'right',
            'left',
            'minimized',
            'main'
        ].includes(v) ? v : null;
    } catch (_) {
        return null;
    }
};
const $9c23a4342af0d1fd$export$bfceabc89ef73da4 = (dock)=>dock === 'main' ? 'page' : dock === 'minimized' ? 'minimized' : 'sidebar';
const $9c23a4342af0d1fd$export$f9c6f718ff58c196 = (mode, side)=>mode === 'page' ? 'main' : mode === 'minimized' ? 'minimized' : side === 'left' ? 'left' : 'right';
const $9c23a4342af0d1fd$export$8122ab6c54c993cb = (currentDock, prefs, storedDock)=>{
    const docks = [
        'right',
        'left',
        'minimized',
        'main'
    ];
    const norm = (v)=>docks.includes(v) ? v : null;
    const recorded = norm(prefs && typeof prefs === 'object' ? prefs.assistantDock : null);
    if (recorded) return recorded !== currentDock ? {
        apply: recorded
    } : null;
    const local = norm(storedDock);
    return local ? {
        migrate: local
    } : null;
};
const $9c23a4342af0d1fd$export$7319a9272edbf5fc = (root)=>{
    const r = root || {};
    const dock = r.assistantDock;
    if (!r.assistantOpen) return dock === 'main' ? 'main' : 'closed';
    return dock === 'left' || dock === 'minimized' ? dock : 'right';
};
const $9c23a4342af0d1fd$export$c952793aa6908a75 = (root, side, opts)=>{
    const r = root || {};
    if (r.assistantDock === 'minimized') return {
        assistantDock: 'right'
    };
    if (r.assistantDock === 'main') {
        const builder = typeof r.currentPath === 'string' && /^(?:\/w\/[a-z0-9-]{1,48}(?:\/(?!p(?:[/?#]|$))[A-Za-z0-9_-]{1,64})?)?\/preview(?:[/?#]|$)/.test(r.currentPath);
        if (r._canvasSlot || r._canvasSlotSecond || opts && opts.overlay || builder) return {
            assistantDock: side === 'left' ? 'left' : 'right',
            _assistantDockPromotedFrom: 'main'
        };
        const path = typeof r.currentPath === 'string' && r.currentPath ? r.currentPath : '/';
        return {
            assistantOpen: false,
            _homeThreadOpen: true,
            _mainThreadPath: path
        };
    }
    return null;
};
const $9c23a4342af0d1fd$export$e5ebc30c5c44a0d = (root)=>{
    const r = root || {};
    return r._assistantDockPromotedFrom === 'main' ? {
        assistantDock: 'main',
        _assistantDockPromotedFrom: null
    } : null;
};

});

parcelRegister("ik7KJ", function(module, exports) {

$parcel$export(module.exports, "setAssistantMode", () => $d5701bcb4cb8c7c5$export$daf5794254b706bf);
$parcel$export(module.exports, "readStoredAssistantMode", () => $d5701bcb4cb8c7c5$export$7e6cfa90c08d2236);
$parcel$export(module.exports, "assistantModeBeforeFly", () => $d5701bcb4cb8c7c5$export$75ac62b1a1d7a4be);
$parcel$export(module.exports, "assistantModeOf", () => $d5701bcb4cb8c7c5$export$5120174928227ae6);
$parcel$export(module.exports, "reconcileAssistantModeFromPrefs", () => $d5701bcb4cb8c7c5$export$551c8741eb7e3b09);
// assistantMode.js — WHAT THE ASSISTANT PRODUCES (AI_ASSISTANT_SPEC v1 §1 and
// §12.1; DESIGN-WL-ASSISTANT-MAIN-VIEW-1). Nika 2026-09-29: "dropdown should
// contain [Assistant, Dashboard, Tools (platform apps), Apps (frontend),
// Presentation]" — five modes, a CLOSED vocabulary on the client and the server.
//
// ONE state key, `root.assistantMode`:
//   'assistant'     ASSISTANT — a conversation; each answer is text plus
//                   embedded, live UI blocks (the default until 2026-10-22;
//                   now the mode the home's Dashboard gives back when no
//                   mode before Fly is known, functions/homeView.js)
//   'dashboard'     DASHBOARD — a generated board of widgets (the ai.boards
//                   path, functions/assistantBoard.js: one fast call, no tools)
//   'tools'         TOOLS — work INSIDE the installed platform apps: open the
//                   right app page with filters, run app actions, find and
//                   install store apps (every write confirmed)
//   'apps'          APPS — a FRONTEND app: a small app surface built inside
//                   this workspace (create_extension), previewed inline, then
//                   "Save as app"; a full app project only when asked
//   'presentation'  PRESENTATION — a live deck (the ai.boards deck shape,
//                   functions/assistantDeck.js: one fast call, no tools)
//   'fly'           FLY — every ask composes a PAGE, like a Fly site
//                   (keepz--fly): eyebrow + title, a checked opening, live
//                   sections, follow-ups, one session of pages (functions/
//                   assistantFly.js; the ai.boards fly shape). THE DEFAULT:
//                   Nika 2026-10-17, "fly mode will run as mode for now,
//                   later we can make it default"; 2026-10-22, "ok make fly
//                   default view" — a person who never chose a mode is in Fly
//                   mode, and their home opens on Fly (functions/homeView.js).
// The chip shipped to dev only, so a stored 'apps' simply means frontend apps
// now (no migration, §12.1). MODE is WHAT the AI produces; PLACEMENT
// (`assistantDock`, functions/assistantDock.js) is WHERE it shows.
//
// PERSISTED PER USER: localStorage paints first (`symbols_assistant_mode`);
// the `user_preferences` row (`assistantMode`) follows the person to every
// device. The record wins once it has loaded; a local choice with no record
// migrates up (loadPrivateData).
//
// WRITES ARE DECISIONS (the home-prefs durability law, functions/homeLook.js):
// at once, never debounced, SINGLE-FLIGHT on the queue every writer of the
// user_preferences row shares (`root.__navbarSaveQueue` — the navbar tabs, the
// assistant starters, the home look), keyed the way they key it. The update
// REPLACES the row, so the payload is composed at SEND time from the live row
// (a click-time payload would drop what another writer landed meanwhile); a
// row that has not loaded is read first (a write never replaces the account's
// other preferences with one key); a decision superseded while it waited sends
// nothing (the newest one lands last); the confirmed value is adopted only
// when no newer decision waits.
//
// AN EXPLICIT CHOICE WINS OVER EVERY DEFAULT: this writer is the only thing
// that sets the key. The AI may answer ONE ask in another mode when the ask is
// clearly a board or an app action (and it says so) — that is a per-answer
// route in homeAiSend, never a write here.
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained — the few literals are restated.
// setAssistantMode(mode) via el.call — or setAssistantMode(root, mode, sdk)
// from shell code. The mode chip (design-d2, packages/shared) reads
// `root.assistantMode` and calls `el.call('setAssistantMode', mode)`.
//
// `{ local: true }` (el.call('setAssistantMode', mode, { local: true }), or the
// 4th argument from shell code) is a HOME TAB, not a choice (BLD-13, Nika
// 2026-10-25: "Change only the home view"): the live mode and its Fly side
// effects, nothing persisted — no record, no device cache, no "before Fly".
// The home's tabs (functions/homeView.js) hold that view in `_homeMode` and
// homeModeSync gives the person's own pick back off the home. Every other
// call is a choice: it persists, and it ends a home view (`_homeMode: null`).
function $d5701bcb4cb8c7c5$export$daf5794254b706bf(a, b, c, d) {
    const modes = [
        'assistant',
        'dashboard',
        'tools',
        'apps',
        'presentation',
        'fly'
    ];
    const viaCall = typeof a === 'string' || a == null;
    const value = viaCall ? a : b;
    const opts = (viaCall ? b : d) || null;
    const local = !!(opts && typeof opts === 'object' && opts.local);
    const self = this && typeof this === 'object' ? this : null;
    const root = viaCall ? self && self.state && self.state.root || null : a;
    const sdk = viaCall ? self && (self.sdk || self.context && self.context.sdk) || null : c || null;
    if (!modes.includes(value)) {
        // A silent ignore costs a live-test cycle (the dock's AI-308 lesson): say
        // what was refused and what is accepted.
        console.warn(`[shell] setAssistantMode ignored invalid value "${String(value)}" \u{2014} ` + "accepted values: 'assistant' | 'dashboard' | 'tools' | 'apps' | 'presentation' | 'fly'");
        return;
    }
    if (!root || typeof root.update !== 'function') return;
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    const previousMode = root.assistantMode;
    const previousFlyWorkspace = root._aiFlyWorkspace;
    const patch = {
        assistantMode: value
    };
    if (!local) {
        if (prefs && prefs.assistantMode !== value) patch.userPrefs = {
            ...prefs,
            assistantMode: value
        };
        if (root._homeMode) patch._homeMode = null;
    }
    root.update(patch, {
        preventFetch: true
    });
    const fns = self && self.context && self.context.functions || {};
    if (self && typeof self.call === 'function') {
        // A stored mode can also enter through the shell mount. If that reactive
        // edge already initialized Fly during update, do not repeat its prompt.
        if (value === 'fly' && root._aiFlyWorkspace === previousFlyWorkspace && typeof fns.assistantFlyWorkspaceEnter === 'function') self.call('assistantFlyWorkspaceEnter');
        if (value !== 'fly' && previousMode === 'fly') {
            if (typeof fns.assistantFlyWorkspaceClose === 'function') self.call('assistantFlyWorkspaceClose');
            if (typeof fns.assistantFlyClose === 'function') self.call('assistantFlyClose');
        }
    }
    if (local) return;
    try {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('symbols_assistant_mode', value);
            // The mode Fly was entered FROM, so the home's Dashboard choice can give
            // it back (functions/homeView.js homeViewSelect). A per-device
            // convenience: on another device Dashboard falls back to 'assistant'.
            if (value === 'fly' && modes.includes(previousMode) && previousMode !== 'fly') localStorage.setItem('symbols_assistant_mode_before_fly', previousMode);
        }
    } catch (err) {
        console.warn('[shell] assistant-mode cache write failed:', err && err.message);
    }
    // Every explicit choice is SENT, the active value included: the loaded copy
    // of the row can be stale (a boot read that predates an earlier write lands
    // after it), so "the copy already says so" proves nothing about the record.
    // The write is idempotent; a burst collapses to its newest decision below.
    if (!sdk || typeof sdk.execute !== 'function') return;
    const w = root.workspace;
    const key = String(w && (w.id || w._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '') || 'user';
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    root.__assistantModeSeq = (root.__assistantModeSeq || 0) + 1;
    const seq = root.__assistantModeSeq;
    const prior = queue.get(key) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        if (seq !== root.__assistantModeSeq) return null;
        // PER-PATH PATCH — names only `assistantMode`, so a second tab's write to
        // any OTHER key never gets overwritten (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: {
                set: {
                    assistantMode: value
                }
            }
        });
        if (seq === root.__assistantModeSeq) {
            const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
            root.update({
                userPrefs: now ? {
                    ...now,
                    assistantMode: value
                } : row && typeof row === 'object' ? row : {
                    assistantMode: value
                }
            }, {
                preventFetch: true
            });
        }
        return row;
    });
    queue.set(key, task);
    return task.catch((err)=>{
        console.warn('[shell] user_preferences assistantMode save failed:', err && err.message);
        return null;
    });
}
const $d5701bcb4cb8c7c5$export$7e6cfa90c08d2236 = (storage)=>{
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const v = store ? store.getItem('symbols_assistant_mode') : null;
        return [
            'assistant',
            'dashboard',
            'tools',
            'apps',
            'presentation',
            'fly'
        ].includes(v) ? v : null;
    } catch (_) {
        return null;
    }
};
const $d5701bcb4cb8c7c5$export$75ac62b1a1d7a4be = (storage)=>{
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const v = store ? store.getItem('symbols_assistant_mode_before_fly') : null;
        return [
            'assistant',
            'dashboard',
            'tools',
            'apps',
            'presentation'
        ].includes(v) ? v : 'assistant';
    } catch (_) {
        return 'assistant';
    }
};
const $d5701bcb4cb8c7c5$export$5120174928227ae6 = (root)=>{
    const v = root && typeof root === 'object' ? root.assistantMode : null;
    return [
        'assistant',
        'dashboard',
        'tools',
        'apps',
        'presentation',
        'fly'
    ].includes(v) ? v : 'fly';
};
const $d5701bcb4cb8c7c5$export$551c8741eb7e3b09 = (currentMode, prefs, storedMode)=>{
    const modes = [
        'assistant',
        'dashboard',
        'tools',
        'apps',
        'presentation',
        'fly'
    ];
    const norm = (v)=>modes.includes(v) ? v : null;
    const recorded = norm(prefs && typeof prefs === 'object' ? prefs.assistantMode : null);
    if (recorded) return recorded !== currentMode ? {
        apply: recorded
    } : null;
    const local = norm(storedMode);
    return local ? {
        migrate: local
    } : null;
};

});

parcelRegister("14aeZ", function(module, exports) {

$parcel$export(module.exports, "clampAssistantWidth", () => $0c6e1bc1cc427112$export$5ea145ff4d0b324c);
$parcel$export(module.exports, "assistantWidthForKey", () => $0c6e1bc1cc427112$export$176bf2980aa7b977);
$parcel$export(module.exports, "readStoredAssistantWidth", () => $0c6e1bc1cc427112$export$9bd83863733b563a);
$parcel$export(module.exports, "reconcileAssistantWidthFromPrefs", () => $0c6e1bc1cc427112$export$c1cd041743f3f7f6);
$parcel$export(module.exports, "setAssistantWidth", () => $0c6e1bc1cc427112$export$48df46a7d2398acb);
// assistantWidth.js — THE DOCKED SIDEBAR'S WIDTH, remembered per person
// (AI_ASSISTANT_SPEC v1 §8 "Sidebar … adjustable width"; Nika's pick 7 A;
// DESIGN-WL-ASSISTANT-MAIN-VIEW-1, lane current-23-assistant).
//
// `root.assistantWidth` (px, null = the default 640) is the drawer's width —
// the shell publishes it to `--assistant-width` for the drawer AND the content
// column it reserves (app.js). The drag and the keyboard (Arrow keys step,
// Home / End jump to the bounds) change it LIVE; the width is REMEMBERED when
// the gesture ends: localStorage paints first (`symbols_assistant_width`), the
// `user_preferences` row (`assistantWidth`) follows the person to every
// device, the record wins at boot and a local width with no record migrates
// up. Writes follow the home-prefs durability law (single-flight on the shared
// prefs queue, the payload composed from the live row at send time, an
// unloaded row read first, the newest decision last).
//
// Bounds: 320 px (the drawer's narrowest readable column) to half the
// viewport — the same clamp the drag always enforced.
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained — the bounds are restated.
// A width inside the bounds for a viewport `vw` (px), or null for "the default".
const $0c6e1bc1cc427112$export$5ea145ff4d0b324c = (value, vw)=>{
    const n = Math.round(Number(value));
    if (!Number.isFinite(n) || n <= 0) return null;
    const view = Number(vw) > 0 ? Number(vw) : 1200;
    const max = Math.max(320, Math.floor(view * 0.5));
    return Math.max(320, Math.min(max, n));
};
const $0c6e1bc1cc427112$export$176bf2980aa7b977 = (current, key, opts)=>{
    const o = opts || {};
    const view = Number(o.vw) > 0 ? Number(o.vw) : 1200;
    const max = Math.max(320, Math.floor(view * 0.5));
    const now = Number(current) > 0 ? Number(current) : 640;
    const step = o.shift ? 120 : 24;
    const widen = o.dock === 'left' ? 'ArrowRight' : 'ArrowLeft';
    const narrow = o.dock === 'left' ? 'ArrowLeft' : 'ArrowRight';
    let next = null;
    if (key === widen) next = now + step;
    else if (key === narrow) next = now - step;
    else if (key === 'Home') next = 320;
    else if (key === 'End') next = max;
    if (next === null) return null;
    return Math.max(320, Math.min(max, Math.round(next)));
};
const $0c6e1bc1cc427112$export$9bd83863733b563a = (storage)=>{
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const v = Number(store ? store.getItem('symbols_assistant_width') : null);
        return Number.isFinite(v) && v >= 320 ? Math.round(v) : null;
    } catch (_) {
        return null;
    }
};
const $0c6e1bc1cc427112$export$c1cd041743f3f7f6 = (current, prefs, stored)=>{
    const norm = (v)=>{
        const n = Math.round(Number(v));
        return Number.isFinite(n) && n >= 320 ? n : null;
    };
    const recorded = norm(prefs && typeof prefs === 'object' ? prefs.assistantWidth : null);
    if (recorded) return recorded !== norm(current) ? {
        apply: recorded
    } : null;
    const local = norm(stored);
    return local ? {
        migrate: local
    } : null;
};
function $0c6e1bc1cc427112$export$48df46a7d2398acb(a, b, c) {
    const viaCall = typeof a === 'number' || a == null;
    const raw = viaCall ? a : b;
    const self = this && typeof this === 'object' ? this : null;
    const root = viaCall ? self && self.state && self.state.root || null : a;
    const sdk = viaCall ? self && (self.sdk || self.context && self.context.sdk) || null : c || null;
    if (!root || typeof root.update !== 'function') return null;
    const vw = typeof window !== 'undefined' && window.innerWidth ? window.innerWidth : 1200;
    const n = Math.round(Number(raw));
    if (!Number.isFinite(n) || n <= 0) return null;
    const value = Math.max(320, Math.min(Math.max(320, Math.floor(vw * 0.5)), n));
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    const patch = {
        assistantWidth: value
    };
    if (prefs && prefs.assistantWidth !== value) patch.userPrefs = {
        ...prefs,
        assistantWidth: value
    };
    root.update(patch, {
        preventFetch: true
    });
    try {
        if (typeof localStorage !== 'undefined') localStorage.setItem('symbols_assistant_width', String(value));
    } catch (err) {
        console.warn('[shell] assistant-width cache write failed:', err && err.message);
    }
    if (!sdk || typeof sdk.execute !== 'function') return null;
    const w = root.workspace;
    const key = String(w && (w.id || w._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '') || 'user';
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    root.__assistantWidthSeq = (root.__assistantWidthSeq || 0) + 1;
    const seq = root.__assistantWidthSeq;
    const prior = queue.get(key) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        if (seq !== root.__assistantWidthSeq) return null;
        // PER-PATH PATCH — names only `assistantWidth` (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: {
                set: {
                    assistantWidth: value
                }
            }
        });
        if (seq === root.__assistantWidthSeq) {
            const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
            root.update({
                userPrefs: now ? {
                    ...now,
                    assistantWidth: value
                } : row && typeof row === 'object' ? row : {
                    assistantWidth: value
                }
            }, {
                preventFetch: true
            });
        }
        return row;
    });
    queue.set(key, task);
    return task.catch((err)=>{
        console.warn('[shell] user_preferences assistantWidth save failed:', err && err.message);
        return null;
    });
}

});

parcelRegister("azpxa", function(module, exports) {

$parcel$export(module.exports, "INBOUND_PROMPT_PARAM", () => $7b20facbdc0c49a4$export$ae8df78402fe748e);
$parcel$export(module.exports, "INBOUND_PROMPT_MAX_LENGTH", () => $7b20facbdc0c49a4$export$2f1c90c46f4622d4);
$parcel$export(module.exports, "parseInboundPrompt", () => $7b20facbdc0c49a4$export$4a8128d6594cf7d6);
$parcel$export(module.exports, "inboundPromptForBuilder", () => $7b20facbdc0c49a4$export$51dab077a6c5536a);
$parcel$export(module.exports, "stripInboundPromptParam", () => $7b20facbdc0c49a4$export$94352f153eadc582);
$parcel$export(module.exports, "INBOUND_PROMPT_PARK_KEY", () => $7b20facbdc0c49a4$export$d1977348bcc12ad6);
$parcel$export(module.exports, "INBOUND_PROMPT_PARK_MAX_AGE_MS", () => $7b20facbdc0c49a4$export$f5f34fef576294e7);
$parcel$export(module.exports, "parkInboundPrompt", () => $7b20facbdc0c49a4$export$757986732f08e49f);
$parcel$export(module.exports, "takeParkedInboundPrompt", () => $7b20facbdc0c49a4$export$153e1698ee610a7c);
$parcel$export(module.exports, "receiveInboundPrompt", () => $7b20facbdc0c49a4$export$86e08a6bfaa932d9);
// The landing hands a visitor's sentence to the workspace as `?prompt=<text>`
// (company/packages/landing's PromptBar.js + the hero composer's
// RevealEndCard.js — both `window.location.href =
// 'https://my.symbols.app/?prompt=' + encodeURIComponent(sentence)`, landing's
// side of WS-WORKSPACE-CONSUMES-THE-PROMPT-QUERY-FROM-THE-LANDING-HERO-
// COMPOSER-1). `prompt` is the coordinated param name — a rename needs both
// sides. Framework-free (no `window`/DOMQL reference) so it unit-tests with
// no DOM shim; the shell-root CanvasPromptTextarea mount (app.js) is the only
// caller.
const $7b20facbdc0c49a4$export$ae8df78402fe748e = 'prompt';
const $7b20facbdc0c49a4$export$2f1c90c46f4622d4 = 2000;
const $7b20facbdc0c49a4$export$4a8128d6594cf7d6 = (search)=>{
    const raw = new URLSearchParams(search || '').get($7b20facbdc0c49a4$export$ae8df78402fe748e);
    if (!raw) return null;
    const text = raw.trim().slice(0, $7b20facbdc0c49a4$export$2f1c90c46f4622d4);
    return text || null;
};
const $7b20facbdc0c49a4$export$51dab077a6c5536a = (path)=>/^(\/w\/[a-z0-9-]{1,48}(\/[A-Za-z0-9_-]{1,64})?)?\/add-app(\/|$)/.test(String(path || '').split(/[?#]/)[0]);
const $7b20facbdc0c49a4$export$94352f153eadc582 = (href)=>{
    const url = new URL(href);
    url.searchParams.delete($7b20facbdc0c49a4$export$ae8df78402fe748e);
    return url.toString();
};
const $7b20facbdc0c49a4$export$d1977348bcc12ad6 = 'symbols_inbound_prompt';
const $7b20facbdc0c49a4$export$f5f34fef576294e7 = 600000;
const $7b20facbdc0c49a4$export$757986732f08e49f = (text, storage, now = Date.now())=>{
    if (!text || !storage) return false;
    try {
        storage.setItem($7b20facbdc0c49a4$export$d1977348bcc12ad6, JSON.stringify({
            text: String(text).slice(0, $7b20facbdc0c49a4$export$2f1c90c46f4622d4),
            at: now
        }));
        return true;
    } catch (_) {
        // A sandboxed frame or a full quota — the sentence is not held, and the
        // caller keeps `?prompt=` in the address bar rather than eating it.
        return false;
    }
};
const $7b20facbdc0c49a4$export$153e1698ee610a7c = (storage, now = Date.now())=>{
    if (!storage) return null;
    let raw = null;
    try {
        raw = storage.getItem($7b20facbdc0c49a4$export$d1977348bcc12ad6);
        if (raw) storage.removeItem($7b20facbdc0c49a4$export$d1977348bcc12ad6);
    } catch (_) {
        return null;
    }
    if (!raw) return null;
    let parked = null;
    try {
        parked = JSON.parse(raw);
    } catch (_) {
        return null;
    }
    if (!parked || typeof parked.text !== 'string' || !parked.at) return null;
    if (now - Number(parked.at) > $7b20facbdc0c49a4$export$f5f34fef576294e7) return null;
    const text = parked.text.trim().slice(0, $7b20facbdc0c49a4$export$2f1c90c46f4622d4);
    return text || null;
};
const $7b20facbdc0c49a4$export$86e08a6bfaa932d9 = ({ search: search, href: href, deliver: deliver, storage: storage, now: now = Date.now() } = {})=>{
    const text = $7b20facbdc0c49a4$export$4a8128d6594cf7d6(search);
    if (!text) return {
        text: null,
        delivered: false,
        parked: false,
        nextHref: null
    };
    let delivered = false;
    try {
        delivered = typeof deliver === 'function' && deliver(text) === true;
    } catch (_) {
        delivered = false;
    }
    const parked = delivered ? false : $7b20facbdc0c49a4$export$757986732f08e49f(text, storage, now);
    const held = delivered || parked;
    return {
        text: text,
        delivered: delivered,
        parked: parked,
        nextHref: held && typeof href === 'string' && href ? $7b20facbdc0c49a4$export$94352f153eadc582(href) : null
    };
};

});

parcelRegister("aO3dH", function(module, exports) {

$parcel$export(module.exports, "assistantTurnStop", () => $7de1124d1ac82d24$export$1f1f80764736d165);
$parcel$export(module.exports, "installSimoneAiTransport", () => $7de1124d1ac82d24$export$b2f5bcba1966c07a);
$parcel$export(module.exports, "syncSimoneLocalBridge", () => $7de1124d1ac82d24$export$afc9db6391abc351);
$parcel$export(module.exports, "supersedeParkedAiToolApprovals", () => $7de1124d1ac82d24$export$c9c9c94702ce6f17);
$parcel$export(module.exports, "settleParkedAiToolApprovals", () => $7de1124d1ac82d24$export$517ab25864db4e2e);
$parcel$export(module.exports, "reofferPendingClientCall", () => $7de1124d1ac82d24$export$914e48bd5244f23f);
$parcel$export(module.exports, "runClientToolWithAuth", () => $7de1124d1ac82d24$export$695c27f322c1f4a7);
$parcel$export(module.exports, "onTargetModeChange", () => $7de1124d1ac82d24$export$e179c1d63fbcf026);
$parcel$export(module.exports, "isReadOnlyAiTool", () => $7de1124d1ac82d24$export$c50056db6e7e85b9);
$parcel$export(module.exports, "resolveChatCard", () => $7de1124d1ac82d24$export$8566d409569c4a92);
$parcel$export(module.exports, "changeChatCardAnswer", () => $7de1124d1ac82d24$export$2843f1f50eafea99);
$parcel$export(module.exports, "isAiDeleteTool", () => $7de1124d1ac82d24$export$b303d4c381f6656e);
$parcel$export(module.exports, "aiAskedCreateKinds", () => $7de1124d1ac82d24$export$b707522d81430ee4);
$parcel$export(module.exports, "isLiveReadOnlyModuleFn", () => $7de1124d1ac82d24$export$464ab4e80706876c);
$parcel$export(module.exports, "approveAllAiToolsForTurn", () => $7de1124d1ac82d24$export$43ba336f5180c9fe);
$parcel$export(module.exports, "resolveAiToolApproval", () => $7de1124d1ac82d24$export$1d57447306a0971d);
$parcel$export(module.exports, "aiToolRunNow", () => $7de1124d1ac82d24$export$3df545fa04ce1340);
$parcel$export(module.exports, "moduleStashReady", () => $7de1124d1ac82d24$export$af7331ccf17e3135);
$parcel$export(module.exports, "waitForModuleStash", () => $7de1124d1ac82d24$export$24c27e8fe1fc41bd);
// installSimoneAiTransport(el) — wires simone's chat surface (mounted
// at the workspace shell root via the Chat component) to dispatch
// through sdk.ai instead of the chrome-extension bridge.
//
// Simone's sendPrompt function snapshots the user message into
// `s.root.chatMessages`, flips `chatTyping: true`, and calls
// `window.__simoneSendOverBridge({ type: 'user_message', text, ... })`.
// In the extension that handle posts to a WebSocket (claude-code bridge)
// and the bridge emits assistant_delta / turn_complete events back to
// the page, which transport/ws.js stitches into chatMessages.
//
// Workspace has no such bridge — sdk.ai does the round-trip itself. We
// install a function that mirrors the bridge protocol enough to keep
// simone's UI happy: on each turn we
//
//   1. Generate an assistant id and push a placeholder
//      { id, role: 'assistant', text: '', streaming: true } row so the
//      Working indicator + the bubble-empty Dots both render.
//   2. Call sdk.ai.dispatch(text). For 'simone'/'providers' modes that
//      streams through /ai-chat/stream (text deltas); 'local' opens
//      ws://127.0.0.1:8765.
//   3. On each onChunk(delta), append to the assistant message's text
//      and re-push the array so DOMQL re-renders.
//   4. On onDone(result), flip streaming:false + chatTyping:false. If
//      the result is an action intent the SDK already populated
//      _aiActionProposals — AiActionConfirmCard handles the rest.
//
// Bridge status is forced to 'open' as long as the AI service is
// resolved — simone's composer disables the Send button when
// bridgeStatus !== 'open', so we need to look healthy.

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $9ZTVI = parcelRequire("9ZTVI");

var $gzr3m = parcelRequire("gzr3m");

var $i2kG6 = parcelRequire("i2kG6");

var $c4Noe = parcelRequire("c4Noe");

var $go87e = parcelRequire("go87e");

var $cwTCb = parcelRequire("cwTCb");

var $8WAnX = parcelRequire("8WAnX");

var $eujtO = parcelRequire("eujtO");

var $9C8Ov = parcelRequire("9C8Ov");

var $1vH8H = parcelRequire("1vH8H");

var $472jS = parcelRequire("472jS");

var $czZQn = parcelRequire("czZQn");

var $3YHy5 = parcelRequire("3YHy5");
const $7de1124d1ac82d24$var$shellUserFacingErrorMessage = (...args)=>(0, $1X0Je.default).functions.userFacingErrorMessage(...args);
// EntityRef string form — the dedupe key for the merged `attached.refs` below.
const $7de1124d1ac82d24$var$formatEntityRef = (...args)=>(0, $1X0Je.default).functions.formatEntityRef(...args);
let $7de1124d1ac82d24$var$_shellInstalled = false;
let $7de1124d1ac82d24$var$_installerEl = null;
// THE TURN IN FLIGHT, per chat scope ('general' | 'addapp' | 'dashboard'):
// what assistantTurnStop ends on screen, and what a follow-up waits for. A
// stopped turn keeps running on the SERVER — a workspace conversation has no
// cancel route, and its turn lock answers 409 ("already has a turn in
// progress") to a new message until the loop ends; the SDK swallows that 409,
// so a follow-up sent at once was never answered. The follow-up therefore
// waits for the stopped turn to settle (its onDone / onError) plus a short
// grace for the lock, at most STOPPED_TURN_WAIT_MS; only the latest waiting
// send of a scope goes.
const $7de1124d1ac82d24$var$_turnsInFlight = new Map();
const $7de1124d1ac82d24$var$_queuedSends = new Map();
// Both are keyed by the WORKSPACE and the scope: a stopped turn of one
// workspace never holds back a send of the next after a switch
// (moduleMemoCensus — tenant-keyed); a turn's entry leaves when it settles.
const $7de1124d1ac82d24$var$_turnKey = (root, scope)=>{
    const ws = root && root.workspace;
    const id = ws && (ws.id || ws._id);
    return String(id || '') + '::' + scope;
};
const $7de1124d1ac82d24$var$STOPPED_TURN_WAIT_MS = 45000;
const $7de1124d1ac82d24$var$STOPPED_TURN_GRACE_MS = 600;
// A bundle sentence for a line the PERSON reads in the thread (the failed-turn
// bubble and the three system lines: local bridge down, AI not ready, no active
// workspace): through the live shell element's polyglot, so it follows the
// session language, or the shipped English when no element is up — never a raw
// key.
// Everything else this file writes is aimed at the MODEL (tool results, the
// dispatched prompt's prefixes) or is a log line, and stays English on purpose.
const $7de1124d1ac82d24$var$_sayKey = (key)=>{
    const el = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
    return el && typeof el.call === 'function' ? String(el.call('polyglot', key)) : String((0, $1X0Je.default).functions.i18nStaticEnglish()[key] || key);
};
// The shell's own words for a message the server REFUSED FOR CREDITS — a
// registered step (functions/creditsRefusal.js), reached through the live shell
// element the way `_sayKey` reaches polyglot: the copy follows the session
// language, the way out follows the viewer's role. `_creditsRow` answers the
// row fields (the sentence and the metadata carrying the figures) for ONE
// message, or null for any other message; `_creditsRows` does the same over a
// list of chat rows. Every path that turns a server answer into a bubble asks
// one of them, so the server's prose cannot reach a bubble by a side door. With
// no element up (or a step that fails) the row stays as it came.
const $7de1124d1ac82d24$var$_creditsEl = ()=>typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
const $7de1124d1ac82d24$var$_creditsRow = (text, metadata, root, from)=>{
    const el = from || $7de1124d1ac82d24$var$_creditsEl();
    try {
        const worded = el && typeof el.call === 'function' ? el.call('creditsRefusalRow', text, metadata, root) : null;
        return worded && typeof worded.text === 'string' ? worded : null;
    } catch (_) {
        return null;
    }
};
const $7de1124d1ac82d24$var$_creditsRows = (rows, root, from)=>{
    const el = from || $7de1124d1ac82d24$var$_creditsEl();
    try {
        const worded = el && typeof el.call === 'function' ? el.call('creditsRefusalRows', rows, root) : null;
        return Array.isArray(worded) ? worded : rows;
    } catch (_) {
        return rows;
    }
};
// Resolve the LIVE root state. The shell/auth boot can remount the tree, so a
// root captured once at install goes stale — root.update on a destroyed tree
// throws into the SDK's safe() callback swallow, and answers never paint
// (empty assistant bubbles) even though the server answers fine. Preference
// order: the root the SENDER passed alongside the envelope (sendPrompt
// resolves `this.state.root` live at send time — its user bubbles always
// render, so that root is proven-live), then the latest installer element's
// root.
// ONE SHELL ASSISTANT (Nika, 2026-10-03): the site builder on screen (the
// /preview route or a pane showing it) rides the turn as
// `context.previewProject` — `{ owner, key, projectId?, env?, page? }`,
// resolved PER SEND from the visible surface by the preview package's
// registered resolver (preview/functions/previewSite.js previewSiteInView),
// so a closed pane or another site's address never leaks into a turn.
const $7de1124d1ac82d24$var$_shellPreviewProjectInView = (root)=>{
    const siteEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
    const site = siteEl && typeof siteEl.call === 'function' ? siteEl.call('previewSiteInView', root) : null;
    return site && typeof site === 'object' && site.owner && site.key ? site : null;
};
const $7de1124d1ac82d24$var$_shellResolveRoot = (extra)=>{
    if (extra && extra.stateRoot && typeof extra.stateRoot.update === 'function') return extra.stateRoot;
    const el = $7de1124d1ac82d24$var$_installerEl;
    return el && el.state && el.state.root || el && typeof el.getRoot === 'function' && el.getRoot()?.state?.root || null;
};
function $7de1124d1ac82d24$export$1f1f80764736d165(scope) {
    const s = scope === 'addapp' ? 'addapp' : scope === 'dashboard' ? 'dashboard' : 'general';
    const turn = $7de1124d1ac82d24$var$_turnsInFlight.get($7de1124d1ac82d24$var$_turnKey($7de1124d1ac82d24$var$_shellResolveRoot(), s));
    return !!(turn && typeof turn.stop === 'function' && turn.stop());
}
function $7de1124d1ac82d24$export$b2f5bcba1966c07a(el) {
    if (typeof window === 'undefined') return;
    // Refresh the element handle on EVERY call so re-installs (drawer remounts)
    // point at the current tree; only the window handler installs once.
    $7de1124d1ac82d24$var$_installerEl = el;
    const initRoot = $7de1124d1ac82d24$var$_shellResolveRoot(null);
    if (initRoot?.update) initRoot.update({
        bridgeStatus: 'open',
        agent: 'sdk-ai'
    });
    // What this shell renders (functions/assistantRecords.js
    // assistantClientCapabilities): the shell's SDK answers every method with a
    // promise, so the first read starts HERE and keeps its answer on the root;
    // a turn then reads it at once. A host without the function answers
    // undefined.
    try {
        if (el && typeof el.call === 'function') el.call('assistantClientCapabilities');
    } catch (_) {}
    // Reconcile the local-bridge lifecycle with the CURRENT target mode — if
    // the shell booted (or remounted) with 'local' already active, open the
    // socket now instead of waiting for the next TargetSwitcher click.
    try {
        $7de1124d1ac82d24$export$afc9db6391abc351.call(el);
    } catch (_) {}
    if ($7de1124d1ac82d24$var$_shellInstalled) return;
    $7de1124d1ac82d24$var$_shellInstalled = true;
    window.__simoneSendOverBridge = (envelope, extra)=>{
        if (!envelope || !envelope.type) return;
        const root = $7de1124d1ac82d24$var$_shellResolveRoot(extra);
        // Local target → hand the envelope to the local simone-bridge VERBATIM
        // (same protocol standalone simone speaks). sdk.ai stays out of local
        // turns; bridge events stream back through syncSimoneLocalBridge's port
        // listener (handleBridgePayload stitches chatMessages). When the bridge
        // isn't up, fail honestly instead of swallowing the message.
        if (root && root.targetMode === 'local') {
            if ($7de1124d1ac82d24$var$_localPort && root.bridgeStatus === 'open') try {
                $7de1124d1ac82d24$var$_localPort.postMessage({
                    type: 'send',
                    payload: envelope
                });
            } catch (_) {}
            else if (envelope.type === 'user_message') {
                $7de1124d1ac82d24$var$_shellPushSystemMessage(root, $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.localBridge').replace('{url}', ()=>$7de1124d1ac82d24$var$LOCAL_BRIDGE_URL));
                root.update({
                    chatTyping: false
                });
            }
            return;
        }
        if (envelope.type !== 'user_message') return;
        const text = String(envelope.text || '').trim();
        if (!text) return;
        // Scope: 'addapp' dispatches project-scoped to the active extension
        // (envelope.projectId / root._addAppProjectId); its state lives under _ax_*
        // so it never collides with the general drawer/composer.
        const scope = envelope.scope === 'addapp' ? 'addapp' : envelope.scope === 'dashboard' ? 'dashboard' : 'general';
        // 'dashboard' = the / inline-thread surface — workspace-scoped like 'general'
        // (the add-app-only branches below exclude it), just under _db_* keys.
        const k = scope === 'addapp' ? '_ax_' : scope === 'dashboard' ? '_db_' : '';
        const projectId = envelope.projectId || (scope === 'addapp' ? root && root._addAppProjectId || null : null);
        // A STOPPED turn of this scope still runs on the server (_turnsInFlight):
        // this send waits for it to settle, then goes — the newest waiting send
        // only. The user message is already on screen (sendPrompt).
        const turnKey = $7de1124d1ac82d24$var$_turnKey(root, scope);
        const stoppedBefore = $7de1124d1ac82d24$var$_turnsInFlight.get(turnKey);
        if (stoppedBefore && stoppedBefore.stopped && !stoppedBefore.settled && !(extra && extra.afterStoppedTurn)) {
            const ticket = {};
            $7de1124d1ac82d24$var$_queuedSends.set(turnKey, ticket);
            const go = ()=>{
                if ($7de1124d1ac82d24$var$_queuedSends.get(turnKey) !== ticket) return;
                $7de1124d1ac82d24$var$_queuedSends.delete(turnKey);
                window.__simoneSendOverBridge(envelope, {
                    ...extra || {},
                    stateRoot: root,
                    afterStoppedTurn: true
                });
            };
            Promise.race([
                stoppedBefore.drain,
                new Promise((ok)=>setTimeout(ok, $7de1124d1ac82d24$var$STOPPED_TURN_WAIT_MS))
            ]).then(()=>setTimeout(go, $7de1124d1ac82d24$var$STOPPED_TURN_GRACE_MS));
            return;
        }
        const ai = (0, $7iFOV.shellGetAiService)();
        if (!ai) {
            $7de1124d1ac82d24$var$_shellPushSystemMessage(root, $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.notReady'), k);
            if (root?.update) root.update({
                [k + 'chatTyping']: false
            });
            return;
        }
        // Scope sdk.ai to the active workspace so dispatch routes to
        // /core/agents/workspaces/:wsId/conversations (per-member history +
        // workspace actions). The shell holds the canonical workspace id in the
        // governance JWT claims (root.jwtClaims.active_workspace_id); the SDK
        // otherwise has no activeWorkspaceId and would error "no active workspace".
        try {
            const wsId = (0, $9ZTVI.activeWorkspaceId)(root);
            if (wsId && typeof ai.updateContext === 'function') ai.updateContext({
                activeWorkspaceId: wsId
            });
            else if (!wsId && scope !== 'addapp') {
                $7de1124d1ac82d24$var$_shellPushSystemMessage(root, $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.noWorkspace'), k);
                if (root?.update) root.update({
                    [k + 'chatTyping']: false
                });
                return;
            }
        } catch (_) {
        /* best-effort — fall through to dispatch */ }
        // A new user message CLOSES any still-parked approval — the server closes
        // the dangling client call before it starts this turn
        // (closeDanglingClientCall), so leaving Run / Skip live on the old row
        // would offer a button the loop can no longer honour. Settle first, so the
        // row goes quiet at the same moment the server writes its honest "NOT run".
        // This thread's own waiting steps are SUPERSEDED, never declined: nothing
        // is posted for them (a POST would race this message for the turn lock),
        // and the turn that waited on them ends here on screen — its stream would
        // otherwise answer this message's frames through the old callbacks.
        if ($7de1124d1ac82d24$export$c9c9c94702ce6f17(root, k, root && root[k + 'activeSessionId']) > 0) {
            const prior = $7de1124d1ac82d24$var$_turnsInFlight.get(turnKey);
            if (prior && typeof prior.supersede === 'function') prior.supersede();
        }
        $7de1124d1ac82d24$export$517ab25864db4e2e("A new message was sent before this action was approved \u2014 it did not run.");
        // Per-turn guard: cleared at turn start, set when the cloud drives the
        // injectPageInApp client tool itself this turn. The onDone build-spec
        // render fallback reads it directly so it doesn't double-render when the
        // tool already ran.
        $7de1124d1ac82d24$var$_extensionRenderedThisTurn = false;
        const assistantId = `a-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
        const placeholder = {
            id: assistantId,
            role: 'assistant',
            text: '',
            ts: Date.now(),
            streaming: true,
            // Seed EVERY key a factory will later read reactively. A key that is
            // ABSENT at the row's first render is not tracked as a dependency, so
            // the factory never re-fires when the key later appears — the live
            // tool timeline rendered EMPTY (state carried the rows, DOM had none;
            // diagnosed live on dev 2026-08-12: Activity children:0 while
            // s.tools:2). Same latent trap for cards and suggestions.
            tools: [],
            cards: [],
            suggestions: [],
            // The author of THIS row, fixed at dispatch — the one instant at which
            // the thread's routing target and the message are the same fact. Null
            // means the general assistant wrote it, and it stays null forever.
            // AI-TALK-TO-AGENT-REUSES-OPEN-THREAD-1: ChatMessage's Author used to
            // fall back to the LIVE `root._targetAgentName`, so pressing "Talk to
            // QA" re-labelled every earlier reply in the open thread as QA
            // (measured on production 2026-08-30 06:43). The renderer now reads
            // this key only, which also makes it one of the keys that MUST be
            // seeded here — see the note above on absent keys never being tracked.
            agentName: root?._targetAgentName || null,
            // S1 (NIKA BATCH 2026-08-16) — null while streaming (ChatMessage shows
            // a live text-length estimate instead); onDone below patches in the
            // server's authoritative { promptTokens, completionTokens }. Seeded
            // here for the same reason as tools/cards/suggestions above.
            usage: null,
            // GROUNDING (spec §4.2–4.3) — the refs this answer cites and the
            // computed confidence verdict. Seeded here for exactly the reason
            // tools/cards/suggestions/usage are: a key ABSENT at the row's first
            // render is never tracked as a dependency, so ChatMessage's Sources /
            // Confidence factories would never re-fire when onDone patched them in.
            // `sources: []` renders nothing; `confidence: null` renders the muted
            // "Unscored" pill — never a hidden pill, because "the model did not say"
            // and "the model was confident" must not look the same (spec §4.3:
            // ALWAYS present on every assistant message).
            sources: [],
            confidence: null,
            // The advice level (vault spec 06 §7) — null unless the workspace
            // grades its answers. Seeded for the same dependency reason.
            level: null,
            // Touched once a second by the elapsed-timer interval below, purely to
            // give ChatMessage's live elapsed-seconds text a state key to react to
            // — same "seed every key a factory will read" rule as tools/cards/
            // suggestions/usage.
            _tick: Date.now()
        };
        if (root?.update) root.update({
            [k + 'chatMessages']: (root[k + 'chatMessages'] || []).concat(placeholder),
            [k + 'currentAssistantId']: assistantId
        });
        // This scope's turn in flight (_turnsInFlight): `stop` is set below, once
        // the stream's own buffers exist; `drain` resolves when the turn settles.
        let _drained = null;
        const turn = {
            stopped: false,
            settled: false,
            stop: null,
            drain: new Promise((ok)=>{
                _drained = ok;
            })
        };
        const _settleTurn = ()=>{
            if (turn.settled) return;
            turn.settled = true;
            if ($7de1124d1ac82d24$var$_turnsInFlight.get(turnKey) === turn) $7de1124d1ac82d24$var$_turnsInFlight.delete(turnKey);
            _drained();
        };
        $7de1124d1ac82d24$var$_turnsInFlight.set(turnKey, turn);
        // S1 (NIKA BATCH 2026-08-16) — elapsed-time ticker. ChatMessage's live
        // display has nothing to react to on pure wall-clock passage (no delta,
        // no tool event), so this nudges `chatMessages` once a second — the
        // same array-remap `_shellPatchAssistantMessage` already does per delta, just
        // on a timer instead of a stream event. Cleared on both onDone and
        // onError below; a stray interval outliving its message would tick a row
        // nobody is reading.
        let _elapsedTimer = setInterval(()=>{
            $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                _tick: Date.now()
            }, k);
        }, 1000);
        const _stopElapsedTimer = ()=>{
            if (_elapsedTimer) {
                clearInterval(_elapsedTimer);
                _elapsedTimer = null;
            }
        };
        // Picked items are POINTERS in the workspace surface — the user aimed the
        // cursor at something to talk ABOUT it (vs the chrome extension, where a
        // pick marks the DOM node the agent should update). Compact one-liners
        // prefixed to the dispatched text so the agent always sees them.
        const pickedAll = Array.isArray(envelope.context?.pickedElements) ? envelope.context.pickedElements : [];
        // An INSPECTED region (the composer's Inspect & ask, functions/
        // aiInspect.js) is a picked entry that carries its facts: it rides the
        // turn STRUCTURED as `context.inspected` (the server's INSPECTED line),
        // never as the 80-character pointing line below.
        const inspected = pickedAll.filter((p)=>p && p.inspect && typeof p.inspect === 'object').slice(0, 3).map((p)=>p.inspect);
        const picked = pickedAll.filter((p)=>!(p && p.inspect && typeof p.inspect === 'object'));
        const pointing = picked.length ? picked.map((p)=>{
            // The picked element's path (`Header › Nav › Link`) first — a bare
            // key names one of many same-named elements on a site.
            const path = Array.isArray(p?.keyPath) ? p.keyPath.join(" \u203A ") : '';
            const name = path || p?.component || p?.key || p?.tag || 'element';
            const snippet = (p?.text || '').trim().slice(0, 80);
            return `[user is pointing at: ${name}${snippet ? ` \u{2014} "${snippet}"` : ''}]`;
        }).join('\n') + '\n\n' : '';
        // The builder bound to an app sends the person's words only. Which app the
        // thread changes is the SERVER's to say (CORE builder-r2: one per-turn line
        // names the thread's app and its edit path, update_app, for both app kinds;
        // get_project returns the pages). The turn's project route and
        // `context.extensionProjectId` already name it. The note this transport
        // used to prepend ("[editing multi-page app … do NOT create_app again.]")
        // was stored as the person's message and read back under "You" (sam,
        // round 1b); _simone/sessions.js still strips it from older threads.
        const dispatchContext = {
            surface: scope === 'addapp' ? 'add-app-builder' : 'workspace-shell',
            extensionProjectId: scope === 'addapp' ? projectId : null,
            pickedElements: picked.length ? picked : null,
            targetAgentId: root?._targetAgentId || null,
            targetAgentName: root?._targetAgentName || null
        };
        // UI LANGUAGE (server ai-boards/uiLanguage.js renders the USER-FACING
        // LANGUAGE instruction from it): the shell's active language pins every
        // model-authored user-facing string — ask_user / confirm_with_user
        // prompts and choice labels, narration, SUGGEST trailer — when the
        // message itself has no language signal (QA round-2 F9: an emoji-only
        // turn streamed a ka choice-pending row into an en workspace). Sent for
        // BOTH scopes — language is surface-independent.
        if (typeof root?.lang === 'string' && root.lang) dispatchContext.uiLanguage = root.lang;
        // RESUME (the Continue chip, sendPrompt `opts.resume`): the turn picks up
        // a failed-after-tools turn. The message text is the member's own word;
        // the server reads `context.resume` and tells the model to continue
        // without redoing the saved actions. Sent for BOTH scopes.
        if (envelope.context && envelope.context.resume === true) dispatchContext.resume = true;
        // MODE × PLACEMENT (AI_ASSISTANT_SPEC v1 §1–§2, §12.1): ONE brain answers
        // every ask and the MODE shapes its final output — 'assistant' (text + live
        // blocks), 'dashboard' (a board), 'tools' (work inside the platform apps),
        // 'apps' (a frontend app), 'presentation' (a deck), 'fly' (a composed page —
        // a chat turn in Fly mode answers in the page's shape). The PLACEMENT tells it how
        // wide the surface is: 'main' (the MainColumn thread, full-board-width
        // blocks), 'sidebar' (the docked panel) or 'minimized' (the compact
        // popover). The person's mode, read at send time (functions/
        // assistantMode.js); the AI may answer one ask in another mode and says so.
        // The add-app builder is extension-scoped and carries neither.
        if (scope !== 'addapp') {
            // ONE ask's own mode (the focus panel's Summarize / Build a board —
            // sendPrompt's `opts.mode`) wins for this turn; else the person's.
            const _askMode = envelope.context && envelope.context.assistantMode;
            const _mode = [
                'assistant',
                'dashboard',
                'tools',
                'apps',
                'presentation',
                'fly'
            ].includes(_askMode) ? _askMode : root?.assistantMode;
            dispatchContext.assistantMode = [
                'assistant',
                'dashboard',
                'tools',
                'apps',
                'presentation',
                'fly'
            ].includes(_mode) ? _mode : 'assistant';
            dispatchContext.placement = root?._homeThreadOpen === true && root?.assistantDock === 'main' ? 'main' : root?.assistantDock === 'minimized' ? 'minimized' : 'sidebar';
            // WHAT THIS SHELL RENDERS (the server's capability gate, ai-boards
            // answerShape): `capabilities: { records: 1 }` only when the shell renders
            // RECORDS BLOCK v1 and its SDK resolves them (functions/assistantRecords.js
            // assistantClientCapabilities, first read at install); absent = the server
            // offers no embed_records. The SDK forwards `context` whole. An answer
            // still in flight (a promise, the first moments of a boot) sends nothing
            // this turn and lands on the root for the next. Best-effort — a host
            // without the function answers undefined, and a throw never blocks a turn.
            try {
                const capEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                const caps = capEl && typeof capEl.call === 'function' ? capEl.call('assistantClientCapabilities') : null;
                if (caps && typeof caps === 'object' && typeof caps.then !== 'function') dispatchContext.capabilities = caps;
            } catch (_) {
            /* the capability is best-effort */ }
            // THE BUILT-IN APPS' VIEWS AND FORMS (functions/assistantAppViews.js
            // assistantAppCatalog): calendar and tasks have no manifest the server
            // can read, so the turn carries their providers' declarations. An older
            // server ignores the key. Best-effort, like the capability.
            try {
                const catEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                const catalog = catEl && typeof catEl.call === 'function' ? catEl.call('assistantAppCatalog') : null;
                if (Array.isArray(catalog) && catalog.length) dispatchContext.appCatalog = catalog;
            } catch (_) {
            /* the catalog is best-effort */ }
        }
        // Page awareness: the GENERAL AI gets a compact snapshot of the current page
        // (route + its data + what it can do there) so it can answer about and act
        // on what the user is looking at. The add-app builder is extension-scoped
        // and deliberately gets none. Best-effort — never block a turn on it.
        if (scope !== 'addapp') {
            try {
                const pc = (0, $gzr3m.buildPageContext)(root);
                if (pc && pc.currentPage) {
                    dispatchContext.currentPage = pc.currentPage;
                    dispatchContext.pageData = pc.pageData || null;
                    dispatchContext.pageActions = pc.pageActions || null;
                    // What the user is focused on right now (open detail modal / editor /
                    // dialog + the record it shows) — lets the AI resolve "this ticket /
                    // doc / person / agent" against the exact thing on screen.
                    dispatchContext.openView = pc.openView || null;
                    // Live UI + data-scope snapshot: which page/modal/slot/sidebar is
                    // active + the workspace/org the SDK is pinned to, so the AI has full
                    // situational context (see buildUiState / buildUiStateLine).
                    dispatchContext.uiState = pc.uiState || null;
                    // What the member UNDID in this thread: the server says these items
                    // are deleted, so the reply never claims them (_undoneInThread).
                    const undone = $7de1124d1ac82d24$var$_undoneInThread(root, k);
                    if (undone.length) dispatchContext.uiState = {
                        ...pc.uiState || {},
                        undone: undone
                    };
                }
            } catch (_) {
            /* page awareness is best-effort */ }
            // THE ASK SCOPE (functions/aiScope.js; the composer's context selector):
            // what this turn is ABOUT — the page, the app, the workspace, another
            // installed app, or the open record — with the app id, the route, the
            // page and the home widgets in it. The server renders it as the ASK
            // SCOPE line. Best-effort, like the capability above.
            try {
                const scopeEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                const aiScope = scopeEl && typeof scopeEl.call === 'function' ? scopeEl.call('aiScopePayload', root) : null;
                if (aiScope && typeof aiScope === 'object') dispatchContext.aiScope = aiScope;
            } catch (_) {
            /* the scope is best-effort — the page awareness above still answers */ }
            if (inspected.length) dispatchContext.inspected = inspected;
            const previewProject = $7de1124d1ac82d24$var$_shellPreviewProjectInView(root);
            if (previewProject) dispatchContext.previewProject = previewProject;
            // Workspace knowledge layer: the active workspace's personalized surface
            // (module pages/components, live state keys + row shapes, skin vars) —
            // the server renders it as the WORKSPACE UI CATALOG instruction block so
            // answers reuse THIS workspace's UI (open_page_in_split its pages, extend
            // its components in render_answer_ui, read its loaded state).
            try {
                // The live design system the answer views mount under (the root
                // element's context) — its colour and theme names ride the catalog.
                const dsEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                const catalog = (0, $c4Noe.buildUiCatalog)(root, {
                    designSystem: dsEl && dsEl.context && dsEl.context.designSystem || null
                });
                if (catalog) dispatchContext.uiCatalog = catalog;
            } catch (_) {
            /* catalog is best-effort */ }
        }
        // STRUCTURED ATTACHMENTS (spec §4.1) — `context.attached = { refs, canvas }`.
        // The server allowlist (AgentWorkspaceConversationController.appendMessage)
        // keeps this key after validation + caps; the orchestrator renders it as a
        // fenced ATTACHED CONTEXT block and registers every ref as a retrieval
        // candidate. That is what makes these `sent: 'structured'` in the
        // awareness bar, and the bar and this block MUST agree — a chip that
        // claimed 'structured' while the wire dropped the item is the exact drift
        // buildAiAwareness exists to prevent.
        //
        // TWO SOURCES, merged here and nowhere else:
        //   • `root.aiAttached` — the persistent bag the drawer chips render
        //     (attachAiRef / attachAiCanvas from a page or a composer drop).
        //   • `envelope.context.attached` — the PER-TURN payload the home/canvas
        //     composer forwards from getSelectionAiContext() (canvas lane). Passed
        //     through untouched: that lane owns its own node/connection caps and
        //     re-capping here would silently truncate its payload.
        //
        // Refs union, deduped by the `ref:<type>:<id>` string form, persistent bag
        // first (an explicit attach outranks a selection that happens to overlap).
        // Capped at 24 = the server's own cap, so the client never sends items the
        // wire will drop.
        //
        // The whole key is OMITTED when the turn carries nothing, so a plain
        // dispatch payload is byte-identical to what it was before attachments
        // existed — the same rule the `attachments` image leg follows below.
        // The add-app builder is extension-scoped and gets none, like page
        // awareness above.
        if (scope !== 'addapp') try {
            const bag = (0, $i2kG6.readAiAttached)(root);
            const turn = envelope.context && typeof envelope.context.attached === 'object' ? envelope.context.attached : null;
            const turnRefs = turn && Array.isArray(turn.refs) ? turn.refs : [];
            const seen = new Set();
            const refs = [];
            for (const ref of [
                ...bag.refs,
                ...turnRefs
            ]){
                const key = $7de1124d1ac82d24$var$formatEntityRef(ref);
                if (!key || seen.has(key)) continue;
                seen.add(key);
                refs.push(ref);
                if (refs.length >= 24) break;
            }
            const canvas = bag.canvas || (turn && turn.canvas && typeof turn.canvas === 'object' ? turn.canvas : null);
            if (refs.length || canvas) dispatchContext.attached = {
                refs: refs,
                ...canvas ? {
                    canvas: canvas
                } : {}
            };
        } catch (_) {
        /* attachments are best-effort — never block a turn on them */ }
        // Route this message to the user's ACTIVE thread (set by newSession /
        // switchSession, restoreActiveThread after a reload, or the transport itself
        // once a turn names its conversation). Real server ids only — a local 's-…'
        // placeholder names no server conversation yet.
        //
        // ONE BUILDER THREAD = ONE SERVER CONVERSATION (presets round 2, aiko-r2 +
        // marcus-r2): an unbound add-app thread (no app yet, projectId null) carries
        // its id like every other thread. It used to carry only the workspace setup's
        // first thread, and every other unbound builder turn went out with
        // `conversationId: null` — a follow-up or a retry after a failed first build
        // then landed in whatever conversation the SDK had cached for the workspace
        // (any scope's), or, with the placeholder still active, in a NEW thread that
        // is not the free first build's thread and pays.
        //
        // The old guard (05fcc8c7c) kept a leftover PROJECT thread id out of an
        // unbound turn. That case answers itself now: a project conversation is not
        // a workspace conversation, the server answers 404 on the workspace route,
        // and the SDK (then this transport's gone-thread retry below) starts a new
        // conversation with the same message — what the old `null` did.
        const activeConvId = (()=>{
            const id = root[k + 'activeSessionId'];
            return id && !String(id).startsWith('s-') ? id : null;
        })();
        // A local 's-…' placeholder means the user explicitly opened a NEW thread
        // (newSession) that has no server conversation yet. Tell the SDK to CREATE
        // one instead of falling back to its cached last-used conversation — the
        // fallback silently appended the "new" thread onto the previous
        // conversation, so the model kept the old thread's full context (stale
        // answers in a visually-empty chat).
        const wantsNewConversation = !activeConvId && String(root[k + 'activeSessionId'] || '').startsWith('s-');
        let buffered = '';
        // Reasoning segmentation: the model narrates its thinking BETWEEN tool
        // calls ("Let me fetch the records first…"). Everything streamed since the
        // last tool becomes THAT tool's reasoning note when it starts — the
        // narration snaps out of the bubble into the timeline row, the bubble
        // resets for the next segment, and onDone's final text replaces it all.
        let narratedUpto = 0;
        // Delta flush throttle (2026-08-01, per Nika "streaming animation /
        // texts flickering"): SSE frames can land many-per-frame; patching the
        // chatMessages array per delta made the bubble repaint in bursts (and
        // every patch is a whole-array state write). The FIRST token flushes
        // immediately — that's the paint that replaces the "Thinking…" loader —
        // then flushes coalesce to one per ~60ms. The flush closure re-reads
        // `buffered`/`narratedUpto` at fire time, so tool-segmentation snapshots
        // stay correct regardless of cadence. onDone/onError clear the pending
        // timer so a late flush can never overwrite the final answer.
        let _flushTimer = null;
        let _firstTokenPainted = false;
        const turnStartedAt = Date.now();
        const _flushStream = ()=>{
            _flushTimer = null;
            $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                text: $7de1124d1ac82d24$var$_stripSuggestTail(buffered.slice(narratedUpto))
            }, k);
        };
        const _cancelPendingFlush = ()=>{
            if (_flushTimer) {
                clearTimeout(_flushTimer);
                _flushTimer = null;
            }
        };
        // THE PERSON STOPS THE TURN (assistantTurnStop): the reply keeps what
        // arrived — the bubble's own segment, as _flushStream paints it — and says
        // it was stopped under it, the way a failed turn keeps its partial answer;
        // the composer is free again. Everything this turn sends later is ignored
        // on screen (the guards in the callbacks below).
        turn.stop = ()=>{
            if (turn.stopped || turn.settled) return false;
            turn.stopped = true;
            _cancelPendingFlush();
            _stopElapsedTimer();
            // An action still waiting on Run / Skip never runs for a stopped turn.
            $7de1124d1ac82d24$export$517ab25864db4e2e("The person stopped this turn before this action was approved \u2014 it did not run.");
            // A question still waiting on its answer closes: the loop reads that it
            // was not answered, ends, and frees the thread for the next message.
            $7de1124d1ac82d24$var$_endWaitingCards((w)=>$7de1124d1ac82d24$var$_waitsInThread(w, root, k, turn.thread), 'stop', "The person stopped this turn before answering \u2014 the question was not answered.");
            const said = $7de1124d1ac82d24$var$_stripSuggestTail(buffered.slice(narratedUpto)).trim();
            const note = $7de1124d1ac82d24$var$_sayKey('workspace.simone.turn.stopped');
            $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                text: said ? `${said}\n\n> ${note}` : note,
                streaming: false,
                stopped: true
            }, k);
            if (root?.update) root.update({
                [k + 'chatTyping']: false,
                [k + 'currentAssistantId']: null
            });
            return true;
        };
        // A NEW MESSAGE TOOK THE THREAD (supersedeParkedAiToolApprovals, at the
        // next send): this turn waited on a step the server now closes under that
        // message. Its bubble keeps what streamed and stops its dots; everything
        // its stream sends later lands nowhere (the guards below) — the new turn
        // owns the thread, its typing flag and its frames.
        turn.supersede = ()=>{
            if (turn.stopped || turn.settled || turn.superseded) return false;
            turn.superseded = true;
            _cancelPendingFlush();
            _stopElapsedTimer();
            $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                text: $7de1124d1ac82d24$var$_stripSuggestTail(buffered.slice(narratedUpto)).trim(),
                streaming: false
            }, k);
            _settleTurn();
            return true;
        };
        // SIMONE-INFLIGHT-TURN-NO-PERSISTENCE-1 — mark the remembered thread
        // in-flight for the length of this turn. A reload from here can then say
        // honestly that the turn died (and that anything parked on the approval
        // gate never ran) instead of returning an empty panel.
        try {
            const markEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
            if (markEl && typeof markEl.call === 'function') markEl.call('markThreadTurn', scope, true);
        } catch (_) {
        /* best-effort — persistence is never a blocker on sending */ }
        // Image attachments the composer put on the envelope (sendPrompt →
        // ./_simone/attachments.js). Forwarded VERBATIM to sdk.ai, which posts
        // them on the turn's message; the server caps them and persists them as
        // `image` content parts the multimodal providers send as real image
        // blocks. Omitted when the turn has none, so a text-only dispatch payload
        // is byte-identical to what it was before attachments existed — that is
        // also what keeps the local-bridge branch above (which forwards the whole
        // envelope untouched) unaffected.
        const attachments = Array.isArray(envelope.attachments) ? envelope.attachments : [];
        // A THREAD THAT IS GONE: the server answers 404 (the same body as a
        // missing thread) when a member posts into a thread they deleted, and the
        // SDK may still hold that id as its "last used" one. Answered ONCE, before
        // any word arrived (onError below): drop the thread id (a new local
        // thread), send the SAME payload again as a new conversation through the
        // SAME callbacks, into the same answer bubble — the user message is already
        // on screen and is not added again. A second 404, or any other error,
        // fails the turn as before.
        let _goneThreadRetried = false;
        let _turnCallbacks = null;
        const _turnPayload = {
            text: pointing + text,
            projectId: scope === 'addapp' ? projectId : null,
            conversationId: activeConvId,
            newConversation: wantsNewConversation,
            context: dispatchContext,
            ...attachments.length ? {
                attachments: attachments
            } : {}
        };
        // The thread this turn belongs to, as the root names it: the id (or local
        // placeholder) it was sent from; moved when the turn learns its server
        // conversation. A conversation id the turn reports is adopted only while
        // the person is still on that thread — a thread they switched to meanwhile
        // is never repointed.
        turn.thread = root[k + 'activeSessionId'] || null;
        const _adoptTurnConversation = (id)=>{
            const conv = id ? String(id) : '';
            if (!conv || conv.startsWith('s-') || !root?.update) return false;
            const cur = root[k + 'activeSessionId'] || null;
            if (cur !== turn.thread && cur !== null) return false;
            turn.thread = conv;
            if (cur !== conv) root.update({
                [k + 'activeSessionId']: conv
            });
            return true;
        };
        // THE PAGE FOLLOWS THE TURN'S WRITES. Every tool-activity frame reaches the
        // write hooks (onToolEvent below): the add-app preview for the builder's
        // turn, else the site builder on screen and the open canvas editor
        // (preview/functions/previewSite.js previewAfterAiWrite records each
        // project write as `_aiProjectWrite`, canvas RemoteUpdateWatcher follows
        // it). A turn whose stream was lost replays the steps its SAVED transcript
        // holds through the same hooks (_followDetachedTurn / _reconcileAfterTurnError
        // `onSteps`) — dev 2026-10-30: the stream died in a build turn, the answer
        // came from the saved thread, and the open canvas never heard of the page
        // the turn added. Each call reaches the hooks completed once.
        const _hookedCalls = new Set();
        const _afterToolFrame = (evt)=>{
            if (!evt || !evt.phase) return;
            // A successful app write of the builder's turn: the preview reads its
            // rows again, and a write nothing renders re-renders the app
            // (functions/addAppPreviewRefresh.js — persona round 3, B5).
            if (scope === 'addapp' && evt.phase === 'completed' && evt.ok !== false) try {
                const writeEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                if (writeEl && typeof writeEl.call === 'function') Promise.resolve(writeEl.call('addAppPreviewAfterWrite', evt.tool)).catch((err)=>console.warn('[simone] preview refresh failed:', err?.message || err));
            } catch (_) {
            /* the preview refresh never breaks a turn */ }
            // The site builder on screen follows its project's writes DURING the turn
            // (preview/functions/previewSite.js previewAfterAiWrite).
            if (scope !== 'addapp') try {
                const siteEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                if (siteEl && typeof siteEl.call === 'function') siteEl.call('previewAfterAiWrite', evt, root);
            } catch (_) {
            /* the builder refresh never breaks a turn */ }
            if (evt.phase === 'completed' && evt.callId != null) _hookedCalls.add(String(evt.callId));
        };
        const _replaySteps = (steps)=>{
            if (turn.stopped || turn.superseded || !Array.isArray(steps)) return;
            for (const step of steps){
                if (!step || !step.callId || _hookedCalls.has(step.callId)) continue;
                _afterToolFrame({
                    phase: 'completed',
                    callId: step.callId,
                    tool: step.tool,
                    args: step.args,
                    ok: step.ok
                });
            }
        };
        // THE TURN FAILED — the server answered with an error, or a lost
        // connection found nothing to follow (onError, _followAfterDrop): the
        // honest sentence under whatever streamed, the composer free again, and a
        // short re-read in case the answer landed anyway.
        const _failTurn = (err)=>{
            _stopElapsedTimer();
            // Raw error stays in the console for debugging — only the
            // user-facing bubble text is sanitized (never a URL / adblocker
            // diagnostic / stack, see userFacingErrorMessage).
            console.warn('[simone] turn failed:', err?.message || err);
            // A parked approval would strand the SERVER-side turn forever (the
            // loop waits on a tool-result this dead turn can no longer post) —
            // settle them so the loop finishes honestly instead of the user having
            // to type "continue": as steps that did not run (the person never
            // decided), with the way to run them again — never as their "skip".
            $7de1124d1ac82d24$export$517ab25864db4e2e('The turn failed before this action was approved.', {
                notRun: 'workspace.simone.approval.notRun'
            });
            // …and a question still waiting on its answer closes the same way.
            $7de1124d1ac82d24$var$_endWaitingCards((w)=>$7de1124d1ac82d24$var$_waitsInThread(w, root, k, turn.thread), 'end', "The turn failed before the person answered \u2014 the question was not answered.");
            // A FAILED TURN KEEPS ITS THREAD: the SDK names the conversation the turn
            // ran in on its error. While the person is still on this turn's thread
            // (its placeholder, or the id it was sent with), point the thread at it —
            // the retry after a failed build goes into the SAME conversation (the free
            // first build's), never a new one. Before the in-flight mark settles, so
            // the remembered thread is the real one too.
            _adoptTurnConversation(err && err.conversationId);
            try {
                const markEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                if (markEl && typeof markEl.call === 'function') markEl.call('markThreadTurn', scope, false);
            } catch (_) {}
            // A TURN TO AN INACTIVE AGENT (CORE-2f; the server's targetAgentActive.js):
            // the server refuses it before it writes anything — 403, `code:
            // 'agent_inactive'` on the body, which the SDK hands on as `err.cause`. The
            // shell words it in the session language; its English `message` never
            // shows. Any other 403, and every other error, keeps the lines below.
            const agentInactive = !!err && err.status === 403 && !!err.cause && err.cause.code === 'agent_inactive';
            const friendly = agentInactive ? $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.agentInactive') : $7de1124d1ac82d24$var$shellUserFacingErrorMessage(err, {
                networkMessage: $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.network'),
                streamMessage: $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.stream'),
                fallback: (e)=>{
                    const msg = (e?.message || String(e) || '').trim();
                    return msg ? $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.failedWithMessage').replace('{message}', ()=>msg) : $7de1124d1ac82d24$var$_sayKey('workspace.simone.error.failed');
                }
            });
            // NEVER destroy already-streamed words with the error string — keep
            // the partial answer and append the error under it.
            const partial = $7de1124d1ac82d24$var$_stripSuggestTail(buffered);
            $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                text: partial ? `${partial}\n\n> ${friendly}` : friendly,
                streaming: false,
                turnError: true
            }, k);
            if (root?.update) root.update({
                [k + 'chatTyping']: false,
                [k + 'currentAssistantId']: null
            });
            _settleTurn();
            // The failure is often CLIENT-side only: the server finished the
            // turn and persisted its answer while our connection died (proven
            // live 2026-08-11 — three "couldn't reach the server" bubbles whose
            // real answers sat completed in the conversation, unseen). Re-read
            // the conversation on a short backoff and adopt the newest
            // assistant text if one landed.
            $7de1124d1ac82d24$var$_reconcileAfterTurnError({
                root: root,
                k: k,
                scope: scope,
                assistantId: assistantId,
                // The SDK resolves the real conversation id (cache/create) after
                // dispatch — on failure it rides the error, which is the only
                // reliable source when the local session was still a placeholder.
                conversationId: err && err.conversationId || activeConvId,
                ai: ai,
                turnStartedAt: turnStartedAt,
                opts: _turnPayload.projectId ? {
                    projectId: _turnPayload.projectId
                } : null,
                sentText: _turnPayload.text,
                onSteps: _replaySteps
            });
        };
        // THE CONNECTION DROPPED, THE TURN GOES ON (onError — sam, round 1b): the
        // bubble keeps what streamed and says the work goes on, a parked approval
        // stays live (the person may still answer it; the SDK posts the result),
        // and the conversation is followed until the answer lands
        // (_followDetachedTurn). `extra.detachedFollow` tunes the follow's timing
        // for a test; nothing else passes it.
        const _followAfterDrop = (err, convId)=>{
            const callEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
            const said = ()=>$7de1124d1ac82d24$var$_stripSuggestTail(buffered.slice(narratedUpto)).trim();
            const noted = (key)=>{
                const words = said();
                const note = $7de1124d1ac82d24$var$_sayKey(key);
                return words ? `${words}\n\n> ${note}` : `> ${note}`;
            };
            if (root?.update) root.update({
                [k + 'activeSessionId']: convId,
                [k + 'chatTyping']: true
            });
            $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                text: noted('workspace.simone.turn.reconnecting'),
                streaming: true
            }, k);
            const finish = ()=>{
                _stopElapsedTimer();
                try {
                    if (callEl && typeof callEl.call === 'function') {
                        callEl.call('markThreadTurn', scope, false);
                        callEl.call('refreshSessionsAfterTurn', scope);
                        if (scope === 'addapp') callEl.call('loadAddAppExtensions', root);
                    }
                } catch (_) {
                /* best-effort — history refreshes on its next read */ }
                if (root?.update) root.update({
                    [k + 'chatTyping']: false,
                    [k + 'currentAssistantId']: null
                });
                _settleTurn();
            };
            const follow = ()=>$7de1124d1ac82d24$var$_followDetachedTurn({
                    root: root,
                    k: k,
                    assistantId: assistantId,
                    conversationId: convId,
                    ai: ai,
                    sentText: _turnPayload.text,
                    opts: _turnPayload.projectId ? {
                        projectId: _turnPayload.projectId
                    } : null,
                    timing: extra && extra.detachedFollow,
                    onSteps: _replaySteps,
                    onAnswer: (answer)=>{
                        if (turn.superseded) return;
                        // A refusal for credits reads as the shell's sentence here too.
                        const refused = $7de1124d1ac82d24$var$_creditsRow(answer.text, answer.metadata, root);
                        const suggestions = Array.isArray(answer.metadata?.suggestions) ? answer.metadata.suggestions : [];
                        $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                            text: refused ? refused.text : (0, $1vH8H.stripAnswerTrailers)(answer.text),
                            ...refused ? {
                                metadata: refused.metadata
                            } : {},
                            suggestions: suggestions,
                            streaming: false,
                            turnError: false,
                            recovered: true
                        }, k);
                        finish();
                    },
                    onHandOver: (pending)=>{
                        if (turn.superseded) return;
                        // The server asked for a client step while the stream was down: the
                        // reload path offers it (the gate asks again in Ask first) and
                        // follows the rest; this bubble keeps only what streamed.
                        $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                            text: said(),
                            streaming: false
                        }, k);
                        finish();
                        try {
                            $7de1124d1ac82d24$export$914e48bd5244f23f.call(callEl, {
                                offer: pending,
                                conversationId: convId,
                                scope: scope,
                                stateRoot: root,
                                ai: ai,
                                // the live turn's own step: the person is here, not a load
                                live: true,
                                opts: _turnPayload.projectId ? {
                                    projectId: _turnPayload.projectId
                                } : undefined
                            });
                        } catch (_) {}
                    },
                    onWaiting: ()=>{
                        if (turn.superseded) return;
                        // The follow window ended while a step waits for the person: the row
                        // stays live, the bubble says so, and an answer to it follows again.
                        $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                            text: noted('workspace.simone.turn.waitingForYou'),
                            streaming: false
                        }, k);
                        if (root?.update) root.update({
                            [k + 'chatTyping']: false
                        });
                        for (const id of Object.keys($7de1124d1ac82d24$var$_pendingToolApprovals)){
                            const held = $7de1124d1ac82d24$var$_pendingToolApprovals[id];
                            if (!held || held.root !== root || held.k !== k) continue;
                            held.onAnswered = ()=>{
                                $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                                    text: noted('workspace.simone.turn.reconnecting'),
                                    streaming: true
                                }, k);
                                if (root?.update) root.update({
                                    [k + 'chatTyping']: true
                                });
                                follow();
                            };
                        }
                    },
                    onGiveUp: ()=>{
                        if (!turn.superseded) _failTurn(err);
                    },
                    onLost: ()=>{
                        // The thread moved on: the bubble keeps what streamed and stops
                        // its dots (a stop already wrote its own note), the turn settles.
                        if (!turn.stopped && !turn.superseded) $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                            text: said(),
                            streaming: false
                        }, k);
                        _stopElapsedTimer();
                        _settleTurn();
                    }
                });
            follow();
        };
        // A NEW THREAD GETS ITS SERVER CONVERSATION BEFORE ITS FIRST TURN (presets
        // round 2, aiko-r2 + marcus-r2). Left to the SDK, the thread is made with the
        // message and its id reaches this page only when the turn ENDS — a build
        // turn runs for minutes, so a message the person sent meanwhile (after a
        // choice card, a failed build step) still saw the 's-…' placeholder, went
        // out as `newConversation: true` and opened a SECOND thread: not the free
        // first build's thread, so it paid and was refused. `createConversation` is
        // the same POST the SDK makes lazily (same route: the turn's project or the
        // active workspace, empty body), only made first: the thread points at the
        // real id at once, and the in-flight mark is written again with it, so a
        // reload mid-turn restores this thread. No method on the SDK, or the create
        // fails: the SDK makes the thread with the message, as before.
        const _sendTurn = (payload, callbacks)=>{
            if (!wantsNewConversation || typeof ai.createConversation !== 'function') {
                ai.dispatch(payload, callbacks);
                return;
            }
            Promise.resolve().then(()=>ai.createConversation(payload.projectId ? {
                    projectId: payload.projectId
                } : {})).then((conv)=>{
                const id = conv && (conv.id || conv._id);
                if (!id) return;
                // the turn goes into the conversation made for it, even when the
                // person opened another thread meanwhile (that one is not repointed)
                payload.conversationId = String(id);
                payload.newConversation = false;
                if (!_adoptTurnConversation(id)) return;
                try {
                    const markEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                    if (markEl && typeof markEl.call === 'function') markEl.call('markThreadTurn', scope, true);
                } catch (_) {
                /* best-effort — persistence is never a blocker on sending */ }
            }, (err)=>{
                console.warn('[simone] the new thread was not made first:', err?.message || err);
            }).then(()=>ai.dispatch(payload, callbacks));
        };
        _sendTurn(_turnPayload, _turnCallbacks = {
            onChunk: (delta)=>{
                if (turn.stopped || turn.superseded) return;
                buffered += delta;
                if (!_firstTokenPainted) {
                    _firstTokenPainted = true;
                    _flushStream();
                    return;
                }
                if (!_flushTimer) _flushTimer = setTimeout(_flushStream, 60);
            },
            onDone: (result)=>{
                // A superseded turn's stream ends with the NEXT turn's answer — that
                // answer is the new turn's, through its own callbacks.
                if (turn.superseded) return;
                _cancelPendingFlush();
                _stopElapsedTimer();
                $7de1124d1ac82d24$var$_settleRetryingTools(root, assistantId, k);
                // A STOPPED turn the server finished anyway: keep the thread
                // continuable (a new thread's id) and the reply in the server's
                // id-space — never its answer, its hand-offs or its voice. Then the
                // follow-up that waits for it may go.
                if (turn.stopped) {
                    if (root?.update) {
                        const patch = {};
                        if (result?.conversationId) patch[k + 'activeSessionId'] = result.conversationId;
                        if (result?.messageId) patch[k + 'chatMessages'] = (root[k + 'chatMessages'] || []).map((m)=>m && m.id === assistantId ? {
                                ...m,
                                id: String(result.messageId)
                            } : m);
                        if (Object.keys(patch).length) root.update(patch);
                    }
                    try {
                        const callEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                        if (callEl && typeof callEl.call === 'function') {
                            callEl.call('markThreadTurn', scope, false);
                            callEl.call('refreshSessionsAfterTurn', scope);
                        }
                    } catch (_) {
                    /* best-effort — history refreshes on its next read */ }
                    _settleTurn();
                    return;
                }
                // The loop ended with a question of this turn still open: the server
                // closed its call (the SDK never ends a turn while a client call
                // runs), so the card closes too — nothing is posted for it.
                $7de1124d1ac82d24$var$_endWaitingCards((w)=>$7de1124d1ac82d24$var$_waitsInThread(w, root, k, turn.thread), 'end', null);
                // The server's final answer is the post-tool summary. When it is
                // MISSING (provider produced no final text / the tail was lost),
                // fall back to the WHOLE buffered narration — never just the
                // post-last-tool slice. Earlier segments may also live in tool rows
                // as notes; that duplication is strictly better than what shipped:
                // slicing from `narratedUpto` dropped every word streamed before
                // the last tool call, so answers rendered starting mid-sentence
                // ("the Backlog column\n3. Open it…" — dev.my 2026-08-11).
                let finalText = (0, $1vH8H.stripAnswerTrailers)(result?.text) || $7de1124d1ac82d24$var$_stripSuggestTail(buffered) || '';
                // Follow-up suggestions (server-validated, from the assistant
                // message's metadata) ride the message row — ChatMessage renders
                // them as tappable pills under the newest reply.
                const suggestions = Array.isArray(result?.suggestions) ? result.suggestions : [];
                // The assistant message's raw metadata (tickets/opus.md
                // "credits-exhausted UX") — `{ kind:'error', errorCode,
                // errorMessage, retryable, creditsExhausted }` when
                // failWorkspaceLoop synthesized this answer after a loop failure,
                // null on a normal answer. Rides the row exactly like
                // `suggestions` above so ChatMessage's onInit/onUpdate hook can key
                // off `s.metadata` to fire the role-aware notification/banner.
                let metadata = result?.metadata || null;
                // AI-302 — tool-call protocol text must never render as the answer.
                // Post-AI-203 the server recovers these on live turns; this is the
                // state-layer backstop for provider paths that bypass the fixed
                // loop. The raw text survives in metadata for diagnosis.
                const leakCheck = (0, $472jS.sanitizeAssistantProtocolText)(finalText);
                if (leakCheck.leaked) {
                    finalText = leakCheck.text;
                    metadata = {
                        ...metadata || {},
                        protocolLeak: true,
                        rawProtocolText: leakCheck.raw
                    };
                }
                // S1 (NIKA BATCH 2026-08-16) — server's authoritative token count,
                // present on both the streaming and non-streaming AiChatService
                // response shapes (`{ promptTokens, completionTokens }`). null/{}
                // (a turn with no thread, or a provider that never reported usage)
                // both resolve to null so ChatMessage can tell "no data" from
                // "zero tokens" — see its own PvUsage hide: gate.
                const usage = result?.usage && typeof result.usage.completionTokens === 'number' ? result.usage : null;
                // GROUNDING (spec §4.2–4.3). The server returns both on the
                // dispatch result; older/streaming shapes carry them on the
                // assistant message's metadata instead, so read the result first
                // and fall back to metadata — the SAME two-place read
                // sessions._toChatMessages does when it restores a reloaded thread,
                // so a live turn and a reloaded one render identically.
                //
                // `confidence` stays null when neither place has one; ChatMessage
                // renders the muted "Unscored" pill for that, never nothing.
                const sources = Array.isArray(result?.sources) ? result.sources : Array.isArray(metadata?.sources) ? metadata.sources : [];
                const confidence = result?.confidence && typeof result.confidence === 'object' ? result.confidence : metadata?.confidence && typeof metadata.confidence === 'object' ? metadata.confidence : null;
                // The same two-place read for the advice level (vault spec 06 §7).
                const level = result?.level && typeof result.level === 'object' ? result.level : metadata?.level && typeof metadata.level === 'object' ? metadata.level : null;
                // The last call's words show ONCE. The words a model streams beside
                // a call (core-wl callText: saved on the tool-call message, server
                // 84527812) became that call's NOTE at its `started` frame. Two
                // cases put those same words in the answer too — show them as the
                // answer and clear the note, never both:
                //   · the final answer REPEATS the note (whitespace-normalized) —
                //     the model said it beside the call, then again as its answer,
                //     streamed after the call (approved (A), _simone/callNote.js);
                //   · the turn ENDS on its call (nothing streamed after it) and the
                //     server's final text is empty or the whole narration.
                let toolsPatch = null;
                const row = (root?.[k + 'chatMessages'] || []).find((m)=>m.id === assistantId);
                const tools = Array.isArray(row?.tools) ? row.tools : [];
                const lastNoted = tools.length ? tools[tools.length - 1] : null;
                const note = lastNoted && typeof lastNoted.note === 'string' ? lastNoted.note.trim() : '';
                if (note) {
                    const said = String(finalText || '').trim();
                    const endsOnCall = !$7de1124d1ac82d24$var$_stripSuggestTail(buffered.slice(narratedUpto)).trim();
                    if ((0, $9C8Ov.repeatsNote)(finalText, note)) toolsPatch = tools.map((t, i)=>i === tools.length - 1 ? {
                            ...t,
                            note: null
                        } : t);
                    else if (endsOnCall && (!said || said === $7de1124d1ac82d24$var$_stripSuggestTail(buffered).trim())) {
                        finalText = lastNoted.note;
                        toolsPatch = tools.map((t, i)=>i === tools.length - 1 ? {
                                ...t,
                                note: null
                            } : t);
                    }
                }
                // A turn the server refused for CREDITS (INSUFFICIENT_CREDITS /
                // SPEND_CAP_EXCEEDED / ALLOCATION_EXCEEDED) shows the shell's own
                // sentence and way out, never the server's prose — which named a
                // page the product does not have, told an admin to ask an admin, and
                // led with "Before this error, the following actions completed
                // successfully…". Last, so nothing above can put server text back.
                // The figures ride the metadata for the banner. Same gate as a
                // history reload: functions/creditsRefusal.js.
                const refused = $7de1124d1ac82d24$var$_creditsRow(finalText, metadata, root);
                if (refused) {
                    finalText = refused.text;
                    metadata = refused.metadata;
                }
                $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                    ...toolsPatch ? {
                        tools: toolsPatch
                    } : {},
                    text: finalText,
                    streaming: false,
                    suggestions: suggestions,
                    metadata: metadata,
                    usage: usage,
                    sources: sources,
                    confidence: confidence,
                    level: level
                }, k);
                if (root?.update) {
                    const patch = {
                        [k + 'chatTyping']: false,
                        [k + 'currentAssistantId']: null
                    };
                    // Track the conversation this turn used as the active thread — a NEW
                    // thread's id is created server-side on the first message, so capture
                    // it here (without it, the next message can't continue this thread).
                    if (result?.conversationId) patch[k + 'activeSessionId'] = result.conversationId;
                    // Re-key the optimistic assistant message into the SERVER id-space so
                    // the live buffer and the reloaded history (getConversation) share ONE
                    // id-space. Without this the synthetic `a-…` id never matches the
                    // server `_id`, so on the next thread switch/reload the message
                    // duplicates or vanishes and id-keyed grouping/patching glitches (BUG 4).
                    if (result?.messageId) patch[k + 'chatMessages'] = (root[k + 'chatMessages'] || []).map((m)=>m && m.id === assistantId ? {
                            ...m,
                            id: String(result.messageId)
                        } : m);
                    // Intent-specific UI hand-off — action proposals go to the
                    // AiActionConfirmCard via _aiActionProposals (the SDK
                    // populates that field when authMode==='ask'). build /
                    // answer intents just render as the assistant text we
                    // already appended above.
                    if (result?.intent === 'action' && Array.isArray(result.actions) && result.requiresConfirmation) patch._aiActionProposals = result.actions;
                    else if (result?.intent === 'build' && result.spec) patch.freestyleBuildSpec = result.spec;
                    root.update(patch);
                    // BUILD-SPEC RENDER FALLBACK — if the cloud returned a build spec
                    // with renderable DOMQL `source` but did NOT drive the
                    // render_extension_page client tool itself (older agent / dispatch
                    // path that only emits the spec), render it here so a prompt still
                    // produces a live app. The render goes through the SAME guarded
                    // injectPageInApp path (audit + scoped data bridge + isolated
                    // iframe), so it's no less safe than the tool-driven path. Guard:
                    // only when a source string is present AND no client-tool render
                    // already happened this turn (the tool sets _addAppRendered:true).
                    try {
                        const spec = result?.intent === 'build' ? result.spec : null;
                        const specSource = spec && (spec.source || spec.domql || spec.code);
                        if (specSource && typeof specSource === 'string' && !$7de1124d1ac82d24$var$_extensionRenderedThisTurn && scope === 'addapp') {
                            const callEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                            if (callEl && typeof callEl.call === 'function') // Route through the guarded client-tool path (allow-list +
                            // audit + scoped bridge) rather than calling the render
                            // directly — same gate the cloud tool uses.
                            $7de1124d1ac82d24$var$_runPlatformTool(callEl, 'injectPageInApp', [
                                {
                                    name: spec.name || 'Extension',
                                    source: specSource,
                                    projectId: spec.projectId || spec.extensionId || null,
                                    entities: spec.entities || spec.dataEntities || []
                                }
                            ]).catch((err)=>console.warn('[simone] build-spec render fallback failed:', err?.message || err));
                        }
                    } catch (err) {
                        console.warn('[simone] build-spec render fallback threw:', err?.message || err);
                    }
                }
                // Autosave the (scoped) thread list; add-app also refreshes its sidebar
                // since a build may have created/updated an extension.
                try {
                    const callEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                    if (callEl && typeof callEl.call === 'function') {
                        // The turn is over — settle the in-flight flag BEFORE the thread
                        // list refresh, so a reload landing between the two never claims
                        // an interruption that did not happen.
                        callEl.call('markThreadTurn', scope, false);
                        callEl.call('refreshSessionsAfterTurn', scope);
                        if (scope === 'addapp') callEl.call('loadAddAppExtensions', root);
                    }
                } catch (_) {
                /* best-effort — history just won't refresh until reload */ }
                // Speak the reply (ElevenLabs, Simone's voice) — the SAME pipeline
                // wrote the text; speakReply only voices it. Fire-and-forget with
                // silent degrade (pref off / no key / autoplay refusal / live voice
                // session all no-op — the text is already on screen).
                try {
                    const callEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                    if (finalText && callEl && typeof callEl.call === 'function') callEl.call('speakReply', finalText);
                } catch (_) {}
                _settleTurn();
            },
            onError: (err)=>{
                if (turn.superseded) return;
                $7de1124d1ac82d24$var$_settleRetryingTools(root, assistantId, k);
                _cancelPendingFlush();
                // A STOPPED turn that failed on the server: nothing to say about it
                // (the person stopped it); the follow-up that waits for it may go.
                if (turn.stopped) {
                    _stopElapsedTimer();
                    try {
                        const markEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                        if (markEl && typeof markEl.call === 'function') markEl.call('markThreadTurn', scope, false);
                    } catch (_) {}
                    if (root?.update && err && err.conversationId) root.update({
                        [k + 'activeSessionId']: err.conversationId
                    });
                    _settleTurn();
                    return;
                }
                if (!_goneThreadRetried && !buffered && err && err.status === 404) {
                    _goneThreadRetried = true;
                    const freshId = `s-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
                    turn.thread = freshId;
                    if (root?.update) root.update({
                        [k + 'activeSessionId']: freshId
                    });
                    ai.dispatch({
                        ..._turnPayload,
                        conversationId: null,
                        newConversation: true
                    }, _turnCallbacks);
                    return;
                }
                // A LOST CONNECTION — or a 409, a turn already running — while the
                // server works on: follow the turn, never declare it failed (see
                // _followDetachedTurn — sam, round 1b).
                const detachedConv = err && err.conversationId || activeConvId || null;
                if ($7de1124d1ac82d24$var$_turnMayStillRun(err) && detachedConv && !String(detachedConv).startsWith('s-') && ai && typeof ai.getConversation === 'function') {
                    console.warn("[simone] the connection dropped while the turn ran \u2014 following it:", err?.message || err);
                    _followAfterDrop(err, detachedConv);
                    return;
                }
                _failTurn(err);
            },
            // Client (browser) tool: the cloud loop suspended and wants a platform
            // action run HERE, in the user's workspace UI, then the outcome posted
            // back so the loop resumes. The server already resolved the el.call fn +
            // positional args (data.fn / data.args); we run it through a guarded
            // allow-list and return the result for the SDK to submit. window.__wsRoot
            // is the live root element (app.js); _installerEl is the fallback.
            onToolCall: (callId, tool, args, data)=>{
                // A superseded turn runs nothing and answers nothing: a result
                // handed back here would be POSTed into the new message's turn.
                if (turn.superseded) return new Promise(()=>{});
                // Every call this page received: a follow after a dropped connection
                // never offers (and runs) one of them a second time, nor does a load.
                $7de1124d1ac82d24$var$_noteClientCall(callId, root);
                // A stopped turn runs no client action: the refusal goes back to the
                // loop, which then ends sooner (and frees the conversation's lock).
                if (turn.stopped) return Promise.resolve({
                    ok: false,
                    error: "The person stopped this turn \u2014 this action did not run."
                });
                const callEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl;
                const fn = data && data.fn || '';
                const fnArgs = Array.isArray(data?.args) ? data.args : Array.isArray(args) ? args : [];
                // Thread THIS dispatch's root + scope through — chat-surface tools
                // (renderCards / askUser) must attach to the thread that asked, not
                // to whatever _cardScope guesses from global state (a suspended or
                // orphaned turn in another scope used to hijack the cards — the
                // "timeline shows ✓ but no card appears" bug).
                //
                // Through the authorization gate: in "Ask first" mode an effectful
                // call pauses on its timeline row (Run / Skip) until the user
                // answers; reads and Auto mode pass straight through.
                return $7de1124d1ac82d24$export$695c27f322c1f4a7(callEl, root, k, // `data.confirm` is the tool registry's own "ask the user" flag —
                // pass it through, or a confirm-gated tool that merely LOOKS
                // read-only runs with no consent (found live 2026-08-30).
                // `askText`: the person's own words for this turn — a create they
                // asked for runs at once (D2, runClientToolWithAuth).
                {
                    callId: callId,
                    tool: tool,
                    fn: fn,
                    args: fnArgs,
                    confirm: !!(data && data.confirm),
                    readOnly: !!(data && data.readOnly),
                    askText: text
                }, ()=>$7de1124d1ac82d24$var$_rememberRun(root, turn.thread, {
                        callId: callId,
                        tool: tool,
                        fn: fn,
                        readOnly: !!(data && data.readOnly)
                    }, $7de1124d1ac82d24$var$_runPlatformTool(callEl, fn, fnArgs, {
                        root: root,
                        k: k,
                        readOnly: !!(data && data.readOnly),
                        callId: callId
                    }))).then((res)=>{
                    // Superseded while it waited: the server closes the call under
                    // the new message — the SDK must not post anything for it.
                    if (res && res.superseded) return new Promise(()=>{});
                    // AI-301 (tickets/ai.md) — the truth about a write lives in the
                    // tool's own return value, and only the CLIENT ever sees it (the
                    // server's `completed` frame reduces it to a summary string).
                    // Stamp the structured outcome onto the timeline row here, at the
                    // only point it exists, so ChatToolRow can render the created item
                    // as a live link. Pass-through: the SDK still gets `res` verbatim.
                    const created = (0, $8WAnX.toolOutcome)(res);
                    if (created) $7de1124d1ac82d24$var$_patchToolActivity(root, {
                        phase: 'result',
                        callId: callId,
                        tool: tool,
                        created: created
                    }, k);
                    // A REFUSED client tool names its reason on its row, and in the
                    // console for whoever reads the run (Keepz DEV 2026-10-15: two
                    // refused render_answer_ui draws showed a bare ✗ — a parse error
                    // and a `Badge` refusal no one could see; the model's own retry
                    // drew the third). Only the client holds the structured result —
                    // the server's completed frame reduces it to the error code.
                    // A step that could not run any more (expireParkedAiToolApproval)
                    // already says so on its row, in the person's words; the reason
                    // in `res` is the loop's.
                    // A step the person SKIPPED is no failure (dev 2026-10-30: Skip
                    // logged "[simone] delete_ticket failed: The user declined this
                    // action."): the gate's own settle `{ ok: false, denied: true }`
                    // (resolveAiToolApproval; a turn that ended while the step waited,
                    // settleParkedAiToolApprovals) leaves the row "skipped" and the
                    // console quiet — as a reload reads it (sessions.js
                    // _skippedAtTheGate). The SDK still posts it as it is.
                    const failure = res && (res.notRun || res.denied) ? null : (0, $8WAnX.toolFailure)(res);
                    if (failure) {
                        $7de1124d1ac82d24$var$_patchToolActivity(root, {
                            phase: 'result',
                            callId: callId,
                            tool: tool,
                            failure: failure
                        }, k);
                        console.warn(`[simone] ${tool} failed: ${failure}`);
                    }
                    return res;
                });
            },
            // Structured tool-activity frames for EVERY tool the loop runs (server
            // and client alike) — upserted onto the streaming message's `tools`
            // array, which ChatMessage renders as the live agentic timeline. On a
            // `started` frame, everything narrated since the last tool becomes
            // THIS row's reasoning note and the bubble resets for the next segment.
            onToolEvent: (evt)=>{
                if (turn.stopped || turn.superseded) return;
                // The server's close of a superseded step rides the NEW turn's
                // stream: that row already says what happened, where it sits.
                if (evt && evt.callId != null && $7de1124d1ac82d24$var$_supersededCalls.has(String(evt.callId))) return;
                // The server closed a question this turn still waits on (its close
                // of the call — another page's message, say): the card closes as
                // ended and nothing is posted; the frame adds nothing to the row.
                if (evt && evt.phase === 'completed' && evt.ok === false && evt.callId != null && $7de1124d1ac82d24$var$_endWaitingCards((w)=>w.root === root && w.callId === String(evt.callId), 'end', null) > 0) return;
                if (evt && evt.phase === 'started') {
                    // Cancel any queued delta flush BEFORE resetting the bubble — a
                    // throttled flush firing after this reset would repaint the
                    // previous segment's text into the freshly-emptied bubble.
                    _cancelPendingFlush();
                    const note = buffered.slice(narratedUpto).trim();
                    narratedUpto = buffered.length;
                    if (note) evt = {
                        ...evt,
                        note: note
                    };
                    $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                        text: ''
                    }, k);
                }
                $7de1124d1ac82d24$var$_patchToolActivity(root, evt, k);
                // The page's write hooks: the add-app preview, the site builder and
                // the open canvas follow the turn's writes (_afterToolFrame).
                _afterToolFrame(evt);
            },
            // Discard boundary: the server threw away an unpersisted first draft
            // (leaked build call / scratchpad dump, see tickets/opus.md
            // AIUX-STREAM) and is about to rerun the whole loop from scratch. Both
            // generations stream over the SAME onChunk channel with no other
            // marker, so without this the retry's tokens silently continue the
            // first draft's bubble and the user watches one answer get replaced
            // by an unrelated one. Clear the buffer and blank the bubble at the
            // exact point the server discarded its draft, mirroring the
            // tool.activity 'started' bubble-reset above.
            onReset: ()=>{
                if (turn.stopped || turn.superseded) return;
                _cancelPendingFlush();
                buffered = '';
                narratedUpto = 0;
                $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                    text: ''
                }, k);
            },
            // Live active-process events from delegated/chained sub-agents. Maintain a
            // SCOPE-aware activeProcesses[] (k-prefixed, like the rest of the chat
            // state) that the Chat process panel renders: push on agent.started, patch
            // the matching entry on agent.completed. A fresh turn's first start RETAINS
            // the previous (all-finished) batch into runHistory (capped) — the
            // multi-agent view — instead of dropping it, then resets the live list.
            onProcessActive: (data)=>{
                if (!root?.update || !data || turn.superseded) return;
                let list = (root[k + 'activeProcesses'] || []).slice();
                // Undefined → leave runHistory untouched; set → retain the finished
                // batch. Applied together with activeProcesses in ONE root.update at the
                // end so the rotate is a single (not double) reactive invalidation.
                let nextHistory;
                if (data.event === 'agent.started') {
                    if (list.length && list.every((p)=>p.status !== 'running')) {
                        const hist = root[k + 'runHistory'] || [];
                        nextHistory = [
                            ...list.map((p)=>({
                                    ...p
                                })),
                            ...hist
                        ].slice(0, 30);
                        list = [];
                    }
                    list.push({
                        id: data.processId,
                        agentId: data.agentId || '',
                        agentName: data.agentName || '',
                        seedSlug: data.seedSlug || null,
                        role: data.role || '',
                        mode: data.mode || '',
                        step: typeof data.step === 'number' ? data.step : null,
                        task: data.task || '',
                        status: 'running',
                        startedAt: Date.now()
                    });
                } else if (data.event === 'agent.completed') {
                    const idx = list.findIndex((p)=>p.id === data.processId);
                    const done = {
                        status: data.status === 'error' ? 'error' : 'done',
                        result: data.result || '',
                        error: data.error || '',
                        toolsUsed: Array.isArray(data.toolsUsed) ? data.toolsUsed : [],
                        durationMs: data.durationMs || 0
                    };
                    if (idx >= 0) list[idx] = {
                        ...list[idx],
                        ...done
                    };
                    else list.push({
                        id: data.processId,
                        agentId: data.agentId || '',
                        agentName: data.agentName || '',
                        seedSlug: data.seedSlug || null,
                        ...done
                    });
                }
                root.update(nextHistory !== undefined ? {
                    [k + 'activeProcesses']: list,
                    [k + 'runHistory']: nextHistory
                } : {
                    [k + 'activeProcesses']: list
                });
            }
        });
    };
}
// ── Local mode (targetMode 'local') — real simone-bridge round-trip ──────
// The drawer's Local target talks to the SAME local bridge that standalone
// simone / the chrome extension use. This transport keeps OWNING
// window.__simoneSendOverBridge and routes per send (local → WS port,
// anything else → sdk.ai), so the two transports never fight over the
// global. bridgeStatus stays honest per mode: in local mode it mirrors the
// real socket (composer disables while the bridge is down); leaving local
// restores sdk.ai's forced 'open'. Lifecycle is driven by the
// AssistantDrawer's targetMode watcher (app.js) via el.call.
const $7de1124d1ac82d24$var$LOCAL_BRIDGE_URL = 'ws://localhost:8765';
let $7de1124d1ac82d24$var$_localPort = null;
function $7de1124d1ac82d24$export$afc9db6391abc351() {
    if (typeof window === 'undefined') return;
    // Prefer the calling element's live root (el.call binds `this`); fall back
    // to the installer's root for non-element callers.
    const root = this && this.state && this.state.root || $7de1124d1ac82d24$var$_shellResolveRoot(null);
    if (!root || typeof root.update !== 'function') return;
    const local = root.targetMode === 'local';
    if (local && !$7de1124d1ac82d24$var$_localPort) {
        // Entering local mode — open the direct bridge socket. Status events are
        // applied only while local mode is STILL active (a late 'closed' after
        // switching back must not clobber sdk.ai's 'open').
        root.update({
            bridgeStatus: 'connecting',
            bridgeUrl: $7de1124d1ac82d24$var$LOCAL_BRIDGE_URL,
            agent: null
        });
        const port = (0, $cwTCb.createDirectWsPort)($7de1124d1ac82d24$var$LOCAL_BRIDGE_URL);
        $7de1124d1ac82d24$var$_localPort = port;
        const sendToBridge = (payload)=>{
            try {
                port.postMessage({
                    type: 'send',
                    payload: payload
                });
            } catch (_) {}
        };
        port.onMessage.addListener((msg)=>{
            if ($7de1124d1ac82d24$var$_localPort !== port) return; // torn down — drop stragglers
            const live = $7de1124d1ac82d24$var$_shellResolveRoot(null) || root;
            if (!live || live.targetMode !== 'local') return;
            if (msg.type === 'bridge_status') {
                live.update({
                    bridgeStatus: msg.status,
                    bridgeUrl: $7de1124d1ac82d24$var$LOCAL_BRIDGE_URL
                });
                return;
            }
            if (msg.type === 'bridge_message') {
                (0, $cwTCb.handleBridgePayload)(live, msg.payload, null, sendToBridge);
                return;
            }
            (0, $cwTCb.handleAgentEvent)(live, msg, sendToBridge);
        });
    } else if (!local && $7de1124d1ac82d24$var$_localPort) {
        // Leaving local mode — tear the socket down (stops its reconnect loop)
        // and restore the sdk.ai transport's healthy status.
        try {
            $7de1124d1ac82d24$var$_localPort.close();
        } catch (_) {}
        $7de1124d1ac82d24$var$_localPort = null;
        root.update({
            bridgeStatus: 'open',
            bridgeUrl: 'sdk.ai',
            agent: 'sdk-ai',
            chatTyping: false
        });
    }
}
function $7de1124d1ac82d24$export$e179c1d63fbcf026() {
    return $7de1124d1ac82d24$export$afc9db6391abc351.call(this);
}
// Hide the machine-readable follow-up trailer from the LIVE bubble while the
// answer streams — the server strips it from the FINAL text (and returns the
// parsed buttons as result.suggestions), but raw deltas arrive unstripped.
// Also hides a PARTIAL opening marker split across deltas ('<', '<!--SUG', …)
// so no fragment ever flashes; a legit answer ending in one of those prefixes
// gets it back when onDone swaps in the final text.
// All four machine markers (SUGGEST | SOURCES | CONFIDENCE | LEVEL), complete,
// cut off or split across deltas — the one stripper (_simone/answerTrailers.js).
const $7de1124d1ac82d24$var$_stripSuggestTail = (text)=>(0, $1vH8H.stripAnswerTrailers)(text, {
        partial: true
    });
function $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, id, patch, k = '') {
    if (!root?.update) return;
    const list = root[k + 'chatMessages'] || [];
    const next = list.map((m)=>m.id === id ? {
            ...m,
            ...patch
        } : m);
    root.update({
        [k + 'chatMessages']: next
    });
}
function $7de1124d1ac82d24$var$_shellPushSystemMessage(root, text, k = '') {
    if (!root?.update) return;
    const next = (root[k + 'chatMessages'] || []).concat({
        id: `sys-${Date.now()}`,
        role: 'system',
        text: text,
        ts: Date.now()
    });
    root.update({
        [k + 'chatMessages']: next
    });
}
// Extract the text parts of a server-serialized conversation message.
const $7de1124d1ac82d24$var$_messageText = (m)=>{
    if (!m) return '';
    if (typeof m.text === 'string' && m.text) return m.text;
    const parts = Array.isArray(m.content) ? m.content : [];
    return parts.filter((p)=>p && p.type === 'text' && typeof p.text === 'string').map((p)=>p.text).join('\n').trim();
};
// After a turn error, the server may well have COMPLETED the turn — the
// client connection died, not the loop (proven live 2026-08-11: three
// "couldn't reach the server" bubbles whose real answers were persisted
// server-side, including an admission the user never saw). Re-read the
// conversation on a short backoff; if an assistant text message from AFTER
// the turn start exists, adopt it into the errored bubble. Every read hands
// the turn's settled steps (matched by the text it sent) to `onSteps`, so the
// page follows the writes the turn made all the same.
const $7de1124d1ac82d24$var$_reconcileAfterTurnError = ({ root: root, k: k, scope: scope, assistantId: assistantId, conversationId: conversationId, ai: ai, turnStartedAt: turnStartedAt, opts: opts, sentText: sentText, onSteps: onSteps })=>{
    const convId = conversationId || root && root[k + 'activeSessionId'] || null;
    if (!convId || !ai || typeof ai.getConversation !== 'function') return;
    const delays = [
        2500,
        6000,
        12000
    ];
    let attempt = 0;
    const tryOnce = ()=>{
        attempt++;
        Promise.resolve().then(()=>ai.getConversation(convId, opts || {})).then((conv)=>{
            if (typeof onSteps === 'function') onSteps($7de1124d1ac82d24$var$_turnReadOf(conv, sentText).steps);
            const msgs = conv && (conv.messages || conv.data?.messages || conv.conversation?.messages) || [];
            let adopted = null;
            for(let i = msgs.length - 1; i >= 0; i--){
                const m = msgs[i];
                if (!m || m.role !== 'assistant') continue;
                const text = $7de1124d1ac82d24$var$_messageText(m);
                if (!text) continue;
                const ts = Date.parse(m.createdAt || m.created_at || '') || 0;
                if (ts && ts >= turnStartedAt - 2000) {
                    adopted = {
                        text: text,
                        id: m.id || m._id,
                        metadata: m.metadata || null
                    };
                    break;
                }
            }
            if (adopted) {
                // The turn the connection lost may have been the one the server
                // refused for credits: the shell's sentence, not its prose.
                const refused = $7de1124d1ac82d24$var$_creditsRow(adopted.text, adopted.metadata, root);
                $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, assistantId, {
                    text: refused ? refused.text : adopted.text,
                    ...refused ? {
                        metadata: refused.metadata
                    } : {},
                    streaming: false,
                    turnError: false,
                    recovered: true
                }, k);
                try {
                    const callEl = typeof window !== 'undefined' && window.__wsRoot || null;
                    if (callEl && typeof callEl.call === 'function') callEl.call('refreshSessionsAfterTurn', scope);
                } catch (_) {}
                return;
            }
            if (attempt < delays.length) setTimeout(tryOnce, delays[attempt]);
        }).catch(()=>{
            if (attempt < delays.length) setTimeout(tryOnce, delays[attempt]);
        });
    };
    setTimeout(tryOnce, delays[0]);
};
// ── A dropped connection is not a failed turn ───────────────────────────────
// sam, round 1b: the screen said "Sorry — I couldn't reach the server" twice
// (a CORS error in the console) while the server finished the turn — the
// answer showed only after the app was reopened — and an approval the turn
// waited on was settled as "skipped" by that same error. The SDK fails the
// whole turn when its event stream breaks (a proxy cuts a long stream; an
// error page without CORS headers reads as a bare fetch failure), but the
// server's loop keeps running. So a LOST CONNECTION detaches the turn instead
// of failing it: the bubble says the work goes on, a parked approval stays
// live, and the conversation is FOLLOWED until the answer lands — the result
// shows where it was asked. Only when the server never got the message, or
// nothing lands in the follow window, is the failure declared.
// The turn may still run: a lost connection — the same class
// userFacingErrorMessage words as "couldn't reach the server"
// (`NETWORK_UNREACHABLE`, the fetch-failure message shapes), a stream the SDK
// saw break (`STREAM_INTERRUPTED` / `STREAM_TRUNCATED`), a gateway's 502 / 503
// / 504 — or the server's own 409: a turn of this conversation is already
// running (CORE builder-r2: a slow builder turn answers 202 and streams). Any
// other status is the server's own answer: a failed turn.
const $7de1124d1ac82d24$var$_turnMayStillRun = (err)=>{
    if (!err) return false;
    const status = Number(err.status);
    if (err.status != null && Number.isFinite(status) && status > 0) return status === 409 || status === 502 || status === 503 || status === 504;
    const code = String(err.code || '');
    if (code === 'NETWORK_UNREACHABLE' || code === 'STREAM_INTERRUPTED' || code === 'STREAM_TRUNCATED') return true;
    return /failed to fetch|network unreachable|networkerror|load failed/i.test(String(err.message || ''));
};
// The SETTLED tool steps of a saved transcript, from message `from` on: a tool
// call and the result the server saved after it, in order —
// { callId, tool, args, ok }. `callId` is the call message's own id: the id the
// live frames named the call by (the server publishes the tool_call message's
// `_id` as the frame's callId). A call with no result yet is not settled.
const $7de1124d1ac82d24$var$_settledStepsFrom = (msgs, from)=>{
    const steps = [];
    let open = null;
    for(let i = Math.max(0, from); i < msgs.length; i++){
        const m = msgs[i];
        const parts = m && Array.isArray(m.content) && m.content || [];
        const call = parts.find((p)=>p && p.type === 'tool_call');
        if (call) {
            const payload = call.payload || {};
            open = {
                callId: String(m.id || m._id || ''),
                tool: typeof payload.name === 'string' ? payload.name : '',
                args: payload.args && typeof payload.args === 'object' ? payload.args : null
            };
            continue;
        }
        const result = parts.find((p)=>p && p.type === 'tool_result');
        if (result && open) {
            if (open.callId && open.tool) steps.push({
                ...open,
                ok: !(result.payload && result.payload.ok === false)
            });
            open = null;
        }
    }
    return steps;
};
// What a conversation read says about ONE turn, matched by the exact text the
// turn sent (the server saves the person's message as sent): no clock skew, and
// never an earlier turn's answer. → { arrived, answer, pending, closed(id), steps }:
//   arrived  the server holds this turn's message;
//   answer   its newest assistant TEXT after that message (a tool-call message
//            is a step, not an answer) — { text, id, metadata };
//   pending  the client call the server waits on, unless it is answered;
//   closed   a client call the server has a result for (answered or closed);
//   steps    the turn's settled tool steps (_settledStepsFrom).
const $7de1124d1ac82d24$var$_turnReadOf = (conv, sentText)=>{
    const data = conv && typeof conv === 'object' && conv.data && !conv.messages ? conv.data : conv;
    const msgs = data && (data.messages || data.conversation?.messages) || [];
    const sent = String(sentText || '').trim();
    let userIdx = -1;
    for(let i = msgs.length - 1; i >= 0; i--){
        const m = msgs[i];
        if (m && m.role === 'user' && $7de1124d1ac82d24$var$_messageText(m).trim() === sent) {
            userIdx = i;
            break;
        }
    }
    const isStep = (m)=>Array.isArray(m.content) && m.content.some((p)=>p && p.type === 'tool_call') || m.metadata && m.metadata.kind === 'tool_call';
    let answer = null;
    for(let i = msgs.length - 1; userIdx >= 0 && i > userIdx; i--){
        const m = msgs[i];
        if (!m || m.role !== 'assistant' || isStep(m)) continue;
        const text = $7de1124d1ac82d24$var$_messageText(m);
        if (text) {
            answer = {
                text: text,
                id: m.id || m._id || null,
                metadata: m.metadata || null
            };
            break;
        }
    }
    // the transcript's own proof that a call is settled — one
    // `workspace_client_action` message per resolved call (the same reading as
    // _simone/pendingClientCall.js isClientCallResolved)
    const closed = (id)=>msgs.some((m)=>m && m.metadata && m.metadata.kind === 'workspace_client_action' && String(m.metadata.callId || '') === String(id));
    const p = data && data.conversation && data.conversation.metadata;
    const pending = (0, $czZQn.normalizePendingClientCall)(p && p.pendingClientCall);
    return {
        arrived: userIdx >= 0,
        answer: answer,
        pending: pending && !closed(pending.callId) ? pending : null,
        closed: closed,
        steps: userIdx >= 0 ? $7de1124d1ac82d24$var$_settledStepsFrom(msgs, userIdx + 1) : []
    };
};
// Every client call this page received (a call the SDK may still be answering
// must never be offered — and run — a second time) and every one its person
// answered. Bounded: the newest 200 ids.
const $7de1124d1ac82d24$var$_seenClientCalls = new Set();
const $7de1124d1ac82d24$var$_noteClientCall = (id, root)=>{
    if (!id) return;
    $7de1124d1ac82d24$var$_seenClientCalls.add(String(id));
    if ($7de1124d1ac82d24$var$_seenClientCalls.size > 200) $7de1124d1ac82d24$var$_seenClientCalls.delete($7de1124d1ac82d24$var$_seenClientCalls.values().next().value);
    if (root && typeof root === 'object') $7de1124d1ac82d24$var$_boundedAdd($7de1124d1ac82d24$var$_callsOf($7de1124d1ac82d24$var$_seenOnRoot, root), String(id));
};
// ── E: a loaded conversation never re-runs a step by itself ──────────────────
// Dev 2026-10-27: opening a thread (a reload, a switch back) re-offered its
// waiting client call, and the gate ran a navigation or a write that had
// already run — the page jumped, a doc opened twice. Three guards, per page
// (the shell's root) and across a reload of the same tab:
//   1. a call this page already RAN is never run again by a load: the load
//      posts the result that run gave (the server resolves a call once, so a
//      second POST of it is only acknowledged); a call this page received
//      live and did not run (declined, stopped, waiting) is the live path's,
//      and a load does not offer it;
//   2. a WRITE that ran in this tab before a reload (its result never reached
//      the server) asks before it runs again — `smbls.ai.ranCalls` in
//      sessionStorage, per conversation; only another page load's record
//      counts (this page's own memory is guard 1);
//   3. a step that moves or covers the screen asks on load instead of running
//      (ON_LOAD_ASK_FNS). The chain after it is live: the person is there.
const $7de1124d1ac82d24$var$_seenOnRoot = new WeakMap() // root → Set(callId) received live
;
const $7de1124d1ac82d24$var$_ranOnRoot = new WeakMap() // root → Map(callId → that run's result promise)
;
const $7de1124d1ac82d24$var$_callsOf = (map, root)=>{
    let set = map.get(root);
    if (!set) map.set(root, set = new Set());
    return set;
};
const $7de1124d1ac82d24$var$_ranHere = (root, callId)=>{
    const runs = root && typeof root === 'object' ? $7de1124d1ac82d24$var$_ranOnRoot.get(root) : null;
    return runs && runs.get(String(callId)) || null;
};
const $7de1124d1ac82d24$var$_boundedAdd = (set, id)=>{
    set.add(id);
    if (set.size > 200) set.delete(set.values().next().value);
};
const $7de1124d1ac82d24$var$ON_LOAD_ASK_FNS = new Set([
    'openAppPage',
    'openPageInSplit',
    'selectPageItem',
    'renderAnswerUi',
    'injectPageInApp',
    'renderMultiPageApp',
    'aiStartTour',
    'changeGlobalTheme',
    'closeAllModals',
    'globalSearch'
]);
const $7de1124d1ac82d24$var$RAN_CALLS_KEY = 'smbls.ai.ranCalls';
// This page load's mark on its records — a record with another mark was
// written before a reload.
const $7de1124d1ac82d24$var$_PAGE_LOAD = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
// Package-prefixed name: a served catalog page hoists every library's
// module-level helpers into ONE globalScope, and shared's bootTrail.js hoists
// its own `_session` (another body). The workspace-ui globalScope census fails
// on such a pair.
const $7de1124d1ac82d24$var$_simoneSessionStore = ()=>{
    try {
        return typeof window !== 'undefined' && window.sessionStorage ? window.sessionStorage : null;
    } catch (_) {
        return null;
    }
};
const $7de1124d1ac82d24$var$_readRanCalls = ()=>{
    const store = $7de1124d1ac82d24$var$_simoneSessionStore();
    if (!store) return {};
    try {
        const all = JSON.parse(store.getItem($7de1124d1ac82d24$var$RAN_CALLS_KEY) || '{}');
        return all && typeof all === 'object' && !Array.isArray(all) ? all : {};
    } catch (_) {
        return {};
    }
};
// A step RUNS (`running`, its result promise): remembered on this page with
// its result, and — a write in a real conversation — in this tab, so a reload
// before its result lands asks first. → `running`.
const $7de1124d1ac82d24$var$_rememberRun = (root, conversationId, call, running)=>{
    const id = String(call && call.callId || '');
    if (!id) return running;
    if (root && typeof root === 'object') {
        let runs = $7de1124d1ac82d24$var$_ranOnRoot.get(root);
        if (!runs) $7de1124d1ac82d24$var$_ranOnRoot.set(root, runs = new Map());
        runs.set(id, running);
        if (runs.size > 200) runs.delete(runs.keys().next().value);
    }
    const conv = String(conversationId || '');
    if (!conv || conv.startsWith('s-')) return running;
    if (call.readOnly || $7de1124d1ac82d24$export$c50056db6e7e85b9(call.tool, call.fn)) return running;
    const store = $7de1124d1ac82d24$var$_simoneSessionStore();
    if (!store) return running;
    try {
        const all = $7de1124d1ac82d24$var$_readRanCalls();
        const list = (Array.isArray(all[conv]) ? all[conv] : []).filter((e)=>e && e.c !== id);
        list.push({
            c: id,
            p: $7de1124d1ac82d24$var$_PAGE_LOAD
        });
        delete all[conv];
        all[conv] = list.slice(-20);
        const convs = Object.keys(all);
        for (const old of convs.slice(0, Math.max(0, convs.length - 20)))delete all[old];
        store.setItem($7de1124d1ac82d24$var$RAN_CALLS_KEY, JSON.stringify(all));
    } catch (_) {
    /* a full or blocked store only loses the reload guard */ }
    return running;
};
const $7de1124d1ac82d24$var$_ranBeforeReload = (conversationId, callId)=>{
    const list = $7de1124d1ac82d24$var$_readRanCalls()[String(conversationId || '')];
    return Array.isArray(list) && list.some((e)=>e && e.c === String(callId) && e.p !== $7de1124d1ac82d24$var$_PAGE_LOAD);
};
// ── B: a new message supersedes a step still waiting on Run / Skip ───────────
// The calls a new message superseded: their late frames (the server's own
// close of the call, on the NEW turn's stream) add no row anywhere.
const $7de1124d1ac82d24$var$_supersededCalls = new Set();
// Follow a detached turn: one ordinary conversation read every `everyMs`, for
// at most `forMs` (the SDK's own follow window, TURN_BACKSTOP_MAX_MS = 11 min),
// while the turn is still this thread's (a newer send, a stop or a switch takes
// it). `ctx` callbacks:
//   onSteps(steps)      every read: the turn's settled tool steps so far
//                       (_turnReadOf `steps`) — the writes the lost stream
//                       never brought reach the page from here, before the
//                       answer of the same read;
//   onAnswer(answer)    the answer landed;
//   onHandOver(pending) the server waits on a client call this page never
//                       received (the stream was down when it asked): the
//                       reload path re-offers it (reofferPendingClientCall);
//   onWaiting()         the window ended while an approval still waits for
//                       the person — the row stays live, the person decides;
//   onGiveUp()          the server never got the message (`arrivalMs`), the
//                       conversation is gone, or nothing landed;
//   onLost()            a newer send, a stop or a thread switch took the thread
//                       — the follow ends quietly (the newest turn wins).
// A parked approval the server CLOSED meanwhile (answered elsewhere, or its
// own wait ended) is expired on its row — "did not run, ask again" — never
// left offering a Run the loop can no longer honour; a question card whose
// call it closed closes too (_endWaitingCards).
const $7de1124d1ac82d24$var$_followDetachedTurn = (ctx)=>{
    const { root: root, k: k, assistantId: assistantId, conversationId: conversationId, ai: ai, sentText: sentText, opts: opts } = ctx;
    const t = {
        firstMs: 2500,
        everyMs: 4000,
        forMs: 660000,
        arrivalMs: 20000,
        ...ctx.timing || {}
    };
    const started = Date.now();
    const ours = ()=>!!root && root[k + 'currentAssistantId'] === assistantId;
    const mine = (held)=>held && held.root === root && held.k === k;
    const lost = ()=>{
        if (typeof ctx.onLost === 'function') ctx.onLost();
    };
    const tick = ()=>{
        if (!ours()) return lost();
        Promise.resolve().then(()=>ai.getConversation(conversationId, opts || {})).then((conv)=>{
            if (!ours()) return lost();
            const read = $7de1124d1ac82d24$var$_turnReadOf(conv, sentText);
            if (typeof ctx.onSteps === 'function') ctx.onSteps(read.steps);
            // A question whose call the transcript shows closed (the server's
            // own close, or an answer from another page) closes as ended.
            $7de1124d1ac82d24$var$_endWaitingCards((w)=>mine(w) && !!w.callId && read.closed(w.callId), 'end', null);
            if (read.answer) return ctx.onAnswer(read.answer);
            for (const id of Object.keys($7de1124d1ac82d24$var$_pendingToolApprovals)){
                const waitsOnIt = read.pending && String(read.pending.callId) === id;
                if (mine($7de1124d1ac82d24$var$_pendingToolApprovals[id]) && !waitsOnIt && read.closed(id)) $7de1124d1ac82d24$var$expireParkedAiToolApproval(id, 'workspace.simone.approval.expired');
            }
            if (read.pending && !$7de1124d1ac82d24$var$_seenClientCalls.has(String(read.pending.callId))) return ctx.onHandOver(read.pending);
            if (!read.arrived && Date.now() - started >= t.arrivalMs) return ctx.onGiveUp();
            if (Date.now() - started >= t.forMs) {
                const waiting = Object.keys($7de1124d1ac82d24$var$_pendingToolApprovals).some((id)=>mine($7de1124d1ac82d24$var$_pendingToolApprovals[id]));
                return waiting ? ctx.onWaiting() : ctx.onGiveUp();
            }
            setTimeout(tick, t.everyMs);
        }, (err)=>{
            if (!ours()) return lost();
            if (err && err.status === 404) return ctx.onGiveUp();
            if (Date.now() - started >= t.forMs) return ctx.onGiveUp();
            setTimeout(tick, t.everyMs);
        });
    };
    setTimeout(tick, t.firstMs);
};
// ── Live agentic timeline ────────────────────────────────────────────────────
// Structured tool.activity frames ({ phase:'started'|'completed', callId, tool,
// args?, ok?, summary?, label? }) upsert a `tools` array on the streaming
// assistant message; ChatMessage renders it as the tool timeline (ChatToolRow
// rows with live status), so tool traffic never appears as message text.
//
// `label` (2026-09-30 per Nika "make ai responses more user friendly"; server
// lane ai-ux): the step in plain words, at most 80 characters, in the turn's
// language — ChatToolRow shows it instead of the tool name and its argument
// hint. The completed frame's words win (they may say what the step did); a
// frame without one keeps the row's. Every row carries the key — null when
// there is no label — so the row's factories track it from the first render (a
// key absent at first render is never tracked, and a label that arrives with
// the completed frame would never show).
// THE BUILD RETRIES ITSELF (persona round 3, B3: lina, priya, elena, aiko, giorgi, tomas —
// "The app could not be saved this time." two or three times in red before the app appeared,
// and a final-looking failure while the AI was still fixing it). A refused app write is the
// builder's own check: the model fixes it and calls again in the same turn. So while the turn
// runs, that row stays a running step (its failure held as `retryFailure`); a later write of
// the app that succeeds removes the refused rows; a turn that ends with no success shows them
// as failed, with the plain reason (_settleRetryingTools, onDone / onError).
const $7de1124d1ac82d24$var$_BUILD_WRITE_TOOLS = new Set([
    'create_extension',
    'create_app',
    'update_app',
    'commit_project_changes'
]);
function $7de1124d1ac82d24$var$_settleRetryingTools(root, id, k = '') {
    const msg = (root?.[k + 'chatMessages'] || []).find((m)=>m && m.id === id);
    const tools = Array.isArray(msg?.tools) ? msg.tools : [];
    if (!tools.some((t)=>t && t.retrying)) return;
    const settled = tools.map((t)=>{
        if (!t || !t.retrying) return t;
        const { retrying: retrying, retryFailure: retryFailure, ...rest } = t;
        return {
            ...rest,
            status: 'error',
            ...retryFailure ? {
                failure: retryFailure
            } : {}
        };
    });
    $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, id, {
        tools: settled
    }, k);
}
const $7de1124d1ac82d24$var$_toolLabel = (v)=>typeof v === 'string' && (0, $1vH8H.stripAnswerTrailers)(v).trim() ? (0, $1vH8H.stripAnswerTrailers)(v).trim() : null;
function $7de1124d1ac82d24$var$_patchToolActivity(root, evt, k = '') {
    if (!root?.update || !evt || !evt.tool) return;
    let id = root[k + 'currentAssistantId'];
    if (!id) {
        // A frame landing after onDone (late approval ask, straggler completion)
        // used to be dropped entirely — the parked approval then had NO visible
        // row or buttons while the server turn stayed suspended (the "user must
        // type continue" stall). Anchor it to the newest assistant message.
        const list = root[k + 'chatMessages'] || [];
        for(let i = list.length - 1; i >= 0; i--)if (list[i] && list[i].role === 'assistant') {
            id = list[i].id;
            break;
        }
        if (!id) return;
    }
    const msg = (root[k + 'chatMessages'] || []).find((m)=>m.id === id);
    if (!msg) return;
    const key = String(evt.callId || `${evt.tool}-${Date.now()}`);
    const tools = (msg.tools || []).slice();
    const idx = tools.findIndex((t)=>t.id === key);
    if (evt.phase === 'started') {
        const entry = {
            id: key,
            tool: evt.tool,
            args: evt.args || (idx >= 0 ? tools[idx].args : null),
            // The model's narrated reasoning for this step (the text it streamed
            // before calling the tool) — rendered by ChatToolRow under the header.
            // Both this and `args` fall back to what the row ALREADY carries: a
            // started frame that names neither must not ERASE them. A history-
            // restored row holds the server's named-args object, and a re-offered
            // pending call re-starts that row (see reofferPendingClientCall) — the
            // approval card would otherwise ask about an action it cannot show.
            note: (0, $1vH8H.stripAnswerTrailers)(evt.note) || (idx >= 0 ? tools[idx].note : null),
            label: $7de1124d1ac82d24$var$_toolLabel(evt.label) || (idx >= 0 ? tools[idx].label || null : null),
            status: 'running',
            ts: Date.now()
        };
        if (idx >= 0) {
            // A started frame must never DEMOTE an authorization state — the server
            // emits started for client tools too, and its frame racing in after the
            // gate paused the row would flip "waiting for approval" back to a
            // spinner while nothing is actually running.
            const held = [
                'approval',
                'denied',
                'superseded'
            ].includes(tools[idx].status);
            tools[idx] = {
                ...tools[idx],
                ...entry,
                ...held ? {
                    status: tools[idx].status
                } : {}
            };
        } else tools.push(entry);
    } else if (evt.phase === 'approval') {
        // The authorization gate paused this call — the row renders Run / Skip and
        // resolveAiToolApproval settles it. Args from the started frame win (the
        // server's named-args object reads better than the positional array).
        const entry = {
            id: key,
            tool: evt.tool,
            args: idx >= 0 && tools[idx].args || evt.args || null,
            note: idx >= 0 && tools[idx].note || (0, $1vH8H.stripAnswerTrailers)(evt.note) || null,
            label: idx >= 0 && tools[idx].label || $7de1124d1ac82d24$var$_toolLabel(evt.label),
            status: 'approval',
            ts: idx >= 0 ? tools[idx].ts : Date.now()
        };
        if (idx >= 0) tools[idx] = {
            ...tools[idx],
            ...entry
        };
        else tools.push(entry);
    } else if (evt.phase === 'approved') {
        if (idx >= 0) tools[idx] = {
            ...tools[idx],
            status: 'running'
        };
    } else if (evt.phase === 'result') {
        // Structured outcome from the CLIENT tool's own return value (onToolCall
        // stamps it the moment the tool resolves — see toolOutcome.js). Merged in
        // place WITHOUT touching status: the server's `completed` frame arrives
        // after and spreads over the row, so `created` (a write's item) and
        // `failure` (a refusal's reason, toolFailure) survive into the final row.
        if (!evt.created && !evt.failure) return;
        const stamp = {
            ...evt.created ? {
                created: evt.created
            } : {},
            ...evt.failure ? {
                failure: evt.failure
            } : {}
        };
        if (idx >= 0) tools[idx] = {
            ...tools[idx],
            ...stamp
        };
        else tools.push({
            id: key,
            tool: evt.tool,
            args: evt.args || null,
            label: $7de1124d1ac82d24$var$_toolLabel(evt.label),
            ts: Date.now(),
            status: 'running',
            ...stamp
        });
    } else if (evt.phase === 'denied') {
        const done = {
            status: 'denied',
            doneTs: Date.now()
        };
        if (idx >= 0) tools[idx] = {
            ...tools[idx],
            ...done
        };
        else tools.push({
            id: key,
            tool: evt.tool,
            args: evt.args || null,
            label: $7de1124d1ac82d24$var$_toolLabel(evt.label),
            ts: Date.now(),
            ...done
        });
    } else {
        const summary = (0, $1vH8H.stripAnswerTrailers)(evt.summary);
        // A SERVER tool's refusal has no client stamp: its reason is the summary's
        // first line ("I couldn't complete <tool>: <reason>"); a client stamp wins.
        const serverReason = evt.ok === false && !(idx >= 0 && tools[idx].failure) ? String(summary || '').split('\n')[0].trim() : '';
        const buildWrite = $7de1124d1ac82d24$var$_BUILD_WRITE_TOOLS.has(evt.tool);
        // A failed step's summary line 2+ ("Details: <tool> failed — …") is the MODEL's, in
        // English (toolFailureLine.js on the server): the member's row keeps line 1 (B8, giorgi).
        const shown = evt.ok === false ? String(summary || '').split('\n')[0].trim() : summary;
        const done = {
            status: evt.ok === false ? 'error' : 'done',
            summary: shown,
            ...serverReason ? {
                failure: serverReason
            } : {},
            // A step that never ran (expireParkedAiToolApproval): ChatToolRow shows no
            // words written before its call under it (F3) — they were never true.
            ...evt.ok === false && evt.notRun ? {
                notRun: true
            } : {},
            label: $7de1124d1ac82d24$var$_toolLabel(evt.label) || (idx >= 0 ? tools[idx].label || null : null),
            doneTs: Date.now()
        };
        // A SERVER-run create names what it made on its completed frame (D2: a
        // task or an event the person asked for runs at once on the server, its
        // result carries the created id) — the same `created` a client tool
        // stamps, so the row reads Created · Open · Undo.
        const made = (0, $8WAnX.toolOutcome)({
            ok: evt.ok !== false,
            created: evt.created
        });
        if (made) done.created = made;
        if (evt.ok === false && buildWrite) {
            done.status = 'running';
            done.retrying = true;
            delete done.failure;
            if (serverReason) done.retryFailure = serverReason;
        }
        if (idx >= 0) {
            // A denied row stays denied — the loop's completed frame (carrying the
            // ok:false the denial itself produced) is bookkeeping, not a failure.
            // A superseded row stays superseded the same way.
            const kept = [
                'denied',
                'superseded'
            ].includes(tools[idx].status) ? tools[idx].status : '';
            tools[idx] = {
                ...tools[idx],
                ...done,
                ...kept ? {
                    status: kept
                } : {}
            };
        } else tools.push({
            id: key,
            tool: evt.tool,
            args: evt.args || null,
            ts: Date.now(),
            ...done
        });
        // The app was written: the refused tries before it are not failures any more.
        if (evt.ok !== false && buildWrite) {
            for(let i = tools.length - 1; i >= 0; i--)if (tools[i] && tools[i].retrying && $7de1124d1ac82d24$var$_BUILD_WRITE_TOOLS.has(tools[i].tool)) tools.splice(i, 1);
        }
        // An EMBED tool's live block (embed_records / embed_widget): the frame's
        // `embed` becomes the thread card (_simone/toolEmbed.js) on this message,
        // ONCE per call — the server may re-publish a completed frame. A frame
        // without `embed` adds nothing: inert until the server sends it.
        const embedCard = (0, $eujtO.toolEmbedCard)(evt);
        const cards = Array.isArray(msg.cards) ? msg.cards : [];
        if (embedCard && !cards.some((c)=>c && c._embedFor === key)) {
            $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, id, {
                tools: tools,
                cards: cards.concat({
                    ...embedCard,
                    _embedFor: key
                })
            }, k);
            return;
        }
    }
    $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, id, {
        tools: tools
    }, k);
}
// The items the member UNDID in this scope's thread: ChatToolRow's Undo deletes
// a created item and marks its id in `root._aiUndone`. The thread's history
// still holds the create step, so without this the next reply said the item
// exists (wave-2 (1), dev 2026-10-28: "I've added one event … oak qa sync"
// after its Undo). → [{ kind, title }], newest last, at most 5.
const $7de1124d1ac82d24$var$_undoneInThread = (root, k = '')=>{
    const undone = root && root._aiUndone;
    if (!undone || typeof undone !== 'object') return [];
    const out = [];
    for (const m of root[k + 'chatMessages'] || [])for (const t of m && Array.isArray(m.tools) ? m.tools : []){
        const c = t && t.created;
        if (c && c.id != null && undone[String(c.id)]) out.push({
            kind: String(c.kind || 'item'),
            title: String(c.title || '').slice(0, 120)
        });
    }
    return out.slice(-5);
};
// ── Interactive assistant cards ──────────────────────────────────────────────
// The assistant renders rich UI (ticket/people/thumbnail cards, choice/confirm
// buttons) by attaching a `cards` array to its message; ChatMessage renders them
// via the ChatCard dispatcher. ask_user suspends the turn on a card and resumes
// when the user clicks a button (resolveChatCard → the suspended Promise).
// cardId → { root, k, thread, callId, answer(value, label), supersede(),
// end(reason, said) } — the card's thread, its step's call, and its ways out:
// the person's pick, a new message (supersedeParkedAiToolApprovals), or the
// end of its turn without the answer (_endWaitingCards).
const $7de1124d1ac82d24$var$_pendingCardResolves = {};
let $7de1124d1ac82d24$var$_cardSeq = 0;
// The waits (parked approvals, question cards) of one chat scope's thread
// `conversationId`. A wait parked before its thread had a server id (a local
// 's-…' thread) is this thread's too.
const $7de1124d1ac82d24$var$_waitsInThread = (wait, root, k, conversationId)=>{
    if (!wait || wait.root !== root || String(wait.k || '') !== String(k || '')) return false;
    const thread = String(wait.thread || '');
    const conv = conversationId == null ? '' : String(conversationId);
    return !(thread && conv && thread !== conv && !thread.startsWith('s-'));
};
// THE TURN ENDED WITHOUT THE ANSWER (F1, 2026-10-28 — the VOICE lane's open
// risk): a stopped or failed turn left its question card waiting — live
// buttons in the drawer and on the call screen (AiAsk reads an unresolved card
// as a live ask) until an answer or a new message, and a press resolved a
// promise no turn waited for. A stop during a question also held the next
// message back for the whole stopped-turn wait: the server's loop waited on
// the question, so the stopped turn never settled. Each waiting card `match`
// takes closes and says why (`reason`: 'stop' | 'end'); `said` (the
// sentence the model reads, or nothing to post) as for `end` in _askOnCard.
// → how many it closed.
const $7de1124d1ac82d24$var$_endWaitingCards = (match, reason, said)=>{
    let count = 0;
    for (const cardId of Object.keys($7de1124d1ac82d24$var$_pendingCardResolves)){
        const wait = $7de1124d1ac82d24$var$_pendingCardResolves[cardId];
        if (!wait || !match(wait)) continue;
        delete $7de1124d1ac82d24$var$_pendingCardResolves[cardId];
        count += 1;
        try {
            wait.end(reason, said);
        } catch (_) {}
    }
    return count;
};
// Which scope's buffer is the active turn writing to (general '' vs add-app
// '_ax_' vs dashboard '_db_')? Prefer general; use a scoped surface only when it
// alone has a live turn — so render_cards / ask_user attach their interactive
// cards to the RIGHT thread (e.g. the dashboard inline thread, not the drawer).
function $7de1124d1ac82d24$var$_cardScope(root) {
    if (!root || root.currentAssistantId) return '';
    if (root._db_currentAssistantId) return '_db_';
    if (root._ax_currentAssistantId) return '_ax_';
    return '';
}
// Append `cards` to the message currently streaming in this scope, or push a
// fresh assistant message carrying them. Returns the message id.
function $7de1124d1ac82d24$var$_attachCards(root, cards, k = '') {
    if (!root?.update) return null;
    const id = root[k + 'currentAssistantId'];
    const list = root[k + 'chatMessages'] || [];
    const existing = id ? list.find((m)=>m.id === id) : null;
    if (existing) {
        $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, id, {
            cards: (existing.cards || []).concat(cards)
        }, k);
        return id;
    }
    const newId = `a-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    root.update({
        [k + 'chatMessages']: list.concat({
            id: newId,
            role: 'assistant',
            text: '',
            cards: cards,
            ts: Date.now()
        })
    });
    return newId;
}
// APPS mode (AI_ASSISTANT_SPEC §12.1: "a small app surface INSIDE this
// workspace, previewed inline in the thread, then 'Save as app' installs it"):
// while the MAIN THREAD holds the main area, a built app is previewed IN the
// thread — registered as a view (functions/extensionPreview.js, open: false)
// and carried by the turn as a `view` card, whose block offers Save as app
// (functions/assistantThreadBlocks.js). Anywhere else the split sheet opens,
// as before. `_previewInThread` answers whether the thread holds the main
// area; `_attachPreviewCard` hangs the preview on the turn as a `view` card.
function $7de1124d1ac82d24$var$_previewInThread(root) {
    return !!(root && root._homeThreadOpen === true && root.assistantDock === 'main');
}
function $7de1124d1ac82d24$var$_attachPreviewCard(root, scope, pv, name) {
    if (!pv || !pv.ok || !pv.opened) return;
    const k = scope && typeof scope.k === 'string' ? scope.k : $7de1124d1ac82d24$var$_cardScope(root);
    try {
        $7de1124d1ac82d24$var$_attachCards(root, [
            {
                type: 'view',
                route: pv.opened,
                title: pv.title || name || ''
            }
        ], k);
    } catch (_) {
    /* no thread to attach to — the preview stays registered */ }
}
// Mark a choice/confirm card answered: ChatCard folds it to its answer line
// (`_resolved`, `_chosen`, `_chosenLabel`). `extra` says how the person
// answered when it was not a button: `written` (their own words) or `edit` (a
// confirm card's Edit, the words say what should change).
function $7de1124d1ac82d24$var$_markCardResolved(root, msgId, cardId, value, label, k = '', extra) {
    if (!root?.update) return;
    const list = root[k + 'chatMessages'] || [];
    const next = list.map((m)=>{
        if (m.id !== msgId) return m;
        const cards = (m.cards || []).map((c)=>c._cardId === cardId ? {
                ...c,
                _resolved: true,
                _chosen: value,
                _chosenLabel: label,
                _written: !!(extra && extra.written),
                _edit: !!(extra && extra.edit)
            } : c);
        return {
            ...m,
            cards: cards
        };
    });
    root.update({
        [k + 'chatMessages']: next
    });
}
// Every key a question card's factories read, present from its first render
// (a childrenAs:'state' row tracks only the keys it was built with).
const $7de1124d1ac82d24$var$_ASK_CARD_SEED = {
    _resolved: false,
    _chosen: null,
    _chosenLabel: null,
    _superseded: false,
    _closedBy: null,
    _written: false,
    _edit: false
};
// The person's own words from a card's field (Write my own / Edit).
const $7de1124d1ac82d24$var$_cardWords = (extra)=>extra && typeof extra.text === 'string' ? extra.text.trim().slice(0, 2000) : '';
// What the step row names as the answer ("You chose “Red”"). An Edit is no
// choice: the row says "You answered" (no answer) and the card under it shows
// the words the person asked for.
const $7de1124d1ac82d24$var$_rowAnswer = (shown, extra)=>extra && extra.edit ? '' : String(shown || '');
// What the model reads back from an ask_user card. A button gives its value
// and label; on a confirm card also `confirmed`. Words the person wrote
// instead of picking come back as the answer itself, with `written: true`. A
// confirm card's Edit comes back NOT confirmed, the words as `edit`: never a
// yes (the server's answeredYes reads `confirmed` first).
const $7de1124d1ac82d24$var$_askAnswer = (kind, value, label, extra)=>{
    const words = $7de1124d1ac82d24$var$_cardWords(extra);
    if (kind === 'confirm') {
        if (extra && extra.edit) return {
            ok: true,
            choice: 'edit',
            label: words,
            confirmed: false,
            edit: words
        };
        return {
            ok: true,
            choice: value,
            label: label || value,
            confirmed: value === 'confirm'
        };
    }
    if (extra && extra.written) return {
        ok: true,
        choice: words,
        label: words,
        written: true
    };
    return {
        ok: true,
        choice: value,
        label: label || value
    };
};
// What the model reads back from confirm_with_user: `confirmed`, as the
// modal answered, and the person's `edit` when they asked for a change.
const $7de1124d1ac82d24$var$_confirmAnswer = (value, extra)=>extra && extra.edit ? {
        ok: true,
        confirmed: false,
        edit: $7de1124d1ac82d24$var$_cardWords(extra)
    } : {
        ok: true,
        confirmed: value === 'confirm'
    };
// A question card goes on the message that holds its step, so it is drawn
// under that step: a question asked again after a reload (the turn's id is
// clear then) went onto a new empty message, away from its step.
function $7de1124d1ac82d24$var$_attachAskCard(root, card, callId, k = '') {
    const list = root && root[k + 'chatMessages'] || [];
    const host = callId ? list.find((m)=>m && m.role === 'assistant' && Array.isArray(m.tools) && m.tools.some((t)=>t && String(t.id) === callId)) : null;
    if (!host) return $7de1124d1ac82d24$var$_attachCards(root, [
        card
    ], k);
    $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, host.id, {
        cards: (host.cards || []).concat(card)
    }, k);
    return host.id;
}
// ONE QUESTION, ONE CARD, IN THE THREAD THAT ASKED: attach the card, stop the
// typing dots, and wait for the person: a button, their own words, or a new
// message that closes it (supersede). The card carries its step's call id
// (`_callId`), so ChatMessage draws it under the step that asked.
// `result(value, label, extra)` is what the model reads back.
async function $7de1124d1ac82d24$var$_askOnCard(root, k, card, scope, result) {
    const cardId = `card-${++$7de1124d1ac82d24$var$_cardSeq}-${Date.now()}`;
    const callId = scope && scope.callId != null ? String(scope.callId) : '';
    const msgId = $7de1124d1ac82d24$var$_attachAskCard(root, {
        ...card,
        ...$7de1124d1ac82d24$var$_ASK_CARD_SEED,
        _cardId: cardId,
        _callId: callId || null
    }, callId, k);
    // The AI is now waiting on the user — stop the typing indicator and the
    // streaming dots on this message.
    try {
        root.update({
            [k + 'chatTyping']: false
        });
        if (msgId) $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, msgId, {
            streaming: false
        }, k);
    } catch (_) {}
    return await new Promise((resolve)=>{
        $7de1124d1ac82d24$var$_pendingCardResolves[cardId] = {
            root: root,
            k: k,
            // The conversation it waits in — a new message there closes it.
            thread: root && root[k + 'activeSessionId'] || null,
            callId: // Its step's call — the server's close of that call closes it.
            callId,
            answer: (value, label, extra)=>{
                const words = $7de1124d1ac82d24$var$_cardWords(extra);
                const shown = extra && (extra.written || extra.edit) && words || label || value;
                try {
                    $7de1124d1ac82d24$var$_markCardResolved(root, msgId, cardId, value, shown, k, extra);
                } catch (_) {}
                // The row names the pick (W7 live, 2026-10-28: an answered
                // question still read "Waiting for your choice"); the server's
                // completed frame spreads over the row and keeps it.
                if (callId) try {
                    $7de1124d1ac82d24$var$_patchToolRow(root, k, callId, {
                        answer: $7de1124d1ac82d24$var$_rowAnswer(shown, extra)
                    });
                } catch (_) {}
                // The answer resumes the SAME turn — it works on (a first build
                // runs for minutes). Show it working again while this scope still
                // has a turn running; without this the builder looked idle after
                // "Yes, build the board", and the person typed into a turn that was
                // still building (aiko-r2, marcus-r2). A card answered after its
                // turn ended changes nothing.
                try {
                    if (root && root[k + 'currentAssistantId']) root.update({
                        [k + 'chatTyping']: true
                    });
                } catch (_) {}
                resolve(result(value, label, extra));
            },
            // The person wrote instead of picking (dev 2026-10-28, kestrel-
            // assist "Add a lead" → "Never mind…"): the server closes the call
            // under the new message (closeDanglingClientCall, reason
            // `new_message`), so nothing is posted for it, its row reads
            // superseded, and the server's close frame adds no second row.
            supersede: ()=>{
                if (callId) $7de1124d1ac82d24$var$_boundedAdd($7de1124d1ac82d24$var$_supersededCalls, callId);
                try {
                    $7de1124d1ac82d24$var$_markCardSuperseded(root, msgId, cardId, k);
                } catch (_) {}
                if (callId) $7de1124d1ac82d24$var$_patchToolRow(root, k, callId, {
                    status: 'superseded',
                    doneTs: Date.now()
                });
                resolve({
                    ok: false,
                    superseded: true,
                    notRun: true,
                    reason: 'new_message'
                });
            },
            // Its turn ended without the answer (_endWaitingCards): the card closes
            // and says why (`_closedBy` — 'stop': the person stopped the reply;
            // 'end': the turn failed, or the server closed the call), and its step
            // stops waiting: a quiet "Unanswered question", never "Waiting for your
            // choice" (the server's label for the wait). `said`: the loop still
            // waits on the call (a stop, a failure) — the SDK posts this not-run
            // result with that sentence for the model, so the loop ends and frees
            // the thread for the next message. A call the server closed itself
            // gets nothing (no `said`): `superseded`, which the transport never
            // hands to the SDK. Its late frames add nothing.
            end: (reason, said)=>{
                if (callId) $7de1124d1ac82d24$var$_boundedAdd($7de1124d1ac82d24$var$_supersededCalls, callId);
                try {
                    $7de1124d1ac82d24$var$_markCardSuperseded(root, msgId, cardId, k, reason);
                } catch (_) {}
                if (callId) $7de1124d1ac82d24$var$_patchToolRow(root, k, callId, {
                    status: 'denied',
                    label: $7de1124d1ac82d24$var$_sayKey('ai.toolStep.askUnanswered'),
                    doneTs: Date.now()
                });
                if (!said) {
                    resolve({
                        ok: false,
                        superseded: true,
                        notRun: true,
                        reason: 'closed'
                    });
                    return;
                }
                resolve({
                    ok: false,
                    notRun: true,
                    ...reason === 'stop' ? {
                        stopped: true
                    } : {},
                    error: said
                });
            }
        };
    });
}
// A card a new message closed: no pick, its buttons inert, and it says why
// (ChatCard reads `_superseded`). `closedBy`: its turn ended without the
// answer instead ('stop' | 'end' — the card says which).
function $7de1124d1ac82d24$var$_markCardSuperseded(root, msgId, cardId, k = '', closedBy = null) {
    if (!root?.update) return;
    const list = root[k + 'chatMessages'] || [];
    const next = list.map((m)=>{
        if (m.id !== msgId) return m;
        const cards = (m.cards || []).map((c)=>c._cardId === cardId ? {
                ...c,
                _resolved: true,
                _superseded: true,
                _closedBy: closedBy
            } : c);
        return {
            ...m,
            cards: cards
        };
    });
    root.update({
        [k + 'chatMessages']: next
    });
}
function $7de1124d1ac82d24$export$8566d409569c4a92(cardId, value, label, extra) {
    const wait = $7de1124d1ac82d24$var$_pendingCardResolves[cardId];
    if (!wait) return false;
    delete $7de1124d1ac82d24$var$_pendingCardResolves[cardId];
    try {
        wait.answer(value, label, extra);
    } catch (_) {}
    return true;
}
function $7de1124d1ac82d24$export$2843f1f50eafea99(cardId, value, label, extra) {
    const el = this && typeof this.call === 'function' ? this : $7de1124d1ac82d24$var$_creditsEl();
    const root = el && el.state && (el.state.root || el.state) || $7de1124d1ac82d24$var$_shellResolveRoot(null);
    const id = String(cardId || '');
    if (!el || typeof el.call !== 'function' || !root || !root.update || !id) return {
        ok: false,
        reason: 'no-ui'
    };
    for (const [k, scope] of $7de1124d1ac82d24$var$_ROW_SCOPES){
        const msg = (root[k + 'chatMessages'] || []).find((m)=>m && Array.isArray(m.cards) && m.cards.some((c)=>c && c._cardId === id));
        if (!msg) continue;
        const card = msg.cards.find((c)=>c && c._cardId === id);
        if (!card._resolved || card._superseded) return {
            ok: false,
            reason: 'not-answered'
        };
        const edited = !!(extra && (extra.written || extra.edit));
        const answer = String((edited ? $7de1124d1ac82d24$var$_cardWords(extra) : label || value) || '').trim();
        if (!answer) return {
            ok: false,
            reason: 'empty'
        };
        $7de1124d1ac82d24$var$_markCardResolved(root, msg.id, id, edited ? extra.edit ? 'edit' : answer : value, answer, k, extra);
        if (card._callId) $7de1124d1ac82d24$var$_patchToolRow(root, k, card._callId, {
            answer: $7de1124d1ac82d24$var$_rowAnswer(answer, extra)
        });
        const prompt = String(card.prompt || '').trim();
        const question = prompt.length > 120 ? prompt.slice(0, 119).trimEnd() + "\u2026" : prompt;
        const words = String(el.call('polyglot', question ? 'ai.chatCard.ask.changeMessage' : 'ai.chatCard.ask.changeMessageShort') || '').replace('{question}', ()=>question).replace('{answer}', ()=>answer);
        el.call('sendPrompt', words, scope);
        return {
            ok: true,
            sent: true
        };
    }
    return {
        ok: false,
        reason: 'not-found'
    };
}
// ── Client-tool authorization (the "Ask first" contract) ────────────────────
// The AI settings panel has always offered `Ask first — confirm actions before
// they run` vs `Auto — run actions immediately` (sdk.ai.get/setAuthMode, with
// an admin workspace pin), and the server receives that mode with every turn —
// but the CLIENT tool path never enforced it: onToolCall ran every platform
// action the moment the loop asked. This section is the enforcement.
//
// Mechanism mirrors ask_user's suspended-Promise spine exactly
// (_pendingCardResolves/resolveChatCard above): the gate pauses the tool call
// on a Promise, surfaces an `approval` frame on the SAME live timeline row the
// tool already occupies (ChatToolRow renders Run / Skip on it), and
// resolveAiToolApproval — fired by those buttons via el.call — settles it.
// Deny resolves { ok:false, denied:true } so the loop continues honestly
// instead of hanging or fabricating success.
//
// READ-ONLY calls never prompt, in either mode. Asking permission to LOOK
// (list_projects, get_project, excalidrawGetScene) would bury the one ask that
// matters — consent for writes — under a pile of asks nobody reads. The
// classifier below is deliberately conservative: an unknown, unclassifiable
// tool is treated as a WRITE and gated.
const $7de1124d1ac82d24$var$_pendingToolApprovals = {} // callId → { root, k, run, resolve }
;
// Chat-surface + navigation + presentation tools: these ARE the conversation
// (ask_user is itself the consent mechanism) or change nothing but what the
// user is looking at. Both server (snake) and el.call (camel) names — frames
// carry one, dispatch data the other.
const $7de1124d1ac82d24$var$READ_ONLY_AI_TOOLS = new Set([
    'open_search',
    'navigate_to_app',
    'open_page_in_split',
    'select_page_item',
    'render_answer_ui',
    'render_cards',
    'render_extension_page',
    'ask_user',
    'confirm_with_user',
    'close_modals',
    'set_theme',
    'openSearch',
    'openAppPage',
    'openPageInSplit',
    'selectPageItem',
    'renderAnswerUi',
    'renderCards',
    'askUser',
    'confirmWithUser',
    'closeAllModals',
    'changeGlobalTheme',
    'injectPageInApp',
    // create_app/update_app have already saved the draft on the server. This
    // follow-on call only shows it in the preview, like injectPageInApp above.
    'renderMultiPageApp',
    // Proposing an app action only parks it and shows the Approve / Reject
    // card — the card IS the consent, and nothing runs before its click. A
    // Run / Skip row in front of it asked twice (MODULE-ACTIONS-PROPOSAL-NEVER-
    // OFFERED-1). Approve / reject are never AI-callable at all.
    'propose_app_action',
    'proposeModuleAction',
    // Showing what the member can do here changes nothing — the card's rows
    // only send an ask when tapped.
    'describe_capabilities',
    'aiDescribeCapabilities',
    // The quick tour only shows the member their own screen, stop by stop
    // (functions/aiStartTour.js); Escape ends it.
    'start_tour',
    'aiStartTour'
]);
function $7de1124d1ac82d24$export$c50056db6e7e85b9(tool, fn) {
    const t = String(tool || '');
    if ($7de1124d1ac82d24$var$READ_ONLY_AI_TOOLS.has(t)) return true;
    if (/^(list|get|read|search|find|fetch|check)_/.test(t)) return true;
    const f = String(fn || '');
    if ($7de1124d1ac82d24$var$READ_ONLY_AI_TOOLS.has(f)) return true;
    if (/^(list|get|read|search|find|fetch|check)(?=[A-Z]|$)/.test(f)) return true;
    // Module fns carry their app as a lowercase prefix (excalidrawGetScene) —
    // strip it and classify by the verb that follows.
    const m = f.match(/^[a-z0-9]+/);
    const rest = m ? f.slice(m[0].length) : '';
    return /^(Get|List|Read|Search|Find|Fetch|Check)(?=[A-Z]|$)/.test(rest);
}
function $7de1124d1ac82d24$export$b303d4c381f6656e(tool, fn) {
    return /^aiDelete[A-Z]/.test(String(fn || '')) || /^delete_/.test(String(tool || ''));
}
// ── D2: a create the person asked for runs at once ───────────────────────────
// Nika 2026-10-28 (workspace AI overhaul, decision D2): "asked creates run at
// once with Undo; edits, deletes, sends and AI-suggested writes still ask".
// Only the creates a timeline row can UNDO (ChatToolRow UndoCreated →
// aiUndoCreated): a note and a ticket. A folder and a channel have no Undo,
// and a widget's preview IS its consent, so they keep the ask.
const $7de1124d1ac82d24$var$ASKED_CREATE_FNS = {
    aiCreateNote: 'note',
    create_note: 'note',
    aiCreateTicket: 'ticket',
    create_ticket: 'ticket'
};
// A runaway loop is not the person's ask: past this many asked creates in one
// turn, the next one asks again (Run all still grants the rest of the turn).
const $7de1124d1ac82d24$var$ASKED_CREATES_PER_TURN = 10;
const $7de1124d1ac82d24$var$_askedCreatesRun = new Map() // `${k}|${turnId}` → count
;
// English: a create verb, then its object inside the phrase the verb governs
// (a preposition ends the phrase — "a document WITH a strategy" is one doc).
const $7de1124d1ac82d24$var$_EN_CREATE_VERB = /\b(set up|jot down|note down|write up|write down|put together|create|make|add|write|draft|schedule|book|prepare|compose|generate|produce|log|file)\b/g;
const $7de1124d1ac82d24$var$_EN_CREATE_OBJECT = {
    note: 'note',
    doc: 'note',
    document: 'note',
    memo: 'note',
    plan: 'note',
    outline: 'note',
    brief: 'note',
    report: 'note',
    proposal: 'note',
    strategy: 'note',
    summary: 'note',
    'write-up': 'note',
    writeup: 'note',
    article: 'note',
    agenda: 'note',
    checklist: 'note',
    spec: 'note',
    minutes: 'note',
    task: 'ticket',
    todo: 'ticket',
    'to-do': 'ticket',
    ticket: 'ticket',
    reminder: 'ticket',
    issue: 'ticket',
    bug: 'ticket',
    event: 'event',
    meeting: 'event',
    appointment: 'event',
    folder: 'folder'
};
const $7de1124d1ac82d24$var$_EN_PHRASE_END = new Set([
    'with',
    'about',
    'for',
    'from',
    'of',
    'on',
    'in',
    'into',
    'to',
    'regarding',
    'that',
    'which',
    'where',
    'so',
    'because',
    'using',
    'based',
    'by',
    'at',
    'called',
    'named',
    'titled'
]);
const $7de1124d1ac82d24$var$_enObjectKind = (word)=>{
    if ($7de1124d1ac82d24$var$_EN_CREATE_OBJECT[word]) return $7de1124d1ac82d24$var$_EN_CREATE_OBJECT[word];
    if (word.endsWith('ies')) return $7de1124d1ac82d24$var$_EN_CREATE_OBJECT[word.slice(0, -3) + 'y'] || null;
    if (word.endsWith('s')) return $7de1124d1ac82d24$var$_EN_CREATE_OBJECT[word.slice(0, -1)] || null;
    return null;
};
const $7de1124d1ac82d24$var$_enAskedKinds = (sentence, out)=>{
    const s = sentence.toLowerCase().replace(/[’`]/g, "'").trim();
    if (!s) return;
    // A question about a thing, or about how to make one, asks for nothing.
    if (/^(how|what|why|where|when|which|who|whom|whose|is|are|was|were|do|does|did|have|has|had|should|shall)\b/.test(s) || /^(can|could|may|might)\s+(i|we)\b/.test(s)) return;
    if (/\b(don't|dont|do not|never|no need to)\b/.test(s)) return;
    const objectsAfter = (rest)=>{
        const words = rest.split(/[^a-z0-9'-]+/).filter(Boolean).slice(0, 8);
        for (const w of words){
            if ($7de1124d1ac82d24$var$_EN_PHRASE_END.has(w)) break;
            const kind = $7de1124d1ac82d24$var$_enObjectKind(w);
            if (kind) out.add(kind);
        }
        return words;
    };
    // "New task: renew the domain" — a quick capture.
    if (/^new\s/.test(s)) objectsAfter(s.slice(4));
    $7de1124d1ac82d24$var$_EN_CREATE_VERB.lastIndex = 0;
    let m;
    while(m = $7de1124d1ac82d24$var$_EN_CREATE_VERB.exec(s)){
        const rest = s.slice(m.index + m[0].length);
        const first = rest.split(/[^a-z0-9'-]+/).filter(Boolean)[0] || '';
        // "add the notes to the doc" edits a thing; "make sure…" makes nothing.
        if (m[1] === 'add' && /^(the|this|that|these|those|it|my|our|your|his|her|their)$/.test(first)) continue;
        if (m[1] === 'make' && /^(sure|certain|it|that|me|us|them|him|her)$/.test(first)) continue;
        objectsAfter(rest);
    }
};
// Georgian: word order is free, so a create verb stem and an object stem in
// the same sentence. A question word or a negation in it asks for nothing.
const $7de1124d1ac82d24$var$_KA_CREATE_VERB = [
    "\u10E8\u10D4\u10E5\u10DB\u10D4\u10DC",
    "\u10E8\u10D4\u10E5\u10DB\u10DC",
    "\u10E8\u10D4\u10D5\u10E5\u10DB\u10DC\u10D0\u10D7",
    "\u10D3\u10D0\u10D0\u10DB\u10D0\u10E2",
    "\u10D3\u10D0\u10D5\u10D0\u10DB\u10D0\u10E2\u10DD\u10D7",
    "\u10D3\u10D0\u10EC\u10D4\u10E0",
    "\u10D3\u10D0\u10DB\u10D8\u10EC\u10D4\u10E0",
    "\u10E9\u10D0\u10D8\u10DC\u10D8\u10E8\u10DC",
    "\u10E9\u10D0\u10DB\u10D8\u10EC\u10D4\u10E0",
    "\u10D3\u10D0\u10D2\u10D4\u10D2\u10DB",
    "\u10D2\u10D0\u10D0\u10D9\u10D4\u10D7",
    "\u10E8\u10D4\u10D0\u10D3\u10D2\u10D8\u10DC",
    "\u10DB\u10DD\u10D0\u10DB\u10D6\u10D0\u10D3",
    "\u10D3\u10D0\u10DC\u10D8\u10E8\u10DC"
];
// "შექმნილი" — "the created …" — names a thing that exists.
const $7de1124d1ac82d24$var$_KA_NOT_VERB = [
    "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA"
];
const $7de1124d1ac82d24$var$_KA_CREATE_OBJECT = [
    [
        "\u10E8\u10D4\u10DC\u10D8\u10E8\u10D5\u10DC",
        'note'
    ],
    [
        "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0",
        'note'
    ],
    [
        "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2",
        'note'
    ],
    [
        "\u10D2\u10D4\u10D2\u10DB",
        'note'
    ],
    [
        "\u10E1\u10E2\u10E0\u10D0\u10E2\u10D4\u10D2\u10D8",
        'note'
    ],
    [
        "\u10DB\u10DD\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1",
        'note'
    ],
    [
        "\u10E0\u10D4\u10D6\u10D8\u10E3\u10DB\u10D4",
        'note'
    ],
    [
        "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1",
        'ticket'
    ],
    [
        "\u10D0\u10DB\u10DD\u10EA\u10D0\u10DC",
        'ticket'
    ],
    [
        "\u10E8\u10D4\u10EE\u10E1\u10D4\u10DC\u10D4\u10D1",
        'ticket'
    ],
    [
        "\u10E8\u10D4\u10EE\u10D5\u10D4\u10D3\u10E0",
        'event'
    ],
    [
        "\u10E6\u10DD\u10DC\u10D8\u10E1\u10EB\u10D8\u10D4\u10D1",
        'event'
    ],
    [
        "\u10E1\u10D0\u10E5\u10D0\u10E6\u10D0\u10DA\u10D3",
        'folder'
    ]
];
const $7de1124d1ac82d24$var$_KA_QUESTION = new Set([
    "\u10E0\u10DD\u10D2\u10DD\u10E0",
    "\u10E0\u10D0\u10E2\u10DD\u10DB",
    "\u10E1\u10D0\u10D3",
    "\u10E0\u10DD\u10D3\u10D8\u10E1",
    "\u10D5\u10D8\u10DC",
    "\u10E0\u10D0",
    "\u10E0\u10DD\u10DB\u10D4\u10DA\u10D8"
]);
const $7de1124d1ac82d24$var$_KA_NEGATION = new Set([
    "\u10DC\u10E3",
    "\u10D0\u10E0"
]);
const $7de1124d1ac82d24$var$_kaAskedKinds = (sentence, out)=>{
    const words = sentence.split(/[\s,.;:!?"'«»„“”()[\]{}—–]+/).filter(Boolean);
    let verb = false;
    const kinds = [];
    for (const w of words){
        if ($7de1124d1ac82d24$var$_KA_QUESTION.has(w) || $7de1124d1ac82d24$var$_KA_NEGATION.has(w)) return;
        if ($7de1124d1ac82d24$var$_KA_NOT_VERB.some((p)=>w.startsWith(p))) continue;
        if ($7de1124d1ac82d24$var$_KA_CREATE_VERB.some((p)=>w.startsWith(p))) verb = true;
        const obj = $7de1124d1ac82d24$var$_KA_CREATE_OBJECT.find(([p])=>w.startsWith(p));
        if (obj) kinds.push(obj[1]);
    }
    if (verb) for (const kind of kinds)out.add(kind);
};
function $7de1124d1ac82d24$export$b707522d81430ee4(text) {
    const raw = String(text || '');
    if (!raw.trim()) return [];
    // A quoted title names a thing; its words never ask for one.
    const plain = raw.replace(/"[^"\n]*"|“[^”\n]*”|„[^“”\n]*[“”]|«[^»\n]*»|(^|\s)'[^'\n]+'(?=[\s.,!?;:]|$)/g, (m, lead)=>(lead || '') + ' ');
    const out = new Set();
    for (const sentence of plain.split(/[.!?;\n]+/)){
        $7de1124d1ac82d24$var$_enAskedKinds(sentence, out);
        $7de1124d1ac82d24$var$_kaAskedKinds(sentence, out);
    }
    return [
        ...out
    ];
}
// The turn text's asked kinds, with the shell's own ask reader when it is
// registered (ROUTER's `assistantAskIntent`, functions/assistantAskRoute.js):
// a question or an open ask is never a create; a document ask is a note.
const $7de1124d1ac82d24$var$_askedCreateKindsFor = (el, text)=>{
    const own = new Set($7de1124d1ac82d24$export$b707522d81430ee4(text));
    const fns = el && el.context && el.context.functions;
    if (fns && typeof fns.assistantAskIntent === 'function') {
        let intent = null;
        try {
            intent = el.call('assistantAskIntent', text);
        } catch (_) {
            intent = null;
        }
        if (intent === 'question' || intent === 'open') return [];
        if (intent === 'document') own.add('note');
    }
    return [
        ...own
    ];
};
const $7de1124d1ac82d24$var$_takeAskedCreate = (root, k)=>{
    const key = `${k}|${String(root && root[k + 'currentAssistantId'] || '')}`;
    const n = $7de1124d1ac82d24$var$_askedCreatesRun.get(key) || 0;
    if (n >= $7de1124d1ac82d24$var$ASKED_CREATES_PER_TURN) return false;
    $7de1124d1ac82d24$var$_askedCreatesRun.set(key, n + 1);
    if ($7de1124d1ac82d24$var$_askedCreatesRun.size > 50) $7de1124d1ac82d24$var$_askedCreatesRun.delete($7de1124d1ac82d24$var$_askedCreatesRun.keys().next().value);
    return true;
};
// Same resolution order as AiSettingsPanel's picker: the admin workspace pin
// (when the user scoped settings to the whole workspace) wins, then the
// per-user localStorage mode, then the safe default — ask.
const $7de1124d1ac82d24$var$_resolveClientAuthMode = (root)=>{
    try {
        if (root && root._aiScope === 'workspace') {
            const pin = root.workspaceSettings && root.workspaceSettings.aiProvider;
            if (pin && pin.authMode) return pin.authMode;
        }
    } catch (_) {}
    try {
        const ai = (0, $7iFOV.shellGetAiService)();
        const mode = ai && ai.getAuthMode && ai.getAuthMode();
        if (mode) return mode;
    } catch (_) {}
    return 'ask';
};
function $7de1124d1ac82d24$export$695c27f322c1f4a7(el, root, k, call, runFn, authModeOverride) {
    const tool = call && call.tool;
    const fn = call && call.fn;
    const mode = authModeOverride || $7de1124d1ac82d24$var$_resolveClientAuthMode(root);
    // ASK-ALL: every write asks — an asked create too (D2 below never applies).
    // No settings row offers it yet; the gate honours the value when one does.
    const askAll = mode === 'askAll' || mode === 'ask-all';
    // The server's per-tool `confirm` flag (carried on the `tool.call_required`
    // frame and on the persisted pendingClientCall) is an explicit instruction to
    // ask. It OVERRIDES both Auto mode and the read-only classifier: the tool
    // registry knows things a client-side name check cannot, so a tool that only
    // LOOKS read-only must still be able to demand consent. It can only ever ADD
    // an ask — it never skips one. `forceAsk` is the client's own twin: a call a
    // loaded conversation re-offers must never run on its own (item E,
    // reofferPendingClientCall `onLoad`). A delete is forced the same way (D9,
    // isAiDeleteTool above): Auto mode never runs one without the row.
    const aiDelete = $7de1124d1ac82d24$export$b303d4c381f6656e(tool, fn);
    const forced = !!(call && (call.confirm || call.forceAsk)) || aiDelete;
    // MODULE-FN-READONLY-ENFORCED-1 — an app verb the manifest marks
    // `readOnly: true` runs without the Run / Skip row when the server's frame
    // AND this shell's live stash both say so; _runPlatformTool then runs it on
    // a read-only caller that refuses every write, so skipping the ask is safe
    // even for a mislabelled verb. A server `confirm` still forces the ask.
    const readOnlyCall = !!(call && call.readOnly) && $7de1124d1ac82d24$export$464ab4e80706876c(el, fn);
    if (!forced && (mode !== 'ask' && !askAll || readOnlyCall || $7de1124d1ac82d24$export$c50056db6e7e85b9(tool, fn))) return runFn();
    // AI-307 (tickets/ai.md) — "Approve all for this run": the first approval
    // card can grant the REST of the current turn. Scope guarantee falls out of
    // keying the grant to the turn's assistant id — a new turn mints a new id,
    // so the flag can never leak forward, and it is never persisted anywhere.
    // A delete is outside the grant (D9): it asks even after "Run all" — the
    // grant answers the rows on screen, never a delete that comes later.
    if (!(call && call.forceAsk) && !aiDelete && root && root._aiApproveAllFor && root._aiApproveAllFor === String(root[k + 'currentAssistantId'] || '')) return runFn();
    // D2 — a create THIS turn's own words asked for runs at once; its row then
    // reads "Created ✓ · Open · Undo". `askText` rides only the live onToolCall,
    // so a re-offered call (no turn text) keeps the ask.
    if (!forced && !askAll && call && call.askText) {
        const kind = $7de1124d1ac82d24$var$ASKED_CREATE_FNS[fn] || $7de1124d1ac82d24$var$ASKED_CREATE_FNS[tool];
        if (kind && $7de1124d1ac82d24$var$_askedCreateKindsFor(el, call.askText).includes(kind) && $7de1124d1ac82d24$var$_takeAskedCreate(root, k)) return runFn();
    }
    const id = String(call && call.callId || `${fn || tool}-${Date.now()}`);
    $7de1124d1ac82d24$var$_patchToolActivity(root, {
        phase: 'approval',
        callId: id,
        tool: tool || fn,
        args: call && call.args
    }, k);
    // Auto-expand the row — an honest ask shows WHAT it is approving.
    if (root && root.update) root.update({
        _aiToolOpen: {
            ...root._aiToolOpen || {},
            [id]: true
        }
    }, {
        preventFetch: true
    });
    return new Promise((resolve)=>{
        $7de1124d1ac82d24$var$_pendingToolApprovals[id] = {
            root: root,
            k: k,
            tool: tool || fn,
            run: runFn,
            resolve: resolve,
            // The conversation it waits in — a new message in that thread
            // supersedes it (supersedeParkedAiToolApprovals).
            thread: root && root[k + 'activeSessionId'] || null
        };
    });
}
function $7de1124d1ac82d24$export$43ba336f5180c9fe() {
    const root = this && this.state && (this.state.root || this.state) || null;
    if (!root || !root.update) return {
        ok: false,
        error: 'No workspace UI available.'
    };
    // The active scope = whichever surface has a live turn (same preference
    // order as _cardScope).
    const k = root.currentAssistantId ? '' : root._db_currentAssistantId ? '_db_' : '_ax_';
    const turnId = String(root[k + 'currentAssistantId'] || '');
    if (!turnId) return {
        ok: false,
        error: 'No turn is running.'
    };
    root.update({
        _aiApproveAllFor: turnId
    }, {
        preventFetch: true
    });
    for (const id of Object.keys($7de1124d1ac82d24$var$_pendingToolApprovals))$7de1124d1ac82d24$export$1d57447306a0971d(id, true);
    return {
        ok: true,
        turn: turnId
    };
}
function $7de1124d1ac82d24$export$517ab25864db4e2e(reason, opts) {
    const ids = Object.keys($7de1124d1ac82d24$var$_pendingToolApprovals);
    for (const id of ids){
        const held = $7de1124d1ac82d24$var$_pendingToolApprovals[id];
        if (opts && opts.notRun) {
            $7de1124d1ac82d24$var$expireParkedAiToolApproval(id, opts.notRun, reason);
            continue;
        }
        delete $7de1124d1ac82d24$var$_pendingToolApprovals[id];
        // AI-307 hygiene — a turn that ends by settlement also drops its
        // approve-all grant (the id-keying already makes a stale grant inert;
        // this keeps the state clean rather than merely harmless).
        if (held.root && held.root._aiApproveAllFor && held.root.update) try {
            held.root.update({
                _aiApproveAllFor: null
            }, {
                preventFetch: true
            });
        } catch (_) {}
        try {
            $7de1124d1ac82d24$var$_patchToolActivity(held.root, {
                phase: 'denied',
                callId: id,
                tool: held.tool
            }, held.k);
        } catch (_) {}
        try {
            held.resolve({
                ok: false,
                denied: true,
                error: reason || 'This action was not approved before the turn ended.'
            });
        } catch (_) {}
    }
    return ids.length;
}
function $7de1124d1ac82d24$export$c9c9c94702ce6f17(root, k, conversationId) {
    const scope = String(k || '');
    const conv = conversationId == null ? '' : String(conversationId);
    let count = 0;
    for (const id of Object.keys($7de1124d1ac82d24$var$_pendingToolApprovals)){
        const held = $7de1124d1ac82d24$var$_pendingToolApprovals[id];
        if (!$7de1124d1ac82d24$var$_waitsInThread(held, root, scope, conv)) continue;
        delete $7de1124d1ac82d24$var$_pendingToolApprovals[id];
        count += 1;
        $7de1124d1ac82d24$var$_boundedAdd($7de1124d1ac82d24$var$_supersededCalls, String(id));
        if (root && root._aiApproveAllFor && root.update) try {
            root.update({
                _aiApproveAllFor: null
            }, {
                preventFetch: true
            });
        } catch (_) {}
        $7de1124d1ac82d24$var$_patchToolRow(root, scope, id, {
            status: 'superseded',
            doneTs: Date.now()
        });
        try {
            // Never posted (see above): the server writes the step's result.
            held.resolve({
                ok: false,
                superseded: true,
                notRun: true,
                reason: 'new_message'
            });
        } catch (_) {}
    }
    // An ask_user card waits the same way: its turn is suspended on the
    // person's pick, and the server closes that call under the new message too.
    for (const cardId of Object.keys($7de1124d1ac82d24$var$_pendingCardResolves)){
        const wait = $7de1124d1ac82d24$var$_pendingCardResolves[cardId];
        if (!$7de1124d1ac82d24$var$_waitsInThread(wait, root, scope, conv)) continue;
        delete $7de1124d1ac82d24$var$_pendingCardResolves[cardId];
        count += 1;
        try {
            wait.supersede();
        } catch (_) {}
    }
    return count;
}
// One timeline row, patched in the message that holds it — a re-offered row
// sits on a restored message, not on the live turn's.
const $7de1124d1ac82d24$var$_patchToolRow = (root, k, callId, patch)=>{
    if (!root || !root.update) return null;
    const id = String(callId || '');
    const list = root[k + 'chatMessages'] || [];
    const msg = list.find((m)=>m && Array.isArray(m.tools) && m.tools.some((t)=>t && t.id === id));
    if (!msg) return null;
    const tools = msg.tools.map((t)=>t && t.id === id ? {
            ...t,
            ...patch
        } : t);
    $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, msg.id, {
        tools: tools
    }, k);
    return tools.find((t)=>t && t.id === id);
};
// el.call('aiToolRunNow', callId) — the "Run it now" button on a superseded
// row. The step's call is closed on the server, so it cannot be run in place:
// the button asks the AI again, as the person's own follow-up message, in
// their words ("Please run this step now: <step>") — the loop then calls the
// tool again, and the gate treats it like any other call. Once per row.
const $7de1124d1ac82d24$var$_ROW_SCOPES = [
    [
        '',
        'general'
    ],
    [
        '_db_',
        'dashboard'
    ],
    [
        '_ax_',
        'addapp'
    ]
];
function $7de1124d1ac82d24$export$3df545fa04ce1340(callId) {
    const el = this && typeof this.call === 'function' ? this : $7de1124d1ac82d24$var$_creditsEl();
    const root = el && el.state && (el.state.root || el.state) || $7de1124d1ac82d24$var$_shellResolveRoot(null);
    const id = String(callId || '');
    // `reason` is a code for the caller (the row's button ignores it).
    if (!el || typeof el.call !== 'function' || !root || !root.update || !id) return {
        ok: false,
        reason: 'no-ui'
    };
    for (const [k, scope] of $7de1124d1ac82d24$var$_ROW_SCOPES){
        const msg = (root[k + 'chatMessages'] || []).find((m)=>m && Array.isArray(m.tools) && m.tools.some((t)=>t && t.id === id));
        if (!msg) continue;
        const row = msg.tools.find((t)=>t && t.id === id);
        if (row.status !== 'superseded' || row.rerun) return {
            ok: false,
            reason: 'not-superseded'
        };
        // The step in the row's own words, in the session language: the server
        // label, else what the row itself shows (ChatToolStepLabel, the row's own
        // text factory: the client step phrase, else the generic step words).
        // Never the tool name: a Georgian page sent "…: create ticket" (wave 2,
        // dev 2026-10-28). Read at call time, never at module init.
        const shown = (0, $1X0Je.default).components.ChatToolStepLabel;
        const phrase = shown && typeof shown.text === 'function' ? String(shown.text(el, {
            ...row,
            label: null
        }) || '').trim() : '';
        const step = $7de1124d1ac82d24$var$_toolLabel(row.label) || phrase || String(el.call('polyglot', 'ai.toolStep.generic') || '').trim();
        const ask = String(el.call('polyglot', 'workspace.simone.approval.runNowPrompt'));
        $7de1124d1ac82d24$var$_patchToolRow(root, k, id, {
            rerun: true
        });
        el.call('sendPrompt', ask.replace('{step}', ()=>step), scope);
        return {
            ok: true,
            sent: true
        };
    }
    return {
        ok: false,
        reason: 'not-found'
    };
}
// A parked approval that can no longer run — the turn ended under it, or the
// server's own wait for the person ended (round 1b, sam: "skipped 46.0s" while
// he tabbed to it). The row becomes a step that did not run, its reason in
// plain words (`key`, a bundle key — ChatToolRow shows a failed step's reason
// under it), and the answer it sits on offers to run it again: one chip that
// sends that request as the person's message (the loop then asks again). The
// held promise settles as not run, so nothing waits on it.
const $7de1124d1ac82d24$var$expireParkedAiToolApproval = (id, key, reason)=>{
    const held = $7de1124d1ac82d24$var$_pendingToolApprovals[id];
    if (!held) return;
    delete $7de1124d1ac82d24$var$_pendingToolApprovals[id];
    const root = held.root;
    if (root && root._aiApproveAllFor && root.update) try {
        root.update({
            _aiApproveAllFor: null
        }, {
            preventFetch: true
        });
    } catch (_) {}
    const failure = $7de1124d1ac82d24$var$_sayKey(key || 'workspace.simone.approval.expired');
    try {
        $7de1124d1ac82d24$var$_patchToolActivity(root, {
            phase: 'result',
            callId: id,
            tool: held.tool,
            failure: failure
        }, held.k);
        $7de1124d1ac82d24$var$_patchToolActivity(root, {
            phase: 'completed',
            callId: id,
            tool: held.tool,
            ok: false,
            notRun: true,
            summary: failure
        }, held.k);
    } catch (_) {}
    try {
        const list = root && root[held.k + 'chatMessages'] || [];
        const msg = list.find((m)=>m && Array.isArray(m.tools) && m.tools.some((t)=>t && t.id === id));
        if (msg) {
            // ONE chip, in the shape the shared ChatMessage reads: its words
            // (`label`) and the request a press sends (`prompt`). A bare string
            // spread into character keys there: a chip with no words that did
            // nothing.
            const again = $7de1124d1ac82d24$var$_sayKey('workspace.simone.approval.runAgain');
            const had = Array.isArray(msg.suggestions) ? msg.suggestions : [];
            if (!had.some((s)=>s && s.label === again)) $7de1124d1ac82d24$var$_shellPatchAssistantMessage(root, msg.id, {
                suggestions: had.concat({
                    label: again,
                    prompt: again
                })
            }, held.k);
        }
    } catch (_) {}
    try {
        held.resolve({
            ok: false,
            denied: true,
            notRun: true,
            error: reason || "This action was not approved in time \u2014 it did not run."
        });
    } catch (_) {}
};
function $7de1124d1ac82d24$export$1d57447306a0971d(callId, approved) {
    const held = $7de1124d1ac82d24$var$_pendingToolApprovals[callId];
    if (!held) return;
    delete $7de1124d1ac82d24$var$_pendingToolApprovals[callId];
    const { root: root, k: k, tool: tool, run: run, resolve: resolve } = held;
    // A detached turn that stopped following while this row waited picks the
    // follow up again (the answer settles the call; the SDK posts the result).
    const resumeFollow = ()=>{
        if (typeof held.onAnswered === 'function') try {
            held.onAnswered();
        } catch (_) {}
    };
    if (!approved) {
        $7de1124d1ac82d24$var$_patchToolActivity(root, {
            phase: 'denied',
            callId: callId,
            tool: tool
        }, k);
        resolve({
            ok: false,
            denied: true,
            error: 'The user declined this action.'
        });
        resumeFollow();
        return;
    }
    $7de1124d1ac82d24$var$_patchToolActivity(root, {
        phase: 'approved',
        callId: callId,
        tool: tool
    }, k);
    Promise.resolve().then(run).then((res)=>resolve(res), (err)=>resolve({
            ok: false,
            error: err && err.message || String(err)
        })).then(resumeFollow);
}
// ── Re-offering a pending client call after a reload ────────────────────────
// SIMONE-APPROVAL-REOFFER-PENDING-CLIENT-CALL-UI-1. The gate above parks its
// promise in memory, so a reload kills it and the suspended server turn waits
// on a tool-result nobody can post. The server now persists the whole call on
// the conversation and serves it on the ordinary read; `sessions.js`
// restoreActiveThread picks it up and calls this.
//
// Deliberately NOT a second authorization policy: the call goes back through
// the SAME `runClientToolWithAuth` gate the live turn uses, so "Ask first"
// re-asks with the fn + args on the row the restore just painted, while
// read-only / navigation / render tools and Auto mode resume straight through
// — one rule, in one place. The server's own `confirm` flag only ever ADDS an
// ask (it forces the gate's ask mode); it can never skip one.
// How an ACCEPTED resume is followed (turnSettledAfter): one ordinary
// conversation read every 2 s, for at most 2 minutes, and only while the
// person still has the thread open.
const $7de1124d1ac82d24$var$RESUME_FOLLOW_INTERVAL_MS = 2000;
const $7de1124d1ac82d24$var$RESUME_FOLLOW_TIMEOUT_MS = 120000;
function $7de1124d1ac82d24$export$914e48bd5244f23f(payload) {
    const { offer: offer, conversationId: conversationId, scope: scope, opts: opts, stateRoot: stateRoot } = payload || {};
    const call = (0, $czZQn.normalizePendingClientCall)(offer);
    if (!call || !conversationId) return Promise.resolve({
        ok: false,
        error: 'No completable pending call.'
    });
    const root = $7de1124d1ac82d24$var$_shellResolveRoot({
        stateRoot: stateRoot
    });
    if (!root) return Promise.resolve({
        ok: false,
        error: 'No workspace UI available.'
    });
    const k = scope === 'addapp' ? '_ax_' : scope === 'dashboard' ? '_db_' : '';
    const callEl = typeof window !== 'undefined' && window.__wsRoot || $7de1124d1ac82d24$var$_installerEl || this;
    // The CALLER's service wins: sessions.js just used it to read this very
    // conversation, and `el.sdk.ai` is a different stub without the conversation
    // API (see sessions.js `_ai`). Fall back to the shared singleton only when
    // the caller had none to pass.
    const ai = payload && payload.ai || (0, $7iFOV.shellGetAiService)();
    if (!ai || typeof ai.submitToolResult !== 'function') return Promise.resolve({
        ok: false,
        error: 'No AI service to resume the turn.'
    });
    const typing = (on)=>{
        try {
            if (root.update) root.update({
                [k + 'chatTyping']: !!on
            });
        } catch (_) {}
    };
    // E — a load never runs a step again by itself (ON_LOAD_ASK_FNS above). A
    // step still waiting on its Run / Skip, or one this page received live and
    // did not run, is the live path's. `payload.live`: the live turn hands over
    // a call it never received (_followAfterDrop) — the person is there.
    const cid = String(call.callId);
    if ($7de1124d1ac82d24$var$_pendingToolApprovals[cid]) return Promise.resolve({
        ok: false,
        skipped: 'waiting'
    });
    const ranHere = $7de1124d1ac82d24$var$_ranHere(root, cid);
    if (!ranHere && $7de1124d1ac82d24$var$_callsOf($7de1124d1ac82d24$var$_seenOnRoot, root).has(cid)) return Promise.resolve({
        ok: false,
        skipped: 'seen'
    });
    const onLoad = !(payload && payload.live);
    let first = true;
    return (0, $czZQn.resumeFromPendingClientCall)({
        offer: call,
        runWithAuth: (c)=>{
            const isFirst = first;
            first = false;
            // Restore the row to "running" first: history rebuilds a bare tool_call
            // as a finished row, and an offer that is still waiting must not read as
            // already done. The gate flips it to `approval` when it parks. No `args`
            // on purpose — the restored row already holds the server's named-args
            // object, which reads better than the positional array.
            $7de1124d1ac82d24$var$_patchToolActivity(root, {
                phase: 'started',
                callId: c.callId,
                tool: c.tool
            }, k);
            // The loaded step: asked, never run by itself, when it moves or covers
            // the screen or ran in this tab before a reload. Steps chained after it
            // are live.
            const forceAsk = isFirst && onLoad && ($7de1124d1ac82d24$var$ON_LOAD_ASK_FNS.has(c.fn) || $7de1124d1ac82d24$var$_ranBeforeReload(conversationId, c.callId));
            const gate = ()=>$7de1124d1ac82d24$export$695c27f322c1f4a7(callEl, root, k, forceAsk ? {
                    ...c,
                    forceAsk: true
                } : c, ()=>$7de1124d1ac82d24$var$_rememberRun(root, conversationId, c, $7de1124d1ac82d24$var$_runPlatformTool(callEl, c.fn, c.args, {
                        root: root,
                        k: k,
                        readOnly: !!c.readOnly,
                        // a question asked again draws under its own step
                        callId: c.callId
                    })));
            // An APP verb is gated (read-only or Run / Skip) and run from the module
            // stash, and a cold load restores the thread BEFORE the apps publish it
            // (MODULE-FN-READONLY-LABELS-LAG-AN-APP-PUSH-1): decided then, a
            // read-only verb parked on Run / Skip and a run read "not permitted".
            // Decide once the stash declares the verb or the apps pass settled.
            // A step this page already ran posts that run's result instead (E.1).
            const ran = isFirst ? ranHere : null;
            return (ran ? Promise.resolve(ran) : $7de1124d1ac82d24$export$af7331ccf17e3135(callEl, root, c.fn) ? gate() : $7de1124d1ac82d24$export$24c27e8fe1fc41bd(callEl, root, c.fn).then(gate)).then((res)=>{
                // Superseded by a new message (supersedeParkedAiToolApprovals): its
                // row already says so, and nothing is posted.
                if (res && res.superseded) return res;
                // Only NOW is the turn actually working again — parking on Run / Skip
                // is the user's time, not the server's, and "Thinking…" would lie.
                typing(true);
                const created = (0, $8WAnX.toolOutcome)(res);
                const failure = (0, $8WAnX.toolFailure)(res);
                if (failure) $7de1124d1ac82d24$var$_patchToolActivity(root, {
                    phase: 'result',
                    callId: c.callId,
                    tool: c.tool,
                    failure: failure
                }, k);
                $7de1124d1ac82d24$var$_patchToolActivity(root, {
                    phase: 'completed',
                    callId: c.callId,
                    tool: c.tool,
                    ok: res && res.ok !== false,
                    summary: res && (res.summary || (typeof res.error === 'string' ? res.error : '')) || '',
                    ...created ? {
                        created: created
                    } : {}
                }, k);
                return res;
            });
        },
        submitToolResult: (callId, result)=>ai.submitToolResult(conversationId, callId, result, opts),
        // The server accepted the result and runs on past its ack window (202):
        // its answer streams to a page that is not listening. Follow the ordinary
        // read until the turn lands, then paint the thread from the server's own
        // transcript — the same rows a reload would show.
        awaitTurn: async (callId)=>{
            if (typeof ai.getConversation !== 'function') return null;
            const every = payload && payload.followIntervalMs || $7de1124d1ac82d24$var$RESUME_FOLLOW_INTERVAL_MS;
            const until = Date.now() + (payload && payload.followTimeoutMs || $7de1124d1ac82d24$var$RESUME_FOLLOW_TIMEOUT_MS);
            const open = ()=>root[k + 'activeSessionId'] === conversationId;
            while(Date.now() < until && open()){
                await new Promise((resolve)=>setTimeout(resolve, every));
                let data;
                try {
                    data = await ai.getConversation(conversationId, opts);
                } catch (_) {
                    continue;
                }
                const settled = (0, $czZQn.turnSettledAfter)(data, callId);
                if (!settled) continue;
                if (settled.done && open()) try {
                    const words = {
                        continueWord: (0, $3YHy5._continueWord)(callEl)
                    };
                    const rows = $7de1124d1ac82d24$var$_creditsRows((0, $3YHy5._toChatMessages)(data.messages, words), root, callEl);
                    root.update({
                        [k + 'chatMessages']: rows
                    });
                } catch (_) {
                /* best-effort — the turn finished; a reload paints it */ }
                return settled;
            }
            return null;
        },
        onAnswer: (message)=>{
            const text = $7de1124d1ac82d24$var$_messageText(message);
            if (!text) return;
            // A resumed turn can end in the credit refusal too: the shell's sentence
            // and the metadata its notification and banner read (and only then —
            // no other message carries its metadata onto this row).
            const refused = $7de1124d1ac82d24$var$_creditsRow(text, message.metadata, root, callEl);
            const next = (root[k + 'chatMessages'] || []).concat({
                id: String(message.id || message._id || `a-${Date.now()}`),
                role: 'assistant',
                text: refused ? refused.text : text,
                ts: Date.now(),
                streaming: false,
                tools: [],
                cards: [],
                suggestions: Array.isArray(message.metadata?.suggestions) ? message.metadata.suggestions : [],
                ...refused ? {
                    metadata: refused.metadata
                } : {}
            });
            root.update({
                [k + 'chatMessages']: next
            });
        }
    }).then((res)=>{
        // A superseded step belongs to a thread the new message now drives — its
        // typing flag is that turn's.
        if (res && res.superseded) return res;
        typing(false);
        try {
            if (callEl && typeof callEl.call === 'function') callEl.call('refreshSessionsAfterTurn', scope);
        } catch (_) {
        /* best-effort — history just won't refresh until reload */ }
        return res;
    });
}
// Per-turn flag — set true when the cloud loop drives injectPageInApp itself
// (so the onDone build-spec render fallback knows a render already happened and
// skips, avoiding a double-render). Reset at the start of every dispatch turn.
let $7de1124d1ac82d24$var$_extensionRenderedThisTurn = false;
// ── Client (browser) tools ───────────────────────────────────────────────────
// Defense-in-depth allow-list mirroring the server's client-tool catalog
// (workspaceTools.js): only these platform functions may be driven by the AI.
// Destructive ones (logout, switchOrg, …) are never here. The server already
// resolved tool → fn + positional args; we re-check fn here and shape the
// result the model reads. Each returns a structured { ok, … } object.
const $7de1124d1ac82d24$var$CLIENT_TOOL_FNS = new Set([
    'openAppPage',
    'openPageInSplit',
    'renderAnswerUi',
    'changeGlobalTheme',
    'globalSearch',
    'confirmDialog',
    'closeAllModals',
    'injectPageInApp',
    'renderMultiPageApp',
    'selectPageItem',
    'renderCards',
    'askUser',
    'aiDescribeCapabilities',
    'aiStartTour' // start_tour — the quick tour over the member's screen (aiStartTour.js)
]);
// AI workspace-operation tools (functions/aiWorkspaceOps.js): the assistant
// performs what a user can do in the UI (create/rename/duplicate/delete files,
// notes, tickets, channels…). Each takes flat args, resolves the target by
// id/name in the unified root state, reuses the existing UI function + SDK route,
// and returns a structured { ok, … }. Dispatched generically (no per-tool case).
const $7de1124d1ac82d24$var$DATA_OP_FNS = new Set([
    'aiCreateFolder',
    'aiRenameFile',
    'aiDeleteFile',
    'aiDuplicateFile',
    'aiMoveFileToFolder',
    'aiCreateNote',
    'aiRenameNote',
    'aiDeleteNote',
    'aiCreateTicket',
    'aiUpdateTicket',
    'aiAssignTicket',
    'aiMoveTicket',
    'aiDeleteTicket',
    'aiCreateChannel',
    'aiSendMessage',
    // AI-CREATED home widgets (tickets/opus.md "Per-workspace AI-CREATED
    // widgets"). Listed here — NOT in READ_ONLY_AI_TOOLS — so all three are
    // classified WRITE explicitly rather than relying on the unknown-tool
    // default, and every one of them goes through runClientToolWithAuth →
    // resolveAiToolApproval exactly like every other write action (Ask-first
    // mode shows a Run / Skip row carrying a live preview of the pending
    // widget — see ChatToolRow). `aiEditWidget` would otherwise be caught by
    // NEITHER read prefix, and `aiCreateWidget`/`aiDeleteWidget` are writes by
    // any reading — the point of naming them is that the classification is a
    // decision here, not an accident of a regex.
    'aiCreateWidget',
    'aiEditWidget',
    'aiDeleteWidget',
    // mail_draft_reply (architecture/MAIL.md §3.2a) — opens the compose dock
    // through THE one entry point (openMailCompose, mail's eager slice) with a
    // prefilled draft; it never sends. Classified WRITE (not in any read
    // prefix) on purpose: Ask-first mode shows Run/Skip before a dock pops
    // over the person's screen. The server-side tool definition ships with
    // MAIL-AI-TOOLS-1; until then no dispatch names this fn.
    'aiMailDraftReply'
]);
// AI fns declared by the ACTIVE workspace module — read at CALL time from the
// module stash (root.workspaceProject.aiFunctions, written by
// loadWorkspaceProject) so a module injected after transport install is
// honored, and revoked the moment the module tears down. Set-ified per array
// identity (WeakMap) so the per-call gate stays O(1) without re-allocating.
const $7de1124d1ac82d24$var$_EMPTY_FN_SET = new Set();
const $7de1124d1ac82d24$var$_moduleAiFnSetCache = new WeakMap();
const $7de1124d1ac82d24$var$_moduleAiFns = (el)=>{
    const root = el?.state?.root || el?.getRoot?.()?.state?.root;
    const list = root?.workspaceProject?.aiFunctions;
    if (!Array.isArray(list) || !list.length) return $7de1124d1ac82d24$var$_EMPTY_FN_SET;
    let set = $7de1124d1ac82d24$var$_moduleAiFnSetCache.get(list);
    if (!set) {
        set = new Set(list);
        $7de1124d1ac82d24$var$_moduleAiFnSetCache.set(list, set);
    }
    return set;
};
function $7de1124d1ac82d24$export$464ab4e80706876c(el, fn) {
    if (!fn || !$7de1124d1ac82d24$var$_moduleAiFns(el).has(fn)) return false;
    const root = el?.state?.root || el?.getRoot?.()?.state?.root;
    const list = root?.workspaceProject?.readOnlyAiFunctions;
    return Array.isArray(list) && list.includes(fn);
}
function $7de1124d1ac82d24$export$af7331ccf17e3135(el, root, fn) {
    if (!fn || $7de1124d1ac82d24$var$CLIENT_TOOL_FNS.has(fn) || $7de1124d1ac82d24$var$DATA_OP_FNS.has(fn)) return true;
    if ($7de1124d1ac82d24$var$_moduleAiFns(el).has(fn)) return true;
    return !!(root && root._appRoutesSettled);
}
function $7de1124d1ac82d24$export$24c27e8fe1fc41bd(el, root, fn, { timeoutMs: timeoutMs = 15000, intervalMs: intervalMs = 200 } = {}) {
    return new Promise((resolve)=>{
        if ($7de1124d1ac82d24$export$af7331ccf17e3135(el, root, fn)) return resolve(true);
        const started = Date.now();
        const tick = ()=>{
            if ($7de1124d1ac82d24$export$af7331ccf17e3135(el, root, fn)) return resolve(true);
            if (Date.now() - started >= timeoutMs) return resolve(false);
            setTimeout(tick, intervalMs);
        };
        setTimeout(tick, intervalMs);
    });
}
// `scope` — the DISPATCHING turn's { root, k }, threaded from onToolCall so
// chat-surface tools attach to the exact thread that asked. Callers without a
// live dispatch (build-spec fallback, tests) omit it and the chat cases fall
// back to the _cardScope heuristic.
async function $7de1124d1ac82d24$var$_runPlatformTool(el, fn, args = [], scope = null) {
    if (!el || typeof el.call !== 'function') return {
        ok: false,
        error: 'No workspace UI is available to run this action.'
    };
    // Third acceptance leg: fns the ACTIVE workspace module declares AI-drivable
    // (root.workspaceProject.aiFunctions). Scoped exactly like the module's
    // injected functions — gone the moment the module unloads.
    const isModuleFn = $7de1124d1ac82d24$var$_moduleAiFns(el).has(fn);
    if (!$7de1124d1ac82d24$var$CLIENT_TOOL_FNS.has(fn) && !$7de1124d1ac82d24$var$DATA_OP_FNS.has(fn) && !isModuleFn) return {
        ok: false,
        error: `Platform function "${fn}" is not permitted from the AI.`
    };
    try {
        // Data-operation tools (and module-declared fns) take flat args and return
        // their own { ok, … }.
        if ($7de1124d1ac82d24$var$DATA_OP_FNS.has(fn) || isModuleFn) {
            // A verb the frame and the live stash both mark read-only runs on a
            // read-only caller (moduleReadOnlyCall.js): records reads pass, every
            // write / action / send from inside it is refused, and a refused write
            // turns the result into ok:false naming it.
            if (isModuleFn && scope && scope.readOnly && $7de1124d1ac82d24$export$464ab4e80706876c(el, fn)) {
                const caller = (0, $go87e.readOnlyCaller)(el, {
                    fn: fn,
                    refuse: [
                        ...$7de1124d1ac82d24$var$DATA_OP_FNS
                    ]
                });
                let res;
                try {
                    res = await caller.call(fn, ...args);
                } catch (e) {
                    // A refused write usually surfaces as the verb's own throw — the
                    // record still names what was refused.
                    res = {
                        ok: false,
                        error: e && e.message || 'The function failed.'
                    };
                }
                return (0, $go87e.withReadOnlyOutcome)(res && typeof res === 'object' ? res : {
                    ok: res !== false,
                    result: res
                }, (0, $go87e.readOnlyCallOf)(caller));
            }
            const res = await el.call(fn, ...args);
            return res && typeof res === 'object' ? res : {
                ok: res !== false,
                result: res
            };
        }
        switch(fn){
            case 'openAppPage':
                el.call('openAppPage', args[0]);
                return {
                    ok: true,
                    navigated: args[0]
                };
            case 'openPageInSplit':
                {
                    // open_page_in_split — show a workspace page BESIDE the conversation in
                    // the shell PageSlot (root._canvasSlot), the same sheet every app page
                    // opens in. The docked assistant sits beside it (content shrinks), so it
                    // behaves identically on home and every other route now that the inline
                    // dashboard thread is retired. args[0] = route ('' closes it).
                    const route = String(args[0] || '').trim();
                    const callRoot = el?.state?.root || el?.getRoot?.()?.state?.root;
                    if (callRoot?.update) callRoot.update(route ? {
                        _canvasSlot: route,
                        _slotFullscreen: null
                    } : {
                        _canvasSlot: null,
                        _canvasSlotSecond: null,
                        _slotFullscreen: null
                    });
                    return route ? {
                        ok: true,
                        opened: route
                    } : {
                        ok: true,
                        closed: true
                    };
                }
            case 'renderAnswerUi':
                {
                    // render_answer_ui — draw a transient DOMQL answer view
                    // (canvas/functions/answerUi.js owns the parse + audit + register).
                    // INLINE in the thread (AI_ASSISTANT_SPEC v1 §3): the view also rides
                    // the answer as a 'view' card, so the sidebar AND the main thread draw
                    // it where the question was asked (components/AssistantThreadBlock.js).
                    // The split pane beside the conversation opens as before — except while
                    // the MAIN thread holds the home (the view is already in the thread;
                    // its "Open in split" is one click away).
                    const root = scope?.root || el.state?.root || el.state;
                    const k = scope && typeof scope.k === 'string' ? scope.k : $7de1124d1ac82d24$var$_cardScope(root);
                    // THE BUILDER'S OWN TURN: a drawn view IS the app being built, so it
                    // renders in the builder's Preview pane — its render host — never in
                    // a split pane beside the builder (aiko, tomas round 1b: the Preview
                    // said "Your idea is taking shape" all session while the board showed
                    // in a floating pane). The same guarded path as render_extension_page
                    // (the host builds through buildInlineExtensionDef: the audit and the
                    // containment gate), so Save keeps it; a refusal returns to the AI as
                    // it came, and it rebuilds.
                    const builderHost = typeof window !== 'undefined' && window.__addAppHost || null;
                    if (k === '_ax_' && builderHost && typeof builderHost.call === 'function') {
                        const view = args[0] || {};
                        const shown = await builderHost.call('injectPageInApp', {
                            name: String(view.title || '').trim() || $7de1124d1ac82d24$var$_sayKey('workspace.apps.nameFallback'),
                            source: String(view.source || ''),
                            entities: []
                        });
                        if (shown && shown.ok !== false) {
                            $7de1124d1ac82d24$var$_extensionRenderedThisTurn = true;
                            return {
                                ...shown && typeof shown === 'object' ? shown : {},
                                ok: true,
                                rendered: true,
                                note: "Shown in the builder's Preview beside the conversation. The person can Save it as an app there."
                            };
                        }
                        return shown && typeof shown === 'object' ? shown : {
                            ok: false
                        };
                    }
                    const inMain = !!(root && root._homeThreadOpen === true && root.assistantDock === 'main');
                    const res = await el.call('renderAnswerUi', {
                        ...args[0] || {},
                        ...inMain ? {
                            open: false
                        } : {}
                    });
                    if (res && res.ok && res.opened) try {
                        $7de1124d1ac82d24$var$_attachCards(root, [
                            {
                                type: 'view',
                                route: res.opened,
                                title: res.title || ''
                            }
                        ], k);
                    } catch (_) {
                    /* no thread to attach to (a build-spec fallback) — the view stays registered */ }
                    return res && typeof res === 'object' ? res : {
                        ok: true
                    };
                }
            case 'changeGlobalTheme':
                el.call('changeGlobalTheme', args[0]);
                return {
                    ok: true,
                    theme: args[0]
                };
            case 'closeAllModals':
                el.call('closeAllModals');
                return {
                    ok: true
                };
            case 'injectPageInApp':
                {
                    // render_extension_page — args[0] = { name, source, projectId }. CRITICAL:
                    // render ONLY into the add-app surface's own render host
                    // (window.__addAppHost), whose element carries the add-app router/context.
                    // Calling injectPageInApp from the SHELL root (window.__wsRoot) walks up to
                    // the shell router and hijacks the whole workspace (blank view) — never do
                    // that.
                    const payload = args[0] || {};
                    // BIND the builder to the just-created extension's Project: the chat
                    // thread becomes project-scoped from here, the sidebar marks it active,
                    // and a later select reloads ITS thread. Done even when the render host
                    // isn't mounted, so the binding survives a build kicked off elsewhere.
                    const root = el.state && (el.state.root || el.state) || null;
                    if (payload.projectId && root?.update) try {
                        // A BIND, not a switch: the live conversation built this app, so
                        // the chat already holds its thread. Marked hydrated BEFORE the id
                        // lands — the builder's hydrateAddAppThread (subscribed to
                        // _addAppProjectId) otherwise opened the app's own thread over the
                        // live turn: the chat emptied to "What would you like to build?"
                        // and the closing message came back only after a reload (nino,
                        // round 1b). A fresh builder mount clears the mark (BuildCanvas).
                        root.__addAppHydratedThreadId = String(payload.projectId);
                        root.update({
                            _addAppProjectId: String(payload.projectId),
                            _addAppRendered: false
                        });
                        // Refresh the apps sidebar so the new extension appears + shows active.
                        el.call('loadAddAppExtensions', root);
                    } catch (_) {
                    /* binding is best-effort */ }
                    const host = typeof window !== 'undefined' && window.__addAppHost || null;
                    if (!host || typeof host.call !== 'function') {
                        // The add-app render iframe isn't mounted (the user isn't on /add-app,
                        // or it hasn't booted). Queue the render so AppRender.onCreate flushes
                        // it when the host installs — AND open a live preview in the shell
                        // PageSlot right now, so a build is ALWAYS visible where it was asked
                        // for (2026-07-24 per Nika "when it builds app it should also always
                        // open preview"). The preview renders through the same guarded iframe
                        // pipeline (openExtensionPreview → ExtensionEmbed).
                        try {
                            if (typeof window !== 'undefined') window.__addAppPendingRender = {
                                name: payload.name,
                                source: payload.source,
                                entities: payload.entities || payload.dataEntities || []
                            };
                        } catch (_) {}
                        let previewed = false;
                        const inThread = $7de1124d1ac82d24$var$_previewInThread(root);
                        try {
                            const pv = el.call('openExtensionPreview', {
                                name: payload.name,
                                source: payload.source,
                                entities: payload.entities || payload.dataEntities || [],
                                projectId: payload.projectId || payload.extensionId || null,
                                ...inThread ? {
                                    open: false
                                } : {}
                            });
                            previewed = !!(pv && pv.ok);
                            if (inThread) $7de1124d1ac82d24$var$_attachPreviewCard(scope?.root || root, scope, pv, payload.name);
                        } catch (err) {
                            console.warn('[simone] extension preview failed:', err?.message || err);
                        }
                        if (previewed) $7de1124d1ac82d24$var$_extensionRenderedThisTurn = true;
                        return {
                            ok: true,
                            rendered: previewed,
                            bound: !!payload.projectId,
                            note: previewed ? inThread ? 'Preview shown in the conversation, with "Save as app" on it. The app is saved as a draft \u2014 it is not installed until the person saves it as an app.' : "Preview opened beside the conversation. The app is saved \u2014 the Add App surface can iterate on it." : 'Extension created and saved. Open the Add App surface to view it render.'
                        };
                    }
                    const res = await host.call('injectPageInApp', {
                        name: payload.name,
                        source: payload.source,
                        // Forward the declared data surface so renderExtensionInPane scopes
                        // the iframe's SDK executor to exactly these workspaceProject.* entities.
                        entities: payload.entities || payload.dataEntities || []
                    });
                    // Mark this turn as already-rendered so the onDone build-spec fallback
                    // doesn't re-render the same extension.
                    if (res && res.ok !== false) $7de1124d1ac82d24$var$_extensionRenderedThisTurn = true;
                    return res && typeof res === 'object' ? res : {
                        ok: true
                    };
                }
            case 'renderMultiPageApp':
                {
                    // create_app clientAfterExecute — args[0] = { name, pages, theme,
                    // projectId }. Render ONLY into the add-app host (never the shell root —
                    // same hijack hazard as injectPageInApp). Mirrors that path exactly.
                    const payload = args[0] || {};
                    const root = el.state && (el.state.root || el.state) || null;
                    if (payload.projectId && root?.update) try {
                        // A bind, not a switch — see injectPageInApp above.
                        root.__addAppHydratedThreadId = String(payload.projectId);
                        root.update({
                            _addAppProjectId: String(payload.projectId),
                            _addAppRendered: false
                        });
                        el.call('loadAddAppExtensions', root);
                    } catch (_) {
                    /* binding is best-effort */ }
                    const host = typeof window !== 'undefined' && window.__addAppHost || null;
                    if (!host || typeof host.call !== 'function') {
                        // Host not mounted (user isn't on /add-app) — queue for AppRender's
                        // onCreate flush AND open a live PageSlot preview of the app's pages
                        // right here (same always-visible-build contract as injectPageInApp).
                        try {
                            if (typeof window !== 'undefined') window.__addAppPendingApp = {
                                name: payload.name,
                                pages: payload.pages || [],
                                theme: payload.theme || null
                            };
                        } catch (_) {}
                        let previewed = false;
                        const inThread = $7de1124d1ac82d24$var$_previewInThread(root);
                        try {
                            const pv = el.call('openExtensionPreview', {
                                name: payload.name,
                                pages: payload.pages || [],
                                theme: payload.theme || null,
                                projectId: payload.projectId || null,
                                ...inThread ? {
                                    open: false
                                } : {}
                            });
                            previewed = !!(pv && pv.ok);
                            if (inThread) $7de1124d1ac82d24$var$_attachPreviewCard(scope?.root || root, scope, pv, payload.name);
                        } catch (err) {
                            console.warn('[simone] app preview failed:', err?.message || err);
                        }
                        if (previewed) $7de1124d1ac82d24$var$_extensionRenderedThisTurn = true;
                        return {
                            ok: true,
                            rendered: previewed,
                            bound: !!payload.projectId,
                            note: previewed ? inThread ? 'Preview shown in the conversation, with "Save as app" on it. The app is saved as a draft \u2014 it is not installed until the person saves it as an app.' : "Preview opened beside the conversation. The app is saved \u2014 the Add App surface can iterate on it." : 'App created and saved. Open the Add App surface to view it render.'
                        };
                    }
                    const res = await host.call('renderMultiPageApp', {
                        name: payload.name,
                        pages: payload.pages || [],
                        theme: payload.theme || null
                    });
                    if (res && res.ok !== false) $7de1124d1ac82d24$var$_extensionRenderedThisTurn = true;
                    return res && typeof res === 'object' ? res : {
                        ok: true
                    };
                }
            case 'globalSearch':
                {
                    const results = await el.call('globalSearch', args[0]);
                    return {
                        ok: true,
                        query: args[0],
                        results: results
                    };
                }
            case 'selectPageItem':
                {
                    // select_page_item — open/select a ticket/channel/document/event/room
                    // on the page the user is viewing, or a workspace record on its app's
                    // page (type 'record': the third argument is its collection, sent only
                    // by a server that saw `capabilities.openRecord`). Pure client
                    // selection state; the fn returns its own structured { ok, … }. An
                    // older server's two arguments pass through as they are.
                    const res = await el.call('selectPageItem', ...args.slice(0, 3));
                    return res && typeof res === 'object' ? res : {
                        ok: true
                    };
                }
            case 'renderCards':
                {
                    // render_cards — attach display cards (tickets/people/thumbnails) to the
                    // assistant's current message. Non-suspending; the AI keeps answering.
                    // The dispatching turn's { root, k } win over the _cardScope heuristic —
                    // a suspended/orphaned turn in another scope must never steal the cards.
                    const root = scope?.root || el.state?.root || el.state;
                    const cards = Array.isArray(args[0]) ? args[0] : [];
                    const k = scope && typeof scope.k === 'string' ? scope.k : $7de1124d1ac82d24$var$_cardScope(root);
                    $7de1124d1ac82d24$var$_attachCards(root, cards, k);
                    return {
                        ok: true,
                        rendered: cards.length
                    };
                }
            case 'aiStartTour':
                {
                    // start_tour — the quick tour over the member's screen
                    // (functions/aiStartTour.js): home first, then the stops. Its own
                    // { ok, started, stops } is what the model reads.
                    const res = await el.call('aiStartTour');
                    return res && typeof res === 'object' ? res : {
                        ok: res !== false,
                        result: res
                    };
                }
            case 'aiDescribeCapabilities':
                {
                    // describe_capabilities — a TYPED "what can you do here?" gets the
                    // SAME catalogue card the composer's row shows: aiCapabilities.js (the
                    // composer's pure builder over the chosen context — Ask / Do / Build
                    // / Inspect from the installed apps' own manifests) attached to the
                    // live answer, and a compact reading handed back so the model adds
                    // one line instead of listing the catalogue in prose.
                    const root = scope?.root || el.state?.root || el.state;
                    const k = scope && typeof scope.k === 'string' ? scope.k : $7de1124d1ac82d24$var$_cardScope(root);
                    const cat = el.call('aiCapabilities', root);
                    if (!cat || !Array.isArray(cat.groups) || !cat.groups.length) return {
                        ok: false,
                        error: 'No capability catalogue for this context.'
                    };
                    $7de1124d1ac82d24$var$_attachCards(root, [
                        {
                            type: 'capabilities',
                            title: cat.title,
                            scope: cat.scope,
                            groups: cat.groups
                        }
                    ], k);
                    return {
                        ok: true,
                        shown: 'the capabilities card',
                        scope: cat.scope,
                        groups: cat.groups.map((g)=>({
                                key: g.key,
                                title: g.title,
                                items: (Array.isArray(g.items) ? g.items : []).map((it)=>it && it.label).filter(Boolean)
                            }))
                    };
                }
            case 'askUser':
                {
                    // ask_user — render a choice/confirm card and SUSPEND until the user
                    // clicks a button (resolveChatCard resolves this Promise → the turn
                    // resumes with the pick). args = [prompt, options[], kind].
                    const root = scope?.root || el.state?.root || el.state;
                    const k = scope && typeof scope.k === 'string' ? scope.k : $7de1124d1ac82d24$var$_cardScope(root);
                    const prompt = args[0];
                    const options = Array.isArray(args[1]) ? args[1] : [];
                    const kind = args[2] === 'confirm' ? 'confirm' : 'choice';
                    const card = kind === 'confirm' ? {
                        type: 'confirm',
                        prompt: prompt,
                        confirmLabel: options[0] && options[0].label,
                        cancelLabel: options[1] && options[1].label
                    } : {
                        type: 'choice',
                        prompt: prompt,
                        options: options
                    };
                    return await $7de1124d1ac82d24$var$_askOnCard(root, k, card, scope, (value, label, extra)=>$7de1124d1ac82d24$var$_askAnswer(kind, value, label, extra));
                }
            // confirm_with_user — the SAME confirm card, in the thread that asked
            // (Nika 2026-10-28: the confirmation card in the AI chat). It opened the
            // shell's modal, whose template reads `message` and dropped the tool's
            // `body`: the person read a stock line instead of the question. The
            // body IS the question; the model reads `confirmed` back (and `edit`).
            case 'confirmDialog':
                {
                    const root = scope?.root || el.state?.root || el.state;
                    const k = scope && typeof scope.k === 'string' ? scope.k : $7de1124d1ac82d24$var$_cardScope(root);
                    const opts = args[0] && typeof args[0] === 'object' ? args[0] : {};
                    const card = {
                        type: 'confirm',
                        prompt: String(opts.body || opts.message || opts.title || ''),
                        confirmLabel: opts.confirmText,
                        cancelLabel: opts.cancelText
                    };
                    return await $7de1124d1ac82d24$var$_askOnCard(root, k, card, scope, (value, label, extra)=>$7de1124d1ac82d24$var$_confirmAnswer(value, extra));
                }
            default:
                return {
                    ok: false,
                    error: `Unhandled platform function "${fn}".`
                };
        }
    } catch (err) {
        return {
            ok: false,
            error: String(err?.message || err)
        };
    }
}

});
parcelRegister("c4Noe", function(module, exports) {

$parcel$export(module.exports, "buildUiCatalog", () => $8cac2b92732d0f8d$export$1e6a284d45b16f73);
// Workspace UI catalog — the assistant's THIRD knowledge layer (generic →
// DOMQL/platform → THIS workspace). A compact, per-turn snapshot of the active
// workspace's personalized surface, sent as dispatchContext.uiCatalog and
// rendered into the system instructions server-side
// (ConversationOrchestratorService.buildWorkspaceCatalogLine): the module's
// live routes (open_page_in_split targets), its component vocabulary
// (render_answer_ui `extends` targets), its loaded root state keys with sampled
// row shapes (live data the AI reads via `s.root.<key>` — no fetch round-trip),
// and the workspace design-system accent vars. Personalization is server-driven
// (workspace.settings.workspaceModule → loadWorkspaceProject) — this only
// REFLECTS what that mechanism injected, so a workspace without a module (e.g.
// aihouse today) still gets a truthful minimal catalog and everything degrades
// cleanly.
//
// Size discipline: the whole catalog must stay well under the server's 5K cap —
// names and shapes only, never data rows beyond one sampled row's keys.

var $g7CNh = parcelRequire("g7CNh");

var $cmUBA = parcelRequire("cmUBA");

var $lo3nm = parcelRequire("lo3nm");
const $8cac2b92732d0f8d$var$MAX_LIST = 24;
const $8cac2b92732d0f8d$var$MAX_STATE_KEYS = 12;
// The AI-callable verbs are the CALL GATE's list, not a sample: the server
// offers a module verb only when the shell reports it live, so a verb past a
// cut is simply not offered. 24 was one app's worth — Storm's three apps
// declare 24 between them, and the action verb appended after them fell out
// (MODULE-ACTIONS-PROPOSAL-NEVER-OFFERED-1). Names are short; the server's
// line cap (5K) bounds the instruction text either way.
const $8cac2b92732d0f8d$var$MAX_AI_FNS = 96;
const $8cac2b92732d0f8d$var$MAX_ACTIONS = 48;
const $8cac2b92732d0f8d$var$PROPOSE_FN = 'proposeModuleAction';
// One row's shape — key names plus primitive example values (strings clipped),
// enough for the model to write correct filters without shipping the dataset.
//
// Non-primitive fields are described by a TYPE TOKEN, never by an elided
// value-shaped placeholder. This is load-bearing: the catalog is JSON.stringify'd
// straight into the system instruction, so whatever stands in for a nested
// object is read by the model as that field's example VALUE. The former `'{…}'`
// placeholder taught it that a nested payload field literally contains the
// two-character string `{…}`, and it dutifully echoed `"payload": "{…}"` back in
// tool calls (natali QA 2026-07-27). `<object>` / `<array:3>` read as
// annotations, carry the same information, and cannot be mistaken for data.
const $8cac2b92732d0f8d$var$_rowShape = (row)=>{
    if (!row || typeof row !== 'object') return null;
    const shape = {};
    for (const [key, value] of Object.entries(row).slice(0, 14)){
        if (value == null) shape[key] = null;
        else if (typeof value === 'string') shape[key] = value.slice(0, 24);
        else if (typeof value === 'number' || typeof value === 'boolean') shape[key] = value;
        else if (Array.isArray(value)) shape[key] = `<array:${value.length}>`;
        else shape[key] = `<object:${Object.keys(value).slice(0, 6).join(',')}>`;
    }
    return shape;
};
function $8cac2b92732d0f8d$export$1e6a284d45b16f73(root, opts = {}) {
    if (!root) return null;
    const project = root.workspaceProject;
    const catalog = {};
    // The colour and theme names a generated view may use — FIRST in the
    // catalog, ahead of the long per-app lists.
    try {
        const ds = opts && opts.designSystem;
        if (ds && typeof ds === 'object') {
            const names = (0, $lo3nm.designSystemNames)(ds);
            if (names.colors.length || names.themes.length) catalog.designNames = names;
        }
    } catch (_) {
    /* names are optional context — never block a turn on them */ }
    if (project && typeof project === 'object') {
        if (project.id) catalog.module = project.id;
        // WS-MODULE-STATE-SCOPE-1 — a module's rows live on ITS OWN state root now,
        // not on the shell root. Reading `root[key]` here would report every
        // module slice as `{ empty: true }` / `notLoaded` while the module has the
        // data, and the assistant would then re-trigger a loader that already ran.
        // The module store falls back to the shell root for anything it does not
        // own, so this read is correct for both scoped and unscoped modules.
        const modState = project.id != null && root._moduleStateGet?.(project.id) || root;
        const pages = Object.keys(project.pages || {});
        if (pages.length) catalog.pages = pages.slice(0, $8cac2b92732d0f8d$var$MAX_LIST);
        // Only the components a generated view may EXTEND: the containment gate
        // (generatedAppContainment.js) mounts its reviewed list and refuses every
        // other name with component_not_allowed. An installed app's own
        // components are never on it, so advertising them taught the assistant to
        // build every answer view on them — Storm on dev 2026-10-04: six of ten
        // render_answer_ui calls refused for ValCard / ValCellMid
        // (MODULE-COMPONENTS-ADVERTISED-BUT-REFUSED-1).
        const reviewed = new Set((0, $cmUBA.GENERATED_APP_COMPONENT_ALLOWLIST));
        const components = (Array.isArray(project.components) ? project.components : []).filter((n)=>reviewed.has(n));
        if (components.length) catalog.components = components.slice(0, $8cac2b92732d0f8d$var$MAX_LIST);
        const widgets = Array.isArray(project.widgets) ? project.widgets.map((w)=>w && w.id).filter(Boolean) : [];
        if (widgets.length) catalog.widgets = widgets.slice(0, $8cac2b92732d0f8d$var$MAX_LIST);
        // The verbs this module lets the AI drive. Without these the assistant was
        // never told they exist: the shell GATES module fns at call time
        // (simoneAiTransport._moduleAiFns) but nothing advertised them, so a model
        // asked to draw on the Excalidraw board had no way to know
        // `excalidrawAddElements` was there — it could only offer to describe a
        // diagram in prose. Gating and advertising are different jobs and only one
        // of them was done.
        //
        // `docs` carries the call shape when the manifest supplies one, because
        // knowing a verb exists isn't enough to use it well: told only the name, an
        // assistant guesses the arguments, and on excalidraw that guess produced
        // free-floating text elements overlapping their boxes instead of bound,
        // wrapped labels.
        const aiFns = Array.isArray(project.aiFunctions) ? project.aiFunctions : [];
        if (aiFns.length) {
            const listed = aiFns.slice(0, $8cac2b92732d0f8d$var$MAX_AI_FNS);
            // The approval-gated propose verb is never the one a cut drops.
            if (aiFns.includes($8cac2b92732d0f8d$var$PROPOSE_FN) && !listed.includes($8cac2b92732d0f8d$var$PROPOSE_FN)) listed[listed.length - 1] = $8cac2b92732d0f8d$var$PROPOSE_FN;
            catalog.aiFunctions = listed;
            const docs = project.aiFunctionDocs;
            if (docs && typeof docs === 'object') {
                const named = {};
                for (const name of catalog.aiFunctions)if (docs[name]) named[name] = docs[name];
                if (Object.keys(named).length) catalog.aiFunctionDocs = named;
            }
            // The listed verbs this shell runs READ-ONLY (MODULE-FN-READONLY-
            // ENFORCED-1): the server marks a module_fn tool read-only only when its
            // grant agrees, and the gate then runs it without the Run / Skip row on
            // a caller that refuses every write.
            const readOnly = Array.isArray(project.readOnlyAiFunctions) ? project.readOnlyAiFunctions.filter((name)=>catalog.aiFunctions.includes(name)) : [];
            if (readOnly.length) catalog.readOnlyAiFunctions = readOnly;
        }
        // The approval-gated ACTIONS the installed apps declare (manifest
        // `actions`), live in this shell: the keys the assistant may propose with
        // propose_app_action — the member approves the card before anything runs.
        // Reported only while the propose verb itself is callable.
        const actionKeys = Array.isArray(project.actionKeys) ? project.actionKeys : [];
        if (actionKeys.length && (catalog.aiFunctions || []).includes($8cac2b92732d0f8d$var$PROPOSE_FN)) {
            catalog.moduleActions = actionKeys.slice(0, $8cac2b92732d0f8d$var$MAX_ACTIONS);
            const docs = project.actionDocs;
            if (docs && typeof docs === 'object') {
                const named = {};
                for (const key of catalog.moduleActions)if (typeof docs[key] === 'string' && docs[key]) named[key] = docs[key];
                if (Object.keys(named).length) catalog.moduleActionDocs = named;
            }
        }
        const stateKeys = Array.isArray(project.stateKeys) ? project.stateKeys : [];
        if (stateKeys.length) {
            const keys = {};
            for (const key of stateKeys.slice(0, $8cac2b92732d0f8d$var$MAX_STATE_KEYS)){
                const value = modState[key];
                if (Array.isArray(value)) keys[key] = {
                    count: value.length,
                    row: $8cac2b92732d0f8d$var$_rowShape(value[0])
                };
                else if (value && typeof value === 'object') keys[key] = {
                    keys: Object.keys(value).slice(0, 10)
                };
                else keys[key] = {
                    empty: true
                };
            }
            catalog.stateKeys = keys;
        }
        // Loader-backed module data — the imperative data paths auto-discovered
        // from the module's functions (workspaceProjects._discoverLoaders). Each
        // entry names the el.call loader, its primary root state key, and that
        // key's LIVE contents (count + row shape once loaded), so a drawn view
        // knows both where the data lands and whether it must trigger the load.
        const loaders = project.loaders && typeof project.loaders === 'object' ? project.loaders : null;
        if (loaders) {
            const out = {};
            for (const [name, meta] of Object.entries(loaders).slice(0, 10)){
                const key = Array.isArray(meta?.writes) ? meta.writes[0] : null;
                if (!key) continue;
                const value = modState[key];
                const entry = Array.isArray(value) && value.length ? {
                    key: key,
                    count: value.length,
                    row: $8cac2b92732d0f8d$var$_rowShape(value[0])
                } : {
                    key: key,
                    count: 0,
                    notLoaded: true
                };
                if (Array.isArray(meta.flags) && meta.flags.length) entry.flags = meta.flags;
                out[name] = entry;
            }
            if (Object.keys(out).length) catalog.loaders = out;
        }
        // Declared data recipes — declarative fetch descriptors the module ships
        // for AI reuse. Compact projection only (5K-cap discipline).
        const dataRecipes = Array.isArray(project.dataRecipes) ? project.dataRecipes : [];
        if (dataRecipes.length) catalog.dataRecipes = dataRecipes.slice(0, 8).map((r)=>({
                id: r.id || r.from,
                from: r.from,
                method: r.method || 'select',
                ...r.params ? {
                    params: r.params
                } : {},
                ...r.as ? {
                    as: r.as
                } : {},
                ...r.describe ? {
                    describe: String(r.describe).slice(0, 100)
                } : {}
            }));
    }
    // Workspace skin accent — lets composed views echo the workspace's palette
    // (the injected components already carry it; this covers bespoke bits).
    try {
        const ds = (0, $g7CNh.resolveWorkspaceConfig)(root)?.designSystem;
        // Resolved for the theme on screen: a record may carry `varsLight`/
        // `varsDark`, or a `{ light, dark }` pair per token, and only one half of
        // each is in force (FW-DESIGN-SYSTEM-RECORD-NEEDS-PER-THEME-VARS-1). The
        // raw bag would hand the assistant both halves, or an object where a
        // colour belongs.
        const theme = globalThis.document?.documentElement?.getAttribute?.('data-theme');
        const vars = (0, $g7CNh.resolveDesignSystemVars)(ds, theme);
        if (Object.keys(vars).length) catalog.designSystemVars = Object.fromEntries(Object.entries(vars).slice(0, 10));
    } catch (_) {
    /* skin is optional context — never block a turn on it */ }
    return Object.keys(catalog).length ? catalog : null;
}

});

parcelRegister("cwTCb", function(module, exports) {

$parcel$export(module.exports, "handleBridgePayload", () => $91f39d22927f282f$export$9ebc2e6ddcbb6e97);
$parcel$export(module.exports, "handleAgentEvent", () => $91f39d22927f282f$export$699b146b6b11561b);
$parcel$export(module.exports, "wsTransport", () => $91f39d22927f282f$export$7129550bfe792568);
$parcel$export(module.exports, "createDirectWsPort", () => $91f39d22927f282f$export$6375cba4e4a89b43);
// VENDORED from extensions/packages/simone/symbols/transport/ws.js — keep in
// sync with the source (same reason as ./sendPrompt.js: a bare simone import
// breaks CI smbls build). Used by ../simoneAiTransport.js for Local mode:
// createDirectWsPort + handleBridgePayload/handleAgentEvent give the
// workspace AssistantDrawer a real simone-bridge round-trip.
// WebSocket transport — used by chrome-connect (panel ↔ service worker port)
// and by any host that wants raw WS to a local Claude Code bridge.
//
// Host must provide a `port` with .postMessage and .onMessage.addListener
// (mirrors chrome.runtime.Port API). For non-extension hosts, see
// `createDirectWsPort(url)` at the bottom of this file.
const $91f39d22927f282f$var$pendingTools = new Map();
const $91f39d22927f282f$var$newId = ()=>`m-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
const $91f39d22927f282f$var$upsertMessage = (root, id, patch)=>{
    const list = (root.chatMessages || []).slice();
    const idx = list.findIndex((m)=>m.id === id);
    if (idx === -1) list.push({
        id: id,
        ...patch
    });
    else list[idx] = {
        ...list[idx],
        ...patch
    };
    root.update({
        chatMessages: list
    });
};
const $91f39d22927f282f$var$pushSystem = (root, text)=>{
    const list = (root.chatMessages || []).concat({
        id: $91f39d22927f282f$var$newId(),
        role: 'system',
        text: text,
        ts: Date.now()
    });
    root.update({
        chatMessages: list
    });
};
const $91f39d22927f282f$export$9ebc2e6ddcbb6e97 = (root, payload, sendToPage, sendToBridge)=>{
    if (!payload || !payload.type) return;
    if (payload.type === 'bridge_ready') {
        // Bridge surfaces the resolved default target. The picker is opt-in
        // (chat works against the launch default), so targetSelected is mostly
        // informational here.
        root.update({
            chatTyping: false,
            agent: payload.agent || null,
            target: payload.target || null,
            targetSelected: !!payload.targetSelected,
            targetDraftMode: payload.target && payload.target.mode || null,
            targetDraftCwd: payload.target && payload.target.cwd || null,
            cliAuth: payload.cliAuth || null
        });
        // Eagerly request the target catalog so the picker has data the moment
        // the user opens it. WS handshake just completed; sendToBridge is safe.
        if (typeof sendToBridge === 'function') try {
            sendToBridge({
                type: 'list_targets'
            });
        } catch (_) {}
        // Auto-restore saved target across reconnects: if the current origin
        // has a localStorage pairing AND the bridge hasn't already bound a
        // target this session, replay select_target so the user keeps their
        // chosen cwd through parcel HMR / claude SIGTERM / network blips.
        if (typeof sendToBridge === 'function' && !payload.targetSelected) try {
            const origin = root.currentOrigin && typeof root.currentOrigin === 'string' ? root.currentOrigin : typeof window !== 'undefined' && window.location && window.location.origin || null;
            if (origin && typeof window !== 'undefined' && window.localStorage) {
                const pairings = JSON.parse(window.localStorage.getItem('symbols_recent_pairings') || '{}');
                const saved = pairings && pairings[origin] && pairings[origin].target;
                if (saved && (saved.cwd || saved.mode)) sendToBridge({
                    type: 'select_target',
                    target: saved
                });
            }
        } catch (_) {}
        return;
    }
    if (payload.type === 'session_ready') {
        root.update({
            chatTyping: false
        });
        return;
    }
    if (payload.type === 'target_options') {
        root.update({
            targetOptions: payload
        });
        return;
    }
    if (payload.type === 'target_active') {
        const origin = root.currentOrigin && typeof root.currentOrigin === 'string' ? root.currentOrigin : typeof window !== 'undefined' && window.location && window.location.origin || null;
        const target = payload.target || null;
        const nextMode = target && target.mode === 'cloud' ? 'cloud' : target && target.cwd ? 'local' : 'general';
        const baseUpdate = {
            target: target,
            targetSelected: true,
            targetMode: nextMode,
            targetDraftCustom: '',
            targetPickerOpen: false,
            targetPickerView: 'home'
        };
        if (origin && target) try {
            const prev = JSON.parse(window.localStorage.getItem('symbols_recent_pairings') || '{}');
            const label = target.mode === 'cloud' ? target.owner && target.key ? `${target.owner}/${target.key}` : 'cloud project' : target.cwd ? target.cwd.split('/').filter(Boolean).pop() : '(unnamed)';
            prev[origin] = {
                target: target,
                label: label,
                ts: Date.now()
            };
            window.localStorage.setItem('symbols_recent_pairings', JSON.stringify(prev));
            root.update({
                ...baseUpdate,
                recentPairings: prev
            });
        } catch (_) {
            root.update(baseUpdate);
        }
        else root.update(baseUpdate);
        return;
    }
    if (payload.type === 'workspaces_response') {
        root.update({
            cloudWorkspaces: Array.isArray(payload.workspaces) ? payload.workspaces : [],
            cloudWorkspacesLoading: false,
            cloudWorkspacesError: payload.error || null,
            // If bridge resolved a user email (from /auth/me), record it.
            cliAuth: payload.me ? {
                ...root.cliAuth || {},
                email: payload.me.email || root.cliAuth && root.cliAuth.email,
                userId: payload.me.id || root.cliAuth && root.cliAuth.userId,
                apiBaseUrl: payload.apiBaseUrl || root.cliAuth && root.cliAuth.apiBaseUrl
            } : root.cliAuth || null
        });
        return;
    }
    if (payload.type === 'target_locked') {
        $91f39d22927f282f$var$pushSystem(root, payload.reason || 'Target already locked. /reset to swap.');
        return;
    }
    if (payload.type === 'session_reset') {
        // Bridge cleared the child — user may pick a fresh target.
        root.update({
            chatMessages: [],
            chatTyping: false,
            targetSelected: false,
            target: payload.target || root.target
        });
        return;
    }
    if (payload.type === 'status') {
        root.update({
            chatTyping: payload.status === 'requesting'
        });
        return;
    }
    if (payload.type === 'assistant_start') {
        // Lazy bubble — don't materialize an empty "Claude" row yet. Many turns
        // open with a thinking block (ignored) or a tool_use block (rendered as
        // its own card), then never emit text. Creating the bubble up-front
        // leaves a visually empty header. We defer creation until the first
        // assistant_delta lands.
        const id = payload.messageId || 'assistant-current';
        root.update({
            chatTyping: true,
            currentAssistantId: id
        });
        return;
    }
    if (payload.type === 'assistant_delta') {
        const id = root.currentAssistantId || 'assistant-current';
        const list = root.chatMessages || [];
        const existing = list.find((m)=>m.id === id);
        const blocks = {
            ...existing && existing.blocks || {}
        };
        const k = payload.blockIndex || 0;
        blocks[k] = (blocks[k] || '') + (payload.text || '');
        // Named `bi` (block index), not a single letter: frank's pipeline free-var
        // scanner does not descend into a nested arrow's parameter list, so a
        // one-letter param collides with a MINIFIED top-level name in the esbuild
        // bundle and frank lifts that stranger into globalScope — `j` pulled
        // symbolize-markdown's minified renderer in and blocked the publish gate
        // (WORKSPACE-SHELL-FRANK-GATE-BLOCKS-REPUBLISH-1; frank defect filed).
        const text = Object.keys(blocks).sort((a, b)=>Number(a) - Number(b)).map((bi)=>blocks[bi]).join('');
        // First non-empty delta lazily creates the bubble; later deltas update it.
        $91f39d22927f282f$var$upsertMessage(root, id, {
            role: 'assistant',
            text: text,
            blocks: blocks,
            streaming: true,
            ts: Date.now()
        });
        return;
    }
    if (payload.type === 'thinking_delta') return;
    if (payload.type === 'tool_use_start' || payload.type === 'tool_use') {
        const messageId = `tool-${payload.toolUseId || $91f39d22927f282f$var$newId()}`;
        $91f39d22927f282f$var$upsertMessage(root, messageId, {
            role: 'tool',
            toolName: payload.tool,
            toolUseId: payload.toolUseId,
            argsText: payload.input ? JSON.stringify(payload.input, null, 2) : '',
            status: 'pending',
            ts: Date.now()
        });
        const input = payload.input || {};
        if (sendToPage && payload.tool === 'sdk_execute') {
            $91f39d22927f282f$var$pendingTools.set(payload.toolUseId, {
                messageId: messageId,
                toolUseId: payload.toolUseId
            });
            sendToPage({
                type: 'sdk_execute',
                id: payload.toolUseId,
                ...input
            });
        } else if (sendToPage && payload.tool === 'pick_element') {
            $91f39d22927f282f$var$pendingTools.set(payload.toolUseId, {
                messageId: messageId,
                toolUseId: payload.toolUseId
            });
            sendToPage({
                type: 'start_pick'
            });
        } else if (sendToPage && payload.tool === 'inspect_$0') {
            $91f39d22927f282f$var$pendingTools.set(payload.toolUseId, {
                messageId: messageId,
                toolUseId: payload.toolUseId
            });
            sendToPage({
                type: 'inspect_selected',
                id: payload.toolUseId
            });
        }
        return;
    }
    if (payload.type === 'tool_result') {
        const messageId = `tool-${payload.toolUseId}`;
        $91f39d22927f282f$var$upsertMessage(root, messageId, {
            status: payload.isError ? 'error' : 'done',
            resultText: typeof payload.content === 'string' ? payload.content : JSON.stringify(payload.content, null, 2)
        });
        return;
    }
    if (payload.type === 'assistant_stop' || payload.type === 'turn_complete') {
        const id = root.currentAssistantId;
        if (id) {
            // Mark the existing message done — never create a new bubble here.
            const list = (root.chatMessages || []).map((m)=>m.id === id ? {
                    ...m,
                    streaming: false
                } : m);
            root.update({
                chatMessages: list
            });
        }
        root.update({
            chatTyping: false,
            currentAssistantId: null
        });
        return;
    }
    if (payload.type === 'claude_error') {
        $91f39d22927f282f$var$pushSystem(root, 'Claude bridge error: ' + (payload.error || 'unknown'));
        root.update({
            chatTyping: false
        });
        return;
    }
    if (payload.type === 'claude_exited') {
        $91f39d22927f282f$var$pushSystem(root, `Claude subprocess exited (code=${payload.code}). Send a message to restart.`);
        root.update({
            chatTyping: false
        });
        return;
    }
    if (payload.type === 'agent_stuck') {
        $91f39d22927f282f$var$pushSystem(root, payload.reason || "Agent looks stuck \u2014 no output for a while. Try /reset.");
        root.update({
            chatTyping: false
        });
        return;
    }
};
const $91f39d22927f282f$export$699b146b6b11561b = (root, ev, sendToBridge)=>{
    if (!ev || !ev.type) return;
    if (ev.type === 'picked_element') {
        const list = (root.pickedElements || []).slice();
        const sig = (ev.info && ev.info.tagPath || []).join('>');
        const exists = list.some((p)=>(p.tagPath || []).join('>') === sig);
        if (!exists && ev.info) list.push(ev.info);
        root.update({
            pickedElements: list
        });
        return;
    }
    if (ev.type === 'pick_cancelled') {
        root.update({
            picking: false
        });
        return;
    }
    if (ev.type === 'pick_started') {
        root.update({
            picking: true
        });
        return;
    }
    if (ev.type === 'inspect_selected_result') {
        if (ev.info && !ev.info.error) root.update({
            pickedElements: (root.pickedElements || []).concat(ev.info)
        });
        else $91f39d22927f282f$var$pushSystem(root, ev.info && ev.info.error || 'No $0 selected.');
        return;
    }
    if (ev.type === 'sdk_execute_result') {
        const pending = $91f39d22927f282f$var$pendingTools.get(ev.id);
        if (!pending) return;
        $91f39d22927f282f$var$pendingTools.delete(ev.id);
        $91f39d22927f282f$var$upsertMessage(root, pending.messageId, {
            status: ev.ok ? 'done' : 'error',
            resultText: ev.ok ? JSON.stringify(ev.result, null, 2) : ev.error
        });
        if (sendToBridge) sendToBridge({
            type: 'tool_result',
            toolUseId: pending.toolUseId,
            result: ev.ok ? ev.result : {
                error: ev.error
            },
            isError: !ev.ok
        });
    }
};
const $91f39d22927f282f$export$7129550bfe792568 = ({ getPort: getPort, sendToPage: sendToPage = null, subscribeRuntime: subscribeRuntime = null, surface: surface = null } = {})=>{
    // Closed-over by both initBridge (writes) and sendOverBridge (reads) so the
    // component layer can `el.call('sendOverBridge', payload)` without poking
    // any globals.
    let _send = null;
    return {
        initBridge: function() {
            const root = this.state.root;
            const port = getPort();
            if (!port) return;
            const sendToBridge = (payload)=>{
                try {
                    port.postMessage({
                        type: 'send',
                        payload: payload
                    });
                } catch (_) {}
            };
            _send = sendToBridge;
            // Declare the host surface to the bridge so it can scope MCP servers
            // (e.g. skip the inspected-tab MCP for standalone tabs that don't
            // have an extension behind them to drive the inspected page).
            if (surface) try {
                sendToBridge({
                    type: 'hello',
                    surface: surface
                });
            } catch (_) {}
            const dispatch = (msg)=>{
                if (!msg) return;
                if (msg.type === 'bridge_status') {
                    root.update({
                        bridgeStatus: msg.status,
                        bridgeUrl: msg.url || root.bridgeUrl
                    });
                    return;
                }
                if (msg.type === 'bridge_message') {
                    $91f39d22927f282f$export$9ebc2e6ddcbb6e97(root, msg.payload, sendToPage, sendToBridge);
                    return;
                }
                // Inspected-tab tool calls coming back from claude (via the bundled
                // inspected-mcp server). Route to the panel-side executor.
                if (msg.type === 'inspected_tool_call') {
                    if (typeof window.__simoneHandleInspectedTool === 'function') window.__simoneHandleInspectedTool(msg.payload);
                    return;
                }
                $91f39d22927f282f$export$699b146b6b11561b(root, msg, sendToBridge);
            };
            window.__simoneDispatch = dispatch;
            window.__simoneSendOverBridge = sendToBridge;
            port.onMessage.addListener(dispatch);
            if (subscribeRuntime) try {
                subscribeRuntime(dispatch);
            } catch (_) {}
        },
        // Send an arbitrary payload to the bridge. Components call this via
        // `el.call('sendOverBridge', payload)` for select_target, list_targets,
        // reset, cancel, etc. No-op until initBridge has wired the port.
        sendOverBridge: function(payload) {
            if (typeof _send === 'function') _send(payload);
        },
        configureBridge: function(url) {
            const root = this.state.root;
            const next = (url || '').trim() || 'ws://localhost:8765';
            const perTab = root.perTabSessions !== false;
            root.update({
                bridgeUrl: next,
                showSettings: false
            });
            const port = getPort();
            if (port) try {
                port.postMessage({
                    type: 'configure',
                    url: next,
                    perTab: perTab
                });
            } catch (_) {}
        }
    };
};
// Stable per-origin bridge session id. Persisted so reconnects (HMR reload,
// claude SIGTERM, network blip) rebind to the SAME bridge session instead of
// minting a fresh one each time — the bridge keeps the agent child alive
// through a short grace window keyed on this id. Without it every reconnect
// spawned a new session + staged a new MCP config (the connection-log storm).
// sessionStorage (NOT localStorage) is deliberate: it's scoped per browsing
// context, so the id is stable across reloads/HMR within a tab but unique
// between tabs — two same-origin tabs never collide onto one bridge session
// (which would have them fight over a single agent child).
const $91f39d22927f282f$var$SHELL_STORAGE_KEY = 'symbols_bridge_session';
const $91f39d22927f282f$var$bridgeSessionId = ()=>{
    const mint = ()=>typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    try {
        if (typeof window === 'undefined' || !window.sessionStorage) return mint();
        let id = window.sessionStorage.getItem($91f39d22927f282f$var$SHELL_STORAGE_KEY);
        if (!id) {
            id = mint();
            window.sessionStorage.setItem($91f39d22927f282f$var$SHELL_STORAGE_KEY, id);
        }
        return id;
    } catch (_) {
        return mint();
    }
};
// Append ?sid=<id> to the bridge URL so the server (which can't read custom
// headers off a browser WebSocket) can key the session off the query string.
const $91f39d22927f282f$var$withSession = (url, sid)=>{
    try {
        const u = new URL(url, typeof window !== 'undefined' && window.location && window.location.href || undefined);
        u.searchParams.set('sid', sid);
        return u.toString();
    } catch (_) {
        return url + (url.includes('?') ? '&' : '?') + 'sid=' + encodeURIComponent(sid);
    }
};
const $91f39d22927f282f$export$6375cba4e4a89b43 = (url)=>{
    const listeners = new Set();
    const sid = $91f39d22927f282f$var$bridgeSessionId();
    const target = $91f39d22927f282f$var$withSession(url, sid);
    const BASE_DELAY = 1000;
    const MAX_DELAY = 30000;
    let ws = null;
    let reconnectTimer = null;
    let attempt = 0;
    let stopped = false;
    const emit = (msg)=>listeners.forEach((l)=>l(msg));
    const clearTimer = ()=>{
        if (reconnectTimer) {
            clearTimeout(reconnectTimer);
            reconnectTimer = null;
        }
    };
    const scheduleReconnect = ()=>{
        if (stopped || reconnectTimer) return;
        // Don't burn connections against a hidden tab — wait for visibility.
        if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
        const backoff = Math.min(MAX_DELAY, BASE_DELAY * 2 ** attempt);
        const delay = backoff / 2 + Math.random() * (backoff / 2 // 50–100% jitter
        );
        attempt += 1;
        reconnectTimer = setTimeout(()=>{
            reconnectTimer = null;
            connect();
        }, delay);
    };
    const connect = ()=>{
        if (stopped) return;
        clearTimer();
        if (ws && (ws.readyState === 0 || ws.readyState === 1)) return; // already (re)connecting
        ws = new WebSocket(target);
        ws.onopen = ()=>{
            attempt = 0 // reset backoff on a clean open
            ;
            emit({
                type: 'bridge_status',
                status: 'open',
                url: url
            });
        };
        ws.onclose = ()=>{
            emit({
                type: 'bridge_status',
                status: 'closed',
                url: url
            });
            scheduleReconnect();
        };
        ws.onerror = ()=>emit({
                type: 'bridge_status',
                status: 'error',
                url: url
            });
        ws.onmessage = (ev)=>{
            let parsed;
            try {
                parsed = JSON.parse(ev.data);
            } catch (_) {
                parsed = {
                    type: 'raw',
                    text: String(ev.data)
                };
            }
            emit({
                type: 'bridge_message',
                payload: parsed
            });
        };
    };
    // Reconnect the moment the tab is foregrounded again (with a fresh backoff
    // budget), instead of waiting out a timer scheduled before it was hidden.
    if (typeof document !== 'undefined' && document.addEventListener) document.addEventListener('visibilitychange', ()=>{
        if (stopped || document.visibilityState !== 'visible') return;
        if (ws && ws.readyState === 1) return; // still connected, nothing to do
        attempt = 0;
        clearTimer();
        connect();
    });
    connect();
    return {
        postMessage: (msg)=>{
            if (!ws || ws.readyState !== 1) return;
            if (msg.type === 'send' && msg.payload) ws.send(JSON.stringify(msg.payload));
            else msg.type;
        },
        onMessage: {
            addListener: (fn)=>listeners.add(fn)
        },
        // Intentional teardown — stops the reconnect loop so a recreated port
        // doesn't leave an orphan socket retrying in the background.
        close: ()=>{
            stopped = true;
            clearTimer();
            if (ws) try {
                ws.close();
            } catch (_) {}
        }
    };
};

});

parcelRegister("8WAnX", function(module, exports) {

$parcel$export(module.exports, "toolOutcome", () => $682ff6e67e150f17$export$bdb088e5d853d8e2);
$parcel$export(module.exports, "toolFailure", () => $682ff6e67e150f17$export$e404246606e9d82c);
// The ONE definition of "this tool call produced a linkable item" — used by
// BOTH halves of the timeline (AI-301, tickets/ai.md):
//   live turn    — simoneAiTransport.onToolCall stamps the client tool's own
//                  return value onto its timeline row (the server's later
//                  `completed` frame carries only a summary string)
//   history load — sessions._toChatMessages restores it from the persisted
//                  tool_result payload, so links survive a reload
// aiWorkspaceOps write tools return ok({ created: { kind, id, title|name } });
// anything else (reads, updates, failures, denials) normalizes to null.
const $682ff6e67e150f17$export$bdb088e5d853d8e2 = (res)=>{
    if (!res || typeof res !== 'object' || res.ok === false) return null;
    const c = res.created;
    if (!c || typeof c !== 'object' || c.id == null || c.id === '') return null;
    return {
        kind: String(c.kind || 'item'),
        id: String(c.id),
        title: String(c.title || c.name || '')
    };
};
// The ONE definition of "why this tool call failed", in words a person (and
// the keepz lane reading a screenshot) can act on — used by the same two
// halves as toolOutcome: the live stamp (simoneAiTransport.onToolCall) and the
// history fold (sessions._toChatMessages). Measured on dev 2026-10-15 (Keepz
// DEV, "Show me payment pay_09lUkppFn"): two render_answer_ui draws were
// refused before the third drew — a parse error, then `generated_app_blocked`
// for `Badge` + a markup key — and the timeline showed a bare ✗ with no
// reason; the server summary carried only the code. The reason is the
// result's own error (a string or `{ message }`) followed by each violation
// (`rule: detail`), capped. Success, or a failure with nothing to say → null.
const $682ff6e67e150f17$var$FAILURE_MAX = 240;
const $682ff6e67e150f17$export$e404246606e9d82c = (res)=>{
    if (!res || typeof res !== 'object' || res.ok !== false) return null;
    const err = res.error;
    const head = typeof err === 'string' ? err.trim() : err && typeof err === 'object' && typeof err.message === 'string' ? err.message.trim() : '';
    const list = Array.isArray(res.violations) ? res.violations : [];
    const parts = [];
    for (const v of list){
        let s = '';
        if (typeof v === 'string') s = v.trim();
        else if (v && typeof v === 'object' && v.rule) {
            const d = v.detail == null ? '' : String(v.detail).trim();
            s = d ? `${v.rule}: ${d}` : String(v.rule);
        }
        if (s && !parts.includes(s)) parts.push(s);
    }
    const tail = parts.slice(0, 4).join(" \xb7 ");
    const out = head && tail ? `${head} \u{2014} ${tail}` : head || tail;
    if (!out) return null;
    return out.length > $682ff6e67e150f17$var$FAILURE_MAX ? out.slice(0, $682ff6e67e150f17$var$FAILURE_MAX - 1) + "\u2026" : out;
};

});

parcelRegister("eujtO", function(module, exports) {

$parcel$export(module.exports, "toolEmbedCard", () => $a8c2fa58ade1f7fe$export$bc57125572cfd8b2);
$parcel$export(module.exports, "flyPageEmbeds", () => $a8c2fa58ade1f7fe$export$46d884c73e3d6220);
// The ONE definition of "this tool call embedded a live block in the thread"
// (DESIGN-WL-ASSISTANT-MAIN-VIEW-1) — used by BOTH halves of the thread, like
// toolOutcome.js:
//   live turn    — the `tool.activity` completed frame of embed_records /
//                  embed_widget carries `embed` (simoneAiTransport
//                  _patchToolActivity attaches the card)
//   history load — the persisted tool_result payload carries `output.embed`
//                  (sessions._toChatMessages restores the same card)
// The server shapes (ai-boards assistantTools.js):
//   { kind: 'records', block, size? }  a RECORDS BLOCK v1, resolved per viewer
//   { kind: 'widget', widget, params?, size?, title?, pinKey? }  an installed
//                                      app's widget with its params
//   { kind: 'view', view, params?, size?, title? }  an app's read-only VIEW
//                                      (manifest views[] / a built-in package's
//                                      provider) — drawn as a widget card
//   { kind: 'sources', sources: [{ title, url, snippet }], text?, query? }
//                                      web results / a fetched page (U4) —
//                                      source cards or a quote with its source
//   { kind: 'form', form, values, recordId?, title? }  an app's own FORM,
//                                      prefilled from the proposal — a form
//                                      card (functions/assistantAppForms.js)
// → the thread card: { type: 'records', block, size? } (the records path the
// thread already draws: ChatCard → AssistantThreadBlock → AssistantRecordsBlock)
// or { type: 'widget', widget, params, size?, title?, pinKey? }
// (AssistantThreadBlock's widget body). No embed, a refused call, an unknown
// kind or a malformed payload → null: the thread adds nothing.
// Every card carries a TITLE, so every host shows one (a host without the
// shell's block component reads the card through ChatCard's PvCardFallback,
// which shows `title` — without one it was an empty card, design-d2
// 2026-09-29): the model's own, else a readable default — the widget id's last
// part ("crm.crm-pipeline" → "Crm pipeline"), the block's title text, or its
// collection — marked `titleDefault`, so the shell still prefers the
// installed widget's own title / the records block's own (bundle-keyed) title.
const $a8c2fa58ade1f7fe$export$bc57125572cfd8b2 = (x)=>{
    const plain = (v)=>v && typeof v === 'object' && !Array.isArray(v) ? v : null;
    const readable = (ref)=>{
        const tail = String(ref || '').split('.').pop().replace(/[-_]+/g, ' ').trim();
        return tail ? tail.charAt(0).toUpperCase() + tail.slice(1) : '';
    };
    const src = plain(x);
    if (!src || src.ok === false) return null;
    const out = plain(src.output);
    if (out && out.ok === false) return null;
    const e = plain(src.embed) || out && plain(out.embed);
    if (!e) return null;
    const size = [
        's',
        'm',
        'l',
        'xl'
    ].includes(e.size) ? e.size : null;
    if (e.kind === 'records') {
        const block = plain(e.block);
        if (!block) return null;
        const own = plain(block.title);
        const title = own && typeof own.text === 'string' && own.text.trim() || readable(block.collection);
        return {
            type: 'records',
            block: block,
            ...size ? {
                size: size
            } : {},
            ...title ? {
                title: title,
                titleDefault: true
            } : {}
        };
    }
    // A VIEW (an app's read-only view, functions/assistantAppViews.js) is drawn
    // by the widget card: the same row, mount and Open in split.
    if (e.kind === 'widget' || e.kind === 'view') {
        const ref = e.kind === 'view' ? e.view : e.widget;
        if (typeof ref !== 'string' || !ref) return null;
        const own = typeof e.title === 'string' && e.title.trim() ? e.title.trim() : '';
        const title = own || readable(ref);
        return {
            type: 'widget',
            widget: ref,
            params: plain(e.params) || {},
            ...size ? {
                size: size
            } : {},
            ...title ? {
                title: title
            } : {},
            ...!own && title ? {
                titleDefault: true
            } : {},
            ...typeof e.pinKey === 'string' && e.pinKey ? {
                pinKey: e.pinKey
            } : {}
        };
    }
    // WEB SOURCES (web_search / fetch_url, U4): search results become source
    // cards; a fetched page's `text` a quote with its source. Only http(s)
    // links survive (never a javascript: or data: URL); at most 8 sources;
    // title 200, snippet 400, text 1200 characters. No usable source, no card.
    if (e.kind === 'sources') {
        const list = Array.isArray(e.sources) ? e.sources : [];
        const sources = [];
        for (const it of list){
            const item = plain(it);
            if (!item || typeof item.url !== 'string' || !/^https?:\/\/[^\s]+$/i.test(item.url)) continue;
            sources.push({
                title: typeof item.title === 'string' ? item.title.trim().slice(0, 200) : '',
                url: item.url,
                snippet: typeof item.snippet === 'string' ? item.snippet.trim().slice(0, 400) : ''
            });
            if (sources.length === 8) break;
        }
        if (!sources.length) return null;
        const text = typeof e.text === 'string' ? e.text.trim().slice(0, 1200) : '';
        const query = typeof e.query === 'string' ? e.query.trim().slice(0, 200) : '';
        return {
            type: 'sources',
            sources: sources,
            ...text ? {
                text: text
            } : {},
            ...query ? {
                query: query
            } : {}
        };
    }
    // A FORM (an app's own form, prefilled from the assistant's proposal —
    // functions/assistantAppForms.js): nothing is written until the member saves
    // in the app's form.
    if (e.kind === 'form') {
        if (typeof e.form !== 'string' || !e.form) return null;
        const own = typeof e.title === 'string' && e.title.trim() ? e.title.trim() : '';
        const title = own || readable(e.form);
        return {
            type: 'form',
            form: e.form,
            values: plain(e.values) || {},
            ...typeof e.recordId === 'string' && e.recordId ? {
                recordId: e.recordId
            } : {},
            ...title ? {
                title: title
            } : {},
            ...!own && title ? {
                titleDefault: true
            } : {}
        };
    }
    return null;
};
const $a8c2fa58ade1f7fe$export$46d884c73e3d6220 = (page)=>{
    const plain = (v)=>v && typeof v === 'object' && !Array.isArray(v) ? v : null;
    const p = plain(page);
    const items = p && Array.isArray(p.items) ? p.items : [];
    const cards = [];
    const words = [];
    for (const raw of items){
        const it = plain(raw);
        if (!it) continue;
        const head = plain(it.title) ? it.title.text : it.title;
        const title = typeof head === 'string' && head.trim() ? head.trim() : '';
        let card = null;
        if (it.kind === 'records') card = $a8c2fa58ade1f7fe$export$bc57125572cfd8b2({
            embed: {
                kind: 'records',
                block: it,
                size: it.size
            }
        });
        else if (it.kind === 'widget' && typeof it.widget === 'string') card = $a8c2fa58ade1f7fe$export$bc57125572cfd8b2({
            embed: {
                kind: 'widget',
                widget: it.widget,
                params: it.params,
                size: it.size,
                ...title ? {
                    title: title
                } : {}
            }
        });
        else if (it.kind === 'ui') {
            const ui = plain(it.ui);
            const args = ui && plain(ui.args);
            if (ui && args && ui.tool === 'render_cards' && Array.isArray(args.cards)) for (const c of args.cards){
                const one = plain(c);
                if (one && typeof one.type === 'string' && Array.isArray(one.items) && one.items.length) cards.push({
                    type: one.type,
                    items: one.items
                });
            }
            else if (ui && args && ui.tool === 'render_answer_ui' && typeof args.source === 'string' && args.source.trim()) {
                const own = typeof args.title === 'string' ? args.title.trim() : '';
                card = {
                    type: 'view',
                    title: title || own,
                    source: args.source,
                    ...args.placement === 'split' ? {
                        placement: 'split'
                    } : {}
                };
            }
        } else if (it.kind === 'block') {
            const d = plain(it.data) || {};
            const lines = title ? [
                title
            ] : [];
            if (typeof d.text === 'string' && d.text.trim()) lines.push(d.text.trim());
            for (const r of Array.isArray(d.rows) ? d.rows : []){
                const row = plain(r);
                const t = row && (row.title || row.text);
                if (typeof t === 'string' && t.trim()) lines.push('- ' + t.trim() + (typeof row.meta === 'string' && row.meta ? " \xb7 " + row.meta : ''));
            }
            const chips = (Array.isArray(d.chips) ? d.chips : []).filter((c)=>typeof c === 'string' && c.trim());
            if (chips.length) lines.push(chips.join(" \xb7 "));
            if (lines.length > (title ? 1 : 0)) words.push(lines.join('\n'));
        }
        if (card) cards.push(card);
    }
    return {
        cards: cards,
        words: words.join('\n\n')
    };
};

});

parcelRegister("9C8Ov", function(module, exports) {

$parcel$export(module.exports, "repeatsNote", () => $6ffe7fe3728039ba$export$a7bc7b05f8f01b9f);
// The ONE definition of "the answer REPEATS the last call's note"
// (DESIGN-WL-ASSISTANT-MAIN-VIEW-1, approved (A) 2026-09-29) — used by BOTH
// halves of the thread, like toolEmbed.js / toolOutcome.js:
//   live turn    — simoneAiTransport onDone: the server's final text vs the
//                  note the last call took at its `started` frame
//   history load — sessions._toChatMessages: an answer row's text vs the note
//                  its last call restored from the saved callText (core-wl
//                  part 3: [text before] + tool_call + [text after])
// A model can say a sentence beside its call and then say it AGAIN as its
// final answer (dev, Unreal twin, 2026-09-29: "Here are the 5 biggest open
// deals by value." showed as the call's note AND as the answer). Equal after
// whitespace normalization → the thread shows it ONCE, as the answer, and the
// call's note clears. Any other difference keeps both: only an exact repeat
// folds, so a note that says something the answer does not is never lost.
const $6ffe7fe3728039ba$var$words = (s)=>typeof s === 'string' ? s.replace(/\s+/g, ' ').trim() : '';
const $6ffe7fe3728039ba$export$a7bc7b05f8f01b9f = (answer, note)=>{
    const said = $6ffe7fe3728039ba$var$words(answer);
    return !!said && said === $6ffe7fe3728039ba$var$words(note);
};

});

parcelRegister("1vH8H", function(module, exports) {

$parcel$export(module.exports, "stripAnswerTrailers", () => $119a263fed054c5c$export$5b975881d59e0c52);
// Machine trailers are not member-facing text, including when a tool's
// narration follows them. Keep literal protocol examples inside Markdown
// code spans/fences. Streaming may stop halfway through a marker or fence.
const $119a263fed054c5c$export$5b975881d59e0c52 = (text, opts)=>{
    const input = text == null ? '' : String(text);
    const names = [
        'SUGGEST:',
        'SOURCES:',
        'CONFIDENCE:',
        'LEVEL:'
    ];
    let out = '';
    let i = 0;
    while(i < input.length){
        if (i === 0 || input[i - 1] === '\n') {
            const fence = /^ {0,3}(`{3,}|~{3,})[^\n]*(?:\n|$)/.exec(input.slice(i));
            if (fence) {
                const mark = fence[1];
                const close = new RegExp('^ {0,3}' + mark[0] + '{' + mark.length + ',}[ \\t]*\\r?$', 'gm');
                close.lastIndex = i + fence[0].length;
                const end = close.exec(input);
                const next = end ? end.index + end[0].length : input.length;
                out += input.slice(i, next);
                i = next;
                continue;
            }
        }
        if (input[i] === '`') {
            const mark = /^`+/.exec(input.slice(i))[0];
            const close = /`+/g;
            close.lastIndex = i + mark.length;
            let end;
            for(let match = close.exec(input); match; match = close.exec(input))if (match[0].length === mark.length) {
                end = match.index + mark.length;
                break;
            }
            const next = end || i + mark.length;
            out += input.slice(i, next);
            i = next;
            continue;
        }
        if (input[i] === '<') {
            const tail = input.slice(i);
            if (/^<!--[ ]{0,3}(?:SUGGEST|SOURCES|CONFIDENCE|LEVEL):/.test(tail)) {
                const close = input.indexOf('-->', i + 4);
                i = close < 0 ? input.length : close + 3;
                continue;
            }
            if (opts && opts.partial) {
                const cut = /^<(?:!(?:-(?:-([ ]{0,3})([A-Z]*))?)?)?$/.exec(tail);
                if (cut && (!cut[2] || names.some((name)=>name.startsWith(cut[2])))) break;
            }
        }
        out += input[i++];
    }
    return out === input ? out : out.replace(/\s+$/, '');
};

});

parcelRegister("472jS", function(module, exports) {

$parcel$export(module.exports, "sanitizeAssistantProtocolText", () => $2fe99d80ec3f210f$export$f423d0045a23963d);
// tickets/ai.md AI-302 — block tool-call protocol text from the bubble, at
// the workspace STATE layer: the transport's final-text patch (live turns)
// and sessions._toChatMessages (every history reload) both pass assistant
// text through this ONE gate. Since server b8fa8af1 (AI-203) recovers
// whole-text leaks against the task catalog server-side, the primary case
// left here is reload-from-history of PRE-fix conversations (persisted
// leaked answers), plus defense in depth for provider paths that bypass the
// fixed loop.
//
// Deliberately conservative — an assistant legitimately answers with JSON
// and code all day:
//   - fenced code blocks are NEVER flagged (a fence is a formatted answer)
//   - ordinary prose that merely CONTAINS JSON is never flagged (whole-text
//     shapes only)
//   - the measured artifact is a TRUNCATED fragment ('"content": "hello C"
//     } }'), which no JSON.parse catches — the fragment rule requires a
//     leading quoted JSON key, trailing brace residue, no sentence
//     structure, and a short length, so a real answer never matches.
const $2fe99d80ec3f210f$export$ee65abbc880e6380 = "This reply contained internal tool instructions instead of an answer \u2014 the raw output was kept for diagnosis. Ask again if anything is missing.";
const $2fe99d80ec3f210f$export$f423d0045a23963d = (text)=>{
    const t = String(text || '').trim();
    if (!t) return {
        leaked: false
    };
    if (t.startsWith('```')) return {
        leaked: false
    };
    // Whole-text JSON that parses to a call shape: {tool_call:{name,…}} or
    // a bare {name, arguments|args}.
    if (t.startsWith('{') && t.endsWith('}')) {
        try {
            const p = JSON.parse(t);
            if (p && typeof p === 'object' && !Array.isArray(p)) {
                const bag = p.tool_call && typeof p.tool_call === 'object' ? p.tool_call : p;
                const isCall = typeof bag.name === 'string' && bag.name.trim() && (p.tool_call !== undefined || Object.prototype.hasOwnProperty.call(bag, 'arguments') || Object.prototype.hasOwnProperty.call(bag, 'args'));
                if (isCall) return {
                    leaked: true,
                    text: $2fe99d80ec3f210f$export$ee65abbc880e6380,
                    raw: t
                };
            }
        } catch (_) {
        /* unparseable — fall through to the fragment rules */ }
        // A truncated {"tool_call": … prefix that no longer parses.
        if (/^\{\s*"tool_call"\s*:/.test(t)) return {
            leaked: true,
            text: $2fe99d80ec3f210f$export$ee65abbc880e6380,
            raw: t
        };
    }
    // The wire protocol markers as the message body.
    if (/^\[Tool call\]/.test(t) || /^RTLU to=functions\./.test(t)) return {
        leaked: true,
        text: $2fe99d80ec3f210f$export$ee65abbc880e6380,
        raw: t
    };
    // The measured artifact: a mid-JSON fragment — leading quoted key, trailing
    // brace residue, short, and no prose sentence anywhere in it.
    const fragment = /^"[A-Za-z_][\w-]*"\s*:/.test(t) && /[}\]]\s*$/.test(t) && t.length <= 400 && !/[.!?]\s+[A-Z]/.test(t);
    if (fragment) return {
        leaked: true,
        text: $2fe99d80ec3f210f$export$ee65abbc880e6380,
        raw: t
    };
    return {
        leaked: false
    };
};

});

parcelRegister("czZQn", function(module, exports) {

$parcel$export(module.exports, "normalizePendingClientCall", () => $9288b9cde65587ab$export$9ca5375c58692802);
$parcel$export(module.exports, "pendingClientCallOffer", () => $9288b9cde65587ab$export$37c463b28680d62d);
$parcel$export(module.exports, "turnSettledAfter", () => $9288b9cde65587ab$export$9bbdc532b3462a95);
$parcel$export(module.exports, "resumeFromPendingClientCall", () => $9288b9cde65587ab$export$795c96131cead073);
// SIMONE-APPROVAL-REOFFER-PENDING-CLIENT-CALL-UI-1 — the browser half of the
// durable client-tool suspension.
//
// When the cloud loop needs a platform action run in the user's own UI it
// SUSPENDS and waits for a tool-result POST. The live copies of that pending
// call — the approval promise in `simoneAiTransport._pendingToolApprovals` and
// the `tool.call_required` SSE frame — both die with the page, so a reload used
// to strand the turn forever. The server side
// (SIMONE-APPROVAL-STRANDS-SERVER-LOOP-ON-RELOAD-1) now persists the whole call
// on the conversation as `metadata.pendingClientCall`
// ({ callId, tool, fn, args, confirm, suspendedAt }) and serves it on the
// ordinary conversation read; `.../tool-result` already accepts that callId
// from a brand-new connection.
//
// This module is the policy that turns that served record back into an offer,
// and drives the run/POST/resume round-trip. Pure + injected on purpose: the
// approval gate, the platform runner, the POST and the answer sink all arrive
// as functions, so the whole decision is unit-testable with no browser, no SDK
// and no DOM — the same shape `threadPointer.js` uses.
// A resumed turn can suspend again on the NEXT client tool (ask_user →
// follow-on write is the measured chain). Bounded so a server that keeps
// re-suspending can never spin the page.
const $9288b9cde65587ab$export$7a358dfdf3a08fe9 = 8;
const $9288b9cde65587ab$export$1bd8c01951291aba = (messages, callId)=>{
    const id = String(callId || '');
    if (!id) return true;
    const list = Array.isArray(messages) ? messages : [];
    return list.some((m)=>m && m.metadata && m.metadata.kind === 'workspace_client_action' && String(m.metadata.callId || '') === id);
};
const $9288b9cde65587ab$export$9ca5375c58692802 = (pending)=>{
    if (!pending || typeof pending !== 'object') return null;
    const callId = String(pending.callId || '');
    const fn = String(pending.fn || '');
    if (!callId || !fn) return null;
    return {
        callId: callId,
        tool: String(pending.tool || fn),
        fn: fn,
        // The server resolved the positional args at suspend time (`tool.toArgs`).
        // A non-array is a malformed record, not an empty call — pass [] rather
        // than spreading a string into character arguments.
        args: Array.isArray(pending.args) ? pending.args : [],
        confirm: !!pending.confirm,
        // MODULE-FN-READONLY-ENFORCED-1 — the server marks an app verb read-only;
        // the gate still checks the live stash before skipping the ask.
        readOnly: !!pending.readOnly,
        suspendedAt: pending.suspendedAt || null
    };
};
const $9288b9cde65587ab$export$37c463b28680d62d = (conversation, messages)=>{
    const offer = $9288b9cde65587ab$export$9ca5375c58692802(conversation && conversation.metadata && conversation.metadata.pendingClientCall);
    if (!offer) return null;
    if ($9288b9cde65587ab$export$1bd8c01951291aba(messages, offer.callId)) return null;
    return offer;
};
// THE ACCEPTED RESUME (REOFFER-RESUMED-ANSWER-NEVER-PAINTED-1). A resume the
// server cannot finish inside its ack window (TURN_ACK_TIMEOUT_MS, 8 s) answers
// 202 `{ accepted: true }` and keeps the loop running; the answer then rides
// the conversation's SSE stream, which a restored or re-opened thread does not
// follow. Measured on dev 2026-10-05 (conversation 6ac35133…65db): the
// re-offered finRunway ran at 12:49:03, the model answered at 12:49:12, and the
// thread never showed the answer until a reload. `turnSettledAfter` reads ONE
// ordinary conversation read ({ conversation, messages }) for the end of the
// turn the call resumed:
//   { suspended: offer } — the loop paused again on a NEW client call;
//   { done: true }       — after the call's recorded result, an assistant
//                          message with no tool call: the answer;
//   null                 — still running.
const $9288b9cde65587ab$var$_hasToolCall = (m)=>Array.isArray(m && m.content) && m.content.some((p)=>p && p.type === 'tool_call');
const $9288b9cde65587ab$export$9bbdc532b3462a95 = (data, callId)=>{
    const id = String(callId || '');
    const next = $9288b9cde65587ab$export$37c463b28680d62d(data && data.conversation, data && data.messages);
    if (next && next.callId !== id) return {
        suspended: next
    };
    const list = Array.isArray(data && data.messages) ? data.messages : [];
    const at = list.findIndex((m)=>m && m.metadata && m.metadata.kind === 'workspace_client_action' && String(m.metadata.callId || '') === id);
    if (at < 0) return null;
    const answered = list.slice(at + 1).some((m)=>m && m.role === 'assistant' && !$9288b9cde65587ab$var$_hasToolCall(m));
    return answered ? {
        done: true
    } : null;
};
const $9288b9cde65587ab$export$795c96131cead073 = async ({ offer: offer, runWithAuth: runWithAuth, submitToolResult: submitToolResult, onAnswer: onAnswer, awaitTurn: awaitTurn, maxChain: maxChain = $9288b9cde65587ab$export$7a358dfdf3a08fe9 } = {})=>{
    let call = $9288b9cde65587ab$export$9ca5375c58692802(offer);
    if (!call) return {
        ok: false,
        ran: 0,
        error: 'No completable pending call.'
    };
    if (typeof runWithAuth !== 'function' || typeof submitToolResult !== 'function') return {
        ok: false,
        ran: 0,
        error: 'No runner or submitter for the pending call.'
    };
    let ran = 0;
    for(let step = 0; step < Math.max(1, maxChain); step++){
        let result;
        try {
            result = await runWithAuth(call);
        } catch (err) {
            // The tool itself threw. The loop still needs an outcome — reporting the
            // failure resumes it honestly; saying nothing strands it exactly as the
            // reload did.
            result = {
                ok: false,
                error: err && err.message || String(err)
            };
        }
        // A new message superseded the step while it waited on Run / Skip: the
        // server closes the call under that message (closeDanglingClientCall,
        // reason `new_message`), so nothing is posted — a POST here would race the
        // new message for the conversation's turn lock.
        if (result && result.superseded) return {
            ok: true,
            ran: ran,
            superseded: true
        };
        ran += 1;
        let resume;
        try {
            resume = await submitToolResult(call.callId, result === undefined ? {
                ok: true
            } : result);
        } catch (err) {
            return {
                ok: false,
                ran: ran,
                error: err && err.message || String(err)
            };
        }
        if (!resume) return {
            ok: true,
            ran: ran
        };
        if (resume.duplicate) return {
            ok: true,
            ran: ran,
            duplicate: true
        };
        if (resume.suspended) {
            const next = $9288b9cde65587ab$export$9ca5375c58692802(resume);
            if (!next) return {
                ok: true,
                ran: ran,
                suspended: true
            };
            call = next;
            continue;
        }
        if (resume.accepted) {
            if (typeof awaitTurn !== 'function') return {
                ok: true,
                ran: ran,
                accepted: true
            };
            let settled = null;
            try {
                settled = await awaitTurn(call.callId);
            } catch (_) {
                settled = null;
            }
            if (settled && settled.suspended) {
                const next = $9288b9cde65587ab$export$9ca5375c58692802(settled.suspended);
                if (!next) return {
                    ok: true,
                    ran: ran,
                    suspended: true
                };
                call = next;
                continue;
            }
            return {
                ok: true,
                ran: ran,
                accepted: true,
                settled: !!(settled && settled.done)
            };
        }
        if (resume.assistantMessage && typeof onAnswer === 'function') {
            try {
                onAnswer(resume.assistantMessage);
            } catch (_) {
            /* painting the answer is best-effort — the turn already resumed */ }
            return {
                ok: true,
                ran: ran,
                answered: true
            };
        }
        return {
            ok: true,
            ran: ran
        };
    }
    return {
        ok: true,
        ran: ran,
        chainCapped: true
    };
};

});

parcelRegister("3YHy5", function(module, exports) {

$parcel$export(module.exports, "_continueWord", () => $2e58c18f079243cd$export$2f445cb00ad506c3);
$parcel$export(module.exports, "_toChatMessages", () => $2e58c18f079243cd$export$a20e18202e5cd9ba);
$parcel$export(module.exports, "ensureActiveSession", () => $2e58c18f079243cd$export$7b962f1e4c5494f);
$parcel$export(module.exports, "hydrateServerSessions", () => $2e58c18f079243cd$export$c3fece5592184181);
$parcel$export(module.exports, "newSession", () => $2e58c18f079243cd$export$43c80672febddad8);
$parcel$export(module.exports, "openAgentThread", () => $2e58c18f079243cd$export$e1466eb4116c9858);
$parcel$export(module.exports, "restoreActiveThread", () => $2e58c18f079243cd$export$d728b55666a2b84e);
$parcel$export(module.exports, "markThreadTurn", () => $2e58c18f079243cd$export$b4078800b0db6949);
$parcel$export(module.exports, "switchSession", () => $2e58c18f079243cd$export$e3a071b49e0dcae8);
$parcel$export(module.exports, "deleteSession", () => $2e58c18f079243cd$export$f3b72123251cadf);
$parcel$export(module.exports, "toggleSessionMenu", () => $2e58c18f079243cd$export$850ffc4c3585df32);
$parcel$export(module.exports, "persistActiveSession", () => $2e58c18f079243cd$export$192b78dcd8b2a81d);
$parcel$export(module.exports, "refreshSessionsAfterTurn", () => $2e58c18f079243cd$export$a03f1a7de50e42d8);
$parcel$export(module.exports, "toggleStarSession", () => $2e58c18f079243cd$export$4e580161cbdb5141);
$parcel$export(module.exports, "shareSession", () => $2e58c18f079243cd$export$e3211e2ff65bd0c2);
$parcel$export(module.exports, "sessionContextItems", () => $2e58c18f079243cd$export$ba9a6bc9c8e868c4);
$parcel$export(module.exports, "sessionContextAction", () => $2e58c18f079243cd$export$882a14a83f6d4abe);
// Hybrid session manager. When an SDK + active workspace is reachable
// (`el.sdk.ai`), sessions are SERVER-BACKED — per-member workspace conversation
// history surfaced via sdk.ai.{list,get,create,delete}Conversation. When no SDK
// is present (standalone simone, which talks to a local ws bridge), every
// server path no-ops/throws and we fall through to the local in-memory behavior
// below: sessions live in root state and give the user "New chat" + history
// switch within a panel lifetime.

var $9ZTVI = parcelRequire("9ZTVI");

var $8WAnX = parcelRequire("8WAnX");

var $eujtO = parcelRequire("eujtO");

var $9C8Ov = parcelRequire("9C8Ov");

var $1vH8H = parcelRequire("1vH8H");

var $472jS = parcelRequire("472jS");

var $50L4n = parcelRequire("50L4n");

var $czZQn = parcelRequire("czZQn");

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");
const $2e58c18f079243cd$var$resolveAiService = (...args)=>(0, $1X0Je.default).functions.resolveAiService(...args);
// Resolve the AI service that actually owns the conversation API (list / get /
// create / delete / patchConversation). In the WORKSPACE that's the shared
// singleton getAiService() — the same instance the send path uses; `el.sdk.ai`
// is a DIFFERENT stub WITHOUT those methods, so every server-backed session path
// (list, create, switch, delete, star) silently fell through to local. That's
// the real reason previous conversations never loaded and stars never persisted.
// Prefer the shared service, validate it exposes the API, and fall back to
// el.sdk.ai for the standalone-vendored case.
const $2e58c18f079243cd$var$_ai = (el)=>{
    try {
        const shared = typeof (0, $7iFOV.shellGetAiService) === 'function' ? (0, $7iFOV.shellGetAiService)() : null;
        if (shared && typeof shared.listConversations === 'function') return shared;
    } catch (_) {
    /* fall through */ }
    try {
        const sdk = el && el.sdk;
        const ai = sdk && (sdk.ai || sdk.getService && sdk.getService('ai'));
        if (ai && typeof ai.listConversations === 'function') return ai;
    } catch (_) {
    /* fall through */ }
    return null;
};
// Map server conversation messages → simone's flat chatMessages shape.
// Server content is an array of typed parts ([{type:'text',text}, …]). Text
// parts join into the `text` field simone renders. tool_call / tool_result
// parts (the agentic loop persists one intermediate message per) FOLD into a
// `tools` timeline attached to the next text-bearing assistant message — the
// same shape the live transport builds from tool.activity frames — so history
// re-renders with the identical ChatToolRow timeline instead of ghost rows.
// Exported (despite the underscore-private naming convention used
// throughout this module) so tickets/opus.md's "credits-exhausted UX" fix —
// restoring `entry.metadata` on history reload — has direct unit coverage
// without standing up the whole hybrid session manager.
// The persisted record's createdAt → the epoch-ms `ts` the live transport
// stamps (Date.now()), so ChatMessage's Meta.Time (`if: !!s.ts`) and
// ChatToolRow's duration (`s.doneTs - s.ts`) survive a history reload
// (AI-CHAT-RESTORED-THREAD-NO-TIMESTAMP-1). Null, never absent, when the
// record carries no parseable time — a key absent at first render is never
// tracked as a dependency (see the agentName seeding note below).
const $2e58c18f079243cd$var$_messageTs = (m)=>{
    const t = m && m.createdAt ? +new Date(m.createdAt) : NaN;
    return Number.isFinite(t) ? t : null;
};
// A refusal for CREDITS reads as the shell's own sentence, never the server's
// prose (and never its "Before this error, the following actions completed
// successfully…" lead): the rows `_toChatMessages` built go through the shell's
// registered step (functions/creditsRefusal.js creditsRefusalRows) — the copy
// through the live element's polyglot, the way out for the viewer's role. A
// reader that has no element (a bare read) keeps the rows as they are.
const $2e58c18f079243cd$var$_creditsWorded = (el, root, rows)=>{
    try {
        const worded = el && typeof el.call === 'function' ? el.call('creditsRefusalRows', rows, root) : null;
        return Array.isArray(worded) ? worded : rows;
    } catch (_) {
        return rows;
    }
};
// A QUESTION ITS TURN LEFT (F1, dev 2026-10-28): a stop, or a turn that
// failed or ended, closed the waiting card and posted a not-run result for
// it (the transport's _endWaitingCards: `{ ok: false, notRun: true,
// stopped? }`; an older thread's closed page wrote the same shape). Live, its
// row reads "Unanswered question" (`denied`) — never a red ✗ failure, which
// the reload drew, under "Waiting for your choice". A Run / Skip the gate
// declined (`denied`) is the gate's, not the question's (_skippedAtTheGate).
const $2e58c18f079243cd$var$_askLeftByItsTurn = (row, res)=>!!row && (row.tool === 'ask_user' || row.tool === 'confirm_with_user') && !!res && res.ok === false && !res.denied && (!!res.notRun || !!res.stopped || !!res.superseded);
// A STEP THE PERSON SKIPPED (coordinator W3b, 2026-10-29: a reload drew every
// step skipped on Run / Skip as a red ✗ failure). On Skip the transport's gate
// settles `{ ok: false, denied: true, error }` (resolveAiToolApproval; a turn
// that ended while the step waited settles the same shape,
// settleParkedAiToolApprovals); the SDK posts it as it is, and the server
// saves it as the tool_result `payload` (prepareWorkspaceResume, metadata
// kind `workspace_client_action`). Live the row reads `denied` — the quiet ✗
// and "skipped" — and the server's completed frame keeps it so. An approval
// that ran out of time (`notRun`, expireParkedAiToolApproval) is a failed
// row live, with its reason: it stays one.
const $2e58c18f079243cd$var$_skippedAtTheGate = (res)=>!!res && res.ok === false && res.denied === true && !res.notRun;
// AN ANSWERED QUESTION KEEPS ITS CARD (Nika 2026-10-28: "colalpese after
// answer"). A reloaded thread draws an ask_user / confirm_with_user card
// FOLDED to its answer: the line the live card folds to, under its step,
// with Change (components/_simone/ChatCard.js). Built from the saved call
// (prompt, options, labels) and its saved result. Never live buttons: that
// turn has its answer. A question a new message closed comes back as its
// one muted line; one its turn left (the row's `denied`) as that line with
// its reason (`_closedBy`: 'stop' when the person stopped the reply, else
// 'end'), as live; one never answered (the page left mid-ask) has no card.
const $2e58c18f079243cd$var$_askCardFromHistory = (row, res)=>{
    const confirmTool = !!row && row.tool === 'confirm_with_user';
    if (!row || row.tool !== 'ask_user' && !confirmTool) return null;
    const superseded = row.status === 'superseded';
    // A question skipped on Run / Skip (a re-offered one: `denied`) is the
    // gate's: its row reads "skipped", as live, and it never drew a card.
    const left = row.status === 'denied' && !(res && res.denied);
    if (!superseded && !left && (!res || res.ok === false)) return null;
    const a = row.args && typeof row.args === 'object' ? row.args : {};
    const options = Array.isArray(a.options) ? a.options : [];
    const confirm = confirmTool || a.kind === 'confirm';
    const label = (o)=>o && o.label != null ? String(o.label) : null;
    const card = {
        type: confirm ? 'confirm' : 'choice',
        prompt: String((confirmTool ? a.body : a.prompt) || ''),
        ...confirm ? {
            confirmLabel: confirmTool ? a.confirmText || null : label(options[0]),
            cancelLabel: confirmTool ? a.cancelText || null : label(options[1])
        } : {
            options: options
        },
        _cardId: 'ask-' + row.id,
        _callId: row.id,
        _resolved: true,
        _chosen: null,
        _chosenLabel: null,
        _superseded: superseded || left,
        _closedBy: left ? res && res.stopped ? 'stop' : 'end' : null,
        _written: false,
        _edit: false
    };
    if (superseded || left) return card;
    const edit = typeof res.edit === 'string' ? res.edit.trim() : '';
    if (edit) return {
        ...card,
        _chosen: 'edit',
        _chosenLabel: edit,
        _edit: true
    };
    if (confirmTool) {
        if (typeof res.confirmed !== 'boolean') return null;
        return {
            ...card,
            _chosen: res.confirmed ? 'confirm' : 'cancel'
        };
    }
    const choice = res.choice != null ? String(res.choice) : '';
    const shown = String(res.label != null ? res.label : choice).trim();
    if (!shown) return null;
    return {
        ...card,
        _chosen: choice || shown,
        _chosenLabel: shown,
        _written: !!res.written
    };
};
const $2e58c18f079243cd$export$2f445cb00ad506c3 = (el)=>{
    try {
        const w = el && typeof el.call === 'function' ? el.call('polyglot', 'common.action.continue') : null;
        return typeof w === 'string' && w ? w : null;
    } catch (_) {
        return null;
    }
};
// The instruction the Continue chip sent as the member's text before the
// resume became `context.resume` — matched whole, only on a user row.
const $2e58c18f079243cd$var$_LEGACY_CONTINUE_PROMPT = "Continue from where the last turn stopped \u2014 the completed actions are already saved; do not redo them.";
const $2e58c18f079243cd$export$a20e18202e5cd9ba = (messages = [], words = {})=>{
    const out = [];
    let pendingTools = [];
    let pendingCards = [];
    for (const m of messages){
        if (!m) continue;
        const parts = m.content || [];
        const toolCall = parts.find((p)=>p && p.type === 'tool_call');
        if (toolCall) {
            const payload = toolCall.payload || {};
            // What the model SAID beside this call (core-wl callText, server
            // 84527812: [text before] + tool_call + [text after], in order). Live,
            // those words streamed before the call ran and became its NOTE — the
            // same place here, joined in the saved order; never a second bubble.
            // A call saved alone (older sessions) has no note.
            // No machine trailer: the P0 loop saved `<!--SUGGEST:[…]-->` here, at
            // times split across two text parts — so the parts are stripped as ONE
            // text (a separator that a removed trailer takes with it), then split.
            const beside = (0, $1vH8H.stripAnswerTrailers)(parts.filter((p)=>p && p.type === 'text' && typeof p.text === 'string' && p.text.trim()).map((p)=>p.text).join('\u0001')).split('\u0001').map((t)=>t.trim()).filter(Boolean).join('\n');
            pendingTools.push({
                id: String(m.id || m._id || `t-${pendingTools.length}`),
                tool: payload.name || 'tool',
                args: payload.args || null,
                // The step in plain words (server lane ai-ux saves the frame's `label`
                // on the call, 2026-09-30) — ChatToolRow shows it instead of the tool
                // name and its arguments. Null, never absent, on an older saved call:
                // the live transport seeds the same key (simoneAiTransport
                // _patchToolActivity), and a key absent at first render is never
                // tracked.
                label: typeof payload.label === 'string' && (0, $1vH8H.stripAnswerTrailers)(payload.label).trim() ? (0, $1vH8H.stripAnswerTrailers)(payload.label).trim() : null,
                ...beside ? {
                    note: beside
                } : {},
                // The tool_call message's own persisted time = the step's start instant.
                ts: $2e58c18f079243cd$var$_messageTs(m),
                status: 'done'
            });
            // Display cards persist in the tool_call args — restore them so a
            // reloaded thread shows the same cards the live turn rendered.
            // A question card (ask_user, confirm_with_user) never comes back with
            // its buttons — they would offer dead choices; an answered one comes
            // back folded to its answer, at its result (_askCardFromHistory).
            if (payload.name === 'render_cards' && Array.isArray(payload.args?.cards)) pendingCards = pendingCards.concat(payload.args.cards);
            continue;
        }
        const toolResult = parts.find((p)=>p && p.type === 'tool_result');
        if (toolResult) {
            const last = pendingTools[pendingTools.length - 1];
            if (last) {
                if (toolResult.payload && toolResult.payload.ok === false) last.status = 'error';
                // A step a new message closed while it waited (server
                // closeDanglingClientCall, reason `new_message`) reads as the live row
                // did: superseded, with "Run it now" — never as a failure.
                if (toolResult.payload && toolResult.payload.reason === 'new_message' || m.metadata && m.metadata.reason === 'new_message') last.status = 'superseded';
                else if ($2e58c18f079243cd$var$_askLeftByItsTurn(last, toolResult.payload)) // A question its turn left reads as the live row did: unanswered.
                last.status = 'denied';
                else if ($2e58c18f079243cd$var$_skippedAtTheGate(toolResult.payload)) // A step the person skipped reads as the live row did: skipped.
                last.status = 'denied';
                const notRun = !!toolResult.payload?.notRun;
                // …and a step that never ran is marked so, as live (expireParkedAiToolApproval):
                // its row shows no words written before the call (F3).
                if (notRun && toolResult.payload.ok === false) last.notRun = true;
                const summary = (0, $1vH8H.stripAnswerTrailers)(String(toolResult.text || ''));
                // A SERVER tool's refusal (every kind but the browser's own
                // workspace_client_action): line 1 is the member's, line 2+ and the
                // payload are the MODEL's English (toolFailureLine.js on the server).
                // The live frame keeps line 1 as summary and reason; so does a reload
                // (persona round 4, giorgi: "Nothing was saved — … Fix ALL of them").
                const kind = m.metadata && m.metadata.kind;
                const serverRefusal = !notRun && toolResult.payload && toolResult.payload.ok === false && typeof kind === 'string' && kind !== 'workspace_client_action';
                const firstLine = summary.split('\n')[0].trim();
                // A closed page's result also carries retry instructions for the model.
                // Restore only its plain status line, as the live completed frame does.
                last.summary = (notRun || serverRefusal ? firstLine : summary).slice(0, 300);
                // The tool_result message's time = the step's done instant — with `ts`
                // above it re-renders ChatToolRow's duration tag after a reload.
                last.doneTs = $2e58c18f079243cd$var$_messageTs(m);
                // AI-301 — restore the structured created-item outcome the live turn
                // stamped (simoneAiTransport onToolCall), so ChatToolRow's link to the
                // created item survives a history reload, not just the live turn.
                const created = (0, $8WAnX.toolOutcome)(toolResult.payload);
                if (created) last.created = created;
                // An answered question (ask_user): its saved result is the card's own
                // return value ({ ok, choice, label }), so the row names the pick again.
                // An Edit is no pick: its row says "You answered", its card the words.
                const res = toolResult.payload;
                if (last.tool === 'ask_user' && res && res.ok !== false && !res.edit) {
                    const pick = String(res.label != null ? res.label : res.choice != null ? res.choice : '');
                    if (pick.trim()) last.answer = pick.trim();
                }
                // …and its card comes back folded to that answer, under its step.
                const askCard = $2e58c18f079243cd$var$_askCardFromHistory(last, res);
                if (askCard) pendingCards.push(askCard);
                // …and a refusal's reason (toolFailure), so a reloaded ✗ still says why.
                const failure = notRun ? null : serverRefusal ? firstLine || null : (0, $8WAnX.toolFailure)(toolResult.payload);
                if (failure) last.failure = failure;
            }
            // An EMBED tool's live block (embed_records / embed_widget): the SAME card
            // the live turn drew from its completed frame (_simone/toolEmbed.js), on
            // the answer this tool belongs to. A result without `embed` (an older
            // session, any other tool, a refusal) restores nothing.
            const embedCard = (0, $eujtO.toolEmbedCard)(toolResult.payload);
            if (embedCard) pendingCards.push({
                ...embedCard,
                _embedFor: last ? last.id : String(m.id || m._id || '')
            });
            continue;
        }
        let text = parts.filter((p)=>p && p.type === 'text').map((p)=>p.text).join('');
        // No machine trailer reaches a rendered answer (saved P0 threads hold one).
        if (m.role === 'assistant') text = (0, $1vH8H.stripAnswerTrailers)(text);
        // The builder's own notes never read as the person's words: the transport
        // prepends `[user is pointing at: …]` lines to the TEXT it sends so the
        // model sees them, and threads saved before CORE builder-r2 also hold the
        // `[editing multi-page app …]` block it used to prepend; the server saved
        // the turn as sent — the live bubble never showed them, so neither does a
        // reload (sam, round 1b: "[editing multi-page app… do NOT create_app
        // again.]" under "You").
        if (m.role === 'user') {
            text = text.replace(/^(?:\[user is pointing at: [^\n]*\]\n)+\n/, '').replace(/^\[editing multi-page app [\s\S]*?do NOT create_app again\.\]\n\n/, '');
            if (words && words.continueWord && text.trim() === $2e58c18f079243cd$var$_LEGACY_CONTINUE_PROMPT) text = words.continueWord;
        }
        // AI-302 — the history-reload gate: a PRE-AI-203 conversation may hold a
        // persisted assistant answer that IS tool-call protocol text (the
        // measured 3-of-8 leak). Never render it as prose; keep the raw for
        // diagnosis on the entry's metadata below.
        let protocolLeak = null;
        if (m.role === 'assistant') {
            const leakCheck = (0, $472jS.sanitizeAssistantProtocolText)(text);
            if (leakCheck.leaked) {
                text = leakCheck.text;
                protocolLeak = leakCheck.raw;
            }
        }
        const entry = {
            id: String(m.id || m._id || ''),
            role: m.role,
            text: text,
            ts: $2e58c18f079243cd$var$_messageTs(m)
        };
        if (protocolLeak != null) entry.metadata = {
            protocolLeak: true,
            rawProtocolText: protocolLeak
        };
        // AI-TALK-TO-AGENT-REUSES-OPEN-THREAD-1 — the author is a property of the
        // MESSAGE. The server persists the answering agent's display name on the
        // assistant message metadata; restore it so a reloaded transcript keeps
        // the correspondent that actually wrote each reply, in a thread whose
        // routing target changed part-way through. Seeded to null on an
        // agent-less reply for the same reason `tools`/`cards` are seeded: a key
        // absent at first render is never tracked as a dependency, so ChatMessage's
        // Author factory would not re-fire if the row were later patched.
        if (m.role === 'assistant') entry.agentName = m.metadata?.agentName || null;
        // Follow-up suggestions persist on the assistant message's metadata —
        // restore them so a reloaded thread's NEWEST reply regrows its buttons
        // (ChatMessage gates rendering to the last row, so older rows carry the
        // data invisibly).
        if (m.role === 'assistant' && Array.isArray(m.metadata?.suggestions) && m.metadata.suggestions.length) entry.suggestions = m.metadata.suggestions;
        // GROUNDING (spec §4.2–4.3) — the refs the answer cited and its computed
        // confidence verdict, persisted on the assistant message's metadata by the
        // server. Restored for the same reason `suggestions` right above is: the
        // key must EXIST on the entry at first render or ChatMessage's Sources /
        // Confidence factories never track it as a dependency.
        //
        // ⚠️ BOTH are seeded UNCONDITIONALLY on every assistant row, empty/null
        // included — unlike `suggestions`, which is only attached when the server
        // has some. A reloaded answer with no confidence must render the muted
        // "Unscored" pill, and a row whose key is simply absent renders nothing at
        // all: "the model did not say" and "the model was confident" would look
        // identical. Spec §4.3 — confidence is ALWAYS present on an assistant row.
        if (m.role === 'assistant') {
            entry.sources = Array.isArray(m.metadata?.sources) ? m.metadata.sources : [];
            entry.confidence = m.metadata?.confidence && typeof m.metadata.confidence === 'object' ? m.metadata.confidence : null;
            // The advice level (vault spec 06 §7), seeded for the same reason:
            // null on every row a workspace does not grade, the server's bag
            // where it does. ChatMessage renders nothing for null.
            entry.level = m.metadata?.level && typeof m.metadata.level === 'object' ? m.metadata.level : null;
        }
        // Structured error signal (tickets/opus.md "credits-exhausted UX") —
        // restore it on reload too, not just on the live turn, so a reloaded
        // thread's out-of-credits row still carries the metadata-key check
        // ChatMessage's onInit/onUpdate hook reads (`s.metadata.kind==='error'`).
        // Previously dropped entirely on history reload (only `suggestions` was
        // pulled off `m.metadata` here) — a page refresh silently lost the
        // signal even though the server persisted it correctly.
        if (m.role === 'assistant' && m.metadata?.kind === 'error') {
            // Spread-merged — an AI-302 protocol-leak stamp set at entry
            // construction must survive this restore, not be clobbered by it.
            entry.metadata = {
                ...entry.metadata || {},
                kind: m.metadata.kind,
                errorCode: m.metadata.errorCode,
                errorMessage: m.metadata.errorMessage,
                retryable: m.metadata.retryable,
                creditsExhausted: !!m.metadata.creditsExhausted
            };
            // The refusal's own figures, when the server states them structurally.
            // Only copied when present, so a row without them keeps the shape above.
            if (m.metadata.creditsNeeded != null) entry.metadata.creditsNeeded = m.metadata.creditsNeeded;
            // An unkept-promise turn (`TURN_ENDED_ON_PROMISE`) carries
            // `memberText: true`: its text is the model's words plus the server's
            // stop line in the member's language, and ChatMessage shows it as
            // written. Dropped here, a reloaded row fell back to the generic line.
            if (m.metadata.memberText === true) entry.metadata.memberText = true;
            if (m.metadata.creditsAvailable != null) entry.metadata.creditsAvailable = m.metadata.creditsAvailable;
        }
        if (m.role === 'assistant' && pendingTools.length) {
            // The answer REPEATS its last call's note (the model said it beside the
            // call, then again as its answer — _simone/callNote.js): once, as the
            // answer, exactly as the live turn shows it.
            const endCall = pendingTools[pendingTools.length - 1];
            if (endCall && (0, $9C8Ov.repeatsNote)(entry.text, endCall.note)) pendingTools[pendingTools.length - 1] = {
                ...endCall,
                note: null
            };
            entry.tools = pendingTools;
            pendingTools = [];
        }
        // A FLY PAGE's answer (`metadata.flyPage`, Fly mode): its sections are
        // this answer's live cards and its word blocks its words (toolEmbed.js
        // flyPageEmbeds) — a Fly thread opened as a thread showed the openings
        // only (Nika 2026-10-18).
        if (m.role === 'assistant' && m.metadata && m.metadata.flyPage) {
            const fly = (0, $eujtO.flyPageEmbeds)(m.metadata.flyPage);
            if (fly.words) entry.text = [
                entry.text,
                fly.words
            ].filter(Boolean).join('\n\n');
            if (fly.cards.length) pendingCards = pendingCards.concat(fly.cards);
        }
        // A SETUP NOTE (server lane S1, the workspace's first thread: `metadata:
        // { kind: 'note', note: 'plan' | 'summary', source: 'setup', plan? }`,
        // no AI turn): its kind rides the row, so every renderer can tell a note
        // from an answer, and the plan rides with it — the shell draws the plan
        // card in its own language (functions/workspaceSetup.js). The plan note
        // has no words of its own (`text: ''`: the shared row draws nothing for
        // it); the summary note's words are Fly's, shown as written.
        if (m.role === 'assistant' && m.metadata && m.metadata.kind === 'note') {
            const plan = m.metadata.plan;
            entry.metadata = {
                ...entry.metadata || {},
                kind: 'note',
                note: typeof m.metadata.note === 'string' ? m.metadata.note : '',
                source: typeof m.metadata.source === 'string' ? m.metadata.source : '',
                plan: plan && typeof plan === 'object' && !Array.isArray(plan) ? plan : null
            };
        }
        if (m.role === 'assistant' && pendingCards.length) {
            entry.cards = pendingCards;
            pendingCards = [];
        }
        out.push(entry);
    }
    // A conversation can END on tool rows with no answer after them — most
    // importantly when the loop is still SUSPENDED on a client tool this browser
    // never ran. Those trailing rows had no later assistant message to fold onto
    // and were dropped outright, so a reload came back with no timeline row for
    // the pending call and nothing to re-offer it on
    // (SIMONE-APPROVAL-REOFFER-PENDING-CLIENT-CALL-UI-1).
    if (pendingTools.length || pendingCards.length) {
        // The turn ENDED on its call: the words the model said beside that call
        // are its answer — shown once, as the answer (as live), when the row they
        // land on has no answer of its own; otherwise they stay the call's note.
        const last = out[out.length - 1];
        const lands = last && last.role === 'assistant' ? String(last.text || '').trim() : '';
        const endCall = pendingTools[pendingTools.length - 1];
        const endWords = !lands && endCall && typeof endCall.note === 'string' ? endCall.note : '';
        if (endWords) pendingTools[pendingTools.length - 1] = {
            ...endCall,
            note: null
        };
        if (last && last.role === 'assistant') {
            if (pendingTools.length) last.tools = (last.tools || []).concat(pendingTools);
            if (pendingCards.length) last.cards = (last.cards || []).concat(pendingCards);
            if (endWords) last.text = endWords;
        } else out.push({
            id: `a-tools-${pendingTools[0] && pendingTools[0].id || Date.now()}`,
            role: 'assistant',
            text: endWords,
            // No persisted answer message exists to carry a time — inherit the
            // first trailing tool's start instant so the row is not timeless.
            ts: pendingTools[0]?.ts ?? null,
            // Seed every key ChatMessage's factories read. A key that is ABSENT at
            // the row's first render is never tracked as a dependency, so the row
            // would not repaint when the approval state later lands on it — the
            // same trap the live placeholder's tools/cards/suggestions seeding
            // avoids (see simoneAiTransport.js).
            tools: pendingTools,
            cards: pendingCards,
            suggestions: [],
            // No text, so no agent ever wrote it — but the key is seeded for the
            // same dependency-tracking reason as the three above.
            agentName: null
        });
    }
    // The first thread's two notes — the plan, then the summary — are ONE row:
    // the summary's words, carrying the plan. A hidden plan row before the
    // summary would group the summary under it (Chat.js `_grouped`: no author,
    // no time), so the summary would not read as the thread's first answer. A
    // plan with no summary stays its own row, with no words.
    for(let i = 0; i < out.length - 1; i++){
        const a = out[i].metadata;
        const b = out[i + 1].metadata;
        if (a && a.kind === 'note' && a.note === 'plan' && a.plan && b && b.kind === 'note' && b.note === 'summary' && !b.plan) {
            out[i + 1] = {
                ...out[i + 1],
                metadata: {
                    ...b,
                    plan: a.plan
                }
            };
            out.splice(i, 1);
            break;
        }
    }
    return out;
};
const $2e58c18f079243cd$var$newSessionId = ()=>`s-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
const $2e58c18f079243cd$var$titleFromMessages = (el, msgs)=>{
    const fallback = ()=>el.call('polyglot', 'workspace.simone.newChat');
    if (!msgs || !msgs.length) return fallback();
    const first = msgs.find((m)=>m.role === 'user');
    const txt = first && first.text || '';
    return txt.slice(0, 60) + (txt.length > 60 ? "\u2026" : '') || fallback();
};
// Resolve the namespace prefix + project scope for a chat context. The Chat
// callers pass `scope` explicitly ('general' | 'addapp'); /add-app threads live
// under _ax_* root keys and are project-scoped to the active extension
// (root._addAppProjectId), so they never collide with the general drawer/composer.
const $2e58c18f079243cd$var$_scope = (root, scope)=>{
    const addapp = scope === 'addapp';
    const projectId = addapp ? root && root._addAppProjectId || null : null;
    // dashboard = the inline-thread surface on / (its own thread, _db_*); like the
    // general drawer it is workspace-scoped (no projectId), just key-namespaced.
    const k = addapp ? '_ax_' : scope === 'dashboard' ? '_db_' : '';
    return {
        k: k,
        projectId: projectId,
        opts: projectId ? {
            projectId: projectId
        } : {}
    };
};
// Pin the AI service to the active in-org workspace before ANY server conversation
// call (list / get / create). General threads need activeWorkspaceId set or
// _conversationBase() has no base → 404; add-app passes opts.projectId per-call
// instead, so it skips this. Always uses the drift-corrected workspace
// (activeWorkspaceId → root.workspace.id) so list/get/create AGREE even right after
// an org switch — otherwise a thread created/loaded under a stale workspace silently
// 404s or lands in the wrong org. Best-effort: the call may still resolve a cached ws.
const $2e58c18f079243cd$var$pinWorkspace = (ai, root, projectId)=>{
    if (projectId) return;
    try {
        const wsId = (0, $9ZTVI.activeWorkspaceId)(root);
        if (wsId && ai && typeof ai.updateContext === 'function') ai.updateContext({
            activeWorkspaceId: wsId
        });
    } catch (_) {
    /* best-effort */ }
};
// ── Reload survival (SIMONE-INFLIGHT-TURN-NO-PERSISTENCE-1) ────────────────
// `activeSessionId` is in-memory root state, so every reload — F5, a parcel HMR
// refresh, a crash, the AppOrgSwitcher org-switch fallback — forgot WHICH thread
// was open and the panel came back empty while the server still held the whole
// conversation. The pointer below is the only thing persisted; the transcript is
// re-read from the server (`getConversation`), which stays the single source of
// truth. `./threadPointer.js` holds the policy (key, TTL, notice) and is
// store-injected, so a host with no storage degrades to today's behavior.
const $2e58c18f079243cd$var$_store = ()=>{
    try {
        return typeof globalThis !== 'undefined' && globalThis.localStorage || null;
    } catch (_) {
        // Storage access throws outright under some privacy settings.
        return null;
    }
};
// One pointer per tenant AND per correspondent: add-app threads belong to their
// extension's project, general/dashboard to the active workspace. Keying by
// tenant is what stops a pointer restoring another org's conversation after a
// switch; keying by `_threadAgentId` is answer C on
// AI-TALK-TO-AGENT-REUSES-OPEN-THREAD-1 — a named agent keeps its own thread,
// so entering from its card resumes ITS history, never whatever was last open.
//
// `_threadAgentId` is the agent that OWNS the open thread. It is NOT
// `_targetAgentId`, which is where the NEXT message goes: an @-mention aims a
// message at an agent without moving the user out of the thread they are
// typing in, and moving the pointer under them would file that thread as the
// agent's.
const $2e58c18f079243cd$var$_pointerKey = (root, scope, projectId)=>(0, $50L4n.threadPointerKey)(scope, projectId || (0, $9ZTVI.activeWorkspaceId)(root), root && root._threadAgentId);
// The conversation the ADDRESS BAR names for the general thread — `?ai=<id>`,
// the main thread's URL (functions/assistantThreadUrl.js) — or null. The
// add-app and dashboard threads have no URL of their own; a host without the
// function (standalone simone, the preview) has no thread URL at all: el.call
// of a name no context registers answers undefined (smbls utils call()).
const $2e58c18f079243cd$var$_linkedThreadId = (el, scope)=>{
    if (!el || scope === 'addapp' || scope === 'dashboard') return null;
    return el.call('assistantThreadLinkId') || null;
};
// How many messages the chat holds — a send appends, so a change in this
// count while restoreActiveThread reads means the member acted meanwhile.
const $2e58c18f079243cd$var$_chatLength = (list)=>Array.isArray(list) ? list.length : 0;
const $2e58c18f079243cd$var$_rememberThread = (root, scope, projectId, id, inflight)=>{
    const store = $2e58c18f079243cd$var$_store();
    if (!store) return;
    const key = $2e58c18f079243cd$var$_pointerKey(root, scope, projectId);
    if (!id) (0, $50L4n.clearThreadPointer)(store, key);
    else (0, $50L4n.writeThreadPointer)(store, key, id, inflight);
};
// Snapshot the live message buffer into the active session before mutating.
// `k` is the scope's key prefix ('' general | '_ax_' add-app).
const $2e58c18f079243cd$var$shellSnapshot = (el, root, k = '')=>{
    const id = root[k + 'activeSessionId'];
    if (!id) return;
    const sessions = {
        ...root[k + 'sessions'] || {}
    };
    const cur = sessions[id] || {
        id: id,
        ts: Date.now()
    };
    const msgs = root[k + 'chatMessages'] || [];
    // A thread nobody asked in yet keeps the title it came with (the first
    // workspace thread's is the company's name — its notes hold no question).
    const asked = msgs.some((m)=>m && m.role === 'user');
    sessions[id] = {
        ...cur,
        id: id,
        title: asked || !cur.title ? $2e58c18f079243cd$var$titleFromMessages(el, msgs) : cur.title,
        messages: msgs,
        ts: cur.ts || Date.now()
    };
    root.update({
        [k + 'sessions']: sessions
    });
};
const $2e58c18f079243cd$export$7b962f1e4c5494f = function() {
    const root = this.state.root;
    if (root.activeSessionId) return;
    const id = $2e58c18f079243cd$var$newSessionId();
    const sessions = {
        ...root.sessions || {}
    };
    sessions[id] = {
        id: id,
        title: this.call('polyglot', 'workspace.simone.newChat'),
        messages: [],
        ts: Date.now()
    };
    root.update({
        sessions: sessions,
        activeSessionId: id
    });
};
const $2e58c18f079243cd$export$c3fece5592184181 = async function(scope) {
    const el = this;
    const root = el.state.root;
    const { k: k, projectId: projectId, opts: opts } = $2e58c18f079243cd$var$_scope(root, scope);
    // add-app with no extension selected yet → nothing to hydrate (the thread is
    // created on the first message; the sidebar selecting an extension hydrates it).
    if (scope === 'addapp' && !projectId) return;
    // Resolve the real AI service (with the conversation API). _ai prefers the
    // cached getAiService() singleton; during the boot window it's still null, so
    // await resolution here so PREVIOUS chats load on first open (not only after a
    // turn).
    let ai = $2e58c18f079243cd$var$_ai(el);
    if (!ai) try {
        ai = await $2e58c18f079243cd$var$resolveAiService(el && el.sdk);
    } catch (_) {
        return;
    }
    if (!ai || typeof ai.listConversations !== 'function') return;
    // Scope the SDK. add-app passes opts.projectId per-call (routes to
    // /projects/:id/conversations WITHOUT changing the global SDK context, so it
    // can't leak into the general drawer). General sets the active workspace before
    // listing — hydrate runs on load, before the send handler sets it, otherwise
    // _conversationBase() throws "no active workspace" → silent 0 chats.
    $2e58c18f079243cd$var$pinWorkspace(ai, root, projectId);
    try {
        const list = await ai.listConversations(opts);
        if (!Array.isArray(list)) return;
        const prev = root[k + 'sessions'] || {};
        const sessions = {};
        for (const t of list){
            const id = t && (t.conversationId || t.id);
            if (!id) continue;
            sessions[id] = {
                id: id,
                title: t && t.title || el.call('polyglot', 'workspace.simone.newChat'),
                ts: t && t.lastMessageAt ? +new Date(t.lastMessageAt) : Date.now(),
                pinned: !!(t && t.pinned),
                messages: prev[id] && prev[id].messages || []
            };
        }
        root.update({
            [k + 'sessions']: sessions
        });
    } catch (err) {
        // Don't fail silently — this masked the "previous conversations don't load"
        // bug. Keep local sessions, but surface the reason.
        if (typeof console !== 'undefined') console.debug("[simone] hydrateServerSessions: listConversations failed \u2014", err && err.message);
    }
};
const $2e58c18f079243cd$export$43c80672febddad8 = async function(scope) {
    const el = this;
    const root = el.state.root;
    const { k: k, projectId: projectId, opts: opts } = $2e58c18f079243cd$var$_scope(root, scope);
    // Parked approvals from the outgoing thread must settle (as declined) —
    // orphaning them strands the server-side turn forever.
    try {
        el.call('settleParkedAiToolApprovals', 'The conversation was switched before this action was approved.');
    } catch (_) {}
    const reset = {
        [k + 'chatMessages']: [],
        [k + 'chatTyping']: false,
        [k + 'currentAssistantId']: null,
        [k + 'showSessionMenu']: false
    };
    if (!k) {
        reset.chatInput = '';
        reset.pickedElements = [];
    }
    // LAZY thread — do NOT create a server conversation here. Eager-creating one
    // persisted an EMPTY thread in the DB whenever the user opened a new chat but
    // never sent. Instead use a LOCAL placeholder ('s-…' id); the FIRST message
    // lazily creates the real server conversation (the transport dispatches with
    // conversationId=null for an 's-…'/absent id, so the server creates it WITH that
    // message, and onDone re-points activeSessionId to the real id). Net: only
    // non-empty threads ever reach the database.
    $2e58c18f079243cd$var$shellSnapshot(this, root, k);
    const id = $2e58c18f079243cd$var$newSessionId();
    root.update({
        [k + 'sessions']: {
            ...root[k + 'sessions'] || {},
            [id]: {
                id: id,
                title: this.call('polyglot', 'workspace.simone.newChat'),
                messages: [],
                ts: Date.now()
            }
        },
        [k + 'activeSessionId']: id,
        ...reset
    });
    // A local placeholder names no server conversation, so the pointer is dropped
    // rather than pointed at something a reload could not load back.
    $2e58c18f079243cd$var$_rememberThread(root, scope, projectId, id, false);
    // Tell the bridge to spin up a fresh claude subprocess for this session.
    if (typeof window !== 'undefined' && typeof window.__simoneSendOverBridge === 'function') try {
        window.__simoneSendOverBridge({
            type: 'reset'
        });
    } catch (_) {}
};
const $2e58c18f079243cd$export$e1466eb4116c9858 = async function(agent, scope) {
    const el = this;
    const root = el.state.root;
    const agentId = agent && (agent.userId || agent.id) || null;
    const agentName = agent && (agent.name || agent.id) || null;
    const { k: k } = $2e58c18f079243cd$var$_scope(root, scope);
    // Already this correspondent's thread — re-aim the routing target and stop.
    // Reloading here would discard a half-typed draft and flicker the panel for
    // no change at all.
    if ((root._threadAgentId || null) === agentId) {
        root.update({
            _targetAgentId: agentId,
            _targetAgentName: agentName
        });
        return;
    }
    // Parked approvals from the outgoing thread must settle (as declined) —
    // orphaning them strands the server-side turn forever. Same reason as
    // `newSession`.
    try {
        el.call('settleParkedAiToolApprovals', 'The conversation was switched before this action was approved.');
    } catch (_) {}
    $2e58c18f079243cd$var$shellSnapshot(this, root, k);
    // The agent keys move BEFORE the restore, because `_pointerKey` reads
    // `_threadAgentId` to decide which pointer to look up.
    root.update({
        _threadAgentId: agentId,
        _threadAgentName: agentName,
        _targetAgentId: agentId,
        _targetAgentName: agentName,
        [k + 'activeSessionId']: null,
        [k + 'chatMessages']: [],
        [k + 'chatTyping']: false,
        [k + 'currentAssistantId']: null,
        [k + 'showSessionMenu']: false
    });
    await $2e58c18f079243cd$export$d728b55666a2b84e.call(el, scope);
    // No remembered thread for this correspondent (or it could not be loaded) —
    // start an empty one, so the panel and what it shows agree.
    if (!root[k + 'activeSessionId']) await $2e58c18f079243cd$export$43c80672febddad8.call(el, scope);
};
const $2e58c18f079243cd$export$d728b55666a2b84e = async function(scope) {
    const el = this;
    const root = el.state.root;
    const { k: k, projectId: projectId, opts: opts } = $2e58c18f079243cd$var$_scope(root, scope);
    // The user already opened a thread on this mount (a fast click, or add-app
    // selecting an extension). Their choice wins over the remembered one.
    if (root[k + 'activeSessionId']) return;
    const store = $2e58c18f079243cd$var$_store();
    if (!store) return;
    const key = $2e58c18f079243cd$var$_pointerKey(root, scope, projectId);
    const pointer = (0, $50L4n.readThreadPointer)(store, key);
    if (!pointer) return;
    // The address bar names a thread too (a pasted link, a reload, Back /
    // Forward), and that is the person's choice exactly like a click is. The
    // remembered thread loads only when it IS that thread. Any other one stays
    // on the server as it is: loading it first would re-offer its waiting client
    // call below, and the switch to the linked thread would then settle that
    // call as declined before the person ever saw it. Not chosen is not dead —
    // the pointer is kept.
    const linked = $2e58c18f079243cd$var$_linkedThreadId(el, scope);
    if (linked && linked !== pointer.id) return;
    let ai = $2e58c18f079243cd$var$_ai(el);
    if (!ai) try {
        ai = await $2e58c18f079243cd$var$resolveAiService(el && el.sdk);
    } catch (_) {
        return;
    }
    if (!ai || typeof ai.getConversation !== 'function') return;
    $2e58c18f079243cd$var$pinWorkspace(ai, root, projectId);
    // What the chat holds as the read starts — see the check after the read.
    const heldAtRead = $2e58c18f079243cd$var$_chatLength(root[k + 'chatMessages']);
    const typingAtRead = !!root[k + 'chatTyping'];
    let msgs = null;
    let offer = null;
    try {
        const data = await ai.getConversation(pointer.id, opts);
        const words = {
            continueWord: $2e58c18f079243cd$export$2f445cb00ad506c3(el)
        };
        msgs = $2e58c18f079243cd$var$_creditsWorded(el, root, $2e58c18f079243cd$export$a20e18202e5cd9ba(data && data.messages, words));
        // The cloud loop may still be SUSPENDED on a client tool this page never
        // ran. The server persists that whole call on the conversation and serves
        // it here, and `.../tool-result` accepts its callId from a brand-new
        // connection — so a fresh page can still complete the turn. Read the offer
        // now; the transport re-offers it below.
        offer = (0, $czZQn.pendingClientCallOffer)(data && data.conversation, data && data.messages);
    } catch (err) {
        // Deleted, archived, or belonging to a tenant we can no longer read. A
        // pointer that cannot be loaded is a dead pointer — drop it instead of
        // re-asking the server on every single mount.
        (0, $50L4n.clearThreadPointer)(store, key);
        if (typeof console !== 'undefined') console.debug("[simone] restoreActiveThread: getConversation failed \u2014", err && err.message);
        return;
    }
    // The member chose WHILE the read was in flight — a send on a cold load
    // starts its own session with their message: that choice wins exactly like
    // one made before the read, never the remembered thread laid over it (the
    // first send after a cold load vanished, dev 2026-10-05). Not chosen is not
    // dead — the pointer is kept, as for a linked thread above.
    if (root[k + 'activeSessionId']) return;
    // …and a send that has NO id yet is the same choice: it goes with
    // `conversationId: null`, the SDK continues its last conversation, and the
    // turn names the id only when it ENDS (prod check 2026-10-06, DESIGN-
    // COMPOSER-PRIVACY-RESTORE-PROD-LEG-1). A read that lands while that turn
    // runs finds no id — so a message added, or a turn started, during the
    // read wins too. Nothing changed while reading → the remembered thread
    // loads as before.
    if ($2e58c18f079243cd$var$_chatLength(root[k + 'chatMessages']) !== heldAtRead || !typingAtRead && root[k + 'chatTyping']) return;
    // The page went away mid-turn. The approval gate's parked promise died with
    // it, so anything waiting on Run/Skip never ran — say so, once, rather than
    // letting the user retry a write that may or may not already exist.
    // A live offer makes that notice WRONG: the call is not lost, it is about to
    // be asked again on its own row. Re-offer instead of saying "did not run".
    if (!offer && (0, $50L4n.needsInterruptedNotice)(pointer, msgs)) msgs = msgs.concat({
        id: `sys-interrupted-${pointer.ts}`,
        role: 'system',
        text: (0, $50L4n.INTERRUPTED_TURN_NOTICE)
    });
    // One-shot: the notice belongs to the reload that earned it, not to every
    // later mount. Settle the flag before the state write so a crash between the
    // two cannot re-warn.
    (0, $50L4n.writeThreadPointer)(store, key, pointer.id, false);
    root.update({
        [k + 'activeSessionId']: pointer.id,
        [k + 'chatMessages']: msgs,
        // A turn cannot survive the reload — never come back stuck on "Thinking…".
        [k + 'chatTyping']: false,
        [k + 'currentAssistantId']: null
    });
    // Hand the suspended call to the transport, which owns the authorization
    // gate and the platform runner. Through `el.call`, not an import, for the
    // same reason `settleParkedAiToolApprovals` above goes that way.
    if (offer) try {
        el.call('reofferPendingClientCall', {
            offer: offer,
            conversationId: pointer.id,
            scope: scope,
            opts: opts,
            stateRoot: root,
            ai: // The service that just READ this conversation is the one that owns the
            // conversation API — hand it over rather than let the transport
            // re-resolve and risk the SDK stub that lacks submitToolResult.
            ai
        });
    } catch (_) {
    /* best-effort — the thread still restored; only the resume is lost */ }
};
const $2e58c18f079243cd$export$b4078800b0db6949 = function(scope, inflight) {
    const root = this.state.root;
    const { k: k, projectId: projectId } = $2e58c18f079243cd$var$_scope(root, scope);
    $2e58c18f079243cd$var$_rememberThread(root, scope, projectId, root[k + 'activeSessionId'], !!inflight);
};
const $2e58c18f079243cd$export$e3a071b49e0dcae8 = async function(id, scope) {
    const el = this;
    const root = el.state.root;
    const { k: k, projectId: projectId, opts: opts } = $2e58c18f079243cd$var$_scope(root, scope);
    if (!id || id === root[k + 'activeSessionId']) return;
    // Same settle-on-leave as newSession — see the note there.
    try {
        el.call('settleParkedAiToolApprovals', 'The conversation was switched before this action was approved.');
    } catch (_) {}
    $2e58c18f079243cd$var$shellSnapshot(this, root, k);
    const reset = {
        [k + 'chatTyping']: false,
        [k + 'currentAssistantId']: null,
        [k + 'showSessionMenu']: false
    };
    if (!k) {
        reset.chatInput = '';
        reset.pickedElements = [];
    }
    // Server-backed path: load the conversation's real message history. On any
    // failure fall through to the local switch (reads {k}sessions[id].messages).
    const ai = $2e58c18f079243cd$var$_ai(el);
    if (ai) {
        // Scope the SDK BEFORE fetching. General threads need the active workspace set
        // on the AI service; switching can run before any send has set it (straight
        // after load, the user opens History and clicks an older thread), or after an
        // org switch left it stale. Without it getConversation hits _conversationBase()
        // with the wrong/no workspace → 404 → we'd silently fall back to the EMPTY
        // cached buffer = the "changing thread doesn't load" bug.
        $2e58c18f079243cd$var$pinWorkspace(ai, root, projectId);
        try {
            const data = await ai.getConversation(id, opts);
            const words = {
                continueWord: $2e58c18f079243cd$export$2f445cb00ad506c3(el)
            };
            const msgs = $2e58c18f079243cd$var$_creditsWorded(el, root, $2e58c18f079243cd$export$a20e18202e5cd9ba(data && data.messages, words));
            // The thread the person opened may hold a SUSPENDED client call (the
            // page that ran its turn went away). Same read, same rule as
            // restoreActiveThread: an open link or a History click is a restore too.
            // Before this, the call stayed suspended on the server and its row read
            // as done (dev conversation 6ac35133…65db, 2026-10-05).
            const offer = (0, $czZQn.pendingClientCallOffer)(data && data.conversation, data && data.messages);
            root.update({
                [k + 'activeSessionId']: id,
                [k + 'chatMessages']: msgs,
                ...reset
            });
            $2e58c18f079243cd$var$_rememberThread(root, scope, projectId, id, false);
            if (offer) try {
                el.call('reofferPendingClientCall', {
                    offer: offer,
                    conversationId: id,
                    scope: scope,
                    opts: opts,
                    stateRoot: root,
                    ai: ai
                });
            } catch (_) {
            /* best-effort — the thread still opened; only the resume is lost */ }
            return;
        } catch (err) {
            // Do NOT swallow — silently falling back to an empty buffer is exactly what
            // masked "previous thread won't load". Surface the reason, then fall through.
            if (typeof console !== 'undefined') console.debug("[simone] switchSession getConversation failed \u2014", err && err.message);
        }
    }
    const sessions = root[k + 'sessions'] || {};
    const target = sessions[id];
    if (!target) return;
    root.update({
        [k + 'activeSessionId']: id,
        [k + 'chatMessages']: target.messages || [],
        ...reset
    });
    $2e58c18f079243cd$var$_rememberThread(root, scope, projectId, id, false);
};
const $2e58c18f079243cd$export$f3b72123251cadf = function(id) {
    const el = this;
    const root = el.state.root;
    if (!id) return;
    const sess = (root.sessions || {})[id];
    const name = sess && sess.title || el.call('polyglot', 'workspace.simone.newChat');
    const removeNow = async ()=>{
        const before = root.sessions || {};
        const wasOpen = id === root.activeSessionId;
        const openMessages = root.chatMessages;
        const sessions = {
            ...before
        };
        delete sessions[id];
        let activeSessionId = root.activeSessionId;
        let chatMessages = root.chatMessages;
        if (wasOpen) {
            const remaining = Object.values(sessions).sort((a, b)=>(b.ts || 0) - (a.ts || 0));
            if (remaining.length) {
                activeSessionId = remaining[0].id;
                chatMessages = remaining[0].messages || [];
            } else {
                // A NEW local thread, never null: a null id makes the next send fall
                // back to the SDK's cached "last used" thread — the one just deleted,
                // which the server answers with 404. An 's-…' id is sent as a new
                // conversation (the transport's newConversation).
                activeSessionId = $2e58c18f079243cd$var$newSessionId();
                chatMessages = [];
            }
        }
        root.update({
            sessions: sessions,
            activeSessionId: activeSessionId,
            chatMessages: chatMessages
        });
        // Deleting the open thread must not leave a pointer at a dead conversation.
        $2e58c18f079243cd$var$_rememberThread(root, 'general', null, activeSessionId, false);
        // A local (`s-…`) thread has no server conversation: nothing to archive.
        const ai = $2e58c18f079243cd$var$_ai(el);
        if (!ai || String(id).startsWith('s-')) return;
        $2e58c18f079243cd$var$pinWorkspace(ai, root, null);
        try {
            await ai.deleteConversation(id);
        } catch (err) {
            // The server kept it: the row comes back, and the open thread too when
            // the person has not moved to another one meanwhile.
            const restored = {
                ...root.sessions || {}
            };
            if (before[id]) restored[id] = before[id];
            const back = wasOpen && root.activeSessionId === activeSessionId;
            root.update(back ? {
                sessions: restored,
                activeSessionId: id,
                chatMessages: openMessages
            } : {
                sessions: restored
            });
            if (back) $2e58c18f079243cd$var$_rememberThread(root, 'general', null, id, false);
            el.call('openNotification', {
                type: 'error',
                title: el.call('polyglot', 'workspace.simone.removeFailed'),
                message: err && err.message || String(err)
            });
        }
    };
    el.call('confirmDialog', {
        title: el.call('polyglot', 'workspace.simone.removeTitle').replace('{name}', ()=>name),
        // The framework's own default message ("This action cannot be undone.",
        // en + ka) is the consequence here: the person cannot bring it back.
        confirmText: el.call('polyglot', 'workspace.simone.menu.remove'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: removeNow
    });
};
const $2e58c18f079243cd$export$850ffc4c3585df32 = function() {
    const root = this.state.root;
    root.update({
        showSessionMenu: !root.showSessionMenu
    });
};
const $2e58c18f079243cd$export$192b78dcd8b2a81d = function(scope) {
    const root = this.state.root;
    const { k: k } = $2e58c18f079243cd$var$_scope(root, scope);
    $2e58c18f079243cd$var$shellSnapshot(this, root, k);
};
const $2e58c18f079243cd$export$a03f1a7de50e42d8 = async function(scope) {
    const el = this;
    const root = el.state.root;
    if (!$2e58c18f079243cd$var$_ai(el)) return;
    const { k: k } = $2e58c18f079243cd$var$_scope(root, scope);
    await $2e58c18f079243cd$export$c3fece5592184181.call(el, scope);
    const cur = root[k + 'activeSessionId'];
    if (cur && String(cur).startsWith('s-')) {
        const top = Object.values(root[k + 'sessions'] || {}).filter((v)=>v && typeof v === 'object').sort((a, b)=>(b.ts || 0) - (a.ts || 0))[0];
        if (top && top.id) root.update({
            [k + 'activeSessionId']: top.id
        });
    }
    // The turn has settled and the id pointer is final — remember it, not
    // in-flight, so a reload from here restores a complete thread.
    const { projectId: projectId } = $2e58c18f079243cd$var$_scope(root, scope);
    $2e58c18f079243cd$var$_rememberThread(root, scope, projectId, root[k + 'activeSessionId'], false);
};
const $2e58c18f079243cd$export$4e580161cbdb5141 = async function(id) {
    const el = this;
    const root = el.state.root;
    if (!id) return;
    const sessions = {
        ...root.sessions || {}
    };
    const cur = sessions[id];
    if (!cur) return;
    const next = !cur.pinned;
    sessions[id] = {
        ...cur,
        pinned: next
    };
    root.update({
        sessions: sessions
    });
    const ai = $2e58c18f079243cd$var$_ai(el);
    // Local (`s-…`) threads have no server conversation yet — keep the pin
    // local-only (no PATCH to 404 on, no revert). Server threads persist it.
    if (!ai || String(id).startsWith('s-')) return;
    $2e58c18f079243cd$var$pinWorkspace(ai, root, null);
    try {
        await ai.patchConversation(id, {
            pinned: next
        });
    } catch (_) {
        const revert = {
            ...root.sessions || {}
        };
        if (revert[id]) {
            revert[id] = {
                ...revert[id],
                pinned: !next
            };
            root.update({
                sessions: revert
            });
        }
    }
};
const $2e58c18f079243cd$export$e3211e2ff65bd0c2 = async function(id) {
    const el = this;
    const root = el.state.root;
    if (!id) return;
    // A local (`s-…`) thread has no server conversation — nothing to share.
    if (String(id).startsWith('s-')) {
        el.call('openNotification', {
            type: 'error',
            title: el.call('polyglot', 'workspace.simone.notShareable'),
            message: el.call('polyglot', 'workspace.simone.notShareableBody')
        });
        return;
    }
    const ai = $2e58c18f079243cd$var$_ai(el);
    if (!ai) return;
    $2e58c18f079243cd$var$pinWorkspace(ai, root, null);
    try {
        await ai.patchConversation(id, {
            shared: true
        });
    } catch (err) {
        el.call('openNotification', {
            type: 'error',
            title: el.call('polyglot', 'workspace.simone.shareFailed'),
            message: err && err.message || el.call('polyglot', 'workspace.simone.shareFailedBody')
        });
        return;
    }
    try {
        const m = window.location.pathname.match(/^\/w\/[^/]+\/[^/]+/);
        const prefix = m ? m[0] : '';
        const url = `${window.location.origin}${prefix}/?aiConversation=${encodeURIComponent(id)}`;
        await navigator.clipboard.writeText(url);
        el.call('openNotification', {
            type: 'success',
            title: el.call('polyglot', 'workspace.simone.linkCopied'),
            message: el.call('polyglot', 'workspace.simone.linkCopiedBody')
        });
    } catch (err) {
        el.call('openNotification', {
            type: 'error',
            title: el.call('polyglot', 'workspace.simone.copyFailed'),
            message: err && err.message || String(err)
        });
    }
};
const $2e58c18f079243cd$export$ba9a6bc9c8e868c4 = function(root) {
    const dd = root && root.contextDropdown || {};
    const sess = (root.sessions || {})[dd.sessionId];
    const pinned = !!(sess && sess.pinned);
    return [
        {
            key: 'star',
            action: 'star',
            label: pinned ? 'workspace.simone.menu.unstar' : 'workspace.simone.menu.star'
        },
        {
            key: 'share',
            action: 'share',
            label: 'workspace.simone.menu.shareLink'
        },
        {
            key: 'remove',
            action: 'remove',
            label: 'workspace.simone.menu.remove',
            danger: true
        }
    ];
};
const $2e58c18f079243cd$export$882a14a83f6d4abe = function(action, item) {
    const root = this.state.root;
    const dd = root.contextDropdown || {};
    const id = dd.sessionId;
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    if (!id) return;
    if (action === 'star') {
        this.call('toggleStarSession', id);
        // Re-open History (the ContextDropdown's outside-click closed it) so the
        // star toggle is immediately visible on the row.
        root.update({
            showSessionMenu: true
        });
    } else if (action === 'share') this.call('shareSession', id);
    else if (action === 'remove') this.call('deleteSession', id);
};

});
parcelRegister("50L4n", function(module, exports) {

$parcel$export(module.exports, "threadPointerKey", () => $3a6176e6fab871f1$export$9c89447e0db8b2f5);
$parcel$export(module.exports, "readThreadPointer", () => $3a6176e6fab871f1$export$3c34366a497b611);
$parcel$export(module.exports, "writeThreadPointer", () => $3a6176e6fab871f1$export$3af82cf782128db9);
$parcel$export(module.exports, "clearThreadPointer", () => $3a6176e6fab871f1$export$91165cb0586c7889);
$parcel$export(module.exports, "INTERRUPTED_TURN_NOTICE", () => $3a6176e6fab871f1$export$8db641744a042606);
$parcel$export(module.exports, "needsInterruptedNotice", () => $3a6176e6fab871f1$export$3076b83257f29f25);
// Simone thread pointer — the one piece of chat state that must OUTLIVE the
// page, so a reload does not reset the panel to an empty "New chat".
//
// SIMONE-INFLIGHT-TURN-NO-PERSISTENCE-1. The transcript itself is NOT copied
// here: the conversation is server-owned (sdk.ai.getConversation) and copying
// it into browser storage would fork the source of truth and leave workspace
// content sitting in localStorage. What cannot be re-derived after a reload is
// WHICH thread was open — `root.activeSessionId` is in-memory only, so on the
// next mount the panel had no id to load and showed an empty chat even though
// the server still held the whole conversation. That pointer is what this
// module persists.
//
// It also carries `inflight`: true from the moment a turn is dispatched until
// the turn settles. A pointer restored with `inflight: true` means the page
// went away mid-turn — the approval gate's parked promise
// (simoneAiTransport `_pendingToolApprovals`) died with the page, so any action
// that was waiting for approval never ran. The restore surfaces that instead of
// leaving the user to guess (and retry a write that may already exist).
//
// Pure + store-injected on purpose: no direct `localStorage` reference, so the
// whole policy is unit-testable and a storage-less host (SSR, standalone
// simone without a DOM) degrades to a no-op instead of throwing.
// A pointer older than this is not a reload — it is a new visit. Restoring a
// week-old thread on a fresh open would be a surprise, not a recovery.
const $3a6176e6fab871f1$export$13a549c7a3b4cd94 = 86400000;
const $3a6176e6fab871f1$var$PREFIX = 'smbls.simone.thread';
const $3a6176e6fab871f1$export$9c89447e0db8b2f5 = (scope, tenantId, agentId)=>{
    const s = scope === 'addapp' || scope === 'dashboard' ? scope : 'general';
    const base = `${$3a6176e6fab871f1$var$PREFIX}.${s}.${tenantId || 'none'}`;
    return agentId ? `${base}.agent.${agentId}` : base;
};
const $3a6176e6fab871f1$export$3c34366a497b611 = (store, key, now = Date.now())=>{
    if (!store || !key) return null;
    let raw = null;
    try {
        raw = store.getItem(key);
    } catch (_) {
        return null;
    }
    if (!raw) return null;
    let val = null;
    try {
        val = JSON.parse(raw);
    } catch (_) {
        // A corrupt entry is not a pointer — drop it rather than throwing on every
        // mount from then on.
        try {
            store.removeItem(key);
        } catch (_) {}
        return null;
    }
    if (!val || typeof val !== 'object' || !val.id) return null;
    // A local `s-…` placeholder names no server conversation — there is nothing
    // to load it from, so it is not a restorable pointer.
    if (String(val.id).startsWith('s-')) return null;
    const ts = Number(val.ts) || 0;
    if (!ts || now - ts > $3a6176e6fab871f1$export$13a549c7a3b4cd94) return null;
    return {
        id: String(val.id),
        inflight: !!val.inflight,
        ts: ts
    };
};
const $3a6176e6fab871f1$export$3af82cf782128db9 = (store, key, id, inflight = false, now = Date.now())=>{
    if (!store || !key) return false;
    if (!id || String(id).startsWith('s-')) return $3a6176e6fab871f1$export$91165cb0586c7889(store, key);
    try {
        store.setItem(key, JSON.stringify({
            id: String(id),
            inflight: !!inflight,
            ts: now
        }));
        return true;
    } catch (_) {
        // Private mode / quota — persistence is a nicety, never a blocker.
        return false;
    }
};
const $3a6176e6fab871f1$export$91165cb0586c7889 = (store, key)=>{
    if (!store || !key) return false;
    try {
        store.removeItem(key);
        return true;
    } catch (_) {
        return false;
    }
};
const $3a6176e6fab871f1$export$8db641744a042606 = 'That answer stopped when the page reloaded. Anything that was waiting for your approval did not run. Check the result before you ask again.';
const $3a6176e6fab871f1$export$3076b83257f29f25 = (pointer, messages)=>{
    if (!pointer || !pointer.inflight) return false;
    const list = Array.isArray(messages) ? messages : [];
    if (!list.length) return false;
    const last = list[list.length - 1];
    if (!last) return false;
    if (last.role !== 'assistant') return true;
    return !String(last.text || '').trim();
};

});



parcelRegister("4QxwL", function(module, exports) {

$parcel$export(module.exports, "sendPrompt", () => $3876069eb669de3c$export$738cd2174f2d30ef);
// Transport-agnostic send. The active transport (ws.js / supabase.js / etc.)
// installs `window.__simoneSendOverBridge` during initBridge so this function
// doesn't have to know whether it's talking to a chrome.runtime port, a
// direct WebSocket, or a supabase realtime channel.

var $8eEEA = parcelRequire("8eEEA");
const $3876069eb669de3c$export$738cd2174f2d30ef = function(text, scope, images, attached, opts) {
    const trimmed = (text || '').trim();
    if (!trimmed) return;
    const root = this.state.root;
    // Build mode (root._aiBuildMode — the composer '+' menu toggle, 2026-09-02
    // per Nika "toggle which runs this functionality and opens that generated
    // page after output"): an armed send from ANY surface routes into the
    // addapp build pipeline. This transport hop is the one place every
    // sidebar/drawer send passes through, so the flip here covers them all;
    // the canvas composer (freestyle transport) branches in its own
    // _sendPrompt. Not re-flipped when the caller already says 'addapp'
    // (forceBuildApp, the /add-app page itself — that page arms its own
    // watcher or IS the surface).
    if (root && root._aiBuildMode && scope !== 'addapp' && scope !== 'dashboard') {
        scope = 'addapp';
        try {
            this.call('watchAiBuildOutput');
        } catch (_) {}
    }
    // THE BUILDER'S OWN THREAD is a builder turn, whichever chat sent it. The
    // general drawer can hold it (its History lists every workspace thread, and
    // the builder's is one), but the server marks the builder surface PER TURN:
    // a 'general' send there went as `workspace-shell` and lost the builder's
    // free first change (persona round 2d, marcus at 390 px: 442/389/388
    // credits quoted). While the builder is on screen on that same thread, the
    // send goes as 'addapp' with the app — its rows land in the builder chat,
    // so the drawer gives the screen back to it.
    if (root && (!scope || scope === 'general') && this.call('addAppBuilderThreadOpen', root) === true) {
        scope = 'addapp';
        if (root.assistantOpen) root.update({
            assistantOpen: false
        }, {
            preventFetch: true
        });
        try {
            this.call('addAppBuilderChatReveal');
        } catch (_) {}
    }
    // Prime the reply-speech audio element INSIDE this user gesture — autoplay
    // policy blesses an element that already played, which lets the spoken
    // reply (ElevenLabs) start even though it lands seconds after the click.
    try {
        this.call('primeSpeakAudio');
    } catch (_) {}
    // /add-app runs simone in its own project-scoped context — its buffer lives
    // under _ax_* and the turn is dispatched project-scoped (the active extension).
    // The general drawer/composer pass scope 'general' → the bare keys (no-op).
    const addapp = scope === 'addapp';
    // dashboard ('_db_') = the / inline-thread surface — its own thread, workspace-
    // scoped like 'general' but key-namespaced so it never collides with the drawer.
    const k = addapp ? '_ax_' : scope === 'dashboard' ? '_db_' : '';
    const projectId = addapp ? root._addAppProjectId || null : null;
    const id = `u-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
    // Snapshot the currently-picked elements onto the user message itself, so
    // the chip-stack stays visible in the message bubble even after we clear
    // the picker area for the next turn.
    const picked = root.pickedElements || [];
    const inspectedUrl = picked.length && picked[picked.length - 1].url || null;
    const inspectedTitle = picked.length && picked[picked.length - 1].title || null;
    const pageUrl = inspectedUrl || window.location && window.location.href || null;
    const pageTitle = inspectedTitle || document && document.title || null;
    // Image attachments for this turn. Normalized ONCE here, so the bubble and
    // the wire agree on exactly what was sent — a picture refused by the caps
    // must not appear as attached on a message the model never saw it on.
    const { attachments: attachments, rejected: rejected } = (0, $8eEEA.normalizeComposerImages)(images);
    const rejectedNote = (0, $8eEEA.describeRejectedImages)(rejected, (key)=>this.call('polyglot', key));
    const userMsg = {
        id: id,
        role: 'user',
        text: trimmed,
        ts: Date.now(),
        picked: picked.length ? picked.slice() : null,
        pageUrl: pageUrl,
        pageTitle: pageTitle,
        // Name/mime/size only — the base64 stays out of the message buffer (which
        // is persisted per session), and the thumbnails the composer already
        // rendered are the user's visual record of what went.
        attachments: attachments.length ? attachments.map((a)=>({
                name: a.name,
                mime: a.mime,
                size: a.size
            })) : null
    };
    const next = (root[k + 'chatMessages'] || []).concat(userMsg, // Say what was dropped, in the thread, at the moment it was dropped.
    rejectedNote ? [
        {
            id: `sys-${id}`,
            role: 'system',
            text: rejectedNote,
            ts: Date.now()
        }
    ] : []);
    // Turn off inspect/pick mode on send — the picked refs are snapshotted onto
    // the message above, so there's no reason to keep the page picker armed.
    // Mirrors togglePick's off-path (stop_pick to the page + picking:false).
    if (root.picking && typeof window.__ccSendToPage === 'function') try {
        window.__ccSendToPage({
            type: 'stop_pick'
        });
    } catch (_) {}
    // Clear the picker context — the snapshot is now on the message bubble.
    root.update({
        [k + 'chatMessages']: next,
        chatInput: '',
        [k + 'chatTyping']: true,
        picking: false,
        pickedElements: []
    });
    const send = typeof window.__simoneSendOverBridge === 'function' ? window.__simoneSendOverBridge : null;
    if (!send) {
        const errs = (root[k + 'chatMessages'] || []).concat({
            id: `err-${Date.now()}`,
            role: 'system',
            text: this.call('polyglot', 'workspace.simone.noBridge'),
            ts: Date.now()
        });
        root.update({
            [k + 'chatMessages']: errs,
            [k + 'chatTyping']: false
        });
        return;
    }
    // Second arg = live root handle for the sdk.ai transport
    // (simoneAiTransport): its install-time root can go stale across shell
    // remounts, which made assistant patches silently no-op (empty bubbles).
    // This root is resolved fresh at send time so it's always the rendering
    // tree. Passed OUTSIDE the envelope because DOMQL state can't be
    // serialized — the ws/chrome bridge transports take (envelope) only and
    // ignore extra args.
    send({
        id: id,
        type: 'user_message',
        text: trimmed,
        // Scope routes the turn: 'addapp' dispatches project-scoped to the active
        // extension (projectId); 'general' stays workspace-scoped.
        scope: scope || 'general',
        projectId: projectId,
        context: {
            pickedElements: picked,
            url: pageUrl,
            title: pageTitle,
            ...attached && typeof attached === 'object' ? {
                attached: attached
            } : {},
            ...opts && typeof opts.mode === 'string' ? {
                assistantMode: opts.mode
            } : {},
            ...opts && opts.resume === true ? {
                resume: true
            } : {}
        },
        // Attached images, `{ name, mime, size, dataUrl }` each. Added ONLY when
        // the turn carries one, so a text-only envelope is unchanged — the ws /
        // chrome bridge transports read `text` + `context` and ignore unknown
        // keys, and simoneAiTransport forwards this one to sdk.ai.
        ...attachments.length ? {
            attachments: attachments
        } : {}
    }, {
        stateRoot: root
    });
    // Sync the active session with the new message buffer (scoped).
    try {
        this.call('persistActiveSession', scope);
    } catch (_) {}
};

});

parcelRegister("oolN6", function(module, exports) {

$parcel$export(module.exports, "openExtensionPreview", () => $049521804ee5abf0$export$d27534e7d991afbb);
// openExtensionPreview — make every AI app build VISIBLE the moment it lands
// (2026-07-24 per Nika "when it builds app it should also always open preview").
//
// The client half of render_extension_page / create_app used to render ONLY
// into the /add-app canvas (window.__addAppHost); a build kicked off from any
// other surface (the home composer, the docked drawer on a page) queued
// silently with a "open the Add App surface" note. This registers the built
// app as a TRANSIENT preview page and opens it in the shell PageSlot beside
// the conversation — the same split sheet answer views use — so the user
// always SEES what was built, wherever they asked for it.
//
// The def renders through ExtensionEmbed (components/ExtensionEmbed.js): the
// same guarded iframe pipeline as the /add-app pane (audit → guarded parse →
// entity-scoped bridge → isolated realm). Nothing about the preview weakens
// the extension isolation model — the PageSlot page IS the iframe host.
//
// Route shape: '/x-preview/<slug>-<seq>' — seq keeps every render unique so
// the PageSlot keep-alive (same-path remounts are skipped) can never pin a
// stale build when the same app is iterated. Stored in root._aiAnswerPages —
// the same session-transient map answer views live in (PageSlot._defFor
// already resolves any route from it, and its pruning keeps the map bounded).
// metadata.__extensionApp carries { projectId, name } so the PageSlot header
// can offer "Add to Workspace" on preview routes, and the thread's view block
// its "Save as app" (functions/assistantThreadBlocks.js). `open: false` only
// registers the view (the main thread shows it inline).
const $049521804ee5abf0$var$MAX_ANSWER_PAGES = 8;
let $049521804ee5abf0$var$_previewSeq = 0;
const $049521804ee5abf0$var$_shellSlug = (title)=>String(title || 'app').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || 'app';
function $049521804ee5abf0$export$d27534e7d991afbb(payload = {}) {
    const el = this && this.getRoot ? this : arguments[0];
    const args = this && this.getRoot ? payload : arguments[1] || {};
    const name = String(args.name || 'App preview').trim() || 'App preview';
    const pages = Array.isArray(args.pages) ? args.pages : [];
    const source = typeof args.source === 'string' ? args.source : '';
    if (!source.trim() && !pages.length) return {
        ok: false,
        error: 'source or pages is required'
    };
    const root = el.getRootState?.() || el.state?.root || el.getRoot?.()?.state;
    if (!root || typeof root.update !== 'function') return {
        ok: false,
        error: "no root state \u2014 cannot open the app preview"
    };
    const projectId = args.projectId ? String(args.projectId) : null;
    const route = `/x-preview/${$049521804ee5abf0$var$_shellSlug(name)}-${++$049521804ee5abf0$var$_previewSeq}`;
    // IN-SHELL mount (2026-07-25 per Nika "it does not have to be in iframe"):
    // the preview def IS the audited/parsed/scoped app def, so it renders as a
    // native workspace view — live design system, house + module components.
    const built = pages.length ? el.call('buildInlineMultiPageDef', {
        name: name,
        pages: pages,
        entities: args.entities || []
    }) : el.call('buildInlineExtensionDef', {
        name: name,
        source: source,
        entities: Array.isArray(args.entities) ? args.entities : []
    });
    // A contained refusal (generatedAppContainment.js) still opens: the preview
    // shows the blocked-feature state, never any of the app's own code.
    if (!built || built.ok === false && !(built.blocked && built.def)) return {
        ok: false,
        error: built && built.error || 'build failed'
    };
    const def = {
        ...built.def,
        metadata: {
            ...built.def.metadata || {},
            title: name,
            __extensionApp: {
                projectId: projectId,
                name: name
            }
        }
    };
    const entries = Object.entries(root._aiAnswerPages || {}).slice(-($049521804ee5abf0$var$MAX_ANSWER_PAGES - 1));
    entries.push([
        route,
        def
    ]);
    // `open: false` — registered only, the split sheet stays shut: the MAIN
    // THREAD shows the preview inline as a view block (AI_ASSISTANT_SPEC §12.1
    // Apps, functions/simoneAiTransport.js).
    const open = args.open !== false;
    root.update(open ? {
        _aiAnswerPages: Object.fromEntries(entries),
        _canvasSlot: route,
        _slotFullscreen: null
    } : {
        _aiAnswerPages: Object.fromEntries(entries)
    }, {
        preventFetch: true
    });
    return {
        ok: true,
        opened: route,
        title: name,
        shown: open
    };
}

});

parcelRegister("6hzqH", function(module, exports) {

$parcel$export(module.exports, "openLightbox", () => $492fd02f329f7c86$export$78f5d28b604adfe0);
$parcel$export(module.exports, "closeLightbox", () => $492fd02f329f7c86$export$958d61a99dc20493);
// Lightbox open/close helpers — registered via context.functions so any
// element can dispatch them with:
//   el.call('openLightbox', { url, mime, name })
//   el.call('closeLightbox')
//
// AppLightbox lives as a body-only component (no backdrop, no positioning
// — those come from @symbo.ls/windows ModalLayer). State carrier remains
// `root.lightbox` so the body reads `s.root.lightbox?.{url,mime,name}` as
// before — only visibility moves to the layer.
const $492fd02f329f7c86$var$LIGHTBOX_LAYER_ID = 'app-lightbox';
const $492fd02f329f7c86$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
function $492fd02f329f7c86$export$78f5d28b604adfe0(opts) {
    if (!opts?.url) return;
    const root = $492fd02f329f7c86$var$_rootState(this);
    if (!root) return;
    root.update({
        lightbox: opts
    });
    // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
    // so the Close X can't be pushed off-screen by tall content / a short
    // viewport.
    // WS-MODAL-X-HORIZONTAL-OVERFLOW-1: the lightbox wants a WIDE window, so
    // the width goes on the layer descriptor (ModalLayer.js sizes ModalWindow
    // from it) instead of on the body. The body used to force `width: '90vw'`
    // inside a default-'H' window with `overflow: 'visible'` — it overflowed
    // the window, carrying its absolutely-positioned CloseBtn off-screen.
    this.call('openCustomModal', {
        id: $492fd02f329f7c86$var$LIGHTBOX_LAYER_ID,
        width: '90vw',
        maxWidth: '90vw',
        maxHeight: '90vh',
        content: {
            extends: 'AppLightbox'
        }
    });
}
function $492fd02f329f7c86$export$958d61a99dc20493() {
    const root = $492fd02f329f7c86$var$_rootState(this);
    root?.update({
        lightbox: null
    });
    this.call('closeModal', $492fd02f329f7c86$var$LIGHTBOX_LAYER_ID);
}

});

parcelRegister("11oY6", function(module, exports) {

$parcel$export(module.exports, "isOrgOnboardingSkipped", () => $0be940a5732348d5$export$1e13015bf5f68d95);
$parcel$export(module.exports, "openCreateOrgModal", () => $0be940a5732348d5$export$cc70a611e2ad8547);
$parcel$export(module.exports, "closeCreateOrgModal", () => $0be940a5732348d5$export$eed450769b9eaf64);
$parcel$export(module.exports, "openOnboardingWorkspaceModal", () => $0be940a5732348d5$export$4545bfc11760064);
$parcel$export(module.exports, "focusCreateOrgName", () => $0be940a5732348d5$export$1443cee26d0ce67c);
$parcel$export(module.exports, "usePersonalWorkspace", () => $0be940a5732348d5$export$c4cf1d97eb05a1b1);
$parcel$export(module.exports, "orgOnboardingOwnedByWelcome", () => $0be940a5732348d5$export$efc1fe57af884e09);
// Create-organization modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openCreateOrgModal')
//   el.call('closeCreateOrgModal')
//
// Migrated 2026-06-01 from `root.update({ _createOrgModalOpen: true })`
// to a @symbo.ls/windows custom-template layer. All `_createOrg*` state
// fields (name, slug, dirty, status, suggestion, conflict, error, busy)
// are RETAINED as data carriers — the body's reactive reads on them are
// unchanged. Only the visibility flag moves to the layer.
const $0be940a5732348d5$var$CREATE_ORG_LAYER_ID = 'create-org';
// Persisted "I chose to stay on my personal workspace" flag — set by
// `usePersonalWorkspace` so the onboarding gate (NoOrgOverlay) never re-opens
// the modal for this user on subsequent loads. (2026-06-17 per Nika.)
const $0be940a5732348d5$var$ONBOARDING_SKIP_KEY = 'symbols_org_onboarding_skipped';
const $0be940a5732348d5$export$1e13015bf5f68d95 = ()=>{
    try {
        return typeof localStorage !== 'undefined' && localStorage.getItem($0be940a5732348d5$var$ONBOARDING_SKIP_KEY) === '1';
    } catch  {
        return false;
    }
};
const $0be940a5732348d5$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
const $0be940a5732348d5$var$_resetFields = {
    _createOrgName: '',
    _createOrgSlug: '',
    _createOrgSlugDirty: false,
    _createOrgSlugChecking: false,
    _createOrgSlugStatus: null,
    _createOrgSlugSuggestion: null,
    _createOrgSlugConflict: null,
    _createOrgError: null,
    _createOrgBusy: false,
    // Onboarding mode (NoOrgOverlay gate): swaps Cancel for "Use personal
    // workspace" and the modal opens non-dismissable. Off for the normal
    // switcher / dashboard "+ Create workspace" path.
    _createOrgOnboarding: false
};
function $0be940a5732348d5$export$cc70a611e2ad8547() {
    const root = $0be940a5732348d5$var$_rootState(this);
    if (!root) return;
    // Reset the draft fields so reopening doesn't show a stale state.
    root.update($0be940a5732348d5$var$_resetFields);
    // MODAL-X-OVERFLOW-1: `openCustomModal` (shared/functions) supplies a
    // default `maxHeight` so a short viewport can't push ModalHeader (and its
    // Close X) off-screen with no scroll back to it — plain `openModal` here
    // used to leave that ceiling unset. Paired with AppCreateOrgModal's own
    // `maxHeight:'80vh'` root cap; the body's `Fields` region is what
    // actually scrolls.
    this.call('openCustomModal', {
        id: $0be940a5732348d5$var$CREATE_ORG_LAYER_ID,
        // THE DIALOG'S NAME (persona audit WL-9): @symbo.ls/windows names the
        // window by `aria-labelledby="modal-title-<id>"`, and with no `title` the
        // first heading carrying that id is the HIDDEN Confirm template's — the
        // dialog read as "Heading" / "Are you sure?". The title names it.
        title: this.call('polyglot', 'workspace.createOrg.title'),
        content: {
            extends: 'AppCreateOrgModal'
        }
    });
}
function $0be940a5732348d5$export$eed450769b9eaf64() {
    const root = $0be940a5732348d5$var$_rootState(this);
    // Clear all the draft fields back to defaults — matches what the old
    // `extraClose` map did when stateKey-driven `_createOrgModalOpen` flipped null.
    root?.update($0be940a5732348d5$var$_resetFields);
    this.call('closeModal', $0be940a5732348d5$var$CREATE_ORG_LAYER_ID);
}
function $0be940a5732348d5$export$4545bfc11760064() {
    const root = $0be940a5732348d5$var$_rootState(this);
    if (!root) return;
    root.update({
        ...$0be940a5732348d5$var$_resetFields,
        _createOrgOnboarding: true
    });
    // MODAL-X-OVERFLOW-1 (see openCreateOrgModal above) — doubly important
    // here: this variant is non-dismissable (no backdrop/ESC close), so a
    // header pushed off-screen would strand the user with no visible way out.
    this.call('openCustomModal', {
        id: $0be940a5732348d5$var$CREATE_ORG_LAYER_ID,
        dismissOnBackdrop: false,
        // Named by its title, as above (WL-9).
        title: this.call('polyglot', 'workspace.createOrg.title'),
        content: {
            extends: 'AppCreateOrgModal'
        }
    });
}
function $0be940a5732348d5$export$1443cee26d0ce67c(input) {
    const el = input || this;
    const node = el && el.node;
    if (!node || !node.isConnected || typeof node.focus !== 'function') return false;
    if (typeof node.closest === 'function' && node.closest('[inert]')) return false;
    const doc = node.ownerDocument;
    const active = doc && doc.activeElement;
    if (active && active !== node && active !== doc.body && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.isContentEditable)) return false;
    try {
        node.focus();
    } catch (_) {
        return false;
    }
    return !doc || doc.activeElement === node;
}
function $0be940a5732348d5$export$c4cf1d97eb05a1b1() {
    const root = $0be940a5732348d5$var$_rootState(this);
    try {
        if (typeof localStorage !== 'undefined') localStorage.setItem($0be940a5732348d5$var$ONBOARDING_SKIP_KEY, '1');
    } catch (err) {
        console.warn('[onboarding] failed to persist personal-workspace choice:', err);
    }
    root?.update({
        ...$0be940a5732348d5$var$_resetFields,
        _orgOnboardingSkipped: true
    });
    this.call('closeModal', $0be940a5732348d5$var$CREATE_ORG_LAYER_ID);
}
function $0be940a5732348d5$export$efc1fe57af884e09(root) {
    const NEW_ACCOUNT_MS = 1209600000;
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return false;
    if (r._onboardingDecision) return true;
    const prefs = r.userPrefs && typeof r.userPrefs === 'object' ? r.userPrefs : null;
    if (prefs && prefs.onboarding && typeof prefs.onboarding === 'object') return true;
    const user = r.user && typeof r.user === 'object' ? r.user : null;
    const created = user && user.createdAt ? Date.parse(user.createdAt) : NaN;
    if (!Number.isFinite(created)) return false;
    return Date.now() - created <= NEW_ACCOUNT_MS;
}

});

parcelRegister("fAXoF", function(module, exports) {

$parcel$export(module.exports, "isWhitelabelNonMember", () => $b5a84ac711796f6b$export$5009efd6880997ef);
$parcel$export(module.exports, "isWhitelabelNonMemberGateActive", () => $b5a84ac711796f6b$export$dc4be6fb9628a44a);
// The signed-in NON-MEMBER predicate for a white-label host — the ONE
// definition, shared by the gate component (WhitelabelRequestAccess) and
// every shell surface that must stand down while the gate is up
// (CreditBlocker was the first: its "out of credits" overlay painted over
// the request-access card, measured on app.bellforge.eu 2026-08-31).
//
// Fail closed on every unknown, exactly as the component documents: no
// auth, no brand, no pin, or orgs not yet loaded all answer false.

var $lb2Ei = parcelRequire("lb2Ei");

var $gNttC = parcelRequire("gNttC");
const $b5a84ac711796f6b$export$5009efd6880997ef = (root)=>{
    if (!root || !root._authReady || !root.signedIn) return false;
    if (!root.whitelabelBrand) return false;
    // The root MIRROR first (customDomainBoot writes it the moment the scope
    // lands, and subscribeTo re-fires on it); the module pin stays as the
    // fallback for any boot that predates the mirror.
    const pin = root._hostScopeOrgId || (0, $gNttC.getHostScopeOrgId)();
    if (!pin) return false;
    const orgs = Array.isArray(root.orgs) ? root.orgs : null;
    if (!orgs) return false;
    return !orgs.some((o)=>o && String(o.id || o._id) === pin);
};
const $b5a84ac711796f6b$export$dc4be6fb9628a44a = function(root) {
    return (0, $lb2Ei.isCustomDomainHost)() && $b5a84ac711796f6b$export$5009efd6880997ef(root);
};

});

parcelRegister("kKK1U", function(module, exports) {

$parcel$export(module.exports, "isUsernamePromptDone", () => $f1bbcf0f1946c900$export$86210175e8606c73);
$parcel$export(module.exports, "isUsernamePromptPendingPersisted", () => $f1bbcf0f1946c900$export$50e126336f0f338e);
$parcel$export(module.exports, "persistUsernamePromptPending", () => $f1bbcf0f1946c900$export$57f965abd075f30f);
$parcel$export(module.exports, "openUsernamePrompt", () => $f1bbcf0f1946c900$export$bfd87c7ceca3460b);
$parcel$export(module.exports, "closeUsernamePrompt", () => $f1bbcf0f1946c900$export$e0d4b01545eb1441);
$parcel$export(module.exports, "skipUsernamePrompt", () => $f1bbcf0f1946c900$export$17d8cbeeebb40e91);
$parcel$export(module.exports, "saveUsernamePrompt", () => $f1bbcf0f1946c900$export$481c91386bdeac86);
// Username prompt — the INVITEE onboarding step (INVITE-ONBOARDING-
// USERNAME-NOT-ORG-1). A user who joined via an invite must never be
// pushed into org creation (they just joined one); instead they get this
// LIGHT, dismissable nudge to pick their handle — the username the server
// auto-derived from their email until now.
//
// Mirrors createOrgModal.js's open/close mechanics (@symbo.ls/windows
// custom-template layer via openCustomModal) and its localStorage
// persistence convention (symbols_org_onboarding_skipped) so the prompt
// shows at most once per user+browser, however it is resolved.
//
// Trigger contract: the accept-invite page raises `_usernamePromptPending`
// on root state after a live (no-reload) switch, or persists the PENDING
// key before its hard-reload fallback; UsernamePromptGate watches both and
// opens the layer once. Skip and save both persist the DONE key.
const $f1bbcf0f1946c900$var$USERNAME_PROMPT_LAYER_ID = 'username-prompt';
const $f1bbcf0f1946c900$var$USERNAME_PROMPT_DONE_KEY = 'symbols_username_prompt_done';
const $f1bbcf0f1946c900$var$USERNAME_PROMPT_PENDING_KEY = 'symbols_username_prompt_pending';
const $f1bbcf0f1946c900$export$86210175e8606c73 = ()=>{
    try {
        return typeof localStorage !== 'undefined' && localStorage.getItem($f1bbcf0f1946c900$var$USERNAME_PROMPT_DONE_KEY) === '1';
    } catch  {
        return false;
    }
};
const $f1bbcf0f1946c900$export$50e126336f0f338e = ()=>{
    try {
        return typeof localStorage !== 'undefined' && localStorage.getItem($f1bbcf0f1946c900$var$USERNAME_PROMPT_PENDING_KEY) === '1';
    } catch  {
        return false;
    }
};
function $f1bbcf0f1946c900$export$57f965abd075f30f() {
    try {
        if (typeof localStorage !== 'undefined') localStorage.setItem($f1bbcf0f1946c900$var$USERNAME_PROMPT_PENDING_KEY, '1');
    } catch  {
    /* pending marker is best-effort — the live-path root flag still works */ }
}
const $f1bbcf0f1946c900$var$_markDone = ()=>{
    try {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem($f1bbcf0f1946c900$var$USERNAME_PROMPT_DONE_KEY, '1');
            localStorage.removeItem($f1bbcf0f1946c900$var$USERNAME_PROMPT_PENDING_KEY);
        }
    } catch  {
    /* the root flag below still stops re-opens this session */ }
};
const $f1bbcf0f1946c900$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
const $f1bbcf0f1946c900$var$_usernamePromptResetFields = {
    _unamePromptDraft: '',
    _unamePromptBusy: false,
    _unamePromptError: null,
    _unamePromptStatus: 'idle',
    _unamePromptReason: null
};
function $f1bbcf0f1946c900$export$bfd87c7ceca3460b() {
    const root = $f1bbcf0f1946c900$var$_rootState(this);
    if (!root) return;
    root.update({
        ...$f1bbcf0f1946c900$var$_usernamePromptResetFields,
        _unamePromptDraft: root.currentUserUsername || '',
        _usernamePromptPending: false
    });
    // Dismissable ON PURPOSE — this is a nudge, not a gate ("slightly ask",
    // Nika 2026-08-26). Backdrop/ESC close counts as skip-for-now (no DONE
    // key), so it can return next boot only while the PENDING key stands.
    this.call('openCustomModal', {
        id: $f1bbcf0f1946c900$var$USERNAME_PROMPT_LAYER_ID,
        content: {
            extends: 'AppUsernamePrompt'
        }
    });
}
function $f1bbcf0f1946c900$export$e0d4b01545eb1441() {
    const root = $f1bbcf0f1946c900$var$_rootState(this);
    root?.update($f1bbcf0f1946c900$var$_usernamePromptResetFields);
    this.call('closeModal', $f1bbcf0f1946c900$var$USERNAME_PROMPT_LAYER_ID);
}
function $f1bbcf0f1946c900$export$17d8cbeeebb40e91() {
    $f1bbcf0f1946c900$var$_markDone();
    const root = $f1bbcf0f1946c900$var$_rootState(this);
    root?.update({
        ...$f1bbcf0f1946c900$var$_usernamePromptResetFields,
        _usernamePromptPending: false
    });
    this.call('closeModal', $f1bbcf0f1946c900$var$USERNAME_PROMPT_LAYER_ID);
}
async function $f1bbcf0f1946c900$export$481c91386bdeac86() {
    const root = $f1bbcf0f1946c900$var$_rootState(this);
    if (!root || root._unamePromptBusy) return;
    const draft = String(root._unamePromptDraft || '').trim().toLowerCase();
    if (!draft) {
        // KEY-IN-STATE: the Hint resolves `_unamePromptError` through polyglot, which
        // returns a server-supplied message (the `msg` fallback below) verbatim.
        root.update({
            _unamePromptError: 'workspace.username.error.required'
        });
        return;
    }
    if (draft === (root.currentUserUsername || '')) {
        // No change — same outcome as an explicit keep.
        $f1bbcf0f1946c900$export$17d8cbeeebb40e91.call(this);
        return;
    }
    root.update({
        _unamePromptBusy: true,
        _unamePromptError: null
    });
    try {
        const sdk = this.sdk || this.getRoot?.()?.sdk;
        await sdk.updateMe({
            username: draft
        });
        $f1bbcf0f1946c900$var$_markDone();
        root.update({
            ...$f1bbcf0f1946c900$var$_usernamePromptResetFields,
            currentUserUsername: draft,
            _usernamePromptPending: false
        });
        this.call('closeModal', $f1bbcf0f1946c900$var$USERNAME_PROMPT_LAYER_ID);
    } catch (err) {
        const msg = String(err?.message || '');
        root.update({
            _unamePromptBusy: false,
            _unamePromptError: /taken|exists|unavailable|duplicate/i.test(msg) ? 'workspace.username.taken' : msg || 'workspace.username.error.saveFailed'
        });
    }
}

});

parcelRegister("2Ew84", function(module, exports) {

$parcel$export(module.exports, "onboardingEligible", () => $1ee83d5da5d9dd72$export$b6423357d60dc542);
$parcel$export(module.exports, "onboardingFacts", () => $1ee83d5da5d9dd72$export$98f4d3b894ffeb0b);
$parcel$export(module.exports, "onboardingHoldNeeded", () => $1ee83d5da5d9dd72$export$94d0121eda693c8d);
$parcel$export(module.exports, "onboardingTick", () => $1ee83d5da5d9dd72$export$ded98d6059652c27);
$parcel$export(module.exports, "onboardingGateStop", () => $1ee83d5da5d9dd72$export$9e29cc1b5297d8e5);
$parcel$export(module.exports, "openOnboarding", () => $1ee83d5da5d9dd72$export$92f9135f02fb432d);
$parcel$export(module.exports, "onboardingCloseDecision", () => $1ee83d5da5d9dd72$export$e8dc3583d952fe4e);
$parcel$export(module.exports, "closeOnboarding", () => $1ee83d5da5d9dd72$export$577300fecfa4e440);
$parcel$export(module.exports, "onboardingSkip", () => $1ee83d5da5d9dd72$export$cc154070e70ecf35);
$parcel$export(module.exports, "onboardingDocumentKeydown", () => $1ee83d5da5d9dd72$export$e6f8987906ef61c7);
$parcel$export(module.exports, "onboardingChoose", () => $1ee83d5da5d9dd72$export$ce25796851e14df9);
$parcel$export(module.exports, "onboardingReplay", () => $1ee83d5da5d9dd72$export$998a9d60a78af7b6);
$parcel$export(module.exports, "onboardingDecide", () => $1ee83d5da5d9dd72$export$8ff4e8d6b2db10e);
$parcel$export(module.exports, "onboardingNoteFlyArrival", () => $1ee83d5da5d9dd72$export$9a58dc11dceb3e17);
$parcel$export(module.exports, "onboardingFirstName", () => $1ee83d5da5d9dd72$export$3c3ca2dd1e7a0daa);
$parcel$export(module.exports, "onboardingWorkspaceName", () => $1ee83d5da5d9dd72$export$c0b2df8ac8319503);
$parcel$export(module.exports, "onboardingText", () => $1ee83d5da5d9dd72$export$4526b0cf0f3dc074);
$parcel$export(module.exports, "onboardingLanguage", () => $1ee83d5da5d9dd72$export$c595e8b6d92aa2d6);
$parcel$export(module.exports, "onboardingSetWorkspaceLanguage", () => $1ee83d5da5d9dd72$export$181ab2c4fa5dad92);
$parcel$export(module.exports, "onboardingPlan", () => $1ee83d5da5d9dd72$export$13a0bd2c8a6985a);
$parcel$export(module.exports, "onboardingQuestion", () => $1ee83d5da5d9dd72$export$617c78c79c3b9867);
$parcel$export(module.exports, "onboardingProgress", () => $1ee83d5da5d9dd72$export$d26276cf8e98bd49);
$parcel$export(module.exports, "onboardingChatStart", () => $1ee83d5da5d9dd72$export$c628ae7fd5065017);
$parcel$export(module.exports, "onboardingApply", () => $1ee83d5da5d9dd72$export$f732b6b5c3fde254);
$parcel$export(module.exports, "onboardingChatAnswer", () => $1ee83d5da5d9dd72$export$64af0a13e8791c5d);
$parcel$export(module.exports, "onboardingChatSkip", () => $1ee83d5da5d9dd72$export$db17b9122cf4b16e);
$parcel$export(module.exports, "onboardingChatTyped", () => $1ee83d5da5d9dd72$export$d7cf0d26f9e0b176);
$parcel$export(module.exports, "onboardingFocusAnswer", () => $1ee83d5da5d9dd72$export$5e5863eb76fdbdb9);
$parcel$export(module.exports, "onboardingChatHandoff", () => $1ee83d5da5d9dd72$export$4d1c10955527c529);
// onboarding.js — THE NEW-ACCOUNT WELCOME (Nika 2026-10-18: "make nicer user
// experience when new accounts join - help them personalize home page, switch
// language etc. … allow onboarding assistant, tour and skipping"; then "it
// should be wizard like onboarding and click based onboarding could be
// possible … avoid showing complex ui at first load").
//
// ONE moment, once per person. A NEW account (created within the last 14
// days) that has made no onboarding decision yet meets a full-screen setup
// surface on its home (components/OnboardingWizard.js: OnboardingGate →
// OnboardingWizard) — before the busy home: while its record is read the
// surface already holds the screen (onboardingHoldNeeded). From the greeting:
//
//   • THE WIZARD (Get started) — a few click steps, each a real choice:
//     the apps the home shows, the personal look,
//     the home's summary and App strip (functions/onboardingWizard.js).
//   • THE ASSISTANT — the same choices as a short conversation on the same
//     surface (onboardingChat*). A typed question hands off to the real
//     assistant (homeAiSend, the composer's own path).
//   • THE TOUR — six stops over the real chrome (functions/onboardingTour.js).
//   • SKIP — "Skip setup" at every step, each question's own skip, the tour's
//     "Skip tour", Escape. A skip is final: the welcome never comes back by
//     itself. The Personalise panel's "Getting started" group replays the
//     wizard, the assistant and the tour on demand.
//
// Every choice applies AT ONCE through the writers the Personalise panel
// already uses (homeLookSet / homeLookSetTheme / the board's own hide), so
// what the person picks is what the home shows when the surface leaves.
//
// PERSONAL SETUP is separate from workspace creation and administration.
// Fly owns signup, the Blueprint and provisioning. This flow uses the existing
// workspace and its language, and changes only this person's preferences.
// Workspace-wide language changes belong in workspace settings.
//
// THE DECISION is one bag on the user record, `user_preferences.onboarding`:
//   { v: 1, status: 'done' | 'skipped', via: 'wizard' | 'assistant' | 'tour' |
//     'skip' | 'ask' | 'fly' | 'pob', at: ISO, origin?: 'fly' | 'pob' }
//     (records of the first release may also say 'personalize' — any record
//     but a pending one, Fly's or a personalized sign-up's, is a decision;
//     `origin: 'fly'` marks a Fly sign-up whose decision was not `via: 'fly'`,
//     the tour's; `origin: 'pob'` the same for a personalized sign-up)
// Written the way homeLook writes (the home-prefs durability law): this
// session's copy first (`root._onboardingDecision`), then this device's copy
// (localStorage `symbols_onboarding:<userId>`), then the record on the
// SINGLE-FLIGHT queue every user_preferences writer shares
// (`root.__navbarSaveQueue`), the payload composed at SEND time from the live
// row (the update replaces the row). The first decision of a session wins; a
// replay never writes.
//
// A FLY ARRIVAL (Nika 2026-10-25, "Short ready screen (Recommended)"): a person
// who signed up through Fly has answered the workspace's questions already —
// industry, idea, company — so the full wizard never opens for them. Fly
// leaves `{ v: 1, status: 'pending', via: 'fly', at }` on the record instead,
// and the first load of the workspace shows ONE "Your workspace is ready"
// screen (functions/onboardingReady.js, components/OnboardingReadyStep.js):
// what Fly made, the tour offer and a plain close. `done` is written only
// after that screen really showed — `via: 'fly'` on close, `via: 'tour'` when
// the tour starts — and Fly's checklist reads `status === 'done'` only. Every
// other record, Fly's `done` of the first release included, stays a decision
// with no screen. The screen opens on the home AND on the app builder
// (`/add-app?prompt=…&fly=`), over the build thread: the build keeps running
// behind it and closing the screen shows the thread.
//
// A PERSONALIZED SIGN-UP (POB, PLAN §7b-2): a person who signed up with their
// website read never meets the wizard either. The SERVER writes `{ v: 1,
// status: 'pending', via: 'pob', at }` at sign-up, write-once (the client
// never writes it), and the first load of the workspace opens the BUILD BOARD
// on the same surface (functions/onboardingBuild.js,
// components/OnboardingBuildStep.js): one card per server step. `done, via
// 'pob'` is written when the board closes after every step has an outcome;
// a workspace with no board (404) shows nothing and the record waits. THE
// SIGN-UP RACE (POB lead 2026-10-30): a Fly write can win that write-once
// record. A pending Fly record on the HOME therefore asks the board first
// when this SDK can read it: a board (200) opens the board; none, or no
// answer in time, opens Fly's ready screen as before. The app builder, and an
// SDK without the read, open the ready screen at once.
//
// FRANK: every export is self-contained (FA204) — the vocabularies, the
// windows and the keys are restated where they are used; siblings are reached
// through `this.call`.
// Bare shared-library import, read only at CALL time (never at module scope) —
// the same deferred read pages/admin/workspace-settings.js makes for the
// language registry (a module-scope read of a declared library value is a
// stub phantom under frank).

var $1X0Je = parcelRequire("1X0Je");
function $1ee83d5da5d9dd72$export$b6423357d60dc542(root, facts) {
    const NEW_ACCOUNT_MS = 1209600000;
    const f = facts && typeof facts === 'object' ? facts : {};
    const r = root && typeof root === 'object' ? root : null;
    if (!r || !r._authReady || !r.signedIn) return {
        ok: false,
        reason: 'auth'
    };
    if (r._onboardingDecision) return {
        ok: false,
        reason: 'decided'
    };
    if (f.deviceDecided) return {
        ok: false,
        reason: 'decided'
    };
    const prefs = r.userPrefs;
    // The record is the authority: no answer from the row yet, no welcome (a
    // person who skipped on another device must never see it flash here).
    if (!prefs || typeof prefs !== 'object') return {
        ok: false,
        reason: 'prefs'
    };
    const record = prefs.onboarding && typeof prefs.onboarding === 'object' ? prefs.onboarding : null;
    // THE PENDING WELCOMES — the only records that are not a decision: Fly
    // answered the questions and owes the person the ready screen; a
    // personalized sign-up (POB) owes the build board. The record is the proof,
    // so the new-account window below does not apply (an older account that ran
    // Make it real on its workspace is owed it too).
    const pending = !!(record && record.status === 'pending');
    const owedFly = pending && record.via === 'fly';
    const owedPob = pending && record.via === 'pob';
    const owed = owedFly || owedPob;
    if (record && !owed) return {
        ok: false,
        reason: 'decided'
    };
    // A Fly arrival whose record holds no welcome: Fly asked this person every
    // question already, so the full wizard stays closed for the load.
    if (!record && r._onboardingFlyArrival) return {
        ok: false,
        reason: 'fly'
    };
    if (!owed) {
        const user = r.user && typeof r.user === 'object' ? r.user : null;
        const created = user && user.createdAt ? Date.parse(user.createdAt) : NaN;
        if (!Number.isFinite(created)) return {
            ok: false,
            reason: 'account'
        };
        const now = typeof f.now === 'number' ? f.now : Date.now();
        if (now - created > NEW_ACCOUNT_MS) return {
            ok: false,
            reason: 'account'
        };
    }
    const ws = r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    if (!ws || !(ws.id || ws._id) || ws._shape !== 'full') return {
        ok: false,
        reason: 'workspace'
    };
    if (r._wsSwitching || r._wpSwitching || r._dataLoading) return {
        ok: false,
        reason: 'switching'
    };
    // The invitee's username nudge comes first (functions/usernamePrompt.js);
    // org creation never meets a workspace here (NoOrgOverlay).
    if (r._inviteFlowActive || r._usernamePromptPending) return {
        ok: false,
        reason: 'gate'
    };
    // An immersive module owns this person's chrome (bellforge class): its
    // surface is the module's, and the shell's tour stops do not exist there.
    if (f.immersive) return {
        ok: false,
        reason: 'immersive'
    };
    // The full welcome acts on the home (its look and home steps); the ready
    // screen asks nothing of the page, so it also opens where Fly's idea
    // hand-over lands: the app builder, over the build thread. The build board
    // is the workspace's first screen: the home.
    if (!f.onHome && !(owedFly && f.onBuilder)) return {
        ok: false,
        reason: 'route'
    };
    if (r._homeCustomizeMode || r._canvasSlot || r._canvasSlotSecond) return {
        ok: false,
        reason: 'busy'
    };
    if (f.overlayOpen) return {
        ok: false,
        reason: 'overlay'
    };
    if (owedFly && f.setupHolds) return {
        ok: false,
        reason: 'setup'
    };
    return {
        ok: true,
        reason: owedPob ? 'pob-build' : owedFly ? 'fly-ready' : 'new-account'
    };
}
function $1ee83d5da5d9dd72$export$98f4d3b894ffeb0b(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const call = (name, ...args)=>{
        try {
            const fns = el && el.context && el.context.functions;
            return fns && typeof fns[name] === 'function' ? el.call(name, ...args) : undefined;
        } catch (_) {
            return undefined;
        }
    };
    const path = String(r && r.currentPath || '');
    const stripped = call('stripWorkspacePrefix', path);
    const rest = typeof stripped === 'string' ? stripped : path;
    // The assistant's MAIN layer is page content to the welcome (it opens over
    // the home for anyone who asked something); only a real layer above the
    // page — a modal, a dropdown, the open search — makes the welcome wait.
    const layer = call('shellOverlayOpen');
    const userId = String(r && r.currentUserId || '');
    let deviceDecided = false;
    try {
        const store = typeof localStorage !== 'undefined' ? localStorage : null;
        deviceDecided = !!(store && userId && store.getItem('symbols_onboarding:' + userId));
    } catch (_) {
        deviceDecided = false;
    }
    return {
        now: Date.now(),
        onHome: rest === '/' || rest === '',
        // the app builder — where Fly's idea hand-over lands (/add-app?prompt=…&fly=).
        // Read from the stripped route AND from the raw path (inboundPromptForBuilder
        // reads the `/w/<org>[/<ws>]` prefix itself): the strip needs the workspace
        // handle resolver to know segment 2, and an unknown handle would leave
        // `/<handle>/add-app` — a builder the screen then never meets.
        onBuilder: rest === '/add-app' || rest === '/add-app/' || call('inboundPromptForBuilder', path) === true,
        overlayOpen: layer === 'modalRoot' || layer === 'dropdown' || layer === 'search',
        immersive: !!call('moduleImmersiveActive', r),
        deviceDecided: deviceDecided,
        // the workspace still builds itself (WS1): the ready screen waits for it
        setupHolds: !!call('workspaceSetupHoldsReady', r)
    };
}
function $1ee83d5da5d9dd72$export$94d0121eda693c8d(root, facts) {
    const NEW_ACCOUNT_MS = 1209600000;
    const f = facts && typeof facts === 'object' ? facts : {};
    const r = root && typeof root === 'object' ? root : null;
    if (!r || !r._authReady || !r.signedIn) return false;
    if (r._onboardingDecision || f.deviceDecided || r._onboardingFlow) return false;
    // A Fly arrival goes straight on: no calm "loading your preferences" surface
    // for a person Fly just handed over (the record, once read, opens the ready
    // screen or nothing — never the full wizard).
    if (r._onboardingFlyArrival) return false;
    if (r.userPrefs && typeof r.userPrefs === 'object') return false;
    const user = r.user && typeof r.user === 'object' ? r.user : null;
    const created = user && user.createdAt ? Date.parse(user.createdAt) : NaN;
    if (!Number.isFinite(created)) return false;
    const now = typeof f.now === 'number' ? f.now : Date.now();
    if (now - created > NEW_ACCOUNT_MS) return false;
    if (r._wsSwitching || r._wpSwitching) return false;
    if (r._inviteFlowActive || r._usernamePromptPending) return false;
    if (f.immersive || !f.onHome) return false;
    return true;
}
function $1ee83d5da5d9dd72$export$ded98d6059652c27() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const HOLD_MS = 6000;
    const WAIT = [
        'overlay',
        'busy',
        'switching'
    ];
    // looked at again on the slow timer: the waits above, and the setup's hold
    // (its windows and its first build's state move without a key the gate
    // follows) — the setup never keeps the calm surface up over its own thread
    const LOOK_AGAIN = WAIT.concat([
        'setup'
    ]);
    const facts = el.call('onboardingFacts', root);
    const release = ()=>{
        if (el.__onboardingHoldTimer) {
            clearTimeout(el.__onboardingHoldTimer);
            el.__onboardingHoldTimer = null;
        }
        if (root._onboardingHold) root.update({
            _onboardingHold: false
        }, {
            preventFetch: true
        });
    };
    if (el.__onboardingShown) {
        if (root._onboardingHold) release();
        return false;
    }
    const verdict = el.call('onboardingEligible', root, facts) || {};
    if (verdict.ok) {
        el.__onboardingShown = true;
        if (el.__onboardingTimer) {
            clearTimeout(el.__onboardingTimer);
            el.__onboardingTimer = null;
        }
        if (el.__onboardingHoldTimer) {
            clearTimeout(el.__onboardingHoldTimer);
            el.__onboardingHoldTimer = null;
        }
        // Fly's pending welcome: the ready screen (it reads its one slow fact,
        // freezes what it shows, then opens — functions/onboardingReady.js). A
        // personalized sign-up's: the build board (it reads the board first —
        // functions/onboardingBuild.js). The sign-up race: on the home, a pending
        // Fly record asks the board first (a 200 is a personalized sign-up) when
        // this SDK can read it — the feature gate is the method itself.
        if (verdict.reason === 'fly-ready') {
            const fns = el.context && el.context.functions || {};
            let sdk = null;
            if (typeof fns.getSDK === 'function') try {
                sdk = el.call('getSDK');
            } catch (_) {
                sdk = null;
            }
            const canRead = !!(sdk && sdk.isNullClient !== true && typeof sdk.getOnboardingBuild === 'function');
            if (facts && facts.onHome && canRead) el.call('onboardingBuildOpen', {
                orElse: 'ready'
            });
            else el.call('onboardingReadyOpen');
        } else if (verdict.reason === 'pob-build') el.call('onboardingBuildOpen');
        else el.call('openOnboarding', 'welcome');
        return true;
    }
    // Still reading the record of a new account: hold the calm surface, once,
    // for at most HOLD_MS — a record that never answers must not trap the home.
    if (!el.__onboardingHoldSpent && el.call('onboardingHoldNeeded', root, facts)) {
        if (!root._onboardingHold) {
            root.update({
                _onboardingHold: true
            }, {
                preventFetch: true
            });
            el.__onboardingHoldTimer = setTimeout(()=>{
                el.__onboardingHoldTimer = null;
                el.__onboardingHoldSpent = true;
                const r = el.state && el.state.root;
                if (r && r._onboardingHold && !r._onboardingFlow) r.update({
                    _onboardingHold: false
                }, {
                    preventFetch: true
                });
            }, HOLD_MS);
        }
    } else if (root._onboardingHold && !root._onboardingFlow && WAIT.indexOf(verdict.reason) === -1) // Decided, not new, not the home: the home shows.
    release();
    if (LOOK_AGAIN.indexOf(verdict.reason) !== -1 && !el.__onboardingTimer) el.__onboardingTimer = setTimeout(()=>{
        el.__onboardingTimer = null;
        el.call('onboardingTick');
    }, 2500);
    return false;
}
function $1ee83d5da5d9dd72$export$9e29cc1b5297d8e5() {
    const el = this;
    if (el && el.__onboardingTimer) {
        clearTimeout(el.__onboardingTimer);
        el.__onboardingTimer = null;
    }
    if (el && el.__onboardingHoldTimer) {
        clearTimeout(el.__onboardingHoldTimer);
        el.__onboardingHoldTimer = null;
    }
    const root = el && el.state && el.state.root;
    if (root && root._onboardingHold && typeof root.update === 'function') root.update({
        _onboardingHold: false
    }, {
        preventFetch: true
    });
}
function $1ee83d5da5d9dd72$export$92f9135f02fb432d(step, opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const o = opts && typeof opts === 'object' ? opts : {};
    const STEPS = [
        'welcome',
        'work',
        'stack',
        'idea',
        'language',
        'apps',
        'look',
        'home',
        'done',
        'assistant',
        'ready',
        'build'
    ];
    const flow = {
        step: STEPS.indexOf(step) !== -1 ? step : 'welcome',
        replay: !!o.replay,
        progressed: false,
        picked: {},
        picks: {},
        turns: [],
        ask: null,
        answered: 0,
        seq: 0,
        busy: false
    };
    // The ready screen shows what Fly made, frozen at the moment it opens: a
    // row that landed later would shift a screen the person is reading.
    if (flow.step === 'ready') flow.made = o.made && typeof o.made === 'object' ? o.made : {
        apps: [],
        site: null
    };
    root.update({
        _onboardingFlow: flow,
        _homeCustomizeMode: false,
        _homeCustomizeDrawerTucked: false,
        ...root._onboardingHold ? {
            _onboardingOpen: true,
            _onboardingHold: false
        } : {}
    }, {
        preventFetch: true
    });
    // The three choices' reads (an owner/admin): the preset registry — which
    // also settles whether this host's SDK can apply presets — and the App
    // Store's apps (functions/onboardingPresets.js). The ready screen and the
    // build board ask none of the three: Fly or the sign-up answered them.
    if (flow.step !== 'ready' && flow.step !== 'build') el.call('onboardingPresetsPrime', root);
    if (flow.step === 'assistant') el.call('onboardingChatStart');
    setTimeout(()=>{
        if (root._onboardingFlow && !root._onboardingOpen) root.update({
            _onboardingOpen: true
        }, {
            preventFetch: true
        });
    }, 30);
    el.call('onboardingWizardFocus');
    return true;
}
function $1ee83d5da5d9dd72$export$e8dc3583d952fe4e(flow, opened, settled) {
    const f = flow && typeof flow === 'object' ? flow : null;
    if (!f || f.replay) return null;
    if (f.step === 'ready') return opened === false ? null : {
        status: 'done',
        via: 'fly'
    };
    if (f.step === 'build') return opened !== false && settled === true ? {
        status: 'done',
        via: 'pob'
    } : null;
    if (f.step === 'assistant' && f.answered > 0) return {
        status: 'done',
        via: 'assistant'
    };
    if (f.progressed || f.answered > 0) return {
        status: 'done',
        via: 'wizard'
    };
    return {
        status: 'skipped',
        via: 'skip'
    };
}
function $1ee83d5da5d9dd72$export$577300fecfa4e440(reason) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const flow = root._onboardingFlow && typeof root._onboardingFlow === 'object' ? root._onboardingFlow : null;
    const why = typeof reason === 'string' ? reason : 'close';
    const wasOpen = !!root._onboardingOpen;
    if (flow && (why === 'close' || why === 'skip')) {
        // the build board decides only once it settled (its own view says so)
        const view = flow.step === 'build' ? el.call('onboardingBuildView', root) || {} : null;
        const settled = !!(view && view.ctaShown);
        const d = el.call('onboardingCloseDecision', flow, !!root._onboardingOpen, settled);
        if (d) el.call('onboardingDecide', d.status, d.via);
    }
    // The held app picks are the person's: a close keeps them, like every pick
    // the wizard already applied.
    if (flow && flow.step === 'apps') el.call('onboardingWizardApplyApps');
    // "Skip" never loses an earlier answer: a work pick that was not sent yet
    // goes now, with Your apps as they stand (once per flow — a no-op after the
    // send); a finished apply's lines leave with the welcome
    // (functions/onboardingPresets.js).
    if (flow) {
        el.call('onboardingStackSend');
        el.call('onboardingSetupRelease');
        // …and a typed workspace name is the person's too (round 2 BLOCKER #5):
        // it lands on the first workspace whatever closed the welcome.
        el.call('onboardingNameSave');
    }
    root.update({
        _onboardingOpen: null,
        _onboardingHold: false
    }, {
        preventFetch: true
    });
    if (wasOpen && (why === 'close' || why === 'skip')) {
        const idea = String(flow && flow.picks && flow.picks.idea || '').trim();
        const host = typeof el.getRoot === 'function' && el.getRoot() || el;
        setTimeout(()=>host.call('onboardingExitToComposer', idea), 320);
    }
    return true;
}
function $1ee83d5da5d9dd72$export$cc154070e70ecf35() {
    return this.call('closeOnboarding', 'skip');
}
function $1ee83d5da5d9dd72$export$e6f8987906ef61c7(e) {
    const el = this;
    const node = el && el.node;
    const root = el && el.state && el.state.root;
    if (!e || e.defaultPrevented || !node || !node.isConnected || !root) return false;
    if (!root._onboardingOpen || !root._onboardingFlow) return false;
    const doc = node.ownerDocument;
    const target = e.target;
    if (target && doc && target !== doc && target !== doc.body && target !== doc.documentElement) return false;
    if (typeof node.closest === 'function' && node.closest('[inert]')) return false;
    if (e.key === 'Escape') {
        if (typeof e.preventDefault === 'function') e.preventDefault();
        el.call('closeOnboarding', 'close');
        return true;
    }
    if (e.key === 'Tab') {
        el.call('appDialogTrapTab', e);
        return true;
    }
    return false;
}
function $1ee83d5da5d9dd72$export$ce25796851e14df9(path) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const flow = root._onboardingFlow && typeof root._onboardingFlow === 'object' ? root._onboardingFlow : {};
    // The welcome's button leaves with the welcome: give its focus up now, so
    // the next step's heading can take it — a focus left on a hidden button lost
    // Escape and the Tab cycle (live on dev 76305a52b at a phone width).
    try {
        if (el.node && typeof el.node.blur === 'function') el.node.blur();
    } catch (_) {
    /* focus is a courtesy — never an error */ }
    if (path === 'wizard') {
        if (flow.step !== 'welcome') root.update({
            _onboardingFlow: {
                ...flow,
                step: 'welcome'
            }
        }, {
            preventFetch: true
        });
        return !!el.call('onboardingWizardGo', 1);
    }
    if (path === 'assistant') {
        root.update({
            _onboardingFlow: {
                ...flow,
                step: 'assistant'
            }
        }, {
            preventFetch: true
        });
        el.call('onboardingChatStart');
        return true;
    }
    if (path === 'tour') {
        if (!flow.replay) el.call('onboardingDecide', 'done', 'tour');
        el.call('closeOnboarding', 'tour');
        // After the surface's exit, so the first stop is measured on a still page.
        // Through the app root: the button that asked may be gone by then.
        const host = typeof el.getRoot === 'function' && el.getRoot() || el;
        setTimeout(()=>host.call('onboardingTourStart'), 320);
        return true;
    }
    return false;
}
function $1ee83d5da5d9dd72$export$998a9d60a78af7b6(path) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    root.update({
        _homeCustomizeMode: false,
        _homeCustomizeDrawerTucked: false
    }, {
        preventFetch: true
    });
    if (path === 'tour') {
        const host = typeof el.getRoot === 'function' && el.getRoot() || el;
        setTimeout(()=>host.call('onboardingTourStart'), 320);
        return true;
    }
    if (path === 'wizard') {
        el.call('openOnboarding', 'welcome', {
            replay: true
        });
        return !!el.call('onboardingWizardGo', 1);
    }
    // The avatar entry offers both setup and the tour without changing the
    // person's existing completion record or any preference just by opening it.
    if (path === 'welcome') return el.call('openOnboarding', 'welcome', {
        replay: true
    });
    return el.call('openOnboarding', 'assistant', {
        replay: true
    });
}
function $1ee83d5da5d9dd72$export$8ff4e8d6b2db10e(status, via, opts) {
    const STATUSES = [
        'done',
        'skipped'
    ];
    const VIAS = [
        'wizard',
        'assistant',
        'tour',
        'skip',
        'ask',
        'fly',
        'pob'
    ];
    const el = this && typeof this === 'object' ? this : null;
    const o = opts && typeof opts === 'object' ? opts : {};
    const root = o.root || el && el.state && el.state.root || null;
    const sdk = o.sdk || el && el.sdk || null;
    if (!root || typeof root.update !== 'function') return Promise.resolve(null);
    if (root._onboardingDecision && !o.force) return Promise.resolve(null);
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    const bag = {
        v: 1,
        status: STATUSES.indexOf(status) !== -1 ? status : 'skipped',
        via: VIAS.indexOf(via) !== -1 ? via : 'skip',
        at: new Date(typeof o.now === 'number' ? o.now : Date.now()).toISOString()
    };
    // A Fly sign-up keeps where it came from through its decision: Fly's record
    // (`via: 'fly'`, pending or done) becomes `done` via the TOUR and would stop
    // saying so — and the two readers of that word (components/NoOrgOverlay.js:
    // the org question Fly answered must stay answered, or a non-dismissable
    // "create a workspace" modal opens over the tour; and the Fly start screen's
    // "Fly set up <workspace> with you") would lose the person. `origin: 'fly'`
    // carries it. Fly's checklist reads `status` only. A personalized sign-up
    // keeps `origin: 'pob'` the same way: the first thread's research summary
    // and its offers follow that word (functions/assistantFlyResearch.js).
    const before = prefs && prefs.onboarding && typeof prefs.onboarding === 'object' ? prefs.onboarding : null;
    if (before && (before.via === 'fly' || before.origin === 'fly') && bag.via !== 'fly') bag.origin = 'fly';
    else if (before && (before.via === 'pob' || before.origin === 'pob') && bag.via !== 'pob') bag.origin = 'pob';
    const patch = {
        _onboardingDecision: bag
    };
    if (prefs) patch.userPrefs = {
        ...prefs,
        onboarding: bag
    };
    root.update(patch, {
        preventFetch: true
    });
    try {
        const store = o.storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const userId = String(root.currentUserId || '');
        if (store && userId) store.setItem('symbols_onboarding:' + userId, JSON.stringify(bag));
    } catch (err) {
        console.warn('[onboarding] device copy write failed:', err && err.message);
    }
    if (!sdk || typeof sdk.execute !== 'function') return Promise.resolve(null);
    // The queue every user_preferences writer shares, keyed as they key it
    // (functions/homeLook.js homeLookSet).
    const w = root.workspace;
    const key = String(w && (w.id || w._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '') || 'user';
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    const prior = queue.get(key) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        // PER-PATH PATCH — names only `onboarding` (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: {
                set: {
                    onboarding: bag
                }
            }
        });
        if (row && typeof row === 'object') {
            const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
            root.update({
                userPrefs: now ? {
                    ...now,
                    onboarding: row.onboarding || bag
                } : row
            }, {
                preventFetch: true
            });
        }
        return row;
    });
    queue.set(key, task);
    return task.catch((err)=>{
        console.warn('[onboarding] decision save failed:', err && err.message);
        return null;
    });
}
function $1ee83d5da5d9dd72$export$9a58dc11dceb3e17(root, search) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function' || r._onboardingFlyArrival) return false;
    if (typeof search === 'string' && !new URLSearchParams(search).has('fly')) return false;
    r.update({
        _onboardingFlyArrival: true
    }, {
        preventFetch: true
    });
    return true;
}
function $1ee83d5da5d9dd72$export$3c3ca2dd1e7a0daa(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const u = r && r.user && typeof r.user === 'object' ? r.user : null;
    const profile = u && u.profile && typeof u.profile === 'object' ? u.profile : null;
    const name = u && u.name || profile && (profile.firstName || profile.name) || '';
    return String(name).trim().split(/\s+/)[0] || '';
}
function $1ee83d5da5d9dd72$export$c0b2df8ac8319503(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const brand = r && r.whitelabelBrand && r.whitelabelBrand.name;
    return String(ws && (ws.displayName || ws.name) || brand || '').trim();
}
function $1ee83d5da5d9dd72$export$4526b0cf0f3dc074(key, params) {
    const el = this;
    if (!el || typeof el.call !== 'function' || !key) return '';
    const root = el.state && el.state.root;
    const p = params && typeof params === 'object' ? params : {};
    const raw = String(el.call('polyglot', key) || '');
    const values = {
        name: p.name != null ? p.name : el.call('onboardingFirstName', root),
        workspace: p.workspace != null ? p.workspace : el.call('onboardingWorkspaceName', root),
        language: p.language != null ? p.language : '',
        preset: p.preset != null ? p.preset : ''
    };
    if (!values.language && raw.indexOf('{language}') !== -1) {
        const lang = el.call('onboardingLanguage', root) || {};
        const current = (lang.choices || []).find((c)=>c.value === lang.current);
        values.language = current ? current.label : '';
    }
    if (!values.preset && raw.indexOf('{preset}') !== -1) values.preset = String(el.call('onboardingPresetName', root) || '');
    return raw.replace(/\{(name|workspace|language|preset)\}/g, (m, k)=>String(values[k] || ''));
}
function $1ee83d5da5d9dd72$export$c595e8b6d92aa2d6(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const ADMIN_ROLES = [
        'owner',
        'co-owner',
        'admin',
        'maintainer'
    ];
    const shared = (0, $1X0Je.default) && (0, $1X0Je.default).functions || {};
    const registry = Array.isArray(shared.PLATFORM_LANGUAGES) ? shared.PLATFORM_LANGUAGES : null;
    const list = (registry || [
        {
            code: 'en',
            endonym: 'English'
        },
        {
            code: 'ka',
            endonym: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8"
        }
    ]).filter((l)=>l && typeof l.code === 'string');
    const ok = (c)=>typeof c === 'string' && list.some((l)=>l.code === c);
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const settings = ws && ws.settings && typeof ws.settings === 'object' ? ws.settings : null;
    const brand = r && r.whitelabelBrand && r.whitelabelBrand.lang;
    const current = (settings && ok(settings.language) ? settings.language : null) || (ok(brand) ? brand : null) || 'en';
    const role = r && r.org && r.org.role;
    return {
        current: current,
        canChange: !!(ws && (ws.id || ws._id)) && ADMIN_ROLES.indexOf(role) !== -1,
        choices: list.map((l)=>({
                value: l.code,
                label: String(l.endonym || l.code)
            }))
    };
}
async function $1ee83d5da5d9dd72$export$181ab2c4fa5dad92(code) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const lang = el.call('onboardingLanguage', root) || {};
    const supported = (lang.choices || []).some((c)=>c.value === code);
    if (!lang.canChange || !supported) return false;
    if (code === lang.current) return true;
    const ws = root.workspace;
    const wsId = ws && (ws.id || ws._id);
    const sdk = el.sdk;
    const failed = (messageKey)=>el.call('openNotification', {
            title: el.call('polyglot', 'settings.language.saveError'),
            message: el.call('polyglot', messageKey),
            type: 'error'
        });
    if (!wsId || !sdk || typeof sdk.updateWorkspaceSettings !== 'function') {
        failed(wsId ? 'settings.language.notReady' : 'settings.language.noWorkspace');
        return false;
    }
    const prevSettings = root.workspaceSettings;
    root.update({
        workspaceSettings: {
            ...root.workspaceSettings || {},
            language: code
        }
    }, {
        preventFetch: true
    });
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, {
            language: code
        });
        if (res && res.success === false) throw new Error(res.message || '');
    } catch (err) {
        root.update({
            workspaceSettings: prevSettings
        }, {
            preventFetch: true
        });
        console.warn('[onboarding] workspace language save failed:', err && err.message);
        failed('settings.language.adminOnly');
        return false;
    }
    const held = root.workspace;
    if (held && String(held.id || held._id || '') === String(wsId)) el.call('setActiveWorkspaceRecord', root, {
        ...held,
        settings: {
            ...held.settings || {},
            language: code
        }
    }, {
        reason: 'onboarding:language'
    });
    return true;
}
function $1ee83d5da5d9dd72$export$13a0bd2c8a6985a(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const plan = [];
    // THE THREE CHOICES first, as in the wizard (wt/presets CONTRACT §1): Your
    // work — the featured presets and Something else, asked only while the
    // workspace has no preset and this flow sent none (never ask twice; the
    // conversation's own answer keeps its place, so the count stands) — then
    // Your idea, where a TYPED answer is the idea and each example chip answers
    // with its own sentence (functions/onboardingPresets.js).
    const flow = r && r._onboardingFlow;
    const sent = !!(flow && flow.stackSent && !flow.workViaChat);
    if (el.call('onboardingPresetMode', r) === 'pick' && !sent) {
        // the conversation offers the tiles' presets, never the grid's more tile
        const tiles = (el.call('onboardingWorkTiles', r) || []).filter((t)=>t && !t.more);
        if (tiles.length > 1) plan.push({
            id: 'work',
            ask: 'workspace.onboarding.chat.askWork',
            skip: 'workspace.onboarding.chat.keepThis',
            kind: 'option',
            choices: tiles.map((t)=>({
                    value: t.value,
                    label: t.label,
                    hint: t.hint
                }))
        });
    }
    if (el.call('onboardingIdeaAsked', r)) plan.push({
        id: 'idea',
        ask: 'workspace.onboarding.chat.askIdea',
        skip: 'workspace.onboarding.chat.skipQuestion',
        typed: true,
        choices: (el.call('onboardingIdeaExamples') || []).map((x)=>({
                value: x.label,
                label: x.label
            }))
    });
    plan.push({
        id: 'theme',
        ask: 'workspace.onboarding.chat.askTheme',
        skip: 'workspace.onboarding.chat.keepThis',
        choices: [
            {
                value: 'light',
                label: 'workspace.personalize.themeLight',
                icon: 'sun'
            },
            {
                value: 'dark',
                label: 'workspace.personalize.themeDark',
                icon: 'moon'
            },
            {
                value: 'auto',
                label: 'workspace.personalize.themeAuto',
                icon: 'displayPreferences'
            }
        ]
    });
    const skies = el.call('homeSkyChoices');
    if (Array.isArray(skies) && skies.some((s)=>s && s.value !== 'none')) plan.push({
        id: 'sky',
        ask: 'workspace.onboarding.chat.askSky',
        skip: 'workspace.onboarding.chat.keepThis',
        kind: 'sky',
        choices: skies.map((s)=>({
                key: s.key,
                value: s.value,
                label: s.label
            }))
    });
    plan.push({
        id: 'summary',
        ask: 'workspace.onboarding.chat.askSummary',
        skip: 'workspace.onboarding.chat.keepThis',
        kind: 'option',
        choices: [
            {
                value: 'brief',
                label: 'workspace.personalize.summaryBrief',
                hint: 'workspace.onboarding.chat.summaryBriefHint'
            },
            {
                value: 'signals',
                label: 'workspace.personalize.summarySignals',
                hint: 'workspace.onboarding.chat.summarySignalsHint'
            }
        ]
    });
    plan.push({
        id: 'strip',
        ask: 'workspace.onboarding.chat.askStrip',
        skip: 'workspace.onboarding.chat.keepThis',
        kind: 'option',
        choices: [
            {
                value: 'dock',
                label: 'workspace.onboarding.chat.stripDock',
                hint: 'workspace.onboarding.chat.stripDockHint'
            },
            {
                value: 'rail',
                label: 'workspace.onboarding.chat.stripRail',
                hint: 'workspace.onboarding.chat.stripRailHint'
            },
            {
                value: 'off',
                label: 'workspace.onboarding.chat.stripOff',
                hint: 'workspace.onboarding.chat.stripOffHint'
            }
        ]
    });
    plan.push({
        id: 'tour',
        ask: 'workspace.onboarding.chat.askTour',
        choices: [
            {
                value: 'tour',
                label: 'workspace.onboarding.chat.tourYes',
                icon: 'playOval'
            },
            {
                value: 'later',
                label: 'workspace.onboarding.chat.tourNo'
            }
        ]
    });
    return plan;
}
function $1ee83d5da5d9dd72$export$617c78c79c3b9867(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    if (!flow || !flow.ask) return null;
    const plan = el.call('onboardingPlan', r) || [];
    return plan.find((q)=>q.id === flow.ask) || null;
}
function $1ee83d5da5d9dd72$export$d26276cf8e98bd49(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    if (!flow || flow.step !== 'assistant' || !flow.ask) return '';
    const plan = el.call('onboardingPlan', r) || [];
    const at = plan.findIndex((q)=>q.id === flow.ask);
    if (at < 0) return '';
    return String(el.call('polyglot', 'workspace.onboarding.chat.progress') || '').replace('{n}', String(at + 1)).replace('{total}', String(plan.length));
}
function $1ee83d5da5d9dd72$export$c628ae7fd5065017() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const flow = root._onboardingFlow && typeof root._onboardingFlow === 'object' ? root._onboardingFlow : {};
    const plan = el.call('onboardingPlan', root) || [];
    // The greeting reads WITHOUT a name when the record has none — never a
    // placeholder word (the home greeting's own rule).
    const hello = el.call('onboardingFirstName', root) ? 'workspace.onboarding.chat.hello' : 'workspace.onboarding.chat.helloNoName';
    const turns = [
        {
            id: 't1',
            from: 'assistant',
            line: hello
        }
    ];
    turns.push({
        id: 't2',
        from: 'assistant',
        line: 'workspace.onboarding.chat.languageSet'
    });
    // A workspace set up already — at sign-up, or by this flow's own Your work
    // — is told so, never asked again (functions/onboardingPresets.js).
    const work = el.call('onboardingWorkView', root) || {};
    if (work.state === 'applied' || work.state === 'sent') {
        const named = !!el.call('onboardingPresetName', root);
        const custom = work.state === 'applied' ? ((el.call('workspacePresetApplied', root) || {}).key || '') === 'custom' : (flow.picks && flow.picks.work || '') === 'custom';
        turns.push({
            id: 't' + (turns.length + 1),
            from: 'assistant',
            line: custom ? 'workspace.onboarding.chat.workSetCustom' : named ? 'workspace.onboarding.chat.workSet' : 'workspace.onboarding.chat.workSetOther'
        });
    }
    const first = plan[0];
    if (first) turns.push({
        id: 't' + (turns.length + 1),
        from: 'assistant',
        line: first.ask
    });
    root.update({
        _onboardingFlow: {
            ...flow,
            step: 'assistant',
            turns: turns,
            ask: first ? first.id : null,
            answered: 0,
            seq: turns.length,
            busy: false
        }
    }, {
        preventFetch: true
    });
    return true;
}
async function $1ee83d5da5d9dd72$export$f732b6b5c3fde254(id, value) {
    const el = this;
    if (!el || typeof el.call !== 'function') return false;
    if (id === 'theme') {
        el.call('homeLookSetTheme', value);
        return true;
    }
    if (id === 'sky') {
        el.call('homeLookSet', {
            sky: value
        });
        return true;
    }
    if (id === 'summary') {
        el.call('homeLookSet', {
            summaryStyle: value
        });
        return true;
    }
    if (id === 'strip') {
        if (value === 'off') el.call('homeLookSet', {
            stripShown: false
        });
        else el.call('homeLookSet', {
            stripShown: true,
            stripStyle: value
        });
        return true;
    }
    // Your work: the pick, sent in the background with the preset's own apps;
    // Your idea: held for the finish — an example chip's sentence in the
    // session language, or the typed one as it is (functions/onboardingPresets.js).
    if (id === 'work') return !!el.call('onboardingWorkAnswer', value);
    if (id === 'idea') {
        const text = String(el.call('polyglot', value) || value || '');
        return !!el.call('onboardingIdeaSet', text);
    }
    return id === 'tour';
}
async function $1ee83d5da5d9dd72$export$64af0a13e8791c5d(value, opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const o = opts && typeof opts === 'object' ? opts : {};
    const flow = root._onboardingFlow && typeof root._onboardingFlow === 'object' ? root._onboardingFlow : null;
    if (!flow || flow.step !== 'assistant' || !flow.ask || flow.busy) return false;
    const plan = el.call('onboardingPlan', root) || [];
    const at = plan.findIndex((q)=>q.id === flow.ask);
    const q = at >= 0 ? plan[at] : null;
    if (!q) return false;
    const typed = !o.skip && q.typed && typeof o.text === 'string' ? o.text.trim() : '';
    const choice = o.skip ? null : typed ? {
        value: typed,
        label: typed
    } : (q.choices || []).find((c)=>c.value === value) || null;
    if (!o.skip && !choice) return false;
    let seq = flow.seq || flow.turns.length;
    const turns = flow.turns.slice();
    seq += 1;
    turns.push({
        id: 't' + seq,
        from: 'me',
        line: o.skip ? q.skip || 'workspace.onboarding.chat.skipQuestion' : choice.label,
        // an endonym answer names its own language for assistive technology
        lang: !o.skip && choice.lang ? choice.lang : null
    });
    root.update({
        _onboardingFlow: {
            ...flow,
            turns: turns,
            seq: seq,
            busy: true
        }
    }, {
        preventFetch: true
    });
    let landed = true;
    if (choice) landed = await el.call('onboardingApply', q.id, choice.value);
    const now = root._onboardingFlow && typeof root._onboardingFlow === 'object' ? root._onboardingFlow : flow;
    // Closed or restarted while the answer was applied — nothing to continue.
    if (!now || now.step !== 'assistant' || now.ask !== q.id) return landed;
    const answered = (now.answered || 0) + (choice && landed ? 1 : 0);
    const after = now.turns.slice();
    let s2 = now.seq || after.length;
    if (choice && !landed) {
        s2 += 1;
        after.push({
            id: 't' + s2,
            from: 'assistant',
            line: 'workspace.onboarding.chat.notSaved'
        });
    }
    if (!flow.replay && answered > 0) el.call('onboardingDecide', 'done', 'assistant');
    // The tour question ends the conversation: yes starts the tour, no closes
    // with the parting line.
    if (q.id === 'tour') {
        if (choice && choice.value === 'tour') {
            root.update({
                _onboardingFlow: {
                    ...now,
                    turns: after,
                    seq: s2,
                    ask: null,
                    answered: answered,
                    busy: false
                }
            }, {
                preventFetch: true
            });
            el.call('closeOnboarding', 'tour');
            // Through the app root: this answer's button leaves with the question.
            const host = typeof el.getRoot === 'function' && el.getRoot() || el;
            setTimeout(()=>host.call('onboardingTourStart'), 320);
            return true;
        }
        s2 += 1;
        after.push({
            id: 't' + s2,
            from: 'assistant',
            line: 'workspace.onboarding.chat.bye'
        });
        root.update({
            _onboardingFlow: {
                ...now,
                turns: after,
                seq: s2,
                ask: null,
                answered: answered,
                busy: false
            }
        }, {
            preventFetch: true
        });
        return true;
    }
    // The idea is built at the finish — the conversation says so once.
    if (q.id === 'idea' && choice && landed) {
        s2 += 1;
        after.push({
            id: 't' + s2,
            from: 'assistant',
            line: 'workspace.onboarding.chat.ideaNext'
        });
    }
    const next = plan[at + 1] || null;
    if (next) {
        s2 += 1;
        after.push({
            id: 't' + s2,
            from: 'assistant',
            line: next.ask
        });
    }
    root.update({
        _onboardingFlow: {
            ...now,
            turns: after,
            seq: s2,
            ask: next ? next.id : null,
            answered: answered,
            busy: false
        }
    }, {
        preventFetch: true
    });
    return landed;
}
function $1ee83d5da5d9dd72$export$db17b9122cf4b16e() {
    return this.call('onboardingChatAnswer', null, {
        skip: true
    });
}
function $1ee83d5da5d9dd72$export$d7cf0d26f9e0b176(text) {
    const el = this;
    const root = el && el.state && el.state.root;
    const ask = String(text || '').trim();
    if (!root || !ask) return false;
    const q = el.call('onboardingQuestion', root);
    if (q && q.typed) return el.call('onboardingChatAnswer', null, {
        text: ask
    });
    return el.call('onboardingChatHandoff', ask);
}
function $1ee83d5da5d9dd72$export$5e5863eb76fdbdb9(answer) {
    const el = answer || this;
    const node = el && el.node;
    if (!node || typeof node.focus !== 'function') return false;
    const root = el.state && el.state.root;
    if (!root || !root._onboardingOpen) return false;
    // Decided after the answers are in the document: at render a row is not
    // attached yet, so EVERY row looked first and the last one won the focus
    // (live on dev 76305a52b: the sky question focused "None").
    setTimeout(()=>{
        try {
            if (!node.isConnected || node.previousElementSibling) return;
            const doc = node.ownerDocument;
            const active = doc && doc.activeElement;
            if (active && active !== doc.body && active.isConnected) return;
            node.focus({
                preventScroll: true
            });
        } catch (_) {
        /* focus is a courtesy — never an error */ }
    }, 0);
    return true;
}
function $1ee83d5da5d9dd72$export$4d1c10955527c529(text) {
    const el = this;
    const root = el && el.state && el.state.root;
    const ask = String(text || '').trim();
    if (!root || !ask) return false;
    const flow = root._onboardingFlow;
    if (flow && !flow.replay) el.call('onboardingDecide', 'done', 'ask');
    el.call('closeOnboarding', 'ask');
    const host = typeof el.getRoot === 'function' && el.getRoot() || el;
    setTimeout(()=>{
        try {
            host.call('homeAiSend', ask, null, 0, null, {
                mode: 'assistant'
            });
        } catch (err) {
            console.warn('[onboarding] hand-off failed:', err && err.message);
        }
    }, 120);
    return true;
}

});

parcelRegister("5nFIo", function(module, exports) {

$parcel$export(module.exports, "onboardingWizardSteps", () => $3eaf7578f6c8ccb0$export$1adba1da24c4c302);
$parcel$export(module.exports, "onboardingWizardAt", () => $3eaf7578f6c8ccb0$export$c27e5fbf637d244d);
$parcel$export(module.exports, "onboardingWizardGo", () => $3eaf7578f6c8ccb0$export$89d50558c2706f07);
$parcel$export(module.exports, "onboardingWizardFocus", () => $3eaf7578f6c8ccb0$export$705a1101418a33d1);
$parcel$export(module.exports, "onboardingWizardCurrent", () => $3eaf7578f6c8ccb0$export$bc003ea061d5554d);
$parcel$export(module.exports, "onboardingWizardPick", () => $3eaf7578f6c8ccb0$export$8efb37114597caa5);
$parcel$export(module.exports, "onboardingWizardPreset", () => $3eaf7578f6c8ccb0$export$6f7bdc1a4a4fdbb1);
$parcel$export(module.exports, "onboardingWizardLesson", () => $3eaf7578f6c8ccb0$export$1425731228e4de83);
$parcel$export(module.exports, "onboardingWizardJourney", () => $3eaf7578f6c8ccb0$export$a6d88c0de4d93fc6);
$parcel$export(module.exports, "onboardingWizardApps", () => $3eaf7578f6c8ccb0$export$13fc787f4fd63e63);
$parcel$export(module.exports, "onboardingWizardToggleApp", () => $3eaf7578f6c8ccb0$export$6b8e37be2d481f33);
$parcel$export(module.exports, "onboardingWizardAllApps", () => $3eaf7578f6c8ccb0$export$85013ffba173aea8);
$parcel$export(module.exports, "onboardingWizardApplyApps", () => $3eaf7578f6c8ccb0$export$3f722983e580ebcf);
$parcel$export(module.exports, "onboardingWizardFinish", () => $3eaf7578f6c8ccb0$export$d568d3eecde308ba);
$parcel$export(module.exports, "onboardingExitToComposer", () => $3eaf7578f6c8ccb0$export$3d81f9c958432aae);
// onboardingWizard.js — THE SETUP WIZARD of the new-account welcome
// (Nika 2026-10-18: "onboarding should not be just chat assistant. it should
// be wizard like onboarding and click based onboarding could be possible.
// this will help to personalize the view and avoid showing complex ui at
// first load").
//
// A first-run surface that covers the whole shell (components/
// OnboardingWizard.js) and walks a new member through a few CLICK steps, each
// a real choice written through the writers Customize dashboard uses:
//
//   welcome   the greeting — Get started · Set up with the assistant · Take
//             the quick tour
//   work      Your work — a Workspace Preset or Something else (an owner/admin
//             of the workspace, while the SDK can apply presets); the ✓ row
//             when the workspace is set up already (functions/
//             onboardingPresets.js — the three choices, wt/presets CONTRACT §1)
//   stack     Your apps — the picked work's apps; leaving it forward sends the
//             ONE apply in the background
//   idea      Your idea — one optional sentence for the app builder
//   apps      the apps the home shows (not in a flow that shows `stack`): the
//             App strip keeps the picked ones, the others stay in All apps
//             (pages/main.js `_homeOps`)
//   look      theme and background
//   home      the summary (Brief | Signals) and the App strip (Dock | Rail |
//             off)
//   done      Start working (Build my app with an idea) · Take the quick tour
//             · Ask the assistant — and the lines of what was set up
//   ready     a person who signed up through Fly meets this ONE step instead
//             of all the others (its flow has no other step): Your workspace
//             is ready, what Fly made, Start working · Take the quick tour
//             (functions/onboardingReady.js)
//
// ONE VOCABULARY with the setup conversation: the options are its plan's
// (functions/onboarding.js `onboardingPlan`) and every pick applies AT ONCE
// through its writer (`onboardingApply` — the theme repaints the wizard
// itself, the rest lands on the home behind it). The apps are the exception:
// their picks are held in the flow and written in ONE pass when the step is
// left forward, so a dozen toggles are one save.
//
// STATE (`root._onboardingFlow`): `step` names the step; `picks.apps` holds
// the app picks; `picked` the choices made here (a tile shows its pick before
// the writer's state lands); `progressed` turns true at the first pick or the
// first step left forward — a Skip after that counts as done
// (functions/onboarding.js closeOnboarding).
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// The steps for this member, in order — TWO SIDES, never mixed. First the
// WORKSPACE side: the three choices of the Workspace Presets program, for an
// owner/admin of the workspace, written for everyone in it — `work` while the
// host can apply presets, `stack` once a work is picked (never over a
// workspace set up already), `idea`. Then the PERSONAL side: this person's
// own choices only (shared settings such as the workspace language live in
// workspace settings) — `apps` only when the board offers a choice (two apps
// or more), and never in a flow that shows `stack`: every app the person just
// picked shows on the home anyway, and a second "pick your apps" reads as a
// bug (one screen per choice); then the look and the home.
function $3eaf7578f6c8ccb0$export$1adba1da24c4c302(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    // Fly's ready screen is a flow of ONE step: nothing to walk, no counter, no
    // journey (functions/onboardingReady.js).
    if (flow && flow.step === 'ready') return [
        'ready'
    ];
    const plan = el.call('onboardingPlan', r) || [];
    const has = (id)=>plan.some((q)=>q && q.id === id);
    const steps = [
        'welcome'
    ];
    const mode = el.call('onboardingPresetMode', r);
    const stack = !!(mode === 'pick' && flow && flow.picks && flow.picks.work);
    if (mode) steps.push('work');
    if (stack) steps.push('stack');
    if (el.call('onboardingIdeaAsked', r)) steps.push('idea');
    const apps = el.call('onboardingWizardApps', r);
    if (!stack && Array.isArray(apps) && apps.length > 1) steps.push('apps');
    if (has('theme') || has('sky')) steps.push('look');
    if (has('summary') || has('strip')) steps.push('home');
    steps.push('done');
    return steps;
}
function $3eaf7578f6c8ccb0$export$c27e5fbf637d244d(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    if (!flow) return {
        step: null,
        n: 0,
        total: 0
    };
    const steps = el.call('onboardingWizardSteps', r) || [];
    const middle = steps.filter((s)=>s !== 'welcome' && s !== 'done' && s !== 'ready');
    const at = middle.indexOf(flow.step);
    return {
        step: flow.step,
        n: at < 0 ? 0 : at + 1,
        total: middle.length
    };
}
function $3eaf7578f6c8ccb0$export$89d50558c2706f07(delta) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function') return null;
    const steps = el.call('onboardingWizardSteps', root) || [];
    const at = steps.indexOf(flow.step);
    // The conversation steps back to the welcome; any unknown step starts it.
    const from = at < 0 ? 0 : at;
    const to = at < 0 && delta < 0 ? 0 : Math.max(0, Math.min(steps.length - 1, from + (delta < 0 ? -1 : 1)));
    if (at >= 0 && to === at) return flow.step;
    const forward = at >= 0 && to > at;
    if (forward && flow.step === 'apps') el.call('onboardingWizardApplyApps');
    if (forward && flow.step === 'work') el.call('onboardingNameSave');
    if (forward && flow.step === 'stack') el.call('onboardingStackSend');
    const middle = flow.step !== 'welcome' && flow.step !== 'done' && flow.step !== 'assistant';
    const now = root._onboardingFlow || flow;
    root.update({
        _onboardingFlow: {
            ...now,
            step: steps[to],
            progressed: !!(now.progressed || forward && middle)
        }
    }, {
        preventFetch: true
    });
    el.call('onboardingWizardFocus');
    return steps[to];
}
function $3eaf7578f6c8ccb0$export$705a1101418a33d1() {
    const el = this;
    const host = el && typeof el.getRoot === 'function' && el.getRoot() || el;
    setTimeout(()=>{
        try {
            const layer = host && typeof host.lookdown === 'function' && host.lookdown('OnboardingWizard');
            const title = layer && typeof layer.lookdown === 'function' && layer.lookdown('WizardTitle');
            const node = title && title.node;
            if (node && node.isConnected !== false && typeof node.focus === 'function') node.focus({
                preventScroll: true
            });
        } catch (_) {
        /* focus is a courtesy — never an error */ }
    }, 0);
}
function $3eaf7578f6c8ccb0$export$bc003ea061d5554d(id) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root) return null;
    const flow = root._onboardingFlow;
    const picked = flow && flow.picked && typeof flow.picked === 'object' ? flow.picked : {};
    if (typeof picked[id] === 'string') return picked[id];
    if (id === 'language') return (el.call('onboardingLanguage', root) || {}).current || null;
    if (id === 'theme') {
        const mode = root.themeMode;
        return mode === 'light' || mode === 'dark' ? mode : 'auto';
    }
    const look = el.call('homeLookRead', root) || {};
    if (id === 'summary') return look.summaryStyle === 'signals' ? 'signals' : 'brief';
    if (id === 'strip') {
        if (look.stripShown === false) return 'off';
        return look.stripStyle === 'rail' ? 'rail' : 'dock';
    }
    return null;
}
function $3eaf7578f6c8ccb0$export$8efb37114597caa5(id, value) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function' || typeof value !== 'string') return false;
    const picked = flow.picked && typeof flow.picked === 'object' ? flow.picked : {};
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: true,
            picked: {
                ...picked,
                [id]: value
            }
        }
    }, {
        preventFetch: true
    });
    el.call('onboardingApply', id, value);
    return true;
}
function $3eaf7578f6c8ccb0$export$6f7bdc1a4a4fdbb1(value) {
    const root = this.state && this.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || ![
        'focus',
        'overview'
    ].includes(value)) return false;
    const summary = value === 'overview' ? 'signals' : 'brief';
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: true,
            picked: {
                ...flow.picked,
                summary: summary,
                strip: 'dock'
            }
        }
    }, {
        preventFetch: true
    });
    this.call('homeLookSet', {
        summaryStyle: summary,
        stripShown: true,
        stripStyle: 'dock'
    });
    return true;
}
function $3eaf7578f6c8ccb0$export$1425731228e4de83(root) {
    const step = (root || this.state.root)?._onboardingFlow?.step || 'welcome';
    const lessons = {
        welcome: [
            'magicstar',
            'workspace.onboarding.learn.welcomeTitle',
            'workspace.onboarding.learn.welcomeText'
        ],
        work: [
            'layers',
            'workspace.onboarding.learn.workTitle'
        ],
        stack: [
            'blocks',
            'workspace.onboarding.learn.stackTitle'
        ],
        idea: [
            'magicstar',
            'workspace.onboarding.learn.ideaTitle'
        ],
        apps: [
            'search',
            'workspace.onboarding.learn.appsTitle',
            'workspace.onboarding.learn.appsText'
        ],
        look: [
            'magicstar',
            'workspace.onboarding.learn.lookTitle',
            'workspace.onboarding.learn.lookText'
        ],
        home: [
            'home',
            'workspace.onboarding.learn.homeTitle',
            'workspace.onboarding.learn.homeText'
        ],
        done: [
            'checkmark',
            'workspace.onboarding.learn.doneTitle',
            'workspace.onboarding.learn.doneText'
        ],
        // Fly's ready screen: the studio's caption wears the done step's title;
        // the lesson line stays hidden there (it says its one thing in its lead).
        ready: [
            'checkmark',
            'workspace.onboarding.learn.doneTitle'
        ],
        assistant: [
            'magicstar',
            'workspace.onboarding.learn.assistantTitle',
            'workspace.onboarding.learn.assistantText'
        ]
    };
    const lesson = lessons[step] || lessons.welcome;
    return {
        icon: lesson[0],
        title: lesson[1],
        text: lesson[2] || ''
    };
}
function $3eaf7578f6c8ccb0$export$a6d88c0de4d93fc6(root) {
    const r = root || this.state.root;
    const steps = this.call('onboardingWizardSteps', r) || [];
    const current = steps.indexOf(r?._onboardingFlow?.step);
    const labels = {
        work: 'workspace.onboarding.journey.work',
        stack: 'workspace.onboarding.journey.stack',
        idea: 'workspace.onboarding.journey.idea',
        apps: 'workspace.onboarding.journey.apps',
        look: 'workspace.onboarding.journey.look',
        home: 'workspace.onboarding.journey.home'
    };
    const sideOf = (step)=>[
            'work',
            'stack',
            'idea'
        ].indexOf(step) !== -1 ? 'workspace' : 'personal';
    const shown = steps.filter((step)=>labels[step]);
    const both = shown.some((step)=>sideOf(step) === 'workspace') && shown.some((step)=>sideOf(step) === 'personal');
    return shown.map((step, i)=>({
            key: step,
            label: labels[step],
            number: i + 1,
            status: steps.indexOf(step) < current ? 'complete' : steps.indexOf(step) === current ? 'current' : 'upcoming',
            side: sideOf(step),
            sideLabel: both && (i === 0 || sideOf(shown[i - 1]) !== sideOf(step)) ? sideOf(step) === 'workspace' ? 'workspace.onboarding.journey.sideWorkspace' : 'workspace.onboarding.journey.sidePersonal' : ''
        }));
}
function $3eaf7578f6c8ccb0$export$13fc787f4fd63e63(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const ops = r && r._homeOps;
    const rows = ops && typeof ops.onboardingApps === 'function' ? ops.onboardingApps() : [];
    const flow = r && r._onboardingFlow;
    const picks = flow && flow.picks && flow.picks.apps || {};
    return (Array.isArray(rows) ? rows : []).map((row)=>({
            // A row key never equal to a tag name (an app id may be `video`), never
            // the data's own fields.
            key: 'pick-' + row.id,
            id: row.id,
            title: row.title,
            icon: row.icon,
            openRoute: row.openRoute,
            picked: typeof picks[row.id] === 'boolean' ? picks[row.id] : row.shown !== false
        }));
}
function $3eaf7578f6c8ccb0$export$6b8e37be2d481f33(id) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function' || !id) return false;
    const row = (el.call('onboardingWizardApps', root) || []).find((r)=>r.id === id);
    if (!row) return false;
    const picks = flow.picks && flow.picks.apps || {};
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: true,
            picks: {
                ...flow.picks || {},
                apps: {
                    ...picks,
                    [id]: !row.picked
                }
            }
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $3eaf7578f6c8ccb0$export$85013ffba173aea8(on) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function') return false;
    const apps = {};
    for (const row of el.call('onboardingWizardApps', root) || [])apps[row.id] = !!on;
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: true,
            picks: {
                ...flow.picks || {},
                apps: apps
            }
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $3eaf7578f6c8ccb0$export$3f722983e580ebcf() {
    const el = this;
    const root = el && el.state && el.state.root;
    const ops = root && root._homeOps;
    const flow = root && root._onboardingFlow;
    const picks = flow && flow.picks && flow.picks.apps;
    if (!ops || typeof ops.setAppsShown !== 'function' || !picks) return false;
    const live = typeof ops.onboardingApps === 'function' ? ops.onboardingApps() || [] : [];
    const change = {};
    for (const row of live){
        if (typeof picks[row.id] !== 'boolean') continue;
        if (picks[row.id] !== (row.shown !== false)) change[row.id] = picks[row.id];
    }
    if (!Object.keys(change).length) return false;
    return ops.setAppsShown(change) !== false;
}
function $3eaf7578f6c8ccb0$export$d568d3eecde308ba(next) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow) return false;
    const idea = String(flow.picks && flow.picks.idea || '').replace(/\s+/g, ' ').trim();
    if (!flow.replay) el.call('onboardingDecide', 'done', 'wizard');
    el.call('closeOnboarding', 'finish');
    const host = typeof el.getRoot === 'function' && el.getRoot() || el;
    const fns = host && host.context && host.context.functions || {};
    if (next === 'build' && idea) setTimeout(()=>host.call('onboardingBuildIdea', idea), 320);
    else if (next === 'store') setTimeout(()=>host.call('openAppPage', '/marketplace?surface=appstore'), 320);
    else if (next === 'tour') setTimeout(()=>host.call('onboardingTourStart'), 320);
    else if (next === 'assistant' && typeof fns.assistantBoardFocus === 'function') setTimeout(()=>host.call('assistantBoardFocus', 'composer'), 320);
    else if (next === 'home') setTimeout(()=>host.call('onboardingExitToComposer', idea), 320);
    return true;
}
function $3eaf7578f6c8ccb0$export$3d81f9c958432aae(idea) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || root._onboardingOpen || root._onboardingHold) return false;
    try {
        const host = typeof el.getRoot === 'function' && el.getRoot() || el;
        const composer = host && host.lookdown && host.lookdown('CanvasPromptTextarea');
        const field = composer && composer.lookdown && composer.lookdown('Textarea');
        const node = field && field.node;
        if (!node || node.isConnected === false) return false;
        const text = String(idea || '').trim();
        if (text && composer.state && typeof composer.state.update === 'function') {
            const current = String(composer.state.draft || '');
            const draft = current.trim() && current.trim() !== text ? current + '\n' + text : text;
            composer.state.update({
                draft: draft
            });
        }
        node.focus({
            preventScroll: true
        });
        return true;
    } catch (_) {
        return false;
    }
}

});

parcelRegister("6u4gB", function(module, exports) {

$parcel$export(module.exports, "onboardingTourStops", () => $4b88dab743f88b0a$export$3069627adcf21d83);
$parcel$export(module.exports, "onboardingTourRect", () => $4b88dab743f88b0a$export$ec0e272e1170feff);
$parcel$export(module.exports, "onboardingTourStart", () => $4b88dab743f88b0a$export$a2da14e3ced0731c);
$parcel$export(module.exports, "onboardingTourGo", () => $4b88dab743f88b0a$export$a60fac58f24dd8a2);
$parcel$export(module.exports, "onboardingTourMeasure", () => $4b88dab743f88b0a$export$fcae8eebdf920d19);
$parcel$export(module.exports, "onboardingTourEnd", () => $4b88dab743f88b0a$export$97f8658b50094461);
$parcel$export(module.exports, "onboardingTourCurrent", () => $4b88dab743f88b0a$export$41a5bfe6d32f8a2d);
$parcel$export(module.exports, "onboardingTourSide", () => $4b88dab743f88b0a$export$92aeed824c885d1e);
$parcel$export(module.exports, "onboardingTourVars", () => $4b88dab743f88b0a$export$db7200a2507adf73);
// onboardingTour.js — THE QUICK TOUR of the new-account welcome
// (functions/onboarding.js; Nika 2026-10-18 "allow onboarding assistant, tour
// and skipping").
//
// Six stops over the REAL chrome, in reading order — the apps in the navbar,
// search, messages · calls · notifications, the account menu, the App strip,
// the assistant's composer — then a closing card. A stop names its target by
// DOMQL key path from the app root (`el.lookdown`, Rule 40 — never a DOM
// query) and is skipped when that element is not on screen: a phone layout, a
// hidden App strip, a module that hides the composer each simply drop their
// stop, so the tour never points at nothing.
//
// STATE: `root._onboardingTour` = { at, ids, rect, total } while it runs, null
// otherwise — `ids` the stops that resolved at the start, `at` the one shown
// (`ids.length` = the closing card), `rect` its viewport box (read from the
// node, Rule 39). components/OnboardingTour.js renders the dimmed layer with
// its window over `rect` and the card beside it; the card's placement is CSS
// over custom properties (onboardingTourVars), so no card is ever measured.
//
// Skip at any stop: "Skip tour", Escape, Close. Arrow keys walk the stops.
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// The stops, in order. A target is a key path from the app root, or
// `{ path, text, clip }` when that element needs its own line (`text`) or
// scrolls inside a row that shows only part of it (`clip`, the row's key path —
// the Dock's capsule outgrows its row on a phone); the first target that
// resolves to a visible element wins (alternatives — the Dock or the Rail, the
// desktop header or the phone dock, whose Apps / Menu / Assistant buttons stand
// in for the header on a phone: PhoneNavigation).
function $4b88dab743f88b0a$export$3069627adcf21d83() {
    return [
        {
            id: 'apps',
            paths: [
                [
                    'AppHeader',
                    'HeaderTabs'
                ],
                {
                    path: [
                        'PhoneNavigation',
                        'Dock',
                        'PhoneNavButton_apps'
                    ],
                    text: 'workspace.onboarding.tour.appsTextPhone'
                }
            ],
            title: 'workspace.onboarding.tour.appsTitle',
            text: 'workspace.onboarding.tour.appsText'
        },
        {
            id: 'search',
            paths: [
                [
                    'AppHeader',
                    'SearchBtn'
                ],
                [
                    'AppHeader',
                    'HeaderSearch'
                ]
            ],
            title: 'workspace.onboarding.tour.searchTitle',
            text: 'workspace.onboarding.tour.searchText'
        },
        {
            id: 'inbox',
            paths: [
                [
                    'AppHeader',
                    'HeaderActions'
                ]
            ],
            title: 'workspace.onboarding.tour.inboxTitle',
            text: 'workspace.onboarding.tour.inboxText'
        },
        {
            id: 'account',
            paths: [
                [
                    'AppHeader',
                    'MeWrapper'
                ],
                {
                    path: [
                        'PhoneNavigation',
                        'Dock',
                        'PhoneNavButton_menu'
                    ],
                    text: 'workspace.onboarding.tour.accountTextPhone'
                }
            ],
            title: 'workspace.onboarding.tour.accountTitle',
            text: 'workspace.onboarding.tour.accountText'
        },
        {
            id: 'strip',
            paths: [
                {
                    path: [
                        'HomeAppStrip',
                        'DockCapsule'
                    ],
                    clip: [
                        'HomeAppStrip'
                    ]
                },
                [
                    'HomeAppRail',
                    'RailCapsule'
                ]
            ],
            title: 'workspace.onboarding.tour.stripTitle',
            text: 'workspace.onboarding.tour.stripText'
        },
        {
            id: 'composer',
            paths: [
                [
                    'CanvasPromptTextarea'
                ],
                {
                    path: [
                        'PhoneNavigation',
                        'Dock',
                        'PhoneNavButton_ai'
                    ],
                    text: 'workspace.onboarding.tour.composerTextPhone'
                }
            ],
            title: 'workspace.onboarding.tour.composerTitle',
            text: 'workspace.onboarding.tour.composerText'
        }
    ];
}
function $4b88dab743f88b0a$export$ec0e272e1170feff(stop) {
    const el = this;
    const app = el && typeof el.getRoot === 'function' && el.getRoot() || el;
    if (!app || !stop || !Array.isArray(stop.paths)) return null;
    const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
    const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
    // A key path from the app root to its element (the DOMQL tree, Rule 40).
    const find = (path)=>{
        let node = app;
        for (const key of path){
            node = node && typeof node.lookdown === 'function' ? node.lookdown(key) : null;
            if (!node) return null;
        }
        return node;
    };
    for (const target of stop.paths){
        const path = Array.isArray(target) ? target : target && target.path;
        if (!Array.isArray(path)) continue;
        const node = find(path);
        const dom = node && node.node;
        if (!dom || typeof dom.getBoundingClientRect !== 'function') continue;
        const r = dom.getBoundingClientRect();
        if (!r || r.width < 1 || r.height < 1) continue;
        // Off screen (a scrolled-away strip) or under a hidden ancestor.
        if (r.bottom <= 0 || r.right <= 0 || vw && r.left >= vw || vh && r.top >= vh) continue;
        let hidden = false;
        try {
            const cs = typeof getComputedStyle === 'function' ? getComputedStyle(dom) : null;
            hidden = !!cs && (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0');
        } catch (_) {
            hidden = false;
        }
        if (hidden) continue;
        // The part that shows: cut to the row it scrolls in (`clip`), then to the
        // screen — the ring never runs off an edge.
        let left = r.left;
        let top = r.top;
        let right = r.right;
        let bottom = r.bottom;
        const row = !Array.isArray(target) && Array.isArray(target.clip) ? find(target.clip) : null;
        const cr = row && row.node && typeof row.node.getBoundingClientRect === 'function' ? row.node.getBoundingClientRect() : null;
        if (cr && cr.width >= 1 && cr.height >= 1) {
            left = Math.max(left, cr.left);
            top = Math.max(top, cr.top);
            right = Math.min(right, cr.right);
            bottom = Math.min(bottom, cr.bottom);
        }
        if (vw) {
            left = Math.max(left, 0);
            right = Math.min(right, vw);
        }
        if (vh) {
            top = Math.max(top, 0);
            bottom = Math.min(bottom, vh);
        }
        if (right - left < 1 || bottom - top < 1) continue;
        const box = {
            x: Math.round(left),
            y: Math.round(top),
            w: Math.round(right - left),
            h: Math.round(bottom - top)
        };
        // The room to the nearest screen edge: the layer's ring gap never exceeds
        // it, so a ring round a target near an edge stays whole on screen.
        if (vw && vh) box.room = Math.max(0, Math.floor(Math.min(left, top, vw - right, vh - bottom)));
        // The line of THIS target, when it has its own (the phone dock's).
        if (!Array.isArray(target) && target.text) box.text = target.text;
        return box;
    }
    return null;
}
function $4b88dab743f88b0a$export$a2da14e3ced0731c() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const stops = el.call('onboardingTourStops') || [];
    const ids = [];
    let rect = null;
    for (const stop of stops){
        const r = el.call('onboardingTourRect', stop);
        if (!r) continue;
        ids.push(stop.id);
        if (!rect) rect = r;
    }
    root.update({
        _onboardingTour: {
            at: 0,
            ids: ids,
            rect: rect,
            total: ids.length
        },
        // the tour is the top layer: the welcome and edit mode step aside
        _onboardingOpen: null,
        _homeCustomizeMode: false,
        _homeCustomizeDrawerTucked: false
    }, {
        preventFetch: true
    });
    return true;
}
function $4b88dab743f88b0a$export$a60fac58f24dd8a2(delta) {
    const el = this;
    const root = el && el.state && el.state.root;
    const tour = root && root._onboardingTour;
    if (!tour || typeof root.update !== 'function') return false;
    const ids = Array.isArray(tour.ids) ? tour.ids : [];
    const stops = el.call('onboardingTourStops') || [];
    const step = delta < 0 ? -1 : 1;
    let at = tour.at + step;
    while(at >= 0 && at < ids.length){
        const stop = stops.find((s)=>s.id === ids[at]);
        const rect = stop ? el.call('onboardingTourRect', stop) : null;
        if (rect) {
            root.update({
                _onboardingTour: {
                    ...tour,
                    at: at,
                    rect: rect
                }
            }, {
                preventFetch: true
            });
            return true;
        }
        at += step;
    }
    if (at < 0) return false;
    root.update({
        _onboardingTour: {
            ...tour,
            at: ids.length,
            rect: null
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $4b88dab743f88b0a$export$fcae8eebdf920d19() {
    const el = this;
    const root = el && el.state && el.state.root;
    const tour = root && root._onboardingTour;
    if (!tour || typeof root.update !== 'function') return false;
    const ids = Array.isArray(tour.ids) ? tour.ids : [];
    if (tour.at >= ids.length) return false;
    const stops = el.call('onboardingTourStops') || [];
    const stop = stops.find((s)=>s.id === ids[tour.at]);
    const rect = stop ? el.call('onboardingTourRect', stop) : null;
    const prev = tour.rect;
    if (rect && prev && rect.x === prev.x && rect.y === prev.y && rect.w === prev.w && rect.h === prev.h && rect.room === prev.room) return false;
    if (!rect) return el.call('onboardingTourGo', 1);
    root.update({
        _onboardingTour: {
            ...tour,
            rect: rect
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $4b88dab743f88b0a$export$97f8658b50094461() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function' || !root._onboardingTour) return false;
    root.update({
        _onboardingTour: null
    }, {
        preventFetch: true
    });
    return true;
}
function $4b88dab743f88b0a$export$41a5bfe6d32f8a2d(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const tour = r && r._onboardingTour;
    if (!tour) return null;
    const ids = Array.isArray(tour.ids) ? tour.ids : [];
    const stops = el.call('onboardingTourStops') || [];
    const stop = tour.at < ids.length ? stops.find((s)=>s.id === ids[tour.at]) || null : null;
    const text = tour.rect && tour.rect.text || stop && stop.text || '';
    return {
        stop: stop,
        text: text,
        index: tour.at,
        total: ids.length,
        last: tour.at >= ids.length
    };
}
function $4b88dab743f88b0a$export$92aeed824c885d1e(rect, viewportHeight) {
    if (!rect) return 'center';
    const vh = typeof viewportHeight === 'number' && viewportHeight > 0 ? viewportHeight : typeof window !== 'undefined' ? window.innerHeight : 0;
    if (!vh) return 'below';
    const centre = rect.y + rect.h / 2;
    return centre <= vh / 2 ? 'below' : 'above';
}
function $4b88dab743f88b0a$export$db7200a2507adf73(rect) {
    if (!rect) return {};
    const vars = {
        '--tour-x': rect.x + 'px',
        '--tour-y': rect.y + 'px',
        '--tour-w': rect.w + 'px',
        '--tour-h': rect.h + 'px',
        '--tour-cx': Math.round(rect.x + rect.w / 2) + 'px',
        '--tour-bottom': rect.y + rect.h + 'px'
    };
    if (typeof rect.room === 'number') vars['--tour-room'] = rect.room + 'px';
    return vars;
}

});

parcelRegister("iiC3b", function(module, exports) {

$parcel$export(module.exports, "onboardingPresetMode", () => $d5276c72a7c77d2a$export$cffe1610fad1599);
$parcel$export(module.exports, "onboardingIdeaAsked", () => $d5276c72a7c77d2a$export$59e1c56f76b859a);
$parcel$export(module.exports, "onboardingPresetsPrime", () => $d5276c72a7c77d2a$export$a0dd1b100769d284);
$parcel$export(module.exports, "onboardingCatalogApps", () => $d5276c72a7c77d2a$export$152bfa3bcbf6a419);
$parcel$export(module.exports, "onboardingWorkTiles", () => $d5276c72a7c77d2a$export$a5d2d8ec2b07df5b);
$parcel$export(module.exports, "onboardingWorkMore", () => $d5276c72a7c77d2a$export$e0286a89d88f9d76);
$parcel$export(module.exports, "onboardingWorkMoreFocus", () => $d5276c72a7c77d2a$export$1661012f23284ca4);
$parcel$export(module.exports, "onboardingWorkGlyphs", () => $d5276c72a7c77d2a$export$954813f1f3744b32);
$parcel$export(module.exports, "onboardingWorkPick", () => $d5276c72a7c77d2a$export$90189566c169b9bc);
$parcel$export(module.exports, "onboardingWorkAnswer", () => $d5276c72a7c77d2a$export$505f09216680dbbe);
$parcel$export(module.exports, "onboardingPresetName", () => $d5276c72a7c77d2a$export$e7579618547dbc57);
$parcel$export(module.exports, "onboardingWorkView", () => $d5276c72a7c77d2a$export$70599bb145b15160);
$parcel$export(module.exports, "onboardingStackView", () => $d5276c72a7c77d2a$export$e0457b96a36e75da);
$parcel$export(module.exports, "onboardingStackToggle", () => $d5276c72a7c77d2a$export$b64e15de781dd027);
$parcel$export(module.exports, "onboardingStackPlan", () => $d5276c72a7c77d2a$export$61a93734dece157);
$parcel$export(module.exports, "onboardingStackSend", () => $d5276c72a7c77d2a$export$7d9f75d3cae28a53);
$parcel$export(module.exports, "onboardingStackRetry", () => $d5276c72a7c77d2a$export$41ff5dcc433c9119);
$parcel$export(module.exports, "onboardingSetupView", () => $d5276c72a7c77d2a$export$d0076045da223991);
$parcel$export(module.exports, "onboardingSetupRelease", () => $d5276c72a7c77d2a$export$935b92a68d12c21a);
$parcel$export(module.exports, "onboardingIdeaSet", () => $d5276c72a7c77d2a$export$341ac00e82b7f467);
$parcel$export(module.exports, "onboardingNameOf", () => $d5276c72a7c77d2a$export$4b4f7c4f77786d88);
$parcel$export(module.exports, "onboardingNameSet", () => $d5276c72a7c77d2a$export$17d84c355359d9e6);
$parcel$export(module.exports, "onboardingNameSave", () => $d5276c72a7c77d2a$export$f7c4e5899ce7046);
$parcel$export(module.exports, "onboardingIdeaExamples", () => $d5276c72a7c77d2a$export$150f2dd5c6f714ef);
$parcel$export(module.exports, "onboardingIdeaOf", () => $d5276c72a7c77d2a$export$9d83ac0b6ffab1);
$parcel$export(module.exports, "onboardingFootNext", () => $d5276c72a7c77d2a$export$b6a128b73656d921);
$parcel$export(module.exports, "onboardingBuildIdea", () => $d5276c72a7c77d2a$export$4a05b3a82f40a4b8);
// onboardingPresets.js — THE THREE CHOICES of the new-account welcome
// (wt/presets CONTRACT §1 and §5 WIZARD; Nika 2026-10-24: "users should be
// very easily make initial workspaces, by choosing industries, desired apps
// and vibe code new concepts"). The wizard (functions/onboardingWizard.js,
// components/OnboardingWorkStep.js, OnboardingStackStep.js,
// OnboardingIdeaStep.js) and the conversation
// (functions/onboarding.js onboardingPlan) ask the same three, in the same
// order, with the same words:
//
//   work   Your work — an industry IS a Workspace Preset (the store's featured
//          presets, in registry order), or "Something else" (a custom
//          workspace: no preset, the person's own apps)
//   stack  Your apps — the preset's apps ticked (installed ones marked), its
//          suggested apps unticked, the apps the catalog does not carry yet
//          counted (the store sheet's rule); Something else: every App Store
//          app, unticked, the most installed first
//   idea   Your idea — one optional sentence; at Done "Build my app" opens the
//          app builder on it (`/add-app?prompt=<idea>`)
//
// THE DATA IS THE STORE'S (packages/marketplace/functions/workspacePresets.js,
// registered at boot through its eager slice): the registry, the copy, who may
// apply, the ONE apply and its live lines (`root._presetApply`). The apps are
// the shell's own App Store read (`root._wsAppsCatalog`,
// functions/workspaceApps.js loadWorkspaceAppsCatalog), named through the one
// store-copy resolver (storeItemText). Nothing here calls the server.
//
// WHO: an owner/admin of the active workspace (workspacePresetCanApply — the
// person making it). Your work and Your apps only while the host's SDK can
// apply presets (`_workspacePresetsUnsupported`); Your idea whatever the SDK.
// A workspace that already carries `settings.preset` (applied at sign-up from
// a `?preset=` link, or a custom answer) shows what it is set up for and
// sends no second apply.
//
// THE PICKS live in the flow (`root._onboardingFlow.picks`):
//   work   '' | a preset key | 'custom'
//   stack  { [appId]: boolean } — the person's changes over the defaults only
//   idea   the sentence
// `stackSent` names the plan the flow sent: ONE apply per flow. Leaving Your
// apps forward sends it in the BACKGROUND (the flow goes on); a close after a
// work pick sends it too ("Skip" never loses an earlier answer). From then on
// Your work and Your apps show what is being set up, and the done step lists
// every line with its retry.
//
// FRANK: every export is self-contained (FA204) — no import, no module
// constant; siblings through `this.call`.
// Is Your work asked, and how? null — not for this person or this host (a
// member; a host without the store's functions or without the SDK's preset
// calls; a registry that offers no featured preset this surface has words
// for — an older server's — so there is nothing to choose, the store's row
// hides the same way); 'applied' — the workspace carries `settings.preset`
// and this flow sent none; 'pick' — choose. While the registry is read (or
// after a failed read) the step stands, and a flow already on it keeps it: a
// step never vanishes under the person. Every input is read first (reactive
// callers).
function $d5276c72a7c77d2a$export$cffe1610fad1599(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const fns = el && el.context && el.context.functions || {};
    const flow = r && r._onboardingFlow;
    const unsupported = !!(r && r._workspacePresetsUnsupported);
    const list = r ? r._workspacePresets : null;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const settings = ws && ws.settings && typeof ws.settings === 'object' ? ws.settings : null;
    settings && settings.preset;
    r && r.org;
    if (!r || !ws) return null;
    if (typeof fns.workspacePresetCanApply !== 'function' || typeof fns.workspacePresetApplied !== 'function' || typeof fns.workspacePresetApply !== 'function') return null;
    if (unsupported || !el.call('workspacePresetCanApply', r)) return null;
    if (flow && flow.stackSent) return 'pick';
    if (el.call('workspacePresetApplied', r)) return 'applied';
    const holding = !!(flow && (flow.step === 'work' || flow.step === 'stack' || flow.picks && flow.picks.work));
    if (Array.isArray(list) && !holding) {
        const featured = typeof fns.workspacePresetsFeatured === 'function' ? el.call('workspacePresetsFeatured', r) || [] : [];
        const named = featured.some((p)=>!!p && !!el.call('workspacePresetText', p.key, 'name'));
        if (!named) return null;
    }
    return 'pick';
}
function $d5276c72a7c77d2a$export$59e1c56f76b859a(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const fns = el && el.context && el.context.functions || {};
    r && r.workspace;
    r && r.org;
    if (!r || typeof fns.workspacePresetCanApply !== 'function') return false;
    return !!el.call('workspacePresetCanApply', r);
}
function $d5276c72a7c77d2a$export$a0dd1b100769d284(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const fns = el && el.context && el.context.functions || {};
    if (!r || typeof fns.workspacePresetCanApply !== 'function') return false;
    if (!el.call('workspacePresetCanApply', r)) return false;
    if (typeof fns.workspacePresetsLoad === 'function') Promise.resolve(el.call('workspacePresetsLoad')).catch(()=>null);
    if (typeof fns.loadWorkspaceAppsCatalog === 'function' && !r._wsAppsCatalogLoaded && !r._wsAppsCatalogLoading) Promise.resolve(el.call('loadWorkspaceAppsCatalog')).catch(()=>null);
    return true;
}
function $d5276c72a7c77d2a$export$152bfa3bcbf6a419(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const fns = el && el.context && el.context.functions || {};
    const list = r && Array.isArray(r._wsAppsCatalog) ? r._wsAppsCatalog : [];
    const ready = !!(r && r._wsAppsCatalogLoaded);
    const norm = (v)=>String(v || '').trim().toLowerCase();
    const byId = {};
    const order = [];
    for (const a of list){
        if (!a || !a.owner || !a.key) continue;
        const id = norm(a.owner) + '/' + norm(a.key);
        if (byId[id]) continue;
        const named = typeof fns.storeItemText === 'function' ? el.call('storeItemText', {
            key: a.key,
            name: a.name
        }, 'name') : a.name;
        const glyph = !a.icon && typeof fns.glyphNameFor === 'function' ? el.call('glyphNameFor', {
            name: a.name,
            key: a.key
        }, 'ln') : '';
        // the listing's one line about the app (persona round 3, W3: elena —
        // "22 app tiles show one word only, no description"), through the same
        // resolver: the store's own words in the session language, '' for none
        const said = typeof fns.storeItemText === 'function' ? el.call('storeItemText', {
            key: a.key,
            description: a.description
        }, 'description') : a.description;
        byId[id] = {
            id: id,
            title: String(named || a.name || a.key),
            descr: typeof said === 'string' ? said.trim() : '',
            icon: String(a.icon || glyph || ''),
            installs: Number(a.installCount) || 0
        };
        order.push(id);
    }
    return {
        ready: ready,
        order: order,
        byId: byId
    };
}
function $d5276c72a7c77d2a$export$a5d2d8ec2b07df5b(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const fns = el && el.context && el.context.functions || {};
    const flow = r && r._onboardingFlow;
    const work = flow && flow.picks && flow.picks.work || '';
    const list = r && Array.isArray(r._workspacePresets) ? r._workspacePresets : [];
    const featured = typeof fns.workspacePresetsFeatured === 'function' ? el.call('workspacePresetsFeatured', r) || [] : [];
    const tileOf = (p)=>{
        const name = p && el.call('workspacePresetText', p.key, 'name');
        if (!name) return null;
        return {
            key: 'work-' + p.key,
            value: p.key,
            label: name,
            hint: el.call('workspacePresetText', p.key, 'line') || '',
            picked: work === p.key,
            custom: false,
            more: false
        };
    };
    const tiles = featured.map(tileOf).filter(Boolean);
    const rank = (p)=>Number.isFinite(Number(p.order)) ? Number(p.order) : 999;
    const others = list.filter((p)=>p && p.featured !== true && typeof p.key === 'string' && p.key).sort((a, b)=>rank(a) - rank(b)).map(tileOf).filter(Boolean);
    const open = !!(flow && flow.workMore) || others.some((t)=>t.picked);
    if (open) tiles.push(...others);
    tiles.push({
        key: 'work-custom',
        value: 'custom',
        label: 'workspace.onboarding.work.custom',
        hint: 'workspace.onboarding.work.customHint',
        picked: work === 'custom',
        custom: true,
        more: false
    });
    if (!open && others.length) tiles.push({
        key: 'work-more',
        value: '',
        label: 'workspace.onboarding.work.more',
        hint: 'workspace.onboarding.work.moreHint',
        picked: false,
        custom: false,
        more: true
    });
    return tiles;
}
function $d5276c72a7c77d2a$export$e0286a89d88f9d76() {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function' || flow.stackSent || flow.workMore) return false;
    const before = (el.call('onboardingWorkTiles', root) || []).map((t)=>t && t.value);
    root.update({
        _onboardingFlow: {
            ...flow,
            workMore: true
        }
    }, {
        preventFetch: true
    });
    const shown = (el.call('onboardingWorkTiles', root) || []).find((t)=>t && t.value && !t.more && before.indexOf(t.value) === -1);
    if (shown) el.call('onboardingWorkMoreFocus', shown.value);
    return true;
}
function $d5276c72a7c77d2a$export$1661012f23284ca4(value) {
    const el = this;
    if (!el || typeof value !== 'string' || !value) return false;
    const host = typeof el.getRoot === 'function' && el.getRoot() || el;
    const find = ()=>{
        const layer = host && typeof host.lookdown === 'function' && host.lookdown('OnboardingWizard');
        const step = layer && typeof layer.lookdown === 'function' && layer.lookdown('OnboardingWorkStep');
        const grid = step && typeof step.lookdown === 'function' && step.lookdown('OnboardingTileGrid');
        const kids = grid && typeof grid.getChildren === 'function' && grid.getChildren() || [];
        return kids.find((k)=>k && k.state && k.state.value === value) || null;
    };
    const attempt = (left)=>{
        try {
            const tile = find();
            const node = tile && tile.node;
            const doc = node && node.ownerDocument;
            const active = doc && doc.activeElement;
            const free = !active || active === doc.body || !active.isConnected;
            if (node && node.isConnected && typeof node.focus === 'function' && (free || active === node)) {
                node.focus({
                    preventScroll: false
                });
                if (doc.activeElement === node) return;
            } else if (node && node.isConnected && !free) return;
        } catch (_) {
        /* focus is a courtesy — never an error */ }
        if (left > 0) {
            if (typeof requestAnimationFrame === 'function') requestAnimationFrame(()=>attempt(left - 1));
            else setTimeout(()=>attempt(left - 1), 16);
        }
    };
    setTimeout(()=>attempt(8), 0);
    return true;
}
function $d5276c72a7c77d2a$export$954813f1f3744b32(value, root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    r && r._wsAppsCatalog;
    r && r._workspacePresets;
    if (value === 'custom') return [
        {
            key: 'glyph-0',
            icon: 'plus',
            title: ''
        }
    ];
    if (!value) return [
        {
            key: 'glyph-0',
            icon: 'chevronDown',
            title: ''
        }
    ];
    const preset = value ? el.call('workspacePresetByKey', value, r) : null;
    if (!preset) return [];
    const byId = (el.call('onboardingCatalogApps', r) || {}).byId || {};
    const out = [];
    for (const id of preset.apps || []){
        const app = byId[String(id || '').toLowerCase()];
        if (app && out.length < 6) out.push({
            key: 'glyph-' + out.length,
            icon: app.icon,
            title: app.title
        });
    }
    return out;
}
function $d5276c72a7c77d2a$export$90189566c169b9bc(value, opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function' || flow.stackSent) return false;
    if (typeof value !== 'string' || !value) return false;
    const picks = flow.picks && typeof flow.picks === 'object' ? flow.picks : {};
    const toggle = !!(opts && opts.toggle);
    const next = toggle && picks.work === value ? '' : value;
    const same = picks.work === next;
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: true,
            picks: {
                ...picks,
                work: next,
                stack: same ? picks.stack || {} : {}
            }
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $d5276c72a7c77d2a$export$505f09216680dbbe(value) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!el.call('onboardingWorkPick', value)) return false;
    const flow = root && root._onboardingFlow;
    if (flow) root.update({
        _onboardingFlow: {
            ...flow,
            workViaChat: true
        }
    }, {
        preventFetch: true
    });
    el.call('onboardingStackSend');
    return true;
}
function $d5276c72a7c77d2a$export$e7579618547dbc57(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    const work = flow && flow.picks && flow.picks.work || '';
    const fns = el && el.context && el.context.functions || {};
    if (typeof fns.workspacePresetText !== 'function') return '';
    if (work && work !== 'custom') return el.call('workspacePresetText', work, 'name') || '';
    if (work === 'custom' || typeof fns.workspacePresetApplied !== 'function') return '';
    const applied = el.call('workspacePresetApplied', r);
    const key = applied && applied.key;
    return key && key !== 'custom' ? el.call('workspacePresetText', key, 'name') || '' : '';
}
function $d5276c72a7c77d2a$export$70599bb145b15160(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    const apply = r ? r._presetApply : null;
    const list = r ? r._workspacePresets : null;
    const error = r ? r._workspacePresetsError : null;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const wsId = ws ? String(ws._id || ws.id || '') : '';
    const t = (k)=>String(el.call('polyglot', k) || '');
    const out = {
        mode: null,
        state: 'tiles',
        title: '',
        hint: '',
        done: false,
        loading: false,
        failed: false
    };
    const mode = el.call('onboardingPresetMode', r);
    out.mode = mode;
    if (!mode) return out;
    const named = (custom, name)=>{
        if (custom) return t('workspace.onboarding.work.appliedCustom');
        if (!name) return t('workspace.onboarding.work.appliedOther');
        return t('workspace.onboarding.work.applied').replace('{preset}', name);
    };
    if (mode === 'applied') {
        const applied = el.call('workspacePresetApplied', r) || {};
        const custom = applied.key === 'custom';
        const name = custom ? '' : el.call('workspacePresetText', applied.key, 'name') || '';
        out.state = 'applied';
        out.done = true;
        out.title = named(custom, name);
        out.hint = name ? el.call('workspacePresetText', applied.key, 'line') || '' : '';
        return out;
    }
    if (flow && flow.stackSent) {
        const key = flow.picks && flow.picks.work || '';
        const custom = key === 'custom';
        const name = custom ? '' : el.call('workspacePresetText', key, 'name') || '';
        const mine = apply && apply.key === key && String(apply.workspaceId || '') === wsId ? apply : null;
        out.state = 'sent';
        if (mine && mine.status === 'error') {
            out.title = t(mine.error === 'forbidden' ? 'marketplace.preset.errorForbidden' : 'marketplace.preset.errorFailed');
            return out;
        }
        out.done = !!mine && mine.status === 'done';
        out.title = out.done ? named(custom, name) : custom ? t('workspace.onboarding.work.applyingCustom') : t('workspace.onboarding.work.applying').replace('{preset}', name);
        out.hint = name ? el.call('workspacePresetText', key, 'line') || '' : '';
        return out;
    }
    out.loading = !Array.isArray(list) && error !== 'failed';
    out.failed = !Array.isArray(list) && error === 'failed';
    return out;
}
function $d5276c72a7c77d2a$export$e0457b96a36e75da(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const fns = el && el.context && el.context.functions || {};
    const flow = r && r._onboardingFlow;
    const picks = flow && flow.picks || {};
    const work = picks.work || '';
    const stack = picks.stack && typeof picks.stack === 'object' ? picks.stack : {};
    const sent = !!(flow && flow.stackSent);
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const settings = ws && ws.settings && typeof ws.settings === 'object' && ws.settings || {};
    r && r._wsAppsCatalog;
    r && r._workspacePresets;
    const out = {
        work: work,
        custom: work === 'custom',
        ready: false,
        rows: [],
        soon: 0,
        soonText: '',
        picked: 0,
        total: 0,
        countText: ''
    };
    if (!work) return out;
    const norm = (v)=>String(v || '').trim().toLowerCase();
    const cat = el.call('onboardingCatalogApps', r) || {
        ready: false,
        order: [],
        byId: {}
    };
    out.ready = !!cat.ready;
    const installedIds = ((typeof fns.installedWorkspaceAppIds === 'function' ? el.call('installedWorkspaceAppIds', settings) : null) || []).map(norm);
    // THE PRESET'S OWN WORDS for an app (persona round 5, sam: Your apps read
    // each app's generic store line): the picked preset's
    // `setup.appWords['<owner>/<key>'][lang]`, in the session language, else
    // the store's own line (a registry without the words — an older server's).
    const preset = out.custom ? null : el.call('workspacePresetByKey', work, r);
    const setup = preset && preset.setup && typeof preset.setup === 'object' ? preset.setup : {};
    const appWords = setup.appWords && typeof setup.appWords === 'object' && !Array.isArray(setup.appWords) ? setup.appWords : {};
    const lang = String(typeof fns.getActiveLang === 'function' && el.call('getActiveLang') || 'en');
    const wordsOf = (id)=>{
        for (const k of Object.keys(appWords)){
            if (norm(k) !== id) continue;
            const said = appWords[k] && typeof appWords[k] === 'object' ? appWords[k][lang] : null;
            if (typeof said === 'string' && said.trim()) return said.trim();
        }
        return '';
    };
    const row = (id, suggested)=>{
        const app = cat.byId[id];
        const installed = installedIds.indexOf(id) !== -1;
        const own = Object.prototype.hasOwnProperty.call(stack, id);
        const picked = own ? !!stack[id] : !out.custom && !suggested;
        return {
            key: 'stack-' + id.replace(/[^a-z0-9]+/g, '-'),
            id: id,
            label: '',
            title: app.title,
            descr: wordsOf(id) || app.descr || '',
            icon: app.icon,
            picked: installed || picked,
            installed: installed,
            suggested: !!suggested,
            toggleable: !installed && !sent,
            hint: installed ? 'marketplace.preset.appInstalled' : suggested ? 'marketplace.preset.appSuggested' : ''
        };
    };
    if (out.custom) {
        // the most installed first; a tie keeps the catalog's own order
        const ids = cat.order.map((id, at)=>({
                id: id,
                at: at
            })).sort((a, b)=>cat.byId[b.id].installs - cat.byId[a.id].installs || a.at - b.at);
        for (const { id: id } of ids)out.rows.push(row(id, false));
    } else {
        const seen = [];
        const entries = [];
        for (const id of preset && preset.apps || [])entries.push({
            id: norm(id),
            suggested: false
        });
        for (const id of preset && preset.suggested || [])entries.push({
            id: norm(id),
            suggested: true
        });
        for (const entry of entries){
            if (!entry.id || seen.indexOf(entry.id) !== -1) continue;
            seen.push(entry.id);
            if (!cat.byId[entry.id]) {
                if (cat.ready) out.soon++;
                continue;
            }
            out.rows.push(row(entry.id, entry.suggested));
        }
    }
    out.total = out.rows.length;
    out.picked = out.rows.filter((x)=>x.picked).length;
    const t = (k)=>String(el.call('polyglot', k) || '');
    out.soonText = !out.soon ? '' : out.soon === 1 ? t('marketplace.preset.comingSoonOne') : t('marketplace.preset.comingSoon').replace('{count}', String(out.soon));
    out.countText = out.total ? t('workspace.onboarding.wizard.appsCount').replace('{n}', String(out.picked)).replace('{total}', String(out.total)) : '';
    return out;
}
function $d5276c72a7c77d2a$export$b64e15de781dd027(id) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function' || flow.stackSent || !id) return false;
    const view = el.call('onboardingStackView', root) || {
        rows: []
    };
    const row = (view.rows || []).find((x)=>x.id === id);
    if (!row || !row.toggleable) return false;
    const picks = flow.picks && typeof flow.picks === 'object' ? flow.picks : {};
    const stack = picks.stack && typeof picks.stack === 'object' ? picks.stack : {};
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: true,
            picks: {
                ...picks,
                stack: {
                    ...stack,
                    [id]: !row.picked
                }
            }
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $d5276c72a7c77d2a$export$61a93734dece157(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const view = el.call('onboardingStackView', r) || {};
    if (!view.work) return null;
    const include = [];
    const exclude = [];
    for (const row of view.rows || []){
        if (row.installed) continue;
        if (view.custom) {
            if (row.picked) include.push(row.id);
            continue;
        }
        if (row.suggested && row.picked) include.push(row.id);
        if (!row.suggested && !row.picked) exclude.push(row.id);
    }
    return {
        key: view.work,
        include: include.slice(0, 20),
        exclude: exclude
    };
}
function $d5276c72a7c77d2a$export$7d9f75d3cae28a53() {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function' || flow.stackSent) return null;
    if (el.call('onboardingPresetMode', root) !== 'pick') return null;
    const plan = el.call('onboardingStackPlan', root);
    if (!plan || !plan.key) return null;
    const sig = [
        plan.key,
        plan.include.join(','),
        plan.exclude.join(',')
    ].join('|');
    const now = root._onboardingFlow || flow;
    root.update({
        _onboardingFlow: {
            ...now,
            stackSent: sig,
            progressed: true
        }
    }, {
        preventFetch: true
    });
    const opts = plan.key === 'custom' ? {
        include: plan.include
    } : {
        include: plan.include,
        exclude: plan.exclude,
        setup: true
    };
    return Promise.resolve(el.call('workspacePresetApply', plan.key, opts)).catch(()=>null);
}
function $d5276c72a7c77d2a$export$41ff5dcc433c9119() {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || !flow.stackSent) return null;
    const view = el.call('onboardingSetupView', root) || {};
    if (!view.retryable) return null;
    const plan = el.call('onboardingStackPlan', root);
    if (!plan || !plan.key) return null;
    const opts = plan.key === 'custom' ? {
        include: plan.include
    } : {
        include: plan.include,
        exclude: plan.exclude,
        setup: true
    };
    return Promise.resolve(el.call('workspacePresetApply', plan.key, opts)).catch(()=>null);
}
function $d5276c72a7c77d2a$export$d0076045da223991(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    const apply = r ? r._presetApply : null;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const wsId = ws ? String(ws._id || ws.id || '') : '';
    r && r._wsAppsCatalog;
    const t = (k)=>String(el.call('polyglot', k) || '');
    const out = {
        show: false,
        status: '',
        title: '',
        lines: [],
        soonText: '',
        setupText: '',
        errorText: '',
        retryable: false
    };
    if (!flow || !flow.stackSent) return out;
    const key = flow.picks && flow.picks.work || '';
    const custom = key === 'custom';
    const mine = apply && apply.key === key && String(apply.workspaceId || '') === wsId ? apply : null;
    if (!mine) return out;
    out.status = mine.status;
    if (mine.status === 'error') {
        out.show = true;
        out.errorText = t(mine.error === 'forbidden' ? 'marketplace.preset.errorForbidden' : 'marketplace.preset.errorFailed');
        out.retryable = mine.error === 'failed' || mine.error === 'busy';
        return out;
    }
    const byId = (el.call('onboardingCatalogApps', r) || {}).byId || {};
    const STATE_KEYS = {
        pending: 'marketplace.preset.linePending',
        installed: 'marketplace.preset.lineInstalled',
        skipped: 'marketplace.preset.lineSkipped',
        failed: 'marketplace.preset.lineFailed'
    };
    let soon = 0;
    let unnamedFailed = 0;
    for (const line of Array.isArray(mine.lines) ? mine.lines : []){
        const id = String(line && line.appId || '').toLowerCase();
        const app = byId[id];
        if (!app) {
            // no catalog row, so no name: an app this environment does not carry
            // is counted as coming soon; any other failure still asks for a retry
            if (line && line.state === 'failed' && line.error !== 'app_not_found') unnamedFailed++;
            else if (line && (line.state === 'pending' || line.state === 'failed')) soon++;
            continue;
        }
        const state = line.state in STATE_KEYS ? line.state : 'failed';
        const comingSoon = state === 'failed' && line.error === 'app_not_found';
        out.lines.push({
            key: 'line-' + id.replace(/[^a-z0-9]+/g, '-'),
            id: id,
            title: app.title,
            icon: app.icon,
            state: state,
            done: state === 'installed' || state === 'skipped',
            failed: state === 'failed' && !comingSoon,
            stateKey: comingSoon ? 'marketplace.preset.lineComingSoon' : STATE_KEYS[state]
        });
    }
    const count = (n, many, one)=>n === 1 ? t(one) : t(many).replace('{count}', String(n));
    out.soonText = soon ? count(soon, 'marketplace.preset.comingSoon', 'marketplace.preset.comingSoonOne') : '';
    const setup = mine.result && mine.result.setup;
    const failedIn = (part)=>setup && setup[part] && Array.isArray(setup[part].failed) ? setup[part].failed.length : 0;
    const setupFailed = failedIn('channels') + failedIn('folders');
    const madeIn = (part)=>setup && setup[part] ? (Array.isArray(setup[part].created) ? setup[part].created.length : 0) + (Array.isArray(setup[part].existing) ? setup[part].existing.length : 0) : 0;
    if (mine.status === 'done') {
        if (setupFailed) out.setupText = count(setupFailed, 'marketplace.preset.setupFailed', 'marketplace.preset.setupFailedOne');
        else if (madeIn('channels') + madeIn('folders') > 0) out.setupText = t('marketplace.preset.setupReady');
    }
    out.retryable = mine.status === 'done' && (unnamedFailed > 0 || setupFailed > 0 || out.lines.some((l)=>l.failed));
    const name = custom ? '' : el.call('workspacePresetText', key, 'name') || '';
    if (mine.status === 'running') out.title = t('marketplace.preset.progressTitle');
    else if (custom) out.title = t(out.retryable ? 'workspace.onboarding.setup.partialCustom' : 'workspace.onboarding.setup.doneCustom');
    else out.title = t(out.retryable ? 'marketplace.preset.donePartial' : 'marketplace.preset.doneLine').replace('{name}', name);
    out.show = out.lines.length > 0 || soon > 0 || !!out.setupText || out.retryable || !custom;
    return out;
}
function $d5276c72a7c77d2a$export$935b92a68d12c21a() {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || !flow.stackSent || typeof root.update !== 'function') return false;
    const key = flow.picks && flow.picks.work || '';
    const apply = root._presetApply;
    if (!apply || apply.key !== key || apply.status === 'running') return false;
    root.update({
        _presetApply: null
    });
    return true;
}
function $d5276c72a7c77d2a$export$341ac00e82b7f467(text) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function') return false;
    const idea = String(text == null ? '' : text).replace(/[\r\n]+/g, ' ').slice(0, 200);
    const picks = flow.picks && typeof flow.picks === 'object' ? flow.picks : {};
    if ((picks.idea || '') === idea) return true;
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: !!(flow.progressed || idea.trim()),
            picks: {
                ...picks,
                idea: idea
            }
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $d5276c72a7c77d2a$export$4b4f7c4f77786d88(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    const picks = flow && flow.picks && typeof flow.picks === 'object' ? flow.picks : null;
    if (picks && typeof picks.name === 'string') return picks.name;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    return ws ? String(ws.displayName || ws.name || '') : '';
}
function $d5276c72a7c77d2a$export$17d84c355359d9e6(text) {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function') return false;
    const name = String(text == null ? '' : text).replace(/[\r\n]+/g, ' ').slice(0, 60);
    const picks = flow.picks && typeof flow.picks === 'object' ? flow.picks : {};
    if (picks.name === name) return true;
    root.update({
        _onboardingFlow: {
            ...flow,
            progressed: !!(flow.progressed || name.trim()),
            picks: {
                ...picks,
                name: name
            }
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $d5276c72a7c77d2a$export$f7c4e5899ce7046() {
    const el = this;
    const root = el && el.state && el.state.root;
    const flow = root && root._onboardingFlow;
    if (!flow || typeof root.update !== 'function') return null;
    const picks = flow.picks && typeof flow.picks === 'object' ? flow.picks : {};
    if (typeof picks.name !== 'string') return null;
    const name = picks.name.replace(/\s+/g, ' ').trim();
    const ws = root.workspace && typeof root.workspace === 'object' ? root.workspace : null;
    const wsId = ws && (ws.id || ws._id);
    if (!name || !wsId || flow.nameSent === name) return null;
    if (String(ws.displayName || ws.name || '') === name) return null;
    root.update({
        _onboardingFlow: {
            ...root._onboardingFlow || flow,
            nameSent: name
        }
    }, {
        preventFetch: true
    });
    return Promise.resolve(el.call('workspaceRename', root, wsId, name)).catch(()=>null).then((out)=>{
        if (out && (out.ok || out.reason === 'same')) return out;
        const now = root._onboardingFlow;
        if (now && now.nameSent === name) root.update({
            _onboardingFlow: {
                ...now,
                nameSent: null
            }
        }, {
            preventFetch: true
        });
        el.call('openNotification', {
            title: el.call('polyglot', 'admin.workspaceSettings.nameFailed'),
            type: 'error'
        });
        return out;
    });
}
function $d5276c72a7c77d2a$export$150f2dd5c6f714ef() {
    return [
        {
            key: 'idea-1',
            label: 'workspace.onboarding.idea.example1'
        },
        {
            key: 'idea-2',
            label: 'workspace.onboarding.idea.example2'
        },
        {
            key: 'idea-3',
            label: 'workspace.onboarding.idea.example3'
        }
    ];
}
function $d5276c72a7c77d2a$export$9d83ac0b6ffab1(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    return String(flow && flow.picks && flow.picks.idea || '').replace(/\s+/g, ' ').trim();
}
function $d5276c72a7c77d2a$export$b6a128b73656d921(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow || {};
    const work = flow.picks && flow.picks.work || '';
    const idea = el.call('onboardingIdeaOf', r);
    if (flow.step === 'work') {
        const view = el.call('onboardingWorkView', r) || {};
        if (view.state === 'tiles' && !work) return 'workspace.onboarding.chat.skipQuestion';
    }
    if (flow.step === 'idea' && !idea) return 'workspace.onboarding.chat.skipQuestion';
    return 'workspace.onboarding.wizard.next';
}
function $d5276c72a7c77d2a$export$4a05b3a82f40a4b8(text) {
    const el = this;
    const idea = String(text || '').replace(/\s+/g, ' ').trim().slice(0, 200);
    if (!idea || !el || typeof el.router !== 'function') return false;
    const root = el.state && el.state.root || null;
    if (!el.call('addAppPromptPark', idea, root)) return false;
    el.router('/add-app', el.getRoot());
    return true;
}

});

parcelRegister("pSCVI", function(module, exports) {

$parcel$export(module.exports, "onboardingReadyMade", () => $04dcb5adbbf9014d$export$78856e5027cd2f52);
$parcel$export(module.exports, "onboardingReadyOpen", () => $04dcb5adbbf9014d$export$ae5096b3d7814d97);
$parcel$export(module.exports, "onboardingReadyView", () => $04dcb5adbbf9014d$export$1b78bdee4670cda3);
// onboardingReady.js — FLY'S READY SCREEN, the one welcome a person who signed
// up through Fly meets (Nika 2026-10-25, "Short ready screen (Recommended)":
// skip the steps Fly already answered — industry, idea, company — show one
// "Your workspace is ready" screen with the tour offer, and mark the welcome
// done only after a welcome really showed).
//
// WHO: Fly's record — `user_preferences.onboarding = { v: 1, status:
// 'pending', via: 'fly', at }`, written by Make it real where the person had no
// onboarding record (functions/onboarding.js onboardingEligible, reason
// 'fly-ready'). Any other record is a decision and shows nothing.
//
// WHAT: ONE step of the welcome wizard's own surface (components/
// OnboardingWizard.js — its shell, its studio, its title and lead, the
// OnboardingWay tour row and the OnboardingSetupLine rows; components/
// OnboardingReadyStep.js is the step). It says the workspace is ready, lists
// what Fly made — the workspace's apps (the launcher's custom tiles) and its
// website project, the facts the Fly start screen's "Get started" block reads
// (functions/assistantFlyFirstRun.js) — and offers the quick tour and a plain
// close. It asks nothing Fly asked already.
//
// WHEN IT WRITES: `done` only after the screen really showed — `via: 'fly'` on
// close (Escape or Start working: closeOnboarding → onboardingCloseDecision),
// `via: 'tour'` when the tour starts (onboardingChoose) — through the same
// single-flight onboardingDecide every welcome decision uses. A replay never
// writes.
//
// THE BUILD KEEPS RUNNING: the screen opens over the route Fly handed over to.
// On the app builder (`/add-app?prompt=<idea>&fly=`) the idea's first build is
// sent by the builder itself (functions/addAppPrompt.js) and nothing here
// touches it; the page behind is inert, never gone, and closing the screen
// shows the build thread.
//
// NO LAYOUT SHIFT (Rule 66): the facts are read BEFORE the surface opens and
// frozen into the flow (`flow.made`) — a row that landed later would move a
// screen the person is reading.
//
// FRANK: every export is self-contained (FA204) — the caps and the waits are
// restated where they are used; siblings are reached through `this.call`.
// The facts the screen shows, from the root as it is now:
//   apps  the workspace's own apps — the launcher's custom tiles (the house
//         apps every workspace has are not "what Fly made"), each named as the
//         App Store names it
//   site  the newest website project of this workspace, if any
// Titles stay as the tile carries them (a bundle key or the customer's own
// words — onboardingReadyView resolves them through polyglot at render, so a
// language switch is followed); a website project with no name is the bundle
// key of the default name.  → { apps: [{ title, icon }], site: { title } | null }
function $04dcb5adbbf9014d$export$78856e5027cd2f52(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const fns = el && el.context && el.context.functions || {};
    const apps = [];
    if (r && typeof fns.visibleStarterTiles === 'function') for (const tile of el.call('visibleStarterTiles', r) || []){
        if (!tile || !tile.custom || !tile.route) continue;
        // An installed app's tile (it carries `appKey`) reads its App Store name —
        // "app names = what a person sees in the workspace App Store" (Nika
        // 2026-10-23), through the same resolver every shell surface uses
        // (functions/installedAppName.js); a customer's own tile, or a shell
        // without that resolver, keeps the tile's own words.
        const named = tile.appKey && typeof fns.installedAppName === 'function' ? String(el.call('installedAppName', {
            appKey: tile.appKey,
            title: tile.title
        }) || '').trim() : '';
        const title = named || String(tile.title || '').trim();
        if (!title) continue;
        apps.push({
            title: title,
            icon: String(tile.icon || '')
        });
    }
    let site = null;
    if (r && typeof fns.assistantFlyFirstRunSites === 'function') {
        const first = (el.call('assistantFlyFirstRunSites', r) || [])[0];
        // a project with no name of its own reads as the default name ("Website"),
        // never as its slug
        if (first) site = {
            title: String(first.name || '').trim() || 'workspace.onboarding.ready.siteDefault'
        };
    }
    // THE IDEA (persona round 5, aiko: "my idea was not on it … so I feared it
    // was lost"): the app the person asked Fly for, whose first build runs
    // behind this screen. Read where it waits or went, first answer wins: the
    // setup thread's plan note (`concepts[0].text`), the text parked for the
    // builder (this tab's `symbols_add_app_prompt`, or the root's hold where
    // storage is refused), the idea Fly held on the workspace
    // (`settings.pendingIdea`), else the first message the person sent in the
    // build thread. → '' when there is none.
    const ideaOf = ()=>{
        const text = (v)=>typeof v === 'string' ? v.trim() : '';
        const msgs = r && Array.isArray(r._ax_chatMessages) ? r._ax_chatMessages : [];
        const note = msgs.find((m)=>m && m.metadata && m.metadata.kind === 'note' && m.metadata.plan);
        const plan = note && typeof note.metadata.plan === 'object' ? note.metadata.plan : null;
        const concept = plan && Array.isArray(plan.concepts) ? plan.concepts[0] : null;
        if (concept && text(concept.text)) return text(concept.text);
        try {
            const store = typeof window !== 'undefined' && window.sessionStorage;
            const parked = store ? JSON.parse(store.getItem('symbols_add_app_prompt') || 'null') : null;
            if (parked && text(parked.text)) return text(parked.text);
        } catch (_) {
        /* no storage, or a bad park — the next source answers */ }
        if (r && text(r.__addAppPromptHeld)) return text(r.__addAppPromptHeld);
        const held = r && r.workspace && r.workspace.settings && r.workspace.settings.pendingIdea;
        if (held && held.v === 1 && text(held.text)) return text(held.text);
        const first = msgs.find((m)=>m && m.role === 'user' && text(m.text));
        return first ? text(first.text) : '';
    };
    return {
        apps: apps,
        site: site,
        idea: ideaOf()
    };
}
function $04dcb5adbbf9014d$export$ae5096b3d7814d97(opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return Promise.resolve(false);
    const o = opts && typeof opts === 'object' ? opts : {};
    const waitMs = typeof o.waitMs === 'number' && o.waitMs >= 0 ? o.waitMs : 1200;
    const fns = el.context && el.context.functions || {};
    let read = Promise.resolve();
    if (!Array.isArray(root._projectsForActiveOrg) && typeof fns.canvasAnswerRead === 'function') try {
        read = Promise.resolve(el.call('canvasAnswerRead', el)).catch(()=>null);
    } catch (_) {
        read = Promise.resolve();
    }
    let timer = null;
    const cap = new Promise((resolve)=>{
        timer = setTimeout(resolve, waitMs);
    });
    // The gate cleared the hold's own timer when it found the person eligible,
    // so a screen that does not open must let the hold's surface go itself.
    const letGo = ()=>{
        if (root._onboardingHold && !root._onboardingFlow) root.update({
            _onboardingHold: false
        }, {
            preventFetch: true
        });
        return false;
    };
    return Promise.race([
        read,
        cap
    ]).then(()=>{
        if (timer) clearTimeout(timer);
        if (root._onboardingFlow || root._onboardingDecision) return letGo();
        const opened = el.call('openOnboarding', 'ready', {
            made: el.call('onboardingReadyMade', root)
        });
        return opened ? true : letGo();
    }).catch((err)=>{
        console.warn('[onboarding] the ready screen did not open:', err && err.message);
        return letGo();
    });
}
function $04dcb5adbbf9014d$export$1b78bdee4670cda3(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const flow = r && r._onboardingFlow;
    const made = flow && flow.made && typeof flow.made === 'object' ? flow.made : null;
    const CAP = 6;
    const word = (k)=>String(el.call('polyglot', k) || '');
    // a row is a name and the plain tick: a state WORD beside it would squeeze
    // the name in a half-width cell (Georgian sets 15-40% longer) and says
    // nothing the caption does not
    const row = (key, title, icon)=>({
            key: key,
            id: key,
            title: String(el.call('polyglot', title) || title || ''),
            icon: icon,
            state: 'installed',
            done: true,
            failed: false,
            stateKey: ''
        });
    const list = made && Array.isArray(made.apps) ? made.apps : [];
    const rows = list.slice(0, CAP).map((a, i)=>row('ready-app-' + (i + 1), a.title, String(a.icon || '') || 'blocks'));
    // The person's idea first — the person's own words (never a bundle key),
    // on one short line, and "Building now" where the tick would be: its first
    // build runs behind this screen.
    const idea = made && typeof made.idea === 'string' ? made.idea.trim().replace(/\s+/g, ' ') : '';
    if (idea) {
        const MAX = 90;
        rows.unshift({
            key: 'ready-idea-1',
            id: 'ready-idea-1',
            title: idea.length > MAX ? idea.slice(0, MAX - 1).trimEnd() + "\u2026" : idea,
            icon: 'magicstar',
            state: 'building',
            done: false,
            failed: false,
            stateKey: 'workspace.onboarding.ready.ideaBuilding'
        });
    }
    if (made && made.site && made.site.title) rows.push(row('ready-site-1', made.site.title, 'globe'));
    const extra = list.length - CAP;
    const moreText = extra > 0 ? extra === 1 ? word('workspace.onboarding.ready.moreOne') : word('workspace.onboarding.ready.more').replace('{count}', String(extra)) : '';
    return {
        show: rows.length > 0,
        rows: rows,
        moreText: moreText
    };
}

});

parcelRegister("l6XrB", function(module, exports) {

$parcel$export(module.exports, "onboardingBuildRead", () => $f5e844df4e3ecfa3$export$593e3fa09e3050f1);
$parcel$export(module.exports, "onboardingBuildPoll", () => $f5e844df4e3ecfa3$export$b79d7bca8de16745);
$parcel$export(module.exports, "onboardingBuildOpen", () => $f5e844df4e3ecfa3$export$fb581f89835d29ec);
$parcel$export(module.exports, "onboardingBuildRetry", () => $f5e844df4e3ecfa3$export$85c5efc5a5aced29);
$parcel$export(module.exports, "onboardingBuildGo", () => $f5e844df4e3ecfa3$export$7078bbe1aa2de60e);
$parcel$export(module.exports, "onboardingBuildView", () => $f5e844df4e3ecfa3$export$8dfd3dbce1f3054b);
// onboardingBuild.js — THE BUILD BOARD of a personalized sign-up (POB S6,
// PLAN §7b-2; decision 9 of 2026-10-25: the setup steps show IN the
// workspace). A person who signed up with their website read (POB) does not
// meet the welcome wizard: the workspace opens at once on ONE board that shows
// what sign-up really did — one card per server step, each with its live
// state, its result line and, when it made something, a way to it.
//
// WHO: the POB record — `user_preferences.onboarding = { v: 1, status:
// 'pending', via: 'pob', at }`, written by the SERVER at sign-up, write-once
// (the client never writes it; functions/onboarding.js onboardingEligible,
// reason 'pob-build'). The board is the server's: a workspace with no board
// (the sign-up was not POB — server core/pob-board-2 answers 200 with data
// `null`, an older server a 404 `not_found`; both read as "no board") shows
// nothing at all, and the record waits for a load that has one. THE SIGN-UP RACE (POB lead
// 2026-10-30): a Fly write can win the write-once record, so a PENDING FLY
// record whose workspace answers a board (200) is a personalized sign-up too
// — the gate's tick asks the board first on the home (`opts.orElse: 'ready'`
// below) and Fly's ready screen opens only when there is none.
//
// THE DATA IS THE SERVER'S, through the SDK only (feature-detected, never a
// version guess):
//   sdk.getOnboardingBuild(workspaceId)            (any member)
//     → { researchId, steps: [{ key, status: pending | running | done |
//         failed | skipped, label: { en, ka }, result?: { count }, link?,
//         error?: { code }, reason?: { code }, retryable?, at }], done,
//         checklist? }
//     (server core/pob-research 34c695c9c, OnboardingBuild's step schema).
//     The NESTED shape is the only one (POB lead 2026-10-30): a `count` or a
//     `code` flat on the step is not read. A board without a researchId,
//     `done` or a label still reads: done is "every step has an outcome", and
//     a card without a server label is named by the shell's own words.
//     `retryable` (server core/pob-board-2): true only for a failed `apps`
//     step with a preset; false hides Try again; no field (an older server)
//     keeps the client's rule. Kept as true | false | null.
//     `checklist: { profile, website, team, import }`, each `{ done, at }` —
//     the first thread's "Getting started" ticks (functions/
//     assistantFlyResearch.js); the ONE source of them when it is there. An
//     item the server left out is not done; no checklist (an older server)
//     is null.
//   sdk.retryOnboardingBuildStep(workspaceId, key) (manager; a failed step
//     only — v0: apps; 409 `not_retryable` otherwise)
// Step keys of v0: workspace, profile, apps, records, site. A skipped step
// always names its reason and the card says it in words — never a silent
// skip. The card's name is the server's own label, in the session language.
//
// THE POLL: every 2 s while a step is pending or running; it stops when the
// board is done, after 5 minutes (the board then says some steps still run,
// and the person may go on), on a workspace change, or when there is no
// board.
//
// THE WAY ON: "Open my workspace" shows once every step has an outcome (done,
// failed or skipped) — or the 5 minutes passed. Closing the board decides
// `done, via 'pob'` only then (functions/onboarding.js
// onboardingCloseDecision); an early close (Escape) decides nothing, so the
// board comes back on the next load.
//
//   root._pobBuild = { ws, status: 'ok' | 'none' | 'error', at, board, code,
//                      since, timedOut, retrying, note, canRetry }
// `canRetry` — the SDK in this page has `retryOnboardingBuildStep`; without it
// a failed card shows no Try again (no dead button).
//
// FRANK: every export is self-contained (FA204) — the vocabularies and the
// windows are restated where they are used; siblings are reached through
// `this.call`.
// THE READ — one in flight per workspace; an answer for a workspace that is no
// longer active drops itself. A 200 with no data (`null`, or `{ success:
// true, data: null }` — server core/pob-board-2) and a 403 / 404 /
// `not_found` (an older server) are "no board here" (`none`), never an error
// on screen; a failed read keeps the lines already on screen. `opts.sdk` — a
// test seam. → a promise of the stored entry, or null when nothing was asked
// (no workspace, no SDK read).
function $f5e844df4e3ecfa3$export$593e3fa09e3050f1(rootIn, opts) {
    const STATUSES = [
        'pending',
        'running',
        'done',
        'failed',
        'skipped'
    ];
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const root = rootIn || el && el.state && el.state.root || null;
    if (!root || typeof root !== 'object' || typeof root.update !== 'function') return Promise.resolve(null);
    const wsOf = (x)=>{
        const w = x && x.workspace;
        return String(w && (w.id || w._id) || '');
    };
    const wsId = wsOf(root);
    if (!wsId) return Promise.resolve(null);
    const fns = el && el.context && el.context.functions || {};
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    // The feature gate is the method itself (the shell's init-await proxy reads
    // a method the SDK lacks as undefined).
    if (!sdk || sdk.isNullClient === true || typeof sdk.getOnboardingBuild !== 'function') return Promise.resolve(null);
    const flight = root.__pobBuildFlight;
    if (flight && flight.ws === wsId && flight.promise) return flight.promise;
    const prevOf = ()=>root._pobBuild && typeof root._pobBuild === 'object' && root._pobBuild.ws === wsId ? root._pobBuild : null;
    // the nested shape only: `result.count`, `error.code`, `reason.code`
    const count = (x)=>{
        const res = x.result && typeof x.result === 'object' ? x.result : null;
        const n = res && res.count != null ? Number(res.count) : NaN;
        return Number.isFinite(n) && n >= 0 ? Math.floor(n) : null;
    };
    const codeOf = (x)=>x && typeof x === 'object' && typeof x.code === 'string' ? x.code : '';
    // the first thread's four items; one the server left out is not done
    const ITEMS = [
        'profile',
        'website',
        'team',
        'import'
    ];
    const checklist = (c)=>{
        if (!c || typeof c !== 'object' || Array.isArray(c)) return null;
        const out = {};
        for (const k of ITEMS){
            const x = c[k] && typeof c[k] === 'object' ? c[k] : null;
            out[k] = {
                done: !!(x && x.done === true),
                at: x && x.done === true && typeof x.at === 'string' ? x.at : null
            };
        }
        return out;
    };
    const clean = (board)=>({
            researchId: board.researchId ? String(board.researchId) : '',
            done: board.done === true,
            checklist: checklist(board.checklist),
            steps: board.steps.filter((x)=>x && typeof x.key === 'string' && x.key).map((x)=>({
                    key: x.key,
                    status: STATUSES.indexOf(x.status) !== -1 ? x.status : 'pending',
                    label: {
                        en: String(x.label && x.label.en || ''),
                        ka: String(x.label && x.label.ka || '')
                    },
                    count: count(x),
                    link: typeof x.link === 'string' ? x.link : '',
                    error: codeOf(x.error),
                    reason: codeOf(x.reason),
                    retryable: typeof x.retryable === 'boolean' ? x.retryable : null,
                    at: x.at || null
                }))
        });
    const none = (status, code)=>status === '403' || status === '404' || code === 'not_found' || code === 'forbidden';
    const promise = Promise.resolve().then(()=>sdk.getOnboardingBuild(wsId)).then((res)=>{
        const bare = res && typeof res === 'object' && !Array.isArray(res) ? res : null;
        if (bare && bare.success === false) {
            const code = String(bare.error || bare.code || 'failed');
            return none(String(bare.status || ''), code) ? {
                status: 'none',
                board: null,
                code: code
            } : {
                status: 'error',
                board: null,
                code: code
            };
        }
        const board = bare && 'success' in bare && 'data' in bare ? bare.data && typeof bare.data === 'object' ? bare.data : null : bare;
        if (!board) return {
            status: 'none',
            board: null,
            code: ''
        };
        if (!Array.isArray(board.steps)) return {
            status: 'error',
            board: null,
            code: 'shape'
        };
        return {
            status: 'ok',
            board: clean(board),
            code: ''
        };
    }, (err)=>{
        const status = String(err && (err.status || err.statusCode) || '');
        const code = String(err && (err.code || err.error) || status || 'failed');
        return none(status, code) ? {
            status: 'none',
            board: null,
            code: code
        } : {
            status: 'error',
            board: null,
            code: code
        };
    }).then((got)=>{
        if (root.__pobBuildFlight && root.__pobBuildFlight.promise === promise) root.__pobBuildFlight = null;
        if (wsOf(root) !== wsId) return null;
        const prev = prevOf();
        const next = {
            ws: wsId,
            status: got.status,
            at: Date.now(),
            board: got.board,
            code: got.code,
            since: prev && prev.since || Date.now(),
            timedOut: !!(prev && prev.timedOut),
            retrying: prev && prev.retrying || '',
            note: prev && prev.note || '',
            canRetry: typeof sdk.retryOnboardingBuildStep === 'function'
        };
        // An earlier answer stays on screen through a failed poll (a network
        // blip must not wipe the cards the person is reading).
        if (got.status === 'error' && prev && prev.status === 'ok' && prev.board) {
            next.status = 'ok';
            next.board = prev.board;
        }
        root.update({
            _pobBuild: next
        }, {
            preventFetch: true
        });
        return next;
    });
    root.__pobBuildFlight = {
        ws: wsId,
        promise: promise
    };
    return promise;
}
function $f5e844df4e3ecfa3$export$b79d7bca8de16745(rootIn, opts) {
    const EVERY_MS = 2000;
    const MAX_MS = 300000;
    const OUTCOMES = [
        'done',
        'failed',
        'skipped'
    ];
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const root = rootIn || el && el.state && el.state.root || null;
    if (!root || typeof root !== 'object' || !el || typeof el.call !== 'function') return false;
    const wsOf = (x)=>{
        const w = x && x.workspace;
        return String(w && (w.id || w._id) || '');
    };
    const wsId = wsOf(root);
    if (!wsId) return false;
    const every = typeof o.everyMs === 'number' && o.everyMs >= 0 ? o.everyMs : EVERY_MS;
    const max = typeof o.maxMs === 'number' && o.maxMs >= 0 ? o.maxMs : MAX_MS;
    const cur = root.__pobBuildPoll;
    if (cur && cur.ws === wsId && cur.live && !o.force) return true;
    if (cur && cur.timer) clearTimeout(cur.timer);
    const poll = {
        ws: wsId,
        live: true,
        since: Date.now(),
        timer: null,
        tick: null
    };
    root.__pobBuildPoll = poll;
    const end = ()=>{
        poll.live = false;
        if (poll.timer) clearTimeout(poll.timer);
        poll.timer = null;
    };
    const settled = (board)=>!!board && (board.done === true || board.steps.length > 0 && board.steps.every((x)=>OUTCOMES.indexOf(x.status) !== -1));
    // a fresh loop starts a fresh window: the board's own mark goes with it
    const entry = root._pobBuild;
    if (o.force && entry && entry.ws === wsId && entry.timedOut) root.update({
        _pobBuild: {
            ...entry,
            timedOut: false
        }
    }, {
        preventFetch: true
    });
    poll.tick = ()=>{
        poll.timer = null;
        if (!poll.live || root.__pobBuildPoll !== poll) return;
        if (wsOf(root) !== wsId) return end();
        if (Date.now() - poll.since >= max) {
            end();
            const now = root._pobBuild;
            if (now && now.ws === wsId && !now.timedOut) root.update({
                _pobBuild: {
                    ...now,
                    timedOut: true
                }
            }, {
                preventFetch: true
            });
            return;
        }
        Promise.resolve(el.call('onboardingBuildRead', root, {
            sdk: o.sdk || null
        })).catch(()=>null).then((got)=>{
            if (!poll.live || root.__pobBuildPoll !== poll) return;
            if (!got || got.status === 'none') return end();
            if (got.status === 'ok' && settled(got.board)) return end();
            poll.timer = setTimeout(poll.tick, every);
        });
    };
    poll.tick();
    return true;
}
function $f5e844df4e3ecfa3$export$fb581f89835d29ec(opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return Promise.resolve(false);
    const o = opts && typeof opts === 'object' ? opts : {};
    const waitMs = typeof o.waitMs === 'number' && o.waitMs >= 0 ? o.waitMs : 4000;
    const letGo = ()=>{
        if (root._onboardingHold && !root._onboardingFlow) root.update({
            _onboardingHold: false
        }, {
            preventFetch: true
        });
        return false;
    };
    // no board: the race's way out is Fly's ready screen (it takes the surface
    // and the hold, as the tick's own call did); else the hold lets go
    const noBoard = ()=>{
        if (o.orElse === 'ready' && !root._onboardingFlow) {
            el.call('onboardingReadyOpen');
            return false;
        }
        return letGo();
    };
    let timer = null;
    const cap = new Promise((resolve)=>{
        timer = setTimeout(()=>resolve(null), waitMs);
    });
    let read;
    try {
        read = Promise.resolve(el.call('onboardingBuildRead', root, {
            sdk: o.sdk || null
        })).catch(()=>null);
    } catch (_) {
        read = Promise.resolve(null);
    }
    return Promise.race([
        read,
        cap
    ]).then((got)=>{
        if (timer) clearTimeout(timer);
        if (!got || got.status !== 'ok' || !got.board) return noBoard();
        if (root._onboardingFlow || root._onboardingDecision) return letGo();
        const opened = el.call('openOnboarding', 'build');
        if (!opened) return letGo();
        el.call('onboardingBuildPoll', root, {
            sdk: o.sdk || null
        });
        return true;
    }).catch((err)=>{
        console.warn('[onboarding] the build board did not open:', err && err.message);
        return noBoard();
    });
}
function $f5e844df4e3ecfa3$export$85c5efc5a5aced29(key, opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const root = o.root && typeof o.root === 'object' && o.root || el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return Promise.resolve(false);
    const w = root.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const fns = el && el.context && el.context.functions || {};
    const entry = root._pobBuild;
    if (!wsId || !entry || entry.ws !== wsId || entry.status !== 'ok' || !entry.board) return Promise.resolve(false);
    if (entry.retrying) return Promise.resolve(false);
    const step = entry.board.steps.find((x)=>x.key === key);
    // a failed step only, and never one the server marked `retryable: false`
    if (!step || step.status !== 'failed' || step.retryable === false) return Promise.resolve(false);
    if (typeof fns.currentUserIsAdmin !== 'function' || !el.call('currentUserIsAdmin', root)) return Promise.resolve(false);
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || typeof sdk.retryOnboardingBuildStep !== 'function') return Promise.resolve(false);
    root.update({
        _pobBuild: {
            ...entry,
            retrying: key,
            note: ''
        }
    }, {
        preventFetch: true
    });
    const settle = (ok, note)=>{
        const cur = root._pobBuild;
        if (cur && cur.ws === wsId) root.update({
            _pobBuild: {
                ...cur,
                retrying: '',
                note: note || ''
            }
        }, {
            preventFetch: true
        });
        if (ok) el.call('onboardingBuildPoll', root, {
            force: true,
            sdk: o.sdk || null
        });
        return ok;
    };
    return Promise.resolve().then(()=>sdk.retryOnboardingBuildStep(wsId, key)).then((res)=>{
        const bare = res && typeof res === 'object' ? res : null;
        if (bare && bare.success === false) {
            const code = String(bare.error || bare.code || '');
            return settle(false, code === 'not_retryable' ? 'refused' : 'failed');
        }
        return settle(true, '');
    }, (err)=>{
        const status = String(err && (err.status || err.statusCode) || '');
        const code = String(err && (err.code || err.error) || '');
        console.warn('[onboarding] build retry refused:', status || code);
        return settle(false, status === '409' || code === 'not_retryable' ? 'refused' : 'failed');
    });
}
function $f5e844df4e3ecfa3$export$7078bbe1aa2de60e(href) {
    const el = this;
    const to = typeof href === 'string' ? href : '';
    if (!el || !to || to.charAt(0) !== '/') return false;
    el.call('closeOnboarding', 'close');
    const host = typeof el.getRoot === 'function' && el.getRoot() || el;
    setTimeout(()=>host.call('openInSlot', to, host), 320);
    return true;
}
function $f5e844df4e3ecfa3$export$8dfd3dbce1f3054b(rootIn) {
    const OUTCOMES = [
        'done',
        'failed',
        'skipped'
    ];
    // the card's name when the server sent none (the v0 steps)
    const NAMES = {
        workspace: 'workspace.pobBuild.stepWorkspace',
        profile: 'workspace.pobBuild.stepProfile',
        apps: 'workspace.pobBuild.stepApps',
        records: 'workspace.pobBuild.stepRecords',
        site: 'workspace.pobBuild.stepSite'
    };
    // a skipped step's reason, in words (a code the client does not know reads
    // as the plain "Skipped")
    const REASONS = {
        offered_as_import: 'workspace.pobBuild.offered',
        no_offerings_found: 'workspace.pobBuild.noOfferings',
        site_offer_pending: 'workspace.pobBuild.sitePending',
        no_site_found: 'workspace.pobBuild.noSite',
        no_preset: 'workspace.pobBuild.noPreset',
        research_deleted: 'workspace.pobBuild.researchDeleted',
        research_expired: 'workspace.pobBuild.researchExpired',
        research_not_done: 'workspace.pobBuild.researchNotDone',
        research_invalid: 'workspace.pobBuild.noResearch',
        no_research: 'workspace.pobBuild.noResearch'
    };
    const ICONS = {
        done: 'checkmark',
        failed: 'warning',
        skipped: 'minus',
        pending: 'clock',
        running: 'clock'
    };
    const HIDDEN = {
        show: false,
        settled: false,
        ctaShown: false,
        timedOut: false,
        rows: [],
        noteText: '',
        footText: ''
    };
    const el = this;
    const root = rootIn || el && el.state && el.state.root || null;
    if (!root || typeof root !== 'object') return HIDDEN;
    const w = root.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const entry = root._pobBuild && typeof root._pobBuild === 'object' ? root._pobBuild : null;
    if (!wsId || !entry || entry.ws !== wsId || entry.status !== 'ok' || !entry.board) return HIDDEN;
    const word = (key, params)=>{
        if (!key) return '';
        const raw = el.call('polyglot', key);
        let out = raw == null ? '' : String(raw);
        const p = params && typeof params === 'object' ? params : {};
        for (const token of Object.keys(p))out = out.split(token).join(String(p[token]));
        return out;
    };
    const lang = String(el.call('getActiveLang') || root.lang || 'en');
    const fns = el.context && el.context.functions || {};
    const admin = typeof fns.currentUserIsAdmin === 'function' && !!el.call('currentUserIsAdmin', root);
    // what a done step made, in words
    const doneText = (x)=>{
        const n = x.count;
        if (x.key === 'workspace') return word('workspace.pobBuild.workspaceDone');
        if (x.key === 'profile' && n) return n === 1 ? word('workspace.pobBuild.profileDoneOne') : word('workspace.pobBuild.profileDone', {
            '{count}': n
        });
        if (x.key === 'apps' && n != null) return n === 1 ? word('workspace.pobBuild.appsDoneOne') : word('workspace.pobBuild.appsDone', {
            '{count}': n
        });
        if (x.key === 'records' && n) return n === 1 ? word('workspace.pobBuild.recordsDoneOne') : word('workspace.pobBuild.recordsDone', {
            '{count}': n
        });
        if (x.key === 'site') return word('workspace.pobBuild.siteDone');
        return word('workspace.pobBuild.done');
    };
    const skipText = (x)=>{
        if (x.reason === 'offered_as_import' && x.count) return x.count === 1 ? word('workspace.pobBuild.offeredOne') : word('workspace.pobBuild.offered', {
            '{count}': x.count
        });
        if (x.reason === 'offered_as_import') return word('workspace.pobBuild.offeredNone');
        return word(REASONS[x.reason] || 'workspace.pobBuild.skipped');
    };
    const rows = entry.board.steps.map((x, i)=>{
        const done = x.status === 'done';
        const failed = x.status === 'failed';
        const skipped = x.status === 'skipped';
        const running = x.status === 'running';
        const pending = x.status === 'pending';
        const label = x.label && (x.label[lang] || x.label.en) || '';
        // a way to what the step made: the server's own link (a path in this
        // workspace), else the apps it installed
        const href = done ? x.link && x.link.charAt(0) === '/' ? x.link : x.key === 'apps' && x.count ? '/apps' : '' : '';
        return {
            key: 'pob-build-' + (i + 1),
            step: x.key,
            status: x.status,
            title: label || word(NAMES[x.key] || '') || x.key,
            icon: ICONS[x.status] || 'clock',
            done: done,
            failed: failed,
            skipped: skipped,
            running: running || pending,
            resultText: done ? doneText(x) : failed ? word('workspace.pobBuild.notDone') : skipped ? skipText(x) : running ? word('workspace.pobBuild.running') : word('workspace.pobBuild.pending'),
            // a done step that made only part of it (some apps did not install)
            partText: done && x.error === 'some_failed' ? word('workspace.pobBuild.appsSomeFailed') : '',
            // the server's word first (`retryable: false` — not this step); no word
            // (an older server): every failed step, for an owner or admin
            retryable: failed && admin && entry.canRetry !== false && x.retryable !== false,
            retrying: entry.retrying === x.key,
            linkHref: href,
            linkText: href ? x.key === 'apps' ? word('workspace.pobBuild.seeApps') : word('workspace.pobBuild.see') : ''
        };
    });
    const settled = entry.board.done === true || rows.length > 0 && entry.board.steps.every((x)=>OUTCOMES.indexOf(x.status) !== -1);
    const timedOut = entry.timedOut === true && !settled;
    const noteText = entry.note === 'refused' ? word('workspace.pobBuild.retryRefused') : entry.note === 'failed' ? word('workspace.pobBuild.retryFailed') : timedOut ? word('workspace.pobBuild.timedOut') : '';
    return {
        show: true,
        settled: settled,
        ctaShown: settled || timedOut,
        timedOut: timedOut,
        rows: rows,
        noteText: noteText,
        footText: settled ? word('workspace.pobBuild.ready') : ''
    };
}

});

parcelRegister("l3wtL", function(module, exports) {

$parcel$export(module.exports, "addAppPromptRead", () => $f54312741d445511$export$129b414dd44f1275);
$parcel$export(module.exports, "addAppPromptPark", () => $f54312741d445511$export$8066a8c9e9ed3c47);
$parcel$export(module.exports, "addAppPromptAddress", () => $f54312741d445511$export$c4a5e779c7d2280b);
$parcel$export(module.exports, "addAppPromptTake", () => $f54312741d445511$export$b5045adc230d8d13);
$parcel$export(module.exports, "addAppPromptFlush", () => $f54312741d445511$export$9e697ba9d80bdb46);
$parcel$export(module.exports, "addAppPendingIdeaTake", () => $f54312741d445511$export$41a9dfe11b925825);
// addAppPrompt.js — the app builder starts a NEW build thread with a waiting
// text as its first message, ONCE (wt/presets CONTRACT §5 WIZARD).
//
// FREE TEXT NEVER IN A URL (CONTRACT §1): an in-app sender PARKS the text and
// routes to the bare `/add-app` — the welcome's "Build my app"
// (functions/onboardingPresets.js onboardingBuildIdea → addAppPromptPark).
// `?prompt=<text>` and `#prompt=<text>` stay readable for INBOUND links only
// (an external link, an old bookmark, Fly's hand-over
// `/w/<org>/<ws>/add-app?prompt=<idea>&fly=`, fly docs/SYMBOLS.md §5): read
// once, parked, and taken out of the address bar in the same tick.
//
// THE PARK — the landing hand-off's own order (functions/inboundPrompt.js):
// the text leaves the address bar only once it is held where a slower step
// can still reach it. The builder's mount reads it (addAppPromptTake), parks
// it in THIS tab's sessionStorage, then drops `prompt` — from the query AND
// the fragment — and `fly`, and a `thread` that would bind another app, from
// the address bar, in the same call (history and trackers read
// `location.href` / `hash`). The send waits for the builder's transport
// (`root.bridgeStatus === 'open'`) and takes the park ONE time
// (addAppPromptFlush): a reload in between finds the park, not the param, so
// the text is sent once. Where nothing can be parked (a sandboxed frame, a
// full quota) the text is held on the root for this page only and the param
// stays until the send, so a reload still has it.
//
// The shell root's boot hand-off (app.js, `?prompt=` for the HOME composer)
// leaves this route alone (inboundPromptForBuilder): the home composer never
// also takes it.
//
// `fly` — a Fly arrival: Make it real answered the welcome's questions already,
// so the full wizard never opens over the build thread. The builder only MARKS
// the load (functions/onboarding.js onboardingNoteFlyArrival — the shell's boot
// marks it too, before this mount strips `fly`) and decides nothing: Fly's
// `pending` record is what owes the person the one "Your workspace is ready"
// screen, and that screen opens over the build thread without touching it
// (functions/onboardingReady.js) — the park below and the send are the
// builder's alone.
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// The builder's params in a query string (and, for inbound links, a fragment)
// → { text, fly }: `text` the trimmed prompt (2000 characters at most, the
// landing's own bound) or null; `fly` true when Fly's hand-over marked it
// (`fly` present, whatever its value). The query's prompt wins when both carry
// one. A fragment is read only when it is param-shaped and names `prompt` or
// `fly` — a plain anchor (`#main-content`) is not a param. `URLSearchParams`
// decodes once — a second decode would mangle a typed '%'.
function $f54312741d445511$export$129b414dd44f1275(search, hash) {
    const q = new URLSearchParams(typeof search === 'string' ? search : '');
    const frag = typeof hash === 'string' ? hash.replace(/^#/, '') : '';
    const h = /(^|&)(prompt|fly)(=|&|$)/.test(frag) ? new URLSearchParams(frag) : null;
    const raw = q.get('prompt') || h && h.get('prompt') || '';
    const text = raw ? raw.trim().slice(0, 2000) : '';
    return {
        text: text || null,
        fly: q.has('fly') || !!(h && h.has('fly'))
    };
}
function $f54312741d445511$export$8066a8c9e9ed3c47(text, root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const t = String(text == null ? '' : text).trim().slice(0, 2000);
    if (!t) return false;
    const w = typeof window !== 'undefined' ? window : null;
    try {
        const store = w ? w.sessionStorage : null;
        if (store) {
            store.setItem('symbols_add_app_prompt', JSON.stringify({
                text: t,
                at: Date.now()
            }));
            return 'parked';
        }
    } catch (_) {
    /* refused — held on the root below */ }
    if (!r) return false;
    r.__addAppPromptHeld = t;
    return 'held';
}
function $f54312741d445511$export$c4a5e779c7d2280b(href, opts) {
    let url;
    try {
        url = new URL(String(href || ''));
    } catch (_) {
        return null;
    }
    url.searchParams.delete('prompt');
    url.searchParams.delete('fly');
    if (opts && opts.thread) url.searchParams.delete('thread');
    let hash = url.hash;
    const frag = hash.replace(/^#/, '');
    if (/(^|&)(prompt|fly)(=|&|$)/.test(frag)) {
        const kept = frag.split('&').filter((part)=>{
            const key = part.split('=')[0];
            let name = key;
            try {
                name = decodeURIComponent(key);
            } catch (_) {
                name = key;
            }
            return part !== '' && name !== 'prompt' && name !== 'fly';
        });
        hash = kept.length ? '#' + kept.join('&') : '';
    }
    return url.pathname + url.search + hash;
}
function $f54312741d445511$export$b5045adc230d8d13(root, opts) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return false;
    const PARK = 'symbols_add_app_prompt';
    const MAX_AGE_MS = 600000;
    const w = typeof window !== 'undefined' ? window : null;
    let store = null;
    try {
        store = w ? w.sessionStorage : null;
    } catch (_) {
        store = null;
    }
    const useUrl = !(opts && opts.url === false);
    if (useUrl && w && w.location) {
        const got = el.call('addAppPromptRead', w.location.search, w.location.hash) || {};
        if (got.fly) el.call('onboardingNoteFlyArrival', r);
        // nothing to park in: 'held' for this page, the param kept until the send
        const kept = got.text ? el.call('addAppPromptPark', got.text, r) : false;
        if (kept === 'parked' || got.fly && !got.text) try {
            const next = el.call('addAppPromptAddress', w.location.href, {
                thread: !!got.text
            });
            const now = w.location.pathname + w.location.search + w.location.hash;
            if (next && next !== now && w.history && typeof w.history.replaceState === 'function') // The shell's query-only address contract (functions/homeBoardUrl.js):
            // no navigation, no router dispatch, no new history entry.
            // frank-allow FA410
            w.history.replaceState(w.history.state, '', next);
        } catch (err) {
            console.warn('[add-app] the prompt link could not leave the address bar:', err && err.message);
        }
    }
    let waiting = !!r.__addAppPromptHeld;
    if (!waiting && store) try {
        const raw = store.getItem(PARK);
        const parked = raw ? JSON.parse(raw) : null;
        waiting = !!(parked && typeof parked.text === 'string' && parked.text.trim() && Date.now() - Number(parked.at) <= MAX_AGE_MS);
    } catch (_) {
        waiting = false;
    }
    if (waiting) {
        r.__addAppHydratedThreadId = null;
        if (r._addAppProjectId) r.update({
            _addAppProjectId: null
        }, {
            preventFetch: true
        });
    }
    return waiting;
}
async function $f54312741d445511$export$9e697ba9d80bdb46(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return false;
    const PARK = 'symbols_add_app_prompt';
    const MAX_AGE_MS = 600000;
    const w = typeof window !== 'undefined' ? window : null;
    const fns = el && el.context && el.context.functions || {};
    const owns = typeof fns.workspaceSetupOwnsBuild === 'function' ? el.call('workspaceSetupOwnsBuild', r) : false;
    if (owns === null) return false;
    if (owns === true) {
        const held = !!r.__addAppPromptHeld;
        r.__addAppPromptHeld = null;
        try {
            const store = w ? w.sessionStorage : null;
            if (store) store.removeItem(PARK);
        } catch (_) {
        /* nothing could be parked */ }
        if (held && w && w.location) try {
            const next = el.call('addAppPromptAddress', w.location.href, {
                thread: false
            });
            const now = w.location.pathname + w.location.search + w.location.hash;
            if (next && next !== now && w.history && typeof w.history.replaceState === 'function') // frank-allow FA410
            w.history.replaceState(w.history.state, '', next);
        } catch (_) {
        /* the address keeps the param; a reload is an arrival the setup owns */ }
        return false;
    }
    if (r.bridgeStatus !== 'open') return false;
    let text = '';
    let fromPage = false;
    try {
        const store = w ? w.sessionStorage : null;
        const raw = store ? store.getItem(PARK) : null;
        if (raw) store.removeItem(PARK);
        const parked = raw ? JSON.parse(raw) : null;
        if (parked && typeof parked.text === 'string' && Date.now() - Number(parked.at) <= MAX_AGE_MS) text = parked.text.trim();
    } catch (_) {
        text = '';
    }
    if (!text && r.__addAppPromptHeld) {
        text = String(r.__addAppPromptHeld).trim();
        fromPage = true;
    }
    r.__addAppPromptHeld = null;
    if (!text) return false;
    r.__addAppHydratedThreadId = null;
    r.update({
        _addAppProjectId: null,
        _addAppRendered: false,
        _addAppUnbackedEntities: []
    }, {
        preventFetch: true
    });
    try {
        await el.call('newSession', 'addapp');
    } catch (err) {
        console.warn('[add-app] a new build thread did not start:', err && err.message);
    }
    el.call('sendPrompt', text, 'addapp');
    // The page-held text is sent: its param leaves the address bar now — the
    // query's AND the fragment's (a held welcome idea never had one, and an
    // unchanged address writes no history).
    if (fromPage && w && w.location) try {
        const next = el.call('addAppPromptAddress', w.location.href, {
            thread: false
        });
        const now = w.location.pathname + w.location.search + w.location.hash;
        if (next && next !== now && w.history && typeof w.history.replaceState === 'function') // frank-allow FA410
        w.history.replaceState(w.history.state, '', next);
    } catch (_) {
    /* the text is sent; the address keeps a param a reload would read */ }
    return true;
}
async function $f54312741d445511$export$41a9dfe11b925825(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function' || !r.workspaceReady) return false;
    const ws = r.workspace;
    const wsId = String(ws && (ws.id || ws._id) || '');
    const idea = ws && ws.settings && ws.settings.pendingIdea;
    const text = idea && idea.v === 1 && typeof idea.text === 'string' ? idea.text.trim().slice(0, 2000) : '';
    if (!wsId || !text) return false;
    // One take per idea per page, even where the held record keeps a stale copy.
    const stamp = wsId + '|' + String(idea.at || '');
    if (r.__addAppPendingIdeaFlight === wsId || r.__addAppPendingIdeaTaken === stamp) return false;
    const fns = el && el.context && el.context.functions || {};
    if (typeof fns.currentUserIsAdmin !== 'function' || !el.call('currentUserIsAdmin', r)) return false;
    let sdk = null;
    if (typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || sdk.isNullClient === true || typeof sdk.updateWorkspaceSettings !== 'function') return false;
    const PARK = 'symbols_add_app_prompt';
    const w = typeof window !== 'undefined' ? window : null;
    let waiting = !!r.__addAppPromptHeld;
    if (!waiting) try {
        const store = w ? w.sessionStorage : null;
        waiting = !!(store && store.getItem(PARK));
    } catch (_) {
        waiting = false;
    }
    r.__addAppPendingIdeaFlight = wsId;
    let cleared = false;
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, {
            pendingIdea: null
        });
        cleared = !(res && res.success === false);
    } catch (err) {
        console.warn('[add-app] the waiting idea could not be taken:', err && err.message);
    } finally{
        r.__addAppPendingIdeaFlight = null;
    }
    if (!cleared) return false;
    r.__addAppPendingIdeaTaken = stamp;
    // The held record forgets it too, so no later mount takes it again.
    const held = r.workspace;
    if (held && String(held.id || held._id || '') === wsId && held.settings) {
        const { pendingIdea: pendingIdea, ...rest } = held.settings;
        if (typeof fns.setActiveWorkspaceRecord === 'function') el.call('setActiveWorkspaceRecord', r, {
            ...held,
            settings: rest
        }, {
            reason: 'add-app:pendingIdea'
        });
    }
    if (waiting) return false;
    if (!el.call('addAppPromptPark', text, r)) return false;
    await el.call('addAppPromptFlush', r);
    return true;
}

});

parcelRegister("2nxDN", function(module, exports) {

$parcel$export(module.exports, "addAppComposerFocus", () => $1bb7d32318a71a4a$export$68f9f2979467b8b3);
// addAppComposerFocus.js — the app builder opens with the focus in its chat
// composer (persona round 5, sam, keyboard only: after Enter on the welcome's
// "Build my app" the builder opened with the focus on the page body, and the
// way to the chat was a Tab walk from the top through the nav).
//
// The builder's canvas (pages/add-app.js BuildCanvas) calls it on its mount
// and on every update (a transport change is one): the composer's field is
// disabled until the transport is open (shared Chat: `bridgeStatus`), and a
// disabled field cannot take the focus, so the open transport's update is the
// one that lands it on a cold load.
//
// A cold load mounts the builder under the boot screen's `inert` lock
// (index.html lockBodyInput, released on `smbls:boot-ready`, ~3 s on dev): a
// focus there is a silent no-op. An attempt under the lock stops at once and
// the canvas asks again when the lock lifts (its `onWindowSmbls:boot-ready`)
// — the empty builder has no later update that would (W16b live check).
//
// It takes the focus ONCE per mount, and only a focus nobody holds (the page
// body, or a node the route change removed): a link or a control the person
// moved to keeps it. Only where the builder IS the route — the home's Build
// tab (`scope.addAppThreadInUrl: false`) has the home's own composer.
//
// FRANK: self-contained; the canvas element is `this` (el.call).
// → true when an attempt was scheduled.
function $1bb7d32318a71a4a$export$68f9f2979467b8b3() {
    const el = this;
    if (!el || el._addAppComposerFocusDone) return false;
    if (el.scope && el.scope.addAppThreadInUrl === false) return false;
    const root = el.state && el.state.root;
    if (!root || root.bridgeStatus !== 'open') return false;
    if (el._addAppComposerFocusTry) return true;
    el._addAppComposerFocusTry = true;
    const field = ()=>{
        const main = typeof el.lookup === 'function' ? el.lookup('AppMain') : null;
        const chat = main && main.Conversation && main.Conversation.Chat;
        const box = chat && chat.ComposerWrap && chat.ComposerWrap.PromptTextarea;
        return box && box.Textarea || null;
    };
    const attempt = (left)=>{
        let again = left > 0;
        try {
            const node = (field() || {}).node;
            if (node && typeof node.closest === 'function' && node.closest('[inert]')) // the boot screen's lock (index.html lockBodyInput): a focus is a
            // no-op until it lifts, and frames end long before it does — the
            // canvas asks again on `smbls:boot-ready`
            again = false;
            else if (node && node.isConnected && typeof node.focus === 'function' && !node.disabled) {
                const doc = node.ownerDocument;
                const active = doc && doc.activeElement;
                const free = !active || active === doc.body || !active.isConnected;
                if (!free && active !== node) {
                    // the person is somewhere already: never take it from them
                    el._addAppComposerFocusDone = true;
                    again = false;
                } else {
                    if (active !== node) node.focus({
                        preventScroll: true
                    });
                    if (doc.activeElement === node) {
                        el._addAppComposerFocusDone = true;
                        again = false;
                    }
                }
            }
        } catch (_) {
        /* focus is a courtesy — never an error */ }
        if (again) {
            if (typeof requestAnimationFrame === 'function') requestAnimationFrame(()=>attempt(left - 1));
            else setTimeout(()=>attempt(left - 1), 16);
        } else el._addAppComposerFocusTry = false;
    };
    setTimeout(()=>attempt(10), 0);
    return true;
}

});

parcelRegister("exs7L", function(module, exports) {

$parcel$export(module.exports, "addAppBuildOutcome", () => $a959f6a631f626aa$export$198229f8b0a7f0ec);
// addAppBuildOutcome.js — what the builder's Preview pane says when a build
// left nothing on it (wt/presets qa/briefs/WS-build-ui-r1.md finding 3).
//
// aiko and tomas met a pane that read "Your idea is taking shape" for a whole
// session: every build step failed, or the board showed somewhere else, and
// the pane never said so. The pane shows the built app (pages/add-app.js
// AppRender), or it says plainly that the build failed.
//
// READ, NEVER STORED: the answer comes from the builder's own thread
// (`_ax_chatMessages` — the live turn's timeline rows, or a restored thread's)
// and the pane's own flag (`_addAppRendered`). A stored flag would need its own
// clearing on every send, switch and reload; the rows already say it.
//
// FRANK: self-contained (FA204) — the step list is restated in the function.
// The builder's outcome → 'failed' | null.
//   'failed'  the newest assistant answer that ran a BUILD step is finished,
//             at least one build step failed, none succeeded, and the pane
//             holds nothing — the build ended with nothing to show;
//   null      still working (the newest answer streams), something is on the
//             pane (or loading into it), a failed step was followed by one
//             that worked, or no build step ran at all.
// A later answer with no build step (a question after the failure) keeps the
// failure on the pane: the scan goes back to the newest answer that built.
function $a959f6a631f626aa$export$198229f8b0a7f0ec(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r) return null;
    if (r._addAppRendered || r._addAppSwitching) return null;
    const msgs = Array.isArray(r._ax_chatMessages) ? r._ax_chatMessages : [];
    // The steps that put an app on the pane — server tool names (the timeline
    // rows carry them; a module fn's transport prefix stripped) — and the two
    // that build a project without drawing it here (a project made and left
    // empty is no app to show).
    const RENDER = [
        'create_app',
        'update_app',
        'create_extension',
        'update_extension',
        'render_extension_page',
        'render_answer_ui'
    ];
    const BUILD = RENDER.concat([
        'create_project',
        'commit_project_changes'
    ]);
    const nameOf = (t)=>String(t && t.tool || '').replace(/^module_fn_/, '');
    for(let i = msgs.length - 1; i >= 0; i--){
        const m = msgs[i];
        if (!m || m.role !== 'assistant') continue;
        if (m.streaming) return null;
        const rows = (Array.isArray(m.tools) ? m.tools : []).filter((t)=>BUILD.includes(nameOf(t)));
        if (!rows.length) continue;
        const failed = rows.some((t)=>t.status === 'error');
        const worked = rows.some((t)=>t.status === 'done' && RENDER.includes(nameOf(t)));
        return failed && !worked ? 'failed' : null;
    }
    return null;
}

});

parcelRegister("9nZUz", function(module, exports) {

$parcel$export(module.exports, "addAppBalanceLine", () => $6d56495619aee49d$export$b5ad973d3d0c7600);
// addAppBalance.js — the workspace's credits where a builder looks
// (wt/presets qa/briefs/WS-build-ui-r1.md finding 5).
//
// aiko found the balance only under workspace menu → Admin → the credit page;
// elena took five clicks. The builder's composer carries one line now: the
// credits this workspace holds, and — for an admin — the credit page by its own
// name (pages/add-app.js ComposerWrap.BuildBalance).
//
// The figure is the credit guard's (functions/creditGuard.js
// creditGuardState — `sdk.getCreditBalance`, loaded at boot and on every
// workspace switch): nothing is fetched here. UNKNOWN IS NOT ZERO — a balance
// that could not be read shows no line at all, never a confident "0".
//
// FRANK: self-contained (FA204); siblings through `this.call`.
// The compact balance → { text, count, tooltip, fraction, admin } or null.
//   text   "{count} credits available" in the session language;
//   admin  the viewer may open the credit page (currentUserIsAdmin).
function $6d56495619aee49d$export$b5ad973d3d0c7600(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!el || typeof el.call !== 'function' || !r || !r.signedIn) return null;
    const guard = el.call('creditGuardState', r);
    if (!guard || !guard.loaded || guard.error || guard.status === 'unknown') return null;
    if (guard.total == null || !Number.isFinite(Number(guard.total))) return null;
    const count = Number(guard.total).toLocaleString('en-US', {
        maximumFractionDigits: 2
    });
    const text = String(el.call('polyglot', 'workspace.addApp.balance.available')).replace('{count}', ()=>count);
    // The number includes purchased credits. The pie specifically represents
    // the monthly allowance; a top-up must never invent a larger grant.
    // Missing allowance fields are unknown, even though the guard defaults them
    // to zero for its separate threshold policy.
    const data = r._creditGuard?.data || r._creditGuard || {};
    const known = (value)=>value != null && value !== '' && Number.isFinite(Number(value));
    const hasGrant = known(data.grantSize) && Number(data.grantSize) > 0 && known(data.grantRemaining);
    const fraction = hasGrant ? Math.max(0, Math.min(1, Number(data.grantRemaining) / Number(data.grantSize))) : null;
    const format = (value)=>Number(value).toLocaleString('en-US', {
            maximumFractionDigits: 2
        });
    const lines = [
        text
    ];
    if (hasGrant) lines.push(String(el.call('polyglot', 'workspace.addApp.balance.allowance')).replace('{remaining}', ()=>format(data.grantRemaining)).replace('{total}', ()=>format(data.grantSize)));
    if (known(data.topupRemaining) && Number(data.topupRemaining) > 0) lines.push(String(el.call('polyglot', 'workspace.addApp.balance.purchased')).replace('{count}', ()=>format(data.topupRemaining)));
    const admin = !!el.call('currentUserIsAdmin', r);
    if (admin) lines.push(String(el.call('polyglot', 'admin.usage.title')));
    return {
        text: text,
        count: count,
        tooltip: lines.join('\n'),
        fraction: fraction,
        admin: admin
    };
}

});

parcelRegister("6lzOV", function(module, exports) {

$parcel$export(module.exports, "addAppEstimatePlace", () => $49f07d6685784cfe$export$567dcfb982d592eb);
$parcel$export(module.exports, "addAppEstimateReady", () => $49f07d6685784cfe$export$8a1b6792451b09e9);
$parcel$export(module.exports, "addAppEstimateBody", () => $49f07d6685784cfe$export$daeffb33b16b5a2f);
$parcel$export(module.exports, "addAppEstimateRecord", () => $49f07d6685784cfe$export$17437c1205bfbf73);
$parcel$export(module.exports, "addAppEstimateAsk", () => $49f07d6685784cfe$export$2ae0e88717b12971);
$parcel$export(module.exports, "addAppEstimateSend", () => $49f07d6685784cfe$export$482884dd1c7dba67);
$parcel$export(module.exports, "addAppEstimateStop", () => $49f07d6685784cfe$export$ce6b0e9a0026e4bf);
$parcel$export(module.exports, "addAppEstimateLine", () => $49f07d6685784cfe$export$fb7a8edb7c43368e);
// addAppEstimate.js — THE COST BEFORE A BUILD, where the builder writes
// (workspace presets programme, WS lane `feat/build-estimate-ui`; the server
// half is lane CORE-EST, S1-API.md §10 "CORE-EST — build estimate").
//
// Every persona of the build walks said the same: no price shows before a
// build, and a failed try costs credits ("776 credits bought no working
// board"). The server answers what a builder turn's FIRST model step will
// reserve and whether this workspace can pay it, before the turn is sent —
// no model call, no write:
//
//   POST /core/workspaces/:workspaceId/build-estimate     (sdk.estimateBuild)
//   body    the builder turn's own body: content, context (surface
//           'add-app-builder', uiLanguage, …), modelMode, targetAgentId, plus
//           conversationId when the thread exists
//   answer  { surface, step: { full, min }, build: null,
//             basis: 'first-step-only', balance, waived, waiver,
//             allocationExceeded, canStart, enough }
//
// THE LINE (pages/add-app.js ComposerWrap.BuildEstimate — the /add-app
// builder and the home's Build tab: one page in two places). While the person
// types, one quiet line under the composer says what the first step costs:
//   waived              "Your first build is free."          (only then)
//   priced              "This first step costs about {count} credits."
//   not enough /        the price, the reason, and the way out — an admin's
//   allocation          link to the credit page, a member's "ask a workspace
//                       admin" (the credits lane's own refusal words,
//                       functions/creditsRefusal.js)
// `step.full` is the FIRST STEP, never the price of the build: `build` is null
// (the ledger cannot tell one builder turn's steps apart yet).
//
// THE ASK: debounced while the person types, and again on a thread, workspace,
// language or agent change (the composer's `stateDeps`). One request in
// flight; the newest ask wins and an older answer is dropped. The draft rides
// the POST body only: never a URL, never a log line, never root state (the
// record below holds numbers, flags and ids).
//
// NEVER A BROKEN STATE: no SDK method (`sdk.estimateBuild` arrives with the
// SDK release), the null client, a refused place or any error → no line, no
// console output. A place the server refused stays quiet, so a failure never
// turns into a request loop: for good on 400 / 401 / 403 / 404, one minute on
// anything else (a 503 NO_AI_PROVIDERS, a lost connection).
//
// NOT PRICED (the server's own gaps, S1-API.md §10.5): an app's own thread
// (`_addAppProjectId` — the project-scoped builder conversation), and a turn
// that is already running (its credits move while it runs).
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// `this` is the calling element. The bookkeeping (the timer, the request in
// flight, the refused places) lives on the root as a plain `__` property:
// never reactive, never written by `root.update`.
// The place an estimate prices — the workspace the turn is billed to and the
// thread it runs in: 'ws|thread', 'ws|new' before the thread exists, or ''
// where nothing is priced (signed out, no workspace, an app's own thread).
// Every key is read up front (reactive callers).
function $49f07d6685784cfe$export$567dcfb982d592eb(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : null;
    if (!r || !el || typeof el.call !== 'function') return '';
    const signedIn = !!r.signedIn;
    const bound = !!r._addAppProjectId;
    const active = r._ax_activeSessionId ? String(r._ax_activeSessionId) : '';
    let ws = '';
    try {
        ws = String(el.call('activeWorkspaceId', r) || '');
    } catch (_) {
        ws = '';
    }
    if (!signedIn || bound || !ws) return '';
    // a local 's-…' id names no server thread yet: the turn makes one
    return ws + '|' + (active && !active.startsWith('s-') ? active : 'new');
}
function $49f07d6685784cfe$export$8a1b6792451b09e9(root) {
    const el = this;
    if (!el || typeof el.call !== 'function') return false;
    // Home keeps the builder mounted while another view is shown. Its draft
    // survives, but pricing pauses until Create is visible again. Dedicated
    // and pane builders have no HomeBuildView ancestor and remain independent.
    if (typeof el.lookup === 'function' && el.lookup('HomeBuildView') && !el.call('homeBuildShown', root)) return false;
    if (!el.call('addAppEstimatePlace', root)) return false;
    let sdk = null;
    try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    return !!sdk && sdk.isNullClient !== true && typeof sdk.estimateBuild === 'function';
}
function $49f07d6685784cfe$export$daeffb33b16b5a2f(root, draft) {
    const el = this;
    const r = root && typeof root === 'object' ? root : null;
    const text = typeof draft === 'string' ? draft.trim() : '';
    if (!r || !text || !el || typeof el.call !== 'function') return null;
    const key = String(el.call('addAppEstimatePlace', r) || '');
    const at = key.indexOf('|');
    if (at <= 0) return null;
    const workspaceId = key.slice(0, at);
    const thread = key.slice(at + 1);
    // the model mode the SDK sends with the turn (sdk.ai.getModelMode)
    let modelMode = '';
    try {
        const ai = el.call('getAiService');
        if (ai && typeof ai.getModelMode === 'function') modelMode = String(ai.getModelMode() || '');
    } catch (_) {
        modelMode = '';
    }
    if (!modelMode) modelMode = typeof r.modelMode === 'string' && r.modelMode ? r.modelMode : 'auto';
    const context = {
        surface: 'add-app-builder',
        extensionProjectId: null,
        pickedElements: null,
        targetAgentId: r._targetAgentId || null,
        targetAgentName: r._targetAgentName || null
    };
    if (typeof r.lang === 'string' && r.lang) context.uiLanguage = r.lang;
    const body = {
        content: text,
        modelMode: modelMode,
        targetAgentId: r._targetAgentId || null,
        context: context
    };
    if (thread && thread !== 'new') body.conversationId = thread;
    return {
        workspaceId: workspaceId,
        key: key,
        body: body
    };
}
function $49f07d6685784cfe$export$17437c1205bfbf73(data, key) {
    const count = (v)=>typeof v === 'number' && Number.isFinite(v) && v >= 0 ? v : null;
    if (!data || typeof data !== 'object' || !key) return null;
    const step = data.step && typeof data.step === 'object' ? data.step : null;
    const full = count(step && step.full);
    if (full === null) return null;
    for (const flag of [
        'waived',
        'canStart',
        'enough'
    ]){
        if (typeof data[flag] !== 'boolean') return null;
    }
    return {
        key: String(key),
        at: Date.now(),
        full: full,
        min: count(step.min),
        waived: data.waived,
        allocationExceeded: data.allocationExceeded === true,
        canStart: data.canStart,
        enough: data.enough
    };
}
function $49f07d6685784cfe$export$2ae0e88717b12971(root, draft) {
    const PAUSE_MS = 700;
    const el = this;
    const r = root && typeof root === 'object' ? root : el && el.state && el.state.root || null;
    if (!r || !el || typeof el.call !== 'function') return false;
    if (!r.__addAppEstimateRun || typeof r.__addAppEstimateRun !== 'object') r.__addAppEstimateRun = {
        seq: 0,
        timer: null,
        flight: null,
        queued: null,
        refused: {}
    };
    const run = r.__addAppEstimateRun;
    if (run.timer) clearTimeout(run.timer);
    run.timer = null;
    const quiet = ()=>{
        run.seq += 1;
        run.queued = null;
        if (r._addAppEstimate && typeof r.update === 'function') r.update({
            _addAppEstimate: null
        }, {
            preventFetch: true
        });
        return false;
    };
    // a turn in flight: its credits move — the composer asks again after it
    if (r._ax_chatTyping) return quiet();
    if (!el.call('addAppEstimateReady', r)) return quiet();
    const ask = el.call('addAppEstimateBody', r, draft);
    if (!ask) return quiet();
    const now = Date.now();
    const refusedAll = Number(run.refused['*']) || 0;
    const refusedHere = Number(run.refused[ask.key]) || 0;
    if (now < refusedAll || now < refusedHere) return quiet();
    // the price on screen belongs to another place (a thread, a workspace): it
    // goes now; the same place keeps it until the new answer lands (no flicker)
    if (r._addAppEstimate && r._addAppEstimate.key !== ask.key && typeof r.update === 'function') r.update({
        _addAppEstimate: null
    }, {
        preventFetch: true
    });
    run.seq += 1;
    const seq = run.seq;
    run.timer = setTimeout(()=>{
        run.timer = null;
        el.call('addAppEstimateSend', r, seq, ask);
    }, PAUSE_MS);
    return true;
}
function $49f07d6685784cfe$export$482884dd1c7dba67(root, seq, ask) {
    const RETRY_MS = 60000;
    const el = this;
    const r = root && typeof root === 'object' ? root : null;
    const run = r && r.__addAppEstimateRun;
    if (!run || !ask || seq !== run.seq || !el || typeof el.call !== 'function') return Promise.resolve(false);
    if (run.flight) {
        run.queued = {
            seq: seq,
            ask: ask
        };
        return Promise.resolve(false);
    }
    let sdk = null;
    try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || sdk.isNullClient === true || typeof sdk.estimateBuild !== 'function') return Promise.resolve(false);
    const flight = {
        seq: seq
    };
    run.flight = flight;
    let request;
    try {
        request = Promise.resolve(sdk.estimateBuild(ask.workspaceId, ask.body));
    } catch (err) {
        request = Promise.reject(err);
    }
    const after = ()=>{
        if (run.flight === flight) run.flight = null;
        const next = run.queued;
        run.queued = null;
        if (next && next.seq === run.seq) el.call('addAppEstimateSend', r, next.seq, next.ask);
    };
    return request.then((data)=>{
        let wrote = false;
        if (seq === run.seq && el.call('addAppEstimatePlace', r) === ask.key) {
            const record = el.call('addAppEstimateRecord', data, ask.key);
            if (typeof r.update === 'function') r.update({
                _addAppEstimate: record || null
            }, {
                preventFetch: true
            });
            wrote = !!record;
        }
        after();
        return wrote;
    }, (err)=>{
        const status = Number(err && err.status) || 0;
        // the session or the contract: no place prices — stays quiet
        if (status === 401 || status === 400) run.refused['*'] = Infinity;
        else if (status === 403 || status === 404) run.refused[ask.key] = Infinity;
        else run.refused[ask.key] = Date.now() + RETRY_MS;
        if (seq === run.seq && r._addAppEstimate && typeof r.update === 'function') r.update({
            _addAppEstimate: null
        }, {
            preventFetch: true
        });
        after();
        return false;
    });
}
function $49f07d6685784cfe$export$ce6b0e9a0026e4bf(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : el && el.state && el.state.root || null;
    if (!r) return false;
    const run = r.__addAppEstimateRun;
    if (run && typeof run === 'object') {
        if (run.timer) clearTimeout(run.timer);
        run.timer = null;
        run.queued = null;
        run.seq = (Number(run.seq) || 0) + 1;
    }
    if (r._addAppEstimate && typeof r.update === 'function') r.update({
        _addAppEstimate: null
    }, {
        preventFetch: true
    });
    return true;
}
function $49f07d6685784cfe$export$fb7a8edb7c43368e(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : el && el.state && el.state.root || null;
    if (!r || !el || typeof el.call !== 'function') return null;
    // every key read up front (reactive callers)
    const held = r._addAppEstimate;
    const typing = !!r._ax_chatTyping;
    const switching = !!r._addAppSwitching;
    const place = el.call('addAppEstimatePlace', r);
    if (!held || typeof held !== 'object' || typing || switching) return null;
    if (!place || place !== held.key) return null;
    const t = (key)=>{
        const v = el.call('polyglot', key);
        return v == null ? '' : String(v);
    };
    const view = (kind, lead, reason, way)=>{
        const said = [
            lead,
            reason,
            way && way.text
        ].filter(Boolean).join(' ');
        if (!way || !way.link) return {
            kind: kind,
            lead: lead,
            reason: reason,
            way: way,
            words: said,
            link: '',
            after: ''
        };
        return {
            kind: kind,
            lead: lead,
            reason: reason,
            way: way,
            words: (said ? said + ' ' : '') + (way.before || ''),
            link: way.link,
            after: way.after || ''
        };
    };
    if (held.waived === true) return view('free', t('workspace.addApp.estimate.free'), '', null);
    let lang = '';
    try {
        lang = String(el.call('getActiveLang') || '');
    } catch (_) {
        lang = '';
    }
    if (!lang) lang = typeof r.lang === 'string' && r.lang ? r.lang : 'en';
    const credits = Math.ceil(Number(held.full) || 0);
    let count = String(credits);
    try {
        count = new Intl.NumberFormat(lang, {
            maximumFractionDigits: 0
        }).format(credits);
    } catch (_) {
        count = String(credits);
    }
    const lead = t('workspace.addApp.estimate.step').replace('{count}', ()=>count);
    const allocation = held.allocationExceeded === true;
    if (!allocation && held.canStart === true && held.enough === true) return view('price', lead, '', null);
    let admin = false;
    try {
        admin = !!el.call('currentUserIsAdmin', r);
    } catch (_) {
        admin = false;
    }
    // the credits lane's way out, by role: the admin's words ARE the link
    // ("{link} to keep going." — the template keeps each language's order)
    const linked = (template, label)=>{
        const at = template.indexOf('{link}');
        if (at < 0) return {
            before: '',
            link: label,
            after: ''
        };
        return {
            before: template.slice(0, at),
            link: label,
            after: template.slice(at + 6)
        };
    };
    if (allocation) return view('allocation', lead, t('workspace.credits.chat.allocation'), admin ? linked(t('workspace.credits.chat.limitAdmin'), t('workspace.credits.chat.limitLink')) : {
        text: t('workspace.credits.chat.limitMember')
    });
    return view('short', lead, t('workspace.credits.chat.notEnough'), admin ? linked(t('workspace.credits.chat.balanceAdmin'), t('workspace.credits.chat.addLink')) : {
        text: t('workspace.credits.chat.balanceMember')
    });
}

});

parcelRegister("f0QVc", function(module, exports) {

$parcel$export(module.exports, "addAppChatScroller", () => $aedfe839efc65073$export$7e07babf0c330664);
$parcel$export(module.exports, "addAppChatFollow", () => $aedfe839efc65073$export$1ba6fe432a470de);
$parcel$export(module.exports, "addAppChatTrack", () => $aedfe839efc65073$export$109bdfbb8ae8d654);
$parcel$export(module.exports, "addAppShowCanvas", () => $aedfe839efc65073$export$76030b6a5d36a43f);
// addAppChatFollow.js — THE BUILDER'S CONVERSATION FOLLOWS ITS NEWEST MESSAGE
// (persona round 1b, BLD-16: priya, elena, nino, marcus, giorgi — "the chat
// column did not scroll, so I saw the failure only after I pressed End"; "the
// answer buttons sit under the clipped edge"; "a box about 350 px tall that
// sits inside a card inside the page").
//
// Measured on dev (workspace a2c0b97e5, 2026-10-25; the builder with 20 rows):
//   1. after the person scrolls up, their OWN new message stays under the fold
//      (gap 404 px): the shared Chat re-pins in its Messages `onUpdate`, and
//      smbls 3.14 never runs a descendant's onUpdate for a root-state write
//      (SYNTAX, "Which hook runs on which state change");
//   2. at the bottom, a six-line draft grows the composer by 95 px and the
//      newest 95 px slide under it while the list still counts as pinned —
//      the shared follow watches the message stack's size, never its
//      scroller's;
//   3. at 390 px the message box is 221 px tall inside AppMain, which scrolls
//      too (the panes stack there): one box scrolling inside another.
//
// The builder's own fix (the shared Chat is read-only for this package):
//   - every change of the thread's rows follows (pages/add-app.js Messages
//     `stateDeps`): a new row of the PERSON re-pins and brings the end into
//     view; anything else follows only while pinned, so a person who
//     scrolled up keeps their place;
//   - the composer growing (a draft) and the window resizing follow too;
//   - on the stacked layout the conversation is no inner box: it reads with
//     the page (AppMain is its one scroller) and the composer sticks to the
//     bottom (pages/add-app.js). The follow then scrolls AppMain to the
//     conversation's end, and AppMain's own scroll says whether the person
//     is at that end (addAppChatTrack).
// The pinned flag is the shared Chat's own — `_pinned` on the Messages
// element, kept by its scroll handler on the wide layout — so the shared
// follow (a ResizeObserver on the rows) and this one never disagree.
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// The scroll moves through `scrollTo()`: reading and scrolling a node is
// allowed, a property write is FA511 (functions/agentModeScroll.js).
// The conversation's scroller and the top that shows its end →
// { node, top, inner } or null. `inner`: the message list scrolls itself (the
// wide layout); else AppMain does (the stacked layout), and `top` puts the
// conversation's last edge — the composer — at the bottom of the view.
function $aedfe839efc65073$export$7e07babf0c330664(messages) {
    const el = messages;
    const node = el && el.node;
    if (!node || node.isConnected === false) return null;
    const view = node.ownerDocument && node.ownerDocument.defaultView;
    const scrolls = (n)=>{
        if (!n || !view || typeof view.getComputedStyle !== 'function') return false;
        const css = view.getComputedStyle(n);
        // the longhand, else the shorthand (a document without layout keeps only it)
        const overflowY = css.overflowY || css.overflow;
        return (overflowY === 'auto' || overflowY === 'scroll') && n.scrollHeight > n.clientHeight + 1;
    };
    if (scrolls(node)) return {
        node: node,
        top: node.scrollHeight,
        inner: true
    };
    const main = typeof el.lookup === 'function' ? el.lookup('AppMain') : null;
    const conversation = typeof el.lookup === 'function' ? el.lookup('Conversation') : null;
    const outer = main && main.node;
    if (!outer || !scrolls(outer)) return null;
    const end = conversation && conversation.node || node;
    const box = outer.getBoundingClientRect();
    const edge = end.getBoundingClientRect();
    return {
        node: outer,
        top: Math.max(0, outer.scrollTop + (edge.bottom - box.bottom)),
        inner: false
    };
}
function $aedfe839efc65073$export$1ba6fe432a470de(messages, prev, next) {
    const el = messages;
    const node = el && el.node;
    if (!node || node.isConnected === false) return false;
    const before = Array.isArray(prev) ? prev : [];
    const after = Array.isArray(next) ? next : [];
    // A row of the person among the rows that came in: the send writes the
    // person's row and the transport its answer's placeholder in the same tick,
    // so the newest row is often the placeholder. A thread that opens arrives
    // whole the same way — and opens at its end.
    const added = after.length > before.length ? after.slice(before.length) : [];
    const own = added.some((row)=>!!row && row.role === 'user');
    if (own) el._pinned = true;
    else if (el._pinned === false) return false;
    if (el.__addAppFollow) return true;
    el.__addAppFollow = true;
    const self = this;
    const view = node.ownerDocument && node.ownerDocument.defaultView;
    const frame = view && typeof view.requestAnimationFrame === 'function' ? (fn)=>view.requestAnimationFrame(fn) : (fn)=>setTimeout(fn, 16);
    frame(()=>{
        el.__addAppFollow = false;
        if (node.isConnected === false) return;
        const at = self.call('addAppChatScroller', el);
        if (at && typeof at.node.scrollTo === 'function') at.node.scrollTo({
            top: at.top
        });
    });
    return true;
}
function $aedfe839efc65073$export$109bdfbb8ae8d654(main) {
    const conversation = main && main.Conversation;
    const messages = conversation && conversation.Chat && conversation.Chat.Messages;
    const node = main && main.node;
    if (!messages || !node || !conversation.node) return false;
    const at = this.call('addAppChatScroller', messages);
    if (!at || at.inner || at.node !== node) return false;
    const gap = conversation.node.getBoundingClientRect().bottom - node.getBoundingClientRect().bottom;
    messages._pinned = Math.abs(gap) < 120;
    return true;
}
function $aedfe839efc65073$export$76030b6a5d36a43f(from) {
    const el = from;
    if (!el || typeof el !== 'object') return false;
    const findMain = ()=>{
        if (el.key === 'AppMain') return el;
        let at = el;
        while(at){
            if (at.AppMain && at.AppMain.BuildCanvas) return at.AppMain;
            at = at.parent;
        }
        return null;
    };
    const main = findMain();
    const node = main && main.node;
    const canvas = main && main.BuildCanvas && main.BuildCanvas.node;
    if (!node || !canvas || node.isConnected === false) return false;
    const view = node.ownerDocument && node.ownerDocument.defaultView;
    const conversation = main.Conversation;
    const messages = conversation && conversation.Chat && conversation.Chat.Messages;
    const frame = view && typeof view.requestAnimationFrame === 'function' ? (fn)=>view.requestAnimationFrame(fn) : (fn)=>setTimeout(fn, 16);
    // stacked = AppMain is the scroller (the wide layout never scrolls it)
    const stacked = ()=>{
        if (!view || typeof view.getComputedStyle !== 'function') return false;
        const css = view.getComputedStyle(node);
        const overflowY = css.overflowY || css.overflow;
        return (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1;
    };
    // Unpinned at once, not in the frame: a follow asked for before the frame
    // (a row that lands in the same tick) must already see it.
    if (stacked() && messages) messages._pinned = false;
    if (main.__addAppShowCanvas) return true;
    main.__addAppShowCanvas = true;
    frame(()=>{
        main.__addAppShowCanvas = false;
        if (node.isConnected === false || !stacked()) return;
        if (messages) messages._pinned = false;
        const top = node.scrollTop + (canvas.getBoundingClientRect().top - node.getBoundingClientRect().top);
        if (typeof node.scrollTo === 'function') node.scrollTo({
            top: Math.max(0, top)
        });
    });
    return true;
}

});

parcelRegister("1JE4a", function(module, exports) {

$parcel$export(module.exports, "addAppPhonePane", () => $143912be9fe49bd1$export$e305c86e007303a1);
$parcel$export(module.exports, "addAppPhonePaneSet", () => $143912be9fe49bd1$export$e049b89c883556dc);
$parcel$export(module.exports, "addAppAppsToggle", () => $143912be9fe49bd1$export$eb55cb0afbb5e9a5);
// addAppPhonePane.js — /add-app on a phone: ONE pane at a time (persona round
// 5, marcus, iPhone 390, shots 021/034: "the screen was a pile — an apps list,
// a small chat box, three rows of buttons, then the preview").
//
// Where the builder is narrow (`@mobileL`, or an `@appMobile` pane) it shows
// one of three panes: the chat (the default), the preview of the app, or the
// person's apps list. The choice is `root._addAppPhonePane`; the page
// publishes the pane it shows as `data-phone-pane` and its narrow media rules
// hide the other two (pages/add-app.js). The wide layout ignores it: the apps
// rail there is a page sidebar (shared functions/pageSidebar.js, Nika
// 2026-10-29 "Same rule for all") — shown unless the person hid it for the
// page, with its own hide button and reopen tab. The apps pane is only ever
// the person's own choice: nothing opens it by itself.
//
// Moves: Preview (the chat head) → the preview; Back to build (the preview's
// actions) → the chat; the apps toggle → the apps list, and back; a pick in
// the apps list → that app's preview; a build that lands → its preview.
//
// FRANK: every export is self-contained (FA204) and a `function` (`el.call`
// passes the element as `this`).
// The pane a narrow builder shows. The preview only once there is something
// to show there (a render, or the switch skeleton); otherwise the chat.
// → 'chat' | 'preview' | 'apps'
function $143912be9fe49bd1$export$e305c86e007303a1(root) {
    const r = root && typeof root === 'object' ? root : {};
    const want = r._addAppPhonePane;
    if (want === 'apps') return 'apps';
    if (want === 'preview' && (r._addAppRendered || r._addAppSwitching)) return 'preview';
    return 'chat';
}
function $143912be9fe49bd1$export$e049b89c883556dc(pane) {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return null;
    const next = pane === 'apps' || pane === 'preview' ? pane : 'chat';
    root.update({
        _addAppPhonePane: next
    }, {
        preventFetch: true
    });
    if (next === 'apps' && typeof this.call === 'function') {
        const now = this.call('pageSidebarRead', root, this);
        if (now && now.hidden === true) this.call('pageSidebarSet', now.key, false);
    }
    return next;
}
function $143912be9fe49bd1$export$eb55cb0afbb5e9a5(shown) {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return null;
    const next = shown ? 'chat' : 'apps';
    root.update({
        _addAppPhonePane: next
    }, {
        preventFetch: true
    });
    if (next === 'apps' && typeof this.call === 'function') {
        const now = this.call('pageSidebarRead', root, this);
        if (now && now.hidden === true) this.call('pageSidebarSet', now.key, false);
    }
    return !shown;
}

});

parcelRegister("11fgE", function(module, exports) {

$parcel$export(module.exports, "addAppPreviewWriteKind", () => $0be1ba4154a9c548$export$ce1278b3a2cbd5b9);
$parcel$export(module.exports, "addAppPreviewForget", () => $0be1ba4154a9c548$export$fe73540f7d48cce9);
$parcel$export(module.exports, "addAppPreviewAfterWrite", () => $0be1ba4154a9c548$export$6e220a7934adfeb);
$parcel$export(module.exports, "addAppPreviewRefresh", () => $0be1ba4154a9c548$export$a519494ecfd18f07);
// addAppPreviewRefresh.js — THE BUILDER'S PREVIEW SHOWS WHAT THE AI JUST WROTE
// (persona round 3, B5: priya — "the preview said 'All stocked up!' although
// the AI had saved 3 sample records; only a page reload showed them"; nino —
// "added 3 sample tasks", none shown until the next change).
//
// Two causes, both in the shell:
//   1. A built app's reads are declarative `fetch:` calls rewritten to
//      `workspaceProject.<entity>` (functions/index.js _rewriteFetchDecls), and
//      @symbo.ls/fetch caches every read for 60 s by default in the page's ONE
//      query store (the in-shell preview shares it). A mount inside that time
//      writes the cached rows into state and sends no request — so a re-render
//      right after a write shows the rows from BEFORE the write.
//   2. A write the server runs on its own — a record the AI saves
//      (create/update/delete_workspace_record) or a change to the app's files
//      (commit_project_changes) — has no render step: the preview kept the
//      app it mounted before.
//
// So on every SUCCESSFUL app write of a builder turn (simoneAiTransport.js
// onToolEvent, the `completed` frame of the add-app scope):
//   - the built apps' cached reads are dropped (`removeQueries`), always;
//   - a build write (create_extension / create_app / update_app) renders next
//     on its own (the server's clientAfterExecute render) — it now reads
//     fresh rows;
//   - any other write re-renders the app bound to the builder, from the
//     server's copy of its source (sdk.ai.listExtensions), so the preview
//     shows the app as it is now and reads its rows again.
//
// FRANK: every export is self-contained (FA204) — no import, no module
// constant; siblings through `this.call`.
// The tools whose success changes what the builder's preview shows → 'render'
// (the server renders the app next), 'refresh' (nothing renders: re-render
// here) or '' (not an app write).
function $0be1ba4154a9c548$export$ce1278b3a2cbd5b9(tool) {
    const name = String(tool || '').replace(/^module_fn_/, '');
    if (name === 'create_extension' || name === 'create_app' || name === 'update_app') return 'render';
    if (name === 'create_workspace_record' || name === 'update_workspace_record' || name === 'delete_workspace_record' || name === 'commit_project_changes') return 'refresh';
    return '';
}
function $0be1ba4154a9c548$export$fe73540f7d48cce9() {
    const el = this;
    const fns = el && el.context && el.context.functions || {};
    if (typeof fns.removeQueries !== 'function') return false;
    el.call('removeQueries', /^workspaceProject\./);
    return true;
}
async function $0be1ba4154a9c548$export$6e220a7934adfeb(tool) {
    const el = this;
    const kind = el.call('addAppPreviewWriteKind', tool);
    if (!kind) return '';
    el.call('addAppPreviewForget');
    if (kind === 'render') return 'render';
    const done = await el.call('addAppPreviewRefresh');
    return done ? 'refresh' : '';
}
async function $0be1ba4154a9c548$export$a519494ecfd18f07() {
    const el = this;
    const root = el && el.state && el.state.root;
    const id = root && root._addAppProjectId ? String(root._addAppProjectId) : '';
    const host = typeof window !== 'undefined' ? window.__addAppHost : null;
    if (!id || !host || typeof host.call !== 'function') return false;
    const fns = el.context && el.context.functions || {};
    const ai = typeof fns.getAiService === 'function' ? el.call('getAiService') : null;
    if (!ai || typeof ai.listExtensions !== 'function') return false;
    let list;
    try {
        const wsId = typeof fns.activeWorkspaceId === 'function' ? el.call('activeWorkspaceId', root) : null;
        list = await ai.listExtensions(wsId ? {
            workspaceId: wsId
        } : {});
    } catch (err) {
        console.warn('[add-app] the preview could not read the app again:', err && err.message);
        return false;
    }
    const apps = Array.isArray(list) ? list : [];
    // the person may have opened another app while the list was read
    if (String(root._addAppProjectId || '') !== id) return false;
    const ext = apps.find((a)=>a && String(a.id) === id);
    if (!ext) return false;
    if (typeof root.update === 'function') root.update({
        _userApps: apps
    });
    el.call('addAppPreviewForget');
    if (ext.appKind === 'multipage' && Array.isArray(ext.pages) && ext.pages.length) {
        await host.call('renderMultiPageApp', {
            name: ext.name,
            pages: ext.pages,
            theme: ext.theme || null
        });
        return true;
    }
    if (ext.source) {
        await host.call('injectPageInApp', {
            name: ext.name,
            source: ext.source
        });
        return true;
    }
    return false;
}

});

parcelRegister("hrwvV", function(module, exports) {

$parcel$export(module.exports, "addAppSavedRow", () => $cb2e2ddca90e2d10$export$50d140e61ced85d3);
$parcel$export(module.exports, "addAppSavedPath", () => $cb2e2ddca90e2d10$export$b431a3a7f6a050a7);
$parcel$export(module.exports, "addAppSavedLink", () => $cb2e2ddca90e2d10$export$cf2b6ec11a9f7964);
$parcel$export(module.exports, "addAppSavedNotice", () => $cb2e2ddca90e2d10$export$52e80e2097eefd5e);
// addAppSaved.js — WHERE A SAVED APP IS, AT ONCE (persona round 1b, BLD-28
// client half: nino, priya, sam, tomas, marcus — "'Add to Workspace' gives no
// message, and the apps list does not show 'Client Portal' afterwards"; "the
// draft app is not findable once I leave the builder"; "after Add to
// Workspace the app moves to the Shared list and the Private list says 'No
// private apps yet'").
//
// After Save, Share or Add to workspace the builder says where the app is now,
// in one plain line with the way to open it, and the app stands in Your apps
// at that moment — never only after a reload or the next list read:
//   addAppSavedRow     the app's row in the person's apps (`_userApps`), held
//                      at once (the list read that follows confirms it), and
//                      the sidebar's place follows the app (`_addAppScope`):
//                      a shared app is under Shared, not missing from Private
//   addAppSavedLink    the way to open it: an app in the workspace opens on its
//                      own page (its navbar tab, `addAppSavedPath`); a private or
//                      shared app opens in its builder thread
//                      (`/add-app?thread=<id>`), unless that thread is already
//                      open. A saved notice must not offer a no-op link.
//   addAppSavedNotice  the builder's line: the sentence and its link
//                      (`_addAppSaveNotice` + `_addAppSaveLink`). The link
//                      belongs to ITS sentence (`notice`), so a later notice
//                      never shows an earlier app's link.
// The person's apps are found by search too (functions/search/
// globalSearch.js reads `_userApps`).
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// The app's row, held at once → the row, or null. `app`: { id, name, scope,
// added }. A row already in the list keeps its own fields (source, pages, …);
// the new name / place and "changed now" are laid over it.
function $cb2e2ddca90e2d10$export$50d140e61ced85d3(root, app) {
    const r = root && typeof root === 'object' ? root : null;
    const id = app && app.id != null ? String(app.id) : '';
    if (!r || !id || typeof r.update !== 'function') return null;
    const scope = app.scope === 'shared' ? 'shared' : 'private';
    const list = Array.isArray(r._userApps) ? r._userApps : [];
    const held = list.find((row)=>row && String(row.id) === id) || null;
    const name = String(app && app.name || held && held.name || '').trim();
    const row = {
        ...held || {},
        id: id,
        scope: scope,
        updatedAt: new Date().toISOString()
    };
    if (name) row.name = name;
    const next = held ? list.map((x)=>x && String(x.id) === id ? row : x) : [
        row
    ].concat(list);
    r.update({
        _userApps: next,
        _addAppScope: scope
    }, {
        preventFetch: true
    });
    return row;
}
function $cb2e2ddca90e2d10$export$b431a3a7f6a050a7(root, id) {
    const pid = id != null ? String(id) : '';
    if (!pid) return '';
    const apps = root && Array.isArray(root.workspaceApps) ? root.workspaceApps : [];
    const entry = apps.find((m)=>m && String(m.id) === pid) || null;
    const row = entry && Array.isArray(entry.navbar) ? entry.navbar[0] : null;
    const path = row && typeof row.path === 'string' ? row.path : '';
    return path || '/x/' + encodeURIComponent(pid);
}
function $cb2e2ddca90e2d10$export$cf2b6ec11a9f7964(app) {
    const id = app && app.id != null ? String(app.id) : '';
    if (!id) return null;
    const el = this;
    const root = el.state && el.state.root;
    const functions = el.context?.functions || {};
    const path = String(root?.currentPath || '').split(/[?#]/)[0];
    const bare = typeof functions.stripWorkspacePrefix === 'function' ? el.call('stripWorkspacePrefix', path) : path;
    const builderOpen = String(bare || '').replace(/\/+$/, '') === '/add-app' || typeof functions.homeBuildShown === 'function' && el.call('homeBuildShown', root) || typeof functions.homeBuildInPane === 'function' && el.call('homeBuildInPane', root);
    if (!app.added && builderOpen && String(root?._addAppProjectId || '') === id) return null;
    const word = (key)=>{
        try {
            const v = el.call('polyglot', key);
            return v == null ? '' : String(v);
        } catch (_) {
            return '';
        }
    };
    const name = String(app && app.name || '').trim() || word('workspace.addApp.extensionFallback');
    return {
        href: app.added ? el.call('addAppSavedPath', root, id) : '/add-app?thread=' + encodeURIComponent(id),
        label: word('workspace.addApp.save.openApp').replace('{name}', ()=>name)
    };
}
function $cb2e2ddca90e2d10$export$52e80e2097eefd5e(root, notice, app) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r || typeof r.update !== 'function' || !notice) return null;
    const link = app ? this.call('addAppSavedLink', app) : null;
    r.update({
        _addAppSaveNotice: notice,
        _addAppSaveLink: link ? {
            notice: notice,
            href: link.href,
            label: link.label
        } : null
    });
    if (r.__addAppNoticeTimer) clearTimeout(r.__addAppNoticeTimer);
    r.__addAppNoticeTimer = setTimeout(()=>{
        r.__addAppNoticeTimer = null;
        if (r._addAppSaveNotice === notice) r.update({
            _addAppSaveNotice: null,
            _addAppSaveLink: null
        });
    }, link ? 10000 : 3500);
    return link;
}

});

parcelRegister("1DBpJ", function(module, exports) {

$parcel$export(module.exports, "addAppCrmLeadsView", () => $13167495895a7e82$export$968112c74f5adb28);
$parcel$export(module.exports, "addAppCrmLeadsRowView", () => $13167495895a7e82$export$9db9f4ef625fc1f8);
$parcel$export(module.exports, "addAppCrmLeadsLoad", () => $13167495895a7e82$export$9934e2c7cb7a5301);
$parcel$export(module.exports, "addAppCrmLeadsToggle", () => $13167495895a7e82$export$75e89beb5fc9126f);
// addAppCrmLeads.js — the built app's "send sign-ups to CRM" opt-in on the
// /add-app builder (POB, Nika 2026-10-30 "CRM leads, opt-in per app").
//
// A site the workspace AI builder made can hand its sign-up form rows to the
// workspace CRM as leads — only when the app's owner turns it on. The server
// owns the whole decision (server BuiltAppCrmLeadsController):
//   GET   /core/workspaces/:workspaceId/built-apps/:projectId/crm-leads
//   PATCH same path { enabled }      — owner / admin only (403 otherwise)
// through the SDK's sdk.getBuiltAppCrmLeads / sdk.setBuiltAppCrmLeads. The
// answer: { projectId, enabled, signupForms, crmInstalled, active, reason,
// updatedAt }, reason null when active, else 'no_signup_form' |
// 'crm_not_installed' | 'off'.
//
// The row (pages/add-app.js CrmLeadsRow) keeps the answer in its OWN state
// (`crmLeads`, `crmLeadsFor`, `crmLeadsBusy`) — no root key. What it shows:
//   - nothing for a caller the server refuses (editor, non-member → 403), a
//     missing app (404), an SDK without the methods (an older published SDK)
//     or the null client: the row is hidden, no error;
//   - the switch only when the app declares at least one sign-up form;
//   - "New sign-ups go to your CRM" when active, else the reason's own line,
//     except 'off' — the switch's state says that one.
// A failed PATCH puts the switch back where it was and raises the kit's
// error toast (openNotification), as every other settings write here does.
// The workspace id is the shell's one resolver (el.call('activeWorkspaceId'),
// functions/scopedClient.js), reached through the functions barrel.
// The SDK the element reaches (el.sdk, else the shell's getSDK), or null for
// the null client. Every method of the shell's SDK answers a PROMISE (an
// init-await Proxy), so only the method's PRESENCE is read synchronously.
const $13167495895a7e82$var$_crmLeadsSdk = (el)=>{
    let sdk = null;
    try {
        sdk = el && el.sdk || (el && typeof el.call === 'function' ? el.call('getSDK') : null);
    } catch (_) {
        sdk = null;
    }
    if (!sdk || sdk.isNullClient === true) return null;
    return sdk;
};
// The active workspace id through the shell's resolver, or null.
const $13167495895a7e82$var$_crmLeadsWorkspaceId = (el, root)=>{
    try {
        return el && typeof el.call === 'function' && el.call('activeWorkspaceId', root) || null;
    } catch (_) {
        return null;
    }
};
// The server's answer, kept to the fields the row reads. Anything that is not
// an answer reads null (the row hides).
const $13167495895a7e82$var$_crmLeadsAnswer = (answer)=>{
    if (!answer || typeof answer !== 'object') return null;
    if (typeof answer.enabled !== 'boolean') return null;
    return {
        projectId: answer.projectId != null ? String(answer.projectId) : '',
        enabled: answer.enabled,
        signupForms: Array.isArray(answer.signupForms) ? answer.signupForms : [],
        crmInstalled: answer.crmInstalled === true,
        active: answer.active === true,
        reason: typeof answer.reason === 'string' ? answer.reason : null,
        updatedAt: answer.updatedAt || null
    };
};
function $13167495895a7e82$export$968112c74f5adb28(answer) {
    const a = $13167495895a7e82$var$_crmLeadsAnswer(answer);
    if (!a) return {
        show: false,
        toggle: false,
        checked: false,
        lineKey: ''
    };
    const toggle = a.signupForms.length > 0;
    let lineKey = '';
    if (a.active) lineKey = 'workspace.addApp.crmLeads.on';
    else if (a.reason === 'crm_not_installed') lineKey = 'workspace.addApp.crmLeads.noCrm';
    else if (a.reason === 'no_signup_form') lineKey = 'workspace.addApp.crmLeads.noForm';
    return {
        show: toggle || !!lineKey,
        toggle: toggle,
        checked: a.enabled,
        lineKey: lineKey
    };
}
function $13167495895a7e82$export$9db9f4ef625fc1f8(s) {
    const bound = !!(s && s.root && s.root._addAppProjectId);
    const forThis = bound && s && s.crmLeadsFor === String(s.root._addAppProjectId);
    return $13167495895a7e82$export$968112c74f5adb28(forThis ? s.crmLeads : null);
}
async function $13167495895a7e82$export$9934e2c7cb7a5301() {
    const el = this;
    const s = el && el.state;
    if (!s || typeof s.update !== 'function') return null;
    const root = s.root || null;
    const projectId = root && root._addAppProjectId ? String(root._addAppProjectId) : '';
    const workspaceId = $13167495895a7e82$var$_crmLeadsWorkspaceId(el, root);
    const sdk = $13167495895a7e82$var$_crmLeadsSdk(el);
    if (!projectId || !workspaceId || !sdk || typeof sdk.getBuiltAppCrmLeads !== 'function') {
        s.update({
            crmLeads: null,
            crmLeadsFor: projectId,
            crmLeadsBusy: false
        });
        return null;
    }
    if (s.crmLeadsFor !== projectId) s.update({
        crmLeads: null,
        crmLeadsFor: projectId,
        crmLeadsBusy: false
    });
    let answer = null;
    try {
        answer = $13167495895a7e82$var$_crmLeadsAnswer(await sdk.getBuiltAppCrmLeads(workspaceId, projectId));
    } catch (_) {
        // 403 (not an owner / admin), 404, offline: the row stays hidden
        answer = null;
    }
    // the builder moved to another app while the read was in flight
    if (String(root && root._addAppProjectId || '') !== projectId) return null;
    s.update({
        crmLeads: answer,
        crmLeadsFor: projectId
    });
    return answer;
}
async function $13167495895a7e82$export$75e89beb5fc9126f() {
    const el = this;
    const s = el && el.state;
    if (!s || typeof s.update !== 'function') return null;
    const root = s.root || null;
    const projectId = root && root._addAppProjectId ? String(root._addAppProjectId) : '';
    const prev = s.crmLeadsFor === projectId ? s.crmLeads : null;
    if (!prev || s.crmLeadsBusy) return null;
    const workspaceId = $13167495895a7e82$var$_crmLeadsWorkspaceId(el, root);
    const sdk = $13167495895a7e82$var$_crmLeadsSdk(el);
    if (!workspaceId || !sdk || typeof sdk.setBuiltAppCrmLeads !== 'function') return null;
    const enabled = !prev.enabled;
    s.update({
        crmLeadsBusy: true,
        crmLeads: {
            ...prev,
            enabled: enabled
        }
    });
    try {
        const answer = $13167495895a7e82$var$_crmLeadsAnswer(await sdk.setBuiltAppCrmLeads(workspaceId, projectId, {
            enabled: enabled
        }));
        s.update({
            crmLeadsBusy: false,
            crmLeads: answer || {
                ...prev,
                enabled: enabled
            }
        });
        return answer;
    } catch (_) {
        s.update({
            crmLeadsBusy: false,
            crmLeads: prev
        });
        try {
            el.call('openNotification', {
                title: el.call('polyglot', 'workspace.addApp.crmLeads.saveError'),
                type: 'error'
            });
        } catch (__) {
        /* the switch is back where it was */ }
        return null;
    }
}

});

parcelRegister("1nnHq", function(module, exports) {

$parcel$export(module.exports, "SHARE_EXPIRY_CHOICES", () => $100a52a25cbf58b4$export$37ca3a0113b53a2b);
$parcel$export(module.exports, "isPublicShareViewPath", () => $100a52a25cbf58b4$export$8da22d8d846cc8f5);
$parcel$export(module.exports, "shareLinkUrl", () => $100a52a25cbf58b4$export$cae93c36f1687529);
$parcel$export(module.exports, "openShareModal", () => $100a52a25cbf58b4$export$bc9d470aa4d15670);
$parcel$export(module.exports, "closeShareModal", () => $100a52a25cbf58b4$export$76b1017990596240);
$parcel$export(module.exports, "refreshShareLinks", () => $100a52a25cbf58b4$export$624f9e67a99c80ef);
$parcel$export(module.exports, "createShareLinkNow", () => $100a52a25cbf58b4$export$c96bbe07397fd748);
$parcel$export(module.exports, "copyShareLink", () => $100a52a25cbf58b4$export$f83f67a708eba4a7);
$parcel$export(module.exports, "revokeShareLinkNow", () => $100a52a25cbf58b4$export$c9dbd890f4268589);
$parcel$export(module.exports, "confirmRevokeShareLink", () => $100a52a25cbf58b4$export$ffad02f77772c1a);
$parcel$export(module.exports, "shareLinkStatusLabel", () => $100a52a25cbf58b4$export$9fa1b3bf095b9bcb);
// Public share links — the ONE implementation behind the "Share publicly…"
// action on every surface (PUBLIC-SHARE-LINKS-1).
//
// WHY IT LIVES IN THE SHELL, not in files/ and documents/
// Both feature packages need the identical dialog, and neither may import
// the other (no sibling imports between project files). The shell already
// owns the cross-surface chrome, so the modal + these helpers live here once
// and a feature package contributes a single menu row:
//
//   el.call('openShareModal', { targetType: 'file', targetId, name })
//
// Functions and components merge into ONE context at boot, so the call and
// the `extends: 'ShareLinkModal'` bare key resolve from any package mounted
// in the shell. Outside the shell the call is simply absent — the menu row
// degrades to a no-op instead of crashing.
//
// ⚠️ THE TOKEN IS SHOWN ONCE
// The server stores only sha256(token). `createShareLink` is the only call
// that ever returns the raw value, so `_shareNewUrl` holds it for exactly as
// long as the dialog is open and nothing persists it. Reopening the dialog
// lists the link but CANNOT show its URL again — that is the design, not a
// gap: mint a new link and revoke the old one.
//
// Defaults are Nika's product calls (2026-08-20): the link serves the LIVE
// document, and it expires in 30 DAYS unless the user picks "never".

var $1X0Je = parcelRequire("1X0Je");
// The SDK comes off the ELEMENT first (`el.sdk`, what every files/notes
// function already uses) and falls back to the shared singleton only when a
// caller has none. Element-first is what makes these functions testable
// without a live SDK — and it is the same instance either way at runtime.
const $100a52a25cbf58b4$var$_shellSdk = (el)=>el?.sdk || (0, $1X0Je.default).functions && (0, $1X0Je.default).functions.getSDK();
const $100a52a25cbf58b4$var$SHARE_LAYER_ID = 'share-link';
const $100a52a25cbf58b4$export$37ca3a0113b53a2b = [
    {
        key: '30',
        days: 30,
        label: 'workspace.share.expiry.d30'
    },
    {
        key: '7',
        days: 7,
        label: 'workspace.share.expiry.d7'
    },
    {
        key: '90',
        days: 90,
        label: 'workspace.share.expiry.d90'
    },
    {
        key: 'never',
        days: null,
        label: 'workspace.share.expiry.never'
    }
];
const $100a52a25cbf58b4$export$8da22d8d846cc8f5 = (pathname)=>/^(?:\/w\/[a-z0-9-]{1,48}(?:\/[A-Za-z0-9_-]{1,64})?)?\/s\/[^/]+/.test(typeof pathname === 'string' ? pathname : '');
const $100a52a25cbf58b4$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
const $100a52a25cbf58b4$var$_origin = ()=>typeof window !== 'undefined' ? window.location.origin : '';
// Two busy flags, not one. `_shareLoading` is the BACKGROUND list read that
// openShareModal kicks off; `_shareBusy` is a user-initiated mutation
// (create/revoke). Sharing one flag made the dialog's own opening read
// disable the Create button until the list came back — a real dead window
// on a slow link, and the reason the unit suite could not create right
// after opening.
const $100a52a25cbf58b4$var$_reset = {
    _shareTarget: null,
    _shareLinks: [],
    _shareBusy: false,
    _shareLoading: false,
    _shareError: null,
    _shareNewUrl: null,
    _shareExpiryKey: '30'
};
function $100a52a25cbf58b4$export$cae93c36f1687529(pathOrToken) {
    if (!pathOrToken) return '';
    // Composed HERE rather than through `sdk.shareUrl`, even though the SDK
    // ships the identical helper. The shell reaches the SDK through
    // shared/functions/sdkClient.js, whose proxy makes EVERY method async
    // unless it is in the small `SYNC_PASS` allowlist — so a SYNC SDK helper
    // called from UI code returns a Promise, and a Promise stringifies into
    // the DOM as "[object Promise]". Measured live 2026-08-22 on
    // workspace.localhost: `sdk.shareUrl('/s/ABC', origin)` came back as a
    // Promise. The allowlist lives in a shared package this squad does not
    // own, and a URL join needs no SDK at all — so the shell owns the join
    // and the SDK method stays for consumers that call the SDK directly.
    const path = String(pathOrToken).startsWith('/s/') ? String(pathOrToken) : `/s/${pathOrToken}`;
    const origin = $100a52a25cbf58b4$var$_origin();
    return origin ? `${origin.replace(/\/+$/, '')}${path}` : path;
}
function $100a52a25cbf58b4$export$bc9d470aa4d15670(target) {
    const root = $100a52a25cbf58b4$var$_rootState(this);
    if (!root || !target || !target.targetType || !target.targetId) return;
    root.update({
        ...$100a52a25cbf58b4$var$_reset,
        _shareTarget: {
            targetType: target.targetType,
            targetId: String(target.targetId),
            name: target.name || ''
        }
    });
    this.call('openCustomModal', {
        id: $100a52a25cbf58b4$var$SHARE_LAYER_ID,
        content: {
            extends: 'ShareLinkModal'
        }
    });
    this.call('refreshShareLinks');
}
function $100a52a25cbf58b4$export$76b1017990596240() {
    const root = $100a52a25cbf58b4$var$_rootState(this);
    root?.update($100a52a25cbf58b4$var$_reset);
    this.call('closeModal', $100a52a25cbf58b4$var$SHARE_LAYER_ID);
}
async function $100a52a25cbf58b4$export$624f9e67a99c80ef() {
    const root = $100a52a25cbf58b4$var$_rootState(this);
    const target = root?._shareTarget;
    if (!target) return;
    root.update({
        _shareLoading: true,
        _shareError: null
    });
    try {
        const res = await $100a52a25cbf58b4$var$_shellSdk(this).listShareLinks({
            targetType: target.targetType,
            targetId: target.targetId
        });
        root.update({
            _shareLoading: false,
            _shareLinks: res?.data || res || []
        });
    } catch (err) {
        root.update({
            _shareLoading: false,
            _shareError: err?.message || this.call('polyglot', 'workspace.share.error.loadFailed')
        });
    }
}
async function $100a52a25cbf58b4$export$c96bbe07397fd748() {
    const root = $100a52a25cbf58b4$var$_rootState(this);
    const target = root?._shareTarget;
    if (!target || root._shareBusy) return;
    const choice = $100a52a25cbf58b4$export$37ca3a0113b53a2b.find((c)=>c.key === (root._shareExpiryKey || '30')) || $100a52a25cbf58b4$export$37ca3a0113b53a2b[0];
    root.update({
        _shareBusy: true,
        _shareError: null
    });
    try {
        // `days: null` means never — pass it EXPLICITLY. Omitting the key would
        // ask the server for its default instead, which is the opposite choice.
        const created = await $100a52a25cbf58b4$var$_shellSdk(this).createShareLink({
            targetType: target.targetType,
            targetId: target.targetId,
            expiresInDays: choice.days
        });
        const url = $100a52a25cbf58b4$export$cae93c36f1687529(created?.path || created?.token);
        root.update({
            _shareBusy: false,
            _shareNewUrl: url
        });
        await this.call('refreshShareLinks');
        // The clipboard write is FIRE-AND-FORGET, deliberately not awaited.
        // `navigator.clipboard.writeText` can HANG — not reject — while the
        // browser decides whether to prompt for the permission (measured live
        // 2026-08-22: a create in a non-focused tab left the await pending long
        // enough to time out the whole evaluation). Awaiting it would leave the
        // dialog mid-flow on a link that already exists and is already on
        // screen. The copy is a convenience; the link is the result.
        this.call('copyShareLink', url);
    } catch (err) {
        root.update({
            _shareBusy: false,
            _shareError: err?.message || this.call('polyglot', 'workspace.share.error.createFailed')
        });
    }
}
async function $100a52a25cbf58b4$export$f83f67a708eba4a7(url) {
    if (!url) return false;
    try {
        await navigator.clipboard.writeText(url);
        this.call('openNotification', {
            type: 'success',
            title: this.call('polyglot', 'workspace.share.copied.title'),
            message: this.call('polyglot', 'workspace.share.copied.message')
        });
        return true;
    } catch (err) {
        // A clipboard refusal is not a failure of the SHARE — the link exists and
        // is visible in the dialog. Say exactly that instead of implying the
        // share did not happen.
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'workspace.share.copyFailed.title'),
            message: this.call('polyglot', 'workspace.share.copyFailed.message')
        });
        console.warn('[ShareLink] clipboard write failed:', err?.message || err);
        return false;
    }
}
async function $100a52a25cbf58b4$export$c9dbd890f4268589(id) {
    const root = $100a52a25cbf58b4$var$_rootState(this);
    if (!id || !root || root._shareBusy) return;
    root.update({
        _shareBusy: true,
        _shareError: null
    });
    try {
        await $100a52a25cbf58b4$var$_shellSdk(this).revokeShareLink(id);
        // A revoked link's URL must stop being offered for copying — the field
        // still holding it would invite pasting a dead link.
        root.update({
            _shareBusy: false,
            _shareNewUrl: null
        });
        await this.call('refreshShareLinks');
        this.call('openNotification', {
            type: 'success',
            title: this.call('polyglot', 'workspace.share.revoked.title'),
            message: this.call('polyglot', 'workspace.share.revoked.message')
        });
    } catch (err) {
        root.update({
            _shareBusy: false,
            _shareError: err?.message || this.call('polyglot', 'workspace.share.error.revokeFailed')
        });
    }
}
function $100a52a25cbf58b4$export$ffad02f77772c1a(id) {
    const root = $100a52a25cbf58b4$var$_rootState(this);
    if (!id || !root || root._shareBusy) return;
    const name = String(root._shareTarget?.name || '').trim();
    this.call('confirmDialog', {
        title: name ? this.call('polyglot', 'workspace.share.revoke.title').replace('{name}', ()=>name) : this.call('polyglot', 'shell.invite.link.revokeAsk'),
        message: this.call('polyglot', 'workspace.share.revoked.message'),
        confirmText: this.call('polyglot', 'workspace.share.modal.revoke'),
        cancelText: this.call('polyglot', 'shell.invite.link.keep'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: ()=>this.call('revokeShareLinkNow', id)
    });
}
function $100a52a25cbf58b4$export$9fa1b3bf095b9bcb(row) {
    if (!row) return '';
    const t = (k)=>this.call('polyglot', k);
    if (row.revokedAt) return t('workspace.share.status.revoked');
    if (row.expiresAt && new Date(row.expiresAt).getTime() <= Date.now()) return t('workspace.share.status.expired');
    if (!row.expiresAt) return t('workspace.share.status.never');
    const days = Math.max(0, Math.ceil((new Date(row.expiresAt).getTime() - Date.now()) / 86400000));
    return days <= 1 ? t('workspace.share.status.today') : t('workspace.share.status.days').replace('{count}', days);
}

});

parcelRegister("iQSJg", function(module, exports) {

$parcel$export(module.exports, "openProfileModal", () => $db97895b6c13580a$export$61e0beb31520f9bf);
$parcel$export(module.exports, "closeProfileModal", () => $db97895b6c13580a$export$59bdd6288bde72bc);
// Calendar profile modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openProfileModal', email)
//   el.call('closeProfileModal')
//
// Migrated 2026-06-01 from `root.update({ profileEmail: email })` to a
// @symbo.ls/windows custom-template layer. `root.profileEmail` stays as
// the data carrier — chat hash-sync + the body's own reactive reads
// still pull from it. Only the visibility flag moves to the layer.
const $db97895b6c13580a$var$PROFILE_LAYER_ID = 'cal-profile';
const $db97895b6c13580a$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
function $db97895b6c13580a$export$61e0beb31520f9bf(email) {
    if (!email) return;
    const root = $db97895b6c13580a$var$_rootState(this);
    if (!root) return;
    root.update({
        profileEmail: email
    });
    // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
    // so the Close X can't be pushed off-screen by tall content / a short
    // viewport.
    this.call('openCustomModal', {
        id: $db97895b6c13580a$var$PROFILE_LAYER_ID,
        content: {
            extends: 'CalProfileModal'
        }
    });
}
function $db97895b6c13580a$export$59bdd6288bde72bc() {
    const root = $db97895b6c13580a$var$_rootState(this);
    // Mirrors the old `extraClose: { profileModalTab: 'profile' }` reset.
    root?.update({
        profileEmail: null,
        profileModalTab: 'profile'
    });
    this.call('closeModal', $db97895b6c13580a$var$PROFILE_LAYER_ID);
}

});

parcelRegister("48wyv", function(module, exports) {

$parcel$export(module.exports, "openEventDetailModal", () => $303129a5cf0d83ea$export$9907b6a0e04f8af0);
$parcel$export(module.exports, "closeEventDetailModal", () => $303129a5cf0d83ea$export$4a1d18c2db75c2ef);
$parcel$export(module.exports, "closeStaleEventDetailModal", () => $303129a5cf0d83ea$export$f3fd689c15653601);
// Calendar event detail modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openEventDetailModal', event)   // calendar event object
//   el.call('closeEventDetailModal')
//
// Migrated 2026-06-01 from `root.update({ selectedEvent: ev,
// showEventDetail: true })` to a @symbo.ls/windows custom-template
// layer. `root.selectedEvent` retained as data carrier — the body's
// reactive reads + the chat/calendar hash sync still pull from it.

var $3W6VK = parcelRequire("3W6VK");
const $303129a5cf0d83ea$var$EVENT_DETAIL_LAYER_ID = 'cal-event-detail';
const $303129a5cf0d83ea$var$ACTIVE_EVENT_DETAIL_KEY = Symbol.for('symbols.calendar.activeEventDetail');
const $303129a5cf0d83ea$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
// URL deep-link marker — same shape as the tickets modal's `?ticket=<id>`
// (2026-06-08 per Nika "event modal url same as tickets"). A query param
// instead of the calendar's `#event=` hash so the link is route-independent
// — it survives opening the calendar inside the home AppWindow (where the
// hash sync is gated off) and is shareable like a ticket link.
const $303129a5cf0d83ea$var$_eventSnapshot = (event)=>({
        id: event.id,
        title: event.title,
        date: event.date,
        startTime: event.startTime,
        endTime: event.endTime,
        startAt: event.startAt,
        endAt: event.endAt,
        creatorEmail: event.creatorEmail,
        organizerEmail: event.organizerEmail,
        description: event.description,
        invitees: event.invitees,
        integrationMetadata: event.integrationMetadata,
        googleEventId: event.googleEventId,
        googleCalendarId: event.googleCalendarId,
        color: event.color,
        type: event.type
    });
const $303129a5cf0d83ea$var$_setEventUrlParam = (event)=>{
    if (typeof window === 'undefined' || event?.id == null) return;
    try {
        const url = new URL(window.location.href);
        url.searchParams.set('event', String(event.id));
        // The calendar feed and the PageSlot restore asynchronously. Carry the
        // already-open event with its deep link so a refresh can render details
        // immediately instead of mounting the modal against selectedEvent=null.
        url.searchParams.set('eventSnapshot', JSON.stringify($303129a5cf0d83ea$var$_eventSnapshot(event)));
        window.history.replaceState(null, '', url.toString());
    } catch (_) {}
};
// Only while the address still names THIS event. A close that a navigation
// causes (`closeStaleEventDetailModal`) runs on the NEW address, and that
// address can already name ANOTHER event (Back / Forward to its link): its
// params must stay for that event's own restore.
const $303129a5cf0d83ea$var$_clearEventUrlParam = (eventId)=>{
    if (typeof window === 'undefined') return;
    try {
        const url = new URL(window.location.href);
        const named = url.searchParams.get('event');
        if (named !== null && (eventId == null || named === String(eventId))) {
            for (const key of [
                'event',
                'eventSeries',
                'eventFingerprint',
                'eventSnapshot',
                'eventRsvp'
            ])url.searchParams.delete(key);
            window.history.replaceState(null, '', url.toString());
        }
    } catch (_) {}
};
function $303129a5cf0d83ea$export$9907b6a0e04f8af0(event) {
    if (!event) return;
    const root = $303129a5cf0d83ea$var$_rootState(this);
    if (!root) return;
    // Deep-link restoration can be attempted by more than one keep-alive
    // Calendar instance while the workspace PageSlot is settling. Opening the
    // same event again would push another windows layer; after a refresh those
    // duplicate layers surfaced as an empty modal and console warnings for
    // ModalLayer_0, ModalLayer_1, ... . The first opener owns the layer.
    if (root.showEventDetail && String(root.selectedEvent?.id || '') === String(event.id || '')) return;
    // A PageSlot calendar and its keep-alive counterpart can restore the same
    // query-param event through different root objects. Root-local carrier
    // flags cannot dedupe those calls, but both instances share one document
    // and one windows layer host. Claim the event id before pushing the layer
    // so even two synchronous restore calls produce one dialog.
    const eventId = event.id == null ? null : String(event.id);
    const eventDocument = typeof document === 'object' && document ? document : null;
    if (eventDocument && eventId != null) {
        if (eventDocument[$303129a5cf0d83ea$var$ACTIVE_EVENT_DETAIL_KEY] === eventId) return;
        eventDocument[$303129a5cf0d83ea$var$ACTIVE_EVENT_DETAIL_KEY] = eventId;
    }
    // Normalize description + invitees so the skeleton state in
    // CalEventDetailModal doesn't get stuck. The body's reactive props
    // treat `undefined` as "still loading" and show indefinite
    // skeletons. Summary feeds (intranetEvents on the home dashboard,
    // certain mention links) deliver events without those fields at
    // all → modal renders, fires fetchEventDetails on init, but if the
    // fetch silently fails or returns no extra data the description /
    // invitees fields stay undefined and the skeleton never resolves.
    //
    // Pre-seeding with whatever the caller already has (preserving
    // values they passed in) and `null` / `[]` fallback means:
    //   - If the SDK fetch populates real values, both are overwritten
    //     in fetchEventDetails — caller never sees a stale empty state.
    //   - If the fetch never resolves, the body renders the loaded
    //     branch with empty content; the user sees the title + time +
    //     header info and can close the modal cleanly instead of
    //     staring at a never-ending skeleton.
    const normalized = {
        ...event,
        // Creator/organizer parity (2026-06-10) — the home "Coming up" feed
        // (intranetEvents) delivers the organizer as `organizerEmail`, while the
        // calendar `events` feed maps the SAME `organizer_email` DB column to
        // `creatorEmail` (loadPrivateData). CalEventDetailModal's "Created by"
        // row reads `creatorEmail` only, so without this fallback that row
        // silently vanished when the modal was opened from the home dashboard —
        // the visible "events modal looks worse on /" gap. Normalize once here,
        // the single choke-point both the home and calendar event cells share.
        creatorEmail: event.creatorEmail || event.organizerEmail || null,
        description: event.description ?? null,
        invitees: Array.isArray(event.invitees) ? event.invitees : []
    };
    root.update({
        selectedEvent: normalized,
        showEventDetail: true
    });
    // Reflect the open event in the URL as `?event=<id>` (tickets-style,
    // route-independent) so the link is shareable and works from `/`.
    $303129a5cf0d83ea$var$_setEventUrlParam(normalized);
    // onClose fires when the layer is popped via backdrop click or ESC
    // (the windows ModalLayer dispatches it from its dismiss path). Use
    // it to clear selectedEvent so reopen-on-different-event doesn't
    // surface the previous one's data for a frame, and so onUpdate's
    // hash-clear runs.
    (0, $3W6VK.suppressInitialModalFocus)($303129a5cf0d83ea$var$EVENT_DETAIL_LAYER_ID);
    // MODAL-X-OVERFLOW-1: an explicit maxHeight keeps the outer ModalWindow
    // ceiling bounded so tall content / a short viewport can't push
    // ModalHeader's Close X off-screen (@symbo.ls/windows defaults maxHeight
    // to null otherwise). Kept as a raw openModal call (not the shared
    // openCustomModal wrapper) — this file's own unit test pins the literal
    // 'openModal' dispatch name.
    this.call('openModal', {
        id: $303129a5cf0d83ea$var$EVENT_DETAIL_LAYER_ID,
        template: 'custom',
        width: 'I',
        maxWidth: '92vw',
        maxHeight: '90vh',
        content: {
            extends: 'CalEventDetailModal'
        },
        onClose: ()=>{
            if (eventDocument && eventDocument[$303129a5cf0d83ea$var$ACTIVE_EVENT_DETAIL_KEY] === eventId) delete eventDocument[$303129a5cf0d83ea$var$ACTIVE_EVENT_DETAIL_KEY];
            const selected = root.selectedEvent;
            const responses = selected?.integrationMetadata?.calendarParticipantResponses;
            let events = root.events;
            if (responses && selected) {
                const seriesBase = String(selected.googleEventId || '').replace(/_\d{8}(?:T\d{6}Z)?$/, '');
                events = (root.events || []).map((event)=>{
                    const sameEvent = event.id === selected.id;
                    const sameSeries = seriesBase && String(event.googleEventId || '').replace(/_\d{8}(?:T\d{6}Z)?$/, '') === seriesBase;
                    if (!sameEvent && !sameSeries) return event;
                    return {
                        ...event,
                        integrationMetadata: {
                            ...event.integrationMetadata || {},
                            calendarParticipantResponses: responses
                        }
                    };
                });
            }
            root.update({
                events: events,
                selectedEvent: null,
                showEventDetail: false
            });
            $303129a5cf0d83ea$var$_clearEventUrlParam(eventId);
        }
    });
}
function $303129a5cf0d83ea$export$4a1d18c2db75c2ef() {
    // selectedEvent + showEventDetail are cleared by the layer's onClose
    // callback (see openEventDetailModal above). All this needs to do is
    // pop the windows-plugin layer; the onClose path handles the rest.
    // The X button's onClick + any other explicit-close consumer routes
    // through here.
    this.call('closeModal', $303129a5cf0d83ea$var$EVENT_DETAIL_LAYER_ID);
}
function $303129a5cf0d83ea$export$f3fd689c15653601(wantedId) {
    const root = $303129a5cf0d83ea$var$_rootState(this);
    const openId = root?.showEventDetail ? root.selectedEvent?.id : null;
    if (openId == null) return false;
    const wanted = wantedId !== undefined ? wantedId : this.call('readPageParam', 'event');
    if (wanted != null && String(wanted) === String(openId)) return false;
    $303129a5cf0d83ea$export$4a1d18c2db75c2ef.call(this);
    return true;
}

});
parcelRegister("3W6VK", function(module, exports) {

$parcel$export(module.exports, "restoreOpenModalLayer", () => $2ddc2a18cd1b8783$export$82825f4e36e49bd5);
$parcel$export(module.exports, "suppressInitialModalFocus", () => $2ddc2a18cd1b8783$export$c4cec362fda86fd0);
// Reused windows slots can retain their closed state when the reactive open
// pass is skipped. Restore the host properties that control layout, paint and
// hit-testing without raising CSS specificity.
const $2ddc2a18cd1b8783$export$82825f4e36e49bd5 = (layerId)=>{
    const root = globalThis.__SMBLS_WINDOWS_MODAL_ROOT__;
    const stack = root?.state?.stack || [];
    const index = stack.findIndex((layer)=>layer?.id === layerId);
    if (index < 0) return;
    const slot = root?.['ModalLayer_' + index];
    const node = slot?.node || slot?.__ref?.node;
    if (!node?.style?.setProperty) return;
    node.style.setProperty('display', 'flex');
    node.style.setProperty('opacity', '1');
    node.style.setProperty('visibility', 'visible');
    node.style.setProperty('pointer-events', 'auto');
};
const $2ddc2a18cd1b8783$export$c4cec362fda86fd0 = (layerId)=>{
    if (typeof document === 'undefined') return;
    const titleId = 'modal-title-' + layerId;
    const onFocus = (event)=>{
        const dialog = event.target?.closest?.(`[aria-labelledby="${titleId}"]`);
        if (dialog) event.target.blur?.();
    };
    document.addEventListener('focusin', onFocus, true);
    const schedule = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (callback)=>setTimeout(callback, 0);
    schedule(()=>schedule(()=>document.removeEventListener('focusin', onFocus, true)));
};

});


parcelRegister("aJk2q", function(module, exports) {

$parcel$export(module.exports, "openNewBookingModal", () => $7cfda67b76f73572$export$307f246a9bee0648);
$parcel$export(module.exports, "closeNewBookingModal", () => $7cfda67b76f73572$export$e85fed53a6d03b78);
// Calendar new-booking modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openNewBookingModal', overrides)   // freshBooking() overrides
//   el.call('closeNewBookingModal')
//
// Migrated 2026-08-01 from `root.update({ showNewBooking: true, newBooking:
// freshBooking(overrides) })` to a @symbo.ls/windows custom-template layer —
// mirrors the 2026-06-01 CalProfileModal / CalEventDetailModal migration.
// `root.newBooking` / `root.showNewBooking` are retained as data carriers —
// the body's reactive reads (title autofocus, edit-vs-create header copy,
// the scope-picker save re-trigger) still pull from them.
//
// `overrides` is passed straight to `freshBooking(overrides)` — the exact
// contract every former in-page opener already used (date, invitees, type,
// editingEventId for the edit path, …). A caller that genuinely can't
// express its draft via freshBooking overrides can pass a fully-built
// booking object as `{ __booking }` and it's used as-is instead — prefer
// plain overrides everywhere; nothing in this codebase needs the escape
// hatch today.

var $3W6VK = parcelRequire("3W6VK");
const $7cfda67b76f73572$var$NEW_BOOKING_LAYER_ID = 'cal-new-booking';
const $7cfda67b76f73572$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
function $7cfda67b76f73572$export$307f246a9bee0648(overrides) {
    const root = $7cfda67b76f73572$var$_rootState(this);
    if (!root) return;
    const booking = overrides && overrides.__booking ? overrides.__booking : this.call('freshBooking', overrides || {});
    // MODAL-X-OVERFLOW-1: an explicit maxHeight keeps the outer ModalWindow
    // ceiling bounded so tall content / a short viewport can't push
    // ModalHeader's Close X off-screen (@symbo.ls/windows defaults maxHeight
    // to null otherwise). Kept as a raw openModal call (not the shared
    // openCustomModal wrapper) — this file's own unit test pins the literal
    // 'openModal' dispatch name.
    this.call('openModal', {
        id: $7cfda67b76f73572$var$NEW_BOOKING_LAYER_ID,
        template: 'custom',
        // The date + two time inputs need more room than the shared modal's
        // compact default. Keep the wider desktop size responsive on smaller
        // viewports instead of letting the row escape the window.
        width: 'I',
        maxWidth: '92vw',
        maxHeight: '90vh',
        content: {
            extends: 'CalNewBookingModal'
        },
        // Mirrors the old `extraClose: { pendingSuggestion: null }` reset —
        // fires on every dismiss path (backdrop click, ESC, X button,
        // programmatic close).
        onClose: ()=>root.update({
                showNewBooking: false,
                pendingSuggestion: null
            })
    });
    (0, $3W6VK.restoreOpenModalLayer)($7cfda67b76f73572$var$NEW_BOOKING_LAYER_ID);
    // Push the layer before publishing the legacy URL/form carriers. In recent
    // signal builds, subscribers to showNewBooking can enter a reactive cascade;
    // dispatching first guarantees that cascade cannot swallow the user's click.
    root.update({
        newBooking: booking,
        showNewBooking: true
    });
}
function $7cfda67b76f73572$export$e85fed53a6d03b78() {
    // showNewBooking + pendingSuggestion are cleared by the layer's onClose
    // callback (see openNewBookingModal above) — this only needs to pop the
    // windows-plugin layer.
    this.call('closeModal', $7cfda67b76f73572$var$NEW_BOOKING_LAYER_ID);
}

});

parcelRegister("j3mi5", function(module, exports) {

$parcel$export(module.exports, "openTicketDetailModal", () => $ddef96967017b75c$export$3692dd58632b9073);
$parcel$export(module.exports, "closeTicketDetailModal", () => $ddef96967017b75c$export$517ff7e6347a6e8e);
// Ticket detail modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openTicketDetailModal', ticket)
//   el.call('closeTicketDetailModal')
//
// Seeds `root.selectedTicket` ONLY. `TicketsDetailModal` extends Modal with
// stateKey 'selectedTicket'; the SINGLE shell-root instance (workspace/app.js,
// 2026-08-06 consolidation of the former 14 page mounts) shows reactively the
// moment the carrier is set — an instant display flip on EVERY route,
// calendar/documents/files/studio/admin included.
//
// The @symbo.ls/windows custom-template push this helper used to ALSO do is
// deliberately GONE: windows' Slot.set(content) re-prepares the ~4,000-line
// TicketsDetailModal definition synchronously on EVERY open — a measured
// 15-40s main-thread freeze (see the perf note above the shell-root mount in
// app.js; the framework fix for the super-linear prepare is ticketed in
// tickets/smbls.md). First surfaced live when notification clicks started
// opening tickets from arbitrary routes: `/w/<org>?ticket=<id>` hard-froze
// the tab. Pages must NOT re-mount the modal — Modal stateKey semantics
// make any second mounted instance a double-open.
const $ddef96967017b75c$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
// WS-ROOT-DEFAULTS-NO-WRITER-1: root.recentTickets had a reader (chat's
// ##number ref lookup, TicketDetailModal's own urlId scan) but no writer,
// ever — every open funnels through this single choke point, so it is the
// one place a recently-viewed cache can be built without a second writer
// to keep in sync.
const $ddef96967017b75c$var$RECENT_TICKETS_CAP = 20;
const $ddef96967017b75c$var$_ticketKey = (t)=>String(t?.id ?? t?._id ?? t?.number ?? '');
function $ddef96967017b75c$export$3692dd58632b9073(ticket) {
    if (!ticket) return;
    const root = $ddef96967017b75c$var$_rootState(this);
    if (!root) return;
    const key = $ddef96967017b75c$var$_ticketKey(ticket);
    const prevRecent = Array.isArray(root.recentTickets) ? root.recentTickets : [];
    const recentTickets = key ? [
        ticket,
        ...prevRecent.filter((t)=>$ddef96967017b75c$var$_ticketKey(t) !== key)
    ].slice(0, $ddef96967017b75c$var$RECENT_TICKETS_CAP) : prevRecent;
    root.update({
        selectedTicket: ticket,
        recentTickets: recentTickets
    });
}
function $ddef96967017b75c$export$517ff7e6347a6e8e() {
    const root = $ddef96967017b75c$var$_rootState(this);
    root?.update({
        selectedTicket: null
    });
}

});

parcelRegister("5UN4H", function(module, exports) {

$parcel$export(module.exports, "openPersonDetailModal", () => $44e83fef4e269831$export$39436bee7bb5e35e);
$parcel$export(module.exports, "closePersonDetailModal", () => $44e83fef4e269831$export$823295e3d65adde2);
// Person detail modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openPersonDetailModal', person)   // person object
//   el.call('closePersonDetailModal')
//
// Migrated 2026-06-01 from `root.update({ _personDetail: person })` to
// a @symbo.ls/windows custom-template layer. `root._personDetail` plus
// the related `_personDetailShowAdd` / `_personDetailAddTeamId` fields
// stay as data carriers — the body's reactive reads on them are
// unchanged.
const $44e83fef4e269831$var$PERSON_DETAIL_LAYER_ID = 'person-detail';
const $44e83fef4e269831$var$_rootState = (el)=>el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null;
function $44e83fef4e269831$export$39436bee7bb5e35e(person) {
    if (!person) return;
    const root = $44e83fef4e269831$var$_rootState(this);
    if (!root) return;
    root.update({
        _personDetail: person,
        _personDetailShowAdd: false,
        _personDetailAddTeamId: null
    });
    // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
    // so the Close X can't be pushed off-screen by tall content / a short
    // viewport.
    //
    // WS-MODAL-X-HORIZONTAL-OVERFLOW-1: window WIDTH is the layer's job, not
    // the body's. The descriptor sizes ModalWindow (ModalLayer.js reads
    // `width` / `maxWidth` through walkToLayer) so the window caps at the
    // viewport; the body then fills 100% of that slot. Before this the body
    // carried `width: 'I'` inside a default-'H' window with
    // `overflow: 'visible'`, so the body — and the ModalHeader Close X at its
    // right edge — painted OUTSIDE the window and past the viewport.
    this.call('openCustomModal', {
        id: $44e83fef4e269831$var$PERSON_DETAIL_LAYER_ID,
        width: 'I',
        maxWidth: '90vw',
        content: {
            extends: 'PersonDetailModal'
        }
    });
}
function $44e83fef4e269831$export$823295e3d65adde2() {
    const root = $44e83fef4e269831$var$_rootState(this);
    root?.update({
        _personDetail: null,
        _personDetailShowAdd: false,
        _personDetailAddTeamId: null
    });
    this.call('closeModal', $44e83fef4e269831$var$PERSON_DETAIL_LAYER_ID);
}

});

parcelRegister("lY4w0", function(module, exports) {

$parcel$export(module.exports, "openPersonPopover", () => $ffe2b43354c87b4d$export$6e799d6986e1b736);
$parcel$export(module.exports, "closePersonPopover", () => $ffe2b43354c87b4d$export$56729464abb1c3f7);
// Anchored mini-profile + quick-actions popover — el.call('openPersonPopover',
// email, anchorEl). Mirrors the openProfileModal / openPersonDetailModal /
// openTicketDetailModal convention (this file's siblings): stash the target
// on root state, then trigger the surface that reads it back reactively.
//
// Unlike those three this is NOT a @symbo.ls/windows modal layer — it's a
// small anchored dropdown, the SAME @symbo.ls/dropdown layer AppOrgSwitcher
// and AppNavbar's More menu use (DropdownRoot mounted once at the shell root
// in app.js). ESC + outside-click dismiss and auto-flip positioning are
// already owned by that shared layer — nothing to wire here for those.
//
// `content` on the dropdown layer is a static descriptor (see
// @symbo.ls/dropdown openDropdown — it has no per-open payload channel), so
// `root._personPopoverEmail` is the data channel the content component
// (PersonPopoverCard, components/PersonPopover.js) reads.
const $ffe2b43354c87b4d$var$POPOVER_ID = 'personPopover';
function $ffe2b43354c87b4d$export$6e799d6986e1b736(email, anchorEl, displayName) {
    if (!email) return;
    const root = this?.state?.root || this?.state;
    if (!root) return;
    // §3.7 Directory: an address outside the member roster resolves against
    // Party emails — fired here, at the mutation site, never from a popover
    // lifecycle hook; the card reads root._partyByEmail back reactively.
    // Fire-and-forget: the popover renders its email fallback meanwhile.
    const known = this.call('findPerson', email);
    if (!known) this.call('resolvePartyByEmail', email);
    // `selectedPerson` no longer carries geometry — the dropdown layer owns
    // placement since SharedPersonCard was retired. It stays as the ASSISTANT'S
    // awareness channel: the detectOpenRecord ladder in functions/pageContext.js
    // and AiContextBar's subscription list both key off it, so removing its last
    // writer left the assistant blind to an open person. `onClose` below clears
    // it, which is what made this key unusable before — nothing cleared it.
    root.update({
        _personPopoverEmail: email,
        _personPopoverName: displayName || null,
        selectedPerson: known || {
            email: email,
            name: displayName || null
        }
    });
    this.call('openDropdown', {
        anchorEl: anchorEl || this,
        id: $ffe2b43354c87b4d$var$POPOVER_ID,
        // The dock sits at the viewport bottom — prefer opening upward. The
        // plugin auto-flips to bottom-start when there isn't enough headroom
        // (e.g. this same popover reused from a top-of-page avatar later).
        placement: 'top-start',
        // Every dismissal lands here — Escape, outside click, an action button,
        // a scroll — so the awareness channel closes with the surface it
        // describes. `_personPopoverEmail` deliberately survives: the card still
        // reads it while the layer tears down, and reopening the same person
        // rewrites the same value.
        //
        // DEFERRED, and it must stay deferred. Written synchronously, this root
        // update lands WHILE the dropdown layer tears its panel down, and the
        // panel's own `Actions` children factory re-runs against a half-detached
        // element: `[smbls] children: factory threw at
        // …DropdownRoot.PanelHost.Panel.content.Actions: el.call is not a
        // function` (live QA, 2026-09-20, first open/close cycle only — a race,
        // so a green suite will not catch it). Same cure and same reason as the
        // search launcher's own onClose (functions/searchApps.js).
        onClose: ()=>queueMicrotask(()=>root.update({
                    selectedPerson: null
                })),
        content: {
            extends: 'PersonPopoverCard'
        }
    });
}
function $ffe2b43354c87b4d$export$56729464abb1c3f7() {
    this.call('closeDropdown', $ffe2b43354c87b4d$var$POPOVER_ID);
}

});

parcelRegister("F8Fzk", function(module, exports) {

$parcel$export(module.exports, "resolvePartyByEmail", () => $07ba8e067d885497$export$27a3f37086af2ae5);
$parcel$export(module.exports, "addPartyFromEmail", () => $07ba8e067d885497$export$7f0110456a27f97);
// Party-by-email resolution for the person popover (architecture/MAIL.md
// §3.7 Directory row — "resolve by email against Party emails and members;
// 'Add to directory' creates a Party"). Members resolve through findPerson
// already for their OWN address; this file covers every address findPerson
// cannot answer — an outside Party contact, or a colleague writing from a
// personal alias findPerson never sees (it only knows canonical addresses).
//
// The cache is root._partyByEmail: absent = never asked, `false` = resolved
// with NO match (the Add-to-directory gate), an object = the match summary.
// resolvePartyByEmail reads GET /core/mail/resolve (MailService#resolveAddress,
// MAIL-INTEGRATIONS-SERVER-1) — ONE server read against Party emails,
// WorkspaceMember addresses AND UserEmailAlias rows in one pass, replacing
// the old parties.list({q}) client-side scan that could never see an alias.
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");

var $iNbdw = parcelRequire("iNbdw");
const $07ba8e067d885497$var$_shellNorm = (email)=>String(email || '').trim().toLowerCase();
const $07ba8e067d885497$var$_shellSummary = (row)=>({
        id: String(row.id || row._id || ''),
        name: row.name || '',
        kind: row.kind || 'person'
    });
// The resolver answers `{ email, member, party, alias }`. A member match
// beats a party match — an active colleague outranks a directory stub at the
// same address — and `alias` alone (a known user with no seat here and no
// directory Party) carries no local identity to show, so it stays a
// non-match, same as a genuine stranger.
const $07ba8e067d885497$var$_summaryFromResolve = (res)=>{
    if (res && res.member) return {
        id: String(res.member.userId || ''),
        name: res.member.name || '',
        kind: 'person'
    };
    if (res && res.party) return $07ba8e067d885497$var$_shellSummary(res.party);
    return false;
};
// One in-flight lookup per address — a popover re-render must not fan out
// duplicate resolve calls (the chatFold single-flight idiom).
const $07ba8e067d885497$var$_inFlight = new Map();
const $07ba8e067d885497$export$27a3f37086af2ae5 = async function(email) {
    const root = this && this.state && this.state.root;
    const key = $07ba8e067d885497$var$_shellNorm(email);
    if (!root || !key) return null;
    const cached = (root._partyByEmail || {})[key];
    if (cached !== undefined) return cached;
    if ($07ba8e067d885497$var$_inFlight.has(key)) return $07ba8e067d885497$var$_inFlight.get(key);
    const write = (0, $iNbdw.sameWorkspaceWriter)(root);
    const run = (async ()=>{
        try {
            const mail = await (0, $1NxyO.getSDK)().getService('mail');
            const res = await mail.resolveAddress(key, {
                workspaceId: (0, $iNbdw.wsIdOf)(root)
            });
            const value = $07ba8e067d885497$var$_summaryFromResolve(res);
            write({
                _partyByEmail: {
                    ...root._partyByEmail || {},
                    [key]: value
                }
            });
            return value;
        } catch (err) {
            // Leave the cache UNTOUCHED on a failed read: absent means "never
            // resolved", so the next open retries instead of freezing a guess.
            console.warn('[partyLookup] resolve failed', err);
            return null;
        } finally{
            $07ba8e067d885497$var$_inFlight.delete(key);
        }
    })();
    $07ba8e067d885497$var$_inFlight.set(key, run);
    return run;
};
const $07ba8e067d885497$export$7f0110456a27f97 = async function(email, displayName) {
    const root = this && this.state && this.state.root;
    const key = $07ba8e067d885497$var$_shellNorm(email);
    if (!root || !key) return null;
    const write = (0, $iNbdw.sameWorkspaceWriter)(root);
    try {
        const parties = await (0, $1NxyO.getSDK)().getService('parties');
        const row = await parties.create({
            kind: 'person',
            name: (displayName || '').trim() || key,
            emails: [
                key
            ]
        });
        const value = row ? $07ba8e067d885497$var$_shellSummary(row) : false;
        if (value) write({
            _partyByEmail: {
                ...root._partyByEmail || {},
                [key]: value
            }
        });
        this.call('openNotification', {
            type: 'success',
            icon: 'people',
            title: this.call('polyglot', 'workspace.person.addedDirectory'),
            message: (displayName || '').trim() || key
        });
        return value || null;
    } catch (err) {
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'workspace.person.addDirectoryFailed'),
            message: err && err.message || ''
        });
        return null;
    }
};

});

parcelRegister("bopKf", function(module, exports) {

$parcel$export(module.exports, "githubColorTokenFromName", () => $84b5e80831c0d950$export$f46bad6610667829);
const $84b5e80831c0d950$var$GITHUB_COLOR_TOKEN = {
    GRAY: 'caption',
    RED: 'red',
    ORANGE: 'orange',
    YELLOW: 'yellow',
    GREEN: 'green',
    BLUE: 'blue',
    PURPLE: 'purple',
    PINK: 'magenta'
};
const $84b5e80831c0d950$export$f46bad6610667829 = (color)=>$84b5e80831c0d950$var$GITHUB_COLOR_TOKEN[color] || 'caption';

});

parcelRegister("e1ZLm", function(module, exports) {

$parcel$export(module.exports, "formatBytes", () => $a3711181ea0d2e33$export$e1a3971de07c83b5);
const $a3711181ea0d2e33$export$e1a3971de07c83b5 = (sz)=>{
    if (!sz) return '';
    if (sz < 1024) return sz + ' B';
    if (sz < 1048576) return Math.round(sz / 1024) + ' KB';
    return Math.round(sz / 1024 / 1024) + ' MB';
};

});

parcelRegister("9x78k", function(module, exports) {

$parcel$export(module.exports, "resolveSky", () => $6f0cbaa190613e7b$export$2ff75615ef9515d2);
$parcel$export(module.exports, "ambientModuleStage", () => $6f0cbaa190613e7b$export$76ad29f835286727);
$parcel$export(module.exports, "ambientSkyFileKey", () => $6f0cbaa190613e7b$export$c24b3dbdf0f82f11);
$parcel$export(module.exports, "ambientSkyUrl", () => $6f0cbaa190613e7b$export$78de44a7bbce3bb);
$parcel$export(module.exports, "ambientMaskImage", () => $6f0cbaa190613e7b$export$74e239d23996b5d8);
$parcel$export(module.exports, "ambientFadeMask", () => $6f0cbaa190613e7b$export$87f769dddd130fbf);
$parcel$export(module.exports, "ambientSkyFlip", () => $6f0cbaa190613e7b$export$f85b6339d71767b5);
$parcel$export(module.exports, "ambientSkyPlacement", () => $6f0cbaa190613e7b$export$942921c13b89155b);
$parcel$export(module.exports, "ambientSkyDrifts", () => $6f0cbaa190613e7b$export$19322e342cb78e82);
$parcel$export(module.exports, "ambientSkyPainted", () => $6f0cbaa190613e7b$export$6ac342c8b6459de7);
$parcel$export(module.exports, "ambientSkyState", () => $6f0cbaa190613e7b$export$1f01aca53d786dac);
$parcel$export(module.exports, "ambientFadeTop", () => $6f0cbaa190613e7b$export$3a3c78f985620159);
$parcel$export(module.exports, "ambientSyncFade", () => $6f0cbaa190613e7b$export$f1803213a5cb4574);
$parcel$export(module.exports, "ambientScheduleFade", () => $6f0cbaa190613e7b$export$890c0157e782f742);
$parcel$export(module.exports, "ambientCancelFade", () => $6f0cbaa190613e7b$export$ca31ab9d291949ce);
$parcel$export(module.exports, "ambientSkySync", () => $6f0cbaa190613e7b$export$d330840066c9ad69);
$parcel$export(module.exports, "ambientSkyScrolled", () => $6f0cbaa190613e7b$export$301299b583dfac7d);
$parcel$export(module.exports, "ambientGroundState", () => $6f0cbaa190613e7b$export$1e6a5f1365532733);
$parcel$export(module.exports, "ambientGroundProgress", () => $6f0cbaa190613e7b$export$5f66d36669fa6fee);
$parcel$export(module.exports, "ambientGroundWatch", () => $6f0cbaa190613e7b$export$f28b5ef6e365bcc2);
$parcel$export(module.exports, "ambientGroundUnwatch", () => $6f0cbaa190613e7b$export$fd9e0d1a093068d4);
$parcel$export(module.exports, "ambientGroundSet", () => $6f0cbaa190613e7b$export$a91cf83e5674cb29);
// Ambient sky — the helpers behind AmbientBackdrop
// (DESIGN-WL-AMBIENT-SKIN-BACKDROP-1, HOME_AMBIENT_SKIN_SPEC §1–§2).
//
// FRANK: every export is invoked through `el.call(...)` and is SELF-CONTAINED.
// Frank stringifies each export on its own, so no export reaches another
// top-level binding bare — it goes through `this.call(...)` (the element) or
// carries its own copy of a literal. Same FA204 rule as
// shared/functions/workspaceSettings.js; __tests__/ambientBackdrop.test.js
// locks it.
//
// THE SKIN is never decided or read here. The shell stamps <html data-skin>
// from functions/workspaceSkin.js `resolveWorkspaceSkin` (the one skin rule,
// also read by the admin Appearance card; NO attribute means solid), and the
// shell's injected sheet shows the layer for the ambient skin only (app.js,
// docs/patches/ambient-mount.app.js.patch) — so the sky and the stamp can
// never disagree. This file adds only the SKY's own off switches (§2).
// → { enabled, sky, reason }. env: { reduceTransparency, stageOverride,
// pending, resolvedSky, userSky }. The sky follows the server's contract (core
// 9193ff2c, workspace.resolvedAppearance): the record's own valid pick, then
// the server's resolved sky, then the local default — the precedence
// functions/workspaceSkin.js uses for the skin. OVER all three, the PERSON's
// own sky (`userSky`, user_preferences.homeLook.sky through the Personalise
// panel — functions/homeLook.js; DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1): an
// explicit choice wins over the workspace's, 'none' included, and `null`
// follows the workspace. The first matching off switch wins: pending > the
// person's none > the workspace's none > reduce-transparency > stage-override
// (the skin gate is the stamp, in CSS). `pending` = the record is in flight: a
// render site never paints a default over a workspace that may be configured
// otherwise. The catalogue is the set of masks in files/ambient; its first
// entry is the spec default (`clouds`).
const $6f0cbaa190613e7b$export$2ff75615ef9515d2 = function resolveSky(settings, env) {
    const catalogue = [
        'clouds',
        'dunes',
        'hills',
        'lake',
        'window',
        'mountains'
    ];
    const e = env && typeof env === 'object' ? env : {};
    const bag = settings && typeof settings === 'object' ? settings.appearance : null;
    const appearance = bag && typeof bag === 'object' ? bag : {};
    const off = (reason)=>({
            enabled: false,
            sky: null,
            reason: reason
        });
    const valid = (v)=>v === 'none' || catalogue.includes(v);
    const user = valid(e.userSky) ? e.userSky : null;
    const picked = valid(appearance.sky) ? appearance.sky : null;
    const resolved = !picked && valid(e.resolvedSky) ? e.resolvedSky : null;
    if (e.pending) return off('pending');
    if (user === 'none') return off('user-none');
    if (!user && (picked || resolved) === 'none') return off('sky-none');
    if (e.reduceTransparency) return off('reduce-transparency');
    if (e.stageOverride) return off('stage-override');
    if (user) return {
        enabled: true,
        sky: user,
        reason: 'user'
    };
    if (picked) return {
        enabled: true,
        sky: picked,
        reason: 'record'
    };
    if (resolved) return {
        enabled: true,
        sky: resolved,
        reason: 'resolved'
    };
    return {
        enabled: true,
        sky: catalogue[0],
        reason: 'default'
    };
};
const $6f0cbaa190613e7b$export$76ad29f835286727 = function ambientModuleStage(workspaceProject) {
    const wp = workspaceProject && typeof workspaceProject === 'object' ? workspaceProject : null;
    if (!wp) return false;
    const cfg = wp.config && typeof wp.config === 'object' ? wp.config : null;
    const chrome = cfg && cfg.chrome !== undefined ? cfg.chrome : wp.chrome;
    const stage = chrome && typeof chrome === 'object' ? chrome.stage : null;
    const filled = (v)=>typeof v === 'string' && v.trim() !== '';
    if (filled(stage)) return true;
    return !!(stage && typeof stage === 'object' && (filled(stage.light) || filled(stage.dark)));
};
const $6f0cbaa190613e7b$export$c24b3dbdf0f82f11 = function ambientSkyFileKey(sky) {
    return typeof sky === 'string' && sky ? 'ambient/' + sky + '.png' : null;
};
const $6f0cbaa190613e7b$export$78de44a7bbce3bb = function ambientSkyUrl(sky) {
    if (typeof sky !== 'string' || !sky) return null;
    const key = 'ambient/' + sky + '.png';
    const files = this && this.context ? this.context.files : null;
    const rec = files && typeof files === 'object' ? files[key] || files['/files/' + key] : null;
    const src = rec && rec.content ? rec.content.src : null;
    return typeof src === 'string' && src ? src : null;
};
const $6f0cbaa190613e7b$export$74e239d23996b5d8 = function ambientMaskImage(url, fadeTop, placement) {
    if (typeof url !== 'string' || !url) return 'none';
    const layer = 'url("' + url.replace(/"/g, '%22') + '")';
    if (placement === 'horizon') {
        const band = 'min(66.667vw, 50vh)';
        return layer + ', linear-gradient(to top, black 0, black calc(' + band + ' * 0.6), transparent ' + band + ')';
    }
    if (typeof fadeTop !== 'number' || !Number.isFinite(fadeTop) || fadeTop <= 0) return layer;
    const edge = Math.round(fadeTop);
    const solid = Math.round(edge * 0.8);
    return layer + ', linear-gradient(to bottom, black 0, black ' + solid + 'px, transparent ' + edge + 'px)';
};
const $6f0cbaa190613e7b$export$87f769dddd130fbf = function ambientFadeMask(fadeTop, placement) {
    if (placement === 'top') {
        const edge = typeof fadeTop === 'number' && Number.isFinite(fadeTop) && fadeTop > 0 ? ', ' + Math.round(fadeTop) + 'px' : '';
        const band = 'min(66.667vw, 60vh' + edge + ')';
        return 'linear-gradient(to top, black 0, black calc(' + band + ' * 0.75), transparent ' + band + ')';
    }
    if (placement === 'horizon') {
        const band = 'min(66.667vw, 50vh)';
        return 'linear-gradient(to top, black 0, black calc(' + band + ' * 0.6), transparent ' + band + ')';
    }
    if (placement !== 'grid') return 'none';
    if (typeof fadeTop !== 'number' || !Number.isFinite(fadeTop) || fadeTop <= 0) return 'none';
    const edge = Math.round(fadeTop);
    const solid = Math.round(edge * 0.8);
    return 'linear-gradient(to bottom, black 0, black ' + solid + 'px, transparent ' + edge + 'px)';
};
const $6f0cbaa190613e7b$export$f85b6339d71767b5 = function ambientSkyFlip(placement) {
    return placement === 'top' ? 'scaleY(-1)' : 'none';
};
const $6f0cbaa190613e7b$export$942921c13b89155b = function ambientSkyPlacement(fadeTo, s) {
    if (fadeTo !== 'top') return typeof fadeTo === 'string' && fadeTo ? fadeTo : 'horizon';
    const el = this;
    const root = s && s.root ? s.root : s || null;
    const look = el && typeof el.call === 'function' ? el.call('homeLookRead', root) : null;
    return look && look.skyLayout === 'bottom' ? 'horizon' : 'top';
};
const $6f0cbaa190613e7b$export$19322e342cb78e82 = function ambientSkyDrifts(sky) {
    return sky === 'clouds';
};
const $6f0cbaa190613e7b$export$6ac342c8b6459de7 = function ambientSkyPainted(style) {
    const read = (camel, kebab)=>{
        if (!style || typeof style !== 'object') return '';
        const direct = style[camel];
        if (typeof direct === 'string' && direct) return direct;
        return typeof style.getPropertyValue === 'function' ? style.getPropertyValue(kebab) || '' : '';
    };
    const isUrl = (v)=>/(^|,\s*)url\(/.test(v);
    if (isUrl(read('maskImage', 'mask-image'))) return {
        painted: true,
        via: 'mask-image'
    };
    if (isUrl(read('webkitMaskImage', '-webkit-mask-image'))) return {
        painted: true,
        via: '-webkit-mask-image'
    };
    return {
        painted: false,
        via: null
    };
};
const $6f0cbaa190613e7b$export$1f01aca53d786dac = function ambientSkyState(s) {
    const el = this;
    const root = s && s.root ? s.root : s || null;
    const ws = el.call('workspaceSettings', s);
    const ready = !!(ws && ws.ready);
    const settings = ready ? ws.settings || {} : null;
    const pending = !!(ws && !ready && ws.pending);
    const record = ws && ws.workspace || root && root.workspace || null;
    const look = record && record.resolvedAppearance ? record.resolvedAppearance : null;
    // The record's ground forms come from the shared rule; an unregistered rule
    // answers undefined, and the sky then stays off (fail closed).
    const recordStage = el.call('hasStageOverride', settings);
    if (recordStage === undefined) return {
        enabled: false,
        sky: null,
        reason: 'stage-unknown',
        url: null
    };
    const stageOverride = !!recordStage || !!el.call('ambientModuleStage', root ? root.workspaceProject : null);
    const ctx = el.context || {};
    const win = ctx.window || (typeof window !== 'undefined' ? window : null);
    const media = win && typeof win.matchMedia === 'function' ? win.matchMedia('(prefers-reduced-transparency: reduce)') : null;
    const reduceTransparency = !!(media && media.matches);
    // The person's own sky (functions/homeLook.js) — an unregistered reader
    // answers undefined, and the workspace's sky stands.
    const mine = el.call('homeLookRead', root);
    const pick = el.call('resolveSky', settings, {
        reduceTransparency: reduceTransparency,
        stageOverride: stageOverride,
        pending: pending,
        resolvedSky: look ? look.sky : null,
        userSky: mine ? mine.sky : null
    });
    if (!pick.enabled) return {
        enabled: false,
        sky: null,
        reason: pick.reason,
        url: null
    };
    const url = el.call('ambientSkyUrl', pick.sky);
    if (!url) return {
        enabled: false,
        sky: pick.sky,
        reason: 'asset-missing',
        url: null
    };
    return {
        enabled: true,
        sky: pick.sky,
        reason: pick.reason,
        url: url
    };
};
const $6f0cbaa190613e7b$export$3a3c78f985620159 = function ambientFadeTop(el) {
    const self = el || this;
    if (!self || !self.node || typeof self.getRoot !== 'function') return null;
    if (self.fadeTo !== 'grid' && self.fadeTo !== 'top') return null;
    const root = self.getRoot();
    const keys = Array.isArray(self.fadeAnchor) ? self.fadeAnchor : [
        self.fadeAnchor
    ];
    const boxOf = (key)=>{
        const anchor = key && root && typeof root.lookdown === 'function' ? root.lookdown(key) : null;
        const node = anchor ? anchor.node : null;
        if (!node || typeof node.getBoundingClientRect !== 'function') return null;
        return node.getBoundingClientRect();
    };
    if (self.fadeTo === 'top') {
        let rect = null;
        for (const key of keys){
            const box = boxOf(key);
            if (box && box.height > 0) {
                rect = box;
                break;
            }
        }
        if (!rect) return null;
        const scroller = typeof root.lookdown === 'function' ? root.lookdown('MainColumn') : null;
        const offset = scroller && scroller.node ? Number(scroller.node.scrollTop) || 0 : 0;
        const edge = rect.top + offset;
        return Number.isFinite(edge) && edge > 0 ? Math.round(edge) : null;
    }
    const rect = boxOf(keys[0]);
    if (!rect) return null;
    const top = rect.top - self.node.getBoundingClientRect().top;
    return Number.isFinite(top) && top > 0 ? Math.round(top) : null;
};
const $6f0cbaa190613e7b$export$f1803213a5cb4574 = function ambientSyncFade(el, s) {
    const self = el || this;
    if (!self || typeof self.call !== 'function') return null;
    if (self.fadeTo !== 'grid' && self.fadeTo !== 'top') return null;
    const top = self.call('ambientFadeTop', self);
    if (self.fadeTo === 'top' && top == null) return s ? s.fadeTop : null;
    if (s && typeof s.update === 'function' && s.fadeTop !== top) s.update({
        fadeTop: top
    });
    return top;
};
const $6f0cbaa190613e7b$export$890c0157e782f742 = function ambientScheduleFade(el, s) {
    const layer = el || this;
    if (!layer || !layer.node || typeof layer.call !== 'function') return null;
    if (layer.fadeTo !== 'grid' && layer.fadeTo !== 'top') return null;
    const pending = layer.__ambientFadeFrame;
    if (pending && pending.node === layer.node) {
        pending.state = s;
        return s ? s.fadeTop : null;
    }
    if (pending) layer.call('ambientCancelFade', layer);
    const ctx = layer.context || {};
    const win = ctx.window || (typeof window !== 'undefined' ? window : null);
    if (!win || typeof win.requestAnimationFrame !== 'function') return layer.call('ambientSyncFade', layer, s);
    const frame = {
        node: layer.node,
        state: s,
        id: null,
        win: win
    };
    layer.__ambientFadeFrame = frame;
    frame.id = win.requestAnimationFrame(()=>{
        if (layer.__ambientFadeFrame !== frame) return;
        try {
            if (layer.node === frame.node && frame.node.isConnected !== false) layer.call('ambientSyncFade', layer, frame.state);
        } finally{
            if (layer.__ambientFadeFrame === frame) layer.__ambientFadeFrame = null;
        }
    });
    return s ? s.fadeTop : null;
};
const $6f0cbaa190613e7b$export$ca31ab9d291949ce = function ambientCancelFade(el) {
    const layer = el || this;
    const frame = layer && layer.__ambientFadeFrame;
    if (!frame) return;
    layer.__ambientFadeFrame = null;
    if (typeof frame.win.cancelAnimationFrame === 'function') frame.win.cancelAnimationFrame(frame.id);
};
const $6f0cbaa190613e7b$export$d330840066c9ad69 = function ambientSkySync(el) {
    const self = el || this;
    if (!self || typeof self.getRoot !== 'function') return null;
    const root = self.getRoot();
    const sky = root && typeof root.lookdown === 'function' ? root.lookdown('AmbientBackdrop') : null;
    if (!sky || typeof sky.call !== 'function') return null;
    return sky.call('ambientScheduleFade', sky, sky.state);
};
const $6f0cbaa190613e7b$export$301299b583dfac7d = function ambientSkyScrolled(el) {
    const self = el || this;
    if (!self || !self.node || typeof self.getRoot !== 'function') return null;
    const ctx = self.context || {};
    const win = ctx.window || (typeof window !== 'undefined' ? window : null);
    const css = win ? win.CSS : null;
    if (css && typeof css.supports === 'function' && css.supports('animation-timeline: scroll()')) return null;
    const root = self.getRoot();
    const sky = root && typeof root.lookdown === 'function' ? root.lookdown('AmbientBackdrop') : null;
    const s = sky ? sky.state : null;
    if (!s || typeof s.update !== 'function') return null;
    const away = (Number(self.node.scrollTop) || 0) > 0;
    if (!!s.skyAway !== away) s.update({
        skyAway: away
    });
    return away;
};
const $6f0cbaa190613e7b$export$1e6a5f1365532733 = function ambientGroundState(s, groundSky) {
    const el = this;
    const sky = el.call('ambientSkyState', s);
    if (!sky || !sky.enabled && sky.reason !== 'asset-missing') return {
        enabled: false,
        sky: null,
        reason: sky ? sky.reason : 'sky-unknown',
        url: null
    };
    // The person's 'bottom' layout is the sky as it was before: no ground.
    const root = s && s.root ? s.root : s || null;
    const look = el.call('homeLookRead', root);
    if (look && look.skyLayout === 'bottom') return {
        enabled: false,
        sky: null,
        reason: 'layout-bottom',
        url: null
    };
    const art = typeof groundSky === 'string' && groundSky ? groundSky : 'mountains';
    const url = el.call('ambientSkyUrl', art);
    if (!url) return {
        enabled: false,
        sky: art,
        reason: 'asset-missing',
        url: null
    };
    return {
        enabled: true,
        sky: art,
        reason: sky.reason,
        url: url
    };
};
const $6f0cbaa190613e7b$export$5f66d36669fa6fee = function ambientGroundProgress(m) {
    const v = m && typeof m === 'object' ? m : {};
    const num = (x)=>typeof x === 'number' && Number.isFinite(x) ? x : 0;
    const range = Math.max(0, num(v.scrollHeight) - num(v.clientHeight));
    if (range < 1) return 0;
    const top = Math.min(range, Math.max(0, num(v.scrollTop)));
    const stretch = Math.max(0, num(v.stretch));
    const start = Math.max(0, range - stretch);
    // within one px of the end counts as the end (fractional scroll offsets)
    if (v.reduced) return top >= range - 1 ? 1 : 0;
    if (range - start < 1) return top >= range - 1 ? 1 : 0;
    return Math.min(1, Math.max(0, (top - start) / (range - start)));
};
const $6f0cbaa190613e7b$export$f28b5ef6e365bcc2 = function ambientGroundWatch(el) {
    const self = el || this;
    if (!self || !self.node || typeof self.call !== 'function') return null;
    const ctx = self.context || {};
    const win = ctx.window || (typeof window !== 'undefined' ? window : null);
    if (!win || typeof win.IntersectionObserver !== 'function') return null;
    const css = win.CSS;
    if (css && typeof css.supports === 'function' && css.supports('animation-timeline: scroll()')) return null;
    const scroller = self.parent && self.parent.node ? self.parent.node : null;
    if (!scroller) return null;
    if (self.scope && self.scope.groundObserver) self.scope.groundObserver.disconnect();
    const media = typeof win.matchMedia === 'function' ? win.matchMedia('(prefers-reduced-motion: reduce)') : null;
    const sync = ()=>{
        const doc = win.document;
        const root = doc ? doc.documentElement : null;
        const reduced = !!(media && media.matches) || !!(root && root.getAttribute('data-motion') === 'reduced');
        const p = self.call('ambientGroundProgress', {
            scrollTop: scroller.scrollTop,
            scrollHeight: scroller.scrollHeight,
            clientHeight: scroller.clientHeight,
            stretch: scroller.clientHeight * 0.4,
            reduced: reduced
        });
        // reduced motion: shown only at the very end; else from the stretch start
        self.call('ambientGroundSet', self, reduced ? p >= 1 : p > 0);
    };
    const io = new win.IntersectionObserver(sync, {
        root: scroller,
        rootMargin: '0px 0px 40% 0px',
        threshold: [
            0,
            1
        ]
    });
    io.observe(self.node);
    if (self.scope) self.scope.groundObserver = io;
    return io;
};
const $6f0cbaa190613e7b$export$fd9e0d1a093068d4 = function ambientGroundUnwatch(el) {
    const self = el || this;
    const io = self && self.scope ? self.scope.groundObserver : null;
    if (io) io.disconnect();
    if (self && self.scope) self.scope.groundObserver = null;
    if (self && typeof self.call === 'function') self.call('ambientGroundSet', self, false);
    return null;
};
const $6f0cbaa190613e7b$export$a91cf83e5674cb29 = function ambientGroundSet(el, on) {
    const self = el || this;
    if (!self || typeof self.getRoot !== 'function') return null;
    const root = self.getRoot();
    const ground = root && typeof root.lookdown === 'function' ? root.lookdown('AmbientGround') : null;
    const s = ground ? ground.state : null;
    if (!s || typeof s.update !== 'function') return null;
    const next = !!on;
    if (s.groundIn !== next) s.update({
        groundIn: next
    });
    return next;
};

});

parcelRegister("k99Sk", function(module, exports) {

$parcel$export(module.exports, "groupLabel", () => $eaac4eed34acb9da$export$808794a1efddf200);
$parcel$export(module.exports, "groupKeyOf", () => $eaac4eed34acb9da$export$93bce263b840bcab);
$parcel$export(module.exports, "peopleRosterScope", () => $eaac4eed34acb9da$export$a17dc8cff242d62a);
$parcel$export(module.exports, "peopleRosterIsReduced", () => $eaac4eed34acb9da$export$e8a56cb7568944b3);
$parcel$export(module.exports, "peopleFilterActive", () => $eaac4eed34acb9da$export$f647d0ceaf6eadba);
$parcel$export(module.exports, "peopleGroupCategories", () => $eaac4eed34acb9da$export$473366439e5e7e9e);
$parcel$export(module.exports, "peopleRoleCategories", () => $eaac4eed34acb9da$export$bf495272b9b17544);
$parcel$export(module.exports, "memberStatusOf", () => $eaac4eed34acb9da$export$12e4ccf89e0be933);
$parcel$export(module.exports, "isActiveTeamCategory", () => $eaac4eed34acb9da$export$2e7daf6e77ee120f);
$parcel$export(module.exports, "peopleMemberStatusSummary", () => $eaac4eed34acb9da$export$e1b5b013f89095a8);
$parcel$export(module.exports, "peopleTeamCategories", () => $eaac4eed34acb9da$export$2a0f7f5c3adbe817);
$parcel$export(module.exports, "groupPeopleByCategory", () => $eaac4eed34acb9da$export$8feb88c6d949f22e);
$parcel$export(module.exports, "filterPeople", () => $eaac4eed34acb9da$export$8d0a56f9265c826);
$parcel$export(module.exports, "peopleTeamsDirectory", () => $eaac4eed34acb9da$export$96b0bc8046e93f07);
$parcel$export(module.exports, "peopleHasVisible", () => $eaac4eed34acb9da$export$ef2861ace08d6723);
$parcel$export(module.exports, "peopleRosterView", () => $eaac4eed34acb9da$export$5fe4fe74e1ce801f);
$parcel$export(module.exports, "groupFilteredPeople", () => $eaac4eed34acb9da$export$1878c8b52d8511e3);
// People grouping and filtering helpers.
// All are el.call()-compatible (regular functions, `this` binds to element).
parcelRequire("aGIjc");

var $eb4QA = parcelRequire("eb4QA");

var $kg2OA = parcelRequire("kg2OA");
// 'Other' is the teamless bucket key — labelled 'No team' so the
// default grouped view reads as what it is (people without a
// TeamMember row in the active org) instead of a mystery category.
const $eaac4eed34acb9da$var$GROUP_LABEL = {
    Other: 'workspace.people.group.noTeam'
};
function $eaac4eed34acb9da$export$808794a1efddf200(raw) {
    // An empty group is the teamless bucket too — its label is the bundle key,
    // never the bare id.
    const key = raw || 'Other';
    return $eaac4eed34acb9da$var$GROUP_LABEL[key] || key.replace(/^./, (c)=>c.toUpperCase());
}
// REAL teams only — system permission groups (Admin / Manager /
// Members / HR / … seeded per org by the server's SystemTeamsSeeder
// as permission carriers) are NOT teams in the people-directory
// sense; everyone is in `Members`, so treating them as teams turned
// the grouping into a permissions readout.
// Accepts a person-like `{ userId, email }` (preferred — userId resolves for
// non-mgmt viewers whose rows carry no email) or a bare email string (legacy).
// Delegates the id-first/email-fallback join to teams.js personTeams.
const $eaac4eed34acb9da$var$_realTeams = (personOrEmail, root)=>(0, $kg2OA.personTeams)(personOrEmail, root).filter((t)=>!t.isSystem);
function $eaac4eed34acb9da$export$93bce263b840bcab(person, root) {
    const teams = $eaac4eed34acb9da$var$_realTeams(person, root);
    return teams[0]?.name || 'Other';
}
const $eaac4eed34acb9da$export$a17dc8cff242d62a = (root)=>{
    const orgId = root?.jwtClaims?.workspace_org_id;
    if (!orgId) return 'all';
    if ((0, $eb4QA.LEGACY_ORG_IDS).has(orgId)) return 'all';
    const set = root?.orgMembersByOrgId?.[orgId];
    if (set && Object.keys(set).length > 0) return 'org';
    return String(root?.currentUserEmail || '').toLowerCase() ? 'selfOnly' : 'none';
};
const $eaac4eed34acb9da$var$_activeOrgPeople = (root)=>{
    const people = root?.people || [];
    const scope = $eaac4eed34acb9da$export$a17dc8cff242d62a(root);
    if (scope === 'all') return people;
    if (scope === 'none') return [];
    if (scope === 'selfOnly') {
        const myEmail = String(root?.currentUserEmail || '').toLowerCase();
        return people.filter((p)=>String(p?.email || '').toLowerCase() === myEmail);
    }
    const set = root.orgMembersByOrgId[root.jwtClaims.workspace_org_id];
    return people.filter((p)=>!!set[String(p?.email || '').toLowerCase()]);
};
function $eaac4eed34acb9da$export$e8a56cb7568944b3() {
    const root = this && this.state && this.state.root;
    return $eaac4eed34acb9da$export$a17dc8cff242d62a(root) === 'selfOnly';
}
function $eaac4eed34acb9da$export$f647d0ceaf6eadba() {
    const root = this && this.state && this.state.root;
    return !!((root?.peopleQuery || '').trim() || root?.selectedGroup || root?.selectedRole || root?.selectedTeamCategory);
}
function $eaac4eed34acb9da$export$473366439e5e7e9e() {
    const root = this && this.state && this.state.root;
    const people = $eaac4eed34acb9da$var$_activeOrgPeople(root);
    const counts = new Map();
    for (const p of people){
        const k = $eaac4eed34acb9da$export$93bce263b840bcab(p, root);
        counts.set(k, (counts.get(k) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort((a, b)=>a[0].localeCompare(b[0])).map(([key, count])=>({
            key: key,
            label: $eaac4eed34acb9da$export$808794a1efddf200(key),
            count: count,
            name: key,
            kind: 'group'
        }));
}
// Returns all roles with user counts derived from root.roles.byUser.
// CU-10 §90: roles no longer on person object; source is root.roles.byUser.
// el.call('peopleRoleCategories')
// CU-10 §90: public.roles view dropped (migration 0087). Role order/labels
// fall back to the canonical hardcoded list; counts derived from byUser.
const $eaac4eed34acb9da$var$ROLE_FALLBACK_ORDER = [
    'superadmin',
    'admin',
    'manager',
    'member',
    'advisor',
    'investor'
];
const $eaac4eed34acb9da$var$ROLE_FALLBACK_LABELS = {
    superadmin: 'Superadmin',
    admin: 'Admin',
    manager: 'Manager',
    member: 'Member',
    advisor: 'Advisor',
    investor: 'Investor'
};
function $eaac4eed34acb9da$export$bf495272b9b17544() {
    const root = this && this.state && this.state.root;
    const people = $eaac4eed34acb9da$var$_activeOrgPeople(root);
    const byUser = root?.roles?.byUser || {};
    const counts = new Map();
    for (const p of people){
        // Legacy fallback for pre-§90 data still in p.roles
        const legacyRoles = Array.isArray(p.roles) && p.roles.length > 0 ? p.roles : null;
        if (legacyRoles) for (const r of legacyRoles)counts.set(r, (counts.get(r) || 0) + 1);
        else {
            const role = byUser[p.userId] || 'member';
            counts.set(role, (counts.get(role) || 0) + 1);
        }
    }
    return $eaac4eed34acb9da$var$ROLE_FALLBACK_ORDER.filter((r)=>counts.has(r)).map((r)=>({
            key: r,
            label: $eaac4eed34acb9da$var$ROLE_FALLBACK_LABELS[r] || r.replace(/^./, (c)=>c.toUpperCase()),
            count: counts.get(r) || 0,
            name: r,
            kind: 'role'
        }));
}
function $eaac4eed34acb9da$export$12e4ccf89e0be933(email, root) {
    // A per-person status of 'left' (departed) or 'inactive' (read-only access)
    // wins over the team-derived status — the member is inactive regardless of
    // which teams they're in.
    const person = (root && root.people || []).find((p)=>(p.email || '').toLowerCase() === (email || '').toLowerCase());
    if (person && (person.status === 'left' || person.status === 'inactive')) return 'inactive';
    // Prefer the resolved person (carries userId) so non-mgmt viewers resolve;
    // fall back to the bare email when no roster row was found.
    const teams = (0, $kg2OA.personTeams)(person || email, root);
    return teams.some((t)=>$eaac4eed34acb9da$export$2e7daf6e77ee120f(t.category)) ? 'active' : 'inactive';
}
function $eaac4eed34acb9da$export$e1b5b013f89095a8() {
    const root = this && this.state && this.state.root;
    const people = $eaac4eed34acb9da$var$_activeOrgPeople(root);
    let active = 0;
    for (const p of people)if ($eaac4eed34acb9da$export$12e4ccf89e0be933(p?.email, root) === 'active') active += 1;
    return [
        {
            key: 'all',
            label: 'workspace.people.filter.everyone',
            count: people.length,
            name: null,
            kind: 'category'
        },
        {
            key: 'active',
            label: 'workspace.people.filter.active',
            count: active,
            name: 'active',
            kind: 'category'
        },
        {
            key: 'inactive',
            label: 'workspace.people.filter.inactive',
            count: people.length - active,
            name: 'inactive',
            kind: 'category'
        }
    ];
}
function $eaac4eed34acb9da$export$2a0f7f5c3adbe817() {
    const root = this && this.state && this.state.root;
    const teamsByEmail = root?.teamsByEmail || {};
    // id-first — non-mgmt roster rows carry no email (server projection), so
    // the email map never matches for them (tickets/fable.md P0 regression).
    const teamsByUserId = root?.teamsByUserId || {};
    const counts = Object.fromEntries((0, $eb4QA.CATEGORIES).map((c)=>[
            c,
            0
        ]));
    counts.none = 0;
    for (const p of $eaac4eed34acb9da$var$_activeOrgPeople(root)){
        const byId = p?.userId != null ? teamsByUserId[String(p.userId)] : null;
        const email = String(p?.email || '').toLowerCase();
        const cat = (0, $eb4QA.effectiveCategory)(Array.isArray(byId) && byId.length && byId || teamsByEmail[email]);
        counts[cat] = (counts[cat] || 0) + 1;
    }
    // Bundle KEYS — every consumer of these rows resolves through polyglot at
    // its render site (PeopleFilterLink / PeopleGroupBlock), which also lets a
    // real TEAM name pass through untouched.
    const LABELS = {
        manager: 'workspace.people.category.manager',
        active: 'workspace.people.filter.active',
        passive: 'workspace.people.category.passive',
        external: 'workspace.people.category.external',
        archived: 'workspace.people.category.archived',
        none: 'workspace.people.category.unassigned'
    };
    const out = [];
    for (const cat of (0, $eb4QA.CATEGORIES))if (counts[cat] > 0) out.push({
        key: cat,
        label: LABELS[cat],
        count: counts[cat],
        name: cat,
        kind: 'category'
    });
    if (counts.none > 0) out.push({
        key: 'none',
        label: 'workspace.people.category.unassigned',
        count: counts.none,
        name: 'none',
        kind: 'category'
    });
    return out;
}
function $eaac4eed34acb9da$export$8feb88c6d949f22e() {
    const root = this && this.state && this.state.root;
    const filtered = $eaac4eed34acb9da$export$8d0a56f9265c826.call(this);
    const teamsByEmail = root?.teamsByEmail || {};
    // id-first, email fallback — same P0-regression join as peopleTeamCategories.
    const teamsByUserId = root?.teamsByUserId || {};
    const buckets = new Map();
    for (const p of filtered){
        const byId = p?.userId != null ? teamsByUserId[String(p.userId)] : null;
        const email = String(p?.email || '').toLowerCase();
        const cat = (0, $eb4QA.effectiveCategory)(Array.isArray(byId) && byId.length && byId || teamsByEmail[email]);
        if (!buckets.has(cat)) buckets.set(cat, []);
        buckets.get(cat).push(p);
    }
    // Bundle KEYS — every consumer of these rows resolves through polyglot at
    // its render site (PeopleFilterLink / PeopleGroupBlock), which also lets a
    // real TEAM name pass through untouched.
    const LABELS = {
        manager: 'workspace.people.category.manager',
        active: 'workspace.people.filter.active',
        passive: 'workspace.people.category.passive',
        external: 'workspace.people.category.external',
        archived: 'workspace.people.category.archived',
        none: 'workspace.people.category.unassigned'
    };
    // Order: manager > active > passive > external > archived > none
    const order = [
        ...(0, $eb4QA.CATEGORIES),
        'none'
    ];
    return order.filter((cat)=>cat !== 'archived' && buckets.has(cat) && buckets.get(cat).length > 0).map((cat)=>({
            name: LABELS[cat] || cat,
            people: buckets.get(cat)
        }));
}
function $eaac4eed34acb9da$export$96b0bc8046e93f07() {
    const root = this && this.state && this.state.root;
    const orgId = root?.jwtClaims?.workspace_org_id;
    // ALL of the active org's teams (2026-06-06 per Nika "it does not
    // show all teams") — system teams (Members / Admin / HR / …)
    // included, since they carry real memberships worth browsing
    // (Members holds the whole roster). The DEFAULT body grouping still
    // uses real teams only (see groupFilteredPeople) so the system
    // groups don't swallow the directory; clicking a system team in the
    // rail filters to its members explicitly.
    const teams = (root?.teams || []).filter((t)=>!orgId || String(t.orgId) === String(orgId));
    // Count only members that appear in the active-org PEOPLE roster
    // (_activeOrgPeople — the federated, profiled members /people renders).
    // Invited-but-never-onboarded members (rows in teamsByEmail with no
    // people-roster entry — dropped by /core/users/people's supabaseUserId
    // gate) are intentionally excluded here so the rail's counts match the
    // body list + Members summary (no more "Members 85" beside "Active 53").
    // The FULL membership, including those invitees, lives on /admin/teams
    // (2026-06-09 per Nika).
    const rosterEmails = new Set($eaac4eed34acb9da$var$_activeOrgPeople(root).map((p)=>String(p?.email || '').toLowerCase()));
    const membersByTeam = {};
    for (const [email, list] of Object.entries(root?.teamsByEmail || {})){
        if (!rosterEmails.has(email)) continue;
        for (const t of list || []){
            if (!membersByTeam[t.id]) membersByTeam[t.id] = [];
            membersByTeam[t.id].push(email);
        }
    }
    return teams.map((t)=>({
            id: t.id,
            name: t.name,
            slug: t.slug,
            orgName: t.orgName,
            // Team category (manager/active/passive/external/archived) —
            // the rail splits on it: Active vs Inactive sections.
            category: t.category || 'active',
            emails: membersByTeam[t.id] || [],
            count: (membersByTeam[t.id] || []).length,
            kind: 'team'
        })).sort((a, b)=>b.count - a.count || a.name.localeCompare(b.name));
}
const $eaac4eed34acb9da$export$2e7daf6e77ee120f = (category)=>category === 'active' || category === 'manager';
// The per-person filter predicate, built ONCE per call and shared by
// `filterPeople` and `peopleHasVisible`, so "who passes the filter" has one
// definition. Two copies would drift the day a fifth filter lands — the same
// reason `peopleFilterActive` exists.
const $eaac4eed34acb9da$var$_personMatcher = (root)=>{
    const g = root?.selectedGroup;
    const r = root?.selectedRole;
    const c = root?.selectedTeamCategory // 'active' | 'inactive' | null (binary member-status lens)
    ;
    const q = (root?.peopleQuery || '').trim().toLowerCase();
    // CU-10 §90: role per person from root.roles.byUser (not p.roles)
    const byUser = root?.roles?.byUser || {};
    return (p)=>{
        // Team filter matches ANY of the person's org-scoped teams —
        // system ones included so the rail's Members / HR / … entries
        // filter correctly. 'Other' still means "no REAL team" to match
        // the default grouping's bucket.
        if (g) {
            const all = (0, $kg2OA.personTeams)(p, root).map((t)=>t.name);
            const real = $eaac4eed34acb9da$var$_realTeams(p, root);
            const mine = all.length || real.length ? all : [];
            if (!real.length) mine.push('Other');
            if (!mine.includes(g)) return false;
        }
        if (r) {
            // Legacy fallback: person still has .roles array
            const legacyRoles = Array.isArray(p.roles) && p.roles.length > 0 ? p.roles : null;
            if (legacyRoles) {
                if (legacyRoles.length === 0 && r !== 'member') return false;
                if (legacyRoles.length > 0 && !legacyRoles.includes(r)) return false;
            } else {
                const assignedRole = byUser[p.userId] || 'member';
                if (assignedRole !== r) return false;
            }
        }
        if (c) {
            // Binary member-status lens (active | inactive) — derived from
            // team membership; see memberStatusOf.
            if ($eaac4eed34acb9da$export$12e4ccf89e0be933(p?.email, root) !== c) return false;
        }
        if (q) {
            const name = (p?.name || '').toLowerCase();
            const email = (p?.email || '').toLowerCase();
            const position = (p?.position || '').toLowerCase();
            if (!name.includes(q) && !email.includes(q) && !position.includes(q)) return false;
        }
        return true;
    };
};
function $eaac4eed34acb9da$export$8d0a56f9265c826() {
    const root = this && this.state && this.state.root;
    return $eaac4eed34acb9da$var$_activeOrgPeople(root).filter($eaac4eed34acb9da$var$_personMatcher(root));
}
function $eaac4eed34acb9da$export$ef2861ace08d6723() {
    const root = this && this.state && this.state.root;
    return $eaac4eed34acb9da$var$_activeOrgPeople(root).some($eaac4eed34acb9da$var$_personMatcher(root));
}
function $eaac4eed34acb9da$export$5fe4fe74e1ce801f() {
    const root = this && this.state && this.state.root;
    const status = this.call('peopleStatus', root);
    if (status !== 'loaded') return status;
    if ($eaac4eed34acb9da$export$ef2861ace08d6723.call(this)) return 'list';
    return $eaac4eed34acb9da$export$f647d0ceaf6eadba.call(this) ? 'emptyFiltered' : 'emptyFresh';
}
function $eaac4eed34acb9da$export$1878c8b52d8511e3() {
    const root = this && this.state && this.state.root;
    const filtered = $eaac4eed34acb9da$export$8d0a56f9265c826.call(this);
    // Role filter active — single group labelled with the role
    if (root?.selectedRole) {
        const available = root?.roles?.available || [];
        const meta = available.find((r)=>r.name === root.selectedRole);
        return [
            {
                name: meta?.label || root.selectedRole,
                people: filtered
            }
        ];
    }
    // Category filter active — single group labelled with the category
    if (root?.selectedTeamCategory) {
        // The header carries the same bundle KEY the rail row carried, so the
        // filtered view and the filter that produced it read identically.
        const CATEGORY_KEY = {
            manager: 'workspace.people.category.manager',
            active: 'workspace.people.filter.active',
            passive: 'workspace.people.category.passive',
            external: 'workspace.people.category.external',
            archived: 'workspace.people.category.archived',
            inactive: 'workspace.people.filter.inactive',
            none: 'workspace.people.category.unassigned'
        };
        const label = CATEGORY_KEY[root.selectedTeamCategory] || root.selectedTeamCategory.charAt(0).toUpperCase() + root.selectedTeamCategory.slice(1);
        return [
            {
                name: label,
                people: filtered
            }
        ];
    }
    // Team filter active — single group labelled with the team. Without
    // this, filtering by a SYSTEM team (Members / HR / …) fell through
    // to the real-team bucketing below and the header read "No team"
    // for people whose only membership is the selected system team.
    //
    // Scoped to the active-org PEOPLE roster only. Invited-but-never-
    // onboarded members (TeamMember rows with no people-roster entry) are
    // intentionally NOT surfaced on /people — the full team membership,
    // including those invitees (with a Reinvite affordance), lives on
    // /admin/teams (2026-06-09 per Nika). The previous ghost-card
    // injection here is what made /people inconsistent with its own counts.
    if (root?.selectedGroup) {
        // Stamp `_groupTeamName` so each PersonCard's team badge reflects the
        // section it's listed under (the selected group), not the member's
        // arbitrary primary team — see the default branch below for why.
        const label = $eaac4eed34acb9da$export$808794a1efddf200(root.selectedGroup);
        const tagged = filtered.map((p)=>({
                ...p,
                _groupTeamName: label
            }));
        return [
            {
                name: label,
                people: tagged
            }
        ];
    }
    // Default (including explicit team filter) — group by REAL team
    // (system permission groups excluded). A person appears under EVERY
    // org-scoped team they belong to (true group-by-teams semantics;
    // the previous primary-team-only bucketing hid multi-team
    // membership), and under 'No team' (key 'Other') when they have
    // none in the active org.
    //
    // Each bucket gets a SHALLOW COPY of the person stamped with
    // `_groupTeamName` = the team name of THIS section. A multi-team
    // member appears in several buckets; without the per-section stamp,
    // every one of their cards read the same primary-team badge
    // (`personTeams(...)[0].name`) regardless of section — so under
    // "Class B" a member also in "Class C" was mislabelled "Class C".
    // Pushing the shared reference and stamping in place would lose to
    // last-write-wins; the copy keeps each section's stamp distinct.
    const buckets = new Map();
    for (const p of filtered){
        const teams = $eaac4eed34acb9da$var$_realTeams(p, root);
        const keys = teams.length ? teams.map((t)=>t.name) : [
            'Other'
        ];
        for (const k of keys){
            if (!buckets.has(k)) buckets.set(k, []);
            buckets.get(k).push({
                ...p,
                _groupTeamName: k === 'Other' ? null : k
            });
        }
    }
    // Sort: named teams alphabetically first, then "No team" last
    return [
        ...buckets.entries()
    ].sort((a, b)=>{
        if (a[0] === 'Other') return 1;
        if (b[0] === 'Other') return -1;
        return a[0].localeCompare(b[0]);
    }).map(([key, ppl])=>({
            name: $eaac4eed34acb9da$export$808794a1efddf200(key),
            people: ppl
        }));
}

});

parcelRegister("3aYah", function(module, exports) {

$parcel$export(module.exports, "orgChartDirectory", () => $2500f9bb500be4a9$export$2e199d970188c594);
$parcel$export(module.exports, "orgChartManagerOf", () => $2500f9bb500be4a9$export$aa9a89ee7e59c6b9);
$parcel$export(module.exports, "orgChartChildrenOf", () => $2500f9bb500be4a9$export$3332443849b90346);
$parcel$export(module.exports, "orgChartOpen", () => $2500f9bb500be4a9$export$4d9a4bd3ae42786c);
$parcel$export(module.exports, "orgChartSetWorking", () => $2500f9bb500be4a9$export$7c9bde06e8dddf5e);
$parcel$export(module.exports, "orgChartDiff", () => $2500f9bb500be4a9$export$68e0ccc0a42ede97);
$parcel$export(module.exports, "orgChartIsDirty", () => $2500f9bb500be4a9$export$289a1c1a2026208d);
$parcel$export(module.exports, "orgChartSave", () => $2500f9bb500be4a9$export$3d9e663f4ff38849);
// Org chart — bulk manager editor + minimal chart view.
// tickets/sonnet.md "org chart: UI (admin editor screen + chart view)".
// Server half already shipped (server 424165e8, sdk 5f1396a):
//   sdk.getService('parties').list({kind:'person'})            — roster
//   sdk.getService('parties').listAllRelationships({kind:'reports_to'}) — edges
//   sdk.getService('parties').setManagers([{partyId,managerId}])       — bulk write (admin)
// This file is the data/state layer; components/OrgChartModal.js is the view.
//
// Party is a separate workspace-scoped identity from root.people (a Party
// row is auto-created 1:1 per (workspace, User) on every member-add —
// server ensurePartyForMember.js). The relationship edge direction is
// `a reports_to b` — a's manager is b.
//
// Joined to root.people on EMAIL, not on party.user === person.userId —
// live-verified 2026-08-16: root.people[].userId is the SUPABASE auth
// uuid (e.g. "43661a1c-b321-..."), while Party.user is the Mongo
// User._id (e.g. "6868484c0cf470c5890933cc") for the SAME person — the
// exact id-space gap ensurePartyForMember.js's own header comment
// documents ("userId MUST be the Mongo User._id, never the Supabase auth
// uuid"). The two ids can never string-match; email is the one identity
// signal both sides actually carry the same value for (confirmed against
// three real linked Party docs in dev).
//
// workspaceId resolution goes through this.call('activeWorkspaceId', root)
// rather than a sibling import of scopedClient.js — FA001, no imports
// between project files even within functions/.
// root.people (name/avatar/email) joined to the loaded Party roster
// (root._orgChartParties) on email, case-insensitive (see the id-space
// note above). A roster entry with no matching Party means the load
// hasn't settled yet, or this person has no Party row at all (a real gap
// this pass found: ensurePartyForMember isn't backfilled for most
// existing workspaces) — skipped rather than rendered broken.
// el.call('orgChartDirectory')
function $2500f9bb500be4a9$export$2e199d970188c594() {
    const root = this && this.state && this.state.root;
    const parties = root?._orgChartParties || [];
    const people = root?.people || [];
    const byEmail = new Map(parties.filter((p)=>p.primaryEmail).map((p)=>[
            String(p.primaryEmail).toLowerCase(),
            p
        ]));
    const rows = [];
    for (const person of people){
        const email = String(person.email || '').toLowerCase();
        const party = email ? byEmail.get(email) : null;
        if (!party) continue;
        rows.push({
            partyId: party.id,
            // No third fallback: a person with no email never reaches this line (the
            // join above skips them), so a nameless member reads as their email.
            name: person.name || person.email,
            avatar: person.avatar || null,
            email: person.email || null
        });
    }
    return rows.sort((a, b)=>a.name.localeCompare(b.name));
}
function $2500f9bb500be4a9$export$aa9a89ee7e59c6b9() {
    const root = this && this.state && this.state.root;
    const edges = root?._orgChartEdges || [];
    const map = new Map();
    for (const e of edges)if (e.kind === 'reports_to' && e.a) map.set(String(e.a), e.b != null ? String(e.b) : null);
    return map;
}
function $2500f9bb500be4a9$export$3332443849b90346() {
    const directory = $2500f9bb500be4a9$export$2e199d970188c594.call(this);
    const knownIds = new Set(directory.map((p)=>p.partyId));
    const managerOf = $2500f9bb500be4a9$export$aa9a89ee7e59c6b9.call(this);
    const map = new Map();
    for (const p of directory){
        const mgr = managerOf.get(p.partyId);
        const key = mgr && knownIds.has(mgr) ? mgr : 'root';
        if (!map.has(key)) map.set(key, []);
        map.get(key).push(p.partyId);
    }
    return map;
}
async function $2500f9bb500be4a9$export$4d9a4bd3ae42786c(s) {
    const el = this;
    const root = s.root;
    root.update({
        _orgChartOpen: true,
        _orgChartLoading: true,
        _orgChartLoadError: null
    });
    const workspaceId = this.call('activeWorkspaceId', root);
    try {
        // getService() is itself async (SDK init-gated — resolves to the real
        // service only once boot settles, a bare Promise facade otherwise), so
        // it must be awaited BEFORE calling a method on the result — chaining
        // .list(...) straight off the unresolved call throws "not a function".
        const parties = await el.sdk.getService('parties');
        const [rows, edges] = await Promise.all([
            parties.list({
                kind: 'person'
            }, {
                workspaceId: workspaceId
            }),
            parties.listAllRelationships({
                kind: 'reports_to'
            }, {
                workspaceId: workspaceId
            })
        ]);
        const working = {};
        for (const e of edges || [])if (e.kind === 'reports_to' && e.a) working[String(e.a)] = e.b != null ? String(e.b) : null;
        root.update({
            _orgChartParties: rows || [],
            _orgChartEdges: edges || [],
            _orgChartWorking: working,
            _orgChartLoading: false,
            _orgChartSaveError: null
        });
    } catch (err) {
        root.update({
            _orgChartLoading: false,
            _orgChartLoadError: err && err.message || el.call('polyglot', 'workspace.orgChart.loadFailed')
        });
    }
}
function $2500f9bb500be4a9$export$7c9bde06e8dddf5e(s, partyId, managerId) {
    const root = s.root;
    const next = {
        ...root._orgChartWorking || {}
    };
    if (managerId) next[partyId] = managerId;
    else delete next[partyId];
    root.update({
        _orgChartWorking: next
    });
}
function $2500f9bb500be4a9$export$68e0ccc0a42ede97() {
    const root = this && this.state && this.state.root;
    const working = root?._orgChartWorking || {};
    const original = $2500f9bb500be4a9$export$aa9a89ee7e59c6b9.call(this);
    const directory = $2500f9bb500be4a9$export$2e199d970188c594.call(this);
    const out = [];
    for (const p of directory){
        const before = original.get(p.partyId) || null;
        const after = working[p.partyId] || null;
        if (before !== after) out.push({
            partyId: p.partyId,
            managerId: after
        });
    }
    return out;
}
function $2500f9bb500be4a9$export$289a1c1a2026208d() {
    return $2500f9bb500be4a9$export$68e0ccc0a42ede97.call(this).length > 0;
}
// Best-effort: swap a bare 24-hex Mongo id embedded in a server validation
// message for the matching person's name, so "party not found in this
// workspace: 68a1..." reads as a name. Falls back to the raw message when
// nothing matches — never throws on a shape it doesn't expect.
const $2500f9bb500be4a9$var$_humanizeIds = (message, directory)=>{
    if (!message) return message;
    const byId = new Map(directory.map((p)=>[
            p.partyId,
            p.name
        ]));
    return message.replace(/[a-f0-9]{24}/gi, (id)=>byId.get(id) || id);
};
async function $2500f9bb500be4a9$export$3d9e663f4ff38849(s) {
    const el = this;
    const root = s.root;
    const assignments = $2500f9bb500be4a9$export$68e0ccc0a42ede97.call(this);
    if (!assignments.length) return true;
    root.update({
        _orgChartSaving: true,
        _orgChartSaveError: null
    });
    const workspaceId = this.call('activeWorkspaceId', root);
    try {
        const parties = await el.sdk.getService('parties');
        await parties.setManagers(assignments, {
            workspaceId: workspaceId
        });
        const edges = await parties.listAllRelationships({
            kind: 'reports_to'
        }, {
            workspaceId: workspaceId
        });
        root.update({
            _orgChartEdges: edges || [],
            _orgChartSaving: false
        });
        return true;
    } catch (err) {
        const directory = $2500f9bb500be4a9$export$2e199d970188c594.call(this);
        root.update({
            _orgChartSaving: false,
            _orgChartSaveError: $2500f9bb500be4a9$var$_humanizeIds(err && err.message || el.call('polyglot', 'workspace.orgChart.saveFailed'), directory)
        });
        return false;
    }
}

});

parcelRegister("dVAG8", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE", () => $a23d0cdbdf1f70e5$export$6f0555de4f60e84e);
$parcel$export(module.exports, "linkResources", () => $a23d0cdbdf1f70e5$export$1a1fbe0cef65583f);
$parcel$export(module.exports, "unlinkResources", () => $a23d0cdbdf1f70e5$export$829a9fa68d6e4cdf);
$parcel$export(module.exports, "getLinkedResources", () => $a23d0cdbdf1f70e5$export$7f0c8230a9f61c14);
$parcel$export(module.exports, "backfillMeetRoomLinks", () => $a23d0cdbdf1f70e5$export$ae288418cc560b02);
// Cross-resource link helpers. Reads/writes the `resource_links` Mongo
// collection so chat channels, calendar events, and meet rooms can
// reference each other. Mongo-backed via sdk.resourceLinks.*; canonical
// (aType, aId) < (bType, bId) ordering enforced server-side.
//
// All functions support both direct calls and `el.call('fn', ...)` — root is
// inferred from `this.state.root` when the user passes a channel/event/room.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $a23d0cdbdf1f70e5$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $a23d0cdbdf1f70e5$export$6f0555de4f60e84e = Object.freeze({
    CHAT_CHANNEL: 'chat_channel',
    MEET_ROOM: 'meet_room',
    CALENDAR_EVENT: 'calendar_event'
});
const $a23d0cdbdf1f70e5$var$_VALID_TYPES = new Set(Object.values($a23d0cdbdf1f70e5$export$6f0555de4f60e84e));
const $a23d0cdbdf1f70e5$var$_asId = (x)=>x == null ? null : String(x);
// Per-(links array identity) cache for getLinkedResources results. The cache
// is invalidated automatically whenever `root.resourceLinks` is replaced
// (link/unlink optimistic updates always produce a new array reference).
const $a23d0cdbdf1f70e5$var$_linksCache = new WeakMap();
async function $a23d0cdbdf1f70e5$export$1a1fbe0cef65583f(aType, aId, bType, bId) {
    const root = this?.state?.root;
    const me = root?.currentUserEmail;
    if (!aType || aId == null || !bType || bId == null) return null;
    if (aType === bType && $a23d0cdbdf1f70e5$var$_asId(aId) === $a23d0cdbdf1f70e5$var$_asId(bId)) return null;
    try {
        // Server canonicalizes (aType, aId) < (bType, bId) ordering and is
        // idempotent — duplicate pair returns existing row with existed:true.
        const result = await $a23d0cdbdf1f70e5$var$shellGetSDK().execute('resourceLinks', 'create', {
            payload: {
                aType: aType,
                aId: $a23d0cdbdf1f70e5$var$_asId(aId),
                bType: bType,
                bId: $a23d0cdbdf1f70e5$var$_asId(bId),
                createdBy: me
            }
        });
        const data = result?.doc ?? (Array.isArray(result?.data) ? result.data[0] : result?.data ?? result ?? null);
        if (!data) return null;
        if (root) {
            const cur = root.resourceLinks || [];
            const matchKey = data._id || data.id;
            const exists = cur.some((r)=>(r._id || r.id) === matchKey);
            if (!exists) root.update({
                resourceLinks: [
                    ...cur,
                    data
                ]
            });
        }
        return data;
    } catch (err) {
        console.error('[linkResources]', err);
        return null;
    }
}
async function $a23d0cdbdf1f70e5$export$829a9fa68d6e4cdf(aType, aId, bType, bId) {
    const root = this?.state?.root;
    const sAId = $a23d0cdbdf1f70e5$var$_asId(aId);
    const sBId = $a23d0cdbdf1f70e5$var$_asId(bId);
    try {
        // Server canonicalizes ordering before lookup, so caller direction doesn't matter.
        await $a23d0cdbdf1f70e5$var$shellGetSDK().execute('resourceLinks', 'removeByPair', {
            payload: {
                aType: aType,
                aId: sAId,
                bType: bType,
                bId: sBId
            }
        });
        if (root) {
            const cur = root.resourceLinks || [];
            root.update({
                resourceLinks: cur.filter((r)=>!(r.aType === aType && r.aId === sAId && r.bType === bType && r.bId === sBId || r.aType === bType && r.aId === sBId && r.bType === aType && r.bId === sAId))
            });
        }
        return true;
    } catch (err) {
        console.error('[unlinkResources]', err?.message || err);
        return false;
    }
}
function $a23d0cdbdf1f70e5$export$7f0c8230a9f61c14(rootOrType, maybeId, maybeType) {
    let root, type, id;
    if (typeof rootOrType === 'string') {
        root = this?.state?.root;
        type = rootOrType;
        id = maybeId;
    } else {
        root = rootOrType;
        type = maybeId;
        id = maybeType;
    }
    const links = root && root.resourceLinks || null;
    if (!links) return [];
    let byKey = $a23d0cdbdf1f70e5$var$_linksCache.get(links);
    if (!byKey) {
        byKey = new Map();
        $a23d0cdbdf1f70e5$var$_linksCache.set(links, byKey);
    }
    const sid = $a23d0cdbdf1f70e5$var$_asId(id);
    const key = `${type}\x00${sid}`;
    const cached = byKey.get(key);
    if (cached) return cached;
    const out = [];
    for (const r of links){
        const linkId = r._id ?? r.id;
        if (r.aType === type && $a23d0cdbdf1f70e5$var$_asId(r.aId) === sid) out.push({
            type: r.bType,
            id: r.bId,
            linkId: linkId
        });
        else if (r.bType === type && $a23d0cdbdf1f70e5$var$_asId(r.bId) === sid) out.push({
            type: r.aType,
            id: r.aId,
            linkId: linkId
        });
    }
    byKey.set(key, out);
    return out;
}
async function $a23d0cdbdf1f70e5$export$ae288418cc560b02() {
    const root = this?.state?.root;
    const ops = [];
    for (const r of root?.rooms || []){
        if (r.calendarEventId != null) ops.push($a23d0cdbdf1f70e5$export$1a1fbe0cef65583f.call(this, 'meet_room', r.id, 'calendar_event', r.calendarEventId));
        if (r.chatChannelId != null) ops.push($a23d0cdbdf1f70e5$export$1a1fbe0cef65583f.call(this, 'meet_room', r.id, 'chat_channel', r.chatChannelId));
    }
    await Promise.all(ops);
}

});

parcelRegister("lLLtZ", function(module, exports) {

$parcel$export(module.exports, "loadPendingInvitations", () => $fd92d1d8833c5b40$export$cd6cbd2220f6b75b);
$parcel$export(module.exports, "invalidatePendingInvitations", () => $fd92d1d8833c5b40$export$c31550e91665e40);
$parcel$export(module.exports, "revokePendingInvitation", () => $fd92d1d8833c5b40$export$62d779aa00da30da);
// Pending workspace invitations — the WorkspaceInvitation rows created via
// POST /workspaces/:workspaceId/invitations (WorkspaceController.createInvitation /
// WorkspaceMemberService.invite). This is the SAME model the Simone AI
// assistant's `invite_member` tool writes to (server/src/domains/agents/
// services/workspaceTools.js executeInviteMember → WorkspaceMemberService.invite),
// so an invite Simone sends shows up here too.
//
// Distinct from the org-scoped OrgInvitation (createOrgInvitation /
// InviteDropdown magic-link) and the team-scoped TeamInvitation
// (inviteToTeam / pages/admin/teams.js Reinvite) — those are different
// Mongo collections with their own list/revoke surfaces.
//
// The server gates listWorkspaceInvitations to workspace owner/admin
// (requireWorkspaceRole(['owner','admin'])) — a non-admin caller gets a
// 403, not a filtered/empty list — so callers MUST gate on
// currentUserIsAdmin() before fetching, same as the render gate on the
// /people page section.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");

var $9ZTVI = parcelRequire("9ZTVI");
const $fd92d1d8833c5b40$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $fd92d1d8833c5b40$var$_shellGetSdk = ()=>{
    if (typeof window === 'undefined') return null;
    return $fd92d1d8833c5b40$var$shellGetSDK();
};
// SDK list-response unwrap — listWorkspaceInvitations returns
// `{success, data:{items}}` per WorkspaceController.listInvitations; also
// tolerate a bare array / `{items}` shape for resilience.
const $fd92d1d8833c5b40$var$_shellUnwrapList = (r)=>r?.data?.items || r?.items || r?.data || (Array.isArray(r) ? r : []);
const $fd92d1d8833c5b40$var$_label = (raw)=>(raw || 'editor').replace(/^./, (c)=>c.toUpperCase());
const $fd92d1d8833c5b40$var$_mapInvite = (i)=>({
        id: String(i._id || i.id || ''),
        email: i.email || '',
        role: i.role || 'editor',
        roleLabel: $fd92d1d8833c5b40$var$_label(i.role),
        invitedAt: i.createdAt || null,
        expiresAt: i.expiresAt || null
    });
// In-flight dedup + short-TTL cache, keyed by workspace id — mirrors
// listOrgMembers.js so a page mount + any sidebar refresh don't fan out
// duplicate /workspaces/:id/invitations requests.
let $fd92d1d8833c5b40$var$_pendingInvitesInflight = null;
let $fd92d1d8833c5b40$var$_pendingInvitesInflightWs = null;
let $fd92d1d8833c5b40$var$_pendingInvitesCache = null;
let $fd92d1d8833c5b40$var$_pendingInvitesCacheAt = 0;
let $fd92d1d8833c5b40$var$_pendingInvitesCacheWs = null;
// Named distinctly from `getWorkspaceCached.js`'s OWN (different-value:
// 8000 vs this file's 10000) top-level `TTL_MS` — two consts sharing one
// generic name get esbuild-renamed in the merged bundle (`TTL_MS`/
// `TTL_MS2`), and this file's read was owned by no declaration frank's
// checker could attribute. Because the two values genuinely differ, an
// unlucky future rename/reorder could have silently swapped which TTL this
// file's cache used — a locally-unique name removes that risk entirely.
const $fd92d1d8833c5b40$var$PENDING_INVITE_TTL_MS = 10000;
// el.call('loadPendingInvitations', s.root) — fetches (or serves the cached)
// pending invitation list and writes it to root.pendingInvitations. No-op
// (clears the list) when there's no active workspace or the caller isn't a
// workspace/org admin, so a member never fires the request that always 403s.
// The request itself, a named module function (not an async IIFE held in a
// local: frank lifted that local as a cut-off globalScope entry that did not
// parse). The latches carry unique names: a bare `_cache` collided with
// another module's and shipped renamed (`_cache2`).
const $fd92d1d8833c5b40$var$_fetchPendingInvitations = async (sdk, root, wsId)=>{
    const raw = await sdk.listWorkspaceInvitations(wsId).catch((err)=>{
        console.warn('[pendingInvitations] list failed:', err?.message || err);
        return null;
    });
    const list = $fd92d1d8833c5b40$var$_shellUnwrapList(raw).map($fd92d1d8833c5b40$var$_mapInvite);
    $fd92d1d8833c5b40$var$_pendingInvitesCache = list;
    $fd92d1d8833c5b40$var$_pendingInvitesCacheAt = Date.now();
    $fd92d1d8833c5b40$var$_pendingInvitesCacheWs = wsId;
    root?.update?.({
        pendingInvitations: list
    });
    return list;
};
async function $fd92d1d8833c5b40$export$cd6cbd2220f6b75b(root) {
    const wsId = (0, $9ZTVI.activeWorkspaceId)(root);
    if (!wsId) {
        root?.update?.({
            pendingInvitations: []
        });
        return [];
    }
    if ($fd92d1d8833c5b40$var$_pendingInvitesCache && $fd92d1d8833c5b40$var$_pendingInvitesCacheWs === wsId && Date.now() - $fd92d1d8833c5b40$var$_pendingInvitesCacheAt < $fd92d1d8833c5b40$var$PENDING_INVITE_TTL_MS) {
        root?.update?.({
            pendingInvitations: $fd92d1d8833c5b40$var$_pendingInvitesCache
        });
        return $fd92d1d8833c5b40$var$_pendingInvitesCache;
    }
    if ($fd92d1d8833c5b40$var$_pendingInvitesInflight && $fd92d1d8833c5b40$var$_pendingInvitesInflightWs === wsId) return $fd92d1d8833c5b40$var$_pendingInvitesInflight;
    const sdk = $fd92d1d8833c5b40$var$_shellGetSdk();
    if (!sdk || typeof sdk.listWorkspaceInvitations !== 'function') return [];
    const inflight = $fd92d1d8833c5b40$var$_fetchPendingInvitations(sdk, root, wsId);
    $fd92d1d8833c5b40$var$_pendingInvitesInflight = inflight;
    $fd92d1d8833c5b40$var$_pendingInvitesInflightWs = wsId;
    try {
        return await inflight;
    } finally{
        if ($fd92d1d8833c5b40$var$_pendingInvitesInflight === inflight) {
            $fd92d1d8833c5b40$var$_pendingInvitesInflight = null;
            $fd92d1d8833c5b40$var$_pendingInvitesInflightWs = null;
        }
    }
}
function $fd92d1d8833c5b40$export$c31550e91665e40() {
    $fd92d1d8833c5b40$var$_pendingInvitesCache = null;
    $fd92d1d8833c5b40$var$_pendingInvitesCacheAt = 0;
    $fd92d1d8833c5b40$var$_pendingInvitesCacheWs = null;
}
async function $fd92d1d8833c5b40$export$62d779aa00da30da(root, inviteId) {
    const wsId = (0, $9ZTVI.activeWorkspaceId)(root);
    if (!wsId || !inviteId) throw new Error('workspaceId and inviteId are required');
    const sdk = $fd92d1d8833c5b40$var$_shellGetSdk();
    if (!sdk || typeof sdk.revokeWorkspaceInvitation !== 'function') throw new Error('SDK not available');
    await sdk.revokeWorkspaceInvitation(wsId, inviteId);
    $fd92d1d8833c5b40$export$c31550e91665e40();
    const next = (root?.pendingInvitations || []).filter((i)=>i.id !== inviteId);
    root?.update?.({
        pendingInvitations: next
    });
    return next;
}

});

parcelRegister("8BLCC", function(module, exports) {

$parcel$export(module.exports, "forceBuildApp", () => $6446b8255ab7af93$export$2ae7963f9cebcf8);
$parcel$export(module.exports, "watchAiBuildOutput", () => $6446b8255ab7af93$export$671c5542e4f80f20);
// 'Build app' — the AI surfaces' EXPLICIT build mode.
//
// v2 (2026-09-02 per Nika "buld app should not open /add-app section but
// should be toggle which runs this functionality and opens that generated
// page after output"): the '+' menu row ARMS root._aiBuildMode instead of
// navigating. While armed, a send from EITHER AI surface routes into the
// addapp-scoped build pipeline from wherever the user is — the canvas
// composer branches in its own _sendPrompt (its normal path is
// freestyleSend, a different transport), and the sidebar rides the scope
// flip in functions/_simone/sendPrompt.js — and `watchAiBuildOutput`
// opens the build surface in a pane once the output lands, so
// the user sees the generated page without leaving their screen
// mid-build.
//
// forceBuildApp(draft) stays the single entry: send the draft into the
// addapp thread headlessly + arm the completion watcher.
const $6446b8255ab7af93$export$2ae7963f9cebcf8 = function(draft, attachments, attached) {
    const root = this.state && this.state.root;
    if (!root || !root.update) return;
    const text = String(draft || '').trim();
    if (!text) return;
    try {
        this.call('sendPrompt', text, 'addapp', attachments, attached);
    } catch (err) {
        console.warn('[buildApp] send failed:', err && err.message);
        return;
    }
    this.call('watchAiBuildOutput');
};
const $6446b8255ab7af93$export$671c5542e4f80f20 = function() {
    const root = this.state && this.state.root;
    if (!root || !root.update) return;
    if (root.__aiBuildWatch) clearInterval(root.__aiBuildWatch);
    const t0 = Date.now();
    let sawTyping = false;
    root.__aiBuildWatch = setInterval(()=>{
        const typing = !!root._ax_chatTyping;
        if (typing) sawTyping = true;
        if (sawTyping && !typing) {
            clearInterval(root.__aiBuildWatch);
            root.__aiBuildWatch = null;
            // ON THE HOME the Build tab IS the builder (functions/homeBuild.js;
            // Nika 2026-10-23: "build tab should reuse ui/ux of /add-apps"): the
            // output is in it, so the tab comes to the front — never a second
            // builder in a pane over the home.
            const fns = this.context && this.context.functions || {};
            if (typeof fns.homeTabsOnScreen === 'function' && typeof fns.homeViewSelect === 'function' && this.call('homeTabsOnScreen', root)) {
                this.call('homeViewSelect', 'build');
                return;
            }
            if (!root._canvasSlot) root.update({
                _canvasSlot: '/add-app'
            }, {
                preventFetch: true
            });
            return;
        }
        if (Date.now() - t0 > 300000) {
            clearInterval(root.__aiBuildWatch);
            root.__aiBuildWatch = null;
        }
    }, 1000);
};

});

parcelRegister("11u4Q", function(module, exports) {

$parcel$export(module.exports, "aiChatListThreads", () => $0bed3727cb69e682$export$5d01aee379bb7e09);
$parcel$export(module.exports, "aiChatLoadThread", () => $0bed3727cb69e682$export$c74eea73b1376faa);
$parcel$export(module.exports, "aiChatCreateThread", () => $0bed3727cb69e682$export$e5f962d1c7ce0b);
// AI chat thread helpers — server-backed via `sdk.aiChat.threads.*` and
// `sdk.aiChat.messages.list`. AiChatService persists thread + message
// records in Mongo (chat_threads / chat_messages); these helpers thread
// the SDK calls into the workspace's reactive root state so the
// AppAssistant panel + HomePrompt strip read from the same place.
//
// State surface populated here:
//   - root._aiThreads     — array of { id, title, updated_at, ... }
//   - root._aiThreadId    — currently active thread id
//   - root._aiThreadsLoading — true while a list fetch is in flight
//
// AppAssistantThreadPicker (workspace/components/AppAssistantThreadPicker.js)
// reads these keys and calls back into these functions via `el.call(...)`.
//
// Error handling: catch + console.warn rather than fail loudly. The
// picker stays usable even when threads RPC is unavailable — it just
// shows "No saved threads yet" and the inline thread continues to work
// against `root.assistantMessages`.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");

var $jZ5ZE = parcelRequire("jZ5ZE");
const $0bed3727cb69e682$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $0bed3727cb69e682$var$_logErr = (label, err)=>{
    console.warn(`[aiAssistantThreads] ${label}:`, err?.message || err);
};
// Unwrap an SDK list response into a plain array — the aiChat list methods
// may return a bare array or an envelope ({ data } / { items }).
const $0bed3727cb69e682$var$_shellRows = (res)=>Array.isArray(res) ? res : res?.data || res?.items || [];
const $0bed3727cb69e682$var$_normalizeThread = (t)=>({
        id: t?.id || t?._id,
        // KEY-IN-STATE — AppAssistantThreadPicker resolves this through polyglot,
        // and a real (tenant) thread title passes through untranslated.
        title: t?.title || t?.subject || 'workspace.assistant.threadFallback',
        updatedAt: t?.updated_at || t?.updatedAt || t?.created_at || null,
        // Tenant key — AiChatThread.workspace (server@22ff64d4, 2026-07-14
        // WORKSPACE-scoping decision). The server is the real scoping gate
        // (AiChatController.listThreads → resolveAiChatScope); this is carried
        // through only so AppAssistantThreadPicker can do a belt-and-suspenders
        // filter against a stale-JWT race. `required:false` during the server's
        // backfill window, so pre-backfill rows normalize to `null` here —
        // callers must treat `null` as "unscoped, don't hide" rather than a
        // mismatch.
        workspaceId: t?.workspace || t?.workspaceId || t?.workspace_id || null
    });
// Shared auth guard for every ai-chat write. Returns `true` when the
// SDK has a usable token; false otherwise. Wrapped in a try/catch so
// `getService('auth')` throwing inside the flat-method proxy (during
// SDK boot, before services register) doesn't escape as an unhandled
// rejection — the original guard hit that exact path.
const $0bed3727cb69e682$var$_hasAuthToken = (sdk)=>{
    if (!sdk) return false;
    try {
        if (typeof sdk.getAuthToken === 'function') {
            const tok = sdk.getAuthToken();
            if (tok) return true;
        }
    } catch  {}
    try {
        if (typeof sdk.isAuthenticated === 'function') return !!sdk.isAuthenticated();
    } catch  {}
    return false;
};
const $0bed3727cb69e682$export$5d01aee379bb7e09 = async function aiChatListThreads(root) {
    if (!root) return;
    if (root._aiThreadsLoading) return;
    const sdk = $0bed3727cb69e682$var$shellGetSDK();
    if (!$0bed3727cb69e682$var$_hasAuthToken(sdk)) return;
    // Join the workspace-switch epoch: threads are WORKSPACE-scoped, and a list
    // request issued in tenant A that resolves after a switch to tenant B would
    // repaint A's personalized threads over B's wiped state ("loading old AI
    // threads" — per Nika 2026-08-01). Capture the epoch before the request;
    // drop the response when stale (the new tenant's own refetch owns the data).
    const _gen = (0, $jZ5ZE.scopeGen)();
    root.update({
        _aiThreadsLoading: true
    });
    try {
        const aiChat = await sdk.getService('aiChat');
        const res = await aiChat.threads.list({
            limit: 30
        });
        if ((0, $jZ5ZE.scopeStale)(_gen)) return;
        const raw = $0bed3727cb69e682$var$_shellRows(res);
        const threads = raw.map($0bed3727cb69e682$var$_normalizeThread).filter((t)=>!!t.id);
        root.update({
            _aiThreads: threads,
            _aiThreadsLoading: false,
            _aiThreadsLoadAttempted: true
        });
    } catch (err) {
        if ((0, $jZ5ZE.scopeStale)(_gen)) return;
        $0bed3727cb69e682$var$_logErr('list failed', err);
        root.update({
            _aiThreadsLoading: false,
            _aiThreadsLoadAttempted: true
        });
    }
};
const $0bed3727cb69e682$export$c74eea73b1376faa = async function aiChatLoadThread(root, threadId) {
    if (!root || !threadId) return;
    const sdk = $0bed3727cb69e682$var$shellGetSDK();
    if (!$0bed3727cb69e682$var$_hasAuthToken(sdk)) return;
    root.update({
        _aiThreadId: threadId,
        assistantMessages: [],
        assistantTyping: false
    });
    try {
        const aiChat = await sdk.getService('aiChat');
        const res = await aiChat.messages.list(threadId, {
            limit: 200
        });
        const raw = $0bed3727cb69e682$var$_shellRows(res);
        // Service may return rows in either order — sort by created_at asc
        // so the panel renders oldest → newest top-to-bottom.
        const sorted = raw.slice().sort((a, b)=>{
            const at = new Date(a?.created_at || a?.createdAt || 0).getTime();
            const bt = new Date(b?.created_at || b?.createdAt || 0).getTime();
            return at - bt;
        });
        const messages = sorted.map((m)=>({
                role: m?.role || 'assistant',
                content: m?.content || m?.text || '',
                _streaming: false
            }));
        root.update({
            assistantMessages: messages
        });
    } catch (err) {
        $0bed3727cb69e682$var$_logErr('load failed', err);
    }
};
const $0bed3727cb69e682$export$e5f962d1c7ce0b = async function aiChatCreateThread(root) {
    if (!root) return;
    const sdk = $0bed3727cb69e682$var$shellGetSDK();
    if (!$0bed3727cb69e682$var$_hasAuthToken(sdk)) return;
    try {
        const aiChat = await sdk.getService('aiChat');
        const res = await aiChat.threads.create({
            title: this.call('polyglot', 'workspace.simone.newThread')
        });
        const created = $0bed3727cb69e682$var$_normalizeThread(res?.data || res);
        if (!created.id) {
            $0bed3727cb69e682$var$_logErr('create returned no id', res);
            return;
        }
        root.update({
            _aiThreads: [
                created,
                ...root._aiThreads || []
            ],
            _aiThreadId: created.id,
            assistantMessages: [],
            assistantTyping: false
        });
    } catch (err) {
        $0bed3727cb69e682$var$_logErr('create failed', err);
    }
};

});

parcelRegister("6yYb9", function(module, exports) {

$parcel$export(module.exports, "myPersonId", () => $4c74994cefb32cc2$export$493ca61e204c8c73);
$parcel$export(module.exports, "agentRosterStatus", () => $4c74994cefb32cc2$export$29842ab2f64f6eab);
$parcel$export(module.exports, "agentsAssignedToMe", () => $4c74994cefb32cc2$export$cac439bdf8afc33a);
$parcel$export(module.exports, "yourAgentsRows", () => $4c74994cefb32cc2$export$6cca02c30e350fd6);
$parcel$export(module.exports, "yourAgentsSubtitle", () => $4c74994cefb32cc2$export$7dc49cfffc5b49d1);
$parcel$export(module.exports, "yourAgentsCountText", () => $4c74994cefb32cc2$export$99217a711307bc9e);
$parcel$export(module.exports, "agentRosterCountText", () => $4c74994cefb32cc2$export$23ab6264285fcef8);
$parcel$export(module.exports, "teamHeadcountText", () => $4c74994cefb32cc2$export$11c1f5a4edb21d);
$parcel$export(module.exports, "teamSplitFlex", () => $4c74994cefb32cc2$export$97292335712e7593);
$parcel$export(module.exports, "teamSplitUnknown", () => $4c74994cefb32cc2$export$367c65ca0c61183b);
$parcel$export(module.exports, "teamSplitTitle", () => $4c74994cefb32cc2$export$1926e6a788c3f290);
$parcel$export(module.exports, "teamAvatarsHidden", () => $4c74994cefb32cc2$export$948c57f8994e06a6);
$parcel$export(module.exports, "teamAvatarRows", () => $4c74994cefb32cc2$export$a8e1f7ca129c0011);
$parcel$export(module.exports, "AGENT_ACCESS_ROLES", () => $4c74994cefb32cc2$export$d30128c5d3e049e3);
$parcel$export(module.exports, "agentAccessOptions", () => $4c74994cefb32cc2$export$af607a03d7fd49ca);
$parcel$export(module.exports, "agentAccessHint", () => $4c74994cefb32cc2$export$d102ff9584835fbf);
$parcel$export(module.exports, "agentProjectOptions", () => $4c74994cefb32cc2$export$bd1cc4de524f510c);
$parcel$export(module.exports, "closeCreateAgent", () => $4c74994cefb32cc2$export$311b9572e28ab475);
$parcel$export(module.exports, "submitCreateAgent", () => $4c74994cefb32cc2$export$443a16fa9a773988);

var $eOUFv = parcelRequire("eOUFv");

var $kpQ55 = parcelRequire("kpQ55");
'use strict';
const $4c74994cefb32cc2$export$493ca61e204c8c73 = (root)=>root?.currentUserId || root?.currentUserEmail || null;
const $4c74994cefb32cc2$var$_agentRoster = (root)=>Array.isArray(root?._agents) ? root._agents : [];
const $4c74994cefb32cc2$export$29842ab2f64f6eab = (root)=>{
    if (Array.isArray(root?._agents)) return 'loaded';
    if (root?._agentsError) return 'error';
    return 'loading';
};
const $4c74994cefb32cc2$export$cac439bdf8afc33a = (root)=>(0, $kpQ55.agentsAssignedTo)(root, root?.currentUserId);
const $4c74994cefb32cc2$export$6cca02c30e350fd6 = (root)=>{
    // Tier-aware (shared with /my-agents via agentsVisibleToViewer): an
    // admin/owner sees every agent, a manager sees agents assigned to self +
    // reports, a member sees agents assigned to self. `_assigned` is only
    // true for agents actually assigned to the viewer (carries an
    // assignmentId) so the relationship badge shows on those but not on the
    // admin's full-roster view.
    const agents = (0, $kpQ55.agentsVisibleToViewer)(root);
    return [
        ...agents.map((a)=>({
                ...a,
                _agent: true,
                _assigned: !!a._assignmentId
            })),
        {
            _create: true,
            id: '__create_agent__',
            name: 'Create agent'
        }
    ];
};
// Header subtitle for the widget.
//
// FALSE-ZERO-1 surface 4: only the admin branch reads straight off
// `root._agents` (agentsVisibleToViewer's admin path is the full roster) —
// the manager/member branch counts `root.agentAssignmentsByAssignee`
// instead, a separately-loaded map with its own state, so it is not part
// of this ambiguity and is left untouched. For admin, "No agents yet" is
// only correct once the roster has actually loaded and is genuinely empty.
// Reached as `el.call('yourAgentsSubtitle', root)`, so `this` is the element.
// A direct import call (the unit tests) has no element; `_t` returns the KEY
// there instead of throwing, and those tests pin the key.
const $4c74994cefb32cc2$var$_t = function(key) {
    return this && typeof this.call === 'function' ? this.call('polyglot', key) : key;
};
const $4c74994cefb32cc2$export$7dc49cfffc5b49d1 = function(root) {
    const t = $4c74994cefb32cc2$var$_t.bind(this);
    if ((0, $kpQ55.viewerTier)(root) === 'admin') {
        const status = $4c74994cefb32cc2$export$29842ab2f64f6eab(root);
        if (status === 'loading') return t('workspace.agents.checking');
        if (status === 'error') return t('workspace.agents.loadFailed');
        const n = (0, $kpQ55.agentsVisibleToViewer)(root).length;
        if (!n) return t('workspace.agents.none');
        return t(n === 1 ? 'workspace.agents.countInWorkspaceOne' : 'workspace.agents.countInWorkspace').replace('{count}', n);
    }
    const n = (0, $kpQ55.agentsVisibleToViewer)(root).length;
    if (n > 0) return t(n === 1 ? 'workspace.agents.assignedToYouOne' : 'workspace.agents.assignedToYou').replace('{count}', n);
    return t('workspace.agents.createFirst');
};
const $4c74994cefb32cc2$export$99217a711307bc9e = (root)=>{
    if ((0, $kpQ55.viewerTier)(root) === 'admin') {
        const status = $4c74994cefb32cc2$export$29842ab2f64f6eab(root);
        if (status === 'loading') return "\u2013";
        if (status === 'error') return '!';
    }
    return String($4c74994cefb32cc2$export$6cca02c30e350fd6(root).filter((r)=>r._agent).length);
};
const $4c74994cefb32cc2$export$23ab6264285fcef8 = (root)=>{
    const status = $4c74994cefb32cc2$export$29842ab2f64f6eab(root);
    if (status === 'loading') return "\u2013";
    if (status === 'error') return '!';
    return String($4c74994cefb32cc2$var$_agentRoster(root).length);
};
// ── FALSE-ZERO-1 residual: the three Home consumers that still read
// `_agents.length` raw (AppTeamWidget's combined count, the AgentsWidget
// share bar, the AgentsWidget avatar row). Measured live on
// `/w/system/hq` 2026-08-20 with the roster absent: the count rendered a
// confident "78" (people only — the true total is 86) and the share bar
// rendered a confident 100% / 0% split. Both are MEASUREMENTS, so both
// may only render from positively-read inputs.
//
// The people side reads the Home load-state contract
// (FALSE-ZERO-HOME-NON-AGENT-KEYS-1, functions/homeLoadState.js): `people`
// is `[]`-seeded, so `Array.isArray(root.people)` is true from the first
// frame and never meant "loaded" — a loaded 2-agent roster against the
// seeded `[]` rendered a confident "2" here. `peopleLoaded` is the positive
// marker every people producer writes; `peopleError` is its failure.
const $4c74994cefb32cc2$var$_peopleLoaded = (root)=>(0, $eOUFv.peopleStatus)(root) === 'loaded';
const $4c74994cefb32cc2$var$_peopleFailed = (root)=>(0, $eOUFv.peopleStatus)(root) === 'error';
const $4c74994cefb32cc2$export$11c1f5a4edb21d = (root)=>{
    const status = $4c74994cefb32cc2$export$29842ab2f64f6eab(root);
    if (status === 'error' || $4c74994cefb32cc2$var$_peopleFailed(root)) return '!';
    if (status === 'loading' || !$4c74994cefb32cc2$var$_peopleLoaded(root)) return "\u2013";
    return String(root.people.length + $4c74994cefb32cc2$var$_agentRoster(root).length);
};
const $4c74994cefb32cc2$export$97292335712e7593 = (root, part)=>{
    if ($4c74994cefb32cc2$export$367c65ca0c61183b(root)) return '0';
    const people = root.people.length;
    const agents = $4c74994cefb32cc2$var$_agentRoster(root).length;
    const total = people + agents;
    if (!total) return '0.5';
    const frac = (part === 'agents' ? agents : people) / total;
    return String(frac > 0 ? Math.max(frac, 0.04) : 0);
};
const $4c74994cefb32cc2$export$367c65ca0c61183b = (root)=>$4c74994cefb32cc2$export$29842ab2f64f6eab(root) !== 'loaded' || !$4c74994cefb32cc2$var$_peopleLoaded(root);
const $4c74994cefb32cc2$export$1926e6a788c3f290 = function(root) {
    const t = $4c74994cefb32cc2$var$_t.bind(this);
    if ($4c74994cefb32cc2$export$29842ab2f64f6eab(root) === 'error') return t('workspace.agents.loadFailedShort');
    if ($4c74994cefb32cc2$var$_peopleFailed(root)) return t('workspace.agents.membersLoadFailed');
    return '';
};
const $4c74994cefb32cc2$export$948c57f8994e06a6 = (root)=>{
    if ($4c74994cefb32cc2$export$367c65ca0c61183b(root)) return false;
    return root.people.length + $4c74994cefb32cc2$var$_agentRoster(root).length === 0;
};
const $4c74994cefb32cc2$export$a8e1f7ca129c0011 = (root)=>{
    const people = $4c74994cefb32cc2$var$_peopleLoaded(root) ? root.people.slice(0, 3) : [];
    return [
        ...people,
        ...$4c74994cefb32cc2$var$_agentRoster(root).slice(0, 3)
    ].slice(0, 5);
};
const $4c74994cefb32cc2$var$_shellSlugify = (name)=>String(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
const $4c74994cefb32cc2$export$d30128c5d3e049e3 = [
    {
        value: 'guest',
        text: 'workspace.agents.role.guest',
        permissions: [
            'read'
        ],
        hint: 'workspace.agents.role.guestHint'
    },
    {
        value: 'editor',
        text: 'workspace.agents.role.editor',
        permissions: [
            'read',
            'write'
        ],
        hint: 'workspace.agents.role.editorHint'
    },
    {
        value: 'admin',
        text: 'workspace.agents.role.admin',
        permissions: [
            'read',
            'write',
            'manage'
        ],
        hint: 'workspace.agents.role.adminHint'
    }
];
const $4c74994cefb32cc2$export$af607a03d7fd49ca = ()=>$4c74994cefb32cc2$export$d30128c5d3e049e3;
const $4c74994cefb32cc2$export$d102ff9584835fbf = (root)=>{
    const v = root?._createAgentAccess || 'editor';
    const r = $4c74994cefb32cc2$export$d30128c5d3e049e3.find((x)=>x.value === v);
    return r && r.hint || '';
};
const $4c74994cefb32cc2$export$bd1cc4de524f510c = (root)=>{
    const all = Array.isArray(root?._projectsForActiveOrg) ? root._projectsForActiveOrg : [];
    const activeWsId = root?.jwtClaims?.active_workspace_id || root?.workspace?.id;
    const scoped = !activeWsId ? all : all.filter((p)=>{
        const wsId = p?.workspace?.id || p?.workspace?._id || p?.workspace;
        return String(wsId) === String(activeWsId);
    });
    return [
        {
            value: '',
            text: 'workspace.agents.scope.wholeWorkspace'
        },
        ...scoped.map((p)=>({
                value: String(p.id || p._id || p.key || ''),
                text: p.name || p.key || 'workspace.agents.untitledProject'
            })).filter((o)=>o.value)
    ];
};
const $4c74994cefb32cc2$var$_resetCreateState = {
    _createAgentOpen: false,
    _createAgentName: '',
    _createAgentRole: '',
    _createAgentAccess: 'editor',
    _createAgentProjectId: '',
    _createAgentPending: false,
    _createAgentError: null
};
const $4c74994cefb32cc2$export$311b9572e28ab475 = (root)=>root?.update?.($4c74994cefb32cc2$var$_resetCreateState);
const $4c74994cefb32cc2$export$443a16fa9a773988 = async (el, root)=>{
    if (!root?.update) return;
    const name = String(root._createAgentName || '').trim();
    if (!name) return;
    const role = String(root._createAgentRole || '').trim();
    root.update({
        _createAgentPending: true,
        _createAgentError: null
    });
    const sdk = el?.sdk || root?.sdk;
    if (!sdk || typeof sdk.createAgent !== 'function') {
        root.update({
            _createAgentPending: false,
            _createAgentError: el.call('polyglot', 'workspace.createAgent.unavailable')
        });
        return;
    }
    // Access level → stored user-role + permission set; project scope is
    // the workspace-project id the agent runs in ('' = whole workspace).
    const access = $4c74994cefb32cc2$export$d30128c5d3e049e3.find((r)=>r.value === (root._createAgentAccess || 'editor')) || $4c74994cefb32cc2$export$d30128c5d3e049e3[1];
    const projectId = String(root._createAgentProjectId || '').trim() || null;
    try {
        const created = await sdk.createAgent({
            name: name,
            role: role,
            kind: 'agent',
            userRole: access.value,
            permissions: access.permissions,
            projectId: projectId,
            // Org tenancy (2026-06-06) — agents are created per workspace
            // org; the server stamps metadata.organization and scopes
            // listAgents by it.
            organization: root?.jwtClaims?.workspace_org_id || null
        });
        const c = created && created.data || created || {};
        const slug = String(c.username || c.slug || $4c74994cefb32cc2$var$_shellSlugify(name) || name).toLowerCase();
        const newAgent = {
            id: slug,
            name: c.name || name,
            caption: role || el.call('polyglot', 'workspace.agents.fallbackName') + " \xb7 " + slug,
            kind: 'agent',
            avatar: c.avatar || null,
            userId: c.id || c._id || null,
            email: c.email || null
        };
        const existing = $4c74994cefb32cc2$var$_agentRoster(root);
        const next = existing.some((a)=>String(a.id || '').toLowerCase() === slug) ? existing : [
            ...existing,
            newAgent
        ];
        root.update({
            ...$4c74994cefb32cc2$var$_resetCreateState,
            _agents: next,
            _agentsLoaded: false
        });
        // Auto-assign the new agent to the creator so it shows up in
        // "Your agents" immediately + renders an assignment edge on
        // /team-and-agents. Nika 2026-06-03: "new agents I create are by
        // default connected to me." Failure here is non-fatal — the agent
        // exists; the user can re-assign manually if the wire failed.
        const agentUserId = newAgent.userId;
        const assigneeUserId = root.currentUserId;
        const orgId = root.jwtClaims?.workspace_org_id || root.jwtClaims?.orgs && root.jwtClaims.orgs[0]?.id || null;
        if (agentUserId && assigneeUserId && orgId) try {
            await (0, $kpQ55.assignAgentToUser)(root, {
                orgId: orgId,
                agentUserId: agentUserId,
                assigneeUserId: assigneeUserId
            });
        } catch (assignErr) {
            console.warn('[submitCreateAgent] auto-assign to creator failed:', assignErr?.message || assignErr);
        }
        // Created (the auto-assign above is best-effort): the caller may now take
        // its form as saved (markPageSaved).
        return true;
    } catch (err) {
        root.update({
            _createAgentPending: false,
            _createAgentError: err && err.message || el.call('polyglot', 'workspace.createAgent.failed')
        });
        return false;
    }
};

});
parcelRegister("eOUFv", function(module, exports) {

$parcel$export(module.exports, "HOME_UNKNOWN_GLYPH", () => $aca1b15b5633abee$export$217c0961a12e1028);
$parcel$export(module.exports, "HOME_ERROR_GLYPH", () => $aca1b15b5633abee$export$a74db58bc8acb155);
$parcel$export(module.exports, "peopleStatus", () => $aca1b15b5633abee$export$e05053d92f00b8c8);
$parcel$export(module.exports, "peopleCountText", () => $aca1b15b5633abee$export$878092e76ab6ac3d);
$parcel$export(module.exports, "peopleTitle", () => $aca1b15b5633abee$export$42fbbd9dd8f56a96);
$parcel$export(module.exports, "homeActivityStatus", () => $aca1b15b5633abee$export$6d3b26f6e71268d2);
$parcel$export(module.exports, "homeActivityMetric", () => $aca1b15b5633abee$export$b37ca1eb04cbcbf4);
$parcel$export(module.exports, "homeActiveNow", () => $aca1b15b5633abee$export$246b706688ae1c20);
$parcel$export(module.exports, "homeActivityMetricText", () => $aca1b15b5633abee$export$d51f29e7598d678a);
$parcel$export(module.exports, "homeActiveNowText", () => $aca1b15b5633abee$export$9e135bfe15966067);
$parcel$export(module.exports, "homeActiveTodayText", () => $aca1b15b5633abee$export$e10291dda5a2c019);
$parcel$export(module.exports, "homeActivityUnknown", () => $aca1b15b5633abee$export$83d38f986b10b042);
$parcel$export(module.exports, "homeActivitySegFlex", () => $aca1b15b5633abee$export$686857c800622e2f);
$parcel$export(module.exports, "homeActivityTitle", () => $aca1b15b5633abee$export$15bd624965ac9dc4);
$parcel$export(module.exports, "homeTicketsStatus", () => $aca1b15b5633abee$export$f6ac7d968733ac0b);
$parcel$export(module.exports, "homeMyTicketsStatus", () => $aca1b15b5633abee$export$ecdc5793c4332a03);
$parcel$export(module.exports, "homeTicketsInFlight", () => $aca1b15b5633abee$export$8ac313ce101a745e);
$parcel$export(module.exports, "homeTicketListState", () => $aca1b15b5633abee$export$a0ec941951b0c905);
$parcel$export(module.exports, "homeTicketCountText", () => $aca1b15b5633abee$export$5bc9960163168e6);
$parcel$export(module.exports, "homeMyTicketsCount", () => $aca1b15b5633abee$export$14e5b005fb7a0a6);
$parcel$export(module.exports, "remindersStatus", () => $aca1b15b5633abee$export$d5bdfa170825ac20);
$parcel$export(module.exports, "remindersTodayText", () => $aca1b15b5633abee$export$3f539b4564adcb6c);
$parcel$export(module.exports, "remindersSubtitle", () => $aca1b15b5633abee$export$2ad0a75634e72355);
$parcel$export(module.exports, "remindersListState", () => $aca1b15b5633abee$export$71c4a5236f1c40d2);
$parcel$export(module.exports, "remindersEmptyText", () => $aca1b15b5633abee$export$9044ea0084ac0498);

var $7iFOV = parcelRequire("7iFOV");
'use strict';
// FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — the Home load-state contract for the
// four state keys the agent-roster fix (FALSE-ZERO-1) did NOT cover:
// `people`, `_homeWorkspaceActivity`, the ticket lists, and `reminders`.
//
// THE LAW (three states, one surface):
//   NOT LOADED          → a skeleton / '–'. Never a number.
//   LOADED, GENUINELY 0 → the honest zero plus its empty-state copy.
//   FAILED              → an error affordance ('!'). Never a zero.
// A surface that cannot tell state 1 from state 2 is the bug.
//
// ⚠️ WHY `Array.isArray(root.X)` IS NOT A LOADED SIGNAL HERE, MEASURED.
// The agent roster could use it because `shared/state.js` seeds `_agents:
// null`. This app's own schema seeds `people: []`, `reminders: []`,
// `tickets: []` and `myTickets: []` — so `Array.isArray` is TRUE from the
// first frame, before any producer has run. Reproduced 2026-08-20 against
// the real schema default (`state-app.js`): with `people: []` (seed) and a
// LOADED 2-agent roster, the parent's `teamHeadcountText` returned "2" and
// its share bar returned people 0 / agents 1 — a confident total and a
// confident 100%-agents split, both computed from a roster nobody had read.
// An `[]`-seeded key therefore needs a POSITIVE marker written by its
// producer; that is what `peopleLoaded` / `remindersLoaded` are, and why
// they are declared in `state-app.js` (an undeclared key is dropped by
// smbls 3.14 `root.update()`). Home's own ticket cache `_userTickets` is
// instead seeded `null` — the same "not read yet" convention as `_agents`
// and `_homeWorkspaceActivity` — because its one-shot request gate
// (`_homeTicketsLoaded`) is set BEFORE the fetch resolves and so can never
// double as the positive marker.
//
// ⚠️ AND WHY A CONSUMER FIX ALONE IS WORTHLESS. The parent's predecessor
// shipped a correct tri-state consumer that rendered a permanent '–' for
// four days, because no producer wrote the key on Home. Every status below
// names the producer that writes its marker, and each producer runs on
// Home. `root.tickets` has NO Home producer at all — see
// `homeTicketsStatus`.
// One-line status resolver shared by every key below: a positive marker,
// an error key, nothing else. Kept private so a consumer cannot invent a
// fifth state.
const $aca1b15b5633abee$var$_status = (loaded, error)=>{
    if (error) return 'error';
    return loaded ? 'loaded' : 'loading';
};
const $aca1b15b5633abee$export$217c0961a12e1028 = "\u2013";
const $aca1b15b5633abee$export$a74db58bc8acb155 = '!';
// Render a count through the contract. `count` is only evaluated in the
// loaded branch, so a caller can pass a thunk that assumes loaded data.
const $aca1b15b5633abee$var$_countText = (status, count)=>{
    if (status === 'error') return $aca1b15b5633abee$export$a74db58bc8acb155;
    if (status !== 'loaded') return $aca1b15b5633abee$export$217c0961a12e1028;
    return String(count());
};
const $aca1b15b5633abee$export$e05053d92f00b8c8 = (root)=>$aca1b15b5633abee$var$_status(!!root?.peopleLoaded && Array.isArray(root?.people), root?.peopleError);
const $aca1b15b5633abee$export$878092e76ab6ac3d = (root)=>$aca1b15b5633abee$var$_countText($aca1b15b5633abee$export$e05053d92f00b8c8(root), ()=>root.people.length);
function $aca1b15b5633abee$export$42fbbd9dd8f56a96(root) {
    return $aca1b15b5633abee$export$e05053d92f00b8c8(root) === 'error' ? (0, $7iFOV.shellSay)(this, 'workspace.agents.membersLoadFailed') : '';
}
const $aca1b15b5633abee$export$6d3b26f6e71268d2 = (root)=>{
    const a = root?._homeWorkspaceActivity;
    return $aca1b15b5633abee$var$_status(!!a && typeof a === 'object', root?._homeWorkspaceActivityError);
};
// A single metric can be missing from an otherwise-loaded payload, so the
// per-metric read carries its own presence check on top of the payload
// status.
const $aca1b15b5633abee$var$_metric = (root, key)=>{
    const a = root?._homeWorkspaceActivity;
    const v = a && a[key];
    return typeof v === 'number' && Number.isFinite(v) ? v : null;
};
const $aca1b15b5633abee$export$b37ca1eb04cbcbf4 = (v)=>{
    if (v == null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};
const $aca1b15b5633abee$export$246b706688ae1c20 = (root)=>$aca1b15b5633abee$export$6d3b26f6e71268d2(root) === 'loaded' ? $aca1b15b5633abee$var$_metric(root, 'usersNow') : null;
const $aca1b15b5633abee$export$d51f29e7598d678a = (root, key)=>{
    const status = $aca1b15b5633abee$export$6d3b26f6e71268d2(root);
    if (status === 'error') return $aca1b15b5633abee$export$a74db58bc8acb155;
    const v = status === 'loaded' ? $aca1b15b5633abee$var$_metric(root, key) : null;
    return v == null ? $aca1b15b5633abee$export$217c0961a12e1028 : String(v);
};
const $aca1b15b5633abee$export$9e135bfe15966067 = (root)=>$aca1b15b5633abee$export$d51f29e7598d678a(root, 'usersNow');
const $aca1b15b5633abee$export$e10291dda5a2c019 = (root)=>$aca1b15b5633abee$export$d51f29e7598d678a(root, 'usersToday');
const $aca1b15b5633abee$export$83d38f986b10b042 = (root)=>$aca1b15b5633abee$export$6d3b26f6e71268d2(root) !== 'loaded' || $aca1b15b5633abee$var$_metric(root, 'usersNow') == null || $aca1b15b5633abee$var$_metric(root, 'usersToday') == null;
const $aca1b15b5633abee$export$686857c800622e2f = (root, part)=>{
    if ($aca1b15b5633abee$export$83d38f986b10b042(root)) return '0';
    const now = $aca1b15b5633abee$var$_metric(root, 'usersNow');
    const today = Math.max($aca1b15b5633abee$var$_metric(root, 'usersToday'), now);
    if (!today) return part === 'now' ? '0.04' : '0.96';
    const frac = (part === 'now' ? now : today - now) / today;
    return String(frac > 0 ? Math.max(frac, 0.04) : 0);
};
function $aca1b15b5633abee$export$15bd624965ac9dc4(root) {
    return $aca1b15b5633abee$export$6d3b26f6e71268d2(root) === 'error' ? (0, $7iFOV.shellSay)(this, 'workspace.home.loadState.activity') : '';
}
const $aca1b15b5633abee$export$f6ac7d968733ac0b = (root)=>$aca1b15b5633abee$var$_status(Array.isArray(root?._userTickets), root?._homeTicketsError);
const $aca1b15b5633abee$export$ecdc5793c4332a03 = (root)=>$aca1b15b5633abee$var$_status(Array.isArray(root?._userTickets) && Array.isArray(root?.myTickets), root?._homeTicketsError);
const $aca1b15b5633abee$export$8ac313ce101a745e = (root)=>$aca1b15b5633abee$export$f6ac7d968733ac0b(root) === 'loaded' ? root._userTickets.length : null;
const $aca1b15b5633abee$export$a0ec941951b0c905 = (root, count)=>{
    const status = $aca1b15b5633abee$export$f6ac7d968733ac0b(root);
    if (status !== 'loaded') return status;
    return count ? 'list' : 'empty';
};
const $aca1b15b5633abee$export$5bc9960163168e6 = (root, count)=>$aca1b15b5633abee$var$_countText($aca1b15b5633abee$export$f6ac7d968733ac0b(root), ()=>count);
const $aca1b15b5633abee$export$14e5b005fb7a0a6 = (root)=>$aca1b15b5633abee$export$ecdc5793c4332a03(root) === 'loaded' ? root.myTickets.length : null;
const $aca1b15b5633abee$export$d5bdfa170825ac20 = (root)=>{
    if (root?._remindersLoadError) return 'error';
    return $aca1b15b5633abee$var$_status(!!root?.remindersLoaded && Array.isArray(root?.reminders), root?.remindersError);
};
const $aca1b15b5633abee$export$3f539b4564adcb6c = (root, counts)=>$aca1b15b5633abee$var$_countText($aca1b15b5633abee$export$d5bdfa170825ac20(root), ()=>(counts || {}).today || 0);
function $aca1b15b5633abee$export$2ad0a75634e72355(root, counts) {
    const status = $aca1b15b5633abee$export$d5bdfa170825ac20(root);
    if (status === 'error') return (0, $7iFOV.shellSay)(this, 'workspace.home.loadState.reminders');
    // An unread set shows the widget's descriptor — the skeleton body carries
    // the busy state; a renderable "Loading…" string is illegal (DESIGN_LANGUAGE
    // §9, lock renderable-loading-string). The numeral stays '–' meanwhile.
    if (status !== 'loaded') return (0, $7iFOV.shellSay)(this, 'workspace.home.loadState.remindersDescriptor');
    const n = (counts || {}).today || 0;
    return n ? (0, $7iFOV.shellSay)(this, 'workspace.home.loadState.remindersDueToday').replace('{count}', ()=>String(n)) : (0, $7iFOV.shellSay)(this, 'workspace.home.loadState.remindersDescriptor');
}
const $aca1b15b5633abee$export$71c4a5236f1c40d2 = (root, counts)=>{
    const status = $aca1b15b5633abee$export$d5bdfa170825ac20(root);
    if (status !== 'loaded') return status;
    return (counts || {}).all ? 'list' : 'empty';
};
function $aca1b15b5633abee$export$9044ea0084ac0498(root) {
    return $aca1b15b5633abee$export$d5bdfa170825ac20(root) === 'error' ? (0, $7iFOV.shellSay)(this, 'workspace.home.loadState.reminders') : (0, $7iFOV.shellSay)(this, 'workspace.home.loadState.remindersEmpty');
}

});

parcelRegister("kpQ55", function(module, exports) {

$parcel$export(module.exports, "agentAssignOrgId", () => $edce8aab6bb1e768$export$fc739e9e2a917caf);
$parcel$export(module.exports, "agentUserIdForSlug", () => $edce8aab6bb1e768$export$5deb7d8cea2f821);
$parcel$export(module.exports, "agentBySlugUserId", () => $edce8aab6bb1e768$export$749a57089a4c9bd7);
$parcel$export(module.exports, "viewerTier", () => $edce8aab6bb1e768$export$18210b8bd7a64ca7);
$parcel$export(module.exports, "agentsVisibleToViewer", () => $edce8aab6bb1e768$export$a711248e509bb21f);
$parcel$export(module.exports, "agentsAssignedTo", () => $edce8aab6bb1e768$export$87a6be2483495e71);
$parcel$export(module.exports, "loadAllAgentAssignments", () => $edce8aab6bb1e768$export$9361de32fb81c39);
$parcel$export(module.exports, "assignAgentToUser", () => $edce8aab6bb1e768$export$7670c68f1142eaf2);
$parcel$export(module.exports, "unassignAgentFromUser", () => $edce8aab6bb1e768$export$56457273f320882d);
$parcel$export(module.exports, "setAgentAssignmentRelationship", () => $edce8aab6bb1e768$export$dcec74c33a647f1e);
$parcel$export(module.exports, "usersAssignedToAgent", () => $edce8aab6bb1e768$export$707e3475a2102876);

var $1X0Je = parcelRequire("1X0Je");

var $hv7Tn = parcelRequire("hv7Tn");
'use strict';
const $edce8aab6bb1e768$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// Same list-shape unwrap teams.js uses — servers return {items} / {data} /
// {data:{items}} / bare array depending on endpoint + version.
const $edce8aab6bb1e768$var$_shellUnwrapList = (r)=>r?.items || r?.data?.items || r?.data || (Array.isArray(r) ? r : []);
const $edce8aab6bb1e768$var$_shellGetSdk = ()=>{
    if (typeof window === 'undefined') return null;
    return $edce8aab6bb1e768$var$shellGetSDK();
};
// A populated ref may be an object ({_id,name,...}) or a bare id string.
const $edce8aab6bb1e768$var$_idOf = (ref)=>{
    if (!ref) return null;
    if (typeof ref === 'string') return ref;
    return ref._id || ref.id || null;
};
const $edce8aab6bb1e768$export$fc739e9e2a917caf = (root)=>root?.jwtClaims?.workspace_org_id || Array.isArray(root?.jwtClaims?.orgs) && root.jwtClaims.orgs[0]?.id || root?.workspace?.id || null;
const $edce8aab6bb1e768$export$5deb7d8cea2f821 = (root, slug)=>{
    const a = (Array.isArray(root?._agents) ? root._agents : []).find((x)=>String(x.id).toLowerCase() === String(slug || '').toLowerCase());
    return a?.userId || null;
};
const $edce8aab6bb1e768$export$749a57089a4c9bd7 = (root, userId)=>(Array.isArray(root?._agents) ? root._agents : []).find((x)=>String(x.userId) === String(userId)) || null;
// ─── Viewer-scoped visibility ─────────────────────────────────────
// Shared with the /my-agents canvas (team-and-agents.js keeps a mirror
// for its own package — canvas can't import workspace functions except
// via el.call, so the tier logic is intentionally duplicated across the
// package boundary; keep the two in sync). The home "Your agents" widget
// and /my-agents must agree on what each viewer sees:
//   admin   — owner|co-owner|admin org role, admin.teams perm, or jwt
//             is_owner → every agent.
//   manager — leads ≥1 team (team-maintainer in teamsByEmail) → the
//             agents assigned to self + the people on teams they lead.
//   member  — agents assigned to self.
const $edce8aab6bb1e768$var$_ADMIN_ROLES = [
    'owner',
    'co-owner',
    'admin',
    'superadmin'
];
const $edce8aab6bb1e768$export$18210b8bd7a64ca7 = (root)=>{
    // Gate-A claim cutover: is_owner / permissions sourced from the Mongo
    // active-org row (claimResolver.js). Kept in lock-step with the canvas
    // `_viewerTier` mirror.
    const claims = (0, $hv7Tn.shellResolveClaims)(root);
    const role = (root?.roles && root.roles.byUser || {})[root?.currentUserId] || null;
    const perms = Array.isArray(claims.permissions) ? claims.permissions : [];
    if (claims.is_owner || $edce8aab6bb1e768$var$_ADMIN_ROLES.includes(String(role || '')) || perms.includes('admin.teams')) return 'admin';
    // id-first: a non-mgmt viewer's own roster row carries no email, so the
    // email map is empty for them — resolve their teams via the stable userId
    // (root.currentUserId is the Mongo _id) before falling back to email
    // (tickets/fable.md P0 regression).
    const uid = root?.currentUserId != null ? String(root.currentUserId) : '';
    const email = String(root?.currentUserEmail || '').toLowerCase();
    const byId = uid && root?.teamsByUserId?.[uid] || null;
    const myTeams = (byId && byId.length ? byId : email && root?.teamsByEmail?.[email]) || [];
    if (myTeams.some((t)=>/maintainer|manager|lead/i.test(String(t.role || '')))) return 'manager';
    return 'member';
};
// People (User _ids) on teams the viewer leads; [] for non-managers.
const $edce8aab6bb1e768$var$_shellPeopleUnderViewer = (root)=>{
    // id-first membership resolution (non-mgmt rows carry no email) — see
    // viewerTier / tickets/fable.md P0 regression.
    const uid = root?.currentUserId != null ? String(root.currentUserId) : '';
    const email = String(root?.currentUserEmail || '').toLowerCase();
    const byIdMap = root?.teamsByUserId || {};
    const byEmail = root?.teamsByEmail || {};
    const myById = uid && byIdMap[uid] || null;
    const myTeams = (myById && myById.length ? myById : email && byEmail[email]) || [];
    const leadIds = myTeams.filter((t)=>/maintainer|manager|lead/i.test(String(t.role || ''))).map((t)=>String(t.id));
    if (!leadIds.length) return [];
    const out = [];
    for (const p of Array.isArray(root?.people) ? root.people : []){
        if (!p?.userId) continue;
        if (uid && String(p.userId) === uid || email && String(p?.email || '').toLowerCase() === email) continue;
        const rows = p.userId != null && byIdMap[String(p.userId)] || byEmail[String(p?.email || '').toLowerCase()] || [];
        if (rows.some((t)=>leadIds.includes(String(t.id)))) out.push(p.userId);
    }
    return out;
};
const $edce8aab6bb1e768$export$a711248e509bb21f = (root)=>{
    const tier = $edce8aab6bb1e768$export$18210b8bd7a64ca7(root);
    if (tier === 'admin') {
        const roster = Array.isArray(root?._agents) ? root._agents : [];
        return roster.map((a)=>({
                ...a
            }));
    }
    const assigneeIds = [
        root?.currentUserId,
        ...$edce8aab6bb1e768$var$_shellPeopleUnderViewer(root)
    ].filter(Boolean);
    const seen = new Set();
    const out = [];
    for (const uid of assigneeIds)for (const a of $edce8aab6bb1e768$export$87a6be2483495e71(root, uid)){
        if (seen.has(a.id)) continue;
        seen.add(a.id);
        out.push(a);
    }
    return out;
};
// Load assignments across every org the user belongs to, indexed both
// ways. Feature-detected: a no-op (empty maps) until sdk.listAgentAssignments
// ships in the SDK dist, so the UI degrades gracefully meanwhile.
// smbls reconciles object-valued state by key, so a key that was present
// in a prior map but is absent after a rebuild/unassign can linger as
// `undefined` rather than being dropped — and the `{ ...prev }` spreads in
// the optimistic writers below then carry that `undefined` forward
// indefinitely. `_pruneMap` keeps only non-empty arrays so the maps stay
// clean (no `undefined`/empty values), self-healing any inherited cruft.
// `_commitMaps` is the single write point that prunes before every update.
// Pairs with the Array.isArray guard in agentsAssignedTo (belt + braces).
const $edce8aab6bb1e768$var$_pruneMap = (m)=>{
    const out = {};
    for(const k in m)if (Array.isArray(m[k]) && m[k].length) out[k] = m[k];
    return out;
};
const $edce8aab6bb1e768$var$_commitMaps = (root, byAssignee, byAgent)=>{
    const a = $edce8aab6bb1e768$var$_pruneMap(byAssignee);
    const g = $edce8aab6bb1e768$var$_pruneMap(byAgent);
    root?.update?.({
        agentAssignmentsByAssignee: a,
        agentAssignmentsByAgent: g
    });
    return {
        agentAssignmentsByAssignee: a,
        agentAssignmentsByAgent: g
    };
};
const $edce8aab6bb1e768$export$9361de32fb81c39 = async (root)=>{
    const sdk = await $edce8aab6bb1e768$var$_shellGetSdk();
    if (!sdk || typeof sdk.listAgentAssignments !== 'function') return {
        agentAssignmentsByAssignee: {},
        agentAssignmentsByAgent: {}
    };
    const orgs = root?.jwtClaims?.orgs || [];
    const byAssignee = {};
    const byAgent = {};
    await Promise.all(orgs.map(async (org)=>{
        const orgId = org.id;
        if (!orgId) return;
        const res = await sdk.listAgentAssignments(orgId).catch((err)=>{
            const msg = err && err.message || '';
            // Membership-gated orgs throw — that's expected, stay quiet.
            if (!/membership|not.*member|forbidden|403|404/i.test(msg)) console.warn('[agentAssignments] list failed for', orgId, msg);
            return null;
        });
        if (!res) return;
        for (const a of $edce8aab6bb1e768$var$_shellUnwrapList(res)){
            // The server populates both the Mongo _id and the federated
            // supabaseUserId. The frontend's id space is mixed: agents +
            // currentUserId are Mongo _ids, but workspace people (canvas nodes,
            // person.userId) are supabaseUserId UUIDs. Use the UUID as the
            // canonical assignee id (so canvas edges + person rows match) and
            // dual-key the index under EVERY alias so any lookup space resolves.
            const agentMongo = $edce8aab6bb1e768$var$_idOf(a.agent);
            const agentUuid = a.agent && a.agent.supabaseUserId || null;
            const assigneeMongo = $edce8aab6bb1e768$var$_idOf(a.assignee);
            const assigneeUuid = a.assignee && a.assignee.supabaseUserId || null;
            const entry = {
                id: a._id || a.id,
                agent: agentMongo,
                agentName: a.agent && (a.agent.name || a.agent.username) || null,
                assignee: assigneeUuid || assigneeMongo,
                assigneeName: a.assignee && (a.assignee.name || a.assignee.email) || null,
                role: a.role || 'assignee',
                status: a.status || 'active',
                relationship: a.metadata && a.metadata.relationship || null,
                orgId: orgId
            };
            for (const k of new Set([
                assigneeUuid,
                assigneeMongo
            ].filter(Boolean)))(byAssignee[k] = byAssignee[k] || []).push(entry);
            for (const k of new Set([
                agentMongo,
                agentUuid
            ].filter(Boolean)))(byAgent[k] = byAgent[k] || []).push(entry);
        }
    }));
    return $edce8aab6bb1e768$var$_commitMaps(root, byAssignee, byAgent);
};
const $edce8aab6bb1e768$export$7670c68f1142eaf2 = async (root, { orgId: orgId, agentUserId: agentUserId, assigneeUserId: assigneeUserId, role: role = 'assignee' })=>{
    const sdk = await $edce8aab6bb1e768$var$_shellGetSdk();
    if (!sdk || typeof sdk.assignAgent !== 'function') throw new Error("Agent assignment isn\u2019t available on this build yet");
    if (!orgId || !agentUserId || !assigneeUserId) throw new Error('orgId, agentUserId and assigneeUserId are required');
    const res = await sdk.assignAgent(orgId, {
        agentId: agentUserId,
        assigneeId: assigneeUserId,
        role: role
    });
    const created = res && res.data || res || {};
    const entry = {
        id: created._id || created.id,
        agent: agentUserId,
        assignee: assigneeUserId,
        role: created.role || role,
        status: created.status || 'active',
        relationship: null,
        orgId: orgId
    };
    const byAssignee = {
        ...root.agentAssignmentsByAssignee || {}
    };
    const byAgent = {
        ...root.agentAssignmentsByAgent || {}
    };
    byAssignee[assigneeUserId] = [
        ...byAssignee[assigneeUserId] || [],
        entry
    ];
    byAgent[agentUserId] = [
        ...byAgent[agentUserId] || [],
        entry
    ];
    $edce8aab6bb1e768$var$_commitMaps(root, byAssignee, byAgent);
    return entry;
};
const $edce8aab6bb1e768$export$56457273f320882d = async (root, { orgId: orgId, assignmentId: assignmentId, agentUserId: agentUserId, assigneeUserId: assigneeUserId })=>{
    const sdk = await $edce8aab6bb1e768$var$_shellGetSdk();
    if (!sdk || typeof sdk.unassignAgent !== 'function') throw new Error("Agent assignment isn\u2019t available on this build yet");
    await sdk.unassignAgent(orgId, assignmentId);
    const byAssignee = {
        ...root.agentAssignmentsByAssignee || {}
    };
    const byAgent = {
        ...root.agentAssignmentsByAgent || {}
    };
    if (assigneeUserId && byAssignee[assigneeUserId]) {
        byAssignee[assigneeUserId] = byAssignee[assigneeUserId].filter((a)=>a.id !== assignmentId);
        if (!byAssignee[assigneeUserId].length) delete byAssignee[assigneeUserId];
    }
    if (agentUserId && byAgent[agentUserId]) {
        byAgent[agentUserId] = byAgent[agentUserId].filter((a)=>a.id !== assignmentId);
        if (!byAgent[agentUserId].length) delete byAgent[agentUserId];
    }
    $edce8aab6bb1e768$var$_commitMaps(root, byAssignee, byAgent);
};
const $edce8aab6bb1e768$export$dcec74c33a647f1e = async (root, { orgId: orgId, assignmentId: assignmentId, agentUserId: agentUserId, assigneeUserId: assigneeUserId, relationship: relationship })=>{
    const sdk = await $edce8aab6bb1e768$var$_shellGetSdk();
    if (!sdk || typeof sdk.updateAgentAssignment !== 'function') throw new Error("Agent assignment update isn\u2019t available on this build yet");
    if (!orgId || !assignmentId) throw new Error('orgId and assignmentId are required');
    const rel = relationship || null;
    await sdk.updateAgentAssignment(orgId, assignmentId, {
        metadata: {
            relationship: rel
        }
    });
    const patch = (e)=>e.id === assignmentId ? {
            ...e,
            relationship: rel
        } : e;
    const byAssignee = {
        ...root.agentAssignmentsByAssignee || {}
    };
    const byAgent = {
        ...root.agentAssignmentsByAgent || {}
    };
    if (assigneeUserId && byAssignee[assigneeUserId]) byAssignee[assigneeUserId] = byAssignee[assigneeUserId].map(patch);
    if (agentUserId && byAgent[agentUserId]) byAgent[agentUserId] = byAgent[agentUserId].map(patch);
    $edce8aab6bb1e768$var$_commitMaps(root, byAssignee, byAgent);
};
const $edce8aab6bb1e768$export$87a6be2483495e71 = (root, assigneeUserId = root?.currentUserId)=>{
    if (!assigneeUserId) return [];
    // Defensive: a key can exist with a non-array (undefined) value from a
    // stale optimistic write / state-clone; treat anything non-array as empty.
    const raw = root?.agentAssignmentsByAssignee?.[assigneeUserId];
    const rows = Array.isArray(raw) ? raw : [];
    return rows.map((r)=>{
        const a = $edce8aab6bb1e768$export$749a57089a4c9bd7(root, r.agent);
        return a ? {
            ...a,
            _assignmentId: r.id,
            _assignmentRole: r.role,
            _assignmentRelationship: r.relationship || null
        } : {
            id: r.agent,
            // Both copy fields carry bundle KEYS when the row has no words of
            // its own (the KEY-IN-STATE form): YourAgentCard resolves `name` and
            // `caption` through polyglot, which returns a real name verbatim.
            name: r.agentName || 'workspace.agents.fallbackName',
            caption: 'workspace.agents.caption',
            kind: 'agent',
            userId: r.agent,
            _assignmentId: r.id,
            _assignmentRole: r.role,
            _assignmentRelationship: r.relationship || null
        };
    });
};
const $edce8aab6bb1e768$export$707e3475a2102876 = (root, agentUserId)=>{
    if (!agentUserId) return [];
    return root?.agentAssignmentsByAgent?.[agentUserId] || [];
};

});


parcelRegister("5ML7q", function(module, exports) {

$parcel$export(module.exports, "reminderScopeWs", () => $4365fc43c49e0bd1$export$86b5f1774b232d9);
$parcel$export(module.exports, "rowToReminder", () => $4365fc43c49e0bd1$export$422c1302f0a51a03);
$parcel$export(module.exports, "reminderIsMine", () => $4365fc43c49e0bd1$export$6d99fc022c96ba87);
$parcel$export(module.exports, "reminderParseMentions", () => $4365fc43c49e0bd1$export$d1af97dc8b1a7048);
$parcel$export(module.exports, "createReminder", () => $4365fc43c49e0bd1$export$237deebceb0c51a0);
$parcel$export(module.exports, "toggleReminder", () => $4365fc43c49e0bd1$export$10b8b4e15357c1ca);
$parcel$export(module.exports, "deleteReminder", () => $4365fc43c49e0bd1$export$248ace6cab211eb2);
$parcel$export(module.exports, "confirmDeleteReminder", () => $4365fc43c49e0bd1$export$eab7ef461c24d461);
$parcel$export(module.exports, "confirmConvertReminderToTask", () => $4365fc43c49e0bd1$export$f5b42809a2e5500e);
$parcel$export(module.exports, "setRemindersFilter", () => $4365fc43c49e0bd1$export$d846bfd276f0cbf2);
$parcel$export(module.exports, "reminderDueLabel", () => $4365fc43c49e0bd1$export$a465112fe215870f);
$parcel$export(module.exports, "reminderIsOverdue", () => $4365fc43c49e0bd1$export$4d5c6b2292db9d5);
$parcel$export(module.exports, "reminderGroups", () => $4365fc43c49e0bd1$export$358752ecb2f68392);
$parcel$export(module.exports, "reminderCounts", () => $4365fc43c49e0bd1$export$e04673c3de24a793);
$parcel$export(module.exports, "setRemindersScope", () => $4365fc43c49e0bd1$export$439b1a261d07ed52);
$parcel$export(module.exports, "reminderEmptyText", () => $4365fc43c49e0bd1$export$b0ebe504956e5716);
$parcel$export(module.exports, "reminderQuickDue", () => $4365fc43c49e0bd1$export$82ca138ebee6844b);
$parcel$export(module.exports, "reminderDraftDueInputValue", () => $4365fc43c49e0bd1$export$eb2ef3c99c97296);
$parcel$export(module.exports, "setReminderDraftDue", () => $4365fc43c49e0bd1$export$54398903120291c0);
$parcel$export(module.exports, "clearReminderDraftDue", () => $4365fc43c49e0bd1$export$6b0d437e0a8885a5);
$parcel$export(module.exports, "submitReminderDraft", () => $4365fc43c49e0bd1$export$6e0bfd7d1b16853e);
$parcel$export(module.exports, "setReminderMentionQuery", () => $4365fc43c49e0bd1$export$5c868fefd7ca3d94);
$parcel$export(module.exports, "reminderMentionMatches", () => $4365fc43c49e0bd1$export$849afc1a2c9b7b50);
$parcel$export(module.exports, "applyReminderMention", () => $4365fc43c49e0bd1$export$a8adfff57cca0f1a);
$parcel$export(module.exports, "toggleReminderDraftShared", () => $4365fc43c49e0bd1$export$b4620d72e4e32ee3);
$parcel$export(module.exports, "convertReminderToTask", () => $4365fc43c49e0bd1$export$997d55a32893e8b6);
$parcel$export(module.exports, "convertReminderToEvent", () => $4365fc43c49e0bd1$export$738dd150df2f7804);
$parcel$export(module.exports, "reminderDueSweep", () => $4365fc43c49e0bd1$export$c8e998f8bdcd1802);
// Built-in Reminders app — personal, per-user reminders backed by the
// generic records plane (workspaceProject.records, collection: 'reminders').
// No dedicated server table: every row is { id, collection, name, data,
// created_at, updated_at } — `name` carries the title, everything else
// (done/dueAt/notes/ownerEmail) rides the `data` blob (PATCH shallow-merges
// `data`, so a toggle only ever sends `{ data: { done } }`).
//
// PERSONAL SCOPE (v1): the server does not yet scope /records by owner, so
// every function here filters/writes strictly through `mine()` — only rows
// whose `data.ownerEmail === root.currentUserEmail` are ever shown or
// mutated. Tightening this server-side is a known follow-up (see the
// workspace ticket board), not attempted here.
//
// Registered on the project via functions/index.js barrel so every export
// below resolves through `el.call('fnName', …)` (never imported directly —
// see components/ReminderRow.js, components/ReminderComposer.js,
// pages/reminders.js).
const $4365fc43c49e0bd1$var$COLLECTION = 'reminders';
const $4365fc43c49e0bd1$var$_logErr = (scope, err)=>console.error(`[${scope}]`, err && err.message || err);
const $4365fc43c49e0bd1$var$_tempId = ()=>`temp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
const $4365fc43c49e0bd1$var$_isTempId = (id)=>typeof id === 'string' && id.startsWith('temp-');
const $4365fc43c49e0bd1$var$_nowIso = ()=>new Date().toISOString();
const $4365fc43c49e0bd1$export$86b5f1774b232d9 = function(root) {
    const r = root || this && this.state && this.state.root || null;
    if (!r) return null;
    const wsDoc = r.workspace && (r.workspace.id || r.workspace._id);
    if (wsDoc) return wsDoc;
    if (r.activeWorkspaceId) return r.activeWorkspaceId;
    const claims = r.jwtClaims || {};
    if (claims.active_workspace_id) return claims.active_workspace_id;
    let pointer = null;
    try {
        pointer = this && this.call ? this.call('getActiveWorkspacePointer') : null;
    } catch (_) {
        pointer = null;
    }
    if (pointer) return pointer;
    const first = Array.isArray(r.workspaces) && r.workspaces[0];
    return first && (first.id || first._id) || null;
};
// Only the signed-in user's own reminders — client-side personal-scope gate
// (see PERSONAL SCOPE note above).
const $4365fc43c49e0bd1$var$_mine = (root)=>{
    const me = (root && root.currentUserEmail ? root.currentUserEmail : '').toLowerCase();
    if (!me) return [];
    return (root && root.reminders || []).filter((r)=>(r && r.ownerEmail || '').toLowerCase() === me);
};
const $4365fc43c49e0bd1$export$422c1302f0a51a03 = (row)=>{
    const id = row && (row.id || row._id) || '';
    const data = row && row.data || {};
    return {
        id: id,
        key: id,
        title: row && row.name || '',
        done: !!data.done,
        dueAt: data.dueAt || null,
        notes: data.notes || '',
        ownerEmail: data.ownerEmail || '',
        // 'private' (owner-only, the default) | 'shared' (whole workspace).
        visibility: data.visibility === 'shared' ? 'shared' : 'private',
        // Emails @mentioned in the title at create time (already notified).
        mentions: Array.isArray(data.mentions) ? data.mentions : [],
        // Set by reminderDueSweep after the due-time notification fired — the
        // re-fire guard that survives reloads and other devices.
        notifiedAt: data.notifiedAt || null,
        createdAt: row && row.created_at || null,
        updatedAt: row && row.updated_at || null
    };
};
// Rows for the selected Files-style scope. Private means only the current
// member's private rows; Shared means workspace-visible rows. The scope switch
// is intentionally a view selector, not a transport parameter: the generic
// records plane returns the collection, then the app applies its own
// creator/visibility contract just as the Files canvas does.
const $4365fc43c49e0bd1$var$_shellVisible = (root)=>{
    const me = (root && root.currentUserEmail ? root.currentUserEmail : '').toLowerCase();
    if (!me) return [];
    const scope = root && root.remindersScope === 'shared' ? 'shared' : 'private';
    return (root && root.reminders || []).filter((r)=>{
        if (!r) return false;
        if (scope === 'shared') return r.visibility === 'shared';
        return r.visibility !== 'shared' && (r.ownerEmail || '').toLowerCase() === me;
    });
};
const $4365fc43c49e0bd1$export$6d99fc022c96ba87 = function(root, r) {
    const rt = root || this && this.state && this.state.root;
    const me = (rt && rt.currentUserEmail ? rt.currentUserEmail : '').toLowerCase();
    return !!me && (r && r.ownerEmail || '').toLowerCase() === me;
};
const $4365fc43c49e0bd1$export$d1af97dc8b1a7048 = function(root, title) {
    const rt = root || this && this.state && this.state.root;
    const people = rt && rt.people || [];
    const me = (rt && rt.currentUserEmail ? rt.currentUserEmail : '').toLowerCase();
    const found = new Set();
    const re = /@([\p{L}\p{N}._-]+(?:\s+[\p{L}\p{N}._-]+)?)/gu;
    let m;
    while(m = re.exec(title || '')){
        const two = m[1].toLowerCase();
        const one = two.split(/\s+/)[0];
        for (const cand of [
            two,
            one
        ]){
            const hit = people.find((p)=>{
                const name = (p.name || '').toLowerCase();
                const first = name.split(/\s+/)[0];
                const local = (p.email || '').split('@')[0].toLowerCase();
                return name === cand || first === cand || local === cand;
            });
            if (hit && (hit.email || '').toLowerCase() !== me) {
                found.add(hit.email);
                break;
            }
        }
    }
    return [
        ...found
    ];
};
const $4365fc43c49e0bd1$export$237deebceb0c51a0 = async function(payload) {
    const root = this && this.state && this.state.root;
    const fetch = this && this.context && this.context.fetch;
    if (!root) return null;
    const title = (payload && payload.title || '').trim();
    if (!title) return null;
    const me = root.currentUserEmail || '';
    const tempId = $4365fc43c49e0bd1$var$_tempId();
    const now = $4365fc43c49e0bd1$var$_nowIso();
    const dueAt = payload && payload.dueAt || null;
    const notes = payload && payload.notes || '';
    const visibility = (payload && payload.visibility) === 'shared' ? 'shared' : 'private';
    const mentions = $4365fc43c49e0bd1$export$d1af97dc8b1a7048.call(this, root, title);
    const optimistic = {
        id: tempId,
        key: tempId,
        title: title,
        done: false,
        dueAt: dueAt,
        notes: notes,
        ownerEmail: me,
        visibility: visibility,
        mentions: mentions,
        notifiedAt: null,
        createdAt: now,
        updatedAt: now
    };
    root.update({
        reminders: [
            ...root.reminders || [],
            optimistic
        ]
    });
    if (!fetch || !fetch.insert) {
        $4365fc43c49e0bd1$var$_logErr('createReminder', 'context.fetch.insert missing');
        return null;
    }
    try {
        const wsId = $4365fc43c49e0bd1$export$86b5f1774b232d9.call(this, root);
        const result = await fetch.insert({
            from: 'workspaceProject.records',
            ...wsId ? {
                params: {
                    workspaceId: wsId
                }
            } : {},
            data: {
                collection: $4365fc43c49e0bd1$var$COLLECTION,
                name: title,
                data: {
                    done: false,
                    dueAt: dueAt,
                    notes: notes,
                    ownerEmail: me,
                    visibility: visibility,
                    mentions: mentions
                }
            }
        });
        if (result && result.error) throw result.error;
        const real = $4365fc43c49e0bd1$export$422c1302f0a51a03(result && result.data);
        if (!real.id) throw new Error('insert returned no id');
        root.update({
            reminders: (root.reminders || []).map((r)=>r.id === tempId ? real : r)
        });
        // Notify every @mentioned teammate (createNotification self-guards, so
        // the author can never notify themselves). Fire-and-forget — a failed
        // notification must not fail the create.
        for (const email of mentions)try {
            this.call('createNotification', {
                userEmail: email,
                type: 'mention',
                title: this.call('polyglot', 'workspace.reminders.mentionTitle').replace('{name}', me),
                body: title + (notes ? ` \u{2014} ${notes}` : ''),
                href: '/reminders'
            });
        } catch (_) {
        /* fire-and-forget */ }
        return real.id;
    } catch (err) {
        $4365fc43c49e0bd1$var$_logErr('createReminder', err);
        // Roll back the optimistic row AND hand the typed text back to the
        // composer — losing the draft on a failed insert forces a retype.
        root.update({
            reminders: (root.reminders || []).filter((r)=>r.id !== tempId),
            _reminderDraft: title,
            _reminderDraftDue: dueAt
        });
        this.call('openNotification', {
            title: this.call('polyglot', 'workspace.reminders.addFailed'),
            message: err && err.message || this.call('polyglot', 'workspace.reminders.tryAgain'),
            type: 'error'
        });
        return null;
    }
};
const $4365fc43c49e0bd1$export$10b8b4e15357c1ca = async function(id) {
    const root = this && this.state && this.state.root;
    const fetch = this && this.context && this.context.fetch;
    if (!root || !id) return;
    const list = root.reminders || [];
    const current = list.find((r)=>r.id === id);
    if (!current) return;
    const nextDone = !current.done;
    const now = $4365fc43c49e0bd1$var$_nowIso();
    root.update({
        reminders: list.map((r)=>r.id === id ? {
                ...r,
                done: nextDone,
                updatedAt: now
            } : r)
    });
    if ($4365fc43c49e0bd1$var$_isTempId(id) || !fetch || !fetch.update) return;
    try {
        const wsId = $4365fc43c49e0bd1$export$86b5f1774b232d9.call(this, root);
        const result = await fetch.update({
            from: 'workspaceProject.records',
            params: {
                id: id,
                ...wsId ? {
                    workspaceId: wsId
                } : {}
            },
            data: {
                data: {
                    done: nextDone
                }
            }
        });
        if (result && result.error) throw result.error;
    } catch (err) {
        $4365fc43c49e0bd1$var$_logErr('toggleReminder', err);
        root.update({
            reminders: (root.reminders || []).map((r)=>r.id === id ? {
                    ...r,
                    done: current.done,
                    updatedAt: current.updatedAt
                } : r)
        });
        this.call('openNotification', {
            title: this.call('polyglot', 'workspace.reminders.updateFailed'),
            message: err && err.message || this.call('polyglot', 'workspace.reminders.tryAgain'),
            type: 'error'
        });
    }
};
const $4365fc43c49e0bd1$export$248ace6cab211eb2 = async function(id) {
    const root = this && this.state && this.state.root;
    const fetch = this && this.context && this.context.fetch;
    if (!root || !id) return;
    const list = root.reminders || [];
    const removed = list.find((r)=>r.id === id);
    root.update({
        reminders: list.filter((r)=>r.id !== id)
    });
    if ($4365fc43c49e0bd1$var$_isTempId(id) || !fetch || !fetch.delete) return;
    try {
        const wsId = $4365fc43c49e0bd1$export$86b5f1774b232d9.call(this, root);
        const result = await fetch.delete({
            from: 'workspaceProject.records',
            params: {
                id: id,
                ...wsId ? {
                    workspaceId: wsId
                } : {}
            }
        });
        if (result && result.error) throw result.error;
    } catch (err) {
        $4365fc43c49e0bd1$var$_logErr('deleteReminder', err);
        if (removed) root.update({
            reminders: [
                ...root.reminders || [],
                removed
            ]
        });
        this.call('openNotification', {
            title: this.call('polyglot', 'workspace.reminders.deleteFailed'),
            message: err && err.message || this.call('polyglot', 'workspace.reminders.tryAgain'),
            type: 'error'
        });
    }
};
const $4365fc43c49e0bd1$export$eab7ef461c24d461 = function(id) {
    const root = this && this.state && this.state.root;
    if (!root || !id) return;
    const r = (root.reminders || []).find((x)=>x && x.id === id);
    if (!r || !$4365fc43c49e0bd1$export$6d99fc022c96ba87(root, r)) return;
    const name = String(r.title || '').trim();
    this.call('confirmDialog', {
        title: name ? this.call('polyglot', 'workspace.reminders.deleteTitle').replace('{name}', ()=>name) : this.call('polyglot', 'workspace.ctxMenu.reminder.deleteConfirm'),
        message: this.call('polyglot', r.visibility === 'shared' ? 'workspace.reminders.deleteSharedBody' : 'workspace.ctxMenu.reminder.deleteBody'),
        confirmText: this.call('polyglot', 'workspace.ctxMenu.reminder.deleteCta'),
        cancelText: this.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: ()=>this.call('deleteReminder', id)
    });
};
const $4365fc43c49e0bd1$export$f5b42809a2e5500e = function(id) {
    const root = this && this.state && this.state.root;
    if (!root || !id) return;
    const r = (root.reminders || []).find((x)=>x && x.id === id);
    if (!r || !$4365fc43c49e0bd1$export$6d99fc022c96ba87(root, r)) return;
    this.call('confirmDialog', {
        title: this.call('polyglot', 'workspace.ctxMenu.reminder.toTicketConfirm'),
        message: this.call('polyglot', 'workspace.ctxMenu.reminder.toTicketBody'),
        confirmText: this.call('polyglot', 'workspace.ctxMenu.reminder.toTicketCta'),
        cancelText: this.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>this.call('convertReminderToTask', id)
    });
};
const $4365fc43c49e0bd1$var$_FILTERS = new Set([
    'all',
    'today',
    'upcoming',
    'completed'
]);
const $4365fc43c49e0bd1$export$d846bfd276f0cbf2 = function(key) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    root.update({
        _remindersFilter: $4365fc43c49e0bd1$var$_FILTERS.has(key) ? key : 'all'
    });
};
const $4365fc43c49e0bd1$var$_startOfDay = (d)=>new Date(d.getFullYear(), d.getMonth(), d.getDate());
const $4365fc43c49e0bd1$var$_dayDiff = (dueAt)=>{
    const d = new Date(dueAt);
    if (Number.isNaN(d.getTime())) return null;
    return Math.round(($4365fc43c49e0bd1$var$_startOfDay(d) - $4365fc43c49e0bd1$var$_startOfDay(new Date())) / 86400000);
};
const $4365fc43c49e0bd1$export$a465112fe215870f = function(dueAt) {
    if (!dueAt) return null;
    const d = new Date(dueAt);
    if (Number.isNaN(d.getTime())) return null;
    const diff = $4365fc43c49e0bd1$var$_dayDiff(dueAt);
    if (diff == null) return null;
    if (diff < 0) return this.call('polyglot', 'workspace.reminders.due.overdue').replace('{count}', Math.abs(diff));
    if (diff === 0) {
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        return this.call('polyglot', 'workspace.reminders.due.today').replace('{time}', `${hh}:${mm}`);
    }
    if (diff === 1) return this.call('polyglot', 'workspace.reminders.due.tomorrow');
    // The SESSION language (shared localizedDate); this was pinned to en-US, so a
    // Georgian reminder read `Wed, Aug 19`.
    const out = this.call('localizedDate', d, {
        weekday: 'short',
        month: 'short',
        day: 'numeric'
    });
    return typeof out === 'string' && out ? out : `${d.toLocaleDateString('en-US', {
        weekday: 'short'
    })}, ${d.toLocaleDateString('en-US', {
        month: 'short'
    })} ${d.getDate()}`;
};
const $4365fc43c49e0bd1$export$4d5c6b2292db9d5 = (dueAt, done)=>{
    if (done || !dueAt) return false;
    const diff = $4365fc43c49e0bd1$var$_dayDiff(dueAt);
    return diff != null && diff < 0;
};
const $4365fc43c49e0bd1$var$_sortByDue = (a, b)=>{
    if (!a.dueAt && !b.dueAt) return (a.title || '').localeCompare(b.title || '');
    if (!a.dueAt) return 1;
    if (!b.dueAt) return -1;
    return new Date(a.dueAt) - new Date(b.dueAt);
};
const $4365fc43c49e0bd1$export$358752ecb2f68392 = (root)=>{
    const all = $4365fc43c49e0bd1$var$_shellVisible(root);
    const open = all.filter((r)=>!r.done);
    const done = all.filter((r)=>r.done);
    const filter = root && root._remindersFilter || 'all';
    const overdue = [];
    const today = [];
    const tomorrow = [];
    const upcoming = [];
    const noDate = [];
    for (const r of open){
        const diff = r.dueAt ? $4365fc43c49e0bd1$var$_dayDiff(r.dueAt) : null;
        if (diff == null) noDate.push(r);
        else if (diff < 0) overdue.push(r);
        else if (diff === 0) today.push(r);
        else if (diff === 1) tomorrow.push(r);
        else upcoming.push(r);
    }
    [
        overdue,
        today,
        tomorrow,
        upcoming
    ].forEach((arr)=>arr.sort($4365fc43c49e0bd1$var$_sortByDue));
    noDate.sort((a, b)=>(a.title || '').localeCompare(b.title || ''));
    done.sort((a, b)=>new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0));
    const ALL_GROUPS = [
        {
            key: 'overdue',
            label: 'workspace.reminders.group.overdue',
            tone: 'error',
            items: overdue
        },
        {
            key: 'today',
            label: 'workspace.reminders.group.today',
            items: today
        },
        {
            key: 'tomorrow',
            label: 'workspace.reminders.group.tomorrow',
            items: tomorrow
        },
        {
            key: 'upcoming',
            label: 'workspace.reminders.group.upcoming',
            items: upcoming
        },
        {
            key: 'nodate',
            label: 'workspace.reminders.group.noDate',
            items: noDate
        },
        {
            key: 'completed',
            label: 'workspace.reminders.group.completed',
            muted: true,
            items: done
        }
    ];
    let picked;
    if (filter === 'today') picked = ALL_GROUPS.filter((g)=>g.key === 'overdue' || g.key === 'today');
    else if (filter === 'upcoming') picked = ALL_GROUPS.filter((g)=>g.key === 'tomorrow' || g.key === 'upcoming');
    else if (filter === 'completed') picked = ALL_GROUPS.filter((g)=>g.key === 'completed');
    else picked = ALL_GROUPS;
    return picked.filter((g)=>g.items.length);
};
const $4365fc43c49e0bd1$export$e04673c3de24a793 = (root)=>{
    const all = $4365fc43c49e0bd1$var$_shellVisible(root);
    const open = all.filter((r)=>!r.done);
    const done = all.filter((r)=>r.done);
    let today = 0;
    let upcoming = 0;
    for (const r of open){
        if (!r.dueAt) continue;
        const diff = $4365fc43c49e0bd1$var$_dayDiff(r.dueAt);
        if (diff == null) continue;
        if (diff <= 0) today += 1;
        else upcoming += 1;
    }
    return {
        all: all.length,
        today: today,
        upcoming: upcoming,
        completed: done.length
    };
};
const $4365fc43c49e0bd1$export$439b1a261d07ed52 = function(scope) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const next = scope === 'shared' ? 'shared' : 'private';
    if (root.remindersScope === next && !!root._reminderDraftShared === (next === 'shared')) return;
    root.update({
        remindersScope: next,
        _reminderDraftShared: next === 'shared'
    });
};
const $4365fc43c49e0bd1$export$b0ebe504956e5716 = function(root) {
    const t = (k)=>this.call('polyglot', k);
    if (root && root._remindersLoadError) return t('workspace.reminders.empty.notEnabled');
    const filter = root && root._remindersFilter || 'all';
    if (filter === 'today') return t('workspace.reminders.empty.today');
    if (filter === 'upcoming') return t('workspace.reminders.empty.upcoming');
    if (filter === 'completed') return t('workspace.reminders.empty.completed');
    return t(root && root.remindersScope === 'shared' ? 'workspace.reminders.empty.shared' : 'workspace.reminders.empty.private');
};
// Quick-chip due values (Today / Tomorrow / Next week), all defaulted to a
// 9am local reminder time — a plain, predictable v1 default.
const $4365fc43c49e0bd1$var$_atNineAm = (date)=>{
    const d = new Date(date);
    d.setHours(9, 0, 0, 0);
    return d;
};
const $4365fc43c49e0bd1$export$82ca138ebee6844b = (kind)=>{
    const now = new Date();
    if (kind === 'today') return $4365fc43c49e0bd1$var$_atNineAm(now).toISOString();
    if (kind === 'tomorrow') {
        const d = new Date(now);
        d.setDate(d.getDate() + 1);
        return $4365fc43c49e0bd1$var$_atNineAm(d).toISOString();
    }
    if (kind === 'nextWeek') {
        const d = new Date(now);
        d.setDate(d.getDate() + 7);
        return $4365fc43c49e0bd1$var$_atNineAm(d).toISOString();
    }
    return null;
};
const $4365fc43c49e0bd1$export$eb2ef3c99c97296 = (root)=>{
    const iso = root && root._reminderDraftDue;
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n)=>String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
const $4365fc43c49e0bd1$export$54398903120291c0 = function(localValue) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    if (!localValue) {
        root.update({
            _reminderDraftDue: null
        });
        return;
    }
    const d = new Date(localValue);
    if (Number.isNaN(d.getTime())) return;
    root.update({
        _reminderDraftDue: d.toISOString()
    });
};
const $4365fc43c49e0bd1$export$6b0d437e0a8885a5 = function() {
    const root = this && this.state && this.state.root;
    if (!root) return;
    root.update({
        _reminderDraftDue: null
    });
};
const $4365fc43c49e0bd1$export$6e0bfd7d1b16853e = async function() {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const title = (root._reminderDraft || '').trim();
    if (!title) return;
    const dueAt = root._reminderDraftDue || null;
    const visibility = root._reminderDraftShared ? 'shared' : 'private';
    root.update({
        _reminderDraft: '',
        _reminderDraftDue: null,
        _reminderDraftShared: false,
        _reminderMentionQuery: null
    });
    await this.call('createReminder', {
        title: title,
        dueAt: dueAt,
        visibility: visibility
    });
};
const $4365fc43c49e0bd1$export$5c868fefd7ca3d94 = function(value) {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const m = /@([\p{L}\p{N}._-]*)$/u.exec(value || '');
    const next = m ? m[1].toLowerCase() : null;
    if ((root._reminderMentionQuery || null) !== next) root.update({
        _reminderMentionQuery: next
    });
};
const $4365fc43c49e0bd1$export$849afc1a2c9b7b50 = function(root) {
    const rt = root || this && this.state && this.state.root;
    const q = rt && rt._reminderMentionQuery;
    if (q == null) return [];
    const me = (rt.currentUserEmail || '').toLowerCase();
    return (rt && rt.people || []).filter((p)=>(p.email || '').toLowerCase() !== me).filter((p)=>{
        if (!q) return true;
        const name = (p.name || '').toLowerCase();
        const local = (p.email || '').split('@')[0].toLowerCase();
        return name.includes(q) || local.includes(q);
    }).slice(0, 6);
};
const $4365fc43c49e0bd1$export$a8adfff57cca0f1a = function(person) {
    const root = this && this.state && this.state.root;
    if (!root || !person) return;
    const first = ((person.name || person.email || '').split(/\s+/)[0] || '').trim();
    const draft = root._reminderDraft || '';
    root.update({
        _reminderDraft: draft.replace(/@([\p{L}\p{N}._-]*)$/u, `@${first} `),
        _reminderMentionQuery: null
    });
};
const $4365fc43c49e0bd1$export$b4620d72e4e32ee3 = function() {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const next = !root._reminderDraftShared;
    root.update({
        _reminderDraftShared: next,
        remindersScope: next ? 'shared' : 'private'
    });
};
const $4365fc43c49e0bd1$export$997d55a32893e8b6 = async function(id) {
    const root = this && this.state && this.state.root;
    if (!root || !id) return;
    const r = (root.reminders || []).find((x)=>x.id === id);
    // Owner-only (it deletes the reminder): the same rule as the delete.
    if (!r || !$4365fc43c49e0bd1$export$6d99fc022c96ba87(root, r)) return;
    try {
        const created = await this.call('saveTicket', {
            title: r.title,
            description: r.notes || '',
            columnKey: 'backlog'
        });
        if (!created) throw new Error('ticket create returned nothing');
        await this.call('deleteReminder', id);
        this.call('openNotification', {
            type: 'success',
            title: this.call('polyglot', 'workspace.reminders.converted'),
            message: r.title,
            href: '/tasks'
        });
    } catch (err) {
        $4365fc43c49e0bd1$var$_logErr('convertReminderToTask', err);
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'workspace.reminders.convertFailed'),
            message: err && err.message || this.call('polyglot', 'workspace.reminders.tryAgain')
        });
    }
};
const $4365fc43c49e0bd1$export$738dd150df2f7804 = function(id) {
    const root = this && this.state && this.state.root;
    if (!root || !id) return;
    const r = (root.reminders || []).find((x)=>x.id === id);
    if (!r) return;
    const overrides = {
        title: r.title,
        description: r.notes || ''
    };
    if (r.dueAt) {
        const d = new Date(r.dueAt);
        if (!Number.isNaN(d.getTime())) {
            const pad = (n)=>String(n).padStart(2, '0');
            overrides.date = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
            overrides.startTime = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
            const end = new Date(d.getTime() + 3600000);
            overrides.endTime = `${pad(end.getHours())}:${pad(end.getMinutes())}`;
        }
    }
    this.call('openNewBookingModal', overrides);
};
// ── Due-time notifications ──────────────────────────────────────────────
// Sweeps MY open reminders whose dueAt has passed and that haven't fired
// yet (notifiedAt guard persists via the records PATCH so other devices /
// later sessions don't re-fire). Local toast + chime immediately; a bell
// row is written through the notifications entity so the center shows it
// too. Throttled internally so callers can invoke it freely.
// WS-SWITCH-MEMO-PLANE-1: the throttle is TENANT-KEYED, not a single scalar.
// `_mine(root)` reads `root.reminders`, which the workspace switch wipes and
// refetches — but the throttle was one module-level number, so the sweep's
// "already ran" verdict survived the switch. Land inside the window and
// workspace B's already-overdue reminders fired NO toast, NO chime and NO bell
// row until the stamp aged out. Keying by `${currentUserEmail}|${wsId}` makes
// the new tenant a natural MISS — no teardown call to remember, the pattern
// `_dashCache` (analytics) and `NOTIF_SCOPE` (notifications) already use here.
// Bounded so a long session across many workspaces cannot grow it without end.
const $4365fc43c49e0bd1$var$_dueSweepLast = new Map();
const $4365fc43c49e0bd1$var$_DUE_SWEEP_MS = 55000;
const $4365fc43c49e0bd1$var$_DUE_SWEEP_MAX_SCOPES = 50;
const $4365fc43c49e0bd1$var$_dueSweepScope = function(root) {
    const me = root && root.currentUserEmail || '';
    let wsId = null;
    try {
        wsId = $4365fc43c49e0bd1$export$86b5f1774b232d9.call(this, root);
    } catch (_) {
        wsId = null;
    }
    // An unresolved workspace is a DIFFERENT scope, never a shared one — the
    // '' / 'anon' fallback shape this ticket names as the one way these regress.
    return `${me}|${wsId == null ? '' : String(wsId)}`;
};
const $4365fc43c49e0bd1$export$c8e998f8bdcd1802 = async function() {
    const root = this && this.state && this.state.root;
    const fetch = this && this.context && this.context.fetch;
    if (!root || !fetch || !fetch.update) return;
    const nowMs = Date.now();
    const scope = $4365fc43c49e0bd1$var$_dueSweepScope.call(this, root);
    const last = $4365fc43c49e0bd1$var$_dueSweepLast.get(scope) || 0;
    if (nowMs - last < $4365fc43c49e0bd1$var$_DUE_SWEEP_MS) return;
    if ($4365fc43c49e0bd1$var$_dueSweepLast.size >= $4365fc43c49e0bd1$var$_DUE_SWEEP_MAX_SCOPES && !$4365fc43c49e0bd1$var$_dueSweepLast.has(scope)) $4365fc43c49e0bd1$var$_dueSweepLast.delete($4365fc43c49e0bd1$var$_dueSweepLast.keys().next().value);
    $4365fc43c49e0bd1$var$_dueSweepLast.set(scope, nowMs);
    const me = root.currentUserEmail || '';
    if (!me) return;
    const due = $4365fc43c49e0bd1$var$_mine(root).filter((r)=>!r.done && r.dueAt && new Date(r.dueAt).getTime() <= nowMs && (!r.notifiedAt || new Date(r.notifiedAt) < new Date(r.dueAt)));
    for (const r of due){
        const stamp = $4365fc43c49e0bd1$var$_nowIso();
        // Optimistic local guard first so a slow PATCH can't double-fire within
        // this session.
        root.update({
            reminders: (root.reminders || []).map((x)=>x.id === r.id ? {
                    ...x,
                    notifiedAt: stamp
                } : x)
        });
        this.call('openNotification', {
            type: 'info',
            title: this.call('polyglot', 'workspace.reminders.due'),
            message: r.title + (r.notes ? ` \u{2014} ${r.notes}` : ''),
            icon: 'bell',
            sound: true,
            href: '/reminders'
        });
        try {
            const wsId = $4365fc43c49e0bd1$export$86b5f1774b232d9.call(this, root);
            await fetch.update({
                from: 'workspaceProject.records',
                params: {
                    id: r.id,
                    ...wsId ? {
                        workspaceId: wsId
                    } : {}
                },
                data: {
                    data: {
                        notifiedAt: stamp
                    }
                }
            });
        } catch (err) {
            $4365fc43c49e0bd1$var$_logErr('reminderDueSweep', err);
        }
        // Bell-center row (self-targeted, so the guarded createNotification
        // shared fn can't be used — write the entity directly, fire-and-forget).
        try {
            const sdk = this.sdk || this.context && this.context.sdk;
            if (sdk && typeof sdk.execute === 'function') await sdk.execute('workspaceProject.notifications', 'create', {
                payload: {
                    user_email: me,
                    type: 'reminder',
                    title: this.call('polyglot', 'workspace.reminders.due'),
                    body: r.title,
                    href: '/reminders'
                }
            });
        } catch (_) {
        /* fire-and-forget */ }
    }
};

});

parcelRegister("fRtNs", function(module, exports) {

$parcel$export(module.exports, "openAppContextMenu", () => $b8c2eb3c2e027830$export$8c480940cf50073);
$parcel$export(module.exports, "appContextMenuItems", () => $b8c2eb3c2e027830$export$d8ff5d7b406b0f89);
$parcel$export(module.exports, "appContextMenuAction", () => $b8c2eb3c2e027830$export$3967439d467514f2);
// Native Workspace app context menus. The shell owns the single
// ContextDropdown instance; this module only supplies focused actions for
// native app records and a common opener for visible "more" controls,
// right-click, and touch long-press.
const $b8c2eb3c2e027830$var$_sameId = (left, right)=>String(left || '') === String(right || '');
const $b8c2eb3c2e027830$var$_reminderFor = (root, id)=>(root?.reminders || []).find((item)=>$b8c2eb3c2e027830$var$_sameId(item?.id, id));
const $b8c2eb3c2e027830$var$_broadcastFor = (root, id)=>(root?.announcements || []).find((item)=>$b8c2eb3c2e027830$var$_sameId(item?.id, id));
const $b8c2eb3c2e027830$var$_ownsReminder = (root, reminder)=>{
    const me = String(root?.currentUserEmail || '').toLowerCase();
    return !!me && me === String(reminder?.ownerEmail || '').toLowerCase();
};
const $b8c2eb3c2e027830$var$_shellClose = (root)=>root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
const $b8c2eb3c2e027830$var$_menuNotify = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (_) {
    /* notifications are advisory only */ }
};
const $b8c2eb3c2e027830$export$8c480940cf50073 = function openAppContextMenu(event, appContext, options = {}) {
    const root = this?.state?.root;
    if (!root || !appContext?.kind) return;
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const rect = this.node?.getBoundingClientRect?.();
    const anchor = !!options.anchor;
    const x = anchor && rect ? rect.right : Number(event?.clientX) || rect?.left || 0;
    const y = anchor && rect ? rect.bottom : Number(event?.clientY) || rect?.bottom || 0;
    const active = root.contextDropdown?.appContextMenu;
    if (root.contextDropdown?.open && active?.kind === appContext.kind && $b8c2eb3c2e027830$var$_sameId(active?.id, appContext.id)) {
        $b8c2eb3c2e027830$var$_shellClose(root);
        return;
    }
    root.update({
        contextDropdown: {
            open: true,
            x: x,
            y: y,
            itemsFn: 'appContextMenuItems',
            actionFn: 'appContextMenuAction',
            appContextMenu: {
                kind: appContext.kind,
                id: appContext.id || null
            }
        }
    }, {
        preventFetch: true
    });
};
const $b8c2eb3c2e027830$export$d8ff5d7b406b0f89 = function appContextMenuItems(root) {
    const context = root?.contextDropdown?.appContextMenu;
    if (!context?.kind) return [];
    if (context.kind === 'reminder') {
        const reminder = $b8c2eb3c2e027830$var$_reminderFor(root, context.id);
        if (!reminder) return [];
        const items = [
            {
                key: 'reminder-toggle',
                action: 'reminder-toggle',
                label: reminder.done ? 'workspace.ctxMenu.reminder.markOpen' : 'workspace.ctxMenu.reminder.markDone',
                icon: reminder.done ? 'reload' : 'checkmark'
            },
            {
                key: 'reminder-divider-actions',
                divider: true
            }
        ];
        // "Convert to ticket…" deletes the reminder once the ticket exists, so it
        // is the owner's, like Delete (functions/reminders.js
        // confirmConvertReminderToTask).
        if ($b8c2eb3c2e027830$var$_ownsReminder(root, reminder)) items.push({
            key: 'reminder-ticket',
            action: 'reminder-ticket',
            label: 'workspace.ctxMenu.reminder.toTicket',
            icon: 'checkOval'
        });
        items.push({
            key: 'reminder-event',
            action: 'reminder-event',
            label: 'workspace.ctxMenu.reminder.toEvent',
            icon: 'dateOutline'
        });
        if ($b8c2eb3c2e027830$var$_ownsReminder(root, reminder)) items.push({
            key: 'reminder-divider-danger',
            divider: true
        }, {
            key: 'reminder-delete',
            action: 'reminder-delete',
            label: 'workspace.ctxMenu.reminder.delete',
            icon: 'trash',
            danger: true
        });
        return items;
    }
    if (context.kind === 'broadcast') {
        const post = $b8c2eb3c2e027830$var$_broadcastFor(root, context.id);
        if (!post) return [];
        let canEdit = false;
        try {
            canEdit = !!this.call('canEditBroadcast', post, root);
        } catch (_) {
            canEdit = false;
        }
        const items = [
            {
                key: 'broadcast-open',
                action: 'broadcast-open',
                label: 'workspace.ctxMenu.broadcast.open'
            }
        ];
        if (canEdit) items.push({
            key: 'broadcast-edit',
            action: 'broadcast-edit',
            label: 'workspace.ctxMenu.broadcast.edit',
            icon: 'edit'
        }, {
            key: 'broadcast-divider-danger',
            divider: true
        }, {
            key: 'broadcast-delete',
            action: 'broadcast-delete',
            label: 'workspace.ctxMenu.broadcast.delete',
            icon: 'trash',
            danger: true
        });
        return items;
    }
    if (context.kind === 'system-health') return [
        {
            key: 'system-refresh',
            action: 'system-refresh',
            label: 'workspace.ctxMenu.system.refresh',
            icon: 'reload'
        },
        {
            key: 'system-divider-copy',
            divider: true
        },
        {
            key: 'system-copy-summary',
            action: 'system-copy-summary',
            label: 'workspace.ctxMenu.system.copySummary',
            icon: 'copy'
        }
    ];
    return [];
};
// The status words of the summary — the same keys the /system page's own
// STATUS table names (pages/system.js), written out so each stays greppable.
// A status this table does not know is shown as its raw id.
const $b8c2eb3c2e027830$var$_SUMMARY_STATUS_KEY = {
    healthy: 'workspace.system.status.healthy',
    degraded: 'workspace.system.status.degraded',
    building: 'workspace.system.status.building',
    failed: 'workspace.system.status.failed',
    down: 'workspace.system.status.failed',
    pending: 'workspace.system.status.pending',
    probe_error: 'workspace.system.status.probeError',
    none: 'workspace.system.status.noData'
};
// The copied summary is also the success toast's message, so every word of
// it resolves through the bundle.
const $b8c2eb3c2e027830$var$_systemSummary = (root, el)=>{
    const counts = new Map();
    for (const cell of Object.values(root?.systemMatrix || {})){
        const status = String(cell?.status || 'none');
        counts.set(status, (counts.get(status) || 0) + 1);
    }
    const details = [
        ...counts.entries()
    ].filter(([, count])=>count > 0)// A count and a status word — "3 healthy" / "3 ჯანსაღი": the pair reads
    // in this order in both shipped languages, so it needs no sentence key.
    .map(([status, count])=>`${count} ${el.call('polyglot', $b8c2eb3c2e027830$var$_SUMMARY_STATUS_KEY[status] || status)}`).join(', ');
    return el.call('polyglot', 'workspace.ctxMenu.system.summary').replace('{details}', details || el.call('polyglot', 'workspace.ctxMenu.system.summaryEmpty'));
};
const $b8c2eb3c2e027830$var$_copySystemSummary = async (el, root)=>{
    const summary = $b8c2eb3c2e027830$var$_systemSummary(root, el);
    try {
        if (typeof navigator === 'undefined' || !navigator.clipboard?.writeText) throw new Error('Clipboard is unavailable');
        await navigator.clipboard.writeText(summary);
        $b8c2eb3c2e027830$var$_menuNotify(el, {
            type: 'success',
            title: el.call('polyglot', 'workspace.ctxMenu.system.copied'),
            message: summary
        });
    } catch (_) {
        $b8c2eb3c2e027830$var$_menuNotify(el, {
            type: 'error',
            title: el.call('polyglot', 'workspace.ctxMenu.system.copyFailed'),
            message: el.call('polyglot', 'workspace.ctxMenu.system.copyFailedBody')
        });
    }
};
const $b8c2eb3c2e027830$export$3967439d467514f2 = async function appContextMenuAction(action) {
    const root = this?.state?.root;
    const context = root?.contextDropdown?.appContextMenu;
    if (!root || !context) return;
    $b8c2eb3c2e027830$var$_shellClose(root);
    if (context.kind === 'reminder') {
        const reminder = $b8c2eb3c2e027830$var$_reminderFor(root, context.id);
        if (!reminder) return;
        if (action === 'reminder-toggle') {
            this.call('toggleReminder', reminder.id);
            return;
        }
        // The row's icons open the same two asks (functions/reminders.js), so a
        // reminder has ONE delete confirm and ONE convert confirm.
        if (action === 'reminder-ticket') {
            this.call('confirmConvertReminderToTask', reminder.id);
            return;
        }
        if (action === 'reminder-event') {
            this.call('convertReminderToEvent', reminder.id);
            return;
        }
        if (action === 'reminder-delete' && $b8c2eb3c2e027830$var$_ownsReminder(root, reminder)) this.call('confirmDeleteReminder', reminder.id);
        return;
    }
    if (context.kind === 'broadcast') {
        const post = $b8c2eb3c2e027830$var$_broadcastFor(root, context.id);
        if (!post) return;
        if (action === 'broadcast-open') {
            this.call('openBroadcastDetail', post);
            return;
        }
        let canEdit = false;
        try {
            canEdit = !!this.call('canEditBroadcast', post, root);
        } catch (_) {
            canEdit = false;
        }
        if (!canEdit) return;
        if (action === 'broadcast-edit') {
            this.call('openBroadcastComposer', post);
            return;
        }
        if (action === 'broadcast-delete') this.call('confirmDeleteBroadcast', post);
        return;
    }
    if (context.kind === 'system-health') {
        if (action === 'system-refresh') {
            root._systemHealthOps?.refresh?.();
            return;
        }
        if (action === 'system-copy-summary') await $b8c2eb3c2e027830$var$_copySystemSummary(this, root);
    }
};

});

parcelRegister("1OhIx", function(module, exports) {

$parcel$export(module.exports, "loadGettingStartedTeam", () => $15183441fe3513e7$export$c717e213bee77f27);
$parcel$export(module.exports, "gettingStartedTeamRows", () => $15183441fe3513e7$export$fe7a2680c5330cb4);
$parcel$export(module.exports, "gettingStartedDraft", () => $15183441fe3513e7$export$a53b3f9033017f27);
$parcel$export(module.exports, "gettingStartedEmailOk", () => $15183441fe3513e7$export$18057be9899e6dd3);
$parcel$export(module.exports, "gettingStartedOnDomain", () => $15183441fe3513e7$export$63caefeb800d6f19);
$parcel$export(module.exports, "setGettingStartedEmail", () => $15183441fe3513e7$export$3f3278ce1acda9a2);
$parcel$export(module.exports, "toggleGettingStartedInvite", () => $15183441fe3513e7$export$c59ae184f1323485);
$parcel$export(module.exports, "setGettingStartedOtherEmail", () => $15183441fe3513e7$export$a249f23c77efeb99);
$parcel$export(module.exports, "gettingStartedInviteCount", () => $15183441fe3513e7$export$3e9f60e9f8af1a7f);
$parcel$export(module.exports, "sendGettingStartedInvites", () => $15183441fe3513e7$export$aaefafcc594481bb);
$parcel$export(module.exports, "removeGettingStartedPerson", () => $15183441fe3513e7$export$45aace56f4c341a8);
$parcel$export(module.exports, "setGettingStartedDomainJoin", () => $15183441fe3513e7$export$cf4ed4f3cfea0233);
$parcel$export(module.exports, "toggleGettingStartedWhy", () => $15183441fe3513e7$export$bbb40abe089ce530);
$parcel$export(module.exports, "gettingStartedTeamSource", () => $15183441fe3513e7$export$e1ecc194be44eb8a);
$parcel$export(module.exports, "gettingStartedSurfaceFor", () => $15183441fe3513e7$export$31868d2ff5fb45cf);
// Getting started → Team — the data behind /getting-started/team (POB S9,
// pages/gettingStartedTeam.js): the people the onboarding research read off
// the company's OWN team page after sign-up, the owner's invites to them, and
// the company-domain join switch. The onboarding lane owns the server and
// these SDK names (POB plan §7b-3):
//   listOnboardingPeople(wsId)  → { people: [{ id, name, role, sourceUrl,
//                                  fetchedAt, expiresAt, invitedAt }],
//                                  domain, domainMatchesOwner }
//   removeOnboardingPerson(wsId, personId)               → { removed: true }
//   inviteOnboardingPerson(wsId, personId, { email, recipientName })
//                               → { invitation, person } — the server sends
//                                 the plain workspace invite, role editor,
//                                 and marks the row used; 400 `invalid_email`
//   getDomainJoin(wsId) / setDomainJoin(wsId, enabled)
//                               → { domain, enabled, eligible };
//                                 409 `domain_not_eligible`
// Someone the research did not find goes through the existing workspace
// invite (createWorkspaceInvitation, role editor). A found person never does:
// that call drops every key but email / role / recipientName / teams, so the
// server could not mark the row used.
//
// Privacy (plan §6, picks D3 and D5): every switch starts OFF and turns ON
// only beside an e-mail the owner typed; nothing here reads, guesses or
// prefills an address; a row nobody invites expires on the server after 30
// days. The domain switch exists only when the server says the owner's own
// verified e-mail is on that domain (`eligible`).
//
// Until the server answers — the SDK has no such method yet, or the route
// answers 404/501 — the page says "Soon" and offers no button (plan §7b-2:
// no dead buttons). A 403 is the manager gate.
//
// Root keys (state-app.js, the workspace-scoped wipe): the read
// (`gettingStartedTeamStatus` idle|loading|ready|soon|denied|error,
// `gettingStartedPeople`, `gettingStartedDomain`, `gettingStartedDomainJoin`
// + its `…Status`), the owner's draft per person
// (`gettingStartedInvites` { [personId]: { email, on, status, error } } —
// every write carries all four fields, because a write REPLACES the object
// a key holds — smbls 3.14.870 store — so a left-out field would be lost),
// the "someone else" field
// (`gettingStartedOther` { email, status, error }), the send flag + its last
// result, and the "Why do I see this?" disclosure.
//
// Row fields are `person*`-named on purpose: a `childrenAs: 'state'` row
// falls back to ROOT keys for a field it does not own, and the root has its
// own `name`, `role` and `status`.

var $1X0Je = parcelRequire("1X0Je");
// Module helpers carry a `_gst` prefix: frank hoists a functions file's
// module helpers into the project's one shared scope by name.
const $15183441fe3513e7$var$_gstRootOf = (root, ctx)=>root || ctx && ctx.state && ctx.state.root || null;
// The tab's own workspace beats the session claim (it lags a switch); either
// id shape — the scopedClient.js `activeWorkspaceId` rule, copied so the
// switch tail can call these loaders without an element.
const $15183441fe3513e7$var$_gstWsId = (r)=>String(r && r.workspace && (r.workspace.id || r.workspace._id) || r && r.jwtClaims && r.jwtClaims.active_workspace_id || '');
const $15183441fe3513e7$var$_gstSdk = (seam, ctx)=>seam && seam.sdk || ctx && ctx.sdk || (0, $1X0Je.default).functions.getSDK();
const $15183441fe3513e7$var$_gstHas = (sdk, name)=>!!sdk && typeof sdk[name] === 'function';
// The SDK raises an HTTP failure with `status` and the JSON body as `cause`;
// the server names the reason in `error` (or `code`).
const $15183441fe3513e7$var$_gstCode = (err)=>err && err.cause && (err.cause.error || err.cause.code) || '';
const $15183441fe3513e7$var$_gstNotThere = (err)=>!!err && (err.status === 404 || err.status === 501);
const $15183441fe3513e7$var$_gstEmailOk = (value)=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
const $15183441fe3513e7$var$_gstDraftOf = (r, personId)=>{
    const d = r && r.gettingStartedInvites && r.gettingStartedInvites[personId] || {};
    return {
        email: typeof d.email === 'string' ? d.email : '',
        on: !!d.on,
        status: d.status || '',
        error: d.error || ''
    };
};
const $15183441fe3513e7$var$_gstPerson = (p)=>({
        personId: String(p && (p.id || p._id) || ''),
        personName: String(p && p.name || ''),
        personRole: String(p && p.role || ''),
        personSource: String(p && p.sourceUrl || ''),
        invitedAt: p && p.invitedAt || null
    });
async function $15183441fe3513e7$export$c717e213bee77f27(root, via) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r) return;
    const seam = via && typeof via === 'object' ? via : {};
    // A cold boot that settles on another workspace later re-runs the read
    // (the History loader's boot-identity rule).
    (0, $1X0Je.default).functions.onWorkspaceIdentityCorrected($15183441fe3513e7$export$c717e213bee77f27);
    const wsId = $15183441fe3513e7$var$_gstWsId(r);
    if (!wsId) {
        (0, $1X0Je.default).functions.onActiveWorkspaceFull($15183441fe3513e7$export$c717e213bee77f27);
        return;
    }
    const write = typeof seam.write === 'function' ? seam.write : (patch)=>r.update(patch);
    // A reply that outlived its workspace never lands.
    const land = (patch)=>{
        if ($15183441fe3513e7$var$_gstWsId(r) === wsId) write(patch);
    };
    const sdk = $15183441fe3513e7$var$_gstSdk(seam, this);
    if (!$15183441fe3513e7$var$_gstHas(sdk, 'listOnboardingPeople')) {
        land({
            gettingStartedTeamStatus: 'soon'
        });
        return;
    }
    land({
        gettingStartedTeamStatus: 'loading'
    });
    try {
        const [res, join] = await Promise.all([
            sdk.listOnboardingPeople(wsId),
            // The join switch is optional: no route yet = no switch, never a
            // failed page.
            $15183441fe3513e7$var$_gstHas(sdk, 'getDomainJoin') ? sdk.getDomainJoin(wsId).catch(()=>null) : null
        ]);
        const body = (res && res.data && Array.isArray(res.data.people) ? res.data : res) || {};
        const people = (Array.isArray(body.people) ? body.people : []).map($15183441fe3513e7$var$_gstPerson).filter((p)=>p.personId);
        const domain = String(body.domain || join && join.domain || '');
        land({
            gettingStartedTeamStatus: 'ready',
            gettingStartedPeople: people,
            gettingStartedDomain: domain,
            gettingStartedDomainJoin: join ? {
                domain: String(join.domain || domain),
                enabled: !!join.enabled,
                eligible: !!join.eligible
            } : null,
            gettingStartedDomainJoinStatus: ''
        });
    } catch (err) {
        if ($15183441fe3513e7$var$_gstNotThere(err)) {
            land({
                gettingStartedTeamStatus: 'soon'
            });
            return;
        }
        if (err && err.status === 403) {
            land({
                gettingStartedTeamStatus: 'denied'
            });
            return;
        }
        console.error('[getting-started/team]', err);
        land({
            gettingStartedTeamStatus: 'error'
        });
    }
}
function $15183441fe3513e7$export$fe7a2680c5330cb4(root) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    return (r && r.gettingStartedPeople || []).map((p)=>({
            personId: p.personId,
            personName: p.personName,
            personRole: p.personRole,
            personSource: p.personSource,
            invitedAt: p.invitedAt || null
        }));
}
function $15183441fe3513e7$export$a53b3f9033017f27(root, personId) {
    return $15183441fe3513e7$var$_gstDraftOf($15183441fe3513e7$var$_gstRootOf(root, this), personId);
}
function $15183441fe3513e7$export$18057be9899e6dd3(value) {
    return $15183441fe3513e7$var$_gstEmailOk(value);
}
function $15183441fe3513e7$export$63caefeb800d6f19(root, value) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    const domain = String(r && r.gettingStartedDomain || '').toLowerCase().replace(/^www\./, '');
    const email = String(value || '').trim().toLowerCase();
    if (!domain || !$15183441fe3513e7$var$_gstEmailOk(email)) return false;
    const host = email.split('@').pop();
    return host === domain || host.endsWith(`.${domain}`);
}
function $15183441fe3513e7$export$3f3278ce1acda9a2(root, personId, value) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r || !personId) return;
    const cur = $15183441fe3513e7$var$_gstDraftOf(r, personId);
    const email = String(value == null ? '' : value);
    r.update({
        gettingStartedInvites: {
            ...r.gettingStartedInvites || {},
            [personId]: {
                email: email,
                on: cur.on && $15183441fe3513e7$var$_gstEmailOk(email),
                status: '',
                error: ''
            }
        }
    });
}
function $15183441fe3513e7$export$c59ae184f1323485(root, personId) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r || !personId) return;
    const person = (r && r.gettingStartedPeople || []).find((p)=>p.personId === personId);
    if (!person || person.invitedAt) return;
    const cur = $15183441fe3513e7$var$_gstDraftOf(r, personId);
    r.update({
        gettingStartedInvites: {
            ...r.gettingStartedInvites || {},
            [personId]: {
                email: cur.email,
                on: !cur.on && $15183441fe3513e7$var$_gstEmailOk(cur.email),
                status: '',
                error: ''
            }
        }
    });
}
function $15183441fe3513e7$export$a249f23c77efeb99(root, value) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r) return;
    r.update({
        gettingStartedOther: {
            email: String(value == null ? '' : value),
            status: '',
            error: ''
        }
    });
}
function $15183441fe3513e7$export$3e9f60e9f8af1a7f(root) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r) return 0;
    const rows = (r && r.gettingStartedPeople || []).filter((p)=>{
        const d = $15183441fe3513e7$var$_gstDraftOf(r, p.personId);
        return !p.invitedAt && d.on && $15183441fe3513e7$var$_gstEmailOk(d.email);
    });
    const other = r.gettingStartedOther && r.gettingStartedOther.email || '';
    return rows.length + ($15183441fe3513e7$var$_gstEmailOk(other) ? 1 : 0);
}
async function $15183441fe3513e7$export$aaefafcc594481bb(root, via) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r || r.gettingStartedSending) return null;
    const seam = via && typeof via === 'object' ? via : {};
    const wsId = $15183441fe3513e7$var$_gstWsId(r);
    if (!wsId) return null;
    const sdk = $15183441fe3513e7$var$_gstSdk(seam, this);
    const write = typeof seam.write === 'function' ? seam.write : (patch)=>r.update(patch);
    const picked = (r && r.gettingStartedPeople || []).filter((p)=>{
        const d = $15183441fe3513e7$var$_gstDraftOf(r, p.personId);
        return !p.invitedAt && d.on && $15183441fe3513e7$var$_gstEmailOk(d.email);
    });
    const otherEmail = String(r.gettingStartedOther && r.gettingStartedOther.email || '').trim();
    const sendOther = $15183441fe3513e7$var$_gstEmailOk(otherEmail);
    if (!picked.length && !sendOther) return null;
    const sending = {
        ...r.gettingStartedInvites || {}
    };
    picked.forEach((p)=>{
        sending[p.personId] = {
            ...$15183441fe3513e7$var$_gstDraftOf(r, p.personId),
            status: 'sending',
            error: ''
        };
    });
    write({
        gettingStartedSending: true,
        gettingStartedSendResult: null,
        gettingStartedInvites: sending
    });
    const results = await Promise.all(picked.map(async (p)=>{
        const d = $15183441fe3513e7$var$_gstDraftOf(r, p.personId);
        if (!$15183441fe3513e7$var$_gstHas(sdk, 'inviteOnboardingPerson')) return {
            p: p,
            d: d,
            ok: false,
            code: 'unavailable'
        };
        try {
            const res = await sdk.inviteOnboardingPerson(wsId, p.personId, {
                email: d.email.trim(),
                recipientName: p.personName
            });
            const person = res && (res.person || res.data && res.data.person) || {};
            return {
                p: p,
                d: d,
                ok: true,
                invitedAt: person.invitedAt || new Date().toISOString()
            };
        } catch (err) {
            console.error('[getting-started/team] invite', err);
            return {
                p: p,
                d: d,
                ok: false,
                code: $15183441fe3513e7$var$_gstCode(err) || 'failed'
            };
        }
    }));
    let otherResult = null;
    if (sendOther) try {
        await sdk.createWorkspaceInvitation(wsId, {
            email: otherEmail,
            role: 'editor'
        });
        otherResult = {
            ok: true
        };
    } catch (err) {
        console.error('[getting-started/team] invite (someone else)', err);
        otherResult = {
            ok: false,
            code: $15183441fe3513e7$var$_gstCode(err) || 'failed'
        };
    }
    // A switch landed mid-send: the new workspace's slice is not ours to write.
    if ($15183441fe3513e7$var$_gstWsId(r) !== wsId) return null;
    const drafts = {
        ...r.gettingStartedInvites || {}
    };
    const invitedAt = {};
    results.forEach((x)=>{
        if (x.ok) {
            invitedAt[x.p.personId] = x.invitedAt;
            drafts[x.p.personId] = {
                email: '',
                on: false,
                status: 'sent',
                error: ''
            };
        } else drafts[x.p.personId] = {
            email: x.d.email,
            on: true,
            status: 'failed',
            error: x.code
        };
    });
    const sent = results.filter((x)=>x.ok).length + (otherResult && otherResult.ok ? 1 : 0);
    const failed = results.length - results.filter((x)=>x.ok).length + (otherResult && !otherResult.ok ? 1 : 0);
    write({
        gettingStartedSending: false,
        gettingStartedPeople: (r && r.gettingStartedPeople || []).map((p)=>invitedAt[p.personId] ? {
                ...p,
                invitedAt: invitedAt[p.personId]
            } : p),
        gettingStartedInvites: drafts,
        ...otherResult ? {
            gettingStartedOther: otherResult.ok ? {
                email: '',
                status: 'sent',
                error: ''
            } : {
                email: otherEmail,
                status: 'failed',
                error: otherResult.code
            }
        } : {},
        gettingStartedSendResult: {
            sent: sent,
            failed: failed
        }
    });
    return {
        sent: sent,
        failed: failed
    };
}
async function $15183441fe3513e7$export$45aace56f4c341a8(root, personId, via) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r || !personId) return false;
    const seam = via && typeof via === 'object' ? via : {};
    const wsId = $15183441fe3513e7$var$_gstWsId(r);
    const sdk = $15183441fe3513e7$var$_gstSdk(seam, this);
    if (!wsId || !$15183441fe3513e7$var$_gstHas(sdk, 'removeOnboardingPerson')) return false;
    const write = typeof seam.write === 'function' ? seam.write : (patch)=>r.update(patch);
    const cur = $15183441fe3513e7$var$_gstDraftOf(r, personId);
    write({
        gettingStartedInvites: {
            ...r.gettingStartedInvites || {},
            [personId]: {
                ...cur,
                status: 'removing',
                error: ''
            }
        }
    });
    try {
        await sdk.removeOnboardingPerson(wsId, personId);
    } catch (err) {
        console.error('[getting-started/team] remove', err);
        if ($15183441fe3513e7$var$_gstWsId(r) === wsId) write({
            gettingStartedInvites: {
                ...r.gettingStartedInvites || {},
                [personId]: {
                    ...cur,
                    status: 'failed',
                    error: 'removeFailed'
                }
            }
        });
        return false;
    }
    if ($15183441fe3513e7$var$_gstWsId(r) !== wsId) return false;
    write({
        gettingStartedPeople: (r && r.gettingStartedPeople || []).filter((p)=>p.personId !== personId),
        gettingStartedInvites: {
            ...r.gettingStartedInvites || {},
            [personId]: {
                email: '',
                on: false,
                status: '',
                error: ''
            }
        }
    });
    return true;
}
async function $15183441fe3513e7$export$cf4ed4f3cfea0233(root, enabled, via) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    const cur = r && r.gettingStartedDomainJoin;
    if (!r || !cur || !cur.eligible) return;
    const seam = via && typeof via === 'object' ? via : {};
    const wsId = $15183441fe3513e7$var$_gstWsId(r);
    const sdk = $15183441fe3513e7$var$_gstSdk(seam, this);
    if (!wsId || !$15183441fe3513e7$var$_gstHas(sdk, 'setDomainJoin')) return;
    const write = typeof seam.write === 'function' ? seam.write : (patch)=>r.update(patch);
    write({
        gettingStartedDomainJoinStatus: 'saving'
    });
    try {
        const res = await sdk.setDomainJoin(wsId, !!enabled) || {};
        if ($15183441fe3513e7$var$_gstWsId(r) !== wsId) return;
        write({
            gettingStartedDomainJoin: {
                domain: String(res.domain || cur.domain || ''),
                enabled: !!res.enabled,
                eligible: res.eligible !== false
            },
            gettingStartedDomainJoinStatus: ''
        });
    } catch (err) {
        console.error('[getting-started/team] domain join', err);
        if ($15183441fe3513e7$var$_gstWsId(r) !== wsId) return;
        const refused = err && (err.status === 409 || $15183441fe3513e7$var$_gstCode(err) === 'domain_not_eligible');
        write({
            gettingStartedDomainJoinStatus: refused ? 'notEligible' : 'failed'
        });
    }
}
function $15183441fe3513e7$export$bbb40abe089ce530(root) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    if (!r) return;
    r.update({
        _gettingStartedWhyOpen: !r._gettingStartedWhyOpen
    });
}
function $15183441fe3513e7$export$e1ecc194be44eb8a(root) {
    const r = $15183441fe3513e7$var$_gstRootOf(root, this);
    const first = (r && r.gettingStartedPeople || []).find((p)=>p.personSource);
    const url = first && first.personSource || '';
    if (!url) return {
        url: '',
        label: ''
    };
    try {
        const u = new URL(url);
        const path = u.pathname === '/' ? '' : u.pathname.replace(/\/$/, '');
        return {
            url: url,
            label: `${u.host.replace(/^www\./, '')}${path}`
        };
    } catch (e) {
        return {
            url: url,
            label: url
        };
    }
}
function $15183441fe3513e7$export$31868d2ff5fb45cf(href) {
    const path = String(href || '').split('?')[0].split('#')[0];
    if (path === '/getting-started/team') return 'team';
    if (path === '/getting-started/imports') return 'imports';
    return null;
}

});

parcelRegister("fJThD", function(module, exports) {

$parcel$export(module.exports, "loadGettingStartedImports", () => $b755f1219dd3ca41$export$c190242883feda8e);
$parcel$export(module.exports, "gettingStartedImportRows", () => $b755f1219dd3ca41$export$cf183a9ec13fa017);
$parcel$export(module.exports, "gettingStartedImportCanUpload", () => $b755f1219dd3ca41$export$5235b5e8f08a1f5f);
$parcel$export(module.exports, "gettingStartedFileCheck", () => $b755f1219dd3ca41$export$2b47d421e1e8fae);
$parcel$export(module.exports, "uploadGettingStartedFile", () => $b755f1219dd3ca41$export$2038ee3c0d41bb13);
$parcel$export(module.exports, "reviewGettingStartedSource", () => $b755f1219dd3ca41$export$3c960eb7b9af729c);
$parcel$export(module.exports, "closeGettingStartedReview", () => $b755f1219dd3ca41$export$2261f996cab1d055);
$parcel$export(module.exports, "gettingStartedImportColumns", () => $b755f1219dd3ca41$export$6064e9ef3ae6009f);
$parcel$export(module.exports, "setGettingStartedImportTarget", () => $b755f1219dd3ca41$export$c91417240aa70297);
$parcel$export(module.exports, "setGettingStartedImportMapping", () => $b755f1219dd3ca41$export$738439f7f34da3fe);
$parcel$export(module.exports, "gettingStartedImportPick", () => $b755f1219dd3ca41$export$38cadfa67f95f945);
$parcel$export(module.exports, "gettingStartedImportFields", () => $b755f1219dd3ca41$export$f3a79c74fe1df222);
$parcel$export(module.exports, "gettingStartedImportTargetOptions", () => $b755f1219dd3ca41$export$afcaa5c02dbfd49a);
$parcel$export(module.exports, "gettingStartedImportFieldOptions", () => $b755f1219dd3ca41$export$89332d2a7601fdfc);
$parcel$export(module.exports, "gettingStartedImportCanRun", () => $b755f1219dd3ca41$export$71964c4856e36c71);
$parcel$export(module.exports, "gettingStartedImportErrorKey", () => $b755f1219dd3ca41$export$72fb8890a029ecfe);
$parcel$export(module.exports, "gettingStartedImportNoteKey", () => $b755f1219dd3ca41$export$16ce041c5cc12814);
$parcel$export(module.exports, "runGettingStartedImport", () => $b755f1219dd3ca41$export$c824763f2945dde9);
$parcel$export(module.exports, "gettingStartedImportCanUndo", () => $b755f1219dd3ca41$export$c9694db35609c3c8);
$parcel$export(module.exports, "undoGettingStartedImport", () => $b755f1219dd3ca41$export$9636f2880b6ed227);
$parcel$export(module.exports, "gettingStartedImportSourceFrom", () => $b755f1219dd3ca41$export$8af212b8aad46466);
$parcel$export(module.exports, "gettingStartedImportSourceParam", () => $b755f1219dd3ca41$export$f7b3be2908ba989d);
// Getting started → Imports — the data behind /getting-started/imports (POB
// S10, pages/gettingStartedImports.js): the import connectors, the owner's own
// upload, the preview, the column → field mapping onto an installed app's
// collection or one of the workspace's own collections, the run and its undo.
// The onboarding lane owns the server and these SDK names (POB plan §7b-3
// "Import core", the SDK's ImportsService):
//   listImportSources(wsId) → { sources: [{ id: 'file'|'google_sheets', kind,
//                               name { en, ka } | null, status live|planned|
//                               missing, auth }] } — the CONNECTORS. The `file`
//                               one is the drop zone; one that is not live
//                               says "Soon". (The files and pages the
//                               onboarding research finds on the company's own
//                               site are a later step, not a source here.)
//   listImportTargets(wsId) → [{ app (null = the workspace's own collection),
//                               collection, label{en,ka}, fields: [{ key,
//                               label{en,ka}, type, required }], open? }]
//                               (`open`: no fields declared, so every column
//                               becomes a field of its own)
//   uploadImportFile(wsId, file) → { fileId, name, size, kind } — 400
//                               `unsupported_file` (pdf/csv/xlsx only), 413
//                               `too_large` (10 MB). A PDF still uploads, but
//                               the page does not offer it until the server
//                               reads PDF tables.
//   previewImport(wsId, { fileId } | { sourceId }) → { previewId, columns:
//                               [{ key, label, sample, fieldKey? }] (fieldKey:
//                               the column's new field for an open target,
//                               the server's naming), rows (the first 5),
//                               total, suggestedTarget { app, collection } |
//                               null, suggestedMapping { column: field } (for
//                               an open target: the same keys), expiresAt }
//                               — a file by its fileId only (`{ sourceId:
//                               'file' }` is a 400); 404 `object_not_found` /
//                               `preview_not_found`
//                               (an upload lives 24 h), 413 `too_large` (5000
//                               rows or 10 MB), 422 `no_table_found` (every
//                               PDF today), 400 `unknown_connector`, 409
//                               `connector_not_available`
//   runImport(wsId, { previewId, target: { app, collection }, mapping })
//                             → 202 { importId } — 404 `preview_not_found`
//   getImport(wsId, importId) → { status running|done|failed|undone,
//                               counts { created, skipped, failed }, errors }
//                               — 404 `import_not_found`
//   undoImport(wsId, importId) — removes the rows of a done or a failed import
//                               (7 days); 409 `already_undone`
//
// Until the server answers — the SDK has no such method yet, the route
// answers 501, or a 404 with no code the contract knows — the page says
// "Soon" and offers no button (plan §7b-2: no dead buttons). A 403 is the
// manager gate.
//
// Root keys (state-app.js, the workspace-scoped wipe): the read
// (`gettingStartedImportStatus` idle|loading|ready|soon|denied|error,
// `gettingStartedSources`, `gettingStartedTargets`), the open review
// (`gettingStartedReview` { previewId, name, total, columns } — what the
// preview holds; null on the list), the owner's choice for it
// (`gettingStartedMapping` { targetKey, mapping }), the last refusal
// (`gettingStartedImportError`: a server code, or expired / pdf_not_read /
// connector_not_available / unavailable / failed), the busy flag while a file
// uploads or a preview reads (`gettingStartedUploading`) and the run
// (`gettingStartedRun`). The choice is its own key so a pick never replaces
// the review the column list renders from: the list keeps its rows and the
// select keeps focus. Every write carries the whole object: `mapping` holds
// EVERY column of the preview ('' = skip it), so no write can leave a stale
// column behind.
//
// Row fields are `source*` / `target*` / `field*` / `column*`-named on purpose:
// a `childrenAs: 'state'` row falls back to ROOT keys for a field it does not
// own, and the root has its own `id`, `label`, `kind` and `url`.

var $1X0Je = parcelRequire("1X0Je");
// Module helpers carry a `_gsi` prefix: frank hoists a functions file's
// module helpers into the project's one shared scope by name.
const $b755f1219dd3ca41$var$_gsiRootOf = (root, ctx)=>root || ctx && ctx.state && ctx.state.root || null;
// The tab's own workspace beats the session claim (it lags a switch); either
// id shape — the scopedClient.js `activeWorkspaceId` rule.
const $b755f1219dd3ca41$var$_gsiWsId = (r)=>String(r && r.workspace && (r.workspace.id || r.workspace._id) || r && r.jwtClaims && r.jwtClaims.active_workspace_id || '');
const $b755f1219dd3ca41$var$_gsiSdk = (seam, ctx)=>seam && seam.sdk || ctx && ctx.sdk || (0, $1X0Je.default).functions.getSDK();
const $b755f1219dd3ca41$var$_gsiHas = (sdk, name)=>!!sdk && typeof sdk[name] === 'function';
const $b755f1219dd3ca41$var$_gsiSeam = (via)=>via && typeof via === 'object' ? via : {};
const $b755f1219dd3ca41$var$_gsiWriter = (seam, r)=>typeof seam.write === 'function' ? seam.write : (patch)=>r.update(patch);
// The SDK raises an HTTP failure with `status` and the JSON body as `cause`;
// the server names the reason in `error` (the SDK copies it to `code`).
const $b755f1219dd3ca41$var$_gsiCode = (err)=>String(err && (err.cause && (err.cause.error || err.cause.code) || err.code) || '');
// The contract's 404 codes: a thing that is gone, never a route not there yet.
const $b755f1219dd3ca41$var$_gsiGone = (code)=>code === 'preview_not_found' || code === 'object_not_found' || code === 'import_not_found';
// The route is not there yet: 501, or a 404 with no code the contract knows.
const $b755f1219dd3ca41$var$_gsiNotThere = (err)=>!!err && (err.status === 501 || err.status === 404 && !$b755f1219dd3ca41$var$_gsiGone($b755f1219dd3ca41$var$_gsiCode(err)));
// The reason a refusal shows: the server's own code when the page knows it,
// else the status the contract gives that code.
const $b755f1219dd3ca41$var$_gsiErrorOf = (err)=>{
    const code = $b755f1219dd3ca41$var$_gsiCode(err);
    if (code === 'unsupported_file' || code === 'too_large' || code === 'no_table_found') return code;
    // The upload (or its preview) is gone after 24 h: it goes up again.
    if (code === 'preview_not_found' || code === 'object_not_found') return 'expired';
    if (code === 'unknown_connector' || code === 'connector_not_available') return 'connector_not_available';
    if (err && err.status === 413) return 'too_large';
    if (err && err.status === 422) return 'no_table_found';
    if ($b755f1219dd3ca41$var$_gsiNotThere(err)) return 'unavailable';
    return 'failed';
};
const $b755f1219dd3ca41$var$_gsiErrorKey = (code)=>{
    if (!code) return '';
    if (code === 'unsupported_file') return 'workspace.gettingStarted.imports.errUnsupported';
    if (code === 'too_large') return 'workspace.gettingStarted.imports.errTooLarge';
    if (code === 'no_table_found') return 'workspace.gettingStarted.imports.errNoTable';
    if (code === 'pdf_not_read') return 'workspace.gettingStarted.imports.errPdfNotRead';
    if (code === 'expired') return 'workspace.gettingStarted.imports.errExpired';
    if (code === 'connector_not_available') return 'workspace.gettingStarted.imports.errSourceSoon';
    if (code === 'unavailable') return 'workspace.gettingStarted.imports.errUnavailable';
    return 'workspace.gettingStarted.imports.errFailed';
};
// An answer may come wrapped in `{ data }`.
const $b755f1219dd3ca41$var$_gsiBody = (res)=>(res && res.data && typeof res.data === 'object' && !Array.isArray(res.data) ? res.data : res) || {};
const $b755f1219dd3ca41$var$_gsiText = (v)=>typeof v === 'string' ? v.trim() : '';
// A name in both languages: the server's { en, ka } (Georgian falls back to
// English), a plain string, else `fallback` (a connector's id, a collection's
// key) — never an empty name.
const $b755f1219dd3ca41$var$_gsiLabelOf = (label, fallback)=>{
    const obj = label && typeof label === 'object' ? label : null;
    const en = obj ? $b755f1219dd3ca41$var$_gsiText(obj.en) || $b755f1219dd3ca41$var$_gsiText(obj.ka) : $b755f1219dd3ca41$var$_gsiText(label);
    const text = en || String(fallback == null ? '' : fallback);
    return {
        en: text,
        ka: obj && $b755f1219dd3ca41$var$_gsiText(obj.ka) || text
    };
};
const $b755f1219dd3ca41$var$_gsiNameIn = (r, label)=>label[(r && r.lang) === 'ka' ? 'ka' : 'en'] || label.en;
const $b755f1219dd3ca41$var$_gsiSource = (x)=>{
    const id = String(x && (x.id || x._id) || '');
    return {
        sourceId: id,
        sourceKind: String(x && x.kind || id),
        sourceAuth: String(x && x.auth || ''),
        sourceStatus: String(x && x.status || ''),
        sourceName: $b755f1219dd3ca41$var$_gsiLabelOf(x && x.name, id)
    };
};
const $b755f1219dd3ca41$var$_gsiSourcesOf = (res)=>{
    const body = $b755f1219dd3ca41$var$_gsiBody(res);
    return (Array.isArray(body.sources) ? body.sources : []).map($b755f1219dd3ca41$var$_gsiSource).filter((x)=>x.sourceId);
};
const $b755f1219dd3ca41$var$_gsiSourceOf = (r, id)=>(r && r.gettingStartedSources || []).find((x)=>x.sourceId === id) || null;
const $b755f1219dd3ca41$var$_gsiLive = (x)=>!!x && x.sourceStatus === 'live';
// The file connector is the drop zone: a file previews by its fileId, never
// by `{ sourceId: 'file' }` (a 400).
const $b755f1219dd3ca41$var$_gsiIsFile = (x)=>!!x && x.sourceId === 'file';
// A connector that previews by `{ sourceId }`: a live one other than the file.
const $b755f1219dd3ca41$var$_gsiPreviewable = (x)=>$b755f1219dd3ca41$var$_gsiLive(x) && !$b755f1219dd3ca41$var$_gsiIsFile(x);
const $b755f1219dd3ca41$var$_gsiTarget = (t)=>{
    const app = t && t.app ? String(t.app) : null;
    const collection = String(t && t.collection || '');
    return {
        targetKey: `${app || ''}|${collection}`,
        // null: one of the workspace's own collections — the run names no app.
        targetApp: app,
        targetCollection: collection,
        targetLabel: $b755f1219dd3ca41$var$_gsiLabelOf(t && t.label, collection),
        // No fields declared: every column becomes a field of its own.
        targetOpen: !!t && t.open === true,
        targetFields: (t && Array.isArray(t.fields) ? t.fields : []).filter((f)=>f && f.key).map((f)=>({
                fieldKey: String(f.key),
                fieldLabel: $b755f1219dd3ca41$var$_gsiLabelOf(f.label, f.key),
                fieldRequired: !!f.required
            }))
    };
};
const $b755f1219dd3ca41$var$_gsiTargetsOf = (res)=>{
    const body = Array.isArray(res) ? res : $b755f1219dd3ca41$var$_gsiBody(res);
    const list = Array.isArray(body) ? body : Array.isArray(body.targets) ? body.targets : [];
    return list.map($b755f1219dd3ca41$var$_gsiTarget).filter((t)=>t.targetCollection);
};
const $b755f1219dd3ca41$var$_gsiTargetOf = (r, key)=>(r && r.gettingStartedTargets || []).find((t)=>t.targetKey === key) || null;
// A field key the server takes for an open target (mapping.js FIELD_KEY_RE).
const $b755f1219dd3ca41$var$_gsiFieldKeyOk = (v)=>typeof v === 'string' && /^[a-zA-Z_][a-zA-Z0-9_]{0,63}$/.test(v);
// An open target's field per column. The server names them (Georgian
// headers transliterated) and the preview carries them (`columnField`): the
// server's key first, as given; a column with none gets `c<n>`, the server's
// own fallback, and a name already taken gets `_2`, `_3` … within 64
// characters.
const $b755f1219dd3ca41$var$_gsiOwnKeys = (columns)=>{
    const list = Array.isArray(columns) ? columns : [];
    // A Set: a header may name `constructor`, which a plain object already has.
    const used = new Set();
    const out = {};
    const claim = (column, base)=>{
        let key = base;
        for(let n = 2; used.has(key); n++)key = `${base.slice(0, 64 - String(n).length - 1)}_${n}`;
        used.add(key);
        out[column] = key;
    };
    list.forEach((c)=>{
        if (c.columnField) claim(c.columnKey, c.columnField);
    });
    list.forEach((c, i)=>{
        if (!c.columnField) claim(c.columnKey, `c${i + 1}`);
    });
    return out;
};
const $b755f1219dd3ca41$var$_gsiColumnsOf = (r)=>{
    const review = r && r.gettingStartedReview;
    return review && review.columns || [];
};
// The fields a column may go into: the target's own, or for an open target
// one new field per column.
const $b755f1219dd3ca41$var$_gsiFieldsOf = (r, target)=>{
    if (!target) return [];
    if (!target.targetOpen) return target.targetFields;
    const columns = $b755f1219dd3ca41$var$_gsiColumnsOf(r);
    const own = $b755f1219dd3ca41$var$_gsiOwnKeys(columns);
    return columns.map((c)=>({
            fieldKey: own[c.columnKey],
            fieldLabel: {
                en: c.columnLabel,
                ka: c.columnLabel
            },
            fieldRequired: false
        }));
};
// pdf / csv / xlsx by extension, or by MIME type when the name has none.
const $b755f1219dd3ca41$var$_gsiKindOf = (file)=>{
    const ext = String(file && file.name || '').toLowerCase().split('.').pop();
    if (ext === 'pdf' || ext === 'csv' || ext === 'xlsx') return ext;
    const type = String(file && file.type || '');
    if (type === 'application/pdf') return 'pdf';
    if (type === 'text/csv') return 'csv';
    if (type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return 'xlsx';
    return '';
};
// The contract's own limits, checked before any upload: 10 MB, pdf/csv/xlsx.
const $b755f1219dd3ca41$var$_gsiFileCheck = (file)=>{
    if (!file || typeof file !== 'object' || !$b755f1219dd3ca41$var$_gsiKindOf(file)) return 'unsupported_file';
    if (Number(file.size) > 10485760) return 'too_large';
    return '';
};
// Up to three non-empty values per column, from the preview rows (objects by
// column key, or arrays by position), else the column's own sample; and the
// field key the server gives the column for an open target: its own
// `fieldKey` first, else the mapping the server suggested for one (`given`);
// '' = none.
const $b755f1219dd3ca41$var$_gsiColumns = (columns, rows, given)=>(Array.isArray(columns) ? columns : []).map((c, i)=>{
        const key = String(c && c.key != null ? c.key : i);
        const samples = (Array.isArray(rows) ? rows : []).map((row)=>Array.isArray(row) ? row[i] : row && row[key]).filter((v)=>v != null && String(v).trim() !== '').map((v)=>String(v)).slice(0, 3);
        const sample = c && c.sample != null ? String(c.sample) : '';
        const own = c && c.fieldKey;
        const field = $b755f1219dd3ca41$var$_gsiFieldKeyOk(own) ? own : given && given[key];
        return {
            columnKey: key,
            columnLabel: String(c && (c.label || c.key) || ''),
            columnSamples: samples.length ? samples : sample ? [
                sample
            ] : [],
            columnField: $b755f1219dd3ca41$var$_gsiFieldKeyOk(field) ? field : ''
        };
    });
// The mapping onto one target: every column present, '' = skip. An open
// target takes every column as its own new field. Else a wanted field the
// target lacks is dropped, a field takes one column (the first), and a
// column still free takes the field its own name names.
const $b755f1219dd3ca41$var$_gsiMapFor = (columns, wanted, target)=>{
    const out = {};
    if (target && target.targetOpen) {
        const own = $b755f1219dd3ca41$var$_gsiOwnKeys(columns);
        columns.forEach((c)=>{
            out[c.columnKey] = own[c.columnKey];
        });
        return out;
    }
    const fields = target && target.targetFields || [];
    const has = (key)=>fields.some((f)=>f.fieldKey === key);
    const used = new Set();
    columns.forEach((c)=>{
        const f = wanted && wanted[c.columnKey];
        if (f && has(f) && !used.has(f)) {
            out[c.columnKey] = f;
            used.add(f);
        } else out[c.columnKey] = '';
    });
    columns.forEach((c)=>{
        if (out[c.columnKey]) return;
        const name = c.columnLabel.trim().toLowerCase();
        const hit = fields.find((f)=>!used.has(f.fieldKey) && name && (f.fieldKey.toLowerCase() === name || f.fieldLabel.en.toLowerCase() === name || f.fieldLabel.ka.toLowerCase() === name));
        if (hit) {
            out[c.columnKey] = hit.fieldKey;
            used.add(hit.fieldKey);
        }
    });
    return out;
};
const $b755f1219dd3ca41$var$_gsiChoice = (r)=>r && r.gettingStartedMapping || null;
const $b755f1219dd3ca41$var$_gsiPicked = (choice)=>Object.values(choice && choice.mapping || {}).filter(Boolean);
// A required field of the chosen target that no column goes into yet.
const $b755f1219dd3ca41$var$_gsiMissing = (r)=>{
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    const target = choice && $b755f1219dd3ca41$var$_gsiTargetOf(r, choice.targetKey);
    const picked = $b755f1219dd3ca41$var$_gsiPicked(choice);
    return !!target && target.targetFields.some((f)=>f.fieldRequired && !picked.includes(f.fieldKey));
};
const $b755f1219dd3ca41$var$_gsiCanRun = (r)=>{
    const review = r && r.gettingStartedReview;
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    if (!review || !review.previewId || !choice) return false;
    if (!$b755f1219dd3ca41$var$_gsiTargetOf(r, choice.targetKey)) return false;
    return $b755f1219dd3ca41$var$_gsiPicked(choice).length > 0 && !$b755f1219dd3ca41$var$_gsiMissing(r);
};
// Undo is offered while a done or a failed run added rows (a failed run's
// partial rows go too) and they are not undone yet.
const $b755f1219dd3ca41$var$_gsiCanUndo = (run)=>!!run && !!run.importId && (run.status === 'done' || run.status === 'failed') && Number(run.created) > 0 && run.undo !== 'done';
// May this column take this field? '' (skip) always; else a field of the
// target — for an open target, the column's own new field and no other.
const $b755f1219dd3ca41$var$_gsiTakes = (r, target, columnKey, field)=>{
    if (!field) return true;
    if (!target) return false;
    if (target.targetOpen) return $b755f1219dd3ca41$var$_gsiOwnKeys($b755f1219dd3ca41$var$_gsiColumnsOf(r))[columnKey] === field;
    return target.targetFields.some((f)=>f.fieldKey === field);
};
const $b755f1219dd3ca41$var$_gsiSourceFrom = (href)=>{
    const s = String(href || '');
    const q = s.indexOf('?');
    if (q < 0) return '';
    try {
        return new URLSearchParams(s.slice(q + 1).split('#')[0]).get('source') || '';
    } catch (e) {
        return '';
    }
};
// The preview of a file or a live connector → the open review. Resolves the
// review, or null (refused, or the workspace changed meanwhile). `kind` is
// the uploaded file's (pdf / csv / xlsx; '' for a connector).
const $b755f1219dd3ca41$var$_gsiPreview = async (r, wsId, sdk, write, ref, name, kind)=>{
    if (!$b755f1219dd3ca41$var$_gsiHas(sdk, 'previewImport')) {
        write({
            gettingStartedUploading: false,
            gettingStartedImportError: 'unavailable'
        });
        return null;
    }
    write({
        gettingStartedUploading: true,
        gettingStartedImportError: ''
    });
    try {
        const body = $b755f1219dd3ca41$var$_gsiBody(await sdk.previewImport(wsId, ref));
        if ($b755f1219dd3ca41$var$_gsiWsId(r) !== wsId) return null;
        const s = body.suggestedTarget || {};
        const suggested = $b755f1219dd3ca41$var$_gsiTargetOf(r, `${s.app || ''}|${s.collection || ''}`);
        // An open target the server suggests comes with its field keys.
        const given = suggested && suggested.targetOpen ? body.suggestedMapping : null;
        const columns = $b755f1219dd3ca41$var$_gsiColumns(body.columns, body.rows, given);
        const review = {
            previewId: String(body.previewId || ''),
            name: String(name || ''),
            total: Number(body.total) || 0,
            columns: columns
        };
        write({
            gettingStartedUploading: false,
            gettingStartedImportError: '',
            gettingStartedReview: review,
            gettingStartedMapping: {
                targetKey: suggested ? suggested.targetKey : '',
                mapping: $b755f1219dd3ca41$var$_gsiMapFor(columns, body.suggestedMapping || {}, suggested)
            },
            gettingStartedRun: null
        });
        return review;
    } catch (err) {
        console.error('[getting-started/imports] preview', err);
        if ($b755f1219dd3ca41$var$_gsiWsId(r) !== wsId) return null;
        const code = $b755f1219dd3ca41$var$_gsiErrorOf(err);
        // Every PDF answers no_table_found today: it says why.
        const shown = code === 'no_table_found' && kind === 'pdf' ? 'pdf_not_read' : code;
        const patch = {
            gettingStartedUploading: false,
            gettingStartedImportError: shown
        };
        // The server cannot use this connector yet: its row says "Soon" too.
        if (code === 'connector_not_available' && ref && ref.sourceId) patch.gettingStartedSources = (r.gettingStartedSources || []).map((x)=>x.sourceId === ref.sourceId ? {
                ...x,
                sourceStatus: 'planned'
            } : x);
        write(patch);
        return null;
    }
};
async function $b755f1219dd3ca41$export$c190242883feda8e(root, via) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    if (!r) return;
    const seam = $b755f1219dd3ca41$var$_gsiSeam(via);
    // A cold boot that settles on another workspace later re-runs the read
    // (the History loader's boot-identity rule).
    (0, $1X0Je.default).functions.onWorkspaceIdentityCorrected($b755f1219dd3ca41$export$c190242883feda8e);
    const wsId = $b755f1219dd3ca41$var$_gsiWsId(r);
    if (!wsId) {
        (0, $1X0Je.default).functions.onActiveWorkspaceFull($b755f1219dd3ca41$export$c190242883feda8e);
        return;
    }
    const write = $b755f1219dd3ca41$var$_gsiWriter(seam, r);
    // A reply that outlived its workspace never lands.
    const land = (patch)=>{
        if ($b755f1219dd3ca41$var$_gsiWsId(r) === wsId) write(patch);
    };
    const sdk = $b755f1219dd3ca41$var$_gsiSdk(seam, this);
    if (!$b755f1219dd3ca41$var$_gsiHas(sdk, 'listImportSources')) {
        land({
            gettingStartedImportStatus: 'soon'
        });
        return;
    }
    land({
        gettingStartedImportStatus: 'loading'
    });
    try {
        const [res, targets] = await Promise.all([
            sdk.listImportSources(wsId),
            // No targets route yet = nothing to import into, never a failed page.
            $b755f1219dd3ca41$var$_gsiHas(sdk, 'listImportTargets') ? sdk.listImportTargets(wsId).catch(()=>[]) : []
        ]);
        if ($b755f1219dd3ca41$var$_gsiWsId(r) !== wsId) return;
        const sources = $b755f1219dd3ca41$var$_gsiSourcesOf(res);
        // No connector at all: nothing to import from yet, so "Soon" — never a
        // list with nothing on it.
        if (!sources.length) {
            land({
                gettingStartedImportStatus: 'soon'
            });
            return;
        }
        land({
            gettingStartedImportStatus: 'ready',
            gettingStartedSources: sources,
            gettingStartedTargets: $b755f1219dd3ca41$var$_gsiTargetsOf(targets)
        });
    } catch (err) {
        if ($b755f1219dd3ca41$var$_gsiNotThere(err)) {
            land({
                gettingStartedImportStatus: 'soon'
            });
            return;
        }
        if (err && err.status === 403) {
            land({
                gettingStartedImportStatus: 'denied'
            });
            return;
        }
        console.error('[getting-started/imports]', err);
        land({
            gettingStartedImportStatus: 'error'
        });
        return;
    }
    // Only a live connector other than the file previews by its id: the file,
    // a "Soon" connector and a research find (a later step) open nothing.
    const sourceId = typeof seam.sourceId === 'string' ? seam.sourceId : '';
    const source = sourceId ? $b755f1219dd3ca41$var$_gsiSourceOf(r, sourceId) : null;
    if ($b755f1219dd3ca41$var$_gsiPreviewable(source)) await $b755f1219dd3ca41$var$_gsiPreview(r, wsId, sdk, write, {
        sourceId: sourceId
    }, $b755f1219dd3ca41$var$_gsiNameIn(r, source.sourceName));
}
function $b755f1219dd3ca41$export$cf183a9ec13fa017(root) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    return (r && r.gettingStartedSources || []).filter((x)=>!($b755f1219dd3ca41$var$_gsiIsFile(x) && $b755f1219dd3ca41$var$_gsiLive(x))).map((x)=>{
        const name = $b755f1219dd3ca41$var$_gsiLabelOf(x.sourceName, x.sourceId);
        return {
            sourceId: x.sourceId,
            sourceNameEn: name.en,
            sourceNameKa: name.ka,
            sourceLive: $b755f1219dd3ca41$var$_gsiLive(x)
        };
    });
}
function $b755f1219dd3ca41$export$5235b5e8f08a1f5f(root) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    return (r && r.gettingStartedSources || []).some((x)=>$b755f1219dd3ca41$var$_gsiIsFile(x) && $b755f1219dd3ca41$var$_gsiLive(x));
}
function $b755f1219dd3ca41$export$2b47d421e1e8fae(file) {
    return $b755f1219dd3ca41$var$_gsiFileCheck(file);
}
async function $b755f1219dd3ca41$export$2038ee3c0d41bb13(root, file, via) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    if (!r || r.gettingStartedUploading) return null;
    const seam = $b755f1219dd3ca41$var$_gsiSeam(via);
    const wsId = $b755f1219dd3ca41$var$_gsiWsId(r);
    if (!wsId) return null;
    const write = $b755f1219dd3ca41$var$_gsiWriter(seam, r);
    const refused = $b755f1219dd3ca41$var$_gsiFileCheck(file);
    if (refused) {
        write({
            gettingStartedImportError: refused
        });
        return null;
    }
    const sdk = $b755f1219dd3ca41$var$_gsiSdk(seam, this);
    if (!$b755f1219dd3ca41$var$_gsiHas(sdk, 'uploadImportFile')) {
        write({
            gettingStartedImportError: 'unavailable'
        });
        return null;
    }
    write({
        gettingStartedUploading: true,
        gettingStartedImportError: ''
    });
    let up;
    try {
        up = $b755f1219dd3ca41$var$_gsiBody(await sdk.uploadImportFile(wsId, file));
    } catch (err) {
        console.error('[getting-started/imports] upload', err);
        if ($b755f1219dd3ca41$var$_gsiWsId(r) === wsId) write({
            gettingStartedUploading: false,
            gettingStartedImportError: $b755f1219dd3ca41$var$_gsiErrorOf(err)
        });
        return null;
    }
    if ($b755f1219dd3ca41$var$_gsiWsId(r) !== wsId) return null;
    if (!up.fileId) {
        write({
            gettingStartedUploading: false,
            gettingStartedImportError: 'failed'
        });
        return null;
    }
    return $b755f1219dd3ca41$var$_gsiPreview(r, wsId, sdk, write, {
        fileId: up.fileId
    }, up.name || file.name, String(up.kind || $b755f1219dd3ca41$var$_gsiKindOf(file)));
}
async function $b755f1219dd3ca41$export$3c960eb7b9af729c(root, sourceId, via) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    if (!r || !sourceId || r.gettingStartedUploading) return null;
    const source = $b755f1219dd3ca41$var$_gsiSourceOf(r, sourceId);
    const wsId = $b755f1219dd3ca41$var$_gsiWsId(r);
    if (!$b755f1219dd3ca41$var$_gsiPreviewable(source) || !wsId) return null;
    const seam = $b755f1219dd3ca41$var$_gsiSeam(via);
    return $b755f1219dd3ca41$var$_gsiPreview(r, wsId, $b755f1219dd3ca41$var$_gsiSdk(seam, this), $b755f1219dd3ca41$var$_gsiWriter(seam, r), {
        sourceId: sourceId
    }, $b755f1219dd3ca41$var$_gsiNameIn(r, source.sourceName));
}
function $b755f1219dd3ca41$export$2261f996cab1d055(root) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    if (!r) return;
    r.update({
        gettingStartedReview: null,
        gettingStartedMapping: null,
        gettingStartedRun: null,
        gettingStartedImportError: ''
    });
}
function $b755f1219dd3ca41$export$6064e9ef3ae6009f(root) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    return $b755f1219dd3ca41$var$_gsiColumnsOf(r).map((c)=>({
            columnKey: c.columnKey,
            columnLabel: c.columnLabel,
            columnSampleText: (c.columnSamples || []).join(', ')
        }));
}
function $b755f1219dd3ca41$export$c91417240aa70297(root, targetKey) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const review = r && r.gettingStartedReview;
    const target = $b755f1219dd3ca41$var$_gsiTargetOf(r, targetKey);
    if (!review || !target) return;
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r) || {};
    r.update({
        gettingStartedMapping: {
            targetKey: target.targetKey,
            mapping: $b755f1219dd3ca41$var$_gsiMapFor(review.columns || [], choice.mapping || {}, target)
        }
    });
}
function $b755f1219dd3ca41$export$738439f7f34da3fe(root, columnKey, fieldKey) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    if (!choice || !choice.mapping || !Object.prototype.hasOwnProperty.call(choice.mapping, columnKey)) return;
    const field = String(fieldKey || '');
    if (!$b755f1219dd3ca41$var$_gsiTakes(r, $b755f1219dd3ca41$var$_gsiTargetOf(r, choice.targetKey), columnKey, field)) return;
    const mapping = {};
    Object.keys(choice.mapping).forEach((col)=>{
        if (col === columnKey) mapping[col] = field;
        else mapping[col] = field && choice.mapping[col] === field ? '' : choice.mapping[col];
    });
    r.update({
        gettingStartedMapping: {
            targetKey: choice.targetKey,
            mapping: mapping
        }
    });
}
function $b755f1219dd3ca41$export$38cadfa67f95f945(root, columnKey) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    return String(choice && choice.mapping && choice.mapping[columnKey] || '');
}
function $b755f1219dd3ca41$export$f3a79c74fe1df222(root) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    const target = choice && $b755f1219dd3ca41$var$_gsiTargetOf(r, choice.targetKey);
    return $b755f1219dd3ca41$var$_gsiFieldsOf(r, target).map((f)=>({
            ...f,
            fieldLabel: {
                ...f.fieldLabel
            }
        }));
}
function $b755f1219dd3ca41$export$afcaa5c02dbfd49a(root, pickText) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    const current = choice && choice.targetKey || '';
    const rows = (r && r.gettingStartedTargets || []).map((t)=>({
            value: t.targetKey,
            text: $b755f1219dd3ca41$var$_gsiNameIn(r, t.targetLabel),
            selected: t.targetKey === current ? true : undefined
        }));
    return current ? rows : [
        {
            value: '',
            text: String(pickText || ''),
            selected: true
        },
        ...rows
    ];
}
function $b755f1219dd3ca41$export$89332d2a7601fdfc(root, columnKey, words) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const lang = (r && r.lang) === 'ka' ? 'ka' : 'en';
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    const target = choice && $b755f1219dd3ca41$var$_gsiTargetOf(r, choice.targetKey);
    const pick = String(choice && choice.mapping && choice.mapping[columnKey] || '');
    const w = words && typeof words === 'object' ? words : {};
    const skip = {
        value: '',
        text: String(w.skip || ''),
        selected: pick ? undefined : true
    };
    if (target && target.targetOpen) {
        const own = $b755f1219dd3ca41$var$_gsiOwnKeys($b755f1219dd3ca41$var$_gsiColumnsOf(r))[columnKey];
        const add = {
            value: own,
            text: String(w.newField || ''),
            selected: pick === own ? true : undefined
        };
        return own ? [
            skip,
            add
        ] : [
            skip
        ];
    }
    const fields = (target ? target.targetFields : []).map((f)=>({
            value: f.fieldKey,
            text: f.fieldRequired ? `${f.fieldLabel[lang] || f.fieldLabel.en} ${String(w.required || '')}`.trim() : f.fieldLabel[lang] || f.fieldLabel.en,
            selected: f.fieldKey === pick ? true : undefined
        }));
    return [
        skip,
        ...fields
    ];
}
function $b755f1219dd3ca41$export$71964c4856e36c71(root) {
    return $b755f1219dd3ca41$var$_gsiCanRun($b755f1219dd3ca41$var$_gsiRootOf(root, this));
}
function $b755f1219dd3ca41$export$72fb8890a029ecfe(code) {
    return $b755f1219dd3ca41$var$_gsiErrorKey(code);
}
function $b755f1219dd3ca41$export$16ce041c5cc12814(root) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const code = r && r.gettingStartedImportError;
    if (code) return $b755f1219dd3ca41$var$_gsiErrorKey(code);
    const run = r && r.gettingStartedRun;
    if (run) {
        // The undo's outcome first: a failed run's rows may be undone too.
        if (run.undo === 'done') return 'workspace.gettingStarted.imports.undone';
        if (run.undo === 'failed') return 'workspace.gettingStarted.imports.undoFailed';
        if (run.status === 'failed') return 'workspace.gettingStarted.imports.runFailed';
        if (run.status === 'pending') return 'workspace.gettingStarted.imports.pending';
        if (run.status !== 'done') return '';
        return 'workspace.gettingStarted.imports.done';
    }
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    if (!choice || !choice.targetKey || $b755f1219dd3ca41$var$_gsiCanRun(r)) return '';
    if ($b755f1219dd3ca41$var$_gsiMissing(r)) return 'workspace.gettingStarted.imports.needRequired';
    return $b755f1219dd3ca41$var$_gsiPicked(choice).length ? '' : 'workspace.gettingStarted.imports.needColumn';
}
async function $b755f1219dd3ca41$export$c824763f2945dde9(root, via) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    if (!r || !$b755f1219dd3ca41$var$_gsiCanRun(r)) return null;
    // One thing at a time: a run going, or the undo of the last one (its rows
    // are still going; a new run would race it for the run on screen).
    const last = r.gettingStartedRun;
    if (last && (last.status === 'starting' || last.status === 'running' || last.undo === 'undoing')) return null;
    const seam = $b755f1219dd3ca41$var$_gsiSeam(via);
    const wsId = $b755f1219dd3ca41$var$_gsiWsId(r);
    if (!wsId) return null;
    const write = $b755f1219dd3ca41$var$_gsiWriter(seam, r);
    const sdk = $b755f1219dd3ca41$var$_gsiSdk(seam, this);
    if (!$b755f1219dd3ca41$var$_gsiHas(sdk, 'runImport') || !$b755f1219dd3ca41$var$_gsiHas(sdk, 'getImport')) {
        write({
            gettingStartedImportError: 'unavailable'
        });
        return null;
    }
    const sleep = typeof seam.sleep === 'function' ? seam.sleep : (ms)=>new Promise((res)=>setTimeout(res, ms));
    const maxPolls = Number(seam.maxPolls) > 0 ? Number(seam.maxPolls) : 150;
    const review = r.gettingStartedReview;
    const choice = $b755f1219dd3ca41$var$_gsiChoice(r);
    const target = $b755f1219dd3ca41$var$_gsiTargetOf(r, choice.targetKey);
    const mapping = {};
    Object.keys(choice.mapping || {}).forEach((col)=>{
        if (choice.mapping[col]) mapping[col] = choice.mapping[col];
    });
    const fresh = (importId, status, counts)=>({
            importId: importId,
            status: status,
            created: Number(counts && counts.created) || 0,
            skipped: Number(counts && counts.skipped) || 0,
            failed: Number(counts && counts.failed) || 0,
            undo: ''
        });
    write({
        gettingStartedImportError: '',
        gettingStartedRun: fresh('', 'starting', null)
    });
    let importId = '';
    try {
        const body = $b755f1219dd3ca41$var$_gsiBody(await sdk.runImport(wsId, {
            previewId: review.previewId,
            target: {
                app: target.targetApp,
                collection: target.targetCollection
            },
            mapping: mapping
        }));
        importId = String(body.importId || body.id || '');
    } catch (err) {
        console.error('[getting-started/imports] run', err);
        if ($b755f1219dd3ca41$var$_gsiWsId(r) !== wsId) return null;
        const code = $b755f1219dd3ca41$var$_gsiErrorOf(err);
        // The preview is gone (24 h, or a finished run used it up): back to the
        // list, where the file goes up again.
        const gone = code === 'expired' ? {
            gettingStartedReview: null,
            gettingStartedMapping: null
        } : {};
        write({
            ...gone,
            gettingStartedRun: null,
            gettingStartedImportError: code
        });
        return null;
    }
    if ($b755f1219dd3ca41$var$_gsiWsId(r) !== wsId) return null;
    if (!importId) {
        write({
            gettingStartedRun: null,
            gettingStartedImportError: 'failed'
        });
        return null;
    }
    let run = fresh(importId, 'running', null);
    write({
        gettingStartedRun: run
    });
    for(let i = 0; i < maxPolls; i++){
        await sleep(2000);
        // The page went back to the list, another run began, or the workspace
        // changed: this poll is no longer anyone's.
        const mine = ()=>$b755f1219dd3ca41$var$_gsiWsId(r) === wsId && r.gettingStartedRun && r.gettingStartedRun.importId === importId;
        if (!mine()) return null;
        let st = null;
        let lost = false;
        try {
            st = $b755f1219dd3ca41$var$_gsiBody(await sdk.getImport(wsId, importId));
        } catch (err) {
            console.warn('[getting-started/imports] status read failed', err);
            // The server no longer knows this run; any other failed read is
            // retried by the next poll.
            lost = $b755f1219dd3ca41$var$_gsiCode(err) === 'import_not_found';
        }
        if (!mine()) return null;
        if (lost) {
            write({
                gettingStartedRun: {
                    ...run,
                    status: 'failed'
                }
            });
            return {
                importId: importId,
                status: 'failed'
            };
        }
        if (!st) continue;
        // Undone meanwhile (another tab): a done run whose undo is done — the
        // note says so and Undo hides.
        if (st.status === 'undone') {
            write({
                gettingStartedRun: {
                    ...fresh(importId, 'done', st.counts),
                    undo: 'done'
                }
            });
            return {
                importId: importId,
                status: 'undone'
            };
        }
        const status = st.status === 'done' || st.status === 'failed' ? st.status : 'running';
        run = fresh(importId, status, st.counts);
        write({
            gettingStartedRun: run
        });
        if (status !== 'running') return {
            importId: importId,
            status: status
        };
    }
    write({
        gettingStartedRun: {
            ...run,
            status: 'pending'
        }
    });
    return {
        importId: importId,
        status: 'pending'
    };
}
function $b755f1219dd3ca41$export$c9694db35609c3c8(root) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    return $b755f1219dd3ca41$var$_gsiCanUndo(r && r.gettingStartedRun);
}
async function $b755f1219dd3ca41$export$9636f2880b6ed227(root, via) {
    const r = $b755f1219dd3ca41$var$_gsiRootOf(root, this);
    const run = r && r.gettingStartedRun;
    if (!$b755f1219dd3ca41$var$_gsiCanUndo(run) || run.undo === 'undoing') return false;
    const seam = $b755f1219dd3ca41$var$_gsiSeam(via);
    const wsId = $b755f1219dd3ca41$var$_gsiWsId(r);
    if (!wsId) return false;
    const write = $b755f1219dd3ca41$var$_gsiWriter(seam, r);
    const sdk = $b755f1219dd3ca41$var$_gsiSdk(seam, this);
    if (!$b755f1219dd3ca41$var$_gsiHas(sdk, 'undoImport')) {
        write({
            gettingStartedImportError: 'unavailable'
        });
        return false;
    }
    write({
        gettingStartedRun: {
            ...run,
            undo: 'undoing'
        }
    });
    // The outcome lands only while this run is still the one on screen (Back
    // or a workspace switch clears it meanwhile).
    const mine = ()=>$b755f1219dd3ca41$var$_gsiWsId(r) === wsId && !!r.gettingStartedRun && r.gettingStartedRun.importId === run.importId;
    try {
        await sdk.undoImport(wsId, run.importId);
    } catch (err) {
        // Undone already (another tab): its rows are gone all the same.
        if ($b755f1219dd3ca41$var$_gsiCode(err) !== 'already_undone') {
            console.error('[getting-started/imports] undo', err);
            if (mine()) write({
                gettingStartedRun: {
                    ...run,
                    undo: 'failed'
                }
            });
            return false;
        }
    }
    if ($b755f1219dd3ca41$var$_gsiWsId(r) !== wsId) return false;
    if (mine()) write({
        gettingStartedRun: {
            ...run,
            undo: 'done'
        }
    });
    return true;
}
function $b755f1219dd3ca41$export$8af212b8aad46466(href) {
    return $b755f1219dd3ca41$var$_gsiSourceFrom(href);
}
function $b755f1219dd3ca41$export$f7b3be2908ba989d() {
    const el = this;
    const r = el && el.state && el.state.root;
    const paneKey = el && typeof el.call === 'function' ? el.call('slotPaneKeyForStrict', el) : null;
    if (paneKey) return $b755f1219dd3ca41$var$_gsiSourceFrom(r && r[paneKey]);
    const q = r && r.query;
    return q && typeof q === 'object' && q.source ? String(q.source) : '';
}

});

parcelRegister("fxEFw", function(module, exports) {

$parcel$export(module.exports, "eventHasMeetLink", () => $b5097c089a70f770$export$433ab6e43352960d);
$parcel$export(module.exports, "joinEventCall", () => $b5097c089a70f770$export$2277cbb24ed797f0);
// Home "Coming up" widget — one-click Join for calendar events that already
// look like a call (board §2 "events/coming-up: next events with JOIN
// button for meet-linked ones"). Reuses the calendar package's OWN join
// dispatch verbatim (calendar/components/EventDetailModal.js's "Join call"
// SaveBtn: find-or-create a meet_rooms row keyed by calendarEventId, then
// hand off activeRoomId/meetView) rather than inventing a second one —
// `createRoom`/`connectCall` are already globally el.call-able (meet's
// eager slice, see workspace/sharedLibraries.js) from any route, exactly
// how EventDetailModal itself calls them from the calendar package.
//
// "meet-linked" is a real signal, not every event: `root.intranetEvents`
// (the home summary feed) carries no explicit meetUrl/meetingMode field,
// so the only two honest signals available here are (1) a meet_rooms row
// already scheduled for this event (root.rooms — shell-eager, see
// loadPrivateData.js's workspace-change meet.rooms fetch) or (2) the
// event's own description carrying a call link — the SAME heuristic
// EventDetailModal's EditBtn already uses to infer meetingMode from
// existing event data. Events without either signal still open fine (the
// card's onClick opens the full detail modal, which has its own
// unconditional "Join call" button) — this just skips the card-level
// shortcut for events that don't look like a call.
const $b5097c089a70f770$var$_MEET_LINK_RE = /\/meet#room=|https?:\/\//i;
const $b5097c089a70f770$export$433ab6e43352960d = function(event) {
    if (!event) return false;
    const root = this && this.state && this.state.root;
    const rooms = root && root.rooms || [];
    if (event.id != null && Array.isArray(rooms) && rooms.some((r)=>r.calendarEventId === event.id)) return true;
    return $b5097c089a70f770$var$_MEET_LINK_RE.test(event.description || '');
};
const $b5097c089a70f770$export$2277cbb24ed797f0 = async function(event) {
    const root = this && this.state && this.state.root;
    if (!root || !event) return;
    const existing = (root.rooms || []).find((r)=>r.calendarEventId === event.id);
    let id = existing?.id;
    if (!id) id = await this.call('createRoom', {
        name: event.title || this.call('polyglot', 'workspace.meet.calendarCall'),
        kind: 'scheduled',
        calendarEventId: event.id,
        transcribeEnabled: true
    });
    if (!id) {
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'workspace.meet.startFailed'),
            message: this.call('polyglot', 'workspace.meet.startFailedBody')
        });
        return;
    }
    root.update({
        activeRoomId: id,
        meetView: 'call'
    });
    // Complete the explicit join before mounting Meet, so its seed sees the
    // live room instead of opening a second pre-join preview.
    await this.call('connectCall', id);
    const hash = 'room=' + encodeURIComponent(id) + '&view=call';
    this.call('openAppPage', '/meet#' + hash);
};

});

parcelRegister("24hpk", function(module, exports) {

$parcel$export(module.exports, "activeMeetingInvite", () => $18197540d8d4e4d6$export$22b7b44783888113);
$parcel$export(module.exports, "joinMeetingInvite", () => $18197540d8d4e4d6$export$ad39ca56f3a5c01f);
// meetingInviteBanner — CALL-INVITATION (tickets/fable.md, Nika
// 2026-08-13: "add notification/beautiful banner when its call invitation
// on given scdheduled time or calendar meeting"). Data half for
// CallInvitationBanner.js (workspace/packages/workspace/components).
//
// The TRIGGER is server-side (server/src/domains/notifications/services/
// meetingStartingScheduler.js's interval sweep) — it writes a durable,
// deduped `meeting_starting` notification (metadata: { kind,
// calendarEventId, workspaceId, eventTitle, startAt, endAt }) per
// invitee/organizer once a CalendarEvent enters its due window. That row
// reaches this client the SAME way every other notification already does
// — subscribeNotifications.js's realtime socket push into `root.notifs`
// (no new transport, no client-side polling needed for the "appear"
// moment) — so `activeMeetingInvite` below is a pure VIEW over
// `root.notifs` + `root.rooms` + `root.activeRoomId`, not a fetcher.
//
// DISMISS = markNotificationRead (shared/functions/markNotificationRead.js,
// already el.call-registered). Reusing the notification's own durable
// `read` flag — rather than inventing a parallel pref/cookie the way
// CreditBanner's dismissal does — means "stays dismissed" is server-durable
// and cross-device for free, and there is exactly one dismissal mechanism
// to keep in sync instead of two.
//
// SCOPE DECISIONS (ticket: "decide... state the choice"):
//   - Workspace scope: an invite only surfaces while its OWN workspace is
//     the CURRENTLY ACTIVE one. Join ultimately resolves/creates a meet
//     room through the ambient active-workspace context (createRoom /
//     connectCall) — surfacing a different workspace's invite here would
//     either join the wrong tenant's room or silently fail (the exact
//     cross-org room-mismatch class roomUrl.js's header comment already
//     documents). Switching into that workspace surfaces its own due
//     invites in turn.
//   - Overlapping meetings: soonest-wins, ONE banner at a time. The next
//     due invite (if any) appears on the following render once the
//     current one is dismissed or joined — no stacking UI, consistent
//     with the single-attention-surface convention every other corner
//     overlay here already follows (CreditBanner/CreditBlocker/PersonaPill
//     never co-render more than one instance of themselves either).
//
// FA204 / frank functions-file convention (see creditGuard.js's own header
// note): every export below is SELF-CONTAINED — no export reads a sibling
// export or a module-scope helper. frank lifts each export individually;
// a bare module-scope helper reference reads as undefined after
// frank.toJSON() serialization.
/**
 * activeMeetingInvite(root) -> the single soonest qualifying
 * `meeting_starting` notification to show as a banner, or null.
 *
 * Excludes: already-read (dismissed) rows, invites for a workspace other
 * than the currently active one, events that have already ended
 * (metadata.endAt in the past), and events already joined (a meet room
 * exists for the event AND either it's the room currently connected or
 * the room itself has ended).
 */ const $18197540d8d4e4d6$export$22b7b44783888113 = function(root) {
    const r = root || this && this.state && this.state.root;
    if (!r || !r.signedIn) return null;
    const ws = r.workspace;
    const wsId = ws && (ws.id || ws._id) || null;
    const now = Date.now();
    const rooms = Array.isArray(r.rooms) ? r.rooms : [];
    const candidates = (r.notifs || []).filter((n)=>{
        if (!n || n.read) return false;
        const meta = n.metadata;
        if (!meta || meta.kind !== 'meeting_starting') return false;
        if (wsId != null && meta.workspaceId != null && String(meta.workspaceId) !== String(wsId)) return false;
        if (meta.endAt) {
            const endMs = Date.parse(meta.endAt);
            if (Number.isFinite(endMs) && now >= endMs) return false;
        }
        const room = rooms.find((rm)=>rm && rm.calendarEventId === meta.calendarEventId);
        if (room && (room.id === r.activeRoomId || room.endedAt)) return false;
        return true;
    });
    if (!candidates.length) return null;
    candidates.sort((a, b)=>{
        const am = Date.parse(a.metadata && a.metadata.startAt || '');
        const bm = Date.parse(b.metadata && b.metadata.startAt || '');
        return (Number.isFinite(am) ? am : Infinity) - (Number.isFinite(bm) ? bm : Infinity);
    });
    return candidates[0];
};
const $18197540d8d4e4d6$export$ad39ca56f3a5c01f = async function(notif) {
    if (!notif || !this || !this.call) return;
    const meta = notif.metadata || {};
    if (meta.calendarEventId == null) return;
    await this.call('joinEventCall', {
        id: meta.calendarEventId,
        title: meta.eventTitle || notif.title
    });
    try {
        await this.call('markNotificationRead', notif.id);
    } catch (err) {
        console.warn('[joinMeetingInvite] markNotificationRead failed:', err?.message || err);
    }
};

});

parcelRegister("lkMHI", function(module, exports) {

$parcel$export(module.exports, "ensureWorkspaceVoice", () => $f8813ed88f5127e5$export$3bfa8558d30c19c7);
$parcel$export(module.exports, "stopWorkspaceVoice", () => $f8813ed88f5127e5$export$3451a5f26274ae7a);
$parcel$export(module.exports, "acceptWorkspaceCall", () => $f8813ed88f5127e5$export$c5025b79eee62484);
$parcel$export(module.exports, "declineWorkspaceCall", () => $f8813ed88f5127e5$export$de2e28013616df64);
$parcel$export(module.exports, "hangUpWorkspaceCall", () => $f8813ed88f5127e5$export$ff336b5e4bc54c2e);
$parcel$export(module.exports, "toggleWorkspaceCallMute", () => $f8813ed88f5127e5$export$f2faff516d3a4316);
$parcel$export(module.exports, "toggleWorkspaceCallHold", () => $f8813ed88f5127e5$export$9b58c01bff9392ea);
$parcel$export(module.exports, "toggleWorkspaceCallKeypad", () => $f8813ed88f5127e5$export$e523f08cf01568d);
$parcel$export(module.exports, "pressWorkspaceCallDigit", () => $f8813ed88f5127e5$export$7ceee129be90d993);
$parcel$export(module.exports, "requestEndWorkspaceCall", () => $f8813ed88f5127e5$export$90de913c1317c3);
$parcel$export(module.exports, "dismissWorkspaceCall", () => $f8813ed88f5127e5$export$af5efaf880db01c1);
$parcel$export(module.exports, "cancelEndWorkspaceCall", () => $f8813ed88f5127e5$export$9a633be2ad472a23);
$parcel$export(module.exports, "workspaceCallAvailability", () => $f8813ed88f5127e5$export$c94d26a8bd463d3);
$parcel$export(module.exports, "startWorkspaceCall", () => $f8813ed88f5127e5$export$68077b759bac7f7a);
$parcel$export(module.exports, "workspaceCallEyebrow", () => $f8813ed88f5127e5$export$9dd6c84cf73766de);
$parcel$export(module.exports, "workspaceCallTitle", () => $f8813ed88f5127e5$export$469288463e690449);
$parcel$export(module.exports, "workspaceCallClock", () => $f8813ed88f5127e5$export$8f5fefa75fceffc2);
$parcel$export(module.exports, "workspaceCallMeta", () => $f8813ed88f5127e5$export$327af2be860b8916);
$parcel$export(module.exports, "workspaceCallRingMayTakeFocus", () => $f8813ed88f5127e5$export$cedb71be256096f);
$parcel$export(module.exports, "workspaceCallClear", () => $f8813ed88f5127e5$export$84b79e9be4ce0b1a);
$parcel$export(module.exports, "workspaceCallMissed", () => $f8813ed88f5127e5$export$51d4de9ec6fdbb1b);
// WORKSPACE CALLS — the shell call panel's runtime (comms-phone v2, "calls
// inside the workspace"). Nika 2026-10-01: "we should be making all calls and
// messaging preferebly inside the workspace through twillio/whatsapp APIs".
//
// ONE voice session per workspace session. The SDK owns every wire detail:
// `sdk.getService('channels').voiceClient({ workspaceId })` mints the voice
// token, opens the per-member call stream, and — for a LIVE Twilio number
// only — lazy-loads the Twilio Voice JS SDK with its own dynamic import
// (FA206). This file never imports Twilio and never opens a socket or a
// fetch: it drives the panel state from the voice client's events.
//
// THE PANEL STATE is ONE root key, `_callPanel` (null = idle, panel hidden),
// always written in its FULL shape (PANEL_SHAPE) so a merge never leaves a
// stale field from the previous call. `_callPanelTick` is a 1 s clock nudge
// that runs only while a call is answered (the in-call timer).
//
// CAPABILITY: the panel stays hidden when the SDK has no
// `channels.voiceClient` (an SDK build before comms-phone v2), when the
// server refuses a voice session (403 forbidden_workspace_role, 409
// no_browser_number / browser_calling_not_available, 400 account_required),
// or when the member is signed out. The server is the role gate: an owner,
// an admin or a member (stored `editor`) gets a token; a Contributor (stored
// `viewer`) or a guest gets the 403, which is KEPT, never retried on a clock
// (THE ROLE GATE below).
//
// THE LIVE OBJECTS (the voice client, the call handle, the pending incoming
// call) are not data and cannot ride state; they live in `_rt` below — the
// same module-singleton shape meet's connectCall.js uses for its LiveKit Room,
// for the same reason (a route change must never tear a call down). The
// workspace switch (functions/loadPrivateData.js) and the shell's onRemove
// call stopWorkspaceVoice, so a call never follows the member into another
// tenant.
// ── pure model ────────────────────────────────────────────────────────────
const $f8813ed88f5127e5$export$add5f4dcd0e8911b = [
    'completed',
    'no_answer',
    'busy',
    'failed',
    'canceled'
];
const $f8813ed88f5127e5$export$d8bd6518cb23a7d2 = 8000;
const $f8813ed88f5127e5$export$62fbe9a97e30b123 = Object.freeze({
    callId: null,
    direction: 'out',
    status: 'initiated',
    phase: 'outgoing',
    name: null,
    number: null,
    answeredAt: null,
    durationSec: null,
    muted: false,
    held: false,
    keypadOpen: false,
    digits: '',
    confirmEnd: false,
    canMute: false,
    canHold: false,
    canKeypad: false,
    busy: false,
    errorKey: null
});
// The literal key per ended state — never built by concatenation (the i18n
// gate resolves every key from its literal).
const $f8813ed88f5127e5$var$OUT_ENDED_KEYS = {
    completed: 'workspace.callPanel.ended.completed',
    no_answer: 'workspace.callPanel.ended.noAnswer',
    busy: 'workspace.callPanel.ended.busy',
    failed: 'workspace.callPanel.ended.failed',
    canceled: 'workspace.callPanel.ended.canceled'
};
const $f8813ed88f5127e5$export$e99071b5d77244e4 = (value)=>typeof value === 'string' && /^in/i.test(value) ? 'in' : 'out';
const $f8813ed88f5127e5$export$fbdc3f25ab13c654 = (status, direction)=>{
    if ($f8813ed88f5127e5$export$add5f4dcd0e8911b.includes(status)) return 'ended';
    if (status === 'answered') return 'active';
    return direction === 'in' ? 'incoming' : 'outgoing';
};
const $f8813ed88f5127e5$export$859696f1e9040a76 = (panel)=>!!panel && panel.phase === 'ended' && panel.direction === 'in' && panel.status !== 'completed';
const $f8813ed88f5127e5$export$f6c78625eb002318 = (panel)=>{
    if (!panel) return $f8813ed88f5127e5$var$OUT_ENDED_KEYS.failed;
    if ($f8813ed88f5127e5$export$859696f1e9040a76(panel)) return 'workspace.callPanel.ended.missed';
    return $f8813ed88f5127e5$var$OUT_ENDED_KEYS[panel.status] || $f8813ed88f5127e5$var$OUT_ENDED_KEYS.failed;
};
const $f8813ed88f5127e5$export$3422684a3fc6065e = (panel)=>{
    if (!panel) return null;
    if (panel.phase === 'incoming') return 'workspace.callPanel.incoming';
    if (panel.phase === 'active') return panel.held ? 'workspace.callPanel.onHold' : 'workspace.callPanel.onCall';
    if (panel.phase === 'ended') return $f8813ed88f5127e5$export$f6c78625eb002318(panel);
    return panel.status === 'ringing' ? 'workspace.callPanel.ringing' : 'workspace.callPanel.calling';
};
const $f8813ed88f5127e5$export$58cc022a79fdc9c4 = (seconds)=>{
    const total = Math.max(0, Math.floor(Number(seconds) || 0));
    const h = Math.floor(total / 3600);
    const m = Math.floor(total % 3600 / 60);
    const s = String(total % 60).padStart(2, '0');
    return h ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
};
const $f8813ed88f5127e5$export$db1201ea1c1edfe8 = (panel, now = Date.now())=>{
    if (!panel) return 0;
    if (panel.phase === 'ended' && panel.durationSec != null) return panel.durationSec;
    const at = panel.answeredAt ? Date.parse(panel.answeredAt) : NaN;
    return Number.isFinite(at) ? Math.max(0, Math.floor((now - at) / 1000)) : 0;
};
const $f8813ed88f5127e5$export$9f008c31f1438190 = (row, base = {})=>{
    const call = row && row.call || {};
    const direction = $f8813ed88f5127e5$export$e99071b5d77244e4(call.direction || row && row.direction || base.direction);
    const status = call.status || base.status || $f8813ed88f5127e5$export$62fbe9a97e30b123.status;
    const number = row ? direction === 'in' ? row.from : row.to : null;
    const party = row && row.party;
    return {
        ...$f8813ed88f5127e5$export$62fbe9a97e30b123,
        ...base,
        callId: row && row.id || base.callId || null,
        direction: direction,
        status: status,
        phase: $f8813ed88f5127e5$export$fbdc3f25ab13c654(status, direction),
        name: party && party.name || base.name || null,
        number: number || base.number || null,
        answeredAt: call.answeredAt || base.answeredAt || null,
        durationSec: call.durationSec != null ? call.durationSec : base.durationSec != null ? base.durationSec : null
    };
};
// A ring moves focus into the panel only when the member is not typing: an
// input that takes text, a textarea, a select or a contenteditable keeps it
// (design-d2 review). Buttons, checkboxes and the page body give it up.
const $f8813ed88f5127e5$var$NON_TEXT_INPUTS = [
    'button',
    'checkbox',
    'radio',
    'submit',
    'reset',
    'range',
    'color',
    'file',
    'image'
];
const $f8813ed88f5127e5$export$46a189ffd329dd24 = (active)=>{
    if (!active) return true;
    if (active.isContentEditable) return false;
    const tag = String(active.tagName || '').toUpperCase();
    if (tag === 'TEXTAREA' || tag === 'SELECT') return false;
    if (tag === 'INPUT') return $f8813ed88f5127e5$var$NON_TEXT_INPUTS.includes(String(active.type || 'text').toLowerCase());
    return true;
};
const $f8813ed88f5127e5$export$210d7e7a1d7b0fe7 = (rect)=>{
    if (!rect || !rect.height) return null;
    return `calc(${Math.ceil(rect.height)}px + var(--spacing-Z1))`;
};
const $f8813ed88f5127e5$export$f2ddb6fe3344a54b = (channels)=>!!channels && typeof channels.voiceClient === 'function';
const $f8813ed88f5127e5$export$909dc9ef84af38bf = (err)=>err && err.code != null && err.code !== '' ? String(err.code) : null;
// Refusals that will not change by retrying soon: no voice number, several
// numbers and no default, a 403 with no machine code. Retried after
// REFUSED_RETRY_MS (an admin may connect a number meanwhile); anything else
// after TRANSIENT_RETRY_MS. The role refusal is not on a clock (THE ROLE GATE).
const $f8813ed88f5127e5$var$REFUSED_CODES = [
    'http_403',
    'forbidden',
    'several_twilio_accounts',
    'no_browser_number',
    'browser_calling_not_available',
    'account_required',
    'account_paused',
    'account_disconnected'
];
const $f8813ed88f5127e5$var$REFUSED_RETRY_MS = 600000;
const $f8813ed88f5127e5$var$TRANSIENT_RETRY_MS = 60000;
// THE ROLE GATE. The server answers a voice session, a call start, an answer
// and a hang-up for an owner, an admin or a member (the channels routes'
// requireWorkspaceEditor); a Contributor (stored `viewer`) or a guest gets
// 403 `forbidden_workspace_role`. That refusal is KEPT for the workspace: a
// role does not change by waiting, and a clock retry is one more 403 on a
// route sync. It lifts when the member's role read (the server's own answer
// on the workspace read, roleHelpers.js callerWorkspaceRole) moves to ANOTHER
// known role, on a workspace switch and on sign-out (stopWorkspaceVoice). No
// role list lives here: the server stays the gate.
const $f8813ed88f5127e5$var$_callRoleRefused = (code)=>code === 'forbidden_workspace_role';
// ── runtime ───────────────────────────────────────────────────────────────
const $f8813ed88f5127e5$var$_rt = {
    voice: null,
    channels: null,
    session: null,
    wsId: null,
    starting: null,
    root: null,
    el: null,
    panel: null,
    handle: null,
    handleOff: null,
    incoming: null,
    tick: null,
    linger: null,
    blockedWs: null,
    retryAt: 0,
    refusal: null,
    // The role the member had when the server refused it (THE ROLE GATE); null
    // while the role read is not known yet.
    refusedRole: null,
    unsupported: false
};
const $f8813ed88f5127e5$var$_shellWsIdOf = (root)=>{
    if (!root) return null;
    const ws = root.workspace;
    return ws && (ws.id || ws._id) || root.activeWorkspaceId || null;
};
const $f8813ed88f5127e5$var$_clearTimers = ()=>{
    if ($f8813ed88f5127e5$var$_rt.tick) clearInterval($f8813ed88f5127e5$var$_rt.tick);
    if ($f8813ed88f5127e5$var$_rt.linger) clearTimeout($f8813ed88f5127e5$var$_rt.linger);
    $f8813ed88f5127e5$var$_rt.tick = null;
    $f8813ed88f5127e5$var$_rt.linger = null;
};
const $f8813ed88f5127e5$var$_write = (panel)=>{
    $f8813ed88f5127e5$var$_rt.panel = panel ? {
        ...$f8813ed88f5127e5$export$62fbe9a97e30b123,
        ...panel
    } : null;
    const root = $f8813ed88f5127e5$var$_rt.root;
    if (root && typeof root.update === 'function') root.update({
        _callPanel: $f8813ed88f5127e5$var$_rt.panel ? {
            ...$f8813ed88f5127e5$var$_rt.panel
        } : null
    }, {
        preventFetch: true
    });
    const phase = $f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.phase;
    if (phase === 'active' && !$f8813ed88f5127e5$var$_rt.tick) $f8813ed88f5127e5$var$_rt.tick = setInterval(()=>{
        if ($f8813ed88f5127e5$var$_rt.root && typeof $f8813ed88f5127e5$var$_rt.root.update === 'function') $f8813ed88f5127e5$var$_rt.root.update({
            _callPanelTick: Date.now()
        }, {
            preventFetch: true
        });
    }, 1000);
    else if (phase !== 'active' && $f8813ed88f5127e5$var$_rt.tick) {
        clearInterval($f8813ed88f5127e5$var$_rt.tick);
        $f8813ed88f5127e5$var$_rt.tick = null;
    }
    if ($f8813ed88f5127e5$var$_rt.linger && phase !== 'ended') {
        clearTimeout($f8813ed88f5127e5$var$_rt.linger);
        $f8813ed88f5127e5$var$_rt.linger = null;
    }
};
const $f8813ed88f5127e5$var$_shellPatch = (partial)=>{
    if (!$f8813ed88f5127e5$var$_rt.panel) return;
    $f8813ed88f5127e5$var$_write({
        ...$f8813ed88f5127e5$var$_rt.panel,
        ...partial
    });
};
const $f8813ed88f5127e5$var$_detachHandle = ()=>{
    if (typeof $f8813ed88f5127e5$var$_rt.handleOff === 'function') try {
        $f8813ed88f5127e5$var$_rt.handleOff();
    } catch (_) {
    /* already detached */ }
    $f8813ed88f5127e5$var$_rt.handle = null;
    $f8813ed88f5127e5$var$_rt.handleOff = null;
};
// A call reached a terminal state: drop the live objects, keep the summary.
const $f8813ed88f5127e5$var$_shellSettle = ()=>{
    $f8813ed88f5127e5$var$_detachHandle();
    $f8813ed88f5127e5$var$_rt.incoming = null;
    const panel = $f8813ed88f5127e5$var$_rt.panel;
    if (!panel || panel.phase !== 'ended' || $f8813ed88f5127e5$export$859696f1e9040a76(panel)) return;
    if ($f8813ed88f5127e5$var$_rt.linger) clearTimeout($f8813ed88f5127e5$var$_rt.linger);
    const callId = panel.callId;
    $f8813ed88f5127e5$var$_rt.linger = setTimeout(()=>{
        $f8813ed88f5127e5$var$_rt.linger = null;
        if ($f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.callId === callId && $f8813ed88f5127e5$var$_rt.panel.phase === 'ended') $f8813ed88f5127e5$var$_write(null);
    }, $f8813ed88f5127e5$export$d8bd6518cb23a7d2);
};
// Apply a fresh call row (stream frame, handle state, getCall answer).
const $f8813ed88f5127e5$var$_applyRow = (row, extra = {})=>{
    const panel = $f8813ed88f5127e5$var$_rt.panel;
    if (!panel || !row || row.id && panel.callId && row.id !== panel.callId) return;
    // ONE end per call: once ended, a later frame (the stream confirming a
    // local end, a refined status) changes nothing but a duration the server
    // measured. No second write, no second settle.
    if (panel.phase === 'ended') {
        const sec = row.call && row.call.durationSec;
        if (typeof sec === 'number' && sec !== panel.durationSec) $f8813ed88f5127e5$var$_write({
            ...panel,
            durationSec: sec
        });
        return;
    }
    const next = $f8813ed88f5127e5$export$9f008c31f1438190(row, {
        ...panel,
        ...extra
    });
    // The panel's own flags survive a row update; a terminal row clears them.
    if (next.phase === 'ended') {
        next.confirmEnd = false;
        next.keypadOpen = false;
        next.busy = false;
        if (next.durationSec == null && panel.answeredAt) next.durationSec = $f8813ed88f5127e5$export$db1201ea1c1edfe8(panel);
    }
    $f8813ed88f5127e5$var$_write(next);
    if (next.phase === 'ended') $f8813ed88f5127e5$var$_shellSettle();
};
const $f8813ed88f5127e5$var$_attachHandle = (handle)=>{
    $f8813ed88f5127e5$var$_detachHandle();
    if (!handle) return;
    $f8813ed88f5127e5$var$_rt.handle = handle;
    const offs = [];
    if (typeof handle.on === 'function') offs.push(handle.on('state', ()=>{
        if ($f8813ed88f5127e5$var$_rt.handle === handle) $f8813ed88f5127e5$var$_applyRow(handle.call);
    }), // v3 (1): the handle's hold state is the truth (simulated always; live
    // only when the server reports capabilities.hold).
    handle.on('hold', (on)=>{
        if ($f8813ed88f5127e5$var$_rt.handle === handle) $f8813ed88f5127e5$var$_shellPatch({
            held: !!on
        });
    }));
    $f8813ed88f5127e5$var$_rt.handleOff = ()=>offs.forEach((off)=>typeof off === 'function' && off());
    $f8813ed88f5127e5$var$_shellPatch({
        held: typeof handle.isHeld === 'function' ? !!handle.isHeld() : false,
        canMute: typeof handle.mute === 'function',
        canHold: typeof handle.hold === 'function',
        canKeypad: typeof handle.sendDigits === 'function',
        muted: typeof handle.isMuted === 'function' ? !!handle.isMuted() : false
    });
};
const $f8813ed88f5127e5$var$_refreshPanelCall = ()=>{
    const panel = $f8813ed88f5127e5$var$_rt.panel;
    const channels = $f8813ed88f5127e5$var$_rt.channels;
    if (!panel || !panel.callId || !channels || typeof channels.getCall !== 'function') return;
    const callId = panel.callId;
    Promise.resolve(channels.getCall(callId, {
        workspaceId: $f8813ed88f5127e5$var$_rt.wsId
    })).then((res)=>{
        const row = (res && res.call && res.call.id ? res.call : null) || (res && res.id ? res : null);
        if (row && $f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.callId === callId) $f8813ed88f5127e5$var$_applyRow(row);
    }).catch(()=>{
    /* the next stream frame reconciles */ });
};
// A Device or call error during a call (voice_device_error, call_error): the
// panel names it; the call's own state still comes from its frames. A role
// refusal with no call on screen (the token renewal of a member whose role
// dropped) ends the session the server no longer honours.
const $f8813ed88f5127e5$var$_onError = (voice)=>(err)=>{
        if ($f8813ed88f5127e5$var$_rt.voice !== voice) return;
        const code = $f8813ed88f5127e5$export$909dc9ef84af38bf(err);
        const onCall = !!$f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.phase !== 'ended';
        if ($f8813ed88f5127e5$var$_callRoleRefused(code) && !onCall) {
            $f8813ed88f5127e5$var$_callEndForRole($f8813ed88f5127e5$var$_rt.el, code);
            return;
        }
        if (!onCall) return;
        $f8813ed88f5127e5$var$_shellPatch({
            errorKey: $f8813ed88f5127e5$export$39c53995c3c4b029(code)
        });
    };
const $f8813ed88f5127e5$var$_onIncoming = (voice)=>(incoming)=>{
        if ($f8813ed88f5127e5$var$_rt.voice !== voice || !incoming) return;
        // Already on a call: let this one ring through to the member's next leg.
        if ($f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.phase !== 'ended') return;
        $f8813ed88f5127e5$var$_clearTimers();
        $f8813ed88f5127e5$var$_detachHandle();
        $f8813ed88f5127e5$var$_rt.incoming = incoming;
        // v3: the caller hung up before accept → the incoming moves to 'canceled'
        // at once (SDK d742a1a). End the ring now; the local frame and the stream
        // frame that follow are no-ops (one end).
        if (typeof incoming.on === 'function') incoming.on('state', (status)=>{
            if ($f8813ed88f5127e5$var$_rt.incoming !== incoming || !$f8813ed88f5127e5$export$add5f4dcd0e8911b.includes(status)) return;
            $f8813ed88f5127e5$var$_applyRow({
                ...incoming.call || {
                    id: incoming.callId
                },
                id: incoming.callId || incoming.call && incoming.call.id,
                call: {
                    ...incoming.call && incoming.call.call || {},
                    direction: 'in',
                    status: status
                }
            });
        });
        $f8813ed88f5127e5$var$_write($f8813ed88f5127e5$export$9f008c31f1438190(incoming.call || null, {
            callId: incoming.callId || null,
            direction: 'in',
            status: 'ringing'
        }));
        // Live mode hands over no row (the Twilio call carries only the id): read it
        // for the caller's name and number.
        if (!incoming.call) $f8813ed88f5127e5$var$_refreshPanelCall();
    };
const $f8813ed88f5127e5$var$_onFrame = (voice)=>(frame)=>{
        if ($f8813ed88f5127e5$var$_rt.voice !== voice || !frame || !$f8813ed88f5127e5$var$_rt.panel) return;
        if (frame.id && frame.id === $f8813ed88f5127e5$var$_rt.panel.callId && frame.call) $f8813ed88f5127e5$var$_applyRow(frame.call);
    };
const $f8813ed88f5127e5$var$_onOpen = (voice)=>()=>{
        if ($f8813ed88f5127e5$var$_rt.voice === voice) $f8813ed88f5127e5$var$_refreshPanelCall();
    };
const $f8813ed88f5127e5$var$_callTeardown = ()=>{
    const voice = $f8813ed88f5127e5$var$_rt.voice;
    $f8813ed88f5127e5$var$_clearTimers();
    $f8813ed88f5127e5$var$_detachHandle();
    $f8813ed88f5127e5$var$_rt.incoming = null;
    $f8813ed88f5127e5$var$_rt.voice = null;
    $f8813ed88f5127e5$var$_rt.session = null;
    $f8813ed88f5127e5$var$_rt.channels = null;
    $f8813ed88f5127e5$var$_rt.wsId = null;
    $f8813ed88f5127e5$var$_rt.starting = null;
    if (voice && typeof voice.stop === 'function') try {
        voice.stop();
    } catch (_) {
    /* already stopped */ }
};
// THE ROLE GATE helpers. The role read is the shell's own (the server's answer
// on the workspace read); undefined while it has not landed.
const $f8813ed88f5127e5$var$_callRoleOf = (el)=>{
    if (!el || typeof el.call !== 'function') return null;
    const role = el.call('callerWorkspaceRole', $f8813ed88f5127e5$var$_rt.root || el.state && el.state.root);
    return typeof role === 'string' && role ? role : null;
};
// Keep a role refusal for this workspace, with the role the member had when
// the server said no.
const $f8813ed88f5127e5$var$_callKeepRoleRefusal = (wsId, code, role)=>{
    $f8813ed88f5127e5$var$_rt.refusal = code;
    $f8813ed88f5127e5$var$_rt.blockedWs = wsId;
    $f8813ed88f5127e5$var$_rt.retryAt = Infinity;
    $f8813ed88f5127e5$var$_rt.refusedRole = role || null;
};
// A kept role refusal lifts only when the role read moves to ANOTHER known
// role (a promotion reaches the shell on its next workspace read). Unknown to
// known is no change: the server already judged the role the member has.
const $f8813ed88f5127e5$var$_callRoleRecheck = (el)=>{
    const role = $f8813ed88f5127e5$var$_callRoleOf(el);
    if (!role) return;
    if (!$f8813ed88f5127e5$var$_rt.refusedRole) {
        $f8813ed88f5127e5$var$_rt.refusedRole = role;
        return;
    }
    if (role === $f8813ed88f5127e5$var$_rt.refusedRole) return;
    $f8813ed88f5127e5$var$_rt.blockedWs = null;
    $f8813ed88f5127e5$var$_rt.retryAt = 0;
    $f8813ed88f5127e5$var$_rt.refusal = null;
    $f8813ed88f5127e5$var$_rt.refusedRole = null;
};
// The server refused this member's role on a live session (the role dropped
// mid-session): end the session it no longer honours, so this tab rings no
// more, and keep the refusal. An ended summary on screen keeps its own timer.
const $f8813ed88f5127e5$var$_callEndForRole = (el, code)=>{
    const wsId = $f8813ed88f5127e5$var$_rt.wsId;
    $f8813ed88f5127e5$var$_callTeardown();
    if (wsId) $f8813ed88f5127e5$var$_callKeepRoleRefusal(wsId, code, $f8813ed88f5127e5$var$_callRoleOf(el));
    $f8813ed88f5127e5$var$_shellSettle();
};
// The line for a refused in-call action: the role line when the server
// refused the member's role, else the action's own line. The call stays on
// screen with its hang-up: the server still holds it.
const $f8813ed88f5127e5$var$_callRefusalLine = (err, line)=>{
    const code = $f8813ed88f5127e5$export$909dc9ef84af38bf(err);
    return $f8813ed88f5127e5$var$_callRoleRefused(code) ? $f8813ed88f5127e5$export$39c53995c3c4b029(code) : line;
};
const $f8813ed88f5127e5$var$_channelsOf = async (el)=>{
    const sdk = el && typeof el.call === 'function' ? el.call('getSDK') : null;
    if (!sdk || typeof sdk.getService !== 'function') return null;
    return Promise.resolve(sdk.getService('channels')).catch(()=>null);
};
async function $f8813ed88f5127e5$export$3bfa8558d30c19c7() {
    const root = this && this.state && this.state.root;
    if (!root) return null;
    // Signed out (logout resets the root and routes to /login without a shell
    // remount): end any session that is still up.
    if (!(root.signedIn || root.currentUserEmail)) {
        if ($f8813ed88f5127e5$var$_rt.voice || $f8813ed88f5127e5$var$_rt.panel || $f8813ed88f5127e5$var$_rt.starting) $f8813ed88f5127e5$export$3451a5f26274ae7a.call(this);
        return null;
    }
    const wsId = $f8813ed88f5127e5$var$_shellWsIdOf(root);
    if (!wsId) return null;
    if ($f8813ed88f5127e5$var$_rt.wsId && $f8813ed88f5127e5$var$_rt.wsId !== wsId) {
        $f8813ed88f5127e5$var$_callTeardown();
        $f8813ed88f5127e5$var$_write(null);
    }
    $f8813ed88f5127e5$var$_rt.root = root;
    $f8813ed88f5127e5$var$_rt.el = this;
    if ($f8813ed88f5127e5$var$_rt.voice && $f8813ed88f5127e5$var$_rt.wsId === wsId) return $f8813ed88f5127e5$var$_rt.session;
    if ($f8813ed88f5127e5$var$_rt.starting) return $f8813ed88f5127e5$var$_rt.starting;
    if ($f8813ed88f5127e5$var$_rt.unsupported) return null;
    if ($f8813ed88f5127e5$var$_rt.blockedWs === wsId && $f8813ed88f5127e5$var$_callRoleRefused($f8813ed88f5127e5$var$_rt.refusal)) $f8813ed88f5127e5$var$_callRoleRecheck(this);
    if ($f8813ed88f5127e5$var$_rt.blockedWs === wsId && Date.now() < $f8813ed88f5127e5$var$_rt.retryAt) return null;
    $f8813ed88f5127e5$var$_rt.wsId = wsId;
    const el = this;
    const run = (async ()=>{
        const channels = await $f8813ed88f5127e5$var$_channelsOf(el);
        if ($f8813ed88f5127e5$var$_rt.wsId !== wsId) return null;
        if (!$f8813ed88f5127e5$export$f2ddb6fe3344a54b(channels)) {
            $f8813ed88f5127e5$var$_rt.unsupported = !!channels;
            $f8813ed88f5127e5$var$_rt.blockedWs = wsId;
            $f8813ed88f5127e5$var$_rt.retryAt = Date.now() + $f8813ed88f5127e5$var$TRANSIENT_RETRY_MS;
            $f8813ed88f5127e5$var$_rt.wsId = null;
            return null;
        }
        const voice = channels.voiceClient({
            workspaceId: wsId
        });
        try {
            voice.on('incoming', $f8813ed88f5127e5$var$_onIncoming(voice));
            voice.on('call', $f8813ed88f5127e5$var$_onFrame(voice));
            voice.on('open', $f8813ed88f5127e5$var$_onOpen(voice));
            voice.on('error', $f8813ed88f5127e5$var$_onError(voice));
            const session = await voice.start();
            if ($f8813ed88f5127e5$var$_rt.wsId !== wsId) {
                voice.stop();
                return null;
            }
            $f8813ed88f5127e5$var$_rt.voice = voice;
            $f8813ed88f5127e5$var$_rt.channels = channels;
            $f8813ed88f5127e5$var$_rt.session = session || null;
            $f8813ed88f5127e5$var$_rt.blockedWs = null;
            $f8813ed88f5127e5$var$_rt.refusal = null;
            $f8813ed88f5127e5$var$_rt.refusedRole = null;
            return $f8813ed88f5127e5$var$_rt.session;
        } catch (err) {
            try {
                voice.stop();
            } catch (_) {
            /* never started */ }
            const code = $f8813ed88f5127e5$export$909dc9ef84af38bf(err);
            if ($f8813ed88f5127e5$var$_callRoleRefused(code)) $f8813ed88f5127e5$var$_callKeepRoleRefusal(wsId, code, $f8813ed88f5127e5$var$_callRoleOf(el));
            else {
                $f8813ed88f5127e5$var$_rt.refusal = code;
                $f8813ed88f5127e5$var$_rt.blockedWs = wsId;
                $f8813ed88f5127e5$var$_rt.retryAt = Date.now() + ($f8813ed88f5127e5$var$REFUSED_CODES.includes(code) ? $f8813ed88f5127e5$var$REFUSED_RETRY_MS : $f8813ed88f5127e5$var$TRANSIENT_RETRY_MS);
            }
            if ($f8813ed88f5127e5$var$_rt.wsId === wsId) $f8813ed88f5127e5$var$_rt.wsId = null;
            return null;
        }
    })();
    $f8813ed88f5127e5$var$_rt.starting = run;
    run.finally(()=>{
        if ($f8813ed88f5127e5$var$_rt.starting === run) $f8813ed88f5127e5$var$_rt.starting = null;
    });
    return run;
}
function $f8813ed88f5127e5$export$3451a5f26274ae7a() {
    const root = this && this.state && this.state.root || $f8813ed88f5127e5$var$_rt.root;
    $f8813ed88f5127e5$var$_callTeardown();
    $f8813ed88f5127e5$var$_rt.blockedWs = null;
    $f8813ed88f5127e5$var$_rt.retryAt = 0;
    $f8813ed88f5127e5$var$_rt.refusedRole = null;
    if (root) $f8813ed88f5127e5$var$_rt.root = root;
    $f8813ed88f5127e5$var$_write(null);
    $f8813ed88f5127e5$var$_rt.root = null;
    $f8813ed88f5127e5$var$_rt.el = null;
}
async function $f8813ed88f5127e5$export$c5025b79eee62484() {
    const incoming = $f8813ed88f5127e5$var$_rt.incoming;
    if (!incoming || !$f8813ed88f5127e5$var$_rt.panel || $f8813ed88f5127e5$var$_rt.panel.busy) return false;
    $f8813ed88f5127e5$var$_shellPatch({
        busy: true,
        confirmEnd: false,
        errorKey: null
    });
    try {
        const handle = await incoming.accept();
        if ($f8813ed88f5127e5$var$_rt.incoming !== incoming) return false;
        $f8813ed88f5127e5$var$_rt.incoming = null;
        $f8813ed88f5127e5$var$_attachHandle(handle);
        $f8813ed88f5127e5$var$_shellPatch({
            busy: false
        });
        if (handle && handle.call) $f8813ed88f5127e5$var$_applyRow(handle.call);
        return true;
    } catch (err) {
        const code = $f8813ed88f5127e5$export$909dc9ef84af38bf(err);
        if ($f8813ed88f5127e5$var$_callRoleRefused(code)) {
            // The server refused the answer for this member's role (the role
            // dropped mid-session): the ring ends here as a missed call with the
            // role line, and the session ends, so no Accept is left to press.
            const panel = $f8813ed88f5127e5$var$_rt.panel;
            $f8813ed88f5127e5$var$_callEndForRole(this, code);
            if (panel) $f8813ed88f5127e5$var$_write({
                ...panel,
                status: panel.phase === 'ended' ? panel.status : 'no_answer',
                phase: 'ended',
                busy: false,
                confirmEnd: false,
                keypadOpen: false,
                errorKey: $f8813ed88f5127e5$export$39c53995c3c4b029(code)
            });
            return false;
        }
        $f8813ed88f5127e5$var$_shellPatch({
            busy: false,
            errorKey: 'workspace.callPanel.error.accept'
        });
        return false;
    }
}
async function $f8813ed88f5127e5$export$de2e28013616df64() {
    const incoming = $f8813ed88f5127e5$var$_rt.incoming;
    if (!incoming) return false;
    $f8813ed88f5127e5$var$_rt.incoming = null;
    // A declined call leaves no summary: the member chose not to take it, and
    // the server rings the next leg (or records the miss and rings the bell).
    $f8813ed88f5127e5$var$_write(null);
    try {
        await incoming.reject();
        return true;
    } catch (_) {
        return false;
    }
}
async function $f8813ed88f5127e5$export$ff336b5e4bc54c2e() {
    if ($f8813ed88f5127e5$var$_rt.incoming && !$f8813ed88f5127e5$var$_rt.handle) return $f8813ed88f5127e5$export$de2e28013616df64.call(this);
    const handle = $f8813ed88f5127e5$var$_rt.handle;
    if (!$f8813ed88f5127e5$var$_rt.panel || $f8813ed88f5127e5$var$_rt.panel.phase === 'ended') return false;
    $f8813ed88f5127e5$var$_shellPatch({
        busy: true,
        confirmEnd: false,
        keypadOpen: false,
        errorKey: null
    });
    try {
        if (!handle) {
            $f8813ed88f5127e5$var$_shellPatch({
                busy: false,
                errorKey: 'workspace.callPanel.error.hangUp'
            });
            return false;
        }
        await handle.hangup();
        // The stream frame settles the panel; a handle that already knows the end
        // settles it now.
        // v3 (6): hangup() settles the handle at once; the stream frame confirms.
        if ($f8813ed88f5127e5$export$add5f4dcd0e8911b.includes(handle.status)) $f8813ed88f5127e5$var$_applyRow(handle.call);
        else $f8813ed88f5127e5$var$_shellPatch({
            busy: false
        });
        return true;
    } catch (err) {
        $f8813ed88f5127e5$var$_shellPatch({
            busy: false,
            errorKey: $f8813ed88f5127e5$var$_callRefusalLine(err, 'workspace.callPanel.error.hangUp')
        });
        return false;
    }
}
function $f8813ed88f5127e5$export$f2faff516d3a4316() {
    const handle = $f8813ed88f5127e5$var$_rt.handle;
    if (!handle || typeof handle.mute !== 'function') return false;
    const next = !(typeof handle.isMuted === 'function' ? handle.isMuted() : $f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.muted);
    handle.mute(next);
    $f8813ed88f5127e5$var$_shellPatch({
        muted: typeof handle.isMuted === 'function' ? !!handle.isMuted() : next
    });
    return true;
}
async function $f8813ed88f5127e5$export$9b58c01bff9392ea() {
    const handle = $f8813ed88f5127e5$var$_rt.handle;
    if (!handle || typeof handle.hold !== 'function' || !$f8813ed88f5127e5$var$_rt.panel) return false;
    const next = !$f8813ed88f5127e5$var$_rt.panel.held;
    try {
        await handle.hold(next);
        $f8813ed88f5127e5$var$_shellPatch({
            held: typeof handle.isHeld === 'function' ? !!handle.isHeld() : next
        });
        return true;
    } catch (err) {
        $f8813ed88f5127e5$var$_shellPatch({
            errorKey: $f8813ed88f5127e5$var$_callRefusalLine(err, 'workspace.callPanel.error.hold')
        });
        return false;
    }
}
function $f8813ed88f5127e5$export$e523f08cf01568d() {
    if (!$f8813ed88f5127e5$var$_rt.panel || !$f8813ed88f5127e5$var$_rt.panel.canKeypad) return false;
    $f8813ed88f5127e5$var$_shellPatch({
        keypadOpen: !$f8813ed88f5127e5$var$_rt.panel.keypadOpen
    });
    return true;
}
function $f8813ed88f5127e5$export$7ceee129be90d993(digit) {
    const handle = $f8813ed88f5127e5$var$_rt.handle;
    const d = String(digit == null ? '' : digit);
    if (!handle || typeof handle.sendDigits !== 'function' || !/^[0-9*#]$/.test(d)) return false;
    try {
        handle.sendDigits(d);
    } catch (_) {
        // v3 (1): the handle refuses what it cannot send (invalid_digits).
        return false;
    }
    $f8813ed88f5127e5$var$_shellPatch({
        digits: `${$f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.digits || ''}${d}`.slice(-24)
    });
    return true;
}
async function $f8813ed88f5127e5$export$90de913c1317c3() {
    const panel = $f8813ed88f5127e5$var$_rt.panel;
    if (!panel) return false;
    if (panel.phase === 'ended') return $f8813ed88f5127e5$export$af5efaf880db01c1.call(this);
    if (!panel.confirmEnd) {
        $f8813ed88f5127e5$var$_shellPatch({
            confirmEnd: true,
            keypadOpen: false
        });
        return true;
    }
    return panel.phase === 'incoming' ? $f8813ed88f5127e5$export$de2e28013616df64.call(this) : $f8813ed88f5127e5$export$ff336b5e4bc54c2e.call(this);
}
function $f8813ed88f5127e5$export$9a633be2ad472a23() {
    if (!$f8813ed88f5127e5$var$_rt.panel || !$f8813ed88f5127e5$var$_rt.panel.confirmEnd) return false;
    $f8813ed88f5127e5$var$_shellPatch({
        confirmEnd: false
    });
    return true;
}
function $f8813ed88f5127e5$export$af5efaf880db01c1() {
    if (!$f8813ed88f5127e5$var$_rt.panel || $f8813ed88f5127e5$var$_rt.panel.phase !== 'ended') return false;
    $f8813ed88f5127e5$var$_write(null);
    return true;
}
// ── starting a call (slice 2: the entry point other surfaces el.call) ────────
// Refusals that mean "this workspace cannot call from the browser": the
// caller falls back (the device path, tel:), and the panel never shows.
const $f8813ed88f5127e5$var$NO_BROWSER_CODES = [
    'several_twilio_accounts',
    'no_browser_number',
    'browser_calling_not_available',
    'account_required',
    'account_paused',
    'account_disconnected',
    'http_403',
    'forbidden'
];
const $f8813ed88f5127e5$export$833e89345fecfd41 = (err)=>$f8813ed88f5127e5$export$909dc9ef84af38bf(err) === 'microphone_denied';
// The panel line per voice-client code — literal keys (the i18n gate reads
// them); an unknown code takes the generic "did not start" line.
const $f8813ed88f5127e5$var$CALL_ERROR_KEYS = {
    microphone_denied: 'workspace.callPanel.error.microphone',
    call_not_connected: 'workspace.callPanel.error.notConnected',
    voice_device_unavailable: 'workspace.callPanel.error.device',
    voice_device_error: 'workspace.callPanel.error.device',
    voice_sdk_unavailable: 'workspace.callPanel.error.device',
    call_error: 'workspace.callPanel.error.callError',
    call_not_started: 'workspace.callPanel.error.start',
    forbidden_workspace_role: 'workspace.callPanel.error.role'
};
const $f8813ed88f5127e5$export$39c53995c3c4b029 = (code)=>code && $f8813ed88f5127e5$var$CALL_ERROR_KEYS[code] || 'workspace.callPanel.error.start';
// Why there is no session: no voice client in the SDK, the server's refusal
// code (v3: e.g. several_twilio_accounts), else 'unavailable'.
const $f8813ed88f5127e5$var$_refusalCode = ()=>$f8813ed88f5127e5$var$_rt.unsupported ? 'unsupported' : $f8813ed88f5127e5$var$_rt.refusal || 'unavailable';
async function $f8813ed88f5127e5$export$c94d26a8bd463d3() {
    await $f8813ed88f5127e5$export$3bfa8558d30c19c7.call(this);
    if ($f8813ed88f5127e5$var$_rt.voice) {
        const accountIds = Array.isArray($f8813ed88f5127e5$var$_rt.voice.accountIds) ? [
            ...$f8813ed88f5127e5$var$_rt.voice.accountIds
        ] : [];
        return {
            available: true,
            mode: $f8813ed88f5127e5$var$_rt.session && $f8813ed88f5127e5$var$_rt.session.mode || null,
            accountIds: accountIds
        };
    }
    return {
        available: false,
        mode: null,
        code: $f8813ed88f5127e5$var$_refusalCode()
    };
}
async function $f8813ed88f5127e5$export$68077b759bac7f7a(opts = {}) {
    const { partyId: partyId, conversationId: conversationId, regarding: regarding, name: name, callId: callId, accountId: accountId } = opts || {};
    const to = opts && (opts.to || opts.number) || undefined;
    if (!callId && !partyId && !conversationId && !to) return {
        ok: false,
        code: 'bad_request'
    };
    await $f8813ed88f5127e5$export$3bfa8558d30c19c7.call(this);
    const voice = $f8813ed88f5127e5$var$_rt.voice;
    if (!voice) return {
        ok: false,
        code: $f8813ed88f5127e5$var$_refusalCode()
    };
    if ($f8813ed88f5127e5$var$_rt.panel && $f8813ed88f5127e5$var$_rt.panel.phase !== 'ended') return {
        ok: false,
        code: 'busy'
    };
    $f8813ed88f5127e5$var$_clearTimers();
    $f8813ed88f5127e5$var$_detachHandle();
    $f8813ed88f5127e5$var$_rt.incoming = null;
    const base = {
        direction: 'out',
        status: 'initiated',
        name: name || null,
        number: to || null
    };
    if (callId) {
        // v3 (2): follow a call started elsewhere. The attached handle carries no
        // audio here (no mute / keypad / hold); its hangup() goes through the
        // SDK's calls hang-up (POST /calls/:id/hangup).
        $f8813ed88f5127e5$var$_write({
            ...$f8813ed88f5127e5$export$62fbe9a97e30b123,
            ...base,
            callId: callId
        });
        let attached;
        try {
            attached = await voice.attach(callId);
        } catch (err) {
            if ($f8813ed88f5127e5$var$_rt.voice === voice) $f8813ed88f5127e5$var$_write(null);
            return {
                ok: false,
                code: $f8813ed88f5127e5$export$909dc9ef84af38bf(err) || 'not_found'
            };
        }
        if ($f8813ed88f5127e5$var$_rt.voice !== voice || !attached) return {
            ok: false,
            code: 'stopped'
        };
        $f8813ed88f5127e5$var$_attachHandle(attached);
        if (attached.call) $f8813ed88f5127e5$var$_applyRow(attached.call);
        return {
            ok: true,
            callId: callId,
            adopted: true
        };
    }
    $f8813ed88f5127e5$var$_write({
        ...$f8813ed88f5127e5$export$62fbe9a97e30b123,
        ...base,
        busy: true
    });
    let handle;
    try {
        handle = await voice.call({
            ...partyId ? {
                partyId: partyId
            } : {},
            ...conversationId ? {
                conversationId: conversationId
            } : {},
            ...to ? {
                to: to
            } : {},
            ...regarding ? {
                regarding: regarding
            } : {},
            ...accountId ? {
                accountId: accountId
            } : {}
        });
    } catch (err) {
        if ($f8813ed88f5127e5$var$_rt.voice !== voice) return {
            ok: false,
            code: 'stopped'
        };
        const code = $f8813ed88f5127e5$export$909dc9ef84af38bf(err) || 'call_not_started';
        if ($f8813ed88f5127e5$var$_callRoleRefused(code)) {
            // The member's role dropped mid-session: no failed panel (the caller
            // falls back to the device path, as for NO_BROWSER_CODES), and the
            // session the server no longer honours ends (THE ROLE GATE).
            $f8813ed88f5127e5$var$_write(null);
            $f8813ed88f5127e5$var$_callEndForRole(this, code);
            return {
                ok: false,
                code: code
            };
        }
        if ($f8813ed88f5127e5$var$NO_BROWSER_CODES.includes(code)) {
            $f8813ed88f5127e5$var$_write(null);
            return {
                ok: false,
                code: code
            };
        }
        $f8813ed88f5127e5$var$_write({
            ...$f8813ed88f5127e5$var$_rt.panel || $f8813ed88f5127e5$export$62fbe9a97e30b123,
            ...base,
            status: 'failed',
            phase: 'ended',
            busy: false,
            errorKey: $f8813ed88f5127e5$export$39c53995c3c4b029(code)
        });
        $f8813ed88f5127e5$var$_shellSettle();
        return {
            ok: false,
            code: code
        };
    }
    if ($f8813ed88f5127e5$var$_rt.voice !== voice || !handle) return {
        ok: false,
        code: 'stopped'
    };
    $f8813ed88f5127e5$var$_write({
        ...$f8813ed88f5127e5$var$_rt.panel || $f8813ed88f5127e5$export$62fbe9a97e30b123,
        callId: handle.callId || null,
        busy: false
    });
    $f8813ed88f5127e5$var$_attachHandle(handle);
    if (handle.call) $f8813ed88f5127e5$var$_applyRow(handle.call);
    return {
        ok: true,
        callId: handle.callId || null
    };
}
function $f8813ed88f5127e5$export$9dd6c84cf73766de(panel) {
    const key = $f8813ed88f5127e5$export$3422684a3fc6065e(panel);
    return key ? this.call('polyglot', key) : '';
}
function $f8813ed88f5127e5$export$469288463e690449(panel) {
    if (!panel) return '';
    return panel.name || panel.number || this.call('polyglot', 'workspace.callPanel.unknownCaller');
}
function $f8813ed88f5127e5$export$8f5fefa75fceffc2(panel) {
    if (!panel) return '';
    if (panel.phase === 'active') return $f8813ed88f5127e5$export$58cc022a79fdc9c4($f8813ed88f5127e5$export$db1201ea1c1edfe8(panel));
    if (panel.phase === 'ended' && panel.status === 'completed') return this.call('polyglot', 'workspace.callPanel.duration').replace('{duration}', $f8813ed88f5127e5$export$58cc022a79fdc9c4($f8813ed88f5127e5$export$db1201ea1c1edfe8(panel)));
    return '';
}
function $f8813ed88f5127e5$export$327af2be860b8916(panel) {
    if (!panel) return '';
    const parts = [];
    if (panel.name && panel.number) parts.push(panel.number);
    const clock = $f8813ed88f5127e5$export$8f5fefa75fceffc2.call(this, panel);
    if (clock) parts.push(clock);
    return parts.join(" \xb7 ");
}
function $f8813ed88f5127e5$export$cedb71be256096f(active) {
    return $f8813ed88f5127e5$export$46a189ffd329dd24(active);
}
function $f8813ed88f5127e5$export$84b79e9be4ce0b1a(rect) {
    return $f8813ed88f5127e5$export$210d7e7a1d7b0fe7(rect);
}
function $f8813ed88f5127e5$export$51d4de9ec6fdbb1b(panel) {
    return $f8813ed88f5127e5$export$859696f1e9040a76(panel);
}
const $f8813ed88f5127e5$export$a59b4aa8e2ef67d2 = ()=>{
    $f8813ed88f5127e5$var$_callTeardown();
    Object.assign($f8813ed88f5127e5$var$_rt, {
        root: null,
        el: null,
        panel: null,
        blockedWs: null,
        retryAt: 0,
        refusal: null,
        refusedRole: null,
        unsupported: false
    });
};

});

parcelRegister("b6fDZ", function(module, exports) {

var $iEU3e = parcelRequire("iEU3e");

var $8kgML = parcelRequire("8kgML");

var $bShA0 = parcelRequire("bShA0");
$parcel$exportWildcard(module.exports, $iEU3e);
$parcel$exportWildcard(module.exports, $8kgML);
$parcel$exportWildcard(module.exports, $bShA0);

});
parcelRegister("iEU3e", function(module, exports) {

$parcel$export(module.exports, "subscribeNotifications", () => $d9577105541fbe54$export$a848450d3ff9c734);
$parcel$export(module.exports, "fetchNotifications", () => $d9577105541fbe54$export$bfd9e0818328ace6);
$parcel$export(module.exports, "resetNotificationsCache", () => $d9577105541fbe54$export$a40638c4663d75cf);
// migrated 2026-04-27 to SDK realtime — `workspaceProject.realtime.notifications`
// dispatches through the SDK's pluggable provider. The transport is the SDK
// /user-socket registry (server emits `notification-created` to the
// recipient's `user:<id>` room), selected by
// `sdkRealtimeProvider._openNotificationsSocket` and installed in bootShell.
// The Supabase `postgres_changes` provider that used to serve this op was
// removed with the governance project — swapping transports again is a
// provider-only change; this file doesn't move.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $d9577105541fbe54$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// Not-ready retries (see subscribeNotifications), counted on the calling
// element: every 2 s for about a minute;
// after that the shell's route-sync self-heal (app.js _ensureShellRealtime)
// keeps calling it.
const $d9577105541fbe54$var$NOT_READY_RETRY_MS = 2000;
const $d9577105541fbe54$var$NOT_READY_RETRY_MAX = 30;
const $d9577105541fbe54$export$a848450d3ff9c734 = function() {
    const root = this?.state?.root;
    if (!root) return;
    const me = root.currentUserEmail;
    if (!me) return;
    // Prevent double-subscribe.
    if (root._notifChannel) return;
    let _unsub = null;
    let _cancelled = false;
    Promise.resolve($d9577105541fbe54$var$shellGetSDK().getService?.('workspaceProject')).then((wp)=>{
        if (_cancelled || !wp?.realtime?.subscribeNotifications) return;
        // Subscribe only once the transport can open. Too early, the SDK hands
        // back a silent no-op (no realtime provider yet, or no access token for
        // the user socket) that looks exactly like a live handle, and the
        // `_notifChannel` guard then blocks every later attempt: no row and no
        // toast ever arrived for the rest of the session (persona round 4,
        // marcus on iPhone, dev 2026-10-28; reproduced on a clean boot). Not
        // ready → release the guard and try again shortly.
        const sdk = $d9577105541fbe54$var$shellGetSDK();
        const signedIn = typeof sdk?.isAuthenticated !== 'function' || !!sdk.isAuthenticated();
        if (typeof wp._realtimeProvider !== 'function' || !signedIn) {
            if (root._notifChannel === handle) root._notifChannel = null;
            this._notifNotReadyRetries = (this._notifNotReadyRetries || 0) + 1;
            if (this._notifNotReadyRetries <= $d9577105541fbe54$var$NOT_READY_RETRY_MAX) setTimeout(()=>{
                try {
                    this.call('subscribeNotifications');
                } catch (_) {}
            }, $d9577105541fbe54$var$NOT_READY_RETRY_MS);
            return;
        }
        this._notifNotReadyRetries = 0;
        _unsub = wp.realtime.subscribeNotifications({
            userEmail: me
        }, (_event, payload)=>{
            const row = payload?.new;
            if (!row) return;
            const cur = root.notifs || [];
            if (cur.some((n)=>n.id === row.id)) return;
            const notif = $d9577105541fbe54$var$_rowToNotif(row);
            root.update({
                notifs: [
                    notif,
                    ...cur
                ]
            });
            // Visibility split — never double-notify for the SAME event: the
            // native browser Notification covers the backgrounded/hidden-tab
            // case (the user can't see an in-app toast right now), an in-app
            // toast covers the foreground case. `this` here is the calling
            // element (arrow function inherits subscribeNotifications' own
            // `this`, bound by el.call), so el.call resolution + the sound
            // pref/de-dup guards inside openNotification/playNotifySound apply
            // exactly as they do for every other openNotification call site.
            if (typeof document !== 'undefined' && document.hidden) $d9577105541fbe54$var$_showBrowserNotification(notif);
            else if (notif.metadata?.kind !== 'chat_message') // CHAT-NOTIFY-1 (tickets/opus.md) — a `chat_message` bell row is
            // ALWAYS accompanied, in this SAME tab, by chat's own realtime
            // toast (subscribeRealtime.js `_notifyNewMessage`, booted at shell
            // scope alongside this subscription — both fire off the identical
            // message insert). That toast already makes the richer decision
            // (skips itself for the sender, a muted channel, or a channel the
            // viewer is actively looking at — chatUtils.js
            // `isChatChannelInView`) and carries a "jump to conversation"
            // action this generic bell toast doesn't. Showing this one too
            // would stack two toasts for one message every time. The
            // backgrounded-tab branch above is unaffected — it's the ONLY
            // path that produces the desktop/OS notification chat never had.
            try {
                this.call('openNotification', {
                    title: notif.title || this.call('polyglot', 'workspace.notification.fallbackTitle'),
                    message: notif.body || '',
                    icon: 'bell',
                    href: notif.href || undefined,
                    // Entity routing for the toast click — GlobalNotification hands
                    // these to openNotificationTarget so a ticket/event toast opens
                    // its feature modal in place. The toast's own `type` key is its
                    // VISUAL theme, so the notification's entity type rides
                    // `notifType` (both just spread onto the queue row).
                    notifType: notif.type || undefined,
                    metadata: notif.metadata || undefined,
                    sound: true
                });
            } catch (err) {
                console.warn('[subscribeNotifications] toast failed:', err?.message || err);
            }
        });
    }).catch((err)=>{
        console.warn('[subscribeNotifications] subscribe failed:', err?.message || err);
    });
    // Stash a callable handle that supports both fn() and .unsubscribe()
    // shapes so legacy cleanup paths keep working unchanged.
    const handle = ()=>{
        _cancelled = true;
        if (typeof _unsub === 'function') try {
            _unsub();
        } catch (_) {}
    };
    handle.unsubscribe = handle;
    root._notifChannel = handle;
};
// Dedupe state for fetchNotifications. This is a GLOBAL data load, and its
// call sites each guarded themselves independently — the shell boot timer,
// IntranetAppHeader.onRender (guarded per ELEMENT, so it re-fires every time
// the header element is rebuilt on an SPA route change) and the inbox page.
// Measured on /studio: six `workspaceProject.notifications list` round trips
// for a single navigation, and nineteen across a cold load — 7s of request
// time spent re-fetching a list that had not changed.
//
// Guarding at the function instead of at each call site means a new caller
// cannot reintroduce the storm.
//
// WS-SWITCH-MEMO-PLANE-1: the dedupe state is SCOPED, not global. This is a
// module-level memo, so it survives a workspace switch untouched — and the list
// it guards is workspace-scoped (`workspaceProject.notifications`). Unscoped, a
// switch inside the 30s window served the PREVIOUS workspace's notifications
// and suppressed the refetch that would have corrected them.
// `resetNotificationsCache` below was written for exactly this and was never
// called from anywhere in the tree — which is the argument for keying rather
// than tearing down: the key cannot be forgotten at a call site that does not
// exist. The scope carries the user too, so signing in as someone else misses
// as well.
let $d9577105541fbe54$var$NOTIF_PROMISE = null;
let $d9577105541fbe54$var$NOTIF_SCOPE = null;
let $d9577105541fbe54$var$NOTIF_AT = 0;
const $d9577105541fbe54$var$NOTIF_TTL_MS = 30000;
// Same lookup chain the records dedupe cache uses (moduleDataBridge `_readKey`).
// An unresolved workspace yields a DIFFERENT scope than a resolved one, so the
// boot-time entry is missed once the id lands — a miss, never a stale serve.
const $d9577105541fbe54$var$_notifScope = (root, me)=>String(me || '') + '|' + String(root?.workspace?.id ?? root?.workspace?._id ?? root?.jwtClaims?.active_workspace_id ?? '');
const $d9577105541fbe54$export$bfd9e0818328ace6 = async function(opts) {
    const root = this?.state?.root;
    if (!root) return;
    const me = root.currentUserEmail;
    if (!me) return;
    const force = opts && opts.force === true;
    const scope = $d9577105541fbe54$var$_notifScope(root, me);
    if (!force && $d9577105541fbe54$var$NOTIF_SCOPE === scope) {
        if ($d9577105541fbe54$var$NOTIF_PROMISE) return $d9577105541fbe54$var$NOTIF_PROMISE;
        if (Date.now() - $d9577105541fbe54$var$NOTIF_AT < $d9577105541fbe54$var$NOTIF_TTL_MS) return;
    }
    // A scope change invalidates BOTH halves: an in-flight fetch for the previous
    // workspace must not be handed to this caller, and its `NOTIF_AT` stamp must
    // not keep the new scope inside the TTL window.
    if ($d9577105541fbe54$var$NOTIF_SCOPE !== scope) {
        $d9577105541fbe54$var$NOTIF_PROMISE = null;
        $d9577105541fbe54$var$NOTIF_AT = 0;
        $d9577105541fbe54$var$NOTIF_SCOPE = scope;
    }
    const mine = (async ()=>{
        try {
            const result = await $d9577105541fbe54$var$shellGetSDK().execute('workspaceProject.notifications', 'list', {});
            // Memo-safe is not mirror-safe: this write lands AFTER the await, so a
            // switch during the round trip would mirror the previous workspace's rows
            // into the new one's `root.notifs` and then stamp the TTL over it. Re-read
            // the scope at completion and drop a result the switch has orphaned.
            if ($d9577105541fbe54$var$_notifScope(root, root.currentUserEmail) !== scope) return;
            const data = Array.isArray(result?.data) ? result.data : Array.isArray(result) ? result : [];
            // `notifsLoaded`: the centre has answered — Home's inbox signal waits
            // for it (functions/homeSignals.js homeSignalsInbox), so a first paint
            // never says "nothing" over unread rows still on their way.
            root.update({
                notifs: data.map($d9577105541fbe54$var$_rowToNotif),
                notifsLoaded: true
            });
            $d9577105541fbe54$var$NOTIF_AT = Date.now();
        } catch (e) {
            console.error('[fetchNotifications]', e?.message || e);
            // a failed read is an answer too: Home does not wait on it forever
            if (!root.notifsLoaded) root.update({
                notifsLoaded: true
            });
        } finally{
            // Only clear the slot if it is still OURS — a newer scope's fetch may have
            // replaced it while this one was in flight.
            if ($d9577105541fbe54$var$NOTIF_PROMISE === mine) $d9577105541fbe54$var$NOTIF_PROMISE = null;
        }
    })();
    $d9577105541fbe54$var$NOTIF_PROMISE = mine;
    return $d9577105541fbe54$var$NOTIF_PROMISE;
};
function $d9577105541fbe54$export$a40638c4663d75cf() {
    $d9577105541fbe54$var$NOTIF_PROMISE = null;
    $d9577105541fbe54$var$NOTIF_SCOPE = null;
    $d9577105541fbe54$var$NOTIF_AT = 0;
}
const $d9577105541fbe54$var$_rowToNotif = (r)=>({
        id: r.id,
        userEmail: r.user_email,
        type: r.type,
        title: r.title,
        body: r.body,
        href: r.href,
        metadata: r.metadata || {},
        read: !!r.read,
        createdAt: r.created_at
    });
const $d9577105541fbe54$var$_showBrowserNotification = (notif)=>{
    if (typeof window === 'undefined') return;
    if (Notification.permission !== 'granted') return;
    try {
        const n = new Notification(notif.title, {
            body: notif.body || '',
            icon: '/favicon.ico',
            tag: notif.id
        });
        if (notif.href) n.onclick = ()=>{
            window.focus();
            window.location.hash = '';
            window.location.pathname = notif.href;
            n.close();
        };
    } catch (e) {
    /* SW required in some browsers */ }
};

});

parcelRegister("8kgML", function(module, exports) {

$parcel$export(module.exports, "requestBrowserPermission", () => $60fd36374913cda5$export$87583831425b9001);
/**
 * Request browser notification permission.
 * Call early in app lifecycle (e.g. onCreate of main page).
 * Returns 'granted', 'denied', or 'default'.
 */ const $60fd36374913cda5$export$87583831425b9001 = async function() {
    if (typeof window === 'undefined' || !('Notification' in window)) return 'denied';
    if (Notification.permission === 'granted') return 'granted';
    if (Notification.permission === 'denied') return 'denied';
    return Notification.requestPermission();
};

});

parcelRegister("bShA0", function(module, exports) {

$parcel$export(module.exports, "ORG_NOTIF_SIGNALS", () => $8a525fd82524e7b3$export$5fb175dece63f7ee);
$parcel$export(module.exports, "fetchOrgNotifCount", () => $8a525fd82524e7b3$export$6b876a55bbae8046);
// §I8 — cross-org notification badge counts.
//
// Hits the server's `/auth/me/org-notifications` endpoint, which forwards
// via HMAC to the governance `symbols-admin-ops` edge fn's
// `notifications.count_by_org` handler. Response shape:
//   { data: { counts: { [orgId]: { mentions, ticketsAssigned, meetingInvites,
//                                  mailUnread } } } }
//
// `AppWorkspaceSwitcher`'s per-org `NotifBadge` reads `root.orgNotifCount[orgId]`
// as a single aggregate number — we sum the signals into one badge
// count per org. The signals still live behind the flat key so a future
// per-type surfacing (e.g. mention-only pulse, ticket-only indicator)
// can read `root.orgNotifSignals[orgId]` without refetching.
//
// THE SIGNAL LIST IS DATA, NOT A HAND-WRITTEN SUM. It used to be three
// destructured names added together, and a fourth type the server started
// sending was not "not yet wired" — it was silently dropped from BOTH the
// badge count and the per-type map this file promises a future reader
// (MAIL-BADGE-NOTIFICATIONS-WIDGET-1, `mailUnread`, architecture/MAIL.md
// §3.6). One list now drives the sum and the map together, so adding a type
// is one entry, and a type the server has not shipped yet reads 0 rather than
// turning the sum into NaN and printing "NaN" on the badge plate.
//
// `mailUnread` is unread mail the viewer is GRANTED — shared-inbox mail, a
// thread assigned to them, a failed send, and personal mail only on an account
// that opted in (§3.6). The server owns that filtering; this side owns only
// "do not drop what arrives".
//
// Fails-soft: any error leaves existing counts untouched. Server itself
// already fails-soft to `{counts:{}}` when governance URL is unset, so
// a 200 response with empty counts is normal during pre-wiring.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $8a525fd82524e7b3$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $8a525fd82524e7b3$export$5fb175dece63f7ee = [
    'mentions',
    'ticketsAssigned',
    'meetingInvites',
    'mailUnread'
];
const $8a525fd82524e7b3$export$6b876a55bbae8046 = async (root)=>{
    if (!root) return;
    // Skip the poll when the tab is not visible — saves free-tier edge fn
    // invocations for users with the intranet backgrounded. The first call
    // on sign-in always goes through (document.hidden is false on active tab).
    if (typeof document !== 'undefined' && document.hidden) return;
    if (!$8a525fd82524e7b3$var$shellGetSDK().getAuthToken()) return;
    try {
        // SDK method threads the auth header + base URL through TokenManager
        // and returns the unwrapped data payload directly.
        const data = await $8a525fd82524e7b3$var$shellGetSDK().getMyOrgNotifications();
        const counts = data && data.counts || {};
        const flat = {};
        const signals = {};
        for (const [orgId, perType] of Object.entries(counts)){
            const per = {};
            let total = 0;
            for (const kind of $8a525fd82524e7b3$export$5fb175dece63f7ee){
                const n = Number(perType?.[kind] || 0);
                per[kind] = n;
                total += n;
            }
            flat[orgId] = total;
            signals[orgId] = per;
        }
        root.update({
            orgNotifCount: flat,
            orgNotifSignals: signals
        });
    } catch  {
    // fail-soft — leave prior counts intact
    }
};

});


parcelRegister("jfwUK", function(module, exports) {

var $ciO23 = parcelRequire("ciO23");
$parcel$exportWildcard(module.exports, $ciO23);

});
parcelRegister("ciO23", function(module, exports) {

$parcel$export(module.exports, "updateActivityScoring", () => $8f4df9cd62f4695d$export$ddafc4b5bb33fca6);
// Admin-only writer for activity_scoring_config. Receives the list of
// "dirty" rows (the admin UI already filtered out unchanged rows) and
// PATCHes them through workspaceProject.activity.updateScoringConfig.
// Server enforces the superadmin gate (mongoStore.js requireSuperadmin), so
// a non-superadmin's whole batch is denied.
//
// Returns { ok, updated, rejected } — never a bare boolean. tickets/
// sonnet.md P2 (2026-08-15 bellforge owner audit): the old version only
// ever distinguished success from failure by whether the SDK call THREW —
// a per-row server-side rejection (score out of the 0–100 UI's own bound,
// or a stale activity_type) resolves normally with `{ok:false, rejected:
// [...]}` in the body, which used to read as success here, so the admin
// saw "All changes saved." for a write that silently discarded exactly the
// row it should have complained about. The server now reports real,
// per-row {activity_type, reason} rejections (mongoStore.js
// scopedUpdateScoringConfig) instead of a blind {ok:true} — this function's
// job is to pass that through unmangled, not to collapse it back into a
// boolean.
//
// migrated 2026-04-27 to SDK route workspaceProject.activity.updateScoringConfig
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $8f4df9cd62f4695d$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $8f4df9cd62f4695d$export$ddafc4b5bb33fca6 = async function(dirty) {
    if (!Array.isArray(dirty) || !dirty.length) return {
        ok: true,
        updated: [],
        rejected: []
    };
    const me = this?.state?.root?.currentUserEmail || null;
    const now = new Date().toISOString();
    const rows = dirty.map((r)=>({
            activity_type: r.activity_type,
            enabled: r._draftEnabled,
            score: r._draftScore,
            updated_at: now,
            updated_by: me
        }));
    try {
        const res = await $8f4df9cd62f4695d$var$shellGetSDK().execute('workspaceProject.activity', 'updateScoringConfig', {
            rows: rows
        });
        const data = res && typeof res === 'object' && 'data' in res ? res.data : res;
        // A denied (non-superadmin) call resolves with the server's {status,
        // error} envelope, not the {ok,updated,rejected} shape above — surface
        // it as a single rejection naming every row rather than pretending one
        // of the two known-good shapes was returned.
        if (!data || typeof data !== 'object' || !Array.isArray(data.rejected)) return {
            ok: false,
            updated: [],
            rejected: rows.map((r)=>({
                    activity_type: r.activity_type,
                    reason: data?.error?.message || data?.message || 'admin.activityScoring.reason.rejected'
                }))
        };
        return {
            ok: data.ok !== false,
            updated: data.updated || [],
            rejected: data.rejected
        };
    } catch (err) {
        console.error('[updateActivityScoring]', err?.message || err);
        return {
            ok: false,
            updated: [],
            rejected: rows.map((r)=>({
                    activity_type: r.activity_type,
                    reason: err?.message || 'admin.activityScoring.reason.network'
                }))
        };
    }
};

});


parcelRegister("4qZU8", function(module, exports) {

$parcel$export(module.exports, "globalSearch", () => (parcelRequire("3hALp")).globalSearch);
$parcel$export(module.exports, "closeNavSearch", () => (parcelRequire("3hALp")).closeNavSearch);
$parcel$export(module.exports, "navigateSearchResult", () => (parcelRequire("3hALp")).navigateSearchResult);
$parcel$export(module.exports, "navigateSearchApp", () => (parcelRequire("3hALp")).navigateSearchApp);
$parcel$export(module.exports, "runSearchCommand", () => (parcelRequire("3hALp")).runSearchCommand);
$parcel$export(module.exports, "runSearchAction", () => (parcelRequire("3hALp")).runSearchAction);
$parcel$export(module.exports, "navSearchRowText", () => (parcelRequire("3hALp")).navSearchRowText);
$parcel$export(module.exports, "moveNavSearchSelection", () => (parcelRequire("3hALp")).moveNavSearchSelection);
$parcel$export(module.exports, "activateNavSearchSelection", () => (parcelRequire("3hALp")).activateNavSearchSelection);
$parcel$export(module.exports, "CATEGORY_META", () => (parcelRequire("3hALp")).CATEGORY_META);
$parcel$export(module.exports, "groupSearchResults", () => (parcelRequire("3hALp")).groupSearchResults);
$parcel$export(module.exports, "appSearchHits", () => (parcelRequire("eEsFC")).appSearchHits);
$parcel$export(module.exports, "appSuggestionHits", () => (parcelRequire("eEsFC")).appSuggestionHits);
$parcel$export(module.exports, "commandSearchHits", () => (parcelRequire("4jMOb")).commandSearchHits);

var $3hALp = parcelRequire("3hALp");

var $eEsFC = parcelRequire("eEsFC");

var $4jMOb = parcelRequire("4jMOb");

});
parcelRegister("3hALp", function(module, exports) {

$parcel$export(module.exports, "CATEGORY_META", () => $263f7a1d2c1a4250$export$9247ea43d19dc9e);
$parcel$export(module.exports, "groupSearchResults", () => $263f7a1d2c1a4250$export$67cec3c6d747ce1c);
$parcel$export(module.exports, "globalSearch", () => $263f7a1d2c1a4250$export$2b3bfbaa540c83e0);
$parcel$export(module.exports, "closeNavSearch", () => $263f7a1d2c1a4250$export$dfd1c1be4a27e9cb);
$parcel$export(module.exports, "navigateSearchResult", () => $263f7a1d2c1a4250$export$d04c18bc3487b6ed);
$parcel$export(module.exports, "navigateSearchApp", () => $263f7a1d2c1a4250$export$8f26ad9c3129e61a);
$parcel$export(module.exports, "runSearchCommand", () => $263f7a1d2c1a4250$export$e4242e7117a7ea91);
$parcel$export(module.exports, "runSearchAction", () => $263f7a1d2c1a4250$export$91b9314c97091a99);
$parcel$export(module.exports, "navSearchRowText", () => $263f7a1d2c1a4250$export$5999f1490a71fdb9);
$parcel$export(module.exports, "moveNavSearchSelection", () => $263f7a1d2c1a4250$export$805890d017124c9);
$parcel$export(module.exports, "activateNavSearchSelection", () => $263f7a1d2c1a4250$export$c150a6f131a3787b);
// Global navbar search — queries the main entity tables in parallel and
// returns a categorised result set the dropdown can render directly.
//
// Categories: people, tickets, channels, messages, events, documents, notes, kb.
// Each category caps at 5 hits.
//
// migrated 2026-04-27 to SDK route workspaceProject.search (rpc).
//
// The server wraps `workspace_global_search(q, surfaces, limit)` — a single
// SQL function the wrapper exposes via /search. The function is expected
// to return rows with at least { surface, id, title, subtitle, href }
// fields. While migrations land, surfaces lacking server-side support are
// quietly elided. People are still resolved client-side from `root.people`.
//
// TODO[server]: wire the workspace_global_search() SQL function so all
// surfaces fan out server-side; once it ships, surface-specific queries
// here are no longer needed.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");

var $hml1G = parcelRequire("hml1G");

var $iNbdw = parcelRequire("iNbdw");

var $D8RKl = parcelRequire("D8RKl");

var $eEsFC = parcelRequire("eEsFC");

var $4jMOb = parcelRequire("4jMOb");

var $55G3L = parcelRequire("55G3L");

var $asht4 = parcelRequire("asht4");
const $263f7a1d2c1a4250$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// The `integration_kinds` CATALOGUE read ("what could you connect?") — no org
// context, no configured instances, exactly the shape the zero-result
// suggestion pass wants. SDK-only, like every other read in this file.
const $263f7a1d2c1a4250$var$shellListIntegrationKinds = (...args)=>(0, $1X0Je.default).functions.listIntegrationKinds(...args);
const $263f7a1d2c1a4250$var$_LIMIT = 5;
const $263f7a1d2c1a4250$var$_DEBOUNCE_MS = 200;
// Client-side pass cache TTL — shared by the documents pass (_docHits) and the
// files pass (_fileHits) below.
const $263f7a1d2c1a4250$var$_PASS_CACHE_MS = 30000;
// The suggestion catalogues (App Store projects, integration_kinds) are
// STATIC platform data, not tenant rows that change under the user — so they
// hold far longer than the 30s tenant-row passes above. They are also read on
// the zero-result path, which fires per KEYSTROKE while somebody types a word
// nothing matches ("c" → "cr" → "crm"): a short TTL there is three network
// round-trips for one answer.
const $263f7a1d2c1a4250$var$_CATALOG_CACHE_MS = 300000;
// Below this length a zero-result query is almost always a half-typed word,
// so the suggestion pass skips the two catalogue reads and returns only its
// (network-free) browse rows. The menu is still never empty.
const $263f7a1d2c1a4250$var$_SUGGEST_MIN_CHARS = 2;
// Category metadata for display ordering and labels.
//
// `kind` selects the ROW RENDERER: 'record' (the default) is
// NavSearchResultItem, 'apps' is NavSearchAppItem — the AppListItem-derived
// launcher row, so an app in the results reads exactly like the same app in
// the apps launcher. NavSearchResultGroup branches on it (components/
// NavSearchDropdown.js); `_groupResults` stamps it onto every group.
const $263f7a1d2c1a4250$export$9247ea43d19dc9e = {
    // Apps the workspace ALREADY has (built-in tiles + installed apps), FIRST
    // in the menu (2026-09-10 per Nika "search should also search and suggest
    // apps"): a one-word query — "mail", "calendar", "files" — nearly always
    // means "take me there", and a navigation answer buried under five ticket
    // titles is an answer nobody sees.
    apps: {
        label: 'workspace.search.category.apps',
        icon: 'blocks',
        order: -1,
        kind: 'apps'
    },
    // COMMANDS — the shell keyboard registry's rows (HOME_AMBIENT_SKIN_SPEC §5:
    // "The command palette (ws-w2) lists the same registry rows with keycaps").
    // Right after the apps: like an app, a command answers "do this now", and
    // a query only ever matches one by its own label or group, so it never
    // crowds out a record. NavSearchCommandItem renders the rows; a pick runs
    // the command (runSearchCommand below), it never navigates to a href.
    commands: {
        label: 'workspace.search.category.commands',
        icon: 'keyboard',
        order: -0.5,
        kind: 'commands'
    },
    // ⌘K FILTER CHIPS (CMDK-05) and what to do with the chipped result
    // (CMDK-08) — searchAppRecordResults.js builds the rows, NavSearchActionItem
    // renders them, a pick runs the row's `_searchAction` (runSearchAction
    // below). The active chips head the list; the values to filter by and the
    // actions close it, after every record group.
    [(0, $55G3L.SEARCH_CHIPS_CATEGORY)]: {
        label: 'workspace.search.category.chips',
        icon: 'filter',
        order: -2,
        kind: 'actions'
    },
    [(0, $55G3L.SEARCH_FILTERS_CATEGORY)]: {
        label: 'workspace.search.category.filters',
        icon: 'filter',
        order: 20,
        kind: 'actions'
    },
    [(0, $55G3L.SEARCH_ACTIONS_CATEGORY)]: {
        label: 'workspace.search.category.actions',
        icon: 'arrowRight',
        order: 21,
        kind: 'actions'
    },
    people: {
        label: 'workspace.search.category.people',
        icon: 'people',
        order: 0
    },
    tickets: {
        label: 'workspace.search.category.tickets',
        icon: 'check',
        order: 1
    },
    channels: {
        label: 'workspace.search.category.channels',
        icon: 'chat',
        order: 2
    },
    messages: {
        label: 'workspace.search.category.messages',
        icon: 'chat',
        order: 3
    },
    // The server's OWN `mail` surface (WorkspaceSearchService SURFACES, row href
    // `/mail?thread=<id>`), so a mirrored thread reads as Mail instead of the raw
    // surface name the fallback below would print. Label/icon mirror AppNavbar's
    // `mail` entry (icon 'email', route /mail); the order seats it between chat
    // and calendar, which is where a reader looks for something somebody sent
    // them (MAIL-SEARCH-UI-CATEGORY-ROW-1).
    mail: {
        label: 'workspace.search.category.mail',
        icon: 'email',
        order: 4
    },
    events: {
        label: 'workspace.search.category.events',
        icon: 'date',
        order: 5
    },
    // 'documents' remains as a category key only for SERVER-side surface hits
    // (ALL_SURFACES) — client doc hits all classify as notes/kb now that the
    // surface renamed to Notes.
    documents: {
        label: 'workspace.search.category.notes',
        icon: 'document',
        order: 6
    },
    notes: {
        label: 'workspace.search.category.notes',
        icon: 'document',
        order: 7
    },
    kb: {
        label: 'workspace.search.category.kb',
        icon: 'bookmark',
        order: 8
    },
    // Label/icon mirror AppNavbar's `files` entry (icon 'folder', route /files).
    files: {
        label: 'workspace.search.category.files',
        icon: 'folder',
        order: 9
    },
    // ── Zero-result suggestion groups ─────────────────────────────────────────
    // Present ONLY when nothing else matched (see the suggestion pass in
    // globalSearch below), hence the far-away order numbers: they can never
    // interleave with real hits, and if the suggestion pass ever ran alongside
    // results they would still sort to the bottom.
    appstore: {
        label: 'workspace.search.category.appStore',
        icon: 'blocks',
        order: 90,
        kind: 'apps'
    },
    integrations: {
        label: 'workspace.search.category.integrations',
        icon: 'api',
        order: 91,
        kind: 'apps'
    },
    discover: {
        label: 'workspace.search.category.discover',
        icon: 'search',
        order: 92,
        kind: 'apps'
    }
};
// Map a server-side row {surface, id, title, ...} to the client-side
// flat result shape used by the dropdown. Surfaces without an explicit
// mapping fall through to a generic shape — let the server label them.
const $263f7a1d2c1a4250$var$_SURFACE_HREF = {
    tickets: (r)=>`/tasks/my?ticket=${r.number || r.id}`,
    notes: (r)=>`/notes?id=${r.id}`,
    kb: (r)=>`/notes/knowledge-base?id=${r.id}`,
    events: (r)=>`/calendar?event=${r.id}`,
    channels: (r)=>`/chat?channel=${r.id}`,
    messages: (r)=>`/chat?channel=${r.channel_id}&message=${r.id}`,
    documents: (r)=>`/notes?id=${r.id}`,
    // `?node=<id>` is the /files desktop's universal-link deep open — it reopens
    // that exact node once its canvas has loaded (files/pages/files.js).
    files: (r)=>`/files?node=${r.id}`
};
// The doc family: one doc, many ids (its docId slug, its Mongo _id). Its
// docId is the id the notes surface opens (`/notes?id=<docId>`) — a server
// row that carries it links there, not to the server's own href.
const $263f7a1d2c1a4250$var$_DOC_SURFACES = new Set([
    'documents',
    'notes',
    'kb'
]);
const $263f7a1d2c1a4250$var$_shapeRow = (row)=>{
    const surface = row.surface || row._category;
    const docId = $263f7a1d2c1a4250$var$_DOC_SURFACES.has(surface) && row.docId ? row.docId : null;
    const id = docId || row.id || row._id;
    const title = row.title || row._title || `#${row.number || id}`;
    const subtitle = row.subtitle || row._subtitle || row.author || '';
    const hrefBuilder = $263f7a1d2c1a4250$var$_SURFACE_HREF[surface];
    return {
        _category: surface,
        _id: id,
        _title: title,
        _subtitle: subtitle,
        _href: docId && hrefBuilder ? hrefBuilder({
            ...row,
            id: docId
        }) : row.href || row._href || (hrefBuilder ? hrefBuilder(row) : '#')
    };
};
// ── Documents/notes/KB client-side pass ─────────────────────────────────────
// The `workspaceProject.search` RPC below never shipped server-side (the SQL
// function doesn't exist — it always throws, caught below) and the ONLY
// client-side fallback pass was people, so `docs` rows never appeared in the
// dropdown at all (commit cfdc18b6 removed the other client-side surface
// queries). Mirrors documents/functions/index.js's reloadDocsAfterSwitch
// exactly: entity name is `docs` (NOT `documents` — that's the SDK route the
// /documents page's OWN fetch uses), same row transform, so a search hit and
// the /documents grid describe the identical row shape.
//
// Module-level, workspace-keyed, 30s cache: typing "docu…" character by
// character must not re-issue docs.select() on every keystroke, and a
// workspace switch must not leak the previous tenant's rows into a fresh
// query.
let $263f7a1d2c1a4250$var$_docsSearchCache = {
    key: null,
    rows: null,
    at: 0
};
const $263f7a1d2c1a4250$var$_workspaceCacheKey = (root)=>String(root?.workspace?.id ?? root?.workspace?._id ?? root?.org?.id ?? root?.org?._id ?? '');
// Row `type` values from the `docs` collection are the Mongo discriminator
// names (document/kb_article/note/user_document — see server DocService) —
// clean, unambiguous, and already what documentsFetch's transform carries
// through as-is. Splits the flat search hit into the SAME three categories
// the rest of this file already declares (CATEGORY_META, _SURFACE_HREF)
// rather than dumping every doc-family row under "documents".
const $263f7a1d2c1a4250$var$_DOC_TYPE_CATEGORY = {
    note: 'notes',
    kb_article: 'kb'
};
const $263f7a1d2c1a4250$var$_docHits = async (root, ql)=>{
    let rows;
    try {
        const key = $263f7a1d2c1a4250$var$_workspaceCacheKey(root);
        const now = Date.now();
        if (root?._documentsLoaded && Array.isArray(root.documents) && root.documents.length) rows = root.documents;
        else if ($263f7a1d2c1a4250$var$_docsSearchCache.rows && $263f7a1d2c1a4250$var$_docsSearchCache.key === key && now - $263f7a1d2c1a4250$var$_docsSearchCache.at < $263f7a1d2c1a4250$var$_PASS_CACHE_MS) rows = $263f7a1d2c1a4250$var$_docsSearchCache.rows;
        else {
            // `list`, NOT `select`. The `docs` entity route exposes
            // list/get/create/update/remove/tree/folders — `select` is only an
            // ADAPTER-level alias (shared/functions/sdkAdapter.js maps it onto
            // `list` for declarative `fetch:` configs) and does not exist on a
            // direct sdk.execute call, so this threw on EVERY keystroke:
            //   "Entity 'docs' does not support op 'select'"
            // The catch below swallowed it and returned [], which is why Documents
            // / Notes / Knowledge Base never appeared in the dropdown unless
            // /documents had already been visited this session (the root.documents
            // fast path above). Verified live 2026-08-05.
            const res = await $263f7a1d2c1a4250$var$shellGetSDK().execute('docs', 'list', {});
            const raw = Array.isArray(res) ? res : res?.data || [];
            rows = raw.map((r)=>({
                    id: r.docId || r._id || r.id,
                    // every id the doc answers to — the merge drops a server row that
                    // names the same doc by another of them
                    _ids: [
                        r.docId,
                        r._id,
                        r.id
                    ].filter(Boolean).map(String),
                    title: r.title || 'workspace.search.untitled',
                    folder: r.folderPath || r.folder || 'company',
                    type: r.type || 'doc',
                    _bodyText: (0, $hml1G._joinBodyText)((0, $hml1G._docContent)(r.body || r.content))
                }));
            $263f7a1d2c1a4250$var$_docsSearchCache = {
                key: key,
                rows: rows,
                at: now
            };
        }
    } catch (err) {
        console.warn('[globalSearch] documents fetch failed', err?.message || err);
        return [];
    }
    const matched = (rows || []).filter((d)=>(d.title || '').toLowerCase().includes(ql) || (d._bodyText || '').toLowerCase().includes(ql));
    // Each of the three doc-family categories caps at _LIMIT independently
    // (matching every other category in this file — see the header comment)
    // so e.g. five matching notes can't crowd a matching document out of the
    // dropdown entirely.
    const byCategory = {
        documents: [],
        notes: [],
        kb: []
    };
    for (const d of matched){
        const category = $263f7a1d2c1a4250$var$_DOC_TYPE_CATEGORY[d.type] || 'notes';
        const bucket = byCategory[category];
        if (bucket.length >= $263f7a1d2c1a4250$var$_LIMIT) continue;
        const hrefBuilder = $263f7a1d2c1a4250$var$_SURFACE_HREF[category];
        bucket.push({
            _category: category,
            _id: d.id,
            _title: d.title || 'workspace.search.untitledDocument',
            _subtitle: d.folder || '',
            _href: hrefBuilder ? hrefBuilder(d) : `/notes?id=${d.id}`,
            _altIds: (d._ids || [
                d.id,
                d._id,
                d.docId
            ]).filter(Boolean).map(String)
        });
    }
    return [
        ...byCategory.documents,
        ...byCategory.notes,
        ...byCategory.kb
    ];
};
// ── Files client-side pass ──────────────────────────────────────────────────
// Files had no representation in search at all before 2026-08-05 (per Nika
// "why documents and files are not in search dropdown"): no CATEGORY_META row,
// no href builder, no fetch pass — and no `files` surface server-side either
// (server ALL_SURFACES covers tickets/channels/messages/events/documents/
// notes/kb only), so a client pass is the only way to reach them today.
//
// Source is `workspaceProject.fileCanvas` — the /files desktop's own node
// table (files/functions/fetchConfigs.js fileCanvasFetch), already on root as
// `fileNodes` once /files has been visited. Deliberately NOT sdk.files.*:
// FileService has no entity route and its only list-shaped read is
// listMyUploads() (per-user uploads, not the workspace's shared desktop).
//
// Same module-level, workspace-keyed, 30s-cached shape as _docHits above, and
// for the same two reasons: typing character by character must not re-issue
// the list on every keystroke, and a workspace switch must not leak the
// previous tenant's rows into a fresh query.
let $263f7a1d2c1a4250$var$_filesSearchCache = {
    key: null,
    rows: null,
    at: 0
};
const $263f7a1d2c1a4250$var$_fileHits = async (root, ql)=>{
    let rows;
    try {
        const key = $263f7a1d2c1a4250$var$_workspaceCacheKey(root);
        const now = Date.now();
        if (root?._fileNodesLoaded && Array.isArray(root.fileNodes) && root.fileNodes.length) rows = root.fileNodes;
        else if ($263f7a1d2c1a4250$var$_filesSearchCache.rows && $263f7a1d2c1a4250$var$_filesSearchCache.key === key && now - $263f7a1d2c1a4250$var$_filesSearchCache.at < $263f7a1d2c1a4250$var$_PASS_CACHE_MS) rows = $263f7a1d2c1a4250$var$_filesSearchCache.rows;
        else {
            // `list` for the same reason the docs pass above uses it — `select` is
            // an adapter-only alias and throws on a direct sdk.execute call.
            const res = await $263f7a1d2c1a4250$var$shellGetSDK().execute('workspaceProject.fileCanvas', 'list', {});
            const raw = Array.isArray(res) ? res : res?.data || [];
            // Mirrors fileCanvasFetch's transform for the fields search needs, so a
            // search hit and the /files desktop describe the identical row.
            rows = raw.map((r)=>({
                    id: r.id,
                    name: r.name || 'workspace.search.untitled',
                    kind: r.kind,
                    mime: r.mime_type || r.mime || null
                }));
            $263f7a1d2c1a4250$var$_filesSearchCache = {
                key: key,
                rows: rows,
                at: now
            };
        }
    } catch (err) {
        console.warn('[globalSearch] files fetch failed', err?.message || err);
        return [];
    }
    return (rows || []).filter((f)=>(f.name || '').toLowerCase().includes(ql)).slice(0, $263f7a1d2c1a4250$var$_LIMIT).map((f)=>({
            _category: 'files',
            _id: f.id,
            _title: f.name || 'workspace.search.untitled',
            _subtitle: f.kind === 'folder' ? 'workspace.search.folder' : f.mime || '',
            _href: `/files?node=${f.id}`
        }));
};
// ── App records pass (CMDK-FINDS-APP-RECORDS-1) ─────────────────────────────
// The rows the installed apps opt into the workspace search — their manifest's
// `collections[].search`: fleet nodes, incidents, networks. The server answers
// (SDK `search.workspace`, surface 'app-records'): only opted-in collections,
// under the caller's records grant and field rules, matched on the declared
// fields — so a guest without a key finds none of the collections it cannot
// read. No cache: the rows are live data and the call is one indexed query.
// The app-records pass: the rows, plus — for an app that declares them — the
// chip values with their counts and the app pages that take the matched rows
// (CMDK-05 / CMDK-08). `q` already carries the active chips as `field:value`
// tokens (serializeSearchChips), so the server scopes everything to them.
const $263f7a1d2c1a4250$var$_appRecordSearch = async (el, root, q)=>{
    const none = {
        hits: [],
        facets: [],
        handoffs: [],
        totals: [],
        total: 0,
        totalCapped: false
    };
    let data;
    try {
        const res = await $263f7a1d2c1a4250$var$shellGetSDK().execute('search', 'workspace', {
            query: q,
            surfaces: [
                (0, $55G3L.APP_RECORDS_SURFACE)
            ],
            limit: $263f7a1d2c1a4250$var$_LIMIT
        });
        data = res && res.data && !Array.isArray(res.data) ? res.data : res;
    } catch (err) {
        console.warn('[globalSearch] app records pass threw', err?.message || err);
        return none;
    }
    // The server names each app by its manifest's first tile or tab (its
    // search opt-in index); a member reads the App Store's name for it — Nika
    // 2026-10-23: "app names = what a person sees in the workspace App Store".
    // So every `app` the reply carries is named here, once, through THE
    // store-copy resolver with the app's record key (the last segment of its
    // `owner/key` id): the group label, a value's list hint and the "Open in
    // <app>" hand-off all read these records, and the rows are transient — the
    // next query builds them again, in the language of that moment. An app the
    // store ships no name for keeps the server's words.
    const _named = (row)=>{
        const app = row && row.app;
        if (!app || typeof app !== 'object' || typeof app.name !== 'string') return row;
        const id = typeof app.id === 'string' ? app.id : '';
        const key = id.includes('/') ? id.split('/').pop() : '';
        if (!key) return row;
        let name = '';
        try {
            name = el.call('storeItemText', {
                key: key,
                name: app.name
            }, 'name');
        } catch (_) {
            name = '';
        }
        return typeof name === 'string' && name && name !== app.name ? {
            ...row,
            app: {
                ...app,
                name: name
            }
        } : row;
    };
    const _list = (v)=>Array.isArray(v) ? v.map(_named) : [];
    const results = _list(data?.results);
    const handoffs = _list(data?.handoffs);
    const totals = Array.isArray(data?.totals) ? data.totals : [];
    // How many rows the search matched — the server's totals, the same rows the
    // chip counts come from; never the page shown (searchMatchTotal).
    const matched = (0, $55G3L.searchMatchTotal)({
        totals: totals,
        handoffs: handoffs,
        results: results,
        limit: $263f7a1d2c1a4250$var$_LIMIT
    });
    return {
        hits: (0, $55G3L.appRecordSearchHits)(results, {
            hrefFor: (ref)=>el.call('entityRefHref', ref, root),
            iconFor: (ref)=>el.call('entityRefIcon', ref),
            limit: $263f7a1d2c1a4250$var$_LIMIT
        }),
        facets: _list(data?.facets),
        handoffs: handoffs,
        totals: totals,
        total: matched.count,
        totalCapped: matched.capped
    };
};
// ── Zero-result suggestion catalogues ───────────────────────────────────────
// Read ONLY on the zero-result path, so an ordinary search never pays for
// them. Both are static platform data (see _CATALOG_CACHE_MS).
//
// The App Store catalog is NOT re-fetched here: `loadWorkspaceAppsCatalog`
// (functions/workspaceApps.js) is the ONE reader of the `workspaceModule:
// true` projects list and it already caches onto the root
// (`_wsAppsCatalog` / `_wsAppsCatalogLoaded` / `_wsAppsCatalogLoading`), so a
// suggestion and the /add-app rail can never disagree about what the store
// holds. A load already in flight returns early without populating — that
// keystroke simply falls back to the browse rows and the next one has it.
const $263f7a1d2c1a4250$var$_storeCatalog = async (el, root)=>{
    if (Array.isArray(root?._wsAppsCatalog) && root._wsAppsCatalog.length) return root._wsAppsCatalog;
    if (root?._wsAppsCatalogLoaded) return root._wsAppsCatalog || [];
    try {
        await el.call('loadWorkspaceAppsCatalog');
    } catch (err) {
        console.warn('[globalSearch] app-store catalog unavailable', err?.message || err);
        return [];
    }
    return root?._wsAppsCatalog || [];
};
// Module-level, workspace-keyed cache — same shape and the same two reasons
// as _docsSearchCache / _filesSearchCache above (no re-issue per keystroke, no
// tenant leak across a switch), on the longer catalogue TTL.
let $263f7a1d2c1a4250$var$_integrationKindsCache = {
    key: null,
    rows: null,
    at: 0
};
const $263f7a1d2c1a4250$var$_integrationKindHits = async (root)=>{
    const key = $263f7a1d2c1a4250$var$_workspaceCacheKey(root);
    const now = Date.now();
    if ($263f7a1d2c1a4250$var$_integrationKindsCache.rows && $263f7a1d2c1a4250$var$_integrationKindsCache.key === key && now - $263f7a1d2c1a4250$var$_integrationKindsCache.at < $263f7a1d2c1a4250$var$_CATALOG_CACHE_MS) return $263f7a1d2c1a4250$var$_integrationKindsCache.rows;
    try {
        const rows = await $263f7a1d2c1a4250$var$shellListIntegrationKinds();
        const list = Array.isArray(rows) ? rows : [];
        // Only a NON-EMPTY read is cached. An empty one is indistinguishable from
        // "the SDK had no session yet" — pinning that for five minutes would hide
        // the whole catalogue for the rest of a boot that simply asked too early.
        // Block body, not a one-liner: `__tests__/moduleLetCensus.test.js` reads a
        // single-line `if (…) <symbol> = …` followed by a `return` as a SKIP GUARD
        // on a module `let` (the "already did this" shape it exists to catch), and
        // this is a write, not a guard.
        if (list.length) $263f7a1d2c1a4250$var$_integrationKindsCache = {
            key: key,
            rows: list,
            at: now
        };
        return list;
    } catch (err) {
        console.warn('[globalSearch] integration kinds unavailable', err?.message || err);
        return [];
    }
};
// Group flat results by category, respecting display order. Each item gets
// a `_flatIndex` — a running index across the WHOLE grouped set (group order
// first, then item order within a group) — so the keyboard-navigation path
// (moveNavSearchSelection / activateNavSearchSelection below) and each
// NavSearchResultItem row (NavSearchDropdown.js) can agree on "which row is
// #3" without either side re-deriving the flatten order independently.
// Exported (as `groupSearchResults`, below) purely so the CONTRACT the
// dropdown reads — group order and the `kind` that picks the row renderer —
// is assertable without mounting DOMQL or stubbing three network passes.
const $263f7a1d2c1a4250$export$67cec3c6d747ce1c = (results)=>{
    const grouped = {};
    for (const r of results){
        if (!grouped[r._category]) grouped[r._category] = [];
        grouped[r._category].push(r);
    }
    let flatIndex = 0;
    // An app-records group (one per app) carries its OWN label — the app's name,
    // tenant content — and icon on its rows, and sits right after People.
    const orderOf = (cat)=>$263f7a1d2c1a4250$export$9247ea43d19dc9e[cat]?.order ?? ((0, $55G3L.isAppRecordsCategory)(cat) ? (0, $55G3L.APP_RECORDS_ORDER) : 99);
    return Object.entries(grouped).sort(([a], [b])=>orderOf(a) - orderOf(b)).map(([cat, items])=>({
            category: cat,
            label: $263f7a1d2c1a4250$export$9247ea43d19dc9e[cat]?.label || items[0]?._groupLabel || cat,
            icon: $263f7a1d2c1a4250$export$9247ea43d19dc9e[cat]?.icon || items[0]?._groupIcon || 'search',
            // Which ROW component renders this group — see CATEGORY_META above. A
            // server surface with no entry here falls back to 'record', which is
            // what every category rendered as before app rows existed.
            kind: $263f7a1d2c1a4250$export$9247ea43d19dc9e[cat]?.kind || 'record',
            items: items.map((it)=>({
                    ...it,
                    _flatIndex: flatIndex++
                }))
        }));
};
// Total item count across every group — moveNavSearchSelection's wrap bound.
const $263f7a1d2c1a4250$var$_flatCount = (grouped)=>Array.isArray(grouped) ? grouped.reduce((n, g)=>n + (g.items?.length || 0), 0) : 0;
// A "Pin to navbar" context menu on a result row (NavSearchResultItem.
// onContextmenu, NavSearchDropdown.js — opened with `fromNavSearch: true`)
// can outlive the keystroke that started this call: globalSearch's own
// debounce (await below) + network round-trip gives a right-click a real
// window to open the menu WHILE a call is still in flight — the call then
// resolves after and would otherwise SWAP OUT the rows the menu's
// `searchResult` payload was captured from, even though HeaderSearch's /
// IntranetAppHeader's blur guard correctly kept `_navSearchOpen` true (a
// true `_navSearchOpen` is necessary but not sufficient — the ROWS must
// stay on screen too). Only the POST-AWAIT write below needs this: the
// empty-query short-circuit and the very first sync update above never
// cross an await, so they can't land after the menu opens — `onInput`
// (globalSearch's own trigger) can't even fire while the menu has focus
// moved off the input. Every close path (Escape, outside click, the Pin
// action) nulls `contextDropdown`, so live search resumes the instant it
// closes — nothing here to separately track or clean up.
const $263f7a1d2c1a4250$var$_navSearchMenuOpen = (root)=>!!(root?.contextDropdown?.open && root.contextDropdown.fromNavSearch);
const $263f7a1d2c1a4250$export$2b3bfbaa540c83e0 = async function(query) {
    const root = this.state.root;
    const q = (query || '').trim();
    // ⛔ CAPTURED HERE, BEFORE THE DEBOUNCE — not at the write site below.
    // WS-SWITCH-INCOMPLETE-1: `navSearchResults` / `_navSearchGrouped` are
    // workspace-scoped (state-app.js), so the switch empties them. That closes
    // the persistent case only. This call outlives its tenant by design — a
    // 200ms debounce plus three network passes — and its ONLY in-flight guard
    // was `root.navSearchQuery !== query`. The query text is the user's own
    // input and is deliberately UNSCOPED, so it survives the switch UNCHANGED:
    // after A -> B the query guard still MATCHES and A's tickets, notes and
    // files land in B's dropdown, where Enter calls openInSlot with A's href.
    // A query guard is not a tenant guard.
    const _write = (0, $iNbdw.sameWorkspaceWriter)(root);
    // ⌘K FILTER CHIPS (CMDK-05): with a chip active the palette is a filtered
    // list of the apps' rows — it stays open with no text, and only the
    // app-records pass runs (the chips ride its query). `chipsSig` pins this
    // call to the chips it was issued for: a chip added or removed while it was
    // in flight makes its answer stale, exactly like a changed query.
    const chips = Array.isArray(root._navSearchChips) ? root._navSearchChips : [];
    const chipsSig = (0, $55G3L.serializeSearchChips)(chips);
    const filtering = !!chipsSig;
    // Stale-results fix (SEARCH-1, 2026-08-14): every new query resets the
    // keyboard selection immediately — a row highlighted for the PREVIOUS
    // query must never look "selected" against results that no longer belong
    // to it. `_navSearchLoading` (already written here) is the single source
    // of truth the dropdown reads to DIM the still-on-screen previous-query
    // rows and show a loading indicator until this exact call's results land
    // (see HeaderSearch.js's Dropdown for the render side).
    root.update({
        navSearchQuery: query || '',
        _navSearchLoading: !!q || filtering,
        _navSearchOpen: !!q || filtering,
        _navSearchActiveIndex: -1
    });
    if (!q && !filtering) {
        root.update({
            navSearchResults: [],
            _navSearchGrouped: [],
            _navSearchLoading: false,
            _navSearchOpen: false,
            _navSearchActiveIndex: -1
        });
        return [];
    }
    await new Promise((r)=>setTimeout(r, $263f7a1d2c1a4250$var$_DEBOUNCE_MS));
    if (root.navSearchQuery !== query) return root.navSearchResults || [];
    const _stale = ()=>root.navSearchQuery !== query || (0, $55G3L.serializeSearchChips)(Array.isArray(root._navSearchChips) ? root._navSearchChips : []) !== chipsSig;
    if (filtering) {
        const rec = await $263f7a1d2c1a4250$var$_appRecordSearch(this, root, q ? `${chipsSig} ${q}` : chipsSig);
        if (_stale()) return root.navSearchResults || [];
        const rows = [
            ...(0, $55G3L.activeChipRows)(chips),
            ...rec.hits,
            ...(0, $55G3L.facetFilterRows)(rec.facets, {
                term: q,
                chips: chips
            }),
            ...(0, $55G3L.searchActionRows)({
                chips: chips,
                handoffs: rec.handoffs,
                total: rec.total,
                totalCapped: rec.totalCapped,
                totals: rec.totals
            })
        ];
        if (!$263f7a1d2c1a4250$var$_navSearchMenuOpen(root)) {
            const landed = _write({
                navSearchResults: rows,
                _navSearchGrouped: $263f7a1d2c1a4250$export$67cec3c6d747ce1c(rows)
            });
            root.update(landed ? {
                _navSearchLoading: false,
                _navSearchOpen: true
            } : {
                _navSearchLoading: false,
                _navSearchOpen: false,
                _navSearchActiveIndex: -1
            });
        }
        return rec.hits.map((h)=>({
                id: h._id,
                title: h._title,
                category: h._category,
                subtitle: h._subtitle || null,
                href: h._href || null
            }));
    }
    const ql = q.toLowerCase();
    // APP hits (2026-09-10 per Nika "search should also search and suggest
    // apps"). Purely local — the launcher's already-gated group list plus a
    // string match — so it costs no round-trip and needs no cache, and it runs
    // BEFORE the network passes so the cheap navigation answer is ready the
    // moment anything else lands. `this.call('polyglot', …)` resolves a shipped
    // tile's key so a Georgian session matches Georgian words; the row keeps
    // the KEY, so the rendered label still re-translates on a language switch.
    const _t = (key)=>{
        try {
            return this.call('polyglot', key || '');
        } catch (_) {
            return key || '';
        }
    };
    // Guarded like every other pass in this file: a launcher tile's own
    // `visible()` is module-supplied code, and a throwing module must degrade
    // search to "no app rows", never to "no search".
    // An installed app answers to the name the member reads — the App Store's
    // (Nika 2026-10-23: "app names = what a person sees in the workspace App
    // Store") — through THE store-copy resolver, the same call the row's title
    // makes (AppListItem). The shared resolver, not the shell's
    // installedAppName: the comm app runs this pass before the shell registry
    // folds in (comm/functions.js), and the shared library is there at boot.
    const _name = (tile)=>{
        try {
            return this.call('storeItemText', {
                key: tile.appKey,
                name: tile.title || ''
            }, 'name');
        } catch (_) {
            return '';
        }
    };
    let appHits = [];
    try {
        // …and the person's own apps (Your apps — BLD-28: a saved draft is found
        // from any page), after the workspace's: an app already in the workspace
        // answers once, as its own tile.
        appHits = (0, $eEsFC.appSearchHits)((0, $D8RKl.searchAppGroupsFor)(root), ql, {
            translate: _t,
            name: _name,
            limit: $263f7a1d2c1a4250$var$_LIMIT,
            userApps: root && root._userApps
        });
    } catch (err) {
        console.warn('[globalSearch] apps pass threw', err?.message || err);
    }
    // COMMAND hits (DESIGN-WL-SHELL-KEYBOARD-MOTION-1): the shell keyboard
    // registry's rows (`listShortcuts` — the ? sheet's own source), matched on
    // their translated label and group. Local like the app pass, and guarded the
    // same way: a registry that throws costs the command rows, never the search.
    // `fallbackLang: 'en'` lets a Georgian session answer "keyboard" too — the
    // app pass reaches English through its keys and routes the same way.
    let commandHits = [];
    try {
        const _tIn = (key, lang)=>{
            try {
                return lang ? this.call('polyglot', key || '', lang) : this.call('polyglot', key || '');
            } catch (_) {
                return key || '';
            }
        };
        commandHits = (0, $4jMOb.commandSearchHits)(this.call('listShortcuts') || [], ql, {
            translate: _tIn,
            fallbackLang: 'en',
            limit: $263f7a1d2c1a4250$var$_LIMIT
        });
    } catch (err) {
        console.warn('[globalSearch] commands pass threw', err?.message || err);
    }
    // Fire alongside the server RPC below — both are network-bound (the docs
    // pass has its own 30s cache, so this only actually hits the network on a
    // cache-cold workspace), no reason to serialize them.
    const docsPromise = $263f7a1d2c1a4250$var$_docHits(root, ql).catch((err)=>{
        console.warn('[globalSearch] documents pass threw', err?.message || err);
        return [];
    });
    // Files ride alongside the docs pass and the server RPC for the same reason:
    // all three are network-bound (this one has its own 30s cache, so it only
    // actually hits the network on a cache-cold workspace).
    const filesPromise = $263f7a1d2c1a4250$var$_fileHits(root, ql).catch((err)=>{
        console.warn('[globalSearch] files pass threw', err?.message || err);
        return [];
    });
    // The installed apps' opted-in rows (CMDK-FINDS-APP-RECORDS-1) — network-
    // bound like the two passes above, so it rides alongside them.
    const recordsPromise = $263f7a1d2c1a4250$var$_appRecordSearch(this, root, q).catch((err)=>{
        console.warn('[globalSearch] app records pass threw', err?.message || err);
        return {
            hits: [],
            facets: [],
            handoffs: [],
            totals: [],
            total: 0,
            totalCapped: false
        };
    });
    let serverResults = [];
    try {
        const result = await $263f7a1d2c1a4250$var$shellGetSDK().execute('workspaceProject.search', 'rpc', {
            q: q,
            options: {
                limit: $263f7a1d2c1a4250$var$_LIMIT
            }
        });
        if (root.navSearchQuery !== query) return root.navSearchResults || [];
        const rows = Array.isArray(result?.data) ? result.data : Array.isArray(result) ? result : [];
        serverResults = rows.map($263f7a1d2c1a4250$var$_shapeRow);
    } catch (err) {
        // Swallow until the server-side search RPC ships. People-only fallback
        // still renders so the dropdown never goes empty.
        console.warn('[globalSearch] server search unavailable, returning people-only', err?.message || err);
    }
    if (root.navSearchQuery !== query) return root.navSearchResults || [];
    const docHits = await docsPromise;
    const fileHits = await filesPromise;
    const records = await recordsPromise;
    const recordHits = records.hits;
    // A chip value the typed text names ("Pinecrest" → "Customer · Pinecrest
    // Custody · 3"): picking it turns the search into a filtered list (CMDK-05).
    const filterHits = (0, $55G3L.facetFilterRows)(records.facets, {
        term: q
    });
    if (root.navSearchQuery !== query) return root.navSearchResults || [];
    const peopleHits = (root.people || []).filter((p)=>(p.name || '').toLowerCase().includes(ql) || (p.email || '').toLowerCase().includes(ql)).slice(0, $263f7a1d2c1a4250$var$_LIMIT).map((p)=>({
            _category: 'people',
            _id: p.email,
            _title: p.name || p.email,
            _subtitle: p.email,
            _href: `/people?u=${encodeURIComponent(p.email)}`
        }));
    // ONE DOC, ONE ROW (lane TOOLS item F; dev 2026-10-27: "Lead Generation
    // Strategy" listed twice — the docs pass by its docId, the server search by
    // its _id — and the server row's link opened an empty note). The docs pass
    // row wins (its `/notes?id=<docId>` opens the doc); a server row of the doc
    // family naming the same doc — by any of its ids, or by its title — goes.
    const sameTitle = (t)=>String(t || '').trim().toLowerCase();
    const docIds = new Set();
    const docTitles = new Set();
    for (const h of docHits){
        for (const id of h._altIds || [
            h._id
        ])docIds.add(String(id));
        docTitles.add(sameTitle(h._title));
    }
    const serverRows = serverResults.filter((r)=>!($263f7a1d2c1a4250$var$_DOC_SURFACES.has(r._category) && (docIds.has(String(r._id)) || docTitles.has(sameTitle(r._title)))));
    const docRows = docHits.map(({ _altIds: _altIds, ...row })=>row);
    const all = [
        ...appHits,
        ...commandHits,
        ...peopleHits,
        ...recordHits,
        ...docRows,
        ...fileHits,
        ...serverRows,
        ...filterHits
    ];
    // NOTHING matched — offer what this workspace could ADD instead of an empty
    // menu (2026-09-10 per Nika "if nothing found - it should suggest from
    // appstore, marketplace or integrations"). Only here, only on a real zero,
    // and the two catalogue reads are skipped for a half-typed query
    // (_SUGGEST_MIN_CHARS) — the browse rows alone already make the menu
    // answerable, so a one-character miss costs no network at all.
    if (!all.length) {
        const wide = q.length >= $263f7a1d2c1a4250$var$_SUGGEST_MIN_CHARS;
        const catalog = wide ? await $263f7a1d2c1a4250$var$_storeCatalog(this, root) : [];
        const kinds = wide ? await $263f7a1d2c1a4250$var$_integrationKindHits(root) : [];
        // The catalogue reads are awaits, so re-check the query the same way
        // every other pass above does — a suggestion set for an abandoned query
        // must never land over the answer to the current one.
        if (root.navSearchQuery !== query) return root.navSearchResults || [];
        // `el: this` — the store rule runs through the element (searchAppResults.js)
        all.push(...(0, $eEsFC.appSuggestionHits)(ql, {
            catalog: catalog,
            integrationKinds: kinds,
            limit: $263f7a1d2c1a4250$var$_LIMIT,
            el: this
        }));
    }
    // Guarded write — see _navSearchMenuOpen above: a "Pin to navbar" menu
    // opened on one of the CURRENTLY-VISIBLE rows must not have those rows
    // swapped out from under it by this call finally landing. `_navSearchOpen`
    // is left untouched (still true, both because it already is and because
    // the blur guard is what's keeping it true) — only the rows/loading flag
    // are held back; live search resumes with fresh data the instant the menu
    // closes (nothing to reconcile — the next keystroke's call writes normally).
    if (!$263f7a1d2c1a4250$var$_navSearchMenuOpen(root)) {
        // ⛔ THE PATCH SPLITS, and it must. The ROWS are tenant data, so they are
        // dropped when this reply outlived its workspace. The two transport flags
        // are this call's own terminal state, and they are deliberately UNSCOPED —
        // the switch's wipe never reaches them. Dropping them together with the
        // rows would strand the dropdown dimmed-with-a-spinner over an empty list
        // for the rest of the session: a leak fix that becomes a stuck surface.
        // A request cancelled by a switch is still a request that has STOPPED.
        const landed = _write({
            navSearchResults: all,
            _navSearchGrouped: $263f7a1d2c1a4250$export$67cec3c6d747ce1c(all)
        });
        root.update(landed ? {
            _navSearchLoading: false,
            _navSearchOpen: true
        } : {
            _navSearchLoading: false,
            _navSearchOpen: false,
            _navSearchActiveIndex: -1
        });
    }
    // Return the hits so the open_search client tool can hand them to the model
    // (it was returning undefined — the AI saw the search "ran" but got zero rows,
    // so it could never chain a hit into select_page_item / move_ticket). Compact,
    // model-friendly shape. The human dropdown reads root.navSearchResults above.
    // Keyboard COMMAND rows stay out: they are this person's key bindings, not
    // places or records the model can open (no href, a bundle key for a title).
    return all.filter((h)=>h._category !== 'commands' && !h._searchAction).map((h)=>({
            id: h._id,
            title: h._title,
            category: h._category,
            subtitle: h._subtitle || null,
            href: h._href || null
        }));
};
const $263f7a1d2c1a4250$export$dfd1c1be4a27e9cb = function() {
    const root = this.state.root;
    root.update({
        navSearchQuery: '',
        // A closed search drops its chips: a palette reopened later starts
        // unfiltered, never silently scoped by an earlier session's chips.
        _navSearchChips: [],
        navSearchResults: [],
        _navSearchGrouped: [],
        _navSearchLoading: false,
        _navSearchOpen: false,
        _navSearchActiveIndex: -1
    });
    // The search is over, so is its dropdown: the launcher hosts the results
    // (9A), and a closed search must not leave it standing. Its own dismissal
    // stamp keeps the focus hand-back from opening it again. Reached through
    // `this.call` and availability-checked (a test root or a standalone bundle
    // has no launcher) — never a module helper: every export here is
    // serialized on its own (FA204).
    try {
        if (typeof this?.context?.functions?.closeSearchLauncher === 'function') this.call('closeSearchLauncher');
    } catch (_) {
    /* a launcher already gone is the goal */ }
    // Search app selections consume this intent in the same event. Escape
    // and outside dismissal leave it unused, so remove the empty split pane.
    if (root._slotSplitIntent) queueMicrotask(()=>{
        if (root._slotSplitIntent && !root._navSearchOpen) root.update({
            _slotSplitIntent: false
        });
    });
};
const $263f7a1d2c1a4250$export$d04c18bc3487b6ed = function(href) {
    const root = this.state.root;
    root.update({
        _headerSearchOpen: false,
        navSearchQuery: '',
        _navSearchChips: [],
        navSearchResults: [],
        _navSearchGrouped: [],
        _navSearchLoading: false,
        _navSearchOpen: false,
        _navSearchActiveIndex: -1
    });
    // A picked record row ends the search — the launcher that listed it closes
    // with it (9A: the rows live in the launcher). Same self-contained call as
    // closeNavSearch's.
    try {
        if (typeof this?.context?.functions?.closeSearchLauncher === 'function') this.call('closeSearchLauncher');
    } catch (_) {
    /* a launcher already gone is the goal */ }
    // Open-in-slot-vs-navigate (incl. the tickets external-entry-point
    // carve-out — a /tickets subview floating over /studio reads wrong) is
    // centralized in openInSlot (shared/functions/openInSlot.js) so search and
    // every other opener (notifications, toasts, …) can never drift.
    this.call('openInSlot', href, this);
};
const $263f7a1d2c1a4250$export$8f26ad9c3129e61a = function(route) {
    if (!route) return;
    $263f7a1d2c1a4250$export$dfd1c1be4a27e9cb.call(this);
    // Result activation ends the search gesture. Keeping the morph open
    // leaves HeaderTabs (including Open apps) transparent and non-interactive.
    this.state.root.update({
        _headerSearchOpen: false
    });
    this.call('selectAppFromSwitcher', route);
};
const $263f7a1d2c1a4250$export$e4242e7117a7ea91 = function(id) {
    if (!id) return false;
    const root = this.state && this.state.root;
    this.call('closeNavSearch');
    if (root && typeof root.update === 'function') root.update({
        _headerSearchOpen: false
    });
    return this.call('runShortcut', id) === true;
};
const $263f7a1d2c1a4250$export$91b9314c97091a99 = function(action) {
    const root = this.state && this.state.root;
    if (!root || !action || typeof action !== 'object') return false;
    const chips = Array.isArray(root._navSearchChips) ? root._navSearchChips : [];
    const query = root.navSearchQuery || '';
    // The field takes focus FIRST, then the search runs. A field that had lost
    // focus re-runs the search from its focus handler with the text still in it
    // (HeaderSearch openSearchSurface reads the DOM value, which follows
    // navSearchQuery one tick late); the search issued after it supersedes that
    // run. The other order let the stale text win: live on dev 34259e777
    // (2026-10-07), a chip picked after the field lost focus kept "Pinecrest"
    // as a term, and the term emptied the "Filter by" group.
    if (action.type === 'chip-add' && action.chip) {
        const key = (0, $55G3L.searchChipKey)(action.chip);
        if (!key || chips.some((c)=>(0, $55G3L.searchChipKey)(c) === key)) return false;
        const { field: field, value: value, label: label, fieldLabel: fieldLabel } = action.chip;
        root.update({
            _navSearchChips: [
                ...chips,
                {
                    field: field,
                    value: value,
                    label: label,
                    fieldLabel: fieldLabel
                }
            ]
        });
        this.call('focusHeaderSearch');
        this.call('globalSearch', '');
        return true;
    }
    if (action.type === 'chip-remove') {
        root.update({
            _navSearchChips: chips.filter((c)=>(0, $55G3L.searchChipKey)(c) !== action.key)
        });
        this.call('focusHeaderSearch');
        this.call('globalSearch', query);
        return true;
    }
    if (action.type === 'chips-clear') {
        root.update({
            _navSearchChips: []
        });
        this.call('focusHeaderSearch');
        this.call('globalSearch', query);
        return true;
    }
    if (action.type === 'handoff') {
        const href = (0, $55G3L.searchHandoffHref)(action);
        if (!href) return false;
        this.call('navigateSearchResult', href);
        return true;
    }
    if (action.type === 'ask') {
        const filters = chips.map((c)=>`${c.fieldLabel || c.field}: ${c.label || c.value}`).join(" \xb7 ");
        const rows = (Array.isArray(root.navSearchResults) ? root.navSearchResults : []).filter((r)=>r && typeof r._id === 'string' && r._id.startsWith('ref:record:'));
        const prompt = query.trim() || this.call('polyglot', 'workspace.search.action.askPrompt').replace('{filters}', filters);
        const context = {
            title: this.call('polyglot', 'workspace.search.action.askContext').replace('{filters}', filters),
            text: rows.map((r)=>r._title).filter(Boolean).join(', '),
            records: rows.map((r)=>r._id.slice(11).replace('/', ':'))
        };
        this.call('closeNavSearch');
        root.update({
            _headerSearchOpen: false
        });
        (0, $asht4.buildModuleAskBridge)(root).call(this, prompt, {
            context: context
        });
        return true;
    }
    return false;
};
const $263f7a1d2c1a4250$export$5999f1490a71fdb9 = function(text, key, params) {
    if (typeof text === 'string' && text) return text;
    if (typeof key !== 'string' || !key) return '';
    let out = this.call('polyglot', key);
    if (typeof out !== 'string') return '';
    for (const [k, v] of Object.entries(params && typeof params === 'object' ? params : {}))out = out.split(`{${k}}`).join(String(v));
    return out;
};
const $263f7a1d2c1a4250$export$805890d017124c9 = function(delta) {
    const root = this.state.root;
    const count = $263f7a1d2c1a4250$var$_flatCount(root?._navSearchGrouped);
    if (!count) return;
    const hasSelection = typeof root._navSearchActiveIndex === 'number' && root._navSearchActiveIndex >= 0;
    // No selection yet: Down starts at the top (index 0), Up starts at the
    // bottom (index count-1) — the same "Up from nothing lands on the last
    // row" convention every house listbox uses. Modeled as the position we'd
    // be moving FROM: one before the top for Down, the top itself for Up (so
    // subtracting 1 wraps to the bottom).
    const cur = hasSelection ? root._navSearchActiveIndex : delta > 0 ? -1 : 0;
    const next = ((cur + delta) % count + count) % count;
    root.update({
        _navSearchActiveIndex: next
    });
};
const $263f7a1d2c1a4250$export$c150a6f131a3787b = function() {
    const root = this.state.root;
    const grouped = root?._navSearchGrouped;
    const count = $263f7a1d2c1a4250$var$_flatCount(grouped);
    if (!count) return;
    const idx = typeof root._navSearchActiveIndex === 'number' && root._navSearchActiveIndex >= 0 ? root._navSearchActiveIndex : 0;
    let seen = 0;
    for (const g of grouped){
        const items = g.items || [];
        if (idx < seen + items.length) {
            const target = items[idx - seen];
            // An APP row opens through the launcher's opener, a record row through
            // openInSlot — the same split the two ROW components make on click, so
            // Enter and a click can never send the same row to two different
            // containers.
            // A COMMAND row runs through the keyboard registry (runSearchCommand) —
            // the same call its click makes.
            if (target?._appRoute) this.call('navigateSearchApp', target._appRoute);
            else if (target?._shortcutId) this.call('runSearchCommand', target._shortcutId);
            else if (target?._searchAction) this.call('runSearchAction', target._searchAction);
            else if (target?._href) this.call('navigateSearchResult', target._href);
            return;
        }
        seen += items.length;
    }
};

});
parcelRegister("eEsFC", function(module, exports) {

$parcel$export(module.exports, "appSearchHits", () => $aaab0a6f7f0897e6$export$38a2ad293231352c);
$parcel$export(module.exports, "appSuggestionHits", () => $aaab0a6f7f0897e6$export$d9de4ba7f1013ed1);
// Global search — APP results + zero-result suggestions.
//
// Nika 2026-09-10: "search should also search and suggest apps. if nothing
// found - it should suggest from appstore, marketplace or integrations".
// Two behaviours, both PURE over data so they unit-test without a DOM or a
// network (globalSearch.js owns the fetching and the state write):
//
//   1. `appSearchHits` — the apps this workspace ALREADY has (the built-in
//      SEARCH_APPS tiles plus every installed app / module tile) matched
//      against the query, so typing "cal" offers Calendar beside the record
//      hits. It takes the groups `searchAppGroupsFor(root)` already built, so
//      the feature-flag gate, the admin gate and every module tile's own
//      per-viewer `visible()` are ALREADY applied — search can never offer an
//      app the launcher itself hides for this viewer.
//
//   2. `appSuggestionHits` — what the menu shows when the query matched
//      NOTHING. An empty menu is a dead end, and the workspace can nearly
//      always ADD the thing that was just asked for. Three sources in
//      descending specificity: the App Store catalog (the same
//      `workspaceModule: true` projects read the /add-app rail renders), the
//      `integration_kinds` catalogue, and three always-present BROWSE rows
//      for the App Store / Marketplace / Integrations surfaces — so the menu
//      is never empty even for a query nothing in either catalogue matches.
//
// Row shape is deliberately DOUBLE-KEYED. `title` / `caption` / `icon` /
// `route` is the launcher tile contract `AppListItem` already renders (its
// Title/Caption resolve through one `el.call('polyglot', …)`, which returns a
// shipped key translated and a customer's own words verbatim — so the KEY is
// what travels here, never a pre-resolved string, and a language switch still
// re-renders). `_category` / `_id` / `_title` / `_subtitle` / `_href` is the
// search-result contract `_groupResults` groups and `moveNavSearchSelection`
// indexes. `_appRoute` is the marker that says "open me through the
// launcher's own opener": `NavSearchResultGroup` renders these rows with
// `NavSearchAppItem` and `activateNavSearchSelection` routes them through
// `selectAppFromSwitcher`, so a Calendar pick from search lands exactly where
// a Calendar pick from the apps launcher lands (canvas full-page, /admin
// full-page, everything else the PageSlot).
// THE catalog search rule (packages/shared/functions/catalogSearch.js) — the
// word / word-prefix / word-form match the App Store itself and the
// assistant's store search use. The App Store and integration suggestions
// below match through it, so "schedule" offers Scheduling here exactly as the
// store shows it. CALLED THROUGH THE ELEMENT (`opts.el.call`) — globalSearch
// hands its element in: a published shared function finds its own helpers
// through its receiver, and `_wsShared.functions.X(...)` gives it the
// functions bag instead, so it threw `__scope.catalogSearchCachedQueryWords is
// not a function` (design-d2's review, 2026-10-01; the parcel build never
// shows it). The wrapper below serves a call with no element (a test) — bare
// shared-library import + a deferred-call wrapper, never a deep subpath or a
// module-scope destructure (see app.js's P0 note).

var $1X0Je = parcelRequire("1X0Je");
const $aaab0a6f7f0897e6$var$catalogSearchRank = (...args)=>(0, $1X0Je.default).functions.catalogSearchRank(...args);
const $aaab0a6f7f0897e6$var$_rankStoreRows = (el, rows, q, fields)=>el && typeof el.call === 'function' ? el.call('catalogSearchRank', rows, q, {
        fields: fields
    }) : $aaab0a6f7f0897e6$var$catalogSearchRank(rows, q, {
        fields: fields
    });
// Discovery entry points — the three surfaces a workspace adds capability
// from. ALWAYS returned by `appSuggestionHits`, matched query or not: they are
// the answer to "I looked for X and this workspace has no X".
//
// Every one of them is a MARKETPLACE surface, deliberately, and none is
// `/admin/integrations`: the admin hub renders only the kinds an org has
// already configured and is admin-gated, while discovery ("what could you
// connect?") is the marketplace's own Integrations surface — see
// pages/admin/integrations.js, which says so in its own header.
const $aaab0a6f7f0897e6$var$_BROWSE_ROWS = [
    {
        id: 'browse-appstore',
        title: 'shell.launcher.appStore',
        caption: 'workspace.search.suggest.appStoreCaption',
        icon: 'blocks',
        route: '/marketplace?surface=appstore'
    },
    {
        id: 'browse-marketplace',
        title: 'workspace.search.suggest.marketplace',
        caption: 'workspace.search.suggest.marketplaceCaption',
        icon: 'library',
        route: '/marketplace'
    },
    {
        id: 'browse-integrations',
        title: 'workspace.search.suggest.integrations',
        caption: 'workspace.search.suggest.integrationsCaption',
        icon: 'api',
        route: '/marketplace?surface=integrations'
    }
];
// Rank a needle against a row's searchable fields. 0 = a field STARTS with the
// query (a strong, "you meant this" match), 1 = a field merely contains it,
// -1 = no field matched at all. Two buckets rather than a fuzzy score on
// purpose: the caller caps at five rows, and a prefix hit is the only ordering
// distinction that reliably reads as correct to a human ("mail" must not put
// "Broadcast — send mail to the team" above "Mail").
const $aaab0a6f7f0897e6$var$_rank = (needle, fields)=>{
    let best = -1;
    for (const f of fields || []){
        const v = String(f || '').toLowerCase();
        if (!v) continue;
        const at = v.indexOf(needle);
        if (at < 0) continue;
        const score = at === 0 ? 0 : 1;
        if (best < 0 || score < best) best = score;
        if (best === 0) return 0;
    }
    return best;
};
// What an App Store row and an integration kind are searched on — the
// server's store fields as far as each row carries them (name 4, category 2,
// key 2, description 1). HOW they match is the shared rule's, not this file's.
//
// An App Store row's name and line are ALSO searched in the words the member
// READS: the session language, through THE store-copy resolver — the call the
// row's own title and caption make (AppListItem) — beside the record's own
// words, which stay. The App Store's own search does the same
// (packages/marketplace/functions/index.js `_storeSearchFields`). The record
// carries English only, so a Georgian query matched no App Store app by the
// name or the line its row shows (lane DESC, gap 3). The shared rule keeps a
// word once, at its best field's weight, so a shown word that equals a record
// word adds nothing. With no element (a test, a bare call) only the record's
// own words are searched. The read is guarded like globalSearch's own name
// read (`_name`): an element that cannot answer the resolver — it throws —
// costs the shown words, never the suggestions.
const $aaab0a6f7f0897e6$var$_storeSuggestFields = (el)=>{
    const shown = (a, field)=>{
        if (!a || !el || typeof el.call !== 'function') return '';
        try {
            return el.call('storeItemText', a, field) || '';
        } catch (_) {
            return '';
        }
    };
    return [
        {
            get: (a)=>a && a.name || '',
            weight: 4
        },
        {
            get: (a)=>shown(a, 'name'),
            weight: 4
        },
        {
            get: (a)=>a && a.category || '',
            weight: 2
        },
        {
            get: (a)=>a && a.key || '',
            weight: 2
        },
        {
            get: (a)=>a && a.description || '',
            weight: 1
        },
        {
            get: (a)=>shown(a, 'description'),
            weight: 1
        }
    ];
};
const $aaab0a6f7f0897e6$var$_integrationSuggestFields = ()=>[
        {
            get: (k)=>k && k.label || '',
            weight: 4
        },
        {
            get: (k)=>k && k.category || '',
            weight: 2
        },
        {
            get: (k)=>k && k.kind || '',
            weight: 2
        },
        {
            get: (k)=>k && k.description || '',
            weight: 1
        }
    ];
// Stable sort: rank first, then the source order (SEARCH_APPS' own order,
// which is the launcher's curated order — Work before Team before Insights).
const $aaab0a6f7f0897e6$var$_byRank = (a, b)=>a.rank - b.rank || a.order - b.order;
// One row, in both contracts at once. See the header for why it is double-keyed.
//
// `appKey` rides along when the tile names an app RECORD — an installed app's
// one launcher tile (workspaceConfigs.js stamps it) or an App Store row (its
// own key). AppListItem's title reads the name through THE store-copy
// resolver with it, so the row says what the App Store says (Nika 2026-10-23:
// "app names = what a person sees in the workspace App Store"). A tile with no
// record — a house tile, an app's sub-surface, a customer's own — carries none
// and reads exactly as before.
//
// `captionAppKey` rides along only on an App Store row: its caption is the
// RECORD's one line, so AppListItem's caption reads it through the same
// resolver with this key — the store's line in the session language (lane
// DESC, gap 3). `appKey` cannot say it: an installed app's tile carries
// `appKey` for its name, and its caption is the app's own.
const $aaab0a6f7f0897e6$var$_appRow = (category, tile, id)=>({
        _category: category,
        _id: id || tile.route || tile.title,
        _title: tile.title,
        _subtitle: tile.caption || '',
        _href: tile.route,
        _appRoute: tile.route,
        title: tile.title,
        caption: tile.caption || '',
        icon: tile.icon || 'blocks',
        iconBg: tile.iconBg,
        route: tile.route,
        ...tile.appKey ? {
            appKey: tile.appKey
        } : {},
        ...tile.captionAppKey ? {
            captionAppKey: tile.captionAppKey
        } : {}
    });
const $aaab0a6f7f0897e6$export$38a2ad293231352c = (groups, query, opts)=>{
    const q = String(query || '').trim().toLowerCase();
    if (!q) return [];
    const options = opts || {};
    const translate = typeof options.translate === 'function' ? options.translate : (k)=>k;
    const name = typeof options.name === 'function' ? options.name : ()=>'';
    const limit = options.limit || 5;
    // `userApps` (root._userApps): the person's own apps join as a last group,
    // Your apps (personAppTiles below), so the caller needs one helper only.
    const base = groups || [];
    const yours = options.userApps ? $aaab0a6f7f0897e6$export$f50f0720fe70283a(options.userApps, base.flatMap((g)=>g && g.apps || [])) : [];
    const all = yours.length ? [
        ...base,
        {
            key: 'your-apps',
            label: 'workspace.addApp.apps.yours',
            apps: yours
        }
    ] : base;
    const seen = new Set();
    const scored = [];
    for (const g of all)for (const a of g && g.apps || []){
        if (!a || !a.route) continue;
        // Dedupe by ROUTE: the same destination legitimately appears in more
        // than one launcher group (SEARCH_APPS lists /team-members twice, as
        // "Team members" and as "Users"), and two rows opening the same page is
        // a worse answer than one.
        const key = String(a.route).toLowerCase();
        if (seen.has(key)) continue;
        const rank = $aaab0a6f7f0897e6$var$_rank(q, [
            name(a),
            translate(a.title),
            translate(a.caption),
            a.title,
            String(a.route).replace(/^\//, '')
        ]);
        if (rank < 0) continue;
        seen.add(key);
        scored.push({
            rank: rank,
            order: scored.length,
            row: $aaab0a6f7f0897e6$var$_appRow('apps', a)
        });
    }
    return scored.sort($aaab0a6f7f0897e6$var$_byRank).slice(0, limit).map((s)=>s.row);
};
const $aaab0a6f7f0897e6$export$f50f0720fe70283a = (userApps, workspaceTiles)=>{
    const inWorkspace = new Set();
    for (const tile of workspaceTiles || []){
        const hit = /^\/x\/([^/?#]+)/.exec(String(tile && tile.route || ''));
        if (hit) inWorkspace.add(decodeURIComponent(hit[1]));
    }
    const at = (app)=>{
        const raw = app.updatedAt || app.updated_at || app.createdAt || app.created_at;
        const t = typeof raw === 'number' ? raw : Date.parse(raw || '');
        return Number.isFinite(t) ? t : 0;
    };
    return (Array.isArray(userApps) ? userApps : []).filter((app)=>app && app.id && String(app.name || '').trim()).filter((app)=>!inWorkspace.has(String(app.id))).map((app, i)=>({
            app: app,
            t: at(app),
            i: i
        })).sort((a, b)=>b.t - a.t || a.i - b.i).map(({ app: app })=>({
            title: String(app.name).trim(),
            caption: 'workspace.addApp.apps.yours',
            icon: app.appKind === 'multipage' ? 'layers' : 'blocks',
            route: '/add-app?thread=' + encodeURIComponent(String(app.id))
        }));
};
const $aaab0a6f7f0897e6$export$d9de4ba7f1013ed1 = (query, opts)=>{
    const q = String(query || '').trim().toLowerCase();
    const options = opts || {};
    const limit = options.limit || 5;
    const rows = [];
    // Both catalogues rank through the shared rule (see the import note): the
    // matching rows only, best first, the catalogue's own order between equals.
    const storeRows = (options.catalog || []).filter((a)=>a && a.key);
    const store = q ? $aaab0a6f7f0897e6$var$_rankStoreRows(options.el, storeRows, q, $aaab0a6f7f0897e6$var$_storeSuggestFields(options.el)) : [];
    // A row's App Store page — the App Store's own item deep link, from its one
    // builder (marketplace functions/appStoreItemLink.js, registered at boot),
    // which the /add-app catalog card's Details link asks too
    // (components/AddAppCatalogCard.js): a suggestion and the rail agree on
    // where an app lives. Asked through the element, like the store rule above,
    // and guarded like the shown words: with no element (a test, a bare call),
    // or one that cannot answer, the row has no link, never no row.
    const storeLink = (a)=>{
        const el = options.el;
        if (!el || typeof el.call !== 'function') return null;
        try {
            return el.call('appStoreItemLink', a.owner, a.key) || null;
        } catch (_) {
            return null;
        }
    };
    rows.push(...store.slice(0, limit).map((a)=>// The caption travels as the record's words and names its record
        // (`captionAppKey`, see `_appRow`), so it resolves where it renders,
        // like the title.
        $aaab0a6f7f0897e6$var$_appRow('appstore', {
            title: a.name || a.key,
            caption: a.description || 'workspace.search.suggest.appStoreRow',
            icon: 'blocks',
            route: storeLink(a),
            appKey: a.key,
            captionAppKey: a.key
        }, `appstore:${a.owner}/${a.key}`)));
    const kindRows = (options.integrationKinds || []).filter((k)=>k && k.kind);
    const integrations = q ? $aaab0a6f7f0897e6$var$_rankStoreRows(options.el, kindRows, q, $aaab0a6f7f0897e6$var$_integrationSuggestFields()) : [];
    rows.push(...integrations.slice(0, limit).map((k)=>// Every integration row lands on the marketplace's Integrations
        // SURFACE rather than a per-kind deep link. The per-kind marketplace id
        // (`int.<slug>`, with three overrides) is the marketplace package's own
        // mapping and the shell must not grow a second copy of it, and the
        // /admin/integrations/<kind> detail pages are an explicit route map
        // that a catalogue kind can be absent from — a suggestion that 404s is
        // worse than one that lands on the shelf it lives on.
        $aaab0a6f7f0897e6$var$_appRow('integrations', {
            title: k.label || k.kind,
            caption: k.description || 'workspace.search.suggest.integrationRow',
            icon: 'api',
            route: '/marketplace?surface=integrations'
        }, `integration:${k.kind}`)));
    rows.push(...$aaab0a6f7f0897e6$var$_BROWSE_ROWS.map((b)=>$aaab0a6f7f0897e6$var$_appRow('discover', b, b.id)));
    return rows;
};

});

parcelRegister("4jMOb", function(module, exports) {

$parcel$export(module.exports, "commandSearchHits", () => $324ecc18ae7aa9cf$export$4d4f65e5e9cca65c);
// Global search — COMMAND rows: the ⌘K palette offers the shell keyboard
// registry's rows (HOME_AMBIENT_SKIN_SPEC §5: "The command palette (ws-w2)
// lists the same registry rows with keycaps" · DESIGN-WL-SHELL-KEYBOARD-MOTION-1).
//
// `rows` is `el.call('listShortcuts')` — { id, label, group, keycaps[], joiner,
// sequence, adopted, runnable, active }, `label` / `group` being bundle KEYS.
// PURE over data, so it unit-tests without a registry, a DOM or a network
// (globalSearch.js reads the registry and writes the state).
//
// WHAT IS OFFERED: a row whose command can run HERE, now — the registry's
// `runnable` (a `run` AND the row's own `when` for the live root, so
// "Customize dashboard" is not offered off the home board). Never an ADOPTED
// row (⌘K is HeaderSearch's, Enter is the focused card's — the registry lists
// them and runs neither), and never a key RANGE (1–9 opens the nth tile: the
// keystroke IS the argument, and a pick has none).
//
// KEYCAPS travel only while the keystroke works (`active` — the person's
// single-key switch, the workspace flag): a keycap for a dead key is a lie
// (AppKeycap's rule; the ? sheet drops those rows the same way). The row is
// still offered — a pick is a command, not a key (`runShortcut`).
//
// MATCHING: the translated label and the translated group ("go" offers every
// Go to row), in the session language and — with `fallbackLang` — in that
// language too, so a Georgian session still answers "keyboard". A translation
// that comes back AS its key (polyglot's missing-key echo) is never matched:
// every key shares its dotted prefix, and "sh" is not every command. Two
// buckets, as in searchAppResults.js: a field that STARTS with the query, then
// a field that contains it; ties keep the registry's own order.
//
// ROW SHAPE — double-keyed, like the app rows: the search-result contract
// (`_category` / `_id` / `_title` / `_subtitle`, grouped and indexed by
// globalSearch.js) plus the sheet-row contract (`label` / `group` / `keycaps`
// / `joiner`), which the palette row renders through the ? sheet's own row
// (components/NavSearchDropdown.js NavSearchCommandItem extends
// ShortcutsSheetRow), so a shortcut reads the same in both places. KEYS, never
// pre-resolved strings, so a language switch re-renders. `_shortcutId` is the
// marker activateNavSearchSelection routes to `runSearchCommand`; there is no
// `_href` — a command is not a place. `ariaKeys` names the keystroke to
// assistive technology (aria-keyshortcuts): a chord or one key; null for a
// sequence ("G then H" is two keystrokes, which the attribute cannot say) and
// for a row with no live keystroke.
//
// Self-contained on purpose (frank serializes every registered function
// ALONE): every helper lives inside the function.
const $324ecc18ae7aa9cf$export$4d4f65e5e9cca65c = (rows, query, opts)=>{
    const q = String(query || '').trim().toLowerCase();
    if (!q || !Array.isArray(rows)) return [];
    const options = opts || {};
    const translate = typeof options.translate === 'function' ? options.translate : (k)=>k;
    const fallbackLang = options.fallbackLang || null;
    const limit = options.limit || 5;
    const said = (key, lang)=>{
        if (!key) return '';
        let v = '';
        try {
            v = lang ? translate(key, lang) : translate(key);
        } catch (_) {
            v = '';
        }
        return typeof v === 'string' && v && v !== key ? v.toLowerCase() : '';
    };
    const ARIA = {
        "\u2318": 'Meta',
        Ctrl: 'Control',
        "\u2325": 'Alt',
        Alt: 'Alt',
        "\u21E7": 'Shift',
        Esc: 'Escape',
        "\u21B5": 'Enter'
    };
    const scored = [];
    for (const r of rows){
        if (!r || typeof r !== 'object' || !r.id || !r.label) continue;
        if (!r.runnable || r.adopted || r.joiner === 'range') continue;
        const fields = [
            said(r.label),
            said(r.group)
        ];
        if (fallbackLang) fields.push(said(r.label, fallbackLang), said(r.group, fallbackLang));
        let rank = -1;
        for (const f of fields){
            if (!f) continue;
            const at = f.indexOf(q);
            if (at < 0) continue;
            const score = at === 0 ? 0 : 1;
            if (rank < 0 || score < rank) rank = score;
        }
        if (rank < 0) continue;
        const keycaps = r.active && Array.isArray(r.keycaps) ? r.keycaps.map(String) : [];
        const ariaKeys = keycaps.length && !r.sequence && r.joiner !== 'then' ? keycaps.map((cap)=>ARIA[cap] || cap).join('+') : null;
        scored.push({
            rank: rank,
            order: scored.length,
            row: {
                _category: 'commands',
                _id: 'command:' + r.id,
                _title: r.label,
                _subtitle: r.group || '',
                _shortcutId: r.id,
                label: r.label,
                group: r.group || '',
                keycaps: keycaps,
                joiner: r.joiner || null,
                ariaKeys: ariaKeys
            }
        });
    }
    return scored.sort((a, b)=>a.rank - b.rank || a.order - b.order).slice(0, limit).map((s)=>s.row);
};

});

parcelRegister("55G3L", function(module, exports) {

$parcel$export(module.exports, "APP_RECORDS_SURFACE", () => $3b4e0b93caaf90e0$export$36b90c365dc6dc4f);
$parcel$export(module.exports, "APP_RECORDS_ORDER", () => $3b4e0b93caaf90e0$export$80d5b5db231d01f7);
$parcel$export(module.exports, "isAppRecordsCategory", () => $3b4e0b93caaf90e0$export$d97471311c283958);
$parcel$export(module.exports, "SEARCH_CHIPS_CATEGORY", () => $3b4e0b93caaf90e0$export$581f71fbf6051e04);
$parcel$export(module.exports, "SEARCH_FILTERS_CATEGORY", () => $3b4e0b93caaf90e0$export$1542edd44b22e9b7);
$parcel$export(module.exports, "SEARCH_ACTIONS_CATEGORY", () => $3b4e0b93caaf90e0$export$1ddc2f30fabdd3f2);
$parcel$export(module.exports, "searchChipKey", () => $3b4e0b93caaf90e0$export$836f2b14bc6846e2);
$parcel$export(module.exports, "serializeSearchChips", () => $3b4e0b93caaf90e0$export$467ea64b58d0341c);
$parcel$export(module.exports, "activeChipRows", () => $3b4e0b93caaf90e0$export$3fdd3614226af47e);
$parcel$export(module.exports, "facetFilterRows", () => $3b4e0b93caaf90e0$export$2a70dbee0940b7b2);
$parcel$export(module.exports, "searchMatchTotal", () => $3b4e0b93caaf90e0$export$502eb59817ba68fd);
$parcel$export(module.exports, "searchActionRows", () => $3b4e0b93caaf90e0$export$426a23a7002a963a);
$parcel$export(module.exports, "searchHandoffHref", () => $3b4e0b93caaf90e0$export$1b8c7d9baf5030de);
$parcel$export(module.exports, "appRecordSearchHits", () => $3b4e0b93caaf90e0$export$509eb785ab15c6e9);
// ⌘K — the rows an installed app opts into the workspace search
// (CMDK-FINDS-APP-RECORDS-1): fleet nodes, incidents, networks.
//
// An app marks a collection searchable in its own manifest
// (`collections[].search: { title, subtitle }`); the server answers the
// member search over those collections only (surface 'app-records': the
// caller's records grant and field rules apply, matched on the declared
// fields only), and each result is an entity ref with its title, its
// subtitle and the app it belongs to. This builder turns those results into
// dropdown rows:
//
//   - one GROUP per app, labelled with the app's own name (tenant content —
//     polyglot passes it through unchanged), right after People;
//   - a row OPENS on the module page that owns its collection, through the
//     record-route registry (`entityRefHref`) — a result nothing in this
//     workspace can open is dropped, never shown as a dead row.
//
// A plain builder, not an `el.call` function — imported directly by
// globalSearch.js, like searchAppResults.js and searchCommandResults.js.
const $3b4e0b93caaf90e0$export$36b90c365dc6dc4f = 'app-records';
const $3b4e0b93caaf90e0$export$899c0c984a7e5ccc = 'records:';
const $3b4e0b93caaf90e0$export$80d5b5db231d01f7 = 0.5;
const $3b4e0b93caaf90e0$export$d97471311c283958 = (cat)=>typeof cat === 'string' && cat.startsWith($3b4e0b93caaf90e0$export$899c0c984a7e5ccc);
const $3b4e0b93caaf90e0$var$_safe = (fn, ...args)=>{
    try {
        return fn ? fn(...args) : null;
    } catch (_) {
        return null;
    }
};
const $3b4e0b93caaf90e0$export$581f71fbf6051e04 = 'search-chips';
const $3b4e0b93caaf90e0$export$1542edd44b22e9b7 = 'search-filters';
const $3b4e0b93caaf90e0$export$1ddc2f30fabdd3f2 = 'search-actions';
const $3b4e0b93caaf90e0$var$FILTER_ROWS_IDLE = 6;
const $3b4e0b93caaf90e0$var$FILTER_ROWS_FOR_TERM = 4;
const $3b4e0b93caaf90e0$var$CHIP_FIELD = /^[A-Za-z_][A-Za-z0-9_]{0,63}$/;
const $3b4e0b93caaf90e0$var$_chipOk = (c)=>!!c && typeof c.field === 'string' && $3b4e0b93caaf90e0$var$CHIP_FIELD.test(c.field) && typeof c.value === 'string' && !!c.value.trim() && c.value.length <= 120 && !c.value.includes('"');
const $3b4e0b93caaf90e0$export$836f2b14bc6846e2 = (c)=>c ? `${c.field}:${c.value}` : '';
function $3b4e0b93caaf90e0$export$467ea64b58d0341c(chips) {
    return (Array.isArray(chips) ? chips : []).filter($3b4e0b93caaf90e0$var$_chipOk).map((c)=>/\s/.test(c.value) ? `${c.field}:"${c.value}"` : `${c.field}:${c.value}`).join(' ');
}
// "Environment · Mainnet" — the chip as a member reads it.
const $3b4e0b93caaf90e0$var$_recordChipText = (c)=>`${c.fieldLabel || c.field} \xb7 ${c.label || c.value}`;
function $3b4e0b93caaf90e0$export$3fdd3614226af47e(chips) {
    return (Array.isArray(chips) ? chips : []).filter($3b4e0b93caaf90e0$var$_chipOk).map((c)=>({
            _category: $3b4e0b93caaf90e0$export$581f71fbf6051e04,
            _id: 'chip:' + $3b4e0b93caaf90e0$export$836f2b14bc6846e2(c),
            _title: $3b4e0b93caaf90e0$var$_recordChipText(c),
            _metaKey: 'workspace.search.chip.remove',
            _icon: 'close',
            _searchAction: {
                type: 'chip-remove',
                key: $3b4e0b93caaf90e0$export$836f2b14bc6846e2(c)
            }
        }));
}
function $3b4e0b93caaf90e0$export$69c28a3f1a69b46e(parts) {
    const list = Array.isArray(parts) ? parts.filter((p)=>p && Number(p.count) > 0) : [];
    if (list.length < 2) return '';
    const apps = new Set(list.map((p)=>p.appId || p.appName || ''));
    const named = list.map((p)=>({
            name: p.listLabel || (apps.size > 1 ? p.appName : '') || '',
            count: Number(p.count) || 0
        }));
    if (named.some((p)=>!p.name)) return '';
    if (new Set(named.map((p)=>p.name)).size < named.length) return '';
    return named.map((p)=>`${p.name} ${p.count}`).join(" \xb7 ");
}
function $3b4e0b93caaf90e0$export$2a70dbee0940b7b2(facets, { term: term = '', chips: chips = [], limit: limit } = {}) {
    const active = new Set((Array.isArray(chips) ? chips : []).map($3b4e0b93caaf90e0$export$836f2b14bc6846e2));
    const merged = new Map();
    for (const f of Array.isArray(facets) ? facets : []){
        if (!f || typeof f.field !== 'string' || !Array.isArray(f.values)) continue;
        for (const v of f.values){
            if (!v || typeof v.value !== 'string') continue;
            const chip = {
                field: f.field,
                value: v.value,
                label: typeof v.label === 'string' && v.label ? v.label : v.value,
                fieldLabel: typeof f.label === 'string' && f.label ? f.label : f.field
            };
            if (!$3b4e0b93caaf90e0$var$_chipOk(chip)) continue;
            const key = $3b4e0b93caaf90e0$export$836f2b14bc6846e2(chip);
            if (active.has(key)) continue;
            const prev = merged.get(key);
            const count = Number(v.count) || 0;
            const part = {
                collection: f.collection,
                listLabel: typeof f.listLabel === 'string' ? f.listLabel : '',
                appId: f.app && f.app.id || '',
                appName: f.app && f.app.name || '',
                count: count
            };
            merged.set(key, {
                chip: chip,
                count: (prev ? prev.count : 0) + count,
                parts: [
                    ...prev ? prev.parts : [],
                    part
                ]
            });
        }
    }
    const t = String(term || '').trim().toLowerCase();
    let rows = [
        ...merged.values()
    ];
    if (t) rows = rows.filter(({ chip: chip })=>[
            chip.label,
            chip.value,
            chip.fieldLabel
        ].some((s)=>String(s).toLowerCase().includes(t)));
    rows.sort((a, b)=>b.count - a.count || $3b4e0b93caaf90e0$var$_recordChipText(a.chip).localeCompare($3b4e0b93caaf90e0$var$_recordChipText(b.chip)));
    const cap = limit || (t ? $3b4e0b93caaf90e0$var$FILTER_ROWS_FOR_TERM : $3b4e0b93caaf90e0$var$FILTER_ROWS_IDLE);
    return rows.slice(0, cap).map(({ chip: chip, count: count, parts: parts })=>{
        const hint = $3b4e0b93caaf90e0$export$69c28a3f1a69b46e(parts);
        return {
            _category: $3b4e0b93caaf90e0$export$1542edd44b22e9b7,
            _id: 'filter:' + $3b4e0b93caaf90e0$export$836f2b14bc6846e2(chip),
            _title: $3b4e0b93caaf90e0$var$_recordChipText(chip),
            _meta: String(count),
            ...hint ? {
                _hint: hint
            } : {},
            _icon: 'filter',
            _searchAction: {
                type: 'chip-add',
                chip: chip
            }
        };
    });
}
function $3b4e0b93caaf90e0$export$502eb59817ba68fd({ totals: totals, handoffs: handoffs, results: results, limit: limit } = {}) {
    const list = Array.isArray(totals) ? totals.filter(Boolean) : [];
    if (list.length) return {
        count: list.reduce((n, t)=>n + (Number(t.total) || 0), 0),
        capped: list.some((t)=>t.capped === true)
    };
    const fromHandoffs = (Array.isArray(handoffs) ? handoffs : []).reduce((n, h)=>n + (Number(h?.total) || 0), 0);
    if (fromHandoffs) return {
        count: fromHandoffs,
        capped: false
    };
    const page = Array.isArray(results) ? results.length : 0;
    return {
        count: page,
        capped: !!limit && page >= limit
    };
}
const $3b4e0b93caaf90e0$var$_recordCountText = (n, capped)=>capped ? `${n}+` : n;
function $3b4e0b93caaf90e0$export$426a23a7002a963a({ chips: chips = [], handoffs: handoffs = [], total: total, totalCapped: totalCapped = false, totals: totals = [] } = {}) {
    if (!(Array.isArray(chips) ? chips : []).some($3b4e0b93caaf90e0$var$_chipOk)) return [];
    const rows = [];
    for (const h of Array.isArray(handoffs) ? handoffs : []){
        if (!h || typeof h.route !== 'string' || typeof h.param !== 'string') continue;
        const values = Array.isArray(h.values) ? h.values.filter((v)=>typeof v === 'string' && v) : [];
        if (!values.length) continue;
        const appName = h.app && h.app.name || '';
        rows.push({
            _category: $3b4e0b93caaf90e0$export$1ddc2f30fabdd3f2,
            _id: 'handoff:' + (h.collection || h.route),
            ...h.label ? {
                _title: h.label
            } : {
                _titleKey: 'workspace.search.action.openIn',
                _titleParams: {
                    app: appName
                }
            },
            _metaKey: 'workspace.search.action.rows',
            _metaParams: {
                count: $3b4e0b93caaf90e0$var$_recordCountText(Number(h.total) || values.length, (Array.isArray(totals) ? totals : []).some((t)=>t && t.collection === h.collection && t.capped === true))
            },
            _icon: 'arrowRight',
            _searchAction: {
                type: 'handoff',
                route: h.route,
                param: h.param,
                values: values
            }
        });
    }
    const n = Number(total) || 0;
    if (n) rows.push({
        _category: $3b4e0b93caaf90e0$export$1ddc2f30fabdd3f2,
        _id: 'ask',
        _titleKey: 'workspace.search.action.ask',
        _metaKey: 'workspace.search.action.rows',
        _metaParams: {
            count: $3b4e0b93caaf90e0$var$_recordCountText(n, totalCapped)
        },
        _icon: 'chat',
        _searchAction: {
            type: 'ask'
        }
    });
    rows.push({
        _category: $3b4e0b93caaf90e0$export$1ddc2f30fabdd3f2,
        _id: 'clear',
        _titleKey: 'workspace.search.action.clear',
        _icon: 'dismiss',
        _searchAction: {
            type: 'chips-clear'
        }
    });
    return rows;
}
function $3b4e0b93caaf90e0$export$1b8c7d9baf5030de(action) {
    if (!action || typeof action.route !== 'string' || typeof action.param !== 'string') return '';
    if (action.route[0] !== '/' || action.route[1] === '/' || /[?#\s]/.test(action.route)) return '';
    const values = (Array.isArray(action.values) ? action.values : []).filter((v)=>typeof v === 'string' && v);
    if (!values.length || !$3b4e0b93caaf90e0$var$CHIP_FIELD.test(action.param.replace(/-/g, '_'))) return '';
    return `${action.route}?${encodeURIComponent(action.param)}=${values.map(encodeURIComponent).join(',')}`;
}
function $3b4e0b93caaf90e0$export$509eb785ab15c6e9(results, { hrefFor: hrefFor, iconFor: iconFor, limit: limit = 5 } = {}) {
    const out = [];
    for (const r of Array.isArray(results) ? results : []){
        if (out.length >= limit) break;
        if (!r || typeof r.ref !== 'string' || r.surface !== $3b4e0b93caaf90e0$export$36b90c365dc6dc4f) continue;
        const href = $3b4e0b93caaf90e0$var$_safe(hrefFor, r.ref);
        if (typeof href !== 'string' || !href) continue;
        const appId = r.app && typeof r.app.id === 'string' && r.app.id || r.collection || 'records';
        const icon = $3b4e0b93caaf90e0$var$_safe(iconFor, r.ref);
        out.push({
            _category: $3b4e0b93caaf90e0$export$899c0c984a7e5ccc + appId,
            _groupLabel: r.app && typeof r.app.name === 'string' && r.app.name || r.collection || '',
            ...typeof icon === 'string' && icon ? {
                _groupIcon: icon
            } : {},
            _id: r.ref,
            _title: typeof r.title === 'string' && r.title || r.ref,
            _subtitle: typeof r.snippet === 'string' ? r.snippet : '',
            _href: href
        });
    }
    return out;
}

});



parcelRegister("eKWOV", function(module, exports) {

$parcel$export(module.exports, "MC_SETTINGS_KEYS", () => $abe2fd0b23ee5206$export$f28600ceebf54e90);
$parcel$export(module.exports, "mcLoadState", () => $abe2fd0b23ee5206$export$91461c33e47410d6);
$parcel$export(module.exports, "mcListModuleVersions", () => $abe2fd0b23ee5206$export$40c9b1e23818a4d7);
$parcel$export(module.exports, "mcAssignModule", () => $abe2fd0b23ee5206$export$beb22d860d2e9861);
$parcel$export(module.exports, "mcSavePersonalization", () => $abe2fd0b23ee5206$export$589560100432c619);
$parcel$export(module.exports, "mcRollbackModule", () => $abe2fd0b23ee5206$export$3ebfde7ce02db5f3);
$parcel$export(module.exports, "mcEditListItem", () => $abe2fd0b23ee5206$export$ec4d9f5a7c14717b);
$parcel$export(module.exports, "mcAddListItem", () => $abe2fd0b23ee5206$export$ffe0d9f3de1b3092);
$parcel$export(module.exports, "mcRemoveListItem", () => $abe2fd0b23ee5206$export$5f8226c0d578446f);
$parcel$export(module.exports, "mcMoveListItem", () => $abe2fd0b23ee5206$export$96aad30ec5b6b4aa);
$parcel$export(module.exports, "mcTogglePanel", () => $abe2fd0b23ee5206$export$5a80d383efaac10e);
$parcel$export(module.exports, "MC_RECORDS_GRANT_OPS", () => $abe2fd0b23ee5206$export$cb85f7823ad81150);
$parcel$export(module.exports, "mcDefaultAppId", () => $abe2fd0b23ee5206$export$38beeca6efcf1ed9);
$parcel$export(module.exports, "mcRevokeRecordsCollection", () => $abe2fd0b23ee5206$export$eea497f2e1f693ae);
$parcel$export(module.exports, "mcToggleRecordsOp", () => $abe2fd0b23ee5206$export$f8697e62045cde8e);
$parcel$export(module.exports, "mcSaveSelectedAppGrant", () => $abe2fd0b23ee5206$export$628ff38e451affb1);
$parcel$export(module.exports, "mcCheckAppSync", () => $abe2fd0b23ee5206$export$3d4e99428f52b629);
$parcel$export(module.exports, "mcGrantCanon", () => $abe2fd0b23ee5206$export$b7e3cf15a4cbb08c);
$parcel$export(module.exports, "mcLevelChanges", () => $abe2fd0b23ee5206$export$724db6d1ff2dbce8);
$parcel$export(module.exports, "mcToggleSyncSelection", () => $abe2fd0b23ee5206$export$c081cfbe2a0125b2);
$parcel$export(module.exports, "mcApplyAppSync", () => $abe2fd0b23ee5206$export$d4e32fa681dbf068);
$parcel$export(module.exports, "mcMigrateLegacyAppInstall", () => $abe2fd0b23ee5206$export$9f7d9e62f4a70fbd);
$parcel$export(module.exports, "mcValidateDesignSystem", () => $abe2fd0b23ee5206$export$78a0a4391ae83e3e);
$parcel$export(module.exports, "mcRemoveModule", () => $abe2fd0b23ee5206$export$83deaa5a9e45a61c);
$parcel$export(module.exports, "mcResetPersonalization", () => $abe2fd0b23ee5206$export$aba73721d6a5b450);
$parcel$export(module.exports, "mcResetNavbar", () => $abe2fd0b23ee5206$export$c0cf082f6c0d7673);
// moduleConsole.js — el.call action helpers for the /admin/module console
// (pages/admin/module.js). Every backend touch is SDK-only (el.sdk.*) — zero
// raw fetch. The console lets an org owner/admin point the workspace at a
// module + version, manage the module's records capability grant
// (workspace_records via moduleDataBridge), personalize (navbar / apps /
// panels / designSystem), and roll a version back.
//
// Calling convention (matches greenigActions.js / moduleActions.js): these are
// registered functions invoked via `el.call('mcX', ...args)`, so inside each
// `this` IS the element. We read `el = this`, `root = el.state.root`, and the
// SDK off `el.sdk` (bootShell exposes context.methods.sdk as el.sdk). Explicit
// args (slug, keyName, value, version) ride after the name.
//
// State model — all console state lives under `_mc*` root keys so it's easy to
// reason about and never collides with shell/module state:
//   _mcState          { loaded, loading, error, wsId, orgId, orgSlug, settings }
//   _mcTab            active tab id
//   _mcModuleDraft    { owner, key, channel, version, tier }
//   _mcVersions       { loading, error, list, envs }
//   _mcDs             { text, parsed, error, validated }
//   _mcBusy           { assign, rollback, personalize, uninstall }
//   _mcGrantAppId     Grant tab's selected app ("owner/key") — workspaceModule
//                      or one entry of the plural workspaceApps list
//   _mcSyncChecking   the app id currently being manifest-diffed, or null
//   _mcSyncDiff        { appId, declared, granted, added, stale, checkedAt }
//   _mcSyncSelection   { grant: {collection: bool}, revoke: {collection: bool} }
//                      (bucket names deliberately avoid signal-store reserved
//                      method names — `add` collided; see STATE_METHODS in
//                      @symbo.ls/state src/methods.js)
//   _mcSyncError       last collections-sync check error message, or null
//
// Persistence is merge-safe: settings writes go through
// `el.sdk.updateWorkspaceSettings(wsId, partialSettings)` with ONLY the changed
// key(s) — never the whole settings bag. Each mutating action optimistically
// patches `root._mcState.settings`, then persists; a failure rolls the
// optimistic patch back and surfaces a Notification.

var $g7CNh = parcelRequire("g7CNh");

var $7ytvD = parcelRequire("7ytvD");

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $7muxD = parcelRequire("7muxD");
const $abe2fd0b23ee5206$var$shellWorkspaceSettings = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
const $abe2fd0b23ee5206$var$diffDeclaredCollections = (...args)=>(0, $1X0Je.default).functions.diffDeclaredCollections(...args);
const $abe2fd0b23ee5206$var$applyCollectionsSync = (...args)=>(0, $1X0Je.default).functions.applyCollectionsSync(...args);
const $abe2fd0b23ee5206$var$upsertWorkspaceApp = (...args)=>(0, $1X0Je.default).functions.upsertWorkspaceApp(...args);
const $abe2fd0b23ee5206$var$recordsEntryKey = (...args)=>(0, $1X0Je.default).functions.recordsEntryKey(...args);
const $abe2fd0b23ee5206$export$f28600ceebf54e90 = [
    'workspaceModule',
    'workspaceApps',
    'navbar',
    'apps',
    'home_default_panels',
    'designSystem'
];
// ── small internal helpers (single-file, pure) ────────────────────────────
const $abe2fd0b23ee5206$var$_sdkOf = (el)=>el && el.sdk || el && el.context && el.context.methods && el.context.methods.sdk || null;
const $abe2fd0b23ee5206$var$_consoleRootOf = (el)=>el && el.state && el.state.root || null;
// Toast wrapper — openNotification is a house method (shared/methods/
// notification.js). Swallow its throw on standalone surfaces where the toast
// infra isn't wired (mirrors IntegrationConfigureForm._toast).
const $abe2fd0b23ee5206$var$_consoleNotify = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (err) {
        console.warn('[moduleConsole]', payload && payload.title, payload && payload.message || '', err);
    }
};
const $abe2fd0b23ee5206$var$_orgSlugFromClaims = (claims)=>{
    const orgId = claims && claims.workspace_org_id;
    const orgs = claims && claims.orgs || [];
    const o = orgs.find((x)=>(x.id || x._id) === orgId);
    return o && (o.slug || o.username) || null;
};
// Resolve the ids the console needs from root, tolerant of the leaned-claims
// shape (root.workspace can lag behind an org switch — see workspaceProjects.js).
const $abe2fd0b23ee5206$var$_ids = (root)=>{
    // DECISION site (spec §5), NOT a write-base one — despite every write in this
    // file riding on the `wsId` it returns. What is read here is IDENTITY, and
    // identity is the one thing a list/claims-shaped record carries correctly:
    // it is missing `settings`, never `id`. Gating this on `ready` would strand
    // the console on exactly the boots where it is most needed (the record is
    // still in flight, but the workspace it refers to is already unambiguous),
    // and `updateWorkspaceSettings` is per-key merge-safe server-side, so a write
    // addressed by a correct id is safe regardless of what we hold locally. The
    // unsafe part is the LOCAL mirror — guarded separately, at each mirror.
    const { id: wsId } = $abe2fd0b23ee5206$var$shellWorkspaceSettings(root);
    const org = root.org || {};
    const claims = root.jwtClaims || {};
    return {
        wsId: wsId || null,
        orgId: claims.workspace_org_id || org.id || org._id || null,
        orgSlug: org.slug || org.username || $abe2fd0b23ee5206$var$_orgSlugFromClaims(claims) || null
    };
};
// Merge-safe optimistic patch of the console's working settings copy. Returns
// the previous value of the FIRST patched key so the caller can roll back.
const $abe2fd0b23ee5206$var$_patchSettings = (root, patch)=>{
    const st = root._mcState || {};
    const prevSettings = st.settings || {};
    const firstKey = Object.keys(patch)[0];
    const prevValue = firstKey ? prevSettings[firstKey] : undefined;
    root.update({
        _mcState: {
            ...st,
            settings: {
                ...prevSettings,
                ...patch
            }
        }
    });
    return prevValue;
};
const $abe2fd0b23ee5206$var$_setBusy = (root, key, val)=>{
    root.update({
        _mcBusy: {
            ...root._mcBusy || {},
            [key]: val
        }
    });
};
// ── workspaceApps compare-and-swap ─────────────────────────────────────────
// `settings.workspaceApps[]` is written as a WHOLE ARRAY by five different
// callers (marketplace install, /add-app install, both uninstalls, and this
// console's records-grant save), so two of them used to silently clobber each
// other — and each entry's `capabilities.records.collections` is an
// AUTHORIZATION field. `PATCH /core/workspaces/:id/settings` therefore
// preserves a still-installed app's stored capabilities UNLESS the writer
// proves freshness by echoing back the array it read, as `expectedApps`; a
// stale echo is refused with 409 instead of applied. This console is where
// deliberate grant/revoke edits happen, so it always sends the precondition.
const $abe2fd0b23ee5206$var$_appsPatch = (root, patch)=>{
    if (!('workspaceApps' in patch)) return patch;
    return {
        ...patch,
        expectedApps: root && root._mcAppsBaseline || []
    };
};
// After a successful write our payload IS what the server now holds, so it
// becomes the baseline for the next save — no extra round-trip.
const $abe2fd0b23ee5206$var$_rebaseApps = (root, value)=>{
    root.update({
        _mcAppsBaseline: Array.isArray(value) ? JSON.parse(JSON.stringify(value)) : []
    });
};
const $abe2fd0b23ee5206$var$_isAppsConflict = (err)=>/apps_version_conflict|changed since you read it/i.test(err && err.message || '');
// A 409 is not a failure the operator caused — someone else installed or
// uninstalled an app while this tab was open. Re-read so the tab shows the
// truth, and say plainly that the edit has to be redone on top of it.
const $abe2fd0b23ee5206$var$_handleSaveError = async (el, root, err, failTitleKey, fallbackMessage)=>{
    if (!$abe2fd0b23ee5206$var$_isAppsConflict(err)) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', failTitleKey),
        message: err && err.message || fallbackMessage || '',
        type: 'error'
    });
    await el.call('mcLoadState');
    $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.appsChanged'),
        message: el.call('polyglot', 'admin.module.notify.appsChangedBody'),
        type: 'error'
    });
};
// Unwrap the SDK envelope ({success,data,message}) → data, tolerant of a bare
// payload (some read methods return raw).
const $abe2fd0b23ee5206$var$_data = (res)=>res && typeof res === 'object' && 'data' in res ? res.data : res;
// Validate a designSystem editor payload shape
// ({canvasBg?, vars?, varsLight?, varsDark?}). Returns the error sentence
// (resolved through `el`), or null when the shape is acceptable.
//
// A `vars` value may be a scalar OR a `{ light, dark }` pair, and the two
// sibling channels `varsLight` / `varsDark` carry the same fact one level up.
// All three exist because `vars` alone holds ONE value per token, which cannot
// express a token whose light half is a gradient and whose dark half is a
// colour — `light-dark()` takes two <color>s, so that record paints nothing
// (FW-DESIGN-SYSTEM-RECORD-NEEDS-PER-THEME-VARS-1; the reader is
// workspaceConfigs.js resolveDesignSystemVars).
const $abe2fd0b23ee5206$var$_validateDsShape = (obj, el)=>{
    if (obj == null || typeof obj !== 'object' || Array.isArray(obj)) return el.call('polyglot', 'admin.module.error.dsNotObject');
    if ('canvasBg' in obj && obj.canvasBg != null && typeof obj.canvasBg !== 'string') return el.call('polyglot', 'admin.module.error.dsCanvasBg');
    const isScalar = (v)=>typeof v === 'string' || typeof v === 'number';
    const isPair = (v)=>!!v && typeof v === 'object' && !Array.isArray(v) && ('light' in v || 'dark' in v);
    // The three channels share one error vocabulary: `dsVars` names a container
    // that is not an object of name → value pairs, `dsVarType` names the token
    // whose value is neither a scalar nor a well-formed { light, dark } pair.
    for (const channel of [
        'vars',
        'varsLight',
        'varsDark'
    ]){
        if (!(channel in obj) || obj[channel] == null) continue;
        const bag = obj[channel];
        if (typeof bag !== 'object' || Array.isArray(bag)) return el.call('polyglot', 'admin.module.error.dsVars');
        for (const [k, v] of Object.entries(bag)){
            // A pair is legal in `vars` only — inside varsLight/varsDark it would be
            // a theme nested in a theme, which has no reading.
            if (channel === 'vars' && isPair(v)) {
                const halves = [
                    v.light,
                    v.dark
                ].filter((h)=>h != null);
                if (halves.length && halves.every(isScalar)) continue;
                return el.call('polyglot', 'admin.module.error.dsVarType').replace('{name}', k);
            }
            if (isScalar(v)) continue;
            return el.call('polyglot', 'admin.module.error.dsVarType').replace('{name}', k);
        }
    }
    return null;
};
async function $abe2fd0b23ee5206$export$91461c33e47410d6() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId, orgId: orgId, orgSlug: orgSlug } = $abe2fd0b23ee5206$var$_ids(root);
    root.update({
        _mcState: {
            ...root._mcState || {},
            loading: true,
            error: null,
            wsId: wsId,
            orgId: orgId,
            orgSlug: orgSlug
        }
    });
    if (!sdk || !wsId) {
        root.update({
            _mcState: {
                ...root._mcState || {},
                loading: false,
                loaded: true,
                error: el.call('polyglot', !wsId ? 'admin.module.error.noWorkspace' : 'admin.module.notify.sdkNotReady'),
                settings: root._mcState && root._mcState.settings || {}
            }
        });
        return;
    }
    let settings = {};
    let error = null;
    try {
        const res = await sdk.getWorkspace(wsId);
        const full = $abe2fd0b23ee5206$var$_data(res) || {};
        settings = full.settings || {};
    } catch (err) {
        error = err && err.message || el.call('polyglot', 'admin.module.error.loadFailed');
    }
    const dsText = settings.designSystem ? JSON.stringify(settings.designSystem, null, 2) : '';
    root.update({
        _mcState: {
            loaded: true,
            loading: false,
            error: error,
            wsId: wsId,
            orgId: orgId,
            orgSlug: orgSlug,
            settings: settings
        },
        // The SERVER's copy of the app list, kept untouched by the optimistic
        // `_patchSettings` writes below — it is the compare-and-swap precondition
        // (`expectedApps`) every `workspaceApps` save sends. `_mcState.settings`
        // cannot serve that role: the Grant tab mutates it locally on every
        // revoke/op-toggle before Save is ever pressed, so by save time it is the
        // DESIRED state, not the observed one.
        _mcAppsBaseline: Array.isArray(settings.workspaceApps) ? JSON.parse(JSON.stringify(settings.workspaceApps)) : [],
        _mcDs: {
            text: dsText,
            parsed: settings.designSystem || null,
            error: null,
            validated: Boolean(settings.designSystem)
        },
        // Seed the module-assignment draft from the current reference (defaulting
        // owner = workspace org slug for Tier-1 self-serve).
        _mcModuleDraft: {
            owner: settings.workspaceModule && settings.workspaceModule.owner || orgSlug || '',
            key: settings.workspaceModule && settings.workspaceModule.key || '',
            channel: settings.workspaceModule && settings.workspaceModule.channel || 'production',
            version: settings.workspaceModule && settings.workspaceModule.version || '',
            tier: settings.workspaceModule && settings.workspaceModule.tier || 'trusted'
        }
    });
}
async function $abe2fd0b23ee5206$export$40c9b1e23818a4d7() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const draft = root._mcModuleDraft || {};
    const owner = draft.owner;
    const key = draft.key;
    if (!owner || !key) return root.update({
        _mcVersions: {
            loading: false,
            error: el.call('polyglot', 'admin.module.error.pickRef'),
            list: [],
            envs: []
        }
    });
    root.update({
        _mcVersions: {
            ...root._mcVersions || {},
            loading: true,
            error: null
        }
    });
    try {
        const project = $abe2fd0b23ee5206$var$_data(await sdk.getProjectByKey({
            owner: owner,
            key: key
        }));
        const projectId = project && (project._id || project.id);
        if (!projectId) throw new Error(el.call('polyglot', 'admin.module.error.projectNotFound').replace('{ref}', `${owner}/${key}`));
        let list = [];
        let envs = [];
        try {
            const v = $abe2fd0b23ee5206$var$_data(await sdk.getProjectVersions(projectId, {
                branch: draft.branch || 'main'
            }));
            list = Array.isArray(v) ? v : v && v.versions || [];
        } catch (err) {
            console.warn('[moduleConsole] getProjectVersions failed', err && err.message);
        }
        try {
            const e = $abe2fd0b23ee5206$var$_data(await sdk.listEnvironments(projectId));
            const map = e && e.environments || {};
            envs = Object.keys(map).map((k)=>({
                    key: k,
                    ...map[k]
                }));
        } catch (err) {
            console.warn('[moduleConsole] listEnvironments failed', err && err.message);
        }
        root.update({
            _mcVersions: {
                loading: false,
                error: null,
                list: list,
                envs: envs,
                projectId: projectId
            }
        });
    } catch (err) {
        root.update({
            _mcVersions: {
                loading: false,
                error: err && err.message || el.call('polyglot', 'admin.module.error.lookupFailed'),
                list: [],
                envs: []
            }
        });
    }
}
function $abe2fd0b23ee5206$export$beb22d860d2e9861() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const draft = root._mcModuleDraft || {};
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    if (!draft.owner || !draft.key) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.missingRef'),
        message: el.call('polyglot', 'admin.module.notify.missingRefBody'),
        type: 'error'
    });
    if (typeof sdk.updateWorkspaceSettings !== 'function') return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        message: el.call('polyglot', 'admin.module.notify.sdkNotReadyBody'),
        type: 'error'
    });
    el.call('confirmDialog', {
        title: el.call('polyglot', 'admin.module.assign.confirmTitle').replace('{module}', `${draft.owner}/${draft.key}`),
        message: el.call('polyglot', 'admin.module.assign.confirmMessage'),
        confirmText: el.call('polyglot', 'admin.module.assign.save'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: ()=>$abe2fd0b23ee5206$var$_assignModuleNow(el, root, sdk, draft, wsId)
    });
}
async function $abe2fd0b23ee5206$var$_assignModuleNow(el, root, sdk, draft, wsId) {
    // Spread the existing module ref first so server-managed fields (capabilities
    // grant edited on the Grant tab, resolved-version metadata, install stamps)
    // survive a re-assign — then override only the fields the form edits.
    const prevMod = root._mcState && root._mcState.settings && root._mcState.settings.workspaceModule || null;
    const workspaceModule = {
        ...prevMod || {},
        type: 'project',
        owner: draft.owner,
        key: draft.key,
        channel: draft.channel || 'production',
        version: draft.version || null,
        tier: draft.tier || 'trusted'
    };
    // Auto-grant on first assign: nothing else writes capabilities.records
    // (WORKSPACE_APPS.md ground truth), so an assign without a grant leaves the
    // module data bridge with nothing to allow. Grant the module its OWN
    // declared collections; an existing grant (Grant tab / re-assign of the
    // same module) is preserved untouched by the spread above.
    const prevCols = workspaceModule.capabilities && workspaceModule.capabilities.records && workspaceModule.capabilities.records.collections;
    const sameModule = prevMod && prevMod.owner === draft.owner && prevMod.key === draft.key;
    if (!(sameModule && Array.isArray(prevCols) && prevCols.length)) {
        // el.call, NOT a bare reference: fetchDeclaredCollections is a registered
        // function exported from workspaceApps.js, not imported here — a bare call
        // threw `fetchDeclaredCollections is not defined` and silently failed every
        // FRESH module assign (this branch only runs on a new/changed module).
        // See tickets/workspace.md. FA001: cross-file fns go through el.call.
        const declared = await el.call('fetchDeclaredCollections', draft.owner, draft.key);
        if (declared.length) workspaceModule.capabilities = {
            ...sameModule ? workspaceModule.capabilities || {} : {},
            records: {
                collections: declared,
                ops: [
                    'list',
                    'get',
                    'create',
                    'update',
                    'upsert',
                    'remove',
                    'subscribe'
                ]
            }
        };
        else if (!sameModule) delete workspaceModule.capabilities;
    }
    const prev = $abe2fd0b23ee5206$var$_patchSettings(root, {
        workspaceModule: workspaceModule
    });
    $abe2fd0b23ee5206$var$_setBusy(root, 'assign', true);
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, {
            workspaceModule: workspaceModule
        });
        // The server's own words, or none: every catch below owns a translated
        // title (and, where it has one, a translated body) — no client sentence.
        if (res && res.success === false) throw new Error(res.message);
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.assigned').replace('{module}', `${draft.owner}/${draft.key}`),
            type: 'success'
        });
    } catch (err) {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            workspaceModule: prev
        });
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.assignFailed'),
            message: err && err.message || el.call('polyglot', 'admin.module.notify.assignFailedBody'),
            type: 'error'
        });
    } finally{
        $abe2fd0b23ee5206$var$_setBusy(root, 'assign', false);
    }
}
async function $abe2fd0b23ee5206$export$589560100432c619(keyName, value) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    if ($abe2fd0b23ee5206$export$f28600ceebf54e90.indexOf(keyName) < 0) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.unsupportedSetting'),
        message: keyName,
        type: 'error'
    });
    // An EMPTY navbar list is not a personalization — it's "render zero header
    // tabs", which no workspace can want. Persist the cleared-key sentinel
    // (null) instead so resolution falls through to the module's
    // configDefaults.navbar / DEFAULT_NAVBAR, exactly like mcResetNavbar.
    // Without this, Save-after-Reset (the working copy is null, the Save button
    // reads `navbar || []`) — or removing every row and saving — stored
    // `settings.navbar: []`, which used to blank every header tab. Other list
    // keys keep [] (an empty home_default_panels is a deliberate hide-all).
    if (keyName === 'navbar' && Array.isArray(value) && !value.length) value = null;
    if (typeof sdk.updateWorkspaceSettings !== 'function') return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        message: el.call('polyglot', 'admin.module.notify.sdkNotReadyBody'),
        type: 'error'
    });
    const prev = $abe2fd0b23ee5206$var$_patchSettings(root, {
        [keyName]: value
    });
    $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', true);
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, $abe2fd0b23ee5206$var$_appsPatch(root, {
            [keyName]: value
        }));
        if (res && res.success === false) throw new Error(res.message);
        if (keyName === 'workspaceApps') $abe2fd0b23ee5206$var$_rebaseApps(root, value);
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.saved'),
            message: keyName,
            type: 'success'
        });
    } catch (err) {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            [keyName]: prev
        });
        await $abe2fd0b23ee5206$var$_handleSaveError(el, root, err, 'admin.module.notify.saveFailed', keyName);
    } finally{
        $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', false);
    }
}
function $abe2fd0b23ee5206$export$3ebfde7ce02db5f3(version) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    const cur = root._mcState && root._mcState.settings && root._mcState.settings.workspaceModule || null;
    if (!cur) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.noModule'),
        type: 'error'
    });
    if (typeof sdk.updateWorkspaceSettings !== 'function') return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        message: el.call('polyglot', 'admin.module.notify.sdkNotReadyBody'),
        type: 'error'
    });
    el.call('confirmDialog', {
        title: version ? el.call('polyglot', 'admin.module.versions.pinTitle').replace('{version}', version) : el.call('polyglot', 'admin.module.versions.unpinTitle'),
        message: el.call('polyglot', version ? 'admin.module.versions.pinMessage' : 'admin.module.versions.unpinMessage'),
        confirmText: el.call('polyglot', version ? 'admin.module.versions.pinCta' : 'admin.module.versions.unpin'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>$abe2fd0b23ee5206$var$_rollbackModuleNow(el, root, sdk, wsId, cur, version)
    });
}
async function $abe2fd0b23ee5206$var$_rollbackModuleNow(el, root, sdk, wsId, cur, version) {
    const workspaceModule = {
        ...cur,
        version: version || null
    };
    const prev = $abe2fd0b23ee5206$var$_patchSettings(root, {
        workspaceModule: workspaceModule
    });
    root.update({
        _mcModuleDraft: {
            ...root._mcModuleDraft || {},
            version: version || ''
        }
    });
    $abe2fd0b23ee5206$var$_setBusy(root, 'rollback', true);
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, {
            workspaceModule: workspaceModule
        });
        if (res && res.success === false) throw new Error(res.message);
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: version ? el.call('polyglot', 'admin.module.notify.pinned').replace('{version}', version) : el.call('polyglot', 'admin.module.notify.unpinned'),
            type: 'success'
        });
    } catch (err) {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            workspaceModule: prev
        });
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.rollbackFailed'),
            message: err && err.message || '',
            type: 'error'
        });
    } finally{
        $abe2fd0b23ee5206$var$_setBusy(root, 'rollback', false);
    }
}
// ── Personalize working-copy list editors (no persist — Save does that) ────
// navbar [{label,path}] and apps [{title,caption,icon,iconBg,route}] are edited
// against the console's working settings copy; the section's Save button then
// persists the whole array through mcSavePersonalization(key, value).
const $abe2fd0b23ee5206$var$_listOf = (root, key)=>{
    const list = root._mcState && root._mcState.settings && root._mcState.settings[key];
    return Array.isArray(list) ? list : [];
};
function $abe2fd0b23ee5206$export$ec4d9f5a7c14717b(key, idx, field, value) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const list = $abe2fd0b23ee5206$var$_listOf(root, key).map((it, i)=>i === idx ? {
            ...it,
            [field]: value
        } : it);
    $abe2fd0b23ee5206$var$_patchSettings(root, {
        [key]: list
    });
}
function $abe2fd0b23ee5206$export$ffe0d9f3de1b3092(key, template) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    $abe2fd0b23ee5206$var$_patchSettings(root, {
        [key]: [
            ...$abe2fd0b23ee5206$var$_listOf(root, key),
            {
                ...template || {}
            }
        ]
    });
}
function $abe2fd0b23ee5206$export$5f8226c0d578446f(key, idx) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const list = $abe2fd0b23ee5206$var$_listOf(root, key);
    const removed = list[idx];
    let next = list.filter((_, i)=>i !== idx);
    if (key === 'navbar' && removed && removed.path && !removed.dismissed) {
        const contributedPaths = new Set([
            ...(Array.isArray(root.workspaceApps) ? root.workspaceApps : []).flatMap((a)=>Array.isArray(a && a.navbar) ? a.navbar : []),
            ...root.workspaceProject && Array.isArray(root.workspaceProject.config?.navbar) ? root.workspaceProject.config.navbar : []
        ].map((t)=>t && t.path && String(t.path).toLowerCase()).filter(Boolean));
        if (contributedPaths.has(String(removed.path).toLowerCase())) next = [
            ...next,
            {
                path: removed.path,
                dismissed: true
            }
        ];
    }
    $abe2fd0b23ee5206$var$_patchSettings(root, {
        [key]: next
    });
}
function $abe2fd0b23ee5206$export$96aad30ec5b6b4aa(key, fromIdx, toIdx) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const list = $abe2fd0b23ee5206$var$_listOf(root, key);
    if (fromIdx === toIdx || fromIdx < 0 || toIdx < 0 || fromIdx >= list.length || toIdx >= list.length) return;
    const next = list.slice();
    const [moved] = next.splice(fromIdx, 1);
    next.splice(toIdx, 0, moved);
    $abe2fd0b23ee5206$var$_patchSettings(root, {
        [key]: next
    });
}
function $abe2fd0b23ee5206$export$5a80d383efaac10e(id) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const cur = $abe2fd0b23ee5206$var$_listOf(root, 'home_default_panels');
    const next = cur.indexOf(id) >= 0 ? cur.filter((x)=>x !== id) : [
        ...cur,
        id
    ];
    $abe2fd0b23ee5206$var$_patchSettings(root, {
        home_default_panels: next
    });
}
const $abe2fd0b23ee5206$export$cb85f7823ad81150 = [
    'list',
    'get',
    'create',
    'update',
    'upsert',
    'remove',
    'subscribe'
];
const $abe2fd0b23ee5206$var$_moduleOf = (root)=>root._mcState && root._mcState.settings && root._mcState.settings.workspaceModule || null;
// ── Which installed app the Grant tab is looking at ─────────────────────────
// A grant can live in EITHER of two settings slots: the legacy singular
// `workspaceModule` (Tier 3 full-takeover custom module) or an entry of the
// additive `workspaceApps` list (Tier 2 /add-app + marketplace installs — the
// shape every real deployment shipped so far, ICCA + Certification, actually
// uses). The revoke/toggle/sync actions below all resolve "the selected app"
// through the same lookup so they patch EXACTLY the slot it lives in and
// nothing else. Mirrors pages/admin/module.js `_installedApps` — duplicated
// (project files don't import one another); keep the two in sync.
const $abe2fd0b23ee5206$var$_lcId = (v)=>v == null ? '' : String(v).toLowerCase();
const $abe2fd0b23ee5206$var$_refId = (r)=>`${$abe2fd0b23ee5206$var$_lcId(r && r.owner)}/${$abe2fd0b23ee5206$var$_lcId(r && r.key)}`;
const $abe2fd0b23ee5206$var$_appRefLocation = (root, ownerKey)=>{
    if (!ownerKey) return null;
    const settings = root._mcState && root._mcState.settings || {};
    const mod = settings.workspaceModule;
    if (mod && mod.owner && $abe2fd0b23ee5206$var$_refId(mod) === ownerKey) return {
        src: 'workspaceModule',
        ref: mod
    };
    const apps = Array.isArray(settings.workspaceApps) ? settings.workspaceApps : [];
    const idx = apps.findIndex((r)=>r && r.owner && $abe2fd0b23ee5206$var$_refId(r) === ownerKey);
    return idx >= 0 ? {
        src: 'workspaceApps',
        ref: apps[idx],
        idx: idx
    } : null;
};
// The Grant tab's default selection when the admin hasn't picked one yet —
// the legacy module if assigned, else the first installed app.
const $abe2fd0b23ee5206$var$_defaultAppIdFor = (root)=>{
    const settings = root._mcState && root._mcState.settings || {};
    if (settings.workspaceModule && settings.workspaceModule.owner) return $abe2fd0b23ee5206$var$_refId(settings.workspaceModule);
    const apps = Array.isArray(settings.workspaceApps) ? settings.workspaceApps : [];
    const first = apps.find((r)=>r && r.owner && r.key);
    return first ? $abe2fd0b23ee5206$var$_refId(first) : null;
};
function $abe2fd0b23ee5206$export$38beeca6efcf1ed9() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    return root ? $abe2fd0b23ee5206$var$_defaultAppIdFor(root) : null;
}
const $abe2fd0b23ee5206$var$_selectedAppId = (root)=>root && (root._mcGrantAppId || $abe2fd0b23ee5206$var$_defaultAppIdFor(root)) || null;
// Patch ONE app ref back into whichever settings key it lives in — the single
// merge-safe write every mutator below shares.
const $abe2fd0b23ee5206$var$_patchAppRef = (root, loc, nextRef)=>{
    if (loc.src === 'workspaceModule') {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            workspaceModule: nextRef
        });
        return;
    }
    const settings = root._mcState && root._mcState.settings || {};
    const apps = Array.isArray(settings.workspaceApps) ? [
        ...settings.workspaceApps
    ] : [];
    apps[loc.idx] = nextRef;
    $abe2fd0b23ee5206$var$_patchSettings(root, {
        workspaceApps: apps
    });
};
function $abe2fd0b23ee5206$export$eea497f2e1f693ae(collection) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const loc = $abe2fd0b23ee5206$var$_appRefLocation(root, $abe2fd0b23ee5206$var$_selectedAppId(root));
    if (!loc) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.noAppSelected'),
        type: 'error'
    });
    el.call('confirmDialog', {
        title: el.call('polyglot', 'admin.module.records.revokeTitle').replace('{collection}', collection),
        message: el.call('polyglot', 'admin.module.records.revokeMessage'),
        confirmText: el.call('polyglot', 'admin.module.records.revoke'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>{
            // The dialog is modal: `loc`, read at the click, is still the entry
            // the question was about.
            const rec = loc.ref.capabilities && loc.ref.capabilities.records || {
                collections: [],
                ops: []
            };
            // Filter by KEY — a stored entry may be `{ key, read, write }` (F1),
            // which an identity compare against the UI's key string would never
            // match, leaving the "revoked" collection silently granted.
            const collections = (rec.collections || []).filter((c)=>$abe2fd0b23ee5206$var$recordsEntryKey(c) !== collection);
            const nextRef = {
                ...loc.ref,
                capabilities: {
                    ...loc.ref.capabilities || {},
                    records: {
                        ...rec,
                        collections: collections
                    }
                }
            };
            $abe2fd0b23ee5206$var$_patchAppRef(root, loc, nextRef);
        }
    });
}
function $abe2fd0b23ee5206$export$f8697e62045cde8e(op) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const loc = $abe2fd0b23ee5206$var$_appRefLocation(root, $abe2fd0b23ee5206$var$_selectedAppId(root));
    if (!loc) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.noAppSelected'),
        type: 'error'
    });
    const rec = loc.ref.capabilities && loc.ref.capabilities.records || {
        collections: [],
        ops: []
    };
    const cur = Array.isArray(rec.ops) && rec.ops.length ? rec.ops : [
        ...$abe2fd0b23ee5206$export$cb85f7823ad81150
    ];
    const turningOff = cur.indexOf(op) >= 0;
    if (turningOff && cur.length === 1) // moduleDataBridge.js reads an EMPTY `ops` array as "all ops" (unset =
    // unrestricted) — unchecking the LAST op would silently flip the grant
    // back to unrestricted instead of narrowing it. Revoke the collection
    // instead if the intent is to remove all access.
    return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.cantRevokeAll'),
        message: el.call('polyglot', 'admin.module.notify.cantRevokeAllBody'),
        type: 'error'
    });
    const ops = turningOff ? cur.filter((o)=>o !== op) : [
        ...cur,
        op
    ];
    const nextRef = {
        ...loc.ref,
        capabilities: {
            ...loc.ref.capabilities || {},
            records: {
                ...rec,
                ops: ops
            }
        }
    };
    $abe2fd0b23ee5206$var$_patchAppRef(root, loc, nextRef);
}
async function $abe2fd0b23ee5206$export$628ff38e451affb1() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const loc = $abe2fd0b23ee5206$var$_appRefLocation(root, $abe2fd0b23ee5206$var$_selectedAppId(root));
    if (!loc) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.noAppSelected'),
        type: 'error'
    });
    const settings = root._mcState && root._mcState.settings || {};
    const value = loc.src === 'workspaceModule' ? settings.workspaceModule : settings.workspaceApps;
    await el.call('mcSavePersonalization', loc.src, value);
}
async function $abe2fd0b23ee5206$export$3d4e99428f52b629(ownerKeyArg) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const ownerKey = ownerKeyArg || $abe2fd0b23ee5206$var$_selectedAppId(root);
    const loc = $abe2fd0b23ee5206$var$_appRefLocation(root, ownerKey);
    if (!loc) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.noAppToCheck'),
        type: 'error'
    });
    const [owner, key] = ownerKey.split('/');
    root.update({
        _mcSyncChecking: ownerKey,
        _mcSyncError: null
    });
    try {
        const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
        let branch = loc.ref.branch || 'main';
        let version = loc.ref.version || null;
        if (!version && loc.ref.channel) try {
            const cfg = await el.call('resolveEnvPublishConfig', {
                owner: owner,
                key: key
            }, loc.ref.channel, wsId ? {
                workspaceId: wsId
            } : {});
            if (cfg) {
                branch = cfg.branch || branch;
                if (cfg.version && cfg.version !== 'latest') version = cfg.version;
            }
        } catch (_) {
        // The loader's fallback: an unreadable channel config loads the head.
        }
        const declared = await el.call('fetchDeclaredCollections', owner, key, {
            branch: branch,
            version: version || 'latest',
            ...wsId ? {
                workspaceId: wsId
            } : {}
        });
        const granted = loc.ref.capabilities && loc.ref.capabilities.records && loc.ref.capabilities.records.collections || [];
        const { added: added, stale: stale } = $abe2fd0b23ee5206$var$diffDeclaredCollections(declared, granted);
        // The singular `workspaceModule` slot has no compare-and-swap, so the
        // server takes no level approval there: no `changed` list for it.
        const changed = loc.src === 'workspaceApps' ? el.call('mcLevelChanges', declared, granted) || [] : [];
        root.update({
            _mcSyncChecking: null,
            _mcSyncDiff: {
                appId: ownerKey,
                declared: declared,
                granted: granted,
                added: added,
                stale: stale,
                changed: changed,
                checkedAt: Date.now()
            },
            // Default selection: propose GRANTING every newly-declared collection
            // (the whole point of the check), propose REVOKING none — a revoke
            // removes standing access, the more consequential half of the
            // decision, so it stays an explicit per-collection opt-in. A level
            // change is the same kind of decision: approved one by one, never by
            // default.
            _mcSyncSelection: {
                grant: Object.fromEntries(added.map((c)=>[
                        c,
                        true
                    ])),
                revoke: Object.fromEntries(stale.map((c)=>[
                        c,
                        false
                    ])),
                approve: Object.fromEntries(changed.map((c)=>[
                        c.key,
                        false
                    ]))
            }
        });
    } catch (err) {
        root.update({
            _mcSyncChecking: null,
            _mcSyncError: err && err.message || el.call('polyglot', 'admin.module.error.checkFailed')
        });
    }
}
function $abe2fd0b23ee5206$export$b7e3cf15a4cbb08c(entry) {
    const READ = [
        'member',
        'admin',
        'own',
        'scoped',
        'acl'
    ];
    const WRITE = [
        'editor',
        'admin',
        'own',
        'scoped',
        'acl'
    ];
    const isObj = (v)=>Boolean(v) && typeof v === 'object' && !Array.isArray(v);
    const sorted = (m)=>{
        const names = Object.keys(m).sort((a, b)=>a.localeCompare(b));
        return names.length ? Object.fromEntries(names.map((n)=>[
                n,
                m[n]
            ])) : null;
    };
    const teamsOf = (raw)=>{
        if (!isObj(raw)) return null;
        const level = (v, valid, plain)=>v === undefined ? undefined : valid.includes(v) ? v : plain;
        const out = {};
        for (const [rawSlug, o] of Object.entries(raw)){
            const slug = rawSlug.trim().toLowerCase();
            if (!slug || !isObj(o)) continue;
            const read = level(o.read, READ, 'member');
            const write = level(o.write, WRITE, 'editor');
            if (read === undefined && write === undefined) continue;
            out[slug] = {
                read: read,
                write: write
            };
        }
        return sorted(out);
    };
    const fieldsOf = (raw)=>{
        if (!isObj(raw)) return null;
        const tier = (v, valid, closed)=>v === undefined ? undefined : typeof v === 'string' && v.startsWith('perm:') && v.length > 5 || valid.includes(v) ? v : closed;
        const out = {};
        for (const [rawName, rule] of Object.entries(raw)){
            const name = rawName.trim();
            if (!name || !isObj(rule)) continue;
            const read = tier(rule.read, [
                'member',
                'own',
                'admin'
            ], 'admin');
            const write = tier(rule.write, [
                'editor',
                'admin',
                'server'
            ], 'server');
            if (read === undefined && write === undefined) continue;
            out[name] = {
                read: read,
                write: write
            };
        }
        return sorted(out);
    };
    const canon = (raw)=>{
        if (typeof raw === 'string') {
            const key = raw.trim().toLowerCase();
            if (!key) return null;
            return {
                key: key,
                read: 'member',
                write: 'editor',
                scopeField: null,
                teams: null,
                fields: null
            };
        }
        if (!raw || typeof raw !== 'object' || typeof raw.key !== 'string') return null;
        const key = raw.key.trim().toLowerCase();
        if (!key) return null;
        return {
            key: key,
            read: raw.read === undefined ? 'member' : READ.includes(raw.read) ? raw.read : 'admin',
            write: raw.write === undefined ? 'editor' : WRITE.includes(raw.write) ? raw.write : 'admin',
            scopeField: typeof raw.scopeField === 'string' && raw.scopeField.trim() ? raw.scopeField.trim() : null,
            teams: teamsOf(raw.teams),
            fields: fieldsOf(raw.fields)
        };
    };
    return canon(entry);
}
function $abe2fd0b23ee5206$export$724db6d1ff2dbce8(declared, granted) {
    const el = this;
    const byKey = (list)=>{
        const out = new Map();
        for (const raw of Array.isArray(list) ? list : []){
            const c = el.call('mcGrantCanon', raw);
            if (c && !out.has(c.key)) out.set(c.key, {
                raw: raw,
                c: c
            });
        }
        return out;
    };
    const same = (a, b)=>JSON.stringify(a) === JSON.stringify(b);
    const stored = byKey(granted);
    const out = [];
    for (const [key, d] of byKey(declared)){
        const s = stored.get(key);
        if (!s || same(s.c, d.c)) continue;
        const scopedAny = [
            s.c.read,
            s.c.write,
            d.c.read,
            d.c.write
        ].includes('scoped');
        out.push({
            key: key,
            now: s.c,
            asks: d.c,
            entry: d.raw,
            rules: !same(s.c.teams, d.c.teams) || !same(s.c.fields, d.c.fields) || !scopedAny && s.c.scopeField !== d.c.scopeField
        });
    }
    return out;
}
function $abe2fd0b23ee5206$export$c081cfbe2a0125b2(kind, collection) {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root || kind !== 'grant' && kind !== 'revoke' && kind !== 'approve') return;
    const sel = root._mcSyncSelection || {
        grant: {},
        revoke: {}
    };
    const bucket = {
        ...sel[kind] || {}
    };
    bucket[collection] = !bucket[collection];
    root.update({
        _mcSyncSelection: {
            ...sel,
            [kind]: bucket
        }
    });
}
async function $abe2fd0b23ee5206$export$d4e32fa681dbf068() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const diff = root._mcSyncDiff;
    if (!diff) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.checkFirst'),
        type: 'error'
    });
    const sel = root._mcSyncSelection || {
        grant: {},
        revoke: {}
    };
    // `added`/`stale` are collection KEYS (diffDeclaredCollections). A grant
    // writes the DECLARED entry for that key — which may carry per-collection
    // levels (`{ key, read, write }`, F1) — so the app's declared access policy
    // lands on the ref verbatim instead of being flattened to a member-wide
    // string. Revokes prune by key.
    const declared = Array.isArray(diff.declared) ? diff.declared : [];
    const grant = (diff.added || []).filter((c)=>sel.grant && sel.grant[c]).map((k)=>declared.find((d)=>$abe2fd0b23ee5206$var$recordsEntryKey(d) === k) || k);
    const revoke = (diff.stale || []).filter((c)=>sel.revoke && sel.revoke[c]);
    // An approved LEVEL change (mcLevelChanges): the manifest's entry, as
    // declared, for a key already granted.
    const approve = (diff.changed || []).filter((c)=>sel.approve && sel.approve[c.key]);
    if (!grant.length && !revoke.length && !approve.length) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.nothingSelected'),
        message: el.call('polyglot', 'admin.module.notify.nothingSelectedBody'),
        type: 'error'
    });
    const loc = $abe2fd0b23ee5206$var$_appRefLocation(root, diff.appId);
    if (!loc) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.appGone'),
        type: 'error'
    });
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    if (!sdk || typeof sdk.updateWorkspaceSettings !== 'function' || !wsId) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        type: 'error'
    });
    // applyCollectionsSync (workspace-shared) keeps its own { add, prune } arg
    // names — that's the shared-library API; only the console's selection
    // buckets are named grant/revoke (see the _mcSyncSelection note up top).
    // An approval alone leaves the grant's `ops` as they are.
    const synced = grant.length || revoke.length ? $abe2fd0b23ee5206$var$applyCollectionsSync(loc.ref, {
        add: grant,
        prune: revoke
    }) : loc.ref;
    // Each approved key takes the manifest's entry IN PLACE, and the entry
    // names the keys it approves (`approveLevels`, request-only: the server
    // checks each against its own read of the manifest, lands its entry, and
    // never stores the field). Only the plural list carries an approval.
    const nextRef = approve.length && loc.src === 'workspaceApps' ? (()=>{
        const asks = new Map(approve.map((c)=>[
                c.key,
                c.entry
            ]));
        const rec = synced.capabilities && synced.capabilities.records || {};
        const collections = (Array.isArray(rec.collections) ? rec.collections : []).map((e)=>{
            const k = $abe2fd0b23ee5206$var$recordsEntryKey(e).trim().toLowerCase();
            return asks.has(k) ? asks.get(k) : e;
        });
        return {
            ...synced,
            capabilities: {
                ...synced.capabilities || {},
                records: {
                    ...rec,
                    collections: collections
                }
            },
            approveLevels: approve.map((c)=>c.key)
        };
    })() : synced;
    const patchValue = loc.src === 'workspaceModule' ? nextRef : (()=>{
        const settings = root._mcState && root._mcState.settings || {};
        const apps = Array.isArray(settings.workspaceApps) ? [
            ...settings.workspaceApps
        ] : [];
        apps[loc.idx] = nextRef;
        return apps;
    })();
    const patch = {
        [loc.src]: patchValue
    };
    const prev = $abe2fd0b23ee5206$var$_patchSettings(root, patch);
    $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', true);
    try {
        // The sync IS a capability change, so it must carry the precondition —
        // without it the server would preserve the stored grant and this write
        // would land as a no-op.
        const res = await sdk.updateWorkspaceSettings(wsId, $abe2fd0b23ee5206$var$_appsPatch(root, patch));
        if (res && res.success === false) throw new Error(res.message);
        // An approval lands the SERVER's entry and never stores `approveLevels`:
        // the answer's list (else this payload without the field) is what is
        // stored now — the view and the baseline, so no later save re-sends it.
        if (approve.length && loc.src === 'workspaceApps') {
            const stored = res && res.settings && Array.isArray(res.settings.workspaceApps) ? res.settings.workspaceApps : patchValue.map((r)=>{
                if (!r || typeof r !== 'object') return r;
                const copy = {
                    ...r
                };
                delete copy.approveLevels;
                return copy;
            });
            $abe2fd0b23ee5206$var$_patchSettings(root, {
                workspaceApps: stored
            });
            $abe2fd0b23ee5206$var$_rebaseApps(root, stored);
        } else if (loc.src === 'workspaceApps') $abe2fd0b23ee5206$var$_rebaseApps(root, patchValue);
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.grantSynced'),
            message: [
                grant.length ? el.call('polyglot', 'admin.module.notify.grantedCount').replace('{count}', grant.length) : null,
                revoke.length ? el.call('polyglot', 'admin.module.notify.revokedCount').replace('{count}', revoke.length) : null,
                approve.length ? el.call('polyglot', 'admin.module.notify.approvedCount').replace('{count}', approve.length) : null
            ].filter(Boolean).join(', '),
            type: 'success'
        });
        root.update({
            _mcSyncDiff: null,
            _mcSyncSelection: null
        });
    } catch (err) {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            [loc.src]: prev
        });
        // The server refused an approval: the app declares another level now than
        // the one the admin saw (or its manifest could not be read). Nothing was
        // written — check again, so the sheet shows what the app asks for now.
        const refusal = err && err.cause && err.cause.error;
        if (refusal === 'level_approval_stale' || refusal === 'level_approval_unverifiable') {
            $abe2fd0b23ee5206$var$_consoleNotify(el, {
                title: el.call('polyglot', 'admin.module.notify.levelStale'),
                message: el.call('polyglot', 'admin.module.notify.levelStaleBody'),
                type: 'error'
            });
            await el.call('mcCheckAppSync', diff.appId);
        } else await $abe2fd0b23ee5206$var$_handleSaveError(el, root, err, 'admin.module.notify.syncFailed');
    } finally{
        $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', false);
    }
}
async function $abe2fd0b23ee5206$export$9f7d9e62f4a70fbd() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const settings = root._mcState && root._mcState.settings || {};
    const mod = settings.workspaceModule;
    if (!mod || mod.installMode !== 'app') return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.nothingToMigrate'),
        message: el.call('polyglot', 'admin.module.notify.nothingToMigrateBody'),
        type: 'error'
    });
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    if (!sdk || typeof sdk.updateWorkspaceSettings !== 'function' || !wsId) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        type: 'error'
    });
    const prevModule = mod;
    const prevApps = Array.isArray(settings.workspaceApps) ? settings.workspaceApps : [];
    const nextApps = $abe2fd0b23ee5206$var$upsertWorkspaceApp(prevApps, mod);
    const patch = {
        workspaceModule: null,
        workspaceApps: nextApps
    };
    $abe2fd0b23ee5206$var$_patchSettings(root, patch);
    $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', true);
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, $abe2fd0b23ee5206$var$_appsPatch(root, patch));
        if (res && res.success === false) throw new Error(res.message);
        $abe2fd0b23ee5206$var$_rebaseApps(root, nextApps);
        // Live-sync the shell the same way mcResetNavbar does — null/replace on
        // the workspace RECORD (loadWorkspaceProject/loadWorkspaceApps resolve
        // refs from root.workspace.settings) and on root.workspaceSettings (the
        // reactive cache applyWorkspaceConfig reads), then re-run both loaders so
        // the app's routes/nav move over to the plural path immediately.
        // WRITE-BASE site (spec §5). `{ ...(ws.settings || {}), ...patch }` merges
        // over a base that may not exist: on a list-shaped record it FABRICATES a
        // settings bag containing only the key just written, and every raw reader
        // downstream then treats that one-key bag as the workspace's whole
        // configuration (loadWorkspaceProject/loadWorkspaceApps did exactly that
        // via `!!ws.settings` until this same spec §5 pass). The server write above
        // has already landed and is per-key merge-safe, so ONLY the local mirror is
        // conditional here — never the persistence.
        const base = (0, $7iFOV.workspaceSettingsForWrite)(root);
        const localSync = {
            // `root.workspaceSettings` is a DIFFERENT store — the derived bag
            // applyWorkspaceConfig publishes and HeaderTabs reads reactively. It has
            // no record shape to corrupt, and the re-runs below republish it anyway,
            // so it syncs unconditionally.
            workspaceSettings: {
                ...root.workspaceSettings || {},
                ...patch
            },
            _mcGrantAppId: $abe2fd0b23ee5206$var$_refId(mod)
        };
        if (base) localSync.workspace = {
            ...root.workspace,
            settings: {
                ...base,
                ...patch
            }
        };
        else (0, $7muxD.invalidateWorkspaceCache)(wsId);
        root.update(localSync);
        await (0, $7ytvD.loadWorkspaceProject)(root, sdk);
        await (0, $7ytvD.loadWorkspaceApps)(root, sdk);
        (0, $g7CNh.applyWorkspaceConfig)(root);
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.migrated'),
            message: el.call('polyglot', 'admin.module.notify.migratedBody').replace('{module}', `${mod.owner}/${mod.key}`),
            type: 'success'
        });
    } catch (err) {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            workspaceModule: prevModule,
            workspaceApps: prevApps
        });
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.migrationFailed'),
            message: err && err.message || '',
            type: 'error'
        });
    } finally{
        $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', false);
    }
}
function $abe2fd0b23ee5206$export$78a0a4391ae83e3e() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const ds = root._mcDs || {};
    const text = ds.text || '';
    if (!text.trim()) {
        root.update({
            _mcDs: {
                ...ds,
                error: el.call('polyglot', 'admin.module.error.dsEmpty'),
                parsed: null,
                validated: false
            }
        });
        return;
    }
    let parsed;
    try {
        parsed = JSON.parse(text);
    } catch (err) {
        root.update({
            _mcDs: {
                ...ds,
                error: el.call('polyglot', 'admin.module.error.dsInvalidJson').replace('{detail}', err && err.message || ''),
                parsed: null,
                validated: false
            }
        });
        return;
    }
    const shapeErr = $abe2fd0b23ee5206$var$_validateDsShape(parsed, el);
    if (shapeErr) {
        root.update({
            _mcDs: {
                ...ds,
                error: shapeErr,
                parsed: null,
                validated: false
            }
        });
        return;
    }
    root.update({
        _mcDs: {
            ...ds,
            error: null,
            parsed: parsed,
            validated: true
        }
    });
    $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.dsValid'),
        message: el.call('polyglot', 'admin.module.notify.dsValidBody'),
        type: 'success'
    });
}
function $abe2fd0b23ee5206$export$83deaa5a9e45a61c() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    const mod = $abe2fd0b23ee5206$var$_moduleOf(root);
    if (!mod) return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.noModule'),
        type: 'error'
    });
    if (typeof sdk.updateWorkspaceSettings !== 'function') return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        message: el.call('polyglot', 'admin.module.notify.sdkNotReadyBody'),
        type: 'error'
    });
    el.call('confirmDialog', {
        title: el.call('polyglot', 'admin.module.notify.uninstallConfirm'),
        message: el.call('polyglot', 'admin.module.notify.uninstallConfirmBody').replace('{module}', `${mod.owner}/${mod.key}`),
        confirmText: el.call('polyglot', 'admin.module.notify.uninstallCta'),
        // The D1 shape (CRUD-CONFIRM-STANDARD, 2026-10-30): `'red'` is not a
        // brand theme and rendered unstyled; the title already says what goes.
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: async ()=>{
            // Snapshot the FULL working-copy settings (not just the first patched
            // key — _patchSettings only returns one prior value) so a failure can
            // roll every one of the four reset keys back, not just workspaceModule.
            const prevSettings = root._mcState && root._mcState.settings || {};
            const reset = {
                workspaceModule: null,
                navbar: null,
                apps: null,
                home_default_panels: null
            };
            $abe2fd0b23ee5206$var$_patchSettings(root, reset);
            $abe2fd0b23ee5206$var$_setBusy(root, 'uninstall', true);
            try {
                const res = await sdk.updateWorkspaceSettings(wsId, reset);
                if (res && res.success === false) throw new Error(res.message);
                await $abe2fd0b23ee5206$export$91461c33e47410d6.call(el);
                $abe2fd0b23ee5206$var$_consoleNotify(el, {
                    title: el.call('polyglot', 'admin.module.notify.uninstalled').replace('{module}', `${mod.owner}/${mod.key}`),
                    type: 'success'
                });
            } catch (err) {
                root.update({
                    _mcState: {
                        ...root._mcState || {},
                        settings: prevSettings
                    }
                });
                $abe2fd0b23ee5206$var$_consoleNotify(el, {
                    title: el.call('polyglot', 'admin.module.notify.uninstallFailed'),
                    message: err && err.message || el.call('polyglot', 'admin.module.notify.uninstallFailedBody'),
                    type: 'error'
                });
            } finally{
                $abe2fd0b23ee5206$var$_setBusy(root, 'uninstall', false);
            }
        }
    });
}
function $abe2fd0b23ee5206$export$aba73721d6a5b450() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    if (typeof sdk.updateWorkspaceSettings !== 'function') return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        message: el.call('polyglot', 'admin.module.notify.sdkNotReadyBody'),
        type: 'error'
    });
    el.call('confirmDialog', {
        title: el.call('polyglot', 'admin.module.navbar.resetConfirmTitle'),
        message: el.call('polyglot', 'admin.module.navbar.resetConfirmMessage'),
        confirmText: el.call('polyglot', 'admin.module.navbar.reset'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>$abe2fd0b23ee5206$var$_resetPersonalizationNow(el, root, sdk, wsId)
    });
}
async function $abe2fd0b23ee5206$var$_resetPersonalizationNow(el, root, sdk, wsId) {
    const _st0 = root._mcState && root._mcState.settings || {};
    const prevNavbar = _st0.navbar;
    const prevPanels = _st0.home_default_panels;
    $abe2fd0b23ee5206$var$_patchSettings(root, {
        navbar: null,
        home_default_panels: null
    });
    $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', true);
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, {
            navbar: null,
            home_default_panels: null
        });
        if (res && res.success === false) throw new Error(res.message);
        // Per-user / page widgets — mirror the Customize drawer's reset: wipe
        // the localStorage seeds and null the server row's layout + hidden set
        // (no dashboard_v stamp needed: a null layout + empty hidden set IS the
        // base default regardless of version gating).
        try {
            Object.keys(globalThis.localStorage || {}).filter((k)=>k.startsWith('symbols.home.')).forEach((k)=>globalThis.localStorage.removeItem(k));
        } catch (_) {
        /* private mode */ }
        const prefsNext = {
            grid_layout: null,
            hidden_widgets: {}
        };
        root.update({
            userDashboardPrefs: prefsNext,
            _homeHiddenWidgets: {}
        });
        try {
            await sdk.execute('workspaceProject.homeDashboardPrefs', 'update', {
                payload: prefsNext
            });
        } catch (err) {
            console.warn('[moduleConsole] dashboard prefs reset failed:', err?.message || err);
        }
        // WRITE-BASE site (spec §5) — same reasoning as mcMigrateLegacyAppInstall's
        // mirror above: merging the two nulled keys over an absent base publishes a
        // `settings` bag that describes nothing but the reset itself, on a record
        // that never had one. The server reset already succeeded; skipping the
        // mirror costs only the local paint, and the loaders re-run right below.
        const base = (0, $7iFOV.workspaceSettingsForWrite)(root);
        const localSync = {
            workspaceSettings: {
                ...root.workspaceSettings || {},
                navbar: null,
                home_default_panels: null
            }
        };
        if (base) localSync.workspace = {
            ...root.workspace,
            settings: {
                ...base,
                navbar: null,
                home_default_panels: null
            }
        };
        else (0, $7muxD.invalidateWorkspaceCache)(wsId);
        root.update(localSync);
        await (0, $7ytvD.loadWorkspaceProject)(root, sdk);
        await (0, $7ytvD.loadWorkspaceApps)(root, sdk);
        (0, $g7CNh.applyWorkspaceConfig)(root);
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.resetAll'),
            type: 'success'
        });
    } catch (err) {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            navbar: prevNavbar,
            home_default_panels: prevPanels
        });
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.resetFailed'),
            message: err && err.message || '',
            type: 'error'
        });
    } finally{
        $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', false);
    }
}
async function $abe2fd0b23ee5206$export$c0cf082f6c0d7673() {
    const el = this;
    const root = $abe2fd0b23ee5206$var$_consoleRootOf(el);
    if (!root) return;
    const sdk = $abe2fd0b23ee5206$var$_sdkOf(el);
    const { wsId: wsId } = $abe2fd0b23ee5206$var$_ids(root);
    if (typeof sdk.updateWorkspaceSettings !== 'function') return $abe2fd0b23ee5206$var$_consoleNotify(el, {
        title: el.call('polyglot', 'admin.module.notify.sdkNotReady'),
        message: el.call('polyglot', 'admin.module.notify.sdkNotReadyBody'),
        type: 'error'
    });
    const prev = $abe2fd0b23ee5206$var$_patchSettings(root, {
        navbar: null
    });
    $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', true);
    try {
        const res = await sdk.updateWorkspaceSettings(wsId, {
            navbar: null
        });
        if (res && res.success === false) throw new Error(res.message);
        // Live-sync the shell so the header reflects the reset without a reload —
        // the same record + resolved-cache sync workspaceApps.js
        // resetWorkspaceNavbar/uninstallWorkspaceApp perform: null the key on the
        // workspace RECORD (HeaderTabs' first-paint source, and what
        // loadWorkspaceProject resolves settings from) and on
        // root.workspaceSettings (HeaderTabs' reactive reader), re-run the
        // project loader so the cached workspaceProject.config drops the old
        // saved navbar (it merged the pre-reset settings at load time), then
        // re-resolve so the module's configDefaults.navbar / DEFAULT_NAVBAR
        // paints immediately.
        // WRITE-BASE site (spec §5) — third instance of the same mirror, same
        // guard. The navbar is the surface where the fabricated bag was most
        // visible: a one-key `{navbar: null}` bag on a lean record reads as "this
        // workspace has settings, and its navbar is explicitly cleared", which is
        // indistinguishable from a workspace that really did reset its navbar.
        const base = (0, $7iFOV.workspaceSettingsForWrite)(root);
        const localSync = {
            workspaceSettings: {
                ...root.workspaceSettings || {},
                navbar: null
            }
        };
        if (base) localSync.workspace = {
            ...root.workspace,
            settings: {
                ...base,
                navbar: null
            }
        };
        else (0, $7muxD.invalidateWorkspaceCache)(wsId);
        root.update(localSync);
        await (0, $7ytvD.loadWorkspaceProject)(root, sdk);
        await (0, $7ytvD.loadWorkspaceApps)(root, sdk);
        (0, $g7CNh.applyWorkspaceConfig)(root);
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.resetNavbar'),
            type: 'success'
        });
    } catch (err) {
        $abe2fd0b23ee5206$var$_patchSettings(root, {
            navbar: prev
        });
        $abe2fd0b23ee5206$var$_consoleNotify(el, {
            title: el.call('polyglot', 'admin.module.notify.resetFailed'),
            message: err && err.message || '',
            type: 'error'
        });
    } finally{
        $abe2fd0b23ee5206$var$_setBusy(root, 'personalize', false);
    }
}

});

parcelRegister("79OEu", function(module, exports) {

$parcel$export(module.exports, "registerShellRoot", () => $5360aa163e663162$export$e8d1b483843539f5);
$parcel$export(module.exports, "loadWorkspaceAppsCatalog", () => $5360aa163e663162$export$447d1c437e013616);
$parcel$export(module.exports, "installWorkspaceAppRef", () => $5360aa163e663162$export$b6299b30601cd704);
$parcel$export(module.exports, "isExtensionAddedToWorkspace", () => $5360aa163e663162$export$24ee46770ed3ff1c);
$parcel$export(module.exports, "isExtensionAddedPending", () => $5360aa163e663162$export$7e90408dcec2a9ae);
$parcel$export(module.exports, "addExtensionToWorkspace", () => $5360aa163e663162$export$931db370800dd41d);
$parcel$export(module.exports, "reactivateWorkspaceModule", () => $5360aa163e663162$export$f502251b39c2e3c7);
$parcel$export(module.exports, "navigateToWorkspaceApp", () => $5360aa163e663162$export$fdb511fc17a378d8);
$parcel$export(module.exports, "uninstallWorkspaceApp", () => $5360aa163e663162$export$e16ae8c00245ef60);
$parcel$export(module.exports, "removeInstalledWorkspaceApp", () => $5360aa163e663162$export$1019c211790c7a30);
$parcel$export(module.exports, "resetWorkspaceNavbar", () => $5360aa163e663162$export$48a30517631770dc);
// workspaceApps.js — the /add-app catalog rail + direct-ref install actions
// (WORKSPACE_APPS.md "Install — one flow, one write"). The workspace-shell
// twin of marketplace/functions `installWorkspaceApp` — same ref + auto-grant
// shape; keep the two in sync (tickets/workspace.md WS-APPS records-grant
// ticket tracks consolidating them).
//
// Calling convention matches moduleConsole.js: registered functions invoked
// via `el.call('fnName', …)`, so inside each `this` IS the element.

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $7ytvD = parcelRequire("7ytvD");

var $g7CNh = parcelRequire("g7CNh");
const $5360aa163e663162$var$buildWorkspaceModuleRef = (...args)=>(0, $1X0Je.default).functions.buildWorkspaceModuleRef(...args);
const $5360aa163e663162$var$upsertWorkspaceApp = (...args)=>(0, $1X0Je.default).functions.upsertWorkspaceApp(...args);
const $5360aa163e663162$var$appsWritePatch = (...args)=>(0, $1X0Je.default).functions.appsWritePatch(...args);
const $5360aa163e663162$var$writeWorkspaceAppsWithRetry = (...args)=>(0, $1X0Je.default).functions.writeWorkspaceAppsWithRetry(...args);
const $5360aa163e663162$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $5360aa163e663162$var$shellWorkspaceSettings = (...args)=>(0, $1X0Je.default).functions.workspaceSettings(...args);
const $5360aa163e663162$var$workspaceSettingsPending = (...args)=>(0, $1X0Je.default).functions.workspaceSettingsPending(...args);
// The shell's authoritative state root, registered once at boot (app.js
// onCreate hands its `s.root`). The marketplace install/detail modals mount in
// an isolated @symbo.ls/windows layer whose element subtree does NOT reach the
// shell state root via getRoot()/state.root — so a hot-activate driven from
// there could never find the root that HeaderTabs/home bind to, and the live
// navbar update silently no-oped (server write succeeded, UI only updated on
// reload). This registry is the reliable handle reactivateWorkspaceModule uses.
let $5360aa163e663162$var$_shellRoot = null;
function $5360aa163e663162$export$e8d1b483843539f5(root) {
    if (root && typeof root === 'object') $5360aa163e663162$var$_shellRoot = root;
}
const $5360aa163e663162$var$_appsNotify = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (err) {
        console.warn('[workspaceApps]', payload && payload.title, payload && payload.message || '', err);
    }
};
// WRITE-BASE guard (spec §5), shared by every settings mutation below. Returns
// the bag to merge over, or null AFTER notifying — a caller that gets null must
// ABORT the mutation, never merge over `{}`.
//
// Aborting outright is the conservative half of a deliberate asymmetry with the
// per-key setters in featureFlags.js / voiceSettings.js, which only skip their
// optimistic mirror and still persist. Those PATCH exactly one leaf key and the
// server merges it, so there is a safe half worth keeping. The writes here are
// not like that: `workspaceApps` is a WHOLE-ARRAY write whose CAS precondition
// (`expectedApps`) is computed from this very bag, so a base of `[]` read off an
// unloaded record is precisely the stale writer that DROPS apps it never saw
// (tickets/server.md "workspaceApps: a stale writer can still DROP an entry it
// never saw"). There is no safe half of that write to keep, so the whole action
// stops and says so out loud rather than silently succeeding at the wrong thing.
const $5360aa163e663162$var$_settingsForWrite = (el, root, titleKey)=>{
    const base = (0, $7iFOV.workspaceSettingsForWrite)(root);
    if (base) return base;
    $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', titleKey || 'workspace.apps.stillLoading'),
        message: el.call('polyglot', 'workspace.apps.stillLoadingBody'),
        type: 'error'
    });
    return null;
};
async function $5360aa163e663162$export$447d1c437e013616() {
    const el = this;
    const root = el.state && el.state.root;
    const sdk = el.sdk || el.context && el.context.methods && el.context.methods.sdk;
    if (!root || root._wsAppsCatalogLoading) return;
    if (!sdk || typeof sdk.listPublicProjects !== 'function') return;
    root.update({
        _wsAppsCatalogLoading: true
    });
    try {
        // limit matches the marketplace's own app fetch (hydrateWorkspaceAppsFromSdk,
        // limit: 100) — was 12, a silent drift that capped this /add-app rail's
        // underlying catalog well below the real app count (tickets/workspace.md WS-APPS).
        const res = await sdk.listPublicProjects({
            workspaceModule: true,
            limit: 100
        });
        const rows = (Array.isArray(res) ? res : res && res.data || []).filter((p)=>p && p.metadata && p.metadata.workspaceModule === true);
        const apps = rows.map((p)=>{
            const owner = p.workspace && p.workspace.organization && p.workspace.organization.slug || p.workspace && p.workspace.slug || 'system';
            const key = p.key || p.slug || '';
            // The listing's icon (`metadata.store.icon.name` — the App Store
            // tile's own picture, the same name the app's launcher entry carries)
            // for the calm glyph the welcome's app rows wear; the install count
            // orders a list by how often an app is installed.
            const store = p.metadata && p.metadata.store;
            const icon = store && store.icon && typeof store.icon === 'object' ? store.icon.name : '';
            const installs = Number(p.installCount);
            // The listing's tagline (`metadata.store.tagline`, { <lang>: text }) is
            // the app's ONE LINE on every shell surface — the /add-app card, the
            // search caption, the welcome's app rows — read through the shared
            // store-copy resolver (`storeItemText`), which finds it here by key.
            // Only the tagline rides on the row; the rest of the listing is the
            // App Store page's. A text with no language is the English one, as
            // the store's own listing reader takes it.
            const said = store && typeof store === 'object' ? store.tagline : null;
            const tagline = {};
            if (typeof said === 'string' && said.trim()) tagline.en = said.trim();
            else if (said && typeof said === 'object' && !Array.isArray(said)) {
                for (const lang of Object.keys(said))if (typeof said[lang] === 'string' && said[lang].trim()) tagline[lang] = said[lang].trim();
            }
            return {
                id: `${owner}/${key}`,
                owner: owner,
                key: key,
                name: p.name || key,
                category: p.metadata && p.metadata.appCategory || 'app',
                description: p.metadata && p.metadata.description || '',
                store: Object.keys(tagline).length ? {
                    tagline: tagline
                } : null,
                icon: typeof icon === 'string' && /^[A-Za-z][A-Za-z0-9-]{0,63}$/.test(icon) ? icon : '',
                installCount: Number.isFinite(installs) && installs > 0 ? Math.floor(installs) : 0
            };
        }).filter((a)=>a.key);
        root.update({
            _wsAppsCatalog: apps,
            _wsAppsCatalogLoading: false,
            _wsAppsCatalogLoaded: true
        });
    } catch (err) {
        console.warn('[workspaceApps] catalog load failed:', err && err.message);
        root.update({
            _wsAppsCatalog: [],
            _wsAppsCatalogLoading: false,
            _wsAppsCatalogLoaded: true
        });
    }
}
async function $5360aa163e663162$export$b6299b30601cd704(refInput) {
    const el = this;
    const root = el.state && el.state.root;
    const sdk = el.sdk || el.context && el.context.methods && el.context.methods.sdk;
    const input = refInput || {};
    if (!root || !sdk || typeof sdk.updateWorkspaceSettings !== 'function') return;
    if (!input.owner || !input.key) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.missingRef'),
        message: el.call('polyglot', 'workspace.apps.missingRefBody'),
        type: 'error'
    });
    const ws = root.workspace || {};
    const wsId = ws._id || ws.id;
    if (!wsId) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.noWorkspace'),
        type: 'error'
    });
    // WRITE-BASE (spec §5). Chosen over DECISION/RENDER because the bag is read
    // purely to build the next one — the CAS `baseline` below and the optimistic
    // mirror further down. Gated BEFORE `_wsAppsInstalling` is set so an abort
    // leaves no stuck spinner.
    const settingsBase = $5360aa163e663162$var$_settingsForWrite(el, root, 'workspace.apps.cantInstallYet');
    if (!settingsBase) return;
    if (root._wsAppsInstalling) return;
    root.update({
        _wsAppsInstalling: `${input.owner}/${input.key}`
    });
    try {
        // Additive install: append to the plural `settings.workspaceApps` list
        // instead of overwriting the single `workspaceModule`. Installing app B no
        // longer clobbers app A. upsert dedups by owner/key so a re-install updates
        // in place. The single workspaceModule stays reserved for a full-takeover
        // client module.
        //
        // Whole-array write — send `expectedApps` (the list this write is about
        // to build from) as the CAS precondition and retry once on a stale-read
        // 409, so an in-flight install can't be the writer that drops a sibling
        // app it never saw (tickets/server.md "workspaceApps: a stale writer can
        // still DROP an entry it never saw").
        //
        // Read off `settingsBase` (the §5-guarded bag), never `ws.settings` — the
        // optional-chained read could only ever return `[]` for a record that had
        // simply not arrived, which is the exact stale baseline this CAS exists to
        // defend against.
        const baseline = settingsBase.workspaceApps || [];
        const doWrite = async (apps)=>{
            // Hand the EXISTING ref through as `prevRef` (a re-install / channel-or-
            // tier change on an already-installed app) so buildWorkspaceModuleRef
            // preserves any hand-granted capabilities (ai/files) that live on it and
            // that this builder has no manifest signal to re-derive — otherwise a
            // simple channel switch would silently wipe them (tickets/workspace.md
            // "a workspace app's capability grant never re-syncs").
            const prevRef = (apps || []).find((r)=>r && String(r.owner).toLowerCase() === String(input.owner).toLowerCase() && String(r.key).toLowerCase() === String(input.key).toLowerCase());
            const appRef = await $5360aa163e663162$var$buildWorkspaceModuleRef({
                ...input,
                prevRef: prevRef
            });
            const workspaceApps = $5360aa163e663162$var$upsertWorkspaceApp(apps, appRef);
            await sdk.updateWorkspaceSettings(wsId, $5360aa163e663162$var$appsWritePatch({
                workspaceApps: workspaceApps
            }, apps));
            return workspaceApps;
        };
        const workspaceApps = await $5360aa163e663162$var$writeWorkspaceAppsWithRetry(sdk, wsId, baseline, doWrite);
        // Patch the local settings bag so loadWorkspaceApps resolves the new list
        // without a refetch, then hot-activate. Merged over the §5-guarded base,
        // so this mirror can only ever be built on a bag that really exists.
        const settings = {
            ...settingsBase,
            workspaceApps: workspaceApps
        };
        root.update({
            workspace: {
                ...ws,
                settings: settings
            }
        });
        await (0, $7ytvD.loadWorkspaceApps)(root, sdk);
        // Surface the app's configDefaults (navbar / launcher apps) into the live
        // shell — loadWorkspaceApps injects pages+components and sets
        // root.workspaceApps, but the navbar/launcher only re-render when
        // applyWorkspaceConfig re-runs (resolveWorkspaceConfig appends each app's
        // navbar). Without this the app installs + its routes exist but its nav
        // entry (e.g. crm-app's "Contacts" → /crm) never appears until a reload.
        (0, $g7CNh.applyWorkspaceConfig)(root);
        const appId = `${String(input.owner).toLowerCase()}/${String(input.key).toLowerCase()}`;
        // The app's App Store name, in the session language (Nika 2026-10-23:
        // "app names = what a person sees in the workspace App Store"): a catalog
        // card's install passes the record's English `name`, and a direct ref
        // (the /add-app owner + key fields) passes none — the notice printed
        // "system/commerce-app installed". installedAppName asks THE store
        // resolver with the record identity; an app the store ships no name for
        // reads the name it was installed by, else its own first tab, else its id.
        const loaded = (Array.isArray(root.workspaceApps) ? root.workspaceApps : []).find((a)=>String(a && a.appId).toLowerCase() === appId);
        const label = el.call('installedAppName', {
            appId: `${input.owner}/${input.key}`,
            label: input.name || '',
            navbar: loaded && loaded.navbar,
            apps: loaded && loaded.apps
        }) || `${input.owner}/${input.key}`;
        // Auto-navigate to the freshly-installed app — same one-flow contract as
        // the marketplace install paths (reactivateWorkspaceModule +
        // navigateToWorkspaceApp), so /add-app doesn't feel like a second, lesser
        // install entry point (Fable 2026-08-09 acceptance contract). No-ops
        // silently if a landing route can't be resolved — the app is still
        // installed and live either way.
        try {
            el.call('navigateToWorkspaceApp', appId);
        } catch (_) {
        /* navigation surface unavailable — the app is still installed + live */ }
        // Resolve the landing path again for the notification's own `href` so
        // clicking "Open" on the toast re-navigates even if the auto-navigate
        // above no-oped (e.g. fired from a context with no PageSlot yet).
        let openHref = null;
        try {
            const apps = Array.isArray(root.workspaceApps) ? root.workspaceApps : [];
            const app = apps.find((a)=>String(a && a.appId).toLowerCase() === appId);
            openHref = app && Array.isArray(app.navbar) && app.navbar.find((t)=>t && t.path)?.path || null;
        } catch (_) {
        /* best-effort — the toast still confirms success without a click-through */ }
        // Copy matches the house install-flow contract exactly: "<App> installed
        // — Open" (Open navigates via `href`, never window.location — see
        // GlobalNotification/openNotificationTarget).
        $5360aa163e663162$var$_appsNotify(el, {
            title: el.call('polyglot', 'workspace.apps.installed').replace('{app}', label),
            message: el.call('polyglot', 'workspace.apps.installedBody'),
            type: 'success',
            ...openHref ? {
                href: openHref
            } : {}
        });
    } catch (err) {
        $5360aa163e663162$var$_appsNotify(el, {
            title: el.call('polyglot', 'workspace.apps.installFailed'),
            message: err && err.message || el.call('polyglot', 'workspace.apps.installFailedBody'),
            type: 'error'
        });
    } finally{
        root.update({
            _wsAppsInstalling: null
        });
    }
}
const $5360aa163e663162$export$24ee46770ed3ff1c = (root, projectId)=>{
    const id = String(projectId || '');
    if (!id) return false;
    const { settings: settings } = $5360aa163e663162$var$shellWorkspaceSettings(root);
    const list = settings && settings.workspaceApps;
    return (Array.isArray(list) ? list : []).some((r)=>r && r.type === 'extension' && String(r.projectId) === id);
};
const $5360aa163e663162$export$7e90408dcec2a9ae = (root)=>$5360aa163e663162$var$workspaceSettingsPending(root);
async function $5360aa163e663162$export$931db370800dd41d(extInput) {
    const el = this;
    const root = el.state && el.state.root;
    const sdk = el.sdk || el.context && el.context.methods && el.context.methods.sdk;
    if (!root || !sdk || typeof sdk.updateWorkspaceSettings !== 'function') return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.cantAddYet'),
        type: 'error'
    });
    const ws = root.workspace || {};
    const wsId = ws._id || ws.id;
    if (!wsId) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.noWorkspace'),
        type: 'error'
    });
    // WRITE-BASE (spec §5) — same whole-array `workspaceApps` write as
    // installWorkspaceAppRef, so the same abort. Gated up here, BEFORE the
    // confirm dialog, for two reasons: it never asks the user to confirm an
    // action that would then refuse, and the `isExtensionAddedToWorkspace` check
    // below becomes a genuine answer rather than a `false` from an unread record
    // (which would let this path share an extension workspace-wide a second time
    // for an app that was already added).
    const settingsBase = $5360aa163e663162$var$_settingsForWrite(el, root, 'workspace.apps.cantAddYet');
    if (!settingsBase) return;
    const projectId = String(extInput && (extInput.projectId || extInput.id) || root._addAppProjectId || '');
    if (!projectId) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.saveFirst'),
        message: el.call('polyglot', 'workspace.apps.saveFirstBody'),
        type: 'error'
    });
    const row = (root._userApps || []).find((a)=>a && String(a.id) === projectId) || null;
    const name = extInput && extInput.name || row && row.name || el.call('polyglot', 'workspace.apps.nameFallback');
    if ($5360aa163e663162$export$24ee46770ed3ff1c(root, projectId)) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.alreadyAdded').replace('{app}', name),
        type: 'info'
    });
    el.call('confirmDialog', {
        title: el.call('polyglot', 'workspace.apps.addConfirm'),
        message: el.call('polyglot', 'workspace.apps.addConfirmBody').replace('{app}', name),
        confirmText: el.call('polyglot', 'workspace.apps.addCta'),
        // No glyph: the kit's confirm draws its icon at the head row's end, right
        // beside Close, where a "+" read as a second button (W16b live check).
        icon: null,
        onConfirm: async ()=>{
            if (root._wsAppsInstalling) return $5360aa163e663162$var$_appsNotify(el, {
                title: el.call('polyglot', 'workspace.addApp.installingOwn'),
                type: 'info'
            });
            root.update({
                _wsAppsInstalling: `extension/${projectId}`
            });
            try {
                // 1) Share — skip only when the list already shows it shared.
                const ai = (0, $7iFOV.shellGetAiService)();
                if (ai && typeof ai.updateExtension === 'function' && (!row || row.scope !== 'shared')) await ai.updateExtension(projectId, {
                    workspaceId: wsId,
                    scope: 'shared'
                });
                // 2) Reference it from the additive apps list + hot-activate (same
                //    sequence as installWorkspaceAppRef above). owner/key make the
                //    ref dedupe-able by the shared upsert's `owner/key` identity.
                // Whole-array write — CAS precondition + retry-once (see
                // installWorkspaceAppRef above / tickets/server.md).
                const ref = {
                    type: 'extension',
                    owner: 'extension',
                    key: projectId,
                    projectId: projectId,
                    name: name
                };
                // Baseline off the §5-guarded bag (see installWorkspaceAppRef) — an
                // optional-chained `[]` here is indistinguishable from "this workspace
                // has no apps" and would make the CAS precondition assert a lie.
                const baseline = settingsBase.workspaceApps || [];
                const workspaceApps = await $5360aa163e663162$var$writeWorkspaceAppsWithRetry(sdk, wsId, baseline, async (apps)=>{
                    const next = $5360aa163e663162$var$upsertWorkspaceApp(apps, ref);
                    await sdk.updateWorkspaceSettings(wsId, $5360aa163e663162$var$appsWritePatch({
                        workspaceApps: next
                    }, apps));
                    return next;
                });
                const settings = {
                    ...settingsBase,
                    workspaceApps: workspaceApps
                };
                root.update({
                    workspace: {
                        ...ws,
                        settings: settings
                    }
                });
                // A deliberate install hot-activates quietly: the activation strip's
                // "Retrying workspace loading" belongs to a boot or a retry, never to
                // the apps reload after the person's own click (BLD-28).
                await (0, $7ytvD.loadWorkspaceApps)(root, sdk, {
                    quiet: true
                });
                (0, $g7CNh.applyWorkspaceConfig)(root);
                const added = el.call('polyglot', 'workspace.apps.added').replace('{app}', name);
                // WHERE THE APP IS NOW (functions/addAppSaved.js, BLD-28): shared and
                // in the workspace — its row in Your apps at once (the builder's list
                // shows the Shared place, where it went), the list read again, and the
                // builder that holds it says so with the way to its own page.
                const app = {
                    id: projectId,
                    name: name,
                    scope: 'shared',
                    added: true
                };
                try {
                    el.call('addAppSavedRow', root, app);
                    el.call('loadAddAppExtensions', root);
                    if (String(root._addAppProjectId || '') === projectId) el.call('addAppSavedNotice', root, added, app);
                } catch (_) {
                /* the builder is not here: the notification below still says it */ }
                $5360aa163e663162$var$_appsNotify(el, {
                    title: added,
                    message: el.call('polyglot', 'workspace.apps.addedBody'),
                    type: 'success',
                    // a press opens the app on its own page
                    href: el.call('addAppSavedPath', root, projectId)
                });
            } catch (err) {
                $5360aa163e663162$var$_appsNotify(el, {
                    title: el.call('polyglot', 'workspace.apps.addFailed'),
                    message: err && err.message || el.call('polyglot', 'workspace.apps.serverRejected'),
                    type: 'error'
                });
            } finally{
                root.update({
                    _wsAppsInstalling: null
                });
            }
        }
    });
}
async function $5360aa163e663162$export$f502251b39c2e3c7(hostArg, settingsPatch, opts) {
    const quiet = !!(opts && typeof opts === 'object' && opts.quiet === true);
    const el = this;
    // Resolve the workspace-bearing root robustly. The marketplace passes its
    // island host — a state-shaped node (marketplaceHostOf/useHostState) that may
    // carry `workspace` itself, on `.root`, or on NEITHER (app-window islands own
    // an isolated state slice). So after the host chain, fall back to el's own
    // state root and finally the root ELEMENT's state — one of these is the shell
    // state root that carries `workspace`. sdk resolves off el or merged context.
    const rootEl = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
    const root = [
        $5360aa163e663162$var$_shellRoot,
        hostArg,
        hostArg && hostArg.root,
        el && el.state && el.state.root,
        rootEl && rootEl.state
    ].find((c)=>c && c.workspace);
    // sdk: prefer the caller element, then the shell root's element, then the
    // module-level getSDK() — the marketplace island `el` often carries no `.sdk`.
    let sdk = el && (el.sdk || el.context && el.context.methods && el.context.methods.sdk);
    if (!sdk && $5360aa163e663162$var$_shellRoot) {
        const sel = $5360aa163e663162$var$_shellRoot.__element || $5360aa163e663162$var$_shellRoot.getRoot && $5360aa163e663162$var$_shellRoot.getRoot();
        sdk = sel && sel.sdk || sel && sel.context && sel.context.methods && sel.context.methods.sdk;
    }
    if (!sdk) // Module-level getSDK() (deferred-wrapper import at the top of this
    // file) — no separate dynamic import of a deep sdk.js subpath needed;
    // that subpath can't resolve through the platform's public importmap
    // once this package is pushed as a library (tickets/execution-
    // board.md §1 P0).
    try {
        sdk = $5360aa163e663162$var$shellGetSDK?.();
    } catch (_) {
    /* sdk module not reachable — bail below */ }
    if (!root || !root.workspace || !sdk) return;
    if (settingsPatch && typeof settingsPatch === 'object') {
        // WRITE-BASE (spec §5), and the sharpest one in this file: this merge is
        // the ONLY thing that carries the caller's already-persisted server write
        // into the local record, and the loaders below read the result. Merged over
        // a missing base it publishes a bag holding nothing but `settingsPatch` —
        // so loadWorkspaceApps then reads `workspaceApps: undefined` off a record
        // that LOOKS full and unloads every app the workspace has. Aborting the
        // hot-cycle costs the caller a reload; not aborting costs them their apps.
        //
        // Scoped to the patch branch on purpose. A patch-less reactivate is a pure
        // re-run of the loaders with no base read at all, so it is NOT a
        // write-base site and must keep working while the record is in flight.
        //
        // The record is handed to the guard directly rather than as `root`: the
        // accessor prefers an `input.root` hop, and the marketplace host chain
        // resolved above can land on a state slice whose `.root` carries a
        // DIFFERENT workspace than the one this merge is about to write. Passing
        // the record keeps the guard and the mutation talking about one object.
        const settingsBase = $5360aa163e663162$var$_settingsForWrite(el, {
            workspace: root.workspace
        }, "Can\u2019t apply the app change yet");
        if (!settingsBase) return;
        root.update({
            workspace: {
                ...root.workspace,
                settings: {
                    ...settingsBase,
                    ...settingsPatch
                }
            },
            // Drop the resolved-config self-merge cache so navbar/apps/panels
            // re-resolve fresh instead of re-asserting the outgoing module's config
            // (same reset the /add-app twin and loadPrivateData's switch path do).
            workspaceSettings: null
        });
    }
    // Re-run BOTH loaders: the single takeover module AND the additive apps list.
    // A marketplace install/uninstall hands `{ workspaceApps }` through
    // settingsPatch, so the additive path is the one that actually changed; the
    // takeover reload is a cheap no-op (memoized) when its ref is unchanged.
    await (0, $7ytvD.loadWorkspaceProject)(root, sdk, quiet ? {
        quiet: true
    } : undefined);
    await (0, $7ytvD.loadWorkspaceApps)(root, sdk, quiet ? {
        quiet: true
    } : undefined);
    // Surface the resolved config (navbar + launcher) into the live shell — the
    // loaders inject pages+components and set root.workspaceProject/workspaceApps,
    // but the navbar/home only re-render when applyWorkspaceConfig re-runs
    // (resolveWorkspaceConfig appends each app's navbar). Without this a
    // marketplace install loads the app's routes but its nav entry (e.g. crm-app's
    // "Contacts" → /crm) never appears until a reload.
    (0, $g7CNh.applyWorkspaceConfig)(root);
}
function $5360aa163e663162$export$fdb511fc17a378d8(appId) {
    const el = this;
    const want = String(appId || '').toLowerCase();
    // Find whichever candidate root actually holds the just-installed app in its
    // workspaceApps. The live shell state root (el.state.root) carries the fresh
    // post-reactivate list; the registered _shellRoot can be a stale pre-update
    // clone (state updates re-clone), so DON'T trust it blindly — pick the root
    // whose list contains the target.
    const rootEl = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
    const candidates = [
        el && el.state && el.state.root,
        rootEl && rootEl.state,
        $5360aa163e663162$var$_shellRoot
    ];
    const hasApp = (r)=>r && Array.isArray(r.workspaceApps) && r.workspaceApps.some((a)=>String(a && a.appId).toLowerCase() === want);
    const root = candidates.find(hasApp) || candidates.find((r)=>r && r.workspaceApps) || null;
    const apps = (root && Array.isArray(root.workspaceApps) ? root.workspaceApps : []) || [];
    const app = apps.find((a)=>String(a && a.appId).toLowerCase() === want) || null;
    const path = app && Array.isArray(app.navbar) && app.navbar.length ? app.navbar.find((t)=>t && t.path)?.path : null;
    if (!path) return;
    try {
        el.call('openAppPage', path, {
            preferSlot: true
        });
    } catch (_) {
        // openAppPage not reachable from here — fall back to the router.
        try {
            el.router?.(path, el.getRoot?.());
        } catch (__) {
        /* navigation surface unavailable — the app is still installed + live */ }
    }
}
function $5360aa163e663162$export$e16ae8c00245ef60() {
    const el = this;
    const root = el.state && el.state.root;
    const sdk = el.sdk || el.context && el.context.methods && el.context.methods.sdk;
    if (!root || !sdk || typeof sdk.updateWorkspaceSettings !== 'function') return;
    const slotRef = root.workspace && root.workspace.settings && root.workspace.settings.workspaceModule;
    if (slotRef && slotRef.installMode === 'app' && slotRef.owner && slotRef.key) return el.call('removeInstalledWorkspaceApp', `${slotRef.owner}/${slotRef.key}`);
    const activeId = root.workspaceProject && root.workspaceProject.id;
    if (!activeId) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.noAppInstalled'),
        type: 'error'
    });
    const ws = root.workspace || {};
    const wsId = ws._id || ws.id;
    if (!wsId) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.noWorkspace'),
        type: 'error'
    });
    // WRITE-BASE (spec §5). The server PATCH here is a single merge-safe key
    // (`workspaceModule: null`), but the local mirror below rebuilds the WHOLE
    // bag and then drops `workspaceSettings` so the loaders re-resolve from it —
    // so a mirror built over a missing base hands the loaders a bag containing
    // only `workspaceModule: null` and silently strips the plural apps list too.
    // Gated before the confirm so the user is never asked to approve a refusal.
    const settingsBase = $5360aa163e663162$var$_settingsForWrite(el, root, 'workspace.apps.cantRemoveYet');
    if (!settingsBase) return;
    // The takeover module by its App Store name (installedAppName — see the
    // install notice above), else its `owner/key` id as before.
    const activeName = el.call('installedAppName', root.workspaceProject) || activeId;
    el.call('confirmDialog', {
        title: el.call('polyglot', 'workspace.apps.removeConfirm'),
        message: el.call('polyglot', 'workspace.apps.removeConfirmBody').replace('{app}', activeName),
        confirmText: el.call('polyglot', 'workspace.apps.removeCta'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        // The house confirm (CRUD standard D1): the primary button, no icon.
        confirmTheme: 'primary',
        icon: null,
        onConfirm: async ()=>{
            if (root._wsAppsUninstalling) return;
            root.update({
                _wsAppsUninstalling: activeId
            });
            try {
                await sdk.updateWorkspaceSettings(wsId, {
                    workspaceModule: null
                });
                root.update({
                    workspace: {
                        ...ws,
                        settings: {
                            ...settingsBase,
                            workspaceModule: null
                        }
                    },
                    // Drop the resolved-config self-merge cache too (see
                    // workspaceConfigs.js applyWorkspaceConfig's precedence comment) —
                    // it otherwise keeps re-asserting the outgoing module's navbar/
                    // apps/panels/skin instead of letting the hot re-apply below
                    // resolve them fresh. Same reset loadPrivateData.js performs at a
                    // workspace switch (the framework's own deactivate/activate cycle).
                    workspaceSettings: null
                });
                await (0, $7ytvD.loadWorkspaceProject)(root, sdk);
                await (0, $7ytvD.loadWorkspaceApps)(root, sdk);
                (0, $g7CNh.applyWorkspaceConfig)(root);
                $5360aa163e663162$var$_appsNotify(el, {
                    title: el.call('polyglot', 'workspace.apps.removed').replace('{app}', activeName),
                    message: el.call('polyglot', 'workspace.apps.removedBody'),
                    type: 'success'
                });
            } catch (err) {
                $5360aa163e663162$var$_appsNotify(el, {
                    title: el.call('polyglot', 'workspace.apps.removeFailed'),
                    message: err && err.message || el.call('polyglot', 'workspace.apps.serverRejected'),
                    type: 'error'
                });
            } finally{
                root.update({
                    _wsAppsUninstalling: null
                });
            }
        }
    });
}
async function $5360aa163e663162$export$1019c211790c7a30(appId) {
    const el = this;
    const root = el.state && el.state.root;
    if (!root) return;
    const id = String(appId || '').toLowerCase();
    const sep = id.indexOf('/');
    const owner = sep > 0 ? id.slice(0, sep) : '';
    const key = sep > 0 ? id.slice(sep + 1) : '';
    if (!owner || !key) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.noAppSelected'),
        type: 'error'
    });
    const ws = root.workspace || {};
    if (!ws._id && !ws.id) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.noWorkspace'),
        type: 'error'
    });
    // WRITE-BASE (spec §5). Nothing here writes a settings bag any more (the
    // DELETE pulls one entry on the server), but the finish merges the server's
    // list over this record's settings (reactivateWorkspaceModule), and that
    // merge refuses a record still in flight. Gated before the dialog, so a
    // person is never asked to approve a removal the shell cannot then show.
    if (!$5360aa163e663162$var$_settingsForWrite(el, root, 'workspace.apps.cantRemoveYet')) return;
    // The takeover removal (uninstallWorkspaceApp above) rebuilds the whole
    // local bag while it runs; a removal started under it waits for it.
    if (root._wsAppsUninstalling) return;
    const apps = Array.isArray(root.workspaceApps) ? root.workspaceApps : [];
    const target = apps.find((a)=>a && String(a.appId).toLowerCase() === id);
    // The app by its App Store name (installedAppName — see the install notice
    // above); the store's dialog and toast read the name the item carries.
    const name = el.call('installedAppName', target || {
        appId: id
    }) || id;
    const dialog = await el.call('ensureMarketplaceUninstallDialog');
    if (dialog && dialog.reason === 'notReady') return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.cantRemoveYet'),
        message: el.call('polyglot', 'workspace.apps.stillLoadingBody'),
        type: 'error'
    });
    const host = dialog && dialog.host;
    // The store's dialog could not load (a plane that cannot fold the
    // marketplace chunk): the server's guard still decides, behind the shell's
    // own confirm. See _removeWithServerGuard.
    if (!host) return $5360aa163e663162$var$_removeWithServerGuard(el, root, id, name);
    return el.call('openAppUninstallDialog', {
        kind: 'app',
        id: id,
        owner: owner,
        key: key,
        name: name
    }, host);
}
// The Remove when the App Store's dialog cannot load. A plane that cannot fold
// the marketplace chunk (the frank-published shell has no import-map entry for
// it) used to answer "Remove failed" and remove nothing. Here the removal
// still goes through the server's dependency guard: the shell's own confirm,
// then sdk.removeWorkspaceApp — the atomic DELETE, never `force`. A 409 (an
// installed app requires this one) is the blocked state: a notice that names
// each app that requires it, by its App Store name where the shell holds the
// app, else by its id, in the store's own copy (marketplace.uninstallDeps.*).
// A removal refreshes the shell through reactivateWorkspaceModule with the
// server's settings, the path the store's dialog takes.
//
// What the fallback cannot do: warn about an OPTIONAL dependent before the
// removal. The dialog reads every manifest for that; the 409 body carries ids
// and requirements only, and an optional dependent never blocks.
const $5360aa163e663162$var$_removeWithServerGuard = (el, root, id, name)=>{
    const sdk = el.sdk || el.context && el.context.methods && el.context.methods.sdk;
    const ws = root.workspace || {};
    const wsId = ws._id || ws.id;
    if (!sdk || typeof sdk.removeWorkspaceApp !== 'function') return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.removeFailed'),
        message: el.call('polyglot', 'common.action.try_again'),
        type: 'error'
    });
    el.call('confirmDialog', {
        title: el.call('polyglot', 'workspace.apps.removeConfirm'),
        message: el.call('polyglot', 'workspace.apps.removeConfirmBody').replace('{app}', name),
        confirmText: el.call('polyglot', 'workspace.apps.removeCta'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        // The house confirm (CRUD standard D1): the primary button, no icon.
        confirmTheme: 'primary',
        icon: null,
        onConfirm: async ()=>{
            if (root._wsAppsUninstalling) return;
            root.update({
                _wsAppsUninstalling: id
            });
            try {
                try {
                    await sdk.removeWorkspaceApp(wsId, id);
                } catch (err) {
                    if (err && err.status === 409) return $5360aa163e663162$var$_appsNotify(el, $5360aa163e663162$var$_removeBlockedNotice(el, root, name, err));
                    throw err;
                }
                const settings = await $5360aa163e663162$var$_settingsAfterRemoval(sdk, wsId, ws, id);
                await el.call('reactivateWorkspaceModule', root, settings);
                $5360aa163e663162$var$_appsNotify(el, {
                    title: el.call('polyglot', 'workspace.apps.removed').replace('{app}', name),
                    message: el.call('polyglot', 'workspace.apps.removedBody'),
                    type: 'success'
                });
            } catch (err) {
                $5360aa163e663162$var$_appsNotify(el, {
                    title: el.call('polyglot', 'workspace.apps.removeFailed'),
                    message: err && err.message || el.call('polyglot', 'workspace.apps.serverRejected'),
                    type: 'error'
                });
            } finally{
                root.update({
                    _wsAppsUninstalling: null
                });
            }
        }
    });
};
// The installed apps after a removal: the server's record, read back. If that
// read fails, the record this shell holds minus the removed app — never an
// empty list, which would unload every other app.
const $5360aa163e663162$var$_settingsAfterRemoval = async (sdk, wsId, ws, id)=>{
    const fresh = typeof sdk.getWorkspace === 'function' ? await sdk.getWorkspace(wsId).catch(()=>null) : null;
    if (fresh && fresh.settings) return {
        workspaceApps: fresh.settings.workspaceApps || [],
        workspaceModule: fresh.settings.workspaceModule ?? null
    };
    const base = ws.settings || {};
    const idOf = (r)=>`${r && r.owner || ''}/${r && r.key || ''}`.toLowerCase();
    const slot = base.workspaceModule;
    return {
        workspaceApps: (base.workspaceApps || []).filter((r)=>idOf(r) !== id),
        workspaceModule: slot && idOf(slot) === id ? null : slot ?? null
    };
};
// The blocked notice of a 409: "Can't remove {name}", and the apps that
// require it (the required ones; all of them if the body marks none).
const $5360aa163e663162$var$_removeBlockedNotice = (el, root, name, err)=>{
    const cause = err && err.cause;
    const all = cause && Array.isArray(cause.dependents) && cause.dependents || [];
    const required = all.filter((d)=>d && d.requirement === 'required');
    const apps = Array.isArray(root.workspaceApps) ? root.workspaceApps : [];
    const names = (required.length ? required : all).map((d)=>{
        const did = String(d && d.id || '').toLowerCase();
        const entry = apps.find((a)=>a && String(a.appId).toLowerCase() === did);
        return el.call('installedAppName', entry || {
            appId: did
        }) || did;
    });
    return {
        title: el.call('polyglot', 'marketplace.uninstallDeps.title').replace('{name}', name),
        message: $5360aa163e663162$var$_removeDependentsList(el, names),
        type: 'error',
        duration: 8000
    };
};
// A list of names in the session language ("A, B and C" / "A, B და C").
const $5360aa163e663162$var$_removeDependentsList = (el, names)=>{
    try {
        return new Intl.ListFormat(el.call('getActiveLang') || undefined, {
            type: 'conjunction'
        }).format(names);
    } catch (_) {
        return new Intl.ListFormat(undefined, {
            type: 'conjunction'
        }).format(names);
    }
};
function $5360aa163e663162$export$48a30517631770dc() {
    const el = this;
    const root = el.state && el.state.root;
    const sdk = el.sdk || el.context && el.context.methods && el.context.methods.sdk;
    if (!root || !sdk || typeof sdk.updateWorkspaceSettings !== 'function') return;
    const ws = root.workspace || {};
    const wsId = ws._id || ws.id;
    if (!wsId) return $5360aa163e663162$var$_appsNotify(el, {
        title: el.call('polyglot', 'workspace.apps.noWorkspace'),
        type: 'error'
    });
    // WRITE-BASE (spec §5). Same shape as uninstallWorkspaceApp: one merge-safe
    // key on the wire (`navbar: null`), but a full-bag local mirror. Rebuilt over
    // a missing base it would republish the record carrying nothing but
    // `navbar: null` — and applyWorkspaceConfig immediately re-resolves the shell
    // from that, so a reset of the navbar would blank the apps list with it.
    const settingsBase = $5360aa163e663162$var$_settingsForWrite(el, root, 'workspace.apps.cantResetYet');
    if (!settingsBase) return;
    el.call('confirmDialog', {
        title: el.call('polyglot', 'workspace.apps.resetNavbarConfirm'),
        message: el.call('polyglot', 'workspace.apps.resetNavbarConfirmBody'),
        confirmText: el.call('polyglot', 'workspace.apps.resetNavbarCta'),
        onConfirm: async ()=>{
            try {
                await sdk.updateWorkspaceSettings(wsId, {
                    navbar: null
                });
                root.update({
                    workspace: {
                        ...ws,
                        settings: {
                            ...settingsBase,
                            navbar: null
                        }
                    },
                    // Same self-merge cache drop as uninstallWorkspaceApp above,
                    // scoped to just the navbar key so apps/panels/skin are untouched.
                    workspaceSettings: {
                        ...root.workspaceSettings || {},
                        navbar: null
                    }
                });
                (0, $g7CNh.applyWorkspaceConfig)(root);
                $5360aa163e663162$var$_appsNotify(el, {
                    title: el.call('polyglot', 'workspace.apps.navbarReset'),
                    type: 'success'
                });
            } catch (err) {
                $5360aa163e663162$var$_appsNotify(el, {
                    title: el.call('polyglot', 'workspace.apps.resetFailed'),
                    message: err && err.message || el.call('polyglot', 'workspace.apps.serverRejected'),
                    type: 'error'
                });
            }
        }
    });
}

});

parcelRegister("hv8sj", function(module, exports) {

$parcel$export(module.exports, "installedAppName", () => $cbdbe40456c3a6d6$export$f486338b1660bffd);
// THE NAME A PERSON READS FOR AN INSTALLED APP — the App Store's catalogue
// name, in the session language.
//
// Nika 2026-10-23: "app names = what a person sees in the workspace App Store
// ('Catalogue names'). When two surfaces disagree, change the one that
// differs." The persona walks of 2026-10-24 measured the disagreement: the app
// window's apps rail named the installed apps "Store, Catalog, CMS, Analytics"
// (marcus, 390 px) and /add-app's "Installed apps" list read "CMS, CRM,
// Scheduling, Store, Catalog" (aiko, 1512 px), while the App Store, the phone
// Apps sheet and the /add-app cards said Commerce, Products, Content,
// Insights. Those are the words of each app's MANIFEST (`configDefaults.navbar`
// / `.apps`), printed by every surface that took a manifest row's label.
//
// So this is no second naming rule. It hands THE store-copy resolver
// (shared functions/storeItemText.js — the one the App Store itself calls) the
// app's record identity and the words the app already carries, and returns
// what that resolver says: the record's own localized name, else the shipped
// `marketplace.app.<slug>.name`, else the app's own words through polyglot.
// An app the store ships no name for (a third party's, a customer's, an
// extension) keeps its own words, untouched.
//
// `app` is whatever the caller holds that names one installed app:
//   • a `root.workspaceApps` entry (`{ appId: 'owner/key', navbar, apps }`);
//   • a row the shell STAMPED with its app's identity (`{ appKey, label }` /
//     `{ appKey, title }` — workspaceConfigs.js stamps `appKey` on the ONE row
//     an app contributes, and only then);
//   • a plain `{ appId, label }` a caller builds from what it has.
// A row with no identity — a sub-surface of an app that ships several rows
// ("Policies" + "Claims"), a house tile, a customer's own tab — has no record
// to ask, so it reads exactly as before: its own words through polyglot.
//
// Call it as `el.call('installedAppName', app)` — `el.call` binds `this` = el.
// A direct import call (no element) returns the app's own words unresolved.
const $cbdbe40456c3a6d6$export$f486338b1660bffd = function installedAppName(app) {
    if (!app || typeof app !== 'object') return '';
    const text = (v)=>typeof v === 'string' ? v.trim() : '';
    // The record identity. `appKey` is the stamp a row carries; an id is
    // `owner/key` (`appId` on a loaded entry, `catalogId` on an activation,
    // `id` on a loaded entry and on the takeover module) and the record key is
    // its last segment. An id without a `/` (an extension's project id) names
    // no store record.
    const ownerKey = [
        app.appId,
        app.catalogId,
        app.id
    ].map(text).find((v)=>v.includes('/'));
    const key = text(app.appKey) || (ownerKey ? ownerKey.split('/').pop() : '');
    // The words the app already carries: the row's own, else the entry's first
    // navbar tab, else its first launcher tile.
    const nav = (Array.isArray(app.navbar) ? app.navbar : []).find((n)=>n && text(n.label));
    const tile = (Array.isArray(app.apps) ? app.apps : []).find((t)=>t && (text(t.title) || text(t.label)));
    const own = text(app.label) || text(app.title) || text(app.name) || (nav ? text(nav.label) : '') || (tile ? text(tile.title) || text(tile.label) : '');
    if (!this || typeof this.call !== 'function') return own;
    const named = this.call('storeItemText', {
        key: key,
        name: own
    }, 'name');
    return typeof named === 'string' ? named : own;
};

});

parcelRegister("3lK1C", function(module, exports) {

$parcel$export(module.exports, "appsHubModel", () => $270708df77dc9965$export$b06286410eba0dea);
$parcel$export(module.exports, "appsHubLoad", () => $270708df77dc9965$export$61b1fe8927b6fe8d);
$parcel$export(module.exports, "appsHubOpen", () => $270708df77dc9965$export$6d2ce8403119f4a2);
$parcel$export(module.exports, "appsHubEdit", () => $270708df77dc9965$export$dc56c9c142341729);
$parcel$export(module.exports, "appsHubManage", () => $270708df77dc9965$export$df2e37405d81fc44);
// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace". This is where a workspace sees its add-ons —
// the ones installed here, the ones its team built, the ones the App Store
// offers — and where each opens, changes and is managed. A website never
// appears here; it lives on the Websites board (/studio).
//
// Every function below reads root state only and writes nothing new: install,
// remove and share stay in their own flows (the App Store, /add-app). FA204 —
// each export carries its own helpers.
// el.call('appsHubModel', root) → { installed, team, store } — the rows the
// three sections render, every row keyed `app-…` (a data key never becomes an
// HTML tag) and carrying every field a row reads (no root fallback).
//   installed — one row per installed app (root.workspaceApps manifests, the
//               raw refs while a manifest is still loading, the takeover
//               module, installed AI-built apps); source 'store' | 'ai' |
//               'custom'; channel from the install ref.
//   team      — AI-built apps of this workspace (root._userApps) that are not
//               installed: they wait in /add-app.
//   store     — App Store apps (root._wsAppsCatalog) not installed here, first 6.
// No row carries a caption: no card here shows one (lane CAP, 2026-10-30). A
// store app's record `description` is its raw English line, so a card that
// one day shows a line reads THE store-copy resolver at render
// (`storeItemText`, as AddAppCatalogCard's Description does), never the row.
function $270708df77dc9965$export$b06286410eba0dea(root) {
    const r = root && typeof root === 'object' ? root : {};
    const lc = (v)=>v == null ? '' : String(v).trim().toLowerCase();
    const isObjectId = (v)=>typeof v === 'string' && /^[a-f0-9]{24}$/i.test(v);
    const ws = r.workspace && typeof r.workspace === 'object' ? r.workspace : {};
    const settings = ws.settings && typeof ws.settings === 'object' ? ws.settings : {};
    const refs = Array.isArray(settings.workspaceApps) ? settings.workspaceApps : [];
    const catalog = Array.isArray(r._wsAppsCatalog) ? r._wsAppsCatalog : [];
    const catalogIds = new Set(catalog.map((a)=>lc(a && a.id)).filter(Boolean));
    // An installed app is an App Store app when the loaded catalog lists it. A
    // PRIVATE system module (bookmarks-app on staging, 2026-10-21) is not in the
    // store: it read "App Store" and its Manage opened the general Marketplace
    // (no item page). Until the catalog has loaded (or when its read failed and
    // left it empty) a system app stays the provisional store guess.
    const catalogKnown = r._wsAppsCatalogLoaded === true && catalogIds.size > 0;
    const storeSource = (id, owner)=>catalogIds.has(id) || !catalogKnown && lc(owner) === 'system' ? 'store' : 'custom';
    const refById = new Map();
    for (const ref of refs){
        if (!ref || typeof ref !== 'object') continue;
        if (ref.type === 'extension' && ref.projectId) refById.set(lc(ref.projectId), ref);
        else if (ref.owner && ref.key) refById.set(lc(ref.owner) + '/' + lc(ref.key), ref);
    }
    const firstTile = (m)=>{
        const tiles = Array.isArray(m && m.apps) ? m.apps : [];
        const t = tiles.find((x)=>x && x.route) || null;
        if (t) return t;
        const nav = Array.isArray(m && m.navbar) ? m.navbar.find((x)=>x && x.path) : null;
        return nav ? {
            title: nav.label,
            route: nav.path
        } : null;
    };
    const channelOf = (ref)=>ref && ref.channel === 'development' ? 'development' : 'production';
    const installed = [];
    const seen = new Set();
    const pushInstalled = (row)=>{
        if (!row.id || seen.has(row.id)) return;
        seen.add(row.id);
        installed.push(row);
    };
    const wp = r.workspaceProject;
    for (const m of Array.isArray(r.workspaceApps) ? r.workspaceApps : []){
        if (!m || typeof m.id !== 'string' || !m.id) continue;
        const id = lc(m.id);
        const tile = firstTile(m) || {};
        const ai = isObjectId(m.id);
        const [owner, key] = ai ? [
            '',
            m.id
        ] : m.id.split('/');
        const ref = refById.get(id) || null;
        pushInstalled({
            key: 'app-' + id.replace(/[^a-z0-9]+/g, '-'),
            id: id,
            owner: owner || '',
            appKey: key || '',
            projectId: ai ? m.id : '',
            title: tile.title || ref && ref.name || key || m.id,
            icon: tile.icon || '',
            glyph: tile.glyph || '',
            route: tile.route || (ai ? '/x/' + m.id : ''),
            source: ai ? 'ai' : storeSource(id, owner),
            channel: channelOf(ref),
            installed: true
        });
    }
    // Refs whose manifest has not activated yet still count as installed.
    for (const [id, ref] of refById){
        if (seen.has(id)) continue;
        const ai = ref.type === 'extension';
        pushInstalled({
            key: 'app-' + id.replace(/[^a-z0-9]+/g, '-'),
            id: id,
            owner: ai ? '' : String(ref.owner || ''),
            appKey: ai ? String(ref.projectId) : String(ref.key || ''),
            projectId: ai ? String(ref.projectId) : '',
            title: ref.name || (ai ? '' : ref.key) || id,
            icon: '',
            glyph: '',
            route: ai ? '/x/' + ref.projectId : '',
            source: ai ? 'ai' : storeSource(id, ref.owner),
            channel: channelOf(ref),
            installed: true
        });
    }
    if (wp && typeof wp.id === 'string' && wp.id.indexOf('/') > 0) {
        const id = lc(wp.id);
        const [owner, key] = wp.id.split('/');
        const legacy = settings.workspaceModule;
        pushInstalled({
            key: 'app-' + id.replace(/[^a-z0-9]+/g, '-'),
            id: id,
            owner: owner,
            appKey: key,
            projectId: '',
            title: wp.name || wp.config && wp.config.name || key,
            icon: '',
            glyph: '',
            route: '/',
            source: catalogIds.has(id) ? 'store' : 'custom',
            channel: channelOf(legacy),
            installed: true
        });
    }
    const team = [];
    for (const x of Array.isArray(r._userApps) ? r._userApps : []){
        const pid = x && (x.id || x._id || x.projectId);
        if (!pid || seen.has(lc(pid))) continue;
        seen.add(lc(pid));
        team.push({
            key: 'app-' + lc(pid),
            id: lc(pid),
            owner: '',
            appKey: String(pid),
            projectId: String(pid),
            title: x.name || x.title || String(pid),
            icon: '',
            glyph: '',
            route: '',
            source: 'ai',
            channel: 'development',
            installed: false
        });
    }
    // The workspace's OWN modules — a custom or forked module project of this
    // workspace that is not installed here and is not in the App Store (that
    // one waits in the store section): known by the server's app marker on the
    // project list (metadata.workspaceModule, server 4d77db631).
    const activeWsId = String(ws.id || ws._id || r.jwtClaims && r.jwtClaims.active_workspace_id || '');
    const slugOf = (v)=>{
        if (!v) return '';
        if (typeof v === 'string') return isObjectId(v) ? '' : v;
        return v.slug || v.username || '';
    };
    for (const p of Array.isArray(r._projectsForActiveOrg) ? r._projectsForActiveOrg : []){
        if (!p || !p.key) continue;
        const m = p.metadata && typeof p.metadata === 'object' ? p.metadata : {};
        if (m.workspaceModule !== true) continue;
        const w = p.workspace;
        const pWs = String(w && (w.id || w._id) || w || '');
        if (activeWsId && pWs && pWs !== activeWsId) continue;
        const owner = slugOf(p.owner) || slugOf(w && w.organization);
        const key = String(p.key).split('.')[0];
        const id = lc(owner) + '/' + lc(key);
        if (!owner || seen.has(id) || catalogIds.has(id)) continue;
        seen.add(id);
        team.push({
            key: 'app-' + id.replace(/[^a-z0-9]+/g, '-'),
            id: id,
            owner: owner,
            appKey: key,
            projectId: '',
            title: p.name || key,
            icon: '',
            glyph: '',
            route: '',
            source: 'custom',
            channel: 'development',
            installed: false
        });
    }
    // THE STORE SECTION follows the workspace's preset (persona round 5, elena,
    // Medical: it offered Payroll, Invoices, Production and Products). A
    // workspace set up from a preset (`settings.preset.key`, not the 'custom'
    // answer) is offered what ITS preset names in the registry
    // (root._workspacePresets, GET /core/presets): the preset's `suggested`
    // apps first, then a preset app the apply left out — never an app the
    // preset does not name. Until the registry is read (or with no row for the
    // key) nothing is offered. No preset: the catalogue's first six.
    const applied = settings.preset && typeof settings.preset === 'object' ? settings.preset : null;
    const presetKey = applied && typeof applied.key === 'string' ? applied.key.trim() : '';
    let offer = catalog;
    if (presetKey && presetKey !== 'custom') {
        const registry = Array.isArray(r._workspacePresets) ? r._workspacePresets : [];
        const preset = registry.find((p)=>p && p.key === presetKey) || null;
        const list = (v)=>Array.isArray(v) ? v : [];
        const named = preset ? [
            ...list(preset.suggested),
            ...list(preset.apps)
        ] : [];
        const byId = new Map();
        for (const a of catalog)if (a && a.id && !byId.has(lc(a.id))) byId.set(lc(a.id), a);
        offer = [];
        const picked = new Set();
        for (const id of named){
            const a = byId.get(lc(id));
            if (!a || picked.has(lc(id))) continue;
            picked.add(lc(id));
            offer.push(a);
        }
    }
    const store = [];
    for (const a of offer){
        if (!a || !a.id || seen.has(lc(a.id))) continue;
        if (store.length >= 6) break;
        store.push({
            key: 'app-' + lc(a.id).replace(/[^a-z0-9]+/g, '-'),
            id: lc(a.id),
            owner: String(a.owner || ''),
            appKey: String(a.key || ''),
            projectId: '',
            title: a.name || a.key || a.id,
            icon: '',
            glyph: '',
            route: '',
            source: 'store',
            channel: 'production',
            installed: false
        });
    }
    return {
        installed: installed,
        team: team,
        store: store
    };
}
function $270708df77dc9965$export$61b1fe8927b6fe8d() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root) return;
    try {
        el.call('loadAddAppExtensions', root);
    } catch (_) {}
    try {
        if (!root._wsAppsCatalogLoaded) el.call('loadWorkspaceAppsCatalog');
    } catch (_) {}
    // A preset workspace's store section reads its preset's suggestions from
    // the registry (appsHubModel): the store's reader, registered at boot by
    // marketplace/functions/eagerSlice.js. It never rejects.
    try {
        const ws = root.workspace;
        const preset = ws && ws.settings && ws.settings.preset;
        const key = preset && typeof preset === 'object' ? String(preset.key || '').trim() : '';
        if (key && key !== 'custom' && !Array.isArray(root._workspacePresets)) Promise.resolve(el.call('workspacePresetsLoad')).catch(()=>null);
    } catch (_) {}
    // The workspace's own module projects (the "Built by your team" custom
    // rows): the home's org project list, read here when no home read it.
    try {
        if (!root._projectsForActiveOrg) el.call('canvasAnswerRead', el);
    } catch (_) {}
}
function $270708df77dc9965$export$6d2ce8403119f4a2(row) {
    if (!row || !row.route) return;
    this.call('openAppPage', row.route);
}
function $270708df77dc9965$export$dc56c9c142341729(row) {
    const root = this && this.state && this.state.root;
    if (!root || !row || !row.projectId) return;
    root.update({
        _addAppProjectId: String(row.projectId)
    }, {
        preventFetch: true
    });
    this.call('openAppPage', '/add-app');
}
function $270708df77dc9965$export$df2e37405d81fc44(row) {
    if (!row || !row.owner || !row.appKey) return;
    if (row.source === 'custom') {
        const root = this && this.state && this.state.root;
        if (root && typeof root.update === 'function' && !row.installed) root.update({
            _wsAppsRefOwner: String(row.owner),
            _wsAppsRefKey: String(row.appKey)
        }, {
            preventFetch: true
        });
        this.call('openAppPage', '/add-app');
        return;
    }
    // Its page in the catalogue's App Store tab (decision 7, ledger AS-3), in
    // the shell's pane like the navbar's Apps — /apps/store is no app-window
    // route, so a plain open landed a full page. The route is this hub's own;
    // the item is the App Store's (marketplace functions/appStoreItemLink.js,
    // registered at boot). An owner or a key that names no App Store item
    // opens nothing.
    const route = this.call('appStoreItemLink', row.owner, row.appKey, '/apps/store');
    if (!route) return;
    this.call('openAppPage', route, {
        preferSlot: true
    });
}

});

parcelRegister("L8D7m", function(module, exports) {

$parcel$export(module.exports, "closeModal", () => $08db15a00ae39a41$export$3f6fecd573f3fa48);
// closeModal — its own module so an entry that does not load this whole
// barrel (the comm app, comm/functions.js) registers the SAME dispatcher.
parcelRequire("4qCA4");
var $f3rZN = parcelRequire("f3rZN");
const $08db15a00ae39a41$export$3f6fecd573f3fa48 = function(id) {
    if (id) return (0, $f3rZN.closeModal).call(this, id);
    const root = this?.state?.root;
    let m = this;
    while(m){
        const sk = typeof m.stateKey === 'string' ? m.stateKey : null;
        if (sk) {
            if (!root?.update) return;
            const extra = m.extraClose && typeof m.extraClose === 'object' && !Array.isArray(m.extraClose) ? m.extraClose : null;
            root.update(extra ? {
                [sk]: null,
                ...extra
            } : {
                [sk]: null
            });
            return;
        }
        m = m.parent;
    }
    return (0, $f3rZN.closeModal).call(this);
};

});
parcelRegister("4qCA4", function(module, exports) {

$parcel$export(module.exports, "windowsFunctions", () => $33978474e042249f$export$918af4b444eb58d0);
$parcel$export(module.exports, "closeModal", () => (parcelRequire("f3rZN")).closeModal);

var $27CtR = parcelRequire("27CtR");

var $f3rZN = parcelRequire("f3rZN");

var $3c6rH = parcelRequire("3c6rH");

var $cfoKj = parcelRequire("cfoKj");

var $kQT84 = parcelRequire("kQT84");

var $7uZAa = parcelRequire("7uZAa");

var $jtcLi = parcelRequire("jtcLi");
const $33978474e042249f$export$918af4b444eb58d0 = {
    openModal: (0, $27CtR.openModal),
    closeModal: (0, $f3rZN.closeModal),
    closeAllModals: (0, $3c6rH.closeAllModals),
    confirmDialog: (0, $cfoKj.confirmDialog),
    alertDialog: (0, $kQT84.alertDialog),
    promptDialog: (0, $7uZAa.promptDialog),
    getLayer: (0, $jtcLi.getLayer)
};

});
parcelRegister("27CtR", function(module, exports) {

$parcel$export(module.exports, "openModal", () => $18ba15a6de716af6$export$a7f6cffb6b8ba11c);

var $jtcLi = parcelRequire("jtcLi");

var $baSp1 = parcelRequire("baSp1");
function $18ba15a6de716af6$export$a7f6cffb6b8ba11c(e = {}) {
    const o = (0, $jtcLi.resolveModalRoot)(this);
    if (!o) return null;
    o.__modalIdCounter = (o.__modalIdCounter || 0) + 1;
    const t = e.id || `modal_${o.__modalIdCounter}_${Date.now().toString(36)}`, a = {
        id: t,
        template: e.template || "custom",
        title: e.title,
        message: e.message,
        icon: e.icon,
        confirmText: e.confirmText,
        cancelText: e.cancelText,
        okText: e.okText,
        confirmTheme: e.confirmTheme,
        placeholder: e.placeholder,
        defaultValue: e.defaultValue,
        dismissOnBackdrop: e.dismissOnBackdrop,
        content: e.content,
        width: e.width,
        maxWidth: e.maxWidth,
        maxHeight: e.maxHeight,
        onConfirm: e.onConfirm,
        onCancel: e.onCancel,
        onOk: e.onOk,
        onClose: e.onClose
    }, n = o.state?.stack || [];
    if (n.length >= 5) return console.warn("[windows] openModal: stack already at the 5-layer maximum, dropping the new layer. Close some modals first."), null;
    const d = n.length, l = (0, $baSp1.takeSlot)(o, d);
    return o.state.update(l ? {
        stack: [
            ...n,
            a
        ],
        leaving: l
    } : {
        stack: [
            ...n,
            a
        ]
    }), t;
}

});
parcelRegister("jtcLi", function(module, exports) {

$parcel$export(module.exports, "walkToLayer", () => $e2ca9ffd21715e5c$export$8ca5275668e19885);
$parcel$export(module.exports, "walkToLayerExiting", () => $e2ca9ffd21715e5c$export$6e9390be34a2a80);
$parcel$export(module.exports, "layerTitle", () => $e2ca9ffd21715e5c$export$52b53d37661e4515);
$parcel$export(module.exports, "layerTitleId", () => $e2ca9ffd21715e5c$export$439436631b3e46df);
$parcel$export(module.exports, "resolveModalRoot", () => $e2ca9ffd21715e5c$export$5d0676a4b1bcf65e);
$parcel$export(module.exports, "getLayer", () => $e2ca9ffd21715e5c$export$f5b74d0d242cec02);
function $e2ca9ffd21715e5c$export$8ca5275668e19885(r) {
    let t = r;
    for(; t;){
        if (t.layer !== void 0) return t.layer;
        t = t.parent;
    }
    return null;
}
function $e2ca9ffd21715e5c$export$6e9390be34a2a80(r) {
    let t = r;
    for(; t;){
        if (t.layer !== void 0) return !!t.layerExiting;
        t = t.parent;
    }
    return !1;
}
function $e2ca9ffd21715e5c$export$52b53d37661e4515(r) {
    const t = r?.title;
    return t == null ? "" : String(t).trim();
}
function $e2ca9ffd21715e5c$export$439436631b3e46df(r, t) {
    return !r || !r.id || r.template !== t ? null : t === "custom" ? $e2ca9ffd21715e5c$export$52b53d37661e4515(r) ? "modal-title-" + r.id : null : t === "confirm" || t === "alert" || t === "prompt" ? "modal-title-" + r.id : null;
}
function $e2ca9ffd21715e5c$export$5d0676a4b1bcf65e(r) {
    let t = r;
    for(; t;){
        if (t.key === "ModalRoot") return t;
        if (t.ModalRoot && t.ModalRoot.__ref) return t.ModalRoot;
        t = t.parent;
    }
    const o = r?.getRoot?.();
    return o?.ModalRoot ? o.ModalRoot : typeof globalThis < "u" && globalThis.__SMBLS_WINDOWS_MODAL_ROOT__?.__ref ? globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ : null;
}
function $e2ca9ffd21715e5c$export$f5b74d0d242cec02() {
    return $e2ca9ffd21715e5c$export$8ca5275668e19885(this);
}

});

parcelRegister("baSp1", function(module, exports) {

$parcel$export(module.exports, "takeSlot", () => $822ad4186ea91b18$export$26a4b198775cd9ea);
$parcel$export(module.exports, "removeLayers", () => $822ad4186ea91b18$export$3c75c984ac37fe91);
const $822ad4186ea91b18$var$m = "(prefers-reduced-motion: reduce)", $822ad4186ea91b18$var$y = (e)=>e?.node || e?.__ref?.node || null, $822ad4186ea91b18$var$u = (e, n)=>$822ad4186ea91b18$var$y(e && e["ModalLayer_" + n]), $822ad4186ea91b18$export$ff7706047246b98b = ()=>typeof window < "u" && typeof window.matchMedia == "function" && !!window.matchMedia($822ad4186ea91b18$var$m).matches, $822ad4186ea91b18$export$9e438ffb187c02cc = (e, n)=>{
    const t = $822ad4186ea91b18$var$u(e, n);
    !t || typeof t.style?.setProperty != "function" || (t.style.setProperty("display", "none", "important"), t.style.setProperty("opacity", "0", "important"), t.style.setProperty("visibility", "hidden", "important"), t.style.setProperty("pointer-events", "none", "important"));
}, $822ad4186ea91b18$export$fca08aa74cf12364 = (e, n)=>{
    const t = $822ad4186ea91b18$var$u(e, n);
    !t || typeof t.style?.removeProperty != "function" || (t.style.removeProperty("display"), t.style.removeProperty("opacity"), t.style.removeProperty("visibility"), t.style.removeProperty("pointer-events"));
}, $822ad4186ea91b18$var$P = (e, n)=>{
    const t = $822ad4186ea91b18$var$u(e, n);
    return !!t && typeof t.getAnimations == "function" && !$822ad4186ea91b18$export$ff7706047246b98b();
}, $822ad4186ea91b18$var$g = (e)=>{
    if (!e || typeof e.getAnimations != "function") return [];
    const n = [];
    for (const t of e.getAnimations()){
        const r = typeof t?.effect?.getComputedTiming == "function" ? t.effect.getComputedTiming() : null;
        r && r.iterations === 1 / 0 || typeof t?.finished?.then == "function" && n.push(t.finished.then(()=>{}, ()=>{}));
    }
    return n;
};
function $822ad4186ea91b18$export$211613be1165b5c1(e, n, t) {
    if (!e?.__ref) return;
    const r = e.__layerExits;
    if (!r || r[n] !== t) return;
    delete r[n];
    const s = e.state;
    if (s) {
        if (s.leaving?.[n]) {
            const o = Array.from(s.leaving);
            o[n] = null, s.update({
                leaving: o
            });
        }
        s.stack?.[n] || $822ad4186ea91b18$export$9e438ffb187c02cc(e, n);
    }
}
const $822ad4186ea91b18$var$w = (e)=>{
    typeof requestAnimationFrame == "function" ? requestAnimationFrame(()=>e()) : setTimeout(e, 0);
}, $822ad4186ea91b18$var$A = (e, n, t)=>{
    $822ad4186ea91b18$var$w(()=>{
        if (!e.__ref || e.__layerExits?.[n] !== t) return;
        const r = e["ModalLayer_" + n];
        Promise.all([
            ...$822ad4186ea91b18$var$g($822ad4186ea91b18$var$y(r)),
            ...$822ad4186ea91b18$var$g($822ad4186ea91b18$var$y(r?.ModalWindow))
        ]).then(()=>$822ad4186ea91b18$export$211613be1165b5c1(e, n, t));
    });
};
function $822ad4186ea91b18$export$26a4b198775cd9ea(e, n) {
    e.__layerExits && delete e.__layerExits[n], $822ad4186ea91b18$export$fca08aa74cf12364(e, n);
    const t = e.state?.leaving;
    if (!t?.[n]) return null;
    const r = Array.from(t);
    return r[n] = null, r;
}
function $822ad4186ea91b18$export$3c75c984ac37fe91(e, n) {
    const t = e?.state, r = t?.stack || [], s = [], o = [], a = [];
    for(let i = 0; i < r.length; i++){
        const f = !!n(r[i], i);
        a[i] = !f, f ? s.push(r[i]) : o.push(r[i]);
    }
    if (!o.length) return o;
    const p = t.leaving || [], c = Array.from(p), l = [], _ = [];
    for(let i = s.length; i < r.length; i++)a[i] && $822ad4186ea91b18$var$P(e, i) ? (c[i] = r[i], l.push(i)) : (c[i] = null, _.push(i));
    const v = c.some((i, f)=>(i || null) !== (p[f] || null));
    t.update(v ? {
        stack: s,
        leaving: c
    } : {
        stack: s
    });
    for (const i of _)$822ad4186ea91b18$export$9e438ffb187c02cc(e, i);
    if (l.length) {
        e.__layerExits || (e.__layerExits = {});
        for (const i of l){
            const f = {};
            e.__layerExits[i] = f, $822ad4186ea91b18$var$A(e, i, f);
        }
    }
    return o;
}

});


parcelRegister("f3rZN", function(module, exports) {

$parcel$export(module.exports, "closeModal", () => $af5cda3675df9553$export$3f6fecd573f3fa48);

var $jtcLi = parcelRequire("jtcLi");

var $baSp1 = parcelRequire("baSp1");
function $af5cda3675df9553$export$3f6fecd573f3fa48(r) {
    const t = (0, $jtcLi.resolveModalRoot)(this);
    if (!t) return;
    const n = t.state?.stack || [];
    if (!n.length) return;
    const s = n.length - 1, c = (0, $baSp1.removeLayers)(t, r ? (o)=>o.id !== r : (o, e)=>e !== s);
    for (const o of c)if (typeof o.onClose == "function") try {
        o.onClose();
    } catch (e) {
        console.warn("[windows] onClose threw:", e);
    }
}

});

parcelRegister("3c6rH", function(module, exports) {

$parcel$export(module.exports, "closeAllModals", () => $25377e153437e853$export$8d2660641b6fb76a);

var $jtcLi = parcelRequire("jtcLi");

var $baSp1 = parcelRequire("baSp1");
function $25377e153437e853$export$8d2660641b6fb76a() {
    const e = (0, $jtcLi.resolveModalRoot)(this);
    if (!e) return;
    const t = (0, $baSp1.removeLayers)(e, ()=>!1);
    for(let o = t.length - 1; o >= 0; o--){
        const r = t[o];
        if (typeof r?.onClose == "function") try {
            r.onClose();
        } catch (l) {
            console.warn("[windows] onClose threw:", l);
        }
    }
}

});

parcelRegister("cfoKj", function(module, exports) {

$parcel$export(module.exports, "confirmDialog", () => $8eaa14c27a5e309a$export$8f50df58f957fd19);
function $8eaa14c27a5e309a$export$8f50df58f957fd19(e) {
    const n = typeof e == "string" ? {
        message: e
    } : e || {};
    return this.call("openModal", {
        ...n,
        template: "confirm"
    });
}

});

parcelRegister("kQT84", function(module, exports) {

$parcel$export(module.exports, "alertDialog", () => $f2e36d7b61860dd6$export$50ac3e8044276aa7);
function $f2e36d7b61860dd6$export$50ac3e8044276aa7(e) {
    const t = typeof e == "string" ? {
        message: e
    } : e || {};
    return this.call("openModal", {
        ...t,
        template: "alert"
    });
}

});

parcelRegister("7uZAa", function(module, exports) {

$parcel$export(module.exports, "promptDialog", () => $575b1ab1c0087f64$export$8de5dfaa2c6427c7);
function $575b1ab1c0087f64$export$8de5dfaa2c6427c7(t) {
    const e = typeof t == "string" ? {
        message: t
    } : t || {};
    return this.call("openModal", {
        ...e,
        template: "prompt"
    });
}

});



parcelRegister("9cDO9", function(module, exports) {

$parcel$export(module.exports, "prefetchSlotRoute", () => $6b341d14075728d4$export$85f0938db3967848);
// PREFETCH A ROUTE THE USER IS ABOUT TO OPEN (DESIGN-WL-PAGESLOT-OPEN-SPLIT-
// SEARCH-1 — Nika 2026-09-28: "improve speed of pageslot opening from any of
// the home page widgets").
//
//   el.call('prefetchSlotRoute', route) → true when a load started
//
// A pointer resting on, or focus reaching, something that opens a route (a
// home widget, an App strip tile, a launcher tile) starts that route's lazy
// chunk load NOW — the placeholder's own `scope.prefetch` (pages/lazyPage.js)
// — so the click finds the module already in the module cache and the window
// fills in without the network round trip. It mounts nothing and writes no
// state: a prefetch the user never follows costs one warm cache entry.
//
// The route resolves through the SAME chain the PageSlot mounts from
// (`root._slotResolve`, installed by pages/main.js, then `context.pages`), so
// a prefetch can never warm a different page than the one the click opens.
// Routes with nothing lazy behind them (the shell's eager pages, an installed
// app's module page — its bundle loads with the workspace) answer false.
//
// Once per route per shell: the set of started routes lives on the SHELL ROOT
// ELEMENT (the keyboard registry's storage rule — never module scope, never a
// window global, never root STATE), and a failed load forgets its route so the
// next hover may try again. Self-contained: every read goes through `this`.
function $6b341d14075728d4$export$85f0938db3967848(route) {
    const origin = this;
    if (!route || !origin) return false;
    const host = typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    const root = origin.state && origin.state.root || host && host.state || null;
    const clean = String(route).split('?')[0].split('#')[0];
    if (!clean) return false;
    const seen = host.__slotPrefetched || (host.__slotPrefetched = new Set());
    if (seen.has(clean)) return false;
    let def = null;
    try {
        def = root && typeof root._slotResolve === 'function' && root._slotResolve(clean) || origin.context && origin.context.pages && origin.context.pages[clean] || null;
    } catch (_) {
        def = null;
    }
    const prefetch = def && def.scope && def.scope.prefetch;
    if (typeof prefetch !== 'function') return false;
    seen.add(clean);
    try {
        // The loaders ride in the definition's scope (pages/lazyPage.js).
        const started = prefetch(def.scope);
        if (started && typeof started.catch === 'function') started.catch(()=>seen.delete(clean));
    } catch (_) {
        seen.delete(clean);
        return false;
    }
    return true;
}

});

parcelRegister("k0i6b", function(module, exports) {

$parcel$export(module.exports, "setSlotSheetWidth", () => $e901d8c0496daa66$export$e2280e5aa4e37492);
// THE WINDOW'S WIDTH — remembered per PERSON (Nika 2026-09-29: "why did you
// decrease width of pageslot? maybe increase a bit so at least it takes up to
// 60-70% and add option to resize in full").
//
//   el.call('setSlotSheetWidth', 72)    // a percent of the band
//   el.call('setSlotSheetWidth', null)  // back to the default
//
// The PageSlot sheet's resize handle (canvas/components/PageSlot.js, the width
// block) writes the share of the band one floating window takes. The share
// lives on the person's user_preferences row as `slotSheetWidth` — the same
// share on every screen and every device — with this session's decision on
// `root._slotSheetWidth` (the window answers at once, even before the row has
// loaded) and this device's copy in localStorage (`symbols_slot_sheet_w`: it
// paints before the row arrives; the record wins once it has). null clears
// all three to the default, so a changed default reaches this person too.
//
// WRITES ARE DECISIONS (the home-prefs durability law; functions/homeLook.js
// states the whole contract this repeats): at once, never debounced,
// SINGLE-FLIGHT on the queue every writer of the row shares
// (`root.__navbarSaveQueue`, keyed by workspace). The update REPLACES the row,
// so the payload is a MERGE onto a FRESH read at send time; no partial copy of
// an unloaded row ever lands in the state; a read that fails sends nothing; a
// decision superseded while it waited sends nothing.
//
// Frank note: every registered export is serialized on its own (FA204), so
// this one is self-contained — the bounds restate PageSlot.js's.
function $e901d8c0496daa66$export$e2280e5aa4e37492(pct) {
    let value = null;
    if (pct != null) {
        const n = Number(pct);
        if (!isFinite(n) || typeof pct === 'boolean') {
            console.warn(`[shell] setSlotSheetWidth ignored "${String(pct)}" \u{2014} a percent of the band (30-100) or null`);
            return null;
        }
        value = Math.round(Math.max(30, Math.min(100, n)) * 10) / 10;
    }
    const self = this && typeof this === 'object' ? this : null;
    const root = self && self.state && self.state.root || null;
    if (!root || typeof root.update !== 'function') return null;
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    const patch = {
        _slotSheetWidth: value
    };
    if (prefs) patch.userPrefs = {
        ...prefs,
        slotSheetWidth: value
    };
    root.update(patch, {
        preventFetch: true
    });
    try {
        if (typeof localStorage !== 'undefined') {
            if (value == null) localStorage.removeItem('symbols_slot_sheet_w');
            else localStorage.setItem('symbols_slot_sheet_w', String(value));
        }
    } catch (err) {
        console.warn('[shell] slot sheet width cache write failed:', err && err.message);
    }
    const sdk = self && (self.sdk || self.context && self.context.sdk) || null;
    if (!sdk || typeof sdk.execute !== 'function') return null;
    const w = root.workspace;
    const key = String(w && (w.id || w._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '') || 'user';
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    root.__slotSheetWidthSeq = (root.__slotSheetWidthSeq || 0) + 1;
    const seq = root.__slotSheetWidthSeq;
    const prior = queue.get(key) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        if (seq !== root.__slotSheetWidthSeq) return null;
        // PER-PATH PATCH — names only `slotSheetWidth`; `null` CLEARS the key
        // (unset), never stored as a literal null (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', value === null ? {
            patch: {
                unset: [
                    'slotSheetWidth'
                ]
            }
        } : {
            patch: {
                set: {
                    slotSheetWidth: value
                }
            }
        });
        if (seq === root.__slotSheetWidthSeq) {
            const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
            root.update({
                userPrefs: now ? {
                    ...now,
                    slotSheetWidth: value
                } : row && typeof row === 'object' ? row : {
                    slotSheetWidth: value
                }
            }, {
                preventFetch: true
            });
        }
        return row;
    });
    queue.set(key, task);
    return task.catch((err)=>{
        console.warn('[shell] user_preferences slotSheetWidth save failed:', err && err.message);
        return null;
    });
}

});

parcelRegister("5MRhO", function(module, exports) {

$parcel$export(module.exports, "dashboardWidgetForRoute", () => $436ac4f8193340e2$export$d0f56c21c81a05ff);
$parcel$export(module.exports, "HOME_WIDGET_DRAG_MIME", () => $436ac4f8193340e2$export$489504b11efc0b28);
$parcel$export(module.exports, "stampLauncherDashboardDrag", () => $436ac4f8193340e2$export$5c56b9ac5685b4f7);
$parcel$export(module.exports, "isHomeWidgetVisibleOnGrid", () => $436ac4f8193340e2$export$2b2bcbe34372cd31);
$parcel$export(module.exports, "isLauncherDashboardDrag", () => $436ac4f8193340e2$export$6c6bc17a4813a3bc);
$parcel$export(module.exports, "addLauncherAppToDashboard", () => $436ac4f8193340e2$export$c00daf8952419631);
$parcel$export(module.exports, "isCustomAppTile", () => $436ac4f8193340e2$export$5e16724c7c0c7f33);
$parcel$export(module.exports, "searchAppTileMenuItems", () => $436ac4f8193340e2$export$aa9a7af9a4e612e8);
$parcel$export(module.exports, "searchAppTileMenuAction", () => $436ac4f8193340e2$export$dc961707207f992e);
// Apps-launcher tile context menu (2026-07-30 per Nika "allow right click on
// those dropdown icons and allow to add on dashboard") — right-clicking a
// SearchAppTile opens the house ContextDropdown with Open / Open in side view
// / Add to dashboard / Pin to navbar. Same registered itemsFn/actionFn
// contract as navbarTabMenu.js; `appTile` rides the dropdown state so the
// rows know which tile was targeted.
// Direct-import contract (same as navSearchResultMenu.js): these are plain
// exports built for exactly this cross-menu reuse — the pin lane is the
// per-user pinnedCustom prefs, the same one drag-to-navbar commits through.
// Bare shared-library import, not a deep navbarTabMenu.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0). Deferred-call
// wrappers, not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $436ac4f8193340e2$var$shellNavbarTabPrefs = (...args)=>(0, $1X0Je.default).functions.navbarTabPrefs(...args);
const $436ac4f8193340e2$var$shellToggleCustomNavbarPin = (...args)=>(0, $1X0Je.default).functions.toggleCustomNavbarPin(...args);
// House app routes → their home-dashboard app-icon widget ids (the
// AppStudioWidget… family in pages/main.js — HOME_CATALOG's `app-*` set).
// Tiles whose route isn't here (module pages, admin surfaces, canvas views)
// simply don't offer the dashboard row — there is no widget to add.
const $436ac4f8193340e2$var$ROUTE_WIDGET = {
    '/studio': 'app-studio',
    // /tasks is the canonical route (tickets→tasks rename 2026-08-06); the
    // widget id stays the internal 'app-tickets'. '/tickets' = legacy alias.
    '/tasks': 'app-tickets',
    '/tickets': 'app-tickets',
    '/chat': 'app-chat',
    '/calendar': 'app-calendar',
    '/reminders': 'app-reminders',
    '/meet': 'app-meet',
    '/announcements': 'app-broadcast',
    // /notes is the canonical route (documents→notes rename 2026-08-06); the
    // widget id stays the internal 'app-documents'. '/documents' = legacy alias.
    '/notes': 'app-documents',
    '/documents': 'app-documents',
    '/agents': 'app-agents',
    '/team-and-agents': 'app-team',
    '/analytics': 'app-analytics',
    '/workspace-analytics': 'app-analytics',
    '/team-members': 'app-people',
    '/system-status': 'app-health',
    '/system': 'app-health'
};
const $436ac4f8193340e2$export$d0f56c21c81a05ff = (route)=>$436ac4f8193340e2$var$ROUTE_WIDGET[String(route || '')] || null;
const $436ac4f8193340e2$export$489504b11efc0b28 = 'application/x-symbols-home-widget';
const $436ac4f8193340e2$export$5c56b9ac5685b4f7 = (event, route)=>{
    const widgetId = $436ac4f8193340e2$export$d0f56c21c81a05ff(route);
    const transfer = event?.dataTransfer;
    if (!widgetId || !transfer) return null;
    try {
        transfer.setData('text/x-home-widget-id', widgetId);
        transfer.setData($436ac4f8193340e2$export$489504b11efc0b28, '1');
        // Preserve the shared ref source's copy/link policy. Home asks for `copy`,
        // which is already valid for the existing page-ref drag.
        return widgetId;
    } catch (_) {
        return null;
    }
};
const $436ac4f8193340e2$export$2b2bcbe34372cd31 = (id)=>{
    if (!id || typeof document === 'undefined') return false;
    const sel = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(String(id)) : String(id);
    const item = document.querySelector(`.home-grid > [data-module-widget][data-widget-id="${sel}"]`) || document.querySelector(`.home-grid > [data-widget-id="${sel}"]`);
    if (!item) return false;
    if (item.style && item.style.display === 'none') return false;
    // `hide:` hides through a class, so the computed display is the answer.
    const view = item.ownerDocument && item.ownerDocument.defaultView;
    if (view && view.getComputedStyle) return view.getComputedStyle(item).display !== 'none';
    return true;
};
const $436ac4f8193340e2$export$6c6bc17a4813a3bc = (types)=>{
    if (!types) return false;
    return Array.from(types).includes($436ac4f8193340e2$export$489504b11efc0b28);
};
const $436ac4f8193340e2$var$_notifyDashboardPlacement = (el, payload)=>{
    try {
        el.call('openNotification', payload);
    } catch (_) {
    // The app switcher can render on a minimal standalone surface where the
    // shell toast mount is not present. The navigation/add intent remains safe.
    }
};
function $436ac4f8193340e2$export$c00daf8952419631(route) {
    const root = this?.state?.root;
    const widgetId = $436ac4f8193340e2$export$d0f56c21c81a05ff(route);
    if (!root || !widgetId || typeof root.update !== 'function') {
        $436ac4f8193340e2$var$_notifyDashboardPlacement(this, {
            type: 'info',
            title: this.call('polyglot', 'shell.launcherTileMenu.notOnHome'),
            message: this.call('polyglot', 'shell.launcherTileMenu.notOnHomeBody')
        });
        return {
            status: 'unsupported',
            widgetId: null
        };
    }
    // On the board already? The board's composed hidden map answers once it has
    // resolved: `!!hidden[id]`, an ABSENT key being a default-visible widget
    // (the general default map carries keys for hidden ids only). Before the
    // board resolves nobody knows, and the live grid's own duplicate check
    // answers at the drop (`_consumeAddWidgetIntent`). Restated in the menu's
    // row below — every export here is serialized on its own (FA204).
    const hiddenMap = root._homeHiddenWidgets;
    if (hiddenMap && typeof hiddenMap === 'object' && !hiddenMap[widgetId]) {
        $436ac4f8193340e2$var$_notifyDashboardPlacement(this, {
            type: 'info',
            title: this.call('polyglot', 'shell.launcherTileMenu.alreadyOnHome'),
            message: this.call('polyglot', 'shell.launcherTileMenu.alreadyOnHomeBody')
        });
        return {
            status: 'exists',
            widgetId: widgetId
        };
    }
    // GridContainer consumes this only after GridStack is live, then routes
    // through its existing restore/persistence path. Set it before navigation so
    // the intent survives the route handoff.
    root.update({
        _homeAddWidget: widgetId
    }, {
        preventFetch: true
    });
    try {
        this.call('closeDropdown', 'searchApps');
    } catch (_) {
    /* the action also works from a context menu outside the launcher layer */ }
    try {
        this.router('/', this.getRoot());
    } catch (_) {
    /* already on Home or router unavailable — GridContainer sees the intent */ }
    return {
        status: 'queued',
        widgetId: widgetId
    };
}
const $436ac4f8193340e2$export$5e16724c7c0c7f33 = (tile)=>!!tile && (tile.kind === 'extension' || !!tile.projectId || /^\/x\//.test(String(tile.route || '')));
const $436ac4f8193340e2$export$aa9a7af9a4e612e8 = function(root) {
    const cm = root && root.contextDropdown;
    if (!cm || !cm.open || !cm.appTile) return [];
    const t = cm.appTile;
    // i18n — every `label` here is a polyglot KEY. ContextDropdown's row
    // renders `el.call('polyglot', s.label || '')`, so a key resolves and a
    // non-key would pass through — these are all shipped chrome, so all keys.
    const items = [
        {
            key: 'open',
            action: 'open',
            label: 'shell.launcherTileMenu.open'
        }
    ];
    // Side view only where a split can actually happen — same classifier +
    // open-primary conditions as the navbar tab menu (navbarTabMenu.js).
    let fullPage = false;
    try {
        fullPage = !!(this.call('isCanvasRoute', t.route) || this.call('isFullPageRoute', t.route));
    } catch (_) {
        fullPage = false;
    }
    if (!fullPage && !!root._canvasSlot && root._canvasSlot !== t.route) items.push({
        key: 'sideview',
        action: 'sideview',
        label: 'shell.launcherTileMenu.sideView'
    });
    // Custom, AI-built apps are authored in /add-app — one extension is one
    // thread there — so Edit takes you back to that app's own thread
    // (2026-08-02 per Nika "on custom made apps you can add context menu edit").
    // House apps have no authoring surface and get no Edit row.
    if ($436ac4f8193340e2$export$5e16724c7c0c7f33(t)) items.push({
        key: 'edit',
        action: 'edit',
        label: 'shell.launcherTileMenu.edit'
    });
    const widgetId = $436ac4f8193340e2$export$d0f56c21c81a05ff(t.route);
    if (widgetId) {
        // ONE question: is the widget on the board now? A workspace panel set
        // decides only the ids it names, and a person's add always wins over it —
        // their saved choice sits on top of the panel base, on every workspace
        // kind (DESIGN-WL-HOME-DEFAULTS-ALL-WORKSPACES-1; the "a panel set
        // overrides the user's choices on every resync" premise this row used to
        // read has been false since 2026-08-01). So the row reads the board's
        // composed hidden map — `!!hidden[id]`, an ABSENT key being a
        // default-visible widget — and, before the board resolves, is offered: the
        // add path's own duplicate check answers at the grid.
        const hiddenMap = root._homeHiddenWidgets;
        const alreadyOnDashboard = !!hiddenMap && typeof hiddenMap === 'object' && !hiddenMap[widgetId];
        if (!alreadyOnDashboard) items.push({
            key: 'adddash',
            action: 'adddash',
            label: 'shell.launcherTileMenu.addToDashboard'
        });
    }
    // Pin/unpin on the header tab strip (2026-08-06 per Nika "add more related
    // options to context menu to items in searchdropdown" + the drag-to-navbar
    // twin). A pin on a route the base navbar already shows is harmless —
    // applyNavbarTabPrefs filters custom rows whose path is in the base set.
    const navPath = String(t.route || '').split(/[?#]/)[0];
    if (navPath) {
        const pinned = $436ac4f8193340e2$var$shellNavbarTabPrefs(root).pinnedCustom.some((c)=>c && c.path === navPath);
        items.push({
            key: 'navpin',
            action: 'navpin',
            label: pinned ? 'shell.launcherTileMenu.unpin' : 'shell.launcherTileMenu.pin'
        });
    }
    return items;
};
const $436ac4f8193340e2$export$dc961707207f992e = function(action) {
    const root = this.state.root;
    const t = root.contextDropdown?.appTile || null;
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    if (!t) return;
    if (action === 'open') {
        this.call('closeDropdown', 'searchApps');
        this.call('selectAppFromSwitcher', t.route);
        return;
    }
    if (action === 'sideview') {
        this.call('closeDropdown', 'searchApps');
        try {
            this.call('openAppPage', t.route, {
                preferSlot: true,
                split: true
            });
        } catch (_) {
            this.router(t.route, this.getRoot());
        }
        return;
    }
    if (action === 'edit') {
        // Identity: the stamped projectId, else the `/x/<key>` route segment (a
        // tile composed before the stamp landed). Both are what /add-app keys its
        // thread on via `_addAppProjectId` — see state-app.js "one extension = one
        // thread". Setting it BEFORE the route means a fresh /add-app mount reads
        // the right extension on first render instead of opening a blank thread.
        const projectId = t.projectId || String(t.route || '').replace(/^\/x\//, '').split(/[?#/]/)[0] || '';
        if (!projectId) return;
        this.call('closeDropdown', 'searchApps');
        root.update({
            _addAppProjectId: projectId
        }, {
            preventFetch: true
        });
        this.call('openAppPage', '/add-app');
        return;
    }
    if (action === 'navpin') {
        const navPath = String(t.route || '').split(/[?#]/)[0];
        if (navPath) $436ac4f8193340e2$var$shellToggleCustomNavbarPin(root, {
            path: navPath,
            label: t.title || navPath
        });
        return;
    }
    if (action === 'adddash') this.call('addLauncherAppToDashboard', t.route);
};

});

parcelRegister("j97dQ", function(module, exports) {

$parcel$export(module.exports, "navSearchResultMenuItems", () => $df0475ceabf91421$export$375b85872b10abb0);
$parcel$export(module.exports, "navSearchResultMenuAction", () => $df0475ceabf91421$export$ff46442dd8c4818f);
// Global-search-result row context menu (2026-08-02 per Nika "add in
// searchdropdown items pin to navbar in context menu") — right-clicking a
// NavSearchResultItem (components/NavSearchDropdown.js, rendered inside
// HeaderSearch's and IntranetAppHeader's search dropdowns) opens the house
// ContextDropdown with a single Pin/Unpin row. Same registered
// itemsFn/actionFn contract as shared/functions/navbarTabMenu.js (base tabs)
// and functions/searchAppTileMenu.js (apps-launcher tiles); `searchResult`
// rides the dropdown state so the rows know which row was targeted.
//
// A search result's route is never part of the base HEADER_TABS /
// workspaceSettings.navbar list HeaderTabs renders, so pinning one is a
// CUSTOM navbar pin (navbarTabMenu.js's `pinnedCustom`) — the SAME per-user ×
// per-workspace prefs bag the base-tab pin/remove/reorder menu already
// writes to, not a second mechanism. toggleCustomNavbarPin owns the
// toggle + persistence; applyNavbarTabPrefs (consumed by HeaderTabs) is what
// turns a pinned result into a real, visible navbar tab.
// Bare shared-library import, not a deep navbarTabMenu.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0). Deferred-call
// wrappers, not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $df0475ceabf91421$var$shellNavbarTabPrefs = (...args)=>(0, $1X0Je.default).functions.navbarTabPrefs(...args);
const $df0475ceabf91421$var$shellToggleCustomNavbarPin = (...args)=>(0, $1X0Je.default).functions.toggleCustomNavbarPin(...args);
const $df0475ceabf91421$export$375b85872b10abb0 = function(root) {
    const cm = root && root.contextDropdown;
    const result = cm && cm.searchResult;
    if (!cm || !cm.open || !result || !result.path) return [];
    const pinned = $df0475ceabf91421$var$shellNavbarTabPrefs(root).pinnedCustom.some((c)=>c.path === result.path);
    return [
        {
            key: 'pin',
            action: 'pin',
            label: pinned ? 'shell.navSearchMenu.unpin' : 'shell.navSearchMenu.pin'
        }
    ];
};
const $df0475ceabf91421$export$ff46442dd8c4818f = async function(action) {
    const root = this.state.root;
    const result = root.contextDropdown?.searchResult || null;
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    if (action === 'pin' && result?.path) {
        await $df0475ceabf91421$var$shellToggleCustomNavbarPin(root, result);
        // Collapse the search dropdown too — same post-action closeDropdown
        // convention searchAppTileMenuAction uses for every one of its rows. The
        // one-shot blur timer that was holding it open for this menu (see
        // HeaderSearch.js / IntranetAppHeader.js onBlur) already resolved
        // (skipped) the instant the menu opened, so nothing else will ever
        // re-check and close it; the pinned result now lives in the real navbar
        // (HeaderTabs), so retracting the transient panel surfaces that instead
        // of leaving a stale results list on screen.
        this.call('closeNavSearch');
    }
};

});

parcelRegister("3GI9o", function(module, exports) {

$parcel$export(module.exports, "startDemo", () => $2af78ab1366c9b9b$export$ed5b6110725779f6);
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $2af78ab1366c9b9b$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $2af78ab1366c9b9b$export$ed5b6110725779f6 = async (email)=>$2af78ab1366c9b9b$var$shellGetSDK().startDemo({
        email: email
    });

});

parcelRegister("cY3NJ", function(module, exports) {

$parcel$export(module.exports, "enterDemo", () => $970e09772a7f5065$export$925a5e7e83cc6ea6);
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $970e09772a7f5065$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $970e09772a7f5065$export$925a5e7e83cc6ea6 = async ()=>$970e09772a7f5065$var$shellGetSDK().enterDemo();

});

parcelRegister("cZH4f", function(module, exports) {

$parcel$export(module.exports, "demoHandoff", () => $975c96d9109b8ee4$export$d22a754d6303a420);

var $1X0Je = parcelRequire("1X0Je");

var $hkFDz = parcelRequire("hkFDz");
const $975c96d9109b8ee4$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $975c96d9109b8ee4$var$shellWorkspaceOrigin = (...args)=>(0, $1X0Je.default).functions.workspaceOrigin(...args);
const $975c96d9109b8ee4$export$d22a754d6303a420 = async ()=>{
    if (typeof window === 'undefined') return false;
    const sdk = $975c96d9109b8ee4$var$shellGetSDK();
    const session = await sdk.getSession();
    const accessToken = session?.access_token;
    if (!accessToken) return false;
    const refreshToken = session?.refresh_token || '';
    // `expires_at` is the TokenManager's epoch-ms expiry; magic-callback reads
    // `access_exp` as epoch-ms and derives `expires_in` from it. Pass it through
    // when present so the persisted token carries an accurate lifetime.
    const accessExp = Number(session?.expires_at) || 0;
    const params = new URLSearchParams();
    params.set('access_token', accessToken);
    if (refreshToken) params.set('refresh_token', refreshToken);
    if (accessExp) params.set('access_exp', String(accessExp));
    // Land the user on the shell home after the callback persists the session.
    params.set('redirect', '/');
    const origin = $975c96d9109b8ee4$var$shellWorkspaceOrigin() || 'https://my.symbols.app';
    // ARRIVAL LANGUAGE HINT (WS-ARRIVAL-URL-CARRIES-NO-LANGUAGE-HINT-1). The
    // shell's own boot loader resolves its FIRST-PAINT language from `?lang=`,
    // then from two caches keyed by HOST. demo.symbols.app and my.symbols.app
    // are different hosts, so neither cache has an entry there and the landing
    // frame is English — even though this origin runs the whole shell and
    // resolved the demo workspace's language long before the claim click.
    //
    // `__smblsBootLangPublished` is the RESOLVED language and only that: the
    // head script's own first-paint guess writes `__smblsBootLang`, while
    // app.js `_publishBootLang(root.lang)` is the sole writer of this key. So
    // a shell that never settled a language stamps nothing and the destination
    // falls through to its own levels — a guessed hint is worse than none.
    const target = (0, $hkFDz.appendBootLangHint)(`${origin}/auth/magic-callback#${params.toString()}`, window.__smblsBootLangPublished);
    // Full cross-origin navigation (NOT el.router) — a different origin must do
    // a hard load so the shell boots fresh and magic-callback's onRender reads
    // the hash before the SDK TokenManager hydrates from (empty) my-origin
    // localStorage.
    window.location.assign(target);
    return true;
};

});
parcelRegister("hkFDz", function(module, exports) {

$parcel$export(module.exports, "appendBootLangHint", () => $c9e49a358e1379e0$export$6b791ca19a3a220b);
$parcel$export(module.exports, "writeBootLangHint", () => $c9e49a358e1379e0$export$f314ada6ec5cc507);
$parcel$export(module.exports, "withBootLangHint", () => $c9e49a358e1379e0$export$d09fe983449777a9);
// bootLang — the boot-language seam: the one place the shell hands the
// PRE-BUNDLE loader (index.html) a language it can read synchronously, on the
// next load, with no network request before first paint.
// (WS-BOOT-LOADER-PAINTS-ENGLISH-ONLY-BEFORE-THE-BUNDLE-1.)
//
// WHY A CACHE AT ALL. The overlay in index.html is the FIRST paint. It cannot
// read root state and it cannot await a lookup without painting the wrong
// language first and correcting it after — the exact flash the theme pre-seed
// beside it exists to prevent. So the only correct answer is a synchronous
// read of what we learned LAST time. This is the same shape, and the same
// reasoning, as `cacheWhitelabelBootIdentity` in whitelabelBrand.js.
//
// ⚠️ WHAT THIS MAY NOT BECOME (UI-LANG-WORKSPACE-DECIDES-ENGLISH-DEFAULT-1;
// THE LAW lives in shared/functions/languages.js `resolveLang`). A workspace
// renders in the language IT is set to; a workspace set to nothing renders
// English. A person's account preference and this device's `localStorage.lang`
// never decide a workspace's interface language. So:
//   • The entry is keyed by the ARRIVAL'S WORKSPACE SCOPE, never by the
//     account and never once per browser. A scope with no entry reads English
//     — a MISS is the law's default, never another workspace's language.
//   • Nothing here is a CHOICE. `setLang`'s `transient` contract already
//     refuses to persist a RESOLVED language to `localStorage.lang` or to the
//     account, precisely so a workspace's rule cannot follow a member out of
//     the workspace that made it. This cache cannot do that either: it is
//     per host AND per workspace scope, so it is unreadable from anywhere the
//     law would not have answered the same way.
//
// HOST-KEYED, like `wlBoot:` — one browser can visit several white-label
// tenants, and a shared key would paint one tenant's language on another's
// domain.
//
// BOUNDED — at most 8 scopes per host, oldest dropped first (insertion order
// on a plain object). A language code is two bytes; the cap is there so a
// browser that visits many workspaces cannot grow this without limit.
//
// Best-effort by construction: a private-mode or quota-full localStorage must
// never break a boot, so every failure is swallowed and the next boot falls
// back to the next level of the precedence (the tenant brand, else English).
//
// ── FA204 / frank trap ────────────────────────────────────────────────────
// `functions/` is a frank SECTION BARREL: every export becomes its own
// emitted entry, and a bare module-scope const read from inside an exported
// function is unresolvable in the eval-revived runtime. So the key prefix,
// the shipped-language list and the entry cap are INLINED in every export
// that needs them — the same shape `languages.js`, `setLang.js` and
// `activeWorkspacePointer.js` use for their own lists.
/**
 * The scope key an arrival's boot language is cached under — the workspace
 * identity the loader can know SYNCHRONOUSLY, before any bundle.
 *
 * Mirrors `resolveActiveWorkspace`'s own precedence (shared/functions/
 * activeWorkspacePointer.js), because that is the function that decides the
 * REAL scope once the live boot resolves. Any drift means a warm boot either
 * misses its own entry (safe, just no win) or — far worse — reads an entry
 * the live boot would not have used.
 *
 *   • MWT on and the URL carries `/w/<org>[/<seg2>]` → the URL wins, exactly
 *     as the live resolver's URL branch does: `u:<org>` or `u:<org>/<seg2>`.
 *     The URL is NOT blended with the pointer, so an arrival at a workspace
 *     that has no entry yet CANNOT fall through to the previous workspace's.
 *   • otherwise (MWT off, or no `/w/` prefix) → the tab's own
 *     active-workspace pointer, which is what the live resolver uses then:
 *     `p:<id>`. A switch moves the pointer, so it is a different key.
 *   • neither → `null`: no scope is knowable, so there is no cache level and
 *     the precedence falls to the tenant brand, else English.
 *
 * Pure. The caller supplies the inputs; nothing here reads the document.
 *
 * @param {object} sources
 * @param {string} [sources.pathname]   `location.pathname`
 * @param {string} [sources.pointer]    the tab's active-workspace pointer id
 * @param {boolean} [sources.mwtEnabled] default true (the shipped default)
 * @returns {string|null}
 */ const $c9e49a358e1379e0$export$513811fd8569a95e = ({ pathname: pathname, pointer: pointer, mwtEnabled: mwtEnabled = true } = {})=>{
    // The SAME two expressions `getWorkspaceRawSegments` uses — inlined, never
    // read off that sibling, so the emitted entry resolves (FA204/FA001).
    const ONE = /^\/w\/([a-z0-9-]{1,48})(?=[/?#]|$)/;
    const TWO = /^\/w\/([a-z0-9-]{1,48})\/([A-Za-z0-9_-]{1,64})(?=[/?#]|$)/;
    const path = typeof pathname === 'string' ? pathname : '';
    if (mwtEnabled && path) {
        const two = path.match(TWO);
        if (two) return 'u:' + two[1].toLowerCase() + '/' + two[2].toLowerCase();
        const one = path.match(ONE);
        if (one) return 'u:' + one[1].toLowerCase();
    }
    const id = typeof pointer === 'string' ? pointer.trim() : '';
    return id ? 'p:' + id : null;
};
const $c9e49a358e1379e0$export$a528c3fa644fc768 = (hostname, scope, { store: store } = {})=>{
    const SUPPORTED = [
        'en',
        'ka'
    ];
    try {
        const bag = store || (typeof globalThis !== 'undefined' ? globalThis.localStorage : null) || null;
        if (!bag || !hostname || !scope) return null;
        const raw = typeof bag.getItem === 'function' ? bag.getItem('wsBootLang:' + hostname) : bag['wsBootLang:' + hostname];
        const map = JSON.parse(raw || 'null');
        if (!map || typeof map !== 'object' || Array.isArray(map)) return null;
        const code = map[scope];
        return typeof code === 'string' && SUPPORTED.indexOf(code) !== -1 ? code : null;
    } catch (_) {
        return null;
    }
};
const $c9e49a358e1379e0$export$c609a6d3604c0117 = (hostname, scope, lang, { store: store } = {})=>{
    const SUPPORTED = [
        'en',
        'ka'
    ];
    const MAX_SCOPES = 8;
    try {
        const bag = store || (typeof globalThis !== 'undefined' ? globalThis.localStorage : null) || null;
        if (!bag || !hostname || !scope) return false;
        if (typeof lang !== 'string' || SUPPORTED.indexOf(lang) === -1) return false;
        const key = 'wsBootLang:' + hostname;
        const get = (k)=>typeof bag.getItem === 'function' ? bag.getItem(k) : bag[k];
        const set = (k, v)=>{
            if (typeof bag.setItem === 'function') bag.setItem(k, v);
            else bag[k] = v;
        };
        let map = null;
        try {
            const parsed = JSON.parse(get(key) || 'null');
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) map = parsed;
        } catch (_) {
            map = null;
        }
        const next = {};
        for(const k in map || {}){
            if (k === scope) continue;
            const code = map[k];
            if (typeof code === 'string' && SUPPORTED.indexOf(code) !== -1) next[k] = code;
        }
        // Re-inserting the scope last keeps insertion order == recency, so the
        // drop below removes the LEAST recently resolved scope.
        next[scope] = lang;
        const keys = Object.keys(next);
        const trimmed = {};
        for (const k of keys.slice(Math.max(0, keys.length - MAX_SCOPES)))trimmed[k] = next[k];
        set(key, JSON.stringify(trimmed));
        return true;
    } catch (_) {
        return false;
    }
};
const $c9e49a358e1379e0$export$6b791ca19a3a220b = (url, lang)=>{
    const SUPPORTED = [
        'en',
        'ka'
    ];
    if (typeof url !== 'string' || !url) return url;
    if (typeof lang !== 'string' || SUPPORTED.indexOf(lang) === -1) return url;
    const cut = url.indexOf('#');
    const head = cut === -1 ? url : url.slice(0, cut);
    const frag = cut === -1 ? '' : url.slice(cut);
    const q = head.indexOf('?');
    // `(^|&)lang=` and not a bare `lang=`: `?slang=en` is a different parameter.
    if (q !== -1 && /(^|&)lang=/.test(head.slice(q + 1))) return url;
    return head + (q === -1 ? '?' : '&') + 'lang=' + lang + frag;
};
const $c9e49a358e1379e0$export$e8ab84d9d26507d6 = (win = typeof window !== 'undefined' ? window : null)=>{
    try {
        if (!win || !win.location) return null;
        // The MWT read `mwtFlag.js` performs, inlined: `?mwt` wins over
        // `localStorage.mwt`, and the shipped default is ON.
        const q = new win.URLSearchParams(win.location.search || '').get('mwt');
        const stored = (()=>{
            try {
                return win.localStorage ? win.localStorage.getItem('mwt') : null;
            } catch (_) {
                return null;
            }
        })();
        const mwtEnabled = q === '1' || q === 'on' ? true : q === '0' || q === 'off' ? false : stored !== 'off';
        const pointer = (()=>{
            try {
                if (mwtEnabled && win.sessionStorage) {
                    const own = win.sessionStorage.getItem('activeWorkspace');
                    if (own) return own;
                }
                return win.localStorage ? win.localStorage.getItem('activeWorkspace') : null;
            } catch (_) {
                return null;
            }
        })();
        return $c9e49a358e1379e0$export$513811fd8569a95e({
            pathname: win.location.pathname || '',
            pointer: pointer || '',
            mwtEnabled: mwtEnabled
        });
    } catch (_) {
        return null;
    }
};
const $c9e49a358e1379e0$export$f314ada6ec5cc507 = (lang, win = typeof window !== 'undefined' ? window : null)=>{
    const SUPPORTED = [
        'en',
        'ka'
    ];
    try {
        if (!win || !win.location || typeof lang !== 'string') return false;
        if (SUPPORTED.indexOf(lang) === -1) return false;
        return $c9e49a358e1379e0$export$c609a6d3604c0117(win.location.hostname, $c9e49a358e1379e0$export$e8ab84d9d26507d6(win), lang, {
            store: win.localStorage
        });
    } catch (_) {
        return false;
    }
};
const $c9e49a358e1379e0$export$5a8b10f9024f3d36 = (win = typeof window !== 'undefined' ? window : null)=>{
    try {
        if (!win || !win.location) return null;
        return $c9e49a358e1379e0$export$a528c3fa644fc768(win.location.hostname, $c9e49a358e1379e0$export$e8ab84d9d26507d6(win), {
            store: win.localStorage
        });
    } catch (_) {
        return null;
    }
};
const $c9e49a358e1379e0$export$d09fe983449777a9 = (row, win = typeof window !== 'undefined' ? window : null)=>{
    if (!row || typeof row !== 'object') return row;
    const lang = $c9e49a358e1379e0$export$5a8b10f9024f3d36(win);
    return lang ? {
        ...row,
        loaderLang: lang
    } : row;
};

});


parcelRegister("7uQG1", function(module, exports) {

$parcel$export(module.exports, "aiCreateFolder", () => $5754323c21438f36$export$c39dcbd14d5563a8);
$parcel$export(module.exports, "aiRenameFile", () => $5754323c21438f36$export$f8457fdb0c1c3b2e);
$parcel$export(module.exports, "aiDeleteFile", () => $5754323c21438f36$export$b4503338f927d984);
$parcel$export(module.exports, "aiDuplicateFile", () => $5754323c21438f36$export$7848dc229b3673a3);
$parcel$export(module.exports, "aiMoveFileToFolder", () => $5754323c21438f36$export$bfcc0407c5da8ab);
$parcel$export(module.exports, "aiCreateNote", () => $5754323c21438f36$export$ac55dbd365223732);
$parcel$export(module.exports, "aiRenameNote", () => $5754323c21438f36$export$2631626d56cea84d);
$parcel$export(module.exports, "aiDeleteNote", () => $5754323c21438f36$export$4997dc0d83171264);
$parcel$export(module.exports, "columnKeyFor", () => $5754323c21438f36$export$f5ed03c615f60577);
$parcel$export(module.exports, "aiMoveTicket", () => $5754323c21438f36$export$c1d7b08a08e81b3a);
$parcel$export(module.exports, "aiUndoCreated", () => $5754323c21438f36$export$8418d404615cb53b);
$parcel$export(module.exports, "aiDeleteTicket", () => $5754323c21438f36$export$55558d9b359f055);
$parcel$export(module.exports, "aiCreateTicket", () => $5754323c21438f36$export$c87a101953c2f8b3);
$parcel$export(module.exports, "aiUpdateTicket", () => $5754323c21438f36$export$3ca088d0f29d4721);
$parcel$export(module.exports, "aiAssignTicket", () => $5754323c21438f36$export$ee828b0b35250177);
$parcel$export(module.exports, "aiCreateChannel", () => $5754323c21438f36$export$978a7501ae4cf2bb);
$parcel$export(module.exports, "aiSendMessage", () => $5754323c21438f36$export$dd7dd95d1ef27458);
$parcel$export(module.exports, "aiCreateWidget", () => $5754323c21438f36$export$efa1583c651024bf);
$parcel$export(module.exports, "aiEditWidget", () => $5754323c21438f36$export$1f1f11a10c10a3e4);
$parcel$export(module.exports, "aiDeleteWidget", () => $5754323c21438f36$export$10d37e3a6e34e0e6);
// AI workspace operations — let the assistant DO what a user can do in the UI.
//
// The simone assistant is a chat alternative to the workspace UI: anything a
// user can do by clicking, the assistant should be able to do by calling a tool
// (instead of telling the user to do it manually). These thin wrappers take
// LLM-friendly flat args, resolve the target entity by id OR name from the live
// unified root state (the same lists the page snapshot shows the model), and
// reuse the EXISTING UI functions / SDK routes — so each op runs the same code
// path (optimistic state update + SDK persist) the UI uses and the change shows
// immediately.
//
// Registered via functions/index.js; invoked from the server's clientTool path
// (simoneAiTransport `_runPlatformTool` → el.call). `this` is the workspace shell
// root element (window.__wsRoot): `this.state.root` is the unified state,
// `this.call(fn,…)` reaches every registered package function, `this.sdk` / the
// getSDK() proxy is the SDK.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $5754323c21438f36$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $5754323c21438f36$var$norm = (v)=>String(v == null ? '' : v).trim().toLowerCase();
const $5754323c21438f36$var$ok = (extra)=>({
        ok: true,
        ...extra
    });
const $5754323c21438f36$var$fail = (message)=>({
        ok: false,
        error: message
    });
// Resolve an entity from a root list by exact id (id/ticketId/number), then by
// case-insensitive label (name/title/…). The AI normally passes an id from the
// page snapshot, but tolerate a name so "duplicate My notes" works directly.
function $5754323c21438f36$var$resolve(list, target, nameKeys = [
    'name',
    'title'
]) {
    if (!Array.isArray(list) || target == null || target === '') return null;
    const t = String(target);
    const byId = list.find((x)=>String(x?.id) === t || String(x?.ticketId) === t || String(x?.number) === t);
    if (byId) return byId;
    const tn = $5754323c21438f36$var$norm(target);
    return list.find((x)=>nameKeys.some((k)=>$5754323c21438f36$var$norm(x?.[k]) === tn)) || null;
}
const $5754323c21438f36$var$rowId = (res)=>{
    const row = res?.data || res;
    if (!row) return null;
    return row.id || (Array.isArray(row) ? row[0] && row[0].id : null);
};
const $5754323c21438f36$export$c39dcbd14d5563a8 = async function(name) {
    const id = await this.call('createCanvasFolder', name || 'New folder');
    return id ? $5754323c21438f36$var$ok({
        created: {
            kind: 'folder',
            id: id,
            name: name || 'New folder'
        }
    }) : $5754323c21438f36$var$fail('Could not create the folder.');
};
const $5754323c21438f36$export$f8457fdb0c1c3b2e = async function(target, newName) {
    const node = $5754323c21438f36$var$resolve(this.state.root?.fileNodes, target);
    if (!node) return $5754323c21438f36$var$fail(`No file or folder named "${target}" found.`);
    if (!newName) return $5754323c21438f36$var$fail('A new name is required.');
    const renamed = await this.call('commitRenameNode', node.id, String(newName));
    if (renamed === false) return $5754323c21438f36$var$fail(`Could not rename "${node.name}".`);
    return $5754323c21438f36$var$ok({
        renamed: {
            id: node.id,
            from: node.name,
            to: String(newName)
        }
    });
};
const $5754323c21438f36$export$b4503338f927d984 = async function(target) {
    const node = $5754323c21438f36$var$resolve(this.state.root?.fileNodes, target);
    if (!node) return $5754323c21438f36$var$fail(`No file or folder named "${target}" found.`);
    const deleted = await this.call('deleteCanvasNode', node.id);
    if (deleted === false) return $5754323c21438f36$var$fail(`Could not delete "${node.name}".`);
    return $5754323c21438f36$var$ok({
        deleted: {
            id: node.id,
            name: node.name
        }
    });
};
const $5754323c21438f36$export$7848dc229b3673a3 = async function(target, newName) {
    const root = this.state.root;
    const node = $5754323c21438f36$var$resolve(root?.fileNodes, target);
    if (!node) return $5754323c21438f36$var$fail(`No file or folder named "${target}" found.`);
    const name = newName && String(newName).trim() || `${node.name} copy`;
    // Reuse the same blob (file_id/url) — duplicating the row, not the storage object.
    const payload = {
        kind: node.kind || 'file',
        name: name,
        parent_id: node.parentId || null,
        x: (Number(node.x) || 0) + 24,
        y: (Number(node.y) || 0) + 24,
        scope: node.scope || root.filesScope || 'shared',
        created_by: root.currentUserEmail || null,
        file_id: node.fileId || null,
        url: node.url || null,
        mime_type: node.mime || null,
        size: node.size || null,
        doc_id: node.docId || null
    };
    let id;
    try {
        id = $5754323c21438f36$var$rowId(await $5754323c21438f36$var$shellGetSDK().execute('workspaceProject.fileCanvas', 'create', {
            payload: payload
        }));
    } catch (e) {
        return $5754323c21438f36$var$fail('Duplicate failed: ' + (e?.message || e));
    }
    if (!id) return $5754323c21438f36$var$fail('Duplicate failed (no id returned).');
    try {
        root.update({
            fileNodes: [
                ...root.fileNodes || [],
                {
                    ...node,
                    id: id,
                    name: name,
                    x: payload.x,
                    y: payload.y
                }
            ]
        });
    } catch (_) {}
    return $5754323c21438f36$var$ok({
        duplicated: {
            from: node.name,
            to: name,
            id: id
        }
    });
};
const $5754323c21438f36$export$bfcc0407c5da8ab = async function(target, folderTarget) {
    const root = this.state.root;
    const node = $5754323c21438f36$var$resolve(root?.fileNodes, target);
    if (!node) return $5754323c21438f36$var$fail(`No file or folder named "${target}" found.`);
    let folderId = null;
    if (folderTarget && ![
        'root',
        'desktop',
        'top',
        'home'
    ].includes($5754323c21438f36$var$norm(folderTarget))) {
        const folder = $5754323c21438f36$var$resolve((root?.fileNodes || []).filter((n)=>n.kind === 'folder'), folderTarget);
        if (!folder) return $5754323c21438f36$var$fail(`No folder named "${folderTarget}" found.`);
        folderId = folder.id;
    }
    await this.call('moveNodesIntoFolder', [
        node.id
    ], folderId);
    return $5754323c21438f36$var$ok({
        moved: {
            id: node.id,
            into: folderId || 'desktop'
        }
    });
};
const $5754323c21438f36$export$ac55dbd365223732 = async function(title, content, folder) {
    // `source: 'ai'` is what the docs schema expects for an assistant-authored
    // row (member / import / meet / ai are all first-class). Without it every
    // note the assistant writes is indistinguishable from one a person typed —
    // measured live: AI-created docs were all landing as source 'member'.
    // `folderPath` lets a multi-document run file itself into one folder instead
    // of scattering across the root; createNote has always accepted both.
    const fallbackTitle = this.call('polyglot', 'workspace.ai.newRecord.note');
    const id = await this.call('createNote', {
        title: title || fallbackTitle,
        content: content || '',
        source: 'ai',
        ...folder ? {
            folderPath: String(folder)
        } : {}
    });
    return id ? $5754323c21438f36$var$ok({
        created: {
            kind: 'note',
            id: id,
            title: title || fallbackTitle
        }
    }) : $5754323c21438f36$var$fail('Could not create the note.');
};
const $5754323c21438f36$export$2631626d56cea84d = async function(target, newTitle) {
    const root = this.state.root;
    const inNotes = $5754323c21438f36$var$resolve(root?.notes, target, [
        'title',
        'name'
    ]);
    const doc = inNotes || $5754323c21438f36$var$resolve(root?.documents, target, [
        'title',
        'name'
    ]);
    if (!doc) return $5754323c21438f36$var$fail(`No note or document named "${target}" found.`);
    if (!newTitle) return $5754323c21438f36$var$fail('A new title is required.');
    const entity = inNotes ? 'docs.notes' : 'docs';
    try {
        await $5754323c21438f36$var$shellGetSDK().execute(entity, 'update', {
            id: doc.id,
            payload: {
                title: String(newTitle)
            }
        });
    } catch (e) {
        return $5754323c21438f36$var$fail('Rename failed: ' + (e?.message || e));
    }
    try {
        const patch = (arr)=>(arr || []).map((x)=>String(x.id) === String(doc.id) ? {
                    ...x,
                    title: String(newTitle)
                } : x);
        root.update({
            notes: patch(root.notes),
            documents: patch(root.documents)
        });
    } catch (_) {}
    // The cached note lists predate the write (documents functions/docListCache.js).
    this.call('forgetDocLists');
    return $5754323c21438f36$var$ok({
        renamed: {
            id: doc.id,
            from: doc.title || doc.name,
            to: String(newTitle)
        }
    });
};
const $5754323c21438f36$export$4997dc0d83171264 = async function(target) {
    const root = this.state.root;
    const inNotes = $5754323c21438f36$var$resolve(root?.notes, target, [
        'title',
        'name'
    ]);
    const doc = inNotes || $5754323c21438f36$var$resolve(root?.documents, target, [
        'title',
        'name'
    ]);
    if (!doc) return $5754323c21438f36$var$fail(`No note or document named "${target}" found.`);
    // The typed `docs.notes` sugar only does CRU; the generic `docs` entity owns
    // remove for both notes and documents.
    try {
        await $5754323c21438f36$var$shellGetSDK().execute('docs', 'remove', {
            id: doc.id
        });
    } catch (e) {
        return $5754323c21438f36$var$fail('Delete failed: ' + (e?.message || e));
    }
    try {
        const drop = (arr)=>(arr || []).filter((x)=>String(x.id) !== String(doc.id));
        root.update({
            notes: drop(root.notes),
            documents: drop(root.documents)
        });
    } catch (_) {}
    this.call('forgetDocLists');
    return $5754323c21438f36$var$ok({
        deleted: {
            id: doc.id,
            title: doc.title || doc.name
        }
    });
};
// ── TICKETS (root.tickets + root.columns; SDK entity tickets) ───────────────
// Fuzzy-normalize a column key/label/name for matching: lowercase, strip
// every non-alphanumeric (so "To Do" / "to-do" / "TO_DO" collapse to the
// same "todo"), then drop one trailing "s" (naive singularize) so a plural
// board heading — "To Dos" / "Backlogs" / "TO DOS" — still matches its
// singular column ("todo" / "backlog"). AI-supplied column labels rarely
// match the stored label byte-for-byte (case, spacing, plural), and the
// straight equality this replaced silently fell through to the caller's
// "column not found → default" branch, landing every mismatched ticket in
// Backlog regardless of what the user asked for.
const $5754323c21438f36$var$normColumnFuzzy = (v)=>{
    const base = String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]/g, '');
    return base.length > 1 && base.endsWith('s') ? base.slice(0, -1) : base;
};
function $5754323c21438f36$export$f5ed03c615f60577(root, columnRef) {
    const cols = root?.columns || [];
    const exact = cols.find((c)=>$5754323c21438f36$var$norm(c?.key) === $5754323c21438f36$var$norm(columnRef) || $5754323c21438f36$var$norm(c?.label) === $5754323c21438f36$var$norm(columnRef) || $5754323c21438f36$var$norm(c?.name) === $5754323c21438f36$var$norm(columnRef));
    if (exact) return {
        col: exact,
        key: exact.key
    };
    const target = $5754323c21438f36$var$normColumnFuzzy(columnRef);
    const col = cols.find((c)=>$5754323c21438f36$var$normColumnFuzzy(c?.key) === target || $5754323c21438f36$var$normColumnFuzzy(c?.label) === target || $5754323c21438f36$var$normColumnFuzzy(c?.name) === target);
    return {
        col: col,
        key: col?.key || columnRef
    };
}
const $5754323c21438f36$export$c1d7b08a08e81b3a = async function(target, columnRef) {
    const root = this.state.root;
    const tk = $5754323c21438f36$var$resolve(root?.tickets, target, [
        'title'
    ]);
    if (!tk) return $5754323c21438f36$var$fail(`No ticket matching "${target}" found.`);
    const { col: col, key: key } = $5754323c21438f36$export$f5ed03c615f60577(root, columnRef);
    const res = await this.call('moveTicket', {
        ticketId: tk.ticketId || tk.id,
        columnKey: key,
        position: 0
    });
    if (res === false) return $5754323c21438f36$var$fail('Move failed.');
    try {
        root.update({
            tickets: (root.tickets || []).map((x)=>String(x.id) === String(tk.id) ? {
                    ...x,
                    columnKey: key
                } : x)
        });
    } catch (_) {}
    return $5754323c21438f36$var$ok({
        moved: {
            ticket: tk.title,
            to: col?.label || key
        }
    });
};
// AI-306 (tickets/ai.md) — Undo an AI-created item BY ID, with zero
// page-state coupling. The sibling aiDelete* ops resolve by name against the
// CURRENTLY-LOADED root arrays (root.notes/documents/tickets), which is right
// for the model's "delete the launch memo" but wrong for the timeline's Undo
// chip: the chip carries the exact id from the create result, and the arrays
// are empty on any route that hasn't loaded them — measured live: an Undo on
// /w/<org> "succeeded" in the UI while the doc stayed in Mongo, because the
// name-resolve failed before any delete ran. Deletes by id through the same
// persist paths the resolving ops use; nothing new is reachable.
// A failed Undo also carries `cause`: a code the timeline row says in words
// of the active language (ChatToolRow UndoFailure → ai.tool.undoWhy.*). Wave 2
// (dev 2026-10-28): the row printed the raw cause, an SDK message or
// "deleteEvent is not available here", in English on a Georgian page. The raw
// error goes to the console only. The code comes from the error's structured
// fields, never from its words:
//   gone         HTTP 404 / 410: the item is not there any more
//   denied       HTTP 401 / 403: the person may not delete it
//   network      the SDK's NETWORK_UNREACHABLE: the request never arrived
//   unavailable  DELETE_UNAVAILABLE: this page has no delete for the kind
//   failed       anything else
const $5754323c21438f36$var$undoFailed = (err)=>{
    console.warn('[aiUndoCreated] Undo failed:', err);
    const status = Number(err && err.status);
    const code = err && err.code;
    const cause = status === 404 || status === 410 ? 'gone' : status === 401 || status === 403 ? 'denied' : code === 'NETWORK_UNREACHABLE' ? 'network' : code === 'DELETE_UNAVAILABLE' ? 'unavailable' : 'failed';
    return {
        ...$5754323c21438f36$var$fail('Undo failed.'),
        cause: cause
    };
};
const $5754323c21438f36$export$8418d404615cb53b = async function(kind, id) {
    const k = String(kind || '');
    const target = String(id || '').trim();
    if (!target) return $5754323c21438f36$var$fail('An item id is required.');
    if (k === 'note' || k === 'document') {
        try {
            await $5754323c21438f36$var$shellGetSDK().execute('docs', 'remove', {
                id: target
            });
        } catch (e) {
            return $5754323c21438f36$var$undoFailed(e);
        }
        try {
            const root = this.state.root;
            const drop = (arr)=>(arr || []).filter((x)=>String(x.id) !== target);
            root.update({
                notes: drop(root.notes),
                documents: drop(root.documents)
            });
        } catch (_) {}
        this.call('forgetDocLists');
        return $5754323c21438f36$var$ok({
            deleted: {
                kind: k,
                id: target
            }
        });
    }
    // A ticket and an event — made by the client op or by a server-run create
    // (lane TOOLS D2: its result carries the created id) — go through the
    // registered delete of their surface (tickets / calendar eager slices,
    // declarative fetch → the SDK). An event delete is the calendar's soft
    // delete, so a synced Google copy is removed too. `callerReports`: the
    // delete throws its failure here, its status and code intact, and shows no
    // message of its own. The row says the result, once.
    if (k === 'ticket' || k === 'event') {
        const fnName = k === 'ticket' ? 'deleteTicket' : 'deleteEvent';
        if (typeof this.context?.functions?.[fnName] !== 'function') return $5754323c21438f36$var$undoFailed(Object.assign(new Error(`${fnName} is not available here`), {
            code: 'DELETE_UNAVAILABLE'
        }));
        let res;
        try {
            res = await this.call(fnName, target, {
                callerReports: true
            });
        } catch (e) {
            return $5754323c21438f36$var$undoFailed(e);
        }
        if (res === false) return $5754323c21438f36$var$undoFailed(`${fnName} refused ${target}`);
        const key = k === 'ticket' ? 'tickets' : 'calendarEvents';
        try {
            const root = this.state.root;
            root.update({
                [key]: (root[key] || []).filter((x)=>String(x.id) !== target)
            });
        } catch (_) {}
        return $5754323c21438f36$var$ok({
            deleted: {
                kind: k,
                id: target
            }
        });
    }
    return $5754323c21438f36$var$fail(`"${k}" cannot be undone from the timeline.`);
};
const $5754323c21438f36$export$55558d9b359f055 = async function(target) {
    const root = this.state.root;
    const tk = $5754323c21438f36$var$resolve(root?.tickets, target, [
        'title'
    ]);
    if (!tk) return $5754323c21438f36$var$fail(`No ticket matching "${target}" found.`);
    const res = await this.call('deleteTicket', tk.ticketId || tk.id);
    if (res === false) return $5754323c21438f36$var$fail('Delete failed.');
    try {
        root.update({
            tickets: (root.tickets || []).filter((x)=>String(x.id) !== String(tk.id))
        });
    } catch (_) {}
    return $5754323c21438f36$var$ok({
        deleted: {
            ticket: tk.title,
            id: tk.id
        }
    });
};
const $5754323c21438f36$export$c87a101953c2f8b3 = async function(title, columnRef, body) {
    const root = this.state.root;
    if (!title) return $5754323c21438f36$var$fail('A ticket title is required.');
    const cols = root?.columns || [];
    const { col: col, key: key } = columnRef ? $5754323c21438f36$export$f5ed03c615f60577(root, columnRef) : {
        col: cols[0],
        key: cols[0]?.key
    };
    const columnKey = key || 'backlog';
    const ticket = {
        title: String(title),
        body: body || '',
        columnKey: columnKey,
        reporterEmail: root.currentUserEmail || null,
        state: 'not_started'
    };
    const id = await this.call('saveTicket', ticket);
    if (!id) return $5754323c21438f36$var$fail('Could not create the ticket.');
    // saveTicket is a PURE persist — unlike the sibling ops it does NOT
    // touch root.tickets, so an AI-created ticket never appeared on the board and
    // selectPageItem/open couldn't find it right after. Optimistically insert the
    // new row (the same thing the board's own create flow does) so it shows
    // immediately AND is openable in the same turn. Guard a double-insert if a
    // board reload raced in first.
    try {
        if (!(root.tickets || []).some((t)=>String(t.id) === String(id))) root.update({
            tickets: [
                {
                    id: id,
                    title: ticket.title,
                    body: ticket.body,
                    columnKey: columnKey,
                    column_key: columnKey,
                    position: 0,
                    reporterEmail: ticket.reporterEmail,
                    reporter_email: ticket.reporterEmail,
                    state: ticket.state,
                    labels: [],
                    metadata: {}
                },
                ...root.tickets || []
            ]
        });
    } catch (_) {}
    // Return the id so the assistant can chain create → select_page_item(open)
    // without a re-query round-trip.
    return $5754323c21438f36$var$ok({
        created: {
            kind: 'ticket',
            id: id,
            title: ticket.title,
            column: col?.label || columnKey
        }
    });
};
const $5754323c21438f36$export$3ca088d0f29d4721 = async function(target, title, body) {
    const root = this.state.root;
    const tk = $5754323c21438f36$var$resolve(root?.tickets, target, [
        'title'
    ]);
    if (!tk) return $5754323c21438f36$var$fail(`No ticket matching "${target}" found.`);
    if (title == null && body == null) return $5754323c21438f36$var$fail("Nothing to update \u2014 pass a new title and/or body.");
    const patch = {
        ...title == null ? {} : {
            title: String(title)
        },
        ...body == null ? {} : {
            body: String(body)
        }
    };
    const saved = await this.call('saveTicket', {
        ...tk,
        id: tk.ticketId || tk.id,
        ticketId: tk.ticketId || tk.id,
        ...patch
    });
    if (!saved) return $5754323c21438f36$var$fail('Could not update the ticket.');
    try {
        root.update({
            tickets: (root.tickets || []).map((x)=>String(x.id) === String(tk.id) ? {
                    ...x,
                    ...patch
                } : x)
        });
    } catch (_) {}
    return $5754323c21438f36$var$ok({
        updated: {
            kind: 'ticket',
            id: tk.id,
            title: patch.title || tk.title,
            fields: Object.keys(patch)
        }
    });
};
const $5754323c21438f36$export$ee828b0b35250177 = async function(target, email) {
    const root = this.state.root;
    const tk = $5754323c21438f36$var$resolve(root?.tickets, target, [
        'title'
    ]);
    if (!tk) return $5754323c21438f36$var$fail(`No ticket matching "${target}" found.`);
    const addr = String(email || '').trim();
    if (addr) {
        const people = Array.isArray(root?.people) ? root.people : [];
        if (people.length && !people.some((p)=>$5754323c21438f36$var$norm(p?.email) === $5754323c21438f36$var$norm(addr))) return $5754323c21438f36$var$fail(`"${addr}" is not a member of this workspace \u{2014} use an email from list_members, or invite them first.`);
    }
    const saved = await this.call('saveTicket', {
        ...tk,
        id: tk.ticketId || tk.id,
        ticketId: tk.ticketId || tk.id,
        assigneeEmail: addr || null
    });
    if (!saved) return $5754323c21438f36$var$fail('Could not update the assignee.');
    try {
        root.update({
            tickets: (root.tickets || []).map((x)=>String(x.id) === String(tk.id) ? {
                    ...x,
                    assigneeEmail: addr || null,
                    assignee_email: addr || null
                } : x)
        });
    } catch (_) {}
    return $5754323c21438f36$var$ok({
        assigned: {
            kind: 'ticket',
            id: tk.id,
            title: tk.title,
            assignee: addr || null
        }
    });
};
const $5754323c21438f36$export$978a7501ae4cf2bb = async function(name, topic, isPrivate) {
    if (!name) return $5754323c21438f36$var$fail('A channel name is required.');
    // createChannel lives in the lazily-folded chat context (bundle-fold) —
    // headless AI ops must fold before calling.
    await this.call('ensureChatContext');
    const id = await this.call('createChannel', {
        kind: 'channel',
        name: String(name),
        topic: topic || '',
        isPrivate: !!isPrivate
    });
    return id ? $5754323c21438f36$var$ok({
        created: {
            kind: 'channel',
            id: id,
            name: String(name)
        }
    }) : $5754323c21438f36$var$fail('Could not create the channel.');
};
const $5754323c21438f36$export$dd7dd95d1ef27458 = async function(channelTarget, body) {
    const root = this.state.root;
    if (!body) return $5754323c21438f36$var$fail('A message body is required.');
    const ch = $5754323c21438f36$var$resolve(root?.channels, channelTarget, [
        'name',
        'title'
    ]);
    // Only trust a raw channelTarget when it LOOKS like an id (Mongo hex / uuid) —
    // an unresolvable NAME must NOT be used verbatim as a channel id, which would
    // misroute the message into an unrendered bucket (or another workspace). Fall
    // back to the active channel, else fail with a clear "no channel" error.
    const looksLikeId = (v)=>typeof v === 'string' && (/^[0-9a-f]{24}$/i.test(v) || /^[0-9a-f-]{32,}$/i.test(v));
    const channelId = ch && ch.id || (looksLikeId(channelTarget) ? channelTarget : null) || root?.activeChannelId;
    if (!channelId) return $5754323c21438f36$var$fail(`No channel matching "${channelTarget}" found.`);
    // sendMessage rides the lazily-folded chat context (bundle-fold).
    await this.call('ensureChatContext');
    const id = await this.call('sendMessage', {
        channelId: channelId,
        body: String(body)
    });
    return id ? $5754323c21438f36$var$ok({
        sent: {
            channel: ch?.name || channelId
        }
    }) : $5754323c21438f36$var$fail('Could not send the message.');
};
// ── AI-CREATED home widgets (tickets/opus.md "Per-workspace AI-CREATED
// widgets") ─────────────────────────────────────────────────────────────────
//
// The second half of Nika's mandate "new apps should be able to have their own
// widgets from appstore or created by user ai": a member asks the assistant for
// a widget and it lands on their home board with the SAME chrome, hue and
// gs-clamps an app-store widget gets.
//
// These are ordinary WRITE data-ops — same registry, same `runClientToolWithAuth`
// → `resolveAiToolApproval` gate every other write goes through (Ask-first by
// default), no bespoke approval path. What makes them safe is not this file:
//
//   * the TOOL SCHEMA (server workspaceTools.js `create_widget`) accepts only
//     the fixed block vocabulary — a model that "wants" to emit a function
//     literally cannot, because no field accepts one;
//   * the SERVER validates every write against that vocabulary
//     (widgetDefSchema.js) and rejects anything else;
//   * the SERVER capability-checks the dataRecipe for the CREATING user before
//     it persists, and re-checks it for every VIEWING user on read.
//
// So this layer stays thin on purpose: SDK call, refresh the plane, report.
// Re-read the AI widget plane after a write so the board converges in the same
// turn (the create/edit/delete is only "done" when the user can see it).
const $5754323c21438f36$var$_refreshAiWidgets = async function(root) {
    const sdk = $5754323c21438f36$var$shellGetSDK();
    const wsId = root && root.workspace && (root.workspace.id || root.workspace._id) || null;
    const rows = await sdk.execute('workspaceProject.widgetDefs', 'list', wsId ? {
        workspaceId: wsId
    } : {});
    root.update({
        workspaceAiWidgets: Array.isArray(rows) ? rows : []
    });
    return Array.isArray(rows) ? rows : [];
};
const $5754323c21438f36$export$efa1583c651024bf = async function(widget, opts) {
    const root = this.state.root;
    const def = widget && typeof widget === 'object' ? widget : null;
    if (!def || !def.title) return $5754323c21438f36$var$fail('A widget title is required.');
    // A PINNED board card (DESIGN-WL-ASSISTANT-MAIN-HOME-1; the widgetDefs
    // contract CORE-WIDGETDEFS-ACCEPT-BOARD-ITEMS-1) carries either an installed
    // app's widget by reference with its params (`{ widget: '<app>.<id>',
    // params }`) or the values the card showed (`{ block: { type, data, format?,
    // source? } }`) — no recipe of its own. The server derives the kind and
    // validates both shapes; this guard keeps refusing a def with no content.
    const pinnedRef = typeof def.widget === 'string' && !!def.widget;
    const pinnedBlock = !!(def.block && typeof def.block === 'object' && def.block.type);
    // A RECORDS block (WIDGET-TOOLS-RECORDS-SHAPE-1): one app collection read
    // live for each viewer — the assistant's create_widget `records` shape and a
    // pinned board records card. The server validates it against the creating
    // member's collections; the home draws it with AssistantRecordsBlock.
    const pinnedRecords = !!(def.records && typeof def.records === 'object' && typeof def.records.collection === 'string' && def.records.collection);
    if (!pinnedRef && !pinnedBlock && !pinnedRecords) {
        if (!def.dataRecipe || !def.dataRecipe.from) return $5754323c21438f36$var$fail('A widget needs a dataRecipe naming which data it reads.');
        if (!def.body || !Array.isArray(def.body.blocks) || !def.body.blocks.length) return $5754323c21438f36$var$fail('A widget needs a body with at least one block.');
    }
    const sdk = $5754323c21438f36$var$shellGetSDK();
    const wsId = root && root.workspace && (root.workspace.id || root.workspace._id) || null;
    try {
        const created = await sdk.execute('workspaceProject.widgetDefs', 'create', {
            widget: def,
            ...wsId ? {
                workspaceId: wsId
            } : {}
        });
        await $5754323c21438f36$var$_refreshAiWidgets.call(this, root);
        const createdId = created && created.id;
        // "Change with AI" (HOME-WIDGET-CHANGE-WITH-AI-1): the new card takes the
        // place of the card the member asked to change — the home board's own
        // operation (pages/main.js _homeOps.replaceWidget). Off the home board the
        // widget is still created; the answer says the card was not swapped.
        const replaces = opts && typeof opts.replaces === 'string' ? opts.replaces.trim() : '';
        let replaced = false;
        if (replaces && createdId) {
            const ops = root && root._homeOps;
            try {
                replaced = !!(ops && typeof ops.replaceWidget === 'function' && ops.replaceWidget(replaces, createdId));
            } catch (_) {
                replaced = false;
            }
        }
        return $5754323c21438f36$var$ok({
            created: {
                kind: 'widget',
                id: createdId,
                title: def.title,
                ...replaces ? {
                    replaced: replaced ? replaces : null
                } : {}
            }
        });
    } catch (err) {
        // The server's rejection is the useful part — a validation failure names
        // the field of the vocabulary the model got wrong, a capability failure
        // tells the user plainly that they cannot read that data. The SDK keeps
        // the body on `err.cause`: its `details` carry the field reasons, and
        // without them the model only ever saw "widget definition rejected" and
        // could not correct itself (dev 2026-10-04: dataRecipe.params.filter).
        const base = err && err.message || 'Could not create the widget.';
        const details = err && err.cause && Array.isArray(err.cause.details) ? err.cause.details : [];
        const why = details.slice(0, 6).map((d)=>d && d.path ? `${d.path}: ${d.message}` : d && d.message || '').filter(Boolean);
        return $5754323c21438f36$var$fail(why.length ? `${base} (${why.join('; ')})` : base);
    }
};
const $5754323c21438f36$export$1f1f11a10c10a3e4 = async function(widgetId, patch) {
    const root = this.state.root;
    const id = String(widgetId || '').trim();
    if (!id) return $5754323c21438f36$var$fail('A widget id is required.');
    if (!patch || typeof patch !== 'object') return $5754323c21438f36$var$fail('Nothing to change.');
    const sdk = $5754323c21438f36$var$shellGetSDK();
    const wsId = root && root.workspace && (root.workspace.id || root.workspace._id) || null;
    try {
        const updated = await sdk.execute('workspaceProject.widgetDefs', 'update', {
            id: id,
            widget: patch,
            ...wsId ? {
                workspaceId: wsId
            } : {}
        });
        await $5754323c21438f36$var$_refreshAiWidgets.call(this, root);
        return $5754323c21438f36$var$ok({
            updated: {
                kind: 'widget',
                id: updated && updated.id || id
            }
        });
    } catch (err) {
        // Same as aiCreateWidget: the field reasons ride on `err.cause.details`.
        const base = err && err.message || 'Could not update the widget.';
        const details = err && err.cause && Array.isArray(err.cause.details) ? err.cause.details : [];
        const why = details.slice(0, 6).map((d)=>d && d.path ? `${d.path}: ${d.message}` : d && d.message || '').filter(Boolean);
        return $5754323c21438f36$var$fail(why.length ? `${base} (${why.join('; ')})` : base);
    }
};
const $5754323c21438f36$export$10d37e3a6e34e0e6 = async function(widgetId) {
    const root = this.state.root;
    const id = String(widgetId || '').trim();
    if (!id) return $5754323c21438f36$var$fail('A widget id is required.');
    const sdk = $5754323c21438f36$var$shellGetSDK();
    const wsId = root && root.workspace && (root.workspace.id || root.workspace._id) || null;
    try {
        await sdk.execute('workspaceProject.widgetDefs', 'remove', {
            id: id,
            ...wsId ? {
                workspaceId: wsId
            } : {}
        });
        await $5754323c21438f36$var$_refreshAiWidgets.call(this, root);
        return $5754323c21438f36$var$ok({
            deleted: {
                kind: 'widget',
                id: id
            }
        });
    } catch (err) {
        return $5754323c21438f36$var$fail(err && err.message || 'Could not delete the widget.');
    }
};

});

parcelRegister("02uje", function(module, exports) {

$parcel$export(module.exports, "aiStartTour", () => $0077b2cd8d47fae5$export$83f378d82d299fa2);
// aiStartTour.js — the assistant's `start_tour` (server workspaceTools.js):
// THE QUICK TOUR on demand (functions/onboardingTour.js — a few highlighted
// stops over the member's real screen). Nika 2026-10-18, "close all
// followups": a member who asked the assistant for a tour got prose about it.
//
// The tour points at the HOME page's chrome (the navbar, the App strip, the
// composer), so it starts there: a page sheet open in the PageSlot steps aside
// (the same writes as open_page_in_split's close), and off the home the shell
// goes home first — the open the phone dock's Home makes (`openAppPage('/')`).
// The main thread stays: on the home it never hides the App strip or the
// composer, and a navigation already clears it. Then the welcome's own beat
// (320 ms) and `onboardingTourStart`.
//
// A CLIENT TOOL (simoneAiTransport CLIENT_TOOL_FNS; read-only class — it
// changes only what the member sees, so Ask-first never asks). Answers
// `{ ok: true, started: true, stops, note }` for the model to read, or
// `{ ok: false, error }`. It writes no onboarding decision. The `note` says
// what the screen now shows and how little to say: the tool's description
// asks for one short sentence, and live on dev (ba591daf1) the model still
// wrote three about the stops — the result is what it reads last.
//
// `opts` — test seams: { beatMs, homeWaitMs, stepMs }.
//
// FRANK: one self-contained export (FA204); siblings through `this.call`.
async function $0077b2cd8d47fae5$export$83f378d82d299fa2(opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function' || !el || typeof el.call !== 'function') return {
        ok: false,
        error: 'No workspace screen is available for the tour.'
    };
    const fns = el.context && el.context.functions || {};
    if (typeof fns.onboardingTourStart !== 'function') return {
        ok: false,
        error: 'This workspace has no tour.'
    };
    const o = opts && typeof opts === 'object' ? opts : {};
    const beatMs = typeof o.beatMs === 'number' ? o.beatMs : 320;
    const homeWaitMs = typeof o.homeWaitMs === 'number' ? o.homeWaitMs : 3000;
    const stepMs = typeof o.stepMs === 'number' ? o.stepMs : 100;
    const wait = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
    const onHome = ()=>{
        const raw = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
        const stripped = el.call('stripWorkspacePrefix', raw);
        const path = String(typeof stripped === 'string' ? stripped : raw).split(/[?#]/)[0];
        return path === '/' || path === '';
    };
    // A page sheet over the home covers the stops.
    if (root._canvasSlot || root._canvasSlotSecond) root.update({
        _canvasSlot: null,
        _canvasSlotSecond: null,
        _slotFullscreen: null
    });
    if (!onHome()) {
        try {
            await el.call('openAppPage', '/');
        } catch (_) {
        // the wait below decides
        }
        const until = Date.now() + homeWaitMs;
        while(!onHome() && Date.now() < until)await wait(stepMs);
        if (!onHome()) return {
            ok: false,
            error: 'The home page did not open, so the tour could not start.'
        };
    }
    await wait(beatMs);
    el.call('onboardingTourStart');
    const tour = root._onboardingTour;
    if (!tour) return {
        ok: false,
        error: 'The tour could not start.'
    };
    return {
        ok: true,
        started: true,
        stops: Number(tour.total) || 0,
        // Live on dev 3103cfd the first note stopped the description of the stops
        // but not the filler ("Of course. I've started the workspace tour for you.
        // Follow the steps on your screen…"): a word ceiling and the parts to
        // leave out are what a model keeps to.
        note: "The tour is on the member's screen now; each stop explains itself there. Answer with ONE short sentence of at most eight words, in the member's language \u2014 no greeting, no list, and do not describe the stops."
    };
}

});

parcelRegister("ly0mS", function(module, exports) {

$parcel$export(module.exports, "MAX_SNAPSHOT_AGE_MS", () => $fafd0f04fae9fc60$export$602c388925155d7d);
$parcel$export(module.exports, "MAX_SNAPSHOT_ENTRIES", () => $fafd0f04fae9fc60$export$3921bf760100bfd5);
$parcel$export(module.exports, "decodeAccessTokenUserId", () => $fafd0f04fae9fc60$export$11e46a9f34a2ecc3);
$parcel$export(module.exports, "_snapshotKey", () => $fafd0f04fae9fc60$export$a45758762419c429);
$parcel$export(module.exports, "writeBootSnapshot", () => $fafd0f04fae9fc60$export$91d8aa2df7e1ed3b);
$parcel$export(module.exports, "readBootSnapshot", () => $fafd0f04fae9fc60$export$d1a395f012eb59dc);
$parcel$export(module.exports, "recordBootSnapshotSkin", () => $fafd0f04fae9fc60$export$644bb479b7466348);
$parcel$export(module.exports, "applyWarmBootSkin", () => $fafd0f04fae9fc60$export$385f39fe15ac6771);
$parcel$export(module.exports, "purgeBootSnapshot", () => $fafd0f04fae9fc60$export$cc4b6ff2a7cca6af);
$parcel$export(module.exports, "purgeAllBootSnapshots", () => $fafd0f04fae9fc60$export$f751fab21aaa4170);
$parcel$export(module.exports, "_snapshotMatchesUrlScope", () => $fafd0f04fae9fc60$export$ceecefe863c980b9);
$parcel$export(module.exports, "readSessionBootOrgs", () => $fafd0f04fae9fc60$export$9b92d503e7eac9c);
$parcel$export(module.exports, "resolveWarmBootSnapshot", () => $fafd0f04fae9fc60$export$50f46d6e6b9790f9);
// bootSnapshot — scope-keyed warm-start boot cache (tickets/workspace.md
// "boot: scope-keyed warm-start snapshot"; PAINT half: tickets/opus.md
// "boot: the scope-keyed warm-start snapshot's PAINT half was never built").
//
// STATUS (2026-08-09): BOTH halves are wired.
//   Storage: write on every settled boot, purge on every workspace switch —
//   unchanged since 2026-08-08, see `writeBootSnapshot`/`purgeBootSnapshot`
//   below and their call sites in `loadPrivateData.js`.
//   Paint: `resolveWarmBootSnapshot()` (bottom of this file) is the ONE
//   integration point — workspace/index.js calls it before invoking
//   `bootShell({ ..., warmSnapshot })`. Nika granted permission 2026-08-09 to
//   edit `packages/shared/functions/bootShell.js` for this specific change
//   (see that file's own comment at the warm-start block for the accepted
//   conditions) — this module still does 100% of the "is this snapshot
//   actually safe to paint for THIS URL" judgment; bootShell only trusts an
//   already-validated row, never touches localStorage/the URL to decide.
//
// WHAT THIS BUYS: a repeat boot into a warm tenant paints identity chrome
// (org switcher, workspace name, member roster) in the SAME frame the shell
// mounts, instead of after the `/core/boot` round trip resolves. Measured
// 2026-08-08 (workspace@<see tickets/workspace.md>, pre-paint-half): COLD
// boot RTT ~1558ms / chrome painted ~2708ms; REPEAT boot RTT ~1213ms /
// chrome painted ~2907ms — i.e. even a REPEAT boot into the SAME tenant
// burned the full RTT before this half existed, because `bootShell` always
// awaited it before mounting anything. Re-measured after this change — see
// tickets/opus.md for the numbers.
//
// HOW THE PAINT HALF STAYS SAFE (the ticket's own bar: "a warm-start
// snapshot that paints stale or wrong-scope content is worse than no warm
// start"):
//   1. `userId` is decoded from the CURRENT `symbols_access_token` (never a
//      self-written "last known user" pointer) — a different signed-in user
//      in the same browser can never resolve another user's snapshot.
//   2. The lookup is keyed by the tab's OWN active-workspace pointer
//      (`activeWorkspacePointer.js` — sessionStorage per-tab when MWT is on),
//      exactly the same source `bootShell`'s live `resolveActiveWorkspace`
//      falls back to when the URL doesn't name a more specific scope.
//   3. `_snapshotMatchesUrlScope` cross-checks the URL against the snapshot's
//      OWN cached org/workspace identity using nothing but string compares —
//      no assumption, no guess. When the URL names an org/workspace that
//      disagrees with what's cached, this refuses (null) rather than paint
//      a plausible-looking wrong scope. See that function's own comments for
//      the exact precedence, which mirrors `resolveActiveWorkspace`'s live
//      one (URL org+handle wins; bare-org URL defers to the pointer already
//      being inside that org; MWT-off ignores the URL prefix entirely).
//   4. `readBootSnapshot` (unchanged) still refuses on schema-version drift,
//      staleness (7 days), or a missing/mismatched `orgId` embedded in the
//      payload.
//   5. bootShell's own reconcile (once the REAL `/core/boot` round trip
//      resolves, moments later) always wins over the cache — see that file's
//      warm-start block. A wrong or stale guess self-heals within one paint
//      cycle instead of persisting.
//
// SCOPE ISOLATION (the part that MUST be bulletproof even half-wired):
//   Storage key is `(userId × workspaceId)` — globally collision-free on its
//   own (Mongo ids), but the ticket's compound key is `(orgId × workspaceId)`,
//   so `orgId` is embedded in the payload and CROSS-CHECKED on read: a caller
//   that knows the expected orgId (post-boot verification, tests) passes it
//   and a mismatch is treated exactly like a missing snapshot. `userId` is
//   decoded from the CURRENT `symbols_access_token` (not a self-written "last
//   known user" pointer) so a different signed-in user in the same browser can never
//   read another user's snapshot even before any network round trip lands.
//   `schemaVersion` is stamped and checked — an older build's snapshot shape
//   is discarded, never coerced (mirrors the `_shape: 'full' | 'list'`
//   precedent in activeWorkspaceRecord.js: "agreement on identity is not
//   agreement on completeness").
//
// PURGE PATHS:
//   - Sign-out: the storage key is prefixed `symbols_boot_snapshot_v<N>__` —
//     `symbols_`-prefixed keys are ALREADY swept by the existing
//     `purgeAuthStorage()` (packages/shared/functions/clearAuthStorage.js,
//     used by both bootShell's pre-mount force-logout and the post-mount
//     switchers/logout.js). No shared-file edit needed to satisfy "signing
//     out purges it" — this rides the existing wipe path by construction.
//   - Workspace/org switch: `onWorkspaceChange`'s PHASE-1 wipe (this
//     package's `functions/loadPrivateData.js`) calls `purgeBootSnapshot` for
//     the OUTGOING (userId, workspaceId) before the new tenant's data lands —
//     belt-and-suspenders on top of the fact that a different tenant simply
//     reads a DIFFERENT storage key and could never paint the old one anyway.
//
// CONTENT: chrome-only. No tickets/documents/AI-thread/records data — this
// is explicitly NOT a general "cache the whole boot payload" store; it's the
// minimal set the ticket names for first-frame identity chrome.
// Only used by the PAINT-side resolver at the bottom of this file
// (`resolveWarmBootSnapshot`) — reuses the SAME URL-scheme parser and
// pointer/flag accessors `bootShell`'s own live resolution already goes
// through (`activeWorkspacePointer.js`'s `resolveActiveWorkspace`), so this
// module's "does the cache match the URL" precedence can never drift from
// what boot actually does with a live response.
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).

var $1X0Je = parcelRequire("1X0Je");

var $7sTYS = parcelRequire("7sTYS");
var $fafd0f04fae9fc60$require$Buffer = $7sTYS.Buffer;
// Deferred to call time — an eager module-scope destructure of the barrel's
// default crashes the shell boot inside the shared-barrel init cycle.
const $fafd0f04fae9fc60$var$shellGetWorkspaceRawSegments = (...args)=>(0, $1X0Je.default).functions.getWorkspaceRawSegments(...args);
const $fafd0f04fae9fc60$var$shellGetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.getActiveWorkspacePointer(...args);
const $fafd0f04fae9fc60$var$shellIsMwtEnabled = (...args)=>(0, $1X0Je.default).functions.isMwtEnabled(...args);
// v2 (P0 tenant isolation, tickets/fable.md 2026-08-14): workspace rows now
// cache `key` (`ws_<nanoid>`) so `_findByHandle` can resolve key-form URL
// handles — v1 rows couldn't, so a `/w/<org>/ws_<key>/…` URL read as an
// unrecognized ROUTE segment and a same-org snapshot for a DIFFERENT
// workspace could paint. The version bump discards every v1 row on read
// (schema drift is refused, never coerced); stale v1 localStorage keys ride
// purgeAuthStorage()'s existing `symbols_` sweep.
const $fafd0f04fae9fc60$var$SCHEMA_VERSION = 2;
const $fafd0f04fae9fc60$var$KEY_PREFIX = `symbols_boot_snapshot_v${$fafd0f04fae9fc60$var$SCHEMA_VERSION}__`;
const $fafd0f04fae9fc60$export$602c388925155d7d = 604800000 // 7 days
;
const $fafd0f04fae9fc60$export$3921bf760100bfd5 = 8;
const $fafd0f04fae9fc60$var$_local = ()=>{
    try {
        return globalThis.localStorage || null;
    } catch  {
        return null;
    }
};
// Monotonic write-order tiebreaker. `Date.now()` resolution (1ms) is coarse
// enough that a burst of writes (many workspaces warmed in quick succession —
// exactly what the LRU-cap path is defending against) can land the SAME `ts`,
// which would make "evict oldest" ambiguous among ties. A simple incrementing
// counter, unaffected by clock resolution, makes eviction order deterministic.
let $fafd0f04fae9fc60$var$_writeSeq = 0;
const $fafd0f04fae9fc60$export$11e46a9f34a2ecc3 = (token)=>{
    if (!token || typeof token !== 'string') return null;
    try {
        const parts = token.split('.');
        if (parts.length < 2) return null;
        const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - b64.length % 4);
        const json = typeof atob === 'function' ? atob(b64 + pad) : $fafd0f04fae9fc60$require$Buffer.from(b64 + pad, 'base64').toString('utf8');
        const payload = JSON.parse(json);
        return String(payload?.sub || payload?._id || payload?.userId || '') || null;
    } catch  {
        return null;
    }
};
const $fafd0f04fae9fc60$export$a45758762419c429 = (userId, workspaceId)=>`${$fafd0f04fae9fc60$var$KEY_PREFIX}${String(userId)}__${String(workspaceId)}`;
// Every prefixed key currently in storage, newest-first by our own `ts`
// field (corrupt/foreign rows sort last and are treated as evictable).
const $fafd0f04fae9fc60$var$_allSnapshotKeys = (store)=>{
    try {
        return Object.keys(store).filter((k)=>k.startsWith($fafd0f04fae9fc60$var$KEY_PREFIX));
    } catch  {
        return [];
    }
};
const $fafd0f04fae9fc60$export$91d8aa2df7e1ed3b = ({ userId: userId, orgId: orgId, workspaceId: workspaceId, currentUserEmail: currentUserEmail, currentUserUsername: currentUserUsername, org: org, orgs: orgs, workspace: workspace, workspaces: workspaces, members: members, workspaceSkin: workspaceSkin } = {})=>{
    const store = $fafd0f04fae9fc60$var$_local();
    if (!store) return false;
    if (!userId || !orgId || !workspaceId) return false;
    // THE SKIN (see recordBootSnapshotSkin below): a rewrite that does not know
    // it — the rule answers null while a configured module has not loaded —
    // keeps the skin this scope's row already carries.
    const skinOf = (v)=>v === 'ambient' || v === 'solid' ? v : null;
    let keptSkin = null;
    if (!skinOf(workspaceSkin)) try {
        const prev = JSON.parse(store.getItem($fafd0f04fae9fc60$export$a45758762419c429(userId, workspaceId)) || 'null');
        keptSkin = prev && String(prev.userId) === String(userId) ? skinOf(prev.workspaceSkin) : null;
    } catch  {
        keptSkin = null;
    }
    const payload = {
        v: $fafd0f04fae9fc60$var$SCHEMA_VERSION,
        ts: Date.now(),
        seq: ++$fafd0f04fae9fc60$var$_writeSeq,
        userId: String(userId),
        orgId: String(orgId),
        workspaceId: String(workspaceId),
        currentUserEmail: currentUserEmail || '',
        currentUserUsername: currentUserUsername || '',
        org: org ? {
            id: org.id,
            name: org.name,
            slug: org.slug,
            logo: org.logo
        } : null,
        orgs: Array.isArray(orgs) ? orgs.map((o)=>({
                id: o.id,
                name: o.name,
                slug: o.slug
            })) : [],
        workspace: workspace ? {
            id: workspace.id,
            name: workspace.name,
            slug: workspace.slug,
            key: workspace.key,
            org_id: workspace.org_id
        } : null,
        // The workspace's OWN interface-language pair — the one input bootShell's
        // first paint needs from `settings`, and the only part of `settings` this
        // chrome-only cache carries. bootShell resolves the warm mount's language
        // from it with the same `resolveLang` precedence applyWorkspaceLangPolicy
        // uses, so a Georgian workspace no longer paints English on the splash and
        // Georgian once the full record lands (measured on my.symbols.app,
        // 2026-09-23). Written only when the record carries a `settings` bag (the
        // caller writes on a settled boot, where the record is full); `null`
        // otherwise, which first paint reads as "no workspace signal" — the
        // behaviour before this field existed. Additive: an older v2 row simply
        // lacks it, so no schema bump.
        workspaceLanguage: workspace && workspace.settings && typeof workspace.settings === 'object' ? {
            language: workspace.settings.language || null,
            languagePolicy: workspace.settings.languagePolicy || null
        } : null,
        // The workspace's OWN default theme — `settings.theme = { mode }`, 'light' |
        // 'dark' or null — the other `settings` input first paint needs. The warm
        // mount seeds it (shared bootResolve.js 5b, below the user's own choice),
        // so a dark-by-default workspace (GreenIG, Nika 2026-10-18) paints dark
        // from its first frame; the cold mount reads the full record itself.
        // Same rule as workspaceLanguage: written when the record carries
        // `settings`, null otherwise. Additive: an older row lacks it.
        workspaceTheme: (()=>{
            const settings = workspace && workspace.settings && typeof workspace.settings === 'object' ? workspace.settings : null;
            const theme = settings ? settings.theme : null;
            const mode = theme && typeof theme === 'object' ? theme.mode : theme;
            return mode === 'light' || mode === 'dark' ? mode : null;
        })(),
        // The skin the shell stamps for this scope — `ambient` | `solid`, or null
        // when not known yet (DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-WHITELABEL-1).
        // A warm boot mounts from this row before /core/boot answers; the entry
        // (index.js, applyWarmBootSkin) stamps <html data-skin> from it before the
        // first paint, so the header pills and the composer are drawn in the
        // right skin from the first frame instead of changing when the record
        // lands. Additive, like workspaceLanguage: an older v2 row lacks it.
        workspaceSkin: skinOf(workspaceSkin) || keptSkin,
        workspaces: Array.isArray(workspaces) ? workspaces.map((w)=>({
                id: w.id,
                name: w.name,
                slug: w.slug,
                key: w.key,
                org_id: w.org_id,
                type: w.type
            })) : [],
        // Roster trimmed to what chrome (avatars, name) actually paints — not
        // the full HR-shaped `_person` row (bio/pronouns/social links/dates).
        members: Array.isArray(members) ? members.slice(0, 200).map((m)=>({
                userId: m.userId,
                name: m.name,
                avatar: m.avatar,
                email: m.email
            })) : []
    };
    try {
        store.setItem($fafd0f04fae9fc60$export$a45758762419c429(userId, workspaceId), JSON.stringify(payload));
    } catch  {
        return false;
    }
    // LRU-evict beyond the cap so a browser that has warmed many tenants
    // doesn't grow this store unboundedly.
    try {
        const keys = $fafd0f04fae9fc60$var$_allSnapshotKeys(store);
        if (keys.length > $fafd0f04fae9fc60$export$3921bf760100bfd5) {
            const withTs = keys.map((k)=>{
                try {
                    const row = JSON.parse(store.getItem(k) || 'null');
                    return {
                        k: k,
                        ts: row?.ts || 0,
                        seq: row?.seq || 0
                    };
                } catch  {
                    return {
                        k: k,
                        ts: 0,
                        seq: 0
                    };
                }
            }).sort((a, b)=>b.ts - a.ts || b.seq - a.seq);
            for (const { k: k } of withTs.slice($fafd0f04fae9fc60$export$3921bf760100bfd5))try {
                store.removeItem(k);
            } catch  {}
        }
    } catch  {}
    return true;
};
const $fafd0f04fae9fc60$export$d1a395f012eb59dc = ({ userId: userId, workspaceId: workspaceId, orgId: orgId, maxAgeMs: maxAgeMs } = {})=>{
    const store = $fafd0f04fae9fc60$var$_local();
    if (!store || !userId || !workspaceId) return null;
    let raw;
    try {
        raw = store.getItem($fafd0f04fae9fc60$export$a45758762419c429(userId, workspaceId));
    } catch  {
        return null;
    }
    if (!raw) return null;
    let row;
    try {
        row = JSON.parse(raw);
    } catch  {
        return null;
    }
    if (!row || row.v !== $fafd0f04fae9fc60$var$SCHEMA_VERSION) return null;
    if (String(row.userId) !== String(userId)) return null;
    if (String(row.workspaceId) !== String(workspaceId)) return null;
    if (!row.orgId) return null;
    if (orgId != null && String(row.orgId) !== String(orgId)) return null;
    const age = Date.now() - (row.ts || 0);
    if (!(age >= 0) || age > (maxAgeMs ?? $fafd0f04fae9fc60$export$602c388925155d7d)) return null;
    return row;
};
const $fafd0f04fae9fc60$export$644bb479b7466348 = ({ userId: userId, workspaceId: workspaceId, skin: skin } = {})=>{
    const store = $fafd0f04fae9fc60$var$_local();
    if (!store || !userId || !workspaceId) return false;
    if (skin !== 'ambient' && skin !== 'solid') return false;
    const key = $fafd0f04fae9fc60$export$a45758762419c429(userId, workspaceId);
    let row;
    try {
        row = JSON.parse(store.getItem(key) || 'null');
    } catch  {
        return false;
    }
    if (!row || row.v !== $fafd0f04fae9fc60$var$SCHEMA_VERSION) return false;
    if (String(row.userId) !== String(userId)) return false;
    if (String(row.workspaceId) !== String(workspaceId)) return false;
    if (row.workspaceSkin === skin) return true;
    try {
        store.setItem(key, JSON.stringify({
            ...row,
            workspaceSkin: skin
        }));
        return true;
    } catch  {
        return false;
    }
};
const $fafd0f04fae9fc60$export$e92a65bf9156d46a = (snap)=>{
    const skin = snap && typeof snap === 'object' ? snap.workspaceSkin : null;
    return skin === 'ambient' || skin === 'solid' ? skin : null;
};
const $fafd0f04fae9fc60$export$385f39fe15ac6771 = (snap, doc = typeof document !== 'undefined' ? document : null)=>{
    const skin = $fafd0f04fae9fc60$export$e92a65bf9156d46a(snap);
    const html = doc && doc.documentElement;
    if (!skin || !html || typeof html.setAttribute !== 'function') return null;
    if (html.getAttribute('data-skin') !== skin) html.setAttribute('data-skin', skin);
    return skin;
};
const $fafd0f04fae9fc60$export$cc4b6ff2a7cca6af = ({ userId: userId, workspaceId: workspaceId } = {})=>{
    const store = $fafd0f04fae9fc60$var$_local();
    if (!store || !userId || !workspaceId) return;
    try {
        store.removeItem($fafd0f04fae9fc60$export$a45758762419c429(userId, workspaceId));
    } catch  {}
};
const $fafd0f04fae9fc60$export$f751fab21aaa4170 = ()=>{
    const store = $fafd0f04fae9fc60$var$_local();
    if (!store) return;
    for (const k of $fafd0f04fae9fc60$var$_allSnapshotKeys(store))try {
        store.removeItem(k);
    } catch  {}
};
// ── PAINT-SIDE RESOLVER (tickets/opus.md — the PAINT half) ─────────────────
//
// The token bootShell itself checks for the SDK auth gate
// (`_hasSdkToken` there) — read locally here too so this module never
// depends on bootShell for identity resolution.
const $fafd0f04fae9fc60$var$_rawAccessToken = ()=>{
    const store = $fafd0f04fae9fc60$var$_local();
    if (!store) return null;
    try {
        return store.getItem('symbols_access_token') || store.getItem('symbols_bridge_access_token') || null;
    } catch  {
        return null;
    }
};
// Does `handle` name ANY workspace in `list` (the cached org-scoped roster)?
// Same precedence as `findWorkspaceInOrg` (activeWorkspacePointer.js):
// slug → key → id. `key` joined the cache at SCHEMA_VERSION 2 (P0 tenant
// isolation) — without it a key-form URL handle (`ws_<nanoid>`, the ONLY
// handle a slug-less workspace has) read as an unrecognized ROUTE segment,
// so a same-org snapshot keyed to a DIFFERENT workspace slipped past the
// scope match and painted for that URL.
const $fafd0f04fae9fc60$var$_findByHandle = (list, handle)=>{
    if (!Array.isArray(list) || !handle) return null;
    const want = String(handle).toLowerCase();
    const eq = (v)=>String(v ?? '').toLowerCase() === want;
    return list.find((w)=>w && (eq(w.slug) || eq(w.key) || eq(w.id))) || null;
};
const $fafd0f04fae9fc60$export$ceecefe863c980b9 = (snap, { orgSlug: orgSlug, seg2: seg2 } = {}, { mwtEnabled: mwtEnabled = true } = {})=>{
    if (!snap) return false;
    if (!mwtEnabled || !orgSlug) return true;
    const snapOrgSlug = String(snap.org?.slug || '').toLowerCase();
    if (!snapOrgSlug || snapOrgSlug !== String(orgSlug).toLowerCase()) return false;
    if (!seg2) return true;
    const hit = $fafd0f04fae9fc60$var$_findByHandle(snap.workspaces, seg2);
    const cachedId = String(snap.workspace?.id || '');
    if (!hit && String(seg2).toLowerCase() === 'default') {
        // `default` that no cached workspace claims: the live resolver picks the
        // org's MAIN workspace (type hq → shared → first of the org), never the
        // pointer this snapshot is keyed by. Match only when this snapshot IS
        // that workspace. The live tie-breaks (first `shared`, first row) follow
        // the LIVE list's order, which this cached roster need not share, so only
        // a unique row at its tier counts; anything else proves nothing and
        // refuses, like an empty roster.
        const orgId = String(snap.orgId || snap.workspace?.org_id || '');
        const mine = (Array.isArray(snap.workspaces) ? snap.workspaces : []).filter((w)=>w && String(w.org_id ?? w.organization ?? '') === orgId);
        const only = (rows)=>rows.length === 1 ? rows[0] : null;
        const hqs = mine.filter((w)=>w.type === 'hq');
        const shared = mine.filter((w)=>w.type === 'shared');
        const main = hqs.length ? only(hqs) : shared.length ? only(shared) : only(mine);
        return !!cachedId && !!main && String(main.id || '') === cachedId;
    }
    if (!hit) return true // unrecognized segment — treated as a ROUTE, mirrors the live fallthrough
    ;
    return !!cachedId && String(hit.id || '') === cachedId;
};
const $fafd0f04fae9fc60$export$9b92d503e7eac9c = ({ workspaceId: workspaceId, maxAgeMs: maxAgeMs = 86400000 } = {})=>{
    try {
        const userId = $fafd0f04fae9fc60$export$11e46a9f34a2ecc3($fafd0f04fae9fc60$var$_rawAccessToken());
        if (!userId || !workspaceId) return null;
        const row = $fafd0f04fae9fc60$export$d1a395f012eb59dc({
            userId: userId,
            workspaceId: workspaceId,
            maxAgeMs: maxAgeMs
        });
        return row && Array.isArray(row.orgs) && row.orgs.length ? row.orgs : null;
    } catch  {
        return null;
    }
};
const $fafd0f04fae9fc60$export$50f46d6e6b9790f9 = ({ pathname: pathname } = {})=>{
    try {
        const userId = $fafd0f04fae9fc60$export$11e46a9f34a2ecc3($fafd0f04fae9fc60$var$_rawAccessToken());
        if (!userId) return null;
        const workspaceId = $fafd0f04fae9fc60$var$shellGetActiveWorkspacePointer();
        if (!workspaceId) return null;
        const snap = $fafd0f04fae9fc60$export$d1a395f012eb59dc({
            userId: userId,
            workspaceId: workspaceId
        });
        if (!snap) return null;
        const path = pathname != null ? pathname : typeof window !== 'undefined' && window.location && window.location.pathname || '';
        const rawSegs = $fafd0f04fae9fc60$var$shellGetWorkspaceRawSegments(path);
        if (!$fafd0f04fae9fc60$export$ceecefe863c980b9(snap, rawSegs, {
            mwtEnabled: $fafd0f04fae9fc60$var$shellIsMwtEnabled()
        })) return null;
        return snap;
    } catch (err) {
        console.warn('[bootSnapshot] resolveWarmBootSnapshot failed:', err?.message || err);
        return null;
    }
};

});

parcelRegister("9StQo", function(module, exports) {

$parcel$export(module.exports, "CANVAS_REDIRECT_RESERVED_SEGMENTS", () => $73104e9972420eb0$export$9c972599f00d674c);
$parcel$export(module.exports, "isCanvasProjectPath", () => $73104e9972420eb0$export$67e157606a5fcab9);
// canvasProjectRedirect.js — the workspace shell's catch-all classifier.
//
// tickets/workspace.md "should the workspace shell serve project CANVAS
// routes at all? (`/<owner>/<project>`)" — RESOLVED 2026-07-28, per Nika:
// option (b), serve them IN-SHELL. pages/projectRedirect.js now lazily folds
// the full canvas graph and mounts the editor page for project-shaped paths;
// this file only classifies which unmatched paths are project-shaped.
//
// History, because it explains two shipped bugs: option (a) — "redirect to
// the host that runs the editor" — was implemented here as
// `canvasProjectRedirectUrl = workspaceUrl(...)`, i.e. it redirected to the
// WORKSPACE SHELL ITSELF: the very host whose inability to serve the route
// triggered the redirect. On prod that was a same-URL reload of a page that
// still couldn't serve it; in dev it resolved to the dead `my.localhost`
// host (until workspace 00c8728a) — which is where the "New project" flow
// was actually dumping users. The builder is deleted; do not reintroduce it.
// Every first-path-segment this shell (or canvas, via its OWN explicit,
// non-catch-all page keys — dashboard/account/signup/studios/team-and-agents/
// agents) already owns (pages/index.js + manifest.js's route table). A path
// under one of these never redirects, even a deep sub-path with no exact
// page match (it 404s in-shell instead) — a close-miss under a REAL top
// segment must never bounce to a different host.
//
// Bare shared-library import, not a deep projectUrls.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0). Deferred-call
// wrapper, not a module-scope destructure — see app.js's circular-init note.

var $7iFOV = parcelRequire("7iFOV");
const $73104e9972420eb0$export$9c972599f00d674c = new Set([
    'w',
    // Auth + session
    'login',
    'signin',
    'signup',
    'signup-confirmation',
    'reset-password',
    'forgot-password',
    'verify-email',
    'auth',
    'github-auth-callback',
    '_session-bridge',
    'demo',
    // Domain libraries mounted at the shell root
    'tickets',
    'chat',
    'chats',
    'calendar',
    'inbox',
    'epics',
    'teams',
    'meet',
    'meet-guest',
    'notes',
    'documents',
    'docs',
    // Shell-owned intranet pages
    'admin',
    'people',
    'my',
    'announcements',
    'company',
    'data',
    'data-external',
    // 'system' is deliberately NOT reserved: the bare `/system` page was
    // unregistered so `/system/<key>` opens the "system" org's projects in
    // the canvas editor (see the `/system-status` note in pages/index.js —
    // the admin page lives at `/admin/system`). Listing it here re-created
    // the very shadowing that removal fixed: the catch-all classified
    // /system/platform as not-project-shaped and 404'd it (2026-07-29 per
    // Nika).
    'system-status',
    'integrations',
    'features',
    'profile',
    'settings',
    'user',
    'u',
    'add-app',
    // Lazy shared-library sub-apps mounted at the shell root
    'marketplace',
    'preview',
    'infra',
    'analytics',
    'workspace-analytics',
    'logs',
    // Canvas surfaces with their OWN explicit (non-catch-all) page keys —
    // unaffected by dropping canvas's '/*', reserved here too for deep
    // unmapped sub-paths under them.
    'dashboard',
    'account',
    'studios',
    'studio',
    'team-and-agents',
    'agents',
    // The POB getting-started pages (/getting-started/team, /imports): an
    // unmapped step under them is the shell's not-found, never the editor.
    'getting-started'
]);
const $73104e9972420eb0$export$67e157606a5fcab9 = (pathname)=>{
    const path = String(pathname || '');
    const segments = path.split('/').filter(Boolean);
    if (segments.length < 2) return false // a bare `/<owner>` alone names nothing to redirect to
    ;
    const first = segments[0].toLowerCase();
    // `/w/…` is reserved intranet space EXCEPT its canvas-project form — the
    // positional `p` marker decides (see the header note above).
    if (first === 'w') return !!(0, $7iFOV.shellParseWorkspaceProjectPath)(path);
    return !$73104e9972420eb0$export$9c972599f00d674c.has(first);
};

});

parcelRegister("9ocWj", function(module, exports) {

$parcel$export(module.exports, "orgSwitchStaleWorkspaces", () => $01c39e86013c5531$export$f8d6395144a4af83);
$parcel$export(module.exports, "orgSwitchUrlWorkspace", () => $01c39e86013c5531$export$7119da57df6d3757);
$parcel$export(module.exports, "orgSwitchHopWorkspace", () => $01c39e86013c5531$export$5352cef1729632d5);
// orgSwitchUrl.js — the workspace records an ORG SWITCH must treat as "stale
// URL segments", for the shell's `sdk.orgSwitched` handler.
//
// WHY (WS-ORG-SWITCH-URL-DOUBLE-WORKSPACE-SEGMENT-1, measured live
// 2026-08-21): scheme A stamps EVERY workspace URL as
// `/w/<org>/<ws-handle>/<route…>`. On an org switch the address bar still
// holds the OUTGOING org's URL, so segment 2 is the OUTGOING workspace's
// handle. `syncWorkspaceUrl(..., {rewriteOrg:true})` rebuilds the path from
// the settled state, and its belt-and-suspenders strip drops segment 2 only
// when it RECOGNISES it — against `state.workspace` + `state.workspaces`, or
// the raw `ws_<nanoid>` id shape.
//
// The shell was passing the INCOMING org's list. A raw-id handle
// (`ws_UYAOhQyNjm`) still self-identifies by shape, but a SLUG handle does
// not: leaving `/w/system/hq/tasks` for Bellforge produced
// `/w/bellforge/ws_UYAOhQyNjm/hq/tasks` — the outgoing `hq` slug kept as an
// extra segment, because no bellforge workspace is named `hq`.
//
// The handler holds the outgoing scope at entry (before the refetch pipeline
// re-scopes `root.workspace` / `root.workspaces`), so the fix is to CARRY it,
// not to guess: a slug is only strippable when it is a workspace we know we
// just left. Nothing here widens the strip to unknown segments — a real route
// segment (`/w/system/tasks`, the legacy bare form) is still never eaten.
//
// FA204 / frank trap: the export below is self-contained — no module-scope
// reads, no bare sibling-export calls (workspacePrefix.js header, readerVoice
// precedent).
// Merge the incoming org's workspaces with the outgoing org's workspaces and
// the outgoing ACTIVE workspace record, deduped by identity. Non-object and
// unidentifiable entries are dropped; every input is optional.
const $01c39e86013c5531$export$f8d6395144a4af83 = (outgoingWorkspace, outgoingList, incomingList)=>{
    const out = [];
    const seen = new Set();
    const push = (w)=>{
        if (!w || typeof w !== 'object') return;
        const sig = String(w.id ?? w._id ?? w.key ?? w.slug ?? '');
        if (!sig || seen.has(sig)) return;
        seen.add(sig);
        out.push(w);
    };
    if (Array.isArray(incomingList)) for (const w of incomingList)push(w);
    if (Array.isArray(outgoingList)) for (const w of outgoingList)push(w);
    push(outgoingWorkspace);
    return out;
};
const $01c39e86013c5531$export$7119da57df6d3757 = (candidate, newOrgId)=>{
    if (!candidate || typeof candidate !== 'object') return null;
    const wsOrg = String(candidate.org_id ?? candidate.organization ?? candidate.organizationId ?? candidate.org ?? '');
    const want = String(newOrgId ?? '');
    if (wsOrg && want && wsOrg !== want) return null;
    const handle = candidate.slug ?? candidate.key ?? candidate.id ?? candidate._id;
    if (!handle) return null;
    return candidate;
};
const $01c39e86013c5531$export$5352cef1729632d5 = (hopWorkspaceId, pools)=>{
    const want = String(hopWorkspaceId ?? '');
    if (!want) return null;
    const lists = Array.isArray(pools) ? pools : [];
    for (const list of lists){
        if (!Array.isArray(list)) continue;
        for (const w of list){
            if (!w || typeof w !== 'object') continue;
            if (String(w.id ?? '') === want || String(w._id ?? '') === want) return w;
            if (String(w.key ?? '') === want || String(w.slug ?? '') === want) return w;
        }
    }
    return /^ws_[A-Za-z0-9_-]+$/.test(want) ? {
        key: want
    } : null;
};

});

parcelRegister("crAoO", function(module, exports) {

$parcel$export(module.exports, "selectNonCoreMembers", () => $90f43dc2b6eca452$export$693fd958fbc9eef1);
$parcel$export(module.exports, "deactivateNonCoreMembers", () => $90f43dc2b6eca452$export$c99410285a9b6ce8);
// Bulk "deactivate all non-core members" — the write half of the admin danger
// zone's DzDeactivateAll action (pages/admin/danger.js).
//
// EXTRACTED FROM THE COMPONENT ON PURPOSE. This loop decides, per member,
// WHICH user id gets written. When that decision lived inside a `_dangerRow`
// closure it could not be asserted by anything, and it was wrong for months in
// a way that returned HTTP 200 the whole time (see below). It lives here so
// __tests__/deactivateNonCoreMembers.test.js can pin the targets.
//
// ── THE BUG THIS REPLACES ────────────────────────────────────────────────
// The old body called:
//
//   sdk.execute('workspaceProject.userProfiles', 'update',
//               { id: p.userId, payload: { status: 'left' } })
//
// which routed to the `/sb` PostgREST passthrough. That proxy lists
// `user_profiles` in USER_SCOPED_TABLES (server/workers/workspace-project/
// src/surfaces/sb.js) and therefore injects `user_id=eq.<caller>` into the URL
// filter AND overwrites `row.user_id` in the body from the verified auth
// scope — it must, because it forwards with service_role and has to re-impose
// the scoping RLS would otherwise do. The `id` the caller passed was accepted
// and then discarded.
//
// Net effect, every iteration: the ACTING ADMIN's own profile row was stamped
// `status: 'left'`, once per member. No member was ever deactivated (the
// feature silently did nothing) and the admin repeatedly marked themselves as
// having left. Both failures returned 200, which is why a smoke test never
// caught it — asserting a successful status here proves nothing.
//
// ── THE FIX ─────────────────────────────────────────────────────────────
// `sdk.updateUserHrProfile(userId, patch)` addresses
// `PATCH /core/users/:userId/hr-profile` (server UserHrProfileService), which
// resolves the target across all three id spaces the people roster emits
// (Mongo _id | supabaseUserId UUID | email), permits a self-write, requires a
// platform admin to write anyone else, and returns 403 rather than
// mis-scoping. A caller without the rights now FAILS LOUDLY instead of
// corrupting its own row behind a success status.
// Roles that keep a member active. Anyone whose effective role is outside this
// set is "non-core" and gets deactivated.
const $90f43dc2b6eca452$var$CORE_ROLES = new Set([
    'superadmin',
    'admin',
    'manager',
    'member'
]);
// Resolve a person's effective role. CU-10 §90 moved roles from `p.roles` onto
// `root.roles.byUser`; the legacy per-person array is still honored when
// present so a stale roster shape doesn't silently reclassify everyone.
const $90f43dc2b6eca452$var$_isCore = (person, rolesByUser)=>{
    const legacyRoles = Array.isArray(person.roles) && person.roles.length > 0 ? person.roles : null;
    if (legacyRoles) return legacyRoles.some((r)=>$90f43dc2b6eca452$var$CORE_ROLES.has(r));
    return $90f43dc2b6eca452$var$CORE_ROLES.has(rolesByUser[person.userId] || 'member');
};
const $90f43dc2b6eca452$export$693fd958fbc9eef1 = (people, rolesByUser = {})=>(Array.isArray(people) ? people : []).filter((p)=>p && p.userId && p.status !== 'left' && !$90f43dc2b6eca452$var$_isCore(p, rolesByUser));
const $90f43dc2b6eca452$export$c99410285a9b6ce8 = async (sdk, { people: people, rolesByUser: rolesByUser } = {})=>{
    if (!sdk || typeof sdk.updateUserHrProfile !== 'function') throw new Error("[deactivateNonCoreMembers] sdk.updateUserHrProfile is unavailable \u2014 refusing to fall back to the caller-scoped userProfiles route");
    const targets = $90f43dc2b6eca452$export$693fd958fbc9eef1(people, rolesByUser);
    const targeted = [];
    const failed = [];
    for (const person of targets)try {
        await sdk.updateUserHrProfile(person.userId, {
            status: 'left'
        });
        targeted.push(person.userId);
    } catch (error) {
        failed.push({
            userId: person.userId,
            error: error
        });
    }
    if (failed.length) {
        const err = new Error(`Deactivated ${targeted.length} of ${targets.length} members \u{2014} ${failed.length} failed (${failed[0].error?.message || 'unknown error'})`);
        err.targeted = targeted;
        err.failed = failed;
        throw err;
    }
    return {
        targeted: targeted,
        failed: failed
    };
};
var $90f43dc2b6eca452$export$2e2bcd8739ae039 = $90f43dc2b6eca452$export$c99410285a9b6ce8;

});

parcelRegister("d1ihk", function(module, exports) {

$parcel$export(module.exports, "adminDangerRoleBlock", () => $97a98c1a56e9110b$export$69524eaed272b9ea);
// /admin/danger — WHO MAY RUN EACH ACTION (CRUD-CONFIRM-STANDARD D10,
// 2026-10-30). The page opens to every `admin.danger.access` holder, but the
// server allows two of its three actions to far fewer callers. Read from the
// server's own rules (server origin/main ede72eba0):
//
//   • PURGE — POST /chat/messages/purge answers 403 `admin_role_required`
//     unless `auth.isSuperadmin` (workers/workspace-project/src/surfaces/
//     chat.js:416-418), and that is the caller's Mongo `User.globalRole ===
//     'admin'` (workers/workspace-project/src/auth.js:404-407). Its two token
//     legs (`symbols_role`, `symbols_roster_role`) were minted by the Supabase
//     auth plane, gone since 2026-07-27; nothing issues them now. A
//     `globalRole: 'owner'` does NOT pass it.
//   • DEACTIVATE — every write is PATCH /users/:userId/hr-profile, which
//     answers 403 `forbidden_not_self` unless the caller is a platform
//     superuser (src/domains/users/services/UserHrProfileService.js:89 and
//     117-118 → src/core/services/PlatformSuperuser.js:65-72): the
//     `platformSuperuser` bit on the User record. That module's env
//     allowlist (break-glass service accounts) is invisible here.
//   • EXPORT — no rule beyond the page's own gate; never blocked here.
//
// `root.user` is the caller's own /auth/me record, and it carries both
// `globalRole` and `platformSuperuser`. No record yet is NOT a refusal: the
// server stays the guard (lane A1's shape — an unknown role is not read-only).
//
// ON A CUSTOMER (WHITE-LABEL) DOMAIN NOBODY MAY. Every request whose `Origin`
// is a verified white-label host runs inside a host lock
// (src/core/middleware/customDomainScope.js:250-277, mounted before the
// /workspace-project plane at src/index.js:619 and before core at :666).
// Inside it the purge's `isSuperadmin` is false (the bridge sends
// `hostLocked`, src/index.js:375-376 → workers/workspace-project/src/auth.js:
// 404-407) and so is `isPlatformSuperuser` (PlatformSuperuser.js:66) —
// platform admins and superusers included. The shell holds the same fact
// before it mounts: `root.whitelabelHostScope` (state.js), written by
// `seedWhitelabelHostScope` (functions/whitelabelBrand.js) from GET
// /core/organizations/custom-domain-scope, which answers the scope that very
// middleware locked the request to (OrganizationController.js:3849-3857).
// An object there is a bound customer domain; `false` is a customer domain
// whose tenant could not be established (an unbound verified row locks to
// nothing, customDomainScope.js:253, and the shell renders no tenant at all);
// `null` is a platform host. Both customer cases answer the domain sentence
// for both actions, before any role is read. Not mirrored: a handoff session
// token carried to a platform host (no flow sends one there) — the server's
// 403 stays the answer.
//
// THE one check of the page: `right` names the action's rule ('purge' |
// 'deactivate'); the answer is the sentence that says who can (or that this
// domain cannot) — the row shows it, and the button stays disabled and asks
// nothing — or null when this caller may run the action here. A registered
// function (`el.call`); `this` is the calling element.
const $97a98c1a56e9110b$export$69524eaed272b9ea = function adminDangerRoleBlock(right) {
    const el = this;
    if (right !== 'purge' && right !== 'deactivate') return null;
    const root = el && el.state && el.state.root || null;
    if (!root) return null;
    const host = root.whitelabelHostScope;
    if (host === false || host && typeof host === 'object') return el.call('polyglot', 'admin.danger.domain.notAllowed');
    const user = root.user;
    if (!user || typeof user !== 'object') return null;
    let key = null;
    if (right === 'purge' && user.globalRole !== 'admin') key = 'admin.danger.purgeChat.notAllowed';
    else if (right === 'deactivate' && user.platformSuperuser !== true) key = 'admin.danger.deactivate.notAllowed';
    return key ? el.call('polyglot', key) : null;
};

});

parcelRegister("a8wem", function(module, exports) {

$parcel$export(module.exports, "adminTeamIsMe", () => $7613a711f9db59c7$export$44c5e7186581bdf7);
$parcel$export(module.exports, "adminTeamHasMe", () => $7613a711f9db59c7$export$f0aa5978e2fd6d39);
$parcel$export(module.exports, "adminToggleTeamPermission", () => $7613a711f9db59c7$export$8b2df2b00a29d743);
$parcel$export(module.exports, "adminRenameTeam", () => $7613a711f9db59c7$export$8fe17bf675ac875f);
$parcel$export(module.exports, "adminDeleteTeam", () => $7613a711f9db59c7$export$cc7508eb68dc29cc);
// /admin/teams — the team writes that change who may do what, behind the house
// dialogs (CRUD-CONFIRM-STANDARD, 2026-10-30).
//
//   • RENAME — a team could be created but never renamed (the SDK's
//     `updateTeam` had no caller). A prompt seeded with the current name; the
//     write is PATCH /organizations/:orgId/teams/:teamId `{ name }`, gated
//     server-side on `admin.teams`.
//   • DELETE — a team could not be deleted at all (`deleteTeam` had no
//     caller). The house confirm names the team and says what goes with it;
//     the write is DELETE /organizations/:orgId/teams/:teamId (`admin.teams`
//     plus the server's can-manage check for a confidential team). A SYSTEM
//     team is never offered: the seeder owns it (server Team.isSystem — "you
//     can't delete this").
//   • THE SELF-GUARD — a permission switch writes at once, and an admin could
//     switch off a permission their own access rests on (`admin.teams`,
//     `admin.team_permissions`, …) with one stray click. A switch turned OFF
//     on the signed-in person's OWN team (they are not an owner: owners bypass
//     every check) asks first; the page decides that and passes `askSelf`.
//     Every other switch stays one click, as before.
//
// Each export is a registered function (`el.call('adminRenameTeam', team)`);
// `this` is the calling element (state root, `sdk`, `call`, `router`). The
// write runs in the dialog's `onConfirm` only. No imports: the page passes
// what it resolved (Rule FA001 — functions read nothing from sibling files).
// The private helpers carry a `_team` prefix: frank lifts module-level
// helpers into ONE emitted globalScope, where a same-named helper of another
// file (`_fail` in pages/admin/teams.js, `_sdkOf` in moduleConsole.js) would
// collide (FA202).
const $7613a711f9db59c7$var$_teamRootOf = (el)=>el && el.state && el.state.root || null;
const $7613a711f9db59c7$var$_teamSdkOf = (el)=>el && el.sdk || el && el.context && el.context.methods && el.context.methods.sdk || null;
// A failure the person acted on is SAID (the shape of the page's `_fail`).
const $7613a711f9db59c7$var$_teamFail = (el, key, err)=>{
    el.call('openNotification', {
        title: el.call('polyglot', 'common.state.error'),
        message: el.call('polyglot', key).replace('{error}', err && err.message || err || ''),
        type: 'error'
    });
};
const $7613a711f9db59c7$export$44c5e7186581bdf7 = (root, email, userId)=>{
    const me = String(root && root.currentUserId || '');
    const myEmail = String(root && root.currentUserEmail || '').toLowerCase();
    if (me && userId != null && String(userId) === me) return true;
    return !!myEmail && String(email || '').toLowerCase() === myEmail;
};
const $7613a711f9db59c7$export$f0aa5978e2fd6d39 = (root, teamId)=>{
    if (!root || !teamId) return false;
    const me = String(root.currentUserId || '');
    const byId = me && root.teamsByUserId && root.teamsByUserId[me] || [];
    if (byId.some((t)=>t && t.id === teamId)) return true;
    const byEmail = root.teamsByEmail || {};
    for (const email of Object.keys(byEmail)){
        const entry = (byEmail[email] || []).find((t)=>t && t.id === teamId);
        if (entry && $7613a711f9db59c7$export$44c5e7186581bdf7(root, email, entry.userId)) return true;
    }
    return false;
};
function $7613a711f9db59c7$export$8b2df2b00a29d743(team, permKey, { askSelf: askSelf = false } = {}) {
    const el = this;
    const root = $7613a711f9db59c7$var$_teamRootOf(el);
    if (!root || !team || !permKey) return undefined;
    const next = new Set(team.permissions || []);
    const turningOff = next.has(permKey);
    if (turningOff) next.delete(permKey);
    else next.add(permKey);
    const permissions = [
        ...next
    ];
    // The switch paints from `team.permissions` (its `onCheck`), so a refused
    // write — or a cancelled question — repaints it from the record. Nudge the
    // repaint to be safe.
    const repaint = ()=>root.update({
            _permRetry: (root._permRetry || 0) + 1
        });
    const write = async ()=>{
        try {
            await el.call('updateTeamPermissions', root, {
                orgId: team.orgId,
                teamId: team.id,
                permissions: permissions
            });
        } catch (err) {
            console.warn('[admin/teams] permission toggle failed', err);
            repaint();
        }
    };
    if (!turningOff || !askSelf) return write();
    el.call('confirmDialog', {
        title: el.call('polyglot', 'admin.teams.perm.selfTitle').replace('{permission}', el.call('permLabelText', permKey)),
        message: el.call('polyglot', 'admin.teams.perm.selfMessage'),
        confirmText: el.call('polyglot', 'admin.teams.perm.turnOff'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: write,
        onCancel: repaint
    });
    return undefined;
}
function $7613a711f9db59c7$export$8fe17bf675ac875f(team) {
    const el = this;
    const root = $7613a711f9db59c7$var$_teamRootOf(el);
    if (!root || !team) return;
    el.call('promptDialog', {
        title: el.call('polyglot', 'admin.teams.rename.title'),
        message: el.call('polyglot', 'admin.teams.create.prompt'),
        placeholder: el.call('polyglot', 'admin.teams.create.prompt'),
        defaultValue: team.name || '',
        confirmText: el.call('polyglot', 'common.action.rename'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        onConfirm: async (value)=>{
            const name = String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
            if (!name || name === team.name) return;
            const sdk = $7613a711f9db59c7$var$_teamSdkOf(el);
            try {
                if (!sdk || typeof sdk.updateTeam !== 'function') throw new Error('SDK not available');
                const res = await sdk.updateTeam(team.orgId, team.id, {
                    name: name
                });
                const stored = res && (res.data || res) || {};
                const saved = typeof stored.name === 'string' && stored.name ? stored.name : name;
                root.update({
                    teams: (root.teams || []).map((t)=>t && t.id === team.id ? {
                            ...t,
                            name: saved
                        } : t)
                });
            } catch (err) {
                console.warn('[admin/teams] rename failed', err);
                $7613a711f9db59c7$var$_teamFail(el, 'admin.teams.rename.failed', err);
            }
        }
    });
}
// Drop one team id from an index of `key → [{ id, … }]`.
const $7613a711f9db59c7$var$_withoutTeam = (index, teamId)=>{
    const out = {};
    for (const key of Object.keys(index || {}))out[key] = (index[key] || []).filter((t)=>t && t.id !== teamId);
    return out;
};
function $7613a711f9db59c7$export$cc7508eb68dc29cc(team) {
    const el = this;
    const root = $7613a711f9db59c7$var$_teamRootOf(el);
    if (!root || !team || team.isSystem) return;
    const mine = $7613a711f9db59c7$export$f0aa5978e2fd6d39(root, team.id);
    el.call('confirmDialog', {
        title: el.call('polyglot', 'admin.teams.delete.title').replace('{team}', team.name || team.slug || ''),
        message: el.call('polyglot', mine ? 'admin.teams.delete.messageSelf' : 'admin.teams.delete.message'),
        confirmText: el.call('polyglot', 'common.action.delete'),
        cancelText: el.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: async ()=>{
            const sdk = $7613a711f9db59c7$var$_teamSdkOf(el);
            try {
                if (!sdk || typeof sdk.deleteTeam !== 'function') throw new Error('SDK not available');
                await sdk.deleteTeam(team.orgId, team.id);
            } catch (err) {
                console.warn('[admin/teams] delete failed', err);
                $7613a711f9db59c7$var$_teamFail(el, 'admin.teams.delete.failed', err);
                return;
            }
            // The invite drafts belong to the deleted team; the Back button
            // clears them the same way.
            root.update({
                teams: (root.teams || []).filter((t)=>t && t.id !== team.id),
                teamsByEmail: $7613a711f9db59c7$var$_withoutTeam(root.teamsByEmail, team.id),
                teamsByUserId: $7613a711f9db59c7$var$_withoutTeam(root.teamsByUserId, team.id),
                _teamInviteEmail: '',
                _teamInviteStatus: null
            });
            const routeRoot = el.call('findRouteRoot', el);
            if (routeRoot) el.router('/admin/teams', routeRoot);
        }
    });
}

});

parcelRegister("eMdOt", function(module, exports) {

$parcel$export(module.exports, "authWrapperTitle", () => $ac20435b0d8ad860$export$a1952b198fd5b140);
// The TITLE of a sign-in route wrapper (pages/index.js `login` / `signin`)
// on a white-label host (ws crm review of 178bd1266; relman, vault.pr:
// 2,487 ms "Log in / Symbols" over the edge-stamped "Vault Partners").
//
//   el.call('authWrapperTitle', 'workspace.page.login')
//
// The wrapper and the shared sign-in page it mounts BOTH carry metadata, and
// helmet keeps whichever title was last written. So on a custom-domain host:
//   • a NAMED brand is there → no title here: the inner page owns
//     "Sign in / <org>";
//   • the brand is still LOADING (root.whitelabelBrand null) → no title: the
//     edge-stamped one stays — never "… / Symbols";
//   • the lookup settled with NO brand (whitelabelBrand false, written by
//     applyWhitelabelBrandLate) → the wrapper's own title, never an empty tab.
// A platform host (isCustomDomainHost false or not registered) keeps the
// wrapper's own title, unchanged. `function`, not an arrow: el.call binds
// `this` to the element.
function $ac20435b0d8ad860$export$a1952b198fd5b140(key) {
    const el = this;
    const brand = el?.state?.root?.whitelabelBrand;
    if (brand && brand.name) return undefined;
    const fns = el?.context?.functions;
    const customDomain = typeof fns?.isCustomDomainHost === 'function' && !!el.call('isCustomDomainHost');
    if (customDomain && brand == null) return undefined;
    return el.call('polyglot', key);
}

});

parcelRegister("dbWbc", function(module, exports) {

$parcel$export(module.exports, "isPlatformHostname", () => $99a96eb66f2cac8e$export$5dca0be4db6346c6);
$parcel$export(module.exports, "pathNamesOrg", () => $99a96eb66f2cac8e$export$d815e91071265dd7);
$parcel$export(module.exports, "resolveCustomDomainPath", () => $99a96eb66f2cac8e$export$fd5bd2ef93e88483);
$parcel$export(module.exports, "bootCustomDomainScope", () => $99a96eb66f2cac8e$export$bfa6102916e875aa);
// WHITELABEL-1 — boot-time org resolution for a white-label host.
//
// Every other entry shape NAMES its org in the URL (`/w/<org>`, a project
// canvas owner segment, `/studio/<owner>`), and reconcileMwtOrgFromUrl already
// solves all three. A white-label host names its org NOWHERE in the URL:
// `https://app.bellforge.eu/` is a bare path, so the shell boots whatever
// workspace the user last used — someone else's, from the customer's point of
// view.
//
// Rather than teach the reconcile a fourth, URL-less source (it is a delicate
// path with documented workspace-isolation invariants), this resolves the host
// to its org/workspace and then hands off to the EXISTING `/w/<org>/<ws>`
// machinery by navigating there once. One code path stays authoritative for
// "which org is this tab", which is the property that made the previous
// three-shape bug fixable at all.
//
// The scope comes from the server (Organization.customDomains, verified rows
// only) — never a hardcoded host→org map, which would put deployment identity
// in the bundle and rot the moment a customer moves.

var $1X0Je = parcelRequire("1X0Je");

var $lb2Ei = parcelRequire("lb2Ei");

var $gNttC = parcelRequire("gNttC");

var $2C7Li = parcelRequire("2C7Li");
// Same thin-wrapper idiom mwtRouter.js uses — read the flag through the shared
// package at CALL time, never captured at module scope (the flag caches on
// `globalThis.__mwtFlagCache` and tests reset it between cases).
const $99a96eb66f2cac8e$var$shellIsMwtEnabled = (...args)=>(0, $1X0Je.default).functions.isMwtEnabled(...args);
// WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1 — the tab-side pointer setter.
// MWT off it writes THIS ORIGIN's localStorage, MWT on this tab's
// sessionStorage; a white-label host has its own origin, so the write can
// never move a my.symbols tab (activeWorkspacePointer.js owns the split).
const $99a96eb66f2cac8e$var$shellSetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspacePointer(...args);
const $99a96eb66f2cac8e$var$PLATFORM_SUFFIXES = [
    'symbols.app',
    'symbo.ls',
    'localhost'
];
const $99a96eb66f2cac8e$export$5dca0be4db6346c6 = (hostname)=>{
    const h = String(hostname || '').toLowerCase().split(':')[0];
    if (!h) return true;
    if ((0, $lb2Ei.isWhitelabelPreviewHost)(h)) return false;
    return $99a96eb66f2cac8e$var$PLATFORM_SUFFIXES.some((s)=>h === s || h.endsWith(`.${s}`));
};
const $99a96eb66f2cac8e$export$d815e91071265dd7 = (pathname, root)=>!!(0, $2C7Li.urlNamedOrgSlug)(pathname || '/', root);
const $99a96eb66f2cac8e$export$beac2be347d9fc89 = async (opts)=>{
    const o = opts || {};
    const hostname = o.hostname;
    const apiBase = String(o.apiBase || '').replace(/\/+$/, '');
    const fetchImpl = o.fetchImpl;
    if (!hostname || $99a96eb66f2cac8e$export$5dca0be4db6346c6(hostname)) return null;
    if (!apiBase || typeof fetchImpl !== 'function') return null;
    try {
        const url = `${apiBase}/core/organizations/custom-domain-scope?host=${encodeURIComponent(hostname)}`;
        const res = await fetchImpl(url, {
            credentials: 'omit'
        });
        if (!res || !res.ok) return null;
        const body = await res.json();
        return body && body.data || null;
    } catch (_) {
        return null;
    }
};
const $99a96eb66f2cac8e$export$903eae595bed5a8a = async (opts)=>{
    const o = opts || {};
    const hostname = o.hostname;
    const pathname = o.pathname || '/';
    const apiBase = String(o.apiBase || '').replace(/\/+$/, '');
    const fetchImpl = o.fetchImpl;
    const orgs = Array.isArray(o.orgs) ? o.orgs : [];
    if (!hostname || $99a96eb66f2cac8e$export$5dca0be4db6346c6(hostname)) return null;
    if (!apiBase || typeof fetchImpl !== 'function') return null;
    const scope = o.scope !== undefined ? o.scope : await $99a96eb66f2cac8e$export$beac2be347d9fc89({
        hostname: hostname,
        apiBase: apiBase,
        fetchImpl: fetchImpl
    });
    if (!scope || !scope.organizationId || !scope.workspaceId) return null;
    // The scope carries IDs; `/w/<org>` speaks SLUGS. Map through the orgs the
    // shell already loaded rather than inventing a second identity source.
    const org = orgs.find((x)=>{
        const id = x && (x.id || x._id);
        return id && String(id) === String(scope.organizationId);
    });
    const slug = org && (org.slug || org.username);
    if (!slug) return null;
    // WORKSPACE SEGMENT: the `ws_`-shaped KEY only, never a raw ObjectId.
    //
    // WHITELABEL-BOOT-LOOP-1 (measured on app.bellforge.eu, 2026-08-19: the tab
    // froze on every signed-in route). The scope's `workspaceId` is a raw
    // ObjectId, but the canonical workspace segment is the HANDLE
    // (`workspaceUrlHandle` = slug → key → id). Emitting the raw id produced a
    // URL the shell's own canonicalizer immediately rewrote away; this resolver
    // then saw a bare path again and re-emitted it. Two writers, opposite
    // directions, forever — a main-thread navigation loop that locked the
    // renderer. A `ws_`-shaped key is different in kind: it IS a first-class
    // handle (orgSwitchUrl.js law: "accept the id alone ONLY when it is already
    // ws_-shaped"), so the canonicalizer claims it and never rewrites it away.
    //
    // WHY the segment is stated at all
    // (WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1): a bare `/w/<org>` hands the
    // workspace pick to pointer → server claim, and the server claim is the
    // LAST WORKSPACE THE USER USED ANYWHERE — a multi-workspace user who left
    // my.symbols on another workspace of the same org then landed there under
    // the customer's domain. The host's scope row names its workspace; state
    // it when it can be stated safely, fall back to org-only when the key is
    // not handle-shaped.
    const wsKey = String(scope.workspaceKey || '');
    const wsSegment = /^ws_/.test(wsKey) ? wsKey : null;
    const home = wsSegment ? `/w/${slug}/${wsSegment}/` : `/w/${slug}/`;
    // Which org does the URL name? The caller that holds the shell root passes
    // it (`root`), so a canvas is told apart from an installed app's sub-page.
    const named = (0, $2C7Li.urlNamedOrgSlug)(pathname, o.root);
    const foreign = !!named && named !== slug;
    const bare = pathname === '/' || pathname === '';
    return {
        organizationId: String(scope.organizationId),
        workspaceId: String(scope.workspaceId),
        workspaceKey: wsSegment,
        slug: slug,
        foreign: foreign,
        path: bare || foreign ? home : null
    };
};
const $99a96eb66f2cac8e$export$fd5bd2ef93e88483 = async (opts)=>{
    const resolved = await $99a96eb66f2cac8e$export$903eae595bed5a8a(opts);
    return resolved ? resolved.path : null;
};
const $99a96eb66f2cac8e$export$bfa6102916e875aa = (root, el, opts = {})=>{
    const win = opts.win || (typeof window !== 'undefined' ? window : null);
    if (!win || !win.location) return Promise.resolve('none');
    const hostname = win.location.hostname;
    if ($99a96eb66f2cac8e$export$5dca0be4db6346c6(hostname)) return Promise.resolve('none');
    // WHITELABEL-BOOT-LOOP-1 — the guard must be PAGE-scoped, not element-
    // scoped. The first cut hung it on `el`, but the shell re-renders (and a
    // navigation re-creates this element), so every re-render handed back a
    // fresh element with a fresh, unset flag — the resolver re-armed and could
    // navigate again. Combined with the id-vs-handle mismatch above that became
    // an endless rewrite loop. `win` is the one object that survives every
    // re-render within a page load, so "at most once per load" is enforceable
    // only there. The element flag stays as a cheap first check.
    if (el && el._customDomainBootDone) return Promise.resolve('none');
    if (win.__symbolsCustomDomainBootDone) return Promise.resolve('none');
    // WHITELABEL-STRICT-TENANT-SCOPE-1 — NO path exempts a white-label tab from
    // this run any more. It used to return here for every path that "named an
    // org" (a bare /studio and every 2-segment app page included), so those
    // loads never pinned the host's org at all.
    const pathname = win.location && win.location.pathname || '/';
    if (el) el._customDomainBootDone = true;
    win.__symbolsCustomDomainBootDone = true;
    const apiBase = opts.apiBase;
    const fetchImpl = opts.fetchImpl || (typeof win.fetch === 'function' ? win.fetch.bind(win) : null);
    const maxAttempts = opts.maxAttempts != null ? opts.maxAttempts : 25;
    const delayMs = opts.delayMs != null ? opts.delayMs : 200;
    // WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1 — fetch the scope NOW, before
    // the orgs ladder. The fetch needs no orgs (only the slug mapping does),
    // and the moment it lands we stamp the TAB-SIDE workspace pointer so the
    // boot's own precedence (pointer → server claim) picks the host's
    // workspace instead of whatever my.symbols last used. The pointer write is
    // origin-scoped (this host's storage), so no my.symbols tab can move.
    // Fails closed exactly like the resolver: a null scope stamps nothing.
    // The pre-mount seed (whitelabelBrand.js seedWhitelabelHostScope) already
    // resolved this host's scope from the same endpoint: reuse it rather than a
    // second request, whose transient failure would CLEAR the pin the seed set.
    const seeded = root && root.whitelabelHostScope;
    const scopeSource = seeded && seeded.organizationId ? Promise.resolve(seeded) : $99a96eb66f2cac8e$export$beac2be347d9fc89({
        hostname: hostname,
        apiBase: apiBase,
        fetchImpl: fetchImpl
    });
    const scopePromise = scopeSource.then((scope)=>{
        if (scope && scope.workspaceId) try {
            $99a96eb66f2cac8e$var$shellSetActiveWorkspacePointer(String(scope.workspaceId));
        } catch (_) {}
        // WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1, the THIRD defect (the
        // switchOrg race). Publish the host's ORG here — the same moment, and for
        // the same reason, as the workspace pointer above: this is the earliest
        // instant we honestly know it, and every tick auth runs before it is a
        // tick that can state the ambient org instead. From here on auth stands
        // down (resolveActiveOrgId consults the pin), so the wrong org is never
        // written at all rather than written and corrected. Full argument in
        // hostScopePin.js. A null/failed scope CLEARS the pin — fail closed.
        (0, $gNttC.setHostScopeOrgId)(scope && scope.organizationId);
        // MIRROR the pin into root state for REACTIVE consumers
        // (WhitelabelRequestAccess). The module-level pin is silent: it can
        // land AFTER a subscriber's last evaluation, and nothing re-fires —
        // measured 2026-08-31 (the non-member gate stayed hidden with every
        // other input true). auth keeps reading the MODULE pin (its stand-down
        // must not depend on render timing); the root key exists only so
        // subscribeTo consumers re-evaluate when the pin lands. Same
        // fail-closed contract: a null scope mirrors null.
        try {
            root.update({
                _hostScopeOrgId: scope && scope.organizationId && String(scope.organizationId) || null
            }, {
                preventFetch: true
            });
        } catch (_) {}
        return scope;
    });
    // WHITELABEL-BOOT-STUCK-AFTER-SIGNIN-1 — releasing the one-shot when the
    // ladder DECIDED NOTHING.
    //
    // The guard above is armed BEFORE the ladder runs, which is right for the
    // loop it prevents but wrong for the signed-out first load. On
    // app.bellforge.eu the first page load is the SIGN-IN page: `root.orgs` is
    // empty because nobody is signed in yet, the ladder waits its 5 s
    // (25 x 200 ms), gives up, and the PAGE-scoped flag stays set for the rest
    // of that page load. The user then signs in, `orgs` populates on the very
    // same load — and the boot can never re-arm. The hub is left on "Opening
    // your workspace…", which has no failure state, forever. Measured
    // 2026-08-23: the backend scope lookup was healthy the whole time and
    // staging.my.symbols.app/w/bellforge/<ws> worked, because a URL that already
    // names the org makes `pathNamesOrg()` true and skips this path entirely.
    //
    // A timeout waiting for `orgs` is NOT a decision — nothing was resolved and,
    // crucially, NOTHING WAS NAVIGATED. Releasing the flag there cannot reopen
    // WHITELABEL-BOOT-LOOP-1, whose loop came from successful navigations
    // re-firing. Every path that actually decides (resolved a target, navigated,
    // or determined this host has no scope) keeps the one-shot.
    const releaseOneShot = ()=>{
        if (el) el._customDomainBootDone = false;
        win.__symbolsCustomDomainBootDone = false;
    };
    return new Promise((resolve)=>{
        // WAIT FOR THE ORG WE NEED, NOT FOR ANY ORG
        // (WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1, the SECOND defect).
        //
        // The ladder used to proceed the moment `root.orgs` was non-empty. But
        // resolveCustomDomainScope does not need SOME orgs, it needs THE org the
        // scope names — it maps organizationId to a slug through that list and
        // returns null when the id is absent. So a PARTIAL orgs array passed the
        // gate, the lookup then failed, and the boot resolved 'none': NO redirect,
        // no retry, and the one-shot NOT released (only the timeout path releases
        // it). The tab then keeps the last-used workspace on a customer's own
        // domain — the symptom Nika reported on gita.pr.symbols.app.
        //
        // THIS IS A DIFFERENT DEFECT FROM THE switchOrg RACE. On work.astio.ai the
        // redirect DOES happen and two un-awaited writers then fight over the org;
        // here the redirect never happens at all, so the ordering fix cannot reach
        // it. Two defects, one symptom.
        //
        // Waiting on the specific id closes the window without adding a timer: the
        // ladder already bounds itself, and a scope still unresolved after
        // maxAttempts releases the one-shot and decides nothing, exactly as before.
        // A null scope (not a white-label host) has no id to wait for and keeps the
        // old any-orgs behaviour.
        const hasScopeOrg = (orgs, scope)=>{
            if (!scope || !scope.organizationId) return orgs.length > 0;
            return orgs.some((x)=>x && String(x.id || x._id) === String(scope.organizationId));
        };
        let scopeSeen // undefined until the fetch settles
        ;
        scopePromise.then((s)=>{
            scopeSeen = s === undefined ? null : s;
        }).catch(()=>{
            scopeSeen = null;
        });
        const attempt = (n)=>{
            const orgs = root && Array.isArray(root.orgs) ? root.orgs : [];
            // Also wait while the scope fetch is still in flight (`scopeSeen`
            // undefined). Without that, the very first tick could pass the gate on a
            // partial orgs array before we even know WHICH org to look for — which
            // is the same hole in a smaller window, and it is what the two new tests
            // caught on the first run of this fix.
            if (scopeSeen === undefined || !orgs.length || !hasScopeOrg(orgs, scopeSeen)) {
                if (n >= maxAttempts) {
                    releaseOneShot();
                    return resolve('none');
                }
                setTimeout(()=>attempt(n + 1), delayMs);
                return;
            }
            scopePromise.then((scope)=>$99a96eb66f2cac8e$export$903eae595bed5a8a({
                    hostname: hostname,
                    pathname: pathname,
                    apiBase: apiBase,
                    fetchImpl: fetchImpl,
                    orgs: orgs,
                    scope: scope,
                    root: root
                })).then((resolved)=>{
                if (!resolved) return resolve('none');
                // Send the tab to `target` — the host's home: on a bare load (the MWT
                // hand-off below) and, WHITELABEL-STRICT-TENANT-SCOPE-1, whenever the
                // URL names ANOTHER tenant. Returns whether it navigated.
                const navigate = (target)=>{
                    // Never rewrite to the path we are already on. Belt-and-braces
                    // against WHITELABEL-BOOT-LOOP-1: even if some future caller
                    // defeats the once-guard, a no-op navigation cannot start a loop.
                    const here = win.location && win.location.pathname || '/';
                    if (!target || here === target) return false;
                    try {
                        win.history.replaceState(win.history.state, '', target);
                    } catch (_) {}
                    if (el && typeof el.router === 'function') try {
                        el.router(target, el.getRoot ? el.getRoot() : undefined);
                    } catch (_) {}
                    return true;
                };
                // WS-WHITELABEL-ORG-PIN-INERT-WITH-MWT-OFF-1 — the URL handoff is
                // INERT when the MWT flag is off, so with that flag off this whole
                // resolver used to be a no-op that still consumed its one-shot.
                //
                // The handoff above states the org by NAVIGATING to `/w/<slug>/` and
                // letting the prefix machinery pin the tab. That machinery is gated
                // on the flag at its first line: `reconcileMwtOrgFromUrl` returns
                // immediately when `isMwtEnabled()` is false, and `mwtOnRenderRouter`
                // actively HEALS a prefixed URL back to the bare route in that case.
                // So with `localStorage.mwt='off'` (or `?mwt=0`) nothing ever consumes
                // the prefix: we resolved the right org, emitted the right URL, and
                // the URL was discarded — measured live on app.bellforge.eu
                // 2026-08-25, where `/w/bellforge/ws_UYAOhQyNjm` was rewritten to `/`
                // inside the first second and held there.
                //
                // A single-org user never noticed, because the ambient org is the only
                // org. A MULTI-org user got whatever org the session last used — the
                // customer seeing ANOTHER TENANT'S workspace under their own domain,
                // which is the exact class WHITELABEL-1 exists to prevent.
                //
                // So when the prefix cannot be consumed, state the org through the
                // channel that IS live in that mode: the same client-only rescope
                // `reconcileMwtOrgFromUrl` uses for its cross-org branch —
                // `sdk.switchOrg(id, { skipPersist: true })`. It loads the org into
                // THIS tab's root via the existing onWorkspaceChange pipeline with no
                // Mongo PATCH and no cross-tab broadcast, so a white-label tab cannot
                // move a shared pointer out from under the user's other tabs.
                //
                // Deliberately NOT the other option on the table (force the MWT flag
                // ON for custom-domain hosts): that would silently re-enable per-tab
                // pointer scoping, URL prefixes and convergence gating for a customer
                // who explicitly opted out, changing far more than "which org is this
                // tab" — and the flag's opt-out is a documented affordance.
                if (!$99a96eb66f2cac8e$var$shellIsMwtEnabled()) {
                    const sdk = opts.sdk || null;
                    // A URL naming another tenant leaves for the host's BARE home: with
                    // the flag off a `/w/` prefix is healed away, and the pin below is
                    // what states the org.
                    const left = resolved.foreign ? navigate('/') : false;
                    if (!sdk || typeof sdk.switchOrg !== 'function') return resolve(left ? 'redirected' : 'none');
                    // Already this org — no org hop, but the run still DECIDED:
                    // the workspace pointer above is this branch's whole point
                    // (WHITELABEL-HOST-KEEPS-ACTIVE-WORKSPACE-1: same org, wrong
                    // workspace was exactly the case that leaked the my.symbols
                    // active workspace onto the customer's host). 'pinned', not
                    // 'none', so the one-shot is kept — a decision was made.
                    const activeOrgId = sdk._context && sdk._context.activeOrgId;
                    if (!(activeOrgId && String(activeOrgId) === resolved.organizationId)) try {
                        Promise.resolve(sdk.switchOrg(resolved.organizationId, {
                            skipPersist: true
                        })).catch((err)=>console.warn('[whitelabel] org pin failed:', err && err.message || err));
                    } catch (err) {
                        console.warn('[whitelabel] org pin threw:', err && err.message || err);
                        return resolve(left ? 'redirected' : 'none');
                    }
                    return resolve(left ? 'redirected' : 'pinned');
                }
                // MWT on. The host's own route — a bare /studio, an app page, its
                // own /w/<slug>/… — stays where it is: the boot already resolved
                // this tab inside the host's tenant (bootResolve states the host's
                // org and workspace pre-render), so there is nothing to hand off.
                if (!resolved.path) return resolve('pinned');
                return resolve(navigate(resolved.path) ? 'redirected' : 'none');
            }).catch(()=>resolve('none'));
        };
        attempt(0);
    });
};

});
parcelRegister("2C7Li", function(module, exports) {

$parcel$export(module.exports, "isProjectCanvasPath", () => $1e7526b3a7dfe152$export$2234089854fbd629);
$parcel$export(module.exports, "urlOrgSlug", () => $1e7526b3a7dfe152$export$2e3261de55ecc044);
$parcel$export(module.exports, "urlNamedOrgSlug", () => $1e7526b3a7dfe152$export$a8537d9819cccf44);
// urlOrgSlug.js — which ORG does a shell URL name?
//
// Moved out of app.js (WHITELABEL-STRICT-TENANT-SCOPE-1) so every caller that
// asks this question shares ONE definition: app.js's MWT reconcile and its
// neutral-chrome test (`_foreignOrgUrl`), the custom-domain boot
// (customDomainBoot.js), and the white-label route guard
// (whitelabelRouteGuard.js). A second copy of the reserved list or the canvas
// rule is exactly the drift this file exists to prevent.
//
// Pure path classifiers (Rule 64: reads only). `root` is the shell's root
// STATE, consulted only for the installed module routes.

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");
// Read through the shared package at CALL time (app.js's idiom) — the
// barrel's default is not safe to destructure at module scope.
const $1e7526b3a7dfe152$var$moduleRoutesFromRoot = (...args)=>(0, $1X0Je.default).functions.moduleRoutesFromRoot(...args);
const $1e7526b3a7dfe152$var$shellIsModuleRoute = (...args)=>(0, $1X0Je.default).functions.isModuleRoute(...args);
const $1e7526b3a7dfe152$var$shellGetWorkspacePrefixSlug = (...args)=>(0, $1X0Je.default).functions.getWorkspacePrefixSlug(...args);
const $1e7526b3a7dfe152$export$83804a2854744e2a = new Set([
    'studio',
    'workspaces',
    'tickets',
    'tasks',
    'task',
    'ticket',
    'chat',
    'meet',
    'calendar',
    'dashboard',
    'admin',
    'marketplace',
    // The one catalogue (decision 7): /apps (Workspace apps) and /apps/store
    // (the App Store tab). Unreserved, /apps/store read as owner "apps" /
    // project "store" — a canvas laid under the header (live on dev,
    // 2026-10-25).
    'apps',
    'notes',
    // Legacy alias — documents→notes rename (2026-08-06 per Nika); keep
    // reserved so a stale /documents/<key> deep link never misreads as an
    // <owner>/<project> canvas pair.
    'documents',
    'settings',
    'profile',
    'system-status',
    'logs',
    'analytics',
    'search',
    'notifications',
    'help',
    'data',
    'feed',
    'user',
    'u',
    'auth',
    // Every other two-segment page the shell serves (pages/index.js). A
    // `/<a>/<b>` page whose first segment is not here reads as a project canvas
    // of owner "<a>": the org reconcile finds no member org of that name and,
    // once its retries run out, rescopes the tab to the workspace home — POB
    // S9's /getting-started/team did that live on dev (W25, 2026-10-30) — and
    // the shell lays the page out full-bleed as a canvas.
    // __tests__/gettingStartedRouteIsNotACanvas.test.js gates the page map
    // against this list, so a new two-segment page cannot miss it again.
    'getting-started',
    // /infra/status (the bare /infra stays the full-bleed deployment canvas
    // through app.js's own _isInfraCanvasPath).
    'infra',
    'resolutions',
    // The public share viewer, /s/<token>. It is chromeless, so its layout does
    // not change; signed in, the reconcile read "s" as an org slug.
    's',
    'workspace-analytics',
    // `w` reserves the multi-workspace-tabs prefix segment (`/w/<org-slug>`) so a
    // workspace URL is never misread as a `<owner>/<project>` canvas pair (§6b).
    'w'
]);
const $1e7526b3a7dfe152$export$2234089854fbd629 = (p, root)=>{
    const path = (0, $7iFOV.shellStripWorkspacePrefix)(p || '');
    const segs = path.split('/').filter(Boolean);
    if (segs.length !== 2 || $1e7526b3a7dfe152$export$83804a2854744e2a.has(segs[0])) return false;
    return !$1e7526b3a7dfe152$var$shellIsModuleRoute(path, $1e7526b3a7dfe152$var$moduleRoutesFromRoot(root));
};
const $1e7526b3a7dfe152$export$2e3261de55ecc044 = (p, root)=>{
    const path = (0, $7iFOV.shellStripWorkspacePrefix)(p || '');
    const segs = path.split('/').filter(Boolean);
    if (!segs.length) return null;
    // `/studio/<owner>` + `/workspaces/<owner>` — org is segment 2 (the same rule
    // studios.js's own ownerSlugFromUrl applies to load that board's data). A
    // bare `/studio` names NO org.
    if (segs[0] === 'studio' || segs[0] === 'workspaces') return segs[1] || null;
    // `/<owner>/<key>` — a live project canvas; the owner segment IS the org slug.
    if ($1e7526b3a7dfe152$export$2234089854fbd629(path, root)) return segs[0] || null;
    return null;
};
const $1e7526b3a7dfe152$export$a8537d9819cccf44 = (p, root)=>$1e7526b3a7dfe152$var$shellGetWorkspacePrefixSlug(p || '') || $1e7526b3a7dfe152$export$2e3261de55ecc044(p, root) || '';

});


parcelRegister("ehZst", function(module, exports) {

$parcel$export(module.exports, "DEMO_BLOCKED_ROUTE_RE", () => $a672538fe70399c4$export$5e2480e7e98dadb3);
$parcel$export(module.exports, "demoRouteGuard", () => $a672538fe70399c4$export$14c36f24c0637489);
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).

var $7iFOV = parcelRequire("7iFOV");

var $iJIxS = parcelRequire("iJIxS");
const $a672538fe70399c4$export$5e2480e7e98dadb3 = /^\/(admin|data|features|people|team-members)(\/|$)/;
const $a672538fe70399c4$export$14c36f24c0637489 = ({ pathname: pathname, element: element, query: query, hash: hash })=>{
    const root = element?.state?.root || element?.state;
    if (!root?.isDemo) return true;
    // Carry the blocked navigation's query + hash onto the bounce target — the
    // guard fires INSIDE the router before the target URL is parsed any
    // further, so `query`/`hash` here are the smbls router's own parse of the
    // path that was being navigated to (see plugins/router/index.js's
    // `guardContext`), not the page the visitor is leaving. Dropping them was
    // the same "redirect rebuilt from a bare '/' " bug as the module-route-leave
    // + demo-lockdown bounces in app.js (see functions/bootRedirectQuery.js) —
    // same class, different call site (a router GUARD string return, not
    // `el.router()`), so fixed the same way: reattach instead of discarding.
    const tail = (0, $iJIxS.queryHashTail)(query, hash);
    // Strip any `/w/<org-slug>` prefix before the lockdown test — otherwise a
    // prefixed `/w/acme/admin` slips past the anchored `^/(admin|…)` regex and a
    // demo session reaches admin/data/features/other-org people (§6d; security).
    // No-op until Phase 3 emits the prefix.
    if ($a672538fe70399c4$export$5e2480e7e98dadb3.test((0, $7iFOV.shellStripWorkspacePrefix)(pathname || ''))) return '/' + tail;
    // Bare /studio renders the all-workspaces dashboard canvas, which is empty
    // for a fresh sandbox — but the org's studios board (/studio/<slug>) shows
    // the seeded "Acme Landing" project frame. Land the demo visitor there so
    // the header "Studio" tab always opens onto content.
    if (pathname === '/studio') {
        const slug = root.orgs?.[0]?.slug || root.org?.slug;
        if (slug) return `/studio/${slug}` + tail;
    }
    return true;
};

});

parcelRegister("7uzFM", function(module, exports) {

$parcel$export(module.exports, "commRouteGuard", () => $574701a074585c88$export$844e9052d7888e76);

var $iJIxS = parcelRequire("iJIxS");
const $574701a074585c88$export$844e9052d7888e76 = ({ pathname: pathname, element: element, query: query, hash: hash })=>{
    const call = element && typeof element.call === 'function' ? element.call.bind(element) : null;
    if (!call || !call('isCommHost')) return true;
    const path = String(pathname || '/');
    if (call('isCommRoute', path)) return true;
    const tail = (0, $iJIxS.queryHashTail)(query, hash);
    const home = call('commHome') + tail;
    const bare = call('stripWorkspacePrefix', path.split(/[?#]/)[0]) || '/';
    if (bare === '/') return home;
    if (call('openOnWorkspaceHost', element, path + tail)) return false;
    return home;
};

});

parcelRegister("gqVTy", function(module, exports) {

$parcel$export(module.exports, "hasUnsavedInput", () => $bf6bfbcb5cd96949$export$e06b83a9910adc8e);
// hasUnsavedInput — does this page (or pane) hold work the user would lose if
// it were unmounted? (perf/shell-keepalive, review Delta 2, 2026-10-10)
//
//   el.call('hasUnsavedInput', pageOrPaneEl)   // or with `this` = that element
//
// A page is unsaved ONLY when it SAYS so. Two declarations count, anywhere in
// its element tree:
//   • `isDirty: (el, s) => boolean` — the page-level hook;
//   • `dirty` — the flag editors and AppDialog already set (a value or a fn).
// A declaration that throws counts as unsaved: a bug must never cost input.
//
// There is deliberately NO value heuristic. Comparing a field's live value with
// the value the framework rendered misread `{{ }}` template values and value
// functions that use their context, pinned pages with a page-local search box
// and pages whose form was already saved — and it never saw the field kinds
// below. A page with any of these MUST declare `isDirty` / `dirty` to be
// protected:
//   • select / AppSelect / AppSelectCompact;
//   • checkbox, radio, range, date, time, datetime-local, month, week, color,
//     file inputs;
//   • contenteditable (chat and mail Composer, tickets TicketDetailModal /
//     GeneralMain, every rich-text editor) and Monaco;
//   • widgets that write the value in code and fire only `change`
//     (date pickers, AppFieldChips, AppFieldSegmented, AppFieldColors);
//   • fields in a modal or dropdown rendered outside the page (ModalRoot).
// Typed text in a page that declares nothing is NOT protected.
//
// Used by the PageSlot keep-alive cap (canvas PageSlot `_hostPinned`) and the
// split-pane replace, with `confirmDiscardChanges` as the one prompt.
function $bf6bfbcb5cd96949$export$e06b83a9910adc8e(container) {
    const LIMIT = 20000;
    const root = container || this;
    if (!root || typeof root !== 'object') return false;
    // A DISPOSED element holds no work: smbls `remove()` clears `__ref` but keeps
    // the element's own evaluated props (a removed page keeps `isDirty: true`).
    // A stale `root.__slotLiveHosts` entry must never make a split ask about a
    // page that is already gone (__tests__/hasUnsavedInputDisposedHost.test.js).
    if (!root.__ref) return false;
    const declares = (el, prop)=>{
        const v = el[prop];
        if (typeof v !== 'function') return !!v;
        try {
            return !!v.call(el, el, el.state, el.context);
        } catch (err) {
            return true;
        }
    };
    const stack = [
        root
    ];
    let seen = 0;
    while(stack.length && seen < LIMIT){
        const el = stack.pop();
        seen++;
        if (!el || typeof el !== 'object') continue;
        if (declares(el, 'isDirty') || declares(el, 'dirty')) return true;
        const kids = el.__ref && el.__ref.__children;
        if (!Array.isArray(kids)) continue;
        for (const k of kids){
            const child = typeof k === 'string' ? el[k] : k;
            if (child && typeof child === 'object' && child !== el) stack.push(child);
        }
    }
    return false;
}

});

parcelRegister("bq0U5", function(module, exports) {

$parcel$export(module.exports, "confirmDiscardChanges", () => $8502d2dbbda249d5$export$7e3b464f861adab6);
// confirmDiscardChanges — the ONE in-app "Discard changes?" prompt
// (perf/shell-keepalive, review D5 + Delta 2 N1, 2026-10-10).
//
//   el.call('confirmDiscardChanges', { onDiscard, onKeep })
//
// Asked before a page that DECLARES unsaved work (`hasUnsavedInput`) is
// dropped: the PageSlot keep-alive cap (canvas PageSlot `_confirmDiscardParked`)
// and the split-pane replace. Keep is the DEFAULT. Exactly one of the two
// callbacks runs, once:
//   • Discard (the confirm button)       → onDiscard
//   • Keep (the cancel button)           → onKeep
//   • Esc / a backdrop click             → onKeep. The windows plugin pops the
//     layer through ModalRoot `_popTop` / `_popAt`, which run ONLY `onClose`
//     — never `onCancel`, although the plugin's confirmDialog header says so
//     (framework ticket) — so the local `onClose` ends an open request as Keep;
//   • the layer is refused (5 layers open) → onKeep at once.
function $8502d2dbbda249d5$export$7e3b464f861adab6(opts = {}) {
    const el = this;
    const t = (key)=>el.call('polyglot', key);
    let settled = false;
    const settle = (fn)=>{
        if (settled) return;
        settled = true;
        if (typeof fn === 'function') fn();
    };
    const id = el.call('confirmDialog', {
        title: t('workspace.unsaved.discardTitle'),
        message: t('workspace.unsaved.discardMessage'),
        confirmText: t('workspace.unsaved.discard'),
        cancelText: t('workspace.unsaved.keep'),
        // The house confirm (CRUD standard D1): the primary button, no icon.
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>settle(opts.onDiscard),
        onCancel: ()=>settle(opts.onKeep),
        onClose: ()=>settle(opts.onKeep)
    });
    if (!id) settle(opts.onKeep);
    return id || null;
}

});

parcelRegister("5wIx1", function(module, exports) {

$parcel$export(module.exports, "markPageSaved", () => $0109d8b59a702259$export$39f3f509b20be590);
// markPageSaved — the page's save SUCCEEDED: every shared field-kit control in
// it takes its current value as the loaded one and is no longer unsaved
// (FIELD-KIT DIRTY, shared AppField.js; perf/shell-keepalive 2026-10-10).
//
//   el.call('markPageSaved', pageOrFormEl)   // or with `this` = that element
//
// Call it ONLY after the save resolved. A failed save does not call it, so the
// controls keep declaring unsaved work and the keep-alive cap / split-pane
// replace still ask "Discard changes?" for the page. Returns how many controls
// it cleared.
function $0109d8b59a702259$export$39f3f509b20be590(container) {
    const LIMIT = 20000;
    const root = container || this;
    if (!root || typeof root !== 'object') return 0;
    const stack = [
        root
    ];
    let seen = 0;
    let cleared = 0;
    while(stack.length && seen < LIMIT){
        const el = stack.pop();
        seen++;
        if (!el || typeof el !== 'object') continue;
        if (el.__kitTouched && el.scope && typeof el.scope.kitSaved === 'function') {
            el.scope.kitSaved(el);
            cleared++;
        }
        const kids = el.__ref && el.__ref.__children;
        if (!Array.isArray(kids)) continue;
        for (const k of kids){
            const child = typeof k === 'string' ? el[k] : k;
            if (child && typeof child === 'object' && child !== el) stack.push(child);
        }
    }
    return cleared;
}

});

parcelRegister("2Od7Q", function(module, exports) {

$parcel$export(module.exports, "creditGuardState", () => $20ba6ebd88c316e6$export$a1ad358a5230e76d);
$parcel$export(module.exports, "creditBlockerShown", () => $20ba6ebd88c316e6$export$719874648ab5f429);
$parcel$export(module.exports, "creditShortState", () => $20ba6ebd88c316e6$export$6c66a2f5d5969aa1);
$parcel$export(module.exports, "askAdminsForCredits", () => $20ba6ebd88c316e6$export$29d304c76653c905);
$parcel$export(module.exports, "creditPillVisible", () => $20ba6ebd88c316e6$export$12501f409fc10d44);
$parcel$export(module.exports, "creditDockMode", () => $20ba6ebd88c316e6$export$4b958cda4fdc3e06);
$parcel$export(module.exports, "loadCreditGuard", () => $20ba6ebd88c316e6$export$248ed557d4369599);
$parcel$export(module.exports, "creditBlockerDismissedStorageKey", () => $20ba6ebd88c316e6$export$ffbaf3cf7490ac37);
$parcel$export(module.exports, "readCreditBlockerDismissed", () => $20ba6ebd88c316e6$export$9e8c851ddbfb6a21);
$parcel$export(module.exports, "writeCreditBlockerDismissed", () => $20ba6ebd88c316e6$export$40c2d4b6f88817ae);
$parcel$export(module.exports, "notifyCreditThreshold", () => $20ba6ebd88c316e6$export$247a9dba1d8c1f63);
$parcel$export(module.exports, "CREDITS_EXHAUSTED_ERROR_CODES", () => $20ba6ebd88c316e6$export$2944bdd33c0a5fe2);
$parcel$export(module.exports, "notifyCreditsExhaustedFromMessage", () => $20ba6ebd88c316e6$export$b00b05fbb7f693dc);
// creditGuard — the workspace credit safety surface's data half.
//
// Feeds three UI consumers (tickets/fable.md, Nika 2026-08-13 "beautiful
// workspace-blocker when workspace runs out of credits. also notifications +
// banner to admin when its approaching to end"):
//   • CreditBlocker  — full-viewport stop when the workspace is EXHAUSTED
//   • CreditBanner   — admin corner pill for LOW / CRITICAL, links /credits
//   • threshold notifications — toast for the signed-in admin + persisted
//     bell notifications for the OTHER admins, deduped per workspace+month.
//
// Data: `root._creditGuard` — fetched via `sdk.getCreditBalance(wsId)` (the
// exact call /credits' own balance card makes, pages/admin/usage.js) on boot
// (loadPrivateData fan-out) and on every workspace switch (onWorkspaceChange
// refetch block; the key is in state.js's WORKSPACE_SCOPED_KEYS wipe
// registry, per the workspace-switch isolation invariants). All figures come
// from the server's credit-meter — nothing here hardcodes a grant size,
// price, or credit count (feedback_never_hardcode_use_db_record). The
// LOW/CRITICAL fractions are client UX presentation thresholds (when to
// start warning), not billing-contract values — the same class of constant
// as ProgressBar's warnAt/dangerAt on the usage page.
//
// FA204 / frank functions-file convention: every export below is
// SELF-CONTAINED — no export reads a sibling export or a module-scope
// helper (the frank lift extracts each export individually; a bare sibling
// reference reads as undefined after serialization —
// project_frank_drops_module_local_helpers). The status derivation is
// therefore inlined where needed.
//
// Bare shared-library import + call-time deferred reads — an eager
// module-scope destructure of the barrel's default crashes the shell boot
// inside the shared-barrel init cycle (see workspaceProjects.js).

var $1X0Je = parcelRequire("1X0Je");
const $20ba6ebd88c316e6$export$a1ad358a5230e76d = function(root) {
    const r = root || this?.state?.root;
    const raw = r?._creditGuard;
    if (!raw) return {
        loaded: false,
        error: null,
        status: null
    };
    const data = raw.data || raw;
    if (data.error) return {
        loaded: true,
        error: data.error,
        status: null
    };
    // UNKNOWN ≠ ZERO (CREDIT-BLOCK-1 / FALSE-ZERO-1). The server marks a
    // balance it could not resolve with `found: false` + NULL numerics
    // (CreditsService.getWorkspaceBalance). The coercion MUST sit behind that
    // discriminator, not in front of it: `null ?? 0` evaluates to `0`, so the
    // old `Number(data.total ?? 0)` turned both a null total AND an absent
    // field into a confident zero — which became `exhausted`, which became a
    // full-viewport lockout on a workspace holding 1.25M credits. A balance
    // we cannot read is `'unknown'`, and nothing may be gated on it.
    const rawTotal = data.total;
    const totalNum = Number(rawTotal);
    if (data.found === false || rawTotal == null || rawTotal === '' || !Number.isFinite(totalNum)) return {
        loaded: true,
        error: null,
        status: 'unknown',
        total: null,
        grantSize: null,
        grantRemaining: null,
        topupRemaining: null
    };
    const total = totalNum;
    const grantSize = Number(data.grantSize ?? 0);
    const grantRemaining = Number(data.grantRemaining ?? 0);
    const topupRemaining = Number(data.topupRemaining ?? 0);
    let status = 'ok';
    if (total <= 0) status = 'exhausted';
    else if (grantSize > 0 && total <= grantSize * 0.1) status = 'critical';
    else if (grantSize > 0 && total <= grantSize * 0.3) status = 'low';
    return {
        loaded: true,
        error: null,
        status: status,
        total: total,
        grantSize: grantSize,
        grantRemaining: grantRemaining,
        topupRemaining: topupRemaining
    };
};
const $20ba6ebd88c316e6$export$719874648ab5f429 = function(el, root, seed) {
    const e = el || this;
    const r = root || e?.state?.root;
    if (!e || !r || !r.signedIn) return false;
    if (e.call('isWhitelabelNonMemberGateActive', r)) return false;
    // Scheme-A URLs carry the /w/<org>/<workspace> prefix — strip it so the
    // allowlist matches the ROUTE, not the tenancy prefix.
    const path = e.call('stripWorkspacePrefix', r.currentPath || '/') || '/';
    if (path.startsWith('/admin/usage') || path.startsWith('/login') || path.startsWith('/auth') || path.startsWith('/profile') || path.startsWith('/account')) return false;
    if (r._creditBlockerDismissed) return false;
    // `_creditBlockerDismissed` is in-memory root state, so ANY remount wiped it
    // and re-armed the gate on every page mount (CREDITS-GATE-UI-BREAK-1); the
    // sessionStorage marker survives a remount within the tab and dies with it.
    const wsId = r.workspace?.id || r.workspace?._id || null;
    if (wsId && e.call('readCreditBlockerDismissed', wsId)) {
        if (seed && typeof r.update === 'function') r.update({
            _creditBlockerDismissed: true
        }, {
            preventFetch: true
        });
        return false;
    }
    const guard = e.call('creditGuardState', r);
    // 'unknown' deliberately does NOT reach here — only a positively confirmed
    // zero gates (CREDIT-BLOCK-1 defect #2, fail direction).
    return !!(guard && guard.loaded && !guard.error && guard.status === 'exhausted');
};
const $20ba6ebd88c316e6$export$6c66a2f5d5969aa1 = function(el, root) {
    const e = el || this;
    const r = root || e?.state?.root;
    const short = r?._creditsShort;
    if (!e || !r || !short || short.dismissed) return null;
    const needed = Number(short.needed);
    const reported = Number(short.available);
    if (!Number.isFinite(needed) || !Number.isFinite(reported)) return null;
    const guard = e.call('creditGuardState', r);
    if (guard && guard.status === 'exhausted') return null;
    const read = Number(r._creditGuard && r._creditGuard._at);
    const total = Number(guard && guard.total);
    const guardIsNewer = !!guard && guard.loaded && !guard.error && guard.status !== 'unknown' && Number.isFinite(total) && Number.isFinite(read) && read >= Number(short.at || 0);
    const balance = guardIsNewer ? total : reported;
    if (!(balance > 0) || balance >= needed) return null;
    return {
        needed: needed,
        available: balance,
        admin: !!e.call('currentUserIsAdmin', r),
        // A member has already asked the admins about THIS refusal.
        asked: !!short.asked
    };
};
const $20ba6ebd88c316e6$export$29d304c76653c905 = async function(el, root) {
    const host = el && el.call ? el : this;
    const r = root || host?.state?.root;
    if (!r || !host || typeof host.call !== 'function') return false;
    const short = r._creditsShort;
    if (!short || short.asked) return false;
    const t = (key)=>String(host.call('polyglot', key));
    const toast = (type, title, message)=>{
        try {
            host.call('openNotification', {
                type: type,
                title: title,
                message: message
            });
        } catch (e) {}
    };
    const fmt = (n)=>Number(n || 0).toLocaleString('en-US');
    const byUser = r.roles?.byUser || {};
    const people = Array.isArray(r.people) ? r.people : [];
    const admins = people.filter((p)=>{
        const role = p?.userId != null ? byUser[p.userId] : null;
        return role === 'owner' || role === 'admin';
    });
    const me = r.currentUserEmail;
    const adminEmails = admins.map((p)=>p.email).filter((email)=>email && email !== me);
    if (!adminEmails.length) {
        const names = admins.map((p)=>p.name).filter(Boolean).slice(0, 3).join(', ');
        toast('error', t('workspace.credits.ask.failedTitle'), names ? t('workspace.credits.ask.whoMessage').replace('{names}', ()=>names) : t('workspace.credits.ask.failedMessage'));
        return false;
    }
    let who = '';
    try {
        const mine = host.call('currentUser', r);
        who = mine && mine.name || '';
    } catch (e) {}
    who = who || me || '';
    const wsName = r.workspace?.name || t('workspace.credits.thisWorkspace');
    const wsId = r.workspace?.id || r.workspace?._id || null;
    const body = t('workspace.credits.ask.body').replace('{name}', ()=>who).replace('{workspace}', ()=>wsName).replace('{needed}', ()=>fmt(short.needed)).replace('{available}', ()=>fmt(short.available));
    const sent = await Promise.all(adminEmails.map((email)=>Promise.resolve(host.call('createNotification', {
            userEmail: email,
            type: 'system',
            title: t('workspace.credits.ask.title'),
            body: body,
            href: '/admin/usage',
            metadata: {
                kind: 'credit_request',
                workspaceId: wsId,
                needed: short.needed,
                available: short.available
            }
        })).catch(()=>null)));
    if (!sent.some(Boolean)) {
        toast('error', t('workspace.credits.ask.failedTitle'), t('workspace.credits.ask.failedMessage'));
        return false;
    }
    // Marked on the refusal it answers; a NEW refusal writes a fresh record.
    const held = r._creditsShort;
    if (held && held.at === short.at) r.update({
        _creditsShort: {
            ...held,
            asked: true
        }
    }, {
        preventFetch: true
    });
    toast('success', t('workspace.credits.ask.sentTitle'), t('workspace.credits.ask.sentMessage'));
    return true;
};
const $20ba6ebd88c316e6$export$12501f409fc10d44 = function(el, root) {
    const e = el || this;
    const r = root || e?.state?.root;
    if (!e || !r || !r.signedIn) return false;
    // White-label stand-down (mirrors CreditBlocker.Overlay): a NON-member
    // behind the request-access gate meets no credit chrome at all.
    if (e.call('isWhitelabelNonMemberGateActive', r)) return false;
    // Scheme-A prefix stripped — match the route, not the tenancy prefix.
    const path = e.call('stripWorkspacePrefix', r.currentPath || '/') || '/';
    if (path.startsWith('/admin/usage')) return false;
    // A held SHORTFALL (creditShortState) shows to every role — a member needs
    // the pointer to an admin as much as an admin needs the button — and does
    // not wait for the balance read: the refusal already said what the balance
    // was. It outranks the low/critical warning below; one pill, one message.
    if (e.call('creditShortState', e, r)) return true;
    const guard = e.call('creditGuardState', r);
    if (!guard || !guard.loaded || guard.error) return false;
    // EXHAUSTED belongs to CreditBlocker until that gate is dismissed; then this
    // pill takes over as the persistent indicator. Exactly one is ever visible.
    if (guard.status === 'exhausted') {
        if (!r._creditBlockerDismissed) return false;
    } else if (guard.status !== 'low' && guard.status !== 'critical') return false;
    if (!e.call('currentUserIsAdmin', r)) return false;
    // Dismissal: highest dismissed level for the current month wins; an
    // ESCALATION re-shows. `_creditBannerDismissed` mirrors the pref into state
    // so this re-runs on dismiss without a reload.
    const wsId = r.workspace?.id || r.workspace?._id || 'ws';
    const period = new Date().toISOString().slice(0, 7);
    const level = guard.status === 'exhausted' ? 3 : guard.status === 'critical' ? 2 : 1;
    const seen = r._creditBannerDismissed || e.call('getPref', `credit_banner_${wsId}`);
    const [seenPeriod, seenLevelRaw] = String(seen || '').split(':');
    if (seenPeriod === period && (Number(seenLevelRaw) || 0) >= level) return false;
    return true;
};
const $20ba6ebd88c316e6$export$4b958cda4fdc3e06 = function(el, root) {
    const e = el || this;
    const r = root || e?.state?.root;
    if (!e || !e.call('creditPillVisible', e, r)) return null;
    return e.call('creditGuardState', r)?.status === 'exhausted' ? 'cover' : 'pill';
};
const $20ba6ebd88c316e6$export$248ed557d4369599 = async function(root, sdkMaybe) {
    const r = root || this?.state?.root;
    if (!r) return null;
    const wsId = r?.workspace?.id || r?.workspace?._id || r?.jwtClaims?.active_workspace_id || null;
    if (!wsId) return null;
    const sdk = sdkMaybe || (0, $1X0Je.default).functions.getSDK();
    if (typeof sdk?.getCreditBalance !== 'function') return null;
    try {
        const res = await sdk.getCreditBalance(wsId);
        const data = res?.data || res || {};
        r.update?.({
            _creditGuard: {
                ...data,
                _wsId: wsId,
                _at: new Date().getTime()
            }
        });
    } catch (e) {
        // `error` is a FLAG — every guard surface stays silent on it (a metering
        // outage must never lock a workspace) — so its fallback is an id.
        r.update?.({
            _creditGuard: {
                error: e?.message || 'balance_unavailable',
                _wsId: wsId
            }
        });
    }
    return r._creditGuard;
};
const $20ba6ebd88c316e6$export$ffbaf3cf7490ac37 = (wsId)=>`credit_blocker_${wsId || 'ws'}`;
const $20ba6ebd88c316e6$export$9e8c851ddbfb6a21 = (wsId, storage)=>{
    const _key = (id)=>`credit_blocker_${id || 'ws'}`;
    const _storage = (s)=>{
        if (s) return s;
        try {
            return globalThis.sessionStorage || null;
        } catch (_) {
            return null;
        }
    };
    const store = _storage(storage);
    if (!store || !wsId) return false;
    try {
        return store.getItem(_key(wsId)) === '1';
    } catch (_) {
        return false;
    }
};
const $20ba6ebd88c316e6$export$40c2d4b6f88817ae = (wsId, dismissed, storage)=>{
    const _key = (id)=>`credit_blocker_${id || 'ws'}`;
    const _storage = (s)=>{
        if (s) return s;
        try {
            return globalThis.sessionStorage || null;
        } catch (_) {
            return null;
        }
    };
    const store = _storage(storage);
    if (!store || !wsId) return;
    try {
        if (dismissed) store.setItem(_key(wsId), '1');
        else store.removeItem(_key(wsId));
    } catch (_) {
    /* best-effort — storage quota / privacy mode */ }
};
const $20ba6ebd88c316e6$export$247a9dba1d8c1f63 = async function(el, root) {
    const host = el && el.call ? el : this;
    const r = root || host?.state?.root;
    if (!r || !host?.call) return;
    // Inline status derivation (self-contained per the frank convention —
    // keep in sync with creditGuardState above).
    const raw = r?._creditGuard;
    if (!raw) return;
    const data = raw.data || raw;
    if (data.error) return;
    // UNKNOWN ≠ ZERO — same discriminator as creditGuardState above (kept in
    // sync deliberately; the frank lift extracts each export individually, so
    // this cannot call a shared helper). Announcing "you are out of credits"
    // off a balance we failed to read is the same false-confidence failure as
    // blocking on it, so an unreadable balance notifies nothing.
    const rawTotal = data.total;
    const total = Number(rawTotal);
    if (data.found === false || rawTotal == null || rawTotal === '' || !Number.isFinite(total)) return;
    const grantSize = Number(data.grantSize ?? 0);
    let status = 'ok';
    if (total <= 0) status = 'exhausted';
    else if (grantSize > 0 && total <= grantSize * 0.1) status = 'critical';
    else if (grantSize > 0 && total <= grantSize * 0.3) status = 'low';
    const level = status === 'exhausted' ? 3 : status === 'critical' ? 2 : status === 'low' ? 1 : 0;
    if (level < 1) return;
    let isAdminNow = false;
    try {
        isAdminNow = !!host.call('currentUserIsAdmin', r);
    } catch (e) {}
    if (!isAdminNow) return;
    // Dedupe key stability (CREDITS-GATE-UI-BREAK-1, the duplicate stacked
    // toasts): `r.workspace?.id` is a LATE-LANDING value — a `_creditGuard`
    // write can arrive (and this notifier fire) before `root.workspace`
    // resolves, so the first announcement deduped under `credit_notify_ws`
    // and the re-fire after the workspace landed deduped under
    // `credit_notify_<real id>` — two keys, two identical toasts. The guard
    // record itself carries the workspace it was FETCHED for (`_wsId`,
    // stamped by loadCreditGuard) — that key exists from the very first
    // fire and never changes shape mid-boot.
    const wsId = data._wsId || raw._wsId || r?.workspace?.id || r?.workspace?._id || 'ws';
    const period = new Date().toISOString().slice(0, 7);
    const prefKey = `credit_notify_${wsId}`;
    // Prefs are COOKIES (shared/prefs.js) — objects don't survive the
    // round-trip, so the dedupe marker is a plain `period:level` string.
    let seen = null;
    try {
        seen = host.call('getPref', prefKey);
    } catch (e) {}
    const [seenPeriod, seenLevelRaw] = String(seen || '').split(':');
    const seenLevel = seenPeriod === period ? Number(seenLevelRaw) || 0 : 0;
    if (level <= seenLevel) return;
    try {
        host.call('setPref', prefKey, `${period}:${level}`);
    } catch (e) {}
    const t = (key)=>host.call('polyglot', key);
    const wsName = r?.workspace?.name || t('workspace.credits.thisWorkspace');
    const fmt = (n)=>Number(n || 0).toLocaleString('en-US');
    const copy = status === 'exhausted' ? {
        title: t('workspace.credits.exhausted.title'),
        message: t('workspace.credits.exhausted.message').replace('{workspace}', wsName)
    } : status === 'critical' ? {
        title: t('workspace.credits.critical.title'),
        message: t('workspace.credits.critical.message').replace('{workspace}', wsName).replace('{count}', fmt(total))
    } : {
        title: t('workspace.credits.low.title'),
        message: t('workspace.credits.low.message').replace('{workspace}', wsName).replace('{count}', fmt(total))
    };
    try {
        host.call('openNotification', {
            type: status === 'low' ? 'warning' : 'error',
            title: copy.title,
            message: copy.message,
            href: '/admin/usage'
        });
    } catch (e) {}
    // Other admins: workspace people whose org role is owner/admin
    // (roles.byUser is keyed by userId; _loadRoles fills it from
    // listOrgMembers). createNotification itself refuses self-rows, and the
    // explicit filter keeps the fan-out honest anyway.
    const byUser = r?.roles?.byUser || {};
    const people = Array.isArray(r?.people) ? r.people : [];
    const others = people.filter((p)=>{
        const role = p?.userId != null ? byUser[p.userId] : null;
        return role === 'owner' || role === 'admin';
    }).map((p)=>p.email).filter((email)=>email && email !== r.currentUserEmail);
    if (others.length) try {
        await host.call('createNotifications', others, {
            type: 'system',
            title: copy.title,
            body: copy.message,
            href: '/admin/usage',
            metadata: {
                kind: 'credit_threshold',
                level: status,
                workspaceId: wsId,
                period: period
            }
        });
    } catch (e) {}
};
const $20ba6ebd88c316e6$export$2944bdd33c0a5fe2 = [
    'INSUFFICIENT_CREDITS',
    'SPEND_CAP_EXCEEDED',
    'ALLOCATION_EXCEEDED'
];
const $20ba6ebd88c316e6$export$b00b05fbb7f693dc = async function(el, s) {
    const host = el && el.call ? el : this;
    if (!host || typeof host.call !== 'function') return;
    const root = s && s.root || host.state?.root;
    if (!root || !s || s.streaming) return;
    const metadata = s.metadata;
    if (!metadata || metadata.kind !== 'error') return;
    const code = String(metadata.errorCode || '');
    const isCreditsExhausted = metadata.creditsExhausted === true || [
        'INSUFFICIENT_CREDITS',
        'SPEND_CAP_EXCEEDED',
        'ALLOCATION_EXCEEDED'
    ].includes(code);
    if (!isCreditsExhausted) return;
    const msgId = String(s.id || '');
    const seenIds = root._creditsErrorNotifiedIds || [];
    if (msgId && seenIds.includes(msgId)) return;
    if (msgId) root.update({
        _creditsErrorNotifiedIds: [
            ...seenIds,
            msgId
        ]
    }, {
        preventFetch: true
    });
    // HOLD the shortfall — the toast below is gone in seconds, and the reply in
    // the thread has no button (persona audit round 1: four of four new accounts
    // stopped at "needed 190-222, available 100" with no way on). CreditBanner
    // shows it, with the way out for this person's role, until the balance
    // covers it or they close it; /admin/usage reads it too. Only a BALANCE
    // refusal has a "needs N, has M" — a spend cap or an allocation does not.
    // The figures are the structured `creditsNeeded` / `creditsAvailable` (the
    // state layer writes them, creditsRefusal.js) or, on a row nothing
    // normalized, the server's own "needed N, available M". Inline on purpose:
    // this file's exports are self-contained (the frank lift, above).
    if (code !== 'SPEND_CAP_EXCEEDED' && code !== 'ALLOCATION_EXCEEDED') {
        const count = (v)=>{
            if (v === null || v === undefined || v === '' || typeof v === 'boolean') return null;
            const n = Number(v);
            return Number.isFinite(n) && n >= 0 ? n : null;
        };
        let needed = count(metadata.creditsNeeded);
        let available = count(metadata.creditsAvailable);
        if (needed === null || available === null) {
            const hit = /needed\s+(\d+(?:\.\d+)?)\s*,\s*available\s+(\d+(?:\.\d+)?)/i.exec(String(metadata.errorMessage || ''));
            needed = hit ? Number(hit[1]) : null;
            available = hit ? Number(hit[2]) : null;
        }
        if (needed !== null && available !== null) {
            const at = Number(s.ts) || new Date().getTime();
            const held = root._creditsShort;
            root.update({
                _creditsShort: {
                    needed: needed,
                    available: available,
                    at: at,
                    msgId: msgId,
                    // The same refusal told twice (a live row re-keyed to its server
                    // id) keeps its "closed" and its "admins told"; a NEW refusal
                    // opens — and asks — again.
                    dismissed: !!(held && held.at === at && held.dismissed),
                    asked: !!(held && held.at === at && held.asked)
                }
            }, {
                preventFetch: true
            });
        }
    }
    let isAdminNow = false;
    try {
        isAdminNow = !!host.call('currentUserIsAdmin', root);
    } catch (e) {}
    if (!isAdminNow) {
        try {
            host.call('openNotification', {
                type: 'error',
                title: host.call('polyglot', 'workspace.credits.member.title'),
                message: host.call('polyglot', 'workspace.credits.member.message')
            });
        } catch (e) {}
        return;
    }
    const t = (key)=>host.call('polyglot', key);
    const copy = code === 'SPEND_CAP_EXCEEDED' ? {
        title: t('workspace.credits.spendCap.title'),
        message: t('workspace.credits.spendCap.message')
    } : code === 'ALLOCATION_EXCEEDED' ? {
        title: t('workspace.credits.allocation.title'),
        message: t('workspace.credits.allocation.message')
    } : {
        title: t('workspace.credits.blocked.title'),
        message: t('workspace.credits.blocked.message')
    };
    try {
        host.call('openNotification', {
            type: 'error',
            title: copy.title,
            message: copy.message,
            href: '/admin/usage'
        });
    } catch (e) {}
    // Refresh the balance NOW so CreditBlocker/CreditBanner flip on
    // immediately instead of waiting for the next scheduled poll — matters
    // most for INSUFFICIENT_CREDITS (an actual zero balance). Spend-cap /
    // allocation hits don't necessarily zero the balance, so the guard may
    // legitimately stay quiet for those; the notification above still fired
    // either way.
    try {
        await host.call('loadCreditGuard', root);
    } catch (e) {}
};

});

parcelRegister("amofj", function(module, exports) {

$parcel$export(module.exports, "isCreditsError", () => $78aec43a39264f7b$export$b0a678ba9e5cf6c3);
$parcel$export(module.exports, "creditsShortfall", () => $78aec43a39264f7b$export$51bd91f18703b016);
$parcel$export(module.exports, "creditsErrorText", () => $78aec43a39264f7b$export$db735b4bade8bd2c);
$parcel$export(module.exports, "applyCreditsError", () => $78aec43a39264f7b$export$d1504fc980662007);
$parcel$export(module.exports, "creditsRefusalRow", () => $78aec43a39264f7b$export$713342e43a48ad4e);
$parcel$export(module.exports, "creditsRefusalRows", () => $78aec43a39264f7b$export$7a1a6469a0e0ef53);
// A refused-for-credits reply: the SHELL owns the sentence, never the server's.
//
// The server writes a failed turn as an ordinary assistant message
// (ConversationOrchestratorService.failWorkspaceLoop). For the three credit
// codes its prose is English, names a page the product does not call that
// ("Credits & Usage"), tells the person that "a workspace admin can top up"
// when they ARE the admin, offers no button, and — when a tool ran first — it
// opens with "Before this error, the following actions completed successfully:
// Done: read_entities completed successfully..". All four personas of the
// round-1 onboarding audit met exactly that text as the first screen of a new
// workspace (needed 190 to 222, available 100).
//
// ChatMessage (packages/shared) renders `s.text` for these codes — it does not
// rewrite them the way it rewrites every other error — and it is not ours to
// edit. So the fix lives where the row is BUILT, in the workspace state layer:
// the transport's final patch (a live turn, a recovered turn, a resumed turn),
// sessions.js (a history reload, a thread switch) and the add-app reader each
// pass the row through `creditsRefusalRow` / `creditsRefusalRows`. The server's
// text never reaches a bubble; its numbers do, and they travel on the row's
// metadata (`creditsNeeded` / `creditsAvailable`) for the persistent banner.
//
// REGISTERED, NOT IMPORTED. These are functions of the shell's registry (the
// barrel, functions/index.js), reached as `el.call('creditsRefusalRow', …)`:
// the state-layer modules import nothing from here, so the dependency is one
// registry name, not a sibling import. Every export is SELF-CONTAINED (the
// FA204 convention of functions/creditGuard.js) — no module-scope helper or
// constant is read from inside one; the siblings are reached through
// `this.call`, the receiver `el.call` hands every function.
//
// The copy is reached through the caller's `say(key)` (the live shell
// element's polyglot), and the role through `isAdmin` — `creditsRefusalRow`
// supplies both from the element it runs on.
// The row is a credit refusal: the server's own boolean, or one of its three
// normalized codes. Same test as functions/creditGuard.js
// notifyCreditsExhaustedFromMessage, so the text and the notification never
// disagree about which rows they treat.
const $78aec43a39264f7b$export$b0a678ba9e5cf6c3 = function isCreditsError(metadata) {
    if (!metadata || metadata.kind !== 'error') return false;
    return metadata.creditsExhausted === true || [
        'INSUFFICIENT_CREDITS',
        'SPEND_CAP_EXCEEDED',
        'ALLOCATION_EXCEEDED'
    ].includes(String(metadata.errorCode || ''));
};
const $78aec43a39264f7b$export$51bd91f18703b016 = function creditsShortfall(metadata, text) {
    const count = (value)=>{
        if (value === null || value === undefined || value === '' || typeof value === 'boolean') return null;
        const n = Number(value);
        return Number.isFinite(n) && n >= 0 ? n : null;
    };
    const m = metadata || {};
    const needed = count(m.creditsNeeded);
    const available = count(m.creditsAvailable);
    if (needed !== null && available !== null) return {
        needed: needed,
        available: available
    };
    const wording = /needed\s+(\d+(?:\.\d+)?)\s*,\s*available\s+(\d+(?:\.\d+)?)/i;
    for (const source of [
        m.errorMessage,
        text
    ]){
        const hit = wording.exec(String(source || ''));
        if (hit) return {
            needed: Number(hit[1]),
            available: Number(hit[2])
        };
    }
    return null;
};
const $78aec43a39264f7b$export$db735b4bade8bd2c = function creditsErrorText(metadata, text, opts) {
    const { say: say, isAdmin: isAdmin } = opts || {};
    const t = typeof say === 'function' ? say : (key)=>key;
    const code = String(metadata && metadata.errorCode || '');
    const admin = typeof isAdmin === 'function' ? !!isAdmin() : !!isAdmin;
    const limit = code === 'SPEND_CAP_EXCEEDED' || code === 'ALLOCATION_EXCEEDED';
    const credits = (n)=>Number(n).toLocaleString('en-US', {
            maximumFractionDigits: 2
        });
    let lead;
    if (code === 'SPEND_CAP_EXCEEDED') lead = t('workspace.credits.chat.spendCap');
    else if (code === 'ALLOCATION_EXCEEDED') lead = t('workspace.credits.chat.allocation');
    else {
        const gap = this.call('creditsShortfall', metadata, text);
        lead = gap ? String(t('workspace.credits.chat.short')).replace('{needed}', ()=>credits(gap.needed)).replace('{available}', ()=>credits(gap.available)) : t('workspace.credits.chat.notEnough');
    }
    const link = (key)=>`[${t(key)}](/admin/usage)`;
    const way = admin ? String(t(limit ? 'workspace.credits.chat.limitAdmin' : 'workspace.credits.chat.balanceAdmin')).replace('{link}', ()=>link(limit ? 'workspace.credits.chat.limitLink' : 'workspace.credits.chat.addLink')) : t(limit ? 'workspace.credits.chat.limitMember' : 'workspace.credits.chat.balanceMember');
    return `${lead} ${way}`;
};
const $78aec43a39264f7b$export$d1504fc980662007 = function applyCreditsError(text, metadata, opts) {
    if (!this.call('isCreditsError', metadata)) return {
        text: text,
        metadata: metadata
    };
    const code = String(metadata && metadata.errorCode || '');
    const limit = code === 'SPEND_CAP_EXCEEDED' || code === 'ALLOCATION_EXCEEDED';
    const gap = limit ? null : this.call('creditsShortfall', metadata, text);
    return {
        text: this.call('creditsErrorText', metadata, text, opts),
        metadata: gap ? {
            ...metadata,
            creditsNeeded: gap.needed,
            creditsAvailable: gap.available
        } : metadata
    };
};
const $78aec43a39264f7b$export$713342e43a48ad4e = function creditsRefusalRow(text, metadata, root) {
    if (!this.call('isCreditsError', metadata)) return null;
    const el = this;
    return this.call('applyCreditsError', text, metadata, {
        say: (key)=>{
            try {
                return String(el.call('polyglot', key));
            } catch (_) {
                return String(key);
            }
        },
        isAdmin: ()=>{
            try {
                return !!el.call('currentUserIsAdmin', root);
            } catch (_) {
                return false;
            }
        }
    });
};
const $78aec43a39264f7b$export$7a1a6469a0e0ef53 = function creditsRefusalRows(rows, root) {
    const list = Array.isArray(rows) ? rows : [];
    return list.map((row)=>{
        if (!row || !row.metadata || row.role === 'user') return row;
        const refused = this.call('creditsRefusalRow', row.text, row.metadata, root);
        return refused ? {
            ...row,
            text: refused.text,
            metadata: refused.metadata
        } : row;
    });
};

});

parcelRegister("5BDlp", function(module, exports) {

$parcel$export(module.exports, "appDefaultWidgetIds", () => $414eed6a242c342b$export$d97eb501b9599e54);
$parcel$export(module.exports, "resolveHomePanelSet", () => $414eed6a242c342b$export$6fc21f619d12516b);
$parcel$export(module.exports, "isWidgetRestorable", () => $414eed6a242c342b$export$3f6428c06fec0b2c);
// homePanelSet.js — the one decision behind "which home widgets does this
// workspace's `home_default_panels` actually authorise?"
//
// Extracted from pages/main.js's `_resolveWsPanelsInfo` because the whole bug
// lived in a single boolean buried in a 6000-line page module, where it could
// not be tested. Everything here is pure: the caller supplies the raw set, the
// ids the catalog currently knows, and whether a declared module's widgets are
// still in flight.
//
// The failure this exists to prevent: a workspace's panel set is AUTHORITATIVE
// — any widget it does not name is force-hidden. Bellforge's set was
// `['greeting', 'bf-overview']` and `bf-overview` exists nowhere in the
// codebase, so all 28 grid items were hidden and the home read as "widgets did
// not load", with nothing logged anywhere.
/**
 * @param {object}   args
 * @param {string[]} args.panels               raw `home_default_panels`
 * @param {Set<string>} args.knownIds          every id the ACTIVE workspace's
 *                                             catalog resolves (house set ∪ the
 *                                             live module/app widgets)
 * @param {boolean}  args.moduleWidgetsPending a module source is declared but
 *                                             its widgets have not landed yet
 * @returns {{ panels: string[]|null, ghosts: string[], authoritative: boolean }}
 *          `panels: null` means "treat as unset" — the caller falls through to
 *          the global default board rather than hiding everything.
 */ // Which of an installed app's declared widgets are ON BY DEFAULT — the
// generic install contract (2026-08-13 per Nika: "appstore apps come with
// widgets support — after installing they are just main part of the workspace
// workflow"). Before this, an additive install's widgets were force-hidden
// unless someone hand-pinned the workspace's `home_default_panels` (the
// app-mode compose deliberately never takes panels from the app), so every
// appstore install shipped ZERO visible widgets — verified live on
// natali/ws_EEYlHGTvZ8: 13 installed apps, no module widget rendered, and the
// Customize drawer couldn't reveal them either (the project gate blocks
// restore paths for ids the panel set doesn't name).
//
// The rule, per app stash ({ widgets, home_default_panels }):
//   • `home_default_panels` declared (manifest configDefaults) → the ids it
//     names THAT THE APP ITSELF DECLARES as widgets are default-on. The
//     intersection is the security posture: an app pins only its OWN widgets
//     — it can never flip a house widget or another app's (bi's declared
//     ['greeting','bi-revenue',…] contributes only the bi-* ids).
//   • no `home_default_panels` → ALL of the app's declared widgets are
//     default-on (widgets exist to be seen; an app opts a widget OUT by
//     declaring panels without it, e.g. bi omits bi-stock).
// Union across apps, deduped. Pure + sync — callers derive the stash from
// `root.workspaceApps` (live), so install/uninstall converge with zero
// per-workspace writes: the ids appear when the app's manifest lands and
// vanish when the ref is removed.
const $414eed6a242c342b$export$d97eb501b9599e54 = (apps)=>{
    const out = new Set();
    for (const app of Array.isArray(apps) ? apps : []){
        const widgets = Array.isArray(app && app.widgets) ? app.widgets : [];
        if (!widgets.length) continue;
        const declared = new Set(widgets.map((w)=>w && w.id).filter(Boolean));
        const panels = Array.isArray(app && app.home_default_panels) ? app.home_default_panels : null;
        const defaults = panels ? panels.filter((id)=>declared.has(id)) : [
            ...declared
        ];
        for (const id of defaults)out.add(id);
    }
    return out;
};
const $414eed6a242c342b$export$6fc21f619d12516b = ({ panels: panels, knownIds: knownIds, moduleWidgetsPending: moduleWidgetsPending = false })=>{
    const raw = Array.isArray(panels) ? panels : [];
    const known = knownIds instanceof Set ? knownIds : new Set(knownIds || []);
    const ghosts = raw.filter((id)=>!known.has(id));
    // The question that matters: does this set name at least one REAL
    // non-greeting widget? The old test asked whether every entry was the
    // literal string `greeting`, which `['greeting', 'bf-overview']` passes.
    const namesSomethingReal = raw.some((id)=>id !== 'greeting' && known.has(id));
    // Withhold the verdict while a declared module's widgets are in flight —
    // mid-flight a genuine project board names only ids the catalog does not
    // know yet, and judging it now would collapse it to the global default for a
    // beat and visibly flip back once they land.
    const authoritative = namesSomethingReal || moduleWidgetsPending;
    // A set that is nothing but `greeting` still means "unset": a workspace whose
    // module was removed collapses to exactly that, and taken as authoritative it
    // would strand the home on greeting-only.
    const meaningful = raw.some((id)=>id !== 'greeting');
    return {
        // Returned VERBATIM, never filtered: module widgets mount asynchronously
        // and must survive this pass untouched — the resync reveals them once
        // their nodes exist. Only the verdict consults the catalog.
        panels: authoritative && meaningful ? raw : null,
        ghosts: ghosts,
        authoritative: authoritative
    };
};
const $414eed6a242c342b$export$3f6428c06fec0b2c = ({ id: id, scopedIds: scopedIds, appPlaneIds: appPlaneIds, aiIds: aiIds, panels: panels })=>{
    if (!id) return false;
    const asSet = (v)=>v instanceof Set ? v : new Set(Array.isArray(v) ? v : []);
    if (!asSet(scopedIds).has(id)) return true;
    if (asSet(aiIds).has(id)) return true;
    if (asSet(appPlaneIds).has(id)) return true;
    return Array.isArray(panels) && panels.includes(id);
};

});

parcelRegister("htRH6", function(module, exports) {

$parcel$export(module.exports, "untrackedState", () => $cb9ecba7b962ae24$export$a9868f3c81fc3851);
parcelRequire("fu4Jd");
var $bugUg = parcelRequire("bugUg");
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");
// DOMQL subscribeTo handlers execute inside the signal observer that watches
// their declared keys. Reading unrelated state through the live proxy silently
// widens that dependency set and can turn a later write into a feedback
// cascade. This view reads from the raw backing object, but forwards state
// methods and assignments through the live proxy so writes remain reactive.
//
// Nested stores need the same treatment: a parent raw object retains the child
// snapshot it was created with, while the nested store owns later updates.
// Read each current signal with peek() and recursively wrap store values so
// nested reads stay current without subscribing and nested writes still reach
// the live store. Arrays and ordinary objects are not independent signal stores
// and can pass through unchanged.
const $cb9ecba7b962ae24$var$views = new WeakMap();
const $cb9ecba7b962ae24$export$a9868f3c81fc3851 = (state)=>{
    const raw = state?.__raw;
    if (!raw || typeof raw !== 'object') return state;
    let view = $cb9ecba7b962ae24$var$views.get(state);
    if (view) return view;
    const signals = (0, $4VQqJ.isStore)(state) ? (0, $4VQqJ.getSignals)(state) : null;
    view = new Proxy(raw, {
        get (target, key) {
            if ((0, $bugUg.STATE_METHODS).has(key)) return state[key];
            const signal = signals?.[key];
            const value = signal ? signal.peek() : Reflect.get(target, key);
            return (0, $4VQqJ.isStore)(value) ? $cb9ecba7b962ae24$export$a9868f3c81fc3851(value) : value;
        },
        set (_target, key, value) {
            state[key] = value;
            return true;
        },
        deleteProperty (_target, key) {
            return delete state[key];
        }
    });
    $cb9ecba7b962ae24$var$views.set(state, view);
    return view;
};

});

parcelRegister("iI0D7", function(module, exports) {

$parcel$export(module.exports, "bootMark", () => $d9ecd324e46e5826$export$708804e0d593c66e);
$parcel$export(module.exports, "bootMeasure", () => $d9ecd324e46e5826$export$434146fb0a09ec93);
$parcel$export(module.exports, "IDLE_BOOT_TIMEOUT_MS", () => $d9ecd324e46e5826$export$496cdfeb31490abf);
$parcel$export(module.exports, "deferIdleBoot", () => $d9ecd324e46e5826$export$ae94e75855842f1d);
// Idle-deferred boot scheduling — iPad program P1 (boot long-task queue:
// 5.3s home / 6.1s calendar measured). The shell's onCreate used to open
// every realtime transport (user-socket, presence socket, meet SSE)
// synchronously inside the same boot task that paints first chrome; none
// of that work is needed for first paint. `deferIdleBoot` moves a boot
// off the critical path into the browser's idle time, with two hard
// guarantees:
//
//   1. TIMER BACKSTOP, ALWAYS ARMED. requestIdleCallback is frame-gated —
//      it never fires in a hidden/occluded tab (same failure class as the
//      WAAPI onfinish lesson), and WebKit (the iPad target!) doesn't ship
//      rIC at all. A plain setTimeout at `timeout` ms runs the boot
//      deterministically wherever idle never comes; whichever leg fires
//      first cancels the other.
//   2. DISPOSER CONTRACT. The returned function replaces the boot's own
//      unsubscribe at the shell teardown call sites (`el._xxx?.()`): called
//      before the boot ran it cancels the pending schedule; called after,
//      it invokes the cleanup the boot returned. No teardown/boot race.
//
// Every scheduled boot is stamped with performance marks (same `wsboot:`
// idiom as loadPrivateData.js's boot telemetry — read them via
// performance.getEntriesByType('measure') filtered on 'wsboot:'):
//   wsboot:<name>:queued          mark — scheduled (inside the boot task)
//   wsboot:<name>:start/:end      marks — around the boot's own execution
//   wsboot:<name>:deferred        measure — how far off boot it moved
//   wsboot:<name>                 measure — the boot's own sync cost
// Perf-mark helpers — guarded no-ops wherever the Performance API is
// absent. Exported so app.js stamps its KEPT-EAGER boots (analyzing,
// feature flags) with the same idiom.
const $d9ecd324e46e5826$export$708804e0d593c66e = (name)=>{
    try {
        if (typeof performance !== 'undefined') performance.mark(name);
    } catch (_) {
    /* telemetry only */ }
};
const $d9ecd324e46e5826$export$434146fb0a09ec93 = (name, from, to)=>{
    try {
        if (typeof performance !== 'undefined') performance.measure(name, from, to);
    } catch (_) {
    /* telemetry only */ }
};
const $d9ecd324e46e5826$export$496cdfeb31490abf = 2500;
const $d9ecd324e46e5826$export$ae94e75855842f1d = (name, fn, { timeout: timeout = $d9ecd324e46e5826$export$496cdfeb31490abf } = {})=>{
    let ran = false;
    let disposed = false;
    let cleanup = null;
    let idleId = null;
    let timerId = null;
    $d9ecd324e46e5826$export$708804e0d593c66e(`wsboot:${name}:queued`);
    const cancelPending = ()=>{
        if (idleId != null && typeof cancelIdleCallback === 'function') try {
            cancelIdleCallback(idleId);
        } catch (_) {}
        if (timerId != null) clearTimeout(timerId);
        idleId = null;
        timerId = null;
    };
    const run = ()=>{
        if (ran || disposed) return;
        ran = true;
        cancelPending();
        $d9ecd324e46e5826$export$708804e0d593c66e(`wsboot:${name}:start`);
        try {
            const result = fn();
            cleanup = typeof result === 'function' ? result : null;
        } catch (err) {
            console.warn(`[shell] idle boot '${name}' failed:`, err?.message || err);
        }
        $d9ecd324e46e5826$export$708804e0d593c66e(`wsboot:${name}:end`);
        $d9ecd324e46e5826$export$434146fb0a09ec93(`wsboot:${name}:deferred`, `wsboot:${name}:queued`, `wsboot:${name}:start`);
        $d9ecd324e46e5826$export$434146fb0a09ec93(`wsboot:${name}`, `wsboot:${name}:start`, `wsboot:${name}:end`);
    };
    // Idle leg — only where the API exists (WebKit/WKWebView lacks it).
    if (typeof requestIdleCallback === 'function') idleId = requestIdleCallback(run, {
        timeout: timeout
    });
    // Backstop leg — ALWAYS armed (rule 1 above). run() dedupes.
    timerId = setTimeout(run, timeout);
    return ()=>{
        if (disposed) return;
        disposed = true;
        cancelPending();
        if (typeof cleanup === 'function') try {
            cleanup();
        } catch (_) {}
        cleanup = null;
    };
};

});

parcelRegister("6QCFv", function(module, exports) {

$parcel$export(module.exports, "hasAuthoritativeWorkspace", () => $4fc59829e20257ee$export$6c13ba842accf338);
$parcel$export(module.exports, "awaitInitialWorkspace", () => $4fc59829e20257ee$export$43d9e7328744fe92);
$parcel$export(module.exports, "createPostAuthWorkspaceRevealCoordinator", () => $4fc59829e20257ee$export$42f69ba91c013feb);
// First-sign-in workspace readiness gate.
//
// A session/user can arrive before the SDK has populated its active workspace
// list. Both a `/w/<org>` deep link and an ordinary signed-in `/` boot must
// wait for that short resolution window before loading module config and the
// dashboard layout; otherwise the shell reveals defaults and visibly reshuffles
// when auth's late-claim reconciliation lands.

var $htRH6 = parcelRequire("htRH6");
const $4fc59829e20257ee$var$workspaceId = (root)=>String(root?.workspace?.id || root?.workspace?._id || '');
const $4fc59829e20257ee$export$6c13ba842accf338 = (root, expectedWorkspaceId = null)=>{
    const id = $4fc59829e20257ee$var$workspaceId(root);
    if (!id || root?._bootFromCache === true || root?.workspaceReady !== true) return false;
    return !expectedWorkspaceId || id === String(expectedWorkspaceId);
};
const $4fc59829e20257ee$var$hasResolvableOrg = (root)=>!!(root?.org?.id || root?.org?._id || root?.jwtClaims?.workspace_org_id || Array.isArray(root?.orgs) && root.orgs.length);
const $4fc59829e20257ee$export$43d9e7328744fe92 = async (root, { urlScoped: urlScoped = false, workspaceId: expectedWorkspaceId = null, attempts: attempts = 150, ordinaryAttempts: // Ordinary (non-URL-scoped, non-exact-id) boots cap at a much shorter
// ceiling — see the header comment above for why the full 15s bound is
// safe to skip here. `Math.min(attempts, ordinaryAttempts)` so a caller
// that explicitly passes a SMALLER `attempts` (tests, callers wanting an
// even tighter bound) is never stretched back out.
ordinaryAttempts = 60, intervalMs: intervalMs = 100 } = {})=>{
    const readRoot = ()=>(0, $htRH6.untrackedState)(root);
    const initialRoot = readRoot();
    if ($4fc59829e20257ee$export$6c13ba842accf338(initialRoot, expectedWorkspaceId)) return true;
    // An expected workspace id comes from a confirmed auth claim, or the URL
    // names a specific org/workspace scope. It must always wait for that exact
    // full record, even if an earlier warm snapshot or another tab's pointer
    // currently supplies a plausible workspace.
    const needsExactMatch = !!expectedWorkspaceId || urlScoped;
    const shouldWait = needsExactMatch || initialRoot?._bootFromCache === true || initialRoot?.signedIn && $4fc59829e20257ee$var$hasResolvableOrg(initialRoot);
    if (!shouldWait) return false;
    const effectiveAttempts = needsExactMatch ? attempts : Math.min(attempts, ordinaryAttempts);
    for(let i = 0; i < effectiveAttempts && !$4fc59829e20257ee$export$6c13ba842accf338(readRoot(), expectedWorkspaceId); i++)await new Promise((resolve)=>setTimeout(resolve, intervalMs));
    return $4fc59829e20257ee$export$6c13ba842accf338(readRoot(), expectedWorkspaceId);
};
const $4fc59829e20257ee$export$42f69ba91c013feb = ({ beginDataLoad: _beginDataLoad, endDataLoad: _endDataLoad })=>{
    const pending = new WeakMap();
    const begin = (root, workspaceId)=>{
        if (!root || !workspaceId) return null;
        const id = String(workspaceId);
        const held = pending.get(root);
        if (held && held.workspaceId === id) return held;
        const token = {
            workspaceId: id,
            epoch: _beginDataLoad(root)
        };
        pending.set(root, token);
        return token;
    };
    const isActive = (root, workspaceId)=>{
        const held = root && pending.get(root);
        return !!held && held.workspaceId === String(workspaceId || '');
    };
    const end = (root, token)=>{
        if (!root || !token || pending.get(root) !== token) return false;
        pending.delete(root);
        return _endDataLoad(root, token.epoch);
    };
    return {
        begin: begin,
        isActive: isActive,
        end: end
    };
};

});

parcelRegister("9hgTz", function(module, exports) {

$parcel$export(module.exports, "moduleRecordRow", () => $6c12ceaabd64fc61$export$c112f8e823c3d459);
// The MODULE RECORD-ROW REGISTRY — "which of the app's own components draws
// ONE row of this collection?" Sibling of functions/moduleRecordRoutes.js
// ("where does a row open?"), read over the same pair of places:
//
//   collections: [{ key: 'crm_deals', route: '/crm', param: 'deal', row: 'CrmDealRecordRow' }]
//
// `workspaceProjects.js _normalizeRecordRows` validates the declarations at
// load (the component must ship with the module; key folded to lower case)
// and publishes `[{ key, row, moduleId }]` on `root.workspaceProject.recordRows`
// (the takeover module) and on each `root.workspaceApps[].recordRows` (the
// additive apps). ORDER IS THE CONTRACT, as for the routes: the takeover's
// rows first, then the apps', and the FIRST declaration of a key wins.
//
// The one consumer today is the AI answer's records list
// (functions/assistantRecords.js assistantRecordsRowOf → the mount contract in
// assistantRecordsRowMount). The shell names no app here: every app that
// declares a row gets its rows drawn its own way; every other collection keeps
// the shell's generic row.
//
// Both call forms work, like moduleRecordRoute: `moduleRecordRow(root, key)`
// (tests, shell code) and `el.call('moduleRecordRow', key)` (the element is
// `this` and the root comes from its state). Self-contained on purpose (FA204).
//
// → `{ key, row, moduleId }` for ONE collection, or null.
function $6c12ceaabd64fc61$export$c112f8e823c3d459(rootOrKey, maybeKey) {
    const rootArg = rootOrKey && typeof rootOrKey === 'object' ? rootOrKey : null;
    const rawKey = rootArg ? maybeKey : rootOrKey;
    const key = rawKey == null ? '' : String(rawKey).trim().toLowerCase();
    if (!key) return null;
    let root = rootArg;
    if (!root && this && typeof this === 'object') {
        if (this.state && this.state.root) root = this.state.root;
        else if (typeof this.getRootState === 'function') try {
            root = this.getRootState();
        } catch (_) {
            root = null;
        }
    }
    if (!root || typeof root !== 'object') return null;
    const lists = [];
    const project = root.workspaceProject;
    if (project && typeof project === 'object' && Array.isArray(project.recordRows)) lists.push(project.recordRows);
    if (Array.isArray(root.workspaceApps)) {
        for (const app of root.workspaceApps)if (app && typeof app === 'object' && Array.isArray(app.recordRows)) lists.push(app.recordRows);
    }
    for (const rows of lists)for (const r of rows){
        if (!r || typeof r !== 'object') continue;
        const k = r.key == null ? '' : String(r.key).trim().toLowerCase();
        const row = typeof r.row === 'string' ? r.row.trim() : '';
        const moduleId = r.moduleId == null ? '' : String(r.moduleId);
        // A half row (a stash from an older bundle, a dev override) never mounts.
        if (k !== key || !row || !moduleId) continue;
        return {
            key: k,
            row: row,
            moduleId: moduleId
        };
    }
    return null;
}

});

parcelRegister("izGzx", function(module, exports) {

$parcel$export(module.exports, "tileModuleDataBridge", () => $d85c84d3b01bdaa1$export$8089a0453ed4c7bd);
// USER-CODE-ORIGIN security review B1: the `moduleData` a board / thumbnail
// TILE may use. The tile runs a project's own code in an opaque frame. It must
// never get the shell-root `moduleData`: that bridge carries the ACTIVE
// workspace's MERGED app grants, and the SDK takes a `workspaceId` in the args
// over the active workspace — a frame-supplied id reached any workspace of
// the viewer.
//
// `tileModuleDataBridge(project)` (this = a shell element) returns a bridge
// built PER FRAME, at mount, by the host:
//   • only if THIS project is installed in the active workspace (the
//     takeover module or an additive app, matched by owner/key);
//   • from THAT install's own grant only (records), never the union of apps;
//   • pinned to that workspace id — the host sets `workspaceId` on every
//     call, after the canvas table already refused any scope key the frame
//     sent (canvas/functions/canvas/tileCalls.js, shared findScopeKey);
//   • records list/get/create/update/upsert/remove only (no subscribe, no
//     schema meta, no integrations).
// Returns null when the project is not installed here: the tile then gets no
// `moduleData` at all.

var $f18a7 = parcelRequire("f18a7");

var $g7CNh = parcelRequire("g7CNh");
function $d85c84d3b01bdaa1$export$8089a0453ed4c7bd(project, opts) {
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    if (!project || !project.owner || !project.key) return null;
    const rs = typeof this.getRootState === 'function' ? this.getRootState() : null;
    const ws = rs && rs.workspace;
    const wsId = ws && (ws.id || ws._id);
    const settings = ws && ws.settings;
    if (!wsId || !settings) return null;
    const refs = [];
    const mod = settings.workspaceModule;
    if (mod && typeof mod === 'object' && mod.owner && mod.key) refs.push(mod);
    refs.push(...(0, $g7CNh.installedAppRefs)(settings));
    const ref = refs.find((r)=>lc(r.owner) === lc(project.owner) && lc(r.key) === lc(project.key));
    const records = ref && ref.capabilities && ref.capabilities.records;
    if (!records || !Array.isArray(records.collections) || !records.collections.length) return null;
    // A root that holds ONLY this install: the bridge's live-grant sync reads
    // root.workspace.settings, so it can never widen to another app's grant.
    const pinnedRoot = {
        workspace: {
            id: String(wsId),
            settings: {
                workspaceApps: [
                    ref
                ]
            }
        }
    };
    const bridge = (0, $f18a7.buildModuleDataBridge)(pinnedRoot, {
        records: records
    }, opts && typeof opts.getSdkFn === 'function' ? {
        getSdkFn: opts.getSdkFn
    } : undefined);
    const OPS = [
        'list',
        'get',
        'create',
        'update',
        'upsert',
        'remove'
    ];
    return (from, op, args)=>{
        if (from !== 'records' || !OPS.includes(op)) return Promise.reject(new Error('[tile] only records ' + OPS.join('/') + ' are served to a tile.'));
        const a = args && typeof args === 'object' && !Array.isArray(args) ? args : {};
        return bridge('records', op, {
            ...a,
            workspaceId: String(wsId)
        });
    };
}

});

parcelRegister("gO4wS", function(module, exports) {

$parcel$export(module.exports, "mwtRouter", () => $c3c4d4411a94f898$export$9999274c252f319c);
$parcel$export(module.exports, "mwtRouterHref", () => $c3c4d4411a94f898$export$5e73c1e0c6b13972);
$parcel$export(module.exports, "reconcileMwtOrgFromUrl", () => $c3c4d4411a94f898$export$fc42afb8d7cfc68f);
$parcel$export(module.exports, "mwtOnRenderRouter", () => $c3c4d4411a94f898$export$90e2d9257ef760e2);
// mwtRouter.js — multi-workspace-tabs router wrapper (Phase 3, §6a).
//
// Registered as `context.functions.router` so EVERY `el.router()` + `Link`/
// `RouteLink` click funnels through it. When MWT is ON it emits + consumes an
// optional `/w/<org-slug>` prefix on the workspaceProject INTRANET routes only
// (canvas / marketplace / preview keep their own bare URLs, §6b). When OFF it is
// a transparent pass-through — the app navigates exactly as today.
//
// smbls' router couples matchRoute + pushState to ONE pathname (plugins/router
// index.js:229/281), so the wrapper writes the PREFIXED URL to the address bar
// itself, then calls the default router with the STRIPPED path + `pushState:false`
// to render the real route without overwriting the URL. `mwtOnRenderRouter`
// covers the initial hard-load render, which bypasses `context.functions.router`
// (smbls/src/router.js `onRouterRenderDefault` calls the default router directly).
//
// The pure decision (planMwtNav) lives in shared/functions/mwtNav.js so it stays
// testable without `@symbo.ls/router`. This module only wires it to the router +
// history. Plain module, direct ESM import into context.js's functions map —
// FA001 legally allows context.js to import it (frank-audit's sibling-import
// allowlist covers context.js itself), but that is NOT the same claim as
// "never frank-serialized": frank evaluates context.js's REAL merged
// `functions` object at toJSON time, so this function DOES get serialized —
// correctly, since workspace-shell's own JSON needs it. The "never leaks
// into a consumer" guarantee comes from `sharedLibIgnore: ['app',
// 'functions/router']` on context.js (packages/utils/sharedLibraries.js
// `mergeOneLibrary`), not from anything here. A prior version of this
// comment claimed the opposite and was wrong — the platform push serialized
// this function into workspace-shell's library form and it hijacked every
// consumer's routing until the sharedLibIgnore fix landed. See
// tickets/opus.md "shared-library pushes serialize app-wiring functions".

var $6mxzB = parcelRequire("6mxzB");

var $9StQo = parcelRequire("9StQo");

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $aKav5 = parcelRequire("aKav5");
const $c3c4d4411a94f898$var$shellIsMwtEnabled = (...args)=>(0, $1X0Je.default).functions.isMwtEnabled(...args);
const $c3c4d4411a94f898$var$planMwtNav = (...args)=>(0, $1X0Je.default).functions.planMwtNav(...args);
const $c3c4d4411a94f898$var$mwtOrgToReconcile = (...args)=>(0, $1X0Je.default).functions.mwtOrgToReconcile(...args);
const $c3c4d4411a94f898$var$isMwtIntranetRoute = (...args)=>(0, $1X0Je.default).functions.isMwtIntranetRoute(...args);
const $c3c4d4411a94f898$var$shellResolveWorkspaceUrlHandle = (...args)=>(0, $1X0Je.default).functions.resolveWorkspaceUrlHandle(...args);
const $c3c4d4411a94f898$var$moduleRoutesFromRoot = (...args)=>(0, $1X0Je.default).functions.moduleRoutesFromRoot(...args);
const $c3c4d4411a94f898$var$shellGetWorkspacePrefixSlug = (...args)=>(0, $1X0Je.default).functions.getWorkspacePrefixSlug(...args);
const $c3c4d4411a94f898$var$shellGetWorkspaceRawSegments = (...args)=>(0, $1X0Je.default).functions.getWorkspaceRawSegments(...args);
const $c3c4d4411a94f898$var$shellWithWorkspacePath = (...args)=>(0, $1X0Je.default).functions.withWorkspacePath(...args);
const $c3c4d4411a94f898$var$_mwtWin = (el)=>el?.context?.window || (typeof window !== 'undefined' ? window : null);
const $c3c4d4411a94f898$var$_orgSlug = (el)=>{
    try {
        const org = el?.getRoot?.()?.state?.org;
        return org && (org.slug || org.username) || null;
    } catch  {
        return null;
    }
};
// The workspace handle to stamp on emitted intranet URLs (scheme A: path
// segment 2) — the shared rule in workspaceUrlSync.js (non-HQ always carries
// it; HQ never needs it; legacy untyped records fall back to a strict
// known-siblings check). This used to be a local copy of the sibling heuristic
// whose `!orgId ||` clause matched EVERY workspace while the org was still
// resolving — so any nav racing boot stamped a redundant handle onto
// single-workspace orgs.
const $c3c4d4411a94f898$var$_workspaceHandle = (el)=>{
    try {
        return $c3c4d4411a94f898$var$shellResolveWorkspaceUrlHandle(el?.getRoot?.()?.state);
    } catch  {
        return null;
    }
};
const $c3c4d4411a94f898$var$_moduleRoutes = (el)=>$c3c4d4411a94f898$var$moduleRoutesFromRoot(el?.getRoot?.()?.state);
const $c3c4d4411a94f898$export$9999274c252f319c = (path, el, state = {}, opts = {})=>{
    const plan = $c3c4d4411a94f898$var$planMwtNav({
        path: path,
        slug: $c3c4d4411a94f898$var$_orgSlug(el),
        ws: $c3c4d4411a94f898$var$_workspaceHandle(el),
        moduleRoutes: $c3c4d4411a94f898$var$_moduleRoutes(el),
        mwtEnabled: $c3c4d4411a94f898$var$shellIsMwtEnabled()
    });
    const win = $c3c4d4411a94f898$var$_mwtWin(el);
    // MWT OFF — pass-through for the ROUTE, but the reserved `/w/<slug>` prefix
    // is still stripped for MATCHING. Same invariant mwtOnRenderRouter states
    // and enforces for the hard load: "a prefixed URL must resolve to its real
    // route whether or not MWT is enabled" — stripWorkspacePrefix is a no-op
    // off-prefix, so an unprefixed nav is byte-identical to before.
    //
    // WS-CUSTOM-DOMAIN-HUB-SILENT-BOOT-FAIL-1: this branch used to hand the RAW
    // path to the default router, which matches a level-1 key — so an in-app
    // `el.router('/w/bellforge/')` matched the BARE `/w` route (the workspace
    // hub) instead of `/`. The hub then forwards a single-org user to
    // `withWorkspacePrefix(slug, '/')`, which is the very path it is already on,
    // so it re-mounted itself forever under "Opening your workspace…". Nothing
    // consumes the prefix with the flag off (reconcileMwtOrgFromUrl returns
    // immediately), so the URL is unhonourable and healed away rather than left
    // stranded — exactly what the hard-load twin does.
    if (!plan) {
        const matchPath = (0, $7iFOV.shellStripWorkspacePrefix)(path);
        if (matchPath !== path && opts.pushState === false && win?.history) try {
            win.history.replaceState(state, '', matchPath);
        } catch  {}
        return (0, $6mxzB.router)(matchPath, el, state, opts);
    }
    // Prefix intranet targets: write the /w/<slug> URL ourselves, then render the
    // stripped route without letting the default router overwrite the address bar.
    // Honor pushState:false (popstate / initial render) — never double-write.
    // `replace: true` REWRITES the current entry, exactly as the default router
    // does for an unprefixed URL (plugins/router `replace`): this branch used to
    // push whatever the caller asked, so a query rewrite on a workspace URL
    // stacked a Back entry for every write (functions/assistantThreadUrl.js is
    // the first caller that needs a true replace here).
    if (plan.addressBarUrl && opts.pushState !== false && win?.history) {
        try {
            if (opts.replace) win.history.replaceState(state, null, plan.addressBarUrl);
            else win.history.pushState(state, null, plan.addressBarUrl);
        } catch  {}
        return (0, $6mxzB.router)(plan.matchPath, el, state, {
            ...opts,
            pushState: false
        });
    }
    return (0, $6mxzB.router)(plan.matchPath, el, state, opts);
};
const $c3c4d4411a94f898$export$5e73c1e0c6b13972 = (href, el)=>{
    const slug = $c3c4d4411a94f898$var$_orgSlug(el);
    const ws = $c3c4d4411a94f898$var$_workspaceHandle(el);
    const moduleRoutes = $c3c4d4411a94f898$var$_moduleRoutes(el);
    const plan = $c3c4d4411a94f898$var$planMwtNav({
        path: href,
        slug: slug,
        ws: ws,
        moduleRoutes: moduleRoutes,
        mwtEnabled: $c3c4d4411a94f898$var$shellIsMwtEnabled()
    });
    return plan && plan.addressBarUrl || href;
};
const $c3c4d4411a94f898$export$7ee4ffed655229a = (root, el, _try = 0)=>{
    if (!el) return;
    const win = $c3c4d4411a94f898$var$_mwtWin(el);
    if (!win?.location) return;
    const path = win.location.pathname || '/';
    const { seg2: seg2 } = $c3c4d4411a94f898$var$shellGetWorkspaceRawSegments(path);
    if (!seg2) return;
    const stripped = (0, $7iFOV.shellStripWorkspacePrefix)(path);
    const stillAmbiguous = stripped.split('/')[1] === seg2;
    if (!stillAmbiguous) {
        // Resolver recognized segment 2 as a workspace — re-render the real route
        // unless the initial dispatch already matched it (resolver was warm).
        if (String(root.currentPath || '') === stripped) return;
        // ...and unless the router already RENDERED that route. `currentPath` is
        // seeded with the RAW pathname by app.js onCreate ('/w/<org>/<ws>'), so the
        // check above never held on a Scheme A URL, and this heal re-dispatched a
        // route that was already on screen: on a cold /w/unreal/default load the
        // whole home page was built a second time (3.9 s of synchronous work at
        // load 75, dev deploy 31). The router records what it rendered as
        // `route` / `routePath` (its first-segment key) on the root state.
        const _want = '/' + (stripped.split('/')[1] || '');
        if (root.route === _want || root.routePath === _want) return;
        // ...and unless the INITIAL dispatch already asked for this exact route and
        // is still in flight (the router writes route/routePath only after its auth
        // guard resolves; this heal runs from the signin tick, ~150 ms after the
        // first dispatch on dev deploy 33 - and rebuilt the home a second time).
        if (el.__ref && el.__ref.__mwtInitialPath === stripped) return;
        // Canvas-project paths (/w/<org>[/<ws>]/p/<key>) mount the editor off the
        // RAW pathname via the '/*' catch-all (projectRedirect classification) —
        // a resolver-warm re-dispatch would just remount the same editor once
        // (~1-2s into a cold load, visible re-render) for zero routing gain.
        if ((0, $9StQo.isCanvasProjectPath)(win.location.pathname)) return;
        try {
            // Promise.resolve(...).catch: the router can also reject ASYNCHRONOUSLY
            // (mid-heal teardown, half-mounted el) — a bare try/catch only covers
            // the sync throw and left an unhandledRejection.
            Promise.resolve((0, $6mxzB.router)(stripped + (win.location.search || '') + (win.location.hash || ''), el, {}, {
                pushState: false
            })).catch(()=>{});
        } catch  {}
        return;
    }
    // "Data present" = a source the resolver can actually DECIDE from: the org
    // list (needed to attribute a handle to the path's org) plus either
    // workspaces list, or the settled active workspace + org records (the
    // resolver's list-independent fast path). Until one exists, keep polling;
    // once one does and the segment still reads ambiguous, it's a genuine
    // route.
    const orgsReady = Array.isArray(root.orgs) && root.orgs.length;
    const listsReady = orgsReady && (Array.isArray(root.workspaces) && root.workspaces.length || root.orgWorkspaces && Object.keys(root.orgWorkspaces).length);
    const dataReady = listsReady || root.workspace && root.org;
    if (!dataReady || seg2.startsWith('ws_') && !listsReady) {
        // The ghost-handle branch below needs the FULL workspace lists: the
        // fast path (active workspace + org alone) can only recognize the
        // ACTIVE workspace's own handle, so judging a SIBLING-workspace deep
        // link on it would rescope a legitimate URL away while the lists are
        // still loading.
        if (_try < 50) setTimeout(()=>$c3c4d4411a94f898$export$7ee4ffed655229a(root, el, _try + 1), 200);
        return;
    }
    // SHELL-WS-HANDLE-1 (tickets/bellforge.md, 2026-08-15). Data landed and
    // segment 2 STILL does not resolve. For a plain segment that is the
    // documented Scheme A outcome — unmatched segments read as routes on the
    // HQ (relman's bare-URL finding: that half of the ticket was correct
    // behaviour mislabelled as a bug). But a `ws_`-prefixed segment can NEVER
    // be a route: server-side workspace slugs are minted against a reserved
    // blacklist mirroring the static route names, and raw ids always carry
    // the `ws_` shape prefix (workspaceUrlSync.js's own contract). So an
    // unresolvable ws_ segment is a GHOST handle — deleted workspace, another
    // member's inaccessible workspace, or a typo — and letting it read as a
    // route left the HQ rendering under a URL naming a workspace that does
    // not exist for this session (same label-lie class as TENANCY-URL-1).
    // Rescope the address bar to the active workspace's canonical URL and
    // re-dispatch the root; the ghost's trailing route segments belong to the
    // ghost's namespace and are not reinterpreted.
    if (seg2.startsWith('ws_')) {
        const activeOrg = root.org;
        const activeSlug = activeOrg?.slug || activeOrg?.username;
        if (!activeSlug) return;
        const handle = $c3c4d4411a94f898$var$shellResolveWorkspaceUrlHandle({
            workspace: root.workspace,
            org: activeOrg,
            workspaces: Array.isArray(root.workspaces) ? root.workspaces : []
        });
        const target = $c3c4d4411a94f898$var$shellWithWorkspacePath(activeSlug, handle, '/');
        console.warn('[mwt] workspace handle "' + seg2 + '" resolves to nothing for this session \u2014 ' + 'rescoped to ' + target + ' (a ws_-shaped segment is never a route)');
        try {
            win.history.replaceState(win.history.state, '', target);
        } catch  {}
        try {
            // Same async-rejection guard as the re-dispatch above.
            Promise.resolve((0, $6mxzB.router)('/', el, {}, {
                pushState: false
            })).catch(()=>{});
        } catch  {}
    }
};
const $c3c4d4411a94f898$export$fc42afb8d7cfc68f = (root, sdk, el, _attempt = 0, opts = {})=>{
    if (!$c3c4d4411a94f898$var$shellIsMwtEnabled() || !sdk || !root || typeof sdk.switchOrg !== 'function') return;
    // Fire the route heal exactly once per reconcile entry (attempt 0) — it
    // owns its own retry loop, independent of the org-reconcile retries below.
    if (_attempt === 0) $c3c4d4411a94f898$export$7ee4ffed655229a(root, el);
    // The SDK's CURRENT org — what `switchOrg` keys on to load data. Populated on a
    // `/w/<slug>` deep-link (auth.js seeds the SDK context), but NOT on a bare load:
    // there resolveActiveOrgId sets `root.org` only, so the active org lives solely
    // in root. The two branches below therefore draw from different sources.
    const sdkOrgId = sdk._context?.activeOrgId;
    const rootOrgId = root.org && (root.org.id ?? root.org._id);
    // Retry (~5s) until the orgs list AND some notion of the active org land —
    // either source clears the shared guard. The cross-org branch re-checks
    // `sdkOrgId` on its own (a URL-pinned `root.org` can't drive that comparison);
    // the canonicalize branch is happy with `root.org` (bare loads have no sdkOrgId,
    // so gating the shared guard on sdkOrgId starved canonicalize entirely).
    if (!sdkOrgId && !rootOrgId || !Array.isArray(root.orgs) || !root.orgs.length) {
        if (_attempt < 25) setTimeout(()=>$c3c4d4411a94f898$export$fc42afb8d7cfc68f(root, sdk, el, _attempt + 1, opts), 200);
        return;
    }
    const win = typeof window !== 'undefined' ? window : null;
    if (!win || !win.location) return;
    const path = win.location.pathname || '/';
    // Any URL shape that NAMES an org feeds the same reconcile. `/w/<org>/…`
    // states it in the prefix; a project canvas states it as the owner segment;
    // `/studio|/workspaces/<owner>` states it as segment 2. Previously only the
    // first was consulted, so the other two rendered the persisted org's chrome
    // over another org's content.
    let slug = $c3c4d4411a94f898$var$shellGetWorkspacePrefixSlug(path);
    // Which "currently active org" the URL's slug is compared against differs by
    // shape, and getting it wrong is why the first cut of this fix did nothing:
    //
    //  • `/w/<slug>` — auth.js URL-PINS `root.org` to the slug, so root would
    //    always look like it is "already there". The SDK context is the only
    //    honest comparand, and it IS populated on a MEMBER-org landing. On a
    //    FOREIGN slug nothing may ever populate it (see the ladder-spent
    //    fallback below); root.org is honest there, as the pin skips non-members.
    //  • project canvas / `/studio/<owner>` — nothing pins `root.org`; it holds
    //    the genuinely-active (persisted) org. And on such a BARE load the SDK
    //    context's `activeOrgId` is never populated at all (see the comment on
    //    sdkOrgId above), so requiring it here meant 25 retries and a silent
    //    give-up — the reconcile ran, found no SDK org, and quit every time.
    let activeForCompare = sdkOrgId;
    if (!slug && typeof opts.ownerSlugForPath === 'function') {
        try {
            slug = opts.ownerSlugForPath(path) || null;
        } catch (err) {
            console.warn('[mwt] ownerSlugForPath threw:', err?.message || err);
        }
        if (slug) activeForCompare = sdkOrgId || rootOrgId;
    }
    if (slug) {
        // Cross-org: switch this tab to the URL's org when the active one differs
        // (loads that org's data client-only). Retry while the comparand is still
        // resolving — async on a fresh deep link.
        if (!activeForCompare) {
            if (_attempt < 25) {
                setTimeout(()=>$c3c4d4411a94f898$export$fc42afb8d7cfc68f(root, sdk, el, _attempt + 1, opts), 200);
                return;
            }
            // Ladder spent and still no SDK org: on a FOREIGN `/w/` slug that is the
            // steady state, not a race. The boot seeds sdk._context.activeOrgId from
            // the URL org (null for a non-member) or user.activeOrganization — with
            // no resolved workspace only when that org is in the session's own list
            // (bootResolve's own-org seed) — and skips its pre-render switchOrg for a
            // non-member org, so for an unset or departed stored org no writer is
            // coming. Returning here kept the foreign address over the session's own
            // workspace for good, with no log (dev.my 2026-10-30: test user Dan on
            // /w/kestrel-assist/default). Compare against root.org instead: auth.js
            // pins it to a URL org only for a member, so a foreign slug can never
            // read as "already there", and the own-org guard below still keeps a
            // pinned member URL from bouncing. The entry gate guarantees rootOrgId.
            activeForCompare = rootOrgId;
        }
        const targetOrgId = $c3c4d4411a94f898$var$mwtOrgToReconcile({
            slug: slug,
            orgs: root.orgs,
            activeOrgId: activeForCompare
        });
        if (!targetOrgId) {
            // Aligned fast-exit: bootShell now pre-seeds sdk._context.activeOrgId on
            // every /w/ landing (and pre-switches on cross-org ones), so "no target"
            // usually means MATCHED, not not-yet-resolved. When the slug's org is
            // resolvable and equals the comparand there is nothing to reconcile —
            // return now instead of burning the 25×200ms retry ladder.
            const _urlOrg = root.orgs.find((o)=>o && (o.slug === slug || o.username === slug));
            const _urlOrgId = _urlOrg ? String(_urlOrg.id ?? _urlOrg._id ?? '') : null;
            if (_urlOrgId && String(activeForCompare) === _urlOrgId) return;
            // Two reasons collapse into the same "no target" result here, and a
            // single check can't tell them apart: genuinely not a member of
            // `slug` (mwtOrgToReconcile's own guard — never attempt a switch onto
            // a stranger's public project), OR `root.orgs` — already non-empty
            // enough to pass the length-only gate above — just hasn't grown to
            // include THIS org yet (2026-08-02 "navbar changes not always saves"
            // investigation, Nika: a project-canvas route, e.g. /<owner>/<key>,
            // rendered a DIFFERENT, persisted org's chrome over the URL's owner).
            // A bounded retry costs nothing extra for the first case
            // (mwtOrgToReconcile keeps returning null, harmlessly, for the same
            // reason on every attempt) and closes the gap for the second — same
            // shared `_attempt` budget as every other wait in this function, not
            // an unbounded extra loop.
            if (_attempt < 25) {
                setTimeout(()=>$c3c4d4411a94f898$export$fc42afb8d7cfc68f(root, sdk, el, _attempt + 1, opts), 200);
                return;
            }
            // TENANCY-URL-1 (2026-08-14, Nika: workspaces "fully isolated" — a
            // foreign URL must never label another tenant's render). Retries are
            // exhausted and the slug still resolves to NO member org: this session
            // cannot see that tenant. Every earlier cut fell through HERE and left
            // the ACTIVE workspace rendering under the foreign address
            // (/w/natali/ws_…/notes showing the bellforge module, measured live).
            // Rescope the address bar to the active org's canonical URL and
            // re-dispatch the workspace root — the foreign ws-handle and route
            // segments belong to the other tenant's namespace and must not be
            // reinterpreted inside this one. replaceState, not push: the content
            // was always the caller's own workspace; only the label lied.
            const _activeOrgRow = activeForCompare && root.orgs.find((o)=>String(o.id ?? o._id ?? '') === String(activeForCompare)) || root.org;
            const _activeSlug = _activeOrgRow?.slug || _activeOrgRow?.username;
            // CANVAS-PROJECT-PAGE-BOUNCE-1 (2026-08-21) — NOT-FOREIGN GUARD, and it
            // has to sit here, after the fallback above resolved `_activeSlug`.
            //
            // `_activeOrgRow` falls back to `root.org`, which a `/w/<slug>/…` landing
            // URL-PINS to the very slug this branch is about to judge foreign
            // (functions/auth.js). So when the two agree, the lookups above missed for
            // the OTHER reason this branch's own comment lists — `root.orgs` was
            // "non-empty enough" to pass the entry gate but had still not grown to
            // include the ACTIVE org inside the 25x200ms budget (or that row carries
            // no `slug`; `mwtOrgToReconcile` matches on `slug` only) — not because
            // another tenant is being rendered.
            //
            // Rescoping there rewrites org -> the same org and handle -> the same
            // handle, so its ONLY net effect is to DROP the route and SPA-navigate to
            // the workspace home:
            //     /w/nikoloza/ws_oT4pVpU0yT/p/word  ->  /w/nikoloza/ws_oT4pVpU0yT
            // which is the reported project-canvas bounce byte for byte (same org,
            // same workspace segment, project route gone, document alive because the
            // exit is `el.router('/')`, hence the title lagging behind the URL). The
            // ~18-20s delay is this ladder: the reconcile enters post-auth and the
            // budget expires ~5s later; the intermittency is whether the org row wins
            // that race. Compared case-insensitively because the URL segment is
            // user-typed/shared and org slugs are not case-significant.
            //
            // Tenant isolation is untouched: a slug that genuinely differs from the
            // active org's own slug still falls through and still rescopes
            // (TENANCY-URL-1) — see mwtRouterSelfRescope.test.js's last case.
            const _sameOrgSlug = (a, b)=>!!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();
            if (_sameOrgSlug(_activeSlug, slug) || _sameOrgSlug(root.org?.slug, slug) || _sameOrgSlug(root.org?.username, slug)) return;
            if (_activeSlug) {
                const _handle = $c3c4d4411a94f898$var$shellResolveWorkspaceUrlHandle({
                    workspace: root.workspace,
                    org: _activeOrgRow,
                    workspaces: Array.isArray(root.workspaces) ? root.workspaces : []
                });
                const _target = $c3c4d4411a94f898$var$shellWithWorkspacePath(_activeSlug, _handle, '/');
                console.warn('[mwt] URL org "' + slug + "\" is outside this session's memberships \u2014 " + 'rescoped to ' + _target + ' (tenant isolation)');
                try {
                    win.history.replaceState(win.history.state, '', _target);
                } catch  {}
                if (el && typeof el.router === 'function') try {
                    el.router('/', el.getRoot ? el.getRoot() : undefined);
                } catch  {}
            }
            return;
        }
        console.log("[mwt] cross-org reconcile \u2192 switchOrg", slug, targetOrgId);
        Promise.resolve(sdk.switchOrg(targetOrgId, {
            skipPersist: true
        })).catch((err)=>console.warn('[mwt] cross-org reconcile failed:', err?.message || err));
        return;
    }
    // Bare URL (no `/w/` prefix) — canonicalize an INTRANET route to the active
    // org's `/w/<org-slug>` so every tab shows its workspace URL from load, not
    // just after navigation (design §8 test 8). replaceState (not push): the page
    // already rendered the correct route; we only rewrite the address bar, and the
    // AppShell history patch re-syncs `root.currentPath` (Phase-1 consumers strip).
    const pathOnly = path.split(/[?#]/)[0];
    if (!$c3c4d4411a94f898$var$isMwtIntranetRoute(pathOnly, $c3c4d4411a94f898$var$moduleRoutesFromRoot(root))) return;
    // Resolve the active org from `root.org` — a bare load has no `sdkOrgId`, so
    // that is the authoritative source here; prefer the SDK-matched org only when
    // the SDK context is actually populated (a rare belt-and-suspenders path).
    const activeOrg = sdkOrgId && root.orgs.find((o)=>String(o.id ?? o._id ?? '') === String(sdkOrgId)) || root.org;
    const activeSlug = activeOrg?.slug || activeOrg?.username;
    if (!activeSlug) return;
    // Scheme A: canonicalize straight to the FULL form — org segment plus the
    // workspace segment when the active workspace needs one (shared rule), so a
    // bare `/tickets` load lands on `/w/acme/team-b/tickets` in one rewrite
    // instead of waiting for the next workspace-change sync to add the handle.
    const handle = $c3c4d4411a94f898$var$shellResolveWorkspaceUrlHandle({
        workspace: root.workspace,
        org: activeOrg,
        workspaces: Array.isArray(root.workspaces) ? root.workspaces : []
    });
    const tail = (win.location.search || '') + (win.location.hash || '');
    const target = $c3c4d4411a94f898$var$shellWithWorkspacePath(activeSlug, handle, path) + tail;
    if (target === path + tail) return;
    try {
        win.history.replaceState(win.history.state, '', target);
    } catch  {}
};
const $c3c4d4411a94f898$export$90e2d9257ef760e2 = (el)=>{
    const win = $c3c4d4411a94f898$var$_mwtWin(el);
    const loc = win?.location;
    if (!loc || !el?.routes) return;
    const rawPath = loc.pathname || '/';
    const norm = rawPath === 'srcdoc' || rawPath === 'about:srcdoc' || rawPath === 'blank' ? '/' : rawPath;
    // Always strip the reserved, unambiguous `/w/<slug>` prefix for route-matching —
    // a prefixed URL must resolve to its real route whether or not MWT is enabled. A
    // transient `?mwt=1` session (flag not persisted — dropped off the URL on the
    // first prefixed nav) leaves a `/w/<slug>` URL behind; loaded later with the flag
    // reading OFF, an un-stripped prefix fell through to the canvas
    // project-not-found 404 ("<slug> not found"). Mirrors the Phase-1 classifiers,
    // which all strip unconditionally (stripWorkspacePrefix is a no-op off-prefix).
    // WHITELABEL-STRICT-TENANT-SCOPE-1 — on a white-label host a URL naming
    // ANOTHER org (`/w/<other>/…`, `/studio/<other>`, another owner's canvas)
    // lands on the host's home on this FIRST render, which runs before any router
    // guard. Stripping a foreign `/w/keepz/default` used to leave `/default` — a
    // route that does not exist — so the tab showed "Not found".
    const foreignHome = (0, $aKav5.whitelabelForeignRedirect)(norm, el?.state?.root || el?.state);
    const matchPath = foreignHome || (0, $7iFOV.shellStripWorkspacePrefix)(norm);
    // Flag OFF but the URL still carries a stale prefix → heal the address bar back to
    // the bare route so the tab isn't stranded on a dead `/w/<slug>` URL. When the flag
    // is ON the prefix is intentional (per-tab scope) and is preserved — except a
    // foreign one, which always leaves.
    // A foreign URL's query and hash belong to the other org's route — they are
    // not carried onto the host's home.
    const tail = foreignHome ? '' : (loc.search || '') + (loc.hash || '');
    if ((foreignHome || !$c3c4d4411a94f898$var$shellIsMwtEnabled()) && matchPath !== norm && win.history) try {
        win.history.replaceState(win.history.state, '', matchPath + tail);
    } catch  {}
    const url = matchPath + tail;
    // Remember what this first dispatch asked for: the router answers it only
    // after its auth guard resolves, so the Scheme A heal (signin tick) can run
    // while this dispatch is still in flight and must not ask for it again.
    if (el.__ref) el.__ref.__mwtInitialPath = matchPath;
    return (0, $6mxzB.router)(url, el, {}, {
        initialRender: true,
        pushState: false
    });
};

});
parcelRegister("6mxzB", function(module, exports) {

$parcel$export(module.exports, "router", () => $01320bba1a5f7757$export$5375cda95f0b0eb4);
parcelRequire("byww3");
var $fXgyh = parcelRequire("fXgyh");
var $czfS0 = parcelRequire("czfS0");
var $cdzjF = parcelRequire("cdzjF");
var $gjNoZ = parcelRequire("gjNoZ");
var $BEBTO = parcelRequire("BEBTO");


var $i30jO = parcelRequire("i30jO");

var $gCyyJ = parcelRequire("gCyyJ");
parcelRequire("f41Ve");
var $6yBlx = parcelRequire("6yBlx");
var $bgB1J = parcelRequire("bgB1J");
const $01320bba1a5f7757$var$$t = (t, e, o)=>({
        ...t.context && t.context.domqlOptions,
        ...e.mountOptions,
        contentElementKey: o
    }), $01320bba1a5f7757$var$Tt = (t, e, o)=>{
    const r = o.mountOptions;
    if (!r) return;
    const n = e.context && e.context.domqlOptions;
    for(const a in r)t[a] = n && a in n ? n[a] : void 0;
}, $01320bba1a5f7757$var$wt = (t)=>{
    const e = $bgB1J.mountYieldBudget;
    return typeof e == "function" ? e(t.mountYield) > 0 : t.mountYield === !0;
}, $01320bba1a5f7757$var$Jt = (t)=>{
    const e = t && t.context && t.context.__hydration;
    return !!e && e.adopted > 0;
}, $01320bba1a5f7757$var$Xt = (t)=>{
    const e = $bgB1J.mountPending;
    return typeof e != "function" || !e(t) ? null : $bgB1J.whenMounted(t);
}, $01320bba1a5f7757$var$nt = Object.freeze({
    holdTail: !0
}), $01320bba1a5f7757$var$Zt = (t)=>typeof t.holdPage == "function" && typeof $bgB1J.releaseMount == "function", $01320bba1a5f7757$var$St = (t, e)=>{
    const o = ()=>$bgB1J.releaseMount(t);
    (0, $gCyyJ.isThenable)(e) ? e.then(o, o) : o();
}, $01320bba1a5f7757$var$te = (t, e)=>{
    let o = null;
    try {
        o = t.holdPage(e);
    } catch  {}
    $01320bba1a5f7757$var$St(e, o);
}, $01320bba1a5f7757$var$bt = Object.freeze({
    holdTail: !0,
    deferAttach: !0
}), $01320bba1a5f7757$var$ee = (t, e, o, r)=>{
    const n = t.firstView;
    if (!n || typeof $bgB1J.releaseMount != "function" || typeof $6yBlx.attachElement != "function") return null;
    if (!n.committed) return $01320bba1a5f7757$var$nt;
    if (!$01320bba1a5f7757$var$wt(r)) return null;
    const a = e.node;
    return !e[o] && a && a.isConnected ? $01320bba1a5f7757$var$bt : (r.mountYield = void 0, null);
}, $01320bba1a5f7757$var$ne = async ()=>{
    await $bgB1J.whenMountIdle();
    const t = $bgB1J.mountIdle;
    if (typeof t == "function") for(; !t();)await $bgB1J.whenMountIdle();
}, $01320bba1a5f7757$var$oe = (t, e, o, r)=>{
    if (e === $01320bba1a5f7757$var$nt) {
        t.firstView.page = o, $01320bba1a5f7757$var$St(o, t.firstView.commit);
        return;
    }
    e === $01320bba1a5f7757$var$bt && $01320bba1a5f7757$var$ne().then(()=>{
        o.__ref && r() && $6yBlx.attachElement(o), $bgB1J.releaseMount(o);
    });
}, $01320bba1a5f7757$var$vt = /^:(.+)/, $01320bba1a5f7757$var$Ot = /^\*$/, $01320bba1a5f7757$var$xt = new Map, $01320bba1a5f7757$export$c1d2f753e345bfd = (t)=>{
    const e = $01320bba1a5f7757$var$xt.get(t);
    if (e) return e;
    const o = t.replace(/^\//, "").split("/"), r = [];
    let n = !1;
    for(let u = 0; u < o.length; u++){
        const s = o[u].match($01320bba1a5f7757$var$vt);
        s ? r.push({
            index: u,
            name: s[1]
        }) : $01320bba1a5f7757$var$Ot.test(o[u]) && (n = !0);
    }
    const a = {
        segments: o,
        params: r,
        hasWildcard: n,
        pattern: t
    };
    return $01320bba1a5f7757$var$xt.set(t, a), a;
}, $01320bba1a5f7757$export$b4ee0d6794375c82 = (t, e, o = 0)=>{
    const n = t.replace(/^\//, "").split("/").filter(Boolean).slice(o), a = "/" + (n[0] || "");
    if (!e) return {
        key: null,
        content: null,
        params: {},
        routePath: a
    };
    let u = null, s = -1, h = {};
    for(const i in e){
        if (i === "/*") continue;
        const m = $01320bba1a5f7757$export$c1d2f753e345bfd(i), f = $01320bba1a5f7757$var$se(n, m);
        f > s && (s = f, u = i, h = $01320bba1a5f7757$var$Nt(n, m));
    }
    return !u && e["/*"] && (u = "/*"), {
        key: u,
        content: u ? e[u] : null,
        params: h,
        routePath: a
    };
}, $01320bba1a5f7757$var$se = (t, e)=>{
    const { segments: o, hasWildcard: r } = e;
    if (!r && o.length !== t.length && o.length !== 1 && o.length > t.length) return -1;
    let n = 0;
    const a = Math.min(o.length, t.length);
    for(let u = 0; u < a; u++)if (o[u] === t[u]) n += 3;
    else if ($01320bba1a5f7757$var$vt.test(o[u])) n += 1;
    else if ($01320bba1a5f7757$var$Ot.test(o[u])) n += .5;
    else return -1;
    return n;
}, $01320bba1a5f7757$var$ie = (t)=>{
    try {
        return decodeURIComponent(t);
    } catch  {
        return t;
    }
}, $01320bba1a5f7757$var$Nt = (t, e)=>{
    const o = {};
    for (const { index: r, name: n } of e.params)t[r] && (o[n] = $01320bba1a5f7757$var$ie(t[r]));
    return o;
}, $01320bba1a5f7757$export$1e8473eaf75b0d10 = (t)=>{
    if (!t || t === "?") return {};
    const e = {};
    return new URLSearchParams(t).forEach((r, n)=>{
        e[n] !== void 0 ? (Array.isArray(e[n]) || (e[n] = [
            e[n]
        ]), e[n].push(r)) : e[n] = r;
    }), e;
}, $01320bba1a5f7757$var$ot = (t)=>!!t && typeof t == "object" && typeof t.route == "string", $01320bba1a5f7757$var$Et = (t)=>t === !1 || typeof t == "string" || $01320bba1a5f7757$var$ot(t) ? t : void 0, $01320bba1a5f7757$var$ue = 10, $01320bba1a5f7757$var$rt = (t, e, o = 0)=>{
    for(let r = o; r < t.length; r++){
        const n = t[r](e);
        if ((0, $gCyyJ.isThenable)(n)) return Promise.resolve(n).then((u)=>{
            const s = $01320bba1a5f7757$var$Et(u);
            return s === void 0 ? $01320bba1a5f7757$var$rt(t, e, r + 1) : s;
        });
        const a = $01320bba1a5f7757$var$Et(n);
        if (a !== void 0) return a;
    }
    return !0;
}, $01320bba1a5f7757$export$6b398ed5c45e580b = async (t, e)=>!t || !t.length ? !0 : $01320bba1a5f7757$var$rt(t, e), $01320bba1a5f7757$var$Pt = (t, e, o, r)=>{
    if (typeof t != "string" || !o || !Object.prototype.hasOwnProperty.call(o, t)) return null;
    const n = o[t];
    if (!n) return null;
    const a = e.replace(/^\//, "").split("/").filter(Boolean).slice(r || 0);
    return {
        route: t,
        content: n,
        params: t === "/*" ? {} : $01320bba1a5f7757$var$Nt(a, $01320bba1a5f7757$export$c1d2f753e345bfd(t))
    };
}, $01320bba1a5f7757$var$ce = (t, e)=>{
    const o = $cdzjF.isSameRoutePage;
    return typeof o == "function" ? o(t, e) : t === e;
}, $01320bba1a5f7757$var$st = (t)=>(0, $czfS0.isObject)(t) && (0, $czfS0.isString)(t.extends) && Object.keys(t).every((e)=>e === "extends" || e === "metadata" || e === "helmet") ? t.extends : t, $01320bba1a5f7757$var$Mt = (t, e, o = 0)=>[].concat(t.extends || [], t.extend || []).reduce((r, n)=>{
        const a = (0, $czfS0.isString)(n) ? e && e[n] : n;
        if (!a || typeof a != "object" || o > 7) return r;
        const u = a.metadata !== void 0 ? a.metadata : $01320bba1a5f7757$var$Mt(a, e, o + 1);
        return u !== void 0 ? u : r;
    }, void 0), $01320bba1a5f7757$var$le = (t, e)=>$01320bba1a5f7757$var$st(t) !== t || t.metadata === void 0 || (0, $czfS0.isObject)(t.metadata) && (0, $czfS0.isObject)($01320bba1a5f7757$var$Mt(t, e && e.context && e.context.components)), $01320bba1a5f7757$var$At = (t, e)=>{
    const o = $cdzjF.routeEntryMetadata;
    if (typeof o == "function") return o(t, e && e.context && e.context.components);
}, $01320bba1a5f7757$var$fe = (t, e, o)=>{
    if (!e || typeof e != "object" || e.metadata === void 0 && e.helmet === void 0) return t;
    const r = $01320bba1a5f7757$var$At(e, o);
    return r !== void 0 && r !== e.metadata && (t.metadata = r), t;
}, $01320bba1a5f7757$var$de = (t, e)=>{
    !t || typeof t != "object" || !t.__ref || (0, $gjNoZ.runPluginHook)("routeHead", t, $01320bba1a5f7757$var$At(e, t), e);
}, $01320bba1a5f7757$export$147046761d9d45df = (t, e)=>{
    if (!e) return t;
    const o = Array.isArray(e) ? e : e.split(".");
    let r = t;
    for (const n of o){
        if (!r || !r[n]) return null;
        r = r[n];
    }
    return r;
}, $01320bba1a5f7757$var$he = (t, e)=>{
    const o = e.customRouterElement;
    if (!o || !t.__ref || t.__ref.root !== t) return t;
    const r = $01320bba1a5f7757$export$147046761d9d45df(t, o);
    return !r || r === t ? t : (t.routes && (r.routes = t.routes), r);
}, $01320bba1a5f7757$export$e7a685f330e7752 = (t = 0, e)=>{
    e || (e = typeof (0, $fXgyh.window) < "u" ? (0, $fXgyh.window).location.pathname : "/");
    const r = e.split("/")[t + 1];
    if (r) return `/${r}`;
};
let $01320bba1a5f7757$export$7a9e7a91cdf4fce1, $01320bba1a5f7757$export$ed098f724085d263 = 0, $01320bba1a5f7757$var$It = 0;
const $01320bba1a5f7757$var$it = (t)=>!t || t === "srcdoc" || t === "about:srcdoc" ? "/" : t, $01320bba1a5f7757$var$_e = (t)=>t && (t.scrollingElement || t.documentElement) || null, $01320bba1a5f7757$var$Lt = {
    level: $01320bba1a5f7757$export$ed098f724085d263,
    pushState: !0,
    replace: !1,
    initialRender: !1,
    scrollToTop: !0,
    scrollToNode: !1,
    scrollBody: !1,
    useFragment: !1,
    updateState: !0,
    scrollToOffset: 0,
    contentElementKey: "content",
    scrollToOptions: {
        behavior: "smooth"
    },
    useParamsMatching: !0,
    exitTimeout: 300,
    scrollRestoreTimeout: 1e3
}, $01320bba1a5f7757$var$Ft = (t, e)=>{
    if (!t || t.visibilityState !== "visible") return !1;
    try {
        const o = e && typeof e.matchMedia == "function" && e.matchMedia("(prefers-reduced-motion: reduce)");
        if (o && o.matches) return !1;
    } catch  {}
    return !0;
}, $01320bba1a5f7757$var$Bt = (t)=>{
    const e = t.__routeExit;
    e && (t.__routeExit = null, e.abort());
}, $01320bba1a5f7757$var$ye = (t, e, o, r, n, a, u)=>{
    const s = e.__routeExit;
    if (s && s.page === o) return s.wait;
    if ($01320bba1a5f7757$var$Bt(e), !o || !o.node || typeof t.onRouteExit > "u" || !$01320bba1a5f7757$var$Ft(a, u)) return null;
    const h = typeof n == "number" && n >= 0 ? n : $01320bba1a5f7757$var$Lt.exitTimeout, i = typeof AbortController == "function" ? new AbortController : null, m = {
        ...r,
        page: o,
        timeout: h,
        signal: i ? i.signal : void 0
    };
    let f;
    try {
        f = (0, $BEBTO.triggerEventOn)("routeExit", t, m);
    } catch  {
        return null;
    }
    if (!f || typeof f.then != "function") return null;
    const E = {
        page: o,
        abort: ()=>{
            i && !i.signal.aborted && i.abort();
        }
    };
    return E.wait = new Promise((A)=>{
        const l = setTimeout(()=>{
            E.abort(), A();
        }, h), d = ()=>{
            clearTimeout(l), A();
        };
        f.then(d, d);
    }), e.__routeExit = E, E.wait;
}, $01320bba1a5f7757$var$W = new WeakMap, $01320bba1a5f7757$var$ge = (t)=>t === !0 ? {} : t && typeof t == "object" && !Array.isArray(t) ? t : null, $01320bba1a5f7757$var$Te = (t, e, o, r)=>{
    const n = $01320bba1a5f7757$var$ge(t.transition);
    return !n || !e || (0, $gCyyJ.isLazyFallback)(e.content) || !o || typeof o.startViewTransition != "function" || $01320bba1a5f7757$var$W.get(o) > 0 || !$01320bba1a5f7757$var$Ft(o, r) ? null : n;
}, $01320bba1a5f7757$var$we = (t)=>{
    const e = t.__routeTransition;
    if (!(!e || e.updating)) try {
        e.transition.skipTransition();
    } catch  {}
}, $01320bba1a5f7757$var$Se = (t)=>{
    const e = typeof t.types == "string" ? [
        t.types
    ] : t.types;
    return Array.isArray(e) ? e.filter((o)=>typeof o == "string" && o) : [];
}, $01320bba1a5f7757$var$be = (t)=>{
    try {
        const e = t && t.ViewTransition;
        return !!e && "types" in e.prototype;
    } catch  {
        return !1;
    }
}, $01320bba1a5f7757$var$ve = 100, $01320bba1a5f7757$var$Oe = 1e3, $01320bba1a5f7757$var$Ht = (t, e)=>t === !1 ? 1 / 0 : typeof t == "number" && t >= 0 ? t : e, $01320bba1a5f7757$var$qt = (t)=>{
    const e = t && t.performance;
    return e && typeof e.now == "function" ? e.now() : Date.now();
}, $01320bba1a5f7757$var$xe = (t)=>{
    t && typeof t.then == "function" && t.then(null, ()=>{});
}, $01320bba1a5f7757$var$Re = (t, e, o, r, n, a, u)=>{
    const s = t.node, h = s && s.style, i = typeof o.name == "string" && o.name ? o.name : null, m = e.__routeTransition, f = {
        transition: null,
        updating: !1,
        name: i,
        previousName: m && m.name && h ? m.previousName : h && h.viewTransitionName || ""
    }, E = ()=>{
        if (e.__routerNavSeq === a) {
            f.updating = !0, f.swapStarted = $01320bba1a5f7757$var$qt(n), $01320bba1a5f7757$var$W.set(r, ($01320bba1a5f7757$var$W.get(r) || 0) + 1);
            try {
                return u();
            } finally{
                $01320bba1a5f7757$var$W.set(r, $01320bba1a5f7757$var$W.get(r) - 1), f.updating = !1;
            }
        }
    }, A = ()=>{
        i && h && h.viewTransitionName === i && (h.viewTransitionName = f.previousName);
    };
    i && h && (h.viewTransitionName = i);
    const l = $01320bba1a5f7757$var$Se(o);
    let d = null;
    try {
        d = l.length && $01320bba1a5f7757$var$be(n) ? r.startViewTransition({
            update: E,
            types: l
        }) : r.startViewTransition(E);
    } catch  {}
    if (!d) return A(), null;
    f.transition = d, e.__routeTransition = f, $01320bba1a5f7757$var$xe(d.ready);
    let v = !1, M = null;
    const D = ()=>{
        v = !0, M !== null && (n.clearTimeout(M), M = null), e.__routeTransition === f && (e.__routeTransition = null, A());
    }, j = ()=>{
        if (!(v || e.__routeTransition !== f)) try {
            d.skipTransition();
        } catch  {}
    };
    d.finished && typeof d.finished.then == "function" ? d.finished.then(D, D) : D();
    const F = $01320bba1a5f7757$var$Ht(o.swapBudget, $01320bba1a5f7757$var$ve), G = $01320bba1a5f7757$var$Ht(o.timeout, $01320bba1a5f7757$var$Oe);
    G !== 1 / 0 && d.ready && typeof d.ready.then == "function" && n && typeof n.setTimeout == "function" && d.ready.then(()=>{
        v || (M = n.setTimeout(()=>{
            M = null, j();
        }, G));
    }, ()=>{});
    const B = d.updateCallbackDone;
    return !B || typeof B.then != "function" ? Promise.resolve() : (F !== 1 / 0 && B.then(()=>{
        f.swapStarted !== void 0 && $01320bba1a5f7757$var$qt(n) - f.swapStarted > F && j();
    }, ()=>{}), B);
}, $01320bba1a5f7757$export$5375cda95f0b0eb4 = async (t, e, o = {}, r = {})=>{
    let n = e || void 0;
    const a = n?.context?.window || (0, $fXgyh.window), u = n?.context?.document || (0, $fXgyh.document), s = {
        ...$01320bba1a5f7757$var$Lt,
        ...n.context.routerOptions,
        ...r
    };
    $01320bba1a5f7757$export$ed098f724085d263 = s.lastLevel, n = $01320bba1a5f7757$var$he(n, s);
    const h = !(r && r.render === !1), i = n.__ref;
    (s.contentElementKey !== "content" && s.contentElementKey !== i.contentElementKey || !i.contentElementKey) && (i.contentElementKey = s.contentElementKey || "content");
    const m = i.contentElementKey || s.contentElementKey || "content", f = a.location.origin !== "null" ? a.location.origin : "http://localhost";
    t = $01320bba1a5f7757$var$it(t);
    const E = typeof a.URL == "function" ? a.URL : typeof globalThis < "u" && globalThis.URL || URL, A = new E(f + t), { pathname: l, search: d, hash: v } = A, M = $01320bba1a5f7757$export$1e8473eaf75b0d10(d), D = n.node, j = v && v !== a.location.hash.slice(1), F = l !== $01320bba1a5f7757$export$7a9e7a91cdf4fce1, G = $01320bba1a5f7757$export$7a9e7a91cdf4fce1, B = ++$01320bba1a5f7757$var$It;
    $01320bba1a5f7757$export$7a9e7a91cdf4fce1 = l;
    const H = ()=>{
        $01320bba1a5f7757$var$It === B && ($01320bba1a5f7757$export$7a9e7a91cdf4fce1 = G);
    }, w = i.__routerRendered;
    let S, J, p, C;
    if (s.useParamsMatching) {
        const c = $01320bba1a5f7757$export$b4ee0d6794375c82(l, n.routes, s.level);
        S = c.key, J = c.routePath, p = c.content, C = c.params;
    } else {
        S = $01320bba1a5f7757$export$e7a685f330e7752(s.level, l), J = S;
        const c = n.routes;
        p = c ? c[S || "/"] || c["/*"] : null, C = {};
    }
    if (r && r.route != null) {
        const c = $01320bba1a5f7757$var$Pt(r.route, l, n.routes, s.level);
        !c && s.silent, S = c ? c.route : r.route, p = c ? c.content : null, C = c ? c.params : {};
    }
    s.scrollNode === void 0 && (s.scrollNode = $01320bba1a5f7757$var$_e(u));
    const O = s.scrollToNode ? D : s.scrollNode;
    if (n.state?.root?.debugging) {
        n.state.root.debugging = !1;
        return;
    }
    const b = (0, $i30jO.beginHistoryNavigation)(a, s, O);
    if (b && b.pop && b.pop.echo) return;
    if (!p) {
        H(), s.onNotFound ? s.onNotFound({
            pathname: l,
            route: S,
            element: n
        }) : (s.silent || console.warn("[smbls/router] no content matched for path", l, "\u2014 available routes:", Object.keys(n.routes || {})), s.event && s.event.type === "popstate" && (0, $i30jO.keepAddressWithPage)(b, i, a));
        return;
    }
    const Dt = r && r.lazy ? i.__routerStartSeq : i.__routerStartSeq = (i.__routerStartSeq || 0) + 1;
    if (s.guards && s.guards.length) {
        const c = {
            pathname: l,
            route: S,
            params: C,
            query: M,
            hash: v,
            element: n,
            state: o
        };
        let _ = $01320bba1a5f7757$var$rt(s.guards, c);
        if ((0, $gCyyJ.isThenable)(_) && (_ = await _, i.__routerStartSeq !== Dt)) {
            H(), (0, $i30jO.dropHistoryNavigation)(b);
            return;
        }
        if (_ === !1) {
            H(), (0, $i30jO.refuseHistoryNavigation)(b);
            return;
        }
        const Q = (x)=>{
            const R = new E(f + $01320bba1a5f7757$var$it(x));
            return R.pathname === l && R.search === d && R.hash === v;
        }, U = typeof _ == "string" ? _ : $01320bba1a5f7757$var$ot(_) && typeof _.path == "string" && !Q(_.path) ? _.path : null;
        if ($01320bba1a5f7757$var$ot(_) && U === null) {
            const x = $01320bba1a5f7757$var$Pt(_.route, l, n.routes, s.level);
            if (!x) {
                s.silent, H(), s.onNotFound ? s.onNotFound({
                    pathname: l,
                    route: _.route,
                    element: n
                }) : s.event && s.event.type === "popstate" && (0, $i30jO.keepAddressWithPage)(b, i, a);
                return;
            }
            S = x.route, p = x.content, C = x.params, r = {
                ...r,
                route: x.route
            };
        } else if (U !== null) {
            const x = !!(b && b.pop);
            if (x && !(0, $i30jO.commitHistoryNavigation)(b)) return;
            const R = [
                ...r && r.__redirectChain || [],
                l
            ], q = new E(f + $01320bba1a5f7757$var$it(U)).pathname, I = R.includes(q) || R.length >= $01320bba1a5f7757$var$ue;
            I && s.silent;
            const y = {
                ...r,
                __redirectChain: R
            };
            return I && (y.guards = []), typeof _ == "string" ? delete y.route : y.route = _.route, x && (y.event = void 0), delete y.render, (x || s.initialRender) && (y.pushState = !0, y.replace = !0), $01320bba1a5f7757$export$5375cda95f0b0eb4(U, e, o, y);
        }
    }
    const P = h ? (0, $gCyyJ.lazyRoute)(p, n, n.routes, s) : null;
    if (P && P.rematch) return $01320bba1a5f7757$export$5375cda95f0b0eb4(t, n, o, r);
    if (P && P.wait) {
        const c = i.__routerNavSeq;
        return await P.wait, i.__routerNavSeq !== c || typeof n?.set != "function" ? void 0 : $01320bba1a5f7757$export$5375cda95f0b0eb4(t, n, o, {
            ...r,
            guards: [],
            __lazyAwaited: !0
        });
    }
    P && (p = P.content, s.lazy = {
        group: P.group,
        status: P.status
    });
    const Y = i.__routerNavSeq = (i.__routerNavSeq || 0) + 1, jt = !w || w.content !== p || w.route !== S, at = !!w && $01320bba1a5f7757$var$ce(w.content, p), k = !(!h || s.keepSamePage === !0 && at && s.force !== !0) && (F || jt || s.force === !0);
    if (k && w && !(0, $gCyyJ.isLazyFallback)(w.content)) {
        const c = $01320bba1a5f7757$var$ye(n, i, n[m], {
            from: w.route,
            to: S,
            pathname: l,
            params: C,
            query: M,
            hash: v
        }, s.exitTimeout, u, a);
        if (c && (await c, i.__routerNavSeq !== Y || (i.__routeExit && i.__routeExit.wait === c && (i.__routeExit = null), typeof n?.set != "function"))) return;
    } else $01320bba1a5f7757$var$Bt(i);
    const ut = k ? $01320bba1a5f7757$var$Te(s, w, u, a) : null;
    if (k && $01320bba1a5f7757$var$we(i), s.pushState) {
        const c = l + (d || "") + (v || "");
        (0, $i30jO.writeHistoryEntry)(b, o, c, s.replace, a);
    } else b && (0, $i30jO.commitHistoryNavigation)(b);
    (0, $i30jO.noteAddress)(i, a);
    const V = $01320bba1a5f7757$var$$t(n, s, m), ct = ()=>{
        const c = k ? $01320bba1a5f7757$var$ee(s, n, m, V) : null, _ = (!!w || $01320bba1a5f7757$var$wt(V)) && !!O && O.scrollTop === 0 && !O.scrollLeft, Q = !w && !!s.initialRender && !!O && $01320bba1a5f7757$var$Jt(n) && (Number(O.scrollTop) > 0 || Number(O.scrollLeft) > 0), x = F || !j ? {
            route: S,
            routePath: J,
            hash: v,
            params: C,
            query: M,
            debugging: !1
        } : {
            params: C,
            query: M
        };
        s.updateState && n.state.update(x, {
            preventContentUpdate: !0
        });
        let R = null;
        if (k) {
            m && s.removeOldElement && n[m].remove();
            const I = n.__ref?.origin?.content, y = {};
            if (I) for(const g in I){
                const T = I[g];
                g === "__ref" || g === "props" || g === "node" || g === "parent" || g === "key" || (typeof T == "string" || typeof T == "number" || typeof T == "boolean" || typeof T == "object" && T !== null && !T.node && !T.__ref) && (y[g] = T);
            }
            const L = $01320bba1a5f7757$var$fe({
                ...y,
                ...typeof p == "object" ? p : {
                    extends: p
                }
            }, p, n);
            s.useFragment && (L.tag = "fragment");
            const z = {
                content: p,
                route: S
            }, X = i.__routerRendered;
            try {
                if (typeof n?.set != "function") return;
                i.__routerRendered = z;
                const g = !c && $01320bba1a5f7757$var$Zt(s), T = n.set(L, V, c || (g ? $01320bba1a5f7757$var$nt : void 0));
                T && c ? $01320bba1a5f7757$var$oe(s, c, T, ()=>i.__routerNavSeq === Y) : T && g && $01320bba1a5f7757$var$te(s, T), R = $01320bba1a5f7757$var$Xt(n[m]);
            } catch (g) {
                i.__routerRendered === z && (i.__routerRendered = X), console.error("[smbls/router] failed to render route content", l, g);
                try {
                    (0, $gjNoZ.runPluginHook)("renderError", n, {
                        where: "route",
                        route: l,
                        error: g
                    });
                } catch (T) {
                    console.error("[smbls/router] renderError hook threw:", T);
                }
            }
        } else at && w.route !== S && i.__routerRendered === w && (i.__routerRendered = {
            content: p,
            route: S
        }, p !== w.content && $01320bba1a5f7757$var$de(n[m], p));
        const q = ()=>{
            const I = !F && j, y = !h || (0, $i30jO.restoreHistoryScroll)(b, O, s, u);
            if (!y && !Q && s.scrollToTop && !I && !_ && O?.scrollTo && O.scrollTo({
                ...s.scrollToOptions || {},
                top: 0,
                left: 0
            }), !y && !Q && s.scrollToNode && p[m]?.node?.scrollTo && p[m].node.scrollTo({
                ...s.scrollToOptions || {},
                top: 0,
                left: 0
            }), !y && v) {
                const L = u.getElementById(v.slice(1));
                if (L && O?.scrollTo) {
                    const z = a.getComputedStyle ? a.getComputedStyle(L) : null, X = z && parseFloat(z.scrollMarginTop) || 0, g = L.getBoundingClientRect().top + O.scrollTop - X - (s.scrollToOffset || 0);
                    O.scrollTo({
                        ...s.scrollToOptions || {},
                        top: g,
                        left: 0
                    });
                }
            }
            P && (0, $gCyyJ.settleLazyRoute)(n, P, (L)=>$01320bba1a5f7757$export$5375cda95f0b0eb4(t, n, o, {
                    ...r,
                    ...L
                })), (0, $BEBTO.triggerEventOn)("routeChanged", n, s);
        };
        if (R) return R.then(()=>{
            $01320bba1a5f7757$var$Tt(V, n, s), i.__routerNavSeq === Y && q();
        });
        $01320bba1a5f7757$var$Tt(V, n, s), q();
    }, lt = ut ? $01320bba1a5f7757$var$Re(n, i, ut, u, a, Y, ct) : null;
    if (lt) {
        await lt;
        return;
    }
    return ct();
};
var $01320bba1a5f7757$export$2e2bcd8739ae039 = $01320bba1a5f7757$export$5375cda95f0b0eb4;

});
parcelRegister("i30jO", function(module, exports) {

$parcel$export(module.exports, "beginHistoryNavigation", () => $d238c10c925feeb2$export$adef36fea84619f);
$parcel$export(module.exports, "commitHistoryNavigation", () => $d238c10c925feeb2$export$15e747e52705eb4f);
$parcel$export(module.exports, "dropHistoryNavigation", () => $d238c10c925feeb2$export$5e4c1af22614ce01);
$parcel$export(module.exports, "refuseHistoryNavigation", () => $d238c10c925feeb2$export$b3b308720c720514);
$parcel$export(module.exports, "noteAddress", () => $d238c10c925feeb2$export$ee8c8440223ea42e);
$parcel$export(module.exports, "keepAddressWithPage", () => $d238c10c925feeb2$export$e2c89e467493e34e);
$parcel$export(module.exports, "writeHistoryEntry", () => $d238c10c925feeb2$export$567d872fbc3cfbc8);
$parcel$export(module.exports, "restoreHistoryScroll", () => $d238c10c925feeb2$export$2f82d639f1e7b5a4);
const $d238c10c925feeb2$var$x = "__smblsRouter", $d238c10c925feeb2$var$S = new WeakMap;
let $d238c10c925feeb2$var$J = 0;
const $d238c10c925feeb2$var$N = ()=>Date.now().toString(36) + (++$d238c10c925feeb2$var$J).toString(36) + Math.random().toString(36).slice(2, 6), $d238c10c925feeb2$var$b = (e)=>{
    try {
        const t = e && e.history;
        if (t && typeof t.pushState == "function" && typeof t.replaceState == "function" && typeof t.go == "function") return t;
    } catch  {}
    return null;
}, $d238c10c925feeb2$var$y = (e)=>{
    try {
        return e.state;
    } catch  {
        return;
    }
}, $d238c10c925feeb2$var$h = (e)=>{
    try {
        const { pathname: t, search: r, hash: n } = e.location;
        return t + r + n;
    } catch  {
        return null;
    }
}, $d238c10c925feeb2$var$_ = (e)=>{
    if (!e || typeof e != "object" || Array.isArray(e)) return !1;
    const t = Object.getPrototypeOf(e);
    return t === null || Object.getPrototypeOf(t) === null;
}, $d238c10c925feeb2$var$L = (e)=>{
    const t = $d238c10c925feeb2$var$_(e) ? e[$d238c10c925feeb2$var$x] : null;
    return t && typeof t.key == "string" && typeof t.chain == "string" && Number.isInteger(t.index) ? t : null;
}, $d238c10c925feeb2$var$T = (e, t)=>e == null ? {
        [$d238c10c925feeb2$var$x]: t
    } : $d238c10c925feeb2$var$_(e) ? {
        ...e,
        [$d238c10c925feeb2$var$x]: t
    } : null, $d238c10c925feeb2$var$q = ()=>({
        key: $d238c10c925feeb2$var$N(),
        index: 0,
        chain: $d238c10c925feeb2$var$N()
    }), $d238c10c925feeb2$var$d = (e, t)=>{
    const r = $d238c10c925feeb2$var$L(t);
    return {
        key: r ? r.key : null,
        index: r ? r.index : null,
        chain: r ? r.chain : null,
        url: $d238c10c925feeb2$var$h(e),
        state: t
    };
}, $d238c10c925feeb2$var$R = (e, t)=>{
    const r = $d238c10c925feeb2$var$L(e);
    return t.key ? !!r && r.key === t.key : !r && e === t.state;
}, $d238c10c925feeb2$var$m = (e, t, r)=>!!r && $d238c10c925feeb2$var$h(e) === r.url && $d238c10c925feeb2$var$R(t, r), $d238c10c925feeb2$var$E = (e, t, r)=>({
        ...e,
        url: t,
        state: r
    }), $d238c10c925feeb2$var$O = (e, t)=>{
    const r = $d238c10c925feeb2$var$y(t), n = $d238c10c925feeb2$var$d(e, r);
    if (n.key) return n;
    const o = $d238c10c925feeb2$var$q(), s = $d238c10c925feeb2$var$T(r, o);
    if (!s) return n;
    try {
        t.replaceState(s, null);
    } catch  {
        return n;
    }
    return $d238c10c925feeb2$var$E(o, n.url, s);
}, $d238c10c925feeb2$var$U = (e, t)=>{
    let r = $d238c10c925feeb2$var$S.get(e);
    return !r && t && (r = {
        current: null,
        pending: null,
        expect: null,
        seq: 0,
        pops: new WeakMap,
        positions: null,
        scrollNode: null,
        restore: null
    }, $d238c10c925feeb2$var$S.set(e, r)), r || null;
}, $d238c10c925feeb2$var$I = "smbls.router.scroll", $d238c10c925feeb2$var$P = 100, $d238c10c925feeb2$var$z = 1e3, $d238c10c925feeb2$var$H = [
    "wheel",
    "touchstart",
    "keydown",
    "pointerdown"
], $d238c10c925feeb2$var$F = (e)=>{
    try {
        return e.sessionStorage || null;
    } catch  {
        return null;
    }
}, $d238c10c925feeb2$var$w = (e)=>{
    try {
        const t = JSON.parse(e.getItem($d238c10c925feeb2$var$I) || "[]");
        return Array.isArray(t) ? t.filter((r)=>Array.isArray(r) && typeof r[0] == "string") : [];
    } catch  {
        return [];
    }
}, $d238c10c925feeb2$var$D = (e, t)=>{
    if (!e.positions) {
        e.positions = new Map;
        const r = $d238c10c925feeb2$var$F(t);
        if (r) for (const [n, o] of $d238c10c925feeb2$var$w(r))o && Number.isFinite(o.top) && Number.isFinite(o.left) && e.positions.set(n, {
            top: o.top,
            left: o.left
        });
    }
    return e.positions;
}, $d238c10c925feeb2$var$A = (e, t, r, n)=>{
    const o = $d238c10c925feeb2$var$D(e, t);
    o.delete(r), o.set(r, {
        top: Math.round(Number(n.scrollTop) || 0),
        left: Math.round(Number(n.scrollLeft) || 0)
    }), o.size > $d238c10c925feeb2$var$P && o.delete(o.keys().next().value);
    const s = $d238c10c925feeb2$var$F(t);
    if (s) try {
        const c = new Map($d238c10c925feeb2$var$w(s));
        for (const [i, l] of o)c.delete(i), c.set(i, l);
        s.setItem($d238c10c925feeb2$var$I, JSON.stringify(Array.from(c).slice(-$d238c10c925feeb2$var$P)));
    } catch  {}
}, $d238c10c925feeb2$var$j = (e, t, r)=>{
    (!t || t.visibilityState !== "hidden") && typeof e.requestAnimationFrame == "function" ? e.requestAnimationFrame(r) : typeof e.setTimeout == "function" ? e.setTimeout(r, 16) : setTimeout(r, 16);
}, $d238c10c925feeb2$var$B = (e, t, r, n, o, s, c)=>{
    r.restore && r.restore.end("replaced"), r.restore = n;
    const i = typeof c == "number" && c >= 0 ? c : $d238c10c925feeb2$var$z, l = ()=>Math.max(0, (Number(o.scrollHeight) || 0) - (Number(o.clientHeight) || 0)), u = (f, k)=>{
        typeof o.scrollTo == "function" ? o.scrollTo({
            top: f,
            left: k,
            behavior: "instant"
        }) : (o.scrollTop = f, o.scrollLeft = k);
    }, p = typeof e.addEventListener == "function", a = ()=>n.end("visitor");
    if (n.end = (f)=>{
        if (!n.outcome && (n.outcome = f, p)) for (const k of $d238c10c925feeb2$var$H)e.removeEventListener(k, a, !0);
    }, l() >= s.top - 1) return u(s.top, s.left), n.end("placed");
    Number(o.scrollTop) > 0 && u(0, 0);
    const C = Number(o.scrollTop) || 0, W = Date.now();
    if (p) for (const f of $d238c10c925feeb2$var$H)e.addEventListener(f, a, {
        capture: !0,
        passive: !0
    });
    const M = ()=>{
        if (n.outcome) return;
        if (r.seq !== n.seq) return n.end("overtaken");
        if (Math.abs((Number(o.scrollTop) || 0) - C) > 1) return n.end("visitor");
        const f = l() >= s.top - 1;
        if (!f && Date.now() - W < i) return $d238c10c925feeb2$var$j(e, t, M);
        u(Math.min(s.top, l()), s.left), n.end(f ? "placed" : "clamped");
    };
    $d238c10c925feeb2$var$j(e, t, M);
}, $d238c10c925feeb2$var$V = (e, t)=>{
    const { win: r, history: n, track: o } = e, s = o.pops.get(t);
    if (s) return s;
    const c = $d238c10c925feeb2$var$d(r, $d238c10c925feeb2$var$y(n)), i = o.expect;
    o.expect = null;
    let l;
    if (i && c.key === i.key && c.url === i.url) l = {
        echo: !0
    };
    else {
        const u = o.current, p = !!(c.key && u && u.key === c.key), a = p ? null : u;
        a && a.key && e.scrollNode && $d238c10c925feeb2$var$A(o, r, a.key, e.scrollNode), l = {
            to: c,
            from: a,
            stay: p,
            seq: o.seq,
            settled: !1,
            committed: !1
        }, o.pending = l;
    }
    return o.pops.set(t, l), l;
}, $d238c10c925feeb2$var$Z = (e)=>{
    const { win: t, history: r, track: n } = e, o = $d238c10c925feeb2$var$y(r);
    if (n.pending && $d238c10c925feeb2$var$m(t, o, n.pending.to) || n.expect && $d238c10c925feeb2$var$m(t, o, n.expect.away)) return;
    const s = n.current;
    if (s && (s.key ? $d238c10c925feeb2$var$R(o, s) : $d238c10c925feeb2$var$m(t, o, s))) {
        s.url = $d238c10c925feeb2$var$h(t), s.state = o;
        return;
    }
    n.current = e.restore ? $d238c10c925feeb2$var$O(t, r) : $d238c10c925feeb2$var$d(t, o), n.pending = null, n.seq++;
}, $d238c10c925feeb2$export$adef36fea84619f = (e, t, r)=>{
    const n = t.scrollRestoration === "restore", o = $d238c10c925feeb2$var$b(e), s = n || Array.isArray(t.guards) && t.guards.length > 0, c = o && $d238c10c925feeb2$var$U(o, s);
    if (!c) return null;
    const i = {
        win: e,
        history: o,
        track: c,
        restore: n,
        scrollNode: n && r ? r : null,
        pop: null
    };
    i.scrollNode && (c.scrollNode = i.scrollNode);
    const l = t.event;
    return l && l.type === "popstate" ? i.pop = $d238c10c925feeb2$var$V(i, l) : $d238c10c925feeb2$var$Z(i), i;
}, $d238c10c925feeb2$var$g = (e, t)=>{
    t.settled = !0, e.pending === t && (e.pending = null);
}, $d238c10c925feeb2$export$15e747e52705eb4f = (e)=>{
    const t = e && e.pop;
    if (!t || t.echo) return !0;
    if (t.settled) return t.committed;
    const { win: r, history: n, track: o } = e;
    return $d238c10c925feeb2$var$g(o, t), o.seq !== t.seq || !$d238c10c925feeb2$var$m(r, $d238c10c925feeb2$var$y(n), t.to) ? !1 : (o.current = e.restore && !t.to.key ? $d238c10c925feeb2$var$O(r, n) : t.to, o.seq++, t.committed = !0, !0);
}, $d238c10c925feeb2$export$5e4c1af22614ce01 = (e)=>{
    const t = e && e.pop;
    t && !t.echo && !t.settled && $d238c10c925feeb2$var$g(e.track, t);
}, $d238c10c925feeb2$var$G = (e, t, r)=>{
    try {
        e.addEventListener("popstate", ()=>{
            t.expect === r && (t.expect = null);
        }, {
            once: !0
        });
    } catch  {}
}, $d238c10c925feeb2$export$b3b308720c720514 = (e, t)=>{
    const r = e && e.pop;
    if (!r || r.echo || r.settled) return;
    const { win: n, history: o, track: s } = e;
    $d238c10c925feeb2$var$g(s, r);
    const c = r.from;
    if (!c || s.seq !== r.seq || !$d238c10c925feeb2$var$m(n, $d238c10c925feeb2$var$y(o), r.to)) return;
    const i = r.to;
    if (!t && c.key && i.key && c.chain === i.chain && c.index !== i.index) {
        const p = s.expect = {
            key: c.key,
            url: c.url,
            away: i
        };
        $d238c10c925feeb2$var$G(n, s, p);
        try {
            o.go(c.index - i.index);
        } catch  {
            s.expect = null;
        }
        return;
    }
    const l = $d238c10c925feeb2$var$q(), u = $d238c10c925feeb2$var$T(c.state, l);
    try {
        o.replaceState(u || c.state, null, c.url);
    } catch  {
        return;
    }
    s.current = u ? $d238c10c925feeb2$var$E(l, c.url, u) : $d238c10c925feeb2$var$d(n, $d238c10c925feeb2$var$y(o)), s.seq++;
}, $d238c10c925feeb2$export$ee8c8440223ea42e = (e, t)=>{
    const r = $d238c10c925feeb2$var$h(t);
    e && r !== null && (e.__routerAddress = r);
}, $d238c10c925feeb2$export$e2c89e467493e34e = (e, t, r)=>{
    const n = e && e.pop;
    if (n && !n.echo && n.from) return $d238c10c925feeb2$export$b3b308720c720514(e, !0);
    n && !n.settled && $d238c10c925feeb2$var$g(e.track, n);
    const o = $d238c10c925feeb2$var$b(r), s = t && t.__routerAddress;
    if (!(!o || !s || s === $d238c10c925feeb2$var$h(r))) try {
        o.replaceState($d238c10c925feeb2$var$y(o), null, s);
    } catch  {}
}, $d238c10c925feeb2$export$567d872fbc3cfbc8 = (e, t, r, n, o = e && e.win)=>{
    if (!e) {
        try {
            n ? o.history.replaceState(t, null, r) : o.history.pushState(t, null, r);
        } catch  {}
        return;
    }
    const { history: s, track: c } = e, i = c.current;
    !n && i && i.key && e.scrollNode && $d238c10c925feeb2$var$A(c, o, i.key, e.scrollNode);
    const l = n ? $d238c10c925feeb2$var$d(o, $d238c10c925feeb2$var$y(s)) : $d238c10c925feeb2$var$O(o, s), u = l.key ? n ? {
        key: l.key,
        index: l.index,
        chain: l.chain
    } : {
        key: $d238c10c925feeb2$var$N(),
        index: l.index + 1,
        chain: l.chain
    } : $d238c10c925feeb2$var$q(), p = $d238c10c925feeb2$var$T(t, u);
    try {
        n ? s.replaceState(p || t, null, r) : s.pushState(p || t, null, r);
    } catch  {
        return;
    }
    c.current = p ? $d238c10c925feeb2$var$E(u, r, p) : $d238c10c925feeb2$var$d(o, $d238c10c925feeb2$var$y(s)), c.pending = null, c.expect = null, c.seq++;
}, $d238c10c925feeb2$export$2f82d639f1e7b5a4 = (e, t, r, n)=>{
    if (!e || !e.restore || !t) return !1;
    const o = e.pop;
    if (o ? o.stay || !o.committed : !r.initialRender) return !1;
    const { win: s, track: c } = e, i = c.current, l = i && i.key && $d238c10c925feeb2$var$D(c, s).get(i.key);
    if (!l) return !1;
    const u = c.restore;
    return !!u && u.key === i.key && (o ? u.pop === o : !u.pop && u.seq === c.seq) && u.outcome === "visitor" || $d238c10c925feeb2$var$B(s, n, c, {
        key: i.key,
        pop: o,
        seq: c.seq,
        outcome: null
    }, t, l, r.scrollRestoreTimeout), !0;
}, $d238c10c925feeb2$export$6ed27cb48b29daa8 = (e)=>{
    const t = $d238c10c925feeb2$var$b(e), r = t && $d238c10c925feeb2$var$S.get(t);
    !r || !r.scrollNode || !r.current || !r.current.key || $d238c10c925feeb2$var$A(r, e, r.current.key, r.scrollNode);
};

});

parcelRegister("gCyyJ", function(module, exports) {

$parcel$export(module.exports, "isLazyFallback", () => $c19b00b5acae16b9$export$ef196434524d0961);
$parcel$export(module.exports, "isThenable", () => $c19b00b5acae16b9$export$f5b060c2914b97c8);
$parcel$export(module.exports, "lazyRoute", () => $c19b00b5acae16b9$export$344f0db079bc4db6);
$parcel$export(module.exports, "settleLazyRoute", () => $c19b00b5acae16b9$export$36071f5603f4d591);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");
parcelRequire("f41Ve");
var $fHfMu = parcelRequire("fHfMu");

var $iwkuS = parcelRequire("iwkuS");
const $c19b00b5acae16b9$var$x = [
    "components",
    "functions",
    "methods",
    "snippets"
], $c19b00b5acae16b9$var$F = new Set([
    "pages",
    ...$c19b00b5acae16b9$var$x
]), $c19b00b5acae16b9$var$j = new Set([
    "default",
    "__esModule"
]), $c19b00b5acae16b9$var$w = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), $c19b00b5acae16b9$var$u = (t)=>!!t && typeof t == "object" && !Array.isArray(t), $c19b00b5acae16b9$var$S = new WeakMap, $c19b00b5acae16b9$var$M = new WeakMap, $c19b00b5acae16b9$var$P = new WeakMap, $c19b00b5acae16b9$var$v = new Set, $c19b00b5acae16b9$var$z = (t, e = console.warn)=>{
    $c19b00b5acae16b9$var$v.has(t) || ($c19b00b5acae16b9$var$v.add(t), e(t));
}, $c19b00b5acae16b9$var$B = (t)=>$c19b00b5acae16b9$var$u(t && t.lazy), $c19b00b5acae16b9$var$E = (t, e)=>{
    const o = t && t.lazy;
    return $c19b00b5acae16b9$var$u(o) && $c19b00b5acae16b9$var$w(o, e) ? o[e] : void 0;
}, $c19b00b5acae16b9$var$k = (t, e)=>{
    const o = $c19b00b5acae16b9$var$E(t, e);
    return $c19b00b5acae16b9$var$u(o) && $c19b00b5acae16b9$var$w(o, "load") ? o.load : o;
}, $c19b00b5acae16b9$var$q = (t, e)=>{
    const o = $c19b00b5acae16b9$var$E(t, e);
    return $c19b00b5acae16b9$var$u(o) && typeof o.when == "function" ? o.when : null;
}, $c19b00b5acae16b9$var$Y = (t)=>{
    const e = new Error(`[smbls/router] lazy group "${t}" waits: its \`when\` said false \u2014 nothing was requested`);
    return e.code = "LAZY_WAITING", e;
}, $c19b00b5acae16b9$var$A = (t, e)=>{
    let o = $c19b00b5acae16b9$var$S.get(t);
    o || ($c19b00b5acae16b9$var$S.set(t, o = new Map), t.__teardowns = t.__teardowns || [], t.__teardowns.push(()=>{
        for (const r of o.values())r.disposed = !0, r.waiting.clear();
        $c19b00b5acae16b9$var$S.delete(t);
    }));
    let s = o.get(e);
    return s || (s = {
        status: "idle",
        attempts: 0,
        promise: null,
        failure: null,
        disposed: !1,
        pages: null,
        waiting: new Set,
        maps: new Set
    }, o.set(e, s)), s;
}, $c19b00b5acae16b9$export$35fda8fcab55f409 = (t, e)=>!$c19b00b5acae16b9$var$B(e) || !$c19b00b5acae16b9$var$u(t) || !$c19b00b5acae16b9$var$w(t, "lazy") ? null : typeof t.lazy == "string" && t.lazy ? t.lazy : null, $c19b00b5acae16b9$export$ef196434524d0961 = (t)=>!!t && typeof t == "object" && $c19b00b5acae16b9$var$P.has(t), $c19b00b5acae16b9$var$T = (t, e)=>(t && t.lazy && typeof t.lazy == "object" && (0, $iwkuS.reportDroppedFeature)("lazyRoutes", e), null), $c19b00b5acae16b9$var$V = (t)=>t && (t.status === "error" || t.status === "reload" || t.status === "waiting") ? t.status : "loading", $c19b00b5acae16b9$var$J = (t, e)=>typeof $c19b00b5acae16b9$var$k(t, e) != "function" ? "error" : $c19b00b5acae16b9$var$V($c19b00b5acae16b9$var$S.get(t)?.get(e)), $c19b00b5acae16b9$var$H = (t, e)=>{
    const o = $c19b00b5acae16b9$var$M.get(t);
    if (o && o.group === e) return o;
    const { lazy: s, state: r, ...n } = t, a = r == null || $c19b00b5acae16b9$var$u(r) || typeof r == "function";
    a ? n.state = (f, c)=>{
        const h = typeof r == "function" ? r(f, c) : r;
        return {
            ...$c19b00b5acae16b9$var$u(h) ? h : null,
            lazyStatus: $c19b00b5acae16b9$var$J(f.context, e)
        };
    } : (n.state = r, (0, $dSdIt.isLoudDevRuntime)() && $c19b00b5acae16b9$var$z(`[smbls/router] the placeholder of lazy group "${e}" binds its state to a path (${JSON.stringify(r)}), so it gets no \`lazyStatus\` \u2014 give it its own state object to show a load failure.`));
    const l = {
        definition: n,
        group: e,
        hasStatus: a
    };
    return $c19b00b5acae16b9$var$M.set(t, l), $c19b00b5acae16b9$var$P.set(n, l), l;
}, $c19b00b5acae16b9$var$Q = (t)=>t.__ref && t.__ref.contentElementKey || "content", $c19b00b5acae16b9$var$b = (t, e)=>{
    const o = t && t.__ref && t.__ref.__routerRendered, s = o && $c19b00b5acae16b9$export$ef196434524d0961(o.content) ? $c19b00b5acae16b9$var$P.get(o.content) : null;
    return !s || s.group !== e ? null : {
        record: s,
        page: t[$c19b00b5acae16b9$var$Q(t)]
    };
}, $c19b00b5acae16b9$var$m = (t, e, o)=>{
    const s = $c19b00b5acae16b9$var$b(t, e);
    if (!s || !s.record.hasStatus) return;
    const r = s.page && s.page.state;
    if (!(!r || typeof r.update != "function" || r.lazyStatus === o)) try {
        r.update({
            lazyStatus: o
        });
    } catch (n) {
        console.error(`[smbls/router] lazy group "${e}": could not show the "${o}" status on its placeholder`, n);
    }
}, $c19b00b5acae16b9$var$X = (t)=>$c19b00b5acae16b9$var$u(t) ? !Object.keys(t).some((o)=>$c19b00b5acae16b9$var$F.has(o)) && $c19b00b5acae16b9$var$u(t.default) ? t.default : t : {}, $c19b00b5acae16b9$var$tt = (t)=>{
    const e = {};
    if (!$c19b00b5acae16b9$var$u(t)) return e;
    for (const o of Object.keys(t)){
        if ($c19b00b5acae16b9$var$j.has(o)) continue;
        const s = o.charCodeAt(0) === 47, r = s ? o : "/" + (o === "index" ? "" : o);
        (s || !$c19b00b5acae16b9$var$w(e, r)) && (e[r] = t[o]);
    }
    return e;
}, $c19b00b5acae16b9$var$G = (t, e, o, s, r)=>{
    if (!$c19b00b5acae16b9$var$u(t)) return 0;
    let n = 0;
    for (const a of Object.keys(t))$c19b00b5acae16b9$export$35fda8fcab55f409(t[a], s) === e && (n++, $c19b00b5acae16b9$var$w(o, a) ? t[a] = o[a] : delete t[a]);
    for (const a of Object.keys(o))$c19b00b5acae16b9$var$w(t, a) ? t[a] !== o[a] && r.push(`pages['${a}']`) : t[a] = o[a];
    return n;
}, $c19b00b5acae16b9$var$U = (t, e, o)=>{
    const s = t[e];
    if (!$c19b00b5acae16b9$var$u(s)) {
        t[e] = {
            ...o
        };
        return;
    }
    try {
        for(const r in o)s[r] = o[r];
        if (Object.keys(o).every((r)=>s[r] === o[r])) return;
    } catch  {}
    t[e] = {
        ...s,
        ...o
    };
}, $c19b00b5acae16b9$var$et = (t)=>{
    const e = t.__ref && t.__ref.origin;
    if (!$c19b00b5acae16b9$var$u(e)) return [];
    const o = [].concat(e.extends || [], e.extend || []);
    if (o.length) return o.filter((n)=>typeof n == "string").map((n)=>(n.includes(">") ? n.split(">")[0] : n).trim());
    const s = t.key;
    if (typeof s != "string" || !/^[A-Z]/.test(s)) return [];
    const r = [
        s.indexOf("_"),
        s.indexOf(".")
    ].filter((n)=>n > 0);
    return [
        r.length ? s.slice(0, Math.min(...r)) : s
    ];
}, $c19b00b5acae16b9$var$ot = (t, e, o, s)=>{
    const r = new Set;
    for (const a of s.waiting){
        const l = $c19b00b5acae16b9$var$b(a, e);
        l && l.page && r.add(l.page);
    }
    const n = (a)=>{
        const l = a && a.__ref && a.__ref.__children;
        if (Array.isArray(l)) for (const f of l){
            const c = a[f];
            if (!(!c || !c.__ref || r.has(c) || !c.node)) {
                for (const h of $c19b00b5acae16b9$var$et(c)){
                    if (!o.has(h)) continue;
                    const y = (c.__ref.path || [
                        c.key
                    ]).join(" \u203A ");
                    $c19b00b5acae16b9$var$z(`[smbls/router] lazy group "${e}": ${y} was built before the group loaded, so it renders without "${h}". A built element never takes a later registration \u2014 build it after el.call('loadLazy', '${e}') resolves (an \`if:\` gate does that), or keep "${h}" out of the group.`);
                }
                n(c);
            }
        }
    };
    n(t);
}, $c19b00b5acae16b9$var$st = (t, e, o, s)=>{
    const r = t.context, n = $c19b00b5acae16b9$var$X(o), a = (0, $dSdIt.isLoudDevRuntime)(), l = [], f = new Set;
    if (a) for (const i of Object.keys(n))$c19b00b5acae16b9$var$F.has(i) || $c19b00b5acae16b9$var$j.has(i) || $c19b00b5acae16b9$var$z(`[smbls/router] lazy group "${e}" exports \`${i}\`, which a lazy group cannot add \u2014 it adds pages, components, functions, methods and snippets only. Declare the rest with the app.`);
    let c = !1;
    for (const i of $c19b00b5acae16b9$var$x){
        const _ = n[i];
        if (!$c19b00b5acae16b9$var$u(_)) continue;
        const p = $c19b00b5acae16b9$var$u(r[i]) ? r[i] : {}, O = {};
        for (const d of Object.keys(_))if (!$c19b00b5acae16b9$var$j.has(d)) {
            if ($c19b00b5acae16b9$var$w(p, d)) {
                p[d] !== _[d] && l.push(`${i}.${d}`);
                continue;
            }
            O[d] = _[d];
        }
        const R = Object.keys(O);
        if (R.length && ($c19b00b5acae16b9$var$U(r, i, O), i === "components" && R.forEach((d)=>f.add(d)), i === "methods" && (c = !0), (i === "functions" || i === "snippets") && $c19b00b5acae16b9$var$u(r.utils))) {
            const d = {};
            for (const $ of R)$c19b00b5acae16b9$var$w(r.utils, $) || (d[$] = O[$]);
            Object.keys(d).length && $c19b00b5acae16b9$var$U(r, "utils", d);
        }
    }
    c && (0, $fHfMu.refreshContextProto)(r);
    const h = $c19b00b5acae16b9$var$tt(n.pages);
    s.pages = h;
    let y = null;
    try {
        y = typeof t.getRoot == "function" ? t.getRoot() : null;
    } catch  {}
    const g = new Set;
    $c19b00b5acae16b9$var$u(r.pages) && g.add(r.pages), y && $c19b00b5acae16b9$var$u(y.routes) && g.add(y.routes);
    for (const i of s.maps)g.add(i);
    for (const i of s.waiting)$c19b00b5acae16b9$var$u(i.routes) && g.add(i.routes);
    for (const i of g)$c19b00b5acae16b9$var$G(i, e, h, r, l);
    a && l.length && $c19b00b5acae16b9$var$z(`[smbls/router] lazy group "${e}" redefines ${l.join(", ")}, which the app already has \u2014 the app's own value stays. Rename them: frank refuses the same collision at \`smbls push\`.`), a && f.size && y && $c19b00b5acae16b9$var$ot(y, e, f, s);
}, $c19b00b5acae16b9$var$N = (t, e)=>{
    const o = t && t.__ref, s = o && o.__lazyRoute;
    if (!s || s.group !== e || (o.__lazyRoute = null, typeof t.set != "function") || !$c19b00b5acae16b9$var$b(t, e)) return;
    const r = ()=>s.rerender({
            pushState: !1,
            replace: !1,
            scrollToTop: !1,
            guards: [],
            lazy: {
                group: e,
                status: "loaded"
            }
        }), n = ()=>{
        s.first && !$c19b00b5acae16b9$var$b(t, e) && $c19b00b5acae16b9$var$C(t.context, e);
    };
    Promise.resolve().then(r).then(n).catch((a)=>console.error(`[smbls/router] lazy group "${e}" loaded, but its route failed to render`, a));
}, $c19b00b5acae16b9$export$f5b060c2914b97c8 = (t)=>!!t && (typeof t == "object" || typeof t == "function") && typeof t.then == "function", $c19b00b5acae16b9$var$nt = (t, e, o)=>!!t && ($c19b00b5acae16b9$export$f5b060c2914b97c8(e) && e === t.returned || !!o && typeof o == "object" && o === t.error), $c19b00b5acae16b9$var$D = (t, e)=>{
    const o = t.context, s = $c19b00b5acae16b9$var$A(o, e);
    if (s.status === "loading" || s.status === "loaded") return s.promise;
    const r = $c19b00b5acae16b9$var$k(o, e), n = $c19b00b5acae16b9$var$q(o, e), a = s.failure;
    s.status = "loading";
    let l, f = !1, c = !1;
    const h = ()=>n ? n(t) : !0, y = (i)=>{
        if (i === !1) throw c = !0, $c19b00b5acae16b9$var$Y(e);
        return l = r(s.attempts++);
    }, g = Promise.resolve().then(h).then(y).then((i)=>{
        f = !0, s.disposed || $c19b00b5acae16b9$var$st(t, e, i, s);
    }).then(()=>{
        s.status = "loaded", s.failure = null;
        const i = [
            ...s.waiting
        ];
        s.waiting.clear();
        for (const _ of i)$c19b00b5acae16b9$var$N(_, e);
    }, (i)=>{
        if (c) {
            if (s.status = "waiting", s.promise = null, s.disposed) throw i;
            for (const p of [
                ...s.waiting
            ])$c19b00b5acae16b9$var$b(p, e) ? $c19b00b5acae16b9$var$m(p, e, "waiting") : s.waiting.delete(p);
            throw i;
        }
        const _ = !f && $c19b00b5acae16b9$var$nt(a, l, i);
        if (s.failure = f ? null : {
            returned: l,
            error: i
        }, s.status = _ ? "reload" : "error", s.promise = null, s.disposed) throw i;
        _ ? $c19b00b5acae16b9$var$z(`[smbls/router] lazy group "${e}" cannot load in this page: its loader handed back the import that already failed (the same promise or the same error) and requested nothing \u2014 a bundler that keeps a failed dynamic import (parcel) does this. Its routes show their placeholder with lazyStatus 'reload'; reloading the page loads the group.`, (p)=>console.error(p, i)) : console.error(`[smbls/router] lazy group "${e}" failed to load. Its routes show their placeholder with lazyStatus 'error'; the next navigation to one of them, or loadLazy('${e}'), calls the group's loader again.`, i);
        for (const p of [
            ...s.waiting
        ])$c19b00b5acae16b9$var$b(p, e) ? $c19b00b5acae16b9$var$m(p, e, s.status) : s.waiting.delete(p);
        throw i;
    });
    g.catch(()=>{}), s.promise = g;
    for (const i of s.waiting)$c19b00b5acae16b9$var$m(i, e, "loading");
    return g;
}, $c19b00b5acae16b9$var$at = (t, e)=>{
    const o = t && t.lazyFirstView;
    return o === !0 || Array.isArray(o) && o.includes(e);
}, $c19b00b5acae16b9$var$C = (t, e)=>{
    t && (t.__lazyFirstViews || (t.__lazyFirstViews = new Set), t.__lazyFirstViews.add(e));
}, $c19b00b5acae16b9$var$it = (t, e)=>{
    const o = t.context, s = ()=>($c19b00b5acae16b9$var$C(o, e), !0), r = ()=>!1;
    return Promise.resolve($c19b00b5acae16b9$var$D(t, e)).then(s, r);
}, $c19b00b5acae16b9$export$344f0db079bc4db6 = (t, e, o, s = null)=>{
    const r = e && e.context;
    const n = $c19b00b5acae16b9$export$35fda8fcab55f409(t, r);
    if (!n) return null;
    const a = $c19b00b5acae16b9$var$A(r, n);
    if ($c19b00b5acae16b9$var$u(o) && a.maps.add(o), a.status === "loaded" && $c19b00b5acae16b9$var$G(o, n, a.pages || {}, r, []) > 0) return {
        rematch: !0
    };
    const l = typeof $c19b00b5acae16b9$var$k(r, n) == "function";
    if (l && s && s.initialRender && !s.__lazyAwaited && $c19b00b5acae16b9$var$at(r, n)) return {
        wait: $c19b00b5acae16b9$var$it(e, n),
        group: n
    };
    const f = s && s.__lazyAwaited && (a.status === "error" || a.status === "reload" || a.status === "waiting");
    return l && !f ? $c19b00b5acae16b9$var$D(e, n) : $c19b00b5acae16b9$var$z(`[smbls/router] a route names lazy group "${n}", which context.lazy does not declare as a loader (\`lazy: { ${n}: () => import('./\u2026') }\`) \u2014 it shows its placeholder in the error state.`, console.error), {
        content: $c19b00b5acae16b9$var$H(t, n).definition,
        group: n,
        status: l ? "loading" : "error",
        first: !!(s && s.initialRender)
    };
}, $c19b00b5acae16b9$export$36071f5603f4d591 = (t, e, o)=>{
    if (!e || !e.group || e.status === "error") return;
    const s = t.context, r = t.__ref;
    if (!r || typeof $c19b00b5acae16b9$var$k(s, e.group) != "function") return;
    const n = $c19b00b5acae16b9$var$A(s, e.group);
    if (r.__lazyRoute = {
        group: e.group,
        rerender: o,
        first: !!e.first
    }, $c19b00b5acae16b9$var$m(t, e.group, $c19b00b5acae16b9$var$V(n)), n.status === "loaded") {
        const a = ()=>$c19b00b5acae16b9$var$N(t, e.group);
        Promise.resolve().then(a);
        return;
    }
    n.waiting.add(t);
};
function $c19b00b5acae16b9$export$a9c5e1a518cd40ab(t) {
    const e = this, o = e && e.context;
    if (!o) return Promise.reject(new TypeError("[smbls/router] loadLazy runs on an element: el.call('loadLazy', name)"));
    const s = $c19b00b5acae16b9$var$k(o, t);
    return typeof s != "function" ? (s === void 0 && $c19b00b5acae16b9$var$B(o) && (0, $dSdIt.isLoudDevRuntime)() && $c19b00b5acae16b9$var$z(`[smbls/router] loadLazy('${t}'): context.lazy declares no group "${t}" \u2014 nothing to load.`), Promise.resolve()) : $c19b00b5acae16b9$var$D(e, t);
}

});
parcelRegister("f41Ve", function(module, exports) {
$parcel$export(module.exports, "attachElement", () => (parcelRequire("6yBlx")).attachElement);
$parcel$export(module.exports, "mountIdle", () => (parcelRequire("bgB1J")).mountIdle);
$parcel$export(module.exports, "mountPending", () => (parcelRequire("bgB1J")).mountPending);
$parcel$export(module.exports, "mountYieldBudget", () => (parcelRequire("bgB1J")).mountYieldBudget);
$parcel$export(module.exports, "refreshContextProto", () => (parcelRequire("fHfMu")).refreshContextProto);
$parcel$export(module.exports, "releaseMount", () => (parcelRequire("bgB1J")).releaseMount);
$parcel$export(module.exports, "whenMounted", () => (parcelRequire("bgB1J")).whenMounted);
$parcel$export(module.exports, "whenMountIdle", () => (parcelRequire("bgB1J")).whenMountIdle);
parcelRequire("cHApf");

});
parcelRegister("cHApf", function(module, exports) {

$parcel$export(module.exports, "attachElement", () => (parcelRequire("6yBlx")).attachElement);
$parcel$export(module.exports, "mountIdle", () => (parcelRequire("bgB1J")).mountIdle);
$parcel$export(module.exports, "mountPending", () => (parcelRequire("bgB1J")).mountPending);
$parcel$export(module.exports, "mountYieldBudget", () => (parcelRequire("bgB1J")).mountYieldBudget);
$parcel$export(module.exports, "refreshContextProto", () => (parcelRequire("fHfMu")).refreshContextProto);
$parcel$export(module.exports, "releaseMount", () => (parcelRequire("bgB1J")).releaseMount);
$parcel$export(module.exports, "whenMountIdle", () => (parcelRequire("bgB1J")).whenMountIdle);
$parcel$export(module.exports, "whenMounted", () => (parcelRequire("bgB1J")).whenMounted);
parcelRequire("6UPjc");
var $6yBlx = parcelRequire("6yBlx");

var $bgB1J = parcelRequire("bgB1J");

var $dBu6N = parcelRequire("dBu6N");

var $bCOVr = parcelRequire("bCOVr");

var $8gewL = parcelRequire("8gewL");

var $aBPRx = parcelRequire("aBPRx");

var $10sxy = parcelRequire("10sxy");

var $87g1D = parcelRequire("87g1D");

var $1UaPr = parcelRequire("1UaPr");
var $5zSXA = parcelRequire("5zSXA");

var $8RrjX = parcelRequire("8RrjX");

var $fHfMu = parcelRequire("fHfMu");

var $iav9c = parcelRequire("iav9c");

});
parcelRegister("6UPjc", function(module, exports) {

$parcel$export(module.exports, "attachElement", () => (parcelRequire("6yBlx")).attachElement);

var $gxGLR = parcelRequire("gxGLR");

var $6yBlx = parcelRequire("6yBlx");
(0, $gxGLR.installElementFeatures)();

});
parcelRegister("gxGLR", function(module, exports) {

$parcel$export(module.exports, "installElementFeatures", () => $c0b0e7d5f6148323$export$be91d582ea0787b3);

var $8NJs1 = parcelRequire("8NJs1");

var $g568v = parcelRequire("g568v");

var $g0uWD = parcelRequire("g0uWD");

var $9Ffxy = parcelRequire("9Ffxy");

var $1UaPr = parcelRequire("1UaPr");

var $4ZlRD = parcelRequire("4ZlRD");

var $5dcbP = parcelRequire("5dcbP");

var $a3srI = parcelRequire("a3srI");
function $c0b0e7d5f6148323$export$be91d582ea0787b3() {
    (0, $8NJs1.FEATURES).viewEvents = (0, $g568v.registerViewEvents), (0, $8NJs1.FEATURES).chains = (0, $g0uWD.chainHandler), (0, $8NJs1.FEATURES).rows = (0, $9Ffxy.plainRows), (0, $8NJs1.FEATURES).hydration = (0, $1UaPr.hydrationFeature), (0, $8NJs1.FEATURES).mount = (0, $4ZlRD.mountYieldFeature), (0, $8NJs1.FEATURES).containerVw = (0, $5dcbP.containerVwFeature), (0, $8NJs1.FEATURES).faceWait = (0, $a3srI.faceWaitFeature);
}

});
parcelRegister("8NJs1", function(module, exports) {

$parcel$export(module.exports, "FEATURES", () => $668627f536d324f7$export$d6a5c11f04f75862);
const $668627f536d324f7$export$d6a5c11f04f75862 = {
    viewEvents: null,
    chains: null,
    rows: null,
    hydration: null,
    mount: null,
    containerVw: null,
    faceWait: null
}, $668627f536d324f7$export$5b41124338c9baf7 = {
    bridge: null
};

});

parcelRegister("g568v", function(module, exports) {

$parcel$export(module.exports, "registerViewEvents", () => $bb51df829a996acd$export$e8d861b596277a26);

var $10sxy = parcelRequire("10sxy");

var $g0uWD = parcelRequire("g0uWD");

const $bb51df829a996acd$var$I = 1e-6, $bb51df829a996acd$var$g = new WeakMap;
function $bb51df829a996acd$var$V(e, t, r) {
    const o = e.defaultView, c = o && o.IntersectionObserver;
    if (typeof c != "function") return null;
    let s = $bb51df829a996acd$var$g.get(e);
    s || $bb51df829a996acd$var$g.set(e, s = new Map);
    const n = t + "|" + r;
    let i = s.get(n);
    if (i) return i;
    i = {
        id: n,
        byKey: s,
        threshold: t,
        targets: new Map,
        observer: null
    };
    try {
        const f = r ? {
            threshold: t,
            rootMargin: r
        } : {
            threshold: t
        };
        i.observer = new c((u)=>$bb51df829a996acd$var$E(i, u), f);
    } catch  {
        return null;
    }
    return s.set(n, i), i;
}
function $bb51df829a996acd$var$E(e, t) {
    for(let r = 0; r < t.length; r++){
        const o = t[r], c = e.targets.get(o.target);
        if (!c) continue;
        const s = !!o.isIntersecting && o.intersectionRatio >= e.threshold - $bb51df829a996acd$var$I;
        if (s === c.inView) continue;
        c.inView = s;
        const n = s ? "in" : "leave", i = c.subs.slice();
        for(let f = 0; f < i.length; f++){
            const u = i[f];
            if (!(u.kind !== n || u.dead)) {
                u.once && $bb51df829a996acd$var$v(e, c, u);
                try {
                    u.run(o);
                } catch (a) {
                    $bb51df829a996acd$var$O(a);
                }
            }
        }
    }
}
function $bb51df829a996acd$var$O(e) {
    typeof globalThis.reportError == "function" ? globalThis.reportError(e) : queueMicrotask(()=>{
        throw e;
    });
}
function $bb51df829a996acd$var$v(e, t, r) {
    if (r.dead) return;
    r.dead = !0;
    const o = t.subs.indexOf(r);
    o !== -1 && t.subs.splice(o, 1), !t.subs.length && (e.targets.delete(t.node), e.observer.unobserve(t.node), !e.targets.size && (e.observer.disconnect(), e.byKey.delete(e.id)));
}
function $bb51df829a996acd$var$h(e, t, r, o, c) {
    const s = (0, $10sxy.stringHandler)(e, c.handler), n = c.options;
    if (typeof s != "function") return;
    const i = n && n.threshold, f = typeof i == "number" && i >= 0 && i <= 1 ? i : 0, u = n && typeof n.rootMargin == "string" ? n.rootMargin.trim() : "", a = $bb51df829a996acd$var$V(r, f, u);
    if (!a) return;
    let l = a.targets.get(t);
    l || (l = {
        node: t,
        inView: !1,
        subs: []
    }, a.targets.set(t, l), a.observer.observe(t));
    const d = {
        kind: o,
        once: !!(n && n.once === !0),
        run: (0, $10sxy.wrapEventHandler)(e, s),
        dead: !1
    };
    l.subs.push(d);
    const p = e.__ref;
    p.__eventCleanup || (p.__eventCleanup = []), p.__eventCleanup.push(()=>$bb51df829a996acd$var$v(a, l, d));
}
function $bb51df829a996acd$export$e8d861b596277a26(e) {
    const t = e.node;
    if (!t || t.nodeType !== 1) return;
    const r = t.ownerDocument, o = r && r.defaultView;
    if (!o || typeof o.IntersectionObserver != "function") return;
    const c = (0, $g0uWD.handlerEntries)(e.onInView);
    for(let n = 0; n < c.length; n++)$bb51df829a996acd$var$h(e, t, r, "in", c[n]);
    const s = (0, $g0uWD.handlerEntries)(e.onLeaveView);
    for(let n = 0; n < s.length; n++)$bb51df829a996acd$var$h(e, t, r, "leave", s[n]);
}

});
parcelRegister("10sxy", function(module, exports) {

$parcel$export(module.exports, "isHandlerKey", () => $0bbbee047e7e11bc$export$ae352554c07670b4);
$parcel$export(module.exports, "eventNameFrom", () => $0bbbee047e7e11bc$export$916fc7fcfc1f38e4);
$parcel$export(module.exports, "stringHandler", () => $0bbbee047e7e11bc$export$336fb27a38da53bf);
$parcel$export(module.exports, "wrapEventHandler", () => $0bbbee047e7e11bc$export$d09f5504a38c35a6);
$parcel$export(module.exports, "registerEvent", () => $0bbbee047e7e11bc$export$bd50bc4cd3c601ee);
$parcel$export(module.exports, "globalEventKeyInfo", () => $0bbbee047e7e11bc$export$808e64c4c4712dbb);
$parcel$export(module.exports, "registerGlobalEvent", () => $0bbbee047e7e11bc$export$4b9ce7ba883a6845);

var $aBPRx = parcelRequire("aBPRx");
parcelRequire("dYaY2");
var $dSdIt = parcelRequire("dSdIt");

var $8gewL = parcelRequire("8gewL");
parcelRequire("67GC6");
var $521xJ = parcelRequire("521xJ");
const $0bbbee047e7e11bc$var$p = new WeakMap, $0bbbee047e7e11bc$var$I = {
    passive: !0
}, $0bbbee047e7e11bc$var$B = {
    passive: !0,
    capture: !0
}, $0bbbee047e7e11bc$var$y = (e, t)=>(0, $aBPRx.PASSIVE_EVENTS).has(e) ? t ? $0bbbee047e7e11bc$var$B : $0bbbee047e7e11bc$var$I : t || !1;
function $0bbbee047e7e11bc$var$w(e) {
    let t = $0bbbee047e7e11bc$var$p.get(e);
    return t || (t = {
        handlers: new Map,
        installed: new Set
    }, $0bbbee047e7e11bc$var$p.set(e, t)), t;
}
function $0bbbee047e7e11bc$var$O(e, t) {
    const o = $0bbbee047e7e11bc$var$w(t);
    if (o.installed.has(e)) return;
    o.installed.add(e);
    const n = e === "focus" || e === "blur" || e === "focusin" || e === "focusout" || e === "mouseenter" || e === "mouseleave" || e === "pointerenter" || e === "pointerleave", r = e === "mouseenter" || e === "mouseleave" || e === "pointerenter" || e === "pointerleave";
    t.addEventListener(e, (i)=>{
        if (r) {
            const u = i.target, a = o.handlers.get(e), c = a && u ? a.get(u) : null;
            if (!c || i.relatedTarget && typeof u.contains == "function" && u.contains(i.relatedTarget)) return;
            c(i);
            return;
        }
        let s = i.target;
        for(; s && s !== t;){
            const u = o.handlers.get(e);
            if (u) {
                const a = u.get(s);
                if (a && (a(i), i.cancelBubble)) return;
            }
            s = s.parentNode;
        }
    }, $0bbbee047e7e11bc$var$y(e, n));
}
function $0bbbee047e7e11bc$export$da585c536ffe97a0(e, t, o, n) {
    n || (n = t.ownerDocument?.documentElement || t.getRootNode());
    const r = $0bbbee047e7e11bc$var$w(n);
    $0bbbee047e7e11bc$var$O(e, n), r.handlers.has(e) || r.handlers.set(e, new WeakMap), r.handlers.get(e).set(t, o);
}
function $0bbbee047e7e11bc$export$a6391ca54aead708(e, t, o) {
    o || (o = t.ownerDocument?.documentElement || t.getRootNode());
    const n = $0bbbee047e7e11bc$var$p.get(o);
    if (!n) return;
    const r = n.handlers.get(e);
    r && r.delete(t);
}
function $0bbbee047e7e11bc$export$ae352554c07670b4(e) {
    if (e.charCodeAt(0) !== 111 || e.charCodeAt(1) !== 110) return !1;
    const t = e.charCodeAt(2);
    return t >= 65 && t <= 90;
}
function $0bbbee047e7e11bc$export$916fc7fcfc1f38e4(e) {
    return e.charAt(2).toLowerCase() + e.slice(3);
}
const $0bbbee047e7e11bc$var$P = /^[A-Za-z_$][\w$]*$/;
function $0bbbee047e7e11bc$export$336fb27a38da53bf(e, t) {
    return typeof t != "string" || !$0bbbee047e7e11bc$var$P.test(t) ? t : function(n) {
        return e.call(t, n);
    };
}
function $0bbbee047e7e11bc$export$2144169e939890ff(e) {
    return (0, $aBPRx.DELEGATED_EVENTS).has(e) && !(0, $aBPRx.LIFECYCLE_EVENTS).has(e);
}
function $0bbbee047e7e11bc$export$d09f5504a38c35a6(e, t) {
    const { context: o } = e, n = o?.designSystem;
    return (r)=>{
        n && (0, $521xJ.pushConfig)(n);
        try {
            const i = t.call(e, r, e, e.state, o);
            if (i && typeof i.then == "function") {
                i.catch((s)=>{
                    e.error = s, console.error("[DOMQL] Async event error:", s);
                }).finally(()=>{
                    n && (0, $521xJ.popConfig)();
                });
                return;
            }
        } catch (i) {
            if (e.error = i, console.error("[DOMQL] Event error:", i), o?.strictMode) throw i;
        }
        n && (0, $521xJ.popConfig)();
    };
}
const $0bbbee047e7e11bc$var$L = (e)=>!!e && (e.capture === !0 || typeof e.passive == "boolean" || e.once === !0);
function $0bbbee047e7e11bc$var$H(e, t) {
    return $0bbbee047e7e11bc$var$L(t) ? {
        capture: t.capture === !0,
        passive: typeof t.passive == "boolean" ? t.passive : (0, $aBPRx.PASSIVE_EVENTS).has(e),
        once: t.once === !0
    } : $0bbbee047e7e11bc$var$y(e, !1);
}
function $0bbbee047e7e11bc$var$U(e, t, o) {
    return (n)=>{
        let r = n.target;
        if (r && r.nodeType !== 1 && (r = r.parentElement), !r || typeof r.closest != "function") return;
        let i;
        try {
            i = r.closest(t);
        } catch  {
            return;
        }
        i && e.contains(i) && o(n);
    };
}
function $0bbbee047e7e11bc$export$bd50bc4cd3c601ee(e, t, o, n) {
    const { node: r, context: i } = t;
    if (!r) return;
    let s = $0bbbee047e7e11bc$export$d09f5504a38c35a6(t, o);
    const u = n && typeof n.selector == "string" && n.selector;
    u && (s = $0bbbee047e7e11bc$var$U(r, u, s));
    const c = !(0, $aBPRx.NON_BUBBLING_EVENTS).has(e) && $0bbbee047e7e11bc$export$2144169e939890ff(e) && !$0bbbee047e7e11bc$var$L(n), f = c ? null : $0bbbee047e7e11bc$var$H(e, n);
    if (c) {
        const l = i?.rootNode || r.ownerDocument?.documentElement;
        $0bbbee047e7e11bc$export$da585c536ffe97a0(e, r, s, l);
    } else r.addEventListener(e, s, f);
    t.__ref.__eventCleanup || (t.__ref.__eventCleanup = []), t.__ref.__eventCleanup.push(()=>{
        if (c) {
            const l = i?.rootNode || r.ownerDocument?.documentElement;
            $0bbbee047e7e11bc$export$a6391ca54aead708(e, r, l);
        } else r.removeEventListener(e, s, f);
    });
}
const $0bbbee047e7e11bc$var$E = [
    [
        "onDocument",
        "document"
    ],
    [
        "onWindow",
        "window"
    ],
    [
        "onVisualViewport",
        "visualViewport"
    ],
    [
        "onMediaQuery",
        "mediaQuery"
    ]
];
function $0bbbee047e7e11bc$export$808e64c4c4712dbb(e) {
    if (typeof e != "string") return null;
    for(let t = 0; t < $0bbbee047e7e11bc$var$E.length; t++){
        const o = $0bbbee047e7e11bc$var$E[t][0];
        if (e.length <= o.length || !e.startsWith(o)) continue;
        const n = e.charCodeAt(o.length);
        if (!(n < 65 || n > 90)) return {
            target: $0bbbee047e7e11bc$var$E[t][1],
            eventName: e.slice(o.length).toLowerCase()
        };
    }
    return null;
}
function $0bbbee047e7e11bc$var$F(e, t, o) {
    let n = t, r = !1, i, s = !1, u = null;
    return t && typeof t == "object" && typeof t != "function" && (n = t.handler, r = !!t.capture, s = !!t.once, typeof t.passive == "boolean" && (i = t.passive), typeof t.query == "string" && (u = t.query)), n = $0bbbee047e7e11bc$export$336fb27a38da53bf(e, n), typeof n != "function" ? null : (i === void 0 && (i = (0, $aBPRx.PASSIVE_EVENTS).has(o)), {
        handler: n,
        capture: r,
        passive: i,
        once: s,
        query: u
    });
}
function $0bbbee047e7e11bc$var$K(e, t, o) {
    const n = e.node?.ownerDocument || e.context?.document || (typeof document < "u" ? document : null);
    if (!n || typeof n.addEventListener != "function") return null;
    if (t === "document") return n;
    const r = n.defaultView || (typeof window < "u" ? window : null);
    if (!r) return null;
    if (t === "window") return typeof r.addEventListener == "function" ? r : null;
    if (t === "visualViewport") {
        const i = r.visualViewport;
        return i && typeof i.addEventListener == "function" ? i : null;
    }
    if (t === "mediaQuery") {
        const i = o && o.query;
        if (typeof i != "string" || !i.trim() || typeof r.matchMedia != "function") return null;
        try {
            return r.matchMedia(i) || null;
        } catch  {
            return null;
        }
    }
    return null;
}
const $0bbbee047e7e11bc$var$g = /^@media\s+/i, $0bbbee047e7e11bc$var$j = /^[@[.#&:>*~+]/, $0bbbee047e7e11bc$var$m = new Set;
function $0bbbee047e7e11bc$var$b(e, t) {
    !(0, $dSdIt.isLoudDevRuntime)() || $0bbbee047e7e11bc$var$m.has(e) || ($0bbbee047e7e11bc$var$m.add(e), console.warn(`[smbls] onMediaQueryChange: "${e}" ${t} \u2014 no listener is registered.`));
}
function $0bbbee047e7e11bc$var$Y(e, t) {
    if (typeof t != "string") return null;
    const o = t.trim();
    if (!o) return null;
    const n = e.context?.designSystem?.media, r = (s)=>{
        const u = n && typeof n == "object" ? n[s] : void 0;
        return typeof u == "string" && u.trim() ? u.trim() : null;
    };
    let i = o;
    if (o.charCodeAt(0) === 64 && !$0bbbee047e7e11bc$var$g.test(o)) {
        if (i = r(o.slice(1)), !i) return $0bbbee047e7e11bc$var$b(o, "is not a key of designSystem.media"), null;
    } else i = r(o) || o;
    return $0bbbee047e7e11bc$var$g.test(i) ? i.replace($0bbbee047e7e11bc$var$g, "").trim() || null : $0bbbee047e7e11bc$var$j.test(i) ? ($0bbbee047e7e11bc$var$b(o, `names "${i}", which is not a media query`), null) : i;
}
function $0bbbee047e7e11bc$var$z(e, t, o, n) {
    try {
        return e.addEventListener(t, o, n), !0;
    } catch  {
        return typeof e.addListener == "function" ? (e.addListener(o), !0) : !1;
    }
}
function $0bbbee047e7e11bc$var$C(e, t, o, n) {
    try {
        e.removeEventListener(t, o, n);
    } catch  {
        typeof e.removeListener == "function" && e.removeListener(o);
    }
}
function $0bbbee047e7e11bc$export$4b9ce7ba883a6845(e, t, o) {
    if (t.__ref) {
        if (Array.isArray(o)) {
            if (e.target !== "mediaQuery") return;
            for(let r = 0; r < o.length; r++)$0bbbee047e7e11bc$var$D(e, t, o[r]);
            return;
        }
        $0bbbee047e7e11bc$var$D(e, t, o);
    }
}
function $0bbbee047e7e11bc$var$D(e, t, o) {
    const n = t.__ref, r = $0bbbee047e7e11bc$var$F(t, o, e.eventName);
    if (!r || e.target === "mediaQuery" && e.eventName !== "change" || e.target === "mediaQuery" && (r.query = $0bbbee047e7e11bc$var$Y(t, r.query), !r.query)) return;
    const i = $0bbbee047e7e11bc$var$K(t, e.target, r);
    if (!i) return;
    const s = e.target + ":" + (r.query ? r.query + ":" : "") + e.eventName + ":" + (r.capture ? 1 : 0);
    if (n.__globalEvents && n.__globalEvents.has(s)) return;
    const u = $0bbbee047e7e11bc$export$d09f5504a38c35a6(t, r.handler), a = e.target === "window" && e.eventName === "load";
    let c = !1;
    const f = (M)=>{
        if ((0, $8gewL.isElementConnected)(t)) {
            if (a) {
                if (c) return;
                c = !0;
            }
            u(M);
        }
    }, l = {
        capture: r.capture,
        passive: r.passive,
        once: r.once
    };
    if (!$0bbbee047e7e11bc$var$z(i, e.eventName, f, l)) return;
    n.__globalEvents || (n.__globalEvents = new Map);
    const _ = {
        target: i,
        eventName: e.eventName,
        listener: f,
        options: l
    };
    n.__globalEvents.set(s, _), n.__eventCleanup || (n.__eventCleanup = []), n.__eventCleanup.push(()=>{
        $0bbbee047e7e11bc$var$C(i, e.eventName, f, l), n.__globalEvents && n.__globalEvents.delete(s);
    }), a && $0bbbee047e7e11bc$var$X(t, s, _, ()=>c);
}
function $0bbbee047e7e11bc$var$X(e, t, o, n) {
    const r = o.target.document;
    !r || r.readyState !== "complete" || (0, $8gewL.whenConnected)(e, ()=>queueMicrotask(()=>{
            const i = e.__ref;
            if (n() || !i || !i.__globalEvents || i.__globalEvents.get(t) !== o) return;
            const s = o.target, u = typeof s.Event == "function" ? s.Event : typeof Event == "function" ? Event : null;
            u && (o.listener(new u("load")), o.options.once && n() && $0bbbee047e7e11bc$var$C(s, "load", o.listener, o.options));
        }));
}

});
parcelRegister("aBPRx", function(module, exports) {

$parcel$export(module.exports, "REGISTRY", () => $7b9596e95e548181$export$21cc2ed387caee94);
$parcel$export(module.exports, "LIFECYCLE_EVENTS", () => $7b9596e95e548181$export$1b96fccf01613a9);
$parcel$export(module.exports, "NON_BUBBLING_EVENTS", () => $7b9596e95e548181$export$b632cb6b8bb0d201);
$parcel$export(module.exports, "PASSIVE_EVENTS", () => $7b9596e95e548181$export$e58a6cc0822ad4ca);
$parcel$export(module.exports, "DELEGATED_EVENTS", () => $7b9596e95e548181$export$2edd40343a7ba9df);
const $7b9596e95e548181$export$21cc2ed387caee94 = new Set([
    "extends",
    "children",
    "content",
    "childrenAs",
    "childExtends",
    "childExtendsRecursive",
    "childProps",
    "inheritParentProps",
    "state",
    "if",
    "deferUntil",
    "define",
    "deps",
    "tag",
    "attr",
    "style",
    "text",
    "html",
    "value",
    "data",
    "classlist",
    "class",
    "vars",
    "scope",
    "root",
    "context",
    "$router",
    "routes",
    "fetch",
    "variables",
    "query",
    "key",
    "component",
    "preventContentUpdate",
    "preventContentRecreate",
    "subscribeTo",
    "autoGrow",
    "faceWait",
    "srcObject",
    "allowRuntimeTemplates",
    "__name",
    "__ref",
    "__hash",
    "__text",
    "parent",
    "node"
]), $7b9596e95e548181$export$4548702dd438fdb5 = {
    text: "text",
    html: "html",
    style: "style",
    attr: "attr",
    data: "data",
    classlist: "classlist",
    state: "state",
    scope: "scope"
}, $7b9596e95e548181$export$1b96fccf01613a9 = new Set([
    "start",
    "init",
    "complete",
    "attachNode",
    "stateInit",
    "stateCreated",
    "beforeUpdate",
    "update",
    "afterUpdate",
    "beforeClassAssign",
    "lazyLoad",
    "render",
    "renderRouter",
    "done",
    "create",
    "frame",
    "mounted",
    "contentUpdate",
    "startUpdate",
    "stateUpdate",
    "beforeStateUpdate",
    "initInspect",
    "initSync",
    "beforeRemove",
    "remove",
    "bridgeMount",
    "bridgeUpdate",
    "bridgeDestroy"
]), $7b9596e95e548181$export$b632cb6b8bb0d201 = new Set([
    "load",
    "error",
    "abort",
    "scroll",
    "canplay",
    "canplaythrough",
    "ended",
    "pause",
    "play",
    "playing",
    "ratechange",
    "seeked",
    "seeking",
    "stalled",
    "suspend",
    "timeupdate",
    "volumechange",
    "waiting",
    "durationchange",
    "loadeddata",
    "loadedmetadata",
    "progress",
    "emptied",
    "resize"
]), $7b9596e95e548181$export$e58a6cc0822ad4ca = new Set([
    "wheel",
    "mousewheel",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel"
]), $7b9596e95e548181$export$2edd40343a7ba9df = new Set([
    "click",
    "dblclick",
    "mousedown",
    "mouseup",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "mouseover",
    "mouseout",
    "pointerdown",
    "pointerup",
    "pointermove",
    "pointerenter",
    "pointerleave",
    "pointerover",
    "pointerout",
    "touchstart",
    "touchend",
    "touchmove",
    "keydown",
    "keyup",
    "keypress",
    "input",
    "change",
    "submit",
    "reset",
    "focus",
    "blur",
    "focusin",
    "focusout",
    "wheel",
    "contextmenu",
    "drag",
    "dragstart",
    "dragend",
    "dragenter",
    "dragleave",
    "dragover",
    "drop"
]);

});

parcelRegister("dYaY2", function(module, exports) {

$parcel$export(module.exports, "isLoudDevRuntime", () => (parcelRequire("dSdIt")).isLoudDevRuntime);
parcelRequire("byww3");
var $dSdIt = parcelRequire("dSdIt");

});

parcelRegister("8gewL", function(module, exports) {

$parcel$export(module.exports, "isElementConnected", () => $603b1630e5eaf7c6$export$2d64b2827a323bda);
$parcel$export(module.exports, "whenConnected", () => $603b1630e5eaf7c6$export$3007301b101cb77a);
$parcel$export(module.exports, "flushConnected", () => $603b1630e5eaf7c6$export$c582b0274631c7da);
$parcel$export(module.exports, "forgetConnected", () => $603b1630e5eaf7c6$export$9bab10f275f628e1);
const $603b1630e5eaf7c6$var$t = new Set;
function $603b1630e5eaf7c6$export$2d64b2827a323bda(n) {
    const e = n && n.node;
    if (!e) return !1;
    const r = e.nodeType === 11 ? n.__ref?.__fragmentAnchor : e;
    return r ? r.isConnected !== !1 : !1;
}
function $603b1630e5eaf7c6$export$3007301b101cb77a(n, e) {
    const r = n && n.node, o = n && n.__ref;
    if (!(!r || !o || typeof e != "function")) {
        if ($603b1630e5eaf7c6$export$2d64b2827a323bda(n)) {
            e(n);
            return;
        }
        (o.__onConnected || (o.__onConnected = [])).push(e), $603b1630e5eaf7c6$var$t.add(n);
    }
}
function $603b1630e5eaf7c6$export$c582b0274631c7da() {
    if ($603b1630e5eaf7c6$var$t.size) for (const n of $603b1630e5eaf7c6$var$t){
        const e = n.__ref, r = n.node;
        if (!e || !r) {
            $603b1630e5eaf7c6$var$t.delete(n);
            continue;
        }
        if (!$603b1630e5eaf7c6$export$2d64b2827a323bda(n)) continue;
        $603b1630e5eaf7c6$var$t.delete(n);
        const o = e.__onConnected;
        if (e.__onConnected = null, !!o) for(let c = 0; c < o.length; c++)try {
            o[c](n);
        } catch (f) {
            typeof console < "u" && console.error && console.error("[smbls] whenConnected callback failed:", f?.message || f);
        }
    }
}
function $603b1630e5eaf7c6$export$9bab10f275f628e1(n) {
    $603b1630e5eaf7c6$var$t.size && $603b1630e5eaf7c6$var$t.delete(n) && n.__ref && (n.__ref.__onConnected = null);
}

});


parcelRegister("g0uWD", function(module, exports) {

$parcel$export(module.exports, "chainHandler", () => $ba74a6670f176779$export$69823c0b8e4936d);
$parcel$export(module.exports, "handlerEntries", () => $ba74a6670f176779$export$e92f650c0b6ea1b7);

var $aBPRx = parcelRequire("aBPRx");
parcelRequire("dYaY2");
var $dSdIt = parcelRequire("dSdIt");

var $10sxy = parcelRequire("10sxy");
const $ba74a6670f176779$var$h = Symbol("handlerChain.none"), $ba74a6670f176779$var$x = new Set([
    "inView",
    "leaveView"
]), $ba74a6670f176779$var$L = new Set([
    "bridgeMount",
    "bridgeUpdate",
    "bridgeDestroy"
]), $ba74a6670f176779$var$c = new WeakMap, $ba74a6670f176779$var$C = new WeakMap;
let $ba74a6670f176779$var$p = !1;
const $ba74a6670f176779$export$2cfa1b92052873cd = (e)=>e !== null && typeof e == "object" && e.always === !0;
function $ba74a6670f176779$var$V(e) {
    const n = (0, $10sxy.eventNameFrom)(e);
    return $ba74a6670f176779$var$x.has(n) ? !0 : (0, $aBPRx.LIFECYCLE_EVENTS).has(n) && !$ba74a6670f176779$var$L.has(n);
}
const $ba74a6670f176779$var$E = new Set;
function $ba74a6670f176779$var$_(e) {
    $ba74a6670f176779$var$E.has(e) || !(0, $dSdIt.isLoudDevRuntime)() || ($ba74a6670f176779$var$E.add(e), console.warn(`[smbls] \`${e}: { always: true, \u2026 }\` \u2014 \`always\` composes the lifecycle hooks (onInit, onRender, onCreate, onMounted, onUpdate, onRemove, \u2026; not the bridge hooks) and onInView / onLeaveView only. \`${e}\` keeps the default merge: an extender's own \`${e}\` replaces this one. Run the shared step from a lifecycle hook, or call it from the extender's handler.`));
}
function $ba74a6670f176779$var$y(e) {
    return e && typeof e == "object" ? {
        handler: e.handler,
        options: e
    } : {
        handler: e,
        options: null
    };
}
function $ba74a6670f176779$var$a(e, n) {
    const t = {
        always: e,
        own: n,
        list: n ? e.concat(n) : e,
        next: null,
        prims: null,
        cleared: null
    }, r = function(...i) {
        return $ba74a6670f176779$var$A(t, this, i);
    };
    return $ba74a6670f176779$var$c.set(r, t), $ba74a6670f176779$var$p = !0, r;
}
function $ba74a6670f176779$var$w(e) {
    let n = $ba74a6670f176779$var$C.get(e);
    return n || (n = $ba74a6670f176779$var$a([
        $ba74a6670f176779$var$y(e)
    ], null), $ba74a6670f176779$var$C.set(e, n)), n;
}
function $ba74a6670f176779$var$F(e, n) {
    const t = $ba74a6670f176779$var$c.get(e);
    if (n == null || n === !1) return t.own ? t.cleared || (t.cleared = $ba74a6670f176779$var$a(t.always, null)) : e;
    if (typeof n != "object" && typeof n != "function") {
        const s = t.prims || (t.prims = new Map);
        let l = s.get(n);
        return l || s.set(n, l = $ba74a6670f176779$var$a(t.always, $ba74a6670f176779$var$y(n))), l;
    }
    const r = t.next || (t.next = new WeakMap);
    let o = r.get(n);
    if (o) return o;
    const i = $ba74a6670f176779$export$2cfa1b92052873cd(n) ? $ba74a6670f176779$var$c.get($ba74a6670f176779$var$w(n)) : typeof n == "function" ? $ba74a6670f176779$var$c.get(n) : void 0;
    return o = i ? $ba74a6670f176779$var$a(t.always.concat(i.always), i.own) : $ba74a6670f176779$var$a(t.always, $ba74a6670f176779$var$y(n)), r.set(n, o), o;
}
function $ba74a6670f176779$var$H(e, n, t) {
    const r = $ba74a6670f176779$export$2cfa1b92052873cd(n), o = !r && $ba74a6670f176779$var$p && typeof n == "function" && $ba74a6670f176779$var$c.has(n);
    if (!r && !o && !$ba74a6670f176779$export$2cfa1b92052873cd(t)) return $ba74a6670f176779$var$h;
    if (!$ba74a6670f176779$var$V(e)) return $ba74a6670f176779$var$_(e), $ba74a6670f176779$var$h;
    const i = r ? $ba74a6670f176779$var$w(n) : o ? n : null;
    return i ? $ba74a6670f176779$var$F(i, t) : $ba74a6670f176779$var$w(t);
}
function $ba74a6670f176779$export$69823c0b8e4936d(e, n, t, r) {
    if (!(0, $10sxy.isHandlerKey)(n)) return !1;
    const o = $ba74a6670f176779$var$H(n, t, r);
    return o === $ba74a6670f176779$var$h ? !1 : (e[n] = o, !0);
}
function $ba74a6670f176779$export$e92f650c0b6ea1b7(e) {
    if (typeof e == "function") {
        const n = $ba74a6670f176779$var$p ? $ba74a6670f176779$var$c.get(e) : void 0;
        return n ? n.list : [
            {
                handler: e,
                options: null
            }
        ];
    }
    return typeof e == "string" ? [
        {
            handler: e,
            options: null
        }
    ] : e && typeof e == "object" ? [
        {
            handler: e.handler,
            options: e
        }
    ] : [];
}
function $ba74a6670f176779$var$A(e, n, t) {
    const r = e.list;
    let o, i = !1, s = null, l = !1, b;
    for(let u = 0; u < r.length; u++){
        const d = r[u].handler;
        if (typeof d != "function") continue;
        let f;
        try {
            f = d.apply(n, t);
        } catch (g) {
            l ? console.error("[smbls] lifecycle handler error:", g) : (l = !0, b = g);
            continue;
        }
        f === !1 ? i = !0 : f && typeof f.then == "function" && (s || (s = [])).push(f), o = f;
    }
    if (l) {
        if (s) for (const u of s)u.then(null, (d)=>console.error("[smbls] lifecycle handler error:", d));
        throw b;
    }
    return i ? !1 : s ? s.length === 1 ? s[0] : $ba74a6670f176779$var$R(s) : o;
}
function $ba74a6670f176779$var$R(e) {
    return Promise.allSettled(e).then((n)=>{
        let t = null;
        for (const r of n)r.status === "rejected" && (t ? console.error("[smbls] lifecycle handler error:", r.reason) : t = r);
        if (t) throw t.reason;
    });
}

});


parcelRegister("9Ffxy", function(module, exports) {

$parcel$export(module.exports, "plainRows", () => $7093ff5a26bda564$export$8d51158c7cd4519e);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $1H9Q8 = parcelRequire("1H9Q8");

var $8RrjX = parcelRequire("8RrjX");

var $6yBlx = parcelRequire("6yBlx");

var $jdWhC = parcelRequire("jdWhC");
const $7093ff5a26bda564$var$p = (e, r)=>Object.prototype.hasOwnProperty.call(e, r), $7093ff5a26bda564$var$I = 1e3, $7093ff5a26bda564$var$K = 24, $7093ff5a26bda564$var$b = Object.freeze({}), $7093ff5a26bda564$var$E = Object.freeze({});
let $7093ff5a26bda564$var$d = 0;
const $7093ff5a26bda564$var$g = (e)=>{
    if ((0, $4VQqJ.isStore)(e) || $7093ff5a26bda564$var$p(e, "__ref")) return !1;
    const r = Object.getPrototypeOf(e);
    return r === Object.prototype || r === null;
};
function $7093ff5a26bda564$var$j(e, r, i) {
    if (e === null || typeof e != "object") return e;
    if (--$7093ff5a26bda564$var$d < 0 || r > $7093ff5a26bda564$var$K) {
        $7093ff5a26bda564$var$d = -1;
        return;
    }
    if (Array.isArray(e)) {
        const t = new Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = i ? e[n] : $7093ff5a26bda564$var$j(e[n], r + 1, !1);
        return t;
    }
    if (i || !$7093ff5a26bda564$var$g(e)) return e;
    const c = {};
    for(const t in e)$7093ff5a26bda564$var$p(e, t) && (c[t] = $7093ff5a26bda564$var$j(e[t], r + 1, t === "extends" || t === "childExtends"));
    return c;
}
function $7093ff5a26bda564$var$L(e) {
    $7093ff5a26bda564$var$d = $7093ff5a26bda564$var$I;
    let r;
    try {
        r = $7093ff5a26bda564$var$j(e, 0, !1);
    } catch  {
        return $7093ff5a26bda564$var$b;
    }
    return $7093ff5a26bda564$var$d < 0 ? $7093ff5a26bda564$var$b : r;
}
function $7093ff5a26bda564$var$x(e, r, i, c) {
    if (e === r) return !0;
    if (e === null || typeof e != "object" || r === null || typeof r != "object" || --$7093ff5a26bda564$var$d < 0 || i > $7093ff5a26bda564$var$K) return !1;
    if (Array.isArray(e)) {
        if (!Array.isArray(r) || r.length !== e.length) return !1;
        for(let n = 0; n < e.length; n++)if (c ? e[n] !== r[n] : !$7093ff5a26bda564$var$x(e[n], r[n], i + 1, !1)) return !1;
        return !0;
    }
    if (c || Array.isArray(r) || !$7093ff5a26bda564$var$g(e) || !$7093ff5a26bda564$var$g(r)) return !1;
    let t = 0;
    for(const n in e)if ($7093ff5a26bda564$var$p(e, n) && (t++, !$7093ff5a26bda564$var$p(r, n) || !$7093ff5a26bda564$var$x(e[n], r[n], i + 1, n === "extends" || n === "childExtends"))) return !1;
    for(const n in r)$7093ff5a26bda564$var$p(r, n) && t--;
    return t === 0;
}
function $7093ff5a26bda564$var$U(e, r) {
    if (r === $7093ff5a26bda564$var$b || r === $7093ff5a26bda564$var$E) return !1;
    $7093ff5a26bda564$var$d = $7093ff5a26bda564$var$I;
    try {
        return $7093ff5a26bda564$var$x(e, r, 0, !1);
    } catch  {
        return !1;
    }
}
const $7093ff5a26bda564$var$A = (e)=>(0, $4VQqJ.getObserver)() ? (0, $1H9Q8.untrack)(()=>$7093ff5a26bda564$var$L(e)) : $7093ff5a26bda564$var$L(e), $7093ff5a26bda564$var$$ = (e, r)=>(0, $4VQqJ.getObserver)() ? (0, $1H9Q8.untrack)(()=>$7093ff5a26bda564$var$U(e, r)) : $7093ff5a26bda564$var$U(e, r);
function $7093ff5a26bda564$var$B(e, r, i, c) {
    let t = e;
    return t && typeof t == "object" && !Array.isArray(t) && !$7093ff5a26bda564$var$g(t) && (c || i && !t.ignoreChildExtends) && (t = c ? (0, $8RrjX.deepMergeChild)({}, t) : {
        ...t
    }), typeof r == "function" ? {
        item: t,
        props: c
    } : t;
}
const $7093ff5a26bda564$var$C = (e)=>({
        childProps: typeof e.childProps == "function" ? void 0 : e.childProps,
        childExtends: e.childExtends
    });
class $7093ff5a26bda564$var$F {
    constructor(r, i){
        this.shared = r, this.rows = i;
    }
    add(r, i, c, t, n) {
        this.rows.set(r, $7093ff5a26bda564$var$A($7093ff5a26bda564$var$B(i, t, n, c.props)));
    }
    failed(r) {
        this.rows.set(r, $7093ff5a26bda564$var$E);
    }
    none(r) {
        this.rows.delete(r);
    }
}
const $7093ff5a26bda564$var$se = Object.freeze([]);
function $7093ff5a26bda564$var$ie(e, r, i, c, t) {
    const n = r.__plainRows.rows, M = r.__plainRows.shared, D = $7093ff5a26bda564$var$C(e), T = $7093ff5a26bda564$var$$(D, M), m = e.childProps, G = (0, $6yBlx.runtimeViewOf)(e, "childProps"), N = e.childExtends, h = new Array(i.length), O = new Map;
    for(let s = 0; s < i.length; s++){
        const o = (0, $6yBlx.arrayRowDefinition)(e, i[s], s, m, G, N, !1, !0);
        if (O.has(o.key)) return !1;
        O.set(o.key, o), h[s] = o;
    }
    for(let s = 0; s < h.length; s++){
        const o = h[s];
        o.input = $7093ff5a26bda564$var$B(i[s], m, N, o.props);
        const f = T ? n.get(o.key) : void 0;
        if (f === void 0) continue;
        const u = e[o.key];
        u && u.__ref && u.parent === e && $7093ff5a26bda564$var$$(o.input, f) && (o.kept = !0, o.snap = f);
    }
    const y = t ? [] : null;
    for (const s of n.keys()){
        const o = O.get(s);
        if (o && o.kept) continue;
        const f = e[s];
        f?.remove && f.remove(), delete e[s], y && y.push(s);
    }
    const w = t ? [] : null, S = t ? [] : null, l = new Map;
    let k = null, _ = null;
    for(let s = 0; s < h.length; s++){
        const o = h[s];
        if (o.kept) {
            l.set(o.key, o.snap), S && S.push(o.key);
            const a = (0, $6yBlx.placedRowNode)(e[o.key]);
            a && (_ = (0, $6yBlx.placeAfter)(e, a, _));
            continue;
        }
        l.set(o.key, $7093ff5a26bda564$var$A(o.input));
        let f;
        try {
            f = (0, $6yBlx.create)((0, $6yBlx.markRuntimeSupplied)(o.def, o.supplied), e, o.key, c, (0, $6yBlx.rowAttach)(e, _));
        } catch (a) {
            if (l.set(o.key, $7093ff5a26bda564$var$E), k || (k = new Set), k.add(o.key), typeof console < "u" && console.error) {
                const q = r.path?.join(".") || e.key || "<root>";
                console.error(`[smbls] child "${o.key}" failed to construct at ${q} (re-run, skipping this row):`, a?.message || a);
            }
            (0, $jdWhC.reportRenderError)(e, {
                where: "child",
                key: o.key,
                error: a
            });
            continue;
        }
        if (r.__disposed) return !0;
        if (!f) {
            l.delete(o.key);
            continue;
        }
        const u = (0, $6yBlx.placedRowNode)(f);
        u && (_ = u), w && w.push(o.key);
    }
    r.__plainRows = new $7093ff5a26bda564$var$F(T ? M : $7093ff5a26bda564$var$A(D), l);
    const R = Array.from(l.keys());
    (0, $6yBlx.placeRows)(e, R, k);
    const H = new Set(r.__children), P = [];
    for(let s = 0; s < R.length; s++)H.has(R[s]) && P.push(R[s]);
    for (const s of r.__children)l.has(s) || P.push(s);
    return r.__children = P, t && (w.length || y.length) && (0, $6yBlx.triggerContentUpdate)(e, {
        added: w,
        removed: y,
        kept: S
    }), !0;
}
const $7093ff5a26bda564$export$8d51158c7cd4519e = {
    track: (e)=>new $7093ff5a26bda564$var$F($7093ff5a26bda564$var$A($7093ff5a26bda564$var$C(e)), new Map),
    reconcile (e, r, i, c, t) {
        const n = Array.isArray(i) ? i : i == null || i === !1 ? $7093ff5a26bda564$var$se : null;
        return !!n && $7093ff5a26bda564$var$ie(e, r, n, c, t);
    }
};

});
parcelRegister("1H9Q8", function(module, exports) {

$parcel$export(module.exports, "withDesignSystem", () => $13c170964be1ff31$export$2658a0ac8ba45977);
$parcel$export(module.exports, "untrack", () => $13c170964be1ff31$export$363ebc4b78b8f807);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");
parcelRequire("67GC6");
var $521xJ = parcelRequire("521xJ");
function $13c170964be1ff31$export$2658a0ac8ba45977(r, t) {
    const e = r && r.context && r.context.designSystem;
    if (!e) return t();
    (0, $521xJ.pushConfig)(e);
    try {
        return t();
    } finally{
        (0, $521xJ.popConfig)();
    }
}
const $13c170964be1ff31$export$363ebc4b78b8f807 = $4VQqJ.untrack || ((r)=>{
    const t = $4VQqJ.getObserver();
    if (!t) return r();
    $4VQqJ.setObserver(null);
    try {
        return r();
    } finally{
        $4VQqJ.setObserver(t);
    }
});

});

parcelRegister("8RrjX", function(module, exports) {

$parcel$export(module.exports, "applyExtends", () => $673877582066ebcd$export$1ac92e2b1d1a0b6d);
$parcel$export(module.exports, "openMergeLayer", () => $673877582066ebcd$export$8e3c75647eef69dd);
$parcel$export(module.exports, "deepMergeChild", () => $673877582066ebcd$export$5a265dc3afef96b9);
$parcel$export(module.exports, "closeMergeLayer", () => $673877582066ebcd$export$10278a04bb84b87a);

var $fe4kH = parcelRequire("fe4kH");

var $ewXm2 = parcelRequire("ewXm2");

var $8NJs1 = parcelRequire("8NJs1");
const $673877582066ebcd$var$R = new WeakMap;
function $673877582066ebcd$var$h(r) {
    const t = [];
    return r.extends && (Array.isArray(r.extends) ? t.push(...r.extends) : t.push(r.extends)), r.extend && (Array.isArray(r.extend) ? t.push(...r.extend) : t.push(r.extend)), t;
}
function $673877582066ebcd$export$1ac92e2b1d1a0b6d(r, t, s) {
    const a = $673877582066ebcd$var$h(t);
    if (!a.length) return;
    const o = r.context || s?.context || {}, c = o.components || {};
    for(let n = 0; n < a.length; n++){
        const e = $673877582066ebcd$var$p(a[n], c, o, t);
        e && e !== t && $673877582066ebcd$var$y(r, e, s, new Set([
            t
        ]));
    }
}
const $673877582066ebcd$var$C = Symbol.for("smbls.shadowedComponents");
function $673877582066ebcd$var$M(r, t, s, a) {
    const o = a && a[$673877582066ebcd$var$C], c = o ? o.get(t) : void 0, n = c ? c.length + 1 : 1;
    let e = null, f = !1;
    for(let i = 0; i <= n; i++){
        const u = i === 0 ? r[t] : i === n ? r[`smbls.${t}`] : c[i - 1];
        if (u) {
            if (u === s) f = !0;
            else {
                if (f) return u;
                e === null && (e = u);
            }
        }
    }
    return f ? null : e;
}
function $673877582066ebcd$var$p(r, t, s, a) {
    if (typeof r == "string") {
        if (r.includes(">")) {
            const o = r.split(">").map((n)=>n.trim());
            let c = t[o[0]] || t[`smbls.${o[0]}`];
            for(let n = 1; n < o.length && c; n++)c = c[o[n]];
            return c || null;
        }
        return $673877582066ebcd$var$M(t, r, a, s);
    }
    return typeof r == "object" && r !== null ? r : null;
}
function $673877582066ebcd$var$y(r, t, s, a = new Set) {
    if (a.has(t)) return;
    a.add(t);
    const o = $673877582066ebcd$var$h(t);
    if (o.length) {
        const n = r.context || s?.context || {}, e = n.components || {};
        for(let f = 0; f < o.length; f++){
            const i = $673877582066ebcd$var$p(o[f], e, n, t);
            i && $673877582066ebcd$var$y(r, i, s, a);
        }
    }
    const c = $673877582066ebcd$export$8e3c75647eef69dd(r);
    for(const n in t){
        if (n === "extends" || n === "extend") continue;
        const e = t[n];
        c && c.mark(n);
        const f = (0, $8NJs1.FEATURES).chains;
        f !== null && f(r, n, r[n], e) || (r[n] === void 0 ? e && typeof e == "object" && !Array.isArray(e) && typeof e != "function" ? r[n] = {
            ...e
        } : r[n] = e : typeof r[n] == "object" && typeof e == "object" && !Array.isArray(r[n]) && !Array.isArray(e) && r[n] !== null && e !== null ? r[n] = $673877582066ebcd$export$5a265dc3afef96b9(r[n], e) : r[n] = e);
    }
}
class $673877582066ebcd$var$N {
    constructor(){
        this.rank = 0, this.ranks = null;
    }
    mark(t) {
        $673877582066ebcd$var$E(t) && (this.ranks || (this.ranks = new Map), this.ranks.set(t, this.rank));
    }
    get(t) {
        return this.ranks ? this.ranks.get(t) : void 0;
    }
    get size() {
        return this.ranks ? this.ranks.size : 0;
    }
}
const $673877582066ebcd$var$l = new Set;
for (const r of [
    (0, $ewXm2.CSS_LONGHAND_SHORTHANDS),
    (0, $ewXm2.CSS_SHORTHAND_LONGHANDS)
])for(const t in r)$673877582066ebcd$var$l.add(t), $673877582066ebcd$var$l.add((0, $ewXm2.cssCamelName)(t));
const $673877582066ebcd$var$A = new Map;
function $673877582066ebcd$var$E(r) {
    const t = r.charCodeAt(0);
    if (t >= 65 && t <= 90 || t >= 48 && t <= 57) return !1;
    let s = $673877582066ebcd$var$A.get(r);
    return s === void 0 && (s = !!(0, $fe4kH.CSS_PROPS_REGISTRY)[r] || $673877582066ebcd$var$l.has(r) || r.indexOf("-") >= 0 && !(r.charCodeAt(0) === 45 && r.charCodeAt(1) === 45) && $673877582066ebcd$var$l.has((0, $ewXm2.cssPropName)(r)), $673877582066ebcd$var$A.set(r, s)), s;
}
function $673877582066ebcd$export$8e3c75647eef69dd(r) {
    const t = r && r.__ref;
    if (!t) return null;
    let s = t.__mergeLayer;
    return s || (s = t.__mergeLayer = new $673877582066ebcd$var$N), s.rank++, s;
}
function $673877582066ebcd$export$10278a04bb84b87a(r) {
    const t = r && r.__ref && r.__ref.__mergeLayer;
    if (!t || !t.ranks) return;
    let s;
    for (const a of t.ranks.values())if (s === void 0) s = a;
    else if (a !== s) return;
    t.ranks = null;
}
function $673877582066ebcd$export$5a265dc3afef96b9(r, t) {
    const s = {
        ...r
    }, a = (0, $8NJs1.FEATURES).chains;
    for(const o in t){
        const c = s[o], n = t[o];
        a !== null && a(s, o, c, n) || (c && n && typeof c == "object" && typeof n == "object" && !Array.isArray(c) && !Array.isArray(n) && typeof c != "function" && typeof n != "function" ? s[o] = $673877582066ebcd$export$5a265dc3afef96b9(c, n) : s[o] = n);
    }
    return s;
}

});
parcelRegister("ewXm2", function(module, exports) {

$parcel$export(module.exports, "CSS_SHORTHAND_LONGHANDS", () => $a9421866ed4b5e7a$export$957250e5cfab4acc);
$parcel$export(module.exports, "CSS_LONGHAND_SHORTHANDS", () => $a9421866ed4b5e7a$export$7f1f6beb13bf1a4d);
$parcel$export(module.exports, "cssShorthandStatesLonghand", () => $a9421866ed4b5e7a$export$da574fd15a2c79e3);
$parcel$export(module.exports, "cssShorthandStatesThemeLonghand", () => $a9421866ed4b5e7a$export$16aed46cf362f662);
$parcel$export(module.exports, "cssPropName", () => $a9421866ed4b5e7a$export$7996caeb46a3bdf6);
$parcel$export(module.exports, "cssCamelName", () => $a9421866ed4b5e7a$export$210d7b134e4cafb0);
parcelRequire("6pGsV");
var $aFJFR = parcelRequire("aFJFR");
var $9L4Qx = parcelRequire("9L4Qx");
if (!$aFJFR.CSS_SHORTHAND_LONGHANDS || !$aFJFR.CSS_LONGHAND_SHORTHANDS) throw new Error("@symbo.ls/element: the installed @symbo.ls/css does not export CSS_SHORTHAND_LONGHANDS / CSS_LONGHAND_SHORTHANDS (the CSS shorthand family table, packages/css/src/cssLonghands.js). This element needs the @symbo.ls/css published in the same release \u2014 update @symbo.ls/css.");
const $a9421866ed4b5e7a$export$957250e5cfab4acc = $aFJFR.CSS_SHORTHAND_LONGHANDS, $a9421866ed4b5e7a$export$7f1f6beb13bf1a4d = $aFJFR.CSS_LONGHAND_SHORTHANDS, $a9421866ed4b5e7a$export$da574fd15a2c79e3 = $aFJFR.cssShorthandStatesLonghand || (()=>!1), $a9421866ed4b5e7a$export$16aed46cf362f662 = $aFJFR.cssShorthandStatesThemeLonghand || $a9421866ed4b5e7a$export$da574fd15a2c79e3, $a9421866ed4b5e7a$var$o = (s)=>s.charCodeAt(0) === 45 && s.charCodeAt(1) === 45, $a9421866ed4b5e7a$export$7996caeb46a3bdf6 = $9L4Qx.cssPropName || ((s)=>$a9421866ed4b5e7a$var$o(s) ? s : s.replace(/[A-Z]/g, (t)=>"-" + t.toLowerCase())), $a9421866ed4b5e7a$export$210d7b134e4cafb0 = $9L4Qx.cssCamelName || ((s)=>$a9421866ed4b5e7a$var$o(s) ? s : s.replace(/-([a-z])/g, (t, S)=>S.toUpperCase()));

});


parcelRegister("6yBlx", function(module, exports) {

$parcel$export(module.exports, "triggerContentUpdate", () => $4c62e3475ce4e4e1$export$cf3cc0b695ef095e);
$parcel$export(module.exports, "create", () => $4c62e3475ce4e4e1$export$185802fd694ee1f5);
$parcel$export(module.exports, "reportCreateChildrenError", () => $4c62e3475ce4e4e1$export$ea9f2c6c3ae41a1e);
$parcel$export(module.exports, "syncSelectValue", () => $4c62e3475ce4e4e1$export$3b058bdaa6ecc53);
$parcel$export(module.exports, "completeCreate", () => $4c62e3475ce4e4e1$export$5b0a8b3d5ad40532);
$parcel$export(module.exports, "attachElement", () => $4c62e3475ce4e4e1$export$2b6cc1479174a046);
$parcel$export(module.exports, "attachWhole", () => $4c62e3475ce4e4e1$export$2d5553a5ccaac8cb);
$parcel$export(module.exports, "placedRowNode", () => $4c62e3475ce4e4e1$export$7098c6c10b33842e);
$parcel$export(module.exports, "runtimeViewOf", () => $4c62e3475ce4e4e1$export$2d5526e9c7b5a43a);
$parcel$export(module.exports, "markRuntimeSupplied", () => $4c62e3475ce4e4e1$export$43c64c8265a0bfaa);
$parcel$export(module.exports, "writeElementText", () => $4c62e3475ce4e4e1$export$868dbbfae37a1bda);
$parcel$export(module.exports, "resolveStyleBlock", () => $4c62e3475ce4e4e1$export$5babfef4e4474017);
$parcel$export(module.exports, "writeAttr", () => $4c62e3475ce4e4e1$export$50a52ac7cfdacacb);
$parcel$export(module.exports, "acquireBeforeUpdateGuard", () => $4c62e3475ce4e4e1$export$3afe46815fe1a2cd);
$parcel$export(module.exports, "releaseBeforeUpdateGuard", () => $4c62e3475ce4e4e1$export$b751efa7c53f55a);
$parcel$export(module.exports, "isStaticCssProp", () => $4c62e3475ce4e4e1$export$c96c0de160ac5e8c);
$parcel$export(module.exports, "recompileStaticCss", () => $4c62e3475ce4e4e1$export$dbd278a227449096);
$parcel$export(module.exports, "reconcileAttrProp", () => $4c62e3475ce4e4e1$export$b29a6950bf85efa4);
$parcel$export(module.exports, "arrayRowDefinition", () => $4c62e3475ce4e4e1$export$66718326536203a4);
$parcel$export(module.exports, "placeAfter", () => $4c62e3475ce4e4e1$export$b8757934a0745a7c);
$parcel$export(module.exports, "rowAttach", () => $4c62e3475ce4e4e1$export$48200b07a3d569e1);
$parcel$export(module.exports, "placeRows", () => $4c62e3475ce4e4e1$export$df7e4aa0fbf95649);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $1H9Q8 = parcelRequire("1H9Q8");

var $87g1D = parcelRequire("87g1D");

var $aBPRx = parcelRequire("aBPRx");

var $10sxy = parcelRequire("10sxy");

var $8NJs1 = parcelRequire("8NJs1");

var $bF2FJ = parcelRequire("bF2FJ");

var $8RrjX = parcelRequire("8RrjX");

var $8gewL = parcelRequire("8gewL");

var $hAgpL = parcelRequire("hAgpL");

var $fHfMu = parcelRequire("fHfMu");
parcelRequire("bCOVr");
parcelRequire("dYaY2");
var $dSdIt = parcelRequire("dSdIt");

parcelRequire("byww3");
var $dc7wk = parcelRequire("dc7wk");
var $2C0hZ = parcelRequire("2C0hZ");
var $avbFu = parcelRequire("avbFu");
var $5pnrT = parcelRequire("5pnrT");
var $TarXh = parcelRequire("TarXh");
var $kkSVW = parcelRequire("kkSVW");

var $jdWhC = parcelRequire("jdWhC");
parcelRequire("fu4Jd");
var $bugUg = parcelRequire("bugUg");

var $9aRcW = parcelRequire("9aRcW");
var $kaMEs = parcelRequire("kaMEs");
var $fe4kH = parcelRequire("fe4kH");
var $4XTEI = parcelRequire("4XTEI");
var $j2Odm = parcelRequire("j2Odm");
var $lhJVy = parcelRequire("lhJVy");
parcelRequire("6pGsV");
var $9L4Qx = parcelRequire("9L4Qx");
parcelRequire("67GC6");
var $5koEk = parcelRequire("5koEk");
var $521xJ = parcelRequire("521xJ");

var $gBDdH = parcelRequire("gBDdH");

var $1hCtT = parcelRequire("1hCtT");

var $ewXm2 = parcelRequire("ewXm2");

var $gwMPl = parcelRequire("gwMPl");

var $1silJ = parcelRequire("1silJ");
const $4c62e3475ce4e4e1$var$hn = (0, $1hCtT.resolveElementIdEngine)({
    uniqId: 1,
    scopedStyleId: 0
}, (0, $1silJ.VERSION)), $4c62e3475ce4e4e1$var$_t = [], $4c62e3475ce4e4e1$var$it = new Set;
let $4c62e3475ce4e4e1$var$xo = !1, $4c62e3475ce4e4e1$var$_n = 0, $4c62e3475ce4e4e1$var$yt = null, $4c62e3475ce4e4e1$var$jt = null;
function $4c62e3475ce4e4e1$var$gt() {
    return typeof Date < "u" && typeof Date.now == "function" ? Date.now() : 0;
}
function $4c62e3475ce4e4e1$var$yn() {
    return typeof document < "u" && document.visibilityState === "hidden";
}
const $4c62e3475ce4e4e1$var$_r = 250, $4c62e3475ce4e4e1$var$yr = 1e3;
function $4c62e3475ce4e4e1$var$gr() {
    return $4c62e3475ce4e4e1$var$jt && ($4c62e3475ce4e4e1$var$jt !== (typeof requestAnimationFrame == "function" ? requestAnimationFrame : null) || $4c62e3475ce4e4e1$var$yn()) ? !0 : $4c62e3475ce4e4e1$var$gt() - $4c62e3475ce4e4e1$var$_n >= $4c62e3475ce4e4e1$var$yr;
}
function $4c62e3475ce4e4e1$var$br() {
    if ($4c62e3475ce4e4e1$var$xo = !0, $4c62e3475ce4e4e1$var$_n = $4c62e3475ce4e4e1$var$gt(), $4c62e3475ce4e4e1$var$jt = null, typeof requestAnimationFrame != "function") {
        const t = typeof clearTimeout == "function" ? clearTimeout : null, o = setTimeout($4c62e3475ce4e4e1$export$8b6ba24181b4fb6e, 0);
        $4c62e3475ce4e4e1$var$yt = t ? ()=>t(o) : null;
        return;
    }
    if ($4c62e3475ce4e4e1$var$yn()) {
        const t = typeof clearTimeout == "function" ? clearTimeout : null, o = setTimeout($4c62e3475ce4e4e1$export$8b6ba24181b4fb6e, $4c62e3475ce4e4e1$var$_r);
        $4c62e3475ce4e4e1$var$yt = t ? ()=>t(o) : null;
    } else {
        const t = typeof cancelAnimationFrame == "function" ? cancelAnimationFrame : null;
        $4c62e3475ce4e4e1$var$jt = requestAnimationFrame;
        const o = requestAnimationFrame($4c62e3475ce4e4e1$export$8b6ba24181b4fb6e);
        $4c62e3475ce4e4e1$var$yt = t ? ()=>t(o) : null;
    }
}
function $4c62e3475ce4e4e1$var$Ot() {
    if ($4c62e3475ce4e4e1$var$xo) {
        if (!$4c62e3475ce4e4e1$var$gr()) return;
        const t = $4c62e3475ce4e4e1$var$yt;
        if ($4c62e3475ce4e4e1$var$yt = null, t) try {
            t();
        } catch  {}
    }
    $4c62e3475ce4e4e1$var$br();
}
const $4c62e3475ce4e4e1$var$gn = 300, $4c62e3475ce4e4e1$var$bn = 15e4;
let $4c62e3475ce4e4e1$var$Co = 0;
function $4c62e3475ce4e4e1$export$609490690ccf017b() {
    $4c62e3475ce4e4e1$var$Co++;
    let t = !1;
    return ()=>{
        t || (t = !0, !(--$4c62e3475ce4e4e1$var$Co > 0) && ($4c62e3475ce4e4e1$var$_t.length || $4c62e3475ce4e4e1$var$it.size) && $4c62e3475ce4e4e1$var$Ot());
    };
}
function $4c62e3475ce4e4e1$export$8b6ba24181b4fb6e() {
    if ($4c62e3475ce4e4e1$var$xo = !1, $4c62e3475ce4e4e1$var$yt = null, $4c62e3475ce4e4e1$var$jt = null, $4c62e3475ce4e4e1$var$Co > 0 || ($4c62e3475ce4e4e1$var$it.size && $4c62e3475ce4e4e1$var$Re(), !$4c62e3475ce4e4e1$var$_t.length)) return;
    const t = $4c62e3475ce4e4e1$var$_t.splice(0, $4c62e3475ce4e4e1$var$_t.length);
    for(let o = 0; o < t.length; o++){
        const n = t[o];
        if (n.node) {
            if (!n.node.isConnected) {
                const s = n.__ref || (n.__ref = {});
                s.__mountAttempts = (s.__mountAttempts || 0) + 1, s.__mountFirstAttemptAt == null && (s.__mountFirstAttemptAt = $4c62e3475ce4e4e1$var$gt());
                const r = $4c62e3475ce4e4e1$var$gt() - s.__mountFirstAttemptAt;
                s.__mountAttempts <= $4c62e3475ce4e4e1$var$gn && r < $4c62e3475ce4e4e1$var$bn ? ($4c62e3475ce4e4e1$var$_t.push(n), $4c62e3475ce4e4e1$var$Ot()) : console.warn("[DOMQL] onMounted dropped after", s.__mountAttempts, "attempts /", r, "ms \u2014 node never connected:", n.key || n.tag || n);
                continue;
            }
            typeof n.onBridgeMount == "function" && (0, $bF2FJ.mountBridge)(n), typeof n.onMounted == "function" && $4c62e3475ce4e4e1$var$$("Mounted", n, n.__ref?.__mountOptions || {});
        }
    }
}
function $4c62e3475ce4e4e1$var$vo(t, o) {
    const n = t.__ref?.__autoGrow;
    n && n.active && $4c62e3475ce4e4e1$var$Vt(t, !0), !(typeof t.onMounted != "function" && typeof t.onBridgeMount != "function") && (t.__ref.__mountOptions = o, $4c62e3475ce4e4e1$var$_t.push(t), $4c62e3475ce4e4e1$var$Ot());
}
function $4c62e3475ce4e4e1$export$cf3cc0b695ef095e(t, o) {
    typeof t.onContentUpdate == "function" && ((0, $jdWhC.dispatchPluginHook)("contentUpdate", t, o), (0, $1H9Q8.withDesignSystem)(t, ()=>{
        try {
            t.onContentUpdate(t, t.state, t.context, o);
        } catch (n) {
            if ((0, $jdWhC.reportLifecycleError)(t, "onContentUpdate", n), t.context?.strictMode) throw n;
        }
    }));
}
function $4c62e3475ce4e4e1$var$Ar(t) {
    return t.toLowerCase();
}
function $4c62e3475ce4e4e1$var$wn(t) {
    const o = t.charCodeAt(0);
    return o === 58 || o === 64 || o === 38 || o === 91;
}
function $4c62e3475ce4e4e1$var$to(t) {
    if (typeof t == "string") return t || void 0;
    if (typeof t == "number" || typeof t == "bigint") return String(t);
}
function $4c62e3475ce4e4e1$var$Sn(t, o, n, s) {
    return $4c62e3475ce4e4e1$var$oo(s, $4c62e3475ce4e4e1$var$to(t) || (o && typeof o == "object" ? $4c62e3475ce4e4e1$var$to(o.key) : void 0) || String(n));
}
function $4c62e3475ce4e4e1$var$oo(t, o) {
    if (!t || typeof o != "string") return o;
    let n = o;
    for(; $4c62e3475ce4e4e1$var$wr(t, n);)n = "$" + n;
    return n !== o && $4c62e3475ce4e4e1$var$Sr(t, o, n), n;
}
function $4c62e3475ce4e4e1$var$wr(t, o) {
    if ((0, $aBPRx.REGISTRY).has(o) && o !== "content") return !0;
    if (!(o in t)) return !1;
    const n = t[o];
    return !(n && typeof n == "object" && n.__ref && n.parent === t);
}
const $4c62e3475ce4e4e1$var$xn = new Set;
function $4c62e3475ce4e4e1$var$Sr(t, o, n) {
    if (!(0, $dSdIt.isLoudDevRuntime)()) return;
    const s = t.__ref && t.__ref.path && t.__ref.path.join(".") || t.key || "<root>", r = s + "::" + o;
    $4c62e3475ce4e4e1$var$xn.has(r) || ($4c62e3475ce4e4e1$var$xn.add(r), console.warn(`[smbls] a child keyed "${o}" at ${s} names a property of its parent; it lives at el["${n}"] (data-key="${n}") so the parent keeps its own "${o}". Prefix the data keys to keep plain el.<key> access.`));
}
function $4c62e3475ce4e4e1$export$185802fd694ee1f5(t, o, n, s = {}, r) {
    if ((0, $4VQqJ.getObserver)()) return (0, $1H9Q8.untrack)(()=>$4c62e3475ce4e4e1$export$185802fd694ee1f5(t, o, n, s, r));
    if (t == null || t === !1) return null;
    const i = $4c62e3475ce4e4e1$var$Gr(t);
    (typeof t == "string" || typeof t == "number") && (t = {
        text: t
    }), n = $4c62e3475ce4e4e1$var$to(n);
    const f = $4c62e3475ce4e4e1$var$to(t.key), c = Object.create(null);
    c.key = n || (f && o ? $4c62e3475ce4e4e1$var$oo(o, f) : f) || `_${$4c62e3475ce4e4e1$var$hn.uniqId++}`, c.parent = o || null, c.context = t.context || o?.context || s.context || {}, c.context.__create || (c.context.__create = $4c62e3475ce4e4e1$export$185802fd694ee1f5);
    const a = c.__ref = {
        __if: !0,
        __children: [],
        __exec: {},
        __effects: [],
        __eventCleanup: [],
        root: o?.__ref?.root || c,
        path: o?.__ref?.path ? [
            ...o.__ref.path,
            c.key
        ] : [
            c.key
        ],
        origin: t,
        __mount: null,
        __plainRows: null,
        __ifParked: null
    };
    i && (a.__runtimeSource = i);
    let e = r;
    r && (r.holdTail || r.deferAttach) && (r.holdTail && (0, $8NJs1.FEATURES).mount !== null && (0, $8NJs1.FEATURES).mount.hold(c), r.deferAttach && ((0, $hAgpL.mountRecord)(a).attachLater = !0), e = void 0);
    const l = t;
    t = $4c62e3475ce4e4e1$var$Cn(c, t, n, f, o, s);
    const d = $4c62e3475ce4e4e1$var$No(c, a);
    if (d != null) {
        let _;
        if (typeof d == "function") try {
            _ = d(c, c.state, c.context);
        } catch (y) {
            if (_ = !1, a.__ifError = y, typeof console < "u" && console.warn) {
                const w = c.key || c.tag || "?";
                console.warn(`[smbls] \`if:\` evaluator threw on ${w} \u2014 treating as false:`, y?.message || y);
            }
        }
        else _ = d;
        a.__if = !!_;
    }
    if (a.__if) typeof d == "function" && (a.__ifInitialized = !0);
    else {
        if (o) {
            o[c.key] = c;
            const y = o.__ref;
            y && (y.__ifParked || (y.__ifParked = new Set)).add(c.key);
        }
        const _ = $4c62e3475ce4e4e1$var$Er(t, n, c.context?.components);
        return _.length && (a.__ifLateMerge = {
            definition: l,
            key: n,
            ownKey: f,
            names: _,
            options: s
        }), typeof d == "function" && $4c62e3475ce4e4e1$var$Bn(c, a, d), c;
    }
    c.tag || (c.tag = (0, $87g1D.detectTag)(c)), $4c62e3475ce4e4e1$var$$("Init", c, s);
    const u = (0, $8NJs1.FEATURES).hydration, p = c.node = u !== null && u.adopt(c) || (0, $87g1D.cacheNode)(c);
    if (!p) return c;
    const g = u !== null ? c.context?.__replacing : void 0;
    if (g && u.markReplaced(g, c, p), c.tag === "fragment") {
        const y = (c.context?.document || globalThis.document).createComment("");
        p.appendChild(y), a.__fragmentAnchor = y;
    }
    if ($4c62e3475ce4e4e1$var$$("AttachNode", c, s), p.setAttribute && c.key && p.getAttribute("data-key") !== String(c.key) && p.setAttribute("data-key", c.key), o) {
        const _ = o[c.key];
        o[c.key] = c;
        const y = o.__ref?.__children;
        y && (_ === void 0 || !y.includes(c.key)) && y.push(c.key);
    }
    p.setAttribute && c.context?.scopeSelector && c.context.scopeSelector !== ":root" && c.context.key && c.key === c.context.key && p.setAttribute("data-smbls-app", c.context.key), c.id && p.setAttribute && (p.id = c.id), $4c62e3475ce4e4e1$var$Es(c, s), $4c62e3475ce4e4e1$var$In(c), $4c62e3475ce4e4e1$var$Un(c);
    try {
        $4c62e3475ce4e4e1$var$Ls(c, s);
    } catch (_) {
        $4c62e3475ce4e4e1$export$ea9f2c6c3ae41a1e(c, _);
    }
    const h = a.__mount;
    return h !== null && h.pending > 0 ? (h.attachLater || (s.mountWhole === !0 && !(r && r.holdTail) && $4c62e3475ce4e4e1$var$xr(c, o) ? h.held = !0 : $4c62e3475ce4e4e1$var$Ct(c, o, e)), h.tail = ()=>(0, $8NJs1.FEATURES).mount.finish(c, s), c) : ($4c62e3475ce4e4e1$export$3b058bdaa6ecc53(c, !0), (h === null || !h.attachLater) && $4c62e3475ce4e4e1$var$Ct(c, o, e), $4c62e3475ce4e4e1$export$5b0a8b3d5ad40532(c, s), c);
}
function $4c62e3475ce4e4e1$export$2b6cc1479174a046(t) {
    const o = t && t.__ref && t.__ref.__mount;
    return !o || !o.attachLater || (o.attachLater = !1, !t.node || t.__ref.__if === !1) ? !1 : ($4c62e3475ce4e4e1$var$Ct(t, t.parent), !0);
}
function $4c62e3475ce4e4e1$var$xr(t, o) {
    if (!o || o.tag === "fragment") return !1;
    const n = t.node;
    if (!n || n.nodeType === 11) return !1;
    const s = o.node || (o.nodeType ? o : null);
    return !!s && n.parentNode !== s;
}
function $4c62e3475ce4e4e1$export$2d5553a5ccaac8cb(t) {
    const o = t.__ref, n = o && o.__mount;
    if (!n || !n.held || (n.held = !1, o.__if === !1)) return;
    const s = t.node, r = t.parent;
    if (!s || !r) return;
    const i = r.__ref;
    if (!i) {
        $4c62e3475ce4e4e1$var$Ct(t, r);
        return;
    }
    const f = r.node;
    if (!f) return;
    const c = i.__children, a = c ? c.lastIndexOf(t.key) : -1;
    let e;
    for(let l = a - 1; l >= 0; l--){
        const d = r[c[l]], u = d && ($4c62e3475ce4e4e1$export$7098c6c10b33842e(d) || (d.tag === "fragment" && d.__ref ? d.__ref.__fragmentAnchor : null));
        if (u && u.parentNode === f) {
            e = u.nextSibling;
            break;
        }
    }
    e === void 0 && (e = (0, $87g1D.firstSlotAfterText)(f, i.__textNode)), $4c62e3475ce4e4e1$var$Ct(t, r, e ? {
        position: "before",
        node: e
    } : void 0);
}
function $4c62e3475ce4e4e1$export$ea9f2c6c3ae41a1e(t, o) {
    if (typeof console < "u" && console.error) {
        const n = t.__ref?.path?.join(".") || t.key || "<root>";
        console.error(`[smbls] createChildren failed at ${n}:`, o?.message || o, o?.stack ? `
` + o.stack.split(`
`).slice(0, 6).join(`
`) : "");
    }
    (0, $jdWhC.reportRenderError)(t, {
        where: "createChildren",
        error: o
    });
}
const $4c62e3475ce4e4e1$var$Po = [
    "Create",
    "Complete",
    "Render",
    "RenderRouter"
];
function $4c62e3475ce4e4e1$export$5b0a8b3d5ad40532(t, o) {
    typeof t.html == "function" && t.node && !t.node.innerHTML && (0, $1H9Q8.withDesignSystem)(t, ()=>{
        try {
            const n = t.html(t, t.state, t.context);
            n != null && typeof n != "function" && (t.node.innerHTML = n);
        } catch  {}
    });
    for(let n = 0; n < $4c62e3475ce4e4e1$var$Po.length; n++){
        if ($4c62e3475ce4e4e1$var$$($4c62e3475ce4e4e1$var$Po[n], t, o), !t.__ref) return;
        $4c62e3475ce4e4e1$var$Po[n] === "Render" && $4c62e3475ce4e4e1$var$Mo(t);
    }
    if (t.__ref.__if !== !1 && $4c62e3475ce4e4e1$var$vo(t, o), typeof t.onFrame == "function") {
        const n = t.onFrame, s = t.context?.designSystem, r = ()=>{
            if (t.node) {
                if (t.node.isConnected) {
                    s && (0, $521xJ.pushConfig)(s);
                    try {
                        n(t, t.state, t.context);
                    } catch (i) {
                        console.error("[DOMQL] onFrame error:", i);
                    } finally{
                        s && (0, $521xJ.popConfig)();
                    }
                }
                requestAnimationFrame(r);
            }
        };
        requestAnimationFrame(r);
    }
}
function $4c62e3475ce4e4e1$var$no(t, o) {
    const n = o && o.__ref && o.__ref.__mount;
    !n || !n.tail || n.holder || (n.holder = t, (0, $8NJs1.FEATURES).mount.hold(t));
}
const $4c62e3475ce4e4e1$var$vr = new Set([
    "childProps",
    "attr",
    "style",
    "scope",
    "data",
    "vars"
]);
function $4c62e3475ce4e4e1$var$Cn(t, o, n, s, r, i) {
    if (n && !o.extends && !o.extend) {
        const h = n.indexOf("_"), _ = n.indexOf(".");
        let y = h > 0 ? h : -1;
        if (_ > 0 && (y < 0 || _ < y) && (y = _), y > 0) {
            const w = n.substring(0, y), x = t.context?.components;
            x && (x[w] || x["smbls." + w]) ? o = {
                ...o,
                extends: w
            } : x && (0, $dSdIt.isLoudDevRuntime)() && (/^[A-Z]\w*_\d+$/.test(n) || /^[A-Z]\w*\.\w+$/.test(n)) && console.warn(`[smbls] auto-extend: key "${n}" looks like an instance of "${w}" but neither "${w}" nor "smbls.${w}" is registered in context.components \u2014 element will render as a plain <div>. Register the base component or rename the key.`);
        }
    }
    t.__ref && (t.__ref.__mergeLayer = null), (0, $8RrjX.applyExtends)(t, o, i);
    const f = (0, $8RrjX.openMergeLayer)(t), c = t.props && typeof t.props == "object" ? t.props : null;
    for(const h in o)if (!(h === "parent" || h === "node" || h === "__ref" || h === "extends" || h === "context" || h === "props")) {
        if (h === "key") {
            s && (t.key = r ? $4c62e3475ce4e4e1$var$oo(r, s) : s);
            continue;
        }
        f && f.mark(h), $4c62e3475ce4e4e1$var$To(t, h, o[h]);
    }
    if (c) for(const h in c)$4c62e3475ce4e4e1$var$To(t, h, c[h]);
    const a = o.props;
    if (a && typeof a == "object") {
        for(const h in a)$4c62e3475ce4e4e1$var$To(t, h, a[h]);
        if (f) for(const h in a)f.mark(h);
    }
    (0, $8RrjX.closeMergeLayer)(t), o.classlist !== void 0 && (t.classlist = o.classlist), o.text !== void 0 && (t.text = o.text), o.html !== void 0 && (t.html = o.html);
    const e = t.scope && typeof t.scope == "object" ? t.scope : null, l = r?.scope, d = t.context && typeof t.context.globalScope == "object" && t.context.globalScope || null, u = l || d || null;
    if (o.scope !== void 0 || e) {
        const h = {};
        e && Object.assign(h, e), o.scope !== void 0 && Object.assign(h, o.scope), t.scope = (0, $4VQqJ.createScopeStore)(h, u);
    } else u && (t.scope = u);
    o.if !== void 0 && (t.if = o.if);
    const p = t.__ref, g = $4c62e3475ce4e4e1$var$Kr(t, p && p.__runtimeSource);
    return p && (p.__declaredArrays = g || void 0), (0, $fHfMu.addMethods)(t), $4c62e3475ce4e4e1$var$jr(t, r, o, i), o;
}
function $4c62e3475ce4e4e1$var$To(t, o, n) {
    const s = t[o], r = (0, $8NJs1.FEATURES).chains;
    if (r !== null && r(t, o, s, n)) return;
    const i = s && n && typeof s == "object" && typeof n == "object" && !Array.isArray(s) && !Array.isArray(n);
    i && o.charCodeAt(0) >= 65 && o.charCodeAt(0) <= 90 ? t[o] = (0, $8RrjX.deepMergeChild)(s, n) : i && $4c62e3475ce4e4e1$var$vr.has(o) ? t[o] = {
        ...s,
        ...n
    } : i && $4c62e3475ce4e4e1$var$wn(o) ? t[o] = (0, $8RrjX.deepMergeChild)(s, n) : t[o] = n;
}
const $4c62e3475ce4e4e1$var$Pr = new Set([
    "key",
    "parent",
    "context",
    "__ref"
]);
function $4c62e3475ce4e4e1$var$Tr(t, o) {
    for (const s of Object.keys(t))$4c62e3475ce4e4e1$var$Pr.has(s) || delete t[s];
    let n = o.definition;
    if (!n.extends && !n.extend && typeof o.key == "string") {
        const s = t.context?.components || {}, r = s[o.key] || s["smbls." + o.key];
        r && (n = {
            ...n,
            extends: r
        });
    }
    (0, $1H9Q8.untrack)(()=>$4c62e3475ce4e4e1$var$Cn(t, n, o.key, o.ownKey, t.parent, o.options));
}
function $4c62e3475ce4e4e1$var$Er(t, o, n) {
    const s = n || {}, r = (c)=>!!(s[c] || s["smbls." + c]), i = [], f = [];
    if (t.extends && f.push(...Array.isArray(t.extends) ? t.extends : [
        t.extends
    ]), t.extend && f.push(...Array.isArray(t.extend) ? t.extend : [
        t.extend
    ]), f.length) {
        for (const c of f){
            if (typeof c != "string") continue;
            const a = c.includes(">") ? c.split(">")[0].trim() : c;
            r(a) || i.push(a);
        }
        return i;
    }
    if (typeof o == "string" && /^[A-Z]/.test(o)) {
        let c = -1;
        const a = o.indexOf("_"), e = o.indexOf(".");
        a > 0 && (c = a), e > 0 && (c < 0 || e < c) && (c = e);
        const l = c > 0 ? o.substring(0, c) : o;
        r(l) || i.push(l);
    }
    return i;
}
function $4c62e3475ce4e4e1$var$Eo(t, o, n) {
    if (typeof t.onStateInit != "function" && !(0, $jdWhC.hasPluginHook)(t, "stateInit")) return;
    const s = t.state;
    t.state = o;
    try {
        $4c62e3475ce4e4e1$var$$("StateInit", t, n);
    } finally{
        t.state = s;
    }
}
const $4c62e3475ce4e4e1$var$jo = (t)=>({
        isDataOnlyKey: (o)=>(0, $avbFu.polyglotSeededKeys)(t).has(o)
    });
function $4c62e3475ce4e4e1$var$jr(t, o, n, s) {
    const r = !o, i = n.state && typeof n.state == "object" && !Array.isArray(n.state) && Object.keys(n.state).length === 0, f = r && i && t.context?.state, c = n.state !== void 0 && !f ? n.state : t.state && !(0, $4VQqJ.isStore)(t.state) ? t.state : void 0;
    if (c == null) {
        if (o?.state) t.state = o.state, (0, $bugUg.applyStateMethods)(t, t.state);
        else if (t.context?.state) {
            const a = t.context.state, e = {
                ...a
            }, l = t.context?.polyglot;
            if (l?.translations) {
                const d = t.context, u = $5pnrT.polyglotFallbackLang(a.lang, l), p = new Set, g = (y, w)=>{
                    p.has(y) || (0, $avbFu.isPolyglotWritableKey)(d, y, e) && (e[y] = w, p.add(y), (0, $avbFu.markPolyglotSeeded)(d, y, w));
                }, h = l.translations[u];
                if (h && typeof h == "object") for(const y in h)g(y, h[y]);
                const _ = new Set($5pnrT.polyglotLanguages(l, !1));
                for(const y in l.translations)_.has(y) || g(y, l.translations[y]);
            }
            (0, $4VQqJ.isStore)(e) || $4c62e3475ce4e4e1$var$Eo(t, e, s), t.state = (0, $4VQqJ.isStore)(e) ? e : (0, $4VQqJ.createStore)(e, $4c62e3475ce4e4e1$var$jo(t.context)), t.state.__element = t, t.state.root = t.state, (0, $bugUg.applyStateMethods)(t, t.state), $kkSVW.promoteActiveRootState?.(a, t.state), $4c62e3475ce4e4e1$var$$("StateCreated", t, s);
        } else t.state = {}, Object.defineProperty(t.state, "root", {
            value: t.state,
            enumerable: !1,
            configurable: !0,
            writable: !0
        }), (0, $bugUg.applyStateMethods)(t, t.state);
        return;
    }
    if (typeof c == "string") {
        if (t.state = $4c62e3475ce4e4e1$var$Pn(c, o), t.state && typeof t.state == "object" && !(0, $4VQqJ.isStore)(t.state)) {
            const a = o?.state?.root || o?.state || t.state;
            Object.defineProperty(t.state, "root", {
                value: a,
                enumerable: !1,
                configurable: !0,
                writable: !0
            });
        }
        (0, $bugUg.applyStateMethods)(t, t.state), $4c62e3475ce4e4e1$var$Dr(t, c, o), $4c62e3475ce4e4e1$var$$("StateCreated", t, s);
        return;
    }
    if (typeof c == "function") {
        const a = c(t, o?.state);
        if ((0, $4VQqJ.isStore)(a)) t.state = a;
        else {
            const e = a || {};
            $4c62e3475ce4e4e1$var$Eo(t, e, s), t.state = (0, $4VQqJ.createStore)(e, o?.state ? void 0 : $4c62e3475ce4e4e1$var$jo(t.context));
        }
    } else if ((0, $4VQqJ.isStore)(c)) t.state = c;
    else {
        const a = {
            ...c
        };
        $4c62e3475ce4e4e1$var$Eo(t, a, s), t.state = (0, $4VQqJ.createStore)(a, o?.state ? void 0 : $4c62e3475ce4e4e1$var$jo(t.context));
    }
    t.state.__element = t, o?.state ? (t.state.parent = o.state, t.state.root = o.state.root || o.state) : t.state.root = t.state, (0, $bugUg.applyStateMethods)(t, t.state), $kkSVW.promoteActiveRootState?.(c, t.state), $4c62e3475ce4e4e1$var$$("StateCreated", t, s);
}
function $4c62e3475ce4e4e1$var$kn(t, o) {
    if (!o) return t;
    const n = o.split("/");
    let s = t;
    for (const r of n){
        if (s == null) return {};
        s = s[r];
    }
    return s ?? {};
}
function $4c62e3475ce4e4e1$var$vn(t, o) {
    const n = o.state;
    return t.startsWith("~/") ? [
        n && (n.root || n),
        t.slice(2)
    ] : t.startsWith("../") ? [
        n,
        t.slice(3)
    ] : [
        n,
        t
    ];
}
function $4c62e3475ce4e4e1$var$Pn(t, o) {
    if (!o) return {};
    if (t === ".") return o.state || {};
    if (t.startsWith("../") || t.startsWith("~/")) {
        const [r, i] = $4c62e3475ce4e4e1$var$vn(t, o);
        return i ? $4c62e3475ce4e4e1$var$kn(r, i) : r ?? {};
    }
    if (o.state?.[t] !== void 0) return o.state[t];
    const n = $4c62e3475ce4e4e1$var$kn(o.state, t);
    if (n != null && Object.keys(n).length > 0) return n;
    const s = o.context?.polyglot;
    if (s?.translations) {
        const r = $5pnrT.polyglotFallbackLang(o.state?.root?.lang, s), i = s.translations[r];
        if (i?.[t] !== void 0) return i[t];
        if (s.translations[t] !== void 0) return s.translations[t];
    }
    return {};
}
function $4c62e3475ce4e4e1$var$Or(t, o) {
    const [n, s] = $4c62e3475ce4e4e1$var$vn(t, o);
    if (!s || !n || typeof n != "object") return;
    const r = n[s];
    if (r !== void 0 || s.indexOf("/") === -1) return r;
    let i = n;
    for (const f of s.split("/")){
        if (i == null || typeof i != "object") return;
        i = i[f];
    }
    return i;
}
function $4c62e3475ce4e4e1$var$Dr(t, o, n) {
    const s = t.__ref;
    if (!s || !n || o === "." || !(0, $4VQqJ.isStore)(n.state)) return;
    s.__stateBinding && s.__stateBinding.dispose();
    const r = (0, $1H9Q8.untrack)(()=>(0, $4VQqJ.createEffect)(()=>{
            const i = $4c62e3475ce4e4e1$var$Or(o, n);
            !i || typeof i != "object" || i === t.state || (0, $1H9Q8.untrack)(()=>$4c62e3475ce4e4e1$var$Tn(t, t.state, i, !0));
        }, {
            depth: s.path ? s.path.length : 0,
            label: $4c62e3475ce4e4e1$var$E(s, "state")
        }));
    r._isStateBinding = !0, s.__stateBinding = r, s.__effects && s.__effects.push(r);
}
function $4c62e3475ce4e4e1$var$Tn(t, o, n, s) {
    const r = t.__ref;
    if (!r) return;
    if (s || t.state === o) {
        t.state = n, s && (0, $bugUg.applyStateMethods)(t, n), $4c62e3475ce4e4e1$var$jn(r);
        const f = r.__children;
        if (f) for(let c = 0; c < f.length; c++){
            const a = t[f[c]];
            a && a.__ref && a.parent === t && $4c62e3475ce4e4e1$var$Tn(a, o, n, !1);
        }
        return;
    }
    if (r.__stateBinding) {
        r.__stateBinding._notify();
        return;
    }
    const i = t.state;
    i && typeof i == "object" && i.parent === o && (i.parent = n, $4c62e3475ce4e4e1$var$jn(r));
}
function $4c62e3475ce4e4e1$var$En(t, o) {
    const n = t.__ifParked;
    if (!n || !n.size) return o;
    for (const s of n)o.includes(s) || o.push(s);
    return o;
}
function $4c62e3475ce4e4e1$var$jn(t) {
    const o = t.__effects;
    if (o) for(let n = 0; n < o.length; n++){
        const s = o[n];
        s && !s._disposed && !s._isStateBinding && !s._isSubscribeToEffect && typeof s._notify == "function" && s._notify();
    }
}
const $4c62e3475ce4e4e1$var$Lr = new Set([
    "s",
    "state",
    "ctx",
    "context"
]), $4c62e3475ce4e4e1$var$Oo = new WeakMap;
function $4c62e3475ce4e4e1$var$Rr(t) {
    if ($4c62e3475ce4e4e1$var$Oo.has(t)) return $4c62e3475ce4e4e1$var$Oo.get(t);
    let o = null;
    try {
        const n = typeof $2C0hZ.getFunctionSource == "function" ? $2C0hZ.getFunctionSource(t) : Function.prototype.toString.call(t);
        if (typeof n == "string") {
            const s = n.match(/^\s*(?:async\s+)?([A-Za-z_$][\w$]*)\s*=>/) || n.match(/^[^(]*\(([^)]*)\)/);
            s && (o = {
                params: s[1].split(",").map((r)=>r.trim())
            });
        }
    } catch  {}
    return $4c62e3475ce4e4e1$var$Oo.set(t, o), o;
}
function $4c62e3475ce4e4e1$var$Nr(t) {
    const o = $4c62e3475ce4e4e1$var$Rr(t);
    return o ? o.params.map((n)=>n.split("=")[0].trim()).filter(Boolean) : [];
}
const $4c62e3475ce4e4e1$var$Mr = 3, $4c62e3475ce4e4e1$var$Fr = /^(is|has)[A-Z0-9_$]/, $4c62e3475ce4e4e1$var$Ir = new Set([
    "routerOptions"
]), $4c62e3475ce4e4e1$var$On = new WeakSet;
function $4c62e3475ce4e4e1$var$$r(t, o) {
    if (typeof t != "function" || t.length !== 2 || o && ($4c62e3475ce4e4e1$var$Fr.test(o) || $4c62e3475ce4e4e1$var$Ir.has(o)) || $4c62e3475ce4e4e1$var$On.has(t)) return !1;
    const n = $4c62e3475ce4e4e1$var$Nr(t);
    if (n.length < 2) return !1;
    const s = n[1].replace(/[{}[\]]/g, "").trim();
    return s.length < $4c62e3475ce4e4e1$var$Mr || $4c62e3475ce4e4e1$var$Lr.has(s) ? !1 : ($4c62e3475ce4e4e1$var$On.add(t), !0);
}
function $4c62e3475ce4e4e1$var$Ur(t) {
    const o = t.__ref, n = t.tag || "div", s = t.context?.designSystem, r = [], i = Object.keys(t);
    for(let f = 0; f < i.length; f++){
        const c = i[f];
        if (typeof t[c] != "function" || (0, $aBPRx.REGISTRY).has(c)) continue;
        const a = c.charCodeAt(0);
        a >= 65 && a <= 90 || (0, $10sxy.isHandlerKey)(c) || (0, $fe4kH.CSS_PROPS_REGISTRY)[c] || (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST) && (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(c) || a !== 45 && ((0, $gBDdH.checkAttributeByTagName)(n, c) || ((0, $dSdIt.isLoudDevRuntime)() && $4c62e3475ce4e4e1$var$$r(t[c], c) && console.warn(`[smbls] custom prop "${c}"${t.key ? ` on key "${t.key}"` : ""} is a function \u2014 it will be auto-invoked on read and its RETURN VALUE stored, not preserved as a callable reference. If you meant to stash a callback, use el.call('${c}', \u2026) instead of reading el.${c}(\u2026) directly (see RULES.md Rule 8).`), r.push({
            prop: c,
            fn: t[c]
        })));
    }
    for(let f = 0; f < r.length; f++){
        const { prop: c, fn: a } = r[f];
        o.__exec[c] = a, Object.defineProperty(t, c, {
            get () {
                s && (0, $521xJ.pushConfig)(s);
                try {
                    return a(t, t.state, t.context);
                } catch  {
                    return;
                } finally{
                    s && (0, $521xJ.popConfig)();
                }
            },
            set (e) {
                delete o.__exec[c], Object.defineProperty(t, c, {
                    value: e,
                    writable: !0,
                    configurable: !0,
                    enumerable: !0
                });
            },
            configurable: !0,
            enumerable: !0
        });
    }
}
function $4c62e3475ce4e4e1$var$Br(t, o) {
    if (!(!Array.isArray(o) || o.length === 0)) for(let n = 0; n < o.length; n++){
        const s = o[n];
        try {
            typeof s == "function" ? s(t, t.state, t.context) : typeof s == "string" && t.state?.[s];
        } catch  {}
    }
}
function $4c62e3475ce4e4e1$var$L(t, o, n) {
    return !Array.isArray(o) || o.length === 0 ? n : function(...s) {
        return $4c62e3475ce4e4e1$var$Br(t, o), n.apply(this, s);
    };
}
function $4c62e3475ce4e4e1$var$bt(t, o) {
    if (!(!t || Array.isArray(t) || typeof t != "object")) return t[o];
}
function $4c62e3475ce4e4e1$var$E(t, o) {
    return ()=>t.path.join(".") + "::" + o;
}
const $4c62e3475ce4e4e1$var$Dn = new Set;
function $4c62e3475ce4e4e1$var$F(t, o, n) {
    if (!(0, $dSdIt.isLoudDevRuntime)()) return;
    const s = $4c62e3475ce4e4e1$var$E(t, o)();
    $4c62e3475ce4e4e1$var$Dn.has(s) || ($4c62e3475ce4e4e1$var$Dn.add(s), console.warn(`[smbls] "${o}" effect threw on ${t.path.join(".")} \u2014 keeping previous value:`, n?.message || n));
}
const $4c62e3475ce4e4e1$var$Ln = /(['"`])((?:\\.|(?!\1)[^\\])*)\1/g, $4c62e3475ce4e4e1$var$Rn = new WeakMap, $4c62e3475ce4e4e1$var$Vr = (t)=>{
    let o = $4c62e3475ce4e4e1$var$Rn.get(t);
    if (o !== void 0) return o;
    o = null;
    let n;
    try {
        n = String(t);
    } catch  {
        n = "";
    }
    if (n.includes("{{")) {
        $4c62e3475ce4e4e1$var$Ln.lastIndex = 0;
        let s;
        for(; (s = $4c62e3475ce4e4e1$var$Ln.exec(n)) !== null;)s[2].includes("{{") && (o || (o = [])).push(s[2]);
    }
    return $4c62e3475ce4e4e1$var$Rn.set(t, o), o;
}, $4c62e3475ce4e4e1$var$Hr = (t, o)=>{
    const n = $4c62e3475ce4e4e1$var$Vr(t);
    if (n) for(let s = 0; s < n.length; s++)o.add(n[s]);
}, $4c62e3475ce4e4e1$var$Wr = (t, o)=>!(0, $10sxy.isHandlerKey)(t) && !(0, $gwMPl.isCssProp)(o, t), $4c62e3475ce4e4e1$var$Do = (t, o, n, s, r)=>{
    if (typeof o == "string") {
        !r && o.includes("{{") && n.add(o);
        return;
    }
    typeof o == "function" && $4c62e3475ce4e4e1$var$Wr(t, s) && $4c62e3475ce4e4e1$var$Hr(o, n);
}, $4c62e3475ce4e4e1$var$Lo = new WeakMap, $4c62e3475ce4e4e1$var$Dt = (t, o)=>Object.prototype.hasOwnProperty.call(t, o), $4c62e3475ce4e4e1$var$Lt = (t)=>{
    if (typeof t == "string" || typeof t == "number") return {
        text: t
    };
    if (!t || typeof t != "object" || Array.isArray(t)) return null;
    const o = t.props;
    return o && typeof o == "object" && !Array.isArray(o) ? (0, $8RrjX.deepMergeChild)(t, o) : t;
}, $4c62e3475ce4e4e1$var$Rt = (t, o)=>t && o ? (0, $8RrjX.deepMergeChild)(t, o) : t || o || null, $4c62e3475ce4e4e1$var$Nn = (t, o)=>{
    const n = t.__ref && t.__ref.__runtimeSource;
    return !!n && $4c62e3475ce4e4e1$var$Dt(n, o);
}, $4c62e3475ce4e4e1$export$2d5526e9c7b5a43a = (t, o)=>$4c62e3475ce4e4e1$var$Nn(t, o) ? $4c62e3475ce4e4e1$var$Lt(t.__ref.__runtimeSource[o]) : null, $4c62e3475ce4e4e1$export$43c64c8265a0bfaa = (t, o)=>(o && t && typeof t == "object" && $4c62e3475ce4e4e1$var$Lo.set(t, o), t), $4c62e3475ce4e4e1$var$Gr = (t)=>{
    if (!t || typeof t != "object") return;
    const o = $4c62e3475ce4e4e1$var$Lo.get(t);
    return o && $4c62e3475ce4e4e1$var$Lo.delete(t), o;
}, $4c62e3475ce4e4e1$var$Ro = (t, o, n)=>{
    if (typeof t == "string") {
        t.includes("{{") && o.add(t);
        return;
    }
    if (!(!t || typeof t != "object" || n.has(t))) {
        if (n.add(t), Array.isArray(t)) {
            for(let s = 0; s < t.length; s++)$4c62e3475ce4e4e1$var$Ro(t[s], o, n);
            return;
        }
        if (!t.__ref) for (const s of Object.keys(t)){
            if (s === "state") continue;
            const r = Object.getOwnPropertyDescriptor(t, s);
            r && "value" in r && $4c62e3475ce4e4e1$var$Ro(r.value, o, n);
        }
    }
}, $4c62e3475ce4e4e1$var$Kr = (t, o)=>{
    let n = null;
    for (const s of Object.keys(t)){
        if ((0, $aBPRx.REGISTRY).has(s) || o && $4c62e3475ce4e4e1$var$Dt(o, s)) continue;
        const r = Object.getOwnPropertyDescriptor(t, s), i = r && r.value;
        if (!Array.isArray(i)) continue;
        const f = new Set;
        $4c62e3475ce4e4e1$var$Ro(i, f, new Set), f.size && (n || (n = new Map), n.set(i, f));
    }
    return n;
}, $4c62e3475ce4e4e1$var$Mn = (t, o)=>{
    if (Array.isArray(o)) for(let n = t; n; n = n.parent){
        const s = n.__ref && n.__ref.__declaredArrays, r = s && s.get(o);
        if (!r) continue;
        const i = t.__ref;
        i.__authoredTemplates || (i.__authoredTemplates = new Set);
        for (const f of r)i.__authoredTemplates.add(f);
        return;
    }
}, $4c62e3475ce4e4e1$var$Fn = [
    "attr",
    "aria",
    "data",
    "metadata"
], $4c62e3475ce4e4e1$var$zr = (t)=>{
    if ($4c62e3475ce4e4e1$var$Fn.includes(t)) return !0;
    const o = t.charCodeAt(0);
    return o === 46 || o === 33 || o === 64;
}, $4c62e3475ce4e4e1$var$Yr = (t, o)=>{
    const n = new Set, s = t.tag || "div";
    for (const r of Object.keys(t)){
        const i = Object.getOwnPropertyDescriptor(t, r), f = i && i.value, c = !!o && $4c62e3475ce4e4e1$var$Dt(o, r);
        if (f && typeof f == "object" && !Array.isArray(f)) {
            if (!$4c62e3475ce4e4e1$var$zr(r)) continue;
            const a = c ? o[r] : null, e = a && typeof a == "object" ? a : null, l = r.charCodeAt(0) === 46 || r.charCodeAt(0) === 33;
            for(const d in f){
                const u = c && (!e || $4c62e3475ce4e4e1$var$Dt(e, d)), p = f[d];
                if (l && p && typeof p == "object" && !Array.isArray(p) && $4c62e3475ce4e4e1$var$Fn.includes(d)) {
                    for(const g in p)$4c62e3475ce4e4e1$var$Do(g, p[g], n, s, u);
                    continue;
                }
                $4c62e3475ce4e4e1$var$Do(d, p, n, s, u);
            }
            continue;
        }
        $4c62e3475ce4e4e1$var$Do(r, f, n, s, c);
    }
    return n;
};
function $4c62e3475ce4e4e1$var$In(t, o) {
    const n = t.__ref, s = !!(o && o.skipIfEffect), r = $4c62e3475ce4e4e1$var$Yr(t, n.__runtimeSource);
    if (n.__authoredTemplates) for (const e of r)n.__authoredTemplates.add(e);
    else n.__authoredTemplates = r;
    if ($4c62e3475ce4e4e1$var$Ur(t), typeof t.text == "function") {
        const e = t.text, l = $4c62e3475ce4e4e1$var$L(t, t.textDeps, e), d = ()=>{
            let p = l(t, t.state, t.context);
            return t.node && typeof p == "string" && p.includes("{{") && (p = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, p, t.state)), p;
        }, u = (0, $4VQqJ.createEffect)(()=>{
            if (!n.contentManaged) try {
                const p = $4c62e3475ce4e4e1$var$Vn(t, n, d);
                if (p === $4c62e3475ce4e4e1$var$B) return;
                t.node && p != null && typeof p != "function" && typeof p != "object" && $4c62e3475ce4e4e1$export$868dbbfae37a1bda(t, p);
            } catch (p) {
                $4c62e3475ce4e4e1$var$F(n, "text", p);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "text")
        });
        n.__effects.push(u), n.__exec.text = e;
    } else if (typeof t.text == "string" && t.text.includes("{{")) {
        const e = t.text, l = ()=>(0, $TarXh.replaceLiteralsWithObjectFields).call(t, e, t.state), d = (0, $4VQqJ.createEffect)(()=>{
            if (n.contentManaged) return;
            const u = $4c62e3475ce4e4e1$var$Vn(t, n, l);
            u !== $4c62e3475ce4e4e1$var$B && (u != null && (t.text = u), t.node && $4c62e3475ce4e4e1$export$868dbbfae37a1bda(t, u ?? ""));
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "text")
        });
        n.__effects.push(d), n.__exec.text = e;
    }
    const i = t.tag || "div";
    for (const e of Object.keys(t))if (typeof t[e] == "function" && !(0, $aBPRx.REGISTRY).has(e) && !(0, $10sxy.isHandlerKey)(e) && !n.__exec[e] && !(0, $gwMPl.isAttributeFirst)(i, e)) {
        if ((0, $fe4kH.CSS_PROPS_REGISTRY)[e]) {
            const l = t[e], d = $4c62e3475ce4e4e1$var$L(t, t[e + "Deps"], l), u = e;
            let p, g = null, h = null, _;
            const y = ()=>{
                for (const k of h)t.node.classList.remove(k);
                h = null, _ = void 0;
            }, w = ()=>{
                $4c62e3475ce4e4e1$var$zn(t, u, g, null), $4c62e3475ce4e4e1$var$io(t, u, null), g = null;
            }, x = (0, $4VQqJ.createEffect)(()=>{
                const k = t.context?.designSystem;
                k && (0, $521xJ.pushConfig)(k);
                try {
                    const b = d(t, t.state, t.context);
                    (0, $j2Odm.pushStaticCssPass)();
                    let A;
                    try {
                        A = (0, $fe4kH.CSS_PROPS_REGISTRY)[u](b, t, t.state, t.context);
                    } finally{
                        (0, $j2Odm.popStaticCssPass)();
                    }
                    if (Array.isArray(A)) {
                        const S = {};
                        for (const C of A)if (C) for(const T in C)S[T] = C[T];
                        A = S;
                    }
                    if (u === "show" || u === "hide") {
                        t.node && $4c62e3475ce4e4e1$var$uo(t, u, !!(A && A.display), !0);
                        return;
                    }
                    if (A && t.node && $4c62e3475ce4e4e1$var$Qr(A)) {
                        const S = $4c62e3475ce4e4e1$var$wt(A);
                        if (S === null || S !== _) {
                            _ = S;
                            const C = (0, $9L4Qx.css)($4c62e3475ce4e4e1$var$ft(t, A), null, t.context?.cssPrefix), T = C ? C.split(" ").filter(Boolean) : null;
                            if (t.node.classList) {
                                if (h) for (const v of h)t.node.classList.remove(v);
                                if (T && T.length) for (const v of T)t.node.classList.add(v);
                                h = T;
                            }
                        }
                        g && w(), p = void 0;
                    } else if (A && t.node) {
                        h && y();
                        const S = $4c62e3475ce4e4e1$var$wt(A);
                        if (S === null || S !== p || !$4c62e3475ce4e4e1$var$St(t.node, g, t)) {
                            p = S;
                            const C = $4c62e3475ce4e4e1$var$Qn(t, A, g, u);
                            g = $4c62e3475ce4e4e1$var$Mt(t.node, C, t), $4c62e3475ce4e4e1$var$io(t, u, g);
                        }
                    } else t.node && (h && y(), g && w(), p = void 0);
                } finally{
                    k && (0, $521xJ.popConfig)();
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, u)
            });
            n.__effects.push(x), n.__exec[e] = l;
        } else if ((0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST) && (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(e)) {
            const l = t[e], d = $4c62e3475ce4e4e1$var$L(t, t[e + "Deps"], l), u = e;
            let p, g = null;
            const h = (0, $4VQqJ.createEffect)(()=>{
                const _ = t.context?.designSystem;
                _ && (0, $521xJ.pushConfig)(_);
                try {
                    const y = d(t, t.state, t.context);
                    if (t.node) {
                        if (y != null) {
                            const w = u + ":" + String(y);
                            if (w !== p || !$4c62e3475ce4e4e1$var$St(t.node, g, t)) {
                                p = w;
                                const x = {
                                    [u]: y
                                }, k = $4c62e3475ce4e4e1$var$Qn(t, x);
                                g = $4c62e3475ce4e4e1$var$Mt(t.node, k, t), $4c62e3475ce4e4e1$var$io(t, u, g);
                            }
                        } else p = void 0, g = null, $4c62e3475ce4e4e1$var$io(t, u, null), u === "display" ? $4c62e3475ce4e4e1$var$It(t, "") : t.node.style[u] = "";
                    }
                } finally{
                    _ && (0, $521xJ.popConfig)();
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, u)
            });
            n.__effects.push(h), n.__exec[e] = l;
        } else if (e.charCodeAt(0) === 45) {
            const l = t[e];
            $4c62e3475ce4e4e1$var$qn(t, e, l, t[e + "Deps"], e), n.__exec[e] = l;
        }
    }
    if ($4c62e3475ce4e4e1$var$mr(t), typeof t.html == "function") {
        const e = t.html, l = $4c62e3475ce4e4e1$var$L(t, t.htmlDeps, e), d = (0, $4VQqJ.createEffect)(()=>{
            (0, $1H9Q8.withDesignSystem)(t, ()=>{
                const u = l(t, t.state, t.context);
                t.node && u != null && typeof u != "function" && (t.node.innerHTML = u);
            });
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "html")
        });
        n.__effects.push(d), n.__exec.html = e;
    }
    if (typeof t.value == "function") {
        const e = t.value, l = $4c62e3475ce4e4e1$var$L(t, t.valueDeps, e), d = ()=>{
            let p = l(t, t.state, t.context);
            return typeof p == "string" && p.includes("{{") && (p = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, p, t.state)), p;
        }, u = (0, $4VQqJ.createEffect)(()=>{
            try {
                const p = $4c62e3475ce4e4e1$var$q(t, n, "value", d);
                if (p === $4c62e3475ce4e4e1$var$B) return;
                $4c62e3475ce4e4e1$var$Hn(t, p);
            } catch (p) {
                $4c62e3475ce4e4e1$var$F(n, "value", p);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "value")
        });
        n.__effects.push(u), n.__exec.value = e;
    } else if (typeof t.value == "string" && t.value.includes("{{")) {
        const e = t.value, l = ()=>(0, $TarXh.replaceLiteralsWithObjectFields).call(t, e, t.state), d = (0, $4VQqJ.createEffect)(()=>{
            try {
                const u = $4c62e3475ce4e4e1$var$q(t, n, "value", l);
                if (u === $4c62e3475ce4e4e1$var$B) return;
                $4c62e3475ce4e4e1$var$Hn(t, u);
            } catch (u) {
                $4c62e3475ce4e4e1$var$F(n, "value", u);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "value")
        });
        n.__effects.push(d), n.__exec.value = e;
    }
    if (typeof t.style == "function") {
        const e = t.style, l = $4c62e3475ce4e4e1$var$L(t, t.styleDeps, e);
        let d, u = null, p, g, h, _;
        const y = (0, $4VQqJ.createEffect)(()=>{
            const w = l(t, t.state, t.context), x = t.context && t.context.designSystem;
            let k;
            if (w && typeof w == "object" && w === p && x === h) {
                const A = $4c62e3475ce4e4e1$var$wt(w);
                k = A !== null && A === g ? _ : $4c62e3475ce4e4e1$export$5babfef4e4474017(t, w), g = A;
            } else k = $4c62e3475ce4e4e1$export$5babfef4e4474017(t, w), g = void 0;
            p = w, h = x, _ = k;
            const b = $4c62e3475ce4e4e1$var$wt(k);
            (b === null || b !== d || !$4c62e3475ce4e4e1$var$St(t.node, u, t)) && (d = b, $4c62e3475ce4e4e1$var$Fo(t.node, u, k, t), $4c62e3475ce4e4e1$var$Q(t.node, k, t), u = $4c62e3475ce4e4e1$var$Mt(t.node, k, t));
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "style")
        });
        n.__effects.push(y), n.__exec.style = e;
    } else if (t.style && typeof t.style == "object") for(const e in t.style){
        const l = t.style[e];
        if (typeof l != "function") continue;
        const d = $4c62e3475ce4e4e1$var$L(t, $4c62e3475ce4e4e1$var$bt(t.styleDeps, e), l);
        let u, p = null;
        const g = (0, $4VQqJ.createEffect)(()=>{
            try {
                const h = d(t, t.state, t.context);
                if (t.node) {
                    const _ = e + ":" + String(h);
                    if (_ !== u || !$4c62e3475ce4e4e1$var$St(t.node, p, t)) {
                        u = _;
                        const y = $4c62e3475ce4e4e1$export$5babfef4e4474017(t, {
                            [e]: h
                        });
                        $4c62e3475ce4e4e1$var$Fo(t.node, p, Object.assign({}, y, {
                            [e]: ""
                        }), t), $4c62e3475ce4e4e1$var$Q(t.node, y, t), p = $4c62e3475ce4e4e1$var$Mt(t.node, y, t);
                    }
                }
            } catch (h) {
                $4c62e3475ce4e4e1$var$F(n, "style." + e, h);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "style." + e)
        });
        n.__effects.push(g);
    }
    if (t.attr && typeof t.attr == "object") {
        for(const e in t.attr)if (typeof t.attr[e] == "function") {
            const l = $4c62e3475ce4e4e1$var$L(t, $4c62e3475ce4e4e1$var$bt(t.attrDeps, e), t.attr[e]), d = e, u = d.toLowerCase(), p = ()=>{
                let h = l(t, t.state, t.context);
                return typeof h == "string" && h.includes("{{") && (h = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, h, t.state)), h;
            }, g = (0, $4VQqJ.createEffect)(()=>{
                try {
                    const h = $4c62e3475ce4e4e1$var$q(t, n, u, p);
                    if (h === $4c62e3475ce4e4e1$var$B) return;
                    t.node?.setAttribute && $4c62e3475ce4e4e1$export$50a52ac7cfdacacb(t.node, d, h);
                } catch (h) {
                    $4c62e3475ce4e4e1$var$F(n, "attr." + d, h);
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, "attr." + d)
            });
            g._attrName = d.toLowerCase(), n.__effects.push(g);
        } else if (typeof t.attr[e] == "string" && t.attr[e].includes("{{")) {
            const l = t.attr[e], d = e, u = d.toLowerCase(), p = ()=>(0, $TarXh.replaceLiteralsWithObjectFields).call(t, l, t.state), g = (0, $4VQqJ.createEffect)(()=>{
                try {
                    const h = $4c62e3475ce4e4e1$var$q(t, n, u, p);
                    if (h === $4c62e3475ce4e4e1$var$B || !t.node || !t.node.setAttribute) return;
                    t.node.setAttribute(d, (0, $gBDdH.serializeAttrValue)(d, h ?? ""));
                } catch (h) {
                    $4c62e3475ce4e4e1$var$F(n, "attr." + d, h);
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, "attr." + d)
            });
            g._attrName = d.toLowerCase(), n.__effects.push(g);
        }
    }
    if (t.aria && typeof t.aria == "object") for(const e in t.aria){
        const l = t.aria[e];
        if (typeof l == "string" && l.includes("{{")) {
            const h = l, _ = "aria-" + e.replace(/[A-Z]/g, (x)=>"-" + x.toLowerCase()), y = ()=>(0, $TarXh.replaceLiteralsWithObjectFields).call(t, h, t.state), w = (0, $4VQqJ.createEffect)(()=>{
                try {
                    const x = $4c62e3475ce4e4e1$var$q(t, n, _, y);
                    if (x === $4c62e3475ce4e4e1$var$B || !t.node || !t.node.setAttribute) return;
                    t.node.setAttribute(_, (0, $gBDdH.serializeAttrValue)(_, x ?? ""));
                } catch (x) {
                    $4c62e3475ce4e4e1$var$F(n, "aria." + e, x);
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, "aria." + e)
            });
            w._attrName = _, n.__effects.push(w);
            continue;
        }
        if (typeof l != "function") continue;
        const d = $4c62e3475ce4e4e1$var$L(t, $4c62e3475ce4e4e1$var$bt(t.ariaDeps, e), t.aria[e]), u = "aria-" + e.replace(/[A-Z]/g, (h)=>"-" + h.toLowerCase()), p = ()=>d(t, t.state, t.context), g = (0, $4VQqJ.createEffect)(()=>{
            try {
                const h = $4c62e3475ce4e4e1$var$q(t, n, u, p);
                if (h === $4c62e3475ce4e4e1$var$B || !t.node?.setAttribute) return;
                $4c62e3475ce4e4e1$export$50a52ac7cfdacacb(t.node, u, h);
            } catch (h) {
                $4c62e3475ce4e4e1$var$F(n, "aria." + e, h);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "aria." + e)
        });
        g._attrName = u, n.__effects.push(g);
    }
    if (t.data && typeof t.data == "object") for(const e in t.data){
        const l = t.data[e];
        if (typeof l == "string" && l.includes("{{")) {
            const _ = l, y = "data-" + e.replace(/[A-Z]/g, (k)=>"-" + k.toLowerCase()), w = ()=>(0, $TarXh.replaceLiteralsWithObjectFields).call(t, _, t.state), x = (0, $4VQqJ.createEffect)(()=>{
                try {
                    const k = $4c62e3475ce4e4e1$var$q(t, n, y, w);
                    if (k === $4c62e3475ce4e4e1$var$B || !t.node || !t.node.setAttribute) return;
                    t.node.setAttribute(y, k ?? "");
                } catch (k) {
                    $4c62e3475ce4e4e1$var$F(n, "data." + e, k);
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, "data." + e)
            });
            x._attrName = y, n.__effects.push(x);
            continue;
        }
        if (typeof l != "function") continue;
        const d = $4c62e3475ce4e4e1$var$L(t, $4c62e3475ce4e4e1$var$bt(t.dataDeps, e), t.data[e]), p = "data-" + e.replace(/[A-Z]/g, (_)=>"-" + _.toLowerCase()), g = ()=>d(t, t.state, t.context), h = (0, $4VQqJ.createEffect)(()=>{
            try {
                const _ = $4c62e3475ce4e4e1$var$q(t, n, p, g);
                if (_ === $4c62e3475ce4e4e1$var$B || !t.node?.setAttribute) return;
                _ == null || _ === !1 ? t.node.removeAttribute(p) : typeof _ != "function" && typeof _ != "object" && t.node.setAttribute(p, _ === !0 ? "" : _);
            } catch (_) {
                $4c62e3475ce4e4e1$var$F(n, "data." + e, _);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "data." + e)
        });
        h._attrName = p, n.__effects.push(h);
    }
    const f = t.classlist && typeof t.classlist == "object" && !Array.isArray(t.classlist) ? t.classlist : t.class && typeof t.class == "object" && !Array.isArray(t.class) ? t.class : null;
    if (f) for(const e in f){
        if (typeof f[e] != "function") continue;
        const l = $4c62e3475ce4e4e1$var$L(t, $4c62e3475ce4e4e1$var$bt(t.classDeps, e), f[e]), d = (0, $4VQqJ.createEffect)(()=>{
            try {
                const u = l(t, t.state, t.context);
                if (!t.node?.classList) return;
                typeof u == "string" ? t.node.classList.add(u) : u ? t.node.classList.add(e) : t.node.classList.remove(e);
            } catch (u) {
                $4c62e3475ce4e4e1$var$F(n, "class." + e, u);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "class." + e)
        });
        n.__effects.push(d);
    }
    const c = s ? null : $4c62e3475ce4e4e1$var$No(t, n);
    typeof c == "function" && $4c62e3475ce4e4e1$var$Bn(t, n, c);
    for (const e of Object.keys(t)){
        if ((0, $aBPRx.REGISTRY).has(e) || typeof t[e] != "function") continue;
        const l = e.charCodeAt(0);
        if (l >= 65 && l <= 90 || (0, $10sxy.isHandlerKey)(e)) continue;
        const d = t[e];
        n.__exec[e] = d;
        const u = t.tag || "div";
        if ((0, $gBDdH.checkAttributeByTagName)(u, e) && !(0, $gwMPl.isCssProp)(u, e)) {
            const p = (0, $gBDdH.camelToAttr)(e) || e, g = $4c62e3475ce4e4e1$var$L(t, t[e + "Deps"], d), h = p.toLowerCase(), _ = ()=>{
                let w = g(t, t.state, t.context);
                return typeof w == "string" && w.includes("{{") && (w = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, w, t.state)), w;
            }, y = (0, $4VQqJ.createEffect)(()=>{
                try {
                    let w = $4c62e3475ce4e4e1$var$q(t, n, h, _);
                    if (w === $4c62e3475ce4e4e1$var$B) return;
                    const x = (0, $gBDdH.ATTR_TRANSFORMS)[e];
                    if (x && w != null) {
                        const k = x(t);
                        k !== void 0 && (w = k);
                    }
                    t.node?.setAttribute && $4c62e3475ce4e4e1$export$50a52ac7cfdacacb(t.node, p, w, !0);
                } catch (w) {
                    $4c62e3475ce4e4e1$var$F(n, e, w);
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, e)
            });
            y._attrName = p.toLowerCase(), n.__effects.push(y);
        }
    }
    const a = t.tag || "div";
    for (const e of Object.keys(t)){
        if ((0, $aBPRx.REGISTRY).has(e)) continue;
        const l = t[e];
        if (typeof l != "string" || !l.includes("{{")) continue;
        const d = e.charCodeAt(0);
        if (d >= 65 && d <= 90 || (0, $10sxy.isHandlerKey)(e) || (0, $gwMPl.isCssProp)(a, e) || (0, $gBDdH.ATTR_TRANSFORMS)[e] || !(0, $gBDdH.checkAttributeByTagName)(a, e)) continue;
        const u = (0, $gBDdH.camelToAttr)(e) || e, p = u.toLowerCase(), g = ()=>(0, $TarXh.replaceLiteralsWithObjectFields).call(t, l, t.state), h = (0, $4VQqJ.createEffect)(()=>{
            try {
                const _ = $4c62e3475ce4e4e1$var$q(t, n, p, g);
                if (_ === $4c62e3475ce4e4e1$var$B || !t.node || !t.node.setAttribute) return;
                t.node.setAttribute(u, (0, $gBDdH.serializeAttrValue)(u, _ ?? ""));
            } catch (_) {
                $4c62e3475ce4e4e1$var$F(n, e, _);
            }
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, e)
        });
        h._attrName = u.toLowerCase(), n.__effects.push(h);
    }
    if ($4c62e3475ce4e4e1$var$ce(t), $4c62e3475ce4e4e1$var$ve(t), typeof t.onStateUpdate == "function" && Array.isArray(t.stateDeps)) {
        const e = t.onStateUpdate, l = t.stateDeps;
        let d = !1, u = [];
        const p = (0, $4VQqJ.createEffect)(()=>{
            const g = [];
            for(let y = 0; y < l.length; y++){
                const w = l[y];
                try {
                    g[y] = typeof w == "function" ? w(t, t.state, t.context) : t.state?.[w];
                } catch  {
                    g[y] = void 0;
                }
            }
            if (!d) {
                d = !0, u = g;
                return;
            }
            let h = g.length !== u.length;
            for(let y = 0; !h && y < g.length; y++)g[y] !== u[y] && (h = !0);
            const _ = u;
            u = g, h && (0, $1H9Q8.withDesignSystem)(t, ()=>{
                try {
                    e(t, t.state, t.context, {
                        prev: _,
                        next: g
                    });
                } catch (y) {
                    if ((0, $jdWhC.reportLifecycleError)(t, "onStateUpdate", y), t.context?.strictMode) throw y;
                }
            });
        }, {
            depth: n.path.length,
            label: $4c62e3475ce4e4e1$var$E(n, "onStateUpdate")
        });
        n.__effects.push(p);
    }
    $4c62e3475ce4e4e1$var$Ae(t);
}
function $4c62e3475ce4e4e1$var$$n(t) {
    const o = t.__ref.__mount;
    if (o !== null && o.attachLater) return;
    const n = t.parent, s = n?.node;
    if (!s || !t.node) {
        $4c62e3475ce4e4e1$var$Ct(t, t.parent);
        return;
    }
    let r = null;
    const i = Object.keys(n), f = i.indexOf(t.key);
    for(let a = f + 1; a < i.length; a++){
        const e = n[i[a]];
        if (e?.node?.parentNode === s) {
            r = e.node;
            break;
        }
    }
    t.node.parentNode === s && t.node.nextSibling === r || (r ? s.insertBefore(t.node, r) : s.appendChild(t.node)), (0, $8gewL.flushConnected)();
}
function $4c62e3475ce4e4e1$var$Un(t) {
    $4c62e3475ce4e4e1$var$Wn(t), $4c62e3475ce4e4e1$var$De(t), $4c62e3475ce4e4e1$var$ds(t), $4c62e3475ce4e4e1$var$We(t), $4c62e3475ce4e4e1$var$He(t);
}
function $4c62e3475ce4e4e1$var$No(t, o) {
    const n = t.deferUntil;
    if (typeof n != "function" || o.__deferOpen) return t.if;
    const s = t.if;
    return (r, i, f)=>{
        if (!o.__deferOpen) {
            let c;
            try {
                c = n(r, i, f);
            } catch (a) {
                const e = o.__deferUntilError === void 0;
                if (o.__deferUntilError = a, e && typeof console < "u" && console.warn) {
                    const l = r.key || r.tag || "?";
                    console.warn(`[smbls] \`deferUntil:\` threw on ${l} \u2014 treating as false:`, a?.message || a);
                }
                return !1;
            }
            if (!c) return !1;
            o.__deferOpen = !0;
        }
        return s == null ? !0 : typeof s == "function" ? s(r, i, f) : s;
    };
}
function $4c62e3475ce4e4e1$var$Bn(t, o, n) {
    let s = $4c62e3475ce4e4e1$var$L(t, t.ifDeps, n);
    const r = (0, $4VQqJ.createEffect)(()=>{
        const i = !o.__ifInitialized && o.__ifLateMerge;
        if (i) {
            const e = t.context?.components || {};
            if (i.names.some((l)=>e[l] || e["smbls." + l])) {
                o.__ifLateMerge = null, $4c62e3475ce4e4e1$var$Tr(t, i);
                const l = $4c62e3475ce4e4e1$var$No(t, o);
                s = $4c62e3475ce4e4e1$var$L(t, t.ifDeps, typeof l == "function" ? l : n);
            }
        }
        let f;
        try {
            f = s(t, t.state, t.context);
        } catch (e) {
            if (f = !1, o.__ifError = e, typeof console < "u" && console.warn) {
                const l = t.key || t.tag || "?";
                console.warn(`[smbls] \`if:\` reactive effect threw on ${l} \u2014 treating as false:`, e?.message || e);
            }
            return;
        }
        const c = o.__if;
        o.__if = !!f;
        const a = o.__mount;
        if (!(!c && o.__if && a !== null && a.held)) {
            if (c && !o.__if && t.node) {
                t.node.remove();
                try {
                    typeof t.onRemove == "function" && t.onRemove(t);
                } catch (e) {
                    console.error("[smbls] onRemove error:", e);
                }
            } else if (!c && o.__if) {
                if (o.__ifInitialized) t.node || (t.node = (0, $87g1D.cacheNode)(t)), t.node && (t.node.ref = t), $4c62e3475ce4e4e1$var$$n(t), $4c62e3475ce4e4e1$var$Wn(t), $4c62e3475ce4e4e1$var$ds(t), $4c62e3475ce4e4e1$var$$("Render", t, {}), $4c62e3475ce4e4e1$var$Mo(t), $4c62e3475ce4e4e1$var$vo(t, {});
                else {
                    o.__ifInitialized = !0, o.__ifLateMerge = null, t.tag || (t.tag = (0, $87g1D.detectTag)(t)), $4c62e3475ce4e4e1$var$$("Init", t, {});
                    const e = (0, $8NJs1.FEATURES).hydration;
                    if (!t.node) {
                        t.node = e !== null && e.adopt(t) || (0, $87g1D.cacheNode)(t);
                        const l = e !== null && t.node ? t.context?.__replacing : void 0;
                        l && e.markReplaced(l, t, t.node);
                    }
                    if (!t.node) return;
                    if (t.node.ref = t, t.parent?.__ref?.__children && !t.parent.__ref.__children.includes(t.key) && t.parent.__ref.__children.push(t.key), t.parent?.__ref?.__ifParked && t.parent.__ref.__ifParked.delete(t.key), t.tag === "fragment" && !o.__fragmentAnchor) {
                        const d = (t.context?.document || globalThis.document).createComment("");
                        t.node.appendChild(d), o.__fragmentAnchor = d;
                    }
                    $4c62e3475ce4e4e1$var$$("AttachNode", t, {}), t.node.setAttribute && t.key && t.node.setAttribute("data-key", t.key), t.id && t.node.setAttribute && (t.node.id = t.id), $4c62e3475ce4e4e1$var$Es(t, {}), $4c62e3475ce4e4e1$var$In(t, {
                        skipIfEffect: !0
                    }), $4c62e3475ce4e4e1$var$Un(t), $4c62e3475ce4e4e1$var$Ls(t, {}), $4c62e3475ce4e4e1$var$$n(t), $4c62e3475ce4e4e1$var$$("Create", t, {}), $4c62e3475ce4e4e1$var$$("Complete", t, {}), $4c62e3475ce4e4e1$var$$("Render", t, {}), $4c62e3475ce4e4e1$var$Mo(t), $4c62e3475ce4e4e1$var$$("RenderRouter", t, {}), $4c62e3475ce4e4e1$var$vo(t, {});
                }
            }
        }
    }, {
        depth: o.path.length,
        label: $4c62e3475ce4e4e1$var$E(o, "if")
    });
    o.__effects.push(r);
}
const $4c62e3475ce4e4e1$var$B = Symbol("builtTextKept");
function $4c62e3475ce4e4e1$var$Vn(t, o, n) {
    const s = o.__builtText;
    if (!s) return n();
    if (s.parentNode !== t.node || typeof $dc7wk.evaluateText != "function") return o.__builtText = null, n();
    const { value: r, ready: i } = $dc7wk.evaluateText(n);
    return i ? r : $4c62e3475ce4e4e1$var$B;
}
function $4c62e3475ce4e4e1$var$q(t, o, n, s) {
    const r = o.__builtAttrs;
    if (!r || !r.values.has(n)) return s();
    const i = t.node;
    if (i !== r.node || typeof $dc7wk.evaluateText != "function") return o.__builtAttrs = null, s();
    const { value: f, ready: c } = $dc7wk.evaluateText(s);
    return c ? (r.values.delete(n), r.values.size || (o.__builtAttrs = null), f) : (i.setAttribute(n, r.values.get(n)), $4c62e3475ce4e4e1$var$B);
}
function $4c62e3475ce4e4e1$export$868dbbfae37a1bda(t, o) {
    const n = t.node;
    if (!n) return;
    t.__ref && t.__ref.__builtText && (t.__ref.__builtText = null);
    const s = o == null || typeof o == "object" ? "" : String(o);
    if (t.tag === "string") {
        n.nodeValue !== s && (n.nodeValue = s);
        return;
    }
    const r = t.__ref;
    let i = r ? r.__textNode : null;
    if (i && i.parentNode !== n && (i = null), !i) {
        const c = n.firstChild;
        c && c.nodeType === 3 && (i = c);
    }
    i ? i.nodeValue !== s && (i.nodeValue = s) : n.firstChild ? (i = (n.ownerDocument || t.context?.document || globalThis.document).createTextNode(s), n.insertBefore(i, n.firstChild)) : (n.textContent = s, i = n.firstChild && n.firstChild.nodeType === 3 ? n.firstChild : null), r && (r.__textNode = i || null);
    const f = (0, $8NJs1.FEATURES).faceWait;
    f !== null && f.active && f.text(t);
}
function $4c62e3475ce4e4e1$var$Mo(t) {
    const o = (0, $8NJs1.FEATURES).faceWait;
    o !== null && o.rendered(t);
}
function $4c62e3475ce4e4e1$var$qr(t, o) {
    return o !== "checked" || !t || t.tagName !== "INPUT" ? null : t.hasAttribute("checked");
}
function $4c62e3475ce4e4e1$var$Zr(t, o) {
    if (o === null) return;
    const n = t.hasAttribute("checked");
    n !== o && t.checked !== n && (t.checked = n);
}
function $4c62e3475ce4e4e1$export$50a52ac7cfdacacb(t, o, n, s) {
    n == null || n === !1 && !(0, $gBDdH.isEnumeratedTrueFalseAttr)(o) ? $4c62e3475ce4e4e1$var$eo(t, o, null) : typeof n == "function" || typeof n == "object" || (s && o === "src" && "src" in t ? t.src = n : $4c62e3475ce4e4e1$var$eo(t, o, (0, $gBDdH.serializeAttrValue)(o, n)));
}
function $4c62e3475ce4e4e1$var$eo(t, o, n) {
    const s = $4c62e3475ce4e4e1$var$qr(t, o);
    n == null ? t.removeAttribute(o) : t.setAttribute(o, n), $4c62e3475ce4e4e1$var$Zr(t, s);
}
function $4c62e3475ce4e4e1$var$Hn(t, o) {
    const n = t.node;
    if (!n || !("value" in n)) return;
    const s = o == null ? "" : String(o);
    if (n.value === s) return;
    const r = n.ownerDocument, i = !!r && r.activeElement === n, f = i && typeof n.selectionStart == "number" ? n.selectionStart : null, c = i && typeof n.selectionEnd == "number" ? n.selectionEnd : null;
    if (n.value = s, i && f != null && c != null) try {
        n.setSelectionRange(f, c);
    } catch  {}
    const a = t.__ref && t.__ref.__autoGrow;
    a && a.active && a.resize();
}
function $4c62e3475ce4e4e1$var$Wn(t) {
    const { node: o } = t;
    if (o) {
        if ((typeof t.text == "string" && !t.text.includes("{{") || typeof t.text == "number") && $4c62e3475ce4e4e1$export$868dbbfae37a1bda(t, t.text), $4c62e3475ce4e4e1$var$ws(t), typeof t.html == "string" && (o.innerHTML = t.html), t.value != null && typeof t.value != "function" && !(typeof t.value == "string" && t.value.includes("{{")) && "value" in o) {
            const n = String(t.value);
            o.value !== n && (o.value = n);
        }
        if (t.style && typeof t.style == "object") {
            let n = t.style;
            for(const s in t.style)if (typeof t.style[s] == "function") {
                n = {};
                for(const r in t.style)typeof t.style[r] != "function" && (n[r] = t.style[r]);
                break;
            }
            $4c62e3475ce4e4e1$var$Q(o, $4c62e3475ce4e4e1$export$5babfef4e4474017(t, n), t);
        }
        if (t.attr && typeof t.attr == "object") for(const n in t.attr){
            const s = t.attr[n];
            typeof s == "function" || typeof s == "object" || s != null && (typeof s == "string" && s.includes("{{") || s === !1 && !(0, $gBDdH.isEnumeratedTrueFalseAttr)(n) || o.setAttribute && o.setAttribute(n, (0, $gBDdH.serializeAttrValue)(n, s)));
        }
        if (typeof t.themeModifier == "string" && t.themeModifier && o.setAttribute && o.setAttribute("data-theme", t.themeModifier), t.data && typeof t.data == "object") for(const n in t.data){
            const s = t.data[n];
            typeof s == "function" || typeof s == "object" || s == null || s === !1 || typeof s == "string" && s.includes("{{") || o.dataset && (o.dataset[n] = s === !0 ? "" : s);
        }
        if (t.classlist || t.class) {
            const n = t.classlist || t.class;
            if (typeof n == "string") n.split(" ").forEach((s)=>s && o.classList.add(s));
            else if (typeof n == "object") for(const s in n){
                const r = typeof n[s] == "function" ? n[s](t, t.state, t.context) : n[s];
                r && o.classList.add(typeof r == "string" ? r : s);
            }
        }
    }
}
function $4c62e3475ce4e4e1$var$wt(t) {
    if (t == null || typeof t != "object") return "s:" + String(t);
    try {
        return "o:" + JSON.stringify(t);
    } catch  {
        return null;
    }
}
function $4c62e3475ce4e4e1$var$Qr(t) {
    if (!t || typeof t != "object") return !1;
    for(const o in t){
        const n = t[o];
        if (n && typeof n == "object" && !Array.isArray(n)) return !0;
    }
    return !1;
}
function $4c62e3475ce4e4e1$var$Mt(t, o, n) {
    if (!t || !t.style || !o) return null;
    const s = t.style, r = [];
    for(const i in o){
        if (o[i] == null || i.charAt(0) === "&") continue;
        const c = $4c62e3475ce4e4e1$var$Z(i);
        r.push(c, $4c62e3475ce4e4e1$var$xt(n, s, c), $4c62e3475ce4e4e1$var$Uo(n, s, c));
    }
    return r;
}
function $4c62e3475ce4e4e1$var$Gn(t, o) {
    return typeof t.getPropertyValue == "function" ? t.getPropertyValue(o) : "";
}
function $4c62e3475ce4e4e1$var$Kn(t, o) {
    return typeof t.getPropertyPriority == "function" ? t.getPropertyPriority(o) : "";
}
function $4c62e3475ce4e4e1$var$Z(t) {
    return (0, $ewXm2.cssPropName)(t);
}
function $4c62e3475ce4e4e1$var$Fo(t, o, n, s) {
    if (!t || !t.style || !o || !o.length) return;
    const r = t.style, i = new Set;
    if (n && typeof n == "object") for(const f in n)n[f] == null || f.charAt(0) === "&" || i.add($4c62e3475ce4e4e1$var$Z(f));
    for(let f = 0; f < o.length; f += 3){
        const c = o[f];
        i.has(c) || $4c62e3475ce4e4e1$var$xt(s, r, c) === o[f + 1] && (s && c === "display" ? $4c62e3475ce4e4e1$var$It(s, "") : typeof r.removeProperty == "function" && r.removeProperty(c));
    }
}
function $4c62e3475ce4e4e1$var$io(t, o, n) {
    const s = t.__ref;
    s && (n ? (s.__heldInline || (s.__heldInline = new Map)).set(o, n) : s.__heldInline && s.__heldInline.delete(o));
}
function $4c62e3475ce4e4e1$var$Xr(t, o, n) {
    if (t.__heldInline) {
        for (const [s, r] of t.__heldInline)if (s !== o) {
            for(let i = 0; i < r.length; i += 3)if (r[i] === n) return !0;
        }
    }
    return !1;
}
function $4c62e3475ce4e4e1$var$zn(t, o, n, s) {
    const r = t.__ref, i = t.node;
    if (!r || !n || !i || !i.style) return;
    const f = r.__inlineCssKeys;
    let c = null;
    for(let d = 0; d < n.length; d += 3){
        const u = n[d];
        s && s.has(u) || $4c62e3475ce4e4e1$var$Xr(r, o, u) || (c || (c = []), c.push(d), f && f.delete(u));
    }
    if (!c) return;
    const a = f && $4c62e3475ce4e4e1$var$Io(t, f), e = i.style, l = [];
    for (const d of c){
        const u = n[d];
        a && a[u] !== void 0 || $4c62e3475ce4e4e1$var$xt(t, e, u) === n[d + 1] && l.push(u);
    }
    for (const d of l)d === "display" ? $4c62e3475ce4e4e1$var$It(t, "") : typeof e.removeProperty == "function" && e.removeProperty(d);
}
function $4c62e3475ce4e4e1$var$Jr(t, o, n) {
    const s = [];
    for(let f = 0; f < o.length; f += 3)s.push(o[f]);
    let r = !1;
    for(const f in n){
        const c = (0, $ewXm2.CSS_LONGHAND_SHORTHANDS)[f];
        s.some((a)=>c.includes(a)) && (r = !0, s.includes(f) || s.push(f));
    }
    if (!r) return;
    const i = t.node.style;
    o.length = 0;
    for (const f of s)o.push(f, $4c62e3475ce4e4e1$var$xt(t, i, f), $4c62e3475ce4e4e1$var$Uo(t, i, f));
}
function $4c62e3475ce4e4e1$var$St(t, o, n) {
    if (!o || !t || !t.style) return !1;
    const s = t.style;
    for(let r = 0; r < o.length; r += 3)if ($4c62e3475ce4e4e1$var$xt(n, s, o[r]) !== o[r + 1] || $4c62e3475ce4e4e1$var$Uo(n, s, o[r]) !== o[r + 2]) return !1;
    return !0;
}
const $4c62e3475ce4e4e1$var$Ft = (t)=>t.charCodeAt(0) === 45 && t.charCodeAt(1) === 45, $4c62e3475ce4e4e1$var$Yn = (t)=>typeof t == "number" || t === !0 || typeof t == "string" && t !== "", $4c62e3475ce4e4e1$var$co = (t)=>$4c62e3475ce4e4e1$var$Ft(t) ? t : "--" + t;
function $4c62e3475ce4e4e1$var$fo(t, o) {
    if (!$4c62e3475ce4e4e1$var$X(t)) return null;
    let n = null;
    for (const s of Object.keys(t)){
        if (!s) continue;
        let r = t[s];
        if (typeof r == "function") {
            if (!o) continue;
            r = r(o, o.state, o.context);
        }
        $4c62e3475ce4e4e1$var$Yn(r) && (n || (n = {}), n[$4c62e3475ce4e4e1$var$co(s)] = r);
    }
    return n;
}
function $4c62e3475ce4e4e1$var$qn(t, o, n, s, r) {
    $4c62e3475ce4e4e1$var$Zn(t, r, $4c62e3475ce4e4e1$var$L(t, s, n), (i)=>$4c62e3475ce4e4e1$var$Yn(i) ? {
            [o]: i
        } : null);
}
function $4c62e3475ce4e4e1$var$Zn(t, o, n, s, r) {
    const i = t.__ref;
    let f, c = null;
    const a = (0, $4VQqJ.createEffect)(()=>{
        (0, $1H9Q8.withDesignSystem)(t, ()=>{
            try {
                const e = s(n(t, t.state, t.context)), l = t.node;
                if (!l || !l.style) return;
                const d = $4c62e3475ce4e4e1$var$wt(e);
                (d === null || d !== f || !$4c62e3475ce4e4e1$var$St(l, c)) && (f = d, $4c62e3475ce4e4e1$var$Fo(l, c, e), e && $4c62e3475ce4e4e1$var$Q(l, $4c62e3475ce4e4e1$var$ft(t, e)), c = e ? $4c62e3475ce4e4e1$var$Mt(l, e) : null, r && r(e));
            } catch (e) {
                $4c62e3475ce4e4e1$var$F(i, o, e);
            }
        });
    }, {
        depth: i.path.length,
        label: $4c62e3475ce4e4e1$var$E(i, o)
    });
    i.__effects.push(a);
}
function $4c62e3475ce4e4e1$var$mr(t) {
    const o = t.__ref, n = t.vars;
    if (typeof n == "function") {
        $4c62e3475ce4e4e1$var$te(t, n), o.__exec.vars = n;
        return;
    }
    if ($4c62e3475ce4e4e1$var$X(n)) for (const s of Object.keys(n)){
        const r = n[s];
        !s || typeof r != "function" || $4c62e3475ce4e4e1$var$qn(t, $4c62e3475ce4e4e1$var$co(s), r, $4c62e3475ce4e4e1$var$bt(t.varsDeps, s), "vars." + s);
    }
}
function $4c62e3475ce4e4e1$var$te(t, o) {
    const n = t.__ref;
    $4c62e3475ce4e4e1$var$Zn(t, "vars", $4c62e3475ce4e4e1$var$L(t, t.varsDeps, o), (s)=>$4c62e3475ce4e4e1$var$fo(s), (s)=>{
        n.__varsInline = s ? new Set(Object.keys(s)) : null;
    });
}
function $4c62e3475ce4e4e1$var$oe(t, o) {
    if (typeof t[o] == "function" && ((0, $gwMPl.isCssProp)(t.tag || "div", o) || o.charCodeAt(0) === 45)) return !0;
    if (!$4c62e3475ce4e4e1$var$Ft(o)) return !1;
    const n = t.vars;
    if (typeof n == "function") {
        const s = t.__ref && t.__ref.__varsInline;
        return !!(s && s.has(o));
    }
    if (!$4c62e3475ce4e4e1$var$X(n)) return !1;
    for (const s of Object.keys(n))if (typeof n[s] == "function" && $4c62e3475ce4e4e1$var$co(s) === o) return !0;
    return !1;
}
function $4c62e3475ce4e4e1$var$ne(t) {
    let o = null;
    for(const n in t)t[n] != null && n.charAt(0) !== "&" && (o || (o = new Set), o.add($4c62e3475ce4e4e1$var$Z(n)));
    return o;
}
function $4c62e3475ce4e4e1$var$se(t, o, n, s) {
    const r = t.__ref;
    if (!r) return;
    let i = null;
    if (n) for (const f of n){
        if (s && s.has(f)) continue;
        const c = o[f];
        if (c == null || typeof c == "object") continue;
        const a = $4c62e3475ce4e4e1$var$Z(f);
        (0, $ewXm2.CSS_LONGHAND_SHORTHANDS)[a] && (i || (i = {}), i[a] = c);
    }
    r.__declaredLonghands = i;
}
function $4c62e3475ce4e4e1$var$Io(t, o) {
    const n = t.__ref, s = n && n.__declaredLonghands;
    if (!s || !o) return null;
    let r = null;
    for(const i in s){
        if (o.has(i)) continue;
        const f = (0, $ewXm2.CSS_LONGHAND_SHORTHANDS)[i];
        let c = !1;
        for(let a = 0; a < f.length; a++)if (o.has(f[a])) {
            c = !0;
            break;
        }
        c && (r || (r = {}), r[i] = s[i]);
    }
    return r;
}
function $4c62e3475ce4e4e1$var$Qn(t, o, n, s) {
    const r = t.node, i = $4c62e3475ce4e4e1$var$ne(o), f = i && $4c62e3475ce4e4e1$var$Io(t, i);
    if (n && $4c62e3475ce4e4e1$var$zn(t, s, n, f ? new Set([
        ...i,
        ...Object.keys(f)
    ]) : i), $4c62e3475ce4e4e1$var$Q(r, o, t), !i) return o;
    const c = t.__ref;
    if (c) {
        if (c.__inlineCssKeys) for (const a of i)c.__inlineCssKeys.add(a);
        else c.__inlineCssKeys = new Set(i);
    }
    return f ? ($4c62e3475ce4e4e1$var$Q(r, $4c62e3475ce4e4e1$var$ft(t, f)), Object.assign({}, o, f)) : o;
}
function $4c62e3475ce4e4e1$var$re(t) {
    const o = t.__ref;
    if (!o || !o.__inlineCssKeys || !o.__declaredLonghands) return;
    const n = $4c62e3475ce4e4e1$var$Io(t, o.__inlineCssKeys);
    if (!n) return;
    const s = [];
    if (o.__heldInline) for (const r of o.__heldInline.values())$4c62e3475ce4e4e1$var$St(t.node, r, t) && s.push(r);
    $4c62e3475ce4e4e1$var$Q(t.node, $4c62e3475ce4e4e1$var$ft(t, n));
    for (const r of s)$4c62e3475ce4e4e1$var$Jr(t, r, n);
}
function $4c62e3475ce4e4e1$export$5babfef4e4474017(t, o) {
    return !o || typeof o != "object" ? o : (0, $1H9Q8.withDesignSystem)(t, ()=>{
        try {
            return (0, $lhJVy.resolveStyleBlockTokens)(o, t);
        } catch  {
            return o;
        }
    });
}
const $4c62e3475ce4e4e1$var$Xn = "none", $4c62e3475ce4e4e1$var$$o = (t)=>!!(t && t.__hiddenBy && t.__hiddenBy.size), $4c62e3475ce4e4e1$var$Jn = (t)=>$4c62e3475ce4e4e1$var$Gn(t, "display") === $4c62e3475ce4e4e1$var$Xn && $4c62e3475ce4e4e1$var$Kn(t, "display") === "important";
function $4c62e3475ce4e4e1$var$mn(t, o) {
    o ? t.setProperty("display", o[0], o[1]) : typeof t.removeProperty == "function" ? t.removeProperty("display") : t.display = "";
}
function $4c62e3475ce4e4e1$var$uo(t, o, n, s) {
    const r = t.__ref, i = t.node;
    if (!r || !i || !i.style) return;
    let f = r.__hiddenBy;
    const c = !!(f && f.size);
    n ? (f || (f = r.__hiddenBy = new Set), f.add(o)) : f && f.delete(o);
    const a = i.style;
    f && f.size ? $4c62e3475ce4e4e1$var$Jn(a) || a.setProperty("display", $4c62e3475ce4e4e1$var$Xn, "important") : (c || s && $4c62e3475ce4e4e1$var$Jn(a)) && $4c62e3475ce4e4e1$var$mn(a, r.__shownDisplay || null);
}
function $4c62e3475ce4e4e1$var$It(t, o, n) {
    const s = t.__ref, r = o ? [
        String(o),
        n || ""
    ] : null;
    s && (s.__shownDisplay = r);
    const i = t.node;
    !i || !i.style || $4c62e3475ce4e4e1$var$$o(s) || $4c62e3475ce4e4e1$var$mn(i.style, r);
}
function $4c62e3475ce4e4e1$var$xt(t, o, n) {
    const s = n === "display" && t && t.__ref;
    return $4c62e3475ce4e4e1$var$$o(s) ? s.__shownDisplay ? s.__shownDisplay[0] : "" : $4c62e3475ce4e4e1$var$Gn(o, n);
}
function $4c62e3475ce4e4e1$var$Uo(t, o, n) {
    const s = n === "display" && t && t.__ref;
    return $4c62e3475ce4e4e1$var$$o(s) ? s.__shownDisplay ? s.__shownDisplay[1] : "" : $4c62e3475ce4e4e1$var$Kn(o, n);
}
function $4c62e3475ce4e4e1$var$Q(t, o, n) {
    if (!t || !o || !t.style) return;
    n && (o = $4c62e3475ce4e4e1$var$ft(n, o));
    let s = null;
    for(const r in o){
        const i = o[r];
        if (i != null) {
            if (r.charAt(0) === "&" && typeof i == "object") {
                s || (s = {}), s[r] = i;
                continue;
            }
            try {
                const f = String(i);
                if (typeof i == "object" && f === "[object Object]") continue;
                const c = (0, $ewXm2.cssPropName)(r), a = f.trim(), e = /\s*!important\s*$/.test(a), l = a.replace(/\s*!important\s*$/, "");
                if (n && c === "display") {
                    $4c62e3475ce4e4e1$var$It(n, l, e ? "important" : "");
                    continue;
                }
                t.style.setProperty(c, l, e ? "important" : "");
            } catch  {}
        }
    }
    s && $4c62e3475ce4e4e1$var$ee(t, s);
}
function $4c62e3475ce4e4e1$var$ee(t, o) {
    const n = `_ds${$4c62e3475ce4e4e1$var$hn.scopedStyleId++}`;
    t.classList.add(n);
    const s = t.ownerDocument;
    let r = s.querySelector("style[data-smbls-scoped]");
    r || (r = s.createElement("style"), r.setAttribute("data-smbls-scoped", ""), s.head.appendChild(r));
    let i = "";
    for(const f in o){
        const c = "." + n, a = (0, $9L4Qx.splitSelectorList)(f.replace(/&/g, c)).map((l)=>l.includes(c) ? l : c + l).join(", "), e = o[f];
        if (typeof e == "object") {
            let l = "", d = "";
            for(const u in e){
                const p = e[u];
                if (typeof p == "object") {
                    const g = (0, $9L4Qx.splitSelectorList)(a), h = u.includes("&") ? g.map((y)=>u.replace(/&/g, y)).join(", ") : g.map((y)=>`${y} ${u}`).join(", ");
                    let _ = "";
                    for(const y in p)_ += `${$4c62e3475ce4e4e1$var$Z(y)}: ${p[y]};`;
                    d += (0, $9L4Qx.wrapHoverRule)(`${h} { ${_} }`, h) + `
`;
                } else l += `${$4c62e3475ce4e4e1$var$Z(u)}: ${p};`;
            }
            l && (i += (0, $9L4Qx.wrapHoverRule)(`${a} { ${l} }`, a) + `
`), d && (i += d);
        }
    }
    i && (r.textContent += i);
}
const $4c62e3475ce4e4e1$var$ts = new Set;
function $4c62e3475ce4e4e1$var$os(t) {
    if (!Array.isArray(t)) return "";
    const o = [];
    for(let n = 0; n < t.length; n++)typeof t[n] == "string" && t[n].length && o.push(t[n]);
    return o.sort(), o.join("|");
}
function $4c62e3475ce4e4e1$var$ie(t, o, n) {
    const s = $4c62e3475ce4e4e1$var$os(n);
    queueMicrotask(()=>{
        if (!t.__ref) return;
        let r;
        try {
            r = o(t, t.state, t.context);
        } catch  {
            return;
        }
        if ($4c62e3475ce4e4e1$var$os(r) === s) return;
        const i = t.__ref.path ? t.__ref.path.join(".") : t.key || "?";
        $4c62e3475ce4e4e1$var$ts.has(i) || ($4c62e3475ce4e4e1$var$ts.add(i), console.warn(`[smbls] subscribeTo function at "${i}" resolved to a DIFFERENT key list one microtask after create \u2014 wired [${n.join(", ") || "(none)"}], probed [${Array.isArray(r) ? r.join(", ") : String(r)}]. subscribeTo's function form is resolved ONCE at element-create time (registerSubscribeToEffects, @symbo.ls/element core.js) \u2014 this element stays wired to the ORIGINAL list for its whole lifetime, so this drift is invisible to the reactive effect and any key only present in the new list will never trigger onUpdate. If the watched key genuinely is not known until later (e.g. a module config that loads after shell boot), route the write through an imperative call instead of subscribeTo \u2014 see functions/moduleOpenBridge.js's moduleOpenPage (workspace repo) for the house pattern.`));
    });
}
function $4c62e3475ce4e4e1$var$ce(t) {
    const o = t.subscribeTo, n = typeof o == "function";
    let s = o;
    if (n) try {
        s = o(t, t.state, t.context);
    } catch  {
        s = null;
    }
    if (n && (0, $dSdIt.isLoudDevRuntime)() && $4c62e3475ce4e4e1$var$ie(t, o, Array.isArray(s) ? s : []), !Array.isArray(s) || s.length === 0) return;
    const r = t.__ref;
    for(let i = 0; i < s.length; i++){
        const f = s[i];
        if (typeof f != "string" || f.length === 0) continue;
        const c = f.split("."), a = c[0], e = c.slice(1), l = {
            value: !1
        }, d = (0, $4VQqJ.createEffect)(()=>{
            const u = t.state && ((0, $4VQqJ.isStore)(t.state) ? t.state.root : null);
            if (!u || !(0, $4VQqJ.isStore)(u)) return;
            let p = u;
            p = p[a];
            for(let h = 0; h < e.length && !(p == null || typeof p != "object"); h++)if ((0, $4VQqJ.isStore)(p)) p = p[e[h]];
            else break;
            if (!l.value) return;
            let g = !1;
            if (typeof t.onBeforeUpdate == "function" && (0, $1H9Q8.withDesignSystem)(t, ()=>{
                try {
                    if ($4c62e3475ce4e4e1$export$3afe46815fe1a2cd(r)) {
                        const h = t.onBeforeUpdate(t, t.state, t.context, {
                            updateBySubscription: !0
                        });
                        h && typeof h.then == "function" ? h.then(()=>$4c62e3475ce4e4e1$export$b751efa7c53f55a(r, !1), (_)=>{
                            $4c62e3475ce4e4e1$export$b751efa7c53f55a(r, !0), (0, $jdWhC.dispatchPluginHook)("error", t, {
                                hook: "onBeforeUpdate",
                                error: _
                            }) || console.error("[DOMQL] subscribeTo onBeforeUpdate error:", _);
                        }) : ($4c62e3475ce4e4e1$export$b751efa7c53f55a(r, !1), h === !1 && (g = !0));
                    }
                } catch (h) {
                    $4c62e3475ce4e4e1$export$b751efa7c53f55a(r, !0), (0, $jdWhC.dispatchPluginHook)("error", t, {
                        hook: "onBeforeUpdate",
                        error: h
                    }) || console.error("[DOMQL] subscribeTo onBeforeUpdate error:", h);
                }
            }), !g && t.node && r.__effects) for(let h = 0; h < r.__effects.length; h++){
                const _ = r.__effects[h];
                _ && _ !== d && !_._disposed && !_._isSubscribeToEffect && typeof _._execute == "function" && _._execute();
            }
            !g && typeof t.onUpdate == "function" && (0, $1H9Q8.withDesignSystem)(t, ()=>{
                try {
                    t.onUpdate(t, t.state, t.context);
                } catch (h) {
                    (0, $jdWhC.dispatchPluginHook)("error", t, {
                        hook: "onUpdate",
                        error: h
                    }) || console.error("[DOMQL] subscribeTo onUpdate error:", h);
                }
            });
        }, {
            depth: r.path.length,
            label: $4c62e3475ce4e4e1$var$E(r, "subscribeTo(" + f + ")")
        });
        l.value = !0, d._isSubscribeToEffect = !0, r.__effects.push(d);
    }
}
function $4c62e3475ce4e4e1$var$Bo(t, o) {
    return t.charCodeAt(0) === 64 && t.length > 1 && !t.startsWith("@media") && !t.startsWith("@keyframes") && !t.startsWith("@supports") && !t.startsWith("@container") && (t === "@dark" || t === "@light" || !o.context?.designSystem?.media?.[t.slice(1)]);
}
function $4c62e3475ce4e4e1$var$Vo(t, o) {
    if (t.charCodeAt(0) !== 64 || /^@(media|supports|container|keyframes)\b/.test(t)) return t;
    const n = o.context?.designSystem?.media?.[t.slice(1)];
    if (!n) return t;
    if (typeof n == "string" && !/^@(supports|container)\b/.test(n)) {
        const s = $4c62e3475ce4e4e1$var$rs(o);
        if (s) {
            const r = (0, $9aRcW.containerBreakpointQuery)(n);
            if (r) return `@container ${s} ${r}`;
        }
    }
    return /^@(media|supports|container)\b/.test(n) ? n : `@media ${n}`;
}
function $4c62e3475ce4e4e1$var$Ho(t, o, n, s, r) {
    const i = r || $4c62e3475ce4e4e1$var$ae(t);
    return (0, $5koEk.isForcedColorsQuery)(t) ? (0, $5koEk.inForcedColors)(()=>$4c62e3475ce4e4e1$var$Bt(o, n, !1, s, i)) : $4c62e3475ce4e4e1$var$Bt(o, n, !1, s, i);
}
const $4c62e3475ce4e4e1$var$fe = /(::[a-z-]+(?:\([^()]*\))?|:(?:before|after|first-line|first-letter))(?::[a-z-]+(?:\([^()]*\))?)*\s*$/i;
function $4c62e3475ce4e4e1$var$ae(t) {
    if (typeof t != "string" || t.charCodeAt(0) === 64) return null;
    const o = t.match($4c62e3475ce4e4e1$var$fe);
    return o ? o[1] : null;
}
const $4c62e3475ce4e4e1$var$ue = /^::(?:-webkit-scrollbar|part\()/i, $4c62e3475ce4e4e1$var$le = /^(?::[a-z-]+(?:\([^()]*\))?)+$/i;
function $4c62e3475ce4e4e1$var$de(t) {
    const o = [];
    let n = 0, s = 0;
    for(let r = 0; r < t.length; r++){
        const i = t.charCodeAt(r);
        i === 40 ? n++ : i === 41 ? n-- : i === 44 && n === 0 && (o.push(t.slice(s, r)), s = r + 1);
    }
    return o.push(t.slice(s)), o;
}
function $4c62e3475ce4e4e1$var$ns(t, o) {
    if (t.charCodeAt(0) === 64) return !0;
    const n = $4c62e3475ce4e4e1$var$ue.test(o);
    for (const s of $4c62e3475ce4e4e1$var$de(t)){
        const r = s.trim(), i = r.lastIndexOf("&"), f = i === -1 ? r : r.slice(i + 1);
        if (!(i !== -1 && f === "") && !(n && $4c62e3475ce4e4e1$var$le.test(f))) return !1;
    }
    return !0;
}
function $4c62e3475ce4e4e1$var$ss(t, o) {
    let n = null;
    for(const s in t){
        const r = t[s];
        if (!$4c62e3475ce4e4e1$var$X(r)) continue;
        const i = $4c62e3475ce4e4e1$var$ns(s, o) ? $4c62e3475ce4e4e1$var$ss(r, o) : void 0;
        i !== r && (n || (n = {
            ...t
        }), i === void 0 ? delete n[s] : n[s] = i);
    }
    return n || t;
}
function $4c62e3475ce4e4e1$var$rs(t) {
    const o = t.__ref;
    if (o && o.__breakpointContainer !== void 0) return o.__breakpointContainer;
    let n = null;
    for(let s = t.parent; s && typeof s == "object"; s = s.parent){
        const r = s.breakpointsFrom;
        if (r != null && r !== !1) {
            n = (0, $9aRcW.breakpointsContainerName)(r, s);
            break;
        }
    }
    return o && (o.__breakpointContainer = n), n;
}
function $4c62e3475ce4e4e1$var$ft(t, o) {
    const n = (0, $8NJs1.FEATURES).containerVw;
    return n !== null && n.on && o && $4c62e3475ce4e4e1$var$rs(t) ? n.lengths(o) : o;
}
function $4c62e3475ce4e4e1$var$pe(t, o) {
    return (0, $8NJs1.FEATURES).containerVw !== null && (0, $8NJs1.FEATURES).containerVw.scope(t, o);
}
const $4c62e3475ce4e4e1$var$es = new Set;
function $4c62e3475ce4e4e1$var$he(t, o) {
    const n = o?.__ref?.path ? o.__ref.path.join(".") : o?.key || "?", s = n + "::" + t;
    $4c62e3475ce4e4e1$var$es.has(s) || ($4c62e3475ce4e4e1$var$es.add(s), console.warn(`[smbls/css] "${t}" at ${n} is a CHILD-COMPONENT key nested inside a pseudo/selector block (":hover", "@dark", etc.) \u2014 that is never a valid CSS selector fragment. The rule is DROPPED (not shipped as a dead/never-matching selector). To reveal a child on a parent state, target the child's OWN class from the parent selector instead, e.g. move the declaration onto the child element itself, or use a sibling-selector combinator in a top-level style block.`));
}
const $4c62e3475ce4e4e1$var$is = new Map;
function $4c62e3475ce4e4e1$var$_e(t) {
    let o = $4c62e3475ce4e4e1$var$is.get(t);
    if (o) return o;
    o = [];
    const n = (s)=>{
        if (s) for (const r of s)o.push((0, $ewXm2.cssCamelName)(r));
    };
    return n((0, $ewXm2.CSS_LONGHAND_SHORTHANDS)[t]), n((0, $ewXm2.CSS_SHORTHAND_LONGHANDS)[t]), $4c62e3475ce4e4e1$var$is.set(t, o), o;
}
function $4c62e3475ce4e4e1$var$$t(t, o, n) {
    return $4c62e3475ce4e4e1$var$oe(t, o) || !!(n && n.has(o));
}
let $4c62e3475ce4e4e1$var$Ut = null;
function $4c62e3475ce4e4e1$var$ye(t) {
    if (!$4c62e3475ce4e4e1$var$Ut) {
        $4c62e3475ce4e4e1$var$Ut = new Map;
        const o = $kaMEs.CSS_PROP_WRITES;
        if (o) {
            for (const n of Object.keys(o))if (!(n === "hide" || n === "show")) for (const s of o[n]){
                if (s === n) continue;
                let r = $4c62e3475ce4e4e1$var$Ut.get(s);
                r || $4c62e3475ce4e4e1$var$Ut.set(s, r = []), r.push(n);
            }
        }
    }
    return $4c62e3475ce4e4e1$var$Ut.get(t);
}
function $4c62e3475ce4e4e1$var$cs(t, o, n) {
    if ($4c62e3475ce4e4e1$var$$t(t, o, n)) return !0;
    const s = $4c62e3475ce4e4e1$var$ye(o);
    if (s) {
        for(let r = 0; r < s.length; r++)if ($4c62e3475ce4e4e1$var$$t(t, s[r], n)) return !0;
    }
    return !1;
}
function $4c62e3475ce4e4e1$var$ge(t, o, n) {
    if ($4c62e3475ce4e4e1$var$cs(t, o, n)) return !0;
    const s = $4c62e3475ce4e4e1$var$_e($4c62e3475ce4e4e1$var$Z(o));
    for(let r = 0; r < s.length; r++)if ($4c62e3475ce4e4e1$var$cs(t, s[r], n)) return !0;
    return !1;
}
function $4c62e3475ce4e4e1$var$Bt(t, o, n, s, r) {
    const i = {}, f = new Set, c = (e, l, d)=>{
        if (r && $4c62e3475ce4e4e1$var$X(l)) {
            if (!$4c62e3475ce4e4e1$var$ns(e, r)) return;
            l = $4c62e3475ce4e4e1$var$ss(l, r);
        }
        const u = !Object.prototype.hasOwnProperty.call(i, e);
        i[e] = l, u && (d || $4c62e3475ce4e4e1$var$ge(o, e, s)) && f.add(e);
    }, a = (e, l, d)=>{
        if ((0, $fe4kH.CSS_PROPS_REGISTRY)[e]) {
            const u = (0, $fe4kH.CSS_PROPS_REGISTRY)[e](l, o, o.state, o.context);
            if (u) {
                const p = Array.isArray(u) ? u : [
                    u
                ];
                for (const g of p)if (g) for (const h of Object.keys(g))c(h, g[h], d);
            }
        } else c(e, l, d);
    };
    for(const e in t){
        if (!Object.prototype.hasOwnProperty.call(t, e)) continue;
        let l = t[e];
        if (typeof l == "function" && (l = l(o, o.state, o.context)), !(l == null || typeof l == "function")) {
            if (typeof l == "object" && !Array.isArray(l)) {
                if (e === "style") {
                    for(const p in l){
                        let g = l[p];
                        typeof g == "function" && (g = g(o, o.state, o.context)), !(g == null || typeof g == "function") && a(p, g, $4c62e3475ce4e4e1$var$$t(o, p, s));
                    }
                    continue;
                }
                if (e === "vars") {
                    const p = $4c62e3475ce4e4e1$var$fo(l, o);
                    if (p) for(const g in p)a(g, p[g], $4c62e3475ce4e4e1$var$$t(o, g, s));
                    continue;
                }
                if ($4c62e3475ce4e4e1$var$Bo(e, o)) {
                    const p = $4c62e3475ce4e4e1$var$Bt(l, o, !1, s, r);
                    Object.keys(p).length && (i[`[data-theme="${e.slice(1)}"] &`] = p);
                    continue;
                }
                if (/^[A-Z][A-Za-z0-9]*$/.test(e)) {
                    (0, $dSdIt.isLoudDevRuntime)() && $4c62e3475ce4e4e1$var$he(e, o);
                    continue;
                }
                const d = $4c62e3475ce4e4e1$var$Vo(e, o), u = $4c62e3475ce4e4e1$var$Ho(d, l, o, s, r);
                Object.keys(u).length && (i[d] = u);
                continue;
            }
            a(e, l, $4c62e3475ce4e4e1$var$$t(o, e, s));
        }
    }
    if (n) for(const e in i)f.add(e);
    for (const e of f){
        const l = i[e];
        typeof l == "string" && !l.includes("!important") && (i[e] = l + " !important");
    }
    return i;
}
const $4c62e3475ce4e4e1$var$X = (t)=>!!t && typeof t == "object" && !Array.isArray(t);
function $4c62e3475ce4e4e1$var$fs(t, o) {
    for(const n in o){
        const s = o[n];
        t[n] = $4c62e3475ce4e4e1$var$X(s) ? $4c62e3475ce4e4e1$var$fs($4c62e3475ce4e4e1$var$X(t[n]) ? t[n] : {}, s) : s;
    }
    return t;
}
function $4c62e3475ce4e4e1$var$be(t, o) {
    if (!$4c62e3475ce4e4e1$var$X(o)) return;
    let n;
    for (const s of t.split(" ")){
        const r = s ? o[s] : null;
        $4c62e3475ce4e4e1$var$X(r) && (n = $4c62e3475ce4e4e1$var$fs(n || {}, r));
    }
    return n;
}
function $4c62e3475ce4e4e1$var$Wo(t, o) {
    if (o === void 0 && (o = 0), o > 8) return !1;
    if (typeof t == "function") return !0;
    if (t && typeof t == "object" && !Array.isArray(t)) {
        for(const n in t)if (Object.prototype.hasOwnProperty.call(t, n) && $4c62e3475ce4e4e1$var$Wo(t[n], o + 1)) return !0;
    }
    return !1;
}
function $4c62e3475ce4e4e1$var$as(t, o, n) {
    if (!o || typeof o != "object" || Array.isArray(o)) return null;
    if ($4c62e3475ce4e4e1$var$Bo(t, n)) {
        const i = $4c62e3475ce4e4e1$var$Bt(o, n, !1);
        return Object.keys(i).length ? {
            cssProp: `[data-theme="${t.slice(1)}"] &`,
            block: i
        } : null;
    }
    const s = $4c62e3475ce4e4e1$var$Vo(t, n), r = $4c62e3475ce4e4e1$var$Ho(s, o, n);
    return Object.keys(r).length ? {
        cssProp: s,
        block: r
    } : null;
}
function $4c62e3475ce4e4e1$var$Ae(t) {
    const o = t.__ref;
    for (const n of Object.keys(t)){
        if (!$4c62e3475ce4e4e1$var$wn(n)) continue;
        const s = t[n];
        if (!s || typeof s != "object" || Array.isArray(s) || !$4c62e3475ce4e4e1$var$Wo(s)) continue;
        let r = null, i;
        const f = (0, $4VQqJ.createEffect)(()=>{
            if (!t.node) return;
            const c = t.context?.designSystem;
            c && (0, $521xJ.pushConfig)(c);
            let a, e = !1;
            try {
                const l = $4c62e3475ce4e4e1$var$as(n, s, t), d = l ? $4c62e3475ce4e4e1$var$wt(l.block) + "::" + l.cssProp : null;
                if (d !== null && d === i) e = !0;
                else if (i = d, l) {
                    const u = (0, $9L4Qx.css)($4c62e3475ce4e4e1$var$ft(t, {
                        [l.cssProp]: l.block
                    }), null, t.context?.cssPrefix);
                    a = u ? u.split(" ").filter(Boolean) : null;
                } else a = null;
            } finally{
                c && (0, $521xJ.popConfig)();
            }
            if (!(e || !t.node.classList)) {
                if (r) for (const l of r)t.node.classList.remove(l);
                if (a && a.length) for (const l of a)t.node.classList.add(l);
                r = a;
            }
        }, {
            depth: o.path.length,
            label: $4c62e3475ce4e4e1$var$E(o, "cssBlock(" + n + ")")
        });
        o.__effects.push(f);
    }
}
const $4c62e3475ce4e4e1$var$we = ()=>!0, $4c62e3475ce4e4e1$var$Se = (t, o)=>{
    const n = t.charAt(0);
    return (n === ":" || n === "@" || n === "&" || n === "[") && o && typeof o == "object" && !Array.isArray(o) ? !0 : !!(0, $fe4kH.CSS_PROPS_REGISTRY)[t] || !!((0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST) && (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(t)) || $4c62e3475ce4e4e1$var$Ft(t) || t === "vars";
};
function $4c62e3475ce4e4e1$var$xe(t, o, n) {
    const s = {};
    let r = !1;
    for(const c in n)Object.prototype.hasOwnProperty.call(n, c) && (c !== "data" && c !== "aria" && ($4c62e3475ce4e4e1$var$Se(c, n[c]) || (0, $aBPRx.REGISTRY).has(c)) ? s[c] = !0 : r = !0);
    if (!r) return null;
    const i = (0, $gBDdH.extractConditionalAttrs)({
        [o]: n
    }, t.tag || "div", s, $4c62e3475ce4e4e1$var$we);
    let f = null;
    for(const c in i)/^on/i.test(c) || (f || (f = {}), f[c] = i[c]);
    return f;
}
function $4c62e3475ce4e4e1$var$us(t, o, n, s, r, i) {
    const f = t.node;
    let c = null;
    const a = (e)=>{
        (c || (c = [])).push(e);
    };
    for(const e in s){
        const l = o.owners.get(e), d = l === n;
        if (!i && l !== void 0 && !d) continue;
        let u;
        try {
            u = s[e](t);
        } catch (g) {
            $4c62e3475ce4e4e1$var$F(t.__ref, "conditional(" + n + ")." + e, g), d && a(e);
            continue;
        }
        if (typeof u == "string" && u.includes("{{") && (u = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, u, t.state)), d && f.getAttribute(e) !== o.written.get(e)) {
            a(e);
            continue;
        }
        if (u == null || typeof u == "object" || typeof u == "function") {
            d && $4c62e3475ce4e4e1$var$ls(f, o, e);
            continue;
        }
        const p = u === !1 && !(0, $gBDdH.isEnumeratedTrueFalseAttr)(e) ? null : String((0, $gBDdH.serializeAttrValue)(e, u));
        a(e), !(d && p === o.written.get(e)) && (l === void 0 && o.base.set(e, f.getAttribute(e)), $4c62e3475ce4e4e1$var$eo(f, e, p), o.owners.set(e, n), o.written.set(e, p));
    }
    r.appliedAttrs = c;
}
function $4c62e3475ce4e4e1$var$ls(t, o, n) {
    t.getAttribute(n) === o.written.get(n) && $4c62e3475ce4e4e1$var$eo(t, n, o.base.get(n)), o.owners.delete(n), o.base.delete(n), o.written.delete(n);
}
function $4c62e3475ce4e4e1$var$Ce(t, o, n, s) {
    const r = s.appliedAttrs;
    if (s.appliedAttrs = null, !!r) for (const i of r)o.owners.get(i) === n && $4c62e3475ce4e4e1$var$ls(t.node, o, i);
}
function $4c62e3475ce4e4e1$var$ds(t) {
    const o = t.__ref && t.__ref.__conditionalAttrs, n = t.node;
    if (!(!o || !o.owners.size || !n || !n.getAttribute)) for (const s of o.owners.keys()){
        const r = o.written.get(s), i = n.getAttribute(s);
        i !== r && (o.base.set(s, i), r == null ? n.removeAttribute(s) : n.setAttribute(s, r));
    }
}
let $4c62e3475ce4e4e1$var$Go;
const $4c62e3475ce4e4e1$var$ke = ()=>$4c62e3475ce4e4e1$var$Go === void 0 ? $4c62e3475ce4e4e1$var$Go = (0, $dSdIt.isLoudDevRuntime)() : $4c62e3475ce4e4e1$var$Go;
function $4c62e3475ce4e4e1$var$ps(t, o) {
    const n = $4VQqJ.countUntrackedReads;
    typeof n == "function" ? t.untrackedReads += n(o) : o();
}
function $4c62e3475ce4e4e1$var$ve(t) {
    const o = t.__ref;
    o.__conditionalRunners = [];
    let n = null;
    const s = new Map;
    for (const r of Object.keys(t)){
        const i = r.charAt(0);
        if (i !== "." && i !== "!") continue;
        const f = r.slice(1);
        if (!f) continue;
        if (/[:@\s>~+[\]]/.test(f)) {
            if (typeof console < "u" && console.warn) {
                const _ = f.split(/[:@\s>~+[\]]/)[0];
            }
            continue;
        }
        const c = t[r];
        if (!c || typeof c != "object") continue;
        const a = i === "!", e = {
            lastMatch: !1,
            appliedKeys: null,
            appliedClasses: null,
            appliedAttrs: null,
            hides: !1,
            probe: !1,
            untrackedReads: 0
        }, l = $4c62e3475ce4e4e1$var$xe(t, r, c);
        l && !n && (n = o.__conditionalAttrs = {
            owners: new Map,
            base: new Map,
            written: new Map
        });
        const d = new Set;
        for(const _ in c){
            if (!Object.prototype.hasOwnProperty.call(c, _)) continue;
            const y = _.charAt(0), w = c[_];
            if (!((y === ":" || y === "@" || y === "&" || y === "[") && w && typeof w == "object" && !Array.isArray(w))) {
                if (_ === "vars" && $4c62e3475ce4e4e1$var$X(w)) {
                    for (const x of Object.keys(w))x && d.add($4c62e3475ce4e4e1$var$co(x));
                    continue;
                }
                d.add(_);
            }
        }
        const u = ()=>{
            let _;
            const y = e.probe;
            let w;
            if (y ? $4c62e3475ce4e4e1$var$ps(e, ()=>{
                w = t[f];
            }) : w = t[f], w === void 0) {
                const b = !!t.state && f in t.state, A = t.state ? t.state[f] : void 0;
                if (b || A !== void 0) _ = A;
                else {
                    const S = t.context?.cases?.[f];
                    if (S === void 0) return;
                    try {
                        _ = typeof S == "function" ? S.call(t, t) : S;
                    } catch (C) {
                        _ = !1, o.__conditionalError = C, typeof console < "u" && console.warn && console.warn(`[smbls] conditional \`${r}\` case fn threw on ${t.key || "?"} \u2014 treating as false:`, C?.message || C);
                    }
                }
            } else if (typeof w == "function") try {
                y ? $4c62e3475ce4e4e1$var$ps(e, ()=>{
                    _ = w(t, t.state, t.context);
                }) : _ = w(t, t.state, t.context);
            } catch (b) {
                _ = !1, o.__conditionalError = b, typeof console < "u" && console.warn && console.warn(`[smbls] conditional \`${r}\` predicate threw on ${t.key || "?"} \u2014 treating as false:`, b?.message || b);
            }
            else _ = w;
            y && (e.probe = !1);
            const x = a ? !_ : !!_;
            if (!t.node) return;
            const k = t.context?.designSystem;
            if (x === e.lastMatch) {
                if (x && l && t.node.setAttribute) {
                    k && (0, $521xJ.pushConfig)(k);
                    try {
                        $4c62e3475ce4e4e1$var$us(t, n, r, l, e, !1);
                    } finally{
                        k && (0, $521xJ.popConfig)();
                    }
                }
                return;
            }
            e.lastMatch = x, k && (0, $521xJ.pushConfig)(k);
            try {
                if (x) {
                    const b = {}, A = {};
                    let S = !1, C = !1;
                    for(const v in c){
                        if (!Object.prototype.hasOwnProperty.call(c, v)) continue;
                        const P = c[v], V = v.charAt(0);
                        if ((V === ":" || V === "@" || V === "&" || V === "[") && P && typeof P == "object" && !Array.isArray(P)) {
                            if ($4c62e3475ce4e4e1$var$Bo(v, t)) {
                                const N = $4c62e3475ce4e4e1$var$Bt(P, t, !1, d);
                                Object.keys(N).length && (A[`[data-theme="${v.slice(1)}"] &`] = N, S = !0);
                            } else {
                                const N = $4c62e3475ce4e4e1$var$Vo(v, t), dt = $4c62e3475ce4e4e1$var$Ho(N, P, t, d);
                                Object.keys(dt).length && (A[N] = dt, S = !0);
                            }
                            continue;
                        }
                        const z = typeof P == "function" ? P(t, t.state, t.context) : P;
                        if (z != null) {
                            if (v === "hide" || v === "show") {
                                const N = (0, $fe4kH.CSS_PROPS_REGISTRY)[v](z, t, t.state, t.context);
                                N && N.display && (C = !0);
                            } else if ((0, $fe4kH.CSS_PROPS_REGISTRY)[v]) {
                                const N = (0, $fe4kH.CSS_PROPS_REGISTRY)[v](z, t, t.state, t.context);
                                if (N) {
                                    const dt = Array.isArray(N) ? N : [
                                        N
                                    ];
                                    for (const _o of dt)_o && Object.assign(b, _o);
                                }
                            } else if ((0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST) && (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(v)) b[v] = z;
                            else if ($4c62e3475ce4e4e1$var$Ft(v)) b[v] = z;
                            else if (v === "vars") {
                                const N = $4c62e3475ce4e4e1$var$fo(z, t);
                                N && Object.assign(b, N);
                            }
                        }
                    }
                    (C || e.hides) && (e.hides = C, $4c62e3475ce4e4e1$var$uo(t, r, C));
                    const T = Object.keys(b);
                    if (T.length) {
                        $4c62e3475ce4e4e1$var$Q(t.node, b, t);
                        for (const v of T){
                            let P = s.get(v);
                            P || (P = [], s.set(v, P));
                            const V = P.findIndex((z)=>z.key === r);
                            V !== -1 && P.splice(V, 1), P.push({
                                key: r,
                                value: b[v]
                            });
                        }
                        e.appliedKeys = T;
                    } else e.appliedKeys = null;
                    if (S) {
                        const v = (0, $9L4Qx.css)($4c62e3475ce4e4e1$var$ft(t, A), null, t.context?.cssPrefix, {
                            state: !0
                        }), P = v ? v.split(" ").filter(Boolean) : [];
                        if (P.length && t.node.classList) {
                            for (const V of P)t.node.classList.add(V);
                            e.appliedClasses = P;
                        } else e.appliedClasses = null;
                    } else if (e.appliedClasses) {
                        for (const v of e.appliedClasses)t.node.classList.remove(v);
                        e.appliedClasses = null;
                    }
                    l && t.node.setAttribute && $4c62e3475ce4e4e1$var$us(t, n, r, l, e, !0);
                } else {
                    if (e.appliedAttrs && $4c62e3475ce4e4e1$var$Ce(t, n, r, e), e.appliedKeys) {
                        for (const b of e.appliedKeys){
                            const A = s.get(b);
                            if (!A) continue;
                            const S = A.findIndex((C)=>C.key === r);
                            if (S !== -1) {
                                if (A.splice(S, 1), A.length) {
                                    const C = A[A.length - 1].value, T = (0, $ewXm2.cssPropName)(b), v = String(C).trim().replace(/\s*!important\s*$/, "");
                                    $4c62e3475ce4e4e1$var$xt(t, t.node.style, T) !== v && $4c62e3475ce4e4e1$var$Q(t.node, {
                                        [b]: C
                                    }, t);
                                } else s.delete(b), $4c62e3475ce4e4e1$var$Ft(b) ? t.node.style.removeProperty(b) : (0, $ewXm2.cssPropName)(b) === "display" ? $4c62e3475ce4e4e1$var$It(t, "") : t.node.style[b] = "";
                            }
                        }
                        e.appliedKeys = null;
                    }
                    if (e.hides && (e.hides = !1, $4c62e3475ce4e4e1$var$uo(t, r, !1)), e.appliedClasses) {
                        for (const b of e.appliedClasses)t.node.classList.remove(b);
                        e.appliedClasses = null;
                    }
                }
            } finally{
                k && (0, $521xJ.popConfig)();
            }
        };
        o.__conditionalRunners.push(u);
        const p = t[f + "Deps"], g = $4c62e3475ce4e4e1$var$L(t, p, u);
        $4c62e3475ce4e4e1$var$ke() && typeof (o.__exec && o.__exec[f] || t[f]) == "function" && !(Array.isArray(p) && p.length === 0) && (e.probe = !0);
        const h = (0, $4VQqJ.createEffect)(g, {
            depth: o.path.length,
            label: $4c62e3475ce4e4e1$var$E(o, "conditional(" + r + ")")
        });
        e.probe && (e.probe = !1), e.untrackedReads > 0 && h._sources.size, o.__effects.push(h);
    }
}
const $4c62e3475ce4e4e1$var$Ko = new WeakSet, $4c62e3475ce4e4e1$var$zo = new WeakMap;
function $4c62e3475ce4e4e1$var$Pe(t) {
    const o = $4c62e3475ce4e4e1$var$zo.get(t);
    if (o === "painted") return !1;
    if (o === void 0) {
        $4c62e3475ce4e4e1$var$zo.set(t, "open");
        const n = t.defaultView, s = ()=>{
            $4c62e3475ce4e4e1$var$zo.set(t, "painted");
        };
        n && typeof n.requestAnimationFrame == "function" ? n.requestAnimationFrame(s) : setTimeout(s, 0);
    }
    return !0;
}
const $4c62e3475ce4e4e1$var$Yo = new WeakSet;
function $4c62e3475ce4e4e1$var$Te(t) {
    if ($4c62e3475ce4e4e1$var$Yo.has(t)) return;
    $4c62e3475ce4e4e1$var$Yo.add(t);
    const o = ()=>{
        $4c62e3475ce4e4e1$var$Yo.delete(t);
        const s = t.body || t.documentElement;
        s && s.offsetWidth;
    }, n = t.defaultView;
    n && typeof n.requestAnimationFrame == "function" ? n.requestAnimationFrame(o) : setTimeout(o, 0);
}
function $4c62e3475ce4e4e1$var$Ee(t, o) {
    const n = t.ownerDocument;
    if (n && !$4c62e3475ce4e4e1$var$Pe(n)) {
        if ((0, $8NJs1.FEATURES).hydration !== null && o && o.context && o.context.__hydration) {
            $4c62e3475ce4e4e1$var$Te(n);
            return;
        }
        $4c62e3475ce4e4e1$var$Ko.has(n) || ($4c62e3475ce4e4e1$var$Ko.add(n), queueMicrotask(()=>{
            $4c62e3475ce4e4e1$var$Ko.delete(n);
            const s = n.body || n.documentElement;
            s && s.offsetWidth;
        }));
    }
}
const $4c62e3475ce4e4e1$var$qo = new WeakSet;
let $4c62e3475ce4e4e1$var$hs = !1;
function $4c62e3475ce4e4e1$var$_s(t) {
    return t.startsWith("[data-theme=") || t.startsWith("[data-skin=") || t.startsWith("@media") && (t.includes("prefers-color-scheme") || t.includes("prefers-reduced-transparency"));
}
function $4c62e3475ce4e4e1$var$Zo(t, o) {
    const n = {
        ...t
    };
    for(const s in o){
        const r = o[s], i = n[s];
        n[s] = r && typeof r == "object" && i && typeof i == "object" ? $4c62e3475ce4e4e1$var$Zo(i, r) : r;
    }
    return n;
}
function $4c62e3475ce4e4e1$var$ys(t, o) {
    const n = {};
    for(const s in t){
        const r = t[s];
        if (r && typeof r == "object") {
            const i = $4c62e3475ce4e4e1$var$ys(r, o);
            Object.keys(i).length && (n[s] = i);
        } else o(s) || (n[s] = r);
    }
    return n;
}
function $4c62e3475ce4e4e1$var$gs(t, o, n) {
    const s = $4c62e3475ce4e4e1$var$Qo(t);
    if (!s) return !1;
    for(let r = 0; r < s.length; r += 3){
        const i = s[r + 1];
        if (!n.has(i)) continue;
        const f = o[i];
        if (!(f == null || typeof f == "object") && (0, $ewXm2.cssShorthandStatesThemeLonghand)(s[r], f, s[r + 2])) return !0;
    }
    return !1;
}
function $4c62e3475ce4e4e1$var$je(t, o, n) {
    let s = 1 / 0, r = -1 / 0;
    for (const f of o.values())f < s && (s = f), f > r && (r = f);
    if (n) for (const f of n.values())f > r && (r = f);
    if (r <= s) return null;
    let i = null;
    for (const [f, c] of o){
        if (c === r) continue;
        const a = $4c62e3475ce4e4e1$var$Qo(f);
        if (a) for(let e = 0; e < a.length; e += 3){
            const l = a[e], d = a[e + 1], u = a[e + 2], p = t[d] != null ? o.get(d) : void 0, g = n && n.get(l), h = p !== void 0 && p > c && (0, $ewXm2.cssShorthandStatesLonghand)(l, t[d], u), _ = !h && g !== void 0 && g > c && (0, $ewXm2.cssShorthandStatesLonghand)(l, void 0, u);
            if (h || _) {
                h && delete t[f], i || (i = new Set), i.add(f);
                break;
            }
        }
    }
    return i;
}
const $4c62e3475ce4e4e1$var$bs = new Map;
function $4c62e3475ce4e4e1$var$Qo(t) {
    let o = $4c62e3475ce4e4e1$var$bs.get(t);
    if (o !== void 0) return o;
    const n = $4c62e3475ce4e4e1$var$Z(t), s = (0, $ewXm2.CSS_LONGHAND_SHORTHANDS)[n];
    if (o = null, Array.isArray(s)) {
        o = [];
        for (const r of s)o.push(r, (0, $ewXm2.cssCamelName)(r), n);
    }
    return $4c62e3475ce4e4e1$var$bs.set(t, o), o;
}
const $4c62e3475ce4e4e1$var$As = new Set([
    "page",
    "zoom"
]), $4c62e3475ce4e4e1$var$Oe = (t, o)=>{
    $4c62e3475ce4e4e1$var$As.add(t);
    const n = typeof CSS < "u" ? CSS : null;
    if (!n || typeof n.supports != "function") return;
    let s = !1;
    try {
        s = n.supports($4c62e3475ce4e4e1$var$Z(t), String(o));
    } catch  {
        s = !1;
    }
    s && console.warn(`[smbls] css: "${t}: ${o}" is valid CSS, but smbls has no entry for "${t}", so the element gets no CSS for it. Write it in style: { ${t}: \u2026 } for now, and report the missing property.`);
};
function $4c62e3475ce4e4e1$var$ws(t) {
    const { node: o } = t;
    if (!o) return;
    if ($4c62e3475ce4e4e1$var$hs || ($4c62e3475ce4e4e1$var$hs = !0, (0, $9L4Qx.css)({
        display: "none"
    })), $4c62e3475ce4e4e1$var$qo.has(t)) {
        console.error("[applyCssInProps] re-entry detected for element", t.key, "prop path:", t.__ref?.path);
        return;
    }
    $4c62e3475ce4e4e1$var$qo.add(t);
    const n = t.context?.designSystem;
    n && (0, $521xJ.pushConfig)(n), (0, $j2Odm.pushStaticCssPass)();
    try {
        const s = {};
        let r = !1, i = [], f = null, c = null, a = null, e = null;
        const l = t.__ref && t.__ref.__mergeLayer;
        let d, u = null, p = null, g = !1;
        const h = (b, A)=>{
            if (A && typeof A == "object" && $4c62e3475ce4e4e1$var$_s(b)) {
                a || (a = {});
                const S = a[b];
                S && (A = $4c62e3475ce4e4e1$var$Zo(S, A)), a[b] = A;
            } else (A === null || typeof A != "object") && (e || (e = new Set), e.add(b), d !== void 0 && (u || (u = new Map), u.set(b, d)));
            s[b] = A;
        };
        if (Object.prototype.hasOwnProperty.call(t, "theme") && typeof t.theme != "function" && (0, $fe4kH.CSS_PROPS_REGISTRY).theme) {
            const b = (0, $fe4kH.CSS_PROPS_REGISTRY).theme(t.theme, t, t.state, t.context);
            if (b) {
                const A = (S)=>{
                    for(const C in S){
                        const T = S[C];
                        T && typeof T == "object" ? $4c62e3475ce4e4e1$var$_s(C) && (f || (f = {}), f[C] = T) : $4c62e3475ce4e4e1$var$Qo(C) && (c || (c = [])).push(C), s[C] = T;
                    }
                };
                if (Array.isArray(b)) for (const S of b)S && A(S);
                else A(b);
                r = !0;
            }
        }
        const _ = (b, A)=>{
            if (b === "vars") {
                const S = $4c62e3475ce4e4e1$var$fo(A);
                if (S) {
                    for(const C in S)h(C, S[C]);
                    r = !0;
                }
                return;
            }
            if (b === "hide" || b === "show") {
                const S = (0, $fe4kH.CSS_PROPS_REGISTRY)[b](A, t, t.state, t.context);
                S && S.display && (g = !0);
                return;
            }
            if ((0, $fe4kH.CSS_PROPS_REGISTRY)[b]) {
                const S = (0, $fe4kH.CSS_PROPS_REGISTRY)[b](A, t, t.state, t.context);
                if (S) {
                    if (Array.isArray(S)) {
                        for (const C of S)if (C) for(const T in C)h(T, C[T]);
                    } else for(const C in S)h(C, S[C]);
                    r = !0;
                }
            } else if ((0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST) && (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(b)) A != null && typeof A != "object" && (h(b, A), r = !0);
            else if (b.charCodeAt(0) === 45) A != null && typeof A != "object" && (h(b, A), r = !0);
            else if (b.charAt(0) === "&" || b.charAt(0) === "@" || b.charAt(0) === ":" || b.charAt(0) === "[") {
                if (A && typeof A == "object" && !Array.isArray(A)) {
                    if ($4c62e3475ce4e4e1$var$Wo(A)) return;
                    const S = $4c62e3475ce4e4e1$var$as(b, A, t);
                    S && (h(S.cssProp, S.block), r = !0);
                }
            } else (typeof A == "string" || typeof A == "number") && !$4c62e3475ce4e4e1$var$As.has(b) && (0, $dSdIt.isLoudDevRuntime)() && !(0, $gBDdH.checkAttributeByTagName)(t.tag || "div", b) && $4c62e3475ce4e4e1$var$Oe(b, A);
        };
        if (typeof t.class == "string") {
            const b = $4c62e3475ce4e4e1$var$be(t.class, t.context?.designSystem?.class);
            if (b) for(const A in b)_(A, b[A]);
        }
        const y = e ? new Set(e) : null, w = t.tag || "div";
        for (const b of Object.keys(t)){
            if (typeof t[b] == "function") {
                const S = l && l.get(b);
                S !== void 0 && (0, $gwMPl.isCssProp)(w, b) && (p || (p = new Map), p.set($4c62e3475ce4e4e1$var$Z(b), S));
                continue;
            }
            if (d = l ? l.get(b) : void 0, b === "vars") {
                _(b, t[b]);
                continue;
            }
            if ((0, $aBPRx.REGISTRY).has(b) || b === "theme") continue;
            const A = b.charCodeAt(0);
            A >= 65 && A <= 90 || (0, $10sxy.isHandlerKey)(b) || (0, $gwMPl.isAttributeFirst)(w, b) || _(b, t[b]);
        }
        d = void 0;
        const x = u ? $4c62e3475ce4e4e1$var$je(s, u, p) : null;
        if (c && e) for (const b of c)e.has(b) || !(b in s) || $4c62e3475ce4e4e1$var$gs(b, s, e) && delete s[b];
        if (f) {
            const b = e ? (A)=>e.has(A) || $4c62e3475ce4e4e1$var$gs(A, s, e) : null;
            for(const A in f){
                let S = b ? $4c62e3475ce4e4e1$var$ys(f[A], b) : f[A];
                a && a[A] && (S = $4c62e3475ce4e4e1$var$Zo(S, a[A])), Object.keys(S).length ? s[A] = S : delete s[A];
            }
        }
        if ($4c62e3475ce4e4e1$var$se(t, s, e, x ? new Set([
            ...y || [],
            ...x
        ]) : y), $4c62e3475ce4e4e1$var$uo(t, "static", g), t.breakpointsFrom != null && $4c62e3475ce4e4e1$var$pe(t, s) && (r = !0), r) {
            s.display && String(s.display).includes("!important") && ($4c62e3475ce4e4e1$var$Q(o, {
                display: s.display
            }, t), delete s.display);
            const b = t.display != null && typeof t.display != "function" ? t.display : t.hide === !0 || t.show === !1 ? "none" : null;
            typeof b == "string" && b !== "" && s.display && s.display !== b && (s.display = b);
            const A = (0, $9L4Qx.css)($4c62e3475ce4e4e1$var$ft(t, s), null, t.context?.cssPrefix);
            if (i = A ? A.split(" ").filter(Boolean) : [], A && o.classList) {
                const S = i;
                let C = !1;
                for (const T of S)o.classList.add(T), C || (T.charCodeAt(0) === 95 && T.charCodeAt(1) === 99 || T.charCodeAt(0) === 95 && T.indexOf("_c", 1) !== -1) && (C = !0);
                C && $4c62e3475ce4e4e1$var$Ee(o, t);
            }
        }
        const k = t.__ref;
        if (k) {
            const b = k.__staticCssClasses;
            if (b && o.classList) {
                const A = new Set(i);
                for (const S of b)A.has(S) || o.classList.remove(S);
            }
            k.__staticCssClasses = i;
        }
        $4c62e3475ce4e4e1$var$re(t);
    } finally{
        (0, $j2Odm.popStaticCssPass)(), n && (0, $521xJ.popConfig)(), $4c62e3475ce4e4e1$var$qo.delete(t);
    }
}
const $4c62e3475ce4e4e1$export$c96c0de160ac5e8c = (t)=>!!(0, $fe4kH.CSS_PROPS_REGISTRY)[t] || !!((0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST) && (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(t)) || typeof t == "string" && t.charCodeAt(0) === 45;
function $4c62e3475ce4e4e1$export$dbd278a227449096(t) {
    t && t.node && $4c62e3475ce4e4e1$var$ws(t);
}
function $4c62e3475ce4e4e1$var$De(t) {
    const { node: o } = t;
    if (!o || !o.setAttribute) return;
    if (t.aria && typeof t.aria == "object") for(const r in t.aria){
        const i = t.aria[r];
        if (typeof i == "function" || typeof i == "object" || i == null || typeof i == "string" && i.includes("{{")) continue;
        const f = "aria-" + r.replace(/[A-Z]/g, (c)=>"-" + c.toLowerCase());
        o.setAttribute(f, (0, $gBDdH.serializeAttrValue)(f, i));
    }
    const n = (0, $gBDdH.applyAttrTransforms)(t);
    for(const r in n){
        const i = n[r];
        i != null && i !== !1 && typeof i != "function" && typeof i != "object" && o.setAttribute(r, i === !0 ? "" : i);
    }
    const s = t.tag || "div";
    for (const r of Object.keys(t)){
        if (typeof t[r] == "function" || (0, $aBPRx.REGISTRY).has(r) || r === "on" || n[r] !== void 0) continue;
        const i = r.charCodeAt(0);
        if (!(i >= 65 && i <= 90) && !(0, $10sxy.isHandlerKey)(r) && !(0, $gwMPl.isCssProp)(s, r) && (0, $gBDdH.checkAttributeByTagName)(s, r)) {
            let f = t[r];
            if (f == null) continue;
            if (typeof f == "string" && f.includes("{{")) {
                if (!(0, $gBDdH.ATTR_TRANSFORMS)[r]) continue;
                f = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, f, t.state);
            }
            if (f == null || typeof f == "function" || typeof f == "object" || f === !1 && !(0, $gBDdH.isEnumeratedTrueFalseAttr)((0, $gBDdH.camelToAttr)(r) || r)) continue;
            const c = (0, $gBDdH.camelToAttr)(r) || r;
            o.setAttribute(c, (0, $gBDdH.serializeAttrValue)(c, f));
        }
    }
}
function $4c62e3475ce4e4e1$export$b29a6950bf85efa4(t, o) {
    const { node: n } = t;
    if (!n || !n.setAttribute) return;
    const s = o.charCodeAt(0);
    if (s >= 65 && s <= 90 || (0, $10sxy.isHandlerKey)(o)) return;
    const r = t.tag || "div";
    if ((0, $gwMPl.isCssProp)(r, o) || !(0, $gBDdH.checkAttributeByTagName)(r, o)) return;
    const i = (0, $gBDdH.camelToAttr)(o) || o, f = i.toLowerCase(), c = t.__ref && t.__ref.__effects;
    let a = !1;
    if (c) for(let d = 0; d < c.length; d++){
        const u = c[d];
        u && u._attrName === f && !u._disposed && typeof u._execute == "function" && (a = !0, u._execute());
    }
    if (a) return;
    let e = t[o];
    const l = (0, $gBDdH.ATTR_TRANSFORMS)[o];
    if (l && e != null) {
        const d = l(t);
        d !== void 0 && (e = d);
    }
    typeof e == "string" && e.includes("{{") && (e = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, e, t.state)), $4c62e3475ce4e4e1$export$50a52ac7cfdacacb(n, i, e);
}
function $4c62e3475ce4e4e1$var$Le(t, o) {
    const n = t.node, s = t.__ref;
    let r = s.__autoGrow;
    if (!o) {
        if (r && r.active) {
            try {
                n.removeEventListener("input", r.resize);
            } catch  {}
            $4c62e3475ce4e4e1$var$xs(r), $4c62e3475ce4e4e1$var$it.delete(t), n.style.height = "", r.appliedMax != null && n.style.maxHeight === r.appliedMax && (n.style.maxHeight = ""), $4c62e3475ce4e4e1$var$vs(n, r, !1), r.active = !1, r.appliedMax = null, r.lastMeasure = 0;
        }
        return;
    }
    r || (r = s.__autoGrow = {
        active: !1,
        appliedMax: null,
        lastMeasure: 0,
        lastWidth: null,
        watch: null,
        awaitingLayout: !1,
        appliedScroll: !1,
        fontsHooked: !1,
        attachAttempts: 0,
        firstAttemptAt: null,
        resize: ()=>{
            if (!n.isConnected) {
                $4c62e3475ce4e4e1$var$Vt(t, !0);
                return;
            }
            if (!(n.scrollHeight > 0)) {
                r.awaitingLayout = !0, $4c62e3475ce4e4e1$var$Ss(t, r);
                return;
            }
            r.awaitingLayout = !1;
            const f = $4c62e3475ce4e4e1$var$Me(n), c = $4c62e3475ce4e4e1$var$Fe(f), a = n.style.height;
            n.style.height = "0px", c && $4c62e3475ce4e4e1$var$Jo(n);
            const e = n.scrollHeight;
            if (!(e > 0)) {
                n.style.height = a, c && $4c62e3475ce4e4e1$var$Jo(n);
                return;
            }
            const l = $4c62e3475ce4e4e1$var$Ie(n, f), d = l != null && e < l ? l : e, u = $4c62e3475ce4e4e1$var$Be(f), p = u != null && d > u;
            n.style.height = $4c62e3475ce4e4e1$var$Ue(p ? u : d, f) + "px", c && $4c62e3475ce4e4e1$var$Jo(n), $4c62e3475ce4e4e1$var$vs(n, r, p), r.lastMeasure = e, r.lastWidth = n.clientWidth, $4c62e3475ce4e4e1$var$Ss(t, r);
        }
    }, s.__eventCleanup || (s.__eventCleanup = []), s.__eventCleanup.push(()=>{
        try {
            n.removeEventListener("input", r.resize);
        } catch  {}
        $4c62e3475ce4e4e1$var$xs(r), $4c62e3475ce4e4e1$var$it.delete(t);
    })), r.active || (n.addEventListener("input", r.resize), r.active = !0, $4c62e3475ce4e4e1$var$Ne(t, r));
    const i = typeof o == "object" && o.max != null ? String(o.max) : null;
    i !== r.appliedMax && (i == null ? r.appliedMax != null && n.style.maxHeight === r.appliedMax && (n.style.maxHeight = "") : n.style.maxHeight = i, r.appliedMax = i), r.resize();
}
function $4c62e3475ce4e4e1$var$Vt(t, o) {
    const n = t.__ref?.__autoGrow;
    n && (o && (n.attachAttempts = 0, n.firstAttemptAt = null), $4c62e3475ce4e4e1$var$it.add(t), $4c62e3475ce4e4e1$var$Ot());
}
function $4c62e3475ce4e4e1$var$Re() {
    const t = Array.from($4c62e3475ce4e4e1$var$it);
    $4c62e3475ce4e4e1$var$it.clear();
    for(let o = 0; o < t.length; o++){
        const n = t[o], s = n.node, r = n.__ref?.__autoGrow;
        if (!(!s || !r || !r.active)) {
            if (!s.isConnected) {
                r.firstAttemptAt == null && (r.firstAttemptAt = $4c62e3475ce4e4e1$var$gt()), r.attachAttempts += 1, r.attachAttempts <= $4c62e3475ce4e4e1$var$gn && $4c62e3475ce4e4e1$var$gt() - r.firstAttemptAt < $4c62e3475ce4e4e1$var$bn && ($4c62e3475ce4e4e1$var$it.add(n), $4c62e3475ce4e4e1$var$Ot());
                continue;
            }
            r.attachAttempts = 0, r.firstAttemptAt = null, r.resize();
        }
    }
}
function $4c62e3475ce4e4e1$var$Ss(t, o) {
    if (o.watch) return;
    const n = t.node;
    if (!n) return;
    const s = n.ownerDocument && n.ownerDocument.defaultView, r = s && s.ResizeObserver || (typeof ResizeObserver == "function" ? ResizeObserver : null);
    if (typeof r != "function") return;
    const i = ()=>{
        if (!o.active || !n.isConnected || !(n.scrollHeight > 0)) return;
        if (o.awaitingLayout) {
            o.awaitingLayout = !1, $4c62e3475ce4e4e1$var$Vt(t, !0);
            return;
        }
        const c = n.clientWidth;
        o.lastWidth != null && Math.abs(c - o.lastWidth) < .5 || (o.lastWidth = c, $4c62e3475ce4e4e1$var$Vt(t, !0));
    };
    let f;
    try {
        f = new r(i), f.observe(n);
    } catch  {
        return;
    }
    o.watch = f;
}
function $4c62e3475ce4e4e1$var$xs(t) {
    const o = t.watch;
    if (o) {
        t.watch = null;
        try {
            o.disconnect();
        } catch  {}
    }
}
function $4c62e3475ce4e4e1$var$Ne(t, o) {
    if (o.fontsHooked) return;
    o.fontsHooked = !0;
    const n = t.node && t.node.ownerDocument, s = n && n.fonts && n.fonts.ready;
    !s || typeof s.then != "function" || s.then(()=>{
        o.active && t.node && $4c62e3475ce4e4e1$var$Vt(t, !0);
    }, ()=>{});
}
function $4c62e3475ce4e4e1$var$Me(t) {
    const o = t.ownerDocument && t.ownerDocument.defaultView;
    try {
        return o && o.getComputedStyle ? o.getComputedStyle(t) : null;
    } catch  {
        return null;
    }
}
const $4c62e3475ce4e4e1$var$lt = (t)=>typeof t == "string" && /^\s*-?\d*\.?\d+px\s*$/.test(t) ? parseFloat(t) : null, $4c62e3475ce4e4e1$var$Xo = (t)=>($4c62e3475ce4e4e1$var$lt(t.paddingTop) || 0) + ($4c62e3475ce4e4e1$var$lt(t.paddingBottom) || 0), $4c62e3475ce4e4e1$var$Cs = (t)=>($4c62e3475ce4e4e1$var$lt(t.borderTopWidth) || 0) + ($4c62e3475ce4e4e1$var$lt(t.borderBottomWidth) || 0);
function $4c62e3475ce4e4e1$var$Fe(t) {
    if (!t) return !1;
    const o = String(t.transitionProperty || "").split(","), n = String(t.transitionDuration || "0s").split(",");
    for(let s = 0; s < o.length; s++){
        const r = o[s].trim();
        if (!(r !== "all" && r !== "height") && parseFloat(n[s % n.length]) > 0) return !0;
    }
    return !1;
}
function $4c62e3475ce4e4e1$var$Jo(t) {
    if (typeof t.getAnimations != "function") return;
    let o;
    try {
        o = t.getAnimations();
    } catch  {
        return;
    }
    for(let n = 0; n < o.length; n++){
        const s = o[n];
        if (s && s.transitionProperty === "height") try {
            s.cancel();
        } catch  {}
    }
}
function $4c62e3475ce4e4e1$var$Ie(t, o) {
    if (!o || !t.hasAttribute || !t.hasAttribute("rows")) return null;
    const n = parseInt(t.getAttribute("rows"), 10);
    if (!(n > 0)) return null;
    const s = $4c62e3475ce4e4e1$var$lt(o.lineHeight) || $4c62e3475ce4e4e1$var$$e(t, o);
    return s > 0 ? n * s + $4c62e3475ce4e4e1$var$Xo(o) : null;
}
const $4c62e3475ce4e4e1$var$Ht = [
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "fontStretch",
    "fontSize",
    "fontFamily",
    "lineHeight",
    "letterSpacing"
], $4c62e3475ce4e4e1$var$ks = new WeakMap;
function $4c62e3475ce4e4e1$var$$e(t, o) {
    const n = t.ownerDocument, s = n && (n.body || n.documentElement);
    if (!s || !n.createElement) return null;
    let r = $4c62e3475ce4e4e1$var$ks.get(n);
    r || (r = new Map, $4c62e3475ce4e4e1$var$ks.set(n, r));
    const i = $4c62e3475ce4e4e1$var$Ht.map((e)=>o[e] || "").join("|");
    if (r.has(i)) return r.get(i);
    const f = n.createElement("textarea");
    f.rows = 1, f.setAttribute("aria-hidden", "true"), f.tabIndex = -1;
    const c = f.style;
    c.position = "absolute", c.visibility = "hidden", c.top = "0", c.left = "-9999px", c.height = "auto", c.minHeight = "0", c.maxHeight = "none", c.padding = "0", c.border = "0", c.boxSizing = "content-box", c.overflow = "hidden";
    for(let e = 0; e < $4c62e3475ce4e4e1$var$Ht.length; e++)o[$4c62e3475ce4e4e1$var$Ht[e]] && (c[$4c62e3475ce4e4e1$var$Ht[e]] = o[$4c62e3475ce4e4e1$var$Ht[e]]);
    let a = 0;
    try {
        s.appendChild(f), a = f.clientHeight;
    } catch  {
        a = 0;
    } finally{
        f.parentNode && f.parentNode.removeChild(f);
    }
    return a > 0 ? (r.set(i, a), a) : null;
}
function $4c62e3475ce4e4e1$var$Ue(t, o) {
    return o ? o.boxSizing === "border-box" ? t + $4c62e3475ce4e4e1$var$Cs(o) : o.boxSizing === "content-box" ? Math.max(0, t - $4c62e3475ce4e4e1$var$Xo(o)) : t : t;
}
function $4c62e3475ce4e4e1$var$Be(t) {
    if (!t) return null;
    const o = $4c62e3475ce4e4e1$var$lt(t.maxHeight);
    if (o == null || !(o > 0)) return null;
    const n = $4c62e3475ce4e4e1$var$Xo(t), s = $4c62e3475ce4e4e1$var$Cs(t), r = t.boxSizing === "border-box" ? o - s : o + n, i = $4c62e3475ce4e4e1$var$lt(t.lineHeight);
    if (!(i > 0)) return r;
    const f = Math.floor((r - n) / i + 1e-6);
    return f >= 1 ? f * i + n : r;
}
function $4c62e3475ce4e4e1$var$vs(t, o, n) {
    n ? o.appliedScroll || (t.style.overflowY = "auto", o.appliedScroll = !0) : o.appliedScroll && (t.style.overflowY === "auto" && (t.style.overflowY = ""), o.appliedScroll = !1);
}
const $4c62e3475ce4e4e1$var$Ps = [
    "srcObject",
    "muted"
], $4c62e3475ce4e4e1$var$Ve = (t, o)=>t === "muted" ? o === !0 || o === "" || o === "true" || o === "muted" : o ?? null;
function $4c62e3475ce4e4e1$var$He(t) {
    const o = t.node, n = t.__ref;
    if (!(!o || !n)) for(let s = 0; s < $4c62e3475ce4e4e1$var$Ps.length; s++){
        const r = $4c62e3475ce4e4e1$var$Ps[s], i = t[r];
        if (i === void 0 || !(r in o)) continue;
        const f = (c)=>{
            const a = $4c62e3475ce4e4e1$var$Ve(r, c);
            if (o[r] !== a) try {
                o[r] = a;
            } catch (e) {
                $4c62e3475ce4e4e1$var$F(n, r, e);
            }
        };
        if (typeof i == "function") {
            const c = $4c62e3475ce4e4e1$var$L(t, t[r + "Deps"], i), a = (0, $4VQqJ.createEffect)(()=>{
                try {
                    f(c(t, t.state, t.context));
                } catch (e) {
                    $4c62e3475ce4e4e1$var$F(n, r, e);
                }
            }, {
                depth: n.path.length,
                label: $4c62e3475ce4e4e1$var$E(n, r)
            });
            n.__effects.push(a), n.__exec[r] = i;
        } else f(i);
        r === "srcObject" && (n.__releaseMedia = ()=>{
            try {
                o.srcObject != null && (o.srcObject = null);
            } catch  {}
        });
    }
}
function $4c62e3475ce4e4e1$var$We(t) {
    if (!t.autoGrow) return;
    const o = t.node;
    if (!o || o.tagName !== "TEXTAREA") return;
    const n = t.__ref, s = t.autoGrow, r = typeof s == "function" ? $4c62e3475ce4e4e1$var$L(t, t.autoGrowDeps, s) : null, i = (0, $4VQqJ.createEffect)(()=>{
        const f = t.autoGrow;
        let c = f;
        if (typeof f == "function") try {
            c = (f === s && r ? r : f)(t, t.state, t.context);
        } catch  {
            c = null;
        }
        $4c62e3475ce4e4e1$var$Le(t, c);
    }, {
        depth: n.path.length,
        label: $4c62e3475ce4e4e1$var$E(n, "autoGrow")
    });
    n.__effects || (n.__effects = []), n.__effects.push(i), r && (n.__exec.autoGrow = s);
}
const $4c62e3475ce4e4e1$var$Ts = new Set([
    "onSwipe",
    "onSwipeLeft",
    "onSwipeRight",
    "onSwipeUp",
    "onSwipeDown"
]);
function $4c62e3475ce4e4e1$var$Es(t, o) {
    let n = !1;
    for (const s of Object.keys(t)){
        if (!(0, $10sxy.isHandlerKey)(s) || $4c62e3475ce4e4e1$var$Ts.has(s)) continue;
        if (s === "onInView" || s === "onLeaveView") {
            n = !0;
            continue;
        }
        const r = (0, $10sxy.globalEventKeyInfo)(s);
        if (r) {
            (0, $10sxy.registerGlobalEvent)(r, t, t[s]);
            continue;
        }
        let i = t[s], f = null;
        if (i && typeof i == "object" && !Array.isArray(i) && (f = i, i = f.handler), i = (0, $10sxy.stringHandler)(t, i), typeof i != "function") continue;
        const c = (0, $10sxy.eventNameFrom)(s);
        (0, $aBPRx.LIFECYCLE_EVENTS).has(c) || (0, $10sxy.registerEvent)($4c62e3475ce4e4e1$var$Ar(c), t, i, f);
    }
    $4c62e3475ce4e4e1$var$Ge(t), n && (0, $8NJs1.FEATURES).viewEvents && (0, $8NJs1.FEATURES).viewEvents(t);
}
function $4c62e3475ce4e4e1$var$Ge(t) {
    const o = t.node;
    if (!o || !o.addEventListener) return;
    const n = {};
    let s = !1;
    for (const u of $4c62e3475ce4e4e1$var$Ts){
        const p = t[u];
        typeof p == "function" && (n[u] = p, s = !0);
    }
    if (!s) return;
    const r = typeof t.swipeThreshold == "number" ? t.swipeThreshold : 40, i = typeof t.swipeMaxDuration == "number" ? t.swipeMaxDuration : 600;
    let f = 0, c = 0, a = 0, e = !1;
    const l = (u)=>{
        const p = u.touches && u.touches[0] || u.changedTouches && u.changedTouches[0];
        p && (f = p.clientX, c = p.clientY, a = Date.now(), e = !0);
    }, d = (u)=>{
        if (!e) return;
        e = !1;
        const p = u.changedTouches && u.changedTouches[0] || u.touches && u.touches[0];
        if (!p) return;
        const g = p.clientX - f, h = p.clientY - c, _ = Date.now() - a;
        if (_ > i) return;
        const y = Math.abs(g), w = Math.abs(h);
        if (Math.max(y, w) < r) return;
        let x;
        if (y > w * 1.2) x = g < 0 ? "left" : "right";
        else if (w > y * 1.2) x = h < 0 ? "up" : "down";
        else return;
        const k = "onSwipe" + x.charAt(0).toUpperCase() + x.slice(1), b = n[k], A = n.onSwipe;
        b && b.call(t, u, t, t.state, t.context), A && A.call(t, {
            direction: x,
            dx: g,
            dy: h,
            dt: _,
            event: u
        }, t, t.state, t.context);
    };
    o.addEventListener("touchstart", l, {
        passive: !0
    }), o.addEventListener("touchend", d, {
        passive: !0
    }), t.__ref.__eventCleanup || (t.__ref.__eventCleanup = []), t.__ref.__eventCleanup.push(()=>{
        try {
            o.removeEventListener("touchstart", l);
        } catch  {}
        try {
            o.removeEventListener("touchend", d);
        } catch  {}
    });
}
function $4c62e3475ce4e4e1$export$66718326536203a4(t, o, n, s, r, i, f, c) {
    let a = o;
    (typeof a == "string" || typeof a == "number") && (a = {
        text: a
    });
    let e = s;
    if (typeof s == "function") try {
        e = s(t, a);
    } catch  {
        e = null;
    }
    let l = typeof s == "function" ? $4c62e3475ce4e4e1$var$Lt(e) : r;
    if (c && !f && (l = $4c62e3475ce4e4e1$var$Rt(l, $4c62e3475ce4e4e1$var$Lt(o))), f) {
        let d = o;
        (typeof o == "string" || typeof o == "number") && (d = {
            value: o,
            text: o
        }), a = e ? {
            ...e,
            state: d
        } : {
            state: d
        };
    } else e && (a = (0, $8RrjX.deepMergeChild)(e, a));
    return a = $4c62e3475ce4e4e1$var$Wt(a, i), {
        def: a,
        key: $4c62e3475ce4e4e1$var$Sn(a?.key, o, n, t),
        supplied: l,
        props: e
    };
}
function $4c62e3475ce4e4e1$var$Wt(t, o) {
    if (!o || !t || t.ignoreChildExtends) return t;
    if (!t.extends) return {
        ...t,
        extends: o
    };
    const n = Array.isArray(t.extends) ? t.extends : [
        t.extends
    ], s = Array.isArray(o) ? o : [
        o
    ];
    return {
        ...t,
        extends: [
            ...s,
            ...n
        ]
    };
}
const $4c62e3475ce4e4e1$export$7098c6c10b33842e = (t)=>{
    const o = t && t.__ref;
    if (!o || o.__if === !1 || o.__mount && o.__mount.held) return null;
    const n = t.node;
    return n && n.nodeType !== 11 ? n : null;
}, $4c62e3475ce4e4e1$var$js = (t, o)=>o ? o.nextSibling : (0, $87g1D.firstSlotAfterText)(t.node, t.__ref.__textNode), $4c62e3475ce4e4e1$export$b8757934a0745a7c = (t, o, n)=>{
    const s = $4c62e3475ce4e4e1$var$js(t, n);
    return o !== s && t.node.insertBefore(o, s), o;
}, $4c62e3475ce4e4e1$export$48200b07a3d569e1 = (t, o)=>{
    const n = $4c62e3475ce4e4e1$var$js(t, o);
    return n ? {
        position: "before",
        node: n
    } : void 0;
};
function $4c62e3475ce4e4e1$export$df7e4aa0fbf95649(t, o, n) {
    let s = null;
    for(let r = 0; r < o.length; r++){
        if (n && n.has(o[r])) continue;
        const i = $4c62e3475ce4e4e1$export$7098c6c10b33842e(t[o[r]]);
        i && (s = $4c62e3475ce4e4e1$export$b8757934a0745a7c(t, i, s));
    }
}
function $4c62e3475ce4e4e1$var$Ds(t, o, n, s) {
    const r = (0, $8NJs1.FEATURES).rows, i = r !== null && t.childrenAs !== "state" && t.tag !== "fragment" ? r.track(t) : null, f = $4c62e3475ce4e4e1$var$mo(t, o, n, s, !0, i);
    return t.__ref.__plainRows = i && (f || o == null || o === !1) ? i : null, f;
}
function $4c62e3475ce4e4e1$var$mo(t, o, n, s, r, i) {
    if (!o || !t.node) return;
    const f = t.childExtends, c = $4c62e3475ce4e4e1$export$2d5526e9c7b5a43a(t, "childProps"), a = t.__ref, e = (0, $8NJs1.FEATURES).mount, l = s > 0 && t.tag !== "fragment" && a ? s : 0;
    if (Array.isArray(o)) {
        const d = t.childProps, u = t.childrenAs === "state", p = (g, h)=>{
            const _ = $4c62e3475ce4e4e1$export$66718326536203a4(t, o[g], g, d, c, f, u, r);
            i && i.add(_.key, o[g], _, d, f);
            try {
                const y = $4c62e3475ce4e4e1$export$185802fd694ee1f5($4c62e3475ce4e4e1$export$43c64c8265a0bfaa(_.def, _.supplied), t, _.key, n, h);
                return !y && i && i.none(_.key), $4c62e3475ce4e4e1$var$no(t, y), y;
            } catch (y) {
                if (i && i.failed(_.key), typeof console < "u" && console.error) {
                    const w = t.__ref?.path?.join(".") || t.key || "<root>";
                    console.error(`[smbls] child "${_.key}" failed to construct at ${w} (initial render, skipping this row):`, y?.message || y);
                }
                return (0, $jdWhC.reportRenderError)(t, {
                    where: "child",
                    key: _.key,
                    error: y
                }), null;
            }
        };
        if (!l) {
            for(let g = 0; g < o.length && !(a && a.__disposed); g++)p(g);
            return !0;
        }
        return e.rows(t, o.length, p, l), !0;
    }
    if (typeof o == "string") {
        const d = $4c62e3475ce4e4e1$var$Pn(o, t);
        if (Array.isArray(d)) return $4c62e3475ce4e4e1$var$mo(t, d, n, s, !0, i);
    }
    if (typeof o == "object") {
        const d = (p, g)=>{
            if ((0, $aBPRx.REGISTRY).has(p)) return !1;
            let h = o[p];
            if (h == null || h === !1) return !1;
            const _ = r ? $4c62e3475ce4e4e1$var$Rt(c, $4c62e3475ce4e4e1$var$Lt(h)) : c;
            (typeof h == "string" || typeof h == "number") && (h = {
                text: h
            }), t.childProps && (h = (0, $8RrjX.deepMergeChild)(t.childProps, h)), h = $4c62e3475ce4e4e1$var$Wt(h, f);
            const y = $4c62e3475ce4e4e1$export$185802fd694ee1f5($4c62e3475ce4e4e1$export$43c64c8265a0bfaa(h, _), t, $4c62e3475ce4e4e1$var$oo(t, p), n, g);
            return $4c62e3475ce4e4e1$var$no(t, y), y;
        };
        if (!l) {
            for(const p in o)d(p);
            return;
        }
        const u = [];
        for(const p in o)u.push(p);
        e.rows(t, u.length, (p, g)=>d(u[p], g), l);
    }
}
function $4c62e3475ce4e4e1$export$3b058bdaa6ecc53(t, o) {
    const n = t.node;
    if (!n || n.tagName !== "SELECT") return;
    const s = n.options;
    if (!s || !s.length) return;
    const r = t.__ref, i = r && r.__exec && r.__exec.value, f = typeof i == "function", c = t.value != null && typeof t.value != "function";
    if (f || c) {
        let l;
        if (f) try {
            l = i(t, t.state, t.context);
        } catch  {
            return;
        }
        else l = t.value, typeof l == "string" && l.includes("{{") && (l = (0, $TarXh.replaceLiteralsWithObjectFields).call(t, l, t.state));
        const d = l == null ? "" : String(l);
        n.value !== d && (n.value = d);
        return;
    }
    const a = o || !(r && r.__selectSynced);
    if (r && (r.__selectSynced = !0), !a) return;
    let e = -1;
    for(let l = 0; l < s.length; l++)s[l].defaultSelected && (e = l);
    e >= 0 && n.selectedIndex !== e && (n.selectedIndex = e);
}
function $4c62e3475ce4e4e1$var$Ls(t, o) {
    let { children: n, content: s } = t;
    const r = t.childExtends, i = typeof n == "function", f = i || $4c62e3475ce4e4e1$var$Nn(t, "children");
    if (typeof n == "function") {
        const d = n, u = t.__ref;
        let p = !1, g;
        const h = $4c62e3475ce4e4e1$var$L(t, t.childrenDeps, d), _ = (0, $4VQqJ.createEffect)(()=>{
            const y = p;
            p = !0;
            let w;
            try {
                w = h(t, t.state, t.context);
            } catch (v) {
                if (typeof console < "u" && console.error) {
                    const P = t.__ref?.path?.join(".") || t.key || "<root>";
                    console.error(`[smbls] \`children:\` factory threw at ${P}${y ? "" : " (initial run, treating as empty)"}:`, v?.message || v);
                }
                (0, $jdWhC.reportRenderError)(t, {
                    where: "children",
                    error: v
                });
                return;
            }
            if (!y) {
                g = w;
                return;
            }
            if (w === t.children) return;
            $4c62e3475ce4e4e1$var$Mn(t, w), t.children = w, u.__mount && u.__mount.chunkGen++;
            const x = typeof t.onContentUpdate == "function", k = x ? [] : null, b = x ? [] : null, A = x ? [] : null;
            if (Array.isArray(w) && t.childrenAs === "state") {
                const v = t.childProps, P = [], V = new Map;
                for(let D = 0; D < w.length; D++){
                    const J = w[D];
                    let M = v;
                    if (typeof v == "function") try {
                        M = v(t, J);
                    } catch  {
                        M = null;
                    }
                    const at = $4c62e3475ce4e4e1$var$Sn(M && M.key, J, D, t);
                    P.push(at), V.set(at, {
                        rawChild: J,
                        childProps: M
                    });
                }
                const z = new Set(P), N = $4c62e3475ce4e4e1$var$En(u, u.__children.slice());
                for (const D of N)if (!z.has(D)) {
                    const J = t[D];
                    J?.remove && J.remove(), delete t[D], b && b.push(D);
                }
                const dt = t.childExtends, Gt = !(t.tag === "fragment") && !!t.node;
                let Kt = null;
                const kt = new Set;
                for (const D of P){
                    const J = V.get(D), M = J.rawChild, at = t[D];
                    if (at && at.state) {
                        if (M && typeof M == "object") {
                            const R = at.state, zt = R.$replace || R.replace, nn = R.$update || R.update;
                            try {
                                if (typeof zt == "function") zt.call(R, M);
                                else if (typeof nn == "function") {
                                    for(const H in R)if (!(H === "__element" || H === "root" || H === "parent" || H === "update") && !Object.prototype.hasOwnProperty.call(M, H)) try {
                                        R[H] = void 0;
                                    } catch  {}
                                    nn.call(R, M);
                                } else for(const H in M)R[H] = M[H];
                            } catch (H) {
                                if (typeof console < "u" && console.error) {
                                    const Is = t.__ref?.path?.join(".") || t.key || "<root>";
                                    console.error(`[smbls] child "${D}" failed to patch at ${Is} (reconcile, keeping its previous data for this pass):`, H?.message || H);
                                }
                            }
                        }
                        if (A && A.push(D), Gt) {
                            const R = $4c62e3475ce4e4e1$export$7098c6c10b33842e(at);
                            R && (Kt = $4c62e3475ce4e4e1$export$b8757934a0745a7c(t, R, Kt));
                        }
                        continue;
                    }
                    let yo = M;
                    (typeof M == "string" || typeof M == "number") && (yo = {
                        value: M,
                        text: M
                    });
                    const go = J.childProps, Ms = $4c62e3475ce4e4e1$var$Wt(go ? {
                        ...go,
                        state: yo
                    } : {
                        state: yo
                    }, dt), Fs = typeof v == "function" ? $4c62e3475ce4e4e1$var$Lt(go) : $4c62e3475ce4e4e1$export$2d5526e9c7b5a43a(t, "childProps");
                    let on;
                    try {
                        on = $4c62e3475ce4e4e1$export$185802fd694ee1f5($4c62e3475ce4e4e1$export$43c64c8265a0bfaa(Ms, Fs), t, D, o, Gt ? $4c62e3475ce4e4e1$export$48200b07a3d569e1(t, Kt) : void 0);
                    } catch (R) {
                        if (typeof console < "u" && console.error) {
                            const zt = t.__ref?.path?.join(".") || t.key || "<root>";
                            console.error(`[smbls] child "${D}" failed to construct at ${zt} (reconcile, skipping this row):`, R?.message || R);
                        }
                        (0, $jdWhC.reportRenderError)(t, {
                            where: "child",
                            key: D,
                            error: R
                        }), kt.add(D);
                        continue;
                    }
                    if (u.__disposed) return;
                    if (Gt) {
                        const R = $4c62e3475ce4e4e1$export$7098c6c10b33842e(on);
                        R && (Kt = R);
                    }
                    k && k.push(D);
                }
                Gt && $4c62e3475ce4e4e1$export$df7e4aa0fbf95649(t, P, kt.size ? kt : null), u.__children = kt.size ? P.filter((D)=>!kt.has(D)) : P, x && (k.length || b.length) && $4c62e3475ce4e4e1$export$cf3cc0b695ef095e(t, {
                    added: k,
                    removed: b,
                    kept: A
                }), $4c62e3475ce4e4e1$export$3b058bdaa6ecc53(t, !1);
                return;
            }
            if (t.childrenAs !== "state" && u.__plainRows && (0, $8NJs1.FEATURES).rows.reconcile(t, u, w, o, x)) {
                $4c62e3475ce4e4e1$export$3b058bdaa6ecc53(t, !1);
                return;
            }
            const T = x ? [
                ...u.__children
            ] : null;
            for (const v of $4c62e3475ce4e4e1$var$En(u, [
                ...u.__children
            ])){
                const P = t[v];
                P?.remove && P.remove(), delete t[v];
            }
            u.__children = [], $4c62e3475ce4e4e1$var$Ds(t, w, o, 0), $4c62e3475ce4e4e1$export$3b058bdaa6ecc53(t, !1), x && $4c62e3475ce4e4e1$export$cf3cc0b695ef095e(t, {
                added: [
                    ...u.__children
                ],
                removed: T,
                kept: []
            });
        }, {
            depth: u.path.length,
            label: $4c62e3475ce4e4e1$var$E(u, "children")
        });
        u.__effects.push(_), n = g, $4c62e3475ce4e4e1$var$Mn(t, n), t.children = n;
    }
    const c = (0, $8NJs1.FEATURES).mount, a = c !== null ? c.budgetOf(t, o) : 0, e = (0, $hAgpL.mountPendingOf)(t.__ref), l = i ? $4c62e3475ce4e4e1$var$Ds(t, n, o, a) : $4c62e3475ce4e4e1$var$mo(t, n, o, a, f);
    if (a && (0, $hAgpL.mountPendingOf)(t.__ref) > e) {
        c.defer(t, a, ()=>$4c62e3475ce4e4e1$var$Rs(t, o, n, s, r, l, a));
        return;
    }
    $4c62e3475ce4e4e1$var$Rs(t, o, n, s, r, l, a);
}
function $4c62e3475ce4e4e1$var$Rs(t, o, n, s, r, i, f) {
    const c = (0, $hAgpL.mountPendingOf)(t.__ref);
    if (s != null && !(s && s.__ref)) {
        let a = s;
        typeof a == "string" || typeof a == "number" ? a = {
            text: a
        } : typeof a != "object" && (a = {}), t.childProps && (a = (0, $8RrjX.deepMergeChild)(t.childProps, a)), a = $4c62e3475ce4e4e1$var$Wt(a, r);
        const e = $4c62e3475ce4e4e1$var$Rt($4c62e3475ce4e4e1$export$2d5526e9c7b5a43a(t, "childProps"), $4c62e3475ce4e4e1$export$2d5526e9c7b5a43a(t, "content"));
        $4c62e3475ce4e4e1$var$no(t, $4c62e3475ce4e4e1$export$185802fd694ee1f5($4c62e3475ce4e4e1$export$43c64c8265a0bfaa(a, e), t, "content", o));
    }
    if (!(n && !i)) {
        if (f && (0, $hAgpL.mountPendingOf)(t.__ref) > c) {
            (0, $8NJs1.FEATURES).mount.defer(t, f, ()=>$4c62e3475ce4e4e1$var$Ns(t, o, r, f));
            return;
        }
        $4c62e3475ce4e4e1$var$Ns(t, o, r, f);
    }
}
function $4c62e3475ce4e4e1$var$Ns(t, o, n, s) {
    const r = t.context?.components || {}, i = t.__ref && t.__ref.__runtimeSource, f = i ? {} : null;
    {
        const e = Object.keys(t);
        for(let l = 0; l < e.length; l++){
            const d = e[l];
            if (!d.endsWith("Extends") || typeof t[d] != "string") continue;
            const u = d.slice(0, -7);
            if (!u || u.charCodeAt(0) < 65 || u.charCodeAt(0) > 90) continue;
            const p = {
                extends: t[d]
            };
            delete t[d];
            for(let g = l + 1; g < e.length; g++){
                const h = e[g], _ = h.charCodeAt(0);
                if (_ >= 65 && _ <= 90 || (0, $aBPRx.REGISTRY).has(h) || typeof t[h] == "function" && (h.startsWith("on") || h.startsWith("."))) break;
                const y = t[h];
                y !== void 0 && (p[h] = y, delete t[h], f && $4c62e3475ce4e4e1$var$Dt(i, h) && (f[u] || (f[u] = {}), f[u][h] = i[h]));
            }
            t[u] && typeof t[u] == "object" ? t[u] = {
                ...p,
                ...t[u]
            } : t[u] = p;
        }
    }
    const c = Object.keys(t), a = (e)=>{
        if ((0, $aBPRx.REGISTRY).has(e) || typeof t[e] != "object" || t[e] === null) return !1;
        const l = e.charCodeAt(0);
        if (l < 65 || l > 90) return !1;
        let d = t[e];
        if (d.__ref) return !1;
        if (!d.extends && !d.extend) {
            const p = r[e] || r[`smbls.${e}`];
            p && (d = {
                ...d,
                extends: p
            });
        }
        t.childProps && (d = (0, $8RrjX.deepMergeChild)(t.childProps, d)), d = $4c62e3475ce4e4e1$var$Wt(d, n);
        const u = i ? $4c62e3475ce4e4e1$var$Rt($4c62e3475ce4e4e1$export$2d5526e9c7b5a43a(t, "childProps"), $4c62e3475ce4e4e1$var$Rt(f[e] || null, $4c62e3475ce4e4e1$export$2d5526e9c7b5a43a(t, e))) : null;
        $4c62e3475ce4e4e1$var$no(t, $4c62e3475ce4e4e1$export$185802fd694ee1f5($4c62e3475ce4e4e1$export$43c64c8265a0bfaa(d, u), t, e, o));
    };
    if (!s) {
        for (const e of c)a(e);
        return;
    }
    (0, $8NJs1.FEATURES).mount.run(t, c.length, (e)=>a(c[e]), s);
}
function $4c62e3475ce4e4e1$var$Ct(t, o, n) {
    const { node: s } = t;
    if (!s) return;
    s.ref = t;
    const r = o?.tag === "fragment" ? o.__ref?.__fragmentAnchor : null;
    if (r) {
        const a = r.parentNode;
        if (a) {
            if (n?.position === "before" && n.node) a.insertBefore(s, n.node);
            else if (n?.position === "after" && n.node) {
                const e = n.node.nextSibling;
                a.insertBefore(s, e || r);
            } else a.insertBefore(s, r);
            (0, $8gewL.flushConnected)();
            return;
        }
    }
    const i = o?.node || (o?.nodeType ? o : null);
    if (!i) return;
    if (!n && (0, $8NJs1.FEATURES).hydration !== null) {
        const a = t.context && t.context.__hydration;
        if (a && (0, $8NJs1.FEATURES).hydration.place(a, t, o, i, s)) return;
    }
    const f = n?.node, c = s.parentNode === i;
    if (f && f.parentNode !== i) (!c || s.nextSibling) && i.appendChild(s);
    else if (n?.position === "before" && f) f !== s && (!c || s.nextSibling !== f) && i.insertBefore(s, f);
    else if (n?.position === "after" && n.node) {
        const a = n.node.nextSibling;
        a === s || (a ? i.insertBefore(s, a) : i.appendChild(s));
    } else (!c || s.nextSibling) && i.appendChild(s);
    (0, $8gewL.flushConnected)();
}
const $4c62e3475ce4e4e1$export$a0ab69825a57b3f9 = 3;
function $4c62e3475ce4e4e1$export$3afe46815fe1a2cd(t) {
    return !t || t.__inBeforeUpdate || (t.__beforeUpdateFailCount || 0) >= $4c62e3475ce4e4e1$export$a0ab69825a57b3f9 ? !1 : (t.__inBeforeUpdate = !0, !0);
}
function $4c62e3475ce4e4e1$export$b751efa7c53f55a(t, o) {
    t && (t.__inBeforeUpdate = !1, o ? (t.__beforeUpdateFailCount = (t.__beforeUpdateFailCount || 0) + 1, t.__beforeUpdateFailCount === $4c62e3475ce4e4e1$export$a0ab69825a57b3f9 && typeof console < "u" && console.error && console.error(`[DOMQL] onBeforeUpdate failed ${$4c62e3475ce4e4e1$export$a0ab69825a57b3f9}x in a row on this element \u2014 pausing automatic retries until a future prop/state change re-arms it.`)) : t.__beforeUpdateFailCount = 0);
}
function $4c62e3475ce4e4e1$var$$(t, o, n) {
    const s = t.charAt(0).toLowerCase() + t.slice(1);
    (0, $jdWhC.dispatchPluginHook)(s, o, n);
    const r = "on" + t, i = o[r];
    if (typeof i == "function") {
        const a = t === "Render" ? "__inRender" : t === "RenderRouter" ? "__inRenderRouter" : null;
        if (a) {
            if (o.__ref[a]) return !0;
            o.__ref[a] = !0;
        }
        const e = o.context?.designSystem;
        e && (0, $521xJ.pushConfig)(e);
        let l = !!a;
        try {
            const d = i(o, o.state, o.context, n);
            if (d && typeof d.then == "function") {
                const u = o.__ref;
                return d.catch((p)=>{
                    (0, $jdWhC.reportLifecycleError)(o, r, p);
                }).finally(()=>{
                    a && u && (u[a] = !1);
                }), l = !1, !0;
            }
            if (d === !1) return !1;
        } catch (d) {
            if ((0, $jdWhC.reportLifecycleError)(o, r, d), o.context?.strictMode) throw d;
        } finally{
            e && (0, $521xJ.popConfig)(), l && o.__ref && (o.__ref[a] = !1);
        }
    }
    return !0;
}
var $4c62e3475ce4e4e1$export$2e2bcd8739ae039 = $4c62e3475ce4e4e1$export$185802fd694ee1f5;

});
parcelRegister("87g1D", function(module, exports) {

$parcel$export(module.exports, "SVG_NS", () => $5e8b687605634f08$export$276d1de0bc02ff5b);
$parcel$export(module.exports, "isSvgTag", () => $5e8b687605634f08$export$ac48d93d50510706);
$parcel$export(module.exports, "detectTag", () => $5e8b687605634f08$export$5075bd4eae016d2c);
$parcel$export(module.exports, "cacheNode", () => $5e8b687605634f08$export$257247f9c0329159);
$parcel$export(module.exports, "firstSlotAfterText", () => $5e8b687605634f08$export$14a41848001a1c8);
const $5e8b687605634f08$export$276d1de0bc02ff5b = "http://www.w3.org/2000/svg", $5e8b687605634f08$export$23d5ae6d2560d158 = new Set([
    "svg",
    "path",
    "circle",
    "ellipse",
    "line",
    "polyline",
    "polygon",
    "rect",
    "g",
    "defs",
    "use",
    "symbol",
    "clipPath",
    "mask",
    "pattern",
    "image",
    "text",
    "tspan",
    "textPath",
    "marker",
    "linearGradient",
    "radialGradient",
    "stop",
    "filter",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feFlood",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "feSpecularLighting",
    "feTile",
    "feTurbulence",
    "animate",
    "animateMotion",
    "animateTransform",
    "set",
    "foreignObject",
    "desc",
    "title",
    "metadata"
]), $5e8b687605634f08$var$p = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "string",
    "fragment",
    "shadow"
]);
function $5e8b687605634f08$export$77ee750ed81149c6(e) {
    return $5e8b687605634f08$var$p.has(e) || $5e8b687605634f08$export$23d5ae6d2560d158.has(e);
}
function $5e8b687605634f08$export$ac48d93d50510706(e) {
    return $5e8b687605634f08$export$23d5ae6d2560d158.has(e);
}
function $5e8b687605634f08$export$5075bd4eae016d2c(e) {
    let { tag: t, key: o } = e;
    if (typeof t == "function") try {
        t = t(e, e.state, e.context);
    } catch (n) {
        t = void 0, typeof console < "u" && console.error && console.error(`[smbls] \`tag:\` factory threw on "${o || "<anon>"}" \u2014 falling back to key-based tag detection:`, n?.message || n);
    }
    if (t === !0 && (t = o), typeof t == "string" && $5e8b687605634f08$export$77ee750ed81149c6(t)) return t;
    if (!o || typeof o != "string") return "div";
    const a = new Set([
        "html",
        "head",
        "body",
        "meta",
        "link",
        "script",
        "style",
        "title",
        "base",
        "noscript",
        "template",
        "th",
        "tr",
        "td",
        "thead",
        "tbody",
        "tfoot",
        "caption",
        "col",
        "colgroup"
    ]);
    let r = o.toLowerCase();
    return r.includes(".") && (r = r.split(".")[0]), r.includes("_") && (r = r.split("_")[0]), $5e8b687605634f08$export$77ee750ed81149c6(r) && !a.has(r) ? r : "div";
}
const $5e8b687605634f08$var$f = {};
function $5e8b687605634f08$export$39fdcd81e0c5d80b(e, t) {
    const o = t?.context?.document || globalThis.document;
    if (!o) return null;
    if (e === "string") return o.createTextNode(t?.text || "");
    if (e === "fragment") return o.createDocumentFragment();
    if ($5e8b687605634f08$export$ac48d93d50510706(e)) {
        const a = t?.parent;
        if (e === "svg" || a?.node?.namespaceURI === $5e8b687605634f08$export$276d1de0bc02ff5b) return o.createElementNS($5e8b687605634f08$export$276d1de0bc02ff5b, e);
        if (e !== "svg") return o.createElement("div");
    }
    return o.createElement(e);
}
function $5e8b687605634f08$export$257247f9c0329159(e) {
    const t = e.tag = $5e8b687605634f08$export$5075bd4eae016d2c(e), a = $5e8b687605634f08$export$ac48d93d50510706(t) && (t === "svg" || e.parent?.node?.namespaceURI === $5e8b687605634f08$export$276d1de0bc02ff5b) ? "svg:" + t : t, r = e?.context?.document || globalThis.document;
    let n = $5e8b687605634f08$var$f[a];
    if (n || (n = $5e8b687605634f08$var$f[a] = $5e8b687605634f08$export$39fdcd81e0c5d80b(t, e)), !n) return null;
    const c = r && n.ownerDocument !== r ? $5e8b687605634f08$export$39fdcd81e0c5d80b(t, e) : n.cloneNode(!0);
    return t === "string" && (c.nodeValue = e.text || ""), c;
}
function $5e8b687605634f08$export$14a41848001a1c8(e, t) {
    return t && t.parentNode === e ? t.nextSibling : e.firstChild;
}

});

parcelRegister("bF2FJ", function(module, exports) {

$parcel$export(module.exports, "mountBridge", () => $87d598a4a81e9c7f$export$65308330d731e9eb);
$parcel$export(module.exports, "destroyBridge", () => $87d598a4a81e9c7f$export$899406a77f9aa04a);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $1H9Q8 = parcelRequire("1H9Q8");

var $jdWhC = parcelRequire("jdWhC");
parcelRequire("dYaY2");
var $dSdIt = parcelRequire("dSdIt");

const $87d598a4a81e9c7f$var$y = (t, r)=>Object.prototype.hasOwnProperty.call(t, r);
function $87d598a4a81e9c7f$var$d(t, r, i) {
    return (0, $1H9Q8.untrack)(()=>(0, $1H9Q8.withDesignSystem)(t, ()=>r.call(t, i, t, t.state, t.context)));
}
function $87d598a4a81e9c7f$var$g(t, r) {
    if (!(0, $dSdIt.isLoudDevRuntime)()) return;
    const i = r.__children && r.__children.length > 0;
    !i && t.html == null || console.warn(`[smbls] bridge host "${r.path.join(".")}" renders DOMQL ${i ? "children" : "html"} inside the node it hands to its library \u2014 the library owns that subtree and may replace them. Keep DOMQL children beside the host, not in it.`);
}
function $87d598a4a81e9c7f$export$65308330d731e9eb(t) {
    const r = t.__ref, i = t.node;
    if (!r || !i || r.__bridge || typeof t.onBridgeMount != "function") return;
    if (!("scrollHeight" in i)) return;
    const o = r.__bridge = {
        settled: !1,
        failed: !1,
        disposed: !1,
        destroyed: !1,
        instance: void 0,
        effect: null
    };
    r.contentManaged = !0, $87d598a4a81e9c7f$var$g(t, r);
    let n;
    try {
        n = $87d598a4a81e9c7f$var$d(t, t.onBridgeMount, i);
    } catch (e) {
        if (o.failed = !0, (0, $jdWhC.reportLifecycleError)(t, "onBridgeMount", e), t.context?.strictMode) throw e;
        return;
    }
    if (n && typeof n.then == "function") {
        n.then((e)=>$87d598a4a81e9c7f$var$c(t, o, e), (e)=>{
            o.failed = !0, (0, $jdWhC.reportLifecycleError)(t, "onBridgeMount", e);
        });
        return;
    }
    $87d598a4a81e9c7f$var$c(t, o, n);
}
function $87d598a4a81e9c7f$var$c(t, r, i) {
    if (r.settled = !0, r.instance = i, r.disposed) {
        $87d598a4a81e9c7f$var$u(t, r);
        return;
    }
    if (Object.defineProperty(t, "bridge", {
        value: i,
        writable: !0,
        configurable: !0,
        enumerable: !1
    }), typeof t.onBridgeUpdate != "function") return;
    const o = t.__ref;
    r.effect = (0, $4VQqJ.createEffect)(()=>{
        r.disposed || (0, $1H9Q8.withDesignSystem)(t, ()=>{
            try {
                const n = t.onBridgeUpdate.call(t, r.instance, t, t.state, t.context);
                n && typeof n.then == "function" && n.catch((e)=>(0, $jdWhC.reportLifecycleError)(t, "onBridgeUpdate", e));
            } catch (n) {
                (0, $jdWhC.reportLifecycleError)(t, "onBridgeUpdate", n);
            }
        });
    }, {
        depth: o.path.length,
        label: ()=>o.path.join(".") + "::onBridgeUpdate"
    }), o.__effects.push(r.effect);
}
function $87d598a4a81e9c7f$export$899406a77f9aa04a(t) {
    const r = t.__ref?.__bridge;
    !r || r.disposed || (r.disposed = !0, r.effect && r.effect.dispose(), r.settled && $87d598a4a81e9c7f$var$u(t, r));
}
function $87d598a4a81e9c7f$var$u(t, r) {
    if (r.destroyed) return;
    r.destroyed = !0;
    const i = r.instance;
    if (r.instance = void 0, $87d598a4a81e9c7f$var$y(t, "bridge") && (t.bridge = void 0), typeof t.onBridgeDestroy == "function") try {
        const o = $87d598a4a81e9c7f$var$d(t, t.onBridgeDestroy, i);
        o && typeof o.then == "function" && o.catch((n)=>(0, $jdWhC.reportLifecycleError)(t, "onBridgeDestroy", n));
    } catch (o) {
        (0, $jdWhC.reportLifecycleError)(t, "onBridgeDestroy", o);
    }
}

});
parcelRegister("jdWhC", function(module, exports) {

$parcel$export(module.exports, "hasPluginHook", () => $dfec710f984d16ea$export$71be8ce002f52d80);
$parcel$export(module.exports, "dispatchPluginHook", () => $dfec710f984d16ea$export$c5a301ffc0aba375);
$parcel$export(module.exports, "reportLifecycleError", () => $dfec710f984d16ea$export$c2d2393498768378);
$parcel$export(module.exports, "reportRenderError", () => $dfec710f984d16ea$export$5609811465949fc3);

var $gjNoZ = parcelRequire("gjNoZ");
const $dfec710f984d16ea$var$o = new WeakMap;
let $dfec710f984d16ea$var$l = null, $dfec710f984d16ea$var$c = null;
function $dfec710f984d16ea$var$u(r, t) {
    let e = r === $dfec710f984d16ea$var$l ? $dfec710f984d16ea$var$c : $dfec710f984d16ea$var$o.get(r);
    (!e || e.length !== r.length) && (e = {
        length: r.length,
        hooks: new Map
    }, $dfec710f984d16ea$var$o.set(r, e)), $dfec710f984d16ea$var$l = r, $dfec710f984d16ea$var$c = e;
    let n = e.hooks.get(t);
    if (n === void 0) {
        n = !1;
        for (const i of r)if (typeof i[t] == "function") {
            n = !0;
            break;
        }
        e.hooks.set(t, n);
    }
    return n;
}
function $dfec710f984d16ea$export$71be8ce002f52d80(r, t) {
    const e = r && r.context && r.context.plugins;
    return !!(e && e.length && $dfec710f984d16ea$var$u(e, t));
}
function $dfec710f984d16ea$export$c5a301ffc0aba375(r, t, ...e) {
    return $dfec710f984d16ea$export$71be8ce002f52d80(t, r) ? (0, $gjNoZ.runPluginHook)(r, t, ...e) : !1;
}
function $dfec710f984d16ea$export$c2d2393498768378(r, t, e) {
    $dfec710f984d16ea$export$c5a301ffc0aba375("error", r, {
        hook: t,
        error: e
    }) || console.error(`[DOMQL] Lifecycle "${t}" error:`, e);
}
function $dfec710f984d16ea$export$5609811465949fc3(r, t) {
    try {
        $dfec710f984d16ea$export$c5a301ffc0aba375("renderError", r, t);
    } catch (e) {
        console.error("[smbls] renderError hook threw:", e);
    }
}

});


parcelRegister("hAgpL", function(module, exports) {

$parcel$export(module.exports, "mountRecord", () => $ccd2880e74d36a74$export$7e1aef6e8b7c04d7);
$parcel$export(module.exports, "mountPendingOf", () => $ccd2880e74d36a74$export$8324eb49f5233a98);
function $ccd2880e74d36a74$export$7e1aef6e8b7c04d7(n) {
    return n.__mount || (n.__mount = {
        pending: 0,
        tail: null,
        holder: null,
        waiters: null,
        chunkGen: 0,
        attachLater: !1,
        held: !1
    });
}
function $ccd2880e74d36a74$export$8324eb49f5233a98(n) {
    const t = n.__mount;
    return t ? t.pending : 0;
}

});

parcelRegister("fHfMu", function(module, exports) {

$parcel$export(module.exports, "addMethods", () => $b6d71cfd596a781c$export$626ce79af72fc3d3);
$parcel$export(module.exports, "refreshContextProto", () => $b6d71cfd596a781c$export$95c94b3cc462cf3f);

var $dBu6N = parcelRequire("dBu6N");

var $bCOVr = parcelRequire("bCOVr");

var $8gewL = parcelRequire("8gewL");
parcelRequire("dYaY2");
var $dSdIt = parcelRequire("dSdIt");

var $8NJs1 = parcelRequire("8NJs1");


parcelRequire("byww3");
var $cjyfe = parcelRequire("cjyfe");
var $2C0hZ = parcelRequire("2C0hZ");
var $kkSVW = parcelRequire("kkSVW");
function $b6d71cfd596a781c$var$_(t, e, o) {
    const n = t?.context?.analyze;
    if (!n || !n.emit || e === "warn" && !n.shouldCapture("warnings") || e === "error" && !n.shouldCapture("errors")) return;
    const r = o.map((i)=>i?.message || (typeof i == "string" ? i : null)).filter(Boolean).join(" ");
    n.emit({
        id: `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`,
        ts: Date.now(),
        type: e === "error" ? "error" : "warning",
        level: e,
        hook: e === "error" ? "el.error" : "el.warn",
        element: {
            key: t.key != null ? String(t.key) : null,
            name: t.__name || null,
            tag: t.tag || null
        },
        message: r || null,
        args: o
    });
}
const $b6d71cfd596a781c$var$y = new Set;
function $b6d71cfd596a781c$var$k(t, e, o) {
    const n = String(e);
    if ($b6d71cfd596a781c$var$y.has(n)) return;
    $b6d71cfd596a781c$var$y.add(n);
    const r = t?.__ref?.path, i = Array.isArray(r) && r.length ? r.join(".") : t?.key != null ? String(t.key) : "(unknown element)", f = o != null ? `resolves to a non-function (${typeof o}) \u2014 it cannot be called` : "is not registered in context.methods, context.functions, or context.utils, and is not an element method", c = `[smbls] el.call('${n}') at <${i}>: "${n}" ${f}. Returning undefined (unchanged behavior) \u2014 check the name for typos or register the function on the project. Warned once per name; repeat misses are silent.`;
    $b6d71cfd596a781c$var$_(t, "error", [
        c
    ]), console.error(c);
}
const $b6d71cfd596a781c$var$w = (t, e)=>Object.prototype.hasOwnProperty.call(t, e), $b6d71cfd596a781c$var$I = new Set, $b6d71cfd596a781c$var$m = (t)=>$b6d71cfd596a781c$var$w($b6d71cfd596a781c$export$474e10c2e087cf28, t) && !($cjyfe.ELEMENT_METHOD_OVERRIDE_POINTS || $b6d71cfd596a781c$var$I).has(t), $b6d71cfd596a781c$var$d = new Set, $b6d71cfd596a781c$export$beb5ec0241b65734 = ()=>{
    $b6d71cfd596a781c$var$d.clear();
};
function $b6d71cfd596a781c$var$S(t, e) {
    $b6d71cfd596a781c$var$d.has(t) || ($b6d71cfd596a781c$var$d.add(t), (0, $dSdIt.isLoudDevRuntime)() && console.warn(`[smbls] ${e}: context.methods.${t} is named like a built-in element method and is not the app's own override (it was not on the element prototype when it was built) \u2014 ignored; the built-in keeps winning. Declare an intentional override in the app's OWN methods.`));
}
function $b6d71cfd596a781c$var$Q(...t) {
    return $b6d71cfd596a781c$var$_(this, "warn", t), (0, $kkSVW.warn).apply(this, t);
}
function $b6d71cfd596a781c$var$U(...t) {
    return $b6d71cfd596a781c$var$_(this, "error", t), (0, $kkSVW.error).apply(this, t);
}
const $b6d71cfd596a781c$export$474e10c2e087cf28 = {
    update: (0, $dBu6N.update),
    remove: (0, $bCOVr.remove),
    getDB: (0, $kkSVW.getDB),
    getQuery: (0, $kkSVW.getQuery),
    getRootData: (0, $kkSVW.getRootData),
    getPath: (0, $kkSVW.getPath),
    nextElement: (0, $kkSVW.nextElement),
    previousElement: (0, $kkSVW.previousElement),
    verbose: (0, $kkSVW.verbose),
    warn: $b6d71cfd596a781c$var$Q,
    error: $b6d71cfd596a781c$var$U,
    variables: (0, $kkSVW.variables),
    spotByPath: (0, $kkSVW.spotByPath),
    set (t, e, o) {
        const n = this.__ref;
        if (n) {
            if (n.__setLocked) {
                n.__setQueued = {
                    content: t,
                    options: e
                };
                return;
            }
            n.__setLocked = !0;
        }
        let r;
        const i = t != null ? (0, $8NJs1.FEATURES).hydration : null, f = i && typeof i.handBack == "function" ? this.context?.__hydration : null, c = f && n?.__children && this.content?.__ref ? i.handBack(f, this.content) : null;
        try {
            if (this.removeContent(), t != null) {
                const s = this.context?.__create;
                try {
                    s && (r = s(t, this, "content", e, o));
                } finally{
                    c && i.settleHandBack(f, c);
                }
            }
            this.__ref && (this.__ref.contentManaged = !0);
        } finally{
            if (n) {
                n.__setLocked = !1;
                const s = n.__setQueued;
                s && (n.__setQueued = null, this.set(s.content, s.options));
            }
        }
        return r;
    },
    reset (t) {
        const e = this.context?.__create;
        if (!e) return this;
        const o = this.parent, n = this.key, r = this.parse();
        return this.remove(), e(r, o, n, t);
    },
    lookup (t) {
        let e = this.parent;
        for(; e;){
            if (typeof t == "function") {
                if (t(e)) return e;
            } else if (typeof t == "string") {
                if (e.key === t) return e;
                if (e[t] && e[t].__ref) return e[t];
            }
            e = e.parent;
        }
        return null;
    },
    whenConnected (t) {
        return (0, $8gewL.whenConnected)(this, t);
    },
    lookdown (t) {
        const e = this.__ref;
        if (!e?.__children) return null;
        for (const o of e.__children){
            const n = this[o];
            if (!n) continue;
            if (typeof t == "function") {
                if (t(n)) return n;
            } else if (typeof t == "string" && n.key === t) return n;
            const r = n.lookdown?.(t);
            if (r) return r;
        }
        return null;
    },
    lookdownAll (t, e = []) {
        const o = this.__ref;
        if (!o?.__children) return e;
        for (const n of o.__children){
            const r = this[n];
            r && (typeof t == "function" ? t(r) && e.push(r) : typeof t == "string" && r.key === t && e.push(r), r.lookdownAll?.(t, e));
        }
        return e;
    },
    getRef (t) {
        return t ? this.__ref && this.__ref[t] : this.__ref;
    },
    getChildren () {
        const t = this.__ref && this.__ref.__children;
        return Array.isArray(t) ? t.map((e)=>this[e]) : [];
    },
    getAdoption () {
        const t = this.__ref && this.__ref.__adoption;
        if (t) return t;
        if (this.node) return null;
        const e = (0, $8NJs1.FEATURES).hydration;
        return e && typeof e.foresee == "function" ? e.foresee(this) : null;
    },
    facesReady () {
        const t = (0, $8NJs1.FEATURES).faceWait;
        return t ? t.ready(this) : Promise.resolve([]);
    },
    checkFaces () {
        const t = (0, $8NJs1.FEATURES).faceWait;
        t && t.recheck(this);
    },
    getRoot: (0, $kkSVW.getRoot),
    getRootState: (0, $kkSVW.getRootState),
    getRootContext: (0, $kkSVW.getRootContext),
    getContext: (0, $kkSVW.getContext),
    parse (t) {
        const e = {}, o = t ? new Set(t) : null, n = this.__ref?.__exec;
        for(const r in this)if (!(r === "parent" || r === "node" || r === "__ref") && !o?.has(r)) {
            if (n && n[r] !== void 0) {
                e[r] = n[r];
                continue;
            }
            typeof this[r] != "function" && (e[r] = this[r]);
        }
        return e;
    },
    parseDeep (t) {
        const e = this.parse(t), o = this.__ref;
        if (o?.__children) for (const n of o.__children)this[n]?.parseDeep && (e[n] = this[n].parseDeep(t));
        return e;
    },
    keys () {
        return Object.keys(this);
    },
    log (...t) {
        if (t.length) {
            const e = {};
            for (const o of t)e[o] = this[o];
            console.log(e);
        } else console.log(this);
    },
    setProps (t, e) {
        return this.update(t, e);
    },
    setNodeStyles (t) {
        if (this.node?.style) for(const e in t){
            const o = t[e];
            if (o == null) continue;
            const n = e.replace(/[A-Z]/g, (i)=>"-" + i.toLowerCase()), r = String(o).replace(/\s*!important\s*$/, "");
            this.node.style.setProperty(n, r, "important");
        }
    },
    call (t, ...e) {
        const o = this.context, n = $b6d71cfd596a781c$var$m(t);
        n && o?.methods?.[t] && o.methods[t] !== this[t] && $b6d71cfd596a781c$var$S(t, "el.call");
        const r = n ? this[t] : o?.methods?.[t] || o?.functions?.[t] || o?.utils?.[t] || this[t];
        if (typeof r == "function") {
            const i = $2C0hZ.isFailedRevival;
            if (!i || !i(r)) return r.call(this, ...e);
            (0, $dSdIt.isLoudDevRuntime)() && $b6d71cfd596a781c$var$k(this, t, $2C0hZ.getFunctionSource(r));
            return;
        }
        (0, $dSdIt.isLoudDevRuntime)() && $b6d71cfd596a781c$var$k(this, t, r);
    },
    removeContent () {
        const t = this.__ref;
        if (!t?.__children) return;
        const e = this.content;
        if (e?.remove) {
            e.remove(), delete this.content;
            const o = t.__children.indexOf("content");
            o !== -1 && t.__children.splice(o, 1);
        }
        e?.node?.parentNode && e.node.parentNode.removeChild(e.node);
    }
}, $b6d71cfd596a781c$var$p = new WeakMap;
function $b6d71cfd596a781c$var$z(t) {
    if (!t) return $b6d71cfd596a781c$export$474e10c2e087cf28;
    let e = $b6d71cfd596a781c$var$p.get(t);
    if (e) return e;
    e = Object.create($b6d71cfd596a781c$export$474e10c2e087cf28);
    const o = t.methods;
    if (o) for(const n in o)e[n] = o[n];
    return $b6d71cfd596a781c$var$p.set(t, e), e;
}
function $b6d71cfd596a781c$export$626ce79af72fc3d3(t) {
    const e = $b6d71cfd596a781c$var$z(t.context);
    Object.setPrototypeOf(t, e);
}
function $b6d71cfd596a781c$export$95c94b3cc462cf3f(t) {
    if (!t) return !1;
    const e = $b6d71cfd596a781c$var$p.get(t);
    if (!e) return !1;
    const o = t.methods;
    if (!o) return !1;
    for(const n in o){
        if ($b6d71cfd596a781c$var$m(n) && !$b6d71cfd596a781c$var$w(e, n)) {
            $b6d71cfd596a781c$var$S(n, "refreshContextProto");
            continue;
        }
        e[n] = o[n];
    }
    return !0;
}

});
parcelRegister("dBu6N", function(module, exports) {

$parcel$export(module.exports, "update", () => $9e7616057ab0ed6d$export$722fbec263ad908a);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $aBPRx = parcelRequire("aBPRx");

var $6yBlx = parcelRequire("6yBlx");

var $jdWhC = parcelRequire("jdWhC");

var $ewXm2 = parcelRequire("ewXm2");
function $9e7616057ab0ed6d$export$722fbec263ad908a(o = {}, f = {}) {
    const t = this, i = t.__ref;
    if (!i) return;
    if ((typeof o == "string" || typeof o == "number") && (o = {
        text: o
    }), !f.preventListeners && typeof t.onBeforeUpdate == "function" && (0, $6yBlx.acquireBeforeUpdateGuard)(i)) try {
        const e = t.onBeforeUpdate(t, t.state, t.context, f);
        if (e && typeof e.then == "function") e.then(()=>(0, $6yBlx.releaseBeforeUpdateGuard)(i, !1), (n)=>{
            (0, $6yBlx.releaseBeforeUpdateGuard)(i, !0), (0, $jdWhC.dispatchPluginHook)("error", t, {
                hook: "onBeforeUpdate",
                error: n
            }) || console.error("[DOMQL] onBeforeUpdate error:", n);
        });
        else if ((0, $6yBlx.releaseBeforeUpdateGuard)(i, !1), e === !1) return t;
    } catch (e) {
        throw (0, $6yBlx.releaseBeforeUpdateGuard)(i, !0), e;
    }
    const a = !o || Object.keys(o).length === 0, c = [];
    let d = !1;
    (0, $4VQqJ.batch)(()=>{
        if (o.state && (0, $4VQqJ.isStore)(t.state) && t.state.$update(o.state), o.text !== void 0 && (t.text = o.text, !i.__exec.text && t.node && (0, $6yBlx.writeElementText)(t, o.text ?? "")), o.html !== void 0 && (t.html = o.html, !i.__exec.html && t.node && (t.node.innerHTML = o.html)), o.style && t.node?.style) {
            if (!i.__exec.style) {
                const e = (0, $6yBlx.resolveStyleBlock)(t, o.style);
                for(const n in e){
                    const r = e[n];
                    if (r == null) continue;
                    const s = (0, $ewXm2.cssPropName)(n), y = String(r).replace(/\s*!important\s*$/, "");
                    t.node.style.setProperty(s, y, "important");
                }
            }
            t.style || (t.style = {}), Object.assign(t.style, o.style);
        }
        if (o.attr && t.node?.setAttribute) {
            for(const e in o.attr){
                const n = o.attr[e];
                (0, $6yBlx.writeAttr)(t.node, e, n);
            }
            t.attr || (t.attr = {}), Object.assign(t.attr, o.attr);
        }
        if (o.data && t.node?.dataset) {
            for(const e in o.data)t.node.dataset[e] = o.data[e];
            t.data || (t.data = {}), Object.assign(t.data, o.data);
        }
        if (o.vars && typeof o.vars == "object" && !Array.isArray(o.vars)) {
            const e = t.vars && typeof t.vars == "object" && !Array.isArray(t.vars) ? t.vars : null;
            t.vars = {
                ...e,
                ...o.vars
            }, d = !0;
        }
        for(const e in o){
            if ((0, $aBPRx.REGISTRY).has(e) || e === "state") continue;
            const n = o[e], r = t[e];
            if (r && r.__ref && typeof r.update == "function") r.update(n, f);
            else if (typeof n == "object" && n !== null) {
                const s = e.charCodeAt(0);
                s >= 65 && s <= 90 && (0, $6yBlx.create)(n, t, e, f);
            } else e !== "text" && e !== "html" && e !== "style" && e !== "attr" && e !== "data" && (t[e] = n, typeof n != "function" && c.push(e));
        }
    });
    for(let e = 0; e < c.length; e++)(0, $6yBlx.reconcileAttrProp)(t, c[e]);
    if (t.node) {
        let e = d;
        for(let n = 0; !e && n < c.length; n++)(0, $6yBlx.isStaticCssProp)(c[n]) && (e = !0);
        e && (0, $6yBlx.recompileStaticCss)(t);
    }
    if (t.node && a && i.__effects && i.__effects.length) for(let e = 0; e < i.__effects.length; e++){
        const n = i.__effects[e];
        n && !n._disposed && !n._isSubscribeToEffect && typeof n._execute == "function" && n._execute();
    }
    else if (t.node && i.__conditionalRunners) for (const e of i.__conditionalRunners)e();
    return (0, $jdWhC.dispatchPluginHook)("update", t), !f.preventListeners && typeof t.onUpdate == "function" && t.onUpdate(t, t.state, t.context, f), t;
}
var $9e7616057ab0ed6d$export$2e2bcd8739ae039 = $9e7616057ab0ed6d$export$722fbec263ad908a;

});

parcelRegister("bCOVr", function(module, exports) {

$parcel$export(module.exports, "remove", () => $876abf0ba1411091$export$cd7f480d6b8286c3);
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $1H9Q8 = parcelRequire("1H9Q8");

var $bF2FJ = parcelRequire("bF2FJ");

var $8NJs1 = parcelRequire("8NJs1");

var $8gewL = parcelRequire("8gewL");
function $876abf0ba1411091$export$fcfbbcec2cb820d5(r) {
    if (!r) return;
    const _ = r.__ref;
    if (!_) return;
    if (_.__onConnected && (0, $8gewL.forgetConnected)(r), (0, $4VQqJ.getObserver)()) return (0, $1H9Q8.untrack)(()=>$876abf0ba1411091$export$fcfbbcec2cb820d5(r));
    _.__disposed = !0, (_.__faceWait || _.__faceWaitLate) && (0, $8NJs1.FEATURES).faceWait !== null && (0, $8NJs1.FEATURES).faceWait.dispose(r);
    const a = _.__if === !1 && !_.__ifInitialized;
    if (!a) try {
        typeof r.onBeforeRemove == "function" && r.onBeforeRemove(r, r.state, r.context);
    } catch (i) {
        console.error("[smbls] onBeforeRemove error:", i);
    }
    if (_.__bridge && (0, $bF2FJ.destroyBridge)(r), _.__effects) {
        for(let i = 0; i < _.__effects.length; i++)_.__effects[i].dispose();
        _.__effects.length = 0;
    }
    if (typeof _.__releaseMedia == "function" && (_.__releaseMedia(), _.__releaseMedia = null), _.__eventCleanup) {
        for(let i = 0; i < _.__eventCleanup.length; i++)_.__eventCleanup[i]();
        _.__eventCleanup.length = 0;
    }
    if (_.__children) {
        const i = _.__children.slice();
        _.__children.length = 0;
        for(let f = 0; f < i.length; f++){
            const o = r[i[f]];
            o && o.__ref && $876abf0ba1411091$export$fcfbbcec2cb820d5(o);
        }
    }
    if (_.__ifParked && _.__ifParked.size) {
        const i = [
            ..._.__ifParked
        ];
        _.__ifParked.clear();
        for(let f = 0; f < i.length; f++){
            const o = r[i[f]];
            o && o.__ref && o.parent === r && $876abf0ba1411091$export$fcfbbcec2cb820d5(o);
        }
    }
    const n = (0, $8NJs1.FEATURES).hydration !== null ? r.context?.__replacing : void 0;
    n && (0, $8NJs1.FEATURES).hydration.releaseReplaced(n, r), _.__keepNode ? _.__keepNode = !1 : r.node?.parentNode ? r.node.remove() : r.tag === "fragment" && _.__fragmentAnchor?.parentNode && _.__fragmentAnchor.remove();
    const s = r.state?.$destroy || r.state?.destroy;
    if (typeof s == "function" && r.state.__element === r && s.call(r.state), r.parent?.__ref?.__children) {
        const i = r.parent.__ref.__children.indexOf(r.key);
        i !== -1 && r.parent.__ref.__children.splice(i, 1), r.parent.__ref.__ifParked && r.parent.__ref.__ifParked.delete(r.key), delete r.parent[r.key];
    }
    if (!a) try {
        typeof r.onRemove == "function" && r.onRemove(r);
    } catch (i) {
        console.error("[smbls] onRemove error:", i);
    }
    _.__mount && _.__mount.tail && (0, $8NJs1.FEATURES).mount.abandon(r, _), r.node = null, r.parent = null, r.__ref = null;
}
function $876abf0ba1411091$export$cd7f480d6b8286c3() {
    $876abf0ba1411091$export$fcfbbcec2cb820d5(this);
}

});


parcelRegister("1hCtT", function(module, exports) {

$parcel$export(module.exports, "resolveElementIdEngine", () => $0ef53a874a7d58ed$export$820b714454a32733);

var $1silJ = parcelRequire("1silJ");
const $0ef53a874a7d58ed$export$77df6d698d949909 = "__SMBLS_ELEMENT_ID_ENGINE__", $0ef53a874a7d58ed$export$820b714454a32733 = (e, o, r)=>{
    const l = o || (0, $1silJ.VERSION), t = r || (typeof globalThis < "u" ? globalThis : null);
    if (!t) return e;
    const n = t[$0ef53a874a7d58ed$export$77df6d698d949909];
    return n && n.engine && n.version === l ? n.engine : (n || (t[$0ef53a874a7d58ed$export$77df6d698d949909] = {
        version: l,
        engine: e
    }), e);
}, $0ef53a874a7d58ed$export$1f093d34b3855c8a = (e)=>{
    const o = e || (typeof globalThis < "u" ? globalThis : null);
    o && delete o[$0ef53a874a7d58ed$export$77df6d698d949909];
};

});
parcelRegister("1silJ", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $10f6a3cf5d09dcff$export$a4ad2735b021c132);
const $10f6a3cf5d09dcff$export$a4ad2735b021c132 = "3.14.832";

});


parcelRegister("gwMPl", function(module, exports) {

$parcel$export(module.exports, "isAttributeFirst", () => $c08582884f8be34c$export$fcecddb1cf39b4c5);
$parcel$export(module.exports, "isCssProp", () => $c08582884f8be34c$export$9131c2bd924e6483);

var $gBDdH = parcelRequire("gBDdH");

var $fe4kH = parcelRequire("fe4kH");
var $4XTEI = parcelRequire("4XTEI");
const $c08582884f8be34c$export$a44032cbe984c678 = new Set([
    "rows",
    "cols",
    "wrap",
    "fill",
    "stroke",
    "offset"
]), $c08582884f8be34c$export$fcecddb1cf39b4c5 = (o, t)=>$c08582884f8be34c$export$a44032cbe984c678.has(t) && (0, $gBDdH.checkAttributeByTagName)(o, t), $c08582884f8be34c$export$9131c2bd924e6483 = (o, t)=>!!((0, $fe4kH.CSS_PROPS_REGISTRY)[t] || (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST) && (0, $4XTEI.DEFAULT_CSS_PROPERTIES_LIST).has(t)) && !$c08582884f8be34c$export$fcecddb1cf39b4c5(o, t);

});



parcelRegister("1UaPr", function(module, exports) {

$parcel$export(module.exports, "hydrationFeature", () => $16336bc7dde11a72$export$2b8c184cfdfcf04d);
parcelRequire("byww3");
var $5zSXA = parcelRequire("5zSXA");

var $87g1D = parcelRequire("87g1D");
const $16336bc7dde11a72$var$O = new Set([
    "src",
    "srcset"
]), $16336bc7dde11a72$var$S = new Set([
    "class",
    "style",
    "id",
    "data-br"
]), $16336bc7dde11a72$var$m = new Set([
    "sizes",
    "loading",
    "fetchpriority",
    "decoding",
    "crossorigin",
    "referrerpolicy",
    "width",
    "height"
]), $16336bc7dde11a72$var$C = new Set([
    "sizes",
    "media",
    "type",
    "width",
    "height"
]), $16336bc7dde11a72$var$R = (e)=>e === "img" ? $16336bc7dde11a72$var$m : e === "source" ? $16336bc7dde11a72$var$C : null, $16336bc7dde11a72$var$L = (e)=>e.charCodeAt(0) === 97 && e.startsWith("aria-") || e.charCodeAt(0) === 100 && e.startsWith("data-") && e !== "data-br" && e !== "data-key", $16336bc7dde11a72$var$N = (e, t)=>{
    for (const n of t){
        const r = e.nodes.get(n.target);
        r && (r.delete(n.attributeName), r.size || e.nodes.delete(n.target));
    }
}, $16336bc7dde11a72$var$P = (e, t, n)=>{
    let r = e.built;
    if (!r) {
        const o = t.ownerDocument && t.ownerDocument.defaultView && t.ownerDocument.defaultView.MutationObserver || (typeof MutationObserver == "function" ? MutationObserver : null);
        if (!o) return !1;
        const s = new Map;
        r = e.built = {
            nodes: s,
            observer: null
        }, r.observer = new o((a)=>$16336bc7dde11a72$var$N(r, a));
    }
    return r.nodes.set(t, new Set(n)), r.observer.observe(t, {
        attributes: !0,
        attributeFilter: n
    }), !0;
};
function $16336bc7dde11a72$export$b9bd432eae378efa(e) {
    const t = e && e.built;
    if (!t) return 0;
    e.built = null, $16336bc7dde11a72$var$N(t, t.observer.takeRecords()), t.observer.disconnect();
    let n = 0;
    for (const [r, o] of t.nodes)for (const s of o)r.hasAttribute(s) && (r.removeAttribute(s), n++);
    return t.nodes.clear(), n;
}
function $16336bc7dde11a72$export$8066a111e2505fa9(e) {
    const t = e?.context?.__hydration;
    if (!t) return null;
    const n = e.tag = (0, $87g1D.detectTag)(e);
    if (n === "string" || n === "fragment") return null;
    const r = (0, $5zSXA.elementPath)(e), o = t.registry[r === "" ? "__root" : r], s = o !== void 0 ? t.nodes[o] : null;
    if (!s || s.nodeType !== 1 || t.claimed.has(s)) return o !== void 0 && t.misses++, null;
    const a = (0, $87g1D.isSvgTag)(n) && (n === "svg" || e.parent?.node?.namespaceURI === (0, $87g1D.SVG_NS)), l = (0, $87g1D.isSvgTag)(n) && !a && n !== "svg" ? "div" : n, c = a ? s.namespaceURI === (0, $87g1D.SVG_NS) : s.namespaceURI !== (0, $87g1D.SVG_NS);
    if (s.localName !== l || !c) return t.misses++, null;
    t.claimed.add(s), t.adopted++, e.__ref && (e.__ref.__adoption = "adopted");
    const u = t.pending;
    if (u && u.delete(s)) {
        const i = s.parentNode, b = i ? (t.pendingIn.get(i) || 1) - 1 : 0;
        b > 0 ? t.pendingIn.set(i, b) : i && t.pendingIn.delete(i);
    }
    let f = null, g = null;
    const _ = $16336bc7dde11a72$var$R(s.localName);
    for (const i of Array.from(s.getAttributeNames ? s.getAttributeNames() : []))$16336bc7dde11a72$var$O.has(i) || i === "data-key" || ($16336bc7dde11a72$var$S.has(i) || (g || (g = new Map)).set(i, s.getAttribute(i)), !(_ && _.has(i)) && ($16336bc7dde11a72$var$L(i) ? (f || (f = [])).push(i) : s.removeAttribute(i)));
    if (f && !$16336bc7dde11a72$var$P(t, s, f)) for (const i of f)s.removeAttribute(i);
    if (g && e.__ref && (e.__ref.__builtAttrs = {
        node: s,
        values: g
    }), u) {
        let i = 0, b = 0;
        const k = s.firstChild, d = e.text != null && k && k.nodeType === 3 && !u.has(k) ? k : null;
        d && e.__ref && (e.__ref.__builtText = d);
        for(let h = s.firstChild; h;){
            const T = h.nextSibling;
            h !== d && !u.has(h) && (h.nodeType === 3 ? i++ : h.nodeType !== 8 && b++, s.removeChild(h)), h = T;
        }
        (b || i > (e.text != null && !d ? 1 : 0)) && (t.whole || (t.whole = new Set)).add(e);
    } else for(; s.firstChild;)s.removeChild(s.firstChild);
    return s.localName === "img" && s.complete && s.naturalWidth > 0 && $16336bc7dde11a72$var$W(s), s;
}
const $16336bc7dde11a72$var$B = 500;
function $16336bc7dde11a72$var$W(e) {
    let t = !1, n = !1;
    const r = (o)=>{
        o.isTrusted && (n ? o.stopImmediatePropagation() : t = !0, e.removeEventListener("load", r, !0));
    };
    e.addEventListener("load", r, !0), setTimeout(()=>{
        if (!t) {
            if (!(e.complete && e.naturalWidth > 0)) {
                e.removeEventListener("load", r, !0);
                return;
            }
            n = !0, e.dispatchEvent(new Event("load")), setTimeout(()=>e.removeEventListener("load", r, !0), $16336bc7dde11a72$var$B);
        }
    }, 0);
}
function $16336bc7dde11a72$export$134231d33cf28e66(e, t, n, r, o) {
    if (o.parentNode === r && e.claimed.has(o)) return !0;
    const s = e.pendingIn;
    if (!s || !s.has(r)) return !1;
    let a;
    const l = n && n.__ref, c = l && l.__children, u = c ? c.lastIndexOf(t.key) : -1;
    for(let f = u - 1; f >= 0; f--){
        const g = n[c[f]], _ = g && g.node;
        if (_ && _ !== o && _.parentNode === r) {
            a = _.nextSibling;
            break;
        }
    }
    return a === void 0 && (a = (0, $87g1D.firstSlotAfterText)(r, l && l.__textNode)), a === o || r.insertBefore(o, a), !0;
}
function $16336bc7dde11a72$export$68a9a72b819375d6(e, t) {
    const n = e.whole;
    if (!n) return !1;
    if (n.has(t)) return !0;
    const r = t.parent;
    return !r || !n.has(r) ? !1 : (n.add(t), !0);
}
function $16336bc7dde11a72$export$f73b52344e850790(e, t) {
    const n = t && t.__ref, r = t && t.node;
    if (!n || !r || !e.pending || !e.claimed.has(r)) return null;
    const o = r.parentNode;
    return o ? (e.claimed.delete(r), e.adopted--, e.pending.add(r), e.pendingIn.set(o, (e.pendingIn.get(o) || 0) + 1), n.__keepNode = !0, r) : null;
}
function $16336bc7dde11a72$export$bb20bc69e19abafd(e, t) {
    if (!t || !e.pending || !e.pending.delete(t)) return;
    const n = t.parentNode;
    if (n) {
        const r = (e.pendingIn.get(n) || 1) - 1;
        r > 0 ? e.pendingIn.set(n, r) : e.pendingIn.delete(n), t.remove();
    }
}
const $16336bc7dde11a72$var$p = "\0", $16336bc7dde11a72$var$w = "#";
function $16336bc7dde11a72$export$e3d6746a3db95274(e) {
    const t = new Set, n = new Map, r = (o, s)=>{
        const a = o.getAttribute("data-key"), l = a === null ? s : s ? s + $16336bc7dde11a72$var$p + a : $16336bc7dde11a72$var$w;
        if (l) {
            const c = l + $16336bc7dde11a72$var$p + o.localName, u = n.get(c) || 0;
            n.set(c, u + 1), t.add(c + $16336bc7dde11a72$var$p + u);
        }
        for (const c of o.children)r(c, l);
    };
    for (const o of e || [])o && o.nodeType === 1 && r(o, "");
    return {
        places: t,
        chains: new WeakMap,
        taken: new Map,
        slots: new WeakMap
    };
}
const $16336bc7dde11a72$var$E = (e)=>{
    const t = [];
    for(let n = e; n; n = n.parent){
        const r = n.node, o = r && r.nodeType === 1 ? r.getAttribute("data-key") : null;
        o !== null && t.push(o);
    }
    return t.length ? (t.pop(), t.length ? $16336bc7dde11a72$var$w + $16336bc7dde11a72$var$p + t.reverse().join($16336bc7dde11a72$var$p) : $16336bc7dde11a72$var$w) : "";
};
function $16336bc7dde11a72$export$911d275e729f706f(e, t, n) {
    const r = t.parent;
    let o = r ? e.chains.get(r) : "";
    o === void 0 && (o = $16336bc7dde11a72$var$E(r));
    const s = n.nodeType === 1 && t.key ? o ? o + $16336bc7dde11a72$var$p + t.key : $16336bc7dde11a72$var$w : o;
    if (e.chains.set(t, s), n.nodeType !== 1 || !s) return;
    const a = s + $16336bc7dde11a72$var$p + n.localName;
    let l = e.taken.get(a);
    l || e.taken.set(a, l = new Set);
    let c = 0;
    for(; l.has(c);)c++;
    l.add(c), e.slots.set(t, [
        a,
        c
    ]), e.places.has(a + $16336bc7dde11a72$var$p + c) && t.__ref && (t.__ref.__adoption = "replaced");
}
function $16336bc7dde11a72$export$571fa92a153b2e1d(e) {
    const t = e && e.context;
    if (!t || !t.__hydration && !t.__replacing) return null;
    const n = typeof e.tag == "string" ? e.tag : (0, $87g1D.detectTag)(e);
    if (n === "string" || n === "fragment") return null;
    const r = (0, $87g1D.isSvgTag)(n) && (n === "svg" || e.parent?.node?.namespaceURI === (0, $87g1D.SVG_NS)), o = (0, $87g1D.isSvgTag)(n) && !r && n !== "svg" ? "div" : n, s = t.__hydration;
    if (s) {
        const b = (0, $5zSXA.elementPath)(e), k = s.registry[b === "" ? "__root" : b], d = k !== void 0 ? s.nodes[k] : null;
        if (!d || d.nodeType !== 1 || s.claimed.has(d)) return null;
        const h = r ? d.namespaceURI === (0, $87g1D.SVG_NS) : d.namespaceURI !== (0, $87g1D.SVG_NS);
        return d.localName === o && h ? "adopted" : null;
    }
    const a = t.__replacing;
    if (!e.key) return null;
    const l = e.parent;
    let c = l ? a.chains.get(l) : "";
    c === void 0 && (c = $16336bc7dde11a72$var$E(l));
    const u = c ? c + $16336bc7dde11a72$var$p + e.key : $16336bc7dde11a72$var$w, f = r ? o : String(o).toLowerCase(), g = u + $16336bc7dde11a72$var$p + f, _ = a.taken.get(g);
    let i = 0;
    for(; _ && _.has(i);)i++;
    return a.places.has(g + $16336bc7dde11a72$var$p + i) ? "replaced" : null;
}
function $16336bc7dde11a72$export$f6d059efa1507889(e, t) {
    const n = e.slots.get(t);
    if (!n) return;
    e.slots.delete(t);
    const r = e.taken.get(n[0]);
    r && r.delete(n[1]);
}
const $16336bc7dde11a72$export$2b8c184cfdfcf04d = {
    adopt: $16336bc7dde11a72$export$8066a111e2505fa9,
    place: $16336bc7dde11a72$export$134231d33cf28e66,
    whole: $16336bc7dde11a72$export$68a9a72b819375d6,
    settle: $16336bc7dde11a72$export$b9bd432eae378efa,
    handBack: $16336bc7dde11a72$export$f73b52344e850790,
    settleHandBack: $16336bc7dde11a72$export$bb20bc69e19abafd,
    markReplaced: $16336bc7dde11a72$export$911d275e729f706f,
    releaseReplaced: $16336bc7dde11a72$export$f6d059efa1507889,
    foresee: $16336bc7dde11a72$export$571fa92a153b2e1d
};

});

parcelRegister("4ZlRD", function(module, exports) {

$parcel$export(module.exports, "mountYieldFeature", () => $3a1dd1acc04e50f3$export$93432533a747abc1);

var $bgB1J = parcelRequire("bgB1J");

var $6yBlx = parcelRequire("6yBlx");

var $hAgpL = parcelRequire("hAgpL");

var $8NJs1 = parcelRequire("8NJs1");
function $3a1dd1acc04e50f3$var$G(n, r) {
    const t = r && r.mountYield;
    if (!t && !n.yieldChildren) return 0;
    const o = (0, $8NJs1.FEATURES).hydration !== null && n.context ? n.context.__hydration : null;
    if (o && (0, $8NJs1.FEATURES).hydration.whole(o, n)) return 0;
    const u = t ? (0, $bgB1J.mountYieldBudget)(t) : 0, e = (0, $bgB1J.mountYieldBudget)(n.yieldChildren);
    return u && e ? u < e ? u : e : u || e;
}
function $3a1dd1acc04e50f3$var$S(n, r, t, o, u) {
    (0, $bgB1J.openMountBudget)(o);
    try {
        $3a1dd1acc04e50f3$var$M(n, n.__ref, 0, r, t, o, u, !1);
    } finally{
        (0, $bgB1J.closeMountBudget)();
    }
}
function $3a1dd1acc04e50f3$var$M(n, r, t, o, u, e, f, s) {
    try {
        for(let i = t; i < o; i++){
            const c = r.__mount, l = c ? c.pending : 0;
            if (u(i) === !1) continue;
            if (r.__disposed) break;
            const d = (0, $bgB1J.mountTick)(), a = r.__mount;
            if (i + 1 < o && (d || (a ? a.pending : 0) > l)) {
                f && f.onSuspend && f.onSuspend(), s || (0, $bgB1J.holdMount)(n);
                const m = i + 1;
                (0, $bgB1J.enqueueMountWork)(()=>$3a1dd1acc04e50f3$var$T(n, r, m, o, u, e, f), e, (0, $bgB1J.mountLeaseOf)(n));
                return;
            }
        }
    } catch (i) {
        if (!s) throw i;
        (0, $6yBlx.reportCreateChildrenError)(n, i);
    }
    s && (0, $bgB1J.settleMount)(n);
}
function $3a1dd1acc04e50f3$var$T(n, r, t, o, u, e, f) {
    if (r.__disposed || f && f.isStale && f.isStale()) {
        (0, $bgB1J.settleMount)(n);
        return;
    }
    $3a1dd1acc04e50f3$var$M(n, r, t, o, u, e, f, !0);
}
function $3a1dd1acc04e50f3$var$q(n, r, t) {
    (0, $bgB1J.holdMount)(n), (0, $bgB1J.enqueueMountWork)(()=>{
        try {
            const o = n.__ref;
            o && !o.__disposed && t();
        } catch (o) {
            (0, $6yBlx.reportCreateChildrenError)(n, o);
        } finally{
            (0, $bgB1J.settleMount)(n);
        }
    }, r, (0, $bgB1J.mountLeaseOf)(n));
}
function $3a1dd1acc04e50f3$var$D(n, r, t, o) {
    const u = n.__ref, e = (0, $hAgpL.mountRecord)(u), f = ++e.chunkGen, s = n.node, i = [];
    let c = !1;
    $3a1dd1acc04e50f3$var$S(n, r, (l)=>{
        const d = t(l, c ? (0, $6yBlx.rowAttach)(n, $3a1dd1acc04e50f3$var$I(s, i)) : void 0), a = $3a1dd1acc04e50f3$var$R(d);
        return a ? i.push(a) : d && d.__ref.__mount && d.__ref.__mount.held && i.push(d), d;
    }, o, {
        isStale: ()=>e.chunkGen !== f,
        onSuspend: ()=>{
            c = !0;
        }
    });
}
function $3a1dd1acc04e50f3$var$R(n) {
    const r = (0, $6yBlx.placedRowNode)(n);
    if (r) return r;
    const t = n && n.__ref;
    return t && t.__if !== !1 && n.tag === "fragment" && t.__fragmentAnchor || null;
}
function $3a1dd1acc04e50f3$var$I(n, r) {
    for(let t = r.length - 1; t >= 0; t--){
        const o = r[t].__ref ? $3a1dd1acc04e50f3$var$R(r[t]) : r[t];
        if (o && o.parentNode === n) return o;
    }
    return null;
}
function $3a1dd1acc04e50f3$var$L(n, r) {
    const t = n.__ref;
    try {
        (0, $6yBlx.syncSelectValue)(n, !0), (0, $6yBlx.attachWhole)(n), (0, $6yBlx.completeCreate)(n, r);
    } finally{
        (0, $bgB1J.settleMountWaiters)(n, t);
        const o = t.__mount, u = o && o.holder;
        u && (o.holder = null, (0, $bgB1J.settleMount)(u));
    }
}
const $3a1dd1acc04e50f3$export$93432533a747abc1 = {
    budgetOf: $3a1dd1acc04e50f3$var$G,
    run: $3a1dd1acc04e50f3$var$S,
    rows: $3a1dd1acc04e50f3$var$D,
    defer: $3a1dd1acc04e50f3$var$q,
    hold: (0, $bgB1J.holdMount),
    finish: $3a1dd1acc04e50f3$var$L,
    abandon: (0, $bgB1J.abandonMount)
};

});
parcelRegister("bgB1J", function(module, exports) {

$parcel$export(module.exports, "mountYieldBudget", () => $833de91d497cd656$export$4577d2228cf45ddf);
$parcel$export(module.exports, "mountTick", () => $833de91d497cd656$export$9112d350ef5c8134);
$parcel$export(module.exports, "openMountBudget", () => $833de91d497cd656$export$ca66cc2b9982f69d);
$parcel$export(module.exports, "closeMountBudget", () => $833de91d497cd656$export$f6bed56c2326f55a);
$parcel$export(module.exports, "enqueueMountWork", () => $833de91d497cd656$export$91122e62d8d35a0c);
$parcel$export(module.exports, "mountLeaseOf", () => $833de91d497cd656$export$1f57d5ba4c8d5f52);
$parcel$export(module.exports, "whenMountIdle", () => $833de91d497cd656$export$2b1e5058ee1f4d17);
$parcel$export(module.exports, "mountIdle", () => $833de91d497cd656$export$db22bd65afe40d6b);
$parcel$export(module.exports, "holdMount", () => $833de91d497cd656$export$6d10a3007befff5);
$parcel$export(module.exports, "releaseMount", () => $833de91d497cd656$export$b8b702516a2fa7d0);
$parcel$export(module.exports, "mountPending", () => $833de91d497cd656$export$a8a94c549f413c60);
$parcel$export(module.exports, "whenMounted", () => $833de91d497cd656$export$960d6e20ba336959);
$parcel$export(module.exports, "settleMountWaiters", () => $833de91d497cd656$export$c9d02ff59937b642);
$parcel$export(module.exports, "abandonMount", () => $833de91d497cd656$export$e9a2f6d476b14f8c);
$parcel$export(module.exports, "settleMount", () => $833de91d497cd656$export$b8b702516a2fa7d0);

var $hAgpL = parcelRequire("hAgpL");
const $833de91d497cd656$export$4d1c58c78979557d = 50;
function $833de91d497cd656$export$4577d2228cf45ddf(t) {
    return t === !0 ? $833de91d497cd656$export$4d1c58c78979557d : typeof t == "number" && t > 0 ? t : 0;
}
const $833de91d497cd656$var$r = [];
let $833de91d497cd656$var$l = !1, $833de91d497cd656$var$i = 0, $833de91d497cd656$var$f = $833de91d497cd656$export$4d1c58c78979557d, $833de91d497cd656$var$a = !1, $833de91d497cd656$var$x = [];
const $833de91d497cd656$var$d = typeof performance < "u" && typeof performance.now == "function" ? ()=>performance.now() : ()=>Date.now(), $833de91d497cd656$var$M = [];
let $833de91d497cd656$var$h = null;
function $833de91d497cd656$var$D(t) {
    if (!$833de91d497cd656$var$h) {
        const e = new MessageChannel;
        e.port1.onmessage = ()=>{
            const n = $833de91d497cd656$var$M.shift();
            !$833de91d497cd656$var$M.length && typeof e.port1.unref == "function" && e.port1.unref(), n && n();
        }, $833de91d497cd656$var$h = e;
    }
    $833de91d497cd656$var$M.push(t), $833de91d497cd656$var$M.length === 1 && typeof $833de91d497cd656$var$h.port1.ref == "function" && $833de91d497cd656$var$h.port1.ref(), $833de91d497cd656$var$h.port2.postMessage(0);
}
function $833de91d497cd656$var$w(t) {
    const e = typeof globalThis < "u" ? globalThis.scheduler : null;
    if (e && typeof e.yield == "function") {
        e.yield().then(t, t);
        return;
    }
    if (typeof setImmediate == "function") {
        setImmediate(t);
        return;
    }
    if (typeof MessageChannel == "function") {
        $833de91d497cd656$var$D(t);
        return;
    }
    setTimeout(t, 0);
}
function $833de91d497cd656$export$8af9927c09321dd4() {
    return new Promise((t)=>$833de91d497cd656$var$w(t));
}
function $833de91d497cd656$export$8ae8e59a7f77afd1(t = 0, e) {
    return !$833de91d497cd656$var$i || (e || $833de91d497cd656$var$d()) - $833de91d497cd656$var$i + t < $833de91d497cd656$var$f ? !1 : ($833de91d497cd656$var$a = !0, !0);
}
let $833de91d497cd656$var$g = 0, $833de91d497cd656$var$k = 0, $833de91d497cd656$var$y = 0, $833de91d497cd656$var$p = 0;
function $833de91d497cd656$var$T() {
    $833de91d497cd656$var$g = 0, $833de91d497cd656$var$k = $833de91d497cd656$var$i, $833de91d497cd656$var$y = 0, $833de91d497cd656$var$p = 0;
}
function $833de91d497cd656$export$9112d350ef5c8134() {
    if (!$833de91d497cd656$var$i) return !1;
    if ($833de91d497cd656$var$g++, $833de91d497cd656$var$p > 0) return $833de91d497cd656$var$p--, !1;
    const t = $833de91d497cd656$var$d(), e = t - $833de91d497cd656$var$i, n = e / $833de91d497cd656$var$g, o = (t - $833de91d497cd656$var$k) / ($833de91d497cd656$var$g - $833de91d497cd656$var$y), c = o > n ? o : n;
    $833de91d497cd656$var$k = t, $833de91d497cd656$var$y = $833de91d497cd656$var$g;
    const P = $833de91d497cd656$var$f - e - c;
    return P <= 0 ? ($833de91d497cd656$var$a = !0, !0) : ($833de91d497cd656$var$p = c > 0 ? Math.floor(P / c / 2) : 0, !1);
}
let $833de91d497cd656$var$s = 0;
function $833de91d497cd656$export$ca66cc2b9982f69d(t = $833de91d497cd656$export$4d1c58c78979557d) {
    $833de91d497cd656$var$s === 0 && !$833de91d497cd656$var$i ? ($833de91d497cd656$var$i = $833de91d497cd656$var$d(), $833de91d497cd656$var$a = !1, $833de91d497cd656$var$f = t, $833de91d497cd656$var$T()) : t < $833de91d497cd656$var$f && ($833de91d497cd656$var$f = t, $833de91d497cd656$var$p = 0), $833de91d497cd656$var$s++;
}
let $833de91d497cd656$var$u = null, $833de91d497cd656$var$I = !1;
const $833de91d497cd656$var$E = typeof queueMicrotask == "function" ? queueMicrotask : (t)=>Promise.resolve().then(t);
function $833de91d497cd656$var$m() {
    $833de91d497cd656$var$i = 0, $833de91d497cd656$var$a = !1, $833de91d497cd656$var$f = $833de91d497cd656$export$4d1c58c78979557d, $833de91d497cd656$var$T();
}
function $833de91d497cd656$var$L() {
    $833de91d497cd656$var$I || ($833de91d497cd656$var$I = !0, $833de91d497cd656$var$E(()=>{
        $833de91d497cd656$var$I = !1, $833de91d497cd656$var$s === 0 && $833de91d497cd656$var$m();
    }));
}
function $833de91d497cd656$export$f6bed56c2326f55a() {
    $833de91d497cd656$var$s > 0 && $833de91d497cd656$var$s--, !($833de91d497cd656$var$s !== 0 || $833de91d497cd656$var$u !== null) && ($833de91d497cd656$var$l ? $833de91d497cd656$var$L() : $833de91d497cd656$var$m());
}
function $833de91d497cd656$export$91122e62d8d35a0c(t, e = $833de91d497cd656$export$4d1c58c78979557d, n = null) {
    const o = {
        fn: t,
        budget: e,
        lease: n
    };
    $833de91d497cd656$var$u ? $833de91d497cd656$var$u.push(o) : $833de91d497cd656$var$r.push(o), $833de91d497cd656$var$l || ($833de91d497cd656$var$l = !0, $833de91d497cd656$var$w($833de91d497cd656$var$B));
}
function $833de91d497cd656$export$1f57d5ba4c8d5f52(t) {
    const e = t && t.context;
    return e && e.__mountLease || null;
}
function $833de91d497cd656$export$10ac418a0bfb7e25(t) {
    if (!t) return;
    let e = 0;
    for(let n = 0; n < $833de91d497cd656$var$r.length; n++){
        const o = $833de91d497cd656$var$r[n];
        o.lease !== t && ($833de91d497cd656$var$r[e++] = o);
    }
    if ($833de91d497cd656$var$r.length = e, $833de91d497cd656$var$u) {
        let n = 0;
        for(let o = 0; o < $833de91d497cd656$var$u.length; o++)$833de91d497cd656$var$u[o].lease !== t && ($833de91d497cd656$var$u[n++] = $833de91d497cd656$var$u[o]);
        $833de91d497cd656$var$u.length = n;
    }
    typeof t.lost == "function" && t.lost();
}
function $833de91d497cd656$var$q(t) {
    if (t.lease !== null && !t.lease.live()) {
        $833de91d497cd656$export$10ac418a0bfb7e25(t.lease);
        return;
    }
    const e = $833de91d497cd656$var$u;
    $833de91d497cd656$var$u = [];
    try {
        t.fn();
    } catch (n) {
        typeof console < "u" && console.error && console.error("[smbls] deferred mount chunk failed:", n?.message || n);
    } finally{
        const n = $833de91d497cd656$var$u;
        $833de91d497cd656$var$u = e, n.length && $833de91d497cd656$var$r.unshift(...n);
    }
}
function $833de91d497cd656$export$2b1e5058ee1f4d17() {
    return !$833de91d497cd656$var$l && !$833de91d497cd656$var$r.length ? Promise.resolve() : new Promise((t)=>$833de91d497cd656$var$x.push(t));
}
function $833de91d497cd656$export$db22bd65afe40d6b() {
    return !$833de91d497cd656$var$l && !$833de91d497cd656$var$r.length;
}
function $833de91d497cd656$var$b() {
    if (!$833de91d497cd656$var$x.length) return;
    const t = $833de91d497cd656$var$x;
    $833de91d497cd656$var$x = [];
    for(let e = 0; e < t.length; e++)t[e]();
}
function $833de91d497cd656$var$B() {
    for($833de91d497cd656$var$i = $833de91d497cd656$var$d(), $833de91d497cd656$var$a = !1, $833de91d497cd656$var$f = 1 / 0, $833de91d497cd656$var$T(); $833de91d497cd656$var$r.length;){
        const t = $833de91d497cd656$var$r.shift();
        if (t.budget < $833de91d497cd656$var$f && ($833de91d497cd656$var$f = t.budget, $833de91d497cd656$var$p = 0), $833de91d497cd656$var$q(t), $833de91d497cd656$var$a || $833de91d497cd656$var$d() - $833de91d497cd656$var$i >= $833de91d497cd656$var$f) break;
    }
    if ($833de91d497cd656$var$s = 0, $833de91d497cd656$var$m(), $833de91d497cd656$var$r.length) {
        $833de91d497cd656$var$w($833de91d497cd656$var$B);
        return;
    }
    $833de91d497cd656$var$l = !1, $833de91d497cd656$var$b();
}
function $833de91d497cd656$export$2ee4854081d04e23() {
    let e = 0;
    for($833de91d497cd656$var$i = 0; $833de91d497cd656$var$r.length && e++ < 1e5;)$833de91d497cd656$var$q($833de91d497cd656$var$r.shift());
    $833de91d497cd656$var$l = !1, $833de91d497cd656$var$s = 0, $833de91d497cd656$var$m(), $833de91d497cd656$var$b();
}
function $833de91d497cd656$export$afb119826d08a1d8() {
    return $833de91d497cd656$var$r.length;
}
function $833de91d497cd656$export$c1cd243ffe90a31c() {
    $833de91d497cd656$var$r.length = 0, $833de91d497cd656$var$u = null, $833de91d497cd656$var$l = !1, $833de91d497cd656$var$s = 0, $833de91d497cd656$var$m(), $833de91d497cd656$var$b();
}
function $833de91d497cd656$export$6d10a3007befff5(t) {
    (0, $hAgpL.mountRecord)(t.__ref).pending++;
}
function $833de91d497cd656$export$b8b702516a2fa7d0(t) {
    const e = t && t.__ref, n = e && e.__mount;
    if (!n || !(n.pending > 0) || --n.pending > 0 || e.__disposed) return;
    const o = n.tail;
    o && (n.tail = null, o());
}
function $833de91d497cd656$export$a8a94c549f413c60(t) {
    const e = t && t.__ref && t.__ref.__mount;
    return !!(e && e.tail);
}
function $833de91d497cd656$export$960d6e20ba336959(t) {
    const e = t && t.__ref && t.__ref.__mount;
    return !e || !e.tail ? Promise.resolve(t) : new Promise((n)=>{
        (e.waiters || (e.waiters = [])).push(n);
    });
}
function $833de91d497cd656$export$c9d02ff59937b642(t, e = t && t.__ref) {
    const n = e && e.__mount, o = n && n.waiters;
    if (o) {
        n.waiters = null;
        for(let c = 0; c < o.length; c++)o[c](t);
    }
}
function $833de91d497cd656$export$e9a2f6d476b14f8c(t, e = t && t.__ref) {
    const n = e && e.__mount;
    if (!n || !n.tail) return;
    n.tail = null, n.pending = 0;
    const o = n.holder;
    n.holder = null, $833de91d497cd656$export$c9d02ff59937b642(t, e), o && $833de91d497cd656$export$b8b702516a2fa7d0(o);
}

});


parcelRegister("5dcbP", function(module, exports) {

$parcel$export(module.exports, "containerVwFeature", () => $3cb79f4681b7a1d5$export$e2891939802a885e);
parcelRequire("67GC6");
var $521xJ = parcelRequire("521xJ");

var $9aRcW = parcelRequire("9aRcW");
const $3cb79f4681b7a1d5$var$a = "--smbls-cvw", $3cb79f4681b7a1d5$var$v = /(^|[^\w.-])(-?(?:\d+\.?\d*|\.\d+))[sld]?vw\b/g, $3cb79f4681b7a1d5$var$u = /\d[sld]?vw\b/, $3cb79f4681b7a1d5$var$f = (t)=>t.replace($3cb79f4681b7a1d5$var$v, "$1calc($2 * var(" + $3cb79f4681b7a1d5$var$a + "))"), $3cb79f4681b7a1d5$var$d = (t)=>{
    if (typeof t == "string") return $3cb79f4681b7a1d5$var$u.test(t) ? $3cb79f4681b7a1d5$var$f(t) : t;
    if (!t || typeof t != "object" || Array.isArray(t)) return t;
    let r = null;
    for(const n in t){
        const e = t[n], o = n === $3cb79f4681b7a1d5$var$a ? e : $3cb79f4681b7a1d5$var$d(e);
        o !== e && ((r || (r = Object.assign({}, t)))[n] = o);
    }
    return r || t;
}, $3cb79f4681b7a1d5$var$h = (t)=>{
    const r = (0, $521xJ.getActiveConfig)().cssVars || {}, n = {
        [$3cb79f4681b7a1d5$var$a]: t
    }, e = [];
    for(const o in r){
        const i = r[o];
        typeof i == "string" && $3cb79f4681b7a1d5$var$u.test(i) && (n[o] = $3cb79f4681b7a1d5$var$f(i), e.push(o));
    }
    for(let o = 0; o < e.length; o++){
        const i = "var(" + e[o];
        for(const c in r){
            const s = r[c];
            !(c in n) && typeof s == "string" && (s.includes(i + ")") || s.includes(i + ",")) && (n[c] = s, e.push(c));
        }
    }
    return n;
}, $3cb79f4681b7a1d5$var$p = new WeakSet, $3cb79f4681b7a1d5$export$e2891939802a885e = {
    on: !1,
    lengths: $3cb79f4681b7a1d5$var$d,
    scope (t, r) {
        let n = t.breakpointsFrom, e = "1cqi";
        if ((0, $9aRcW.breakpointsContainerName)(n, t)) {
            this.on = !0;
            const o = t.node && t.node.ownerDocument && t.node.ownerDocument.defaultView || globalThis;
            if (!$3cb79f4681b7a1d5$var$p.has(o)) {
                $3cb79f4681b7a1d5$var$p.add(o);
                try {
                    o.CSS.registerProperty({
                        name: $3cb79f4681b7a1d5$var$a,
                        syntax: "<length>",
                        inherits: !0,
                        initialValue: "1vw"
                    });
                } catch  {}
            }
        } else {
            try {
                typeof n == "function" && (n = n(t, t.state, t.context));
            } catch  {
                return;
            }
            if (!this.on || typeof n != "string" || !/^(window|media)$/.test(n.trim())) return;
            e = "1vw";
        }
        return r["& > *"] = Object.assign($3cb79f4681b7a1d5$var$h(e), r["& > *"]), !0;
    }
};

});

parcelRegister("a3srI", function(module, exports) {

$parcel$export(module.exports, "faceWaitFeature", () => $75203ff755a87883$export$f0bc49ef791f39a9);

var $8gewL = parcelRequire("8gewL");
const $75203ff755a87883$export$883630cdffd081f3 = 3e3, $75203ff755a87883$export$6c85c7e84573641d = "data-smbls-face-wait", $75203ff755a87883$var$pt = new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "math",
    "emoji",
    "fangsong",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "inherit",
    "initial",
    "unset",
    "revert"
]);
let $75203ff755a87883$var$P = new WeakMap;
const $75203ff755a87883$var$g = new Set;
let $75203ff755a87883$var$W = !1, $75203ff755a87883$var$k = 0;
const $75203ff755a87883$var$q = (t)=>String(t || "").trim().replace(/^(["'])(.*)\1$/, "$2").toLowerCase(), $75203ff755a87883$var$J = (t)=>t && t.defaultView || null;
function $75203ff755a87883$var$Q(t) {
    if (!t) return null;
    let e = $75203ff755a87883$var$P.get(t);
    if (e !== void 0) return e;
    const n = $75203ff755a87883$var$J(t), i = t.fonts;
    return e = n && i && typeof i.forEach == "function" && typeof n.getComputedStyle == "function" ? {
        doc: t,
        win: n,
        fonts: i,
        waits: new Map,
        watches: new Map,
        links: null,
        observer: null,
        attributes: null,
        fontKeys: null,
        written: null,
        sheet: null,
        inline: null,
        inlineKey: "",
        table: null,
        tableSize: 0
    } : null, $75203ff755a87883$var$P.set(t, e), e;
}
const $75203ff755a87883$var$E = (t)=>{
    const e = t && t.node;
    return e && e.ownerDocument || t?.context?.document || (typeof document < "u" ? document : null);
}, $75203ff755a87883$var$yt = (t)=>{
    const e = [];
    for (const n of String(t || "U+0-10FFFF").split(",")){
        const i = /U\+([0-9A-F?]+)(?:-([0-9A-F]+))?/i.exec(n);
        if (!i) continue;
        const o = parseInt(i[1].replace(/\?/g, "0"), 16), s = parseInt(i[2] || i[1].replace(/\?/g, "F"), 16);
        e.push([
            o,
            s
        ]);
    }
    return e.length ? e : [
        [
            0,
            1114111
        ]
    ];
}, $75203ff755a87883$var$X = (t)=>t === "bold" ? 700 : t === "normal" || t === "bolder" || t === "lighter" ? 400 : Number(t) || 400, $75203ff755a87883$var$Z = (t)=>{
    const e = String(t || "400").trim().split(/\s+/).map($75203ff755a87883$var$X);
    return [
        e[0],
        e[1] === void 0 ? e[0] : e[1]
    ];
}, $75203ff755a87883$var$N = (t)=>{
    const e = String(t || "normal").trim().toLowerCase();
    return e.startsWith("italic") ? "italic" : e.startsWith("oblique") ? "oblique" : "normal";
}, $75203ff755a87883$var$S = (t, e)=>{
    const n = new RegExp(`(?:^|[;{\\s])${e}\\s*:\\s*([^;}]+)`, "i").exec(t);
    return n ? n[1].trim() : "";
}, $75203ff755a87883$var$tt = (t, e, n, i)=>$75203ff755a87883$var$q(t) + "|" + $75203ff755a87883$var$Z(e).join("-") + "|" + $75203ff755a87883$var$N(n) + "|" + String(i || "U+0-10FFFF").replace(/\s+/g, "").toUpperCase();
let $75203ff755a87883$var$K = new WeakMap;
function $75203ff755a87883$var$gt(t) {
    let e = $75203ff755a87883$var$K.get(t);
    if (e === void 0) {
        const n = t.cssText || "";
        e = (t.type === 5 || /^\s*@font-face/i.test(n)) && /url\(\s*['"]?data:/i.test($75203ff755a87883$var$S(n, "src")) ? $75203ff755a87883$var$tt($75203ff755a87883$var$S(n, "font-family"), $75203ff755a87883$var$S(n, "font-weight"), $75203ff755a87883$var$S(n, "font-style"), $75203ff755a87883$var$S(n, "unicode-range")) : "", $75203ff755a87883$var$K.set(t, e);
    }
    return e;
}
function $75203ff755a87883$var$mt(t) {
    const e = t.doc.styleSheets, n = (e ? e.length : 0) + ":" + (t.fonts.size || 0);
    if (t.inline && t.inlineKey === n) return t.inline;
    const i = new Set;
    for(let o = 0; e && o < e.length; o++){
        let s;
        try {
            s = e[o].cssRules;
        } catch  {
            continue;
        }
        for(let r = 0; s && r < s.length; r++){
            const a = s[r];
            if (typeof a.type == "number" && a.type !== 5) continue;
            const f = $75203ff755a87883$var$gt(a);
            f && i.add(f);
        }
    }
    return t.inline = i, t.inlineKey = n, i;
}
function $75203ff755a87883$var$z(t) {
    const e = t.fonts.size || 0;
    if (t.table && t.tableSize === e) return t.table;
    const n = new Map;
    let i = 0;
    t.fonts.forEach((s)=>{
        const r = $75203ff755a87883$var$q(s.family), a = {
            face: s,
            order: i++,
            ranges: $75203ff755a87883$var$yt(s.unicodeRange),
            weight: $75203ff755a87883$var$Z(s.weight),
            style: $75203ff755a87883$var$N(s.style),
            key: $75203ff755a87883$var$tt(s.family, s.weight, s.style, s.unicodeRange)
        }, f = n.get(r);
        f ? f.push(a) : n.set(r, [
            a
        ]);
    }), t.table = n, t.tableSize = e;
    const o = ()=>{
        t.table === n && (t.table = null);
    };
    return typeof queueMicrotask == "function" ? queueMicrotask(o) : Promise.resolve().then(o), n;
}
const $75203ff755a87883$var$bt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
};
function $75203ff755a87883$var$et(t, [e, n]) {
    if (t >= e && t <= n) return 0;
    const i = n < t, o = i ? t - n : e - t;
    return t >= 400 && t <= 500 ? !i && e <= 500 ? 1e3 + o : i ? 2e3 + o : 3e3 + o : t < 400 ? i ? 1e3 + o : 2e3 + o : i ? 2e3 + o : 1e3 + o;
}
function $75203ff755a87883$var$wt(t, e, n) {
    const i = e.weight + "|" + e.style, o = n.get(i);
    if (o) return o;
    let s = t;
    for (const f of $75203ff755a87883$var$bt[e.style]){
        const u = t.filter((c)=>c.style === f);
        if (u.length) {
            s = u;
            break;
        }
    }
    let r = 1 / 0;
    for (const f of s)r = Math.min(r, $75203ff755a87883$var$et(e.weight, f.weight));
    const a = s.filter((f)=>$75203ff755a87883$var$et(e.weight, f.weight) === r);
    return n.set(i, a), a;
}
const $75203ff755a87883$var$Wt = (t, e)=>t.ranges.some(([n, i])=>e >= n && e <= i);
function $75203ff755a87883$var$kt(t, e, n, i, o, s, r) {
    for (const a of n){
        if ($75203ff755a87883$var$pt.has(a)) return null;
        const f = e.get(a);
        if (!f) {
            s.missing = !0;
            continue;
        }
        let u = r.get(a);
        u || r.set(a, u = new Map);
        const c = $75203ff755a87883$var$wt(f, i, u).filter((_)=>$75203ff755a87883$var$Wt(_, o));
        if (!c.length) continue;
        if (c.length === 1) return c[0].face;
        const l = $75203ff755a87883$var$mt(t);
        return (c.find((_)=>l.has(_.key)) || c[c.length - 1]).face;
    }
    return null;
}
function $75203ff755a87883$var$St(t, e) {
    const n = [];
    if (!t || !t.childNodes) return n;
    if (!e) {
        for (const s of t.childNodes)s.nodeType === 3 && s.nodeValue && n.push(s);
        return n;
    }
    const i = t.ownerDocument;
    if (i && typeof i.createTreeWalker == "function") {
        const s = i.createTreeWalker(t, 4);
        for(let r = s.nextNode(); r; r = s.nextNode())r.nodeValue && n.push(r);
        return n;
    }
    const o = (s)=>{
        for (const r of s.childNodes)r.nodeType === 3 ? r.nodeValue && n.push(r) : o(r);
    };
    return o(t), n;
}
const $75203ff755a87883$var$nt = (t)=>t.fontFamily + "|" + t.fontWeight + "|" + t.fontStyle;
function $75203ff755a87883$var$it(t, e) {
    const n = t.win.getComputedStyle(e);
    return {
        key: $75203ff755a87883$var$nt(n),
        stack: String(n.fontFamily || "").split(",").map($75203ff755a87883$var$q).filter(Boolean),
        want: {
            weight: $75203ff755a87883$var$X(String(n.fontWeight || "400")),
            style: $75203ff755a87883$var$N(n.fontStyle)
        }
    };
}
function $75203ff755a87883$export$65e6b0e05dec591f(t, e, n, i = $75203ff755a87883$var$z(t), o = null) {
    const s = {
        missing: !1
    }, r = new Set, a = new Map;
    o && a.set(e, o);
    const f = new Map;
    for (const u of $75203ff755a87883$var$St(e, n)){
        const c = u.parentNode;
        if (!c || c.nodeType !== 1) continue;
        let l = a.get(c);
        if (l || (l = $75203ff755a87883$var$it(t, c), a.set(c, l)), !l.stack.length) continue;
        const d = new Set;
        for (const _ of u.nodeValue){
            const M = _.codePointAt(0);
            if (M < 32 || d.has(M)) continue;
            d.add(M);
            const G = $75203ff755a87883$var$kt(t, i, l.stack, l.want, M, s, f);
            G && r.add(G);
        }
    }
    return {
        faces: [
            ...r
        ],
        missing: s.missing
    };
}
const $75203ff755a87883$var$ot = (t, e)=>e.status === "loaded" || !!(t.waits.get(e) || {}).done;
function $75203ff755a87883$var$D(t, e) {
    let n = t.waits.get(e);
    return n || (n = {
        done: !1,
        promise: null
    }, t.waits.set(e, n), n.promise = new Promise((i)=>{
        const o = ()=>{
            n.done = !0, i();
        };
        t.win.setTimeout(o, $75203ff755a87883$export$883630cdffd081f3);
        try {
            Promise.resolve(e.load()).then(o, o);
        } catch  {
            o();
        }
    })), n.promise;
}
function $75203ff755a87883$var$I(t) {
    if (t.links && t.links.done) return null;
    const e = t.doc.querySelectorAll ? t.doc.querySelectorAll('link[rel="stylesheet"][data-smbls-font]') : [], n = [];
    for (const i of e)i.sheet || n.push(i);
    if (!n.length) return null;
    if (!t.links) {
        const i = t.links = {
            done: !1,
            promise: null
        };
        i.promise = new Promise((o)=>{
            const s = ()=>{
                i.done = !0, o();
            };
            t.win.setTimeout(s, $75203ff755a87883$export$883630cdffd081f3);
            let r = n.length;
            const a = ()=>{
                --r <= 0 && s();
            };
            for (const f of n)f.addEventListener("load", a, {
                once: !0
            }), f.addEventListener("error", a, {
                once: !0
            });
        });
    }
    return t.links.promise;
}
function $75203ff755a87883$var$Ft(t) {
    if (t.sheet) return;
    const e = t.doc, n = e.createElement("style");
    n.setAttribute($75203ff755a87883$export$6c85c7e84573641d, ""), (e.head || e.documentElement).appendChild(n);
    const i = n.sheet, o = [
        `[${$75203ff755a87883$export$6c85c7e84573641d}="wait"]{visibility:hidden}`,
        `@media print{[${$75203ff755a87883$export$6c85c7e84573641d}="wait"]{visibility:visible}}`
    ];
    if (i && typeof i.insertRule == "function") for (const s of o)try {
        i.insertRule(s, i.cssRules.length);
    } catch  {}
    else n.textContent = o.join("");
    t.sheet = n;
}
let $75203ff755a87883$var$m = null;
function $75203ff755a87883$var$B(t, e) {
    if ($75203ff755a87883$var$m) return void $75203ff755a87883$var$m.push(()=>$75203ff755a87883$var$B(t, e));
    const n = e.node;
    !n || !n.setAttribute || ($75203ff755a87883$var$Ft(t), n.getAttribute($75203ff755a87883$export$6c85c7e84573641d) !== "wait" && n.setAttribute($75203ff755a87883$export$6c85c7e84573641d, "wait"));
}
function $75203ff755a87883$var$F(t) {
    if ($75203ff755a87883$var$m) return void $75203ff755a87883$var$m.push(()=>$75203ff755a87883$var$F(t));
    const e = t.node;
    e && e.removeAttribute && e.hasAttribute && e.hasAttribute($75203ff755a87883$export$6c85c7e84573641d) && e.removeAttribute($75203ff755a87883$export$6c85c7e84573641d);
}
const $75203ff755a87883$var$st = (t, e)=>{
    try {
        return t.win.getComputedStyle(e).display === "contents";
    } catch  {
        return !1;
    }
};
function $75203ff755a87883$var$rt(t, e) {
    if (typeof e.checkVisibility == "function") {
        if (e.checkVisibility()) return !0;
    } else if (typeof e.getClientRects != "function" || e.getClientRects().length > 0) return !0;
    if (!$75203ff755a87883$var$st(t, e)) return !1;
    const n = t.doc;
    if (typeof n.createRange != "function") return !0;
    const i = n.createRange();
    return i.selectNodeContents(e), typeof i.getClientRects != "function" || i.getClientRects().length > 0;
}
function $75203ff755a87883$var$At(t, e) {
    const n = t.win.ResizeObserver;
    return typeof n != "function" ? !1 : (t.observer || (t.observer = new n((i)=>{
        const o = [];
        for (const s of i){
            const r = s.target && s.target.__smblsFaceWait;
            if (!r) {
                t.observer.unobserve(s.target);
                continue;
            }
            $75203ff755a87883$var$rt(t, s.target) && (t.observer.unobserve(s.target), s.target.__smblsFaceWait = null, o.push(r));
        }
        o.length && $75203ff755a87883$var$ut(o);
    })), e.node.__smblsFaceWait = e, t.observer.observe(e.node), !0);
}
const $75203ff755a87883$var$Tt = [
    "class",
    "style",
    "lang"
], $75203ff755a87883$var$h = new Set, $75203ff755a87883$var$V = new Set, $75203ff755a87883$var$Mt = (t, e)=>{
    try {
        return $75203ff755a87883$var$nt(t.win.getComputedStyle(e));
    } catch  {
        return "";
    }
};
function $75203ff755a87883$var$Ct(t, e) {
    if ($75203ff755a87883$var$h.size) {
        for (const n of e){
            const i = n.target;
            i && i.nodeType === 1 && t.written.add(i);
        }
        t.written.size && ($75203ff755a87883$var$T.add(t), $75203ff755a87883$var$lt(t.win));
    }
}
const $75203ff755a87883$var$at = (t)=>!!(t.__ref && t.__ref.__faceWaitSeen) && !$75203ff755a87883$var$g.has(t);
function $75203ff755a87883$var$Rt(t) {
    const e = t.written;
    if (t.written = new Set, !$75203ff755a87883$var$h.size || !e.size || !t.fontKeys) return;
    const n = new Map, i = (s, r)=>{
        if (!$75203ff755a87883$var$at(r)) return;
        const a = n.get(s);
        a ? a.push(r) : n.set(s, [
            r
        ]);
    };
    for (const s of e)for(let r = s; r && r.nodeType === 1; r = r.parentNode){
        const a = r.__smblsFaceArm;
        a && (r === s || a.__ref?.__faceWait === "tree") && i(s, a);
    }
    for (const s of $75203ff755a87883$var$h)if (!(!s.node || !$75203ff755a87883$var$at(s))) for(let r = s.node.parentNode; r && r.nodeType === 1; r = r.parentNode)e.has(r) && i(r, s);
    if (!n.size) return;
    const o = new Set;
    for (const [s, r] of n){
        const a = $75203ff755a87883$var$Mt(t, s);
        if (t.fontKeys.get(s) !== a) {
            t.fontKeys.set(s, a);
            for (const f of r)o.add(f);
        }
    }
    for (const s of o)$75203ff755a87883$var$p(s);
}
function $75203ff755a87883$var$Ot(t) {
    if (t.attributes) return;
    const e = t.win.MutationObserver, n = t.doc.documentElement;
    typeof e != "function" || !n || (t.fontKeys = new WeakMap, t.written = new Set, t.attributes = new e((i)=>{
        try {
            $75203ff755a87883$var$Ct(t, i);
        } catch  {}
    }), t.attributes.observe(n, {
        attributes: !0,
        subtree: !0,
        attributeFilter: $75203ff755a87883$var$Tt
    }), $75203ff755a87883$var$V.add(t));
}
function $75203ff755a87883$var$ft() {
    for (const t of $75203ff755a87883$var$V)t.attributes.disconnect(), $75203ff755a87883$var$T.delete(t), t.written = null, t.attributes = null, t.fontKeys = null;
    $75203ff755a87883$var$V.clear();
}
function $75203ff755a87883$var$xt(t) {
    let e = t.faceWait;
    if (typeof e == "function") try {
        e = e(t, t.state, t.context);
    } catch  {
        e = void 0;
    }
    if (e === !0) return "tree";
    if (e === !1 || t.tag === "string" || t.context?.designSystem?.faceWait !== !0) return null;
    const n = t.__ref && t.__ref.__textNode;
    return n && n.nodeValue ? "own" : "late";
}
let $75203ff755a87883$var$U = 0;
function $75203ff755a87883$var$R(t, e) {
    !t.__faceWaitLate != !e && (t.__faceWaitLate = e || null, $75203ff755a87883$var$U += e ? 1 : -1);
}
function $75203ff755a87883$var$ct(t) {
    const e = t.__ref;
    if (!e || !e.__faceWait) return;
    if (!(0, $8gewL.isElementConnected)(t)) {
        e.__faceWaitConnect || (e.__faceWaitConnect = !0, (0, $8gewL.whenConnected)(t, ()=>{
            e.__faceWaitConnect = !1, $75203ff755a87883$var$p(t);
        }));
        return;
    }
    const n = $75203ff755a87883$var$Q($75203ff755a87883$var$E(t));
    if (!n) return;
    const i = t.node;
    $75203ff755a87883$var$Ot(n);
    let o = null;
    try {
        o = $75203ff755a87883$var$it(n, i);
    } catch  {}
    n.fontKeys && n.fontKeys.set(i, o ? o.key : "");
    const { faces: s, missing: r } = $75203ff755a87883$export$65e6b0e05dec591f(n, i, e.__faceWait === "tree", $75203ff755a87883$var$Lt(n), o), a = s.filter((c)=>!$75203ff755a87883$var$ot(n, c)), f = r ? $75203ff755a87883$var$I(n) : null;
    if (!a.length && !f) return $75203ff755a87883$var$F(t);
    if (!$75203ff755a87883$var$rt(n, i) && $75203ff755a87883$var$At(n, t)) {
        $75203ff755a87883$var$st(n, i) || $75203ff755a87883$var$B(n, t);
        return;
    }
    $75203ff755a87883$var$B(n, t);
    const u = e.__faceWaitToken = (e.__faceWaitToken || 0) + 1;
    Promise.all([
        ...a.map((c)=>$75203ff755a87883$var$D(n, c)),
        f
    ]).then(()=>{
        e.__faceWaitToken === u && e.__faceWait && $75203ff755a87883$var$p(t);
    });
}
let $75203ff755a87883$var$A = null;
function $75203ff755a87883$var$Lt(t) {
    if (!$75203ff755a87883$var$A) return $75203ff755a87883$var$z(t);
    let e = $75203ff755a87883$var$A.get(t);
    return e || $75203ff755a87883$var$A.set(t, e = $75203ff755a87883$var$z(t)), e;
}
function $75203ff755a87883$var$ut(t) {
    if ($75203ff755a87883$var$m) {
        for (const n of t)try {
            $75203ff755a87883$var$ct(n);
        } catch  {
            $75203ff755a87883$var$F(n);
        }
        return;
    }
    $75203ff755a87883$var$A = new Map;
    const e = $75203ff755a87883$var$m = [];
    try {
        for (const n of t)try {
            $75203ff755a87883$var$ct(n);
        } catch  {
            $75203ff755a87883$var$F(n);
        }
    } finally{
        $75203ff755a87883$var$A = null, $75203ff755a87883$var$m = null;
        for (const n of e)try {
            n();
        } catch  {}
    }
}
function $75203ff755a87883$var$j() {
    $75203ff755a87883$var$W = !1;
    const t = [
        ...$75203ff755a87883$var$g
    ];
    $75203ff755a87883$var$g.clear(), t.length && $75203ff755a87883$var$ut(t);
}
const $75203ff755a87883$var$b = new Map;
let $75203ff755a87883$var$O = !1;
const $75203ff755a87883$var$x = new Set, $75203ff755a87883$var$vt = (t, e)=>typeof t.requestAnimationFrame == "function" ? t.requestAnimationFrame(e) : -t.setTimeout(e, 16), $75203ff755a87883$var$Pt = (t, e)=>{
    e < 0 ? t.clearTimeout(-e) : typeof t.cancelAnimationFrame == "function" && t.cancelAnimationFrame(e);
}, $75203ff755a87883$var$T = new Set;
function $75203ff755a87883$var$qt(t, e) {
    const n = t.MessageChannel || (typeof MessageChannel == "function" ? MessageChannel : null);
    if (n) {
        const i = new n;
        i.port1.onmessage = ()=>{
            i.port1.close(), e();
        }, i.port2.postMessage(0);
        return;
    }
    t.setTimeout(e, 0);
}
function $75203ff755a87883$var$lt(t) {
    !t || $75203ff755a87883$var$b.has(t) || $75203ff755a87883$var$b.set(t, $75203ff755a87883$var$vt(t, ()=>$75203ff755a87883$var$Et(t)));
}
function $75203ff755a87883$var$Et(t) {
    $75203ff755a87883$var$b.delete(t), $75203ff755a87883$var$O = !0;
    try {
        for (const e of [
            ...$75203ff755a87883$var$T
        ]){
            $75203ff755a87883$var$T.delete(e);
            try {
                e.written && $75203ff755a87883$var$Rt(e);
            } catch  {}
        }
        $75203ff755a87883$var$j();
    } finally{
        $75203ff755a87883$var$O = !1;
    }
    typeof t.requestAnimationFrame == "function" && ($75203ff755a87883$var$x.add(t), $75203ff755a87883$var$qt(t, ()=>{
        $75203ff755a87883$var$x.delete(t);
    })), $75203ff755a87883$var$g.size && $75203ff755a87883$var$dt();
}
const $75203ff755a87883$var$Nt = (t)=>!!t && typeof t.requestAnimationFrame == "function" && !(t.document && t.document.visibilityState === "hidden");
function $75203ff755a87883$var$dt() {
    $75203ff755a87883$var$W || ($75203ff755a87883$var$W = !0, typeof queueMicrotask == "function" ? queueMicrotask($75203ff755a87883$var$j) : Promise.resolve().then($75203ff755a87883$var$j));
}
function $75203ff755a87883$var$p(t) {
    if ($75203ff755a87883$var$g.add(t), $75203ff755a87883$var$O || $75203ff755a87883$var$W) return;
    const e = $75203ff755a87883$var$J($75203ff755a87883$var$E(t));
    if (!$75203ff755a87883$var$b.has(e)) {
        if (!$75203ff755a87883$var$x.has(e) && $75203ff755a87883$var$Nt(e)) return $75203ff755a87883$var$lt(e);
        $75203ff755a87883$var$dt();
    }
}
const $75203ff755a87883$export$d491ee02df860581 = 1e4, $75203ff755a87883$var$_t = 200, $75203ff755a87883$var$zt = (t)=>!!t.loaded && typeof t.loaded.then == "function", $75203ff755a87883$var$ht = (t, e)=>{
    let n = t.watches.get(e);
    return n || (n = new Promise((i)=>{
        let o = Math.ceil($75203ff755a87883$export$d491ee02df860581 / $75203ff755a87883$var$_t);
        const s = ()=>{
            if (e.status === "loaded") return i(e);
            if (o-- <= 0) return i(null);
            t.win.setTimeout(s, $75203ff755a87883$var$_t);
        };
        s();
    }), t.watches.set(e, n), n);
}, $75203ff755a87883$var$w = (t, e = [], n = null)=>{
    const i = e.filter((o)=>o.status !== "loaded" && (o.status === "error" ? !!n : $75203ff755a87883$var$zt(o)));
    return Object.defineProperty(t, "late", {
        value: i.length ? Promise.all(i.map((o)=>o.status === "error" ? $75203ff755a87883$var$ht(n, o) : o.loaded.then(()=>o, ()=>n ? $75203ff755a87883$var$ht(n, o) : null))).then((o)=>o.filter(Boolean)) : null
    }), t;
};
function $75203ff755a87883$var$Dt(t) {
    return new Promise((e)=>{
        try {
            const n = $75203ff755a87883$var$E(t), i = $75203ff755a87883$var$Q(n);
            if (!i || !t.node) return e($75203ff755a87883$var$w([]));
            const o = ()=>{
                const { faces: a } = $75203ff755a87883$export$65e6b0e05dec591f(i, t.node, !0);
                return $75203ff755a87883$var$w(a.filter((f)=>f.status === "loaded"), a, i);
            }, s = ()=>{
                const { faces: a, missing: f } = $75203ff755a87883$export$65e6b0e05dec591f(i, t.node, !0);
                if (!a.length && !f) return e($75203ff755a87883$var$w([]));
                const u = a.filter((d)=>d.status !== "loaded");
                if (!u.length && !(f && $75203ff755a87883$var$I(i))) return e($75203ff755a87883$var$w(a));
                if (t.__ref && t.__ref.__adoption === "adopted" && "__smblsFacesReady" in i.win) {
                    Promise.resolve(i.win.__smblsFacesReady).then(()=>e(o()), ()=>e(o()));
                    return;
                }
                const l = f ? $75203ff755a87883$var$I(i) : null;
                Promise.all([
                    ...u.map((d)=>$75203ff755a87883$var$D(i, d)),
                    l
                ]).then(()=>{
                    if (!l) return e(o());
                    const d = $75203ff755a87883$export$65e6b0e05dec591f(i, t.node, !0).faces.filter((_)=>!$75203ff755a87883$var$ot(i, _));
                    Promise.all(d.map((_)=>$75203ff755a87883$var$D(i, _))).then(()=>e(o()));
                }, ()=>e(o()));
            };
            if ((0, $8gewL.isElementConnected)(t)) return s();
            let r = !1;
            i.win.setTimeout(()=>{
                r || (r = !0, e($75203ff755a87883$var$w([])));
            }, $75203ff755a87883$export$883630cdffd081f3), (0, $8gewL.whenConnected)(t, ()=>{
                r || (r = !0, s());
            });
        } catch  {
            e($75203ff755a87883$var$w([]));
        }
    });
}
const $75203ff755a87883$export$f0bc49ef791f39a9 = {
    get active () {
        return $75203ff755a87883$var$k > 0 || $75203ff755a87883$var$L > 0 || $75203ff755a87883$var$U > 0;
    },
    rendered (t) {
        const e = t.__ref;
        if (!e) return;
        let n = $75203ff755a87883$var$xt(t);
        if (n === "late" ? ($75203ff755a87883$var$R(e, !0), n = null) : e.__faceWaitLate && $75203ff755a87883$var$R(e, !1), !(!n && !e.__faceWait)) {
            if (n !== e.__faceWait && $75203ff755a87883$var$$(t, n), !n) return $75203ff755a87883$var$F(t);
            if (e.__adoption === "adopted" && !e.__faceWaitSeen) {
                e.__faceWaitSeen = !0;
                return;
            }
            e.__faceWaitSeen = !0, $75203ff755a87883$var$p(t);
        }
    },
    text (t) {
        const e = t.__ref;
        if (e && e.__faceWaitLate) {
            const n = e.__textNode;
            n && n.nodeValue && ($75203ff755a87883$var$R(e, !1), $75203ff755a87883$var$$(t, "own"), e.__faceWaitSeen = !0, $75203ff755a87883$var$p(t));
        } else e && e.__faceWait && e.__faceWaitSeen && $75203ff755a87883$var$p(t);
        if ($75203ff755a87883$var$k) for(let n = t.parent; n; n = n.parent){
            const i = n.__ref;
            i && i.__faceWait === "tree" && i.__faceWaitSeen && $75203ff755a87883$var$p(n);
        }
    },
    ready: $75203ff755a87883$var$Dt,
    recheck (t) {
        const e = t && t.node;
        for (const n of $75203ff755a87883$var$h)(n === t || e && n.node && e.contains(n.node)) && (n.__ref && (n.__ref.__faceWaitSeen = !0), $75203ff755a87883$var$p(n));
    },
    dispose (t) {
        const e = t.__ref;
        e && e.__faceWait && $75203ff755a87883$var$$(t, null), e && e.__faceWaitLate && $75203ff755a87883$var$R(e, !1), $75203ff755a87883$var$g.delete(t);
    }
};
let $75203ff755a87883$var$L = 0;
function $75203ff755a87883$var$$(t, e) {
    const n = t.__ref, i = n.__faceWait;
    i === "tree" ? $75203ff755a87883$var$k-- : i === "own" && $75203ff755a87883$var$L--, e === "tree" ? $75203ff755a87883$var$k++ : e === "own" && $75203ff755a87883$var$L++, n.__faceWait = e || null;
    const o = t.node;
    e ? ($75203ff755a87883$var$h.add(t), o && (o.__smblsFaceArm = t)) : ($75203ff755a87883$var$h.delete(t), n.__faceWaitToken = (n.__faceWaitToken || 0) + 1, o && o.__smblsFaceWait && (o.__smblsFaceWait = null), o && o.__smblsFaceArm === t && (o.__smblsFaceArm = null), $75203ff755a87883$var$h.size || $75203ff755a87883$var$ft());
}
function $75203ff755a87883$export$e8309a34518327d5() {
    $75203ff755a87883$var$g.clear();
    for (const [t, e] of $75203ff755a87883$var$b)$75203ff755a87883$var$Pt(t, e);
    $75203ff755a87883$var$b.clear(), $75203ff755a87883$var$W = !1, $75203ff755a87883$var$O = !1, $75203ff755a87883$var$x.clear(), $75203ff755a87883$var$T.clear(), $75203ff755a87883$var$k = 0, $75203ff755a87883$var$L = 0, $75203ff755a87883$var$U = 0, $75203ff755a87883$var$h.clear(), $75203ff755a87883$var$ft(), $75203ff755a87883$var$P = new WeakMap, $75203ff755a87883$var$K = new WeakMap;
}

});



parcelRegister("iav9c", function(module, exports) {
parcelRequire("kfWEd");
var $4VQqJ = parcelRequire("4VQqJ");

var $1H9Q8 = parcelRequire("1H9Q8");

var $8gewL = parcelRequire("8gewL");

const $d3a1526524ccffd5$var$a = "inertOutside", $d3a1526524ccffd5$var$A = new Set([
    "SCRIPT",
    "STYLE",
    "LINK",
    "META",
    "TEMPLATE",
    "NOSCRIPT",
    "BASE",
    "TITLE"
]), $d3a1526524ccffd5$var$P = 'a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex], [contenteditable]:not([contenteditable="false"])', $d3a1526524ccffd5$var$B = {
    attributes: !0,
    attributeFilter: [
        "inert"
    ]
}, $d3a1526524ccffd5$var$E = new WeakMap, $d3a1526524ccffd5$var$O = new WeakMap, $d3a1526524ccffd5$var$d = new Set, $d3a1526524ccffd5$var$w = (e, t)=>Object.prototype.hasOwnProperty.call(e, t);
function $d3a1526524ccffd5$var$f(e) {
    try {
        return (0, $1H9Q8.untrack)(e);
    } catch (t) {
        console.error("[smbls] inertOutside:", t);
    }
}
function $d3a1526524ccffd5$var$S(e) {
    const t = ()=>$d3a1526524ccffd5$var$f(e);
    typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t);
}
function $d3a1526524ccffd5$var$N(e) {
    if (!e || !e.defaultView || !("activeElement" in e)) return null;
    let t = $d3a1526524ccffd5$var$E.get(e);
    if (t) return t;
    const n = e.defaultView.MutationObserver || globalThis.MutationObserver;
    return typeof n != "function" ? null : (t = {
        doc: e,
        layers: [],
        held: new Map,
        top: null,
        observer: null
    }, t.observer = new n((s)=>$d3a1526524ccffd5$var$f(()=>$d3a1526524ccffd5$var$v(t, s))), $d3a1526524ccffd5$var$E.set(e, t), t);
}
function $d3a1526524ccffd5$var$y(e, t) {
    const n = e.element.node;
    return !!n && n.nodeType === 1 && n.isConnected && n.ownerDocument === t;
}
function $d3a1526524ccffd5$var$x(e) {
    const t = e.activeElement;
    return t && t !== e.body && t !== e.documentElement ? t : null;
}
const $d3a1526524ccffd5$var$T = (e)=>!!(e.closest && e.closest("[inert]"));
function $d3a1526524ccffd5$var$k(e) {
    const t = e.ownerDocument, n = new Set, s = [];
    for(let o = e; o !== t.body; o = o.parentNode){
        const c = o.parentNode;
        if (!c || c.nodeType !== 1 || c === t.documentElement) break;
        s.push(c);
        for(let u = c.firstElementChild; u; u = u.nextElementSibling)u !== o && !$d3a1526524ccffd5$var$A.has(u.tagName) && n.add(u);
    }
    return {
        outside: n,
        parents: s
    };
}
function $d3a1526524ccffd5$var$m(e, t) {
    for(let n = 0; n < t.length; n++){
        const { type: s, target: o } = t[n];
        s === "attributes" && e.held.has(o) && e.held.set(o, !o.hasAttribute("inert"));
    }
}
function $d3a1526524ccffd5$var$v(e, t) {
    const { doc: n, held: s, observer: o } = e;
    t && $d3a1526524ccffd5$var$m(e, t), $d3a1526524ccffd5$var$m(e, o.takeRecords());
    const c = e.top, u = [];
    for (const r of e.layers){
        const h = $d3a1526524ccffd5$var$y(r, n);
        h && !r.live && (u.push(r), r.returnFocus = $d3a1526524ccffd5$var$x(n)), r.live = h;
    }
    u.length && (e.layers = e.layers.filter((r)=>!u.includes(r)).concat(u));
    let i = null;
    for(let r = e.layers.length - 1; r >= 0 && !i; r--)e.layers[r].live && (i = e.layers[r]);
    e.top = i;
    const { outside: p, parents: _ } = i ? $d3a1526524ccffd5$var$k(i.element.node) : {
        outside: new Set,
        parents: []
    };
    for (const [r, h] of s)p.has(r) || (h && r.removeAttribute("inert"), s.delete(r));
    for (const r of p)s.has(r) || s.set(r, !1), r.hasAttribute("inert") || (r.setAttribute("inert", ""), s.set(r, !0));
    o.takeRecords(), o.disconnect();
    for (const r of _)o.observe(r, {
        childList: !0
    });
    for (const r of s.keys())o.observe(r, $d3a1526524ccffd5$var$B);
    e.layers.some((r)=>!r.live) ? $d3a1526524ccffd5$var$d.add(e) : $d3a1526524ccffd5$var$d.delete(e);
    for (const r of e.layers)!r.live && !r.connecting && !(0, $8gewL.isElementConnected)(r.element) && (r.connecting = !0, (0, $8gewL.whenConnected)(r.element, ()=>$d3a1526524ccffd5$var$f(()=>{
            r.connecting = !1, r.declared && !r.live && $d3a1526524ccffd5$var$y(r, e.doc) && $d3a1526524ccffd5$var$v(e);
        })));
    if (i === c) return;
    const l = c && !(c.declared && c.live) ? c : null;
    if (i && u.includes(i)) l && l.returnFocus && (i.returnFocus = l.returnFocus), $d3a1526524ccffd5$var$S(()=>$d3a1526524ccffd5$var$D(e, i));
    else if (l) {
        const r = l.returnFocus;
        $d3a1526524ccffd5$var$S(()=>$d3a1526524ccffd5$var$q(e, l, r));
    }
    l && (l.returnFocus = null);
}
function $d3a1526524ccffd5$var$D(e, t) {
    const n = t.element.node;
    if (e.top !== t || !n || !n.isConnected) return;
    const s = e.doc, o = s.activeElement;
    if (o && n.contains(o)) return;
    const c = new Set, u = (i, p)=>{
        if (c.has(i) || (c.add(i), i.matches(":disabled"))) return !1;
        const _ = p && i.getAttribute("tabindex");
        return _ && parseInt(_, 10) < 0 ? !1 : (i.focus(), s.activeElement === i);
    };
    for (const i of n.querySelectorAll("[autofocus]"))if (u(i, !1)) return;
    for (const i of n.querySelectorAll($d3a1526524ccffd5$var$P))if (u(i, !0)) return;
    o && o !== s.body && typeof o.blur == "function" && o.blur();
}
function $d3a1526524ccffd5$var$q(e, t, n) {
    if (t.declared && t.live) return;
    const s = e.doc, o = s.activeElement, c = t.element.node;
    (!o || o === s.body || c && c.contains(o) || $d3a1526524ccffd5$var$T(o)) && (n && n.isConnected && n.ownerDocument === s && !$d3a1526524ccffd5$var$T(n) && (n.focus({
        preventScroll: !0
    }), s.activeElement === n) || e.top && $d3a1526524ccffd5$var$D(e, e.top));
}
function $d3a1526524ccffd5$var$b(e, t) {
    if (e.declared === t) return;
    const n = e.manager;
    if (e.declared = t, e.live = !1, t) n.layers.push(e);
    else {
        const s = n.layers.indexOf(e);
        s !== -1 && n.layers.splice(s, 1);
    }
    $d3a1526524ccffd5$var$v(n);
}
function $d3a1526524ccffd5$var$F(e) {
    let t = e[$d3a1526524ccffd5$var$a];
    if (typeof t == "function") try {
        t = t(e, e.state, e.context);
    } catch  {
        t = !1;
    }
    return !!t;
}
function $d3a1526524ccffd5$var$I(e) {
    let t = $d3a1526524ccffd5$var$O.get(e);
    if (t) return t;
    const n = e.__ref, s = e.node;
    if (!n || !s || s.nodeType !== 1) return null;
    const o = $d3a1526524ccffd5$var$N(s.ownerDocument);
    if (!o) return null;
    t = {
        element: e,
        manager: o,
        declared: !1,
        live: !1,
        connecting: !1,
        returnFocus: null
    }, $d3a1526524ccffd5$var$O.set(e, t);
    const c = (0, $4VQqJ.createEffect)(()=>{
        const u = $d3a1526524ccffd5$var$F(e);
        $d3a1526524ccffd5$var$f(()=>$d3a1526524ccffd5$var$b(t, u));
    }, {
        depth: n.path.length,
        label: ()=>n.path.join(".") + "::" + $d3a1526524ccffd5$var$a
    });
    return n.__effects || (n.__effects = []), n.__effects.push(c), n.__eventCleanup || (n.__eventCleanup = []), n.__eventCleanup.push(()=>$d3a1526524ccffd5$var$f(()=>$d3a1526524ccffd5$var$b(t, !1))), t;
}
function $d3a1526524ccffd5$var$U() {
    for (const e of $d3a1526524ccffd5$var$d){
        if (!e.doc.defaultView) {
            $d3a1526524ccffd5$var$d.delete(e);
            continue;
        }
        e.layers.some((t)=>!t.live && $d3a1526524ccffd5$var$y(t, e.doc)) && $d3a1526524ccffd5$var$v(e);
    }
}
const $d3a1526524ccffd5$export$2952d29fb81ddc9b = {
    name: $d3a1526524ccffd5$var$a,
    create (e) {
        if ($d3a1526524ccffd5$var$w(e, $d3a1526524ccffd5$var$a)) $d3a1526524ccffd5$var$f(()=>$d3a1526524ccffd5$var$I(e));
    },
    render () {
        $d3a1526524ccffd5$var$d.size && $d3a1526524ccffd5$var$f($d3a1526524ccffd5$var$U);
    },
    update (e) {
        if ($d3a1526524ccffd5$var$w(e, $d3a1526524ccffd5$var$a)) $d3a1526524ccffd5$var$f(()=>{
            const t = $d3a1526524ccffd5$var$I(e);
            t && $d3a1526524ccffd5$var$b(t, $d3a1526524ccffd5$var$F(e));
        });
    }
};

});



parcelRegister("iwkuS", function(module, exports) {

$parcel$export(module.exports, "reportDroppedFeature", () => $d7bb1d73d83990ca$export$430df68873dc83d0);
const $d7bb1d73d83990ca$var$o = new Set, $d7bb1d73d83990ca$export$430df68873dc83d0 = (e, t)=>{
    if ($d7bb1d73d83990ca$var$o.has(e) || ($d7bb1d73d83990ca$var$o.add(e), typeof console > "u" || !console.error)) return;
    const r = t && t.__ref && t.__ref.path, s = r && r.length ? ` (at <${r.join(".")}>)` : "";
    console.error(`[smbls] "${e}"${s} is not in this build: symbols.json build.treeShakeFeatures left it out because neither the project source nor its build settings use it. Add "${e}" to build.treeShakeFeatures.keep.`);
}, $d7bb1d73d83990ca$export$3c5080ea638d070d = ()=>$d7bb1d73d83990ca$var$o.clear();

});



parcelRegister("aKav5", function(module, exports) {

$parcel$export(module.exports, "whitelabelForeignRedirect", () => $7d26586853d64f8c$export$73add47c0e9d5b93);
$parcel$export(module.exports, "whitelabelRouteGuard", () => $7d26586853d64f8c$export$adca24523b6ee30c);
// whitelabelRouteGuard.js — a white-label host never navigates to another
// tenant (WHITELABEL-STRICT-TENANT-SCOPE-1).
//
// Nika 2026-10-15: "this bug is serious and we need to strictly isolate all
// tenants and workspaces. now https://unreal.pr.symbols.app/studio shows keepz
// app". A customer's domain names ONE tenant; a URL on it that names a
// DIFFERENT org — `/w/<other>/…`, `/studio/<other>`, `/workspaces/<other>`, a
// `/<other>/<project>` canvas, or the account's own personal namespace — is
// another tenant's surface rendered under the customer's brand. The earlier
// contract ("a deep link into another org on a white-label host is NOT
// hijacked", customDomainBoot.js) is withdrawn: the host's tenant wins.
//
// smbls router guard (registered via context.router.guards — see
// demoRouteGuard.js / authGuard.js for the convention: `true` allows, a string
// redirects). Running INSIDE the router, before pushState/content-set, means
// the foreign page never mounts at all — no half-rendered board, no fetch of
// the other tenant's data, no title write. The boot-time half (the URL the tab
// LOADS on, before any navigation) is customDomainBoot.js; the data half is
// the server's host lock, which refuses another tenant whatever the URL says.
//
// Fail-safe on the platform: no host pin → `true`, before any parsing.

var $gNttC = parcelRequire("gNttC");

var $2C7Li = parcelRequire("2C7Li");
const $7d26586853d64f8c$var$idOf = (row)=>row ? String(row.id || row._id || '') : '';
const $7d26586853d64f8c$export$175b955d81da82f = (root, hostOrgId)=>{
    if (!root || !hostOrgId) return '';
    const rows = Array.isArray(root.orgs) ? root.orgs : [];
    const hit = rows.find((o)=>$7d26586853d64f8c$var$idOf(o) === String(hostOrgId)) || (root.org && $7d26586853d64f8c$var$idOf(root.org) === String(hostOrgId) ? root.org : null);
    return hit && (hit.slug || hit.username) || '';
};
const $7d26586853d64f8c$export$73add47c0e9d5b93 = (pathname, root)=>{
    const hostOrgId = (0, $gNttC.getHostScopeOrgId)() || root && root._hostScopeOrgId || null;
    if (!hostOrgId) return null;
    const named = (0, $2C7Li.urlNamedOrgSlug)(pathname || '', root);
    if (!named) return null;
    const hostSlug = $7d26586853d64f8c$export$175b955d81da82f(root, hostOrgId);
    // The host's slug is not known yet (orgs still loading): allow, and let the
    // two layers that need no slug hold the line — the boot reconcile
    // (customDomainBoot.js redirects a foreign URL once orgs land) and the
    // server's host lock (no data of another tenant is served to this origin).
    if (!hostSlug) return null;
    // Home of THIS host — the shell canonicalizes `/` onto the host's own
    // workspace. Nothing from the foreign URL (query, hash) is carried over.
    return named === hostSlug ? null : '/';
};
const $7d26586853d64f8c$export$adca24523b6ee30c = ({ pathname: pathname, element: element })=>$7d26586853d64f8c$export$73add47c0e9d5b93(pathname, element?.state?.root || element?.state) || true;
var $7d26586853d64f8c$export$2e2bcd8739ae039 = $7d26586853d64f8c$export$adca24523b6ee30c;

});


parcelRegister("df4OW", function(module, exports) {

$parcel$export(module.exports, "NotificationWrapper", () => $9a406a5bc29b0de6$export$3785346a4fed4152);
// Notification wrapper — reusable across intranet and editor.
// Reads `root.notifs` array (caller populates via listNotifications).
//
// ⚠️ DELIBERATE DUPLICATE, not the canonical copy (opus lane, 2026-08-19,
// tickets/opus.md census H2). `shared/components/Notifications.js` now
// carries its OWN local `NotificationWrapper` — the canonical one every
// OTHER consumer (canvas, marketplace, docs, analytics, preview) actually
// gets, since a cross-package top-level re-export of THIS file's version
// never resolved for a consumer declaring `shared` without `workspace-shell`
// (frank always stubs it regardless of declaration — FRANK-PAGES-BAG-1,
// tickets/done.md). This copy stays HERE, unchanged, because it is
// project-LOCAL to the shell — which already wins over any shared-library
// merge for the shell's own render tree, so the shell was never actually
// broken by the cross-package stub. Redirecting this file to import
// `@symbo-ls/workspace-shared`'s copy instead would add a NEW cross-package
// edge on the shell's OWN `smbls push` (frank-published despite
// `bundler: parcel`), risking the identical stub trap this relocation just
// fixed for `shared` — not worth it for a component this small. Keep the
// two bodies in sync by hand if either changes.
//
// NOTE: this file used to also export a `NotificationBell` here — an older
// duplicate (no `activeHighlight`) of the canonical bell in
// packages/workspace/components/NotificationBell.js. Removed 2026-07-27.
// Grepped the whole monorepo for other consumers of collab/index.js's
// NotificationBell export — none — so it was genuinely dead, not merely
// shadowed.
//
// NotificationPanel ALSO used to be defined here — an older, divergent
// duplicate (no `extends: 'CommonCard'`, 360x480, no All/Unread filter, its
// own `_markReadOptimistic` / `_markAllReadOptimistic` writing straight to
// ./queries.js) of the canonical panel in
// packages/workspace/components/NotificationBell.js. Both were reachable at
// once: this collab copy rendered exclusively in canvas's standalone bundle
// (links shared, never workspace), while the workspace copy shadowed it in
// the workspace shell (project components barrel wins over the shared-
// library merge) — two different panels behind one key. Removed 2026-07-27:
// the canonical (newer) definition moved to
// shared/components/Notifications.js as the SOLE copy, reusing this
// package's `markNotificationRead` / `markAllNotificationsRead` el.call
// registry (now also promoted to shared/functions so canvas resolves it
// too) instead of the optimistic-write helpers that used to live here.
// Loads root.notifs once a real recipient email is known, and re-loads if it
// changes (sign-out/sign-in in the same tab). Guarding on `el._loadedFor ===
// email` (not a bare "already ran" boolean) is the fix for a real bug found
// live 2026-07-30 verifying the PersonPopover Ping action: the previous guard
// set `el._loaded = true` UNCONDITIONALLY before checking `currentUserEmail`,
// so if this component's first (and, absent a subscription, likely ONLY)
// onRender fired before auth hydration finished — routine on a fresh boot —
// it saw an empty email, bailed, and never got another chance: root.notifs
// stayed permanently empty for the rest of the session even though the
// server had real rows (confirmed: a direct `workspaceProject.notifications`
// list call returned data the bell/panel never saw). Pairing `onInit` +
// `onUpdate` with `subscribeTo: ['currentUserEmail']` mirrors the established
// PendingInvitesBlock pattern (components/PersonCard.js) for "load once a
// late-hydrating root key is ready, retry on the next update".

const $9a406a5bc29b0de6$var$_loadNotifs = (el, s)=>{
    const email = s.root?.currentUserEmail;
    if (!email || el._loadedFor === email) return;
    el._loadedFor = email;
    (async ()=>{
        const { listNotifications: listNotifications } = await (parcelRequire("9qps7"));
        const { data: data } = await listNotifications({
            recipientEmail: email,
            limit: 50
        });
        const rows = (data || []).map((n)=>({
                ...n,
                createdAt: n.created_at,
                read: !!n.read
            }));
        s.root.update({
            notifs: rows
        });
    })();
};
const $9a406a5bc29b0de6$export$3785346a4fed4152 = {
    position: 'relative',
    subscribeTo: [
        'currentUserEmail'
    ],
    onInit: (el, s)=>$9a406a5bc29b0de6$var$_loadNotifs(el, s),
    onUpdate: (el, s)=>$9a406a5bc29b0de6$var$_loadNotifs(el, s),
    // Panel is dropdown-layer content now (the bell opens it via
    // openDropdown) — mounting it here would render a second, in-flow copy.
    NotificationBell: {}
};

});

parcelRegister("cKmtB", function(module, exports) {

$parcel$export(module.exports, "primePeople", () => $947b374aa9b678cf$export$53574c4e2e52fda0);
$parcel$export(module.exports, "primedOrgSlug", () => $947b374aa9b678cf$export$ccdfbb38e9a10158);
$parcel$export(module.exports, "peekPrimedPeople", () => $947b374aa9b678cf$export$62799c500286dd4f);
$parcel$export(module.exports, "consumePrimedPeople", () => $947b374aa9b678cf$export$87145f577859cea1);
// Boot-time member-roster prime — the single biggest workspace loading-speed
// win for the member list.
//
// PROBLEM (profiled 2026-06-13): the /users/members roster is authed by the SDK
// Mongo token alone (already in localStorage at page entry) and is org-scoped
// SERVER-side from that token — so it needs NEITHER getMe, the governance JWT,
// NOR the resolved org/workspace state. Yet the normal path
// (loadPrivateData → listOrgMembers) is structurally pinned to the END of a
// fully sequential auth+mount boot: awaitSDKInit → getMe → eager
// org/workspace scope fetches → import('smbls') + create() → onCreate prelude →
// subscribeAuthSession → loadPrivateData. The roster fetch can't even START
// until several seconds in (measured: people not on screen until ~7-13s).
//
// FIX: fire the roster fetch at the very workspace entry (index.js), in
// PARALLEL with the entire boot, and have loadPrivateData CONSUME the in-flight
// promise instead of issuing a fresh round-trip at the tail of the boot. This
// collapses the roster's latency from "after the whole boot" to "≈ as soon as
// the SDK init resolves (a few ms)". Zero correctness risk: same endpoint, same
// token, same server-side org scoping — and loadPrivateData falls back to a
// fresh fetch if the prime is absent or failed (worst case == old behavior).
let $947b374aa9b678cf$var$_primed = null;
let $947b374aa9b678cf$var$_primedOrgSlug = null;
let $947b374aa9b678cf$var$_consumed = false;
// The /w/<org-slug> segment at page entry — the ONLY tenant signal available
// before any auth/workspace state resolves. Sent to the server as `orgSlug`
// (membership-verified there) so the prime is scoped to the tab's viewed org
// rather than the token's global activeOrganization, which lags URL-based
// workspace browsing (the prime used to plant the OTHER org's roster).
// Named distinctly from app.js's own unrelated `_urlOrgSlug` — two
// same-named module-scope consts in the same bundle get esbuild-
// disambiguated (`_urlOrgSlug2`), which frank's classifier can't map back
// to source (`unresolvable-identifier`). See tickets/fable.md "decompose
// workspace-shell's 507 defects".
const $947b374aa9b678cf$var$_primeUrlOrgSlug = ()=>{
    const m = /^\/w\/([^/]+)/.exec(globalThis.location?.pathname || '');
    return m ? m[1].toLowerCase() : null;
};
const $947b374aa9b678cf$export$53574c4e2e52fda0 = (sdk)=>{
    if ($947b374aa9b678cf$var$_primed || !sdk || typeof sdk.execute !== 'function') return $947b374aa9b678cf$var$_primed;
    $947b374aa9b678cf$var$_primedOrgSlug = $947b374aa9b678cf$var$_primeUrlOrgSlug();
    $947b374aa9b678cf$var$_primed = Promise.resolve().then(()=>sdk.execute('users.members', 'list', $947b374aa9b678cf$var$_primedOrgSlug ? {
            orgSlug: $947b374aa9b678cf$var$_primedOrgSlug
        } : undefined)).then((rows)=>Array.isArray(rows) ? rows : rows?.data || rows?.people || rows?.rows || []).catch((err)=>{
        console.warn('[peoplePrime] roster prime failed', err?.message || err);
        return null;
    });
    return $947b374aa9b678cf$var$_primed;
};
const $947b374aa9b678cf$export$ccdfbb38e9a10158 = ()=>$947b374aa9b678cf$var$_primedOrgSlug;
const $947b374aa9b678cf$export$62799c500286dd4f = ()=>$947b374aa9b678cf$var$_primed;
const $947b374aa9b678cf$export$87145f577859cea1 = ()=>{
    if ($947b374aa9b678cf$var$_consumed) return null;
    $947b374aa9b678cf$var$_consumed = true;
    return $947b374aa9b678cf$var$_primed;
};

});

parcelRegister("6p65M", function(module, exports) {

$parcel$export(module.exports, "homeWidgetHue", () => $4a99cda973f3475e$export$66f7ceb705f28401);
$parcel$export(module.exports, "posterFamilyEntry", () => $4a99cda973f3475e$export$21e5935e16a3a9a3);
$parcel$export(module.exports, "POSTER_FAMILY_KEYS", () => $4a99cda973f3475e$export$3e169af86e3cd628);
$parcel$export(module.exports, "POSTER_FAMILY_LABELS", () => $4a99cda973f3475e$export$c00abe930b2a977c);
$parcel$export(module.exports, "homeWidgetColorOptions", () => $4a99cda973f3475e$export$d89f3e498bcc0a00);
$parcel$export(module.exports, "homeWidgetAppColorOption", () => $4a99cda973f3475e$export$54228a2c7aeea976);
$parcel$export(module.exports, "homeWidgetSurfaceHue", () => $4a99cda973f3475e$export$3ac0c9e30b0a42b3);
$parcel$export(module.exports, "rowHueRotation", () => $4a99cda973f3475e$export$c343282a2c25c62d);
parcelRequire("67GC6");
var $hzNzB = parcelRequire("hzNzB");
var $5koEk = parcelRequire("5koEk");
// Home-board poster palette — the geex/bellforge direction as the DEFAULT
// workspace look (Nika 2026-08-09: "restyle all builtin workspace apps /
// home page widgets… from bellforge workspace you have all design direction
// which we should make default workspace").
//
// One hue per widget, binary ink, ink-alpha secondary system — the bellforge
// rotation (workspace/BELLFORGE_REDESIGN.md) generalized to the shell's home
// widgets. App shortcuts and their content siblings share a family so the
// board reads as one set (multicolor lives ACROSS the set, never within one
// card — design-direction.md §6). `greeting` is deliberately absent: it is
// the board's neutral adaptive anchor (≤2 neutral screens per set).
//
// Posters are theme-invariant by design (verified pattern from bellforge:
// hue + binary ink render identically in dark and light shells); everything
// secondary derives from the ink via the colour grammar, never a gray.
//
// WHAT THIS FILE DOES NOT DO: pick what a visual drawn ON the card reads in.
// The {bg, ink} pair below is the PLATE contract — a surface and the ink that
// reads on it (HomeWidgetPlate, HomeWidgetAvatars) — and it reads against the
// CARD only by accident, because a plate colour is never measured against the
// card's own background. A dark "plate" family (analytics, a near-black hue)
// is illegible there in the dark theme: DESIGN-HOME-WIDGET-HUE-DARK-PLATE-
// INVISIBLE-1. The on-surface answer — `--home-widget-accent`, derived per
// theme against the design system's own card ground — lives in
// functions/homeWidgetFrame.js (`homeWidgetAccentOnSurfaceVars`), not here;
// every bar/dot/spark/stat a widget draws on its card reads that var, never
// `--home-widget-hue` directly.
//
// Module-widget hue fallback (tickets/brief-product-ui-direction.md "Module
// widget hue resolution" — widget EXTENSIBILITY contract, 2026-08-12): this
// MAP is a FIXED house catalog keyed by the shell's OWN widget/route ids — a
// third-party app-module's widget (apps/bi's 'bi-revenue', a future
// AI-created widget, …) is NEVER in it, by construction, forever. Before the
// second `fallbackHue` parameter existed, every such widget silently fell
// through to the neutral overlay/title pair — discarding whatever hue the
// module's OWN manifest declared for it (`spec.iconBg`, or the newer
// top-level `hue`) — so a 4-widget module like BI rendered as 4 identical
// grey tiles instead of the purple/blue/green/orange its manifest names.
// `homeWidgetHue(id, fallbackHue, designSystem)` now tries the curated MAP
// first (zero behaviour change for every house id/route), and when that
// misses, resolves `fallbackHue` — a bare hue-family name, e.g. 'purple' —
// by MEASURING it (tickets/fable.md, closing the hole left by workspace
// `737b47e6`'s hand-seeded `_HUE_INK` table): `designSystem` is the caller's
// processed scratch CONFIG (`el.context.designSystem` — see AppHueTile.js),
// threaded through as a plain parameter so this stays a pure, DOM-less,
// `el`-less function with no reach into a global singleton. `resolveColorRgb`
// (`@symbo.ls/scratch`, the same package's `getSafeInk` already uses it — see
// `system/ink.js`) resolves the hue's REAL rgb from that config — applying
// the `+N`/`-N` tone grammar itself — and `_measuredInk` below picks
// whichever of pure black/white clears MORE WCAG contrast against it. A hue
// name that is not a brand hue at all (unresolvable — no DOM/config can name
// it) still falls through to WHITE ink, the documented historical default
// for an undecided hue (the pre-refactor global fallback was literally
// `iconBg || 'blue'` background with a fixed white ink; see
// HomeModuleWidget.Header.IconTile in pages/main.js) — there being nothing to
// measure is the one case still left to a guess, and it is the ONLY case
// left to one. A caller with no `designSystem` to hand (e.g. the module-scope
// `homeWidgetHue(id)` calls in pages/main.js, which never pass a
// `fallbackHue` and therefore never reach this branch at all) gets the exact
// same historical-default behaviour, unchanged.
// ── THE POSTER CATALOG (tickets/fable.md HOME-POSTER-BRAND-1, 2026-08-19) ──
// ⚠️ SINCE 2026-09-02 THIS IS NO LONGER THE HOME BOARD'S DEFAULT TREATMENT.
// The board renders one neutral solid surface for every card; a family below
// is painted only where the USER picked it (context menu ▸ "Add color"). Read
// `posterFamilyEntry` / `homeWidgetSurfaceHue` at the bottom of this file
// before assuming a house id still paints its hue on the / page. The map is
// still live for the route-keyed LAUNCHER tiles.
// Every house id/route below resolves to a POSTER FAMILY, and every family
// is a pair of SEMANTIC TOKENS of the shell design system
// (`designSystem/color.js`, `poster<Family>` + `poster<Family>Ink`) — not a
// raw brand hue. Same rendered defaults (the tokens alias the exact hues
// this map used to name), one difference that matters: scratch emits each
// token as a CSS var (`--color-posterStudio`, `--color-posterStudioInk`), so
// a BRANDED WORKSPACE can supply its own poster pairs through the record
// channel the shell already has — `Workspace.settings.designSystem.vars`,
// written inline on `<html>` by `workspaceConfigs._applyDesignSystem` and
// reverted on switch — and the WHOLE identity follows (card, launcher tile,
// re-plated rows, hover wash, secondary-ink steps) with zero code and zero
// tenant literal here. A workspace without those vars renders the defaults.
//   record contract (plain CSS colours, supply the PAIR):
//     "--color-posterStudio": "<hue>", "--color-posterStudioInk": "<white|black>"
//
// Third column = the SECONDARY-INK alpha, MEASURED per family (the smallest
// alpha of the binary ink that clears ≥4.6:1 — the AA text floor plus a
// margin — composited over ITS OWN hue; `__tests__/homePosterTokens.test.js`
// re-derives every number from the real design system and fails if one
// drifts). The old blanket `.55` was a grammar floor nobody had measured:
// on a saturated hue it read at 1.9–3.5:1 (calendar red 1.92, chat 2.04,
// studio 2.88 …), i.e. every poster Subtitle and body caption was under AA.
// On a deep hue the step sits near the full ink (meet .94) — hierarchy
// below it is carried by size/weight, not alpha; on gray2 it stays at .46.
// `inkMeta` on a poster equals the same step: there is no AA headroom under
// it (the `.45` meta grammar belongs to the row families below).
//
// Binary-ink law unchanged (design-direction.md §6): white is the ink of a
// deep/saturated hue, black only of a pale one. Three families were DEEPENED
// with the `−N` grammar so white clears ≥5.0:1 at full opacity (the Meet
// `green-20` precedent, now `green-45`): calendar `red`→`red-40`, chat
// `grassgreen`→`grassgreen-35`, meet `green-20`→`green-45`. The alias lives
// in designSystem/color.js; this file names only the semantic token.
const $4a99cda973f3475e$var$POSTER_FAMILIES = {
    studio: [
        'posterStudio',
        'posterStudioInk',
        '.81'
    ],
    tickets: [
        'posterTickets',
        'posterTicketsInk',
        '.67'
    ],
    chat: [
        'posterChat',
        'posterChatInk',
        '.90'
    ],
    calendar: [
        'posterCalendar',
        'posterCalendarInk',
        '.92'
    ],
    reminders: [
        'posterReminders',
        'posterRemindersInk',
        '.58'
    ],
    meet: [
        'posterMeet',
        'posterMeetInk',
        '.94'
    ],
    broadcast: [
        'posterBroadcast',
        'posterBroadcastInk',
        '.60'
    ],
    documents: [
        'posterDocuments',
        'posterDocumentsInk',
        '.64'
    ],
    agents: [
        'posterAgents',
        'posterAgentsInk',
        '.77'
    ],
    team: [
        'posterTeam',
        'posterTeamInk',
        '.59'
    ],
    analytics: [
        'posterAnalytics',
        'posterAnalyticsInk',
        '.46'
    ],
    people: [
        'posterPeople',
        'posterPeopleInk',
        '.89'
    ],
    health: [
        'posterHealth',
        'posterHealthInk',
        '.59'
    ],
    files: [
        'posterFiles',
        'posterFilesInk',
        '.62'
    ]
};
// Widget id / app route → poster family. App shortcuts and their content
// siblings share a family so the board reads as one set (multicolor lives
// ACROSS the set, never within one card — design-direction.md §6).
// `greeting` is deliberately absent: it is the board's neutral adaptive
// anchor (≤2 neutral screens per set). Route aliases keep the search
// dropdown springboard (SEARCH_APPS rows carry `route`) and any launcher on
// the SAME family as the home board — one source of truth.
const $4a99cda973f3475e$var$HOUSE_HUE_MAP = {
    'app-studio': 'studio',
    projects: 'studio',
    'app-tickets': 'tickets',
    received: 'tickets',
    given: 'tickets',
    'app-chat': 'chat',
    'app-calendar': 'calendar',
    events: 'calendar',
    'next-up': 'calendar',
    'app-reminders': 'reminders',
    'app-meet': 'meet',
    'app-broadcast': 'broadcast',
    broadcast: 'broadcast',
    'app-documents': 'documents',
    assets: 'documents',
    'app-agents': 'agents',
    agents: 'agents',
    youragents: 'agents',
    'app-team': 'team',
    teamtime: 'team',
    'app-analytics': 'analytics',
    analytics: 'analytics',
    activity: 'analytics',
    'app-people': 'people',
    'app-health': 'health',
    '/studio': 'studio',
    '/tasks': 'tickets',
    '/notes': 'documents',
    '/files': 'files',
    '/chat': 'chat',
    '/calendar': 'calendar',
    '/meet': 'meet',
    '/reminders': 'reminders',
    // History reads the activity log — the analytics family.
    '/history': 'analytics',
    '/announcements': 'broadcast',
    '/team-and-agents': 'agents',
    '/agents': 'agents',
    '/team-members': 'team',
    '/analytics': 'analytics',
    '/workspace-analytics': 'analytics',
    '/people': 'people',
    '/health': 'health',
    '/system-status': 'health',
    '/admin/system': 'health',
    '/admin': 'analytics',
    '/admin/module': 'analytics',
    '/admin/permissions': 'analytics',
    '/admin/teams': 'analytics',
    '/admin/usage': 'analytics'
};
// Bare hue-family name → the house's art-directed form of it. Applies ONLY to
// the manifest-fallback path (a house id/route already resolves through
// `HOUSE_HUE_MAP` directly), so a module declaring `hue: 'green'` lands on the
// exact same plate as the house's own `app-meet`, rather than on the raw
// brand hex that fails the ink floor. This is an ART-DIRECTION choice (one
// `green` identity board-wide, keeping §6's Meet `green` + `red` pairing) —
// not a contrast workaround, so it survives the move to measured ink below:
// `_measuredInk('green-45', …)` still independently clears the 3:1 floor with
// white (5.03:1), it just no longer needs to be TOLD that. (`green-20` until
// 2026-08-19; the house Meet plate deepened to `green-45` for the 4.5:1 TEXT
// floor — the raw module hue stays a RAW token on purpose: a module's
// manifest hue is the module's own brand, not a poster, so a workspace's
// poster-record override must not silently re-skin it.)
const $4a99cda973f3475e$var$_HUE_ALIAS = {
    green: 'green-45'
};
// Measure the binary ink for a resolved bg token, replacing the hand-seeded
// `_HUE_INK` table `737b47e6` shipped (deleted here — see tickets/fable.md).
// No second hand-authored list, no enumeration ceiling: any brand hue this
// repo will ever declare, including one no one has typed into this file,
// resolves through the SAME live design-system lookup a rendered
// `background: bg` would use.
//
// design-direction.md §6's binary-ink law is CATEGORICAL, not "whichever
// wins more contrast": white is the default ink for a deep/saturated hue,
// black only for a pale/bright one that fails white outright. Picking
// "whichever of black/white measures higher contrast" is the WRONG rule
// here — black nearly always out-measures white against a mid-tone hue (its
// luminance floor is 0, white's is 1, so black usually has more headroom),
// which would silently flip every hue that already clears the floor with
// white — `green-20` (3.61:1 white, but 5.82:1 black) and `blue` (3.62:1
// white, but 5.80:1 black) both did exactly this on the first pass, which
// would have regressed `green`'s art-directed white-ink Meet identity and
// the pre-existing `blue` pairing even though NEITHER was failing anything.
// The correct measurement is a FLOOR check: white wins whenever it already
// clears 3:1 (matching every hue the house has ever shipped white ink for,
// with no table needed to say so); only a hue that genuinely fails white
// falls to black.
//
// `resolveColorRgb` (`@symbo.ls/scratch`, the same resolver `getSafeInk`
// already uses — system/ink.js) walks `designSystem.color`/`.gradient` by
// name, applying the `+N`/`-N` additive tone shift itself (mirrors
// `getColorShade`, `smbls/packages/scratch/src/utils/color.js`) — so
// `'pink+20'`/`'cerulean+30'`-style tokens resolve exactly like a rendered
// element's `background:` would, with no separate tone-parsing here.
//
// Returns `null` when the token can't be resolved at all (not a registered
// brand hue and not a parsable CSS color, or no `designSystem` was handed
// in) — there is nothing to measure, so the caller keeps its own documented
// fallback. `resolveColorRgb`'s own color-string fallback can throw when the
// runtime's DOM is present but incomplete (a test-harness stub with no
// `document.body`, see `__tests__/testDomShim.js`) rather than degrading to
// its own "can't resolve" return — the try/catch below normalizes that into
// the same `null` "can't measure" signal, so a DOM-completeness quirk in one
// runtime can never make this pure function throw where a real browser or a
// full DOM never would.
const $4a99cda973f3475e$var$_measuredInk = (bg, designSystem)=>{
    if (!designSystem) return null;
    let resolved;
    try {
        resolved = (0, $5koEk.resolveColorRgb)(bg, designSystem);
    } catch (_) {
        return null;
    }
    if (!resolved) return null;
    const composited = (0, $hzNzB.compositeOverBackdrop)(resolved.rgb, resolved.alpha);
    const onWhite = (0, $hzNzB.contrastRatio)(composited, [
        255,
        255,
        255
    ]);
    // White is the default/preferred ink (design-direction.md §6) — keep it
    // whenever it already clears the 3:1 non-text floor. Only fall to black
    // when white genuinely fails, and even then only if black actually
    // measures better (it will, for anything that fails white this badly —
    // this is a defensive comparison, not the decision rule).
    if (onWhite >= 3) return 'white';
    const onBlack = (0, $hzNzB.contrastRatio)(composited, [
        0,
        0,
        0
    ]);
    return onBlack >= onWhite ? 'black' : 'white';
};
// Shared {bg, ink, inkSoft, inkMeta, wash, fill} contract builder — the ONE
// place that derives the ink-alpha secondary system (§6: secondary text .55
// floor, meta .45, interactive wash .08, resting fill .12) from a resolved
// {bg, ink} pair, so `homeWidgetHue` and `rowHueRotation` can never drift on
// the derivation even though they resolve their base pair differently.
//
// `inkMetaOverride` (optional, 3rd positional) — DESIGN_LANGUAGE.md §8.5
// rule 6 ("never dim with opacity on top of an already-muted token — the
// composite silently halves the ratio; use the muted token at full
// opacity"). The blanket `ink + '.45'` formula assumes every `{bg, ink}`
// pair has enough full-opacity headroom to survive a 45%-alpha dilution
// toward `bg` — true for `homeWidgetHue`'s deep-hue/white-ink posters, but
// MEASURABLY FALSE for `rowHueRotation('pastel')`'s `purple+32` fill
// (composited bellforge measurement rgb(147,101,207): full-opacity black
// clears the WCAG floor at only 5.00:1 — the smallest headroom in the
// family, by design a saturated-not-actually-pale tint — so ANY alpha
// dilution below 1.0 drops it under 4.5:1; verified computationally against
// every alpha step from 0 to 1, none between 0.99 and 0 clears 4.5:1).
// Pass a concrete, independently-measured-safe value here instead of
// trusting the blanket formula when a family's bg tone doesn't have that
// margin — never guessed, always computed via `contrastRatio`/
// `compositeOverBackdrop` against the family's real composited fills.
// `inkSoftOverride` (optional, 4th positional) — the same idea one step up:
// the POSTER families pass their MEASURED secondary alpha (see
// `POSTER_FAMILIES` above) instead of the blanket `.55`. Row families leave
// it unset and keep the grammar default.
const $4a99cda973f3475e$var$_hueEntry = (bg, ink, inkMetaOverride, inkSoftOverride)=>({
        bg: bg,
        ink: ink,
        inkSoft: inkSoftOverride || ink + '.55',
        inkMeta: inkMetaOverride || ink + '.45',
        wash: ink + '.08',
        fill: ink + '.12'
    });
function $4a99cda973f3475e$export$66f7ceb705f28401(id, fallbackHue, designSystem) {
    const entry = $4a99cda973f3475e$export$21e5935e16a3a9a3($4a99cda973f3475e$var$HOUSE_HUE_MAP[id]);
    if (entry) return entry;
    if (typeof fallbackHue === 'string' && fallbackHue) {
        const bg = $4a99cda973f3475e$var$_HUE_ALIAS[fallbackHue] || fallbackHue;
        return $4a99cda973f3475e$var$_hueEntry(bg, $4a99cda973f3475e$var$_measuredInk(bg, designSystem) || 'white');
    }
    return null;
}
function $4a99cda973f3475e$export$21e5935e16a3a9a3(familyKey) {
    const family = $4a99cda973f3475e$var$POSTER_FAMILIES[familyKey];
    if (!family) return null;
    // bg + ink are the family's SEMANTIC tokens; the secondary step is the
    // measured alpha of THAT ink token (`posterStudioInk.81`), which resolves
    // at paint time off the same var a record override rewrites.
    const soft = family[1] + family[2];
    return $4a99cda973f3475e$var$_hueEntry(family[0], family[1], soft, soft);
}
const $4a99cda973f3475e$export$3e169af86e3cd628 = Object.keys($4a99cda973f3475e$var$POSTER_FAMILIES);
const $4a99cda973f3475e$export$c00abe930b2a977c = {
    studio: 'Electric blue',
    tickets: 'Orange',
    chat: 'Moss green',
    calendar: 'Brick red',
    reminders: 'Yellow',
    meet: 'Forest green',
    broadcast: 'Pink',
    documents: 'Sky blue',
    agents: 'Purple',
    team: 'Cyan',
    analytics: 'Graphite',
    people: 'Brown',
    health: 'Lime',
    files: 'Azure'
};
function $4a99cda973f3475e$export$d89f3e498bcc0a00(root, widgetId) {
    // Unconditional map read — same FA515 reasoning as `homeWidgetSurfaceHue`.
    const map = root ? root._homeWidgetColors : null;
    const picked = map && widgetId ? map[widgetId] : null;
    return $4a99cda973f3475e$export$3e169af86e3cd628.map((key)=>({
            key: key,
            label: $4a99cda973f3475e$export$c00abe930b2a977c[key],
            bg: $4a99cda973f3475e$var$POSTER_FAMILIES[key][0],
            ink: $4a99cda973f3475e$var$POSTER_FAMILIES[key][1],
            active: picked === key
        }));
}
function $4a99cda973f3475e$export$54228a2c7aeea976(root, widgetId, appHue, designSystem) {
    const entry = $4a99cda973f3475e$var$_rawHueEntry(appHue, designSystem);
    if (!entry) return null;
    // Unconditional map read — same FA515 reasoning as the resolver.
    const map = root ? root._homeWidgetColors : null;
    const picked = map && widgetId ? map[widgetId] : null;
    return {
        key: appHue,
        label: 'workspace.widgetColor.appColor',
        bg: entry.bg,
        ink: entry.ink,
        active: picked === appHue
    };
}
// A RAW hue name (a module's manifest hue, as the user picked it) → the same
// {bg, ink, …} contract a family key produces. Shared by the resolver and by
// the picker's "App color" row so the swatch and the card it will paint can
// never disagree on either half of the pair.
//
// Returns null when the hue is genuinely unresolvable AND a design system was
// available to prove it. That distinction matters: `_measuredInk` returns null
// both for "not a colour" and for "no design system handed in", and treating
// the second as unresolvable would neutralise every correct hue at a call site
// that has no config to thread. So the no-config branch keeps the documented
// historical default (white ink), and only a MEASURED failure neutralises —
// which is what stops a typo'd manifest hue from minting an invalid
// `background` declaration that drops, leaving white text on a transparent
// card.
const $4a99cda973f3475e$var$_rawHueEntry = (hue, designSystem)=>{
    if (typeof hue !== 'string' || !hue) return null;
    const bg = $4a99cda973f3475e$var$_HUE_ALIAS[hue] || hue;
    if (!designSystem) return $4a99cda973f3475e$var$_hueEntry(bg, 'white');
    const ink = $4a99cda973f3475e$var$_measuredInk(bg, designSystem);
    return ink ? $4a99cda973f3475e$var$_hueEntry(bg, ink) : null;
};
function $4a99cda973f3475e$export$3ac0c9e30b0a42b3(root, id, designSystem) {
    const map = root ? root._homeWidgetColors : null;
    const picked = map && id ? map[id] : null;
    if (typeof picked !== 'string' || !picked) return null;
    return $4a99cda973f3475e$export$21e5935e16a3a9a3(picked) || $4a99cda973f3475e$var$_rawHueEntry(picked, designSystem);
}
// Row-hue rotations — geex reference frames 11/22/23 (workspace/design-refs/
// geex, tickets/brief-product-ui-direction.md "two colour registers"). Unlike
// `homeWidgetHue` (ONE hue per whole poster/widget), these cycle a small
// family of hues PER ROW so a list reads as one rotating set instead of one
// flat color:
//   'muted'  — full-bleed inbox/broadcast rows: olive/green/orange/red,
//              deep enough for WHITE ink (frame 11).
//   'pastel' — tonal transaction/order rows: lavender/lemon/mint/sky tints,
//              pale enough for BLACK ink (frames 22/23).
// Same {bg, ink, inkSoft, inkMeta, wash, fill} contract as homeWidgetHue so
// row components never branch on which family they got.
// `pastel` 3rd-column `inkMetaOverride` — MEASURED, not the blanket `.45`
// formula (see `_hueEntry`'s docblock). Ground truth: live-composited
// bellforge Enterprise rgb values for these four exact fills — `purple+32`
// rgb(147,101,207), `yellow+20` rgb(252,224,106), `phosphorus+32`
// rgb(220,248,85), `cerulean+32` rgb(32,220,255) — run through this
// package's own `contrastRatio`/`compositeOverBackdrop` (identical math
// `_measuredInk` above uses), computed with a real safety margin (targeting
// >=5.0:1, not a razor-thin 4.50 that could round-trip fail under render
// jitter) rather than the largest technically-passing alpha:
//   purple+32:      full-opacity black is the CEILING at 5.00:1 — this fill
//                    is not actually pale (a saturated mid-purple despite
//                    the `+32` lighten), so it has zero headroom for ANY
//                    dilution; every alpha < 1.0 measured under 4.5:1.
//                    Override is the literal `'black'` (opaque, no `.NN`
//                    suffix) — NOT `null`/falsy: `_hueEntry`'s formula is
//                    `inkMetaOverride || ink + '.45'`, so a falsy override
//                    would silently fall through to the broken blanket
//                    formula this fix exists to stop using here.
//   yellow+20:      alpha .65 -> 6.29:1 (headroom to spare; .59 is the
//                    lowest-alpha floor for >=5.0, rounded up for margin)
//   phosphorus+32:  alpha .65 -> 6.54:1 (.58 floor)
//   cerulean+32:    alpha .65 -> 5.74:1 (.61 floor)
// Re-derive with scratchpad/probe_ink.mjs-style math (contrastRatio +
// compositeOverBackdrop from `@symbo.ls/scratch`) if this palette's tone
// values ever change — these are computed constants, not eyeballed.
const $4a99cda973f3475e$var$ROW_HUE_FAMILIES = {
    muted: [
        [
            'brown',
            'white'
        ],
        [
            'green-10',
            'white'
        ],
        [
            'orange-10',
            'white'
        ],
        [
            'red-10',
            'white'
        ]
    ],
    pastel: [
        [
            'purple+32',
            'black',
            'black'
        ],
        [
            'yellow+20',
            'black',
            'black.65'
        ],
        [
            'phosphorus+32',
            'black',
            'black.65'
        ],
        [
            'cerulean+32',
            'black',
            'black.65'
        ]
    ]
};
function $4a99cda973f3475e$export$c343282a2c25c62d(index, family) {
    const list = $4a99cda973f3475e$var$ROW_HUE_FAMILIES[family] || $4a99cda973f3475e$var$ROW_HUE_FAMILIES.muted;
    const i = ((Number(index) || 0) % list.length + list.length) % list.length;
    const hit = list[i];
    return $4a99cda973f3475e$var$_hueEntry(hit[0], hit[1], hit[2]);
}

});

parcelRegister("74YUs", function(module, exports) {

$parcel$export(module.exports, "homeWidgetColorsKey", () => $5278277c6f525864$export$bbe72d970e1231d6);
$parcel$export(module.exports, "readHomeWidgetColors", () => $5278277c6f525864$export$3b4ffd664670e52e);
// Per-widget colour storage — the two PURE decisions behind the home board's
// "Add color" feature (2026-09-02, Nika: "add in context menu 'Add color'
// option so users can customize widget colors + suggested colors"): what the
// local cache key looks like, and which source wins at boot.
//
// The IO stays in pages/main.js beside the hidden-widget writer this mirrors
// (`_hiddenWidgetsKey` / `_saveHiddenWidgets` / `_resolveBootHidden`) — the
// localStorage write, the `_savePrefsPatch` debounce and the workspace-scope
// builder all already live there and are shared with the layout and hidden
// sets. Only the decisions live here, because a decision is what a test can
// pin and IO is not: a colour map written under the wrong scope key is a
// cross-workspace leak, and a boot read with the wrong precedence silently
// resurrects a stale colour after a device sync.
//
// ── SCOPE ────────────────────────────────────────────────────────────────
// The key carries the workspace scope for the same reason the hidden set's
// does: a user's board is per workspace, and a shared key would paint one
// workspace's choices onto another's widgets the moment the ids collide (and
// house widget ids collide by construction — every workspace has `greeting`,
// `received`, `app-chat`). The caller passes the scope string it already
// resolved (`_wsScopeForBootRead(root)`), so there is exactly one scope
// resolver in the app and this file cannot drift from it.
function $5278277c6f525864$export$bbe72d970e1231d6(scope) {
    return `symbols.home.widgetColors.v1.${scope || 'default'}`;
}
function $5278277c6f525864$export$3b4ffd664670e52e(prefsRow, cachedRaw) {
    const fromRow = prefsRow && prefsRow.widget_colors;
    if ($5278277c6f525864$var$_isColorMap(fromRow)) return fromRow;
    try {
        const parsed = cachedRaw ? JSON.parse(cachedRaw) : null;
        if ($5278277c6f525864$var$_isColorMap(parsed)) return parsed;
    } catch (_) {
    /* unreadable cache → no colours, never a throw at boot */ }
    return {};
}
// A colour map is a plain object of `{ widgetId: familyKey }`. An ARRAY is
// rejected explicitly: `typeof [] === 'object'`, and an array reaching a
// `map[id]` lookup would silently resolve every widget to undefined rather
// than surfacing the bad shape.
const $5278277c6f525864$var$_isColorMap = (v)=>!!v && typeof v === 'object' && !Array.isArray(v);

});

parcelRegister("aJYU4", function(module, exports) {

$parcel$export(module.exports, "HOME_GRID_CELL_CAP", () => $7d1d597f66a57ede$export$be848df41eb346c);
$parcel$export(module.exports, "HOME_GRID_STEPS", () => $7d1d597f66a57ede$export$7c51d342b3419093);
$parcel$export(module.exports, "HOME_WIDGET_SIZES", () => $7d1d597f66a57ede$export$eb64929ce5651ed6);
$parcel$export(module.exports, "homeGridMetrics", () => $7d1d597f66a57ede$export$655b5d8adfdda81a);
$parcel$export(module.exports, "homeWidgetSpanAt", () => $7d1d597f66a57ede$export$39afd78ac2a36876);
$parcel$export(module.exports, "homeWidgetSpan", () => $7d1d597f66a57ede$export$9ae13b69a13f8950);
$parcel$export(module.exports, "HOME_BODY_LAYOUTS", () => $7d1d597f66a57ede$export$10539cbad73da51c);
$parcel$export(module.exports, "homeBodyFit", () => $7d1d597f66a57ede$export$163142670a1cd3b6);
$parcel$export(module.exports, "homeSpanVar", () => $7d1d597f66a57ede$export$388e3ed337540034);
$parcel$export(module.exports, "homeSpanFitCss", () => $7d1d597f66a57ede$export$4c5a8a14e168a7d0);
$parcel$export(module.exports, "homeSpanVarsFor", () => $7d1d597f66a57ede$export$86db81b5e291a6b8);
$parcel$export(module.exports, "homeSpanFitWords", () => $7d1d597f66a57ede$export$fc6026f08ff2b6be);
$parcel$export(module.exports, "homeWidgetSizeForCell", () => $7d1d597f66a57ede$export$1ed7b07fbfaa3ad3);
// HOME GRID METRICS — the ONE geometry table of the workspace "/" board
// (tickets/reference/white-label-redesign/HOME_WIDGETS_SPEC.md §1).
//
// Every number the board's layout depends on lives here: the column steps,
// the gutters, the square-cell cap, the four widget sizes and what each size
// spans at each column count. pages/main.js and the home components read these
// functions; __tests__/homeGridMetrics.test.js pins every value to the spec
// table, so there is no second copy to drift.
//
// COLUMNS FOLLOW THE GRID'S OWN WIDTH, never the viewport — the assistant dock
// narrowing the page narrows the grid too. The board states this as container
// queries in its injected stylesheet (pages/main.js `_injectWidgetStyles`,
// generated from this table): the smbls atomic CSS engine does not wrap an
// `@container` key yet (it composes `.cls @container …`, dead CSS). Pure CSS
// also lays the board out in a hidden background tab, where rAF and
// ResizeObserver never fire. `homeGridMetrics` answers the same question for
// JS and for the lock test.
//
// NO APP TILES: app shortcuts never sit in the grid — they live in the ONE App
// strip between the greeting and the grid (decision H1 A, Nika "go all
// recommended", 2026-09-27; components/HomeAppStrip.js). So every step's grid
// is its cells, one track per cell (the phone step's half-tracks existed only
// to seat app tiles two up, and left with them).
//
// The px values are the spec's own geometry, stated once here on purpose (the
// spec: "one constants module … a lock test pins its px values to this
// table"). They are not spacing tokens: the spacing scale is em-based and the
// cell grid must not shrink with a card's font size.
//
// WIDER BOARD (Nika 2026-09-27: "also make main width more wider"): the cell
// cap is 300 and two wide steps join the table — 5 columns from a 1500 px
// grid, 6 from 1800. Each new step starts where its cell is about 280 px, the
// same rule the 4-column step follows (1180 -> 277): a column is added only
// when the cells stay at least as large as the old cap. The widest board is
// 6 x 300 + 5 x 24 = 1920 px (was 4 x 280 + 3 x 24 = 1192). The grid is the
// page column minus its two `C` gutters, so the viewports read roughly
// 1440 -> 4, 1680 -> 5, 1920 -> 6 columns.
const $7d1d597f66a57ede$export$be848df41eb346c = 300;
const $7d1d597f66a57ede$export$7c51d342b3419093 = [
    {
        minWidth: 1800,
        cols: 6,
        gutter: 24
    },
    {
        minWidth: 1500,
        cols: 5,
        gutter: 24
    },
    {
        minWidth: 1180,
        cols: 4,
        gutter: 24
    },
    {
        minWidth: 860,
        cols: 3,
        gutter: 16
    },
    {
        minWidth: 520,
        cols: 2,
        gutter: 12,
        fill: true,
        rows: 'auto'
    },
    {
        minWidth: 0,
        cols: 1,
        gutter: 12,
        fill: true,
        rows: 'auto'
    }
];
const $7d1d597f66a57ede$export$eb64929ce5651ed6 = [
    's',
    'm',
    'l',
    'xl'
];
const $7d1d597f66a57ede$export$655b5d8adfdda81a = (width)=>{
    const w = Number(width) > 0 ? Number(width) : 0;
    const step = $7d1d597f66a57ede$export$7c51d342b3419093.find((s)=>w >= s.minWidth) || $7d1d597f66a57ede$export$7c51d342b3419093[$7d1d597f66a57ede$export$7c51d342b3419093.length - 1];
    const raw = (w - (step.cols - 1) * step.gutter) / step.cols;
    const cell = Math.max(0, step.fill ? Math.floor(raw) : Math.min($7d1d597f66a57ede$export$be848df41eb346c, Math.floor(raw)));
    return {
        cols: step.cols,
        gutter: step.gutter,
        cell: cell,
        width: step.cols * cell + (step.cols - 1) * step.gutter,
        square: step.rows !== 'auto'
    };
};
const $7d1d597f66a57ede$export$ab16aa851688704c = 4;
const $7d1d597f66a57ede$var$_whole = (v)=>typeof v === 'number' && Number.isInteger(v) && v >= 1;
const $7d1d597f66a57ede$export$39afd78ac2a36876 = (spanAt, cols)=>{
    if (!spanAt || typeof spanAt !== 'object' || Array.isArray(spanAt)) return null;
    const n = Math.floor(Number(cols));
    if (!(n >= 1)) return null;
    if (!Object.prototype.hasOwnProperty.call(spanAt, n)) return null;
    const o = spanAt[n];
    if (!o || typeof o !== 'object' || Array.isArray(o)) return null;
    if (!$7d1d597f66a57ede$var$_whole(o.c)) return null;
    const hasR = Object.prototype.hasOwnProperty.call(o, 'r');
    if (hasR && !$7d1d597f66a57ede$var$_whole(o.r)) return null;
    const r = hasR ? o.r : 1;
    return {
        c: Math.min(o.c, n),
        r: Math.min(r, $7d1d597f66a57ede$export$ab16aa851688704c)
    };
};
const $7d1d597f66a57ede$export$9ae13b69a13f8950 = (size, cols, spanAt)=>{
    const n = Math.max(1, Math.floor(Number(cols)) || 1);
    const own = $7d1d597f66a57ede$export$39afd78ac2a36876(spanAt, n);
    if (own) return own;
    const spans = {
        s: [
            1,
            1
        ],
        m: [
            2,
            1
        ],
        l: [
            2,
            2
        ],
        xl: [
            n,
            1
        ]
    };
    const [c, r] = spans[size] || spans.s;
    if (n === 1) return {
        c: 1,
        r: size === 'l' ? 2 : 1
    };
    return {
        c: Math.min(c, n),
        r: r
    };
};
const $7d1d597f66a57ede$export$10539cbad73da51c = {
    s: {
        columns: 'minmax(0, 1fr)',
        areas: '"hero" "delta" "visual" "footer"',
        rows: 'auto auto auto minmax(0, 1fr)'
    },
    m: {
        columns: 'minmax(0, 1fr) minmax(0, 1fr)',
        areas: '"hero visual" "delta visual" "footer footer"',
        rows: 'auto minmax(0, 1fr) auto'
    },
    l: {
        columns: 'minmax(0, 1fr)',
        areas: '"hero" "delta" "visual" "list" "footer"',
        rows: 'auto auto auto minmax(0, 1fr) auto'
    },
    xl: {
        columns: 'minmax(0, 1fr) minmax(0, 1.25fr) minmax(0, 1.25fr)',
        areas: '"hero visual list" "delta visual list" "footer footer footer"',
        rows: 'auto minmax(0, 1fr) auto'
    }
};
const $7d1d597f66a57ede$export$163142670a1cd3b6 = (size, cols, spanAt)=>{
    const { c: c, r: r } = $7d1d597f66a57ede$export$9ae13b69a13f8950(size, cols, spanAt);
    if (r > 1) return 'l';
    if (c <= 1) return 's';
    if (c === 2) return 'm';
    return 'xl';
};
const $7d1d597f66a57ede$export$388e3ed337540034 = (axis, cols, fallback)=>'var(--home-span-' + axis + '-' + cols + ', ' + fallback + ')';
const $7d1d597f66a57ede$var$_hasList = (fit)=>/(^|[\s"])list([\s"]|$)/.test(($7d1d597f66a57ede$export$10539cbad73da51c[fit] || $7d1d597f66a57ede$export$10539cbad73da51c.s).areas);
const $7d1d597f66a57ede$export$4c5a8a14e168a7d0 = ()=>{
    const steps = $7d1d597f66a57ede$export$7c51d342b3419093.slice().sort((a, b)=>a.minWidth - b.minWidth);
    return steps.map((step, i)=>{
        const next = steps[i + 1];
        const rules = [];
        for (const fit of $7d1d597f66a57ede$export$eb64929ce5651ed6){
            const at = ".home-grid > [data-span-fit~='" + step.cols + ':' + fit + "']";
            const to = $7d1d597f66a57ede$export$10539cbad73da51c[fit];
            rules.push(at + ' .home-widget-body { grid-template-columns: ' + to.columns + '; grid-template-areas: ' + to.areas + '; grid-template-rows: ' + to.rows + '; }');
            if ($7d1d597f66a57ede$var$_hasList(fit)) {
                rules.push(at + ' .home-widget-list:not([data-as-visual]) { display: flex; }');
                rules.push(at + ' .home-widget-list[data-as-visual] { display: flex; ' + (fit === 'xl' ? 'grid-row: visual; grid-column: visual-start / list-end; }' : 'grid-column: visual; grid-row: visual-start / list-end; }'));
            } else {
                rules.push(at + ' .home-widget-list:not([data-as-visual]) { display: none; }');
                rules.push(at + ' .home-widget-list[data-as-visual] { grid-column: visual; grid-row: visual; }');
            }
        }
        let range = '';
        if (step.minWidth > 0 && next) range = '(' + step.minWidth + 'px <= width < ' + next.minWidth + 'px)';
        else if (step.minWidth > 0) range = '(width >= ' + step.minWidth + 'px)';
        else if (next) range = '(width < ' + next.minWidth + 'px)';
        return range ? '@container homeboard ' + range + ' {\n' + rules.join('\n') + '\n}' : rules.join('\n');
    }).join('\n');
};
const $7d1d597f66a57ede$export$86db81b5e291a6b8 = (spanAt)=>{
    const out = {};
    for (const step of $7d1d597f66a57ede$export$7c51d342b3419093){
        const span = $7d1d597f66a57ede$export$39afd78ac2a36876(spanAt, step.cols);
        if (!span) continue;
        out['--home-span-c-' + step.cols] = String(span.c);
        out['--home-span-r-' + step.cols] = String(span.r);
    }
    return out;
};
const $7d1d597f66a57ede$export$fc6026f08ff2b6be = (size, spanAt)=>$7d1d597f66a57ede$export$7c51d342b3419093.map((step)=>{
        if (!$7d1d597f66a57ede$export$39afd78ac2a36876(spanAt, step.cols)) return '';
        const fit = $7d1d597f66a57ede$export$163142670a1cd3b6(size, step.cols, spanAt);
        return fit === $7d1d597f66a57ede$export$163142670a1cd3b6(size, step.cols) ? '' : step.cols + ':' + fit;
    }).filter(Boolean).join(' ');
const $7d1d597f66a57ede$export$1ed7b07fbfaa3ad3 = (w, h)=>{
    const cw = Number(w) > 0 ? Number(w) : 1;
    const ch = Number(h) > 0 ? Number(h) : 1;
    if (cw >= 8) return 'xl';
    if (cw >= 5 && cw >= ch * 1.4) return 'm';
    if (ch >= 4 && (cw >= 4 || ch > cw)) return 'l';
    return 's';
};

});

parcelRegister("4gSNJ", function(module, exports) {

$parcel$export(module.exports, "homeSparkGeom", () => $31c32a6b8ad91ead$export$485e2deacc78ad98);
$parcel$export(module.exports, "homeSlotText", () => $31c32a6b8ad91ead$export$36fd6831f156e430);
// Geometry for the home widget visuals (HOME_WIDGETS_SPEC.md §2 "Mini
// visual"). Pure functions: the slot components call them through `el.call`
// (a component file may not import a sibling), and the tests call them
// directly.
// Sparkline geometry in a `w` × `h` viewBox with `pad` px of inset: the
// stroke path, the closed area path under it, and the last point (the end
// marker). Values are scaled to the series' own min..max; a flat series sits
// on the middle line. Fewer than two points draw nothing — the slot shows its
// skeleton instead of a lone dot. Coordinates are rounded to 0.1 px so the
// path text stays short and stable between renders.
const $31c32a6b8ad91ead$export$485e2deacc78ad98 = function homeSparkGeom(points, w, h, pad) {
    const values = Array.isArray(points) ? points.map(Number).filter((v)=>Number.isFinite(v)) : [];
    if (values.length < 2) return null;
    const width = Number(w) || 120;
    const height = Number(h) || 36;
    const inset = Number(pad) >= 0 ? Number(pad) : 3;
    const min = Math.min(...values);
    const max = Math.max(...values);
    const span = max - min;
    const round = (n)=>Math.round(n * 10) / 10;
    const step = (width - inset * 2) / (values.length - 1);
    const coords = values.map((v, i)=>({
            x: round(inset + i * step),
            y: round(span ? height - inset - (v - min) / span * (height - inset * 2) : height / 2)
        }));
    const line = coords.map((p, i)=>`${i ? 'L' : 'M'}${p.x},${p.y}`).join(' ');
    const first = coords[0];
    const last = coords[coords.length - 1];
    return {
        linePath: line,
        areaPath: `${line} L${last.x},${height} L${first.x},${height} Z`,
        end: {
            x: last.x,
            y: last.y
        }
    };
};
const $31c32a6b8ad91ead$export$36fd6831f156e430 = function homeSlotText(target) {
    if (!target) return undefined;
    const t = target.text;
    if (typeof t !== 'function') return t;
    try {
        return t(target, target.state, target.context);
    } catch (_) {
        return undefined;
    }
};

});

parcelRegister("io6d9", function(module, exports) {

$parcel$export(module.exports, "homeHelpTipPlace", () => $d62f494c423daf9d$export$2b0e3ba58c8ac595);
$parcel$export(module.exports, "homeHelpTipReserve", () => $d62f494c423daf9d$export$d687fe8351548c12);
$parcel$export(module.exports, "homeWidgetHelpTipMeasure", () => $d62f494c423daf9d$export$bd8252927df2abc7);
$parcel$export(module.exports, "homeWidgetHelpTipForget", () => $d62f494c423daf9d$export$190a57c6598a767d);
$parcel$export(module.exports, "homeWidgetHelpTipStyle", () => $d62f494c423daf9d$export$d33de9c9c1cca1ef);
$parcel$export(module.exports, "homeWidgetHelpTipClose", () => $d62f494c423daf9d$export$d5815b8629e79876);
$parcel$export(module.exports, "homeWidgetHelpOpen", () => $d62f494c423daf9d$export$dc2e56cdff6b0fd5);
// THE HOME WIDGET (?) PANEL'S PLACEMENT (WS-WIDGET-HELP-TOOLTIP-ANCHOR-1;
// Nika 2026-10-09: "fix (?) tooltip position").
//
// The brand QuestionMarkTooltip parks its panel at `left: 50%` of its
// containing block. In the widget header that block is the HEADER (2026-09-10:
// a panel anchored to the 15px glyph tracked the title's length and hung 64px
// outside the card, and its `100%` width cap measured the glyph), so the panel
// opened under the header's middle — ~800px from its (?) on an XL card
// (measured on staging vault.pr, 2560 wide: glyph x 486, panel centre x 1280).
//
// The header stays the CLAMP — the panel lives inside it and its width cap is
// the card's — and the panel is PLACED at its glyph:
//   • centred on the (?), shifted inward only as far as the header and the app
//     frame need (a 390px phone included); a panel wider than the room starts
//     at the room's start;
//   • below the (?); above it when the room below is short of the panel and
//     the room above is larger — never over the glyph.
// The brand panel draws no arrow (its `:before` is `content: none`, measured
// on staging 2026-10-09), so the panel's own edge is what meets the (?).
// The gap between the glyph and the panel is the `Y` spacing token, added in
// CSS so it scales with the type like every other gap.
//
// Measured through DOMQL elements: the panel's (?) is `el.parent`, the header
// is the nearest ancestor keyed `Header`, the app frame is the outermost
// element (the same frame the brand's own edge guard measures — the product
// shell scrolls inside it, so it is the viewport). No document lookups.
const $d62f494c423daf9d$var$_num = (v)=>typeof v === 'number' && Number.isFinite(v) ? v : null;
const $d62f494c423daf9d$var$_rect = (r)=>r && $d62f494c423daf9d$var$_num(r.left) !== null && $d62f494c423daf9d$var$_num(r.top) !== null && $d62f494c423daf9d$var$_num(r.right) !== null && $d62f494c423daf9d$var$_num(r.bottom) !== null ? r : null;
const $d62f494c423daf9d$export$2b0e3ba58c8ac595 = (input)=>{
    if (!input || typeof input !== 'object') return null;
    const glyph = $d62f494c423daf9d$var$_rect(input.glyph);
    const box = $d62f494c423daf9d$var$_rect(input.box);
    const frame = $d62f494c423daf9d$var$_rect(input.frame);
    const w = input.panel && $d62f494c423daf9d$var$_num(input.panel.w);
    const h = input.panel && $d62f494c423daf9d$var$_num(input.panel.h);
    if (!glyph || !box || !frame || w === null || h === null) return null;
    const cx = (glyph.left + glyph.right) / 2;
    const minLeft = Math.max(box.left, frame.left);
    const maxRight = Math.min(box.right, frame.right);
    const absLeft = Math.max(minLeft, Math.min(cx - w / 2, maxRight - w));
    const left = Math.round(absLeft - box.left);
    // Bands the frame does not lend: the app header at the top, the composer
    // (prompt bar) at the bottom (homeHelpTipReserve).
    const reserve = input.reserve && typeof input.reserve === 'object' ? input.reserve : {};
    const reserveTop = $d62f494c423daf9d$var$_num(reserve.top) || 0;
    const reserveBottom = $d62f494c423daf9d$var$_num(reserve.bottom) || 0;
    const roomBelow = frame.bottom - reserveBottom - glyph.bottom;
    const roomAbove = glyph.top - frame.top - reserveTop;
    // the glyph's own height stands in for the CSS gap in the room test
    const need = h + (glyph.bottom - glyph.top);
    const side = roomBelow < need && roomAbove > roomBelow ? 'above' : 'below';
    const top = Math.round(side === 'above' ? glyph.top - box.top - h : glyph.bottom - box.top);
    return {
        left: left,
        top: top,
        side: side,
        glyphX: Math.round(cx - (box.left + left))
    };
};
const $d62f494c423daf9d$export$d687fe8351548c12 = (node)=>{
    const doc = node && node.ownerDocument;
    const view = doc && doc.defaultView;
    if (!view || typeof view.getComputedStyle !== 'function') return {
        top: 0,
        bottom: 0
    };
    const cs = view.getComputedStyle(doc.documentElement);
    const px = (name)=>{
        const m = /^\s*(-?\d+(?:\.\d+)?)px\s*$/.exec(String(cs.getPropertyValue(name) || ''));
        return m ? Math.max(0, Number(m[1])) : 0;
    };
    const shown = doc.documentElement && typeof doc.documentElement.getAttribute === 'function' && doc.documentElement.getAttribute('data-prompt') === 'shown';
    return {
        top: px('--nav-clear'),
        bottom: shown ? px('--prompt-clear') : 0
    };
};
const $d62f494c423daf9d$export$bd8252927df2abc7 = function homeWidgetHelpTipMeasure() {
    const trigger = this;
    const panel = trigger && trigger.TooltipHidden;
    const s = trigger && trigger.state;
    if (!panel || !s || typeof s.update !== 'function') return null;
    let header = trigger.parent;
    while(header && header.key !== 'Header')header = header.parent;
    let frame = trigger;
    while(frame && frame.parent && frame.parent.node)frame = frame.parent;
    const nodes = [
        trigger.node,
        panel.node,
        header && header.node,
        frame && frame.node
    ];
    if (nodes.some((n)=>!n || typeof n.getBoundingClientRect !== 'function')) return null;
    const place = this.call('homeHelpTipPlace', {
        glyph: trigger.node.getBoundingClientRect(),
        box: header.node.getBoundingClientRect(),
        frame: frame.node.getBoundingClientRect(),
        panel: {
            w: panel.node.offsetWidth,
            h: panel.node.offsetHeight
        },
        reserve: this.call('homeHelpTipReserve', panel.node)
    });
    if (!place) return null;
    const next = {
        left: place.left,
        top: place.top,
        side: place.side
    };
    s.update({
        _helpTipPlace: next
    });
    return next;
};
const $d62f494c423daf9d$export$190a57c6598a767d = function homeWidgetHelpTipForget() {
    const s = this && this.state;
    const place = s && s._helpTipPlace;
    if (!place || place.stale || typeof s.update !== 'function') return;
    // still open for THIS (?) (the brand keeps it open while it has focus): the
    // place is still the one on screen — never pull it from under the panel
    const trigger = this.TooltipHidden ? this : this.parent;
    const open = s.root && s.root.helpTooltipOpenId;
    if (open && trigger && typeof trigger.call === 'function') {
        if (trigger.call('exec', trigger.helpTipId, trigger) === open) return;
    }
    s.update({
        _helpTipPlace: {
            ...place,
            stale: true
        }
    });
};
const $d62f494c423daf9d$export$d33de9c9c1cca1ef = function homeWidgetHelpTipStyle() {
    const el = this;
    const shown = !!(el && el.isShown);
    const reveal = shown ? {
        opacity: '1',
        visibility: 'visible'
    } : {
        opacity: '0',
        visibility: 'hidden'
    };
    let place = el && el.state && el.state._helpTipPlace;
    // OPENED WITHOUT AN APPROACH — keyboard focus (the brand opens on focus) or
    // code (a root write of helpTooltipOpenId): no fresh place yet, so measure
    // ONCE, now. Only at an open — a closed or freshly placed panel never reads
    // layout (ws crm note on 2e2f488c0).
    if (shown && (!place || place.stale) && el.parent && typeof el.parent.call === 'function') place = el.parent.call('homeWidgetHelpTipMeasure') || place;
    if (!place || shown && place.stale) return reveal;
    const above = place.side === 'above';
    return {
        left: place.left + 'px',
        right: 'auto',
        top: above ? 'calc(' + place.top + 'px - var(--spacing-Y))' : 'calc(' + place.top + 'px + var(--spacing-Y))',
        bottom: 'auto',
        transform: 'none',
        ...reveal
    };
};
const $d62f494c423daf9d$export$d5815b8629e79876 = function homeWidgetHelpTipClose() {
    const trigger = this && this.parent;
    const root = this && this.state && this.state.root;
    if (!trigger || !root || typeof root.update !== 'function') return;
    if (!root.helpTooltipOpenId) {
        $d62f494c423daf9d$export$190a57c6598a767d.call(this);
        return;
    }
    const id = trigger.call('exec', trigger.helpTipId, trigger);
    if (id && root.helpTooltipOpenId === id) root.update({
        helpTooltipOpenId: null
    });
    // its place was measured for the old size
    $d62f494c423daf9d$export$190a57c6598a767d.call(this);
};
const $d62f494c423daf9d$export$dc2e56cdff6b0fd5 = function homeWidgetHelpOpen(s) {
    const open = s && s.root && s.root.helpTooltipOpenId;
    if (!open) return false;
    const q = this && this.Header && this.Header.TitleRow && this.Header.TitleRow.QuestionMarkTooltip;
    if (!q || typeof q.call !== 'function') return false;
    return q.call('exec', q.helpTipId, q) === open;
};

});

parcelRegister("1Qr8P", function(module, exports) {

$parcel$export(module.exports, "homeWidgetAccent", () => $157fb382a324cb8c$export$50f9aadcbe659a06);
$parcel$export(module.exports, "homeWidgetAccentOnSurfaceVars", () => $157fb382a324cb8c$export$49fb1e5d78322201);
$parcel$export(module.exports, "homeWidgetAccentVars", () => $157fb382a324cb8c$export$4bb0a167a15f3915);
$parcel$export(module.exports, "homeWidgetIsApp", () => $157fb382a324cb8c$export$a9d708af640c88e2);
$parcel$export(module.exports, "homeWidgetDefaultSize", () => $157fb382a324cb8c$export$b16bfbce54d00d63);
$parcel$export(module.exports, "homeWidgetFrameSize", () => $157fb382a324cb8c$export$a6270c12be0c62fa);
$parcel$export(module.exports, "homeWidgetBaseSize", () => $157fb382a324cb8c$export$1d8d4dd7763ebd7);
$parcel$export(module.exports, "homeWidgetSpanAtOf", () => $157fb382a324cb8c$export$bce887b9fb209ef5);
$parcel$export(module.exports, "homeWidgetSpanFor", () => $157fb382a324cb8c$export$269a067966ebef86);
$parcel$export(module.exports, "homeWidgetSpanVars", () => $157fb382a324cb8c$export$fe71d81acc8d7585);
$parcel$export(module.exports, "homeWidgetSpanFit", () => $157fb382a324cb8c$export$c445f1152579a582);
$parcel$export(module.exports, "homeWidgetFrameStyle", () => $157fb382a324cb8c$export$c5f44590261978f5);
$parcel$export(module.exports, "homeWidgetFrameOrder", () => $157fb382a324cb8c$export$89bcdaabc9ebf84d);
$parcel$export(module.exports, "homeWidgetUnderView", () => $157fb382a324cb8c$export$735f387ba1fc3816);
$parcel$export(module.exports, "homeWidgetFrameHidden", () => $157fb382a324cb8c$export$5010c57071cdd600);
$parcel$export(module.exports, "homeWidgetOpenRoute", () => $157fb382a324cb8c$export$d056ea8f821c6189);
$parcel$export(module.exports, "homeWidgetActionOf", () => $157fb382a324cb8c$export$9f39e0e31b40f487);
$parcel$export(module.exports, "homeWidgetOpen", () => $157fb382a324cb8c$export$29636de75500c679);
$parcel$export(module.exports, "homeWidgetRunAction", () => $157fb382a324cb8c$export$8a1aa3ca2124af9e);
$parcel$export(module.exports, "openHomeWidgetForm", () => $157fb382a324cb8c$export$c3797b84a8a42ae9);
$parcel$export(module.exports, "mountHomeWidgetForm", () => $157fb382a324cb8c$export$76ab7d9a5b0b7075);
$parcel$export(module.exports, "homeWidgetRow", () => $157fb382a324cb8c$export$bf6930168955302b);
$parcel$export(module.exports, "homeWidgetParams", () => $157fb382a324cb8c$export$5bc37b5f35b971a9);
$parcel$export(module.exports, "homeWidgetHideLabel", () => $157fb382a324cb8c$export$d14a219c24c991ba);
$parcel$export(module.exports, "homeWidgetHelpOf", () => $157fb382a324cb8c$export$e40e1a51f08c33eb);
$parcel$export(module.exports, "homeWidgetSizeRows", () => $157fb382a324cb8c$export$e8bb017f85e51399);
$parcel$export(module.exports, "homeWidgetSizeMenuRow", () => $157fb382a324cb8c$export$31ded606eeac176a);
$parcel$export(module.exports, "homeWidgetSetSize", () => $157fb382a324cb8c$export$da7a8f8f7a516a42);
// The home widget FRAME's helpers (components/HomeWidgetFrame.js) — every
// value the frame shows that depends on more than its own state row, as
// registered functions so the component stays closure-free (frank) and both
// widget planes (the page's own widgets and module/app widgets) read the
// same answers.
//
// The frame's state row is the widget DESCRIPTOR:
//   { id, title, icon, kind: 'widget' | 'app', size, minSize, hue,
//     openRoute, openCall?, action?: { icon, label, call? | route? | set? },
//     help?, moduleId?, spec? (the manifest's legacy spec) }
// `openCall` names a registered function every open runs first (Broadcast
// marks its news seen).
// Module rows carry their manifest entry as-is, so every read below also
// looks in `spec` for the legacy spelling (iconBg, openRoute, w × h).
parcelRequire("67GC6");
var $9z5MX = parcelRequire("9z5MX");
var $5koEk = parcelRequire("5koEk");

var $7dUkh = parcelRequire("7dUkh");

var $aJYU4 = parcelRequire("aJYU4");

var $6p65M = parcelRequire("6p65M");

var $hWNk6 = parcelRequire("hWNk6");

var $jFE3F = parcelRequire("jFE3F");
const $157fb382a324cb8c$var$_POSTER_FAMILY_KEYS = new Set([
    'studio',
    'tickets',
    'chat',
    'calendar',
    'reminders',
    'meet',
    'broadcast',
    'documents',
    'agents',
    'team',
    'analytics',
    'people',
    'health',
    'files'
]);
const $157fb382a324cb8c$export$50f9aadcbe659a06 = function homeWidgetAccent(root, id, hue, designSystem) {
    const picked = (0, $6p65M.homeWidgetSurfaceHue)(root, id, designSystem);
    if (picked) return picked;
    const house = (0, $6p65M.homeWidgetHue)(id, null, designSystem);
    if (house) return house;
    if (typeof hue !== 'string' || !hue) return null;
    if ($157fb382a324cb8c$var$_POSTER_FAMILY_KEYS.has(hue)) return (0, $6p65M.posterFamilyEntry)(hue);
    return (0, $6p65M.homeWidgetHue)(null, hue, designSystem);
};
const $157fb382a324cb8c$var$_css = (token, designSystem)=>{
    if (!token) return null;
    try {
        const r = (0, $5koEk.resolveColorRgb)(token, designSystem);
        if (!r || !Array.isArray(r.rgb)) return null;
        const [red, green, blue] = r.rgb.map((n)=>Math.round(Number(n) || 0));
        const a = r.alpha == null ? 1 : Number(r.alpha);
        return a >= 1 ? `rgb(${red}, ${green}, ${blue})` : `rgba(${red}, ${green}, ${blue}, ${a})`;
    } catch (_) {
        return null;
    }
};
// The WCAG non-text floor (a bar, a spark line, a dot is a graphic, not
// text), which is also the floor the ticket's acceptance names. `getSafeInk`
// accepts a candidate at `need - 0.02`, so a reading is compared with the
// same margin — otherwise a colour the design system just certified would be
// rejected here on the second decimal.
const $157fb382a324cb8c$var$_GRAPHICS_FLOOR = 3;
const $157fb382a324cb8c$var$_FLOOR_MARGIN = 0.02;
// The CARD's own surface token for one scheme — the ground every on-surface
// visual is measured against. The frame paints
// `var(--home-card-bg, var(--theme-card-background))`, i.e. the design
// system's `theme.card` half, and `--home-card-bg` is deliberately NOT read:
// that is a module / workspace-record re-tint written on `<html>` at runtime,
// and a ground an ancestor can repaint is not knowable when this runs (the
// same limit scratch's own `getSafeInk` header documents). In DARK the static
// ground is the LIGHTER of the two readings, so an accent that clears the bar
// against it clears more against a darker re-tint. No token is guessed when
// the design system cannot name its card: the caller falls back to the title
// ink, which reads on any surface the shell will paint.
const $157fb382a324cb8c$var$_cardGround = (designSystem, scheme)=>{
    const card = designSystem && designSystem.theme && designSystem.theme.card;
    const half = card && card['@' + scheme];
    const bg = half && half.value && half.value.background || card && card.value && card.value['@' + scheme] && card.value['@' + scheme].background;
    return typeof bg === 'string' && bg ? bg : null;
};
// THE ACCENT a hue paints an ON-SURFACE visual with (a HomeWidgetList bar, a
// HomeWidgetProgress fill, a HomeWidgetSpark line, a HomeWidgetDelta chip, a
// HomeWidgetDots dot, the records block's stat and chart) — never the plate.
// The plate is a SURFACE, and it reads against the card only by accident:
// measured against the design system's own card halves, 6 of the 14 poster
// families fall under the 3:1 graphics floor in dark and 7 in light, with
// `analytics` worst at 1.19:1 — a near-black plate on a near-black card, the
// invisible Validators bars HOME-WIDGET-ACCENT-DARK-PLATE-INVISIBLE-1
// measured on dev.
//
// Derived by the design system's OWN rule, never decided here: scratch's
// `getSafeInk(hue, ground, { large: true, scheme })` holds the hue's OKLCH
// hue AND chroma and walks lightness until the rounded, composited colour
// clears the floor. So a family that already reads keeps its exact plate
// colour — and keeps it as `var(--color-poster<Family>)`, so a branded
// workspace's record override still re-tints the accent — while one that does
// not is brightened or deepened WITHIN its own family instead of swapped for
// a generic ink, which is what keeps a hue a hue. A designer who disagrees
// with a derivation authors `<hue>Safe` in `designSystem/color.js`, the
// escape hatch `getSafeInk` checks before it derives anything.
//
// Returns null when there is no accent inside the family: a translucent wash
// cannot reach the floor at ANY lightness, because the search preserves the
// alpha (the neutral `widgetPlate` tint tops out at 1.17:1 light / 1.51:1
// dark). The caller takes the title ink there.
const $157fb382a324cb8c$var$_accentFor = (bgToken, designSystem, scheme)=>{
    const ground = $157fb382a324cb8c$var$_cardGround(designSystem, scheme);
    if (!bgToken || !ground || !designSystem) return null;
    try {
        const info = (0, $9z5MX.getSafeInkInfo)(bgToken, ground, {
            large: true,
            scheme: scheme
        }, designSystem);
        if (!info || !info.value || info.unresolved) return null;
        if (info.ratio != null && info.ratio + $157fb382a324cb8c$var$_FLOOR_MARGIN < $157fb382a324cb8c$var$_GRAPHICS_FLOOR) return null;
        return info.value;
    } catch (_) {
        return null;
    }
};
const $157fb382a324cb8c$export$49fb1e5d78322201 = function homeWidgetAccentOnSurfaceVars(bgToken, designSystem) {
    return {
        '--home-widget-accent-light': $157fb382a324cb8c$var$_accentFor(bgToken, designSystem, 'light') || 'var(--color-title)',
        '--home-widget-accent-dark': $157fb382a324cb8c$var$_accentFor(bgToken, designSystem, 'dark') || 'var(--color-title)'
    };
};
const $157fb382a324cb8c$export$4bb0a167a15f3915 = function homeWidgetAccentVars(s, designSystem) {
    const hue = s && (s.hue || s.spec && (s.spec.hue || s.spec.iconBg) || s.iconBg);
    const entry = $157fb382a324cb8c$export$50f9aadcbe659a06(s && s.root, s && s.id, hue, designSystem);
    const bg = entry && $157fb382a324cb8c$var$_css(entry.bg, designSystem);
    const ink = entry && $157fb382a324cb8c$var$_css(entry.ink, designSystem);
    const plate = bg && ink ? {
        '--home-widget-hue': bg,
        '--home-widget-hue-ink': ink
    } : {
        '--home-widget-hue': 'var(--color-widgetPlate)',
        '--home-widget-hue-ink': 'var(--color-title)'
    };
    return {
        ...plate,
        ...$157fb382a324cb8c$export$49fb1e5d78322201(bg && ink ? entry.bg : null, designSystem)
    };
};
const $157fb382a324cb8c$export$a9d708af640c88e2 = function homeWidgetIsApp(s) {
    return !!s && (s.kind === 'app' || !!(s.spec && s.spec.iconOnly));
};
const $157fb382a324cb8c$export$b16bfbce54d00d63 = function homeWidgetDefaultSize(s) {
    if (!s) return 's';
    if ($157fb382a324cb8c$export$a9d708af640c88e2(s)) return 's';
    const own = s.size || s.spec && s.spec.size;
    if (own) return own;
    const spec = s.spec || s;
    return (0, $aJYU4.homeWidgetSizeForCell)(spec.w, spec.h);
};
const $157fb382a324cb8c$export$a6270c12be0c62fa = function homeWidgetFrameSize(s) {
    if (!s || $157fb382a324cb8c$export$a9d708af640c88e2(s)) return 's';
    const min = s.minSize || s.spec && s.spec.minSize;
    return (0, $7dUkh.homeLayoutSizeOf)(s.root && s.root._homeLayout, s.id, $157fb382a324cb8c$export$b16bfbce54d00d63(s), min);
};
const $157fb382a324cb8c$export$1d8d4dd7763ebd7 = function homeWidgetBaseSize(s) {
    if (!s || $157fb382a324cb8c$export$a9d708af640c88e2(s)) return 's';
    const min = s.minSize || s.spec && s.spec.minSize;
    return (0, $7dUkh.homeLayoutSizeOf)(null, s.id, $157fb382a324cb8c$export$b16bfbce54d00d63(s), min);
};
const $157fb382a324cb8c$export$bce887b9fb209ef5 = function homeWidgetSpanAtOf(s) {
    if (!s || $157fb382a324cb8c$export$a9d708af640c88e2(s)) return null;
    const own = s.spanAt || s.spec && s.spec.spanAt;
    return own && typeof own === 'object' && !Array.isArray(own) ? own : null;
};
const $157fb382a324cb8c$export$269a067966ebef86 = function homeWidgetSpanFor(s, size, cols) {
    const spanAt = $157fb382a324cb8c$export$bce887b9fb209ef5(s);
    if (!spanAt || size !== $157fb382a324cb8c$export$1d8d4dd7763ebd7(s)) return this.call('homeWidgetSpan', size, cols);
    return this.call('homeWidgetSpan', size, cols, spanAt);
};
const $157fb382a324cb8c$export$fe71d81acc8d7585 = function homeWidgetSpanVars(s) {
    const spanAt = $157fb382a324cb8c$export$bce887b9fb209ef5(s);
    if (!spanAt || $157fb382a324cb8c$export$a6270c12be0c62fa(s) !== $157fb382a324cb8c$export$1d8d4dd7763ebd7(s)) return {};
    return this.call('homeSpanVarsFor', spanAt) || {};
};
const $157fb382a324cb8c$export$c445f1152579a582 = function homeWidgetSpanFit(s) {
    const spanAt = $157fb382a324cb8c$export$bce887b9fb209ef5(s);
    if (!spanAt) return null;
    const size = $157fb382a324cb8c$export$a6270c12be0c62fa(s);
    if (size !== $157fb382a324cb8c$export$1d8d4dd7763ebd7(s)) return null;
    return this.call('homeSpanFitWords', size, spanAt) || null;
};
const $157fb382a324cb8c$export$c5f44590261978f5 = function homeWidgetFrameStyle(s, designSystem) {
    return {
        ...$157fb382a324cb8c$export$4bb0a167a15f3915(s, designSystem),
        ...$157fb382a324cb8c$export$fe71d81acc8d7585.call(this, s)
    };
};
const $157fb382a324cb8c$export$89bcdaabc9ebf84d = function homeWidgetFrameOrder(s) {
    const layout = s && s.root && s.root._homeLayout;
    if (!Array.isArray(layout)) return 9999;
    const at = layout.findIndex((e)=>e && e.id === s.id);
    return at < 0 ? 9999 : at;
};
const $157fb382a324cb8c$export$735f387ba1fc3816 = function homeWidgetUnderView(s) {
    if (!s || s.board && s.board !== 'home') return false;
    const root = s.root;
    const fns = this && this.context && this.context.functions;
    const open = fns && fns.assistantBoardOpen;
    return !!(root && typeof open === 'function' && open.call(this, root));
};
const $157fb382a324cb8c$export$5010c57071cdd600 = function homeWidgetFrameHidden(s) {
    const hidden = s && s.root && s.root._homeHiddenWidgets;
    return !!(hidden && s && hidden[s.id] === true);
};
const $157fb382a324cb8c$export$d056ea8f821c6189 = function homeWidgetOpenRoute(s) {
    return s && (s.openRoute || s.spec && s.spec.openRoute) || null;
};
const $157fb382a324cb8c$export$9f39e0e31b40f487 = function homeWidgetActionOf(s) {
    const own = s && (s.action || s.spec && s.spec.action);
    if (own && (own.call || own.route || own.set)) return {
        icon: own.icon || 'plus',
        label: own.label || 'workspace.widget.action.add'
    };
    if ($157fb382a324cb8c$export$d056ea8f821c6189(s)) return {
        icon: 'arrowUpRight',
        label: 'workspace.menu.openApp'
    };
    return null;
};
const $157fb382a324cb8c$export$29636de75500c679 = function homeWidgetOpen(s, event) {
    const route = $157fb382a324cb8c$export$d056ea8f821c6189(s);
    if (!route) return;
    const before = s && (s.openCall || s.spec && s.spec.openCall);
    if (before) try {
        this.call(before, s.id);
    } catch (err) {
        console.warn('[home] widget open hook failed:', s && s.id, err && err.message);
    }
    const opts = event && (event.metaKey || event.ctrlKey) ? {
        split: true
    } : undefined;
    this.call('openAppPage', route, opts);
};
const $157fb382a324cb8c$export$8a1aa3ca2124af9e = function homeWidgetRunAction(s, event, bodyEl) {
    const own = s && (s.action || s.spec && s.spec.action);
    if (own && own.call) {
        const target = bodyEl || this;
        const form = typeof own.form === 'string' && own.form ? own.form : null;
        try {
            if (form) {
                this.call('openHomeWidgetForm', {
                    form: form,
                    moduleId: s.moduleId || null,
                    widgetId: s.id
                });
                return target.call(own.call, s.id, event, {
                    form: true
                });
            }
            return target.call(own.call, s.id, event);
        } catch (err) {
            console.warn('[home] widget action failed:', s && s.id, err && err.message);
            return undefined;
        }
    }
    if (own && own.route) return this.call('openAppPage', own.route);
    // A declarative root patch — e.g. Your agents' ＋ opens the create-agent
    // modal by its root key.
    if (own && own.set && s.root) return s.root.update(own.set);
    return $157fb382a324cb8c$export$29636de75500c679.call(this, s, event);
};
const $157fb382a324cb8c$export$c3797b84a8a42ae9 = function openHomeWidgetForm(req) {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function' || !req || !req.form) return null;
    const prev = root._homeWidgetForm;
    const next = {
        form: String(req.form),
        moduleId: req.moduleId || null,
        widgetId: req.widgetId || null,
        seq: (prev && prev.seq || 0) + 1
    };
    const open = req.open;
    if (open && typeof open.call === 'string' && open.call) next.open = Object.freeze({
        call: open.call,
        args: Object.freeze(Array.isArray(open.args) ? [
            ...open.args
        ] : [])
    });
    root.update({
        _homeWidgetForm: next
    });
    return next;
};
const $157fb382a324cb8c$export$76ab7d9a5b0b7075 = function mountHomeWidgetForm(host, req) {
    if (!host || typeof host.set !== 'function' || !req || !req.form) return false;
    const sig = `${req.moduleId || ''}/${req.form}/${req.seq || 0}`;
    if (host.__homeFormSig === sig) return false;
    // The shell root, whatever scope the host holds now.
    const root = (0, $jFE3F.shellRootOf)(host.state && host.state.root || null);
    const modCtx = req.moduleId && root && typeof root._moduleDsCtxGet === 'function' ? root._moduleDsCtxGet(req.moduleId) : null;
    const def = {
        extends: req.form
    };
    if (modCtx) {
        def.context = modCtx;
        if (modCtx.globalScope) def.scope = Object.assign({}, modCtx.globalScope);
    }
    (0, $jFE3F.scopeHostState)(host, (0, $jFE3F.moduleStateScopeOf)(modCtx));
    host.__homeFormSig = sig;
    try {
        host.set(def);
    } catch (err) {
        host.__homeFormSig = null;
        console.warn('[home] widget form mount failed:', req.form, err && err.message);
        return false;
    }
    const open = req.open;
    const form = host.content;
    if (open && typeof open.call === 'string' && form && typeof form.call === 'function') try {
        const ran = form.call(open.call, ...Array.isArray(open.args) ? open.args : []);
        if (ran && typeof ran.then === 'function') ran.then(null, (err)=>console.warn('[home] form open failed:', open.call, err && err.message));
    } catch (err) {
        console.warn('[home] form open failed:', open.call, err && err.message);
    }
    return true;
};
// THE PARAMS A BODY READS (FRAME CONTRACT v1, DESIGN-WL-ASSISTANT-MAIN-HOME-1):
// `el.scope.params` = the schema's defaults + this instance's values. Two row
// shapes reach the frame:
//   • a HOME row is the manifest widget entry itself — its `params` is the
//     SCHEMA (`{ <name>: { type, values?, default? } }`), and there are no
//     instance values (the home twin renders its defaults);
//   • a BOARD descriptor carries the manifest entry in `spec` (its `params`
//     is the schema) and this instance's values in `params`.
// A schema entry is an object with a `type`; a value is anything else. A
// body that ignores params renders its home twin.
const $157fb382a324cb8c$var$_isSchema = (p)=>!!p && typeof p === 'object' && !Array.isArray(p) && Object.keys(p).length > 0 && Object.values(p).every((v)=>v && typeof v === 'object' && typeof v.type === 'string');
const $157fb382a324cb8c$export$bf6930168955302b = function homeWidgetRow(w, moduleId) {
    const row = {
        ...w,
        key: w.id,
        moduleId: moduleId
    };
    if (w.params && typeof w.params === 'object' && !Array.isArray(w.params)) row.params = Object.freeze({
        ...w.params
    });
    return row;
};
const $157fb382a324cb8c$export$5bc37b5f35b971a9 = function homeWidgetParams(s) {
    if (!s) return {};
    const spec = s.spec && typeof s.spec === 'object' ? s.spec : null;
    const schema = spec && $157fb382a324cb8c$var$_isSchema(spec.params) && spec.params || $157fb382a324cb8c$var$_isSchema(s.params) && s.params || {};
    const own = s.params && typeof s.params === 'object' && !$157fb382a324cb8c$var$_isSchema(s.params) ? s.params : {};
    const out = {};
    for (const [name, def] of Object.entries(schema))if (def && def.default !== undefined) out[name] = def.default;
    for (const [name, value] of Object.entries(own))if (value !== undefined) out[name] = value;
    return out;
};
const $157fb382a324cb8c$export$d14a219c24c991ba = function homeWidgetHideLabel(row) {
    const key = row && row.title;
    if (!key) return this.call('polyglot', 'workspace.widget.action.hide');
    const title = this.call('polyglot', key);
    return String(this.call('polyglot', 'workspace.menu.hideWidget')).replace('{title}', title);
};
const $157fb382a324cb8c$export$e40e1a51f08c33eb = function homeWidgetHelpOf(s) {
    return (0, $hWNk6.normalizeWidgetHelp)(s && s.help);
};
const $157fb382a324cb8c$export$e8bb017f85e51399 = function homeWidgetSizeRows(s) {
    const all = [
        's',
        'm',
        'l',
        'xl'
    ];
    const min = s && (s.minSize || s.spec && s.spec.minSize) || 's';
    const from = Math.max(0, all.indexOf(min));
    const label = {
        s: 'S',
        m: 'M',
        l: 'L',
        xl: 'XL'
    };
    return all.slice(from).map((size)=>({
            key: size,
            value: size,
            text: label[size],
            widgetId: s && s.id
        }));
};
const $157fb382a324cb8c$export$31ded606eeac176a = function homeWidgetSizeMenuRow(s) {
    if (!s || !s.id || !this.call('isCoarsePointer')) return null;
    const rows = $157fb382a324cb8c$export$e8bb017f85e51399(s);
    if (rows.length < 2) return null;
    const current = this.call('homeWidgetFrameSize', s);
    return {
        key: 'widgetSize',
        label: 'workspace.widget.size.label',
        children: rows.map((r)=>({
                key: `widgetSize-${r.value}`,
                action: 'widgetSize',
                label: r.text,
                checked: r.value === current,
                widgetId: s.id,
                size: r.value
            }))
    };
};
const $157fb382a324cb8c$export$da7a8f8f7a516a42 = function homeWidgetSetSize(size) {
    const row = this && this.state;
    const root = row && row.root;
    const id = row && row.widgetId;
    if (!root || !id || !root._homeOps || typeof root._homeOps.setWidgetSize !== 'function') return;
    root._homeOps.setWidgetSize(id, size);
};

});
parcelRegister("7dUkh", function(module, exports) {

$parcel$export(module.exports, "homeLayoutFromLegacy", () => $54257080989e1154$export$c6c28710b688523e);
$parcel$export(module.exports, "homeLayoutNormalize", () => $54257080989e1154$export$114608e425afd853);
$parcel$export(module.exports, "homeLayoutEnsure", () => $54257080989e1154$export$231f5ee1851bc016);
$parcel$export(module.exports, "homeLayoutOrderBy", () => $54257080989e1154$export$8dff2b2c73e4fb5a);
$parcel$export(module.exports, "homeLayoutMove", () => $54257080989e1154$export$a023230f3fdda28b);
$parcel$export(module.exports, "homeLayoutCardId", () => $54257080989e1154$export$cd16b87f76d5270d);
$parcel$export(module.exports, "homeLayoutReplace", () => $54257080989e1154$export$3d31f1965d96cd86);
$parcel$export(module.exports, "homeLayoutSetSize", () => $54257080989e1154$export$47e70d7e768077c1);
$parcel$export(module.exports, "homeLayoutSizeOf", () => $54257080989e1154$export$748d23f0fc4d4360);
// HOME LAYOUT v2 — the workspace "/" board as an ORDER of widgets, each with
// one of four sizes (HOME_WIDGETS_SPEC.md §1 + §6). No free placement: the
// CSS grid flows the order (`grid-auto-flow: row dense`), so a hidden or
// removed widget can never leave a hole and nothing has coordinates to drift.
//
// WIRE SHAPE — the same prefs field the 12-column GridStack map used
// (`grid_layout`: Mixed, round-trips byte-identically; the server's tenancy
// pass only strips foreign ids while walking arrays of `{ id }`), as an
// ORDERED ARRAY of `{ id, size, v: 2 }`. An array, not a wrapper object, so
// that tenancy pass still sees every id.
//
// A 12-column record converts ONCE on read: reading order (y, then x) and
// w × h snapped to the nearest size by `homeWidgetSizeForCell` — the same
// mapping the interim board used, so a converted board keeps the look its
// owner arranged.
//
// Pure functions, never mutate their input; pages/main.js keeps the state,
// the cache and the durable writes.

var $aJYU4 = parcelRequire("aJYU4");
const $54257080989e1154$var$_RANK = {
    s: 0,
    m: 1,
    l: 2,
    xl: 3
};
const $54257080989e1154$var$_size = (s)=>(0, $aJYU4.HOME_WIDGET_SIZES).includes(s) ? s : 's';
const $54257080989e1154$var$_isEntry = (e)=>!!e && typeof e === 'object' && typeof e.id === 'string' && e.id !== '';
const $54257080989e1154$export$c637a1a86f635ebd = (layout)=>Array.isArray(layout) && layout.some((e)=>$54257080989e1154$var$_isEntry(e) && e.v === 2);
const $54257080989e1154$export$c6c28710b688523e = (layout)=>{
    if (!Array.isArray(layout)) return [];
    const rows = [];
    layout.forEach((e, i)=>{
        if (!$54257080989e1154$var$_isEntry(e)) return;
        const y = Number.isFinite(Number(e.y)) && e.y !== null && e.y !== undefined ? Number(e.y) : Infinity;
        const x = Number.isFinite(Number(e.x)) && e.x !== null && e.x !== undefined ? Number(e.x) : Infinity;
        rows.push({
            e: e,
            i: i,
            y: y,
            x: x
        });
    });
    rows.sort((a, b)=>a.y - b.y || a.x - b.x || a.i - b.i);
    const seen = new Set();
    const out = [];
    for (const { e: e } of rows){
        if (seen.has(e.id)) continue;
        seen.add(e.id);
        out.push({
            id: e.id,
            size: (0, $aJYU4.homeWidgetSizeForCell)(e.w, e.h),
            v: 2
        });
    }
    return out;
};
const $54257080989e1154$export$114608e425afd853 = (layout)=>{
    if (!Array.isArray(layout) || !layout.length) return [];
    if (!$54257080989e1154$export$c637a1a86f635ebd(layout)) return $54257080989e1154$export$c6c28710b688523e(layout);
    const seen = new Set();
    const out = [];
    for (const e of layout){
        if (!$54257080989e1154$var$_isEntry(e) || seen.has(e.id)) continue;
        seen.add(e.id);
        out.push({
            id: e.id,
            size: $54257080989e1154$var$_size(e.size),
            v: 2
        });
    }
    return out;
};
const $54257080989e1154$export$231f5ee1851bc016 = (layout, entries)=>{
    const base = Array.isArray(layout) ? layout : [];
    const have = new Set(base.map((e)=>e && e.id));
    const add = [];
    for (const e of Array.isArray(entries) ? entries : []){
        if (!$54257080989e1154$var$_isEntry(e) || have.has(e.id)) continue;
        have.add(e.id);
        add.push({
            id: e.id,
            size: $54257080989e1154$var$_size(e.size),
            v: 2
        });
    }
    return add.length ? [
        ...base,
        ...add
    ] : layout;
};
const $54257080989e1154$export$8dff2b2c73e4fb5a = (entries, ids)=>{
    const list = Array.isArray(entries) ? entries : [];
    const order = Array.isArray(ids) ? ids.filter((id)=>typeof id === 'string' && id) : [];
    if (!order.length || !list.length) return entries;
    const byId = new Map();
    for (const e of list)if ($54257080989e1154$var$_isEntry(e) && !byId.has(e.id)) byId.set(e.id, e);
    const head = [];
    const taken = new Set();
    for (const id of order){
        const e = byId.get(id);
        if (!e || taken.has(id)) continue;
        taken.add(id);
        head.push(e);
    }
    if (!head.length) return entries;
    return [
        ...head,
        ...list.filter((e)=>!($54257080989e1154$var$_isEntry(e) && taken.has(e.id)))
    ];
};
const $54257080989e1154$export$a023230f3fdda28b = (layout, id, toIndex)=>{
    const list = Array.isArray(layout) ? layout : [];
    const from = list.findIndex((e)=>e && e.id === id);
    if (from < 0) return layout;
    const next = list.slice();
    const [item] = next.splice(from, 1);
    const to = Math.max(0, Math.min(next.length, Math.floor(Number(toIndex)) || 0));
    next.splice(to, 0, item);
    return next;
};
const $54257080989e1154$export$cd16b87f76d5270d = (layout, ref)=>{
    const list = Array.isArray(layout) ? layout : [];
    const id = typeof ref === 'string' ? ref.trim() : '';
    if (!id) return null;
    if (list.some((e)=>e && e.id === id)) return id;
    const dot = id.lastIndexOf('.');
    if (dot <= 0 || dot === id.length - 1) return null;
    const bare = id.slice(dot + 1);
    return list.some((e)=>e && e.id === bare) ? bare : null;
};
const $54257080989e1154$export$3d31f1965d96cd86 = (layout, oldId, newId)=>{
    const list = Array.isArray(layout) ? layout : [];
    if (!oldId || !newId || oldId === newId) return layout;
    const at = list.findIndex((e)=>e && e.id === oldId);
    if (at < 0) return layout;
    const size = $54257080989e1154$var$_size(list[at].size);
    const next = list.filter((e)=>!(e && e.id === newId));
    next.splice(next.findIndex((e)=>e && e.id === oldId) + 1, 0, {
        id: newId,
        size: size,
        v: 2
    });
    return next;
};
const $54257080989e1154$export$47e70d7e768077c1 = (layout, id, size, minSize)=>{
    const list = Array.isArray(layout) ? layout : [];
    let want = $54257080989e1154$var$_size(size);
    const min = $54257080989e1154$var$_size(minSize);
    if ($54257080989e1154$var$_RANK[want] < $54257080989e1154$var$_RANK[min]) want = min;
    const at = list.findIndex((e)=>e && e.id === id);
    if (at < 0) return [
        ...list,
        {
            id: id,
            size: want,
            v: 2
        }
    ];
    const next = list.slice();
    next[at] = {
        ...next[at],
        size: want,
        v: 2
    };
    return next;
};
const $54257080989e1154$export$748d23f0fc4d4360 = (layout, id, fallback, minSize)=>{
    const hit = Array.isArray(layout) ? layout.find((e)=>e && e.id === id) : null;
    const size = $54257080989e1154$var$_size(hit ? hit.size : fallback);
    const min = $54257080989e1154$var$_size(minSize);
    return $54257080989e1154$var$_RANK[size] < $54257080989e1154$var$_RANK[min] ? min : size;
};
const $54257080989e1154$export$3f4609bdbc333b00 = (layout)=>{
    const map = new Map();
    (Array.isArray(layout) ? layout : []).forEach((e, i)=>{
        if ($54257080989e1154$var$_isEntry(e) && !map.has(e.id)) map.set(e.id, i);
    });
    return map;
};

});


parcelRegister("68PIQ", function(module, exports) {

$parcel$export(module.exports, "homeWidgetDragStart", () => $478b9c69e01f51f0$export$3b7964e8b0ec7352);
$parcel$export(module.exports, "homeWidgetDragMove", () => $478b9c69e01f51f0$export$cb72e458500079ca);
$parcel$export(module.exports, "homeWidgetDragEnd", () => $478b9c69e01f51f0$export$5dbd2d7212cccbda);
$parcel$export(module.exports, "homeWidgetKeyMove", () => $478b9c69e01f51f0$export$f7c15a57afc12c7e);
// Drag-to-reorder on the home board (HOME_WIDGETS_SPEC.md §6): in edit mode a
// widget is picked up, follows the pointer, and every time it crosses another
// widget it takes that widget's place in the ORDER — the CSS grid reflows the
// neighbours at once (iPad behaviour, no free placement, no holes). Dropping
// persists the order through the page's durable prefs write; a cancelled
// gesture restores the order it started from.
//
// Pointer events cover mouse, pen and touch alike (the frame sets
// `touch-action: none` in edit mode so a touch drag does not scroll). One drag
// at a time, so its bookkeeping is a plain handle on the root state
// (`root._homeDragging`, like `root._homeOps`) and one reactive key,
// `_homeDragId`, for the lifted look.
//
// `this` is the frame element (el.call). Hit-testing reads the grid's own
// child nodes and their rects (reading `el.node` is allowed; no document
// query), and the card follows the pointer through `setNodeStyles`, the
// element's sanctioned inline-style escape hatch.
//
// MOTION (DESIGN-WL-HOME-WIDTH-RESIZE-1, functions/homeWidgetMotion.js): the
// lifted card grows to `scale 1.02` (DESIGN_SPEC §6.4 "dragged card: lift
// shadow float + scale(1.02), A" — the individual `scale` property, which the
// frame transitions at `A`); the neighbours glide into their new cells (the
// board wraps `moveWidget` in its FLIP); the drop hands the pointer offset to
// the frame's `translate` transition, so the card SETTLES into its cell instead
// of jumping. The pointer-follow itself is the inline `transform`, which the
// frame never transitions, so the card stays under the finger. Reduced motion
// or a hidden tab: no lift and no glide (homeWidgetMotionAllowed).
const $478b9c69e01f51f0$export$3b7964e8b0ec7352 = function homeWidgetDragStart(e, s) {
    const root = s && s.root;
    if (!root || !root._homeCustomizeMode || !this || !this.node) return;
    if (e && e.button !== undefined && e.button !== 0) return;
    // Never from a control — but the title and the app tile are the card's own
    // buttons (they open it outside edit mode), so in edit mode they are handles.
    const t = e && e.target;
    const control = t && t.closest && t.closest('button, a, input, textarea, select, [role="radio"], [role="tab"], .gs-no-drag');
    if (control && !(control.matches && control.matches('.widget-title, .widget-app-tile'))) return;
    const rect = this.node.getBoundingClientRect();
    root._homeDragging = {
        id: s.id,
        pointerId: e.pointerId,
        startX: e.clientX,
        startY: e.clientY,
        grabX: e.clientX - rect.left,
        grabY: e.clientY - rect.top,
        dx: 0,
        dy: 0,
        moved: false,
        lastTarget: null,
        before: Array.isArray(root._homeLayout) ? root._homeLayout.slice() : null
    };
    try {
        this.node.setPointerCapture(e.pointerId);
    } catch (_) {
    /* synthetic events carry no capturable pointer */ }
};
const $478b9c69e01f51f0$export$cb72e458500079ca = function homeWidgetDragMove(e, s) {
    const root = s && s.root;
    const d = root && root._homeDragging;
    if (!d || d.id !== s.id || d.pointerId !== undefined && e.pointerId !== d.pointerId) return;
    if (!d.moved) {
        // A small dead zone keeps a click a click.
        if (Math.hypot(e.clientX - d.startX, e.clientY - d.startY) < 6) return;
        d.moved = true;
        root.update({
            _homeDragId: d.id
        }, {
            preventFetch: true
        });
        // The lift (DESIGN_SPEC §6.4) — only where motion is allowed.
        d.lifted = !!this.call('homeWidgetMotionAllowed', this.node);
        if (d.lifted) this.setNodeStyles({
            scale: '1.02'
        });
    }
    if (e.cancelable) e.preventDefault();
    const node = this.node;
    const gridNode = node && node.parentElement;
    if (!gridNode) return;
    let target = null;
    for (const child of gridNode.children){
        if (child === node) continue;
        const id = child.getAttribute && child.getAttribute('data-widget-id');
        if (!id) continue;
        const r = child.getBoundingClientRect();
        if (!r.width || !r.height) continue;
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
            target = id;
            break;
        }
    }
    // Follow the pointer from wherever the flow has put the card now: its rect
    // includes the current translate, so subtract it to get the resting place.
    const follow = (x, y)=>{
        const r = node.getBoundingClientRect();
        const baseLeft = r.left - d.dx;
        const baseTop = r.top - d.dy;
        d.dx = x - d.grabX - baseLeft;
        d.dy = y - d.grabY - baseTop;
        this.setNodeStyles({
            transform: `translate(${Math.round(d.dx)}px, ${Math.round(d.dy)}px)`
        });
    };
    if (target && target !== d.lastTarget && root._homeOps && root._homeOps.moveWidget) {
        d.lastTarget = target;
        root._homeOps.moveWidget(d.id, target);
        // The new order reaches the DOM in smbls' effect flush, one microtask
        // later: re-anchor the card to its NEW cell then, before any frame paints,
        // so it never jumps by the cell it just left.
        const x = e.clientX;
        const y = e.clientY;
        const again = ()=>{
            if (root._homeDragging === d) follow(x, y);
        };
        if (typeof queueMicrotask === 'function') queueMicrotask(again);
        else Promise.resolve().then(again);
    }
    follow(e.clientX, e.clientY);
};
const $478b9c69e01f51f0$export$5dbd2d7212cccbda = function homeWidgetDragEnd(e, s, cancelled) {
    const root = s && s.root;
    const d = root && root._homeDragging;
    if (!d || d.id !== s.id) return;
    root._homeDragging = null;
    try {
        if (this.node && d.pointerId !== undefined) this.node.releasePointerCapture(d.pointerId);
    } catch (_) {
    /* already released */ }
    if (!d.moved) {
        this.setNodeStyles({
            transform: ''
        });
        return;
    }
    // SETTLE: the card sits in its cell already (the live reorder moved it
    // there); the pointer offset moves from the instant `transform` to the
    // transitioned `translate`, so clearing it glides the card home and the
    // lift eases off. Without motion the card simply lands.
    if (d.lifted && this.node) {
        this.setNodeStyles({
            transition: 'none',
            translate: `${Math.round(d.dx)}px ${Math.round(d.dy)}px`,
            transform: ''
        });
        this.node.offsetWidth;
        this.setNodeStyles({
            transition: '',
            translate: '',
            scale: ''
        });
    } else this.setNodeStyles({
        transform: '',
        scale: ''
    });
    root.update({
        _homeDragId: null
    }, {
        preventFetch: true
    });
    const ops = root._homeOps;
    if (!ops) return;
    if (cancelled) {
        if (d.before && ops.setLayout) ops.setLayout(d.before, {
            persist: false
        });
        return;
    }
    if (ops.persistLayout) ops.persistLayout();
};
const $478b9c69e01f51f0$export$f7c15a57afc12c7e = function homeWidgetKeyMove(e, s) {
    const root = s && s.root;
    if (!e || e.shiftKey || e.metaKey || e.ctrlKey || e.altKey) return;
    if (!root || !root._homeCustomizeMode || !root._homeOps || !root._homeOps.moveBy) return;
    const delta = e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : 0;
    if (!delta) return;
    e.preventDefault();
    root._homeOps.moveBy(s.id, delta);
};

});

parcelRegister("krR5z", function(module, exports) {

$parcel$export(module.exports, "homeWidgetResizeSizes", () => $ee2f829e5eb8766f$export$abd803a7742ffcf3);
$parcel$export(module.exports, "homeWidgetResizeBox", () => $ee2f829e5eb8766f$export$1f5c65ba952afbc8);
$parcel$export(module.exports, "homeWidgetResizeSnap", () => $ee2f829e5eb8766f$export$772c683e7f252432);
$parcel$export(module.exports, "homeWidgetResizeStep", () => $ee2f829e5eb8766f$export$edddff7755017202);
$parcel$export(module.exports, "homeWidgetResizeMetrics", () => $ee2f829e5eb8766f$export$8cf6aa8117c0b75f);
$parcel$export(module.exports, "homeWidgetResizeStepBy", () => $ee2f829e5eb8766f$export$27560f3fbb06e6fa);
$parcel$export(module.exports, "homeWidgetResizeStart", () => $ee2f829e5eb8766f$export$bb6d7ee387bdee30);
$parcel$export(module.exports, "homeWidgetResizeMove", () => $ee2f829e5eb8766f$export$728e146ff63e98b7);
$parcel$export(module.exports, "homeWidgetResizeEnd", () => $ee2f829e5eb8766f$export$5f93b014578b635);
$parcel$export(module.exports, "homeWidgetResizeKey", () => $ee2f829e5eb8766f$export$244af034a302e2fb);
$parcel$export(module.exports, "homeWidgetResizeTitle", () => $ee2f829e5eb8766f$export$f75709d5fa748593);
// RESIZE a home widget by its corner (Nika 2026-09-27: "add resize
// functionality to widgets"; DESIGN-WL-HOME-WIDTH-RESIZE-1, HOME_WIDGETS_SPEC
// §1 dated line + §6).
//
// The board still knows four sizes and nothing else (S 1×1 · M 2×1 · L 2×2 ·
// XL the full row, functions/homeGridMetrics.js). A resize never invents a
// fifth: the pointer asks for a box, the box SNAPS to the nearest size this
// widget allows, and the release writes that size through the board's one
// durable layout write (`root._homeOps.setWidgetSize` → pages/main.js
// `_setHomeWidgetSize`: immediate, single-flight, outbox-backed).
//
//   the handle   — components/HomeWidgetResizeHandle.js (the frame child `HomeWidgetResizeHandle`), the
//                  card's bottom-right corner (shown on hover, focus-within and
//                  always in edit mode). Pointer down CAPTURES the pointer on
//                  the handle, so every move and the release land on it — no
//                  document listener; Escape on the (focused) handle cancels.
//   the outline  — `WidgetResizeGhost`, the dashed box the release will give
//                  (its own state: `{ size, w, h }`), painted over the
//                  neighbours from the card's top-left corner.
//   the minimum  — content sets the smallest size (HOME_AMBIENT_SKIN_SPEC §3
//                  law 2): the allowed sizes are the size picker's own rows
//                  (`homeWidgetSizeRows`), so the two can never disagree.
//   the keyboard — Shift + an arrow steps the focused widget one size that way
//                  in edit mode (functions/shortcutsHome.js), and the arrows on
//                  the focused handle do the same.
//
// `this` is an element (el.call) — the handle for the pointer / key handlers.
// Every export stands alone (frank serializes each one by itself): the shared
// reads are registered functions reached through `this.call`. The drag's
// bookkeeping is a plain handle on the root state (`root._homeResizing`, like
// the reorder's `root._homeDragging`) — one gesture at a time, never rendered.
// The sizes this widget may take, smallest first — the picker's rule.
function $ee2f829e5eb8766f$export$abd803a7742ffcf3(s) {
    const rows = this.call('homeWidgetSizeRows', s);
    const out = (Array.isArray(rows) ? rows : []).map((r)=>r && r.value).filter(Boolean);
    return out.length ? out : [
        's',
        'm',
        'l',
        'xl'
    ];
}
function $ee2f829e5eb8766f$export$1f5c65ba952afbc8(size, metrics, s) {
    const m = metrics || {};
    const span = (s ? this.call('homeWidgetSpanFor', s, size, m.cols) : this.call('homeWidgetSpan', size, m.cols)) || {
        c: 1,
        r: 1
    };
    const cell = Number(m.cell) || 0;
    const gap = Number(m.gutter) || 0;
    return {
        c: span.c,
        r: span.r,
        w: span.c * cell + (span.c - 1) * gap,
        h: span.r * cell + (span.r - 1) * gap
    };
}
function $ee2f829e5eb8766f$export$772c683e7f252432(want, metrics, allowed, current, s) {
    const sizes = Array.isArray(allowed) && allowed.length ? allowed : [
        's',
        'm',
        'l',
        'xl'
    ];
    const w = Number(want && want.w) || 0;
    const h = Number(want && want.h) || 0;
    let best = null;
    let bestD = Infinity;
    for (const size of sizes){
        const box = this.call('homeWidgetResizeBox', size, metrics, s);
        const d = Math.hypot(box.w - w, box.h - h);
        if (d < bestD - 0.5) {
            best = size;
            bestD = d;
        } else if (Math.abs(d - bestD) <= 0.5 && size === current) best = size;
    }
    return best || current || sizes[0];
}
function $ee2f829e5eb8766f$export$edddff7755017202(current, dir, cols, allowed, s) {
    const sizes = Array.isArray(allowed) && allowed.length ? allowed : [
        's',
        'm',
        'l',
        'xl'
    ];
    const span = (z)=>(s ? this.call('homeWidgetSpanFor', s, z, cols) : this.call('homeWidgetSpan', z, cols)) || {
            c: 1,
            r: 1
        };
    const cur = span(current);
    const want = {
        c: cur.c + (dir === 'right' ? 1 : dir === 'left' ? -1 : 0),
        r: cur.r + (dir === 'down' ? 1 : dir === 'up' ? -1 : 0)
    };
    const ok = (sp)=>dir === 'right' ? sp.c > cur.c : dir === 'left' ? sp.c < cur.c : dir === 'down' ? sp.r > cur.r : dir === 'up' ? sp.r < cur.r : false;
    let best = null;
    let bestD = Infinity;
    for (const z of sizes){
        if (z === current) continue;
        const sp = span(z);
        if (!ok(sp)) continue;
        const d = Math.abs(sp.c - want.c) + Math.abs(sp.r - want.r);
        if (d < bestD) {
            best = z;
            bestD = d;
        }
    }
    return best;
}
function $ee2f829e5eb8766f$export$8cf6aa8117c0b75f(card) {
    const node = card && (card.node || card);
    const grid = node && node.parentElement;
    const width = grid && grid.clientWidth || node && node.getBoundingClientRect().width || 0;
    return this.call('homeGridMetrics', width);
}
function $ee2f829e5eb8766f$export$27560f3fbb06e6fa(s, dir, card) {
    const root = s && s.root;
    const ops = root && root._homeOps;
    if (!ops || typeof ops.setWidgetSize !== 'function' || !s.id) return false;
    if (this.call('homeWidgetIsApp', s)) return false;
    const metrics = this.call('homeWidgetResizeMetrics', card);
    const current = this.call('homeWidgetFrameSize', s);
    const next = this.call('homeWidgetResizeStep', current, dir, metrics.cols, this.call('homeWidgetResizeSizes', s), s);
    if (!next || next === current) return false;
    ops.setWidgetSize(s.id, next);
    return true;
}
function $ee2f829e5eb8766f$export$bb6d7ee387bdee30(e, s) {
    const root = s && s.root;
    const card = this && this.parent;
    const ops = root && root._homeOps;
    if (!root || !card || !card.node || !ops || typeof ops.setWidgetSize !== 'function') return false;
    if (e && e.button !== undefined && e.button !== 0) return false;
    if (root._homeDragging || this.call('homeWidgetIsApp', s)) return false;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    const rect = card.node.getBoundingClientRect();
    const from = this.call('homeWidgetFrameSize', s);
    root._homeResizing = {
        id: s.id,
        pointerId: e && e.pointerId,
        left: rect.left,
        top: rect.top,
        // the pointer keeps its place relative to the corner it grabbed
        offX: rect.right - (e && e.clientX || 0),
        offY: rect.bottom - (e && e.clientY || 0),
        startX: e && e.clientX || 0,
        startY: e && e.clientY || 0,
        metrics: this.call('homeWidgetResizeMetrics', card),
        allowed: this.call('homeWidgetResizeSizes', s),
        from: from,
        size: from,
        moved: false
    };
    try {
        this.node.setPointerCapture(e.pointerId);
    } catch (_) {
    /* synthetic events carry no capturable pointer */ }
    // Focus rides on the handle for the gesture: Escape lands here in every
    // browser (Safari does not focus a pressed button), and :focus-within keeps
    // the handle shown while the pointer leaves the card.
    try {
        this.node.focus({
            preventScroll: true
        });
    } catch (_) {
    /* a detached node takes no focus */ }
    return true;
}
function $ee2f829e5eb8766f$export$728e146ff63e98b7(e, s) {
    const root = s && s.root;
    const r = root && root._homeResizing;
    if (!r || !s || r.id !== s.id) return false;
    if (r.pointerId !== undefined && e && e.pointerId !== undefined && e.pointerId !== r.pointerId) return false;
    if (!r.moved) {
        if (Math.hypot(e.clientX - r.startX, e.clientY - r.startY) < 4) return false;
        r.moved = true;
    }
    if (e.cancelable) e.preventDefault();
    const want = {
        w: e.clientX + r.offX - r.left,
        h: e.clientY + r.offY - r.top
    };
    const size = this.call('homeWidgetResizeSnap', want, r.metrics, r.allowed, r.size, s);
    const ghost = this.parent && this.parent.WidgetResizeGhost;
    if (ghost && ghost.state && (size !== r.size || !r.shown)) {
        const box = this.call('homeWidgetResizeBox', size, r.metrics, s);
        ghost.state.update({
            size: size,
            w: box.w,
            h: box.h
        });
        r.shown = true;
    }
    r.size = size;
    return true;
}
function $ee2f829e5eb8766f$export$5f93b014578b635(e, s, cancelled) {
    const root = s && s.root;
    const r = root && root._homeResizing;
    if (!r || !s || r.id !== s.id) return false;
    if (r.pointerId !== undefined && e && e.pointerId !== undefined && e.pointerId !== r.pointerId) return false;
    root._homeResizing = null;
    try {
        if (this.node && r.pointerId !== undefined) this.node.releasePointerCapture(r.pointerId);
    } catch (_) {
    /* already released */ }
    const ghost = this.parent && this.parent.WidgetResizeGhost;
    if (ghost && ghost.state && r.shown) ghost.state.update({
        size: null,
        w: 0,
        h: 0
    });
    if (cancelled || !r.moved || !r.size || r.size === r.from) return false;
    const ops = root._homeOps;
    if (!ops || typeof ops.setWidgetSize !== 'function') return false;
    ops.setWidgetSize(s.id, r.size);
    return true;
}
function $ee2f829e5eb8766f$export$244af034a302e2fb(e, s) {
    const root = s && s.root;
    if (!root || !e) return false;
    const r = root._homeResizing;
    if (e.key === 'Escape' || e.key === 'Esc') {
        if (!r || r.id !== s.id) return false;
        e.preventDefault();
        e.stopPropagation();
        this.call('homeWidgetResizeEnd', {
            pointerId: r.pointerId
        }, s, true);
        return true;
    }
    const dir = e.key === 'ArrowRight' ? 'right' : e.key === 'ArrowLeft' ? 'left' : e.key === 'ArrowDown' ? 'down' : e.key === 'ArrowUp' ? 'up' : null;
    if (!dir || r || e.metaKey || e.ctrlKey || e.altKey) return false;
    e.preventDefault();
    e.stopPropagation();
    return this.call('homeWidgetResizeStepBy', s, dir, this.parent);
}
function $ee2f829e5eb8766f$export$f75709d5fa748593(s) {
    const label = this.call('polyglot', 'workspace.widget.size.label');
    const size = this.call('homeWidgetFrameSize', s);
    const code = {
        s: 'S',
        m: 'M',
        l: 'L',
        xl: 'XL'
    }[size] || 'S';
    return `${label} \xb7 ${code}`;
}

});

parcelRegister("cKLMf", function(module, exports) {

$parcel$export(module.exports, "homeWidgetMotionAllowed", () => $948ed775fd2c9118$export$62ca52ee4eef3449);
$parcel$export(module.exports, "homeWidgetFlipDelta", () => $948ed775fd2c9118$export$b4f7df9e012b1286);
$parcel$export(module.exports, "homeWidgetFlipStart", () => $948ed775fd2c9118$export$e4e8003279ab344f);
$parcel$export(module.exports, "homeWidgetFlipCapture", () => $948ed775fd2c9118$export$4ed96b68924883b);
$parcel$export(module.exports, "homeWidgetFlipPlay", () => $948ed775fd2c9118$export$6302e74f8fecb030);
$parcel$export(module.exports, "homeWidgetFlip", () => $948ed775fd2c9118$export$e63219be79e80714);
$parcel$export(module.exports, "homeWidgetExit", () => $948ed775fd2c9118$export$9ee62df4ca148ade);
$parcel$export(module.exports, "homeWidgetReveal", () => $948ed775fd2c9118$export$daff469aef2ed91d);
// HOME BOARD MOTION — cards move instead of jumping (Nika 2026-09-28: "also
// add transitions and animations on moving around the widgets";
// DESIGN-WL-HOME-WIDTH-RESIZE-1, HOME_WIDGETS_SPEC §1 dated line).
//
// ONE technique for every change of the board's arrangement — a reorder (drag
// or keys), a resize (handle, keys or the picker), a restore and a hide: FLIP.
//   First   — read every card's rect before the change (`homeWidgetFlipCapture`);
//   Last    — apply the change, then read the rects again;
//   Invert  — put each moved card back where it was with an inline `translate`
//             (the individual CSS property, so it never fights the drag's own
//             pointer-follow `transform`), transitions off;
//   Play    — hand the card to its declared transition: the frame
//             (components/HomeWidgetFrame.js) lists `translate C defaultBezier`,
//             so clearing the inline value glides it home.
// A card that GREW is revealed with an `inset()` clip from its old box to its
// new one (`clip-path C defaultBezier`) — its content is already laid out at
// the new size, so nothing stretches. A hidden card leaves with the brand's
// `modalOutDown` (fade + a short fall, `B`); a restored card enters with the
// frame's own `fadeInUpShort`.
//
// The motion is CSS-driven: the inline values are the START of a declared
// transition, and the layout underneath is already final. So the state after a
// move is correct without a single frame — a hidden tab or a screenshot taken
// mid-way can only show the card on its way, never in a wrong cell.
//
// NO MOTION — the change lands at once — when (`homeWidgetMotionAllowed`):
//   • the OS asks for reduced motion (`prefers-reduced-motion: reduce`);
//   • the person asked for it in the app (`root.a11yMotion`);
//   • the document is not visible (the PageSlot / routeTransition rule:
//     transitions are frame-gated, and animating for nobody is pure risk).
//
// `this` is an element (el.call). Every export stands alone (frank serializes
// each one by itself): helpers are local consts or registered functions reached
// through `this.call`. Styles go through `setNodeStyles`, the element's
// sanctioned inline-style escape hatch (the drag's own channel); reads are
// `getBoundingClientRect` / `offsetWidth` on nodes the grid already owns.
// May the board animate right now? `node` names the document to ask (the
// grid's own node); without one, the element's.
function $948ed775fd2c9118$export$62ca52ee4eef3449(node) {
    const el = this;
    const own = el && el.node;
    const doc = node && node.ownerDocument || own && own.ownerDocument || null;
    if (!doc || doc.visibilityState !== 'visible') return false;
    const win = doc.defaultView;
    if (win && typeof win.matchMedia === 'function' && win.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    const st = el && el.state;
    const root = st && st.root || st;
    if (root && root.a11yMotion) return false;
    return true;
}
function $948ed775fd2c9118$export$b4f7df9e012b1286(first, last) {
    const num = (v)=>Number.isFinite(Number(v)) ? Number(v) : 0;
    if (!first || !last) return null;
    const fw = num(first.width);
    const fh = num(first.height);
    const lw = num(last.width);
    const lh = num(last.height);
    if (!(fw > 0) || !(fh > 0) || !(lw > 0) || !(lh > 0)) return null;
    const round = (v, p)=>Math.round(v * p) / p;
    const dx = round(num(first.left) - num(last.left), 100);
    const dy = round(num(first.top) - num(last.top), 100);
    const growRight = Math.max(0, round(lw - fw, 100));
    const growBottom = Math.max(0, round(lh - fh, 100));
    return {
        dx: dx,
        dy: dy,
        sx: round(fw / lw, 10000),
        sy: round(fh / lh, 10000),
        grow: {
            right: growRight,
            bottom: growBottom
        },
        moved: Math.abs(dx) >= 0.5 || Math.abs(dy) >= 0.5,
        resized: Math.abs(lw - fw) >= 0.5 || Math.abs(lh - fh) >= 0.5
    };
}
function $948ed775fd2c9118$export$e4e8003279ab344f(delta, radius) {
    if (!delta) return null;
    const growing = delta.grow && (delta.grow.right >= 0.5 || delta.grow.bottom >= 0.5);
    if (!delta.moved && !growing) return null;
    const out = {};
    if (delta.moved) out.translate = `${delta.dx}px ${delta.dy}px`;
    if (growing) {
        const r = radius ? ` round ${radius}` : '';
        out.clipPath = `inset(0px ${delta.grow.right}px ${delta.grow.bottom}px 0px${r})`;
        out.clipPathEnd = `inset(0px 0px 0px 0px${r})`;
    }
    return out;
}
function $948ed775fd2c9118$export$4ed96b68924883b(grid) {
    const node = grid && (grid.node || grid);
    const kids = node && node.children;
    const out = {};
    if (!kids) return out;
    Array.prototype.forEach.call(kids, (child)=>{
        const id = child && child.getAttribute && child.getAttribute('data-widget-id');
        if (!id || typeof child.getBoundingClientRect !== 'function') return;
        const r = child.getBoundingClientRect();
        if (!r || !(r.width > 0) || !(r.height > 0)) return;
        out[id] = {
            left: r.left,
            top: r.top,
            width: r.width,
            height: r.height
        };
    });
    return out;
}
function $948ed775fd2c9118$export$6302e74f8fecb030(grid, first, opts) {
    const node = grid && (grid.node || grid);
    const kids = node && node.children;
    if (!kids || !first) return 0;
    if (!this.call('homeWidgetMotionAllowed', node)) return 0;
    const skip = new Set(opts && opts.exclude || []);
    const resized = opts && opts.resized;
    const cards = [];
    Array.prototype.forEach.call(kids, (child)=>{
        const id = child && child.getAttribute && child.getAttribute('data-widget-id');
        const card = child && child.ref;
        if (!id || skip.has(id) || !first[id] || !card || typeof card.setNodeStyles !== 'function') return;
        cards.push({
            id: id,
            child: child,
            card: card
        });
    });
    if (!cards.length) return 0;
    // 1. Cancel whatever glide is in flight, so LAST is the true layout.
    for (const c of cards){
        if (c.card.__homeClipTimer != null) clearTimeout(c.card.__homeClipTimer);
        c.card.__homeClipTimer = null;
        c.card.setNodeStyles({
            transition: 'none',
            translate: '0 0',
            clipPath: ''
        });
    }
    // 2. Read every LAST rect in one pass (one layout), then write the inverses.
    const plans = [];
    const planned = new Set();
    for (const c of cards){
        const r = c.child.getBoundingClientRect();
        const delta = this.call('homeWidgetFlipDelta', first[c.id], r);
        if (!delta) continue;
        let radius = null;
        if (c.id === resized && delta.grow && (delta.grow.right >= 0.5 || delta.grow.bottom >= 0.5)) {
            const win = c.child.ownerDocument && c.child.ownerDocument.defaultView;
            const cs = win && typeof win.getComputedStyle === 'function' ? win.getComputedStyle(c.child) : null;
            radius = cs && cs.borderTopLeftRadius || null;
        }
        const start = this.call('homeWidgetFlipStart', c.id === resized ? delta : {
            ...delta,
            grow: {
                right: 0,
                bottom: 0
            }
        }, radius);
        if (start) {
            plans.push({
                ...c,
                start: start
            });
            planned.add(c.id);
        }
    }
    for (const c of cards)if (!planned.has(c.id)) c.card.setNodeStyles({
        transition: '',
        translate: ''
    });
    if (!plans.length) return 0;
    for (const p of plans)p.card.setNodeStyles({
        translate: p.start.translate || '0 0',
        clipPath: p.start.clipPath || ''
    });
    // 3. Commit the start frame (a layout read), then PLAY: back to the declared
    //    transition, the inline start values cleared (the clip goes to its full
    //    box, and is dropped once the glide has had its time).
    node.offsetWidth;
    let clipLeft = 0;
    for (const p of plans){
        p.card.setNodeStyles({
            transition: '',
            translate: ''
        });
        if (p.start.clipPathEnd) {
            p.card.setNodeStyles({
                clipPath: p.start.clipPathEnd
            });
            clipLeft++;
        }
    }
    if (clipLeft) {
        const ds = this.context && this.context.designSystem;
        const step = ds && ds.timing && ds.timing.sequence && ds.timing.sequence.C;
        const wait = step && Number(step.val) || 0;
        for (const p of plans){
            if (!p.start.clipPathEnd) continue;
            const card = p.card;
            const clear = ()=>{
                card.__homeClipTimer = null;
                card.setNodeStyles({
                    clipPath: ''
                });
            };
            if (wait > 0 && typeof setTimeout === 'function') card.__homeClipTimer = setTimeout(clear, wait + 60);
            else clear();
        }
    }
    return plans.length;
}
function $948ed775fd2c9118$export$e63219be79e80714(grid, change, opts) {
    const node = grid && (grid.node || grid);
    const first = this.call('homeWidgetMotionAllowed', node) ? this.call('homeWidgetFlipCapture', grid) : null;
    const result = typeof change === 'function' ? change() : undefined;
    const el = this;
    const play = ()=>{
        const played = el.call('homeWidgetFlipPlay', grid, first, opts);
        if (opts && typeof opts.after === 'function') opts.after(played);
    };
    if (typeof queueMicrotask === 'function') queueMicrotask(play);
    else Promise.resolve().then(play);
    return result;
}
function $948ed775fd2c9118$export$9ee62df4ca148ade(grid, id, done) {
    const finish = typeof done === 'function' ? done : ()=>{};
    const node = grid && (grid.node || grid);
    const kids = node && node.children;
    let card = null;
    if (kids && id) Array.prototype.forEach.call(kids, (child)=>{
        if (!card && child && child.getAttribute && child.getAttribute('data-widget-id') === id) card = child;
    });
    if (!card || typeof card.animate !== 'function' || !this.call('homeWidgetMotionAllowed', node)) return finish();
    const r = card.getBoundingClientRect();
    if (!r || !(r.width > 0)) return finish();
    const ds = this.context && this.context.designSystem;
    const timing = ds && ds.timing;
    const step = timing && timing.sequence && timing.sequence.B;
    const duration = step && Number(step.val);
    const easing = timing && timing.defaultBezier;
    const frames = ds && ds.animation && ds.animation.modalOutDown;
    if (!duration || !easing || !frames || !frames.to) return finish();
    const from = {
        opacity: 1
    };
    const anim = card.animate([
        from,
        frames.to
    ], {
        duration: duration,
        easing: easing,
        fill: 'forwards'
    });
    anim.id = 'homeWidgetExit';
    let ran = false;
    let timer = null;
    const land = ()=>{
        if (ran) return;
        ran = true;
        if (timer != null) clearTimeout(timer);
        timer = null;
        try {
            finish();
        } finally{
            try {
                anim.cancel();
            } catch (_) {
            /* already gone with its card */ }
        }
    };
    Promise.resolve(anim.finished).then(land, land);
    if (typeof setTimeout === 'function') timer = setTimeout(land, duration + 120);
    return undefined;
}
function $948ed775fd2c9118$export$daff469aef2ed91d(column, grid, id) {
    const scroller = column && (column.node || column);
    const node = grid && (grid.node || grid);
    const kids = node && node.children;
    if (!scroller || !kids || !id || typeof scroller.scrollBy !== 'function') return 'none';
    let card = null;
    Array.prototype.forEach.call(kids, (child)=>{
        if (!card && child && child.getAttribute && child.getAttribute('data-widget-id') === id) card = child;
    });
    if (!card || !(card.offsetHeight > 0) || typeof node.getBoundingClientRect !== 'function') return 'none';
    const g = node.getBoundingClientRect();
    const top = g.top + card.offsetTop;
    const bottom = top + card.offsetHeight;
    const view = scroller.getBoundingClientRect();
    const win = scroller.ownerDocument && scroller.ownerDocument.defaultView;
    const cs = win && typeof win.getComputedStyle === 'function' ? win.getComputedStyle(scroller) : null;
    const from = view.top + (cs && parseFloat(cs.paddingTop) || 0);
    const to = view.bottom - (cs && parseFloat(cs.paddingBottom) || 0);
    if (top >= from - 0.5 && bottom <= to + 0.5) return 'visible';
    // a card taller than the room, or above it, aligns its top; else its bottom
    const delta = bottom - top > to - from || top < from ? top - from : bottom - to;
    const smooth = !!this.call('homeWidgetMotionAllowed', scroller);
    scroller.scrollBy({
        top: Math.round(delta),
        behavior: smooth ? 'smooth' : 'auto'
    });
    return smooth ? 'smooth' : 'instant';
}

});

parcelRegister("76atT", function(module, exports) {

$parcel$export(module.exports, "persistableHiddenMap", () => $52b13945cf5b2f38$export$9a29d03a8fa20746);
// homeHiddenPersist.js — the one decision behind "which entries of the home
// board's hidden map are DURABLE?"
//
// The composed map the board renders (`_composeHiddenMap` in pages/main.js) is
// three different kinds of fact stacked together:
//
//   1. DEFAULTS      — `_DEFAULT_HIDDEN_WIDGETS`, the workspace panel set, the
//                      installed apps' declared widget defaults. Re-derived on
//                      every boot from data the shell already holds.
//   2. USER CHOICES  — the hides and restores a person actually performed.
//   3. RENDER CLAMPS — a house row whose route gate is OFF, a module widget the
//                      panel set does not grant. Policy, evaluated per render.
//
// Only (2) is durable. The write path did not know that: `_hideWidgetById`
// persisted `{ ...root._homeHiddenWidgets, [id]: true }`, so ONE hide wrote all
// three kinds to the localStorage cache AND the server row. Measured on the
// app-mode vault workspace (2026-09-10): hiding a single app icon persisted 27
// keys — 16 pure defaults (`received … app-infra`), 5 app-plane defaults, 5
// redundant `false`s, and the one real gesture.
//
// Three costs, in rising order of seriousness:
//   • the row stops being readable — nobody can tell a choice from a default;
//   • a default can never be CHANGED again for anyone who has ever touched
//     their board: the stale copy in their row outranks the new default
//     (`{ ...baseHidden, ...savedHidden }`), which is the same "frozen the
//     async-mount race into the row as fake user hides" failure the first-run
//     seed already carries a warning about;
//   • a RENDER CLAMP written into the row is a policy decision turned into a
//     user preference — it outlives the policy. A house row hidden because its
//     route gate was off stays hidden in the row after the gate comes back on.
//
// Pure by design: the caller supplies every input, so a test can pin the
// decision without a browser, a grid, or a network.
/**
 * @param {object} args
 * @param {object} args.stored    the map currently persisted (server row ▸ cache)
 * @param {object} args.gestures  the EXPLICIT choices made in this document.
 *   Every entry here is written VERBATIM — a gesture is never pruned against
 *   `base`, because `base` is still converging while the board is clickable.
 * @param {object} args.base      the default map for this workspace RIGHT NOW
 * @param {Set<string>} args.knownIds  every widget id this workspace can render
 * @param {Set<string>} args.gatedIds  ids currently clamped hidden by a gate
 * @returns {object} the map to write — explicit choices only
 */ const $52b13945cf5b2f38$export$9a29d03a8fa20746 = ({ stored: stored, gestures: gestures, base: base, knownIds: knownIds, gatedIds: gatedIds } = {})=>{
    const _stored = stored && typeof stored === 'object' ? stored : {};
    const _gestures = gestures && typeof gestures === 'object' ? gestures : {};
    const _base = base && typeof base === 'object' ? base : {};
    const known = knownIds instanceof Set ? knownIds : new Set(knownIds || []);
    const gated = gatedIds instanceof Set ? gatedIds : new Set(gatedIds || []);
    const out = {};
    for (const id of new Set([
        ...Object.keys(_stored),
        ...Object.keys(_gestures)
    ])){
        // A clamp is never a stored choice — not even when the user's own last
        // gesture agreed with it. The gate decides again on every render.
        if (gated.has(id)) continue;
        // A key with no catalog row HERE cannot be acted on here: the drawer will
        // not offer it and no card can carry it. Keeping it only lets one
        // workspace's vocabulary accumulate in another's row.
        if (!known.has(id)) continue;
        const isGesture = Object.prototype.hasOwnProperty.call(_gestures, id);
        const value = isGesture ? !!_gestures[id] : !!_stored[id];
        // An INHERITED entry that agrees with the current default carries no
        // information: the read path composes `{ ...base, ...saved }`, so dropping
        // it leaves today's outcome identical and lets tomorrow's default reach the
        // user. This is what makes the pruning safe to apply to entries written
        // long before this rule existed — it can only ever remove a redundancy.
        //
        // A GESTURE IS NEVER PRUNED, even when it happens to agree with today's
        // base (WS-HOME-PREFS-PERSIST-ALWAYS-1). Two reasons, and the first is a
        // measured data-loss class, not a preference:
        //
        //   1. `base` is still CONVERGING while the board is already clickable.
        //      It is re-derived per call from live root state — the workspace's
        //      panel set, the installed apps' manifests, and (since
        //      WS-HOME-APPMODE-DEFAULT-WIDGETS-1) whether this workspace is an
        //      app-mode install, a fact that arrives with `workspaceSettings`
        //      seconds after the first paint. So the same click can be durable or
        //      silently discarded depending only on WHEN it happened. Durability
        //      must never depend on a value that is still settling.
        //   2. A default and a decision are different kinds of fact. "This is off
        //      unless you say otherwise" is a default; "I turned this off" is a
        //      person's answer, and it must keep outranking a default that later
        //      changes its mind. Storing it is the whole point.
        //
        // The fossilised-defaults defect WS-HOME-PREFS-DURABLE-1 fixed is untouched
        // by this: only the ledger's entries are exempt, and the ledger is recorded
        // at gesture sites ALONE (never by a resolver's reconcile) — see the
        // `_recordUserHidden` contract in pages/main.js.
        if (!isGesture && value === !!_base[id]) continue;
        out[id] = value;
    }
    return out;
};

});

parcelRegister("hkMuP", function(module, exports) {

$parcel$export(module.exports, "resolveSavedPrefsSource", () => $c9e9ec3f4c04f2a8$export$fcf32fa0cb755570);
// homePrefsBootSource.js — the one decision behind "whose answer does the home
// board boot from: the SERVER row, or the local cache?"
//
// THE RULE, and it has one direction only: the per-user × per-workspace server
// row (`home_dashboard_prefs`) is the single source of truth for a widget
// hide/show and for the grid layout. `localStorage` is a BOOT CACHE — it exists
// so the board can paint before the prefs GET lands, and for a boot with no
// network. It may never outrank the server.
//
// THE BUG THIS PINS, measured live on vault.pr.symbols.app (staging shell
// f6ce7c87e, Vault workspace 6a9d6f43208bdbbaed744900, 2026-09-10):
// the server row was set to `hidden_widgets: {}` — "nothing is hidden" — while
// the device's cache still held eight ids from an earlier session. The board
// booted with EIGHT widgets hidden. The row said the opposite and lost.
//
// The cause was one line of shape-checking: the saved set was read through
// `_nonEmptyMap`, which maps `{}` to `null`, and `null` means "no answer, fall
// through to the cache". So an EMPTY map — the perfectly ordinary state of a
// user who has hidden nothing, or who has just restored everything — was
// indistinguishable from "the row has not loaded yet". The consequences are
// exactly the two Nika reported:
//   • restore every widget on device A ⇒ the row empties ⇒ device B keeps
//     showing A's old hides forever, because B's cache outranks the row;
//   • clear a device's cache and the board changes — proof the device, not the
//     account, was holding the answer.
//
// PRESENCE, NOT EMPTINESS, is the test. A row that provably belongs to this
// workspace scope IS the answer, whatever it contains. The cache is consulted
// only when no such row exists yet.
//
// THE VERSION GATE keeps its meaning and gains a missing half. A row stamped
// below `currentVersion` is deliberately ignored once, so a default rollout can
// reach a member who has customised (`CURRENT_DASHBOARD_V` in pages/main.js).
// The cache MUST NOT stand in for that row: it is the same generation of the
// same answer, so honouring it would quietly defeat the reset for every user
// who still had one. A stale row therefore yields NO saved set at all.
//
// Pure by design: the caller supplies every input, so a test can pin the
// decision without a browser, a network or a storage API.
/**
 * @param {object} args
 * @param {object|null} args.row         the prefs row mirrored onto root state,
 *                                       or null when none has landed
 * @param {string|null} args.rowScope    the workspace the row tags itself with
 * @param {string} args.scope            the workspace scope being booted
 * @param {number} args.rowVersion       the row's `dashboard_v`
 * @param {number} args.currentVersion   `CURRENT_DASHBOARD_V`
 * @param {object|null} args.cache       the parsed localStorage cache, or null
 * @returns {{ saved: object|null, source: 'server'|'cache'|'none' }}
 *   `saved` is the map to compose over the base; `source` names who answered,
 *   which the caller uses to decide whether the cache still needs a refresh.
 */ const $c9e9ec3f4c04f2a8$export$fcf32fa0cb755570 = ({ row: row, rowScope: rowScope, scope: scope, rowVersion: rowVersion, currentVersion: currentVersion, cache: cache } = {})=>{
    const scoped = row && typeof row === 'object' && !Array.isArray(row) && rowScope && rowScope === scope;
    if (scoped) {
        // A row below the current schema version is the one-time reset-everyone.
        // It answers "ignore every saved set", and the cache is part of that set.
        if (Number(rowVersion || 0) < Number(currentVersion || 0)) return {
            saved: null,
            source: 'server'
        };
        // Present ⇒ authoritative, `{}` included. `{}` is a real answer: "nothing
        // is hidden here". This is the whole fix.
        return {
            saved: row,
            source: 'server'
        };
    }
    // No row for this scope yet — the GET is still in flight, the user has never
    // saved, or this boot has no network. The cache paints so the board is not
    // blank, and the server's answer replaces it the moment it lands.
    if (cache && typeof cache === 'object' && !Array.isArray(cache)) return {
        saved: cache,
        source: 'cache'
    };
    return {
        saved: null,
        source: 'none'
    };
};
var $c9e9ec3f4c04f2a8$export$2e2bcd8739ae039 = {
    resolveSavedPrefsSource: $c9e9ec3f4c04f2a8$export$fcf32fa0cb755570
};

});

parcelRegister("dDuP2", function(module, exports) {

$parcel$export(module.exports, "homeWidgetCatalog", () => $9ed6d3859699d6e6$export$3d936103197ebf4);
$parcel$export(module.exports, "homeDefaultVisibleWidgets", () => $9ed6d3859699d6e6$export$39a7dd52d66b878e);
$parcel$export(module.exports, "homePanelRows", () => $9ed6d3859699d6e6$export$a1137389592aa15e);
// homeWidgetCatalog.js — THE HOME WIDGET REGISTRY: every house widget the
// workspace "/" board can show, and the ones it shows before anybody
// personalises it (DESIGN-WL-HOME-DEFAULTS-ALL-WORKSPACES-1).
//
// ONE registry, three readers:
//   • the board (pages/main.js `HOME_CATALOG`, `_DEFAULT_VISIBLE_WIDGETS`,
//     `homeCatalogFor`) — what it renders and what ships on;
//   • /admin/dashboard-defaults and the /admin/module Panels tab — the rows an
//     admin can turn on for the whole workspace (`homePanelRows` below).
// Both admin pages used to carry their own eleven-row `HOME_PANELS` copy, so
// every widget born after it (Next up, the App strip shortcuts, the team
// pulse / priority mix / workload summaries, the mail inbox) was on the board
// and missing from the pages that set the board's defaults.
//
// FRANK: every export is self-contained (FA204) — the lists live inside the
// functions that return them, and siblings are reached through `this.call`.
// Catalog of every house widget that lives on the home page. Keys match the
// `spec.id` passed into `_widget(...)` in pages/main.js; titles + icons feed
// the customize drawer when a widget is hidden so it can be restored, and the
// admin panel pages' rows (`homePanelRows`).
//
// `subtitle` (optional) is the SAME literal bundle key the widget's own card
// header uses, repeated here because the drawer needs it and two catalog
// rows can carry the SAME title: `assets` and `app-documents` both resolve
// to "Notes", `broadcast` and `app-broadcast` both to "Broadcast" (measured
// 2026-09-10). It is written out per row, never derived from the title key —
// `__tests__/i18nWorkspaceExtraction.test.js` requires every polyglot key to
// be a LITERAL, because a key built by concatenation is invisible to the
// extractor and to the "does this key exist" check. A row whose CARD header
// shows a live count (`assets`: "3 notes", `broadcast`: "2 unread") still
// carries one here: the drawer lists a widget that is OFF the board, so there
// is no count to show and nothing to tell it apart from its app-shortcut
// namesake. Those rows name a STATIC `workspace.widget.<id>.subtitle` key that
// exists for the drawer alone, alongside the card's own `subtitle<Count|Empty|
// Loading>` family.
//
// Keep this in sync with the widget declarations in pages/main.js
// (MainColumn.GridContainer) — adding a widget without listing it here means
// the drawer can't surface it after removal, and no admin can turn it on.
const $9ed6d3859699d6e6$export$3d936103197ebf4 = function homeWidgetCatalog() {
    return [
        // `place` names a row that renders in the page FRAME, not as a board card:
        // 'head' — the page head (the greeting and its summary); 'dock' — an App
        // strip shortcut. An app-mode workspace keeps its frame defaults and stands
        // down only the board cards (functions/homeDefaultWidgets.js
        // houseDefaultHiddenMap; Nika 2026-10-03, "Greeting + house dock").
        {
            id: 'greeting',
            title: 'workspace.catalog.greeting',
            icon: 'user',
            place: 'head'
        },
        // Module widgets (GreenIG's coverbanner/policies/claims/…) are NOT
        // catalogued here — homeCatalogFor appends the ACTIVE module's declared
        // widgets from the manifest stash (_allModuleWidgetsFor).
        {
            id: 'received',
            title: 'workspace.catalog.received',
            icon: 'check'
        },
        {
            id: 'given',
            title: 'workspace.catalog.given',
            icon: 'check'
        },
        // S8 (NIKA BATCH 2026-08-16) — workspace-wide ticket-status summary,
        // board-status.py's visual properties (proportional bar, fixed-width
        // counts, a who-can-act legend), not personal like Received/Given above.
        {
            id: 'teampulse',
            title: 'workspace.catalog.teampulse',
            icon: 'analytics'
        },
        // S8 second pass — the same summary language on the other two axes a
        // board is read on: how urgent the open work is, and who carries it.
        {
            id: 'prioritymix',
            title: 'workspace.catalog.prioritymix',
            icon: 'analytics'
        },
        {
            id: 'workload',
            title: 'workspace.catalog.workload',
            icon: 'people'
        },
        {
            id: 'projects',
            title: 'workspace.catalog.projects',
            icon: 'layers'
        },
        {
            id: 'assets',
            title: 'workspace.catalog.assets',
            icon: 'document',
            subtitle: 'workspace.widget.assets.subtitle'
        },
        {
            id: 'agents',
            title: 'workspace.catalog.agents',
            icon: 'star',
            subtitle: 'workspace.widget.agents.subtitle'
        },
        {
            id: 'youragents',
            title: 'workspace.catalog.youragents',
            icon: 'star'
        },
        {
            id: 'analytics',
            title: 'workspace.catalog.analytics',
            icon: 'analytics',
            subtitle: 'workspace.widget.analytics.subtitle'
        },
        {
            id: 'events',
            title: 'workspace.catalog.events',
            icon: 'date outline'
        },
        {
            id: 'next-up',
            title: 'workspace.catalog.nextUp',
            icon: 'date outline'
        },
        {
            id: 'activity',
            title: 'workspace.catalog.activity',
            icon: 'analytics',
            subtitle: 'workspace.widget.activity.subtitle'
        },
        {
            id: 'teamtime',
            title: 'workspace.catalog.teamtime',
            icon: 'globe',
            subtitle: 'workspace.widget.teamtime.subtitle'
        },
        {
            id: 'broadcast',
            title: 'workspace.catalog.broadcast',
            icon: 'bell',
            subtitle: 'workspace.widget.broadcast.subtitle'
        },
        // The built-in mail client's inbox card (architecture/MAIL.md §3.6).
        // `gateRoute` is the FIRST house row to carry one — see homeCatalogFor: mail
        // is behind a feature flag AND the app-access ACL, so a workspace with mail
        // off must not be OFFERED the widget in the customize drawer either.
        {
            id: 'mail-inbox',
            title: 'workspace.catalog.mailInbox',
            icon: 'email',
            gateRoute: '/mail'
        },
        // App-shortcut icon widgets — default on a fresh workspace (see the
        // AppStudioWidget… declarations in GridContainer + _DEFAULT_VISIBLE_WIDGETS).
        {
            id: 'app-studio',
            place: 'dock',
            title: 'workspace.catalog.appStudio',
            icon: 'layers',
            subtitle: 'workspace.widget.appStudio.subtitle'
        },
        {
            id: 'app-infra',
            place: 'dock',
            title: 'workspace.catalog.appInfra',
            icon: 'server',
            subtitle: 'workspace.widget.appInfra.subtitle'
        },
        {
            id: 'app-tickets',
            place: 'dock',
            title: 'workspace.catalog.appTickets',
            icon: 'check',
            subtitle: 'workspace.widget.appTickets.subtitle'
        },
        {
            id: 'app-chat',
            place: 'dock',
            title: 'workspace.catalog.appChat',
            icon: 'chat',
            subtitle: 'workspace.widget.appChat.subtitle'
        },
        {
            id: 'app-calendar',
            place: 'dock',
            title: 'workspace.catalog.appCalendar',
            icon: 'date outline',
            subtitle: 'workspace.widget.appCalendar.subtitle'
        },
        {
            id: 'app-reminders',
            title: 'workspace.catalog.appReminders',
            icon: 'clockOutline',
            place: 'dock'
        },
        {
            id: 'app-meet',
            place: 'dock',
            title: 'workspace.catalog.appMeet',
            icon: 'video',
            subtitle: 'workspace.widget.appMeet.subtitle'
        },
        {
            id: 'app-broadcast',
            place: 'dock',
            title: 'workspace.catalog.appBroadcast',
            icon: 'bell',
            subtitle: 'workspace.widget.appBroadcast.subtitle'
        },
        {
            id: 'app-documents',
            place: 'dock',
            title: 'workspace.catalog.appDocuments',
            icon: 'document',
            subtitle: 'workspace.widget.appDocuments.subtitle'
        },
        {
            id: 'app-agents',
            place: 'dock',
            title: 'workspace.catalog.appAgents',
            icon: 'star',
            subtitle: 'workspace.widget.appAgents.subtitle'
        },
        {
            id: 'app-team',
            place: 'dock',
            title: 'workspace.catalog.appTeam',
            icon: 'people',
            subtitle: 'workspace.widget.appTeam.subtitle'
        },
        {
            id: 'app-analytics',
            place: 'dock',
            title: 'workspace.catalog.appAnalytics',
            icon: 'analytics',
            subtitle: 'workspace.widget.appAnalytics.subtitle'
        },
        {
            id: 'app-people',
            place: 'dock',
            title: 'workspace.catalog.appPeople',
            icon: 'user',
            subtitle: 'workspace.widget.appPeople.subtitle'
        },
        {
            id: 'app-health',
            place: 'dock',
            title: 'workspace.catalog.appHealth',
            icon: 'eye',
            subtitle: 'workspace.widget.appHealth.subtitle'
        }
    ];
};
const $9ed6d3859699d6e6$export$39a7dd52d66b878e = function homeDefaultVisibleWidgets() {
    return [
        'greeting',
        // Next up — the day's next event, on by default (Nika's pick "Next up
        // widget on", HOME_AMBIENT_SKIN_SPEC.md §0).
        'next-up',
        // Cool-app icon shortcuts — on by default so a fresh workspace isn't bare.
        'app-studio',
        'app-tickets',
        'app-chat',
        'app-calendar',
        'app-reminders',
        'app-meet',
        'app-broadcast',
        'app-documents',
        'app-agents',
        'app-team',
        'app-analytics',
        'app-people',
        'app-health'
    ];
};
const $9ed6d3859699d6e6$export$a1137389592aa15e = function homePanelRows(root) {
    const el = this;
    const call = (name, ...args)=>el && typeof el.call === 'function' ? el.call(name, ...args) : undefined;
    const r = root && typeof root === 'object' ? root : {};
    const bag = r.workspaceSettings && typeof r.workspaceSettings === 'object' ? r.workspaceSettings : {};
    const panels = Array.isArray(bag.home_default_panels) ? bag.home_default_panels : [];
    const catalog = call('homeWidgetCatalog');
    const defaults = call('homeDefaultVisibleWidgets');
    const houseDefaults = new Set(Array.isArray(defaults) ? defaults : []);
    // A takeover module's set governs every row. App mode locks only the frame
    // rows (catalog `place`: the house Dock apps), which show there like on every
    // workspace (Nika 2026-10-03, "Greeting + house dock"); its board cards stay
    // switchable. A general workspace locks every house default.
    const takeover = !!call('takeoverModuleRef', r);
    const appMode = !takeover && !!call('isAppModeWorkspace', r);
    const locked = (w)=>!takeover && houseDefaults.has(w.id) && (!appMode || !!w.place);
    const rows = [];
    const seen = new Set([
        'greeting'
    ]);
    for (const w of Array.isArray(catalog) ? catalog : []){
        if (!w || !w.id || seen.has(w.id)) continue;
        if (w.gateRoute && call('navItemVisible', r, w.gateRoute) === false) continue;
        seen.add(w.id);
        const named = panels.includes(w.id);
        const state = named ? 'on' : locked(w) ? 'default' : 'off';
        rows.push({
            id: w.id,
            label: w.title || w.id,
            state: state
        });
    }
    const planes = [
        r.workspaceProject && r.workspaceProject.widgets
    ];
    for (const app of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])planes.push(app && app.widgets);
    for (const widgets of planes)for (const w of Array.isArray(widgets) ? widgets : []){
        if (!w || !w.id || seen.has(w.id)) continue;
        seen.add(w.id);
        rows.push({
            id: w.id,
            label: w.title || w.id,
            state: panels.includes(w.id) ? 'on' : 'off'
        });
    }
    return rows;
};

});

parcelRegister("bBsgH", function(module, exports) {

$parcel$export(module.exports, "broadcastFromWire", () => $872913eda72db040$export$145059c51cb904d3);
$parcel$export(module.exports, "broadcastReadTime", () => $872913eda72db040$export$4dc032739b0031e4);
$parcel$export(module.exports, "broadcastItemsForView", () => $872913eda72db040$export$e85d2751d37275b3);
$parcel$export(module.exports, "broadcastVisibleItems", () => $872913eda72db040$export$609fddf9baf6fdae);
$parcel$export(module.exports, "broadcastTags", () => $872913eda72db040$export$ca4b8d7dd9510bab);
$parcel$export(module.exports, "broadcastUnreadCount", () => $872913eda72db040$export$f5294b78ca96df04);
$parcel$export(module.exports, "markBroadcastSeen", () => $872913eda72db040$export$e6617da3c51f22a0);
$parcel$export(module.exports, "setBroadcastScope", () => $872913eda72db040$export$3ee11806242e8a8c);
$parcel$export(module.exports, "setBroadcastTag", () => $872913eda72db040$export$1a53301a68800355);
$parcel$export(module.exports, "setBroadcastQuery", () => $872913eda72db040$export$e745b30b76452192);
$parcel$export(module.exports, "broadcastHasActiveFilters", () => $872913eda72db040$export$6314838490a3ee8e);
$parcel$export(module.exports, "clearBroadcastFilters", () => $872913eda72db040$export$ead22fcfaefde759);
$parcel$export(module.exports, "showMoreBroadcastItems", () => $872913eda72db040$export$79801e4000b83276);
$parcel$export(module.exports, "canPublishBroadcast", () => $872913eda72db040$export$f4f5f3f5ad18d13a);
$parcel$export(module.exports, "canEditBroadcast", () => $872913eda72db040$export$47a064f7002bde78);
$parcel$export(module.exports, "openBroadcastDetail", () => $872913eda72db040$export$eea323c21e118e17);
$parcel$export(module.exports, "openBroadcastComposer", () => $872913eda72db040$export$e47498364bab11c4);
$parcel$export(module.exports, "setBroadcastDraft", () => $872913eda72db040$export$f2825a3fc62ca9dc);
$parcel$export(module.exports, "saveBroadcastDraft", () => $872913eda72db040$export$22aa9786a390ebdd);
$parcel$export(module.exports, "toggleBroadcastReaction", () => $872913eda72db040$export$eec69f77a331fe80);
$parcel$export(module.exports, "submitBroadcastDraft", () => $872913eda72db040$export$7112513bcdf8946e);
$parcel$export(module.exports, "confirmDeleteBroadcast", () => $872913eda72db040$export$e02d6964e7b7ac75);
$parcel$export(module.exports, "deleteBroadcast", () => $872913eda72db040$export$2f00ff65580130ca);
// Broadcast — the internal/external newsroom backing /announcements.
//
// Announcements remain the canonical server entity. This module keeps the
// client-side view, authoring draft and optimistic reaction state together so
// the page, home widget and detail window all read one normalized shape.
const $872913eda72db040$var$_audience = (value)=>value === 'external' ? 'external' : 'internal';
const $872913eda72db040$var$_shellMe = (root)=>{
    const email = (root?.currentUserEmail || '').toLowerCase();
    return (root?.people || []).find((person)=>(person.email || '').toLowerCase() === email) || null;
};
const $872913eda72db040$var$_plainText = (body)=>(Array.isArray(body) ? body : [
        body
    ]).map((part)=>String(part || '').trim()).filter(Boolean).join('\n\n');
// Minutes a post takes to read: 200 words a minute, never under one. The
// record stores only this COUNT (`read_time`). `broadcastReadTime` renders
// the sentence around it in the viewer's language, so a post saved on a
// Georgian page does not read Georgian on an English one.
const $872913eda72db040$var$_readMinutes = (body)=>{
    const words = $872913eda72db040$var$_plainText(body).split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(words / 200));
};
const $872913eda72db040$var$_samePost = (post, id)=>String(post?.id) === String(id);
const $872913eda72db040$export$145059c51cb904d3 = function broadcastFromWire(row) {
    if (!row) return null;
    return {
        id: row.id || row._id,
        title: row.title || '',
        author: row.author || '',
        authorAvatar: row.author_avatar || row.authorAvatar || '',
        authorRole: row.author_role || row.authorRole || '',
        date: row.date || '',
        readTime: row.read_time || row.readTime || '',
        // A row with no topic carries the studio's default-topic KEY: the filter
        // rail (broadcastTags) and the news pill (IntranetRows) resolve it through
        // polyglot, and a real topic passes through verbatim.
        tag: row.tag || 'workspace.broadcastStudio.preview.tagDefault',
        cover: row.cover || '',
        excerpt: row.excerpt || '',
        body: Array.isArray(row.body) ? row.body : row.body ? [
            row.body
        ] : [],
        reactions: row.reactions || {},
        audience: $872913eda72db040$var$_audience(row.audience),
        externalUrl: row.external_url || row.externalUrl || ''
    };
};
const $872913eda72db040$export$4dc032739b0031e4 = function broadcastReadTime(post) {
    if (!post || !post.readTime) return '';
    return String(this.call('polyglot', 'workspace.broadcast.readTime')).replace('{count}', String($872913eda72db040$var$_readMinutes(post.body)));
};
const $872913eda72db040$export$e85d2751d37275b3 = function broadcastItemsForView(root) {
    const scope = root?._broadcastScope || 'internal';
    const tag = root?._broadcastTag || 'all';
    const query = (root?._broadcastQuery || '').trim().toLowerCase();
    return (root?.announcements || []).filter((post)=>{
        const audience = $872913eda72db040$var$_audience(post?.audience);
        if (scope !== 'all' && audience !== scope) return false;
        if (tag !== 'all' && String(post?.tag || '').toLowerCase() !== tag) return false;
        if (!query) return true;
        return [
            post?.title,
            post?.excerpt,
            post?.author,
            post?.tag,
            $872913eda72db040$var$_plainText(post?.body)
        ].join(' ').toLowerCase().includes(query);
    }).sort((a, b)=>String(b?.date || '').localeCompare(String(a?.date || '')));
};
const $872913eda72db040$export$609fddf9baf6fdae = function broadcastVisibleItems(root) {
    const limit = Math.max(1, Number(root?._broadcastVisibleCount) || 50);
    return $872913eda72db040$export$e85d2751d37275b3(root).slice(0, limit);
};
const $872913eda72db040$export$ca4b8d7dd9510bab = function broadcastTags(root) {
    const counts = new Map();
    for (const post of root?.announcements || []){
        const tag = String(post?.tag || '').trim() || 'workspace.broadcastStudio.preview.tagDefault';
        const key = tag.toLowerCase();
        counts.set(key, {
            key: key,
            label: tag,
            count: (counts.get(key)?.count || 0) + 1
        });
    }
    return [
        {
            key: 'all',
            label: 'workspace.broadcastStudio.tag.all',
            count: (root?.announcements || []).length
        },
        ...counts.values()
    ];
};
const $872913eda72db040$export$f5294b78ca96df04 = function broadcastUnreadCount(root) {
    const seenAt = Number(root?._broadcastLastSeenAt) || 0;
    return (root?.announcements || []).filter((post)=>{
        const t = post?.date ? new Date(post.date).getTime() : 0;
        return t > seenAt;
    }).length;
};
const $872913eda72db040$export$e6617da3c51f22a0 = function markBroadcastSeen() {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _broadcastLastSeenAt: Date.now()
    }, {
        preventFetch: true
    });
};
const $872913eda72db040$export$3ee11806242e8a8c = function setBroadcastScope(scope) {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _broadcastScope: scope === 'external' || scope === 'all' ? scope : 'internal',
        _broadcastVisibleCount: 50
    });
};
const $872913eda72db040$export$1a53301a68800355 = function setBroadcastTag(tag) {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _broadcastTag: tag || 'all',
        _broadcastVisibleCount: 50
    });
};
const $872913eda72db040$export$e745b30b76452192 = function setBroadcastQuery(query) {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _broadcastQuery: String(query || ''),
        _broadcastVisibleCount: 50
    });
};
const $872913eda72db040$export$6314838490a3ee8e = function broadcastHasActiveFilters(root) {
    return !!String(root?._broadcastQuery || '').trim() || (root?._broadcastTag || 'all') !== 'all';
};
const $872913eda72db040$export$ead22fcfaefde759 = function clearBroadcastFilters() {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _broadcastQuery: '',
        _broadcastTag: 'all',
        _broadcastVisibleCount: 50
    });
};
const $872913eda72db040$export$79801e4000b83276 = function showMoreBroadcastItems() {
    const root = this?.state?.root;
    if (!root) return;
    root.update({
        _broadcastVisibleCount: (Number(root._broadcastVisibleCount) || 50) + 50
    });
};
const $872913eda72db040$export$f4f5f3f5ad18d13a = function canPublishBroadcast(rootArg) {
    const root = rootArg || this?.state?.root;
    if (!root) return false;
    return this.call('hasPermission', root, 'stories.post') || root.org?.role === 'owner' || root.org?.role === 'admin';
};
const $872913eda72db040$export$47a064f7002bde78 = function canEditBroadcast(post, rootArg) {
    const root = rootArg || this?.state?.root;
    if (!root || !post) return false;
    if (this.call('hasPermission', root, 'stories.edit_others')) return true;
    if (!this.call('canPublishBroadcast', root)) return false;
    const me = $872913eda72db040$var$_shellMe(root);
    const meName = (me?.name || '').trim().toLowerCase();
    const meEmail = (root.currentUserEmail || '').trim().toLowerCase();
    const author = (post.author || '').trim().toLowerCase();
    return Boolean(author && (author === meName || author === meEmail));
};
const $872913eda72db040$export$eea323c21e118e17 = function openBroadcastDetail(post) {
    const root = this?.state?.root;
    if (!root || !post) return false;
    root.update({
        selectedAnnouncement: post
    });
    this.call('openModal', {
        id: 'announcement-detail',
        template: 'custom',
        width: 'G1',
        maxHeight: '85vh',
        content: {
            extends: 'AnnouncementDetailModal'
        }
    });
    return true;
};
const $872913eda72db040$export$e47498364bab11c4 = function openBroadcastComposer(post) {
    const root = this?.state?.root;
    if (!root || !post && !this.call('canPublishBroadcast', root)) return;
    if (post && !this.call('canEditBroadcast', post, root)) return;
    root.update({
        _broadcastDraft: post ? {
            id: post.id,
            title: post.title || '',
            excerpt: post.excerpt || '',
            body: $872913eda72db040$var$_plainText(post.body),
            // The topic input shows this value: resolve a stored key to its word.
            tag: this.call('polyglot', post.tag || 'workspace.broadcastStudio.preview.tagDefault'),
            audience: $872913eda72db040$var$_audience(post.audience),
            externalUrl: post.externalUrl || ''
        } : {
            id: null,
            title: '',
            excerpt: '',
            body: '',
            tag: this.call('polyglot', 'workspace.broadcastStudio.preview.tagDefault'),
            audience: root._broadcastScope === 'external' ? 'external' : 'internal',
            externalUrl: ''
        },
        _broadcastSaveError: null
    });
    // A FORM window: the form-modal width every workspace form takes ('I',
    // capped at the viewport by the layer). It was 'G1' — the read card's width
    // — and opened 355 px wide at 1440, its headline field cutting its own
    // placeholder (dev 9b9291d4e, 2026-10-02).
    this.call('openModal', {
        id: 'broadcast-compose',
        template: 'custom',
        width: 'I',
        maxWidth: '90vw',
        maxHeight: '85vh',
        content: {
            extends: 'BroadcastComposerModal'
        }
    });
};
const $872913eda72db040$export$f2825a3fc62ca9dc = function setBroadcastDraft(field, value) {
    const root = this?.state?.root;
    if (!root || !root._broadcastDraft || !field) return;
    root.update({
        _broadcastDraft: {
            ...root._broadcastDraft,
            [field]: String(value || '')
        }
    });
};
const $872913eda72db040$export$22aa9786a390ebdd = async function saveBroadcastDraft(opts) {
    const root = this?.state?.root;
    const sdk = this?.sdk || this?.context?.sdk;
    const draft = root?._broadcastDraft;
    if (!root || !draft || root._broadcastSaving || !sdk?.execute) return false;
    const title = String(draft.title || '').trim();
    const body = String(draft.body || '').split(/\n{2,}/).map((paragraph)=>paragraph.trim()).filter(Boolean);
    const audience = $872913eda72db040$var$_audience(draft.audience);
    let externalUrl = String(draft.externalUrl || '').trim();
    if (!title) {
        root.update({
            _broadcastSaveError: this.call('polyglot', 'workspace.broadcastStudio.error.noTitle')
        });
        return false;
    }
    if (!body.length) {
        root.update({
            _broadcastSaveError: this.call('polyglot', 'workspace.broadcastStudio.error.noBody')
        });
        return false;
    }
    if (audience === 'external' && externalUrl) try {
        externalUrl = new URL(externalUrl.startsWith('http') ? externalUrl : `https://${externalUrl}`).toString();
    } catch (_) {
        root.update({
            _broadcastSaveError: this.call('polyglot', 'workspace.broadcastStudio.error.badUrl')
        });
        return false;
    }
    else if (audience === 'internal') externalUrl = '';
    if (opts && opts.check) {
        if (root._broadcastSaveError) root.update({
            _broadcastSaveError: null
        });
        return true;
    }
    const me = $872913eda72db040$var$_shellMe(root);
    const payload = {
        title: title,
        excerpt: String(draft.excerpt || '').trim() || body[0],
        body: body,
        // Persisted: the WORD the author saw as the topic placeholder, never a
        // key — other surfaces read the stored topic as it is.
        tag: String(draft.tag || '').trim() || this.call('polyglot', 'workspace.broadcastStudio.preview.tagDefault'),
        audience: audience,
        external_url: externalUrl || null,
        author: me?.name || root.currentUserEmail || this.call('polyglot', 'workspace.broadcastStudio.authorFallback'),
        author_avatar: me?.avatar || me?.avatarUrl || null,
        author_role: me?.role || null,
        date: new Date().toISOString().slice(0, 10),
        read_time: String($872913eda72db040$var$_readMinutes(body))
    };
    const write = this.call('sameWorkspaceWriter', root);
    root.update({
        _broadcastSaving: true,
        _broadcastSaveError: null
    });
    try {
        const operation = draft.id ? 'update' : 'create';
        const result = await sdk.execute('workspaceProject.announcements', operation, {
            ...draft.id ? {
                id: draft.id
            } : {},
            payload: payload
        });
        const saved = this.call('broadcastFromWire', result?.announcement || result);
        // A bundle KEY as the message — the catch below resolves it.
        if (!saved?.id) throw new Error('workspace.broadcastStudio.error.noId');
        const exists = (root.announcements || []).some((post)=>$872913eda72db040$var$_samePost(post, saved.id));
        if (!write({
            announcements: exists ? (root.announcements || []).map((post)=>$872913eda72db040$var$_samePost(post, saved.id) ? saved : post) : [
                saved,
                ...root.announcements || []
            ],
            _broadcastSaving: false,
            _broadcastDraft: null
        })) return false;
        this.call('closeModal', 'broadcast-compose');
        return true;
    } catch (err) {
        write({
            _broadcastSaving: false,
            _broadcastSaveError: this.call('polyglot', err?.message || 'workspace.broadcastStudio.error.publishFailed')
        });
        return false;
    }
};
const $872913eda72db040$export$eec69f77a331fe80 = async function toggleBroadcastReaction(id, emoji) {
    const root = this?.state?.root;
    const sdk = this?.sdk || this?.context?.sdk;
    if (!root || !id || !emoji || !sdk?.execute) return false;
    const write = this.call('sameWorkspaceWriter', root);
    const before = root.announcements || [];
    const me = $872913eda72db040$var$_shellMe(root);
    const name = me?.name || root.currentUserEmail || this.call('polyglot', 'workspace.broadcastStudio.reactionYou');
    const optimistic = before.map((post)=>{
        if (!$872913eda72db040$var$_samePost(post, id)) return post;
        const reactions = {
            ...post.reactions || {}
        };
        const next = Array.isArray(reactions[emoji]) ? [
            ...reactions[emoji]
        ] : [];
        const index = next.indexOf(name);
        if (index === -1) next.push(name);
        else next.splice(index, 1);
        if (next.length) reactions[emoji] = next;
        else delete reactions[emoji];
        return {
            ...post,
            reactions: reactions
        };
    });
    root.update({
        announcements: optimistic
    });
    try {
        const result = await sdk.execute('workspaceProject.announcements', 'react', {
            id: id,
            emoji: emoji
        });
        const saved = this.call('broadcastFromWire', result?.announcement || result);
        if (saved?.id) return write({
            announcements: (root.announcements || []).map((post)=>$872913eda72db040$var$_samePost(post, saved.id) ? saved : post)
        });
        return true;
    } catch (err) {
        write({
            announcements: before,
            _broadcastSaveError: err?.message || this.call('polyglot', 'workspace.broadcastStudio.error.reactionFailed')
        });
        return false;
    }
};
const $872913eda72db040$export$7112513bcdf8946e = async function submitBroadcastDraft(onStored) {
    const root = this?.state?.root;
    const draft = root?._broadcastDraft;
    if (!root || !draft || root._broadcastSaving) return false;
    const save = async ()=>{
        const stored = await this.call('saveBroadcastDraft');
        if (stored && typeof onStored === 'function') onStored();
        return stored;
    };
    const external = $872913eda72db040$var$_audience(draft.audience) === 'external';
    if (draft.id) {
        const was = (root.announcements || []).find((post)=>$872913eda72db040$var$_samePost(post, draft.id));
        if (!(external && was && $872913eda72db040$var$_audience(was.audience) !== 'external')) return save();
    }
    if (!await this.call('saveBroadcastDraft', {
        check: true
    })) return false;
    const title = String(draft.title || '').trim();
    this.call('confirmDialog', {
        title: this.call('polyglot', external ? 'workspace.broadcastStudio.publish.titleExternal' : 'workspace.broadcastStudio.publish.titleWorkspace').replace('{title}', ()=>title),
        message: this.call('polyglot', external ? 'workspace.broadcastStudio.composer.externalHint' : 'workspace.broadcastStudio.composer.workspaceHint'),
        confirmText: this.call('polyglot', draft.id ? 'workspace.broadcastStudio.composer.saveChanges' : 'workspace.broadcastStudio.composer.publish'),
        cancelText: this.call('polyglot', 'common.action.cancel'),
        confirmTheme: 'primary',
        // `null` is the explicit opt-out; OMITTING the key takes the template's
        // 'warning' default.
        icon: null,
        onConfirm: save
    });
    return false;
};
const $872913eda72db040$export$e02d6964e7b7ac75 = function confirmDeleteBroadcast(post) {
    const root = this?.state?.root;
    if (!post || !this.call('canEditBroadcast', post, root)) return;
    this.call('confirmDialog', {
        title: this.call('polyglot', 'workspace.broadcastStudio.delete.title'),
        message: this.call('polyglot', 'workspace.broadcastStudio.delete.message'),
        confirmText: this.call('polyglot', 'workspace.broadcastStudio.delete.confirm'),
        cancelText: this.call('polyglot', 'common.action.cancel'),
        // D1 house shape ('danger' is no brand theme: the button had no style).
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>this.call('deleteBroadcast', post.id)
    });
};
const $872913eda72db040$export$2f00ff65580130ca = async function deleteBroadcast(id) {
    const root = this?.state?.root;
    const sdk = this?.sdk || this?.context?.sdk;
    if (!root || !id || !sdk?.execute) return false;
    const write = this.call('sameWorkspaceWriter', root);
    const before = root.announcements || [];
    root.update({
        announcements: before.filter((post)=>!$872913eda72db040$var$_samePost(post, id))
    });
    try {
        await sdk.execute('workspaceProject.announcements', 'remove', {
            id: id
        });
        return true;
    } catch (err) {
        write({
            announcements: before,
            _broadcastSaveError: err?.message || this.call('polyglot', 'workspace.broadcastStudio.error.deleteFailed')
        });
        return false;
    }
};

});

parcelRegister("in9xh", function(module, exports) {

$parcel$export(module.exports, "aiWidgetsFor", () => $d601c59523b8180e$export$194af261b692203f);
$parcel$export(module.exports, "aiWidgetIdsFor", () => $d601c59523b8180e$export$3fa1402c5d22019);
$parcel$export(module.exports, "aiWidgetOwnerLabel", () => $d601c59523b8180e$export$99d4546548c9f484);
$parcel$export(module.exports, "aiWidgetTextStyle", () => $d601c59523b8180e$export$7af982e7787d7333);
$parcel$export(module.exports, "aiWidgetToneInk", () => $d601c59523b8180e$export$9ad81ef596ef8f2f);
$parcel$export(module.exports, "resolveWidgetPath", () => $d601c59523b8180e$export$9ae6b0779789bf09);
$parcel$export(module.exports, "readWidgetField", () => $d601c59523b8180e$export$f0c81f970090e845);
$parcel$export(module.exports, "widgetListItems", () => $d601c59523b8180e$export$70b48435ff1fd6f6);
$parcel$export(module.exports, "widgetListPeak", () => $d601c59523b8180e$export$bbf00f3632f7ff7a);
$parcel$export(module.exports, "formatWidgetValue", () => $d601c59523b8180e$export$ca9a15a4b968747);
$parcel$export(module.exports, "aiWidgetCapability", () => $d601c59523b8180e$export$3f9c00e922c18f28);
$parcel$export(module.exports, "loadAiWidgetData", () => $d601c59523b8180e$export$d69a502e5b75137f);
$parcel$export(module.exports, "normalizeAiWidgetData", () => $d601c59523b8180e$export$5768821e98136016);
$parcel$export(module.exports, "aiWidgetState", () => $d601c59523b8180e$export$a417e4c25a6d4028);
$parcel$export(module.exports, "setAiWidgetVisibility", () => $d601c59523b8180e$export$c91a83932ae00981);
$parcel$export(module.exports, "deleteAiWidgetDef", () => $d601c59523b8180e$export$3cf126499f739ac8);
// aiWidgets.js — the client half of AI-CREATED home widgets (tickets/opus.md
// "Per-workspace AI-CREATED widgets"), the second half of Nika's mandate
// "new apps should be able to have their own widgets from appstore or created
// by user ai". The APP-STORE half is the module-manifest `widgets: []` contract
// (pages/main.js HomeModuleWidget / _adoptModuleWidgets); this plane reuses ALL
// of its hosting mechanics and adds only what a module-less widget needs.
//
// ─── The one hard constraint ─────────────────────────────────────────────────
// An AI-created widget's body is DATA, never CODE. Nothing here — and nothing
// in WidgetRenderer — ever evaluates a stored string: no eval, no Function, no
// `extends` of an author-supplied component key. A body is a fixed vocabulary
// of block types whose fields are PATHS into that widget's own resolved
// dataRecipe result, and the six interpreters live in reviewed code.
//
// The server is the security boundary (server/src/domains/widgets/
// widgetDefSchema.js validates every write, and re-checks the VIEWING user's
// capability on every read). Everything here is the mirror of that contract:
// it re-checks defensively and degrades, but it never grants.
//
// Pure + sync unless noted, and registered as project functions so the
// component reaches them via `el.call('fn', …)` — never a cross-file import,
// and never a module-scope const read from a factory (frank drops those).
// Bare shared-library import, deferred-call style — the shell's function
// modules all reach the shared barrel this way (circular-init safety).

var $7iFOV = parcelRequire("7iFOV");
const $d601c59523b8180e$export$194af261b692203f = (root)=>{
    const rows = Array.isArray(root && root.workspaceAiWidgets) ? root.workspaceAiWidgets : [];
    if (!rows.length) return [];
    const live = root && root.workspace && (root.workspace.id || root.workspace._id) || null;
    return rows.filter((w)=>{
        if (!w || !w.id) return false;
        if (!live || !w.workspaceId) return true;
        return String(w.workspaceId) === String(live);
    });
};
const $d601c59523b8180e$export$3fa1402c5d22019 = (root)=>{
    const ids = new Set();
    for (const w of $d601c59523b8180e$export$194af261b692203f(root))ids.add(w.id);
    return ids;
};
const $d601c59523b8180e$export$99d4546548c9f484 = (widget)=>{
    if (!widget || !widget.aiGenerated) return '';
    const who = widget.createdByName;
    return who ? `AI \xb7 ${who}` : 'AI';
};
// ─── Data binding ────────────────────────────────────────────────────────────
// Segments that could reach the prototype chain. The server's path regex
// already rejects these on write; re-checked here so a row written before a
// future schema change (or hand-inserted into the collection) still cannot
// walk out of its own data.
const $d601c59523b8180e$var$FORBIDDEN_SEGMENTS = [
    '__proto__',
    'prototype',
    'constructor'
];
const $d601c59523b8180e$export$7af982e7787d7333 = (block)=>{
    const b = block && typeof block === 'object' ? block : {};
    if (b.type !== 'text-block') return 'body';
    const style = b.textStyle != null ? b.textStyle : b.tone;
    return style === 'caption' ? 'caption' : 'body';
};
const $d601c59523b8180e$export$9ad81ef596ef8f2f = (tone)=>({
        good: 'successInk',
        warning: 'warningInk',
        critical: 'dangerInk'
    })[tone] || null;
const $d601c59523b8180e$export$9ae6b0779789bf09 = (data, path)=>{
    if (data == null || typeof path !== 'string' || !path) return undefined;
    const segments = path.split(/[.[\]]+/).filter(Boolean);
    let cursor = data;
    for (const segment of segments){
        if (cursor == null || typeof cursor !== 'object') return undefined;
        if ($d601c59523b8180e$var$FORBIDDEN_SEGMENTS.indexOf(segment) !== -1) return undefined;
        if (!Object.prototype.hasOwnProperty.call(cursor, segment)) return undefined;
        cursor = cursor[segment];
    }
    return cursor;
};
const $d601c59523b8180e$export$f0c81f970090e845 = (item, field)=>{
    if (!item || typeof item !== 'object' || typeof field !== 'string' || !field) return undefined;
    if ($d601c59523b8180e$var$FORBIDDEN_SEGMENTS.indexOf(field) !== -1) return undefined;
    if (!Object.prototype.hasOwnProperty.call(item, field)) return undefined;
    return item[field];
};
const $d601c59523b8180e$export$70b48435ff1fd6f6 = (data, block)=>{
    if (!block) return [];
    const raw = $d601c59523b8180e$export$9ae6b0779789bf09(data, block.itemsPath);
    const rows = Array.isArray(raw) ? raw : [];
    const limit = Math.min(Math.max(Number(block.limit) || 5, 1), 20);
    const labelField = block.labelField || block.titleField || 'name';
    const valueField = block.valueField || 'value';
    const metaField = block.metaField || null;
    return rows.slice(0, limit).map((row, i)=>{
        const label = $d601c59523b8180e$export$f0c81f970090e845(row, labelField);
        const value = $d601c59523b8180e$export$f0c81f970090e845(row, valueField);
        const meta = metaField ? $d601c59523b8180e$export$f0c81f970090e845(row, metaField) : undefined;
        return {
            key: `${i}`,
            label: label == null ? "\u2014" : String(label),
            value: typeof value === 'number' ? value : Number(value) || 0,
            rawValue: value,
            meta: meta == null ? '' : String(meta)
        };
    });
};
const $d601c59523b8180e$export$bbf00f3632f7ff7a = (items)=>{
    let peak = 0;
    for (const item of Array.isArray(items) ? items : [])if (item && item.value > peak) peak = item.value;
    return peak;
};
const $d601c59523b8180e$export$ca9a15a4b968747 = (value, format, opts)=>{
    const options = opts || {};
    if (value == null || value === '') return "\u2014";
    const prefix = options.prefix || '';
    const suffix = options.suffix || '';
    if (format === 'text' || typeof value === 'boolean') return `${prefix}${value}${suffix}`;
    const num = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(num)) return `${prefix}${value}${suffix}`;
    if (format === 'percent') return `${prefix}${Math.round(num * (Math.abs(num) <= 1 ? 100 : 1))}%${suffix}`;
    if (format === 'currency') return `${prefix}${num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    })}${suffix}`;
    return `${prefix}${num.toLocaleString()}${suffix}`;
};
function $d601c59523b8180e$export$3f9c00e922c18f28(widget, fetchState) {
    const stamped = widget && widget.viewerCapability;
    const stampedAllowed = !!(stamped && stamped.allowed === true);
    const denied = fetchState && fetchState.denied;
    const allowed = stampedAllowed && !denied;
    const reason = denied ? 'denied_at_read' : stamped && stamped.reason || 'unknown';
    return {
        allowed: allowed,
        reason: reason,
        notice: allowed ? '' : reason === 'unknown_source' ? (0, $7iFOV.shellSay)(this, 'workspace.aiWidget.notice.sourceGone') : (0, $7iFOV.shellSay)(this, 'workspace.aiWidget.notice.noAccess')
    };
}
const $d601c59523b8180e$export$d69a502e5b75137f = async (root, sdk, widget)=>{
    if (!root || !sdk || !widget || !widget.id) return;
    const recipe = widget.dataRecipe;
    if (!recipe || !recipe.from) return;
    const stamped = widget.viewerCapability;
    // Never spend a request on a widget the server already told this viewer they
    // cannot read.
    if (!stamped || stamped.allowed !== true) return;
    const wsId = root.workspace && (root.workspace.id || root.workspace._id) || null;
    const bag = root._aiWidgetData || {};
    const current = bag[widget.id];
    const sig = `${wsId || ''}/${widget.updatedAt || ''}`;
    if (current && current.sig === sig && (current.loading || current.settled)) return;
    const write = (patch)=>{
        const next = {
            ...root._aiWidgetData || {}
        };
        next[widget.id] = {
            ...next[widget.id] || {},
            sig: sig,
            ...patch
        };
        root.update({
            _aiWidgetData: next
        }, {
            preventFetch: true
        });
    };
    write({
        loading: true,
        settled: false,
        denied: false,
        error: null
    });
    try {
        const params = {
            ...recipe.params || {},
            ...wsId ? {
                workspaceId: wsId
            } : {}
        };
        const data = await sdk.execute(recipe.from, recipe.method || 'list', params);
        write({
            loading: false,
            settled: true,
            data: $d601c59523b8180e$export$5768821e98136016(data)
        });
    } catch (err) {
        const message = err && err.message || String(err);
        const denied = /forbidden|not granted|403|permission/i.test(message);
        write({
            loading: false,
            settled: true,
            denied: denied,
            error: message
        });
    }
};
const $d601c59523b8180e$export$5768821e98136016 = (data)=>{
    if (Array.isArray(data)) return {
        records: data,
        rows: data,
        count: data.length
    };
    if (data && typeof data === 'object') {
        const rows = Array.isArray(data.records) ? data.records : Array.isArray(data.rows) ? data.rows : Array.isArray(data.data) ? data.data : [];
        return {
            ...data,
            records: rows,
            rows: rows,
            count: typeof data.count === 'number' ? data.count : rows.length
        };
    }
    return {
        records: [],
        rows: [],
        count: 0,
        value: data
    };
};
const $d601c59523b8180e$export$a417e4c25a6d4028 = (root, id)=>root && root._aiWidgetData && root._aiWidgetData[id] || {};
const $d601c59523b8180e$export$c91a83932ae00981 = async (root, sdk, widget, visibility)=>{
    if (!root || !sdk || !widget || !widget.id) return {
        ok: false
    };
    const wsId = root.workspace && (root.workspace.id || root.workspace._id) || null;
    try {
        const fresh = await sdk.execute('workspaceProject.widgetDefs', 'update', {
            id: widget.id,
            widget: {
                visibility: visibility
            },
            ...wsId ? {
                workspaceId: wsId
            } : {}
        });
        const rows = Array.isArray(root.workspaceAiWidgets) ? root.workspaceAiWidgets : [];
        root.update({
            workspaceAiWidgets: rows.map((w)=>w && w.id === widget.id ? fresh : w)
        }, {
            preventFetch: true
        });
        return {
            ok: true,
            widget: fresh
        };
    } catch (err) {
        return {
            ok: false,
            error: err && err.message || String(err)
        };
    }
};
const $d601c59523b8180e$export$3cf126499f739ac8 = async (root, sdk, widget)=>{
    if (!root || !sdk || !widget || !widget.id) return {
        ok: false
    };
    const wsId = root.workspace && (root.workspace.id || root.workspace._id) || null;
    try {
        await sdk.execute('workspaceProject.widgetDefs', 'remove', {
            id: widget.id,
            ...wsId ? {
                workspaceId: wsId
            } : {}
        });
        const rows = Array.isArray(root.workspaceAiWidgets) ? root.workspaceAiWidgets : [];
        root.update({
            workspaceAiWidgets: rows.filter((w)=>!(w && w.id === widget.id))
        }, {
            preventFetch: true
        });
        return {
            ok: true
        };
    } catch (err) {
        return {
            ok: false,
            error: err && err.message || String(err)
        };
    }
};

});

parcelRegister("l7TnK", function(module, exports) {

$parcel$export(module.exports, "STARTER_MAX", () => $f6153627fa45e902$export$93e34f64c2bc1d72);
$parcel$export(module.exports, "STARTER_TTL_MS", () => $f6153627fa45e902$export$f8eca4e3b025553b);
$parcel$export(module.exports, "STARTER_FAIL_BACKOFF_MS", () => $f6153627fa45e902$export$e99e68ce9fc2ccfb);
$parcel$export(module.exports, "STARTER_SETTLE_MS", () => $f6153627fa45e902$export$3a952f5f53c4f7f7);
$parcel$export(module.exports, "STARTER_CACHE_KEY", () => $f6153627fa45e902$export$ee4bd14a70bfc66f);
$parcel$export(module.exports, "STARTER_CACHE_VERSION", () => $f6153627fa45e902$export$6630624df614f26d);
$parcel$export(module.exports, "STARTER_CACHE_MAX_WORKSPACES", () => $f6153627fa45e902$export$b40fbec0c225796a);
$parcel$export(module.exports, "STARTER_MODULE_MAX", () => $f6153627fa45e902$export$dc62cc8e734b11fc);
$parcel$export(module.exports, "STARTER_TEXT_MAX", () => $f6153627fa45e902$export$640bc489c9387e19);
$parcel$export(module.exports, "STARTER_SNAPSHOT_MAX_CHARS", () => $f6153627fa45e902$export$cba8d7e5813f4eb0);
$parcel$export(module.exports, "STARTER_PURPOSE", () => $f6153627fa45e902$export$7604b580bb7f1213);
$parcel$export(module.exports, "BUILTIN_STARTERS", () => $f6153627fa45e902$export$d4bdc6af9036edae);
$parcel$export(module.exports, "STARTER_LANGUAGE_RULES", () => $f6153627fa45e902$export$15f30766ded058c3);
$parcel$export(module.exports, "starterHash", () => $f6153627fa45e902$export$e3acfaf253341055);
$parcel$export(module.exports, "starterWorkspaceId", () => $f6153627fa45e902$export$ca6fc1004b9ce6b2);
$parcel$export(module.exports, "visibleStarterTiles", () => $f6153627fa45e902$export$aa9c0f581bf69119);
$parcel$export(module.exports, "moduleStarters", () => $f6153627fa45e902$export$415cfd50b999ca96);
$parcel$export(module.exports, "starterSignature", () => $f6153627fa45e902$export$2e168f69989613e7);
$parcel$export(module.exports, "readStarterCache", () => $f6153627fa45e902$export$bedf5976dde1a8a3);
$parcel$export(module.exports, "starterCacheFresh", () => $f6153627fa45e902$export$2792964839370a92);
$parcel$export(module.exports, "trimStarterCache", () => $f6153627fa45e902$export$dae06a3ac5733749);
$parcel$export(module.exports, "starterSnapshot", () => $f6153627fa45e902$export$a22347f8ddde3200);
$parcel$export(module.exports, "starterSystemPrompt", () => $f6153627fa45e902$export$706f2a13606f0a92);
$parcel$export(module.exports, "starterUserMessage", () => $f6153627fa45e902$export$4549129f3b9623f9);
$parcel$export(module.exports, "completionText", () => $f6153627fa45e902$export$3ea4c15e263a0c0f);
$parcel$export(module.exports, "parseStarterReply", () => $f6153627fa45e902$export$4b9a580a78b78fd5);
$parcel$export(module.exports, "starterCaption", () => $f6153627fa45e902$export$8bf5f65b7c4d5e83);
$parcel$export(module.exports, "generatedStarterRows", () => $f6153627fa45e902$export$9b75372dfe52d334);
$parcel$export(module.exports, "builtStarterRows", () => $f6153627fa45e902$export$19b61b633015b7f3);
$parcel$export(module.exports, "workspaceStarters", () => $f6153627fa45e902$export$16fa8d6a8242bc4e);
$parcel$export(module.exports, "ensureWorkspaceStarters", () => $f6153627fa45e902$export$6ab8a9a72a88a4c2);
// assistantStarters.js — the assistant's STARTER PROMPTS, per workspace.
//
// Nika 2026-09-10: "instead of 'ask anything about symbols' say 'ask anything
// about {workspace}', and make those options smart and more beautiful per
// workspace — not static or generic — generated on workspace use."
//
// Before this the drawer's empty state listed four English brochure lines
// ("What is Symbols?") plus every installed app's manifest starters in
// whatever language their author wrote (live on /w/gita/default: 16 chips,
// English and Georgian mixed, in a two-column grid that wrapped ragged).
//
// Two layers, ONE seam — `workspaceStarters(root)`, reached from the shared
// Chat.js Empty slot as `el.call('workspaceStarters', root)`:
//
//   1. BUILT — deterministic, instant, offline. One prompt per app the
//      workspace actually shows (the launcher's own visibility law:
//      searchAppGroupsFor → navItemVisible, so a flagged-off Mail never
//      offers a Mail prompt), the installed apps' own manifest starters
//      first, and one generic staple last. Every row carries the app's glyph
//      and name, so the list already reads as THIS workspace's.
//   2. GENERATED — on first use of the assistant in a workspace
//      (`ensureWorkspaceStarters`, fired by the Empty slot's onCreate and
//      re-armed by its render), a compact snapshot of the workspace — name,
//      language, the industry its Workspace Preset names (when one was
//      applied), the apps it shows, its team (a count and positions, never a
//      person's name, handle or email), the records already loaded, the apps'
//      own starters — goes to the AI through `sdk.ai.completion`
//      (the route the ticket modal's field synthesis already uses) under the
//      server purpose STARTER_PURPOSE (no tools, billed to no one), which
//      writes six prompts IN THE WORKSPACE LANGUAGE, grounded in that
//      snapshot. The set is cached in the member's preferences row
//      (`user_preferences.assistant_starters[workspaceId]`, beside
//      `navbar_tabs`) and regenerated when the app set, the language or a
//      week changes — so the list follows the workspace as it grows, and no
//      one pays a model call per open.
//
// The generated layer never blocks and never shifts layout: the built set
// paints first; the generated set replaces it when it lands (Rule 66 — the
// drawer's Sub line reports the wait, nothing spins). A failed generation
// leaves the built set in place and backs off for the session.
//
// Cache row shape (versioned; a shape change bumps STARTER_CACHE_VERSION and
// every older row simply reads as stale):
//   assistant_starters: { [workspaceId]: { v, lang, hash, at, items: [{ text, app }], rule? } }
//   v    — 2 since 2026-10-30. A v1 set could NAME another member: the
//          snapshot sent each member's name (the handle or the email when they
//          had no display name) and the prompt asked for members by name — on
//          dev a Harbor Homes member read "Check all pending tasks for <another
//          member's handle>". v2 sets come from a snapshot with no person in it
//          and pass the person filter before the write; the bump makes every
//          v1 set stale, so each member regenerates once.
//   rule — starterHash of the language's STARTER_LANGUAGE_RULES entry, when it has one.
//   hash — starterSignature(root): the visible app routes + installed app ids
//          + the manifest starter count. The team and the loaded records are in
//          the SNAPSHOT (they ground the prompts) but not in the hash — they
//          land asynchronously after boot and would make every first open
//          generate twice.

var $1X0Je = parcelRequire("1X0Je");

var $D8RKl = parcelRequire("D8RKl");

var $g7CNh = parcelRequire("g7CNh");
// Deferred reads (barrel-init cycle — see pageContext.js's identical note):
// the shared barrel's default export is still undefined while this module
// evaluates, so nothing here destructures it at module scope.
const $f6153627fa45e902$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $f6153627fa45e902$var$scopeNameOf = (root)=>{
    const fn = (0, $1X0Je.default).functions && (0, $1X0Je.default).functions.assistantScopeName;
    return typeof fn === 'function' ? fn(root) : '';
};
const $f6153627fa45e902$export$93e34f64c2bc1d72 = 6;
const $f6153627fa45e902$export$f8eca4e3b025553b = 604800000;
const $f6153627fa45e902$export$e99e68ce9fc2ccfb = 600000;
const $f6153627fa45e902$export$3a952f5f53c4f7f7 = 1500;
const $f6153627fa45e902$export$ee4bd14a70bfc66f = 'assistant_starters';
const $f6153627fa45e902$export$6630624df614f26d = 2;
const $f6153627fa45e902$export$b40fbec0c225796a = 8;
const $f6153627fa45e902$export$dc62cc8e734b11fc = 2;
const $f6153627fa45e902$export$640bc489c9387e19 = 90;
const $f6153627fa45e902$export$cba8d7e5813f4eb0 = 6000;
const $f6153627fa45e902$export$7604b580bb7f1213 = 'workspace.starters';
const $f6153627fa45e902$export$d4bdc6af9036edae = [
    {
        route: '/tasks',
        labelKey: 'workspace.aiSuggest.tasks.blocked',
        promptKey: 'workspace.aiSuggest.tasks.blockedPrompt'
    },
    {
        route: '/calendar',
        labelKey: 'workspace.aiSuggest.calendar.agenda',
        promptKey: 'workspace.aiSuggest.calendar.agendaPrompt'
    },
    {
        route: '/mail',
        labelKey: 'workspace.aiStarter.mail.unread',
        promptKey: 'workspace.aiStarter.mail.unreadPrompt'
    },
    {
        route: '/chat',
        labelKey: 'workspace.aiStarter.chat.missed',
        promptKey: 'workspace.aiStarter.chat.missedPrompt'
    },
    {
        route: '/notes',
        labelKey: 'workspace.aiStarter.notes.recent',
        promptKey: 'workspace.aiStarter.notes.recentPrompt'
    },
    {
        route: '/files',
        labelKey: 'workspace.aiStarter.files.recent',
        promptKey: 'workspace.aiStarter.files.recentPrompt'
    },
    {
        route: '/meet',
        labelKey: 'workspace.aiStarter.meet.last',
        promptKey: 'workspace.aiStarter.meet.lastPrompt'
    },
    {
        route: '/infra',
        labelKey: 'workspace.aiStarter.infra.status',
        promptKey: 'workspace.aiStarter.infra.statusPrompt'
    },
    {
        route: '/team-members',
        labelKey: 'workspace.aiStarter.people.who',
        promptKey: 'workspace.aiStarter.people.whoPrompt'
    },
    {
        route: '/studio',
        labelKey: 'workspace.aiStarter.apps.installed',
        promptKey: 'workspace.aiStarter.apps.installedPrompt'
    }
];
const $f6153627fa45e902$var$GENERIC_STARTER = {
    labelKey: 'workspace.aiSuggest.generic.myPlate',
    promptKey: 'workspace.aiSuggest.generic.myPlatePrompt'
};
// The customer's own app tiles (a takeover module's apps, an installed app's
// launcher tile) ship no prompt of their own — this pair, with the app's name
// in place of {app}, gives each one a grounded ask.
const $f6153627fa45e902$var$CUSTOM_APP_STARTER = {
    labelKey: 'workspace.aiStarter.app.whatsNew',
    promptKey: 'workspace.aiStarter.app.whatsNewPrompt'
};
// Collections the shell loads onto root for its built-in apps; a module's
// own collections come from `workspaceProject.stateKeys`.
const $f6153627fa45e902$var$ROOT_RECORD_KEYS = [
    'tickets',
    'events',
    'documents',
    'notes',
    'channels',
    'fileNodes'
];
const $f6153627fa45e902$var$LANGUAGE_NAMES = {
    en: 'English',
    ka: 'Georgian'
};
const $f6153627fa45e902$export$15f30766ded058c3 = {
    ka: '- Write every Georgian "text" in the polite plural (\u10D7\u10E5\u10D5\u10D4\u10DC) register: a request uses the -\u10D7 imperative (\u10E8\u10D4\u10D0\u10EF\u10D0\u10DB\u10D4\u10D7, \u10E9\u10D0\u10DB\u10DD\u10DB\u10D8\u10D7\u10D5\u10D0\u10DA\u10D4\u10D7, \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D7), never the informal singular (\u10E8\u10D4\u10D0\u10EF\u10D0\u10DB\u10D4, \u10DB\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4).'
};
const $f6153627fa45e902$var$str = (v)=>v == null ? '' : String(v);
const $f6153627fa45e902$var$titleOf = (rec)=>rec && typeof rec === 'object' ? $f6153627fa45e902$var$str(rec.title || rec.name || rec.label || rec.subject || rec.displayName) : $f6153627fa45e902$var$str(rec);
// The INDUSTRY this workspace was set up for: the key of the Workspace Preset
// the server applied (`settings.preset.key`, written by the preset apply — see
// marketplace/functions/workspacePresets.js workspacePresetApplied). The key is
// DATA, never copy: the generator reads it and writes the prompts in the
// workspace language, so no industry's words live in code. `custom` is "Something
// else" (a blueprint with no industry), not an industry. '' when no preset is
// recorded (a workspace made by hand, or a record that carries no settings).
const $f6153627fa45e902$var$industryOf = (root)=>{
    const settings = root && root.workspace && root.workspace.settings;
    const preset = settings && typeof settings === 'object' ? settings.preset : null;
    const key = preset && typeof preset === 'object' ? $f6153627fa45e902$var$str(preset.key).trim() : '';
    return key && key !== 'custom' ? key : '';
};
const $f6153627fa45e902$export$e3acfaf253341055 = (input)=>{
    const t = $f6153627fa45e902$var$str(input);
    let h = 5381;
    for(let i = 0; i < t.length; i++)h = (h << 5) + h + t.charCodeAt(i) | 0;
    return (h >>> 0).toString(36);
};
// The hash of a language's register rule, '' when it has none.
const $f6153627fa45e902$var$starterRuleOf = (lang)=>{
    const rule = $f6153627fa45e902$export$15f30766ded058c3[$f6153627fa45e902$var$str(lang)];
    return rule ? $f6153627fa45e902$export$e3acfaf253341055(rule) : '';
};
const $f6153627fa45e902$export$ca6fc1004b9ce6b2 = (root)=>{
    if (!root || typeof root !== 'object') return null;
    const ws = root.workspace;
    const id = ws && (ws.id || ws._id) || root.jwtClaims && root.jwtClaims.active_workspace_id;
    return id ? String(id) : null;
};
const $f6153627fa45e902$export$aa9c0f581bf69119 = (root)=>{
    let groups = [];
    try {
        groups = (0, $D8RKl.searchAppGroupsFor)(root) || [];
    } catch (_) {
        groups = [];
    }
    const out = [];
    const seen = new Set();
    for (const g of groups){
        if (!g || g.key === 'admin') continue;
        for (const a of g.apps || []){
            const route = $f6153627fa45e902$var$str(a && a.route);
            if (!route || seen.has(route)) continue;
            seen.add(route);
            out.push({
                route: route,
                title: $f6153627fa45e902$var$str(a.title),
                icon: $f6153627fa45e902$var$str(a.icon) || 'blocks',
                custom: g.key === 'workspace-apps',
                ...a.appKey ? {
                    appKey: $f6153627fa45e902$var$str(a.appKey)
                } : {},
                ...a.projectId ? {
                    projectId: $f6153627fa45e902$var$str(a.projectId)
                } : {}
            });
        }
    }
    return out;
};
// The tiles as the member READS them: an installed app's tile (it carries
// `appKey`) by its App Store name, through installedAppName — Nika
// 2026-10-23: "app names = what a person sees in the workspace App Store".
// marcus's 390 px walk (2026-10-24) read a home suggestion captioned
// "Analytics" — bi-app's manifest tile — where the App Store says Insights.
// The rows below, the generator's snapshot and the model's `app` match all
// read this one title. A house tile's key and a customer's own words stay as
// they are (the builders resolve them through polyglot); with no element (a
// direct import call) every tile stays as it is.
const $f6153627fa45e902$var$namedStarterTiles = (el, tiles)=>tiles.map((t)=>{
        if (!t.appKey || !el || typeof el.call !== 'function') return t;
        const name = el.call('installedAppName', {
            appKey: t.appKey,
            title: t.title
        });
        return typeof name === 'string' && name ? {
            ...t,
            title: name
        } : t;
    });
const $f6153627fa45e902$export$415cfd50b999ca96 = (root)=>{
    const list = root && root.workspaceProject && root.workspaceProject.chatStarters;
    if (!Array.isArray(list)) return [];
    const out = [];
    for (const it of list){
        if (typeof it === 'string') {
            const t = it.trim();
            if (t) out.push({
                text: t
            });
        } else if (it && typeof it === 'object' && typeof it.text === 'string' && it.text.trim()) {
            // A starter that names the app's OWN FORM (`form: '<form id>'`) opens
            // it locally (assistantAppForms.js assistantStarterForm) — no page, no
            // assistant turn (boards-r1 follow-up b).
            const formId = typeof it.form === 'string' && /^[a-z0-9-]+$/.test(it.form) ? it.form : '';
            const appId = $f6153627fa45e902$var$str(it.app || root.workspaceProject.id).trim();
            if (formId && appId) {
                out.push({
                    text: it.text.trim(),
                    localAction: 'assistantStarterForm',
                    form: appId + '.' + formId
                });
                continue;
            }
            out.push({
                text: it.text.trim(),
                localAction: typeof it.localAction === 'string' ? it.localAction : undefined
            });
        }
    }
    return out;
};
const $f6153627fa45e902$export$2e168f69989613e7 = (root, tiles)=>{
    const t = tiles || $f6153627fa45e902$export$aa9c0f581bf69119(root);
    const routes = t.map((x)=>x.route).sort();
    const apps = (Array.isArray(root && root.workspaceApps) ? root.workspaceApps : []).map((a)=>$f6153627fa45e902$var$str(a && (a.id || a.appId))).filter(Boolean).sort();
    return $f6153627fa45e902$export$e3acfaf253341055(JSON.stringify({
        routes: routes,
        apps: apps,
        m: $f6153627fa45e902$export$415cfd50b999ca96(root).length
    }));
};
const $f6153627fa45e902$export$bedf5976dde1a8a3 = (root, wsId)=>{
    const prefs = root && root.userPrefs;
    const all = prefs && typeof prefs === 'object' ? prefs[$f6153627fa45e902$export$ee4bd14a70bfc66f] : null;
    const entry = all && typeof all === 'object' && wsId ? all[wsId] : null;
    return entry && typeof entry === 'object' ? entry : null;
};
const $f6153627fa45e902$export$2792964839370a92 = (entry, { lang: lang, hash: hash, now: now })=>!!entry && entry.v === $f6153627fa45e902$export$6630624df614f26d && entry.lang === lang && entry.hash === hash && $f6153627fa45e902$var$str(entry.rule) === $f6153627fa45e902$var$starterRuleOf(lang) && Array.isArray(entry.items) && entry.items.length > 0 && typeof entry.at === 'number' && now - entry.at >= 0 && now - entry.at < $f6153627fa45e902$export$f8eca4e3b025553b;
const $f6153627fa45e902$export$dae06a3ac5733749 = (all)=>{
    const src = all && typeof all === 'object' ? all : {};
    const ids = Object.keys(src).filter((id)=>src[id] && typeof src[id] === 'object').sort((a, b)=>(src[b].at || 0) - (src[a].at || 0)).slice(0, $f6153627fa45e902$export$b40fbec0c225796a);
    const kept = {};
    for (const id of ids)kept[id] = src[id];
    return kept;
};
// ── No person in a starter (2026-10-30) ─────────────────────────────────────
// A generated tile named another member by handle (dev, Harbor Homes: "Check
// all pending tasks for <handle>"; a public walkthrough video showed it). The
// snapshot sent each member's name (the handle or the email when they had no
// display name) and the prompt asked the model to name members. Now the
// snapshot holds no person and no email address, the prompt forbids naming a
// person, and a generated item that names one never reaches the cache.
// True when the text holds an email address.
const $f6153627fa45e902$var$starterHasEmail = (text)=>/[^\s@]+@[^\s@]+\.[^\s@]+/.test($f6153627fa45e902$var$str(text));
// One email gate over everything the snapshot carries: a list drops a string
// that holds an address, a single field reads ''.
const $f6153627fa45e902$var$starterWithoutEmails = (v)=>{
    if (typeof v === 'string') return $f6153627fa45e902$var$starterHasEmail(v) ? '' : v;
    if (Array.isArray(v)) return v.filter((x)=>typeof x !== 'string' || !$f6153627fa45e902$var$starterHasEmail(x)).map($f6153627fa45e902$var$starterWithoutEmails);
    if (v && typeof v === 'object') {
        const out = {};
        for (const k of Object.keys(v))out[k] = $f6153627fa45e902$var$starterWithoutEmails(v[k]);
        return out;
    }
    return v;
};
// The team as the generator sees it: the positions its members hold
// (`position`, else `title`, else `role`) — unique, non-empty, at most five.
// Never a name, a handle or an email address.
const $f6153627fa45e902$var$starterPositions = (people)=>{
    const out = [];
    const seen = new Set();
    for (const p of people){
        const pos = $f6153627fa45e902$var$str(p && (p.position || p.title || p.role)).trim();
        const k = pos.toLowerCase();
        if (!pos || $f6153627fa45e902$var$starterHasEmail(pos) || seen.has(k)) continue;
        seen.add(k);
        out.push(pos);
        if (out.length >= 5) break;
    }
    return out;
};
// The words that identify a member of THIS workspace: name, full name,
// username or handle, email and the email's local part — lower-case, 3+
// characters (a shorter one matches ordinary words). Read locally from
// root.peopleAll for the person filter; they never go to the model.
const $f6153627fa45e902$var$starterMemberIds = (people)=>{
    const ids = new Set();
    for (const p of Array.isArray(people) ? people : []){
        if (!p || typeof p !== 'object') continue;
        for (const v of [
            p.name,
            p.fullName,
            p.username,
            p.handle,
            p.email
        ]){
            if (typeof v !== 'string') continue;
            const id = v.trim().replace(/^@+/, '').toLowerCase();
            for (const w of id.includes('@') ? [
                id,
                id.split('@')[0]
            ] : [
                id
            ])if (w.length >= 3) ids.add(w);
        }
    }
    return [
        ...ids
    ];
};
// True when the text names one of the ids as a whole word, in any case: a
// letter, a digit or an underscore next to the match makes it part of a
// longer word, not the id.
const $f6153627fa45e902$var$starterNamesMember = (text, ids)=>{
    const hay = $f6153627fa45e902$var$str(text).toLowerCase();
    const wordChar = (c)=>!!c && /[\p{L}\p{N}_]/u.test(c);
    for (const id of ids)for(let at = hay.indexOf(id); at !== -1; at = hay.indexOf(id, at + 1)){
        if (!wordChar(hay[at - 1]) && !wordChar(hay[at + id.length])) return true;
    }
    return false;
};
// The person filter, before the cache write (defense in depth — the model
// never saw a name, but a record title can carry one): an item that holds an
// email address or names a member of this workspace is dropped. The rest is
// kept as it is, never padded.
const $f6153627fa45e902$var$starterItemsWithoutPeople = (items, people)=>{
    const ids = $f6153627fa45e902$var$starterMemberIds(people);
    return items.filter((it)=>!$f6153627fa45e902$var$starterHasEmail(it.text) && !$f6153627fa45e902$var$starterNamesMember(it.text, ids));
};
const $f6153627fa45e902$export$a22347f8ddde3200 = (root, { resolve: resolve, tiles: tiles, now: now } = {})=>{
    const r = root && typeof root === 'object' ? root : {};
    const res = typeof resolve === 'function' ? resolve : (k)=>k;
    const t = tiles || $f6153627fa45e902$export$aa9c0f581bf69119(r);
    const ws = r.workspace || {};
    const org = r.org || {};
    const people = Array.isArray(r.peopleAll) ? r.peopleAll : [];
    const stateKeys = r.workspaceProject && Array.isArray(r.workspaceProject.stateKeys) ? r.workspaceProject.stateKeys : [];
    const records = [];
    const seenKeys = new Set();
    for (const key of [
        ...$f6153627fa45e902$var$ROOT_RECORD_KEYS,
        ...stateKeys
    ]){
        if (!key || seenKeys.has(key)) continue;
        seenKeys.add(key);
        const list = r[key];
        if (!Array.isArray(list) || !list.length) continue;
        records.push({
            key: key,
            count: list.length,
            sample: list.slice(0, 3).map($f6153627fa45e902$var$titleOf).filter(Boolean)
        });
        if (records.length >= 12) break;
    }
    const snap = $f6153627fa45e902$var$starterWithoutEmails({
        workspace: $f6153627fa45e902$var$scopeNameOf(r) || $f6153627fa45e902$var$str(ws.displayName || ws.name),
        slug: $f6153627fa45e902$var$str(ws.slug),
        organization: $f6153627fa45e902$var$str(org.name),
        ...$f6153627fa45e902$var$industryOf(r) ? {
            industry: $f6153627fa45e902$var$industryOf(r)
        } : {},
        language: $f6153627fa45e902$var$str(r.lang) || 'en',
        date: new Date(typeof now === 'number' ? now : Date.now()).toISOString().slice(0, 10),
        members: {
            count: people.length,
            positions: $f6153627fa45e902$var$starterPositions(people)
        },
        apps: t.slice(0, 24).map((x)=>({
                route: x.route,
                title: $f6153627fa45e902$var$str(res(x.title))
            })),
        // Through the bundle, like the built set's rows: a manifest starter may
        // be a KEY the app ships (Storm: { text: 'valStarterAttention', route })
        // — sent raw, the generator read 'valStarterAttention' as a prompt.
        appStarters: $f6153627fa45e902$export$415cfd50b999ca96(r).slice(0, 12).map((s)=>$f6153627fa45e902$var$str(res(s.text)) || s.text),
        records: records
    });
    const size = ()=>JSON.stringify(snap).length;
    if (size() > $f6153627fa45e902$export$cba8d7e5813f4eb0) for (const rec of snap.records)delete rec.sample;
    if (size() > $f6153627fa45e902$export$cba8d7e5813f4eb0) snap.appStarters = [];
    if (size() > $f6153627fa45e902$export$cba8d7e5813f4eb0) snap.members.positions = [];
    if (size() > $f6153627fa45e902$export$cba8d7e5813f4eb0) snap.apps = snap.apps.slice(0, 12);
    return snap;
};
const $f6153627fa45e902$export$706f2a13606f0a92 = (lang)=>{
    const code = $f6153627fa45e902$var$str(lang) || 'en';
    const name = $f6153627fa45e902$var$LANGUAGE_NAMES[code] || code;
    return [
        'You write starter prompts for the AI assistant of a team workspace.',
        `Reply with ONLY a JSON array of exactly ${$f6153627fa45e902$export$93e34f64c2bc1d72} objects, each {"text": string, "app": string|null}. No prose, no markdown, no code fence.`,
        'Rules:',
        `- Write every "text" in ${name} (language code "${code}").`,
        ...$f6153627fa45e902$export$15f30766ded058c3[code] ? [
            $f6153627fa45e902$export$15f30766ded058c3[code]
        ] : [],
        '- Each "text" is ONE short question or request (at most 60 characters) that a member of this workspace would ask the assistant about the workspace\'s own apps, records, people or figures.',
        '- Ground every item in the snapshot: name the apps, record types or figures it lists. Never invent apps or data that are not in the snapshot.',
        '- Never name a person (no member names, handles or email addresses); speak of "the team", a role, or "my".',
        '- When the snapshot has an "industry", the workspace runs a business of that kind: ask what that business does day to day, and favour the apps that serve it over the others.',
        '- Spread the items across different apps; at most two items about the same app.',
        '- "app" is the "route" of the snapshot app the item concerns, copied exactly, or null.',
        '- No numbering, no emoji, no quotation marks inside "text".'
    ].join('\n');
};
const $f6153627fa45e902$export$4549129f3b9623f9 = (snapshot)=>'Workspace snapshot (JSON):\n' + JSON.stringify(snapshot);
const $f6153627fa45e902$export$3ea4c15e263a0c0f = (result)=>{
    if (typeof result === 'string') return result;
    if (!result || typeof result !== 'object') return '';
    if (typeof result.text === 'string') return result.text;
    if (typeof result.content === 'string') return result.content;
    if (result.message) return typeof result.message === 'string' ? result.message : $f6153627fa45e902$var$str(result.message.content);
    if (result.data) {
        if (typeof result.data === 'string') return result.data;
        if (typeof result.data.text === 'string') return result.data.text;
        return JSON.stringify(result.data);
    }
    return '';
};
const $f6153627fa45e902$export$4b9a580a78b78fd5 = (text)=>{
    const raw = $f6153627fa45e902$var$str(text).replace(/```[a-z]*\n?/gi, '').trim();
    const start = raw.indexOf('[');
    if (start < 0) return [];
    let depth = 0;
    let end = -1;
    let inStr = false;
    let esc = false;
    for(let i = start; i < raw.length; i++){
        const c = raw[i];
        if (inStr) {
            if (esc) esc = false;
            else if (c === '\\') esc = true;
            else if (c === '"') inStr = false;
            continue;
        }
        if (c === '"') inStr = true;
        else if (c === '[') depth++;
        else if (c === ']') {
            depth--;
            if (depth === 0) {
                end = i;
                break;
            }
        }
    }
    if (end < 0) return [];
    let arr;
    try {
        arr = JSON.parse(raw.slice(start, end + 1));
    } catch (_) {
        return [];
    }
    if (!Array.isArray(arr)) return [];
    const out = [];
    const seen = new Set();
    for (const it of arr){
        const textOf = typeof it === 'string' ? it : it && typeof it === 'object' ? $f6153627fa45e902$var$str(it.text) : '';
        const t = textOf.replace(/\s+/g, ' ').trim().replace(/^["'“”„«»]+|["'“”„«»]+$/g, '').trim();
        if (t.length < 3 || t.length > $f6153627fa45e902$export$640bc489c9387e19) continue;
        const k = t.toLowerCase();
        if (seen.has(k)) continue;
        seen.add(k);
        const app = it && typeof it === 'object' && typeof it.app === 'string' && it.app.trim() ? it.app.trim() : null;
        out.push({
            text: t,
            app: app
        });
        if (out.length >= $f6153627fa45e902$export$93e34f64c2bc1d72) break;
    }
    return out;
};
const $f6153627fa45e902$export$8bf5f65b7c4d5e83 = (label, appTitle)=>{
    const t = $f6153627fa45e902$var$str(appTitle).trim();
    if (!t) return '';
    return $f6153627fa45e902$var$str(label).toLowerCase().indexOf(t.toLowerCase()) === -1 ? t : '';
};
const $f6153627fa45e902$export$9b75372dfe52d334 = (items, tiles, resolve)=>{
    const res = typeof resolve === 'function' ? resolve : (k)=>k;
    const t = Array.isArray(tiles) ? tiles : [];
    const byRoute = new Map(t.map((x)=>[
            x.route,
            x
        ]));
    const byTitle = new Map(t.map((x)=>[
            $f6153627fa45e902$var$str(res(x.title)).trim().toLowerCase(),
            x
        ]));
    return (Array.isArray(items) ? items : []).map((it, i)=>{
        const app = $f6153627fa45e902$var$str(it && it.app).trim();
        const tile = app && (byRoute.get(app) || byTitle.get(app.toLowerCase())) || null;
        const text = $f6153627fa45e902$var$str(it && it.text);
        return {
            key: 'gen-' + i + '-' + $f6153627fa45e902$export$e3acfaf253341055(text),
            text: text,
            prompt: text,
            icon: tile ? tile.icon : 'magicstar',
            caption: tile ? $f6153627fa45e902$export$8bf5f65b7c4d5e83(text, res(tile.title)) : '',
            route: tile ? $f6153627fa45e902$var$str(tile.route) : '',
            appName: tile ? $f6153627fa45e902$var$str(res(tile.title)) : '',
            appId: tile && tile.projectId ? $f6153627fa45e902$var$str(tile.projectId) : ''
        };
    });
};
const $f6153627fa45e902$export$19b61b633015b7f3 = (root, tiles, resolve)=>{
    const r = root && typeof root === 'object' ? root : {};
    const res = typeof resolve === 'function' ? resolve : (k)=>k;
    const t = Array.isArray(tiles) ? tiles : $f6153627fa45e902$export$aa9c0f581bf69119(r);
    const scopeName = $f6153627fa45e902$var$scopeNameOf(r);
    const rows = [];
    const seen = new Set();
    const push = (row, cap = $f6153627fa45e902$export$93e34f64c2bc1d72 - 1)=>{
        const k = $f6153627fa45e902$var$str(row.text).trim().toLowerCase();
        if (!k || seen.has(k) || rows.length >= cap) return;
        seen.add(k);
        rows.push(row);
    };
    // The apps' own starters carry no caption: the Hint above already names
    // the workspace, and a manifest starter names its own subject.
    //
    // THROUGH THE BUNDLE (2026-09-26, QA on dev/natali: "Add a contact" and
    // "Schedule a booking" rendered in English in a Georgian workspace). A
    // manifest starter is resolved like every other string here: a bundle KEY
    // the module ships (its translations merge into the shell's polyglot map
    // on load) reads in the session language, and a plain literal passes
    // through verbatim — `translate()` returns what it cannot resolve, the
    // property that makes key-in-data safe (the navbar labels rely on it).
    // The row's key stays hashed on the manifest's own text, so it survives a
    // language switch.
    //
    // A manifest starter that is NO bundle key reads only in its author's own
    // words, and a manifest names no language: the words' script is the
    // evidence. In a session whose language writes in its own script — Georgian;
    // every system app's manifest is English (apps/*/symbols/config.js) — a
    // literal shows only when it is written in that script (dev 2026-10-23, a
    // Georgian session before its generated set: "Schedule a booking" was the
    // one English line on screen). The others wait for the generated set, which
    // writes every prompt in the session language; a keyed starter still shows,
    // translated.
    const SCRIPT_OF = {
        ka: /[Ⴀ-ჿᲐ-Ჿ]/
    };
    const script = SCRIPT_OF[$f6153627fa45e902$var$str(r.lang) || 'en'];
    $f6153627fa45e902$export$415cfd50b999ca96(r).filter((st)=>!script || $f6153627fa45e902$var$str(res(st.text)) !== $f6153627fa45e902$var$str(st.text) || script.test(st.text)).slice(0, $f6153627fa45e902$export$dc62cc8e734b11fc).forEach((st, i)=>{
        const text = $f6153627fa45e902$var$str(res(st.text)) || st.text;
        push({
            key: 'mod-' + i + '-' + $f6153627fa45e902$export$e3acfaf253341055(st.text),
            text: text,
            prompt: text,
            localAction: st.localAction,
            ...st.form ? {
                form: st.form
            } : {},
            icon: 'magicstar',
            caption: ''
        });
    });
    for (const tile of t){
        const title = $f6153627fa45e902$var$str(res(tile.title));
        const builtin = $f6153627fa45e902$export$d4bdc6af9036edae.find((b)=>b.route === tile.route);
        if (builtin) {
            const text = $f6153627fa45e902$var$str(res(builtin.labelKey)).replace('{workspace}', scopeName);
            push({
                key: 'app-' + tile.route,
                text: text,
                prompt: $f6153627fa45e902$var$str(res(builtin.promptKey)).replace('{workspace}', scopeName),
                icon: tile.icon,
                caption: $f6153627fa45e902$export$8bf5f65b7c4d5e83(text, title)
            });
        } else if (tile.custom && title) // "{app}: what is new?" already names the app → no caption.
        push({
            key: 'app-' + tile.route,
            text: $f6153627fa45e902$var$str(res($f6153627fa45e902$var$CUSTOM_APP_STARTER.labelKey)).replace('{app}', title),
            prompt: $f6153627fa45e902$var$str(res($f6153627fa45e902$var$CUSTOM_APP_STARTER.promptKey)).replace('{app}', title),
            icon: tile.icon,
            caption: ''
        });
    }
    push({
        key: 'generic-plate',
        text: $f6153627fa45e902$var$str(res($f6153627fa45e902$var$GENERIC_STARTER.labelKey)),
        prompt: $f6153627fa45e902$var$str(res($f6153627fa45e902$var$GENERIC_STARTER.promptKey)),
        icon: 'magicstar',
        caption: ''
    }, $f6153627fa45e902$export$93e34f64c2bc1d72);
    return rows;
};
const $f6153627fa45e902$export$16fa8d6a8242bc4e = function(root) {
    const el = this;
    const r = root || el && el.state && el.state.root;
    if (!r || typeof r !== 'object') return [];
    const resolve = (key)=>{
        try {
            return el && typeof el.call === 'function' ? el.call('polyglot', key) : key;
        } catch (_) {
            return key;
        }
    };
    const tiles = $f6153627fa45e902$var$namedStarterTiles(el, $f6153627fa45e902$export$aa9c0f581bf69119(r));
    const wsId = $f6153627fa45e902$export$ca6fc1004b9ce6b2(r);
    const lang = $f6153627fa45e902$var$str(r.lang) || 'en';
    const cached = wsId ? $f6153627fa45e902$export$bedf5976dde1a8a3(r, wsId) : null;
    if ($f6153627fa45e902$export$2792964839370a92(cached, {
        lang: lang,
        hash: $f6153627fa45e902$export$2e168f69989613e7(r, tiles),
        now: Date.now()
    })) return $f6153627fa45e902$export$9b75372dfe52d334(cached.items, tiles, resolve);
    return $f6153627fa45e902$export$19b61b633015b7f3(r, tiles, resolve);
};
// Persist a generated set under the home-prefs durability law (functions/
// homeLook.js; the dock writer, functions/assistantDock.js): the preferences
// `update` REPLACES the row, so the write is chained on the SAME per-
// workspace queue every writer of the row uses (`root.__navbarSaveQueue`),
// its payload — the cache merge included — is composed at SEND time from the
// LIVE row, and a row that has not loaded is READ first. The optimistic root
// write (the drawer re-renders at once) runs ONLY when the row has loaded: a
// partial `{ assistant_starters }` copy of an unloaded row would read as the
// whole row to the next writer and erase every other stored preference (the
// data-loss defect of a cold boot, or of the window after a workspace switch
// wipes `userPrefs`). Unloaded, the confirmed row lands in the state instead.
const $f6153627fa45e902$var$writeStarterCache = async (root, wsId, entry, getSdk)=>{
    const merge = (row)=>$f6153627fa45e902$export$dae06a3ac5733749({
            ...row && row[$f6153627fa45e902$export$ee4bd14a70bfc66f] || {},
            [wsId]: entry
        });
    const prev = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    if (prev) root.update({
        userPrefs: {
            ...prev,
            [$f6153627fa45e902$export$ee4bd14a70bfc66f]: merge(prev)
        }
    }, {
        preventFetch: true
    });
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    const prior = queue.get(wsId) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        const sdk = getSdk();
        let live = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
        if (!live) {
            const got = await sdk.execute('workspaceProject.userPreferences', 'get');
            live = got && typeof got === 'object' ? got : {};
        }
        // PER-PATH PATCH — names only `assistant_starters`, so no OTHER
        // preference is ever overwritten (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: {
                set: {
                    [$f6153627fa45e902$export$ee4bd14a70bfc66f]: merge(live)
                }
            }
        });
        const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
        root.update({
            userPrefs: now ? {
                ...now,
                [$f6153627fa45e902$export$ee4bd14a70bfc66f]: merge(now)
            } : row && typeof row === 'object' ? row : {
                [$f6153627fa45e902$export$ee4bd14a70bfc66f]: merge(live)
            }
        }, {
            preventFetch: true
        });
        return row;
    });
    queue.set(wsId, task);
    try {
        await task;
    } catch (e) {
        console.warn('[assistantStarters] cache persist failed', e && e.message);
    }
};
const $f6153627fa45e902$export$6ab8a9a72a88a4c2 = async function(root, opts = {}) {
    const el = this;
    const r = root || el && el.state && el.state.root;
    if (!r || typeof r !== 'object' || typeof r.update !== 'function') return null;
    // Two surfaces show the set: the drawer's empty chat (it asks when the
    // drawer is open) and Fly's start screen (functions/assistantFlyStart.js
    // asks with `surface: 'fly'` when it shows). One cached set serves both.
    const surfaceOpen = !!r.assistantOpen || !!opts && opts.surface === 'fly';
    if (!surfaceOpen || !r.workspaceReady) return null;
    const wsId = $f6153627fa45e902$export$ca6fc1004b9ce6b2(r);
    if (!wsId) return null;
    // Installed apps still loading → their tiles and starters are not on root
    // yet; the Empty slot re-arms this when `workspaceApps` lands. Installed app
    // entries only (the ONE shared reader, installedAppRefs): the server-managed
    // records-grant row in settings.workspaceApps is not an app and never
    // publishes, so counting it kept the starters waiting for good.
    const declaredApps = (0, $g7CNh.installedAppRefs)(r.workspace && r.workspace.settings);
    if (declaredApps.length && !Array.isArray(r.workspaceApps)) return null;
    // STARTERS-ONCE (2026-11-01): the cached set lives in the member's
    // preferences row, and that row is read only AFTER the workspace is ready
    // (functions/loadPrivateData.js), while Fly's start screen asks as soon as
    // the workspace is ready. Judged on an unread row (`userPrefs` null — a cold
    // boot, or the window after a workspace switch wipes it), every home load
    // whose read outlasted the settle window spent a model call on a set the row
    // already held. Unread → nothing is decided; the start screen asks again
    // when the row lands (its stateDeps), the drawer's Empty slot at its render.
    if (!r.userPrefs || typeof r.userPrefs !== 'object') return null;
    const now = typeof opts.now === 'function' ? opts.now : Date.now;
    const getSdk = typeof opts.getSdk === 'function' ? opts.getSdk : $f6153627fa45e902$var$shellGetSDK;
    const settleMs = typeof opts.settleMs === 'number' ? opts.settleMs : $f6153627fa45e902$export$3a952f5f53c4f7f7;
    const lang = $f6153627fa45e902$var$str(r.lang) || 'en';
    const hash = $f6153627fa45e902$export$2e168f69989613e7(r, $f6153627fa45e902$export$aa9c0f581bf69119(r));
    const cached = $f6153627fa45e902$export$bedf5976dde1a8a3(r, wsId);
    if ($f6153627fa45e902$export$2792964839370a92(cached, {
        lang: lang,
        hash: hash,
        now: now()
    })) return cached;
    const flightKey = wsId + ':' + lang;
    if (!r.__aiStartersInflight) r.__aiStartersInflight = new Map();
    const inflight = r.__aiStartersInflight;
    if (inflight.has(flightKey)) return inflight.get(flightKey);
    const failed = r.__aiStartersFailed || {};
    if (typeof failed[flightKey] === 'number' && now() - failed[flightKey] < $f6153627fa45e902$export$e99e68ce9fc2ccfb) return null;
    const resolve = (key)=>{
        try {
            return el && typeof el.call === 'function' ? el.call('polyglot', key) : key;
        } catch (_) {
            return key;
        }
    };
    const task = (async ()=>{
        r.update({
            _aiStartersPending: true
        });
        try {
            // Let the app waves land, then read the signature the call is FOR.
            if (settleMs > 0) await new Promise((res)=>setTimeout(res, settleMs));
            // a workspace switch wiped the row meanwhile: ask again when it lands
            if (!r.userPrefs || typeof r.userPrefs !== 'object') return null;
            const tiles = $f6153627fa45e902$var$namedStarterTiles(el, $f6153627fa45e902$export$aa9c0f581bf69119(r));
            const settledHash = $f6153627fa45e902$export$2e168f69989613e7(r, tiles);
            if (settledHash !== hash) return null;
            if ($f6153627fa45e902$export$2792964839370a92($f6153627fa45e902$export$bedf5976dde1a8a3(r, wsId), {
                lang: lang,
                hash: hash,
                now: now()
            })) return $f6153627fa45e902$export$bedf5976dde1a8a3(r, wsId);
            const snapshot = $f6153627fa45e902$export$a22347f8ddde3200(r, {
                resolve: resolve,
                tiles: tiles,
                now: now()
            });
            const sdk = getSdk();
            const ai = await sdk.getService('ai');
            const result = await ai.completion({
                messages: [
                    {
                        role: 'user',
                        content: $f6153627fa45e902$export$4549129f3b9623f9(snapshot)
                    }
                ],
                systemPromptOverride: $f6153627fa45e902$export$706f2a13606f0a92(lang),
                systemRef: $f6153627fa45e902$export$7604b580bb7f1213
            });
            const parsed = $f6153627fa45e902$export$4b9a580a78b78fd5($f6153627fa45e902$export$3ea4c15e263a0c0f(result));
            const items = $f6153627fa45e902$var$starterItemsWithoutPeople(parsed, r.peopleAll);
            // Nothing left is the empty-set path (back off, keep the built set).
            // When the filter emptied it, the warning does not repeat the reply:
            // the reply names a person.
            if (!items.length && parsed.length) throw new Error('empty starter set: every item named a person');
            if (!items.length) throw new Error('empty starter set: ' + $f6153627fa45e902$var$str($f6153627fa45e902$export$3ea4c15e263a0c0f(result)).slice(0, 120));
            const rule = $f6153627fa45e902$var$starterRuleOf(lang);
            const entry = {
                v: $f6153627fa45e902$export$6630624df614f26d,
                lang: lang,
                hash: hash,
                at: now(),
                items: items,
                ...rule ? {
                    rule: rule
                } : {}
            };
            await $f6153627fa45e902$var$writeStarterCache(r, wsId, entry, getSdk);
            return entry;
        } catch (e) {
            r.__aiStartersFailed = {
                ...r.__aiStartersFailed || {},
                [flightKey]: now()
            };
            console.warn('[assistantStarters] generation skipped:', e && e.message);
            return null;
        } finally{
            inflight.delete(flightKey);
            r.update({
                _aiStartersPending: false
            });
        }
    })();
    inflight.set(flightKey, task);
    return task;
};

});

parcelRegister("41OOS", function(module, exports) {

$parcel$export(module.exports, "assistantPageStarterRows", () => $2eeead21d2528d69$export$dd3e6257e4b347e2);
$parcel$export(module.exports, "assistantPageStartersLoad", () => $2eeead21d2528d69$export$a4e4f50ca0731523);
$parcel$export(module.exports, "assistantPageStarterSend", () => $2eeead21d2528d69$export$7f76f1f60017974b);
// assistantPageStarters — the Page view's empty-workspace starter chips
// (WS-W2-ASSISTANT-PAGE-MODE-DOCK-1 unit (e); ASSISTANT_BOARD_MODE_SPEC §4
// "Empty workspace"; umbrella DESIGN-WL-ASSISTANT-MAIN-MODE-1).
//
// Rows for the shared AssistantStarterList (_simone/AssistantStarter.js —
// `{ key, text, prompt, icon, caption, localAction }`), built from the
// ai.boards VOCABULARY: the installed apps' widget catalogue the model is
// given (server src/domains/ai-boards, installed apps ∩ grants). Titles,
// describe lines and app names come from the apps' own manifests through the
// server — already in the member's language — so the chips carry NO copy of
// their own and always offer boards this workspace can actually build. One
// chip = one widget: the title is the capsule line, the describe line is the
// prompt that generates, the app's name is the caption, the widget's icon
// falls back to its app's. One widget per app before a second of any app,
// capped, deterministic.
//
// A tap generates that board directly (`assistantBoardGenerate` — the same
// leg homeAiSend's dashboard route takes, never the chat bridge); the main
// thread steps aside first because ONE view holds the main area. The shared
// capsule's own pre-open (`assistantOpen: true`) is converted by the shell's
// open edge under the main placement (app.js → promoteAssistantDockForOpen),
// so the drawer never opens on the way.
//
// The vocabulary is fetched ONCE per workspace, lazily, the first time a
// host asks (single-flight; a reply for a workspace the user has already
// left is dropped — the same guard as assistantBoardProbe). It lands in
// `_aiBoardVocab` (declared in state-app.js and wiped on a workspace switch
// beside `_aiBoardsAvailable`); a failure stores nothing so a later host may
// retry. The host mounts AssistantStarterList with these rows — the shared
// list and this feed are the whole surface, so the chat's starters and the
// Page view's can never drift apart.
const $2eeead21d2528d69$var$STARTER_CAP = 6;
const $2eeead21d2528d69$var$activeWorkspaceId = (r)=>{
    const ws = r && r.workspace;
    return ws && (ws.id || ws._id) || null;
};
const $2eeead21d2528d69$export$dd3e6257e4b347e2 = function assistantPageStarterRows(root) {
    const r = root || this && this.state && this.state.root || {};
    const vocab = r._aiBoardVocab;
    if (!vocab || typeof vocab !== 'object') return [];
    const wsId = $2eeead21d2528d69$var$activeWorkspaceId(r);
    if (wsId && vocab.workspaceId !== wsId) return [];
    const widgets = Array.isArray(vocab.widgets) ? vocab.widgets : [];
    if (!widgets.length) return [];
    const apps = Array.isArray(vocab.apps) ? vocab.apps : [];
    const appName = {};
    const appIcon = {};
    for (const a of apps){
        if (!a || typeof a !== 'object') continue;
        const k = a.app || a.appId;
        if (!k) continue;
        if (typeof a.name === 'string' && a.name) appName[k] = a.name;
        if (typeof a.icon === 'string' && a.icon) appIcon[k] = a.icon;
    }
    // One widget per app first (vocabulary order both ways), then fill.
    const byApp = new Map();
    for (const w of widgets){
        if (!w || typeof w !== 'object' || typeof w.widget !== 'string' || !w.widget) continue;
        const k = w.app || w.appId || '';
        const list = byApp.get(k) || [];
        list.push(w);
        byApp.set(k, list);
    }
    const picked = [];
    const seen = new Set();
    for (const [, list] of byApp){
        if (picked.length >= $2eeead21d2528d69$var$STARTER_CAP) break;
        picked.push(list[0]);
        seen.add(list[0]);
    }
    for (const [, list] of byApp){
        if (picked.length >= $2eeead21d2528d69$var$STARTER_CAP) break;
        for (const w of list){
            if (picked.length >= $2eeead21d2528d69$var$STARTER_CAP) break;
            if (seen.has(w)) continue;
            picked.push(w);
            seen.add(w);
        }
    }
    return picked.map((w)=>{
        const k = w.app || w.appId || '';
        const text = typeof w.title === 'string' && w.title || w.widget;
        const prompt = typeof w.describe === 'string' && w.describe || text;
        return {
            key: 'pgst-' + w.widget,
            text: text,
            prompt: prompt,
            icon: typeof w.icon === 'string' && w.icon || appIcon[k] || null,
            caption: appName[k] || null,
            localAction: 'assistantPageStarterSend'
        };
    });
};
const $2eeead21d2528d69$export$a4e4f50ca0731523 = async function assistantPageStartersLoad(root, sdk) {
    const el = this;
    const r = root || el && el.state && el.state.root;
    if (!r || typeof r.update !== 'function') return false;
    const workspaceId = $2eeead21d2528d69$var$activeWorkspaceId(r);
    const have = r._aiBoardVocab;
    if (have && typeof have === 'object' && (!workspaceId || !have.workspaceId || have.workspaceId === workspaceId)) return true;
    const flight = workspaceId || 'none';
    if (r.__aiBoardVocabFor === flight) {
        // A load for this workspace is already in the air — share its landing.
        const req = r.__aiBoardVocabReq;
        if (req && typeof req.then === 'function') return req;
        return false;
    }
    r.__aiBoardVocabFor = flight;
    const run = (async ()=>{
        let res = null;
        try {
            const s = sdk || (el && typeof el.call === 'function' ? el.call('getSDK') : null);
            if (!s || typeof s.execute !== 'function') throw new Error('unknown method: ai.boards');
            res = await s.execute('ai.boards', 'vocabulary', workspaceId ? {
                workspaceId: workspaceId
            } : {});
        } catch (_) {
            res = null;
        }
        if (r.__aiBoardVocabFor === flight) {
            r.__aiBoardVocabFor = null;
            r.__aiBoardVocabReq = null;
        }
        const still = $2eeead21d2528d69$var$activeWorkspaceId(r);
        if (still !== workspaceId) return false;
        if (!res || typeof res !== 'object') return false;
        const vocab = res.workspaceId || !workspaceId ? res : {
            ...res,
            workspaceId: workspaceId
        };
        r.update({
            _aiBoardVocab: vocab
        }, {
            preventFetch: true
        });
        return true;
    })();
    r.__aiBoardVocabReq = run;
    return run;
};
const $2eeead21d2528d69$export$7f76f1f60017974b = function assistantPageStarterSend() {
    const el = this;
    const s = el && el.state;
    const raw = s && (s.prompt || s.text || s.label);
    const text = String(raw == null ? '' : raw).trim();
    if (!text) return null;
    try {
        el.call('assistantMainThreadClose');
    } catch (_) {
    /* no thread view on this surface — nothing to step aside */ }
    return el.call('assistantBoardGenerate', {
        prompt: text
    });
};

});

parcelRegister("a54EB", function(module, exports) {

$parcel$export(module.exports, "assistantBoardFixture", () => $756dfb2fc3060e22$export$e1a5f43692bfa473);
$parcel$export(module.exports, "boardSpecHash", () => $756dfb2fc3060e22$export$fb03ed6934cebf38);
$parcel$export(module.exports, "boardVocabularyFor", () => $756dfb2fc3060e22$export$eff1afc37813bf9f);
$parcel$export(module.exports, "validateBoardSpec", () => $756dfb2fc3060e22$export$f2492a4bb21de51c);
$parcel$export(module.exports, "boardItemsFor", () => $756dfb2fc3060e22$export$370d221a60120378);
$parcel$export(module.exports, "assistantBoardCardOpen", () => $756dfb2fc3060e22$export$74637247316f5681);
$parcel$export(module.exports, "applyBoardChunk", () => $756dfb2fc3060e22$export$b7546e056e155297);
$parcel$export(module.exports, "assistantBoardFailed", () => $756dfb2fc3060e22$export$90d759f03b5bd77b);
$parcel$export(module.exports, "assistantBoardViewModel", () => $756dfb2fc3060e22$export$29704eeae2510b94);
$parcel$export(module.exports, "assistantBoardPageOnHome", () => $756dfb2fc3060e22$export$2335f802c238d345);
$parcel$export(module.exports, "assistantBoardShown", () => $756dfb2fc3060e22$export$8e5cb23858bfa300);
$parcel$export(module.exports, "assistantBoardOpen", () => $756dfb2fc3060e22$export$2a7de9bf9c15157e);
$parcel$export(module.exports, "assistantBoardCells", () => $756dfb2fc3060e22$export$1f3eb65228db6f97);
$parcel$export(module.exports, "assistantBoardMetrics", () => $756dfb2fc3060e22$export$c51ad0685f054503);
$parcel$export(module.exports, "assistantBoardSyncGrid", () => $756dfb2fc3060e22$export$f8534abeaca9dd73);
$parcel$export(module.exports, "assistantBoardGridStyle", () => $756dfb2fc3060e22$export$a83cab8b4be825ef);
$parcel$export(module.exports, "assistantBoardCardStyle", () => $756dfb2fc3060e22$export$3eac8176228f7b28);
$parcel$export(module.exports, "assistantBoardCardEmpty", () => $756dfb2fc3060e22$export$629bad7796637c8d);
$parcel$export(module.exports, "assistantBoardBusy", () => $756dfb2fc3060e22$export$e589981ba093b6bf);
$parcel$export(module.exports, "assistantBoardSummaryReserved", () => $756dfb2fc3060e22$export$98f0c3067638003f);
$parcel$export(module.exports, "assistantBoardRefineReserved", () => $756dfb2fc3060e22$export$a244148bb6c70d61);
$parcel$export(module.exports, "assistantBoardSummaryRows", () => $756dfb2fc3060e22$export$35a91a623465ce8f);
$parcel$export(module.exports, "assistantBoardActionsIdle", () => $756dfb2fc3060e22$export$c2c498ab1da72e35);
$parcel$export(module.exports, "assistantBoardPinAllLabel", () => $756dfb2fc3060e22$export$2c26d59a947046e1);
$parcel$export(module.exports, "assistantBoardSaveLabel", () => $756dfb2fc3060e22$export$9fab01b1a6142376);
$parcel$export(module.exports, "assistantBoardSavedId", () => $756dfb2fc3060e22$export$1f7285a0134f79e2);
$parcel$export(module.exports, "assistantBoardPinState", () => $756dfb2fc3060e22$export$4fa63f213467936e);
$parcel$export(module.exports, "assistantBoardChipsOpen", () => $756dfb2fc3060e22$export$191916d9013c5e8d);
$parcel$export(module.exports, "assistantBoardMicro", () => $756dfb2fc3060e22$export$749132f0e8cc79ec);
$parcel$export(module.exports, "assistantBoardStatus", () => $756dfb2fc3060e22$export$b4e2f0e1eac1f810);
$parcel$export(module.exports, "boardSummarySegments", () => $756dfb2fc3060e22$export$d9b65fc5b46287aa);
$parcel$export(module.exports, "boardParamsLabel", () => $756dfb2fc3060e22$export$c0b991862cce8113);
$parcel$export(module.exports, "boardSizeSpec", () => $756dfb2fc3060e22$export$ee9760c40c6cb2a8);
$parcel$export(module.exports, "assistantBoardHueVars", () => $756dfb2fc3060e22$export$bcd8667d0579df7f);
$parcel$export(module.exports, "assistantBoardPinLabel", () => $756dfb2fc3060e22$export$b83c5b3235ccb608);
$parcel$export(module.exports, "assistantBoardBlockFooter", () => $756dfb2fc3060e22$export$3109c1292b5bb185);
$parcel$export(module.exports, "assistantBoardEmptyItem", () => $756dfb2fc3060e22$export$d87aa24e3a830350);
$parcel$export(module.exports, "assistantBoardMountBody", () => $756dfb2fc3060e22$export$6a8776afb517132d);
$parcel$export(module.exports, "assistantBoardBodyMounted", () => $756dfb2fc3060e22$export$9aceb4e6142e5bcd);
$parcel$export(module.exports, "assistantBoardMeasure", () => $756dfb2fc3060e22$export$87fc3cea6356eac8);
$parcel$export(module.exports, "assistantBoardFocus", () => $756dfb2fc3060e22$export$6ecc25db19e0e694);
$parcel$export(module.exports, "assistantBoardShortcuts", () => $756dfb2fc3060e22$export$4c19d6b3e9857e79);
$parcel$export(module.exports, "assistantBoardGenerate", () => $756dfb2fc3060e22$export$bac282c0282a94d0);
$parcel$export(module.exports, "assistantBoardRetry", () => $756dfb2fc3060e22$export$57598b8a19b23e3c);
$parcel$export(module.exports, "assistantBoardRefine", () => $756dfb2fc3060e22$export$45b874060c671a2a);
$parcel$export(module.exports, "assistantBoardDrill", () => $756dfb2fc3060e22$export$f7f750d8e74b9883);
$parcel$export(module.exports, "assistantBoardDrillClose", () => $756dfb2fc3060e22$export$50cbaaf070848e40);
$parcel$export(module.exports, "assistantBoardPeriod", () => $756dfb2fc3060e22$export$60b77b76c56525b5);
$parcel$export(module.exports, "assistantBoardPeriodShown", () => $756dfb2fc3060e22$export$177d90fa76afd563);
$parcel$export(module.exports, "assistantBoardPeriodOptions", () => $756dfb2fc3060e22$export$37e41006873e6762);
$parcel$export(module.exports, "assistantBoardSetPeriod", () => $756dfb2fc3060e22$export$5b112e46e7336a4f);
$parcel$export(module.exports, "assistantBoardRefresh", () => $756dfb2fc3060e22$export$42c8ddfb0c97c276);
$parcel$export(module.exports, "assistantBoardRefreshing", () => $756dfb2fc3060e22$export$dc9adb0bf29c9f89);
$parcel$export(module.exports, "assistantBoardManage", () => $756dfb2fc3060e22$export$2cefb279083158dd);
$parcel$export(module.exports, "assistantBoardRenameStart", () => $756dfb2fc3060e22$export$bfa18e574735af66);
$parcel$export(module.exports, "assistantBoardRenameDraft", () => $756dfb2fc3060e22$export$8b3e3dd24310866d);
$parcel$export(module.exports, "assistantBoardRenameCancel", () => $756dfb2fc3060e22$export$6a11d3635ea5643e);
$parcel$export(module.exports, "assistantBoardRename", () => $756dfb2fc3060e22$export$fdc455d29f6b036b);
$parcel$export(module.exports, "assistantBoardDuplicate", () => $756dfb2fc3060e22$export$35b66ec157200d6f);
$parcel$export(module.exports, "assistantBoardDeleteAsk", () => $756dfb2fc3060e22$export$dbe0125caab91c1a);
$parcel$export(module.exports, "assistantBoardDelete", () => $756dfb2fc3060e22$export$46fa6736f5f8fc88);
$parcel$export(module.exports, "assistantBoardDismiss", () => $756dfb2fc3060e22$export$92ec91cc8aab31a4);
$parcel$export(module.exports, "assistantBoardShow", () => $756dfb2fc3060e22$export$935632459f1de0e3);
$parcel$export(module.exports, "assistantBoardRederive", () => $756dfb2fc3060e22$export$125dc986e105ec40);
$parcel$export(module.exports, "assistantBoardChips", () => $756dfb2fc3060e22$export$a8ebbf48682c88dd);
$parcel$export(module.exports, "boardItemWidgetDef", () => $756dfb2fc3060e22$export$1a09f738d462e490);
$parcel$export(module.exports, "boardItemPinHash", () => $756dfb2fc3060e22$export$8d86e5bd253dbdec);
$parcel$export(module.exports, "pinBoardItem", () => $756dfb2fc3060e22$export$95fae3c0d7bbbe09);
$parcel$export(module.exports, "pinAllBoardItems", () => $756dfb2fc3060e22$export$578886cf35ad6504);
$parcel$export(module.exports, "assistantBoardProbe", () => $756dfb2fc3060e22$export$ce68d523af95916d);
$parcel$export(module.exports, "assistantBoardGridRead", () => $756dfb2fc3060e22$export$14abeb5d9abed53);
$parcel$export(module.exports, "assistantBoardGridReadOff", () => $756dfb2fc3060e22$export$e2ec55064e71cd08);
$parcel$export(module.exports, "assistantBoardMounted", () => $756dfb2fc3060e22$export$2cac8829473951d2);
$parcel$export(module.exports, "saveBoard", () => $756dfb2fc3060e22$export$b7329792d7daafe2);
$parcel$export(module.exports, "assistantBoardShare", () => $756dfb2fc3060e22$export$770eb11ca405e9d8);
$parcel$export(module.exports, "assistantBoardShareLabel", () => $756dfb2fc3060e22$export$c3b7102987c4a7d0);
$parcel$export(module.exports, "assistantBoardToSidebar", () => $756dfb2fc3060e22$export$8ff01d7942f07f54);
$parcel$export(module.exports, "listBoards", () => $756dfb2fc3060e22$export$29ddff0c5a4a44a1);
$parcel$export(module.exports, "getBoard", () => $756dfb2fc3060e22$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "assistantBoardSegments", () => $756dfb2fc3060e22$export$a5e39cd97fe5bc03);
$parcel$export(module.exports, "assistantBoardRowLabel", () => $756dfb2fc3060e22$export$91bf22081c80a07a);
$parcel$export(module.exports, "assistantBoardCurrentSegment", () => $756dfb2fc3060e22$export$676622950200ef42);
$parcel$export(module.exports, "assistantBoardSelect", () => $756dfb2fc3060e22$export$ee96f85f447c90ca);
// ASSISTANT MAIN MODE — the generated board (DESIGN-WL-ASSISTANT-MAIN-VIEW-1,
// tickets/reference/white-label-redesign/ASSISTANT_BOARD_MODE_SPEC.md §2–§5).
// Nika, 2026-09-26: "ai assistant can directly render in main dashboard. it can
// make generative dashboards using all apps installed in workspace on fly."
//
// The model never draws UI. It answers with a BOARD SPEC (§2) — widget ids from
// the installed apps' own manifests with per-instance `params`, plus the six
// existing AI-widget block types for questions no widget answers. This module
// turns that spec into what components/AssistantBoardView.js paints:
//
//   validateBoardSpec   spec × vocabulary → items; an unknown widget, a block
//                       type outside the vocabulary or a duplicate is DROPPED
//                       and COUNTED ("2 OF 3 WIDGETS"), a bad size falls back to
//                       the widget's own default, a param outside the widget's
//                       schema is dropped (the body keeps its default view)
//   boardVocabularyFor  the installed apps' widgets as the view can mount them
//   boardItemsFor       spec → the view's card rows (widget body refs, block
//                       bodies + their static data, hues, footers)
//   applyBoardChunk     the streaming reducer (title + summary first, then the
//                       items one by one — §3)
//   assistantBoardGenerate / Retry / Refine / Dismiss / Show — the flows
//   pinBoardItem / pinAllBoardItems — the existing AI-widget create path
//   saveBoard / listBoards / getBoard — `sdk.execute('ai.boards', …)`
//
// STATE (declared by docs/patches/assistant-board-state-keys.patch):
//   _aiBoard         the board on screen (a view model — see
//                    `assistantBoardGenerate`), workspace-scoped
//   _aiBoardHistory  recent boards for the thread chips, max 5, workspace-scoped
//   _aiBoards        saved boards (`ai.boards.list`), workspace-scoped
//   _aiBoardPreview  UI mode: show the view without the dock gate — on the home
//                    (a board belongs to the route it was made on, §12.2)
//
// THE SERVER HALF DOES NOT EXIST YET (CORE-AI-BOARDS-GENERATE-VOCABULARY-1).
// Every `ai.boards` call goes through `sdk.execute` by name; the SDK throws
// "Unknown entity" today and that lands in the FAILURE state (one sentence +
// Try again), never a raw error and never a raw fetch.
//
// FRANK: every export is SELF-CONTAINED — no import, no module-scope constant,
// no bare call to a sibling export. frank revives each export on its own, so
// any of those is undefined at runtime (memory: frank drops module-local
// helpers; measured on this file: a static `@symbo.ls/scratch` import came back
// as the unresolvable free variable `import_scratch2`). Constants live inside
// the function that reads them; a sibling export is reached through
// `this.call('name', …)` — these are invoked as `el.call('name', …)`, so `this`
// is an element.
// ── The fixture (spec §2's example) ──────────────────────────────────────────
// Used ONLY by tests and by the `_aiBoardPreview` flag until the server's
// `ai.boards.generate` exists. Never a product answer: a preview board cannot
// pin or save (see pinBoardItem / saveBoard). A FUNCTION that returns a fresh
// copy, not a module constant: frank ships every export on its own, and a
// constant read across files belongs in globalScope.js (FA203) — a caller that
// mutated a shared fixture would also change it for every other reader.
const $756dfb2fc3060e22$export$e1a5f43692bfa473 = function assistantBoardFixture() {
    return {
        v: 1,
        id: 'brd_preview',
        prompt: 'How are Q3 viewings going?',
        title: 'Q3 viewings',
        summary: '42 viewings in Q3, up 12% on Q2. 3 deals sit in proposal for more than 14 days.',
        items: [
            {
                kind: 'widget',
                widget: 'scheduling.bookings-trend',
                size: 'xl',
                params: {
                    kind: 'viewing',
                    range: '2026-07-01..2026-09-26',
                    group: 'week'
                }
            },
            {
                kind: 'widget',
                widget: 'crm.deals-stuck',
                size: 'm',
                params: {
                    stage: 'proposal',
                    olderThanDays: 14
                }
            },
            {
                kind: 'block',
                block: 'bars',
                size: 'm',
                title: "Revenue by property \xb7 Q3",
                data: [
                    [
                        'Argo Business Center',
                        61
                    ],
                    [
                        'Vake office',
                        24
                    ]
                ],
                source: {
                    app: 'bi',
                    dataset: 'revenue',
                    range: 'q3'
                }
            }
        ],
        refine: [
            {
                label: 'Only Argo units',
                prompt: 'How are Q3 viewings going for the Argo units only?'
            },
            {
                label: 'Compare with Q2',
                prompt: 'Compare Q3 viewings with Q2.'
            }
        ],
        sources: [
            {
                app: 'scheduling',
                dataset: 'bookings'
            },
            {
                app: 'crm',
                dataset: 'deals'
            },
            {
                app: 'bi',
                dataset: 'revenue'
            }
        ],
        generatedAt: null,
        model: 'fixture'
    };
};
const $756dfb2fc3060e22$export$fb03ed6934cebf38 = function boardSpecHash(value) {
    const stable = (v)=>{
        if (v === null || typeof v !== 'object') return JSON.stringify(v === undefined ? null : v);
        if (Array.isArray(v)) return '[' + v.map(stable).join(',') + ']';
        return '{' + Object.keys(v).filter((k)=>v[k] !== undefined).sort().map((k)=>JSON.stringify(k) + ':' + stable(v[k])).join(',') + '}';
    };
    const text = stable(value);
    let h = 0x811c9dc5;
    for(let i = 0; i < text.length; i++){
        h ^= text.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return (h >>> 0).toString(36);
};
const $756dfb2fc3060e22$export$eff1afc37813bf9f = function boardVocabularyFor(root) {
    const SIZES = [
        's',
        'm',
        'l',
        'xl'
    ];
    const el = this;
    const call = (name, ...args)=>el && typeof el.call === 'function' ? el.call(name, ...args) : undefined;
    const r = root || {};
    const widgets = {};
    const apps = {};
    const plain = (v)=>v && typeof v === 'object' && !Array.isArray(v) ? v : null;
    // A widget's own verbs, as its home card has them (functions/
    // homeWidgetFrame.js — the manifest's top-level spelling, then the legacy
    // `spec`'s): where the card opens, the hook every open runs first, and its
    // ONE square button's action (a "+ New deal" form, an "Open follow-ups"
    // view). A Fly section runs them as the home does.
    const path = (v)=>typeof v === 'string' && v.startsWith('/') && !v.startsWith('//') ? v : null;
    const fnName = (v)=>typeof v === 'string' && v ? v : null;
    // `ownerId` — the widget's app: its gate resolves in THAT app's own scope
    // (two apps may name the same gate function; the root keeps only one).
    // Fails CLOSED here (no gate yet, or a throw: hidden). The shared
    // evaluation (functions/moduleWidgetGate.js) gives the gate the shell
    // bridges and subscribes this run to the member's access (G-H).
    const gateAllows = (w, ownerId)=>!w.visibleFn || call('moduleWidgetGateAllows', r, w, ownerId, false) === true;
    // An app's own words (its first navbar tab). `appKey` beside them is the
    // app's record key — what its name is read by (installedAppName, at render:
    // the block footer and the Fly section picker), so an app reads its App Store
    // name (Nika 2026-10-23: "app names = what a person sees in the workspace App
    // Store") where these words are the manifest's ("Analytics" for Insights).
    const labelOf = (app)=>{
        const nav = app && Array.isArray(app.navbar) ? app.navbar : [];
        const entry = nav.find((n)=>n && typeof n.label === 'string' && n.label);
        return entry && entry.label || '';
    };
    const deniedWidgets = {};
    const add = (app, list)=>{
        const appId = app && app.id ? String(app.id) : '';
        if (!appId || !Array.isArray(list)) return;
        const key = appId.split('/').pop();
        const short = key.replace(/-app$/, '');
        const aliases = [
            ...new Set([
                appId,
                key,
                short
            ].filter(Boolean))
        ];
        const appEntry = {
            id: appId,
            short: short,
            aliases: aliases,
            label: labelOf(app),
            appKey: key,
            hue: null
        };
        for (const w of list){
            if (!w || typeof w !== 'object' || !w.id || !w.body) continue;
            const spec = plain(w.spec) || {};
            const hue = w.hue || spec.hue || spec.iconBg || null;
            if (!appEntry.hue && hue) appEntry.hue = hue;
            if (widgets[w.id] || !gateAllows(w, appId)) continue;
            // A widget may declare the views' `access` (functions/assistantAppViews.js,
            // U5): a member it does not allow gets the quiet line, not the body.
            if (w.access && !call('assistantAppViewAllowed', w.access, r)) {
                if (!deniedWidgets[w.id]) deniedWidgets[w.id] = {
                    ref: short + '.' + w.id,
                    aliases: aliases
                };
                continue;
            }
            const own = SIZES.includes(w.size) ? w.size : SIZES.includes(spec.size) ? spec.size : null;
            const fromCell = call('homeWidgetSizeForCell', spec.w, spec.h);
            const minSize = SIZES.includes(w.minSize) ? w.minSize : SIZES.includes(spec.minSize) ? spec.minSize : 's';
            widgets[w.id] = {
                ref: short + '.' + w.id,
                widgetId: w.id,
                appId: appId,
                aliases: aliases,
                title: w.title || spec.title || w.id,
                icon: w.icon || spec.icon || 'star',
                body: w.body,
                spec: spec,
                hue: hue,
                defaultSize: own || (SIZES.includes(fromCell) ? fromCell : 'm'),
                minSize: minSize,
                params: plain(w.params),
                describe: typeof w.describe === 'string' ? w.describe : '',
                openRoute: path(w.openRoute) || path(spec.openRoute),
                openCall: fnName(w.openCall) || fnName(spec.openCall),
                action: plain(w.action) || plain(spec.action)
            };
        }
        for (const alias of aliases)if (!apps[alias]) apps[alias] = appEntry;
    };
    const wp = r.workspaceProject;
    if (wp) add(wp, wp.widgets);
    for (const app of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])add(app, app && app.widgets);
    // APP VIEWS (functions/assistantAppViews.js): an app's read-only views and
    // the built-in packages' — kept beside the widgets (kind 'view'), so the
    // widget path validates, mounts and opens them. A view this member may not
    // see goes to `denied` (the card's quiet line), never to `widgets`.
    const denied = {
        ...deniedWidgets
    };
    const sources = call('assistantAppViewSources', r);
    for (const src of Array.isArray(sources) ? sources : []){
        const app = src && src.app;
        const appId = app && app.id ? String(app.id) : '';
        if (!appId || !Array.isArray(src.views)) continue;
        const key = appId.split('/').pop();
        const short = key.replace(/-app$/, '');
        const aliases = [
            ...new Set([
                appId,
                key,
                short
            ].filter(Boolean))
        ];
        for (const v of src.views){
            if (!v || typeof v !== 'object' || !v.id || typeof v.component !== 'string') continue;
            if (!/^[a-z0-9-]{1,60}$/.test(String(v.id)) || widgets[v.id]) continue;
            if (!call('assistantAppViewAllowed', v.access, r)) {
                if (!denied[v.id]) denied[v.id] = {
                    ref: short + '.' + v.id,
                    aliases: aliases
                };
                continue;
            }
            widgets[v.id] = {
                kind: 'view',
                ref: short + '.' + v.id,
                widgetId: v.id,
                appId: appId,
                aliases: aliases,
                title: v.title || v.id,
                icon: v.icon || 'star',
                body: v.component,
                spec: {},
                hue: v.hue || null,
                defaultSize: SIZES.includes(v.size) ? v.size : 'l',
                minSize: SIZES.includes(v.minSize) ? v.minSize : 's',
                params: plain(v.params),
                describe: typeof v.describe === 'string' ? v.describe : '',
                fold: src.fold || null,
                link: plain(v.link)
            };
        }
        if (!apps[short]) {
            const appEntry = {
                id: appId,
                short: short,
                aliases: aliases,
                label: labelOf(app),
                appKey: key,
                hue: null
            };
            for (const alias of aliases)if (!apps[alias]) apps[alias] = appEntry;
        }
    }
    return {
        widgets: widgets,
        apps: apps,
        denied: denied,
        blocks: [
            'numeral',
            'text-block',
            'list',
            'chip-row',
            'progress-bars',
            'bar-chart'
        ]
    };
};
const $756dfb2fc3060e22$export$f2492a4bb21de51c = function validateBoardSpec(spec, vocabulary) {
    const SIZES = [
        's',
        'm',
        'l',
        'xl'
    ];
    const RANK = {
        s: 0,
        m: 1,
        l: 2,
        xl: 3
    };
    // The board spec's block names → the AI-widget block vocabulary
    // (server widgetDefSchema.js WIDGET_BLOCK_TYPES, components/AiWidgetBlock.js).
    const BLOCKS = {
        number: 'numeral',
        numeral: 'numeral',
        text: 'text-block',
        'text-block': 'text-block',
        list: 'list',
        chips: 'chip-row',
        'chip-row': 'chip-row',
        bars: 'progress-bars',
        'progress-bars': 'progress-bars',
        chart: 'bar-chart',
        'bar-chart': 'bar-chart'
    };
    const FORMATS = [
        'number',
        'currency',
        'percent',
        'text'
    ];
    const MAX_ITEMS = 12;
    const MAX_ROWS = 20;
    const s = spec && typeof spec === 'object' ? spec : {};
    const vocab = vocabulary && vocabulary.widgets ? vocabulary.widgets : {};
    const text = (v, max)=>typeof v === 'string' ? v.trim().slice(0, max) : '';
    const hashOf = (v)=>{
        const stable = (x)=>{
            if (x === null || typeof x !== 'object') return JSON.stringify(x === undefined ? null : x);
            if (Array.isArray(x)) return '[' + x.map(stable).join(',') + ']';
            return '{' + Object.keys(x).filter((k)=>x[k] !== undefined).sort().map((k)=>JSON.stringify(k) + ':' + stable(x[k])).join(',') + '}';
        };
        const str = stable(v);
        let h = 0x811c9dc5;
        for(let i = 0; i < str.length; i++){
            h ^= str.charCodeAt(i);
            h = Math.imul(h, 0x01000193);
        }
        return (h >>> 0).toString(36);
    };
    const resolve = (ref)=>{
        const raw = text(ref, 120);
        if (!raw) return null;
        const dot = raw.indexOf('.');
        const app = dot > 0 ? raw.slice(0, dot) : '';
        const id = dot > 0 ? raw.slice(dot + 1) : raw;
        const entry = Object.prototype.hasOwnProperty.call(vocab, id) ? vocab[id] : null;
        if (!entry) return null;
        if (app && !(entry.aliases || []).includes(app)) return null;
        return entry;
    };
    const isDate = (v)=>{
        if (typeof v !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
        const d = new Date(v + 'T00:00:00Z');
        return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === v;
    };
    const paramOk = (value, rule)=>{
        const type = rule && rule.type;
        const values = rule && Array.isArray(rule.values) ? rule.values : null;
        // A WORKSPACE enum: the manifest names where its values live (`valuesFrom`,
        // e.g. the CRM pipeline stage over the workspace's crm_settings row). The
        // server resolves that list for THIS caller, offers only it to the model
        // and validates the item against it (server ai-boards AiBoardVocabulary);
        // the shell cannot read the row, so a clean key the static list does not
        // name passes here and the widget body maps it (an unknown key keeps the
        // body's default view). A plain enum stays strict.
        if (type === 'enum' && rule.valuesFrom && typeof rule.valuesFrom === 'object' && typeof value === 'string' && value !== '' && value.length <= 60 && value.trim() === value) return true;
        // A LIVE enum: a built-in view's list the SHELL read from this workspace
        // (`valuesLive: true` — e.g. a site view's websites, canvas functions/
        // canvasAnswer.js canvasAnswerProjectParam). The model is offered the
        // list the catalog carried; a saved page keeps a value this list does not
        // name (yet, or any more — the list lands after a cold boot), and the view
        // maps it itself (an unknown one reads its own sentence). The values-
        // from rule's shape: a clean string key.
        if (type === 'enum' && rule.valuesLive === true && typeof value === 'string' && value !== '' && value.length <= 120 && value.trim() === value) return true;
        // A RANGE takes a named preset its rule lists (`values`, e.g. the calendar
        // agenda's today | next7days | thisWeek | nextWeek — the view turns it into
        // days in the member's clock) OR explicit days. Checked before the plain
        // `values` gate: that gate dropped explicit days whenever presets were
        // listed, and the span check dropped every preset — measured live on dev
        // (Symbols Intranet, "What meetings do I have this week?": the model's
        // `thisWeek` was dropped and the card drew the next 7 days).
        if (type === 'range') {
            if (typeof value !== 'string') return false;
            if (!value.includes('..')) return !!values && values.includes(value);
            const [a, b] = value.split('..');
            return isDate(a) && isDate(b) && a <= b;
        }
        if (values && !values.includes(value)) return false;
        if (type === 'enum') return !!values;
        if (type === 'string') return typeof value === 'string' && value.length <= 200;
        if (type === 'number' || type === 'integer') {
            if (typeof value !== 'number' || !Number.isFinite(value)) return false;
            if (type === 'integer' && !Number.isInteger(value)) return false;
            if (typeof rule.min === 'number' && value < rule.min) return false;
            if (typeof rule.max === 'number' && value > rule.max) return false;
            return true;
        }
        if (type === 'boolean') return typeof value === 'boolean';
        if (type === 'date') return isDate(value);
        return false;
    };
    let paramsDropped = 0;
    const checkParams = (given, schema)=>{
        const out = {};
        const bag = given && typeof given === 'object' && !Array.isArray(given) ? given : {};
        const rules = schema && typeof schema === 'object' ? schema : {};
        for (const name of Object.keys(bag)){
            const rule = Object.prototype.hasOwnProperty.call(rules, name) ? rules[name] : null;
            if (rule && paramOk(bag[name], rule)) out[name] = bag[name];
            else paramsDropped++;
        }
        for (const name of Object.keys(rules)){
            const rule = rules[name] || {};
            if (name in out) continue;
            if (rule.default !== undefined && paramOk(rule.default, rule)) out[name] = rule.default;
            else if (rule.required) return null;
        }
        return out;
    };
    // CONTENT-FIT (HOME_AMBIENT_SKIN_SPEC §3 law 2 — content sets the size;
    // DESIGN-WL-HOME-WIDTH-RESIZE-1): a widget takes its own DESIGNED size — the
    // manifest's size, else its cell through homeWidgetSizeForCell — and the
    // model may ask for a SMALLER size, never a larger one: a larger card only
    // adds empty space around the same body. Never below its minimum.
    const sizeFor = (wanted, entry)=>{
        const floor = SIZES.includes(entry.minSize) ? entry.minSize : 's';
        const designed = SIZES.includes(entry.defaultSize) ? entry.defaultSize : 'm';
        const base = SIZES.includes(wanted) && RANK[wanted] < RANK[designed] ? wanted : designed;
        return RANK[base] < RANK[floor] ? floor : base;
    };
    // A block takes the smallest size its DATA needs — the model's size is not
    // read: one numeral or one sentence is S; a list or bars of up to six rows
    // is one row of two cells (M), more rows take the second row (L); a chart
    // of more than eight bars takes the full row (XL); a few chips fit S. An
    // empty block says one sentence — S. Words: up to TEXT_S characters fit an
    // S card (a 276–300 px square cell holds ~8 lines of ~35 characters, fewer
    // in Georgian); a longer block (up to the server's 280) takes two cells
    // (M), so it wraps in four to six lines and is never cut by its card.
    const TEXT_S = 140;
    const blockSize = (type, data)=>{
        const n = data && data.count ? Number(data.count) : 0;
        if (n && type === 'text-block') return String(data.text || '').length > TEXT_S ? 'm' : 's';
        if (!n || type === 'numeral' || type === 'text-block') return 's';
        if (type === 'chip-row') return n <= 6 ? 's' : 'm';
        if (type === 'bar-chart') return n <= 8 ? 'm' : 'xl';
        return n <= 6 ? 'm' : 'l';
    };
    // The rows of a list, chip-row or bars block: an array, or `{ rows }` (the
    // board's own shape). A chip row also takes the server's canonical data,
    // `{ chips: [...] }` (server ai-boards aiBoardSchema `chip-row`; a chip is a
    // string, `{ label }` or `{ text }`), ahead of `rows`, as the server's own
    // reader does. It read only an array or `{ rows }`, so every server chip row
    // on a live board had no rows and said "Nothing for …" instead of its chips
    // (dev 2026-10-30, the canvas composer board). This is the board's ONE chip
    // reader: the home's pinned blocks (functions/homePinnedItems.js) hand their
    // stored data over as it is.
    const rowsOf = (data, kind)=>{
        const bag = data && typeof data === 'object' && !Array.isArray(data) ? data : {};
        const own = kind === 'chips' && Array.isArray(bag.chips) ? bag.chips : bag.rows;
        const list = Array.isArray(data) ? data : Array.isArray(own) ? own : [];
        const rows = [];
        for (const row of list.slice(0, MAX_ROWS)){
            if (kind === 'chips') {
                const label = Array.isArray(row) ? row[0] : row && typeof row === 'object' ? row.label ?? row.text : row;
                if (label != null && String(label).trim()) rows.push({
                    label: String(label).slice(0, 120)
                });
                continue;
            }
            if (kind === 'list') {
                const title = Array.isArray(row) ? row[0] : row && typeof row === 'object' ? row.title ?? row.label ?? row.name : row;
                const meta = Array.isArray(row) ? row[1] : row && typeof row === 'object' ? row.meta ?? row.value : '';
                if (title != null && String(title).trim()) rows.push({
                    title: String(title).slice(0, 120),
                    meta: meta == null ? '' : String(meta).slice(0, 60)
                });
                continue;
            }
            const label = Array.isArray(row) ? row[0] : row && typeof row === 'object' ? row.label : null;
            const value = Array.isArray(row) ? row[1] : row && typeof row === 'object' ? row.value : null;
            const num = typeof value === 'number' ? value : Number(value);
            if (label != null && String(label).trim() && Number.isFinite(num)) rows.push({
                label: String(label).slice(0, 120),
                value: num
            });
        }
        return rows;
    };
    const blockData = (type, data)=>{
        if (type === 'numeral') {
            const v = Array.isArray(data) ? Array.isArray(data[0]) ? data[0][1] : data[0] : data && typeof data === 'object' ? data.value : data;
            const ok = typeof v === 'number' ? Number.isFinite(v) : typeof v === 'string' && v.trim() !== '';
            // The model's own words beside the number, in the member's language
            // (server ai-boards aiBoardSchema BOARD_BLOCK_DATA `numeral`: `unit` up
            // to 24 characters, `caption` up to 120): the unit says what the number
            // counts ("viewings"), the caption what it covers ("Q3, all offices").
            // Both were dropped here, so the member saw a bare number (QG-LABELS,
            // 2026-10-31). Kept only beside a value and only when they say
            // something, so a numeral without them keeps today's `{ value, count }`
            // (and its key).
            const bag = ok && data && typeof data === 'object' && !Array.isArray(data) ? data : {};
            const unit = text(bag.unit, 24);
            const caption = text(bag.caption, 120);
            return {
                value: ok ? v : null,
                count: ok ? 1 : 0,
                ...unit ? {
                    unit: unit
                } : {},
                ...caption ? {
                    caption: caption
                } : {}
            };
        }
        if (type === 'text-block') {
            const t = typeof data === 'string' ? data : data && typeof data === 'object' ? data.text : '';
            // DISPLAY text, on the server's own budget (BOARD_SUMMARY_MAX = 280,
            // server ai-boards aiBoardSchema `text-block`). It was a raw
            // `slice(0, 120)`: a Fly word block lost its second half mid-word
            // ("…or web a", QA 2026-10-18). A longer string (an older server, the
            // dashboard fallback) is cut at a word boundary and marked with an
            // ellipsis inside the budget — the server's own `text()` rule — never
            // mid-word.
            const MAX = 280;
            const one = typeof t === 'string' ? t.replace(/\s+/g, ' ').trim() : '';
            let clean = one;
            if (one.length > MAX) {
                const cut = one.slice(0, MAX - 1);
                const space = cut.lastIndexOf(' ');
                const head = (space > (MAX - 1) * 0.5 ? cut.slice(0, space) : cut).replace(/[\s,;:.–—-]+$/, '');
                clean = (head || cut) + "\u2026";
            }
            // The SEMANTIC tone of the words (design-d2: `data.tone` = neutral |
            // good | warning | critical; the typographic style is `textStyle` on a
            // def). Anything else is dropped.
            const tone = data && typeof data === 'object' && [
                'neutral',
                'good',
                'warning',
                'critical'
            ].includes(data.tone) ? data.tone : null;
            return {
                text: clean,
                ...tone ? {
                    tone: tone
                } : {},
                count: clean ? 1 : 0
            };
        }
        const kind = type === 'list' ? 'list' : type === 'chip-row' ? 'chips' : 'bars';
        const rows = rowsOf(data, kind);
        return {
            rows: rows,
            count: rows.length
        };
    };
    const blockDef = (type, format, data)=>{
        const fmt = FORMATS.includes(format) ? {
            format: format
        } : {};
        if (type === 'numeral') {
            // The numeral renderer's fields (components/AiWidgetBlock.js
            // AiWidgetNumeral): `unit` is the word drawn beside the number the
            // house hero's way (a grey word that wraps, never cut; `suffix` stays
            // a sign inside the number's own text, "42%"), and `caption` is the
            // line under it. Neither is set without its words: a numeral with
            // none draws as before, with no empty caption line.
            const d = data && typeof data === 'object' ? data : {};
            return {
                type: type,
                valuePath: 'value',
                ...fmt,
                ...d.unit ? {
                    unit: d.unit
                } : {},
                ...d.caption ? {
                    caption: d.caption
                } : {}
            };
        }
        if (type === 'text-block') return {
            type: type,
            textPath: 'text',
            tonePath: 'tone'
        };
        if (type === 'list') return {
            type: type,
            itemsPath: 'rows',
            titleField: 'title',
            metaField: 'meta',
            limit: MAX_ROWS
        };
        if (type === 'chip-row') return {
            type: type,
            itemsPath: 'rows',
            labelField: 'label',
            limit: MAX_ROWS
        };
        return {
            type: type,
            itemsPath: 'rows',
            labelField: 'label',
            valueField: 'value',
            limit: MAX_ROWS,
            ...fmt
        };
    };
    const items = [];
    const droppedRefs = [];
    const seen = new Set();
    let total = 0;
    let dropped = 0;
    const list = Array.isArray(s.items) ? s.items.slice(0, MAX_ITEMS) : [];
    list.forEach((raw, index)=>{
        total++;
        const it = raw && typeof raw === 'object' ? raw : {};
        const drop = (why)=>{
            dropped++;
            droppedRefs.push({
                index: index,
                ref: it.widget || it.block || null,
                why: why
            });
        };
        if (it.kind === 'widget' || !it.kind && it.widget) {
            const entry = resolve(it.widget);
            if (!entry) return drop('not-installed');
            const params = checkParams(it.params, entry.params);
            if (!params) return drop('params');
            const key = 'w:' + entry.widgetId + ':' + hashOf(params);
            if (seen.has(key)) return drop('duplicate');
            seen.add(key);
            items.push({
                key: key,
                kind: 'widget',
                ref: entry.ref,
                widgetId: entry.widgetId,
                appId: entry.appId,
                size: sizeFor(it.size, entry),
                params: params,
                title: text(it.title, 60) || null
            });
            return;
        }
        if (it.kind === 'block' || !it.kind && it.block) {
            const type = Object.prototype.hasOwnProperty.call(BLOCKS, it.block) ? BLOCKS[it.block] : null;
            if (!type) return drop('unknown-block');
            const data = blockData(type, it.data);
            const src = it.source && typeof it.source === 'object' ? it.source : {};
            const source = {
                app: text(src.app, 40),
                dataset: text(src.dataset, 60),
                range: text(src.range, 40)
            };
            const key = 'b:' + type + ':' + hashOf({
                title: it.title || '',
                data: data,
                source: source
            });
            if (seen.has(key)) return drop('duplicate');
            seen.add(key);
            items.push({
                key: key,
                kind: 'block',
                block: type,
                size: blockSize(type, data),
                title: text(it.title, 60),
                def: blockDef(type, it.format, data),
                data: data,
                empty: !data.count,
                source: source
            });
            return;
        }
        // A RECORDS BLOCK v1 (functions/assistantRecords.js): declarative — the
        // rows come from `ai.boards.records` under the member's grants, never from
        // the model. CONTENT SETS THE SIZE, the model's size is not read: one
        // number is S; a list or table of up to six rows is one row of two cells
        // (M), more rows take the second row (L); a table wider than three columns
        // takes the full row (XL); a chart is M.
        if (it.kind === 'records' || !it.kind && typeof it.collection === 'string') {
            const normalized = this && typeof this.call === 'function' ? this.call('recordsBlockNormalize', it) : null;
            if (!normalized) return drop('records');
            const key = 'r:' + hashOf(normalized);
            if (seen.has(key)) return drop('duplicate');
            seen.add(key);
            const size = this.call('recordsContentSize', normalized);
            // A DRILL card (D2, assistantBoardDrill) says which card and which
            // value it came from — short strings only, anything else dropped.
            const dr = it.drill && typeof it.drill === 'object' && !Array.isArray(it.drill) ? it.drill : null;
            const drill = dr ? {
                from: text(dr.from, 80),
                field: text(dr.field, 80),
                fieldLabel: text(dr.fieldLabel, 80),
                value: text(dr.value, 120),
                valueLabel: text(dr.valueLabel, 120),
                source: text(dr.source, 120)
            } : null;
            items.push({
                key: key,
                kind: 'records',
                size: size,
                title: text(normalized.title && normalized.title.text, 60),
                records: normalized,
                ...drill && drill.from && drill.field ? {
                    drill: drill
                } : {},
                source: {
                    app: normalized.app,
                    dataset: normalized.collection,
                    range: normalized.period && normalized.period.preset || ''
                }
            });
            return;
        }
        // A UI SECTION of a Fly page (server ai-boards flyReads.js, Fly train 2):
        // ONE read's result, drawn with the chat's own answer-UI components — the
        // payload a chat tool call carries (`ui`: render_cards / render_answer_ui
        // and its args), `empty` (the read found nothing) or `error` (it did not
        // come back) once the read is in, none of them while it is still reading.
        // The payload comes from the read, never from the model, and the chat's
        // own gates run on it again when it mounts (functions/assistantFlyUi.js).
        // The key never reads the payload: the card stays the same card when its
        // result lands. The model's size is kept (a result's size is not known
        // when its section opens).
        if (it.kind === 'ui') {
            const read = text(it.read, 16);
            const tool = text(it.tool, 60);
            if (!read || !tool) return drop('ui');
            const raw = it.ui && typeof it.ui === 'object' && !Array.isArray(it.ui) ? it.ui : null;
            const ui = raw && (raw.tool === 'render_cards' || raw.tool === 'render_answer_ui') && raw.args && typeof raw.args === 'object' && !Array.isArray(raw.args) ? {
                tool: raw.tool,
                args: raw.args
            } : null;
            const er = !ui && it.error && typeof it.error === 'object' ? it.error : null;
            const error = er ? {
                code: text(er.code, 40) || 'read_failed',
                status: Number.isFinite(Number(er.status)) ? Number(er.status) : null
            } : null;
            const own = text(it.title && typeof it.title === 'object' ? it.title.text : it.title, 60);
            const pinKey = text(it.pinKey, 40);
            const key = 'u:' + hashOf({
                read: read,
                tool: tool,
                title: own,
                pinKey: pinKey
            });
            if (seen.has(key)) return drop('duplicate');
            seen.add(key);
            // Its words when the model gave none: the view's own heading, else the
            // read's name ("list_projects" → "Projects").
            const words = tool.replace(/^(?:get|list|search|read|run)_/, '').replace(/[_-]+/g, ' ').trim();
            const heading = own || (ui && ui.tool === 'render_answer_ui' ? text(ui.args.title, 60) : '') || (words ? words.charAt(0).toUpperCase() + words.slice(1) : '');
            items.push({
                key: key,
                kind: 'ui',
                read: read,
                tool: tool,
                size: SIZES.includes(it.size) ? it.size : 'm',
                title: heading,
                ui: ui,
                empty: !ui && !error && it.empty === true,
                error: error,
                pinKey: pinKey || null
            });
            return;
        }
        drop('unknown-kind');
    });
    const refine = (Array.isArray(s.refine) ? s.refine : []).map((r)=>({
            label: text(r && r.label, 40),
            prompt: text(r && r.prompt, 500)
        })).filter((r)=>r.label && r.prompt).slice(0, 6);
    const sources = (Array.isArray(s.sources) ? s.sources : []).map((x)=>({
            app: text(x && x.app, 40),
            dataset: text(x && x.dataset, 60)
        })).filter((x)=>x.app).slice(0, 12);
    return {
        spec: {
            v: 1,
            id: text(s.id, 80) || null,
            prompt: text(s.prompt, 500),
            title: text(s.title, 60),
            summary: text(s.summary, 400),
            refine: refine,
            sources: sources,
            generatedAt: text(s.generatedAt, 40) || null,
            model: text(s.model, 80) || null
        },
        items: items,
        total: total,
        dropped: dropped,
        droppedRefs: droppedRefs,
        paramsDropped: paramsDropped
    };
};
const $756dfb2fc3060e22$export$370d221a60120378 = function boardItemsFor(spec, root) {
    const vocab = this.call('boardVocabularyFor', root);
    const res = this.call('validateBoardSpec', spec, vocab);
    const boardId = res.spec.id || 'brd_' + this.call('boardSpecHash', res.spec.prompt + '|' + res.spec.title);
    // Where a records card opens: the page of the app that owns its collection
    // (functions/assistantRecords.js assistantRecordsHref — the record-route
    // registry, then the app's own page), so a Fly section's title and ↗ open
    // it as a widget's do. Null on a host without the records functions.
    const fns = this && this.context && this.context.functions || {};
    const recordsRoute = (records)=>{
        if (typeof fns.assistantRecordsHref !== 'function' || !records) return null;
        const href = this.call('assistantRecordsHref', records, null);
        return typeof href === 'string' && href.startsWith('/') ? href : null;
    };
    const items = res.items.map((it, index)=>{
        if (it.kind === 'widget') {
            const entry = vocab.widgets[it.widgetId];
            // The widget's own square-button action rides as a frozen copy: static
            // manifest data the card only reads (a leaf of the card's state).
            const action = entry.kind !== 'view' && entry.action ? Object.freeze({
                ...entry.action
            }) : null;
            return {
                key: it.key,
                kind: 'widget',
                index: index,
                id: entry.widgetId,
                ref: it.ref,
                moduleId: entry.appId,
                title: it.title || entry.title,
                icon: entry.icon,
                body: entry.body,
                spec: entry.spec,
                hue: entry.hue,
                size: it.size,
                params: it.params,
                openRoute: entry.kind === 'view' ? this.call('assistantAppViewLink', entry.link, it.params, root) : entry.openRoute || null,
                openCall: entry.kind === 'view' ? null : entry.openCall || null,
                action: action,
                ...entry.kind === 'view' ? {
                    view: true,
                    fold: entry.fold || null
                } : {}
            };
        }
        // A Fly page's UI section (validateBoardSpec above): the read it shows and
        // what came back — the card body mounts it with the chat's own renderers
        // (functions/assistantFlyUi.js).
        if (it.kind === 'ui') return {
            key: it.key,
            kind: 'ui',
            index: index,
            id: 'gen:' + boardId + ':' + it.key,
            read: it.read,
            tool: it.tool,
            title: it.title,
            icon: 'analytics',
            size: it.size,
            ui: it.ui,
            empty: it.empty,
            error: it.error,
            pinKey: it.pinKey,
            hue: null,
            params: {}
        };
        const app = it.source.app && vocab.apps[it.source.app] ? vocab.apps[it.source.app] : null;
        const apps = new Set((res.spec.sources || []).map((x)=>x.app));
        // A generated row's id is its VALIDATION key (the block's type + title +
        // data + source hashed), never its index: the cold path re-derives the
        // board when the installed apps publish (assistantBoardRederive) and a
        // widget item joins at its place, so the blocks after it MOVE — an
        // index-based id then read the block data the card before it had stashed
        // under that index (`root._aiWidgetData[id]`), and the card keyed by the
        // same validation key was reused without a re-mount: the list showed its
        // empty line, the numeral an em dash (ws-home, dev e09282f9a).
        if (it.kind === 'records') return {
            key: it.key,
            kind: 'records',
            index: index,
            id: 'gen:' + boardId + ':' + it.key,
            title: it.title || this.call('recordsBlockTitle', it.records),
            icon: 'analytics',
            size: it.size,
            records: it.records,
            openRoute: recordsRoute(it.records),
            ...it.drill ? {
                drill: it.drill
            } : {},
            source: it.source,
            hue: app && app.hue ? app.hue : null,
            params: {}
        };
        return {
            key: it.key,
            kind: 'block',
            index: index,
            id: 'gen:' + boardId + ':' + it.key,
            block: it.block,
            title: it.title,
            icon: 'magicstar',
            size: it.size,
            body: {
                blocks: [
                    it.def
                ]
            },
            data: it.data,
            empty: it.empty,
            viewerCapability: {
                allowed: true,
                reason: 'generated'
            },
            source: it.source,
            footerApp: app && app.label || it.source.app || '',
            // the app's record key — the footer names the app by it (see labelOf)
            footerAppKey: app && app.label && app.appKey || '',
            footerDataset: it.source.dataset || '',
            // One app → its colour; several apps or none → the neutral plate.
            hue: app && (apps.size <= 1 || apps.has(it.source.app)) && it.source.app ? app.hue : null,
            params: it.source.range ? {
                range: it.source.range
            } : {}
        };
    });
    return {
        boardId: boardId,
        spec: res.spec,
        items: items,
        total: res.total,
        dropped: res.dropped
    };
};
const $756dfb2fc3060e22$export$74637247316f5681 = function assistantBoardCardOpen(s, event) {
    const host = typeof this.lookup === 'function' ? this.lookup('CardBody') : null;
    const own = this.call('assistantAppViewOwnRoute', host);
    if (!own) return this.call('homeWidgetOpen', s, event);
    const row = s && typeof s === 'object' ? s : {};
    return this.call('homeWidgetOpen', {
        id: row.id,
        openRoute: own,
        openCall: row.openCall || null,
        spec: null
    }, event);
};
const $756dfb2fc3060e22$export$b7546e056e155297 = function applyBoardChunk(board, chunk, root) {
    const SIZES = [
        's',
        'm',
        'l',
        'xl'
    ];
    if (!board || !chunk || typeof chunk !== 'object') return board;
    if (chunk.type === 'error') return this.call('assistantBoardFailed', board, 'failed');
    const raw = board.raw ? {
        ...board.raw
    } : {
        v: 1,
        prompt: board.prompt,
        items: []
    };
    const done = chunk.type === 'done';
    const full = done && chunk.spec && typeof chunk.spec === 'object' ? chunk.spec : null;
    if (full) {
        Object.assign(raw, full);
        raw.items = Array.isArray(full.items) ? full.items.slice() : raw.items || [];
    } else {
        for (const key of [
            'id',
            'title',
            'summary',
            'refine',
            'sources',
            'generatedAt',
            'model'
        ])if (chunk[key] !== undefined) raw[key] = chunk[key];
        const add = Array.isArray(chunk.items) ? chunk.items : chunk.item ? [
            chunk.item
        ] : [];
        if (add.length) raw.items = (raw.items || []).concat(add);
    }
    const derived = this.call('boardItemsFor', raw, root);
    const count = Number(chunk.count);
    const expected = Number.isFinite(count) && count >= 0 ? Math.min(12, Math.floor(count)) : board.expected;
    const sizes = Array.isArray(chunk.sizes) ? chunk.sizes.filter((x)=>SIZES.includes(x)).slice(0, 12) : board.sizes;
    return {
        ...board,
        status: done ? 'ready' : 'streaming',
        raw: raw,
        boardId: derived.boardId,
        spec: derived.spec,
        items: derived.items,
        total: derived.total,
        dropped: derived.dropped,
        expected: done ? derived.items.length : Math.max(expected || 0, derived.items.length),
        sizes: sizes || null,
        receivedAt: board.receivedAt || Date.now(),
        error: null
    };
};
const $756dfb2fc3060e22$export$90d759f03b5bd77b = function assistantBoardFailed(board, reason) {
    const why = reason === 'timeout' || reason === 'unavailable' ? reason : 'failed';
    const prev = board && board.prev;
    const kept = prev ? {
        raw: prev.raw,
        boardId: prev.boardId,
        spec: prev.spec,
        items: prev.items,
        total: prev.total,
        dropped: prev.dropped,
        receivedAt: prev.receivedAt
    } : {
        raw: null,
        spec: null,
        items: [],
        total: 0,
        dropped: 0
    };
    return {
        ...board || {},
        ...kept,
        status: 'failed',
        error: why,
        expected: 0,
        sizes: null
    };
};
const $756dfb2fc3060e22$export$29704eeae2510b94 = function assistantBoardViewModel(root) {
    const r = root || {};
    const board = r._aiBoard;
    const preview = r._aiBoardPreview === true;
    const ws = r.workspace;
    const live = ws && (ws.id || ws._id) || null;
    if (board && typeof board === 'object') {
        if (!board.workspaceId || !live || String(board.workspaceId) === String(live)) return board;
    }
    if (!preview) return null;
    const derived = this.call('boardItemsFor', this.call('assistantBoardFixture'), r);
    return {
        v: 1,
        status: 'ready',
        requestId: 'preview',
        preview: true,
        prompt: derived.spec.prompt,
        raw: null,
        boardId: derived.boardId,
        spec: derived.spec,
        items: derived.items,
        total: derived.total,
        dropped: derived.dropped,
        expected: derived.items.length,
        sizes: null,
        error: null,
        prev: null,
        pins: {},
        pinAll: null,
        save: null,
        notice: null,
        dismissed: false,
        receivedAt: null
    };
};
const $756dfb2fc3060e22$export$2335f802c238d345 = function assistantBoardPageOnHome(root) {
    const r = root || {};
    const dock = r.assistantDock;
    const available = r._aiBoardsAvailable === true;
    const path = r.currentPath;
    if (dock !== 'main' || !available) return false;
    const route = this.call('stripWorkspacePrefix', typeof path === 'string' && path ? path : '/');
    return route === '/' || route === '';
};
const $756dfb2fc3060e22$export$8e5cb23858bfa300 = function assistantBoardShown(root) {
    const r = root || {};
    const preview = r._aiBoardPreview === true;
    const explicit = r._aiBoardExplicit;
    const path = r.currentPath;
    const dock = r.assistantDock;
    const available = r._aiBoardsAvailable === true;
    const page = this.call('assistantBoardPageOnHome', r);
    const vm = this.call('assistantBoardViewModel', r);
    const fns = this.context && this.context.functions;
    const thread = fns && typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    if (!vm || vm.dismissed) return false;
    const norm = (p)=>{
        const raw = typeof p === 'string' && p ? p : '/';
        const s = this.call('stripWorkspacePrefix', raw);
        const v = typeof s === 'string' ? s : raw;
        return v === '' ? '/' : v.length > 1 ? v.replace(/\/+$/, '') : v;
    };
    const route = norm(path);
    const home = route === '/';
    if (norm(vm.path) !== route) return false;
    // AN EXPLICIT OPEN — a `?board=<id>` link or a board tab (assistantBoardSelect)
    // — shows THAT board on the home whatever the placement and the mode (ws-home's
    // live pass 2026-09-29: with the answers minimized the link loaded the board
    // and the view stayed hidden). A link is not a new preference: the stored
    // placement is untouched; Esc / Back to home / Dismiss end it.
    if (explicit && home && (vm.boardId === explicit || vm.savedId === explicit)) return true;
    if (thread) return false;
    if (home) return preview || page;
    return dock === 'main' && available;
};
const $756dfb2fc3060e22$export$2a7de9bf9c15157e = function assistantBoardOpen(root) {
    const r = root || {};
    const board = !!this.call('assistantBoardShown', r);
    const fns = this.context && this.context.functions;
    const thread = fns && typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    // …and the LIVE DECK (Presentation, functions/assistantDeck.js), and the
    // FLY canvas (functions/assistantFly.js).
    const deck = fns && typeof fns.assistantDeckShown === 'function' ? !!this.call('assistantDeckShown', r) : false;
    const fly = fns && typeof fns.assistantFlyShown === 'function' ? !!this.call('assistantFlyShown', r) : false;
    return board || thread || deck || fly;
};
const $756dfb2fc3060e22$export$1f3eb65228db6f97 = function assistantBoardCells(vm, cols) {
    if (!vm) return [];
    const n = Math.max(1, Math.floor(Number(cols)) || 1);
    // `rev` = the board's Refresh count (D3): a widget body's mount signature
    // carries it, so a refresh re-mounts the app's own body (it reads again).
    const rev = Number(vm.rev) || 0;
    const rows = (vm.items || []).map((it)=>({
            ...it,
            cols: n,
            rev: rev
        }));
    if (!this.call('assistantBoardBusy', vm)) return rows;
    const DEFAULT = [
        'xl',
        'm',
        'm'
    ];
    const sizes = Array.isArray(vm.sizes) ? vm.sizes : [];
    const want = Math.max(Number(vm.expected) || 0, rows.length);
    const cells = rows.slice();
    for(let i = rows.length; i < want; i++)cells.push({
        key: 'skeleton-' + i,
        kind: 'skeleton',
        index: i,
        size: sizes[i] || DEFAULT[i] || 'm',
        cols: n,
        rev: rev
    });
    return cells;
};
const $756dfb2fc3060e22$export$c51ad0685f054503 = function assistantBoardMetrics(s) {
    if (s && Number(s.cols) > 0 && Number(s.cell) > 0) return {
        cols: Number(s.cols),
        gutter: Number(s.gutter) || 0,
        cell: Number(s.cell),
        square: s.square !== false
    };
    const widest = this.call('homeGridMetrics', Number.MAX_SAFE_INTEGER);
    return {
        cols: widest.cols,
        gutter: widest.gutter,
        cell: widest.cell,
        square: widest.square !== false
    };
};
const $756dfb2fc3060e22$export$f8534abeaca9dd73 = function assistantBoardSyncGrid(el, s) {
    const host = el || this;
    const m = this.call('assistantBoardMeasure', host);
    if (!m || !(m.cell > 0) || !s || typeof s.update !== 'function') return false;
    const square = m.square !== false;
    if (s.cols === m.cols && s.cell === m.cell && s.gutter === m.gutter && s.square === square) return false;
    s.update({
        cols: m.cols,
        gutter: m.gutter,
        cell: m.cell,
        square: square
    });
    return true;
};
const $756dfb2fc3060e22$export$a83cab8b4be825ef = function assistantBoardGridStyle(s) {
    const m = this.call('assistantBoardMetrics', s);
    const cell = m.cell + 'px';
    return {
        gridTemplateColumns: 'repeat(' + m.cols + ', minmax(0, ' + cell + '))',
        gridAutoRows: m.square === false ? 'auto' : cell,
        columnGap: m.gutter + 'px',
        rowGap: m.gutter + 'px'
    };
};
const $756dfb2fc3060e22$export$3eac8176228f7b28 = function assistantBoardCardStyle(s, designSystem) {
    const span = this.call('homeWidgetSpan', s && s.size || 's', s && s.cols || 1);
    return {
        gridColumn: 'span ' + span.c,
        gridRow: 'span ' + span.r,
        ...this.call('assistantBoardHueVars', s, designSystem)
    };
};
const $756dfb2fc3060e22$export$629bad7796637c8d = function assistantBoardCardEmpty(el, s) {
    if (!s || s.kind === 'skeleton') return null;
    if (s.kind === 'block') return !!s.empty;
    // A Fly UI section: its read found nothing or did not come back — one
    // sentence; its result drawn — something, unless the chat's own gate
    // refused it when it mounted (the body's one quiet line says `empty`).
    if (s.kind === 'ui') {
        if (s.error || s.empty === true) return true;
        if (!s.ui) return null;
        const mounted = el && el.CardBody && el.CardBody.content;
        if (!mounted) return null;
        return mounted.empty === true;
    }
    if (s.kind === 'records') {
        const entry = this.call('assistantRecordsEntry', s.root, this.call('recordsBlockOf', s));
        const status = entry && entry.status;
        if (!status || status === 'loading') return null;
        return status !== 'ready';
    }
    const host = el && el.CardBody;
    const body = host && host.content;
    if (!body) return null;
    const empty = body.empty;
    return empty === true ? true : empty === false ? false : null;
};
const $756dfb2fc3060e22$export$e589981ba093b6bf = function assistantBoardBusy(vm) {
    return !!vm && (vm.status === 'loading' || vm.status === 'streaming');
};
const $756dfb2fc3060e22$export$98f0c3067638003f = function assistantBoardSummaryReserved(vm) {
    return this.call('assistantBoardBusy', vm) || !!(vm && vm.spec && vm.spec.summary);
};
const $756dfb2fc3060e22$export$a244148bb6c70d61 = function assistantBoardRefineReserved(vm) {
    return this.call('assistantBoardBusy', vm) || !!(vm && vm.spec && vm.spec.refine && vm.spec.refine.length);
};
const $756dfb2fc3060e22$export$35a91a623465ce8f = function assistantBoardSummaryRows(vm) {
    if (!vm) return [];
    const summary = vm.spec && vm.spec.summary;
    if (summary) return this.call('boardSummarySegments', summary);
    if (!this.call('assistantBoardBusy', vm)) return [];
    return [
        {
            key: 'building',
            text: this.call('polyglot', 'workspace.assistantBoard.building'),
            fact: false
        }
    ];
};
const $756dfb2fc3060e22$export$c2c498ab1da72e35 = function assistantBoardActionsIdle(vm) {
    return !vm || vm.preview || vm.status !== 'ready' || !(vm.items || []).length;
};
const $756dfb2fc3060e22$export$2c26d59a947046e1 = function assistantBoardPinAllLabel(vm) {
    if (vm && vm.pinAll === 'pinning') return 1;
    return vm && vm.pinAll === 'pinned' ? 2 : 0;
};
const $756dfb2fc3060e22$export$9fab01b1a6142376 = function assistantBoardSaveLabel(vm) {
    if (vm && vm.save === 'saving') return 1;
    return vm && vm.save === 'saved' ? 2 : 0;
};
const $756dfb2fc3060e22$export$1f7285a0134f79e2 = function assistantBoardSavedId(root, ids) {
    const saved = Array.isArray(root && root._aiBoards) ? root._aiBoards : [];
    for (const id of Array.isArray(ids) ? ids : [
        ids
    ]){
        if (id && saved.some((b)=>b && b.id === id)) return id;
    }
    return null;
};
const $756dfb2fc3060e22$export$4fa63f213467936e = function assistantBoardPinState(root, key) {
    const vm = this.call('assistantBoardViewModel', root);
    return vm && vm.pins ? vm.pins[key] : undefined;
};
const $756dfb2fc3060e22$export$191916d9013c5e8d = function assistantBoardChipsOpen(root) {
    const r = root || {};
    const preview = r._aiBoardPreview === true;
    const page = this.call('assistantBoardPageOnHome', r);
    const chips = this.call('assistantBoardChips', r);
    return chips.length > 0 && (preview || page);
};
const $756dfb2fc3060e22$export$749132f0e8cc79ec = function assistantBoardMicro(vm) {
    if (!vm) return '';
    if (vm.status === 'loading' || vm.status === 'streaming') return this.call('polyglot', 'workspace.assistantBoard.microLoading');
    const shown = (vm.items || []).length;
    const total = Math.max(Number(vm.total) || 0, shown);
    const at = vm.spec && vm.spec.generatedAt || vm.receivedAt || null;
    const when = at ? this.call('timeAgo', at) || '' : '';
    if (shown < total) return this.call('polyglot', 'workspace.assistantBoard.microPartial').replace('{shown}', String(shown)).replace('{total}', String(total)).replace('{when}', when);
    if (shown === 1) return this.call('polyglot', 'workspace.assistantBoard.microOne').replace('{when}', when);
    return this.call('polyglot', 'workspace.assistantBoard.micro').replace('{count}', String(shown)).replace('{when}', when);
};
const $756dfb2fc3060e22$export$b4e2f0e1eac1f810 = function assistantBoardStatus(vm) {
    if (!vm) return '';
    if (vm.status === 'failed') {
        if (vm.error === 'timeout') return this.call('polyglot', 'workspace.assistantBoard.timeout');
        if (vm.error === 'unavailable') return this.call('polyglot', 'workspace.assistantBoard.unavailable');
        return this.call('polyglot', 'workspace.assistantBoard.failed');
    }
    if (vm.status === 'ready' && !(vm.items || []).length) return (vm.total || 0) > 0 ? this.call('polyglot', 'workspace.assistantBoard.noneInstalled') : this.call('polyglot', 'workspace.assistantBoard.empty');
    if (vm.notice === 'pinFailed') return this.call('polyglot', 'workspace.assistantBoard.pinFailed');
    if (vm.notice === 'pinDuplicate') return this.call('polyglot', 'workspace.assistantBoard.pinDuplicate');
    if (vm.notice === 'saveFailed') return this.call('polyglot', 'workspace.assistantBoard.saveFailed');
    // D4 saved boards: what a refused write said.
    if (vm.notice === 'renameFailed') return this.call('polyglot', 'workspace.assistantBoard.renameFailed');
    if (vm.notice === 'duplicateFailed') return this.call('polyglot', 'workspace.assistantBoard.duplicateFailed');
    if (vm.notice === 'deleteFailed') return this.call('polyglot', 'workspace.assistantBoard.deleteFailed');
    return '';
};
const $756dfb2fc3060e22$export$d9b65fc5b46287aa = function boardSummarySegments(summary) {
    const text = typeof summary === 'string' ? summary.trim() : '';
    if (!text) return [];
    const sentences = text.split(/(?<=[.!?…])\s+/).filter(Boolean).slice(0, 2).join(' ');
    const out = [];
    const push = (t, fact)=>{
        if (t) out.push({
            key: 'seg' + out.length,
            text: t,
            fact: fact
        });
    };
    if (sentences.includes('**')) {
        sentences.split('**').forEach((part, i)=>push(part, i % 2 === 1));
        return out;
    }
    const FACT = /(?<![\p{L}\p{N}])(?:[A-Z]{3}\s)?\d(?:[\d.,]*\d)?(?:[KMB%]|\s[\p{L}][\p{L}-]*)?/gu;
    let last = 0;
    for (const m of sentences.matchAll(FACT)){
        push(sentences.slice(last, m.index), false);
        push(m[0], true);
        last = m.index + m[0].length;
    }
    push(sentences.slice(last), false);
    return out;
};
const $756dfb2fc3060e22$export$c0b991862cce8113 = function boardParamsLabel(params) {
    const bag = params && typeof params === 'object' ? params : {};
    const canCall = this && typeof this.call === 'function';
    const lang = canCall && this.call('getActiveLang') || 'en';
    const day = (iso)=>{
        const d = new Date(iso + 'T00:00:00Z');
        if (Number.isNaN(d.getTime())) return iso;
        try {
            return new Intl.DateTimeFormat(lang, {
                day: '2-digit',
                month: '2-digit',
                timeZone: 'UTC'
            }).format(d);
        } catch (_) {
            return iso;
        }
    };
    const parts = [];
    for (const key of Object.keys(bag)){
        const v = bag[key];
        if (v == null || v === '') continue;
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}\.\.\d{4}-\d{2}-\d{2}$/.test(v)) {
            const [a, b] = v.split('..');
            parts.push(day(a) + " \u2013 " + day(b));
        } else if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) parts.push(day(v));
        else parts.push(String(v));
    }
    return parts.join(" \xb7 ");
};
const $756dfb2fc3060e22$export$ee9760c40c6cb2a8 = function boardSizeSpec(size) {
    if (size === 'xl') return {
        w: 12,
        h: 3
    };
    if (size === 'l') return {
        w: 6,
        h: 6
    };
    if (size === 's') return {
        w: 3,
        h: 2
    };
    return {
        w: 6,
        h: 3
    };
};
const $756dfb2fc3060e22$export$bcd8667d0579df7f = function assistantBoardHueVars(item, designSystem) {
    // The ON-SURFACE accent halves (`--home-widget-accent-light` /
    // `--home-widget-accent-dark`) come from the frame's own registered helper,
    // reached through `this.call` because every export in this file is
    // self-contained (see the FRANK note at the top) — one derivation, so a
    // generated card and a home card can never disagree about what a hue reads
    // as on the card surface. `null` asks for the neutral answer (the title
    // ink), which is also what the records block documents for a hue-less card.
    const accent = (bg)=>(this && typeof this.call === 'function' ? this.call('homeWidgetAccentOnSurfaceVars', bg, designSystem) : null) || {
            '--home-widget-accent-light': 'var(--color-title)',
            '--home-widget-accent-dark': 'var(--color-title)'
        };
    const neutral = {
        '--home-widget-hue': 'var(--color-widgetPlate)',
        '--home-widget-hue-ink': 'var(--color-title)',
        ...accent(null)
    };
    const hue = item && typeof item.hue === 'string' ? item.hue : '';
    if (!hue || !designSystem) return neutral;
    const canCall = this && typeof this.call === 'function';
    const entry = canCall && this.call('posterFamilyEntry', hue) || canCall && this.call('homeWidgetHue', null, hue, designSystem) || null;
    // A token the design system NAMES is published as its own variable, so a
    // branded workspace's record override (`--color-posterStudio`, the channel
    // homeWidgetHue.js documents) re-tints the plate too. A tone form
    // (`green-45` — today only the `green` alias) has no variable, and a CSS
    // custom property cannot carry a token: `'--x': 'green-45'` ships the raw
    // string (measured in jsdom — only colour PROPS resolve tone grammar). So a
    // tone form keeps the neutral plate rather than a colour guessed in JS
    // (framework gap: no token resolution for custom-property values).
    const colors = designSystem.color || {};
    const named = (token)=>typeof token === 'string' && /^[A-Za-z][A-Za-z0-9]*$/.test(token) && Object.prototype.hasOwnProperty.call(colors, token);
    if (!entry || !named(entry.bg) || !named(entry.ink)) return neutral;
    return {
        '--home-widget-hue': 'var(--color-' + entry.bg + ')',
        '--home-widget-hue-ink': 'var(--color-' + entry.ink + ')',
        ...accent(entry.bg)
    };
};
const $756dfb2fc3060e22$export$b83c5b3235ccb608 = function assistantBoardPinLabel(item, pinned) {
    const title = item && item.title ? String(this.call('polyglot', item.title)) : '';
    const key = pinned ? 'workspace.assistantBoard.pinnedItem' : 'workspace.assistantBoard.pinItem';
    return this.call('polyglot', key).replace('{title}', title);
};
const $756dfb2fc3060e22$export$3109c1292b5bb185 = function assistantBoardBlockFooter(item) {
    // A records card's rows are LIVE (read under the member's grants), so its
    // footer names the collection, never "AI · …".
    if (item && item.kind === 'records') return this.call('assistantBlockSource', {
        type: 'records',
        block: item.records
    });
    // The app by its App Store name, in the session language (installedAppName
    // with the item's `footerAppKey` — see boardVocabularyFor's labelOf): it
    // read "AI · from Analytics revenue" for Insights. An item with no key (an
    // app the vocabulary does not know, an older pin) reads its words through
    // polyglot, as before.
    const app = item && item.footerApp ? String(this.call('installedAppName', {
        appKey: item.footerAppKey,
        label: item.footerApp
    }) || this.call('polyglot', item.footerApp)) : '';
    if (!app) return this.call('polyglot', 'workspace.assistantBoard.blockFooterBare');
    return this.call('polyglot', 'workspace.assistantBoard.blockFooter').replace('{app}', app).replace('{dataset}', item && item.footerDataset || '').replace(/\s+$/, '');
};
const $756dfb2fc3060e22$export$d87aa24e3a830350 = function assistantBoardEmptyItem(item) {
    const params = this.call('boardParamsLabel', item && item.params || {});
    const title = item && item.title ? item.title : '';
    return this.call('polyglot', 'workspace.assistantBoard.emptyItem').replace('{params}', params || title);
};
const $756dfb2fc3060e22$export$6a8776afb517132d = function assistantBoardMountBody(el, s) {
    const host = el || this;
    if (!host || !s || typeof host.set !== 'function') return;
    const root = s.root;
    if (s.kind === 'block') {
        const sig = 'block/' + s.id + '/' + this.call('boardSpecHash', s.data || null);
        if (host.__boardBodySig === sig) return;
        host.__boardBodySig = sig;
        const bag = root && root._aiWidgetData || {};
        const have = bag[s.id];
        if (root && typeof root.update === 'function' && !(have && have.sig === sig)) root.update({
            _aiWidgetData: {
                ...bag,
                [s.id]: {
                    sig: sig,
                    loading: false,
                    settled: true,
                    denied: false,
                    error: null,
                    data: s.data || {}
                }
            }
        }, {
            preventFetch: true
        });
        host.set({
            extends: 'WidgetRenderer'
        });
        return;
    }
    if (s.kind === 'records') {
        // The records renderer reads its block from this card's row (`records`)
        // and its rows from the shared per-workspace cache.
        const sig = 'records/' + s.id + '/' + this.call('boardSpecHash', s.records || null);
        if (host.__boardBodySig === sig) return;
        host.__boardBodySig = sig;
        host.set({
            extends: 'AssistantRecordsBlock'
        });
        return;
    }
    // A Fly UI section: the read's result through the chat's own answer-UI
    // renderers (functions/assistantFlyUi.js) — once it is in.
    if (s.kind === 'ui') {
        this.call('assistantFlyUiMount', host, s);
        return;
    }
    if (s.kind !== 'widget' || !s.body) return;
    // A widget or view body is workspace-scoped content: it waits for the live
    // workspace, as module config and dashboard prefs do (functions/
    // initialWorkspaceReveal.js). A Fly page restored at boot mounted its views
    // before the SDK had a workspace, so their reads went out with no scope —
    // measured on dev 2026-10-18: /core/docs/list and /core/file-canvas with no
    // workspaceId at 8.2 s, and the Files view listed another scope's items
    // (the five newest notes missing). The shell says "not yet" explicitly
    // (state.js: workspaceReady false, or a warm-cache boot). One wait per host,
    // whatever it answers; the card keeps its skeleton meanwhile.
    if (!host.__boardWsWaited && root && (root.workspaceReady === false || root._bootFromCache === true)) {
        if (host.__boardWsWait) return;
        host.__boardWsWait = true;
        const after = this;
        const go = ()=>{
            host.__boardWsWait = false;
            host.__boardWsWaited = true;
            if (host.node && host.node.isConnected === false) return;
            after.call('assistantBoardMountBody', host, host.state || s);
        };
        Promise.resolve(this.call('awaitInitialWorkspace', root)).then(go, go);
        return;
    }
    // A built-in package's VIEW (functions/assistantAppViews.js): its package is
    // lazy — fold its context first when the component is not registered yet,
    // then mount. One fold per host; the card keeps its skeleton meanwhile.
    if (s.fold && typeof s.body === 'string') {
        // A pending fold, or one that already failed for this view (its quiet
        // line stays — never a fold per update).
        if (host.__boardFoldPending || host.__boardBodySig === 'failed/' + (s.id || '')) return;
        const comps = host.context && host.context.components;
        if (!comps || !comps[s.body]) {
            host.__boardFoldPending = true;
            const again = this;
            const quiet = ()=>{
                // The package's chunk did not load: one quiet line, never an empty
                // frame (U5) — a body that says only that is `empty`.
                host.__boardBodySig = 'failed/' + (s.id || '');
                try {
                    host.set({
                        tag: 'p',
                        margin: '0',
                        fontSize: 'Z',
                        color: 'caption',
                        empty: true,
                        text: String(again.call('polyglot', 'workspace.assistantBlock.viewFailed'))
                    });
                    again.call('assistantBoardBodyMounted', host);
                } catch (_) {
                /* the host is gone */ }
            };
            Promise.resolve(this.call('ensureAppViewContext', s.fold)).then((ok)=>{
                host.__boardFoldPending = false;
                if (!ok) return quiet();
                host.__boardBodySig = null;
                again.call('assistantBoardMountBody', host, s);
            }, ()=>{
                host.__boardFoldPending = false;
                quiet();
            });
            return;
        }
    }
    const modCtx = root && typeof root._moduleDsCtxGet === 'function' ? root._moduleDsCtxGet(s.moduleId) : null;
    const sig = 'widget/' + (s.moduleId || '') + '/' + (s.id || '') + '/' + this.call('boardSpecHash', s.params || {}) + '/' + (modCtx ? 1 : 0) + '/' + (Number(s.rev) || 0);
    if (host.__boardBodySig === sig) return;
    host.__boardBodySig = sig;
    const def = typeof s.body === 'string' ? {
        extends: s.body
    } : {
        ...s.body
    };
    def.params = s.params || {};
    if (modCtx) {
        def.context = modCtx;
        if (modCtx.globalScope) def.scope = typeof def.scope === 'object' && def.scope !== null ? Object.assign({}, modCtx.globalScope, def.scope) : modCtx.globalScope;
    }
    // FRAME CONTRACT v1 — the home host's own shape (pages/main.js
    // _mountModuleWidgetBody): the body reads `el.scope.params` (the widget's
    // schema defaults from the vocabulary + this card's values), `widgetId` and
    // `size`. A COPY of whatever scope the body had — the app's shared
    // globalScope bag is never written (every widget of the app shares it).
    // Before, the card set `params` beside the scope, and a body reading
    // `el.scope.params` rendered its home twin (crm-w1 live leg, 2026-09-27).
    const vocab = this.call('boardVocabularyFor', root);
    const entry = vocab && vocab.widgets ? vocab.widgets[s.id] : null;
    const schema = entry && entry.params && typeof entry.params === 'object' ? entry.params : {};
    const defaults = {};
    for (const [name, d] of Object.entries(schema))if (d && typeof d === 'object' && d.default !== undefined) defaults[name] = d.default;
    def.scope = Object.assign({}, def.scope || null, {
        params: {
            ...defaults,
            ...s.params || {}
        },
        widgetId: s.id,
        size: s.size || 's',
        // A VIEW reads `embedded` to leave out its page chrome and every write
        // control — an answer shows the app's UI read-only.
        ...s.view ? {
            embedded: true
        } : {}
    });
    try {
        host.set(def);
    } catch (err) {
        console.warn('[assistantBoard] widget body mount failed:', s.id, err && err.message);
        // A VIEW that cannot mount says so in one quiet line (U5), never an empty
        // frame; a board widget keeps its own frame's empty state.
        if (s.view) try {
            host.set({
                tag: 'p',
                margin: '0',
                fontSize: 'Z',
                color: 'caption',
                empty: true,
                text: String(this.call('polyglot', 'workspace.assistantBlock.viewFailed'))
            });
        } catch (_) {
        /* the host is gone */ }
    }
    this.call('assistantBoardBodyMounted', host);
};
const $756dfb2fc3060e22$export$9aceb4e6142e5bcd = function assistantBoardBodyMounted(host) {
    const card = host && host.parent;
    if (!card || !host.content || typeof card.update !== 'function') return false;
    try {
        card.update();
    } catch (_) {
        return false;
    }
    return true;
};
const $756dfb2fc3060e22$export$87fc3cea6356eac8 = function assistantBoardMeasure(el) {
    const node = el && el.node;
    const width = node && typeof node.getBoundingClientRect === 'function' ? node.getBoundingClientRect().width : 0;
    return this.call('homeGridMetrics', width);
};
const $756dfb2fc3060e22$export$6ecc25db19e0e694 = function assistantBoardFocus(target) {
    try {
        const root = typeof this.getRoot === 'function' ? this.getRoot() : null;
        if (target === 'composer') {
            const composer = root && root.lookdown ? root.lookdown('CanvasPromptTextarea') : null;
            const field = composer && composer.lookdown ? composer.lookdown('Textarea') : null;
            if (field && field.node && typeof field.node.focus === 'function') field.node.focus();
            return !!field;
        }
        const own = typeof this.lookup === 'function' ? this.lookup('AssistantBoardView') : null;
        const view = own || (root && root.lookdown ? root.lookdown('AssistantBoardView') : null);
        const title = view && view.lookdown ? view.lookdown('BoardTitle') : null;
        if (title && title.node && typeof title.node.focus === 'function') title.node.focus({
            preventScroll: true
        });
        return !!title;
    } catch (_) {
        return false;
    }
};
const $756dfb2fc3060e22$export$4c19d6b3e9857e79 = function assistantBoardShortcuts(el) {
    const view = el || this;
    if (!view || typeof view.call !== 'function') return ()=>false;
    // TWO board views register these — the home's and the page layer's
    // (components/AssistantMainLayer.js, `mainHost: 'over'`): the registry keeps
    // ONE row per id and a removal takes only its own record, so the layer's
    // rows keep their own ids, unlabelled (the ? sheet lists each key once).
    const over = view.mainHost === 'over';
    view.call('listShortcuts');
    // A page SHEET above the view (the PageSlot) is the top layer: the shell's
    // own Esc row closes it first.
    const shown = (h, root)=>{
        const node = view.node;
        if (!node || node.isConnected === false) return false;
        if (root && (root._canvasSlot || root._canvasSlotSecond)) return false;
        return !!view.call('assistantBoardShown', root);
    };
    const offs = [
        view.call('registerShortcut', {
            id: over ? 'assistantBoardDismissOver' : 'assistantBoardDismiss',
            keys: 'escape',
            label: over ? null : 'workspace.assistantBoard.shortcutDismiss',
            group: 'shell.headerTabs.dashboard',
            groupOrder: 3,
            order: 6,
            when: shown,
            run: ()=>view.call('assistantBoardDismiss', {
                    focusComposer: true
                })
        }),
        view.call('registerShortcut', {
            id: over ? 'assistantBoardPinOver' : 'assistantBoardPin',
            keys: 'p',
            label: over ? null : 'workspace.assistantBoard.shortcutPin',
            group: 'shell.headerTabs.dashboard',
            groupOrder: 3,
            order: 7,
            when: shown,
            run: (h, root, e)=>{
                const t = e && e.target;
                const card = t && typeof t.closest === 'function' ? t.closest('[data-board-item]') : null;
                const key = card && typeof card.getAttribute === 'function' ? card.getAttribute('data-board-item') : null;
                const vm = view.call('assistantBoardViewModel', root);
                const item = vm && key ? (vm.items || []).find((it)=>it.key === key) : null;
                if (!item) return false;
                view.call('pinBoardItem', view, view.state, item);
                return true;
            }
        })
    ];
    const off = ()=>offs.map((fn)=>typeof fn === 'function' && fn()).some(Boolean);
    view.__boardShortcutsOff = off;
    return off;
};
const $756dfb2fc3060e22$export$bac282c0282a94d0 = async function assistantBoardGenerate(prompt, opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    const input = prompt && typeof prompt === 'object' ? prompt : {
        prompt: prompt
    };
    const text = String(input.prompt == null ? '' : input.prompt).trim();
    if (!root || typeof root.update !== 'function' || !text) return null;
    const o = {
        ...opts || {}
    };
    if (input.attached) o.attached = input.attached;
    if (input.attachments) o.attachments = input.attachments;
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    const current = root._aiBoard;
    const snap = (b)=>({
            raw: b.raw,
            boardId: b.boardId,
            spec: b.spec,
            items: b.items,
            total: b.total,
            dropped: b.dropped,
            receivedAt: b.receivedAt
        });
    const prev = current && current.status === 'ready' && !current.preview && (current.items || []).length ? snap(current) : current && current.prev || null;
    const requestId = 'req_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
    const op = o.refineOf ? 'refine' : 'generate';
    // ONE view holds the main area: a live deck on screen steps aside
    // (functions/assistantDeck.js). The board belongs to the route it is made
    // on (AI_ASSISTANT_SPEC §12.2 — the page's main area, or the home's).
    const fns = el.context && el.context.functions;
    if (fns && typeof fns.assistantDeckDismiss === 'function') el.call('assistantDeckDismiss');
    if (fns && typeof fns.assistantFlyClose === 'function') el.call('assistantFlyClose');
    const madeOn = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    root.update({
        _aiBoard: {
            v: 1,
            status: 'loading',
            requestId: requestId,
            workspaceId: workspaceId,
            path: madeOn,
            prompt: text,
            op: op,
            refineOf: o.refineOf || null,
            refineSpec: o.refineSpec || null,
            threadId: o.threadId || null,
            startedAt: Date.now(),
            expected: 3,
            sizes: null,
            raw: null,
            boardId: null,
            spec: null,
            items: [],
            total: 0,
            dropped: 0,
            error: null,
            prev: prev,
            pins: {},
            pinAll: null,
            save: null,
            notice: null,
            dismissed: false,
            preview: false,
            receivedAt: null
        }
    }, {
        preventFetch: true
    });
    const isCurrent = ()=>{
        const b = root._aiBoard;
        return !!b && b.requestId === requestId;
    };
    const apply = (chunk)=>{
        if (!isCurrent()) return;
        // A failed request is terminal: after the budget fired (spec §4 — the
        // sentence + Try again + the previous board kept), a late stream frame of
        // the SAME request must not resurrect it into a 'streaming' board whose
        // `done` can never arrive (the race already rejected). Only Try again or
        // a new request (new requestId) replaces a failure.
        const cur = root._aiBoard;
        if (cur && cur.status === 'failed') return;
        const next = el.call('applyBoardChunk', cur, chunk, root);
        if (next && isCurrent()) root.update({
            _aiBoard: next
        }, {
            preventFetch: true
        });
    };
    const fail = (reason)=>{
        if (!isCurrent()) return;
        root.update({
            _aiBoard: el.call('assistantBoardFailed', root._aiBoard, reason)
        }, {
            preventFetch: true
        });
    };
    const reasonOf = (err)=>{
        const msg = String(err && err.message || err || '');
        if (/timeout|timed out/i.test(msg)) return 'timeout';
        if (/unknown entity|does not support op|is not available|not found on service|unknown method/i.test(msg)) return 'unavailable';
        return 'failed';
    };
    const sdk = el.sdk || (typeof el.call === 'function' ? el.call('getSDK') : null);
    // The server contract names the budget; until it exists the view waits 45 s
    // (spec §2: the TARGET is ≤ 8 s, measured on dev before a number is claimed).
    const timeoutMs = Number(o.timeoutMs) > 0 ? Number(o.timeoutMs) : 45000;
    let timer = null;
    try {
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        // STREAMING: the SDK streams only when the caller passes one of ITS
        // callbacks (sdk AiBoardsService `wantsStream`: onEvent / onStart / onHead
        // / onItem / onDrop). `onChunk` alone is not one of them, so every board
        // used to arrive in ONE response at the end (live defect 2026-09-28:
        // "all items arrived at the end"). The head and each item now land the
        // moment the server validates them (server AiBoardService: board.head →
        // board.item … → board.done); `onChunk` stays for the chunk-shaped
        // transports the reducer also reads.
        // REFINE of a generated board sends the board ON SCREEN (`spec`, which the
        // server re-validates); `boardId` alone only finds a SAVED board.
        // WHAT THIS SHELL RENDERS (the server's capability gate): `capabilities:
        // { records: 1 }` only when the records renderer is registered and the SDK
        // resolves records (functions/assistantRecords.js); without it the server
        // emits no records item. sdk 3.14.796 builds the body from a closed key
        // list, so there the field never leaves the client (8076ec6+ forwards it).
        // The shell's SDK answers every method with a promise: the first read of
        // a page may answer a promise — awaited; later reads answer at once.
        let capabilities = el.call('assistantClientCapabilities', sdk);
        if (capabilities && typeof capabilities.then === 'function') capabilities = await capabilities;
        const pending = sdk.execute('ai.boards', op, {
            prompt: text,
            ...o.refineOf ? {
                boardId: o.refineOf
            } : {},
            ...o.refineOf && o.refineSpec ? {
                spec: o.refineSpec
            } : {},
            ...o.threadId ? {
                threadId: o.threadId
            } : {},
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {},
            ...o.attached ? {
                attached: o.attached
            } : {},
            ...o.attachments ? {
                attachments: o.attachments
            } : {},
            ...capabilities ? {
                capabilities: capabilities
            } : {},
            onHead: (head)=>{
                if (head && typeof head === 'object') apply({
                    id: head.id,
                    title: head.title,
                    summary: head.summary
                });
            },
            onItem: (frame)=>{
                if (frame && typeof frame === 'object' && frame.item) apply({
                    item: frame.item
                });
            },
            onChunk: apply
        });
        const res = await Promise.race([
            Promise.resolve(pending),
            new Promise((resolve, reject)=>{
                timer = setTimeout(()=>reject(new Error('timeout')), timeoutMs);
            })
        ]);
        const spec = res && typeof res === 'object' ? res.spec || res.board || res : null;
        apply({
            type: 'done',
            spec: spec && Array.isArray(spec.items) ? spec : null
        });
    } catch (err) {
        fail(reasonOf(err));
    } finally{
        if (timer) clearTimeout(timer);
    }
    const done = root._aiBoard;
    if (!done || done.requestId !== requestId) return null;
    if (done.status === 'ready') {
        const entry = {
            id: done.boardId,
            title: done.spec && done.spec.title || text,
            prompt: text,
            raw: done.raw,
            workspaceId: workspaceId,
            at: Date.now()
        };
        const list = Array.isArray(root._aiBoardHistory) ? root._aiBoardHistory : [];
        const same = (h)=>h && (h.id === entry.id || String(h.prompt || '').toLowerCase() === text.toLowerCase());
        root.update({
            _aiBoardHistory: [
                entry,
                ...list.filter((h)=>!same(h))
            ].slice(0, 5)
        }, {
            preventFetch: true
        });
        el.call('assistantBoardFocus', 'title');
    }
    return done;
};
const $756dfb2fc3060e22$export$57598b8a19b23e3c = function assistantBoardRetry() {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!b || !b.prompt) return null;
    return this.call('assistantBoardGenerate', b.prompt, {
        refineOf: b.refineOf || null,
        refineSpec: b.refineSpec || null,
        threadId: b.threadId || null
    });
};
const $756dfb2fc3060e22$export$45b874060c671a2a = function assistantBoardRefine(entry) {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    const prompt = entry && typeof entry === 'object' ? entry.prompt : entry;
    if (!prompt) return null;
    return this.call('assistantBoardGenerate', prompt, {
        refineOf: b && !b.preview && b.boardId || null,
        refineSpec: b && !b.preview && b.raw || null,
        threadId: b && b.threadId || null
    });
};
const $756dfb2fc3060e22$export$f7f750d8e74b9883 = function assistantBoardDrill(sourceKey, bar) {
    const MAX_ITEMS = 12;
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!root || typeof root.update !== 'function' || !b || typeof b !== 'object') return false;
    if (b.preview || b.status !== 'ready' || !b.raw || !Array.isArray(b.raw.items)) return false;
    const items = Array.isArray(b.items) ? b.items : [];
    const source = items.find((it)=>it && it.key === sourceKey && it.kind === 'records');
    if (!source || !source.records) return false;
    const entry = this.call('assistantRecordsEntry', root, source.records);
    const made = this.call('assistantRecordsDrillOf', source.records, entry, bar);
    if (!made) return false;
    const keyOf = (it)=>{
        if (!it || typeof it !== 'object') return '';
        const n = this.call('recordsBlockNormalize', it);
        return n ? 'r:' + this.call('boardSpecHash', n) : '';
    };
    const kept = b.raw.items.filter((it)=>!(it && it.drill && it.drill.from === sourceKey));
    if (kept.length >= MAX_ITEMS) return false;
    const at = kept.findIndex((it)=>keyOf(it) === sourceKey);
    if (at < 0) return false;
    const next = kept.slice();
    next.splice(at + 1, 0, {
        ...made.block,
        drill: {
            from: sourceKey,
            ...made.drill
        }
    });
    const raw = {
        ...b.raw,
        items: next
    };
    const derived = this.call('boardItemsFor', raw, root);
    root.update({
        _aiBoard: {
            ...b,
            raw: raw,
            boardId: derived.boardId,
            spec: derived.spec,
            items: derived.items,
            total: derived.total,
            dropped: derived.dropped,
            expected: derived.items.length
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$50cbaaf070848e40 = function assistantBoardDrillClose(key) {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!root || typeof root.update !== 'function' || !b || !b.raw || !Array.isArray(b.raw.items)) return false;
    const card = (Array.isArray(b.items) ? b.items : []).find((it)=>it && it.key === key);
    if (!card || !card.drill) return false;
    const next = b.raw.items.filter((it)=>{
        if (!it || !it.drill) return true;
        const n = this.call('recordsBlockNormalize', it);
        return !(n && 'r:' + this.call('boardSpecHash', n) === key);
    });
    const raw = {
        ...b.raw,
        items: next
    };
    const derived = this.call('boardItemsFor', raw, root);
    root.update({
        _aiBoard: {
            ...b,
            raw: raw,
            boardId: derived.boardId,
            spec: derived.spec,
            items: derived.items,
            total: derived.total,
            dropped: derived.dropped,
            expected: derived.items.length
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$60b77b76c56525b5 = function assistantBoardPeriod(vm) {
    const items = vm && Array.isArray(vm.items) ? vm.items : [];
    const presets = items.filter((it)=>it && it.kind === 'records' && it.records && it.records.period).map((it)=>it.records.period.preset);
    if (!presets.length) return '';
    return presets.every((p)=>p === presets[0]) ? presets[0] : '';
};
const $756dfb2fc3060e22$export$177d90fa76afd563 = function assistantBoardPeriodShown(vm) {
    if (!vm || typeof vm !== 'object' || vm.preview || vm.status !== 'ready') return false;
    const items = Array.isArray(vm.items) ? vm.items : [];
    return items.some((it)=>it && it.kind === 'records' && it.records && it.records.period);
};
const $756dfb2fc3060e22$export$37e41006873e6762 = function assistantBoardPeriodOptions() {
    return [
        {
            key: 'today',
            value: 'today',
            text: 'workspace.assistantRecords.periodToday'
        },
        {
            key: 'thisWeek',
            value: 'thisWeek',
            text: 'workspace.assistantRecords.periodThisWeek'
        },
        {
            key: 'thisMonth',
            value: 'thisMonth',
            text: 'workspace.assistantRecords.periodThisMonth'
        },
        {
            key: 'thisQuarter',
            value: 'thisQuarter',
            text: 'workspace.assistantRecords.periodThisQuarter'
        },
        {
            key: 'lastQuarter',
            value: 'lastQuarter',
            text: 'workspace.assistantRecords.periodLastQuarter'
        },
        {
            key: 'thisYear',
            value: 'thisYear',
            text: 'workspace.assistantRecords.periodThisYear'
        }
    ];
};
const $756dfb2fc3060e22$export$5b112e46e7336a4f = function assistantBoardSetPeriod(preset) {
    const PRESETS = [
        'today',
        'thisWeek',
        'thisMonth',
        'thisQuarter',
        'lastQuarter',
        'thisYear'
    ];
    if (!PRESETS.includes(preset)) return false;
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!root || typeof root.update !== 'function' || !b || typeof b !== 'object') return false;
    if (b.preview || b.status !== 'ready' || !b.raw || !Array.isArray(b.raw.items)) return false;
    const keyOf = (it)=>{
        const n = it && typeof it === 'object' ? this.call('recordsBlockNormalize', it) : null;
        return n ? 'r:' + this.call('boardSpecHash', n) : '';
    };
    const moved = {};
    const dated = b.raw.items.map((it)=>{
        const n = it && typeof it === 'object' ? this.call('recordsBlockNormalize', it) : null;
        if (!n || !n.period) return it;
        const next = {
            ...it,
            period: {
                ...n.period,
                preset: preset
            }
        };
        const from = keyOf(it);
        const to = keyOf(next);
        if (from && to) moved[from] = to;
        return next;
    });
    const items = dated.map((it)=>it && it.drill && moved[it.drill.from] ? {
            ...it,
            drill: {
                ...it.drill,
                from: moved[it.drill.from]
            }
        } : it);
    const raw = {
        ...b.raw,
        items: items
    };
    const derived = this.call('boardItemsFor', raw, root);
    root.update({
        _aiBoard: {
            ...b,
            raw: raw,
            boardId: derived.boardId,
            spec: derived.spec,
            items: derived.items,
            total: derived.total,
            dropped: derived.dropped,
            expected: derived.items.length
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$42c8ddfb0c97c276 = function assistantBoardRefresh() {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!root || typeof root.update !== 'function' || !b || typeof b !== 'object') return 0;
    if (b.preview || b.status !== 'ready') return 0;
    let asked = 0;
    for (const it of Array.isArray(b.items) ? b.items : []){
        if (!it || it.kind !== 'records' || !it.records) continue;
        const have = this.call('assistantRecordsEntry', root, it.records);
        if (have && have.status === 'loading') continue;
        this.call('assistantRecordsEnsure', this, {
            root: root,
            records: it.records
        }, 'refresh');
        asked++;
    }
    const widgets = (Array.isArray(b.items) ? b.items : []).some((it)=>it && it.kind === 'widget');
    if (asked || widgets) root.update({
        _aiBoard: {
            ...root._aiBoard,
            rev: (Number(b.rev) || 0) + 1
        }
    }, {
        preventFetch: true
    });
    return asked;
};
const $756dfb2fc3060e22$export$dc9adb0bf29c9f89 = function assistantBoardRefreshing(root) {
    const r = root || {};
    const b = r._aiBoard;
    const bag = r._aiRecords;
    if (!b || !bag) return false;
    return (Array.isArray(b.items) ? b.items : []).some((it)=>{
        if (!it || it.kind !== 'records' || !it.records) return false;
        const e = this.call('assistantRecordsEntry', r, it.records);
        return !!e && e.status === 'loading';
    });
};
const $756dfb2fc3060e22$export$2cefb279083158dd = function assistantBoardManage(root) {
    const r = root || {};
    const vm = this.call('assistantBoardViewModel', r);
    const none = {
        savedId: null,
        canRename: false,
        canDelete: false,
        canDuplicate: false
    };
    if (!vm || vm.preview || vm.status !== 'ready') return none;
    const savedId = this.call('assistantBoardSavedId', r, [
        vm.savedId,
        vm.boardId
    ]);
    if (!savedId) return {
        ...none,
        canRename: true
    };
    const row = (Array.isArray(r._aiBoards) ? r._aiBoards : []).find((b)=>b && b.id === savedId);
    return {
        savedId: savedId,
        canRename: !(row && row.viewerCanEdit === false),
        canDelete: !(row && row.viewerCanDelete === false),
        canDuplicate: true
    };
};
const $756dfb2fc3060e22$export$bfa18e574735af66 = function assistantBoardRenameStart() {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!b || typeof root.update !== 'function') return false;
    if (!this.call('assistantBoardManage', root).canRename) return false;
    const title = b.spec && b.spec.title || b.prompt || '';
    root.update({
        _aiBoard: {
            ...b,
            rename: {
                draft: String(title).slice(0, 60)
            },
            notice: null
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$8b3e3dd24310866d = function assistantBoardRenameDraft(value) {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!b || !b.rename || typeof root.update !== 'function') return false;
    root.update({
        _aiBoard: {
            ...b,
            rename: {
                draft: String(value == null ? '' : value).slice(0, 60)
            }
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$6a11d3635ea5643e = function assistantBoardRenameCancel() {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!b || !b.rename || typeof root.update !== 'function') return false;
    root.update({
        _aiBoard: {
            ...b,
            rename: null
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$fdc455d29f6b036b = async function assistantBoardRename() {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!b || !b.rename || typeof root.update !== 'function') return {
        ok: false
    };
    const title = String(b.rename.draft || '').trim().slice(0, 60);
    if (!title) {
        this.call('assistantBoardRenameCancel');
        return {
            ok: false,
            reason: 'empty'
        };
    }
    const before = b.spec && b.spec.title || '';
    const manage = this.call('assistantBoardManage', root);
    const put = (t, notice)=>{
        const cur = root._aiBoard;
        if (!cur || cur.boardId !== b.boardId) return;
        const history = Array.isArray(root._aiBoardHistory) ? root._aiBoardHistory : null;
        const saved = Array.isArray(root._aiBoards) ? root._aiBoards : null;
        root.update({
            _aiBoard: {
                ...cur,
                rename: null,
                notice: notice || null,
                spec: {
                    ...cur.spec || {},
                    title: t
                },
                ...cur.raw ? {
                    raw: {
                        ...cur.raw,
                        title: t
                    }
                } : {}
            },
            ...history ? {
                _aiBoardHistory: history.map((h)=>h && h.id === b.boardId ? {
                        ...h,
                        title: t
                    } : h)
            } : {},
            ...saved && manage.savedId ? {
                _aiBoards: saved.map((x)=>x && x.id === manage.savedId ? {
                        ...x,
                        title: t
                    } : x)
            } : {}
        }, {
            preventFetch: true
        });
    };
    put(title);
    if (!manage.savedId) return {
        ok: true,
        title: title
    };
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    try {
        const sdk = this.sdk || this.call('getSDK');
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        await sdk.execute('ai.boards', 'update', {
            id: manage.savedId,
            patch: {
                title: title
            },
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        return {
            ok: true,
            title: title
        };
    } catch (err) {
        put(before, 'renameFailed');
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
};
const $756dfb2fc3060e22$export$35b66ec157200d6f = async function assistantBoardDuplicate() {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!b || !b.raw || typeof root.update !== 'function') return {
        ok: false
    };
    if (!this.call('assistantBoardManage', root).canDuplicate) return {
        ok: false
    };
    const title = String(this.call('polyglot', 'workspace.assistantBoard.copyTitle')).replace('{title}', b.spec && b.spec.title || b.prompt || '').slice(0, 60);
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    try {
        const sdk = this.sdk || this.call('getSDK');
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const saved = await sdk.execute('ai.boards', 'save', {
            spec: {
                ...b.raw,
                title: title
            },
            prompt: b.prompt,
            title: title,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const row = saved && typeof saved === 'object' ? saved.data || saved : null;
        if (!row || !row.id) throw new Error('no record');
        const cur = root._aiBoard || b;
        const list = Array.isArray(root._aiBoards) ? root._aiBoards : [];
        root.update({
            _aiBoards: [
                row,
                ...list.filter((x)=>x && x.id !== row.id)
            ],
            _aiBoard: {
                ...cur,
                savedId: row.id,
                save: 'saved',
                notice: null,
                spec: {
                    ...cur.spec || {},
                    title: title
                },
                raw: {
                    ...cur.raw || {},
                    title: title
                }
            }
        }, {
            preventFetch: true
        });
        return {
            ok: true,
            board: row
        };
    } catch (err) {
        const cur = root._aiBoard;
        if (cur) root.update({
            _aiBoard: {
                ...cur,
                notice: 'duplicateFailed'
            }
        }, {
            preventFetch: true
        });
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
};
const $756dfb2fc3060e22$export$dbe0125caab91c1a = function assistantBoardDeleteAsk() {
    const root = this.state && this.state.root;
    if (!root || !root._aiBoard) return false;
    const manage = this.call('assistantBoardManage', root);
    if (!manage.canDelete || !manage.savedId) return false;
    const id = manage.savedId;
    const b = root._aiBoard;
    const name = b.spec && b.spec.title || b.prompt || '';
    const t = (key)=>this.call('polyglot', key);
    this.call('confirmDialog', {
        // a function replacement: a `$` in the board's title stays as typed
        title: String(t('workspace.assistantBoard.deleteTitle')).replace('{title}', ()=>name),
        message: t('workspace.assistantBoard.deleteMessage'),
        confirmText: t('common.action.delete'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>this.call('assistantBoardDelete', {
                id: id
            })
    });
    return true;
};
const $756dfb2fc3060e22$export$46fa6736f5f8fc88 = async function assistantBoardDelete(opts) {
    const root = this.state && this.state.root;
    const b = root && root._aiBoard;
    if (!b || typeof root.update !== 'function') return {
        ok: false
    };
    const manage = this.call('assistantBoardManage', root);
    if (!manage.canDelete || !manage.savedId) return {
        ok: false
    };
    const id = manage.savedId;
    if (!opts || opts.id !== id) return {
        ok: false
    };
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    try {
        const sdk = this.sdk || this.call('getSDK');
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        await sdk.execute('ai.boards', 'remove', {
            id: id,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
    } catch (err) {
        const cur = root._aiBoard;
        if (cur) root.update({
            _aiBoard: {
                ...cur,
                notice: 'deleteFailed'
            }
        }, {
            preventFetch: true
        });
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
    const list = Array.isArray(root._aiBoards) ? root._aiBoards : [];
    const history = Array.isArray(root._aiBoardHistory) ? root._aiBoardHistory : null;
    const cur = root._aiBoard || b;
    root.update({
        _aiBoards: list.filter((x)=>x && x.id !== id),
        ...history ? {
            _aiBoardHistory: history.map((h)=>h && h.savedId === id ? {
                    ...h,
                    savedId: null
                } : h)
        } : {},
        _aiBoard: {
            ...cur,
            savedId: null,
            save: null,
            notice: null
        }
    }, {
        preventFetch: true
    });
    this.call('assistantBoardDismiss', {});
    return {
        ok: true,
        id: id
    };
};
const $756dfb2fc3060e22$export$92ec91cc8aab31a4 = function assistantBoardDismiss(opts) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const b = root._aiBoard;
    // An explicit open ends with the view (the address drops ?board on the next
    // mirror — functions/homeBoardUrl.js reads the current segment).
    if (root._aiBoardExplicit) root.update({
        _aiBoardExplicit: null
    }, {
        preventFetch: true
    });
    if (b && !b.dismissed) root.update({
        _aiBoard: {
            ...b,
            dismissed: true
        }
    }, {
        preventFetch: true
    });
    if (root._aiBoardPreview === true) root.update({
        _aiBoardPreview: false
    }, {
        preventFetch: true
    });
    if (opts && opts.focusComposer) this.call('assistantBoardFocus', 'composer');
    return true;
};
const $756dfb2fc3060e22$export$935632459f1de0e3 = function assistantBoardShow(id) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const list = Array.isArray(root._aiBoardHistory) ? root._aiBoardHistory : [];
    const entry = list.find((h)=>h && h.id === id);
    if (!entry || !entry.raw) return false;
    const derived = this.call('boardItemsFor', entry.raw, root);
    const ws = root.workspace;
    const savedId = this.call('assistantBoardSavedId', root, [
        entry.id,
        entry.savedId,
        derived.boardId
    ]);
    // A chip re-shows the board where it is clicked from (AI_ASSISTANT_SPEC
    // §12.2 — the same "belongs to the route" rule a fresh ask tags with at
    // assistantBoardGenerate's `madeOn`), not wherever it was first made.
    const shownOn = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    root.update({
        _aiBoard: {
            v: 1,
            status: 'ready',
            requestId: 'history_' + entry.id,
            workspaceId: ws && (ws.id || ws._id) || null,
            path: shownOn,
            prompt: entry.prompt,
            op: 'generate',
            refineOf: null,
            threadId: null,
            startedAt: entry.at || null,
            expected: derived.items.length,
            sizes: null,
            raw: entry.raw,
            boardId: derived.boardId,
            spec: derived.spec,
            items: derived.items,
            total: derived.total,
            dropped: derived.dropped,
            error: null,
            prev: null,
            pins: {},
            pinAll: null,
            save: savedId ? 'saved' : null,
            savedId: savedId,
            notice: null,
            dismissed: false,
            preview: false,
            receivedAt: entry.at || null
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$125dc986e105ec40 = function assistantBoardRederive(root) {
    const r = root || this && this.state && this.state.root || null;
    const vm = r && r._aiBoard;
    if (!vm || typeof vm !== 'object' || typeof r.update !== 'function') return false;
    if (vm.status !== 'ready' || vm.preview || !vm.raw) return false;
    const ws = r.workspace;
    const live = ws && (ws.id || ws._id) || null;
    if (vm.workspaceId && live && String(vm.workspaceId) !== String(live)) return false;
    const derived = this.call('boardItemsFor', vm.raw, r);
    // A row's link counts too: a site card's ↗ names its website out of the
    // project list and an App Store app out of the App Store list, both of
    // which can land after the board (MISSING-NAMES-2).
    const rows = (items)=>(Array.isArray(items) ? items : []).map((it)=>[
                it.kind,
                it.key,
                it.id,
                typeof it.body === 'string' ? it.body : '',
                typeof it.openRoute === 'string' ? it.openRoute : ''
            ].join(':')).join('|');
    if (rows(derived.items) === rows(vm.items) && derived.total === vm.total) return false;
    r.update({
        _aiBoard: {
            ...vm,
            spec: derived.spec,
            items: derived.items,
            total: derived.total,
            dropped: derived.dropped,
            expected: derived.items.length
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $756dfb2fc3060e22$export$a8ebbf48682c88dd = function assistantBoardChips(root) {
    const r = root || {};
    const list = Array.isArray(r._aiBoardHistory) ? r._aiBoardHistory : [];
    const ws = r.workspace;
    const live = ws && (ws.id || ws._id) || null;
    return list.filter((h)=>h && h.id && (!h.workspaceId || !live || String(h.workspaceId) === String(live))).slice(0, 5).map((h)=>({
            value: h.id,
            label: h.title || h.prompt,
            prompt: h.prompt
        }));
};
const $756dfb2fc3060e22$export$1a09f738d462e490 = function boardItemWidgetDef(item) {
    if (!item || typeof item !== 'object') return null;
    const size = item.size === 's' || item.size === 'l' || item.size === 'xl' ? item.size : 'm';
    const spec = size === 'xl' ? {
        w: 12,
        h: 3
    } : size === 'l' ? {
        w: 6,
        h: 6
    } : size === 's' ? {
        w: 3,
        h: 2
    } : {
        w: 6,
        h: 3
    };
    const title = String(item.title || item.id || '').slice(0, 60);
    const base = {
        title: title,
        icon: item.icon || 'star',
        ...item.hue ? {
            hue: item.hue
        } : {},
        spec: {
            ...spec,
            minW: 2,
            minH: 2
        }
    };
    if (item.kind === 'widget') return {
        ...base,
        widget: item.ref,
        params: item.params || {}
    };
    // A RECORDS card pins its block by reference (WIDGET-TOOLS-RECORDS-SHAPE-1):
    // the server validates it against the member's collections and the home
    // reads its rows live for each viewer. A chart hint rides only on a chart.
    if (item.kind === 'records') {
        const r = item.records && typeof item.records === 'object' ? item.records : null;
        if (!r) return null;
        const records = {
            ...r,
            kind: 'records'
        };
        if (records.view !== 'chart') delete records.chart;
        return {
            ...base,
            records: records
        };
    }
    const def = item.body && Array.isArray(item.body.blocks) ? item.body.blocks[0] : null;
    return {
        ...base,
        block: {
            type: item.block,
            data: item.data || {},
            ...def && def.format ? {
                format: def.format
            } : {},
            source: item.source || {}
        }
    };
};
const $756dfb2fc3060e22$export$8d86e5bd253dbdec = function boardItemPinHash(itemOrRow) {
    const x = itemOrRow && typeof itemOrRow === 'object' ? itemOrRow : {};
    // A records card / row: the QUERY is its identity — the server's pin key
    // fields (widgets recordsPinKey: never the title or the chart hint), the
    // period without the answer clock a board card carries. Without this branch
    // every records row hashed as "no recipe, no body" and the second records
    // pin read as a duplicate of the first.
    const rec = x.records && typeof x.records === 'object' ? x.records : null;
    if (x.kind === 'records' || rec) {
        const r = rec || {};
        const p = r.period && typeof r.period === 'object' ? r.period : null;
        return this.call('boardSpecHash', {
            records: {
                app: r.app || '',
                collection: r.collection || '',
                view: r.view || '',
                filters: Array.isArray(r.filters) ? r.filters : [],
                period: p ? {
                    field: p.field,
                    preset: p.preset
                } : null,
                aggregate: r.aggregate || null,
                groupBy: r.groupBy || null,
                sort: r.sort || null,
                limit: r.limit != null ? r.limit : null,
                fields: Array.isArray(r.fields) ? r.fields : []
            }
        });
    }
    const widget = typeof x.ref === 'string' && x.ref ? x.ref : typeof x.widget === 'string' ? x.widget : '';
    if (x.kind === 'widget' || widget) return this.call('boardSpecHash', {
        widget: widget,
        params: x.params || {}
    });
    const blk = x.block;
    const blockRow = !!blk && typeof blk === 'object';
    if (x.kind === 'block' || blockRow) return this.call('boardSpecHash', {
        block: {
            type: blockRow ? blk.type : blk,
            data: (blockRow ? blk.data : x.data) || {}
        }
    });
    return this.call('boardSpecHash', {
        dataRecipe: x.dataRecipe || null,
        body: x.body || null
    });
};
const $756dfb2fc3060e22$export$95fae3c0d7bbbe09 = async function pinBoardItem(el, s, item) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    const board = root && root._aiBoard;
    if (!root || typeof root.update !== 'function' || !item || !item.key) return {
        ok: false,
        reason: 'unavailable'
    };
    // A records card pins its block (WIDGET-TOOLS-RECORDS-SHAPE-1): the widget
    // defs store kind 'records' and the home draws it with AssistantRecordsBlock.
    if (!board || board.preview || board.status !== 'ready' || item.kind === 'skeleton') return {
        ok: false,
        reason: 'unavailable'
    };
    const mark = (state, notice)=>{
        const b = root._aiBoard;
        if (!b || b.requestId !== board.requestId) return;
        root.update({
            _aiBoard: {
                ...b,
                pins: {
                    ...b.pins || {},
                    [item.key]: state
                },
                ...notice !== undefined ? {
                    notice: notice
                } : {}
            }
        }, {
            preventFetch: true
        });
    };
    const current = (board.pins || {})[item.key];
    if (current === 'pinned' || current === 'pinning') return {
        ok: false,
        reason: 'duplicate'
    };
    const hash = host.call('boardItemPinHash', item);
    const rows = Array.isArray(root.workspaceAiWidgets) ? root.workspaceAiWidgets : [];
    if (rows.some((row)=>host.call('boardItemPinHash', row) === hash)) {
        mark('duplicate', 'pinDuplicate');
        return {
            ok: false,
            reason: 'duplicate'
        };
    }
    mark('pinning', null);
    let res = null;
    try {
        res = await host.call('aiCreateWidget', host.call('boardItemWidgetDef', item));
    } catch (err) {
        res = {
            ok: false,
            error: err && err.message || String(err)
        };
    }
    if (res && res.ok) {
        mark('pinned', null);
        return {
            ok: true
        };
    }
    mark('failed', 'pinFailed');
    return {
        ok: false,
        reason: 'failed',
        error: res && res.error
    };
};
const $756dfb2fc3060e22$export$578886cf35ad6504 = async function pinAllBoardItems(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    const board = root && root._aiBoard;
    if (!root || !board || board.preview || board.status !== 'ready') return {
        ok: false,
        pinned: 0
    };
    const setAll = (state)=>{
        const b = root._aiBoard;
        if (b && b.requestId === board.requestId) root.update({
            _aiBoard: {
                ...b,
                pinAll: state
            }
        }, {
            preventFetch: true
        });
    };
    setAll('pinning');
    let pinned = 0;
    let failed = 0;
    for (const item of board.items || []){
        const state = (root._aiBoard && root._aiBoard.pins || {})[item.key];
        if (state === 'pinned' || state === 'duplicate' || item.kind === 'records') continue;
        const res = await host.call('pinBoardItem', host, {
            root: root
        }, item);
        if (res && res.ok) pinned++;
        else if (!res || res.reason !== 'duplicate') failed++;
    }
    setAll(failed ? null : 'pinned');
    return {
        ok: !failed,
        pinned: pinned,
        failed: failed
    };
};
const $756dfb2fc3060e22$export$ce68d523af95916d = async function assistantBoardProbe(root, sdk) {
    if (!root || typeof root.update !== 'function') return false;
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    let ok = false;
    try {
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const res = await sdk.execute('ai.boards', 'vocabulary', workspaceId ? {
            workspaceId: workspaceId
        } : {});
        ok = res != null && typeof res === 'object';
    } catch (_) {
        ok = false;
    }
    const now = root.workspace;
    const still = now && (now.id || now._id) || null;
    if (still !== workspaceId) return false;
    if (root._aiBoardsAvailable !== ok) root.update({
        _aiBoardsAvailable: ok
    }, {
        preventFetch: true
    });
    return ok;
};
const $756dfb2fc3060e22$export$14abeb5d9abed53 = function assistantBoardGridRead(el, s, sync) {
    const host = el || this;
    if (!host) return false;
    const reader = typeof sync === 'string' && sync ? sync : 'assistantBoardSyncGrid';
    if (!host.__boardGridRead) {
        host.__boardGridRead = true;
        return this.call(reader, host, s);
    }
    if (host.__boardGridQueued) return false;
    const again = this;
    const read = ()=>{
        host.__boardGridQueued = null;
        if (host.node && host.node.isConnected === false) return;
        again.call(reader, host, s);
    };
    host.__boardGridQueued = setTimeout(read, 0);
    return false;
};
const $756dfb2fc3060e22$export$e2ec55064e71cd08 = function assistantBoardGridReadOff(el) {
    const host = el || this;
    if (!host || !host.__boardGridQueued) return false;
    clearTimeout(host.__boardGridQueued);
    host.__boardGridQueued = null;
    return true;
};
const $756dfb2fc3060e22$export$2cac8829473951d2 = function assistantBoardMounted(el, s) {
    const host = el || this;
    this.call('assistantBoardGridRead', host, s);
    const root = s && s.root;
    const ws = root && root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    if (host.__boardProbed && host.__boardProbedFor === workspaceId) return false;
    host.__boardProbed = true;
    host.__boardProbedFor = workspaceId;
    const sdk = host.sdk || this.call('getSDK');
    this.call('assistantBoardProbe', root, sdk);
    this.call('listBoards', root, sdk);
    return true;
};
const $756dfb2fc3060e22$export$b7329792d7daafe2 = async function saveBoard(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    const board = root && root._aiBoard;
    if (!root || !board || board.preview || board.status !== 'ready' || !board.raw) return {
        ok: false,
        reason: 'unavailable'
    };
    // Already a saved record: nothing to write twice.
    if (board.save === 'saved' && board.savedId) return {
        ok: true,
        already: true
    };
    const mark = (save, notice, savedId)=>{
        const b = root._aiBoard;
        if (b && b.requestId === board.requestId) root.update({
            _aiBoard: {
                ...b,
                save: save,
                notice: notice,
                ...savedId ? {
                    savedId: savedId
                } : {}
            }
        }, {
            preventFetch: true
        });
    };
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    mark('saving', null);
    try {
        const sdk = host.sdk || host.call('getSDK');
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const saved = await sdk.execute('ai.boards', 'save', {
            spec: board.raw,
            prompt: board.prompt,
            title: board.spec && board.spec.title || board.prompt,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const row = saved && typeof saved === 'object' ? saved.data || saved : null;
        if (row && row.id) {
            const list = Array.isArray(root._aiBoards) ? root._aiBoards : [];
            // The session's copy of this board learns the record it became, so a
            // chip that re-opens it reads "Saved" too.
            const history = Array.isArray(root._aiBoardHistory) ? root._aiBoardHistory : null;
            root.update({
                _aiBoards: [
                    row,
                    ...list.filter((x)=>x && x.id !== row.id)
                ],
                ...history ? {
                    _aiBoardHistory: history.map((h)=>h && h.id === board.boardId ? {
                            ...h,
                            savedId: row.id
                        } : h)
                } : {}
            }, {
                preventFetch: true
            });
        }
        mark('saved', null, row && row.id);
        return {
            ok: true,
            board: row
        };
    } catch (err) {
        mark('failed', 'saveFailed');
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
};
const $756dfb2fc3060e22$export$770eb11ca405e9d8 = async function assistantBoardShare(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    const board = root && root._aiBoard;
    if (!root || !board || board.preview || board.status !== 'ready' || !board.raw) return {
        ok: false,
        reason: 'unavailable'
    };
    const mark = (share)=>{
        const b = root._aiBoard;
        if (b && b.requestId === board.requestId) root.update({
            _aiBoard: {
                ...b,
                share: share
            }
        }, {
            preventFetch: true
        });
    };
    if (board.share === 'sharing') return {
        ok: false,
        reason: 'busy'
    };
    mark('sharing');
    try {
        let id = board.save === 'saved' && board.savedId ? board.savedId : null;
        if (!id) {
            const saved = await host.call('saveBoard', host, {
                root: root
            });
            id = saved && saved.board && saved.board.id ? saved.board.id : root._aiBoard && root._aiBoard.savedId;
        }
        if (!id) throw new Error('not saved');
        const sdk = host.sdk || host.call('getSDK');
        const ws = root.workspace;
        const workspaceId = ws && (ws.id || ws._id) || null;
        if (sdk && typeof sdk.execute === 'function') await sdk.execute('ai.boards', 'update', {
            id: id,
            patch: {
                visibility: 'workspace'
            },
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const loc = typeof window !== 'undefined' && window.location ? window.location : null;
        const base = loc ? String(loc.origin || '') + String(loc.pathname || '/') : '/';
        const url = base + '?board=' + encodeURIComponent(id);
        mark('shared');
        const say = (ok)=>{
            try {
                host.call('openNotification', {
                    type: ok ? 'success' : 'error',
                    title: host.call('polyglot', ok ? 'workspace.assistantBoard.linkCopied' : 'workspace.share.copyFailed.title'),
                    message: ok ? host.call('polyglot', 'workspace.assistantBoard.linkCopiedHint') : url
                });
            } catch (_) {
            /* no notification host (a test, a standalone surface) */ }
        };
        const clip = typeof navigator !== 'undefined' && navigator.clipboard ? navigator.clipboard : null;
        if (clip && typeof clip.writeText === 'function') Promise.resolve(clip.writeText(url)).then(()=>say(true), ()=>say(false));
        else say(false);
        return {
            ok: true,
            url: url
        };
    } catch (err) {
        mark('failed');
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
};
const $756dfb2fc3060e22$export$c3b7102987c4a7d0 = function assistantBoardShareLabel(vm) {
    const share = vm && vm.share;
    return share === 'sharing' ? 1 : share === 'shared' ? 2 : 0;
};
const $756dfb2fc3060e22$export$8ff01d7942f07f54 = function assistantBoardToSidebar() {
    const root = this && this.state && this.state.root;
    const board = root && root._aiBoard;
    if (!root || typeof root.update !== 'function' || !board || board.status !== 'ready') return false;
    const boardId = board.boardId || board.spec && board.spec.id || null;
    if (!boardId) return false;
    const card = {
        type: 'board',
        boardId: boardId,
        title: board.spec && board.spec.title || board.prompt || '',
        summary: board.spec && board.spec.summary || '',
        count: Array.isArray(board.items) ? board.items.length : 0
    };
    const list = Array.isArray(root.chatMessages) ? root.chatMessages : [];
    const row = {
        id: 'board-' + boardId + '-' + Date.now().toString(36),
        role: 'assistant',
        text: '',
        ts: Date.now(),
        local: true,
        cards: [
            card
        ]
    };
    this.call('assistantBoardDismiss');
    root.update({
        chatMessages: list.concat(row),
        _homeThreadOpen: false,
        assistantOpen: true
    });
    return true;
};
const $756dfb2fc3060e22$export$29ddff0c5a4a44a1 = async function listBoards(root, sdk) {
    if (!root || typeof root.update !== 'function') return [];
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    let rows = [];
    try {
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const res = await sdk.execute('ai.boards', 'list', workspaceId ? {
            workspaceId: workspaceId
        } : {});
        const list = Array.isArray(res) ? res : res && (res.data || res.items) || [];
        rows = list.filter((x)=>x && x.id);
    } catch (_) {
        rows = [];
    }
    const live = root.workspace;
    const still = live && (live.id || live._id) || null;
    if (still === workspaceId) root.update({
        _aiBoards: rows
    }, {
        preventFetch: true
    });
    return rows;
};
const $756dfb2fc3060e22$export$2223f2dfcfd77cef = async function getBoard(root, sdk, id) {
    if (!id) return {
        ok: false,
        reason: 'missing'
    };
    const ws = root && root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    try {
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const res = await sdk.execute('ai.boards', 'get', {
            id: id,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const row = res && typeof res === 'object' ? res.data || res : null;
        const spec = row && (row.spec || (Array.isArray(row.items) ? row : null));
        return spec ? {
            ok: true,
            spec: spec,
            board: row
        } : {
            ok: false,
            reason: 'missing'
        };
    } catch (err) {
        return {
            ok: false,
            reason: 'unavailable',
            error: err && err.message || String(err)
        };
    }
};
const $756dfb2fc3060e22$export$a5e39cd97fe5bc03 = function assistantBoardSegments(root) {
    const r = root || {};
    const vm = this.call('assistantBoardViewModel', r);
    const saved = Array.isArray(r._aiBoards) ? r._aiBoards : [];
    const rows = [
        {
            key: 'home',
            text: 'workspace.assistantBoard.homeBoard',
            value: 'home'
        }
    ];
    const onScreen = vm && !vm.preview && vm.boardId && vm.status !== 'failed' ? vm.boardId : null;
    // A saved board on screen is ITS saved segment — never listed twice.
    const savedAs = onScreen ? this.call('assistantBoardSavedId', r, [
        vm.savedId,
        onScreen
    ]) : null;
    if (onScreen && !savedAs) rows.push({
        key: onScreen,
        text: vm.spec && vm.spec.title || vm.prompt,
        value: onScreen
    });
    // The LIVE DECK made on the home (Presentation, functions/assistantDeck.js)
    // takes a segment like a board; a saved one is its saved row below.
    const fns = this.context && this.context.functions;
    const deck = fns && typeof fns.assistantDeckViewModel === 'function' ? this.call('assistantDeckViewModel', r) : null;
    const deckPath = deck && typeof deck.path === 'string' && deck.path ? deck.path : '/';
    const deckRoute = this.call('stripWorkspacePrefix', deckPath);
    const deckHome = deckRoute === '/' || deckRoute === '';
    if (deck && deckHome && !deck.preview && deck.id && deck.status === 'ready' && !deck.savedId) rows.push({
        key: deck.id,
        text: deck.title || deck.prompt,
        value: deck.id
    });
    for (const b of saved)if (b && b.id) rows.push({
        key: b.id,
        text: b.title || b.id,
        value: b.id
    });
    return rows.length > 1 ? rows : [];
};
const $756dfb2fc3060e22$export$91bf22081c80a07a = function assistantBoardRowLabel() {
    return this.call('polyglot', 'workspace.assistantBoard.boards');
};
const $756dfb2fc3060e22$export$676622950200ef42 = function assistantBoardCurrentSegment(root) {
    const r = root || {};
    const vm = this.call('assistantBoardViewModel', r);
    // A LIVE DECK on screen is its own segment (its saved row when saved).
    const fns = this.context && this.context.functions;
    if (fns && typeof fns.assistantDeckShown === 'function' && this.call('assistantDeckShown', r)) {
        const deck = this.call('assistantDeckViewModel', r);
        if (deck && (deck.savedId || deck.id)) return deck.savedId || deck.id;
    }
    if (!this.call('assistantBoardShown', r) || !vm || !vm.boardId) return 'home';
    return this.call('assistantBoardSavedId', r, [
        vm.savedId,
        vm.boardId
    ]) || vm.boardId;
};
const $756dfb2fc3060e22$export$ee96f85f447c90ca = async function assistantBoardSelect(value) {
    const root = this.state && this.state.root;
    if (!root) return false;
    const fns = this.context && this.context.functions;
    const hasDeck = !!(fns && typeof fns.assistantDeckOpenSaved === 'function');
    if (value === 'home') {
        if (hasDeck) this.call('assistantDeckDismiss');
        return this.call('assistantBoardDismiss', {});
    }
    // A LIVE DECK (Presentation, functions/assistantDeck.js): the deck on screen
    // is already there (a dismissed one comes back); a SAVED deck opens as a
    // deck — its record's spec is a DeckSpec (kind 'deck', deck contract §6).
    const deck = root._aiDeck;
    if (hasDeck && deck && (deck.id === value || deck.savedId === value)) {
        if (deck.dismissed && typeof root.update === 'function') root.update({
            _aiDeck: {
                ...deck,
                dismissed: false
            }
        }, {
            preventFetch: true
        });
        return true;
    }
    const savedRow = (Array.isArray(root._aiBoards) ? root._aiBoards : []).find((b)=>b && b.id === value);
    if (hasDeck && savedRow && savedRow.kind === 'deck') {
        const sdk = this.sdk || this.call('getSDK');
        const got = await this.call('getBoard', root, sdk, value);
        if (!got || !got.ok) return false;
        return this.call('assistantDeckOpenSaved', {
            ...got.board || savedRow,
            spec: got.spec
        });
    }
    // An EXPLICIT open (a board tab, a cold `?board=` link): the board shows
    // whatever the placement or the mode (assistantBoardShown), and the main
    // thread steps aside so ONE view holds the grid area.
    if (fns && typeof fns.assistantMainThreadClose === 'function') this.call('assistantMainThreadClose');
    if (typeof root.update === 'function') root.update({
        _aiBoardExplicit: String(value)
    }, {
        preventFetch: true
    });
    if (this.call('assistantBoardShow', value)) return true;
    const sdk = this.sdk || this.call('getSDK');
    const res = await this.call('getBoard', root, sdk, value);
    if (!res || !res.ok) return false;
    // A cold `?board=<id>` link can name a saved DECK the list has not shown yet.
    if (hasDeck && res.spec && res.spec.kind === 'deck') {
        if (typeof root.update === 'function') root.update({
            _aiBoardExplicit: null
        }, {
            preventFetch: true
        });
        return this.call('assistantDeckOpenSaved', {
            ...res.board || {},
            id: value,
            spec: res.spec
        });
    }
    const list = Array.isArray(root._aiBoardHistory) ? root._aiBoardHistory : [];
    const ws = root.workspace;
    const entry = {
        id: value,
        title: res.board && res.board.title || res.spec.title || '',
        prompt: res.spec.prompt || '',
        raw: res.spec,
        workspaceId: ws && (ws.id || ws._id) || null,
        at: Date.now()
    };
    root.update({
        _aiBoardHistory: [
            entry,
            ...list.filter((h)=>h && h.id !== value)
        ].slice(0, 5)
    }, {
        preventFetch: true
    });
    return this.call('assistantBoardShow', value);
};

});

parcelRegister("ljZYp", function(module, exports) {

$parcel$export(module.exports, "moduleWidgetGateAllows", () => $f85b71ec56bd11dd$export$a89d5ca275036d7e);
// A manifest widget's `visibleFn` gate (G-H, 2026-10-28) — the ONE evaluation
// both boards share: the home board (pages/main.js _allModuleWidgetsFor, fails
// OPEN) and the assistant board (functions/assistantBoard.js
// boardVocabularyFor, through `this.call`, fails CLOSED).
//
// The gate is a MODULE function, resolved in its owning app's own scope
// (root._moduleFnGet(name, ownerId) — two apps may name the same gate), and
// called as fn(widgetId, root) with `this` = a shim carrying `call` and
// `state.root`, because module functions expect an element.
//
// THE SHIM'S `call` (G-H, found by BESSI lane F): it resolved ONLY the app's
// own functions, so `this.call('moduleRole')` / `this.call('moduleCan', key)`
// answered undefined inside a gate — the shell bridges live in the shell bag
// (workspaceProjects.js capFns), not in the app's own scope. It now resolves
// like a real element's el.call: the app's own function first, then the shell
// function bag (root._moduleFnGet with no owner).
//
// RE-RUN ON `access` (G-H): the board factories re-run on what their LAST run
// read (smbls dynamic tracking). A first run that met no gate function yet
// (the app's functions inject later, with no root signal) read nothing about
// the member, so the arrival of the workspace record's `access` never re-ran
// it: the fail-open answer stayed for the session. The evaluation reads
// root.workspace.access first, every time — the field moduleRole / moduleCan
// answer from (moduleAccessBridge.js) — so every board that gates a widget
// re-runs when the member's access lands or changes.
//
// ONE self-contained export (frank ships every export on its own): the shim
// is built inside, not by a sibling helper.
// true / false from the gate; `fallback` when the widget's gate function has
// not injected yet or throws.
const $f85b71ec56bd11dd$export$a89d5ca275036d7e = function moduleWidgetGateAllows(root, widget, ownerId, fallback) {
    if (!widget || !widget.visibleFn) return true;
    // Subscribe the calling factory to the member's access before anything
    // can return (see RE-RUN ON `access` above).
    const workspace = root && root.workspace;
    workspace && workspace.access;
    const get = root && root._moduleFnGet;
    if (typeof get !== 'function') return fallback;
    const gate = get(widget.visibleFn, ownerId);
    if (typeof gate !== 'function') return fallback;
    const shim = {
        state: {
            root: root
        },
        call: (name, ...args)=>{
            const fn = get(name, ownerId) || get(name);
            return typeof fn === 'function' ? fn.apply(shim, args) : undefined;
        }
    };
    try {
        return !!gate.call(shim, widget.id, root);
    } catch (_) {
        return fallback;
    }
};

});

parcelRegister("PjK35", function(module, exports) {

$parcel$export(module.exports, "assistantSendRoute", () => $09a413d46a42ed46$export$cbe5d2a40ea97287);
$parcel$export(module.exports, "assistantMainThreadOpen", () => $09a413d46a42ed46$export$47c9e2aebe56b3da);
$parcel$export(module.exports, "assistantMainHost", () => $09a413d46a42ed46$export$b2817efe016f05e9);
$parcel$export(module.exports, "assistantMainLayerShown", () => $09a413d46a42ed46$export$935b1a0b0880720b);
$parcel$export(module.exports, "assistantMainLayerOpen", () => $09a413d46a42ed46$export$7eea03e96b12b85a);
$parcel$export(module.exports, "assistantMainThreadShow", () => $09a413d46a42ed46$export$fc475de1837dd0e7);
$parcel$export(module.exports, "assistantMainThreadSession", () => $09a413d46a42ed46$export$633fca64a9778449);
$parcel$export(module.exports, "assistantOpenThread", () => $09a413d46a42ed46$export$d8012c5f5d601c2);
$parcel$export(module.exports, "assistantMainThreadClose", () => $09a413d46a42ed46$export$ee7c16272b28b124);
$parcel$export(module.exports, "assistantMainThreadSync", () => $09a413d46a42ed46$export$2c8528c74b389693);
$parcel$export(module.exports, "assistantThreadToSidebar", () => $09a413d46a42ed46$export$f99f739f603eb46d);
$parcel$export(module.exports, "assistantThreadToMain", () => $09a413d46a42ed46$export$6fcd099f1a53a6f6);
$parcel$export(module.exports, "assistantThreadCanMoveToMain", () => $09a413d46a42ed46$export$42c82326d91f5096);
$parcel$export(module.exports, "assistantThreadRows", () => $09a413d46a42ed46$export$261cb1a145a61666);
$parcel$export(module.exports, "assistantThreadMicro", () => $09a413d46a42ed46$export$4d5eb2b5d137113e);
$parcel$export(module.exports, "assistantMainThreadShortcuts", () => $09a413d46a42ed46$export$350caf3e0d4c5e9b);
// assistantMainThread.js — THE MAIN THREAD (AI_ASSISTANT_SPEC v1 §1 + §8 and
// v1.1 §12.2; Nika's pick 6 A, the DEFAULT placement). Nika 2026-09-28: "when I
// ask something to AI, it should use generative capabilities and render into
// MainColumn … lets try MainColumn as AI thread as default option"; 2026-09-29:
// "make main thread ai as default" — main thread = "Everywhere".
//
// MODE × PLACEMENT. The mode (`assistantMode`, functions/assistantMode.js) is
// WHAT the AI produces; the placement (`assistantDock`, functions/
// assistantDock.js) is WHERE it shows. With the main placement
// (`assistantDock === 'main'`) on ANY route:
//   dashboard     → a GENERATED BOARD over the main area (functions/
//                   assistantBoard.js — the ai.boards path, one fast call);
//   presentation  → a LIVE DECK over the main area (functions/assistantDeck.js,
//                   the same path's deck shape);
//   assistant     → the MAIN THREAD: the SAME general-scope conversation the
//   tools           sidebar shows (`root.chatMessages`, the chat agent with every
//   apps            tool) — a reading column for text, full-width rows for blocks
//                   (components/AssistantMainThread.js).
// The MAIN AREA is the home's grid area on the home (pages/main.js mounts the
// views there) and the page sheet everywhere else (components/
// AssistantMainLayer.js lays the same views over the page; the page stays
// mounted underneath and keeps its state). A page SHEET open in the PageSlot
// covers the main area, so a send there keeps the compact path (the reasoning
// pill over the sheet). Another placement (sidebar, minimized) takes today's
// path: the drawer or the pill. The mode rides every dispatch either way
// (simoneAiTransport → `context.assistantMode`).
//
// THE FLAG. `root._homeThreadOpen` says the main thread is up (the name
// predates §12.2; it holds for every route now), `root._mainThreadPath` the
// route it opened on. The reasoning pill and the suggestion island step aside
// while the flag is set (shared/_simone), so the thread is the turn's ONE
// surface. It is cleared whenever the thread cannot show: Esc / Back, Open in
// sidebar, a board or a deck taking the view, the placement leaving 'main', a
// NAVIGATION (the page the person went to shows — the conversation stays in
// the sidebar and the thread chips).
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained — the few literals are restated.
// Where a composer send goes: 'fly' | 'board' | 'deck' | 'thread' | null
// (today's path). FLY (docs/FLY_MODE.md) is its own canvas in every placement. The FIVE modes of AI_ASSISTANT_SPEC §12.1 take two brains: DASHBOARD
// and PRESENTATION are the ai.boards path (one fast call, no tools — a board,
// a live deck); ASSISTANT, TOOLS and APPS are the chat agent with every tool
// (the main thread). A board or a deck the service cannot take yet is a
// thread turn (the server answers it like Assistant, deck contract §7). Any
// route (§12.2); a page sheet open in the PageSlot keeps today's path — the
// sheet covers the main area, and the reasoning pill carries the turn over it.
// `askMode` — one ask's own output (the focus panel's Summarize / Build a
// board, functions/aiPanel.js) routes that ask; absent, the person's mode.
const $09a413d46a42ed46$export$cbe5d2a40ea97287 = function assistantSendRoute(root, askMode) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return null;
    if (r._canvasSlot || r._canvasSlotSecond) return null;
    const modes = [
        'assistant',
        'dashboard',
        'tools',
        'apps',
        'presentation',
        'fly'
    ];
    const mode = modes.includes(askMode) ? askMode : modes.includes(r.assistantMode) ? r.assistantMode : 'assistant';
    const fns = this && this.context && this.context.functions;
    // FLY is a canvas of pages in the main area by nature ("the conversation IS
    // the site") — whatever the placement, once the board service answers here
    // (`_aiBoardsAvailable`; the fly page engine falls back to a board on a
    // server without its shape).
    if (mode === 'fly' && r._aiBoardsAvailable === true && !!fns && typeof fns.assistantFlyGenerate === 'function') return 'fly';
    if (r.assistantDock !== 'main') return null;
    const boards = r._aiBoardsAvailable === true && !!fns;
    if (mode === 'dashboard' && boards && typeof fns.assistantBoardGenerate === 'function') return 'board';
    if (mode === 'presentation' && boards && typeof fns.assistantDeckGenerate === 'function') return 'deck';
    return 'thread';
};
const $09a413d46a42ed46$export$47c9e2aebe56b3da = function assistantMainThreadOpen(root) {
    const r = root && typeof root === 'object' ? root : {};
    const open = r._homeThreadOpen === true;
    const dock = r.assistantDock;
    const raw = typeof r.currentPath === 'string' && r.currentPath ? r.currentPath : '/';
    const at = r._mainThreadPath;
    if (!open || dock !== 'main') return false;
    if (typeof at !== 'string' || !at) return true;
    const norm = (p)=>{
        const s = typeof this.call === 'function' ? this.call('stripWorkspacePrefix', p) : p;
        const v = typeof s === 'string' ? s : p;
        return v === '' ? '/' : v.length > 1 ? v.replace(/\/+$/, '') : v;
    };
    return norm(raw) === norm(at);
};
const $09a413d46a42ed46$export$b2817efe016f05e9 = function assistantMainHost(root) {
    const r = root && typeof root === 'object' ? root : {};
    const raw = typeof r.currentPath === 'string' && r.currentPath ? r.currentPath : '/';
    const stripped = typeof this.call === 'function' ? this.call('stripWorkspacePrefix', raw) : raw;
    const path = typeof stripped === 'string' ? stripped : raw;
    return path === '/' || path === '' ? 'home' : 'over';
};
const $09a413d46a42ed46$export$935b1a0b0880720b = function assistantMainLayerShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const host = this.call('assistantMainHost', r);
    const thread = !!this.call('assistantMainThreadOpen', r);
    const fns = this && this.context && this.context.functions;
    const board = fns && typeof fns.assistantBoardShown === 'function' ? !!this.call('assistantBoardShown', r) : false;
    const deck = fns && typeof fns.assistantDeckShown === 'function' ? !!this.call('assistantDeckShown', r) : false;
    const fly = fns && typeof fns.assistantFlyShown === 'function' ? !!this.call('assistantFlyShown', r) : false;
    // A call's theater (meet functions/meetFly.js — registered with the call's
    // meet context): the call's Fly pages over the call.
    const call = fns && typeof fns.meetFlyTheaterShown === 'function' ? !!this.call('meetFlyTheaterShown', r) : false;
    return host === 'over' && (thread || board || deck || fly || call);
};
const $09a413d46a42ed46$export$7eea03e96b12b85a = function assistantMainLayerOpen(host) {
    const origin = host || this;
    const st = origin && origin.state;
    const root = st && st.root || st || null;
    if (!root || root._canvasSlot || root._canvasSlotSecond) return false;
    return !!(origin && typeof origin.call === 'function' && origin.call('assistantMainLayerShown', root));
};
const $09a413d46a42ed46$export$fc475de1837dd0e7 = function assistantMainThreadShow() {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const fns = this.context && this.context.functions;
    if (fns && typeof fns.assistantBoardDismiss === 'function') this.call('assistantBoardDismiss');
    if (fns && typeof fns.assistantDeckDismiss === 'function') this.call('assistantDeckDismiss');
    if (fns && typeof fns.assistantFlyClose === 'function') this.call('assistantFlyClose');
    // A call's theater (meet functions/meetFly.js) steps aside too: the call
    // comes back under the thread's layer only when the thread closes.
    if (fns && typeof fns.meetFlyTheater === 'function') this.call('meetFlyTheater', false);
    const path = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    if (root._homeThreadOpen !== true || root._mainThreadPath !== path) root.update({
        _homeThreadOpen: true,
        _mainThreadPath: path
    }, {
        preventFetch: true
    });
    // A send opened it: the composer is the opener (Esc returns there).
    const app = typeof this.getRoot === 'function' ? this.getRoot() : null;
    if (app) app.__mainThreadOpener = null;
    this.call('assistantMainThreadSession');
    return true;
};
const $09a413d46a42ed46$export$633fca64a9778449 = function assistantMainThreadSession() {
    const root = this && this.state && this.state.root;
    if (!root) return null;
    if (root.activeSessionId) return root.activeSessionId;
    const list = Array.isArray(root.chatMessages) ? root.chatMessages : [];
    if (list.length) return null;
    const fns = this.context && this.context.functions;
    if (!fns || typeof fns.ensureActiveSession !== 'function') return null;
    this.call('ensureActiveSession');
    return root.activeSessionId || null;
};
const $09a413d46a42ed46$export$d8012c5f5d601c2 = function assistantOpenThread(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return null;
    const fns = this && this.context && this.context.functions || {};
    const has = (name)=>typeof fns[name] === 'function';
    const list = Array.isArray(r.chatMessages) ? r.chatMessages : [];
    if (r.activeSessionId || list.length) return null;
    if (!has('assistantFlySession') || !has('switchSession')) return null;
    const mode = r.assistantMode;
    const view = has('assistantEffectiveView') ? this.call('assistantEffectiveView', r) : null;
    if (mode !== 'fly' && mode !== 'dashboard' && view !== 'pages') return null;
    if (!this.call('assistantFlySession', r) && has('assistantFlyRestore')) this.call('assistantFlyRestore', r);
    const fly = this.call('assistantFlySession', r);
    const id = fly && typeof fly.threadId === 'string' && fly.threadId ? fly.threadId : null;
    if (!id) return null;
    // The switch reads the thread from the server and logs its own failure; a
    // thread it cannot read leaves the chat as it was.
    const loading = this.call('switchSession', id);
    if (loading && typeof loading.catch === 'function') loading.catch(()=>null);
    return id;
};
const $09a413d46a42ed46$export$ee7c16272b28b124 = function assistantMainThreadClose(opts) {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    if (root._homeThreadOpen === true || root._mainThreadPath) root.update({
        _homeThreadOpen: false,
        _mainThreadPath: null
    }, {
        preventFetch: true
    });
    // Focus: back to the OPENER when a page button opened the thread (the
    // shell's open edge records it — app.js), else to the composer.
    const app = typeof this.getRoot === 'function' ? this.getRoot() : null;
    const opener = app ? app.__mainThreadOpener : null;
    if (app) app.__mainThreadOpener = null;
    if (opts && opts.focusComposer) {
        const doc = opener && opener.ownerDocument;
        if (opener && opener.isConnected !== false && typeof opener.focus === 'function' && (!doc || opener !== doc.body)) {
            try {
                opener.focus({
                    preventScroll: true
                });
            } catch (_) {
            /* the opener cannot take focus — the composer below */ }
            // focus() never throws for an element the browser refuses (hidden,
            // disabled, inert) — it leaves focus where it was. Only an opener that
            // really HOLDS focus now ends here; otherwise the composer takes it.
            if (doc && doc.activeElement === opener) return true;
        }
        const fns = this.context && this.context.functions;
        if (fns && typeof fns.assistantBoardFocus === 'function') this.call('assistantBoardFocus', 'composer');
    }
    return true;
};
const $09a413d46a42ed46$export$2c8528c74b389693 = function assistantMainThreadSync(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r || r._homeThreadOpen !== true || typeof r.update !== 'function') return false;
    const raw = typeof r.currentPath === 'string' && r.currentPath ? r.currentPath : '/';
    const at = r._mainThreadPath;
    const norm = (p)=>{
        const s = typeof this.call === 'function' ? this.call('stripWorkspacePrefix', p) : p;
        const v = typeof s === 'string' ? s : p;
        return v === '' ? '/' : v.length > 1 ? v.replace(/\/+$/, '') : v;
    };
    const moved = typeof at === 'string' && !!at && norm(raw) !== norm(at);
    if (r.assistantDock === 'main' && !moved) return false;
    r.update({
        _homeThreadOpen: false,
        _mainThreadPath: null
    }, {
        preventFetch: true
    });
    return true;
};
const $09a413d46a42ed46$export$f99f739f603eb46d = function assistantThreadToSidebar() {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const patch = {
        _homeThreadOpen: false,
        _mainThreadPath: null,
        assistantOpen: true
    };
    if (root.assistantDock === 'main') {
        const side = this.call('lastAssistantSide');
        patch.assistantDock = side === 'left' ? 'left' : 'right';
        patch._assistantDockPromotedFrom = 'main';
    }
    root.update(patch);
    return true;
};
const $09a413d46a42ed46$export$6fcd099f1a53a6f6 = function assistantThreadToMain() {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const promoted = root._assistantDockPromotedFrom === 'main';
    if (!promoted && root.assistantDock !== 'main') this.call('setAssistantDock', 'main');
    const fns = this.context && this.context.functions;
    if (fns && typeof fns.assistantBoardDismiss === 'function') this.call('assistantBoardDismiss');
    if (fns && typeof fns.assistantDeckDismiss === 'function') this.call('assistantDeckDismiss');
    // ONE view holds the main area: the Fly canvas and a call's theater step
    // aside too, as assistantMainThreadShow does — a thread link (`?ai=`) on a
    // Fly session drew the thread over the open canvas, the same answers twice
    // (Nika 2026-10-18: "it duplicates ui").
    if (fns && typeof fns.assistantFlyClose === 'function') this.call('assistantFlyClose');
    if (fns && typeof fns.meetFlyTheater === 'function') this.call('meetFlyTheater', false);
    const path = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    root.update({
        assistantOpen: false,
        _homeThreadOpen: true,
        _mainThreadPath: path
    });
    // The drawer that held focus is gone: focus goes to the composer the thread
    // answers through (never the body). Esc then returns there too.
    const app = typeof this.getRoot === 'function' ? this.getRoot() : null;
    if (app) app.__mainThreadOpener = null;
    if (fns && typeof fns.assistantBoardFocus === 'function') this.call('assistantBoardFocus', 'composer');
    return true;
};
const $09a413d46a42ed46$export$42c82326d91f5096 = function assistantThreadCanMoveToMain(root) {
    const r = root && typeof root === 'object' ? root : {};
    const list = r.chatMessages;
    return Array.isArray(list) && list.length > 0;
};
const $09a413d46a42ed46$export$261cb1a145a61666 = function assistantThreadRows(list, cache) {
    const WIDE = [
        'view',
        'records',
        'board',
        'widget',
        'form',
        'sources',
        'capabilities'
    ];
    const all = Array.isArray(list) ? list.filter((m)=>m && typeof m === 'object') : [];
    const draws = (m)=>m.role !== 'assistant' || !!m.text || !!m.streaming || Array.isArray(m.cards) && m.cards.length > 0 || Array.isArray(m.tools) && m.tools.length > 0 || !!(m.metadata && m.metadata.kind === 'note' && m.metadata.plan);
    const at = [];
    const rows = [];
    all.forEach((m, i)=>{
        if (!draws(m)) return;
        at.push(i);
        rows.push(m);
    });
    const previous = cache?.threadRows || [];
    const next = [];
    let prevRole = null;
    const result = rows.map((m, i)=>{
        const grouped = m.role === prevRole;
        prevRole = m.role;
        const key = String(m.id || 'm' + at[i]);
        const last = i === rows.length - 1;
        const hit = previous[i];
        const fields = Object.keys(m);
        const cards = Array.isArray(m.cards) ? m.cards : [];
        const sameCards = hit && hit.row.key === key && hit.cardSnapshot.length === cards.length && cards.every((card, index)=>Object.is(card, hit.cardSnapshot[index]));
        // Streaming replaces only its current message. Retain settled rows and
        // block arrays so a delta cannot reconcile every chart in the thread.
        // Compare a shallow snapshot too: a caller may update a message in place.
        if (hit && hit.row.key === key && hit.row._last === last && hit.row._grouped === grouped && sameCards && fields.length === Object.keys(hit.source).length && fields.every((field)=>Object.is(m[field], hit.source[field]))) {
            next.push(hit);
            return hit.row;
        }
        const wide = sameCards ? hit.row._wide : cards.filter((c)=>c && WIDE.includes(c.type));
        const row = {
            ...m,
            key: key,
            cards: sameCards ? hit.row.cards : wide.length ? cards.filter((c)=>!(c && WIDE.includes(c.type))) : cards,
            _wide: wide,
            _grouped: grouped,
            _last: last
        };
        next.push({
            source: {
                ...m
            },
            cardSnapshot: cards.slice(),
            row: row
        });
        return row;
    });
    if (cache) {
        const settled = cache.threadRowResult;
        if (settled?.length === result.length && result.every((row, i)=>row === settled[i])) return settled;
        cache.threadRows = next;
        cache.threadRowResult = result;
    }
    return result;
};
const $09a413d46a42ed46$export$4d5eb2b5d137113e = function assistantThreadMicro(root) {
    const r = root && typeof root === 'object' ? root : {};
    const words = {
        assistant: 'workspace.assistantThread.modeAssistant',
        dashboard: 'workspace.assistantThread.modeDashboard',
        tools: 'workspace.assistantThread.modeTools',
        apps: 'workspace.assistantThread.modeApps',
        presentation: 'workspace.assistantThread.modePresentation'
    };
    const views = {
        chat: 'workspace.homeView.chat',
        home: 'workspace.homeView.chat',
        pages: 'canvas.navbar.pages.panelTitle',
        build: 'workspace.assistantThread.modeApps',
        present: 'workspace.assistantThread.modePresentation'
    };
    const mode = words[r.assistantMode] ? r.assistantMode : 'assistant';
    const fns = this.context && this.context.functions || {};
    const view = typeof fns.assistantEffectiveView === 'function' ? this.call('assistantEffectiveView', r) : null;
    const list = Array.isArray(r.chatMessages) ? r.chatMessages : [];
    const asks = list.filter((m)=>m && m.role === 'user').length;
    const word = String(this.call('polyglot', views[view] || words[mode]));
    const line = String(this.call('polyglot', asks === 1 ? 'workspace.assistantThread.microOne' : 'workspace.assistantThread.micro'));
    return line.replace('{mode}', word).replace('{count}', String(asks));
};
const $09a413d46a42ed46$export$350caf3e0d4c5e9b = function assistantMainThreadShortcuts(el) {
    const view = el || this;
    if (!view || typeof view.call !== 'function') return ()=>false;
    const over = view.mainHost === 'over';
    view.call('listShortcuts');
    const off = view.call('registerShortcut', {
        id: over ? 'assistantThreadCloseOver' : 'assistantThreadClose',
        keys: 'escape',
        label: over ? null : 'workspace.assistantThread.shortcutClose',
        group: 'shell.headerTabs.dashboard',
        groupOrder: 3,
        order: 8,
        // A page SHEET above the thread (the AI opened a page in split during the
        // turn) is the top layer: the shell's own Esc row closes it first.
        when: (h, root)=>{
            const node = view.node;
            if (!node || node.isConnected === false) return false;
            if (root && (root._canvasSlot || root._canvasSlotSecond)) return false;
            return !!view.call('assistantMainThreadOpen', root);
        },
        run: ()=>view.call('assistantMainThreadClose', {
                focusComposer: true
            })
    });
    const stop = ()=>typeof off === 'function' ? !!off() : false;
    view.__threadShortcutsOff = stop;
    return stop;
};

});

parcelRegister("bBP8k", function(module, exports) {

$parcel$export(module.exports, "assistantAskIntent", () => $873ad0703a323dd5$export$83fec280aaf882e1);
$parcel$export(module.exports, "assistantEffectiveView", () => $873ad0703a323dd5$export$f5507dcdf21fc4c9);
$parcel$export(module.exports, "assistantAskRoute", () => $873ad0703a323dd5$export$880b662e283fb362);
$parcel$export(module.exports, "assistantAskNotify", () => $873ad0703a323dd5$export$6fe2986894eee6b4);
$parcel$export(module.exports, "assistantAskBack", () => $873ad0703a323dd5$export$f2548ae7f2d632fc);
$parcel$export(module.exports, "assistantAskHandoff", () => $873ad0703a323dd5$export$292f2046f498d2ac);
$parcel$export(module.exports, "assistantThreadBesidePane", () => $873ad0703a323dd5$export$da72191d06fb7b36);
// assistantAskRoute.js — THE ASK ROUTER (the workspace AI overhaul, 2026-10-28).
//
// Nika's debugged thread (dev, 2026-10-27): one conversation said "Dashboard ·
// 7 questions" in its head, "Describe a dashboard…" in the composer and Pages
// in the Ask menu, while every answer came as chat. A document ask became a
// chat answer in one view and a generated page in another, and a board that
// the service could not make became a silent chat turn. ONE decision now
// routes every ask, and ONE reader names the view the labels show:
//
//   THE VIEW IS THE DEFAULT. Chat answers in the chat; Pages makes a Fly page;
//   the Home tab answers a question in the chat; Apps keeps its builder
//   conversation; Present makes a live deck.
//   A CLEAR INTENT SWITCHES, from any view: a dashboard → a Fly page (a
//   generated board when Fly is not here, else the chat with one note); an app
//   → the app builder; slides → a live deck; a website → the site builder when
//   one is registered; a document, an open or an action → the chat thread (its
//   tools do those); the tour → the tour. A switch says so in one quiet line
//   with one way back (assistantAskNotify, assistantAskBack). Never modal.
//   AN EXPLICIT ASK MODE (the composer's focus panel) and a question about a
//   picked region keep their own routes (functions/homeAiSend.js).
//
// The person's stored mode is never written here: a switch on the home moves
// the home's VIEW with the tabs' local form (functions/homeView.js
// homeViewSelect — `setAssistantMode(m, { local: true })`).
//
// Addendum (orchestrator, 2026-10-28): a stored 'dashboard' mode reads as the
// Pages view and 'tools' as the Chat view — mapped here at read time, the
// stored value untouched.
//
// FRANK: every export is self-contained — no import, no module-scope helper,
// no bare call to a sibling (frank revives each export alone, FA204); a sibling
// is reached through `this.call('name', …)`.
// WHAT THE ASK WANTS: 'question' | 'dashboard' | 'document' | 'website' |
// 'app' | 'deck' | 'open' | 'action' | 'tour'. Conservative by design: only a
// request verb at the start (after "please", "can you", "გთხოვთ", …) with a
// known object, or a bare noun phrase ("a board of my tickets"), names a
// surface. A question, a status ask ("are you still doing the document?"), a
// negation ("do not build a tracker") and anything else is a 'question' — the
// view answers it. A QUOTED TITLE is a name, never a verb or an object ("Open
// the 'Lead Generation Strategy' document" opens it). English and Georgian,
// the informal and the polite plural (შექმენი / შექმენით).
const $873ad0703a323dd5$export$83fec280aaf882e1 = function assistantAskIntent(text) {
    const raw = String(text == null ? '' : text).replace(/[’‘]/g, "'").replace(/\s+/g, ' ').trim();
    if (!raw) return 'question';
    // A quoted title reads as one neutral word ('qq').
    const t = (' ' + raw + ' ').replace(/([\s(:,])["“„«'][^"“”„«»'\n]{1,160}["“”»'](?=[\s.,!?;:)])/g, '$1 qq ').toLowerCase().replace(/\s+/g, ' ').trim();
    const end = '(?=$|[\\s.,!?;:])';
    // THE TOUR — the Symbols tour, from any view. The tour word ends the ask (a
    // travel workspace's "show me the tour bookings" stays a question).
    const tour = /\b(?:take me (?:on|through|to)|give me|start|begin|launch|run|show me|do|open|play|restart|resume)(?:\s+(?:me|us|the|a|an|quick|short|guided|product|symbols|workspace|full|little))*\s+tours?(?:\s+of\s+(?:symbols|the (?:workspace|app|platform|product)))?(?:\s+(?:please|now|again))?\s*[.!]*$/.test(t) || /^(?:the |a )?(?:symbols |product |quick |guided |workspace )*tour(?: please)?\s*[.!]*$/.test(t) || /\bshow (?:me|us) around\b/.test(t) || /\bhow (?:does|do) (?:symbols|this|it|the (?:workspace|app|platform)) work\b.*\bshow me\b/.test(t) || /\bshow me how (?:symbols|this|it|the (?:workspace|app|platform)) works?\b/.test(t) || /(?:^|\s)ტურ(?:ი|ს|ზე|ით)?\s*[.!]*$/.test(t) || /^(?:ჩამიტარე|დამიწყე|დაიწყე|მაჩვენე|გამატარე|გამიკეთე)(?:თ)?\s+ტურ/.test(t) || /(?:^|\s)მაჩვენე(?:თ)?\s+როგორ\s+მუშაობს/.test(t) || new RegExp("(?:^|\\s)\u10D3\u10D0\u10DB\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10D4\u10E0\u10D4\u10D1\u10D8\u10DC\u10D4(?:\u10D7)?" + end).test(t) || /(?:^|\s)გამაცანი(?:თ)?(?:\s+(?:symbols|სიმბოლს)\S*)?\s*[.!]*$/.test(t);
    if (tour) return 'tour';
    // A NEGATION near the start is never a request.
    if (/^(?:\S+\s+){0,3}(?:do not|don't|dont|never|no need to)\b/.test(t)) return 'question';
    if (/^(?:\S+\s+){0,2}(?:არ|ნუ)\s/.test(t)) return 'question';
    // THE LEAD-IN: courtesy and request frames before the verb.
    const leadIn = /^(?:hey|hi|hello|ok|okay|so|now|then|and|also|alright|great|cool|thanks|thank you|please|pls|kindly|quickly|just|go ahead and|could you|can you|would you mind|would you|will you|i want you to|i'd like you to|i would like you to|i need you to|i want to|i'd like to|i would like to|i need to|i want|i need|i'd like|let's|lets|let us|help me|try to|maybe|გთხოვთ|გთხოვ|თუ შეიძლება|შეგიძლიათ|შეგიძლია|ახლა|კარგი|მინდა რომ|მინდა|მსურს|მჭირდება|დამეხმარეთ|დამეხმარე|მოდი)(?:[\s,.!:;-]+|$)/;
    let s = t;
    for(let i = 0; i < 6; i++){
        const next = s.replace(leadIn, '');
        if (next === s) break;
        s = next;
    }
    if (!s) return 'question';
    // THE OBJECT NOUNS, by the surface they name. The Georgian stems follow
    // docs/I18N-GLOSSARY.md: a draft is დრაფტი, and the Blueprint word is Fly's
    // workspace plan, never a document.
    const objects = [
        [
            'website',
            /\b(?:web ?sites?|sites?|landing(?: ?pages?)?|home ?pages?|web ?pages?|portfolio(?: site)?|blog(?! posts?))\b|(?:^|\s)(?:ვებსაიტ|საიტ|ვებგვერდ|ლენდინგ|სადესანტო|ბლოგ)/g
        ],
        [
            'deck',
            /\b(?:presentations?|slide ?decks?|decks?|slides?|slideshows?|pitch(?: decks?)?)\b|(?:^|\s)(?:პრეზენტაცი|სლაიდ|დეკ(?=$|[\s.,!?ისზ]))/g
        ],
        [
            'app',
            /\b(?:apps?|applications?|extensions?|plug-?ins?|mini-?apps?|trackers?|portals?|crm|tools?|boards?)\b|(?:^|\s)(?:აპლიკაცი|აპ(?:ი|ს|ის)?(?=$|[\s.,!?])|ექსთენშენ|პლაგინ|ტრეკერ|პორტალ|ბორდ|დაფ)/g
        ],
        [
            'dashboard',
            /\b(?:dashboards?|charts?|graphs?|reports?|analytics|kpis?|metrics|visuali[sz]ations?|tables?|pages?|funnels?|leaderboards?|scorecards?|heat ?maps?)\b|(?:^|\s)(?:დაშბორდ|დეშბორდ|გრაფიკ|დიაგრამ|ანგარიშ|რეპორტ|ანალიტიკ|ცხრილ|გვერდ)/g
        ],
        [
            'document',
            /\b(?:documents?|docs?|notes?|memos?|plans?|proposals?|strateg(?:y|ies)|briefs?|outlines?|drafts?|articles?|essays?|letters?|polic(?:y|ies)|specs?|specifications?|checklists?|agendas?|minutes|write-?ups?|posts?|playbooks?|guides?|wiki|readme|faqs?|scripts?|contracts?)\b|(?:^|\s)(?:დოკუმენტ|დოკ(?=$|[\s.,!?ისზ])|შენიშვნ|ჩანაწერ|გეგმ|სტრატეგი|წინადადებ|მემო|სტატი|წერილ|ოქმ|დრაფტ|ხელშეკრულებ)/g
        ],
        [
            'action',
            /\b(?:tickets?|tasks?|to-?dos?|events?|meetings?|calls?|invites?|invitations?|contacts?|leads?|deals?|invoices?|customers?|clients?|reminders?|channels?|folders?|projects?|records?|entries|entry|rows?|columns?|fields?|e-?mails?|messages?|mails?|replies|reply|comments?|issues?|bugs?|appointments?|bookings?|orders?|users?|members?|teammates?)\b|(?:^|\s)(?:ტიკეტ|დავალებ|შეხვედრ|ღონისძიებ|კონტაქტ|ლიდ|გარიგებ|ინვოის|ზარ|მეილ|ელფოსტ|შეტყობინებ|არხ|საქაღალდ|პროექტ|კლიენტ|შეკვეთ|წევრ)/g
        ]
    ];
    // Every object word in a phrase, each as its whole word; a word inside a
    // longer one is dropped ("landing page" holds "page").
    const objectsIn = (str)=>{
        const found = [];
        for (const [cls, re] of objects){
            re.lastIndex = 0;
            let m = re.exec(str);
            while(m){
                const at = m.index + (m[0].length - m[0].replace(/^\s+/, '').length);
                let stop = m.index + m[0].length;
                while(stop < str.length && !/[\s.,!?;:()]/.test(str[stop]))stop++;
                found.push({
                    cls: cls,
                    at: at,
                    end: stop,
                    word: str.slice(at, stop)
                });
                if (!m[0].length) re.lastIndex++;
                m = re.exec(str);
            }
        }
        return found.filter((a)=>!found.some((b)=>b !== a && b.at <= a.at && b.end >= a.end && b.end - b.at > a.end - a.at));
    };
    // THE HEAD NOUN of the object. English: the LAST object word of the first
    // noun phrase (modifiers lead — "a client feedback board" is a board, "a
    // lead generation strategy document" a document); the phrase ends at a
    // preposition, a conjunction or a mark. Georgian: the first object word in
    // the nominative (the direct object of a request — "დოკუმენტი ლიდების
    // სტრატეგიით" is a document), else the first one.
    const stops = /^(?:of|for|with|about|on|in|into|to|that|which|who|whose|showing|shows|show|from|by|per|and|or|but|using|based|where|so|as|at|called|named|titled|comparing|including|listing|containing|tracking|covering|between|across|over|under|than|like|then|while|when|if|because|since|after|before|until|via|against|around|without|within|is|are|was|were|has|have|look|looks)$/;
    const headOf = (tail)=>{
        const str = String(tail || '').trim();
        if (!str) return null;
        const words = str.split(/\s+/);
        if (/[ა-ჿ]/.test(str)) {
            const room = words.slice(0, 8).join(' ');
            const all = objectsIn(room).sort((a, b)=>a.at - b.at);
            if (!all.length) return null;
            const head = all.find((m)=>/[იაე]$/.test(m.word) && !/(?:ის|ით|ზე|ში|თვის|დან|ად)$/.test(m.word)) || all[0];
            return {
                ...head,
                first: head.at === 0,
                size: words.length,
                rest: room.slice(head.end).trim()
            };
        }
        const phrase = [];
        for (const w of words){
            const bare = w.replace(/[,.;:!?()]+$/, '');
            if (phrase.length && stops.test(bare)) break;
            phrase.push(bare);
            if (bare !== w || phrase.length >= 8) break;
        }
        const np = phrase.join(' ');
        const all = objectsIn(np);
        if (!all.length) return null;
        const head = all.reduce((a, b)=>b.at > a.at ? b : a);
        return {
            ...head,
            first: head.at === 0,
            size: phrase.length,
            rest: words.slice(phrase.length).join(' ')
        };
    };
    const isBoard = (h)=>!!h && h.cls === 'app' && /^(?:boards?|ბორდ|დაფ)/.test(h.word);
    // A BOARD that describes data ("a board of my tickets", "a board showing
    // …") is a dashboard; any other board you build is an app ("a client
    // feedback board"), as the builder has always taken it. A Georgian ბორდი is
    // the workspace's dashboard word; a დაფა (the glossary's Board) is data when
    // the words after it say what it shows ("დაფა ჩემი დავალებებით", "დაფა
    // გაყიდვებზე", "დაფა, რომელიც აჩვენებს …").
    const boardKind = (h)=>/^ბორდ/.test(h.word) || /^(?:of|showing|with|that shows|comparing|by|per)\b/.test(h.rest) || /^დაფ/.test(h.word) && (/^[,\s]*(?:რომელიც|სადაც)/.test(h.rest) || h.rest.split(/\s+/).slice(0, 4).some((w)=>/(?:ით|ზე)[.,!?]*$/.test(w))) ? 'dashboard' : 'app';
    const verb = (re)=>{
        const m = re.exec(s);
        return m ? s.slice(m[0].length).trim() : null;
    };
    // THE VERB at the start — each family in both languages.
    if (verb(/^(?:visuali[sz]e|chart|plot|graph)\b/) !== null) return 'dashboard';
    const comm = verb(new RegExp("^(?:send|e-?mail|mail|message|text|dm|reply(?: to)?|respond(?: to)?|forward|schedule|reschedule|book|invite|remind|assign|reassign|cancel|approve|reject|decline|accept|pay|refund|submit|upload|install|uninstall|connect|subscribe|unsubscribe|post|notify|ping|write (?:back )?to|\u10D2\u10D0(?:\u10E3|\u10DB\u10D8)?\u10D2\u10D6\u10D0\u10D5\u10DC(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D0)|\u10D3\u10D0(?:\u10DB\u10D8)?\u10DC\u10D8\u10E8\u10DC(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7)|\u10E8\u10D4\u10DB\u10D0\u10EE\u10E1\u10D4\u10DC(?:\u10D4|\u10D4\u10D7)|\u10DB\u10D8(?:\u10E1|\u10E3)?\u10EC\u10D4\u10E0(?:\u10D4|\u10D4\u10D7)|\u10DB\u10DD\u10D8\u10EC\u10D5\u10D8(?:\u10D4|\u10D4\u10D7)|\u10DB\u10D8\u10D0\u10DC\u10D8\u10ED(?:\u10D4|\u10D4\u10D7)|\u10D2\u10D0\u10E3\u10D6\u10D8\u10D0\u10E0(?:\u10D4|\u10D4\u10D7))" + end));
    if (comm !== null) return 'action';
    const open = verb(new RegExp("^(?:open(?: up)?|re-?open|go to|go back to|take me to|bring me to|navigate to|jump to|switch to|pull up|bring up|launch|\u10D2\u10D0(?:\u10DB\u10D8|\u10D5)?\u10EE\u10E1(?:\u10D4\u10DC\u10D8|\u10D4\u10DC\u10D8\u10D7|\u10DC\u10D0|\u10DC\u10D0\u10D7|\u10DC\u10D8|\u10DC\u10D8\u10D7)|\u10D2\u10D0\u10D3\u10D0\u10D3\u10D8(?:\u10D7)?|\u10D2\u10D0\u10D3\u10D0\u10DB\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4(?:\u10D7)?|\u10EC\u10D0\u10DB\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4(?:\u10D7)?)" + end));
    // "open a new document" asks for a new one: the object decides, below.
    if (open !== null && !/^(?:(?:a|an)\s+)?new\b|^ახალი\s/.test(open)) return 'open';
    const write = verb(new RegExp("^(?:write(?: up| down)?|draft|compose|jot(?: down)?|type up|draw up|\u10D3\u10D0(?:\u10DB\u10D8|\u10D5)?\u10EC\u10D4\u10E0(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D0|\u10D0\u10D7))" + end));
    if (write !== null) {
        const h = headOf(write);
        if (h && [
            'website',
            'deck'
        ].includes(h.cls)) return h.cls;
        if (h && h.cls === 'app' && !isBoard(h)) return 'app';
        if (h && h.cls === 'action' && /mail|message|repl|მეილ|ელფოსტ|შეტყობინებ/.test(h.word)) return 'action';
        return 'document';
    }
    const create = open !== null ? open : verb(new RegExp("^(?:build|make|create|generate|prepare|put together|design|set up|setup|spin up|produce|mock up|whip up|craft|assemble|develop|code|\u10E8\u10D4(?:\u10DB\u10D8|\u10D5)?\u10E5\u10DB(?:\u10D4\u10DC\u10D8|\u10D4\u10DC\u10D8\u10D7|\u10DC\u10D0|\u10DC\u10D0\u10D7|\u10DC\u10D8|\u10DC\u10D8\u10D7)|\u10D2\u10D0(?:\u10D0|\u10DB\u10D8|\u10D5\u10D0|\u10E3)?\u10D9\u10D4\u10D7(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D4\u10D1\u10D0)|\u10D0(?:\u10D0|\u10DB\u10D8|\u10D5\u10D0)?\u10EC\u10E7(?:\u10D5\u10D4|\u10D5\u10D4\u10D7|\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10DD\u10D1\u10D0)|\u10D0(?:\u10D0|\u10DB\u10D8|\u10D5\u10D0)?\u10D2(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D4\u10D1\u10D0)|\u10DB\u10DD(?:\u10D0|\u10DB\u10D8|\u10D5\u10D0)?\u10DB\u10D6\u10D0\u10D3(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D4\u10D1\u10D0)|\u10D3\u10D0(?:\u10D0|\u10DB\u10D8|\u10D5\u10D0)?\u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D4\u10D1\u10D0)|\u10D3\u10D0(?:\u10DB\u10D8|\u10D5)?\u10EE\u10D0\u10E2(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D5\u10D0))" + end));
    if (create !== null) {
        // "make sure …", "make it shorter", "make this better" edit what is there.
        if (/^(?:sure|certain|it|this|that|them|these|those|everything|anything|something)\b/.test(create)) return 'question';
        const h = headOf(create.replace(/^(?:me|us)\s+/, ''));
        if (!h) return 'question';
        return isBoard(h) ? boardKind(h) : h.cls;
    }
    const show = verb(new RegExp("^(?:show(?: me| us)?|display|give me|get me|(?:\u10DB\u10D0|\u10DB\u10D8|\u10D0)\u10E9\u10D5\u10D4\u10DC(?:\u10D4|\u10D4\u10D7))" + end));
    if (show !== null) {
        const h = headOf(show);
        if (!h) return 'question';
        // "show me the sales dashboard" names a thing that exists: open it.
        const named = /^(?:the|my|our|this|that|these|those|your|ჩემი|ჩვენი|თქვენი|ეს|ამ)\s/.test(show) && h.size <= 5;
        if (named && h.cls !== 'action') return 'open';
        if (h.cls === 'dashboard' || isBoard(h)) return 'dashboard';
        if (h.cls === 'deck') return 'deck';
        return 'question';
    }
    const edit = verb(new RegExp("^(?:add|update|edit|change|rename|delete|remove|archive|unarchive|restore|mark|close|move|set|tag|label|pin|unpin|log|record|enable|disable|turn on|turn off|merge|duplicate|copy|convert|transfer|complete|finish|export|import|share|attach|link|unlink|\u10D3\u10D0(?:\u10D0|\u10DB\u10D8|\u10D5\u10D0)?\u10DB\u10D0\u10E2(?:\u10D4|\u10D4\u10D7|\u10DD|\u10DD\u10D7|\u10D4\u10D1\u10D0)|\u10EC\u10D0(?:\u10DB\u10D8)?\u10E8\u10D0\u10DA(?:\u10D4|\u10D4\u10D7)|\u10E8\u10D4(?:\u10DB\u10D8)?\u10EA\u10D5\u10D0\u10DA(?:\u10D4|\u10D4\u10D7)|\u10D2\u10D0\u10DC\u10D0\u10D0\u10EE\u10DA(?:\u10D4|\u10D4\u10D7)|\u10D2\u10D0\u10D3\u10D0(?:\u10D8|\u10DB\u10D8)\u10E2\u10D0\u10DC(?:\u10D4|\u10D4\u10D7))" + end));
    if (edit !== null) {
        const h = headOf(edit);
        if (h) return h.cls === 'action' ? 'action' : 'question';
        // "add Nika to the project": no object in the phrase — any record word
        // further on makes it an action.
        return objectsIn(edit.split(/\s+/).slice(0, 8).join(' ')).some((m)=>m.cls === 'action') ? 'action' : 'question';
    }
    // A QUESTION by its shape.
    if (/^(?:what|what's|whats|which|who|whom|whose|when|where|why|how|is|are|am|was|were|do|does|did|can|could|should|would|will|shall|may|might|have|has|had|any|tell me|explain|describe|summari[sz]e|list|find|look up|search)\b/.test(s) || /\?\s*$/.test(s) || /^(?:რა|რას|რის|რით|როგორ|რატომ|როდის|სად|საიდან|ვინ|ვის|რომელ|რამდენ|ხომ|არის|გაქვს|გაქვთ|შეიძლება|მითხარი|მითხარით|ამიხსენი|ამიხსენით)/.test(s)) return 'question';
    // A NOUN PHRASE that IS the ask: "a board of my tickets", "new presentation",
    // "dashboard of sales by month", "ახალი პრეზენტაცია", "დაშბორდი გაყიდვებზე".
    const article = /^(?:a|an|new|another|one|ახალი)\s+/.exec(s);
    const h = headOf(article ? s.slice(article[0].length) : s);
    if (!h || h.cls === 'action') return 'question';
    const georgian = /[ა-ჿ]/.test(h.word);
    const whole = georgian ? s.split(/\s+/).length <= 6 && (article || h.first) : h.size <= 4 && (article || h.first) && (!h.rest || /^(?:of|for|about|on|with|showing|that shows|comparing|by|per|from|to)\b/.test(h.rest));
    if (!whole) return 'question';
    return isBoard(h) ? boardKind(h) : h.cls;
};
const $873ad0703a323dd5$export$f5507dcdf21fc4c9 = function assistantEffectiveView(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this && this.context && this.context.functions || {};
    const mode = r.assistantMode;
    const pane = !!(r._canvasSlot || r._canvasSlotSecond);
    r.assistantDock, r._homeMode, r.currentPath, r._aiFly, r._homeThreadOpen;
    const thread = typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    const fly = typeof fns.assistantFlyShown === 'function' ? !!this.call('assistantFlyShown', r) : false;
    const deck = typeof fns.assistantDeckShown === 'function' ? !!this.call('assistantDeckShown', r) : false;
    const tabs = typeof fns.homeTabsOnScreen === 'function' && typeof fns.homeViewOf === 'function' ? !!this.call('homeTabsOnScreen', r) : false;
    const tab = tabs ? this.call('homeViewOf', r) : null;
    if (thread) return mode === 'apps' ? 'build' : 'chat';
    if (pane) return 'chat';
    if (tabs) {
        const byTab = {
            main: 'pages',
            chat: 'chat',
            present: 'present',
            build: 'build'
        };
        return byTab[tab] || 'home';
    }
    if (fly) return 'pages';
    if (deck) return 'present';
    if (mode === 'fly' || mode === 'dashboard') return 'pages';
    if (mode === 'presentation') return 'present';
    if (mode === 'apps') return 'build';
    return 'chat';
};
const $873ad0703a323dd5$export$880b662e283fb362 = function assistantAskRoute(root, text, opts) {
    const r = root && typeof root === 'object' ? root : {};
    const o = opts && typeof opts === 'object' ? opts : {};
    const fns = this && this.context && this.context.functions || {};
    const has = (name)=>typeof fns[name] === 'function';
    const mode = r.assistantMode;
    const main = r.assistantDock === 'main';
    const pane = !!(r._canvasSlot || r._canvasSlotSecond);
    const boards = r._aiBoardsAvailable === true;
    const intent = typeof o.intent === 'string' && o.intent ? o.intent : this.call('assistantAskIntent', text);
    const view = has('assistantEffectiveView') ? this.call('assistantEffectiveView', r) : 'chat';
    const chat = !pane && main ? 'thread' : 'drawer';
    // A stored Dashboard mode keeps its board meaning: "build a client feedback
    // board" there is a page; from any other view the builder makes it
    // (homeAiSendBuild round2c). An app, a tracker or a portal is always an app.
    const ask = String(text == null ? '' : text).toLowerCase();
    const boardPage = intent === 'app' && mode === 'dashboard' && /\bboards?\b|(?:^|\s)(?:ბორდ|დაფ)/.test(ask) && !/\b(?:apps?|applications?|trackers?|portals?|crm|extensions?|plug-?ins?|tools?)\b|აპლიკაცი|ტრეკერ|პორტალ/.test(ask);
    const wants = intent === 'tour' ? 'tour' : intent === 'app' && !boardPage ? 'app' : intent === 'website' ? 'site' : pane ? 'chat' : intent === 'dashboard' || boardPage ? 'pages' : intent === 'deck' ? 'deck' : intent === 'question' ? view === 'pages' ? 'pages' : view === 'present' ? 'deck' : 'chat' : 'chat';
    let surface = chat;
    let unavailable = null;
    // The tour's gate is the Fly start tile's own (assistantFlyTourOffered:
    // aiStartTour and onboardingTourStart registered) — one start, one gate.
    const tourOn = has('assistantFlyTourOffered') ? !!this.call('assistantFlyTourOffered') : has('aiStartTour') && has('onboardingTourStart');
    if (wants === 'tour' && tourOn) surface = 'tour';
    else if (wants === 'app' && has('forceBuildApp')) surface = 'app';
    else if (wants === 'site' && has('assistantOpenSiteBuilder')) surface = 'site';
    else if (wants === 'pages') {
        // Fly takes the main area on any placement; a generated board needs the
        // main placement. With the service up but no room for a board, the chat
        // answers without a note (nothing is unavailable).
        if (boards && has('assistantFlyGenerate')) surface = 'fly';
        else if (boards && main && has('assistantBoardGenerate')) surface = 'board';
        else if (!boards) unavailable = 'pages';
    } else if (wants === 'deck') {
        if (boards && main && has('assistantDeckGenerate')) surface = 'deck';
        else if (!boards) unavailable = 'slides';
    }
    const probe = !!unavailable && !o.probed && !boards && has('assistantBoardProbe');
    const family = (x)=>x === 'fly' || x === 'board' ? 'pages' : x === 'thread' || x === 'drawer' ? 'chat' : x;
    // The view's own surfaces: Build's conversation is the builder's, so an app
    // and its questions both stay home there.
    const own = view === 'pages' ? [
        'pages'
    ] : view === 'present' ? [
        'deck'
    ] : view === 'build' ? [
        'app',
        'chat'
    ] : [
        'chat'
    ];
    const switched = !pane && !unavailable && surface !== 'tour' && !own.includes(family(surface));
    const back = !switched ? null : view === 'pages' ? 'pages' : view === 'home' ? 'home' : view === 'present' ? null : 'chat';
    const conversation = surface === 'thread' || surface === 'drawer';
    const keepsMode = mode === 'assistant' || mode === 'tools' || mode === 'apps' && intent === 'question';
    return {
        intent: intent,
        view: view,
        wants: wants,
        surface: surface,
        route: surface === 'drawer' ? null : surface,
        mode: conversation && !keepsMode ? 'assistant' : null,
        switched: switched,
        back: back,
        unavailable: unavailable,
        probe: probe
    };
};
const $873ad0703a323dd5$export$6fe2986894eee6b4 = function assistantAskNotify(decision) {
    const d = decision && typeof decision === 'object' ? decision : null;
    const root = this && this.state && this.state.root;
    if (!d || !root || typeof root.update !== 'function') return false;
    if (d.unavailable) {
        const list = Array.isArray(root.chatMessages) ? root.chatMessages : [];
        const said = list.some((m)=>m && m.metadata && m.metadata.kind === 'routeNote' && m.metadata.note === d.unavailable);
        if (said) return false;
        const key = d.unavailable === 'slides' ? 'workspace.askRoute.slidesUnavailable' : 'workspace.askRoute.pagesUnavailable';
        const now = Date.now();
        root.update({
            chatMessages: list.concat({
                id: 'sys-route-' + now.toString(36) + Math.random().toString(36).slice(2, 6),
                role: 'system',
                text: String(this.call('polyglot', key)),
                ts: now,
                metadata: {
                    kind: 'routeNote',
                    note: d.unavailable
                }
            })
        }, {
            preventFetch: true
        });
        return true;
    }
    if (!d.switched) return false;
    const lines = {
        fly: 'workspace.askRoute.toPages',
        board: 'workspace.askRoute.toPages',
        deck: 'workspace.askRoute.toSlides',
        app: 'workspace.askRoute.toApp',
        site: 'workspace.askRoute.toSite',
        thread: 'workspace.askRoute.toChat',
        drawer: 'workspace.askRoute.toChat'
    };
    const backs = {
        chat: 'workspace.askRoute.backToChat',
        pages: 'workspace.askRoute.backToPages',
        home: 'workspace.askRoute.backToHome'
    };
    const line = lines[d.surface];
    // The toast host is a METHOD (shared methods/notification.js): look it up
    // the way `call` does (utils → functions → methods → snippets).
    const c = this.context || {};
    const toast = [
        'utils',
        'functions',
        'methods',
        'snippets'
    ].some((k)=>c[k] && typeof c[k].openNotification === 'function');
    if (!line || !toast) return false;
    const back = backs[d.back] ? d.back : null;
    try {
        this.call('openNotification', {
            title: String(this.call('polyglot', line)),
            ...back ? {
                actionLabel: backs[back],
                action: {
                    call: 'assistantAskBack',
                    args: [
                        back
                    ]
                }
            } : {},
            duration: 6000
        });
    } catch (_) {
        return false;
    }
    return true;
};
const $873ad0703a323dd5$export$f2548ae7f2d632fc = function assistantAskBack(target) {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const fns = this.context && this.context.functions || {};
    const has = (name)=>typeof fns[name] === 'function';
    const main = root.assistantDock === 'main';
    const tabs = main && has('homeViewSelect') && has('homeTabsOnScreen') && !!this.call('homeTabsOnScreen', root);
    if (target === 'pages') {
        if (tabs) {
            this.call('homeViewSelect', 'main');
            return true;
        }
        if (has('assistantMainThreadClose')) this.call('assistantMainThreadClose');
        return has('assistantFlyWorkspaceEnter') ? !!this.call('assistantFlyWorkspaceEnter') : false;
    }
    if (target === 'home') {
        if (tabs) {
            this.call('homeViewSelect', 'dashboard');
            return true;
        }
        for (const name of [
            'assistantFlyClose',
            'assistantBoardDismiss',
            'assistantDeckDismiss',
            'assistantMainThreadClose'
        ])if (has(name)) this.call(name);
        return true;
    }
    if (target !== 'chat') return false;
    if (tabs) {
        this.call('homeViewSelect', 'chat');
        return true;
    }
    for (const name of [
        'assistantFlyClose',
        'assistantBoardDismiss',
        'assistantDeckDismiss'
    ])if (has(name)) this.call(name);
    if (main && has('assistantMainThreadShow')) return !!this.call('assistantMainThreadShow');
    root.update({
        assistantOpen: true
    });
    return true;
};
const $873ad0703a323dd5$export$292f2046f498d2ac = function assistantAskHandoff(text, opts) {
    const root = this && this.state && this.state.root;
    const fns = this && this.context && this.context.functions || {};
    const ask = String(text == null ? '' : text).trim();
    if (!root || !ask || root._aiBuildMode) return false;
    if (typeof fns.homeAiSend !== 'function' || typeof fns.assistantAskIntent !== 'function') return false;
    const intent = this.call('assistantAskIntent', ask);
    if (![
        'tour',
        'dashboard',
        'app',
        'deck',
        'website'
    ].includes(intent)) return false;
    const from = opts && typeof opts.from === 'string' ? opts.from : 'chat';
    this.call('homeAiSend', ask, null, 0, null, {
        from: from
    });
    return true;
};
const $873ad0703a323dd5$export$da72191d06fb7b36 = function assistantThreadBesidePane(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r || typeof r.update !== 'function') return false;
    const pane = !!(r._canvasSlot || r._canvasSlotSecond);
    const phone = r._isPhoneViewport === true;
    const open = !!this.call('assistantMainThreadOpen', r);
    if (!pane || phone || !open) return false;
    return !!this.call('assistantThreadToSidebar');
};

});

parcelRegister("jrMGk", function(module, exports) {

$parcel$export(module.exports, "aiInstalledApps", () => $e2864d1dc642bbd3$export$3b2a8f2ab2c23d7c);
$parcel$export(module.exports, "aiAppMain", () => $e2864d1dc642bbd3$export$264e456792d5aa80);
$parcel$export(module.exports, "aiScopeSurface", () => $e2864d1dc642bbd3$export$af6cf50c766afcf7);
$parcel$export(module.exports, "aiScopeOptions", () => $e2864d1dc642bbd3$export$75fc32a77e3a660e);
$parcel$export(module.exports, "aiScopeChosenKey", () => $e2864d1dc642bbd3$export$23e154103de3a3de);
$parcel$export(module.exports, "aiScopeCurrent", () => $e2864d1dc642bbd3$export$8881c7563bc9b747);
$parcel$export(module.exports, "setAiScope", () => $e2864d1dc642bbd3$export$3ac200618d0b5213);
$parcel$export(module.exports, "aiScopePayload", () => $e2864d1dc642bbd3$export$93b7ee1d36f265a1);
// aiScope.js — THE AI CONTEXT of the composer: what the assistant is asked
// ABOUT (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1).
//
// Nika 2026-10-04: "redesign ai textarea focus popover, make it more beautiful
// and clear with more sensible options and option to choose/switch active
// context, based on what is active (app or page) and also option to inspect
// and ask".
//
// ONE scope at a time, chosen from the surface the member is on:
//
//   record     the record open on screen (a ticket, an event, a note …) —
//              the ALTERABLE REFERENCE of pageContext.js (`_aiRefMutedFor`)
//   page       a page of an app that has several (Validators · Overview,
//              Validators · Networks …)
//   app        the app that owns the route (Validators, Tasks …)
//   workspace  the workspace as a whole (Solana)
//   app:<id>   ANOTHER installed app (Tokens, Finances) — asked about from
//              wherever the member is
//
// DEFAULT = the most specific one that exists: an open record, else the page
// of a multi-page app, else the app, else the workspace (the home).
// A CHOICE (`setAiScope`) is remembered against the surface it was made on
// (`root._aiAskContext = { key, at }`): navigating somewhere else returns to the
// default, so a stale choice never silently re-targets a new page.
// The record option IS the alterable reference: choosing anything broader
// mutes the open record (`_aiRefMutedFor`, the key the context chip and the
// wire already read), choosing it back un-mutes it — one truth, two controls.
//
// Readers (all through el.call, `this` = the calling element for polyglot):
//   aiScopeOptions(root)   the selector's rows, most specific first
//   aiScopeCurrent(root)   the chosen (or default) row — the composer pill
//   aiScopePayload(root)   the wire shape (simoneAiTransport → context.aiScope)
//   setAiScope(key)        the one writer

var $7iFOV = parcelRequire("7iFOV");

var $gzr3m = parcelRequire("gzr3m");

var $l7TnK = parcelRequire("l7TnK");
const $e2864d1dc642bbd3$var$_aisStr = (v)=>v == null ? '' : String(v);
const $e2864d1dc642bbd3$var$_aisPathOnly = (p)=>$e2864d1dc642bbd3$var$_aisStr(p).split('#')[0].split('?')[0];
// The line glyph (the house `ln*` set, shared designSystem/icons.js) a record
// type wears — the same apps the records live in.
const $e2864d1dc642bbd3$var$_AIS_RECORD_GLYPH = {
    ticket: 'tasks',
    event: 'calendar',
    document: 'notes',
    person: 'teamMembers',
    teamMember: 'teamMembers',
    createMember: 'teamMembers',
    agent: 'agents',
    createAgent: 'agents',
    announcement: 'broadcast',
    project: 'studio'
};
// A glyph KEY → the sprite name through the ONE resolver (shared
// functions/glyphNames.js), which falls back when the design system lacks it.
const $e2864d1dc642bbd3$var$_aisGlyph = (el, tile)=>{
    try {
        if (el && typeof el.call === 'function') {
            const name = el.call('glyphNameFor', tile, 'ln');
            if (typeof name === 'string' && name) return name;
        }
    } catch (_) {
    /* no resolver on this host — the raw key below */ }
    const key = $e2864d1dc642bbd3$var$_aisStr(tile && tile.glyph);
    return key ? 'ln' + key[0].toUpperCase() + key.slice(1) : 'lnApps';
};
const $e2864d1dc642bbd3$var$_aisSay = (el, key)=>(0, $7iFOV.shellSay)(el, key);
const $e2864d1dc642bbd3$var$_aisResolve = (el, text)=>{
    const t = $e2864d1dc642bbd3$var$_aisStr(text);
    if (!t) return '';
    try {
        return el && typeof el.call === 'function' ? $e2864d1dc642bbd3$var$_aisStr(el.call('polyglot', t)) || t : t;
    } catch (_) {
        return t;
    }
};
const $e2864d1dc642bbd3$export$3b2a8f2ab2c23d7c = (root)=>{
    const out = [];
    const r = root && typeof root === 'object' ? root : {};
    const seen = new Set();
    const project = r.workspaceProject;
    if (project && typeof project === 'object' && project.id) {
        const cd = project.configDefaults || project.config && project.config.configDefaults || {};
        out.push({
            id: $e2864d1dc642bbd3$var$_aisStr(project.id),
            pages: Object.keys(project.pages || {}).map($e2864d1dc642bbd3$var$_aisPathOnly),
            apps: Array.isArray(cd.apps) ? cd.apps : [],
            navbar: Array.isArray(cd.navbar) ? cd.navbar : [],
            widgets: Array.isArray(project.widgets) ? project.widgets : [],
            chatStarters: Array.isArray(project.chatStarters) ? project.chatStarters : [],
            actionKeys: Array.isArray(project.actionKeys) ? project.actionKeys : [],
            actionDocs: project.actionDocs || {},
            actionLabels: project.actionLabels || {},
            aiFunctions: Array.isArray(project.aiFunctions) ? project.aiFunctions : [],
            aiFunctionDocs: project.aiFunctionDocs || {},
            takeover: true
        });
        seen.add($e2864d1dc642bbd3$var$_aisStr(project.id));
    }
    for (const a of Array.isArray(r.workspaceApps) ? r.workspaceApps : []){
        if (!a || typeof a !== 'object') continue;
        const id = $e2864d1dc642bbd3$var$_aisStr(a.id || a.appId);
        if (!id || seen.has(id)) continue;
        seen.add(id);
        out.push({
            id: id,
            pages: (Array.isArray(a.pages) ? a.pages : []).map($e2864d1dc642bbd3$var$_aisPathOnly),
            apps: Array.isArray(a.apps) ? a.apps : [],
            navbar: Array.isArray(a.navbar) ? a.navbar : [],
            widgets: Array.isArray(a.widgets) ? a.widgets : [],
            chatStarters: Array.isArray(a.chatStarters) ? a.chatStarters : [],
            actionKeys: Array.isArray(a.actionKeys) ? a.actionKeys : [],
            actionDocs: a.actionDocs || {},
            actionLabels: a.actionLabels || {},
            aiFunctions: Array.isArray(a.aiFunctions) ? a.aiFunctions : [],
            aiFunctionDocs: a.aiFunctionDocs || {},
            takeover: false
        });
    }
    return out;
};
// An installed app's MAIN route and its NAME: its launcher tile, else its
// first navbar row, else its first page. The name is the App Store's for the
// app (installedAppName — Nika 2026-10-23: "app names = what a person sees in
// the workspace App Store"; the composer's chip read the manifest's "Store"
// for Commerce), else the tile's / tab's own words (a bundle key or a literal
// — polyglot resolves both), else the app's key ("storm/storm-tokens" →
// "Storm tokens") so a chip never shows an id.
const $e2864d1dc642bbd3$var$_aisAppName = (el, app, raw)=>{
    try {
        if (el && typeof el.call === 'function') {
            const named = $e2864d1dc642bbd3$var$_aisStr(el.call('installedAppName', {
                id: app.id,
                label: raw
            }));
            if (named) return named;
        }
    } catch (_) {
    /* the resolver is unavailable — the app's own words below */ }
    return $e2864d1dc642bbd3$var$_aisResolve(el, raw);
};
const $e2864d1dc642bbd3$export$264e456792d5aa80 = (app, el)=>{
    const tile = (app.apps || []).find((t)=>t && (t.route || t.path));
    const nav = (app.navbar || []).find((n)=>n && (n.path || n.route));
    const route = $e2864d1dc642bbd3$var$_aisPathOnly(tile && (tile.route || tile.path) || nav && (nav.path || nav.route) || app.pages[0] || '');
    const raw = $e2864d1dc642bbd3$var$_aisStr(tile && (tile.title || tile.label) || nav && (nav.label || nav.title));
    let name = $e2864d1dc642bbd3$var$_aisAppName(el, app, raw);
    if (!name) {
        const key = $e2864d1dc642bbd3$var$_aisStr(app.id).split('/').pop().replace(/-app$/, '');
        name = key.replace(/[-_]+/g, ' ').replace(/^\w/, (c)=>c.toUpperCase());
    }
    return {
        route: route,
        name: name
    };
};
// The installed app that serves `path`: an exact page, else the app whose page
// is the longest prefix (`/validators/node` under `/validators`).
const $e2864d1dc642bbd3$var$_aisAppForPath = (apps, path)=>{
    let best = null;
    let bestLen = -1;
    for (const app of apps)for (const p of app.pages){
        if (!p) continue;
        const hit = path === p || p !== '/' && path.startsWith(p + '/');
        if (hit && p.length > bestLen) {
            best = app;
            bestLen = p.length;
        }
    }
    return best;
};
// A BUILT-IN app (Tasks, Calendar, Notes …): the launcher tile whose route is
// the path or its first segment. Read from the launcher's own visibility law
// (assistantStarters.visibleStarterTiles → searchApps), so a flagged-off app
// never becomes a scope.
const $e2864d1dc642bbd3$var$_aisBuiltinForPath = (root, path)=>{
    const seg = '/' + (path.split('/').filter(Boolean)[0] || '');
    if (seg === '/') return null;
    let tiles = [];
    try {
        tiles = (0, $l7TnK.visibleStarterTiles)(root);
    } catch (_) {
        tiles = [];
    }
    return tiles.find((t)=>t && !t.custom && (t.route === path || t.route === seg)) || null;
};
// The routed page element's own title (helmet metadata), or '' — the page
// name a module gives a page it never pinned to a tab (`/validators/node` →
// "storm-chi-1 · Validators", a title its live state fills in). Only the
// element made for THIS route: during an in-app navigation the routed element
// is still the previous page until the new one mounts (BESSI /alerts read
// „მომხმარებლები" for one page — lane www-9b G-2, 2026-10-28). An element
// whose metadata is not this route's definition's is that previous page.
const $e2864d1dc642bbd3$var$_aisRoutedPageTitle = (el, path)=>{
    try {
        const top = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
        const key = top && top.__ref && top.__ref.contentElementKey || 'content';
        const page = top && top[key];
        if (!page || typeof page.call !== 'function') return '';
        const pages = el.context && el.context.pages;
        const def = pages && typeof pages === 'object' ? pages[path] : null;
        // The element's metadata may be a merged copy: its title (a factory, or
        // the literal) is the definition's own.
        const a = page.metadata;
        const b = def && def.metadata;
        const same = !!a && !!b && (a === b || typeof a === 'object' && typeof b === 'object' && a.title === b.title);
        if (!same) return '';
        return $e2864d1dc642bbd3$var$_aisStr(page.call('resolvePageMetadataTitle', page.metadata));
    } catch (_) {
        return '';
    }
};
// "storm-chi-1 · Validators" → "storm-chi-1" when the app is Validators: a
// page title commonly carries its app's name, and the chip already says it.
// A title whose app part reads otherwise (the app's own word for itself —
// "შეკვეთები · ოპერაციები" under the store name BESSI) keeps its page part,
// the first.
const $e2864d1dc642bbd3$var$_aisStripAppName = (title, appName)=>{
    const t = $e2864d1dc642bbd3$var$_aisStr(title).trim();
    const a = $e2864d1dc642bbd3$var$_aisStr(appName).trim();
    if (!t || !a || t === a) return t === a ? '' : t;
    const all = t.split(/\s+[·|—–/-]\s+/).filter((p)=>p && p.trim());
    const parts = all.filter((p)=>p.trim() !== a);
    return (parts.length === all.length && all.length > 1 ? all.slice(0, 1) : parts).join(" \xb7 ").trim();
};
const $e2864d1dc642bbd3$export$af6cf50c766afcf7 = function aiScopeSurface(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const path = $e2864d1dc642bbd3$var$_aisPathOnly((0, $gzr3m.aiEffectivePath)(r)) || '/';
    const apps = $e2864d1dc642bbd3$export$3b2a8f2ab2c23d7c(r);
    const own = path === '/' ? null : $e2864d1dc642bbd3$var$_aisAppForPath(apps, path);
    let app = null;
    let page = null;
    if (own) {
        const main = $e2864d1dc642bbd3$export$264e456792d5aa80(own, el);
        app = {
            id: own.id,
            name: main.name,
            route: main.route || own.pages[0] || path,
            module: true
        };
        // A page of its own only where the app HAS pages to tell apart.
        if (own.pages.length > 1) {
            let label = '';
            if (path === app.route) label = $e2864d1dc642bbd3$var$_aisSay(el, 'workspace.aiScope.overview');
            if (!label) label = $e2864d1dc642bbd3$var$_aisResolve(el, (0, $gzr3m.aiDeclaredRouteLabel)(r, path));
            // The page's own title from its definition, by route (pageContext.js
            // aiModulePageTitle — in the app's context and the session language).
            if (!label) label = $e2864d1dc642bbd3$var$_aisStripAppName((0, $gzr3m.aiModulePageTitle)(path, el), app.name);
            // The routed page's own title — only when the page IS the route: a
            // page open in the slot over the home is not the routed page.
            if (!label && !r._canvasSlot) label = $e2864d1dc642bbd3$var$_aisStripAppName($e2864d1dc642bbd3$var$_aisRoutedPageTitle(el, path), app.name);
            if (!label) {
                const last = path.split('/').filter(Boolean).pop() || '';
                label = last.replace(/[-_]+/g, ' ').replace(/^\w/, (c)=>c.toUpperCase());
            }
            if (label && label !== app.name) page = {
                route: path,
                label: label
            };
        }
    } else if (path !== '/') {
        const tile = $e2864d1dc642bbd3$var$_aisBuiltinForPath(r, path);
        if (tile) app = {
            id: 'builtin:' + tile.route,
            name: $e2864d1dc642bbd3$var$_aisResolve(el, tile.title),
            route: tile.route,
            module: false
        };
    }
    let record = null;
    try {
        const rec = (0, $gzr3m.aiOpenRecord)(r, el);
        if (rec) record = {
            type: $e2864d1dc642bbd3$var$_aisStr(rec.type),
            id: $e2864d1dc642bbd3$var$_aisStr(rec.id),
            title: $e2864d1dc642bbd3$var$_aisResolve(el, rec.title || rec.type),
            rec: rec
        };
    } catch (_) {
        record = null;
    }
    const ws = r.workspace || {};
    const wsName = $e2864d1dc642bbd3$var$_aisStr(ws.displayName || ws.name || ws.slug);
    return {
        path: path,
        app: app,
        page: page,
        record: record,
        apps: apps,
        workspace: {
            name: wsName
        }
    };
};
// The surface's identity: a choice holds while this holds.
const $e2864d1dc642bbd3$var$_aisSurfaceAt = (sf)=>[
        sf.path,
        sf.record ? sf.record.type + ':' + sf.record.id : ''
    ].join('|');
// The selector's rows for a surface, most specific first, then the OTHER
// installed apps. { key, kind, label (full), short (the chip's word), glyph,
// appId, route, other? }
const $e2864d1dc642bbd3$var$_aisOptions = (el, sf)=>{
    const out = [];
    if (sf.record) out.push({
        key: 'record',
        kind: 'record',
        label: sf.record.title,
        short: sf.record.title,
        glyph: $e2864d1dc642bbd3$var$_aisGlyph(el, {
            glyph: $e2864d1dc642bbd3$var$_AIS_RECORD_GLYPH[sf.record.type] || 'notes'
        }),
        appId: sf.app ? sf.app.id : null,
        route: sf.path
    });
    if (sf.app && sf.page) out.push({
        key: 'page',
        kind: 'page',
        label: sf.app.name + " \xb7 " + sf.page.label,
        short: sf.page.label,
        glyph: $e2864d1dc642bbd3$var$_aisGlyph(el, {
            glyph: 'page'
        }),
        appId: sf.app.id,
        route: sf.page.route
    });
    if (sf.app) out.push({
        key: 'app',
        kind: 'app',
        label: sf.app.name,
        short: sf.app.name,
        glyph: $e2864d1dc642bbd3$var$_aisGlyph(el, {
            route: sf.app.route
        }),
        appId: sf.app.id,
        route: sf.app.route
    });
    const wsLabel = sf.workspace.name || $e2864d1dc642bbd3$var$_aisSay(el, 'workspace.aiScope.kindWorkspace');
    out.push({
        key: 'workspace',
        kind: 'workspace',
        label: wsLabel,
        short: wsLabel,
        glyph: $e2864d1dc642bbd3$var$_aisGlyph(el, {
            glyph: 'home'
        }),
        appId: null,
        route: '/'
    });
    for (const app of sf.apps){
        if (sf.app && sf.app.id === app.id) continue;
        const main = $e2864d1dc642bbd3$export$264e456792d5aa80(app, el);
        if (!main.route) continue;
        out.push({
            key: 'app:' + app.id,
            kind: 'app',
            other: true,
            label: main.name,
            short: main.name,
            glyph: $e2864d1dc642bbd3$var$_aisGlyph(el, {
                route: main.route
            }),
            appId: app.id,
            route: main.route
        });
    }
    return out;
};
// The checked key for a surface: a live choice for THIS surface, else the
// default. A muted open record is a choice too — the member took it out of
// the prompt from the context chip — so the default steps past it.
const $e2864d1dc642bbd3$var$_aisChosenKey = (r, sf, options)=>{
    if (!options.length) return null;
    const choice = r._aiAskContext && typeof r._aiAskContext === 'object' ? r._aiAskContext : null;
    if (choice && choice.at === $e2864d1dc642bbd3$var$_aisSurfaceAt(sf) && options.some((o)=>o.key === choice.key)) return choice.key;
    const muted = !!(sf.record && (0, $gzr3m.aiRecordMuted)(r, sf.record.rec));
    const first = options.find((o)=>!(o.kind === 'record' && muted));
    return first ? first.key : options[0].key;
};
const $e2864d1dc642bbd3$export$75fc32a77e3a660e = function aiScopeOptions(root) {
    return $e2864d1dc642bbd3$var$_aisOptions(this, $e2864d1dc642bbd3$export$af6cf50c766afcf7.call(this, root));
};
const $e2864d1dc642bbd3$export$23e154103de3a3de = function aiScopeChosenKey(root) {
    const r = root && typeof root === 'object' ? root : {};
    const sf = $e2864d1dc642bbd3$export$af6cf50c766afcf7.call(this, r);
    return $e2864d1dc642bbd3$var$_aisChosenKey(r, sf, $e2864d1dc642bbd3$var$_aisOptions(this, sf));
};
const $e2864d1dc642bbd3$export$8881c7563bc9b747 = function aiScopeCurrent(root) {
    const r = root && typeof root === 'object' ? root : {};
    const sf = $e2864d1dc642bbd3$export$af6cf50c766afcf7.call(this, r);
    const options = $e2864d1dc642bbd3$var$_aisOptions(this, sf);
    const key = $e2864d1dc642bbd3$var$_aisChosenKey(r, sf, options);
    return options.find((o)=>o.key === key) || null;
};
const $e2864d1dc642bbd3$export$3ac200618d0b5213 = function setAiScope(key) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const sf = $e2864d1dc642bbd3$export$af6cf50c766afcf7.call(el, root);
    const row = $e2864d1dc642bbd3$var$_aisOptions(el, sf).find((o)=>o.key === key);
    if (!row) return false;
    const patch = {
        _aiAskContext: {
            key: row.key,
            at: $e2864d1dc642bbd3$var$_aisSurfaceAt(sf)
        }
    };
    if (sf.record) {
        const refKey = (0, $gzr3m.aiRecordRefKey)(sf.record.rec);
        const muted = root._aiRefMutedFor === refKey;
        if (row.kind === 'record' && muted) patch._aiRefMutedFor = null;
        if (row.kind !== 'record' && !muted) patch._aiRefMutedFor = refKey;
    }
    root.update(patch, {
        preventFetch: true
    });
    return true;
};
// The home board's widgets in a scope, for the wire: the frames the member
// SEES on the home right now (rendered, not under the assistant's board), in
// document order, each with its app and its params. Read off the routed page's
// own element tree. Off the home there is no board on screen: none.
const $e2864d1dc642bbd3$var$_aisHomeWidgets = (el, root, sf, row)=>{
    if (sf.path !== '/' || root && (root._canvasSlot || root._canvasSlotSecond)) return [];
    const top = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
    const key = top && top.__ref && top.__ref.contentElementKey || 'content';
    const page = top && top[key];
    if (!page || typeof page.lookdownAll !== 'function') return [];
    const frames = page.lookdownAll((c)=>{
        const node = c && c.node;
        return !!(node && node.classList && node.classList.contains('home-grid-item') && node.dataset && node.dataset.widgetId);
    }) || [];
    const out = [];
    for (const f of frames){
        const node = f.node;
        if (typeof node.getClientRects === 'function' && node.getClientRects().length === 0) continue;
        if (node.hasAttribute && node.hasAttribute('data-under-view')) continue;
        const st = f.state || {};
        const appId = st.moduleId ? $e2864d1dc642bbd3$var$_aisStr(st.moduleId) : null;
        if (row.kind === 'app' && row.appId !== appId) continue;
        let params = null;
        try {
            const raw = st.params && typeof st.params.parse === 'function' ? st.params.parse() : st.params;
            params = raw && typeof raw === 'object' ? JSON.parse(JSON.stringify(raw)) : null;
        } catch (_) {
            params = null;
        }
        out.push({
            id: $e2864d1dc642bbd3$var$_aisStr(st.id || node.dataset.widgetId),
            ...appId ? {
                app: appId
            } : {},
            ...params && Object.keys(params).length ? {
                params: params
            } : {}
        });
        if (out.length >= 12) break;
    }
    return out;
};
const $e2864d1dc642bbd3$export$93b7ee1d36f265a1 = function aiScopePayload(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return null;
    const sf = $e2864d1dc642bbd3$export$af6cf50c766afcf7.call(el, r);
    const options = $e2864d1dc642bbd3$var$_aisOptions(el, sf);
    if (!options.length) return null;
    const key = $e2864d1dc642bbd3$var$_aisChosenKey(r, sf, options);
    const row = options.find((o)=>o.key === key) || options[0];
    const choice = r._aiAskContext && typeof r._aiAskContext === 'object' ? r._aiAskContext : null;
    const app = row.appId ? sf.apps.find((a)=>a.id === row.appId) : null;
    const out = {
        kind: row.kind,
        label: row.label,
        chosen: !!(choice && choice.key === row.key && choice.at === $e2864d1dc642bbd3$var$_aisSurfaceAt(sf)),
        route: row.route || sf.path,
        workspace: sf.workspace.name || null
    };
    if (row.appId) {
        const name = row.kind === 'app' ? row.label : sf.app ? sf.app.name : row.label;
        out.app = {
            id: row.appId,
            name: name,
            ...app ? {
                route: $e2864d1dc642bbd3$export$264e456792d5aa80(app, el).route
            } : {}
        };
    }
    if (row.kind === 'page' && sf.page) out.page = {
        route: sf.page.route,
        label: sf.page.label
    };
    if (row.kind === 'record' && sf.record) out.record = {
        type: sf.record.type,
        id: sf.record.id,
        title: sf.record.title
    };
    // Where the member IS, when the scope is elsewhere (another app, the
    // workspace): the model must not mistake the page for the ask.
    if ((row.other || row.kind === 'workspace') && sf.path !== '/') out.onPage = sf.path;
    const widgets = $e2864d1dc642bbd3$var$_aisHomeWidgets(el, r, sf, row);
    if (widgets.length) out.widgets = widgets;
    return out;
};

});

parcelRegister("dHbyA", function(module, exports) {

$parcel$export(module.exports, "aiPanelSuggestions", () => $9f884176dc34f0bd$export$183e7bffd060587c);
$parcel$export(module.exports, "aiPanelActions", () => $9f884176dc34f0bd$export$8d8e44421428cc45);
$parcel$export(module.exports, "aiPanelVerbPrompt", () => $9f884176dc34f0bd$export$bdc96158da92c1cf);
$parcel$export(module.exports, "aiPanelRun", () => $9f884176dc34f0bd$export$7b0f9b50f54aa187);
$parcel$export(module.exports, "aiPanelSend", () => $9f884176dc34f0bd$export$44a7306e0ac7f019);
// aiPanel.js — what the composer's focus panel OFFERS for the chosen context
// (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1; the panel itself is the
// shared SimoneSuggestions, the context model is functions/aiScope.js).
//
//   aiPanelSuggestions(root)  the grouped rows: SUGGESTED (the scoped app's
//                             own starters, the page's intent, the built-in
//                             page / record sets, "What can you do here?")
//                             and RECENT (the member's own last asks) — at
//                             most _AIP_MAX rows
//   aiPanelActions(root)      the three first-class verbs: Inspect & ask,
//                             Summarize, Build a board
//   aiPanelRun(kind)          runs one verb for the chosen context
//   aiPanelSend(row)          sends one suggestion row
//
// The SEND is the composer's own (homeAiSend), so a panel ask lands where a
// typed one lands (the main thread, the sidebar, a board). The person's mode
// is respected for a suggestion; the two verbs that name their output carry
// it for that one ask — Summarize answers, Build a board builds — and never
// write the mode (functions/assistantMode.js: an explicit choice wins).

var $7iFOV = parcelRequire("7iFOV");

var $gzr3m = parcelRequire("gzr3m");

var $jrMGk = parcelRequire("jrMGk");
const $9f884176dc34f0bd$var$_AIP_MAX = 6;
const $9f884176dc34f0bd$var$_AIP_STARTERS_MAX = 3;
const $9f884176dc34f0bd$var$_AIP_RECENT_MAX = 2;
const $9f884176dc34f0bd$var$_aipStr = (v)=>v == null ? '' : String(v);
const $9f884176dc34f0bd$var$_aipText = (el, key)=>{
    const t = $9f884176dc34f0bd$var$_aipStr(key);
    if (!t) return '';
    try {
        return el && typeof el.call === 'function' ? $9f884176dc34f0bd$var$_aipStr(el.call('polyglot', t)) || t : t;
    } catch (_) {
        return t;
    }
};
// A sentence with a {name} hole, filled by a FUNCTION (a `$&` in a tenant's
// name must never read as a replacement pattern).
const $9f884176dc34f0bd$var$_aipFill = (el, key, name)=>(0, $7iFOV.shellSay)(el, key).replace('{name}', ()=>$9f884176dc34f0bd$var$_aipStr(name));
const $9f884176dc34f0bd$var$_aipGlyph = (el, key)=>{
    try {
        if (el && typeof el.call === 'function') {
            const n = el.call('glyphNameFor', {
                glyph: key
            }, 'ln');
            if (typeof n === 'string' && n) return n;
        }
    } catch (_) {
    /* no resolver on this host */ }
    return 'ln' + key[0].toUpperCase() + key.slice(1);
};
// A manifest starter that names its app's OWN FORM (`{ text, form }`, the
// merged stash adds `app` — workspaceProjects.js _composeAiStash) → the form
// ref '<app id>.<form id>', else ''.
const $9f884176dc34f0bd$var$_aipStarterForm = (it, fallbackAppId)=>{
    if (!it || typeof it !== 'object' || typeof it.form !== 'string') return '';
    if (!/^[a-z0-9-]+$/.test(it.form)) return '';
    const app = $9f884176dc34f0bd$var$_aipStr(it.app || fallbackAppId).trim();
    return app ? app + '.' + it.form : '';
};
// One app's starters: its manifest list, a starter that names a PAGE first
// when the scope is that page (`{ text, route }` — the page-scoped starter of
// the module docs), each resolved through polyglot (a bundle key the app
// ships reads in the session language, a literal passes through).
const $9f884176dc34f0bd$var$_aipAppStarters = (el, app, route)=>{
    const list = Array.isArray(app && app.chatStarters) ? app.chatStarters : [];
    const rows = [];
    for (const it of list){
        const text = typeof it === 'string' ? it : it && typeof it.text === 'string' ? it.text : '';
        if (!text.trim()) continue;
        const own = it && typeof it === 'object' && typeof it.route === 'string' ? it.route : '';
        // a starter naming the app's OWN FORM opens it (assistantStarterForm)
        const form = $9f884176dc34f0bd$var$_aipStarterForm(it, app && app.id);
        rows.push({
            raw: text.trim(),
            route: own,
            localAction: form ? 'assistantStarterForm' : it && typeof it.localAction === 'string' ? it.localAction : undefined,
            form: form
        });
    }
    const onPage = route ? rows.filter((r)=>r.route === route) : [];
    const general = rows.filter((r)=>!r.route);
    return [
        ...onPage,
        ...general
    ].map((r)=>{
        const text = $9f884176dc34f0bd$var$_aipText(el, r.raw);
        return {
            kind: 'starter',
            text: text,
            prompt: text,
            localAction: r.localAction,
            ...r.form ? {
                form: r.form
            } : {},
            glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'assistant')
        };
    });
};
// The member's own recent asks: this thread's user lines (newest first), then
// the other threads' titles. Never a placeholder title.
const $9f884176dc34f0bd$var$_aipRecent = (el, root)=>{
    const out = [];
    const seen = new Set();
    const push = (t)=>{
        const text = $9f884176dc34f0bd$var$_aipStr(t).replace(/\s+/g, ' ').trim();
        const k = text.toLowerCase();
        if (text.length < 3 || text.length > 140 || seen.has(k)) return;
        seen.add(k);
        out.push(text);
    };
    const msgs = Array.isArray(root && root.chatMessages) ? root.chatMessages : [];
    for(let i = msgs.length - 1; i >= 0 && out.length < 6; i--){
        const m = msgs[i];
        if (m && m.role === 'user') push(m.text);
    }
    const newChat = $9f884176dc34f0bd$var$_aipText(el, 'workspace.simone.newChat').toLowerCase();
    const sessions = root && root.sessions && typeof root.sessions === 'object' ? root.sessions : {};
    const list = Object.values(sessions).filter((x)=>x && x.title).sort((a, b)=>(b.ts || 0) - (a.ts || 0));
    for (const sess of list){
        if (out.length >= 6) break;
        if ($9f884176dc34f0bd$var$_aipStr(sess.title).toLowerCase() === newChat) continue;
        push(sess.title);
    }
    return out;
};
// The built-in sets (pageContext.js) as rows.
const $9f884176dc34f0bd$var$_aipBuiltinRows = (el, items, on)=>items.map((s)=>({
            kind: 'intent',
            text: $9f884176dc34f0bd$var$_aipText(el, s.labelKey),
            prompt: $9f884176dc34f0bd$var$_aipText(el, s.promptKey),
            on: on || '',
            glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'assistant')
        }));
const $9f884176dc34f0bd$export$183e7bffd060587c = function aiPanelSuggestions(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const row = (0, $jrMGk.aiScopeCurrent).call(el, r);
    if (!row) return [];
    const sf = (0, $jrMGk.aiScopeSurface).call(el, r);
    const apps = (0, $jrMGk.aiInstalledApps)(r);
    const suggested = [];
    const seen = new Set();
    const add = (list, row2)=>{
        const k = $9f884176dc34f0bd$var$_aipStr(row2.text).trim().toLowerCase();
        if (!k || seen.has(k)) return;
        seen.add(k);
        list.push(row2);
    };
    // 1. THE CONTEXT'S OWN ASKS.
    if (row.kind === 'record' && sf.record) for (const x of $9f884176dc34f0bd$var$_aipBuiltinRows(el, (0, $gzr3m.aiRecordSuggestionItems)(sf.record.type), sf.record.title))add(suggested, x);
    else if (row.kind === 'workspace') {
        // The workspace's own: one starter per app, in the round-robin order the
        // composed stash already keeps (workspaceProjects._composeAiStash).
        const merged = Array.isArray(r.workspaceProject && r.workspaceProject.chatStarters) ? r.workspaceProject.chatStarters : [];
        for (const it of merged.slice(0, $9f884176dc34f0bd$var$_AIP_STARTERS_MAX)){
            const raw = typeof it === 'string' ? it : it && it.text;
            const text = $9f884176dc34f0bd$var$_aipText(el, raw);
            const form = $9f884176dc34f0bd$var$_aipStarterForm(it, r.workspaceProject && r.workspaceProject.id);
            if (text) add(suggested, {
                kind: 'starter',
                text: text,
                prompt: text,
                localAction: form ? 'assistantStarterForm' : it && typeof it === 'object' ? it.localAction : undefined,
                ...form ? {
                    form: form
                } : {},
                glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'assistant')
            });
        }
    } else {
        const app = row.appId ? apps.find((a)=>a.id === row.appId) : null;
        const starters = app ? $9f884176dc34f0bd$var$_aipAppStarters(el, app, row.kind === 'page' ? row.route : '') : [];
        for (const x of starters.slice(0, $9f884176dc34f0bd$var$_AIP_STARTERS_MAX))add(suggested, x);
        // A built-in app's page set (Tasks, Calendar, Chat, Notes).
        if (!app && sf.app && row.key === 'app') for (const x of $9f884176dc34f0bd$var$_aipBuiltinRows(el, (0, $gzr3m.aiPageSuggestionItems)(sf.path)))add(suggested, x);
    }
    // 2. THE CONTEXT'S INTENT — what needs attention, said for this context.
    if (row.kind === 'page' || row.kind === 'app' && !row.other && !sf.page) add(suggested, {
        kind: 'intent',
        text: (0, $7iFOV.shellSay)(el, 'workspace.aiScope.intent.attention'),
        prompt: $9f884176dc34f0bd$var$_aipFill(el, 'workspace.aiScope.intent.attentionPrompt', row.label),
        glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'attention')
    });
    else if (row.kind === 'app') add(suggested, {
        kind: 'intent',
        text: $9f884176dc34f0bd$var$_aipFill(el, 'workspace.aiScope.intent.attentionApp', row.label),
        prompt: $9f884176dc34f0bd$var$_aipFill(el, 'workspace.aiScope.intent.attentionAppPrompt', row.label),
        glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'attention')
    });
    else if (row.kind === 'workspace') {
        const plate = (0, $gzr3m.aiGenericSuggestionItems)()[0];
        if (plate) add(suggested, {
            kind: 'intent',
            text: $9f884176dc34f0bd$var$_aipText(el, plate.labelKey),
            prompt: $9f884176dc34f0bd$var$_aipText(el, plate.promptKey),
            glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'attention')
        });
    }
    // 3. WHAT CAN YOU DO HERE — always offered, last, in the quieter ink: the
    // deterministic capabilities answer (functions/aiCapabilities.js).
    const help = {
        kind: 'capabilities',
        text: (0, $7iFOV.shellSay)(el, 'workspace.aiSuggest.generic.whatCanYouDo'),
        prompt: (0, $7iFOV.shellSay)(el, 'workspace.aiSuggest.generic.whatCanYouDo'),
        localAction: 'aiShowCapabilities',
        glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'help'),
        generic: true
    };
    // the help row is a row above too: asking it once must not repeat it as a
    // recent ask (measured live on dev 2026-10-04)
    seen.add($9f884176dc34f0bd$var$_aipStr(help.text).trim().toLowerCase());
    // 4. RECENT — the member's own words, never a duplicate of a row above.
    const recent = [];
    for (const text of $9f884176dc34f0bd$var$_aipRecent(el, r)){
        if (recent.length >= $9f884176dc34f0bd$var$_AIP_RECENT_MAX) break;
        const k = text.toLowerCase();
        if (seen.has(k)) continue;
        recent.push({
            kind: 'recent',
            text: text,
            prompt: text,
            glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'history')
        });
    }
    // THE CAP: the context's rows give way to the member's own asks, never below
    // two of them; the help row always stays.
    const room = $9f884176dc34f0bd$var$_AIP_MAX - 1 - recent.length;
    const keep = Math.max(Math.min(2, suggested.length), Math.min(suggested.length, room));
    const shown = suggested.slice(0, keep);
    shown.push(help);
    const recentShown = recent.slice(0, Math.max(0, $9f884176dc34f0bd$var$_AIP_MAX - shown.length));
    const stamp = (list, group)=>list.map((x, i)=>({
                ...x,
                key: group + '-' + i + '-' + x.kind
            }));
    const groups = [
        {
            key: 'suggested',
            label: row.kind === 'workspace' ? (0, $7iFOV.shellSay)(el, 'workspace.aiScope.group.suggested') : $9f884176dc34f0bd$var$_aipFill(el, 'workspace.aiScope.group.suggestedFor', row.short || row.label),
            rows: stamp(shown, 'suggested')
        }
    ];
    if (recentShown.length) groups.push({
        key: 'recent',
        label: (0, $7iFOV.shellSay)(el, 'workspace.aiScope.group.recent'),
        rows: stamp(recentShown, 'recent')
    });
    return groups;
};
const $9f884176dc34f0bd$export$8d8e44421428cc45 = function aiPanelActions(root) {
    const el = this;
    const row = (0, $jrMGk.aiScopeCurrent).call(el, root);
    if (!row) return [];
    return [
        {
            key: 'inspect',
            label: (0, $7iFOV.shellSay)(el, 'workspace.aiScope.action.inspect'),
            hint: (0, $7iFOV.shellSay)(el, 'workspace.aiScope.action.inspectHint'),
            glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'inspect')
        },
        {
            key: 'summarize',
            label: (0, $7iFOV.shellSay)(el, 'workspace.aiScope.action.summarize'),
            hint: $9f884176dc34f0bd$var$_aipFill(el, 'workspace.aiScope.action.summarizeHint', row.label),
            glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'summarize')
        },
        {
            key: 'board',
            label: (0, $7iFOV.shellSay)(el, 'workspace.aiScope.action.board'),
            hint: $9f884176dc34f0bd$var$_aipFill(el, 'workspace.aiScope.action.boardHint', row.label),
            glyph: $9f884176dc34f0bd$var$_aipGlyph(el, 'dashboard')
        }
    ];
};
// The ask a verb sends for a context kind.
const $9f884176dc34f0bd$var$_AIP_VERB_KEYS = {
    summarize: {
        record: 'workspace.aiScope.action.summarizePromptRecord',
        page: 'workspace.aiScope.action.summarizePromptPage',
        app: 'workspace.aiScope.action.summarizePromptApp',
        workspace: 'workspace.aiScope.action.summarizePromptWorkspace'
    },
    board: {
        record: 'workspace.aiScope.action.boardPromptRecord',
        page: 'workspace.aiScope.action.boardPromptPage',
        app: 'workspace.aiScope.action.boardPromptApp',
        workspace: 'workspace.aiScope.action.boardPromptWorkspace'
    }
};
const $9f884176dc34f0bd$export$bdc96158da92c1cf = function aiPanelVerbPrompt(kind, root) {
    const el = this;
    const row = (0, $jrMGk.aiScopeCurrent).call(el, root);
    const keys = $9f884176dc34f0bd$var$_AIP_VERB_KEYS[kind];
    if (!row || !keys) return '';
    return $9f884176dc34f0bd$var$_aipFill(el, keys[row.kind] || keys.app, row.label);
};
// The panel closes after a pick: the textarea keeps focus for the next words,
// the panel stays down until it is asked for again.
const $9f884176dc34f0bd$var$_aipClosePanel = (el)=>{
    const root = el && el.state && el.state.root;
    if (root && typeof root.update === 'function') root.update({
        _aiPanel: 'dismissed'
    }, {
        preventFetch: true
    });
};
const $9f884176dc34f0bd$export$7b0f9b50f54aa187 = function aiPanelRun(kind) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    if (kind === 'inspect') {
        $9f884176dc34f0bd$var$_aipClosePanel(el);
        return el.call('aiInspectStart');
    }
    const text = $9f884176dc34f0bd$export$bdc96158da92c1cf.call(el, kind, root);
    if (!text) return false;
    $9f884176dc34f0bd$var$_aipClosePanel(el);
    el.call('homeAiSend', text, null, 0, null, {
        mode: kind === 'board' ? 'dashboard' : 'assistant'
    });
    return true;
};
const $9f884176dc34f0bd$export$44a7306e0ac7f019 = function aiPanelSend(row) {
    const el = this;
    const x = row && typeof row === 'object' ? row : null;
    if (!x) return false;
    $9f884176dc34f0bd$var$_aipClosePanel(el);
    if (x.localAction) try {
        // the row rides along (assistantStarterForm reads its `form`)
        el.call(x.localAction, x);
        return true;
    } catch (_) {
    /* the action's host is gone — fall through to asking it */ }
    const text = $9f884176dc34f0bd$var$_aipStr(x.prompt || x.text).trim();
    if (!text) return false;
    el.call('homeAiSend', text);
    return true;
};

});

parcelRegister("h9R4P", function(module, exports) {

$parcel$export(module.exports, "aiInspectRegionOf", () => $c7dc72df3caeeace$export$eeaf5f755310d69a);
$parcel$export(module.exports, "aiInspectFacts", () => $c7dc72df3caeeace$export$ac792f5ef6e58b15);
$parcel$export(module.exports, "aiInspectStart", () => $c7dc72df3caeeace$export$1792b3f4366484cb);
$parcel$export(module.exports, "aiInspectStop", () => $c7dc72df3caeeace$export$d26165806baaf2c7);
$parcel$export(module.exports, "aiInspectPick", () => $c7dc72df3caeeace$export$ea3209ae3c2cdfff);
$parcel$export(module.exports, "aiInspectHover", () => $c7dc72df3caeeace$export$c5ceeae3b6b6630b);
$parcel$export(module.exports, "aiInspectRefresh", () => $c7dc72df3caeeace$export$f7a8cb10d4eaf609);
$parcel$export(module.exports, "aiInspectSwallow", () => $c7dc72df3caeeace$export$85e5414cbe0e66c8);
$parcel$export(module.exports, "aiInspectClick", () => $c7dc72df3caeeace$export$48e7947f26d95e38);
$parcel$export(module.exports, "aiInspectKey", () => $c7dc72df3caeeace$export$190bcd199fc241b5);
// aiInspect.js — INSPECT & ASK (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1).
//
// Nika 2026-10-04: "… and also option to inspect and ask".
//
// The composer's focus panel starts it ("Inspect & ask"). While it is on, the
// page shows an outline under the pointer around the region it would take
// (components/AiInspectLayer.js); a click takes that region as a context
// attachment of the composer — its title, its visible words and figures, a
// widget's id and params, the record ids the module marks — and the next ask
// is about it. Escape leaves; the arrow keys walk the regions and Enter takes
// one, so the mode works without a pointer.
//
// WHAT IS A REGION (the module contract, documented in the developers docs,
// "Inspect & ask"):
//   • data-inspect="<title or bundle key>" on a module element — an explicit
//     region (`dataInspect: 'valWFleetTitle'` in DOMQL); `data-inspect=""`
//     opts in with the title read from the region itself;
//   • data-inspect-record="<collection>:<id>[,…]" on an element inside a
//     region — the records it shows (rows, list items);
//   • data-inspect="false" — a PRIVATE subtree, at any depth: never taken
//     (not even an explicit region inside it; the region, if any, is the
//     nearest ancestor above it), and when a region above it is taken, its
//     words, figures and record ids never ride the ask;
//   • every home widget frame is a region by default (its widget id, app and
//     params ride along);
//   • a module page that marks nothing still answers: the nearest SECTION /
//     ARTICLE / role="region", else the nearest card surface (its own fill and
//     radius) — never smaller than 120 × 40, never most of the screen.
// Only the routed page (`content`), the page sheet (`PageSlot`) and the main
// layer over a page (`AssistantMainLayer` — a Fly page, a board, the thread
// off the home: a Fly page itself can be inspected, Fly train 2) are
// inspected; the shell's chrome (header, composer, rails, overlays) never is.
//
// THE CAPTURE rides the composer's picked context (`root.pickedElements`):
// one entry per region with its facts on `inspect`. That array is declared,
// wiped on a workspace switch, rendered as a chip in the composer and under
// the sent line, and cleared after a send — the whole lifecycle exists
// already. simoneAiTransport lifts the facts into `context.inspected` (the
// server's INSPECTED line) instead of the 80-character pointing line.
//
// Non-reactive handles (the hovered region, the keyboard list) live on the
// root state object under `__aiInspect*` — the root.__navbarSaveQueue
// pattern; the reactive pair is `_aiInspect` (on/off) and `_aiInspectBox`
// (the outline).
const $c7dc72df3caeeace$var$_AII_TEXT_MAX = 1800;
const $c7dc72df3caeeace$var$_AII_RECORDS_MAX = 20;
const $c7dc72df3caeeace$var$_AII_REGIONS_MAX = 3;
// The root children whose subtree is inspectable: the routed page, the page
// sheet and the main layer over a page (the Fly canvas, a board, the thread
// off the home). Everything else directly under the shell root is chrome.
const $c7dc72df3caeeace$var$_AII_PAGE_KEYS = [
    'content',
    'PageSlot',
    'AssistantMainLayer'
];
const $c7dc72df3caeeace$var$_AII_CONTROL_TAGS = [
    'BUTTON',
    'A',
    'INPUT',
    'TEXTAREA',
    'SELECT',
    'LABEL',
    'OPTION'
];
const $c7dc72df3caeeace$var$_aiiStr = (v)=>v == null ? '' : String(v);
const $c7dc72df3caeeace$var$_aiiClean = (v)=>$c7dc72df3caeeace$var$_aiiStr(v).replace(/\s+/g, ' ').trim();
const $c7dc72df3caeeace$var$_aiiRootOf = (el)=>el && el.state && el.state.root || null;
const $c7dc72df3caeeace$var$_aiiTopOf = (el)=>{
    try {
        return el && typeof el.getRoot === 'function' ? el.getRoot() : null;
    } catch (_) {
        return null;
    }
};
const $c7dc72df3caeeace$var$_aiiWin = ()=>typeof window !== 'undefined' ? window : null;
// The DOMQL element a DOM node belongs to (a text node, an icon's <use> and a
// node DOMQL did not create walk up to the nearest one that carries `.ref`).
const $c7dc72df3caeeace$var$_aiiElementOfNode = (node)=>{
    let n = node;
    while(n && !n.ref)n = n.parentNode;
    return n ? n.ref : null;
};
// Is this element a region, and of which kind: 'explicit' | 'widget' |
// 'section' | null.
const $c7dc72df3caeeace$var$_aiiKind = (el)=>{
    const node = el && el.node;
    if (!node || node.nodeType !== 1) return null;
    const ds = node.dataset || {};
    if (ds.inspect != null && ds.inspect !== 'false') return 'explicit';
    if (ds.widgetId && node.classList && node.classList.contains('home-grid-item')) return 'widget';
    // A Fly page's widget or view section (components/AssistantFlyView.js
    // AssistantFlyCard `data-fly-widget`): a widget region too — its id, app
    // and params ride along.
    if (ds.flyWidget) return 'widget';
    if ($c7dc72df3caeeace$var$_AII_CONTROL_TAGS.includes(node.tagName)) return null;
    if (typeof node.getBoundingClientRect !== 'function') return null;
    const r = node.getBoundingClientRect();
    if (r.width < 120 || r.height < 40) return null;
    const win = $c7dc72df3caeeace$var$_aiiWin();
    if (win && r.width * r.height > 0.6 * win.innerWidth * win.innerHeight) return null;
    const role = node.getAttribute && node.getAttribute('role');
    if (node.tagName === 'SECTION' || node.tagName === 'ARTICLE' || role === 'region') return 'section';
    if (!win || typeof win.getComputedStyle !== 'function') return null;
    const cs = win.getComputedStyle(node);
    const bg = $c7dc72df3caeeace$var$_aiiStr(cs.backgroundColor);
    const filled = !!bg && bg !== 'transparent' && !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(bg);
    const rounded = parseFloat(cs.borderTopLeftRadius) > 0;
    return filled && rounded ? 'section' : null;
};
const $c7dc72df3caeeace$export$eeaf5f755310d69a = function aiInspectRegionOf(target) {
    let el = $c7dc72df3caeeace$var$_aiiElementOfNode(target);
    // The shell root ELEMENT (el.getRoot()). Live, it is not parentless: the
    // framework wraps it (`{ smblsapp }`), so "the parent has no parent" would
    // stop one level too high and take nothing (measured on dev 2026-10-04).
    // A tree with no root pointer (a bare test tree) keeps that rule.
    const top = $c7dc72df3caeeace$var$_aiiTopOf(el);
    let region = null;
    while(el){
        const node = el.node;
        const ds = node && node.dataset || {};
        // An opted-out subtree (data-inspect="false") is never taken — not even an
        // explicit region inside it: the nearest region ABOVE it is (privacy wins
        // at every depth; its words never ride, see _aiiRead).
        if (ds.inspect === 'false') region = null;
        if (!region && ds.inspect !== 'false') {
            const kind = $c7dc72df3caeeace$var$_aiiKind(el);
            if (kind) region = {
                el: el,
                kind: kind
            };
        }
        const parent = el.parent;
        // A child of the shell root: the page or the sheet bound the search;
        // anything else there is chrome.
        if (parent && (top ? parent === top : !parent.parent)) return $c7dc72df3caeeace$var$_AII_PAGE_KEYS.includes(el.key) ? region : null;
        if (top && el === top) return null;
        el = parent;
    }
    return null;
};
// Is this DOM element opted out of Inspect — the module contract's PRIVATE
// marker, `data-inspect="false"` (a host name, an IP, a private note)?
const $c7dc72df3caeeace$var$_aiiOptedOut = (n)=>!!(n && n.nodeType === 1 && n.dataset && n.dataset.inspect === 'false');
// THE ONE READ of a region's rendered tree — what a person can SEE in it:
// its words (text nodes in document order, capped), the record ids it marks
// (`data-inspect-record`, capped) and its first heading. It skips what is
// hidden, inert or aria-hidden (a widget's resting edit controls) and EVERY
// opted-out subtree at any depth: a region above a private child is taken,
// the child's words, figures and record ids never are (privacy finding,
// Validators node page's Host card, 2026-10-05). A READ of the rendered tree
// (like the outline's measurement): what a module's props and html rendered
// is only there, never in the DOMQL element tree. Nothing here writes to a
// node. → { text, records, heading }
const $c7dc72df3caeeace$var$_aiiRead = (node, max)=>{
    const parts = [];
    const records = [];
    let len = 0;
    let headingNode = null;
    const walk = (n, isRoot)=>{
        if (!n) return;
        if (n.nodeType === 3) {
            if (len >= max) return;
            const t = $c7dc72df3caeeace$var$_aiiClean(n.nodeValue);
            if (t) {
                parts.push(t);
                len += t.length + 3;
            }
            return;
        }
        if (n.nodeType !== 1) return;
        if ($c7dc72df3caeeace$var$_aiiOptedOut(n)) return;
        const tag = n.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEMPLATE') return;
        if (n.hidden || n.hasAttribute && n.hasAttribute('inert')) return;
        if (n.getAttribute && n.getAttribute('aria-hidden') === 'true') return;
        if (typeof n.getClientRects === 'function' && n.getClientRects().length === 0) return;
        const marked = n.dataset ? n.dataset.inspectRecord : null;
        if (marked) for (const one of $c7dc72df3caeeace$var$_aiiStr(marked).split(',')){
            const t = one.trim();
            if (t && records.length < $c7dc72df3caeeace$var$_AII_RECORDS_MAX && !records.includes(t)) records.push(t);
        }
        if (!headingNode && !isRoot && (/^H[1-6]$/.test(tag) || n.getAttribute && n.getAttribute('role') === 'heading')) headingNode = n;
        for (const c of n.childNodes || [])walk(c, false);
    };
    walk(node, true);
    const heading = headingNode ? $c7dc72df3caeeace$var$_aiiRead(headingNode, 80).text : '';
    return {
        text: parts.join(" \xb7 ").slice(0, max),
        records: records,
        heading: heading
    };
};
// A region's title: its own declared one, a widget's, its accessible name,
// its first heading, else its first visible words — the last two from the
// same read, so never from an opted-out subtree.
const $c7dc72df3caeeace$var$_aiiTitleOf = (el, kind, say)=>{
    const node = el.node;
    const ds = node && node.dataset || {};
    if (kind === 'explicit' && ds.inspect && ds.inspect !== 'true') return $c7dc72df3caeeace$var$_aiiClean(say(ds.inspect));
    if (kind === 'widget' && el.state && el.state.title) return $c7dc72df3caeeace$var$_aiiClean(say(el.state.title));
    const aria = node.getAttribute && node.getAttribute('aria-label');
    if (aria) return $c7dc72df3caeeace$var$_aiiClean(aria);
    const read = $c7dc72df3caeeace$var$_aiiRead(node, 160);
    if (read.heading) return read.heading.slice(0, 80);
    const first = read.text.split(" \xb7 ")[0] || '';
    return first.slice(0, 80);
};
// Plain data from a DOMQL state value (a nested state proxy hands its values
// over through parse()).
const $c7dc72df3caeeace$var$_aiiPlain = (v)=>{
    if (!v || typeof v !== 'object') return v;
    const p = typeof v.parse === 'function' ? v.parse() : v;
    try {
        return JSON.parse(JSON.stringify(p));
    } catch (_) {
        return undefined;
    }
};
const $c7dc72df3caeeace$export$ac792f5ef6e58b15 = function aiInspectFacts(region) {
    const el = this;
    const r = region && region.el ? region : null;
    if (!r || !r.el.node) return null;
    const say = (key)=>{
        try {
            return typeof el.call === 'function' ? $c7dc72df3caeeace$var$_aiiStr(el.call('polyglot', key)) || key : key;
        } catch (_) {
            return key;
        }
    };
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el) || {};
    const node = r.el.node;
    const title = $c7dc72df3caeeace$var$_aiiTitleOf(r.el, r.kind, say) || say('workspace.aiInspect.untitled');
    const facts = {
        id: 'region-' + Date.now().toString(36),
        title: title,
        kind: r.kind === 'widget' ? 'widget' : 'section'
    };
    let route = '';
    try {
        route = $c7dc72df3caeeace$var$_aiiStr(el.call('aiScopeSurface', root).path);
    } catch (_) {
        route = '';
    }
    if (route) facts.route = route;
    if (r.kind === 'widget') {
        const s = r.el.state || {};
        facts.widget = {
            id: $c7dc72df3caeeace$var$_aiiStr(s.id)
        };
        if (s.moduleId) facts.app = {
            id: $c7dc72df3caeeace$var$_aiiStr(s.moduleId)
        };
        // The params it was asked with, then what its mounted view RESOLVED over
        // them (a Fly section's view — the views contract's `resolvedParams`,
        // functions/assistantAppViews.js): a site card names the site it shows.
        const body = r.el.CardBody && r.el.CardBody.content;
        const bag = (v)=>v && typeof v === 'object' && !Array.isArray(v) ? v : {};
        const params = {
            ...bag($c7dc72df3caeeace$var$_aiiPlain(s.params)),
            ...bag(body ? $c7dc72df3caeeace$var$_aiiPlain(body.resolvedParams) : null)
        };
        if (Object.keys(params).length) facts.widget.params = params;
        if (s.describe) facts.widget.describe = $c7dc72df3caeeace$var$_aiiStr(s.describe).slice(0, 240);
    } else try {
        const sf = el.call('aiScopeSurface', root);
        if (sf && sf.app && sf.app.module) facts.app = {
            id: sf.app.id,
            name: sf.app.name
        };
    } catch (_) {
    /* no scope reader on this host */ }
    // Words and record ids from the one read: never from an opted-out subtree.
    const read = $c7dc72df3caeeace$var$_aiiRead(node, $c7dc72df3caeeace$var$_AII_TEXT_MAX);
    if (read.records.length) facts.records = read.records;
    facts.text = read.text;
    return facts;
};
// The outline's box for a region (viewport px — a MEASUREMENT, the one place
// raw px are the value), with its label.
const $c7dc72df3caeeace$var$_aiiBox = (region, label)=>{
    const r = region.el.node.getBoundingClientRect();
    return {
        x: Math.round(r.left),
        y: Math.round(r.top),
        w: Math.round(r.width),
        h: Math.round(r.height),
        label: $c7dc72df3caeeace$var$_aiiStr(label)
    };
};
const $c7dc72df3caeeace$var$_aiiShow = (el, root, region)=>{
    root.__aiInspectRegion = region || null;
    if (!region) {
        if (root._aiInspectBox) root.update({
            _aiInspectBox: null
        }, {
            preventFetch: true
        });
        return;
    }
    const say = (key)=>$c7dc72df3caeeace$var$_aiiStr(el.call('polyglot', key)) || key;
    const label = $c7dc72df3caeeace$var$_aiiTitleOf(region.el, region.kind, say);
    root.update({
        _aiInspectBox: $c7dc72df3caeeace$var$_aiiBox(region, label)
    }, {
        preventFetch: true
    });
};
// The composer's textarea, to hand focus back to.
const $c7dc72df3caeeace$var$_aiiComposerField = (el)=>{
    const top = $c7dc72df3caeeace$var$_aiiTopOf(el);
    const composer = top && top.CanvasPromptTextarea;
    const field = composer && composer.Textarea;
    return field && field.node ? field.node : null;
};
const $c7dc72df3caeeace$export$1792b3f4366484cb = function aiInspectStart() {
    const el = this;
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el);
    if (!root || typeof root.update !== 'function') return false;
    root.__aiInspectRegion = null;
    root.__aiInspectList = null;
    root.__aiInspectIndex = -1;
    root.update({
        _aiInspect: true,
        _aiInspectBox: null,
        _aiPanel: 'dismissed',
        _promptFocused: false
    }, {
        preventFetch: true
    });
    // The layer mounts on this update (if-gated: no open-edge hook), so the
    // focus move polls briefly for its hint.
    const win = $c7dc72df3caeeace$var$_aiiWin();
    if (win && typeof win.setTimeout === 'function') {
        let tries = 0;
        const tick = ()=>{
            tries++;
            const top = $c7dc72df3caeeace$var$_aiiTopOf(el);
            const hint = top && top.AiInspectLayer && top.AiInspectLayer.InspectHint;
            if (hint && hint.node && typeof hint.node.focus === 'function') {
                hint.node.focus();
                return;
            }
            if (tries < 10) win.setTimeout(tick, 30);
        };
        win.setTimeout(tick, 0);
    }
    return true;
};
const $c7dc72df3caeeace$export$d26165806baaf2c7 = function aiInspectStop() {
    const el = this;
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el);
    if (!root || typeof root.update !== 'function') return false;
    root.__aiInspectRegion = null;
    root.__aiInspectList = null;
    root.__aiInspectIndex = -1;
    root.update({
        _aiInspect: false,
        _aiInspectBox: null
    }, {
        preventFetch: true
    });
    const field = $c7dc72df3caeeace$var$_aiiComposerField(el);
    if (field && typeof field.focus === 'function') field.focus();
    return true;
};
const $c7dc72df3caeeace$export$ea3209ae3c2cdfff = function aiInspectPick(region) {
    const el = this;
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el);
    if (!root || typeof root.update !== 'function' || !region) return false;
    const facts = $c7dc72df3caeeace$export$ac792f5ef6e58b15.call(el, region);
    if (!facts) return false;
    const entry = {
        keyPath: [
            facts.title
        ],
        key: facts.title,
        tag: 'region',
        title: facts.title,
        text: $c7dc72df3caeeace$var$_aiiStr(facts.text).slice(0, 80),
        pickedAt: Date.now(),
        inspect: facts
    };
    const prev = (Array.isArray(root.pickedElements) ? root.pickedElements : []).filter((p)=>!(p && p.inspect && p.inspect.title === facts.title && p.inspect.route === facts.route));
    const regions = prev.filter((p)=>p && p.inspect);
    const keep = regions.length >= $c7dc72df3caeeace$var$_AII_REGIONS_MAX ? prev.filter((p)=>p !== regions[0]) : prev;
    root.update({
        pickedElements: [
            ...keep,
            entry
        ],
        _aiPanel: 'dismissed'
    });
    $c7dc72df3caeeace$export$d26165806baaf2c7.call(el);
    return true;
};
const $c7dc72df3caeeace$export$c5ceeae3b6b6630b = function aiInspectHover(e) {
    const el = this;
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el);
    if (!root || !root._aiInspect || !e) return;
    if (el.node && typeof el.node.contains === 'function' && el.node.contains(e.target)) return;
    const region = $c7dc72df3caeeace$export$eeaf5f755310d69a(e.target);
    const cur = root.__aiInspectRegion;
    if ((cur && cur.el) === (region && region.el)) return;
    $c7dc72df3caeeace$var$_aiiShow(el, root, region);
};
const $c7dc72df3caeeace$export$f7a8cb10d4eaf609 = function aiInspectRefresh() {
    const el = this;
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el);
    if (!root || !root._aiInspect) return;
    const cur = root.__aiInspectRegion;
    if (!cur || !cur.el || !cur.el.node || !cur.el.node.isConnected) {
        $c7dc72df3caeeace$var$_aiiShow(el, root, null);
        return;
    }
    $c7dc72df3caeeace$var$_aiiShow(el, root, cur);
};
const $c7dc72df3caeeace$export$85e5414cbe0e66c8 = function aiInspectSwallow(e) {
    const el = this;
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el);
    if (!root || !root._aiInspect || !e) return false;
    if (el.node && typeof el.node.contains === 'function' && el.node.contains(e.target)) return false;
    if (typeof e.preventDefault === 'function') e.preventDefault();
    if (typeof e.stopPropagation === 'function') e.stopPropagation();
    return true;
};
const $c7dc72df3caeeace$export$48e7947f26d95e38 = function aiInspectClick(e) {
    const el = this;
    if (!$c7dc72df3caeeace$export$85e5414cbe0e66c8.call(el, e)) return false;
    const region = $c7dc72df3caeeace$export$eeaf5f755310d69a(e.target);
    if (!region) return true;
    return $c7dc72df3caeeace$export$ea3209ae3c2cdfff.call(el, region);
};
// Is this element inside (or itself) an opted-out subtree, below `host`?
const $c7dc72df3caeeace$var$_aiiInsideOptOut = (el, host)=>{
    let e = el;
    while(e && e !== host){
        if ($c7dc72df3caeeace$var$_aiiOptedOut(e.node)) return true;
        e = e.parent;
    }
    return false;
};
// The keyboard list: every region of the page in document order, visible in
// the viewport, never inside an opted-out subtree (built once per walk, on
// the first arrow).
const $c7dc72df3caeeace$var$_aiiCandidates = (el)=>{
    const top = $c7dc72df3caeeace$var$_aiiTopOf(el);
    if (!top) return [];
    const win = $c7dc72df3caeeace$var$_aiiWin();
    const vh = win ? win.innerHeight : 0;
    const out = [];
    for (const key of $c7dc72df3caeeace$var$_AII_PAGE_KEYS){
        const host = top[key];
        if (!host || typeof host.lookdownAll !== 'function') continue;
        // A host that is not on screen offers nothing: the main layer while it is
        // closed, the page while the layer is over it (both keep their box,
        // hidden — app.js, the AssistantMainLayer rule).
        const hostNode = host.node;
        if (hostNode && win && typeof win.getComputedStyle === 'function' && win.getComputedStyle(hostNode).visibility === 'hidden') continue;
        const found = host.lookdownAll((c)=>{
            const kind = $c7dc72df3caeeace$var$_aiiKind(c);
            if (!kind || $c7dc72df3caeeace$var$_aiiInsideOptOut(c, host)) return false;
            const r = c.node.getBoundingClientRect();
            return !vh || r.bottom > 0 && r.top < vh;
        }) || [];
        for (const c of found)out.push({
            el: c,
            kind: $c7dc72df3caeeace$var$_aiiKind(c)
        });
    }
    return out;
};
const $c7dc72df3caeeace$export$190bcd199fc241b5 = function aiInspectKey(e) {
    const el = this;
    const root = $c7dc72df3caeeace$var$_aiiRootOf(el);
    if (!root || !root._aiInspect || !e) return false;
    const key = e.key;
    if (key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        $c7dc72df3caeeace$export$d26165806baaf2c7.call(el);
        return true;
    }
    const next = key === 'ArrowDown' || key === 'ArrowRight' || key === 'Tab' && !e.shiftKey;
    const prev = key === 'ArrowUp' || key === 'ArrowLeft' || key === 'Tab' && e.shiftKey;
    if (next || prev) {
        e.preventDefault();
        e.stopPropagation();
        if (!root.__aiInspectList) root.__aiInspectList = $c7dc72df3caeeace$var$_aiiCandidates(el);
        const list = root.__aiInspectList;
        if (!list.length) return true;
        const at = typeof root.__aiInspectIndex === 'number' ? root.__aiInspectIndex : -1;
        const i = next ? (at + 1) % list.length : at <= 0 ? list.length - 1 : at - 1;
        root.__aiInspectIndex = i;
        const region = list[i];
        const node = region.el.node;
        // Bring it into view (the one scroll a keyboard walk needs).
        if (node && typeof node.scrollIntoView === 'function') node.scrollIntoView({
            block: 'nearest'
        });
        $c7dc72df3caeeace$var$_aiiShow(el, root, region);
        return true;
    }
    if (key === 'Enter') {
        const cur = root.__aiInspectRegion;
        if (!cur) return false;
        e.preventDefault();
        e.stopPropagation();
        return $c7dc72df3caeeace$export$ea3209ae3c2cdfff.call(el, cur);
    }
    return false;
};

});

parcelRegister("8MHsf", function(module, exports) {

$parcel$export(module.exports, "aiCapabilities", () => $665483961bb78723$export$bf9404565b9bd21f);
$parcel$export(module.exports, "aiShowCapabilities", () => $665483961bb78723$export$b8ba6db7a612de88);
$parcel$export(module.exports, "aiCapabilityRun", () => $665483961bb78723$export$5b128f4866709a1f);
// aiCapabilities.js — "WHAT CAN YOU DO HERE?", answered from what is
// installed, never from a guess (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-
// INSPECT-1, Nika's addition 2026-10-04: "improve 'რისი გაკეთება შეიძლება'
// section make it more clear").
//
// The answer was the model's free prose ("what can you do here?" → a vague
// list). Now it is a CATALOGUE for the chosen context (functions/aiScope.js),
// built from the installed apps' own manifests and the shell's own abilities,
// in four groups — each item tappable:
//
//   Ask      2–3 real questions for this context (the app's own starters, a
//            record's own actions) — a tap asks it
//   Do       the app's approval-gated actions (mint tokens, move funds,
//            acknowledge an incident) — a tap asks the assistant to prepare
//            it; nothing runs before the member approves the proposal card
//   Build    a board for this context, and the app's widgets the board can
//            hold — a tap builds (the Dashboard path, for that ask only)
//   Inspect  point at a widget or a section and ask about it — a tap starts it
//
// `aiShowCapabilities()` answers the panel's "What can you do here?" row AT
// ONCE, with no model call: the member's line and the catalogue land in the
// thread where answers land (the main thread, or the assistant sidebar).
// `aiCapabilities(root)` is the pure catalogue; `aiCapabilityRun(item)` runs
// one row.

var $7iFOV = parcelRequire("7iFOV");

var $gzr3m = parcelRequire("gzr3m");

var $jrMGk = parcelRequire("jrMGk");
const $665483961bb78723$var$_AIC_ASK_MAX = 3;
const $665483961bb78723$var$_AIC_DO_MAX = 4;
const $665483961bb78723$var$_AIC_WIDGETS_MAX = 3;
// a catalogue line's description, in characters (one or two lines in the card)
const $665483961bb78723$var$_AIC_LINE_MAX = 120;
const $665483961bb78723$var$_aicStr = (v)=>v == null ? '' : String(v);
const $665483961bb78723$var$_aicText = (el, key)=>{
    const t = $665483961bb78723$var$_aicStr(key);
    if (!t) return '';
    try {
        return el && typeof el.call === 'function' ? $665483961bb78723$var$_aicStr(el.call('polyglot', t)) || t : t;
    } catch (_) {
        return t;
    }
};
// A sentence with ONE named hole, filled by a FUNCTION (a `$&` in a tenant's
// name must never read as a replacement pattern). Each caller names its own
// placeholder literally, so the bundle and the source agree on it.
const $665483961bb78723$var$_aicFill = (el, key, token, value)=>(0, $7iFOV.shellSay)(el, key).replace(token, ()=>$665483961bb78723$var$_aicStr(value));
// "mintTokens" → "Mint tokens": an action that declares no label still reads
// as words, never as its key.
const $665483961bb78723$var$_aicWords = (key)=>{
    const words = $665483961bb78723$var$_aicStr(key).replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/[-_]+/g, ' ').trim().toLowerCase();
    return words ? words[0].toUpperCase() + words.slice(1) : '';
};
// A line for a PERSON from a module's `describe` (written for the assistant —
// long, with parameter notes): its first sentence, cut at a word with an
// ellipsis when it is still long.
const $665483961bb78723$var$_aicSentence = (v, max)=>{
    const t = $665483961bb78723$var$_aicStr(v).replace(/\s+/g, ' ').trim();
    if (!t) return '';
    const end = t.search(/[.!?](\s|$)/);
    const first = end > 0 ? t.slice(0, end + 1) : t;
    if (first.length <= max) return first;
    const cut = first.slice(0, max);
    const space = cut.lastIndexOf(' ');
    return (space > max * 0.6 ? cut.slice(0, space) : cut).replace(/[\s,;:·(-]+$/, '') + "\u2026";
};
const $665483961bb78723$var$_aicKeyItems = (grp)=>{
    const items = [];
    grp.items.forEach((it, i)=>items.push({
            ...it,
            key: grp.key + '-' + i
        }));
    return {
        ...grp,
        items: items
    };
};
const $665483961bb78723$var$_aicStarterText = (el, it)=>{
    const raw = typeof it === 'string' ? it : it && typeof it.text === 'string' ? it.text : '';
    return $665483961bb78723$var$_aicText(el, raw.trim());
};
const $665483961bb78723$export$bf9404565b9bd21f = function aiCapabilities(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const row = (0, $jrMGk.aiScopeCurrent).call(el, r);
    if (!row) return null;
    const sf = (0, $jrMGk.aiScopeSurface).call(el, r);
    const apps = (0, $jrMGk.aiInstalledApps)(r);
    const inScope = row.kind === 'workspace' ? apps : row.appId ? apps.filter((a)=>a.id === row.appId) : [];
    // ASK — the context's own questions.
    const ask = [];
    if (row.kind === 'record' && sf.record) for (const s of (0, $gzr3m.aiRecordSuggestionItems)(sf.record.type).slice(0, $665483961bb78723$var$_AIC_ASK_MAX))ask.push({
        kind: 'ask',
        label: $665483961bb78723$var$_aicText(el, s.labelKey),
        prompt: $665483961bb78723$var$_aicText(el, s.promptKey)
    });
    else if (row.kind === 'workspace') {
        const merged = Array.isArray(r.workspaceProject && r.workspaceProject.chatStarters) ? r.workspaceProject.chatStarters : [];
        for (const it of merged.slice(0, $665483961bb78723$var$_AIC_ASK_MAX)){
            const t = $665483961bb78723$var$_aicStarterText(el, it);
            if (t) ask.push({
                kind: 'ask',
                label: t,
                prompt: t
            });
        }
    } else {
        for (const app of inScope)for (const it of app.chatStarters){
            if (ask.length >= $665483961bb78723$var$_AIC_ASK_MAX) break;
            const t = $665483961bb78723$var$_aicStarterText(el, it);
            if (t) ask.push({
                kind: 'ask',
                label: t,
                prompt: t
            });
        }
    }
    if (!ask.length) {
        const t = (0, $7iFOV.shellSay)(el, 'workspace.aiCap.askFallback');
        ask.push({
            kind: 'ask',
            label: t,
            prompt: $665483961bb78723$var$_aicFill(el, 'workspace.aiCap.askFallbackPrompt', '{name}', row.label)
        });
    }
    // DO — the approval-gated actions the apps in this context declare.
    const doItems = [];
    for (const app of inScope)for (const key of app.actionKeys){
        if (doItems.length >= $665483961bb78723$var$_AIC_DO_MAX) break;
        const label = $665483961bb78723$var$_aicText(el, app.actionLabels[key]) || $665483961bb78723$var$_aicWords(key);
        const describe = $665483961bb78723$var$_aicSentence(app.actionDocs[key], $665483961bb78723$var$_AIC_LINE_MAX);
        doItems.push({
            kind: 'do',
            label: label,
            describe: describe,
            action: key,
            app: app.id,
            prompt: $665483961bb78723$var$_aicFill(el, 'workspace.aiCap.doPrompt', '{action}', label)
        });
    }
    // BUILD — a board for the context, and the widgets it can hold.
    const build = [
        {
            kind: 'build',
            label: $665483961bb78723$var$_aicFill(el, 'workspace.aiCap.buildBoard', '{name}', row.label),
            prompt: $665483961bb78723$var$_aicFill(el, 'workspace.aiCap.buildBoardPrompt', '{name}', row.label)
        }
    ];
    const seenWidget = new Set();
    for (const app of inScope){
        let perApp = 0;
        for (const w of app.widgets){
            if (build.length > $665483961bb78723$var$_AIC_WIDGETS_MAX) break;
            if (!w || !w.id || seenWidget.has(w.id) || w.kind === 'app') continue;
            if (w.spec && w.spec.iconOnly) continue;
            if (row.kind === 'workspace' && perApp >= 1) break;
            const title = $665483961bb78723$var$_aicText(el, w.title);
            if (!title) continue;
            seenWidget.add(w.id);
            perApp++;
            build.push({
                kind: 'build',
                label: title,
                // the widget's own subtitle (a bundle key it ships) reads for people;
                // its `describe` is written for the assistant
                describe: $665483961bb78723$var$_aicText(el, w.subtitle) || $665483961bb78723$var$_aicSentence(w.describe, $665483961bb78723$var$_AIC_LINE_MAX),
                widget: w.id,
                app: app.id,
                prompt: $665483961bb78723$var$_aicFill(el, 'workspace.aiCap.buildWidgetPrompt', '{widget}', title)
            });
        }
    }
    const groups = [
        {
            key: 'ask',
            title: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.ask'),
            explain: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.askExplain'),
            glyph: 'lnAssistant',
            items: ask
        }
    ];
    if (doItems.length) groups.push({
        key: 'do',
        title: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.do'),
        explain: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.doExplain'),
        glyph: 'lnCheck',
        items: doItems
    });
    groups.push({
        key: 'build',
        title: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.build'),
        explain: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.buildExplain'),
        glyph: 'lnDashboard',
        items: build
    });
    groups.push({
        key: 'inspect',
        title: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.inspect'),
        explain: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.inspectExplain'),
        glyph: 'lnInspect',
        items: [
            {
                kind: 'inspect',
                label: (0, $7iFOV.shellSay)(el, 'workspace.aiCap.inspectStart')
            }
        ]
    });
    // Every line keyed by its group and place (the card's children keys).
    const keyed = groups.map($665483961bb78723$var$_aicKeyItems);
    return {
        scope: {
            kind: row.kind,
            label: row.label,
            ...row.appId ? {
                app: row.appId
            } : {}
        },
        title: $665483961bb78723$var$_aicFill(el, 'workspace.aiCap.title', '{name}', row.label),
        groups: keyed
    };
};
const $665483961bb78723$export$b8ba6db7a612de88 = function aiShowCapabilities() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const cat = $665483961bb78723$export$bf9404565b9bd21f.call(el, root);
    if (!cat) return false;
    const route = typeof el.context?.functions?.assistantSendRoute === 'function' ? el.call('assistantSendRoute', root, 'assistant') : null;
    try {
        if (route === 'thread') el.call('assistantMainThreadShow');
        else root.update({
            assistantOpen: true,
            _homeThreadOpen: false
        });
    } catch (_) {
    /* no thread view on this surface — the sidebar takes it */ }
    const now = Date.now();
    const ask = (0, $7iFOV.shellSay)(el, 'workspace.aiSuggest.generic.whatCanYouDo');
    const user = {
        id: 'u-cap-' + now,
        role: 'user',
        text: ask,
        ts: now
    };
    const answer = {
        id: 'a-cap-' + now,
        role: 'assistant',
        text: $665483961bb78723$var$_aicFill(el, 'workspace.aiCap.intro', '{name}', cat.scope.label),
        ts: now + 1,
        streaming: false,
        cards: [
            {
                type: 'capabilities',
                title: cat.title,
                scope: cat.scope,
                groups: cat.groups
            }
        ],
        sources: [],
        confidence: null,
        level: null,
        metadata: {
            kind: 'capabilities'
        }
    };
    const msgs = Array.isArray(root.chatMessages) ? root.chatMessages : [];
    root.update({
        chatMessages: msgs.concat(user, answer)
    });
    try {
        el.call('persistActiveSession', 'general');
    } catch (_) {
    /* the local buffer holds it either way */ }
    return true;
};
const $665483961bb78723$export$5b128f4866709a1f = function aiCapabilityRun(item) {
    const el = this;
    const x = item && typeof item === 'object' ? item : null;
    if (!x) return false;
    if (x.kind === 'inspect') return el.call('aiInspectStart');
    const text = $665483961bb78723$var$_aicStr(x.prompt || x.label).trim();
    if (!text) return false;
    const mode = x.kind === 'build' ? 'dashboard' : x.kind === 'do' ? 'assistant' : null;
    el.call('homeAiSend', text, null, 0, null, mode ? {
        mode: mode
    } : null);
    return true;
};

});

parcelRegister("18lRJ", function(module, exports) {

$parcel$export(module.exports, "assistantThreadUrlNext", () => $0d377fde372f5d2c$export$e864b5b3d61cd173);
$parcel$export(module.exports, "assistantThreadIdLinkable", () => $0d377fde372f5d2c$export$c889ceb36d9c8946);
$parcel$export(module.exports, "assistantThreadLinkId", () => $0d377fde372f5d2c$export$c4f49f2d14728bd3);
$parcel$export(module.exports, "assistantThreadUrlTarget", () => $0d377fde372f5d2c$export$f58ec85ca08eace5);
$parcel$export(module.exports, "assistantThreadUrlWrite", () => $0d377fde372f5d2c$export$d1ceb3bfec83d9d8);
$parcel$export(module.exports, "assistantThreadUrlCommit", () => $0d377fde372f5d2c$export$fcd7bbdafad0f763);
$parcel$export(module.exports, "assistantThreadUnavailable", () => $0d377fde372f5d2c$export$cd3313b54d7c5c00);
$parcel$export(module.exports, "assistantThreadLinkOpen", () => $0d377fde372f5d2c$export$d2a8d16d15d8889d);
$parcel$export(module.exports, "assistantThreadLinkLeave", () => $0d377fde372f5d2c$export$cf70cdee247f9bc1);
$parcel$export(module.exports, "assistantThreadUrlReconcile", () => $0d377fde372f5d2c$export$60ce515f2298943);
// assistantThreadUrl.js — EVERY MAIN-THREAD CONVERSATION HAS ITS OWN URL
// (Nika 2026-09-30: "also add unique url to those thread in main chatbot so we
// can identify those again").
//
// THE SHAPE: `?ai=<conversationId>` on the route the main thread shows over —
// `/w/<org>/<ws>/?ai=…` on the home, `/w/<org>/<ws>/crm?ai=…` over a page
// (main thread = "Everywhere", AI_ASSISTANT_SPEC §12.2). A query key, not a
// path segment: the main thread is a VIEW of the route it opened on
// (`_mainThreadPath`), so the route stays the route. Not `thread=`: the
// address bar already mirrors a PageSlot pane's own query
// (`/?page=/mail&thread=…`), and chat and add-app read that name.
// The URL keeps the address bar's own `/w/<org>/<ws>` prefix, so a pasted link
// opens in the right workspace — on a canvas project page too
// (`/w/<org>/<ws>/p/<key>?ai=…`, see assistantThreadUrlWrite).
//
// WHY: the open thread was remembered PER DEVICE (functions/_simone/
// threadPointer.js — localStorage, 24 h), so another device, or the same one a
// day later, showed no conversation. The URL names the thread for a reload,
// another device and a pasted link. The pointer STAYS: it still serves the
// drawer, the dashboard and add-app threads, the agent threads and the
// in-flight flag (the interrupted-turn notice) — the URL wins for the main
// thread and the pointer follows it (switchSession writes it).
//
// ONE RECONCILE, TWO DIRECTIONS (components/AssistantThreadUrlSync.js runs it on
// every change of the keys it reads). `root._aiThreadUrlId` is the id the URL
// and the state last AGREED on:
//   • the ADDRESS BAR moved away from it (a pasted link, a reload, Back /
//     Forward) → the URL leads: open that conversation, or close the thread
//     the URL no longer names;
//   • the STATE moved away from it (the first real id of a new conversation,
//     a history switch, "Open in main", Esc, "Open in sidebar", New chat, a
//     navigation, a placement change) → the URL follows. A thread that GAINS
//     its URL or changes it is a new history entry (push: Back returns to the
//     page without the thread); a thread that LOSES it rewrites the entry
//     (replace: never stack an entry for what the person just closed).
// A local `s-…` session names no server conversation and never reaches the URL.
//
// ACCESS. The server decides: `getWorkspaceConversation` reads a conversation
// for its owner, or for a workspace member once the owner shared it, and
// answers the SAME 404 for an unshared and a missing one (the route middleware
// checked the membership first). The client only reports it: a link that
// cannot be read loads NO rows, the thread view says "not available"
// (`root._aiThreadLink.status === 'unavailable'`; the sidebar placement gets a
// notification), and the next send starts a NEW conversation — never a hidden
// one under an empty view. The line itself is components/
// AssistantThreadUnavailable.js, mounted in the thread view above the empty hint.
//
// PLACEMENT (Nika's pick): the default placement opens the link in MAIN, over
// the route in the URL; a person who chose the sidebar gets it in the sidebar.
// The choice is never rewritten.
//
// Navigation goes through `el.router` — never a raw history or location write.
//
// THE ENGINE RE-RUNS THE RECONCILE INSIDE ITS OWN WRITES. The sentinel calls it
// from a `subscribeTo` effect, which tracks every root key the reconcile
// reads: a root write made here (a marker, the thread's flag) flushes that
// effect again — at once when the write comes from outside an effect (the
// link's async read), after the current run otherwise. And the router can
// write the history entry LATER than the call (the default router awaits its
// guards before the write; only the workspace-prefixed branch writes at once).
// So every step keeps each intermediate state readable as "nothing to do":
//   • while a link is decided its marker says `loading` — the final marker
//     write is the LAST write of the step;
//   • a URL write states what the address bar WILL show before anything else
//     moves (`el.__aiThreadUrlExpect`, assistantThreadUrlCommit); until the
//     bar shows it the reconcile stands still.
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained and reaches its siblings by el.call.
// PURE — the app URL (path + query + hash) that names conversation `id`. A
// falsy id removes the key. Every other parameter and the hash stay as they are.
const $0d377fde372f5d2c$export$e864b5b3d61cd173 = function assistantThreadUrlNext(route, params, hash, id) {
    const path = typeof route === 'string' && route ? route : '/';
    const query = new URLSearchParams(params || '');
    if (id) query.set('ai', String(id));
    else query.delete('ai');
    const qs = query.toString();
    return path + (qs ? '?' + qs : '') + (typeof hash === 'string' ? hash : '');
};
const $0d377fde372f5d2c$export$c889ceb36d9c8946 = function assistantThreadIdLinkable(id) {
    return typeof id === 'string' && !!id && !id.startsWith('s-');
};
const $0d377fde372f5d2c$export$c4f49f2d14728bd3 = function assistantThreadLinkId() {
    const app = typeof this.getRoot === 'function' ? this.getRoot() : this;
    if (!app || typeof app.call !== 'function') return null;
    const v = app.call('readPageParam', 'ai');
    return this.call('assistantThreadIdLinkable', v) ? v : null;
};
const $0d377fde372f5d2c$export$f58ec85ca08eace5 = function assistantThreadUrlTarget(root) {
    const r = root && typeof root === 'object' ? root : {};
    const id = r.activeSessionId;
    const open = !!this.call('assistantMainThreadOpen', r);
    return open && this.call('assistantThreadIdLinkable', id) ? id : null;
};
const $0d377fde372f5d2c$export$d1ceb3bfec83d9d8 = function assistantThreadUrlWrite(id, replace) {
    const app = typeof this.getRoot === 'function' ? this.getRoot() : this;
    if (!app || typeof app.call !== 'function' || typeof this.router !== 'function') return null;
    const live = app.call('readPageRoute');
    const route = typeof live === 'string' && live ? live : '/';
    const next = this.call('assistantThreadUrlNext', route, app.call('readPageParams'), app.call('readPageHash'), id || null);
    return this.router(next, app, {}, {
        scrollToTop: false,
        replace: !!replace
    });
};
const $0d377fde372f5d2c$export$fcd7bbdafad0f763 = function assistantThreadUrlCommit(id, replace) {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const want = id || null;
    const expect = {
        id: want
    };
    this.__aiThreadUrlExpect = expect;
    if ((root._aiThreadUrlId || null) !== want || root._aiThreadLink) root.update({
        _aiThreadUrlId: want,
        _aiThreadLink: null
    }, {
        preventFetch: true
    });
    let done = null;
    try {
        done = this.call('assistantThreadUrlWrite', want, replace);
    } catch (_) {
        done = null;
    }
    const lift = ()=>{
        if (this.__aiThreadUrlExpect !== expect) return false;
        this.__aiThreadUrlExpect = null;
        return true;
    };
    if (this.call('assistantThreadLinkId') === want) lift();
    else if (done && typeof done.then === 'function') {
        const settle = ()=>{
            if (lift()) this.call('assistantThreadUrlReconcile');
        };
        done.then(settle, settle);
    } else // no router, or one that wrote nothing: nothing is on its way
    lift();
    return true;
};
const $0d377fde372f5d2c$export$cd3313b54d7c5c00 = function assistantThreadUnavailable(root) {
    const r = root && typeof root === 'object' ? root : {};
    const link = r._aiThreadLink;
    const list = r.chatMessages;
    const empty = !Array.isArray(list) || list.length === 0;
    return !!(link && link.status === 'unavailable') && empty;
};
const $0d377fde372f5d2c$export$d2a8d16d15d8889d = async function assistantThreadLinkOpen(id) {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function' || !id) return false;
    const ws = root.workspace && (root.workspace.id || root.workspace._id) || null;
    root.update({
        _aiThreadUrlId: id,
        _aiThreadLink: {
            id: id,
            status: 'loading',
            ws: ws
        }
    }, {
        preventFetch: true
    });
    try {
        // When the link names the thread this device remembers, the restore brings
        // it back with its mid-turn notice and its waiting client call; it stands
        // still for any other remembered thread (sessions.js restoreActiveThread:
        // the address bar wins). Every other id is a plain server read. Both leave
        // `activeSessionId` alone when the read fails.
        if (!root.activeSessionId) await this.call('restoreActiveThread');
        if (root.activeSessionId !== id) await this.call('switchSession', id);
    } catch (_) {
    /* a failed read is the not-available state below */ }
    // The address bar or the workspace moved on while the conversation loaded:
    // the attempt that started after this one owns the state now.
    const mine = root._aiThreadLink;
    if (!mine || mine.id !== id || mine.status !== 'loading' || (mine.ws || null) !== ws) return false;
    const main = root.assistantDock === 'main' && !root._canvasSlot && !root._canvasSlotSecond;
    // The thread (or the sidebar) shows FIRST and the marker goes LAST: while
    // it says `loading` the reconcile stands still, so no half-open state is
    // read as a change of the thread.
    if (root.activeSessionId === id) {
        if (main) {
            this.call('assistantThreadToMain');
            root.update({
                _aiThreadLink: null
            }, {
                preventFetch: true
            });
        } else {
            root.update({
                assistantOpen: true
            });
            // The sidebar shows it: the URL names MAIN threads only.
            this.call('assistantThreadUrlCommit', null, true);
        }
        this.call('assistantThreadUrlReconcile');
        return true;
    }
    // NOT AVAILABLE — no rows of it, and none of another conversation under the
    // message: the next send starts a new one.
    if (main) {
        root.update({
            activeSessionId: null,
            chatMessages: [],
            chatTyping: false,
            currentAssistantId: null
        });
        this.call('assistantThreadToMain');
        root.update({
            _aiThreadLink: {
                id: id,
                status: 'unavailable',
                ws: ws
            }
        }, {
            preventFetch: true
        });
        this.call('assistantThreadUrlReconcile');
        return false;
    }
    this.call('openNotification', {
        type: 'error',
        title: this.call('polyglot', 'workspace.simone.threadUnavailableTitle'),
        message: this.call('polyglot', 'workspace.simone.threadUnavailable')
    });
    // The sidebar is closed and its chat not mounted: when the person opens it,
    // it restores the thread this device remembers, as on any load — the address
    // bar names no thread by then.
    this.call('assistantThreadUrlCommit', null, true);
    return false;
};
const $0d377fde372f5d2c$export$cf70cdee247f9bc1 = function assistantThreadLinkLeave() {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const last = root._aiThreadUrlId;
    const link = root._aiThreadLink;
    const showing = !!this.call('assistantMainThreadOpen', root) && (root.activeSessionId === last || !!(link && link.id === last));
    // The thread closes first and the markers go last: a reconcile that runs in
    // between still reads "the address bar names no thread" and ends here too.
    if (showing) this.call('assistantMainThreadClose');
    if (root._aiThreadUrlId || root._aiThreadLink) root.update({
        _aiThreadUrlId: null,
        _aiThreadLink: null
    }, {
        preventFetch: true
    });
    return true;
};
const $0d377fde372f5d2c$export$60ce515f2298943 = function assistantThreadUrlReconcile() {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return null;
    const ws = root.workspace && (root.workspace.id || root.workspace._id) || null;
    const step = ()=>{
        const url = this.call('assistantThreadLinkId');
        const last = root._aiThreadUrlId || null;
        const link = root._aiThreadLink;
        // A URL write of this module is on its way (assistantThreadUrlCommit):
        // nothing is decided until the address bar shows it.
        const expect = this.__aiThreadUrlExpect;
        if (expect) {
            if (url !== expect.id) return 'pending';
            this.__aiThreadUrlExpect = null;
        }
        // The open thread's markers are gone and the address bar still names it:
        // the workspace changed. The thread stays behind.
        if (url && this.__aiThreadAgreed === url && url !== last) {
            this.__aiThreadAgreed = null;
            this.call('assistantThreadUrlCommit', null, true);
            return 'switch';
        }
        // 1. The address bar moved: the URL leads.
        if (url !== last) {
            if (!url) {
                this.call('assistantThreadLinkLeave');
                return 'leave';
            }
            // The read needs the AI service and the workspace it reads in; the view
            // re-runs this when either lands.
            if (root._aiSvcReady !== true || !ws) return 'wait';
            this.call('assistantThreadLinkOpen', url);
            return 'open';
        }
        // 2. The state moved: the URL follows.
        if (link && link.id === url) {
            // The answer is for another workspace than the one the shell is in now.
            if (link.ws && ws && link.ws !== ws) {
                if (root._aiSvcReady !== true) return 'wait';
                this.call('assistantThreadLinkOpen', url);
                return 'open';
            }
            if (link.status === 'loading') return 'loading';
            const open = !!this.call('assistantMainThreadOpen', root);
            const next = this.call('assistantThreadUrlTarget', root);
            // The message is on screen: the dead link stays on the address bar until
            // the person closes the thread or a new conversation takes its place.
            if (open && !next) return 'unavailable';
            this.call('assistantThreadUrlCommit', next, true);
            return 'write';
        }
        const target = this.call('assistantThreadUrlTarget', root);
        if (target === last) return null;
        this.call('assistantThreadUrlCommit', target, !target);
        return 'write';
    };
    const did = step();
    // What the address bar and an OPEN thread agree on now. A loading or an
    // unreadable link is not an agreement, and the memory lasts only while the
    // address bar still names that id.
    const now = this.call('assistantThreadLinkId');
    const held = root._aiThreadUrlId || null;
    if (now && !root._aiThreadLink && held === now) this.__aiThreadAgreed = now;
    else if (this.__aiThreadAgreed !== now) this.__aiThreadAgreed = null;
    return did;
};

});

parcelRegister("2sLUA", function(module, exports) {

$parcel$export(module.exports, "assistantDeckSupport", () => $1cb35c931ae90560$export$74172a57cce8a2e9);
$parcel$export(module.exports, "assistantDeckFixture", () => $1cb35c931ae90560$export$7ff446ae00f9b090);
$parcel$export(module.exports, "assistantDeckSlidesFor", () => $1cb35c931ae90560$export$5e61911e85dd5c72);
$parcel$export(module.exports, "applyDeckFrame", () => $1cb35c931ae90560$export$a731df3aac86821c);
$parcel$export(module.exports, "assistantDeckFailed", () => $1cb35c931ae90560$export$e5fac5c977615cc8);
$parcel$export(module.exports, "assistantDeckViewModel", () => $1cb35c931ae90560$export$c14fbd5a7434a03a);
$parcel$export(module.exports, "assistantDeckShown", () => $1cb35c931ae90560$export$7803ca3911df69cd);
$parcel$export(module.exports, "assistantDeckSlide", () => $1cb35c931ae90560$export$dc48f8fdda49ef41);
$parcel$export(module.exports, "assistantDeckCounter", () => $1cb35c931ae90560$export$51778a2099623748);
$parcel$export(module.exports, "assistantDeckCanGo", () => $1cb35c931ae90560$export$fd866246dd6a09e7);
$parcel$export(module.exports, "assistantDeckMicro", () => $1cb35c931ae90560$export$b1acdb9b5e26b9d7);
$parcel$export(module.exports, "assistantDeckStatus", () => $1cb35c931ae90560$export$857b17d35c832f49);
$parcel$export(module.exports, "assistantDeckSaveLabel", () => $1cb35c931ae90560$export$c57d93834864b619);
$parcel$export(module.exports, "assistantDeckActionsIdle", () => $1cb35c931ae90560$export$21fabce9f5a9c0da);
$parcel$export(module.exports, "assistantDeckGo", () => $1cb35c931ae90560$export$101dc3e274e66822);
$parcel$export(module.exports, "assistantDeckDismiss", () => $1cb35c931ae90560$export$ff7c40d76ae24ccb);
$parcel$export(module.exports, "assistantDeckGenerate", () => $1cb35c931ae90560$export$480e01f911be918f);
$parcel$export(module.exports, "assistantDeckRetry", () => $1cb35c931ae90560$export$7373129832330caf);
$parcel$export(module.exports, "assistantDeckFocus", () => $1cb35c931ae90560$export$5f0174da05a2f1f1);
$parcel$export(module.exports, "saveDeck", () => $1cb35c931ae90560$export$9d050f2ed5d65c19);
$parcel$export(module.exports, "assistantDeckOpenSaved", () => $1cb35c931ae90560$export$a3a30e33575c236a);
$parcel$export(module.exports, "assistantDeckRederive", () => $1cb35c931ae90560$export$ea60163cdbf8a1ba);
$parcel$export(module.exports, "assistantDeckPresent", () => $1cb35c931ae90560$export$e26d601f07fcb2ab);
$parcel$export(module.exports, "assistantDeckPresentExit", () => $1cb35c931ae90560$export$73f08aa27dd62f3e);
$parcel$export(module.exports, "assistantDeckPresenterKey", () => $1cb35c931ae90560$export$aeb9b542017fcde2);
$parcel$export(module.exports, "assistantDeckShortcuts", () => $1cb35c931ae90560$export$fae42c9669f04c9d);
// assistantDeck.js — PRESENTATION: a LIVE DECK in the main area
// (AI_ASSISTANT_SPEC v1.1 §12.1–§12.2; the ai.boards DECK contract v1 of the
// aib lane). Nika 2026-09-29: "dropdown should contain [… Presentation]";
// Presentation = "Live deck in thread".
//
// A deck is the ai.boards path's second shape: ONE fast model call, no tools —
// the same `generate` / `refine` ops with `mode: 'presentation'`. The model
// never writes a number: a slide is a headline (+ an optional subtitle and
// speaker notes) and one or two LIVE items — an installed app's widget with
// its params, or a declarative RECORDS BLOCK whose rows the renderer fetches
// through the SDK (`ai.boards.records`). This module turns the DeckSpec into
// what components/AssistantDeckView.js paints:
//
//   assistantDeckSlidesFor   DeckSpec × the installed vocabulary → the slides;
//                            each content slide's items go through the BOARD's
//                            own derivation (boardItemsFor → validateBoardSpec),
//                            so a slide mounts exactly what a board would, and
//                            an item this shell cannot mount is counted, never
//                            guessed at
//   applyDeckFrame           the streaming reducer over the board.* frames
//                            (board.start · board.head · board.slide … ·
//                            board.drop · board.done (authoritative) ·
//                            board.error)
//   assistantDeckGenerate    a send in Presentation mode (functions/homeAiSend.js)
//                            — a follow-up while a deck shows REFINES it
//   assistantDeckGo / Present / Save / Dismiss / Retry — the view's verbs
//
// THE VIEW MODEL (`root._aiDeck`, workspace-scoped, beside `_aiBoard`):
//   { v, status: 'loading'|'streaming'|'ready'|'failed', requestId,
//     workspaceId, path, prompt, op, raw, id, title, summary, slides, index,
//     total, dropped, error, save, savedId, notice, dismissed, explicit,
//     preview, startedAt, receivedAt }
// `path` is the route the deck was made on: the deck shows in THAT page's main
// area (the home's grid area on the home, the page layer elsewhere). ONE view
// holds the main area — the main thread and a generated board step aside for a
// deck, and a deck steps aside for them.
//
// FRANK: every export is SELF-CONTAINED — no import, no module-scope constant,
// no bare call to a sibling export (reached through `this.call`), exactly like
// functions/assistantBoard.js. These run as `el.call('name', …)`, so `this` is
// an element.
// ── The SDK seam (SDK-PIN) ───────────────────────────────────────────────────
// @symbo.ls/sdk 3.14.799 forwards `mode` on ai.boards generate / refine and
// marks it: `getService('aiBoards').supportsMode === true` (workspace pin
// 5fbed0373). An OLDER SDK drops `mode` from the request — the server would
// answer a BOARD — so without the marker a Presentation send makes NO model
// call and the deck says it is not available here (the one honest state).
// Returns true | false, or a promise of one (the shell's SDK answers
// getService with a promise on a page's first read).
const $1cb35c931ae90560$export$74172a57cce8a2e9 = function assistantDeckSupport(sdk) {
    try {
        const client = sdk || this && this.sdk || (this && typeof this.call === 'function' ? this.call('getSDK') : null);
        if (!client || client.isNullClient === true || typeof client.getService !== 'function') return false;
        const has = (svc)=>!!(svc && svc.supportsMode === true);
        let svc = null;
        try {
            svc = client.getService('aiBoards');
        } catch (_) {
            return false;
        }
        if (svc && typeof svc.then === 'function') return Promise.resolve(svc).then(has, ()=>false);
        return has(svc);
    } catch (_) {
        return false;
    }
};
const $1cb35c931ae90560$export$7ff446ae00f9b090 = function assistantDeckFixture() {
    return {
        v: 1,
        kind: 'deck',
        id: 'brd_deck_preview',
        prompt: 'Present our Q3 sales and inventory for the board meeting',
        title: 'Q3 sales and inventory',
        summary: 'Where the pipeline stands, what sold, and what is still available.',
        slides: [
            {
                id: 's1',
                kind: 'title',
                title: 'Q3 sales and inventory',
                subtitle: "Board meeting \xb7 Q3"
            },
            {
                id: 's2',
                kind: 'content',
                title: 'The pipeline today',
                subtitle: 'Open deals by stage',
                notes: 'Start with the shape of the pipeline before the sold units.',
                items: [
                    {
                        id: 's2i1',
                        kind: 'widget',
                        widget: 'crm.crm-pipeline',
                        app: 'crm',
                        params: {},
                        size: 'l'
                    }
                ]
            },
            {
                id: 's3',
                kind: 'content',
                title: 'Deals in negotiation',
                items: [
                    {
                        id: 's3i1',
                        kind: 'records',
                        app: 'crm',
                        collection: 'crm_deals',
                        view: 'stat',
                        title: {
                            text: 'Deals in negotiation'
                        },
                        filters: [
                            {
                                field: 'stage',
                                op: 'eq',
                                value: 'offer_negotiation'
                            }
                        ],
                        aggregate: {
                            op: 'count'
                        },
                        size: 's'
                    },
                    {
                        id: 's3i2',
                        kind: 'records',
                        app: 'crm',
                        collection: 'crm_deals',
                        view: 'list',
                        title: {
                            text: 'The largest ones'
                        },
                        filters: [
                            {
                                field: 'stage',
                                op: 'eq',
                                value: 'offer_negotiation'
                            }
                        ],
                        sort: {
                            field: 'value',
                            dir: 'desc'
                        },
                        limit: 5,
                        fields: [
                            'title',
                            'contactName',
                            'value',
                            'currency'
                        ],
                        size: 'm'
                    }
                ]
            },
            {
                id: 's4',
                kind: 'content',
                title: 'What sold this quarter',
                items: [
                    {
                        id: 's4i1',
                        kind: 'records',
                        app: 'realestate',
                        collection: 're_units',
                        view: 'chart',
                        title: {
                            text: 'Units sold by space type'
                        },
                        filters: [
                            {
                                field: 'status',
                                op: 'eq',
                                value: 'sold'
                            }
                        ],
                        period: {
                            field: 'statusChangedAt',
                            preset: 'thisQuarter'
                        },
                        aggregate: {
                            op: 'count'
                        },
                        groupBy: 'spaceType',
                        size: 'l'
                    }
                ]
            },
            {
                id: 's5',
                kind: 'content',
                title: 'Viewings this quarter',
                notes: 'Close on demand: the viewings keep the pipeline full.',
                items: [
                    {
                        id: 's5i1',
                        kind: 'records',
                        app: 'workspace',
                        collection: 'booking',
                        view: 'chart',
                        title: {
                            text: 'Viewings by status'
                        },
                        filters: [
                            {
                                field: 'kind',
                                op: 'eq',
                                value: 'viewing'
                            }
                        ],
                        period: {
                            field: 'startAt',
                            preset: 'thisQuarter'
                        },
                        aggregate: {
                            op: 'count'
                        },
                        groupBy: 'status',
                        size: 'l'
                    }
                ]
            }
        ],
        sources: [
            {
                app: 'crm'
            },
            {
                app: 'realestate'
            },
            {
                app: 'workspace'
            }
        ],
        generatedAt: null,
        model: 'fixture'
    };
};
const $1cb35c931ae90560$export$5e61911e85dd5c72 = function assistantDeckSlidesFor(spec, root) {
    const text = (v, n)=>typeof v === 'string' ? v.trim().slice(0, n) : '';
    const s = spec && typeof spec === 'object' ? spec : {};
    const deckId = text(s.id, 80) || 'deck';
    const list = Array.isArray(s.slides) ? s.slides.filter((x)=>x && typeof x === 'object') : [];
    const first = list[0] && list[0].kind === 'title' ? list[0] : null;
    const titleSlide = {
        key: 's1',
        id: 's1',
        kind: 'title',
        title: text(first ? first.title : s.title, 80) || text(s.title, 80),
        subtitle: text(first ? first.subtitle : s.summary, 140),
        notes: text(first && first.notes, 600),
        items: [],
        total: 0,
        dropped: 0
    };
    const contents = list.filter((x)=>x.kind !== 'title').slice(0, 8);
    let total = 0;
    let dropped = 0;
    const slides = [
        titleSlide
    ];
    contents.forEach((raw, i)=>{
        const id = text(raw.id, 8) || 's' + (i + 2);
        const items = Array.isArray(raw.items) ? raw.items.slice(0, 2) : [];
        const derived = this.call('boardItemsFor', {
            v: 1,
            id: deckId + '-' + id,
            prompt: text(s.prompt, 500),
            title: text(raw.title, 60),
            items: items,
            sources: Array.isArray(s.sources) ? s.sources : []
        }, root);
        total += derived.total;
        dropped += derived.dropped;
        slides.push({
            key: id,
            id: id,
            kind: 'content',
            title: text(raw.title, 80),
            subtitle: text(raw.subtitle, 140),
            notes: text(raw.notes, 600),
            items: derived.items.map((it)=>({
                    ...it,
                    slide: id
                })),
            total: derived.total,
            dropped: derived.dropped
        });
    });
    return {
        slides: slides,
        total: total,
        dropped: dropped
    };
};
const $1cb35c931ae90560$export$a731df3aac86821c = function applyDeckFrame(deck, frame, root) {
    if (!deck || !frame || typeof frame !== 'object') return deck;
    const event = String(frame.event || '');
    const data = frame.data && typeof frame.data === 'object' ? frame.data : {};
    if (event === 'board.error') return this.call('assistantDeckFailed', deck, data.code || 'failed');
    const raw = deck.raw ? {
        ...deck.raw,
        slides: Array.isArray(deck.raw.slides) ? deck.raw.slides.slice() : []
    } : {
        v: 1,
        kind: 'deck',
        prompt: deck.prompt,
        slides: []
    };
    let status = deck.status === 'loading' ? 'streaming' : deck.status;
    let dropped = Number(deck.streamDropped) || 0;
    if (event === 'board.start') {
        if (data.id) raw.id = data.id;
    } else if (event === 'board.head') {
        if (typeof data.title === 'string') raw.title = data.title;
        if (typeof data.summary === 'string') raw.summary = data.summary;
        if (data.id) raw.id = data.id;
    } else if (event === 'board.slide') {
        const slide = data.slide && typeof data.slide === 'object' ? data.slide : null;
        const at = Number.isInteger(data.index) && data.index >= 0 ? data.index : raw.slides.length;
        // Slides land at their INDEX (the title slide may come after a content
        // one): the raw list keeps every position — a hole is null until its
        // slide lands; the derivation skips holes.
        if (slide) {
            raw.slides[at] = slide;
            raw.slides = Array.from(raw.slides, (x)=>x || null);
        }
    } else if (event === 'board.drop') dropped += 1;
    else if (event === 'board.done') {
        const spec = data.spec && typeof data.spec === 'object' ? data.spec : null;
        // A done frame with no slides is a BOARD: a server that does not know the
        // deck shape yet answered the ask as a board — not available here.
        if (!spec || !Array.isArray(spec.slides)) return this.call('assistantDeckFailed', deck, spec ? 'unavailable' : 'failed');
        Object.assign(raw, spec);
        raw.slides = spec.slides.slice();
        status = 'ready';
    } else return deck;
    const derived = this.call('assistantDeckSlidesFor', raw, root);
    const count = derived.slides.length;
    const index = Math.min(Math.max(Number(deck.index) || 0, 0), Math.max(count - 1, 0));
    return {
        ...deck,
        status: status,
        raw: raw,
        id: raw.id || deck.id || null,
        title: typeof raw.title === 'string' ? raw.title : deck.title || '',
        summary: typeof raw.summary === 'string' ? raw.summary : deck.summary || '',
        slides: derived.slides,
        total: derived.total,
        dropped: derived.dropped,
        streamDropped: dropped,
        index: index,
        error: null,
        receivedAt: deck.receivedAt || Date.now()
    };
};
const $1cb35c931ae90560$export$e5fac5c977615cc8 = function assistantDeckFailed(deck, reason) {
    const code = String(reason || '');
    const why = code === 'timeout' || code === 'unavailable' ? code : code === 'empty_deck' || code === 'empty' ? 'empty' : code === 'invalid_mode' ? 'unavailable' : 'failed';
    return {
        ...deck || {},
        status: 'failed',
        error: why
    };
};
const $1cb35c931ae90560$export$c14fbd5a7434a03a = function assistantDeckViewModel(root) {
    const r = root || {};
    const deck = r._aiDeck;
    const preview = r._aiDeckPreview === true;
    const ws = r.workspace;
    const live = ws && (ws.id || ws._id) || null;
    if (deck && typeof deck === 'object') {
        if (!deck.workspaceId || !live || String(deck.workspaceId) === String(live)) return deck;
    }
    if (!preview) return null;
    const raw = this.call('assistantDeckFixture');
    const derived = this.call('assistantDeckSlidesFor', raw, r);
    const index = Math.min(Math.max(Number(r._aiDeckPreviewIndex) || 0, 0), derived.slides.length - 1);
    return {
        v: 1,
        status: 'ready',
        requestId: 'preview',
        preview: true,
        path: '/',
        prompt: raw.prompt,
        raw: raw,
        id: raw.id,
        title: raw.title,
        summary: raw.summary,
        slides: derived.slides,
        total: derived.total,
        dropped: derived.dropped,
        index: index,
        error: null,
        save: null,
        savedId: null,
        notice: null,
        dismissed: false,
        receivedAt: null
    };
};
const $1cb35c931ae90560$export$7803ca3911df69cd = function assistantDeckShown(root) {
    const r = root || {};
    const path = r.currentPath;
    const dock = r.assistantDock;
    const available = r._aiBoardsAvailable === true;
    const vm = this.call('assistantDeckViewModel', r);
    const fns = this.context && this.context.functions;
    const thread = fns && typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    if (!vm || vm.dismissed) return false;
    const norm = (p)=>{
        const raw = typeof p === 'string' && p ? p : '/';
        const s = this.call('stripWorkspacePrefix', raw);
        const v = typeof s === 'string' ? s : raw;
        return v === '' ? '/' : v.length > 1 ? v.replace(/\/+$/, '') : v;
    };
    const route = norm(path);
    if (norm(vm.path) !== route) return false;
    if (thread) return false;
    if (vm.explicit || vm.preview) return route === '/';
    return dock === 'main' && available;
};
const $1cb35c931ae90560$export$dc48f8fdda49ef41 = function assistantDeckSlide(vm) {
    const slides = vm && Array.isArray(vm.slides) ? vm.slides : [];
    if (!slides.length) return vm && (vm.status === 'loading' || vm.status === 'streaming') ? {
        key: 'skeleton',
        kind: 'skeleton',
        items: []
    } : null;
    const i = Math.min(Math.max(Number(vm.index) || 0, 0), slides.length - 1);
    return slides[i];
};
const $1cb35c931ae90560$export$51778a2099623748 = function assistantDeckCounter(vm) {
    const slides = vm && Array.isArray(vm.slides) ? vm.slides : [];
    if (!slides.length) return '';
    const i = Math.min(Math.max(Number(vm.index) || 0, 0), slides.length - 1);
    return String(this.call('polyglot', 'workspace.assistantDeck.counter')).replace('{index}', String(i + 1)).replace('{count}', String(slides.length));
};
const $1cb35c931ae90560$export$fd866246dd6a09e7 = function assistantDeckCanGo(vm, step) {
    const slides = vm && Array.isArray(vm.slides) ? vm.slides : [];
    const i = Math.min(Math.max(Number(vm && vm.index) || 0, 0), Math.max(slides.length - 1, 0));
    return step < 0 ? i > 0 : i < slides.length - 1;
};
const $1cb35c931ae90560$export$b1acdb9b5e26b9d7 = function assistantDeckMicro(vm) {
    if (!vm) return '';
    if (vm.status === 'loading' || vm.status === 'streaming') return this.call('polyglot', 'workspace.assistantDeck.microLoading');
    const count = Array.isArray(vm.slides) ? vm.slides.length : 0;
    const at = vm.raw && vm.raw.generatedAt || vm.receivedAt || null;
    const when = at ? this.call('timeAgo', at) || '' : '';
    return String(this.call('polyglot', 'workspace.assistantDeck.micro')).replace('{count}', String(count)).replace('{when}', when).replace(/\s·\s$/, '');
};
const $1cb35c931ae90560$export$857b17d35c832f49 = function assistantDeckStatus(vm) {
    if (!vm) return '';
    if (vm.status === 'failed') {
        if (vm.error === 'timeout') return this.call('polyglot', 'workspace.assistantDeck.timeout');
        if (vm.error === 'unavailable') return this.call('polyglot', 'workspace.assistantDeck.unavailable');
        if (vm.error === 'empty') return this.call('polyglot', 'workspace.assistantDeck.empty');
        return this.call('polyglot', 'workspace.assistantDeck.failed');
    }
    if (vm.notice === 'saveFailed') return this.call('polyglot', 'workspace.assistantDeck.saveFailed');
    return '';
};
const $1cb35c931ae90560$export$c57d93834864b619 = function assistantDeckSaveLabel(vm) {
    const state = vm && vm.save;
    return state === 'saving' ? 1 : state === 'saved' ? 2 : 0;
};
const $1cb35c931ae90560$export$21fabce9f5a9c0da = function assistantDeckActionsIdle(vm) {
    return !vm || vm.preview || vm.status !== 'ready' || !(vm.slides || []).length;
};
const $1cb35c931ae90560$export$101dc3e274e66822 = function assistantDeckGo(step, opts) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const vm = this.call('assistantDeckViewModel', root);
    const slides = vm && Array.isArray(vm.slides) ? vm.slides : [];
    if (!slides.length) return false;
    const cur = Math.min(Math.max(Number(vm.index) || 0, 0), slides.length - 1);
    const to = opts && opts.to != null ? Number(opts.to) : cur + (Number(step) || 0);
    const next = Math.min(Math.max(Number.isFinite(to) ? to : cur, 0), slides.length - 1);
    if (next === cur) return false;
    if (vm.preview) {
        root.update({
            _aiDeckPreviewIndex: next
        }, {
            preventFetch: true
        });
        return true;
    }
    root.update({
        _aiDeck: {
            ...root._aiDeck,
            index: next
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $1cb35c931ae90560$export$ff7c40d76ae24ccb = function assistantDeckDismiss(opts) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const d = root._aiDeck;
    if (d && !d.dismissed) root.update({
        _aiDeck: {
            ...d,
            dismissed: true
        }
    }, {
        preventFetch: true
    });
    if (root._aiDeckPreview === true) root.update({
        _aiDeckPreview: false
    }, {
        preventFetch: true
    });
    const fns = this.context && this.context.functions;
    if (opts && opts.focusComposer && fns && typeof fns.assistantBoardFocus === 'function') this.call('assistantBoardFocus', 'composer');
    return true;
};
const $1cb35c931ae90560$export$480e01f911be918f = async function assistantDeckGenerate(prompt, opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    const input = prompt && typeof prompt === 'object' ? prompt : {
        prompt: prompt
    };
    const text = String(input.prompt == null ? '' : input.prompt).trim();
    if (!root || typeof root.update !== 'function' || !text) return null;
    const o = {
        ...opts || {}
    };
    if (input.attached) o.attached = input.attached;
    if (input.attachments) o.attachments = input.attachments;
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    const madeOn = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    // A FOLLOW-UP refines the deck on screen (the coordinator's reading of
    // Nika's "Live deck in thread": the next ask shapes the same deck).
    const current = root._aiDeck;
    const shown = !!el.call('assistantDeckShown', root);
    const onScreen = !o.fresh && shown && current && current.status === 'ready' && !current.preview && current.raw ? current : null;
    const refine = o.refine || (onScreen ? {
        spec: onScreen.raw,
        boardId: onScreen.savedId || null
    } : null);
    const op = refine ? 'refine' : 'generate';
    // ONE view holds the main area: a board on screen steps aside.
    const fns = el.context && el.context.functions;
    if (fns && typeof fns.assistantBoardDismiss === 'function') el.call('assistantBoardDismiss');
    if (fns && typeof fns.assistantFlyClose === 'function') el.call('assistantFlyClose');
    const requestId = 'deck_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);
    root.update({
        _aiDeck: {
            v: 1,
            status: 'loading',
            requestId: requestId,
            workspaceId: workspaceId,
            path: onScreen ? onScreen.path : madeOn,
            prompt: text,
            op: op,
            raw: null,
            id: null,
            title: onScreen ? onScreen.title : '',
            summary: '',
            slides: onScreen ? onScreen.slides : [],
            total: 0,
            dropped: 0,
            streamDropped: 0,
            index: 0,
            error: null,
            save: null,
            savedId: null,
            notice: null,
            dismissed: false,
            explicit: false,
            preview: false,
            startedAt: Date.now(),
            receivedAt: null
        }
    }, {
        preventFetch: true
    });
    const isCurrent = ()=>{
        const d = root._aiDeck;
        return !!d && d.requestId === requestId;
    };
    const apply = (frame)=>{
        if (!isCurrent()) return;
        const next = el.call('applyDeckFrame', root._aiDeck, frame, root);
        if (next && isCurrent()) root.update({
            _aiDeck: next
        }, {
            preventFetch: true
        });
    };
    const fail = (reason)=>{
        if (!isCurrent()) return;
        root.update({
            _aiDeck: el.call('assistantDeckFailed', root._aiDeck, reason)
        }, {
            preventFetch: true
        });
    };
    const reasonOf = (err)=>{
        const msg = String(err && (err.code || err.message) || err || '');
        if (/timeout|timed out/i.test(msg)) return 'timeout';
        if (/empty_deck/i.test(msg)) return 'empty';
        if (/^unavailable$|invalid_mode|unknown entity|does not support op|is not available|not found on service|unknown method/i.test(msg)) return 'unavailable';
        return 'failed';
    };
    const sdk = el.sdk || (typeof el.call === 'function' ? el.call('getSDK') : null);
    const timeoutMs = Number(o.timeoutMs) > 0 ? Number(o.timeoutMs) : 45000;
    let timer = null;
    try {
        // SDK-PIN: an SDK that would drop `mode` makes no call (assistantDeckSupport).
        let supported = el.call('assistantDeckSupport', sdk);
        if (supported && typeof supported.then === 'function') supported = await supported;
        if (!supported || !sdk || typeof sdk.execute !== 'function') throw new Error('unavailable');
        let capabilities = el.call('assistantClientCapabilities', sdk);
        if (capabilities && typeof capabilities.then === 'function') capabilities = await capabilities;
        const pending = sdk.execute('ai.boards', op, {
            prompt: text,
            mode: 'presentation',
            ...refine && refine.boardId ? {
                boardId: refine.boardId
            } : {},
            ...refine && !refine.boardId && refine.spec ? {
                spec: refine.spec
            } : {},
            ...o.threadId ? {
                threadId: o.threadId
            } : {},
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {},
            ...o.attached ? {
                attached: o.attached
            } : {},
            ...o.attachments ? {
                attachments: o.attachments
            } : {},
            ...capabilities ? {
                capabilities: capabilities
            } : {},
            onEvent: (frame)=>{
                if (frame && typeof frame === 'object' && frame.event !== 'board.done') apply(frame);
            }
        });
        const res = await Promise.race([
            Promise.resolve(pending),
            new Promise((resolve, reject)=>{
                timer = setTimeout(()=>reject(new Error('timeout')), timeoutMs);
            })
        ]);
        const data = res && typeof res === 'object' ? res.data || res : null;
        apply({
            event: 'board.done',
            data: data && data.spec ? data : {
                spec: data
            }
        });
    } catch (err) {
        fail(reasonOf(err));
    } finally{
        if (timer) clearTimeout(timer);
    }
    const done = root._aiDeck;
    if (!done || done.requestId !== requestId) return null;
    if (done.status === 'ready') el.call('assistantDeckFocus', 'title');
    return done;
};
const $1cb35c931ae90560$export$7373129832330caf = function assistantDeckRetry() {
    const root = this.state && this.state.root;
    const d = root && root._aiDeck;
    if (!d || !d.prompt) return null;
    return this.call('assistantDeckGenerate', d.prompt, {
        fresh: d.op !== 'refine'
    });
};
const $1cb35c931ae90560$export$5f0174da05a2f1f1 = function assistantDeckFocus(target) {
    try {
        const app = typeof this.getRoot === 'function' ? this.getRoot() : null;
        if (target === 'composer') return !!this.call('assistantBoardFocus', 'composer');
        const view = app && typeof app.lookdown === 'function' ? app.lookdown('AssistantDeckView') : null;
        const title = view && typeof view.lookdown === 'function' ? view.lookdown('DeckTitle') : null;
        const node = title && title.node;
        if (node && typeof node.focus === 'function' && node.isConnected !== false) {
            node.focus({
                preventScroll: true
            });
            return true;
        }
    } catch (_) {
    /* no view on this surface */ }
    return false;
};
const $1cb35c931ae90560$export$9d050f2ed5d65c19 = async function saveDeck(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    const deck = root && root._aiDeck;
    if (!root || !deck || deck.preview || deck.status !== 'ready' || !deck.raw) return {
        ok: false,
        reason: 'unavailable'
    };
    if (deck.save === 'saved' && deck.savedId) return {
        ok: true,
        already: true
    };
    const mark = (save, notice, savedId)=>{
        const d = root._aiDeck;
        if (d && d.requestId === deck.requestId) root.update({
            _aiDeck: {
                ...d,
                save: save,
                notice: notice,
                ...savedId ? {
                    savedId: savedId
                } : {}
            }
        }, {
            preventFetch: true
        });
    };
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    mark('saving', null);
    try {
        const sdk = host.sdk || host.call('getSDK');
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const saved = await sdk.execute('ai.boards', 'save', {
            spec: deck.raw,
            title: deck.title || deck.prompt,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const row = saved && typeof saved === 'object' ? saved.data || saved : null;
        if (row && row.id) {
            const list = Array.isArray(root._aiBoards) ? root._aiBoards : [];
            root.update({
                _aiBoards: [
                    {
                        kind: 'deck',
                        ...row
                    },
                    ...list.filter((x)=>x && x.id !== row.id)
                ]
            }, {
                preventFetch: true
            });
        }
        mark('saved', null, row && row.id);
        return {
            ok: true,
            board: row
        };
    } catch (err) {
        mark('failed', 'saveFailed');
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
};
const $1cb35c931ae90560$export$a3a30e33575c236a = function assistantDeckOpenSaved(row) {
    const root = this.state && this.state.root;
    const spec = row && typeof row === 'object' ? row.spec || null : null;
    if (!root || typeof root.update !== 'function' || !spec || !Array.isArray(spec.slides)) return false;
    const fns = this.context && this.context.functions;
    if (fns && typeof fns.assistantBoardDismiss === 'function') this.call('assistantBoardDismiss');
    if (fns && typeof fns.assistantMainThreadClose === 'function') this.call('assistantMainThreadClose');
    const derived = this.call('assistantDeckSlidesFor', spec, root);
    const ws = root.workspace;
    root.update({
        _aiDeck: {
            v: 1,
            status: 'ready',
            requestId: 'saved_' + row.id,
            workspaceId: ws && (ws.id || ws._id) || null,
            path: '/',
            prompt: spec.prompt || '',
            op: 'generate',
            raw: spec,
            id: spec.id || row.id,
            title: row.title || spec.title || '',
            summary: spec.summary || '',
            slides: derived.slides,
            total: derived.total,
            dropped: derived.dropped,
            streamDropped: 0,
            index: 0,
            error: null,
            save: 'saved',
            savedId: row.id,
            notice: null,
            dismissed: false,
            explicit: true,
            preview: false,
            startedAt: null,
            receivedAt: Date.now()
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $1cb35c931ae90560$export$ea60163cdbf8a1ba = function assistantDeckRederive(root) {
    const r = root || this && this.state && this.state.root || null;
    const vm = r && r._aiDeck;
    if (!vm || typeof vm !== 'object' || typeof r.update !== 'function') return false;
    if (vm.status !== 'ready' || vm.preview || !vm.raw) return false;
    const derived = this.call('assistantDeckSlidesFor', vm.raw, r);
    const sig = (slides)=>(Array.isArray(slides) ? slides : []).map((sl)=>sl.key + ':' + (sl.items || []).map((it)=>it.kind + '/' + it.key).join(',')).join('|');
    if (sig(derived.slides) === sig(vm.slides)) return false;
    r.update({
        _aiDeck: {
            ...vm,
            slides: derived.slides,
            total: derived.total,
            dropped: derived.dropped
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $1cb35c931ae90560$export$e26d601f07fcb2ab = function assistantDeckPresent() {
    const root = this.state && this.state.root;
    const vm = root ? this.call('assistantDeckViewModel', root) : null;
    if (!vm || !(vm.slides || []).length) return false;
    this.call('openModal', {
        id: 'assistant-deck-presenter',
        template: 'custom',
        width: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        content: {
            extends: 'AssistantDeckPresenter'
        }
    });
    return true;
};
const $1cb35c931ae90560$export$73f08aa27dd62f3e = function assistantDeckPresentExit() {
    this.call('closeModal', 'assistant-deck-presenter');
    return true;
};
const $1cb35c931ae90560$export$aeb9b542017fcde2 = function assistantDeckPresenterKey(e) {
    const key = e && e.key;
    const moves = {
        ArrowRight: 1,
        ArrowDown: 1,
        PageDown: 1,
        ' ': 1,
        ArrowLeft: -1,
        ArrowUp: -1,
        PageUp: -1
    };
    const root = this.state && this.state.root;
    const vm = root ? this.call('assistantDeckViewModel', root) : null;
    const count = vm && Array.isArray(vm.slides) ? vm.slides.length : 0;
    let moved = false;
    if (moves[key]) moved = this.call('assistantDeckGo', moves[key]);
    else if (key === 'Home') moved = this.call('assistantDeckGo', 0, {
        to: 0
    });
    else if (key === 'End') moved = this.call('assistantDeckGo', 0, {
        to: count - 1
    });
    else return false;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    return moved;
};
const $1cb35c931ae90560$export$fae42c9669f04c9d = function assistantDeckShortcuts(el) {
    const view = el || this;
    if (!view || typeof view.call !== 'function') return ()=>false;
    const over = view.mainHost === 'over';
    view.call('listShortcuts');
    const shown = (h, root)=>{
        const node = view.node;
        if (!node || node.isConnected === false) return false;
        if (root && (root._canvasSlot || root._canvasSlotSecond)) return false;
        return !!view.call('assistantDeckShown', root);
    };
    const row = (id, keys, label, order, run)=>view.call('registerShortcut', {
            id: over ? id + 'Over' : id,
            keys: keys,
            label: over ? null : label,
            group: 'shell.headerTabs.dashboard',
            groupOrder: 3,
            order: order,
            when: shown,
            run: run
        });
    const offs = [
        row('assistantDeckDismiss', 'escape', 'workspace.assistantDeck.shortcutDismiss', 10, ()=>view.call('assistantDeckDismiss', {
                focusComposer: true
            })),
        row('assistantDeckPrevious', 'arrowleft', 'workspace.assistantDeck.shortcutPrevious', 11, ()=>view.call('assistantDeckGo', -1)),
        row('assistantDeckNext', 'arrowright', 'workspace.assistantDeck.shortcutNext', 12, ()=>view.call('assistantDeckGo', 1))
    ];
    const off = ()=>offs.map((fn)=>typeof fn === 'function' && fn()).some(Boolean);
    view.__deckShortcutsOff = off;
    return off;
};

});

parcelRegister("19CFn", function(module, exports) {

$parcel$export(module.exports, "assistantFlySession", () => $0d74a00aebfd4291$export$18b67f630ff75b7a);
$parcel$export(module.exports, "assistantFlyShown", () => $0d74a00aebfd4291$export$f4533999e6f460fb);
$parcel$export(module.exports, "assistantFlyPage", () => $0d74a00aebfd4291$export$67770d3da83ee59c);
$parcel$export(module.exports, "assistantFlyPages", () => $0d74a00aebfd4291$export$48d2f0485df3424b);
$parcel$export(module.exports, "assistantFlyFolded", () => $0d74a00aebfd4291$export$52f01ac714e29b45);
$parcel$export(module.exports, "assistantFlyRows", () => $0d74a00aebfd4291$export$efa1455915b842f0);
$parcel$export(module.exports, "assistantFlyFold", () => $0d74a00aebfd4291$export$893ce6c17f1fdf60);
$parcel$export(module.exports, "assistantFlySectionCount", () => $0d74a00aebfd4291$export$115fd2f7d0c7efb7);
$parcel$export(module.exports, "assistantFlyRowMeta", () => $0d74a00aebfd4291$export$3e31a12e0e28c134);
$parcel$export(module.exports, "assistantFlyErrorReason", () => $0d74a00aebfd4291$export$7a4997eada0b00bc);
$parcel$export(module.exports, "applyFlyFrame", () => $0d74a00aebfd4291$export$a151ddb521b35272);
$parcel$export(module.exports, "assistantFlyCells", () => $0d74a00aebfd4291$export$fc8bcb5cd6f95477);
$parcel$export(module.exports, "assistantFlyGridStyle", () => $0d74a00aebfd4291$export$b8c69dc0e7928653);
$parcel$export(module.exports, "assistantFlyPageStyle", () => $0d74a00aebfd4291$export$33697e2b3252ab33);
$parcel$export(module.exports, "assistantFlyMeasure", () => $0d74a00aebfd4291$export$35781eafbf0896ff);
$parcel$export(module.exports, "assistantFlySyncGrid", () => $0d74a00aebfd4291$export$20d0870b99fe0d17);
$parcel$export(module.exports, "assistantFlyCardStyle", () => $0d74a00aebfd4291$export$126aac7c5c703f25);
$parcel$export(module.exports, "assistantFlyStatusKey", () => $0d74a00aebfd4291$export$b63a6affa8a4a694);
$parcel$export(module.exports, "assistantFlyRailShown", () => $0d74a00aebfd4291$export$9d98b18edf50b463);
$parcel$export(module.exports, "assistantFlyRailHidden", () => $0d74a00aebfd4291$export$7f0afa80353419eb);
$parcel$export(module.exports, "assistantFlyRailToggle", () => $0d74a00aebfd4291$export$5167d7a04468176f);
$parcel$export(module.exports, "assistantFlyRailMarksShown", () => $0d74a00aebfd4291$export$c41a13bd2790e194);
$parcel$export(module.exports, "assistantFlyRailMarks", () => $0d74a00aebfd4291$export$446c7b6a393f6d7c);
$parcel$export(module.exports, "assistantFlyRailLines", () => $0d74a00aebfd4291$export$8bfd7d6c8935f2a);
$parcel$export(module.exports, "assistantFlyRailMeta", () => $0d74a00aebfd4291$export$11217e52cafdb611);
$parcel$export(module.exports, "assistantFlyByline", () => $0d74a00aebfd4291$export$bc21eaca6d468e4b);
$parcel$export(module.exports, "assistantFlyRecordsWrite", () => $0d74a00aebfd4291$export$9b69ff0b309887c);
$parcel$export(module.exports, "assistantFlyRecordsSettle", () => $0d74a00aebfd4291$export$eb857309034b2447);
$parcel$export(module.exports, "assistantFlyGenerate", () => $0d74a00aebfd4291$export$cf68ffdabb0022f1);
$parcel$export(module.exports, "assistantFlyStop", () => $0d74a00aebfd4291$export$a29a41f7096cb828);
$parcel$export(module.exports, "assistantFlyAsk", () => $0d74a00aebfd4291$export$f739d1519789790d);
$parcel$export(module.exports, "assistantFlyPageAct", () => $0d74a00aebfd4291$export$acfd3bf606ea0ce2);
$parcel$export(module.exports, "assistantFlyHandoff", () => $0d74a00aebfd4291$export$6d25666f22fd3b89);
$parcel$export(module.exports, "assistantFlyFormCard", () => $0d74a00aebfd4291$export$c5d4c19abdc9b70e);
$parcel$export(module.exports, "assistantFlyFormStatus", () => $0d74a00aebfd4291$export$d58917760e97d065);
$parcel$export(module.exports, "assistantFlyFormOpen", () => $0d74a00aebfd4291$export$3870ae2c233cad98);
$parcel$export(module.exports, "assistantFlyFormNote", () => $0d74a00aebfd4291$export$4260758df2c4316a);
$parcel$export(module.exports, "assistantFlyCardVerb", () => $0d74a00aebfd4291$export$94f54f763153fbf2);
$parcel$export(module.exports, "assistantFlyCardActionLabel", () => $0d74a00aebfd4291$export$ebeeadec93f764ef);
$parcel$export(module.exports, "assistantFlyCardAct", () => $0d74a00aebfd4291$export$a7f86d15d6758e38);
$parcel$export(module.exports, "assistantFlyCardCloses", () => $0d74a00aebfd4291$export$b8790edf91ac4661);
$parcel$export(module.exports, "assistantFlyCardCloseLabel", () => $0d74a00aebfd4291$export$3cf7fba3f7079d6b);
$parcel$export(module.exports, "assistantFlyCardClose", () => $0d74a00aebfd4291$export$a2b9d305dc4537fc);
$parcel$export(module.exports, "assistantFlyDrill", () => $0d74a00aebfd4291$export$d8936690206e860);
$parcel$export(module.exports, "assistantFlyDrillClose", () => $0d74a00aebfd4291$export$86f6ac368a5b8ae6);
$parcel$export(module.exports, "assistantFlyFocus", () => $0d74a00aebfd4291$export$56d444834d820a79);
$parcel$export(module.exports, "assistantFlyClose", () => $0d74a00aebfd4291$export$61fd462016db12f8);
$parcel$export(module.exports, "assistantFlyNew", () => $0d74a00aebfd4291$export$c645060276b1049);
$parcel$export(module.exports, "assistantFlyLink", () => $0d74a00aebfd4291$export$3f29c6d161cf43a);
$parcel$export(module.exports, "assistantFlyShare", () => $0d74a00aebfd4291$export$64cb8c7d9a5b04e9);
$parcel$export(module.exports, "assistantFlySavable", () => $0d74a00aebfd4291$export$1b1efe1723c9e4a4);
$parcel$export(module.exports, "assistantFlySave", () => $0d74a00aebfd4291$export$9095528eaabdb64e);
$parcel$export(module.exports, "assistantFlyPersist", () => $0d74a00aebfd4291$export$99fa93926ec9bd6b);
$parcel$export(module.exports, "assistantFlyRestore", () => $0d74a00aebfd4291$export$ee20165432fc334);
$parcel$export(module.exports, "assistantFlyUrlOpen", () => $0d74a00aebfd4291$export$5036ecbef20543fa);
$parcel$export(module.exports, "assistantFlyMounted", () => $0d74a00aebfd4291$export$8de8de5b83d5912);
$parcel$export(module.exports, "assistantFlyShortcuts", () => $0d74a00aebfd4291$export$899fe41303e7e61b);
$parcel$export(module.exports, "assistantFlyReveal", () => $0d74a00aebfd4291$export$bd86b59ef84dbf3f);
// assistantFly.js — FLY MODE, the assistant's sixth mode (docs/FLY_MODE.md).
// Nika 2026-10-17: "add fly mode to workspace where it runs just like fly
// keepz … replicate full fly functionality and ux also speed", "its for
// general workspace for all workspaces", "make that flow easy, beautiful,
// clean, simple".
//
// Every ask composes a PAGE, the way a Fly site does (keepz--fly): an eyebrow
// (scope · window), a title, an OPENING whose every number comes from the
// page's own data, the sections (this workspace's own widgets, records blocks
// and word blocks — the ai.boards vocabulary), the follow-up asks. The pages
// of one SESSION stand on one canvas in the main area: the newest open, the
// older ones folded to their head row; a follow-up builds on the page before.
//
// THE BRAIN is the server's fly page engine — ai.boards generate with
// `mode: 'fly'` (server AiBoardService.runFly): one fast call streams the
// head, then each section; a records section's DATA rides the same stream
// (`fly.data` → the records cache, so its card asks nothing); a short second
// call streams the opening (`fly.text`). A server without the fly shape
// answers `invalid_mode`: the page is then built from a DASHBOARD board (its
// summary is the opening, its refine asks the follow-ups) — fly mode works on
// every server.
//
// THE SESSION is an assistant thread: the first page asks with
// `threadId: 'new'` (the server makes the thread with that page), the next
// ones with its id — the thread holds every ask and page (the sidebar shows
// it; the server reads it as context). A page asked from a CALL is ephemeral
// (`opts.ephemeral`): no thread.
//
// STATE — `root._aiFly` (workspace-scoped, declared in state-app.js):
//   { v: 1, workspaceId, threadId, open, path, focus, fold, pages: [page] }
//   `fold`: the open page folded too — every page of the thread is its row
//   (assistantFlyFold; a row or a new ask opens one again). Not persisted.
//   page = { key, id, status: 'loading'|'streaming'|'ready'|'failed', phase:
//     'compose'|'data'|'write'|'done', error, prompt, eyebrow, title, opening,
//     items, followUps, fallback, at, ms }
//
// FRANK: every export is SELF-CONTAINED — no import, no module-scope constant,
// no bare call to a sibling export (frank revives each export on its own); a
// sibling is reached through `this.call('name', …)`. These run as
// `el.call('name', …)`, so `this` is an element.
// The session of the workspace on screen, or null.
const $0d74a00aebfd4291$export$18b67f630ff75b7a = function assistantFlySession(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fly = r._aiFly;
    const ws = r.workspace;
    const live = ws && (ws.id || ws._id) || null;
    if (!fly || typeof fly !== 'object') return null;
    if (fly.workspaceId && live && String(fly.workspaceId) !== String(live)) return null;
    return fly;
};
const $0d74a00aebfd4291$export$f4533999e6f460fb = function assistantFlyShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const path = r.currentPath;
    const fly = this.call('assistantFlySession', r);
    // ONE view holds the main area: an open main thread wins, as it does over a
    // board and a deck (a `?ai=` link over an open canvas drew the same answers
    // twice — Nika 2026-10-18, "it duplicates ui").
    const fns = this.context && this.context.functions;
    const thread = fns && typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    // Only where the person can ask (functions/assistantFlyWorkspace.js
    // assistantFlyAvailable): Fly is the home's default view, and a workspace
    // that turned its assistant off keeps its dashboard whatever a session or a
    // link left open.
    const available = fns && typeof fns.assistantFlyAvailable === 'function' ? !!this.call('assistantFlyAvailable', r) : true;
    if (!fly || fly.open !== true || thread || !available) return false;
    const norm = (p)=>{
        const raw = typeof p === 'string' && p ? p : '/';
        const s = typeof this.call === 'function' ? this.call('stripWorkspacePrefix', raw) : raw;
        const v = typeof s === 'string' ? s : raw;
        return v === '' ? '/' : v.length > 1 ? v.replace(/\/+$/, '') : v;
    };
    return norm(fly.path) === norm(path);
};
const $0d74a00aebfd4291$export$67770d3da83ee59c = function assistantFlyPage(root, key) {
    const fly = this.call('assistantFlySession', root);
    const pages = (fly && Array.isArray(fly.pages) ? fly.pages : []).filter(Boolean);
    const want = key || fly && fly.focus;
    return pages.find((p)=>p.key === want) || pages[pages.length - 1] || null;
};
const $0d74a00aebfd4291$export$48d2f0485df3424b = function assistantFlyPages(root) {
    const fly = this.call('assistantFlySession', root);
    const pages = (fly && Array.isArray(fly.pages) ? fly.pages : []).filter(Boolean);
    const focus = fly && fly.focus;
    const folded = !!this.call('assistantFlyFolded', root);
    return pages.map((p, i)=>({
            ...p,
            index: i,
            count: pages.length,
            open: !folded && p.key === focus || p.status === 'loading' || p.status === 'streaming'
        }));
};
const $0d74a00aebfd4291$export$52f01ac714e29b45 = function assistantFlyFolded(root) {
    const fly = this.call('assistantFlySession', root);
    if (!fly || fly.fold !== true) return false;
    const pages = Array.isArray(fly.pages) ? fly.pages : [];
    return !pages.some((p)=>p && (p.status === 'loading' || p.status === 'streaming'));
};
const $0d74a00aebfd4291$export$efa1455915b842f0 = function assistantFlyRows(root, side) {
    const pages = this.call('assistantFlyPages', root) || [];
    if (this.call('assistantFlyFolded', root)) return side === 'after' ? [] : pages;
    let at = pages.findIndex((p)=>p.open);
    if (at < 0) {
        const cur = this.call('assistantFlyPage', root);
        at = cur ? pages.findIndex((p)=>p.key === cur.key) : -1;
    }
    if (at < 0) return [];
    return side === 'after' ? pages.filter((p, i)=>i > at && !p.open) : pages.filter((p, i)=>i < at && !p.open);
};
const $0d74a00aebfd4291$export$893ce6c17f1fdf60 = function assistantFlyFold() {
    const root = this.state && this.state.root;
    const fly = this.call('assistantFlySession', root);
    if (!fly || fly.fold === true || !(fly.pages || []).length) return false;
    root.update({
        _aiFly: {
            ...fly,
            fold: true
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $0d74a00aebfd4291$export$115fd2f7d0c7efb7 = function assistantFlySectionCount(page, root) {
    const items = (page && Array.isArray(page.items) ? page.items : []).filter(Boolean);
    if (!items.length) return 0;
    const res = this.call('validateBoardSpec', {
        items: items
    }, this.call('boardVocabularyFor', root));
    return res && Array.isArray(res.items) ? res.items.length : 0;
};
const $0d74a00aebfd4291$export$3e31a12e0e28c134 = function assistantFlyRowMeta(page) {
    const p = page && typeof page.parse === 'function' ? page.parse() : page;
    if (!p || typeof p !== 'object') return '';
    const parts = [];
    if (p.status === 'ready' && p.at) parts.push(String(this.call('localizedDate', new Date(p.at), {
        hour: 'numeric',
        minute: '2-digit'
    }) || ''));
    const n = p.status === 'ready' ? this.call('assistantFlySectionCount', p, this.state && this.state.root) : 0;
    if (n > 0) parts.push(String(this.call('polyglot', n === 1 ? 'workspace.assistantFly.sectionCountOne' : 'workspace.assistantFly.sectionCount')).replace('{n}', String(n)));
    return parts.filter(Boolean).join(" \xb7 ");
};
const $0d74a00aebfd4291$export$7a4997eada0b00bc = function assistantFlyErrorReason(code) {
    const c = String(code || '');
    if (/timeout|timed out/i.test(c)) return 'timeout';
    if (/empty_page|empty_board|no_items/i.test(c)) return 'empty';
    if (/credits|ai_cap/i.test(c)) return 'credits';
    if (/model_invalid_output|ai_failed|invalid_block|invalid_spec/i.test(c)) return 'model';
    if (/ai_unavailable/i.test(c)) return 'busy';
    if (/unauthorized|forbidden/i.test(c)) return 'access';
    if (/^aborted$/i.test(c)) return 'stopped';
    return 'failed';
};
const $0d74a00aebfd4291$export$a151ddb521b35272 = function applyFlyFrame(page, frame) {
    if (!page || !frame || typeof frame !== 'object') return page;
    const event = String(frame.event || '');
    const d = frame.data && typeof frame.data === 'object' ? frame.data : {};
    const line = (v)=>String(typeof v === 'string' ? v : '').replace(/\s+/g, ' ').trim();
    const status = page.status === 'loading' ? 'streaming' : page.status;
    // A next ask { label, prompt } — or the quick tour { label, action: 'tour' }
    // the server offers a shell that runs it (functions/assistantFlyFollow.js).
    const follow = (list)=>(Array.isArray(list) ? list : []).filter((f)=>f && f.label && (f.prompt || f.action === 'tour')).slice(0, 4);
    if (event === 'board.error') {
        const error = this.call('assistantFlyErrorReason', d.code);
        return {
            ...page,
            status: 'failed',
            phase: 'done',
            error: error
        };
    }
    if (event === 'board.start') return {
        ...page,
        status: status,
        id: d.id || page.id
    };
    if (event === 'board.head') return {
        ...page,
        status: status,
        eyebrow: line(d.eyebrow) || page.eyebrow || '',
        title: line(d.title) || page.title || '',
        // A board (the fallback) has a summary: it is the page's opening.
        opening: page.opening || (page.fallback ? line(d.summary) : '')
    };
    if (event === 'board.item') {
        const item = d.item && typeof d.item === 'object' ? d.item : null;
        if (!item) return page;
        const items = Array.isArray(page.items) ? page.items.slice() : [];
        const at = Number.isInteger(d.index) && d.index >= 0 ? d.index : items.length;
        items[at] = item;
        return {
            ...page,
            status: status,
            items: Array.from(items, (x)=>x || null)
        };
    }
    if (event === 'board.drop') return {
        ...page,
        status: status,
        dropped: (Number(page.dropped) || 0) + 1
    };
    if (event === 'fly.data') return {
        ...page,
        status: status,
        phase: page.phase === 'write' ? 'write' : 'data'
    };
    // THE READS (Fly train 2, server ai-boards flyReads.js): the page model's
    // plan right after its head, then each read as it settles. A UI section
    // says what it is reading until its read lands (functions/assistantFlyUi.js
    // assistantFlyUiNote), then what came back (`fly.ui`). The phase stays —
    // the sections are still streaming while the reads run.
    if (event === 'fly.plan') {
        const list = Array.isArray(d.reads) ? d.reads : [];
        const reads = list.filter((r)=>r && typeof r.id === 'string' && r.id).slice(0, 8).map((r)=>({
                id: r.id,
                tool: typeof r.tool === 'string' ? r.tool : '',
                state: 'reading'
            }));
        return {
            ...page,
            status: status,
            reads: reads
        };
    }
    if (event === 'fly.read') {
        const readId = typeof d.readId === 'string' ? d.readId : '';
        if (!readId) return page;
        const reads = Array.isArray(page.reads) ? page.reads.slice() : [];
        const at = reads.findIndex((r)=>r && r.id === readId);
        const was = at >= 0 ? reads[at] : null;
        const next = {
            id: readId,
            tool: typeof d.tool === 'string' && d.tool ? d.tool : was && was.tool || '',
            state: d.ok ? 'ok' : 'failed',
            ...d.ok ? {} : {
                code: String(d.code || 'read_failed')
            }
        };
        if (at >= 0) reads[at] = next;
        else reads.push(next);
        return {
            ...page,
            status: status,
            reads: reads
        };
    }
    if (event === 'fly.ui') {
        const itemId = typeof d.itemId === 'string' ? d.itemId : '';
        const items = Array.isArray(page.items) ? page.items : [];
        const at = itemId ? items.findIndex((it)=>it && it.id === itemId) : -1;
        const ui = d.ui && typeof d.ui === 'object' && (d.ui.tool === 'render_cards' || d.ui.tool === 'render_answer_ui') && d.ui.args && typeof d.ui.args === 'object' ? {
            tool: d.ui.tool,
            args: d.ui.args
        } : null;
        const shown = ui ? {
            ui: ui
        } : d.empty === true ? {
            empty: true
        } : d.error && typeof d.error === 'object' ? {
            error: {
                code: String(d.error.code || 'read_failed'),
                status: Number(d.error.status) || null
            }
        } : null;
        // A result for a section this page never saw (a cut answer's) waits for
        // board.done, which carries every section with what it shows.
        if (at < 0 || !shown) return page;
        const next = items.slice();
        const base = {
            ...items[at]
        };
        delete base.ui;
        delete base.empty;
        delete base.error;
        next[at] = {
            ...base,
            ...shown
        };
        return {
            ...page,
            status: status,
            items: next
        };
    }
    if (event === 'fly.follow') return {
        ...page,
        status: status,
        followUps: follow(d.followUps)
    };
    if (event === 'fly.text') {
        const delta = typeof d.delta === 'string' ? d.delta : '';
        if (!delta) return page;
        const opening = page.opening ? page.opening + (/^\s/.test(delta) ? '' : ' ') + delta : delta;
        return {
            ...page,
            status: status,
            phase: 'write',
            opening: opening.replace(/\s+/g, ' ').trim()
        };
    }
    if (event === 'board.done') {
        const spec = d.spec && typeof d.spec === 'object' ? d.spec : null;
        if (!spec) return {
            ...page,
            status: 'failed',
            phase: 'done',
            error: 'failed'
        };
        const fly = spec.kind === 'fly';
        const items = Array.isArray(spec.items) ? spec.items.slice() : page.items || [];
        const followUps = fly ? Array.isArray(spec.followUps) ? spec.followUps : [] : Array.isArray(spec.refine) ? spec.refine : [];
        const opening = fly ? line(spec.opening) || line(spec.lead) : line(spec.summary);
        if (!items.length && !opening) return {
            ...page,
            status: 'failed',
            phase: 'done',
            error: 'empty'
        };
        // What the page read and how each read went (`spec.reads` — never the
        // rows); the plan the stream sent when the done has none.
        const reads = Array.isArray(spec.reads) ? spec.reads.filter((r)=>r && typeof r.id === 'string' && r.id).slice(0, 8).map((r)=>({
                id: r.id,
                tool: typeof r.tool === 'string' ? r.tool : '',
                state: r.ok ? 'ok' : 'failed',
                ...r.ok ? {} : {
                    code: String(r.code || 'read_failed')
                }
            })) : Array.isArray(page.reads) ? page.reads : [];
        return {
            ...page,
            status: 'ready',
            phase: 'done',
            error: null,
            id: spec.id || page.id,
            reads: reads,
            eyebrow: fly ? line(spec.eyebrow) || page.eyebrow || '' : page.eyebrow || '',
            title: line(spec.title) || page.title || page.prompt,
            opening: opening || page.opening || '',
            items: items,
            followUps: follow(followUps),
            // A CHANGE the ask asks for (create, send, schedule …): the page shows
            // what it touches; the assistant's Tools do it (assistantFlyHandoff).
            action: fly ? line(spec.action) : '',
            // …and the app's OWN FORM that makes that change, when the page names
            // one (server ai-boards normalizeFlyForm: `{ form: '<app>.<id>', app,
            // values }`): the page opens it, prefilled, through the answer's form
            // path (assistantFlyFormOpen → assistantFormOpen) — no assistant turn.
            form: fly && spec.form && typeof spec.form === 'object' && typeof spec.form.form === 'string' && spec.form.form.trim() ? {
                form: spec.form.form.trim(),
                app: typeof spec.form.app === 'string' ? spec.form.app : '',
                values: spec.form.values && typeof spec.form.values === 'object' && !Array.isArray(spec.form.values) ? {
                    ...spec.form.values
                } : {}
            } : null,
            fallback: !fly || !!page.fallback,
            ms: Number(d.ms) || (page.at ? Date.now() - page.at : null),
            model: d.model || null
        };
    }
    return page;
};
const $0d74a00aebfd4291$export$fc8bcb5cd6f95477 = function assistantFlyCells(page, root, cols) {
    if (!page) return [];
    const n = Math.max(1, Math.floor(Number(cols)) || 1);
    const items = (Array.isArray(page.items) ? page.items : []).filter(Boolean);
    let rows = [];
    if (items.length) {
        const derived = this.call('boardItemsFor', {
            v: 1,
            id: page.id || null,
            prompt: page.prompt || '',
            title: page.title || page.prompt || '',
            summary: '',
            items: items,
            refine: [],
            sources: []
        }, root);
        // Each cell's key carries its page: a new page's sections are NEW cards
        // (they enter, their bodies mount), never an earlier page's reused.
        // A UI section also carries how its read stands (`readState`: reading ·
        // ok · failed, the page's `reads`) and whether the page is done
        // (`settled`) — what it says until its result is in
        // (functions/assistantFlyUi.js).
        const reads = Array.isArray(page.reads) ? page.reads : [];
        const settled = page.status === 'ready' || page.status === 'failed';
        // A records section's bars drill into THIS page once it is done — the
        // person's own page; a call's is the call's (assistantFlyDrill).
        const drillsInto = page.status === 'ready' && page.source !== 'call' ? page.key : null;
        rows = (derived && derived.items || []).map((it)=>{
            const read = it.kind === 'ui' ? reads.find((r)=>r && r.id === it.read) : null;
            return {
                ...it,
                key: page.key + '-' + it.key,
                cols: n,
                rev: 0,
                page: page.key,
                onLayer: !!page.onLayer,
                ...it.kind === 'ui' ? {
                    readState: read ? read.state : null,
                    settled: settled
                } : {},
                ...it.kind === 'records' ? {
                    drillsInto: drillsInto
                } : {}
            };
        });
    }
    const composing = (page.status === 'loading' || page.status === 'streaming') && (page.phase || 'compose') === 'compose';
    if (!composing) return rows;
    const SIZES = [
        'xl',
        'm',
        'm'
    ];
    const want = Math.max(rows.length + 1, 3);
    const cells = rows.slice();
    for(let i = rows.length; i < want; i++)cells.push({
        key: page.key + '-sk' + i,
        kind: 'skeleton',
        index: i,
        size: SIZES[i] || 'm',
        cols: n,
        rev: 0,
        onLayer: !!page.onLayer
    });
    return cells;
};
const $0d74a00aebfd4291$export$b8c69dc0e7928653 = function assistantFlyGridStyle(s) {
    const m = this.call('assistantBoardMetrics', s);
    return this.call('assistantBoardGridStyle', {
        cols: m.cols,
        gutter: m.gutter,
        cell: m.cell,
        square: true
    });
};
const $0d74a00aebfd4291$export$33697e2b3252ab33 = function assistantFlyPageStyle(s) {
    const m = this.call('assistantBoardMetrics', s);
    const cols = Number(m && m.cols) || 0;
    const cell = Number(m && m.cell) || 0;
    const gutter = Number(m && m.gutter) || 0;
    if (!(cols > 0 && cell > 0)) return {};
    const width = {
        maxWidth: cols * cell + (cols - 1) * gutter + 'px'
    };
    return s && s.start === true ? {
        ...width,
        marginLeft: '0px'
    } : width;
};
const $0d74a00aebfd4291$export$35781eafbf0896ff = function assistantFlyMeasure(el) {
    const host = el || this;
    const node = host && host.node;
    if (!node || typeof node.getBoundingClientRect !== 'function') return null;
    const box = node.getBoundingClientRect();
    if (!(box.width > 0)) return null;
    const board = typeof node.closest === 'function' ? node.closest('[data-home-board]') : null;
    const outer = board && typeof board.getBoundingClientRect === 'function' ? board : null;
    const full = this.call('homeGridMetrics', outer ? outer.getBoundingClientRect().width : box.width);
    if (!full || !(full.cell > 0)) return null;
    const railEl = host.AssistantFlyRail && host.AssistantFlyRail.node;
    const rail = railEl && typeof railEl.getBoundingClientRect === 'function' ? railEl.getBoundingClientRect() : null;
    if (!rail || !(rail.width > 0) || rail.left >= box.right) return {
        ...full,
        start: false
    };
    const gap = full.gutter;
    const avail = Math.min(box.width, rail.left - gap - box.left);
    if (!(avail > 0)) return {
        ...full,
        start: false
    };
    const cap = this.call('homeGridMetrics', Number.MAX_SAFE_INTEGER).cell;
    const cols = Math.max(1, Math.round((avail + gap) / (full.cell + gap)));
    const cell = Math.max(1, Math.min(cap, Math.floor((avail - (cols - 1) * gap) / cols)));
    return {
        cols: cols,
        gutter: gap,
        cell: cell,
        width: cols * cell + (cols - 1) * gap,
        square: full.square,
        start: true
    };
};
const $0d74a00aebfd4291$export$20d0870b99fe0d17 = function assistantFlySyncGrid(el, s) {
    const host = el || this;
    const m = this.call('assistantFlyMeasure', host);
    if (!m || !(m.cell > 0) || !s || typeof s.update !== 'function') return false;
    const square = m.square !== false;
    const start = m.start === true;
    if (s.cols === m.cols && s.cell === m.cell && s.gutter === m.gutter && s.square === square && s.start === start) return false;
    s.update({
        cols: m.cols,
        gutter: m.gutter,
        cell: m.cell,
        square: square,
        start: start
    });
    return true;
};
const $0d74a00aebfd4291$export$126aac7c5c703f25 = function assistantFlyCardStyle(el, s) {
    const card = el || this;
    const ds = card && card.context ? card.context.designSystem : null;
    const style = this.call('assistantBoardCardStyle', s, ds);
    const empty = this.call('assistantBoardCardEmpty', card, s);
    if (card && (empty === true || empty === false)) card.__flyEmpty = empty;
    return card && card.__flyEmpty === true ? {
        ...style,
        gridRow: 'span 1'
    } : style;
};
const $0d74a00aebfd4291$export$b63a6affa8a4a694 = function assistantFlyStatusKey(page) {
    if (!page) return '';
    if (page.status === 'failed') {
        const e = page.error;
        return e === 'timeout' ? 'workspace.assistantFly.failedTimeout' : e === 'unavailable' ? 'workspace.assistantFly.unavailable' : e === 'empty' ? 'workspace.assistantFly.failedEmpty' : e === 'credits' ? 'workspace.assistantFly.failedCredits' : e === 'stopped' ? 'workspace.assistantFly.stopped' : e === 'model' ? 'workspace.assistantFly.failedModel' : e === 'busy' ? 'workspace.assistantFly.failedBusy' : e === 'access' ? 'workspace.assistantFly.failedAccess' : 'workspace.assistantFly.failed';
    }
    if (page.status !== 'loading' && page.status !== 'streaming') return '';
    const phase = page.phase || 'compose';
    return phase === 'write' ? 'workspace.assistantFly.statusWrite' : phase === 'data' ? 'workspace.assistantFly.statusData' : 'workspace.assistantFly.statusCompose';
};
const $0d74a00aebfd4291$export$9d98b18edf50b463 = function assistantFlyRailShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const slot = !!(r._canvasSlot || r._canvasSlotSecond);
    const shown = !!this.call('assistantFlyShown', r);
    const hidden = !!this.call('assistantFlyRailHidden', r);
    const fly = this.call('assistantFlySession', r);
    const pages = fly && Array.isArray(fly.pages) ? fly.pages.filter(Boolean) : [];
    return shown && !slot && pages.length > 0 && !hidden;
};
const $0d74a00aebfd4291$export$7f0afa80353419eb = function assistantFlyRailHidden(root) {
    const r = root && typeof root === 'object' ? root : {};
    const set = r._aiFlyRailHidden;
    if (set === true || set === false) return set;
    try {
        return typeof localStorage !== 'undefined' ? localStorage.getItem('symbols_fly_rail_hidden') === '1' : false;
    } catch (_) {
        return false;
    }
};
const $0d74a00aebfd4291$export$5167d7a04468176f = function assistantFlyRailToggle(hidden) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return null;
    const next = hidden === true || hidden === false ? hidden : !this.call('assistantFlyRailHidden', root);
    root.update({
        _aiFlyRailHidden: next
    }, {
        preventFetch: true
    });
    try {
        if (typeof localStorage !== 'undefined') localStorage.setItem('symbols_fly_rail_hidden', next ? '1' : '0');
    } catch (_) {
    /* the choice still holds for this page */ }
    return next;
};
const $0d74a00aebfd4291$export$c41a13bd2790e194 = function assistantFlyRailMarksShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const slot = !!(r._canvasSlot || r._canvasSlotSecond);
    const shown = !!this.call('assistantFlyShown', r);
    const hidden = !!this.call('assistantFlyRailHidden', r);
    const fly = this.call('assistantFlySession', r);
    const pages = fly && Array.isArray(fly.pages) ? fly.pages.filter(Boolean) : [];
    return shown && !slot && pages.length > 0 && hidden;
};
const $0d74a00aebfd4291$export$446c7b6a393f6d7c = function assistantFlyRailMarks(root) {
    const fly = this.call('assistantFlySession', root);
    const pages = (fly && Array.isArray(fly.pages) ? fly.pages : []).filter(Boolean);
    const focus = fly && fly.focus || (pages.length ? pages[pages.length - 1].key : null);
    return pages.map((p)=>({
            key: 'mark' + String(p.key || '').replace(/[^A-Za-z0-9]+/g, ''),
            pageKey: p.key || '',
            title: String(p.title || p.prompt || ''),
            open: p.key === focus,
            busy: p.status === 'loading' || p.status === 'streaming',
            failed: p.status === 'failed'
        }));
};
const $0d74a00aebfd4291$export$8bfd7d6c8935f2a = function assistantFlyRailLines(root) {
    const fly = this.call('assistantFlySession', root);
    const pages = (fly && Array.isArray(fly.pages) ? fly.pages : []).filter(Boolean);
    const open = pages.find((p)=>p.key === (fly && fly.focus)) || pages[pages.length - 1] || null;
    const line = (over)=>({
            kind: 'message',
            role: 'user',
            text: '',
            streaming: false,
            ts: null,
            id: null,
            agentName: null,
            toolName: null,
            tools: [],
            cards: [],
            suggestions: [],
            sources: [],
            picked: null,
            metadata: null,
            level: null,
            confidence: null,
            usage: null,
            label: null,
            prompt: null,
            factor: null,
            _grouped: false,
            _last: false,
            _tick: 0,
            pageKey: null,
            open: false,
            failed: false,
            sections: 0,
            took: '',
            ...over
        });
    const out = [];
    for (const p of pages){
        const busy = p.status === 'loading' || p.status === 'streaming';
        const failed = p.status === 'failed';
        const said = failed ? String(this.call('polyglot', this.call('assistantFlyStatusKey', p)) || '') : String(p.opening || '');
        const ms = Number(p.ms);
        // The ask — with the parts of the screen it was about, echoed under it the
        // way a chat turn's sent line is (ChatMessage `picked`). A page assembled
        // with Add section was never asked: no ask line (it drew an empty bubble).
        if (p.prompt) out.push(line({
            key: 'q-' + p.key,
            id: 'q-' + p.key,
            text: p.prompt,
            ts: p.at || null,
            picked: Array.isArray(p.picked) && p.picked.length ? p.picked : null
        }));
        out.push(line({
            key: 'a-' + p.key,
            id: 'a-' + p.key,
            role: 'assistant',
            text: said,
            streaming: busy,
            ts: p.at || null,
            agentName: p.agentName || null,
            pageKey: p.key
        }));
        out.push(line({
            key: 'f-' + p.key,
            kind: 'foot',
            role: 'foot',
            pageKey: p.key,
            open: !!open && open.key === p.key,
            failed: failed,
            sections: busy || failed ? 0 : this.call('assistantFlySectionCount', p, root),
            took: !busy && ms > 0 ? (ms / 1000).toFixed(1) : ''
        }));
    }
    return out;
};
const $0d74a00aebfd4291$export$11217e52cafdb611 = function assistantFlyRailMeta(line) {
    if (!line) return '';
    const parts = [];
    const n = Number(line.sections) || 0;
    if (n > 0) parts.push(String(this.call('polyglot', n === 1 ? 'workspace.assistantFly.sectionCountOne' : 'workspace.assistantFly.sectionCount')).replace('{n}', String(n)));
    if (line.took) parts.push(String(this.call('polyglot', 'workspace.assistantFly.took')).replace('{s}', line.took));
    return parts.join(" \xb7 ");
};
const $0d74a00aebfd4291$export$bc21eaca6d468e4b = function assistantFlyByline(page) {
    if (!page) return '';
    // A page the person assembled with Add section (functions/
    // assistantFlyWorkspace.js, key `fwl-…`) was never composed by the AI: its
    // line says what it holds instead.
    const manual = typeof page.key === 'string' && /^fwl-/.test(page.key);
    const n = manual ? this.call('assistantFlySectionCount', page, this.state && this.state.root) : 0;
    const by = manual ? String(this.call('polyglot', n === 1 ? 'workspace.assistantFly.sectionCountOne' : 'workspace.assistantFly.sectionCount')).replace('{n}', String(n)) : page.agentName ? String(this.call('polyglot', 'workspace.assistantFly.composedByAgent')).replace('{name}', page.agentName) : String(this.call('polyglot', 'workspace.assistantFly.composedBy'));
    // A call's page another participant asked: who asked it.
    const asked = page.askedBy ? " \xb7 " + String(this.call('polyglot', 'workspace.assistantFly.askedBy')).replace('{name}', page.askedBy) : '';
    const at = Number(page.at) || 0;
    const ago = at ? Math.max(0, Date.now() - at) : 0;
    const when = ago < 60000 ? this.call('polyglot', 'workspace.assistantFly.justNow') : ago < 3600000 ? String(this.call('polyglot', 'workspace.assistantFly.minutesAgo')).replace('{n}', String(Math.round(ago / 60000))) : this.call('localizedDate', new Date(at), {
        hour: 'numeric',
        minute: '2-digit'
    });
    return by + asked + " \xb7 " + when;
};
const $0d74a00aebfd4291$export$9b69ff0b309887c = function assistantFlyRecordsWrite(root, item, entry) {
    if (!root || typeof root.update !== 'function' || !item) return false;
    const block = this.call('recordsBlockNormalize', item);
    if (!block) return false;
    const ws = root.workspace;
    const wsId = ws && (ws.id || ws._id) ? String(ws.id || ws._id) : '';
    const key = wsId + ':' + this.call('boardSpecHash', block);
    let lang = '';
    try {
        lang = String(this.call('getActiveLang') || '');
    } catch (_) {
        lang = '';
    }
    const bag = root._aiRecords && typeof root._aiRecords === 'object' ? root._aiRecords : {};
    const have = bag[key];
    let next;
    if (entry === 'mark') {
        // Never over an answer the cache already holds (the same block on an
        // earlier page): the card shows it at once.
        if (have && have.status !== 'failed') return false;
        next = {
            status: 'loading',
            fly: true,
            at: Date.now(),
            ...lang ? {
                lang: lang
            } : {}
        };
    } else if (entry && entry.entry && typeof entry.entry === 'object') {
        const status = [
            'ready',
            'empty'
        ].includes(entry.entry.status) ? entry.entry.status : 'failed';
        next = {
            status: status,
            answer: entry.entry.answer || null,
            at: Date.now(),
            shared: true,
            ...lang ? {
                lang: lang
            } : {}
        };
    } else if (entry && entry.answer) next = {
        ...this.call('assistantRecordsAnswer', entry.answer, block),
        at: Date.now(),
        ...lang ? {
            lang: lang
        } : {}
    };
    else {
        // The server refused the read: the card says so and offers Try again.
        if (have && have.status !== 'loading') return false;
        next = {
            status: 'failed',
            at: Date.now(),
            ...lang ? {
                lang: lang
            } : {}
        };
    }
    const keys = Object.keys(bag).filter((k)=>k !== key);
    const kept = {};
    for (const k of keys.slice(-39))kept[k] = bag[k];
    kept[key] = next;
    root.update({
        _aiRecords: kept
    }, {
        preventFetch: true
    });
    return true;
};
const $0d74a00aebfd4291$export$eb857309034b2447 = function assistantFlyRecordsSettle(root, items) {
    if (!root || typeof root.update !== 'function') return 0;
    const ws = root.workspace;
    const wsId = ws && (ws.id || ws._id) ? String(ws.id || ws._id) : '';
    let lang = '';
    try {
        lang = String(this.call('getActiveLang') || '');
    } catch (_) {
        lang = '';
    }
    let n = 0;
    for (const item of Array.isArray(items) ? items : []){
        if (!item || item.kind !== 'records') continue;
        const block = this.call('recordsBlockNormalize', item);
        if (!block) continue;
        const key = wsId + ':' + this.call('boardSpecHash', block);
        const have = root._aiRecords && root._aiRecords[key];
        if (!have || have.status !== 'loading' || !have.fly) continue;
        n += 1;
        const land = (entry)=>{
            const cur = root._aiRecords && root._aiRecords[key];
            if (!cur || cur.status !== 'loading' || !cur.fly) return;
            root.update({
                _aiRecords: {
                    ...root._aiRecords,
                    [key]: {
                        ...entry,
                        at: Date.now(),
                        ...lang ? {
                            lang: lang
                        } : {}
                    }
                }
            }, {
                preventFetch: true
            });
        };
        Promise.resolve().then(()=>this.call('assistantRecordsFetch', block, wsId || null, lang || null)).then((entry)=>land(entry && entry.status ? entry : {
                status: 'failed'
            }), ()=>land({
                status: 'failed'
            }));
    }
    return n;
};
const $0d74a00aebfd4291$export$cf68ffdabb0022f1 = async function assistantFlyGenerate(prompt, opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    const input = prompt && typeof prompt === 'object' ? prompt : {
        prompt: prompt
    };
    const text = String(input.prompt == null ? '' : input.prompt).replace(/\s+/g, ' ').trim();
    if (!root || typeof root.update !== 'function' || !text) return null;
    const o = {
        ...opts || {}
    };
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    const fns = el.context && el.context.functions;
    const madeOn = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    const key = 'fp' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    // The first ask after a load on a route whose canvas has not mounted yet
    // (the page layer mounts with its first page): the stored session comes
    // back first, so the new page joins it — never a fresh session whose save
    // would overwrite the stored pages (dev /crm, 2026-10-18).
    if (!o.ephemeral && !el.call('assistantFlySession', root)) try {
        el.call('assistantFlyRestore', root);
    } catch (_) {
    /* no stored session: a new one starts */ }
    const session = el.call('assistantFlySession', root) || {
        v: 1,
        workspaceId: workspaceId,
        threadId: null,
        open: false,
        path: madeOn,
        focus: null,
        pages: []
    };
    // The session's thread: its id, or 'new' for the first page — never twice
    // (a second ask while the first is still making the thread stays off it).
    const pending = (session.pages || []).some((p)=>p && p.thread === 'new' && p.status !== 'ready' && p.status !== 'failed');
    const thread = o.ephemeral ? null : session.threadId ? session.threadId : pending ? null : 'new';
    // A server without the fly shape answers `invalid_mode` once: the session
    // remembers it (in memory only — never stored, so a server that gains the
    // shape is asked again after a reload) and makes its next pages from a board
    // at once, without the extra round trip. A call's BOARD ask (meet
    // functions/meetFly.js, `engine: 'board'`) is a page made from a board too.
    const boardOnly = session.engine === 'board' || o.engine === 'board';
    // A SOLO ask's context (Fly train 2, functions/assistantFlyContext.js): the
    // composer's scope with the subjects the page on screen shows, and the parts
    // of the screen the member pointed at — read NOW, while the page the member
    // asked from is still the one on screen. A CALL's ask carries none: its page
    // goes to every member of the call, and the reads and the regions are the
    // asker's own (the coordinator's answer, 2026-10-19).
    let asked = null;
    if (!o.ephemeral) try {
        asked = el.call('assistantFlyAskContext', root);
    } catch (_) {
        asked = null;
    }
    // A home tile pinned to a built app asks about THAT app: its scope replaces
    // the composer's (the home's: the whole workspace).
    const tileScope = o.aiScope && typeof o.aiScope === 'object' && o.aiScope.kind ? o.aiScope : null;
    const askContext = tileScope ? {
        ...asked && asked.context || {},
        aiScope: tileScope
    } : asked && asked.context ? asked.context : null;
    const askPicked = asked && Array.isArray(asked.picked) ? asked.picked : [];
    // The project (and board page) the ask was made on — its "Do it" sends it
    // (assistantFlyHandoff; functions/assistantFlyContext.js
    // assistantFlyAskTarget, with the WHY). A call's page has none.
    let target = null;
    if (!o.ephemeral) try {
        target = el.call('assistantFlyAskTarget', root, input.attached);
    } catch (_) {
        target = null;
    }
    const page = {
        key: key,
        id: null,
        status: 'loading',
        phase: 'compose',
        error: null,
        prompt: text,
        eyebrow: '',
        title: '',
        opening: '',
        items: [],
        followUps: [],
        reads: [],
        fallback: boardOnly,
        thread: thread,
        at: Date.now(),
        ms: null,
        ...o.agentName ? {
            agentName: String(o.agentName).slice(0, 60)
        } : {},
        ...target ? {
            target: target
        } : {},
        // The parts of the screen the ask was about: the rail echoes them under
        // the ask the way a chat turn's sent line does (ChatMessage `picked`).
        ...askPicked.length ? {
            picked: askPicked.map((p)=>({
                    keyPath: Array.isArray(p.keyPath) ? p.keyPath.slice(0, 4) : [],
                    key: typeof p.key === 'string' ? p.key : '',
                    tag: typeof p.tag === 'string' ? p.tag : 'region',
                    pickedAt: p.pickedAt || null,
                    inspect: {
                        title: String(p.inspect && p.inspect.title || p.title || '').slice(0, 120)
                    }
                }))
        } : {}
    };
    // THE PAGE IS PLACED AFTER THE REQUEST LEAVES (dev Keepz, 2026-10-17: the
    // canvas render took ~0.4–1.2 s of main thread, and it ran BEFORE the
    // request went out): the model works while the page renders. A frame that
    // comes before the page is placed waits for it. ONE view holds the main
    // area: a board, a deck or the thread steps aside then too.
    let placed = !!o.ephemeral;
    const queued = [];
    // An ephemeral page (a call) lives in its caller's hands, not the session.
    let local = page;
    const read = ()=>{
        if (o.ephemeral) return local;
        const fly = el.call('assistantFlySession', root);
        return fly && Array.isArray(fly.pages) ? fly.pages.find((p)=>p && p.key === key) || null : null;
    };
    const write = (next)=>{
        if (!next) return;
        if (o.ephemeral) local = next;
        else {
            const fly = el.call('assistantFlySession', root);
            if (!fly || !Array.isArray(fly.pages) || !fly.pages.some((p)=>p && p.key === key)) return;
            root.update({
                _aiFly: {
                    ...fly,
                    pages: fly.pages.map((p)=>p && p.key === key ? next : p)
                }
            }, {
                preventFetch: true
            });
        }
        if (typeof o.onFrame === 'function') try {
            o.onFrame(next);
        } catch (_) {
        /* the broadcaster's own failure never breaks the page */ }
    };
    const apply = (frame)=>{
        if (!placed) {
            queued.push(frame);
            return;
        }
        const cur = read();
        if (!cur || cur.status === 'failed') return;
        const ev = frame && frame.event;
        const d = frame && frame.data;
        // Records sections: their data comes in this stream.
        if (ev === 'board.item' && d && d.item && d.item.kind === 'records') el.call('assistantFlyRecordsWrite', root, d.item, 'mark');
        if (ev === 'fly.data' && d) {
            const item = (cur.items || []).find((it)=>it && it.id === d.itemId);
            if (item) el.call('assistantFlyRecordsWrite', root, item, d.answer ? {
                answer: d.answer
            } : {
                error: d.error || true
            });
        }
        write(el.call('applyFlyFrame', cur, frame));
    };
    const place = ()=>{
        if (placed) return;
        if (fns && typeof fns.assistantBoardDismiss === 'function') el.call('assistantBoardDismiss');
        if (fns && typeof fns.assistantDeckDismiss === 'function') el.call('assistantDeckDismiss');
        if (fns && typeof fns.assistantMainThreadClose === 'function') el.call('assistantMainThreadClose');
        if (fns && typeof fns.meetFlyTheater === 'function') el.call('meetFlyTheater', false);
        const now = el.call('assistantFlySession', root) || session;
        const before = (now.pages || []).filter(Boolean);
        // Ask again: the new page takes the old one's place.
        const swap = o.replace && before.some((p)=>p.key === o.replace);
        // The picks the ask took leave the composer with the same write, as a
        // sent chat turn's do (functions/_simone/sendPrompt.js): the page and the
        // rail carry them from here.
        const taken = new Set(askPicked);
        const picks = Array.isArray(root.pickedElements) ? root.pickedElements : null;
        root.update({
            _aiFly: {
                ...now,
                workspaceId: workspaceId,
                open: true,
                path: madeOn,
                focus: key,
                fold: false,
                pages: (swap ? before.map((p)=>p.key === o.replace ? page : p) : [
                    ...before,
                    page
                ]).slice(-20)
            },
            ...taken.size && picks ? {
                pickedElements: picks.filter((p)=>!taken.has(p))
            } : {}
        }, {
            preventFetch: true
        });
        placed = true;
        for (const f of queued.splice(0))apply(f);
    };
    const sdk = el.sdk || (typeof el.call === 'function' ? el.call('getSDK') : null);
    const timeoutMs = Number(o.timeoutMs) > 0 ? Number(o.timeoutMs) : 60000;
    const reasonOf = (err)=>{
        const msg = String(err && (err.code || err.message) || err || '');
        if (/unknown entity|does not support op|is not available|not found on service|unknown method/i.test(msg)) return 'unavailable';
        return el.call('assistantFlyErrorReason', msg);
    };
    let capabilities = null;
    try {
        capabilities = el.call('assistantClientCapabilities', sdk);
    } catch (_) {
        capabilities = null;
    }
    // THE BUILT-IN VIEWS a page may place (calendar, tasks, files …): the
    // shell's providers' declarations, the list a chat turn sends as
    // `context.appCatalog` (functions/assistantAppViews.js). Installed apps'
    // views the server reads from their manifests itself.
    let catalog = null;
    try {
        catalog = el.call('assistantAppCatalog');
    } catch (_) {
        catalog = null;
    }
    // A page the person stopped (assistantFlyStop) keeps what arrived: its
    // request ends at the next frame and nothing after it lands on the page.
    const stopped = ()=>{
        const cur = read();
        return !!(cur && cur.status === 'failed' && cur.error === 'stopped');
    };
    const run = async (mode)=>{
        let timer = null;
        const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        try {
            if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
            // A SOLO fly ask draws UI sections (`capabilities.ui`, server
            // recordsBlock clientRendersUi): the page may then SHOW its reads with
            // the chat's answer-UI components (functions/assistantFlyUi.js). A
            // CALL's ask never does — its reads run under the asker's access and
            // the call shows the page to every member; it keeps the sections it
            // has today (the coordinator's answer, 2026-10-19).
            const solo = mode === 'fly' && !o.ephemeral;
            // …nor offers the quick tour: one member's tour on everyone's page.
            const shared = capabilities ? {
                ...capabilities
            } : null;
            if (shared) delete shared.tour;
            const caps = solo ? {
                ...capabilities || {},
                ui: 1
            } : shared && Object.keys(shared).length ? shared : null;
            const pendingCall = sdk.execute('ai.boards', 'generate', {
                prompt: text,
                mode: mode,
                ...mode === 'fly' && thread ? {
                    threadId: thread
                } : {},
                ...mode === 'fly' && Array.isArray(catalog) && catalog.length ? {
                    appCatalog: catalog
                } : {},
                ...workspaceId ? {
                    workspaceId: workspaceId
                } : {},
                ...input.attached ? {
                    attached: input.attached
                } : {},
                ...input.attachments ? {
                    attachments: input.attachments
                } : {},
                ...caps ? {
                    capabilities: caps
                } : {},
                // What "this" means (the chat turn's own `context.aiScope` and
                // `context.inspected`; server AiBoardController pageContextOf). An
                // SDK that does not forward `context` yet drops it — the page is
                // then made as before.
                ...solo && askContext ? {
                    context: askContext
                } : {},
                // The SDK's streamed board request takes the signal to its fetch.
                ...ctrl ? {
                    signal: ctrl.signal
                } : {},
                onEvent: (frame)=>{
                    if (stopped()) {
                        if (ctrl) try {
                            ctrl.abort();
                        } catch (_) {
                        /* already ended */ }
                        return;
                    }
                    if (frame && typeof frame === 'object' && frame.event !== 'board.done') apply(frame);
                }
            });
            const res = await Promise.race([
                Promise.resolve(pendingCall),
                new Promise((resolve, reject)=>{
                    timer = setTimeout(()=>reject(new Error('timeout')), timeoutMs);
                })
            ]);
            const data = res && typeof res === 'object' ? res.data || res : null;
            apply({
                event: 'board.done',
                data: data && data.spec ? data : {
                    spec: data
                }
            });
            return data;
        } finally{
            if (timer) clearTimeout(timer);
        }
    };
    // The request leaves now (the shell's capabilities answer at once after
    // their first read); the page is placed in the next task, after every
    // microtask of the SDK's request ran.
    const first = Promise.resolve(capabilities).catch(()=>null).then((c)=>{
        capabilities = c && typeof c === 'object' ? c : null;
        return run(boardOnly ? 'dashboard' : 'fly');
    });
    first.catch(()=>{});
    if (!placed) {
        await new Promise((resolve)=>setTimeout(resolve, 0));
        place();
    }
    let done = null;
    try {
        done = await first;
    } catch (err) {
        const msg = String(err && (err.code || err.message) || err || '');
        if (stopped()) ;
        else if (!boardOnly && /invalid_mode/i.test(msg)) {
            // A server without the fly shape: the same page, built from a board.
            const fly = el.call('assistantFlySession', root);
            if (fly && fly.engine !== 'board') root.update({
                _aiFly: {
                    ...fly,
                    engine: 'board'
                }
            }, {
                preventFetch: true
            });
            const cur = read();
            if (cur) write({
                ...cur,
                status: 'streaming',
                fallback: true
            });
            try {
                done = await run('dashboard');
            } catch (err2) {
                const cur2 = read();
                if (cur2 && !stopped()) write({
                    ...cur2,
                    status: 'failed',
                    phase: 'done',
                    error: reasonOf(err2)
                });
            }
        } else {
            const cur = read();
            if (cur) write({
                ...cur,
                status: 'failed',
                phase: 'done',
                error: reasonOf(err)
            });
        }
    }
    const finished = read();
    if (finished) el.call('assistantFlyRecordsSettle', root, finished.items);
    // The session learns its thread from the first page; the sidebar's history
    // list hears of it.
    const threadId = done && typeof done.threadId === 'string' ? done.threadId : null;
    if (!o.ephemeral) {
        const fly = el.call('assistantFlySession', root);
        if (fly && threadId && fly.threadId !== threadId) {
            root.update({
                _aiFly: {
                    ...fly,
                    threadId: threadId
                }
            }, {
                preventFetch: true
            });
            try {
                if (fns && typeof fns.refreshSessionsAfterTurn === 'function') el.call('refreshSessionsAfterTurn', 'general');
            } catch (_) {
            /* the list refreshes on its own next read */ }
        }
        el.call('assistantFlyPersist', root);
    }
    return read();
};
const $0d74a00aebfd4291$export$a29a41f7096cb828 = function assistantFlyStop(key) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return 0;
    const fly = el.call('assistantFlySession', root);
    if (!fly || !Array.isArray(fly.pages)) return 0;
    let n = 0;
    const pages = fly.pages.map((p)=>{
        if (!p || key && p.key !== key) return p;
        if (p.status !== 'loading' && p.status !== 'streaming') return p;
        n += 1;
        return {
            ...p,
            status: 'failed',
            phase: 'done',
            error: 'stopped'
        };
    });
    if (n) root.update({
        _aiFly: {
            ...fly,
            pages: pages
        }
    }, {
        preventFetch: true
    });
    return n;
};
const $0d74a00aebfd4291$export$f739d1519789790d = function assistantFlyAsk(entry) {
    const p = entry && typeof entry === 'object' ? entry.prompt : entry;
    const text = String(p == null ? '' : p).trim();
    if (!text) return null;
    const scope = entry && typeof entry === 'object' ? entry.aiScope : null;
    if (scope && typeof scope === 'object' && scope.kind) return this.call('assistantFlyGenerate', text, {
        aiScope: scope
    });
    return this.call('assistantFlyGenerate', text);
};
const $0d74a00aebfd4291$export$acfd3bf606ea0ce2 = function assistantFlyPageAct(s, verb, arg) {
    const page = s && typeof s.parse === 'function' ? s.parse() : s;
    if (!page || typeof page !== 'object') return null;
    if (verb === 'ask') {
        const prompt = String(arg && arg.prompt || page.prompt || '').trim();
        if (!prompt) return null;
        if (page.source === 'call') return this.call('meetFlyAsk', {
            prompt: prompt,
            agentKey: page.agentKey || null,
            agentName: page.agentName || null
        });
        return this.call('assistantFlyAsk', prompt);
    }
    // Ask again / Try again: the SAME page made again, in its place (a call's
    // stage shows one page anyway).
    if (verb === 'again') {
        const prompt = String(page.prompt || '').trim();
        if (!prompt) return null;
        if (page.source === 'call') return this.call('meetFlyAsk', {
            prompt: prompt,
            agentKey: page.agentKey || null,
            agentName: page.agentName || null
        });
        return this.call('assistantFlyGenerate', prompt, {
            replace: page.key
        });
    }
    // A folded row: its page opens where it lives (the session, or the call's
    // theater).
    if (verb === 'focus') return page.source === 'call' ? this.call('meetFlyFocus', page.key) : this.call('assistantFlyFocus', page.key);
    if (verb === 'share') return this.call('assistantFlyShare', page);
    if (verb === 'save') return this.call('assistantFlySave', page);
    return null;
};
const $0d74a00aebfd4291$export$6d25666f22fd3b89 = function assistantFlyHandoff(s) {
    const page = s && typeof s.parse === 'function' ? s.parse() : s;
    if (!page || typeof page !== 'object' || page.source === 'call') return false;
    const text = String(page.action || '').trim();
    if (!text) return false;
    const t = page.target && typeof page.target === 'object' ? page.target.canvas : null;
    const attached = t && typeof t === 'object' && t.projectId ? {
        canvas: {
            projectId: String(t.projectId),
            ...t.boardPageId ? {
                boardPageId: String(t.boardPageId)
            } : {},
            ...t.title ? {
                title: String(t.title)
            } : {},
            nodes: [],
            connections: []
        }
    } : null;
    this.call('homeAiSend', text, null, 0, attached, {
        mode: 'tools'
    });
    return true;
};
const $0d74a00aebfd4291$export$c5d4c19abdc9b70e = function assistantFlyFormCard(s) {
    const page = s && typeof s.parse === 'function' ? s.parse() : s;
    const f = page && typeof page === 'object' ? page.form : null;
    if (!f || typeof f !== 'object' || typeof f.form !== 'string' || !f.form) return null;
    if (page.source === 'call') return null;
    return {
        type: 'form',
        form: f.form,
        values: f.values && typeof f.values === 'object' ? f.values : {}
    };
};
const $0d74a00aebfd4291$export$d58917760e97d065 = function assistantFlyFormStatus(s) {
    const card = this.call('assistantFlyFormCard', s);
    if (!card) return null;
    const fns = this.context && this.context.functions || {};
    if (typeof fns.assistantFormStatus !== 'function') return 'refused';
    return this.call('assistantFormStatus', card) || 'refused';
};
const $0d74a00aebfd4291$export$3870ae2c233cad98 = function assistantFlyFormOpen(s) {
    const card = this.call('assistantFlyFormCard', s);
    if (!card || this.call('assistantFlyFormStatus', s) !== 'ready') return null;
    return this.call('assistantFormOpen', card);
};
const $0d74a00aebfd4291$export$4260758df2c4316a = function assistantFlyFormNote(s) {
    const status = this.call('assistantFlyFormStatus', s);
    if (status === 'denied') return String(this.call('polyglot', 'workspace.assistantBlock.formDenied'));
    if (status === 'refused') return String(this.call('polyglot', 'workspace.assistantBlock.formGone'));
    return '';
};
const $0d74a00aebfd4291$export$94f54f763153fbf2 = function assistantFlyCardVerb(s) {
    const own = s && s.kind === 'widget' ? s.action || s.spec && s.spec.action : null;
    return !!(own && (own.call || own.route || own.set));
};
const $0d74a00aebfd4291$export$ebeeadec93f764ef = function assistantFlyCardActionLabel(s) {
    const a = s && s.kind !== 'skeleton' ? this.call('homeWidgetActionOf', s) : null;
    if (!a) return null;
    const name = s.title ? String(this.call('polyglot', s.title)) : '';
    return String(this.call('polyglot', a.label)).replace('{app}', name);
};
const $0d74a00aebfd4291$export$a7f86d15d6758e38 = function assistantFlyCardAct(s, event) {
    if (!this.call('assistantFlyCardVerb', s)) return this.call('assistantBoardCardOpen', s, event);
    const host = typeof this.lookup === 'function' ? this.lookup('CardBody') : null;
    const body = host && host.content ? host.content : null;
    return this.call('homeWidgetRunAction', s, event, body);
};
const $0d74a00aebfd4291$export$b8790edf91ac4661 = function assistantFlyCardCloses(s) {
    if (!s || typeof s.page !== 'string' || !s.page) return null;
    if (s.kind === 'records' && s.drill && typeof s.drill === 'object') return s.drillsInto === s.page ? 'drill' : null;
    return s.page.startsWith('fwl-') ? 'remove' : null;
};
const $0d74a00aebfd4291$export$3cf7fba3f7079d6b = function assistantFlyCardCloseLabel(s) {
    const what = this.call('assistantFlyCardCloses', s);
    if (what === 'drill') return String(this.call('polyglot', 'workspace.assistantRecords.drillClose')).replace('{title}', s && s.title || '');
    return what === 'remove' ? String(this.call('polyglot', 'shell.flyWorkspace.remove')) : null;
};
const $0d74a00aebfd4291$export$a2b9d305dc4537fc = function assistantFlyCardClose(s) {
    const what = this.call('assistantFlyCardCloses', s);
    if (what === 'drill') return this.call('assistantFlyDrillClose', s.page, s.key);
    if (what === 'remove') return this.call('assistantFlyWorkspaceRemove', s.page, s.key);
    return false;
};
const $0d74a00aebfd4291$export$d8936690206e860 = function assistantFlyDrill(pageKey, cellKey, bar) {
    const MAX_ITEMS = 12;
    const root = this.state && this.state.root;
    const fly = this.call('assistantFlySession', root);
    if (!root || typeof root.update !== 'function' || !fly) return false;
    const pages = Array.isArray(fly.pages) ? fly.pages : [];
    const page = pages.find((p)=>p && p.key === pageKey);
    if (!page || page.status !== 'ready' || page.source === 'call' || page.save === 'saving') return false;
    if (!Array.isArray(page.items) || typeof cellKey !== 'string') return false;
    const prefix = page.key + '-';
    if (!cellKey.startsWith(prefix)) return false;
    const sourceKey = cellKey.slice(prefix.length);
    const derived = this.call('boardItemsFor', {
        v: 1,
        items: page.items
    }, root);
    const source = (derived && derived.items || []).find((it)=>it && it.key === sourceKey && it.kind === 'records');
    if (!source || !source.records) return false;
    const entry = this.call('assistantRecordsEntry', root, source.records);
    const made = this.call('assistantRecordsDrillOf', source.records, entry, bar);
    if (!made) return false;
    const keyOf = (it)=>{
        // A records item as validation reads one: `kind: 'records'`, or no kind
        // with a collection (functions/assistantBoard.js validateBoardSpec).
        if (!it || typeof it !== 'object' || it.kind && it.kind !== 'records') return '';
        const n = this.call('recordsBlockNormalize', it);
        return n ? 'r:' + this.call('boardSpecHash', n) : '';
    };
    const kept = page.items.filter((it)=>!(it && it.drill && it.drill.from === sourceKey));
    if (kept.length >= MAX_ITEMS) return false;
    const at = kept.findIndex((it)=>keyOf(it) === sourceKey);
    if (at < 0) return false;
    const items = kept.slice();
    items.splice(at + 1, 0, {
        ...made.block,
        drill: {
            from: sourceKey,
            ...made.drill
        }
    });
    root.update({
        _aiFly: {
            ...fly,
            pages: pages.map((p)=>p === page ? {
                    ...page,
                    items: items,
                    save: null
                } : p)
        }
    }, {
        preventFetch: true
    });
    this.call('assistantFlyPersist', root);
    return true;
};
const $0d74a00aebfd4291$export$86f6ac368a5b8ae6 = function assistantFlyDrillClose(pageKey, cellKey) {
    const root = this.state && this.state.root;
    const fly = this.call('assistantFlySession', root);
    if (!root || typeof root.update !== 'function' || !fly) return false;
    const pages = Array.isArray(fly.pages) ? fly.pages : [];
    const page = pages.find((p)=>p && p.key === pageKey);
    if (!page || !Array.isArray(page.items) || page.save === 'saving') return false;
    if (typeof cellKey !== 'string' || !cellKey.startsWith(page.key + '-')) return false;
    const key = cellKey.slice(page.key.length + 1);
    const keyOf = (it)=>{
        // A records item as validation reads one: `kind: 'records'`, or no kind
        // with a collection (functions/assistantBoard.js validateBoardSpec).
        if (!it || typeof it !== 'object' || it.kind && it.kind !== 'records') return '';
        const n = this.call('recordsBlockNormalize', it);
        return n ? 'r:' + this.call('boardSpecHash', n) : '';
    };
    const items = page.items.filter((it)=>!(it && it.drill && keyOf(it) === key));
    if (items.length === page.items.length) return false;
    root.update({
        _aiFly: {
            ...fly,
            pages: pages.map((p)=>p === page ? {
                    ...page,
                    items: items,
                    save: null
                } : p)
        }
    }, {
        preventFetch: true
    });
    this.call('assistantFlyPersist', root);
    return true;
};
const $0d74a00aebfd4291$export$56d444834d820a79 = function assistantFlyFocus(key) {
    const root = this.state && this.state.root;
    const fly = this.call('assistantFlySession', root);
    if (!fly || !key || fly.focus === key && fly.fold !== true) return false;
    root.update({
        _aiFly: {
            ...fly,
            focus: key,
            fold: false,
            open: true
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $0d74a00aebfd4291$export$61fd462016db12f8 = function assistantFlyClose(opts) {
    const root = this.state && this.state.root;
    const fly = this.call('assistantFlySession', root);
    if (!fly || !fly.open) return false;
    root.update({
        _aiFly: {
            ...fly,
            open: false
        }
    }, {
        preventFetch: true
    });
    if (opts && opts.focusComposer) this.call('assistantBoardFocus', 'composer');
    return true;
};
const $0d74a00aebfd4291$export$c645060276b1049 = function assistantFlyNew() {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    const madeOn = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    // THE RECENT PAGES (the start screen's Recent, Nika 2026-10-23 "make fly
    // starter screen more advanced"): the pages this new session puts away,
    // newest first, before the ones it already carried — by their asks, each
    // once, at most six. A hand-made page has no ask and is not carried.
    const was = this.call('assistantFlySession', root);
    const recent = [];
    const seen = new Set();
    const carry = (p)=>{
        const prompt = p && typeof p.prompt === 'string' ? p.prompt.trim() : '';
        if (!prompt || seen.has(prompt.toLowerCase()) || recent.length >= 6) return;
        seen.add(prompt.toLowerCase());
        recent.push({
            prompt: prompt.slice(0, 500),
            title: String(p && p.title || prompt).slice(0, 160),
            at: Number(p && p.at) || Date.now()
        });
    };
    const outgoing = was && Array.isArray(was.pages) ? was.pages : [];
    for(let i = outgoing.length - 1; i >= 0; i--)if (outgoing[i] && outgoing[i].status === 'ready') carry(outgoing[i]);
    for (const p of was && Array.isArray(was.recent) ? was.recent : [])carry(p);
    root.update({
        _aiFly: {
            v: 1,
            workspaceId: workspaceId,
            threadId: null,
            open: false,
            path: madeOn,
            focus: null,
            pages: [],
            recent: recent
        }
    }, {
        preventFetch: true
    });
    this.call('assistantFlyPersist', root);
    this.call('assistantBoardFocus', 'composer');
    return true;
};
const $0d74a00aebfd4291$export$3f29c6d161cf43a = function assistantFlyLink(page) {
    if (!page || !page.prompt) return '';
    const loc = typeof window !== 'undefined' && window.location ? window.location : null;
    const base = loc ? String(loc.origin || '') + String(loc.pathname || '/') : '/';
    return base + '?fly=' + encodeURIComponent(String(page.prompt).slice(0, 500));
};
const $0d74a00aebfd4291$export$64cb8c7d9a5b04e9 = function assistantFlyShare(ref) {
    const root = this.state && this.state.root;
    const page = ref && typeof ref === 'object' ? ref : this.call('assistantFlyPage', root, ref);
    const url = this.call('assistantFlyLink', page);
    if (!url) return false;
    const say = (ok)=>{
        try {
            this.call('openNotification', {
                type: ok ? 'success' : 'error',
                title: this.call('polyglot', ok ? 'workspace.assistantFly.linkCopied' : 'workspace.share.copyFailed.title'),
                message: ok ? this.call('polyglot', 'workspace.assistantFly.linkCopiedHint') : url
            });
        } catch (_) {
        /* no notification host (a test, a standalone surface) */ }
    };
    const clip = typeof navigator !== 'undefined' && navigator.clipboard ? navigator.clipboard : null;
    if (clip && typeof clip.writeText === 'function') Promise.resolve(clip.writeText(url)).then(()=>say(true), ()=>say(false));
    else say(false);
    return url;
};
const $0d74a00aebfd4291$export$1b1efe1723c9e4a4 = function assistantFlySavable(page) {
    // A page or its state (the page body's `s`): its items read by index.
    const items = page && page.items;
    const n = items && typeof items.length === 'number' ? items.length : 0;
    for(let i = 0; i < n; i++){
        const it = items[i];
        if (it && it.kind !== 'ui') return true;
    }
    return false;
};
const $0d74a00aebfd4291$export$9095528eaabdb64e = async function assistantFlySave(ref) {
    const root = this.state && this.state.root;
    const page = ref && typeof ref === 'object' ? ref : this.call('assistantFlyPage', root, ref);
    if (!root || !page || page.status !== 'ready' || !this.call('assistantFlySavable', page)) return {
        ok: false,
        reason: 'unavailable'
    };
    const mark = (save)=>{
        if (page.source === 'call') {
            const call = root.meetFly;
            const pages = call && Array.isArray(call.pages) ? call.pages : [];
            if (!pages.some((rec)=>rec && rec.key === page.key)) return;
            root.update({
                meetFly: {
                    ...call,
                    pages: pages.map((rec)=>rec && rec.key === page.key ? {
                            ...rec,
                            page: {
                                ...rec.page,
                                save: save
                            }
                        } : rec)
                }
            }, {
                preventFetch: true
            });
            return;
        }
        const fly = this.call('assistantFlySession', root);
        if (!fly) return;
        root.update({
            _aiFly: {
                ...fly,
                pages: fly.pages.map((p)=>p && p.key === page.key ? {
                        ...p,
                        save: save
                    } : p)
            }
        }, {
            preventFetch: true
        });
    };
    if (page.save === 'saved' || page.save === 'saving') return {
        ok: page.save === 'saved'
    };
    mark('saving');
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    try {
        const sdk = this.sdk || this.call('getSDK');
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const spec = {
            v: 1,
            title: page.title || page.prompt,
            summary: page.title && page.title !== page.prompt ? String(page.prompt || '').slice(0, 280) : '',
            // A UI section is one read's result at the time of the ask, not a live
            // section: a board keeps the sections that read again (the server's
            // board validator refuses a `ui` item).
            items: (page.items || []).filter((it)=>it && it.kind !== 'ui'),
            // the text asks only: the tour chip is no board ask
            refine: (page.followUps || []).filter((f)=>f && f.prompt).map((f)=>({
                    label: f.label,
                    prompt: f.prompt
                })),
            sources: []
        };
        const saved = await sdk.execute('ai.boards', 'save', {
            spec: spec,
            prompt: page.prompt,
            title: spec.title,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const row = saved && typeof saved === 'object' ? saved.data || saved : null;
        if (row && row.id) {
            const list = Array.isArray(root._aiBoards) ? root._aiBoards : [];
            root.update({
                _aiBoards: [
                    row,
                    ...list.filter((x)=>x && x.id !== row.id)
                ]
            }, {
                preventFetch: true
            });
        }
        mark('saved');
        try {
            // the toast opens the board it names (ai-r1, priya: no way to it)
            this.call('openNotification', {
                type: 'success',
                title: this.call('polyglot', 'workspace.assistantFly.saved'),
                message: this.call('polyglot', 'workspace.assistantFly.savedHint'),
                ...row && row.id ? {
                    actionLabel: this.call('polyglot', 'workspace.assistantFly.openBoard'),
                    action: {
                        call: 'assistantBoardSelect',
                        args: [
                            row.id
                        ]
                    }
                } : {}
            });
        } catch (_) {
        /* no notification host */ }
        return {
            ok: true,
            board: row
        };
    } catch (err) {
        mark('failed');
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
};
const $0d74a00aebfd4291$export$99fa93926ec9bd6b = function assistantFlyPersist(root) {
    const fly = this.call('assistantFlySession', root);
    if (!fly || !fly.workspaceId) return false;
    if (typeof localStorage === 'undefined') return false;
    let pages = (fly.pages || []).filter((p)=>p && typeof p.key === 'string').slice(-12).map((p)=>p.status === 'ready' ? p : {
            ...p,
            status: 'failed',
            error: p.status === 'failed' ? p.error || 'failed' : 'stopped',
            id: p.id || null,
            eyebrow: '',
            title: '',
            opening: '',
            items: [],
            reads: [],
            followUps: [],
            form: null
        }).map((p)=>({
            key: p.key,
            id: p.id,
            status: p.status,
            ...p.status === 'failed' ? {
                error: p.error
            } : {},
            phase: 'done',
            prompt: p.prompt,
            eyebrow: p.eyebrow,
            title: p.title,
            opening: p.opening,
            items: p.items,
            reads: Array.isArray(p.reads) ? p.reads : [],
            followUps: p.followUps,
            action: p.action || '',
            form: p.form && typeof p.form === 'object' ? p.form : null,
            fallback: !!p.fallback,
            at: p.at,
            // how long it took (the rail's foot: "6 sections · 4.2 s")
            ms: Number(p.ms) > 0 ? Number(p.ms) : null,
            ...p.agentName ? {
                agentName: p.agentName
            } : {},
            ...Array.isArray(p.picked) && p.picked.length ? {
                picked: p.picked
            } : {},
            // the project its ask was made on: "Do it" after a reload still sends it
            ...p.target && typeof p.target === 'object' ? {
                target: p.target
            } : {}
        }));
    for(;;)try {
        localStorage.setItem('symbols_fly_' + fly.workspaceId, JSON.stringify({
            v: 1,
            threadId: fly.threadId || null,
            pages: pages,
            // the start screen's Recent (assistantFlyNew)
            recent: Array.isArray(fly.recent) ? fly.recent.slice(0, 6) : [],
            focus: fly.focus || null,
            // when it was last worked on (assistantFlyRestore brings back only a
            // recent session; an older one gives way to the start screen)
            savedAt: Date.now()
        }));
        return true;
    } catch (_) {
        if (pages.length <= 1) return false;
        pages = pages.slice(1);
    }
};
const $0d74a00aebfd4291$export$ee20165432fc334 = function assistantFlyRestore(root) {
    if (!root || typeof root.update !== 'function') return false;
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    if (!workspaceId || this.call('assistantFlySession', root)) return false;
    let stored = null;
    try {
        stored = typeof localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('symbols_fly_' + workspaceId) || 'null') : null;
    } catch (_) {
        stored = null;
    }
    if (!stored || typeof stored !== 'object') return false;
    const pages = (Array.isArray(stored.pages) ? stored.pages : []).filter((p)=>p && typeof p.key === 'string' && typeof p.prompt === 'string');
    // An empty session comes back too when it carries the start screen's Recent
    // (a fresh Fly put pages away: assistantFlyNew).
    const recent = (Array.isArray(stored.recent) ? stored.recent : []).filter((p)=>p && typeof p.prompt === 'string' && p.prompt).slice(0, 6);
    if (!pages.length && !recent.length) return false;
    const FRESH_MS = 43200000;
    const savedAt = Number(stored.savedAt) || Math.max(0, ...pages.map((p)=>Number(p && p.at) || 0), ...recent.map((p)=>Number(p.at) || 0));
    if (!(savedAt > 0) || Date.now() - savedAt > FRESH_MS) return false;
    const madeOn = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    root.update({
        _aiFly: {
            v: 1,
            workspaceId: workspaceId,
            threadId: typeof stored.threadId === 'string' ? stored.threadId : null,
            open: false,
            path: madeOn,
            focus: pages.some((p)=>p.key === stored.focus) ? stored.focus : pages.length ? pages[pages.length - 1].key : null,
            pages: pages,
            recent: recent
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $0d74a00aebfd4291$export$5036ecbef20543fa = function assistantFlyUrlOpen(root) {
    const w = typeof window !== 'undefined' ? window : null;
    if (!w || !w.location || !root) return false;
    let url;
    try {
        url = new URL(w.location.href);
    } catch (_) {
        return false;
    }
    const ask = (url.searchParams.get('fly') || '').trim();
    if (!ask) return false;
    url.searchParams.delete('fly');
    if (w.history && typeof w.history.replaceState === 'function') // The shell's query-only address contract (functions/homeBoardUrl.js):
    // no navigation, no router dispatch, no new history entry.
    // frank-allow FA410
    w.history.replaceState(w.history.state, '', url.pathname + url.search + url.hash);
    this.call('assistantFlyGenerate', ask.slice(0, 500));
    return true;
};
const $0d74a00aebfd4291$export$8de8de5b83d5912 = function assistantFlyMounted(el, s) {
    const host = el || this;
    this.call('assistantBoardGridRead', host, s, 'assistantFlySyncGrid');
    const root = s && s.root;
    const ws = root && root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    if (host.__flyMountedFor === workspaceId) return false;
    host.__flyMountedFor = workspaceId;
    this.call('assistantFlyRestore', root);
    if (host.mainHost !== 'over') {
        const sdk = host.sdk || this.call('getSDK');
        Promise.resolve(this.call('assistantBoardProbe', root, sdk)).then(()=>{
            if (host.node && host.node.isConnected !== false) host.call('assistantFlyUrlOpen', root);
        });
    }
    return true;
};
const $0d74a00aebfd4291$export$899fe41303e7e61b = function assistantFlyShortcuts(el) {
    const view = el || this;
    if (!view || typeof view.call !== 'function') return ()=>false;
    const over = view.mainHost === 'over';
    view.call('listShortcuts');
    const shown = (h, root)=>{
        const node = view.node;
        if (!node || node.isConnected === false) return false;
        if (root && (root._canvasSlot || root._canvasSlotSecond)) return false;
        return !!view.call('assistantFlyShown', root);
    };
    const off = view.call('registerShortcut', {
        id: over ? 'assistantFlyCloseOver' : 'assistantFlyClose',
        keys: 'escape',
        label: over ? null : 'workspace.assistantFly.shortcutClose',
        group: 'shell.headerTabs.dashboard',
        groupOrder: 3,
        order: 8,
        when: shown,
        run: ()=>view.call('assistantFlyClose', {
                focusComposer: true
            })
    });
    const stop = ()=>typeof off === 'function' ? off() : false;
    view.__flyShortcutsOff = stop;
    return stop;
};
const $0d74a00aebfd4291$export$bd86b59ef84dbf3f = function assistantFlyReveal(el, key) {
    const host = el || this;
    if (!host || !key || host.__flyRevealed === key) return false;
    const fns = this && this.context && this.context.functions || {};
    if (typeof fns.assistantRevealTop === 'function') {
        host.__flyRevealed = key;
        this.call('assistantRevealTop', host, key, 'page' + key);
        return true;
    }
    const page = typeof host.lookdown === 'function' ? host.lookdown(key) : null;
    const node = page && page.node;
    if (!node || typeof node.scrollIntoView !== 'function') return false;
    host.__flyRevealed = key;
    node.scrollIntoView({
        block: 'start'
    });
    return true;
};

});

parcelRegister("6rBuB", function(module, exports) {

$parcel$export(module.exports, "assistantFlyWorkspaceErrorKey", () => $4b1258ec659bb7d2$export$97c793fb47181adb);
$parcel$export(module.exports, "assistantFlyWorkspaceState", () => $4b1258ec659bb7d2$export$302bec94b5b6ecaa);
$parcel$export(module.exports, "assistantFlyWorkspaceEnter", () => $4b1258ec659bb7d2$export$d8b7598fbb664775);
$parcel$export(module.exports, "assistantFlyAvailable", () => $4b1258ec659bb7d2$export$202a64045d5ce1ef);
$parcel$export(module.exports, "assistantFlyWorkspaceMounted", () => $4b1258ec659bb7d2$export$76485205bd787a03);
$parcel$export(module.exports, "assistantFlySectionOffered", () => $4b1258ec659bb7d2$export$92d3eda41912db05);
$parcel$export(module.exports, "assistantFlyWorkspacePicker", () => $4b1258ec659bb7d2$export$2b678c2a0803b14b);
$parcel$export(module.exports, "assistantFlyWorkspaceClose", () => $4b1258ec659bb7d2$export$d23c2cc3cefa1334);
$parcel$export(module.exports, "assistantFlyWorkspaceNew", () => $4b1258ec659bb7d2$export$fd9ca10e57a4a346);
$parcel$export(module.exports, "assistantFlyHomeFresh", () => $4b1258ec659bb7d2$export$4e574bd7b125b4e6);
$parcel$export(module.exports, "assistantFlyHomeClick", () => $4b1258ec659bb7d2$export$e849b90c756d9589);
$parcel$export(module.exports, "assistantFlyWorkspaceDismiss", () => $4b1258ec659bb7d2$export$977e8c7395825961);
$parcel$export(module.exports, "assistantFlyWorkspaceOptions", () => $4b1258ec659bb7d2$export$1b1503edf03ad184);
$parcel$export(module.exports, "assistantFlyWorkspaceSelect", () => $4b1258ec659bb7d2$export$377f42ddababcf3e);
$parcel$export(module.exports, "assistantFlyWorkspaceReturnShown", () => $4b1258ec659bb7d2$export$f71927a1d6bb64ff);
$parcel$export(module.exports, "assistantFlyWorkspaceRemove", () => $4b1258ec659bb7d2$export$334325e8b338f5e9);
$parcel$export(module.exports, "assistantFlyWorkspaceReturn", () => $4b1258ec659bb7d2$export$5567b1a782dbb769);
// Fly's local tool — Add section — reuses the workspace's board vocabulary and
// board renderer. It never asks a model, fetches data, or copies app
// definitions into session state. Every export is self-contained for Frank
// serialization.
//
// ONE TOOL, IN THE COMPOSER'S "+" (Nika 2026-10-23: "I'm not sure about these
// buttons … maybe we move them somewhere else? open workspace tools is already
// in top menu so whats the point?"): the canvas no longer carries a toolbar.
// "Open workspace" is gone — the top menu and the search open every app.
// "Add section" is a row of the composer's "+" menu while the canvas is on
// screen (assistantFlySectionOffered; canvas CanvasPromptTextarea AttachMenu
// FlySectionRow) — the composer is where a Fly page is made, asked or built.
// What stays here: the section picker, its "Section added" note in the
// canvas's bar, and the guarded return to Fly over an open pane.
//
// The sentence of a failure code — every key written out, so the i18n gates
// ("every shipped key is referenced") see each one; an unknown code reads as
// the navigation failure.
function $4b1258ec659bb7d2$export$97c793fb47181adb(code) {
    const KEYS = {
        unavailable: 'shell.flyWorkspace.error.unavailable',
        limit: 'shell.flyWorkspace.error.limit',
        duplicate: 'shell.flyWorkspace.error.duplicate',
        navigation: 'shell.flyWorkspace.error.navigation',
        changed: 'shell.flyWorkspace.error.changed',
        saving: 'shell.flyWorkspace.error.saving'
    };
    return KEYS[code] || KEYS.navigation;
}
function $4b1258ec659bb7d2$export$302bec94b5b6ecaa(root) {
    const r = root || this.state && this.state.root;
    const ws = r && r.workspace;
    const workspaceId = ws && (ws.id || ws._id);
    if (!workspaceId) return null;
    const saved = r._aiFlyWorkspace;
    if (saved && String(saved.workspaceId) === String(workspaceId)) return saved;
    return {
        workspaceId: String(workspaceId),
        picker: null,
        originPath: null,
        originFocus: null,
        returnPending: false,
        status: 'idle',
        error: null,
        operationId: null,
        seq: 0
    };
}
function $4b1258ec659bb7d2$export$d8b7598fbb664775() {
    const root = this.state && this.state.root;
    const state = this.call('assistantFlyWorkspaceState', root);
    if (!state || !root || typeof root.update !== 'function') return false;
    const fns = this.context && this.context.functions || {};
    let known = this.call('assistantFlySession', root);
    if (!known && typeof fns.assistantFlyRestore === 'function') {
        this.call('assistantFlyRestore', root);
        known = this.call('assistantFlySession', root);
    }
    const fly = known && String(known.workspaceId) === state.workspaceId ? known : {
        v: 1,
        workspaceId: state.workspaceId,
        threadId: null,
        focus: null,
        pages: []
    };
    const path = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    for (const name of [
        'assistantBoardDismiss',
        'assistantDeckDismiss',
        'assistantMainThreadClose'
    ])if (typeof fns[name] === 'function') this.call(name);
    root.update({
        _aiFly: {
            ...fly,
            open: true,
            path: path
        },
        _aiFlyWorkspace: {
            ...state,
            originPath: path,
            originFocus: fly.focus || null,
            picker: null,
            returnPending: !!(root._canvasSlot || root._canvasSlotSecond),
            status: 'idle',
            error: null,
            operationId: null,
            seq: (state.seq || 0) + 1
        }
    }, {
        preventFetch: true
    });
    // A mode choice must not discard an existing pane. The same guarded return
    // path closes it only after the person accepts the normal unsaved prompt.
    if (root._canvasSlot || root._canvasSlotSecond) return this.call('assistantFlyWorkspaceReturn');
    return true;
}
function $4b1258ec659bb7d2$export$202a64045d5ce1ef(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this && this.context && this.context.functions || {};
    if (typeof fns.featureEnabled !== 'function') return true;
    const assistant = !!this.call('featureEnabled', r, 'aiAssistant');
    const composer = !!this.call('featureEnabled', r, 'aiAssistant.composer');
    return assistant && composer;
}
function $4b1258ec659bb7d2$export$76485205bd787a03(el, s) {
    const host = el || this;
    const root = s && s.root || host.state && host.state.root;
    const ws = root && root.workspace;
    const workspaceId = ws && (ws.id || ws._id);
    const mode = root && root.assistantMode;
    const fns = host.context && host.context.functions || {};
    const path = root && typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    const bare = typeof fns.stripWorkspacePrefix === 'function' ? host.call('stripWorkspacePrefix', path) : path;
    const home = typeof bare === 'string' && bare.replace(/\/+$/, '') === '';
    const available = !!root && (typeof fns.assistantFlyAvailable !== 'function' || !!host.call('assistantFlyAvailable', root));
    const previous = host.__flyWorkspaceMountedFor;
    const same = !!previous && previous.workspaceId === workspaceId && previous.mode === mode;
    let fly = root ? host.call('assistantFlySession', root) : null;
    // Fly mode left by anything but the person's own pick (setAssistantMode
    // puts the canvas away for that one): the account's record landing with
    // another mode after the page painted the default. The canvas goes with
    // the mode it opened in.
    if (previous && previous.mode === 'fly' && mode !== 'fly' && previous.workspaceId === workspaceId && fly && fly.open) {
        if (typeof fns.assistantFlyWorkspaceDismiss === 'function') host.call('assistantFlyWorkspaceDismiss');
        fly = host.call('assistantFlySession', root);
    }
    const open = !!(fly && fly.open);
    // `seen`: the canvas has been on screen in this workspace and mode — from
    // then on only the person, or an ask, opens it again.
    const seen = same && !!previous.seen || open;
    host.__flyWorkspaceMountedFor = {
        workspaceId: workspaceId,
        mode: mode,
        seen: seen
    };
    if (!workspaceId || mode !== 'fly' || !available) return false;
    if (same) {
        // The same workspace and mode: only the first arrival on the home still
        // opens the canvas, and never over an open pane (an arrival asks nothing).
        if (seen || !home || root._canvasSlot || root._canvasSlotSecond) return false;
    } else {
        const state = root._aiFlyWorkspace;
        if (open && state && String(state.workspaceId) === String(workspaceId)) return false;
        // A load in Fly mode opens the canvas only on the workspace home: a
        // reload or a deep link to another route (/calendar, /crm) keeps that
        // page, and the canvas waits for the home or the next ask (Nika
        // 2026-10-18; QA saw a closed canvas come back over /calendar on every
        // reload). Choosing Fly in the mode menu still opens it anywhere —
        // setAssistantMode enters by itself.
        if (!home) return false;
    }
    const entered = host.call('assistantFlyWorkspaceEnter');
    if (entered) host.__flyWorkspaceMountedFor = {
        workspaceId: workspaceId,
        mode: mode,
        seen: true
    };
    return entered;
}
function $4b1258ec659bb7d2$export$92d3eda41912db05(root) {
    const r = root && typeof root === 'object' ? root : this.state && this.state.root || {};
    if (r.assistantMode !== 'fly') return false;
    if (r._canvasSlot || r._canvasSlotSecond) return false;
    if (!this.call('assistantFlyWorkspaceState', r)) return false;
    return !!this.call('assistantFlyShown', r);
}
function $4b1258ec659bb7d2$export$2b678c2a0803b14b(kind) {
    if (kind !== 'section') return false;
    const root = this.state && this.state.root;
    const state = this.call('assistantFlyWorkspaceState', root);
    if (!state || !root || root.assistantMode !== 'fly' || typeof root.update !== 'function') return false;
    root.update({
        _aiFlyWorkspace: {
            ...state,
            picker: kind,
            status: 'idle',
            error: null
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $4b1258ec659bb7d2$export$d23c2cc3cefa1334() {
    const root = this.state && this.state.root;
    const state = this.call('assistantFlyWorkspaceState', root);
    if (!state || !root || typeof root.update !== 'function') return false;
    root.update({
        _aiFlyWorkspace: {
            ...state,
            picker: null,
            status: 'idle',
            error: null,
            operationId: null,
            seq: (state.seq || 0) + 1
        }
    }, {
        preventFetch: true
    });
    return true;
}
function $4b1258ec659bb7d2$export$fd9ca10e57a4a346() {
    const root = this.state && this.state.root;
    if (!root || root.assistantMode !== 'fly' || typeof root.update !== 'function') return false;
    this.call('assistantFlyNew');
    return this.call('assistantFlyWorkspaceEnter');
}
function $4b1258ec659bb7d2$export$4e574bd7b125b4e6(opts) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const fns = this.context && this.context.functions || {};
    const path = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    const bare = typeof fns.stripWorkspacePrefix === 'function' ? this.call('stripWorkspacePrefix', path) : path;
    const home = typeof bare === 'string' && bare.split(/[?#]/)[0].replace(/\/+$/, '') === '';
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    const pane = !!(root._canvasSlot || root._canvasSlotSecond);
    const fly = !!workspaceId && !pane && root.assistantMode === 'fly' && (typeof fns.assistantFlyAvailable !== 'function' || !!this.call('assistantFlyAvailable', root));
    if (fly) {
        this.call('assistantFlyNew');
        this.call('assistantFlyWorkspaceEnter');
        if (!home) {
            const fresh = this.call('assistantFlySession', root);
            const state = root._aiFlyWorkspace;
            root.update({
                _aiFly: fresh ? {
                    ...fresh,
                    open: true,
                    path: '/'
                } : root._aiFly,
                _aiFlyWorkspace: state && String(state.workspaceId) === String(workspaceId) ? {
                    ...state,
                    originPath: '/'
                } : state
            }, {
                preventFetch: true
            });
        }
    }
    if (!home && !(opts && opts.navigate === false) && typeof this.router === 'function') this.router('/', typeof this.getRoot === 'function' ? this.getRoot() : this);
    return true;
}
function $4b1258ec659bb7d2$export$e849b90c756d9589(e) {
    if (e && (e.defaultPrevented || typeof e.button === 'number' && e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return false;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    return this.call('assistantFlyHomeFresh');
}
function $4b1258ec659bb7d2$export$977e8c7395825961(opts) {
    this.call('assistantFlyWorkspaceClose');
    return this.call('assistantFlyClose', opts);
}
function $4b1258ec659bb7d2$export$1b1503edf03ad184(root) {
    const state = this.call('assistantFlyWorkspaceState', root);
    if (!state) return [];
    const text = (value)=>this.call('polyglot', typeof value === 'string' ? value : '');
    const options = [];
    const seen = new Set();
    const vocab = this.call('boardVocabularyFor', root);
    const entries = vocab && vocab.widgets || {};
    for (const entry of Object.values(entries)){
        if (!entry || typeof entry.ref !== 'string' || seen.has(entry.ref)) continue;
        const result = this.call('validateBoardSpec', {
            v: 1,
            items: [
                {
                    kind: 'widget',
                    widget: entry.ref,
                    params: {}
                }
            ]
        }, vocab);
        // Required parameters without a valid default need an app-specific flow.
        // They cannot truthfully appear as one-click local sections.
        if (!result || result.dropped || result.items.length !== 1) continue;
        const app = vocab.apps && vocab.apps[entry.appId];
        seen.add(entry.ref);
        options.push({
            value: 'section:' + entry.ref,
            label: text(entry.title || entry.widgetId),
            // The section's app by its App Store name (installedAppName with the
            // vocabulary's `appKey` — Nika 2026-10-23: "app names = what a person
            // sees in the workspace App Store"), else the widget's own description.
            hint: app && app.label ? String(this.call('installedAppName', {
                appKey: app.appKey,
                label: app.label
            }) || text(app.label)) : text(entry.describe),
            icon: entry.icon || 'star'
        });
    }
    return options;
}
function $4b1258ec659bb7d2$export$377f42ddababcf3e(value) {
    const root = this.state && this.state.root;
    const state = this.call('assistantFlyWorkspaceState', root);
    if (!state || !root || root.assistantMode !== 'fly' || typeof root.update !== 'function') return false;
    const fail = (error)=>{
        root.update({
            _aiFlyWorkspace: {
                ...state,
                status: 'failed',
                error: error
            }
        }, {
            preventFetch: true
        });
        return false;
    };
    if (state.picker !== 'section') return false;
    const option = this.call('assistantFlyWorkspaceOptions', root).find((entry)=>entry.value === value);
    if (!option) return fail('unavailable');
    const fly = this.call('assistantFlySession', root);
    if (!fly || String(fly.workspaceId) !== state.workspaceId) return fail('unavailable');
    // All manual sections live on one ready local page. A streaming page's
    // indexed item frames can never overwrite the person's manual insertion.
    const pages = Array.isArray(fly.pages) ? fly.pages : [];
    const page = pages.find((item)=>item && /^fwl-/.test(item.key) && item.status === 'ready');
    if (page && page.save === 'saving') return fail('saving');
    if (!page && pages.length >= 20 || page && (page.items || []).length >= 12) return fail('limit');
    const item = {
        kind: 'widget',
        widget: option.value.slice(8),
        params: {}
    };
    const vocab = this.call('boardVocabularyFor', root);
    const check = this.call('validateBoardSpec', {
        v: 1,
        items: [
            item
        ]
    }, vocab);
    if (!check || check.dropped || check.items.length !== 1) return fail('unavailable');
    const valid = check.items[0];
    const before = this.call('validateBoardSpec', {
        v: 1,
        items: page && page.items || []
    }, vocab);
    if (before.items.some((entry)=>entry.key === valid.key)) return fail('duplicate');
    const raw = {
        kind: 'widget',
        widget: valid.ref,
        size: valid.size,
        params: valid.params
    };
    const derived = this.call('boardItemsFor', {
        v: 1,
        items: [
            raw
        ]
    }, root);
    if (!derived || derived.dropped || derived.items.length !== 1 || !derived.items[0].body) return fail('unavailable');
    const key = page ? page.key : 'fwl-' + Date.now().toString(36) + '-' + (state.seq || 0);
    const local = {
        ...page || {
            key: key,
            id: null,
            status: 'ready',
            phase: 'done',
            error: null,
            prompt: '',
            eyebrow: '',
            title: this.call('polyglot', 'shell.flyWorkspace.localTitle'),
            opening: '',
            followUps: [],
            fallback: false,
            at: Date.now(),
            ms: null
        },
        items: [
            ...page && page.items || [],
            raw
        ],
        save: null
    };
    root.update({
        _aiFly: {
            ...fly,
            open: true,
            focus: key,
            pages: page ? pages.map((entry)=>entry && entry.key === key ? local : entry) : [
                ...pages,
                local
            ]
        },
        _aiFlyWorkspace: {
            ...state,
            picker: null,
            status: 'added',
            error: null,
            seq: (state.seq || 0) + 1
        }
    }, {
        preventFetch: true
    });
    const fns = this.context && this.context.functions || {};
    if (typeof fns.assistantFlyPersist === 'function') this.call('assistantFlyPersist', root);
    return true;
}
function $4b1258ec659bb7d2$export$f71927a1d6bb64ff(root) {
    const state = this.call('assistantFlyWorkspaceState', root);
    const fly = this.call('assistantFlySession', root);
    if (!state || !state.returnPending || !fly || !fly.open || root.assistantMode !== 'fly') return false;
    return !!(root._canvasSlot || root._canvasSlotSecond) || !this.call('assistantFlyShown', root);
}
function $4b1258ec659bb7d2$export$334325e8b338f5e9(pageKey, itemKey) {
    const root = this.state && this.state.root;
    const state = this.call('assistantFlyWorkspaceState', root);
    const fly = this.call('assistantFlySession', root);
    if (!state || !fly || root.assistantMode !== 'fly' || typeof root.update !== 'function') return false;
    const pages = Array.isArray(fly.pages) ? fly.pages : [];
    const page = pages.find((entry)=>entry && entry.key === pageKey);
    if (!page || !/^fwl-/.test(page.key) || page.status !== 'ready') return false;
    if (page.save === 'saving') {
        root.update({
            _aiFlyWorkspace: {
                ...state,
                status: 'failed',
                error: 'saving'
            }
        }, {
            preventFetch: true
        });
        return false;
    }
    const vocab = this.call('boardVocabularyFor', root);
    const checked = this.call('validateBoardSpec', {
        v: 1,
        items: page.items
    }, vocab);
    const item = checked.items.find((entry)=>page.key + '-' + entry.key === itemKey);
    if (!item) return false;
    const items = page.items.filter((raw)=>{
        const result = this.call('validateBoardSpec', {
            v: 1,
            items: [
                raw
            ]
        }, vocab);
        return !result.items.some((entry)=>entry.key === item.key);
    });
    const next = items.length ? pages.map((entry)=>entry === page ? {
            ...page,
            items: items,
            save: null
        } : entry) : pages.filter((entry)=>entry !== page);
    root.update({
        _aiFly: {
            ...fly,
            pages: next,
            focus: !items.length && fly.focus === page.key ? (next[next.length - 1] || {}).key || null : fly.focus
        },
        _aiFlyWorkspace: {
            ...state,
            status: 'idle',
            error: null,
            seq: (state.seq || 0) + 1
        }
    }, {
        preventFetch: true
    });
    const fns = this.context && this.context.functions || {};
    if (typeof fns.assistantFlyPersist === 'function') this.call('assistantFlyPersist', root);
    return true;
}
function $4b1258ec659bb7d2$export$5567b1a782dbb769() {
    const root = this.state && this.state.root;
    const state = this.call('assistantFlyWorkspaceState', root);
    const fly = this.call('assistantFlySession', root);
    if (!state || !fly || !fly.open || root.assistantMode !== 'fly' || String(fly.workspaceId) !== state.workspaceId || !root.update) return false;
    const path = state.originPath || fly.path;
    if (typeof path !== 'string' || !/^\/(?!\/)[^\s\\]*$/.test(path)) return false;
    const seq = (state.seq || 0) + 1;
    const operationId = crypto.randomUUID();
    const slots = [
        root._canvasSlot || null,
        root._canvasSlotSecond || null
    ];
    const hosts = root.__slotLiveHosts || {};
    const liveHosts = [
        hosts._canvasSlot,
        hosts._canvasSlotSecond
    ];
    const fromPath = root.currentPath;
    root.update({
        _aiFlyWorkspace: {
            ...state,
            picker: null,
            status: 'returning',
            error: null,
            operationId: operationId,
            seq: seq
        }
    }, {
        preventFetch: true
    });
    const current = ()=>{
        const live = this.call('assistantFlyWorkspaceState', root);
        const session = this.call('assistantFlySession', root);
        return live && root.assistantMode === 'fly' && session && session.open && live.workspaceId === state.workspaceId && live.operationId === operationId && live.seq === seq ? live : null;
    };
    const cancel = (error)=>{
        const live = current();
        if (!live) return false;
        root.update({
            _aiFlyWorkspace: {
                ...live,
                status: error ? 'failed' : 'idle',
                error: error || null
            }
        }, {
            preventFetch: true
        });
        return false;
    };
    const finish = ()=>{
        const live = current();
        if (!live) return false;
        if (root.currentPath !== fromPath || (root._canvasSlot || null) !== slots[0] || (root._canvasSlotSecond || null) !== slots[1]) return cancel('changed');
        const restore = ()=>{
            const latest = current();
            const session = this.call('assistantFlySession', root);
            if (!latest || !session || String(session.workspaceId) !== state.workspaceId) return false;
            const latestHosts = root.__slotLiveHosts || {};
            if ((root._canvasSlot || null) !== slots[0] || (root._canvasSlotSecond || null) !== slots[1] || latestHosts._canvasSlot !== liveHosts[0] || latestHosts._canvasSlotSecond !== liveHosts[1] || session.path !== fly.path || session.focus !== fly.focus) return cancel('changed');
            // The guarded close mirrors PageSlot's close reset. Suppress its one-shot
            // immersive landing reopen, because Fly is the destination of this close.
            if (root._canvasSlot) root._slotSkipReopenOnce = true;
            root.update({
                _canvasSlot: null,
                _canvasSlotSecond: null,
                _slotFullscreen: null,
                _slotHistSecond: null,
                _slotRailPrimary: false,
                _slotRailSecond: false,
                _slotPinned: null,
                _slotSplitIntent: false,
                _aiFly: {
                    ...session,
                    open: true,
                    path: path,
                    focus: state.originFocus || session.focus
                },
                _aiFlyWorkspace: {
                    ...latest,
                    returnPending: false,
                    status: 'idle',
                    error: null
                }
            }, {
                preventFetch: true
            });
            return true;
        };
        try {
            if (root.currentPath !== path) {
                const moved = this.router(path, this.getRoot());
                if (moved && typeof moved.then === 'function') return moved.then((ok)=>ok === false ? cancel() : root.currentPath === path ? restore() : cancel('navigation'), ()=>cancel('navigation'));
                if (moved === false || root.currentPath !== path) return cancel('navigation');
            }
            return restore();
        } catch (_) {
            return cancel('navigation');
        }
    };
    const fns = this.context && this.context.functions || {};
    let dirty = false;
    try {
        dirty = typeof fns.hasUnsavedInput === 'function' && (slots[0] && this.call('hasUnsavedInput', hosts._canvasSlot) || slots[1] && this.call('hasUnsavedInput', hosts._canvasSlotSecond) || root.currentPath !== path && this.call('hasUnsavedInput', this.getRoot()));
    } catch (_) {
        dirty = true;
    }
    if (!dirty) return finish();
    if (typeof fns.confirmDiscardChanges !== 'function') return cancel('navigation');
    return new Promise((resolve)=>{
        this.call('confirmDiscardChanges', {
            onDiscard: ()=>resolve(finish()),
            onKeep: ()=>resolve(cancel())
        });
    });
}

});

parcelRegister("grJbt", function(module, exports) {

$parcel$export(module.exports, "assistantFlyOnHome", () => $bf923791560e3b89$export$fcaa17642d9c8606);
$parcel$export(module.exports, "assistantFlyTourOffered", () => $bf923791560e3b89$export$2719634163ee51d0);
$parcel$export(module.exports, "assistantFlyStartShown", () => $bf923791560e3b89$export$5a3065d8658a4070);
$parcel$export(module.exports, "assistantFlyStartTiles", () => $bf923791560e3b89$export$14e9a61e6b6aae0b);
$parcel$export(module.exports, "assistantFlyStartAsk", () => $bf923791560e3b89$export$e4e48c796813dff8);
$parcel$export(module.exports, "assistantFlyStartRecent", () => $bf923791560e3b89$export$9fa18d03975a845);
$parcel$export(module.exports, "assistantFlyStartNext", () => $bf923791560e3b89$export$d61e277bf24c5f04);
$parcel$export(module.exports, "assistantFlyStartNextCollect", () => $bf923791560e3b89$export$fa15802f401e2f9);
$parcel$export(module.exports, "assistantFlyStartEventOpen", () => $bf923791560e3b89$export$ff8cbe4be0e0e828);
$parcel$export(module.exports, "assistantFlyStartLabel", () => $bf923791560e3b89$export$5cdbcd99f9e3ab61);
$parcel$export(module.exports, "assistantFlyStartTracks", () => $bf923791560e3b89$export$d9fba96df6b4f018);
$parcel$export(module.exports, "assistantFlyStartGreeting", () => $bf923791560e3b89$export$31895efe23c33946);
$parcel$export(module.exports, "assistantFlyStartCalm", () => $bf923791560e3b89$export$e29b9aabd58a2354);
$parcel$export(module.exports, "assistantFlyStartPrime", () => $bf923791560e3b89$export$383630845dfac97f);
// assistantFlyStart.js — FLY'S FIRST SCREEN, made from each workspace.
//
// Nika 2026-10-22: "give fly initial screen to start from based on each
// workspace". Before this an empty Fly canvas said one line — "Open an app,
// add a section, or ask for a page." — the same in every workspace. Now it
// opens the way keepz--fly does (the reference product, docs/FLY_MODE.md): a
// headline that names THIS workspace, then up to six tiles, each a page one
// tap away (components/AssistantFlyView.js AssistantFlyStart).
//
// THE TILES come from the workspace's own data — nothing here names a tenant
// and nothing is written per workspace by hand:
//
//   FIGURE tiles  what needs the person, live: the home's signals
//                 (HOME_SIGNALS_CONTRACT v1, functions/homeSignals.js — the
//                 installed apps' own `homeSignals` providers and the built-in
//                 tasks / calendar / mail ones; counts only). The signals of
//                 one app and one KIND make ONE tile: the first one's count
//                 and words, "+n more", the app's name, and the kind's ask
//                 ("CRM: what is overdue?"). The page is asked with every
//                 signal of the group as its facts.
//   ASK tiles     this workspace's starters (functions/assistantStarters.js
//                 workspaceStarters): the generated set written for THIS
//                 workspace in its language, else the built set — the
//                 installed apps' own manifest starters first, one ask per
//                 app it shows, the generic staple last.
//
// Figures first (at most three), the asks after them; the first tile is the
// large one. As many as fill whole rows on the dashboard's columns
// (assistantFlyStartTracks): six on three tracks and on a phone, 2 × tracks − 3
// from four tracks up (the large tile's two rows beside it). Until the first
// signals pass has answered (≤ 800 ms, homeSignalsTick's budget) the slots
// hold skeletons, so a figure landing late never reorders tiles a person is
// aiming at (Rule 66). A tile asks the way a page's next-ask chip does
// (assistantFlyAsk); a starter that carries a `localAction` runs it, as it
// does in the chat.
//
// THE TOUR (Nika 2026-10-28: "take me to symbols tour … also add it in
// recommended options"): where the shell runs the quick tour
// (assistantFlyTourOffered), the LAST tile is "Take the tour" — its press
// runs aiStartTour (the home, then the stops), never a page ask. It takes
// the last slot, so the asks keep every slot before it.
//
// THE SUMMARY FIRST (Nika 2026-10-22: "fly should first show current summary
// when its empty on each workspace according to their data"): above the tiles
// the screen says where this workspace stands — the home's greeting
// (assistantFlyStartGreeting) and the dashboard's own summary (components/
// HomeTopSummary.js HomeSummaryBrief over functions/homeSummaryCompose.js: the
// same signals, its AI sentences or its template, the same Updated and
// Refresh), or one calm line when nothing needs the person
// (assistantFlyStartCalm).
//
// FRANK: every export is self-contained — no import, no module constant, no
// bare sibling call (`this.call`). `this` is the calling element.
// The canvas an element sits in is the HOME's (pages/main.js mounts it in the
// grid area), not the page layer's over another route (components/
// AssistantMainLayer.js, `mainHost: 'over'`). Read from the tree, once — the
// host of a mounted view never changes.
const $bf923791560e3b89$export$fcaa17642d9c8606 = function assistantFlyOnHome(el) {
    let node = el || this;
    for(let i = 0; node && i < 16; i++){
        if (node.key === 'AssistantFlyView') return node.mainHost !== 'over';
        node = node.parent;
    }
    return false;
};
const $bf923791560e3b89$export$2719634163ee51d0 = function assistantFlyTourOffered() {
    const fns = this && this.context && this.context.functions || {};
    return typeof fns.aiStartTour === 'function' && typeof fns.onboardingTourStart === 'function';
};
const $bf923791560e3b89$export$5a3065d8658a4070 = function assistantFlyStartShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const shown = !!this.call('assistantFlyShown', r);
    const page = this.call('assistantFlyPage', r);
    return shown && !page;
};
const $bf923791560e3b89$export$14e9a61e6b6aae0b = function assistantFlyStartTiles(root, tracks) {
    const r = root && typeof root === 'object' ? root : {};
    // Whole rows on the tracks the screen has: six on three (and on a phone),
    // the large tile's two rows filled beside it from four tracks up.
    const n = Math.min(6, Math.max(3, Math.floor(Number(tracks)) || 3));
    const MAX = n >= 4 ? 2 * n - 3 : 6;
    const MAX_FIGURES = 3;
    // A kind's ask — every key written out (the i18n gate reads literals);
    // 'new' is the built set's own "{app}: what is new?".
    const ASK = {
        overdue: 'workspace.flyStart.ask.overdue',
        dueToday: 'workspace.flyStart.ask.dueToday',
        upcoming: 'workspace.flyStart.ask.upcoming',
        waiting: 'workspace.flyStart.ask.waiting',
        new: 'workspace.aiStarter.app.whatsNew',
        risk: 'workspace.flyStart.ask.risk'
    };
    const ws = r.workspace;
    const workspaceId = ws && String(ws.id || ws._id || '') || '';
    const st = r._homeSignals;
    if (!workspaceId) return [];
    const word = (key)=>{
        const v = this.call('polyglot', key);
        return v == null ? '' : String(v);
    };
    const blank = {
        key: '',
        kind: 'ask',
        hero: false,
        text: '',
        prompt: '',
        count: '',
        words: '',
        severity: '',
        signal: '',
        app: '',
        icon: 'magicstar',
        more: '',
        localAction: '',
        form: '',
        // the app an ask is pinned to (assistantStarters.js generatedStarterRows):
        // its route, its name, a built app's project id — assistantFlyStartAsk
        route: '',
        appName: '',
        appId: '',
        span: 1,
        tall: false
    };
    // Keys are element keys: letters and digits only, never an HTML tag name.
    const safe = (v)=>String(v == null ? '' : v).replace(/[^A-Za-z0-9]+/g, '');
    // WHOLE ROWS, NEVER A HOLE: fewer tiles than the rows hold (the dashboard's
    // six tracks, eight tiles) left an empty slot at the end. The large tile is
    // two rows tall only when the others fill its first row beside it, and the
    // LAST tile spans the cells its row has left (`span`); a lone large tile
    // takes the whole row. A phone's two tracks are the tile grid's own rule.
    const shape = (list)=>{
        const c = list.length;
        const rest = c - 1;
        const tall = rest > n - 2;
        const cells = (tall ? 4 : 2) + rest;
        const rows = Math.max(tall ? 2 : 1, Math.ceil(cells / n));
        const hole = rows * n - cells;
        return list.map((t, i)=>({
                ...t,
                hero: i === 0,
                tall: i === 0 && tall,
                span: i === 0 ? c === 1 ? n : 2 : i === c - 1 && hole > 0 && hole < n ? 1 + hole : 1
            }));
    };
    const pending = !st || typeof st !== 'object' || String(st.ws) !== workspaceId || !st.windowAt;
    if (pending) return shape(Array.from({
        length: MAX
    }, (_, i)=>({
            ...blank,
            key: 'flyStartSkeleton' + i,
            kind: 'skeleton'
        })));
    // The app a signal belongs to, by its list's route: the launcher's own
    // tiles (assistantStarters.js visibleStarterTiles — the flag / access gate
    // already applied). Its name, or the workspace's when no tile matches.
    const tiles = this.call('visibleStarterTiles', r) || [];
    const scope = String(this.call('assistantScopeName', r) || '');
    const appOf = (sig)=>{
        const href = typeof sig.href === 'string' ? sig.href : '';
        const seg = href.split(/[?#]/)[0].split('/').filter(Boolean)[0] || '';
        const route = seg ? '/' + seg : '';
        const tile = tiles.find((t)=>t && t.route === route) || null;
        // An installed app's tile (it carries `appKey`) by its App Store name,
        // through installedAppName (Nika 2026-10-23: "app names = what a person
        // sees in the workspace App Store") — "Insights: what is overdue?", never
        // the manifest's "Analytics". A house tile's key and a customer's own
        // words read through polyglot, as before.
        const named = tile && tile.appKey ? String(this.call('installedAppName', {
            appKey: tile.appKey,
            title: tile.title
        }) || '') : '';
        return {
            name: tile ? named || word(tile.title) || String(tile.title || '') : '',
            icon: tile && tile.icon ? tile.icon : 'magicstar'
        };
    };
    const out = [];
    const seenAsk = new Set();
    // FIGURES — one tile per app × kind, in the signals' own order (severity,
    // then count, then the App strip's order).
    const view = this.call('homeSignalsView', r) || {};
    const list = Array.isArray(view.list) ? view.list : [];
    const groups = [];
    for (const sig of list){
        if (!sig || !ASK[sig.kind]) continue;
        const id = sig.app + '|' + sig.kind;
        const at = groups.find((g)=>g.id === id);
        if (at) at.signals.push(sig);
        else groups.push({
            id: id,
            signals: [
                sig
            ]
        });
    }
    for (const g of groups.slice(0, MAX_FIGURES)){
        const top = g.signals[0];
        const app = appOf(top);
        // The ask names the app, else the workspace; with neither it would read
        // ": what is overdue?" — that figure waits for a name instead.
        const named = app.name || scope;
        if (!named) continue;
        const text = word(ASK[top.kind]).replace('{app}', named);
        const facts = g.signals.map((x)=>String(this.call('homeSignalsText', x) || '')).join(" \xb7 ");
        const more = g.signals.length > 1 ? word('workspace.flyStart.more').replace('{n}', String(g.signals.length - 1)) : '';
        seenAsk.add(text.trim().toLowerCase());
        out.push({
            ...blank,
            key: 'flyStartSignal' + safe(g.id),
            kind: 'figure',
            text: text,
            prompt: facts ? text + ' (' + facts + ')' : text,
            count: String(top.count),
            words: String(this.call('homeSignalsText', top, {
                bare: true
            }) || ''),
            severity: top.severity || 'info',
            signal: top.id || '',
            app: app.name,
            icon: this.call('homeSignalIcon', top) || 'magicstar',
            more: more
        });
    }
    // ASKS — this workspace's starters, the ones a figure already asks left out
    // (the last slot kept for the tour where the shell runs it).
    const tour = !!this.call('assistantFlyTourOffered');
    const room = tour ? MAX - 1 : MAX;
    const rows = this.call('workspaceStarters', r) || [];
    for (const row of rows){
        if (out.length >= room) break;
        const text = String(row && row.text || '').trim();
        if (!text || seenAsk.has(text.toLowerCase())) continue;
        seenAsk.add(text.toLowerCase());
        out.push({
            ...blank,
            key: 'flyStartAsk' + safe(row.key || text),
            kind: 'ask',
            text: text,
            prompt: String(row.prompt || text),
            app: String(row.caption || ''),
            icon: row.icon || 'magicstar',
            localAction: typeof row.localAction === 'string' ? row.localAction : '',
            // a starter that opens an app's own form (assistantStarterForm)
            form: typeof row.form === 'string' ? row.form : '',
            route: typeof row.route === 'string' ? row.route : '',
            appName: typeof row.appName === 'string' ? row.appName : '',
            appId: typeof row.appId === 'string' ? row.appId : ''
        });
    }
    // THE TOUR — the onboarding's own words: "Take the tour", "Tour" beside its
    // glyph, the one-minute hint on hover; its press runs aiStartTour.
    if (tour) out.push({
        ...blank,
        key: 'flyStartTour',
        kind: 'ask',
        text: word('workspace.onboarding.replayTour'),
        prompt: word('workspace.onboarding.wayTourHint'),
        app: word('workspace.onboarding.tour.endEyebrow'),
        icon: 'playOval',
        localAction: 'aiStartTour'
    });
    return shape(out.slice(0, MAX));
};
const $bf923791560e3b89$export$e4e48c796813dff8 = function assistantFlyStartAsk(s) {
    const tile = s && typeof s.parse === 'function' ? s.parse() : s;
    if (!tile || typeof tile !== 'object' || tile.kind === 'skeleton') return null;
    const fns = this.context && this.context.functions || {};
    if (tile.localAction && typeof fns[tile.localAction] === 'function') // the tile rides along (assistantStarterForm reads its `form`)
    return this.call(tile.localAction, tile);
    const prompt = String(tile.prompt || tile.text || '').trim();
    if (!prompt) return null;
    const route = typeof tile.route === 'string' ? tile.route : '';
    const id = typeof tile.appId === 'string' ? tile.appId : '';
    const name = typeof tile.appName === 'string' ? tile.appName.trim() : '';
    if (!id || !name || !/^\/x\/[^/?#]+/.test(route)) return this.call('assistantFlyAsk', prompt);
    return this.call('assistantFlyAsk', {
        prompt: prompt,
        aiScope: {
            kind: 'app',
            label: name,
            route: route,
            app: {
                id: id,
                name: name,
                route: route
            }
        }
    });
};
const $bf923791560e3b89$export$9fa18d03975a845 = function assistantFlyStartRecent(root) {
    const fly = this.call('assistantFlySession', root);
    const list = fly && Array.isArray(fly.recent) ? fly.recent : [];
    return list.filter((p)=>p && typeof p.prompt === 'string' && p.prompt.trim()).slice(0, 6).map((p, i)=>({
            key: 'recent-' + i,
            kind: 'ask',
            prompt: p.prompt,
            title: String(p.title || p.prompt),
            at: Number(p.at) || 0
        }));
};
const $bf923791560e3b89$export$d61e277bf24c5f04 = function assistantFlyStartNext(root, limit, upcoming) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this && this.context && this.context.functions || {};
    if (typeof fns.homeNextUpItems !== 'function') return [];
    const want = Math.floor(Number(limit));
    const max = want > 0 ? Math.min(want, 6) : 3;
    const now = Date.now();
    const pass = upcoming && typeof upcoming === 'object' ? upcoming : null;
    const items = this.call('homeNextUpItems', r, now, pass) || [];
    return items.slice(0, max).map((x, i)=>{
        const event = x.event || null;
        const hero = this.call('homeNextUpHero', x, now) || {};
        const action = this.call('homeNextUpAction', x) || {};
        const time = String(this.call('homeNextUpTime', x) || '');
        const place = !event && typeof x.place === 'string' ? x.place.trim() : '';
        return {
            key: 'next-' + String(x.key || i).replace(/[^A-Za-z0-9_-]/g, '_'),
            // every key a value (a row's empty key would read the root's)
            eventId: event ? String(event.id || '') : '',
            href: !event && typeof x.href === 'string' ? x.href : '',
            app: !event && typeof x.app === 'string' ? x.app : '',
            title: String(x.title || ''),
            when: [
                hero.before,
                hero.value,
                hero.after
            ].filter(Boolean).join(' '),
            time: place ? time ? time + " \xb7 " + place : place : time,
            label: String(action.label || 'common.action.open'),
            call: String(action.call || (event ? 'openEventDetailModal' : 'homeNextUpOpen'))
        };
    });
};
const $bf923791560e3b89$export$fa15802f401e2f9 = function assistantFlyStartNextCollect(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    if (!host || typeof host.call !== 'function' || !root) return false;
    if (!host.call('assistantFlyStartShown', root)) return false;
    const fns = host.context && host.context.functions || {};
    if (typeof fns.homeNextUpCollect !== 'function') return false;
    host.call('homeNextUpCollect');
    return true;
};
const $bf923791560e3b89$export$ff8cbe4be0e0e828 = function assistantFlyStartEventOpen(s) {
    const row = s && typeof s.parse === 'function' ? s.parse() : s;
    const root = this.state && this.state.root;
    if (!row || !row.call || !root) return false;
    if (row.eventId) {
        const list = Array.isArray(root.intranetEvents) ? root.intranetEvents : [];
        const event = list.find((e)=>e && String(e.id) === String(row.eventId));
        if (!event) return false;
        this.call(row.call, event);
        return true;
    }
    if (row.href) {
        this.call('homeNextUpOpen', {
            href: row.href,
            app: row.app || '',
            title: row.title || ''
        });
        return true;
    }
    return false;
};
const $bf923791560e3b89$export$5cdbcd99f9e3ab61 = function assistantFlyStartLabel(s) {
    if (!s || typeof s !== 'object' || s.kind === 'skeleton') return '';
    const SEVERITY = {
        urgent: 'workspace.home.signals.urgent',
        attention: 'workspace.home.signals.attention'
    };
    const parts = [];
    if (s.kind === 'figure') {
        if (SEVERITY[s.severity]) parts.push(String(this.call('polyglot', SEVERITY[s.severity])));
        if (s.count) parts.push(s.count + ' ' + (s.words || ''));
    }
    if (s.app) parts.push(s.app);
    if (s.text) parts.push(s.text);
    return parts.join(" \u2014 ");
};
const $bf923791560e3b89$export$d9fba96df6b4f018 = function assistantFlyStartTracks(s) {
    const cols = Math.floor(Number(s && s.cols)) || 0;
    return Math.min(6, Math.max(3, cols || 3));
};
const $bf923791560e3b89$export$31895efe23c33946 = function assistantFlyStartGreeting(s, now) {
    const at = new Date(Number(now) || Date.now());
    const hour = at.getHours();
    let person = null;
    try {
        person = this.call('findMe', s);
    } catch (_) {
        person = null;
    }
    const name = String(person && person.name || '').trim().split(/\s+/)[0] || '';
    const has = !!name;
    // Literal keys only (docs/I18N-CONVENTION.md: a key is never built).
    const key = hour >= 5 && hour < 12 ? has ? 'workspace.home.greet.morning' : 'workspace.home.greet.morningNoName' : hour >= 12 && hour < 18 ? has ? 'workspace.home.greet.afternoon' : 'workspace.home.greet.afternoonNoName' : hour >= 18 && hour < 22 ? has ? 'workspace.home.greet.evening' : 'workspace.home.greet.eveningNoName' : has ? 'workspace.home.greet.night' : 'workspace.home.greet.nightNoName';
    const lead = this.call('polyglot', key);
    return {
        lead: lead == null ? '' : String(lead),
        name: name
    };
};
const $bf923791560e3b89$export$e29b9aabd58a2354 = function assistantFlyStartCalm(root) {
    const status = (this.call('homeSummaryCompose', root) || {}).status;
    const KEYS = {
        nothing: 'workspace.home.summary.none',
        unavailable: 'workspace.activation.partialTitle'
    };
    if (!Object.prototype.hasOwnProperty.call(KEYS, status)) return '';
    const words = this.call('polyglot', KEYS[status]);
    return words == null ? '' : String(words);
};
const $bf923791560e3b89$export$383630845dfac97f = function assistantFlyStartPrime(root) {
    const r = root || this.state && this.state.root;
    if (!r || typeof r !== 'object') return false;
    // Only for a start screen on screen: it stays mounted, hidden, on every
    // home, and a hidden one must never spend a model call.
    if (!this.call('assistantFlyStartShown', r)) return false;
    const fns = this.context && this.context.functions || {};
    if (typeof fns.homeSignalsTick === 'function') Promise.resolve().then(()=>this.call('homeSignalsTick', r)).catch((err)=>console.warn('[fly] start signals pass failed:', err && err.message));
    if (typeof fns.ensureWorkspaceStarters === 'function') Promise.resolve().then(()=>this.call('ensureWorkspaceStarters', r, {
            surface: 'fly'
        })).catch((err)=>console.warn('[fly] start starters failed:', err && err.message));
    return true;
};

});

parcelRegister("3DPx5", function(module, exports) {

$parcel$export(module.exports, "assistantFlyFollowChips", () => $2a6cfcf40094152c$export$52503985d5ae0bb5);
$parcel$export(module.exports, "assistantFlyFollowPress", () => $2a6cfcf40094152c$export$51bf8421c8780d17);
// assistantFlyFollow.js — A FLY PAGE'S NEXT ASKS, and the tour among them.
//
// A page's follow-ups (server ai-boards flySchema.normalizeFollowUps) are next
// asks `{ label, prompt }` — one tap is the next page — and, for a shell that
// runs the quick tour (`capabilities.tour`), the tour itself
// `{ label, action: 'tour' }` on a page about what Symbols is, how the
// workspace works or where to start (Nika 2026-10-28: "if we ask what is
// symbols - this could be offering"). The tour chip RUNS the tour
// (aiStartTour: the home, then the stops) — it is never asked as text.
//
// components/AssistantFlyView.js FlyFollow draws the rows; the row shows only
// with a chip in it.
//
// FRANK: every export is self-contained — no import, no module constant, no
// bare sibling call (`this.call`). `this` is the calling element.
// The chip rows of a page (its state `s`: the canvas's page, or a call's).
// Only a ready page has them. Every row carries EVERY key the chip reads (a
// childrenAs-'state' child falls back to ROOT state for a key it lacks):
//   key        'next' + the follow-up's place (stable while the page stands)
//   label      the ask's words; the tour chip says the onboarding's own
//              "Take the tour" in the member's language
//   prompt     the ask ('' on the tour chip)
//   action     'tour' on the tour chip, else ''
//   source     where the page lives ('session' | 'call'): its ask goes there
//   agentKey, agentName   a call's agent
// The tour chip shows only where the shell runs the tour, never on a call's
// page (the call shows the page to every member; the tour is one person's).
// Fields are read straight off the state, never through `.parse()` (a parse
// peeks: the row's reactive caller would subscribe to nothing).
const $2a6cfcf40094152c$export$52503985d5ae0bb5 = function assistantFlyFollowChips(s) {
    if (!s || typeof s !== 'object' || s.status !== 'ready') return [];
    const list = s.followUps;
    const n = list && typeof list.length === 'number' ? list.length : 0;
    const source = s.source || 'session';
    const tour = source !== 'call' && !!this.call('assistantFlyTourOffered');
    const out = [];
    for(let i = 0; i < n && out.length < 4; i++){
        const f = list[i];
        if (!f || typeof f !== 'object') continue;
        if (f.action === 'tour') {
            if (!tour) continue;
            const words = this.call('polyglot', 'workspace.onboarding.replayTour');
            out.push({
                key: 'next' + i,
                label: String(words || f.label || ''),
                prompt: '',
                action: 'tour',
                source: source,
                agentKey: null,
                agentName: null
            });
            continue;
        }
        if (!f.label || !f.prompt) continue;
        out.push({
            key: 'next' + i,
            label: String(f.label),
            prompt: String(f.prompt),
            action: '',
            source: source,
            agentKey: s.agentKey || null,
            agentName: s.agentName || null
        });
    }
    return out;
};
const $2a6cfcf40094152c$export$51bf8421c8780d17 = function assistantFlyFollowPress(s) {
    if (!s || typeof s !== 'object') return null;
    if (s.action === 'tour') {
        if (s.source === 'call' || !this.call('assistantFlyTourOffered')) return null;
        return this.call('aiStartTour');
    }
    if (!s.prompt) return null;
    return this.call('assistantFlyPageAct', s, 'ask', {
        prompt: s.prompt
    });
};

});

parcelRegister("j2K1B", function(module, exports) {

$parcel$export(module.exports, "assistantFlyFirstRunRead", () => $ddd1e7cc62b8d081$export$a5e1cf3926cd1fc1);
$parcel$export(module.exports, "assistantFlyFirstRunPrime", () => $ddd1e7cc62b8d081$export$3f03bdd238fb2b5b);
$parcel$export(module.exports, "assistantFlyFirstRunView", () => $ddd1e7cc62b8d081$export$a33d160e5c2dc4b2);
$parcel$export(module.exports, "assistantFlyFirstRunSites", () => $ddd1e7cc62b8d081$export$c7c3140c40ffdae1);
$parcel$export(module.exports, "assistantFlyFirstRunOpen", () => $ddd1e7cc62b8d081$export$e06f4fc8acf36c3);
$parcel$export(module.exports, "assistantFlyFirstRunDismiss", () => $ddd1e7cc62b8d081$export$da02180f0472d6ec);
// assistantFlyFirstRun.js — A NEW WORKSPACE'S FIRST RUN, on the Fly start
// screen (fly docs/FUNNEL.md §4 G5; Nika 2026-10-24: a workspace is ACTIVATED
// when, within 7 days, ANY of four happens — a teammate invited, 5+ records
// created in the workspace's apps, the website published, 3+ workspace AI
// asks).
//
// ONE calm block, "Get started", the start screen's last part (components/
// AssistantFlyFirstRun.js): four steps that mirror the rule, each with its
// live progress, its done state and ONE action that opens the real place —
//
//   invite   the invite panel (InviteDropdown, the header's own)
//   records  the workspace's first app (the launcher's own tiles), else /apps
//   publish  the workspace's website project (the app split's one classifier),
//            else the Websites view
//   ask      the shell's composer
//
// It folds away when the workspace is activated or the person hides it (per
// person, per workspace: `user_preferences.firstRunDismissed[<workspaceId>]`).
// It is never a modal and never covers a page: it lives inside the start
// screen, which a `?fly=` page replaces on arrival.
//
// THE DATA IS THE SERVER'S. One read, through the SDK only (lane G1, sdk
// 1adab22): `sdk.getService('growth').activation(workspaceId)` → GET
// /core/workspaces/:workspaceId/activation — any member of the workspace; the
// server's evaluateActivation, the SAME function as the funnel's F8. The answer
// (the SDK's _call returns the `data` of `{ success, data }`):
//   { workspaceId, since, windowEndsAt, activated, activatedAt, activatedBy,
//     activationDays, steps: { invited, records: { count, needed },
//                              sitePublished, aiAsks: { count, needed } } }
// The client computes nothing of the rule: the window (`windowEndsAt`, the
// workspace's creation + 7 days), every count and its bar (`needed`; the
// server saturates `count` at it), `invited`, `sitePublished` and `activated`
// are the answer's (assistantFlyFirstRunView reads them). A counted step is
// done when the server's count stands at the server's bar.
//
// FEATURE-DETECTED. Until the shell's SDK has the read (the release manager's
// SDK release that carries sdk 1adab22), `getService('growth')` refuses (no
// such service) or the service has no `activation`: no request, no block — the
// start screen is exactly what it was. A null client, a failed read, a 403 or
// a 404 hide it the same way (a failure is asked again after five minutes).
//
// Arriving from Fly (`user_preferences.onboarding.via === 'fly'` — or
// `origin === 'fly'` once the tour was taken from the ready screen — written by
// Make it real on fly.symbols.app, fly docs/SYMBOLS.md §5): the shell's full
// welcome stays closed (functions/onboarding.js: a Fly record is a decision,
// or — while it is `pending` — owes the ONE ready screen of
// functions/onboardingReady.js), and the block says what Fly already made —
// "Fly set up <ws> with you", "Your apps are ready", "Your website project is
// ready — publish it" — instead of asking for it again.
//
// FRANK: every export is self-contained — no import, no module constant, no
// bare sibling call (`this.call`). `this` is the calling element.
// THE READ — asked while the start screen shows (the block's own onRender and
// stateDeps), at most once a minute per workspace (five minutes after a
// failure); `opts.force` asks again at once (the invite panel closed). One read
// in flight per workspace; an answer for a workspace that is no longer active
// drops itself. → a promise of the stored entry (null when nothing was asked).
//   root._flyFirstRun = { ws, status: 'ok' | 'error', at, data, code, wasOpen }
// `wasOpen`: an earlier answer of this page said the steps are open — so an
// activation that lands now shows its done state instead of vanishing under
// the person's eyes (Rule 66); on the next load an activated workspace shows
// nothing.
function $ddd1e7cc62b8d081$export$a5e1cf3926cd1fc1(root, opts) {
    const OK_MS = 60000;
    const FAIL_MS = 300000;
    const o = opts && typeof opts === 'object' ? opts : {};
    const r = root || this && this.state && this.state.root || null;
    if (!r || typeof r !== 'object' || typeof r.update !== 'function') return Promise.resolve(null);
    const wsOf = (x)=>{
        const w = x && x.workspace;
        return String(w && (w.id || w._id) || '');
    };
    const wsId = wsOf(r);
    if (!wsId || !r.workspaceReady) return Promise.resolve(null);
    let sdk = o.sdk || this && this.sdk || null;
    if (!sdk && this && typeof this.call === 'function') try {
        const fns = this.context && this.context.functions || {};
        sdk = typeof fns.getSDK === 'function' ? this.call('getSDK') : null;
    } catch (_) {
        sdk = null;
    }
    if (!sdk || sdk.isNullClient === true || typeof sdk.getService !== 'function') return Promise.resolve(null);
    const now = Date.now();
    const cur = r._flyFirstRun && typeof r._flyFirstRun === 'object' ? r._flyFirstRun : null;
    if (!o.force && cur && cur.ws === wsId && cur.at > 0) {
        const age = now - cur.at;
        if (age >= 0 && age < (cur.status === 'ok' ? OK_MS : FAIL_MS)) return Promise.resolve(cur);
    }
    const flight = r.__flyFirstRunFlight;
    if (flight && flight.ws === wsId && flight.promise) return flight.promise;
    const opened = (entry)=>{
        const d = entry && entry.status === 'ok' && entry.data;
        if (!d || d.activated === true) return false;
        const ends = Date.parse(String(d.windowEndsAt || ''));
        return Number.isFinite(ends) && ends > Date.now();
    };
    const answered = (res)=>{
        const bare = res && typeof res === 'object' && !Array.isArray(res) ? res : null;
        const data = bare && bare.data && typeof bare.data === 'object' && !Array.isArray(bare.data) ? bare.data : bare;
        const ok = !!data && typeof data.activated === 'boolean';
        return {
            ws: wsId,
            status: ok ? 'ok' : 'error',
            at: Date.now(),
            data: ok ? data : null,
            code: ok ? '' : 'shape'
        };
    };
    const failed = (err)=>({
            ws: wsId,
            status: 'error',
            at: Date.now(),
            data: null,
            code: String(err && (err.status || err.code) || 'failed')
        });
    const promise = Promise.resolve()// The feature gate: the service and its method themselves (the shell's
    // init-await proxy answers getService with a promise; an SDK without the
    // service rejects it), never a version guess.
    .then(()=>sdk.getService('growth')).then((svc)=>svc && typeof svc.activation === 'function' ? svc : null, ()=>null).then((svc)=>svc ? Promise.resolve().then(()=>svc.activation(wsId)).then(answered, failed) : null).then((entry)=>{
        if (r.__flyFirstRunFlight && r.__flyFirstRunFlight.promise === promise) r.__flyFirstRunFlight = null;
        // no read in this SDK: nothing asked, nothing stored, no block
        if (!entry) return null;
        // another workspace is on screen now: this answer is not its
        if (wsOf(r) !== wsId) return null;
        const prev = r._flyFirstRun && r._flyFirstRun.ws === wsId ? r._flyFirstRun : null;
        const next = {
            ...entry,
            wasOpen: !!(prev && (prev.wasOpen || opened(prev)))
        };
        r.update({
            _flyFirstRun: next
        }, {
            preventFetch: true
        });
        return next;
    });
    r.__flyFirstRunFlight = {
        ws: wsId,
        promise: promise
    };
    return promise;
}
function $ddd1e7cc62b8d081$export$3f03bdd238fb2b5b(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root || null;
    if (!host || typeof host.call !== 'function' || !root) return false;
    const fns = host.context && host.context.functions || {};
    if (typeof fns.assistantFlyStartShown === 'function') {
        if (!host.call('assistantFlyStartShown', root)) return false;
    }
    Promise.resolve(host.call('assistantFlyFirstRunRead', root)).catch((err)=>console.warn('[fly] first-run read failed:', err && err.message));
    return true;
}
function $ddd1e7cc62b8d081$export$a33d160e5c2dc4b2(root, now) {
    const KEYS = {
        title: 'workspace.firstRun.title',
        titleDone: 'workspace.firstRun.titleDone',
        lead: 'workspace.firstRun.lead',
        leadFly: 'workspace.firstRun.leadFly',
        leadDone: 'workspace.firstRun.leadDone',
        hide: 'workspace.firstRun.hide',
        progress: 'workspace.firstRun.progress',
        done: 'workspace.firstRun.stepDone'
    };
    // One row per step of the answer (`steps.<field>`), in the rule's order. A
    // `counted` step is { count, needed }; the others are a flag. `ready` copy
    // says what the workspace already has (Fly made it, or the person did)
    // instead of asking for it; `actionReady` names the place the press opens.
    const STEPS = [
        {
            step: 'invite',
            field: 'invited',
            counted: false,
            key: 'firstRunInvite',
            icon: 'userPlus',
            title: 'workspace.firstRun.invite.title',
            hint: 'workspace.firstRun.invite.hint',
            hintReady: '',
            action: 'workspace.firstRun.invite.action',
            actionReady: ''
        },
        {
            step: 'records',
            field: 'records',
            counted: true,
            key: 'firstRunRecords',
            icon: 'database',
            title: 'workspace.firstRun.records.title',
            hint: 'workspace.firstRun.records.hint',
            hintReady: 'workspace.firstRun.records.hintReady',
            action: 'workspace.firstRun.records.actionApps',
            actionReady: 'workspace.firstRun.records.action'
        },
        {
            step: 'publish',
            field: 'sitePublished',
            counted: false,
            key: 'firstRunPublish',
            icon: 'globe',
            title: 'workspace.firstRun.publish.title',
            hint: 'workspace.firstRun.publish.hint',
            hintReady: 'workspace.firstRun.publish.hintReady',
            action: 'workspace.firstRun.publish.actionList',
            actionReady: 'workspace.firstRun.publish.action'
        },
        {
            step: 'ask',
            field: 'aiAsks',
            counted: true,
            key: 'firstRunAsk',
            icon: 'magicstar',
            title: 'workspace.firstRun.ask.title',
            hint: 'workspace.firstRun.ask.hint',
            hintReady: '',
            action: 'workspace.firstRun.ask.action',
            actionReady: ''
        }
    ];
    const HIDDEN = {
        show: false,
        mode: '',
        title: '',
        lead: '',
        hideLabel: '',
        cols: 0,
        steps: []
    };
    const r = root && typeof root === 'object' ? root : {};
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const entry = r._flyFirstRun && typeof r._flyFirstRun === 'object' ? r._flyFirstRun : null;
    if (!wsId || !entry || entry.ws !== wsId || entry.status !== 'ok' || !entry.data) return HIDDEN;
    const prefs = r.userPrefs && typeof r.userPrefs === 'object' ? r.userPrefs : null;
    if (!prefs) return HIDDEN;
    const hidden = prefs.firstRunDismissed;
    if (hidden && typeof hidden === 'object' && hidden[wsId]) return HIDDEN;
    // A personalized sign-up's workspace has its own first thread and its own
    // "Getting started" (functions/assistantFlyResearch.js, POB S7): this block
    // steps aside there. For a POB record — and a Fly one (the sign-up race: a
    // Fly write can win the write-once record) — the slot WAITS for the build
    // board's first answer for this workspace and shows nothing until it is in,
    // so "Get started" never shows and then goes (the POB lead 2026-10-30):
    // a board (200) — the first thread takes the slot; no board (a 404, or a
    // 200 with no data) — "Get started". A failed read is no answer (the first
    // thread's prime asks again). An SDK that cannot read a board never
    // answers, so it never holds the slot.
    const SIGNUPS = [
        'pob',
        'fly'
    ];
    const ob = prefs.onboarding && typeof prefs.onboarding === 'object' ? prefs.onboarding : null;
    if (ob && (SIGNUPS.indexOf(ob.via) !== -1 || SIGNUPS.indexOf(ob.origin) !== -1)) {
        const board = r._pobBuild && typeof r._pobBuild === 'object' ? r._pobBuild : null;
        const answered = !!(board && board.ws === wsId && (board.status === 'ok' || board.status === 'none'));
        if (answered && board.status === 'ok') return HIDDEN;
        if (!answered) {
            const fns = this && this.context && this.context.functions || {};
            let sdk = null;
            if (typeof fns.getSDK === 'function') try {
                sdk = this.call('getSDK');
            } catch (_) {
                sdk = null;
            }
            if (sdk && sdk.isNullClient !== true && typeof sdk.getOnboardingBuild === 'function') return HIDDEN;
        }
    }
    const data = entry.data;
    const t = Number(now) || Date.now();
    let mode = '';
    if (data.activated === true) {
        if (entry.wasOpen) mode = 'done';
    } else {
        const ends = Date.parse(String(data.windowEndsAt || ''));
        if (Number.isFinite(ends) && ends > t) mode = 'open';
    }
    if (!mode) return HIDDEN;
    const word = (key, params)=>{
        if (!key) return '';
        const raw = this.call('polyglot', key);
        let out = raw == null ? '' : String(raw);
        const p = params && typeof params === 'object' ? params : {};
        for (const name of Object.keys(p))out = out.split('{' + name + '}').join(String(p[name]));
        return out;
    };
    const scope = String(this.call('assistantScopeName', r) || '');
    // Fly's record: pending or done via 'fly'; or `origin: 'fly'` once the person
    // took the tour from the ready screen (functions/onboarding.js onboardingDecide)
    const viaFly = !!(prefs.onboarding && (prefs.onboarding.via === 'fly' || prefs.onboarding.origin === 'fly'));
    const fns = this.context && this.context.functions || {};
    // what the workspace already has (the shell's own lists — never the rule):
    // its apps (the launcher's custom tiles) and its website projects
    const tiles = typeof fns.visibleStarterTiles === 'function' ? this.call('visibleStarterTiles', r) || [] : [];
    const app = tiles.find((x)=>x && x.custom && x.route) || null;
    // "Open Commerce" — an installed app's tile (it carries `appKey`) by its App
    // Store name, through installedAppName (Nika 2026-10-23: "app names = what
    // a person sees in the workspace App Store"); a customer's own tile reads
    // its words through polyglot, as before.
    const appName = app ? String(app.appKey && this.call('installedAppName', {
        appKey: app.appKey,
        title: app.title
    }) || '') || word(app.title) : '';
    const sites = this.call('assistantFlyFirstRunSites', r) || [];
    const answer = data.steps && typeof data.steps === 'object' ? data.steps : {};
    const applies = data.applies && typeof data.applies === 'object' ? data.applies : {};
    const num = (v)=>{
        if (v === null || v === undefined || v === '' || typeof v === 'boolean') return null;
        const n = Number(v);
        return Number.isFinite(n) && n >= 0 ? Math.floor(n) : null;
    };
    // the server's two marks of a step that does not count here: `applies`
    // false, else (an answer without `applies`) the step itself null
    const counts = (def)=>typeof applies[def.field] === 'boolean' ? applies[def.field] : answer[def.field] !== null;
    const steps = STEPS.filter(counts).map((def)=>{
        const v = answer[def.field];
        const c = def.counted && v && typeof v === 'object' ? v : {};
        const count = num(c.count);
        const target = num(c.needed);
        // a flag step is done when the server says so; a counted one when the
        // server's count stands at the server's bar
        const done = def.counted ? count != null && target != null && target > 0 && count >= target : v === true;
        const ready = def.step === 'records' && !!app || def.step === 'publish' && sites.length > 0;
        const title = word(def.title);
        const action = done ? word(KEYS.done) : word(ready && def.actionReady ? def.actionReady : def.action, {
            app: appName
        });
        return {
            key: def.key,
            step: def.step,
            icon: done ? 'checkmark' : def.icon,
            done: done,
            title: title,
            hint: word(ready && def.hintReady ? def.hintReady : def.hint, {
                workspace: scope
            }),
            // the count of a step that needs more than one (5 records, 3 asks), as
            // the server counted it — never a count of the client's own
            progress: !done && count != null && target != null && target > 1 ? word(KEYS.progress, {
                n: Math.min(count, target),
                total: target
            }) : '',
            action: action
        };
    });
    return {
        show: true,
        mode: mode,
        title: word(mode === 'done' ? KEYS.titleDone : KEYS.title),
        lead: word(mode === 'done' ? KEYS.leadDone : viaFly ? KEYS.leadFly : KEYS.lead, {
            workspace: scope
        }),
        hideLabel: word(KEYS.hide),
        cols: steps.length,
        steps: steps
    };
}
function $ddd1e7cc62b8d081$export$c7c3140c40ffdae1(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this && this.context && this.context.functions || {};
    const all = Array.isArray(r._projectsForActiveOrg) ? r._projectsForActiveOrg : [];
    if (!all.length) return [];
    if (typeof fns.splitProjectsByKind !== 'function' || typeof fns.projectKindContext !== 'function') return [];
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const scoped = all.filter((p)=>{
        const id = p && p.workspace && typeof p.workspace === 'object' ? p.workspace.id || p.workspace._id : p && p.workspace;
        return !!wsId && String(id || '') === wsId;
    });
    const split = this.call('splitProjectsByKind', scoped, this.call('projectKindContext', r)) || {};
    const sites = Array.isArray(split.websites) ? split.websites : [];
    const at = (p)=>Date.parse(String(p && (p.updatedAt || p.createdAt) || '')) || 0;
    return sites.slice().sort((a, b)=>at(b) - at(a)).map((p)=>({
            owner: String(this.call('ownerSlug', p) || ''),
            key: String(this.call('projectKey', p) || ''),
            name: String(p && p.name || '')
        })).filter((p)=>p.owner && p.key);
}
function $ddd1e7cc62b8d081$export$e06f4fc8acf36c3(s, el) {
    const row = s && typeof s.parse === 'function' ? s.parse() : s;
    const host = el || this;
    const root = host && host.state && host.state.root;
    if (!row || !row.step || row.done || !root) return false;
    if (row.step === 'invite') {
        host.call('openDropdown', {
            anchorEl: host,
            id: 'appInvite',
            placement: 'bottom-start',
            round: 'radiusCard',
            content: {
                extends: 'InviteDropdown'
            },
            onClose: ()=>{
                Promise.resolve(host.call('assistantFlyFirstRunRead', root, {
                    force: true
                })).catch(()=>null);
            }
        });
        return true;
    }
    if (row.step === 'records') {
        const tiles = host.call('visibleStarterTiles', root) || [];
        const app = tiles.find((x)=>x && x.custom && x.route) || null;
        host.call('openInSlot', app ? app.route : '/apps', host);
        return true;
    }
    if (row.step === 'publish') {
        const site = (host.call('assistantFlyFirstRunSites', root) || [])[0];
        const href = site ? host.call('projectHref', root, site.owner, site.key) : null;
        host.call('openInSlot', href || '/studio', host);
        return true;
    }
    if (row.step === 'ask') return !!host.call('focusShellComposer');
    return false;
}
function $ddd1e7cc62b8d081$export$da02180f0472d6ec(opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this && typeof this === 'object' ? this : null;
    const root = o.root || el && el.state && el.state.root || null;
    if (!root || typeof root.update !== 'function') return Promise.resolve(null);
    const w = root.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    if (!wsId) return Promise.resolve(null);
    const at = new Date(typeof o.now === 'number' ? o.now : Date.now()).toISOString();
    const mark = (row)=>{
        const base = row && typeof row === 'object' ? row : {};
        const bag = base.firstRunDismissed && typeof base.firstRunDismissed === 'object' ? base.firstRunDismissed : {};
        return {
            ...base,
            firstRunDismissed: {
                ...bag,
                [wsId]: bag[wsId] || at
            }
        };
    };
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    if (prefs) root.update({
        userPrefs: mark(prefs)
    }, {
        preventFetch: true
    });
    const sdk = o.sdk || el && (el.sdk || el.context && el.context.sdk) || null;
    if (!sdk || typeof sdk.execute !== 'function') return Promise.resolve(null);
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    const prior = queue.get(wsId) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        // the FRESH read: the record as the server holds it now
        const got = await sdk.execute('workspaceProject.userPreferences', 'get');
        const fresh = got && typeof got === 'object' ? got : {};
        const live = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : {};
        const payload = mark({
            ...live,
            ...fresh
        });
        const row = await sdk.execute('workspaceProject.userPreferences', 'update', {
            payload: payload
        });
        const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
        root.update({
            userPrefs: now ? mark(now) : row && typeof row === 'object' ? row : payload
        }, {
            preventFetch: true
        });
        return row;
    });
    queue.set(wsId, task);
    return task.catch((err)=>{
        console.warn('[fly] first-run hide save failed:', err && err.message);
        return null;
    });
}

});

parcelRegister("arFJU", function(module, exports) {

$parcel$export(module.exports, "assistantFlyResearchOwns", () => $79accd9b09883053$export$c5fc9df94bee36ae);
$parcel$export(module.exports, "assistantFlyResearchPrime", () => $79accd9b09883053$export$f70b382108d0b015);
$parcel$export(module.exports, "assistantFlyResearchRead", () => $79accd9b09883053$export$220d4c03b2289e19);
$parcel$export(module.exports, "assistantFlyResearchShown", () => $79accd9b09883053$export$bd6675b64de21b11);
$parcel$export(module.exports, "assistantFlyResearchView", () => $79accd9b09883053$export$9b327bef1a39722f);
$parcel$export(module.exports, "assistantFlyOffersView", () => $79accd9b09883053$export$168bf63305448d26);
$parcel$export(module.exports, "assistantFlyOfferOpen", () => $79accd9b09883053$export$f3c7c4f59b0cc76f);
$parcel$export(module.exports, "assistantFlyChecklistView", () => $79accd9b09883053$export$3d5385fc9c04f439);
$parcel$export(module.exports, "assistantFlyResearchDelete", () => $79accd9b09883053$export$7220563574f5792a);
$parcel$export(module.exports, "assistantFlyResearchDeleteRun", () => $79accd9b09883053$export$e018e9cc85e44dfe);
$parcel$export(module.exports, "assistantFlyResearchDeleteLine", () => $79accd9b09883053$export$abeeaf3b47c4bcf);
$parcel$export(module.exports, "assistantFlyResearchDeleteLineRun", () => $79accd9b09883053$export$1ff43ff1a0ffd34f);
$parcel$export(module.exports, "assistantFlyResearchReviewDone", () => $79accd9b09883053$export$1a768d498a4c738e);
// assistantFlyResearch.js — THE FIRST THREAD of a personalized sign-up (POB
// S7, PLAN §3; decision 11 of 2026-10-25). After the build board, the AI
// panel's first screen (the Fly start screen, components/AssistantFlyStart.js)
// says what was read and from where, offers three things that wait for the
// person, and keeps a short "Getting started" list — components/
// AssistantFlyResearch.js draws it:
//
//   the summary   "I read <domain> and set up your workspace:" — one line per
//                 fact research found (the server's own words, with the page
//                 it came from as a link), the profile fields it filled;
//                 Review what I read (every page it read; Done confirms the
//                 review), Delete all research, and one line deleted alone
//                 (in-app confirm first, owners and admins)
//   the offers    Website · Team · Imports — nothing acts on its own. Each
//                 offer shows "Soon" and no button until its own read answers
//                 AND its sheet is registered in the page slot (the sheets are
//                 another lane's: `/getting-started/team`,
//                 `/getting-started/imports`). Imports reads the import
//                 CONNECTORS (v0 — not what research found): it opens the
//                 imports sheet, whose drop zone is the `file` connector, only
//                 when `file` is live; one lead, one href, no `?source=`. The
//                 Website offer (S8) shows "Soon" until its lane lands
//   the checklist Review your profile · Website · Invite your team · Import —
//                 SERVER TRUTH only. The build board's `checklist` (each item
//                 { done, at }) is the ONE source when the board carries it.
//                 Without it (an older server): Team ticks when a people row
//                 has `invitedAt`; the three others never tick (a connector
//                 carries no `importedAt`). Read again — the board too — when
//                 the screen opens and when the focus returns. On a phone it
//                 folds into one line, "0 of 4 done".
//
// WHO: the person whose record says `via: 'pob'` (or `origin: 'pob'`) in a
// workspace that HAS a build board (functions/onboardingBuild.js — a 404 there
// is "not this workspace"). THE SIGN-UP RACE (POB lead 2026-10-30): the server
// writes the POB record at sign-up, write-once, and a Fly write can win it —
// so a record that says `fly` (via or origin) counts too, in a workspace whose
// board answered (200). Every other person and workspace: nothing, and the
// start screen keeps its own "Get started" (functions/assistantFlyFirstRun.js
// steps aside only here).
//
// THE DATA IS THE SERVER'S, through the SDK only (feature-detected):
//   the research record  sdk.execute('workspaceProject.records', 'list',
//                        { collection: 'onboarding_research', workspaceId })
//                        → data: { profile, findings, domain }; a Finding is
//                        { key, kind, label: { en, ka }, count?, url, fetchedAt }
//   the people           sdk.listOnboardingPeople(workspaceId)
//                        → { people: [{ id, name, role, sourceUrl, fetchedAt,
//                        expiresAt, invitedAt }] }
//   the import sources   sdk.listImportSources(workspaceId) — the import
//                        CONNECTORS (server core/pob-import; SDK
//                        feat/pob-research 6003611, not on dev yet), in
//                        registry order → { sources: [{ id: 'file' |
//                        'google_sheets', kind, name: { en, ka } | null,
//                        status: 'live' | 'planned' | 'missing', auth }] }.
//                        No label, url or importedAt: research finds come in
//                        a later step, not v0. The block keeps { id, status }.
//                        An SDK without it (3dab11a), or a refused read:
//                        Imports says "Soon"
//   delete               sdk.deleteOnboardingResearch(workspaceId)
//                        → { deleted: { records, people, profileFields } }
//   delete one line      sdk.deleteOnboardingResearchLine(workspaceId, line),
//                        line ∈ profile | offerings | faq | team (PLAN P10)
//   the review confirmed sdk.markOnboardingProfileReviewed(workspaceId)
//                        (POST /core/onboarding/build/profile/reviewed — the
//                        checklist's `profile` item)
// (SDK feat/pob-research 3dab11a, server core/pob-research 34c695c9c; the two
// last methods come with the next SDK and server core/pob-board-2 — until
// then their controls are not there.) The team rows' remove and invite
// (removeOnboardingPerson, inviteOnboardingPerson) belong to the Team sheet,
// not to this block.
// The three reads land in the block's OWN state (never a root key — the
// checklist must never read a flag another surface set).
//
// FRANK: every export is self-contained — no import, no module constant, no
// bare sibling call (`this.call`). `this` is the calling element.
// Is this the workspace of a personalized sign-up, for this person? Their
// record says so AND the build board of this workspace answered. Pure.
function $79accd9b09883053$export$c5fc9df94bee36ae(root) {
    // a POB record — or a Fly one (the sign-up race): the board decides
    const SIGNUPS = [
        'pob',
        'fly'
    ];
    const r = root && typeof root === 'object' ? root : {};
    const prefs = r.userPrefs && typeof r.userPrefs === 'object' ? r.userPrefs : null;
    const rec = prefs && prefs.onboarding && typeof prefs.onboarding === 'object' ? prefs.onboarding : null;
    if (!rec || SIGNUPS.indexOf(rec.via) === -1 && SIGNUPS.indexOf(rec.origin) === -1) return false;
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const entry = r._pobBuild && typeof r._pobBuild === 'object' ? r._pobBuild : null;
    return !!(wsId && entry && entry.ws === wsId && entry.status === 'ok');
}
function $79accd9b09883053$export$f70b382108d0b015(el, s, opts) {
    const host = el || this;
    const o = opts && typeof opts === 'object' ? opts : {};
    const root = s && s.root || host && host.state && host.state.root || null;
    if (!host || typeof host.call !== 'function' || !root) return Promise.resolve(false);
    const fns = host.context && host.context.functions || {};
    if (typeof fns.assistantFlyStartShown === 'function' && !host.call('assistantFlyStartShown', root)) return Promise.resolve(false);
    const SIGNUPS = [
        'pob',
        'fly'
    ];
    // an answer this young is the board as it is (the stateDeps change that its
    // own answer causes asks nothing again)
    const FRESH_MS = 5000;
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    const rec = prefs && prefs.onboarding && typeof prefs.onboarding === 'object' ? prefs.onboarding : null;
    if (!rec || SIGNUPS.indexOf(rec.via) === -1 && SIGNUPS.indexOf(rec.origin) === -1) return Promise.resolve(false);
    const w = root.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    if (!wsId) return Promise.resolve(false);
    const entry = root._pobBuild && typeof root._pobBuild === 'object' ? root._pobBuild : null;
    const known = !!(entry && entry.ws === wsId && (entry.status === 'ok' || entry.status === 'none'));
    const stale = known && o.force === true && entry.status === 'ok' && !(Date.now() - Number(entry.at || 0) < FRESH_MS);
    const board = known && !stale ? Promise.resolve(entry) : Promise.resolve(host.call('onboardingBuildRead', root, {
        sdk: o.sdk || null
    })).catch(()=>null);
    return board.then((got)=>{
        if (!got || got.status !== 'ok' || got.ws !== wsId) return false;
        return host.call('assistantFlyResearchRead', host, {
            force: !!o.force,
            sdk: o.sdk || null
        });
    });
}
function $79accd9b09883053$export$220d4c03b2289e19(el, opts) {
    const host = el || this;
    const o = opts && typeof opts === 'object' ? opts : {};
    const st = host && host.state;
    const root = st && st.root;
    if (!st || typeof st.update !== 'function' || !root) return Promise.resolve(false);
    const wsOf = (x)=>{
        const w = x && x.workspace;
        return String(w && (w.id || w._id) || '');
    };
    const wsId = wsOf(root);
    if (!wsId) return Promise.resolve(false);
    const flight = host.__pobResearchFlight;
    if (flight && flight.ws === wsId && flight.promise) return flight.promise;
    if (!o.force && st.pobWs === wsId && st.pobReadAt > 0) return Promise.resolve(true);
    const fns = host.context && host.context.functions || {};
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = host.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || sdk.isNullClient === true) return Promise.resolve(false);
    const unwrap = (res)=>{
        const bare = res && typeof res === 'object' && !Array.isArray(res) ? res : null;
        if (bare && bare.success === false) return null;
        return bare && 'success' in bare && 'data' in bare ? bare.data : bare;
    };
    const web = (u)=>typeof u === 'string' && /^https?:\/\//i.test(u) ? u : '';
    const words = (x)=>x && typeof x === 'object' ? {
            en: String(x.en || ''),
            ka: String(x.ka || '')
        } : typeof x === 'string' ? {
            en: x,
            ka: x
        } : {
            en: '',
            ka: ''
        };
    const research = typeof sdk.execute === 'function' ? Promise.resolve().then(()=>sdk.execute('workspaceProject.records', 'list', {
            collection: 'onboarding_research',
            workspaceId: wsId,
            limit: 5
        })).then((res)=>{
        const rows = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
        const row = rows.find((x)=>x && x.name === 'profile') || rows[0] || null;
        const data = row && row.data && typeof row.data === 'object' ? row.data : null;
        if (!data) return null;
        const profile = data.profile && typeof data.profile === 'object' ? data.profile : {};
        const site = profile.site && typeof profile.site === 'object' ? profile.site : {};
        return {
            domain: String(data.domain || ''),
            siteUrl: web(site.url) || (data.domain ? 'https://' + data.domain + '/' : ''),
            findings: (Array.isArray(data.findings) ? data.findings : []).filter((f)=>f && typeof f.kind === 'string').map((f)=>({
                    kind: f.kind,
                    label: words(f.label),
                    url: web(f.url)
                }))
        };
    }, ()=>null) : Promise.resolve(null);
    const people = typeof sdk.listOnboardingPeople === 'function' ? Promise.resolve().then(()=>sdk.listOnboardingPeople(wsId)).then((res)=>{
        const d = unwrap(res);
        if (!d || !Array.isArray(d.people)) return {
            ok: false,
            list: []
        };
        return {
            ok: true,
            list: d.people.filter((p)=>p && p.id != null).map((p)=>({
                    id: String(p.id),
                    sourceUrl: web(p.sourceUrl),
                    invited: !!p.invitedAt
                }))
        };
    }, ()=>({
            ok: false,
            list: []
        })) : Promise.resolve({
        ok: false,
        list: []
    });
    const sources = typeof sdk.listImportSources === 'function' ? Promise.resolve().then(()=>sdk.listImportSources(wsId)).then((res)=>{
        const d = unwrap(res);
        if (!d || !Array.isArray(d.sources)) return {
            ok: false,
            list: []
        };
        // the import connectors: each one's id and status, nothing else
        return {
            ok: true,
            list: d.sources.filter((x)=>x && x.id != null).map((x)=>({
                    id: String(x.id),
                    status: String(x.status || '')
                }))
        };
    }, ()=>({
            ok: false,
            list: []
        })) : Promise.resolve({
        ok: false,
        list: []
    });
    const promise = Promise.all([
        research,
        people,
        sources
    ]).then(([a, b, c])=>{
        if (host.__pobResearchFlight && host.__pobResearchFlight.promise === promise) host.__pobResearchFlight = null;
        if (wsOf(root) !== wsId) return false;
        const entry = root._pobBuild && typeof root._pobBuild === 'object' ? root._pobBuild : null;
        const board = entry && entry.ws === wsId && entry.status === 'ok' ? entry.board : null;
        const list = board && board.checklist && typeof board.checklist === 'object' ? board.checklist : null;
        st.update({
            pobWs: wsId,
            pobReadAt: Date.now(),
            pobResearch: a,
            pobPeopleOk: b.ok === true,
            pobPeople: b.list,
            pobSourcesOk: c.ok === true,
            pobSources: c.list,
            pobBoardChecklist: list ? {
                ...list
            } : null,
            pobCanReview: typeof sdk.markOnboardingProfileReviewed === 'function',
            pobCanDeleteLine: typeof sdk.deleteOnboardingResearchLine === 'function'
        });
        return true;
    });
    host.__pobResearchFlight = {
        ws: wsId,
        promise: promise
    };
    return promise;
}
function $79accd9b09883053$export$bd6675b64de21b11(root, st) {
    const r = root && typeof root === 'object' ? root : {};
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    if (!wsId || !st || st.pobWs !== wsId || !(st.pobReadAt > 0)) return false;
    return !!this.call('assistantFlyResearchOwns', r);
}
function $79accd9b09883053$export$9b327bef1a39722f(root, st) {
    const HIDDEN = {
        show: false,
        lead: '',
        lines: [],
        pages: [],
        reviewOpen: false,
        reviewText: '',
        reviewDoneShown: false,
        reviewDoneText: '',
        reviewing: false,
        deleteShown: false,
        deleting: false,
        deletedText: '',
        failedText: ''
    };
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    if (!wsId || !st || st.pobWs !== wsId) return HIDDEN;
    const word = (key, params)=>{
        const raw = el.call('polyglot', key);
        let out = raw == null ? '' : String(raw);
        const p = params && typeof params === 'object' ? params : {};
        for (const token of Object.keys(p))out = out.split(token).join(String(p[token]));
        return out;
    };
    const lang = String(el.call('getActiveLang') || r.lang || 'en');
    const place = (url)=>{
        try {
            const u = new URL(url);
            const path = u.pathname && u.pathname !== '/' ? u.pathname : '';
            return u.host.replace(/^www\./, '') + path;
        } catch (_) {
            return '';
        }
    };
    const deleted = st.pobDeleted && typeof st.pobDeleted === 'object' ? st.pobDeleted : null;
    const lineGone = typeof st.pobLineDeleted === 'string' ? st.pobLineDeleted : '';
    const deletedText = deleted ? word('workspace.pobThread.deleted', {
        '{records}': Number(deleted.records) || 0,
        '{people}': Number(deleted.people) || 0,
        '{fields}': Number(deleted.profileFields) || 0
    }) : lineGone ? word('workspace.pobThread.lineDeleted', {
        '{line}': lineGone
    }) : '';
    const failedText = st.pobDeleteFailed === true ? word('workspace.pobThread.deleteFailed') : st.pobReviewFailed === true ? word('workspace.pobThread.reviewFailed') : '';
    const research = st.pobResearch && typeof st.pobResearch === 'object' ? st.pobResearch : null;
    if (!research) return deletedText || failedText ? {
        ...HIDDEN,
        show: true,
        deletedText: deletedText,
        failedText: failedText
    } : HIDDEN;
    const fns = el.context && el.context.functions || {};
    const admin = typeof fns.currentUserIsAdmin === 'function' && !!el.call('currentUserIsAdmin', r);
    // the server's line keys (deleteOnboardingResearchLine), by finding kind.
    // Locations and hours are PROFILE values (CompanyProfile addresses and
    // hours, written by research — the POB lead 2026-10-30): they sit on the
    // profile line, and its delete covers them. Any other kind has no line key.
    const LINES = {
        offerings: 'offerings',
        faq: 'faq',
        team: 'team',
        teamPage: 'team'
    };
    const PROFILE_KINDS = [
        'locations',
        'hours'
    ];
    const canDeleteLines = admin && st.pobCanDeleteLine === true;
    const domain = research.domain || place(research.siteUrl);
    const line = (key, text, url, lineKey)=>{
        const at = url ? place(url) : '';
        const del = lineKey || '';
        const shown = !!(del && canDeleteLines);
        return {
            key: key,
            text: text,
            linkText: at ? word('workspace.pobThread.from', {
                '{place}': at
            }) : '',
            href: at ? url : '',
            deleteLine: del,
            deleteShown: shown,
            deleteLabel: shown ? word('workspace.pobThread.deleteLine', {
                '{line}': text
            }) : '',
            deleting: !!(del && st.pobDeletingLine === del),
            actionRow: false
        };
    };
    const lines = [];
    const entry = r._pobBuild && r._pobBuild.ws === wsId && r._pobBuild.board ? r._pobBuild.board : null;
    const profile = entry ? entry.steps.find((x)=>x.key === 'profile' && x.status === 'done') : null;
    const facts = research.findings.filter((f)=>f.kind !== 'page');
    const factText = (f)=>f.label[lang] || f.label.en;
    const onProfile = (f)=>PROFILE_KINDS.indexOf(f.kind) !== -1;
    // the profile line: the fields the board says research filled, then the
    // profile facts research found, in the server's words ("Filled 4 fields of
    // your company profile, 2 locations, Opening hours"); with no count, the
    // facts alone, from their page
    const filled = profile && profile.count ? profile.count === 1 ? word('workspace.pobThread.profileOne') : word('workspace.pobThread.profile', {
        '{count}': profile.count
    }) : '';
    const profileFacts = facts.filter((f)=>onProfile(f) && factText(f));
    const profileWords = (filled ? [
        filled
    ] : []).concat(profileFacts.map(factText));
    if (profileWords.length) lines.push(line('pob-read-profile', profileWords.join(', '), filled ? research.siteUrl : profileFacts[0].url, 'profile'));
    facts.forEach((f, i)=>{
        const text = factText(f);
        if (text && !onProfile(f)) lines.push(line('pob-read-' + (i + 1), text, f.url, LINES[f.kind]));
    });
    // one fact line with its own delete: every fact line keeps that room
    const actionRow = lines.some((x)=>x.deleteShown);
    for (const x of lines)x.actionRow = actionRow;
    const pages = research.findings.filter((f)=>f.kind === 'page' && f.url).map((f, i)=>line('pob-page-' + (i + 1), f.label[lang] || f.label.en || place(f.url), f.url));
    const reviewOpen = st.pobReviewOpen === true;
    return {
        show: true,
        lead: domain ? word('workspace.pobThread.read', {
            '{domain}': domain
        }) : word('workspace.pobThread.readNoDomain'),
        lines: lines,
        pages: pages,
        reviewOpen: reviewOpen,
        reviewText: word(reviewOpen ? 'workspace.pobThread.reviewHide' : 'workspace.pobThread.review'),
        reviewDoneShown: reviewOpen && pages.length > 0 && admin && st.pobCanReview === true,
        reviewDoneText: word('workspace.pobThread.reviewDone'),
        reviewing: st.pobReviewing === true,
        deleteShown: admin,
        deleting: st.pobDeleting === true || !!st.pobDeletingLine,
        deletedText: deletedText,
        failedText: failedText
    };
}
function $79accd9b09883053$export$168bf63305448d26(root, st) {
    const TEAM = '/getting-started/team';
    const IMPORTS = '/getting-started/imports';
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    if (!wsId || !st || st.pobWs !== wsId) return {
        show: false,
        lead: '',
        rows: []
    };
    const word = (key, params)=>{
        const raw = el.call('polyglot', key);
        let out = raw == null ? '' : String(raw);
        const p = params && typeof params === 'object' ? params : {};
        for (const token of Object.keys(p))out = out.split(token).join(String(p[token]));
        return out;
    };
    const fns = el.context && el.context.functions || {};
    const slot = (href)=>typeof fns.canOpenInSlot === 'function' && !!el.call('canOpenInSlot', href, el);
    const place = (url)=>{
        try {
            const u = new URL(url);
            const path = u.pathname && u.pathname !== '/' ? u.pathname : '';
            return u.host.replace(/^www\./, '') + path;
        } catch (_) {
            return '';
        }
    };
    const research = st.pobResearch && typeof st.pobResearch === 'object' ? st.pobResearch : null;
    const domain = research ? research.domain || place(research.siteUrl) : '';
    // the Website offer: S8 is not on dev yet — "Soon", no button
    const website = {
        key: 'pob-offer-1',
        offer: 'website',
        icon: 'globe',
        title: word('workspace.pobThread.website'),
        lead: domain ? word('workspace.pobThread.websiteLead', {
            '{domain}': domain
        }) : word('workspace.pobThread.websiteLeadNone'),
        soon: true,
        actionText: '',
        href: ''
    };
    // Team: the people found on the company's own team page
    const people = Array.isArray(st.pobPeople) ? st.pobPeople : [];
    const teamPage = people.map((p)=>place(p.sourceUrl)).find(Boolean) || '';
    const teamOk = st.pobPeopleOk === true && slot(TEAM);
    const team = {
        key: 'pob-offer-2',
        offer: 'team',
        icon: 'userPlus',
        title: word('workspace.pobThread.team'),
        lead: people.length && teamPage ? people.length === 1 ? word('workspace.pobThread.teamLeadOne', {
            '{page}': teamPage
        }) : word('workspace.pobThread.teamLead', {
            '{count}': people.length,
            '{page}': teamPage
        }) : word('workspace.pobThread.teamLeadNone'),
        soon: !teamOk,
        actionText: teamOk ? word('workspace.pobThread.teamAction') : '',
        href: teamOk ? TEAM : ''
    };
    // Imports (v0): the read lists the import CONNECTORS, not what research
    // found. The imports sheet's drop zone is the `file` connector (a connector
    // that is not live is a "Coming soon" row there), so the offer is ready
    // only when the read answered and `file` is live. One lead and one href —
    // the sheet itself, never `?source=` (a connector id is no source).
    const sources = Array.isArray(st.pobSources) ? st.pobSources : [];
    const fileLive = sources.some((x)=>x && x.id === 'file' && x.status === 'live');
    const importsOk = st.pobSourcesOk === true && fileLive && slot(IMPORTS);
    const imports = {
        key: 'pob-offer-3',
        offer: 'imports',
        icon: 'upload',
        title: word('workspace.pobThread.imports'),
        lead: word('workspace.pobThread.importsLeadNone'),
        soon: !importsOk,
        actionText: importsOk ? word('workspace.pobThread.importsAction') : '',
        href: importsOk ? IMPORTS : ''
    };
    return {
        show: true,
        lead: word('workspace.pobThread.offers'),
        rows: [
            website,
            team,
            imports
        ]
    };
}
function $79accd9b09883053$export$f3c7c4f59b0cc76f(s, el) {
    const row = s && typeof s.parse === 'function' ? s.parse() : s;
    const host = el || this;
    if (!row || row.soon === true || typeof row.href !== 'string' || !row.href) return false;
    host.call('openInSlot', row.href, host);
    return true;
}
function $79accd9b09883053$export$3d5385fc9c04f439(root, st) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const empty = {
        show: false,
        title: '',
        progressText: '',
        foldText: '',
        folded: false,
        rows: []
    };
    if (!wsId || !st || st.pobWs !== wsId) return empty;
    const word = (key, params)=>{
        const raw = el.call('polyglot', key);
        let out = raw == null ? '' : String(raw);
        const p = params && typeof params === 'object' ? params : {};
        for (const token of Object.keys(p))out = out.split(token).join(String(p[token]));
        return out;
    };
    const people = Array.isArray(st.pobPeople) ? st.pobPeople : [];
    const server = st.pobBoardChecklist && typeof st.pobBoardChecklist === 'object' ? st.pobBoardChecklist : null;
    const done = (item)=>!!(server[item] && server[item].done === true);
    const items = server ? [
        {
            item: 'profile',
            title: 'workspace.pobThread.checkProfile',
            ticked: done('profile')
        },
        {
            item: 'website',
            title: 'workspace.pobThread.checkWebsite',
            ticked: done('website')
        },
        {
            item: 'team',
            title: 'workspace.pobThread.checkTeam',
            ticked: done('team')
        },
        {
            item: 'import',
            title: 'workspace.pobThread.checkImport',
            ticked: done('import')
        }
    ] : [
        // an older server: no field says the profile was reviewed, nor that
        // the website offer was taken, nor that an import ran (the sources
        // are connectors, with no `importedAt`) — these three never tick
        {
            item: 'profile',
            title: 'workspace.pobThread.checkProfile',
            ticked: false
        },
        {
            item: 'website',
            title: 'workspace.pobThread.checkWebsite',
            ticked: false
        },
        {
            item: 'team',
            title: 'workspace.pobThread.checkTeam',
            ticked: st.pobPeopleOk === true && people.some((p)=>p.invited === true)
        },
        {
            item: 'import',
            title: 'workspace.pobThread.checkImport',
            ticked: false
        }
    ];
    const rows = items.map((x, i)=>({
            key: 'pob-check-' + (i + 1),
            item: x.item,
            title: word(x.title),
            ticked: x.ticked === true,
            stateText: word(x.ticked ? 'workspace.pobThread.itemDone' : 'workspace.pobThread.itemOpen')
        }));
    const n = rows.filter((x)=>x.ticked).length;
    const progressText = word('workspace.pobThread.progress', {
        '{n}': n,
        '{total}': rows.length
    });
    const open = st.pobChecklistOpen === true;
    return {
        show: true,
        title: word('workspace.pobThread.checklist'),
        progressText: progressText,
        foldText: progressText,
        folded: r._isPhoneViewport === true && !open,
        rows: rows
    };
}
function $79accd9b09883053$export$7220563574f5792a(el) {
    const host = el || this;
    if (!host || typeof host.call !== 'function') return null;
    const t = (key)=>host.call('polyglot', key);
    return host.call('confirmDialog', {
        title: t('workspace.pobThread.deleteTitle'),
        message: t('workspace.pobThread.deleteMessage'),
        confirmText: t('common.action.delete'),
        cancelText: t('common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>host.call('assistantFlyResearchDeleteRun', host)
    }) || null;
}
function $79accd9b09883053$export$e018e9cc85e44dfe(el, opts) {
    const host = el || this;
    const o = opts && typeof opts === 'object' ? opts : {};
    const st = host && host.state;
    const root = st && st.root;
    if (!st || typeof st.update !== 'function' || !root) return Promise.resolve(null);
    const w = root.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const fns = host.context && host.context.functions || {};
    // one delete at a time (all, or one line)
    if (!wsId || st.pobDeleting === true || st.pobDeletingLine) return Promise.resolve(null);
    if (typeof fns.currentUserIsAdmin !== 'function' || !host.call('currentUserIsAdmin', root)) return Promise.resolve(null);
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = host.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || typeof sdk.deleteOnboardingResearch !== 'function') return Promise.resolve(null);
    st.update({
        pobDeleting: true,
        pobDeleteFailed: false,
        pobReviewFailed: false
    });
    return Promise.resolve().then(()=>sdk.deleteOnboardingResearch(wsId)).then((res)=>{
        const bare = res && typeof res === 'object' ? res : null;
        const d = bare && 'success' in bare && 'data' in bare ? bare.data : bare;
        const deleted = d && d.deleted && typeof d.deleted === 'object' ? d.deleted : null;
        if (!deleted) throw new Error('shape');
        const counts = {
            records: Number(deleted.records) || 0,
            people: Number(deleted.people) || 0,
            profileFields: Number(deleted.profileFields) || 0
        };
        st.update({
            pobDeleting: false,
            pobDeleted: counts,
            pobLineDeleted: '',
            pobResearch: null,
            pobReviewOpen: false
        });
        // the board's profile and records steps say what went; the offers read
        // again (the people went with the research) — the board first, so the
        // reads keep its fresh checklist
        Promise.resolve(host.call('onboardingBuildRead', root, {
            sdk: o.sdk || null
        })).catch(()=>null).then(()=>host.call('assistantFlyResearchRead', host, {
                force: true,
                sdk: o.sdk || null
            })).catch(()=>null);
        return counts;
    }).catch((err)=>{
        console.warn('[onboarding] delete research failed:', err && err.message);
        st.update({
            pobDeleting: false,
            pobDeleteFailed: true
        });
        return null;
    });
}
function $79accd9b09883053$export$abeeaf3b47c4bcf(el, line, text) {
    const LINES = [
        'profile',
        'offerings',
        'faq',
        'team'
    ];
    const pressed = el || this;
    if (!pressed || LINES.indexOf(line) === -1) return null;
    const found = typeof pressed.lookup === 'function' ? pressed.lookup('AssistantFlyResearch') : null;
    const host = found || pressed;
    if (!host || typeof host.call !== 'function') return null;
    const t = (key)=>host.call('polyglot', key);
    const words = String(text || '');
    return host.call('confirmDialog', {
        title: t('workspace.pobThread.deleteLineTitle'),
        message: String(t('workspace.pobThread.deleteLineMessage') || '').split('{line}').join(words),
        confirmText: t('common.action.delete'),
        cancelText: t('common.action.cancel'),
        confirmTheme: 'primary',
        icon: null,
        onConfirm: ()=>host.call('assistantFlyResearchDeleteLineRun', host, line, words)
    }) || null;
}
function $79accd9b09883053$export$1ff43ff1a0ffd34f(el, line, text, opts) {
    const LINES = [
        'profile',
        'offerings',
        'faq',
        'team'
    ];
    const host = el || this;
    const o = opts && typeof opts === 'object' ? opts : {};
    const st = host && host.state;
    const root = st && st.root;
    if (!st || typeof st.update !== 'function' || !root) return Promise.resolve(false);
    if (LINES.indexOf(line) === -1) return Promise.resolve(false);
    const w = root.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const fns = host.context && host.context.functions || {};
    if (!wsId || st.pobDeleting === true || st.pobDeletingLine) return Promise.resolve(false);
    if (typeof fns.currentUserIsAdmin !== 'function' || !host.call('currentUserIsAdmin', root)) return Promise.resolve(false);
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = host.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || typeof sdk.deleteOnboardingResearchLine !== 'function') return Promise.resolve(false);
    const words = String(text || '');
    st.update({
        pobDeletingLine: line,
        pobDeleteFailed: false,
        pobReviewFailed: false,
        pobDeleted: null,
        pobLineDeleted: ''
    });
    return Promise.resolve().then(()=>sdk.deleteOnboardingResearchLine(wsId, line)).then((res)=>{
        const bare = res && typeof res === 'object' ? res : null;
        if (bare && bare.success === false) throw new Error(String(bare.error || bare.code || 'refused'));
        st.update({
            pobDeletingLine: '',
            pobLineDeleted: words
        });
        return Promise.resolve(host.call('onboardingBuildRead', root, {
            sdk: o.sdk || null
        })).catch(()=>null).then(()=>host.call('assistantFlyResearchRead', host, {
                force: true,
                sdk: o.sdk || null
            })).catch(()=>null).then(()=>true);
    }).catch((err)=>{
        console.warn('[onboarding] delete research line failed:', err && err.message);
        st.update({
            pobDeletingLine: '',
            pobDeleteFailed: true
        });
        return false;
    });
}
function $79accd9b09883053$export$1a768d498a4c738e(el, opts) {
    const pressed = el || this;
    const o = opts && typeof opts === 'object' ? opts : {};
    const found = pressed && typeof pressed.lookup === 'function' ? pressed.lookup('AssistantFlyResearch') : null;
    const host = found || pressed;
    const st = host && host.state;
    const root = st && st.root;
    if (!st || typeof st.update !== 'function' || !root) return Promise.resolve(false);
    st.update({
        pobReviewOpen: false
    });
    const w = root.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const fns = host.context && host.context.functions || {};
    if (!wsId || st.pobReviewing === true) return Promise.resolve(false);
    if (typeof fns.currentUserIsAdmin !== 'function' || !host.call('currentUserIsAdmin', root)) return Promise.resolve(false);
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = host.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || typeof sdk.markOnboardingProfileReviewed !== 'function') return Promise.resolve(false);
    st.update({
        pobReviewing: true,
        pobReviewFailed: false,
        pobDeleteFailed: false
    });
    return Promise.resolve().then(()=>sdk.markOnboardingProfileReviewed(wsId)).then((res)=>{
        const bare = res && typeof res === 'object' ? res : null;
        if (bare && bare.success === false) throw new Error(String(bare.error || bare.code || 'refused'));
        st.update({
            pobReviewing: false
        });
        return Promise.resolve(host.call('onboardingBuildRead', root, {
            sdk: o.sdk || null
        })).catch(()=>null).then(()=>host.call('assistantFlyResearchRead', host, {
                force: true,
                sdk: o.sdk || null
            })).catch(()=>null).then(()=>true);
    }).catch((err)=>{
        console.warn('[onboarding] the review was not saved:', err && err.message);
        st.update({
            pobReviewing: false,
            pobReviewFailed: true
        });
        return false;
    });
}

});

parcelRegister("42k1m", function(module, exports) {

$parcel$export(module.exports, "assistantFlyFirstRunPresetLine", () => $2f06e115d20bb4e1$export$9cbac8eed7411f42);
$parcel$export(module.exports, "assistantFlyFirstRunPresetPrime", () => $2f06e115d20bb4e1$export$83777e13809634e3);
$parcel$export(module.exports, "assistantFlyFirstRunPresetOpen", () => $2f06e115d20bb4e1$export$43cae5179d386393);
// firstRunPresetLine.js — the Workspace Presets' ONE entry point for a
// workspace that skipped them (wt/presets CONTRACT §5 WIZARD; the
// orchestrator's ruling 2026-10-24: a LEAD-IN LINE of the first-run block,
// never a step). The block's steps mirror the SERVER's activation rule
// (functions/assistantFlyFirstRun.js: the server decides every step, count,
// bar and window — the client computes nothing of it), so this line is not
// one of them: no tick, not counted, above the steps — "Set up for your work
// — start from a preset" — and its press opens the App Store, whose first row
// is the presets (the store's own sheet shows a preset and applies it).
//
// Shown only while ALL hold:
//   - the block is OPEN: not activated, inside the window, not hidden by the
//     person (the block's own X hides the line with it)
//   - the person may apply a preset (workspacePresetCanApply: owner / admin)
//   - the workspace has no `settings.preset` (a `custom` answer is an answer:
//     the line stays away)
//   - this host's SDK can apply presets, and the registry offers one the store
//     has words for (the store's row is not empty)
//
// FRANK: every export is self-contained; siblings through `this.call`.
// The line's question — pure over `root` (`now` is the block's own test seam).
function $2f06e115d20bb4e1$export$9cbac8eed7411f42(root, now) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const fns = el && el.context && el.context.functions || {};
    // every key the answer depends on, read first (reactive callers)
    r._flyFirstRun;
    r.userPrefs;
    r.workspace;
    r.org;
    r._workspacePresets;
    const unsupported = !!r._workspacePresetsUnsupported;
    if (typeof fns.workspacePresetCanApply !== 'function' || typeof fns.workspacePresetApplied !== 'function' || typeof fns.workspacePresetsFeatured !== 'function' || typeof fns.workspacePresetText !== 'function') return false;
    if (unsupported) return false;
    const view = el.call('assistantFlyFirstRunView', r, now) || {};
    if (!view.show || view.mode !== 'open') return false;
    if (!el.call('workspacePresetCanApply', r)) return false;
    if (el.call('workspacePresetApplied', r)) return false;
    return (el.call('workspacePresetsFeatured', r) || []).some((p)=>!!p && !!el.call('workspacePresetText', p.key, 'name'));
}
function $2f06e115d20bb4e1$export$83777e13809634e3(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root || null;
    const fns = host && host.context && host.context.functions || {};
    if (!host || typeof host.call !== 'function' || !root) return false;
    if (typeof fns.workspacePresetsLoad !== 'function' || typeof fns.workspacePresetCanApply !== 'function' || typeof fns.workspacePresetApplied !== 'function') return false;
    if (typeof fns.assistantFlyStartShown === 'function') {
        if (!host.call('assistantFlyStartShown', root)) return false;
    }
    if (!host.call('workspacePresetCanApply', root)) return false;
    if (host.call('workspacePresetApplied', root)) return false;
    Promise.resolve(host.call('workspacePresetsLoad')).catch(()=>null);
    return true;
}
function $2f06e115d20bb4e1$export$43cae5179d386393() {
    return this.call('openAppPage', '/marketplace?surface=appstore');
}

});

parcelRegister("kja5T", function(module, exports) {

$parcel$export(module.exports, "callPerson", () => $ec8d6971c49aba55$export$1e3e3302f176aff0);
// callPerson.js — CALL ANYONE IN THE WORKSPACE (Nika 2026-10-23: "add calling
// mode into fly so you can call to anyone in workspace").
//
// One call: a private room named for the person, the person ADDED AS ITS
// MEMBER (by user id — a roster row may carry no email: a non-manager's
// roster omits them), this person joined into it on /meet, and, when the
// person's email is known, the join link in a DM. Membership is what lets the
// person see and join the room (and what their shell rings on:
// functions/incomingCall.js); the DM keeps the link in their chat.
//
// `opts.transcribe`: the call keeps a transcript — its summary then builds
// live during the call and waits on its end screen (meet's live recap). Fly's
// calls ask for it; the person popover's Call keeps the room default.
//
// Shared by the person popover's Call (components/PersonPopover.js) and Fly
// (the start screen's People, a "call <name>" ask). Returns the room id, or
// null when the room could not be made (the person is told).
//
// FRANK: self-contained (FA204); siblings through `this.call`.
async function $ec8d6971c49aba55$export$1e3e3302f176aff0(who, opts) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return null;
    const person = (who && typeof who === 'object' ? who : null) || (typeof who === 'string' && who ? this.call('findPerson', who) : null) || null;
    const email = person && typeof person.email === 'string' && person.email || (typeof who === 'string' && who.includes('@') ? who : '') || '';
    const userId = person && (person.userId || person.id || person._id) || null;
    const label = person && person.name || email;
    if (!label) return null;
    const fail = ()=>{
        this.call('openNotification', {
            type: 'error',
            title: this.call('polyglot', 'workspace.person.callFailed'),
            message: this.call('polyglot', 'workspace.person.tryAgain')
        });
        return null;
    };
    let roomId = null;
    try {
        roomId = await this.call('createRoom', {
            name: String(this.call('polyglot', 'workspace.person.callRoomName')).replace('{name}', label),
            kind: 'room',
            visibility: 'private',
            transcribeEnabled: !!(opts && opts.transcribe)
        });
    } catch (err) {
        console.warn('[callPerson] createRoom failed', err && err.message);
    }
    if (!roomId) return fail();
    // The person is a member before anyone joins: their shell sees the room the
    // moment it is live.
    if (userId && String(userId) !== String(root.currentUserId || '')) try {
        await this.call('addMeetMember', {
            roomId: roomId,
            userId: userId
        });
    } catch (err) {
        console.warn('[callPerson] addMeetMember failed', err && err.message);
    }
    // The call opens on /meet: a Messenger left open (a call started from a
    // person card in it) would cover the call, so it closes with the same write
    // (the rule of a link in a message, chat functions/chatLinkClick.js).
    root.update({
        activeRoomId: roomId,
        meetView: 'call',
        ...root._chatDrawerOpen ? {
            _chatDrawerOpen: false
        } : {}
    });
    this.router('/meet', this.getRoot());
    if (typeof window !== 'undefined' && window.history) // The room hash, on the address the route above just wrote: a hash-only
    // URL keeps its path, so the call keeps the tab's `/w/<org>/<workspace>`
    // (F2 — the bare `/meet#…` written here dropped it, and a reload opened
    // the call in the last-used workspace). A raw write on purpose, the stamp
    // meet's own call starters make: a second `this.router` cannot stamp it
    // (a newer navigation takes over the router's pending /meet mount while
    // the shell's onRouteExit motion runs), and a hash inside the route itself
    // is read by the meet page's mount-time seed (a cold `view=call` link
    // opens the join preview) whenever the page mounts at once.
    // frank-allow FA410
    window.history.replaceState(null, '', '#room=' + roomId + '&view=call');
    this.call('connectCall', roomId);
    if (email) try {
        // createChannel + sendMessage live in chat's lazy chunk: fold it first,
        // or the invite silently never sends.
        const folded = await this.call('ensureChatContext');
        if (folded !== false) {
            const channelId = await this.call('createChannel', {
                kind: 'dm',
                memberEmails: [
                    email
                ]
            });
            if (channelId) {
                const url = this.call('meetRoomUrl', root, roomId);
                const body = String(this.call('polyglot', 'workspace.person.callInviteBody')).replace('{url}', url);
                await this.call('sendMessage', {
                    channelId: channelId,
                    body: body
                });
            }
        }
    } catch (err) {
        console.warn('[callPerson] invite message failed', err && err.message);
    }
    return roomId;
}

});

parcelRegister("exGAm", function(module, exports) {

$parcel$export(module.exports, "assistantFlyCallRoster", () => $a9652e5779c71d39$export$ae55839d16526396);
$parcel$export(module.exports, "assistantFlyCallPerson", () => $a9652e5779c71d39$export$49245ded0eb2d30e);
$parcel$export(module.exports, "assistantFlyCallIntent", () => $a9652e5779c71d39$export$9a20c63fcb38be43);
// assistantFlyPeople.js — FLY CALLS ANYONE IN THE WORKSPACE (Nika 2026-10-23:
// "add calling mode into fly so you can call to anyone in workspace").
//
// The start screen showed the members as a row once (Nika 2026-10-23: "instead
// of call, change to members, add popover to those"); the row left it the
// same day ("remove members from init fly"). The roster stays for the call
// ask below (assistantFlyCallRoster, the whole roster).
//
// An ask that is a call (functions/callPerson.js, with a transcript so its
// summary builds during the call):
//   an ask                      "call Nika", "ring thomas", "დაურეკე ნიკას" — a
//                               Fly ask that names ONE member calls them instead
//                               of composing a page (assistantFlyCallIntent);
//                               anything else, or a name two people share, is
//                               an ordinary ask
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// The workspace's people a call can name: the active members but the person
// themself, the ones online first, then by name; at most `limit` (8; 0 = all —
// the call ask reads them all). Read keys: the roster, the presence map, the
// person (reactive callers).
const $a9652e5779c71d39$export$ae55839d16526396 = function assistantFlyCallRoster(root, limit) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this && this.context && this.context.functions || {};
    const all = typeof fns.activeMembers === 'function' ? this.call('activeMembers', r) || [] : Array.isArray(r.people) ? r.people : [];
    const presence = r.presenceById && typeof r.presenceById === 'object' && r.presenceById || {};
    const meEmail = String(r.currentUserEmail || '').toLowerCase();
    const meId = String(r.currentUserId || '');
    // 8 by default; the call ask searches the whole roster (`limit` 0)
    const want = Math.floor(Number(limit));
    const max = want === 0 ? Infinity : Math.max(1, Math.min(24, want || 8));
    const rows = [];
    const seen = new Set();
    for (const p of Array.isArray(all) ? all : []){
        if (!p || typeof p !== 'object') continue;
        const email = String(p.email || '').toLowerCase();
        const userId = p.userId ? String(p.userId) : '';
        if (email && email === meEmail || userId && userId === meId) continue;
        const key = userId || email;
        if (!key || seen.has(key)) continue;
        seen.add(key);
        const name = String(p.name || p.email || '').trim();
        if (!name) continue;
        rows.push({
            key: 'person-' + key.replace(/[^A-Za-z0-9_-]/g, '_'),
            // every key a value (a row's empty key would read the root's)
            userId: userId || '',
            email: email || '',
            name: name,
            avatar: typeof p.avatar === 'string' ? p.avatar : '',
            initials: typeof p.initials === 'string' ? p.initials : '',
            online: !!(email && presence[email] || userId && presence[userId])
        });
    }
    rows.sort((a, b)=>Number(b.online) - Number(a.online) || a.name.localeCompare(b.name));
    return rows.slice(0, max);
};
const $a9652e5779c71d39$export$49245ded0eb2d30e = function assistantFlyCallPerson(s) {
    if (!s || !s.userId && !s.email) return false;
    const who = {
        userId: s.userId || '',
        email: s.email || '',
        name: s.name || ''
    };
    this.call('callPerson', who, {
        transcribe: true
    });
    return true;
};
const $a9652e5779c71d39$export$9a20c63fcb38be43 = function assistantFlyCallIntent(root, text) {
    const raw = String(text || '').trim();
    if (!raw || raw.length > 80) return null;
    const forms = [
        /^(?:please\s+)?(?:call|ring|phone|video\s*call|start\s+a\s+call\s+with|get\s+on\s+a\s+call\s+with)\s+(.+?)\s*[.!?]*$/i,
        /^(?:დაურეკე|დარეკე|დაუკავშირდი)\s+(.+?)\s*[.!?]*$/u
    ];
    let name = null;
    for (const re of forms){
        const m = re.exec(raw);
        if (m) {
            name = m[1];
            break;
        }
    }
    if (!name) return null;
    const q = name.replace(/^@/, '').replace(/\s+(now|please)$/i, '').trim().toLowerCase();
    if (!q) return null;
    // Georgian dative/ergative endings on a first name ("ნიკას", "თომასს").
    const stems = [
        q,
        q.replace(/(ს|ის|მა|მ)$/u, '')
    ].filter(Boolean);
    const people = this.call('assistantFlyCallRoster', root, 0) || [];
    const hits = people.filter((p)=>{
        const full = String(p.name || '').toLowerCase();
        const first = full.split(/\s+/)[0] || '';
        const local = String(p.email || '').split('@')[0].toLowerCase();
        return stems.some((n)=>n === full || n === first || local && n === local);
    });
    return hits.length === 1 ? hits[0] : null;
};

});

parcelRegister("jpKCL", function(module, exports) {

$parcel$export(module.exports, "workspaceModeOf", () => $e22484bb99a4daaa$export$1d83ea137311b2ee);
$parcel$export(module.exports, "workspaceModeSegments", () => $e22484bb99a4daaa$export$d9c7098668465b2f);
$parcel$export(module.exports, "workspaceModeShown", () => $e22484bb99a4daaa$export$d036d166a8f35604);
$parcel$export(module.exports, "workspaceModeSelect", () => $e22484bb99a4daaa$export$14e4500e08712b09);
$parcel$export(module.exports, "workspaceModeToggle", () => $e22484bb99a4daaa$export$ccf4438f7e1fcace);
// workspaceMode.js — THE WORKSPACE OR ITS CLI (Nika 2026-10-23: "add switcher
// so we can switch between normal and CLI-like workspace easily").
//
// One workspace, two ways to have it: the normal shell, or Agent mode — the
// workspace TUI as the whole shell (functions/agentMode.js, WS-AGENT-MODE-1;
// its own choice, persisted per person). One switch, "Workspace · CLI"
// (components/WorkspaceModeSwitch.js), in both shells: at the top of the home,
// at the start of the home's views row (components/HomeViewSwitch.js — clear
// of the Fly rail at the right edge), and in the Agent frame's header where its
// Leave was. Ctrl+` flips it anywhere (functions/shortcutsDefault.js; the
// frame's key bridge, functions/agentModeRuntime.js agentModeKeydown).
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
// 'cli' while the Agent frame is the shell (the person's choice or a link),
// else 'ui'.
const $e22484bb99a4daaa$export$1d83ea137311b2ee = function workspaceModeOf(root) {
    const r = root && typeof root === 'object' ? root : {};
    return r.agentMode === true || r._agentModeLink === true ? 'cli' : 'ui';
};
const $e22484bb99a4daaa$export$d9c7098668465b2f = function workspaceModeSegments() {
    return [
        {
            key: 'modeUi',
            value: 'ui',
            text: 'workspace.agentMode.ui'
        },
        {
            key: 'modeCli',
            value: 'cli',
            text: 'workspace.agentMode.cli'
        }
    ];
};
const $e22484bb99a4daaa$export$d036d166a8f35604 = function workspaceModeShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this && this.context && this.context.functions || {};
    const signedIn = r.signedIn === true;
    const editing = !!r._homeCustomizeMode;
    return signedIn && !editing && typeof fns.setAgentMode === 'function';
};
const $e22484bb99a4daaa$export$14e4500e08712b09 = function workspaceModeSelect(value) {
    const root = this && this.state && this.state.root;
    if (!root || value !== 'ui' && value !== 'cli') return false;
    if (this.call('workspaceModeOf', root) === value) return false;
    this.call('setAgentMode', value === 'cli');
    return true;
};
const $e22484bb99a4daaa$export$ccf4438f7e1fcace = function workspaceModeToggle() {
    const root = this && this.state && this.state.root;
    if (!root) return false;
    return this.call('workspaceModeSelect', this.call('workspaceModeOf', root) === 'cli' ? 'ui' : 'cli');
};

});

parcelRegister("eyLou", function(module, exports) {

$parcel$export(module.exports, "incomingCallScan", () => $a999011a53c9bb31$export$376f1da723d43020);
$parcel$export(module.exports, "incomingCallOf", () => $a999011a53c9bb31$export$718650e3c9c4c77);
$parcel$export(module.exports, "incomingCallJoin", () => $a999011a53c9bb31$export$cc5805ccc327ad75);
$parcel$export(module.exports, "incomingCallDecline", () => $a999011a53c9bb31$export$a3ee269fcd80e7e0);
// incomingCall.js — THE PERSON CALLED RINGS (Nika 2026-10-23: "add calling
// mode into fly so you can call to anyone in workspace"). functions/
// callPerson.js makes the person called a MEMBER of a private room before
// anyone joins; this is their side: a banner (components/IncomingCallBanner.js,
// the meeting invite's own card) with the caller's name, Join call and Decline.
//
// A room rings here when someone else made it in the last two minutes, it has
// not ended, it is not the call this person is already in, they have not put
// it away — and they are one of its members. Seeing the room is NOT being
// called: every member of a workspace can see its private rooms
// (MeetService.assertCanAccessRoom on the server), so membership is asked
// once per room (meet's members list), and the answer remembered on the root
// under a double-underscore key (never state). The ring itself is ONE root key,
// `_callRing` ({ roomId, callerId, at }) or null: the banner reads it.
//
// The scan runs on the banner's own updates — the rooms changing (a room lands
// through meet's realtime the moment it is made) and the invite banner's 30 s
// tick (`_meetingInviteTick`), which lets a ring expire on an idle tab.
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.
function $a999011a53c9bb31$export$376f1da723d43020(el, s) {
    const host = el || this;
    const root = s && s.root || host.state && host.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const RING_MS = 120000;
    const now = Date.now();
    const mine = [
        root.currentUserSupabaseId,
        root.currentUserId
    ].filter(Boolean).map(String);
    const memo = root.__callRing = root.__callRing || {
        member: {},
        away: {}
    };
    const ringing = (room)=>!!room && room.visibility === 'private' && !room.endedAt && !!room.createdBy && !mine.includes(String(room.createdBy)) && room.id !== root.activeRoomId && !memo.away[room.id] && now - (Date.parse(room.createdAt || '') || 0) < RING_MS;
    const rooms = (Array.isArray(root.rooms) ? root.rooms : []).filter(ringing);
    // a ring that no longer qualifies (ended, joined, expired, put away) goes
    const ring = root._callRing;
    if (ring && !rooms.some((r)=>r.id === ring.roomId)) root.update({
        _callRing: null
    }, {
        preventFetch: true
    });
    if (!mine.length) return false;
    const fns = host.context && host.context.functions || {};
    if (typeof fns.listMeetMembers !== 'function') return false;
    for (const room of rooms){
        if (memo.member[room.id] !== undefined) {
            if (memo.member[room.id] === true && !root._callRing) root.update({
                _callRing: {
                    roomId: room.id,
                    callerId: String(room.createdBy),
                    at: Date.parse(room.createdAt || '') || now
                }
            }, {
                preventFetch: true
            });
            continue;
        }
        memo.member[room.id] = 'asking';
        Promise.resolve(host.call('listMeetMembers', room.id)).then((rows)=>{
            const member = (Array.isArray(rows) ? rows : []).some((m)=>mine.includes(String(m && m.userId || '')));
            memo.member[room.id] = member;
            if (member && ringing(room) && !root._callRing) root.update({
                _callRing: {
                    roomId: room.id,
                    callerId: String(room.createdBy),
                    at: Date.parse(room.createdAt || '') || Date.now()
                }
            }, {
                preventFetch: true
            });
        }, ()=>{
            memo.member[room.id] = false;
        });
    }
    return true;
}
function $a999011a53c9bb31$export$718650e3c9c4c77(root) {
    const r = root && typeof root === 'object' ? root : {};
    const ring = r._callRing;
    if (!ring || !ring.roomId) return null;
    const people = Array.isArray(r.people) ? r.people : [];
    const caller = people.find((p)=>p && String(p.userId || '') === String(ring.callerId));
    const room = (Array.isArray(r.rooms) ? r.rooms : []).find((x)=>x && x.id === ring.roomId);
    return {
        roomId: ring.roomId,
        callerName: caller && (caller.name || caller.email) || room && room.name || '',
        at: ring.at || 0
    };
}
function $a999011a53c9bb31$export$cc5805ccc327ad75() {
    const root = this.state && this.state.root;
    const ring = root && root._callRing;
    if (!ring || !ring.roomId) return false;
    const memo = root.__callRing = root.__callRing || {
        member: {},
        away: {}
    };
    memo.away[ring.roomId] = true;
    root.update({
        _callRing: null,
        activeRoomId: ring.roomId,
        meetView: 'call'
    });
    this.router('/meet', this.getRoot());
    if (typeof window !== 'undefined' && window.history) // Hash-only, on the address the route above just wrote, so the call keeps
    // the tab's `/w/<org>/<workspace>` (F2) — the stamp callPerson makes, and
    // why it stays a raw write (functions/callPerson.js).
    // frank-allow FA410
    window.history.replaceState(null, '', '#room=' + ring.roomId + '&view=call');
    this.call('connectCall', ring.roomId);
    return true;
}
function $a999011a53c9bb31$export$a3ee269fcd80e7e0() {
    const root = this.state && this.state.root;
    const ring = root && root._callRing;
    if (!ring || !ring.roomId) return false;
    const memo = root.__callRing = root.__callRing || {
        member: {},
        away: {}
    };
    memo.away[ring.roomId] = true;
    root.update({
        _callRing: null
    }, {
        preventFetch: true
    });
    return true;
}

});

parcelRegister("1jEjH", function(module, exports) {

$parcel$export(module.exports, "homeViewOf", () => $0f56d6d74a38e23a$export$83a67770f7739ac3);
$parcel$export(module.exports, "homeViewSegments", () => $0f56d6d74a38e23a$export$c634301c00d43b64);
$parcel$export(module.exports, "homeViewGroupOf", () => $0f56d6d74a38e23a$export$ea9b412d418c534c);
$parcel$export(module.exports, "homeViewGroups", () => $0f56d6d74a38e23a$export$868cf6b5aadb3e81);
$parcel$export(module.exports, "homeViewModes", () => $0f56d6d74a38e23a$export$1912b45e01a71cfe);
$parcel$export(module.exports, "homeViewGroupSelect", () => $0f56d6d74a38e23a$export$36bd51cbc033c120);
$parcel$export(module.exports, "homeViewMenuOpen", () => $0f56d6d74a38e23a$export$5001620f294b3321);
$parcel$export(module.exports, "homeViewMenuItems", () => $0f56d6d74a38e23a$export$ac405f10c0eb2672);
$parcel$export(module.exports, "homeViewMenuAction", () => $0f56d6d74a38e23a$export$53999c4197a0e67d);
$parcel$export(module.exports, "homeViewNavigationKeydown", () => $0f56d6d74a38e23a$export$ddb28a0d6c72b0b4);
$parcel$export(module.exports, "homeViewShown", () => $0f56d6d74a38e23a$export$66e4cf9108eb336d);
$parcel$export(module.exports, "homeTabsOnScreen", () => $0f56d6d74a38e23a$export$357d6e3689a0dac7);
$parcel$export(module.exports, "homeViewSelect", () => $0f56d6d74a38e23a$export$2d70ebe3283325d2);
$parcel$export(module.exports, "homeModeSync", () => $0f56d6d74a38e23a$export$8418cb2b0c4fb9b9);
// homeView.js — THE HOME'S TABS: Main · Dashboard · Chat · Present · Build.
//
// Nika 2026-10-23: "instead of [fly,dashboard,agent] rename [Main, Dashboard,
// Chat, Present, Build] and draw related experience for each tab aligning AI
// mode, so therefore we might be able to remove dropdown from chatpromptarea
// on canvas and only keep in sidebar and other places".
//
// ONE TAB, ONE AI MODE (functions/assistantMode.js) — each tab is the screen
// its mode makes in the home's main area:
//   Main       'fly'           the Fly canvas (components/AssistantFlyView.js):
//                              the workspace's start screen, or the session's
//                              composed pages
//   Dashboard  'dashboard'     the home board (pages/main.js); an ask builds a
//                              generated board over it (AssistantBoardView)
//   Chat       'assistant'     the conversation in the main area (the main
//                              thread, components/AssistantMainThread.js);
//                              empty, it offers the workspace's starters
//                              (components/HomeTabStart.js, tab 'chat')
//   Present    'presentation'  a live deck (AssistantDeckView); before one,
//                              Present's start screen (HomeTabStart, 'present')
//   Build      'apps'          the app builder itself — the /add-app page on
//                              the home (components/HomeBuildView.js,
//                              functions/homeBuild.js; Nika 2026-10-23: "build
//                              tab should reuse ui/ux of /add-apps")
// Tools ('tools') has no tab of its own: it is a conversation, so its screen
// is Chat's. Every tab but Main asks with the MAIN placement
// (`assistantDock: 'main'` — the answer becomes the home's screen,
// functions/assistantMainThread.js assistantSendRoute); Fly holds the main area
// whatever the placement.
//
// THE TABS ARE THE MODE ON THE HOME, so the composer's mode dropdown stands
// down there (homeTabsOnScreen — canvas CanvasPromptTextarea's two chip
// mounts); the sidebar's chip and the composer's focus panel keep theirs.
//
// THE VIEW IS READ, NEVER STORED: the conversation holding the main area is
// Chat (Build in Apps mode), the Fly canvas is Main, a deck — or Presentation
// mode — is Present, Apps mode is Build, everything else is the dashboard. So
// the tabs agree with every other way in or out: the sidebar's mode menu, a
// `?fly=` link, a view's own Esc, a thread opened from the sidebar.
//
// MAIN IS THE DEFAULT VIEW (Nika 2026-10-22: "ok make fly default view"): a
// person who never chose a mode is in Fly mode (state-app.js), so their home
// opens on Main (functions/assistantFlyWorkspace.js
// assistantFlyWorkspaceMounted). A choice of their own — any tab here, any row
// of the mode menu — wins from then on, on every device (the record). Where
// the person cannot ask (assistantFlyAvailable), the home stays the dashboard
// and offers no tabs.
//
// FRANK: every export is self-contained; siblings through `this.call`.
// The tab on screen. Every gate is read up front (reactive callers).
const $0f56d6d74a38e23a$export$83a67770f7739ac3 = function homeViewOf(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this.context && this.context.functions || {};
    const thread = typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    const fly = !!this.call('assistantFlyShown', r);
    const deck = typeof fns.assistantDeckShown === 'function' ? !!this.call('assistantDeckShown', r) : false;
    const mode = r.assistantMode;
    if (thread) return mode === 'apps' ? 'build' : 'chat';
    if (fly) return 'main';
    if (deck || mode === 'presentation') return 'present';
    if (mode === 'apps') return 'build';
    return 'dashboard';
};
const $0f56d6d74a38e23a$export$c634301c00d43b64 = function homeViewSegments() {
    return [
        {
            key: 'viewMain',
            value: 'main',
            text: 'workspace.homeView.main'
        },
        {
            key: 'viewDashboard',
            value: 'dashboard',
            text: 'shell.headerTabs.dashboard'
        },
        {
            key: 'viewChat',
            value: 'chat',
            text: 'workspace.homeView.chat'
        },
        {
            key: 'viewPresent',
            value: 'present',
            text: 'workspace.homeView.present'
        },
        {
            key: 'viewBuild',
            value: 'build',
            text: 'workspace.homeView.build'
        }
    ];
};
const $0f56d6d74a38e23a$export$ea9b412d418c534c = function homeViewGroupOf(root) {
    const view = this.call('homeViewOf', root);
    if (view === 'main' || view === 'chat') return 'ask';
    if (view === 'build' || view === 'present') return 'create';
    return 'home';
};
const $0f56d6d74a38e23a$export$868cf6b5aadb3e81 = function homeViewGroups() {
    return [
        {
            key: 'groupHome',
            value: 'home',
            text: 'shell.app.home'
        },
        {
            key: 'groupAsk',
            value: 'ask',
            text: 'workspace.aiCap.ask'
        },
        {
            key: 'groupCreate',
            value: 'create',
            text: 'common.action.create'
        }
    ];
};
const $0f56d6d74a38e23a$export$1912b45e01a71cfe = function homeViewModes(root, destination) {
    const group = destination || this.call('homeViewGroupOf', root);
    if (group === 'create') return [
        {
            key: 'modeBuild',
            value: 'build',
            text: 'ai.assistantMode.apps'
        },
        {
            key: 'modePresent',
            value: 'present',
            text: 'canvas.typeFilter.presentation'
        }
    ];
    return [
        {
            key: 'modePages',
            value: 'main',
            text: 'canvas.navbar.pages.panelTitle'
        },
        {
            key: 'modeChat',
            value: 'chat',
            text: 'workspace.homeView.chat'
        }
    ];
};
const $0f56d6d74a38e23a$export$36bd51cbc033c120 = function homeViewGroupSelect(value, mode) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    if (![
        'home',
        'ask',
        'create'
    ].includes(value)) return false;
    const current = this.call('homeViewGroupOf', root);
    const requested = value === 'ask' && [
        'main',
        'chat'
    ].includes(mode) || value === 'create' && [
        'build',
        'present'
    ].includes(mode) ? mode : null;
    if (value === current) return requested ? this.call('homeViewSelect', requested) : false;
    const view = this.call('homeViewOf', root);
    // Only remember the mode, scoped to this workspace. Drafts, pages and
    // decks stay owned by their existing view state; no content is copied.
    const workspaceId = String(root.workspace?.id || root.workspace?._id || '');
    const stored = root._homeViewRecent;
    const recent = stored?.workspaceId === workspaceId ? {
        ...stored
    } : {
        workspaceId: workspaceId
    };
    if (current === 'ask' || current === 'create') recent[current] = view;
    root.update({
        _homeViewRecent: recent
    });
    const next = value === 'home' ? 'dashboard' : value === 'ask' ? recent.ask === 'chat' ? 'chat' : 'main' : recent.create === 'present' ? 'present' : 'build';
    return this.call('homeViewSelect', requested || next);
};
const $0f56d6d74a38e23a$export$5001620f294b3321 = function homeViewMenuOpen(anchor, group) {
    const root = this.state?.root;
    if (!root || ![
        'ask',
        'create'
    ].includes(group)) return false;
    if (!this.call('homeViewShown', root)) return false;
    const node = anchor?.node;
    if (!node || typeof node.getBoundingClientRect !== 'function') return false;
    const box = node.getBoundingClientRect();
    root.update({
        contextDropdown: {
            open: true,
            x: Math.round(box.left),
            y: Math.round(box.bottom + 8),
            homeViewGroup: group,
            itemsFn: 'homeViewMenuItems',
            actionFn: 'homeViewMenuAction'
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $0f56d6d74a38e23a$export$ac405f10c0eb2672 = function homeViewMenuItems(root) {
    const menu = root?.contextDropdown;
    if (!menu?.open || ![
        'ask',
        'create'
    ].includes(menu.homeViewGroup)) return [];
    const fns = this.context && this.context.functions || {};
    const tabOf = {
        pages: 'main',
        chat: 'chat',
        build: 'build',
        present: 'present',
        home: 'dashboard'
    };
    const current = typeof fns.assistantEffectiveView === 'function' ? tabOf[this.call('assistantEffectiveView', root)] || 'dashboard' : this.call('homeViewOf', root);
    return this.call('homeViewModes', root, menu.homeViewGroup).map((mode)=>({
            key: mode.key,
            action: 'homeViewMode',
            view: mode.value,
            label: mode.text,
            checked: current === mode.value
        }));
};
const $0f56d6d74a38e23a$export$53999c4197a0e67d = function homeViewMenuAction(action, item) {
    const root = this.state?.root;
    if (!root || action !== 'homeViewMode' || !this.call('homeViewShown', root)) return false;
    const group = root.contextDropdown?.homeViewGroup;
    const offered = this.call('homeViewMenuItems', root);
    if (!offered.some((mode)=>mode.view === item?.view)) return false;
    root.update({
        contextDropdown: null
    }, {
        preventFetch: true
    });
    this.call('homeViewGroupSelect', group, item.view);
    return true;
};
const $0f56d6d74a38e23a$export$ddb28a0d6c72b0b4 = function homeViewNavigationKeydown(event, item) {
    const group = item?.state?.value;
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && group !== 'home') {
        event.preventDefault();
        this.call('homeViewMenuOpen', item, group);
        return;
    }
    const track = item?.parent;
    const items = typeof track?.getChildren === 'function' ? track.getChildren() : [];
    const index = items.indexOf(item);
    if (index < 0) return;
    const step = {
        ArrowRight: 1,
        ArrowLeft: -1
    }[event.key];
    const next = step ? items[(index + step + items.length) % items.length] : event.key === 'Home' ? items[0] : event.key === 'End' ? items[items.length - 1] : null;
    if (!next || next === item) return;
    event.preventDefault();
    this.call('homeViewGroupSelect', next.state?.value);
    next.node?.focus?.();
};
const $0f56d6d74a38e23a$export$66e4cf9108eb336d = function homeViewShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const editing = !!r._homeCustomizeMode;
    const ws = r.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    const fns = this.context && this.context.functions || {};
    if (!workspaceId || editing) return false;
    if (typeof fns.setAssistantMode !== 'function') return false;
    if (typeof fns.assistantFlyAvailable === 'function') return !!this.call('assistantFlyAvailable', r);
    return true;
};
const $0f56d6d74a38e23a$export$357d6e3689a0dac7 = function homeTabsOnScreen(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this.context && this.context.functions || {};
    const pane = !!(r._canvasSlot || r._canvasSlotSecond);
    const path = typeof r.currentPath === 'string' && r.currentPath ? r.currentPath : '/';
    const bare = typeof fns.stripWorkspacePrefix === 'function' ? this.call('stripWorkspacePrefix', path) : path;
    const home = typeof bare === 'string' && bare.split(/[?#]/)[0].replace(/\/+$/, '') === '';
    const offered = !!this.call('homeViewShown', r);
    return home && !pane && offered;
};
const $0f56d6d74a38e23a$export$2d70ebe3283325d2 = function homeViewSelect(value) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const tabs = [
        'main',
        'dashboard',
        'chat',
        'present',
        'build'
    ];
    if (!tabs.includes(value)) return false;
    const fns = this.context && this.context.functions || {};
    const was = this.call('homeViewOf', root);
    if (was === value) return false;
    // BLD-13 (Nika 2026-10-25: "Change only the home view") — a tab sets the
    // HOME's mode, never the person's pick: `_homeMode` names it for this
    // workspace (with the pick it covers, `barMode`), and setAssistantMode's
    // local write persists nothing. Off the home, homeModeSync gives the pick
    // back, so the build bar keeps the mode the person chose there.
    const mode = (m)=>{
        if (root.assistantMode === m) return;
        const workspaceId = String(root.workspace?.id || root.workspace?._id || '');
        const hm = root._homeMode;
        const barMode = hm && hm.workspaceId === workspaceId && hm.barMode ? hm.barMode : root.assistantMode;
        root.update({
            _homeMode: {
                workspaceId: workspaceId,
                mode: m,
                barMode: barMode
            }
        }, {
            preventFetch: true
        });
        this.call('setAssistantMode', m, {
            local: true
        });
    };
    const placeMain = ()=>{
        if (root.assistantDock !== 'main' && typeof fns.setAssistantDock === 'function') this.call('setAssistantDock', 'main');
    };
    const away = (name)=>{
        if (typeof fns[name] === 'function') this.call(name);
    };
    if (value === 'chat') {
        // A conversation mode first — the one the person had (Tools is one),
        // else the one Fly came from when it was one, else Assistant. Then the
        // main placement, and the thread last (a mode change may close a thread
        // on its way, assistantMode.js): the one going on, or an empty one with
        // the workspace's starters.
        // The person's own pick comes first when it is a conversation: the tabs
        // persist nothing (BLD-13), so the pick a home tab covers is in
        // `_homeMode.barMode`, else the record.
        const chat = [
            'assistant',
            'tools'
        ];
        if (!chat.includes(root.assistantMode)) {
            const hm = root._homeMode;
            const workspaceId = String(root.workspace?.id || root.workspace?._id || '');
            const own = hm && hm.workspaceId === workspaceId && hm.barMode ? hm.barMode : root.userPrefs && root.userPrefs.assistantMode;
            const before = chat.includes(own) ? own : typeof fns.assistantModeBeforeFly === 'function' ? this.call('assistantModeBeforeFly') : 'assistant';
            mode(chat.includes(before) ? before : 'assistant');
        }
        placeMain();
        if (typeof fns.assistantMainThreadShow !== 'function') return false;
        return !!this.call('assistantMainThreadShow');
    }
    // Every other tab: the conversation steps aside when it holds the home (it
    // stays in the sidebar and the thread chips) — Build before a build has none.
    if ((was === 'chat' || was === 'build') && typeof fns.assistantMainThreadOpen === 'function' && this.call('assistantMainThreadOpen', root)) away('assistantMainThreadClose');
    if (value === 'main') {
        // Not in Fly mode yet: the mode pick opens the canvas by itself (and puts
        // a board, a deck and the thread away — assistantFlyWorkspaceEnter).
        if (root.assistantMode !== 'fly') {
            mode('fly');
            return true;
        }
        // Fly mode with its canvas closed (closed earlier, or left on another
        // route): bring the canvas back here.
        if (this.call('assistantFlyShown', root)) return true;
        if (typeof fns.assistantFlyWorkspaceEnter === 'function') return !!this.call('assistantFlyWorkspaceEnter');
        return true;
    }
    // Dashboard, Present, Build: the other tabs' views step aside — a deck for
    // the Dashboard and Build, a generated board for Present and Build — and a
    // Fly canvas shown outside Fly mode (a `?fly=` link answered in another
    // mode) is put away. Leaving Fly mode closes its canvas with the mode.
    if (value !== 'present') away('assistantDeckDismiss');
    if (value !== 'dashboard') away('assistantBoardDismiss');
    mode(value === 'dashboard' ? 'dashboard' : value === 'present' ? 'presentation' : 'apps');
    if (this.call('assistantFlyShown', root)) away('assistantFlyWorkspaceDismiss');
    placeMain();
    return true;
};
const $0f56d6d74a38e23a$export$8418cb2b0c4fb9b9 = function homeModeSync() {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const hm = root._homeMode;
    if (!hm || typeof hm !== 'object') return false;
    const modes = [
        'assistant',
        'dashboard',
        'tools',
        'apps',
        'presentation',
        'fly'
    ];
    const fns = this.context && this.context.functions || {};
    const workspaceId = String(root.workspace?.id || root.workspace?._id || '');
    const path = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
    const bare = typeof fns.stripWorkspacePrefix === 'function' ? this.call('stripWorkspacePrefix', path) : path;
    const home = typeof bare === 'string' && bare.split(/[?#]/)[0].replace(/\/+$/, '') === '';
    const live = root.assistantMode;
    if (home && hm.workspaceId === workspaceId) {
        if (!modes.includes(hm.mode) || live === hm.mode) return false;
        root.update({
            assistantMode: hm.mode
        }, {
            preventFetch: true
        });
        return true;
    }
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    const stored = typeof fns.readStoredAssistantMode === 'function' ? this.call('readStoredAssistantMode') : null;
    const pick = [
        prefs && prefs.assistantMode,
        stored,
        hm.barMode
    ].find((m)=>modes.includes(m)) || 'fly';
    const patch = {};
    if (hm.workspaceId !== workspaceId) patch._homeMode = null;
    if (live === hm.mode && live !== pick) patch.assistantMode = pick;
    if (!Object.keys(patch).length) return false;
    root.update(patch, {
        preventFetch: true
    });
    return true;
};

});

parcelRegister("gv0iu", function(module, exports) {

$parcel$export(module.exports, "homeTabStartShown", () => $c02fc5a3b82c4fe9$export$5ba226c69c4b0a71);
$parcel$export(module.exports, "homeTabStartCopy", () => $c02fc5a3b82c4fe9$export$91cb45254e5646f8);
$parcel$export(module.exports, "homeTabStartOnHome", () => $c02fc5a3b82c4fe9$export$8a6ed01c970f9b49);
$parcel$export(module.exports, "homeTabStartCard", () => $c02fc5a3b82c4fe9$export$795647fe44920843);
$parcel$export(module.exports, "homeTabStartTiles", () => $c02fc5a3b82c4fe9$export$3940bac3f84f123e);
$parcel$export(module.exports, "homeTabStartItems", () => $c02fc5a3b82c4fe9$export$71cf41a8b9acb261);
$parcel$export(module.exports, "homeTabStartAsk", () => $c02fc5a3b82c4fe9$export$bae6d5eddd0789dc);
$parcel$export(module.exports, "homeTabStartOpen", () => $c02fc5a3b82c4fe9$export$39cdbc1cc870426f);
// homeTabStart.js — THE HOME TABS' OWN SCREENS (Nika 2026-10-23: "instead of
// [fly,dashboard,agent] rename [Main, Dashboard, Chat, Present, Build] and
// draw related experience for each tab aligning AI mode").
//
// A tab whose mode makes nothing until it is asked shows ITS start screen
// (components/HomeTabStart.js) in the Fly start screen's shape — the day and
// the workspace, one heading in two inks, one line on what the tab makes, ask
// tiles, and what the person already has of that kind. Everything is made from
// this workspace (its apps, its starters, its saved decks — nothing per
// tenant, nothing hardcoded):
//   chat     the conversation's empty state (components/AssistantMainThread.js):
//            the workspace's own starters (functions/assistantStarters.js)
//   present  Presentation mode before a deck: a deck of the week, of what needs
//            the person, of each of its apps; the decks already made
// A tile asks in the tab's mode through the composer's own path (homeAiSend:
// with the main placement the answer becomes the home's screen — a deck, the
// conversation).
//
// Build has no start screen of its own: its tab IS the app builder, the
// /add-app page on the home (functions/homeBuild.js; Nika 2026-10-23: "build
// tab should reuse ui/ux of /add-apps") — the builder's own empty state, its
// ready-made apps and the person's apps are where a build starts.
//
// FRANK: every export is self-contained; siblings through `this.call`.
// Where a start screen shows. Present: its mode on the home with the tabs on
// screen (functions/homeView.js homeTabsOnScreen), nothing made yet — a deck
// on screen or the conversation holding the home takes the area instead.
// Chat: the conversation itself, empty (wherever the thread shows — its view
// gates the rest). Build: never (its tab is the app builder,
// functions/homeBuild.js). Every key is read up front (reactive callers).
const $c02fc5a3b82c4fe9$export$5ba226c69c4b0a71 = function homeTabStartShown(root, tab) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this.context && this.context.functions || {};
    const mode = r.assistantMode;
    const list = Array.isArray(r.chatMessages) ? r.chatMessages : [];
    const thread = typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    const deck = typeof fns.assistantDeckShown === 'function' ? !!this.call('assistantDeckShown', r) : false;
    const onScreen = typeof fns.homeTabsOnScreen === 'function' ? !!this.call('homeTabsOnScreen', r) : false;
    if (tab === 'chat') return thread && list.length === 0;
    if (!onScreen || thread) return false;
    if (tab === 'present') return mode === 'presentation' && !deck;
    return false;
};
const $c02fc5a3b82c4fe9$export$91cb45254e5646f8 = function homeTabStartCopy(root, tab) {
    const KEYS = {
        // Chat's line is the conversation's own (its empty hint under the tiles,
        // components/AssistantMainThread.js ThreadEmpty): no second one here.
        chat: {
            lead: 'workspace.homeTab.chat.titleLead',
            rest: 'workspace.homeTab.chat.titleRest',
            line: '',
            tiles: 'workspace.flyStart.tilesLabel'
        },
        present: {
            lead: 'workspace.homeTab.present.titleLead',
            rest: 'workspace.homeTab.present.titleRest',
            line: 'workspace.homeTab.present.lead',
            tiles: 'workspace.flyStart.tilesLabel',
            kept: 'workspace.homeTab.present.kept'
        }
    };
    const keys = KEYS[tab] || KEYS.chat;
    const word = (key)=>{
        const v = this.call('polyglot', key);
        return v == null ? '' : String(v);
    };
    const scope = String(this.call('assistantScopeName', root) || '');
    return {
        lead: word(keys.lead).replace('{workspace}', scope),
        rest: word(keys.rest),
        line: keys.line ? word(keys.line) : '',
        tiles: word(keys.tiles),
        kept: keys.kept ? word(keys.kept) : ''
    };
};
const $c02fc5a3b82c4fe9$export$8a6ed01c970f9b49 = function homeTabStartOnHome(el) {
    let node = el || this;
    for(let i = 0; node && i < 24; i++){
        if (node.mainHost === 'over') return false;
        node = node.parent;
    }
    return true;
};
const $c02fc5a3b82c4fe9$export$795647fe44920843 = function homeTabStartCard(el) {
    return this.call('homeTabStartOnHome', el) ? 'var(--home-card-bg, var(--theme-card-background))' : 'cardSolid';
};
const $c02fc5a3b82c4fe9$export$3940bac3f84f123e = function homeTabStartTiles(root, tab) {
    const r = root && typeof root === 'object' ? root : {};
    const MAX = 6;
    const word = (key)=>{
        const v = this.call('polyglot', key);
        return v == null ? '' : String(v);
    };
    const safe = (v)=>String(v == null ? '' : v).replace(/[^A-Za-z0-9]+/g, '');
    const out = [];
    const seen = new Set();
    const push = (key, text, icon, app, extra)=>{
        const t = String(text || '').trim();
        if (!t || seen.has(t.toLowerCase()) || out.length >= MAX) return;
        seen.add(t.toLowerCase());
        out.push({
            key: 'homeTab' + safe(tab) + safe(key || t),
            kind: 'ask',
            hero: false,
            text: t,
            prompt: t,
            count: '',
            words: '',
            severity: '',
            signal: '',
            app: String(app || ''),
            icon: icon || 'magicstar',
            more: '',
            localAction: '',
            form: '',
            span: 1,
            tall: false,
            ...extra || {}
        });
    };
    if (tab === 'chat') {
        for (const row of this.call('workspaceStarters', r) || [])push(row && row.key, row && row.text, row && row.icon, row && row.caption, typeof (row && row.localAction) === 'string' && row.localAction ? {
            localAction: row.localAction,
            prompt: String(row.prompt || row.text || ''),
            // a starter that opens an app's own form (assistantStarterForm)
            ...typeof row.form === 'string' && row.form ? {
                form: row.form
            } : {}
        } : {
            prompt: String(row && (row.prompt || row.text) || '')
        });
        return out;
    }
    if (tab !== 'present') return [];
    // The apps the launcher shows (the flag and access law already applied):
    // the workspace's own first, the builder views left out.
    const builder = new Set();
    for (const group of this.call('searchAppGroupsFor', r) || []){
        if (!group || group.key !== 'views') continue;
        for (const app of group.apps || [])if (app && app.route) builder.add(app.route);
    }
    const tiles = (this.call('visibleStarterTiles', r) || []).filter((t)=>t && t.route && !builder.has(t.route));
    const ranked = [
        ...tiles.filter((t)=>t.custom),
        ...tiles.filter((t)=>!t.custom)
    ];
    // An installed app's tile (it carries `appKey`) by its App Store name,
    // through installedAppName (Nika 2026-10-23: "app names = what a person sees
    // in the workspace App Store") — "Present Insights: where we stand", never
    // the manifest's "Analytics". A house tile's key and a customer's own words
    // read through polyglot, as before.
    const nameOf = (t)=>String(t.appKey && this.call('installedAppName', {
            appKey: t.appKey,
            title: t.title
        }) || '') || word(t.title) || String(t.title || '');
    const scope = String(this.call('assistantScopeName', r) || '');
    push('week', word('workspace.homeTab.present.week').replace('{workspace}', scope), 'date', scope);
    push('attention', word('workspace.homeTab.present.attention'), 'lnAttention', scope);
    for (const t of ranked){
        const name = nameOf(t);
        if (name) push(t.route, word('workspace.homeTab.present.app').replace('{app}', name), t.icon, name);
    }
    return out;
};
const $c02fc5a3b82c4fe9$export$71cf41a8b9acb261 = function homeTabStartItems(root, tab) {
    const r = root && typeof root === 'object' ? root : {};
    const MAX = 6;
    const safe = (v)=>String(v == null ? '' : v).replace(/[^A-Za-z0-9]+/g, '');
    const word = (key)=>{
        const v = this.call('polyglot', key);
        return v == null ? '' : String(v);
    };
    if (tab === 'present') {
        const out = [];
        const deck = r._aiDeck;
        if (deck && deck.id && !deck.savedId && deck.status === 'ready' && !deck.preview && (deck.title || deck.prompt)) out.push({
            key: 'homeTabDeck' + safe(deck.id),
            kind: 'deck',
            id: String(deck.id),
            title: String(deck.title || deck.prompt),
            meta: word('workspace.homeTab.present.unsaved')
        });
        for (const b of Array.isArray(r._aiBoards) ? r._aiBoards : []){
            if (out.length >= MAX) break;
            const isDeck = b && b.id && (b.kind === 'deck' || b.spec && b.spec.kind === 'deck');
            if (!isDeck) continue;
            const at = Date.parse(b.updatedAt || b.updated_at || b.createdAt || b.created_at || '');
            out.push({
                key: 'homeTabDeck' + safe(b.id),
                kind: 'deck',
                id: String(b.id),
                title: String(b.title || b.spec && b.spec.title || b.id),
                at: Number.isFinite(at) ? at : 0,
                meta: ''
            });
        }
        return out;
    }
    return [];
};
const $c02fc5a3b82c4fe9$export$bae6d5eddd0789dc = function homeTabStartAsk(s) {
    const tile = s && typeof s.parse === 'function' ? s.parse() : s;
    if (!tile || typeof tile !== 'object' || tile.kind === 'skeleton') return null;
    const fns = this.context && this.context.functions || {};
    if (tile.localAction && typeof fns[tile.localAction] === 'function') // the tile rides along: a local action that needs its row (a starter
    // naming an app's form, assistantStarterForm) reads it; others ignore it
    return this.call(tile.localAction, tile);
    const prompt = String(tile.prompt || tile.text || '').trim();
    if (!prompt || typeof fns.homeAiSend !== 'function') return null;
    return this.call('homeAiSend', prompt);
};
const $c02fc5a3b82c4fe9$export$39cdbc1cc870426f = function homeTabStartOpen(s) {
    const item = s && typeof s.parse === 'function' ? s.parse() : s;
    if (!item || typeof item !== 'object') return null;
    if (item.kind === 'deck' && item.id) return this.call('assistantBoardSelect', item.id);
    return null;
};

});

parcelRegister("B2MdJ", function(module, exports) {

$parcel$export(module.exports, "homeBuildShown", () => $06f59c38796c6057$export$3553eb48ed956938);
$parcel$export(module.exports, "homeBuildMount", () => $06f59c38796c6057$export$b62a76d95ffdd7df);
$parcel$export(module.exports, "homeBuildInPane", () => $06f59c38796c6057$export$7c3e5497427c269c);
$parcel$export(module.exports, "homeBuildUnmount", () => $06f59c38796c6057$export$5f93719da44054cb);
$parcel$export(module.exports, "homeBuildFit", () => $06f59c38796c6057$export$b8d4438e9f2e822d);
$parcel$export(module.exports, "homeBuildPrefetch", () => $06f59c38796c6057$export$ef2322863bd26af1);
// homeBuild.js — THE HOME'S BUILD TAB IS THE APP BUILDER (Nika 2026-10-23:
// "build tab should reuse ui/ux of /add-apps").
//
// The Build tab does not draw a builder of its own: it mounts the /add-app
// page itself (pages/add-app.js — the build conversation on the left, the
// build canvas with the ready-made apps, the person's apps and the built app
// on the right) in the home's grid area, through the route registry the
// PageSlot mounts routes from (`context.pages`, a lazy entry: the page's chunk
// loads on the first visit, the page skeleton shows meanwhile). One page, two
// places — every change to the builder reaches both.
//
// Three overrides make it a part of the home, not a second page in it: a
// `div`, no `main-content` id and no metadata (the home keeps its landmark,
// its skip link and its title), a clear ground (the home's own shows round
// the builder's sheet). And `scope.addAppThreadInUrl: false`: the home's URL
// is never the thread's link — `?thread=` is also mail's and chat's name
// (functions/assistantThreadUrl.js), so the builder neither reads nor clears
// it here.
//
//   homeBuildShown   the gate: the home's tabs on screen, Build the tab, no
//                    conversation holding the home
//   homeBuildMount   once, on the first show: the page into the view
//   homeBuildFit     the view's band — from its own top to the viewport's
//                    bottom (`--home-build-top`, components/HomeBuildView.js)
//   homeBuildPrefetch the builder's chunk loads while the pointer rests on the
//                    Build tab (the shell's route prefetch), so the tab opens
//                    on the builder, not on its skeleton
//
// ONE BUILDER AT A TIME. The builder's state is the root's (`_addApp*`, the
// `_ax_*` thread) and the AI's renders go to ONE address
// (`window.__addAppHost`), so two builders on screen would fight over both.
// On the home /add-app opens as this tab (functions/searchApps.js
// openAppPage, functions/forceBuildApp.js watchAiBuildOutput), and when a
// pane over the home holds /add-app anyway (a split, a pane that was already
// open) the home's builder leaves the tree (homeBuildUnmount) and comes back
// on the tab's next show:
//   homeBuildInPane   a pane over the home holds /add-app
//   homeBuildUnmount  the page out of the view, the skeleton back
//
// FRANK: every export is self-contained; siblings through `this.call`.
// The gate. Build is the tab on screen (homeViewOf: Apps mode, no Fly canvas,
// no deck), the tabs are (the home, no pane over it), and no conversation holds
// the home (a thread opened from the sidebar in Apps mode does). Every key is
// read up front (reactive callers).
const $06f59c38796c6057$export$3553eb48ed956938 = function homeBuildShown(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this.context && this.context.functions || {};
    const onScreen = typeof fns.homeTabsOnScreen === 'function' ? !!this.call('homeTabsOnScreen', r) : false;
    const tab = typeof fns.homeViewOf === 'function' ? this.call('homeViewOf', r) : null;
    const thread = typeof fns.assistantMainThreadOpen === 'function' ? !!this.call('assistantMainThreadOpen', r) : false;
    return onScreen && tab === 'build' && !thread;
};
const $06f59c38796c6057$export$b62a76d95ffdd7df = async function homeBuildMount(el) {
    const host = el || this;
    if (!host || host.__homeBuildMounted || typeof host.set !== 'function') return false;
    const pages = host.context && host.context.pages || {};
    const entry = pages['/add-app'];
    if (!entry || typeof entry !== 'object') return false;
    host.__homeBuildMounted = true;
    // an unmount while the chunk loads makes this mount stale (homeBuildUnmount)
    const seq = host.__homeBuildSeq = (Number(host.__homeBuildSeq) || 0) + 1;
    let page = entry;
    const scope = entry.scope;
    if (scope && typeof scope.prefetch === 'function') try {
        page = await scope.prefetch(scope);
    } catch (err) {
        if (host.__homeBuildSeq === seq) host.__homeBuildMounted = false;
        console.warn('[homeBuild] the builder did not load:', err && err.message);
        return false;
    }
    // unmounted, gone, or a pane took the builder while the chunk loaded
    if (host.__homeBuildSeq !== seq) return false;
    const root = host.state && host.state.root;
    if (!page || typeof page !== 'object' || !host.__ref || this.call('homeBuildInPane', root)) {
        host.__homeBuildMounted = false;
        return false;
    }
    host.set({
        ...page,
        tag: 'div',
        id: null,
        metadata: null,
        gridRow: null,
        gridColumn: null,
        height: '100%',
        minHeight: '0',
        style: {
            ...page.style || {},
            background: 'transparent'
        },
        scope: {
            ...page.scope || {},
            addAppThreadInUrl: false
        }
    });
    // The lazy page can settle after the initial view measurement. Read the
    // mounted layout again so a fresh sign-in does not need a window resize.
    this.call('homeBuildFit', host);
    return true;
};
const $06f59c38796c6057$export$7c3e5497427c269c = function homeBuildInPane(root) {
    const r = root && typeof root === 'object' ? root : {};
    const fns = this.context && this.context.functions || {};
    const panes = [
        r._canvasSlot,
        r._canvasSlotSecond
    ];
    const bare = (p)=>{
        const raw = String(p).split(/[?#]/)[0];
        const s = typeof fns.stripWorkspacePrefix === 'function' ? this.call('stripWorkspacePrefix', raw) : raw;
        return (typeof s === 'string' ? s : raw).replace(/\/+$/, '');
    };
    return panes.some((p)=>typeof p === 'string' && p !== '' && bare(p) === '/add-app');
};
const $06f59c38796c6057$export$5f93719da44054cb = function homeBuildUnmount(el) {
    const host = el || this;
    if (!host || !host.__homeBuildMounted || typeof host.set !== 'function') return false;
    host.__homeBuildMounted = false;
    host.__homeBuildSeq = (Number(host.__homeBuildSeq) || 0) + 1;
    host.set({
        extends: 'PageSkeleton'
    });
    return true;
};
const $06f59c38796c6057$export$b8d4438e9f2e822d = function homeBuildFit(el) {
    const host = el || this;
    const node = host && host.node;
    if (!node || typeof node.getBoundingClientRect !== 'function') return false;
    const state = host.state && host.state.root;
    if (!this.call('homeBuildShown', state)) return false;
    if (typeof node.getClientRects === 'function' && node.getClientRects().length === 0) return false;
    if (typeof host.setNodeStyles !== 'function') return false;
    const root = typeof host.getRoot === 'function' ? host.getRoot() : null;
    const column = root && typeof root.lookdown === 'function' ? root.lookdown('MainColumn') : null;
    const scrolled = column && column.node ? Number(column.node.scrollTop) || 0 : 0;
    const top = Math.max(0, Math.round(node.getBoundingClientRect().top + scrolled));
    if (host.__homeBuildTop === top) return false;
    host.__homeBuildTop = top;
    host.setNodeStyles({
        '--home-build-top': top + 'px'
    });
    return true;
};
const $06f59c38796c6057$export$ef2322863bd26af1 = function homeBuildPrefetch(value) {
    if (value !== 'build') return false;
    const fns = this.context && this.context.functions || {};
    if (typeof fns.prefetchSlotRoute !== 'function') return false;
    return !!this.call('prefetchSlotRoute', '/add-app');
};

});

parcelRegister("jbjvY", function(module, exports) {

$parcel$export(module.exports, "addAppSidebarRows", () => $df6e2e9b4af8acb9$export$865141f82938beea);
$parcel$export(module.exports, "addAppSidebarEmpty", () => $df6e2e9b4af8acb9$export$be69a86fc41c2f1f);
$parcel$export(module.exports, "addAppScopeSelect", () => $df6e2e9b4af8acb9$export$97d4b2e64de089d7);
$parcel$export(module.exports, "addAppSidebarPick", () => $df6e2e9b4af8acb9$export$b947212462569716);
$parcel$export(module.exports, "addAppCurrentName", () => $df6e2e9b4af8acb9$export$37d648f4412b9aaf);
// addAppSidebar.js — THE BUILDER'S SIDEBARS (pages/add-app.js; Nika 2026-10-23:
// "make sidebar more appealing and beautiful"). The house rail parts carry the
// look — AppSidebarGroup's eyebrow, the kit's segmented choice, AppSidebarRow's
// one row law (components/AddAppSidebarRow.js) — and these say WHAT shows:
//   addAppSidebarRows   the person's apps where they live (Private · Shared),
//                       as rail rows: the glyph, the name, when it last changed
//   addAppSidebarEmpty  the line for a place with no app yet
//   addAppScopeSelect   the choice of the place (AppSegmented `select`)
//   addAppSidebarPick   a row's press: that app's thread and build
//   addAppCurrentName   the conversation's head: the app being built, or a new
//                       one
// One builder, two places: /add-app and the home's Build tab (functions/
// homeBuild.js) mount the same page, so both read these.
//
// FRANK: every export is self-contained; siblings through `this.call`.
// The person's apps in the chosen place, newest first, as AppSidebarRow's state
// (`label`, `icon`, `meta`); `id` is the app's own. Keys are prefixed, so no row
// is keyed by an HTML tag name. Every key is read up front (reactive callers).
const $df6e2e9b4af8acb9$export$865141f82938beea = function addAppSidebarRows(root) {
    const r = root && typeof root === 'object' ? root : {};
    const scope = r._addAppScope === 'shared' ? 'shared' : 'private';
    const apps = Array.isArray(r._userApps) ? r._userApps : [];
    const fns = this.context && this.context.functions || {};
    const word = (key)=>{
        const v = this.call('polyglot', key);
        return v == null ? '' : String(v);
    };
    const safe = (v)=>String(v == null ? '' : v).replace(/[^A-Za-z0-9]+/g, '');
    const at = (ext)=>{
        const raw = ext.updatedAt || ext.updated_at || ext.createdAt || ext.created_at;
        const t = typeof raw === 'number' ? raw : Date.parse(raw || '');
        return Number.isFinite(t) ? t : 0;
    };
    return apps.filter((ext)=>ext && ext.id && (ext.scope || 'private') === scope).map((ext, i)=>({
            ext: ext,
            t: at(ext),
            i: i
        })).sort((a, b)=>b.t - a.t || a.i - b.i).map(({ ext: ext, t: t })=>({
            key: 'addApp' + safe(ext.id),
            id: String(ext.id),
            label: String(ext.name || '').trim() || word('workspace.addApp.extensionFallback'),
            icon: ext.appKind === 'multipage' ? 'layers' : 'blocks',
            meta: t && typeof fns.timeAgo === 'function' ? String(this.call('timeAgo', t) || '') : ''
        }));
};
const $df6e2e9b4af8acb9$export$be69a86fc41c2f1f = function addAppSidebarEmpty(root) {
    const shared = !!root && root._addAppScope === 'shared';
    return shared ? {
        title: 'workspace.addApp.apps.emptyShared',
        line: 'workspace.addApp.apps.emptySharedLine'
    } : {
        title: 'workspace.addApp.apps.emptyPrivate',
        line: 'workspace.addApp.apps.emptyPrivateLine'
    };
};
const $df6e2e9b4af8acb9$export$97d4b2e64de089d7 = function addAppScopeSelect(value) {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    if (value !== 'private' && value !== 'shared') return false;
    if ((root._addAppScope === 'shared' ? 'shared' : 'private') === value) return false;
    root.update({
        _addAppScope: value
    });
    return true;
};
const $df6e2e9b4af8acb9$export$b947212462569716 = function addAppSidebarPick(id) {
    const root = this.state && this.state.root;
    const apps = root && Array.isArray(root._userApps) && root._userApps || [];
    const ext = apps.find((a)=>a && String(a.id) === String(id));
    if (!ext) return false;
    const self = this;
    // A phone shows one pane at a time: the picked app's preview
    // (functions/addAppPhonePane.js — the pane falls back to the chat until
    // something renders there).
    const fns0 = this.context && this.context.functions || {};
    if (typeof fns0.addAppPhonePaneSet === 'function') this.call('addAppPhonePaneSet', 'preview');
    try {
        // Where the panes stack (a phone), the app comes into view once it is
        // picked — the canvas sits under the conversation there (persona round
        // 3, W2: marcus tapped his app and nothing changed on screen).
        Promise.resolve(this.call('selectAddAppExtension', ext)).then(()=>{
            const fns = self.context && self.context.functions || {};
            if (typeof fns.addAppShowCanvas === 'function') self.call('addAppShowCanvas', self);
        }).catch((err)=>console.warn('[add-app] select extension failed', err));
    } catch (err) {
        console.warn('[add-app] select extension failed', err);
        return false;
    }
    return true;
};
const $df6e2e9b4af8acb9$export$37d648f4412b9aaf = function addAppCurrentName(root) {
    const r = root && typeof root === 'object' ? root : {};
    const id = r._addAppProjectId ? String(r._addAppProjectId) : '';
    const apps = Array.isArray(r._userApps) ? r._userApps : [];
    const ext = id ? apps.find((a)=>a && String(a.id) === id) : null;
    const name = ext && String(ext.name || '').trim();
    if (name) return name;
    const v = this.call('polyglot', id ? 'workspace.addApp.extensionFallback' : 'workspace.addApp.chat.newApp');
    return v == null ? '' : String(v);
};

});

parcelRegister("gX2iF", function(module, exports) {

$parcel$export(module.exports, "addAppBuilderLive", () => $c573f0cccc734dea$export$75cd7d34b6b2631b);
$parcel$export(module.exports, "addAppBuilderThreadOpen", () => $c573f0cccc734dea$export$15b52d57b9b5d671);
$parcel$export(module.exports, "addAppBuilderChatReveal", () => $c573f0cccc734dea$export$3d2a585a42e5c06d);
// THE BUILDER'S OWN CHAT as the place a hand-off lands.
//
// The add-app builder (pages/add-app.js) runs its conversation under the
// 'addapp' chat scope: `_ax_*` keys, the app's projectId, and turns the server
// reads as `surface: 'add-app-builder'` — the one surface the free first
// change is waived on. The server marks that surface PER TURN, so a turn on
// the builder's thread sent from the general drawer is an ordinary paid turn.
//
// Persona round 2d (marcus, 390 px, DEV 2026-10-26): scrolled down to the
// preview, he tapped the phone dock's AI "to get my build chat back", got the
// general drawer on a new chat, opened the build thread from its History, and
// his next three changes were quoted 442/389/388 credits.
//
//   addAppBuilderLive        the builder on the page now (the live render
//                            host's builder), or null
//   addAppBuilderThreadOpen  the general drawer holds the open builder's
//                            thread (the same conversation, an app bound)
//   addAppBuilderChatReveal  the builder chat into view, its composer focused
//
// ONE BUILDER AT A TIME (functions/homeBuild.js): the newest render host owns
// the address `__addAppHost` (pages/add-app.js AppRender) and gives it back
// when it leaves. Read here, never written.
//
// FRANK: every export is self-contained; siblings through `this.call`.
const $c573f0cccc734dea$export$75cd7d34b6b2631b = function addAppBuilderLive() {
    const win = this && this.context && this.context.window || (typeof window !== 'undefined' ? window : null);
    const host = win && win.__addAppHost;
    const builder = host && host.builder;
    const node = builder && builder.node;
    return node && node.isConnected ? builder : null;
};
const $c573f0cccc734dea$export$15b52d57b9b5d671 = function addAppBuilderThreadOpen(root) {
    const r = root && typeof root === 'object' ? root : this && this.state && this.state.root || {};
    const drawer = r.activeSessionId;
    const builder = r._ax_activeSessionId;
    const app = r._addAppProjectId;
    if (!drawer || drawer !== builder || !app) return false;
    return !!this.call('addAppBuilderLive');
};
const $c573f0cccc734dea$export$3d2a585a42e5c06d = function addAppBuilderChatReveal() {
    const builder = this.call('addAppBuilderLive');
    if (!builder || typeof builder.lookup !== 'function') return false;
    const main = builder.lookup('AppMain');
    const chat = main && main.Conversation && main.Conversation.Chat;
    const prompt = chat && typeof chat.lookdown === 'function' ? chat.lookdown('PromptTextarea') : null;
    const node = prompt && prompt.Textarea && prompt.Textarea.node;
    if (!node || node.isConnected === false) return false;
    if (typeof node.scrollIntoView === 'function') node.scrollIntoView({
        block: 'nearest'
    });
    if (typeof node.focus === 'function') node.focus({
        preventScroll: true
    });
    return true;
};

});

parcelRegister("ghE7d", function(module, exports) {

$parcel$export(module.exports, "workspaceSetupArrive", () => $bdad59f0f6e35c69$export$9341a36577dc3241);
$parcel$export(module.exports, "workspaceSetupWanted", () => $bdad59f0f6e35c69$export$9617f511997341f0);
$parcel$export(module.exports, "workspaceSetupRead", () => $bdad59f0f6e35c69$export$56bfad9e4943fca5);
$parcel$export(module.exports, "workspaceSetupPoll", () => $bdad59f0f6e35c69$export$db11033dab031a93);
$parcel$export(module.exports, "workspaceSetupEffects", () => $bdad59f0f6e35c69$export$5cd809fefa5516bd);
$parcel$export(module.exports, "workspaceSetupPrime", () => $bdad59f0f6e35c69$export$ad660b8ac51306e9);
$parcel$export(module.exports, "workspaceSetupRetry", () => $bdad59f0f6e35c69$export$101708b74a792a87);
$parcel$export(module.exports, "workspaceSetupRefreshApps", () => $bdad59f0f6e35c69$export$f1095d503b069229);
$parcel$export(module.exports, "workspaceSetupSiteRead", () => $bdad59f0f6e35c69$export$678e7dc9d83144b5);
$parcel$export(module.exports, "workspaceSetupPolicyRead", () => $bdad59f0f6e35c69$export$dd15c6237d7b1bfd);
$parcel$export(module.exports, "workspaceSetupOpenThread", () => $bdad59f0f6e35c69$export$5bdd3427b83e36ff);
$parcel$export(module.exports, "workspaceSetupUserClaim", () => $bdad59f0f6e35c69$export$8148322adc7f2fa3);
$parcel$export(module.exports, "workspaceSetupMeRead", () => $bdad59f0f6e35c69$export$50d52ebd43024fa8);
$parcel$export(module.exports, "workspaceSetupFirstBuild", () => $bdad59f0f6e35c69$export$3f7c39729818fd92);
$parcel$export(module.exports, "workspaceSetupBuildText", () => $bdad59f0f6e35c69$export$28be479a8cd0de65);
$parcel$export(module.exports, "workspaceSetupSendBuild", () => $bdad59f0f6e35c69$export$d345a3c4a5d441c5);
$parcel$export(module.exports, "workspaceSetupBuildPress", () => $bdad59f0f6e35c69$export$d7de46adb836cf3a);
$parcel$export(module.exports, "workspaceSetupOwnsBuild", () => $bdad59f0f6e35c69$export$6fa9aa131d97f24);
$parcel$export(module.exports, "workspaceSetupHoldsReady", () => $bdad59f0f6e35c69$export$fe51f244ce0d3ed);
$parcel$export(module.exports, "workspaceSetupBackHref", () => $bdad59f0f6e35c69$export$c779c2fd11220afa);
$parcel$export(module.exports, "workspaceSetupAppName", () => $bdad59f0f6e35c69$export$7557e7516f410628);
$parcel$export(module.exports, "workspaceSetupView", () => $bdad59f0f6e35c69$export$c7b891cbe212b5b7);
$parcel$export(module.exports, "workspaceSetupPlanView", () => $bdad59f0f6e35c69$export$fbc5e85147c9b50e);
$parcel$export(module.exports, "workspaceSetupPlanOf", () => $bdad59f0f6e35c69$export$c96bf7183dc098e2);
$parcel$export(module.exports, "workspaceSetupOpenSite", () => $bdad59f0f6e35c69$export$afd0cf439b8c35f9);
// workspaceSetup.js — THE WORKSPACE BUILDS ITSELF, in front of the person
// (merge programme lane WS1; Nika's decisions 9 and 11, 2026-10-25: the setup
// steps show IN the workspace while it builds itself, and the first workspace
// thread holds the plan, the summary of the site conversation and the first
// build).
//
// THE DATA IS THE SERVER'S (server lane S1, SDK `getWorkspaceSetup` /
// `startWorkspaceSetup`). Make it real calls `POST /core/workspaces/:id/setup`
// right before the hand-over; the job runs `name`, `language`, `theme`,
// `onboarding` and `thread` before it answers, then one `app:<owner/key>` step
// per app, `preset` and `website` in the background. `GET …/setup` answers
//   { id, run, rev, status: running | done | failed, reason?, stale,
//     steps: [{ key, status, at, reason?, detail? }], counts, threadId,
//     projectId, startedAt, finishedAt }   (or null; owner / admin only)
// and holds NO free text. The client computes nothing of the setup: every
// line, state and reason below is the answer's.
//
// WHERE IT SHOWS: the app builder (/add-app — Fly's hand-over lands there),
// in the job's first thread. The builder opens that thread (the `_ax_` scope,
// the build surface) and draws the setup above its messages
// (components/WorkspaceSetupThread.js): the plan card, one line per step (the
// apps in install order — each app reaches the navigation as its step turns
// done), the website card, the credits, one way back to the site the person
// came from, and the first build.
//
// WHEN: this tab arrived from Make it real (`?fly=` on the builder — the
// arrival mark below, kept for this tab), or the person's own onboarding
// record still says Fly owes them the ready screen (`pending` + `via: 'fly'`).
// No other boot asks. The job shows while it runs and for RECENT_MS after it
// finished; an older job is history (its thread stays a normal thread).
//
// THE POLL: while the job runs — 1 s, growing to 5 s, back to 1 s on every
// change; no request while the tab is hidden; it stops when the job settles,
// the workspace changes or after 15 minutes.
//
// THE FIRST BUILD (CORE r1, the first-build waiver): when the setup is done,
// the idea (`concepts[0].text`, else a line made from the plan) goes as the
// person's own message into the setup thread — seen as sent, never a hidden
// turn — through the builder's scope, so the turn carries the build surface
// (`context.surface: 'add-app-builder'`). It goes by itself only while the
// waiver is open (the signup policy says `firstBuildFree: true`, this person
// never claimed it, this workspace never used it). Otherwise the person
// presses Build (no server publishes what a build costs, so "enough" is never
// guessed), and a workspace with no credits shows the claim / top-up path
// first and sends the build when credits arrive. The client never decides who
// pays: the server's waiver and meter do.
//
// NEVER WRITTEN HERE: the onboarding record (the ready screen is its one
// writer — workspaceSetupHoldsReady tells it when to open), and no free text
// (the summary, the idea) in a URL, an event or a log line.
//
// FRANK: every export is self-contained (FA204) — the caps and the keys are
// restated where they are used, siblings through `this.call`. `this` is the
// calling element.
// The arrival — the builder's mount, BEFORE functions/addAppPrompt.js takes
// `fly` out of the address bar. Where the builder is the route
// (`opts.url !== false`), a `fly` param marks this tab: the mark ({ at, back })
// lives in this tab's sessionStorage so a reload inside RECENT_MS still finds
// it, and on the root for a page with no storage. `back` is the site the
// person came from (the referrer, when it is a platform host other than this
// one) — the way back. → true when the load is an arrival.
function $bdad59f0f6e35c69$export$9341a36577dc3241(root, opts) {
    const MARK = 'symbols_workspace_setup';
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object') return false;
    if (opts && opts.url === false) return false;
    const w = typeof window !== 'undefined' ? window : null;
    if (!w || !w.location) return false;
    let fly = false;
    try {
        fly = new URLSearchParams(String(w.location.search || '')).has('fly');
    } catch (_) {
        fly = false;
    }
    if (!fly) return false;
    const fns = el && el.context && el.context.functions || {};
    let back = '';
    try {
        const doc = w.document;
        const ref = doc && typeof doc.referrer === 'string' ? doc.referrer : '';
        const url = ref ? new URL(ref) : null;
        const local = url && (url.hostname === 'localhost' || url.hostname.endsWith('.localhost'));
        const platform = url && typeof fns.isPlatformHost === 'function' && el.call('isPlatformHost', url.hostname);
        if (url && (url.protocol === 'https:' || local && url.protocol === 'http:') && url.origin !== w.location.origin && platform) back = url.origin + url.pathname;
    } catch (_) {
        back = '';
    }
    const mark = {
        at: Date.now(),
        ws: '',
        back: back
    };
    try {
        const store = w.sessionStorage;
        if (store) store.setItem(MARK, JSON.stringify(mark));
    } catch (_) {
    /* no storage: the root keeps the mark for this page */ }
    r.__workspaceSetupArrival = mark;
    return true;
}
function $bdad59f0f6e35c69$export$9617f511997341f0(root) {
    const MARK = 'symbols_workspace_setup';
    const RECENT_MS = 600000;
    const r = root && typeof root === 'object' ? root : null;
    const out = {
        arrived: false,
        owed: false,
        back: ''
    };
    if (!r) return out;
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    let mark = r.__workspaceSetupArrival && typeof r.__workspaceSetupArrival === 'object' ? r.__workspaceSetupArrival : null;
    try {
        const store = typeof window !== 'undefined' ? window.sessionStorage : null;
        const raw = store ? store.getItem(MARK) : null;
        const kept = raw ? JSON.parse(raw) : null;
        if (kept && typeof kept === 'object' && Number(kept.at) >= Number(mark && mark.at || 0)) mark = kept;
    } catch (_) {
    /* the root's mark, if any */ }
    const age = mark ? Date.now() - Number(mark.at) : NaN;
    const ws = mark ? String(mark.ws || '') : '';
    out.arrived = Number.isFinite(age) && age >= 0 && age <= RECENT_MS && (!ws || ws === wsId);
    if (out.arrived) out.back = String(mark.back || '');
    // the hand-over still in the address bar (the builder has not mounted yet
    // and so has not marked it): an arrival all the same
    if (!out.arrived) try {
        const loc = typeof window !== 'undefined' ? window.location : null;
        out.arrived = !!loc && /\/add-app\/?$/.test(String(loc.pathname || '')) && new URLSearchParams(String(loc.search || '')).has('fly');
    } catch (_) {
        out.arrived = false;
    }
    const prefs = r.userPrefs && typeof r.userPrefs === 'object' ? r.userPrefs : null;
    const rec = prefs && prefs.onboarding && typeof prefs.onboarding === 'object' ? prefs.onboarding : null;
    out.owed = !!(rec && rec.status === 'pending' && rec.via === 'fly');
    return out;
}
function $bdad59f0f6e35c69$export$56bfad9e4943fca5(root, opts) {
    const MARK = 'symbols_workspace_setup';
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object' || typeof r.update !== 'function') return Promise.resolve(null);
    const wsOf = (x)=>{
        const w = x && x.workspace;
        return String(w && (w.id || w._id) || '');
    };
    const wsId = wsOf(r);
    if (!wsId || !r.workspaceReady) return Promise.resolve(null);
    const fns = el && el.context && el.context.functions || {};
    if (typeof fns.currentUserIsAdmin !== 'function' || !el.call('currentUserIsAdmin', r)) return Promise.resolve(null);
    const wanted = el.call('workspaceSetupWanted', r) || {};
    if (!o.force && !wanted.arrived && !wanted.owed) return Promise.resolve(null);
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    // The feature gate is the method itself (the shell's init-await proxy reads
    // a method the SDK lacks as undefined), never a version guess.
    if (!sdk || sdk.isNullClient === true || typeof sdk.getWorkspaceSetup !== 'function') return Promise.resolve(null);
    const flight = r.__workspaceSetupFlight;
    if (flight && flight.ws === wsId && flight.promise) return flight.promise;
    const prevOf = ()=>r._workspaceSetup && typeof r._workspaceSetup === 'object' && r._workspaceSetup.ws === wsId ? r._workspaceSetup : null;
    // The arrival is this workspace's from now on (a switch inside the window is
    // not an arrival for the next workspace).
    if (wanted.arrived) {
        try {
            const store = typeof window !== 'undefined' ? window.sessionStorage : null;
            const raw = store ? store.getItem(MARK) : null;
            const kept = raw ? JSON.parse(raw) : null;
            if (kept && typeof kept === 'object' && !kept.ws) store.setItem(MARK, JSON.stringify({
                ...kept,
                ws: wsId
            }));
        } catch (_) {
        /* the mark stays as it is */ }
        if (r.__workspaceSetupArrival && !r.__workspaceSetupArrival.ws) r.__workspaceSetupArrival = {
            ...r.__workspaceSetupArrival,
            ws: wsId
        };
    }
    const base = ()=>{
        const prev = prevOf();
        return {
            ws: wsId,
            status: 'reading',
            at: 0,
            job: null,
            code: '',
            arrived: !!wanted.arrived || !!(prev && prev.arrived),
            back: prev && prev.back || wanted.back || '',
            opened: prev && prev.opened || '',
            opening: !!(prev && prev.opening),
            retrying: !!(prev && prev.retrying),
            policy: prev && prev.policy !== undefined ? prev.policy : undefined,
            me: prev && prev.me || null,
            site: prev && prev.site || null,
            build: prev && prev.build || '',
            apps: prev && Array.isArray(prev.apps) && prev.apps || null
        };
    };
    if (!prevOf()) r.update({
        _workspaceSetup: base()
    }, {
        preventFetch: true
    });
    const clean = (job)=>{
        const steps = (Array.isArray(job.steps) ? job.steps : []).filter((x)=>x && typeof x.key === 'string' && x.key).map((x)=>({
                key: x.key,
                status: String(x.status || 'pending'),
                at: x.at || null,
                reason: typeof x.reason === 'string' ? x.reason : '',
                detail: x.detail && typeof x.detail === 'object' ? {
                    ...x.detail
                } : null
            }));
        return {
            id: String(job.id || job._id || ''),
            run: job.run || 0,
            rev: job.rev || 0,
            status: String(job.status || ''),
            reason: typeof job.reason === 'string' ? job.reason : '',
            stale: !!job.stale,
            steps: steps,
            threadId: job.threadId ? String(job.threadId) : '',
            projectId: job.projectId ? String(job.projectId) : '',
            startedAt: job.startedAt || null,
            finishedAt: job.finishedAt || null
        };
    };
    const promise = Promise.resolve().then(()=>sdk.getWorkspaceSetup(wsId)).then((res)=>{
        const bare = res && typeof res === 'object' && !Array.isArray(res) ? res : null;
        const job = bare && 'success' in bare && 'data' in bare ? bare.data && typeof bare.data === 'object' ? bare.data : null : bare;
        if (!job) return {
            status: 'none',
            job: null,
            code: ''
        };
        if (typeof job.status !== 'string' || !Array.isArray(job.steps)) return {
            status: 'error',
            job: null,
            code: 'shape'
        };
        return {
            status: 'ok',
            job: clean(job),
            code: ''
        };
    }, (err)=>{
        const code = String(err && (err.status || err.statusCode || err.code) || 'failed');
        return code === '403' || code === '404' ? {
            status: 'none',
            job: null,
            code: code
        } : {
            status: 'error',
            job: null,
            code: code
        };
    }).then((got)=>{
        if (r.__workspaceSetupFlight && r.__workspaceSetupFlight.promise === promise) r.__workspaceSetupFlight = null;
        if (wsOf(r) !== wsId) return null;
        const next = {
            ...base(),
            ...got,
            at: Date.now()
        };
        // An earlier answer of this page stays on screen through one failed
        // poll (a network blip must not wipe the lines the person is reading).
        const prev = prevOf();
        if (got.status === 'error' && prev && prev.status === 'ok' && prev.job) {
            next.status = 'ok';
            next.job = prev.job;
        }
        r.update({
            _workspaceSetup: next
        }, {
            preventFetch: true
        });
        return next;
    });
    r.__workspaceSetupFlight = {
        ws: wsId,
        promise: promise
    };
    return promise;
}
function $bdad59f0f6e35c69$export$db11033dab031a93(root, opts) {
    const BASE_MS = 1000;
    const CAP_MS = 5000;
    const GROW = 1.6;
    const MAX_MS = 900000;
    const FAILS = 3;
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object' || !el || typeof el.call !== 'function') return false;
    const wsOf = (x)=>{
        const w = x && x.workspace;
        return String(w && (w.id || w._id) || '');
    };
    const wsId = wsOf(r);
    if (!wsId) return false;
    const cur = r.__workspaceSetupPoll;
    if (cur && cur.ws === wsId && !o.force) {
        if (cur.live) {
            // a hidden tab came back: ask now instead of at the slow look
            if (o.wake && cur.timer && cur.slept) {
                clearTimeout(cur.timer);
                cur.timer = setTimeout(cur.tick, 0);
            }
            return true;
        }
        if (cur.done) return false;
    }
    if (cur && cur.timer) clearTimeout(cur.timer);
    const poll = {
        ws: wsId,
        live: true,
        done: false,
        slept: false,
        since: Date.now(),
        delay: BASE_MS,
        sig: '',
        fails: 0,
        timer: null,
        tick: null
    };
    r.__workspaceSetupPoll = poll;
    const end = (done)=>{
        poll.live = false;
        poll.done = !!done;
        if (poll.timer) clearTimeout(poll.timer);
        poll.timer = null;
    };
    const hidden = ()=>{
        try {
            const doc = el.node && el.node.ownerDocument || (typeof document !== 'undefined' ? document : null);
            return !!doc && doc.visibilityState === 'hidden';
        } catch (_) {
            return false;
        }
    };
    poll.tick = ()=>{
        poll.timer = null;
        if (!poll.live || r.__workspaceSetupPoll !== poll) return;
        if (wsOf(r) !== wsId) return end(false);
        if (Date.now() - poll.since > MAX_MS) return end(true);
        if (hidden()) {
            poll.slept = true;
            poll.timer = setTimeout(poll.tick, CAP_MS);
            return;
        }
        poll.slept = false;
        Promise.resolve(el.call('workspaceSetupRead', r, {
            sdk: o.sdk || null
        })).catch(()=>null).then((entry)=>{
            if (!poll.live || r.__workspaceSetupPoll !== poll) return;
            // the loop's next step first, so the effects read the poll as it is
            const job = entry && entry.job;
            if (entry && (entry.status === 'error' || entry.code)) poll.fails += 1;
            else poll.fails = 0;
            if (!entry) // nothing was asked (a gate is closed — the role, the SDK, the
            // trigger): a later prime starts again
            end(false);
            else if (entry.status === 'none' || poll.fails >= FAILS) end(true);
            else if (entry.status === 'ok' && (!job || job.status !== 'running')) end(true);
            else {
                const sig = job ? JSON.stringify([
                    job.rev,
                    job.status,
                    job.steps.map((x)=>x.key + ':' + x.status)
                ]) : '';
                if (sig && sig !== poll.sig) {
                    poll.sig = sig;
                    poll.delay = BASE_MS;
                } else poll.delay = Math.min(CAP_MS, Math.round(poll.delay * GROW));
                poll.timer = setTimeout(poll.tick, poll.delay);
            }
            try {
                el.call('workspaceSetupEffects', r, {
                    sdk: o.sdk || null
                });
            } catch (err) {
                console.warn('[setup] effects failed:', err && err.message);
            }
        });
    };
    poll.tick();
    return true;
}
function $bdad59f0f6e35c69$export$5cd809fefa5516bd(root, opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object' || typeof r.update !== 'function') return false;
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const fns = el.context && el.context.functions || {};
    if (typeof fns.addAppPromptFlush === 'function' && el.call('workspaceSetupOwnsBuild', r) === false && (el.call('workspaceSetupWanted', r) || {}).arrived) Promise.resolve(el.call('addAppPromptFlush', r)).catch(()=>null);
    const entry = r._workspaceSetup;
    if (!wsId || !entry || entry.ws !== wsId || entry.status !== 'ok' || !entry.job) return false;
    const job = entry.job;
    const done = job.steps.filter((x)=>x.key.indexOf('app:') === 0 && x.status === 'done').map((x)=>x.key);
    const seen = Array.isArray(entry.apps) ? entry.apps : null;
    // the first look refreshes once when apps are done already (the shell may
    // have read the workspace before they landed); every later done app is new
    // to the navigation
    if (!seen) {
        r.update({
            _workspaceSetup: {
                ...entry,
                apps: done
            }
        }, {
            preventFetch: true
        });
        if (done.length) Promise.resolve(el.call('workspaceSetupRefreshApps', r, {
            sdk: o.sdk || null
        })).catch(()=>null);
    } else if (done.some((k)=>seen.indexOf(k) < 0)) {
        r.update({
            _workspaceSetup: {
                ...r._workspaceSetup,
                apps: done
            }
        }, {
            preventFetch: true
        });
        Promise.resolve(el.call('workspaceSetupRefreshApps', r, {
            sdk: o.sdk || null
        })).catch(()=>null);
    }
    const site = job.steps.find((x)=>x.key === 'website');
    const siteSettled = !!site && (site.status === 'done' || site.status === 'skipped' && site.reason === 'already');
    const siteId = siteSettled ? String(site.detail && site.detail.projectId || job.projectId || '') : '';
    const cur = r._workspaceSetup;
    if (siteId && !(cur.site && cur.site.projectId === siteId)) Promise.resolve(el.call('workspaceSetupSiteRead', r, {
        sdk: o.sdk || null
    })).catch(()=>null);
    if (cur.policy === undefined) Promise.resolve(el.call('workspaceSetupPolicyRead', r, {
        sdk: o.sdk || null
    })).catch(()=>null);
    // the person's record again, right before a free build is promised
    if (job.status === 'done' && cur.policy === true && !(cur.me && cur.me.checked)) Promise.resolve(el.call('workspaceSetupMeRead', r, {
        sdk: o.sdk || null
    })).catch(()=>null);
    if (!r._creditGuard && !r.__workspaceSetupCredits && typeof fns.loadCreditGuard === 'function') {
        r.__workspaceSetupCredits = true;
        Promise.resolve(el.call('loadCreditGuard', r)).catch(()=>null);
    }
    if (o.shown) {
        Promise.resolve(el.call('workspaceSetupOpenThread', r)).catch(()=>null);
        if (el.call('workspaceSetupFirstBuild', r) === 'auto') el.call('workspaceSetupSendBuild', r);
    }
    return true;
}
function $bdad59f0f6e35c69$export$ad660b8ac51306e9(el, s, opts) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root || null;
    if (!host || typeof host.call !== 'function' || !root) return false;
    const o = opts && typeof opts === 'object' ? opts : {};
    const fns = host.context && host.context.functions || {};
    const inUrl = !(host.scope && host.scope.addAppThreadInUrl === false);
    if (!host.__workspaceSetupArrived) {
        host.__workspaceSetupArrived = true;
        host.call('workspaceSetupArrive', root, {
            url: inUrl
        });
    }
    const shown = inUrl ? true : typeof fns.homeBuildShown === 'function' ? !!host.call('homeBuildShown', root) : false;
    host.call('workspaceSetupPoll', root, {
        wake: !!o.wake
    });
    return !!host.call('workspaceSetupEffects', root, {
        shown: shown
    });
}
function $bdad59f0f6e35c69$export$101708b74a792a87(opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = o.root && typeof o.root === 'object' && o.root || el && el.state && el.state.root;
    if (!r || typeof r.update !== 'function') return Promise.resolve(false);
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const fns = el.context && el.context.functions || {};
    const entry = r._workspaceSetup;
    if (!wsId || !entry || entry.ws !== wsId || entry.retrying) return Promise.resolve(false);
    if (typeof fns.currentUserIsAdmin !== 'function' || !el.call('currentUserIsAdmin', r)) return Promise.resolve(false);
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || typeof sdk.startWorkspaceSetup !== 'function') return Promise.resolve(false);
    r.update({
        _workspaceSetup: {
            ...entry,
            retrying: true
        }
    }, {
        preventFetch: true
    });
    const settle = (ok)=>{
        const cur = r._workspaceSetup;
        if (cur && cur.ws === wsId) r.update({
            _workspaceSetup: {
                ...cur,
                retrying: false
            }
        }, {
            preventFetch: true
        });
        if (ok) el.call('workspaceSetupPoll', r, {
            force: true,
            sdk: o.sdk || null
        });
        return ok;
    };
    return Promise.resolve().then(()=>sdk.startWorkspaceSetup(wsId, {
            retry: true
        })).then(()=>settle(true), (err)=>{
        console.warn('[setup] retry refused:', String(err && (err.status || err.code) || ''));
        return settle(false);
    });
}
function $bdad59f0f6e35c69$export$f1095d503b069229(root, opts) {
    const WAIT_MS = 20000;
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object') return Promise.resolve(false);
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const fns = el.context && el.context.functions || {};
    if (!wsId || typeof fns.fetchFullWorkspaceRecord !== 'function') return Promise.resolve(false);
    if (r.__workspaceSetupApps) {
        r.__workspaceSetupApps.again = true;
        return r.__workspaceSetupApps.promise;
    }
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk) return Promise.resolve(false);
    const flight = {
        again: false,
        promise: null
    };
    const stillHere = ()=>{
        const now = r.workspace;
        return String(now && (now.id || now._id) || '') === wsId;
    };
    flight.promise = Promise.resolve().then(()=>el.call('fetchFullWorkspaceRecord', sdk, wsId)).then(async (full)=>{
        if (!full || !stillHere()) return false;
        el.call('setActiveWorkspaceRecord', r, full, {
            sdk: sdk,
            reason: 'workspaceSetup'
        });
        if (typeof fns.reactivateWorkspaceModule === 'function') {
            const settings = full.settings && typeof full.settings === 'object' && full.settings || {};
            let timer = null;
            const bound = new Promise((resolve)=>{
                timer = setTimeout(resolve, WAIT_MS);
            });
            try {
                await Promise.race([
                    // QUIET (R2c-m2): the workspace building itself in front of the
                    // person is no "Retrying workspace loading"; a failure still shows.
                    Promise.resolve(el.call('reactivateWorkspaceModule', null, {
                        workspaceApps: Array.isArray(settings.workspaceApps) ? settings.workspaceApps : []
                    }, {
                        quiet: true
                    })),
                    bound
                ]);
            } finally{
                clearTimeout(timer);
            }
        }
        return true;
    }).catch((err)=>{
        console.warn('[setup] the navigation did not refresh:', err && err.message);
        return false;
    }).then((ok)=>{
        if (r.__workspaceSetupApps === flight) r.__workspaceSetupApps = null;
        if (flight.again && stillHere()) el.call('workspaceSetupRefreshApps', r, o);
        return ok;
    });
    r.__workspaceSetupApps = flight;
    return flight.promise;
}
function $bdad59f0f6e35c69$export$678e7dc9d83144b5(root, opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return Promise.resolve(null);
    const entry = r._workspaceSetup;
    const job = entry && entry.job;
    const step = job && job.steps.find((x)=>x.key === 'website');
    // done (a new website) or skipped `already` (the workspace's own, adopted)
    const settled = !!step && (step.status === 'done' || step.status === 'skipped' && step.reason === 'already');
    const projectId = settled ? String(step.detail && step.detail.projectId || job.projectId || '') : '';
    if (!projectId) return Promise.resolve(null);
    if (r.__workspaceSetupSite === projectId) return Promise.resolve(null);
    const fns = el.context && el.context.functions || {};
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || typeof sdk.getProject !== 'function') return Promise.resolve(null);
    r.__workspaceSetupSite = projectId;
    const ws = entry.ws;
    return Promise.resolve().then(()=>sdk.getProject(projectId)).then((res)=>{
        const p = res && typeof res === 'object' && res.data && typeof res.data === 'object' ? res.data : res;
        if (!p || typeof p !== 'object') return null;
        const owner = typeof fns.ownerSlug === 'function' ? String(el.call('ownerSlug', p) || '') : '';
        const key = typeof fns.projectKey === 'function' ? String(el.call('projectKey', p) || '') : '';
        return {
            projectId: projectId,
            owner: owner,
            key: key,
            name: String(p.name || '').trim()
        };
    }, ()=>null).then((site)=>{
        const cur = r._workspaceSetup;
        if (!site || !cur || cur.ws !== ws) {
            if (!site && r.__workspaceSetupSite === projectId) r.__workspaceSetupSite = '';
            return null;
        }
        r.update({
            _workspaceSetup: {
                ...cur,
                site: site
            }
        }, {
            preventFetch: true
        });
        return site;
    });
}
function $bdad59f0f6e35c69$export$dd15c6237d7b1bfd(root, opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return Promise.resolve(null);
    const entry = r._workspaceSetup;
    if (!entry || entry.policy !== undefined || r.__workspaceSetupPolicy) return Promise.resolve(null);
    const fns = el.context && el.context.functions || {};
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    const ws = entry.ws;
    const store = (policy)=>{
        r.__workspaceSetupPolicy = null;
        const cur = r._workspaceSetup;
        if (cur && cur.ws === ws) r.update({
            _workspaceSetup: {
                ...cur,
                policy: policy
            }
        }, {
            preventFetch: true
        });
        return policy;
    };
    if (!sdk || typeof sdk.getSignupPolicy !== 'function') return Promise.resolve(store(null));
    r.__workspaceSetupPolicy = true;
    return Promise.resolve().then(()=>sdk.getSignupPolicy()).then((res)=>{
        const d = res && typeof res === 'object' && res.data && typeof res.data === 'object' ? res.data : res;
        return store(d && typeof d.firstBuildFree === 'boolean' ? d.firstBuildFree : null);
    }, ()=>store(null));
}
function $bdad59f0f6e35c69$export$5bdd3427b83e36ff(root) {
    const RECENT_MS = 600000;
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return Promise.resolve(false);
    const entry = r._workspaceSetup;
    const job = entry && entry.status === 'ok' ? entry.job : null;
    const id = job ? String(job.threadId || '') : '';
    if (!id) return Promise.resolve(false);
    const ended = Date.parse(String(job.finishedAt || ''));
    const recent = job.status === 'running' || Number.isFinite(ended) && Date.now() - ended <= RECENT_MS;
    // an older job is history — unless this page is a Make it real arrival
    if (!recent && !entry.arrived) return Promise.resolve(false);
    if (String(r._ax_activeSessionId || '') === id) {
        if (entry.opened !== id) r.update({
            _workspaceSetup: {
                ...entry,
                opened: id
            }
        }, {
            preventFetch: true
        });
        return Promise.resolve(true);
    }
    // opened once already: the person moved on to another thread or app
    if (entry.opened === id || entry.opening) return Promise.resolve(false);
    if (r.bridgeStatus !== 'open') return Promise.resolve(false);
    if (!entry.arrived && (r._ax_activeSessionId || r._addAppProjectId)) return Promise.resolve(false);
    r.update({
        _workspaceSetup: {
            ...entry,
            opening: true
        }
    }, {
        preventFetch: true
    });
    if (r._addAppProjectId) {
        r.__addAppHydratedThreadId = null;
        r.update({
            _addAppProjectId: null,
            _addAppRendered: false
        }, {
            preventFetch: true
        });
    }
    const settle = (ok)=>{
        const cur = r._workspaceSetup;
        if (cur && cur.ws === entry.ws) r.update({
            _workspaceSetup: {
                ...cur,
                opening: false,
                opened: ok ? id : cur.opened
            }
        }, {
            preventFetch: true
        });
        return ok;
    };
    return Promise.resolve().then(()=>el.call('switchSession', id, 'addapp')).then(()=>settle(String(r._ax_activeSessionId || '') === id), (err)=>{
        console.warn('[setup] the first thread did not open:', err && err.message);
        return settle(false);
    });
}
function $bdad59f0f6e35c69$export$8148322adc7f2fa3(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return null;
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const entry = r._workspaceSetup && typeof r._workspaceSetup === 'object' && r._workspaceSetup.ws === wsId ? r._workspaceSetup : null;
    const fresh = entry && entry.me && entry.me.fresh ? entry.me : null;
    const u = fresh ? fresh.user : r.user && typeof r.user === 'object' ? r.user : null;
    const claim = u && u.firstBuildFree && typeof u.firstBuildFree === 'object' ? u.firstBuildFree : null;
    return claim && claim.claimedAt ? {
        workspace: String(claim.workspace || ''),
        claimedAt: claim.claimedAt
    } : null;
}
function $bdad59f0f6e35c69$export$50d52ebd43024fa8(root, opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return Promise.resolve(null);
    const entry = r._workspaceSetup;
    if (!entry || entry.me && entry.me.checked || r.__workspaceSetupMe) return Promise.resolve(null);
    const fns = el.context && el.context.functions || {};
    let sdk = o.sdk || null;
    if (!sdk && typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    const ws = entry.ws;
    const store = (user)=>{
        r.__workspaceSetupMe = null;
        const cur = r._workspaceSetup;
        if (!cur || cur.ws !== ws) return null;
        const me = {
            checked: true,
            fresh: !!user,
            user: user ? {
                firstBuildFree: user.firstBuildFree || null
            } : null
        };
        r.update({
            _workspaceSetup: {
                ...cur,
                me: me
            }
        }, {
            preventFetch: true
        });
        return me;
    };
    if (!sdk || typeof sdk.getMe !== 'function') return Promise.resolve(store(null));
    r.__workspaceSetupMe = true;
    return Promise.resolve().then(()=>sdk.getMe()).then((res)=>{
        const me = res && (res.user || res.data && res.data.user) || res;
        return store(me && typeof me === 'object' && (me._id || me.id) ? me : null);
    }, ()=>store(null));
}
function $bdad59f0f6e35c69$export$3f7c39729818fd92(root) {
    const RECENT_MS = 600000;
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object') return '';
    const w = r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const wsId = String(w && (w.id || w._id) || '');
    const entry = r._workspaceSetup;
    const job = entry && entry.ws === wsId && entry.status === 'ok' ? entry.job : null;
    const id = job ? String(job.threadId || '') : '';
    if (!id || String(r._ax_activeSessionId || '') !== id) return '';
    const msgs = Array.isArray(r._ax_chatMessages) ? r._ax_chatMessages : [];
    if (entry.build === 'sent' || msgs.some((m)=>m && m.role === 'user')) return 'sent';
    if (job.status === 'running') return 'wait';
    if (job.status !== 'done') return '';
    const ended = Date.parse(String(job.finishedAt || ''));
    const recent = Number.isFinite(ended) && Date.now() - ended <= RECENT_MS;
    if (!recent && !entry.arrived && !entry.build) return '';
    if (!el.call('workspaceSetupBuildText', r)) return '';
    // The waiver rule (server FirstBuildFreeService.admit): FREE when the policy
    // says `firstBuildFree: true`, this person never claimed it, and this
    // workspace's marker is absent — a marker naming THIS thread means the first
    // build already went here; any other marker closes it (a teammate pays).
    const settings = w && w.settings && typeof w.settings === 'object' ? w.settings : {};
    const marker = settings.firstBuildFree && typeof settings.firstBuildFree === 'object' ? settings.firstBuildFree : null;
    if (marker && String(marker.threadId || '') === id) return 'sent';
    if (entry.policy === undefined) return 'wait';
    if (entry.policy === true && !marker) {
        // a free build is promised only after the person's record is read again
        if (!(entry.me && entry.me.checked)) return 'wait';
        if (!el.call('workspaceSetupUserClaim', r)) return 'auto';
    }
    const fns = el.context && el.context.functions || {};
    const guard = typeof fns.creditGuardState === 'function' ? el.call('creditGuardState', r) : null;
    if (!guard || !guard.loaded) return 'wait';
    if (guard.status === 'exhausted') return 'credits';
    // a build that waited on credits goes once they arrive
    if (entry.build === 'held' && typeof guard.total === 'number' && guard.total > 0) return 'auto';
    return 'ask';
}
function $bdad59f0f6e35c69$export$28be479a8cd0de65(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const msgs = r && Array.isArray(r._ax_chatMessages) ? r._ax_chatMessages : [];
    const row = msgs.find((m)=>m && m.metadata && m.metadata.kind === 'note' && m.metadata.plan);
    const plan = row && typeof row.metadata.plan === 'object' ? row.metadata.plan : null;
    if (!plan) return '';
    const concept = Array.isArray(plan.concepts) ? plan.concepts[0] : null;
    const idea = concept && typeof concept.text === 'string' ? concept.text.trim() : '';
    if (idea) return idea;
    const company = plan.company && typeof plan.company === 'object' ? plan.company : {};
    const name = typeof company.name === 'string' ? company.name.trim() : '';
    const tagline = typeof company.tagline === 'string' ? company.tagline.trim() : '';
    const t = (k)=>String(el.call('polyglot', k) || '');
    if (name && tagline) return t('workspace.setup.buildFromPlan').replace('{company}', name).replace('{tagline}', tagline);
    if (name) return t('workspace.setup.buildFromName').replace('{company}', name);
    return t('workspace.setup.buildPlain');
}
function $bdad59f0f6e35c69$export$d345a3c4a5d441c5(root, opts) {
    const o = opts && typeof opts === 'object' ? opts : {};
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return false;
    const state = el.call('workspaceSetupFirstBuild', r);
    if (!(state === 'auto' || o.pressed && state === 'ask')) return false;
    if (r.bridgeStatus !== 'open' || r._addAppProjectId) return false;
    const entry = r._workspaceSetup;
    const id = String(entry.job.threadId);
    if (r.__workspaceSetupSent === id) return false;
    const text = el.call('workspaceSetupBuildText', r);
    if (!text) return false;
    r.__workspaceSetupSent = id;
    r.update({
        _workspaceSetup: {
            ...entry,
            build: 'sent'
        }
    }, {
        preventFetch: true
    });
    el.call('sendPrompt', text, 'addapp');
    return true;
}
function $bdad59f0f6e35c69$export$d7de46adb836cf3a(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r.update !== 'function') return false;
    const state = el.call('workspaceSetupFirstBuild', r);
    if (state === 'credits') {
        const entry = r._workspaceSetup;
        if (entry.build !== 'held') r.update({
            _workspaceSetup: {
                ...entry,
                build: 'held'
            }
        }, {
            preventFetch: true
        });
        return false;
    }
    return el.call('workspaceSetupSendBuild', r, {
        pressed: true
    });
}
function $bdad59f0f6e35c69$export$6fa9aa131d97f24(root) {
    const RECENT_MS = 600000;
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object') return false;
    const fns = el && el.context && el.context.functions || {};
    const w = r.workspace;
    const wsId = String(w && (w.id || w._id) || '');
    const entry = r._workspaceSetup && r._workspaceSetup.ws === wsId ? r._workspaceSetup : null;
    if (entry && entry.status === 'ok' && entry.job) {
        const job = entry.job;
        if (job.status === 'running') return true;
        if (job.status !== 'done') return false;
        const ended = Date.parse(String(job.finishedAt || ''));
        return Number.isFinite(ended) && Date.now() - ended <= RECENT_MS || !!entry.arrived;
    }
    if (entry && entry.status === 'none') return false;
    if (entry && entry.status === 'reading') return null;
    if (entry && entry.status === 'error') {
        // a failed read is asked again while the poll runs (three in a row end it)
        const poll = r.__workspaceSetupPoll;
        return poll && poll.ws === wsId && poll.live ? null : false;
    }
    // nothing read yet: only an arrival waits for the builder's read
    const wanted = el.call('workspaceSetupWanted', r) || {};
    if (!wanted.arrived) return false;
    if (wsId && r.workspaceReady) {
        if (typeof fns.currentUserIsAdmin !== 'function' || !el.call('currentUserIsAdmin', r)) return false;
    }
    let sdk = null;
    if (typeof fns.getSDK === 'function') try {
        sdk = el.call('getSDK');
    } catch (_) {
        sdk = null;
    }
    if (!sdk || typeof sdk.getWorkspaceSetup !== 'function') return false;
    return null;
}
function $bdad59f0f6e35c69$export$fe51f244ce0d3ed(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object') return false;
    const owns = el.call('workspaceSetupOwnsBuild', r);
    if (owns === null) return true;
    if (owns !== true) return false;
    const entry = r._workspaceSetup;
    const job = entry && entry.job;
    if (!job || job.status === 'running') return true;
    if (!job.threadId) return false;
    // the first build goes only where the builder shows its thread
    const onBuilder = /\/add-app\/?$/.test(String(r.currentPath || '').split('?')[0]);
    if (!onBuilder) return false;
    const state = el.call('workspaceSetupFirstBuild', r);
    return state === 'wait' || state === 'auto';
}
function $bdad59f0f6e35c69$export$c779c2fd11220afa(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    if (!r || typeof r !== 'object') return null;
    const fns = el && el.context && el.context.functions || {};
    const prefs = r.userPrefs && typeof r.userPrefs === 'object' ? r.userPrefs : null;
    const rec = prefs && prefs.onboarding && typeof prefs.onboarding === 'object' ? prefs.onboarding : null;
    const entry = r._workspaceSetup && typeof r._workspaceSetup === 'object' ? r._workspaceSetup : null;
    const here = typeof window !== 'undefined' && window.location ? window.location.origin : '';
    for (const raw of [
        rec && rec.from,
        entry && entry.back
    ]){
        if (typeof raw !== 'string' || !raw) continue;
        try {
            const url = new URL(raw);
            const local = url.hostname === 'localhost' || url.hostname.endsWith('.localhost');
            if (!(url.protocol === 'https:' || local && url.protocol === 'http:')) continue;
            if (url.origin === here) continue;
            if (typeof fns.isPlatformHost !== 'function' || !el.call('isPlatformHost', url.hostname)) continue;
            return {
                href: url.origin + url.pathname,
                host: url.hostname
            };
        } catch (_) {
        /* not a URL */ }
    }
    return null;
}
function $bdad59f0f6e35c69$export$7557e7516f410628(root, id) {
    const el = this;
    const ref = String(id || '').toLowerCase();
    const key = ref.split('/').pop() || '';
    if (!key) return {
        title: '',
        icon: ''
    };
    const fns = el && el.context && el.context.functions || {};
    const byId = typeof fns.onboardingCatalogApps === 'function' ? (el.call('onboardingCatalogApps', root) || {}).byId || {} : {};
    const app = byId[ref];
    if (app && app.title) return {
        title: app.title,
        icon: app.icon || ''
    };
    const named = typeof fns.storeItemText === 'function' ? el.call('storeItemText', {
        key: key,
        name: ''
    }, 'name') : '';
    return {
        title: String(named || '').trim() || key,
        icon: ''
    };
}
function $bdad59f0f6e35c69$export$c7b891cbe212b5b7(root) {
    const RECENT_MS = 600000;
    const el = this;
    const r = root || el && el.state && el.state.root || null;
    const out = {
        show: false,
        pending: false,
        status: '',
        title: '',
        lines: [],
        failText: '',
        retryable: false,
        retrying: false,
        siteShow: false,
        siteTitle: '',
        creditsShow: false,
        creditsText: '',
        backShow: false,
        backHref: '',
        backText: '',
        build: '',
        buildShow: false,
        buildText: '',
        buildAction: '',
        claimShow: false,
        claimText: ''
    };
    if (!r || typeof r !== 'object') return out;
    const w = r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const wsId = String(w && (w.id || w._id) || '');
    const entry = r._workspaceSetup && r._workspaceSetup.ws === wsId ? r._workspaceSetup : null;
    if (!entry) return out;
    const t = (k)=>String(el.call('polyglot', k) || '');
    const job = entry.status === 'ok' ? entry.job : null;
    // reading on an arrival (or opening its thread): the builder's empty state
    // waits instead of flashing under the setup
    if (entry.arrived && (entry.status === 'reading' || entry.opening)) out.pending = true;
    if (!job) return out;
    // no thread yet: the `thread` step still runs (a `200` can answer mid-way),
    // or it failed (`seed_failed`) — then the setup shows on the builder's own
    // blank thread, with its Try again (a retry writes the thread)
    const threadStep = job.steps.find((x)=>x.key === 'thread');
    const threadOpen = !!threadStep && (threadStep.status === 'pending' || threadStep.status === 'running');
    const bare = !job.threadId && entry.arrived && !r._ax_activeSessionId && (job.status === 'failed' || !threadOpen);
    if (!job.threadId && !bare) {
        if (entry.arrived && threadOpen && job.status === 'running') out.pending = true;
        return out;
    }
    if (!bare && String(r._ax_activeSessionId || '') !== job.threadId) {
        if (entry.arrived && !entry.opened && job.status === 'running') out.pending = true;
        return out;
    }
    const ended = Date.parse(String(job.finishedAt || ''));
    const recent = job.status === 'running' || Number.isFinite(ended) && Date.now() - ended <= RECENT_MS;
    // an older job is history — unless this page is a Make it real arrival
    if (!recent && !entry.arrived && !entry.build) return out;
    out.show = true;
    out.status = job.status;
    const wsName = String(w && (w.name || w.displayName) || '').trim();
    // literal keys, one per state and per named / unnamed workspace
    const TITLES = {
        running: [
            'workspace.setup.title',
            'workspace.setup.titleNoName'
        ],
        failed: [
            'workspace.setup.titleFailed',
            'workspace.setup.titleFailedNoName'
        ],
        done: [
            'workspace.setup.titleDone',
            'workspace.setup.titleDoneNoName'
        ]
    };
    const pair = TITLES[job.status] || TITLES.done;
    out.title = wsName ? t(pair[0]).replace('{workspace}', wsName) : t(pair[1]);
    const LABELS = {
        name: [
            'workspace.setup.stepName',
            'edit'
        ],
        language: [
            'workspace.setup.stepLanguage',
            'language'
        ],
        theme: [
            'workspace.setup.stepTheme',
            'theme'
        ],
        preset: [
            'workspace.setup.stepPreset',
            'folder'
        ],
        website: [
            'workspace.setup.stepWebsite',
            'globe'
        ]
    };
    // the reason of a failed line in words; an app the environment does not
    // carry is "Coming soon", never a failure
    const REASONS = {
        missing_required_dependencies: 'workspace.setup.needsApps',
        install_refused: 'workspace.setup.refused',
        forbidden: 'workspace.setup.refused',
        free_cap_reached: 'workspace.setup.siteCap',
        no_app_landed: 'workspace.setup.noApps'
    };
    let failed = 0;
    job.steps.forEach((step, i)=>{
        const app = step.key.indexOf('app:') === 0 ? step.key.slice(4) : '';
        const label = LABELS[step.key];
        if (!app && !label) return;
        if (step.status === 'skipped' && !(step.key === 'website' && step.reason === 'already')) return;
        // the inline steps ran before the person arrived: shown once they settled
        const inline = !app && step.key !== 'preset' && step.key !== 'website';
        if (inline && (step.status === 'pending' || step.status === 'running')) return;
        const named = app ? el.call('workspaceSetupAppName', r, app) || {} : null;
        const soon = !!app && step.status === 'failed' && step.reason === 'app_not_found';
        const isDone = step.status === 'done' || step.status === 'skipped';
        const isFailed = step.status === 'failed' && !soon;
        if (isFailed) failed++;
        const waiting = step.status === 'pending' || step.status === 'running';
        const stateKey = soon ? 'marketplace.preset.lineComingSoon' : isFailed ? REASONS[step.reason] || (app ? 'marketplace.preset.lineFailed' : 'workspace.setup.lineFailed') : waiting ? app ? 'marketplace.preset.linePending' : 'workspace.setup.lineWorking' : app ? step.detail && step.detail.already ? 'marketplace.preset.lineSkipped' : 'marketplace.preset.lineInstalled' : 'workspace.setup.lineReady';
        out.lines.push({
            key: 'setup-line-' + (i + 1),
            id: step.key,
            title: app ? String(named.title || '') : t(label[0]),
            icon: app ? String(named.icon || '') || 'blocks' : label[1],
            state: step.status,
            done: isDone,
            failed: isFailed,
            stateKey: stateKey
        });
    });
    const fns = el.context && el.context.functions || {};
    const admin = typeof fns.currentUserIsAdmin === 'function' && !!el.call('currentUserIsAdmin', r);
    if (job.status === 'failed') {
        out.failText = t('workspace.setup.failedStart');
        out.retryable = admin && job.reason !== 'no_blueprint' && job.reason !== 'workspace_not_found';
    } else if (bare) {
        out.failText = t('workspace.setup.threadFailed');
        out.retryable = admin && job.status === 'done';
    } else if (job.status === 'done' && failed) out.retryable = admin;
    out.retrying = !!entry.retrying;
    const site = job.steps.find((x)=>x.key === 'website');
    if (site && (site.status === 'done' || site.status === 'skipped' && site.reason === 'already') && entry.site && entry.site.owner && entry.site.key) {
        out.siteShow = true;
        out.siteTitle = entry.site.name || t('workspace.setup.stepWebsite');
    }
    // free: the waiver rule (workspaceSetupFirstBuild) — open, or this thread's
    // own (its later turns stay free inside the server's cap)
    const guard = typeof fns.creditGuardState === 'function' ? el.call('creditGuardState', r) : null;
    const claim = el.call('workspaceSetupUserClaim', r);
    const settings = w && w.settings && typeof w.settings === 'object' ? w.settings : {};
    const marker = settings.firstBuildFree && typeof settings.firstBuildFree === 'object' ? settings.firstBuildFree : null;
    const mine = !!marker && !!job.threadId && String(marker.threadId || '') === job.threadId;
    const free = entry.policy === true && (!marker && !claim || mine && (!claim || claim.workspace === wsId));
    if (free) {
        out.creditsShow = true;
        out.creditsText = t('workspace.setup.creditsFree');
    } else if (guard && guard.loaded && typeof guard.total === 'number') {
        out.creditsShow = true;
        out.creditsText = t(guard.total === 1 ? 'workspace.setup.creditsOne' : 'workspace.setup.credits').replace('{count}', Number(guard.total).toLocaleString('en-US'));
    }
    const back = el.call('workspaceSetupBackHref', r);
    if (back) {
        out.backShow = true;
        out.backHref = back.href;
        out.backText = t('workspace.setup.back').replace('{site}', back.host);
    }
    const build = el.call('workspaceSetupFirstBuild', r);
    out.build = build;
    if (build === 'wait' && job.status === 'running') {
        out.buildShow = true;
        out.buildText = t('workspace.setup.buildAfter');
    } else if (build === 'auto' || build === 'wait' && job.status === 'done') {
        out.buildShow = true;
        out.buildText = t('workspace.setup.buildStarting');
    } else if (build === 'ask') {
        out.buildShow = true;
        out.buildText = t('workspace.setup.buildAsk');
        out.buildAction = t('workspace.setup.buildAction');
    } else if (build === 'credits') {
        out.buildShow = true;
        out.buildText = t(admin ? 'workspace.setup.buildCredits' : 'workspace.setup.buildCreditsMember');
        out.claimShow = admin;
        out.claimText = t('workspace.setup.claim');
    }
    return out;
}
function $bdad59f0f6e35c69$export$fbc5e85147c9b50e(plan) {
    const el = this;
    const out = {
        show: false,
        title: '',
        name: '',
        tagline: '',
        facts: '',
        apps: [],
        appsText: '',
        siteText: '',
        ideaLabel: '',
        idea: ''
    };
    const p = plan && typeof plan === 'object' && !Array.isArray(plan) ? plan : null;
    if (!p) return out;
    const root = el && el.state && el.state.root || null;
    const t = (k)=>String(el.call('polyglot', k) || '');
    const text = (v)=>typeof v === 'string' ? v.trim() : '';
    out.show = true;
    out.title = t('workspace.setup.planTitle');
    const company = p.company && typeof p.company === 'object' ? p.company : {};
    out.name = text(company.name);
    out.tagline = text(company.tagline);
    const facts = [];
    // the industry is a preset key: its name is the preset's own (the App
    // Store's resolver), never the key
    const industry = text(p.industry);
    const fns = el && el.context && el.context.functions || {};
    if (industry && industry !== 'custom' && typeof fns.workspacePresetText === 'function') {
        const named = String(el.call('workspacePresetText', industry, 'name') || '').trim();
        if (named) facts.push(named);
    }
    const team = Number(p.team);
    if (Number.isInteger(team) && team > 0) facts.push(team === 1 ? t('workspace.setup.planTeamOne') : t('workspace.setup.planTeam').replace('{count}', team.toLocaleString('en-US')));
    out.facts = facts.join(" \xb7 ");
    const ids = Array.isArray(p.apps) ? p.apps.filter((x)=>typeof x === 'string' && x) : [];
    out.apps = ids.map((id, i)=>{
        const named = el.call('workspaceSetupAppName', root, id) || {};
        return {
            key: 'plan-app-' + (i + 1),
            title: String(named.title || ''),
            icon: String(named.icon || '') || 'blocks'
        };
    });
    out.appsText = out.apps.length ? t('workspace.setup.planApps') : '';
    const site = p.site && typeof p.site === 'object' ? p.site : null;
    const siteName = site ? text(site.name) : '';
    out.siteText = siteName ? t('workspace.setup.planSite').replace('{site}', siteName) : '';
    const concept = Array.isArray(p.concepts) ? p.concepts[0] : null;
    out.idea = concept ? text(concept.text) : '';
    out.ideaLabel = out.idea ? t('workspace.setup.planIdea') : '';
    return out;
}
function $bdad59f0f6e35c69$export$c96bf7183dc098e2(list) {
    const rows = Array.isArray(list) ? list : [];
    const row = rows.find((m)=>m && m.metadata && m.metadata.kind === 'note' && m.metadata.plan);
    return row && typeof row.metadata.plan === 'object' ? row.metadata.plan : null;
}
function $bdad59f0f6e35c69$export$afd0cf439b8c35f9(el) {
    const host = el || this;
    const root = host && host.state && host.state.root;
    if (!root) return false;
    const entry = root._workspaceSetup;
    const site = entry && entry.site;
    const href = site && site.owner && site.key ? host.call('projectHref', root, site.owner, site.key) : null;
    host.call('openInSlot', href || '/studio', host);
    return true;
}

});

parcelRegister("b72sS", function(module, exports) {

$parcel$export(module.exports, "workspaceRename", () => $817242998d4611ca$export$1f14f3abcdea2080);
// workspaceRename — THE ONE RENAME of a workspace from the shell: the
// workspace NAME card (pages/admin/workspace-settings.js, persona audit HO-2)
// and the new-account welcome's name field (components/OnboardingWorkStep.js,
// round 2 BLOCKER #5: a direct sign-up names its FIRST workspace instead of
// founding a second, empty one).
//
// The write is the server's PATCH /workspaces/:id `{ displayName }`
// (`sdk.updateWorkspace`, behind `requireWorkspaceRole(['owner','admin'])`).
// FENCE ON THE READ-BACK: a 200 whose stored name is not the one sent is a
// refusal too. After the server stored the name: the held record (through the
// ONE setter, so every reader of `root.workspace` repaints) and this
// workspace's rows in the switcher's lists.
//
// THE ONE NAME RULE: `displayName` first; the legacy `name` is frozen on older
// records (often "Default") — shared activeWorkspaceRecord.js
// workspaceDisplayName, restated here (FA204: self-contained export).
//
// THE PERSONAL ORG FOLLOWS (R2c-m1, elena-r2c 2026-10-26): a sign-up names its
// personal organization and personal workspace alike ("My workspace"), and the
// server renames the personal org with the workspace while the two share the
// old name (server WorkspaceMemberService.rename `mirrorPersonalOrg`). The org
// switcher lists the ORGANIZATION (`root.orgs` / `root.org`), so its rows take
// the new name here too, under the same rule: the workspace's own org, type
// `personal`, still carrying the old workspace name. A reload reads it from
// /auth/me.
//
// `this` is any shell element with `sdk` + `call`. → { ok: true, name } |
// { ok: false, reason: 'empty' | 'same' | 'unavailable' | 'failed' }.
async function $817242998d4611ca$export$1f14f3abcdea2080(root, wsId, raw) {
    const el = this;
    const name = String(raw == null ? '' : raw).replace(/\s+/g, ' ').trim();
    if (!name) return {
        ok: false,
        reason: 'empty'
    };
    const held = root && root.workspace && typeof root.workspace === 'object' ? root.workspace : null;
    const isThis = (w)=>!!w && !!wsId && String(w.id || w._id || '') === String(wsId);
    if (isThis(held) && String(held.displayName || held.name || '') === name) return {
        ok: false,
        reason: 'same'
    };
    const sdk = el && el.sdk;
    // The name being replaced and the workspace's org, read BEFORE the write.
    const listed = Array.isArray(root && root.workspaces) ? root.workspaces.find(isThis) : null;
    const before = isThis(held) ? held : listed;
    const oldName = before ? String(before.displayName || before.name || '') : '';
    const orgOf = (w)=>w ? String(w.org_id || w.organization || '') : '';
    const orgId = orgOf(before) || orgOf(listed) || (isThis(held) && root.org ? String(root.org.id || '') : '');
    if (!root || !wsId || !sdk || typeof sdk.updateWorkspace !== 'function') return {
        ok: false,
        reason: 'unavailable'
    };
    let stored = null;
    try {
        const ws = await sdk.updateWorkspace(wsId, {
            displayName: name
        });
        stored = ws && typeof ws === 'object' ? ws.displayName : null;
    } catch (err) {
        console.warn('[workspaceRename] save failed:', err && err.message);
        return {
            ok: false,
            reason: 'failed'
        };
    }
    if (stored !== name) {
        console.warn('[workspaceRename] save failed: the stored name is not the one sent');
        return {
            ok: false,
            reason: 'failed'
        };
    }
    const now = root.workspace;
    if (isThis(now)) el.call('setActiveWorkspaceRecord', root, {
        ...now,
        displayName: name,
        name: name
    }, {
        reason: 'admin:rename',
        sdk: sdk
    });
    const rename = (w)=>isThis(w) ? {
            ...w,
            displayName: name,
            name: name
        } : w;
    const byOrg = root.orgWorkspaces;
    if (byOrg && typeof byOrg === 'object') {
        const next = {};
        let changed = false;
        for (const k of Object.keys(byOrg)){
            const list = byOrg[k];
            next[k] = Array.isArray(list) ? list.map(rename) : list;
            if (Array.isArray(list) && list.some(isThis)) changed = true;
        }
        if (changed) root.update({
            orgWorkspaces: next
        });
    }
    if (Array.isArray(root.workspaces) && root.workspaces.some(isThis)) root.update({
        workspaces: root.workspaces.map(rename)
    });
    const orgs = Array.isArray(root.orgs) ? root.orgs : [];
    const orgRow = orgs.find((o)=>o && String(o.id || o._id || '') === orgId);
    const isOrg = (o)=>!!o && !!orgId && String(o.id || o._id || '') === orgId;
    const personal = orgRow && orgRow.type || isOrg(root.org) && root.org.type || '';
    const follows = (o)=>isOrg(o) && !!oldName && o.name === oldName && personal === 'personal';
    const retitle = (o)=>follows(o) ? {
            ...o,
            name: name
        } : o;
    const orgPatch = {};
    if (orgs.some(follows)) orgPatch.orgs = orgs.map(retitle);
    if (follows(root.org)) orgPatch.org = retitle(root.org);
    if (Object.keys(orgPatch).length) root.update(orgPatch);
    return {
        ok: true,
        name: name
    };
}

});

parcelRegister("afTTM", function(module, exports) {

$parcel$export(module.exports, "assistantRevealTop", () => $01ed44d02218114b$export$3cefd714d2348ed8);
$parcel$export(module.exports, "assistantRevealMeasure", () => $01ed44d02218114b$export$db78c61ba7b10c0d);
$parcel$export(module.exports, "assistantRevealPlan", () => $01ed44d02218114b$export$4595899406d7535d);
$parcel$export(module.exports, "assistantRevealScroller", () => $01ed44d02218114b$export$6d2ad12e8e54e676);
$parcel$export(module.exports, "assistantRevealViewId", () => $01ed44d02218114b$export$edc9ef93496a5a5b);
$parcel$export(module.exports, "assistantRevealRoomSet", () => $01ed44d02218114b$export$e16d473efef40c1c);
$parcel$export(module.exports, "assistantRevealRoomClear", () => $01ed44d02218114b$export$76928d026e6ac12e);
$parcel$export(module.exports, "assistantRevealRoom", () => $01ed44d02218114b$export$f12366bcfd857a17);
$parcel$export(module.exports, "assistantThreadAsks", () => $01ed44d02218114b$export$1334d875feac0255);
// assistantReveal.js — A NEW ANSWER'S SECTION COMES TO THE TOP (Nika
// 2026-10-23: "when answering in new section always scroll top of that
// section"). Every main-area view that answers in a new section brings that
// section's top under the shell's floating header, once, when it starts:
//   Main       the new Fly page (functions/assistantFly.js assistantFlyReveal)
//   Chat/Build the question just asked — its answer reads down from it, never
//              a chase of the stream's bottom (components/AssistantMainThread.js)
//   Present    the deck (components/AssistantDeckView.js)
//   Dashboard  the generated board (components/AssistantBoardView.js)
//
// THE ROOM. A new section is the LAST thing in its view: a question just
// asked has no answer under it yet, so the scroller cannot lift it to the top
// (measured on dev 2026-10-23: the question stopped at 409px of a 963px
// view, under 75px wanted, and its answer streamed down under the composer).
// The reveal measures the shortfall and gives the view that much room: a
// `min-height` that holds the section at the top while its answer fills the
// room in, and stops counting once the answer is taller than the view. The
// room lives in root state (`_revealRoom`: the view it belongs to and its
// height) and each view reads it in its own `minHeight` while it is on
// screen — one view holds the main area at a time, so one room is enough.
//
// The scroll follows the scroller's own CSS `scroll-behavior` (the brand reset
// turns smooth scrolling off under reduced motion) and the section's own
// `scroll-margin-top` (the header's clearance). The section's place is read
// from its layout box: a page that rises in (`fadeInUpShort`) starts lower by
// its travel, and the top read through that offset left a Fly page's head
// 12px under the header's clearance (63px, not 75px; measured on dev the
// same day). A section can render a beat after the state that made it (its
// view's children follow the same update): the reveal waits a few short
// ticks for its node, then gives up. The section and its scroller are found
// through the element tree, never a DOM query.
//
// FRANK: every export is self-contained; siblings through `this.call`.
// `key`: the view's descendant keyed so (a page, a row), else the view itself.
// `mark`: once per mark per view (a page key, a question's key, a request).
const $01ed44d02218114b$export$3cefd714d2348ed8 = function assistantRevealTop(el, key, mark, tries) {
    const host = el || this;
    const id = String(mark == null ? key || '' : mark);
    if (!host || !id || host.__revealedTop === id) return false;
    const target = key ? typeof host.lookdown === 'function' ? host.lookdown(key) : null : host;
    const node = target && target.node;
    if (!node || node.isConnected === false || typeof node.getBoundingClientRect !== 'function') {
        const n = Number(tries) || 0;
        if (n >= 10) return false;
        const again = this;
        setTimeout(()=>again.call('assistantRevealTop', host, key, mark, n + 1), 40);
        return false;
    }
    host.__revealedTop = id;
    // Measure, give the view the room it lacks, scroll. The room reaches the
    // view through its reactive `minHeight`: when the scroller cannot go that
    // far yet (the write lands a tick later, or a closed view's box below
    // absorbed part of the growth), measure again on the next tick — three
    // passes at most, then scroll as far as it goes.
    const settle = (pass)=>{
        const box = this.call('assistantRevealMeasure', host, target);
        const plan = box ? this.call('assistantRevealPlan', box) : null;
        if (!plan) {
            // no scroller to read (a test document): the browser's own reveal
            if (typeof node.scrollIntoView === 'function') node.scrollIntoView({
                block: 'start'
            });
            return;
        }
        const scroller = box.scroller;
        if (plan.room > 0 && pass < 3) {
            this.call('assistantRevealRoomSet', host, plan.room);
            const reach = Number(scroller.scrollHeight) - Number(scroller.clientHeight);
            if (reach + 0.5 < plan.top) {
                setTimeout(()=>settle(pass + 1), 0);
                return;
            }
        }
        if (typeof scroller.scrollTo === 'function') scroller.scrollTo({
            top: plan.top
        });
        else scroller.scrollTop = plan.top;
    };
    settle(0);
    return true;
};
const $01ed44d02218114b$export$db78c61ba7b10c0d = function assistantRevealMeasure(host, target) {
    const node = target && target.node;
    const hostNode = host && host.node;
    const doc = node && node.ownerDocument;
    const win = doc && doc.defaultView;
    if (!node || !hostNode || !win || typeof win.getComputedStyle !== 'function') return null;
    const scroller = this.call('assistantRevealScroller', target);
    if (!scroller || typeof scroller.getBoundingClientRect !== 'function') return null;
    const css = win.getComputedStyle(node);
    const lift = (t)=>{
        const m = /^matrix(3d)?\((.+)\)$/.exec(String(t || ''));
        if (!m) return 0;
        const v = m[2].split(',').map(Number);
        return (m[1] ? v[13] : v[5]) || 0;
    };
    const hostCss = win.getComputedStyle(hostNode);
    const px = (v)=>parseFloat(v) || 0;
    const frame = hostCss.boxSizing === 'border-box' ? 0 : px(hostCss.paddingTop) + px(hostCss.paddingBottom) + px(hostCss.borderTopWidth) + px(hostCss.borderBottomWidth);
    const root = scroller === doc.scrollingElement;
    return {
        scroller: scroller,
        nodeTop: node.getBoundingClientRect().top - lift(css.transform),
        clearance: px(css.scrollMarginTop),
        scrollerTop: root ? 0 : scroller.getBoundingClientRect().top + (Number(scroller.clientTop) || 0),
        scrollTop: Number(scroller.scrollTop) || 0,
        scrollHeight: Number(scroller.scrollHeight) || 0,
        clientHeight: Number(scroller.clientHeight) || 0,
        hostHeight: Math.max(0, (Number(hostNode.offsetHeight) || 0) - frame)
    };
};
const $01ed44d02218114b$export$4595899406d7535d = function assistantRevealPlan(m) {
    if (!m) return null;
    const top = Math.max(0, m.scrollTop + m.nodeTop - m.scrollerTop - m.clearance);
    const short = top - Math.max(0, m.scrollHeight - m.clientHeight);
    return {
        top: Math.round(top),
        room: short > 0.5 ? Math.ceil(m.hostHeight + short) : 0
    };
};
const $01ed44d02218114b$export$6d2ad12e8e54e676 = function assistantRevealScroller(target) {
    const node = target && target.node;
    const doc = node && node.ownerDocument;
    const win = doc && doc.defaultView;
    if (!win || typeof win.getComputedStyle !== 'function') return null;
    for(let p = target.parent; p; p = p.parent){
        const n = p.node;
        if (!n || n.nodeType !== 1) continue;
        const y = win.getComputedStyle(n).overflowY;
        if (y === 'auto' || y === 'scroll' || y === 'overlay') return n;
    }
    return doc.scrollingElement || null;
};
const $01ed44d02218114b$export$edc9ef93496a5a5b = function assistantRevealViewId(el) {
    const path = el && typeof el.getPath === 'function' ? el.getPath() : null;
    return Array.isArray(path) && path.length ? path.join('.') : String(el && el.key || '');
};
const $01ed44d02218114b$export$e16d473efef40c1c = function assistantRevealRoomSet(el, px) {
    const root = el && typeof el.getRootState === 'function' ? el.getRootState() : null;
    if (!root || typeof root.update !== 'function' || !(px > 0)) return false;
    const view = this.call('assistantRevealViewId', el);
    root.update({
        _revealRoom: {
            view: view,
            px: Math.ceil(px)
        }
    }, {
        preventFetch: true
    });
    return true;
};
const $01ed44d02218114b$export$76928d026e6ac12e = function assistantRevealRoomClear(el) {
    const root = el && typeof el.getRootState === 'function' ? el.getRootState() : null;
    const room = root && root._revealRoom;
    if (!room || typeof root.update !== 'function') return false;
    if (room.view !== this.call('assistantRevealViewId', el)) return false;
    root.update({
        _revealRoom: null
    }, {
        preventFetch: true
    });
    return true;
};
const $01ed44d02218114b$export$f12366bcfd857a17 = function assistantRevealRoom(el, root, open) {
    const room = root && root._revealRoom;
    if (!open || !room || !(room.px > 0)) return 'auto';
    if (room.view !== this.call('assistantRevealViewId', el)) return 'auto';
    return room.px + 'px';
};
const $01ed44d02218114b$export$1334d875feac0255 = function assistantThreadAsks(root) {
    const r = root && typeof root === 'object' ? root : {};
    const list = Array.isArray(r.chatMessages) ? r.chatMessages.filter((m)=>m && typeof m === 'object') : [];
    let count = 0;
    let key = null;
    list.forEach((m, i)=>{
        if (m.role !== 'user') return;
        count += 1;
        key = String(m.id || 'm' + i);
    });
    const first = list.length ? String(list[0].id || 'm0') : null;
    return {
        count: count,
        key: key,
        first: first
    };
};

});

parcelRegister("kosYS", function(module, exports) {

$parcel$export(module.exports, "agentModeShown", () => $ed8c878a333b12f4$export$c3b80fc7b1981356);
$parcel$export(module.exports, "agentModeFromSearch", () => $ed8c878a333b12f4$export$3264ef4bb9c9afc4);
$parcel$export(module.exports, "readStoredAgentMode", () => $ed8c878a333b12f4$export$cf6e6e51b9cc8cbf);
$parcel$export(module.exports, "reconcileAgentModeFromPrefs", () => $ed8c878a333b12f4$export$d197bdd5ec631390);
$parcel$export(module.exports, "setAgentMode", () => $ed8c878a333b12f4$export$979144547b5c3aa1);
$parcel$export(module.exports, "toggleAgentMode", () => $ed8c878a333b12f4$export$89c3e8a0e7ba662);
$parcel$export(module.exports, "agentModePathWithoutLink", () => $ed8c878a333b12f4$export$8007acbc8b3be39c);
// agentMode.js — AGENT MODE: the workspace TUI as the whole shell
// (WS-AGENT-MODE-1). Nika 2026-10-23: "we have workspace and tui. now we need
// to add workspace agent-mode which is exact replication of TUI in real
// workspace ui". Her choices: a real DOMQL replica (real DOM per row, card and
// field; brand tokens; the mono face), a WHOLE-SHELL mode (the Agent frame
// takes the viewport in place of the header, the rail and the home; it
// persists per person) and ONE shared source with the TUI
// (`@symbo.ls/workspace-model` — functions/agentModeRuntime.js).
//
// ONE state key, `root.agentMode` (boolean): the person's choice.
//   on   the Agent frame (components/AgentModeFrame.js) covers the viewport
//   off  the normal shell
// A LINK enters it for this visit without a write: `?mode=agent`
// (`root._agentModeLink`, read at boot — agentModeFromSearch). Leaving is
// always a choice and is written (setAgentMode(false)).
//
// PERSISTED PER PERSON, the assistantMode law (functions/assistantMode.js):
// localStorage paints first (`symbols_agent_mode`); the `user_preferences`
// row (`agentMode`) follows the person to every device and wins once it has
// loaded (functions/loadPrivateData.js); a device choice with no record
// migrates up. Writes are decisions: at once, single-flight on the queue every
// writer of the row shares (`root.__navbarSaveQueue`, keyed the same way),
// the payload composed at SEND time from the live row, a superseded decision
// sends nothing.
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained — the few literals are restated.
// True while the Agent frame is the shell: the person's choice or a link.
const $ed8c878a333b12f4$export$c3b80fc7b1981356 = (root)=>{
    const r = root && typeof root === 'object' ? root : {};
    const chosen = r.agentMode === true;
    const link = r._agentModeLink === true;
    return chosen || link;
};
const $ed8c878a333b12f4$export$3264ef4bb9c9afc4 = (search)=>{
    try {
        const q = String(search || '');
        const params = new URLSearchParams(q.startsWith('?') ? q.slice(1) : q);
        return params.get('mode') === 'agent';
    } catch (_) {
        return false;
    }
};
const $ed8c878a333b12f4$export$cf6e6e51b9cc8cbf = (storage)=>{
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const v = store ? store.getItem('symbols_agent_mode') : null;
        return v === '1' ? true : v === '0' ? false : null;
    } catch (_) {
        return null;
    }
};
const $ed8c878a333b12f4$export$d197bdd5ec631390 = (current, prefs, stored)=>{
    const recorded = prefs && typeof prefs === 'object' ? prefs.agentMode : undefined;
    if (recorded === true || recorded === false) return recorded !== (current === true) ? {
        apply: recorded
    } : null;
    return stored === true || stored === false ? {
        migrate: stored
    } : null;
};
function $ed8c878a333b12f4$export$979144547b5c3aa1(a, b, c) {
    const viaCall = typeof a === 'boolean' || a == null;
    const value = viaCall ? a : b;
    const self = this && typeof this === 'object' ? this : null;
    const root = viaCall ? self && self.state && self.state.root || null : a;
    const sdk = viaCall ? self && (self.sdk || self.context && self.context.sdk) || null : c || null;
    if (value !== true && value !== false) {
        console.warn(`[shell] setAgentMode ignored invalid value "${String(value)}" \u{2014} accepted values: true | false`);
        return;
    }
    if (!root || typeof root.update !== 'function') return;
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    const patch = {
        agentMode: value
    };
    if (!value) patch._agentModeLink = false;
    if (prefs && prefs.agentMode !== value) patch.userPrefs = {
        ...prefs,
        agentMode: value
    };
    const wasLink = root._agentModeLink === true;
    root.update(patch, {
        preventFetch: true
    });
    // Leaving a `?mode=agent` visit drops the link from the address, so a reload
    // keeps the person's choice instead of entering again (the shell's router).
    if (!value && wasLink && self && typeof self.router === 'function') {
        const path = self.call('agentModePathWithoutLink');
        if (path) self.router(path, self.getRoot(), {}, {
            replace: true
        });
    }
    try {
        if (typeof localStorage !== 'undefined') localStorage.setItem('symbols_agent_mode', value ? '1' : '0');
    } catch (err) {
        console.warn('[shell] agent-mode cache write failed:', err && err.message);
    }
    if (!sdk || typeof sdk.execute !== 'function') return;
    const w = root.workspace;
    const key = String(w && (w.id || w._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '') || 'user';
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    root.__agentModeSeq = (root.__agentModeSeq || 0) + 1;
    const seq = root.__agentModeSeq;
    const prior = queue.get(key) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        if (seq !== root.__agentModeSeq) return null;
        // PER-PATH PATCH — names only `agentMode` (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: {
                set: {
                    agentMode: value
                }
            }
        });
        if (seq === root.__agentModeSeq) {
            const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
            root.update({
                userPrefs: now ? {
                    ...now,
                    agentMode: value
                } : row && typeof row === 'object' ? row : {
                    agentMode: value
                }
            }, {
                preventFetch: true
            });
        }
        return row;
    });
    queue.set(key, task);
    return task.catch((err)=>{
        console.warn('[shell] user_preferences agentMode save failed:', err && err.message);
        return null;
    });
}
function $ed8c878a333b12f4$export$89c3e8a0e7ba662() {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const on = root.agentMode === true || root._agentModeLink === true;
    return this.call('setAgentMode', !on);
}
const $ed8c878a333b12f4$export$8007acbc8b3be39c = (loc)=>{
    try {
        const l = loc || (typeof window !== 'undefined' ? window.location : null);
        if (!l) return null;
        const params = new URLSearchParams(String(l.search || '').replace(/^\?/, ''));
        if (params.get('mode') !== 'agent') return null;
        params.delete('mode');
        const q = params.toString();
        return `${l.pathname}${q ? `?${q}` : ''}${l.hash || ''}`;
    } catch (_) {
        return null;
    }
};

});

parcelRegister("1fM2q", function(module, exports) {

$parcel$export(module.exports, "agentModeWorkspaceId", () => $0e9c7485d69dd8b6$export$3f72fb759cf5a0f8);
$parcel$export(module.exports, "agentModeRuntimeEnsure", () => $0e9c7485d69dd8b6$export$d2374597bb690232);
$parcel$export(module.exports, "agentModeRuntimeStop", () => $0e9c7485d69dd8b6$export$92cf7186d401e53f);
$parcel$export(module.exports, "agentModeSnapshot", () => $0e9c7485d69dd8b6$export$c02b59ac8616bd0f);
$parcel$export(module.exports, "agentModeHandle", () => $0e9c7485d69dd8b6$export$fa92872133d5f6f1);
$parcel$export(module.exports, "agentModeKeydown", () => $0e9c7485d69dd8b6$export$d6716e414f67074b);
$parcel$export(module.exports, "agentModeDocumentKeydown", () => $0e9c7485d69dd8b6$export$7b5324abc24c9aa2);
$parcel$export(module.exports, "agentModeFieldStale", () => $0e9c7485d69dd8b6$export$3a337c6c334c2c5c);
$parcel$export(module.exports, "agentModeClick", () => $0e9c7485d69dd8b6$export$6c601cd6bb539ca);
$parcel$export(module.exports, "agentModeInput", () => $0e9c7485d69dd8b6$export$6f498095e983b774);
// agentModeRuntime.js — THE ONE RUNTIME behind Agent mode (WS-AGENT-MODE-1).
//
// The TUI's apps, data backend and state machine are ONE source,
// `@symbo.ls/workspace-model` (smbls; the terminal TUI imports the same
// package). This file does exactly three things and nothing else:
//   1. create the headless runtime from the shell's OWN SDK instance and
//      session (user, org, workspace); re-create it on a workspace switch;
//   2. hand its `snapshot()` to the frame (components/AgentModeFrame.js) —
//      every render reads the snapshot only;
//   3. forward the person's input: keys (`handle`), clicks (`click`) and native
//      typing (`input`).
// No app, no data call and no state transition lives here.
//
// WHERE THINGS LIVE. The runtime is not state: it sits on the root as a plain
// `__` property (`root.__agentModeRuntime`, like `root.__navbarSaveQueue` —
// the store keeps `__` keys out of its signals). A render of the runtime bumps
// ONE declared root key, `_agentModeRev`; every frame factory reads it, so a
// change re-runs exactly the factories that read the snapshot. The snapshot of
// a revision is computed once and cached beside the runtime.
//
// THE HOST (what a runtime cannot do alone; the contract at the top of the
// package's runtime):
//   open(url)            leave Agent mode, then route the shell to that path
//   exit()               leave Agent mode (`q`, the frame's Leave control)
//   switchWorkspace(id, w)  the header switcher's own commit (shared
//                        AppOrgSwitcher `commitOrgSwitch`): a pick in another
//                        org goes through switchOrg, the same loader, deadline,
//                        URL and failure toast as the header; the runtime is
//                        re-created when root.workspace changes
//   edit                 absent: an editor field is a multiline field here
//
// Frank note: every export is self-contained (FA204); the package is a
// dynamic import inside the handler (FA206), so a shell that never enters
// Agent mode never loads it.
// The workspace id the runtime belongs to ('' before the workspace lands).
const $0e9c7485d69dd8b6$export$3f72fb759cf5a0f8 = (root)=>{
    const w = root && root.workspace;
    return String(w && (w.id || w._id) || '');
};

async function $0e9c7485d69dd8b6$export$d2374597bb690232() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root) return null;
    const shown = root.agentMode === true || root._agentModeLink === true;
    const wsId = String(root.workspace && (root.workspace.id || root.workspace._id) || '');
    const current = root.__agentModeRuntime || null;
    if (!shown || !wsId) {
        if (current) el.call('agentModeRuntimeStop');
        return null;
    }
    if (current && root.__agentModeRuntimeWs === wsId) {
        // The shell's language changed: the model speaks it from its next render
        // (the package's `setLang`; an older package without it stays English).
        const lang = String(root.lang || 'en');
        if (root.__agentModeLang !== lang && typeof current.setLang === 'function') {
            root.__agentModeLang = lang;
            current.setLang(lang);
        }
        return current;
    }
    if (root.__agentModeStarting && root.__agentModeStartingWs === wsId) return root.__agentModeStarting;
    // Start on the full workspace record only. At boot (and on a switch) the
    // shell holds a list entry first (`_shape: 'list'`, shared
    // functions/activeWorkspaceRecord.js) — no `type`, no settings — and the
    // model keeps the session it starts with: the header read
    // "system--hq.workspace" where the TUI reads "system.workspace" (dev
    // 2026-10-23: list at 2.1 s, full at 3.0 s, both under the boot screen).
    // The frame's stateDeps run this again when the full record lands; a
    // record without the marker starts at once.
    if (root.workspace && root.workspace._shape === 'list') return null;
    if (current) el.call('agentModeRuntimeStop');
    const gen = (root.__agentModeGen || 0) + 1;
    root.__agentModeGen = gen;
    root.__agentModeStartingWs = wsId;
    const bump = ()=>{
        if (root.__agentModeGen !== gen) return;
        root.update({
            _agentModeRev: (Number(root._agentModeRev) || 0) + 1
        }, {
            preventFetch: true
        });
    };
    const leave = ()=>{
        if (typeof el.call === 'function') el.call('setAgentMode', false);
    };
    const host = {
        open: (url)=>{
            let path = '/';
            try {
                const u = new URL(String(url || '/'), 'https://agent.mode.invalid');
                path = `${u.pathname}${u.search}${u.hash}`;
            } catch (_) {
                path = '/';
            }
            leave();
            if (typeof el.router === 'function') el.router(path, el.getRoot());
        },
        exit: ()=>leave(),
        // `w` is the picked row ({ id, name, org: { id, slug, name } }). The
        // header switcher's commit is reached through the component registry,
        // the way app.js reads the same object's `activeOrg`. sdk.switchWorkspace
        // alone never moves the org: a pick in another org did nothing (dev
        // 2026-10-23), so it is only the fallback without the shared switcher.
        switchWorkspace: (id, w)=>{
            const comps = el.context && el.context.components;
            const internals = comps && comps.__orgSwitcherInternals;
            const o = w && w.org;
            const orgId = o && (o.id || o._id);
            if (internals && typeof internals.commitOrgSwitch === 'function' && orgId) {
                const org = {
                    ...o,
                    id: orgId
                };
                return internals.commitOrgSwitch(el, root, org, id, w && w.name || o.name || '');
            }
            const sdk = el.sdk || el.context && el.context.sdk;
            return sdk && typeof sdk.switchWorkspace === 'function' ? sdk.switchWorkspace(id) : Promise.resolve(null);
        }
    };
    const starting = (async ()=>{
        try {
            const mod = el.context && el.context.agentModeModel ? el.context.agentModeModel : await (parcelRequire("4nK75"));
            const sdk = el.sdk || el.context && el.context.sdk;
            const data = el.context && el.context.agentModeData ? el.context.agentModeData : await mod.createSdkBackend({
                sdk: sdk,
                // The session the shell already holds: nothing is resolved
                // again and the SDK context is not changed (README).
                session: {
                    user: {
                        id: root.currentUserId || null,
                        email: root.currentUserEmail || null,
                        username: root.currentUserUsername || null
                    },
                    org: root.org || null,
                    workspace: root.workspace || null,
                    workspaces: Array.isArray(root.workspaces) && root.workspaces.length ? root.workspaces : undefined
                }
            });
            if (root.__agentModeGen !== gen) return null;
            // The model speaks the shell's language (the package's `lang` option:
            // app names, hints, help, dialogs, dates).
            const lang = String(root.lang || 'en');
            const runtime = mod.createWorkspaceRuntime({
                data: data,
                host: host,
                options: {
                    shellUrl: '',
                    lang: lang
                }
            });
            root.__agentModeLang = lang;
            root.__agentModeModule = mod;
            root.__agentModeRuntime = runtime;
            root.__agentModeRuntimeWs = wsId;
            root.__agentModeSnapAt = -1;
            runtime.on('render', bump);
            runtime.start();
            root.update({
                _agentModeError: null
            }, {
                preventFetch: true
            });
            bump();
            return runtime;
        } catch (err) {
            if (root.__agentModeGen !== gen) return null;
            console.warn('[shell] agent mode could not start:', err && err.message || err);
            root.update({
                _agentModeError: String(err && err.message || err)
            }, {
                preventFetch: true
            });
            return null;
        } finally{
            if (root.__agentModeGen === gen) {
                root.__agentModeStarting = null;
                root.__agentModeStartingWs = null;
            }
        }
    })();
    root.__agentModeStarting = starting;
    return starting;
}
function $0e9c7485d69dd8b6$export$92cf7186d401e53f() {
    const root = this && this.state && this.state.root;
    if (!root) return;
    const runtime = root.__agentModeRuntime;
    root.__agentModeGen = (root.__agentModeGen || 0) + 1;
    root.__agentModeRuntime = null;
    root.__agentModeModule = null;
    root.__agentModeRuntimeWs = null;
    root.__agentModeLang = null;
    root.__agentModeSnap = null;
    root.__agentModeSnapAt = -1;
    root.__agentModeStarting = null;
    if (runtime && typeof runtime.stop === 'function') try {
        runtime.stop();
    } catch (err) {
        console.warn('[shell] agent mode stop failed:', err && err.message || err);
    }
}
const $0e9c7485d69dd8b6$export$c02b59ac8616bd0f = (root)=>{
    if (!root || typeof root !== 'object') return null;
    const rev = Number(root._agentModeRev) || 0;
    const runtime = root.__agentModeRuntime;
    if (!runtime || typeof runtime.snapshot !== 'function') return null;
    if (root.__agentModeSnapAt !== rev || !root.__agentModeSnap) {
        root.__agentModeSnap = runtime.snapshot();
        root.__agentModeSnapAt = rev;
    }
    return root.__agentModeSnap;
};
function $0e9c7485d69dd8b6$export$fa92872133d5f6f1(ev) {
    const root = this && this.state && this.state.root;
    const runtime = root && root.__agentModeRuntime;
    if (!runtime || !ev) return false;
    runtime.handle(ev);
    return true;
}
function $0e9c7485d69dd8b6$export$d6716e414f67074b(e) {
    const root = this && this.state && this.state.root;
    // Ctrl+` — the workspace or its CLI (functions/workspaceMode.js): back to the
    // workspace, before the runtime reads the key.
    if (e && (e.ctrlKey || e.metaKey) && !e.altKey && (e.key === '`' || e.code === 'Backquote') && this && typeof this.call === 'function') {
        this.call('setAgentMode', false);
        if (typeof e.preventDefault === 'function') e.preventDefault();
        if (typeof e.stopPropagation === 'function') e.stopPropagation();
        return true;
    }
    const mod = root && root.__agentModeModule;
    if (!mod || typeof mod.keyFromDom !== 'function') return false;
    const ev = mod.keyFromDom(e);
    if (!ev) return false;
    if (ev.ctrl && ![
        'k',
        's',
        'n',
        'p'
    ].includes(ev.name)) return false;
    const target = e && e.target;
    const tag = target && target.tagName ? String(target.tagName).toLowerCase() : '';
    const inField = tag === 'input' || tag === 'textarea' || tag === 'select';
    // A field the model has already left takes no native typing: the key is
    // the runtime's, in order, as in the TUI (esc then q: q quits).
    const stale = inField && this.call('agentModeFieldStale', target);
    if (!stale) {
        if (tag === 'textarea' && !ev.ctrl && [
            'enter',
            'up',
            'down'
        ].includes(ev.name)) return false;
        if (inField && !mod.isControlKey(ev)) return false;
    }
    if (!this.call('agentModeHandle', ev)) return false;
    if (typeof e.preventDefault === 'function') e.preventDefault();
    if (typeof e.stopPropagation === 'function') e.stopPropagation();
    return true;
}
function $0e9c7485d69dd8b6$export$7b5324abc24c9aa2(e) {
    const el = this;
    const node = el && el.node;
    if (!e || e.defaultPrevented || !node || !node.isConnected) return false;
    const target = e.target;
    if (target && target !== node.ownerDocument.body && target !== node.ownerDocument.documentElement) return false;
    if (typeof node.closest === 'function' && node.closest('[inert]')) return false;
    if (typeof node.focus === 'function') node.focus({
        preventScroll: true
    });
    return el.call('agentModeKeydown', e);
}
function $0e9c7485d69dd8b6$export$3a337c6c334c2c5c(node) {
    const root = this && this.state && this.state.root;
    const runtime = root && root.__agentModeRuntime;
    if (!runtime || typeof runtime.snapshot !== 'function') return false;
    if (!node || typeof node.getAttribute !== 'function') return false;
    const own = node.getAttribute('data-agent-target');
    if (!own) return false;
    return this.call('agentModeFocusTarget', runtime.snapshot()) !== own;
}
function $0e9c7485d69dd8b6$export$6c601cd6bb539ca(payload, opts) {
    const root = this && this.state && this.state.root;
    const runtime = root && root.__agentModeRuntime;
    if (!runtime || !payload) return false;
    runtime.click(payload, {
        double: !!(opts && opts.double)
    });
    return true;
}
function $0e9c7485d69dd8b6$export$6f498095e983b774(target, value, caret) {
    const root = this && this.state && this.state.root;
    const runtime = root && root.__agentModeRuntime;
    if (!runtime || !target) return false;
    return runtime.input(target, String(value == null ? '' : value), Number.isInteger(caret) ? {
        caret: caret
    } : {});
}

});

parcelRegister("jGOZx", function(module, exports) {

$parcel$export(module.exports, "agentModeInk", () => $e5597e681bfa1d4e$export$487344154ccaf269);
$parcel$export(module.exports, "agentModeDotInk", () => $e5597e681bfa1d4e$export$30a7b0fa30973908);
$parcel$export(module.exports, "agentModeInitial", () => $e5597e681bfa1d4e$export$d0ca1863afca60df);
$parcel$export(module.exports, "agentModeTextKey", () => $e5597e681bfa1d4e$export$71a0d546923df1f0);
$parcel$export(module.exports, "agentModeFieldRow", () => $e5597e681bfa1d4e$export$dfef056c728d051e);
$parcel$export(module.exports, "agentModeHeaderOf", () => $e5597e681bfa1d4e$export$5df0c1ec0fc8abb4);
$parcel$export(module.exports, "agentModeSidebarRowsOf", () => $e5597e681bfa1d4e$export$7de6e4fe867e1530);
$parcel$export(module.exports, "agentModeFooterOf", () => $e5597e681bfa1d4e$export$e4436a51908af986);
$parcel$export(module.exports, "agentModeContentOf", () => $e5597e681bfa1d4e$export$9e9dc7009d50edd1);
$parcel$export(module.exports, "agentModeContentState", () => $e5597e681bfa1d4e$export$5fe97b8aef398c38);
$parcel$export(module.exports, "agentModeVisualOf", () => $e5597e681bfa1d4e$export$b1725ada39b44a61);
$parcel$export(module.exports, "agentModeColumnsOf", () => $e5597e681bfa1d4e$export$4ccf6aee89ee20bf);
$parcel$export(module.exports, "agentModeListOf", () => $e5597e681bfa1d4e$export$a57e5b5a55e4296);
$parcel$export(module.exports, "agentModeDetailOf", () => $e5597e681bfa1d4e$export$b7442491d2c9b2b4);
$parcel$export(module.exports, "agentModeDashboardOf", () => $e5597e681bfa1d4e$export$36ef067f70ad41c2);
$parcel$export(module.exports, "agentModeChatOf", () => $e5597e681bfa1d4e$export$32aa21ec74875ee);
$parcel$export(module.exports, "agentModeAssistantOf", () => $e5597e681bfa1d4e$export$4f88f6eba475d65a);
$parcel$export(module.exports, "agentModeOverlayOf", () => $e5597e681bfa1d4e$export$311df4a469bfdab1);
$parcel$export(module.exports, "agentModeViewShown", () => $e5597e681bfa1d4e$export$4eeff4093b065fc1);
$parcel$export(module.exports, "agentModeBoardModel", () => $e5597e681bfa1d4e$export$c38cce314271fac1);
$parcel$export(module.exports, "agentModeListModel", () => $e5597e681bfa1d4e$export$7782b28de28fe8a3);
$parcel$export(module.exports, "agentModeDetailModel", () => $e5597e681bfa1d4e$export$3329043e80845f1a);
$parcel$export(module.exports, "agentModeDashboardModel", () => $e5597e681bfa1d4e$export$4bfa6177293811f4);
$parcel$export(module.exports, "agentModeChatModel", () => $e5597e681bfa1d4e$export$fdfadfa1c58ec6ba);
$parcel$export(module.exports, "agentModeAssistantModel", () => $e5597e681bfa1d4e$export$ffbb36a0a78ec2c6);
$parcel$export(module.exports, "agentModeOverlayModel", () => $e5597e681bfa1d4e$export$9d9ccdb8674cba6e);
$parcel$export(module.exports, "agentModeRevealSelected", () => $e5597e681bfa1d4e$export$dd818438cec84aee);
// agentModeView.js — the snapshot, read for the DOM (WS-AGENT-MODE-1).
//
// The shared runtime's `snapshot()` (`@symbo.ls/workspace-model`, README
// "snapshot()") describes the whole screen as plain data: the TUI draws it
// into terminal cells, Agent mode draws it as real DOM. Every frame component
// reads the snapshot through THIS file only, so its shape is known in one
// place. Nothing here decides anything the model decides (selection, filter,
// paging, what a key or a click does): the model already hands renderer-ready
// parts (`content.view`) and the `click` payload of every clickable node,
// which travel as they are. This file picks fields, adds the DOM's row keys
// and maps the model's ink tokens onto brand colour roles.
//
// Rows carry prefixed `key`s: a row keyed by data would otherwise become the
// HTML tag its id names (SYNTAX "A key that equals an HTML tag name BECOMES
// that tag").
//
// Frank note: every export is self-contained (FA204) — small maps restated.
// The model's ink tokens (and status tones) → brand colour roles. Every role
// clears the contrast floor on `document` in both schemes.
const $e5597e681bfa1d4e$export$487344154ccaf269 = (token)=>{
    const map = {
        title: 'title',
        strong: 'title',
        text: 'paragraph',
        muted: 'caption',
        faint: 'caption',
        label: 'caption',
        accent: 'accentInk',
        accentBold: 'accentInk',
        success: 'successInk',
        danger: 'dangerInk',
        error: 'dangerInk',
        warning: 'warningInk',
        info: 'caption'
    };
    const t = String(token || '');
    const last = t.includes('+') ? t.slice(t.lastIndexOf('+') + 1) : t;
    return map[last] || 'caption';
};
const $e5597e681bfa1d4e$export$30a7b0fa30973908 = (state)=>({
        live: 'accentInk',
        done: 'successInk',
        warn: 'warningInk',
        error: 'dangerInk'
    })[String(state || '')] || 'caption';
const $e5597e681bfa1d4e$export$d0ca1863afca60df = (name)=>{
    const parts = String(name || '').trim().split(/[\s._@-]+/).filter(Boolean);
    return parts.length ? parts[0][0].toUpperCase() : '?';
};
const $e5597e681bfa1d4e$export$71a0d546923df1f0 = (text)=>{
    const str = String(text || '');
    let h = 0;
    for(let i = 0; i < str.length; i++)h = Math.imul(31, h) + str.charCodeAt(i) | 0;
    return `t${str.length}-${(h >>> 0).toString(36)}`;
};
const $e5597e681bfa1d4e$export$dfef056c728d051e = (node, key, extra)=>{
    const n = node && typeof node === 'object' ? node : {};
    return {
        key: key,
        target: String(n.target || ''),
        value: String(n.value == null ? '' : n.value),
        caret: Number.isInteger(n.caret) ? n.caret : null,
        placeholder: String(n.placeholder || ''),
        focused: !!n.focused,
        ...extra || {}
    };
};
function $e5597e681bfa1d4e$export$5df0c1ec0fc8abb4(snap) {
    const s = snap && typeof snap === 'object' ? snap : {};
    const status = s.status && typeof s.status === 'object' ? s.status : null;
    return {
        host: String(s.host || ''),
        title: String(s.title || ''),
        app: s.app || '',
        tabs: (Array.isArray(s.tabs) ? s.tabs : []).map((t)=>({
                key: `tab-${t.key}`,
                tab: String(t.key),
                label: String(t.label || ''),
                active: !!t.active,
                click: t.click || {
                    tab: t.key
                }
            })),
        busy: !!(status && status.kind === 'busy'),
        // A toast carries the TUI's mark: ✓ done, ! failed.
        statusText: status ? `${status.kind === 'toast' ? ({
            success: "\u2713 ",
            error: '! '
        })[status.tone] || '' : ''}${String(status.text || '')}` : '',
        statusInk: status ? this.call('agentModeInk', status.tone) : 'caption'
    };
}
const $e5597e681bfa1d4e$export$7de6e4fe867e1530 = (snap)=>{
    const side = snap && snap.sidebar && typeof snap.sidebar === 'object' ? snap.sidebar : {};
    const rows = [];
    if (side.label) rows.push({
        key: 'side-ws',
        kind: 'label',
        text: String(side.label)
    });
    for (const [gi, g] of (Array.isArray(side.groups) ? side.groups : []).entries()){
        if (g.label) rows.push({
            key: `side-g${gi}`,
            kind: 'label',
            text: String(g.label),
            gap: true
        });
        for (const it of Array.isArray(g.items) ? g.items : [])rows.push({
            key: `side-app-${it.key}`,
            kind: 'item',
            app: String(it.key),
            // The shell's own app glyph (shared glyphNameFor reads a route).
            route: it.key === 'home' ? '/' : `/${it.key}`,
            text: String(it.label || ''),
            hint: String(it.hint || ''),
            number: Number.isInteger(it.index) && it.index < 9 ? String(it.index + 1) : '',
            active: !!it.active,
            cursor: !!side.focused && it.index === side.cursor,
            badge: !!it.badge,
            click: it.click || {
                app: it.key
            }
        });
    }
    return rows;
};
function $e5597e681bfa1d4e$export$e4436a51908af986(snap) {
    const f = snap && snap.footer && typeof snap.footer === 'object' ? snap.footer : {};
    return {
        focused: !!f.focused,
        click: f.click || {
            ask: true
        },
        field: this.call('agentModeFieldRow', f.input || {
            target: 'ask'
        }, 'ask-field', {
            focusPayload: f.click || {
                ask: true
            },
            labelKey: 'workspace.agentMode.askAi'
        }),
        hints: (Array.isArray(f.hints) ? f.hints : []).map(([k, v], i)=>({
                key: `hint-${i}`,
                k: String(k),
                v: String(v)
            }))
    };
}
const $e5597e681bfa1d4e$export$9e9dc7009d50edd1 = (snap)=>{
    const c = snap && snap.content && typeof snap.content === 'object' ? snap.content : null;
    if (!c) return {
        type: 'none',
        status: 'idle',
        view: null,
        data: null,
        def: {},
        label: ''
    };
    const def = c.def && typeof c.def === 'object' ? c.def : {};
    return {
        type: String(c.type || def.type || 'list'),
        status: String(c.status || 'ready'),
        error: c.error || null,
        label: String(def.label || ''),
        empty: def.empty ? String(def.empty) : '',
        focused: !!c.focused,
        def: def,
        data: c.data == null ? null : c.data,
        view: c.view && typeof c.view === 'object' ? c.view : null
    };
};
function $e5597e681bfa1d4e$export$5fe97b8aef398c38(snap) {
    const c = this.call('agentModeContentOf', snap);
    if (c.type === 'none') return 'none';
    if (c.status === 'loading' && c.data == null && c.type !== 'assistant') return 'loading';
    if (c.status === 'error' && c.data == null) return 'error';
    return 'view';
}
function $e5597e681bfa1d4e$export$b1725ada39b44a61(spec) {
    if (!spec || typeof spec !== 'object') return null;
    if (spec.kind === 'dot') return {
        kind: 'dot',
        ink: this.call('agentModeDotInk', spec.state)
    };
    if (spec.kind === 'people') return {
        kind: 'people',
        people: (spec.names || []).slice(0, 4).map((n, i)=>({
                key: `p-${i}`,
                initial: this.call('agentModeInitial', n),
                name: String(n || '')
            }))
    };
    if (spec.kind === 'progress') return {
        kind: 'progress',
        value: Math.max(0, Math.min(1, Number(spec.value) || 0))
    };
    if (spec.kind === 'spark' || spec.kind === 'ticks') {
        const values = (spec.values || []).map(Number).filter(Number.isFinite).slice(-16);
        const max = Math.max(1, ...values);
        return {
            kind: 'bars',
            ink: spec.state ? this.call('agentModeDotInk', spec.state) : 'caption',
            bars: values.map((v, i)=>({
                    key: `b-${i}`,
                    share: Math.max(0.08, v / max)
                }))
        };
    }
    if (spec.kind === 'text') return {
        kind: 'text',
        text: String(spec.text || ''),
        ink: this.call('agentModeInk', spec.token || 'muted')
    };
    return null;
}
function $e5597e681bfa1d4e$export$4ccf6aee89ee20bf(columns, focused) {
    // Plain loops: every row is plain data (no closure over a column index).
    const out = [];
    const cols = Array.isArray(columns) ? columns : [];
    for(let ci = 0; ci < cols.length; ci++){
        const col = cols[ci];
        const cards = [];
        const list = Array.isArray(col.cards) ? col.cards : [];
        for(let r = 0; r < list.length; r++){
            const card = list[r];
            cards.push({
                key: `card-${ci}-${r}-${card.id || r}`,
                id: card.id == null ? '' : String(card.id),
                title: String(card.title == null ? '' : card.title),
                right: card.right ? String(card.right) : '',
                rightInk: this.call('agentModeInk', card.rightToken || 'muted'),
                visual: this.call('agentModeVisualOf', card.left),
                selected: !!card.selected,
                focused: !!focused,
                click: card.click || {
                    col: ci,
                    row: r
                }
            });
        }
        out.push({
            key: `col-${ci}-${col.key}`,
            column: String(col.key),
            label: String(col.label || col.key || ''),
            count: Number(col.count) || 0,
            empty: col.empty ? String(col.empty) : '',
            active: !!col.active,
            focused: !!focused,
            cards: cards
        });
    }
    return out;
}
function $e5597e681bfa1d4e$export$a57e5b5a55e4296(content) {
    const c = content || {};
    const view = c.view || {};
    const defs = Array.isArray(view.columns) && view.columns.length ? view.columns : [
        {
            key: 'title',
            label: '',
            flex: 1
        }
    ];
    const mainKey = (defs.find((x)=>x.flex) || defs[0]).key;
    const columns = defs.map((col, i)=>({
            key: `colh-${i}-${col.key}`,
            column: String(col.key),
            label: String(col.label || ''),
            align: col.align === 'right' ? 'right' : 'left',
            track: col.flex ? 'minmax(0, 1fr)' : `${Math.max(2, Number(col.width) || 10)}ch`
        }));
    const rows = Array.isArray(view.rows) ? view.rows : [];
    const hasMark = rows.some((r)=>r && (r.dot || r.people));
    const template = [
        '0',
        ...hasMark ? [
            '1ch'
        ] : [],
        ...columns.map((x)=>x.track)
    ].join(' ');
    return {
        columns: columns,
        template: template,
        hasHead: columns.some((x)=>x.label),
        hasMark: hasMark,
        filter: view.filter ? this.call('agentModeFieldRow', view.filter, 'filter-field', {
            labelKey: 'workspace.agentMode.filter'
        }) : null,
        rows: rows.map((r, i)=>r && r.group !== undefined ? {
                key: `lg-${i}`,
                kind: 'group',
                text: String(r.group || ''),
                template: template
            } : {
                key: `lr-${i}-${r && r.id || ''}`,
                kind: 'row',
                id: r && r.id != null ? String(r.id) : '',
                strong: !!(r && r.strong),
                selected: !!(r && r.selected),
                focused: !!c.focused,
                template: template,
                click: r && r.click || {
                    sel: i
                },
                mark: hasMark ? r && r.people && r.people.length ? {
                    kind: 'person',
                    text: this.call('agentModeInitial', r.people[0]),
                    ink: 'title'
                } : r && r.dot ? {
                    kind: 'dot',
                    text: "\u2022",
                    ink: this.call('agentModeDotInk', r.dot)
                } : {
                    kind: 'none',
                    text: '',
                    ink: 'caption'
                } : null,
                cells: columns.map((col, ci)=>({
                        key: `cell-${ci}`,
                        text: String((r && r.cells && r.cells[col.column]) ?? ''),
                        main: col.column === mainKey,
                        align: col.align,
                        strong: !!(r && r.strong)
                    }))
            })
    };
}
const $e5597e681bfa1d4e$export$b7442491d2c9b2b4 = (content)=>{
    const d = content && content.data || {};
    const sections = [];
    const list = Array.isArray(d.sections) ? d.sections : [];
    for(let si = 0; si < list.length; si++){
        const s = list[si];
        const items = [];
        const raw = Array.isArray(s.items) ? s.items : [];
        for(let ii = 0; ii < raw.length; ii++){
            const it = raw[ii];
            items.push({
                key: `si-${si}-${ii}`,
                author: String(it.author || ''),
                time: it.time ? String(it.time) : '',
                text: String(it.text || '')
            });
        }
        sections.push({
            key: `s-${si}`,
            title: String(s.title || ''),
            empty: s.empty ? String(s.empty) : '',
            items: items
        });
    }
    return {
        id: d.id == null ? '' : String(d.id),
        title: String(d.title || ''),
        meta: (Array.isArray(d.meta) ? d.meta : []).map((m)=>String(m)).join(" \xb7 "),
        fields: (Array.isArray(d.fields) ? d.fields : []).map(([label, value], i)=>({
                key: `f-${i}`,
                label: String(label || ''),
                value: String(value == null ? '' : value)
            })),
        body: d.body ? String(d.body) : '',
        sections: sections
    };
};
function $e5597e681bfa1d4e$export$36ef067f70ad41c2(content) {
    const v = content && content.view || {};
    return {
        greeting: String(v.greeting || ''),
        subtitle: String(v.subtitle || ''),
        errors: Array.isArray(v.errors) ? v.errors.length : Number(v.errors) || 0,
        tiles: (Array.isArray(v.tiles) ? v.tiles : []).map((t, i)=>({
                key: `tile-${i}`,
                label: String(t.label || ''),
                value: String(t.value == null ? '' : t.value),
                hint: t.hint ? String(t.hint) : '',
                dot: t.state ? this.call('agentModeDotInk', t.state) : null,
                progress: t.progress != null ? Math.max(0, Math.min(1, Number(t.progress) || 0)) : null
            }))
    };
}
function $e5597e681bfa1d4e$export$32aa21ec74875ee(content) {
    const v = content && content.view || {};
    const channel = v.channel && typeof v.channel === 'object' ? v.channel : null;
    return {
        channels: (Array.isArray(v.channels) ? v.channels : []).map((x, i)=>({
                key: `ch-${i}-${x.id}`,
                id: String(x.id),
                label: String(x.label || ''),
                selected: !!x.selected,
                click: x.click || {
                    select: {
                        channel: x.id
                    }
                }
            })),
        active: channel ? {
            id: String(channel.id),
            label: String(channel.label || '')
        } : null,
        topic: channel && channel.topic ? String(channel.topic) : '',
        messages: (Array.isArray(v.messages) ? v.messages : []).map((m, i)=>({
                key: `msg-${i}-${m.id || ''}`,
                author: String(m.author || ''),
                mine: !!m.mine,
                time: m.time ? String(m.time) : '',
                text: String(m.text || '')
            })),
        writing: !!v.writing,
        writeClick: v.writeClick || {
            write: true
        },
        composer: this.call('agentModeFieldRow', v.composer || {
            target: 'composer'
        }, 'composer-field', {
            focusPayload: v.writeClick || {
                write: true
            },
            labelKey: 'workspace.agentMode.writeMessage'
        })
    };
}
const $e5597e681bfa1d4e$export$4f88f6eba475d65a = (snap)=>{
    const a = snap && snap.assistant || {};
    const v = snap && snap.content && snap.content.view || {};
    return {
        streaming: !!a.streaming,
        suggestions: (Array.isArray(v.suggestions) ? v.suggestions : []).map((t, i)=>({
                key: `sug-${i}`,
                text: String(t)
            })),
        turns: (Array.isArray(a.turns) ? a.turns : []).map((t, i)=>({
                key: `turn-${i}`,
                role: t.role === 'user' ? 'user' : 'assistant',
                text: String(t.text || ''),
                status: String(t.status || 'done'),
                error: t.error && t.error.message ? String(t.error.message) : '',
                hint: t.error && t.error.hint ? String(t.error.hint) : ''
            }))
    };
};
function $e5597e681bfa1d4e$export$311df4a469bfdab1(snap) {
    const list = snap && Array.isArray(snap.overlays) ? snap.overlays : [];
    const o = list[list.length - 1];
    if (!o || typeof o !== 'object') return null;
    const kind = String(o.kind || '');
    const title = String(o.title || '');
    if (kind === 'picker') return {
        kind: kind,
        title: title,
        emptyText: o.emptyText ? String(o.emptyText) : '',
        query: this.call('agentModeFieldRow', o.query || {
            target: 'query'
        }, 'picker-query', {
            labelText: title
        }),
        items: (Array.isArray(o.items) ? o.items : []).map((it, i)=>({
                key: `pick-${i}`,
                label: String(it.label || ''),
                hint: it.hint ? String(it.hint) : '',
                ink: it.token ? this.call('agentModeInk', it.token) : 'title',
                selected: !!it.selected,
                enabled: it.enabled !== false,
                click: it.click || {
                    pick: i
                }
            }))
    };
    if (kind === 'form') return {
        kind: kind,
        title: title,
        submitLabel: String(o.submitLabel || ''),
        submitFocused: !!o.submitFocused,
        submitClick: o.submitClick || {
            submit: true
        },
        fields: (Array.isArray(o.fields) ? o.fields : []).map((f, i)=>{
            const type = f.type === 'select' || f.type === 'editor' ? f.type : 'text';
            const click = f.click || {
                field: i
            };
            const node = type === 'text' && f.input ? f.input : {
                target: f.target,
                value: f.value,
                focused: f.focused
            };
            const options = Array.isArray(f.options) ? f.options : [];
            return {
                key: `field-${i}-${f.key}`,
                field: String(f.key),
                label: String(f.label || ''),
                type: type,
                focused: !!f.focused,
                error: f.error ? String(f.error) : '',
                click: click,
                optionLabel: type === 'select' ? String((options[Number(f.choice) || 0] || {}).label || '') : '',
                input: this.call('agentModeFieldRow', node, `form-${type}`, {
                    focusPayload: click,
                    labelText: String(f.label || '')
                })
            };
        })
    };
    if (kind === 'confirm') return {
        kind: kind,
        title: title,
        message: String(o.message || ''),
        danger: !!o.danger,
        yes: String(o.yes || ''),
        no: String(o.no || ''),
        choice: Number(o.choice) || 0,
        yesClick: o.yesClick || {
            ok: true
        },
        noClick: o.noClick || {
            ok: false
        }
    };
    if (kind === 'help') {
        const helpSections = [];
        const list = (Array.isArray(o.sections) ? o.sections : []).filter((s)=>Array.isArray(s.rows) && s.rows.length);
        for(let si = 0; si < list.length; si++){
            const rows = [];
            for(let ri = 0; ri < list[si].rows.length; ri++){
                const [k, label] = list[si].rows[ri];
                rows.push({
                    key: `hr-${si}-${ri}`,
                    k: String(k),
                    label: String(label)
                });
            }
            helpSections.push({
                key: `hs-${si}`,
                title: String(list[si].title || ''),
                rows: rows
            });
        }
        return {
            kind: kind,
            title: title,
            sections: helpSections,
            // The TUI's lines (shell/overlays.js drawHelp): per section its title,
            // its rows and a blank line. `ui` is the model's own object (the
            // renderer's scroll memory, `ui.top` in lines), never a copy.
            lines: helpSections.reduce((n, sec)=>n + sec.rows.length + 2, 0),
            ui: o.ui && typeof o.ui === 'object' ? o.ui : null
        };
    }
    return null;
}
function $e5597e681bfa1d4e$export$4eeff4093b065fc1(root, type) {
    const snap = this.call('agentModeSnapshot', root);
    if (this.call('agentModeContentState', snap) !== 'view') return false;
    return this.call('agentModeContentOf', snap).type === type;
}
function $e5597e681bfa1d4e$export$c38cce314271fac1(root) {
    const c = this.call('agentModeContentOf', this.call('agentModeSnapshot', root));
    return c.type === 'board' || c.type === 'dashboard' ? this.call('agentModeColumnsOf', (c.view || {}).columns, c.focused) : [];
}
function $e5597e681bfa1d4e$export$7782b28de28fe8a3(root) {
    const c = this.call('agentModeContentOf', this.call('agentModeSnapshot', root));
    return this.call('agentModeListOf', c.type === 'list' ? c : {});
}
function $e5597e681bfa1d4e$export$3329043e80845f1a(root) {
    const c = this.call('agentModeContentOf', this.call('agentModeSnapshot', root));
    return this.call('agentModeDetailOf', c.type === 'detail' ? c : {});
}
function $e5597e681bfa1d4e$export$4bfa6177293811f4(root) {
    const c = this.call('agentModeContentOf', this.call('agentModeSnapshot', root));
    return this.call('agentModeDashboardOf', c.type === 'dashboard' ? c : {});
}
function $e5597e681bfa1d4e$export$fdfadfa1c58ec6ba(root) {
    const c = this.call('agentModeContentOf', this.call('agentModeSnapshot', root));
    return this.call('agentModeChatOf', c.type === 'chat' ? c : {});
}
function $e5597e681bfa1d4e$export$ffbb36a0a78ec2c6(root) {
    return this.call('agentModeAssistantOf', this.call('agentModeSnapshot', root));
}
function $e5597e681bfa1d4e$export$9d9ccdb8674cba6e(root) {
    return this.call('agentModeOverlayOf', this.call('agentModeSnapshot', root));
}
const $e5597e681bfa1d4e$export$dd818438cec84aee = (el, s)=>{
    if (!el || !s || !s.selected) return;
    queueMicrotask(()=>{
        const node = el.node;
        if (node && node.isConnected && typeof node.scrollIntoView === 'function') node.scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
        });
    });
};

});

parcelRegister("7BIh5", function(module, exports) {

$parcel$export(module.exports, "agentModeFocusTarget", () => $589e551791c3bc3d$export$ffdf8c444af377f4);
$parcel$export(module.exports, "agentModeFocusField", () => $589e551791c3bc3d$export$4ecf365e61cd32ae);
$parcel$export(module.exports, "agentModeFocusFrame", () => $589e551791c3bc3d$export$d951bf692b53227);
// agentModeFocus.js — the browser focus follows the model's focus
// (WS-AGENT-MODE-1).
//
// The shared runtime owns WHERE the person is: the sidebar, the content, the
// ASK AI bar, an overlay, a list filter, the chat composer. The browser has
// one focused node. Two rules keep them one:
//   - a frame field the model focuses takes the browser focus
//     (agentModeFocusField, from the field's own render / update);
//   - while the model focuses no field, the frame itself holds the focus, so
//     the keydown bridge keeps receiving keys (agentModeFocusFrame).
// A pointer into a field the model has not focused tells the model first
// (AgentModeField onFocus). The focus moves in a microtask: a field that
// was hidden a moment ago is shown by then (the framework applies `hide` in
// a microtask).
// Which field the snapshot focuses (its input node's `target`), or null.
const $589e551791c3bc3d$export$ffdf8c444af377f4 = (snap)=>{
    if (!snap || typeof snap !== 'object') return null;
    const overlays = Array.isArray(snap.overlays) ? snap.overlays : [];
    const top = overlays[overlays.length - 1];
    if (top) {
        if (top.kind === 'picker') return top.query && top.query.focused ? top.query.target : null;
        if (top.kind === 'form') {
            const f = (Array.isArray(top.fields) ? top.fields : []).find((x)=>x && x.focused);
            return f && f.type !== 'select' ? f.target : null;
        }
        return null;
    }
    const ask = snap.footer && snap.footer.input;
    if (ask && ask.focused) return ask.target;
    const view = snap.content && snap.content.view || {};
    if (view.filter && view.filter.focused) return view.filter.target;
    if (view.composer && view.composer.focused) return view.composer.target;
    return null;
};
const $589e551791c3bc3d$export$4ecf365e61cd32ae = (el, s)=>{
    if (!el || !s || !s.focused) return;
    const attempt = (left)=>{
        const node = el.node;
        if (!node || typeof node.focus !== 'function') return;
        const retry = ()=>{
            if (left > 0 && typeof requestAnimationFrame === 'function') requestAnimationFrame(()=>attempt(left - 1));
        };
        if (!node.isConnected) return retry();
        const doc = node.ownerDocument;
        if (!doc || doc.activeElement !== node) node.focus({
            preventScroll: true
        });
        if (doc && doc.activeElement !== node) return retry();
        // The model's caret (↑ in the ask bar walks the history; a send clears).
        // Only a caret the MODEL moved is applied: a render that leaves it where
        // the person typed (a spinner tick, a toast) keeps their selection.
        const scope = el.scope || {};
        const caret = Number.isInteger(s.caret) ? Math.min(s.caret, node.value.length) : null;
        if (caret === null || scope.agentModeCaret === caret) return;
        scope.agentModeCaret = caret;
        if (typeof node.setSelectionRange === 'function' && node.selectionStart !== caret) node.setSelectionRange(caret, caret);
    };
    queueMicrotask(()=>attempt(8));
};
function $589e551791c3bc3d$export$d951bf692b53227(frame) {
    const el = frame || this;
    const root = el && el.state && el.state.root;
    if (!el || !root) return;
    const snap = this.call('agentModeSnapshot', root);
    if (snap && this.call('agentModeFocusTarget', snap)) return;
    // Same retry as agentModeFocusField: at the first render of a page load
    // the frame is not attached yet, and the keys stayed dead until a click.
    const attempt = (left)=>{
        const node = el.node;
        if (!node || typeof node.focus !== 'function') return;
        const retry = ()=>{
            if (left > 0 && typeof requestAnimationFrame === 'function') requestAnimationFrame(()=>attempt(left - 1));
        };
        if (!node.isConnected) return retry();
        const doc = node.ownerDocument;
        const active = doc && doc.activeElement;
        if (active === node) return;
        // A control of the frame (a tab, a button) may keep a focus it took.
        if (active && node.contains(active)) {
            const tag = String(active.tagName || '').toLowerCase();
            if (tag !== 'input' && tag !== 'textarea') return;
            // A field the model focuses by now keeps it (its own render moved it).
            const now = this.call('agentModeSnapshot', root);
            if (now && this.call('agentModeFocusTarget', now)) return;
        }
        node.focus({
            preventScroll: true
        });
        if (doc && doc.activeElement !== node) retry();
    };
    queueMicrotask(()=>attempt(8));
}

});

parcelRegister("gwiue", function(module, exports) {

$parcel$export(module.exports, "agentModeLineHeight", () => $c06df988400f2461$export$701537542a8872ce);
$parcel$export(module.exports, "agentModeSyncScroll", () => $c06df988400f2461$export$8ac3375a99ff85d7);
$parcel$export(module.exports, "agentModeReportScroll", () => $c06df988400f2461$export$bce5349a4ded073b);
$parcel$export(module.exports, "agentModeSyncHelpScroll", () => $c06df988400f2461$export$c89c24ce12146a5d);
$parcel$export(module.exports, "agentModeReportHelpScroll", () => $c06df988400f2461$export$366027c71a7f5ed5);
// agentModeScroll.js — the content's scroll and the model's rows
// (WS-AGENT-MODE-1).
//
// A detail document and the Ask AI conversation scroll by keys in the model
// (j / k, g / G, PgUp / PgDn move `view.top`, in rows). The DOM scrolls
// natively. Two moves keep them one (the package README "viewport()"):
//   - the model's row → the scroller: when `view.top` changes, the content
//     scrolls to top × its line height (agentModeSyncScroll);
//   - the scroller → the model: the sizes the page keys read (contentRows,
//     docRows) and, after a native scroll, the row now at the top
//     (agentModeReportScroll → runtime.viewport).
// Lists and boards need neither: their rows reveal themselves
// (agentModeRevealSelected).
// The scroller moves through `scrollTo()` — reading and scrolling `el.node`
// is allowed; a property write (`node.scrollTop = …`) is frank FA511.
// The line height of a node in px (the frame's mono line), or null.
const $c06df988400f2461$export$701537542a8872ce = (node)=>{
    if (!node || !node.ownerDocument || !node.ownerDocument.defaultView) return null;
    const cs = node.ownerDocument.defaultView.getComputedStyle(node);
    const lh = parseFloat(cs.lineHeight);
    if (Number.isFinite(lh) && lh > 0) return lh;
    const fs = parseFloat(cs.fontSize);
    return Number.isFinite(fs) && fs > 0 ? fs * 1.5 : null;
};
function $c06df988400f2461$export$8ac3375a99ff85d7(el) {
    const root = el && el.state && el.state.root;
    const node = el && el.node;
    if (!root || !node) return;
    const snap = this.call('agentModeSnapshot', root);
    const content = snap && snap.content;
    const view = content && content.view;
    if (!view || content.type !== 'detail' && content.type !== 'assistant') return;
    const lh = this.call('agentModeLineHeight', node);
    if (!lh) return;
    const scope = el.scope || {};
    queueMicrotask(()=>{
        if (!node.isConnected) return;
        // Ask AI follows the newest line until the reader scrolls up.
        if (content.type === 'assistant' && view.follow) {
            if (typeof node.scrollTo === 'function') node.scrollTo({
                top: node.scrollHeight
            });
            return;
        }
        const top = Number(view.top) || 0;
        if (scope.agentModeTop === top) return;
        scope.agentModeTop = top;
        if (typeof node.scrollTo === 'function') node.scrollTo({
            top: top * lh
        });
    });
}
function $c06df988400f2461$export$bce5349a4ded073b(el, opts) {
    const root = el && el.state && el.state.root;
    const node = el && el.node;
    const runtime = root && root.__agentModeRuntime;
    if (!runtime || typeof runtime.viewport !== 'function' || !node) return;
    const lh = this.call('agentModeLineHeight', node);
    if (!lh) return;
    const top = Math.round(node.scrollTop / lh);
    if (el.scope) el.scope.agentModeTop = top;
    runtime.viewport({
        contentRows: Math.max(1, Math.floor(node.clientHeight / lh)),
        docRows: Math.max(1, Math.ceil(node.scrollHeight / lh)),
        ...opts && opts.top ? {
            top: top
        } : {}
    });
}
function $c06df988400f2461$export$c89c24ce12146a5d(el) {
    const root = el && el.state && el.state.root;
    const node = el && el.node;
    if (!root || !node) return;
    const o = this.call('agentModeOverlayModel', root);
    if (!o || o.kind !== 'help' || !o.ui) return;
    const lh = this.call('agentModeLineHeight', node);
    if (!lh) return;
    const ui = o.ui;
    const lines = Number(o.lines) || 0;
    queueMicrotask(()=>{
        if (!node.isConnected) return;
        const shown = Math.max(1, Math.floor(node.clientHeight / lh));
        const top = Math.max(0, Math.min(Number(ui.top) || 0, Math.max(0, lines - shown)));
        ui.top = top;
        if (typeof node.scrollTo === 'function') node.scrollTo({
            top: top * lh
        });
    });
}
function $c06df988400f2461$export$366027c71a7f5ed5(el) {
    const root = el && el.state && el.state.root;
    const node = el && el.node;
    if (!root || !node) return;
    const o = this.call('agentModeOverlayModel', root);
    if (!o || o.kind !== 'help' || !o.ui) return;
    const lh = this.call('agentModeLineHeight', node);
    if (!lh) return;
    o.ui.top = Math.round(node.scrollTop / lh);
}

});

parcelRegister("4iFeZ", function(module, exports) {

$parcel$export(module.exports, "phoneNavigationAvailable", () => $3218d56a1f511e1c$export$3d05fc806b560ed4);
$parcel$export(module.exports, "phoneNavigationSync", () => $3218d56a1f511e1c$export$db9e580aa52b8e08);
$parcel$export(module.exports, "phoneNavigationBack", () => $3218d56a1f511e1c$export$8ba2cd439d13597d);
$parcel$export(module.exports, "phoneNavigationPanel", () => $3218d56a1f511e1c$export$68876d19e146b48f);
$parcel$export(module.exports, "phoneNavigationClose", () => $3218d56a1f511e1c$export$ab0ca1b6e6159d3f);
$parcel$export(module.exports, "phoneNavigationAppGroups", () => $3218d56a1f511e1c$export$5847fede3b4d5fa6);
$parcel$export(module.exports, "phoneNavigationApps", () => $3218d56a1f511e1c$export$4e6b9f54a7d62246);
$parcel$export(module.exports, "phoneNavigationOpen", () => $3218d56a1f511e1c$export$7806699eb3eecfab);
$parcel$export(module.exports, "phoneNavigationPageRail", () => $3218d56a1f511e1c$export$b730d1cfab6398fc);
$parcel$export(module.exports, "phoneNavigationBrowse", () => $3218d56a1f511e1c$export$881765e74e8c1f56);
$parcel$export(module.exports, "phoneNavigationAssistant", () => $3218d56a1f511e1c$export$7902122ebdd3f5b);
$parcel$export(module.exports, "phoneNavigationUnread", () => $3218d56a1f511e1c$export$df14d7abf1712ddb);
$parcel$export(module.exports, "phoneNavigationSearch", () => $3218d56a1f511e1c$export$8cfb4e94f7532adf);
$parcel$export(module.exports, "phoneNavigationStyles", () => $3218d56a1f511e1c$export$8a12810377b57d43);
// Phone chrome keeps navigation local. App destinations still use the shell's
// permission catalog and guarded opener. No navigation path bypasses either.
function $3218d56a1f511e1c$export$3d05fc806b560ed4(root) {
    const r = root || this.state && this.state.root;
    if (!r || !r.workspace) return false;
    const path = this.call('stripWorkspacePrefix', r.currentPath || '/').split(/[?#]/)[0];
    const fns = this.context && this.context.functions || {};
    if (typeof fns.moduleImmersiveActive === 'function' && this.call('moduleImmersiveActive', r)) return false;
    return !this.call('isChromelessShellPath', path) && path !== '/meet-guest';
}
function $3218d56a1f511e1c$export$db9e580aa52b8e08(el, s) {
    const host = el || this;
    const root = s && s.root || host.state && host.state.root;
    if (!root || typeof root.update !== 'function') return;
    const workspace = root.workspace && (root.workspace.id || root.workspace._id);
    const route = String(root.currentPath || '/').split(/[?#]/)[0];
    const key = JSON.stringify([
        workspace,
        route,
        root._canvasSlot,
        root._canvasSlotSecond
    ]);
    const patch = {};
    if (host.__phoneNavLocation && host.__phoneNavLocation !== key) {
        patch._phoneNavPanel = null;
        patch._phoneNavError = null;
        patch._phoneNavOperation = null;
        patch._phoneComposerOpen = false;
        for (const rail of [
            '_filesRailOpen',
            '_canvasRailOpen',
            '_chatSidebarOpen',
            '_calRailOpen',
            '_meetRailOpen',
            '_ticketsRailOpen',
            '_docsRailOpen',
            '_mailRailOpen',
            '_moduleRailOpen'
        ])if (root[rail]) patch[rail] = false;
    }
    host.__phoneNavLocation = key;
    const media = host.context && host.context.designSystem && host.context.designSystem.media;
    const query = media && media.mobileL;
    if (typeof query === 'string' && typeof window !== 'undefined' && window.matchMedia) {
        const phone = window.matchMedia(query.startsWith('(') ? query : '(' + query + ')').matches;
        if (root._isPhoneViewport !== phone) patch._isPhoneViewport = phone;
        if (!phone && root._phoneNavPanel) patch._phoneNavPanel = null;
    }
    // The route trail the phone Back steps (phoneNavigationBack below): every
    // route the shell shows, in the panes' own history shape (canvas
    // functions/slotHistory.js). A Back landing is the cursor already, so it
    // records nothing — the panes' rule, no guard flag.
    const fns = host.context && host.context.functions || {};
    if (typeof fns.histRecord === 'function' && root.currentPath) {
        const hist = host.call('histRecord', root._phoneNavHist, String(root.currentPath));
        if (hist && hist !== root._phoneNavHist) patch._phoneNavHist = hist;
    }
    if (Object.keys(patch).length) root.update(patch, {
        preventFetch: true
    });
}
function $3218d56a1f511e1c$export$8ba2cd439d13597d() {
    const root = this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const fns = this.context && this.context.functions || {};
    const step = typeof fns.histBack === 'function' ? this.call('histBack', root._phoneNavHist) : null;
    if (!step) return this.call('phoneNavigationOpen', '/');
    root.update({
        _phoneNavHist: step.hist
    }, {
        preventFetch: true
    });
    this.router(step.path, this.getRoot());
    return step.path;
}
function $3218d56a1f511e1c$export$68876d19e146b48f(panel) {
    const root = this.state && this.state.root;
    if (!this.call('phoneNavigationAvailable', root)) return false;
    if (panel !== 'apps' && panel !== 'menu' && panel !== null) return false;
    root.update({
        _phoneNavPanel: panel,
        _phoneNavError: null,
        _phoneNavOperation: null
    }, {
        preventFetch: true
    });
    return true;
}
function $3218d56a1f511e1c$export$ab0ca1b6e6159d3f() {
    return this.call('phoneNavigationPanel', null);
}
function $3218d56a1f511e1c$export$5847fede3b4d5fa6(root) {
    const r = root || this.state && this.state.root;
    if (!this.call('phoneNavigationAvailable', r)) return [];
    const groups = [];
    const seen = new Set();
    for (const group of this.call('searchAppGroupsFor', r) || []){
        const apps = [];
        for (const app of group && group.apps || []){
            const route = app && app.route;
            if (typeof route !== 'string' || !/^\/(?!\/)[^\s\\]*$/.test(route) || seen.has(route)) continue;
            seen.add(route);
            apps.push(app);
        }
        if (apps.length) groups.push({
            ...group,
            apps: apps
        });
    }
    return groups;
}
function $3218d56a1f511e1c$export$4e6b9f54a7d62246(root) {
    const rows = [];
    for (const group of this.call('phoneNavigationAppGroups', root))for (const app of group.apps)rows.push({
        value: app.route,
        label: this.call('polyglot', app.title || app.label || app.route),
        hint: this.call('polyglot', group.label || ''),
        icon: app.icon || 'arrowUpRight'
    });
    return rows;
}
function $3218d56a1f511e1c$export$7806699eb3eecfab(value) {
    const root = this.state && this.state.root;
    if (!this.call('phoneNavigationAvailable', root)) return false;
    if (value !== '/' && !this.call('phoneNavigationApps', root).some((row)=>row.value === value)) return false;
    const operation = crypto.randomUUID();
    const workspace = root.workspace;
    root.update({
        _phoneNavOperation: operation,
        _phoneNavError: null
    }, {
        preventFetch: true
    });
    const settle = (ok)=>{
        if (root.workspace !== workspace || root._phoneNavOperation !== operation) return false;
        root.update({
            _phoneNavOperation: null,
            _phoneNavError: ok === false ? 'navigation' : null,
            _phoneNavPanel: ok === false ? root._phoneNavPanel : null
        }, {
            preventFetch: true
        });
        return ok !== false;
    };
    try {
        const opened = this.call('openAppPage', value);
        return opened && typeof opened.then === 'function' ? opened.then(settle, ()=>settle(false)) : settle(opened);
    } catch (_) {
        return settle(false);
    }
}
function $3218d56a1f511e1c$export$b730d1cfab6398fc(root) {
    const r = root || this.state && this.state.root;
    if (!r) return null;
    const path = this.call('stripWorkspacePrefix', r.currentPath || '/').split(/[?#]/)[0];
    if (path === '/files') return '_filesRailOpen';
    if ([
        '/infra',
        '/agents',
        '/my-agents',
        '/team-and-agents',
        '/canvas'
    ].includes(path) || path === '/studio' || path.startsWith('/studio/')) return '_canvasRailOpen';
    if (path === '/chat') return '_chatSidebarOpen';
    if (path === '/calendar') return '_calRailOpen';
    if (path === '/meet') return '_meetRailOpen';
    if ([
        '/tasks',
        '/tasks/board',
        '/tasks/epics',
        '/tickets',
        '/tickets/board',
        '/tickets/epics'
    ].includes(path)) return '_ticketsRailOpen';
    if ([
        '/notes',
        '/documents',
        '/knowledge-base'
    ].includes(path)) return '_docsRailOpen';
    // A module's own navigation (chrome.rail) on its surface routes: the phone
    // keeps it in a drawer (app.js ModuleRailHost) instead of a column.
    const fns = this.context && this.context.functions || {};
    if (r._projectCanvasOpen && typeof fns.canvasEditorOpen === 'function' && this.call('canvasEditorOpen', r)) return '_canvasRailOpen';
    if (typeof fns.moduleRailActive === 'function' && this.call('moduleRailActive', r)) return '_moduleRailOpen';
    return null;
}
function $3218d56a1f511e1c$export$881765e74e8c1f56() {
    const root = this.state && this.state.root;
    const key = this.call('phoneNavigationPageRail', root);
    if (!key || !this.call('phoneNavigationAvailable', root)) return false;
    root.update({
        _phoneNavPanel: null,
        [key]: true
    }, {
        preventFetch: true
    });
    return true;
}
function $3218d56a1f511e1c$export$7902122ebdd3f5b(canCompose = true) {
    const root = this.state && this.state.root;
    if (!this.call('phoneNavigationAvailable', root) || !this.call('featureEnabled', root, 'aiAssistant')) return false;
    if (root.assistantOpen && root.assistantDock !== 'minimized') {
        root.update({
            assistantOpen: false,
            _phoneNavPanel: null
        }, {
            preventFetch: true
        });
        return true;
    }
    const path = this.call('stripWorkspacePrefix', root.currentPath || '/').split(/[?#]/)[0];
    // The builder's AI is its own chat (functions/addAppBuilderChat.js): the
    // general drawer here opened a NEW chat, and a build thread picked from its
    // History sent paid workspace turns (persona round 2d, marcus at 390 px).
    // No builder on screen yet → the drawer, as on /chat.
    if (path === '/add-app') {
        this.call('phoneNavigationClose');
        if (this.call('addAppBuilderChatReveal') === true) {
            if (root._phoneComposerOpen) root.update({
                _phoneComposerOpen: false
            }, {
                preventFetch: true
            });
            return true;
        }
        return this.call('assistantThreadToSidebar');
    }
    if (path === '/chat' || canCompose === false) {
        this.call('phoneNavigationClose');
        return this.call('assistantThreadToSidebar');
    }
    const open = !root._phoneComposerOpen;
    root.update({
        _phoneNavPanel: null,
        _phoneComposerOpen: open
    }, {
        preventFetch: true
    });
    // The composer's hide factory re-runs in the update's microtask, so a
    // focus now would land on a hidden field. One microtask later it shows,
    // and the focus still runs inside the tap that raised it.
    if (open) queueMicrotask(()=>this.call('assistantBoardFocus', 'composer'));
    return true;
}
function $3218d56a1f511e1c$export$df14d7abf1712ddb(root) {
    const r = root || this.state && this.state.root;
    return (r && r.notifs || []).filter((n)=>n && !n.read).length;
}
function $3218d56a1f511e1c$export$8cfb4e94f7532adf() {
    const root = this.state && this.state.root;
    if (!this.call('phoneNavigationAvailable', root)) return false;
    const shell = this.getRoot();
    const opener = shell.PhoneNavigation?.Dock?.PhoneNavButton_menu?.node;
    if (!root._headerSearchOpen && opener) root.__headerSearchReturnFocusTo = opener;
    root.update({
        _phoneNavPanel: null,
        _headerSearchOpen: true
    }, {
        preventFetch: true
    });
    const header = shell.AppHeader;
    const input = header && header.HeaderSearch && header.HeaderSearch.Form && header.HeaderSearch.Form.Input;
    if (input && input.node && typeof input.node.focus === 'function') input.node.focus({
        preventScroll: true
    });
    return true;
}
function $3218d56a1f511e1c$export$8a12810377b57d43() {
    const ds = this.context && this.context.designSystem;
    const media = ds && ds.media && ds.media.mobileL;
    if (typeof media !== 'string') return '';
    const query = media.startsWith('(') ? media : '(' + media + ')';
    const phone = 'html:has([data-phone-nav="true"])';
    const content = ' [data-key="smblsapp"] > [data-key="content"]';
    return '@media ' + query + '{' + phone + '{--phone-clear:calc(var(--spacing-D) + env(safe-area-inset-bottom));--slot-top:calc(env(safe-area-inset-top) + var(--spacing-Z));--shell-top:var(--slot-top);--chip-row:0;--stack-line:calc(var(--phone-clear) + var(--spacing-Z));--composer-bottom:calc(var(--phone-clear) + var(--spacing-Z));--phone-back-row:calc(var(--size-controlH) + var(--spacing-Z))}' + phone + ' [data-key="AppHeader"]{height:0;min-height:0;padding:0;background:transparent;box-shadow:none;backdrop-filter:none;-webkit-backdrop-filter:none;pointer-events:none}' + phone + ' [data-key="AppHeader"] > [data-key="HeaderSearch"]{position:fixed;top:calc(env(safe-area-inset-top) + var(--spacing-Z));left:var(--spacing-A);right:var(--spacing-A);width:auto;max-width:none;transform:none;--hs-open-phone:none}' + phone + ' [data-key="AppHeader"] > [data-key="HeaderLeft"],' + phone + ' [data-key="AppHeader"] > [data-key="HeaderRight"],' + phone + ' [data-key="AppHeader"] > [data-key="HeaderTabs"]{display:none}' + phone + '[data-prompt="shown"]{--stack-line:calc(var(--prompt-clear) + var(--nav-gap))}' + phone + ' [data-key="CanvasPromptTextarea"]{margin-bottom:0}' + phone + // The app-route sheet's foot clears the dock. The mount has no position
    // (app.js), so a dialog in it resolves against the viewport: its frame
    // takes the same bottom, or the sheet's foot (Save / Cancel) runs under
    // the fixed dock (BESSI QA 2026-10-28, 375px: frame 10..900, mount
    // 10..804).
    '[data-shell-route="app"]' + content + '{margin:var(--slot-top) 0 var(--slot-bottom);height:calc(100dvh - var(--slot-top) - var(--slot-bottom));min-height:0;--app-dialog-inset:var(--slot-top) 0 var(--slot-bottom)}' + phone + '[data-shell-route="home"]:not([data-customizing="open"]) [data-key="content"] [data-key="MainColumn"]{padding-bottom:calc(var(--slot-bottom) + var(--spacing-A));scroll-padding-bottom:var(--slot-bottom)}' + phone + ':not([data-slot="open"]) [data-key="ChatMobileSidebarBar"],' + phone + ':not([data-slot="open"]) [data-key="DocsMobileSidebarBar"],' + phone + ':not([data-slot="open"]) [data-key="CalRailBtn"],' + phone + ':not([data-slot="open"]) [data-phone-page-menu]{display:none}' + phone + ' [data-key="FlyBarActions"]{display:none}' + // The phone Back (components/PhoneNavigation.js PhoneBack): shown on a
    // full-page app route with no pane open — a pane has its own Back — and
    // the page sheet starts below its row, so it never covers the app's
    // first row.
    phone + '[data-shell-route="app"]:not([data-slot="open"]) [data-phone-back]{display:flex}' + phone + '[data-shell-route="app"]:not([data-slot="open"])' + content + '{margin-top:calc(var(--slot-top) + var(--phone-back-row));height:calc(100dvh - var(--slot-top) - var(--phone-back-row) - var(--slot-bottom));--app-dialog-inset:calc(var(--slot-top) + var(--phone-back-row)) 0 var(--slot-bottom)}' + phone + '[data-slot="open"] [data-phone-dock]{visibility:hidden;pointer-events:none}' + '}';
}

});

parcelRegister("8amd9", function(module, exports) {

$parcel$export(module.exports, "assistantFlyStableCells", () => $5f207c8b82fee115$export$e54ffac3ede75e45);
// Fly's opening text can change many times while its sections stay the same.
// Keep the validated cells on their grid host, rather than deriving them for
// every text frame. The vocabulary is deliberately read on EVERY call: a
// module's visibility function may depend on any reactive workspace field.
// Caching that authority by object identity would retain revoked sections.
const $5f207c8b82fee115$export$e54ffac3ede75e45 = function assistantFlyStableCells(page, root, cols) {
    const host = this;
    if (!page) {
        if (host) host.__flyRenderCache = null;
        return [];
    }
    const r = root || {};
    // The lists a section's LINK reads (a site card's ↗: the canvas and preview
    // link functions name a website out of `_projectsForActiveOrg` and an App
    // Store app out of `_wsAppsCatalog`) — read on EVERY call, so the grid
    // follows them, and compared by identity: a list that lands after the cells
    // were derived derives them again (MISSING-NAMES-2).
    const lists = [
        r._projectsForActiveOrg,
        r._wsAppsCatalog
    ];
    const items = Array.isArray(page.items) ? page.items : [];
    const vocabulary = items.some(Boolean) ? this.call('boardVocabularyFor', r) : null;
    const lang = this.call('getActiveLang') || r.lang || '';
    const functions = [];
    let signature;
    try {
        signature = JSON.stringify([
            r.workspace && (r.workspace.id || r.workspace._id) || null,
            lang,
            page.key,
            page.id,
            page.prompt,
            page.title,
            page.status,
            page.phase,
            !!page.onLayer,
            cols,
            items,
            // A UI section's line follows its read (functions/assistantFly.js
            // assistantFlyCells `readState`).
            Array.isArray(page.reads) ? page.reads : null,
            vocabulary
        ], (key, value)=>{
            // JSON alone drops handlers in widget bodies/specs. Record identity as
            // well, so a module replacement cannot retain the previous callbacks.
            if (typeof value !== 'function') return value;
            functions.push(value);
            return {
                flyFunction: functions.length
            };
        });
    } catch (_) {
        // A malformed manifest must not make caching a prerequisite for a page.
        if (host) host.__flyRenderCache = null;
        return this.call('assistantFlyCells', page, r, cols);
    }
    const previous = host && Object.hasOwn(host, '__flyRenderCache') && host.__flyRenderCache;
    if (previous && previous.signature === signature && previous.functions.length === functions.length && functions.every((fn, index)=>fn === previous.functions[index]) && Array.isArray(previous.lists) && lists.every((list, index)=>list === previous.lists[index])) return previous.cells;
    const cells = this.call('assistantFlyCells', page, r, cols);
    if (host) host.__flyRenderCache = {
        signature: signature,
        cells: cells,
        functions: functions,
        lists: lists
    };
    return cells;
};

});

parcelRegister("i9IdK", function(module, exports) {

$parcel$export(module.exports, "assistantFlyCallDo", () => $d37b5e8e42942442$export$a9df555b517883d7);
$parcel$export(module.exports, "assistantFlyCallShortcuts", () => $d37b5e8e42942442$export$b2a857795b19ce5f);
$parcel$export(module.exports, "assistantFlyCallDeck", () => $d37b5e8e42942442$export$ea7f72bcc61ce2de);
// assistantFlyCall.js — the CALL'S THEATER reaches the meet package
// (components/AssistantFlyCallView.js; docs/FLY_MODE.md §3.3).
//
// The theater is a main-layer view; the layer latches at the shell root (a
// home Fly session restored at boot latches it before any call), so the view
// can render BEFORE the call's meet context is folded into the shell — its
// meet functions (meetFlyPages, meetFlyPage, …) are not registered yet. This
// is the one door to them: a name that is not registered answers `undefined`
// quietly (no "not registered" warning on every route), and the parts declare
// `root.meetFly` as their dependency (`childrenDeps` / `textDeps` / …), so
// they re-run once the call has pages — measured live on dev (d5674e131): a
// part whose first run reached the root only through an unregistered name
// subscribed to nothing and never re-ran.
//
// FRANK: self-contained; `this` is the calling element.
const $d37b5e8e42942442$export$a9df555b517883d7 = function assistantFlyCallDo(name, ...args) {
    const fns = this && this.context && this.context.functions;
    if (!fns || typeof name !== 'string' || typeof fns[name] !== 'function') return undefined;
    return this.call(name, ...args);
};
const $d37b5e8e42942442$export$b2a857795b19ce5f = function assistantFlyCallShortcuts(el) {
    const view = el || this;
    if (!view || typeof view.call !== 'function') return ()=>false;
    view.call('listShortcuts');
    const off = view.call('registerShortcut', {
        id: 'assistantFlyCallClose',
        keys: 'escape',
        label: null,
        group: 'shell.headerTabs.dashboard',
        groupOrder: 3,
        order: 9,
        when: (h, root)=>{
            const node = view.node;
            if (!node || node.isConnected === false) return false;
            if (root && (root._canvasSlot || root._canvasSlotSecond)) return false;
            return !!view.call('assistantFlyCallDo', 'meetFlyTheaterShown', root);
        },
        run: ()=>view.call('assistantFlyCallDo', 'meetFlyTheater', false)
    });
    const stop = ()=>typeof off === 'function' ? off() : false;
    view.__flyCallShortcutsOff = stop;
    return stop;
};
const $d37b5e8e42942442$export$ea7f72bcc61ce2de = function assistantFlyCallDeck(root) {
    const p = this.call('assistantFlyCallDo', 'meetFlyPage', root);
    if (!p || p.kind !== 'deck') return null;
    const raw = p.raw && typeof p.raw === 'object' ? p.raw : null;
    const slides = raw ? this.call('assistantDeckSlidesFor', raw, root).slides : [];
    const vm = {
        status: p.status || 'loading',
        error: p.error || null,
        slides: slides,
        // the deck's `slide`: the page's `index` is its place in the theater list
        index: Number(p.slide) || 0,
        notice: null
    };
    const slide = this.call('assistantDeckSlide', vm);
    return {
        key: p.key,
        title: p.title || (raw && typeof raw.title === 'string' ? raw.title : '') || '',
        status: vm.status,
        error: vm.error,
        statusText: this.call('assistantDeckStatus', vm) || '',
        slide: slide || null,
        count: slides.length,
        counter: this.call('assistantDeckCounter', vm) || '',
        canPrev: !!this.call('assistantDeckCanGo', vm, -1),
        canNext: !!this.call('assistantDeckCanGo', vm, 1)
    };
};

});

parcelRegister("5AXvC", function(module, exports) {

$parcel$export(module.exports, "assistantFlyUiState", () => $412e79cf7efcbce7$export$cd96520e17e31588);
$parcel$export(module.exports, "assistantFlyUiNote", () => $412e79cf7efcbce7$export$d2e8cb40d41117a0);
$parcel$export(module.exports, "assistantFlyUiMount", () => $412e79cf7efcbce7$export$9e51099d88b9421a);
// assistantFlyUi.js — A FLY PAGE'S UI SECTIONS (Fly train 2; docs/FLY_MODE.md
// §3.6). Nika 2026-10-18: "workspace fly is more advanced - it has way more
// tools and components and full capacity of use workspace features - so fully
// integrate it".
//
// A page may READ with the assistant's own tools (server ai-boards
// flyReads.js): the page model plans the reads right after its head, the
// server runs them under the member's own grants while the page streams, and
// a `ui` section SHOWS one read's result — the SAME payload a chat answer-UI
// tool call carries:
//   { tool: 'render_cards', args: { cards } }            people / agent chips
//   { tool: 'render_answer_ui', args: { title, source, placement } }
//                                                        a contained DOMQL view
// It is drawn with the chat's OWN renderers, never a second one:
//   render_cards      the chat's card dispatcher (shared ChatCard), one per card
//   render_answer_ui  renderAnswerUi (canvas functions/answerUi.js — the audit
//                     and the containment gate every answer view passes,
//                     registered and NOT opened) mounted inline the way the
//                     assistant's thread mounts it (assistantBlockMountView)
// The stream: board.item (the section and its read) → fly.read (the read
// settled) → fly.ui (what it shows: `ui`, `empty` or `error`); board.done
// carries the same on spec.items (functions/assistantFly.js applyFlyFrame).
//
// Frank note: el.call serializes each export on its own (FA204) — every
// export here is self-contained; a sibling is reached through this.call.
// What a UI section is doing: 'reading' (its read is out, or its result is on
// its way), 'ready' (its result is in), 'empty' (the read found nothing),
// 'error' (the read did not come back, or the page ended before its result
// came) — null for any other row. `s` is the section's cell (functions/
// assistantFly.js assistantFlyCells: the row + `readState` + `settled`).
const $412e79cf7efcbce7$export$cd96520e17e31588 = function assistantFlyUiState(s) {
    if (!s || s.kind !== 'ui') return null;
    if (s.error) return 'error';
    if (s.empty === true) return 'empty';
    if (s.ui) return 'ready';
    // The page is done and this section never heard back: the server's own
    // verdict for such a section is a timeout (AiBoardService.runFly).
    if (s.settled === true) return 'error';
    return 'reading';
};
const $412e79cf7efcbce7$export$d2e8cb40d41117a0 = function assistantFlyUiNote(s) {
    const state = this.call('assistantFlyUiState', s);
    if (!state || state === 'ready') return '';
    const say = (key)=>String(this.call('polyglot', key) || '');
    if (state === 'reading') {
        if (s.readState === 'ok') return '';
        return say('workspace.assistantFly.ui.reading').replace('{what}', String(s.title || ''));
    }
    if (state === 'empty') return say('workspace.assistantFly.ui.empty');
    const code = s.error && typeof s.error.code === 'string' ? s.error.code : 'timeout';
    // Literal keys (docs/I18N-CONVENTION.md: a key is never built).
    const KEYS = {
        timeout: 'workspace.assistantFly.ui.timeout',
        aborted: 'workspace.assistantFly.ui.aborted',
        role_required: 'workspace.assistantFly.ui.roleRequired',
        tool_unavailable: 'workspace.assistantFly.ui.toolUnavailable',
        not_found: 'workspace.assistantFly.ui.notFound',
        source_failed: 'workspace.assistantFly.ui.sourceFailed',
        read_failed: 'workspace.assistantFly.ui.failed',
        invalid_ui: 'workspace.assistantFly.ui.invalid'
    };
    return say(Object.prototype.hasOwnProperty.call(KEYS, code) ? KEYS[code] : KEYS.read_failed);
};
const $412e79cf7efcbce7$export$9e51099d88b9421a = function assistantFlyUiMount(el, s) {
    const host = el || this;
    if (!host || typeof host.set !== 'function' || !s || s.kind !== 'ui') return false;
    const ui = s.ui && typeof s.ui === 'object' ? s.ui : null;
    if (!ui) return false;
    const sig = 'ui/' + String(s.id || '') + '/' + this.call('boardSpecHash', ui);
    if (host.__flyUiSig === sig) return host.__flyUiDrawn === true;
    host.__flyUiSig = sig;
    host.__flyUiDrawn = false;
    const args = ui.args && typeof ui.args === 'object' ? ui.args : {};
    const quiet = (why)=>{
        console.warn('[assistantFly] a ui section was not drawn:', s.tool || '', why || '');
        try {
            host.set({
                tag: 'p',
                margin: '0',
                fontSize: 'Z',
                color: 'caption',
                empty: true,
                text: String(this.call('polyglot', 'workspace.assistantFly.ui.invalid'))
            });
        } catch (_) {
        /* the host is gone */ }
        this.call('assistantBoardBodyMounted', host);
        return false;
    };
    if (ui.tool === 'render_cards') {
        // The chat's own cards (the render_cards tool's `cards`, the shapes
        // ChatCard draws — people, tickets, thumbnails …), each a card state.
        const cards = (Array.isArray(args.cards) ? args.cards : []).filter((c)=>c && typeof c === 'object' && typeof c.type === 'string' && Array.isArray(c.items)).slice(0, 4).map((c, i)=>({
                key: 'card' + i,
                type: c.type,
                items: c.items.filter((it)=>it && typeof it === 'object').slice(0, 20)
            })).filter((c)=>c.items.length);
        if (!cards.length) return quiet('no cards');
        try {
            // The chat message's own card list (shared ChatMessage `Cards`): the
            // cards as state, one ChatCard each.
            host.set({
                tag: 'div',
                flow: 'y',
                gap: 'Z',
                minWidth: '0',
                state: {
                    cards: cards
                },
                childExtends: 'ChatCard',
                childrenAs: 'state',
                children: (el, st)=>st && st.cards || []
            });
        } catch (err) {
            return quiet(err && err.message);
        }
        host.__flyUiDrawn = true;
        this.call('assistantBoardBodyMounted', host);
        return true;
    }
    if (ui.tool === 'render_answer_ui') {
        // The chat's answer view: audited, parsed, registered — not opened (the
        // thread's inline path) — then mounted here as the thread mounts it.
        let res = null;
        try {
            res = this.call('renderAnswerUi', {
                title: typeof args.title === 'string' ? args.title : String(s.title || ''),
                source: typeof args.source === 'string' ? args.source : '',
                placement: args.placement === 'split' ? 'split' : 'inline',
                open: false
            });
        } catch (err) {
            res = {
                ok: false,
                error: err && err.message
            };
        }
        if (!res || res.ok !== true || typeof res.opened !== 'string') return quiet(res && (res.error || (res.violations || []).join(', ')));
        const shown = this.call('assistantBlockMountView', host, {
            type: 'view',
            route: res.opened,
            root: s.root
        });
        if (!shown) return quiet('the view is gone');
        host.__flyUiDrawn = true;
        this.call('assistantBoardBodyMounted', host);
        return true;
    }
    return quiet('unknown tool');
};

});

parcelRegister("lOgtZ", function(module, exports) {

$parcel$export(module.exports, "assistantFlyOnScreen", () => $fe0b0d97224b8fc9$export$62ed0a2dc6a97afa);
$parcel$export(module.exports, "assistantFlyAskContext", () => $fe0b0d97224b8fc9$export$e1376712bbe1586b);
$parcel$export(module.exports, "assistantFlyAskTarget", () => $fe0b0d97224b8fc9$export$822eaef733b3b831);
// assistantFlyContext.js — WHAT A SOLO FLY ASK IS ABOUT (Fly train 2;
// docs/FLY_MODE.md §3.6). The chat turn's own two keys, built the same way
// (functions/simoneAiTransport.js), ride a fly ask's `context`:
//   aiScope    the composer's chosen scope (functions/aiScope.js
//              aiScopePayload). While the Fly canvas holds the main area, its
//              `widgets` are the sections of the page ON SCREEN — each widget
//              or view with the params its view RESOLVED (`resolvedParams`
//              on the mounted body, the views contract in functions/
//              assistantAppViews.js). A site card that showed "Invest" when the
//              model named no site says `project: 'invest'`, so a follow-up
//              stays on the subject the card showed (the sites lane's finding,
//              2026-10-19: the next ask picked "Content and Marketing").
//   inspected  the regions the member pointed at (Inspect & ask, functions/
//              aiInspect.js — a composer pick's `inspect` facts), at most 3.
// The server reads both through the chat's own pickers (ai-boards askScope.js,
// AiBoardController pageContextOf): the ASK SCOPE and INSPECTED lines of the
// page prompt; the regions' figures reach the opening as ON SCREEN facts.
// A CALL's ask carries none (functions/assistantFly.js assistantFlyGenerate).
// The ask's TARGET (assistantFlyAskTarget below) stays on the page: its "Do
// it" hands it to the Tools turn as the structured `attached`.
//
// Frank note: el.call serializes each export on its own (FA204) — every
// export here is self-contained; a sibling is reached through this.call.
// The sections of the Fly page ON SCREEN as the ask scope's `widgets`: each
// widget or view of the open page, in its order, with its app and its params
// — the model's, then what its mounted view resolved over them. [] while the
// canvas is not shown (the scope keeps the home's own widgets then). A
// section whose params outgrow the server's bound (600 characters) goes
// without them; at most 12, the server's own cap.
const $fe0b0d97224b8fc9$export$62ed0a2dc6a97afa = function assistantFlyOnScreen(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r || !this.call('assistantFlyShown', r)) return [];
    const page = this.call('assistantFlyPage', r);
    if (!page || !Array.isArray(page.items) || !page.items.length) return [];
    const cells = (this.call('assistantFlyCells', page, r, 1) || []).filter((c)=>c && c.kind === 'widget' && c.id);
    if (!cells.length) return [];
    // The mounted cards are keyed by their cell (functions/assistantFly.js
    // assistantFlyCells): one walk of the element tree finds them all.
    const keys = new Set(cells.map((c)=>c.key));
    const top = typeof this.getRoot === 'function' ? this.getRoot() : null;
    let cards = [];
    try {
        cards = top && typeof top.lookdownAll === 'function' ? top.lookdownAll((c)=>!!c && keys.has(c.key)) || [] : [];
    } catch (_) {
        cards = [];
    }
    const plain = (v)=>{
        try {
            const p = v && typeof v.parse === 'function' ? v.parse() : v;
            return p && typeof p === 'object' && !Array.isArray(p) ? JSON.parse(JSON.stringify(p)) : null;
        } catch (_) {
            return null;
        }
    };
    const out = [];
    for (const cell of cells){
        const card = cards.find((c)=>c && c.key === cell.key) || null;
        const body = card && card.CardBody ? card.CardBody.content : null;
        let resolved = null;
        try {
            resolved = body ? plain(body.resolvedParams) : null;
        } catch (_) {
            resolved = null;
        }
        const params = {
            ...plain(cell.params) || {},
            ...resolved || {}
        };
        let json = '';
        try {
            json = JSON.stringify(params);
        } catch (_) {
            json = '';
        }
        out.push({
            id: String(cell.id),
            ...cell.moduleId ? {
                app: String(cell.moduleId)
            } : {},
            ...json && json !== '{}' && json.length <= 600 ? {
                params: params
            } : {}
        });
        if (out.length >= 12) break;
    }
    return out;
};
const $fe0b0d97224b8fc9$export$e1376712bbe1586b = function assistantFlyAskContext(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return {
        context: null,
        picked: []
    };
    const out = {};
    let scope = null;
    try {
        scope = this.call('aiScopePayload', r);
    } catch (_) {
        scope = null;
    }
    if (scope && typeof scope === 'object') {
        let shown = [];
        try {
            shown = this.call('assistantFlyOnScreen', r) || [];
        } catch (_) {
            shown = [];
        }
        // An app scope keeps that app's sections, as it keeps its home widgets
        // (functions/aiScope.js).
        const appId = scope.kind === 'app' && scope.app && scope.app.id ? String(scope.app.id) : null;
        const inScope = appId ? shown.filter((w)=>w && w.app === appId) : shown;
        out.aiScope = inScope.length ? {
            ...scope,
            widgets: inScope
        } : scope;
    }
    const picks = Array.isArray(r.pickedElements) ? r.pickedElements : [];
    const regions = picks.filter((p)=>p && p.inspect && typeof p.inspect === 'object').slice(0, 3);
    if (regions.length) out.inspected = regions.map((p)=>p.inspect);
    return {
        context: Object.keys(out).length ? out : null,
        picked: regions
    };
};
const $fe0b0d97224b8fc9$export$822eaef733b3b831 = function assistantFlyAskTarget(root, attached) {
    const cap = (v, n)=>typeof v === 'string' || typeof v === 'number' ? String(v).trim().slice(0, n) : '';
    const shape = (projectId, boardPageId, title)=>projectId ? {
            canvas: {
                projectId: projectId,
                ...boardPageId ? {
                    boardPageId: boardPageId
                } : {},
                ...boardPageId && title ? {
                    title: title
                } : {}
            }
        } : null;
    const own = attached && typeof attached === 'object' && attached.canvas ? attached.canvas : null;
    if (own && typeof own === 'object' && cap(own.projectId, 120)) return shape(cap(own.projectId, 120), cap(own.boardPageId, 120), cap(own.title, 200));
    const r = root && typeof root === 'object' ? root : null;
    const fns = this.context && this.context.functions || {};
    if (!r || typeof r.currentPath !== 'string' || !r.currentPath) return null;
    let key = '';
    try {
        const at = typeof fns.parseWorkspaceProjectPath === 'function' ? this.call('parseWorkspaceProjectPath', r.currentPath) : null;
        const bare = typeof fns.stripWorkspacePrefix === 'function' ? this.call('stripWorkspacePrefix', r.currentPath) : r.currentPath;
        const m = /^\/p\/([^/?#]+)/.exec(typeof bare === 'string' ? bare : '');
        key = at && at.key ? String(at.key) : m ? decodeURIComponent(m[1]) : '';
    } catch (_) {
        key = '';
    }
    const data = r.data && typeof r.data === 'object' && !r.projectNotFound ? r.data : null;
    const loaded = data ? String(data.key || data.projectKey || '') : '';
    if (!key || !loaded || loaded.toLowerCase() !== key.toLowerCase()) return null;
    const projectId = cap(data._id || data.id, 120);
    if (!projectId) return null;
    let v2 = null;
    try {
        v2 = typeof fns.getCanvasV2 === 'function' ? this.call('getCanvasV2') : null;
    } catch (_) {
        v2 = null;
    }
    const boardPageId = cap(v2 && v2.activePageId, 120);
    const board = boardPageId && v2 && Array.isArray(v2.pages) ? v2.pages.find((p)=>p && p.id === boardPageId) : null;
    return shape(projectId, boardPageId, cap(board && board.name, 200));
};

});

parcelRegister("ai0fh", function(module, exports) {

$parcel$export(module.exports, "recordsBlockOf", () => $77dbc68f07ab75ae$export$8c24f5e2eb464555);
$parcel$export(module.exports, "recordsContentSize", () => $77dbc68f07ab75ae$export$37b5315f51d2e8e2);
$parcel$export(module.exports, "recordsBlockNormalize", () => $77dbc68f07ab75ae$export$6293b12570d7ac7e);
$parcel$export(module.exports, "recordsHumanizeKey", () => $77dbc68f07ab75ae$export$95a2423133472253);
$parcel$export(module.exports, "recordsBlockTitle", () => $77dbc68f07ab75ae$export$78c552c81e7e25e9);
$parcel$export(module.exports, "recordsPeriodLabel", () => $77dbc68f07ab75ae$export$709cc1d063166871);
$parcel$export(module.exports, "assistantRecordsEntry", () => $77dbc68f07ab75ae$export$f2da7de5a8b92c8);
$parcel$export(module.exports, "assistantRecordsEnsure", () => $77dbc68f07ab75ae$export$e692e54903a07bd0);
$parcel$export(module.exports, "assistantRecordsAnswer", () => $77dbc68f07ab75ae$export$2c9ca3e670bc1b4b);
$parcel$export(module.exports, "assistantRecordsFetch", () => $77dbc68f07ab75ae$export$be18791b7852fb16);
$parcel$export(module.exports, "assistantRecordsFixture", () => $77dbc68f07ab75ae$export$4170304b781d98fe);
$parcel$export(module.exports, "assistantRecordsViewOf", () => $77dbc68f07ab75ae$export$a5bb6f9dcce9f445);
$parcel$export(module.exports, "assistantRecordsShows", () => $77dbc68f07ab75ae$export$9014280cf6c58945);
$parcel$export(module.exports, "assistantRecordsViewFor", () => $77dbc68f07ab75ae$export$77c4ba2762ccf70);
$parcel$export(module.exports, "assistantRecordsDate", () => $77dbc68f07ab75ae$export$21e3c298217775b8);
$parcel$export(module.exports, "assistantRecordsView", () => $77dbc68f07ab75ae$export$2af4c9eb0672472b);
$parcel$export(module.exports, "assistantRecordsDrillFrom", () => $77dbc68f07ab75ae$export$9471549d9751f94b);
$parcel$export(module.exports, "assistantRecordsBarRows", () => $77dbc68f07ab75ae$export$5b26467199cd8229);
$parcel$export(module.exports, "assistantRecordsDrillOf", () => $77dbc68f07ab75ae$export$42452115ae592002);
$parcel$export(module.exports, "assistantRecordsDrillWords", () => $77dbc68f07ab75ae$export$7a6b47cfa89b2db1);
$parcel$export(module.exports, "assistantRecordsDrill", () => $77dbc68f07ab75ae$export$a4e3ab968d15c90c);
$parcel$export(module.exports, "assistantRecordsRowOf", () => $77dbc68f07ab75ae$export$88422cfeb33565c5);
$parcel$export(module.exports, "assistantRecordsRowMount", () => $77dbc68f07ab75ae$export$88bd8f84e4f546f7);
$parcel$export(module.exports, "assistantRecordsHref", () => $77dbc68f07ab75ae$export$7dd6f2d351e8577d);
$parcel$export(module.exports, "assistantRecordsOpen", () => $77dbc68f07ab75ae$export$3e0169d1fd87e767);
$parcel$export(module.exports, "assistantRecordsWarning", () => $77dbc68f07ab75ae$export$af3ed86dab962d02);
$parcel$export(module.exports, "assistantRecordsSub", () => $77dbc68f07ab75ae$export$910c282d62694c9);
$parcel$export(module.exports, "assistantRecordsNote", () => $77dbc68f07ab75ae$export$2b01af0042091b35);
$parcel$export(module.exports, "assistantClientCapabilities", () => $77dbc68f07ab75ae$export$54056529d325f724);
// assistantRecords.js — THE RECORDS BLOCK v1, client half (AI_ASSISTANT_SPEC v1
// §2 + §3; DESIGN-WL-ASSISTANT-MAIN-VIEW-1, lane current-23-assistant; the
// server half is lane current-23-aib, src/domains/ai-boards recordsBlock.js).
//
// A records block is DECLARATIVE: the model names a collection and how to read
// it, never a number. ONE shape, shared by the Dashboard board items (kind
// 'records') and the thread's inline cards ({ type: 'records', block }):
//   { kind: 'records', app, collection, view: 'stat'|'list'|'table'|'chart',
//     title: { key?, text? }, filters: [{ field, op, value }],
//     period?: { field, preset }, aggregate?: { op, field? }, groupBy?,
//     sort?: { field, dir }, limit?: 1..50, fields?: [field] }
// The rows come from ONE SDK call, `sdk.execute('ai.boards', 'records',
// { workspaceId, block })`, which the server resolves under the member's
// grants → { rows: [{ id, title, values, refs? }], total, aggregate, groups,
// fields, period }. The client caches each answer per workspace + block
// (`root._aiRecords`, workspace-scoped) so the same block in the thread and on
// a board reads once, and a thread moved to the sidebar re-renders without a
// refetch. Until the SDK ships the op, the answer is 'unavailable' — the dev
// fixture answers ONLY behind localStorage `symbols_ai_records_fixture = '1'`
// (no fixture data in any product path).
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained — vocabularies are restated.
// The block a surface carries: a board row (`records`), a thread card
// (`{ type: 'records', block }`) or the block itself — normalized, or null.
const $77dbc68f07ab75ae$export$8c24f5e2eb464555 = function recordsBlockOf(s) {
    const x = s && typeof s === 'object' ? s : null;
    if (!x) return null;
    const raw = x.records && typeof x.records === 'object' ? x.records : x.type === 'records' ? x.block : x.kind === 'records' ? x : null;
    return this.call('recordsBlockNormalize', raw);
};
const $77dbc68f07ab75ae$export$37b5315f51d2e8e2 = function recordsContentSize(block) {
    const b = block && typeof block === 'object' ? block : {};
    const rowsWanted = Number(b.limit) || 10;
    const cols = Array.isArray(b.fields) ? b.fields.length : 0;
    if (b.view === 'stat') return 's';
    if (b.view === 'chart') return 'm';
    if (b.view === 'table' && cols > 3) return 'xl';
    return rowsWanted <= 6 ? 'm' : 'l';
};
const $77dbc68f07ab75ae$export$6293b12570d7ac7e = function recordsBlockNormalize(raw) {
    const VIEWS = [
        'stat',
        'list',
        'table',
        'chart'
    ];
    const OPS = [
        'eq',
        'ne',
        'in',
        'gte',
        'lte',
        'between',
        'contains'
    ];
    const PRESETS = [
        'today',
        'thisWeek',
        'thisMonth',
        'thisQuarter',
        'lastQuarter',
        'thisYear'
    ];
    const AGG = [
        'count',
        'sum',
        'avg',
        'min',
        'max'
    ];
    const b = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : null;
    if (!b || b.kind != null && b.kind !== 'records') return null;
    const str = (v, max)=>typeof v === 'string' && v.trim() ? v.trim().slice(0, max) : null;
    const app = str(b.app, 80);
    const collection = str(b.collection, 80);
    if (!app || !collection) return null;
    const filters = (Array.isArray(b.filters) ? b.filters : []).filter((f)=>f && typeof f === 'object' && str(f.field, 80) && OPS.includes(f.op)).slice(0, 8).map((f)=>({
            field: str(f.field, 80),
            op: f.op,
            value: f.value === undefined ? null : f.value
        }));
    const p = b.period && typeof b.period === 'object' ? b.period : null;
    // ONE clock per answer: an answer's own block carries the clock and the
    // absolute range the server computed its words on (server pinBlockPeriod:
    // asOf + timeZone | tzOffsetMinutes, with from / to). Kept whole, so the
    // records call re-reads THAT span — never "this quarter" again on the
    // browser's clock. Only form is checked here; the server validates.
    const iso = (v)=>typeof v === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(v) ? v.slice(0, 40) : null;
    const zone = p && typeof p.timeZone === 'string' && p.timeZone.trim() ? {
        timeZone: p.timeZone.trim().slice(0, 64)
    } : p && typeof p.tzOffsetMinutes === 'number' && Number.isFinite(p.tzOffsetMinutes) ? {
        tzOffsetMinutes: p.tzOffsetMinutes
    } : null;
    const pin = p && iso(p.asOf) && zone ? {
        asOf: iso(p.asOf),
        ...zone,
        ...iso(p.from) && iso(p.to) ? {
            from: iso(p.from),
            to: iso(p.to)
        } : {}
    } : null;
    const period = p && str(p.field, 80) && PRESETS.includes(p.preset) ? {
        field: str(p.field, 80),
        preset: p.preset,
        ...pin || {}
    } : null;
    const a = b.aggregate && typeof b.aggregate === 'object' ? b.aggregate : null;
    const aggField = a ? str(a.field, 80) : null;
    const aggregate = a && AGG.includes(a.op) && (a.op === 'count' || aggField) ? {
        op: a.op,
        ...aggField ? {
            field: aggField
        } : {}
    } : null;
    const groupBy = str(b.groupBy, 80);
    const so = b.sort && typeof b.sort === 'object' ? b.sort : null;
    const sort = so && str(so.field, 80) ? {
        field: str(so.field, 80),
        dir: so.dir === 'asc' ? 'asc' : 'desc'
    } : null;
    const lim = Math.floor(Number(b.limit));
    const limit = Number.isFinite(lim) && b.limit != null ? Math.min(50, Math.max(1, lim)) : null;
    const fields = (Array.isArray(b.fields) ? b.fields : []).map((f)=>str(f, 80)).filter(Boolean).slice(0, 8);
    const view = VIEWS.includes(b.view) ? b.view : groupBy ? 'chart' : aggregate ? 'stat' : 'list';
    // The DISPLAY hint of a chart (contract ask A, optional): bars | line |
    // donut | chips. Display-only — the view model still checks the data can
    // take it (chips: the categories as pills, each its label and its count).
    const chart = [
        'bars',
        'line',
        'donut',
        'chips'
    ].includes(b.chart) ? b.chart : null;
    const t = b.title;
    const title = t && typeof t === 'object' ? {
        ...str(t.key, 120) ? {
            key: str(t.key, 120)
        } : {},
        ...str(t.text, 120) ? {
            text: str(t.text, 120)
        } : {}
    } : str(t, 120) ? {
        text: str(t, 120)
    } : {};
    return {
        kind: 'records',
        app: app,
        collection: collection,
        view: view,
        title: title,
        filters: filters,
        ...period ? {
            period: period
        } : {},
        ...aggregate ? {
            aggregate: aggregate
        } : {},
        ...groupBy ? {
            groupBy: groupBy
        } : {},
        ...sort ? {
            sort: sort
        } : {},
        ...limit ? {
            limit: limit
        } : {},
        ...fields.length ? {
            fields: fields
        } : {},
        ...chart ? {
            chart: chart
        } : {}
    };
};
const $77dbc68f07ab75ae$export$95a2423133472253 = function recordsHumanizeKey(key) {
    const words = String(key || '').replace(/[_-]+/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').trim().toLowerCase();
    return words ? words.charAt(0).toUpperCase() + words.slice(1) : '';
};
const $77dbc68f07ab75ae$export$78c552c81e7e25e9 = function recordsBlockTitle(block) {
    const b = block && typeof block === 'object' ? block : {};
    const t = b.title && typeof b.title === 'object' ? b.title : {};
    if (t.key) {
        const said = this.call('polyglot', t.key);
        if (said && said !== t.key) return String(said);
    }
    if (t.text) return String(t.text);
    const app = String(b.app || '').split('/').pop().replace(/-app$/, '').toLowerCase();
    let key = String(b.collection || '');
    const lower = key.toLowerCase();
    for (const sep of [
        '.',
        '_',
        '-'
    ])if (app && lower.startsWith(app + sep) && key.length > app.length + 1) {
        key = key.slice(app.length + 1);
        break;
    }
    return this.call('recordsHumanizeKey', key);
};
const $77dbc68f07ab75ae$export$709cc1d063166871 = function recordsPeriodLabel(block) {
    const KEYS = {
        today: 'workspace.assistantRecords.periodToday',
        thisWeek: 'workspace.assistantRecords.periodThisWeek',
        thisMonth: 'workspace.assistantRecords.periodThisMonth',
        thisQuarter: 'workspace.assistantRecords.periodThisQuarter',
        lastQuarter: 'workspace.assistantRecords.periodLastQuarter',
        thisYear: 'workspace.assistantRecords.periodThisYear'
    };
    const p = block && block.period && typeof block.period === 'object' ? block.period : null;
    // A PINNED answer (the server's pin: asOf + a zone + from / to) names its
    // FIXED range — "1 Oct – 31 Dec 2026" in the pin's own time zone — never a
    // relative word: an old pinned answer must not claim "this quarter" over
    // another quarter's range. `to` is exclusive (the range end), so the last
    // day shown is the day before it.
    const ms = (v)=>typeof v === 'string' ? Date.parse(v) : NaN;
    const from = p && p.asOf ? ms(p.from) : NaN;
    const to = p && p.asOf ? ms(p.to) : NaN;
    const zoned = p && typeof p.timeZone === 'string' && p.timeZone ? {
        timeZone: p.timeZone
    } : p && typeof p.tzOffsetMinutes === 'number' && Number.isFinite(p.tzOffsetMinutes) ? {
        shift: p.tzOffsetMinutes
    } : null;
    if (zoned && Number.isFinite(from) && Number.isFinite(to) && to > from) {
        // a fixed offset: shift the instant and read it in UTC
        const at = (t)=>zoned.shift != null ? new Date(t + zoned.shift * 60000) : new Date(t);
        const tz = zoned.shift != null ? 'UTC' : zoned.timeZone;
        const year = (t)=>Number(this.call('localizedDate', at(t), {
                year: 'numeric',
                timeZone: tz
            }).replace(/\D/g, ''));
        const day = (t, withYear)=>String(this.call('localizedDate', at(t), {
                day: 'numeric',
                month: 'short',
                ...withYear ? {
                    year: 'numeric'
                } : {},
                timeZone: tz
            }));
        const last = to - 1;
        const a = day(from, false);
        const b = day(last, true);
        try {
            if (day(from, true) === b) return b;
            if (year(from) !== year(last)) return day(from, true) + " \u2013 " + b;
        } catch (_) {
            return a + " \u2013 " + b;
        }
        return a + " \u2013 " + b;
    }
    const preset = p && p.preset;
    return KEYS[preset] ? String(this.call('polyglot', KEYS[preset])) : '';
};
const $77dbc68f07ab75ae$export$f2da7de5a8b92c8 = function assistantRecordsEntry(root, block) {
    const r = root && typeof root === 'object' ? root : {};
    const bag = r._aiRecords && typeof r._aiRecords === 'object' ? r._aiRecords : {};
    const ws = r.workspace;
    const wsId = ws && (ws.id || ws._id) ? String(ws.id || ws._id) : '';
    if (!block) return null;
    const key = wsId + ':' + this.call('boardSpecHash', block);
    return bag[key] || null;
};
const $77dbc68f07ab75ae$export$e692e54903a07bd0 = function assistantRecordsEnsure(el, s, force) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    const block = host.call('recordsBlockOf', s);
    if (!root || typeof root.update !== 'function' || !block) return null;
    const ws = root.workspace;
    const wsId = ws && (ws.id || ws._id) ? String(ws.id || ws._id) : '';
    const key = wsId + ':' + host.call('boardSpecHash', block);
    const bag = root._aiRecords && typeof root._aiRecords === 'object' ? root._aiRecords : {};
    const have = bag[key];
    // The answer's words come back in the session language (RECORDS RESULT
    // v1.1 `lang`), so an answer read in another language is asked ONCE again
    // after a language switch — stamped with the language it was asked in, so a
    // server that answers in another language never loops.
    let lang = '';
    try {
        lang = String(host.call('getActiveLang') || '');
    } catch (_) {
        lang = '';
    }
    const otherLang = !!(have && have.lang && lang && have.lang !== lang && have.status !== 'loading');
    // `force` true = Try again (a failed read only); 'refresh' = the board's
    // Refresh (D3): any settled answer is asked again, never one in flight.
    const again = force === true && have && have.status === 'failed' || force === 'refresh' && have && have.status !== 'loading';
    if (have && !otherLang && !again) return have;
    const write = (entry)=>{
        const now = root._aiRecords && typeof root._aiRecords === 'object' ? root._aiRecords : {};
        const keys = Object.keys(now).filter((k)=>k !== key);
        const kept = {};
        for (const k of keys.slice(-39))kept[k] = now[k];
        kept[key] = entry;
        root.update({
            _aiRecords: kept
        }, {
            preventFetch: true
        });
    };
    write({
        status: 'loading',
        at: Date.now(),
        ...lang ? {
            lang: lang
        } : {}
    });
    const land = (entry)=>{
        const cur = root._aiRecords && root._aiRecords[key];
        const now = root.workspace;
        const nowId = now && (now.id || now._id) ? String(now.id || now._id) : '';
        if (nowId !== wsId || !cur || cur.status !== 'loading') return;
        write({
            ...entry,
            at: Date.now(),
            ...lang ? {
                lang: lang
            } : {}
        });
    };
    Promise.resolve().then(()=>host.call('assistantRecordsFetch', block, wsId || null, lang || null)).then((entry)=>land(entry && entry.status ? entry : {
            status: 'failed'
        }), ()=>land({
            status: 'failed'
        }));
    return root._aiRecords && root._aiRecords[key];
};
const $77dbc68f07ab75ae$export$2c9ca3e670bc1b4b = function assistantRecordsAnswer(res, block) {
    const r = res && typeof res === 'object' ? res : {};
    const rows = Array.isArray(r.rows) ? r.rows.slice(0, 50) : [];
    const groups = Array.isArray(r.groups) ? r.groups.slice(0, 24) : [];
    const total = Number(r.total) || 0;
    const aggregate = r.aggregate && typeof r.aggregate === 'object' ? r.aggregate : null;
    // RECORDS RESULT v1.1 — every field optional (an older server sends none):
    // the view the SERVER drew (a list or table grouped by a field comes back
    // as a chart: `adjusted` { path: 'view', reason: 'grouped' }), the unit of
    // the numbers (money + its currency, a count, a plain number), what the
    // groups are (groupField, and groupUnit for a time series), the language
    // of the words, and a stat's series for its sparkline.
    const VIEWS = [
        'stat',
        'list',
        'table',
        'chart'
    ];
    const UNITS = [
        'day',
        'week',
        'month'
    ];
    const adjusted = Array.isArray(r.adjusted) ? r.adjusted : [];
    const grouped = adjusted.some((a)=>a && a.path === 'view' && a.reason === 'grouped');
    const served = r.block && typeof r.block === 'object' && VIEWS.includes(r.block.view) ? r.block.view : grouped ? 'chart' : null;
    const u = r.unit && typeof r.unit === 'object' ? r.unit : null;
    const unit = u && [
        'count',
        'money',
        'number'
    ].includes(u.kind) ? u.kind === 'money' ? {
        kind: 'money',
        currency: typeof u.currency === 'string' && u.currency ? u.currency : null
    } : {
        kind: u.kind
    } : null;
    const gf = r.groupField && typeof r.groupField === 'object' ? r.groupField : null;
    const answer = {
        rows: rows,
        groups: groups,
        total: total,
        aggregate: aggregate,
        fields: Array.isArray(r.fields) ? r.fields : [],
        period: r.period || null,
        truncated: !!r.truncated,
        view: served,
        unit: unit,
        groupField: gf && typeof gf.key === 'string' ? {
            key: gf.key,
            label: typeof gf.label === 'string' ? gf.label : '',
            type: typeof gf.type === 'string' ? gf.type : null
        } : null,
        groupUnit: UNITS.includes(r.groupUnit) ? r.groupUnit : null,
        lang: typeof r.lang === 'string' && r.lang ? r.lang : null,
        series: Array.isArray(r.series) ? r.series.filter((p)=>p && typeof p === 'object').slice(0, 90) : null,
        seriesUnit: UNITS.includes(r.seriesUnit) ? r.seriesUnit : null,
        warnings: Array.isArray(r.warnings) ? r.warnings.filter((w)=>typeof w === 'string').slice(0, 8) : [],
        // WHY a block matches nothing (total 0 under its filters / period): the
        // rows each ONE condition would let through if it were left out, largest
        // first — `rows` 0 means the collection itself is empty.
        empty: r.empty && typeof r.empty === 'object' ? {
            rows: Number(r.empty.rows) || 0,
            without: (Array.isArray(r.empty.without) ? r.empty.without : []).filter((w)=>w && typeof w === 'object' && Number(w.count) > 0).slice(0, 4).map((w)=>({
                    path: typeof w.path === 'string' ? w.path : '',
                    field: typeof w.field === 'string' ? w.field : '',
                    count: Number(w.count)
                }))
        } : null,
        // A near-miss value the server read as the real one (`adjusted`
        // { path: 'filters[i].value', reason: 'snapped', from, to }).
        snapped: adjusted.filter((a)=>a && a.reason === 'snapped' && [
                'string',
                'number'
            ].includes(typeof a.from) && [
                'string',
                'number'
            ].includes(typeof a.to)).slice(0, 3).map((a)=>({
                from: String(a.from).slice(0, 60),
                to: String(a.to).slice(0, 60)
            }))
    };
    const view = served || block && block.view;
    const empty = view === 'stat' ? total === 0 : !rows.length && !groups.length;
    return {
        status: empty ? 'empty' : 'ready',
        answer: answer
    };
};
const $77dbc68f07ab75ae$export$be18791b7852fb16 = async function assistantRecordsFetch(block, workspaceId, lang) {
    let fixture = false;
    try {
        fixture = typeof localStorage !== 'undefined' && localStorage.getItem('symbols_ai_records_fixture') === '1';
    } catch (_) {
        fixture = false;
    }
    if (fixture) return this.call('assistantRecordsFixture', block);
    const sdk = this.sdk || this.context && this.context.sdk || (typeof this.call === 'function' ? this.call('getSDK') : null);
    if (!sdk || typeof sdk.execute !== 'function') return {
        status: 'unavailable'
    };
    try {
        // `lang` rides the call (the SDK after 7b767bc sends it; an older SDK
        // drops it and the server reads the member's own language).
        const res = await sdk.execute('ai.boards', 'records', {
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {},
            block: block,
            ...typeof lang === 'string' && lang ? {
                lang: lang
            } : {}
        });
        return this.call('assistantRecordsAnswer', res, block);
    } catch (err) {
        const msg = String(err && err.message || err || '');
        const status = Number(err && err.status);
        if (/unknown entity|does not support|unknown method|unknown op|not found on service|is not available/i.test(msg)) return {
            status: 'unavailable'
        };
        if (status === 403 || /forbidden|denied|not allowed/i.test(msg)) return {
            status: 'denied'
        };
        return {
            status: 'failed'
        };
    }
};
const $77dbc68f07ab75ae$export$4170304b781d98fe = function assistantRecordsFixture(block) {
    const b = block || {};
    const fields = (b.fields && b.fields.length ? b.fields : [
        'status',
        'date'
    ]).slice(0, 3);
    const rows = [];
    const n = Math.min(Number(b.limit) || 5, 8);
    for(let i = 0; i < n; i++){
        const values = {};
        fields.forEach((f, j)=>{
            values[f] = j === 0 ? [
                'open',
                'won',
                'lost'
            ][i % 3] : '2026-09-' + String(10 + i).padStart(2, '0');
        });
        rows.push({
            id: 'fx' + i,
            title: 'Fixture ' + (i + 1),
            values: values
        });
    }
    const groups = b.groupBy ? [
        'open',
        'won',
        'lost'
    ].map((k, i)=>({
            key: k,
            label: k,
            count: 8 - i * 3
        })) : [];
    const agg = b.aggregate || {
        op: 'count'
    };
    return {
        status: 'ready',
        answer: {
            rows: rows,
            groups: groups,
            total: 12,
            aggregate: {
                op: agg.op,
                ...agg.field ? {
                    field: agg.field
                } : {},
                value: agg.op === 'count' ? 12 : 4800
            },
            fields: fields.map((k)=>({
                    key: k,
                    type: k === 'date' ? 'date' : 'string'
                })),
            period: b.period || null,
            truncated: false,
            fixture: true
        }
    };
};
const $77dbc68f07ab75ae$export$a5bb6f9dcce9f445 = function assistantRecordsViewOf(block, entry) {
    const VIEWS = [
        'stat',
        'list',
        'table',
        'chart'
    ];
    const served = entry && entry.answer ? entry.answer.view : null;
    if (VIEWS.includes(served)) return served;
    const own = block && block.view;
    return VIEWS.includes(own) ? own : 'list';
};
const $77dbc68f07ab75ae$export$9014280cf6c58945 = function assistantRecordsShows(s, view) {
    const block = this.call('recordsBlockOf', s);
    const entry = this.call('assistantRecordsEntry', s && s.root, block);
    if (!block || !entry || entry.status !== 'ready') return false;
    return view ? this.call('assistantRecordsViewOf', block, entry) === view : true;
};
const $77dbc68f07ab75ae$export$77c4ba2762ccf70 = function assistantRecordsViewFor(s) {
    const block = this.call('recordsBlockOf', s);
    if (!block) return {};
    return this.call('assistantRecordsView', block, this.call('assistantRecordsEntry', s && s.root, block));
};
const $77dbc68f07ab75ae$export$21e3c298217775b8 = function assistantRecordsDate(value, unit) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}/.test(value)) return value == null ? '' : String(value);
    const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
    const d = new Date(dateOnly ? value + 'T00:00:00Z' : value);
    if (Number.isNaN(d.getTime())) return value.slice(0, 10);
    const utc = dateOnly ? {
        timeZone: 'UTC'
    } : {};
    const year = dateOnly ? d.getUTCFullYear() : d.getFullYear();
    const opts = unit === 'month' ? {
        month: 'short',
        year: 'numeric',
        ...utc
    } : {
        day: 'numeric',
        month: 'short',
        ...year !== new Date().getFullYear() ? {
            year: 'numeric'
        } : {},
        ...utc
    };
    const out = this.call('localizedDate', d, opts);
    return out ? String(out) : value.slice(0, 10);
};
const $77dbc68f07ab75ae$export$2af4c9eb0672472b = function assistantRecordsView(block, entry) {
    const b = block || {};
    const ans = entry && entry.answer ? entry.answer : {};
    const fieldMeta = Array.isArray(ans.fields) ? ans.fields : [];
    const metaOf = (key)=>fieldMeta.find((x)=>x && x.key === key) || null;
    const labelOf = (key)=>{
        const f = metaOf(key);
        if (f && typeof f.label === 'string' && f.label.trim()) return f.label;
        return this.call('recordsHumanizeKey', key);
    };
    // One value of a row, in words: the enum value's label, money with the row's
    // own currency, a compact number, a date, a mark for a yes/no.
    const valueText = (key, v, values)=>{
        if (v === null || v === undefined || v === '') return "\u2014";
        const f = metaOf(key);
        if (f && Array.isArray(f.values)) {
            const hit = f.values.find((x)=>x && String(x.key) === String(v));
            // A label that only repeats the code ("in_review" for in_review) is no
            // label: the rule below gives the words.
            if (hit && typeof hit.label === 'string' && hit.label && hit.label !== String(v)) return hit.label;
        }
        // A category value with no label of its own (`in_review`, `needs-response`)
        // reads as its words — never the code (QA on dev, VaultOS: "in_review"
        // where the app says "Awaiting review"). Only an enum or a status-like
        // field: free text and ids keep their spelling.
        if (typeof v === 'string' && /^[a-z0-9]+(?:[_-][a-z0-9]+)+$/.test(v) && (f && (Array.isArray(f.values) || f.type === 'enum') || /^(status|state|stage|kind|type|severity|priority|phase)$/i.test(String(key)))) {
            const words = v.replace(/[_-]+/g, ' ');
            return words.charAt(0).toUpperCase() + words.slice(1);
        }
        if (typeof v === 'number') {
            if (f && f.unit === 'money') {
                const cur = values && typeof values.currency === 'string' ? values.currency : '';
                return this.call('homeMoney', v, cur);
            }
            return this.call('homeCompactNumber', v);
        }
        // A yes/no in WORDS, both ways. It was `✓` / `—`: a `false` read as an
        // empty cell (QA on dev, VaultOS rules: "Enabled" showed "—" on all 11
        // rows). The field's own label for the value wins above (`values`).
        if (typeof v === 'boolean') return this.call('polyglot', v ? 'workspace.assistantRecords.yes' : 'workspace.assistantRecords.no');
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v) && (!f || f.type === 'date')) return this.call('assistantRecordsDate', v, 'day');
        return String(v).slice(0, 80);
    };
    // The unit of the answer's numbers (aggregate, groups): money with its
    // currency, else a count or a plain number. An older answer without `unit`
    // keeps its aggregate currency.
    const unit = ans.unit && typeof ans.unit === 'object' ? ans.unit : null;
    const agg = ans.aggregate && typeof ans.aggregate === 'object' ? ans.aggregate : {};
    const money = unit ? unit.kind === 'money' : !!agg.currency;
    const currency = money ? unit && unit.currency || agg.currency || '' : '';
    const numberText = (n)=>money ? this.call('homeMoney', n, currency) : this.call('homeCompactNumber', n);
    // THE HERO pair (the home widget's): the numeral and its unit word apart —
    // the money code leads ("GEL" · "64.6K"); a count or a number has no word.
    const code = String(currency || '').trim();
    const heroOf = (n, asMoney)=>({
            number: asMoney ? this.call('homeCompactNumber', n, 1000) : this.call('homeCompactNumber', n),
            unit: asMoney && code ? /^[a-z]{3}$/i.test(code) ? code.toUpperCase() : code : ''
        });
    const keys = fieldMeta.length ? fieldMeta.map((f)=>f.key) : Array.isArray(b.fields) ? b.fields : [];
    const rows = Array.isArray(ans.rows) ? ans.rows : [];
    const out = {
        view: this.call('assistantRecordsViewOf', b, entry),
        total: Number(ans.total) || 0,
        truncated: !!ans.truncated
    };
    // A list or table that holds fewer rows than match says so ("20 of 46
    // shown") — Fly QA on dev, Unreal deals: 20 rows of 46 with no marker.
    const moreOf = (n)=>out.total > n ? String(this.call('polyglot', 'workspace.assistantRecords.shown')).replace('{n}', this.call('homeCompactNumber', n)).replace('{total}', this.call('homeCompactNumber', out.total)) : '';
    if (out.view === 'stat') {
        const byCur = Array.isArray(agg.byCurrency) ? agg.byCurrency : [];
        out.value = agg.value == null ? byCur.length ? '' : "\u2014" : numberText(agg.value);
        out.currencies = byCur.map((c)=>({
                key: String(c.currency),
                text: this.call('homeMoney', c.value, c.currency)
            }));
        const v = typeof agg.value === 'number' && Number.isFinite(agg.value) ? agg.value : null;
        out.hero = v == null ? null : heroOf(v, money);
        // THE TREND: the same measure over the span before (aggregate.previous,
        // null when not comparable) — "↑ 12% vs previous period"; never a fake 0%.
        const prev = typeof agg.previous === 'number' && Number.isFinite(agg.previous) ? agg.previous : null;
        // In an OPEN period with rows dated ahead the server also sends the value
        // TO DATE (aggregate.toDate): the trend compares that with the span before
        // (cut at the same point), like with like; the hero keeps the whole value.
        const soFar = typeof agg.toDate === 'number' && Number.isFinite(agg.toDate) ? agg.toDate : v;
        out.delta = '';
        if (soFar != null && prev != null && prev !== 0) {
            const pct = (soFar - prev) / Math.abs(prev) * 100;
            const r = Math.abs(pct) >= 10 ? Math.round(pct) : Math.round(pct * 10) / 10;
            const arrow = r > 0 ? "\u2191" : r < 0 ? "\u2193" : "\u2192";
            out.delta = String(this.call('polyglot', 'workspace.assistantRecords.deltaVsPrevious')).replace('{delta}', arrow + ' ' + Math.abs(r) + '%');
        }
        // THE SPARK: the period bucketed by its date field (`series`) — two points
        // or more, else none.
        const pts = (Array.isArray(ans.series) ? ans.series : []).map((p)=>p && typeof p === 'object' ? Number(p.value) : NaN).filter((n)=>Number.isFinite(n));
        out.spark = pts.length >= 2 ? pts : null;
        return out;
    }
    if (out.view === 'chart') {
        const groups = (Array.isArray(ans.groups) ? ans.groups : []).filter((g)=>g && typeof g === 'object');
        const value = (g)=>typeof g.value === 'number' ? g.value : Number(g.count) || 0;
        const valueText = (g)=>typeof g.value === 'number' ? numberText(g.value) : this.call('homeCompactNumber', value(g));
        const gf = ans.groupField && typeof ans.groupField === 'object' ? ans.groupField : null;
        const unitOf = ans.groupUnit || (gf && gf.type === 'date' ? 'day' : '');
        if (unitOf) {
            // TIME: a line, oldest to newest (the server's order); the newest value
            // is the one the eye wants — it rides the accent dot's end of the line.
            const last = groups[groups.length - 1];
            out.chart = 'line';
            out.bars = [];
            out.line = groups.length ? {
                points: groups.map(value),
                first: this.call('assistantRecordsDate', String(groups[0].key), unitOf),
                last: this.call('assistantRecordsDate', String(last.key), unitOf),
                // the newest value: whole (the accessible name), and as the home
                // hero draws it — the numeral and its money code apart
                value: valueText(last),
                ...heroOf(value(last), money && typeof last.value === 'number')
            } : null;
            return out;
        }
        // CATEGORIES: bars, largest first; "Other" (the server's own fold) last.
        const other = groups.filter((g)=>g.key === '__other');
        let list = groups.filter((g)=>g.key !== '__other').sort((a, b)=>value(b) - value(a));
        const op = agg && agg.op || b.aggregate && b.aggregate.op || 'count';
        const MAX = 8;
        if (list.length + other.length > MAX) {
            if (op === 'count' || op === 'sum') {
                const rest = [
                    ...list.slice(MAX - 1),
                    ...other
                ];
                list = list.slice(0, MAX - 1);
                const folded = {
                    key: '__other',
                    label: String(this.call('polyglot', 'workspace.assistantRecords.other')),
                    count: rest.reduce((n, g)=>n + (Number(g.count) || 0), 0)
                };
                if (rest.some((g)=>typeof g.value === 'number')) folded.value = rest.reduce((n, g)=>n + (typeof g.value === 'number' ? g.value : 0), 0);
                list.push(folded);
            } else list = list.slice(0, MAX);
        } else list = [
            ...list,
            ...other
        ];
        // ONE row per category: the bar's, the donut legend's and the chip's
        // words, value and drill.
        const rowOf = (g, i)=>{
            const key = String(g.key == null ? i : g.key);
            return {
                key: key,
                label: typeof g.label === 'string' && g.label ? g.label : key,
                value: valueText(g),
                // D2 DRILL-DOWN: a category opens its records (assistantRecordsDrillOf);
                // the fold ("Other") and the empty group name no one value.
                drillable: !!b.groupBy && key !== '__other' && key !== ''
            };
        };
        // CHIPS (the display hint 'chips', board binding A′): the categories as
        // one wrapped row of pills, each its label and its count, in the bars'
        // order and fold, with no scale. Categories only: a time grouping keeps
        // its line (above).
        if (b.chart === 'chips') {
            out.chart = 'chips';
            out.bars = [];
            out.chips = list.map(rowOf);
            return out;
        }
        const max = list.reduce((m, g)=>Math.max(m, value(g)), 0) || 1;
        // D5 THE DONUT — drawn by the data's SHAPE: parts of a whole (a count or
        // a sum, none negative) in 2 to 5 groups with "Other" are a donut, the
        // rest bars. The display hint (`chart`, contract ask A) wins when the
        // data can take it: 'bars' always, 'donut' for parts of a whole in 2 to
        // 8 groups. The legend rows are the bar rows (drillable the same way);
        // each slice one opacity step of the card hue — never a raw colour.
        const sum = list.reduce((n, g)=>n + value(g), 0);
        const parts = (op === 'count' || op === 'sum') && sum > 0 && list.every((g)=>value(g) >= 0);
        const hint = b.chart;
        const donut = parts && list.length >= 2 && (hint === 'donut' ? list.length <= 8 : hint === 'bars' ? false : list.length <= 5);
        const STEPS = [
            1,
            0.72,
            0.5,
            0.34,
            0.22,
            0.14,
            0.1,
            0.07
        ];
        const round2 = (n)=>Math.round(n * 100) / 100;
        out.chart = donut ? 'donut' : 'bars';
        out.bars = list.map((g, i)=>{
            const { key: key, label: label, value: text, drillable: drillable } = rowOf(g, i);
            const row = {
                key: key,
                label: label,
                value: text,
                share: donut ? Math.max(0, Math.min(1, value(g) / sum)) : Math.max(0, Math.min(1, value(g) / max)),
                drillable: drillable
            };
            if (donut) {
                row.dot = STEPS[i] || STEPS[STEPS.length - 1];
                row.shareText = Math.round(row.share * 100) + '%';
            }
            return row;
        });
        // A 100-unit circumference: each slice's dash is its share, its offset
        // starts where the last one ended (25 = the top of the circle).
        let done = 0;
        out.donut = donut ? {
            total: numberText(sum),
            slices: out.bars.map((r)=>{
                const pct = round2(r.share * 100);
                const slice = {
                    key: r.key,
                    dash: pct + ' ' + round2(100 - pct),
                    offset: String(round2(25 - done)),
                    opacity: r.dot
                };
                done += pct;
                return slice;
            })
        } : null;
        return out;
    }
    if (out.view === 'table') {
        // Five columns, seven on a full-width card. When the answer names more,
        // references (which project, which building) yield to the row's own facts
        // (rooms, area, price); the columns keep the answer's order — Fly QA on
        // dev, Unreal "available apartments": price and area fell off behind
        // projectId and buildingId.
        const cap = b.size === 'xl' ? 7 : 5;
        const isRef = (k)=>{
            const f = metaOf(k);
            return !!(f && f.type === 'ref');
        };
        const keep = new Set(keys.length > cap ? [
            ...keys.filter((k)=>!isRef(k)),
            ...keys.filter(isRef)
        ].slice(0, cap) : keys);
        const cols = keys.filter((k)=>keep.has(k));
        out.columns = cols.map((k)=>({
                key: k,
                label: labelOf(k)
            }));
        out.rows = rows.map((r)=>{
            const vals = r.values && typeof r.values === 'object' ? r.values : {};
            const cells = [];
            for (const k of cols)cells.push({
                key: k,
                text: valueText(k, vals[k], vals)
            });
            return {
                key: String(r.id),
                title: r.title == null ? '' : String(r.title),
                cells: cells,
                app: b.app || null,
                collection: b.collection || null,
                row: {
                    id: String(r.id),
                    ...typeof r.href === 'string' ? {
                        href: r.href
                    } : {}
                }
            };
        });
        out.more = moreOf(out.rows.length);
        return out;
    }
    // The app's OWN row for this collection (manifest `collections[].row`),
    // when its module context is live — else the generic title + facts.
    const appRow = this.call('assistantRecordsRowOf', b);
    const fieldList = appRow ? fieldMeta.length ? fieldMeta.filter((f)=>f && typeof f.key === 'string').map((f)=>({
            key: f.key,
            type: f.type || null,
            ...f.label ? {
                label: String(f.label)
            } : {}
        })) : keys.map((k)=>({
            key: String(k),
            type: null
        })) : null;
    // D5 THE STATUS LIST (Pulse's incidents): a status-like enum field —
    // one whose values carry the server's `tone` (contract ask E), else one
    // named status / state / stage / severity / priority — gives each row a
    // semantic tone from the design system (successInk / warningInk /
    // dangerInk / accentInk; none for a word it does not know) and its words;
    // the status leaves the row's facts.
    const TONES = {
        success: 'successInk',
        warning: 'warningInk',
        danger: 'dangerInk',
        info: 'accentInk'
    };
    const WORDS = {
        successInk: [
            'done',
            'complete',
            'completed',
            'won',
            'closed_won',
            'resolved',
            'paid',
            'approved',
            'published',
            'delivered',
            'healthy',
            'ok',
            'success',
            'succeeded',
            'confirmed',
            'active',
            'live'
        ],
        dangerInk: [
            'lost',
            'closed_lost',
            'failed',
            'failure',
            'blocked',
            'overdue',
            'cancelled',
            'canceled',
            'rejected',
            'critical',
            'urgent',
            'error',
            'breached',
            'expired',
            'declined'
        ],
        warningInk: [
            'pending',
            'waiting',
            'review',
            'in_review',
            'on_hold',
            'hold',
            'draft',
            'high',
            'at_risk',
            'warning',
            'due',
            'stuck',
            'paused'
        ],
        accentInk: [
            'new',
            'open',
            'in_progress',
            'progress',
            'scheduled',
            'planned',
            'todo',
            'to_do'
        ]
    };
    const enumFields = fieldMeta.filter((f)=>f && f.type === 'enum' && typeof f.key === 'string');
    const toned = enumFields.find((f)=>Array.isArray(f.values) && f.values.some((v)=>v && TONES[v.tone]));
    const named = enumFields.find((f)=>/(^|_)(status|state|stage|severity|priority)$/i.test(f.key));
    const statusField = toned || named || null;
    const statusKey = statusField ? statusField.key : null;
    const toneOf = (v)=>{
        if (v == null || v === '') return null;
        const hit = Array.isArray(statusField.values) ? statusField.values.find((x)=>x && String(x.key) === String(v)) : null;
        if (hit && TONES[hit.tone]) return TONES[hit.tone];
        const word = String(v).trim().toLowerCase().replace(/[\s-]+/g, '_');
        for (const tone of Object.keys(WORDS))if (WORDS[tone].includes(word)) return tone;
        return null;
    };
    out.rows = rows.map((r)=>{
        const values = r.values && typeof r.values === 'object' ? r.values : {};
        const metaKeys = keys.filter((k)=>k !== statusKey && values[k] != null && values[k] !== '').slice(0, 2);
        const statusValue = statusKey ? values[statusKey] : null;
        const item = {
            tone: statusKey ? toneOf(statusValue) : null,
            status: statusKey && statusValue != null && statusValue !== '' ? valueText(statusKey, statusValue, values) : '',
            key: String(r.id),
            title: r.title == null || r.title === '' ? valueText(keys[0], values[keys[0]], values) : String(r.title),
            meta: metaKeys.map((k)=>valueText(k, values[k], values)).join(" \xb7 "),
            app: b.app || null,
            collection: b.collection || null,
            row: {
                id: String(r.id),
                ...typeof r.href === 'string' ? {
                    href: r.href
                } : {}
            }
        };
        if (!appRow) return item;
        // THE ROW CONTRACT (workspaceProjects.js _normalizeRecordRows): the
        // records-plane shape the app already reads — `name` is the answer's
        // title, `data` its values (only the fields the answer asked for).
        item.appRow = appRow;
        item.fields = fieldList;
        item.record = {
            id: String(r.id),
            collection: appRow.key,
            name: r.title == null ? '' : String(r.title),
            data: {
                ...values
            }
        };
        return item;
    });
    out.more = moreOf(out.rows.length);
    return out;
};
const $77dbc68f07ab75ae$export$9471549d9751f94b = function assistantRecordsDrillFrom(s) {
    if (!s || s.kind !== 'records' || typeof s.key !== 'string' || !s.key) return null;
    if (typeof s.page === 'string' && s.page) return s.drillsInto === s.page ? {
        from: s.key,
        page: s.page
    } : null;
    const root = s.root || this && this.state && this.state.root || null;
    const b = root && root._aiBoard;
    if (!b || typeof b !== 'object' || b.preview || b.status !== 'ready') return null;
    const items = Array.isArray(b.items) ? b.items : [];
    return items.some((it)=>it && it.key === s.key) ? {
        from: s.key
    } : null;
};
const $77dbc68f07ab75ae$export$5b26467199cd8229 = function assistantRecordsBarRows(s) {
    const list = this.call('assistantRecordsViewFor', s).bars || [];
    const drill = list.length ? this.call('assistantRecordsDrillFrom', s) : null;
    return drill ? list.map((b)=>({
            ...b,
            ...drill
        })) : list;
};
const $77dbc68f07ab75ae$export$42452115ae592002 = function assistantRecordsDrillOf(block, entry, bar) {
    const b = this.call('recordsBlockNormalize', block);
    const ans = entry && entry.answer && typeof entry.answer === 'object' ? entry.answer : null;
    const key = bar && bar.key != null ? String(bar.key) : '';
    if (!b || !b.groupBy || !ans || !key || key === '__other') return null;
    const gf = ans.groupField && typeof ans.groupField === 'object' ? ans.groupField : null;
    if (ans.groupUnit || gf && gf.type === 'date') return null;
    const fieldLabel = gf && gf.key === b.groupBy && typeof gf.label === 'string' && gf.label.trim() ? gf.label.trim() : this.call('recordsHumanizeKey', b.groupBy);
    const valueLabel = bar && typeof bar.label === 'string' && bar.label.trim() ? bar.label.trim() : key;
    const source = this.call('recordsBlockTitle', b);
    const filters = b.filters.filter((f)=>f.field !== b.groupBy).concat([
        {
            field: b.groupBy,
            op: 'eq',
            value: key
        }
    ]).slice(-8);
    return {
        block: {
            kind: 'records',
            app: b.app,
            collection: b.collection,
            view: 'list',
            title: {
                text: (source + " \xb7 " + valueLabel).slice(0, 120)
            },
            filters: filters,
            ...b.period ? {
                period: b.period
            } : {},
            ...b.sort ? {
                sort: b.sort
            } : {},
            limit: 10,
            ...b.fields ? {
                fields: b.fields
            } : {}
        },
        drill: {
            field: b.groupBy,
            fieldLabel: fieldLabel,
            value: key,
            valueLabel: valueLabel,
            source: source
        }
    };
};
const $77dbc68f07ab75ae$export$7a6b47cfa89b2db1 = function assistantRecordsDrillWords(s) {
    const d = s && typeof s === 'object' && s.drill && typeof s.drill === 'object' ? s.drill : null;
    if (!d || !d.fieldLabel || !d.valueLabel) return '';
    return String(this.call('polyglot', 'workspace.assistantRecords.drillFilter')).replace('{field}', d.fieldLabel).replace('{value}', d.valueLabel).replace('{source}', d.source || '');
};
const $77dbc68f07ab75ae$export$a4e3ab968d15c90c = function assistantRecordsDrill(bar) {
    if (!bar || !bar.drillable || !bar.from) return false;
    const target = {
        key: bar.key,
        label: bar.label
    };
    if (typeof bar.page === 'string' && bar.page) return this.call('assistantFlyDrill', bar.page, bar.from, target);
    return this.call('assistantBoardDrill', bar.from, target);
};
const $77dbc68f07ab75ae$export$88422cfeb33565c5 = function assistantRecordsRowOf(block) {
    const b = block && typeof block === 'object' ? block : null;
    const col = b && typeof b.collection === 'string' ? b.collection.trim().toLowerCase() : '';
    const root = this && this.state && this.state.root;
    if (!col || !root || typeof root !== 'object') return null;
    const getCtx = typeof root._moduleDsCtxGet === 'function' ? root._moduleDsCtxGet : null;
    if (!getCtx) return null;
    const dot = col.indexOf('.');
    const names = dot > 0 ? [
        col,
        col.slice(dot + 1)
    ] : [
        col
    ];
    let hit = null;
    for (const name of names){
        hit = this.call('moduleRecordRow', root, name);
        if (hit) break;
    }
    if (!hit) return null;
    const broken = root._aiRecordRowsBroken && typeof root._aiRecordRowsBroken === 'object' ? root._aiRecordRowsBroken : {};
    if (broken[hit.moduleId + '/' + hit.row]) return null;
    if (!getCtx(hit.moduleId)) return null;
    return {
        key: hit.key,
        row: hit.row,
        moduleId: hit.moduleId
    };
};
const $77dbc68f07ab75ae$export$88bd8f84e4f546f7 = function assistantRecordsRowMount(el, s) {
    const host = el || this;
    const a = s && s.appRow;
    if (!host || typeof host.set !== 'function' || !a || !a.row) return false;
    const root = s && s.root || host.state && host.state.root || null;
    const modCtx = root && typeof root._moduleDsCtxGet === 'function' ? root._moduleDsCtxGet(a.moduleId) : null;
    if (!modCtx) return false;
    const record = s.record && typeof s.record === 'object' ? s.record : null;
    const fields = Array.isArray(s.fields) ? s.fields : [];
    const sig = 'row/' + (a.moduleId || '') + '/' + a.row + '/' + this.call('boardSpecHash', {
        record: record,
        fields: fields
    });
    if (host.__recordsRowSig === sig) return true;
    host.__recordsRowSig = sig;
    const def = {
        extends: a.row,
        context: modCtx
    };
    def.scope = Object.assign({}, modCtx.globalScope || null, {
        record: record,
        fields: fields
    });
    try {
        host.set(def);
        return true;
    } catch (err) {
        console.warn('[assistantRecords] app row mount failed, the generic row shows:', a.row, err && err.message);
        const bag = root._aiRecordRowsBroken && typeof root._aiRecordRowsBroken === 'object' ? root._aiRecordRowsBroken : {};
        if (typeof root.update === 'function') root.update({
            _aiRecordRowsBroken: {
                ...bag,
                [a.moduleId + '/' + a.row]: true
            }
        }, {
            preventFetch: true
        });
        return false;
    }
};
const $77dbc68f07ab75ae$export$7dd6f2d351e8577d = function assistantRecordsHref(block, row) {
    if (row && typeof row.href === 'string' && row.href.startsWith('/')) return row.href;
    const root = this.state && this.state.root;
    const b = block && typeof block === 'object' ? block : {};
    const col = typeof b.collection === 'string' ? b.collection.trim().toLowerCase() : '';
    if (col && root) {
        const dot = col.indexOf('.');
        const names = dot > 0 ? [
            col,
            col.slice(dot + 1)
        ] : [
            col
        ];
        for (const name of names){
            const where = this.call('moduleRecordRoute', root, name);
            if (!where || typeof where.route !== 'string' || !where.route.startsWith('/')) continue;
            return row && row.id != null && row.id !== '' && where.param ? where.route + '?' + where.param + '=' + encodeURIComponent(String(row.id)) : where.route;
        }
    }
    const want = b.app ? String(b.app) : '';
    // The workspace's own project (the takeover module) first, then the
    // installed apps — the record-route registry's order.
    const apps = [
        ...root && root.workspaceProject && typeof root.workspaceProject === 'object' ? [
            root.workspaceProject
        ] : [],
        ...root && Array.isArray(root.workspaceApps) ? root.workspaceApps : []
    ];
    const app = apps.find((a)=>{
        const id = a && a.id ? String(a.id) : '';
        const key = id.split('/').pop();
        return id === want || key === want || key.replace(/-app$/, '') === want;
    });
    if (!app) return null;
    const pathOf = (n)=>n && typeof n === 'object' ? [
            n.route,
            n.path
        ].find((p)=>typeof p === 'string' && p.startsWith('/')) || '' : '';
    const hit = [
        ...Array.isArray(app.navbar) ? app.navbar : [],
        ...Array.isArray(app.apps) ? app.apps : []
    ].map(pathOf).find(Boolean);
    if (hit) return hit;
    const pages = Array.isArray(app.pages) ? app.pages : [];
    const first = pages.find((p)=>typeof p === 'string' && p.startsWith('/'));
    return first || null;
};
const $77dbc68f07ab75ae$export$3e0169d1fd87e767 = function assistantRecordsOpen(block, row) {
    const href = this.call('assistantRecordsHref', block, row);
    if (!href) return false;
    this.call('openInSlot', href, this);
    return true;
};
const $77dbc68f07ab75ae$export$af3ed86dab962d02 = function assistantRecordsWarning(s) {
    const KEYS = {
        sorted_per_currency: 'workspace.assistantRecords.sortedPerCurrency'
    };
    const block = this.call('recordsBlockOf', s);
    const entry = this.call('assistantRecordsEntry', s && s.root, block);
    if (!entry || !entry.answer || entry.status !== 'ready' && entry.status !== 'empty') return '';
    const out = [];
    // a near-miss value the server read as the real one ("tower a" → "Tower A")
    for (const x of Array.isArray(entry.answer.snapped) ? entry.answer.snapped : [])out.push(String(this.call('polyglot', 'workspace.assistantRecords.snapped')).replace('{from}', x.from).replace('{to}', x.to));
    const list = Array.isArray(entry.answer.warnings) ? entry.answer.warnings : [];
    const hit = entry.status === 'ready' ? list.find((w)=>KEYS[w]) : null;
    if (hit) out.push(String(this.call('polyglot', KEYS[hit])));
    return out.join(" \xb7 ");
};
const $77dbc68f07ab75ae$export$910c282d62694c9 = function assistantRecordsSub(s) {
    const block = this.call('recordsBlockOf', s);
    const entry = this.call('assistantRecordsEntry', s && s.root, block);
    const total = entry && entry.answer ? Number(entry.answer.total) || 0 : 0;
    const period = this.call('recordsPeriodLabel', block);
    const count = String(this.call('polyglot', total === 1 ? 'workspace.assistantRecords.totalOne' : 'workspace.assistantRecords.total')).replace('{count}', this.call('homeCompactNumber', total));
    return period ? period + " \xb7 " + count : count;
};
const $77dbc68f07ab75ae$export$2b01af0042091b35 = function assistantRecordsNote(s) {
    const block = this.call('recordsBlockOf', s);
    const entry = this.call('assistantRecordsEntry', s && s.root, block);
    const status = entry && entry.status;
    if (status === 'empty') {
        const title = this.call('recordsBlockTitle', block);
        const period = this.call('recordsPeriodLabel', block);
        const said = String(this.call('polyglot', 'workspace.assistantRecords.empty')).replace('{title}', title);
        const base = period ? said + " \xb7 " + period : said;
        // WHY (RECORDS RESULT v1.1 `empty`): the ONE condition that, left out,
        // lets the most records through — the period, or a filter by its field's
        // name. A collection with no rows at all has no reason to add.
        const why = entry.answer && entry.answer.empty ? entry.answer.empty : null;
        const top = why && why.rows > 0 && why.without.length ? why.without[0] : null;
        if (!top) return base;
        const byPeriod = top.path === 'period';
        const meta = byPeriod ? null : (Array.isArray(entry.answer.fields) ? entry.answer.fields : []).find((f)=>f && f.key === top.field);
        const field = byPeriod ? '' : meta && typeof meta.label === 'string' && meta.label.trim() ? meta.label : this.call('recordsHumanizeKey', top.field);
        const reason = String(this.call('polyglot', byPeriod ? 'workspace.assistantRecords.emptyOutsidePeriod' : 'workspace.assistantRecords.emptyWithoutFilter')).replace('{count}', this.call('homeCompactNumber', top.count)).replace('{field}', field);
        return base + " \xb7 " + reason;
    }
    if (status === 'unavailable') return String(this.call('polyglot', 'workspace.assistantRecords.unavailable'));
    if (status === 'denied') return String(this.call('polyglot', 'workspace.assistantRecords.denied'));
    if (status === 'failed') return String(this.call('polyglot', 'workspace.assistantRecords.failed'));
    return '';
};
const $77dbc68f07ab75ae$export$54056529d325f724 = function assistantClientCapabilities(sdk) {
    try {
        const ctx = this && this.context || {};
        const fns = ctx.functions || {};
        const opener = fns.selectPageItem;
        const openRecord = typeof opener === 'function' && opener.opensRecords === 1;
        const components = ctx.components || {};
        // APP VIEWS and APP FORMS (functions/assistantAppViews.js,
        // functions/assistantAppForms.js): known at once — the thread's block
        // component draws them and their functions are registered. The server
        // offers embed_view / propose_form only to a shell that declares them.
        const block = !!components.AssistantThreadBlock;
        const views = block && typeof fns.assistantAppViewSources === 'function';
        const forms = block && typeof fns.assistantFormOpen === 'function';
        // THE QUICK TOUR: known at once — the assistant's entry and the tour
        // itself are registered. The server offers start_tour only then.
        const tour = typeof fns.aiStartTour === 'function' && typeof fns.onboardingTourStart === 'function';
        const answer = (records)=>{
            const out = {};
            if (records) out.records = 1;
            if (openRecord) out.openRecord = 1;
            if (views) out.views = 1;
            if (forms) out.forms = 1;
            if (tour) out.tour = 1;
            return Object.keys(out).length ? out : null;
        };
        if (!components.AssistantRecordsBlock) return answer(0);
        const root = this && this.state && this.state.root;
        const kept = root && root._aiClientCaps;
        if (kept && typeof kept === 'object') return answer(Number(kept.records) >= 1 ? 1 : 0);
        const keep = (records)=>{
            const now = root && root._aiClientCaps;
            if (root && typeof root.update === 'function' && !(now && Number(now.records) === records)) root.update({
                _aiClientCaps: {
                    records: records
                }
            }, {
                preventFetch: true
            });
            return answer(records);
        };
        const client = sdk || this && this.sdk || ctx.sdk || (this && typeof this.call === 'function' ? this.call('getSDK') : null);
        if (!client || client.isNullClient === true || typeof client.getService !== 'function') return answer(0);
        const has = (boards)=>boards && typeof boards.records === 'function' ? 1 : 0;
        let boards = null;
        try {
            boards = client.getService('aiBoards');
        } catch (_) {
            return keep(0);
        }
        if (boards && typeof boards.then === 'function') return Promise.resolve(boards).then((svc)=>keep(has(svc)), ()=>keep(0));
        return keep(has(boards));
    } catch (_) {
        return null;
    }
};

});

parcelRegister("4nRwn", function(module, exports) {

$parcel$export(module.exports, "assistantBlockTitle", () => $3312d3a062571ec8$export$5b69bb1b7343715e);
$parcel$export(module.exports, "assistantBlockApp", () => $3312d3a062571ec8$export$afd85284ef4ad420);
$parcel$export(module.exports, "assistantBlockIcon", () => $3312d3a062571ec8$export$55f186e534dbffeb);
$parcel$export(module.exports, "assistantBlockSource", () => $3312d3a062571ec8$export$1651c600b0825f17);
$parcel$export(module.exports, "assistantBlockCan", () => $3312d3a062571ec8$export$a9e3043c3ec36bfa);
$parcel$export(module.exports, "assistantBlockOpen", () => $3312d3a062571ec8$export$f85dde2e245b65f4);
$parcel$export(module.exports, "assistantBlockSaveApp", () => $3312d3a062571ec8$export$2c974b2963a86222);
$parcel$export(module.exports, "assistantBlockSaveAppState", () => $3312d3a062571ec8$export$6986b35d56a6934d);
$parcel$export(module.exports, "assistantBlockSaveState", () => $3312d3a062571ec8$export$c4c4f7e5c4596328);
$parcel$export(module.exports, "assistantBlockSaveBoard", () => $3312d3a062571ec8$export$231eda8f2b506aad);
$parcel$export(module.exports, "assistantBlockSaveLabel", () => $3312d3a062571ec8$export$b361506cedab179f);
$parcel$export(module.exports, "assistantBlockRefine", () => $3312d3a062571ec8$export$38573187989e388c);
$parcel$export(module.exports, "assistantBlockMountView", () => $3312d3a062571ec8$export$25e982f3eee5ffb3);
$parcel$export(module.exports, "assistantBlockViewGone", () => $3312d3a062571ec8$export$34710046e05405a1);
$parcel$export(module.exports, "assistantEmbedWidgetRow", () => $3312d3a062571ec8$export$487b7d02718dfe4b);
$parcel$export(module.exports, "assistantEmbedWidgetStatus", () => $3312d3a062571ec8$export$754c8243922e0b0f);
$parcel$export(module.exports, "assistantEmbedWidgetNote", () => $3312d3a062571ec8$export$d38c563ebba7ddec);
$parcel$export(module.exports, "assistantEmbedWidgetMount", () => $3312d3a062571ec8$export$a084e982fe3d09c4);
// assistantThreadBlocks.js — INLINE GENERATIVE BLOCKS in the assistant's thread
// (AI_ASSISTANT_SPEC v1 §3 "inline in the thread (main + sidebar), not only in
// the split pane"; DESIGN-WL-ASSISTANT-MAIN-VIEW-1, lane current-23-assistant).
//
// A block is a card the assistant attaches to its message (ChatCard renders it
// through components/AssistantThreadBlock.js):
//   { type: 'view', route, title }        an answer view (render_answer_ui) —
//                                         the audited DOMQL def the PageSlot
//                                         mounts, drawn INLINE in the thread
//   { type: 'records', block, title? }    a RECORDS BLOCK v1 (functions/
//                                         assistantRecords.js)
//   { type: 'board', boardId, title, summary, count }   a generated board
//   { type: 'widget', widget, params, size?, title? }    an installed app's
//                                         widget with its params (embed_widget,
//                                         functions/_simone/toolEmbed.js) —
//                                         the app's own body mounted inline
// Actions, each only where it means something: Open in split (the view's
// route, the records' app), Save as app (a view → an extension), Save as
// board (a records block → an `ai_boards` record), Refine (the composer asks
// again about this block). Pin to home waits for core's widget recipes to
// accept a records source (widgetDefSchema allows workspaceProject.records /
// people lists only; a pinned block would lose its filters).
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained — the few literals are restated.
// The block's title line. A title marked `titleDefault` (the readable default
// functions/_simone/toolEmbed.js gives every embed card, so every host shows
// one) yields to the block's own: a records block's (bundle-keyed) title, an
// installed widget's title; it shows where those are missing.
const $3312d3a062571ec8$export$5b69bb1b7343715e = function assistantBlockTitle(s) {
    const x = s && typeof s === 'object' ? s : {};
    const own = x.title && !x.titleDefault ? String(x.title) : '';
    if (x.type === 'records' && !own) return this.call('recordsBlockTitle', this.call('recordsBlockOf', x));
    if (x.type === 'widget' && !own) {
        const row = this.call('assistantEmbedWidgetRow', x);
        if (row && row.title) return String(this.call('polyglot', row.title));
    }
    if (x.type === 'sources' && !own) return this.call('assistantSourcesTitle', x);
    if (x.type === 'form' && !own) {
        const entry = this.call('assistantFormEntry', x);
        if (entry && entry.form && entry.form.title) return String(this.call('polyglot', entry.form.title));
    }
    return x.title ? String(x.title) : '';
};
const $3312d3a062571ec8$export$afd85284ef4ad420 = function assistantBlockApp(s) {
    const x = s && typeof s === 'object' ? s : {};
    let ref = '';
    if (x.type === 'records') {
        const block = this.call('recordsBlockOf', x);
        ref = block && block.app ? String(block.app) : '';
    } else if (x.type === 'widget') {
        const row = this.call('assistantEmbedWidgetRow', x);
        ref = row && row.moduleId ? String(row.moduleId) : String(x.widget || '').split('.')[0];
    } else if (x.type === 'form') {
        const entry = this.call('assistantFormEntry', x);
        ref = entry && entry.appId ? String(entry.appId) : String(x.form || '').split('.')[0];
    }
    if (!ref) return null;
    const root = this.state && this.state.root;
    const apps = root && Array.isArray(root.workspaceApps) ? root.workspaceApps : [];
    const names = (a)=>{
        const id = a && a.id ? String(a.id) : '';
        const key = id.split('/').pop();
        return id === ref || key === ref || key.replace(/-app$/, '') === ref;
    };
    const installed = apps.find(names);
    if (installed) return installed;
    // A built-in package's view or form (calendar, tickets): its provider's app.
    if (x.type !== 'widget' && x.type !== 'form') return null;
    const sources = this.call(x.type === 'form' ? 'assistantAppFormSources' : 'assistantAppViewSources', root);
    const src = (Array.isArray(sources) ? sources : []).find((v)=>v && names(v.app));
    return src && src.app || null;
};
const $3312d3a062571ec8$export$55f186e534dbffeb = function assistantBlockIcon(s) {
    // "What can you do here?" (the capabilities catalogue) answers under the
    // glyph of the row that asked it — never a tile with no glyph (the nameless
    // Icon warned on dev 2026-10-04; DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1)
    if (s && s.type === 'capabilities') return this.call('glyphNameFor', {
        glyph: 'help'
    }, 'ln') || '';
    const app = this.call('assistantBlockApp', s);
    if (!app) return '';
    const tiles = [
        ...Array.isArray(app.apps) ? app.apps : [],
        ...Array.isArray(app.navbar) ? app.navbar : []
    ];
    const hit = tiles.find((t)=>t && typeof t.icon === 'string' && t.icon);
    return hit ? hit.icon : '';
};
const $3312d3a062571ec8$export$1651c600b0825f17 = function assistantBlockSource(s) {
    const x = s && typeof s === 'object' ? s : {};
    if (x.type === 'view') return String(this.call('polyglot', 'workspace.assistantBlock.sourceView'));
    if (x.type === 'board') return String(this.call('polyglot', 'workspace.assistantBlock.sourceBoard')).replace('{count}', String(Number(x.count) || 0));
    if (x.type === 'sources') return this.call('assistantSourcesFoot', x);
    if (x.type !== 'widget' && x.type !== 'records' && x.type !== 'form') return '';
    const app = this.call('assistantBlockApp', x);
    // The app by its App Store name, in the session language (installedAppName
    // — Nika 2026-10-23: "app names = what a person sees in the workspace App
    // Store"): the foot read "From Analytics · widget" for Insights, the
    // manifest's first tab. An app the store ships no name for reads its own
    // first tab through polyglot, as before.
    const nav = app && Array.isArray(app.navbar) ? app.navbar : [];
    const tab = nav.find((n)=>n && typeof n.label === 'string' && n.label);
    const named = app && String(this.call('installedAppName', app) || '') || (tab ? String(this.call('polyglot', tab.label)) : '');
    if (x.type === 'widget' || x.type === 'form') {
        const row = x.type === 'widget' ? this.call('assistantEmbedWidgetRow', x) : null;
        const ref = row && row.moduleId ? row.moduleId : String((x.type === 'form' ? x.form : x.widget) || '').split('.')[0];
        const appName = named || String(ref).split('/').pop().replace(/-app$/, '');
        // A VIEW is the app's own UI, not a widget: "From Calendar"; a form says so.
        const key = x.type === 'form' ? 'workspace.assistantBlock.sourceForm' : row && row.view ? 'workspace.assistantBlock.sourceAppView' : 'workspace.assistantBlock.sourceWidget';
        return String(this.call('polyglot', key)).replace('{app}', appName);
    }
    const block = this.call('recordsBlockOf', x);
    if (!block) return '';
    const appName = named || block.app;
    return String(this.call('polyglot', 'workspace.assistantBlock.sourceRecords')).replace('{app}', appName).replace('{collection}', this.call('recordsBlockTitle', {
        app: block.app,
        collection: block.collection
    }));
};
const $3312d3a062571ec8$export$a9e3043c3ec36bfa = function assistantBlockCan(s, action) {
    const x = s && typeof s === 'object' ? s : {};
    const root = this.state && this.state.root;
    if (action === 'refine') return x.type === 'view' || x.type === 'records' || x.type === 'board' || x.type === 'widget' || x.type === 'form' || x.type === 'sources';
    if (x.type === 'widget') {
        if (action !== 'open') return false;
        const row = this.call('assistantEmbedWidgetRow', x);
        return !!(row && row.openRoute);
    }
    if (x.type === 'view') {
        const def = root && root._aiAnswerPages ? root._aiAnswerPages[x.route] : null;
        if (action === 'open') return !!def;
        // Save as app: an answer view becomes an extension (its source), and a
        // BUILT app (Apps mode, create_extension / create_app — the preview's
        // `__extensionApp`) is installed into the workspace.
        const meta = def && def.metadata;
        const built = meta && meta.__extensionApp && meta.__extensionApp.projectId;
        if (action === 'saveApp') return !!(meta && (meta.__source || built));
        return false;
    }
    if (x.type === 'records') {
        const block = this.call('recordsBlockOf', x);
        if (!block) return false;
        if (action === 'open') return !!this.call('assistantRecordsHref', block, null);
        if (action === 'saveBoard') return true;
        return false;
    }
    if (x.type === 'board') {
        if (action !== 'open' || !x.boardId) return false;
        // Only a board this session still holds can be shown again (the thread
        // chips' history, workspace-scoped and in memory).
        const list = root && Array.isArray(root._aiBoardHistory) ? root._aiBoardHistory : [];
        return list.some((h)=>h && h.id === x.boardId && h.raw);
    }
    return false;
};
const $3312d3a062571ec8$export$f85dde2e245b65f4 = function assistantBlockOpen(s) {
    const x = s && typeof s === 'object' ? s : {};
    if (x.type === 'view' && x.route) {
        this.call('openInSlot', x.route, this);
        return true;
    }
    if (x.type === 'records') return this.call('assistantRecordsOpen', this.call('recordsBlockOf', x), null);
    if (x.type === 'widget') {
        const row = this.call('assistantEmbedWidgetRow', x);
        if (!row || !row.openRoute) return false;
        // A view's own page with the filters the view resolved, when its mounted
        // body declares it (functions/assistantAppViews.js `openRoute`).
        const host = typeof this.lookup === 'function' ? this.lookup('BlockWidget') : null;
        const own = this.call('assistantAppViewOwnRoute', host);
        this.call('openInSlot', own || row.openRoute, this);
        return true;
    }
    if (x.type === 'board' && x.boardId) {
        // The board shows OVER WHATEVER PAGE the person is on (AI_ASSISTANT_SPEC
        // §12.2, "Everywhere"; DESIGN-WL-ASSISTANT-BOARD-OFF-HOME-PAGESLOT-1): the
        // drawer closes (a drawer promoted out of the main placement returns to
        // it, the shell's close edge); a sidebar the person CHOSE keeps its
        // placement and the board shows through the board view's own preview
        // mode on the home — the one route its preview can show on, so that case
        // alone still goes home (the router, the way the header's Home button
        // navigates).
        const root = this.state && this.state.root;
        if (!root || typeof root.update !== 'function') return false;
        const shown = this.call('assistantBoardShow', x.boardId);
        if (!shown) return false;
        const onMain = root.assistantDock === 'main' || root._assistantDockPromotedFrom === 'main';
        root.update({
            assistantOpen: false,
            _homeThreadOpen: false,
            ...onMain ? {} : {
                _aiBoardPreview: true,
                _aiBoard: {
                    ...root._aiBoard,
                    path: '/'
                }
            }
        }, {
            preventFetch: true
        });
        if (onMain) return true;
        const raw = typeof root.currentPath === 'string' && root.currentPath ? root.currentPath : '/';
        const stripped = this.call('stripWorkspacePrefix', raw);
        const path = typeof stripped === 'string' ? stripped : raw;
        if (path !== '/' && path !== '' && typeof this.router === 'function') try {
            this.router('/', typeof this.getRoot === 'function' ? this.getRoot() : undefined);
        } catch (_) {
        /* the router is not reachable here — the board waits on the home */ }
        return true;
    }
    return false;
};
const $3312d3a062571ec8$export$2c974b2963a86222 = function assistantBlockSaveApp(s) {
    const x = s && typeof s === 'object' ? s : {};
    if (x.type !== 'view' || !x.route) return null;
    const root = this.state && this.state.root;
    const def = root && root._aiAnswerPages ? root._aiAnswerPages[x.route] : null;
    const app = def && def.metadata && def.metadata.__extensionApp;
    if (app && app.projectId) return this.call('addExtensionToWorkspace', {
        projectId: app.projectId,
        name: app.name
    });
    return this.call('saveAnswerViewAsApp', x.route);
};
const $3312d3a062571ec8$export$6986b35d56a6934d = function assistantBlockSaveAppState(s) {
    const x = s && typeof s === 'object' ? s : {};
    const root = this.state && this.state.root;
    const def = x.type === 'view' && root && root._aiAnswerPages ? root._aiAnswerPages[x.route] : null;
    const app = def && def.metadata && def.metadata.__extensionApp;
    if (!app || !app.projectId) return 'save';
    const fns = this.context && this.context.functions;
    if (fns && typeof fns.isExtensionAddedPending === 'function' && this.call('isExtensionAddedPending', root)) return 'checking';
    if (fns && typeof fns.isExtensionAddedToWorkspace === 'function') {
        if (this.call('isExtensionAddedToWorkspace', root, app.projectId)) return 'added';
    }
    return 'save';
};
const $3312d3a062571ec8$export$c4c4f7e5c4596328 = function assistantBlockSaveState(root, s) {
    const r = root && typeof root === 'object' ? root : {};
    const bag = r._aiBlockSaves && typeof r._aiBlockSaves === 'object' ? r._aiBlockSaves : {};
    const block = this.call('recordsBlockOf', s);
    if (!block) return null;
    return bag[this.call('boardSpecHash', block)] || null;
};
const $3312d3a062571ec8$export$231eda8f2b506aad = async function assistantBlockSaveBoard(el, s) {
    const host = el || this;
    const root = s && s.root || host && host.state && host.state.root;
    const block = host.call('recordsBlockOf', s);
    if (!root || typeof root.update !== 'function' || !block) return {
        ok: false,
        reason: 'unavailable'
    };
    const key = host.call('boardSpecHash', block);
    const mark = (state)=>{
        const bag = root._aiBlockSaves && typeof root._aiBlockSaves === 'object' ? root._aiBlockSaves : {};
        root.update({
            _aiBlockSaves: {
                ...bag,
                [key]: state
            }
        }, {
            preventFetch: true
        });
    };
    const now = (root._aiBlockSaves || {})[key];
    if (now === 'saving' || now === 'saved') return {
        ok: now === 'saved',
        already: true
    };
    const title = host.call('assistantBlockTitle', s) || host.call('recordsBlockTitle', block);
    const ws = root.workspace;
    const workspaceId = ws && (ws.id || ws._id) || null;
    mark('saving');
    try {
        const sdk = host.sdk || host.call('getSDK');
        if (!sdk || typeof sdk.execute !== 'function') throw new Error('unknown method: ai.boards');
        const saved = await sdk.execute('ai.boards', 'save', {
            spec: {
                v: 1,
                prompt: title,
                title: title,
                summary: '',
                items: [
                    {
                        ...block
                    }
                ]
            },
            title: title,
            ...workspaceId ? {
                workspaceId: workspaceId
            } : {}
        });
        const row = saved && typeof saved === 'object' ? saved.data || saved : null;
        if (row && row.id) {
            const list = Array.isArray(root._aiBoards) ? root._aiBoards : [];
            root.update({
                _aiBoards: [
                    row,
                    ...list.filter((b)=>b && b.id !== row.id)
                ]
            }, {
                preventFetch: true
            });
        }
        mark('saved');
        return {
            ok: true,
            board: row
        };
    } catch (err) {
        mark('failed');
        return {
            ok: false,
            reason: 'failed',
            error: err && err.message || String(err)
        };
    }
};
const $3312d3a062571ec8$export$b361506cedab179f = function assistantBlockSaveLabel(root, s) {
    const state = this.call('assistantBlockSaveState', root, s);
    return state === 'saving' ? 1 : state === 'saved' ? 2 : 0;
};
const $3312d3a062571ec8$export$38573187989e388c = function assistantBlockRefine(s) {
    const title = this.call('assistantBlockTitle', s);
    const text = String(this.call('polyglot', 'workspace.assistantBlock.refinePrefix')).replace('{title}', title);
    try {
        const root = typeof this.getRoot === 'function' ? this.getRoot() : null;
        const composer = root && root.lookdown ? root.lookdown('CanvasPromptTextarea') : null;
        if (composer && composer.state && typeof composer.state.update === 'function') composer.state.update({
            draft: text
        });
        const field = composer && composer.lookdown ? composer.lookdown('Textarea') : null;
        const node = field && field.node;
        if (node && typeof node.focus === 'function') {
            node.focus();
            if (typeof node.setSelectionRange === 'function') node.setSelectionRange(text.length, text.length);
        }
        return !!composer;
    } catch (_) {
        return false;
    }
};
const $3312d3a062571ec8$export$25e982f3eee5ffb3 = function assistantBlockMountView(el, s) {
    const host = el || this;
    if (!host || typeof host.set !== 'function' || !s || s.type !== 'view') return false;
    const root = s.root;
    // A view card that carries its SOURCE and no route — a Fly page's UI
    // section on a reloaded thread (functions/_simone/toolEmbed.js
    // flyPageEmbeds): the answer view is registered again through the same
    // audit and gate (renderAnswerUi, not opened), once per host, and the card
    // learns its route (Open in split and Save as app read it). A source the
    // gate refuses says one quiet line.
    let route = typeof s.route === 'string' ? s.route : '';
    if (!route && typeof s.source === 'string' && s.source.trim()) {
        const want = 'source/' + this.call('boardSpecHash', s.source);
        if (host.__blockViewSource !== want) {
            host.__blockViewSource = want;
            let res = null;
            try {
                res = this.call('renderAnswerUi', {
                    title: typeof s.title === 'string' ? s.title : '',
                    source: s.source,
                    placement: s.placement === 'split' ? 'split' : 'inline',
                    open: false
                });
            } catch (_) {
                res = null;
            }
            host.__blockViewRoute = res && res.ok === true && typeof res.opened === 'string' ? res.opened : '';
            if (!host.__blockViewRoute) {
                host.__blockViewSig = 'refused';
                try {
                    host.set({
                        tag: 'p',
                        margin: '0',
                        fontSize: 'Z',
                        color: 'caption',
                        text: String(this.call('polyglot', 'workspace.assistantBlock.viewFailed'))
                    });
                } catch (_) {
                /* the host is gone */ }
                return false;
            }
            if (typeof s.update === 'function') try {
                s.update({
                    route: host.__blockViewRoute
                }, {
                    preventFetch: true
                });
            } catch (_) {
            /* the card's state is gone — the host keeps its route */ }
        }
        route = host.__blockViewRoute || '';
        if (!route) return false;
    }
    const def = route && root && root._aiAnswerPages ? root._aiAnswerPages[route] : null;
    const sig = def ? 'view/' + route : 'none';
    if (host.__blockViewSig === sig) return !!def;
    host.__blockViewSig = sig;
    if (!def) return false;
    const rest = {
        ...def
    };
    delete rest.metadata;
    host.set({
        ...rest,
        context: def.context,
        tag: 'div',
        gridRow: null,
        gridColumn: null,
        height: 'auto',
        minHeight: '0'
    });
    return true;
};
const $3312d3a062571ec8$export$34710046e05405a1 = function assistantBlockViewGone(s) {
    if (!s || s.type !== 'view') return false;
    // A card that carries its source is drawn from it (assistantBlockMountView
    // above registers it again, or says the gate refused it).
    if (typeof s.source === 'string' && s.source.trim()) return false;
    const root = s.root;
    return !(root && root._aiAnswerPages && root._aiAnswerPages[s.route]);
};
const $3312d3a062571ec8$export$487b7d02718dfe4b = function assistantEmbedWidgetRow(s) {
    const x = s && typeof s === 'object' ? s : {};
    if (x.type !== 'widget' || typeof x.widget !== 'string' || !x.widget) return null;
    const root = this.state && this.state.root;
    if (!root) return null;
    const params = x.params && typeof x.params === 'object' && !Array.isArray(x.params) ? x.params : {};
    const spec = {
        v: 1,
        items: [
            {
                kind: 'widget',
                widget: x.widget,
                params: params,
                ...x.size ? {
                    size: x.size
                } : {}
            }
        ]
    };
    const derived = this.call('boardItemsFor', spec, root);
    const row = derived && Array.isArray(derived.items) ? derived.items[0] : null;
    return row && row.kind === 'widget' ? row : null;
};
const $3312d3a062571ec8$export$754c8243922e0b0f = function assistantEmbedWidgetStatus(s) {
    const x = s && typeof s === 'object' ? s : {};
    if (x.type !== 'widget') return null;
    const root = this.state && this.state.root;
    if (!root) return 'loading';
    const settings = root.workspace && root.workspace.settings || {};
    const refs = this.call('installedAppRefs', settings);
    const declared = Array.isArray(refs) ? refs : [];
    if (declared.length && !Array.isArray(root.workspaceApps)) return 'loading';
    if (this.call('assistantEmbedWidgetRow', x)) return 'ready';
    const ref = String(x.widget || '').split('.')[0];
    const names = (id)=>{
        const full = String(id || '');
        const key = full.split('/').pop();
        return full === ref || key === ref || key.replace(/-app$/, '') === ref;
    };
    const ws = root.workspace;
    const live = ws && (ws.id || ws._id) ? String(ws.id || ws._id) : '';
    const act = root._workspaceActivation;
    const blocked = act && live && String(act.workspaceId || '') === live && act.apps && Array.isArray(act.apps.blocked) ? act.apps.blocked : [];
    if (blocked.some(names)) return 'failed';
    // A view this member may not see (its `access`, functions/assistantAppViews.js).
    const vocab = this.call('boardVocabularyFor', root);
    const id = String(x.widget || '').split('.').pop();
    if (vocab && vocab.denied && Object.prototype.hasOwnProperty.call(vocab.denied, id)) return 'denied';
    // installed here, not published, not refused: the loader is still converging
    if (declared.some((c)=>c && names(String(c.owner || '') + '/' + String(c.key || '')))) return 'loading';
    return 'refused';
};
const $3312d3a062571ec8$export$d38c563ebba7ddec = function assistantEmbedWidgetNote(s) {
    const status = this.call('assistantEmbedWidgetStatus', s);
    if (status === 'failed') return String(this.call('polyglot', 'workspace.assistantBlock.widgetFailed'));
    if (status === 'refused') return String(this.call('polyglot', 'workspace.assistantBlock.widgetGone'));
    if (status === 'denied') return String(this.call('polyglot', 'workspace.assistantBlock.viewDenied'));
    return '';
};
const $3312d3a062571ec8$export$a084e982fe3d09c4 = function assistantEmbedWidgetMount(el, s) {
    const row = this.call('assistantEmbedWidgetRow', s);
    if (!row) return false;
    const root = this.state && this.state.root;
    this.call('assistantBoardMountBody', el, {
        ...row,
        root: root
    });
    return true;
};

});

parcelRegister("hHHSG", function(module, exports) {

$parcel$export(module.exports, "assistantAppViewRoute", () => $ce387db0c8b14e3c$export$9880cc656a978dc1);
$parcel$export(module.exports, "assistantAppViewSources", () => $ce387db0c8b14e3c$export$e2d4e5f80ad01944);
$parcel$export(module.exports, "assistantAppViewAllowed", () => $ce387db0c8b14e3c$export$d4fd418daf2ed9c5);
$parcel$export(module.exports, "assistantAppViewLink", () => $ce387db0c8b14e3c$export$db3abff2145bc756);
$parcel$export(module.exports, "assistantAppViewOwnRoute", () => $ce387db0c8b14e3c$export$b97b5b411f4c184e);
$parcel$export(module.exports, "ensureAppViewContext", () => $ce387db0c8b14e3c$export$36d4ad108226ee67);
$parcel$export(module.exports, "_resetCatalogBundles", () => $ce387db0c8b14e3c$export$28f31f410e042710);
$parcel$export(module.exports, "assistantAppCatalog", () => $ce387db0c8b14e3c$export$1ae7969be59c4406);
// APP VIEWS in an AI answer — the widget contract, generalised (Nika
// 2026-10-01: "chatbot should be using all powerful functionalities from all
// apps ... also calendar, tickets - reusing ui and functionalities right in the
// chatbot").
//
// A VIEW is a read-only piece of an app's own UI the assistant may mount in its
// thread (main + sidebar), with params the model sets. Two declarers, ONE shape:
//
//   an installed app — manifest v2 `views[]` (beside `widgets[]`)
//   a built-in package (calendar, tickets — no manifest; lazy-folded into the
//     shell) — a `<pkg>AiViews()` provider in its EAGER function slice that
//     returns `{ app, fold, views }`
//
//   {
//     id: 'calendar-agenda',          /^[a-z0-9-]+$/, unique across apps
//     title, describe, icon, hue,     as a widget (describe = the ONE line the
//                                     model matches a question against)
//     component: 'CalendarAgendaEmbed' the key the app ships; mounted with
//                                     scope { params, widgetId, size, embedded }
//     params: { … }                   the widget param schema (enum / string /
//                                     number / boolean / range / date,
//                                     values / valuesFrom / default)
//     size, minSize                   s|m|l|xl — a view defaults to l
//     link: { route, query }          "Open in split": query values are a
//                                     param NAME (a range param gives its first
//                                     day) or `{ value }` (a literal)
//     link: { route, call }           a route the params alone cannot name
//                                     (the site's owner, its environment):
//                                     `el.call(call, params, root)` answers it
//                                     (a string starting with '/'), null hides
//                                     the Open
//     access: { admin?, permission?, collections?, route? }
//                                     who may see it — every condition must
//                                     hold (U5); the same checks the app pages
//                                     use: currentUserIsAdmin, hasPermission,
//                                     the workspace's records grant, and the
//                                     navigation gate of the app's page
//                                     (`route`: the module's feature flag and
//                                     the team app-access matrix,
//                                     navItemVisible — a member who cannot
//                                     open /mail sees no mail view, and the
//                                     catalog never offers it)
//   }
//
// EMPTY — the COMPONENT declares `empty` once on its root, the home slot
// grid's contract (components/HomeWidgetBody.js): `true` when its data has
// answered and the view shows only its one sentence (nothing matches, no such
// item, a failed read), `false` when it shows something, `null` while it is
// still reading. A Fly page reads it (functions/assistantBoard.js
// assistantBoardCardEmpty) and gives an empty section ONE row, never one line
// over a blank square:
//
//   TicketsAnswerView: {
//     state: { tickets: null },
//     empty: (el, s) => (Array.isArray(s.tickets) ? s.tickets.length === 0 : null),
//     …
//   }
//
// A view that does not declare it keeps its full size.
//
// ↗ OPEN — the COMPONENT may declare `openRoute` once on its root: the route
// of its own page WITH the filters the view resolved — a teammate's name to
// their email, a project's name to its id — which `link` cannot know before
// the view reads. A card's ↗ Open (a Fly section, assistantBoardCardOpen) and
// a thread block's Open in split (assistantBlockOpen) read it on the mounted
// body and fall back to `link`:
//
//   TicketsAnswerView: {
//     state: { route: null },
//     openRoute: (el, s) => s.route || null,
//     …
//   }
//
// RESOLVED PARAMS — the COMPONENT may declare `resolvedParams` once on its
// root: the params it SHOWS, in its own param names, once it has resolved them
// — a site's key when the model named no site, a teammate's email for a name
// (null while reading). A Fly page's next ask carries them as the sections on
// screen (functions/assistantFlyContext.js, the ask scope's `widgets`), so a
// follow-up stays on the subject the card showed:
//
//   SitePreviewView: {
//     state: { site: null },
//     resolvedParams: (el, s) => (s.site ? { project: s.site.key } : null),
//     …
//   }
//
// The board vocabulary (assistantBoard.js boardVocabularyFor) reads the views
// through assistantAppViewSources and keeps them beside the widgets, so the
// widget path — validation, the card, the mount, Open in split — serves them.
// A view the member may not see goes to `denied`: the card says one quiet line.
//
// Frank note: el.call serializes each export on its own (FA204) — every
// export here is self-contained.
// THE PAGE A VIEW IS GATED ON (`access.route`, assistantAppViewAllowed): its
// own declaration, else the page its link opens — a member who cannot open
// that page (the module's flag, the team app-access matrix) sees no view of it
// either, and the catalog never offers it (U5). A view that declares no route
// and links nowhere (or to the home) is gated by its other conditions only.
// '' when none.
const $ce387db0c8b14e3c$export$9880cc656a978dc1 = function assistantAppViewRoute(view) {
    const v = view && typeof view === 'object' ? view : null;
    if (!v) return '';
    const own = v.access && typeof v.access === 'object' ? v.access.route : null;
    if (typeof own === 'string' && own.startsWith('/')) return own;
    const link = v.link && typeof v.link === 'object' ? v.link.route : null;
    if (typeof link !== 'string' || !link.startsWith('/') || link.startsWith('//')) return '';
    const path = link.split('?')[0].split('#')[0];
    return path && path !== '/' ? path : '';
};
const $ce387db0c8b14e3c$export$e2d4e5f80ad01944 = function assistantAppViewSources(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || {};
    const out = [];
    const gated = (views)=>views.map((v)=>{
            if (!v || typeof v !== 'object') return v;
            const has = v.access && typeof v.access === 'object' ? v.access.route : null;
            if (typeof has === 'string' && has || !el || typeof el.call !== 'function') return v;
            const route = el.call('assistantAppViewRoute', v);
            return route ? {
                ...v,
                access: {
                    ...v.access || {},
                    route: route
                }
            } : v;
        });
    const wp = r.workspaceProject;
    if (wp && Array.isArray(wp.views)) out.push({
        app: wp,
        views: gated(wp.views),
        fold: null
    });
    for (const app of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])if (app && Array.isArray(app.views)) out.push({
        app: app,
        views: gated(app.views),
        fold: null
    });
    // The built-in packages. A provider not registered (a host without the
    // package) adds nothing. files / preview / canvas: the workspace's files,
    // one of its websites live, its projects (Nika 2026-10-17: "fly should be
    // able to display all functionality … website preview, tasks, files").
    // workspace / meet / chat / documents / mail: the team and its agents, the
    // notifications, the reminders, the calls and a call's transcript, a chat
    // channel, a note, the mail (Nika 2026-10-18: "fly should cover all
    // functionality that would be possible otherwise").
    const PROVIDERS = [
        'calendarAiViews',
        'ticketsAiViews',
        'filesAiViews',
        'previewAiViews',
        'canvasAiViews',
        'workspaceAiViews',
        'meetAiViews',
        'chatAiViews',
        'documentsAiViews',
        'mailAiViews'
    ];
    const fns = el && el.context && el.context.functions || null;
    for (const name of PROVIDERS){
        if (fns && typeof fns[name] !== 'function') continue;
        let got = null;
        try {
            got = el.call(name);
        } catch (_) {
            got = null;
        }
        if (!got || typeof got !== 'object' || !got.app || !Array.isArray(got.views)) continue;
        out.push({
            app: got.app,
            views: gated(got.views),
            fold: typeof got.fold === 'string' ? got.fold : null
        });
    }
    return out;
};
const $ce387db0c8b14e3c$export$d4fd418daf2ed9c5 = function assistantAppViewAllowed(access, root) {
    const el = this;
    const a = access && typeof access === 'object' ? access : null;
    if (!a) return true;
    const r = root || el && el.state && el.state.root || {};
    const ask = (name, ...args)=>{
        try {
            return el.call(name, ...args);
        } catch (_) {
            return false;
        }
    };
    if (a.admin === true && !ask('currentUserIsAdmin', r)) return false;
    if (typeof a.permission === 'string' && a.permission && !ask('hasPermission', r, a.permission)) return false;
    if (Array.isArray(a.collections) && a.collections.length) {
        // The records grant the server applies: each installed app's
        // settings.workspaceApps[].capabilities.records.collections (and the
        // takeover module's), unioned. No entry carries a grant → the shell cannot
        // tell; the view mounts and the plane decides (the app page's own rule).
        const s = r.workspace && r.workspace.settings || {};
        const entries = (Array.isArray(s.workspaceApps) ? s.workspaceApps : []).concat(s.workspaceModule ? [
            s.workspaceModule
        ] : []);
        const granted = new Set();
        let known = false;
        for (const e of entries){
            const rec = e && e.capabilities && e.capabilities.records;
            if (!rec || !Array.isArray(rec.collections)) continue;
            known = true;
            for (const c of rec.collections){
                const key = typeof c === 'string' ? c : c && c.key;
                if (key) granted.add(String(key));
            }
        }
        if (known && !a.collections.every((c)=>granted.has(String(c)))) return false;
    }
    // The app's page: its module flag and the team app-access matrix — the one
    // navigation gate (shared functions/featureFlags.js navItemVisible).
    if (typeof a.route === 'string' && a.route.startsWith('/')) {
        let open = true;
        try {
            open = el.call('navItemVisible', r, a.route) !== false;
        } catch (_) {
            open = true;
        }
        if (!open) return false;
    }
    return true;
};
const $ce387db0c8b14e3c$export$db3abff2145bc756 = function assistantAppViewLink(link, params, root) {
    const l = link && typeof link === 'object' ? link : null;
    if (!l || typeof l.route !== 'string' || !l.route.startsWith('/')) return null;
    const p = params && typeof params === 'object' ? params : {};
    if (typeof l.call === 'string' && l.call) {
        const fns = this && this.context && this.context.functions;
        if (!fns || typeof fns[l.call] !== 'function') return null;
        let to = null;
        try {
            to = this.call(l.call, p, root || this.state && this.state.root || {});
        } catch (_) {
            to = null;
        }
        return typeof to === 'string' && to.startsWith('/') && !to.startsWith('//') ? to : null;
    }
    const q = l.query && typeof l.query === 'object' ? l.query : {};
    const parts = [];
    for (const key of Object.keys(q)){
        const src = q[key];
        let v = null;
        if (src && typeof src === 'object' && src.value != null) v = src.value;
        else if (typeof src === 'string') v = p[src];
        if (v == null || v === '') continue;
        let str = String(v);
        if (/^\d{4}-\d{2}-\d{2}\.\.\d{4}-\d{2}-\d{2}$/.test(str)) str = str.slice(0, 10);
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(str));
    }
    return parts.length ? l.route + (l.route.includes('?') ? '&' : '?') + parts.join('&') : l.route;
};
const $ce387db0c8b14e3c$export$b97b5b411f4c184e = function assistantAppViewOwnRoute(host) {
    const body = host && host.content;
    const route = body ? body.openRoute : null;
    return typeof route === 'string' && /^\/(?!\/)/.test(route) ? route : null;
};





const $ce387db0c8b14e3c$export$36d4ad108226ee67 = async function ensureAppViewContext(key) {
    // chat / mail / meet / documents fold through their OWN openers (functions/
    // chatFold.js, mailFold.js, meetFold.js, documentsFold.js): the same
    // add-missing merge plus each package's latch (and the chat / mail overlay
    // slot), so a view never opens a second import path into a package the
    // shell already folds.
    const OPENERS = {
        chat: 'ensureChatContext',
        mail: 'ensureMailContext',
        meet: 'ensureMeetContext',
        documents: 'ensureDocumentsContext'
    };
    if (Object.prototype.hasOwnProperty.call(OPENERS, key)) try {
        return await this.call(OPENERS[key]) === true;
    } catch (err) {
        console.warn('[assistantAppViews] context fold failed:', key, err && err.message);
        return false;
    }
    const rootEl = typeof this.getRoot === 'function' ? this.getRoot() : this;
    const ctx = rootEl && rootEl.context;
    if (!ctx) return false;
    let mod = null;
    try {
        if (key === 'calendar') mod = await (parcelRequire("iSwre"));
        else if (key === 'tickets') mod = await (parcelRequire("3Py9H"));
        else if (key === 'files') mod = await (parcelRequire("7mtaO"));
        else if (key === 'preview') mod = await (parcelRequire("hRfYg"));
        else if (key === 'canvas') mod = await (parcelRequire("3dQQl"));
        else return false;
    } catch (err) {
        console.warn('[assistantAppViews] context fold failed:', key, err && err.message);
        return false;
    }
    const lib = mod && mod.default ? mod.default : mod;
    if (!lib || !lib.components && !lib.functions) return false;
    const add = (from, to)=>{
        if (!from || !to) return;
        for (const k of Object.keys(from))if (!to[k]) to[k] = from[k];
    };
    add(lib.components, ctx.components);
    add(lib.functions, ctx.functions);
    return true;
};
// The bundles the catalog loads ITSELF, per `<lang>/<namespace>` — kept here,
// not in the i18n loader's cache (a language switch evicts that one). Loaded
// through the shell's own `loadI18nNamespace` (no network on a published
// record: it degrades to the base language). A turn sent before a bundle
// arrives carries the words already loaded; the next one carries all.
const $ce387db0c8b14e3c$var$CATALOG_BUNDLES = new Map();
const $ce387db0c8b14e3c$var$CATALOG_PENDING = new Set();
const $ce387db0c8b14e3c$var$KEY_RE = /^[a-z][A-Za-z0-9]*(\.[A-Za-z0-9_-]+)+$/;
const $ce387db0c8b14e3c$export$28f31f410e042710 = ()=>{
    $ce387db0c8b14e3c$var$CATALOG_BUNDLES.clear();
    $ce387db0c8b14e3c$var$CATALOG_PENDING.clear();
};
function $ce387db0c8b14e3c$var$catalogDictionaryKeys(entry) {
    const keys = new Set();
    for (const item of [
        ...Array.isArray(entry.views) ? entry.views : [],
        ...Array.isArray(entry.forms) ? entry.forms : []
    ]){
        if (!item || typeof item !== 'object') continue;
        if (typeof item.title === 'string') keys.add(item.title);
        for (const bag of [
            item.params,
            item.fields
        ]){
            if (!bag || typeof bag !== 'object') continue;
            for (const def of Object.values(bag)){
                const labels = def && typeof def === 'object' ? def.labels : null;
                if (!labels || typeof labels !== 'object') continue;
                for (const label of Object.values(labels))if (typeof label === 'string') keys.add(label);
            }
        }
    }
    return [
        ...keys
    ].filter((k)=>$ce387db0c8b14e3c$var$KEY_RE.test(k));
}
function $ce387db0c8b14e3c$var$catalogLangs(tr) {
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    const langs = new Set(Object.keys(tr || {}));
    for (const code of reg && Array.isArray(reg.langs) && reg.langs || [])langs.add(code);
    return [
        ...langs
    ];
}
function $ce387db0c8b14e3c$var$prefetchCatalogBundles(el, keys) {
    const w = typeof window !== 'undefined' ? window : globalThis;
    const reg = w.__i18nRegistry || globalThis.__i18nRegistry;
    if (!reg || !Array.isArray(reg.langs) || !el || typeof el.call !== 'function') return;
    const known = new Set(Array.isArray(reg.namespaces) ? reg.namespaces : []);
    const namespaces = [
        ...new Set(keys.map((k)=>k.split('.')[0]))
    ].filter((ns)=>known.has(ns));
    for (const code of reg.langs)for (const ns of namespaces){
        const id = code + '/' + ns;
        if ($ce387db0c8b14e3c$var$CATALOG_BUNDLES.has(id) || $ce387db0c8b14e3c$var$CATALOG_PENDING.has(id)) continue;
        $ce387db0c8b14e3c$var$CATALOG_PENDING.add(id);
        let p = null;
        try {
            p = el.call('loadI18nNamespace', code, ns);
        } catch (_) {
            p = null;
        }
        Promise.resolve(p).then((bundle)=>{
            // A language with no bundle degrades to the base one: never store
            // English as another language's words.
            const degraded = code !== reg.baseLang && reg.base && bundle === reg.base[ns];
            if (bundle && typeof bundle === 'object' && !degraded) $ce387db0c8b14e3c$var$CATALOG_BUNDLES.set(id, bundle);
        }).catch(()=>{}).finally(()=>$ce387db0c8b14e3c$var$CATALOG_PENDING.delete(id));
    }
}
const $ce387db0c8b14e3c$export$1ae7969be59c4406 = function assistantAppCatalog() {
    const el = this;
    const fns = el && el.context && el.context.functions || {};
    const NAMES = [
        'calendarAiViews',
        'calendarAiForms',
        'ticketsAiViews',
        'ticketsAiForms',
        'filesAiViews',
        'previewAiViews',
        'canvasAiViews',
        'workspaceAiViews',
        'meetAiViews',
        'chatAiViews',
        'documentsAiViews',
        'mailAiViews'
    ];
    const root = el && el.state && el.state.root || null;
    // Its own page gate, else the page its link opens (assistantAppViewRoute).
    const routeOpen = (view)=>{
        const route = el.call('assistantAppViewRoute', view);
        if (typeof route !== 'string' || !route.startsWith('/')) return true;
        try {
            return el.call('navItemVisible', root, route) !== false;
        } catch (_) {
            return true;
        }
    };
    const out = [];
    for (const name of NAMES){
        if (typeof fns[name] !== 'function') continue;
        let got = null;
        try {
            got = el.call(name);
        } catch (_) {
            got = null;
        }
        const id = got && got.app && typeof got.app.id === 'string' ? got.app.id : '';
        if (!/^system\/[a-z0-9-]+$/.test(id)) continue;
        // WORDS, NOT KEYS: the server reads a field's / param's `labels` as text
        // or { en, ka } and cannot read the shell's bundles, so a bundle-key label
        // leaves as the { en, ka } pair of the loaded bundles (a key no bundle
        // knows, a literal text and a pair pass through). A copy: the provider's
        // own object is never touched.
        let entry = got;
        try {
            entry = JSON.parse(JSON.stringify(got));
        } catch (_) {
            entry = got;
        }
        if (Array.isArray(entry.views)) {
            const open = entry.views.filter(routeOpen);
            if (open.length !== entry.views.length) entry = {
                ...entry,
                views: open
            };
            if (!open.length && !(Array.isArray(entry.forms) && entry.forms.length)) continue;
        }
        // EVERY supported language, not only the UI's: an answer is written in
        // the language of the ASK (live f5276428b: a Georgian ask from an English
        // shell met en-only words). Words come from the loaded translations, then
        // from the bundles this catalog loads itself (catalogBundles below).
        const tr = el && el.context && el.context.polyglot && el.context.polyglot.translations || {};
        const keys = $ce387db0c8b14e3c$var$catalogDictionaryKeys(entry);
        $ce387db0c8b14e3c$var$prefetchCatalogBundles(el, keys);
        const langs = $ce387db0c8b14e3c$var$catalogLangs(tr);
        const wordsOf = (code, key)=>{
            const own = tr[code] && tr[code][key];
            if (typeof own === 'string' && own.trim()) return own.trim();
            const ns = key.split('.')[0];
            const fetched = $ce387db0c8b14e3c$var$CATALOG_BUNDLES.get(code + '/' + ns);
            const text = fetched && fetched[key];
            return typeof text === 'string' && text.trim() ? text.trim() : '';
        };
        const resolve = (labels)=>{
            if (!labels || typeof labels !== 'object') return;
            for (const value of Object.keys(labels)){
                const key = labels[value];
                if (typeof key !== 'string') continue;
                const pair = {};
                for (const code of langs){
                    const text = wordsOf(code, key);
                    if (text) pair[code] = text;
                }
                if (pair.en) labels[value] = pair;
            }
        };
        const bags = [];
        for (const f of Array.isArray(entry.forms) ? entry.forms : [])bags.push(f && f.fields);
        for (const v of Array.isArray(entry.views) ? entry.views : [])bags.push(v && v.params);
        // AN ENUM TRAVELS AS THE SERVER TAKES IT: its first 30 values (the server
        // offers the model no more — aiBoardSchema ENUM_MAX_VALUES) and the
        // labels of those values only; `valuesLive` (the client's own rule for a
        // workspace's live list, assistantBoard.js validateBoardSpec) stays home.
        // A site view's websites enum is the workspace's whole site list, and
        // three views carry it: untrimmed, a big workspace pushed the catalog
        // over the server's byte cap, which drops the WHOLE catalog.
        const ENUM_MAX = 30;
        for (const bag of bags){
            if (!bag || typeof bag !== 'object') continue;
            for (const name of Object.keys(bag)){
                const def = bag[name];
                if (!def || typeof def !== 'object') continue;
                if (def.valuesLive !== undefined) delete def.valuesLive;
                if (def.type === 'enum' && Array.isArray(def.values) && def.values.length > ENUM_MAX) def.values = def.values.slice(0, ENUM_MAX);
                if (def.type === 'enum' && Array.isArray(def.values) && def.labels) {
                    const kept = new Set(def.values.map(String));
                    for (const v of Object.keys(def.labels))if (!kept.has(v)) delete def.labels[v];
                }
                resolve(def.labels);
            }
        }
        // A view's / form's TITLE stays its key (the shell renders the card from
        // it); its words ride beside it as `lang: { <lang>: { <key>: words } }`,
        // the shape of an installed app's dictionary (server appCatalog
        // pickClientAppCatalog). Without them the server could not name a built-in
        // view, and the AI answer used the model's free title (live b8ef3cc45:
        // "Here is team agenda for next week.").
        const lang = {};
        for (const item of [
            ...Array.isArray(entry.views) ? entry.views : [],
            ...Array.isArray(entry.forms) ? entry.forms : []
        ]){
            const key = item && typeof item.title === 'string' ? item.title : '';
            if (!key) continue;
            for (const code of langs){
                const text = wordsOf(code, key);
                if (!text) continue;
                if (!lang[code]) lang[code] = {};
                lang[code][key] = text;
            }
        }
        if (Object.keys(lang).length) entry.lang = lang;
        out.push(entry);
    }
    return out.length ? out : null;
};

});

parcelRegister("7vPqO", function(module, exports) {

$parcel$export(module.exports, "assistantAppFormSources", () => $578352dfcf062030$export$9df3cc45701106e);
$parcel$export(module.exports, "assistantFormEntry", () => $578352dfcf062030$export$c0c0786505366040);
$parcel$export(module.exports, "assistantFormStatus", () => $578352dfcf062030$export$8b104afcc36e776);
$parcel$export(module.exports, "assistantFormNote", () => $578352dfcf062030$export$244ce5a215de676e);
$parcel$export(module.exports, "assistantFormFields", () => $578352dfcf062030$export$f6003d9d385ce560);
$parcel$export(module.exports, "assistantFormRequestId", () => $578352dfcf062030$export$f23996771ac8d438);
$parcel$export(module.exports, "assistantFormSavedStore", () => $578352dfcf062030$export$4c24c209aeaeee99);
$parcel$export(module.exports, "assistantFormState", () => $578352dfcf062030$export$f2d04f5c0ba25b50);
$parcel$export(module.exports, "assistantFormOpen", () => $578352dfcf062030$export$e769b77d8054dc66);
$parcel$export(module.exports, "assistantStarterForm", () => $578352dfcf062030$export$87bb138c7a88455b);
$parcel$export(module.exports, "assistantFormSaved", () => $578352dfcf062030$export$cadc8bd92e4b8f2);
$parcel$export(module.exports, "assistantFormSavedRows", () => $578352dfcf062030$export$89f8828f4eeb8c1c);
$parcel$export(module.exports, "assistantFormOpenSaved", () => $578352dfcf062030$export$61aff548306d009);
$parcel$export(module.exports, "assistantFormAction", () => $578352dfcf062030$export$e62c7d637680d436);
$parcel$export(module.exports, "assistantFormStatusText", () => $578352dfcf062030$export$d601c6c10ef5517f);
// APP FORMS in an AI answer (U3; Nika 2026-10-01: "chatbot should be using
// all powerful functionalities from all apps ... reusing ui and
// functionalities right in the chatbot").
//
// The assistant PROPOSES a record (a new deal, an event moved to Friday, a
// task set to Blocked and given to Ana). The answer shows the proposal and ONE
// action that opens the APP'S OWN form, prefilled. Nothing is written until
// the member saves in that form — the form IS the ask. The app's own save
// function writes (SDK), then reports the saved record, and the answer shows
// it as a row that opens it.
//
// Two declarers, ONE shape (the views' — functions/assistantAppViews.js):
//   an installed app — manifest v2 `forms[]`
//   a built-in package — a `<pkg>AiForms()` provider in its EAGER slice that
//     returns `{ app, forms }` (calendarAiForms, ticketsAiForms)
//
//   {
//     id: 'crm-deal',              /^[a-z0-9-]+$/
//     title, describe              as a view (describe = the ONE line the
//                                  model matches a request against)
//     fields: { <key>: { type, values?, valuesFrom?, label, describe? } }
//                                  what the assistant may propose; the card
//                                  shows these, labelled, in this order
//     open: '<fn>'                 the app's function that seeds its form and
//                                  opens it: (formId, { values, recordId,
//                                  requestId }) — recordId null = create
//     component: '<Component>'     OPTIONAL — a sheet the shell's form host
//                                  mounts first (HomeWidgetFormHost, under the
//                                  app's context), for a form that is not
//                                  already mounted by its package
//     access: { admin?, permission?, collections? }   the views' rule
//   }
//
// WHERE `open` RUNS. For an installed app's form with a `component`, the host
// runs `open` ON the mounted sheet — the app's own function scope and its own
// state scope, the one the sheet reads (functions/moduleStateScope.js). Run
// on the card, a shell surface, the seed landed on the SHELL root while the
// sheet read the app's store: the app's own close (a module-local `draft:
// null`) then shadowed every later seed, and the sheet opened once per page
// load (WS-ASSISTANT-APP-FORM-OPEN-SHELL-SCOPE-1). A built-in package's form,
// and an app form with no `component`, are opened by their own code: `open`
// runs on the card, as before.
//
// THE REPORT. The app's save carries the `requestId` its form was opened with
// and, once the write succeeded, calls
//   el.call('assistantFormSaved', requestId, { id, title, meta?, route? })
// The card then shows that row; `route` opens it in the split.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
// Every source of forms: the takeover module and each installed app
// (`forms[]`), then the built-in providers. Each: { app, forms }.
const $578352dfcf062030$export$9df3cc45701106e = function assistantAppFormSources(root) {
    const el = this;
    const r = root || el && el.state && el.state.root || {};
    const out = [];
    const wp = r.workspaceProject;
    if (wp && Array.isArray(wp.forms)) out.push({
        app: wp,
        forms: wp.forms,
        builtin: false
    });
    for (const app of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])if (app && Array.isArray(app.forms)) out.push({
        app: app,
        forms: app.forms,
        builtin: false
    });
    const PROVIDERS = [
        'calendarAiForms',
        'ticketsAiForms'
    ];
    const fns = el && el.context && el.context.functions || null;
    for (const name of PROVIDERS){
        if (fns && typeof fns[name] !== 'function') continue;
        let got = null;
        try {
            got = el.call(name);
        } catch (_) {
            got = null;
        }
        if (!got || typeof got !== 'object' || !got.app || !Array.isArray(got.forms)) continue;
        out.push({
            app: got.app,
            forms: got.forms,
            builtin: true
        });
    }
    return out;
};
const $578352dfcf062030$export$c0c0786505366040 = function assistantFormEntry(s) {
    const el = this;
    const x = s && typeof s === 'object' ? s : {};
    if (x.type !== 'form') return null;
    const root = el.state && el.state.root;
    if (!root) return {
        status: 'loading',
        form: null,
        appId: null
    };
    const ref = typeof x.form === 'string' ? x.form : '';
    const dot = ref.indexOf('.');
    const app = dot > 0 ? ref.slice(0, dot) : '';
    const id = dot > 0 ? ref.slice(dot + 1) : ref;
    const names = (appId)=>{
        const full = String(appId || '');
        const key = full.split('/').pop();
        return !app || full === app || key === app || key.replace(/-app$/, '') === app;
    };
    const sources = el.call('assistantAppFormSources', root);
    for (const src of Array.isArray(sources) ? sources : []){
        const appId = src && src.app && src.app.id ? String(src.app.id) : '';
        if (!appId || !names(appId)) continue;
        const form = src.forms.find((f)=>f && f.id === id && typeof f.open === 'string');
        if (!form) continue;
        if (!el.call('assistantAppViewAllowed', form.access, root)) return {
            status: 'denied',
            form: null,
            appId: appId
        };
        return {
            status: 'ready',
            form: form,
            appId: appId,
            builtin: !!src.builtin
        };
    }
    // An installed app that has not published yet: its form may still come.
    const settings = root.workspace && root.workspace.settings || {};
    const refs = el.call('installedAppRefs', settings);
    if (Array.isArray(refs) && refs.length && !Array.isArray(root.workspaceApps)) return {
        status: 'loading',
        form: null,
        appId: null
    };
    return {
        status: 'refused',
        form: null,
        appId: null
    };
};
const $578352dfcf062030$export$8b104afcc36e776 = function assistantFormStatus(s) {
    const entry = this.call('assistantFormEntry', s);
    return entry ? entry.status : null;
};
const $578352dfcf062030$export$244ce5a215de676e = function assistantFormNote(s) {
    const status = this.call('assistantFormStatus', s);
    if (status === 'denied') return String(this.call('polyglot', 'workspace.assistantBlock.formDenied'));
    if (status === 'refused') return String(this.call('polyglot', 'workspace.assistantBlock.formGone'));
    return '';
};
const $578352dfcf062030$export$f6003d9d385ce560 = function assistantFormFields(s) {
    const entry = this.call('assistantFormEntry', s);
    if (!entry || entry.status !== 'ready') return [];
    const decl = entry.form.fields && typeof entry.form.fields === 'object' ? entry.form.fields : {};
    const values = s.values && typeof s.values === 'object' ? s.values : {};
    const out = [];
    for (const key of Object.keys(decl)){
        const v = values[key];
        if (v == null || v === '') continue;
        const d = decl[key] || {};
        const label = d.label ? String(this.call('polyglot', d.label)) : key;
        // The app's own word for a value: `valueLabel` (the app's function — the
        // CRM's crmStageLabel names the WORKSPACE pipeline's stages) first, then
        // `labels` (the key the server reads, params.<name>.labels: per value a
        // bundle key or literal text, or an { en, ka } pair); else the value.
        const word = (one)=>{
            const raw = String(one);
            if (typeof d.valueLabel === 'string' && d.valueLabel) try {
                const t = this.call(d.valueLabel, raw);
                if (typeof t === 'string' && t.trim()) return t;
            } catch (_) {
            /* the app's word is best-effort */ }
            const map = d.labels && typeof d.labels === 'object' ? d.labels : null;
            const entry = map && Object.prototype.hasOwnProperty.call(map, raw) ? map[raw] : null;
            if (typeof entry === 'string' && entry) {
                const t = this.call('polyglot', entry);
                return t ? String(t) : entry;
            }
            if (entry && typeof entry === 'object') {
                const lang = String(this.call('getActiveLang') || 'en').split('-')[0];
                const t = entry[lang] || entry.en;
                if (t) return String(t);
            }
            return raw;
        };
        const text = Array.isArray(v) ? v.map(word).join(', ') : typeof v === 'object' ? JSON.stringify(v) : word(v);
        out.push({
            key: key,
            label: label,
            value: text
        });
    }
    return out;
};
const $578352dfcf062030$export$f23996771ac8d438 = function assistantFormRequestId(s) {
    const x = s && typeof s === 'object' ? s : {};
    return 'frm_' + this.call('boardSpecHash', {
        form: x.form || '',
        values: x.values || {},
        recordId: x.recordId || null
    });
};
const $578352dfcf062030$export$4c24c209aeaeee99 = function assistantFormSavedStore(write) {
    const root = this.state && this.state.root;
    const ws = root && root.workspace && (root.workspace.id || root.workspace._id);
    if (!ws) return {};
    const key = 'ai_forms_' + String(ws);
    let store = null;
    try {
        store = globalThis.localStorage || null;
    } catch (_) {
        store = null;
    }
    if (!store) return {};
    let map = {};
    try {
        const raw = store.getItem(key);
        const parsed = raw ? JSON.parse(raw) : null;
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) map = parsed;
    } catch (_) {
        map = {};
    }
    if (write && typeof write === 'object') {
        map = {
            ...map,
            ...write
        };
        const keys = Object.keys(map);
        if (keys.length > 50) for (const k of keys.slice(0, keys.length - 50))delete map[k];
        try {
            store.setItem(key, JSON.stringify(map));
        } catch (_) {
        /* storage full or denied: memory still has it */ }
    }
    return map;
};
const $578352dfcf062030$export$f2d04f5c0ba25b50 = function assistantFormState(s) {
    const root = this.state && this.state.root;
    const bag = root && root._aiForms && typeof root._aiForms === 'object' ? root._aiForms : {};
    const id = this.call('assistantFormRequestId', s);
    if (bag[id]) return bag[id];
    const stored = this.call('assistantFormSavedStore');
    const saved = stored && stored[id];
    return saved && typeof saved === 'object' ? {
        status: 'saved',
        saved: saved
    } : null;
};
const $578352dfcf062030$export$e769b77d8054dc66 = function assistantFormOpen(s) {
    const el = this;
    const entry = el.call('assistantFormEntry', s);
    const root = el.state && el.state.root;
    if (!entry || entry.status !== 'ready' || !root || typeof root.update !== 'function') return null;
    const form = entry.form;
    const decl = form.fields && typeof form.fields === 'object' ? form.fields : {};
    const given = s.values && typeof s.values === 'object' ? s.values : {};
    const values = {};
    for (const key of Object.keys(decl))if (given[key] !== undefined) values[key] = given[key];
    const requestId = el.call('assistantFormRequestId', s);
    const bag = root._aiForms && typeof root._aiForms === 'object' ? root._aiForms : {};
    const prev = bag[requestId];
    if (!(prev && prev.status === 'saved')) root.update({
        _aiForms: {
            ...bag,
            [requestId]: {
                status: 'open'
            }
        }
    }, {
        preventFetch: true
    });
    const args = [
        form.id,
        {
            values: values,
            recordId: s.recordId || null,
            requestId: requestId
        }
    ];
    try {
        if (typeof form.component === 'string' && form.component) {
            const hosted = !entry.builtin;
            el.call('openHomeWidgetForm', {
                form: form.component,
                moduleId: entry.appId,
                widgetId: form.id,
                ...hosted ? {
                    open: {
                        call: form.open,
                        args: args
                    }
                } : {}
            });
            if (hosted) return requestId;
        }
        el.call(form.open, ...args);
    } catch (err) {
        console.warn('[assistantAppForms] open failed:', form.id, err && err.message);
        return null;
    }
    return requestId;
};
const $578352dfcf062030$export$87bb138c7a88455b = function assistantStarterForm(row) {
    const st = row && typeof row === 'object' ? row : this.state;
    const x = st && typeof st.parse === 'function' ? st.parse() : st;
    const ref = x && typeof x.form === 'string' ? x.form.trim() : '';
    const card = ref ? {
        type: 'form',
        form: ref,
        values: {}
    } : null;
    if (card && this.call('assistantFormStatus', card) === 'ready') return this.call('assistantFormOpen', card);
    const prompt = String(x && (x.prompt || x.text) || '').trim();
    const fns = this.context && this.context.functions || {};
    if (prompt && typeof fns.homeAiSend === 'function') return this.call('homeAiSend', prompt);
    return null;
};
const $578352dfcf062030$export$cadc8bd92e4b8f2 = function assistantFormSaved(requestId, saved) {
    const root = this.state && this.state.root;
    const bag = root && root._aiForms && typeof root._aiForms === 'object' ? root._aiForms : null;
    if (!bag || !requestId || !bag[requestId] || typeof root.update !== 'function') return false;
    const row = saved && typeof saved === 'object' ? saved : {};
    const clean = {
        id: row.id != null ? String(row.id) : '',
        title: row.title ? String(row.title) : '',
        meta: row.meta ? String(row.meta) : '',
        route: typeof row.route === 'string' && row.route.startsWith('/') ? row.route : null
    };
    root.update({
        _aiForms: {
            ...bag,
            [requestId]: {
                status: 'saved',
                saved: clean
            }
        }
    }, {
        preventFetch: true
    });
    try {
        this.call('assistantFormSavedStore', {
            [requestId]: clean
        });
    } catch (_) {
    /* best-effort: the session keeps it */ }
    return true;
};
const $578352dfcf062030$export$89f8828f4eeb8c1c = function assistantFormSavedRows(s) {
    const state = this.call('assistantFormState', s);
    if (!state || state.status !== 'saved' || !state.saved) return [];
    const r = state.saved;
    return [
        {
            key: r.id || 'saved',
            title: r.title || String(this.call('polyglot', 'workspace.assistantBlock.formSaved')),
            meta: r.meta,
            icon: 'check',
            ...r.route ? {
                open: {
                    call: 'assistantFormOpenSaved',
                    arg: r.route
                }
            } : {}
        }
    ];
};
const $578352dfcf062030$export$61aff548306d009 = function assistantFormOpenSaved(route) {
    if (typeof route !== 'string' || !route.startsWith('/')) return false;
    this.call('openInSlot', route, this);
    return true;
};
const $578352dfcf062030$export$e62c7d637680d436 = function assistantFormAction(s) {
    const state = this.call('assistantFormState', s);
    if (state && state.status === 'saved') return '';
    return String(this.call('polyglot', state && state.status === 'open' ? 'workspace.assistantBlock.formReopen' : 'workspace.assistantBlock.formReview'));
};
const $578352dfcf062030$export$d601c6c10ef5517f = function assistantFormStatusText(s) {
    const state = this.call('assistantFormState', s);
    return String(this.call('polyglot', state && state.status === 'saved' ? 'workspace.assistantBlock.formSaved' : 'workspace.assistantBlock.formHint'));
};

});

parcelRegister("gtYd7", function(module, exports) {

$parcel$export(module.exports, "assistantOpenSiteBuilder", () => $bffe0f545b9fdeb6$export$fa9c2f8a933b1382);
// assistantOpenSiteBuilder(text, opts) — a WEBSITE ask, sent from the site
// builder (Nika 2026-10-28: "building websites should … work like lovable").
// The ask router (functions/assistantAskRoute.js) hands a 'website' intent
// here; every other ask keeps its own path.
//
//   • A site on screen (the builder at /preview, or a pane showing it —
//     preview functions/previewSite.js previewSiteInView): the ask is a
//     normal send. The transport names that site to the agent per send.
//   • No site on screen: the builder opens first, in its "Setting up your
//     site…" state, and the ask is sent. The first project write the agent
//     makes points the builder at the new site (previewAfterAiWrite).
//
// The ONE chat is the shell assistant, docked beside the builder for the
// session (functions/assistantDock.js promoteAssistantDockForOpen) — no
// placement preference is written. `opts` (optional):
//   images    the composer's image bag (sendPrompt's third slot)
//   attached  the turn's structured attachment (`{ refs?, canvas? }`)
//   mode      this ask's own output mode
//   event     the opening click (⌘ / Ctrl: the builder opens in a split)
// Returns true when the ask was sent, false when there was nothing to send.
function $bffe0f545b9fdeb6$export$fa9c2f8a933b1382(text, opts) {
    const el = this;
    const root = el && el.state && el.state.root;
    const ask = typeof text === 'string' ? text.trim() : '';
    if (!root || typeof root.update !== 'function' || !ask) return false;
    const o = opts && typeof opts === 'object' ? opts : {};
    if (!el.call('previewSiteInView', root)) {
        // No site on screen: a builder that shows none waits for the new site;
        // otherwise the builder opens for it — never on a previous site's
        // carrier (`_previewParams`, the Studio sidebar's).
        const shown = el.call('previewBuilderOnScreen', root);
        if (!shown) root.update({
            _previewParams: null
        });
        root.update({
            _previewSiteStatus: 'setup',
            _previewSiteStep: null
        });
        if (!shown) {
            const e = o.event;
            el.call('openAppPage', '/preview', e && (e.metaKey || e.ctrlKey) ? {
                split: true
            } : undefined);
        }
    }
    // The chat opens beside the builder (an open drawer stays as it is).
    if (!root.assistantOpen) root.update({
        assistantOpen: true,
        _homeThreadOpen: false
    });
    el.call('sendPrompt', ask, undefined, o.images, o.attached, o.mode ? {
        mode: o.mode
    } : undefined);
    return true;
}

});

parcelRegister("2NBeW", function(module, exports) {

$parcel$export(module.exports, "assistantViewListLoad", () => $209d0b719161847f$export$42ab60b2417c96c3);
$parcel$export(module.exports, "assistantViewListModel", () => $209d0b719161847f$export$a0c1439440d71d0a);
$parcel$export(module.exports, "assistantViewListEmpty", () => $209d0b719161847f$export$1024379899bc13dd);
$parcel$export(module.exports, "assistantViewRow", () => $209d0b719161847f$export$d0957c8f29917cfe);
$parcel$export(module.exports, "assistantViewGroup", () => $209d0b719161847f$export$c456b60cec8c33df);
// THE LIST FRAME'S FUNCTIONS — components/AssistantViewList.js, the one
// read-only frame the built-in comms views mount (team, notifications,
// reminders, calls, a transcript, a chat channel, mail, a note).
//
//   assistantViewListLoad   the view's read (`viewLoad`), once per params,
//                           into the frame's OWN state
//   assistantViewListModel  the view's model (`viewModel`) over that read,
//                           normalised; null while reading
//   assistantViewListEmpty  the views contract's `empty`
//   assistantViewRow        a HomeWidgetRow item with every key it reads set
//   assistantViewGroup      one labelled list of rows
//
// Frank note: el.call serializes each export on its own (FA204) — every
// export here is self-contained.
// Run the view's read once per params. The loader answers `{ data, failed }`;
// a loader that throws is a failed read. A newer params set wins over a late
// answer to an older one.
async function $209d0b719161847f$export$42ab60b2417c96c3(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const name = typeof host.viewLoad === 'string' ? host.viewLoad : '';
    if (!name) return null;
    const params = host.scope && host.scope.params || {};
    let sig = name;
    try {
        sig += ':' + JSON.stringify(params);
    } catch (_) {
        sig += ':?';
    }
    if (host.__assistantViewSig === sig) return null;
    host.__assistantViewSig = sig;
    let res = null;
    try {
        res = await host.call(name, host, params);
    } catch (err) {
        console.warn('[assistantViewList] read failed:', name, err && err.message);
        res = {
            data: null,
            failed: true
        };
    }
    if (host.__assistantViewSig !== sig) return null;
    const data = res && typeof res === 'object' && res.data != null ? res.data : {};
    // Frozen: the read is ONE leaf value for the state store (signal
    // store.js isLeafValue) — never a nested store per message or per person;
    // the models only read it, and a new read replaces it whole.
    host.state.update({
        viewData: typeof data === 'object' ? Object.freeze(data) : {},
        viewFailed: !!(res && res.failed)
    });
    return res;
}
function $209d0b719161847f$export$a0c1439440d71d0a(frame, s) {
    const host = frame || this;
    const st = s || host && host.state;
    if (!host || !st || typeof host.call !== 'function') return null;
    const name = typeof host.viewModel === 'string' ? host.viewModel : '';
    if (!name || st.viewData == null) return null;
    st.root && st.root.lang;
    const params = host.scope && host.scope.params || {};
    let m = null;
    try {
        m = host.call(name, st.viewData, params, !!st.viewFailed);
    } catch (err) {
        console.warn('[assistantViewList] model failed:', name, err && err.message);
        return {
            lead: '',
            groups: [],
            body: '',
            note: 'workspace.assistantBlock.viewFailed',
            more: null
        };
    }
    if (!m || typeof m !== 'object') return null;
    const text = (v)=>typeof v === 'string' ? v.trim() : '';
    const groups = (Array.isArray(m.groups) ? m.groups : []).filter((g)=>g && Array.isArray(g.groupRows) && g.groupRows.length);
    // `more`: { shown, total } — N of a known total; { shown, open: true } — a
    // list with a next page whose total the read does not know.
    let more = null;
    if (m.more && typeof m.more === 'object') {
        const shown = Number(m.more.shown);
        const total = m.more.total == null ? null : Number(m.more.total);
        if (shown > 0 && total != null && total > shown) more = {
            shown: shown,
            total: total
        };
        else if (shown > 0 && total == null && m.more.open === true) more = {
            shown: shown,
            total: null
        };
    }
    return {
        lead: text(m.lead),
        groups: groups,
        body: text(m.body),
        note: text(m.note),
        more: more
    };
}
function $209d0b719161847f$export$1024379899bc13dd(frame, s) {
    const host = frame || this;
    const m = host && typeof host.call === 'function' ? host.call('assistantViewListModel', host, s) : null;
    if (!m) return null;
    return !m.lead && !m.body && !m.groups.length;
}
function $209d0b719161847f$export$d0957c8f29917cfe(row) {
    const r = row && typeof row === 'object' ? row : {};
    const open = r.open && typeof r.open === 'object' && r.open.call ? r.open : null;
    return {
        key: String(r.key || 'row'),
        title: r.title == null ? '' : String(r.title),
        meta: r.meta == null || r.meta === '' ? null : String(r.meta),
        initials: r.initials ? String(r.initials) : null,
        icon: r.icon ? String(r.icon) : null,
        src: r.src ? String(r.src) : null,
        progress: typeof r.progress === 'number' ? r.progress : null,
        bad: !!r.bad,
        mark: !!r.mark,
        skel: false,
        href: r.href ? String(r.href) : null,
        open: open ? {
            call: String(open.call),
            arg: open.arg === undefined ? null : open.arg
        } : null
    };
}
function $209d0b719161847f$export$c456b60cec8c33df(group) {
    const g = group && typeof group === 'object' ? group : {};
    return {
        key: 'g-' + String(g.key || 'rows').replace(/[^a-zA-Z0-9_-]/g, ''),
        groupLabel: g.label ? String(g.label) : '',
        groupRows: Array.isArray(g.rows) ? g.rows : []
    };
}

});

parcelRegister("8KqSV", function(module, exports) {

$parcel$export(module.exports, "workspaceAiViews", () => $65e779666b4d8300$export$86c1564ac928f2ab);
$parcel$export(module.exports, "teamPeopleAnswerLoad", () => $65e779666b4d8300$export$4536a0fa59d84f0a);
$parcel$export(module.exports, "teamPeopleAnswerModel", () => $65e779666b4d8300$export$2aa20632ba43a674);
$parcel$export(module.exports, "notificationsAnswerLoad", () => $65e779666b4d8300$export$8b93798bd88f69e0);
$parcel$export(module.exports, "notificationsAnswerModel", () => $65e779666b4d8300$export$64aacc387ded6f69);
$parcel$export(module.exports, "notificationsAnswerOpen", () => $65e779666b4d8300$export$8033d7463d4fbe49);
$parcel$export(module.exports, "remindersAnswerLoad", () => $65e779666b4d8300$export$478f08a11d92813a);
$parcel$export(module.exports, "remindersAnswerModel", () => $65e779666b4d8300$export$dda542574efdff8e);
// THE SHELL'S OWN VIEWS IN AN AI ANSWER — the team and its agents, the
// notifications, the reminders (workspace functions/assistantAppViews.js, the
// `views[]` contract; Nika 2026-10-18: "fly should cover all functionality
// that would be possible otherwise"). Every workspace has them — they are the
// shell's, never an installed app's:
//
//   team-people     the workspace's members (who is online now) and its AI
//                   agents — the roster the shell keeps (root.people, the
//                   presence list root.onlineUsers) and the org's agents
//                   (root._agents, else the same sdk.listAgents read). A
//                   member opens their profile; an agent, Team & agents.
//   notifications   the bell's list (listNotifications), unread first; a row
//                   opens what the bell row opens (notificationHrefOf +
//                   openNotificationTarget). Nothing is marked read here.
//   reminders       the reminders app's own groups (reminderGroups: overdue,
//                   today, tomorrow, upcoming, no date, completed) over the
//                   records plane's `reminders` rows, the app's own scope and
//                   filter rules; a row opens Reminders.
//
// Each view is the shared list frame (components/AssistantViewList.js): a
// read into the frame's OWN state, a model of labelled HomeWidgetRow groups.
// Nothing here writes.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $65e779666b4d8300$export$86c1564ac928f2ab() {
    return {
        app: {
            id: 'system/workspace',
            navbar: [
                {
                    label: 'shell.app.workspace',
                    route: '/',
                    icon: 'home'
                }
            ],
            apps: [
                {
                    icon: 'home'
                }
            ]
        },
        fold: null,
        views: [
            {
                id: 'team-people',
                title: 'workspace.teamAnswer.title',
                describe: "The workspace's people and its AI agents, and who is online now; show = everyone, online, members or agents; search = a name, email or role.",
                component: 'TeamPeopleAnswerView',
                icon: 'people',
                hue: 'people',
                size: 'l',
                params: {
                    show: {
                        type: 'enum',
                        values: [
                            'all',
                            'online',
                            'members',
                            'agents'
                        ],
                        labels: {
                            all: 'workspace.teamAnswer.show.all',
                            online: 'workspace.teamAnswer.show.online',
                            members: 'workspace.teamAnswer.show.members',
                            agents: 'workspace.teamAnswer.show.agents'
                        },
                        default: 'all'
                    },
                    search: {
                        type: 'string',
                        describe: 'words in a name, email or position'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 50,
                        default: 24
                    }
                },
                link: {
                    route: '/team-and-agents',
                    query: {}
                }
            },
            {
                id: 'notifications',
                title: 'workspace.notificationsAnswer.title',
                describe: "The member's notifications (the bell), unread first, newest first; show = all, unread, or only this workspace's.",
                component: 'NotificationsAnswerView',
                icon: 'bell',
                hue: 'analytics',
                size: 'l',
                params: {
                    show: {
                        type: 'enum',
                        values: [
                            'all',
                            'unread',
                            'workspace'
                        ],
                        labels: {
                            all: 'workspace.notificationsAnswer.show.all',
                            unread: 'workspace.notificationsAnswer.show.unread',
                            workspace: 'workspace.notificationsAnswer.show.workspace'
                        },
                        default: 'all'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 50,
                        default: 12
                    }
                },
                link: {
                    route: '/inbox',
                    query: {}
                }
            },
            {
                id: 'reminders',
                title: 'workspace.reminders.listTitle',
                describe: "The member's reminders by due day (overdue, today, upcoming, no date, completed); filter = all, today, upcoming or completed; scope = private or shared.",
                component: 'RemindersAnswerView',
                icon: 'clockOutline',
                hue: 'orange',
                size: 'l',
                params: {
                    filter: {
                        type: 'enum',
                        values: [
                            'all',
                            'today',
                            'upcoming',
                            'completed'
                        ],
                        labels: {
                            all: 'workspace.reminders.filter.all',
                            today: 'workspace.reminders.filter.today',
                            upcoming: 'workspace.reminders.filter.upcoming',
                            completed: 'workspace.reminders.filter.completed'
                        },
                        default: 'all'
                    },
                    scope: {
                        type: 'enum',
                        values: [
                            'private',
                            'shared'
                        ],
                        labels: {
                            private: 'workspace.reminders.scope.private',
                            shared: 'workspace.reminders.scope.shared'
                        },
                        default: 'private'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 50,
                        default: 12
                    }
                },
                link: {
                    route: '/reminders',
                    query: {}
                },
                access: {
                    route: '/reminders'
                }
            }
        ]
    };
}
async function $65e779666b4d8300$export$4536a0fa59d84f0a(el) {
    const host = el || this;
    const root = host && host.state && host.state.root || {};
    const sdk = host && host.sdk || (host && host.call ? host.call('getSDK') : null);
    const out = {
        agents: null,
        agentsFailed: false,
        people: null
    };
    const rosterReady = root.peopleLoaded === true || !!root.peopleError || Array.isArray(root.people) && root.people.length > 0;
    const reads = [];
    if (!Array.isArray(root._agents)) {
        const orgId = root.jwtClaims && root.jwtClaims.workspace_org_id;
        if (sdk && typeof sdk.listAgents === 'function' && orgId) reads.push(Promise.resolve().then(()=>sdk.listAgents(orgId)).then((raw)=>{
            const list = Array.isArray(raw) ? raw : raw && raw.data || [];
            // The roster contract's row shape (the home producer's, pages/
            // main.js _loadHomeAgentRoster): the name per language rides as
            // `nameI18n`, resolved where the row is drawn.
            out.agents = list.map((u)=>({
                    id: String(u && (u.username || u.id || u._id) || '').toLowerCase(),
                    name: u && (u.name || u.username) || '',
                    kind: 'agent',
                    avatar: u && u.avatar || null,
                    userId: u && (u.id || u._id) || null,
                    email: u && u.email || null,
                    nameI18n: u && u.metadata && u.metadata.nameI18n || null
                })).filter((a)=>a.userId);
        }).catch(()=>{
            out.agents = [];
            out.agentsFailed = true;
        }));
        else out.agents = [];
    }
    if (!rosterReady && !sdk) out.people = [];
    if (!rosterReady && sdk) {
        const ws = String(root.workspace && (root.workspace.id || root.workspace._id) || '') || null;
        reads.push(Promise.resolve().then(()=>host.call('listOrgMembers', sdk, ws)).then((rows)=>{
            out.people = (Array.isArray(rows) ? rows : []).map((r)=>({
                    userId: r.user_id,
                    email: r.email,
                    name: r.name || r.email || '',
                    avatar: typeof r.avatar === 'string' && /^(https?:|\/)/.test(r.avatar) ? r.avatar : '',
                    initials: host.call('initials', r.name || ''),
                    position: r.position,
                    status: r.status
                }));
        }).catch(()=>{
            out.people = [];
        }));
    }
    await Promise.all(reads);
    const failed = out.agentsFailed && Array.isArray(out.people) && !out.people.length;
    return {
        data: out,
        failed: failed
    };
}
function $65e779666b4d8300$export$2aa20632ba43a674(data, params) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const p = params && typeof params === 'object' ? params : {};
    const say = (key)=>String(el.call('polyglot', key));
    const rosterReady = root.peopleLoaded === true || !!root.peopleError || Array.isArray(root.people) && root.people.length > 0;
    if (!rosterReady && !Array.isArray(d.people)) return null;
    const show = [
        'all',
        'online',
        'members',
        'agents'
    ].includes(p.show) ? p.show : 'all';
    const limit = Math.max(1, Math.min(50, Math.floor(Number(p.limit)) || 24));
    const words = String(p.search || '').toLowerCase().split(/\s+/).filter(Boolean);
    const matches = (...fields)=>{
        const hay = fields.filter(Boolean).map((f)=>String(f).toLowerCase()).join(' ');
        return words.every((w)=>hay.includes(w));
    };
    const lower = (v)=>String(v || '').toLowerCase();
    const me = lower(root.currentUserEmail);
    const myId = String(root.currentUserId || '');
    const online = new Set((Array.isArray(root.onlineUsers) ? root.onlineUsers : []).map((u)=>lower(u && u.email)).filter(Boolean));
    const agents = Array.isArray(d.agents) ? d.agents : Array.isArray(root._agents) ? root._agents : [];
    const agentIds = new Set(agents.map((a)=>String(a && a.userId || '')).filter(Boolean));
    const agentEmails = new Set(agents.map((a)=>lower(a && a.email)).filter(Boolean));
    // Team & agents' own roster rule (canvas pages/team-and-agents.js
    // _visiblePeople): the departed and the read-only drop out — the viewer is
    // always kept; an agent's own user row is listed once, as an agent.
    const roster = rosterReady ? Array.isArray(root.people) ? root.people : [] : Array.isArray(d.people) ? d.people : [];
    const isMe = (x)=>myId && String(x.userId) === myId || me && lower(x.email) === me;
    const people = roster.filter((x)=>x && (isMe(x) || x.status !== 'left' && x.status !== 'inactive') && !agentIds.has(String(x.userId || '')) && !agentEmails.has(lower(x.email)));
    const isOnline = (x)=>!!x.email && online.has(lower(x.email));
    const memberRow = (x)=>{
        const name = x.name || x.email || say('workspace.person.unknown');
        const self = isMe(x);
        return el.call('assistantViewRow', {
            key: 'p-' + String(x.userId || x.email || name).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: name,
            meta: self ? say('workspace.teamAnswer.you') : isOnline(x) ? say('workspace.teamAnswer.online') : x.position || '',
            src: x.avatar || null,
            initials: x.avatar ? null : x.initials || el.call('initials', name) || null,
            open: x.email ? {
                call: 'openProfileModal',
                arg: String(x.email)
            } : {
                call: 'openAppPage',
                arg: '/team-members'
            }
        });
    };
    const agentRow = (a)=>{
        const name = el.call('agentDisplayName', {
            name: a.name,
            metadata: {
                nameI18n: a.nameI18n
            }
        }, root.lang) || a.name || say('workspace.agents.fallbackName');
        return el.call('assistantViewRow', {
            key: 'a-' + String(a.userId || a.id || name).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: name,
            meta: say('workspace.teamAnswer.agent'),
            src: a.avatar || null,
            initials: a.avatar ? null : el.call('initials', name) || null,
            open: {
                call: 'openAppPage',
                arg: '/team-and-agents'
            }
        });
    };
    const byName = (a, b)=>String(a.name || a.email || '').localeCompare(String(b.name || b.email || ''));
    const members = people.filter((x)=>matches(x.name, x.email, x.position)).sort((a, b)=>Number(isOnline(b)) - Number(isOnline(a)) || byName(a, b));
    const bots = agents.filter((a)=>a && matches(a.name, a.email));
    const groups = [];
    let shown = 0;
    let total = 0;
    const put = (key, labelKey, list, toRow)=>{
        total += list.length;
        const rows = list.slice(0, limit).map(toRow);
        shown += rows.length;
        if (rows.length) groups.push(el.call('assistantViewGroup', {
            key: key,
            label: say(labelKey).replace('{count}', String(list.length)),
            rows: rows
        }));
    };
    if (show === 'online') put('online', 'workspace.teamAnswer.group.online', members.filter((x)=>isOnline(x) && !isMe(x)), memberRow);
    else {
        if (show !== 'agents') put('members', 'workspace.teamAnswer.group.members', members, memberRow);
        if (show !== 'members') put('agents', 'workspace.teamAnswer.group.agents', bots, agentRow);
    }
    let note = '';
    if (!groups.length) note = show === 'online' && !words.length ? 'workspace.teamAnswer.noneOnline' : d.agentsFailed && show === 'agents' ? 'workspace.teamAnswer.failed' : 'workspace.teamAnswer.empty';
    return {
        groups: groups,
        note: note,
        more: {
            shown: shown,
            total: total
        }
    };
}
async function $65e779666b4d8300$export$8b93798bd88f69e0(el) {
    const host = el || this;
    let res = null;
    try {
        res = await host.call('listNotifications');
    } catch (_) {
        res = {
            data: [],
            error: true
        };
    }
    const rows = res && Array.isArray(res.data) ? res.data : [];
    const items = rows.filter((n)=>n && typeof n === 'object').map((n)=>({
            id: String(n.id || n._id || ''),
            title: n.title || '',
            body: n.body || '',
            type: n.type || '',
            href: n.href || '',
            metadata: n.metadata && typeof n.metadata === 'object' ? n.metadata : {},
            read: !!n.read,
            at: Date.parse(n.created_at || n.createdAt || '') || 0
        })).sort((a, b)=>b.at - a.at);
    return {
        data: {
            items: items
        },
        failed: !!(res && res.error) && !items.length
    };
}
function $65e779666b4d8300$export$64aacc387ded6f69(data, params, failed) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const p = params && typeof params === 'object' ? params : {};
    const say = (key)=>String(el.call('polyglot', key));
    if (failed) return {
        groups: [],
        note: 'workspace.notificationsAnswer.failed'
    };
    const show = [
        'all',
        'unread',
        'workspace'
    ].includes(p.show) ? p.show : 'all';
    const limit = Math.max(1, Math.min(50, Math.floor(Number(p.limit)) || 12));
    let items = Array.isArray(d.items) ? d.items : [];
    if (show === 'workspace') items = items.filter((n)=>el.call('isCurrentWorkspaceNotification', n, root) !== false);
    const unread = items.filter((n)=>!n.read);
    const earlier = show === 'unread' ? [] : items.filter((n)=>n.read);
    const ICONS = {
        mention: 'chat',
        ticket_assign: 'check',
        calendar_invite: 'date',
        doc_share: 'document',
        system: 'settings',
        channel_message: 'chat',
        channel_missed_call: 'phone'
    };
    const when = (at)=>{
        if (!at) return '';
        const d0 = new Date(at);
        const today = new Date();
        const sameDay = d0.toDateString() === today.toDateString();
        return String(el.call('localizedDate', d0, sameDay ? {
            hour: '2-digit',
            minute: '2-digit'
        } : {
            month: 'short',
            day: 'numeric'
        }) || '');
    };
    const row = (n)=>{
        const body = String(el.call('htmlToPlainText', n.body) || '').trim();
        const meta = n.metadata || {};
        const keep = {};
        for (const k of [
            'kind',
            'calendarEventId',
            'eventId',
            'ticketObjectId',
            'partyId'
        ])if (meta[k] != null) keep[k] = meta[k];
        return el.call('assistantViewRow', {
            key: 'n-' + String(n.id || n.at).replace(/[^a-zA-Z0-9_-]/g, ''),
            title: n.title || body || say('workspace.notificationsAnswer.untitled'),
            meta: when(n.at),
            icon: ICONS[n.type] || 'bell',
            open: {
                call: 'notificationsAnswerOpen',
                arg: {
                    href: n.href,
                    type: n.type,
                    metadata: keep
                }
            }
        });
    };
    const groups = [];
    let budget = limit;
    const unreadRows = unread.slice(0, budget).map(row);
    budget -= unreadRows.length;
    if (unreadRows.length) groups.push(el.call('assistantViewGroup', {
        key: 'unread',
        label: say('workspace.notificationsAnswer.group.unread').replace('{count}', String(unread.length)),
        rows: unreadRows
    }));
    const earlierRows = earlier.slice(0, Math.max(0, budget)).map(row);
    if (earlierRows.length) groups.push(el.call('assistantViewGroup', {
        key: 'earlier',
        label: say('workspace.notificationsAnswer.group.earlier'),
        rows: earlierRows
    }));
    const note = groups.length ? '' : show === 'unread' ? 'workspace.notificationsAnswer.noUnread' : 'workspace.notificationsAnswer.empty';
    return {
        groups: groups,
        note: note,
        more: {
            shown: unreadRows.length + earlierRows.length,
            total: unread.length + earlier.length
        }
    };
}
function $65e779666b4d8300$export$8033d7463d4fbe49(target) {
    const t = target && typeof target === 'object' ? target : null;
    if (!t || typeof this.call !== 'function') return false;
    const notif = {
        href: t.href || '',
        type: t.type || '',
        metadata: t.metadata || {}
    };
    const href = this.call('notificationHrefOf', notif);
    if (!href) return false;
    this.call('openNotificationTarget', {
        ...notif,
        href: href
    }, this);
    return true;
}
async function $65e779666b4d8300$export$478f08a11d92813a(el) {
    const host = el || this;
    const root = host && host.state && host.state.root || {};
    const sdk = host && host.sdk || host.call('getSDK');
    if (!sdk || typeof sdk.execute !== 'function') return {
        data: {
            items: []
        },
        failed: true
    };
    const ws = host.call('reminderScopeWs', root);
    try {
        const res = await sdk.execute('workspaceProject.records', 'list', {
            collection: 'reminders',
            ...ws ? {
                workspaceId: ws
            } : {},
            limit: 100,
            order: 'updated_at'
        });
        const rows = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
        return {
            data: {
                items: rows.map((r)=>host.call('rowToReminder', r))
            }
        };
    } catch (_) {
        return {
            data: {
                items: []
            },
            failed: true
        };
    }
}
function $65e779666b4d8300$export$dda542574efdff8e(data, params, failed) {
    const el = this;
    const root = el && el.state && el.state.root || {};
    const d = data && typeof data === 'object' ? data : {};
    const p = params && typeof params === 'object' ? params : {};
    const items = Array.isArray(d.items) ? d.items : [];
    if (failed && !items.length) return {
        groups: [],
        note: 'workspace.reminders.loadFailed'
    };
    const filter = [
        'all',
        'today',
        'upcoming',
        'completed'
    ].includes(p.filter) ? p.filter : 'all';
    const scope = p.scope === 'shared' ? 'shared' : 'private';
    const limit = Math.max(1, Math.min(50, Math.floor(Number(p.limit)) || 12));
    const sections = el.call('reminderGroups', {
        reminders: items,
        remindersScope: scope,
        _remindersFilter: filter,
        currentUserEmail: root.currentUserEmail
    }) || [];
    const groups = [];
    let budget = limit;
    let shown = 0;
    let total = 0;
    for (const g of sections){
        const list = Array.isArray(g && g.items) ? g.items : [];
        total += list.length;
        const rows = list.slice(0, Math.max(0, budget)).map((r)=>el.call('assistantViewRow', {
                key: 'r-' + String(r.id || r.key || r.title).replace(/[^a-zA-Z0-9_-]/g, ''),
                title: r.title || String(el.call('polyglot', 'workspace.reminders.untitled')),
                meta: r.done ? '' : el.call('reminderDueLabel', r.dueAt) || '',
                icon: r.done ? 'checkmark' : 'clockOutline',
                bad: !!el.call('reminderIsOverdue', r.dueAt, r.done),
                open: {
                    call: 'openAppPage',
                    arg: '/reminders'
                }
            }));
        budget -= rows.length;
        shown += rows.length;
        if (rows.length) groups.push(el.call('assistantViewGroup', {
            key: g.key,
            label: String(el.call('polyglot', g.label)),
            rows: rows
        }));
    }
    return {
        groups: groups,
        note: groups.length ? '' : 'workspace.remindersAnswer.empty',
        more: {
            shown: shown,
            total: total
        }
    };
}

});

parcelRegister("30rQH", function(module, exports) {

$parcel$export(module.exports, "assistantSourceDomain", () => $2306f9699ea4382c$export$a2d19d1d494d9fc0);
$parcel$export(module.exports, "assistantSourcesRows", () => $2306f9699ea4382c$export$5da35c192a889e8c);
$parcel$export(module.exports, "assistantSourcesQuote", () => $2306f9699ea4382c$export$662813b4cbcf3dbd);
$parcel$export(module.exports, "assistantSourcesTitle", () => $2306f9699ea4382c$export$b6b17ffd8d3c03dd);
$parcel$export(module.exports, "assistantSourcesFoot", () => $2306f9699ea4382c$export$14293f0a5b023807);
// WEB SOURCES in an AI answer (U4) — the `sources` card toolEmbedCard builds
// from a web tool's embed (functions/_simone/toolEmbed.js): search results as
// SOURCE CARDS (title, domain, snippet — each a real link to its page) and a
// fetched page as a QUOTE with its source. Drawn by AssistantThreadBlock
// (BlockSources) with AssistantSourceCard.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
// The host a reader recognises: "colliers.com", never "www.colliers.com".
const $2306f9699ea4382c$export$a2d19d1d494d9fc0 = function assistantSourceDomain(url) {
    const m = /^https?:\/\/([^/?#:]+)/i.exec(String(url || ''));
    return m ? m[1].toLowerCase().replace(/^www\./, '') : '';
};
const $2306f9699ea4382c$export$5da35c192a889e8c = function assistantSourcesRows(s) {
    const x = s && typeof s === 'object' ? s : {};
    if (x.type !== 'sources' || !Array.isArray(x.sources)) return [];
    if (x.text && x.sources.length === 1) return [];
    return x.sources.map((src)=>{
        const domain = this.call('assistantSourceDomain', src.url);
        return {
            key: src.url,
            title: src.title || domain,
            domain: domain,
            snippet: src.snippet || '',
            url: src.url
        };
    });
};
const $2306f9699ea4382c$export$662813b4cbcf3dbd = function assistantSourcesQuote(s) {
    const x = s && typeof s === 'object' ? s : {};
    if (x.type !== 'sources' || !x.text || !Array.isArray(x.sources) || x.sources.length !== 1) return null;
    const src = x.sources[0];
    const domain = this.call('assistantSourceDomain', src.url);
    return {
        text: String(x.text),
        title: src.title || domain,
        domain: domain,
        url: src.url
    };
};
const $2306f9699ea4382c$export$b6b17ffd8d3c03dd = function assistantSourcesTitle(s) {
    const x = s && typeof s === 'object' ? s : {};
    const quote = this.call('assistantSourcesQuote', x);
    if (quote) return String(this.call('polyglot', 'workspace.assistantBlock.sourcesPage')).replace('{domain}', quote.domain);
    if (x.query) return String(this.call('polyglot', 'workspace.assistantBlock.sourcesQuery')).replace('{query}', x.query);
    return String(this.call('polyglot', 'workspace.assistantBlock.sourcesTitle'));
};
const $2306f9699ea4382c$export$14293f0a5b023807 = function assistantSourcesFoot(s) {
    const x = s && typeof s === 'object' ? s : {};
    const n = Array.isArray(x.sources) ? x.sources.length : 0;
    return String(this.call('polyglot', n === 1 ? 'workspace.assistantBlock.sourcesFootOne' : 'workspace.assistantBlock.sourcesFoot')).replace('{count}', String(n));
};

});

parcelRegister("jGgpa", function(module, exports) {

$parcel$export(module.exports, "homeSummaryAiKey", () => $e53eaa3990db4360$export$283284c2d175cfc8);
$parcel$export(module.exports, "homeSummaryAiState", () => $e53eaa3990db4360$export$49c9335b5c48983a);
$parcel$export(module.exports, "homeSummaryAiEnsure", () => $e53eaa3990db4360$export$dd6aa302a0dbd5a);
$parcel$export(module.exports, "homeSummaryAiBrief", () => $e53eaa3990db4360$export$f3c0e9b12e341e00);
$parcel$export(module.exports, "homeSummaryAiChips", () => $e53eaa3990db4360$export$3b6ab692b0b83d09);
// homeSummaryAi.js — THE AI SOURCE of the Brief at the top of the home
// (AI_ASSISTANT_SPEC v1 §7 "the AI summary at the top of the home reads
// signals + vocabulary"; HOME_SIGNALS_CONTRACT v1 §2 rule 8; DESIGN-WL-
// ASSISTANT-MAIN-VIEW-1). The server half is lane current-23-aib:
//   sdk.execute('ai.boards', 'summary', { workspaceId, signals, locale, hour })
//     → { text, chips: [{ signalId, label, count, href }], generatedAt }
// where `signals` are the HOME_SIGNALS the shell collected (counts only), the
// chips are the server's deterministic top signals and every number in the
// text is guarded against the input counts.
//
// THE SWITCH: the Brief reads the AI answer when it lands within 800 ms of the
// signals settling; while it is in flight the Brief holds its skeleton; a
// slower answer, a failure or a service not there yet leaves the Brief on the
// deterministic template (functions/homeSummaryCompose.js) — and it stays on
// the template for those signals (no flip under the reader's eyes). A service
// that is not there is not asked again in this workspace this session.
// One answer per workspace + language + signals (a hash of id:count).
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained.
// The key of one ask: the workspace, the language and the signals' counts.
const $e53eaa3990db4360$export$283284c2d175cfc8 = function homeSummaryAiKey(root, list) {
    const r = root && typeof root === 'object' ? root : {};
    const w = r.workspace;
    const ws = w && String(w.id || w._id || '') || '';
    const lang = String(r.lang || 'en');
    const sig = (Array.isArray(list) ? list : []).map((s)=>s && s.id ? String(s.id) + ':' + String(s.count) : '').filter(Boolean).join('|');
    let h = 0x811c9dc5;
    for(let i = 0; i < sig.length; i++){
        h ^= sig.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return ws + ':' + lang + ':' + (h >>> 0).toString(36);
};
const $e53eaa3990db4360$export$49c9335b5c48983a = function homeSummaryAiState(root, list) {
    const r = root && typeof root === 'object' ? root : {};
    const cur = r._homeSummaryAi;
    if (!cur || typeof cur !== 'object') return null;
    const key = this.call('homeSummaryAiKey', r, list);
    return cur.key === key ? cur : null;
};
const $e53eaa3990db4360$export$dd6aa302a0dbd5a = function homeSummaryAiEnsure(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r || typeof r.update !== 'function') return null;
    const look = this.call('homeLookRead', r) || {};
    if (look.summaryStyle !== 'brief') return null;
    const view = this.call('homeSignalsView', r);
    const list = view && Array.isArray(view.list) ? view.list : [];
    if (!view || view.waiting || !list.length) return null;
    const key = this.call('homeSummaryAiKey', r, list);
    const cur = r._homeSummaryAi;
    if (cur && cur.key === key) return cur;
    const w = r.workspace;
    const ws = w && String(w.id || w._id || '') || '';
    // A service that is not there is not asked again in this workspace.
    if (cur && cur.status === 'unavailable' && cur.ws === ws) {
        r.update({
            _homeSummaryAi: {
                ...cur,
                key: key
            }
        }, {
            preventFetch: true
        });
        return r._homeSummaryAi;
    }
    const sdk = this.sdk || this.context && this.context.sdk || this.call('getSDK');
    if (!sdk || typeof sdk.execute !== 'function') {
        r.update({
            _homeSummaryAi: {
                key: key,
                ws: ws,
                status: 'unavailable'
            }
        }, {
            preventFetch: true
        });
        return r._homeSummaryAi;
    }
    const signals = list.map((s)=>({
            id: s.id,
            app: s.app,
            kind: s.kind,
            count: s.count,
            severity: s.severity,
            label: {
                ...s.label || {},
                text: this.call('homeSignalsText', s)
            },
            ...s.href ? {
                href: s.href
            } : {}
        }));
    r.update({
        _homeSummaryAi: {
            key: key,
            ws: ws,
            status: 'loading',
            at: Date.now()
        }
    }, {
        preventFetch: true
    });
    const land = (patch)=>{
        const now = r._homeSummaryAi;
        if (!now || now.key !== key || now.status !== 'loading') return;
        r.update({
            _homeSummaryAi: {
                ...now,
                ...patch
            }
        }, {
            preventFetch: true
        });
    };
    const timer = setTimeout(()=>land({
            status: 'slow'
        }), 800);
    Promise.resolve().then(()=>sdk.execute('ai.boards', 'summary', {
            ...ws ? {
                workspaceId: ws
            } : {},
            signals: signals,
            locale: String(r.lang || 'en'),
            hour: new Date().getHours()
        })).then((res)=>{
        clearTimeout(timer);
        const text = res && typeof res.text === 'string' ? res.text.trim() : '';
        if (!text) return land({
            status: 'failed'
        });
        land({
            status: 'ready',
            text: text,
            chips: Array.isArray(res.chips) ? res.chips.slice(0, 5) : [],
            generatedAt: res.generatedAt ? Date.parse(res.generatedAt) || Date.now() : Date.now()
        });
    }, (err)=>{
        clearTimeout(timer);
        const msg = String(err && err.message || err || '');
        land({
            status: /unknown entity|does not support|unknown method|unknown op|not found on service|is not available/i.test(msg) ? 'unavailable' : 'failed'
        });
    });
    return r._homeSummaryAi;
};
const $e53eaa3990db4360$export$f3c0e9b12e341e00 = function homeSummaryAiBrief(state) {
    if (!state || state.status !== 'ready' || !state.text) return [];
    return [
        [
            {
                key: 'ai-text',
                text: state.text
            }
        ]
    ];
};
const $e53eaa3990db4360$export$3b6ab692b0b83d09 = function homeSummaryAiChips(state, list) {
    if (!state || state.status !== 'ready' || !state.text) return [];
    const signals = Array.isArray(list) ? list : [];
    const out = [];
    for (const c of Array.isArray(state.chips) ? state.chips : []){
        const sig = signals.find((s)=>s && c && s.id === c.signalId);
        if (sig && !out.includes(sig)) out.push(sig);
    }
    return out;
};

});

parcelRegister("ioeg9", function(module, exports) {

$parcel$export(module.exports, "assistantLatestAnswerId", () => $d6358780783ac6f1$export$bc41fc4254adbe4a);
$parcel$export(module.exports, "assistantAnswerPopoverFor", () => $d6358780783ac6f1$export$86e81359c03b79d0);
$parcel$export(module.exports, "assistantAnswerPopoverDismiss", () => $d6358780783ac6f1$export$76a4a64c3351b52f);
$parcel$export(module.exports, "assistantAnswerToMain", () => $d6358780783ac6f1$export$87d08e9da39e1a4a);
$parcel$export(module.exports, "assistantAnswerToSidebar", () => $d6358780783ac6f1$export$5c7124dca38cef7c);
$parcel$export(module.exports, "assistantAnswerPopoverShortcuts", () => $d6358780783ac6f1$export$5648f985785c9c9f);
// assistantAnswerPopover.js — THE LANDED ANSWER ON THE MINIMIZED ISLAND
// (AI_ASSISTANT_SPEC v1 §1 "minimized — the bottombar only; an answer offers
// 'Open in main' / 'Open in sidebar'"; DESIGN-WL-ASSISTANT-MAIN-VIEW-1).
//
// While the reasoning pill (shared _simone/ReasoningPill.js) is the thread's
// handle, an answer that LANDS (the turn settles) turns its head row into
// "Answer ready" with the two moves: Open in main (the SAME thread in the main
// area of any page, §12.2) and Open in sidebar (the drawer). It never says so
// by itself: only an answer that arrived after the island mounted counts (a
// reload's restored thread does not), once per answer; Esc, ✕, an outside
// press and either move dismiss it.
//
// 2026-10-28 (Nika: "in minimized mode, captions should be like bubble and
// should not resize ai navbar"): these rules used to drive a SECOND capsule —
// components/AssistantAnswerPopover.js, a glass popover measured and stacked
// over the pill — and they now drive the island's own head. The names keep
// their history; `assistantAnswerPopoverBottom` (the stacking measure) left
// with the capsule.
//
// Frank note: el.call serializes each registered export on its own (FA204),
// so every export here is self-contained.
// The newest settled assistant answer's id, or null while a turn runs.
const $d6358780783ac6f1$export$bc41fc4254adbe4a = function assistantLatestAnswerId(root) {
    const r = root && typeof root === 'object' ? root : {};
    const list = Array.isArray(r.chatMessages) ? r.chatMessages : [];
    const typing = !!r.chatTyping;
    if (typing) return null;
    for(let i = list.length - 1; i >= 0; i--){
        const m = list[i];
        if (!m || typeof m !== 'object') continue;
        if (m.role === 'user') return null;
        // a setup note (the first thread's plan and summary) is no answer
        if (m.metadata && m.metadata.kind === 'note') continue;
        if (m.role === 'assistant' && !m.local) return m.streaming ? null : String(m.id || 'm' + i);
    }
    return null;
};
const $d6358780783ac6f1$export$86e81359c03b79d0 = function assistantAnswerPopoverFor(root, baseline) {
    const r = root && typeof root === 'object' ? root : {};
    const minimized = !!r.assistantOpen && r.assistantDock === 'minimized';
    const slot = !r.assistantOpen && !!r._assistantPillHandle;
    const dismissed = r._aiAnswerPopoverDismissed;
    const id = this.call('assistantLatestAnswerId', r);
    if (!minimized && !slot || !id) return null;
    if (id === baseline || id === dismissed) return null;
    return id;
};
const $d6358780783ac6f1$export$76a4a64c3351b52f = function assistantAnswerPopoverDismiss() {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    const id = this.call('assistantLatestAnswerId', root);
    if (!id || root._aiAnswerPopoverDismissed === id) return false;
    root.update({
        _aiAnswerPopoverDismissed: id
    }, {
        preventFetch: true
    });
    return true;
};
const $d6358780783ac6f1$export$87d08e9da39e1a4a = function assistantAnswerToMain() {
    this.call('assistantAnswerPopoverDismiss');
    return !!this.call('assistantThreadToMain');
};
const $d6358780783ac6f1$export$5c7124dca38cef7c = function assistantAnswerToSidebar() {
    const root = this && this.state && this.state.root;
    if (!root || typeof root.update !== 'function') return false;
    this.call('assistantAnswerPopoverDismiss');
    const patch = {
        assistantOpen: true,
        _homeThreadOpen: false
    };
    if (root.assistantOpen && root.assistantDock === 'minimized') patch.assistantDock = 'right';
    root.update(patch);
    return true;
};
const $d6358780783ac6f1$export$5648f985785c9c9f = function assistantAnswerPopoverShortcuts(el) {
    const view = el || this;
    if (!view || typeof view.call !== 'function') return ()=>false;
    view.call('listShortcuts');
    const off = view.call('registerShortcut', {
        id: 'assistantAnswerPopoverClose',
        keys: 'escape',
        label: 'workspace.assistantPopover.close',
        group: 'shell.headerTabs.dashboard',
        groupOrder: 3,
        order: 9,
        when: (h, root)=>{
            const node = view.node;
            if (!node || node.isConnected === false) return false;
            if (typeof node.getClientRects === 'function' && node.getClientRects().length === 0) return false;
            return !!view.call('assistantAnswerPopoverFor', root, view.__answerBaseline);
        },
        run: ()=>view.call('assistantAnswerPopoverDismiss')
    });
    const stop = ()=>typeof off === 'function' ? !!off() : false;
    view.__popoverShortcutsOff = stop;
    return stop;
};

});

parcelRegister("iU3AQ", function(module, exports) {

$parcel$export(module.exports, "homeCompactNumber", () => $dc303e7eca121856$export$1559c301ad587826);
$parcel$export(module.exports, "homeMoney", () => $dc303e7eca121856$export$f6113ac3952e7fb2);
// The home widgets' numerals (HOME_WIDGETS_SPEC.md §2 "Hero", DESIGN_SPEC L43):
// compact by contract, so a hero never needs an ellipsis.
//
//   homeCompactNumber(3420)          → '3,420'   (a count stays exact below 10K)
//   homeCompactNumber(48213)         → '48.2K'
//   homeCompactNumber(86_900_000)    → '86.9M'
//   homeMoney(1234.5, 'usd')         → 'USD 1.2K' (money compacts from 1K)
//   homeMoney(64638, 'GEL')          → 'GEL 64.6K'
//
// Grouping and the compact suffixes are en-US on purpose — the house money
// rule (the ISO code word + the number, never a symbol) and one notation on
// every board, whatever the session language. The code and the amount are
// joined by a no-break space, so the code never wraps away from its number.
const $dc303e7eca121856$export$1559c301ad587826 = function homeCompactNumber(value, threshold) {
    if (value === null || value === undefined || value === '') return '';
    const n = Number(value);
    if (!Number.isFinite(n)) return '';
    const from = Number(threshold) > 0 ? Number(threshold) : 10000;
    const opts = Math.abs(n) >= from ? {
        notation: 'compact',
        maximumFractionDigits: 1
    } : {
        maximumFractionDigits: Math.abs(n) < 10 && n % 1 ? 1 : 0
    };
    try {
        return new Intl.NumberFormat('en-US', opts).format(n);
    } catch (_) {
        return String(Math.round(n));
    }
};
const $dc303e7eca121856$export$f6113ac3952e7fb2 = function homeMoney(value, currency) {
    const s = String(currency == null ? '' : currency).trim();
    const code = /^[a-z]{3}$/i.test(s) ? s.toUpperCase() : s;
    const amount = $dc303e7eca121856$export$1559c301ad587826(value, 1000);
    if (!amount) return '';
    return code ? code + "\xa0" + amount : amount;
};

});

parcelRegister("fXdfQ", function(module, exports) {

$parcel$export(module.exports, "registerShortcut", () => $b9d6a5c1fb248e86$export$d098d867a667bb1f);
$parcel$export(module.exports, "shortcutBlockReason", () => $b9d6a5c1fb248e86$export$aa35489fe7d4a686);
$parcel$export(module.exports, "handleShortcutKeydown", () => $b9d6a5c1fb248e86$export$56748fc880b42d7);
$parcel$export(module.exports, "listShortcuts", () => $b9d6a5c1fb248e86$export$553d0b991490338b);
$parcel$export(module.exports, "shortcutSheetGroups", () => $b9d6a5c1fb248e86$export$cb426a62ec6282ab);
$parcel$export(module.exports, "runShortcut", () => $b9d6a5c1fb248e86$export$dbcf7143923947af);
// THE SHELL KEYBOARD REGISTRY — one registry, one keydown handler, one guard,
// one off switch (HOME_AMBIENT_SKIN_SPEC §5 · DESIGN-WL-SHELL-KEYBOARD-MOTION-1).
//
//   el.call('registerShortcut', { id, keys, seq, label, group, when, run })
//                                            → unregister(): boolean
//   el.call('listShortcuts')                 → rows for the ? sheet and the palette
//   el.call('shortcutSheetGroups')           → the sheet's rows, grouped (live keys only)
//   el.call('handleShortcutKeydown', el, s, event)
//                                            → true when a binding took the key
//   el.call('runShortcut', id)               → run one row's command (the palette)
//   el.call('shortcutBlockReason', el, s, event, kind)
//                                            → why the guard refuses, or null
//
// A BINDING. `keys` is a chord string or an array of alternatives — 'mod+k',
// '/', '?', 'j', 'escape', ['1', …, '9']; `mod` is ⌘ or Ctrl (either one, on
// every platform — the HeaderSearch rule). `seq` is a sequence, ['g', 'h'],
// whose keys must follow each other inside 1.5 s. `when(el, s)` gates it on
// live state; `run(el, s, event)` performs it and may return `false` to
// decline (the key then stays the browser's, and an older binding for the same
// key may take it). `label` / `group` are bundle KEYS — the sheet and the
// palette resolve them through polyglot. `adopted` names the component that
// already owns the key: the row is LISTED (sheet, palette) and never run here,
// so a key is never bound twice. `repeat: true` lets a held key walk.
// Re-registering an id replaces the binding; the most recent registration of a
// key wins, so a surface's own binding layers over the shell's.
//
// THE KINDS the guard reads: `chord` (carries ⌘/Ctrl/Alt), `char` (one
// printable character), `seq` (a sequence), `named` (Escape, Enter).
//
// THE GUARD (spec §5 "Guard") — `shortcutBlockReason`:
//   • a keystroke already handled by its surface (`defaultPrevented`) is never
//     handled again — mail's page keys, a card's Enter, a dialog's Escape win;
//   • an IME composition (`isComposing`, keyCode 229 — Georgian/CJK) runs
//     nothing;
//   • ⌘ / Ctrl / Alt held: only chords run (never shadows ⌘1–9, ⌘L, Ctrl+J);
//   • focus in a field — input, textarea, select, [contenteditable], role
//     textbox / combobox / searchbox — only chords run;
//   • an OPEN OVERLAY owns the keyboard, and nothing runs. The shell exposes
//     "an overlay is open" through these carriers (read, never written here):
//       – focus inside [role=dialog] / [role=alertdialog] / [aria-modal=true] /
//         [role=menu] / [role=listbox] — AppDialog v2's Panel, the legacy
//         Modal Window, the windows ModalWindow, house menus and listboxes
//         (every one moves focus in when it opens);
//       – a DISPLAYED non-kit modal with focus OUTSIDE it — [aria-modal=true]
//         (the marketplace detail; no [data-open] root required — the slot
//         signal is html[data-slot]): its own handler closes it, the shell
//         waits;
//       – the windows ModalRoot stack  — shellRoot.ModalRoot.state.stack;
//       – the DropdownRoot layer       — shellRoot.DropdownRoot.state.layer;
//       – the house context menu       — root.contextDropdown;
//       – the widget colour palette    — root._homeColorPicker;
//       – this registry's own ? sheet   — root._shortcutsSheetOpen;
//       – the header search            — root._headerSearchOpen;
//       – the header drawers           — root._chatDrawerOpen,
//         root._mailDrawerOpen, root.notificationsPanelOpen
//         (shared/components/headerOverlayState.js; the assistant is DOCKED
//         beside the page, not over it, so it blocks nothing).
//     A PageSlot app window is NOT an overlay here: it is a surface, and the
//     board bindings that it covers check `_canvasSlot` themselves.
//
// TWO SWITCHES:
//   • the WORKSPACE switch — the `shell.keyboardShortcuts` feature flag
//     (shared/functions/featureFlagsData.js FEATURE_SUBFLAGS.shell). Off: the
//     registry stands down;
//   • the PERSON's switch (WCAG 2.1.4 Character Key Shortcuts) — the user
//     preference `shortcutsSingleKeys === false` on `root.userPrefs` (the flat
//     user_preferences row `themeMode` lives on; the Settings › Accessibility
//     row that writes it is ws-w2's). Off: `char` and `seq` stop; chords stay.
//   Escape and Enter are not character keys — dismissal and activation — so
//   neither switch silences a `named` binding. Both switches silence
//   KEYSTROKES only: `runShortcut` (a palette pick) is a command, not a key.
//
// STORAGE. The registry lives on the shell ROOT element (`__shortcuts`), never
// in module scope: every export here is serialized ALONE for platform delivery
// (frank), so none of them may lean on a module-scope binding or helper — each
// carries its own small readers (the house rule, shared/functions/themeMode.js).
//
// DEFAULTS are armed lazily, on the first key or listing (`registerDefaultShortcuts`,
// functions/shortcutsDefault.js), so the shell's one listener (the shell
// root's declared `onDocumentKeydown`, app.js) stays ONE call.
function $b9d6a5c1fb248e86$export$d098d867a667bb1f(def) {
    const origin = this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    if (!host || !def || !def.id) return ()=>false;
    const store = host.__shortcuts || (host.__shortcuts = {
        list: [],
        pending: null,
        armed: false,
        last: null
    });
    const NAMED = {
        esc: 'escape',
        escape: 'escape',
        enter: 'enter',
        return: 'enter',
        space: ' '
    };
    const parse = (chord)=>{
        const parts = String(chord).toLowerCase().split('+');
        const key = parts.pop();
        const mods = new Set(parts);
        return {
            key: NAMED[key] || key,
            mod: mods.has('mod') || mods.has('cmd') || mods.has('meta') || mods.has('ctrl'),
            alt: mods.has('alt') || mods.has('option'),
            shift: mods.has('shift')
        };
    };
    const keys = def.keys == null ? [] : Array.isArray(def.keys) ? def.keys : [
        def.keys
    ];
    const alts = keys.map(parse);
    const seq = Array.isArray(def.seq) && def.seq.length ? def.seq.map((k)=>parse(k).key) : null;
    const kind = seq ? 'seq' : alts.some((a)=>a.mod || a.alt) ? 'chord' : alts.length && alts.every((a)=>a.key.length === 1) ? 'char' : 'named';
    const rec = {
        id: String(def.id),
        label: def.label || null,
        group: def.group || null,
        groupOrder: typeof def.groupOrder === 'number' ? def.groupOrder : 0,
        order: typeof def.order === 'number' ? def.order : store.list.length,
        alts: alts,
        seq: seq,
        kind: kind,
        when: typeof def.when === 'function' ? def.when : null,
        run: typeof def.run === 'function' ? def.run : null,
        repeat: !!def.repeat,
        adopted: def.adopted || null,
        keycaps: Array.isArray(def.keycaps) ? def.keycaps.map(String) : null,
        joiner: def.joiner || (seq ? 'then' : null)
    };
    const at = store.list.findIndex((r)=>r.id === rec.id);
    if (at >= 0) store.list.splice(at, 1);
    store.list.push(rec);
    return ()=>{
        const i = store.list.indexOf(rec);
        if (i < 0) return false;
        store.list.splice(i, 1);
        return true;
    };
}
function $b9d6a5c1fb248e86$export$aa35489fe7d4a686(el, s, event, kind) {
    const origin = el || this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    const st = s || host && host.state;
    const root = st && st.root || st || {};
    const e = event || null;
    const t = e && e.target;
    // The keystroke itself first — the cheap reads, and the ones every keypress
    // typed into a field reaches.
    if (e) {
        if (e.isComposing || e.keyCode === 229) return 'composing';
        if (kind !== 'chord' && (e.metaKey || e.ctrlKey || e.altKey)) return 'modifier';
        if (kind !== 'chord' && t && t.nodeType === 1) {
            const tag = String(t.tagName || '').toLowerCase();
            const attr = (name)=>typeof t.getAttribute === 'function' ? t.getAttribute(name) : null;
            const editable = attr('contenteditable');
            const role = attr('role');
            if (t.isContentEditable || tag === 'input' || tag === 'textarea' || tag === 'select' || editable !== null && editable !== 'false' || role === 'textbox' || role === 'combobox' || role === 'searchbox') return 'field';
        }
    }
    // The two switches.
    if (kind !== 'named') {
        let on = true;
        try {
            on = !host || typeof host.call !== 'function' || host.call('featureEnabled', root, 'shell.keyboardShortcuts') !== false;
        } catch (_) {
            on = true;
        }
        if (!on) return 'flag';
    }
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    if ((kind === 'char' || kind === 'seq') && prefs && prefs.shortcutsSingleKeys === false) return 'offSwitch';
    if (!e) return null;
    // The overlay carriers — see the file header for what each one is.
    if (t && typeof t.closest === 'function' && t.closest('[role="dialog"],[role="alertdialog"],[aria-modal="true"],[role="menu"],[role="listbox"]')) return 'overlay:focus';
    // The shell's ONE overlay reader (shared functions/shellOverlayOpen.js),
    // through the calling element's registry — the guard is always called as
    // `host.call('shortcutBlockReason', host, …)`, so `origin` is that element.
    // The assistant's MAIN LAYER over a page ('mainThread', AI_ASSISTANT_SPEC
    // §12.2) is a layer over the PAGE, not over the shell: this registry is the
    // shell's own and sits above it (`/` still reaches the composer the thread
    // answers through, the layer's own Esc row closes it), so it blocks nothing
    // here — only the page's lower keyboard layers stand down under it.
    const layer = origin && typeof origin.call === 'function' ? origin.call('shellOverlayOpen', host) : null;
    if (layer && layer !== 'mainThread') return 'overlay:' + layer;
    if (root.contextDropdown && root.contextDropdown.open !== false) return 'overlay:contextMenu';
    if (root._homeColorPicker) return 'overlay:colorPicker';
    if (root._shortcutsSheetOpen) return 'overlay:sheet';
    if (root._headerSearchOpen) return 'overlay:search';
    if (root._chatDrawerOpen || root._mailDrawerOpen || root.notificationsPanelOpen) return 'overlay:drawer';
    // LAST, a modal every carrier above missed — the marketplace detail, any
    // DISPLAYED [aria-modal="true"]. Focus INSIDE it already answered
    // 'overlay:focus'; this carrier covers focus OUTSIDE it — a closed
    // overlay above the modal returns focus to its header trigger, and the
    // shell's escape binding then closed the modal's whole window on one
    // press (live, dev 92ddd7899, 2026-10-21). The modal's own document
    // handler closes it and spends the key; the shell stands down. Candidates
    // come from the element tree (lookdownAll, FA501); openness from the
    // node's own markup, because the kit keeps closed dialogs mounted — a
    // mounted-but-closed dialog must never lock the shell's keyboard:
    //   • a closed marker above — [data-open="false"], [aria-hidden="true"],
    //     `hidden` (the windows kit marks closed roots so);
    //   • a kit dialog root above — [data-presentation] — that misses
    //     [data-open]: an AppDialog root gains [data-open] only while open,
    //     and a cascade-less test DOM cannot read its closed display;
    //   • computed display/visibility, for everything else.
    // NO open [data-open] root is REQUIRED: the live marketplace detail has
    // none (the slot's signal is html[data-slot], measured on dev 92ddd7899).
    const modalHosts = host && typeof host.lookdownAll === 'function' ? host.lookdownAll((child)=>child && child.node && typeof child.node.getAttribute === 'function' && child.node.getAttribute('aria-modal') === 'true') : null;
    if (modalHosts && modalHosts.length) {
        const view = typeof window !== 'undefined' && typeof window.getComputedStyle === 'function' ? window : null;
        // Geometry runs only where layout exists (the shell root's own box):
        // live, a closed kit dialog still measures 0×0 behind opacity/width
        // tricks a style read misses (five such at rest on dev 92ddd7899); a
        // test DOM (jsdom, the recording DOM) has no layout and every rect is
        // 0×0, so there the markup walks above are the whole judgment.
        let laidOut = false;
        const rootNode = host && host.node;
        if (rootNode && typeof rootNode.getBoundingClientRect === 'function') try {
            const rr = rootNode.getBoundingClientRect();
            laidOut = !!rr && rr.width > 0 && rr.height > 0;
        } catch (_) {}
        for (const m of modalHosts){
            const node = m.node;
            if (t && typeof node.contains === 'function' && node.contains(t)) continue;
            let closed = false;
            let n = node;
            while(n && typeof n.getAttribute === 'function'){
                if (n.getAttribute('data-open') === 'false' || n.getAttribute('aria-hidden') === 'true' || n.hidden) {
                    closed = true;
                    break;
                }
                if (n.getAttribute('data-presentation') != null) {
                    if (n.getAttribute('data-open') == null) closed = true;
                    break;
                }
                n = n.parentElement;
            }
            if (closed) continue;
            if (view) try {
                const cs = view.getComputedStyle(node);
                if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) continue;
            } catch (_) {}
            if (laidOut && typeof node.getBoundingClientRect === 'function') {
                const r = node.getBoundingClientRect();
                if (!r || r.width <= 0 || r.height <= 0) continue;
            }
            return 'overlay:modal';
        }
    }
    return null;
}
function $b9d6a5c1fb248e86$export$56748fc880b42d7(el, s, event) {
    const origin = el || this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    const e = event;
    if (!host || !e) return false;
    const store = host.__shortcuts || (host.__shortcuts = {
        list: [],
        pending: null,
        armed: false,
        last: null
    });
    // One keystroke, one pass: a second listener handed the SAME event never
    // re-runs a binding.
    if (store.last === e) return false;
    store.last = e;
    if (e.defaultPrevented) {
        store.pending = null;
        return false;
    }
    if (e.isComposing || e.keyCode === 229) return false;
    if (!store.armed) {
        store.armed = true;
        try {
            host.call('registerDefaultShortcuts');
        } catch (_) {
        /* a shell without the defaults keeps an empty registry */ }
    }
    const st = s || host.state;
    const root = st && st.root || st || {};
    // Agent mode (WS-AGENT-MODE-1) owns the whole keyboard: its frame forwards
    // every key to the shared runtime, and no shell binding runs under it.
    if (root.agentMode === true || root._agentModeLink === true) {
        store.pending = null;
        return false;
    }
    // The key, layout-aware: a Latin letter as itself; the physical key's Latin
    // letter on a non-Latin layout (Georgian ჯ on the J key is J); any other
    // character as typed ('?', '/', digits); a named key lower-cased.
    const raw = typeof e.key === 'string' ? e.key : '';
    let k = '';
    if (raw.length === 1) {
        const lower = raw.toLowerCase();
        if (lower >= 'a' && lower <= 'z') k = lower;
        else if (raw.charCodeAt(0) > 127 && /^Key[A-Z]$/.test(e.code || '')) k = e.code.slice(3).toLowerCase();
        else k = raw;
    } else k = raw.toLowerCase() === 'esc' ? 'escape' : raw.toLowerCase();
    // A lone modifier (Shift before '?'), a dead key, an IME process key: not a
    // keystroke of its own — an open sequence stays open across it.
    if (!k || k === 'shift' || k === 'control' || k === 'alt' || k === 'meta' || k === 'dead' || k === 'process' || k === 'unidentified') return false;
    const list = store.list;
    const now = typeof e.timeStamp === 'number' && e.timeStamp > 0 ? e.timeStamp : Date.now();
    const blocked = (kind)=>!!host.call('shortcutBlockReason', host, root, e, kind);
    // PLAIN TYPING IS NEVER A SHORTCUT (round 1b, sam — keyboard only: with
    // focus on the page body, a typed sentence opened Calendar; the "4" of
    // "Tuesday 4 to 6 pm" pressed the fourth app tile). A character key that
    // comes within a second of a character that NAMES NO BINDING, typed where a
    // single key could have run (not in a field, no overlay), is typing: no
    // single-key or sequence binding runs for it, and it cannot open a sequence.
    // Chords and named keys are not typing; a key that names a binding — run,
    // declined or held off — is a shortcut attempt, never typing (J J J walks the
    // widgets; P pressed off a card and then on one pins it); the second key of
    // an open sequence belongs to the sequence. The first key after a pause
    // stays a shortcut — one keystroke cannot tell a person typing from a person
    // pressing a key — and the person's own switch (shortcutsSingleKeys) turns
    // single keys off altogether.
    const printable = raw.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey;
    const typing = printable && store.typedAt != null && now - store.typedAt < 1000;
    const seqAttempt = !!store.pending;
    let named = false;
    const typed = ()=>{
        if (printable && !seqAttempt && !named && !blocked('char')) store.typedAt = now;
        return false;
    };
    const matches = (a)=>{
        if (a.key !== k) return false;
        const modHeld = !!(e.metaKey || e.ctrlKey);
        if (a.mod !== modHeld) return false;
        if (a.mod && !!a.alt !== !!e.altKey) return false;
        if (a.shift && !e.shiftKey) return false;
        // Shift+J is not J — but '?' and '/' carry Shift on most layouts
        if (!a.shift && e.shiftKey && a.key.length === 1 && a.key >= 'a' && a.key <= 'z') return false;
        return true;
    };
    // 1. An open sequence: does this key complete (or extend) one?
    if (store.pending) {
        const p = store.pending;
        store.pending = null;
        if (!e.repeat && now - p.at <= 1500 && !blocked('seq')) {
            const typed = p.keys.concat(k);
            for(let i = list.length - 1; i >= 0; i--){
                const b = list[i];
                if (!b.seq || !b.run || b.seq.length !== typed.length) continue;
                if (!b.seq.every((x, j)=>x === typed[j])) continue;
                if (b.when && !b.when(host, root)) continue;
                if (b.run(host, root, e) === false) continue;
                e.preventDefault();
                return true;
            }
            const longer = list.some((b)=>b.seq && b.run && b.seq.length > typed.length && typed.every((x, j)=>b.seq[j] === x));
            if (longer) {
                store.pending = {
                    keys: typed,
                    at: now
                };
                return false;
            }
        }
    // no sequence took it — the key is read on its own below
    }
    // 2. Chords, characters, named keys — the most recent registration first.
    for(let i = list.length - 1; i >= 0; i--){
        const b = list[i];
        if (!b.run || b.seq || !b.alts.some(matches)) continue;
        named = true;
        if (typing && b.kind === 'char') continue;
        if (blocked(b.kind)) continue;
        if (e.repeat && !b.repeat) return false;
        if (b.when && !b.when(host, root)) continue;
        if (b.run(host, root, e) === false) continue;
        e.preventDefault();
        return true;
    }
    // 3. The first key of a sequence opens it (and is not consumed) — never
    // mid-typing.
    const opensSeq = list.some((b)=>b.seq && b.run && b.seq[0] === k);
    if (opensSeq) named = true;
    if (!typing && !e.repeat && opensSeq && !blocked('seq')) {
        store.pending = {
            keys: [
                k
            ],
            at: now
        };
        return false;
    }
    // Nothing took the key: a character typed — the next one within a second
    // is typing too.
    return typed();
}
function $b9d6a5c1fb248e86$export$553d0b991490338b() {
    const origin = this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    if (!host) return [];
    const store = host.__shortcuts || (host.__shortcuts = {
        list: [],
        pending: null,
        armed: false,
        last: null
    });
    if (!store.armed) {
        store.armed = true;
        try {
            host.call('registerDefaultShortcuts');
        } catch (_) {
        /* a shell without the defaults keeps an empty registry */ }
    }
    const st = host.state;
    const root = st && st.root || st || {};
    const nav = typeof navigator === 'undefined' ? null : navigator;
    const platform = String(nav && (nav.userAgentData && nav.userAgentData.platform || nav.platform || nav.userAgent) || '');
    const mac = /mac|iphone|ipad|ipod/i.test(platform);
    // Key legends as printed on the key (Latin on every layout, never translated).
    const capOf = (key)=>key === 'escape' ? 'Esc' : key === 'enter' ? "\u21B5" : key === ' ' ? 'Space' : key.length === 1 ? key.toUpperCase() : key.charAt(0).toUpperCase() + key.slice(1);
    const rows = [];
    for (const b of store.list){
        if (!b.label) continue;
        let ready = !!b.run;
        if (ready && b.when) try {
            ready = !!b.when(host, root);
        } catch (_) {
            ready = false;
        }
        let keycaps = b.keycaps;
        if (!keycaps && b.seq) keycaps = b.seq.map(capOf);
        if (!keycaps && b.alts.length) {
            const a = b.alts[0];
            keycaps = [];
            if (a.mod) keycaps.push(mac ? "\u2318" : 'Ctrl');
            if (a.alt) keycaps.push(mac ? "\u2325" : 'Alt');
            if (a.shift) keycaps.push("\u21E7");
            keycaps.push(capOf(a.key));
        }
        rows.push({
            id: b.id,
            label: b.label,
            group: b.group,
            groupOrder: b.groupOrder,
            order: b.order,
            keycaps: keycaps || [],
            joiner: b.joiner,
            sequence: !!b.seq,
            adopted: !!b.adopted,
            runnable: ready,
            active: !host.call('shortcutBlockReason', host, root, null, b.kind)
        });
    }
    return rows.sort((a, b)=>a.groupOrder - b.groupOrder || a.order - b.order);
}
function $b9d6a5c1fb248e86$export$cb426a62ec6282ab() {
    const rows = (this.call('listShortcuts') || []).filter((r)=>r.active);
    const groups = [];
    for (const r of rows){
        let g = groups[groups.length - 1];
        if (!g || g.label !== r.group) {
            g = {
                key: 'group' + groups.length,
                label: r.group,
                rows: []
            };
            groups.push(g);
        }
        g.rows.push({
            key: r.id,
            ...r
        });
    }
    return groups;
}
function $b9d6a5c1fb248e86$export$dbcf7143923947af(id) {
    const origin = this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    if (!host) return false;
    const store = host.__shortcuts || (host.__shortcuts = {
        list: [],
        pending: null,
        armed: false,
        last: null
    });
    if (!store.armed) {
        store.armed = true;
        try {
            host.call('registerDefaultShortcuts');
        } catch (_) {
        /* a shell without the defaults keeps an empty registry */ }
    }
    const b = store.list.find((r)=>r.id === id);
    if (!b || !b.run) return false;
    const st = host.state;
    const root = st && st.root || st || {};
    if (b.when && !b.when(host, root)) return false;
    return b.run(host, root, null) !== false;
}

});

parcelRegister("g2MQt", function(module, exports) {

$parcel$export(module.exports, "mailtoComposeDefault", () => $bae2b8efceb0f22d$export$c6f7cf002bda8a76);
// mailto: in the shell (architecture/MAIL.md §3.2a) — the in-app composer is
// the DEFAULT ACTION of a plain left-click on a mailto: link, never a
// pre-emption of the surface that owns the link.
//
// The shell root declares `onDocumentClick` (app.js): ONE bubble-phase
// document listener that DOMQL owns (FA503). An element's own onClick runs
// before it — DOMQL delegates element clicks to <html>, below document — so a
// surface that handles the click itself claims it with preventDefault, and
// the shell yields: the CRM contact dialog's Email action and the email in
// its head open the CRM's own composer on the Email tab. A plain mailto link
// (no handler, or one that lets the click through, like Link's router) opens
// the in-app composer through openMailComposeFromMailto (mail
// functions/compose.js) while the `mail` feature is on.
//
// The listener used to be a raw CAPTURE listener in wireGlobalListeners.js
// that ran before every element handler and stopped the click: it took
// every mailto click, the CRM's included (crm-modal's live check on dev
// crm-app 1.0.87 opened the Mail app and saved an empty draft). A modifier
// or non-primary click is the person asking for their own mail client and
// stays with the browser.
//
// `this` is the shell root element; answers true when it opened the composer.
const $bae2b8efceb0f22d$export$c6f7cf002bda8a76 = function mailtoComposeDefault(e) {
    const shell = this;
    if (!e || e.defaultPrevented) return false;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    const target = e.target;
    const anchor = target && typeof target.closest === 'function' ? target.closest('a[href^="mailto:" i]') : null;
    if (!anchor || !shell || typeof shell.call !== 'function') return false;
    const root = shell.state ? shell.state.root || shell.state : null;
    if (!shell.call('featureEnabled', root, 'mail')) return false;
    if (!shell.call('openMailComposeFromMailto', anchor.getAttribute('href'))) return false;
    e.preventDefault();
    return true;
};

});

parcelRegister("j9FGY", function(module, exports) {

$parcel$export(module.exports, "registerDefaultShortcuts", () => $df1f32c06aae95d6$export$3f9fcba506a67052);
$parcel$export(module.exports, "focusShellComposer", () => $df1f32c06aae95d6$export$361f52cf3aef2367);
$parcel$export(module.exports, "closeAppWindow", () => $df1f32c06aae95d6$export$94dfd53ef7be36c1);
$parcel$export(module.exports, "openShortcutsSheet", () => $df1f32c06aae95d6$export$bf53734d7d73bfd);
// THE SHELL'S DEFAULT KEYBOARD MAP (HOME_AMBIENT_SKIN_SPEC §5 "Bindings").
// Armed once per shell by functions/shortcuts.js, on the first key or listing.
//
//   General    ⌘K search (ADOPTED — HeaderSearch owns it) · / prompt bar ·
//              ? this sheet · Esc close / leave edit mode
//   Go to      G then H · T · C · M → home · tasks · calendar · chat
//   Dashboard  1–9 the nth app tile · J / K next / previous widget ·
//              Enter open the focused widget (ADOPTED — the card's own
//              onKeyDown) · A the focused widget's square action (the frame's
//              HomeWidgetAction, pressed through its own onClick —
//              functions/shortcutsHome.js homeWidgetKeyAction) · E edit the board
//
// Deliberately NOT bound:
//   • ⌘⇧L — the spec rules it out.
//
// ADOPTION, not double-binding:
//   • ⌘K — `HeaderSearch` (shared) declares its own document keydown per
//     mounted instance and calls preventDefault. The registry LISTS the row and
//     never runs it: a second handler for one keystroke is exactly the double
//     bind the spec forbids, and listener order cannot make a registry run safe
//     (the header re-mounts on canvas routes, so its listener can land after
//     the shell's).
//   • Enter — the focused app tile's own `onKeyDown` (pages/main.js `_widget`)
//     opens it; the registry lists the row only.
//   • Esc — every overlay owns its own Escape (AppDialog stops it at the root,
//     the dropdown / modal roots close their layer); the guard keeps the
//     registry out while any is open. With no overlay, an open app window is
//     the top thing: Esc closes it through the window's own X
//     (closeAppWindow); only then does Esc reach edit mode. The customize drawer still carries its own Escape
//     too (pages/main.js); both write the SAME exit patch and the registry
//     yields to a handled key, so one Esc is one write in either listener
//     order (docs/patches/shortcuts-esc-precedence.patch retires the drawer's
//     copy so the precedence lives in one place).
//
// Every `when` / `run` receives (shellRoot element, root state[, event]).
// Group labels and row labels are bundle keys; the `shell.shortcuts.*` ones
// ship with docs/patches/shortcuts-i18n.patch.
function $df1f32c06aae95d6$export$3f9fcba506a67052() {
    const el = this;
    const reg = (def)=>el.call('registerShortcut', def);
    const member = (h, s)=>!!(s && s.signedIn);
    const GENERAL = 'shell.shortcuts.group.general';
    const GO_TO = 'shell.shortcuts.group.goTo';
    const BOARD = 'shell.headerTabs.dashboard';
    // The exit every customize control writes (functions/homeCustomizeDismiss.js
    // CUSTOMIZE_EXIT_PATCH — the drawer's ×, Done, Escape and outside press).
    const leaveEditMode = (root)=>{
        root.update({
            _homeCustomizeMode: false,
            _homeCustomizeDrawerTucked: false
        });
    };
    // ── General ────────────────────────────────────────────────────────────
    reg({
        id: 'search',
        keys: 'mod+k',
        label: 'common.action.search',
        group: GENERAL,
        groupOrder: 1,
        order: 1,
        adopted: 'HeaderSearch'
    });
    reg({
        id: 'composer',
        keys: '/',
        label: 'shell.shortcuts.row.composer',
        group: GENERAL,
        groupOrder: 1,
        order: 2,
        when: member,
        run: (h)=>h.call('focusShellComposer')
    });
    reg({
        id: 'sheet',
        keys: '?',
        label: 'shell.shortcuts.row.sheet',
        group: GENERAL,
        groupOrder: 1,
        order: 3,
        when: member,
        run: (h)=>h.call('openShortcutsSheet')
    });
    reg({
        id: 'escape',
        keys: 'escape',
        label: 'shell.shortcuts.row.escape',
        group: GENERAL,
        groupOrder: 1,
        order: 4,
        // The TOP thing first: an open app window (PageSlot) sits over the board,
        // so Esc closes it — through the window's own X (closeAppWindow below) —
        // before it ever reaches edit mode on the board beneath.
        when: (h, root)=>!!(root && (root._canvasSlot || root._canvasSlotSecond || root._homeCustomizeMode)),
        run: (h, root, e)=>{
            if (root._canvasSlot || root._canvasSlotSecond) return h.call('closeAppWindow', e);
            leaveEditMode(root);
        }
    });
    // ── Go to — the router, the way the header's Home button navigates ─────
    const go = (id, letter, path, label, order)=>reg({
            id: id,
            seq: [
                'g',
                letter
            ],
            label: label,
            group: GO_TO,
            groupOrder: 2,
            order: order,
            when: member,
            run: (h)=>{
                // Home, like the header's home icon: a fresh Fly in Fly mode
                // (functions/assistantFlyWorkspace.js assistantFlyHomeFresh).
                if (path === '/' && h.context?.functions?.assistantFlyHomeFresh) {
                    h.call('assistantFlyHomeFresh');
                    return;
                }
                h.router(path, h.getRoot());
            }
        });
    // The workspace or its CLI (functions/workspaceMode.js): Ctrl+` (⌘` is the
    // system's on a Mac). Under the Agent frame its own key bridge takes it.
    reg({
        id: 'workspaceModeToggle',
        keys: 'mod+`',
        label: 'workspace.agentMode.toggle',
        group: GENERAL,
        groupOrder: 1,
        order: 9,
        when: member,
        run: (h)=>h.call('workspaceModeToggle')
    });
    go('goHome', 'h', '/', 'shell.app.home', 1);
    go('goTasks', 't', '/tasks', 'shell.app.tasks', 2);
    go('goCalendar', 'c', '/calendar', 'shell.app.calendar', 3);
    go('goChat', 'm', '/chat', 'shell.app.chat', 4);
    // ── Dashboard — the home board, when it is the surface ─────────────────
    const onBoard = (h, root)=>member(h, root) && !root._homeCustomizeMode;
    reg({
        id: 'openApp',
        keys: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9'
        ],
        keycaps: [
            '1',
            '9'
        ],
        joiner: 'range',
        label: 'shell.shortcuts.row.openApp',
        group: BOARD,
        groupOrder: 3,
        order: 1,
        when: onBoard,
        run: (h, root, e)=>e && /^[1-9]$/.test(e.key) ? h.call('openHomeTile', Number(e.key), e) : false
    });
    reg({
        id: 'nextWidget',
        keys: 'j',
        repeat: true,
        label: 'shell.shortcuts.row.nextWidget',
        group: BOARD,
        groupOrder: 3,
        order: 2,
        when: onBoard,
        run: (h, root, e)=>h.call('focusHomeCard', 1, e)
    });
    reg({
        id: 'prevWidget',
        keys: 'k',
        repeat: true,
        label: 'shell.shortcuts.row.prevWidget',
        group: BOARD,
        groupOrder: 3,
        order: 3,
        when: onBoard,
        run: (h, root, e)=>h.call('focusHomeCard', -1, e)
    });
    reg({
        id: 'openWidget',
        keys: 'enter',
        label: 'shell.shortcuts.row.openWidget',
        group: BOARD,
        groupOrder: 3,
        order: 4,
        adopted: "the focused card\u2019s own button (components/HomeWidgetFrame.js title / app tile)"
    });
    // A — the focused widget's square action. Live only while a card holds the
    // focus, so the ⌘K palette (focus in its own field) never offers a command
    // that has no card to act on; the ? sheet lists it all the same.
    reg({
        id: 'widgetAction',
        keys: 'a',
        label: 'shell.shortcuts.row.widgetAction',
        group: BOARD,
        groupOrder: 3,
        order: 5,
        when: (h, root)=>onBoard(h, root) && !!h.call('homeCardOfTarget'),
        run: (h, root, e)=>h.call('homeWidgetKeyAction', e)
    });
    reg({
        id: 'editBoard',
        keys: 'e',
        label: 'shell.accountMenu.customizeDashboard',
        group: BOARD,
        groupOrder: 3,
        order: 6,
        when: (h, root)=>member(h, root) && !!h.call('homeBoardActive'),
        run: (h, root)=>{
            // The two enter paths that exist (the board's context menu Customize and
            // the account menu's) write exactly this; the exit is the drawer's.
            if (root._homeCustomizeMode) leaveEditMode(root);
            else root.update({
                _homeCustomizeMode: true
            }, {
                preventFetch: true
            });
        }
    });
    el.call('registerHomeResizeShortcuts');
}
function $df1f32c06aae95d6$export$361f52cf3aef2367() {
    const origin = this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    const composer = host && host.CanvasPromptTextarea;
    const field = composer && composer.Textarea;
    const node = field && field.node;
    if (!node || typeof node.focus !== 'function' || node.isConnected === false) return false;
    if (typeof node.getClientRects === 'function' && !node.getClientRects().length) return false;
    try {
        node.focus({
            preventScroll: true
        });
    } catch (_) {
        node.focus();
    }
    const doc = node.ownerDocument;
    return !doc || doc.activeElement === node;
}
function $df1f32c06aae95d6$export$94dfd53ef7be36c1(event) {
    const origin = this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    const slot = host && host.PageSlot;
    if (!slot) return false;
    const st = host.state;
    const root = st && st.root || st || {};
    const t = event && event.target;
    const holds = (pane)=>!!(pane && pane.node && t && typeof pane.node.contains === 'function' && pane.node.contains(t));
    const pane = root._canvasSlotSecond && holds(slot.PaneSecond) && slot.PaneSecond || (root._canvasSlot ? slot.PanePrimary : slot.PaneSecond);
    const btn = pane && pane.Header && pane.Header.CloseBtn;
    if (!btn || typeof btn.onClick !== 'function') return false;
    const ev = event || {
        preventDefault () {},
        stopPropagation () {}
    };
    btn.onClick(ev, btn, btn.state);
    return true;
}
function $df1f32c06aae95d6$export$bf53734d7d73bfd() {
    const origin = this;
    const host = origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
    if (!host || !host.ShortcutsOverlay || !host.ShortcutsOverlay.node) return false;
    const st = host.state;
    const root = st && st.root || st;
    if (!root || typeof root.update !== 'function') return false;
    root.update({
        _shortcutsSheetOpen: true
    });
    return true;
}

});

parcelRegister("4lCqq", function(module, exports) {

$parcel$export(module.exports, "homeBoardActive", () => $32a6ee07107bc1b6$export$4ffba605db567a7);
$parcel$export(module.exports, "homeBoardCards", () => $32a6ee07107bc1b6$export$d55a65e61ced5f3a);
$parcel$export(module.exports, "focusHomeCard", () => $32a6ee07107bc1b6$export$a6e30114de195508);
$parcel$export(module.exports, "homeStripTiles", () => $32a6ee07107bc1b6$export$e97ec01d4d867253);
$parcel$export(module.exports, "openHomeTile", () => $32a6ee07107bc1b6$export$d724c99a94fc534c);
$parcel$export(module.exports, "homeWidgetKeyResize", () => $32a6ee07107bc1b6$export$f728a095c39b7b83);
$parcel$export(module.exports, "homeCardOfTarget", () => $32a6ee07107bc1b6$export$e822e55d9373b216);
$parcel$export(module.exports, "homeWidgetKeyAction", () => $32a6ee07107bc1b6$export$37ce0788ec66464e);
$parcel$export(module.exports, "registerHomeResizeShortcuts", () => $32a6ee07107bc1b6$export$1e629fe79c257655);
// The HOME-BOARD half of the keyboard map (HOME_AMBIENT_SKIN_SPEC §5):
// 1–9 open the nth app tile, J / K walk the focus ring, A runs the focused
// widget's square action, E edits the board,
// Shift + an arrow resizes the focused widget in edit mode
// (DESIGN-WL-HOME-WIDTH-RESIZE-1 — `registerHomeResizeShortcuts` below, armed
// from registerDefaultShortcuts).
//
// THE BOARD IS THE SURFACE only while no PageSlot app window covers it — the
// rule `homeContextMenuAllowed` (functions/homeContextMenu.js) already applies
// to the board's right-click: `_canvasSlot` / `_canvasSlotSecond` open ⇒ the
// board does not answer.
//
// ⚠ THE DOM READS (isolated here, on purpose). The board is the CSS grid of
// pages/main.js (`MainColumn.GridContainer`, class `home-grid`,
// DESIGN-WL-HOME-WIDGETS-1). Every card is ONE HomeWidgetFrame element — the
// grid item and the card (components/HomeWidgetFrame.js) — whose STATE ROW is
// the widget descriptor `{ id, kind, openRoute, … }` and whose CSS `order` is
// its index in `root._homeLayout`: the grid flows that order, so it IS the
// reading order (DOM order is not). The app shortcuts are not cards: they sit
// in the App strip (components/HomeAppStrip.js, components/HomeAppRail.js),
// already in that order. Two readers:
//   • `homeBoardCards` — the grid element through the element tree, its DOM
//     children (every plane's frames: the static ones, and the module /
//     pending fragments render straight into the grid), each child's `ref`
//     (the smbls back-link to its frame element) and the frame's keyboard
//     entry, the title button (`Header.TitleRow.Title`);
//   • `homeStripTiles` — the strip's glass capsule (the Dock's
//     `MainColumn.HomeAppStrip.DockCapsule`, or the Rail's
//     `HomeAppRail.RailCapsule` beside the board — the person's look), its DOM
//     children and each child's `ref` to its item (state row + `Open`, the
//     item's button); "All apps" carries no id and is not a numbered tile.
// No `document.querySelector*`, no writes — every other export here asks these
// two.
const $32a6ee07107bc1b6$var$_shell = (origin)=>origin && typeof origin.getRoot === 'function' && origin.getRoot() || origin;
const $32a6ee07107bc1b6$var$_shortcutsRootOf = (host)=>{
    const st = host && host.state;
    return st && st.root || st;
};
const $32a6ee07107bc1b6$var$_boardPart = (host, key)=>{
    const page = host && host.content;
    const column = page && page.MainColumn;
    const part = column && column[key];
    return part && part.node ? part : null;
};
const $32a6ee07107bc1b6$var$_boardGrid = (host)=>$32a6ee07107bc1b6$var$_boardPart(host, 'GridContainer');
// The assistant's generated board over the grid area (Page mode): the grid is
// NOT the surface while it shows — its cards are inert under the view
// (functions/homeWidgetFrame.js homeWidgetUnderView), so J / K and E pass them
// by. The App strip above the grid stays live (1–9). The view's own rule,
// read from the registry: a shell without the assistant reads false.
const $32a6ee07107bc1b6$var$_underView = (host, root)=>{
    const fns = host && host.context && host.context.functions;
    const open = fns && fns.assistantBoardOpen;
    return typeof open === 'function' && !!open.call(host, root);
};
function $32a6ee07107bc1b6$export$4ffba605db567a7() {
    const host = $32a6ee07107bc1b6$var$_shell(this);
    const root = $32a6ee07107bc1b6$var$_shortcutsRootOf(host);
    if (!host || !root || root._canvasSlot || root._canvasSlotSecond) return false;
    if ($32a6ee07107bc1b6$var$_underView(host, root)) return false;
    return !!$32a6ee07107bc1b6$var$_boardGrid(host);
}
function $32a6ee07107bc1b6$export$d55a65e61ced5f3a() {
    const host = $32a6ee07107bc1b6$var$_shell(this);
    const root = $32a6ee07107bc1b6$var$_shortcutsRootOf(host);
    if (!host || !root || root._canvasSlot || root._canvasSlotSecond) return [];
    if ($32a6ee07107bc1b6$var$_underView(host, root)) return [];
    const grid = $32a6ee07107bc1b6$var$_boardGrid(host);
    const kids = grid && grid.node && grid.node.children;
    if (!kids || !kids.length) return [];
    const hidden = root._homeHiddenWidgets && typeof root._homeHiddenWidgets === 'object' ? root._homeHiddenWidgets : {};
    const layout = Array.isArray(root._homeLayout) ? root._homeLayout : [];
    const place = (id)=>{
        const at = layout.findIndex((e)=>e && e.id === id);
        return at < 0 ? layout.length : at;
    };
    const out = [];
    Array.prototype.forEach.call(kids, (node, dom)=>{
        const card = node && node.ref;
        const row = card && card.state;
        const id = row && row.id;
        if (!id || node.isConnected === false || hidden[id]) return;
        const header = card.Header;
        const entry = header && header.TitleRow && header.TitleRow.Title;
        const focusNode = entry && entry.node || null;
        out.push({
            id: id,
            card: card,
            node: node,
            focusNode: focusNode,
            spec: row,
            route: row.openRoute || null,
            focusable: !!focusNode,
            at: place(id),
            dom: dom
        });
    });
    out.sort((a, b)=>a.at - b.at || a.dom - b.dom);
    return out;
}
function $32a6ee07107bc1b6$export$a6e30114de195508(step, event) {
    const cards = (this.call('homeBoardCards') || []).filter((c)=>c.focusable);
    if (!cards.length) return false;
    const t = event && event.target;
    const at = t ? cards.findIndex((c)=>c.node === t || typeof c.node.contains === 'function' && c.node.contains(t)) : -1;
    const next = at < 0 ? step > 0 ? 0 : cards.length - 1 : Math.min(cards.length - 1, Math.max(0, at + step));
    const node = cards[next].focusNode || cards[next].node;
    try {
        node.focus({
            focusVisible: true
        });
    } catch (_) {
        node.focus();
    }
    return true;
}
function $32a6ee07107bc1b6$export$e97ec01d4d867253() {
    const host = $32a6ee07107bc1b6$var$_shell(this);
    const root = $32a6ee07107bc1b6$var$_shortcutsRootOf(host);
    if (!host || !root || root._canvasSlot || root._canvasSlotSecond) return [];
    let look = null;
    try {
        look = host.call('homeLookRead', root);
    } catch (_) {
        look = null;
    }
    if (look && look.stripShown === false) return [];
    const page = host.content;
    const railEl = page && page.HomeAppRail;
    const rail = railEl && railEl.RailCapsule;
    const dockRow = $32a6ee07107bc1b6$var$_boardPart(host, 'HomeAppStrip');
    const dock = dockRow && dockRow.DockCapsule;
    const mounted = (part)=>!!(part && part.node && part.node.children && part.node.children.length);
    const capsule = look && look.stripStyle === 'rail' ? mounted(rail) ? rail : dock : mounted(dock) ? dock : rail;
    const kids = capsule && capsule.node && capsule.node.children;
    if (!kids || !kids.length) return [];
    const out = [];
    Array.prototype.forEach.call(kids, (node)=>{
        const item = node && node.ref;
        const row = item && item.state;
        const button = item && item.Open;
        if (!row || !row.id || !button || node.isConnected === false) return;
        out.push({
            id: row.id,
            item: item,
            button: button,
            spec: row
        });
    });
    return out;
}
function $32a6ee07107bc1b6$export$d724c99a94fc534c(n, event) {
    const tile = (this.call('homeStripTiles') || [])[Number(n) - 1];
    if (!tile) return false;
    tile.button.call('homeWidgetOpen', tile.spec, event || null);
    return true;
}
function $32a6ee07107bc1b6$export$f728a095c39b7b83(event) {
    const e = event;
    if (!e) return false;
    const dir = e.key === 'ArrowRight' ? 'right' : e.key === 'ArrowLeft' ? 'left' : e.key === 'ArrowDown' ? 'down' : e.key === 'ArrowUp' ? 'up' : null;
    if (!dir) return false;
    const t = e.target;
    if (!t) return false;
    const hit = this.call('homeCardOfTarget', t);
    if (!hit || !hit.card || typeof hit.card.call !== 'function') return false;
    return !!hit.card.call('homeWidgetResizeStepBy', hit.spec, dir, hit.card);
}
function $32a6ee07107bc1b6$export$e822e55d9373b216(target) {
    const cards = this.call('homeBoardCards') || [];
    let t = target;
    if (!t && cards.length) {
        const doc = cards[0].node && cards[0].node.ownerDocument;
        t = doc && doc.activeElement;
    }
    if (!t) return null;
    return cards.find((c)=>c.node === t || typeof c.node.contains === 'function' && c.node.contains(t)) || null;
}
function $32a6ee07107bc1b6$export$37ce0788ec66464e(event) {
    const hit = this.call('homeCardOfTarget', event && event.target);
    const header = hit && hit.card && hit.card.Header;
    const btn = header && header.HomeWidgetAction;
    if (!btn || typeof btn.onClick !== 'function' || typeof btn.call !== 'function') return false;
    if (!btn.call('homeWidgetActionOf', hit.spec)) return false;
    const ev = event || {
        preventDefault () {},
        stopPropagation () {}
    };
    btn.onClick(ev, btn, btn.state);
    return true;
}
function $32a6ee07107bc1b6$export$1e629fe79c257655() {
    const el = this;
    el.call('registerShortcut', {
        id: 'resizeWidget',
        keys: [
            'shift+arrowright',
            'shift+arrowleft',
            'shift+arrowdown',
            'shift+arrowup'
        ],
        keycaps: [
            "\u21E7",
            "\u2190",
            "\u2192",
            "\u2191",
            "\u2193"
        ],
        label: 'shell.shortcuts.row.resizeWidget',
        group: 'shell.headerTabs.dashboard',
        groupOrder: 3,
        order: 7,
        when: (h, root)=>!!(root && root.signedIn && root._homeCustomizeMode) && !!h.call('homeBoardActive'),
        run: (h, root, e)=>h.call('homeWidgetKeyResize', e)
    });
}

});

parcelRegister("2VLCm", function(module, exports) {

$parcel$export(module.exports, "routeTransitionEnter", () => $2225d787fed0654c$export$ea8af1f3b6576d82);
$parcel$export(module.exports, "routeTransitionExit", () => $2225d787fed0654c$export$65a86002090aadd5);
// PAGE / ROUTE MOTION (HOME_AMBIENT_SKIN_SPEC §6 · DESIGN_SPEC §4.6–4.7, §6.4).
//
//   el.call('routeTransitionEnter', shellRoot)  — the NEW page root rises in:
//       `fadeInUpShort` (6.5 % travel), `C` on `springBezier`
//   el.call('routeTransitionExit', pageEl)      — the LEAVING page fades: `B` on
//       `defaultBezier`, opacity only, one letter faster than the entrance;
//       resolves true when it ran, false when it was skipped
//
// Opacity + transform only. No motion, and the final state at once, when:
//   • the OS asks for reduced motion (`prefers-reduced-motion: reduce`);
//   • the person asked for it in the app (`root.a11yMotion`, Settings ›
//     Accessibility — "transitions and animations stand still");
//   • the tab is not visible — WAAPI events are frame-gated, and animating for
//     nobody is pure risk (the PageSlot rule, canvas/components/PageSlot.js);
//   • a token is missing — the duration, the curve and the keyframes are read
//     off the RUNNING design system (`context.designSystem`: the timing
//     sequence's `C` / `B` values, `springBezier` / `defaultBezier`, the
//     `fadeInUpShort` keyframes). Nothing here is a literal duration or curve;
//     a design system without them gets no motion rather than a guess.
//
// WHY WAAPI, like PageSlot: a routed page is a fresh element on every
// navigation, and a one-shot `node.animate()` owns its run without re-rendering
// the page it animates (a css-in-props animation would need a prop the page
// never declared). The page root is the router's content element
// (`shellRoot.content`, @symbo.ls/router `contentElementKey: 'content'`).
//
// WHERE IT HOOKS. The router swaps pages synchronously
// (`element.set(nextContent, …)` in @symbo.ls/router `router()`) and then fires
// `routeChanged` on the shell root — so the ENTRANCE hooks the shell root's
// `onRouteChanged` (docs/patches/route-transition.patch; app.js is ws-w2's).
// The EXIT has no hook to run from: the leaving element is disposed inside the
// same synchronous call, before any shell code sees the navigation. It is
// ready for a router pre-swap hook (framework request on the ticket).
function $2225d787fed0654c$export$ea8af1f3b6576d82(shell) {
    const el = shell || this;
    const page = el && el.content;
    const node = page && page.node;
    if (!node || typeof node.animate !== 'function') return null;
    // Only a NEW page root enters. The router fires `routeChanged` on every
    // call — a query-only navigation keeps the same content element — and the
    // first route of a session is the boot, which the boot loader hands off,
    // not a navigation. The last page root seen rides on the shell element
    // (non-reactive bookkeeping, the house `__x` idiom).
    const last = el.__routeEnterNode;
    el.__routeEnterNode = node;
    if (!last || last === node) return null;
    const doc = node.ownerDocument;
    if (!doc || doc.visibilityState !== 'visible') return null;
    const win = doc.defaultView;
    if (win && typeof win.matchMedia === 'function' && win.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
    const st = el.state;
    const root = st && st.root || st;
    if (root && root.a11yMotion) return null;
    const ds = el.context && el.context.designSystem;
    const timing = ds && ds.timing;
    const step = timing && timing.sequence && timing.sequence.C;
    const duration = step && Number(step.val);
    const easing = timing && timing.springBezier;
    const frames = ds && ds.animation && ds.animation.fadeInUpShort;
    if (!duration || !easing || !frames || !frames.from || !frames.to) return null;
    const anim = node.animate([
        frames.from,
        frames.to
    ], {
        duration: duration,
        easing: easing
    });
    anim.id = 'routeEnter';
    return anim;
}
function $2225d787fed0654c$export$65a86002090aadd5(page) {
    const el = this;
    const node = page && page.node;
    if (!node || typeof node.animate !== 'function') return Promise.resolve(false);
    const doc = node.ownerDocument;
    if (!doc || doc.visibilityState !== 'visible') return Promise.resolve(false);
    const win = doc.defaultView;
    if (win && typeof win.matchMedia === 'function' && win.matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve(false);
    const st = el && el.state;
    const root = st && st.root || st;
    if (root && root.a11yMotion) return Promise.resolve(false);
    const ds = el && el.context && el.context.designSystem;
    const timing = ds && ds.timing;
    const step = timing && timing.sequence && timing.sequence.B;
    const duration = step && Number(step.val);
    const easing = timing && timing.defaultBezier;
    if (!duration || !easing) return Promise.resolve(false);
    const anim = node.animate([
        {
            opacity: 1
        },
        {
            opacity: 0
        }
    ], {
        duration: duration,
        easing: easing
    });
    anim.id = 'routeExit';
    return Promise.resolve(anim.finished).then(()=>true, ()=>true);
}

});

parcelRegister("a8Zn1", function(module, exports) {

$parcel$export(module.exports, "homeBoardUrlRead", () => $762a419b59b173c9$export$78c2cb47c4c4b54e);
$parcel$export(module.exports, "homeBoardUrlSync", () => $762a419b59b173c9$export$1e576fc95fcaa912);
$parcel$export(module.exports, "homeBoardUrlOpen", () => $762a419b59b173c9$export$21087c224424726f);
$parcel$export(module.exports, "homeBoardUrlTick", () => $762a419b59b173c9$export$28e81fe808bbcde1);
// `?board=<id>` — the board on screen, in the home's address
// (ASSISTANT_BOARD_MODE_SPEC.md §4 "`?board=<id>` in the URL";
// DESIGN-WL-ASSISTANT-MAIN-HOME-1). ws-home's half of the boards row.
//
// ONE value decides it: the boards row's current segment
// (functions/assistantBoard.js assistantBoardCurrentSegment) — the board the
// view shows, or 'home'. The address mirrors it; a cold load of a `?board=`
// link opens that board through the row's own switch (assistantBoardSelect),
// so a link and a click can never disagree.
//
// The write is a query-only history.replaceState — no navigation, no router
// dispatch, no new history entry (the same contract as the event detail
// sheet's `?event=` and moduleOpenBridge's setModuleRouteQuery), and never
// when the address already says it (no-op guard).
//
// A COLD LINK waits for Page mode to exist in this workspace
// (`_aiBoardsAvailable`, set by the view's probe) before it opens the board,
// and while it waits — and while the open is in flight — the mirror leaves
// the address alone, so the link is never stripped before it was honoured.
// Once the open settles the address follows the screen again: shown = kept;
// not shown (a failed read, the answers not in Page mode) = removed.
const $762a419b59b173c9$var$PARAM = 'board';
const $762a419b59b173c9$var$_boardUrlWin = ()=>typeof window !== 'undefined' ? window : null;
const $762a419b59b173c9$export$78c2cb47c4c4b54e = function homeBoardUrlRead() {
    const w = $762a419b59b173c9$var$_boardUrlWin();
    if (!w || !w.location) return null;
    try {
        const v = new URLSearchParams(w.location.search || '').get($762a419b59b173c9$var$PARAM);
        return v || null;
    } catch (_) {
        return null;
    }
};
const $762a419b59b173c9$export$1e576fc95fcaa912 = function homeBoardUrlSync(root) {
    const w = $762a419b59b173c9$var$_boardUrlWin();
    if (!w || !w.history || !w.location || typeof w.history.replaceState !== 'function') return false;
    const host = this;
    const pending = host && host.__homeBoardUrl && host.__homeBoardUrl.pending;
    if (pending) return false;
    const seg = this.call('assistantBoardCurrentSegment', root || {});
    const want = seg && seg !== 'home' ? String(seg) : null;
    let url;
    try {
        url = new URL(w.location.href);
    } catch (_) {
        return false;
    }
    const have = url.searchParams.get($762a419b59b173c9$var$PARAM) || null;
    if (have === want) return false;
    if (want) url.searchParams.set($762a419b59b173c9$var$PARAM, want);
    else url.searchParams.delete($762a419b59b173c9$var$PARAM);
    w.history.replaceState(w.history.state, '', url.pathname + url.search + url.hash);
    return true;
};
const $762a419b59b173c9$export$21087c224424726f = function homeBoardUrlOpen(root) {
    const host = this;
    const r = root || {};
    const state = host.__homeBoardUrl = host.__homeBoardUrl || {
        done: false,
        pending: false
    };
    if (state.done) return null;
    const id = $762a419b59b173c9$export$78c2cb47c4c4b54e();
    if (!id) {
        state.done = true;
        return null;
    }
    if (r._aiBoardsAvailable !== true) {
        // not yet — keep the link until the view's probe answers
        state.pending = true;
        return null;
    }
    state.done = true;
    if (this.call('assistantBoardCurrentSegment', r) === id) {
        state.pending = false;
        return null;
    }
    state.pending = true;
    const settle = ()=>{
        state.pending = false;
        $762a419b59b173c9$export$1e576fc95fcaa912.call(host, host.state && host.state.root ? host.state.root : r);
    };
    let out;
    try {
        out = this.call('assistantBoardSelect', id);
    } catch (_) {
        out = null;
    }
    return Promise.resolve(out).then(settle, settle);
};
const $762a419b59b173c9$export$28e81fe808bbcde1 = function homeBoardUrlTick(root) {
    $762a419b59b173c9$export$21087c224424726f.call(this, root);
    return $762a419b59b173c9$export$1e576fc95fcaa912.call(this, root);
};

});

parcelRegister("5oufH", function(module, exports) {

$parcel$export(module.exports, "homeNextUpEvents", () => $3ed6a914c7403679$export$91894ce42a393872);
$parcel$export(module.exports, "homeNextUpHero", () => $3ed6a914c7403679$export$22a3074f9d181b3f);
$parcel$export(module.exports, "homeNextUpTime", () => $3ed6a914c7403679$export$268d7e8349728d8c);
$parcel$export(module.exports, "homeNextUpRows", () => $3ed6a914c7403679$export$33f3533c2e0b5ae1);
$parcel$export(module.exports, "homeNextUpItems", () => $3ed6a914c7403679$export$46556224753d115c);
$parcel$export(module.exports, "homeNextUpAction", () => $3ed6a914c7403679$export$5c1fd352e775f811);
$parcel$export(module.exports, "homeNextUpActionArg", () => $3ed6a914c7403679$export$f59111953f56dd67);
$parcel$export(module.exports, "homeNextUpOpen", () => $3ed6a914c7403679$export$aa1180f331b56d64);
$parcel$export(module.exports, "homeNextUpNormalize", () => $3ed6a914c7403679$export$cd0274a7d1cfd451);
$parcel$export(module.exports, "homeNextUpProviders", () => $3ed6a914c7403679$export$bf2440096abf094b);
$parcel$export(module.exports, "homeNextUpAppsKnown", () => $3ed6a914c7403679$export$a635b6ddfc5b90be);
$parcel$export(module.exports, "homeNextUpProviderSig", () => $3ed6a914c7403679$export$b8a37b0562a8a0f9);
$parcel$export(module.exports, "homeNextUpCollect", () => $3ed6a914c7403679$export$9bc6b691a240c34d);
$parcel$export(module.exports, "homeNextUpClock", () => $3ed6a914c7403679$export$29622c7304943f6a);
$parcel$export(module.exports, "homeNextUpClockStop", () => $3ed6a914c7403679$export$799f3c28980b5f43);
// "NEXT UP" — the reads behind the shell's Next up widget
// (HOME_AMBIENT_SKIN_SPEC.md §4, components/HomeNextUpBody.js).
//
// Data: `root.intranetEvents`, the calendar window the shell already loads
// for the "Coming up" widget (functions/loadPrivateData.js: one day back,
// fourteen ahead) — no new endpoint; `root.intranetEventsLoaded` says the
// window has answered. Every function here is registered, so a body reaches
// it as `el.call('homeNextUp…', …)` and stays closure-free.
//
// MINE: an event is the signed-in user's when its invitee list names them or
// they organised it. (The "Coming up" rule reads the invitee list only, so a
// meeting you organised without inviting yourself never showed there.) The
// feed repeats one booking under several ids; this dedupes by title + start +
// location, as "Coming up" does.
//
// PROVIDERS — the installed apps' own upcoming items (Nika, 2026-09-28: yes to
// "Next up with CRM viewings as the main item"; crm-w1's twin QA F3: the
// widget said "Nothing coming up" over 19 upcoming viewings). An installed
// app answers `homeUpcoming(ctx)` → Promise<Item[]>, a module function
// (Frank-discovered `functions/homeUpcoming.js`) reached through the app's
// OWN module context — the carrier the greeting's homeSignals uses
// (HOME_SIGNALS_CONTRACT v1, functions/homeSignals.js); backend reads inside a
// provider go through @symbo.ls/sdk.
//
//   Item = { id: '<app>.<kind>.<recordId>', kind: 'viewing' | …,
//            title,            // the words a person reads ("Viewing · Salome K.")
//            startAt, endAt?,  // ISO
//            place?,           // where, when the app knows it
//            href }            // an in-app route; Open takes it through openInSlot
//
//   ctx = { root (the app's state root), shell, sdk, workspaceId, lang, now,
//           limit: 5, app, appId }
//
// Rules: Next up is the signed-in person's agenda, so the APP decides whose
// items these are (its own "mine"); at most five, not ended at ctx.now; a
// provider has 5 s (a hang is cut and retried on the next pass); a throw
// reads as none and logs once per pass; one pass per minute per workspace,
// kept on the body's own state (`upcoming`) — no root key.

var $g7CNh = parcelRequire("g7CNh");
const $3ed6a914c7403679$var$_ms = (v)=>{
    if (v == null || v === '') return NaN;
    const t = new Date(v).getTime();
    return Number.isFinite(t) ? t : NaN;
};
const $3ed6a914c7403679$var$_endMs = (e)=>{
    const end = $3ed6a914c7403679$var$_ms(e && e.endAt);
    return Number.isFinite(end) ? end : $3ed6a914c7403679$var$_ms(e && e.startAt);
};
const $3ed6a914c7403679$var$_nextUpNow = (now)=>Number.isFinite(now) && now > 0 ? now : Date.now();
const $3ed6a914c7403679$var$HM = {
    hour: '2-digit',
    minute: '2-digit'
};
const $3ed6a914c7403679$export$91894ce42a393872 = function homeNextUpEvents(root, now) {
    const r = root || {};
    const me = r.currentUserEmail || '';
    const t = $3ed6a914c7403679$var$_nextUpNow(now);
    const seen = new Set();
    return (Array.isArray(r.intranetEvents) ? r.intranetEvents : []).filter((e)=>{
        if (!e || !me) return false;
        if (!Number.isFinite($3ed6a914c7403679$var$_ms(e.startAt)) || $3ed6a914c7403679$var$_endMs(e) <= t) return false;
        const invited = Array.isArray(e.attendees) && e.attendees.includes(me);
        if (!invited && e.organizerEmail !== me) return false;
        const key = (e.title || '') + '|' + (e.startAt || '') + '|' + (e.location || '');
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    }).sort((a, b)=>$3ed6a914c7403679$var$_ms(a.startAt) - $3ed6a914c7403679$var$_ms(b.startAt));
};
const $3ed6a914c7403679$export$22a3074f9d181b3f = function homeNextUpHero(event, now) {
    const start = $3ed6a914c7403679$var$_ms(event && event.startAt);
    if (!Number.isFinite(start)) return null;
    const mins = Math.ceil((start - $3ed6a914c7403679$var$_nextUpNow(now)) / 60000);
    if (mins <= 0) return {
        value: this.call('polyglot', 'common.timeShort.now'),
        before: '',
        after: ''
    };
    let key = 'workspace.widget.nextUp.inHours';
    let n = Math.max(1, Math.round(mins / 60));
    if (mins < 60) {
        key = 'workspace.widget.nextUp.inMinutes';
        n = mins;
    } else if (mins >= 1440) return {
        value: this.call('localizedDate', event.startAt, {
            weekday: 'long'
        }),
        before: '',
        after: ''
    };
    const tpl = String(this.call('polyglot', key));
    const at = tpl.indexOf('{n}');
    if (at < 0) return {
        value: String(n),
        before: '',
        after: tpl
    };
    return {
        value: String(n),
        before: tpl.slice(0, at).trim(),
        after: tpl.slice(at + 3).trim()
    };
};
const $3ed6a914c7403679$export$268d7e8349728d8c = function homeNextUpTime(event) {
    if (!event || !event.startAt) return '';
    const from = this.call('localizedDate', event.startAt, $3ed6a914c7403679$var$HM);
    const to = event.endAt ? this.call('localizedDate', event.endAt, $3ed6a914c7403679$var$HM) : '';
    let zone = '';
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        zone = tz.split('/').pop().replace(/_/g, ' ');
    } catch (_) {
        zone = '';
    }
    const range = to && to !== from ? from + " \u2013 " + to : from;
    return zone ? range + " \xb7 " + zone : range;
};
const $3ed6a914c7403679$export$33f3533c2e0b5ae1 = function homeNextUpRows(root, now, upcoming) {
    const t = $3ed6a914c7403679$var$_nextUpNow(now);
    const midnight = new Date(t);
    midnight.setHours(24, 0, 0, 0);
    return $3ed6a914c7403679$export$46556224753d115c.call(this, root, t, upcoming).slice(1).map((x)=>{
        const hm = this.call('localizedDate', x.startAt, $3ed6a914c7403679$var$HM);
        const later = $3ed6a914c7403679$var$_ms(x.startAt) >= midnight.getTime();
        return {
            key: x.key,
            title: x.title,
            meta: later ? this.call('localizedDate', x.startAt, {
                weekday: 'short'
            }) + ' ' + hm : hm,
            mark: true,
            open: x.event ? {
                call: 'openEventDetailModal',
                arg: x.event
            } : {
                call: 'homeNextUpOpen',
                arg: x
            }
        };
    });
};
const $3ed6a914c7403679$export$5c1fd352e775f811 = function homeNextUpAction(item) {
    if (!item) return null;
    if (item.kind && item.kind !== 'event' && !item.event) return item.href ? {
        label: 'common.action.open',
        call: 'homeNextUpOpen'
    } : null;
    const event = item.event || item;
    if (this.call('eventHasMeetLink', event)) return {
        label: 'workspace.rows.join',
        call: 'joinEventCall'
    };
    return {
        label: 'common.action.open',
        call: 'openEventDetailModal'
    };
};
const $3ed6a914c7403679$export$f59111953f56dd67 = function homeNextUpActionArg(item) {
    return item && item.event ? item.event : item;
};
const $3ed6a914c7403679$export$aa1180f331b56d64 = function homeNextUpOpen(item) {
    if (!item) return;
    if (item.event) return this.call('openEventDetailModal', item.event);
    if (item.href) return this.call('openInSlot', item.href, this);
};
const $3ed6a914c7403679$export$cd0274a7d1cfd451 = function homeNextUpNormalize(list, app, now) {
    if (!Array.isArray(list) || typeof app !== 'string' || !app) return [];
    const t = $3ed6a914c7403679$var$_nextUpNow(now);
    const out = [];
    const seen = new Set();
    for (const x of list){
        if (!x || typeof x !== 'object') continue;
        const title = typeof x.title === 'string' ? x.title.trim() : '';
        const start = $3ed6a914c7403679$var$_ms(x.startAt);
        if (!title || !Number.isFinite(start)) continue;
        const end = $3ed6a914c7403679$var$_ms(x.endAt);
        if ((Number.isFinite(end) ? end : start) <= t) continue;
        const key = typeof x.id === 'string' && x.id ? x.id : app + '.' + start + '.' + title;
        if (seen.has(key)) continue;
        seen.add(key);
        out.push({
            key: key,
            app: app,
            kind: typeof x.kind === 'string' && x.kind && x.kind !== 'event' ? x.kind : 'item',
            title: title,
            startAt: new Date(start).toISOString(),
            endAt: Number.isFinite(end) ? new Date(end).toISOString() : null,
            place: typeof x.place === 'string' ? x.place : '',
            href: typeof x.href === 'string' && /^\/(?!\/)/.test(x.href) ? x.href : null
        });
    }
    out.sort((a, b)=>$3ed6a914c7403679$var$_ms(a.startAt) - $3ed6a914c7403679$var$_ms(b.startAt));
    return out.slice(0, 5);
};
const $3ed6a914c7403679$export$bf2440096abf094b = function homeNextUpProviders(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const out = [];
    const seen = new Set();
    const apps = [];
    const wp = r.workspaceProject;
    if (wp && wp.id) apps.push(wp);
    for (const a of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])apps.push(a);
    const getCtx = typeof r._moduleDsCtxGet === 'function' ? r._moduleDsCtxGet : null;
    const getState = typeof r._moduleStateGet === 'function' ? r._moduleStateGet : null;
    for (const entry of apps){
        const appId = entry && entry.id ? String(entry.id) : '';
        if (!appId || seen.has(appId)) continue;
        seen.add(appId);
        // Still SETTING UP (`pendingWidgets` an array on its published entry) or
        // its setup FAILED (`setupFailed: true`): no state root to read, so it is
        // never asked — homeNextUpAppsKnown keeps "nothing" back when it feeds
        // Next up.
        if (Array.isArray(entry.pendingWidgets) || entry.setupFailed === true) continue;
        const modCtx = getCtx ? getCtx(appId) : null;
        const fns = modCtx && modCtx.functions;
        const own = fns && Object.prototype.hasOwnProperty.call(fns, 'homeUpcoming') ? fns.homeUpcoming : null;
        if (typeof own !== 'function') continue;
        const app = appId.split('/').pop().replace(/-app$/, '');
        const stateRoot = getState && getState(appId) || r;
        const shim = {
            key: 'homeUpcoming',
            context: modCtx,
            sdk: el && el.sdk || null,
            state: {
                root: stateRoot
            },
            call: (name, ...args)=>{
                const f = modCtx.functions[name];
                return typeof f === 'function' ? f.apply(shim, args) : undefined;
            }
        };
        out.push({
            app: app,
            appId: appId,
            run: (ctx)=>own.call(shim, {
                    ...ctx,
                    app: app,
                    appId: appId,
                    root: stateRoot,
                    shell: r
                })
        });
    }
    return out;
};
const $3ed6a914c7403679$export$a635b6ddfc5b90be = function homeNextUpAppsKnown(root) {
    const r = root && typeof root === 'object' ? root : {};
    // The workspace RECORD first (homeSignals.js homeSignalsProviders, the same
    // rule — both readers answer one question): before the full record arrives
    // its settings bag is absent and the installed-apps list reads [] — not
    // "no apps". Loaded = the settings bag or the full-record stamp; while an id
    // is known and the completion is in flight, NOT known; a completion that
    // definitively failed (`_completionUnreachable`) is terminal.
    const w = r.workspace;
    const settingsReady = !!w && (w._shape === 'full' || !!w.settings && typeof w.settings === 'object');
    if (!settingsReady && !!w && !!(w.id || w._id) && !w._completionUnreachable) return false;
    const settings = settingsReady && w.settings || {};
    // Installed APP entries only (the loader's rule, workspaceConfigs.js
    // installedAppRefs): a records-grant row never loads, so it never publishes.
    const appsKnown = !(0, $g7CNh.installedAppRefs)(settings).length || Array.isArray(r.workspaceApps);
    const moduleKnown = !settings.workspaceModule || !!r.workspaceProject;
    // An app still setting up (`pendingWidgets` an array) or whose setup failed
    // (`setupFailed: true`) has not answered — and a failed one never will, so
    // the card never says "nothing" over it. It holds Next up back only when it
    // FEEDS Next up: `homeProviders` (published by the loader at the first apps
    // pass) names 'upcoming'; [] or a list without it never blocks. An entry
    // without the field (an older loader) keeps the wait.
    const published = [
        r.workspaceProject
    ].concat(Array.isArray(r.workspaceApps) ? r.workspaceApps : []);
    const holding = published.some((e)=>{
        if (!e || !(Array.isArray(e.pendingWidgets) || e.setupFailed === true)) return false;
        const feeds = e.homeProviders;
        return !Array.isArray(feeds) || feeds.includes('upcoming');
    });
    return appsKnown && moduleKnown && !holding;
};
const $3ed6a914c7403679$export$b8a37b0562a8a0f9 = function homeNextUpProviderSig(root) {
    const el = this;
    const list = el && typeof el.call === 'function' ? el.call('homeNextUpProviders', root) || [] : [];
    return list.map((p)=>p.appId).sort().join('|');
};
const $3ed6a914c7403679$export$9bc6b691a240c34d = async function homeNextUpCollect(opts) {
    const el = this;
    const o = opts && typeof opts === 'object' ? opts : {};
    const s = el && el.state;
    const r = s && s.root;
    if (!s || !r || typeof s.update !== 'function') return null;
    const wsOf = ()=>r.workspace && String(r.workspace.id || r.workspace._id || '') || null;
    const ws = wsOf();
    if (!ws) return null;
    const now = typeof o.now === 'number' ? o.now : Date.now();
    const TTL = typeof o.ttl === 'number' ? o.ttl : 60000;
    const BUDGET = typeof o.budget === 'number' ? o.budget : 5000;
    let providers = [];
    try {
        providers = el.call('homeNextUpProviders', r) || [];
    } catch (err) {
        console.warn('[home] next-up providers unavailable:', err && err.message);
    }
    const sig = providers.map((p)=>p.appId).sort().join('|');
    const cur = s.upcoming;
    // A pass is kept for a minute — for the SAME provider set: a provider that
    // registers after it (a cold load publishes the apps later) runs at once.
    if (cur && cur.ws === ws && cur.sig === sig && now - cur.at < TTL) return cur;
    if (el.__homeNextUpPass) return cur || null;
    el.__homeNextUpPass = true;
    try {
        const ctx = {
            sdk: el.sdk || null,
            workspaceId: ws,
            lang: r.lang || 'en',
            now: now,
            limit: 5
        };
        // The budget timer is CLEARED when its race settles — never `unref`'d. An
        // unref'd timer cannot hold the loop open, so when a hung provider is the
        // last work on it the loop drains, the budget never fires, the race never
        // settles and the whole pass is left pending. Under `node --test` that
        // reads as "Promise resolution is still pending but the event loop has
        // already resolved", and it cancelled four tests on node v22.23.4 while
        // node v24.22.1 happened to hide it. Clearing gives the budget the one
        // thing unref took away — the ability to fire — and still leaves no handle
        // behind once the provider answered.
        const cut = ()=>{
            let timer;
            const promise = new Promise((resolve)=>{
                timer = setTimeout(()=>resolve({
                        hung: true
                    }), BUDGET);
            });
            return {
                promise: promise,
                clear: ()=>clearTimeout(timer)
            };
        };
        const answers = await Promise.all(providers.map((p)=>{
            const budget = cut();
            return Promise.race([
                Promise.resolve().then(()=>p.run(ctx)).then((list)=>({
                        list: list
                    }), (err)=>({
                        err: err
                    })),
                budget.promise
            ]).then((a)=>({
                    app: p.app,
                    ...a
                })).finally(budget.clear);
        }));
        const items = [];
        for (const a of answers){
            if (a.err) console.warn("[home] next-up provider failed \u2014 read as none:", a.app, a.err && a.err.message);
            else if (a.hung) console.warn('[home] next-up provider did not answer in time:', a.app);
            if (a.list) items.push(...el.call('homeNextUpNormalize', a.list, a.app, now));
        }
        if (wsOf() !== ws) return null;
        const next = {
            ws: ws,
            sig: sig,
            at: now,
            items: items,
            answered: true
        };
        s.update({
            upcoming: next
        }, {
            preventFetch: true
        });
        return next;
    } finally{
        el.__homeNextUpPass = false;
    }
};
const $3ed6a914c7403679$export$46556224753d115c = function homeNextUpItems(root, now, upcoming) {
    const t = $3ed6a914c7403679$var$_nextUpNow(now);
    const events = $3ed6a914c7403679$export$91894ce42a393872.call(this, root, t).map((e, i)=>({
            key: String(e.id != null ? e.id : 'e' + i),
            kind: 'event',
            title: e.title || '',
            startAt: e.startAt,
            endAt: e.endAt || null,
            event: e
        }));
    const items = (upcoming && Array.isArray(upcoming.items) ? upcoming.items : []).filter((x)=>{
        const end = $3ed6a914c7403679$var$_ms(x && x.endAt);
        return x && (Number.isFinite(end) ? end : $3ed6a914c7403679$var$_ms(x.startAt)) > t;
    });
    return [
        ...events,
        ...items
    ].sort((a, b)=>$3ed6a914c7403679$var$_ms(a.startAt) - $3ed6a914c7403679$var$_ms(b.startAt));
};
const $3ed6a914c7403679$export$29622c7304943f6a = function homeNextUpClock() {
    const el = this;
    if (!el || el.__homeNextUpClock || typeof setInterval !== 'function') return;
    const iv = setInterval(()=>{
        if (!el.node || !el.state || typeof el.state.update !== 'function') {
            clearInterval(iv);
            el.__homeNextUpClock = null;
            return;
        }
        el.state.update({
            now: Date.now()
        }, {
            preventFetch: true
        });
        // The providers' pass keeps its own minute (homeNextUpCollect's TTL).
        el.call('homeNextUpCollect');
    }, 30000);
    // Node (the jsdom tests) must not wait on the clock to exit.
    if (iv && typeof iv.unref === 'function') iv.unref();
    el.__homeNextUpClock = iv;
};
const $3ed6a914c7403679$export$799f3c28980b5f43 = function homeNextUpClockStop() {
    const el = this;
    if (el && el.__homeNextUpClock) {
        clearInterval(el.__homeNextUpClock);
        el.__homeNextUpClock = null;
    }
};

});

parcelRegister("dTMvK", function(module, exports) {

$parcel$export(module.exports, "homePinnedBlock", () => $a1e60ab3099f6026$export$48848071d2753cd);
$parcel$export(module.exports, "homePinnedHostRow", () => $a1e60ab3099f6026$export$6ffee4e2f2d2cb55);
// PINNED BOARD ITEMS on the home (DESIGN-WL-ASSISTANT-MAIN-HOME-1 — the shell
// half of the widgetDefs contract CORE-WIDGETDEFS-ACCEPT-BOARD-ITEMS-1, live on
// dev since server c9b2ea7).
//
// A pin (functions/assistantBoard.js pinBoardItem → aiCreateWidget) writes ONE
// `workspaceAiWidgets` row, and the server answers with its `kind`:
//   'widget' { widget: '<app>.<widget id>', params }  an installed app's widget
//   'block'  { block: { type, data, format?, source? } }  the values it showed
//   'recipe' { dataRecipe, body }                      the older AI widgets
// dataRecipe / body are null for 'widget' and 'block', so the home cannot hand
// those rows to WidgetRenderer as they are. homePinnedHostRow turns a row into
// what the home host draws — the SAME card the board drew:
//   widget → the app's own widget entry (module, body, params schema) with the
//            pinned params: the module host mounts it with frame contract v1
//            (scope.params = the schema's defaults + these values);
//   block  → the ONE reviewed block definition (the board's own validator) and
//            its static data (`blockData`), which the host seeds into the
//            AI-widget data bag before WidgetRenderer mounts;
//   an app that is not installed (any more) → the row as it is: WidgetRenderer
//            draws the server's capability notice (viewerCapability
//            not_installed), never a blank card.
//
// FRANK: every export is self-contained (FA204); the board's validator is a
// cross-file import.

var $a54EB = parcelRequire("a54EB");

var $ai0fh = parcelRequire("ai0fh");
const $a1e60ab3099f6026$export$48848071d2753cd = (block)=>{
    if (!block || typeof block !== 'object' || typeof block.type !== 'string') return null;
    const data = block.data;
    const res = (0, $a54EB.validateBoardSpec).call(null, {
        items: [
            {
                kind: 'block',
                block: block.type,
                data: data,
                format: block.format,
                source: block.source || {}
            }
        ]
    }, {
        widgets: {}
    });
    const it = res && Array.isArray(res.items) ? res.items[0] : null;
    if (!it || it.kind !== 'block') return null;
    return {
        type: it.block,
        def: it.def,
        data: it.data
    };
};
const $a1e60ab3099f6026$export$6ffee4e2f2d2cb55 = (row, moduleRows)=>{
    if (!row || typeof row !== 'object') return row;
    const kind = row.kind || (typeof row.widget === 'string' ? 'widget' : row.block && typeof row.block === 'object' ? 'block' : 'recipe');
    if (kind === 'widget' && typeof row.widget === 'string') {
        const at = row.widget.lastIndexOf('.');
        const app = at > 0 ? row.widget.slice(0, at) : '';
        const id = at > 0 ? row.widget.slice(at + 1) : '';
        const aliases = (moduleId)=>{
            const full = String(moduleId || '');
            const key = full.split('/').pop();
            return [
                full,
                key,
                key.replace(/-app$/, '')
            ];
        };
        const entry = (Array.isArray(moduleRows) ? moduleRows : []).find((w)=>w && w.id === id && w.moduleId && aliases(w.moduleId).includes(app));
        if (!entry) return {
            ...row,
            kind: kind
        };
        const layout = {};
        for (const k of [
            'w',
            'h',
            'minW',
            'minH',
            'maxW',
            'maxH'
        ])if (row.spec && Number.isFinite(row.spec[k])) layout[k] = row.spec[k];
        return {
            ...row,
            kind: kind,
            moduleId: entry.moduleId,
            body: entry.body,
            spec: {
                ...entry.spec || {},
                ...layout,
                params: entry.params || entry.spec && entry.spec.params || {}
            },
            params: row.params && typeof row.params === 'object' ? row.params : {},
            title: row.title || entry.title,
            icon: row.icon || entry.icon,
            hue: row.hue || entry.hue || null,
            pinnedFrom: row.widget
        };
    }
    // A RECORDS row (WIDGET-TOOLS-RECORDS-SHAPE-1) takes the block's CONTENT
    // size — the board's own rule — as its size and its floor (a chart in an S
    // cell was squeezed; dev 2026-10-04). Its hue stays its own: without one the
    // records block draws in the text ink (AssistantRecordsBlock).
    if (kind === 'records' && row.records && typeof row.records === 'object') {
        const size = (0, $ai0fh.recordsContentSize)(row.records);
        return {
            ...row,
            kind: kind,
            size: size,
            minSize: size
        };
    }
    if (kind === 'block') {
        // FA204 — the block read is restated here (homePinnedBlock's body): a
        // same-file sibling export does not survive frank.toJSON.
        const block = row.block;
        if (!block || typeof block !== 'object' || typeof block.type !== 'string') return {
            ...row,
            kind: kind
        };
        const data = block.data;
        const res = (0, $a54EB.validateBoardSpec).call(null, {
            items: [
                {
                    kind: 'block',
                    block: block.type,
                    data: data,
                    format: block.format,
                    source: block.source || {}
                }
            ]
        }, {
            widgets: {}
        });
        const it = res && Array.isArray(res.items) ? res.items[0] : null;
        if (!it || it.kind !== 'block') return {
            ...row,
            kind: kind
        };
        return {
            ...row,
            kind: kind,
            body: {
                blocks: [
                    it.def
                ]
            },
            blockData: it.data
        };
    }
    return row;
};

});

parcelRegister("bkUUf", function(module, exports) {

$parcel$export(module.exports, "homeLookNormalize", () => $840db45656f60677$export$e2e8d2802cb484a9);
$parcel$export(module.exports, "readStoredHomeLook", () => $840db45656f60677$export$273bf2dbf2fbc95b);
$parcel$export(module.exports, "homeLookRead", () => $840db45656f60677$export$924816c94d084675);
$parcel$export(module.exports, "homeLookSet", () => $840db45656f60677$export$f8523f2a41f67f7d);
$parcel$export(module.exports, "homeLookSyncCache", () => $840db45656f60677$export$1a6947ca358bbe46);
$parcel$export(module.exports, "homeLookSetTheme", () => $840db45656f60677$export$3dadfc1a72bcad4f);
$parcel$export(module.exports, "homeLookSetStripStyle", () => $840db45656f60677$export$96bf6803407c0b61);
$parcel$export(module.exports, "homeAppStripLookHidden", () => $840db45656f60677$export$3f69ab1c1e2657ca);
$parcel$export(module.exports, "homeLookSetSkyLayout", () => $840db45656f60677$export$5675565b2322fd10);
$parcel$export(module.exports, "homeLookSetSummaryStyle", () => $840db45656f60677$export$eb2330bab47c1014);
$parcel$export(module.exports, "homeLookMoveApp", () => $840db45656f60677$export$8893361ea78ea834);
$parcel$export(module.exports, "homeSkyActive", () => $840db45656f60677$export$3f481a3186cd7f0c);
$parcel$export(module.exports, "homeSkyChoices", () => $840db45656f60677$export$41bb2b0e3eb2277c);
// homeLook.js — THE PERSON'S OWN LOOK OF THE HOME TOP
// (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1; Nika's picks 2026-09-28, rows 1, 2, 4:
// the App strip as a Dock OR a Rail, the summary as a Brief OR Signals, one
// grouped Personalise panel with a per-user background).
//
// ONE bag on the user record, `user_preferences.homeLook`:
//   stripShown    boolean                the App strip on / off
//   stripStyle    'dock' | 'rail'        one glass capsule above the board, or
//                                        a slim rail beside it
//   stripLabels   boolean                app names under the glyphs (off = the
//                                        name on hover and focus)
//   navbarIcons   boolean                the navbar tabs as glyph plates, each
//                                        name in the house tooltip (Nika
//                                        2026-10-23: "try changing text navbar
//                                        items with icons" — default ON); off =
//                                        the text tabs (2026-10-02: optional)
//   navbarPosition      'top' | 'left' |  where the workspace host's navbar
//                       'right' | 'bottom' sits (Nika 2026-10-24: "make sidebar
//                                        optional to be positioned at the top
//                                        left right or bottom") — default
//                                        'left' (Nika 2026-10-27: "also make
//                                        navbar left by default"; it was 'top',
//                                        2026-10-24 "for normal workspace keep
//                                        as is")
//   navbarExpanded      boolean          a left / right rail shows the names
//                                        beside the glyphs ("left and right
//                                        sidebars can be toggle expandable")
//   commNavbarPosition  the same four    the comm host's own ("for com - move
//                                        to the left") — default 'left'
//   commNavbarExpanded  boolean          the comm host's rail, expanded
//   summaryStyle  'brief' | 'signals'    two calm sentences, or four tiles
//   sky           a sky of the files plane ('clouds', 'dunes', … — whatever
//                 files/ambient holds), 'none', or null = follow the
//                 workspace's appearance
//   skyLayout     'top' | 'bottom'       where the ambient sky sits on the
//                                        home (DESIGN-WL-HOME-SKY-TOP-GROUND-1,
//                                        Nika 2026-10-01: "clouds and mountain
//                                        should be the default", "keep bottom
//                                        moving clouds as one of the options"):
//                                        'top' = the clouds hang from the top
//                                        and the mountain ground rises at the
//                                        end of the home scroll (the default);
//                                        'bottom' = the clouds in the bottom
//                                        band, no ground (the layout before)
// A PERSON's choice, like `themeMode` beside it on the same row: it follows
// them to every workspace and every device. An explicit sky wins over the
// workspace's own (functions/ambientBackdrop.js `resolveSky`).
//
// PRECEDENCE — the record wins at boot:
//   1. this session's decision (`root._homeLook`, written by homeLookSet) — it
//      is newer than any read, including a record that lands after it;
//   2. the record (`root.userPrefs.homeLook`) once the row has loaded;
//   3. this device's copy (localStorage `symbols_home_look`) — it paints before
//      the record arrives and mirrors the record once it has (homeLookSyncCache);
//      every tab of the device shares it, so each write is stamped
//      (`symbols_home_look_at`) and no tab writes an older look over it;
//      like the record and the session look it holds the person's EXPLICIT
//      choices only, never a default, so a changed default reaches everybody
//      who never chose that key;
//   4. the defaults: Nika's recommended picks — the strip shown as a Dock with
//      the names on hover, the Brief, the workspace's own sky, the sky at
//      the top with the mountain ground.
//
// WRITES ARE DECISIONS (the home-prefs durability law): at once, never
// debounced, and SINGLE-FLIGHT on the queue every writer of the
// user_preferences row already shares (`root.__navbarSaveQueue` — the navbar
// tabs, the assistant starters): one request at a time, the payload composed
// at SEND time from the live row (the update REPLACES the row, so a payload
// built at click time would drop what another writer landed meanwhile), the
// newest decision lands last. A row that has not loaded is read first — a
// write never replaces the account's other preferences with one key. The
// response is adopted only when no newer decision is waiting, so Dock → Rail →
// Dock never flickers back through Rail.
//
// FRANK: every export is self-contained (FA204) — the vocabularies and the
// defaults are restated where they are used; siblings are reached through
// `this.call`.
// The record bag, the device copy, then the defaults, one key at a time; only
// valid values pass. Pure: `homeLookNormalize(bag)` → the valid keys only.
const $840db45656f60677$export$e2e8d2802cb484a9 = function homeLookNormalize(bag) {
    const out = {};
    if (!bag || typeof bag !== 'object') return out;
    if (typeof bag.stripShown === 'boolean') out.stripShown = bag.stripShown;
    if (bag.stripStyle === 'dock' || bag.stripStyle === 'rail') out.stripStyle = bag.stripStyle;
    if (typeof bag.stripLabels === 'boolean') out.stripLabels = bag.stripLabels;
    if (typeof bag.navbarIcons === 'boolean') out.navbarIcons = bag.navbarIcons;
    for (const k of [
        'navbarPosition',
        'commNavbarPosition'
    ])if ([
        'top',
        'left',
        'right',
        'bottom'
    ].includes(bag[k])) out[k] = bag[k];
    for (const k of [
        'navbarExpanded',
        'commNavbarExpanded'
    ])if (typeof bag[k] === 'boolean') out[k] = bag[k];
    if (bag.summaryStyle === 'brief' || bag.summaryStyle === 'signals') out.summaryStyle = bag.summaryStyle;
    if (bag.sky === null || typeof bag.sky === 'string' && /^[a-z][a-z0-9-]{0,31}$/.test(bag.sky)) out.sky = bag.sky;
    if (bag.skyLayout === 'top' || bag.skyLayout === 'bottom') out.skyLayout = bag.skyLayout;
    // THE PAGE SIDEBAR'S CHOICE (shared functions/pageSidebar.js): page → hidden.
    // At most 64 pages, each a valid key with a boolean.
    const sh = bag.sidebarHidden;
    if (sh && typeof sh === 'object' && !Array.isArray(sh)) {
        const map = {};
        for (const k of Object.keys(sh).slice(0, 64))if (/^[a-z0-9][a-z0-9_-]{0,63}$/.test(k) && typeof sh[k] === 'boolean') map[k] = sh[k];
        if (Object.keys(map).length) out.sidebarHidden = map;
    }
    return out;
};
const $840db45656f60677$export$273bf2dbf2fbc95b = function readStoredHomeLook(storage) {
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const raw = store ? store.getItem('symbols_home_look') : null;
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_) {
        return null;
    }
};
const $840db45656f60677$export$924816c94d084675 = function homeLookRead(root, storage) {
    const norm = (bag)=>{
        const out = {};
        if (!bag || typeof bag !== 'object') return out;
        if (typeof bag.stripShown === 'boolean') out.stripShown = bag.stripShown;
        if (bag.stripStyle === 'dock' || bag.stripStyle === 'rail') out.stripStyle = bag.stripStyle;
        if (typeof bag.stripLabels === 'boolean') out.stripLabels = bag.stripLabels;
        if (typeof bag.navbarIcons === 'boolean') out.navbarIcons = bag.navbarIcons;
        for (const k of [
            'navbarPosition',
            'commNavbarPosition'
        ])if ([
            'top',
            'left',
            'right',
            'bottom'
        ].includes(bag[k])) out[k] = bag[k];
        for (const k of [
            'navbarExpanded',
            'commNavbarExpanded'
        ])if (typeof bag[k] === 'boolean') out[k] = bag[k];
        if (bag.summaryStyle === 'brief' || bag.summaryStyle === 'signals') out.summaryStyle = bag.summaryStyle;
        if (bag.sky === null || typeof bag.sky === 'string' && /^[a-z][a-z0-9-]{0,31}$/.test(bag.sky)) out.sky = bag.sky;
        if (bag.skyLayout === 'top' || bag.skyLayout === 'bottom') out.skyLayout = bag.skyLayout;
        // THE PAGE SIDEBAR'S CHOICE (shared functions/pageSidebar.js): page → hidden.
        // At most 64 pages, each a valid key with a boolean.
        const sh = bag.sidebarHidden;
        if (sh && typeof sh === 'object' && !Array.isArray(sh)) {
            const map = {};
            for (const k of Object.keys(sh).slice(0, 64))if (/^[a-z0-9][a-z0-9_-]{0,63}$/.test(k) && typeof sh[k] === 'boolean') map[k] = sh[k];
            if (Object.keys(map).length) out.sidebarHidden = map;
        }
        return out;
    };
    const r = root && typeof root === 'object' ? root : {};
    const session = r._homeLook;
    const prefs = r.userPrefs;
    const record = prefs && typeof prefs === 'object' ? norm(prefs.homeLook) : null;
    const mine = session && typeof session === 'object' ? norm(session) : null;
    let device = null;
    if (!mine && !record) try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const raw = store ? store.getItem('symbols_home_look') : null;
        device = raw ? norm(JSON.parse(raw)) : null;
    } catch (_) {
        device = null;
    }
    return {
        stripShown: true,
        stripStyle: 'dock',
        stripLabels: false,
        navbarIcons: true,
        navbarPosition: 'left',
        navbarExpanded: false,
        commNavbarPosition: 'left',
        commNavbarExpanded: false,
        summaryStyle: 'brief',
        sky: null,
        skyLayout: 'top',
        ...device || {},
        ...record || {},
        ...mine || {},
        // A MAP, merged page by page (shared functions/pageSidebar.js): a page this
        // session decided wins; every other page keeps the record's choice (a
        // second device's choice lands with the next row).
        sidebarHidden: {
            ...device && device.sidebarHidden || {},
            ...record && record.sidebarHidden || {},
            ...mine && mine.sidebarHidden || {}
        }
    };
};
const $840db45656f60677$export$f8523f2a41f67f7d = function homeLookSet(patch, opts) {
    const norm = (bag)=>{
        const out = {};
        if (!bag || typeof bag !== 'object') return out;
        if (typeof bag.stripShown === 'boolean') out.stripShown = bag.stripShown;
        if (bag.stripStyle === 'dock' || bag.stripStyle === 'rail') out.stripStyle = bag.stripStyle;
        if (typeof bag.stripLabels === 'boolean') out.stripLabels = bag.stripLabels;
        if (typeof bag.navbarIcons === 'boolean') out.navbarIcons = bag.navbarIcons;
        for (const k of [
            'navbarPosition',
            'commNavbarPosition'
        ])if ([
            'top',
            'left',
            'right',
            'bottom'
        ].includes(bag[k])) out[k] = bag[k];
        for (const k of [
            'navbarExpanded',
            'commNavbarExpanded'
        ])if (typeof bag[k] === 'boolean') out[k] = bag[k];
        if (bag.summaryStyle === 'brief' || bag.summaryStyle === 'signals') out.summaryStyle = bag.summaryStyle;
        if (bag.sky === null || typeof bag.sky === 'string' && /^[a-z][a-z0-9-]{0,31}$/.test(bag.sky)) out.sky = bag.sky;
        if (bag.skyLayout === 'top' || bag.skyLayout === 'bottom') out.skyLayout = bag.skyLayout;
        // THE PAGE SIDEBAR'S CHOICE (shared functions/pageSidebar.js): page → hidden.
        // At most 64 pages, each a valid key with a boolean.
        const sh = bag.sidebarHidden;
        if (sh && typeof sh === 'object' && !Array.isArray(sh)) {
            const map = {};
            for (const k of Object.keys(sh).slice(0, 64))if (/^[a-z0-9][a-z0-9_-]{0,63}$/.test(k) && typeof sh[k] === 'boolean') map[k] = sh[k];
            if (Object.keys(map).length) out.sidebarHidden = map;
        }
        return out;
    };
    const el = this && typeof this === 'object' ? this : null;
    const o = opts && typeof opts === 'object' ? opts : {};
    const root = o.root || el && el.state && el.state.root || null;
    const sdk = o.sdk || el && el.sdk || null;
    const change = norm(patch);
    if (!root || typeof root.update !== 'function' || !Object.keys(change).length) return Promise.resolve(null);
    const prefs = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
    // The person's EXPLICIT choices so far — never the effective look: a
    // missing key never becomes a stored value, so a changed default still
    // reaches everybody who never chose that key
    // (DESIGN-WL-HOME-DEFAULTS-ALL-WORKSPACES-1). Same order as the read:
    // this session's decisions, else the record once its row has loaded (a
    // legacy device copy full of defaults heals here), else this device's copy.
    let chosen = null;
    if (root._homeLook && typeof root._homeLook === 'object') chosen = norm(root._homeLook);
    else if (prefs) chosen = norm(prefs.homeLook);
    else try {
        const store = o.storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        const raw = store ? store.getItem('symbols_home_look') : null;
        chosen = raw ? norm(JSON.parse(raw)) : null;
    } catch (_) {
        chosen = null;
    }
    const next = {
        ...chosen || {},
        ...change
    };
    // The page-sidebar map changes PAGE BY PAGE: a decision for one page keeps
    // every other page's choice (shared functions/pageSidebar.js).
    const pages = (bag)=>bag && bag.sidebarHidden || {};
    if (change.sidebarHidden) next.sidebarHidden = {
        ...pages(chosen),
        ...change.sidebarHidden
    };
    const patchState = {
        _homeLook: next
    };
    if (prefs) {
        const was = norm(prefs.homeLook);
        const homeLook = {
            ...was,
            ...change
        };
        if (change.sidebarHidden) homeLook.sidebarHidden = {
            ...pages(was),
            ...change.sidebarHidden
        };
        patchState.userPrefs = {
            ...prefs,
            homeLook: homeLook
        };
    }
    root.update(patchState, {
        preventFetch: true
    });
    // THIS DEVICE'S COPY — READ BEFORE THE WRITE (N3, Nika 2026-10-27: an old
    // tab put back a navbar place the person had changed since). Every tab of
    // this device shares the copy, and this tab's base is as old as its
    // record: when the copy was written AFTER that record could have landed
    // (its stamp `symbols_home_look_at` against this tab's own mark — the note
    // at homeLookSyncCache), another tab wrote it, so the decision lands ON
    // that copy and only the decided keys change. Otherwise this tab's base
    // stands (a legacy copy full of defaults heals here, as before). The
    // record is the source of truth either way: this is its paint-ahead copy.
    const clock = o.clock && typeof o.clock === 'object' ? o.clock : null;
    const now = clock && typeof clock.now === 'function' ? clock.now() : Date.now();
    let mem = root.__homeLookCache;
    if (!mem || typeof mem !== 'object') {
        const bootAt = clock && typeof clock.bootAt === 'number' ? clock.bootAt : typeof performance !== 'undefined' && performance && performance.timeOrigin ? performance.timeOrigin : now;
        mem = root.__homeLookCache = {
            mirrored: null,
            recordAt: bootAt,
            lookedAt: bootAt
        };
    }
    try {
        const store = o.storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        if (store) {
            const at = Number(store.getItem('symbols_home_look_at')) || 0;
            let base = chosen || {};
            if (at > mem.recordAt) {
                const raw = store.getItem('symbols_home_look');
                base = raw ? norm(JSON.parse(raw)) : {};
            }
            const copy = {
                ...base,
                ...change
            };
            if (change.sidebarHidden) copy.sidebarHidden = {
                ...pages(base),
                ...change.sidebarHidden
            };
            store.setItem('symbols_home_look', JSON.stringify(copy));
            store.setItem('symbols_home_look_at', String(now));
        }
    } catch (err) {
        console.warn('[home] look cache write failed:', err && err.message);
    }
    // This tab's own write is no news for the mirror: the record it just
    // patched is the one it composed, never a row from the server.
    if (patchState.userPrefs) mem.mirrored = JSON.stringify(patchState.userPrefs.homeLook);
    if (!sdk || typeof sdk.execute !== 'function') return Promise.resolve(null);
    // The queue every user_preferences writer shares, keyed as they key it.
    const w = root.workspace;
    const key = String(w && (w.id || w._id) || root.jwtClaims && root.jwtClaims.active_workspace_id || '') || 'user';
    if (!root.__navbarSaveQueue) root.__navbarSaveQueue = new Map();
    const queue = root.__navbarSaveQueue;
    root.__homeLookSeq = (root.__homeLookSeq || 0) + 1;
    const seq = root.__homeLookSeq;
    const prior = queue.get(key) || Promise.resolve();
    const task = prior.catch(()=>{}).then(async ()=>{
        // PER-PATH PATCH — one path per CHANGED homeLook key, so neither
        // another top-level preference nor a DIFFERENT homeLook key a second
        // tab wrote is overwritten (CORE-USERPREFS-PATCH-PER-PATH-1).
        const row = await sdk.execute('workspaceProject.userPreferences', 'patch', {
            patch: {
                // …and the page-sidebar map one path per PAGE, so another tab's
                // choice for another page is never overwritten.
                set: Object.entries(change).flatMap(([k, v])=>k === 'sidebarHidden' ? Object.entries(v).map(([page, hide])=>({
                            path: [
                                'homeLook',
                                'sidebarHidden',
                                page
                            ],
                            value: hide
                        })) : [
                        {
                            path: [
                                'homeLook',
                                k
                            ],
                            value: v
                        }
                    ])
            }
        });
        // Adopt the confirmed row only when no newer decision is waiting.
        if (seq === root.__homeLookSeq && row && typeof row === 'object') {
            const now = root.userPrefs && typeof root.userPrefs === 'object' ? root.userPrefs : null;
            root.update({
                userPrefs: now ? {
                    ...now,
                    homeLook: row.homeLook || {
                        ...norm(now.homeLook),
                        ...change
                    }
                } : row
            }, {
                preventFetch: true
            });
        }
        return row;
    });
    queue.set(key, task);
    return task.catch((err)=>{
        console.warn('[home] look save failed:', err && err.message);
        return null;
    });
};
const $840db45656f60677$export$1a6947ca358bbe46 = function homeLookSyncCache(root, storage, clock) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return false;
    const c = clock && typeof clock === 'object' ? clock : null;
    const now = c && typeof c.now === 'function' ? c.now() : Date.now();
    let mem = r.__homeLookCache;
    if (!mem || typeof mem !== 'object') {
        const bootAt = c && typeof c.bootAt === 'number' ? c.bootAt : typeof performance !== 'undefined' && performance && performance.timeOrigin ? performance.timeOrigin : now;
        mem = r.__homeLookCache = {
            mirrored: null,
            recordAt: bootAt,
            lookedAt: bootAt
        };
    }
    const lookedAt = mem.lookedAt;
    mem.lookedAt = now;
    const prefs = r.userPrefs;
    const bag = prefs && typeof prefs === 'object' ? prefs.homeLook : null;
    if (!bag || typeof bag !== 'object') return false;
    const next = JSON.stringify(bag);
    if (mem.mirrored === next) return false;
    mem.mirrored = next;
    mem.recordAt = lookedAt;
    try {
        const store = storage || (typeof localStorage !== 'undefined' ? localStorage : null);
        if (!store) return false;
        const at = Number(store.getItem('symbols_home_look_at')) || 0;
        if (at > mem.recordAt) return false;
        if (store.getItem('symbols_home_look') === next) return false;
        store.setItem('symbols_home_look', next);
        store.setItem('symbols_home_look_at', String(now));
        return true;
    } catch (_) {
        return false;
    }
};
const $840db45656f60677$export$3dadfc1a72bcad4f = function homeLookSetTheme(mode) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function' || typeof el.call !== 'function') return;
    const next = el.call('normalizeThemeMode', mode);
    root.update({
        themeMode: next
    }, {
        preventFetch: true
    });
    el.call('writeStoredThemeMode', next);
    el.call('changeGlobalTheme', next);
    el.call('persistThemeModeToUser', root, el.sdk, next);
};
const $840db45656f60677$export$96bf6803407c0b61 = function homeLookSetStripStyle(value) {
    if (this && typeof this.call === 'function') return this.call('homeLookSet', {
        stripStyle: value
    });
};
const $840db45656f60677$export$3f69ab1c1e2657ca = function homeAppStripLookHidden(root, style) {
    const look = (this && typeof this.call === 'function' ? this.call('homeLookRead', root) : null) || {};
    if (look.stripShown === false) return true;
    return style === 'rail' && look.stripStyle !== 'rail';
};
const $840db45656f60677$export$5675565b2322fd10 = function homeLookSetSkyLayout(value) {
    if (this && typeof this.call === 'function') return this.call('homeLookSet', {
        skyLayout: value
    });
};
const $840db45656f60677$export$eb2330bab47c1014 = function homeLookSetSummaryStyle(value) {
    if (this && typeof this.call === 'function') return this.call('homeLookSet', {
        summaryStyle: value
    });
};
const $840db45656f60677$export$8893361ea78ea834 = function homeLookMoveApp(id, targetId) {
    const el = this;
    const root = el && el.state && el.state.root;
    const ops = root && root._homeOps;
    if (!ops || typeof ops.moveWidget !== 'function' || !id || !targetId || id === targetId) return false;
    ops.moveWidget(id, targetId);
    if (typeof ops.persistLayout === 'function') ops.persistLayout();
    return true;
};
const $840db45656f60677$export$3f481a3186cd7f0c = function homeSkyActive(s) {
    const el = this;
    if (!el || typeof el.call !== 'function') return null;
    const root = s && s.root;
    const look = el.call('homeLookRead', root);
    if (look && look.sky) return look.sky;
    const state = el.call('ambientSkyState', s);
    if (state && state.sky) return state.sky;
    return state && state.reason === 'sky-none' ? 'none' : null;
};
const $840db45656f60677$export$41bb2b0e3eb2277c = function homeSkyChoices() {
    const el = this;
    const names = {
        clouds: 'workspace.personalize.skyClouds',
        dunes: 'workspace.personalize.skyDunes',
        hills: 'workspace.personalize.skyHills',
        lake: 'workspace.personalize.skyLake',
        window: 'workspace.personalize.skyWindow',
        mountains: 'workspace.personalize.skyMountains'
    };
    const files = el && el.context && el.context.files && typeof el.context.files === 'object' ? el.context.files : {};
    const skies = [];
    for (const key of Object.keys(files)){
        const m = /^(?:\/files\/)?ambient\/([a-z][a-z0-9-]{0,31})\.png$/.exec(key);
        if (m && !skies.includes(m[1])) skies.push(m[1]);
    }
    const rows = skies.map((sky)=>({
            key: sky,
            value: sky,
            label: names[sky] || sky
        }));
    rows.push({
        key: 'none',
        value: 'none',
        label: 'workspace.personalize.skyNone'
    });
    return rows;
};

});

parcelRegister("gDIGr", function(module, exports) {

$parcel$export(module.exports, "homeSignalsNormalize", () => $c1d2f316c844002e$export$7c8eb1d181c57858);
$parcel$export(module.exports, "homeSignalsText", () => $c1d2f316c844002e$export$efc03cdb9106a00b);
$parcel$export(module.exports, "homeSignalsProviders", () => $c1d2f316c844002e$export$9f21de92b879fc59);
$parcel$export(module.exports, "homeSignalsTick", () => $c1d2f316c844002e$export$1be10616a5f66ce2);
$parcel$export(module.exports, "homeSignalsInvalidate", () => $c1d2f316c844002e$export$abab624e97c7165a);
$parcel$export(module.exports, "homeSignalsView", () => $c1d2f316c844002e$export$b75b64cb419e4325);
$parcel$export(module.exports, "homeSignalsOnData", () => $c1d2f316c844002e$export$b1cc447582b98a6a);
$parcel$export(module.exports, "homeSignalsTasks", () => $c1d2f316c844002e$export$be5ae930360164d6);
$parcel$export(module.exports, "homeSignalsCalendar", () => $c1d2f316c844002e$export$7e04f437423bf15a);
$parcel$export(module.exports, "homeSignalsMail", () => $c1d2f316c844002e$export$e97f5c5c068a28d7);
$parcel$export(module.exports, "homeSignalsInbox", () => $c1d2f316c844002e$export$fca456cedf8148c8);
$parcel$export(module.exports, "homeSignalsOpen", () => $c1d2f316c844002e$export$5974a55080921a12);
$parcel$export(module.exports, "homeTopClock", () => $c1d2f316c844002e$export$ca88dfbe8d97b41d);
$parcel$export(module.exports, "homeTopClockStop", () => $c1d2f316c844002e$export$3f32156f05cbc124);
// homeSignals.js — WHAT NEEDS THE PERSON, from every installed app: the shell
// side of HOME_SIGNALS_CONTRACT v1 (tickets/reference/white-label-redesign/
// HOME_SIGNALS_CONTRACT.md; DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1).
//
// An app answers `homeSignals(ctx)` → Promise<Signal[]> — a module function
// (Frank-discovered `functions/homeSignals.js`), reached through the app's OWN
// module context, the same carrier the ai-boards vocabulary and the home board
// use for an app's widgets (`root._moduleDsCtxGet(appId).functions`, own
// properties only: the context chains to the shell's merged bag, and a
// sibling app's `homeSignals` must never answer for this one). Backend reads
// inside a provider go through @symbo.ls/sdk (`this.sdk` / `ctx.sdk`).
//
//   Signal = { id: '<app>.<subject>.<kind>', app, kind, count >= 1,
//              severity: 'urgent'|'attention'|'info',
//              label: { key, params }, href, at?, notifFilter? }
//
// `notifFilter` ('all' | 'unread' | 'workspace', the root's `_notifFilter`)
// rides only a signal that opens the Inbox: the Inbox filter that lists the
// rows the signal counted. homeSignalsOpen sets it before it opens the list.
//
// THE RULES THIS FILE ENFORCES (contract §2):
//   • counts only — a signal carries no names and no record text; an invalid
//     or zero signal is dropped; at most 5 per app, sorted inside the app by
//     severity then count; `app` is the provider the shell called, whatever
//     the provider wrote;
//   • BUDGET: a pass waits at most 800 ms for its providers. A provider still
//     out after that is skipped for this render and lands on the next one; a
//     call still out after 10 s reads as `[]` (a hang must not hold the line
//     forever). A throw or a rejection reads as `[]` and logs once;
//   • CACHE: per workspace, 60 s, in memory (`root._homeSignals`, workspace-
//     scoped — a switch wipes it, and a late answer for the previous
//     workspace drops itself). `el.call('homeSignalsInvalidate', app)` from a
//     mutation site refreshes at once;
//   • ORDER: severity (urgent > attention > info), then count, then the app's
//     place in the App strip;
//   • "Nothing needs you right now" only when EVERY installed provider has
//     answered and none emitted a signal; while providers load, the line waits.
//
// THE BUILT-IN PROVIDERS move onto the same contract: tasks (open, overdue),
// calendar (today's events), mail (unread), inbox (unread notifications) — the counts the greeting showed as
// a sentence, now as signals. They read the shell's own loaded state and are
// READY only once their source has answered (a first-paint "0 tasks" would be a
// false claim); a source still silent after 5 s answers with what it has.
//
// FRANK: every export is self-contained (FA204) — the vocabularies and the
// small helpers are restated where they are used; siblings are reached through
// `this.call`. No module state: the cache is the workspace-scoped root key.

var $g7CNh = parcelRequire("g7CNh");
const $c1d2f316c844002e$export$7c8eb1d181c57858 = function homeSignalsNormalize(list, app) {
    const KINDS = [
        'overdue',
        'dueToday',
        'upcoming',
        'waiting',
        'new',
        'risk'
    ];
    const RANK = {
        urgent: 0,
        attention: 1,
        info: 2
    };
    // The Inbox's filters (the root's `_notifFilter`, shared state.js).
    const NOTIF_FILTERS = [
        'all',
        'unread',
        'workspace'
    ];
    if (!Array.isArray(list) || typeof app !== 'string' || !app) return [];
    const out = [];
    const seen = new Set();
    for (const s of list){
        if (!s || typeof s !== 'object') continue;
        const count = Math.floor(Number(s.count));
        if (!Number.isFinite(count) || count < 1) continue;
        if (!KINDS.includes(s.kind) || !(s.severity in RANK)) continue;
        const label = s.label && typeof s.label === 'object' ? s.label : null;
        if (!label || typeof label.key !== 'string' || !label.key) continue;
        const id = typeof s.id === 'string' && s.id ? s.id : app + '.' + label.key + '.' + s.kind;
        if (seen.has(id)) continue;
        seen.add(id);
        const params = {};
        const raw = label.params && typeof label.params === 'object' ? label.params : {};
        for (const [k, v] of Object.entries(raw))if (typeof v === 'number' || typeof v === 'string') params[k] = v;
        const at = typeof s.at === 'string' && !Number.isNaN(new Date(s.at).getTime()) ? s.at : null;
        const href = typeof s.href === 'string' && s.href.charAt(0) === '/' ? s.href : null;
        const sig = {
            id: id,
            app: app,
            kind: s.kind,
            count: count,
            severity: s.severity,
            label: {
                key: label.key,
                params: params
            },
            href: href,
            at: at
        };
        // A filter for the list it opens, and only the Inbox has one: any other
        // signal never moves the Inbox's filter.
        if (href && href.split(/[?#]/)[0] === '/inbox' && NOTIF_FILTERS.includes(s.notifFilter)) sig.notifFilter = s.notifFilter;
        out.push(sig);
    }
    out.sort((a, b)=>RANK[a.severity] - RANK[b.severity] || b.count - a.count);
    return out.slice(0, 5);
};
const $c1d2f316c844002e$export$efc03cdb9106a00b = function homeSignalsText(sig, opts) {
    if (!sig || !sig.label) return '';
    const el = this;
    const key = sig.label.key;
    const template = el && typeof el.call === 'function' ? String(el.call('polyglot', key) ?? key) : String(key);
    const params = sig.label.params || {};
    const text = template.replace(/\{([a-zA-Z]+)\}/g, (m, name)=>Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : m);
    if (!opts || !opts.bare) return text;
    const n = String(sig.count);
    const m = new RegExp('(^|[^0-9])(' + n + ')(?![0-9])').exec(text);
    if (!m) return text;
    const at = m.index + m[1].length;
    return (text.slice(0, at) + text.slice(at + n.length)).replace(/\s{2,}/g, ' ').trim();
};
const $c1d2f316c844002e$export$9f21de92b879fc59 = function homeSignalsProviders(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const call = (name, ...args)=>el && typeof el.call === 'function' ? el.call(name, ...args) : undefined;
    const providers = [];
    const ctxFor = (extra)=>({
            root: r,
            sdk: el && el.sdk || null,
            workspaceId: r.workspace && String(r.workspace.id || r.workspace._id || '') || null,
            lang: r.lang || 'en',
            now: Date.now(),
            ...extra
        });
    // Built-ins — the shell's own apps, over the shell's loaded state.
    const ticketsReady = Array.isArray(r._userTickets) || !!r._homeTicketsError || r._dataLoading === false && !r.currentUserEmail;
    providers.push({
        app: 'tasks',
        appId: null,
        ready: ticketsReady,
        run: ()=>call('homeSignalsTasks', ctxFor({
                app: 'tasks'
            }))
    });
    providers.push({
        app: 'calendar',
        appId: null,
        ready: !!(r.intranetEventsLoaded || r.intranetEventsError),
        run: ()=>call('homeSignalsCalendar', ctxFor({
                app: 'calendar'
            }))
    });
    if (call('navItemVisible', r, '/mail')) {
        const counts = r.navUnreadCounts && typeof r.navUnreadCounts === 'object' ? r.navUnreadCounts : {};
        providers.push({
            app: 'mail',
            appId: null,
            ready: counts.mail !== undefined && counts.mail !== null,
            run: ()=>call('homeSignalsMail', ctxFor({
                    app: 'mail'
                }))
        });
    }
    // Inbox — the notification centre's unread rows of this workspace (persona
    // round 5, marcus: "Nothing needs you right now" over an unread lead). A
    // built app pings its owner ONLY through notifications, so this is where
    // its news reaches the home. Ready once the centre answered (`notifsLoaded`).
    providers.push({
        app: 'inbox',
        appId: null,
        ready: !!r.notifsLoaded,
        run: ()=>call('homeSignalsInbox', ctxFor({
                app: 'inbox'
            }))
    });
    // Installed apps — the takeover module first, then the additive apps, one
    // provider per app, through the app's OWN module context.
    // Only INSTALLED APP entries wait for the published list — the loader's own
    // rule (workspaceConfigs.js installedAppRefs). A records-grant row
    // (`type: 'legacy-backfill'`) or any other non-app row is never loaded, so
    // it never publishes: counting it held the line "not known" for nothing.
    //
    // THE WORKSPACE RECORD FIRST (crm-w1, dev 3e103946b, the Unreal twin's cold
    // load: "Nothing needs you right now." sat in the page text from 11.6 s to
    // 12.9 s under the boot loader). Before the full record arrives the
    // `settings` bag is absent and the installed-apps list reads [] — "no apps",
    // a lie. The record is LOADED when it carries its settings bag or the
    // full-record stamp (shared workspaceSettings.js: a list / claims row never
    // carries settings). While an id is known and the completion is in flight
    // the apps are NOT known. A completion that definitively failed
    // (`_completionUnreachable`) is terminal — nothing more is coming, so the
    // default (no apps) is the honest answer and nothing waits forever.
    const w = r.workspace;
    const settingsReady = !!w && (w._shape === 'full' || !!w.settings && typeof w.settings === 'object');
    const settingsPending = !settingsReady && !!w && !!(w.id || w._id) && !w._completionUnreachable;
    const settings = settingsReady && w.settings || {};
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const refs = (0, $g7CNh.installedAppRefs)(settings);
    const installed = new Set(refs.map((ref)=>lc(ref.owner) + '/' + lc(ref.key)));
    const published = Array.isArray(r.workspaceApps) ? r.workspaceApps : null;
    const appsKnown = !refs.length || !!published;
    // THE APPS THE LOADER SAYS WILL NOT COME — known WITHOUT data. Its record of
    // this workspace's apps phase (functions/workspaceProjects.js
    // updateWorkspaceActivation) names the refused ones (`blocked`, settled); a
    // finished pass that reported a failure ('partial' | 'error' | 'blocked')
    // did not load the installed apps missing from the published list; a
    // published entry may say `loadFailed`. A failed takeover module (its phase
    // 'error') is the same. None of them waits forever, and none lets the home
    // say "nothing" — its items are unknown.
    const wsKey = w && String(w.id || w._id || '') || '';
    const act = r._workspaceActivation;
    const phase = (name)=>act && typeof act === 'object' && String(act.workspaceId || '') === wsKey && act[name] && typeof act[name] === 'object' ? act[name] : null;
    const appsPhase = phase('apps');
    const blocked = new Set((appsPhase && Array.isArray(appsPhase.blocked) ? appsPhase.blocked : []).map(lc));
    const passFailed = !!appsPhase && [
        'partial',
        'error',
        'blocked'
    ].includes(appsPhase.state);
    const publishedIds = new Set();
    for (const a of published || []){
        if (a && a.appId) publishedIds.add(lc(a.appId));
        if (a && a.id) publishedIds.add(lc(a.id));
    }
    const failed = [];
    for (const id of installed)if (blocked.has(id) || published && passFailed && !publishedIds.has(id)) failed.push(id);
    const modulePhase = phase('module');
    const moduleFailed = !!settings.workspaceModule && !r.workspaceProject && !!modulePhase && modulePhase.state === 'error';
    if (moduleFailed) failed.push('module');
    const moduleKnown = !settings.workspaceModule || !!r.workspaceProject || moduleFailed;
    const seen = new Set();
    const apps = [];
    const wp = r.workspaceProject;
    if (wp && wp.id) apps.push(wp);
    for (const a of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])apps.push(a);
    const getCtx = typeof r._moduleDsCtxGet === 'function' ? r._moduleDsCtxGet : null;
    const getState = typeof r._moduleStateGet === 'function' ? r._moduleStateGet : null;
    let holding = false;
    for (const appEntry of apps){
        const appId = appEntry && appEntry.id ? String(appEntry.id) : '';
        if (!appId || seen.has(appId)) continue;
        seen.add(appId);
        const isModule = appEntry === wp;
        const keys = [
            lc(appEntry.appId),
            lc(appId)
        ].filter(Boolean);
        // Does it FEED the Signals? The loader publishes the home providers an app
        // has at the first apps pass (`homeProviders`: 'signals' / 'upcoming'; [] =
        // it never feeds the home); an entry without the field (an older loader)
        // is taken to feed them.
        const feeds = appEntry.homeProviders;
        const feedsSignals = !Array.isArray(feeds) || feeds.includes('signals');
        // The loader gave up on it — refused (`apps.blocked`), `loadFailed`, or its
        // setup FAILED (`setupFailed: true`, pendingWidgets null; its placeholder
        // keeps the error): known WITHOUT data. Never asked (its provider would
        // read the SHELL root and answer a wrong "0 follow-ups"), never waited
        // for, and when it feeds the Signals the home never says "nothing" over it.
        if (!isModule && (appEntry.loadFailed === true || appEntry.setupFailed === true || keys.some((k)=>blocked.has(k)))) {
            if (feedsSignals && !keys.some((k)=>failed.includes(k))) failed.push(keys[0]);
            continue;
        }
        // Still SETTING UP — its published entry carries `pendingWidgets` as an
        // array (the boot reveals the home before the apps finish): it has no state
        // root yet, so it is never asked, and it holds the line back from "nothing"
        // only when it feeds the Signals. An entry the workspace no longer INSTALLS
        // (uninstalled during its setup; the loader drops it on its next pass) is
        // nothing to wait for.
        if (Array.isArray(appEntry.pendingWidgets)) {
            if (!isModule && !keys.some((k)=>installed.has(k))) continue;
            if (feedsSignals) holding = true;
            continue;
        }
        const modCtx = getCtx ? getCtx(appId) : null;
        const fns = modCtx && modCtx.functions;
        const own = fns && Object.prototype.hasOwnProperty.call(fns, 'homeSignals') ? fns.homeSignals : null;
        if (typeof own !== 'function') continue;
        const short = appId.split('/').pop().replace(/-app$/, '');
        const stateRoot = getState && getState(appId) || r;
        // The module function runs as an element of ITS app: `this.call` resolves
        // the app's own functions first, `this.state.root` is its state root.
        const shim = {
            key: 'homeSignals',
            context: modCtx,
            sdk: el && el.sdk || null,
            state: {
                root: stateRoot
            },
            call: (name, ...args)=>{
                const f = modCtx.functions[name];
                return typeof f === 'function' ? f.apply(shim, args) : undefined;
            }
        };
        providers.push({
            app: short,
            appId: appId,
            ready: true,
            run: ()=>own.call(shim, ctxFor({
                    app: short,
                    appId: appId,
                    root: stateRoot,
                    shell: r
                }))
        });
    }
    return {
        known: !settingsPending && appsKnown && moduleKnown && !holding,
        providers: providers,
        failed: failed.slice().sort()
    };
};
const $c1d2f316c844002e$export$1be10616a5f66ce2 = async function homeSignalsTick(root, opts) {
    const el = this;
    const o = opts && typeof opts === 'object' ? opts : {};
    const now = typeof o.now === 'function' ? o.now : ()=>Date.now();
    const BUDGET = typeof o.budget === 'number' ? o.budget : 800;
    const TTL = typeof o.ttl === 'number' ? o.ttl : 60000;
    const HANG = typeof o.hang === 'number' ? o.hang : 10000;
    const WAIT = typeof o.wait === 'number' ? o.wait : 5000;
    const sleep = typeof o.sleep === 'function' ? o.sleep : (ms)=>new Promise((resolve)=>{
            const t = setTimeout(resolve, ms);
            if (t && typeof t.unref === 'function') t.unref();
        });
    const r = root || el && el.state && el.state.root;
    if (!r || typeof r.update !== 'function' || !el || typeof el.call !== 'function') return null;
    const wsOf = ()=>{
        const w = r.workspace;
        return w && String(w.id || w._id || '') || null;
    };
    const ws = wsOf();
    if (!ws) return null;
    const read = ()=>{
        const cur = r._homeSignals;
        return cur && typeof cur === 'object' && cur.ws === ws ? cur : null;
    };
    const fresh = (t)=>({
            ws: ws,
            known: false,
            expected: [],
            failed: [],
            apps: {},
            inflight: {},
            logged: {},
            firstAt: t,
            windowAt: 0,
            updatedAt: 0
        });
    // Every write re-reads the live key and merges, so answers landing in any
    // order never overwrite each other; a switch (another workspace on screen)
    // drops the write.
    const write = (fn)=>{
        if (wsOf() !== ws) return false;
        const cur = read() || fresh(now());
        const next = fn(cur);
        if (!next || next === cur) return false;
        r.update({
            _homeSignals: next
        }, {
            preventFetch: true
        });
        return true;
    };
    let listing = null;
    try {
        listing = el.call('homeSignalsProviders', r);
    } catch (err) {
        console.warn('[home] signals providers unavailable:', err && err.message);
    }
    if (!listing || typeof listing !== 'object') listing = {
        known: false,
        providers: []
    };
    const providers = Array.isArray(listing.providers) ? listing.providers : [];
    const failedNow = Array.isArray(listing.failed) ? listing.failed : [];
    const t0 = now();
    const before = read() || fresh(t0);
    const expected = providers.map((p)=>p.app);
    // A call out for longer than the hang limit reads as an empty answer (and
    // logs once); it is retried on the next pass.
    const hung = Object.keys(before.inflight || {}).filter((app)=>t0 - before.inflight[app] >= HANG && expected.includes(app));
    const due = providers.filter((p)=>{
        const hit = before.apps[p.app];
        if (hit && t0 - hit.at < TTL) return false;
        const started = before.inflight[p.app];
        if (started && t0 - started < HANG) return false;
        return !!p.ready || t0 - before.firstAt >= WAIT;
    });
    write((c)=>{
        const same = !hung.length && !due.length && c.known === !!listing.known && c.expected.length === expected.length && c.expected.every((a, i)=>a === expected[i]) && (c.failed || []).join('|') === failedNow.join('|');
        if (same && read()) return c;
        const inflight = {
            ...c.inflight
        };
        const apps = {
            ...c.apps
        };
        const logged = {
            ...c.logged
        };
        for (const app of hung){
            delete inflight[app];
            if (!apps[app]) apps[app] = {
                at: t0,
                status: 'timeout',
                signals: []
            };
            if (!logged[app]) {
                logged[app] = true;
                console.warn('[home] signals provider did not answer in time:', app);
            }
        }
        for (const p of due)inflight[p.app] = t0;
        return {
            ...c,
            known: !!listing.known,
            expected: expected,
            failed: failedNow,
            apps: apps,
            inflight: inflight,
            logged: logged
        };
    });
    const runs = due.map((p)=>Promise.resolve().then(()=>p.run()).then((list)=>({
                ok: true,
                list: list
            }), (err)=>({
                ok: false,
                err: err
            })).then((res)=>{
            const signals = res.ok ? el.call('homeSignalsNormalize', res.list, p.app) : [];
            const t = now();
            write((c)=>{
                const inflight = {
                    ...c.inflight
                };
                delete inflight[p.app];
                const logged = {
                    ...c.logged
                };
                if (!res.ok && !logged[p.app]) {
                    logged[p.app] = true;
                    console.warn("[home] signals provider failed \u2014 read as none:", p.app, res.err && res.err.message);
                }
                return {
                    ...c,
                    apps: {
                        ...c.apps,
                        [p.app]: {
                            at: t,
                            status: res.ok ? 'ok' : 'error',
                            signals: signals
                        }
                    },
                    inflight: inflight,
                    logged: logged,
                    updatedAt: t
                };
            });
        }));
    if (runs.length) await Promise.race([
        Promise.all(runs),
        sleep(BUDGET)
    ]);
    // The first pass window closes: from here the line shows what answered.
    write((c)=>c.windowAt ? c : {
            ...c,
            windowAt: now()
        });
    // When a next pass is worth running.
    const after = read() || fresh(t0);
    const times = [];
    for (const app of expected){
        const hit = after.apps[app];
        if (hit) times.push(hit.at + TTL);
        const started = after.inflight[app];
        if (started) times.push(started + HANG);
    }
    if (providers.some((p)=>!p.ready && !after.apps[p.app])) times.push(after.firstAt + WAIT);
    return {
        nextAt: times.length ? Math.min(...times) : null
    };
};
const $c1d2f316c844002e$export$abab624e97c7165a = function homeSignalsInvalidate(app, opts) {
    const el = this;
    const r = el && el.state && el.state.root;
    if (!r || typeof r.update !== 'function') return null;
    const cur = r._homeSignals;
    if (cur && typeof cur === 'object' && cur.apps) {
        const apps = {};
        for (const [k, v] of Object.entries(cur.apps))apps[k] = !app || k === app ? {
            ...v,
            at: 0
        } : v;
        r.update({
            _homeSignals: {
                ...cur,
                apps: apps
            }
        }, {
            preventFetch: true
        });
    }
    return typeof el.call === 'function' ? el.call('homeSignalsTick', r, opts) : null;
};
const $c1d2f316c844002e$export$b75b64cb419e4325 = function homeSignalsView(root) {
    const RANK = {
        urgent: 0,
        attention: 1,
        info: 2
    };
    const r = root && typeof root === 'object' ? root : {};
    const w = r.workspace;
    const ws = w && String(w.id || w._id || '') || null;
    const st = r._homeSignals;
    if (!ws || !st || typeof st !== 'object' || st.ws !== ws) return {
        list: [],
        settled: false,
        waiting: true,
        updatedAt: 0
    };
    const expected = Array.isArray(st.expected) ? st.expected : [];
    const apps = st.apps && typeof st.apps === 'object' ? st.apps : {};
    const settled = !!st.known && expected.every((a)=>!!apps[a]);
    const all = [];
    // ONE FACT, ONCE: a signal's `id` is namespaced by the module that emits it
    // (`crm.followups.dueToday`), so the same id from two providers is the same
    // fact — an app whose module context carries the CRM's provider beside the
    // CRM itself printed "2 follow-ups due today" twice in the greeting (the
    // media lane, dev 2026-10-25). The first provider in install order keeps it.
    const seenIds = new Set();
    for (const a of expected){
        const hit = apps[a];
        if (!hit || !Array.isArray(hit.signals)) continue;
        for (const s of hit.signals){
            const id = s && typeof s.id === 'string' && s.id ? s.id : null;
            if (id && seenIds.has(id)) continue;
            if (id) seenIds.add(id);
            all.push(s);
        }
    }
    // The App strip order: a built-in app's shortcut, a module app's first
    // icon-only widget, in the saved home layout.
    const layout = Array.isArray(r._homeLayout) ? r._homeLayout : [];
    const pos = (id)=>{
        const at = layout.findIndex((e)=>e && e.id === id);
        return at < 0 ? Number.MAX_SAFE_INTEGER : at;
    };
    const order = {
        tasks: pos('app-tickets'),
        calendar: pos('app-calendar')
    };
    const modules = [];
    if (r.workspaceProject && r.workspaceProject.id) modules.push(r.workspaceProject);
    for (const a of Array.isArray(r.workspaceApps) ? r.workspaceApps : [])modules.push(a);
    for (const m of modules){
        const short = String(m.id || '').split('/').pop().replace(/-app$/, '');
        if (!short || short in order) continue;
        const icons = (Array.isArray(m.widgets) ? m.widgets : []).filter((x)=>x && (x.kind === 'app' || x.spec && x.spec.iconOnly));
        order[short] = icons.length ? Math.min(...icons.map((x)=>pos(x.id))) : Number.MAX_SAFE_INTEGER;
    }
    const place = (app)=>Object.prototype.hasOwnProperty.call(order, app) ? order[app] : Number.MAX_SAFE_INTEGER;
    const list = all.map((s, i)=>({
            s: s,
            i: i
        })).sort((a, b)=>(RANK[a.s.severity] ?? 3) - (RANK[b.s.severity] ?? 3) || b.s.count - a.s.count || place(a.s.app) - place(b.s.app) || a.i - b.i).map((x)=>x.s);
    const waiting = !st.windowAt || !st.known || !list.length && !settled;
    // How many installed apps the loader says will not come (known without
    // data): with zero items the home may not say "nothing" over them.
    const failed = Array.isArray(st.failed) ? st.failed.length : 0;
    return {
        list: list,
        settled: settled,
        waiting: waiting,
        failed: failed,
        updatedAt: st.updatedAt || 0
    };
};
const $c1d2f316c844002e$export$b1cc447582b98a6a = function homeSignalsOnData(el, s, change) {
    const self = el || this;
    if (!self || typeof self.call !== 'function') return null;
    const root = s && s.root;
    const prev = change && change.prev || [];
    const next = change && change.next || [];
    // each built-in app's place in the head's deps (pages/main.js HomeGreeting:
    // tickets, events, mail count, apps, project, workspace, unread
    // notifications, notifications loaded)
    const builtIns = {
        tasks: [
            0
        ],
        calendar: [
            1
        ],
        mail: [
            2
        ],
        inbox: [
            6,
            7
        ]
    };
    const stale = Object.keys(builtIns).filter((app)=>builtIns[app].some((i)=>prev[i] !== next[i]));
    const cur = root && root._homeSignals;
    if (stale.length && cur && typeof cur === 'object' && cur.apps && typeof root.update === 'function') {
        const apps = {
            ...cur.apps
        };
        for (const app of stale)if (apps[app]) apps[app] = {
            ...apps[app],
            at: 0
        };
        root.update({
            _homeSignals: {
                ...cur,
                apps: apps
            }
        }, {
            preventFetch: true
        });
    }
    return self.call('homeSignalsTick', root);
};
const $c1d2f316c844002e$export$be5ae930360164d6 = function homeSignalsTasks(ctx) {
    const root = ctx && ctx.root || {};
    const done = [
        'done',
        'closed',
        'resolved',
        'cancelled',
        'archived'
    ];
    const me = String(root.currentUserEmail || '').toLowerCase();
    if (!me) return [];
    const rows = Array.isArray(root._userTickets) && root._userTickets.length ? root._userTickets : Array.isArray(root.tickets) ? root.tickets : [];
    const mine = rows.filter((t)=>{
        if (!t || done.includes(String(t.state || t.status || '').toLowerCase())) return false;
        return String(t.assigneeEmail || t.assignee_email || '').toLowerCase() === me;
    });
    const nowMs = ctx && ctx.now || Date.now();
    const today = new Date(nowMs);
    today.setHours(0, 0, 0, 0);
    const overdue = mine.filter((t)=>{
        const due = t.dueDate || t.due_date;
        if (!due) return false;
        const d = new Date(due);
        if (Number.isNaN(d.getTime())) return false;
        // A bare YYYY-MM-DD is a LOCAL calendar day.
        const day = /^\d{4}-\d{2}-\d{2}$/.test(String(due)) ? new Date(Number(String(due).slice(0, 4)), Number(String(due).slice(5, 7)) - 1, Number(String(due).slice(8, 10))) : d;
        return day.getTime() < today.getTime();
    }).length;
    const out = [];
    if (overdue) out.push({
        id: 'tasks.mine.overdue',
        app: 'tasks',
        kind: 'overdue',
        count: overdue,
        severity: 'urgent',
        label: {
            key: overdue === 1 ? 'workspace.home.signals.taskOverdueOne' : 'workspace.home.signals.taskOverdueOther',
            params: {
                count: overdue
            }
        },
        href: '/tasks/my'
    });
    if (mine.length) out.push({
        id: 'tasks.mine.waiting',
        app: 'tasks',
        kind: 'waiting',
        count: mine.length,
        severity: 'info',
        label: {
            key: mine.length === 1 ? 'workspace.home.summary.taskOne' : 'workspace.home.summary.taskOther',
            params: {
                count: mine.length
            }
        },
        href: '/tasks/my'
    });
    return out;
};
const $c1d2f316c844002e$export$7e04f437423bf15a = function homeSignalsCalendar(ctx) {
    const root = ctx && ctx.root || {};
    const me = root.currentUserEmail;
    const nowMs = ctx && ctx.now || Date.now();
    const start = new Date(nowMs);
    start.setHours(0, 0, 0, 0);
    const end = start.getTime() + 86400000;
    const ahead = (Array.isArray(root.intranetEvents) ? root.intranetEvents : []).filter((e)=>{
        const t = e && e.startAt ? new Date(e.startAt).getTime() : 0;
        if (!t || t < nowMs || t >= end) return false;
        return !Array.isArray(e.attendees) || e.attendees.includes(me);
    }).map((e)=>new Date(e.startAt).getTime()).sort((a, b)=>a - b);
    if (!ahead.length) return [];
    return [
        {
            id: 'calendar.events.dueToday',
            app: 'calendar',
            kind: 'dueToday',
            count: ahead.length,
            severity: 'attention',
            label: {
                key: ahead.length === 1 ? 'workspace.home.summary.eventOne' : 'workspace.home.summary.eventOther',
                params: {
                    count: ahead.length
                }
            },
            href: '/calendar',
            at: new Date(ahead[0]).toISOString()
        }
    ];
};
const $c1d2f316c844002e$export$e97f5c5c068a28d7 = function homeSignalsMail(ctx) {
    const root = ctx && ctx.root || {};
    const counts = root.navUnreadCounts && typeof root.navUnreadCounts === 'object' ? root.navUnreadCounts : {};
    const n = Math.floor(Number(counts.mail || 0));
    if (!n || n < 1) return [];
    return [
        {
            id: 'mail.inbox.new',
            app: 'mail',
            kind: 'new',
            count: n,
            severity: 'info',
            label: {
                key: n === 1 ? 'workspace.home.summary.mailOne' : 'workspace.home.summary.mailOther',
                params: {
                    count: n
                }
            },
            href: '/mail'
        }
    ];
};
const $c1d2f316c844002e$export$fca456cedf8148c8 = function homeSignalsInbox(ctx) {
    const el = this;
    const root = ctx && ctx.root || {};
    const rows = Array.isArray(root.notifs) ? root.notifs : [];
    const mine = (n)=>{
        if (!el || typeof el.call !== 'function') return true;
        return el.call('isCurrentWorkspaceNotification', n, root) !== false;
    };
    const n = rows.filter((row)=>row && !row.read && mine(row)).length;
    if (!n) return [];
    return [
        {
            id: 'inbox.notifications.new',
            app: 'inbox',
            kind: 'new',
            count: n,
            severity: 'attention',
            label: {
                key: n === 1 ? 'workspace.home.summary.notifOne' : 'workspace.home.summary.notifOther',
                params: {
                    count: n
                }
            },
            href: '/inbox',
            notifFilter: 'workspace'
        }
    ];
};
const $c1d2f316c844002e$export$5974a55080921a12 = function homeSignalsOpen(e, sig) {
    const el = this;
    const NOTIF_FILTERS = [
        'all',
        'unread',
        'workspace'
    ];
    const href = sig && typeof sig.href === 'string' ? sig.href : null;
    if (!href) {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        return false;
    }
    if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)) return false;
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    const filter = typeof sig === 'object' && 'notifFilter' in sig && NOTIF_FILTERS.includes(sig.notifFilter) ? sig.notifFilter : null;
    const root = el && el.state && el.state.root;
    if (filter && root && typeof root.update === 'function') root.update({
        _notifFilter: filter
    }, {
        preventFetch: true
    });
    if (el && typeof el.call === 'function') el.call('openInSlot', href, el);
    return true;
};
const $c1d2f316c844002e$export$ca88dfbe8d97b41d = function homeTopClock() {
    const el = this;
    if (!el || el.__homeTopClock || typeof setInterval !== 'function') return;
    const rootOf = ()=>el.state && el.state.root || null;
    const schedule = (pass)=>Promise.resolve(pass).then((res)=>{
            const at = res && res.nextAt;
            if (!at || !el.node) return;
            const wait = Math.max(1000, at - Date.now());
            if (wait >= 30000) return;
            clearTimeout(el.__homeTopSoon);
            el.__homeTopSoon = setTimeout(()=>schedule(el.call('homeSignalsTick', rootOf())), wait);
            if (el.__homeTopSoon && typeof el.__homeTopSoon.unref === 'function') el.__homeTopSoon.unref();
        }).catch((err)=>console.warn('[home] signals pass failed:', err && err.message));
    const beat = ()=>{
        if (!el.node || !el.state || typeof el.state.update !== 'function') {
            clearInterval(el.__homeTopClock);
            el.__homeTopClock = null;
            return;
        }
        el.state.update({
            now: Date.now()
        }, {
            preventFetch: true
        });
        el.call('homeLookSyncCache', rootOf());
        schedule(el.call('homeSignalsTick', rootOf()));
    };
    el.__homeTopClock = setInterval(beat, 30000);
    // Node (the jsdom tests) must not wait on the clock to exit.
    if (el.__homeTopClock && typeof el.__homeTopClock.unref === 'function') el.__homeTopClock.unref();
    el.call('homeLookSyncCache', rootOf());
    schedule(el.call('homeSignalsTick', rootOf()));
};
const $c1d2f316c844002e$export$3f32156f05cbc124 = function homeTopClockStop() {
    const el = this;
    if (!el) return;
    if (el.__homeTopClock) {
        clearInterval(el.__homeTopClock);
        el.__homeTopClock = null;
    }
    if (el.__homeTopSoon) {
        clearTimeout(el.__homeTopSoon);
        el.__homeTopSoon = null;
    }
};

});

parcelRegister("iEkVj", function(module, exports) {

$parcel$export(module.exports, "homeSummaryCompose", () => $d93c3162c83e8100$export$5c643134f355613c);
$parcel$export(module.exports, "homeSummaryShowsSignals", () => $d93c3162c83e8100$export$dfc573309c83854b);
$parcel$export(module.exports, "homeTopYields", () => $d93c3162c83e8100$export$c393a12acdd19221);
$parcel$export(module.exports, "homeSignalIcon", () => $d93c3162c83e8100$export$e6672f241aff23a3);
$parcel$export(module.exports, "homeSignalsLabel", () => $d93c3162c83e8100$export$3bc4a05d38de73d1);
$parcel$export(module.exports, "homeSummaryBrief", () => $d93c3162c83e8100$export$a6fd8ba4fd7e3ea9);
$parcel$export(module.exports, "homeSummaryOpenAsBoard", () => $d93c3162c83e8100$export$6c268e5058d85cf1);
// homeSummaryCompose.js — THE ONE SOURCE of the summary at the top of the home
// (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1; Nika's pick 2026-09-28 row 2: the Brief
// OR the Signals, a personal option).
//
// Both summary styles and the greeting sub-line render from the model this
// function returns, and nothing else:
//
//   { source, status, line, tiles, brief, briefChips, updatedAt }
//     source     'signals' today. The server AI source (ai-boards, a later
//                current-23 core lane) will answer the SAME shape, so it
//                replaces this function without a change to any component.
//     status     'waiting' — the providers are still answering: the surfaces
//                hold their skeleton, never a premature "nothing";
//                'nothing' — every installed provider answered and none
//                emitted a signal: "Nothing needs you right now";
//                'ready'.
//     line       the greeting sub-line: the top two signals (joined by " · ").
//     tiles      the Signals style: the top four signals.
//     brief      the Brief style: at most two sentences, each an array of runs
//                — { key, text } words, { key, chip } a signal (its count and
//                words, a link to its list), { key, time } the nearest start.
//     briefChips the AI sentence's signals: their own row below it.
//     updatedAt  when the last answer landed (the Brief's "Updated").
//
// THE TEMPLATES ARE DETERMINISTIC (no AI until the AI source is wired — and
// nothing is labelled "AI"): every number on screen is a signal's own count or
// its own `at`. Nothing is summed, nothing is estimated, no "and N more":
//   1. the signals that need attention (urgent + attention), at most three:
//      "Waiting on you: {facts}."; with none, the rest: "You have {facts}.";
//   2. then, when the first sentence named the attention group, the rest, at
//      most three: "You also have {facts}.".
// A fact with a start later today carries it: "3 events today from 10:00".
// The list words are the bundle's own ("{a} and {b}", "{a}, {b} and {c}") —
// never a joiner stitched in code, never Intl.ListFormat (Chrome ships no
// Georgian list data).
//
// FRANK: self-contained exports; siblings through `this.call`.
const $d93c3162c83e8100$export$5c643134f355613c = function homeSummaryCompose(root) {
    const el = this;
    const view = el && typeof el.call === 'function' ? el.call('homeSignalsView', root) : {
        list: [],
        settled: false,
        waiting: true,
        updatedAt: 0
    };
    const list = (view && Array.isArray(view.list) ? view.list : []).slice();
    // 'unavailable' — every provider answered with zero items, but an installed
    // app will not come (the loader refused it or failed it: homeSignals.js
    // `failed`). Its items are unknown, so the home never says "nothing" then;
    // it says "Some apps couldn't load" (the loader's own words,
    // workspace.activation.partialTitle). "Nothing" is only for apps that are
    // ALL known, loaded and empty.
    const status = view.waiting ? 'waiting' : list.length ? 'ready' : view.settled ? view.failed ? 'unavailable' : 'nothing' : 'waiting';
    // THE AI SOURCE (functions/homeSummaryAi.js — ai.boards.summary): the
    // Brief alone switches. While the ask is in flight (≤ 800 ms) the Brief holds
    // its skeleton (`briefStatus` 'waiting'); an answer in time replaces the
    // template's sentences; anything else keeps the template. The greeting line
    // and the Signals tiles never wait for it.
    const fns = el && el.context && el.context.functions;
    const ai = status === 'ready' && fns && typeof fns.homeSummaryAiState === 'function' ? el.call('homeSummaryAiState', root, list) : null;
    const aiReady = !!(ai && ai.status === 'ready');
    return {
        source: aiReady ? 'ai' : 'signals',
        status: status,
        briefStatus: ai && ai.status === 'loading' ? 'waiting' : status,
        line: status === 'ready' ? list.slice(0, 2) : [],
        tiles: status === 'ready' ? list.slice(0, 4) : [],
        brief: status !== 'ready' || !el ? [] : aiReady ? el.call('homeSummaryAiBrief', ai, list) : el.call('homeSummaryBrief', list),
        // The AI sentence's signals, as their own row under it (the template's
        // facts are words of its sentences, so it has none).
        briefChips: status === 'ready' && el && aiReady ? el.call('homeSummaryAiChips', ai, list) || [] : [],
        // No time while the summary waits: the Updated line belongs to a summary
        // that is on screen (a zero or a mid-load time never reaches the page —
        // "Updated 04:00 AM" was a zero formatted in Tbilisi).
        updatedAt: status === 'waiting' ? 0 : aiReady && ai.generatedAt ? ai.generatedAt : view && view.updatedAt || 0
    };
};
const $d93c3162c83e8100$export$dfc573309c83854b = function homeSummaryShowsSignals(root) {
    const el = this;
    if (!el || typeof el.call !== 'function') return false;
    const status = (el.call('homeSummaryCompose', root) || {}).status;
    if (status === 'waiting' || status === 'ready') return true;
    if (status !== 'nothing' && status !== 'unavailable') return false;
    return (el.call('homeLookRead', root) || {}).summaryStyle === 'signals';
};
const $d93c3162c83e8100$export$c393a12acdd19221 = function homeTopYields(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return false;
    const thread = r._homeThreadOpen === true;
    const fns = el && el.context && el.context.functions;
    const shown = fns && fns.assistantBoardShown;
    const board = typeof shown === 'function' ? !!shown.call(el, r) : false;
    const deckShown = fns && fns.assistantDeckShown;
    const deck = typeof deckShown === 'function' ? !!deckShown.call(el, r) : false;
    // …and the FLY canvas (functions/assistantFly.js assistantFlyShown).
    const flyShown = fns && fns.assistantFlyShown;
    const fly = typeof flyShown === 'function' ? !!flyShown.call(el, r) : false;
    // …and a home tab's own screen — Present's start (functions/homeTabStart.js
    // homeTabStartShown) or Build's app builder (functions/homeBuild.js
    // homeBuildShown; the home's tabs, Nika 2026-10-23): the tab's head is the
    // screen's, not the dashboard's.
    const startShown = fns && fns.homeTabStartShown;
    const present = typeof startShown === 'function' ? !!startShown.call(el, r, 'present') : false;
    const buildShown = fns && fns.homeBuildShown;
    const build = typeof buildShown === 'function' ? !!buildShown.call(el, r) : false;
    return thread || board || deck || fly || present || build;
};
const $d93c3162c83e8100$export$e6672f241aff23a3 = function homeSignalIcon(sig) {
    const ICONS = {
        overdue: 'clock',
        dueToday: 'date',
        upcoming: 'dateOutline',
        waiting: 'check',
        new: 'email',
        risk: 'flag'
    };
    const kind = sig && typeof sig.kind === 'string' ? sig.kind : '';
    return Object.prototype.hasOwnProperty.call(ICONS, kind) ? ICONS[kind] : 'sfInfoOval';
};
const $d93c3162c83e8100$export$3bc4a05d38de73d1 = function homeSignalsLabel(sig) {
    const el = this;
    if (!el || typeof el.call !== 'function') return '';
    const words = String(el.call('homeSignalsText', sig) || '');
    const key = sig && sig.severity === 'urgent' ? 'workspace.home.signals.urgent' : sig && sig.severity === 'attention' ? 'workspace.home.signals.attention' : null;
    if (!key) return words;
    const said = el.call('polyglot', key);
    return said && said !== key ? said + ': ' + words : words;
};
const $d93c3162c83e8100$export$a6fd8ba4fd7e3ea9 = function homeSummaryBrief(list, now) {
    const el = this;
    const t = (key)=>el && typeof el.call === 'function' ? String(el.call('polyglot', key) ?? key) : key;
    const signals = Array.isArray(list) ? list : [];
    const attention = signals.filter((s)=>s && s.severity !== 'info').slice(0, 3);
    const rest = signals.filter((s)=>s && s.severity === 'info').slice(0, 3);
    const nowMs = typeof now === 'number' ? now : Date.now();
    const endOfDay = new Date(nowMs);
    endOfDay.setHours(24, 0, 0, 0);
    // Split a bundle template into literal runs and its `{name}` slots.
    const parts = (template)=>String(template).split(/(\{[a-z]+\})/).filter(Boolean);
    const facts = (group, prefix)=>{
        const listKey = group.length === 3 ? 'workspace.home.summary.three' : group.length === 2 ? 'workspace.home.summary.two' : null;
        const template = listKey ? t(listKey) : '{a}';
        const slot = {
            '{a}': 0,
            '{b}': 1,
            '{c}': 2
        };
        const runs = [];
        parts(template).forEach((part, i)=>{
            const at = slot[part];
            if (at === undefined) {
                runs.push({
                    key: prefix + 'w' + i,
                    text: part
                });
                return;
            }
            const sig = group[at];
            if (!sig) return;
            runs.push({
                key: prefix + 'c' + at,
                chip: sig
            });
            const start = sig.at ? new Date(sig.at).getTime() : NaN;
            if (Number.isFinite(start) && start >= nowMs && start < endOfDay.getTime()) {
                const time = el && typeof el.call === 'function' ? el.call('localizedDate', start, {
                    hour: '2-digit',
                    minute: '2-digit'
                }) : '';
                if (time) {
                    runs.push({
                        key: prefix + 't' + at,
                        text: ' '
                    });
                    runs.push({
                        key: prefix + 'f' + at,
                        time: t('workspace.home.brief.from').replace('{time}', time)
                    });
                }
            }
        });
        return runs;
    };
    const sentence = (key, group, prefix)=>{
        const runs = [];
        parts(t(key)).forEach((part, i)=>{
            if (part === '{facts}') runs.push(...facts(group, prefix));
            else runs.push({
                key: prefix + 's' + i,
                text: part
            });
        });
        return runs;
    };
    const out = [];
    if (attention.length) {
        out.push(sentence('workspace.home.brief.waiting', attention, 'a'));
        if (rest.length) out.push(sentence('workspace.home.brief.also', rest, 'b'));
    } else if (rest.length) out.push(sentence('workspace.home.summary.sentence', rest, 'a'));
    return out;
};
const $d93c3162c83e8100$export$6c268e5058d85cf1 = function homeSummaryOpenAsBoard() {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof el.call !== 'function') return null;
    const model = el.call('homeSummaryCompose', root);
    const words = (model.tiles || []).map((s)=>el.call('homeSignalsText', s)).filter(Boolean);
    if (!words.length) return null;
    const template = String(el.call('polyglot', 'workspace.home.brief.boardPrompt') ?? '');
    const prompt = template.replace('{facts}', words.join(" \xb7 "));
    return el.call('assistantBoardGenerate', prompt);
};

});

parcelRegister("khsuc", function(module, exports) {

$parcel$export(module.exports, "autoTopupData", () => $ec3b7de6d0415025$export$2ba212f7e39da79c);
$parcel$export(module.exports, "autoTopupWorkspace", () => $ec3b7de6d0415025$export$fd1a9d45efeb2430);
$parcel$export(module.exports, "autoTopupRule", () => $ec3b7de6d0415025$export$d7ddda4036e802f4);
$parcel$export(module.exports, "autoTopupValidation", () => $ec3b7de6d0415025$export$2289ae45f71cf242);
$parcel$export(module.exports, "autoTopupMoney", () => $ec3b7de6d0415025$export$71a4f42fdbb65ef6);
$parcel$export(module.exports, "autoTopupNumber", () => $ec3b7de6d0415025$export$a4d5533b6a9112de);
$parcel$export(module.exports, "autoTopupEdit", () => $ec3b7de6d0415025$export$bfa258d841909eb2);
$parcel$export(module.exports, "autoTopupChange", () => $ec3b7de6d0415025$export$c4b89aa1421656ee);
$parcel$export(module.exports, "autoTopupReview", () => $ec3b7de6d0415025$export$11d5ce36adc6e083);
$parcel$export(module.exports, "autoTopupClose", () => $ec3b7de6d0415025$export$b6b96942c843de8c);
$parcel$export(module.exports, "autoTopupAction", () => $ec3b7de6d0415025$export$b92e21467e3bd75a);
// The UI never enables automation optimistically. Stripe setup completion is
// the server's authority. Scope every async result to its original workspace.
const $ec3b7de6d0415025$export$2ba212f7e39da79c = (root)=>root?._autoTopup?.data || root?._autoTopup;
const $ec3b7de6d0415025$export$fd1a9d45efeb2430 = (root)=>root?.workspace?.id || root?.workspace?._id || root?.jwtClaims?.active_workspace_id;
const $ec3b7de6d0415025$var$ratesFor = (root)=>root?._usageRates?.data || root?._usageRates || {};
const $ec3b7de6d0415025$var$dollarsToCents = (value)=>{
    if (!/^\d+(\.\d{1,2})?$/.test(String(value))) return NaN;
    return Math.round(Number(value) * 100);
};
const $ec3b7de6d0415025$export$d7ddda4036e802f4 = (root)=>{
    const data = $ec3b7de6d0415025$export$2ba212f7e39da79c(root) || {};
    const draft = root?._autoTopupDraft;
    const rates = $ec3b7de6d0415025$var$ratesFor(root);
    const amountCents = draft ? $ec3b7de6d0415025$var$dollarsToCents(draft.amountUsd) : data.amountCents;
    return {
        amountCents: amountCents,
        thresholdCredits: draft ? Number(draft.thresholdCredits) : data.thresholdCredits,
        monthlyLimitCents: draft ? $ec3b7de6d0415025$var$dollarsToCents(draft.limitUsd) : data.monthlyLimitCents,
        credits: draft ? rates.centsPerCredit > 0 ? Math.floor(amountCents / rates.centsPerCredit) : null : data.credits
    };
};
const $ec3b7de6d0415025$export$2289ae45f71cf242 = (root)=>{
    const rates = $ec3b7de6d0415025$var$ratesFor(root);
    const rule = $ec3b7de6d0415025$export$d7ddda4036e802f4(root);
    if (!(rates.centsPerCredit > 0) || !(rates.topupMinCents > 0) || !(rates.topupMaxCents >= rates.topupMinCents)) return 'rates';
    if (!Number.isSafeInteger(rule.amountCents) || rule.amountCents < rates.topupMinCents || rule.amountCents > rates.topupMaxCents) return 'amount';
    if (!Number.isSafeInteger(rule.thresholdCredits) || rule.thresholdCredits < 1 || rule.thresholdCredits >= rule.credits) return 'threshold';
    if (!Number.isSafeInteger(rule.monthlyLimitCents) || rule.monthlyLimitCents < rule.amountCents || rule.monthlyLimitCents > rates.topupMaxCents) return 'limit';
    return null;
};
const $ec3b7de6d0415025$export$71a4f42fdbb65ef6 = (cents)=>Number.isFinite(cents) ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2
    }).format(cents / 100) : "\u2014";
const $ec3b7de6d0415025$export$a4d5533b6a9112de = (value)=>Number.isFinite(value) ? value.toLocaleString('en-US') : "\u2014";
const $ec3b7de6d0415025$export$bfa258d841909eb2 = function(root) {
    const data = $ec3b7de6d0415025$export$2ba212f7e39da79c(root) || {};
    const rates = $ec3b7de6d0415025$var$ratesFor(root);
    const amount = data.amountCents || rates.topupMinCents;
    const credits = rates.centsPerCredit > 0 ? Math.floor(amount / rates.centsPerCredit) : null;
    root.update({
        _autoTopupDraft: {
            thresholdCredits: data.thresholdCredits ?? (credits ? Math.max(1, Math.floor(credits / 5)) : ''),
            amountUsd: amount ? String(amount / 100) : '',
            limitUsd: data.monthlyLimitCents ? String(data.monthlyLimitCents / 100) : amount ? String(amount / 100) : ''
        },
        _autoTopupStep: 'edit',
        _autoTopupConsent: false,
        _autoTopupError: null,
        _autoTopupTouched: false,
        _autoTopupCheckoutUrl: null
    });
};
const $ec3b7de6d0415025$export$c4b89aa1421656ee = function(root, field, value) {
    root.update({
        _autoTopupDraft: {
            ...root._autoTopupDraft,
            [field]: value
        },
        _autoTopupConsent: false,
        _autoTopupError: null
    });
};
const $ec3b7de6d0415025$export$11d5ce36adc6e083 = function(root) {
    root.update({
        _autoTopupTouched: true
    });
    if (!$ec3b7de6d0415025$export$2289ae45f71cf242(root)) root.update({
        _autoTopupStep: 'review',
        _autoTopupConsent: false
    });
};
const $ec3b7de6d0415025$export$b6b96942c843de8c = function(root) {
    root.update({
        _autoTopupDraft: null,
        _autoTopupStep: null,
        _autoTopupConsent: false,
        _autoTopupError: null,
        _autoTopupCheckoutUrl: null
    });
};
const $ec3b7de6d0415025$export$b92e21467e3bd75a = async function(root, action) {
    if (root._autoTopupBusy) return;
    const workspaceId = $ec3b7de6d0415025$export$fd1a9d45efeb2430(root);
    if (!workspaceId) return;
    const request = (root._autoTopupRequest || 0) + 1;
    const sdk = this.call('getSDK');
    const method = {
        setup: 'setupAutoTopup',
        pause: 'pauseAutoTopup',
        refresh: 'refreshAutoTopup',
        load: 'getAutoTopup'
    }[action];
    if (!method || typeof sdk?.[method] !== 'function') {
        root.update({
            _autoTopupError: 'unavailable'
        });
        return;
    }
    if (action === 'setup' && ($ec3b7de6d0415025$export$2289ae45f71cf242(root) || !root._autoTopupConsent || root._autoTopupStep !== 'review')) return;
    root.update({
        _autoTopupBusy: true,
        _autoTopupError: null,
        _autoTopupRequest: request
    });
    const current = ()=>$ec3b7de6d0415025$export$fd1a9d45efeb2430(root) === workspaceId && root._autoTopupRequest === request;
    try {
        const payload = action === 'setup' ? {
            ...$ec3b7de6d0415025$export$d7ddda4036e802f4(root),
            consent: true,
            returnUrl: globalThis.document?.URL
        } : undefined;
        const response = await sdk[method](workspaceId, payload);
        const data = response?.data || response;
        if (!current()) return;
        if (action === 'setup') {
            // Native external link, never feed a Stripe URL into the app router.
            const url = new URL(data?.url);
            if (url.protocol !== 'https:' || url.hostname !== 'checkout.stripe.com') throw new Error('invalid_checkout_url');
            root.update({
                _autoTopupCheckoutUrl: url.toString(),
                _autoTopupStep: 'card',
                _autoTopup: {
                    ...$ec3b7de6d0415025$export$2ba212f7e39da79c(root),
                    ...$ec3b7de6d0415025$export$d7ddda4036e802f4(root),
                    enabled: false,
                    status: 'setup_required'
                }
            });
        } else {
            root.update({
                _autoTopup: data
            });
            if (action === 'pause') $ec3b7de6d0415025$export$b6b96942c843de8c(root);
        }
    } catch (error) {
        if (current()) root.update({
            _autoTopupError: error?.cause?.error === 'forbidden' ? 'forbidden' : error?.cause?.error === 'payment_in_progress' ? 'inProgress' : 'failed'
        });
    } finally{
        if (current()) root.update({
            _autoTopupBusy: false
        });
    }
};

});

parcelRegister("kZu9w", function(module, exports) {

$parcel$export(module.exports, "topupReturnParse", () => $f480e4d75f0b9b15$export$b61ac05da67822bd);
$parcel$export(module.exports, "topupCheckoutUrls", () => $f480e4d75f0b9b15$export$b6077dec5e34e296);
$parcel$export(module.exports, "topupReturnClearUrl", () => $f480e4d75f0b9b15$export$1cb9c78388809c2f);
$parcel$export(module.exports, "topupReturnConfirm", () => $f480e4d75f0b9b15$export$91eb61483ef799ba);
$parcel$export(module.exports, "topupReturnHandle", () => $f480e4d75f0b9b15$export$4edde085590dcee6);
$parcel$export(module.exports, "topupReturnText", () => $f480e4d75f0b9b15$export$dd99a71ae86a6931);
// /admin/usage — the return leg of a credit top-up checkout (ws crm,
// 2026-10-01, Nika's Stripe Sandbox run: he paid $20, the page came back to
// /admin/usage with NO message and NO credits).
//
// Stripe sends the person back to the usage page. A paid checkout carries
// `session_id` (the server writes it into the success URL); a cancelled one
// carries the page's own `topup=cancelled` marker (`topupCheckoutUrls`).
// On that return the page:
//   • confirms the payment through the SDK (`confirmCreditTopup(workspaceId,
//     sessionId)`, the `POST /core/workspaces/:workspaceId/billing/topups/
//     confirm` route → { applied, alreadyApplied, credits, balance }),
//     shows ONE line from the server's answer ("Payment received. 1,000
//     credits added.") or the failure with a retry, refreshes the balance,
//     and takes the return params off the address bar through the router;
//   • for a cancelled checkout shows a calm "No payment was made." line.
// An SDK without the confirm method keeps today's behaviour (no line, the
// URL untouched) — the page never breaks on an older SDK.
//
// State: ONE root key, `_topupReturn` (state.js, WORKSPACE_SCOPED):
//   null | { status: 'confirming' | 'paid' | 'failed' | 'cancelled',
//            sessionId?, credits?, error? }
// `this` is an element on the page in every export below (el.call).
// The return params of a URL string: { sessionId, cancelled } or null.
const $f480e4d75f0b9b15$export$b61ac05da67822bd = function topupReturnParse(href) {
    let url;
    try {
        url = new URL(String(href || ''));
    } catch (_) {
        return null;
    }
    const sessionId = url.searchParams.get('session_id') || null;
    const cancelled = url.searchParams.get('topup') === 'cancelled';
    if (!sessionId && !cancelled) return null;
    return {
        sessionId: sessionId,
        cancelled: cancelled && !sessionId
    };
};
const $f480e4d75f0b9b15$export$b6077dec5e34e296 = function topupCheckoutUrls(href) {
    const el = this;
    let url;
    try {
        url = new URL(String(href || ''));
    } catch (_) {
        return {
            successUrl: href || '',
            cancelUrl: href || ''
        };
    }
    const route = el && typeof el.call === 'function' ? el.call('stripWorkspacePrefix', url.pathname) : null;
    if (typeof route === 'string') {
        const prefix = route === '/' ? url.pathname.replace(/\/+$/, '') : url.pathname.slice(0, url.pathname.length - route.length);
        url.pathname = `${prefix}/admin/usage`;
        url.search = '';
        url.hash = '';
    }
    url.searchParams.delete('session_id');
    url.searchParams.delete('topup');
    const successUrl = url.toString();
    url.searchParams.set('topup', 'cancelled');
    return {
        successUrl: successUrl,
        cancelUrl: url.toString()
    };
};
const $f480e4d75f0b9b15$export$1cb9c78388809c2f = function topupReturnClearUrl() {
    const el = this;
    const doc = el && el.context && el.context.document;
    const href = doc && doc.URL || globalThis.document && globalThis.document.URL || '';
    let url;
    try {
        url = new URL(href);
    } catch (_) {
        return false;
    }
    if (!url.searchParams.has('session_id') && !url.searchParams.has('topup')) return false;
    url.searchParams.delete('session_id');
    url.searchParams.delete('topup');
    const bare = el.call('stripWorkspacePrefix', url.pathname) || url.pathname;
    const root = typeof el.getRoot === 'function' ? el.getRoot() : null;
    if (!root || typeof el.router !== 'function') return false;
    el.router(bare + url.search + url.hash, root, {}, {
        replace: true,
        scrollToTop: false
    });
    return true;
};
// The workspace the usage page is showing (pages/admin/usage.js
// `_usageWorkspaceId` — the same precedence).
const $f480e4d75f0b9b15$var$workspaceOf = (root)=>root?.workspace?.id || root?.workspace?._id || root?.jwtClaims?.active_workspace_id || null;
const $f480e4d75f0b9b15$export$91eb61483ef799ba = async function topupReturnConfirm(root, sessionId) {
    const el = this;
    if (!root || !sessionId) return null;
    const sdk = el.call('getSDK');
    if (!sdk || typeof sdk.confirmCreditTopup !== 'function') return null;
    const workspaceId = $f480e4d75f0b9b15$var$workspaceOf(root);
    if (!workspaceId) return null;
    if (root._topupReturn && root._topupReturn.status === 'confirming') return null;
    root.update({
        _topupReturn: {
            status: 'confirming',
            sessionId: sessionId
        }
    });
    try {
        const res = await sdk.confirmCreditTopup(workspaceId, sessionId);
        const data = res && res.data || res || {};
        if ($f480e4d75f0b9b15$var$workspaceOf(root) !== workspaceId) return null;
        const credits = Number(data.credits ?? data.creditsAdded);
        root.update({
            _topupReturn: {
                status: 'paid',
                sessionId: sessionId,
                credits: Number.isFinite(credits) ? credits : null
            }
        });
        // the balance row: a fresh read in the loader's own shape; the
        // confirm answer's balance when the read is not there
        let balance = data.balance ? {
            data: data.balance
        } : null;
        if (typeof sdk.getCreditBalance === 'function') try {
            balance = await sdk.getCreditBalance(workspaceId);
        } catch (_) {
        // keep the confirm answer's balance (or the row's last value)
        }
        if (balance && $f480e4d75f0b9b15$var$workspaceOf(root) === workspaceId) root.update({
            _usageBalance: balance
        });
        el.call('topupReturnClearUrl');
        return 'paid';
    } catch (err) {
        if ($f480e4d75f0b9b15$var$workspaceOf(root) !== workspaceId) return null;
        root.update({
            _topupReturn: {
                status: 'failed',
                sessionId: sessionId,
                error: err && err.cause && err.cause.error || err && err.message || null
            }
        });
        return 'failed';
    }
};
const $f480e4d75f0b9b15$export$4edde085590dcee6 = async function topupReturnHandle(root) {
    const el = this;
    if (!root) return null;
    const doc = el && el.context && el.context.document;
    const params = el.call('topupReturnParse', doc && doc.URL || globalThis.document && globalThis.document.URL || '');
    if (!params) return null;
    if (params.cancelled) {
        root.update({
            _topupReturn: {
                status: 'cancelled'
            }
        });
        el.call('topupReturnClearUrl');
        return 'cancelled';
    }
    const sdk = el.call('getSDK');
    // An SDK without the confirm method: today's behaviour, nothing else.
    if (!sdk || typeof sdk.confirmCreditTopup !== 'function') return null;
    if (!$f480e4d75f0b9b15$var$workspaceOf(root)) {
        // a cold deep link: the workspace record lands after the page mounts
        el.call('onActiveWorkspaceFull', ()=>el.call('topupReturnConfirm', root, params.sessionId));
        return 'waiting';
    }
    return el.call('topupReturnConfirm', root, params.sessionId);
};
const $f480e4d75f0b9b15$export$dd99a71ae86a6931 = function topupReturnText(state) {
    const el = this;
    const r = state && state._topupReturn;
    if (!r) return '';
    if (r.status === 'paid') {
        if (r.credits == null) return el.call('polyglot', 'admin.usage.topup.returnPaidNoCount');
        const n = Number(r.credits).toLocaleString('en-US', {
            maximumFractionDigits: 2
        });
        return el.call('polyglot', 'admin.usage.topup.returnPaid').replace('{credits}', n);
    }
    if (r.status === 'confirming') return el.call('polyglot', 'admin.usage.topup.returnConfirming');
    if (r.status === 'failed') return el.call('polyglot', 'admin.usage.topup.returnFailed');
    if (r.status === 'cancelled') return el.call('polyglot', 'admin.usage.topup.returnCancelled');
    return '';
};

});

parcelRegister("lKVGb", function(module, exports) {

$parcel$export(module.exports, "userCodeRuntimeText", () => $fd6aa2c332e6c589$export$23f7223c176a4fde);
// USER-CODE-ORIGIN: the smbls runtime TEXT the opaque user-code frame boots
// from (shared functions/iframeApp/userCodeFrame.js reads it through
// `el.call('userCodeRuntimeText')`). It lives in packages/workspace ONLY — the
// one package no other library bundles (frameworks ruling 2026-10-10): shared,
// preview and canvas reach it through the call, so the 595 KB string never
// rides a library's published data. frank bundles a dynamic
// `import('smbls/iife-string')` into the emitted library, and the 614 KB minified module's names collided with a
// lifted helper (`globalScope.G` lost its peer `u`: PUBLISH BLOCKED,
// unresolvable-identifier — measured 2026-10-10, fieldKitNameSurvivesFrank).
// The same import already ships in the shell's M2 sandbox and emits clean
// there. A lazy chunk: only a mount of user code pays for it.

const $fd6aa2c332e6c589$export$23f7223c176a4fde = ()=>(parcelRequire("kvnPV")).then((m)=>m.default || m);

});

parcelRegister("diDcA", function(module, exports) {

$parcel$export(module.exports, "inviteDropdownMode", () => $9aeb5d7f4b4fea7b$export$199cc75da3c0f8b8);
$parcel$export(module.exports, "inviteLinkPanelState", () => $9aeb5d7f4b4fea7b$export$ad07488389397559);
$parcel$export(module.exports, "inviteLinkRowRole", () => $9aeb5d7f4b4fea7b$export$68800acc1f2a5137);
$parcel$export(module.exports, "inviteLinkRowDate", () => $9aeb5d7f4b4fea7b$export$af559528c40eaea8);
$parcel$export(module.exports, "inviteLinkRowAsking", () => $9aeb5d7f4b4fea7b$export$c4a6a5a9dc37fa86);
$parcel$export(module.exports, "inviteLinkRowElement", () => $9aeb5d7f4b4fea7b$export$b4b2e3ba6ed3235d);
$parcel$export(module.exports, "inviteLinkFocus", () => $9aeb5d7f4b4fea7b$export$e1b9822a1b3db751);
$parcel$export(module.exports, "inviteLinkGuarded", () => $9aeb5d7f4b4fea7b$export$d0829fadc2e8091c);
$parcel$export(module.exports, "inviteLinkAsk", () => $9aeb5d7f4b4fea7b$export$1da84dffc9d22481);
$parcel$export(module.exports, "inviteLinkKeep", () => $9aeb5d7f4b4fea7b$export$73d8ba68b81c9228);
$parcel$export(module.exports, "inviteLinkConfirm", () => $9aeb5d7f4b4fea7b$export$a5cf739789672de6);
// The invite panel's mode switch (components/InviteDropdown.js): 'email' or
// 'link'. Called by AppSegmented as `el.call('inviteDropdownMode', value)`,
// so `this` is the segment that was picked; its track (InviteMode) owns no
// state, so the track's state IS the panel's. (The dropdown layer mounts the
// panel under the key `content`: a lookup by name finds nothing.) A switch
// also drops a pending revoke confirmation — it belongs to the view that asked.
function $9aeb5d7f4b4fea7b$export$199cc75da3c0f8b8(value) {
    const track = this && this.parent;
    const s = track && track.state;
    if (!s || typeof s.update !== 'function' || value !== 'email' && value !== 'link') return;
    if (s.mode === value) return;
    s.update({
        mode: value,
        revokeAsk: ''
    });
}
function $9aeb5d7f4b4fea7b$export$ad07488389397559() {
    // From inside the section `lookup` finds it (it walks UP); from the panel
    // itself the section is a child.
    const host = this.lookup('MagicLinkInInvite') || this.MagicLinkInInvite;
    return host && host.state && host.state.parent || {};
}
function $9aeb5d7f4b4fea7b$export$68800acc1f2a5137(s) {
    const host = this.lookup('MagicLinkInInvite');
    return host ? host.scope.magicLinkRoleText(this, s, s.role) : s && s.role || '';
}
function $9aeb5d7f4b4fea7b$export$af559528c40eaea8(s) {
    const host = this.lookup('MagicLinkInInvite');
    return host && s ? host.scope.magicLinkDate(this, s.endsAt) : '';
}
function $9aeb5d7f4b4fea7b$export$c4a6a5a9dc37fa86(s) {
    return !!(s && s.inviteId) && this.call('inviteLinkPanelState').revokeAsk === s.inviteId;
}
// ── The two-step revoke (components/InviteDropdown.js) ───────────────────
// First press: the row asks "Revoke this link?". The confirm "Revoke" does
// NOT appear where the first one was — that spot (the row's last button) is
// "Keep", and focus moves there — so a double click or a second fast Enter
// lands on the safe choice. Both answers also ignore activations for
// INVITE_REVOKE_GUARD_MS after the swap.
const $9aeb5d7f4b4fea7b$var$INVITE_REVOKE_GUARD_MS = 300;
function $9aeb5d7f4b4fea7b$export$b4b2e3ba6ed3235d(inviteId) {
    const section = this.lookup('MagicLinkInInvite') || this.MagicLinkInInvite;
    const list = section && section.ActiveLinks && section.ActiveLinks.LinkList;
    return list && inviteId && list['magicLink_' + inviteId] || null;
}
function $9aeb5d7f4b4fea7b$export$e1b9822a1b3db751(target) {
    const node = target && target.node;
    if (!node || typeof node.focus !== 'function') return;
    node.focus();
    setTimeout(()=>{
        if (node.isConnected && typeof node.focus === 'function') node.focus();
    }, 0);
}
function $9aeb5d7f4b4fea7b$export$d0829fadc2e8091c() {
    const panel = this.call('inviteLinkPanelState');
    return Date.now() - (Number(panel.revokeAskAt) || 0) < $9aeb5d7f4b4fea7b$var$INVITE_REVOKE_GUARD_MS;
}
function $9aeb5d7f4b4fea7b$export$1da84dffc9d22481(s) {
    const panel = this.call('inviteLinkPanelState');
    if (!panel.update || !s || s.busy) return;
    panel.update({
        revokeAsk: s.inviteId,
        revokeAskAt: Date.now()
    });
    const row = this.call('inviteLinkRowElement', s.inviteId);
    if (row) this.call('inviteLinkFocus', row.AppCapsuleBtnGhost_keep);
}
function $9aeb5d7f4b4fea7b$export$73d8ba68b81c9228(inviteId) {
    const panel = this.call('inviteLinkPanelState');
    if (!panel.update || !panel.revokeAsk) return;
    const id = inviteId || panel.revokeAsk;
    panel.update({
        revokeAsk: '',
        revokeAskAt: 0
    });
    const row = this.call('inviteLinkRowElement', id);
    if (row) this.call('inviteLinkFocus', row.AppCapsuleBtnGhost_revoke);
}
function $9aeb5d7f4b4fea7b$export$a5cf739789672de6(s) {
    const panel = this.call('inviteLinkPanelState');
    const host = this.lookup('MagicLinkInInvite');
    if (!panel.update || !host || !s || s.busy) return null;
    const id = s.inviteId;
    panel.update({
        revokeAsk: '',
        revokeAskAt: 0
    });
    return Promise.resolve(host.scope.magicLinkRevoke(host, host.state, id, s)).then(()=>{
        const row = this.call('inviteLinkRowElement', id);
        const actions = host.LinkActions;
        this.call('inviteLinkFocus', row ? row.AppCapsuleBtnGhost_revoke : actions && actions.AppCapsuleBtnPrimary);
    });
}

});

parcelRegister("a1COj", function(module, exports) {

$parcel$export(module.exports, "skipToMainHref", () => $74c81a4ee1fc4a79$export$91d9fc8b210a6cc3);
// skipToMainHref.js — THE SKIP LINK FOLLOWS THE OPEN WINDOW.
//
// The shell's first tab stop (app.js SkipToMain) jumps past the chrome to the
// content on screen. With the primary PageSlot pane open over the page, that
// content is the window, not the page behind it, so the link targets the pane:
// canvas components/PageSlot.js names each pane `page-slot-pane-<slot key>`,
// and the pane's `tabindex: -1` lets the browser's fragment jump focus it —
// the next Tab lands on the window's first control. With no pane open the
// link targets the route's main landmark (`#main-content`,
// functions/anchorMainContent.js).
//
// The primary pane is open while `_canvasSlot` holds its route — PageSlot's
// own gate (`_slotPane` hide). A close or a minimize clears the key or moves
// the split's second route into it (PageSlot `_closeSlot` / `_minimizeSlot`),
// so the second pane never holds a route alone, and the split placeholder
// (`_slotSplitIntent`, no route yet) belongs to the header search, which holds
// the keyboard. The key is read up front (a reactive caller: the link's
// `href`, re-rendered on `subscribeTo: ['_canvasSlot']`).
const $74c81a4ee1fc4a79$export$91d9fc8b210a6cc3 = function skipToMainHref(root) {
    const r = root && typeof root === 'object' ? root : {};
    const route = r._canvasSlot;
    return route ? '#page-slot-pane-_canvasSlot' : '#main-content';
};

});

parcelRegister("hSLcD", function(module, exports) {

$parcel$export(module.exports, "meetRealtimeScope", () => $d04c184e442d682c$export$9a7e5da4c5dd191a);
$parcel$export(module.exports, "personaOracleReady", () => $d04c184e442d682c$export$55d802ab90fbae51);
// sessionStreams.js — the streams and session reads a page with no session
// never opens (persona audit round 1, OV-2).
//
// MEASURED (dev, 2026-10-24/25, all eight personas): a signed-out page
// (/signup, /login, /demo, the magic-link callback before its tokens land)
// opened the shell's meet stream — `GET /core/meet/stream` answered 401 six to
// eighteen times while the SDK retried — and read the persona oracle
// (`GET /workspace-project/persona` → 401). The first signed-in load opened
// the same stream before the workspace was known (400: no workspace in the
// scope). Both are a SESSION's reads: the shell's meet channel feeds the call
// badge of ONE workspace, and the persona oracle reports the session's own
// role lens. Without a session there is nothing to stream and nothing to ask.
//
// The session signal is `currentUserEmail` — the one the shell's other
// realtime streams already wait on (app.js `_ensureShellRealtime`).
//
// FRANK: each export is self-contained (FA204) — no module-scope helper.
// The workspace id the shell's meet channel may open for, or null (no
// session yet, or no workspace resolved yet).
function $d04c184e442d682c$export$9a7e5da4c5dd191a(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r || typeof r.currentUserEmail !== 'string' || !r.currentUserEmail) return null;
    const ws = r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const id = ws && (ws.id || ws._id);
    return id ? String(id) : null;
}
function $d04c184e442d682c$export$55d802ab90fbae51(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r || r.signedIn !== true) return false;
    if (typeof r.currentUserEmail !== 'string' || !r.currentUserEmail) return false;
    const ws = r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    return !!(ws && (ws.id || ws._id));
}

});

parcelRegister("iJL0D", function(module, exports) {

$parcel$export(module.exports, "homeCtxTipVisible", () => $da40e5066eb838d0$export$6f47c7aafe4d3e83);
$parcel$export(module.exports, "homeCtxTipTick", () => $da40e5066eb838d0$export$723b59362211a293);
$parcel$export(module.exports, "homeKeyboardContextMenu", () => $da40e5066eb838d0$export$84f5744e518284dc);
// The home's context-menu tip (pages/main.js CtxMenuTip) and the keyboard way
// into the same menus (persona audit round 1, WH-9 — seven personas).
//
// MEASURED (dev 2026-10-24/25): the tip floated bottom-right over the cards
// and the chat on every page — it stayed up over an open window, the
// assistant and the welcome — it never went away unless its × was found, and
// it named no keyboard way ("the hint is mouse-only").
//
//   1. ONCE. It is dismissed for good after it has been SEEN for a few
//      seconds — the same dismissal its × writes (`_homeCtxTipDismissed` +
//      the `smbls_pref__homeCtxTipDismissed` cookie app.js reads at boot).
//      Time spent hidden does not count.
//   2. NEVER OVER CONTENT. It shows only on the plain board: not while a
//      window (PageSlot) is open, nor the assistant, the main thread, the
//      welcome or customize mode — the layers it used to sit on top of.
//   3. THE KEYBOARD WAY. Shift+F10 or the context-menu key on the board opens
//      the menu a right-click opens, on every OS (macOS has no keyboard
//      context menu of its own; Windows and Linux send their own, which is
//      cancelled so one menu opens, not two). The tip's words name it.
//
// FRANK: each export is self-contained (FA204); `this` is the calling element.
// Is the tip allowed on screen now? Pure over the root state.
function $da40e5066eb838d0$export$6f47c7aafe4d3e83(root) {
    const r = root && typeof root === 'object' ? root : null;
    if (!r) return false;
    return !(r._homeCtxTipDismissed || r._homeCustomizeMode || r._canvasSlot || r._canvasSlotSecond || r._homeThreadOpen || r.assistantOpen || r._onboardingOpen);
}
function $da40e5066eb838d0$export$723b59362211a293(tip, visible, env) {
    const SEEN_MS = 8000;
    const el = tip || this;
    if (!el || typeof el !== 'object') return false;
    const e = env && typeof env === 'object' ? env : {};
    const now = typeof e.now === 'function' ? e.now : ()=>Date.now();
    const set = typeof e.setTimeout === 'function' ? e.setTimeout : (fn, ms)=>setTimeout(fn, ms);
    const clear = typeof e.clearTimeout === 'function' ? e.clearTimeout : (id)=>clearTimeout(id);
    const scope = el.scope && typeof el.scope === 'object' ? el.scope : el.scope = {};
    const t = scope.ctxTipOnce || (scope.ctxTipOnce = {
        left: SEEN_MS,
        since: null,
        timer: null
    });
    if (t.done) return false;
    if (!visible) {
        if (t.timer != null) {
            clear(t.timer);
            t.timer = null;
            if (t.since != null) t.left = Math.max(0, t.left - (now() - t.since));
            t.since = null;
        }
        return false;
    }
    if (t.timer != null) return true;
    t.since = now();
    t.timer = set(()=>{
        t.timer = null;
        t.done = true;
        const root = el.state && el.state.root;
        if (root && typeof root.update === 'function') root.update({
            _homeCtxTipDismissed: true
        }, {
            preventFetch: true
        });
        try {
            if (typeof el.call === 'function') el.call('setPref', '_homeCtxTipDismissed', '1');
        } catch (_) {
        /* the cookie is a courtesy — the state already hides it */ }
    }, t.left);
    return true;
}
function $da40e5066eb838d0$export$84f5744e518284dc(e) {
    if (!e || e.defaultPrevented) return false;
    const isMenuKey = e.key === 'ContextMenu' || e.key === 'F10' && e.shiftKey === true;
    if (!isMenuKey || e.altKey || e.ctrlKey || e.metaKey) return false;
    const target = e.target;
    if (!target || typeof target.dispatchEvent !== 'function') return false;
    if (typeof target.closest === 'function' && target.closest('input, textarea, [contenteditable]')) return false;
    const view = target.ownerDocument && target.ownerDocument.defaultView;
    if (!view || typeof view.MouseEvent !== 'function') return false;
    const r = typeof target.getBoundingClientRect === 'function' ? target.getBoundingClientRect() : {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    };
    if (typeof e.preventDefault === 'function') e.preventDefault();
    target.dispatchEvent(new view.MouseEvent('contextmenu', {
        bubbles: true,
        cancelable: true,
        clientX: Math.round(r.left + Math.min(r.width / 2, 24)),
        clientY: Math.round(r.top + Math.min(r.height / 2, 24)),
        view: view
    }));
    return true;
}

});

parcelRegister("eE7tm", function(module, exports) {

$parcel$export(module.exports, "workspaceIsBusiness", () => $aa9a9901eab48fea$export$f632b17fb325d0e2);
$parcel$export(module.exports, "adminRailGroups", () => $aa9a9901eab48fea$export$f4f827d0077b9c14);
$parcel$export(module.exports, "canOpenAdmin", () => $aa9a9901eab48fea$export$72afefba6acf0fe);
$parcel$export(module.exports, "adminLandingPath", () => $aa9a9901eab48fea$export$416c2e566e565d7b);
// The admin rail's entries, in their groups (persona audit round 1 + 1b,
// WH-8 — seven personas).
//
// MEASURED (dev 2026-10-24/25): the rail listed 19 entries in one run — a
// clinic's owner read "Client Module", "Feature Flags", "Status", "System
// Health" beside "Users & Roles" — and at 1366x768 the last entries were cut
// below the screen with no scroll.
//
// Four groups, each under its own heading (components/AdminChrome.js
// AdminSidebarGroup, a native disclosure): the workspace itself, its usage and
// activity, its connections, and the developer tools. On a BUSINESS workspace
// the developer group starts folded — never while the page you are on is in
// it. A business workspace is one whose owner told us their work:
// `settings.preset` (an industry preset or "Something else", CONTRACT §1 —
// any non-empty preset is "answered"); a workspace with none keeps every
// group open (a developer's own workspace, or one set up before presets).
//
// The ROW ORDER is part of the contract (the admin page tests pin it):
// Workspace Settings first; Branding right after White-label Domains; Mail
// right after Integrations.
//
// FRANK: each export is self-contained (FA204) — the table lives inside the
// function that returns it; `this` is the calling element when el.call runs it.
// Is the active workspace a business workspace? → true when its owner chose a
// work (an industry preset or "Something else") in the welcome, Fly or the App
// Store.
function $aa9a9901eab48fea$export$f632b17fb325d0e2(root) {
    const r = root && typeof root === 'object' ? root : this && this.state && this.state.root;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const preset = ws && ws.settings && typeof ws.settings === 'object' ? ws.settings.preset : null;
    return !!(preset && typeof preset === 'object' && typeof preset.key === 'string' && preset.key);
}
function $aa9a9901eab48fea$export$f4f827d0077b9c14(root) {
    const r = root && typeof root === 'object' ? root : this && this.state && this.state.root;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const preset = ws && ws.settings && typeof ws.settings === 'object' ? ws.settings.preset : null;
    const business = !!(preset && typeof preset === 'object' && typeof preset.key === 'string' && preset.key);
    // The page on screen, without the /w/<org>/<workspace> prefix.
    const raw = String(r && (r.currentPath || r.route) || '/').split('?')[0];
    const here = raw.replace(/^\/w\/[^/]+\/[^/]+(?=\/|$)/, '') || '/';
    const groups = [
        {
            key: 'workspace',
            label: 'admin.nav.groupWorkspace',
            rows: [
                // FIRST on purpose (2026-09-02 per Nika): the GENERAL settings page
                // leads, every specialised console follows it.
                {
                    label: 'admin.nav.workspaceSettings',
                    href: '/admin/workspace-settings',
                    icon: 'settings'
                },
                {
                    label: 'admin.nav.usersRoles',
                    href: '/admin',
                    icon: 'user'
                },
                {
                    label: 'admin.nav.teams',
                    href: '/admin/teams',
                    icon: 'network'
                },
                {
                    label: 'admin.nav.permissions',
                    href: '/admin/permissions',
                    icon: 'lock'
                },
                {
                    label: 'admin.nav.dashboardDefaults',
                    href: '/admin/dashboard-defaults',
                    icon: 'grid'
                },
                // White-label domains — `Organization.customDomains`, the branded host
                // the SHELL is served on — and right after it what that host LOOKS
                // like (`Organization.branding`): two halves of one product.
                {
                    label: 'admin.nav.domains',
                    href: '/admin/domains',
                    icon: 'globe'
                },
                {
                    label: 'admin.nav.branding',
                    href: '/admin/branding',
                    icon: 'colorOutline'
                },
                // The data export sits beside the danger zone: both act on the whole
                // workspace.
                {
                    label: 'admin.data.nav',
                    href: '/admin/data',
                    icon: 'database'
                },
                {
                    label: 'admin.nav.danger',
                    href: '/admin/danger',
                    icon: 'exclMark'
                }
            ]
        },
        {
            key: 'usage',
            label: 'admin.nav.groupUsage',
            rows: [
                {
                    label: 'admin.nav.usage',
                    href: '/admin/usage',
                    icon: 'billing'
                },
                {
                    label: 'admin.nav.analytics',
                    href: '/admin/analytics',
                    icon: 'analytics'
                },
                {
                    label: 'admin.nav.activityLogs',
                    href: '/admin/logs',
                    icon: 'clock'
                },
                {
                    label: 'admin.nav.activityScoring',
                    href: '/admin/activity-scoring',
                    icon: 'ratingStar'
                }
            ]
        },
        {
            key: 'connections',
            label: 'admin.nav.groupConnections',
            rows: [
                {
                    label: 'admin.nav.integrations',
                    href: '/admin/integrations',
                    icon: 'sfPlugin'
                },
                {
                    label: 'admin.nav.mail',
                    href: '/admin/mail',
                    icon: 'email'
                }
            ]
        },
        {
            key: 'developer',
            label: 'admin.nav.groupDeveloper',
            foldable: true,
            rows: [
                {
                    label: 'admin.nav.module',
                    href: '/admin/module',
                    icon: 'blocks'
                },
                {
                    label: 'admin.nav.flags',
                    href: '/admin/flags',
                    icon: 'switching'
                },
                {
                    label: 'admin.nav.externalData',
                    href: '/data/external',
                    icon: 'database'
                },
                {
                    label: 'admin.nav.status',
                    href: '/admin/status',
                    icon: 'signal'
                },
                {
                    label: 'admin.nav.systemHealth',
                    href: '/admin/system',
                    icon: 'signal'
                }
            ]
        }
    ];
    // THE ROWS FOLLOW EACH PAGE'S OWN GATE (3a, concierge 2026-10-31 23:35):
    // a row shows unless the page it opens sends this person away
    // (functions/roleHelpers.js `adminPageAccess`, the answer the page itself
    // runs). A page still waiting for its inputs keeps its row, as the page
    // keeps the person; a group left with no row is left out. So an org admin
    // reads every row, and a workspace admin who is only an org member reads
    // the workspace's own pages. Asked through the calling element (el.call);
    // a bare call, with no element to ask, lists every row.
    const el = this && typeof this.call === 'function' ? this : null;
    const shows = (row)=>!el || el.call('adminPageAccess', r, row.href) !== 'closed';
    return groups.map((g)=>{
        const rows = g.rows.filter(shows);
        const holdsHere = rows.some((row)=>row.href === here);
        return {
            key: g.key,
            label: g.label,
            foldable: !!g.foldable,
            folded: !!g.foldable && business && !holdsHere,
            rows: rows
        };
    }).filter((g)=>g.rows.length);
}
function $aa9a9901eab48fea$export$72afefba6acf0fe(root) {
    const el = this && typeof this.call === 'function' ? this : null;
    const r = root && typeof root === 'object' ? root : el && el.state && el.state.root;
    if (!el || !r) return false;
    const rows = (el.call('adminRailGroups', r) || []).flatMap((g)=>g.rows || []);
    return rows.some((row)=>row.href.indexOf('/admin') === 0 && el.call('adminPageAccess', r, row.href) === 'open');
}
function $aa9a9901eab48fea$export$416c2e566e565d7b(root) {
    const el = this && typeof this.call === 'function' ? this : null;
    const r = root && typeof root === 'object' ? root : el && el.state && el.state.root;
    if (!el || !r) return '/';
    const rows = (el.call('adminRailGroups', r) || []).flatMap((g)=>g.rows || []).filter((row)=>row.href.indexOf('/admin/') === 0);
    const answers = rows.map((row)=>el.call('adminPageAccess', r, row.href));
    const at = answers.indexOf('open');
    if (at >= 0) return rows[at].href;
    return answers.indexOf('pending') >= 0 ? '' : '/';
}

});

parcelRegister("dKgR9", function(module, exports) {

$parcel$export(module.exports, "workspaceLanguageMenuRow", () => $a01ca589e40acb9c$export$ce2a420bf8492312);
$parcel$export(module.exports, "workspaceLanguageSelect", () => $a01ca589e40acb9c$export$ab3a6ca0c1206217);
// The avatar menu's Language row — the workspace shell's half (persona audit
// round 1, WL-2: giorgi and nino looked for the language and found it four
// taps deep, name → Admin → Workspace Settings → Language).
//
// The shared account menu (shared/functions/accountMenu.js) shows the row
// this builds and hands a pick back; a host that does not register these two
// shows no row.
//
//   workspaceLanguageMenuRow(root) → { key, label, children } | null
//     Only for someone who may set the WORKSPACE's language (onboardingLanguage
//     `canChange` — the org roles the admin card gates on); null for a member
//     (the workspace's language is its admins' choice) and for a host that
//     ships one language. The label names the current language ("Language:
//     English"), the children are the shipped languages by endonym, the
//     current one checked — the Theme row's shape.
//   workspaceLanguageSelect(code)
//     The ONE writer the welcome's language step uses
//     (onboardingSetWorkspaceLanguage): the per-key settings PATCH, then the
//     held record converges (setActiveWorkspaceRecord) and the shell's
//     language policy repaints the session at once — never the person's own
//     setLang.
//
// FRANK: self-contained exports; siblings through `this.call`.
function $a01ca589e40acb9c$export$ce2a420bf8492312(root) {
    const el = this;
    if (!el || typeof el.call !== 'function') return null;
    const lang = el.call('onboardingLanguage', root);
    if (!lang || typeof lang !== 'object' || !lang.canChange) return null;
    const choices = (Array.isArray(lang.choices) ? lang.choices : []).filter((c)=>c && typeof c.value === 'string' && c.value);
    if (choices.length < 2) return null;
    const current = choices.find((c)=>c.value === lang.current) || null;
    const words = String(el.call('polyglot', 'workspace.menu.language') || '');
    return {
        key: 'language',
        label: words.replace('{language}', current ? String(current.label || current.value) : ''),
        children: choices.map((c)=>({
                key: 'language-' + c.value,
                action: 'workspaceLanguage',
                code: c.value,
                label: String(c.label || c.value),
                checked: c.value === lang.current
            }))
    };
}
function $a01ca589e40acb9c$export$ab3a6ca0c1206217(code) {
    const el = this;
    if (!el || typeof el.call !== 'function' || typeof code !== 'string' || !code) return false;
    return el.call('onboardingSetWorkspaceLanguage', code);
}

});

parcelRegister("dL10z", function(module, exports) {

$parcel$export(module.exports, "applyShellLangPolicy", () => $a0407255c686f27f$export$1aada8dab3d212f6);
$parcel$export(module.exports, "markShellLangOwed", () => $a0407255c686f27f$export$7fd2a97f472d627e);
/**
 * applyShellLangPolicy — the shell root's gate in front of the WORKSPACE
 * language policy (shared `applyWorkspaceLangPolicy`).
 *
 * The workspace policy resolves `enforced > workspace language > brand >
 * English`. That chain belongs to a SIGNED-IN shell: it is boot step 7b's
 * chain, and 7b only runs with a session. A signed-out shell (the /login
 * bounce, a guest route) gets its language from the public resolution
 * instead (shared publicBootLang.js: `?lang=` → brand → browser → English),
 * stamped by bootShell before the auth shell mounts.
 *
 * The shell root ran the workspace policy once at mount on EVERY shell,
 * signed out included. With no session there is no workspace, so it
 * answered English and overwrote the public language: a Georgian browser on
 * dev.my.symbols.app/login painted `ka`, then English (QA round 4, giorgi).
 *
 * Signed out → nothing (the public language stays). Signed in → the policy,
 * unchanged. An in-place sign-in reaches the signed-in branch when the full
 * workspace record lands (`onActiveWorkspaceFull` re-runs the handler).
 *
 * THE LANGUAGE AN IN-PAGE SIGN-IN OWES (KA-1 race; concierge headless check,
 * dev, en-US browser, Georgian workspace, 2026-10-30). That sign-in continues
 * in the same shell: the signed-in chrome mounts in the PUBLIC language, and
 * the workspace language arrives with the full record as a switch that loads
 * the Georgian bundles. The loader waited for the data load only: it lifted
 * at 3.0–3.3 s, and the switch landed at 2.7 s in one run and at 4.9 s in
 * another (English chrome on screen for ~1.6 s). `markShellLangOwed` below
 * raises `_langOwed` at that sign-in; the shell loader holds while it is up
 * and shows no word (app.js `_isLoaderActive`, MainLoader). The newest run of
 * this policy that DECIDES pays it, once its switch has applied.
 *
 * A `function`, not an arrow: `el.call` binds `this` to the element.
 *
 * @returns {Promise<boolean>|boolean} true when the session language changed
 */ function $a0407255c686f27f$export$1aada8dab3d212f6() {
    const el = this;
    const root = el?.state?.root || el?.state || null;
    if (!root || root.signedIn !== true) return false;
    const result = el.call('applyWorkspaceLangPolicy');
    // A run DECIDES on a record that is complete, or never will be. A
    // placeholder decides nothing: the run on the full record pays. Only the
    // newest deciding run pays: an older one that a newer switch superseded
    // resolves first, while the newer bundles still load.
    const ws = root.workspace;
    if (root._langOwed === true && !!ws && !!(ws.id || ws._id) && el.call('workspaceSettingsPending', root) !== true) {
        const run = {};
        el._langOwedRun = run;
        const pay = ()=>{
            if (el._langOwedRun !== run) return;
            el._langOwedRun = null;
            clearTimeout(el._langOwedCap);
            el._langOwedCap = null;
            try {
                if (root._langOwed === true) root.update({
                    _langOwed: false
                });
            } catch (_) {
            /* torn down before the switch applied */ }
        };
        Promise.resolve(result).then(pay, pay);
    }
    return result;
}
function $a0407255c686f27f$export$7fd2a97f472d627e() {
    const el = this;
    const root = el?.state?.root || el?.state || null;
    if (!root || typeof root.update !== 'function') return false;
    if (el.context?.bootSignedIn !== false) return false;
    clearTimeout(el._langOwedCap);
    el._langOwedRun = null;
    root.update({
        _langOwed: true
    });
    const cap = setTimeout(()=>{
        if (el._langOwedCap !== cap) return;
        el._langOwedCap = null;
        el._langOwedRun = null;
        try {
            if (root._langOwed === true) root.update({
                _langOwed: false
            });
        } catch (_) {
        /* torn down */ }
    }, 7000);
    el._langOwedCap = cap;
    // The full record can land before this tick: its policy run is over, and it
    // ran with nothing owed. Run the policy once more; it pays when it decides.
    // No record, or a placeholder: the full record's own run comes later.
    const ws = root.workspace;
    if (!!ws && !!(ws.id || ws._id) && el.call('workspaceSettingsPending', root) !== true) Promise.resolve(el.call('applyShellLangPolicy')).catch((err)=>console.warn('[shell] workspace language policy failed:', err?.message || err));
    return true;
}

});


parcelRegister("df0As", function(module, exports) {

$parcel$export(module.exports, "workspaceScopedWipe", () => $9a3d219ffab17311$export$1b7b301a3deaced6);
// Scope key sets — used by switcher functions to clear the right state
// entries on each scope boundary.

var $MygIX = parcelRequire("MygIX");
var $4MpU9 = parcelRequire("4MpU9");

var $j9v8x = parcelRequire("j9v8x");
const $9a3d219ffab17311$export$f3c838493bcddb40 = new Set([
    'user',
    'preferences',
    'themeMode',
    'lang'
]);
const $9a3d219ffab17311$export$f7d96e00e6255606 = new Set([
    'org',
    'permissions',
    'orgMembers',
    'orgRoles',
    'orgTeams'
]);
const $9a3d219ffab17311$export$be490344bd4e10ea = new Set([
    'workspace',
    'workspaceMembers',
    'workspaceIntegrations',
    'workspaceBilling'
]);
const $9a3d219ffab17311$export$a7caae68135f0ff4 = new Set([
    'project',
    'projectComponents',
    'projectPages',
    'projectState'
]);
const $9a3d219ffab17311$export$c8740b164904f871 = new Set([
    'workspaceProject'
]);
// Fresh, type-directed empty value for a schema default. Arrays/objects
// must be NEW instances every call — `stateDefaults` is a module-level
// singleton (state.js's default export, imported once), so reusing its `[]`
// / `{}` literal directly would let one workspace's mutations bleed into
// the next switch's "empty" value. Scalars (null/false/''/numbers) are
// immutable in JS and pass through unchanged — nothing to clone.
const $9a3d219ffab17311$var$_freshEmpty = (v)=>Array.isArray(v) ? [] : v && typeof v === 'object' ? {} : v;
const $9a3d219ffab17311$export$1b7b301a3deaced6 = (root)=>{
    const patch = (0, $j9v8x.moduleScopedWipe)(root);
    for (const key of (0, $MygIX.WORKSPACE_SCOPED_KEYS))patch[key] = Object.prototype.hasOwnProperty.call((0, $4MpU9.WORKSPACE_SCOPED_OVERRIDES), key) ? $9a3d219ffab17311$var$_freshEmpty((0, $4MpU9.WORKSPACE_SCOPED_OVERRIDES)[key]) : $9a3d219ffab17311$var$_freshEmpty((0, $MygIX.STATE_DEFAULTS)[key]);
    return patch;
};

});

parcelRegister("1gcj7", function(module, exports) {

$parcel$export(module.exports, "healUserRecord", () => $0eb0d50e600397dd$export$eeceba1f529d7af9);
// SHELL-USER-KEY-1 (tickets/bellforge.md, 2026-08-15): on a warm-start boot
// the `currentUser*` identity keys come from the CACHED snapshot, while the
// full `root.user` record is stamped pre-create only when the LIVE getMe
// succeeds (bootShell.js `context.state.user = _me`). When getMe fails
// ambiguously (`_getMeUnresolved` — transport error, 5xx — routine on a
// loaded dev box), the boot correctly proceeds without it, but nothing
// retried the stamp, so `root.user` stayed null for the whole session —
// measured live: `root.user`/`root.me` empty while `currentUserId`/
// `currentUserEmail` landed, silently emptying every consumer that reads
// the record (globalRole gates, display names).
//
// One-shot, non-blocking heal, called from loadPrivateData on every boot
// pass: when the record is missing but the session is real, re-fetch getMe
// and stamp it reactively. The latch is a plain property on purpose (not
// state — a failed heal must not re-render anything; the next full boot
// retries naturally). Returns the in-flight promise for tests; callers
// fire-and-forget.
const $0eb0d50e600397dd$export$eeceba1f529d7af9 = (root, sdk)=>{
    if (!root || !sdk || typeof sdk.getMe !== 'function') return null;
    if (root.user || !root.currentUserId || root._userRecordHealTried) return null;
    root._userRecordHealTried = true;
    return (async ()=>{
        try {
            const meRes = await sdk.getMe();
            const me = meRes && (meRes.user || meRes.data && meRes.data.user) || meRes;
            if (me && (me._id || me.id) && !root.user) {
                root.update({
                    user: me
                });
                return true;
            }
        } catch (_) {
        /* ambiguous again — leave null; canonical identity keys still work */ }
        return false;
    })();
};

});

parcelRegister("caKf8", function(module, exports) {

$parcel$export(module.exports, "setAnalyzingWorkspace", () => $8dca4a249ebf536b$export$bdde0f5e6945a5c2);
$parcel$export(module.exports, "resolveAnalyzingScopeId", () => $8dca4a249ebf536b$export$83b305ed6af44b56);
$parcel$export(module.exports, "bootAnalyzing", () => $8dca4a249ebf536b$export$d1756ea37d9dd993);
$parcel$export(module.exports, "identifyFromSdk", () => $8dca4a249ebf536b$export$e6f44109b5d45581);
$parcel$export(module.exports, "reidentifyOnOrgSwitch", () => $8dca4a249ebf536b$export$8e98275a5fb1017a);
/**
 * Workspace-shell analyzing singleton.
 *
 * Wraps @symbo.ls/analyzing so every sub-app + the shell itself share one
 * session, one user identity, and one transport. Boots once the SDK is
 * available so the envelope ships through sdk.execute('workspaceProject.analyzed',
 * 'ingest', …) — a deprecated SDK-level alias that delegates to the main API
 * server's Mongo-backed POST /core/analyzed/ingest route (the old
 * Supabase-backed workspace-project worker surface it used to name was
 * deleted with the Supabase plane, 2026-07-27).
 *
 * Replaces Grafana Faro. No dedicated worker, no separate endpoint.
 *
 * Usage from app.js:
 *   import { bootAnalyzing, identifyAnalyzing, reidentifyOnOrgSwitch } from './analyzing.js'
 *   onCreate: (el, s) => {
 *     bootAnalyzing({ sdk: el.sdk })
 *     identifyAnalyzing({ user: s.user })
 *   }
 *
 * Failures are swallowed — telemetry breaking the shell would be worse than
 * the missing data.
 *
 * ATTRIBUTION (tickets/opus.md "analyzed ingest: real per-app attribution"):
 * `appKey` is a caller-supplied parameter (see `bootAnalyzing` below), no
 * longer a hardcoded literal — server/src/domains/analyzed/services/
 * AnalyzedWriteService.js's writeEnvelope() already derives the stored
 * `projectId` from `envelope.project_id || app?.key`, authoritatively
 * scoped underneath a SEPARATE, server/JWT-resolved `workspace` (tenant)
 * field — so any caller of bootAnalyzing MAY stamp its own identity
 * (ideally its manifest's canonical `key`, e.g. 'system--canvas') without
 * opening any cross-tenant vector: a spoofed appKey can only mislabel data
 * that already belongs to the caller's own authenticated tenant.
 *
 * THIS FILE's own call site (workspace/packages/workspace/app.js) keeps
 * the literal 'workspace' default deliberately: app.js is the unified
 * my.symbols.app shell's OWN root component — it is never shared with
 * canvas/marketplace/preview's standalone app.js files (each ships its
 * own), so 'workspace' is the accurate identity here, not a placeholder.
 * The shell DOES lazy-route canvas/marketplace/preview/native pages
 * within this one session (workspace/packages/workspace/index.js's
 * `apps` map + the smbls default router over merged `context.pages`),
 * but that routing is deliberately NOT used to further split this
 * `appKey`/`projectId`, for two concrete reasons:
 *   1. Each sub-app's `manifest.routes` regex array is consulted ONLY by
 *      bootShell's single-app STANDALONE dispatch (`_singleAppDispatch`
 *      in shared/functions/bootShell.js) — the unified multi-app shell
 *      never matches URLs against it. Reusing it here anyway is actively
 *      wrong: canvas/manifest.js's own catch-all `/^\/[^/]+\/[^/]+/`
 *      matches the primary Scheme-A workspace URL shape
 *      (`/w/<org>/<workspace>/...`), so naive regex reuse would
 *      mislabel effectively all native workspace traffic as "canvas".
 *   2. Even a reliable per-route signal would face the same problem the
 *      ticket flags for native routes (/tasks vs /notes vs /excalidraw):
 *      one continuous browser session can legitimately cross from
 *      native pages into canvas into marketplace, and a single
 *      session-level `projectId` can't cleanly represent that — forcing
 *      a split is a product call about analytics granularity, not an
 *      engineering default. `route` already rides on every EVENT
 *      (AnalyzedWriteService: `eventDocs[].route`), so a rollup can
 *      still derive per-route/per-surface breakdowns later without the
 *      shell guessing at a taxonomy here.
 * Genuinely separate deployments (canvas/marketplace/preview/analytics's
 * OWN standalone `bootShell()` entry points, and any workspace/apps/*
 * platform feature app) are real, unambiguous, single-app sessions and
 * are the correct place to pass a distinct `appKey` — that wiring lives
 * outside this package (workspace/packages/canvas, workspace/packages/
 * shared, workspace/apps/*) and is out of this file's scope.
 */ parcelRequire("lHyXG");
var $jaOyK = parcelRequire("jaOyK");

var $hmkNw = parcelRequire("hmkNw");
let $8dca4a249ebf536b$var$_instance = null;
let $8dca4a249ebf536b$var$_booting = false;
// Resolves when the async tracker construction settles (see bootAnalyzing).
let $8dca4a249ebf536b$var$_bootPromise = null;
// Tenant scope — every envelope carries `workspace_id` so the server's
// /core/analyzed/ingest can route the write to the correct tenant
// bucket without relying on `req.user.activeOrganization`. The
// workspace shell stamps this from the unified-auth-boot snapshot at
// init (orgs[0] / Mongo activeOrg / gov JWT — same resolver the rest
// of the shell uses) and refreshes it on every `sdk.orgSwitched`
// event so subsequent telemetry lands in the new tenant. Stays
// module-level so the beforeSend closure can read the latest value
// without rebinding the analyzing instance.
let $8dca4a249ebf536b$var$_workspaceId = null;
const $8dca4a249ebf536b$export$bdde0f5e6945a5c2 = (id)=>{
    const next = id ? String(id) : null;
    // The boot set (null → id) of a FULL page load: the tracker may have
    // reused the tab's stored session id from a page in ANOTHER workspace
    // (ANALYZING-SESSION-BOOT-ROTATE-1). Rotate there, same path as below.
    if ($8dca4a249ebf536b$var$_workspaceId == null && next != null && $8dca4a249ebf536b$var$_rotateIfStoredScopeDiffers(next)) return;
    const changed = $8dca4a249ebf536b$var$_workspaceId != null && next != null && next !== $8dca4a249ebf536b$var$_workspaceId;
    // A CHANGE of tenant scope mid-page ends the current analyzing session and
    // starts a fresh one (tickets/analytics.md ANALYZING-SESSION-ROTATE-1). The
    // server keys a session row on {_id, workspace}: the same session id under
    // the new workspace is refused (409) for the rest of the session — every
    // post-switch beacon used to be dropped silently. Only a real change
    // rotates: the boot set (null → id), a repeat of the same id, and a clear
    // (id → null) do not. `_instance` may be null pre-boot; nothing to rotate.
    //
    // ORDER MATTERS: rotate BEFORE re-stamping `_workspaceId`. The rotation
    // flushes the old session's queue plus its terminal envelope synchronously
    // through beforeSend, which reads `_workspaceId` — so that last envelope is
    // stamped with the OLD workspace and the server (member-gated explicit
    // stamp on /ingest) files it under the old session regardless of when the
    // user's Mongo claim flips. Measured the other way round: 6× 409 on the
    // old id, endedAt never written, its last batch lost.
    if (changed && $8dca4a249ebf536b$var$_instance && typeof $8dca4a249ebf536b$var$_instance.startNewSession === 'function') {
        $8dca4a249ebf536b$var$_instance.startNewSession();
        $8dca4a249ebf536b$var$_workspaceId = next;
        // Open the new session on the wire right away (the dashboard's Who's
        // Active reads sessions, not just events) instead of waiting for the
        // next organic event.
        try {
            $8dca4a249ebf536b$var$_instance.captureMessage('session.start', 'info', {
                reason: 'workspace-switch',
                workspaceId: next
            });
        } catch (_) {}
        // Fresh session, fresh page-view dedupe: the path on screen after the
        // switch is the NEW session's first page view, not a consecutive repeat
        // of the old session's last one. The next navigation (org switches
        // almost always route) re-emits even when the pathname is identical.
        $8dca4a249ebf536b$var$_lastPageViewPath = null;
        return;
    }
    $8dca4a249ebf536b$var$_workspaceId = next;
};
const $8dca4a249ebf536b$export$b5b66d259f06b59d = 'smbls_sid_ws';
const $8dca4a249ebf536b$var$_sessionScopeStorage = ()=>{
    try {
        return typeof globalThis !== 'undefined' ? globalThis.sessionStorage || null : null;
    } catch (_) {
        return null;
    }
};
const $8dca4a249ebf536b$var$_readSessionScope = ()=>{
    try {
        const raw = $8dca4a249ebf536b$var$_sessionScopeStorage()?.getItem?.($8dca4a249ebf536b$export$b5b66d259f06b59d);
        if (!raw) return null;
        const rec = JSON.parse(raw);
        if (!rec || typeof rec.sessionId !== 'string' || typeof rec.workspaceId !== 'string') return null;
        if (!rec.sessionId || !rec.workspaceId) return null;
        return rec;
    } catch (_) {
        return null;
    }
};
const $8dca4a249ebf536b$export$16acc6b8304e6554 = (envelope)=>{
    try {
        const sessionId = envelope?.session?.id;
        const workspaceId = envelope?.workspace_id;
        if (!sessionId || !workspaceId) return;
        $8dca4a249ebf536b$var$_sessionScopeStorage()?.setItem?.($8dca4a249ebf536b$export$b5b66d259f06b59d, JSON.stringify({
            sessionId: String(sessionId),
            workspaceId: String(workspaceId)
        }));
    } catch (_) {
    /* best-effort */ }
};
// Rotate when the tab's stored record says the CURRENT session id shipped
// under another workspace than `next`. Same order as the live switch: the
// old session ends while the stamp is still ITS workspace, then the new
// session opens with a session.start. Returns true when it rotated (and
// stamped `next`).
const $8dca4a249ebf536b$var$_rotateIfStoredScopeDiffers = (next)=>{
    if (!next || !$8dca4a249ebf536b$var$_instance || typeof $8dca4a249ebf536b$var$_instance.startNewSession !== 'function') return false;
    const stored = $8dca4a249ebf536b$var$_readSessionScope();
    if (!stored) return false;
    let current = null;
    try {
        current = $8dca4a249ebf536b$var$_instance.sessionId;
    } catch (_) {
        return false;
    }
    if (!current || stored.sessionId !== String(current) || stored.workspaceId === next) return false;
    $8dca4a249ebf536b$var$_workspaceId = stored.workspaceId;
    try {
        $8dca4a249ebf536b$var$_instance.startNewSession();
    } catch (_) {
    /* the tracker stays on the old id; the stamp still moves on */ }
    $8dca4a249ebf536b$var$_workspaceId = next;
    try {
        $8dca4a249ebf536b$var$_instance.captureMessage('session.start', 'info', {
            reason: 'workspace-boot',
            workspaceId: next
        });
    } catch (_) {}
    $8dca4a249ebf536b$var$_lastPageViewPath = null;
    return true;
};
const $8dca4a249ebf536b$export$286878ee1052fbae = (instance)=>{
    $8dca4a249ebf536b$var$_instance = instance || null;
};
const $8dca4a249ebf536b$export$d2b5942c39cfc8a1 = ()=>$8dca4a249ebf536b$var$_workspaceId;
const $8dca4a249ebf536b$export$83b305ed6af44b56 = ({ sdk: sdk, root: root, claims: claims } = {})=>sdk?._context?.activeWorkspaceId || root?.workspace?.id || root?.activeWorkspaceId || claims?.active_workspace_id || root?.jwtClaims?.active_workspace_id || root?.org?.id || claims?.workspace_org_id || root?.jwtClaims?.workspace_org_id || null;
// Attribution key this instance booted with — set once, inside
// bootAnalyzing, from the caller's `appKey` (or the 'workspace' default).
// Exposed read-only (no setter — unlike `_workspaceId`, this is a
// boot-time identity, not a value that changes mid-session) so tests and
// QA can confirm what a given caller actually stamped without reaching
// into the instance internals.
let $8dca4a249ebf536b$var$_appKey = null;
const $8dca4a249ebf536b$export$4bac9f62406beb0e = ()=>$8dca4a249ebf536b$var$_appKey;
const $8dca4a249ebf536b$export$1e672ab706944ab7 = (appKey)=>appKey ? String(appKey) : 'workspace';
const $8dca4a249ebf536b$var$releaseTag = ()=>{
    if (typeof globalThis !== 'undefined' && globalThis.__BUILD_SHA__) return String(globalThis.__BUILD_SHA__);
    return null;
};
const $8dca4a249ebf536b$export$d1756ea37d9dd993 = ({ sdk: sdk, capture: capture, workspaceId: workspaceId, appKey: appKey } = {})=>{
    if ($8dca4a249ebf536b$var$_instance || $8dca4a249ebf536b$var$_booting) return $8dca4a249ebf536b$var$_instance;
    if (typeof window === 'undefined') return null;
    if (!sdk) return null;
    // Stash a reference so the lazy resolver below can pick up a swap-in if
    // the workspace shell ever re-mints its SDK (rare but possible during
    // session refresh). Surfacing on window also gives QA a probe point.
    try {
        window.__symbolsSdk = sdk;
    } catch (_) {}
    if (workspaceId) $8dca4a249ebf536b$var$_workspaceId = String(workspaceId);
    $8dca4a249ebf536b$var$_appKey = $8dca4a249ebf536b$export$1e672ab706944ab7(appKey);
    $8dca4a249ebf536b$var$_booting = true;
    // The `@symbo.ls/analyzing` import is resolved inside an ASYNC function on
    // purpose. In the published payload frank rewrites a bare npm import into
    // `await import(...)`, and it refuses to inject that await into a
    // synchronous caller chain — `unresolvable-npm-module-sync-guard`, the last
    // finding that blocked the workspace-shell publish
    // (WORKSPACE-SHELL-FRANK-GATE-BLOCKS-REPUBLISH-1). Booting one microtask
    // later is invisible to callers: every call site ignores the return value,
    // and `getAnalyzing()` already answered null while `_booting` was true.
    // `identifyFromSdk` awaits `_bootPromise`, so the identity stamp still
    // lands on the real instance.
    // The inner `await` is load-bearing, not style: frank only injects the
    // dynamic `await import('@symbo.ls/analyzing')` into `_bootAnalyzingNow`
    // when EVERY call site of it in the project awaits it
    // (toJSON.js `hasUnawaitedCallSiteInProject`). The retained promise lets
    // `identifyFromSdk` join an in-flight boot.
    $8dca4a249ebf536b$var$_bootPromise = (async ()=>{
        try {
            return await $8dca4a249ebf536b$var$_bootAnalyzingNow({
                sdk: sdk,
                capture: capture
            });
        } catch (err) {
            console.warn('[analyzing] boot failed:', err?.message || err);
            return null;
        }
    })();
    return $8dca4a249ebf536b$var$_instance;
};
// The actual tracker construction — async so the npm import can be awaited.
const $8dca4a249ebf536b$var$_bootAnalyzingNow = async ({ sdk: sdk, capture: capture })=>{
    try {
        $8dca4a249ebf536b$var$_instance = (0, $jaOyK.createAnalyzing)({
            // Pass a LAZY sdk resolver: the workspace shell may call bootAnalyzing
            // before the SDK has fully hydrated its services / execute proxy. By
            // resolving fresh on every envelope flush we tolerate a brief boot
            // race without dropping events.
            sdk: ()=>typeof window !== 'undefined' && window.__symbolsSdk || sdk,
            appKey: $8dca4a249ebf536b$var$_appKey,
            release: $8dca4a249ebf536b$var$releaseTag(),
            env: (0, $hmkNw.currentChannel)(),
            level: 'info',
            sampleRate: 1,
            // Default-on user interaction capture for the workspace shell. The
            // smbls/plugins/analyze browser listeners emit one `pointer` event
            // per click/dblclick/contextmenu with `target.key` + `target.path`
            // resolved by walking up the DOM looking for `data-key` attributes
            // (which DOMQL emits on every element with a key). Callers may
            // override individual flags (pass `capture: { pointer: false }` to
            // opt out). Errors/console/network/navigation/performance/viewport
            // stay on via the underlying `remote` preset.
            capture: {
                pointer: true,
                keyboard: false,
                forms: false,
                ...capture || {}
            },
            // Symbols-dogfood scrub: never ship raw auth payloads or tokens. The
            // built-in redact catches the obvious cases (`password`, `token`,
            // `apikey`, `secret`); these additions cover symbols-specific shapes.
            redact: [
                /symbols_access_token/i,
                /workspace_access_token/i,
                /jwtClaims/i
            ],
            consoleSink: false,
            memorySink: true,
            // beforeSend does three things:
            //   1. Drops the envelope entirely when there's no workspace scope
            //      (pre-login pages, signed-out users, boot race before the
            //      shell resolves the active workspace). Without this guard the
            //      tracker still POSTs to /core/analyzed/ingest with no
            //      workspace_id — the server now accepts both authed + anon
            //      ingest, so it falls through to req.body.workspace_id which
            //      is also missing and returns 400. Telemetry is workspace-
            //      scoped data by design; pre-login activity can't be
            //      attributed to a tenant and is silently dropped.
            //   2. Stamps `workspace_id` from the module-level `_workspaceId`
            //      so the server's /core/analyzed/ingest can scope the write
            //      per tenant without depending on `req.user.activeOrganization`.
            //   3. Drops our own ingest traffic so analyzing never observes
            //      itself observing.
            //   4. Stamps the analytics read side's family + zone facts
            //      (WS-ANALYTICS-FAMILY-SPLIT-UTC-TOTALS-1): every shell session
            //      is the WORKSPACE family (`kind`), and `page.utcOffset`
            //      (minutes east of UTC) lets the session detail name the
            //      visitor's zone. Guarded — never clobbers a caller-set kind,
            //      never throws on a foreign envelope shape; works with the
            //      currently published SDK (plain envelope fields).
            beforeSend: (envelope)=>{
                if (!envelope) return envelope;
                if (!$8dca4a249ebf536b$var$_workspaceId) return null;
                envelope.workspace_id = $8dca4a249ebf536b$var$_workspaceId;
                try {
                    if (!envelope.kind) envelope.kind = 'workspace';
                    const page = envelope.page && typeof envelope.page === 'object' ? envelope.page : {};
                    if (page.utcOffset == null) envelope.page = {
                        ...page,
                        utcOffset: -new Date().getTimezoneOffset()
                    };
                } catch (_) {
                /* stamp is best-effort */ }
                if (!Array.isArray(envelope.events)) {
                    $8dca4a249ebf536b$export$16acc6b8304e6554(envelope);
                    return envelope;
                }
                envelope.events = envelope.events.filter((e)=>{
                    if (e.type !== 'network') return true;
                    const u = String(e.url || '');
                    if (u.includes('/analyzed/')) return false;
                    return true;
                });
                if (!envelope.events.length) return null;
                // The envelope ships: remember which workspace this session id now
                // belongs to, for the next full page load of this tab.
                $8dca4a249ebf536b$export$16acc6b8304e6554(envelope);
                return envelope;
            }
        });
        // Boot with a stamp already known (bootAnalyzing's `workspaceId`): the
        // tracker may have reused a session id this tab shipped under ANOTHER
        // workspace before a full-page navigation — rotate BEFORE the state
        // activates, so no envelope ships the old id under the new workspace
        // (ANALYZING-SESSION-BOOT-ROTATE-1). A later boot set (null → id) goes
        // through setAnalyzingWorkspace instead.
        if ($8dca4a249ebf536b$var$_workspaceId) $8dca4a249ebf536b$var$_rotateIfStoredScopeDiffers($8dca4a249ebf536b$var$_workspaceId);
        // The plugin state activates inside DOMQL's create() → plugin lifecycle.
        // For pre-shell errors caught by the SDK's pre-boot window listeners we
        // call activate(null) so they flush immediately.
        try {
            $8dca4a249ebf536b$var$_instance.state.activate(null);
        } catch (_) {}
        // Debug exposure — surfaces the analyzing instance on window so QA can
        // probe captureError / state / sessionId from the console. Never use
        // for application logic.
        try {
            if (typeof window !== 'undefined') window.__symbolsAnalyzing = $8dca4a249ebf536b$var$_instance;
        } catch (_) {}
        // Route/slot page views — see the section above getAnalyzing.
        try {
            $8dca4a249ebf536b$var$_wirePageViews();
        } catch (_) {}
    } catch (err) {
        console.warn('[analyzing] boot failed:', err?.message || err);
        $8dca4a249ebf536b$var$_instance = null;
        $8dca4a249ebf536b$var$_appKey = null;
    } finally{
        $8dca4a249ebf536b$var$_booting = false;
    }
    return $8dca4a249ebf536b$var$_instance;
};
const $8dca4a249ebf536b$export$a08cb966e0f2c6a5 = ()=>$8dca4a249ebf536b$var$_instance;
// ── Shell page views (WS-SHELL-ANALYZING-NO-PAGE-VIEW-EVENTS-1) ────────────
// The server's page-view predicate matches `message: 'page_view'` OR
// `type: 'navigation'` (AnalyzedController _PAGE_VIEW_EXPR). The smbls
// analyze plugin's `navigation` capture never fires for the shell — routes
// move through PageSlot slot swaps and `el.router`, not through the hook it
// wires — so the workspace family sat at 0 page views while the public
// tracker's own `page_view` capture (sdk/packages/analyzing/src/boot.js)
// counted the projects family fine. The shell therefore captures its own
// `page_view`, the same shape the public tracker emits: the aggregations
// read `payload.data.path` (_PAGE_PATH_EXPR).
//
// No history patch here (Rule 64 — never mutate window/history from the
// shell): AppShell's `installAppShellSync` (workspace/packages/shared)
// already patches pushState/replaceState ONCE per window and dispatches
// `locationchange` for both, and PageSlot mirrors the primary pane's slot
// route into the `?page=` query through that same patched API. Riding
// `locationchange` + `popstate` (Back/Forward) with read-only listeners
// covers router navigations AND slot swaps with one pair of hooks.
let $8dca4a249ebf536b$var$_lastPageViewPath = null;
let $8dca4a249ebf536b$var$_pageViewWired = false;
const $8dca4a249ebf536b$export$e5b732b0ddf8c3c8 = (href)=>{
    if (typeof href !== 'string' || !href) return null;
    let url;
    try {
        // Base makes relative hrefs resolvable (tests, foreign shells).
        url = new URL(href, 'https://shell.invalid');
    } catch (_) {
        return null;
    }
    const slot = url.searchParams.get('page');
    if (slot && slot.startsWith('/')) {
        const clean = slot.split('?')[0].split('#')[0];
        if (clean) return clean;
    }
    return url.pathname || '/';
};
const $8dca4a249ebf536b$export$92ab14d0aa42e41e = (path)=>{
    if (typeof path !== 'string' || !path) return false;
    if (path === $8dca4a249ebf536b$var$_lastPageViewPath) return false;
    if (!$8dca4a249ebf536b$var$_instance || typeof $8dca4a249ebf536b$var$_instance.captureMessage !== 'function') return false;
    $8dca4a249ebf536b$var$_lastPageViewPath = path;
    try {
        $8dca4a249ebf536b$var$_instance.captureMessage('page_view', 'info', {
            path: path
        });
    } catch (_) {
    /* telemetry must never break navigation */ }
    return true;
};
const $8dca4a249ebf536b$var$_onPageViewNav = ()=>{
    if (typeof window === 'undefined') return;
    try {
        $8dca4a249ebf536b$export$92ab14d0aa42e41e($8dca4a249ebf536b$export$e5b732b0ddf8c3c8(window.location.href));
    } catch (_) {}
};
const $8dca4a249ebf536b$var$_wirePageViews = ()=>{
    if ($8dca4a249ebf536b$var$_pageViewWired) return;
    if (typeof window === 'undefined') return;
    $8dca4a249ebf536b$var$_pageViewWired = true;
    window.addEventListener('locationchange', $8dca4a249ebf536b$var$_onPageViewNav);
    window.addEventListener('popstate', $8dca4a249ebf536b$var$_onPageViewNav);
    // The boot itself is the first page view (same as the public tracker's
    // initial capture). beforeSend still gates on workspace scope at flush.
    $8dca4a249ebf536b$var$_onPageViewNav();
};
const $8dca4a249ebf536b$export$a5e9d5d3f4fd5b6c = ()=>{
    $8dca4a249ebf536b$var$_lastPageViewPath = null;
};
const $8dca4a249ebf536b$export$e6f44109b5d45581 = async (sdk, seedUser = null)=>{
    if (!$8dca4a249ebf536b$var$_instance && $8dca4a249ebf536b$var$_bootPromise) try {
        await $8dca4a249ebf536b$var$_bootPromise;
    } catch (_) {}
    if (!$8dca4a249ebf536b$var$_instance) return;
    // Identity is the user id (see identifyAnalyzing): a seed without one is
    // no identity, so fall through to getMe() for the full record.
    if (seedUser && (seedUser.id || seedUser._id)) {
        $8dca4a249ebf536b$export$71245e0838dc6a5a({
            user: seedUser
        });
        return;
    }
    if (!sdk?.getMe) return;
    try {
        const me = await sdk.getMe();
        const user = me?.user || me || null;
        if (user && (user.id || user._id)) $8dca4a249ebf536b$export$71245e0838dc6a5a({
            user: user
        });
    } catch (err) {
        // The shell calls identifyFromSdk eagerly on mount, before the user
        // signs in (and on every subscribeAuthSession refresh). When the
        // SDK has no token, an expired/rotated token, or a token that the
        // server rejects on signature, getMe() throws an auth-class error.
        // None of these are actionable from telemetry — the user hasn't
        // logged in yet, or just needs to re-log. subscribeAuthSession
        // re-fires identifyFromSdk the moment a fresh session lands, so we
        // lose nothing by swallowing. Real failure modes (server 5xx,
        // malformed response, network) still warn.
        const msg = err?.message || String(err);
        const status = err?.status || err?.cause?.status;
        const isAuthClass = status === 401 || /no token provided/i.test(msg) || /invalid token/i.test(msg) || // "Invalid token: invalid signature", "Invalid token: expired"
        /invalid signature/i.test(msg) || /token expired/i.test(msg) || /unauthorized/i.test(msg);
        if (isAuthClass) return;
        // Browser-level network aborts — Safari throws `TypeError: Load failed`
        // and Chrome throws `Failed to fetch` when a fetch is cancelled by
        // navigation (route guard redirect, sign-in flow rerouting, page
        // unload mid-request). identifyFromSdk fires from boot + every
        // subscribeAuthSession tick, so it's the most likely fetch to get
        // aborted during early-route transitions. None of these are
        // actionable telemetry — the SDK will re-identify on the next
        // session tick once the page settles.
        // (WORKSPACE-ANALYZING-IDENTIFY-PRE-AUTH-NOISE).
        const isNetworkAbort = /load failed/i.test(msg) || /failed to fetch/i.test(msg) || /networkerror/i.test(msg) || /the operation was aborted/i.test(msg);
        if (isNetworkAbort) return;
        console.warn('[analyzing] identifyFromSdk failed:', msg);
    }
};
const $8dca4a249ebf536b$export$71245e0838dc6a5a = ({ user: user } = {})=>{
    if (!$8dca4a249ebf536b$var$_instance) return;
    const userId = user ? user.id || user._id || null : null;
    if (!userId) {
        $8dca4a249ebf536b$var$_instance.identify(null);
        return;
    }
    const plan = user.plan || user.subscription_plan || null;
    $8dca4a249ebf536b$var$_instance.identify({
        userId: String(userId),
        traits: plan ? {
            plan: plan
        } : {}
    });
};
const $8dca4a249ebf536b$export$8e98275a5fb1017a = (sdk, getStateRoot)=>{
    if (!sdk?.rootBus?.on || !$8dca4a249ebf536b$var$_instance) return ()=>{};
    const handler = (payload)=>{
        const root = typeof getStateRoot === 'function' ? getStateRoot() : null;
        $8dca4a249ebf536b$export$71245e0838dc6a5a({
            user: root?.user
        });
        // Refresh tenant scope so subsequent envelopes carry the new
        // workspace_id. Payload from `sdk.orgSwitched` has the canonical
        // `newOrgId`; fall back to root.org?.id /
        // root.jwtClaims.workspace_org_id when the bus echoes without a
        // payload (older emit paths).
        // Same resolver as boot and onWorkspaceChange — never `newOrgId` first:
        // an org id here vs a workspace id there is a stamp CHANGE, i.e. a
        // spurious session rotation (ANALYZING-SESSION-ROTATE-1).
        const nextId = $8dca4a249ebf536b$export$83b305ed6af44b56({
            sdk: sdk,
            root: root
        }) || payload?.newOrgId || root?.jwtClaims?.workspace_org_id || null;
        if (nextId) $8dca4a249ebf536b$export$bdde0f5e6945a5c2(nextId);
    };
    sdk.rootBus.on('sdk.orgSwitched', handler);
    return ()=>{
        try {
            sdk.rootBus.off('sdk.orgSwitched', handler);
        } catch (_) {}
    };
};

});


parcelRegister("kuISg", function(module, exports) {

$parcel$export(module.exports, "hasSessionToken", () => $eeb96b12bb85b5c9$export$99e0bf065eb0a9bc);
$parcel$export(module.exports, "AUTH_PATHS", () => $eeb96b12bb85b5c9$export$50c9e7c916c6ed95);
$parcel$export(module.exports, "authRedirectTarget", () => $eeb96b12bb85b5c9$export$f572abf94cedbe9);
$parcel$export(module.exports, "isChromelessShellPath", () => $eeb96b12bb85b5c9$export$23e8768e4133d55d);
// The session gate's pure pieces — moved out of auth.js so an entry
// that does not load the whole auth module (the comm app,
// comm/functions.js) registers the SAME predicate the workspace shell's
// router guard and cold boot run. auth.js re-exports every one of them.

var $1X0Je = parcelRequire("1X0Je");
const $eeb96b12bb85b5c9$export$99e0bf065eb0a9bc = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        const sym = window.localStorage.getItem('symbols_access_token') || // bootShell accepts the bridge token as proof of a session too, so this
        // must agree with it or the two disagree mid-boot.
        window.localStorage.getItem('symbols_bridge_access_token');
        if (sym) {
            const exp = +window.localStorage.getItem('symbols_expires_at');
            if (!exp || exp > Date.now()) return true;
            // An EXPIRED access token alongside a live refresh token is a valid
            // session, not a signed-out one: the SDK's TokenManager reports exactly
            // this state as 'valid' ("expired but recoverable") and rotates it on
            // boot with delay 0. Calling it signed-out here bounced anyone returning
            // after an idle hour to /login despite a recoverable session.
            if (window.localStorage.getItem('symbols_refresh_token')) return true;
        }
    } catch (e) {
    /* localStorage may throw in some sandbox contexts */ }
    return false;
};
const $eeb96b12bb85b5c9$export$50c9e7c916c6ed95 = [
    '/login',
    '/signin',
    '/signup',
    '/signup-confirmation',
    '/reset-password',
    '/forgot-password',
    '/verify-email',
    // demo.symbols.app email gate — a guest-only surface like the sign-in
    // pages: chrome stays hidden (app.js derives its route-kind regex from
    // this list) and an authed visitor on /demo bounces home.
    '/demo'
];
const $eeb96b12bb85b5c9$export$f572abf94cedbe9 = ({ path: path, search: search = '', authed: authed, demoHost: demoHost = false, loginPath: loginPath = '/login', authPaths: authPaths = $eeb96b12bb85b5c9$export$50c9e7c916c6ed95, publicPathPrefixes: publicPathPrefixes = [], isPublicPath: isPublicPath = null } = {})=>{
    const p = String(path || '/');
    if (publicPathPrefixes.some((x)=>p === x || p.startsWith(x + '/') || p.startsWith(x + '?'))) return null;
    if (typeof isPublicPath === 'function' && isPublicPath(p)) return null;
    if (authed) {
        // CORE-AUTH-TAKEOVER-PATHS D9 — a sign-in link from a CLI or plugin
        // (`/login?session=<id>`, or `/?session=<id>` once the visitor signed in
        // on it) goes to the explicit Continue step: the server no longer arms
        // the session as a side effect, so the bounce home would strand the
        // device. Only `/` and the auth pages carry a sign-in `session`.
        if (p === '/' || authPaths.some((ap)=>p === ap || p.startsWith(ap + '/'))) {
            const sid = new URLSearchParams(search || '').get('session');
            if (sid && sid.length <= 200) return `/sign-in-session?session=${encodeURIComponent(sid)}`;
        }
        return null;
    }
    for (const ap of authPaths){
        if (p === ap || p.startsWith(ap + '/') || p.startsWith(ap + '?')) return null;
    }
    // On a demo host (demo.symbols.app / dev.demo.symbols.app, or the local
    // ?demo=1 / symbols_force_demo override) unauthed visitors go to the
    // branded /demo email gate instead of the real /login. /demo is in
    // AUTH_PATHS, so once they land there this returns null — no loop.
    if (demoHost) return '/demo';
    // Preserve the requested destination (path + query) through the bounce
    // via `?next=` — the same convention bootShell's _forceLogoutAndReauth
    // and the SPA nav-guard already use, and the `authed && onAuthPage`
    // branch below already honors on the way back. Dropping it stranded
    // every inbound deep link, invitation ?token= links above all (P0
    // invite-flow fix, 2026-08-06). Bare `/` stays a plain /login.
    // LOGINLOOP-1: build `dest` from the current path plus its query MINUS
    // any `next` the URL already carries. Appending `search` verbatim (what
    // this did before) re-wrapped an existing `next` instead of reusing it,
    // so every bounce nested one level deeper —
    // `/?next=%2F` -> `/login?next=%2F%3Fnext%3D%252F` -> … byte-for-byte
    // the reported loop URL. The `dest !== '/'` guard below could not catch
    // it either: once `search` held a `next`, `dest` was never bare `/`.
    // Only when the current URL carries nothing of its own (bare `/`) is the
    // carried `next` the real destination — resolveAuthNext unwraps it
    // repeatedly so a hand-nested URL collapses to its innermost target
    // instead of being re-wrapped. Preferring `selfDest` first is what keeps
    // an invitation deep link (`/accept-org-invite?token=…&next=%2F`) intact:
    // resolveAuthNext alone would return the carried `/` and drop the token,
    // undoing the P0 invite-flow fix this block exists for.
    const _params = new URLSearchParams(search || '');
    _params.delete('next');
    const _query = _params.toString();
    const selfDest = p + (_query ? `?${_query}` : '');
    const dest = selfDest === '/' ? (0, $1X0Je.default).functions.resolveAuthNext(p, search || '') : selfDest;
    const next = dest && dest !== '/' ? `?next=${encodeURIComponent(dest)}` : '';
    return `${loginPath}${next}`;
};
const $eeb96b12bb85b5c9$export$23e8768e4133d55d = (path)=>{
    const p = typeof path === 'string' && path ? path : '/';
    const names = [
        'login',
        'signin',
        'signup',
        'signup-confirmation',
        'reset-password',
        'forgot-password',
        'verify-email',
        'demo',
        'accept-invite',
        'accept-org-invite',
        'accept-team-invite',
        'accept-workspace-invite',
        's/[^/]+'
    ];
    return new RegExp('^/(' + names.join('|') + ')(/|$)').test(p);
};

});


parcelRegister("8WfZd", function(module, exports) {

$parcel$export(module.exports, "needTicketDetailModal", () => $6820240f48e519e5$export$149314f3ab7ace37);
// The ticket detail modal arrives on first need, not in the boot entry.
//
// TicketDetailModal.js (89 KB minified) rode the tickets EAGER slice only
// because the shell root bare-keys `TicketsDetailModal` (app.js) and smbls used
// to merge a parked `if:` element's extends at parse time. Element >= 3.14.798
// re-merges a parked element on its first true `if:` when its name was
// registered since (FW-IF-GATED-ELEMENT-IGNORES-LATE-REGISTERED-EXTENDS-1), so:
//
//   need (a seeded `selectedTicket`, the /ticket/:id full page, or a
//   `?ticket=` deep link) -> load the module once -> add its components to the
//   live registry (add-missing) -> `root._ticketModalReady = true` -> the latch
//   opens and the modal builds with its full component.
//
// The predicate reads `_ticketModalReady` on every pass, so the write that
// ends the load re-runs it. A /tickets route that already folded the full
// tickets context registers the component first; then no load happens.
//
// Frank note (FA204): the in-flight load lives on a global holder, not a
// module-scope binding, and every helper below is self-contained. The default
// loader is written in the body, not as a default parameter over a module
// const: frank publishes a default parameter that reads the body's own scope
// alias before it exists, so a call without `loader` threw on publication.
// A module's components: its PascalCase object exports (functions such as
// `copyTicketUrl` are not components).
const $6820240f48e519e5$export$7756ec1843f0ce44 = (mod)=>{
    const out = {};
    for(const k in mod || {}){
        const v = mod[k];
        if (/^[A-Z]/.test(k) && v && typeof v === 'object') out[k] = v;
    }
    return out;
};


const $6820240f48e519e5$export$cf1f92e56dea3103 = (el, root, loader)=>{
    const load = typeof loader === 'function' ? loader : ()=>(parcelRequire("2mQtZ"));
    if (!root || typeof root.update !== 'function') return null;
    const holder = globalThis.__ticketDetailModalLoad = globalThis.__ticketDetailModalLoad || {};
    const components = el && el.context && el.context.components;
    const markReady = ()=>{
        if (!root._ticketModalReady) root.update({
            _ticketModalReady: true
        }, {
            preventFetch: true
        });
    };
    if (components && (components.TicketsDetailModal || components['smbls.TicketsDetailModal'])) {
        // Already registered (a tickets route folded the full context). Mark ready
        // outside the predicate's own effect run.
        Promise.resolve().then(markReady);
        return null;
    }
    if (holder.pending) return holder.pending;
    holder.pending = Promise.resolve().then(function() {
        return (parcelRequire("2mQtZ"));
    }).then((res)=>load()).then((mod)=>{
        const comps = function(m) {
            const out = {};
            for(const k in m || {}){
                const v = m[k];
                if (/^[A-Z]/.test(k) && v && typeof v === 'object') out[k] = v;
            }
            return out;
        }(mod && mod.default && !mod.TicketsDetailModal ? mod.default : mod);
        const reg = el && el.context && el.context.components;
        if (reg) {
            for(const k in comps)if (!reg[k]) reg[k] = comps[k];
        }
        markReady();
    }).catch((err)=>{
        console.warn('[ticketDetailModal] load failed:', err && err.message);
    }).finally(()=>{
        holder.pending = null;
    });
    return holder.pending;
};
const $6820240f48e519e5$export$f2ec543408efa9af = ()=>{
    if (typeof window === 'undefined') return false;
    try {
        return !!new URL(window.location.href).searchParams.get('ticket');
    } catch (_) {
        return false;
    }
};
const $6820240f48e519e5$export$c3ad859a79412812 = (el, s, inUrl, loader)=>{
    const root = s && s.root;
    // Read first, every pass: the load's write must re-run this predicate.
    const ready = !!(root && root._ticketModalReady);
    if (el.__wsDeferredMounted) return true;
    const need = !!root && (root.selectedTicket != null || !!root._ticketFullPage || !!(typeof inUrl === 'function' && inUrl()));
    if (!need) return false;
    if (!ready) {
        $6820240f48e519e5$export$cf1f92e56dea3103(el, root, loader);
        return false;
    }
    el.__wsDeferredMounted = true;
    return true;
};
const $6820240f48e519e5$export$149314f3ab7ace37 = (el, s)=>$6820240f48e519e5$export$c3ad859a79412812(el, s, $6820240f48e519e5$export$f2ec543408efa9af);
const $6820240f48e519e5$export$4ef8dcbadfc24f1d = ({ ticketParamInUrl: inUrl, loader: loader } = {})=>(el, s)=>$6820240f48e519e5$export$c3ad859a79412812(el, s, inUrl, loader);

});
parcelRegister("2mQtZ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("brLsd"))) : import("brLsd")).then(()=>parcelRequire('eSuYl'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("hO9x8", function(module, exports) {

$parcel$export(module.exports, "SHELL_STAGE", () => $cf6e80516498c622$export$9afa8dadfa6f09eb);
$parcel$export(module.exports, "startShellStageLadder", () => $cf6e80516498c622$export$466afc98baafc292);
// Staged shell mount — split the boot tree build into bounded tasks.
//
// ── The measurement this exists for (WS-SHELL-BOOT-TASK-LOAF-ACCEPTANCE-1) ──
// `bootShell` mounts the shell with one smbls `create()` call, and that call
// builds the WHOLE tree synchronously. `yieldToPaint` already moved the build
// out of whatever task the boot happened to be in, but the build itself is
// still ONE unsplit task: LoAF on dev.my.symbols.app (visible tab, 3 cold
// navigate loads of /w/silverbreeze-labs, 2026-08-28) reports a single frame
// of 757 / 590 / 594 ms whose only script is the `TimerHandler:setTimeout`
// that resolves `yieldToPaint` — i.e. the mount continuation. Acceptance is
// "no single boot task over 500 ms", so the continuation has to be cut into
// pieces, not merely moved.
//
// ── How the ladder cuts it ──────────────────────────────────────────────────
// Top-level shell subtrees that are NOT on screen at first paint carry an
// `if:` latch keyed on a stage number. `create()` returns EARLY on a false
// `if:` — before createChildren / registerEffects / applyStaticMixins — so a
// not-yet-staged subtree costs nothing in the boot task, and `registerIfEffect`
// runs the full creation in place on the first true evaluation (same key, same
// parent chain — bare-key resolution and every tree walk are unchanged).
//
// The ladder then advances `root._shellStage` 1 → 2 → 3, ONE MACROTASK APART,
// starting right after the mount. Each advance builds only that stage's
// subtrees, so N stages become N bounded tasks instead of one long one. The
// whole ladder finishes within a few frames of first paint, so nothing a user
// can reach is meaningfully later than before — this is a task-granularity
// change, not a lazy-loading change.
//
// ── Why not `yieldToPaint` (shared/functions/yieldToPaint.js) ───────────────
// Different contract, deliberately not reused: `yieldToPaint` resolves on
// EITHER a real frame or a 50 ms bound and reports which arm won, because its
// job is "give the compositor one frame before this one big build". The ladder
// needs the opposite guarantee — a macrotask that always arrives promptly even
// with no compositor at all (hidden tab: `requestAnimationFrame` never fires
// and `setTimeout` is clamped to 1 s, then 1/min past ~5 min hidden — measured
// 2026-08-22 on the ModalRoot arming, which is why THAT site grew its own
// MessageChannel arm). Reaching yieldToPaint from here would also need a deep
// `@symbo-ls/workspace-shared/functions/...` subpath import, which cannot
// resolve through the platform importmap (see app.js's own header).
//
// Frank note: self-contained — no bare sibling-export reads, no DOM writes.
// Highest stage the ladder advances to. Keep in lockstep with the `if:`
// latches in app.js — `SHELL_STAGE` names them so a new subtree cannot pick a
// stage the ladder never reaches.
const $cf6e80516498c622$export$9afa8dadfa6f09eb = {
    // First click surfaces + blocking gates: dropdown/tooltip/context hosts,
    // toast host, org-switch overlay, and the no-org / username / credit gates.
    INTERACTIVE: 1,
    // Persistent chrome nobody can reach in the first frames: presence dock,
    // messenger slot, persona pill, banners, reasoning pill, zoombar, split view.
    CHROME: 2,
    // Event-driven overlays — voice, AI bridge/confirm, meet widget, call banner.
    OVERLAYS: 3
};
const $cf6e80516498c622$export$4511e29324b016fc = $cf6e80516498c622$export$9afa8dadfa6f09eb.OVERLAYS;
const $cf6e80516498c622$export$91e13d3157d477cd = (fn, win = typeof window !== 'undefined' ? window : null)=>{
    const doc = win && win.document;
    const visible = !!doc && doc.visibilityState !== 'hidden';
    const raf = visible && typeof win.requestAnimationFrame === 'function';
    if (raf) {
        let done = false;
        const once = ()=>{
            if (done) return;
            done = true;
            fn();
        };
        // rAF runs BEFORE the frame is drawn; the 0 ms timer chained after it lands
        // AFTER, so the next stage builds on the far side of a real paint.
        try {
            win.requestAnimationFrame(()=>win.setTimeout(once, 0));
        } catch (_) {
        /* fall through to the bound below */ }
        win.setTimeout(once, 50);
        return;
    }
    if (win && typeof win.MessageChannel === 'function') {
        const ch = new win.MessageChannel();
        ch.port1.onmessage = ()=>{
            ch.port1.close();
            fn();
        };
        ch.port2.postMessage(0);
        return;
    }
    if (typeof setTimeout === 'function') setTimeout(fn, 0);
    else fn();
};
// Roots whose ladder already started. A WeakSet rather than a flag ON the root:
// the root is a reactive state proxy, and an ad-hoc own key on it would be a
// state write that every `s.root` reader re-runs for.
const $cf6e80516498c622$var$_ladderStarted = new WeakSet();
const $cf6e80516498c622$export$466afc98baafc292 = (root, opts = {})=>{
    if (!root || typeof root.update !== 'function') return false;
    if ($cf6e80516498c622$var$_ladderStarted.has(root)) return false;
    $cf6e80516498c622$var$_ladderStarted.add(root);
    const max = typeof opts.max === 'number' ? opts.max : $cf6e80516498c622$export$4511e29324b016fc;
    const schedule = opts.schedule || $cf6e80516498c622$export$91e13d3157d477cd;
    const step = (stage)=>{
        if (stage > max) return;
        try {
            // preventFetch: the stage counter is pure scheduling state — it must
            // never re-trigger a declarative `fetch:` on the root.
            root.update({
                _shellStage: stage
            }, {
                preventFetch: true
            });
        } catch (_) {
            /* a torn-down root just stops the ladder */ return;
        }
        schedule(()=>step(stage + 1));
    };
    schedule(()=>step(1));
    return true;
};
const $cf6e80516498c622$export$3342229d0e9ed05d = (root)=>{
    if (root) $cf6e80516498c622$var$_ladderStarted.delete(root);
};

});

parcelRegister("fDn7k", function(module, exports) {

$parcel$export(module.exports, "orgSwitcherPanelPin", () => $b61c6e1d841f12c3$export$5fd685d0fbb8e645);
// TODO(dropdown-panel-reposition): temporary. Delete this file — and the
// `PanelHost: { Panel: orgSwitcherPanelPin }` override on the shell's
// DropdownRoot in app.js — once @symbo.ls/dropdown re-anchors on resize,
// re-measures a Panel whose content grows (followContent, at the foot of
// this file) and accepts an `inset` option (openOrgSwitcherMenu then passes
// `inset: { right: 'A1' }` itself).
//
// The org switcher's dropdown Panel pins to the viewport's right edge (the
// `A1` spacing step) instead of the plugin's anchor-computed `left`. The
// @symbo.ls/dropdown Panel writes `left` from the trigger rect it snapshotted
// at open — through its reactive `left` prop, inline in its `onRender`, and
// inline in a rAF after the content mounts — so a window resize left the menu
// stranded at the old x. A right-anchored Panel follows the viewport instead.
//
// Every other dropdown keeps the plugin's anchor positioning: each override
// below runs the plugin's own hook first, and only the org switcher's layer
// is re-pinned. The Panel node is REUSED across layers, so every other layer
// gets the inline `right` this file wrote taken back off.
// Import createEffect through the `smbls` umbrella, NOT '@symbo.ls/signal' —
// the same signal-copy rule DropdownRoot.js documents.

var $eY4Ct = parcelRequire("eY4Ct");
parcelRequire("cEpNz");
var $4kTba = parcelRequire("4kTba");

var $cQy7L = parcelRequire("cQy7L");
const $b61c6e1d841f12c3$var$RIGHT_INSET = 'var(--spacing-A1)';
// The plugin hooks this file wraps. Checked at import so a plugin release that
// renames or drops one fails here, by name, instead of on the first dropdown.
const $b61c6e1d841f12c3$var$_plugin = (0, $4kTba.DropdownRoot)?.PanelHost?.Panel;
for (const hook of [
    'left',
    'onInit',
    'onRender'
]){
    if (typeof $b61c6e1d841f12c3$var$_plugin?.[hook] !== 'function') throw new Error(`[orgSwitcherPanelPin] @symbo.ls/dropdown DropdownRoot.PanelHost.Panel.${hook} is not a function \u{2014} ` + 'the plugin changed shape; update or remove this override.');
}
const $b61c6e1d841f12c3$var$_isOrgSwitcher = (layer)=>layer?.id === (0, $cQy7L.ORG_SWITCHER_DROPDOWN_ID);
// A navbar RAIL (shared functions/navbarLayout.js) puts the switcher at the
// foot of a left or right column, and its menu opens beside the rail
// (AppOrgSwitcher.menuPlacement): the plugin's own anchor places it there, as
// it does every other dropdown. Pinned to the viewport's right edge instead,
// it opened across the screen from a left rail and over a right one
// (measured on dev 50e520dd0). A shell without the layout read pins as ever.
const $b61c6e1d841f12c3$var$_onRail = (el)=>{
    const fns = el?.context?.functions;
    if (!fns || typeof fns.navbarLayoutRead !== 'function') return false;
    return !!(el.call('navbarLayoutRead', el.state?.root) || {}).rail;
};
const $b61c6e1d841f12c3$var$_pinsRight = (el, layer)=>$b61c6e1d841f12c3$var$_isOrgSwitcher(layer) && !$b61c6e1d841f12c3$var$_onRail(el);
const $b61c6e1d841f12c3$export$936202b4d8beac71 = (el, layer)=>{
    if (!el.node) return;
    if ($b61c6e1d841f12c3$var$_pinsRight(el, layer)) {
        el.node.style.removeProperty('left');
        el.node.style.right = $b61c6e1d841f12c3$var$RIGHT_INSET;
    } else el.node.style.removeProperty('right');
};
const $b61c6e1d841f12c3$export$5fd685d0fbb8e645 = {
    left: (el)=>$b61c6e1d841f12c3$var$_pinsRight(el, el.parent?.layer) ? 'auto' : $b61c6e1d841f12c3$var$_plugin.left(el),
    onInit: (el)=>{
        $b61c6e1d841f12c3$var$_plugin.onInit(el);
        // On every layer change: settle `right` now, then again after the
        // plugin's content-mount rAF has written its inline `left` (a double rAF
        // lands after that single one).
        // `__pinnedLayer` drops a frame callback that a newer layer has
        // overtaken, so a stale org-switcher pin never lands on the next menu.
        const effect = (0, $eY4Ct.createEffect)(()=>{
            const layer = el.parent?.layer;
            el.__pinnedLayer = layer;
            $b61c6e1d841f12c3$export$936202b4d8beac71(el, layer);
            if (!layer || typeof requestAnimationFrame === 'undefined') return;
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
                    if (el.__pinnedLayer === layer) $b61c6e1d841f12c3$export$936202b4d8beac71(el, layer);
                }));
        });
        if (el.__ref) el.__ref.__effects?.push(effect);
    },
    onRender: (el)=>{
        $b61c6e1d841f12c3$var$_plugin.onRender(el);
        $b61c6e1d841f12c3$export$936202b4d8beac71(el, el.parent?.layer);
        $b61c6e1d841f12c3$var$followContent(el);
    }
};
// THE PANEL FOLLOWS ITS CONTENT (same TODO as the head of this file: delete
// once @symbo.ls/dropdown re-measures by itself). The plugin measures and
// places the Panel once, a frame after the layer's content mounts; a body
// that grows after that (the invite's member list, loaded by the body
// itself) grows from where it was placed — past the screen's edge for a
// menu that opens upward or beside a navbar rail (measured on dev
// 1055707e3: the invite beside a left rail ended 14px below the screen).
// One observer on the reused Panel node: a size change runs the plugin's
// own measure-and-place again (left, top, the fitted max height), then the
// pin. A layer-less (closed) Panel is left alone; an equal size does
// nothing, so the place it writes cannot loop.
const $b61c6e1d841f12c3$var$followContent = (el)=>{
    if (el.__panelFollow || !el.node || typeof ResizeObserver === 'undefined') return;
    let last = null;
    el.__panelFollow = new ResizeObserver(()=>{
        const node = el.node;
        if (!node || !el.parent?.layer) {
            last = null;
            return;
        }
        const r = node.getBoundingClientRect();
        const size = {
            w: Math.round(r.width),
            h: Math.round(r.height)
        };
        if (last && Math.abs(last.w - size.w) <= 1 && Math.abs(last.h - size.h) <= 1) return;
        last = size;
        $b61c6e1d841f12c3$var$_plugin.onRender(el);
        $b61c6e1d841f12c3$export$936202b4d8beac71(el, el.parent?.layer);
    });
    el.__panelFollow.observe(el.node);
};

});


parcelRegister("bWCLy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b232ea25b4fd2a3$export$2e2bcd8739ae039);
// ── Intranet ──

var $hn2a0 = parcelRequire("hn2a0");

var $1X0Je = parcelRequire("1X0Je");

var $kvxcA = parcelRequire("kvxcA");

var $cT6tU = parcelRequire("cT6tU");

var $l0m6y = parcelRequire("l0m6y");

var $fdfsh = parcelRequire("fdfsh");

var $65kO4 = parcelRequire("65kO4");

var $aA4I2 = parcelRequire("aA4I2");

var $iwxpi = parcelRequire("iwxpi");

var $8Ofnd = parcelRequire("8Ofnd");

var $hgKZn = parcelRequire("hgKZn");

var $8RC0A = parcelRequire("8RC0A");

var $6wqeJ = parcelRequire("6wqeJ");

var $jhYyf = parcelRequire("jhYyf");

var $4e8H1 = parcelRequire("4e8H1");

var $9Hn8c = parcelRequire("9Hn8c");

// /data (~99KB dev) + /add-app — admin-grade surfaces, route-map-only (no
// bare-key consumers): lazy per bundle-split T1.
// Its Data* row components fold in on first mount (lazyPageWithComponents).
const $8b232ea25b4fd2a3$var$data = (0, $hn2a0.lazyPageWithComponents)(()=>(parcelRequire("dGGl7")), 'data', (el)=>({
        title: el.call('pageTitle', 'workspace.page.data')
    }));

const $8b232ea25b4fd2a3$var$addApp = (0, $hn2a0.lazyPage)(()=>(parcelRequire("8C37J")).then((m)=>m.addApp), (el)=>({
        title: el.call('pageTitle', 'workspace.page.addApp')
    }));

// /data/external — the Data backend-visualization surface (connected org
// backends + records-plane browser + fetch wiring), flag-gated by
// `data.externalSources`. Selection is state-driven (root `_ext*` keys) on
// this single registered path — source/table picks ride ?src=&table= query
// params so the shared RemoteTableCard's router navigation never falls
// through to the '/*' catch-all.
const $8b232ea25b4fd2a3$var$dataExternal = (0, $hn2a0.lazyPage)(()=>(parcelRequire("9M6jj")).then((m)=>m.dataExternal), (el)=>({
        title: el.call('pageTitle', 'workspace.page.dataExternal')
    }));

// /reminders — built-in personal reminders app (workspace-shell owns it,
// not a feature package). Lazy per the same bundle-split convention as the
// other operator/secondary surfaces on this route map.
const $8b232ea25b4fd2a3$var$reminders = (0, $hn2a0.lazyPage)(()=>(parcelRequire("iyNfb")).then((m)=>m.reminders), (el)=>({
        title: el.call('pageTitle', 'workspace.page.reminders')
    }));

// THE APP SPLIT (docs/APP_SPLIT.md) — the Workspace apps view of the Apps hub.
const $8b232ea25b4fd2a3$var$appsHub = (0, $hn2a0.lazyPage)(()=>(parcelRequire("1rG13")).then((m)=>m.appsHub), (el)=>({
        title: el.call('pageTitle', 'workspace.page.apps')
    }));

// /history — built-in History app: the workspace activity log as a
// horizontal timeline (workspace-shell page, not a feature package). Lazy
// like the other built-in app pages.
const $8b232ea25b4fd2a3$var$history = (0, $hn2a0.lazyPage)(()=>(parcelRequire("bfN28")).then((m)=>m.history), (el)=>({
        title: el.call('pageTitle', 'workspace.page.history')
    }));

// /getting-started/team — POB S9 "Invite your team" (the people the
// onboarding research found on the company's own team page). Opened from the
// first-thread Team card through openInSlot; lazy like the other built-in
// pages.
const $8b232ea25b4fd2a3$var$gettingStartedTeam = (0, $hn2a0.lazyPage)(()=>(parcelRequire("jnBqo")).then((m)=>m.gettingStartedTeam), (el)=>({
        title: el.call('pageTitle', 'workspace.gettingStarted.team.title')
    }));

// /getting-started/imports — POB S10 "Import your data" (the import
// connectors: the owner's own file, and the others "Coming soon" until they
// are live). `?source=<id>` opens a live connector's review.
const $8b232ea25b4fd2a3$var$gettingStartedImports = (0, $hn2a0.lazyPage)(()=>(parcelRequire("6OfOT")).then((m)=>m.gettingStartedImports), (el)=>({
        title: el.call('pageTitle', 'workspace.gettingStarted.imports.title')
    }));

// /inbox — full-page notification center. The bell panel's "View all
// notifications" + NotificationBell have routed here all along while the
// page itself was missing (manifest reserved the route; the router
// 404-bounced every click).
const $8b232ea25b4fd2a3$var$inbox = (0, $hn2a0.lazyPage)(()=>(parcelRequire("7u3aP")).then((m)=>m.inbox), (el)=>({
        title: el.call('pageTitle', 'workspace.page.inbox')
    }));

// /team-and-agents is a panzoom canvas page — it lives in
// @symbo-ls/workspace-canvas next to /studios. The route below reaches it by
// STRING-EXTEND (`extends: 'teamAndAgents'`), never by importing the sibling
// page object: canvas's eager slice (sharedLibraries.js `canvasEager`)
// already registers `teamAndAgents` as a component at boot, and a value
// imported from a declared library serializes to "" when this project is
// published (frank stub-phantom) — the platform record's /team-and-agents
// would have gone hollow on the next push and shadowed canvas's real page
// (measured by the prod-platform-libraries frank gate, 2026-09-22).
// /agents is the agents-only view of the team-and-agents canvas (no people,
// + a My/All/Status/Type/Assignment filter toolbar). It replaces /my-agents,
// which now aliases to it.
const $8b232ea25b4fd2a3$var$agents = (0, $hn2a0.lazyPage)(()=>Promise.resolve((parcelRequire("7lWOZ"))).then((m)=>m.agents), (el)=>({
        title: el.call('pageTitle', 'workspace.page.agents')
    }));

// ── Analytics ── (lazy shared library — project dashboard + workspace usage +
// map + logs). @symbo-ls/workspace-analytics is deferred out of the eager
// `sharedLibraries.js` merge — its ~74K of dashboard/logs components + rollup/
// logs/map functions + route table only matter once an analytics route is
// visited. Its context.js carries a `.pages` map, so each route registers via
// lazySharedLib: on first mount it folds analytics' components + functions +
// state into the live shell context, then el.sets the picked page (each is
// itself a lazyPage that loads its own body chunk). The EAGER carve-out is the
// analytics state schema alone (sharedLibraries.js), for the canvas
// dashboard's Analytics button, which writes analytics root keys before any
// analytics route is visited. Bare /logs stays a shell redirect
// (logsRedirect) — see the route map below.
// /s/:token — the public share-link viewer (PUBLIC-SHARE-LINKS-1). Lazy:
// a recipient-only surface with no bare-key consumers anywhere in the app.
const $8b232ea25b4fd2a3$var$sharedResource = (0, $hn2a0.lazyPage)(()=>(parcelRequire("3KjYC")).then((m)=>m.sharedResource), (el)=>({
        title: el.call('polyglot', 'workspace.page.sharedResource')
    }));

const $8b232ea25b4fd2a3$var$_analyticsCtx = ()=>(parcelRequire("e8HBd"));
const $8b232ea25b4fd2a3$var$analyticsProject = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.analytics')
    }));
const $8b232ea25b4fd2a3$var$workspaceAnalytics = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.workspaceAnalytics')
    }));
const $8b232ea25b4fd2a3$var$analyticsMap = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/map'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.analyticsMap')
    }));
const $8b232ea25b4fd2a3$var$analyticsSessions = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/sessions'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.analyticsSessions')
    }));
// Fixed-path session detail (PageSlot drill-through target — id rides
// root._logsSessionId; the /sessions/:id param route stays for real URLs).
const $8b232ea25b4fd2a3$var$analyticsLogsSessionFixed = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/logs/session'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsSession')
    }));
// PROJECTS-family per-session detail + bugs / events views
// (WS-ANALYTICS-FAMILY-SPLIT-UTC-TOTALS-1) — the same page modules as the
// workspace logs sections, scoped by family at fetch time inside the
// analytics package. Existing polyglot titles — no new i18n keys.
const $8b232ea25b4fd2a3$var$analyticsSession = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/sessions/:id'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsSession')
    }));
const $8b232ea25b4fd2a3$var$analyticsSessionFixed = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/session'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsSession')
    }));
const $8b232ea25b4fd2a3$var$analyticsBugs = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/bugs'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.analyticsBugs')
    }));
const $8b232ea25b4fd2a3$var$analyticsEvents = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/events'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.analyticsEvents')
    }));
// Unique visitors (WS-ANALYTICS-UTM-CAMPAIGNS-UI-1 addendum) — the logs
// Users module on the projects family, its own title.
const $8b232ea25b4fd2a3$var$analyticsVisitors = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/analytics/visitors'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.analyticsVisitors')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogs = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logs')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogsUsers = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs/users'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsUsers')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogsSessions = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs/sessions'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsSessions')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogsSession = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs/sessions/:id'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsSession')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogsEvents = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs/events'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsEvents')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogsBugs = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs/bugs'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsBugs')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogsNetwork = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs/network'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsNetwork')
    }));
const $8b232ea25b4fd2a3$var$analyticsLogsVerbose = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/logs/verbose'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.logsVerbose')
    }));
// ── Identity pages (consolidated in shared/pages/) ──
// Imported from their SOURCE files, deliberately NOT via the
// identity-index.js barrel: that barrel also statically imports all 16
// admin pages, so a single static barrel import pinned the whole admin
// surface (~192KB dev) into the eager shell chunk. Auth pages must stay
// eager (signed-out boots render them first paint); admin lazifies below.
// (Bundle-split T1 — see tickets/workspace.md "iPad/native-like program".)
// Read off the bare `_wsShared` import (page defs keyed by export name in
// shared's pages namespace — `callback` is already aliased to `authCallback`
// by shared's own barrel), deferred inside a `lazyPage` loader — never at
// module scope. Deep per-file subpaths like
// '@symbo-ls/workspace-shared/pages/auth/login.js' cannot resolve through
// the platform's public importmap once this project is pushed as a library
// (tickets/execution-board.md §1), and a direct module-scope read is a
// stub-phantom-value under frank (WS-SHARED-LAZYPAGE-HOLLOW-ROUTES-SWITCH-1).
// `@symbo-ls/workspace-shared` rides the shell's eager sharedLibraries merge,
// so `_wsShared.pages` is already populated by the time any of these mount —
// the loader's `Promise.resolve` settles on the next microtask, before the
// next paint, so first-paint stays effectively eager (same trick already
// proven live for acceptInvite/waitlistInvite below).
// On a white-label host these two wrappers yield the title while the brand
// loads (and to the inner page once it has a name) — functions/authWrapperTitle.js.
const $8b232ea25b4fd2a3$var$login = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.login), (el)=>({
        title: el.call('authWrapperTitle', 'workspace.page.login')
    }));
const $8b232ea25b4fd2a3$var$signin = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.signin), (el)=>({
        title: el.call('authWrapperTitle', 'workspace.page.signin')
    }));
const $8b232ea25b4fd2a3$var$signup = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.signup), (el)=>({
        title: el.call('authWrapperTitle', 'workspace.page.signup')
    }));
const $8b232ea25b4fd2a3$var$signupConfirmation = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.signupConfirmation), (el)=>({
        title: el.call('polyglot', 'workspace.page.signupConfirmation')
    }));
const $8b232ea25b4fd2a3$var$resetPassword = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.resetPassword), (el)=>({
        title: el.call('polyglot', 'workspace.page.resetPassword')
    }));
const $8b232ea25b4fd2a3$var$authCallback = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.authCallback), (el)=>({
        title: el.call('polyglot', 'workspace.page.authCallback')
    }));
const $8b232ea25b4fd2a3$var$magicCallback = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.magicCallback), (el)=>({
        title: el.call('polyglot', 'workspace.page.authCallback')
    }));
// /profile and /orgs: the page's OWN title logic, asked at call time
// (shared/pages/profile.js metadata, "<name> / People / <brand>"), read inside
// the function, never at module scope (the rule at the top of this file). An
// open pane titles itself from the wrapper's metadata (below), so a fixed
// workspace.page.profile turned a member's profile pane into "Account"
// (dev.my 2026-10-30).
const $8b232ea25b4fd2a3$var$profile = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.profile), (el, s)=>(0, $1X0Je.default).pages.profile.metadata(el, s));
// /settings mounts the same account page under its OWN title. A wrapper's
// `metadata` outlives the first mount: an open pane titles itself from it
// (canvas PageSlot _syncSlotTitle → this route's metadata, again on a pane
// switch and on a language switch; the pane's title bar reads it too). Under
// a workspace.page.profile title the Settings pane read "Account" (dev.my
// 2026-10-30). A full-page route keeps the page's own title after a language
// switch. The key is the page's own settings title (shared/pages/profile.js
// metadata, the settings view).
const $8b232ea25b4fd2a3$var$accountSettings = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.profile), (el)=>({
        title: el.call('pageTitle', 'account.profile.settingsTitle')
    }));
// ── Invitation accept surfaces ── (P0 invite-flow fix, 2026-08-06)
// The server's invite emails link buildInviteUrl targets — /accept-invite
// (project), /accept-org-invite, /accept-team-invite,
// /accept-workspace-invite — which were UNROUTED here (dead-end 404 for
// every recipient in every environment). All four mount ONE shared page
// that parses kind+token, bounces unauthed visitors to /login?next=<self>
// (token preserved), and calls the matching SDK accept method.
// /waitlist-invite forwards to /signup with the token intact (signup
// already consumes ?token as sdk.register's inviteToken). Still route-time
// deferred (lazyPage), but the loader now reads the page off the bare
// `_wsShared` import instead of a deep
// '@symbo-ls/workspace-shared/pages/auth/accept-invite.js' dynamic import —
// unresolvable through the platform's public importmap once this project is
// pushed as a library (tickets/execution-board.md §1). Both pages are
// re-exported by shared's pages barrel for exactly this consumer, which
// trades their former lazy-chunk split for correctness on the platform:
// they now ride shared's eager pages barrel like every other auth page.
const $8b232ea25b4fd2a3$var$acceptInvite = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.acceptInvite), (el)=>({
        title: el.call('authWrapperTitle', 'workspace.page.acceptInvite')
    }));
const $8b232ea25b4fd2a3$var$waitlistInvite = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.waitlistInvite), (el)=>({
        title: el.call('polyglot', 'workspace.page.waitlistInvite')
    }));

// ── Calendar ── (lazy shared library + page — #16 calendar slim)
// @symbo-ls/workspace-calendar is deferred out of the eager `sharedLibraries.js`
// merge: its ~200KB of week/month/team/team-now/mini/sidebar/main/quick-create
// components + its 31KB page module only matter once the /calendar route is
// visited. The route is registered as a lazySharedLibPage entry: on first mount it
// folds the calendar CONTEXT (components + functions + state) into the live shell
// context (add-missing — never clobbering the eager modal slice), THEN loads the
// page module and el.sets it — so the page's bare-key children (CalMain,
// CalSidebar, CalWeekView, CalMonthView, CalTeamView, CalTeamNowView,
// CalMiniCalendar, CalQuickCreate) and every el.call resolve against the
// now-populated registry. The EAGER carve-out (CalEventDetailModal +
// CalProfileModal + CalNewBookingModal, the save/delete/move/freshBooking
// functions, and the full calendar state schema) stays registered via
// sharedLibraries.js for the home widgets / shell-root event+profile openers /
// chat / meet surfaces that reference them before the calendar route mounts.
// calendar's context.js default export has no `.pages` map (its page lives in a
// separate module), so — like /documents and /tickets — the page module is passed
// as the explicit second loader. The single _calendarCtx import is module-cached,
// so the context + page each resolve as one cached chunk.
const $8b232ea25b4fd2a3$var$_calendarCtx = ()=>(parcelRequire("iSwre"));

const $8b232ea25b4fd2a3$var$calendar = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_calendarCtx, ()=>(parcelRequire("jIVd0")).then((m)=>m.calendarHome), (el)=>({
        title: el.call('pageTitle', 'workspace.page.calendar')
    }));

// ── Tickets ── (lazy shared library + page — #16 tickets slim)
// @symbo-ls/workspace-tickets is deferred out of the eager `sharedLibraries.js`
// merge: its ~620KB of board/kanban/triage/roadmap/resolutions components +
// function surface only matter once a /tickets* or /resolutions* route is
// visited. Each route below is registered as a lazySharedLibPage entry: on first
// mount it folds the tickets CONTEXT (components + functions + state) into the
// live shell context (add-missing — never clobbering the eager slice), THEN loads
// the picked page module and el.sets it — so the page's bare-key children
// (TicketsKanban, TicketsGeneralMain, TicketsMyViewMain, ResolutionsSidebar, …)
// and every el.call resolve against the now-populated registry. The EAGER
// carve-out (TicketsDetailModal + TicketsActivityHeatmap + TicketsSidebar/
// TicketsSidebarGroup, and the save/delete/move/reloadTickets/freshTicket
// functions, and the full tickets state schema) stays registered via
// sharedLibraries.js for the home widgets / /tickets/status / chat / meet / canvas
// / infra / GreenIG surfaces that reference them before any tickets route mounts.
// tickets' context.js default export has no `.pages` map (its pages live in
// separate modules), so — like /documents and /files — the page module is passed
// as the explicit second loader. The single _ticketsCtx import is module-cached,
// so every tickets route shares ONE context chunk; each page module is its own
// cached chunk.
const $8b232ea25b4fd2a3$var$_ticketsCtx = ()=>(parcelRequire("3Py9H"));

const $8b232ea25b4fd2a3$var$tickets = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("8Eobr")).then((m)=>m.myView), (el)=>({
        title: el.call('pageTitle', 'workspace.page.myTasks')
    }));

const $8b232ea25b4fd2a3$var$ticketView = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("033np")).then((m)=>m.ticketView), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticket')
    }));

const $8b232ea25b4fd2a3$var$ticketsBoard = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("eGYKs")).then((m)=>m.home), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsBoard')
    }));

const $8b232ea25b4fd2a3$var$ticketsGeneral = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("9yYCT")).then((m)=>m.general), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsGeneral')
    }));

const $8b232ea25b4fd2a3$var$ticketsFeed = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("avtTh")).then((m)=>m.feed), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsFeed')
    }));

// /tickets/canvas removed (2026-06-09 per Nika) — /tickets is the board now.
// Epics + Stories merged into one /tickets/epics view (2026-06-09 per Nika);
// /tickets/logs removed.
const $8b232ea25b4fd2a3$var$ticketsEpics = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("lge8j")).then((m)=>m.epics), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsEpics')
    }));

const $8b232ea25b4fd2a3$var$ticketsStandups = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("jZGDx")).then((m)=>m.standups), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsStandups')
    }));

const $8b232ea25b4fd2a3$var$requests = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("hI6RD")).then((m)=>m.requests), (el)=>({
        title: el.call('pageTitle', 'workspace.page.resolutionsRequests')
    }));

const $8b232ea25b4fd2a3$var$requestsInbound = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("hI6RD")).then((m)=>m.requestsInbound), (el)=>({
        title: el.call('pageTitle', 'workspace.page.resolutionsInbound')
    }));

const $8b232ea25b4fd2a3$var$requestsOutbound = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("hI6RD")).then((m)=>m.requestsOutbound), (el)=>({
        title: el.call('pageTitle', 'workspace.page.resolutionsOutbound')
    }));

const $8b232ea25b4fd2a3$var$requestsAudit = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("hI6RD")).then((m)=>m.requestsAudit), (el)=>({
        title: el.call('pageTitle', 'workspace.page.resolutionsAudit')
    }));

const $8b232ea25b4fd2a3$var$resolutions = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("7Hnzg")).then((m)=>m.resolutions), (el)=>({
        title: el.call('pageTitle', 'workspace.page.resolutions')
    }));

const $8b232ea25b4fd2a3$var$resolutionsImprovements = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("7Hnzg")).then((m)=>m.resolutionsImprovements), (el)=>({
        title: el.call('pageTitle', 'workspace.page.resolutionsImprovements')
    }));

const $8b232ea25b4fd2a3$var$resolutionsEditRequests = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("7Hnzg")).then((m)=>m.resolutionsEditRequests), (el)=>({
        title: el.call('pageTitle', 'workspace.page.resolutionsEditRequests')
    }));

const $8b232ea25b4fd2a3$var$ticketsRelease = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("8H9Jz")).then((m)=>m.release), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsRelease')
    }));

const $8b232ea25b4fd2a3$var$ticketsRoadmap = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_ticketsCtx, ()=>(parcelRequire("hLdDq")).then((m)=>m.roadmap), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsRoadmap')
    }));


// ── Chat ── (lazy shared library + page — chat bundle-fold, 2026-08-01)
// chat is deferred out of the eager sharedLibraries.js merge (only a slim
// function slice + state stay eager); a direct /chat visit must fold the
// context FIRST so the page's bare-key children resolve — same shape as
// meet/calendar/documents. The context import is module-cached, so the
// messenger's ensureChatContext and this route share ONE chunk.
const $8b232ea25b4fd2a3$var$chat = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("jPn99")), ()=>(parcelRequire("1JtPJ")).then((m)=>m.chatHome), (el)=>({
        title: el.call('pageTitle', 'workspace.page.chat')
    }));


// ── Mail ── (lazy shared library + page — the built-in email client,
// architecture/MAIL.md). Same shape as chat: only a slim eager slice (three
// page-body components + the drawer toggles + state) rides sharedLibraries.js;
// a direct /mail visit folds the full context FIRST so the page's bare-key
// children resolve. The context import is module-cached, so the header
// envelope's ensureMailContext (functions/mailFold.js) and this route share
// ONE chunk.
const $8b232ea25b4fd2a3$var$mail = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("gOp2u")), ()=>(parcelRequire("li6hd")).then((m)=>m.mailHome), (el)=>({
        title: el.call('pageTitle', 'workspace.page.mail')
    }));


// ── Documents ── (lazy shared library + page)
// @symbo-ls/workspace-documents is deferred out of the eager `sharedLibraries.js`
// merge — its ~65K of page-body components, fetch blocks, and search utils only
// matter on /documents. lazySharedLibPage folds the documents CONTEXT
// (components + functions + state) into the live shell context on first mount,
// THEN loads the picked page module; all four routes share the one context
// import + their own page chunk. The EAGER carve-out (DocsSidebar closure +
// createNote/createKnowledgeArticle/saveKbArticle) stays registered via
// sharedLibraries.js because shared/chat/meet/AI surfaces reference them BEFORE
// /documents is ever visited. The context.js default export has no `.pages`, so
// the page module is passed as the explicit second loader.
const $8b232ea25b4fd2a3$var$documents = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("aNDji")), ()=>(parcelRequire("13oJx")).then((m)=>m.documentsHome), (el)=>({
        title: el.call('pageTitle', 'workspace.page.notes')
    }));


const $8b232ea25b4fd2a3$var$documentsKb = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("aNDji")), ()=>(parcelRequire("h7Pna")).then((m)=>m.knowledgeBase), (el)=>({
        title: el.call('pageTitle', 'workspace.page.kb')
    }));


const $8b232ea25b4fd2a3$var$documentsEditor = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("aNDji")), ()=>(parcelRequire("1ijdV")).then((m)=>m.editor), (el)=>({
        title: el.call('pageTitle', 'workspace.page.editor')
    }));


// ── Files ── (lazy shared library + page)
// @symbo-ls/workspace-files is deferred out of the eager `sharedLibraries.js`
// merge — its ~105K of desktop components + grid/upload/viewer functions only
// matter on /files. lazySharedLibPage folds the files CONTEXT (components +
// functions + state) into the live shell context on first mount, THEN loads the
// page module. The EAGER carve-out (createCanvasFolder / commitRenameNode /
// deleteCanvasNode / moveNodesIntoFolder) stays registered via sharedLibraries.js
// because the workspace AI layer el.call's them BEFORE /files is ever visited.
// The context.js default export has no `.pages`, so the page module is passed as
// the explicit second loader (mirrors /documents).
const $8b232ea25b4fd2a3$var$files = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("7mtaO")), ()=>(parcelRequire("6LoKu")).then((m)=>m.filesHome), (el)=>({
        title: el.call('pageTitle', 'workspace.page.files')
    }));

// ── Infra ── (lazy shared library)
// @symbo-ls/workspace-infra is a HARD LEAF — no other package string-extends,
// bare-keys, or el.calls any Infra* component/fn — so it is deferred out of the
// eager `sharedLibraries.js` merge and registered here as lazy routes instead.
// On first mount of one of these, lazySharedLib folds infra's components +
// functions into the live shell context (the injectPageInApp mechanism) and
// then renders the picked page; both routes share one dynamic-import chunk.
const $8b232ea25b4fd2a3$var$infra = (0, $hn2a0.lazySharedLib)(()=>(parcelRequire("8NLYd")), (lib)=>lib.pages['/infra'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.infra')
    }));

const $8b232ea25b4fd2a3$var$infraStatus = (0, $hn2a0.lazySharedLib)(()=>(parcelRequire("8NLYd")), (lib)=>lib.pages['/infra/status'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.infraStatus')
    }));

// ── Marketplace ── (lazy shared library)
// @symbo-ls/workspace-marketplace is deferred out of the eager shell bundle
// (#16): its ~274KB component barrel + ~116KB function barrel only matter once a
// /marketplace* route is visited. The shell used to boot-merge them via
// workspace/context.js (`...marketplacePages` + the full comp/fn barrels), which
// is exactly why a naive barrel-carve would have un-registered the whole
// MarketplaceIsland tree with no backstop. Instead every /marketplace* route is
// registered here as a lazySharedLib entry: on first mount it folds the FULL
// marketplace context (components + functions + state) into the live shell
// context, THEN el.sets the picked page — so its bare-key children
// (MarketplaceIsland, MarketplaceFeedIsland, PromptGalleryCard, …) and every
// el.call resolve against the now-populated registry. The EAGER carve-out (the
// shell-root install modal: MarketplaceInstallModal + IntegrationLogo +
// closeInstallModal) stays registered via workspace/context.js's eagerSlice
// imports. marketplace's context.js carries a `.pages` map, so each route picks
// its page off `lib.pages[...]`; all routes share one dynamic-import chunk.
const $8b232ea25b4fd2a3$var$_marketplaceCtx = ()=>(parcelRequire("17dat"));
// /marketplace serves the catalogue's App Store page (decision 7, ledger AS-3):
// a bare visit opens the App Store, which moves to /apps/store
// (`marketplaceAppStoreRedirect`); a developer entry — `?surface=market` /
// `?surface=integrations` — stays here with the store's three surfaces.
const $8b232ea25b4fd2a3$var$marketplace = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_marketplaceCtx, (lib)=>lib.pages['/apps/store'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.marketplace')
    }));
// /apps/store — THE ONE CATALOGUE's App Store tab (Nika's decision 7, "one
// catalogue": /apps + an App Store tab). The navbar's "Apps" opens /apps; its
// App Store tab opens this. Same lazy store context as /marketplace.
const $8b232ea25b4fd2a3$var$appsStore = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_marketplaceCtx, (lib)=>lib.pages['/apps/store'], (el)=>({
        title: el.call('pageTitle', 'shell.launcher.appStore')
    }));
const $8b232ea25b4fd2a3$var$marketplaceFeed = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_marketplaceCtx, (lib)=>lib.pages['/marketplace/feed'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.marketplaceCommunity')
    }));
const $8b232ea25b4fd2a3$var$marketplaceRailDemo = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_marketplaceCtx, (lib)=>lib.pages['/marketplace/installable-rail-demo'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.marketplaceRailDemo')
    }));
const $8b232ea25b4fd2a3$var$marketplacePromptGallery = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_marketplaceCtx, (lib)=>lib.pages['/marketplace/prompt-gallery'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.marketplacePrompts')
    }));

// ── Preview ── (lazy shared library — #16 preview half)
// @symbo-ls/workspace-preview is deferred out of the eager shell bundle (#16):
// its ~121KB component barrel (Scene/SceneTemplate/SceneNavbar/PreviewNavbar/
// PreviewSidebar/PreviewAssistant/PreviewErrorBoundary) + the page + function
// barrels only matter once /preview is visited. The shell used to boot-merge
// them via workspace/context.js (`...previewPages` + the full comp/fn barrels),
// which is exactly why a naive barrel-carve would have un-registered the whole
// preview UI with no backstop. Registered here as a lazySharedLib entry instead:
// on first mount it folds the FULL preview context (components + functions) into
// the live shell context, THEN el.sets the picked page — so Scene's bare-key
// children + el.call('renderProject')/el.call('renderDesignSystem') (the iframe
// boot) resolve against the now-populated registry. preview's context.js carries
// a `.pages` map, so the route picks its page off `lib.pages['/preview']`; the
// context + its page module ride one dynamic-import chunk. The EAGER carve-out is
// only the Simone-Chat picker/model backstop fns (workspace/context.js #16). The
// home/canvas PageSlot opens the same page via _APP_WINDOW_PAGES._previewPage
// (pages/main.js), which folds this same context first.
const $8b232ea25b4fd2a3$var$_previewCtx = ()=>(parcelRequire("hRfYg"));
const $8b232ea25b4fd2a3$var$preview = (0, $hn2a0.lazySharedLib)($8b232ea25b4fd2a3$var$_previewCtx, (lib)=>lib.pages['/preview'], (el)=>({
        title: el.call('pageTitle', 'workspace.page.preview')
    }));

// ── Meet ── (lazy shared library + page — meet+chat bundle-fold, 2026-08-01)
// @symbo-ls/workspace-meet is deferred out of the eager `sharedLibraries.js`
// merge: its ~280KB of call/room-list/video/transcript/suggestion UI +
// LiveKit/realtime function surface only matter once a /meet or /meet-guest
// route is visited. Both routes are registered as lazySharedLibPage entries:
// on first mount they fold the meet CONTEXT (components + functions) into the
// live shell context (add-missing — never clobbering the eager slice), THEN
// load the picked page module and el.set it — so the page's bare-key children
// and every el.call resolve against the now-populated registry. The EAGER
// carve-out (MeetCallWidget + MeetControlBarIconButton + MeetNewRoomModal,
// and the connectCall/disconnectCall/openNewRoomModal/closeNewRoomModal/
// createRoom/meetRoomUrl/markSuggestionApplied functions) stays registered via
// sharedLibraries.js for the shell-root call dock / global "New meeting"
// action / chat / calendar / tickets surfaces that reference them before
// either meet route ever mounts. meet's context.js default export has no
// `.pages` map (its pages live in separate modules), so — like calendar — the
// page module is passed as the explicit second loader. The single _meetCtx
// import is module-cached, so both meet routes share ONE context chunk.
const $8b232ea25b4fd2a3$var$_meetCtx = ()=>(parcelRequire("l9i79"));

const $8b232ea25b4fd2a3$var$meet = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_meetCtx, ()=>(parcelRequire("aKYox")).then((m)=>m.meetHome), (el)=>({
        title: el.call('pageTitle', 'workspace.page.meet')
    }));

const $8b232ea25b4fd2a3$var$meetGuest = (0, $hn2a0.lazySharedLibPage)($8b232ea25b4fd2a3$var$_meetCtx, ()=>(parcelRequire("g26qD")).then((m)=>m.guest), (el)=>({
        title: el.call('pageTitle', 'workspace.page.meet')
    }));

// ── System ── (bundle-split T1: /admin/system + /features + /tickets/status
// lazy — operator surfaces, route-map-only. flags stays static: tiny, and its
// flagsRedirect participates in early routing.)
const $8b232ea25b4fd2a3$var$system = (0, $hn2a0.lazyPage)(()=>(parcelRequire("6yR3k")).then((m)=>m.system), (el)=>({
        title: el.call('pageTitle', 'workspace.page.systemHealth')
    }));

const $8b232ea25b4fd2a3$var$systemStatusRedirect = (0, $hn2a0.lazyPage)(()=>(parcelRequire("6yR3k")).then((m)=>m.systemStatusRedirect), (el)=>({
        title: el.call('pageTitle', 'workspace.page.systemHealth')
    }));

const $8b232ea25b4fd2a3$var$features = (0, $hn2a0.lazyPage)(()=>(parcelRequire("9s1tM")).then((m)=>m.features), (el)=>({
        title: el.call('pageTitle', 'workspace.page.features')
    }));

const $8b232ea25b4fd2a3$var$ticketsStatus = (0, $hn2a0.lazyPage)(()=>(parcelRequire("9s1tM")).then((m)=>m.ticketsStatus), (el)=>({
        title: el.call('pageTitle', 'workspace.page.ticketsStatus')
    }));

// ── Admin (bundle-split T1: lazy per-page, no barrel) ──
// Every admin page loads on first visit via lazyPage — admin is an operator
// surface and has no business in the boot-critical chunk. Two footnotes:
// • bare-keys stay safe: AdminSidebar/AdminUserRow/AdminModule* are registered
//   in components/index.js (which statically imports admin.js + module
//   components), so lazy PAGES mount against an eagerly-registered registry —
//   that pin also means admin.js/module.js themselves dedupe into the eager
//   chunk until the components move to their own files (ticketed follow-up).
// • loaders import the local ./admin/ SOURCE files, never the identity-index
//   barrel — a barrel chunk would re-bundle all 16 pages as one blob.
// • each admin title is a LITERAL metadata function. A `(key) => (el) => …`
//   factory closed over `key`; frank cannot serialize a closure, so the
//   published `metadata` read `key` off the shared globalScope instead (an
//   unrelated helper value) and every admin tab title resolved wrong.
const $8b232ea25b4fd2a3$var$admin = (0, $hn2a0.lazyPage)(()=>(parcelRequire("7SVpv")).then((m)=>m.admin), (el)=>({
        title: el.call('pageTitle', 'admin.page.title')
    }));

const $8b232ea25b4fd2a3$var$adminTeams = (0, $hn2a0.lazyPage)(()=>(parcelRequire("eeN3I")).then((m)=>m.adminTeams), (el)=>({
        title: el.call('pageTitle', 'admin.page.teams')
    }));

const $8b232ea25b4fd2a3$var$adminPermissions = (0, $hn2a0.lazyPage)(()=>(parcelRequire("k5PUf")).then((m)=>m.adminPermissions), (el)=>({
        title: el.call('pageTitle', 'admin.page.permissions')
    }));

const $8b232ea25b4fd2a3$var$adminActivityScoring = (0, $hn2a0.lazyPage)(()=>(parcelRequire("9oaOM")).then((m)=>m.adminActivityScoring), (el)=>({
        title: el.call('pageTitle', 'admin.page.activityScoring')
    }));

const $8b232ea25b4fd2a3$var$adminDanger = (0, $hn2a0.lazyPage)(()=>(parcelRequire("1EWCl")).then((m)=>m.adminDanger), (el)=>({
        title: el.call('pageTitle', 'admin.page.danger')
    }));

const $8b232ea25b4fd2a3$var$adminLogs = (0, $hn2a0.lazyPage)(()=>(parcelRequire("2DXB7")).then((m)=>m.adminLogs), (el)=>({
        title: el.call('pageTitle', 'admin.page.logs')
    }));

const $8b232ea25b4fd2a3$var$adminIntegrations = (0, $hn2a0.lazyPage)(()=>(parcelRequire("1unLs")).then((m)=>m.adminIntegrations), (el)=>({
        title: el.call('pageTitle', 'admin.page.integrations')
    }));

const $8b232ea25b4fd2a3$var$adminIntegrationsGithub = (0, $hn2a0.lazyPageWithComponents)(()=>(parcelRequire("il7jP")), 'adminIntegrationsGithub', (el)=>({
        title: el.call('pageTitle', 'admin.page.integrationsGithub')
    }));

const $8b232ea25b4fd2a3$var$adminIntegrationsGoogle = (0, $hn2a0.lazyPageWithComponents)(()=>(parcelRequire("kEufJ")), 'adminIntegrationsGoogle', (el)=>({
        title: el.call('pageTitle', 'admin.page.integrationsGoogle')
    }));

const $8b232ea25b4fd2a3$var$adminIntegrationsNpm = (0, $hn2a0.lazyPageWithComponents)(()=>(parcelRequire("bKIrz")), 'adminIntegrationsNpm', (el)=>({
        title: el.call('pageTitle', 'admin.page.integrationsNpm')
    }));

const $8b232ea25b4fd2a3$var$adminIntegrationsGeneric = (0, $hn2a0.lazyPage)(()=>(parcelRequire("3DNhV")).then((m)=>m.adminIntegrationsGeneric), (el)=>({
        title: el.call('pageTitle', 'admin.page.integrationsGeneric')
    }));

const $8b232ea25b4fd2a3$var$adminIntegrationsMcp = (0, $hn2a0.lazyPageWithComponents)(()=>(parcelRequire("22ZiX")), 'adminIntegrationsMcp', (el)=>({
        title: el.call('pageTitle', 'admin.page.integrationsMcp')
    }));

const $8b232ea25b4fd2a3$var$adminStatus = (0, $hn2a0.lazyPage)(()=>(parcelRequire("bP5E4")).then((m)=>m.adminStatus), (el)=>({
        title: el.call('pageTitle', 'admin.page.status')
    }));

const $8b232ea25b4fd2a3$var$adminDomains = (0, $hn2a0.lazyPage)(()=>(parcelRequire("1icb6")).then((m)=>m.adminDomains), (el)=>({
        title: el.call('pageTitle', 'admin.page.domains')
    }));

// /admin/branding — the ORG's white-label presentation (name, tagline, the two
// marks, the three colours, the boot theme and the pre-auth language). The
// sibling of /admin/domains: that page attaches the branded HOST, this one
// says what the branded surfaces on it look like.
const $8b232ea25b4fd2a3$var$adminBranding = (0, $hn2a0.lazyPage)(()=>(parcelRequire("gKYCm")).then((m)=>m.adminBranding), (el)=>({
        title: el.call('pageTitle', 'admin.page.branding')
    }));

// /admin/data — the workspace data export ("export any time"): an owner or
// admin starts a ZIP of the whole workspace, downloads it through a
// short-lived signed link, deletes it. Server: /workspaces/:id/exports.
const $8b232ea25b4fd2a3$var$adminData = (0, $hn2a0.lazyPage)(()=>(parcelRequire("rFUTx")).then((m)=>m.adminData), (el)=>({
        title: el.call('pageTitle', 'admin.data.page.title')
    }));

const $8b232ea25b4fd2a3$var$adminUsage = (0, $hn2a0.lazyPage)(()=>(parcelRequire("fLrKQ")).then((m)=>m.adminUsage), (el)=>({
        title: el.call('pageTitle', 'admin.page.usage')
    }));

const $8b232ea25b4fd2a3$var$adminAnalytics = (0, $hn2a0.lazyPage)(()=>(parcelRequire("c6pcc")).then((m)=>m.adminAnalytics), (el)=>({
        title: el.call('pageTitle', 'admin.page.analytics')
    }));

const $8b232ea25b4fd2a3$var$adminDashboardDefaults = (0, $hn2a0.lazyPage)(()=>(parcelRequire("jMY48")).then((m)=>m.adminDashboardDefaults), (el)=>({
        title: el.call('pageTitle', 'admin.page.dashboardDefaults')
    }));

// /admin/workspace-settings — the GENERAL workspace settings page (the
// workspace default language today; the home for every workspace-level
// preference that is not a specialised console of its own).
const $8b232ea25b4fd2a3$var$adminWorkspaceSettings = (0, $hn2a0.lazyPage)(()=>(parcelRequire("ePXwE")).then((m)=>m.adminWorkspaceSettings), (el)=>({
        title: el.call('pageTitle', 'admin.page.workspaceSettings')
    }));


// /admin/mail — the workspace mail console (architecture/MAIL.md §3.5). A
// SHARED-LIB page loader, not lazyPage: the page's cards and data plane live
// in @symbo-ls/workspace-mail (MailAdminProviderCard, MailSetupStep,
// loadMailSetup, …), so the mail context must fold BEFORE the page mounts
// for those bare keys to resolve — same fold the '/mail' route runs.
const $8b232ea25b4fd2a3$var$adminMail = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("gOp2u")), ()=>(parcelRequire("kG8Bn")).then((m)=>m.adminMail), (el)=>({
        title: el.call('pageTitle', 'admin.mail.page.title')
    }));

// /admin/module — the Client Module console (connect DB, grant tables, assign
// module+version, personalize, rollback). Local page (workspace-shell owns it).
const $8b232ea25b4fd2a3$var$adminModule = (0, $hn2a0.lazyPageWithComponents)(()=>(parcelRequire("f426L")), 'adminModule', (el)=>({
        title: el.call('pageTitle', 'admin.page.module')
    }));

// /demo — branded email gate shown to unauthed visitors on demo.symbols.app /
// dev.demo.symbols.app (and local `?demo=1` / symbols_force_demo override).
// redirectIfUnauthed bounces guests here instead of /login when isDemoHost().
// Lazy (T1): only demo hosts ever mount it; the loader covers the beat.
const $8b232ea25b4fd2a3$var$demoGate = (0, $hn2a0.lazyPage)(()=>(parcelRequire("lj0dP")).then((m)=>m.demoGate), (el)=>({
        title: el.call('polyglot', 'workspace.page.demo')
    }));
var $8b232ea25b4fd2a3$export$2e2bcd8739ae039 = {
    // Intranet
    '/': (0, $kvxcA.main),
    // Bare `/w` (no org slug) — the workspace hub: auto-forwards to the only
    // org, or shows the picker. Was an unrouted 404 (2026-07-29 per Nika).
    '/w': (0, $cT6tU.workspaceHub),
    '/team-members': (0, $l0m6y.people),
    // Legacy alias — old links/bookmarks keep working; nav points at
    // /team-members now (renamed 2026-06-06 per Nika).
    '/people': (0, $l0m6y.people),
    // Contacts directory moved to the system/crm-app marketplace module
    // (correct Manifest v2 shape) — /contacts previously lived here, baked
    // directly into the shell (the greenig-in-shell anti-pattern).
    '/my': (0, $fdfsh.my),
    '/announcements': (0, $65kO4.announcements),
    '/company': (0, $aA4I2.company),
    // (The legacy static '/claims' route is gone — WS6: GreenIG's pages inject
    // dynamically from its published v2 module, scoped to its own workspace.)
    '/add-app': $8b232ea25b4fd2a3$var$addApp,
    '/apps': $8b232ea25b4fd2a3$var$appsHub,
    '/apps/store': $8b232ea25b4fd2a3$var$appsStore,
    // Its own title: a pane titles itself from the ROUTE def's metadata, and a
    // string-extend def carries none until it renders — the pane bar read the
    // raw path "/team-and-agents" (measured live 2026-09-22).
    '/team-and-agents': {
        extends: 'teamAndAgents',
        metadata: (el)=>({
                title: el.call('pageTitle', 'workspace.page.teamAndAgents')
            })
    },
    '/agents': $8b232ea25b4fd2a3$var$agents,
    '/my-agents': $8b232ea25b4fd2a3$var$agents,
    // Analytics surface — tabs share AnalyticsNavbar. Registered here as lazy
    // routes (lazySharedLib folds @symbo-ls/workspace-analytics' context in on
    // first mount) now that analytics is deferred out of the eager sharedLibraries
    // merge. Canonical + legacy alias paths mirror the analytics package's own
    // pages map (pages/index.js + pages/logs/index.js). Bare /logs stays a shell
    // redirect so existing deep-links/bookmarks don't 404 after the route move.
    '/analytics': $8b232ea25b4fd2a3$var$analyticsProject,
    '/analytics/map': $8b232ea25b4fd2a3$var$analyticsMap,
    '/analytics/sessions': $8b232ea25b4fd2a3$var$analyticsSessions,
    '/analytics/sessions/:id': $8b232ea25b4fd2a3$var$analyticsSession,
    '/analytics/session': $8b232ea25b4fd2a3$var$analyticsSessionFixed,
    '/analytics/visitors': $8b232ea25b4fd2a3$var$analyticsVisitors,
    '/analytics/bugs': $8b232ea25b4fd2a3$var$analyticsBugs,
    '/analytics/events': $8b232ea25b4fd2a3$var$analyticsEvents,
    '/analytics/logs/session': $8b232ea25b4fd2a3$var$analyticsLogsSessionFixed,
    '/workspace-analytics/logs/session': $8b232ea25b4fd2a3$var$analyticsLogsSessionFixed,
    '/workspace-analytics': $8b232ea25b4fd2a3$var$workspaceAnalytics,
    '/workspace-analytics/map': $8b232ea25b4fd2a3$var$analyticsMap,
    '/workspace-analytics/logs': $8b232ea25b4fd2a3$var$analyticsLogs,
    '/workspace-analytics/logs/users': $8b232ea25b4fd2a3$var$analyticsLogsUsers,
    '/workspace-analytics/logs/sessions': $8b232ea25b4fd2a3$var$analyticsLogsSessions,
    '/workspace-analytics/logs/sessions/:id': $8b232ea25b4fd2a3$var$analyticsLogsSession,
    '/workspace-analytics/logs/events': $8b232ea25b4fd2a3$var$analyticsLogsEvents,
    '/workspace-analytics/logs/bugs': $8b232ea25b4fd2a3$var$analyticsLogsBugs,
    '/workspace-analytics/logs/network': $8b232ea25b4fd2a3$var$analyticsLogsNetwork,
    '/workspace-analytics/logs/verbose': $8b232ea25b4fd2a3$var$analyticsLogsVerbose,
    // Legacy /analytics/logs/* aliases (kept so deep-links/bookmarks don't 404).
    '/analytics/logs': $8b232ea25b4fd2a3$var$analyticsLogs,
    '/analytics/logs/users': $8b232ea25b4fd2a3$var$analyticsLogsUsers,
    '/analytics/logs/sessions': $8b232ea25b4fd2a3$var$analyticsLogsSessions,
    '/analytics/logs/sessions/:id': $8b232ea25b4fd2a3$var$analyticsLogsSession,
    '/analytics/logs/events': $8b232ea25b4fd2a3$var$analyticsLogsEvents,
    '/analytics/logs/bugs': $8b232ea25b4fd2a3$var$analyticsLogsBugs,
    '/analytics/logs/network': $8b232ea25b4fd2a3$var$analyticsLogsNetwork,
    '/analytics/logs/verbose': $8b232ea25b4fd2a3$var$analyticsLogsVerbose,
    // Even older bare /logs/* aliases. Bare /logs itself stays the redirect.
    '/logs': (0, $iwxpi.logsRedirect),
    '/logs/users': $8b232ea25b4fd2a3$var$analyticsLogsUsers,
    '/logs/sessions': $8b232ea25b4fd2a3$var$analyticsLogsSessions,
    '/logs/sessions/:id': $8b232ea25b4fd2a3$var$analyticsLogsSession,
    '/logs/events': $8b232ea25b4fd2a3$var$analyticsLogsEvents,
    '/logs/bugs': $8b232ea25b4fd2a3$var$analyticsLogsBugs,
    '/logs/network': $8b232ea25b4fd2a3$var$analyticsLogsNetwork,
    '/logs/verbose': $8b232ea25b4fd2a3$var$analyticsLogsVerbose,
    // Signed-in user's own account settings, under its own tab title
    // (accountSettings above). `/profile` stays as a
    // legacy alias for `?u=<email>` cross-user links still in flight.
    // `/orgs` lands on the same account surface — historically the
    // membership picker, now folded into the unified account page.
    '/settings': $8b232ea25b4fd2a3$var$accountSettings,
    '/profile': $8b232ea25b4fd2a3$var$profile,
    '/orgs': $8b232ea25b4fd2a3$var$profile,
    // Public-facing user profile — both prefixes mount the same page
    // (the slug is read from the URL inside the page's onCreate). The
    // canonical link surfaces `/user/:slug` so it reads cleanly when
    // shared; `/u/:slug` is a compact alias that the marketplace and
    // feed components prefer.
    '/user/:slug': (0, $8RC0A.userProfile),
    '/u/:slug': (0, $8RC0A.userProfile),
    // /s/:token — the recipient's view of a public share link
    // (PUBLIC-SHARE-LINKS-1). A guest route: listed in the shell entry's
    // publicPathPrefixes so an unauthed visitor renders it instead of
    // bouncing to /login. Lazy — nothing else in the app references it, and
    // the surface is reached by URL only.
    '/s/:token': $8b232ea25b4fd2a3$var$sharedResource,
    // demo.symbols.app email gate — a guest route (in AUTH_PATHS +
    // publicPathPrefixes) so chrome stays hidden and no auth bounce fires.
    '/demo': $8b232ea25b4fd2a3$var$demoGate,
    '/login': $8b232ea25b4fd2a3$var$login,
    '/signin': $8b232ea25b4fd2a3$var$signin,
    '/signup': $8b232ea25b4fd2a3$var$signup,
    '/signup-confirmation': $8b232ea25b4fd2a3$var$signupConfirmation,
    '/reset-password': $8b232ea25b4fd2a3$var$resetPassword,
    '/auth/callback': $8b232ea25b4fd2a3$var$authCallback,
    '/github-auth-callback': $8b232ea25b4fd2a3$var$authCallback,
    '/auth/magic-callback': $8b232ea25b4fd2a3$var$magicCallback,
    // Emailed invitation landings (see the acceptInvite/waitlistInvite defs
    // above). One page, four kinds — the path names the kind.
    '/accept-invite': $8b232ea25b4fd2a3$var$acceptInvite,
    '/accept-org-invite': $8b232ea25b4fd2a3$var$acceptInvite,
    '/accept-team-invite': $8b232ea25b4fd2a3$var$acceptInvite,
    '/accept-workspace-invite': $8b232ea25b4fd2a3$var$acceptInvite,
    '/waitlist-invite': $8b232ea25b4fd2a3$var$waitlistInvite,
    '/data': $8b232ea25b4fd2a3$var$data,
    '/data/projects': $8b232ea25b4fd2a3$var$data,
    '/data/users': $8b232ea25b4fd2a3$var$data,
    '/data/plans': $8b232ea25b4fd2a3$var$data,
    '/data/organizations': $8b232ea25b4fd2a3$var$data,
    '/data/teams': $8b232ea25b4fd2a3$var$data,
    '/data/subscriptions': $8b232ea25b4fd2a3$var$data,
    '/data/external': $8b232ea25b4fd2a3$var$dataExternal,
    // Calendar
    '/calendar': $8b232ea25b4fd2a3$var$calendar,
    // Reminders — built-in personal reminders app (workspace-shell page, not
    // a feature package).
    '/reminders': $8b232ea25b4fd2a3$var$reminders,
    // History — built-in timeline of the workspace activity log.
    '/history': $8b232ea25b4fd2a3$var$history,
    // Getting started — the first-thread offers (POB S9/S10). Not under
    // `/onboarding`: that is the old wizard's route.
    '/getting-started/team': $8b232ea25b4fd2a3$var$gettingStartedTeam,
    '/getting-started/imports': $8b232ea25b4fd2a3$var$gettingStartedImports,
    '/inbox': $8b232ea25b4fd2a3$var$inbox,
    // Tasks (né Tickets — renamed 2026-08-06 per Nika "in workspace — rename
    // tickets to tasks … instead of /tickets it will be /tasks"). /tasks is the
    // board kanban canvas (2026-06-09 per Nika); the personalized "My view"
    // lives at /tasks-page; /tasks/canvas removed. USER-FACING rename only —
    // the data plane keeps its internal names (sdk.tickets.*, root.tickets,
    // @symbo-ls/workspace-tickets, server /core/tickets).
    '/tasks': $8b232ea25b4fd2a3$var$ticketsBoard,
    '/tasks-page': $8b232ea25b4fd2a3$var$tickets,
    // Dedicated full-page view (linked from the modal's Expand icon).
    // Path-param shape mirrors `/user/:slug` — the smbls auto-router
    // matches it after the explicit /tasks/* routes are tried.
    '/task/:id': $8b232ea25b4fd2a3$var$ticketView,
    '/tasks/general': $8b232ea25b4fd2a3$var$ticketsGeneral,
    // /tasks/feed is the summary digest (recent activity + standups).
    '/tasks/feed': $8b232ea25b4fd2a3$var$ticketsFeed,
    // Epics + Stories merged into one view (2026-06-09 per Nika).
    '/tasks/epics': $8b232ea25b4fd2a3$var$ticketsEpics,
    '/tasks/board': $8b232ea25b4fd2a3$var$ticketsBoard,
    '/tasks/status': $8b232ea25b4fd2a3$var$ticketsStatus,
    '/tasks/standups': $8b232ea25b4fd2a3$var$ticketsStandups,
    '/tasks/release': $8b232ea25b4fd2a3$var$ticketsRelease,
    '/tasks/roadmap': $8b232ea25b4fd2a3$var$ticketsRoadmap,
    // Legacy /tickets* + /ticket/:id — URL-NORMALIZING REDIRECTS, not aliases
    // (2026-08-06 per Nika "you dont have to alias /tickets — fix all
    // references to /tasks"). One shared def computes its own canonical
    // target via canonicalRoutePath, so old deep-links/bookmarks/stored
    // navbar configs land on /tasks (or /resolutions for the moved groups)
    // with the address bar normalized. No page content is ever served under
    // a /tickets URL again.
    '/tickets': (0, $8Ofnd.tasksRedirect),
    '/tickets-page': (0, $8Ofnd.tasksRedirect),
    '/ticket/:id': (0, $8Ofnd.tasksRedirect),
    '/tickets/general': (0, $8Ofnd.tasksRedirect),
    '/tickets/feed': (0, $8Ofnd.tasksRedirect),
    '/tickets/epics': (0, $8Ofnd.tasksRedirect),
    '/tickets/board': (0, $8Ofnd.tasksRedirect),
    '/tickets/status': (0, $8Ofnd.tasksRedirect),
    '/tickets/standups': (0, $8Ofnd.tasksRedirect),
    '/tickets/release': (0, $8Ofnd.tasksRedirect),
    '/tickets/roadmap': (0, $8Ofnd.tasksRedirect),
    // Resolutions — dedicated top-level surface (own sidebar). The
    // Requests + Resolutions groups moved here out of the tickets sidebar.
    '/resolutions': $8b232ea25b4fd2a3$var$resolutions,
    '/resolutions/improvements': $8b232ea25b4fd2a3$var$resolutionsImprovements,
    '/resolutions/edit-requests': $8b232ea25b4fd2a3$var$resolutionsEditRequests,
    '/resolutions/audit': $8b232ea25b4fd2a3$var$requestsAudit,
    '/resolutions/requests': $8b232ea25b4fd2a3$var$requests,
    '/resolutions/requests/inbound': $8b232ea25b4fd2a3$var$requestsInbound,
    '/resolutions/requests/outbound': $8b232ea25b4fd2a3$var$requestsOutbound,
    // Legacy /tickets/{requests,resolutions}* — same URL-normalizing redirect
    // (canonicalRoutePath maps these to their /resolutions homes).
    '/tickets/requests': (0, $8Ofnd.tasksRedirect),
    '/tickets/requests/inbound': (0, $8Ofnd.tasksRedirect),
    '/tickets/requests/outbound': (0, $8Ofnd.tasksRedirect),
    '/tickets/requests/audit': (0, $8Ofnd.tasksRedirect),
    '/tickets/resolutions': (0, $8Ofnd.tasksRedirect),
    '/tickets/resolutions/improvements': (0, $8Ofnd.tasksRedirect),
    '/tickets/resolutions/edit-requests': (0, $8Ofnd.tasksRedirect),
    // Chat
    '/chat': $8b232ea25b4fd2a3$var$chat,
    // Mail
    '/mail': $8b232ea25b4fd2a3$var$mail,
    // Notes (renamed from Documents 2026-08-06 per Nika — the /documents*
    // family + /docs are URL-normalizing redirects via canonicalRoutePath,
    // same pattern as /tickets → /tasks above)
    '/notes': $8b232ea25b4fd2a3$var$documents,
    '/notes/knowledge-base': $8b232ea25b4fd2a3$var$documentsKb,
    '/notes/kb': $8b232ea25b4fd2a3$var$documentsKb,
    '/notes/editor': $8b232ea25b4fd2a3$var$documentsEditor,
    '/docs': (0, $hgKZn.notesRedirect),
    '/documents': (0, $hgKZn.notesRedirect),
    '/documents/notes': (0, $hgKZn.notesRedirect),
    '/documents/knowledge-base': (0, $hgKZn.notesRedirect),
    '/documents/kb': (0, $hgKZn.notesRedirect),
    '/documents/editor': (0, $hgKZn.notesRedirect),
    // Files — shared desktop canvas (real uploads + folders + markdown docs)
    '/files': $8b232ea25b4fd2a3$var$files,
    // Infra — deployment canvas + status page. Lazy shared library (deferred out
    // of the eager sharedLibraries merge); registers its components/functions on
    // first mount. /infra/status also opens in the shell PageSlot via
    // root._canvasSlot (resolved from this same registry).
    '/infra': $8b232ea25b4fd2a3$var$infra,
    '/infra/status': $8b232ea25b4fd2a3$var$infraStatus,
    // Meet
    '/meet': $8b232ea25b4fd2a3$var$meet,
    '/meet-guest': $8b232ea25b4fd2a3$var$meetGuest,
    // Marketplace — lazy shared library (folds the full marketplace context on
    // first mount; the eager chunk carries only the shell-root install-modal
    // slice — see workspace/context.js #16). These override the dead canvas
    // `/marketplace` page (canvasPages['/marketplace'], superseded here since
    // shellPages wins the context.js pages merge). `/feed` aliases the community
    // feed, mirroring marketplace's own page map.
    '/marketplace': $8b232ea25b4fd2a3$var$marketplace,
    '/marketplace/feed': $8b232ea25b4fd2a3$var$marketplaceFeed,
    '/feed': $8b232ea25b4fd2a3$var$marketplaceFeed,
    '/marketplace/installable-rail-demo': $8b232ea25b4fd2a3$var$marketplaceRailDemo,
    '/marketplace/prompt-gallery': $8b232ea25b4fd2a3$var$marketplacePromptGallery,
    // Preview — lazy shared library (folds the full preview context on first
    // mount; the eager chunk carries only the Simone-Chat picker/model backstop
    // fns — see workspace/context.js #16). Replaces the previously boot-merged
    // previewPages['/preview'] (raw eager page in context.js). The home/canvas
    // PageSlot opens the same page via _APP_WINDOW_PAGES._previewPage (main.js),
    // which folds this same context first.
    '/preview': $8b232ea25b4fd2a3$var$preview,
    // System Health — canonical route is `/system-status`. The legacy
    // bare `/system` registration was removed because it shadowed the
    // canvas project route `/system/:slug` (e.g. `/system/landing`
    // should open the "system" org's "landing" project in canvas, but
    // was being intercepted by the smbls prefix-matcher and rendered
    // the System Health page instead). Anyone still navigating to bare
    // `/system` will fall through to canvas's `/*` handler which 404s
    // gracefully — and we've updated every internal link to point at
    // `/system-status` directly (see AppNavbar TITLES below).
    '/system-status': $8b232ea25b4fd2a3$var$systemStatusRedirect,
    '/admin/system': $8b232ea25b4fd2a3$var$system,
    '/features': $8b232ea25b4fd2a3$var$features,
    '/flags': (0, $6wqeJ.flagsRedirect),
    '/admin/flags': (0, $6wqeJ.flags),
    // Top-level aliases — sidebar links sometimes use bare /integrations and
    // /system instead of the /admin/* nested paths. Both must be registered
    // so the smbls auto-router does not 404 before dispatchUrl can overlay.
    '/integrations': $8b232ea25b4fd2a3$var$adminIntegrations,
    // Admin
    '/admin': $8b232ea25b4fd2a3$var$admin,
    '/admin/teams': $8b232ea25b4fd2a3$var$adminTeams,
    '/admin/permissions': $8b232ea25b4fd2a3$var$adminPermissions,
    '/admin/activity-scoring': $8b232ea25b4fd2a3$var$adminActivityScoring,
    '/admin/logs': $8b232ea25b4fd2a3$var$adminLogs,
    '/admin/integrations': $8b232ea25b4fd2a3$var$adminIntegrations,
    '/admin/integrations/github': $8b232ea25b4fd2a3$var$adminIntegrationsGithub,
    '/admin/integrations/google': $8b232ea25b4fd2a3$var$adminIntegrationsGoogle,
    '/admin/integrations/npm': $8b232ea25b4fd2a3$var$adminIntegrationsNpm,
    '/admin/integrations/openai': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/livekit': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/google_analytics': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/n8n': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/custom_http': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    // Marketplace-seeded kinds (migration 0063). All use the generic
    // detail page — which reads config_schema.fields from the kind row
    // so no bespoke code per kind. Add to this list AND to 0063 together.
    '/admin/integrations/plausible': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/posthog': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/segment': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/mixpanel': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/firebase': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/cloudflare_workers': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/vercel': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/aws': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/postgres': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/mongodb': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/planetscale': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/neon': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/redis': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/zapier': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/make': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/temporal': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/auth0': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/clerk': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/workos': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/stripe': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/paddle': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/lemonsqueezy': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/anthropic': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/replicate': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/pinecone': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/slack': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/discord': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/twilio': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/sendgrid': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/resend': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/aws_s3': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/cloudflare_r2': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/uploadthing': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/sentry': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/datadog': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/logrocket': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/figma': $8b232ea25b4fd2a3$var$adminIntegrationsGeneric,
    '/admin/integrations/mcp': $8b232ea25b4fd2a3$var$adminIntegrationsMcp,
    '/admin/status': $8b232ea25b4fd2a3$var$adminStatus,
    '/admin/domains': $8b232ea25b4fd2a3$var$adminDomains,
    '/admin/branding': $8b232ea25b4fd2a3$var$adminBranding,
    '/admin/usage': $8b232ea25b4fd2a3$var$adminUsage,
    '/admin/analytics': $8b232ea25b4fd2a3$var$adminAnalytics,
    '/admin/dashboard-defaults': $8b232ea25b4fd2a3$var$adminDashboardDefaults,
    '/admin/workspace-settings': $8b232ea25b4fd2a3$var$adminWorkspaceSettings,
    '/admin/mail': $8b232ea25b4fd2a3$var$adminMail,
    '/admin/module': $8b232ea25b4fd2a3$var$adminModule,
    '/admin/data': $8b232ea25b4fd2a3$var$adminData,
    '/admin/danger': $8b232ea25b4fd2a3$var$adminDanger,
    // Cross-origin auth helper. Other Symbols subdomains iframe this page
    // to request the live governance Supabase session, so e.g. the canvas
    // app can read RLS-gated integration rows without a separate signin.
    '/_session-bridge': (0, $jhYyf.sessionBridge),
    '/sign-in-session': (0, $4e8H1.signInSession),
    // Catch-all — MUST stay last / win over canvas's dropped `'/*'` in
    // context.js's merge. Redirects `/<owner>/<key>` project paths to the host
    // that runs the full canvas editor graph; renders a plain not-found for
    // everything else genuinely unmatched.
    '/*': (0, $9Hn8c.projectRedirect)
};

});
parcelRegister("hn2a0", function(module, exports) {

$parcel$export(module.exports, "lazyPage", () => $ca5642a410aff431$export$f0824772714954c5);
$parcel$export(module.exports, "lazySharedLib", () => $ca5642a410aff431$export$3c75c6f66e16f17b);
$parcel$export(module.exports, "lazySharedLibPage", () => $ca5642a410aff431$export$267bc1a9baf1c971);
$parcel$export(module.exports, "lazyPageWithComponents", () => $ca5642a410aff431$export$5f04e65679147949);
// Route-based code-splitting helpers — LOCAL implementation, not a re-export.
//
// The canonical logic lives in `@symbo-ls/workspace-shared/pages/lazyPage.js`
// (full usage docs + the detached-node-race rationale are there). This file
// used to delegate to it at call time (`_wsShared.pages.lazyPage(...args) :
// ''`), which is a stub-phantom-value under frank's publish serializer: ANY
// bag value that is the RESULT OF CALLING a function obtained through a
// stubbed `@symbo-ls/*` import is tainted, even when the loader argument is
// this project's own code — every route wired through that ternary published
// as the literal `""` (WS-SHARED-LAZYPAGE-HOLLOW-ROUTES-SWITCH-1, 172
// measured hollow values). Frank's own test proves the fix shape
// (smbls/plugins/frank/__tests__/stubPhantomValueGate.test.js test (ix)): a
// route value must be a LOCAL object literal, defined in this project's own
// source, whose `onCreate` dynamic-`import()`s the shared page at RUNTIME —
// never a call routed through an external stub at module-eval time. So this
// file carries the real implementation locally instead of delegating.
// The three loader-failure fallbacks read the SHARED chrome key
// `shell.errorState.lazyPage` — byte-identical copy to
// @symbo-ls/workspace-shared/pages/lazyPage.js's own fallback, and this
// package's manifest declares the `shell` namespace, so duplicating the same
// sentence under `workspace.*` would only give a translator two places to
// disagree.
const $ca5642a410aff431$export$4cbbd0e48a8e8cd3 = (root, lib)=>{
    const ctx = root.context;
    if (lib?.components && ctx?.components) {
        for(const k in lib.components)if (!ctx.components[k]) ctx.components[k] = lib.components[k];
    }
    if (lib?.functions && ctx?.functions) {
        for(const k in lib.functions)if (!ctx.functions[k]) ctx.functions[k] = lib.functions[k];
    }
    if (lib?.state) {
        const seed = {};
        for(const k in lib.state)if (root[k] === undefined) seed[k] = lib.state[k];
        if (Object.keys(seed).length) root.update?.(seed);
    }
};
const $ca5642a410aff431$export$5be725afa0d1e580 = (def, host)=>{
    if (!def || typeof def !== 'object' || !host) return def;
    let held = host.role === 'main';
    for(let p = host.parent, i = 0; !held && p && i < 4; p = p.parent, i++)if (p._slotPaneKey) held = true;
    if (!held) return def;
    const own = {};
    if (def.tag === 'main') own.tag = 'div';
    if (def.role === 'main') own.role = null;
    if (def.id === 'main-content') own.id = null;
    if (def.attr && typeof def.attr === 'object' && def.attr.id === 'main-content') own.attr = {
        ...def.attr,
        id: null
    };
    return {
        ...def,
        ...own
    };
};
const $ca5642a410aff431$export$f0824772714954c5 = (loader, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        content: {
            extends: 'PageSkeleton'
        },
        scope: {
            loader: loader,
            prefetch: (scope)=>scope.loader()
        },
        onCreate: async (el)=>{
            if (el.__lazyLoaded) return;
            el.__lazyLoaded = true;
            // Late-resolve guard: the loader can resolve after the router (or the
            // AppWindow PageSlot) navigated away and DISPOSED this placeholder —
            // dispose() clears el.__ref (and el.node); never swap then. NOT
            // connected YET is not gone: smbls 3.14.84x builds an app's whole first
            // view detached and attaches it in one insertion (firstRender), so a
            // loader that settles on the next microtask (the sign-in routes'
            // Promise.resolve) lands before that. The old `!el.node.isConnected`
            // guard read it as gone and kept the signed-out /login on its skeleton
            // forever (staging + dev, 2026-10-21). el.whenConnected runs the swap
            // now when connected, else in the task that inserts the node — so it
            // lands in the first paint — and never for a disposed element.
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const page = await el.scope.loader();
                if (!page) throw new Error('loader resolved empty');
                _place($ca5642a410aff431$export$5be725afa0d1e580({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                }, el));
            } catch (err) {
                console.error('[lazyPage] failed to load route module:', err && err.message);
                _place({
                    tag: 'div',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ shell.errorState.lazyPage | polyglot }}'
                });
            }
        }
    });
const $ca5642a410aff431$export$3c75c6f66e16f17b = (ctxLoader, pickPage, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        content: {
            extends: 'PageSkeleton'
        },
        scope: {
            ctxLoader: ctxLoader,
            pickPage: pickPage,
            prefetch: (scope)=>scope.ctxLoader()
        },
        onCreate: async (el)=>{
            if (el.__lazyLibLoaded) return;
            el.__lazyLibLoaded = true;
            // The late-resolve guard of lazyPage above: never for a disposed
            // placeholder (el.__ref cleared), and a first view that is not attached
            // YET swaps when it is (el.whenConnected).
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const mod = await el.scope.ctxLoader();
                const lib = mod && mod.default ? mod.default : mod;
                // A resolved context with neither components nor functions is a
                // stale/mismatched bundle — fail into the catch (Refresh prompt)
                // instead of silently add-missing-merging nothing and rendering an
                // empty shell.
                if (!lib || !lib.components && !lib.functions) throw new Error("shared-lib context resolved with no components/functions \u2014 stale/mismatched bundle (rebuild needed)");
                const root = el.getRoot?.() || el;
                $ca5642a410aff431$export$4cbbd0e48a8e8cd3(root, lib);
                const page = el.scope.pickPage(lib);
                if (!page) throw new Error('shared-lib page resolved empty');
                _place($ca5642a410aff431$export$5be725afa0d1e580({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                }, el));
            } catch (err) {
                el.__lazyLibLoaded = false;
                console.error('[lazySharedLib] load failed:', err && err.message);
                _place({
                    tag: 'div',
                    role: 'alert',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ shell.errorState.lazyPage | polyglot }}'
                });
            }
        }
    });
const $ca5642a410aff431$export$267bc1a9baf1c971 = (ctxLoader, pageLoader, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        content: {
            extends: 'PageSkeleton'
        },
        scope: {
            ctxLoader: ctxLoader,
            pageLoader: pageLoader,
            prefetch: (scope)=>Promise.all([
                    scope.ctxLoader(),
                    scope.pageLoader()
                ])
        },
        onCreate: async (el)=>{
            if (el.__lazyLibPageLoaded) return;
            el.__lazyLibPageLoaded = true;
            // The late-resolve guard of lazyPage above (disposed → never; not
            // attached yet → when it is).
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const mod = await el.scope.ctxLoader();
                const lib = mod && mod.default ? mod.default : mod;
                const root = el.getRoot?.() || el;
                $ca5642a410aff431$export$4cbbd0e48a8e8cd3(root, lib);
                const page = await el.scope.pageLoader();
                if (!page) throw new Error('page loader resolved empty');
                _place($ca5642a410aff431$export$5be725afa0d1e580({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                }, el));
            } catch (err) {
                console.error('[lazySharedLibPage] load failed:', err && err.message);
                _place({
                    tag: 'div',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ shell.errorState.lazyPage | polyglot }}'
                });
            }
        }
    });
const $ca5642a410aff431$export$5f04e65679147949 = (loader, pageKey, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        content: {
            extends: 'PageSkeleton'
        },
        // The module, the page's export name and the prefetch ride in `scope` —
        // see lazyPage above (a closure over `loader` / `pageKey` does not survive
        // frank's serialization).
        scope: {
            loader: loader,
            pageKey: pageKey,
            prefetch: (scope)=>scope.loader()
        },
        onCreate: async (el)=>{
            if (el.__lazyLibLoaded) return;
            el.__lazyLibLoaded = true;
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const m = await el.scope.loader();
                const components = {};
                for(const k in m || {}){
                    const v = m[k];
                    if (/^[A-Z]/.test(k) && v && typeof v === 'object') components[k] = v;
                }
                const root = el.getRoot?.() || el;
                $ca5642a410aff431$export$4cbbd0e48a8e8cd3(root, {
                    components: components
                });
                const page = m && m[el.scope.pageKey];
                if (!page) throw new Error('page module resolved no ' + el.scope.pageKey);
                _place($ca5642a410aff431$export$5be725afa0d1e580({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                }, el));
            } catch (err) {
                el.__lazyLibLoaded = false;
                console.error('[lazyPageWithComponents] load failed:', err && err.message);
                _place({
                    tag: 'div',
                    role: 'alert',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ shell.errorState.lazyPage | polyglot }}'
                });
            }
        }
    });

});

parcelRegister("kvxcA", function(module, exports) {

$parcel$export(module.exports, "main", () => $eee07520569aad07$export$f22da7240b7add18);
// Home page — the workspace "/" board (DESIGN-WL-HOME-WIDGETS-1,
// tickets/reference/white-label-redesign/HOME_WIDGETS_SPEC.md).
//
// A page head (the greeting line) above ONE CSS grid of widgets: fixed square
// cells, four sizes (S 1×1, M 2×1, L 2×2, XL 4×1), 4 / 3 / 2 / 1 columns by the
// board's own width, flowing the saved ORDER — no free placement, no holes.
// Every widget, the page's own and every module / app / AI widget, renders
// through the one frame (components/HomeWidgetFrame.js): a hue plate, the
// title, one square button, the body. App shortcuts sit in the same grid as
// one-cell app tiles for now (decision H1 C; the App strip is held).
//
// The board paints its final arrangement on the first frame: the geometry is
// pure CSS (_injectWidgetStyles), the layout / hidden map resolve
// synchronously from the account record, the unconfirmed-write outbox and the
// device cache (_reconcileHomeBoard), and widgets still loading hold a
// skeleton in their saved cell. In edit mode (Customize) a widget is dragged
// to a new place in the order, resized with the S · M · L · XL picker, or
// hidden; every such decision persists at once through the durable prefs
// write (the outbox + single-flight PUT, _savePrefsPatch).

var $11nI2 = parcelRequire("11nI2");

var $debL2 = parcelRequire("debL2");
parcelRequire("8BRyL");
var $eOUFv = parcelRequire("eOUFv");
var $74YUs = parcelRequire("74YUs");

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");

var $hn2a0 = parcelRequire("hn2a0");

var $lAJsX = parcelRequire("lAJsX");

var $dS9Zz = parcelRequire("dS9Zz");

var $bbG8O = parcelRequire("bbG8O");

var $aJYU4 = parcelRequire("aJYU4");

var $7dUkh = parcelRequire("7dUkh");

var $1Qr8P = parcelRequire("1Qr8P");

var $2zU0i = parcelRequire("2zU0i");

var $ffnKx = parcelRequire("ffnKx");

var $5BDlp = parcelRequire("5BDlp");

var $76atT = parcelRequire("76atT");

var $hkMuP = parcelRequire("hkMuP");

var $dDuP2 = parcelRequire("dDuP2");

var $ljZYp = parcelRequire("ljZYp");

var $8Zc6q = parcelRequire("8Zc6q");

var $in9xh = parcelRequire("in9xh");

var $dTMvK = parcelRequire("dTMvK");

var $g7CNh = parcelRequire("g7CNh");

var $htRH6 = parcelRequire("htRH6");

var $7ytvD = parcelRequire("7ytvD");

var $4CrGc = parcelRequire("4CrGc");

var $2rYsV = parcelRequire("2rYsV");

var $jgMXB = parcelRequire("jgMXB");

var $g9flU = parcelRequire("g9flU");

var $jZ5ZE = parcelRequire("jZ5ZE");

var $bShA0 = parcelRequire("bShA0");
// shared's registered findMe (the shell no longer re-registers it — see
// functions/index.js header).
const $eee07520569aad07$var$shellFindMe = (...args)=>(0, $1X0Je.default).functions.findMe(...args);
// WS-GRID-PERSIST-1: the SYNCHRONOUS, per-tab workspace identity the home
// cache keys are scoped on. Pure regex parse of the path — no resolver, no
// await, and unlike the shared activeWorkspace pointer it cannot be
// contaminated by another tab.
const $eee07520569aad07$var$shellGetWorkspaceRawSegments = (...args)=>(0, $1X0Je.default).functions.getWorkspaceRawSegments(...args);
const $eee07520569aad07$var$shellGetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.getActiveWorkspacePointer(...args);
const $eee07520569aad07$var$shellIsLoudDevRuntime = (...args)=>(0, $1X0Je.default).functions.isLoudDevRuntime(...args);
const $eee07520569aad07$var$shellNavItemVisible = (...args)=>(0, $1X0Je.default).functions.navItemVisible(...args);
const $eee07520569aad07$var$shellListOrgMembers = (...args)=>(0, $1X0Je.default).functions.listOrgMembers(...args);
const $eee07520569aad07$var$invalidateOrgMembers = (...args)=>(0, $1X0Je.default).functions.invalidateOrgMembers(...args);
// lazySharedLibPage is only exported from the canonical shared implementation
// (the local ./lazyPage.js re-exports lazyPage by name only). The home PageSlot
// resolves /documents + /documents/editor via _APP_WINDOW_PAGES (below) BEFORE
// context.pages, so these must ALSO merge the deferred documents context — a
// plain lazyPage would mount the page against an unregistered doc component set.
// Standalone sub-app pages opened in the AppWindow are lazy-loaded (dynamic
// import chunk) so their code stays out of the initial home bundle — see
// pages/lazyPage.js + LAZY_PAGE_PLAN.md. Same const names feed
// _APP_WINDOW_PAGES below unchanged.
// chat bundle-fold (2026-08-01): chat is now a lazy shared library — the home
// AppWindow PageSlot mount needs the context-fold-then-page-load shape, not a
// bare lazyPage (same conversion as tickets/meet below).
//
// The whole page-registry map is a MEMOIZED FACTORY, not module-scope
// consts — this module loads INSIDE the shared-barrel init cycle (same
// class as workspaceProjects.js/pageContext.js/functions/featureFlags.js's
// fix note), and building 19 lazySharedLib(Page) pages eagerly here — each
// one reading `_wsShared.pages.lazySharedLib(Page)` the instant its own
// `const` line runs — crashed the PRODUCTION BUILD ("Cannot read
// properties of undefined (reading 'lazySharedLibPage')", smbls push,
// tickets/execution-board.md §1). First call builds + caches the map;
// every call after returns the same cached object, so `_appPageFor`
// below stays referentially stable across renders.
let $eee07520569aad07$var$_appWindowPagesCache = null;

























const $eee07520569aad07$var$_getAppWindowPages = (root)=>{
    if ($eee07520569aad07$var$_appWindowPagesCache) return $eee07520569aad07$var$_appWindowPagesCache;
    // Shell pages this map exposes to the AppWindow slot, resolved from the
    // live context registry instead of a sibling import (FA001, see the note
    // beside the imports above).
    const _ctxPages = root && root.context && root.context.pages || {};
    const _chatPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("jPn99")), ()=>(parcelRequire("1JtPJ")).then((m)=>m.chatHome), {
        title: (el)=>el.call('pageTitle', 'workspace.page.chat')
    });
    // Mail — the same lazy-shared-library shape as chat (the built-in email
    // client, architecture/MAIL.md): fold the mail context first, then mount
    // its home page in the AppWindow slot.
    const _mailPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("gOp2u")), ()=>(parcelRequire("li6hd")).then((m)=>m.mailHome), {
        title: (el)=>el.call('pageTitle', 'workspace.page.mail')
    });
    // Tickets is a deferred shared library (folded out of the eager sharedLibraries
    // merge in #16). Opening it in the home AppWindow PageSlot must fold its context
    // in FIRST — lazySharedLibPage, not lazyPage — else a cold AppWindow open (before
    // any direct /tickets router visit) mounts the board against an unregistered
    // tickets component set. Same _ticketsCtx the /tickets* router entries use.
    const _ticketsPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("3Py9H")), ()=>(parcelRequire("8Eobr")).then((m)=>m.myView), {
        title: (el)=>el.call('pageTitle', 'workspace.page.myTasks')
    });
    // Direct import (not el.call) — same rationale as fetchTicketsForUser above:
    // the Received/Given quick-add must create a real ticket on a COLD home
    // load, before the deferred tickets shared library has necessarily folded
    // its functions barrel into context.functions.
    //
    // Same cold-boot rationale as saveTicket above — the Notes widget's quick-
    // new-note row must create a real note on a COLD home load too.
    // Calendar is a deferred shared library (folded out of the eager sharedLibraries
    // merge in #16). Same reasoning as _ticketsPage above — the home AppWindow open
    // must fold the calendar context first via lazySharedLibPage, not a plain
    // lazyPage that would mount CalMain/CalWeekView against an unregistered set.
    const _calendarPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("iSwre")), ()=>(parcelRequire("jIVd0")).then((m)=>m.calendarHome), {
        title: (el)=>el.call('pageTitle', 'workspace.page.calendar')
    });
    // Documents is a deferred shared library (out of the eager sharedLibraries
    // merge), so opening it in the home PageSlot must fold its context in first —
    // lazySharedLibPage, not lazyPage. Same loader the '/documents' router entry
    // uses (pages/index.js).
    const _documentsPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("aNDji")), ()=>(parcelRequire("13oJx")).then((m)=>m.documentsHome), {
        title: (el)=>el.call('pageTitle', 'workspace.page.notes')
    });
    // Analytics is a deferred shared library (out of the eager sharedLibraries
    // merge), so opening it in the home PageSlot must fold its context in first —
    // lazySharedLib, not lazyPage. Its context.js carries a `.pages` map, so each
    // picks the matching lazyPage off lib.pages (same loaders the '/analytics' etc.
    // router entries use in pages/index.js). Mirrors documents' _documentsPage.
    const _analyticsCtx = ()=>(parcelRequire("e8HBd"));
    const _analyticsPage = (0, $hn2a0.lazySharedLib)(_analyticsCtx, (lib)=>lib.pages['/workspace-analytics'], {
        title: (el)=>el.call('pageTitle', 'workspace.page.workspaceAnalytics')
    });
    // Analytics sub-tab pages so the AnalyticsNavbar (Workspace/Map/Logs) tabs
    // can swap the PageSlot content in-place instead of navigating away.
    const _projectAnalyticsPage = (0, $hn2a0.lazySharedLib)(_analyticsCtx, (lib)=>lib.pages['/analytics'], {
        title: (el)=>el.call('pageTitle', 'workspace.page.analytics')
    });
    const _analyticsMapPage = (0, $hn2a0.lazySharedLib)(_analyticsCtx, (lib)=>lib.pages['/analytics/map'], {
        title: (el)=>el.call('pageTitle', 'workspace.page.analyticsMap')
    });
    const _analyticsSessionsPage = (0, $hn2a0.lazySharedLib)(_analyticsCtx, (lib)=>lib.pages['/analytics/sessions'], {
        title: (el)=>el.call('pageTitle', 'workspace.page.analyticsSessions')
    });
    // PageSlot family-host CHROME (pseudo-pages, not navigable routes): the
    // slot's family host resolves these through `_defFor` and mounts ONE per
    // family — the header/controls DOM survives every intra-family route
    // swap. Registered like any lazy analytics page so the chrome lives in
    // the analytics chunk and folds its context.
    const _analyticsChromeProjects = (0, $hn2a0.lazySharedLib)(_analyticsCtx, (lib)=>lib.pages['/analytics/__slot-chrome'], {});
    const _analyticsChromeWorkspace = (0, $hn2a0.lazySharedLib)(_analyticsCtx, (lib)=>lib.pages['/workspace-analytics/__slot-chrome'], {});
    // Logs slot pages — ALL sections, so LogsSidebar clicks swap the slot
    // in place. Only /users was registered before, which made every other
    // section a full-page navigation that tore the PageSlot down.
    const _analyticsLogsPage = (route, title)=>(0, $hn2a0.lazySharedLib)(_analyticsCtx, (lib)=>lib.pages[route], {
            title: title
        });
    const _analyticsLogsUsersPage = _analyticsLogsPage('/analytics/logs/users', (el)=>el.call('pageTitle', 'workspace.page.logsUsers'));
    const _analyticsLogsSessionsPage = _analyticsLogsPage('/analytics/logs/sessions', (el)=>el.call('pageTitle', 'workspace.page.logsSessions'));
    // Two args, not three: the extra alias-path argument used to land in the
    // `title` slot, so the pane title read as the RAW PATH (measured live
    // 2026-09-13). The alias route below maps to this same page.
    const _analyticsLogsSessionPage = _analyticsLogsPage('/analytics/logs/session', (el)=>el.call('pageTitle', 'workspace.page.logsSession'));
    // Bare logs root — redirects in-slot to /users (analytics logs/main.js).
    const _analyticsLogsRootPage = _analyticsLogsPage('/workspace-analytics/logs', (el)=>el.call('pageTitle', 'workspace.page.logs'));
    // PROJECTS-family per-session detail + bugs / events views
    // (WS-ANALYTICS-FAMILY-SPLIT-UTC-TOTALS-1): a project session drills into
    // its own family's detail, never the workspace logs chrome. Existing
    // polyglot titles — no new i18n keys.
    const _analyticsSessionPage = _analyticsLogsPage('/analytics/session', (el)=>el.call('pageTitle', 'workspace.page.logsSession'));
    // Their OWN titles — inside the home PageSlot the pane/document title
    // comes from THIS wrapper, not the package's metadata.title, so reusing
    // the Logs keys titled the projects views "… / Logs / …" (measured live
    // on dev, build 3748c22d).
    const _analyticsBugsPage = _analyticsLogsPage('/analytics/bugs', (el)=>el.call('pageTitle', 'workspace.page.analyticsBugs'));
    const _analyticsEventsPage = _analyticsLogsPage('/analytics/events', (el)=>el.call('pageTitle', 'workspace.page.analyticsEvents'));
    // Unique visitors (WS-ANALYTICS-UTM-CAMPAIGNS-UI-1 addendum) — the logs
    // Users module on the projects family, its own title.
    const _analyticsVisitorsPage = _analyticsLogsPage('/analytics/visitors', (el)=>el.call('pageTitle', 'workspace.page.analyticsVisitors'));
    const _analyticsLogsEventsPage = _analyticsLogsPage('/analytics/logs/events', (el)=>el.call('pageTitle', 'workspace.page.logsEvents'));
    const _analyticsLogsBugsPage = _analyticsLogsPage('/analytics/logs/bugs', (el)=>el.call('pageTitle', 'workspace.page.logsBugs'));
    const _analyticsLogsNetworkPage = _analyticsLogsPage('/analytics/logs/network', (el)=>el.call('pageTitle', 'workspace.page.logsNetwork'));
    const _analyticsLogsVerbosePage = _analyticsLogsPage('/analytics/logs/verbose', (el)=>el.call('pageTitle', 'workspace.page.logsVerbose'));
    // teamAndAgents: the full panzoom board for the `/team-and-agents` route
    // (openRoute below opens it in the AppWindow PageSlot). No longer embedded
    // inline in the home AgentsWidget (2026-08-12 — that widget now renders a
    // deterministic split-count numeral body instead; see AgentsWidget below).
    const _agentsPage = (0, $hn2a0.lazyPage)(()=>Promise.resolve((parcelRequire("7lWOZ"))).then((m)=>m.agents), {
        title: (el)=>el.call('pageTitle', 'workspace.page.agents')
    });
    // Remaining search-launcher destinations (2026-06-08 per Nika "all apps
    // should be opened in PageSlot") — registered here so every app in the
    // search dropdown opens inside the home AppWindow instead of routing away.
    // /studio (the dashboard project-picker surface) opens in the home PageSlot.
    // lazySharedLibPage (not lazyPage): the dashboard embeds the studios board
    // (`StudiosEmbed: {}`) and resolves studios-only components, so studios' 19
    // self-registered components (its default export, #11 Stage 2) must fold into
    // the live context BEFORE the dashboard mounts. Same shape the '/studio' router
    // entry uses (canvas/pages/index.js). Both the studios chunk (context) and the
    // dashboard chunk load on first /studio open; the eager home bundle carries
    // neither. See LAZY_PAGE_PLAN.md.
    const _studioPage = (0, $hn2a0.lazySharedLibPage)(()=>Promise.all([
            (parcelRequire("3lR5Z")),
            (parcelRequire("kLMVv"))
        ]).then(([m, f])=>({
                components: m.studiosContext.components,
                functions: {
                    ...f
                }
            })), ()=>(parcelRequire("iuCDG")).then((m)=>m.dashboard), {
        title: (el)=>el.call('polyglot', 'workspace.page.dashboard')
    });
    // meet+chat bundle-fold (2026-08-01): meet is now a lazy shared library (see
    // pages/index.js's `_meetCtx` for the full rationale) — the home AppWindow
    // PageSlot mount needs the same context-fold-then-page-load shape as the
    // router-level entry, not a bare lazyPage.
    const _meetPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("l9i79")), ()=>(parcelRequire("aKYox")).then((m)=>m.meetHome), {
        title: (el)=>el.call('pageTitle', 'workspace.page.meet')
    });
    // Admin opens inside the home AppWindow (PageSlot) too, like every other app
    // (per Nika "admin button in user dropdown should open admin in PageSlot")
    // rather than full-routing to /admin. Lazy so the admin bundle stays out of
    // the initial home chunk.
    const _adminPage = (0, $hn2a0.lazyPage)(// Import the page's SOURCE file, not the identity-index barrel — the barrel
    // statically imports all 16 admin pages, so a barrel chunk re-bundles the
    // whole admin surface where this slot needs one page (bundle-split T1;
    // pages/index.js route entries import the same source files, so chunks
    // dedupe).
    ()=>(parcelRequire("7SVpv")).then((m)=>m.admin), {
        title: (el)=>el.call('pageTitle', 'workspace.page.admin')
    });
    // Reminders opens inside the home AppWindow (PageSlot) too, like every other
    // non-canvas app — lazy so the reminders bundle stays out of the initial
    // home chunk (mirrors _adminPage).
    const _remindersPage = (0, $hn2a0.lazyPage)(()=>(parcelRequire("iyNfb")).then((m)=>m.reminders), {
        title: (el)=>el.call('pageTitle', 'workspace.page.reminders')
    });
    // History — the built-in activity timeline, in the PageSlot like the two
    // above (lazy, so its bundle stays out of the initial home chunk).
    const _historyPage = (0, $hn2a0.lazyPage)(()=>(parcelRequire("bfN28")).then((m)=>m.history), {
        title: (el)=>el.call('pageTitle', 'workspace.page.history')
    });
    const _systemHealthPage = (0, $hn2a0.lazyPage)(()=>(parcelRequire("6yR3k")).then((m)=>m.system), {
        title: (el)=>el.call('pageTitle', 'workspace.page.systemHealth')
    });
    // NOTE — the GreenIG insurance pages (/policies, /claims, /customers,
    // /transactions) are NOT statically imported here. They live in the PUBLISHED
    // v2 module (silverbreeze-labs/greenig-app) and register into
    // root.workspaceProject.pages when that workspace activates. Route resolution
    // goes through `_appPageFor(path, root)` (below), which consults the project's
    // pages before the shared `_APP_WINDOW_PAGES` — so these routes resolve ONLY in
    // the GreenIG workspace.
    // The document editor opens inside the home AppWindow too (2026-06-08 per
    // Nika "DocumentsWidget items should open in the PageSlot") — the widget
    // tiles set `#doc=<id>` + selectedPage instead of routing away.
    const _documentsEditorPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("aNDji")), ()=>(parcelRequire("1ijdV")).then((m)=>m.editor), {
        title: (el)=>el.call('pageTitle', 'workspace.page.editor')
    });
    // Project preview inside the PageSlot (2026-06-10 per Nika "open preview
    // should open workspace/preview in PageSlot"). Preview is a deferred sub-app
    // (folded out of the eager shell chunk in #16 — see workspace/context.js), so
    // opening it here must fold its context in FIRST — lazySharedLibPage, not
    // lazyPage — else a cold open (before any /preview router visit) mounts the
    // preview page against an unregistered Scene/PreviewNavbar/renderProject set.
    // Same context loader the '/preview' router entry uses (pages/index.js). The
    // pageLoader wrapper caps the standalone page's 100vw/100vh viewport sizing to
    // the sheet, and clears the preview's root-state footprint on unmount —
    // `root.data` is ALSO the canvas editor's project key, so a stale preview write
    // must not leak into the editor. Target project rides root._previewParams (+
    // ?owner/&key/&env for reload-restore); the page's own onCreate hook fetches.
    const _previewPage = (0, $hn2a0.lazySharedLibPage)(()=>(parcelRequire("hRfYg")), ()=>(parcelRequire("b9Lxc")).then((m)=>({
                ...m.main,
                width: '100%',
                height: '100%',
                onRemove: (el, s)=>{
                    // The page's own removal first (the site builder's release,
                    // preview pages/main.js) — this wrapper replaces its onRemove.
                    try {
                        if (typeof m.main.onRemove === 'function') m.main.onRemove(el, s);
                    } catch (err) {
                        console.warn('[AppWindow] preview release failed:', err);
                    }
                    try {
                        const r = s?.root || s;
                        r?.update?.({
                            data: null,
                            fetchError: null,
                            usedFallback: false,
                            resolvedEnv: null,
                            requestedEnv: null,
                            _previewParams: null
                        });
                    } catch (err) {
                        console.warn('[AppWindow] preview cleanup failed:', err);
                    }
                }
            })), {
        title: (el)=>el.call('pageTitle', 'workspace.page.preview')
    });
    const _APP_WINDOW_PAGES = {
        '/chat': _chatPage,
        '/mail': _mailPage,
        '/tickets': _ticketsPage,
        '/tickets/my': _ticketsPage,
        '/tasks': _ticketsPage,
        '/tasks/my': _ticketsPage,
        '/calendar': _calendarPage,
        '/reminders': _remindersPage,
        '/history': _historyPage,
        '/notes': _documentsPage,
        '/notes/editor': _documentsEditorPage,
        // Legacy slot values (stored prefs / old ?page= links) keep resolving.
        '/documents': _documentsPage,
        '/documents/editor': _documentsEditorPage,
        // Merged analytics surface (2026-08-08): /analytics = Projects family
        // (overview + map + logs), /workspace-analytics = Workspace usage.
        // Registered so the AnalyticsNavbar tabs + the AnalyticsHeader view
        // chips + LogsSidebar all stay inside the PageSlot.
        '/analytics/__slot-chrome': _analyticsChromeProjects,
        '/workspace-analytics/__slot-chrome': _analyticsChromeWorkspace,
        '/analytics': _projectAnalyticsPage,
        '/analytics/map': _analyticsMapPage,
        '/analytics/sessions': _analyticsSessionsPage,
        '/analytics/session': _analyticsSessionPage,
        '/analytics/visitors': _analyticsVisitorsPage,
        '/analytics/bugs': _analyticsBugsPage,
        '/analytics/events': _analyticsEventsPage,
        '/analytics/logs/users': _analyticsLogsUsersPage,
        '/analytics/logs/sessions': _analyticsLogsSessionsPage,
        '/analytics/logs/session': _analyticsLogsSessionPage,
        '/workspace-analytics/logs/session': _analyticsLogsSessionPage,
        '/analytics/logs/events': _analyticsLogsEventsPage,
        '/analytics/logs/bugs': _analyticsLogsBugsPage,
        '/analytics/logs/network': _analyticsLogsNetworkPage,
        '/analytics/logs/verbose': _analyticsLogsVerbosePage,
        '/workspace-analytics': _analyticsPage,
        // Legacy slot values (stored prefs / old ?page= links) keep resolving.
        '/workspace-analytics/map': _analyticsMapPage,
        // Every workspace logs section the LogsSidebar navigates to
        // (`/workspace-analytics/logs/<key>`) — registered HERE with an
        // object-form `{ title }` so the pane title resolves; the router
        // registry's entries (pages/index.js) carry function-form metadata,
        // which PageSlot's `_slotEntryMeta` cannot read, so a slot opened on
        // one of these showed the raw path as its title (measured live
        // 2026-09-13 on /workspace-analytics/logs/sessions).
        '/workspace-analytics/logs': _analyticsLogsRootPage,
        '/workspace-analytics/logs/users': _analyticsLogsUsersPage,
        '/workspace-analytics/logs/sessions': _analyticsLogsSessionsPage,
        '/workspace-analytics/logs/events': _analyticsLogsEventsPage,
        '/workspace-analytics/logs/bugs': _analyticsLogsBugsPage,
        '/workspace-analytics/logs/network': _analyticsLogsNetworkPage,
        '/workspace-analytics/logs/verbose': _analyticsLogsVerbosePage,
        // Through the live context (FA001, like /announcements below): the router
        // page is a string-extend of the canvas-registered `teamAndAgents`.
        '/team-and-agents': _ctxPages['/team-and-agents'],
        '/agents': _agentsPage,
        '/my-agents': _agentsPage,
        '/studio': _studioPage,
        '/preview': _previewPage,
        '/meet': _meetPage,
        '/announcements': _ctxPages['/announcements'],
        '/team-members': _ctxPages['/people'] || _ctxPages['/team-members'],
        '/system-status': _systemHealthPage,
        '/admin': _adminPage
    };
    // Only cache once the context was actually reachable — a first call made
    // before the root carries its context must not freeze the two
    // context-resolved entries as `undefined`.
    if (root && root.context) $eee07520569aad07$var$_appWindowPagesCache = _APP_WINDOW_PAGES;
    return _APP_WINDOW_PAGES;
};
// Resolve a route → page definition. The active workspace PROJECT's pages take
// precedence (so project-only routes like /policies resolve ONLY in the workspace
// whose project registered them), then the shared shell map, then — with the
// context passed (`root._slotResolve`) — the rest of the shell's registry. Pass
// `root` so the project pages are visible; without root it falls back to the
// shared map.
const $eee07520569aad07$var$_appPageFor = (path, root, ctx)=>{
    const projPages = root && root.workspaceProject && root.workspaceProject.pages;
    // Module pages resolve from the loader's LIVE wrapped map first — the
    // stash copy in root state has been through root.update's deep clone,
    // which strips the module design-system context off the def (the def
    // mounts, but every module token then resolves against the SHELL config:
    // "navy" paints the CSS keyword, "paper" drops). getModulePageDef is
    // null whenever no module is active, so non-module workspaces are
    // untouched.
    const liveGet = root && typeof root._modulePagesLiveGet === 'function' ? root._modulePagesLiveGet() : null;
    // WS-APP-PAGE-SLOT-KEEPS-MODULE-CTX-1 — the live map above holds the
    // TAKEOVER module's pages only. An INSTALLED app's (loadWorkspaceApps)
    // wrapped defs live in the shell context's `pages` bag alone, so a pane
    // opened from the home (`?page=/socials`, the navbar tab) fell through to
    // the stash copy below and mounted the app against the SHELL design system
    // and the SHELL state root (measured live 2026-09-23, system/socials-app:
    // the pane's designSystem === the shell's, `s.root.shell` undefined; the
    // same app opened from /studio carried its own). Only a def that CARRIES a
    // module context is taken from the bag — a plain shell page keeps the
    // precedence below exactly as it was.
    // WS-APP-OPEN-SLOT-PLACEHOLDER-1 — so is an installed app's OPENING
    // placeholder (before its setup): rendering it is what sets the app up, and
    // it then takes the real page itself. The stash copy mounted the app's raw
    // page against the shell design system and never set the app up. The loader
    // marks its placeholder with this registered symbol (workspaceProjects.js
    // _appOpeningPage; non-enumerable, so no clone or spread carries it).
    const ctxPage = path && ctx && ctx.pages ? ctx.pages[path] : null;
    const ctxOpening = !!ctxPage && !!ctxPage[Symbol.for('symbols.workspace.appOpening')];
    // LAST, every other route of the shell's registry: the page the PageSlot
    // mounts for it anyway (canvas PageSlot `_defFor`, its `context.pages`
    // tier). Without this tier the home OPENED routes it could not NAME: the
    // loader's ?page= restore (workspaceProjects.js _restorePageParam) and the
    // pane both took `/apps` from the bag, while the URL sync (PageSlot
    // `_writeSlotUrl` / `_syncSlotFromUrl`, which ask only this resolver) called
    // it unresolvable — so `?page=/apps` left the address bar the moment the
    // pane opened, and a reload or a Back to that entry lost the pane (dev
    // 2026-10-24, the PM close-audit note on WS-SHELL-APP-ROUTES-NO-MAIN-
    // LANDMARK-1). Last, so a plain bag page never changes the precedence above.
    return path && liveGet && liveGet[path] || path && (0, $7ytvD.getModulePageDef)(path) || (ctxPage && (ctxPage.context || ctxOpening) ? ctxPage : null) || path && projPages && projPages[path] || $eee07520569aad07$var$_getAppWindowPages(root)[path] || ctxPage || undefined;
};
const $eee07520569aad07$export$722e86335be9cdf0 = $eee07520569aad07$var$_appPageFor;
// The first name the greeting addresses. A member with no name yields '' — the
// greeting then reads WITHOUT a name. It used to fall back to the English word
// "there", so a Georgian board read "დილა მშვიდობისა, there".
const $eee07520569aad07$var$_shellFirstName = (name)=>String(name || '').trim().split(/\s+/)[0] || '';
// The bundle key of the greeting's lead-in for an hour of the day. With a name
// the lead-in carries its own separator ("Good morning, ") and the name follows
// in its own span; without one the greeting is the lead-in alone. Literal keys
// only — a key built by concatenation is invisible to grep and to the key gates.
//
// THE HOUR LAW (HOME_SIGNALS_CONTRACT §4; Nika 2026-09-28: "Good evening" at
// 02:20 is wrong; night pick B): 05:00–11:59 morning, 12:00–17:59 afternoon,
// 18:00–21:59 evening, 22:00–04:59 the night line — "Hello, {name}" /
// "გამარჯობა, {name}", never "Good evening" after 22:00 or before 05:00.
const $eee07520569aad07$var$_greetLeadKey = (hour, hasName)=>{
    if (hour >= 5 && hour < 12) return hasName ? 'workspace.home.greet.morning' : 'workspace.home.greet.morningNoName';
    if (hour >= 12 && hour < 18) return hasName ? 'workspace.home.greet.afternoon' : 'workspace.home.greet.afternoonNoName';
    if (hour >= 18 && hour < 22) return hasName ? 'workspace.home.greet.evening' : 'workspace.home.greet.eveningNoName';
    return hasName ? 'workspace.home.greet.night' : 'workspace.home.greet.nightNoName';
};
// (The greeting's one-sentence summary — _greetingFacts / _greetingSummaryRuns
// and their readiness and today's-events helpers — became the SIGNALS of
// HOME_SIGNALS_CONTRACT v1, 2026-09-28: functions/homeSignals.js collects them
// from the built-in apps and every installed app, and the sub-line and the
// summary render from functions/homeSummaryCompose.js.)
// The ?page=<route> restore-param name the home reads on load. The shell PageSlot
// owns writing/clearing it while a slot is open; this constant stays here because
// the home onCreate + workspaceProjects.js restore sites look it up by this name.
const $eee07520569aad07$var$APP_WINDOW_URL_PARAM = 'page';
// (_greetingFor removed 2026-09-24 — never called; the Greeting card's
// GreetLead reads workspace.home.greet.* for the same three day parts.)
// (_dayCockpit + _cockpitBody removed 2026-06-06 — the last cockpit
// tiles, Open tickets + Unread, left the home grid per Nika.)
// Open tickets ASSIGNED TO the current user. Used by the "Received
// tasks" widget — the count + a short list of the most-recent rows
// so the user sees what's on their plate without opening /tickets.
// "Open" excludes the canonical resolved/cancelled state labels.
const $eee07520569aad07$var$_DONE_TICKET_STATES = new Set([
    'done',
    'closed',
    'resolved',
    'cancelled',
    'archived'
]);
const $eee07520569aad07$var$_isOpenTicket = (t)=>!$eee07520569aad07$var$_DONE_TICKET_STATES.has(String(t?.state || t?.status || '').toLowerCase());
const $eee07520569aad07$var$_ticketEmail = (t, field)=>String(t?.[field] || t?.[field === 'assigneeEmail' ? 'assignee_email' : 'reporter_email'] || '').toLowerCase();
// Widget data source — root._userTickets is a DEDICATED key written only
// by _ensureHomeTickets (assigned ∪ reported). The widgets originally read
// the shared board cache root.tickets, but several async boot writers race
// over it (loadPrivateData's workspace-change handler wipes it to [] after
// auth resolves), so the widgets randomly showed "You're clear" depending
// on whether the wipe landed before or after the cold-home load. Fall back
// to the board cache only while the dedicated key hasn't loaded yet.
const $eee07520569aad07$var$_widgetTickets = (root)=>{
    if (Array.isArray(root?._userTickets) && root._userTickets.length) return root._userTickets;
    return Array.isArray(root?.tickets) ? root.tickets : [];
};
// FALSE-EMPTY-HOME-RECEIVED-GIVEN-LOADING-1 — the ONE place a widget turns
// a ticket set into a number, so the Received / Given render sites carry no
// raw `.length` a load-state pin cannot see. The number alone never decides
// a body: `homeTicketListState` does (functions/homeLoadState.js).
const $eee07520569aad07$var$_ticketCount = (rows)=>rows.length;
const $eee07520569aad07$var$_receivedTickets = (root)=>{
    const me = (root?.currentUserEmail || '').toLowerCase();
    if (!me) return [];
    return $eee07520569aad07$var$_widgetTickets(root).filter((t)=>$eee07520569aad07$var$_isOpenTicket(t) && $eee07520569aad07$var$_ticketEmail(t, 'assigneeEmail') === me);
};
// Open tickets the current user CREATED (and assigned to someone
// else). The "Given tasks" widget surfaces these so a project lead
// can glance at what they've delegated.
const $eee07520569aad07$var$_givenTickets = (root)=>{
    const me = (root?.currentUserEmail || '').toLowerCase();
    if (!me) return [];
    return $eee07520569aad07$var$_widgetTickets(root).filter((t)=>{
        if (!$eee07520569aad07$var$_isOpenTicket(t)) return false;
        const reporter = $eee07520569aad07$var$_ticketEmail(t, 'reporterEmail');
        if (reporter !== me) return false;
        const assignee = $eee07520569aad07$var$_ticketEmail(t, 'assigneeEmail');
        // Skip self-assigned rows so the count reads as "delegated work".
        return assignee && assignee !== me;
    });
};
// S8 (NIKA BATCH 2026-08-16) — TeamPulseWidget's bucket grouping. Nika:
// "I like how our board-status py script looks — we need a few new builtin
// widgets for workspace default that show similar summaries." Takes the
// PROPERTIES that make that script readable (tickets/data/board-status.py
// bar()), not its ASCII: a proportional bar over LIVE work only, fixed-width
// count cells, a legend naming who can act. Four buckets, not the model's
// full 8-state enum — a home widget summarizes, it doesn't replace the
// board.
// `label` carries a BUNDLE KEY; the legend's own render site resolves it.
const $eee07520569aad07$var$_PULSE_BUCKETS = [
    {
        key: 'todo',
        label: 'workspace.pulse.todo',
        hue: 'blue'
    },
    {
        key: 'active',
        label: 'workspace.pulse.active',
        hue: 'orange'
    },
    {
        key: 'review',
        label: 'workspace.pulse.review',
        hue: 'purple'
    },
    {
        key: 'blocked',
        label: 'workspace.pulse.blocked',
        hue: 'red'
    }
];
const $eee07520569aad07$var$_pulseBucket = (t)=>{
    const key = String(t?.state || t?.columnKey || '').toLowerCase();
    if (key === 'blocked') return 'blocked';
    if (key === 'ready_to_review' || key === 'ready_to_test' || key === 'review') return 'review';
    if (key === 'in_progress' || key === 'progress') return 'active';
    if (key === 'done' || key === 'released' || key === 'cancelled' || key === 'closed') return null;
    return 'todo';
};
// Counts over every OPEN ticket in the workspace (not just "assigned to
// me" — that distinction is what separates this from Received/Given).
const $eee07520569aad07$var$_workspacePulse = (root)=>{
    const counts = {
        todo: 0,
        active: 0,
        review: 0,
        blocked: 0
    };
    for (const t of $eee07520569aad07$var$_widgetTickets(root)){
        if (!$eee07520569aad07$var$_isOpenTicket(t)) continue;
        const b = $eee07520569aad07$var$_pulseBucket(t);
        if (b) counts[b] += 1;
    }
    return counts;
};
// Largest-remainder allocation over `total` proportional segments — same
// algorithm as board-status.py's own `bar()`, so a bucket with ANY tickets
// never rounds down to a zero-width segment (a 1-in-40 bucket disappearing
// would misreport "nothing blocked" when one ticket genuinely is).
// Bucket-agnostic (S8 second pass): the allocator, the priority buckets and
// the workload grouping all live in `functions/homeSummary.js` as pure,
// directly-testable functions. The page keeps the DATA PLUMBING (which
// tickets are loaded, which count as open); the module keeps the
// arithmetic, so "never round a non-empty bucket to zero" has exactly one
// implementation shared by all three summary widgets.
const $eee07520569aad07$var$_pulseBarSegments = (counts, totalUnits)=>(0, $2zU0i.barSegments)($eee07520569aad07$var$_PULSE_BUCKETS, counts, totalUnits);
// Open rows the summary widgets share — one filter, three widgets.
const $eee07520569aad07$var$_openWidgetTickets = (root)=>$eee07520569aad07$var$_widgetTickets(root).filter($eee07520569aad07$var$_isOpenTicket);
const $eee07520569aad07$var$_workspacePriorityMix = (root)=>(0, $2zU0i.priorityMix)($eee07520569aad07$var$_openWidgetTickets(root));
const $eee07520569aad07$var$_workloadRows = (root)=>(0, $2zU0i.workloadRows)($eee07520569aad07$var$_openWidgetTickets(root), (t)=>$eee07520569aad07$var$_ticketEmail(t, 'assigneeEmail'));
// Cold-home loader for the Received / Given widgets. Those widgets read
// `root.tickets`, which is the board cache — only populated after the
// user has visited a /tickets board this session. On a cold home load it
// is empty, so both widgets rendered "Nothing assigned" / "Nothing
// delegated" even when the user has open work. Fetch the user's assigned
// + reported tickets once here. `currentUserEmail` is set asynchronously
// by auth, so wait briefly for it; skip entirely if the board cache is
// already populated (don't clobber a full board the user just loaded).
// ⚠️ Takes the ELEMENT as well as root (FALSE-ZERO-HOME-NON-AGENT-KEYS-1):
// `fetchTicketsForUser` resolves the SDK through `el.call('getSDK')`, and
// this loader used to hand it `root` — so every Home call threw
// "el.call is not a function", the loader swallowed it into `[]`, and
// `_userTickets` was never written on any cold Home load. Measured live on
// `/w/system/hq` 2026-08-21 the moment the error key existed to show it.
const $eee07520569aad07$var$_ensureHomeTickets = async (el, root, { force: force = false } = {})=>{
    if (!el || !root) return;
    if (root._homeTicketsLoaded && !force) return;
    root._homeTicketsLoaded = true;
    // Wait for BOTH the auth email AND the workspace scope. The tickets list
    // resolves its REQUIRED workspaceId from the SDK's ambient context
    // (mirrored from root.workspace by the auth subscription) — on a cold
    // first boot (e.g. right after the demo startDemo reload) the fetch used
    // to fire before the scope landed, 400 with workspace_id_required, and the
    // one-shot gate swallowed the empty result: "Received tasks" showed
    // "You're clear" even though tickets WERE assigned, until a manual reload.
    let email = root.currentUserEmail || '';
    let wsId = root.workspace?.id || null;
    if (!email || !wsId) await new Promise((resolve)=>{
        let n = 0;
        const iv = setInterval(()=>{
            email = root.currentUserEmail || '';
            wsId = root.workspace?.id || null;
            if (email && wsId || ++n > 30) {
                clearInterval(iv);
                resolve();
            }
        }, 200);
    });
    if (!email) {
        root._homeTicketsLoaded = false;
        return;
    }
    let rows;
    try {
        rows = await (0, $2rYsV.fetchTicketsForUser)(el, email, 100, {
            throwOnError: true
        });
    } catch (err) {
        // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — record the failure instead of
        // swallowing it: `_homeTicketsError` is what lets the Temo caption
        // render "Couldn’t load tickets" rather than a confident "Standing by".
        // The gate re-opens so the next onUpdate / Refresh retries.
        root._homeTicketsLoaded = false;
        root.update({
            _homeTicketsError: err && err.message || el.call('polyglot', 'workspace.home.error.tickets')
        });
        return;
    }
    if (!rows.length && !wsId) {
        // Nothing came back while the workspace scope was still unresolved —
        // that's the 400-race, not a real empty state. Re-open the gate so the
        // next onUpdate retries once the scope lands, and write NOTHING:
        // `_userTickets` stays `null` ("not read yet"), never `[]`.
        root._homeTicketsLoaded = false;
        return;
    }
    // Always write — `[]` with a resolved scope is a real, verified zero
    // (FALSE-ZERO-HOME-NON-AGENT-KEYS-1), not a dropped read.
    const patch = {
        _userTickets: rows,
        _homeTicketsError: null
    };
    // #2323 — also seed myTickets so the home AgentsWidget status shows a
    // non-zero count on a cold home load. ONLY the assigned-to-me subset though: myTickets
    // feeds My View's buckets, which assume assigned-only — the earlier
    // version pushed the full assigned∪reported union in, so tickets you
    // DELEGATED to others briefly appeared in your own buckets. And only when
    // myTickets is still empty, so a fresher page-owned fetch is never
    // clobbered.
    if (!(Array.isArray(root.myTickets) && root.myTickets.length)) {
        const me = email.toLowerCase();
        patch.myTickets = rows.filter((t)=>String(t.assigneeEmail || t.assignee_email || '').toLowerCase().includes(me));
    }
    root.update(patch);
};
// PRESENCE-ZERO-1 (tickets/opus.md) — the "Active right now" widget (+ its
// AppAnalyticsWidget mirror + the Watcher agent status) must report WORKSPACE
// presence ("Who's on the workspace today"), not Projects/site-visitor
// analytics. `loadAnalyticsData` (the generic Projects-family loader
// analytics/functions/loadAnalyticsData.js) resolves an EMPTY project scope
// on Home (no `_analyticsProjectKey`/`_analyticsParams` are ever set here) to
// `excludeProjectId: 'workspace'` — the 2026-08-11 surface-division filter
// that deliberately hides the shell's own dogfood telemetry from the Projects
// dashboard's "All projects" view. That is exactly backwards for a widget
// whose only traffic IS the shell's own telemetry: it pinned this widget at
// 0/0 in every internal/dogfood session, while /workspace-analytics
// (analytics/pages/main.js `_loadWorkspaceMetrics`) queries the SAME
// `analyzed.now`/`activeUsers` rollups scoped `projectId: 'workspace'` and
// reported the true, non-zero count — two surfaces, same underlying
// analyzed-session collection, disagreeing purely on `projectId` filter
// form (verified live: GET /core/analyzed/now?projectId=workspace →
// usersNow:1 vs ?excludeProjectId=workspace → usersNow:0, same moment).
// Fixed by scoping identically to /workspace-analytics and writing to a
// DEDICATED key (`_homeWorkspaceActivity`, not the shared `root._analytics`
// the Projects page also writes) so the two surfaces' scopes can never
// collide again.
const $eee07520569aad07$var$_loadHomeWorkspaceActivity = (el, root)=>{
    if (!el?.sdk?.execute || !root) return;
    el.sdk.execute('analyzed', 'now', {
        filter: {
            projectId: 'workspace'
        }
    }).then((res)=>{
        // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — an ABSENT field is `null`, never
        // a well-formed 0 (`Number(undefined) || 0` was the data-layer half of
        // the false zero); a missing payload is a failed read, not a quiet
        // workspace. Always write, so the widget can leave its skeleton.
        if (!res) {
            root.update({
                _homeWorkspaceActivityError: el.call('polyglot', 'workspace.home.error.workspaceActivityEmpty')
            });
            return;
        }
        root.update({
            _homeWorkspaceActivity: {
                usersNow: (0, $eOUFv.homeActivityMetric)(res.usersNow ?? res.users_now),
                usersToday: (0, $eOUFv.homeActivityMetric)(res.usersToday ?? res.users_today)
            },
            _homeWorkspaceActivityError: null
        });
    }).catch((err)=>{
        console.warn('[home] workspace-activity load failed:', err && err.message);
        root.update({
            _homeWorkspaceActivityError: err && err.message || el.call('polyglot', 'workspace.home.error.workspaceActivity')
        });
    });
};
// FALSE-ZERO-1 (residual, 2026-08-20) — Home's OWN agent-roster producer.
//
// Measured live on `/w/system/hq`: `root._agents` stayed `undefined`
// forever. The tri-state contract (`shared/state.js:142-147`) is written by
// exactly two producers, and NEITHER runs on Home — the shared one lives in
// the Simone mention composer (`shared/_simone/Chat.js` ensureAgentRoster,
// mounts only when the picker opens) and the other on the /team-and-agents
// canvas page. So every Home consumer sat permanently in the `loading`
// branch: the already-fixed "AI agents" numeral rendered a permanent `–`,
// and the unfixed ones rendered a confident wrong number instead.
//
// A consumer cannot fix that. A surface that must distinguish
// loading / loaded / failed needs a producer that actually runs on it, so
// Home gets one — the same one-shot `_agentsLoaded` gate the shared
// producer uses (so the two can never double-fetch), the same SDK call, and
// the same row shape the contract owner writes, so Home, Simone and the
// canvas roster can never disagree about what an agent is.
const $eee07520569aad07$var$_loadHomeAgentRoster = (el, root)=>{
    if (!root || root._agentsLoaded) return;
    const sdk = el && el.sdk;
    const orgId = root.jwtClaims && root.jwtClaims.workspace_org_id;
    if (!sdk || typeof sdk.listAgents !== 'function' || !orgId) return;
    root._agentsLoaded = true;
    Promise.resolve(sdk.listAgents(orgId)).then((raw)=>{
        const list = Array.isArray(raw) ? raw : raw && raw.data || [];
        const agents = list.map((u)=>({
                id: String(u.username || u.id || u._id || '').toLowerCase(),
                name: u.name || u.username || el.call('polyglot', 'workspace.agents.fallbackName'),
                kind: 'agent',
                avatar: u.avatar || null,
                userId: u.id || u._id || null,
                email: u.email || null,
                // the per-language names of a server-seeded agent (the contract's
                // shape, shared/_simone/mention.js agentsFromMongo): the chat's
                // @-mention picker shows "პირადი ასისტენტი" in a Georgian UI
                nameI18n: u.metadata && u.metadata.nameI18n || null
            })).filter((a)=>a.userId);
        // Always write — `[]` is a real, verified zero, not a dropped read.
        root.update({
            _agents: agents,
            _agentsError: null
        });
    }).catch((err)=>{
        // Record the failure instead of swallowing it: `_agentsError` is what
        // lets a consumer render `!` rather than a confident `0`.
        root._agentsLoaded = false;
        root.update({
            _agentsError: err && err.message || el.call('polyglot', 'workspace.home.error.agents')
        });
    });
};
// Re-run every home dashboard data loader in place — the cold-load prefetch in
// onCreate AND the "Refresh" context-menu action both route through here so the
// two can never drift. Analytics (SWR, 30s freshness), the Received / Given /
// ticket widgets, the chat-channel sidebar list, and the Projects widget each
// refetch from the server and repaint reactively; nothing reloads the page.
// `force` bypasses _ensureHomeTickets's one-shot gate — the menu passes
// force:true; the cold onCreate path leaves it self-gating (force:false).
const $eee07520569aad07$var$_refreshHomeData = (el, root, { force: force = false } = {})=>{
    if (!el || !root) return;
    $eee07520569aad07$var$_loadHomeWorkspaceActivity(el, root);
    // Roster feeds AppTeamWidget's combined count, the AgentsWidget share bar
    // and its avatar row. `force` re-arms the one-shot gate so the
    // context-menu Refresh actually refetches it (FALSE-ZERO-1).
    if (force) root._agentsLoaded = false;
    $eee07520569aad07$var$_loadHomeAgentRoster(el, root);
    // Context-menu "Refresh" (force) refetches EVERYTHING the widgets read —
    // the old pass covered analytics/tickets/channels/projects but left the
    // roster + notification badge stale, which read as "refresh does nothing"
    // on people-facing widgets (2026-07-25 per Nika "fix refresh
    // functionality").
    if (force && el.sdk) {
        $eee07520569aad07$var$invalidateOrgMembers();
        $eee07520569aad07$var$shellListOrgMembers(el.sdk, root.workspace?.id ? String(root.workspace.id) : null).then((rows)=>{
            if (!rows) return;
            const all = rows.map((0, $jZ5ZE._person));
            root.update({
                peopleAll: all,
                people: all,
                peopleLoaded: true,
                peopleError: null
            });
        }).catch((err)=>{
            console.warn('[home] roster refresh failed:', err && err.message);
            root.update({
                peopleError: err && err.message || el.call('polyglot', 'workspace.home.error.members')
            });
        });
        (0, $bShA0.fetchOrgNotifCount)(root).catch((err)=>console.warn('[home] notif refresh failed:', err && err.message));
    }
    // Populate root._userTickets for the Received / Given widgets (see
    // _ensureHomeTickets). Fire-and-forget; it self-gates unless forced.
    if (force) root._homeTicketsLoaded = false;
    $eee07520569aad07$var$_ensureHomeTickets(el, root, {
        force: force
    }).catch((err)=>console.warn('[home] tickets load failed:', err && err.message));
    if (el.sdk?.execute) el.sdk.execute('workspaceProject.chat', 'list', {}).then((res)=>{
        const rows = Array.isArray(res) ? res : res?.data || [];
        // Full rowToChannel shape + workspace scoping. The old minimal
        // mapping ({id,name,kind,is_private}) STRIPPED workspaceId, which
        // made filterChannelsToActiveWorkspace fail open downstream — after
        // a home load, every cross-workspace channel from the server's
        // membership union showed in the chat sidebar and Messenger list
        // (the "Symbols chats visible in aihouse" leak, 2026-07-12).
        root.update({
            channels: (0, $4CrGc.filterChannelsToActiveWorkspace)((Array.isArray(rows) ? rows : []).map((0, $4CrGc.rowToChannel)), (0, $4CrGc.getActiveWorkspaceId)(root))
        });
    }).catch((err)=>console.warn('[home] channels load failed:', err && err.message));
    const orgId = root?.jwtClaims?.workspace_org_id || root?.orgs && root.orgs[0]?.id;
    const orgs = root?.jwtClaims?.orgs || root?.orgs || [];
    const orgSlug = orgs.find((o)=>o.id === orgId)?.slug;
    if (orgSlug && el.sdk?.getProjects) {
        // THE APP SPLIT (docs/APP_SPLIT.md): the widget below keeps websites only;
        // the AI-app and App Store ids tell a workspace app the list cannot.
        try {
            el.call('loadProjectKindSignals');
        } catch (_) {}
        el.sdk.getProjects({
            owner: orgSlug,
            limit: 500
        }).then((res)=>{
            const raw = Array.isArray(res) ? res : res?.data || res?.items || [];
            root.update({
                _projectsForActiveOrg: raw
            });
        }).catch((err)=>console.warn('[home] getProjects failed:', err && err.message));
    }
};
// Compact column/state label for the ticket-row pill below — a tiny LOCAL
// map (not a cross-package el.call into the tickets library's own
// formatStateLabel) so Received/Given render correctly on a COLD home load,
// before the deferred tickets shared library has necessarily folded its
// functions barrel into context.functions. Same defensive reasoning as
// fetchTicketsForUser/saveTicket being direct ESM imports above. Ink-only
// (design-direction.md §6): the pill is a neutral wash + this label text,
// never a second accent hue riding on top of the widget's own poster.
// Values are BUNDLE KEYS — the pill's render site resolves them, and the
// suffix-derived fallback in `_ticketPillLabel` passes through polyglot
// verbatim because polyglot returns a non-key unchanged.
const $eee07520569aad07$var$_TICKET_STATE_LABEL = {
    not_started: 'workspace.ticketState.backlog',
    backlog: 'workspace.ticketState.backlog',
    unsynced: 'workspace.ticketState.backlog',
    draft: 'workspace.ticketState.draft',
    todo: 'workspace.ticketState.todo',
    in_progress: 'workspace.ticketState.inProgress',
    blocked: 'workspace.ticketState.blocked',
    awaiting_approval: 'workspace.ticketState.awaitingApproval',
    ready_to_review: 'workspace.ticketState.inReview',
    review: 'workspace.ticketState.inReview',
    ready_to_test: 'workspace.ticketState.readyToTest',
    done: 'workspace.ticketState.done',
    released: 'workspace.ticketState.released',
    cancelled: 'workspace.ticketState.cancelled',
    closed: 'workspace.ticketState.cancelled'
};
const $eee07520569aad07$var$_ticketPillLabel = (t)=>{
    const key = String(t?.state || t?.columnKey || '').toLowerCase();
    if (!key) return '';
    if ($eee07520569aad07$var$_TICKET_STATE_LABEL[key]) return $eee07520569aad07$var$_TICKET_STATE_LABEL[key];
    return key.replace(/_/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase());
};
// Render a single ticket row inside Received / Given widgets. Each
// child is a raw DOMQL definition (no childExtends:'AppListItem') so
// onClick can write `selectedTicket` instead of routing — clicking a
// row sets the AppWindow PageSlot to the matching tickets sub-route
// (so TicketsDetailModal mounts at the page root) AND seeds
// selectedTicket on the same tick, so the modal pops with that row's
// body without the user having to scroll-and-pick from a list.
//
// `counterpartEmail` is the person shown (avatar + name) — for Received
// that's the reporter (who assigned this to me), for Given that's the
// assignee (who I assigned this to): in both cases the OTHER party, since
// showing the viewer's own avatar on every row would be zero information.
// `hue` is the caller's own `homeWidgetSurfaceHue(root, 'received'|'given')`
// result — passed in (not recomputed here) so the row's ink stays the CARD's
// ink rather than the adaptive 'title'/'caption' tokens the row used before:
// those flip with the shell theme while a picked card colour does not, which
// is the exact near-invisible-in-dark-theme bug class already fixed for
// CityMemberRow/UpcomingEventCard (2026-08-12).
// ⚠️ `hue` is NULLABLE since 2026-09-02 (the board's default is one neutral
// solid; a colour is the user's opt-in), so every read below carries the
// adaptive-neutral fallback the row used before posters existed. The callers
// build this inside a `children:` factory, so it is already re-resolved on
// every root update — no extra reactivity is needed here.
const $eee07520569aad07$var$_ticketRowChild = (t, surfacePage, counterpartEmail, hue)=>({
        scope: {
            t: t,
            hue: hue
        },
        tag: 'button',
        type: 'button',
        flow: 'x',
        gap: 'A',
        align: 'center',
        round: 'radiusCard',
        padding: 'Z A',
        textAlign: 'left',
        cursor: 'pointer',
        color: hue && hue.ink || 'title',
        background: 'transparent',
        border: 'none',
        width: '100%',
        transition: '160ms defaultBezier background',
        ':hover': {
            background: hue && hue.wash || 'hover'
        },
        onClick: (e, el)=>{
            e.preventDefault();
            // Show the shell-root TicketsDetailModal by setting its stateKey
            // carrier directly (2026-06-08 perf fix) — NOT through
            // @symbo.ls/windows openModal, which re-prepared the whole
            // ~4,000-line component on every open and froze the UI 15–40s. The
            // modal is mounted once at the shell root (workspace/app.js) and
            // shows reactively on selectedTicket. `surfacePage` is unused here;
            // it stays in the factory args for forward-compat.
            const root = el.state?.root || el.getRoot?.()?.state?.root || el.getRoot?.()?.state;
            root?.update?.({
                selectedTicket: t
            });
        },
        Avatar: {
            avatarType: 'initials',
            boxSize: 'C C',
            flexShrink: '0',
            src: (el, s)=>el.call('avatarUrl', counterpartEmail || t.title)
        },
        Body: {
            flow: 'y',
            gap: 'V',
            flex: '1',
            minWidth: '0',
            TitleRow: {
                flow: 'x',
                align: 'center',
                gap: 'V',
                Title: {
                    tag: 'span',
                    flex: '1',
                    minWidth: '0',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: hue && hue.ink || 'title',
                    // Primary text wraps — never an ellipsis (the home quality law).
                    overflowWrap: 'anywhere',
                    text: (el)=>el.scope.t.title || el.call('polyglot', 'workspace.ticket.untitled')
                },
                // Column pill — ink-wash + the column/state label text, never a
                // second accent hue on this poster (see _ticketPillLabel above).
                Pill: {
                    hide: !$eee07520569aad07$var$_ticketPillLabel(t),
                    tag: 'span',
                    flexShrink: '0',
                    fontSize: 'Y2',
                    fontWeight: '700',
                    lineHeight: '1',
                    padding: 'V Y',
                    round: 'radiusPill',
                    color: hue && hue.ink || 'title',
                    background: hue && hue.fill || 'overlay',
                    whiteSpace: 'nowrap',
                    text: (el)=>el.call('polyglot', $eee07520569aad07$var$_ticketPillLabel(el.scope.t))
                }
            },
            Caption: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y',
                lineHeight: '1.4',
                color: hue && hue.inkSoft || 'caption',
                overflowWrap: 'anywhere',
                text: counterpartEmail ? counterpartEmail.split('@')[0] : ''
            }
        }
    });
// Shared quick-add row for Received/Given — 'received' self-assigns so the
// new row appears in THAT SAME widget immediately (a personal quick task);
// 'given' has no assignee yet (a delegated task is meaningless without one)
// so it opens the real ticket detail modal right after create, reusing the
// existing, proven detail-modal dispatch instead of inventing a bespoke
// inline assignee picker.
// `hueId` is the WIDGET ID this row lives in ('received' / 'given'), not a
// resolved hue object: unlike `_ticketRowChild` above this row is built ONCE,
// at page-definition time, so a resolved object baked here could never
// repaint when the user picks or clears the widget's colour (2026-09-02).
// Every paint prop below resolves it per render instead.
const $eee07520569aad07$var$_taskQuickAddRow = (kind, hueId)=>({
        scope: {
            kind: kind,
            hueId: hueId
        },
        flow: 'x',
        gap: 'V',
        align: 'center',
        flexShrink: '0',
        Input: {
            flex: '1',
            minWidth: '0',
            minHeight: 'controlHCompact',
            round: 'radiusControl',
            fontSize: 'Z1',
            padding: '0 Z1',
            background: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, el.scope.hueId) || {}).fill || 'overlay',
            border: 'none',
            color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, el.scope.hueId) || {}).ink || 'title',
            aria: {
                label: (el)=>el.call('polyglot', el.scope.kind === 'given' ? 'workspace.home.quickAdd.delegateAria' : 'workspace.home.quickAdd.addAria')
            },
            placeholder: (el)=>el.call('polyglot', el.scope.kind === 'given' ? 'workspace.home.quickAdd.delegatePlaceholder' : 'workspace.home.quickAdd.addPlaceholder'),
            value: (el, s)=>s.root?.[el.scope.kind === 'given' ? '_givenQuickAdd' : '_receivedQuickAdd'] || '',
            onClick: (e)=>e.stopPropagation(),
            onInput: (e, el, s)=>s.root.update({
                    [el.scope.kind === 'given' ? '_givenQuickAdd' : '_receivedQuickAdd']: e.target.value
                }),
            onKeydown: (e, el, s)=>{
                e.stopPropagation();
                if (e.key !== 'Enter') return;
                e.preventDefault();
                $eee07520569aad07$var$_submitTaskQuickAdd(el, s.root, el.scope.kind);
            }
        },
        AddBtn: {
            tag: 'button',
            type: 'button',
            class: 'gs-no-drag',
            flexShrink: '0',
            background: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, el.scope.hueId) || {}).ink || 'title',
            // The label sits ON the ink fill, so it must be the ink's counterpart:
            // the colour's own bg on a picked colour, `title-reversed` on the
            // neutral card where the fill is `title`.
            color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, el.scope.hueId) || {}).bg || 'title-reversed',
            border: 'none',
            minHeight: 'controlHCompact',
            round: 'radiusPill',
            padding: '0 Z',
            fontSize: 'Z1',
            fontWeight: '700',
            cursor: 'pointer',
            transition: '120ms defaultBezier opacity',
            ':hover': {
                opacity: '.85'
            },
            ':disabled': {
                opacity: '.4',
                cursor: 'not-allowed'
            },
            disabled: (el, s)=>!(s.root?.[el.scope.kind === 'given' ? '_givenQuickAdd' : '_receivedQuickAdd'] || '').trim(),
            text: kind === 'given' ? '{{ workspace.home.quickAdd.delegate | polyglot }}' : '{{ workspace.home.quickAdd.add | polyglot }}',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                $eee07520569aad07$var$_submitTaskQuickAdd(el, s.root, el.scope.kind);
            }
        }
    });
// Orchestrates the quick-add: read the draft, clear it, create via the
// registered `saveTicket` (imported directly above — same cold-boot
// rationale as fetchTicketsForUser), then append the real row straight into
// `root._userTickets` (the widgets' OWN dedicated cache — saveTicket/
// _applyServerTicketPatch only ever touch root.tickets/selectedTicket/
// myTickets, never this cache) so the new task is visible immediately with
// no extra refetch. 'given' rows carry no assignee yet, so they open the
// real ticket detail modal right after create — completing the delegation
// there reuses the exact same, already-proven UI the row click above does.
const $eee07520569aad07$var$_submitTaskQuickAdd = async (el, root, kind)=>{
    if (!root) return;
    const key = kind === 'given' ? '_givenQuickAdd' : '_receivedQuickAdd';
    const title = (root[key] || '').trim();
    if (!title) return;
    const me = root.currentUserEmail || '';
    root.update({
        [key]: ''
    });
    const payload = {
        title: title,
        columnKey: 'backlog',
        reporterEmail: me
    };
    if (kind === 'received') payload.assigneeEmail = me;
    try {
        const id = await (0, $jgMXB.saveTicket).call(el, payload);
        if (!id) throw new Error('create returned no id');
        const created = {
            ...payload,
            id: id,
            key: id,
            state: 'not_started',
            assigneeEmail: payload.assigneeEmail || null
        };
        root.update({
            _userTickets: [
                ...root._userTickets || [],
                created
            ]
        });
        if (kind === 'given') root.update({
            selectedTicket: created
        });
    } catch (err) {
        console.warn('[home] quick-add task failed:', err && err.message);
        root.update({
            [key]: title
        });
        el.call('openNotification', {
            type: 'error',
            title: el.call('polyglot', 'workspace.home.quickAdd.taskFailed'),
            message: err && err.message || el.call('polyglot', 'workspace.home.tryAgain')
        });
    }
};
// Canonical row shape for the Home dashboard's two Notes-widget fetches
// (AppDocumentsWidget + DocumentsWidget below). Mirrors `documentsFetch`'s
// shape (`documents/functions/index.js`) field-for-field — SAME `from: 'docs'`
// query, so both widgets share that fetch's cache key/`~/documents` root-state
// slot whenever `/notes` mounts inline in the Home AppWindow PageSlot.
// `updatedAt` stays the RAW server ISO string deliberately (DATE-FMT-1): the
// bug was two DIFFERENT per-callsite transforms racing to write that shared
// slot, one of which pre-formatted the date and one of which didn't — a
// single shared mapper removes the shape drift, and every render site reads
// this raw value through the shared `shortDate` formatter (DocumentsList's
// Caption below) instead of re-formatting it at fetch time.
//
// `title` is the RAW title — '' for an untitled document, never a placeholder
// word. The row is DATA: the home tile writes `#note=<id>`, the documents editor
// seeds `editorDoc.title` from it and saveNote sends that title on update, and the
// documents package's `documentsFetch` maps the same slot — an English "Untitled"
// here could be written back to the record, and read as English on a Georgian board.
// The word is translated where the row is RENDERED (the tile's Title below;
// documents' own lists resolve `documents.notes.untitledShort` the same way).
const $eee07520569aad07$var$_mapDocRow = (r)=>{
    const rawFolder = r.folderPath || r.folder || '';
    return {
        id: r.docId || r._id || r.id,
        title: r.title || '',
        folder: rawFolder === '/' ? '' : rawFolder.replace(/^\//, ''),
        type: r.type || 'note',
        source: r.source || 'member',
        updatedAt: r.updatedAt || '',
        author: r.author || ''
    };
};
// Notes widget quick-add (board §2 "notes/assets: chip grid (exists) +
// quick-new-note input row"). Unlike _submitTaskQuickAdd above, createNote
// (imported directly above, same cold-boot rationale as saveTicket) ALREADY
// appends the new row to root.documents/root.notes and sets selectedNoteId
// internally (functions/createNote.js) — so this orchestrator must NOT
// also append, or the note would render twice.
const $eee07520569aad07$var$_submitNoteQuickAdd = async (el, root)=>{
    if (!root) return;
    const title = (root._noteDraft || '').trim();
    if (!title) return;
    root.update({
        _noteDraft: ''
    });
    try {
        const id = await (0, $g9flU.createNote).call(el, {
            title: title
        });
        if (!id) throw new Error('create returned no note');
    } catch (err) {
        console.warn('[home] quick-add note failed:', err && err.message);
        root.update({
            _noteDraft: title
        });
        el.call('openNotification', {
            type: 'error',
            title: el.call('polyglot', 'workspace.home.quickAdd.noteFailed'),
            message: err && err.message || el.call('polyglot', 'workspace.home.tryAgain')
        });
    }
};
// Real-team-only birthday list — the `workspaceProject.birthdays`
// feed includes seeded placeholder names (e.g. Samuel L. Jackson,
// Frank Zappa) that aren't actual team members. Filter to only
// entries that match someone in `root.people` (by email if present,
// otherwise name) so the widget shows real milestones only.
const $eee07520569aad07$var$_teamBirthdays = (root)=>{
    const all = Array.isArray(root?.birthdays) ? root.birthdays : [];
    if (!all.length) return [];
    const people = Array.isArray(root?.people) ? root.people : [];
    if (!people.length) return [];
    const emails = new Set(people.map((p)=>(p.email || '').toLowerCase()).filter(Boolean));
    const names = new Set(people.map((p)=>(p.name || '').trim().toLowerCase()).filter(Boolean));
    return all.filter((b)=>{
        const e = (b?.email || '').toLowerCase();
        if (e && emails.has(e)) return true;
        const n = (b?.name || '').trim().toLowerCase();
        return n && names.has(n);
    });
};
// Projects under the user's currently active workspace.
// THE APP SPLIT (docs/APP_SPLIT.md, WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES):
// the home Projects widget is the WEBSITES widget — a workspace app (a module,
// an AI-built app) opens from the launcher and never shows as a project card.
const $eee07520569aad07$var$_activeWorkspaceProjects = (root)=>{
    const all = Array.isArray(root?._projectsForActiveOrg) ? root._projectsForActiveOrg : [];
    const activeWsId = root?.jwtClaims?.active_workspace_id || root?.workspace?.id;
    const scoped = !activeWsId ? all : all.filter((p)=>{
        const wsId = p?.workspace?.id || p?.workspace?._id || p?.workspace;
        return String(wsId) === String(activeWsId);
    });
    const fns = (0, $1X0Je.default).functions;
    return fns.splitProjectsByKind(scoped, fns.projectKindContext(root)).websites;
};
// Rolling 7-day window from `now`, filtered to where the signed-in user
// is an attendee. Deduped by title+start+location since the upstream
// feed returns duplicate rows with different ids for the same booking.
const $eee07520569aad07$var$_weekEvents = (s)=>{
    const me = s.root.currentUserEmail;
    const now = Date.now();
    const endMs = now + 604800000;
    const seen = new Set();
    return (s.root.intranetEvents || []).filter((e)=>{
        const t = e.startAt ? new Date(e.startAt).getTime() : 0;
        if (t < now || t >= endMs) return false;
        if (Array.isArray(e.attendees) && !e.attendees.includes(me)) return false;
        const key = `${e.title || ''}|${e.startAt || ''}|${e.location || ''}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    }).sort((x, y)=>new Date(x.startAt).getTime() - new Date(y.startAt).getTime());
};
// Timezone CLUSTERS for the Team-timezones widget (2026-08-13 — replaces the
// flat per-member row list, 2026-08-12's fix for the even-older per-CITY
// tile bucketing). Groups by each member's real IANA `timezone` field
// (root.people[].timezone — the same field CalProfileModal / PersonPopoverCard
// / PersonCard already read for the identical purpose), NOT the free-text
// `location` string the two older versions keyed on — two members can spell
// the same city two ways, but an IANA zone id is an exact match key, and
// it's what the live-clock math (`_zoneTime`, components/IntranetRows.js)
// needs anyway. Sorted west→east by live UTC offset so the list reads like
// a world clock; capped
// at 8 zones (the widget body scrolls past that — card.Body sets
// `overflow: auto`).
let $eee07520569aad07$var$_tzGroupsCache = {
    peopleRef: null,
    me: null,
    value: []
};
const $eee07520569aad07$var$_teamTimezoneGroups = (s)=>{
    const people = s.root.people;
    const me = s.root.currentUserEmail;
    if ($eee07520569aad07$var$_tzGroupsCache.peopleRef === people && $eee07520569aad07$var$_tzGroupsCache.me === me) return $eee07520569aad07$var$_tzGroupsCache.value;
    const byTz = new Map();
    for (const p of people || []){
        if (!p || p.email === me) continue;
        const tz = p.timezone || null;
        const key = tz || '__no-timezone__';
        let group = byTz.get(key);
        if (!group) {
            group = {
                timezone: tz,
                members: []
            };
            byTz.set(key, group);
        }
        group.members.push(p);
    }
    const value = Array.from(byTz.values()).map((g)=>({
            ...g,
            offsetMin: $eee07520569aad07$var$_tzOffsetMinutes(g.timezone)
        })).sort((a, b)=>a.offsetMin - b.offsetMin || b.members.length - a.members.length).slice(0, 8);
    $eee07520569aad07$var$_tzGroupsCache = {
        peopleRef: people,
        me: me,
        value: value
    };
    return value;
};
// Robust IANA→UTC-offset-minutes via the round-trip locale-string trick
// (format "now" INTO the zone, re-parse as a Date, diff against true UTC) —
// avoids depending on `timeZoneName: 'shortOffset'` text output for the SORT
// key (that format is still used, display-only, by the shared
// `el.call('zoneLabel', tz)` — shared/functions/zoneLabel.js, TZ-LABELS-1 —
// which components/IntranetRows.js's TzZone reads). Unresolvable zones (or
// the "no timezone set"
// bucket) sort last.
const $eee07520569aad07$var$_tzOffsetMinutes = (timezone)=>{
    if (!timezone) return 9999;
    try {
        const now = Date.now();
        const utcMs = now + new Date().getTimezoneOffset() * 60000;
        const tzMs = new Date(new Date(now).toLocaleString('en-US', {
            timeZone: timezone
        })).getTime();
        return Math.round((tzMs - utcMs) / 60000);
    } catch  {
        return 9999;
    }
};
// Zone-label / live-time text and the TzCluster/TzAvatarItem presentational
// templates live in components/IntranetRows.js, next to their sibling
// Team-timezones components (AvatarBundle, AvatarBundleItem, CityMemberRow)
// — registered (not inlined via `childExtends: {}`) per frank's FA808, which
// flags an inline childExtends object as not independently re-extractable.
// (HOME_WORK / HOME_TEAM / HOME_INSIGHTS moved 2026-06-06 → SEARCH_APPS
// in workspace/functions/searchApps.js. The AppsWidget card that
// rendered them was removed from the home grid; the same list now
// renders as a dropdown when the global search gains focus, and items
// open inside the AppWindow below via el.call('openAppPage').)
// (`_homeAgents` — the headline Temo/Watcher/Caesar cards with their ticket
// and presence captions — was removed 2026-08-21 (FALSE-ZERO-HOME-NON-AGENT-
// KEYS-1): it had no caller since the hardcoded "youragents" widget left the
// grid (see the widget-id history below). Its two Family-D reads
// (`root.tickets.length`, `root.myTickets.length`) and the Watcher presence
// caption were therefore never rendered; the live Family-D defect was the
// `_ensureHomeTickets` loader above, which handed `root` to a function that
// needs an element and so never wrote `_userTickets` on Home.)
// ── THE CARD SURFACE (2026-09-26, DESIGN-WL-HOME-WIDGETS-1) ─────────────────
// Every home card is ONE neutral solid, painted by the frame
// (components/HomeWidgetFrame.js). A widget's colour — its family hue, or the
// user's "Add color" pick (context menu, `root._homeWidgetColors`) — tints its
// icon plate and its one visual only (the accent law, HOME_WIDGETS_SPEC.md
// §3), never the card and never the text a body paints.
//
//   `_NEUTRAL_CARD_BG` — the neutral card: the brand `card` theme fill
//   (design brief 4.2 item 1: an OPAQUE raised fill, gray3 in dark and gray15
//   in light), behind the `--home-card-bg` re-tint channel (a workspace
//   record such as GreenIG's green glass, or a module's chrome.card —
//   functions/workspaceProjects.js applyModuleCardVar). It replaced a
//   translucent white wash, `rgba(255, 255, 255, .06)` dark / `.62` light,
//   that composited to #505056 on the dark stage, where `inactive` ink read
//   2.80:1. `--theme-card-background` is the design system's own variable
//   for that theme and flips with `data-theme`, so ONE inline value serves
//   both schemes. __tests__/homeCardSurfaceTheme.test.js renders it.
const $eee07520569aad07$var$_NEUTRAL_CARD_BG = 'var(--home-card-bg, var(--theme-card-background))';
// The hue a card's BODY paints with: none. Under the accent law above a
// widget's colour lands on its plate and its visual (the frame's
// `--home-widget-hue`), and every body ink is the neutral twin on the neutral
// card — in both themes, whatever the user picked. The body call sites keep
// asking; the one answer is null.
const $eee07520569aad07$var$_cardHue = ()=>null;
// ── Poster steps on ANY home card ────────────────────────────────────────
// Widget bodies written for the always-hued posters painted literal `black`
// / `white` inks and their alpha steps (`.06`/`.08` hover and plates,
// `.12` fills, `.35` rings, a `yellow` check). Every card is neutral by
// default since 2026-09-02, so each literal read in ONE theme only — black
// ink on the dark card, white segments on the light one. `_posterStep`
// returns the user-coloured card's own step (the `{ bg, ink, inkSoft,
// inkMeta, wash, fill }` entry, functions/homeWidgetHue.js `_hueEntry`),
// else the neutral card's twin, so a body never has to know whether its
// card is coloured. The twins are the entry's own grammar on the `title`
// ink: `wash` = ink .08 and `fill` = ink .12 (the entry's alphas), the
// soft and meta inks the adaptive `caption` / `inactive` tokens, `bg` the
// card fill itself. ONE card lookup, shared with HomePosterInk /
// HomePosterSoftInk (`posterCardHue`), so the three can never disagree.
const $eee07520569aad07$var$_NEUTRAL_STEP = {
    bg: $eee07520569aad07$var$_NEUTRAL_CARD_BG,
    ink: 'title',
    inkSoft: 'caption',
    inkMeta: 'inactive',
    wash: 'title.08',
    fill: 'title.12'
};
const $eee07520569aad07$var$_posterStep = (step)=>(el)=>{
        const h = (0, $bbG8O.posterCardHue)(el);
        return h ? h[step] : $eee07520569aad07$var$_NEUTRAL_STEP[step];
    };
// ── SPEC GEOMETRY REGISTRY (WS-HOME-RESET-LAYOUT-INPLACE-1) ──────
// Every widget's DECLARED default cell (x, y, w, h — the 12-column geometry
// its spec or manifest carries), captured at the layer that declares it: the
// static plane through `_widget(spec, body)`, the module plane through
// `HomeModuleWidget`'s `s.spec`. It is the source of the DEFAULT board — a
// fresh board and "Reset layout" — converted to an order + sizes by the same
// homeLayoutFromLegacy a saved 12-column board goes through
// (_defaultLayoutEntries). Declaration-time capture has no ordering hazard and
// touches no DOM.
const $eee07520569aad07$var$_SPEC_GEOMETRY = new Map();
// TENANT DIMENSION (module-memo census). A STATIC widget's id is a constant
// declared in this file — it has no tenant dimension, so it keys on the bare
// id. A MODULE widget's id is tenant DATA out of a manifest, and two
// workspaces can legitimately ship the same id with different geometry, so
// those entries carry the workspace scope in the key. Nothing is ever torn
// down: a stale entry can only be READ through `_specLayoutFor`, which walks
// the ACTIVE workspace's catalog and asks for the scoped key first.
const $eee07520569aad07$var$_specGeometryKey = (id, root)=>root ? `${$eee07520569aad07$var$_wsScope(root)}::${id}` : id;
// Record one widget's DECLARED cell. w/h fall back to the module plane's
// defaults (4 × 3). Returns the spec so the call can sit inline.
const $eee07520569aad07$var$_recordSpecGeometry = (spec, root)=>{
    if (!spec || !spec.id) return spec;
    $eee07520569aad07$var$_SPEC_GEOMETRY.set($eee07520569aad07$var$_specGeometryKey(spec.id, root), {
        x: spec.x != null ? Number(spec.x) : null,
        y: spec.y != null ? Number(spec.y) : null,
        w: Number(spec.w) || null,
        h: Number(spec.h) || null
    });
    return spec;
};
// The declared cells of the ACTIVE workspace's catalog, 12-column shaped.
// Catalog-scoped, so a foreign workspace's module widgets can never leak into
// a reset. Sparse-safe: a widget declared without x/y flows after the placed
// ones instead of being pinned to (0, 0).
const $eee07520569aad07$var$_specLayoutFor = (root, catalog = $eee07520569aad07$var$homeCatalogFor(root))=>{
    const out = [];
    for (const w of catalog){
        // Scoped first (a module widget of THIS workspace), then the bare id (a
        // static widget declared in this file). Never the other workspace's entry.
        const geo = $eee07520569aad07$var$_SPEC_GEOMETRY.get($eee07520569aad07$var$_specGeometryKey(w.id, root)) || $eee07520569aad07$var$_SPEC_GEOMETRY.get(w.id);
        if (!geo) continue;
        const entry = {
            id: w.id
        };
        if (geo.x != null) entry.x = geo.x;
        if (geo.y != null) entry.y = geo.y;
        if (geo.w) entry.w = geo.w;
        if (geo.h) entry.h = geo.h;
        out.push(entry);
    }
    return out;
};
// ── Widget factory ───────────────────────────────────────────────
// One page-declared widget: the shared frame (components/HomeWidgetFrame.js)
// over a state row built from its spec, plus the widget's own body. Module /
// app / AI widgets render through the SAME frame (HomeModuleWidget below), so
// the two planes can no longer drift apart.
//
// spec: { id, title, icon, openRoute?, openCall?, action?, hue?, size?,
//         minSize?, x?, y?, w?, h? }
//   - `app-*` ids render as one-cell app tiles in the grid (decision H1 C,
//     the interim until the App strip ships).
//   - x / y / w / h are the widget's DEFAULT place on a fresh board — read
//     through the spec-geometry registry above and converted by the same
//     homeLayoutFromLegacy a saved 12-column board goes through.
//   - action: `{ icon, label, route? | set? }` — the one square button;
//     without one the frame offers ↗ Open when `openRoute` is set.
const $eee07520569aad07$var$_STATIC_WIDGET_ROWS = new Map();
const $eee07520569aad07$var$_staticWidgetRow = (spec)=>({
        id: spec.id,
        title: spec.title || '',
        icon: spec.icon || 'star',
        kind: String(spec.id).indexOf('app-') === 0 ? 'app' : 'widget',
        size: spec.size || null,
        minSize: spec.minSize || null,
        hue: spec.hue || null,
        openRoute: spec.openRoute || null,
        openCall: spec.openCall || null,
        action: spec.action || null,
        help: spec.help || null,
        spanAt: spec.spanAt || null,
        spec: {
            x: spec.x,
            y: spec.y,
            w: spec.w,
            h: spec.h
        }
    });
const $eee07520569aad07$var$_widget = (spec, body)=>{
    // Runtime source for this widget's DEFAULT cell — see _SPEC_GEOMETRY.
    $eee07520569aad07$var$_recordSpecGeometry(spec);
    const row = $eee07520569aad07$var$_staticWidgetRow(spec);
    $eee07520569aad07$var$_STATIC_WIDGET_ROWS.set(spec.id, row);
    return {
        extends: 'HomeWidgetFrame',
        state: row,
        // Not BUILT while the board keeps it off (qa, unreal home 2026-10-02:
        // the activity widget + heatmap were built on every load, then hidden -
        // 0.6-0.9 s of the home build). Same rule as `hide:` below; restoring it
        // from the customize drawer flips this and builds it then.
        if: (el, s)=>!el.call('homeWidgetFrameHidden', s) && !$eee07520569aad07$var$_moduleShadows(s.root, s.id),
        // A module that ships a widget under a house id replaces the page's own
        // copy while it is installed — one owner per id on the board.
        hide: (el, s)=>el.call('homeWidgetFrameHidden', s) || $eee07520569aad07$var$_moduleShadows(s.root, s.id),
        Body: body || {}
    };
};
// ── App shortcuts — the App strip (HOME_WIDGETS_SPEC §1, decision H1 A) ──
// The built-in app shortcuts are never grid items: they render in the ONE App
// strip between the greeting and the grid (components/HomeAppStrip.js). Each
// keeps its id, its hide pref and its place in the layout ORDER — x / y are
// its default place in a fresh board's reading order (the strip reads the app
// entries' relative order out of root._homeLayout); every shortcut is one
// 2 × 2 legacy cell (an S entry) there.
const $eee07520569aad07$var$_APP_SHORTCUTS = [
    {
        id: 'app-studio',
        x: 4,
        y: 0,
        title: 'workspace.widget.appStudio.title',
        icon: 'layers',
        openRoute: '/studio'
    },
    {
        id: 'app-tickets',
        x: 6,
        y: 0,
        title: 'workspace.widget.appTickets.title',
        icon: 'check',
        openRoute: '/tasks'
    },
    {
        id: 'app-chat',
        x: 8,
        y: 0,
        title: 'workspace.widget.appChat.title',
        icon: 'chat',
        openRoute: '/chat'
    },
    {
        id: 'app-calendar',
        x: 10,
        y: 0,
        title: 'workspace.widget.appCalendar.title',
        icon: 'date outline',
        openRoute: '/calendar'
    },
    {
        id: 'app-reminders',
        x: 4,
        y: 6,
        title: 'workspace.widget.appReminders.title',
        icon: 'clockOutline',
        openRoute: '/reminders'
    },
    {
        id: 'app-meet',
        x: 4,
        y: 2,
        title: 'workspace.widget.appMeet.title',
        icon: 'video',
        openRoute: '/meet'
    },
    {
        id: 'app-broadcast',
        x: 6,
        y: 2,
        title: 'workspace.widget.appBroadcast.title',
        icon: 'bell',
        openRoute: '/announcements'
    },
    {
        id: 'app-documents',
        x: 8,
        y: 2,
        title: 'workspace.widget.appDocuments.title',
        icon: 'document',
        openRoute: '/notes'
    },
    {
        id: 'app-agents',
        x: 10,
        y: 2,
        title: 'workspace.widget.appAgents.title',
        icon: 'star',
        openRoute: '/agents'
    },
    {
        id: 'app-team',
        x: 4,
        y: 4,
        title: 'workspace.widget.appTeam.title',
        icon: 'people',
        openRoute: '/team-and-agents'
    },
    {
        id: 'app-analytics',
        x: 6,
        y: 4,
        title: 'workspace.widget.appAnalytics.title',
        icon: 'analytics',
        openRoute: '/workspace-analytics'
    },
    {
        id: 'app-people',
        x: 8,
        y: 4,
        title: 'workspace.widget.appPeople.title',
        icon: 'user',
        openRoute: '/team-members'
    },
    {
        id: 'app-infra',
        x: 10,
        y: 6,
        title: 'workspace.widget.appInfra.title',
        icon: 'server',
        openRoute: '/infra'
    },
    {
        id: 'app-health',
        x: 10,
        y: 4,
        title: 'workspace.widget.appHealth.title',
        icon: 'eye',
        openRoute: '/system-status'
    }
].map((spec)=>{
    const full = {
        ...spec,
        w: 2,
        h: 2
    };
    $eee07520569aad07$var$_recordSpecGeometry(full);
    const row = $eee07520569aad07$var$_staticWidgetRow(full);
    $eee07520569aad07$var$_STATIC_WIDGET_ROWS.set(full.id, row);
    return row;
});
// The App strip's items: the shortcuts not hidden (an installed module that
// ships the same id owns it) and any module widget that ships as an icon only,
// in the saved layout ORDER. "All apps" closes the row (HomeAppStrip).
const $eee07520569aad07$var$_appStripRows = (root)=>{
    const hidden = root && root._homeHiddenWidgets || {};
    const layout = $eee07520569aad07$var$_currentHomeLayout(root);
    const place = (id)=>{
        const at = layout.findIndex((e)=>e && e.id === id);
        return at < 0 ? layout.length : at;
    };
    const rows = [];
    for (const row of $eee07520569aad07$var$_APP_SHORTCUTS){
        if (hidden[row.id] === true || $eee07520569aad07$var$_moduleShadows(root, row.id)) continue;
        rows.push({
            ...row,
            key: row.id
        });
    }
    for (const w of $eee07520569aad07$var$_allModuleWidgetsFor(root)){
        if (!(0, $1Qr8P.homeWidgetIsApp)(w) || hidden[w.id] === true) continue;
        rows.push({
            ...w,
            kind: 'app',
            key: w.id
        });
    }
    return rows.sort((a, b)=>place(a.id) - place(b.id));
};
// THE SETUP WIZARD's apps step (functions/onboardingWizard.js): every app the
// App strip can show — the house shortcuts and the installed apps' icon
// widgets, the same two sources as `_appStripRows` — each with whether it
// shows now. A hidden app is offered only when a click could bring it back
// (`_widgetRestorable`, the drawer's own test), in the saved layout ORDER.
const $eee07520569aad07$var$_onboardingAppRows = (root)=>{
    const hidden = root && root._homeHiddenWidgets || {};
    const layout = $eee07520569aad07$var$_currentHomeLayout(root);
    const place = (id)=>{
        const at = layout.findIndex((e)=>e && e.id === id);
        return at < 0 ? layout.length : at;
    };
    const rows = [];
    const offer = (id, row)=>{
        const shown = hidden[id] !== true;
        if (!shown && !$eee07520569aad07$var$_widgetRestorable(id, root)) return;
        rows.push({
            id: id,
            title: row.title,
            icon: row.icon,
            openRoute: row.openRoute,
            shown: shown
        });
    };
    for (const row of $eee07520569aad07$var$_APP_SHORTCUTS)if (!$eee07520569aad07$var$_moduleShadows(root, row.id)) offer(row.id, row);
    for (const w of $eee07520569aad07$var$_allModuleWidgetsFor(root))if ((0, $1Qr8P.homeWidgetIsApp)(w)) offer(w.id, w);
    return rows.sort((a, b)=>place(a.id) - place(b.id));
};
// The wizard's picks in ONE write — `{ [id]: true | false }`, shown or
// hidden. The same halves as the board's own hide (`_persistWidgetHide` +
// `_showWidgetHidden`) and restore (`_restoreWidget`): the user's choices are
// recorded, the hidden map flips once, the durable subset persists once —
// never a write per tile. No motion: the wizard covers the board.
const $eee07520569aad07$var$_setAppsShown = (root, picks, sdk)=>{
    if (!root || typeof root.update !== 'function' || !picks || typeof picks !== 'object') return false;
    const cur = {
        ...root._homeHiddenWidgets || {}
    };
    let layout = $eee07520569aad07$var$_currentHomeLayout(root);
    let moved = false;
    let changed = false;
    for (const id of Object.keys(picks)){
        if (picks[id] === true && cur[id] === true && $eee07520569aad07$var$_widgetRestorable(id, root)) {
            const next = (0, $7dUkh.homeLayoutEnsure)(layout, [
                {
                    id: id,
                    size: $eee07520569aad07$var$_defaultWidgetSize(root, id)
                }
            ]);
            if (next !== layout) {
                layout = next;
                moved = true;
            }
            cur[id] = false;
            $eee07520569aad07$var$_recordUserHidden(root, id, false);
            changed = true;
        } else if (picks[id] === false && cur[id] !== true) {
            cur[id] = true;
            $eee07520569aad07$var$_recordUserHidden(root, id, true);
            changed = true;
        }
    }
    if (!changed) return false;
    root.update(moved ? {
        _homeHiddenWidgets: cur,
        _homeLayout: layout
    } : {
        _homeHiddenWidgets: cur
    });
    $eee07520569aad07$var$_saveHiddenWidgets(root, $eee07520569aad07$var$_durableHiddenMap(root), sdk);
    if (moved) $eee07520569aad07$var$_persistHomeLayout(root, sdk);
    return true;
};
// The Dock's and the Rail's items — ONE factory body for both (the strip
// re-reads its rows when the hidden map or the saved order changes).
const $eee07520569aad07$var$_appStripChildren = (root)=>{
    root._homeHiddenWidgets;
    root._homeLayout;
    return $eee07520569aad07$var$_appStripRows(root);
};
// Does the Dock (style 'dock') or the Rail (style 'rail') step aside? The
// person's look turns the strip off, or picks the other style (the Rail's own
// rule) — AND a strip with no app left to show steps aside too: its capsule
// would hold "All apps" alone, one lone launcher pill on the page head
// (measured on dev Vault 2026-10-03, an app-mode workspace whose default
// hides every house shortcut: a 57 × 57 capsule with one grid glyph). The
// header's search launcher and the Apps menu stay. The look half is the
// components' own gate (functions/homeLook.js homeAppStripLookHidden), read
// here too because a mount-site function REPLACES the component's (functions
// never merge).
const $eee07520569aad07$var$_appStripHidden = (el, root, style)=>!!el.call('homeAppStripLookHidden', root, style) || $eee07520569aad07$var$_appStripChildren(root).length === 0;
// A TAB OTHER THAN THE DASHBOARD HOLDS THE HOME (functions/homeView.js — Main,
// Chat, Present, Build): the dashboard's own rows — the App strip, its Rail,
// the boards row — step aside for it. A host without the tabs (no homeViewOf)
// reads as the dashboard.
const $eee07520569aad07$var$_tabHoldsHome = (el, root)=>{
    const tab = el.call('homeViewOf', root);
    return typeof tab === 'string' && tab !== 'dashboard';
};
// The Personalise panel's app list: the same rows, each with its neighbours'
// ids for the arrow buttons (components/HomePersonalize.js).
const $eee07520569aad07$var$_personalizeAppRows = (root)=>{
    const rows = $eee07520569aad07$var$_appStripChildren(root);
    return rows.map((row, i)=>({
            ...row,
            key: row.id,
            prevId: i > 0 ? rows[i - 1].id : null,
            nextId: i < rows.length - 1 ? rows[i + 1].id : null
        }));
};
// ── Module widget host ───────────────────────────────────────────
// Module / app / AI widgets render through the SAME frame as the page's own
// widgets (components/HomeWidgetFrame.js), over their state row: the manifest
// entry as the module loaders stashed it ({ id, title, icon, body, moduleId,
// spec, size?, hue?, action?, help? } — see _allModuleWidgetsFor).
//
// Body content mounts via el.set() keyed by moduleId/id: a string body extends
// a module component (validated by the manifest normalizer and in context by
// stash time — the stash update that renders this host happens AFTER the
// injection), an object body mounts inline.
const $eee07520569aad07$var$_mountModuleWidgetBody = (el, s)=>{
    // The module context is looked up BEFORE the guard and its PRESENCE is part
    // of the signature. The board paints at shell boot, and
    // `_ensureModuleDsContext` builds the module context lazily — so a body can
    // mount against the SHELL context first. With a `moduleId/id` signature that
    // body was never mounted again once the context landed: it kept the shell's
    // tokens and echoed the module's raw translation keys (aihouse home widgets,
    // 2026-09-23). Now the signature changes exactly once, 0 → 1, so the body
    // re-mounts exactly once. It cannot loop: the signature is written before
    // `el.set`, so the update that `set` triggers re-enters with an equal
    // signature and returns. An AI-created body never reads the module context,
    // so its signature stays context-free.
    // CSS-hidden hosts still create children. Wait for restoration before the
    // first body mount, and before the lazy module-context build below, so a
    // hidden widget neither runs its data hooks nor builds a context at boot.
    if (s.root?._homeHiddenWidgets?.[s.id]) return;
    // A pinned app widget (an AI row of kind 'widget' resolved to its module)
    // mounts through the module path below, under its module's context.
    const pinnedApp = !!(s.aiGenerated && s.kind === 'widget' && s.moduleId && s.body);
    const modCtx = s.aiGenerated && !pinnedApp ? null : s.root?._moduleDsCtxGet?.(s.moduleId);
    // A PINNED app widget's params are part of its identity: update_widget and
    // "Change with AI" rewrite them in place, and the body reads them once, at
    // mount (frame contract v1 `scope.params`). Without them in the signature
    // the card kept drawing the old params until a reload (dev 2026-10-04: a
    // testnet card renamed "(Mainnet)" still listed testnet nodes).
    const paramsSig = pinnedApp ? `/${JSON.stringify((0, $1Qr8P.homeWidgetParams)(s))}` : '';
    const sig = `${s.moduleId || ''}/${s.id || ''}/${modCtx ? 1 : 0}${paramsSig}`;
    if (el.__moduleBodySig === sig) return;
    el.__moduleBodySig = sig;
    const body = s.body;
    try {
        // AI-CREATED plane (tickets/opus.md): the body is DATA — a fixed-vocabulary
        // block list — not a module component key and not a component definition.
        // It mounts the ONE reviewed interpreter (components/WidgetRenderer.js),
        // which reads the def off this host's own state (body / dataRecipe /
        // viewerCapability). Spreading the body as an element definition here —
        // what the module branch below does — would treat `blocks` as a child key
        // and, worse, would make an author-supplied object into a component
        // definition. It is never evaluated, never extended by name, never eval'd.
        if (s.aiGenerated && !pinnedApp) {
            // A RECORDS row (kind 'records', WIDGET-TOOLS-RECORDS-SHAPE-1) is one app
            // collection read live for THIS viewer: it mounts the records renderer
            // the board and the thread share — AssistantRecordsBlock reads `records`
            // off this host's state and asks ai.boards.records under the viewer's
            // grants. A viewer the server already refused keeps WidgetRenderer,
            // which draws that notice instead of a read that would only be refused.
            if (s.kind === 'records' && s.records && typeof s.records === 'object' && s.viewerCapability && s.viewerCapability.allowed === true) {
                el.set({
                    extends: 'AssistantRecordsBlock'
                });
                return;
            }
            // A pinned BLOCK carries its values (homePinnedHostRow `blockData`):
            // seeded into the AI-widget data bag BEFORE the interpreter mounts, so
            // its first run reads them (no recipe → loadAiWidgetData fetches nothing).
            if (s.kind === 'block' && s.blockData && s.root && typeof s.root.update === 'function') {
                const bag = s.root._aiWidgetData || {};
                s.root.update({
                    _aiWidgetData: {
                        ...bag,
                        [s.id]: {
                            sig: 'pinned',
                            loading: false,
                            settled: true,
                            denied: false,
                            error: null,
                            data: s.blockData
                        }
                    }
                }, {
                    preventFetch: true
                });
            }
            el.set({
                extends: 'WidgetRenderer'
            });
            return;
        }
        const def = typeof body === 'string' ? {
            extends: body
        } : {
            ...body || {}
        };
        // Thread the module's OWN design-system context into the widget body —
        // the host is a shell-page child, so without this every module token
        // inside a home widget resolved against the SHELL config and silently
        // dropped ("widgets lost styles", bellforge 2026-08-12). Same
        // non-enumerable-context contract as the wrapped module pages
        // (workspaceProjects.js _wrapModulePages); getter closure because the
        // loader chunk's module context never survives root.update clones.
        // Passed as a plain property on the set() payload — same contract as
        // PageSlot's host.set (a non-enumerable prop would be dropped by any
        // spread/clone inside set). The def object is ephemeral (never cached,
        // never ridden onto root state), so enumerability costs nothing here.
        // WS-MODULE-STATE-SCOPE-1: the module context also carries the module's
        // STATE scope now (a plugin on `modCtx`), so a widget body reads and writes
        // the SAME module-local plane the module's pages do — with no def change,
        // which matters here because this def is `{ extends: <moduleComponent> }`
        // and any def key the shell added would shadow the component's own.
        // (`modCtx` is resolved above, before the signature guard.)
        if (modCtx) {
            def.context = modCtx;
            // WS-MODULE-CTX-DROPS-APP-GLOBALSCOPE-1 (live leg) — same scope-root
            // parity as _wrapModulePages: the widget host is a shell-page child, so
            // without a def-level `scope` the body's `__scope` reads resolve the
            // shell chain, never the app's own globalScope bag. Merge order matches
            // the page wrap: the body's own scope keys win over the bag.
            if (modCtx.globalScope) def.scope = typeof def.scope === 'object' && def.scope !== null ? Object.assign({}, modCtx.globalScope, def.scope) : modCtx.globalScope;
        }
        // FRAME CONTRACT v1: the body reads `el.scope.params` (the schema's
        // defaults + this instance's values — functions/homeWidgetFrame.js
        // homeWidgetParams), `el.scope.widgetId` and `el.scope.size` (the size at
        // mount; the live size is the card's data-widget-size). A COPY of whatever
        // scope the body had: the app's shared globalScope bag is never written
        // (every widget of the app shares it).
        def.scope = Object.assign({}, def.scope || null, {
            params: (0, $1Qr8P.homeWidgetParams)(s),
            widgetId: s.id,
            size: (0, $1Qr8P.homeWidgetFrameSize)(s)
        });
        el.set(def);
    } catch (err) {
        console.warn('[home] module widget body mount failed:', s.id, err);
    }
};
// NOTE: the module plane no longer resolves its own hue pair. Both plates a
// module widget can show — the header tile and the icon-mode squircle — now
// extend the shared `AppHueTile`, which does the whole resolution itself
// (house id/route → the widget's own manifest `hue`/`spec.iconBg` → the
// adaptive overlayStrong/title pair). The former `_moduleWidgetHue` helper
// paired the hue's ink with its 8% `wash` over a NEUTRAL card, which is the
// one combination the poster palette is not art-directed for — see the
// IconTile note below.
const $eee07520569aad07$var$HomeModuleWidget = {
    extends: 'HomeWidgetFrame',
    // Defer the whole frame, including its controls/effects, until first shown.
    // Keep it mounted thereafter so hiding/restoring preserves body state.
    if: (el, s)=>{
        if (!el.call('homeWidgetFrameHidden', s)) el.__homeWidgetMounted = true;
        return !!el.__homeWidgetMounted;
    },
    // The launcher's duplicate check prefers a module host over a page widget
    // with the same id (see _findItemById).
    attr: {
        'data-module-widget': 'true'
    },
    // The widget's DEFAULT cell for a reset or a fresh board (_SPEC_GEOMETRY).
    onRender: (el, s)=>{
        const spec = s.spec || {};
        $eee07520569aad07$var$_recordSpecGeometry({
            id: s.id,
            x: spec.x,
            y: spec.y,
            w: spec.w || 4,
            h: spec.h || 3
        }, s.root);
    },
    Body: {
        // Restoring a hidden widget re-runs the mount below (see its guard).
        subscribeTo: [
            '_homeHiddenWidgets'
        ],
        onCreate: (el, s)=>$eee07520569aad07$var$_mountModuleWidgetBody(el, s),
        onUpdate: (el, s)=>$eee07520569aad07$var$_mountModuleWidgetBody(el, s)
    }
};
// A saved cell whose widget has not arrived yet (its module is still loading):
// the frame's geometry with skeletons in it, so the board paints its final
// arrangement at once and the late widget lands in place (zero shift).
// Known gap: a manifest `spanAt` is not on the client before its module, so
// at a step the manifest overrides the skeleton holds the size's plain span
// and the card grows on arrival (WS-HOME-BOARD-SHEET-RAW-DOM-AND-PENDING-SPANAT-1).
const $eee07520569aad07$var$HomeWidgetPending = {
    extends: 'HomeWidgetFrame',
    attr: {
        'aria-busy': 'true'
    },
    // No resize while the widget is still on its way: its minimum size is not
    // known yet, and the handle would let a skeleton go below it.
    HomeWidgetResizeHandle: {
        hide: true
    },
    Header: {
        HomeWidgetPlate: {
            Icon: {
                hide: true
            }
        },
        TitleRow: {
            Title: {
                hide: true
            },
            SkeletonRow: {
                width: '50%'
            }
        }
    },
    Body: {
        Skeleton: {
            height: 'C',
            width: '40%',
            round: 'radiusControl'
        },
        SkeletonRow: {
            marginTop: 'auto',
            width: '30%'
        }
    }
};
// ── mail-inbox widget resolvers (architecture/MAIL.md §3.6) ────────────────
// The unified-inbox list slot. Mail keys one slot per (account, folder) pair
// and `all` is the unified inbox — the literal is mail's own
// `mailListKey(null, 'inbox')`, restated here rather than imported because
// this file must not pull the LAZY mail bundle into the home page's own chunk.
// mail/__tests__ pins the two against each other.
const $eee07520569aad07$var$MAIL_INBOX_LIST_KEY = 'all|inbox';
// Newest-first already: mail's stream reducer sorts every slot on write
// (`_sortRows`, by `lastMessageAt` descending), so this slices rather than
// re-sorting a list the producer has already ordered.
const $eee07520569aad07$var$_mailInboxRows = (s)=>{
    const slot = (s?.root?.mailThreads || {})[$eee07520569aad07$var$MAIL_INBOX_LIST_KEY] || {};
    return Array.isArray(slot.rows) ? slot.rows.slice(0, 5) : [];
};
// The SAME number the header envelope's dot and the navbar badge read — one
// producer (mail's stream reducer), so the card and the badge can never
// disagree about how much unread mail there is.
const $eee07520569aad07$var$_mailUnread = (s)=>Number(s?.root?.navUnreadCounts?.mail || 0);
// Catalog of every widget that lives on the home page — THE registry,
// functions/homeWidgetCatalog.js (`homeWidgetCatalog`, with the notes on
// `subtitle` and the literal-key rule). The admin panel pages read the same
// list, so a widget added there is offered to the admins who set the
// workspace defaults too.
const $eee07520569aad07$var$HOME_CATALOG = (0, $dDuP2.homeWidgetCatalog)();
// The catalog for the ACTIVE workspace: the static house set + the active
// MODULE's widgets (root.workspaceProject.widgets ∪ root.workspaceApps[]
// .widgets — stashed by the loaders from each manifest; ids validated by the
// normalizer /^[a-z0-9-]+$/). Module widgets surface in the customize drawer /
// title lookups / visibility resolvers ONLY while their module is live — a
// module-less workspace sees the house set alone, so no client widget is ever
// offered outside its workspace. (The legacy v1 inline plane is gone — WS6
// migration, 2026-07-30.)
const $eee07520569aad07$var$homeCatalogFor = (root, moduleWidgets = $eee07520569aad07$var$_allModuleWidgetsFor(root))=>{
    // A house row may name the ROUTE that gates it (`gateRoute`). The predicate
    // is `navItemVisible` — the same one the navbar, the launcher and the header
    // envelope hide on — so one flag flip at /flags moves every surface of an
    // app together, this widget included. A row without `gateRoute` is
    // ungated, which is every other house widget.
    //
    // It gates the CATALOG, not just the render, because the catalog is what the
    // customize drawer offers and what the hidden-map resolver loops: filtering
    // here means a workspace with the app off is never offered the card, never
    // reveals it from a saved board, and never reserves its grid cell.
    const house = $eee07520569aad07$var$HOME_CATALOG.filter((w)=>!w.gateRoute || $eee07520569aad07$var$shellNavItemVisible(root, w.gateRoute));
    if (!moduleWidgets.length) return house;
    return [
        ...house,
        // `subtitle` rides along so an installed app's widget is as tellable
        // apart in the Customize drawer as a house row is — the drawer reads the
        // catalog row, not the render spec.
        ...moduleWidgets.map((w)=>({
                id: w.id,
                title: w.title || w.id,
                icon: w.icon || 'star',
                subtitle: w.subtitle || null
            }))
    ];
};
// EVERY module-declared widget for the active workspace, across BOTH module
// planes, each annotated with its owning module id (the body-mount signature
// key):
//   1. the singular takeover module — root.workspaceProject.widgets (stashed
//      by loadWorkspaceProject from the manifest), and
//   2. the ADDITIVE apps — root.workspaceApps[].widgets (stashed per app by
//      loadWorkspaceApps at functions/workspaceProjects.js:1118).
// Plane 2 was a dangling producer until 2026-07-25: the loader collected each
// installed app's manifest widgets onto the stash, but every home resolver
// (catalog, project-scope gate, render host, resync signal) read ONLY plane 1
// — so a workspace running additive apps (settings.workspaceApps) could pin
// e.g. 'bi-revenue' in home_default_panels and nothing would render: the id
// had no catalog entry, produced no host element, and the reveal loop never
// visited it. One resolver, consumed everywhere, keeps the two planes in
// lock-step from now on. First-listed wins on a duplicate widget id (matches
// the loader's inject-skip-existing collision policy).
const $eee07520569aad07$var$_allModuleWidgetsFor = (root)=>{
    const out = [];
    const seen = new Set();
    const push = (widgets, moduleId)=>{
        if (!Array.isArray(widgets)) return;
        for (const w of widgets){
            if (!w || !w.id || seen.has(w.id)) continue;
            // Optional per-widget visibility gate — `visibleFn` names a MODULE
            // function (resolved in its owning app's scope) called as
            // fn(widgetId, root). The module decides with its own model (e.g.
            // bellforge personas, Nika 2026-08-16 "home widgets should be
            // personalized to each user persona"); the shell stays
            // persona-blind. FAIL-OPEN when the fn hasn't injected yet (boot
            // race) — a widget flashing then hiding beats one lost forever.
            // functions/moduleWidgetGate.js: the gate's `this.call` reaches the
            // shell bridges (moduleRole / moduleCan) like a real el.call, and the
            // evaluation reads root.workspace.access first, so this factory
            // re-runs when the member's access lands (G-H).
            if (!(0, $ljZYp.moduleWidgetGateAllows)(root, w, moduleId, true)) continue;
            seen.add(w.id);
            // `key` rides along so the ModuleWidgets children factory reconciles by
            // widget id instead of array position (rawChild.key — the childrenAs:
            // 'state' contract, element/create.js key resolution). Positional keys
            // meant an order change or shrink remapped widget BODIES across
            // surviving hosts while their gs-ids stayed put — the double-registered
            // cms/crm widgets from the BOOT-RESHUFFLE trace.
            out.push((0, $1Qr8P.homeWidgetRow)(w, moduleId));
        }
    };
    const wp = root?.workspaceProject;
    push(wp?.widgets, wp?.id);
    const apps = Array.isArray(root?.workspaceApps) ? root.workspaceApps : [];
    for (const app of apps)push(app?.widgets, app?.id);
    // PLANE 3 — AI-CREATED widgets (tickets/opus.md "Per-workspace AI-CREATED
    // widgets"): per-workspace user content with no module behind it, fetched by
    // loadPrivateData's dashboard-prefs chain into root.workspaceAiWidgets and
    // filtered to the LIVE workspace by aiWidgetsFor (rows carry their own
    // workspaceId — a mid-switch response can never paint the next tenant's
    // board). Unioned LAST and through the SAME `push`, so:
    //   * every existing consumer (catalog, gate bookkeeping, render host,
    //     resync signal, Customize drawer) picks them up with no second path —
    //     the whole point of this being one resolver;
    //   * a house or module widget ALWAYS wins an id collision (`seen`), and the
    //     server's `ai-` id namespace means one cannot be constructed anyway.
    // `moduleId: null` marks the plane for the body mount + subtitle below: an
    // AI widget's body is DATA drawn by WidgetRenderer, never a module component
    // key.
    // A PINNED board item (kind 'widget' / 'block', functions/homePinnedItems.js)
    // is drawn as the board drew it: a widget row resolves to the installed
    // app's own widget (read off the module rows above) with the pinned params,
    // a block row carries the one reviewed block definition and its values.
    // `push` stamps the moduleId it is given, so each row goes with its own: a
    // resolved app widget carries its app's, every other AI row null.
    for (const w of (0, $in9xh.aiWidgetsFor)(root)){
        const host = (0, $dTMvK.homePinnedHostRow)(w, out);
        push([
            host
        ], host && host.moduleId || null);
    }
    return out;
};
// The human name of the app that OWNS a module widget — its own declared
// navbar label (crm → 'CRM', bi → 'Analytics'), which is what the shell's nav
// already calls it. Empty string when the owning app can't be resolved (the
// takeover-module plane, or a stash that hasn't landed) so callers can treat
// "no label" as "say nothing" rather than printing an opaque project id.
const $eee07520569aad07$var$_moduleAppLabel = (root, moduleId)=>{
    if (!moduleId) return '';
    const apps = Array.isArray(root?.workspaceApps) ? root.workspaceApps : [];
    const app = apps.find((a)=>a && a.id === moduleId);
    const nav = Array.isArray(app?.navbar) ? app.navbar : [];
    const entry = nav.find((n)=>n && typeof n.label === 'string' && n.label);
    return entry && entry.label || '';
};
// A module widget's header subtitle.
//
// Two INSTALLED apps can legitimately ship same-titled widgets, and on
// natali/ws_EEYlHGTvZ8 two of them also compute the same number from the same
// workspace records: crm's `crm-pipeline` and bi's `bi-pipeline` both render
// "Pipeline — GEL 102,700 open pipeline". The board therefore showed what read
// as ONE widget drawn twice. It is not: every gs-id on that board is unique
// (verified live) and `_allModuleWidgetsFor` already dedupes by widget id via
// `seen`, so there is nothing to de-duplicate — the resolved set was correct
// and the RENDER was ambiguous. Deduping ids here would have deleted a real,
// separately-installed app's widget.
//
// So: name the owner instead, and only when it actually disambiguates —
// a widget whose title is unique on the visible board stays uncluttered. The
// app's OWN declared `spec.subtitle` always wins. Generic by construction: no
// widget id, app id or title is named here, and the ambiguity is recomputed
// from live state, so it appears and disappears with install/uninstall and
// with the user's own show/hide choices.
const $eee07520569aad07$var$_moduleWidgetSubtitle = (s)=>{
    const own = s.spec?.subtitle;
    if (own) return own;
    // AI-CREATED plane: there is no owning app to name, and "who made this" is
    // the most useful thing this line can carry — a member seeing a widget on
    // their board that no app installed should be able to tell at a glance that
    // the assistant built it, and for whom. Unconditional (not
    // ambiguity-gated like the module case below): provenance is the point.
    const ai = (0, $in9xh.aiWidgetOwnerLabel)(s);
    if (ai) return ai;
    const root = s.root;
    const hidden = root?._homeHiddenWidgets || {};
    const title = s.title || s.id;
    let sharing = 0;
    for (const w of $eee07520569aad07$var$_allModuleWidgetsFor(root)){
        if (hidden[w.id]) continue;
        if ((w.title || w.id) === title) sharing++;
    }
    return sharing > 1 ? $eee07520569aad07$var$_moduleAppLabel(root, s.moduleId) : '';
};
// The widgets a fresh home shows — the registry's own list
// (functions/homeWidgetCatalog.js `homeDefaultVisibleWidgets`); every other
// catalog row is opt-in via the Customize drawer.
const $eee07520569aad07$var$_DEFAULT_VISIBLE_WIDGETS = (0, $dDuP2.homeDefaultVisibleWidgets)();
const $eee07520569aad07$var$_DEFAULT_HIDDEN_WIDGETS = $eee07520569aad07$var$HOME_CATALOG.map((w)=>w.id).filter((id)=>!$eee07520569aad07$var$_DEFAULT_VISIBLE_WIDGETS.includes(id));
// The GLOBAL default hidden map for the house rows of THIS workspace — the
// branch both visibility resolvers reach when the workspace names no
// `home_default_panels` of its own and the session is not a demo.
//
// On a general workspace it is `_DEFAULT_HIDDEN_WIDGETS` mapped to `true`,
// unchanged. On an APP-MODE workspace (`settings.workspaceModule.installMode
// === 'app'`) every house BOARD card is hidden instead: that workspace exists
// to run one installed app, so its default board is the MODULE's declared
// widgets and nothing else (Nika, 2026-09-10). The page FRAME — the greeting
// with its summary and the Dock's house apps (catalog `place`) — keeps its
// defaults there too (Nika 2026-10-03, "Greeting + house dock"). `_foldAppWidgetDefaults` runs immediately
// after this at both call sites and turns the installed app's own default
// widgets back on, so the board is never empty by construction.
//
// This is a DEFAULT, deliberately — never a write. The house rows all stay in
// the Customize drawer (`_drawerHiddenRows` lists exactly what this map hides),
// and adding one back is an ordinary gesture that persists, because a stored
// `false` then DISAGREES with this base and `persistableHiddenMap` keeps it.
// The decision itself lives in functions/homeDefaultWidgets.js so a test can
// pin it without a browser.
const $eee07520569aad07$var$_globalDefaultHidden = (root)=>(0, $8Zc6q.houseDefaultHiddenMap)({
        houseIds: $eee07520569aad07$var$HOME_CATALOG.map((w)=>w.id),
        defaultHiddenIds: $eee07520569aad07$var$_DEFAULT_HIDDEN_WIDGETS,
        appMode: (0, $8Zc6q.isAppModeWorkspace)(root),
        frameIds: $eee07520569aad07$var$HOME_CATALOG.filter((w)=>w.place).map((w)=>w.id)
    });
// Curated showcase set for demo sessions (root.isDemo === true).
// Widgets included are always populated in the seeded demo sandbox:
//   greeting   — always present (user profile)
//   received   — demo user's assigned tickets (seeded server-side)
//   youragents — hardcoded AI-agent cards (s1m0ne, Temo, Caesar, Watcher, +
//                "Create agent"), the primary AI-showcase surface
//   assets     — the 2 seeded demo documents
//   projects   — the seeded "Acme Landing" studio project (server af078c7e
//                seeds it at demo assignment)
//   events     — "Coming up" — the seeded calendar events, re-dated to the
//                claim week with the visitor as invitee (same server commit)
//   next-up    — "Next up" — the same seeded events, the next one first
//   analytics  — "Active right now" live counter
// Dropped vs previous set:
//   agents — Team & agents' numeral body (2026-08-12) reads live headcount;
//             with no demo team/agent data it would show "0" on both sides,
//             a hollow-looking card same as the excluded teamtime/broadcast
//             below — left out of the curated demo set for the same reason,
//             not because of the old embedded-canvas empty-body bug.
//   given  — demo user reports all tickets but delegates none, so the card
//             always shows "You haven't delegated any open tasks".
// Excluded: teamtime / broadcast (empty in a fresh demo and would render
// hollow cards, defeating the showcase purpose).
const $eee07520569aad07$var$_DEMO_VISIBLE_WIDGETS = [
    'greeting',
    'next-up',
    'received',
    'youragents',
    'assets',
    'projects',
    'events',
    'analytics'
];
// Dashboard-preference schema version. Bumping this abandons every user's
// saved panel set on next load (a one-time reset-everyone to the current
// default) — see the version gate in resolveSavedPrefsSource
// (functions/homePrefsBootSource.js) and the stamp in _savePrefsPatch. v2 = the greeting-only default rollout (2026-06-16).
const $eee07520569aad07$var$CURRENT_DASHBOARD_V = 2;
// Widget ids that belong to a workspace MODULE. They may render ONLY when the active
// workspace's SERVER `home_default_panels` lists them — the user's dashboard prefs
// (hidden_widgets) must NEVER un-hide them. hidden_widgets IS scoped per user ×
// workspace (the server's home_dashboard_prefs row — the /sb proxy pins BOTH
// workspace_id and user_id, see server workers/workspace-project/src/surfaces/sb.js
// USER_SCOPED_TABLES — and the localStorage cache key is workspace-scoped too), so
// cross-WORKSPACE leaks aren't the threat. The gate protects against STALE prefs
// within a workspace (a `false` flag persisted while a module was live must not
// reveal its widgets after the module is removed/swapped) and against restore paths
// (drawer click / drag-drop) revealing a module widget the panel set doesn't grant.
// DERIVED per read: every ACTIVE module-declared widget id (takeover module +
// additive apps — _allModuleWidgetsFor). (The legacy v1 inline id list is
// gone — WS6 migration, 2026-07-30; an id nothing renders simply never shows.)
const $eee07520569aad07$var$_projectScopedIdsFor = (root)=>{
    const ids = new Set();
    for (const w of $eee07520569aad07$var$_allModuleWidgetsFor(root))ids.add(w.id);
    return ids;
};
// The ADDITIVE-install widget sources — every stash whose widgets belong to
// an app INSTALLED on this workspace (`settings.workspaceApps[]`, plus the
// legacy pre-plural single app: `settings.workspaceModule` carrying
// `installMode: 'app'`, whose manifest stash lands on root.workspaceProject).
// Real full-takeover modules (no installMode flag — greenig/bellforge class)
// are NOT app-plane: their widgets stay governed by the workspace's
// authoritative `home_default_panels` alone, exactly as before.
const $eee07520569aad07$var$_appPlaneWidgetSources = (root)=>{
    const sources = Array.isArray(root?.workspaceApps) ? [
        ...root.workspaceApps
    ] : [];
    // `appModeModuleRef` reads the RECORD bag (`root.workspace.settings`), which
    // is the only plane the singular install ref ever lands on. This used to read
    // `root.workspaceSettings.workspaceModule` — the RESOLVED CONFIG bag, which
    // never carries that key (measured live on Vault, 2026-09-10), so this branch
    // was dead and a workspace holding ONLY the singular ref contributed no app
    // widgets at all. That is load-bearing now: `houseDefaultHiddenMap` stands
    // the house rows down in app mode and this fold is what puts the module's own
    // rows back, so a dead branch here would leave such a board EMPTY.
    const ref = (0, $8Zc6q.appModeModuleRef)(root);
    const wp = root?.workspaceProject;
    // …and only when the PLURAL list does not already carry the same app. On a
    // workspace holding both refs for one app (Vault holds exactly that: the
    // singular `workspaceModule` AND a `workspaceApps[0]` entry, both
    // `vault/vaultos-app`) the loaded stash is the same widgets twice, and
    // `appDefaultWidgetIds` unions its sources — so a duplicate could only ever
    // widen the default set if the two copies disagreed. Skipping the duplicate
    // keeps every already-plural workspace byte-for-byte as it was.
    const lc = (v)=>v == null ? '' : String(v).toLowerCase();
    const refId = ref ? `${lc(ref.owner)}/${lc(ref.key)}` : '';
    const alreadyPlural = sources.some((s)=>lc(s && s.appId) === refId);
    if (wp && ref && !alreadyPlural) sources.push({
        widgets: wp.widgets,
        home_default_panels: wp.config && wp.config.home_default_panels || wp.configDefaults && wp.configDefaults.home_default_panels || null
    });
    return sources;
};
// EVERY widget id declared by an installed app (default-on or not) — the ids
// the project gate treats as grantable on THIS workspace, so the Customize
// drawer can reveal an app's opt-in widgets (e.g. bi-stock) without the
// workspace hand-pinning home_default_panels.
const $eee07520569aad07$var$_appPlaneWidgetIdsFor = (root)=>{
    const ids = new Set();
    for (const src of $eee07520569aad07$var$_appPlaneWidgetSources(root)){
        for (const w of Array.isArray(src?.widgets) ? src.widgets : [])if (w && w.id) ids.add(w.id);
    }
    return ids;
};
// The installed apps' DEFAULT-ON widget ids (functions/homePanelSet.js rule:
// the app's declared home_default_panels ∩ its own widget ids, or all its
// widgets when it declares no panels). Derived live from the stashes, so
// install/uninstall converge with zero per-workspace writes.
const $eee07520569aad07$var$_appDefaultWidgetIdsFor = (root)=>(0, $5BDlp.appDefaultWidgetIds)($eee07520569aad07$var$_appPlaneWidgetSources(root));
// The ONE restore-grant read, root-bound (the decision itself is pure —
// functions/homePanelSet.js `isWidgetRestorable`). Both consumers of the grant
// — the drawer's candidate list and every restore path — call THIS, so the
// list can never offer a widget the click would refuse, and neither can drift
// from `_enforceProjectGate`'s exemption set again
// (WS-HOME-DRAWER-CANNOT-RESTORE-HIDDEN-MODULE-WIDGET-1).
const $eee07520569aad07$var$_widgetRestorable = (id, root)=>(0, $5BDlp.isWidgetRestorable)({
        id: id,
        scopedIds: $eee07520569aad07$var$_projectScopedIdsFor(root),
        appPlaneIds: $eee07520569aad07$var$_appPlaneWidgetIdsFor(root),
        aiIds: (0, $in9xh.aiWidgetIdsFor)(root),
        panels: $eee07520569aad07$var$_resolveWsPanels(root)
    });
// Fold the installed apps' widget defaults into a BASE hidden map: every
// app-declared widget gets an EXPLICIT entry — `false` (visible) for the
// app's defaults or anything the workspace's own panel set names, `true`
// (opt-in via Customize) for the rest. Explicit entries matter because these
// ids are NOT in HOME_CATALOG (`_DEFAULT_HIDDEN_WIDGETS` never names them):
// without one, an id the loosened project gate no longer force-hides would
// read `undefined` → visible, turning every opt-in widget default-on. The
// caller merges the user's saved prefs ON TOP, so an explicit hide (or an
// explicit reveal of an opt-in widget) sticks. Mutates + returns, matching
// _enforceProjectGate's contract.
const $eee07520569aad07$var$_foldAppWidgetDefaults = (baseHidden, wsVisible, root)=>{
    const defaults = $eee07520569aad07$var$_appDefaultWidgetIdsFor(root);
    const allowed = Array.isArray(wsVisible) ? wsVisible : null;
    for (const id of $eee07520569aad07$var$_appPlaneWidgetIdsFor(root))baseHidden[id] = !(defaults.has(id) || allowed && allowed.includes(id));
    // AI-CREATED widgets are default-ON for whoever the server listed them to
    // (their creator, plus every member for an explicitly workspace-shared one).
    // Same derived-not-written rule the app plane uses above — no per-user prefs
    // write on create, so the widget appears the moment its row lands and
    // disappears the moment it is deleted. An explicit user hide still sticks:
    // the caller merges saved prefs ON TOP of this base map.
    for (const id of (0, $in9xh.aiWidgetIdsFor)(root))baseHidden[id] = false;
    return baseHidden;
};
// Force every module-scoped widget hidden unless the active workspace's panel set
// (server home_default_panels) explicitly includes it. Applied AFTER the user-prefs
// merge, so prefs can reorder/hide generic widgets but can never reveal another
// workspace's module widgets. Mutates + returns the hidden map.
//
// APP-PLANE EXEMPTION (2026-08-13, the generic appstore widget contract): a
// widget declared by an app INSTALLED on this workspace (_appPlaneWidgetIdsFor
// — derived from the server-stored `settings.workspaceApps` refs, so still a
// server-granted surface, never a client fabrication) is grantable HERE by
// construction and passes the gate. Its default visibility is decided by
// _foldAppWidgetDefaults in the base map + the user's prefs on top — before
// this exemption a panel-less workspace force-hid every installed app's
// widgets AND blocked the Customize drawer from ever revealing them (13 apps
// installed on natali/ws_EEYlHGTvZ8, zero widgets renderable). Takeover-module
// widgets keep the strict panels-only rule — the cross-workspace leak this
// gate exists to prevent is unchanged, since an app's ids are exempt only
// while that app is on THIS workspace's install list.
// AI-PLANE EXEMPTION (tickets/opus.md "Per-workspace AI-CREATED widgets"): an
// AI-created widget is per-user content, not an admin-granted module surface —
// `home_default_panels` stays what it has always been, the WORKSPACE ADMIN's
// default board for module widgets. Its authorization is the server's own list
// scoping instead (a personal widget is only ever returned to its creator; a
// shared one to members, each row carrying the CALLER's capability), which is
// strictly stronger than a client-side id gate: the row does not exist in the
// response at all for someone who may not see it. Gating these on
// home_default_panels would mean a member could not have a widget of their own
// without an admin editing workspace settings — the opposite of the ticket's
// personal-by-default rule.
const $eee07520569aad07$var$_enforceProjectGate = (hidden, wsVisible, root)=>{
    const allowed = Array.isArray(wsVisible) ? wsVisible : null;
    const appIds = $eee07520569aad07$var$_appPlaneWidgetIdsFor(root);
    const aiIds = (0, $in9xh.aiWidgetIdsFor)(root);
    for (const id of $eee07520569aad07$var$_projectScopedIdsFor(root)){
        if (appIds.has(id) || aiIds.has(id)) continue;
        if (!allowed || !allowed.includes(id)) hidden[id] = true;
    }
    return hidden;
};
// A workspace's `home_default_panels` is authoritative for its dashboard — but a
// DEGENERATE set that names nothing beyond the always-present greeting (e.g. a
// workspace whose project module was removed, collapsing its panel list back to
// `['greeting']`) would, taken as authoritative, hide every other widget and
// strand the home on greeting-only. Treat such a set as unset (return null) so
// the caller falls through to the global default (the app-icon + data widgets).
// A real project panel set always names its module widgets too — kept as-is even
// if those mount async (the resync reveals them once their nodes exist) — so this
// only rescues the genuinely-empty case and never regresses a project dashboard.
// Last-known home_default_panels per workspace — the boot-paint fallback for
// _resolveWsPanels below. Keyed by the CONTENT workspace (root.workspace — the
// URL-resolved doc), NOT the auth-claim scope: panels are a property of the
// workspace whose dashboard is being RENDERED, and a claim-keyed entry leaked
// one workspace's panel gate onto another's dashboard whenever claim and URL
// diverged (bellforge's [greeting, bf-overview] hid every generic widget on
// /w/nikoloza). Falls back to the boot-read scope only while the workspace
// doc hasn't resolved.
const $eee07520569aad07$var$_wsPanelsCacheKey = (root)=>`symbols.home.wsPanels.v1.${root?.workspace?.id || $eee07520569aad07$var$_wsScopeForBootRead(root)}`;
// Resolve the workspace's own panel set, and say whether the answer is LIVE
// (from settings) or a cached paint-hint. The distinction matters because a
// live set is AUTHORITATIVE — it overrides the user's own show/hide choices —
// and a hint must never be allowed to do that. See _resolveBootHidden.
//
// The cache is an ENVELOPE (`{ ws, panels }`), not a bare array, because a bare
// array had no way to record which workspace it described. `root.workspaceSettings`
// is a GLOBAL root key that lags a workspace switch, while the cache key is the
// NEW `root.workspace.id` — so every switch wrote the PREVIOUS workspace's panel
// list under the NEXT workspace's key. Live-confirmed damage: three unrelated
// workspaces (Symbols Intranet included) all caching the same
// `["greeting","bf-overview"]`, a bellforge-only set. Since a panel set is
// authoritative, that stale entry hid every widget whose id wasn't in it, and
// the boot then persisted that into the user's own hidden_widgets — turning a
// transient race into permanent, cross-workspace data loss.
//
// Reading the envelope also self-heals: legacy bare-array entries no longer
// parse as valid, so the poisoned ones are ignored (and overwritten) on sight.
//
// The envelope also carries `governsHouse` — whether that panel set governs
// the house DEFAULT ids too (a takeover module's board; see
// `panelSetHiddenMap`). The answer comes from the workspace RECORD, which a
// cold boot may not hold yet while this hint paints, so the hint carries the
// last-known answer: a takeover board never flashes the App strip and Next up
// before its record lands, and a configured general workspace never flashes
// without them. `null` on a legacy envelope — the caller asks the record.
const $eee07520569aad07$var$_readWsPanelsCache = (root)=>{
    try {
        const parsed = JSON.parse(localStorage.getItem($eee07520569aad07$var$_wsPanelsCacheKey(root)) || 'null');
        if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') return null;
        if (parsed.ws !== $eee07520569aad07$var$_wsScope(root)) return null;
        if (!Array.isArray(parsed.panels) || !parsed.panels.length) return null;
        return {
            panels: parsed.panels,
            governsHouse: typeof parsed.governsHouse === 'boolean' ? parsed.governsHouse : null
        };
    } catch (_) {
        return null;
    }
};
// True while the workspace DECLARES a module source but its widget stash has
// not landed yet — the window in which the catalog is not yet a fair judge of
// whether a panel id is real. `settings.workspaceModule` is the singular
// takeover module, `settings.workspaceApps[]` the additive plural; both stash
// their manifest widgets onto root asynchronously (loadWorkspaceProject /
// loadWorkspaceApps), and _allModuleWidgetsFor is the union of both planes.
const $eee07520569aad07$var$_moduleWidgetsPending = (root)=>{
    const wss = root?.workspaceSettings || {};
    const declaresModule = !!wss.workspaceModule;
    // Only INSTALLED APP entries count (installedAppRefs) — never a server-managed
    // row such as the records-grant `legacy-backfill`.
    const declaresApps = (0, $g7CNh.installedAppRefs)(wss).length > 0;
    if (!declaresModule && !declaresApps) return false;
    return $eee07520569aad07$var$_allModuleWidgetsFor(root).length === 0;
};
// Warn ONCE per (workspace, ghost set) — this resolver runs on every home
// render, and a config error that logs on every frame is noise nobody reads.
const $eee07520569aad07$var$_warnedGhostPanels = new Set();
const $eee07520569aad07$var$_warnGhostPanels = (root, ghosts, authoritative)=>{
    if (!$eee07520569aad07$var$shellIsLoudDevRuntime()) return;
    const sig = `${$eee07520569aad07$var$_wsScope(root)}|${ghosts.join(',')}`;
    if ($eee07520569aad07$var$_warnedGhostPanels.has(sig)) return;
    $eee07520569aad07$var$_warnedGhostPanels.add(sig);
    console.warn(`[home] home_default_panels names ${ghosts.length} widget id(s) that do not exist: ${ghosts.join(', ')}. ` + (authoritative ? 'The rest of the set is still honoured.' : 'Nothing in the set resolves to a real widget, so the default board is shown instead of hiding everything.'));
};
const $eee07520569aad07$var$_resolveWsPanelsInfo = (root)=>{
    const bag = root?.workspaceSettings;
    const raw = bag?.home_default_panels;
    // PROVENANCE gate (isolation audit #10): `workspaceSettings` is a global
    // key that lags a switch, so a stamped bag describing a DIFFERENT workspace
    // must not be treated as live — and must never be cache-written under the
    // new scope's key (the write below stamps the scope AT WRITE TIME, which
    // proved nothing about where the DATA came from; that's how three unrelated
    // workspaces all cached bellforge's panel set). An UNstamped bag (legacy /
    // optimistic-console write) keeps today's behavior.
    const bagWs = bag?.workspace_id ? String(bag.workspace_id) : null;
    const bagForeign = !!(bagWs && bagWs !== $eee07520569aad07$var$_wsScope(root));
    if (!Array.isArray(raw) || bagForeign) {
        // Settings haven't landed yet (cold boot — home_default_panels arrives via
        // the async getWorkspace/applyWorkspaceConfig pass) or describe another
        // workspace. Fall back to the LAST-KNOWN set for this workspace so the
        // first paint already shows the workspace's own panels instead of the
        // generic default that gets visibly stripped seconds later. Hint only —
        // never authoritative.
        const hint = $eee07520569aad07$var$_readWsPanelsCache(root);
        return {
            panels: hint ? hint.panels : null,
            live: false,
            governsHouse: hint ? hint.governsHouse : null
        };
    }
    // A panel id that names no real widget is a CONFIG ERROR, not an instruction
    // to hide everything. The decision itself lives in functions/homePanelSet.js
    // so it is testable; the board's reconcile re-runs on every module stash
    // update, so this re-runs the moment a pending module lands.
    const pending = $eee07520569aad07$var$_moduleWidgetsPending(root);
    const verdict = (0, $5BDlp.resolveHomePanelSet)({
        panels: raw,
        knownIds: new Set($eee07520569aad07$var$homeCatalogFor(root).map((w)=>w.id)),
        moduleWidgetsPending: pending
    });
    if (verdict.ghosts.length && !pending) $eee07520569aad07$var$_warnGhostPanels(root, verdict.ghosts, verdict.authoritative);
    const resolved = verdict.panels;
    // Does this set govern the house default ids too? Only a takeover module's
    // (functions/homeDefaultWidgets.js `panelSetHiddenMap`) — read off the
    // record, which the live bag implies has landed.
    const governsHouse = !!(0, $8Zc6q.takeoverModuleRef)(root);
    // Write-through, scope-stamped. Skipped entirely until the active workspace
    // is actually known: writing under the 'default' placeholder is how an
    // unattributable set leaks into a real workspace's key.
    const scope = $eee07520569aad07$var$_wsScope(root);
    try {
        if (scope && scope !== 'default') {
            if (resolved) localStorage.setItem($eee07520569aad07$var$_wsPanelsCacheKey(root), JSON.stringify({
                ws: scope,
                panels: resolved,
                governsHouse: governsHouse
            }));
            else localStorage.removeItem($eee07520569aad07$var$_wsPanelsCacheKey(root));
        }
    } catch (_) {
    /* cache is best-effort */ }
    return {
        panels: resolved,
        live: true,
        governsHouse: governsHouse
    };
};
const $eee07520569aad07$var$_resolveWsPanels = (root)=>$eee07520569aad07$var$_resolveWsPanelsInfo(root).panels;
// A board item's node by widget id — reading only (the launcher drop's
// duplicate check). A module host owns an id whenever it exists, so it is
// preferred over a page widget that carries the same id.
const $eee07520569aad07$var$_findItemById = (id)=>{
    if (typeof document === 'undefined' || !id) return null;
    const sel = CSS.escape(String(id));
    return document.querySelector(`.home-grid > [data-module-widget][data-widget-id="${sel}"]`) || document.querySelector(`.home-grid > [data-widget-id="${sel}"]`);
};
const $eee07520569aad07$var$_isHomeWidgetAlreadyVisible = (id)=>{
    const item = $eee07520569aad07$var$_findItemById(id);
    return !!item && window.getComputedStyle(item).display !== 'none';
};
// The ORDER index a drop at (x, y) lands on: the index of the widget under the
// pointer, else null (a drop on an empty part of the board appends).
const $eee07520569aad07$var$_dropIndexAt = (gridEl, root, x, y)=>{
    const node = gridEl && gridEl.node;
    if (!node) return null;
    for (const child of node.children){
        const id = child.getAttribute && child.getAttribute('data-widget-id');
        if (!id) continue;
        const r = child.getBoundingClientRect();
        if (!r.width || !r.height) continue;
        if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
            const at = $eee07520569aad07$var$_currentHomeLayout(root).findIndex((e)=>e.id === id);
            return at < 0 ? null : at;
        }
    }
    return null;
};
// Returns a BUNDLE KEY (the catalog carries keys) or a module-supplied
// server string — polyglot resolves the first and returns the second verbatim.
const $eee07520569aad07$var$_homeWidgetLabel = (root, id)=>$eee07520569aad07$var$homeCatalogFor(root).find((widget)=>widget.id === id)?.title || 'workspace.home.drop.thisApp';
const $eee07520569aad07$var$_notifyHomeWidgetDrop = (el, root, id, alreadyVisible)=>{
    try {
        const label = el.call('polyglot', $eee07520569aad07$var$_homeWidgetLabel(root, id));
        el.call('openNotification', {
            type: alreadyVisible ? 'info' : 'success',
            title: el.call('polyglot', alreadyVisible ? 'workspace.home.drop.already' : 'workspace.home.drop.added'),
            message: el.call('polyglot', alreadyVisible ? 'workspace.home.drop.alreadyMessage' : 'workspace.home.drop.addedMessage').replace('{app}', label)
        });
    } catch (_) {
    /* Home remains usable if a standalone surface has no toast mount. */ }
};
// The launcher asked to put an app on the board (`_homeAddWidget`, the search
// launcher's "Add to dashboard") — reveal it once, in place.
const $eee07520569aad07$var$_consumeAddWidgetIntent = (root, sdk)=>{
    const id = root && root._homeAddWidget;
    if (!id) return;
    root.update({
        _homeAddWidget: null
    }, {
        preventFetch: true
    });
    if ($eee07520569aad07$var$_isHomeWidgetAlreadyVisible(String(id))) return;
    $eee07520569aad07$var$_restoreWidget(String(id), root, null, sdk || root.sdk, true);
};
// True while an installed module ships a widget under this id — its host owns
// the id, and the page's own copy stands down (see `_widget`).
const $eee07520569aad07$var$_moduleShadows = (root, id)=>!!id && $eee07520569aad07$var$_allModuleWidgetsFor(root).some((w)=>w.id === id);
// Show a hidden widget again. It keeps its place in the order (a hide never
// removes the layout entry); a widget the layout never listed joins at the
// end, or where the launcher dropped it (`dropAt.index`). The hidden map
// persists at once, user choices only (_durableHiddenMap).
const $eee07520569aad07$var$_restoreWidget = (id, root, dropAt, sdk, userGesture)=>{
    if (!id || !root?.update) return;
    if (!$eee07520569aad07$var$_widgetRestorable(id, root)) {
        console.warn("[home] restore blocked \u2014 module widget not granted by this workspace panel set:", id);
        return;
    }
    let layout = (0, $7dUkh.homeLayoutEnsure)($eee07520569aad07$var$_currentHomeLayout(root), [
        {
            id: id,
            size: $eee07520569aad07$var$_defaultWidgetSize(root, id)
        }
    ]);
    const moved = !!(dropAt && Number.isFinite(dropAt.index));
    if (moved) layout = (0, $7dUkh.homeLayoutMove)(layout, id, dropAt.index);
    const cur = {
        ...root._homeHiddenWidgets || {}
    };
    cur[id] = false;
    if (userGesture) $eee07520569aad07$var$_recordUserHidden(root, id, false);
    if (moved) $eee07520569aad07$var$_recordUserLayout(root, layout);
    // The restored card enters with the frame's own fade-up; the cards after it
    // glide aside (functions/homeWidgetMotion.js) instead of jumping.
    const apply = ()=>root.update({
            _homeHiddenWidgets: cur,
            _homeLayout: layout
        });
    if (root._homeOps && typeof root._homeOps.withMotion === 'function') root._homeOps.withMotion(apply);
    else apply();
    // Persist the DURABLE subset — the user's own choices — never `cur`, which
    // also carries the workspace defaults and render clamps (_durableHiddenMap).
    $eee07520569aad07$var$_saveHiddenWidgets(root, $eee07520569aad07$var$_durableHiddenMap(root), sdk);
    if (moved) $eee07520569aad07$var$_persistHomeLayout(root, sdk);
};
// Hide a widget: the hidden map flips and persists at once; its layout entry
// stays, so a restore lands where it was. Two halves, split so the DECISION is
// written before the card takes its time to leave (memory: home prefs durability — never delay a
// decision write). The durable map reads the gesture ledger, not the live
// hidden map, so the order of the two halves cannot change what is saved.
const $eee07520569aad07$var$_persistWidgetHide = (id, root, sdk)=>{
    $eee07520569aad07$var$_recordUserHidden(root, id, true);
    // The durable subset, never the composed map — writing the composed map is
    // what once put 16 defaults and a gate clamp into the server row on one Hide
    // click.
    $eee07520569aad07$var$_saveHiddenWidgets(root, $eee07520569aad07$var$_durableHiddenMap(root), sdk);
};
const $eee07520569aad07$var$_showWidgetHidden = (id, root)=>{
    const cur = {
        ...root._homeHiddenWidgets || {}
    };
    cur[id] = true;
    root.update({
        _homeHiddenWidgets: cur
    });
};
// The board's hide (frame ×, the widget menu): persist now, then the card
// leaves (functions/homeWidgetMotion.js `homeWidgetExit`) and the board hides
// it with its neighbours gliding into the gap.
const $eee07520569aad07$var$_hideWidgetWithMotion = (el, root, id)=>{
    if (!id || !root?.update) return;
    $eee07520569aad07$var$_persistWidgetHide(id, root, el.sdk);
    const grid = el.MainColumn && el.MainColumn.GridContainer;
    el.call('homeWidgetExit', grid, id, ()=>el.call('homeWidgetFlip', grid, ()=>$eee07520569aad07$var$_showWidgetHidden(id, root)));
};
// Toast + delegate — the widget right-click "Share to workspace" / "Make
// personal" / "Delete widget" menu items (AI-CREATED plane only) route here.
// Both wrap functions/aiWidgets.js's mutations (the real gate is server-side;
// these two just report the outcome) with the SAME house toast every other
// dashboard write already uses (openNotification — see loadPrivateData.js's
// identical root.call?.(...) guard for a context with no `el`).
const $eee07520569aad07$var$_setAiWidgetVisibilityWithNotice = async (root, sdk, widget, visibility)=>{
    // `root` is ROOT STATE, not an element (this path has no `el` — see the
    // note above). `root.call` is the same optional hop `openNotification`
    // already used; when it is absent nothing is shown either way, so the
    // translation hop carries the same guard rather than throwing.
    const t = (k)=>root.call ? root.call('polyglot', k) : k;
    const title = widget?.title || t('workspace.widget.untitled');
    const result = await (0, $in9xh.setAiWidgetVisibility)(root, sdk, widget, visibility);
    try {
        if (result.ok) root.call?.('openNotification', {
            title: t(visibility === 'workspace' ? 'workspace.widget.shared' : 'workspace.widget.madePersonal').replace('{title}', title),
            message: t(visibility === 'workspace' ? 'workspace.widget.sharedMessage' : 'workspace.widget.personalMessage'),
            type: 'success'
        });
        else root.call?.('openNotification', {
            title: t('workspace.widget.updateFailed'),
            message: result.error || t('workspace.widget.genericError'),
            type: 'error'
        });
    } catch (_) {
    /* the notification surface isn't reachable from this context */ }
};
const $eee07520569aad07$var$_deleteAiWidgetWithNotice = async (root, sdk, widget)=>{
    const t = (k)=>root.call ? root.call('polyglot', k) : k;
    const title = widget?.title || t('workspace.widget.untitled');
    const result = await (0, $in9xh.deleteAiWidgetDef)(root, sdk, widget);
    try {
        if (result.ok) root.call?.('openNotification', {
            title: t('workspace.widget.deleted').replace('{title}', title),
            type: 'success'
        });
        else root.call?.('openNotification', {
            title: t('workspace.widget.deleteFailed'),
            message: result.error || t('workspace.widget.genericError'),
            type: 'error'
        });
    } catch (_) {
    /* the notification surface isn't reachable from this context */ }
};
// House rows whose gate (`gateRoute`) is OFF for this workspace. They are NOT
// in `homeCatalogFor` — by design, so the drawer never offers them — but a
// board can still carry their card: a layout saved while the gate was on, or
// the static mount. Every consumer that reasons about "what is on the board"
// must treat them as hidden shell widgets, never as foreign ones (gita.pr,
// 2026-09-08: a gated-off `mail-inbox` read as foreign silently dropped every
// layout save for the workspace).
const $eee07520569aad07$var$_gatedOffHouseIds = (root)=>$eee07520569aad07$var$HOME_CATALOG.filter((w)=>w.gateRoute && !$eee07520569aad07$var$shellNavItemVisible(root, w.gateRoute)).map((w)=>w.id);
// The LAST MILE every hidden-map resolver shares, in one place:
//   workspace/app DEFAULTS  ▸  the user's SAVED row  ▸  this document's
//   explicit GESTURES  ▸  the two clamps that are policy, not preference
//   (a module widget the panel set does not grant; a house widget whose route
//   gate is off).
// Extracted because three resolvers once carried their own copy of this
// ordering and DRIFTED twice (one discarded the saved map on a panels
// workspace and then persisted `false`, destroying a real user hide). The
// board now has one resolver (`_resolveBootHidden`, re-run by
// `_reconcileHomeBoard`); only the BASE differs per caller, so only the base
// is a parameter.
const $eee07520569aad07$var$_composeHiddenMap = (base, saved, root, wsVisible)=>{
    const hidden = $eee07520569aad07$var$_enforceProjectGate({
        ...base,
        ...saved || {},
        ...$eee07520569aad07$var$_userHiddenFor(root) || {}
    }, wsVisible, root);
    // A gate that is OFF removes the route, so its card cannot stay on the
    // board — this outranks even an explicit user reveal, which is why it runs
    // after the merge rather than inside it.
    for (const id of $eee07520569aad07$var$_gatedOffHouseIds(root))hidden[id] = true;
    return hidden;
};
// ── Board reconcile ───────────────────────────────────────────────
// ONE idempotent pass, run when the grid starts and on every update it
// subscribes to (workspace, settings, the module stash, the prefs row): the
// hidden map and the layout are recomputed from their live sources and written
// only when they differ. Sources, strongest first: this session's own gestures
// (_userHiddenFor / _userLayoutFor), an unconfirmed write from the last session
// (the prefs outbox), the account record when it exists (`{}` and a null layout
// included — an answer, not an absence), the device cache only when no record
// exists, then the workspace defaults. Nothing here writes to the server: only
// a gesture persists (memory: home prefs durability, four causes). This
// replaces the GridStack-era sync / resync / catch-up passes — the CSS grid has
// no engine to keep in step, so there is nothing to retry.
const $eee07520569aad07$var$_sameFlagMap = (a, b)=>{
    const x = a || {};
    const y = b || {};
    const keys = new Set([
        ...Object.keys(x),
        ...Object.keys(y)
    ]);
    for (const k of keys)if (!!x[k] !== !!y[k]) return false;
    return true;
};
const $eee07520569aad07$var$_sameLayout = (a, b)=>Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((e, i)=>e && b[i] && e.id === b[i].id && e.size === b[i].size);
let $eee07520569aad07$var$_replayedOutboxScope = null;
const $eee07520569aad07$var$_sameColorMap = (a, b)=>{
    const x = a || {};
    const y = b || {};
    const keys = new Set([
        ...Object.keys(x),
        ...Object.keys(y)
    ]);
    for (const k of keys)if ((x[k] || null) !== (y[k] || null)) return false;
    return true;
};
const $eee07520569aad07$var$_reconcileHomeBoard = (el, state)=>{
    const root = (0, $htRH6.untrackedState)(state);
    if (!root || !root.update) return;
    const hidden = $eee07520569aad07$var$_resolveBootHidden(root).hidden;
    const layout = $eee07520569aad07$var$_resolveHomeLayout(root);
    // The colour picks ride the same prefs row, which usually lands after the
    // page's onCreate read the device cache alone.
    const colors = $eee07520569aad07$var$_resolveBootWidgetColors(root);
    const patch = {};
    if (!$eee07520569aad07$var$_sameFlagMap(hidden, root._homeHiddenWidgets)) patch._homeHiddenWidgets = hidden;
    if (!$eee07520569aad07$var$_sameLayout(layout, root._homeLayout)) patch._homeLayout = layout;
    if (!$eee07520569aad07$var$_sameColorMap(colors, root._homeWidgetColors)) patch._homeWidgetColors = colors;
    if (Object.keys(patch).length) root.update(patch, {
        preventFetch: true
    });
    // A write the last session could not confirm lands now, once per scope.
    const scope = $eee07520569aad07$var$_wsScope(root);
    if ($eee07520569aad07$var$_replayedOutboxScope !== scope && root.currentUserId && el && el.sdk) {
        $eee07520569aad07$var$_replayedOutboxScope = scope;
        try {
            $eee07520569aad07$var$_replayPrefsOutbox(el.sdk, root);
        } catch (err) {
            console.warn('[home] prefs outbox replay skipped:', err && err.message);
        }
    }
    $eee07520569aad07$var$_consumeAddWidgetIntent(root, el && el.sdk);
};
// The rows the customize drawer offers: every widget of THIS workspace's
// catalog that the board is currently hiding, minus the module-scoped ids no
// plane grants (`_widgetRestorable` — the SAME call `_restoreWidget` makes, so
// the drawer can never list what a click on it would refuse to restore, and an
// app-plane widget an APP-MODE workspace shows by default is offered back
// after a Hide instead of needing a layout reset).
//
// ONE source, three consumers: the list, the section's own `hide`, and the
// hint copy. They used to disagree — the list filtered through the catalog
// while the section and the hint counted RAW keys of `_homeHiddenWidgets`, a
// map that also carries render clamps (a gated-off house row) and ids no card
// here can show. On a workspace with the mail gate off that reads as "some
// widgets are hidden" above an empty list.
const $eee07520569aad07$var$_drawerHiddenRows = (root)=>{
    const hidden = root?._homeHiddenWidgets || {};
    return $eee07520569aad07$var$homeCatalogFor(root).filter((w)=>hidden[w.id] && $eee07520569aad07$var$_widgetRestorable(w.id, root));
};
// One row in the right customize drawer. State per row is one
// HOME_CATALOG entry; click restores by removing the hidden flag and
// re-registering the existing DOM node with Gridstack. Native HTML5
// drag also lifts the widget id onto the DataTransfer payload so the
// GridContainer's `onDrop` (below) can land it at the cursor's cell.
const $eee07520569aad07$var$_customizeDrawerItem = {
    tag: 'button',
    type: 'button',
    class: 'gs-no-drag',
    draggable: true,
    flow: 'x',
    gap: 'Z',
    align: 'center',
    padding: 'Z B',
    round: 'radiusControl',
    background: 'white.04',
    border: 'hairline dashed white.18',
    color: 'title',
    cursor: 'grab',
    width: '100%',
    textAlign: 'left',
    transition: '120ms ease background, 120ms ease border-color, 120ms ease transform',
    ':hover': {
        background: 'white.08',
        // `accentInk` (the [blueDeep, blueBright] semantic pair) rather than the
        // old rgba(120,160,255,0.55) literal — the home board is cross-themed, and
        // blueBright (#47A8FF) is what that literal was eyeballing in dark.
        borderColor: 'accentInk',
        transform: 'translateY(-1px)'
    },
    ':active': {
        cursor: 'grabbing'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        $eee07520569aad07$var$_restoreWidget(s.id, s.root, null, el.sdk, true);
    },
    // dataTransfer carries the widget id; the grid container's onDrop
    // reads it back and restores the widget at the dropped cell.
    onDragstart: (e, el, s)=>{
        e.dataTransfer.setData('text/x-home-widget-id', s.id || '');
        e.dataTransfer.effectAllowed = 'move';
    },
    Icon: {
        extends: 'Icon',
        name: (el, s)=>s.icon || 'plus',
        color: 'caption'
    },
    // Title + subtitle stack, because TWO CATALOG ROWS CAN CARRY THE SAME TITLE.
    // Measured on the vault board (2026-09-10): `workspace.catalog.assets` and
    // `workspace.catalog.appDocuments` both resolve to "Notes", and `broadcast`
    // and `appBroadcast` both to "Broadcast". The house data card was hidden
    // while its app-shortcut namesake sat on the board, so the drawer read as
    // "Notes is listed hidden, but Notes is right there" — a LABEL collision,
    // not a state one (the drawer and the board read the same composed map, and
    // did so before this change too). The shortcut rows already ship a subtitle
    // in the bundle for their own card headers ("Notes & knowledge", "Tasks &
    // board"), so naming it here disambiguates with copy that already exists.
    Label: {
        flow: 'y',
        gap: '0',
        flex: '1',
        minWidth: '0',
        Title: {
            tag: 'span',
            // A catalog title is a polyglot KEY (`workspace.catalog.*` since the
            // extraction, `apps.widget.*` for platform widgets since 1c6e12d16) — the
            // raw read printed the keys in the drawer (Nika 2026-09-09). polyglot
            // returns its input for a non-key, so a manifest that still carries
            // resolved words renders unchanged.
            text: (el, s)=>el.call('polyglot', s.title || ''),
            fontSize: 'Z2',
            color: 'title',
            overflowWrap: 'anywhere'
        },
        Subtitle: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            lineHeight: '1.5',
            overflowWrap: 'anywhere',
            // The row's OWN `subtitle` — a literal bundle key carried by the
            // catalog entry (see HOME_CATALOG's header). A row without one renders
            // title-only; a module widget's manifest subtitle passes through
            // unchanged, because polyglot returns an already-resolved sentence
            // verbatim.
            text: (el, s)=>s.subtitle ? el.call('polyglot', s.subtitle) : '',
            hide: (el, s)=>!s.subtitle
        }
    },
    Add: {
        tag: 'span',
        text: '+',
        color: 'caption',
        fontSize: 'A',
        fontWeight: '700'
    }
};
// ── The board stylesheet ──────────────────────────────────────────
// The grid's geometry, generated from the ONE constants table
// (functions/homeGridMetrics.js, HOME_WIDGETS_SPEC.md §1): columns by the
// board's own width (a container query on MainColumn, so the assistant dock
// narrowing the page narrows the grid too), square cells capped at the spec's
// cell, the gutter per step, and what each size spans at each column count.
// App shortcuts are never grid items: they live in the App strip above the
// grid (HomeAppStrip, decision H1 A). Pure CSS, so the board paints its final geometry on the first frame — no
// rAF, no ResizeObserver, no engine (a hidden tab has neither; the >8 s blank
// was the GridStack boot waiting on them). Rows are a MINIMUM of one cell and
// grow with their content: a widget never clips (quality law).
//
// Why a stylesheet and not props: the smbls atomic engine does not wrap an
// `@container` key yet (it composes `.cls @container …`, dead CSS). The px
// values are the constants module's own; the lock test pins them to the spec.
// NOTE: single quotes only in these comments, never backticks — the whole
// sheet is one template literal.
// `el` = the page element (or any shell element): the spanAt helpers are
// registered functions, reached through el.call (no new sibling import).
const $eee07520569aad07$var$_injectWidgetStyles = (el)=>{
    if (typeof document === 'undefined' || !el || typeof el.call !== 'function') return;
    let style = document.getElementById('home-widget-styles');
    if (!style) {
        style = document.createElement('style');
        style.id = 'home-widget-styles';
        document.head.appendChild(style);
    }
    // The per-step rules are built by plain concatenation, so the sheet itself
    // stays ONE template literal below (a stray backtick can never split it).
    const steps = (0, $aJYU4.HOME_GRID_STEPS).slice().sort((a, b)=>a.minWidth - b.minWidth);
    const stepRules = steps.map((step)=>{
        // A 'fill' step (two columns, one) spreads its cells over the column
        // with no cap; every other step caps the cell (the base rule's value).
        const cell = step.fill ? 'calc((100cqw - (var(--home-cols) - 1) * var(--home-gap)) / var(--home-cols))' : 'min(' + (0, $aJYU4.HOME_GRID_CELL_CAP) + 'px, calc((100cqw - (var(--home-cols) - 1) * var(--home-gap)) / var(--home-cols)))';
        const vars = '.home-grid, .home-greeting, .home-app-strip, .home-boards-row { --home-cols: ' + step.cols + '; --home-gap: ' + step.gutter + 'px; --home-cell: ' + cell + '; }\n' + // One column drops the square-row rule: a card is as tall as its content.
        '.home-grid { grid-auto-rows: ' + (step.rows === 'auto' ? 'auto' : 'minmax(var(--home-cell), auto)') + '; }';
        // What each size spans at this column count (functions/homeGridMetrics.js),
        // unless the card carries its manifest's span for this step
        // ('--home-span-c-<cols>', WS-HOME-GRID-SPAN-PER-STEP-1 — homeSpanVar).
        const spans = [
            's',
            'm',
            'l',
            'xl'
        ].map((size)=>{
            const span = (0, $aJYU4.homeWidgetSpan)(size, step.cols);
            return ".home-grid > [data-widget-size='" + size + "'] { grid-column: span " + el.call('homeSpanVar', 'c', step.cols, span.c) + '; grid-row: span ' + el.call('homeSpanVar', 'r', step.cols, span.r) + '; }';
        }).join('\n');
        const body = vars + '\n' + spans;
        if (step.minWidth <= 0) return body;
        const query = '@container homeboard (min-width: ' + step.minWidth + 'px)';
        return query + ' {\n' + body + '\n}';
    }).join('\n');
    // A size narrower than its own arrangement (M and XL on one column, XL on
    // two) lays its slot body out as the width it really spans — the slot
    // grid's blocks (HOME_BODY_LAYOUTS, the same four components/HomeWidgetBody
    // declares), picked by homeBodyFit. Each step's rules sit in a BOUNDED
    // range, so nothing has to be undone at a wider step. A body whose own
    // arrangement has a list column but whose fit has none hides the list; its
    // visual list stays in the visual area.
    const bodyLayout = (size)=>(0, $aJYU4.HOME_BODY_LAYOUTS)[size] || (0, $aJYU4.HOME_BODY_LAYOUTS).s;
    const hasList = (size)=>/(^|[\s"])list([\s"]|$)/.test(bodyLayout(size).areas);
    const fitRules = steps.map((step, i)=>{
        const next = steps[i + 1];
        const rules = [
            's',
            'm',
            'l',
            'xl'
        ].map((size)=>{
            const fit = (0, $aJYU4.homeBodyFit)(size, step.cols);
            if (fit === size) return '';
            const at = ".home-grid > [data-widget-size='" + size + "']";
            const to = bodyLayout(fit);
            let out = at + ' .home-widget-body { grid-template-columns: ' + to.columns + '; grid-template-areas: ' + to.areas + '; grid-template-rows: ' + to.rows + '; }';
            if (hasList(size) && !hasList(fit)) out += '\n' + at + ' .home-widget-list:not([data-as-visual]) { display: none; }\n' + at + ' .home-widget-list[data-as-visual] { grid-column: visual; grid-row: visual; }';
            return out;
        }).filter(Boolean).join('\n');
        if (!rules) return '';
        let range = '';
        if (step.minWidth > 0 && next) range = '(' + step.minWidth + 'px <= width < ' + next.minWidth + 'px)';
        else if (step.minWidth > 0) range = '(width >= ' + step.minWidth + 'px)';
        else if (next) range = '(width < ' + next.minWidth + 'px)';
        if (!range) return rules;
        const query = '@container homeboard ' + range;
        return query + ' {\n' + rules + '\n}';
    }).filter(Boolean).join('\n');
    style.textContent = `
    [data-home-board] { container: homeboard / inline-size; }
    .home-grid, .home-greeting, .home-app-strip, .home-boards-row {
      --home-cell: min(${0, $aJYU4.HOME_GRID_CELL_CAP}px, calc((100cqw - (var(--home-cols) - 1) * var(--home-gap)) / var(--home-cols)));
      --home-grid-w: calc(var(--home-cols) * var(--home-cell) + (var(--home-cols) - 1) * var(--home-gap));
    }
    .home-grid {
      display: grid;
      grid-auto-flow: row dense;
      justify-content: center;
      grid-template-columns: repeat(var(--home-cols), var(--home-cell));
      grid-auto-rows: minmax(var(--home-cell), auto);
      gap: var(--home-gap);
    }
    /* The page head, the App strip and the boards row sit on the grid's own
       width. */
    .home-greeting, .home-app-strip, .home-boards-row {
      width: min(100%, var(--home-grid-w));
      margin-inline: auto;
    }
    /* A TAB HOLDS THE HOME (functions/homeView.js): every tab but Dashboard
       is the home's own VIEW, not a layer over the board \u{2014} Main's Fly
       canvas, Chat's conversation, Present's deck, Build's app builder, a
       tab's start screen (each a view part, data-home-view-part). The dashboard's cards
       leave the layout, so the page ends where the view's content ends \u{2014} no
       blank scroll under a short screen \u{2014} and the part on screen takes the
       grid's whole width in the flow. Back on the dashboard the cards return
       in place. */
    .home-grid:not([data-home-view='dashboard']) > :not([data-home-view-part]) { display: none; }
    .home-grid:not([data-home-view='dashboard']) > [data-home-view-part][data-open='true'] { position: relative; grid-column: 1 / -1; }
    ${stepRules}
    ${fitRules}
    ${el.call('homeSpanFitCss')}

    /* Edit mode: every card reads as movable \u{2014} the dashed state ring, the
       one stroke the taste law allows \u{2014} and the lifted card follows the
       pointer above its neighbours. */
    .home-grid > [data-editing] {
      outline: 2px dashed color-mix(in srgb, currentColor 35%, transparent);
      outline-offset: -2px;
    }
    .home-grid > [data-dragging] { cursor: grabbing; }

    /* Bodies not yet on the slot contract keep their two tiers: the compact
       one at S and M, the full one at L and XL. Their old in-card inset goes \u{2014}
       the frame pads every card once. A module body's mount point fills the
       card as a flex column, except a slot body (home-widget-body): its grid
       is its own. */
    .home-grid .widget-tier-mini, .home-grid .widget-tier-full { display: none; }
    .home-grid > [data-widget-size='s'] .widget-tier-mini,
    .home-grid > [data-widget-size='m'] .widget-tier-mini,
    .home-grid > [data-widget-size='l'] .widget-tier-full,
    .home-grid > [data-widget-size='xl'] .widget-tier-full { display: flex; }
    .home-grid .widget-body > [data-key='content']:not(.home-widget-body) {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      min-height: 0;
    }
    .home-grid .widget-body > [data-key='content']:not(.home-widget-body) > * {
      flex: 1 1 auto;
      min-height: 0;
    }
    .home-grid .widget-tier-mini, .home-grid .widget-tier-full {
      flex: 1 1 auto;
      min-height: 0;
      padding: 0;
    }

    /* Phone top inset: the AppHeader sits below env(safe-area-inset-top) on a
       notched device and a spacing token cannot carry env(). */
    @media ${(0, $debL2.default).mobileL} {
      [data-key='content'] [data-key='MainColumn'] {
        padding-top: calc(var(--spacing-D1) + env(safe-area-inset-top));
      }
      /* The phone dock replaces the top header. Keep only the safe area and
         the normal gutter above the destination switch in that layout. */
      html:has([data-phone-nav="true"]) [data-home-board] {
        padding-top: calc(var(--spacing-A) + env(safe-area-inset-top));
      }
    }

    /* Touch: a long press is the context-menu gesture, so iOS must not race it
       with text selection on the board's chrome. */
    @media (pointer: coarse) {
      .home-grid { -webkit-touch-callout: none; -webkit-user-select: none; user-select: none; }
    }
  `;
};
// ── Gridstack persistence ────────────────────────────────────────
// The dashboard layout is persisted PER USER + PER WORKSPACE via the
// existing `workspaceProject.userPreferences` SDK surface. Each
// (user, workspace) pair stores its own homeGridLayout — drag/resize
// in workspace A doesn't leak into workspace B.
//
// localStorage is kept as a fast cache so the initial paint can use
// the most recently saved layout while the server prefs are
// fetched. Once `root.userPrefs` lands, the server copy becomes
// authoritative; subsequent saves write to both.
//
// localStorage cache key is workspace-scoped too so a different
// active workspace doesn't see the previous one's cached layout.
//
// Workspace scope shared by every home-scoped key — the cache keys, the SAVE
// gate (content-scope check) and the explicit `workspaceId` pin.
//
// Precedence is TAB-TRUTH FIRST, deliberately (MULTI_WORKSPACE_TABS §6c/§6e):
//
//   1. `root.workspace.id`  — the workspace THIS TAB is pinned to. Under MWT
//      (default ON) bootShell reconciles it from the `/w/<org-slug>` URL via
//      `resolveActiveWorkspace`, and wireGlobalListeners refuses to drag the
//      tab off it when another tab switches.
//   2. the per-tab pointer — `sessionStorage.activeWorkspace` under MWT,
//      shared `localStorage` when opted out. Available SYNCHRONOUSLY at cold
//      boot, before authBridge has parsed any claims, which is what keeps the
//      first paint on the right workspace's cached layout.
//   3. `jwtClaims.active_workspace_id` — last resort only.
//
// The claim used to come FIRST here, which was the bug: it is SESSION-global,
// re-minted by a switch in ANY tab, so a second tab moving to another
// workspace could repoint this tab's dashboard reads/writes at a workspace it
// was never showing. It is kept as the final fallback for the pre-MWT path
// where neither the root nor the pointer has landed.
//
// Reading the pointer also retires the bespoke `symbols.home.lastWsScope`
// mirror this file used to write: that key duplicated — in SHARED
// localStorage — what activeWorkspacePointer already owns per tab, so under
// MWT it leaked a sibling tab's workspace into this tab's boot paint.
const $eee07520569aad07$var$_wsScope = (root)=>root?.workspace?.id || $eee07520569aad07$var$shellGetActiveWorkspacePointer() || root?.jwtClaims?.active_workspace_id || 'default';
// Kept as a named alias for the READ sites (cache keys / boot painting) so the
// call sites still say which side of the read/write split they are on. Both
// resolve identically now — the pointer supplies at boot exactly the
// last-known scope the separate fallback was invented for.
const $eee07520569aad07$var$_wsScopeForBootRead = $eee07520569aad07$var$_wsScope;
// ── WS-GRID-PERSIST-1 — the home cache scope must be TIME-INVARIANT ──────
//
// Nika, twice: "why when I arrange widgets, and then reload they still load
// messy". Root-caused 2026-08-18 by instrumenting the WRITE, not the board.
//
// The write was never broken. A real drag fired 2 `change` events and wrote
// twice, correctly, to `gridLayout.v3.<current-workspace-id>`. But the only
// layout key on disk was `gridLayout.v3.<a DIFFERENT workspace's id>`, with
// none for the live workspace — while `hiddenWidgets`/`wsPanels` WERE correct.
// So the arrangement saved and the reload read a different key, missed, and
// rendered defaults. That asymmetry is the user-visible tell: WHICH widgets
// show survives a reload, WHERE they sit does not.
//
// Why the two keys differ, given both call the SAME builder: `_wsScope` is a
// fallback chain whose answer depends on WHEN it is asked.
//   * at save time  `root.workspace.id` has landed  → correct id
//   * at cold boot  it has not                      → falls to the pointer
// and with MWT OFF (the default) that pointer is SHARED
// `localStorage.activeWorkspace` — every tab reads the same value, so a
// previously-visited workspace or a sibling tab supplies it.
// `activeWorkspacePointer.js`'s own header says the URL is meant to override
// it at boot "resolved via resolveActiveWorkspace" — but that resolve is
// ASYNC and the cache read beats it. A miss is indistinguishable from "no
// saved layout", so nothing errors and the board silently renders defaults.
//
// FIX: scope on the URL, which names this tab's workspace SYNCHRONOUSLY and
// answers identically at boot and at save. `getWorkspaceRawSegments` is a
// pure regex parse — no resolver, no await, no shared storage, and it cannot
// be contaminated by another tab. That is the property the id lacked; the id
// is not "more correct", it is merely unavailable at the moment we need it.
// ⚠️ SECOND ORDER OF THE SAME BUG, measured live 2026-08-18 (leg 3 of the
// acceptance) — the first fix was necessary and NOT sufficient.
//
// The original defect was a scope that answered differently depending on WHEN
// it was asked. Scoping on the URL fixed that for a FIXED path. But the path
// itself is not fixed: **the app redirects `/w/<org>` → `/w/<org>/<ws>` shortly
// after boot.** So the boot read ran under `bellforge` and every save after the
// redirect wrote under `bellforge~ws_UYAOhQyNjm` — a SECOND key, and the
// arrangement was lost again. Same class, one level up.
//
// The measurement that caught it (innerWidth 1812): a move created
// `…v4.bellforge`; a hard reload matched all 8 live widgets with 0 mismatches;
// a move AFTER the redirect created `…v4.bellforge~ws_UYAOhQyNjm`; and loading
// `/w/bellforge` then rendered `crm-recent` at (8,3) while the last save held
// (8,6) and the shallow key held (0,6) — matching NEITHER.
//
// ⛔ REJECTED FIX — scope on `orgSlug` alone. It is stable across both URL
// shapes, which is why it looks right, but it MERGES every workspace in an org
// onto one layout. That is the cross-workspace bleed this file has fought
// twice, and `homeCacheScope.test.js` already asserts sibling workspaces must
// not share a key. Stability is not the only requirement; correctness of the
// boundary is.
//
// ⛔ ALSO REJECTED — append `seg2` unconditionally. It cannot be known before
// the redirect, so it makes the BOOT read wrong instead of the save. The same
// bug facing the other way, and it would pass a naive static-path test.
//
// THE SHAPE THAT IS ACTUALLY TRUE: `/w/<org>` is not a different scope from
// `/w/<org>/<ws>` — it is the SAME scope, not yet refined. So treat the
// org-only form as PROVISIONAL, and when the redirect refines it, MIGRATE the
// provisional value into the refined key. Identical machinery to the v3→v4
// migration: a scope refinement is a key change like any other.
const $eee07520569aad07$var$_homeScopeParts = (root)=>{
    const path = typeof location !== 'undefined' && location.pathname || '';
    const { orgSlug: orgSlug, seg2: seg2 } = $eee07520569aad07$var$shellGetWorkspaceRawSegments(path);
    if (!orgSlug) // No `/w/` prefix (pre-Scheme-A route, bare load): keep the OLD behaviour
    // rather than inventing a third scope. Unchanged, including its weakness.
    return {
        scope: $eee07520569aad07$var$_wsScopeForBootRead(root),
        provisional: null
    };
    // Refined: the workspace is named. This is the terminal scope.
    if (seg2) return {
        scope: `${orgSlug}~${seg2}`,
        provisional: orgSlug
    };
    // Not yet refined — the redirect has not landed. Usable, but transitional.
    return {
        scope: orgSlug,
        provisional: null
    };
};
const $eee07520569aad07$var$_homeScopeKey = (root)=>$eee07520569aad07$var$_homeScopeParts(root).scope;
const $eee07520569aad07$var$_localCacheKey = (root)=>`symbols.home.gridLayout.v4.${$eee07520569aad07$var$_homeScopeKey(root)}`;
// The pre-fix key, built ONLY from a RESOLVED workspace id — deliberately not
// from `_wsScope`, whose whole problem is that it may hand back a stale
// pointer. Returns null until the id is known, so a migration can never read
// another workspace's layout and graft it onto this one (the exact
// cross-workspace bleed this file has fought twice).
const $eee07520569aad07$var$_legacyLocalCacheKey = (root)=>{
    const id = root?.workspace?.id;
    return id ? `symbols.home.gridLayout.v3.${id}` : null;
};
// One-way migration so the fix does not RESET every saved arrangement — a
// key-format change that silently drops everyone's layout looks exactly like
// the bug it repairs. Copies the legacy value forward once, then removes it so
// a later boot cannot re-migrate stale geometry over newer work.
//
// ⚠️ Emptiness is checked as `parsed === null` / `!Array.isArray`, never as
// `if (!parsed)`: an injected-or-reset `[]` is TRUTHY yet zero-length, so a
// bare truthiness guard treats an empty survivor as real data. Same trap the
// state-layer audit flagged on reset-to-`[]` keys.
const $eee07520569aad07$var$_migrateLegacyLayoutKey = (root)=>{
    const legacyKey = $eee07520569aad07$var$_legacyLocalCacheKey(root);
    if (!legacyKey) return null;
    try {
        const raw = localStorage.getItem(legacyKey);
        if (raw === null) return null;
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed) || parsed.length === 0) {
            localStorage.removeItem(legacyKey);
            return null;
        }
        const target = $eee07520569aad07$var$_localCacheKey(root);
        // Never clobber a layout already saved under the new key.
        if (localStorage.getItem(target) === null) $eee07520569aad07$var$_saveScoped(target, parsed);
        localStorage.removeItem(legacyKey);
        return parsed;
    } catch  {
        return null;
    }
};
// Hidden-widget set persisted separately from the layout (which only tracks
// order and size). A fresh home (no saved value) defaults to
// _DEFAULT_HIDDEN_WIDGETS; the customize drawer offers them back and a
// restore persists (2026-06-09 per Nika).
const $eee07520569aad07$var$_hiddenWidgetsKey = (root)=>`symbols.home.hiddenWidgets.v2.${$eee07520569aad07$var$_wsScopeForBootRead(root)}`;
// Best-effort JSON write to a home-scoped localStorage key.
const $eee07520569aad07$var$_saveScoped = (key, val)=>{
    try {
        localStorage.setItem(key, JSON.stringify(val));
    } catch (err) {
        console.warn('[home] cache write failed:', key, err && err.message);
    }
};
// Persist the hidden-widget set: localStorage (immediate, per-workspace cache)
// plus — when an sdk is supplied — the server profile (home_dashboard_prefs,
// per user × workspace) so a user's panel choices follow them across devices.
const $eee07520569aad07$var$_saveHiddenWidgets = (root, val, sdk)=>{
    // The cache first, synchronously, so the board repaints instantly and an
    // offline device still remembers. It is a MIRROR, not an authority — the
    // server response overwrites it in `_flushPrefsPatch`.
    $eee07520569aad07$var$_saveScoped($eee07520569aad07$var$_hiddenWidgetsKey(root), val);
    // IMMEDIATE, never debounced: hiding a widget is one decision, not a stream,
    // and a 600ms hold is a window the user closes by refreshing to check that it
    // stuck. See the header above `_savePrefsPatch` for the live measurement.
    if (sdk) $eee07520569aad07$var$_savePrefsPatch(sdk, root, {
        hidden_widgets: val
    }, 0, {
        immediate: true
    });
};
// Every widget id THIS workspace can actually render: the live catalog (house
// rows whose gate is on + the active module/app widgets) plus the app-plane
// and AI-plane ids, which are grantable here by construction even when a
// panel set does not name them. The durability filter uses it to refuse a key
// that has no card and no drawer row here.
const $eee07520569aad07$var$_renderableWidgetIds = (root)=>{
    const ids = new Set($eee07520569aad07$var$homeCatalogFor(root).map((w)=>w.id));
    for (const id of $eee07520569aad07$var$_appPlaneWidgetIdsFor(root))ids.add(id);
    for (const id of (0, $in9xh.aiWidgetIdsFor)(root))ids.add(id);
    return ids;
};
// The map to WRITE, given the live composed map. `_homeHiddenWidgets` stacks
// defaults, user choices and render clamps together (that is what the board
// needs); the durable stores must hold the choices alone. The decision itself
// lives in functions/homeHiddenPersist.js so a test can pin it without a
// browser — see that file's header for the three costs of getting it wrong.
// Called by BOTH gesture paths, so cache and server can never disagree.
const $eee07520569aad07$var$_durableHiddenMap = (root)=>(0, $76atT.persistableHiddenMap)({
        stored: $eee07520569aad07$var$_storedHiddenMap(root),
        gestures: $eee07520569aad07$var$_userHiddenFor(root) || {},
        base: $eee07520569aad07$var$_resolveBootHidden(root).baseHidden,
        knownIds: $eee07520569aad07$var$_renderableWidgetIds(root),
        gatedIds: new Set($eee07520569aad07$var$_gatedOffHouseIds(root))
    });
// What is persisted for this workspace RIGHT NOW: the scope-guarded server row
// if it has landed, else the workspace-scoped cache. Same precedence
// `_resolveBootHidden` reads its saved set through, so the durability filter
// prunes exactly what that resolver would have honoured.
// ── THE OUTBOX (WS-HOME-PREFS-PERSIST-ALWAYS-1) ────────────────────────────
//
// A decision the server has not ACKNOWLEDGED is not saved, and the browser is
// free to destroy the request that carries it. Measured on the fixed build,
// 2026-09-10: three hides clicked in one tick fire three (immediate) upserts,
// `location.reload()` runs in the same tick, and the browser ABORTS the newest
// in-flight request — 7 of the 8 ids landed, `app-documents` did not. Making
// the write immediate shrinks that window from 600ms to microseconds; it
// cannot close it, because an in-flight `fetch` dies with its document and the
// SDK has no `keepalive` transport.
//
// So the decision is written down BEFORE it is sent, and crossed off only when
// the server confirms it. The next boot finds the un-crossed entry and re-sends
// it. That is an outbox, and it is the only shape that makes "it always saves"
// true — it also covers the plane-mode case (hide something offline, it lands
// when the connection returns) which no retry timer can.
//
// THIS IS NOT THE CACHE OUTRANKING THE SERVER. The cache is a mirror and never
// wins. The outbox holds one thing: a write the server has not answered yet.
// It is cleared the instant it is confirmed, so it can never accumulate an
// opinion — and it is SCOPE-STAMPED, so a pending write for workspace A stays
// pending while the user is in B and replays when they come back.
//
// One record, not a queue: every write is an idempotent upsert of the FULL map
// for its field, so only the newest matters.
const $eee07520569aad07$var$_PREFS_OUTBOX_KEY = 'symbols.home.prefsOutbox.v1';
const $eee07520569aad07$var$_readPrefsOutbox = ()=>{
    try {
        const raw = localStorage.getItem($eee07520569aad07$var$_PREFS_OUTBOX_KEY);
        const rec = raw ? JSON.parse(raw) : null;
        return rec && typeof rec === 'object' && rec.scope && rec.payload ? rec : null;
    } catch (_) {
        return null;
    }
};
const $eee07520569aad07$var$_writePrefsOutbox = (scope, payload, at)=>{
    try {
        localStorage.setItem($eee07520569aad07$var$_PREFS_OUTBOX_KEY, JSON.stringify({
            scope: scope,
            payload: payload,
            at: at
        }));
    } catch (err) {
        // Storage blocked (private mode / quota). The write still goes out; only
        // the crash-recovery half is unavailable, which is the pre-outbox
        // behaviour rather than a new failure.
        console.warn('[home] prefs outbox write failed:', err && err.message);
    }
};
// Cross it off — but ONLY if the record still describes the write we just had
// confirmed. A newer gesture may have replaced it while this request was in
// flight, and clearing that would drop a decision nobody has sent yet.
const $eee07520569aad07$var$_clearPrefsOutbox = (stamp)=>{
    try {
        const rec = $eee07520569aad07$var$_readPrefsOutbox();
        if (rec && stamp && rec.at !== stamp) return;
        localStorage.removeItem($eee07520569aad07$var$_PREFS_OUTBOX_KEY);
    } catch (_) {
    /* storage blocked — nothing to clear */ }
};
// The hidden map of an UNCONFIRMED write for this workspace, or null. Merged
// over the server row by both readers so the user's own last decision is on
// screen while it is still on its way.
const $eee07520569aad07$var$_pendingOutboxHidden = (root)=>{
    const rec = $eee07520569aad07$var$_readPrefsOutbox();
    if (!rec || rec.scope !== $eee07520569aad07$var$_wsScope(root)) return null;
    const hidden = rec.payload?.hidden_widgets;
    return hidden && typeof hidden === 'object' && !Array.isArray(hidden) ? hidden : null;
};
// The parsed cache for this workspace, or null when there is none. A cache is
// a MIRROR of the last answer the server confirmed — never a second opinion,
// and never a tie-breaker against a row that has landed.
const $eee07520569aad07$var$_cachedHiddenMap = (root)=>{
    try {
        const raw = localStorage.getItem($eee07520569aad07$var$_hiddenWidgetsKey(root));
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
    } catch (_) {
        return null;
    }
};
const $eee07520569aad07$var$_storedHiddenMap = (root)=>{
    const scopedPrefs = $eee07520569aad07$var$_prefsRowForScope(root);
    const { saved: saved } = (0, $hkMuP.resolveSavedPrefsSource)({
        row: scopedPrefs?.hidden_widgets,
        rowScope: scopedPrefs ? $eee07520569aad07$var$_wsScope(root) : null,
        scope: $eee07520569aad07$var$_wsScope(root),
        rowVersion: scopedPrefs?.dashboard_v || 0,
        currentVersion: $eee07520569aad07$var$CURRENT_DASHBOARD_V,
        cache: $eee07520569aad07$var$_cachedHiddenMap(root)
    });
    // An UNCONFIRMED write is still this user's latest decision — without it the
    // next gesture's durable map would be computed from a row that has not heard
    // about the previous one, and would quietly drop it.
    const pending = $eee07520569aad07$var$_pendingOutboxHidden(root);
    return pending ? {
        ...saved || {},
        ...pending
    } : saved || {};
};
// ── WS-HOME-PREFS-GESTURE-1 — an EXPLICIT user choice outranks every
// re-resolve, for the rest of this document's life ────────────────────────
//
// The bug, measured live on vault.pr.symbols.app (2026-09-09, staging shell
// 5f9cd5784, workspace 6a9d6f43208bdbbaed744900): hide an app icon while the
// board is still assembling and it comes BACK on screen ~1.5 s later. The
// trace is unambiguous — `_hideWidgetById` writes `{app-chat: true}` (state +
// cache + a PATCH carrying `app-chat: true`), then `_initGridstack`'s
// `root.update({ _homeHiddenWidgets: hiddenInit })` writes `{app-chat: false}`
// over it. `hiddenInit` comes from `_resolveBootHidden`, whose highest-priority
// source is the SERVER prefs row — and that row is still the PRE-gesture one:
// the write is debounced 600 ms, and the boot's own in-flight prefs GET
// resolves after it and re-publishes the stale row onto
// `root.userDashboardPrefs`. So the resolver is not wrong about its inputs; it
// simply has no way to know a newer, human decision already happened.
//
// The board is interactive from ~0.8 s after mount while module widgets keep
// landing for tens of seconds (see `_moduleWidgetsPending` + the 60 s
// `syncFromPrefs` poll), so this window is not a corner case — it is the
// window in which a person actually clicks. And the damage OUTLIVES the
// session: once state has been reverted, the NEXT gesture persists
// `{ ...root._homeHiddenWidgets, [next]: true }` — a map that now carries an
// explicit `false` for the widget the user hid a moment ago, on BOTH planes.
// That is the shape Nika reported ("hide just icons … this bug happens for a
// long time"): the local cache holds `true` for the icons she hid while the
// server row holds an explicit `false` for the same ids.
//
// The fix is a ledger of what the USER actually asked for, keyed by workspace
// scope, merged LAST by every resolver. Deliberately:
//   • module-scope, not root state — it must survive the very `root.update`
//     calls that clobber the map it protects;
//   • per-document, not persisted — it exists to win the boot race, and the
//     durable answer is the prefs row + cache the same gesture already wrote;
//   • scope-stamped with the SAME `_wsScope` the cache key and
//     `_savePrefsPatch` use, so a workspace switch can never carry one
//     tenant's choice onto another's board;
//   • recorded ONLY at the gesture sites (RemoveBtn, the widget context menu,
//     the customize drawer, drag-drop, the launcher's add intent, the colour
//     palette). The board's own reconcile (`_reconcileHomeBoard`) never
//     records here: recording a resolver's transient opinion would turn it
//     into a permanent user choice — the exact inversion this ledger exists
//     to prevent.
// `_enforceProjectGate` still runs AFTER the merge everywhere, so this can
// never reveal a module widget the workspace's panel set does not grant.
let $eee07520569aad07$var$_userWidgetChoices = {
    scope: null,
    hidden: {},
    colors: {}
};
const $eee07520569aad07$var$_userChoiceBucket = (root)=>{
    const scope = $eee07520569aad07$var$_wsScope(root);
    if ($eee07520569aad07$var$_userWidgetChoices.scope !== scope) $eee07520569aad07$var$_userWidgetChoices = {
        scope: scope,
        hidden: {},
        colors: {}
    };
    return $eee07520569aad07$var$_userWidgetChoices;
};
const $eee07520569aad07$var$_recordUserHidden = (root, id, hiddenFlag)=>{
    if (!id || !root) return;
    $eee07520569aad07$var$_userChoiceBucket(root).hidden[id] = !!hiddenFlag;
};
const $eee07520569aad07$var$_recordUserColor = (root, id, family)=>{
    if (!id || !root) return;
    // `null` is a real choice — "clear back to the neutral solid" — so it is
    // STORED, not deleted. Deleting would let the boot resolver's older
    // non-null value win the merge and repaint the colour the user just cleared.
    $eee07520569aad07$var$_userChoiceBucket(root).colors[id] = family || null;
};
// The ledger for the ACTIVE workspace, or an empty map. Never returns another
// scope's bucket: an unmatched scope reads as "no user choices here yet".
const $eee07520569aad07$var$_userHiddenFor = (root)=>$eee07520569aad07$var$_userWidgetChoices.scope === $eee07520569aad07$var$_wsScope(root) ? $eee07520569aad07$var$_userWidgetChoices.hidden : null;
const $eee07520569aad07$var$_userColorsFor = (root)=>$eee07520569aad07$var$_userWidgetChoices.scope === $eee07520569aad07$var$_wsScope(root) ? $eee07520569aad07$var$_userWidgetChoices.colors : null;
// ── PER-WIDGET COLOUR (2026-09-02) ───────────────────────────────────────
// `{ [widgetId]: <poster family key> }` — the colours the USER picked from
// the widget context menu's "Add color" palette. Persisted exactly like the
// hidden-widget set above, through the SAME scope builder, so a user's
// colours cannot leak across workspaces and cannot survive a workspace
// switch as another workspace's board.
//
// The key SHAPE and the boot PRECEDENCE are the two decisions that can leak a
// board across workspaces or resurrect a cleared colour, so both live in
// functions/homeWidgetColors.js where a test can pin them directly. The
// scope string handed in is the SAME `_wsScopeForBootRead` the hidden-widget
// key uses — one scope resolver in the app, no second copy to drift.
const $eee07520569aad07$var$_widgetColorsKey = (root)=>(0, $74YUs.homeWidgetColorsKey)($eee07520569aad07$var$_wsScopeForBootRead(root));
const $eee07520569aad07$var$_saveWidgetColors = (root, val, sdk)=>{
    $eee07520569aad07$var$_saveScoped($eee07520569aad07$var$_widgetColorsKey(root), val);
    // A colour pick is a decision too — same immediate rule as the hidden set.
    if (sdk) $eee07520569aad07$var$_savePrefsPatch(sdk, root, {
        widget_colors: val
    }, 0, {
        immediate: true
    });
};
// Resolve the boot colour map by the SAME precedence the hidden set uses:
// the scope-guarded server row ▸ the workspace-scoped local cache ▸ empty.
// Pure and synchronous, so the page can call it before the first paint and
// a coloured card never flashes neutral first.
// An empty map is the correct answer for a user who picked no colours — there
// is no default to overwrite, so `{}` needs no special reading here. (The
// hidden set reaches the same conclusion by a different route: see the
// ABSENT-vs-EMPTY note above `_prefsRowForScope`.)
const $eee07520569aad07$var$_resolveBootWidgetColors = (root)=>{
    let raw = null;
    try {
        raw = localStorage.getItem($eee07520569aad07$var$_widgetColorsKey(root));
    } catch (_) {
    /* storage blocked (private mode / quota) → row-only, never a throw */ }
    // Scope-guarded row (see `_prefsRowForScope`) ▸ the workspace-scoped cache.
    const resolved = (0, $74YUs.readHomeWidgetColors)($eee07520569aad07$var$_prefsRowForScope(root), raw);
    // …then this document's own palette gestures (WS-HOME-PREFS-GESTURE-1).
    // Identical race to the hidden set: a re-resolve can read a prefs row that
    // still lags this document's gesture. A
    // stored `null` means "cleared", so it is applied as a DELETE rather than
    // written into the map — a null value would repaint the neutral solid via a
    // truthiness check somewhere downstream instead of removing the entry.
    const chosen = $eee07520569aad07$var$_userColorsFor(root);
    if (!chosen) return resolved;
    const merged = {
        ...resolved
    };
    for (const [id, family] of Object.entries(chosen))if (family) merged[id] = family;
    else delete merged[id];
    return merged;
};
// Set (or, with a falsy `family`, CLEAR) one widget's colour. The single
// write path — the palette in `HomeWidgetColorPicker` is its only caller, and
// it reaches it through `root._homeOps`, the same hook bag the context menu's
// refresh/hide/autolayout actions already use.
const $eee07520569aad07$var$_setWidgetColor = (id, family, root, sdk)=>{
    if (!id || !root?.update) return;
    const next = {
        ...root._homeWidgetColors || {}
    };
    // An explicit `null` for the cleared id, never an absent key. The server
    // merges `widget_colors` PER KEY (PrefsService `_mergeWidgetColorsPatch`):
    // a key present with `null` clears it, but an ABSENT key is left
    // untouched — so deleting it here and sending the remaining map never told
    // the server which id to clear, and the stale colour stayed in its row.
    if (family) next[id] = family;
    else next[id] = null;
    $eee07520569aad07$var$_recordUserColor(root, id, family);
    root.update({
        _homeWidgetColors: next
    });
    $eee07520569aad07$var$_saveWidgetColors(root, next, sdk);
};
// Resolve the boot hidden-widget set by PRECEDENCE: the user's own choices
// (server profile if landed, then the workspace-scoped local cache) ▸ the
// workspace-admin default (home_default_panels) ▸ the global default
// (greeting-only for real users; showcase set for demo). Pure — every source
// is synchronously readable, so the page can call this BEFORE the widgets
// first render (their display factories read _homeHiddenWidgets) and the
// first paint already shows the correct set; the board's reconcile
// (`_reconcileHomeBoard`) re-resolves with the same helper as fresher sources
// land. Only a gesture persists.
// ABSENT vs EMPTY, and the shell no longer has to guess (WS-HOME-PREFS-
// PERSIST-ALWAYS-1). This block used to hold `_nonEmptyMap`, which mapped
// EVERY `{}` to "no saved set" and fell through to localStorage. It was a
// client-side patch over a SERVER ambiguity: `HomeDashboardPref.hiddenWidgets`
// defaulted to `{}`, so a LAYOUT-ONLY write (a drag sends `grid_layout` alone)
// created the row with an empty map and "never written" became
// indistinguishable from "nothing is hidden".
//
// Both halves of that guess were wrong in production, on opposite days:
//   • treating `{}` as an ANSWER wiped a board — row `hidden_widgets: {}` +
//     `grid_layout: [greeting]` while localStorage held the real 31-widget map;
//   • treating `{}` as an ABSENCE let one device's cache outrank the account —
//     measured 2026-09-10 on the Vault workspace, row `{}` and the board still
//     hiding eight widgets, i.e. exactly "it does not save / my other device
//     disagrees".
//
// The fix is at the layer that owns the fact: the column is NULLABLE now and
// the serializer emits `hidden_widgets: null` when it was never written
// (server src/core/models/HomeDashboardPref.js + PrefsService). So:
//   null / absent → never written → the boot cache may paint;
//   {}            → written and empty → authoritative, nothing is hidden.
// `resolveSavedPrefsSource` (functions/homePrefsBootSource.js) is the one
// place that reads that distinction, for the hidden set and for `_storedHiddenMap`.
// The user-prefs row ONLY when it provably belongs to the active workspace.
// The row tags its owner workspace (server serializer; _savePrefsPatch stamps
// the mirror the same way). During a switch the mirror briefly holds the
// PREVIOUS workspace's row, and a row with NO tag is unattributable — both
// read as "no saved prefs" rather than leak another workspace's hidden map /
// layout into this one (2026-07-30 isolation audit #4: _loadLayoutFromPrefs
// had the scope guard; its sibling readers — the hidden_widgets +
// dashboard_v reads — did not).
//
// That sibling gap is CLOSED: hidden_widgets and dashboard_v now both read
// through this function. The comment previously described it as "the
// still-live half" of the cross-workspace overwrite; that assertion was stale
// and is removed rather than softened — a comment claiming a live defect that
// is already fixed buys the next auditor a re-investigation or, worse, a
// re-fix on top of the fix.
//
// ⚠️ ASYMMETRY WITH `_wrongScope`, deliberate, do not "harmonise" without
// reading this: an UNTAGGED row is REJECTED here (`!prefs.workspace_id`) but
// is NOT considered wrong-scope by `_wrongScope` (whose `&&` short-circuits on
// a falsy tag), so reconcile would accept what boot refused. Verified
// 2026-08-16 that the server cannot currently PRODUCE an untagged row:
// `HomeDashboardPref.workspace` is `required: true` and the serializer maps
// `workspace_id: d.workspace ?? null`. The only rows that could be untagged
// are legacy documents written before that constraint existed — mongoose
// `required` gates writes, not documents already on disk. Treat the strict
// reading here as correct and `_wrongScope` as the lenient one.
const $eee07520569aad07$var$_prefsRowForScope = (root)=>{
    const prefs = root?.userDashboardPrefs;
    if (!prefs || !prefs.workspace_id) return null;
    return prefs.workspace_id === $eee07520569aad07$var$_wsScope(root) ? prefs : null;
};
const $eee07520569aad07$var$_resolveBootHidden = (root)=>{
    const catalog = $eee07520569aad07$var$homeCatalogFor(root);
    const globalHidden = root?.isDemo ? Object.fromEntries(catalog.map((w)=>[
            w.id,
            !$eee07520569aad07$var$_DEMO_VISIBLE_WIDGETS.includes(w.id)
        ])) : $eee07520569aad07$var$_globalDefaultHidden(root);
    const wsPanels = $eee07520569aad07$var$_resolveWsPanelsInfo(root);
    const wsVisible = wsPanels.panels;
    // A panel set decides what its writers could SAY — the ids it names, and
    // the house panels it leaves out. Its silence about a house DEFAULT id
    // (the greeting, Next up, the App strip shortcuts — no panel-set writer ever
    // offered them) is not a choice, so those follow the global default: the
    // redesign's defaults reach every workspace an admin has configured
    // (DESIGN-WL-HOME-DEFAULTS-ALL-WORKSPACES-1). A takeover module's panel set
    // keeps governing every id (functions/homeDefaultWidgets.js).
    const wsHidden = Array.isArray(wsVisible) ? (0, $8Zc6q.panelSetHiddenMap)({
        catalogIds: catalog.map((w)=>w.id),
        panels: wsVisible,
        houseDefaultIds: $eee07520569aad07$var$_DEFAULT_VISIBLE_WIDGETS,
        globalHidden: globalHidden,
        panelsGovernHouseDefaults: typeof wsPanels.governsHouse === 'boolean' ? wsPanels.governsHouse : !!(0, $8Zc6q.takeoverModuleRef)(root)
    }) : null;
    const baseHidden = wsHidden || globalHidden;
    // Installed apps' widget defaults join the base too — the one fold every
    // default path uses, so no pass can disagree about an app widget's default
    // state and visibly flip it.
    // Demo keeps its curated set.
    if (!root?.isDemo) $eee07520569aad07$var$_foldAppWidgetDefaults(baseHidden, wsVisible, root);
    // The user's saved set is honoured only when it carries the current
    // dashboard version; an older stamp is ignored once so everyone lands on
    // the new default (the one-time reset-everyone). The bumped cache key (v2)
    // abandons stale localStorage the same way. MUST match the columns the
    // write path (_savePrefsPatch) sends — snake_case, on userDashboardPrefs.
    // WS-HOME-PREFS-PERSIST-ALWAYS-1 — PRESENCE decides, not emptiness. A row
    // that belongs to this scope IS the answer, `{}` included ("nothing is
    // hidden"). The cache may only paint while no such row has landed. The
    // decision itself is pure — functions/homePrefsBootSource.js, whose header
    // carries the live measurement of the cache outranking an empty row.
    const scopedPrefs = $eee07520569aad07$var$_prefsRowForScope(root);
    const { saved: savedFromStore } = (0, $hkMuP.resolveSavedPrefsSource)({
        row: scopedPrefs?.hidden_widgets,
        rowScope: scopedPrefs ? $eee07520569aad07$var$_wsScope(root) : null,
        scope: $eee07520569aad07$var$_wsScope(root),
        rowVersion: scopedPrefs?.dashboard_v || 0,
        currentVersion: $eee07520569aad07$var$CURRENT_DASHBOARD_V,
        cache: $eee07520569aad07$var$_cachedHiddenMap(root)
    });
    // …then this device's UNCONFIRMED write, if it has one. Not a second opinion
    // — a decision still on its way to the server (see the outbox header).
    const _pendingHidden = $eee07520569aad07$var$_pendingOutboxHidden(root);
    const savedHidden = _pendingHidden ? {
        ...savedFromStore || {},
        ..._pendingHidden
    } : savedFromStore;
    // The user's per-widget choices win on top of the base default; a widget
    // they explicitly restored (stored `false`) stays shown, and a widget new
    // to the catalog inherits the base. A workspace panel set (wsHidden —
    // live OR cached) defines that BASE for its dashboard, but it must NOT
    // discard the user's own entries: the previous `wsAuthoritative` discard
    // meant every boot on a panels workspace re-hid what the Customize drawer
    // had just restored-and-persisted — the "dashboard swept my widgets" bug
    // (2026-08-01 per Nika; restores must stick, 2026-06-09 rule). Module-
    // scoped widgets are NOT loosened by this: _enforceProjectGate below
    // clamps them to the panel set AFTER the merge, so user prefs can only
    // ever govern generic widgets.
    // …and an EXPLICIT gesture made in this document outranks even the row
    // (WS-HOME-PREFS-GESTURE-1): this resolver re-runs from `_reconcileHomeBoard`
    // while the board is interactive, and its highest-priority source is a
    // prefs row that is still a debounce — and one in-flight GET — behind.
    const hidden = $eee07520569aad07$var$_composeHiddenMap(baseHidden, savedHidden, root, wsVisible);
    return {
        hidden: hidden,
        savedHidden: savedHidden,
        baseHidden: baseHidden,
        wsVisible: wsVisible
    };
};
// Strip engine-rename artifacts from a stored layout. When BOTH widget planes
// (static v1 twin + v2 module host) briefly held the same gs-id, Gridstack's
// engine de-collided the second registration by renaming it `<id>_<n>`
// (gridstack-engine prepareNode) and wrote that back to the DOM — and the next
// save PERSISTED those phantom rows. Widget ids can never legitimately contain
// an underscore (the manifest normalizer enforces /^[a-z0-9-]+$/ and every
// catalog id is dash-cased), so a `<base>_<n>` row whose base id also exists in
// the same layout is definitively poison: drop it, or every boot re-applies the
// phantom geometry and the corruption can never heal.
const $eee07520569aad07$var$_sanitizeLayout = (layout)=>{
    if (!Array.isArray(layout) || !layout.length) return layout;
    const ids = new Set(layout.map((n)=>n && n.id));
    const clean = layout.filter((n)=>{
        const m = n && typeof n.id === 'string' && n.id.match(/^(.+)_\d+$/);
        return !(m && ids.has(m[1]));
    });
    return clean.length ? clean : layout;
};
const $eee07520569aad07$var$_loadLayoutFromPrefs = (root)=>{
    // Scope-guarded read — see _prefsRowForScope: a mid-switch stale mirror or
    // an unattributable (tag-less) row must never shape this workspace's grid.
    const layout = $eee07520569aad07$var$_prefsRowForScope(root)?.grid_layout;
    return Array.isArray(layout) && layout.length ? $eee07520569aad07$var$_sanitizeLayout(layout) : null;
};
// Fold a PROVISIONAL org-only layout into the refined `org~ws` key once the
// redirect names the workspace. Without this the pre-redirect save is orphaned
// under the shallow key and the post-redirect board reads a different one —
// the exact two-key split measured in leg 3.
//
// Direction is one-way and never destructive: the refined key WINS if it
// already exists (it is strictly better-scoped), and the provisional key is
// removed either way so it cannot go stale and re-surface on a later
// `/w/<org>` load — which is how the (8,3) vs (8,6) vs (0,6) three-way
// disagreement arose.
const $eee07520569aad07$var$_refineProvisionalLayoutKey = (root)=>{
    const { scope: scope, provisional: provisional } = $eee07520569aad07$var$_homeScopeParts(root);
    if (!provisional || provisional === scope) return null;
    const shallowKey = `symbols.home.gridLayout.v4.${provisional}`;
    const refinedKey = `symbols.home.gridLayout.v4.${scope}`;
    try {
        const raw = localStorage.getItem(shallowKey);
        if (raw === null) return null;
        const parsed = JSON.parse(raw);
        localStorage.removeItem(shallowKey);
        // Same `[]`-is-truthy discipline as the v3 migration: an empty array is a
        // miss, never a layout to promote.
        if (!Array.isArray(parsed) || parsed.length === 0) return null;
        if (localStorage.getItem(refinedKey) === null) $eee07520569aad07$var$_saveScoped(refinedKey, parsed);
        return parsed;
    } catch  {
        return null;
    }
};
const $eee07520569aad07$var$_loadLayoutFromCache = (root)=>{
    try {
        // Refinement runs BEFORE the read: if the redirect has landed and a
        // provisional layout is waiting, it must be folded in first or this read
        // misses and falls back to defaults.
        $eee07520569aad07$var$_refineProvisionalLayoutKey(root);
        const raw = localStorage.getItem($eee07520569aad07$var$_localCacheKey(root));
        if (raw === null) {
            // Miss under the URL-scoped key. Before falling back to defaults — which
            // is what LOOKED like "my arrangement was lost" — try the pre-fix
            // id-scoped key. Only fires when the resolved id is already known, so it
            // can never adopt another workspace's layout.
            const migrated = $eee07520569aad07$var$_migrateLegacyLayoutKey(root);
            return migrated ? $eee07520569aad07$var$_sanitizeLayout(migrated) : null;
        }
        const parsed = JSON.parse(raw);
        // `parsed.length === 0` is a real (if unusual) saved state, not a miss, so
        // it must NOT fall through to the legacy read — that would resurrect an
        // arrangement the user had emptied.
        return Array.isArray(parsed) && parsed.length ? $eee07520569aad07$var$_sanitizeLayout(parsed) : null;
    } catch  {
        return null;
    }
};
const $eee07520569aad07$var$_saveLayoutToCache = (root, layout)=>{
    // Consume any provisional key on the way past, so a save cannot leave a
    // shallow sibling behind to be read on a later `/w/<org>` load.
    $eee07520569aad07$var$_refineProvisionalLayoutKey(root);
    return $eee07520569aad07$var$_saveScoped($eee07520569aad07$var$_localCacheKey(root), layout);
};
// ── Layout v2: an order of widgets, one size each ─────────────────
// (functions/homeLayoutV2.js, HOME_WIDGETS_SPEC.md §6.) It lives in the same
// places the 12-column GridStack map did: `grid_layout` on the account row and
// `symbols.home.gridLayout.v4.<scope>` on this device; a 12-column record
// converts once, on read.
let $eee07520569aad07$var$_userLayoutChoice = {
    scope: null,
    layout: null
};
const $eee07520569aad07$var$_recordUserLayout = (root, layout)=>{
    $eee07520569aad07$var$_userLayoutChoice = {
        scope: $eee07520569aad07$var$_wsScope(root),
        layout: layout
    };
};
const $eee07520569aad07$var$_userLayoutFor = (root)=>$eee07520569aad07$var$_userLayoutChoice.scope === $eee07520569aad07$var$_wsScope(root) ? $eee07520569aad07$var$_userLayoutChoice.layout : null;
// A reset forgets this session's layout and hide gestures, so the defaults it
// writes are what the board resolves to.
const $eee07520569aad07$var$_forgetHomeGestures = ()=>{
    $eee07520569aad07$var$_userLayoutChoice = {
        scope: null,
        layout: null
    };
    $eee07520569aad07$var$_userWidgetChoices = {
        scope: null,
        hidden: {},
        colors: {}
    };
};
// An unconfirmed layout write from the last session (the outbox), THIS scope.
const $eee07520569aad07$var$_pendingOutboxLayout = (root)=>{
    const rec = $eee07520569aad07$var$_readPrefsOutbox();
    if (!rec || rec.scope !== $eee07520569aad07$var$_wsScope(root)) return null;
    const gl = rec.payload && rec.payload.grid_layout;
    return Array.isArray(gl) ? gl : null;
};
// The state row of any widget the board can render — a page widget's
// declared row, else the active modules' row.
const $eee07520569aad07$var$_widgetRowFor = (root, id)=>$eee07520569aad07$var$_STATIC_WIDGET_ROWS.get(id) || $eee07520569aad07$var$_allModuleWidgetsFor(root).find((w)=>w.id === id) || null;
const $eee07520569aad07$var$_defaultWidgetSize = (root, id)=>{
    const row = $eee07520569aad07$var$_widgetRowFor(root, id);
    return row ? (0, $1Qr8P.homeWidgetDefaultSize)(row) : 's';
};
// The DEFAULT board: every widget this workspace can show, in the reading
// order of its declared cell (static spec geometry, module manifest spec), at
// its declared size — and, when the workspace sets `home_default_panels`, the
// cards that list names first, in ITS order (HOME-DEFAULT-PANELS-ORDER-1: the
// list sets which cards are on AND their order; a cross-app first screen no
// longer depends on each app's manifest coordinates). A member's saved layout
// keeps its own order. The greeting is the page head, not a grid cell.
const $eee07520569aad07$var$_defaultLayoutEntries = (root)=>{
    // Resolve the current module rows once. Looking up each default size through
    // _widgetRowFor re-ran the entire catalog and its visibility gates per card.
    // These indexes live for this pass only: subsequent state changes stay live.
    const moduleWidgets = $eee07520569aad07$var$_allModuleWidgetsFor(root);
    const moduleRows = new Map(moduleWidgets.map((w)=>[
            w.id,
            w
        ]));
    const catalog = $eee07520569aad07$var$homeCatalogFor(root, moduleWidgets);
    const legacy = [];
    const seen = new Set([
        'greeting'
    ]);
    for (const w of $eee07520569aad07$var$_specLayoutFor(root, catalog)){
        if (seen.has(w.id)) continue;
        seen.add(w.id);
        legacy.push(w);
    }
    for (const w of moduleWidgets){
        if (seen.has(w.id)) continue;
        seen.add(w.id);
        const spec = w.spec || {};
        legacy.push({
            id: w.id,
            x: spec.x,
            y: spec.y,
            w: spec.w || 4,
            h: spec.h || 3
        });
    }
    for (const w of catalog){
        if (seen.has(w.id)) continue;
        seen.add(w.id);
        legacy.push({
            id: w.id
        });
    }
    const entries = (0, $7dUkh.homeLayoutFromLegacy)(legacy).map((e)=>{
        const row = $eee07520569aad07$var$_STATIC_WIDGET_ROWS.get(e.id) || moduleRows.get(e.id);
        return {
            id: e.id,
            size: row ? (0, $1Qr8P.homeWidgetDefaultSize)(row) : 's'
        };
    });
    return (0, $7dUkh.homeLayoutOrderBy)(entries, $eee07520569aad07$var$_resolveWsPanels(root));
};
const $eee07520569aad07$var$_resolveHomeLayout = (root)=>{
    const row = $eee07520569aad07$var$_prefsRowForScope(root);
    const saved = $eee07520569aad07$var$_userLayoutFor(root) || $eee07520569aad07$var$_pendingOutboxLayout(root) || (row ? $eee07520569aad07$var$_loadLayoutFromPrefs(root) : $eee07520569aad07$var$_loadLayoutFromCache(root));
    const layout = (0, $7dUkh.homeLayoutNormalize)(Array.isArray(saved) ? saved : []).filter((e)=>e.id !== 'greeting');
    return (0, $7dUkh.homeLayoutEnsure)(layout, $eee07520569aad07$var$_defaultLayoutEntries(root));
};
const $eee07520569aad07$var$_currentHomeLayout = (root)=>Array.isArray(root && root._homeLayout) && root._homeLayout.length ? root._homeLayout : $eee07520569aad07$var$_resolveHomeLayout(root);
// Persist the live layout at once — a reorder or a size pick is a decision,
// never debounced; the outbox and the single-flight write own its durability.
const $eee07520569aad07$var$_persistHomeLayout = (root, sdk)=>{
    const layout = $eee07520569aad07$var$_currentHomeLayout(root);
    $eee07520569aad07$var$_recordUserLayout(root, layout);
    $eee07520569aad07$var$_saveLayoutToCache(root, layout);
    if (sdk) $eee07520569aad07$var$_savePrefsPatch(sdk, root, {
        grid_layout: layout
    }, 0, {
        immediate: true
    });
};
// Live reorder while a card is dragged — persisted on the drop.
const $eee07520569aad07$var$_moveHomeWidget = (root, id, targetId)=>{
    const layout = $eee07520569aad07$var$_currentHomeLayout(root);
    const to = layout.findIndex((e)=>e.id === targetId);
    if (to < 0) return;
    const next = (0, $7dUkh.homeLayoutMove)(layout, id, to);
    if (next === layout) return;
    $eee07520569aad07$var$_recordUserLayout(root, next);
    root.update({
        _homeLayout: next
    }, {
        preventFetch: true
    });
};
// The keyboard path: one place back or forward past the next VISIBLE widget,
// persisted at once.
const $eee07520569aad07$var$_moveHomeWidgetBy = (root, id, delta, sdk)=>{
    const layout = $eee07520569aad07$var$_currentHomeLayout(root);
    const from = layout.findIndex((e)=>e.id === id);
    if (from < 0) return;
    const hidden = root._homeHiddenWidgets || {};
    let to = from + delta;
    while(to > 0 && to < layout.length - 1 && hidden[layout[to].id])to += delta;
    to = Math.max(0, Math.min(layout.length - 1, to));
    if (to === from) return;
    const next = (0, $7dUkh.homeLayoutMove)(layout, id, to);
    $eee07520569aad07$var$_recordUserLayout(root, next);
    root.update({
        _homeLayout: next
    }, {
        preventFetch: true
    });
    $eee07520569aad07$var$_persistHomeLayout(root, sdk);
};
const $eee07520569aad07$var$_setHomeLayout = (root, layout, opts, sdk)=>{
    const next = (0, $7dUkh.homeLayoutNormalize)(layout);
    $eee07520569aad07$var$_recordUserLayout(root, next);
    root.update({
        _homeLayout: next
    }, {
        preventFetch: true
    });
    if (!opts || opts.persist !== false) $eee07520569aad07$var$_persistHomeLayout(root, sdk);
};
// A size pick from edit mode — never below the widget's own minimum.
const $eee07520569aad07$var$_setHomeWidgetSize = (root, id, size, sdk)=>{
    const row = $eee07520569aad07$var$_widgetRowFor(root, id);
    const min = row && (row.minSize || row.spec && row.spec.minSize);
    const next = (0, $7dUkh.homeLayoutSetSize)($eee07520569aad07$var$_currentHomeLayout(root), id, size, min);
    $eee07520569aad07$var$_recordUserLayout(root, next);
    root.update({
        _homeLayout: next
    }, {
        preventFetch: true
    });
    $eee07520569aad07$var$_persistHomeLayout(root, sdk);
};
// Accumulate an arbitrary patch (grid_layout, hidden_widgets) and debounce-write
// it to the per-user, per-workspace home_dashboard_prefs row via the
// workspaceProject API. The row's columns ARE grid_layout / hidden_widgets /
// dashboard_v; the /sb proxy pins user_id + workspace_id server-side, so we send
// only the data columns. Every write stamps the current dashboard version so a
// user who has customized is exempt from the next reset-everyone. The merged set
// is mirrored onto root.userDashboardPrefs immediately for cross-component reads.
let $eee07520569aad07$var$_savePrefsTimer = null;
let $eee07520569aad07$var$_pendingPrefsPatch = null;
let $eee07520569aad07$var$_pendingPrefsScope = null;
// Transport hiccups are ROUTINE, not exceptional: the API restarts under
// nodemon in dev and rolls during a deploy in prod, and every in-flight request
// in that window fails with a bare "Failed to fetch". Swallowing those (the old
// behaviour) meant a drag made in that window stayed correct on screen and in
// localStorage while never reaching the server — so it came back wrong on the
// next device, or after a cache clear. The write is an idempotent upsert of the
// full payload, so retrying is always safe.
const $eee07520569aad07$var$_PREFS_MAX_RETRIES = 3;
// COALESCING IS FOR STREAMS, NOT FOR DECISIONS (WS-HOME-PREFS-PERSIST-ALWAYS-1).
//
// The debounce below existed for one real reason: a drag emits a burst of
// gridstack change events and each one carries a whole layout. Hiding a widget
// is not that. It is ONE deliberate act, and holding it for 600ms put the
// user's decision in a window they can end at any moment — and they do, because
// the natural thing to do after hiding something is to refresh and check that
// it stuck.
//
// MEASURED, live on vault.pr.symbols.app (staging shell f6ce7c87e, Vault
// workspace 6a9d6f43208bdbbaed744900, 2026-09-10). Hide `app-agents`,
// `app-people`, `app-documents` and reload in the same tick:
//   • localStorage cache → 8 hidden ids (written synchronously by the gesture);
//   • server row         → 5 hidden ids, the three newest MISSING;
//   • after the reload   → all three back on screen, because boot correctly
//                          prefers the row and the row never heard about them.
// That is Nika's report, exactly, and it is the whole bug: the PUT died with
// the document. No error was raised anywhere — the timer simply never fired.
//
// So the write path now takes the kind of change into account. `immediate`
// writes go out on the spot (a hide, a restore, a colour pick, a reset);
// `grid_layout` keeps its 600ms coalesce because it is a stream. Every write
// carries the FULL map for its field and the upsert is idempotent, so several
// in flight at once cannot corrupt anything — the newest simply wins, which
// `_prefsWriteSeq` below enforces on the RESPONSE side too.
const $eee07520569aad07$var$_PREFS_DEBOUNCE_MS = 600;
// Monotonic write id. A response may land out of order (a retry that succeeds
// after a newer write already did), and adopting an older server row would
// undo the newer decision on screen. Only the newest write's response is
// adopted; older ones are acknowledged and discarded.
let $eee07520569aad07$var$_prefsWriteSeq = 0;
// Bumped every time a decision is QUEUED. The outbox record carries the value
// it had when it was written, so a confirmation can only cross off the record
// it actually sent — a newer decision queued mid-flight keeps its own entry.
let $eee07520569aad07$var$_outboxStamp = 0;
// How to flush whatever is pending, captured at queue time so the page-hide
// listener below needs no closure over a render.
let $eee07520569aad07$var$_pendingPrefsFlush = null;
// Mark/clear the "your change is not saved" state. Never silent: a decision the
// server did not accept must be visible, or the user learns to distrust the
// board. Cleared by the next success.
const $eee07520569aad07$var$_setPrefsUnsaved = (root, unsaved, err)=>{
    if (!root?.update) return;
    if (!!root._homePrefsUnsaved === !!unsaved) return;
    root.update({
        _homePrefsUnsaved: !!unsaved
    });
    if (!unsaved) return;
    try {
        root.call?.('openNotification', {
            type: 'error',
            title: root.call?.('polyglot', 'workspace.home.prefs.notSavedTitle'),
            message: root.call?.('polyglot', 'workspace.home.prefs.notSavedMessage') || err && err.message
        });
    } catch (_) {
    /* the notice is best-effort; the flag is the contract */ }
};
// Issue the accumulated patch NOW. Split out of `_savePrefsPatch` so three
// callers share one body: the debounce timer, an `immediate` write, and the
// page-hide flush.
// SINGLE-FLIGHT, and it is a correctness rule rather than a politeness one.
// Making a decision write IMMEDIATE meant a burst of clicks issued a request
// each, every one an upsert of the FULL map — and HTTP does not promise
// arrival order. Measured on the fixed build (2026-09-10, three hides in one
// tick): the third request carried all three ids, the second carried two, the
// SECOND arrived last, and the row settled at two. An older payload won.
// So one request at a time: a write requested while one is in flight is merged
// into `_pendingPrefsPatch` and sent when the current one settles. The newest
// value always goes last, a burst collapses to at most two requests, and the
// abort window shrinks with the request count.
let $eee07520569aad07$var$_prefsInFlight = null;
async function $eee07520569aad07$var$_flushPrefsPatch(sdk, root, scope, attempt, opts = {}) {
    // Already sending. The caller's patch is in `_pendingPrefsPatch` (merged by
    // `_savePrefsPatch` before it called us) and the tail below will send it.
    if ($eee07520569aad07$var$_prefsInFlight) return $eee07520569aad07$var$_prefsInFlight;
    const merged = $eee07520569aad07$var$_pendingPrefsPatch || {};
    $eee07520569aad07$var$_pendingPrefsPatch = null;
    if (!Object.keys(merged).length) return;
    if (!root?.currentUserId || !sdk?.execute) return;
    // The claim flipped while the write was debouncing — the snapshot belongs
    // to the previous workspace; writing it now would cross-tenant clobber.
    if ($eee07520569aad07$var$_wsScope(root) !== scope) return;
    const payload = {
        ...merged,
        dashboard_v: $eee07520569aad07$var$CURRENT_DASHBOARD_V
    };
    const seq = ++$eee07520569aad07$var$_prefsWriteSeq;
    // The outbox entry was written at QUEUE time (`_savePrefsPatch`), so a
    // decision is recoverable even if it never reaches this function — a tab
    // closed while another write was in flight, for instance. Read the stamp it
    // carries so the confirmation below crosses off exactly this record.
    const stamp = $eee07520569aad07$var$_outboxStamp;
    root.update({
        userDashboardPrefs: {
            ...root.userDashboardPrefs || {},
            ...payload,
            workspace_id: scope
        }
    });
    // workspaceId pins the row server-side (readExplicitWorkspaceId) so the
    // write is bound to the workspace the snapshot was taken in, not to
    // whatever claim is active when the request lands. The 'default'
    // fallback scope isn't a real workspace id — leave the server on its
    // claim resolution there.
    const request = sdk.execute('workspaceProject.homeDashboardPrefs', 'update', {
        payload: payload,
        ...scope !== 'default' ? {
            workspaceId: scope
        } : {}
    });
    $eee07520569aad07$var$_prefsInFlight = request;
    try {
        const stored = await request;
        // RECONCILE TO WHAT THE SERVER STORED. The row is the source of truth and
        // the write is not a promise that it took our value verbatim — the tenancy
        // guard drops a provably foreign id (server widgetTenancy.js). Adopting the
        // response is what keeps the board, the cache and the account in agreement
        // instead of three hopeful copies.
        if (seq === $eee07520569aad07$var$_prefsWriteSeq && $eee07520569aad07$var$_wsScope(root) === scope && stored && typeof stored === 'object') {
            root.update({
                userDashboardPrefs: {
                    ...stored,
                    workspace_id: scope
                }
            });
            // The cache is a MIRROR of the confirmed answer, never a second opinion.
            if (stored.hidden_widgets && typeof stored.hidden_widgets === 'object') $eee07520569aad07$var$_saveScoped($eee07520569aad07$var$_hiddenWidgetsKey(root), stored.hidden_widgets);
        }
        // CONFIRMED — cross it off. Anything still in the outbox after this is a
        // decision the server has genuinely not seen.
        $eee07520569aad07$var$_clearPrefsOutbox(stamp);
        $eee07520569aad07$var$_setPrefsUnsaved(root, false);
    } catch (err) {
        // Re-queue with backoff instead of dropping the change on the floor. Bail
        // out if the workspace moved on — that snapshot no longer belongs to the
        // active scope and re-sending it would be the cross-workspace clobber the
        // scope guards above exist to prevent.
        if (attempt < $eee07520569aad07$var$_PREFS_MAX_RETRIES && $eee07520569aad07$var$_wsScope(root) === scope) {
            // A retry keeps the ORIGINAL urgency: a decision that failed once is not
            // suddenly a stream, and adding the debounce back would re-open the very
            // window this ticket closed.
            setTimeout(()=>$eee07520569aad07$var$_savePrefsPatch(sdk, root, merged, attempt + 1, opts), 800 * Math.pow(2, attempt));
            return;
        }
        console.warn(`[home] save dashboard prefs failed after ${attempt + 1} attempt(s):`, err && err.message);
        $eee07520569aad07$var$_setPrefsUnsaved(root, true, err);
    } finally{
        $eee07520569aad07$var$_prefsInFlight = null;
        // Whatever the user decided while this request was in the air goes NOW,
        // and it goes last — that is what makes the newest value the stored one.
        if ($eee07520569aad07$var$_pendingPrefsPatch && Object.keys($eee07520569aad07$var$_pendingPrefsPatch).length) $eee07520569aad07$var$_flushPrefsPatch(sdk, root, $eee07520569aad07$var$_wsScope(root), 0, opts);
    }
}
const $eee07520569aad07$var$_savePrefsPatch = (sdk, root, patch, attempt = 0, opts = {})=>{
    const scope = $eee07520569aad07$var$_wsScope(root);
    // A patch queued for a DIFFERENT workspace must never merge with (or ride
    // the timer of) the previous one — drop the stale pending data.
    if ($eee07520569aad07$var$_pendingPrefsScope !== scope) $eee07520569aad07$var$_pendingPrefsPatch = null;
    $eee07520569aad07$var$_pendingPrefsScope = scope;
    // A RETRY carries an OLDER snapshot than anything queued since it failed, so
    // it merges UNDERNEATH the pending patch — a re-sent stale value must never
    // clobber a fresher one the user produced while the retry was waiting.
    $eee07520569aad07$var$_pendingPrefsPatch = attempt ? {
        ...patch,
        ...$eee07520569aad07$var$_pendingPrefsPatch || {}
    } : {
        ...$eee07520569aad07$var$_pendingPrefsPatch || {},
        ...patch
    };
    // WRITE IT DOWN THE MOMENT IT IS DECIDED — before any request exists. From
    // here the decision survives an aborted request, a closed tab, a crash and
    // an offline device; the next boot finds it un-crossed-off and re-sends it.
    // See the outbox header above `_PREFS_OUTBOX_KEY`.
    $eee07520569aad07$var$_outboxStamp += 1;
    $eee07520569aad07$var$_writePrefsOutbox(scope, {
        ...$eee07520569aad07$var$_pendingPrefsPatch || {},
        dashboard_v: $eee07520569aad07$var$CURRENT_DASHBOARD_V
    }, $eee07520569aad07$var$_outboxStamp);
    // Remember how to flush whatever is pending when the document goes away.
    $eee07520569aad07$var$_pendingPrefsFlush = {
        sdk: sdk,
        root: root,
        scope: scope
    };
    $eee07520569aad07$var$_bindPrefsHideFlush();
    if ($eee07520569aad07$var$_savePrefsTimer) clearTimeout($eee07520569aad07$var$_savePrefsTimer);
    if (opts.immediate) {
        $eee07520569aad07$var$_flushPrefsPatch(sdk, root, scope, attempt, opts);
        return;
    }
    $eee07520569aad07$var$_savePrefsTimer = setTimeout(()=>{
        $eee07520569aad07$var$_savePrefsTimer = null;
        $eee07520569aad07$var$_flushPrefsPatch(sdk, root, scope, attempt, opts);
    }, $eee07520569aad07$var$_PREFS_DEBOUNCE_MS);
};
// Re-send a decision the server never acknowledged (see the outbox header).
// Called once per home boot, AFTER the prefs row has had its chance to land,
// so a confirmed write is already crossed off and this is a no-op for
// everybody whose last write completed normally.
//
// Idempotent by construction: the payload is a full-map upsert, so re-sending
// one that DID land (only its response was lost) changes nothing.
const $eee07520569aad07$var$_replayPrefsOutbox = (sdk, root)=>{
    const rec = $eee07520569aad07$var$_readPrefsOutbox();
    if (!rec || !sdk?.execute || !root?.currentUserId) return false;
    const scope = $eee07520569aad07$var$_wsScope(root);
    // A pending write for ANOTHER workspace stays pending — it replays when the
    // user returns there, and must never land under this workspace's row.
    if (rec.scope !== scope) return false;
    $eee07520569aad07$var$_savePrefsPatch(sdk, root, rec.payload, 0, {
        immediate: true
    });
    return true;
};
const $eee07520569aad07$var$_saveLayoutToPrefs = (sdk, root, layout)=>$eee07520569aad07$var$_savePrefsPatch(sdk, root, {
        grid_layout: layout
    });
// LAST CHANCE for a coalescing write. `grid_layout` is the only field still
// debounced, so a drag finished inside the last 600ms of the document's life
// would otherwise be lost the same way the hides were. `pagehide` is the event
// that fires for a reload, a same-tab navigation and a tab close alike;
// `visibilitychange → hidden` catches the mobile/background path that never
// fires `pagehide`. Both are cheap and idempotent — the flush is a no-op when
// nothing is pending.
const $eee07520569aad07$var$_flushPendingPrefsOnHide = ()=>{
    if (!$eee07520569aad07$var$_pendingPrefsPatch || !$eee07520569aad07$var$_pendingPrefsFlush) return;
    if ($eee07520569aad07$var$_savePrefsTimer) {
        clearTimeout($eee07520569aad07$var$_savePrefsTimer);
        $eee07520569aad07$var$_savePrefsTimer = null;
    }
    const { sdk: sdk, root: root, scope: scope } = $eee07520569aad07$var$_pendingPrefsFlush;
    $eee07520569aad07$var$_flushPrefsPatch(sdk, root, scope, 0);
};
// The latch is MODULE scope, never a `window` flag (Rule 64): this module is
// evaluated once per document, which is exactly the lifetime the listeners need.
let $eee07520569aad07$var$_hideFlushBound = false;
const $eee07520569aad07$var$_bindPrefsHideFlush = ()=>{
    if ($eee07520569aad07$var$_hideFlushBound || typeof window === 'undefined') return;
    $eee07520569aad07$var$_hideFlushBound = true;
    window.addEventListener('pagehide', $eee07520569aad07$var$_flushPendingPrefsOnHide);
    window.addEventListener('visibilitychange', ()=>{
        if (typeof document !== 'undefined' && document.visibilityState === 'hidden') $eee07520569aad07$var$_flushPendingPrefsOnHide();
    });
};
// Discard any debounced grid_layout/hidden_widgets write still in flight.
// RESET-LAYOUT-1: ResetBtn calls this FIRST, before stamping its own reset
// payload — without it, a drag/resize made in the ~600ms before the click
// (the pending patch this cancels) can flush its STALE pre-reset geometry
// to the server AFTER the reset's explicit `grid_layout: null` write,
// silently resurrecting the exact size/position Reset was meant to clear.
// Full reload gives that stale timer ample time to fire first — this app's
// own boot can run seconds long (see the 60s syncFromPrefs poll below).
const $eee07520569aad07$var$_cancelPendingPrefsSave = ()=>{
    if ($eee07520569aad07$var$_savePrefsTimer) {
        clearTimeout($eee07520569aad07$var$_savePrefsTimer);
        $eee07520569aad07$var$_savePrefsTimer = null;
    }
    $eee07520569aad07$var$_pendingPrefsPatch = null;
};
// "Reset layout to defaults" — in place, no reload: forget this session's
// gestures and re-resolve. The drawer's reset has just written the account
// row (`grid_layout: null`, default hides), so the board falls back to the
// declared default order and sizes.
const $eee07520569aad07$var$_resetLayoutInPlace = (root)=>{
    if (!root || !root.update) return false;
    $eee07520569aad07$var$_forgetHomeGestures();
    root.update({
        _homeLayout: $eee07520569aad07$var$_resolveHomeLayout(root),
        _homeHiddenWidgets: $eee07520569aad07$var$_resolveBootHidden(root).hidden
    }, {
        preventFetch: true
    });
    return true;
};
// True while the workspace's module / app routes are still loading — the
// window in which a saved layout can name widgets that have not rendered yet.
// The page now shows before the apps finish (boot fix step 2), so on an
// apps-only workspace the loader flag, the module stash and the published
// list can all be empty here: the workspace RECORD's declared app list (the
// source the home signals and Next up read) keeps the window open.
const $eee07520569aad07$var$_moduleRoutesPending = (root)=>{
    if (!root) return false;
    // Apps still setting up after the reveal (boot fix step 4b): an app's widgets
    // publish only after its page wrap, so its saved cells keep their skeletons.
    if (root._appsSettingUp === true) return true;
    if (root._appRoutesSettled === true) return false;
    // Only INSTALLED APP entries count (installedAppRefs, the one shared reader):
    // the list also holds server-managed rows that are not apps (the
    // records-grant `legacy-backfill` row) — they never load and publish no widget.
    return !!(root._dataLoading || root.workspaceProject || (0, $g7CNh.installedAppRefs)(root.workspaceSettings).length > 0 || (0, $g7CNh.installedAppRefs)(root.workspace?.settings).length > 0 || Array.isArray(root.workspaceApps) && root.workspaceApps.length);
};
// Saved cells whose widget is still on its way hold a skeleton in their final
// place (HomeWidgetPending), so the board never reflows when it lands. Once
// the routes settle, an entry nobody rendered is simply not shown.
const $eee07520569aad07$var$_pendingWidgetRows = (root)=>{
    if (!$eee07520569aad07$var$_moduleRoutesPending(root)) return [];
    const layout = Array.isArray(root && root._homeLayout) ? root._homeLayout : [];
    const hidden = root && root._homeHiddenWidgets || {};
    const live = new Set([
        ...$eee07520569aad07$var$_STATIC_WIDGET_ROWS.keys(),
        ...$eee07520569aad07$var$_allModuleWidgetsFor(root).map((w)=>w.id)
    ]);
    // Once the apps list is published, only a widget an app of THIS member still
    // sets up keeps its skeleton (boot fix step 4b: `pendingWidgets`); a saved cell
    // of an app the member cannot use drops then, not after every app settled.
    const arriving = Array.isArray(root && root.workspaceApps) ? new Set(root.workspaceApps.flatMap((a)=>a && Array.isArray(a.pendingWidgets) ? a.pendingWidgets : [])) : null;
    return layout.filter((e)=>e && !live.has(e.id) && !hidden[e.id]).filter((e)=>!arriving || arriving.has(e.id) || !root._appsSettingUp).map((e)=>({
            key: 'pending-' + e.id,
            id: e.id,
            title: '',
            icon: 'star',
            size: e.size
        }));
};
// The dashboard's canonical tab title — helmet writes it when the page mounts,
// and the AppWindow PageSlot's close branch RE-writes it (the keep-alive slot
// leaves the last panel page mounted, so its helmet title would otherwise
// linger on the tab after close).
//
// Through `pageTitle`, the helper every other page uses: it resolves the key in
// the session language and appends the brand. This was the literal `Home / …`,
// so the dashboard was the one tab that stayed English on a Georgian workspace
// (measured live, 2026-09-20).
const $eee07520569aad07$var$HOME_TITLE = (el)=>el.call('pageTitle', 'shell.app.home');
const $eee07520569aad07$export$f22da7240b7add18 = {
    // AppPage = full-bleed flow-x layout (like /chat): a flush left rail and
    // the scrolling main column, each scrolling independently.
    extends: 'AppPage',
    metadata: (el)=>({
            title: $eee07520569aad07$var$HOME_TITLE(el)
        }),
    height: '100%',
    // NOTE: no per-page module-rail clearance here anymore — the SHELL root
    // pads left by the rail's live width for EVERY in-flow page when the
    // active module declares chrome.rail (app.js shellApp paddingLeft), the
    // chat-sidebar-style docked column done once at the root instead of per
    // surface (2026-08-14 per Nika "fix the layout on all pages for
    // bellforge sidebar … make workspace more abstract and modular").
    // Page-level base color so the gutter on wide monitors stays in the
    // active theme. The dot grid lives on MainColumn (the scroll container)
    // so dots scroll with content as the user scrolls. Tried moving
    // them up here onto `main` with `overflow: visible` so the body
    // scrolls naturally, but AppPage's grandparent grid clamps
    // height to 100dvh — Gridstack then can't size widgets, and the
    // layout collapses. Keeping the scroll on MainColumn is the
    // working compromise.
    //
    // ONE ground chain (BF-WIDGET-INK-1, 2026-08-16): the page paints the
    // SAME `var(--stage-bg, var(--color-stage))` the shell root and MainColumn
    // paint (canvasBackground.js STAGE_BACKGROUND). It used to hold its own
    // gray15/gray5 — a fourth resolution path between the root and the board
    // that showed as a band in the wide-monitor gutter and beside a docked
    // module rail. `style`, not `background`: a var() chain is theme-agnostic
    // and must not be split into '@dark'/'@light' halves.
    style: {
        background: 'var(--stage-bg, var(--color-stage))'
    },
    // #2312 — the Projects widget showed the PREVIOUS org's projects after the
    // user switched owner/org. onCreate fetches _projectsForActiveOrg once using
    // the boot-time org; the page stays mounted on switch (jwtClaims updates
    // reactively) so the one-shot fetch went stale. Re-fetch whenever the active
    // org id actually changes. Guarded by el.__loadedOrgId so this no-ops on the
    // frequent unrelated root updates.
    onUpdate: (el, s)=>{
        const root = s.root;
        // Per-widget COLOURS are WORKSPACE-scoped, and a workspace switch inside
        // one org never reaches the org guard below — so the re-resolve is keyed
        // on the workspace scope itself, ABOVE that guard. The switch wipe clears
        // `_homeWidgetColors` (state-app.js) and this reads the NEW workspace's
        // row/cache back; without it the board would sit uncoloured until a full
        // reload. Latched on `el.__homeColorScope` (same shape as
        // `el.__loadedOrgId`) so it fires once per scope move, never on the
        // frequent unrelated root updates.
        const colorScope = $eee07520569aad07$var$_wsScopeForBootRead(root);
        if (colorScope !== el.__homeColorScope) {
            el.__homeColorScope = colorScope;
            root.update({
                _homeWidgetColors: $eee07520569aad07$var$_resolveBootWidgetColors(root),
                // A palette left open across the switch points at a widget the new
                // workspace need not have.
                _homeColorPicker: null
            });
        }
        const orgId = root?.jwtClaims?.workspace_org_id || root?.orgs && root.orgs[0]?.id;
        if (!orgId || orgId === el.__loadedOrgId) return;
        el.__loadedOrgId = orgId;
        const orgs = root?.jwtClaims?.orgs || root?.orgs || [];
        const orgSlug = orgs.find((o)=>o.id === orgId)?.slug;
        if (orgSlug && el.sdk?.getProjects) el.sdk.getProjects({
            owner: orgSlug,
            limit: 500
        }).then((res)=>{
            const raw = Array.isArray(res) ? res : res?.data || res?.items || [];
            root.update({
                _projectsForActiveOrg: raw
            });
        }).catch((err)=>console.warn('[home] org-switch getProjects failed:', err && err.message));
        // Received/Given widgets — the org-switch path (loadPrivateData) wipes
        // root.tickets, and _ensureHomeTickets is one-shot, so without this
        // reset the widgets stayed empty until a full reload. Re-arm + re-fetch
        // for the new org.
        root._homeTicketsLoaded = false;
        $eee07520569aad07$var$_ensureHomeTickets(el, root, {
            force: true
        }).catch((err)=>console.warn('[home] org-switch tickets load failed:', err && err.message));
        // Agent roster — `_agentsLoaded`/`_agents` are workspace-scoped since
        // WS-ROOT-STATE-FORM2-WRITE-HOLE-1 (the switch wipe re-arms the shared
        // one-shot gate), and home stays mounted across the switch, so re-run
        // the loader here exactly like the tickets pair above. Idempotent: the
        // gate itself refuses a duplicate while a fetch is in flight.
        root._agentsLoaded = false;
        $eee07520569aad07$var$_loadHomeAgentRoster(el, root);
    },
    // Same data prefetching as before: analytics snapshot for the
    // Analytics widget, chat channels for the sidebar, projects for the
    // Projects widget. After data is in flight, schedule Gridstack init
    // for after the DOM settles.
    onCreate: (el, s)=>{
        if (el.__homeLoaded) return;
        el.__homeLoaded = true;
        const root = s.root;
        // Resolve the hidden set, the colours and the LAYOUT before the widgets
        // first paint: their size / order / display factories read these keys and
        // every source is synchronously readable (the prefs mirror, the
        // workspace-scoped localStorage, the declared defaults), so the first
        // frame is already the final board. The grid's reconcile keeps them in
        // step as late sources land.
        try {
            root.update({
                _homeHiddenWidgets: $eee07520569aad07$var$_resolveBootHidden(root).hidden,
                _homeWidgetColors: $eee07520569aad07$var$_resolveBootWidgetColors(root),
                _homeLayout: $eee07520569aad07$var$_resolveHomeLayout(root)
            });
        } catch (_) {
        /* the grid's own reconcile resolves them */ }
        // Bridge the shell PageSlot to the home's page resolver so a slot opened
        // from the home dashboard resolves through `_appPageFor` (workspaceProject
        // .pages + the lazy `_APP_WINDOW_PAGES` map, then the rest of
        // context.pages, so the ?page= URL sync names every route the pane
        // mounts) — this is what keeps the home's divergent routes
        // (`/tickets`→myView, `/tickets/my`,
        // `/workspace-analytics/logs/users`) mapping to the right page even though
        // the shared router registry serves something else (or nothing) for them.
        // Assigned directly (NOT via root.update) so the function survives — smbls
        // state clones update payloads and would drop a function value. PageSlot's
        // `_defFor` calls this before falling back to context.pages; it is absent on
        // every non-home surface, so /studio /infra /tickets are unaffected.
        root._slotResolve = (path)=>$eee07520569aad07$var$_appPageFor(path, root, el.context);
        // PageSlot FAMILY registry (2026-08-14, Nika-approved partial-UI scope
        // 2): same-family routes share one slot host — the family's chrome
        // (header + controls, resolved via `chromePath` through the same lazy
        // page channel) persists while only the page body swaps. Family
        // classification mirrors analytics/pages/headerControls.js `_family`
        // exactly: LOGS are workspace telemetry wherever their URL lives; the
        // geo map is projects data wherever its URL lives. Assigned directly
        // (not root.update) — functions don't survive the state clone.
        root._slotFamilyFor = (clean)=>{
            const p = (0, $7iFOV.shellStripWorkspacePrefix)(String(clean || '')).split('?')[0];
            const inAnalytics = p === '/analytics' || p.startsWith('/analytics/') || p === '/workspace-analytics' || p.startsWith('/workspace-analytics/') || p === '/logs' || p.startsWith('/logs/');
            if (!inAnalytics) return null;
            if (p.startsWith('/analytics/__slot-chrome') || p.startsWith('/workspace-analytics/__slot-chrome')) return null;
            const workspaceFam = p.includes('/logs') || p.startsWith('/workspace-analytics') && !p.startsWith('/workspace-analytics/map');
            return workspaceFam ? {
                id: 'analytics-workspace',
                chromePath: '/workspace-analytics/__slot-chrome'
            } : {
                id: 'analytics-projects',
                chromePath: '/analytics/__slot-chrome'
            };
        };
        // Restore the home tab title when the shell PageSlot closes: the mounted
        // sub-app's helmet wrote its own title on open, and the slot is keep-alive
        // so nothing re-writes it on close. PageSlot calls this on every close; the
        // currentPath === '/' guard keeps it home-only (a slot closed on /studio etc.
        // leaves that page's title alone). Assigned directly for the same reason as
        // _slotResolve (functions don't survive root.update's clone).
        root._slotOnClose = ()=>{
            if (typeof document !== 'undefined' && (0, $7iFOV.shellStripWorkspacePrefix)(root.currentPath) === '/') {
                (0, $11nI2.applyMetadata)({
                    title: $eee07520569aad07$var$HOME_TITLE(el)
                }, document);
                // Immersive module chrome: these members have no shell chrome and the
                // bare board is not their surface — closing the module page lands
                // them back on the module's landing page instead of stranding them
                // on a chromeless board. Deferred a tick so the slot's own close
                // write settles before the reopen.
                //
                // EXCEPT an admin PREVIEWING a non-admin persona (moduleViewAsActive):
                // their real board exists behind the sheet and the CloseBtn's dismiss
                // is deliberate — this reopen was the SECOND writer that undid it
                // 11ms later (bellf-qa state.update trace, 2026-08-15: X → null →
                // this setTimeout → '/overview'). Same exemption as the CloseBtn.
                // One-shot suppression — moduleGoHome (the rail logo) closes the
                // slot DELIBERATELY to land on home; without this the deferred
                // reopen below undoes that close for immersive members (the same
                // second-writer shape the view-as exemption fixed).
                if (root._slotSkipReopenOnce) {
                    root._slotSkipReopenOnce = false;
                    return;
                }
                if ((0, $7ytvD.moduleImmersiveActive)(root) && !(0, $7ytvD.moduleViewAsActive)(root)) {
                    const landing = (0, $7ytvD.moduleImmersiveLanding)(root);
                    if (landing && $eee07520569aad07$var$_appPageFor(landing, root)) setTimeout(()=>{
                        if (!root._canvasSlot) root.update({
                            _canvasSlot: landing
                        });
                    }, 0);
                }
            }
        };
        // Restore a sub-app opened before a reload (per Nika): a
        // ?page=<route> in the URL re-opens that PageSlot route so the sheet
        // survives a refresh. The PageSlot keeps the param in sync while open and
        // the close buttons clear it. Resolved via _appPageFor so a workspace-MODULE
        // page (root.workspaceProject.pages) restores too — when the module hasn't
        // injected yet at this point, loadWorkspaceProject's own ?page= recovery
        // re-applies it the moment the pages exist.
        try {
            const bootUrl = new URL(window.location.href);
            // Custom Calendar modal bodies are registered by the lazy Calendar
            // package, after the shell ModalRoot is constructed. Replaying an
            // in-app event snapshot during this cold interval pushes a valid layer
            // descriptor with no resolvable body, producing the empty rounded
            // window reported on refresh. Treat hard refresh like closing that
            // transient modal; the RSVP itself has already been persisted. Plain
            // shared `?event=<id>` links carry no snapshot and retain the existing
            // deep-link loading behavior.
            if (bootUrl.searchParams.has('eventSnapshot')) {
                for (const key of [
                    'event',
                    'eventSeries',
                    'eventFingerprint',
                    'eventSnapshot',
                    'eventRsvp'
                ])bootUrl.searchParams.delete(key);
                window.history.replaceState(null, '', bootUrl.toString());
            }
            const pageParam = bootUrl.searchParams.get($eee07520569aad07$var$APP_WINDOW_URL_PARAM);
            if (pageParam && $eee07520569aad07$var$_appPageFor(pageParam, root)) root.update({
                _canvasSlot: pageParam
            });
        } catch (_) {}
        // All widget data loaders (analytics, tickets, chat channels, projects) route
        // through _refreshHomeData so this cold prefetch and the "Refresh"
        // context-menu action never drift. Cold load self-gates tickets (force:false);
        // the menu forces a refetch.
        $eee07520569aad07$var$_refreshHomeData(el, root);
        // #2312 — mark the org we loaded for so onUpdate only re-fetches projects on an
        // actual org switch (not on every unrelated root update).
        el.__loadedOrgId = root?.jwtClaims?.workspace_org_id || root?.orgs && root.orgs[0]?.id;
        // Expose the board's operations to the right-click ContextDropdown
        // (functions/homeContextMenu.js → homeContextAction) and to the widget
        // frame (components/HomeWidgetFrame.js, functions/homeWidgetDrag.js) through
        // root._homeOps — the loaders and the layout live on this page; the
        // registered functions are thin dispatchers that delegate back here.
        // Every change of the board's arrangement plays through ONE motion
        // (functions/homeWidgetMotion.js, DESIGN-WL-HOME-WIDTH-RESIZE-1): the
        // cards read before, the change, then each moved card glides from where
        // it was (FLIP). No motion under reduced motion / a hidden tab — the
        // change simply lands.
        const withMotion = (change, opts)=>el.call('homeWidgetFlip', el.MainColumn && el.MainColumn.GridContainer, change, opts);
        root._homeOps = {
            withMotion: withMotion,
            refresh: ()=>$eee07520569aad07$var$_refreshHomeData(el, root, {
                    force: true
                }),
            // The hide is a decision: it persists at once; the card then leaves
            // (fade + a short fall) and its neighbours close the gap.
            hideWidget: (id)=>$eee07520569aad07$var$_hideWidgetWithMotion(el, root, id),
            // THE SETUP WIZARD's apps step (functions/onboardingWizard.js): the apps
            // it offers, and its picks written in one pass.
            onboardingApps: ()=>$eee07520569aad07$var$_onboardingAppRows(root),
            setAppsShown: (picks)=>$eee07520569aad07$var$_setAppsShown(root, picks, el.sdk),
            // "Add color" ▸ a swatch (or "Default") in HomeWidgetColorPicker.
            // `family` falsy = clear back to the neutral solid.
            setWidgetColor: (id, family)=>$eee07520569aad07$var$_setWidgetColor(id, family, root, el.sdk),
            // AI-CREATED plane manage actions (tickets/opus.md "Per-workspace
            // AI-CREATED widgets" additive remainder) — share/unshare/delete.
            setAiWidgetVisibility: (widget, visibility)=>$eee07520569aad07$var$_setAiWidgetVisibilityWithNotice(root, el.sdk, widget, visibility),
            deleteAiWidget: (widget)=>$eee07520569aad07$var$_deleteAiWidgetWithNotice(root, el.sdk, widget),
            // "Change with AI" (HOME-WIDGET-CHANGE-WITH-AI-1): the card the assistant
            // made (functions/aiWorkspaceOps.js aiCreateWidget `replaces`) takes the
            // place of the card it replaces — the old card's slot and size — and the
            // old card is hidden, restorable from Customize like any hide. False
            // when the old card is not on this board.
            // The old card may be named by its app-qualified ref; homeLayoutCardId
            // resolves it to the id this board lists (else nothing is replaced).
            replaceWidget: (oldRef, newId)=>{
                const layout = $eee07520569aad07$var$_currentHomeLayout(root);
                const oldId = (0, $7dUkh.homeLayoutCardId)(layout, oldRef);
                if (!oldId) return false;
                const next = (0, $7dUkh.homeLayoutReplace)(layout, oldId, newId);
                if (next === layout) return false;
                withMotion(()=>$eee07520569aad07$var$_setHomeLayout(root, next, undefined, el.sdk));
                $eee07520569aad07$var$_hideWidgetWithMotion(el, root, oldId);
                return true;
            },
            // Layout v2 — drag-to-reorder, the keyboard path and the size picker;
            // `setLayout` restores a cancelled drag without persisting.
            // The card under the pointer follows the pointer — only its
            // neighbours glide while it is dragged.
            moveWidget: (id, targetId)=>withMotion(()=>$eee07520569aad07$var$_moveHomeWidget(root, id, targetId), {
                    exclude: [
                        id
                    ]
                }),
            moveBy: (id, delta)=>withMotion(()=>$eee07520569aad07$var$_moveHomeWidgetBy(root, id, delta, el.sdk)),
            setLayout: (layout, opts)=>withMotion(()=>$eee07520569aad07$var$_setHomeLayout(root, layout, opts, el.sdk)),
            persistLayout: ()=>$eee07520569aad07$var$_persistHomeLayout(root, el.sdk),
            // A resize (the corner handle, Shift + arrow, the picker): the card
            // glides to its new cell and is revealed to its new size, and the page
            // brings it into view when it landed outside it.
            setWidgetSize: (id, size)=>withMotion(()=>$eee07520569aad07$var$_setHomeWidgetSize(root, id, size, el.sdk), {
                    resized: id,
                    // after the flush and the glide: the card's FINAL box
                    after: ()=>el.call('homeWidgetReveal', el.MainColumn, el.MainColumn && el.MainColumn.GridContainer, id)
                })
        };
        // The board's grid stylesheet (container queries from the constants table).
        $eee07520569aad07$var$_injectWidgetStyles(el);
    },
    // HomeSidebar removed from the main view — channels / DMs /
    // agents / events now surface from the AppHeader's "Chat"
    // dropdown instead (see shared/components/AppHeader.js).
    // Main column — the dashboard grid + scroll container. AppPage's
    // overflow:hidden + the grandparent's min-h-100dvh together prevent
    // a true browser-window scroll. So MainColumn keeps its own scroll
    // (overflowY:auto + height:100%), and the DOT GRID lives here on
    // the scroll container so dots move with content as the user
    // scrolls — visually the "dots follow scroll" effect. Opacity
    // bumped to 0.12 (from 0.07) for visibility against the page bg.
    // The home board opens straight on its widgets and shows no title, so this
    // is its one `h1`: announced, never seen (design-direction.md §3).
    PageSrTitle: {
        text: '{{ shell.app.home | polyglot }}'
    },
    // The App strip — the Rail (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1, Nika's pick
    // row 1 C, a personal option): BESIDE the board, in the page's own row, so
    // the board narrows to the room that is left (its columns follow its own
    // width) and nothing overlays a card. The same rows as the Dock.
    HomeAppRail: {
        subscribeTo: [
            'workspaceProject',
            'workspaceApps'
        ],
        // The dashboard's, like the Dock: it steps aside while another tab holds
        // the home (functions/homeView.js).
        hide: (el, s)=>$eee07520569aad07$var$_appStripHidden(el, s.root, 'rail') || $eee07520569aad07$var$_tabHoldsHome(el, s.root),
        RailCapsule: {
            Items: {
                children: (el, s)=>$eee07520569aad07$var$_appStripChildren(s.root)
            }
        }
    },
    MainColumn: {
        // The board's container-query root (see _injectWidgetStyles).
        attr: {
            'data-home-board': 'true'
        },
        // `data-customizing` (a flat hook, like AppDialog's dataPresentation) —
        // 'open' while edit mode shows its panel, 'tucked' while the panel is
        // tucked: on a phone the panel is a bottom sheet over the board's lower
        // half, and workspace/app.js gives the board that much room below its last
        // card, so every card can scroll above the sheet. Both keys are read on
        // every run, so both stay tracked.
        dataCustomizing: (el, s)=>{
            const on = !!s.root._homeCustomizeMode;
            const tucked = !!s.root._homeCustomizeDrawerTucked;
            return on ? tucked ? 'tucked' : 'open' : null;
        },
        flow: 'y',
        gap: 'B',
        flex: '1',
        minWidth: '0',
        height: '100%',
        overflowY: 'auto',
        // Top inset D1 (2026-06-08 per Nika "D1 offset from top and
        // bottom") so the first widget sits D1 below the floating header —
        // matching the GridContainer's existing `marginBottom: 'D1'` so the
        // dashboard is symmetrically inset top↔bottom.
        // The bottom track is scroll CLEARANCE for the ~280px BottomPrompt fade
        // zone, not a bottom offset — without it the last widgets sit permanently
        // behind the gradient. The visible bottom breathing room is the
        // GridContainer's D1 marginBottom.
        //
        // ⚠️ D1 STATIC, not G. The clearance is only owed when the composer is
        // actually on screen, and app.js already supplies exactly that:
        //   html[data-shell-route="home"][data-prompt="shown"] … MainColumn
        //     { padding-bottom: max(var(--spacing-G), var(--slot-bottom)) }
        // So the composer case is unchanged. What changes is the case where there
        // is no composer to clear: this used to reserve ~324px of dead space
        // regardless, which showed up as a large empty area under a short board
        // AND pushed the page into a scrollbar it did not need (Nika: "dont give
        // vertical scroll and big empty area if not needed"). Immersive members —
        // every non-admin on a takeover module like bellforge — never see the
        // composer at all (_composerVisible in app.js), so they were paying the
        // full reservation for something that is never rendered for them.
        padding: 'D1 C D1 C',
        maxWidth: '100%',
        boxSizing: 'border-box',
        '@mobileL': {
            gap: 'B',
            // Side gutters + scroll clearance shrink on a phone, the TOP inset does
            // NOT: the AppHeader doesn't shrink there, it GROWS (the mobile nav pill
            // measures ~63px against the desktop header's 48px). The old `B` top
            // (~26px) parked the first widget row ~37px UNDER the navbar, so the
            // greeting card's avatar was sliced off on every phone load with no white
            // space anywhere between the chrome and the board (2026-08-02 per Nika
            // "top part gets cut" + "add reasonable top padding"). D1 — the same
            // token the desktop inset uses — clears the phone header with ~21px of
            // open space, and the mobileL rule in _injectWidgetStyles tops it up by
            // env(safe-area-inset-top) for notched devices.
            padding: 'D1 A F A',
            overflowX: 'clip'
        },
        style: {
            // Board surface = the ONE ground chain every workspace surface paints
            // (canvasBackground.js STAGE_BACKGROUND, BF-WIDGET-INK-1): the active
            // module's `--stage-bg` override, else the design-system `stage`
            // token (light `milk`, dark `gray5`). The shell root, the `main` page
            // above and every canvas Stage read the same chain, so the board can
            // never differ from the root beside it.
            // NO `--home-bg` above the chain any more (2026-08-16, measured by ai
            // on ws_UYAOhQyNjm: the record's `--home-bg: light-dark(milk,
            // transparent)` outranked the module stage → #F2EDE3 strip beside a
            // #D8D8D8 board in light — the exact seam Nika reported, re-created
            // one layer up). A per-workspace ground has ONE channel, `--stage-bg`
            // (chrome.stage or a record var); a second board-only channel is the
            // four-painter defect again. `--canvas-bg` is different: it is the
            // USER's own Zoombar pick, per theme, canvas-only. History: was
            // `transparent`, then `var(--home-bg, var(--color-stage))`, then
            // `var(--home-bg, var(--stage-bg, …))`.
            // Longhand, NOT the `background` shorthand: the shorthand resets
            // background-image/size/attachment and would wipe the dot grid declared
            // right below it.
            backgroundColor: 'var(--stage-bg, var(--color-stage))',
            // Dot grid — kept as a mechanism (`--home-dot-color` lets a workspace
            // tint it; GreenIG greens the dots over its green canvas) but the
            // house default is OFF (transparent), per the same Codex record: the
            // milk stage reads as one flat plane, dots were noise on it.
            backgroundImage: 'radial-gradient(circle, var(--home-dot-color, transparent) 1px, transparent 1px)',
            backgroundSize: '24px 24px',
            // `local` (vs. default `scroll`) attaches the bg to the
            // element's content, so as MainColumn scrolls the dot grid
            // moves WITH the widgets rather than staying pinned to the
            // visible viewport — the "dots follow scroll" effect.
            backgroundAttachment: 'local'
        },
        // Touch: arm the shared long-press → synthetic-contextmenu shim (see
        // shared/functions/longPress.js — built for exactly this, previously
        // unwired). One arm HERE covers the whole dashboard by bubbling: a 500ms
        // stationary press on a widget fires that widget's own onContextmenu
        // (which stopPropagation()s, exactly like a real right-click), and a press
        // on empty space falls through to the handler below. No-op on fine
        // pointers — the shim gates on isCoarsePointer internally.
        onRender: (el)=>el.call('armLongPress'),
        // The top sky's fallback (no CSS scroll-driven animations): it fades out
        // once the home leaves its top. A no-op where the CSS path runs
        // (functions/ambientBackdrop.js ambientSkyScrolled).
        onScroll: (e, el)=>el.call('ambientSkyScrolled', el),
        // Right-click empty dashboard space → the house ContextDropdown with
        // [Refresh, Customize dashboard] (functions/homeContextMenu.js →
        // homeContextAction). Widgets stopPropagation in their own onContextmenu
        // so they show the widget menu instead; text fields fall through to the
        // native menu. (2026-06-29 per Nika "context menu on empty".)
        //
        // Label normalized to "Customize dashboard" (tickets/sonnet.md
        // ADMIN-MICRO-1 #4) — this used to read bare "Customize" while the
        // per-widget context menu (below, ~L1264/L1811) and the drawer heading
        // (~L7746) both say "Customize dashboard"; same action, same
        // destination, now the same string everywhere it appears.
        // THE KEYBOARD WAY into the same menus (persona audit WH-9): Shift+F10 or
        // the context-menu key on a card — or on any control inside one — sends
        // the board the `contextmenu` a right-click sends, at that element
        // (functions/homeCtxTip.js homeKeyboardContextMenu). A text field keeps
        // its own menu.
        onKeydown: (e, el)=>el.call('homeKeyboardContextMenu', e),
        onContextmenu: (e, el, s)=>{
            // Scope gate (D2 §5, P1) — the board does not answer while a PageSlot
            // page is open over it. The slot frame is inset and its backdrop is
            // pointerEvents:none, so the pixels around an open pane fall through to
            // this handler and produced a HOME menu over a module page.
            // See functions/homeContextMenu.js homeContextMenuAllowed.
            if (!el.call('homeContextMenuAllowed', e, s.root)) return;
            e.preventDefault();
            s.root.update({
                contextDropdown: {
                    open: true,
                    x: e.clientX,
                    y: e.clientY,
                    items: [
                        {
                            label: 'common.action.refresh',
                            action: 'refresh'
                        },
                        {
                            label: 'workspace.menu.customize',
                            action: 'customize'
                        }
                    ],
                    actionFn: 'homeContextAction'
                }
            }, {
                preventFetch: true
            });
            // INTERACT-1: move focus into the menu so Esc/arrow-keys actually
            // reach it — see functions/homeContextMenu.js:focusHomeContextMenu.
            el.call('focusHomeContextMenu');
        },
        // Ask AI composer moved to the BOTTOM — see BottomPrompt below.
        // Matches the canvas `CanvasPromptTextarea` pattern in
        // packages/canvas/components/CanvasPromptTextarea.js, which sits
        // bottom-center of the studio surface and stays in view as the
        // canvas pans.
        // THE HOME'S TWO VIEWS — Dashboard · Fly, the column's first row
        // (components/HomeViewSwitch.js, functions/homeView.js; Nika 2026-10-22
        // "add switcher at the top - dashboard/fly"). It stays in both views.
        HomeViewSwitch: {},
        // The page head (HOME_WIDGETS_SPEC.md §4.1) — not a grid cell: the date
        // as a micro-label, one editorial line, then THE HOME TOP
        // (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1): the sub-line of what needs the
        // person — the top two signals of HOME_SIGNALS_CONTRACT v1 — and the
        // summary in the person's own style (Brief | Signals,
        // components/HomeTopSummary.js). Aligned to the grid's tracks by the board
        // stylesheet (.home-greeting). The `greeting` hide pref still hides it.
        //
        // Its own clock (`state.now`, functions/homeSignals.js homeTopClock): the
        // greeting's hour band and the date follow the wall clock, and the signals
        // refresh. A source of a built-in signal changing — the tasks, the events,
        // the mail count, the installed apps, the workspace — marks that signal
        // stale and runs a pass at once (homeSignalsOnData).
        HomeGreeting: {
            tag: 'header',
            class: 'home-greeting',
            state: {
                now: null
            },
            // The `greeting` hide pref, and THE AI HOLDS THE MAIN COLUMN — the main
            // thread or a generated board over the grid area (homeTopYields,
            // functions/homeSummaryCompose.js): the head steps aside while it shows
            // and returns on Esc / Back to home with its content intact — hidden,
            // never unmounted (no mount-site `if:`), so nothing re-renders, nothing
            // flashes and only this block leaves the layout. Both read up front.
            hide: (el, s)=>{
                const off = !!s.root?._homeHiddenWidgets?.greeting;
                const yields = !!el.call('homeTopYields', s.root);
                return off || yields;
            },
            display: 'flex',
            flexDirection: 'column',
            gap: 'Z',
            minWidth: '0',
            flexShrink: '0',
            boxSizing: 'border-box',
            padding: 'B',
            round: 'radiusCard',
            background: 'var(--home-card-bg, var(--theme-card-background))',
            '@mobileL': {
                padding: 'A'
            },
            onRender: (el)=>el.call('homeTopClock'),
            onRemove: (el)=>el.call('homeTopClockStop'),
            stateDeps: [
                (el, s)=>s.root._userTickets,
                (el, s)=>s.root.intranetEvents,
                (el, s)=>(s.root.navUnreadCounts || {}).mail,
                (el, s)=>s.root.workspaceApps,
                (el, s)=>s.root.workspaceProject,
                (el, s)=>s.root.workspace && (s.root.workspace.id || s.root.workspace._id) || null,
                // the inbox signal's sources: the unread count and the first answer
                (el, s)=>(s.root.notifs || []).filter((n)=>n && !n.read).length,
                (el, s)=>!!s.root.notifsLoaded
            ],
            onStateUpdate: (el, s, ctx, change)=>el.call('homeSignalsOnData', el, s, change),
            DateLabel: {
                extends: 'AppMicroLabel',
                // `subtitle`, not the micro-label's `inactive` nor `caption`: the
                // taller top band (2026-10-02) puts this line on the SOLID cloud, where
                // the near + far layers overlap at full strength. Measured live:
                // `caption` 4.32:1 dark there (4.80:1 over one layer), `inactive`
                // 2.64:1; `subtitle` 5.16:1 dark / >7:1 light
                // (DESIGN-WL-HOME-SKY-TOP-GROUND-1).
                color: 'subtitle',
                text: (el, s)=>el.call('localizedDate', s.now || Date.now(), {
                        weekday: 'long',
                        day: 'numeric',
                        month: 'long'
                    })
            },
            // A line, not a heading: the page's one h1 is PageSrTitle ("Home"),
            // which gives way to the pane bar when the board opens in a pane.
            // NEVER `Line`: a bare PascalCase key extends the registered component
            // of that name, and the brand's `Line` is the 1 px hairline divider —
            // the greeting collapsed to 1 px and the summary painted over it (clip
            // audit round 7, __tests__/homeGreetingOneLine.test.js).
            GreetingLine: {
                tag: 'p',
                margin: '0',
                fontSize: 'C',
                fontWeight: '400',
                lineHeight: '1.25',
                color: 'title',
                overflowWrap: 'anywhere',
                Lead: {
                    tag: 'span',
                    text: (el, s)=>el.call('polyglot', $eee07520569aad07$var$_greetLeadKey(new Date(s.now || Date.now()).getHours(), !!$eee07520569aad07$var$_shellFirstName($eee07520569aad07$var$shellFindMe(s).name)))
                },
                Name: {
                    tag: 'span',
                    fontWeight: '700',
                    text: (el, s)=>$eee07520569aad07$var$_shellFirstName($eee07520569aad07$var$shellFindMe(s).name)
                }
            },
            // The sub-line holds a skeleton line until the providers have answered —
            // a first-paint "nothing needs you" would be a false claim.
            HomeSignalsLine: {},
            HomeTopSummary: {}
        },
        // The App strip — the Dock (HOME_WIDGETS_SPEC.md §1, decision H1 A; the
        // person's style, DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1): the app shortcuts
        // in ONE glass capsule between the page head and the grid — never grid
        // items. In the Rail style the page's HomeAppRail stands beside the board
        // instead. Its items are the page's (_appStripChildren): layout order,
        // hides kept; it re-reads them when the hidden map or the order changes.
        HomeAppStrip: {
            subscribeTo: [
                'workspaceProject',
                'workspaceApps'
            ],
            // …and it is the DASHBOARD's: it steps aside while another tab holds
            // the home (functions/homeView.js).
            hide: (el, s)=>$eee07520569aad07$var$_appStripHidden(el, s.root, 'dock') || $eee07520569aad07$var$_tabHoldsHome(el, s.root),
            DockCapsule: {
                Items: {
                    children: (el, s)=>$eee07520569aad07$var$_appStripChildren(s.root)
                }
            }
        },
        // THE BOARDS ROW (ASSISTANT_BOARD_MODE_SPEC §4, decision 24;
        // DESIGN-WL-ASSISTANT-MAIN-HOME-1): its own row directly above the grid,
        // on the grid's width — Home · the generated board · the saved boards, the
        // kit's view switch (it never cuts a segment: the track scrolls) — and
        // Edit on the right, the board's edit mode (it switches the grid, so it
        // sits on the grid). Shown only while there is more than Home. The rows,
        // the current segment and the switch are the assistant's
        // (functions/assistantBoard.js).
        AssistantBoardsRow: {
            class: 'home-boards-row',
            // `?board=<id>` mirrors the current segment; a cold link opens its
            // board once Page mode answers (functions/homeBoardUrl.js).
            subscribeTo: [
                '_aiBoard',
                '_aiBoards',
                '_aiBoardsAvailable',
                'assistantDock'
            ],
            onRender: (el, s)=>el.call('homeBoardUrlTick', s.root),
            onUpdate: (el, s)=>el.call('homeBoardUrlTick', s.root),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'Z',
            minWidth: '0',
            flexShrink: '0',
            // The dashboard's boards — never under another tab (functions/homeView.js).
            hide: (el, s)=>!el.call('assistantBoardSegments', s.root).length || $eee07520569aad07$var$_tabHoldsHome(el, s.root),
            AppSegmented: {
                variant: 'view',
                minWidth: '0',
                ariaLabel: (el)=>el.call('assistantBoardRowLabel'),
                current: (el, s)=>el.call('assistantBoardCurrentSegment', s.root),
                select: 'assistantBoardSelect',
                childrenAs: 'state',
                children: (el, s)=>el.call('assistantBoardSegments', s.root)
            },
            // Edit edits the board on screen — the home board; a saved board's own
            // edit mode arrives with its record's ops (core ai.boards), so Edit
            // steps aside while a generated or saved board is shown.
            AppCapsuleBtnToolbar: {
                compact: true,
                flexShrink: '0',
                hide: (el, s)=>el.call('assistantBoardOpen', s.root),
                ariaPressed: (el, s)=>String(!!s.root._homeCustomizeMode),
                text: '{{ common.action.edit | polyglot }}',
                onClick: (e, el, s)=>s.root.update({
                        _homeCustomizeMode: !s.root._homeCustomizeMode
                    }, {
                        preventFetch: true
                    })
            }
        },
        // The widget grid (HOME_WIDGETS_SPEC.md §1): a CSS grid flowing the saved
        // ORDER of widgets, each at one of four sizes; its geometry lives in the
        // board stylesheet (_injectWidgetStyles). Module widgets render through
        // the ModuleWidgets host; saved cells of widgets still loading hold a
        // skeleton (PendingWidgets). The assistant's generated board mounts as the
        // grid's last child, OVER the cards (AssistantBoardView below).
        GridContainer: {
            class: 'home-grid',
            // Which of the home's tabs holds the area (functions/homeView.js): while
            // it is not the Dashboard, the board stylesheet takes the cards out of
            // the layout and puts the tab's view part in the flow
            // (_injectWidgetStyles).
            dataHomeView: (el, s)=>el.call('homeViewOf', s.root),
            // the containing block of the generated board laid over the grid area
            position: 'relative',
            subscribeTo: [
                'workspace',
                'workspaceSettings',
                'workspaceProject',
                'workspaceApps',
                'userDashboardPrefs'
            ],
            width: '100%',
            minWidth: '0',
            flexShrink: '0',
            marginBottom: 'D1',
            '@mobileL': {
                marginBottom: 'C'
            },
            // One reconcile BEFORE the widgets render (they read the layout and the
            // hidden map), then on every subscribed update.
            onInit: (el, s)=>{
                $eee07520569aad07$var$_injectWidgetStyles(el);
                $eee07520569aad07$var$_reconcileHomeBoard(el, s.root);
            },
            // …and the top sky re-measures its clear edge after each: the reconcile
            // settles the hidden map, which shows or hides the head rows above the
            // grid (the greeting, the App strip), so the first row with a box moves
            // (functions/ambientBackdrop.js ambientFadeTop — the grid is the last
            // anchor; only a changed edge writes the sky's state).
            onRender: (el, s)=>{
                $eee07520569aad07$var$_reconcileHomeBoard(el, s.root);
                el.call('ambientSkySync', el);
            },
            onUpdate: (el, s)=>{
                $eee07520569aad07$var$_reconcileHomeBoard(el, s.root);
                el.call('ambientSkySync', el);
            },
            // A widget dragged in from the customize drawer (`move`) or the app
            // launcher (`copy`) — accepted anywhere on the board.
            onDragover: (e, el)=>{
                const types = e.dataTransfer && e.dataTransfer.types;
                if (!types || !Array.from(types).includes('text/x-home-widget-id')) return;
                e.preventDefault();
                e.dataTransfer.dropEffect = el.call('isLauncherDashboardDrag', types) ? 'copy' : 'move';
            },
            // The drop lands the widget where the pointer is in the ORDER (on top of
            // a widget = that widget's place), else at the end. A launcher drop of an
            // app already on the board only says so.
            onDrop: (e, el, s)=>{
                const types = e.dataTransfer && e.dataTransfer.types;
                const id = e.dataTransfer && e.dataTransfer.getData('text/x-home-widget-id');
                if (!id) return;
                e.preventDefault();
                const fromLauncher = el.call('isLauncherDashboardDrag', types);
                if (fromLauncher && $eee07520569aad07$var$_isHomeWidgetAlreadyVisible(id)) {
                    try {
                        el.call('closeDropdown', 'searchApps');
                    } catch (_) {
                    /* the drag can also start from a detached launcher layer */ }
                    $eee07520569aad07$var$_notifyHomeWidgetDrop(el, s.root, id, true);
                    return;
                }
                const at = $eee07520569aad07$var$_dropIndexAt(el, s.root, e.clientX, e.clientY);
                $eee07520569aad07$var$_restoreWidget(id, s.root, at == null ? null : {
                    index: at
                }, el.sdk, true);
                if (fromLauncher) {
                    try {
                        el.call('closeDropdown', 'searchApps');
                    } catch (_) {
                    /* Home can receive a synthetic/test drag without the launcher */ }
                    $eee07520569aad07$var$_notifyHomeWidgetDrop(el, s.root, id, false);
                }
            },
            // Next up — the day's next event and the ones after it
            // (HOME_AMBIENT_SKIN_SPEC.md §4, components/HomeNextUpBody.js). First
            // on a fresh board; M, never smaller.
            NextUpWidget: $eee07520569aad07$var$_widget({
                id: 'next-up',
                x: 0,
                y: 0,
                w: 6,
                h: 3,
                size: 'm',
                minSize: 'm',
                title: 'workspace.widget.nextUp.title',
                icon: 'date outline',
                openRoute: '/calendar'
            }, {
                HomeNextUpBody: {}
            }),
            ReceivedWidget: $eee07520569aad07$var$_widget({
                id: 'received',
                x: 0,
                y: 4,
                w: 6,
                h: 4,
                title: 'workspace.widget.received.title',
                icon: 'check',
                openRoute: '/tasks/my'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): numeral + one line ──────────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>el.call('homeTicketCountText', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_receivedTickets(s.root))),
                        title: (el, s)=>el.call('homeTicketListState', s.root, 0) === 'error' ? el.call('polyglot', 'workspace.widget.received.subtitleError') : ''
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.openTasks | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): the real mini-app — rows + quick-add ─
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'V',
                    padding: 'Z',
                    minHeight: '0',
                    QuickAdd: $eee07520569aad07$var$_taskQuickAddRow('received', 'received'),
                    // The skeleton stands in while the set is unread — a mounted /
                    // unmounted shared `SkeletonRow`, never an animation a returned
                    // `null` cannot clear (the parent's measured trap).
                    LoadingRow: {
                        extends: 'SkeletonRow',
                        // Row-height placeholder, so the skeleton occupies the space a
                        // ticket row will — the default `SkeletonRow` height is a text
                        // line (measured 2px here) and read as a hairline, not a row.
                        height: 'B',
                        hide: (el, s)=>el.call('homeTicketListState', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_receivedTickets(s.root))) !== 'loading'
                    },
                    Empty: {
                        hide: (el, s)=>{
                            const st = el.call('homeTicketListState', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_receivedTickets(s.root)));
                            return st !== 'empty' && st !== 'error';
                        },
                        extends: 'HomePosterSoftInk',
                        padding: 'A B',
                        fontSize: 'A',
                        text: (el, s)=>el.call('polyglot', el.call('homeTicketListState', s.root, 0) === 'error' ? 'workspace.widget.received.bodyError' : 'workspace.widget.received.bodyEmpty')
                    },
                    List: {
                        hide: (el, s)=>el.call('homeTicketListState', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_receivedTickets(s.root))) !== 'list',
                        flow: 'y',
                        gap: 'V',
                        overflow: 'auto',
                        minHeight: '0',
                        children: (el, s)=>$eee07520569aad07$var$_receivedTickets(s.root).slice(0, 5).map((t)=>$eee07520569aad07$var$_ticketRowChild(t, '/tasks/my', t.reporterEmail || t.reporter_email, $eee07520569aad07$var$_cardHue(el, s, 'received')))
                    }
                }
            }),
            GivenWidget: $eee07520569aad07$var$_widget({
                id: 'given',
                x: 6,
                y: 4,
                w: 6,
                h: 4,
                title: 'workspace.widget.given.title',
                icon: 'check',
                openRoute: '/tasks'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): numeral + one line ──────────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>el.call('homeTicketCountText', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_givenTickets(s.root))),
                        title: (el, s)=>el.call('homeTicketListState', s.root, 0) === 'error' ? el.call('polyglot', 'workspace.widget.given.subtitleError') : ''
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.delegated | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): the real mini-app — rows + quick-add ─
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'V',
                    padding: 'Z',
                    minHeight: '0',
                    QuickAdd: $eee07520569aad07$var$_taskQuickAddRow('given', 'given'),
                    LoadingRow: {
                        extends: 'SkeletonRow',
                        height: 'B',
                        hide: (el, s)=>el.call('homeTicketListState', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_givenTickets(s.root))) !== 'loading'
                    },
                    Empty: {
                        hide: (el, s)=>{
                            const st = el.call('homeTicketListState', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_givenTickets(s.root)));
                            return st !== 'empty' && st !== 'error';
                        },
                        extends: 'HomePosterSoftInk',
                        padding: 'A B',
                        fontSize: 'A',
                        text: (el, s)=>el.call('polyglot', el.call('homeTicketListState', s.root, 0) === 'error' ? 'workspace.widget.given.bodyError' : 'workspace.widget.given.bodyEmpty')
                    },
                    List: {
                        hide: (el, s)=>el.call('homeTicketListState', s.root, $eee07520569aad07$var$_ticketCount($eee07520569aad07$var$_givenTickets(s.root))) !== 'list',
                        flow: 'y',
                        gap: 'V',
                        overflow: 'auto',
                        minHeight: '0',
                        children: (el, s)=>$eee07520569aad07$var$_givenTickets(s.root).slice(0, 5).map((t)=>$eee07520569aad07$var$_ticketRowChild(t, '/tasks', t.assigneeEmail || t.assignee_email, $eee07520569aad07$var$_cardHue(el, s, 'given')))
                    }
                }
            }),
            TeamPulseWidget: $eee07520569aad07$var$_widget({
                id: 'teampulse',
                x: 0,
                y: 8,
                w: 6,
                h: 3,
                title: 'workspace.widget.teampulse.title',
                icon: 'analytics',
                openRoute: '/tasks',
                hue: 'analytics'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): total + a slim bar, no legend ───────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>{
                            const counts = $eee07520569aad07$var$_workspacePulse(s.root);
                            return String($eee07520569aad07$var$_PULSE_BUCKETS.reduce((sum, b)=>sum + counts[b.key], 0));
                        }
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.openTickets | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): bar + per-bucket counts + legend ─────
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z',
                    minHeight: '0',
                    // Proportional bar — 24 fixed segments (board-status.py's own
                    // largest-remainder allocation), so a bucket with even ONE
                    // ticket never rounds away to nothing.
                    Bar: {
                        flow: 'x',
                        height: 'Y',
                        round: 'radiusControl',
                        overflow: 'hidden',
                        background: 'line',
                        children: (el, s)=>{
                            const counts = $eee07520569aad07$var$_workspacePulse(s.root);
                            return $eee07520569aad07$var$_pulseBarSegments(counts, 24).map((seg)=>({
                                    key: seg.key,
                                    flex: String(seg.units),
                                    background: seg.hue,
                                    minWidth: '0'
                                }));
                        }
                    },
                    // Per-bucket counts — fixed-width cells (this ticket's own
                    // zero-shift rule: a count crossing a digit boundary must not
                    // reflow its neighbours).
                    Counts: {
                        flow: 'x',
                        flexWrap: 'wrap',
                        gap: 'Y',
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const counts = $eee07520569aad07$var$_workspacePulse(s.root);
                            return $eee07520569aad07$var$_PULSE_BUCKETS.map((b)=>({
                                    key: b.key,
                                    ...b,
                                    n: counts[b.key]
                                }));
                        },
                        childExtends: {
                            flow: 'x',
                            gap: 'V',
                            align: 'center',
                            fontSize: 'Z1',
                            color: 'caption',
                            Dot: {
                                tag: 'span',
                                boxSize: 'X1',
                                round: '50%',
                                flexShrink: '0',
                                background: (el, s)=>s.hue
                            },
                            N: {
                                tag: 'span',
                                display: 'inline-block',
                                minWidth: 'C',
                                fontVariantNumeric: 'tabular-nums',
                                fontWeight: '700',
                                color: 'title',
                                text: (el, s)=>String(s.n)
                            },
                            Label: {
                                tag: 'span',
                                // `.replace` is a no-op on the rows whose value carries no
                                // placeholder (the pulse / priority buckets and the person
                                // rows); only the workload "N more" row substitutes.
                                text: (el, s)=>el.call('polyglot', s.label).replace('{count}', s.moreCount ?? '')
                            }
                        }
                    },
                    // Legend — who can act, not just what state things are in.
                    // "Assigned to you" (Received's own count, reused rather than
                    // re-derived) is the one line that turns a summary into a call
                    // to action.
                    Legend: {
                        tag: 'div',
                        hide: (el, s)=>$eee07520569aad07$var$_receivedTickets(s.root).length === 0,
                        fontSize: 'Z1',
                        color: 'caption',
                        paddingTop: 'V',
                        text: (el, s)=>{
                            const n = $eee07520569aad07$var$_receivedTickets(s.root).length;
                            return el.call('polyglot', n === 1 ? 'workspace.pulse.needsYouOne' : 'workspace.pulse.needsYou').replace('{count}', n);
                        }
                    }
                }
            }),
            PriorityMixWidget: $eee07520569aad07$var$_widget({
                id: 'prioritymix',
                x: 6,
                y: 8,
                w: 6,
                h: 3,
                title: 'workspace.widget.prioritymix.title',
                icon: 'analytics',
                openRoute: '/tasks',
                hue: 'tickets'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): the urgent count alone ──────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>{
                            const counts = $eee07520569aad07$var$_workspacePriorityMix(s.root);
                            return String(counts.urgent + counts.high);
                        }
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.urgentOrHigh | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): bar + per-bucket counts + legend ─────
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z',
                    minHeight: '0',
                    Bar: {
                        flow: 'x',
                        height: 'Y',
                        round: 'radiusControl',
                        overflow: 'hidden',
                        background: 'line',
                        children: (el, s)=>(0, $2zU0i.barSegments)((0, $2zU0i.PRIORITY_BUCKETS), $eee07520569aad07$var$_workspacePriorityMix(s.root), 24).map((seg)=>({
                                    key: seg.key,
                                    flex: String(seg.units),
                                    background: seg.hue,
                                    minWidth: '0'
                                }))
                    },
                    Counts: {
                        flow: 'x',
                        flexWrap: 'wrap',
                        gap: 'Y',
                        childrenAs: 'state',
                        children: (el, s)=>{
                            const counts = $eee07520569aad07$var$_workspacePriorityMix(s.root);
                            return (0, $2zU0i.PRIORITY_BUCKETS).map((b)=>({
                                    key: b.key,
                                    ...b,
                                    n: counts[b.key]
                                }));
                        },
                        childExtends: {
                            flow: 'x',
                            gap: 'V',
                            align: 'center',
                            fontSize: 'Z1',
                            color: 'caption',
                            Dot: {
                                tag: 'span',
                                boxSize: 'X1',
                                round: '50%',
                                flexShrink: '0',
                                background: (el, s)=>s.hue
                            },
                            N: {
                                tag: 'span',
                                display: 'inline-block',
                                minWidth: 'C',
                                fontVariantNumeric: 'tabular-nums',
                                fontWeight: '700',
                                color: 'title',
                                text: (el, s)=>String(s.n)
                            },
                            Label: {
                                tag: 'span',
                                // `.replace` is a no-op on the rows whose value carries no
                                // placeholder (the pulse / priority buckets and the person
                                // rows); only the workload "N more" row substitutes.
                                text: (el, s)=>el.call('polyglot', s.label).replace('{count}', s.moreCount ?? '')
                            }
                        }
                    },
                    // Legend — who can act: an unset priority is a triage debt,
                    // not a bucket, so it is named here rather than counted above.
                    Legend: {
                        tag: 'div',
                        hide: (el, s)=>$eee07520569aad07$var$_workspacePriorityMix(s.root).unset === 0,
                        fontSize: 'Z1',
                        color: 'caption',
                        paddingTop: 'V',
                        text: (el, s)=>el.call('polyglot', 'workspace.widget.prioritymix.toTriage').replace('{count}', $eee07520569aad07$var$_workspacePriorityMix(s.root).unset)
                    }
                }
            }),
            WorkloadWidget: $eee07520569aad07$var$_widget({
                id: 'workload',
                x: 0,
                y: 11,
                w: 6,
                h: 4,
                title: 'workspace.widget.workload.title',
                icon: 'people',
                openRoute: '/tasks',
                hue: 'tickets'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): the busiest person's load ───────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>String($eee07520569aad07$var$_workloadRows(s.root).rows[0]?.n || 0)
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: (el, s)=>{
                            const top = $eee07520569aad07$var$_workloadRows(s.root).rows[0];
                            if (!top) return el.call('polyglot', 'workspace.workload.captionEmpty');
                            return el.call('polyglot', 'workspace.workload.captionTop').replace('{name}', el.call('polyglot', top.label));
                        }
                    }
                },
                // ── Full tier (6+ cols): bar + per-person counts + legend ─────
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'Y',
                    padding: 'Z',
                    minHeight: '0',
                    Bar: {
                        flow: 'x',
                        height: 'Y',
                        round: 'radiusControl',
                        overflow: 'hidden',
                        background: 'line',
                        children: (el, s)=>{
                            const { rows: rows } = $eee07520569aad07$var$_workloadRows(s.root);
                            const counts = {};
                            for (const r of rows)counts[r.key] = r.n;
                            return (0, $2zU0i.barSegments)(rows, counts, 24).map((seg)=>({
                                    key: seg.key,
                                    flex: String(seg.units),
                                    background: seg.hue,
                                    minWidth: '0'
                                }));
                        }
                    },
                    Counts: {
                        flow: 'x',
                        flexWrap: 'wrap',
                        gap: 'Y',
                        childrenAs: 'state',
                        children: (el, s)=>$eee07520569aad07$var$_workloadRows(s.root).rows,
                        childExtends: {
                            flow: 'x',
                            gap: 'V',
                            align: 'center',
                            fontSize: 'Z1',
                            color: 'caption',
                            Dot: {
                                tag: 'span',
                                boxSize: 'X1',
                                round: '50%',
                                flexShrink: '0',
                                background: (el, s)=>s.hue
                            },
                            N: {
                                tag: 'span',
                                display: 'inline-block',
                                minWidth: 'C',
                                fontVariantNumeric: 'tabular-nums',
                                fontWeight: '700',
                                color: 'title',
                                text: (el, s)=>String(s.n)
                            },
                            Label: {
                                tag: 'span',
                                // `.replace` is a no-op on the rows whose value carries no
                                // placeholder (the pulse / priority buckets and the person
                                // rows); only the workload "N more" row substitutes.
                                text: (el, s)=>el.call('polyglot', s.label).replace('{count}', s.moreCount ?? '')
                            }
                        }
                    },
                    Legend: {
                        tag: 'div',
                        hide: (el, s)=>$eee07520569aad07$var$_workloadRows(s.root).unassigned === 0,
                        fontSize: 'Z1',
                        color: 'caption',
                        paddingTop: 'V',
                        text: (el, s)=>el.call('polyglot', 'workspace.workload.unassignedCount').replace('{count}', $eee07520569aad07$var$_workloadRows(s.root).unassigned)
                    }
                }
            }),
            ProjectsWidget: $eee07520569aad07$var$_widget({
                id: 'projects',
                x: 0,
                y: 8,
                w: 12,
                h: 7,
                title: 'workspace.widget.websites.title',
                icon: 'layers',
                openRoute: '/studio'
            }, {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 220px), 1fr))',
                // Explicit row height so every grid cell (real ProjectCard +
                // EmptyProjectCard) renders at the same visual size — without
                // it the cards size to their intrinsic content and the row
                // jumped around (ProjectCard gradient = tall ~ 240px;
                // EmptyProjectCard = ~200px). `gridAutoRows: '180px'` plus a
                // matching `childProps.height` on the populated Cards branch
                // keeps the heights uniform regardless of which branch is
                // showing.
                // Populated: fixed 200px rows so every ProjectCard + the AddCard
                // tile render at a uniform height. Empty: a single row that
                // stretches (`1fr`) to fill the widget body so the lone "Create
                // your first project" tile fills the cell instead of shrinking to
                // 200px and leaving a tall dead gap below it.
                gridAutoRows: (el, s)=>$eee07520569aad07$var$_activeWorkspaceProjects(s.root).length === 0 ? 'minmax(200px, 1fr)' : '200px',
                gap: 'B',
                padding: 'B',
                Cards: {
                    hide: (el, s)=>$eee07520569aad07$var$_activeWorkspaceProjects(s.root).length === 0,
                    display: 'contents',
                    childExtends: 'ProjectCard',
                    // The card ships `theme: 'canvas-card-glass'` (near-black glass +
                    // `line` border) — right on a neutral canvas, wrong INSIDE a
                    // saturated widget colour: every tile read as a navy plate with a
                    // grey hairline (Nika 2026-08-15 "fix colors on widgets"). Re-plate
                    // it with the widget colour's own ink-alpha system
                    // (`homeWidgetHue.js` contract: fill = ink.12, wash = ink.08,
                    // inkSoft = ink.55) — one hue per widget.
                    // 2026-09-02: the pair of duplicated `@dark` / `@light` blocks is
                    // GONE and each value is a factory instead. Those blocks existed
                    // because "a plain prop would lose to the theme's own [data-theme]
                    // rules" — true of a STATIC prop, which compiles to a class rule.
                    // A function-valued prop is written as a reactive INLINE style,
                    // which beats every stylesheet rule in both schemes AND repaints
                    // when the user picks or clears the colour. Keeping the blocks
                    // would in fact invert the result: smbls stamps `!important` on a
                    // theme-block declaration that collides with a reactive inline
                    // counterpart (element/src/create.js `collidesWithReactiveInline`).
                    childProps: {
                        height: '200px',
                        minHeight: '200px',
                        background: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).fill || 'overlayStrong',
                        borderColor: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).wash || 'line',
                        Body: {
                            Name: {
                                color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).ink || 'title'
                            },
                            Desc: {
                                color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).inkSoft || 'caption'
                            }
                        }
                    },
                    childrenAs: 'state',
                    children: (el, s)=>{
                        const orgs = s.root?.jwtClaims?.orgs || s.root?.orgs || [];
                        const orgId = s.root?.jwtClaims?.workspace_org_id;
                        const ownerSlug = orgs.find((o)=>o.id === orgId)?.slug || '';
                        const wsId = s.root?.jwtClaims?.active_workspace_id || s.root?.workspace?.id;
                        const wsList = s.root?.jwtClaims?.workspaces || [];
                        const wsSlug = wsList.find((w)=>w.id === wsId)?.slug || '';
                        // ownerSlugOf: extract a human-readable slug from an owner
                        // field. When the field is still a raw Mongo ObjectId (24 hex
                        // chars — un-migrated project) treat it as absent and fall
                        // through to the JWT-derived ownerSlug so the card routes
                        // correctly instead of navigating to /{objectId}/... (#2185).
                        const _isObjectId = (v)=>/^[a-f0-9]{24}$/i.test(String(v || ''));
                        const ownerSlugOf = (v)=>{
                            if (!v) return '';
                            if (typeof v === 'string') return _isObjectId(v) ? '' : v;
                            return v?.slug || '';
                        };
                        return $eee07520569aad07$var$_activeWorkspaceProjects(s.root).map((p)=>({
                                ...p,
                                owner: ownerSlugOf(p.owner) || ownerSlug,
                                workspaceSlug: ownerSlugOf(p.workspaceSlug) || wsSlug
                            }));
                    }
                },
                // "+ New project" tile — shown alongside existing project cards so
                // the create affordance is always reachable, not just in the empty
                // state. Reuses EmptyProjectCard (same +/dashed look + picker click),
                // relabelled for the populated case.
                AddCard: {
                    hide: (el, s)=>$eee07520569aad07$var$_activeWorkspaceProjects(s.root).length === 0,
                    extends: 'EmptyProjectCard',
                    height: '200px',
                    minHeight: '200px',
                    // Same re-plating as the Cards above: EmptyProjectCard's `line`
                    // dashed ring + `overlay`/`dialog` cover + `title`/`caption` ink
                    // are neutral-canvas values that read grey-on-blue inside a
                    // saturated widget colour. Dashed ring = ink at .35
                    // (design-direction §8's dashed-ring alpha), cover = ink wash,
                    // plus = ink fill, text = ink / inkSoft — and every one of them
                    // falls back to the neutral token the shared card ships with when
                    // the widget has no colour (2026-09-02).
                    borderColor: (el, s)=>{
                        const h = $eee07520569aad07$var$_cardHue(el, s, 'projects');
                        return h ? h.ink + '.35' : 'line';
                    },
                    color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).inkSoft || 'caption',
                    // The hover ring brightens from the .35 dashed alpha to the FULL
                    // live ink via `currentColor`. It used to name the ink token
                    // directly and also hop the text from inkSoft to ink; a `:hover`
                    // block is resolved ONCE at create (smbls `resolveCssBlock`), so a
                    // named token there would freeze at whatever colour the card had
                    // on first paint and go stale the moment the user picks another.
                    // `currentColor` reads the element's own reactive `color`, so the
                    // ring follows every colour change with no staleness.
                    ':hover': {
                        borderColor: 'currentColor'
                    },
                    Cover: {
                        background: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).wash || 'overlay',
                        Plus: {
                            background: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).fill || 'dialog',
                            color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).ink || 'title'
                        }
                    },
                    Body: {
                        Title: {
                            text: '{{ workspace.projects.new | polyglot }}',
                            color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).ink || 'title'
                        },
                        Hint: {
                            text: '{{ workspace.projects.addToWorkspace | polyglot }}',
                            color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).inkSoft || 'caption'
                        }
                    }
                },
                Empty: {
                    hide: (el, s)=>$eee07520569aad07$var$_activeWorkspaceProjects(s.root).length !== 0,
                    extends: 'EmptyProjectCard',
                    // Fill the whole widget body (full width across all columns, and
                    // stretch to the full height of the `1fr` row) so the empty state
                    // reads as a deliberate full-size CTA rather than a shrunken 200px
                    // tile. `alignSelf: stretch` overrides EmptyProjectCard's
                    // flex-start so it grows to the row height.
                    gridColumn: '1 / -1',
                    alignSelf: 'stretch',
                    height: 'auto',
                    minHeight: '200px',
                    // Center the + and the "Create your first project" label together as
                    // one group in the middle of the full-size card. EmptyProjectCard's
                    // Cover is 16/9 BY WIDTH — at full widget width that computes to a
                    // ~770px-tall cover that overflows the card and shoves the CTA out of
                    // view. Drop the ratio + the filled cover box, keep the + at its
                    // natural size, and center the [cover, body] column as a group.
                    align: 'center center',
                    gap: 'Z',
                    // Poster ink, like the AddCard branch above. EmptyProjectCard is a
                    // SHARED component (packages/shared): its `title`/`caption` neutrals
                    // are right on a plain canvas and wrong on this fixed poster hue —
                    // measured Title rgb(4,4,4) 3.24:1 and Hint rgb(36,36,40) 2.44:1 on
                    // posterStudio #0F45FF in light, and failing the other way in dark
                    // (HOME-POSTER-NEUTRAL-INK-ON-HUE-1). The resolvers keep the neutral
                    // tokens on every non-poster mount of the same component.
                    color: (0, $dS9Zz.HomePosterSoftInk).color,
                    // `currentColor` for the same reason as the AddCard branch above:
                    // a `:hover` block is resolved once at create and would freeze a
                    // named colour token; `currentColor` follows the element's own
                    // reactive ink instead.
                    ':hover': {
                        borderColor: 'currentColor'
                    },
                    Cover: {
                        aspectRatio: 'auto',
                        flex: '0 0 auto',
                        width: 'auto',
                        background: 'transparent',
                        padding: '0',
                        // Same re-plate the AddCard branch applies — a neutral `dialog`
                        // disc reads as a grey plate on a coloured card.
                        Plus: {
                            background: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'projects') || {}).fill || 'dialog',
                            color: (0, $lAJsX.HomePosterInk).color
                        }
                    },
                    Body: {
                        align: 'center',
                        textAlign: 'center',
                        padding: '0',
                        Title: {
                            color: (0, $lAJsX.HomePosterInk).color
                        },
                        Hint: {
                            color: (0, $dS9Zz.HomePosterSoftInk).color
                        }
                    }
                }
            }),
            DocumentsWidget: $eee07520569aad07$var$_widget({
                id: 'assets',
                x: 0,
                y: 15,
                w: 12,
                h: 4,
                title: 'workspace.widget.assets.title',
                icon: 'document',
                openRoute: '/notes'
            }, {
                flow: 'y',
                minHeight: '0',
                // Inline fetch (same declaration the /documents page uses) —
                // populates `root.documents` so the recent-list below renders
                // immediately and the /documents page benefits from the warm
                // cache on navigation. Kept at this top level (sibling to the
                // Mini/Full tiers below), not nested inside Full — the tiers are
                // a CSS-visibility split, not a conditional mount, so the fetch
                // fires exactly once regardless of which tier is showing.
                fetch: [
                    {
                        method: 'select',
                        from: 'docs',
                        order: 'updatedAt',
                        ascending: false,
                        as: '~/documents',
                        cache: '30s',
                        transform: (res)=>{
                            const rows = Array.isArray(res) ? res : res?.data || [];
                            return {
                                // Mirror documentsFetch's shape (documents/functions) via
                                // the shared `_mapDocRow` mapper — non-KB rows only,
                                // folderPath '/' → unfiled. `updatedAt` stays RAW here
                                // (DATE-FMT-1 — formatting moved to the render boundary,
                                // see Caption below); do NOT re-introduce a per-callsite
                                // `.slice(0, 10)`/format here.
                                documents: rows.filter((r)=>r.type !== 'kb_article').map($eee07520569aad07$var$_mapDocRow),
                                _documentsLoaded: true
                            };
                        },
                        onFetchError: (err, el, s)=>{
                            console.warn('[home] documents fetch failed:', err?.message || err);
                            const root = s?.root || s;
                            if (root?.update) root.update({
                                _documentsLoaded: true,
                                documents: root.documents || []
                            });
                        }
                    }
                ],
                // ── Mini tier (3-5 cols): numeral + one line ──────────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>String((s.root?.documents || []).length)
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.notes | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): the existing chip grid + a quick-new-
                // note row (board §2 "notes/assets: chip grid (exists) +
                // quick-new-note input row").
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'V',
                    padding: 'Z',
                    minHeight: '0',
                    QuickAdd: {
                        flow: 'x',
                        gap: 'V',
                        align: 'center',
                        flexShrink: '0',
                        Input: {
                            flex: '1',
                            minWidth: '0',
                            minHeight: 'controlHCompact',
                            round: 'radiusControl',
                            fontSize: 'Z1',
                            padding: '0 Z1',
                            // The field law (brand `field` theme), as on the Reminders row.
                            theme: 'field',
                            border: 'none',
                            aria: {
                                label: (el)=>el.call('polyglot', 'workspace.notes.newAria')
                            },
                            placeholder: (el)=>el.call('polyglot', 'workspace.notes.newPlaceholder'),
                            value: (el, s)=>s.root?._noteDraft || '',
                            onClick: (e)=>e.stopPropagation(),
                            onInput: (e, el, s)=>s.root.update({
                                    _noteDraft: e.target.value
                                }),
                            onKeydown: (e, el, s)=>{
                                e.stopPropagation();
                                if (e.key !== 'Enter') return;
                                e.preventDefault();
                                $eee07520569aad07$var$_submitNoteQuickAdd(el, s.root);
                            }
                        },
                        AddBtn: {
                            tag: 'button',
                            type: 'button',
                            class: 'gs-no-drag',
                            flexShrink: '0',
                            // The quick-add row's primary action: solid ink (`primary`), never
                            // a hue — `color: 'indigoblue'` on `black` was the old poster's
                            // hue as action ink. The theme owns the hover fill step, so the
                            // opacity hover and its transition are gone (Rule 65); same shape
                            // as the Reminders Add button.
                            theme: 'primary',
                            border: 'none',
                            minHeight: 'controlHCompact',
                            round: 'radiusPill',
                            padding: '0 Z',
                            fontSize: 'Z1',
                            fontWeight: '700',
                            cursor: 'pointer',
                            // THE DISABLED LAW (brand 3.14.793): the field-disabled pair, never
                            // opacity.
                            ':disabled': {
                                theme: 'field-disabled'
                            },
                            disabled: (el, s)=>!(s.root?._noteDraft || '').trim(),
                            text: '{{ workspace.notes.add | polyglot }}',
                            onClick: (e, el, s)=>{
                                e.stopPropagation();
                                $eee07520569aad07$var$_submitNoteQuickAdd(el, s.root);
                            }
                        }
                    },
                    // Grid of tile cards — replaces the legacy vertical row list.
                    // Each tile opens /documents in the home AppWindow PageSlot via
                    // `selectedPage`, NOT via `el.router(route)`: the user stays on
                    // the dashboard, the documents page mounts inline, and the
                    // close-x returns them to home unchanged. Same dispatch shape
                    // the widget header's "Open Documents" action uses.
                    //
                    // Layout: auto-fill `minmax(160px, 1fr)` so tiles re-flow at the
                    // current widget width without per-breakpoint media queries.
                    // Inline tile definition (no `childExtends: 'AppListItem'`) —
                    // AppListItem is a wide-row launcher, the wrong shape for a
                    // grid tile (icon-top vs icon-left, no two-up wrap, route-based
                    // onClick we'd have to fight). Keeping the tile inline also
                    // keeps the home page self-contained — no new shared component
                    // shipping just for this widget.
                    DocumentsList: {
                        hide: (el, s)=>!(s.root.documents || []).length,
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 160px), 1fr))',
                        gap: 'V',
                        overflow: 'auto',
                        minHeight: '0',
                        children: (el, s)=>(s.root.documents || []).slice(0, 8).map((d)=>({
                                    // Stable identity key (DOMQL reconciles `children` arrays by
                                    // key, not array position — project_domql_children_reconcile
                                    // _by_key). Without it, a re-render that reorders
                                    // `root.documents` (a background 30s-cache refetch landing
                                    // after first paint, a resort by `updatedAt`) reconciles by
                                    // POSITION: index 0's node gets reused for whatever row now
                                    // sits at index 0, even though it held a different doc a
                                    // moment ago. Each card's static `text: d.title` / `text:
                                    // […, el.call('shortDate', d.updatedAt)]` is resolved once,
                                    // here, inside this factory — with a stable `key: d.id` a
                                    // reorder now correctly creates/moves/updates by DOCUMENT,
                                    // not by slot, so a card can never show one document's
                                    // shortDate-formatted caption while momentarily still
                                    // wired to a different document's raw row underneath.
                                    key: d.id,
                                    scope: {
                                        d: d
                                    },
                                    tag: 'button',
                                    type: 'button',
                                    flow: 'y',
                                    gap: 'V',
                                    align: 'flex-start',
                                    padding: 'Z A',
                                    round: 'radiusCard',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    background: $eee07520569aad07$var$_posterStep('wash'),
                                    border: 'none',
                                    color: (0, $lAJsX.HomePosterInk).color,
                                    minHeight: 'F',
                                    transition: '160ms defaultBezier background',
                                    ':hover': {
                                        background: $eee07520569aad07$var$_posterStep('fill')
                                    },
                                    // Click opens the EXACT clicked document in the editor
                                    // (2026-06-08 per Nika — items open their own doc; the widget
                                    // header arrow still opens the documents LIST). Mirrors the
                                    // documents page's own DocsCard dispatch: seed editorDoc +
                                    // activeSection for instant render, then navigate to the
                                    // canonical doc URL whose hash the editor reads to load it.
                                    onClick: (e, el, s)=>{
                                        e.preventDefault();
                                        // Keep the selected record on the destination route. The
                                        // editor reads that route through readPageHash, which uses
                                        // the owning pane in PageSlot and the address bar on a
                                        // dedicated page. Clear any stale record before it restores.
                                        s.root.update({
                                            editorDoc: null,
                                            editorMode: 'view',
                                            activeSection: 'editor'
                                        });
                                        el.call('openAppPage', '/notes/editor#note=' + encodeURIComponent(d.id || ''), e);
                                    },
                                    IconTile: {
                                        width: 'C',
                                        height: 'C',
                                        minWidth: 'C',
                                        round: 'radiusControl',
                                        align: 'center center',
                                        // 'document' is NOT a colour token — it fell through the token
                                        // table to solid black, a heavy square fighting the indigoblue
                                        // poster. Ink-alpha fill per the poster secondary system.
                                        background: $eee07520569aad07$var$_posterStep('fill'),
                                        color: (0, $lAJsX.HomePosterInk).color,
                                        Icon: {
                                            name: 'document',
                                            boxSize: 'A'
                                        }
                                    },
                                    Title: {
                                        tag: 'span',
                                        fontSize: 'A',
                                        fontWeight: '700',
                                        color: (0, $lAJsX.HomePosterInk).color,
                                        // Primary text wraps — never clamped behind an ellipsis.
                                        overflowWrap: 'anywhere',
                                        text: d.title || el.call('polyglot', 'documents.notes.untitledShort')
                                    },
                                    Caption: {
                                        extends: 'HomePosterSoftInk',
                                        tag: 'p',
                                        margin: '0',
                                        marginTop: 'auto',
                                        fontSize: 'Y',
                                        lineHeight: '1.4',
                                        overflowWrap: 'anywhere',
                                        // DATE-FMT-1 — format at the render boundary via the
                                        // shared `shortDate` formatter, never a per-callsite
                                        // slice/format in the fetch transform above: `d.updatedAt`
                                        // is the raw server ISO string (see `_mapDocRow`), so this
                                        // is the ONE place it ever gets displayed, and it can
                                        // never reach the DOM unformatted.
                                        text: [
                                            d.folder,
                                            el.call('shortDate', d.updatedAt)
                                        ].filter(Boolean).join(" \xb7 ")
                                    }
                                }))
                    },
                    // Empty state — only renders once the fetch has settled with
                    // zero documents (loading flicker is silenced by the
                    // `_documentsLoaded` gate).
                    Empty: {
                        hide: (el, s)=>!s.root?._documentsLoaded || (s.root.documents || []).length > 0,
                        flow: 'y',
                        gap: 'A',
                        padding: 'A B',
                        Description: {
                            extends: 'HomePosterSoftInk',
                            tag: 'p',
                            margin: '0',
                            fontSize: 'A',
                            lineHeight: '1.5',
                            text: '{{ workspace.notes.empty | polyglot }}'
                        }
                    }
                }
            }),
            AgentsWidget: $eee07520569aad07$var$_widget({
                id: 'agents',
                x: 0,
                y: 27,
                w: 6,
                h: 4,
                title: 'workspace.widget.agents.title',
                icon: 'star',
                openRoute: '/team-and-agents'
            }, {
                // Same geex frame-26 recipe as AnalyticsWidget below: a full-width
                // segmented share bar (people vs. agents of total headcount), then
                // per-segment giant numerals with square legend markers. Reads
                // root.people / root._agents — both already shell-loaded (same
                // contract AppTeamWidget's combined count uses above) — no new
                // fetch.
                flow: 'y',
                gap: 'B',
                padding: 'B',
                SegBar: {
                    flow: 'x',
                    width: '100%',
                    height: 'Z2',
                    round: 'radiusPill',
                    overflow: 'hidden',
                    background: $eee07520569aad07$var$_posterStep('fill'),
                    // Only shown once BOTH counts are positively read — the bar is a
                    // proportion, and a proportion of an unread population is a
                    // confident lie. `SegBarSkeleton` below stands in until then.
                    hide: (el, s)=>el.call('teamSplitUnknown', s.root),
                    title: (el, s)=>el.call('teamSplitTitle', s.root),
                    // FALSE-ZERO-1 — a PROPORTION is a measurement. Both segments
                    // used to divide by a total that silently omitted an unread
                    // roster, so the bar asserted 100% people / 0% agents (measured
                    // live: SegPeople 375.9px, SegAgents 0px, roster absent). Both
                    // now collapse to 0 until BOTH counts are positively read; the
                    // track then shows unsegmented, and the SegBar pulse marks it as
                    // loading rather than empty.
                    SegPeople: {
                        background: $eee07520569aad07$var$_posterStep('ink'),
                        transition: 'A defaultBezier flex',
                        flex: (el, s)=>el.call('teamSplitFlex', s.root, 'people')
                    },
                    SegAgents: {
                        background: $eee07520569aad07$var$_posterStep('inkMeta'),
                        transition: 'A defaultBezier flex',
                        flex: (el, s)=>el.call('teamSplitFlex', s.root, 'agents')
                    }
                },
                // FALSE-ZERO-1 loading affordance. Reuses the design system's own
                // placeholder (shared `components/Skeleton.js` — pulse keyframe +
                // a prefers-reduced-motion branch) instead of animating SegBar
                // from a factory: a returned `null` does not clear an already-set
                // animationName, so the bar kept pulsing after the roster landed —
                // a permanent "still loading" is the same class of lie as a
                // permanent zero. Mount/unmount cannot get stuck that way.
                SegBarSkeleton: {
                    extends: 'SkeletonRow',
                    width: '100%',
                    height: 'Z2',
                    round: 'radiusPill',
                    hide: (el, s)=>!el.call('teamSplitUnknown', s.root),
                    title: (el, s)=>el.call('teamSplitTitle', s.root)
                },
                Rows: {
                    flow: 'x',
                    gap: 'D',
                    wrap: 'wrap',
                    RowPeople: {
                        flow: 'y',
                        gap: 'X',
                        Num: {
                            tag: 'span',
                            fontSize: 'F',
                            fontWeight: '300',
                            lineHeight: '0.95',
                            text: (el, s)=>el.call('peopleCountText', s.root),
                            title: (el, s)=>el.call('peopleTitle', s.root)
                        },
                        LegendRow: {
                            flow: 'x',
                            align: 'center start',
                            gap: 'Y',
                            Mark: {
                                tag: 'div',
                                width: 'X2',
                                height: 'X2',
                                background: $eee07520569aad07$var$_posterStep('ink'),
                                flexShrink: '0'
                            },
                            Name: {
                                extends: 'HomePosterCaption',
                                text: '{{ workspace.caption.teamMembers | polyglot }}'
                            }
                        }
                    },
                    RowAgents: {
                        flow: 'y',
                        gap: 'X',
                        Num: {
                            extends: 'HomePosterSoftInk',
                            tag: 'span',
                            fontSize: 'F',
                            fontWeight: '300',
                            lineHeight: '0.95',
                            // FALSE-ZERO-1 surface 4 — the literal "0 AI agents": was a
                            // bare Array.isArray(_agents) ? length : 0, which reads 0
                            // for BOTH "genuinely zero agents" and "roster still
                            // loading / failed to load". agentRosterCountText
                            // distinguishes all three per the tri-state contract in
                            // shared/state.js:142-147.
                            text: (el, s)=>el.call('agentRosterCountText', s.root),
                            title: (el, s)=>el.call('agentRosterStatus', s.root) === 'error' ? el.call('polyglot', 'workspace.home.error.agents') : ''
                        },
                        LegendRow: {
                            flow: 'x',
                            align: 'center start',
                            gap: 'Y',
                            Mark: {
                                tag: 'div',
                                width: 'X2',
                                height: 'X2',
                                background: $eee07520569aad07$var$_posterStep('inkMeta'),
                                flexShrink: '0'
                            },
                            Name: {
                                extends: 'HomePosterCaption',
                                text: '{{ workspace.caption.aiAgents | polyglot }}'
                            }
                        }
                    }
                },
                // Avatar row (board §2 "team&agents split counts + avatars
                // row (currently near-empty dark card — defect)" — the counts
                // half was already fixed 2026-08-12; this adds the avatars).
                // Reuses AvatarBundleItem's overlapping-circle styling (NOT the
                // AvatarBundle wrapper — that one's own `children` factory is
                // peopleByEmail-bound, people-only; agents need a second,
                // cross-domain source), fed a MIX of root.people + root._agents
                // (both already shell-loaded, no new fetch). borderColor
                // overridden to the poster's own bg (purple) via childProps —
                // AvatarBundleItem's default 'overlay' border is an ADAPTIVE
                // token that would collide with this fixed-ink poster the same
                // way title/caption did for CityMemberRow/UpcomingEventCard.
                Avatars: {
                    // Both factories below short-circuit on `Array.isArray(...)`,
                    // so the auto-tracker can miss `_agents` on a run where
                    // `people` alone already decides the branch (FA515 — factory
                    // deps are control-flow dependent) — declared explicitly so
                    // both stay reactive regardless of which check short-circuits.
                    hideDeps: [
                        'people',
                        '_agents'
                    ],
                    // FALSE-ZERO-1: `people + agents === 0` hid the row whenever the
                    // roster was merely unread — an unread population rendered as a
                    // confident "nobody here". Only a LOADED roster may hide it.
                    hide: (el, s)=>el.call('teamAvatarsHidden', s.root),
                    flow: 'x',
                    align: 'center',
                    marginTop: 'V',
                    childExtends: 'AvatarBundleItem',
                    childrenAs: 'state',
                    // borderColor: poster bg ring (see comment above). BundlePlate:
                    // AvatarBundleItem's house identity plate ships the ADAPTIVE
                    // overlayStrong/title pair — pin it to this fixed purple
                    // poster's own derived {fill, ink} (white-ink family) so dark
                    // mode can't flip the initials illegible. ':last-child' stops
                    // the overlap stack's negative margin bleeding into the next
                    // sibling.
                    childProps: {
                        borderColor: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'agents') || {}).bg || 'overlay',
                        ':last-child': {
                            marginInlineEnd: '0'
                        },
                        BundlePlate: {
                            background: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'agents') || {}).fill || 'overlayStrong',
                            color: (el, s)=>($eee07520569aad07$var$_cardHue(el, s, 'agents') || {}).ink || 'title'
                        }
                    },
                    childrenDeps: [
                        'people',
                        '_agents'
                    ],
                    children: (el, s)=>el.call('teamAvatarRows', s.root)
                }
            }),
            YourAgentsWidget: $eee07520569aad07$var$_widget({
                id: 'youragents',
                x: 0,
                y: 33,
                w: 12,
                h: 5,
                title: 'workspace.widget.youragents.title',
                icon: 'star',
                action: {
                    icon: 'plus',
                    label: 'workspace.widget.action.createAgent',
                    set: {
                        _createAgentOpen: true,
                        _createAgentError: null
                    }
                }
            }, {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 240px), 1fr))',
                gap: 'V',
                padding: 'Z',
                childrenAs: 'state',
                children: (el, s)=>el.call('yourAgentsRows', s.root),
                childExtends: 'YourAgentCard'
            }),
            AnalyticsWidget: $eee07520569aad07$var$_widget({
                id: 'analytics',
                x: 0,
                y: 33,
                w: 6,
                h: 4,
                title: 'workspace.widget.analytics.title',
                icon: 'analytics',
                openRoute: '/workspace-analytics'
            }, {
                // Geex frame 26 (design-refs/geex/26-analytics-segmented-progress
                // .png): ONE full-width segmented bar — solid ink for active-now,
                // ink washes for the rest — then per-segment giant numerals with
                // square legend markers on the widget's gray2 poster. Reads
                // `root._homeWorkspaceActivity` (PRESENCE-ZERO-1 — see
                // `_loadHomeWorkspaceActivity` above; was the Projects-scoped
                // `root._analytics`, which read 0 in every dogfood session), with
                // ?? guards so a bare mount renders zeros, never a throw (the
                // package's own series call is the known .map crash — this
                // composition deliberately does not call it).
                flow: 'y',
                gap: 'B',
                padding: 'B',
                SegBar: {
                    flow: 'x',
                    width: '100%',
                    height: 'Z2',
                    round: 'radiusPill',
                    overflow: 'hidden',
                    background: $eee07520569aad07$var$_posterStep('fill'),
                    // FALSE-ZERO-HOME-NON-AGENT-KEYS-1 — a PROPORTION is a
                    // measurement. Both segments used to read `Number(x) || 0` over
                    // a payload nobody had read (or that had failed), so the bar
                    // asserted "0 of 0 today" as a confident 4%/96% track. Hidden
                    // until BOTH metrics are positively read; `SegBarSkeleton` below
                    // stands in (mount/unmount, never a nulled animation — see the
                    // team bar above for why). The visual floor for a nonzero share
                    // and the collapsed genuinely-zero segment live in
                    // `homeActivitySegFlex` (functions/homeLoadState.js).
                    hide: (el, s)=>el.call('homeActivityUnknown', s.root),
                    title: (el, s)=>el.call('homeActivityTitle', s.root),
                    SegNow: {
                        background: $eee07520569aad07$var$_posterStep('ink'),
                        transition: 'A defaultBezier flex',
                        flex: (el, s)=>el.call('homeActivitySegFlex', s.root, 'now')
                    },
                    SegRest: {
                        background: $eee07520569aad07$var$_posterStep('inkMeta'),
                        transition: 'A defaultBezier flex',
                        flex: (el, s)=>el.call('homeActivitySegFlex', s.root, 'rest')
                    }
                },
                SegBarSkeleton: {
                    extends: 'SkeletonRow',
                    width: '100%',
                    height: 'Z2',
                    round: 'radiusPill',
                    hide: (el, s)=>!el.call('homeActivityUnknown', s.root),
                    title: (el, s)=>el.call('homeActivityTitle', s.root)
                },
                Rows: {
                    flow: 'x',
                    gap: 'D',
                    wrap: 'wrap',
                    RowNow: {
                        flow: 'y',
                        gap: 'X',
                        Num: {
                            tag: 'span',
                            fontSize: 'F',
                            fontWeight: '300',
                            lineHeight: '0.95',
                            text: (el, s)=>el.call('homeActiveNowText', s.root),
                            title: (el, s)=>el.call('homeActivityTitle', s.root)
                        },
                        LegendRow: {
                            flow: 'x',
                            align: 'center start',
                            gap: 'Y',
                            Mark: {
                                tag: 'div',
                                width: 'X2',
                                height: 'X2',
                                background: $eee07520569aad07$var$_posterStep('ink'),
                                flexShrink: '0'
                            },
                            Name: {
                                extends: 'HomePosterCaption',
                                text: '{{ workspace.caption.activeNow | polyglot }}'
                            }
                        }
                    },
                    RowToday: {
                        flow: 'y',
                        gap: 'X',
                        Num: {
                            extends: 'HomePosterSoftInk',
                            tag: 'span',
                            fontSize: 'F',
                            fontWeight: '300',
                            lineHeight: '0.95',
                            text: (el, s)=>el.call('homeActiveTodayText', s.root),
                            title: (el, s)=>el.call('homeActivityTitle', s.root)
                        },
                        LegendRow: {
                            flow: 'x',
                            align: 'center start',
                            gap: 'Y',
                            Mark: {
                                tag: 'div',
                                width: 'X2',
                                height: 'X2',
                                background: $eee07520569aad07$var$_posterStep('inkMeta'),
                                flexShrink: '0'
                            },
                            Name: {
                                extends: 'HomePosterCaption',
                                text: '{{ workspace.caption.today | polyglot }}'
                            }
                        }
                    }
                }
            }),
            ActivityWidget: $eee07520569aad07$var$_widget({
                id: 'activity',
                x: 0,
                y: 39,
                w: 12,
                h: 6,
                title: 'workspace.widget.activity.title',
                icon: 'analytics',
                openRoute: '/tasks/my'
            }, {
                padding: 'B',
                // The heatmap is a SHARED tickets-package component (it also mounts on
                // the neutral /tasks/my page), so its own ink stays the adaptive
                // neutral pair and the POSTER re-plates it here — the same direction
                // every other sub-card on a poster now takes. Measured on the
                // analytics poster #141416 in light: the legend rgb(36,36,40) 1.19:1
                // and the caption line 2.49:1 (HOME-POSTER-NEUTRAL-INK-ON-HUE-1).
                TicketsActivityHeatmap: {
                    CaptionTitle: {
                        color: (0, $dS9Zz.HomePosterSoftInk).color
                    },
                    Legend: {
                        tag: 'div',
                        color: (0, $dS9Zz.HomePosterSoftInk).color
                    },
                    DetailsCard: {
                        Header: {
                            Title: {
                                color: (0, $lAJsX.HomePosterInk).color
                            }
                        },
                        Empty: {
                            color: (0, $dS9Zz.HomePosterSoftInk).color
                        },
                        List: {
                            childProps: {
                                Time: {
                                    color: (0, $dS9Zz.HomePosterSoftInk).color
                                },
                                Detail: {
                                    color: (0, $lAJsX.HomePosterInk).color
                                }
                            }
                        }
                    }
                }
            }),
            EventsWidget: $eee07520569aad07$var$_widget({
                id: 'events',
                x: 0,
                y: 45,
                w: 12,
                h: 6,
                title: 'workspace.widget.events.title',
                icon: 'date',
                openRoute: '/calendar'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): numeral + one line ──────────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>String($eee07520569aad07$var$_weekEvents(s).length)
                    },
                    DueLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.next7Days | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): the existing card grid, now with a
                // JOIN shortcut per meet-linked card (UpcomingEventCard.JoinBtn)
                // and an explicit empty state (was silent — a bare 0-card grid —
                // the header subtitle already says "0 events" but the body
                // itself gave no visual confirmation). Grid nested one level
                // under the tier wrapper: the tier toggle forces `display` on
                // '.widget-tier-full' itself (see _injectWidgetStyles), which
                // would clobber `display: grid` if applied to the grid directly
                // — same nesting reminders/received/given don't need (their
                // tiers are plain flow:'y' lists), but a css-grid body does.
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    minHeight: '0',
                    Empty: {
                        hide: (el, s)=>!!$eee07520569aad07$var$_weekEvents(s).length,
                        extends: 'HomePosterSoftInk',
                        padding: 'A B',
                        fontSize: 'A',
                        text: '{{ workspace.events.empty | polyglot }}'
                    },
                    Grid: {
                        hide: (el, s)=>!$eee07520569aad07$var$_weekEvents(s).length,
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))',
                        // Top-align cards at their natural height (2026-06-08 per Nika)
                        // — grid's default `stretch` made a 2-line-title card stretch
                        // every sibling in its row to match.
                        alignItems: 'start',
                        gap: 'A',
                        padding: 'B',
                        childExtends: 'UpcomingEventCard',
                        childrenAs: 'state',
                        children: (el, s)=>$eee07520569aad07$var$_weekEvents(s).slice(0, 6)
                    }
                }
            }),
            BroadcastWidget: $eee07520569aad07$var$_widget({
                id: 'broadcast',
                x: 0,
                y: 57,
                w: 12,
                h: 4,
                title: 'workspace.widget.broadcast.title',
                icon: 'bell',
                openRoute: '/announcements',
                // Opening the news marks it seen (functions/broadcast.js).
                openCall: 'markBroadcastSeen'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): numeral + one line ──────────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>String(el.call('broadcastUnreadCount', s.root))
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.unread | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): the existing colored rows ────────────
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A B',
                    minHeight: '0',
                    // Latest announcements (2026-06-12 per Nika "BroadcastWidget does
                    // not show news") — the widget was a static CTA; root.announcements
                    // is already loaded shell-wide by loadPrivateData, so render the
                    // newest three as clickable rows (same detail-modal recipe as
                    // IntranetRows: selectedAnnouncement carrier + windows layer).
                    // onClick here (not on BroadcastNewsRow itself) marks the
                    // widget "seen" on ANY click bubbling up from inside — a named
                    // row's own onClick can't be overridden via childExtends in
                    // v3.14 (see that component's file-header comment), so the
                    // listener lives one level up, on this container.
                    News: {
                        flow: 'y',
                        gap: 'Z1',
                        flex: '1',
                        minHeight: '0',
                        overflow: 'auto',
                        childExtends: 'BroadcastNewsRow',
                        childrenAs: 'state',
                        // rowIndex is positional metadata (kept for any rotating
                        // consumer); BroadcastNewsRow itself now paints the poster's
                        // own ink-alpha fill, not a second hue per row — see its header.
                        children: (el, s)=>(s.root?.announcements || []).slice(0, 3).map((a, rowIndex)=>({
                                    ...a,
                                    rowIndex: rowIndex
                                })),
                        onClick: (e, el, s)=>el.call('markBroadcastSeen')
                    },
                    Hint: {
                        hide: (el, s)=>(s.root?.announcements || []).length > 0,
                        extends: 'HomePosterSoftInk',
                        tag: 'p',
                        margin: '0',
                        fontSize: 'Z1',
                        lineHeight: '1.5',
                        text: '{{ workspace.broadcast.empty | polyglot }}'
                    }
                }
            }),
            MailInboxWidget: $eee07520569aad07$var$_widget({
                id: 'mail-inbox',
                x: 0,
                y: 61,
                w: 12,
                h: 5,
                title: 'workspace.widget.mailInbox.title',
                icon: 'email',
                openRoute: '/mail'
            }, {
                flow: 'y',
                minHeight: '0',
                // The count comes from the shell-scope stream, but the ROWS are a
                // REST read the /mail route owns — so the card fetches its own. The
                // fold is idempotent and single-flight (functions/mailFold.js), and
                // `loadMailThreads` no-ops when the slot already has rows, so a
                // re-render costs nothing. Explicit `listKey`: the card always shows
                // the UNIFIED inbox and must never move the /mail page's active view.
                onRender: async (el, s)=>{
                    if (!$eee07520569aad07$var$shellNavItemVisible(s.root, '/mail')) return;
                    try {
                        const ok = await el.call('ensureMailContext');
                        if (ok === false) return;
                        el.call('loadMailThreads', {
                            listKey: $eee07520569aad07$var$MAIL_INBOX_LIST_KEY
                        });
                    } catch (err) {
                        console.warn('[home] mail-inbox widget load failed:', err?.message || err);
                    }
                },
                // ── Mini tier (3-5 cols): numeral + one line ──────────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    subscribeTo: [
                        'navUnreadCounts'
                    ],
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>String($eee07520569aad07$var$_mailUnread(s))
                    },
                    CountLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.unread | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): Compose + the newest five threads ─────
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'Z',
                    padding: 'A B',
                    minHeight: '0',
                    subscribeTo: [
                        'mailThreads',
                        'navUnreadCounts'
                    ],
                    // §3.2a: `openMailCompose` is the ONE compose entry point — it
                    // owns every gate state (off / connect / link / ask-admin), so
                    // this button is correct on a workspace with no mailbox yet and
                    // needs no gate of its own.
                    ComposeBtn: {
                        tag: 'button',
                        type: 'button',
                        class: 'gs-no-drag',
                        flow: 'x',
                        align: 'center center',
                        gap: 'Y',
                        alignSelf: 'flex-start',
                        padding: 'Y A',
                        round: 'radiusControl',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 'Z1',
                        fontWeight: '700',
                        color: 'inherit',
                        // currentColor wash, not a token fill — the card repaints when
                        // the user picks a colour for it, and a fixed token would read
                        // as a second hue on a coloured poster (RULES Rule 67, the same
                        // reason _widget's own Header hover is derived).
                        background: 'color-mix(in srgb, currentColor 10%, transparent)',
                        transition: '120ms defaultBezier background',
                        ':hover': {
                            background: 'color-mix(in srgb, currentColor 18%, transparent)'
                        },
                        ComposeIcon: {
                            extends: 'Icon',
                            name: 'plus',
                            boxSize: 'Z1'
                        },
                        ComposeLabel: {
                            tag: 'span',
                            text: '{{ workspace.widget.mailInbox.compose | polyglot }}'
                        },
                        onClick: (e, el)=>{
                            e.stopPropagation();
                            el.call('openMailCompose');
                        }
                    },
                    Empty: {
                        hide: (el, s)=>!!$eee07520569aad07$var$_mailInboxRows(s).length,
                        extends: 'HomePosterSoftInk',
                        padding: 'Z 0',
                        fontSize: 'A',
                        text: '{{ workspace.widget.mailInbox.empty | polyglot }}'
                    },
                    Rows: {
                        hide: (el, s)=>!$eee07520569aad07$var$_mailInboxRows(s).length,
                        flow: 'y',
                        gap: 'Y',
                        flex: '1',
                        minHeight: '0',
                        overflow: 'auto',
                        childExtends: 'HomeMailRow',
                        childrenAs: 'state',
                        children: (el, s)=>$eee07520569aad07$var$_mailInboxRows(s)
                    }
                }
            }),
            TeamTimeWidget: $eee07520569aad07$var$_widget({
                id: 'teamtime',
                x: 0,
                y: 51,
                w: 12,
                h: 6,
                title: 'workspace.widget.teamtime.title',
                icon: 'globe'
            }, {
                flow: 'y',
                minHeight: '0',
                // ── Mini tier (3-5 cols): numeral + one line ──────────────────
                Mini: {
                    class: 'widget-tier-mini',
                    flow: 'y',
                    gap: 'X',
                    align: 'flex-start flex-end',
                    padding: 'Z',
                    Count: {
                        tag: 'span',
                        fontSize: 'G',
                        fontWeight: '300',
                        lineHeight: '0.9',
                        text: (el, s)=>String($eee07520569aad07$var$_teamTimezoneGroups(s).length)
                    },
                    DueLabel: {
                        extends: 'HomePosterCaption',
                        text: '{{ workspace.caption.timeZones | polyglot }}'
                    }
                },
                // ── Full tier (6+ cols): one CLUSTER per distinct timezone (was
                // one flat row per teammate — 2026-08-13 per Nika "on timezones
                // use avatarbundle and display grouped with timezones"). Each
                // cluster = zone label + giant live local time + the AvatarBundle
                // of that zone's members. Every avatar is clickable (opens their
                // profile via the same `openProfileModal` dispatch IntranetRows /
                // the People page member-open already use) and carries a hover
                // tooltip (name + role + local time) via the shared
                // @symbo.ls/tooltip contract, plus an online dot sourced from
                // `root.presenceById` — the same per-id map PersonCard's
                // PcOnlineDot reads (O(1) lookup, doesn't re-fire every dot when
                // one person's status changes).
                Full: {
                    class: 'widget-tier-full',
                    flow: 'y',
                    gap: 'X',
                    padding: 'B',
                    overflow: 'auto',
                    minHeight: '0',
                    Clusters: {
                        flow: 'y',
                        gap: 'X',
                        childExtends: 'TzCluster',
                        childrenAs: 'state',
                        children: (el, s)=>$eee07520569aad07$var$_teamTimezoneGroups(s)
                    },
                    // Every list needs an empty state (product-UI brief §7) — a
                    // solo workspace (or one where nobody has a timezone set) would
                    // otherwise render a big blank poster below the header.
                    Empty: {
                        extends: 'HomePosterCaption',
                        hide: (el, s)=>$eee07520569aad07$var$_teamTimezoneGroups(s).length > 0,
                        fontSize: 'Z1',
                        text: '{{ workspace.teamtime.empty | polyglot }}'
                    }
                }
            }),
            // Module / app / AI widgets — state-driven rows through the same frame.
            ModuleWidgets: {
                tag: 'fragment',
                subscribeTo: [
                    'workspaceProject',
                    'workspaceApps'
                ],
                childrenAs: 'state',
                childExtends: $eee07520569aad07$var$HomeModuleWidget,
                // An icon-only module widget is an app: the App strip holds it.
                children: (el, s)=>$eee07520569aad07$var$_allModuleWidgetsFor(s.root).filter((w)=>!(0, $1Qr8P.homeWidgetIsApp)(w))
            },
            // Saved cells whose widget is still loading — skeletons in place.
            PendingWidgets: {
                tag: 'fragment',
                subscribeTo: [
                    'workspaceProject',
                    'workspaceApps',
                    '_appRoutesSettled',
                    '_appsSettingUp',
                    '_homeLayout'
                ],
                childrenAs: 'state',
                childExtends: $eee07520569aad07$var$HomeWidgetPending,
                children: (el, s)=>$eee07520569aad07$var$_pendingWidgetRows(s.root)
            },
            // THE GENERATED BOARD (ASSISTANT_BOARD_MODE_SPEC §4, decision 18;
            // components/AssistantBoardView.js): a VIEW of this grid area — laid
            // over the cards from the grid's top edge, out of the grid's flow, so
            // the saved board keeps every cell and nothing on the page moves. The
            // view gates and crossfades itself (opacity + visibility, `C`); the
            // cards under it step aside (inert, aria-hidden, faded — the frame's
            // homeWidgetUnderView), so no focus, click or J / K stop reaches them.
            // No `if:` / `hide:` here: a mount-site gate REPLACES the component's
            // own. A board taller than the grid runs into MainColumn's scroll area.
            AssistantBoardView: {
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                zIndex: '2'
            },
            // THE MAIN THREAD (AI_ASSISTANT_SPEC v1 §8, the default placement;
            // components/AssistantMainThread.js): the same kind of view over this
            // grid area — the conversation in a reading column, its wide blocks
            // across the board. It gates and crossfades itself; ONE view holds the
            // area at a time (the board steps aside while the thread is up). Chat's
            // screen, and Build's while a thread opened in Apps mode holds the home
            // (functions/homeView.js): a view part — while it holds the home the
            // board stylesheet puts it in the flow.
            AssistantMainThread: {
                dataHomeViewPart: true,
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                zIndex: '2'
            },
            // THE LIVE DECK (AI_ASSISTANT_SPEC §12.1, components/AssistantDeckView.js):
            // Presentation mode's view over this grid area — it gates and crossfades
            // itself; ONE view holds the area at a time. Present's screen.
            AssistantDeckView: {
                dataHomeViewPart: true,
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                zIndex: '2'
            },
            // THE FLY CANVAS (docs/FLY_MODE.md, components/AssistantFlyView.js):
            // Fly mode's session of composed pages over this grid area — it gates
            // and crossfades itself; ONE view holds the area at a time. Main's
            // screen.
            AssistantFlyView: {
                dataHomeViewPart: true,
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                zIndex: '2'
            },
            // THE TABS' OWN SCREENS (components/HomeTabStart.js, functions/
            // homeTabStart.js; Nika 2026-10-23: "draw related experience for each
            // tab aligning AI mode"): Present's before a deck. It gates itself;
            // while it shows it is the view part in the flow (it has no box
            // otherwise).
            HomeTabStart_present: {
                tab: 'present',
                dataHomeViewPart: true
            },
            // THE BUILD TAB IS THE APP BUILDER (components/HomeBuildView.js,
            // functions/homeBuild.js; Nika 2026-10-23: "build tab should reuse
            // ui/ux of /add-apps"): the /add-app page itself in this area — the
            // build conversation, the canvas, the ready-made and the person's apps.
            // It gates and crossfades itself, in place (Nika 2026-10-23: "transit
            // page to canvas without switching the page or layout"): closed it lies
            // over this area out of the flow, like the views above; while it shows
            // the board stylesheet puts it in the flow.
            HomeBuildView: {
                dataHomeViewPart: true,
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                zIndex: '2'
            }
        },
        // THE END SENTINEL (DESIGN-WL-HOME-SKY-TOP-GROUND-1): the last in-flow
        // child of the home scroller, zero tall, its negative top margin equal to
        // the column's gap, so it adds no layout at all (the scroll height is
        // unchanged). Only the fallback reads it: a browser without CSS
        // scroll-driven animations watches it (ambientGroundWatch) and raises the
        // ambient ground at the end of the scroll; everywhere else the observer
        // is never made.
        HomeGroundMark: {
            aria: {
                hidden: 'true'
            },
            height: '0',
            marginTop: '-B',
            pointerEvents: 'none',
            flexShrink: '0',
            '@mobileL': {
                marginTop: '-B'
            },
            onRender: (el)=>el.call('ambientGroundWatch', el),
            onRemove: (el)=>el.call('ambientGroundUnwatch', el)
        },
        // Context-menu tip — a dismissible CanvasHelpCard floating bottom-right of
        // the dashboard, surfacing the right-click menus (the empty-area
        // [Refresh, Customize] menu + per-widget menu added 2026-06-29). Persisted
        // dismiss via _homeCtxTipDismissed; hidden in customize mode so it only
        // shows on the plain widget dashboard.
        //
        // ONCE, NEVER OVER CONTENT, WITH THE KEYBOARD WAY (persona audit WH-9,
        // functions/homeCtxTip.js): it shows only on the plain board (no window,
        // assistant, main thread, welcome or customize mode over it), it is
        // dismissed for good after a few seconds SEEN, and its words name Shift+F10
        // — which the board answers (MainColumn onKeydown).
        CtxMenuTip: {
            extends: 'CanvasHelpCard',
            dismissKey: '_homeCtxTipDismissed',
            position: 'fixed',
            // Its own fixed bottom replaces CanvasHelpCard's: the same call-dock
            // clearance (the shell's --calldock-clear) over its own C.
            bottom: 'max(var(--spacing-C), calc(var(--calldock-clear, 0%) + var(--spacing-A)))',
            // Above the EdgeFadeBottom scrim (zIndex 55) so the tip isn't dimmed by
            // the bottom shadow band; still under the z60 composer. (2026-07-03 per
            // Nika "CtxMenuTip should be above shadow".)
            zIndex: '56',
            // Touch now has the long-press → contextmenu shim armed on MainColumn,
            // so the tip is worth showing there too — with touch wording (below)
            // instead of being hidden as it was when the menus were mouse-only.
            //
            // Mounted only while it can show: `if:`, not `hide:` (2026-10-31). A
            // `hide:` tip is still rendered, and so are its children: the shared
            // card's Lottie loads lottie-web and swipe-right.json in its onRender,
            // so every home boot paid ~1.5 s of loading for a tip that was not on
            // screen (dismissed long ago, or under a window). The tip is fixed, out
            // of the flow, so its mount moves nothing (Rule 66). A re-show
            // re-attaches the built node: the Lottie loads once, and the tip's own
            // onRender / onRemove below still drive the once-timer.
            if: (el, s)=>el.call('homeCtxTipVisible', s.root),
            // The once-timer follows what the person can SEE (hidden time is not
            // counted): started at mount when visible, paused and resumed as layers
            // open and close over the board, dropped with the tip.
            stateDeps: [
                (el, s)=>el.call('homeCtxTipVisible', s.root)
            ],
            onStateUpdate: (el, s, ctx, { next: next })=>el.call('homeCtxTipTick', el, !!next[0]),
            onRender: (el, s)=>el.call('homeCtxTipTick', el, el.call('homeCtxTipVisible', s.root)),
            onRemove: (el)=>el.call('homeCtxTipTick', el, false),
            // CanvasHelpCard's swipe-right Lottie is baked white — invisible on this
            // card's light-theme surface (CanvasHelpCard always renders on a dark
            // canvas elsewhere, so the asset never needed to survive a light card
            // before). `difference` blend reads the mark against whatever the card
            // background actually is instead of hardcoding a per-theme color, so it
            // stays legible in both themes without touching the shared asset or
            // component (same technique already used for surface-adaptive marks in
            // ComponentThumbnailUI / Widgets).
            Lottie: {
                mixBlendMode: 'difference'
            },
            TipTitle: {
                tag: 'span',
                // Adaptive ink, NOT a fixed literal. This was `color: 'black'`, which
                // measured 1.08:1 in dark theme — black rgb(0,0,0) on the card's
                // rgb(14,14,15) glass, i.e. invisible (reported by Nika 2026-08-10,
                // "some ui that shows dark on dark"). CanvasHelpCard carries
                // `theme: 'canvas-card-glass'`, so its surface follows the theme; the
                // sibling TipLine1/TipLine2 never broke precisely because they set no
                // colour and inherit the theme's adaptive ink. `title` is the same
                // adaptive token the house menus use (ContextDropdown rows).
                color: 'title',
                fontWeight: '700',
                // Same affordance, per-input wording: long-press drives the synthetic
                // contextmenu on touch (armLongPress on MainColumn), right-click on mouse.
                text: (el)=>el.call('polyglot', el.call('isCoarsePointer') ? 'workspace.home.tipTouch' : 'workspace.home.tipMouse')
            },
            TipLine1: {
                tag: 'span',
                text: '{{ workspace.home.tip1 | polyglot }}'
            },
            TipLine2: {
                tag: 'span',
                text: '{{ workspace.home.tip2 | polyglot }}'
            }
        },
        // The widget context menu's "Add color" palette (2026-09-02). Mounted on
        // the HOME page, not in the shell — it is a home-board surface and the
        // board owns both its trigger (`_homeColorPicker`) and its write path
        // (`_homeOps.setWidgetColor`). Self-hiding on `root._homeColorPicker`, so
        // a bare mount costs one hidden node.
        HomeWidgetColorPicker: {},
        // INTERACT-1: backdrop for the drawer below — clicking anywhere outside
        // the panel closes it, same transparent pointer-catching sibling shape
        // as the house ContextDropdown's own Backdrop (shared/components/
        // ContextDropdown.js: position fixed/absolute + inset:0 + onPointerdown
        // clears the open flag). Declared BEFORE CustomizeDrawer (paints under
        // it in source order) and pinned one below its zIndex so there's no
        // ambiguity either way.
        CustomizeDrawerBackdrop: {
            hide: (el, s)=>!s.root?._homeCustomizeMode,
            position: 'fixed',
            inset: '0',
            zIndex: '1199',
            // `pointerEvents: none` is load-bearing, NOT a style tweak. This layer is
            // `inset: 0` — it covers the WHOLE viewport, and that includes the very
            // dashboard customize mode exists to edit. While it ate pointer events it
            // caused both halves of one bug (Nika 2026-08-15/16): the resize handles
            // and each card's × were unreachable because the backdrop sat on top of
            // them, AND any single click anywhere on the board hit this element's
            // onPointerdown and switched customize mode straight back off. Verified
            // live before the fix: in customize mode `document.elementFromPoint` over
            // a widget's centre AND over its south-east resize corner both returned
            // this node (`_pos-fixed _z-1199`), not the widget.
            //
            // The dismissal itself is still correct and still wanted, so it moves to
            // a document listener that can see the REAL target and skip the two
            // regions that must stay interactive: the grid, and the drawer above.
            pointerEvents: 'none',
            // Outside-press dismissal for customize mode. A DOCUMENT-level listener:
            // this layer is `pointerEvents: none` on purpose (see above), so the
            // press never reaches its own node and only the document can see the
            // REAL target.
            //
            // It used to be a raw `document.addEventListener('pointerdown', …)`
            // fired from `onInit` behind a `ctx.__customizeBackdropBound` app-scope
            // flag, with an ANONYMOUS handler — no reference was kept anywhere, so
            // nothing could remove it even in principle (FA503). Declared, DOMQL
            // registers it once and disposes it; the context flag is gone with it.
            //
            // The backdrop uses `hide:` (display:none, the node stays CONNECTED),
            // so the declared listener stays armed exactly as the raw one did.
            onDocumentPointerdown: (e, el)=>{
                const root = el.state?.root;
                if (!root || !root.update || !root._homeCustomizeMode) return;
                // The decision — which regions are NOT "outside" — lives in
                // functions/homeCustomizeDismiss.js as a pure function, so it is
                // unit-testable by BEHAVIOUR (a press on the peek keeps the mode)
                // rather than by a regex over this file's source text. The three
                // excluded regions are:
                //   .home-grid                      the board customize mode edits
                //   [data-home-customize-drawer]    the drawer itself
                //   [data-home-customize-peek]      the tucked-drawer recall handle
                //
                // The peek handle (UI-CUSTOMIZE-SIDEBAR-REOPEN-1 layer 3) mounts
                // OUTSIDE the drawer BY DESIGN (the drawer translates off-viewport
                // and would carry it along), which put it outside both other
                // exclusions — so pointerdown here dismissed customize mode BEFORE
                // the peek's own click could untuck (pointerdown precedes click;
                // qa: 0-of-3 clicks reopened, mode flipped true→false). The one
                // affordance that exists to undo the tuck must never itself be read
                // as "clicked outside".
                // ⚠️ The list is REGRESSION-PINNED twice: as a SET plus the
                // peek's marker in __tests__/zeroSizeShipped.test.js, and by
                // OUTCOME in __tests__/homeCustomizePeekReopen.test.js. An entry
                // silently dropping out is how this ticket returns.
                const { dismiss: dismiss } = (0, $ffnKx.customizeDismissDecision)(e.target, root._homeCustomizeMode);
                if (!dismiss) return;
                // S7: the exit patch clears the slide-tuck too, so a later re-open
                // never starts invisibly off-canvas from a state left over from
                // last time.
                root.update({
                    ...(0, $ffnKx.CUSTOMIZE_EXIT_PATCH)
                });
            }
        },
        // Right-side customize drawer — slides in when the FloatingCustomizeBtn
        // (above) toggles `_homeCustomizeMode`. Lists every widget the user
        // has hidden (× from each card's RemoveBtn), click any entry to
        // restore it. Reset link at the bottom keeps the previous "Reset to
        // defaults" affordance reachable.
        // UI-CUSTOMIZE-SIDEBAR-REOPEN-1 (Nika: "when customize sidebar
        // dissapears it should leave button to toggle it back"; qa triage
        // 2026-08-18): the tuck translates CustomizeDrawer +120% off-viewport
        // and DrawerSlideToggle rides INSIDE the translating container —
        // customize mode stayed on with the way back rendered off-screen. The
        // untuck affordance must live OUTSIDE the translated element: a peek
        // handle pinned to the right edge, visible ONLY while tucked, same
        // z-band as the drawer it recalls. ae7a26e58 (the tuck ANIMATION fix)
        // is untouched — this is the next problem, not a regression of it.
        CustomizeDrawerPeek: {
            extends: 'IconButton',
            class: 'gs-no-drag',
            // Layer-3 marker (UI-CUSTOMIZE-SIDEBAR-REOPEN-1): the document-level
            // customize dismisser excludes this region by attribute — without it,
            // pointerdown on the peek dismissed customize mode before the click
            // could untuck (see the dismisser's own comment in
            // CustomizeDrawerBackdrop.onInit above). Pinned as a PAIR with that
            // exclusion list in __tests__/zeroSizeShipped.test.js.
            attr: {
                'data-home-customize-peek': ''
            },
            // ZERO-SIZE-SHIPPED-1 #1: subscribeTo is REQUIRED, and listing only one
            // key would not be enough — this hide SHORT-CIRCUITS (`!mode ||
            // !tucked`), so at mount, with customize mode off, the factory returns
            // before `_homeCustomizeDrawerTucked` is ever read and the dep tracker
            // never learns about it (factory deps are control-flow dependent). The
            // tuck flip then never re-evaluated hide, the peek stayed display:none
            // forever, and qa measured it "mounted, 0×0" — present to code, absent
            // to the user. Same idiom as the studios AppSidebar: name
            // every gate key explicitly.
            subscribeTo: [
                '_homeCustomizeMode',
                '_homeCustomizeDrawerTucked'
            ],
            hide: (el, s)=>!s.root?._homeCustomizeMode || !s.root?._homeCustomizeDrawerTucked,
            position: 'fixed',
            right: 'X2',
            // Vertically centered in the drawer's own band (--shell-top .. D1),
            // not the raw viewport, so it reads as the drawer peeking back in.
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: '1200',
            // The phone sheet tucks to its own bar (handle + header) and comes back
            // from there — no side peek on a phone.
            '@mobileL': {
                hide: true
            },
            title: (el)=>el.call('polyglot', 'workspace.customize.showPanel'),
            aria: {
                label: (el)=>el.call('polyglot', 'workspace.customize.showPanel')
            },
            Icon: {
                name: 'chevronLeft',
                boxSize: 'Z'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.root.update({
                    _homeCustomizeDrawerTucked: false
                });
            }
        },
        CustomizeDrawer: {
            // Built on the FIRST customize open, not in the boot task: its
            // HomePersonalize tree cost 0.44-0.5 s of every cold home mount while
            // hidden (mount profile, dev deploy 31). One-way latch - once built,
            // `hide:` below owns visibility as before (no re-create on close, no
            // lost scroll). Its components stay registered eagerly, so the latch
            // defers only the BUILD (same pattern as app.js _latchOnce).
            if: (el, s)=>{
                if (el.__customizeDrawerBuilt) return true;
                if (!s.root?._homeCustomizeMode) return false;
                el.__customizeDrawerBuilt = true;
                return true;
            },
            hide: (el, s)=>!s.root?._homeCustomizeMode,
            // Marks the drawer for CustomizeDrawerBackdrop's outside-pointerdown
            // test above — a pointerdown in here restores a widget or resets the
            // layout, and must not be read as "clicked outside, close".
            // `data-tucked` carries the slide-away state to the CSS (the side drawer
            // slides off to the right, the phone sheet collapses to its bar) — see
            // the tuck rules below.
            attr: {
                'data-home-customize-drawer': '',
                'data-tucked': (el, s)=>s.root?._homeCustomizeDrawerTucked ? 'true' : null
            },
            // INTERACT-1: Esc-to-close. A document-level listener, not a
            // declarative onKeydown — the drawer opens from a context-menu click
            // (or the navbar dropdown), neither of which parks DOM focus inside
            // this panel, so an element-scoped keydown handler would never see
            // the Escape keystroke (the exact bug class this ticket also found on
            // the Home right-click ContextDropdown — that one lives in
            // shared/components/ContextDropdown.js, a shared-library file this
            // lane may not edit; documented separately, not worked around here).
            // It used to be a raw `document.addEventListener('keydown', …)` fired
            // from `onInit` behind a `ctx.__customizeDrawerEscBound` app-scope flag,
            // with an ANONYMOUS handler — nothing could ever remove it (FA503).
            // Declared, DOMQL registers it once and disposes it; the flag is gone.
            //
            // The drawer uses `hide:` (display:none, the node stays CONNECTED), so
            // the listener stays armed exactly as the raw one did — and the handler
            // still self-guards on LIVE state rather than assuming it is open.
            onDocumentKeydown: (e, el)=>{
                // A handled Escape closed something on top (a menu, a palette) — the
                // board stays in edit mode (HOME_AMBIENT_SKIN_SPEC §5: top overlay first).
                if (e.key !== 'Escape' || e.defaultPrevented) return;
                const root = el.state?.root;
                if (!root || !root.update || !root._homeCustomizeMode) return;
                // A dialog or a dropdown ABOVE the drawer owns this Escape (the Reset
                // layout confirm is the everyday case): the drawer does nothing and
                // leaves the key unspent for it — one Escape, one layer.
                if (typeof el.call === 'function' && el.call('shellOverlayOpen')) return;
                e.preventDefault();
                root.update({
                    _homeCustomizeMode: false,
                    _homeCustomizeDrawerTucked: false
                });
            },
            // Exact chat-drawer chrome (2026-06-10 per Nika "CustomizeDrawer should
            // have exact styles, position and theming as chatdrawer"): the same
            // floating glass card the MessengerOverlay list uses (canvas-card-glass,
            // X2 edge inset, --shell-top top / D1 bottom, G1 width, round A) — mirrored
            // to the RIGHT edge. Top tracks the shared --shell-top baseline so it lines
            // up with the messenger + every canvas rail. (2026-07-08 per Nika "sidebar
            // positions consistent on all pages".)
            position: 'fixed',
            right: 'X2',
            top: '--shell-top',
            bottom: 'D1',
            width: 'G1',
            minWidth: 'G1',
            maxWidth: 'G1',
            zIndex: '1200',
            theme: 'canvas-card-glass',
            borderWidth: '0',
            round: 'radiusCard',
            padding: 'A',
            overflow: 'auto',
            // Drawer scroller: edge-bounce must not chain to the dashboard behind.
            overscrollBehavior: 'contain',
            flow: 'y',
            gap: 'B',
            shadow: 'float',
            animation: 'fadeInUpShort',
            animationDuration: 'C',
            // BF-CUSTOMIZE-DRAWER-TOGGLE-1 (Nika 2026-08-16 "hiding toggle does not
            // work"): the framework's `animation` prop defaults
            // `animation-fill-mode` to `both` (css-in-props props/animation.js), so
            // once fadeInUpShort finished, its `to` keyframe
            // (`transform: translate3d(0,0,0)`) stayed applied FOREVER — and a
            // running-or-filled animation outranks every normal declaration in the
            // cascade, class or inline. DrawerSlideToggle then flipped the flag and
            // the chevron on every click while the `transform:` factory below wrote
            // `translateX(120%)` into a declaration the animation kept overriding:
            // flag true, computed transform still `matrix(1,0,0,1,0,0)`. `backwards`
            // keeps the entrance exactly as it was (the `from` state before the first
            // frame) and RELEASES the element to its own transform the moment the
            // animation ends — the `to` keyframe equals the declared resting state,
            // so nothing visibly changes at that hand-off.
            animationFillMode: 'backwards',
            // S7 (NIKA BATCH 2026-08-16) — slide-away toggle, separate from
            // `_homeCustomizeMode` (which mounts/unmounts this whole panel via
            // `hide:` above): `_homeCustomizeDrawerTucked` stays true only while
            // still IN customize mode, so DrawerSlideToggle below can push the
            // panel fully clear of the viewport and pull it back without exiting
            // customize mode. 120% (not 100%) clears the panel past the edge
            // regardless of its own resolved width — no token needed, unlike
            // `right: X2` above, which this doesn't need to know the value of.
            // A STATIC rule on `data-tucked` (attr above), not a transform factory:
            // a factory writes the value INLINE, and an inline transform outranks
            // every `@mobileL` rule — the phone sheet below must not slide sideways.
            '&[data-tucked]': {
                transform: 'translateX(120%)'
            },
            transition: '160ms defaultBezier transform',
            // THE PHONE SHEET (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1; orchestrator
            // decision 2026-10-06). The phone posture used to be the side drawer
            // stretched over the whole screen (inset A on all four sides): edit mode
            // opened over the very board it edits — measured on dev 586122071 at
            // 393, the drawer 16..377 x 16..836 and 0 of 20 widget size segments
            // reachable until the drawer was tucked. On a phone it is a BOTTOM SHEET
            // now: about half the viewport, docked on the bottom edge, top corners
            // round, a grab handle on top (SheetHandle) — the board stays visible
            // and scrollable above it (the board's own bottom room in edit mode:
            // workspace/app.js, `[data-customizing="open"]`). Its last rows clear
            // the composer and the home indicator: `--slot-bottom` is the composer's
            // live top plus the gap and already folds in env(safe-area-inset-bottom);
            // the max() keeps the safe area when no composer is on screen.
            // Tucked, the sheet collapses to its handle and header (the header's
            // toggle and the handle bring it back) instead of sliding sideways.
            // iPad (above 768px) and desktop keep the side drawer.
            '@mobileL': {
                left: '0',
                right: '0',
                top: 'auto',
                bottom: '0',
                width: 'auto',
                minWidth: '0',
                maxWidth: 'none',
                height: '50dvh',
                borderBottomLeftRadius: '0',
                borderBottomRightRadius: '0',
                padding: 'Z1',
                paddingTop: '0',
                paddingBottom: 'max(calc(var(--spacing-Z1) + env(safe-area-inset-bottom)), var(--slot-bottom, var(--spacing-Z1)))',
                gap: 'A',
                '& > [data-key="SheetHandle"]': {
                    display: 'flex'
                },
                '&[data-tucked]': {
                    transform: 'none',
                    height: 'auto'
                },
                '&[data-tucked] > :not([data-key="SheetHandle"]):not([data-key="DrawerHeader"])': {
                    display: 'none'
                }
            },
            // The phone sheet's grab handle: the whole 44pt-tall top band answers a
            // tap — tuck the sheet down to its bar, or bring it back up. Pointer
            // only (aria-hidden): DrawerSlideToggle in the header is the same
            // control for the keyboard and for assistive tech. Shown only in the
            // phone posture (the `@mobileL` rule above).
            SheetHandle: {
                class: 'gs-no-drag',
                display: 'none',
                flexShrink: '0',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                minHeight: 'controlH',
                cursor: 'pointer',
                'aria-hidden': 'true',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    s.root.update({
                        _homeCustomizeDrawerTucked: !s.root?._homeCustomizeDrawerTucked
                    });
                },
                Grip: {
                    tag: 'span',
                    display: 'block',
                    width: 'B1',
                    height: 'X',
                    round: 'radiusPill',
                    background: 'caption',
                    opacity: '.4'
                }
            },
            DrawerHeader: {
                flow: 'x',
                align: 'center space-between',
                DrawerTitle: {
                    tag: 'h3',
                    margin: '0',
                    fontSize: 'A',
                    fontWeight: '700',
                    // Adaptive ink, NOT a fixed literal — the geex craft pass swept this
                    // to 'black' along with the postered widget bodies, but the drawer
                    // sits on adaptive canvas-card-glass, so dark theme rendered black
                    // on black (same class of bug as TipTitle above).
                    color: 'title',
                    text: '{{ workspace.customize.title | polyglot }}'
                },
                // S7 + house close grouped together on the right, Title left, via
                // the same `align: 'center space-between'` DrawerHeader already
                // declares — a bare 3rd child would space-between across all three
                // instead of grouping the two buttons.
                HeaderActions: {
                    flow: 'x',
                    align: 'center',
                    gap: 'V',
                    // Slide the panel out of the way and back, staying IN customize
                    // mode (unlike DrawerClose below, which exits it). Same
                    // directional chevron-flip convention as canvas/components/
                    // PageSlot.js's Back/Forward header buttons.
                    DrawerSlideToggle: {
                        extends: 'IconButton',
                        class: 'gs-no-drag',
                        title: (el, s)=>el.call('polyglot', s.root?._homeCustomizeDrawerTucked ? 'workspace.customize.showPanel' : 'workspace.customize.slideAway'),
                        aria: {
                            label: (el, s)=>el.call('polyglot', s.root?._homeCustomizeDrawerTucked ? 'workspace.customize.showPanel' : 'workspace.customize.slideAway')
                        },
                        Icon: {
                            name: (el, s)=>s.root?._homeCustomizeDrawerTucked ? 'chevronLeft' : 'chevronRight',
                            boxSize: 'Z',
                            // The phone sheet tucks DOWN and comes back UP: a quarter turn
                            // makes the same two chevrons read down (open) and up (tucked).
                            '@mobileL': {
                                transform: 'rotate(90deg)'
                            }
                        },
                        onClick: (e, el, s)=>{
                            e.stopPropagation();
                            s.root.update({
                                _homeCustomizeDrawerTucked: !s.root?._homeCustomizeDrawerTucked
                            });
                        }
                    },
                    // House drawer-header close — THE brand CloseButton (F2
                    // 2026-08-16, one X for every sidebar, drawer and modal): 36px
                    // circle, 16px glyph, hover wash. INTERACT-1's tap-target concern
                    // is met by the IconButton base's coarse-pointer 44pt tap slop,
                    // not by a bigger visible box.
                    DrawerClose: {
                        extends: 'CloseButton',
                        class: 'gs-no-drag',
                        title: (el)=>el.call('polyglot', 'workspace.customize.close'),
                        aria: {
                            label: (el)=>el.call('polyglot', 'workspace.customize.close')
                        },
                        onClick: (e, el, s)=>{
                            e.stopPropagation();
                            s.root.update({
                                _homeCustomizeMode: false,
                                _homeCustomizeDrawerTucked: false
                            });
                        }
                    }
                }
            },
            // PERSONALISE (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1, Nika's pick row 4 A:
            // one panel, grouped) — the App strip, the theme, the background and the
            // summary style, above this drawer's own widget list
            // (components/HomePersonalize.js). Every row is a live decision: the
            // board behind the drawer is the preview.
            HomePersonalize: {
                HomePersonalizeGroup_strip: {
                    AppsList: {
                        children: (el, s)=>$eee07520569aad07$var$_personalizeAppRows(s.root)
                    }
                }
            },
            // The widgets' group: its caption, then the hint and the hidden list.
            CaptionTitle_widgets: {
                fontSize: 'Y2',
                margin: '0',
                align: 'center flex-start',
                Text: {
                    text: '{{ workspace.personalize.widgets | polyglot }}'
                }
            },
            DrawerHint: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y',
                color: 'caption',
                lineHeight: '1.5',
                text: (el, s)=>el.call('polyglot', $eee07520569aad07$var$_drawerHiddenRows(s.root).length === 0 ? 'workspace.customize.hintNoneHidden' : 'workspace.customize.hintSomeHidden')
            },
            HiddenSection: {
                hide: (el, s)=>$eee07520569aad07$var$_drawerHiddenRows(s.root).length === 0,
                flow: 'y',
                gap: 'V',
                // Shared CaptionTitle (2026-06-10 per Nika "CaptionTitle component for
                // caption titles; also match Customize sidebar from / page") — the
                // FilesSidebar / TicketsSidebar / chat rails already render their
                // section captions through this built-in; the home Customize drawer
                // was the last holdout still hand-rolling an inline uppercase span.
                // Same usage shape as those overlays (fontSize Y2 + a Text child).
                CaptionTitle: {
                    fontSize: 'Y2',
                    Text: {
                        text: '{{ workspace.customize.hidden | polyglot }}'
                    }
                },
                HiddenList: {
                    flow: 'y',
                    gap: 'V',
                    childrenAs: 'state',
                    children: (el, s)=>$eee07520569aad07$var$_drawerHiddenRows(s.root),
                    childExtends: $eee07520569aad07$var$_customizeDrawerItem
                }
            },
            // Reset action stays available from the drawer — same behaviour
            // as the old bottom CustomizeBar: clear workspace-scoped local
            // cache + drop `homeGridLayout` from server prefs, then reload.
            ResetBtn: {
                tag: 'button',
                type: 'button',
                class: 'gs-no-drag',
                marginTop: 'A',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                // Fill-contrast separation (borderless law) — the old white.12 stroke
                // + white.06 hover were raw literals that vanished in light theme.
                background: 'overlay',
                border: 'none',
                color: 'caption',
                fontSize: 'Z2',
                cursor: 'pointer',
                textAlign: 'center',
                transition: '120ms ease background',
                ':hover': {
                    background: 'hover'
                },
                text: '{{ workspace.customize.reset | polyglot }}',
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    // RESET-LAYOUT-1: this reloads the page and discards every manual
                    // resize/drag with no way back — confirm before doing it (it was a
                    // silent, unconfirmed destructive action behind the reload).
                    el.call('confirmDialog', {
                        title: el.call('polyglot', 'workspace.customize.resetConfirmTitle'),
                        message: el.call('polyglot', 'workspace.customize.resetConfirmMessage'),
                        confirmText: el.call('polyglot', 'common.action.reset'),
                        cancelText: el.call('polyglot', 'common.action.cancel'),
                        // The house confirm (CRUD standard D1): the primary button, no icon.
                        confirmTheme: 'primary',
                        icon: null,
                        onConfirm: async ()=>{
                            // Cancel any drag/resize save still debouncing (see
                            // _cancelPendingPrefsSave) BEFORE anything else, so a stale
                            // pre-reset patch can never flush over this reset's own write.
                            $eee07520569aad07$var$_cancelPendingPrefsSave();
                            try {
                                // Clear every home-scoped key — the layout, the outbox AND the
                                // hidden-widget set — so reset truly restores defaults. (The
                                // hiddenWidgets key was surviving, silently keeping the user's
                                // last hidden set across a "reset".)
                                Object.keys(localStorage).filter((k)=>k.startsWith('symbols.home.')).forEach((k)=>localStorage.removeItem(k));
                            } catch (_) {
                            /* ignore */ }
                            const root = s.root;
                            if (root?.currentUserId && el.sdk?.execute) {
                                // Clear the layout AND every widget choice on the server
                                // profile, stamping the current version: `grid_layout: null`
                                // and `hidden_widgets: {}` say "no choices", and the board
                                // composes the workspace's own defaults over that — its panel
                                // set, app mode (the installed module's widgets alone, Nika
                                // 2026-09-10) and the installed apps' default widgets
                                // (`_resolveBootHidden`). The same answer the next boot reads,
                                // on this device and every other.
                                //
                                // NEVER a stamped copy of today's defaults
                                // (DESIGN-WL-HOME-DEFAULTS-ALL-WORKSPACES-1). This payload used
                                // to write an explicit boolean for EVERY catalog id — the
                                // global default of that day. A stored default outranks every
                                // later default for that member, so the next default change
                                // would never have reached anybody who ever pressed Reset; and
                                // it ignored the workspace's panel set, so a Reset on a
                                // configured workspace hid the panels its admin had turned on.
                                // The two reasons it was dense are gone: the read composes
                                // `{ ...base, ...saved }`, so `{}` IS the defaults (it no
                                // longer un-hides the catalog), and the server REPLACES
                                // `hidden_widgets` whole (PrefsService, since 14079239), so no
                                // stale per-id key survives an empty write. The module
                                // console's reset (mcResetPersonalization) already wrote `{}`.
                                const next = {
                                    grid_layout: null,
                                    hidden_widgets: {},
                                    dashboard_v: $eee07520569aad07$var$CURRENT_DASHBOARD_V
                                };
                                // RESET-LAYOUT-1: this session's own gestures are forgotten
                                // first (_forgetHomeGestures), or a pre-reset drag or size
                                // pick would outrank this block's own `grid_layout: null` and
                                // silently undo the reset.
                                // WS-HOME-RESET-LAYOUT-INPLACE-1: the OPTIMISTIC local row must
                                // be SCOPE-SHAPED, not a bare copy of the server payload.
                                // `_prefsRowForScope` accepts a prefs object only when its
                                // `workspace_id` matches the live `_wsScope(root)`, and BOTH
                                // hidden-widget resolvers read the saved map through it. A bare
                                // `next` (no workspace_id) reads as "no row for this
                                // workspace", so the board's reconcile re-derives the generic
                                // workspace default and UN-HIDES exactly the widgets this reset
                                // just hid — measured live on system/hq: the reset's own
                                // 34-key map landed on the server, the board kept all 33
                                // widgets on screen, and only a reload agreed with the write.
                                // The server payload stays `next`: workspace_id / user_id are
                                // the server's to derive, never the client's to send.
                                const prevPrefs = root.userDashboardPrefs || {};
                                const nextLocal = {
                                    ...next,
                                    workspace_id: prevPrefs.workspace_id || $eee07520569aad07$var$_wsScope(root),
                                    user_id: prevPrefs.user_id
                                };
                                // The defaults win over this session's own gestures from here on.
                                $eee07520569aad07$var$_forgetHomeGestures();
                                root.update({
                                    userDashboardPrefs: nextLocal,
                                    _homeCustomizeMode: false
                                });
                                // The board from here: the ONE hidden-map resolver over the
                                // seeded row — the workspace's defaults composed over no
                                // choices, exactly what the next boot reads.
                                root.update({
                                    _homeHiddenWidgets: $eee07520569aad07$var$_resolveBootHidden(root).hidden
                                });
                                try {
                                    await el.sdk.execute('workspaceProject.homeDashboardPrefs', 'update', {
                                        payload: next
                                    });
                                } catch (err) {
                                    console.warn('[home] reset dashboard prefs failed:', err && err.message);
                                    // RESET-LAYOUT-2: a failed write used to fall straight through
                                    // to the reload below — which re-read the SERVER's UNTOUCHED
                                    // prefs and restored the exact arrangement the user had just
                                    // asked to discard. So a FAILED reset was indistinguishable
                                    // from a successful one: the page churned through a full boot
                                    // and everything came back, with the only trace a console
                                    // warning nobody sees. That is the reported "net effect of
                                    // clicking Reset: nothing is reset".
                                    //
                                    // Never reload over a failed write. Say so instead, and keep
                                    // the optimistic local reset on screen so the user can see
                                    // what WOULD have been applied and retry — a reload here
                                    // would silently revert that too.
                                    el.call('alertDialog', {
                                        title: el.call('polyglot', 'workspace.customize.resetFailed'),
                                        message: el.call('polyglot', 'workspace.customize.resetFailedMessage')
                                    });
                                    return;
                                }
                            }
                            // WS-HOME-RESET-LAYOUT-INPLACE-1: restore in place. This used
                            // to be `window.location.reload()` — and the reload was not
                            // laziness, it WAS the restore mechanism: nothing at runtime
                            // knew a widget's default cell. `_SPEC_GEOMETRY` knows them now,
                            // and the CSS grid reflows from the re-resolved order at once,
                            // so a reset no longer costs the whole JS heap, the scroll
                            // position and every open panel.
                            if (!$eee07520569aad07$var$_resetLayoutInPlace(root)) // No root to re-resolve on (the page is gone). The server
                            // prefs are already reset; the next board mount resolves them.
                            console.warn("[home] reset: no board root \u2014 prefs reset, board not re-laid");
                        }
                    });
                }
            }
        }
    }
};

});
parcelRegister("lAJsX", function(module, exports) {

$parcel$export(module.exports, "HomePosterInk", () => $fb803a6326418ca4$export$2e60dab1d427f8d2);

var $bbG8O = parcelRequire("bbG8O");
const $fb803a6326418ca4$export$2e60dab1d427f8d2 = {
    color: (el)=>{
        const h = (0, $bbG8O.posterCardHue)(el);
        return h ? h.ink : 'title';
    }
};

});
parcelRegister("bbG8O", function(module, exports) {

$parcel$export(module.exports, "posterCardHue", () => $8251692a218c9a16$export$b9149d351bca8154);
// The ONE poster lookup every poster-ink component shares.
//
// A home-board POSTER card is theme-INVARIANT by construction: `_widget()`
// commits the card to one hue + its binary ink and repeats that background in
// BOTH scheme blocks (see pages/main.js `_widget`). Any descendant that paints
// an ADAPTIVE NEUTRAL token on it (`title` → rgb(4,4,4) light / rgb(241,241,243)
// dark, `caption` → rgb(36,36,40) / rgb(206,206,210)) is therefore wrong in one
// of the two themes by construction — measured 1.11–4.18:1 across the sub-cards
// on /w/system/hq (HOME-POSTER-NEUTRAL-INK-ON-HUE-1, 2026-08-22). The fix is
// never a per-component hue literal and never a new alpha: the descendant takes
// the POSTER's OWN ink, which resolves at paint time off the same
// `--color-poster<Family>Ink` var a branded workspace can override.
//
// `_widget()` stamps `posterId: spec.id` on the poster card; `el.lookup` walks
// ancestors with a ONE-argument predicate (never the `(el, s)` factory shape).
// Returns `null` outside a poster (a neutral card such as the greeting, a module
// widget, or the same shared component mounted on a plain page), so each caller
// keeps its own documented adaptive fallback.
//
// Deliberately NOT registered in functions/index.js: it takes the ELEMENT
// itself, and `el.call('name', …)` forwards arguments only — there is no call
// shape that could pass one. The two ink components import it directly.
//
// ⚠️ 2026-09-02 — the resolution moved from the HOUSE catalog to the USER's
// own colour (Nika: "make solid - a default color for all of them … add in
// context menu 'Add color'"). Every card still stamps `posterId`, including
// the neutral ones, because the stamp is now the widget IDENTITY the colour
// map is keyed by, not a claim that the card carries a hue. `null` — the
// neutral answer — is therefore the COMMON case, not the exception: a card
// with no user colour paints the adaptive glass, and a descendant that
// painted a poster ink on it would be white-on-white in one theme. That is
// exactly the bug class HOME-POSTER-NEUTRAL-INK-ON-HUE-1 fixed in the other
// direction, so both inks keep their neutral `title` / `caption` fallbacks
// and simply reach them far more often now.
//
// `el.state.root` is the ROOT STATE the colour map lives on. The chain
// mirrors the one pages/main.js already uses at its own root-from-element
// sites (`el.state?.root || el.getRoot?.()?.state?.root || …`) so a leaf
// mounted before its state binds resolves neutral rather than throwing —
// one throw inside a colour factory kills that element's whole effect.
function $8251692a218c9a16$export$b9149d351bca8154(el) {
    const card = el.lookup((c)=>!!c.posterId);
    if (!card) return null;
    const root = el.state?.root || el.getRoot?.()?.state?.root || el.getRoot?.()?.state || null;
    return el.call('homeWidgetSurfaceHue', root, card.posterId);
}

});


parcelRegister("dS9Zz", function(module, exports) {

$parcel$export(module.exports, "HomePosterSoftInk", () => $a19811bb339f5cc4$export$f6b4a22cfbc9a5a9);

var $bbG8O = parcelRequire("bbG8O");
const $a19811bb339f5cc4$export$f6b4a22cfbc9a5a9 = {
    color: (el)=>{
        const h = (0, $bbG8O.posterCardHue)(el);
        return h ? h.inkSoft : 'caption';
    }
};

});

parcelRegister("2zU0i", function(module, exports) {

$parcel$export(module.exports, "barSegments", () => $1e0a4ad8d503123b$export$7e7a0530b2483994);
$parcel$export(module.exports, "PRIORITY_BUCKETS", () => $1e0a4ad8d503123b$export$d8e6797740c50842);
$parcel$export(module.exports, "priorityMix", () => $1e0a4ad8d503123b$export$ac4f797b581310aa);
$parcel$export(module.exports, "workloadRows", () => $1e0a4ad8d503123b$export$e11c5a1369ab37f4);
// homeSummary.js — the pure summary math behind the home page's
// board-status widgets (Team pulse, Priority mix, Workload).
//
// S8 of the 2026-08-16 Nika batch: "I like how our board-status py script
// looks — we need a few new builtin widgets for workspace default that show
// similar summaries." The properties worth copying from that script are
// not its ASCII: a proportional bar that never rounds a non-empty bucket
// away, fixed-width count cells so a number growing a digit cannot reflow
// its row, and a legend that names who can act.
//
// Everything here is pure: it takes an array of ALREADY-OPEN tickets and
// returns numbers. The page owns the data plumbing (which tickets are
// loaded, which count as open); this module owns the arithmetic, so the
// "never round to zero" property has exactly one implementation and one
// test file instead of one copy per widget.
/**
 * Largest-remainder allocation of `totalUnits` proportional segments over
 * `buckets`, the same algorithm board-status.py's own `bar()` uses.
 *
 * Two properties the tests pin, both load-bearing:
 *  - a bucket with ANY items gets at least 1 unit (a 1-in-40 bucket must
 *    not disappear — "nothing blocked" when one ticket genuinely is
 *    blocked is a wrong answer, not a rounding detail);
 *  - the emitted units sum to EXACTLY `totalUnits` (the "91 cells against
 *    a 90-column rule" bug the python script's own comment warns about).
 *
 * @param {Array<{key:string,label?:string,hue?:string}>} buckets
 * @param {Record<string, number>} counts  bucket key → item count
 * @param {number} totalUnits
 * @returns {Array<object>} the buckets that earned ≥1 unit, each with `units`
 */ const $1e0a4ad8d503123b$export$7e7a0530b2483994 = (buckets, counts, totalUnits)=>{
    const total = buckets.reduce((sum, b)=>sum + (counts[b.key] || 0), 0);
    if (!total || totalUnits < 1) return [];
    const live = buckets.map((b)=>({
            ...b,
            n: counts[b.key] || 0
        })).filter((r)=>r.n > 0);
    // More non-empty buckets than the bar has units: the min-1 promise
    // cannot hold for all of them, so keep the biggest `totalUnits` and say
    // so by dropping the rest — never by emitting a bar wider than its box.
    if (live.length >= totalUnits) return [
        ...live
    ].sort((a, b)=>b.n - a.n).slice(0, totalUnits).map((r)=>({
            ...r,
            units: 1
        }));
    // Every non-empty bucket takes 1 unit up front (that IS the min-1
    // property); the REST is what gets shared proportionally. Allocating
    // the full width proportionally and then clamping each floor up to 1
    // is what over-fills the bar — 100/1/1 over 8 units wants 7+1+1 = 9.
    const rest = totalUnits - live.length;
    const take = live.map((r)=>{
        const share = r.n / total * rest;
        return {
            ...r,
            share: share,
            units: 1 + Math.floor(share)
        };
    });
    let left = totalUnits - take.reduce((sum, r)=>sum + r.units, 0);
    const byRemainder = [
        ...take
    ].sort((a, b2)=>b2.share - Math.floor(b2.share) - (a.share - Math.floor(a.share)));
    for (const r of byRemainder){
        if (left <= 0) break;
        r.units += 1;
        left -= 1;
    }
    return take;
};
const $1e0a4ad8d503123b$export$d8e6797740c50842 = [
    {
        key: 'urgent',
        label: 'workspace.priority.urgent',
        hue: 'red'
    },
    {
        key: 'high',
        label: 'workspace.priority.high',
        hue: 'orange'
    },
    {
        key: 'medium',
        label: 'workspace.priority.medium',
        hue: 'blue'
    },
    {
        key: 'low',
        label: 'workspace.priority.low',
        hue: 'caption'
    }
];
const $1e0a4ad8d503123b$export$75760dc28712fe99 = (t)=>{
    const key = String(t?.priority || t?.severity || '').toLowerCase();
    if (key === 'urgent' || key === 'p0' || key === 'critical') return 'urgent';
    if (key === 'high' || key === 'p1') return 'high';
    if (key === 'medium' || key === 'normal' || key === 'p2') return 'medium';
    if (key === 'low' || key === 'p3' || key === 'minor') return 'low';
    return null;
};
const $1e0a4ad8d503123b$export$ac4f797b581310aa = (openTickets)=>{
    const counts = {
        urgent: 0,
        high: 0,
        medium: 0,
        low: 0,
        unset: 0
    };
    for (const t of openTickets || [])counts[$1e0a4ad8d503123b$export$75760dc28712fe99(t) || 'unset'] += 1;
    return counts;
};
const $1e0a4ad8d503123b$export$30240b284ec2b91d = [
    'blue',
    'orange',
    'purple',
    'red',
    'green'
];
const $1e0a4ad8d503123b$export$2f9280fe3db9be8c = 5;
const $1e0a4ad8d503123b$export$80b8fc2be194ef53 = (email)=>String(email || '').split('@')[0] || 'unknown';
const $1e0a4ad8d503123b$export$e11c5a1369ab37f4 = (openTickets, emailOf)=>{
    const readEmail = emailOf || ((t)=>String(t?.assigneeEmail || '').toLowerCase());
    const byEmail = new Map();
    let unassigned = 0;
    for (const t of openTickets || []){
        const email = readEmail(t);
        if (!email) {
            unassigned += 1;
            continue;
        }
        byEmail.set(email, (byEmail.get(email) || 0) + 1);
    }
    const sorted = [
        ...byEmail.entries()
    ].sort((a, b)=>b[1] - a[1] || a[0].localeCompare(b[0]));
    const head = sorted.slice(0, $1e0a4ad8d503123b$export$2f9280fe3db9be8c);
    const tail = sorted.slice($1e0a4ad8d503123b$export$2f9280fe3db9be8c);
    const rows = head.map(([email, n], i)=>({
            key: email,
            label: $1e0a4ad8d503123b$export$80b8fc2be194ef53(email),
            hue: $1e0a4ad8d503123b$export$30240b284ec2b91d[i % $1e0a4ad8d503123b$export$30240b284ec2b91d.length],
            n: n
        }));
    if (tail.length) rows.push({
        key: '_others',
        label: 'workspace.workload.more',
        moreCount: tail.length,
        hue: 'caption',
        n: tail.reduce((sum, [, n])=>sum + n, 0)
    });
    return {
        rows: rows,
        unassigned: unassigned
    };
};

});

parcelRegister("ffnKx", function(module, exports) {

$parcel$export(module.exports, "customizeDismissDecision", () => $b19aade63b762f26$export$281ffaad70974d1c);
$parcel$export(module.exports, "CUSTOMIZE_EXIT_PATCH", () => $b19aade63b762f26$export$4821d236814832ff);
// Home board — the "clicked outside customize mode" decision, as ONE pure
// function instead of an inline exclusion list inside pages/main.js.
//
// UI-CUSTOMIZE-SIDEBAR-REOPEN-1 (layer 3, and the reason this file exists):
// the document-level dismisser flipped `_homeCustomizeMode` off on a
// pointerdown anywhere outside the two regions it knew about — the grid and
// the drawer. The tuck/untuck peek handle mounts OUTSIDE the drawer BY
// DESIGN (the drawer translates +120% off-viewport and would carry the peek
// with it — that was layer 1), so the ONE affordance that exists to undo the
// tuck was itself read as "clicked away from the drawer": pointerdown
// dismissed customize mode BEFORE the peek's own click could untuck
// (pointerdown precedes click). The user got a visible control that did the
// opposite of its job, three fixes in a row.
//
// The exclusion list is the ONLY thing standing between that user story and
// its fourth return, and a regex pin on the source text of pages/main.js
// cannot execute it. Here it is a unit: `customizeDismissDecision` takes the
// event target and the live mode flag and returns the decision plus WHY, so
// a test asserts the BEHAVIOUR (a peek pointerdown keeps the mode) instead
// of the spelling of a selector inside a 10k-line page factory.
//
// Pure by construction: no DOM reads beyond `target.closest`, no state
// writes. The caller performs the `root.update`.
// Regions a pointerdown must never be read as a dismissal of customize mode.
// Each entry is load-bearing and each has already cost one shipped bug:
//  - `.home-grid`             the board customize mode exists to edit (select,
//                             drag, resize, remove a widget)
//  - `[data-home-customize-drawer]`  the panel itself (restore a widget, reset)
//  - `[data-home-customize-peek]`    the tucked-drawer recall handle, layer 3
const $b19aade63b762f26$export$b5ec4ade5196793c = [
    '.home-grid',
    '[data-home-customize-drawer]',
    '[data-home-customize-peek]'
];
const $b19aade63b762f26$export$281ffaad70974d1c = (target, customizeMode)=>{
    if (!customizeMode) return {
        dismiss: false,
        reason: 'not-customizing'
    };
    if (!target || typeof target.closest !== 'function') return {
        dismiss: false,
        reason: 'no-target'
    };
    for (const selector of $b19aade63b762f26$export$b5ec4ade5196793c){
        if (target.closest(selector)) return {
            dismiss: false,
            reason: selector
        };
    }
    return {
        dismiss: true,
        reason: 'outside'
    };
};
const $b19aade63b762f26$export$4821d236814832ff = {
    _homeCustomizeMode: false,
    _homeCustomizeDrawerTucked: false
};

});

parcelRegister("1JtPJ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("34XgT"))) : import("34XgT")).then(()=>parcelRequire('7lKau'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("li6hd", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("2vOgs"))) : import("2vOgs")).then(()=>parcelRequire('cxqU5'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("8Eobr", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("aoobU"))) : import("aoobU")).then(()=>parcelRequire('01z5z'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("jIVd0", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("bUNOg"))) : import("bUNOg")).then(()=>parcelRequire('asy94'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("13oJx", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("lQoHc"))) : import("lQoHc")).then(()=>parcelRequire('3SIBT'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("e8HBd", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("juGt4"))) : import("juGt4")).then(()=>parcelRequire('gpyGU'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7lWOZ", function(module, exports) {

$parcel$export(module.exports, "agents", () => $55a81f4c18500c18$export$ac5be7df5fa52a3c);
// /agents — the /team-and-agents canvas, AGENTS ONLY.
//
// This page IS /team-and-agents (it `extends: 'teamAndAgents'`), so it inherits
// the whole surface verbatim — panzoom, drag-to-rearrange, the agent detail
// modal, layout-prefs persistence, presence pulses. The ONLY differences are:
//   1. `root._canvasAgentsOnly` is flipped ON while mounted — team-and-agents.js
//      then hides every human node (`_visiblePeople` → []), the team swim-lane
//      frames (they derive from the people), and all connections (they'd dangle
//      to a hidden person), and the "+" island drops its "Human" row.
//   2. A filter toolbar (mounted in the Stage, gated on `_canvasAgentsOnly`)
//      drives `root._agents{Scope,Status,Type,Assign}`, which `_visibleAgents`
//      reads. Scope = All agents (default) / My agents; plus Status (active /
//      idle), Type (by agent kind), Assignment (assigned / unassigned).
//
// Layout is intentionally SHARED with /team-and-agents (same `_tagPositions`
// prefs): a given agent sits in the same spot on both canvases.
const $55a81f4c18500c18$export$ac5be7df5fa52a3c = {
    extends: 'teamAndAgents',
    metadata: (el)=>({
            title: el.call('pageTitle', 'canvas.page.agents.title')
        }),
    // This route's own name on the inherited, visually hidden `h1`.
    PageSrTitle: {
        text: '{{ canvas.page.agents.title | polyglot }}'
    },
    // The lens (1 above), as data: the inherited onCreate flips agents-only mode
    // ON and seeds the default filters before the boot; the inherited onRemove
    // clears it, so /team-and-agents + the home embed (which share this same
    // root) render the full set again. No hook here: a hook that called the
    // board's own hook through the page OBJECT made frank copy the whole page
    // into globalScope (canvas case 3, 2026-11-01).
    scope: {
        canvasLens: 'agents'
    }
};

});

parcelRegister("3lR5Z", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("kP2Jn"))) : import("kP2Jn")).then(()=>parcelRequire('fpuOM'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("kLMVv", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("fAB9B"))) : import("fAB9B")).then(()=>parcelRequire('eqCWf'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("iuCDG", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("2amgd"))) : import("2amgd")).then(()=>parcelRequire('9BkZG'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("aKYox", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("8SoaX"))) : import("8SoaX")).then(()=>parcelRequire('22xhm'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7SVpv", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("bIgiv"))) : import("bIgiv")).then(()=>parcelRequire('1xaTX'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("iyNfb", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("EBMN6"))) : import("EBMN6")).then(()=>parcelRequire('blWAR'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("bfN28", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("dJCvT"))) : import("dJCvT")).then(()=>parcelRequire('ibgOf'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("6yR3k", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("j3BOt"))) : import("j3BOt")).then(()=>parcelRequire('jxHYx'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1ijdV", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("AfxR1"))) : import("AfxR1")).then(()=>parcelRequire('curKC'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("b9Lxc", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("ktIhx"))) : import("ktIhx")).then(()=>parcelRequire('l0GNM'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("cT6tU", function(module, exports) {

$parcel$export(module.exports, "workspaceHub", () => $961fa62e6e0f3af0$export$508395001ddba590);
// Bare `/w` landing — the workspace hub. `/w/<slug>` pins a tab to an org,
// but the bare prefix used to fall through the catch-all and render the
// shell 404 (2026-07-29 per Nika "prettify /w/ initial layout" — the demo
// entry link lands exactly here). Behavior:
//
//   - orgs still loading → quiet centered loader (no 404 flash)
//   - exactly ONE org    → immediate redirect to its `/w/<slug>` home
//   - several orgs       → a picker: one glass card per workspace, click
//                          routes into it (the AppOrgSwitcher stays the
//                          in-app switcher; this is only the URL landing)
//
// Uses `replaceState`-style routing (pushState: false) for the auto-forward
// so Back never bounces through the bare prefix.
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).

var $1X0Je = parcelRequire("1X0Je");
const $961fa62e6e0f3af0$var$shellWithWorkspacePrefix = (...args)=>(0, $1X0Je.default).functions.withWorkspacePrefix(...args);
const $961fa62e6e0f3af0$var$_hubOrgSlug = (o)=>o?.slug || o?.username || null;
// The orgs the hub OFFERS — the one org-visibility rule (shared
// functions/visibleOrgs.js, the same one the org switcher reads): a team
// member's own EMPTY personal org (/auth/me `hasContent: false`) stays in the
// background (POB persona round 5: a team sign-up saw "Choose a workspace"
// with an extra "My workspace"), but the org the person is IN is never
// hidden. A STALLED hub lists every org it knows: the rescue picker is
// the way out, and a hidden org must not be the one that was needed.
const $961fa62e6e0f3af0$var$_hubOrgs = (el, s)=>{
    const root = s?.root;
    const all = root?.orgs || [];
    if ($961fa62e6e0f3af0$var$_hubStalled(el, s)) return all;
    return el.call('visibleOrgs', all, {
        keep: [
            root?.org?.id,
            root?.org?.slug
        ]
    });
};
// WS-CUSTOM-DOMAIN-HUB-SILENT-BOOT-FAIL-1 — "Opening your workspace…" was an
// UNCONDITIONAL, untimed promise. Every way the forward can fail to happen
// (no org resolvable, orgs never load, or a target that resolves right back to
// this page) left that sentence on screen forever, and `Cards` hid the picker
// below two orgs so a single-org user had no way out either.
//
// The boot resolver's own ladder is 25x200ms = 5s (functions/customDomainBoot.js),
// so a stall declared after 8s is strictly later than every source that could
// still legitimately arrive.
const $961fa62e6e0f3af0$var$_STALL_MS = 8000;
// Injectable exactly like customDomainBoot.js's `delayMs`/`maxAttempts` ladder,
// so the stall can be asserted offline without an 8-second test.
const $961fa62e6e0f3af0$var$_stallMs = (el)=>typeof el.__wHubStallMs === 'number' ? el.__wHubStallMs : $961fa62e6e0f3af0$var$_STALL_MS;
const $961fa62e6e0f3af0$var$_hubStalled = (el, s)=>!!(el.state?._stalled || s?._stalled);
// `withWorkspacePrefix(slug, '/')` emits `/w/<slug>` while the boot resolver
// and the address bar carry `/w/<slug>/` — the same place, spelled two ways.
// A trailing slash must never decide whether a forward is a self-forward.
const $961fa62e6e0f3af0$var$_samePath = (a, b)=>{
    const trim = (p)=>String(p || '').replace(/\/+$/, '') || '/';
    return trim(a) === trim(b);
};
const $961fa62e6e0f3af0$var$_forwardIfSingle = (el, s)=>{
    const root = s.root;
    const orgs = $961fa62e6e0f3af0$var$_hubOrgs(el, s);
    if (el.__wHubForwarded) return;
    // One org → its home. Zero orgs but an active org resolved → same.
    const target = orgs.length === 1 ? orgs[0] : orgs.length === 0 ? root?.org : null;
    const slug = $961fa62e6e0f3af0$var$_hubOrgSlug(target);
    if (!slug) return;
    const path = $961fa62e6e0f3af0$var$shellWithWorkspacePrefix(slug, '/');
    // SELF-FORWARD GUARD. If this page is ALREADY mounted at the path it wants
    // to send the user to, routing there re-mounts this same page — a loop with
    // no exit that reads to the user as an eternal "one moment". Measured live
    // on app.bellforge.eu (2026-08-23, localStorage.mwt='off'): the hub rendered
    // at `/w/bellforge/` and forwarded to `/w/bellforge/`. The routing cause is
    // fixed in functions/mwtRouter.js; this stays as the invariant that no page
    // may forward to itself, whatever the router does upstream.
    if ($961fa62e6e0f3af0$var$_samePath(root?.currentPath, path)) {
        el.__wHubForwarded = true;
        $961fa62e6e0f3af0$var$_markStalled(el);
        return;
    }
    el.__wHubForwarded = true;
    $961fa62e6e0f3af0$var$_clearStallTimer(el);
    el.router(path, el.getRoot(), {}, {
        pushState: false
    });
};
const $961fa62e6e0f3af0$var$_markStalled = (el)=>{
    $961fa62e6e0f3af0$var$_clearStallTimer(el);
    if (el.state?._stalled) return;
    el.state?.update({
        _stalled: true
    });
};
const $961fa62e6e0f3af0$var$_clearStallTimer = (el)=>{
    if (!el.__wHubStallTimer) return;
    clearTimeout(el.__wHubStallTimer);
    el.__wHubStallTimer = null;
};
const $961fa62e6e0f3af0$var$_armStallTimer = (el)=>{
    if (el.__wHubForwarded || el.__wHubStallTimer || el.state?._stalled) return;
    el.__wHubStallTimer = setTimeout(()=>{
        el.__wHubStallTimer = null;
        if (el.__wHubForwarded) return;
        $961fa62e6e0f3af0$var$_markStalled(el);
    }, $961fa62e6e0f3af0$var$_stallMs(el));
};
// Retry = drop the one-shot guards and ask again, so a forward that failed on
// data that has since landed just works. When nothing has changed the stall
// timer re-arms and the failure state comes straight back — never a spinner
// that hides a second failure.
const $961fa62e6e0f3af0$var$_retryForward = (el, s)=>{
    el.__wHubForwarded = false;
    $961fa62e6e0f3af0$var$_clearStallTimer(el);
    el.state?.update({
        _stalled: false
    });
    $961fa62e6e0f3af0$var$_forwardIfSingle(el, s);
    $961fa62e6e0f3af0$var$_armStallTimer(el);
};
const $961fa62e6e0f3af0$export$508395001ddba590 = {
    extends: 'AppPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.hub.page.title')
        }),
    flow: 'y',
    align: 'center center',
    minHeight: '100dvh',
    padding: 'C A',
    // Marker the Retry button's `lookup` predicate finds — see its onClick.
    __wHubPage: true,
    state: {
        _stalled: false
    },
    // Redirect must fire whenever orgs land — onRender covers the mount,
    // subscribeTo + onUpdate cover the async orgs arrival.
    subscribeTo: [
        'orgs',
        'org',
        'signedIn'
    ],
    onRender: (el, s)=>{
        $961fa62e6e0f3af0$var$_forwardIfSingle(el, s);
        $961fa62e6e0f3af0$var$_armStallTimer(el);
    },
    onUpdate: (el, s)=>{
        $961fa62e6e0f3af0$var$_forwardIfSingle(el, s);
        $961fa62e6e0f3af0$var$_armStallTimer(el);
    },
    onRemove: (el)=>$961fa62e6e0f3af0$var$_clearStallTimer(el),
    Hub: {
        flow: 'y',
        gap: 'B',
        width: '100%',
        maxWidth: 'I',
        align: 'center center',
        Intro: {
            flow: 'y',
            gap: 'Z',
            align: 'center center',
            textAlign: 'center',
            H: {
                tag: 'h1',
                margin: '0',
                fontSize: 'C',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const orgs = $961fa62e6e0f3af0$var$_hubOrgs(el, s);
                    if ($961fa62e6e0f3af0$var$_hubStalled(el, s)) return el.call('polyglot', 'workspace.hub.stalledTitle');
                    // A BRANDED TENANT HOST NEVER OFFERS A CHOICE — see `Cards.hide`.
                    if (s.root?.whitelabelBrand) return el.call('polyglot', 'workspace.hub.opening');
                    return el.call('polyglot', orgs.length > 1 ? 'workspace.hub.choose' : 'workspace.hub.opening');
                }
            },
            P: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>{
                    const orgs = $961fa62e6e0f3af0$var$_hubOrgs(el, s);
                    if ($961fa62e6e0f3af0$var$_hubStalled(el, s)) return el.call('polyglot', orgs.length ? 'workspace.hub.stalledWithOrgs' : 'workspace.hub.stalledNoOrgs');
                    if (s.root?.whitelabelBrand) return el.call('polyglot', 'workspace.hub.oneMoment');
                    if (orgs.length > 1) return el.call('polyglot', 'workspace.hub.pickToday');
                    return el.call('polyglot', 'workspace.hub.oneMoment');
                }
            },
            // The one way out of the failure state. Hidden while the forward is
            // still plausibly in flight, so the happy path is unchanged.
            // FA806 — bare PascalCase key auto-extends the built-in; no `extends`.
            Button: {
                hide: (el, s)=>!$961fa62e6e0f3af0$var$_hubStalled(el, s),
                marginTop: 'Z',
                text: '{{ workspace.hub.tryAgain | polyglot }}',
                onClick: (e, el, s)=>{
                    // `lookup` (ONE-argument ancestor predicate) is the DOMQL way up —
                    // never a `.parent.parent` chain, which silently breaks the moment
                    // this button moves a level (functions/posterCardHue.js precedent).
                    const page = el.lookup((c)=>!!c.__wHubPage);
                    if (page) $961fa62e6e0f3af0$var$_retryForward(page, s);
                }
            }
        },
        Cards: {
            // A stalled hub shows EVERY workspace it knows, whatever the count —
            // the picker is the rescue affordance, and hiding it at <=1 was what
            // left a single-org user with nothing to click.
            //
            // WHITELABEL-HUB-PICKER-LEAKS-OTHER-ORGS-1 — but NOT on a branded tenant
            // host while the forward is still in flight. There the HOST names the
            // tenant (app.bellforge.eu -> the Bellforge org), so a picker is both the
            // wrong affordance and a LEAK: it lists every OTHER org the signed-in
            // user belongs to on someone else's branded domain. Measured 2026-08-23:
            // after signing in on app.bellforge.eu the user got "Choose a workspace"
            // instead of landing in Bellforge.
            //
            // A STALLED branded host still shows it — once the forward has provably
            // failed, a way out beats a clean surface, and that is the rescue this
            // block exists for.
            //
            // `whitelabelBrand` is the reactive marker the pre-auth brand chain
            // already writes onto root (whitelabelBrand.js), so this needs no new
            // state, no sibling import and no window.location read. Navigation stays
            // owned by bootCustomDomainScope — one writer per concern.
            hide: (el, s)=>$961fa62e6e0f3af0$var$_hubStalled(el, s) ? !$961fa62e6e0f3af0$var$_hubOrgs(el, s).length : !!s.root?.whitelabelBrand || $961fa62e6e0f3af0$var$_hubOrgs(el, s).length <= 1,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(var(--spacing-G1), 1fr))',
            gap: 'A',
            width: '100%',
            childExtends: 'WorkspaceHubCard',
            childrenAs: 'state',
            children: (el, s)=>$961fa62e6e0f3af0$var$_hubOrgs(el, s).filter((o)=>$961fa62e6e0f3af0$var$_hubOrgSlug(o))
        }
    }
};

});

parcelRegister("l0m6y", function(module, exports) {

$parcel$export(module.exports, "people", () => $f4aabe967414c39b$export$5c754c0557bd8d37);
// Users (Team members) — adopts the SAME app-surface chrome as /calendar
// (per Nika 2026-06-22 "make users and claims same layout (sidebar and layout)
// as on calendar page"): AppPage row → an AppSidebar-extending rail (free
// ViewSwitcher card + the team / members filter cards) + an AppMain-extending
// column with a PageHeader (title) and the people grid in its Body.
//
// The filter content (PpTeamsRail / PpMembersSummary) and the body grid
// (PpGroups / PpEmpty) are the same DB-sourced lists as before — only the
// chrome changed so this surface matches Calendar's sidebar + card layout.
// Header button style — matches pages/data-external.js's _headerBtn (the
// house neutral header-action convention: no border, `overlay` fill,
// `hover` wash, never a one-off accent).
const $f4aabe967414c39b$var$_headerBtn = {
    tag: 'button',
    type: 'button',
    minHeight: 'controlH',
    padding: '0 A',
    round: 'radiusPill',
    border: 'none',
    background: 'overlay',
    color: 'title',
    fontSize: 'Z2',
    fontWeight: '700',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    }
};
const $f4aabe967414c39b$export$5c754c0557bd8d37 = {
    extends: 'AppPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.people.page.title')
        }),
    // Org chart — bulk manager editor + minimal chart view (tickets/sonnet.md
    // "org chart: UI"). Toggled via root._orgChartOpen; see
    // components/OrgChartModal.js + functions/orgChart.js.
    OrgChartModal: {},
    AppSidebar: {
        tag: 'nav',
        'aria-label': (el)=>el.call('polyglot', 'workspace.people.navAria'),
        // On the page-sidebar rule (shared functions/pageSidebar.js): opposite a
        // rail navbar, hideable per page. The first card opens with its caption, so
        // the hide button's corner is free.
        pageSidebar: true,
        // Drop the inherited VIEWS switcher (Frontend/Infra/Tasks/Agents) — /team-members
        // is not a canvas view. (2026-06-22 per Nika "remove Views from /team-members".)
        ViewSwitcher: null,
        // Teams rail — DB-sourced (peopleTeamsDirectory: Mongo Team/TeamMember via
        // the SDK), one filter link per team with its membership count, split by
        // team category: Active = manager/active, Inactive = passive/external/
        // archived. Its own AppSidebar card (CommonCard via childExtends).
        PpTeamsRail: {
            flow: 'y',
            gap: 'Z',
            PpTrHead: {
                extends: 'CaptionTitle',
                fontSize: 'Y2',
                Text: {
                    text: '{{ workspace.people.rail.teams | polyglot }}'
                }
            },
            PpTrAll: {
                extends: 'PeopleFilterLink',
                state: {
                    name: null,
                    kind: 'group',
                    label: 'workspace.people.filter.everyone'
                }
            },
            PpTrList: {
                flow: 'y',
                gap: 'Y',
                childExtends: 'PeopleFilterLink',
                childrenAs: 'state',
                children: (el)=>el.call('peopleTeamsDirectory').filter((t)=>el.call('isActiveTeamCategory', t.category)).map((t)=>({
                            name: t.name,
                            label: t.name,
                            count: t.count,
                            kind: 'group'
                        }))
            },
            PpTrInactiveHead: {
                hide: (el)=>!el.call('peopleTeamsDirectory').some((t)=>!el.call('isActiveTeamCategory', t.category)),
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                paddingTop: 'A',
                text: '{{ workspace.people.rail.inactive | polyglot }}'
            },
            PpTrInactiveList: {
                flow: 'y',
                gap: 'Y',
                opacity: '0.75',
                childExtends: 'PeopleFilterLink',
                childrenAs: 'state',
                children: (el)=>el.call('peopleTeamsDirectory').filter((t)=>!el.call('isActiveTeamCategory', t.category)).map((t)=>({
                            name: t.name,
                            label: t.name,
                            count: t.count,
                            kind: 'group'
                        }))
            }
        },
        // Management lens (Everyone / Active / Inactive member counts). Status
        // derives from team membership. Its own AppSidebar card.
        PpMembersSummary: {
            flow: 'y',
            gap: 'Z',
            PpMsHead: {
                extends: 'CaptionTitle',
                fontSize: 'Y2',
                Text: {
                    text: '{{ workspace.people.rail.members | polyglot }}'
                }
            },
            PpMsList: {
                flow: 'y',
                gap: 'Y',
                childExtends: 'PeopleFilterLink',
                childrenAs: 'state',
                children: (el)=>el.call('peopleMemberStatusSummary')
            }
        }
    },
    AppMain: {
        Header: {
            extends: 'PageHeader',
            // One title per host (design-direction.md §3): under a pane title bar
            // the eyebrow + title pair repeats the bar word for word, so both yield.
            // The org-chart action stays. At the dedicated URL nothing changes.
            LeftGroup: {
                PpEyebrow: {
                    hide: (el, s)=>el.call('paneTitleBarShown', s),
                    tag: 'span',
                    fontSize: 'Z2',
                    fontWeight: '700',
                    letterSpacing: '0.12em',
                    textTransform: 'uppercase',
                    // §4.4 accent ink — brand blue measured 3.21:1 as small-text ink on
                    // the light stage (AA walk 2026-08-08); accentInk holds ≥4.9:1.
                    color: 'accentInk',
                    text: '{{ workspace.people.eyebrow | polyglot }}'
                },
                PpTitle: {
                    hide: (el, s)=>el.call('paneTitleBarShown', s),
                    tag: 'h1',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title',
                    letterSpacing: '-0.02em',
                    margin: '0',
                    text: '{{ workspace.people.title | polyglot }}'
                }
            },
            RightGroup: {
                flow: 'x',
                align: 'center right',
                gap: 'Z',
                OrgChartBtn: {
                    ...$f4aabe967414c39b$var$_headerBtn,
                    text: '{{ workspace.people.orgChart | polyglot }}',
                    onClick: (e, el, s)=>el.call('orgChartOpen', s)
                }
            }
        },
        Body: {
            padding: 'C',
            overflow: 'auto',
            flow: 'y',
            gap: 'C',
            // Outstanding WorkspaceInvitation rows (Simone AI-assistant invites +
            // manual admin invites) — self-hides for non-admins and when there's
            // nothing pending. See components/PersonCard.js PendingInvitesBlock.
            PpPendingInvites: {
                extends: 'PendingInvitesBlock'
            },
            // ── THE ROSTER'S FOUR STATES ─────────────────────────────────────
            // This page used to implement ONE of them: the grid, plus a message
            // gated on "a filter is active". So a cold load painted a blank body,
            // a failed fetch was pixel-identical to an empty roster, and a
            // genuinely empty workspace rendered nothing at all.
            //
            // Every block below asks ONE resolver — `peopleRosterView`
            // (functions/peopleGroups.js) — and compares with its own name, so the
            // five blocks are mutually exclusive by construction. Its loading and
            // error answers come straight from `peopleStatus`
            // (functions/homeLoadState.js), the same one Home's widgets ask, so
            // the two surfaces can never disagree about which state the roster is
            // in. `Array.isArray(root.people)` is NOT that resolver and never can
            // be: state-app.js seeds `people: []`, so it is true from the first
            // frame; the positive marker `peopleLoaded` and its failure key
            // `peopleError` are what every producer writes, and that exact false
            // zero already shipped once (FALSE-ZERO-HOME-NON-AGENT-KEYS-1).
            //
            // `hide:` on every one, never `if:` — each must react AFTER mount,
            // when the fetch lands. `if:` is for "zero elements is the goal".
            // Contract pinned in __tests__/peopleRosterStates.test.js.
            // Permission, not emptiness: a viewer whose org member set comes back
            // empty (the non-mgmt roster projection — functions/peopleGroups.js)
            // sees a roster of exactly themselves. Gated on the REASON the scoping
            // resolver reports, never on "the list happens to be length 1".
            PpReducedNotice: {
                hide: (el, s)=>el.call('peopleStatus', s.root) !== 'loaded' || !el.call('peopleRosterIsReduced'),
                tag: 'p',
                role: 'status',
                margin: '0',
                padding: 'Z A',
                round: 'radiusCard',
                background: 'overlay',
                fontSize: 'Z2',
                color: 'caption',
                text: '{{ workspace.people.state.reduced | polyglot }}'
            },
            PpLoading: {
                // The roster's own track, so the skeleton breaks to the same columns
                // as the list it stands in for.
                extends: 'PeopleGrid',
                hide: (el)=>el.call('peopleRosterView') !== 'loading',
                role: 'status',
                'aria-busy': 'true',
                'aria-label': (el)=>el.call('polyglot', 'workspace.people.state.loading'),
                SkeletonCard: {},
                SkeletonCard_1: {},
                SkeletonCard_2: {},
                SkeletonCard_3: {},
                SkeletonCard_4: {},
                SkeletonCard_5: {}
            },
            // The shared `ErrorState` owns the markup: the icon, the `role="alert"`
            // + `aria-live="assertive"` region, the title and the hint. This block
            // used to rebuild all of it by hand and lost the icon and the live
            // region on the way.
            PpError: {
                extends: 'ErrorState',
                hide: (el)=>el.call('peopleRosterView') !== 'error',
                kind: 'serverError',
                heading: 'workspace.people.state.errorTitle',
                hintText: 'workspace.people.state.errorBody',
                PpErrRetry: {
                    // The ONE recovery action of an error poster is the brand Button in
                    // solid ink — the same as pages/announcements.js's retry and
                    // EmptyState's action, on the Button's own control scale (Rule 68).
                    // It used to spread the header button, whose `overlay` fill is
                    // invisible on this surface (measured live: gray2 at 5% over gray2),
                    // so the retry read as a bare line of text under the message.
                    extends: 'Button',
                    theme: 'primary',
                    text: '{{ common.action.try_again | polyglot }}',
                    // Clearing the failure returns the page to its LOADING state (the
                    // producer leaves `peopleLoaded` false on a failed read), so the
                    // skeleton is what a person sees while the retry runs.
                    // `retryWorkspaceActivation` is the house re-loader — it resolves
                    // the SDK itself and re-runs the same boot load that writes both
                    // roster keys.
                    onClick: (e, el, s)=>{
                        s.root.update({
                            peopleError: null
                        });
                        el.call('retryWorkspaceActivation');
                    }
                }
            },
            PpGroups: {
                // A half-loaded roster must never render as a confident list, and a
                // list of zero groups is one of the two empty states below, not an
                // empty grid.
                hide: (el)=>el.call('peopleRosterView') !== 'list',
                flow: 'y',
                gap: 'D',
                childExtends: 'PeopleGroupBlock',
                childrenAs: 'state',
                children: (el)=>el.call('groupFilteredPeople')
            },
            // A loaded workspace with nobody in it. The page owned no copy for
            // this at all: `PpEmpty` returned `true` on "no filter", so the body
            // was empty under the header.
            PpEmptyFresh: {
                extends: 'EmptyState',
                hide: (el)=>el.call('peopleRosterView') !== 'emptyFresh',
                icon: 'people',
                heading: 'workspace.people.state.emptyTitle',
                hintText: 'workspace.people.state.emptyBody'
            },
            PpEmpty: {
                // The FILTERED empty ONLY. Gated on `peopleLoaded` as well, or it
                // flashes "No members match this filter." over a roster nobody has
                // read yet whenever a filter survives into a cold load.
                hide: (el)=>el.call('peopleRosterView') !== 'emptyFiltered',
                flow: 'y',
                align: 'center center',
                gap: 'A',
                padding: 'D',
                PpEmptyText: {
                    tag: 'p',
                    fontSize: 'A',
                    color: 'caption',
                    textAlign: 'center',
                    text: (el, s)=>{
                        const q = (s.root.peopleQuery || '').trim();
                        if (q) return el.call('polyglot', 'workspace.people.emptyQuery').replace('{query}', q);
                        if (s.root.selectedGroup) return el.call('polyglot', 'workspace.people.emptyGroup').replace('{group}', s.root.selectedGroup);
                        return el.call('polyglot', 'workspace.people.emptyFilter');
                    }
                }
            }
        }
    }
};

});

parcelRegister("fdfsh", function(module, exports) {

$parcel$export(module.exports, "my", () => $b1340ef911318228$export$94fa0a6beb22f989);
const $b1340ef911318228$export$94fa0a6beb22f989 = {
    extends: 'ContentPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.my.page.title')
        }),
    // `eyebrow` is a CUSTOM prop, so a function value is auto-invoked (Rule 70)
    // and ContentPage's `el.parent.parent.parent.parent.eyebrow` reads the
    // resolved string.
    //
    // There is NO `title:` prop any more — same reasoning as
    // packages/shared/pages/profile.js: `title` is a global HTML attribute that
    // ContentPage read as CONTENT (docs/I18N-CONVENTION.md §1.2, the one case
    // with no working rewrite form). The page overrides ContentPage's Title
    // SLOT below instead, and drops the stray native tooltip with the prop.
    eyebrow: (el)=>el.call('polyglot', 'account.profile.eyebrow'),
    // `sectionKey` is the SCROLL KEY: ContentPageSectionLink matches it against
    // `[data-content-section="<key>"]` in MemberProfile.js and writes it to
    // `root.contentSection`. It stays the English string those attributes
    // already carry and must NEVER be translated — a translated key breaks the
    // scroll on the first switch. `label` is the VISIBLE string and goes
    // through polyglot in the FUNCTION form; this factory runs inside
    // ContentPage's reactive `children` factory, so the rail re-renders on a
    // language switch. Same contract as packages/shared/pages/profile.js, and
    // the keys are shared with it.
    //
    // The rail lists exactly the cards the page shows, in the page's reading
    // order. It listed Availability while the owner's card was hidden and
    // missed Accessibility and Assistant, which the page showed (live
    // 2026-10-28). Since member-profile stage 3 the list is ONE shared function
    // (memberProfileAccess.js memberProfileSections) that this page and the
    // shared /profile and /settings page ask: /my is the profile view, so its
    // rail lists the profile's cards.
    sections: (el, s)=>el.call('memberProfileSections', s),
    // Content mounts in ContentPage's main column (PageMain.Body) — the
    // notes-page skeleton; see components/ContentPage.js.
    PageMain: {
        // The heading. FUNCTION form, matching profile.js — the account path is
        // held to one form by components/LanguageSelectField.test.js.
        Header: {
            LeftGroup: {
                // One title per host (design-direction.md §3): "My profile" is the
                // pane bar word for word, so it yields under one. The eyebrow stays.
                Title: {
                    hide: (el, s)=>el.call('paneTitleBarShown', s),
                    text: (el)=>el.call('polyglot', 'account.my.title')
                }
            }
        },
        Body: {
            PageBody: {
                flow: 'y',
                flex: '1',
                minWidth: '0',
                MemberProfile: {}
            }
        }
    }
};

});

parcelRegister("65kO4", function(module, exports) {

$parcel$export(module.exports, "announcements", () => $46e3597bf6bfc8c0$export$d7f3895e994ed5c7);
const $46e3597bf6bfc8c0$var$_scope = (value, label)=>({
        extends: 'BroadcastAudienceSegment',
        value: value,
        label: label
    });
const $46e3597bf6bfc8c0$export$d7f3895e994ed5c7 = {
    extends: 'AppPage',
    // SIZE-1 (tickets/sonnet.md, 2026-08-14): the route is `/announcements`
    // but every user-facing string here said "Broadcast" — the page's own H1,
    // the tab title, and the sidebar's aria-label all disagreed with the URL.
    // Fixed to "Announcements" throughout the user-facing copy below.
    // Internal identifiers (BroadcastNavigation, BroadcastTagFilter,
    // canPublishBroadcast, openBroadcastComposer, …) are untouched — those are
    // the feature's internal name, not copy, and renaming them is a much
    // larger, unrelated change this ticket didn't ask for.
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.announcements.page.title')
        }),
    state: {
        announcementsLoaded: false,
        announcementsError: null
    },
    // `loadPrivateData` normally warms this collection after sign-in. The
    // declarative page fetch makes a direct /announcements visit dependable too
    // and keeps the screen correct after a workspace switch.
    fetch: (el)=>[
            ...el.context.functions.appPageBoilerplateFetch,
            {
                // The fetch SDK adapter maps declarative `select` to the SDK entity's
                // `list` operation. `method: 'list'` itself is not an adapter method.
                method: 'select',
                from: 'workspaceProject.announcements',
                order: 'date',
                as: '~/announcements',
                cache: '15s',
                onFetchStart: (el, s)=>{
                    s.update({
                        announcementsLoaded: false,
                        announcementsError: null
                    }, {
                        preventFetch: true
                    });
                },
                transform: (rows, el, s)=>{
                    // Transform also runs for a cache hit, which skips onFetchComplete.
                    s.update({
                        announcementsLoaded: true,
                        announcementsError: null
                    }, {
                        preventFetch: true
                    });
                    const announcements = [];
                    for (const row of rows || [])announcements.push(el.call('broadcastFromWire', row));
                    return {
                        announcements: announcements
                    };
                },
                onFetchError: (error, el, s)=>{
                    s.update({
                        announcementsLoaded: false,
                        announcementsError: 'workspace.announcements.loadFailed'
                    }, {
                        preventFetch: true
                    });
                }
            }
        ],
    AppSidebar: {
        tag: 'nav',
        'aria-label': (el)=>el.call('polyglot', 'workspace.announcements.navAria'),
        // On the page-sidebar rule (shared functions/pageSidebar.js): opposite a
        // rail navbar, hideable per page. The first card opens with its caption, so
        // the hide button's corner is free.
        pageSidebar: true,
        '@tabletS': {
            width: 'F1',
            minWidth: 'F1'
        },
        BroadcastNavigation: {
            flow: 'y',
            gap: 'A',
            Audience: {
                flow: 'y',
                gap: 'Z',
                CaptionTitle: {
                    fontSize: 'Y2',
                    Text: {
                        text: '{{ workspace.announcements.audience | polyglot }}'
                    }
                },
                Segments: {
                    flow: 'x',
                    gap: 'Y',
                    'aria-label': (el)=>el.call('polyglot', 'workspace.announcements.audienceAria'),
                    Internal: $46e3597bf6bfc8c0$var$_scope('internal', 'workspace.announcements.scope.team'),
                    External: $46e3597bf6bfc8c0$var$_scope('external', 'workspace.announcements.scope.public'),
                    All: $46e3597bf6bfc8c0$var$_scope('all', 'workspace.announcements.scope.all')
                }
            },
            Topics: {
                flow: 'y',
                gap: 'Z',
                CaptionTitle: {
                    fontSize: 'Y2',
                    Text: {
                        text: '{{ workspace.announcements.topics | polyglot }}'
                    }
                },
                List: {
                    flow: 'y',
                    gap: 'V',
                    childExtends: 'BroadcastTagFilter',
                    childrenAs: 'state',
                    children: (el, s)=>el.call('broadcastTags', s.root)
                }
            }
        }
    },
    AppMain: {
        Body: {
            flow: 'y',
            gap: 'C',
            padding: 'C',
            overflow: 'auto',
            minWidth: '0',
            // The page head on the ground (the page-head pattern the built-in
            // /bookmarks head first set; __tests__/pageHeadsFlatLaw.test.js pins
            // it): label, title and lead, the main action on the right. It was a full colour slab
            // (`purple+30` ground, `black` ink, `D` padding, the sheet radius),
            // against the flat/minimal law (design-d2, 2026-10-01).
            Hero: {
                flow: 'x',
                align: 'flex-end space-between',
                gap: 'B',
                flexWrap: 'wrap',
                '@mobileL': {
                    flow: 'y',
                    align: 'stretch flex-start'
                },
                Copy: {
                    flow: 'y',
                    gap: 'X',
                    minWidth: '0',
                    maxWidth: 'H',
                    Eyebrow: {
                        tag: 'span',
                        color: 'inactive',
                        fontSize: 'Y2',
                        fontWeight: '700',
                        text: '{{ workspace.announcements.eyebrow | polyglot }}'
                    },
                    Title: {
                        // One title per host (design-direction.md §3): under a pane title
                        // bar the poster keeps its eyebrow, copy and action, and drops
                        // the line that repeats the bar.
                        hide: (el, s)=>el.call('paneTitleBarShown', s),
                        tag: 'h1',
                        margin: '0',
                        color: 'title',
                        fontSize: 'D',
                        fontWeight: '700',
                        lineHeight: '1.05',
                        text: '{{ workspace.announcements.title | polyglot }}'
                    },
                    Description: {
                        tag: 'p',
                        margin: '0',
                        color: 'caption',
                        fontSize: 'Z2',
                        text: '{{ workspace.announcements.description | polyglot }}'
                    }
                },
                Publish: {
                    tag: 'button',
                    type: 'button',
                    hide: (el, s)=>!el.call('canPublishBroadcast', s.root),
                    minHeight: 'controlH',
                    padding: '0 A',
                    round: 'radiusPill',
                    borderWidth: '0',
                    cursor: 'pointer',
                    theme: 'primary',
                    fontWeight: '700',
                    text: '{{ workspace.announcements.writeRelease | polyglot }}',
                    onClick: (event, el)=>{
                        event.preventDefault();
                        el.call('openBroadcastComposer');
                    }
                }
            },
            Toolbar: {
                flow: 'x',
                align: 'center space-between',
                gap: 'A',
                flexWrap: 'wrap',
                Search: {
                    tag: 'input',
                    type: 'search',
                    name: 'news-search',
                    ariaLabel: (el)=>el.call('polyglot', 'workspace.announcements.searchAria'),
                    autocomplete: 'off',
                    minHeight: 'controlHCompact',
                    minWidth: '0',
                    width: 'G',
                    maxWidth: '100%',
                    padding: '0 A',
                    round: 'radiusPill',
                    border: 'none',
                    background: 'overlay',
                    color: 'title',
                    fontSize: 'Z1',
                    placeholder: (el)=>el.call('polyglot', 'workspace.announcements.search'),
                    value: (el, s)=>s.root?._broadcastQuery || '',
                    onInput: (event, el)=>el.call('setBroadcastQuery', event.target.value)
                },
                Summary: {
                    hide: (el, s)=>!s.announcementsLoaded || !!s.announcementsError,
                    tag: 'span',
                    fontFamily: 'Code',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>el.call('polyglot', 'workspace.announcements.updateCount').replace('{count}', el.call('broadcastItemsForView', s.root).length)
                }
            },
            Error: {
                hide: (el, s)=>!s.root?._broadcastSaveError,
                tag: 'p',
                margin: '0',
                padding: 'Z A',
                round: 'radiusControl',
                background: 'red.15',
                color: 'dangerInk',
                fontSize: 'Z1',
                role: 'status',
                ariaLive: 'polite',
                text: (el, s)=>s.root?._broadcastSaveError || ''
            },
            Loading: {
                hide: (el, s)=>!!s.announcementsLoaded || !!s.announcementsError,
                role: 'status',
                ariaLabel: (el)=>el.call('polyglot', 'common.state.loading'),
                flow: 'y',
                gap: 'A',
                Skeleton_1: {
                    height: 'D',
                    'aria-hidden': true
                },
                Skeleton_2: {
                    height: 'D',
                    'aria-hidden': true
                },
                Skeleton_3: {
                    height: 'D',
                    'aria-hidden': true
                }
            },
            ErrorState: {
                hide: (el, s)=>!s.announcementsError,
                kind: 'serverError',
                heading: 'workspace.announcements.loadFailed',
                hintText: 'workspace.announcements.tryAgain',
                IconWrap: {
                    Icon: {
                        icon: 'infoOval'
                    }
                },
                Button: {
                    theme: 'primary',
                    text: '{{ common.action.try_again | polyglot }}',
                    onClick: (event, el)=>{
                        event.preventDefault();
                        const page = el.lookup((ancestor)=>!!ancestor.__ref?.refetch);
                        if (!page) return;
                        page.state.update({
                            announcementsLoaded: false,
                            announcementsError: null
                        }, {
                            preventFetch: true
                        });
                        page.__ref.refetch();
                    }
                }
            },
            Feed: {
                hide: (el, s)=>!s.announcementsLoaded || !!s.announcementsError,
                flow: 'y',
                gap: 'A',
                maxWidth: 'I',
                childExtends: 'BroadcastStoryCard',
                childrenAs: 'state',
                children: (el, s)=>el.call('broadcastVisibleItems', s.root)
            },
            More: {
                hide: (el, s)=>!s.announcementsLoaded || !!s.announcementsError || el.call('broadcastItemsForView', s.root).length <= (s.root?._broadcastVisibleCount || 50),
                tag: 'button',
                type: 'button',
                alignSelf: 'flex-start',
                minHeight: 'controlHCompact',
                padding: '0 A',
                round: 'radiusPill',
                border: 'none',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z1',
                fontWeight: '700',
                cursor: 'pointer',
                text: '{{ workspace.announcements.showMore | polyglot }}',
                onClick: (event, el)=>{
                    event.preventDefault();
                    el.call('showMoreBroadcastItems');
                }
            },
            Empty: {
                hide: (el, s)=>!s.announcementsLoaded || !!s.announcementsError || el.call('broadcastItemsForView', s.root).length > 0,
                flow: 'y',
                align: 'center center',
                gap: 'A',
                padding: 'E C',
                round: 'radiusSheet',
                background: 'overlay',
                textAlign: 'center',
                Icon: {
                    name: 'bell',
                    boxSize: 'C',
                    color: 'caption'
                },
                Title: {
                    tag: 'h2',
                    margin: '0',
                    fontSize: 'B',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>el.call('polyglot', el.call('broadcastHasActiveFilters', s.root) ? 'workspace.announcements.empty.filteredTitle' : s.root?._broadcastScope === 'external' ? 'workspace.announcements.empty.publicTitle' : s.root?._broadcastScope === 'all' ? 'workspace.announcements.empty.allTitle' : 'workspace.announcements.empty.teamTitle')
                },
                Copy: {
                    tag: 'p',
                    margin: '0',
                    maxWidth: 'G',
                    fontSize: 'Z1',
                    color: 'caption',
                    text: (el, s)=>el.call('polyglot', el.call('broadcastHasActiveFilters', s.root) ? 'workspace.announcements.empty.filteredCopy' : el.call('canPublishBroadcast', s.root) ? 'workspace.announcements.empty.publisherCopy' : 'workspace.announcements.empty.readerCopy')
                },
                Button: {
                    hide: (el, s)=>!el.call('broadcastHasActiveFilters', s.root),
                    theme: 'primary',
                    text: '{{ workspace.announcements.clearFilters | polyglot }}',
                    onClick: (event, el)=>{
                        event.preventDefault();
                        el.call('clearBroadcastFilters');
                    }
                },
                Publish: {
                    tag: 'button',
                    type: 'button',
                    hide: (el, s)=>el.call('broadcastHasActiveFilters', s.root) || !el.call('canPublishBroadcast', s.root),
                    minHeight: 'controlHCompact',
                    padding: '0 A',
                    round: 'radiusPill',
                    border: 'none',
                    background: 'primary',
                    color: 'primary-content',
                    fontSize: 'Z1',
                    fontWeight: '700',
                    cursor: 'pointer',
                    text: '{{ workspace.announcements.writeRelease | polyglot }}',
                    onClick: (event, el)=>{
                        event.preventDefault();
                        el.call('openBroadcastComposer');
                    }
                }
            }
        }
    }
};

});

parcelRegister("aA4I2", function(module, exports) {

$parcel$export(module.exports, "company", () => $7b40eb533c4c151a$export$fd24aeccace07699);
const $7b40eb533c4c151a$var$SECTION_KEYS = {
    Overview: [
        'legal_name',
        'jurisdiction'
    ],
    Registration: [
        'registered_agent',
        'address'
    ],
    Address: [
        'registered_office'
    ]
};
// A section is addressed by a STABLE English key (the rail's `aria-current`
// match, `root.contentSection` and the `data-content-section` scroll anchor all
// compare against it) and LABELLED by a bundle key. The two must not be the
// same string: a translated anchor would break the rail on a language switch.
const $7b40eb533c4c151a$var$SECTION_LABELS = {
    Overview: 'workspace.company.section.overview',
    Registration: 'workspace.company.section.registration',
    Address: 'workspace.company.section.address',
    Resources: 'workspace.company.section.resources'
};
// EVERY value the handlers below need lives on the element's own `scope`,
// and every handler reads it through `el.scope.*`. A closure does not
// survive frank's serialization: the two handlers used to capture `key`,
// `SECTION_LABELS` and `SECTION_KEYS` from this factory, and the scope
// declared the captured value under a DIFFERENT name (`label: key`). The
// rewriter turns each free `key` read into `<ref>.scope.key`, which was
// undefined, so a published shell resolved `SECTION_KEYS[undefined] || []`
// and rendered Overview, Registration and Address as a heading with zero
// rows. Local bypass mode, where the closure still works, looked correct.
// frank-audit flagged the old shape here: "factory captures [key] inside
// returned-object handlers — move to scope:{} on the returned object".
// Both lookups are one-shot per section, so they resolve at factory time
// and travel as plain scope values (FA204). `label` had no reader and is
// gone. `__tests__/companySectionScope.test.js` revives these handlers in a
// fresh realm, which is the only way to reproduce the published failure.
const $7b40eb533c4c151a$var$_section = (key)=>({
        scope: {
            key: key,
            labelKey: $7b40eb533c4c151a$var$SECTION_LABELS[key] || key,
            rowKeys: $7b40eb533c4c151a$var$SECTION_KEYS[key] || []
        },
        attr: {
            'data-content-section': key
        },
        flow: 'y',
        gap: 'A',
        padding: 'D',
        round: 'radiusSheet',
        background: 'overlay',
        CiTitle: {
            tag: 'h2',
            margin: '0 0 B 0',
            fontSize: 'C',
            fontWeight: '700',
            color: 'title',
            letterSpacing: '-0.01em',
            text: (el)=>el.call('polyglot', el.scope.labelKey)
        },
        Rows: {
            flow: 'y',
            childExtends: 'CompanyInfoRow',
            childrenAs: 'state',
            children: (el, s)=>{
                const wanted = el.scope.rowKeys || [];
                return (s.root.companyInfo || []).filter((r)=>wanted.includes(r.key));
            }
        }
    });
const $7b40eb533c4c151a$var$RESOURCES = [
    {
        label: 'workspace.company.res.pitchDeck',
        url: 'https://docs.google.com/presentation/d/1oarPeQXg-s1uxXYLBQ8pdtq0V8Y-PXlXjYUwB_n5SZY/edit',
        icon: 'document'
    },
    {
        label: 'workspace.company.res.landing',
        url: 'https://dev.symbols.app',
        icon: 'globe'
    },
    {
        label: 'workspace.company.res.platformDocs',
        url: 'https://dev.symbols.app/docs/intro',
        icon: 'library'
    },
    {
        label: 'workspace.company.res.sdkDocs',
        url: 'https://docs.google.com/document/d/13IAfzS9eUjapnr5PVK6AVZPkRtjTYG9An7P9GMgRrM8/edit',
        icon: 'code'
    },
    {
        label: 'workspace.company.res.figma',
        url: 'https://www.figma.com/file/LDFnKQSxUxZeeLHt2OT67r?node-id=0:1&locale=en&type=design',
        icon: 'eye'
    },
    {
        label: 'workspace.company.res.github',
        url: 'https://github.com/symbo-ls',
        icon: 'github'
    },
    {
        label: 'workspace.company.res.npm',
        url: 'https://www.npmjs.com/org/symbo.ls',
        icon: 'code'
    }
];
const $7b40eb533c4c151a$export$fd24aeccace07699 = {
    extends: 'ContentPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.company.page.title')
        }),
    // `eyebrow` is a CUSTOM prop, so a function value is auto-invoked (Rule 70)
    // and ContentPage's `el.parent.parent.parent.parent.eyebrow` reads the
    // resolved string. `title` is NOT — it is a global HTML attribute read as
    // CONTENT, the one case with no working rewrite form
    // (docs/I18N-CONVENTION.md §1.2) — so this page overrides ContentPage's
    // Title slot directly (below) instead of translating the `title` prop.
    // Same contract as pages/my.js and packages/shared/pages/profile.js.
    eyebrow: (el)=>el.call('polyglot', 'workspace.company.page.eyebrow'),
    title: 'Company',
    // `sectionKey` is the SCROLL KEY: ContentPageSectionLink matches it against
    // the `[data-content-section="<key>"]` attribute `_section` writes above and
    // publishes it to `root.contentSection`. It stays the English string those
    // attributes already carry and must NEVER be translated — a translated key
    // breaks the scroll on the first switch. `label` is the VISIBLE string and
    // resolves here, inside ContentPage's reactive `children` factory, so the
    // rail re-renders on a language switch.
    sections: (el)=>[
            {
                sectionKey: 'Overview',
                label: el.call('polyglot', 'workspace.company.section.overview')
            },
            {
                sectionKey: 'Registration',
                label: el.call('polyglot', 'workspace.company.section.registration')
            },
            {
                sectionKey: 'Address',
                label: el.call('polyglot', 'workspace.company.section.address')
            },
            {
                sectionKey: 'Resources',
                label: el.call('polyglot', 'workspace.company.section.resources')
            }
        ],
    // Content mounts in ContentPage's main column (PageMain.Body) — the
    // notes-page skeleton; see components/ContentPage.js.
    PageMain: {
        // ContentPage reads the page's `title` prop into this slot. A `title:`
        // prop cannot carry a translation (§1.2), so the page overrides the slot
        // itself — a plain `text:` on a LEAF element, which takes the TEMPLATE
        // form and re-resolves on a language switch.
        Header: {
            LeftGroup: {
                // One title per host (design-direction.md §3): "Company" is the pane
                // bar word for word, so it yields under one. The eyebrow stays.
                Title: {
                    hide: (el, s)=>el.call('paneTitleBarShown', s),
                    text: '{{ workspace.company.page.heading | polyglot }}'
                }
            }
        },
        Body: {
            PageBody: {
                flow: 'y',
                gap: 'C',
                flex: '1',
                minWidth: '0',
                maxWidth: 'I',
                OverviewCard: $7b40eb533c4c151a$var$_section('Overview'),
                RegistrationCard: $7b40eb533c4c151a$var$_section('Registration'),
                AddressCard: $7b40eb533c4c151a$var$_section('Address'),
                ResourcesCard: {
                    ...$7b40eb533c4c151a$var$_section('Resources'),
                    Rows: null,
                    Links: {
                        flow: 'y',
                        childrenAs: 'state',
                        children: ()=>$7b40eb533c4c151a$var$RESOURCES,
                        childExtends: {
                            extends: 'Link',
                            href: (el, s)=>s.url,
                            target: '_blank',
                            textDecoration: 'none',
                            flow: 'x',
                            align: 'center space-between',
                            gap: 'B',
                            padding: 'A 0',
                            ':hover': {
                                background: 'hover'
                            },
                            Left: {
                                flow: 'x',
                                align: 'center left',
                                gap: 'A',
                                Icon: {
                                    icon: (el, s)=>s.icon || 'link',
                                    boxSize: 'A1',
                                    color: 'accentInk'
                                },
                                Label: {
                                    tag: 'span',
                                    fontSize: 'B',
                                    fontWeight: '700',
                                    color: 'title',
                                    // KEY-IN-STATE — the RESOURCES rows above carry bundle keys.
                                    text: (el, s)=>el.call('polyglot', s.label || '')
                                }
                            },
                            Arrow: {
                                tag: 'span',
                                fontSize: 'Z2',
                                color: 'caption',
                                text: '\u2192'
                            }
                        }
                    }
                }
            }
        }
    }
};

});

parcelRegister("iwxpi", function(module, exports) {

$parcel$export(module.exports, "logsRedirect", () => $d7c5211753aaef2d$export$908a53e78edd9b59);
// /logs → /workspace-analytics/logs redirect. Logs are workspace telemetry
// analytics family; this tiny page keeps the old URL alive so any
// bookmark, navbar memory, or in-app link landing on /logs still
// reaches the same content under the new path.
const $d7c5211753aaef2d$export$908a53e78edd9b59 = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.redirect.page.title')
        }),
    AppSidebar: null,
    AppMain: {
        flow: 'y',
        align: 'center center',
        padding: 'C',
        onCreate: (el)=>{
            if (typeof window === 'undefined') return;
            // Swap to the new path with `replaceState` so the back-button
            // doesn't trap the user on the redirect — same convention
            // bootShell uses for fallbackRoute rewrites.
            try {
                const search = window.location.search || '';
                const target = '/workspace-analytics/logs' + search;
                el.router(target, el.getRoot());
            } catch (err) {
                window.location.replace('/workspace-analytics/logs');
            }
        },
        Notice: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            text: '{{ workspace.redirect.openingLogs | polyglot }}'
        }
    }
};

});

parcelRegister("8Ofnd", function(module, exports) {

$parcel$export(module.exports, "tasksRedirect", () => $669eeb14ca1d2aca$export$758fc7d4a79de6c2);
// Legacy /tickets* + /ticket/:id URL-normalizing redirect (2026-08-06 per
// Nika "you dont have to alias /tickets - find all references and fix to
// /tasks"). The rename wave first served old URLs via same-page-object
// aliases; this replaces that: ONE redirect def registered under every
// legacy key routes to the canonical form, so the address bar always shows
// /tasks (or /resolutions for the moved groups) and the app maintains a
// single route family. Target derivation is data-driven via
// canonicalRoutePath (shared/functions/workspacePrefix.js) — the same map
// the navbar/header active-matchers use for stored Mongo navbar configs, so
// the redirect can never disagree with them. Query + hash ride along
// (?ticket= modal deep-links, board filters). Same replace-not-push
// convention as logsRedirect: el.router goes through the MWT wrapper, which
// re-emits the /w/<org> prefix for the stripped canonical target.
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");
const $669eeb14ca1d2aca$var$shellCanonicalRoutePath = (...args)=>(0, $1X0Je.default).functions.canonicalRoutePath(...args);
const $669eeb14ca1d2aca$export$758fc7d4a79de6c2 = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.redirect.page.title')
        }),
    AppSidebar: null,
    AppMain: {
        flow: 'y',
        align: 'center center',
        padding: 'C',
        onCreate: (el)=>{
            if (typeof window === 'undefined') return;
            const stripped = (0, $7iFOV.shellStripWorkspacePrefix)(window.location.pathname || '/');
            const canonical = $669eeb14ca1d2aca$var$shellCanonicalRoutePath(stripped);
            const target = canonical + (window.location.search || '') + (window.location.hash || '');
            try {
                el.router(target, el.getRoot());
            } catch (err) {
                window.location.replace(target);
            }
        },
        Notice: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            text: '{{ workspace.redirect.openingTasks | polyglot }}'
        }
    }
};

});

parcelRegister("hgKZn", function(module, exports) {

$parcel$export(module.exports, "notesRedirect", () => $c92861553a7794ef$export$4ba12168f3135727);
// Legacy /documents* + /docs URL-normalizing redirect (2026-08-06 per Nika
// "rename Documents (/documents) to Notes (/notes)"). Mirrors the /tickets →
// /tasks pattern: ONE redirect def registered under every legacy key routes
// to the canonical form, so the address bar always shows /notes and the app
// maintains a single route family. Target derivation is data-driven via
// canonicalRoutePath (shared/functions/workspacePrefix.js) — the same map
// the navbar/header active-matchers use — so the redirect can never disagree
// with them. Query + hash ride along (?id= deep links, #note=/#kb= editor
// permalinks). Same replace-not-push convention as tasksRedirect: el.router
// goes through the MWT wrapper, which re-emits the /w/<org> prefix for the
// stripped canonical target.
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");
// Deferred to call time — an eager module-scope destructure of the barrel's
// default crashes the shell boot inside the shared-barrel init cycle.
const $c92861553a7794ef$var$shellCanonicalRoutePath = (...args)=>(0, $1X0Je.default).functions.canonicalRoutePath(...args);
const $c92861553a7794ef$export$4ba12168f3135727 = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'workspace.redirect.page.title')
        }),
    AppSidebar: null,
    AppMain: {
        flow: 'y',
        align: 'center center',
        padding: 'C',
        onCreate: (el)=>{
            if (typeof window === 'undefined') return;
            const stripped = (0, $7iFOV.shellStripWorkspacePrefix)(window.location.pathname || '/');
            const canonical = $c92861553a7794ef$var$shellCanonicalRoutePath(stripped);
            const target = canonical + (window.location.search || '') + (window.location.hash || '');
            try {
                el.router(target, el.getRoot());
            } catch (err) {
                window.location.replace(target);
            }
        },
        Notice: {
            tag: 'span',
            fontSize: 'Y',
            color: 'caption',
            text: '{{ workspace.redirect.openingNotes | polyglot }}'
        }
    }
};

});

parcelRegister("8RC0A", function(module, exports) {

$parcel$export(module.exports, "userProfile", () => $6740c1acfffe3953$export$9e5ae5b26d156995);
// userProfile lives in shared/pages so the marketplace standalone
// surface can mount the same page without depending on
// workspace-project. Re-exporting keeps existing pages-index imports
// stable.
//
// Bare shared-library import, not a deep pages/userProfile.js subpath — see
// components/UserProfile.js's identical fix note (tickets/execution-
// board.md §1 P0). Read inside a `lazyPage` loader, never at module scope:
// a direct module-scope read is a stub-phantom-value under frank
// (WS-SHARED-LAZYPAGE-HOLLOW-ROUTES-SWITCH-1), and deferring into the
// loader also sidesteps the identity-index.js → pages/admin/* import-cycle
// hazard the old module-scope read hit live ("Cannot destructure property
// 'userProfile' of '...default.pages' as it is undefined", smbls push) —
// by the time a route actually mounts, every module has finished init.
//
// The wrapper's `metadata` asks the page's OWN title logic at call time, the
// same way (pages/index.js `profile`): a pane title, a first paint and the AI
// route chip read the route's def, never the mounted page — with none, the
// chip read the segment-cased path, "User" in a Georgian session.

var $1X0Je = parcelRequire("1X0Je");

var $hn2a0 = parcelRequire("hn2a0");
const $6740c1acfffe3953$export$9e5ae5b26d156995 = (0, $hn2a0.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.userProfile), (el, s)=>(0, $1X0Je.default).pages.userProfile.metadata(el, s));

});

parcelRegister("6wqeJ", function(module, exports) {

$parcel$export(module.exports, "flags", () => $4bfa154ccc0cae90$export$ceac1d294cf61000);
$parcel$export(module.exports, "flagsRedirect", () => $4bfa154ccc0cae90$export$23958d0d82046625);
// /admin/flags — feature flags, inside the admin area (moved from the
// standalone /flags ContentPage 2026-07-25 per Nika "put flags page in
// /admin"). Lists EVERY product feature from the FEATURE_FLAGS registry
// (functions/featureFlags.js), grouped, with iOS-style switches; core
// "Basics" are locked always-on; rows with subs detail-down into a wash
// card. Overrides persist per-workspace in Mongo
// (workspace.settings.featureFlags via sdk.updateWorkspaceSettings) and
// mirror onto root state — surfaces gate themselves with
// featureEnabled(s.root, key). Admin-gated like every /admin page
// (shouldRedirectNonAdmin — workspace owners/admins; superadmin not
// required, flags are per-workspace personalization).
//
// The flag GROUPS and the Voice block are registered components
// (components/FlagRow.js FlagGroupSection, components/FlagsVoiceCard.js), fed
// at RENDER time from `featureFlagGroupsWithFlags`. They used to be
// module-local element factories mapped into a module-scope `children:` array
// here, which made the entire workspace-shell project uncompilable by frank —
// see tickets/fable.md and the comment on featureFlagGroupsWithFlags in
// functions/featureFlags.js. Nothing on this page may dereference the registry
// at module scope again.

var $gOQVi = parcelRequire("gOQVi");
// The route gate: not a workspace owner or admin → home.
const $4bfa154ccc0cae90$var$_flagsRouteGate = (el, s)=>{
    if (el.call('shouldRedirectNonAdmin', s)) el.call('routeGateBounce', '/');
};
const $4bfa154ccc0cae90$export$ceac1d294cf61000 = {
    extends: 'AppPage',
    metadata: (el)=>({
            title: el.call('pageTitle', 'admin.flags.page.title')
        }),
    // shouldRedirectNonAdmin fails open until identity and the roster land, and
    // a cold deep link lands them after onInit — so the page subscribes to
    // every gate input (functions/roleHelpers.js `routeGateKeys`) and a
    // subscription pass runs the gate ALONE; the `false` vetoes the rest of it
    // (F2, 2026-10-31; the whole note is on pages/admin/admin.js). Before it,
    // the gate ran once, at onInit.
    onInit: (el, s)=>$4bfa154ccc0cae90$var$_flagsRouteGate(el, s),
    subscribeTo: (el)=>el.call('routeGateKeys'),
    onBeforeUpdate: (el, s, ctx, opts)=>{
        if (!opts || !opts.updateBySubscription) return;
        $4bfa154ccc0cae90$var$_flagsRouteGate(el, s);
        return false;
    },
    onCreate: (el, s)=>{
        (0, $gOQVi.hydrateFeatureFlags)(s.root);
    },
    AdminSidebar: {},
    AdminMain: {
        extends: 'AppMain',
        padding: '0',
        Header: {
            extends: 'AdminPageHeader',
            adminIcon: 'switching',
            LeftGroup: {
                // One title per host (design-direction.md §3): "Feature flags" is the
                // pane bar word for word in every language, so it yields under one.
                Title: {
                    extends: 'PageHeaderTitle',
                    hide: (el, s)=>el.call('paneTitleBarShown', s),
                    text: '{{ admin.flags.title | polyglot }}'
                }
            }
        },
        Body: {
            extends: 'AdminPageBody',
            overflow: 'auto',
            gap: 'A',
            '@mobileL': {
                padding: 'A'
            },
            Column: {
                flow: 'y',
                gap: 'A',
                width: '100%',
                // Settings rows read best on a bounded measure.
                maxWidth: '100%',
                Intro: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'Z1',
                    lineHeight: '1.5',
                    color: 'paragraph',
                    text: '{{ admin.flags.intro | polyglot }}'
                },
                FlagGroups: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-H)), 1fr))',
                    alignItems: 'start',
                    gap: 'A',
                    childExtends: 'FlagGroupSection',
                    childrenAs: 'state',
                    childProps: {
                        Card: {
                            childProps: {
                                Top: {
                                    flow: 'y',
                                    align: 'stretch start',
                                    gap: 'Z'
                                }
                            }
                        }
                    },
                    children: (el)=>el.call('featureFlagGroupsWithFlags')
                }
            }
        }
    }
};
const $4bfa154ccc0cae90$export$23958d0d82046625 = {
    metadata: (el)=>({
            title: el.call('pageTitle', 'admin.flags.page.title')
        }),
    onRender: (el)=>{
        const root = el.call('findRouteRoot', el);
        if (root) el.router('/admin/flags', root, {}, {
            pushState: false
        });
    }
};

});

parcelRegister("jhYyf", function(module, exports) {

$parcel$export(module.exports, "sessionBridge", () => $e0ae931c6edf94a7$export$11ed4ec5dc76a106);
// Intranet-side postMessage endpoint. Forwards the SDK tokens stashed in
// localStorage so peer Symbols origins (canvas, marketplace, preview) can
// skip per-subdomain signin. Whitelisted origins only; page has no UI.

var $1X0Je = parcelRequire("1X0Je");
const $e0ae931c6edf94a7$export$11ed4ec5dc76a106 = {
    metadata: (el)=>({
            title: el.call('polyglot', 'workspace.sessionBridge.page.title')
        }),
    // AMBIGUOUS (left): #0f1116 has no exact gray-ramp match (gray2 #141416 is
    // close but not byte-identical) — this is a headless postMessage bridge
    // with no visible UI, so a fixed near-black regardless of theme is fine.
    background: '#0f1116',
    // white.35 measured 3.20:1 on this ground (needs 4.5) — fable.md AA sweep,
    // delegated to tickets/sonnet.md. white.45 clears the floor (4.53:1) but
    // with almost no margin; white.55 measures ~6.22:1 — still visibly dimmer
    // than a normal caption, comfortably clear, and still a fixed ink since
    // the ground above is fixed too.
    color: 'white.55',
    fontFamily: 'system-ui',
    fontSize: 'Z2',
    padding: 'A',
    text: '{{ workspace.sessionBridge.body | polyglot }}',
    // The handshake listener is DECLARED, not armed imperatively (FA503). It
    // used to be a `window.addEventListener('message', …)` fired from
    // `onRender` behind an `el.__bridgeInit` latch with no removal anywhere —
    // so every mount of this page added one more permanent window listener,
    // each keeping this element reachable from `window` forever.
    //
    // The registration moved; the POLICY did not, and it lives in ONE place —
    // shared functions/sessionBridgeResponder.js, which the canvas page and the
    // light bridge entry (bridge.html) answer with too: a foreign origin is
    // rejected before anything is read, a message of the wrong type is ignored,
    // and the answer is the ACCESS token + expiry only, never the refresh token
    // (the server rotates refresh tokens, so a copy on the peer origin signed one
    // of the two origins out on every rotation). The SDK is reached only when
    // this origin's own token must rotate first.
    onWindowMessage: (ev, el)=>(0, $1X0Je.default).functions.answerSessionBridgeRequest(ev, {
            getSdk: ()=>el?.call?.('getSDK')
        }),
    onRender: (el)=>{
        if (el.__bridgeReady) return;
        el.__bridgeReady = true;
        // Parent waits for this handshake before posting its request so the
        // listener is guaranteed armed. The declared `onWindowMessage` above
        // registers when the element takes its NODE, which the framework does
        // BEFORE it runs onRender — measured, not assumed
        // (`__tests__/globalListenerLifecycle.test.js`).
        (0, $1X0Je.default).functions.announceSessionBridgeReady();
    }
};

});

parcelRegister("4e8H1", function(module, exports) {

$parcel$export(module.exports, "signInSession", () => $313f367b090bd5a0$export$66cc0585b9d930b9);
// /sign-in-session?session=<id> — the explicit Continue for a CLI / plugin
// sign-in link (server CORE-AUTH-TAKEOVER-PATHS D9). The shell sends a
// signed-in visitor of `/login?session=<id>` here (functions/auth.js
// authRedirectTarget). Nothing is armed on load: the page reads the session
// facts (loadSignInSession) and arms it only on the Continue click
// (confirmSignInSession), with the device's code when the server asks for it.
const $313f367b090bd5a0$export$66cc0585b9d930b9 = {
    extends: 'Page',
    metadata: (el)=>({
            title: el.call('polyglot', 'workspace.signInSession.page.title')
        }),
    flow: 'y',
    align: 'center center',
    padding: 'D C',
    width: '100%',
    minHeight: '100%',
    state: {
        requested: false,
        loading: true,
        error: null,
        sessionId: '',
        createdAt: '',
        requesterIp: '',
        client: '',
        codeRequired: false,
        code: '',
        codeError: null,
        submitting: false,
        done: false
    },
    onRender: (el)=>{
        el.call('loadSignInSession');
    },
    SessionCard: {
        flow: 'y',
        gap: 'B',
        padding: 'D',
        width: '100%',
        maxWidth: 'H',
        round: 'radiusSheet',
        background: 'overlay',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'line',
        H1: {
            fontSize: 'C',
            fontWeight: '700',
            color: 'title',
            margin: '0',
            text: '{{ workspace.signInSession.title | polyglot }}'
        },
        LoadingSpinner: {
            if: (el, s)=>!!s.loading,
            boxSize: 'C'
        },
        ErrorText: {
            if: (el, s)=>!s.loading && !!s.error,
            role: 'alert',
            color: 'paragraph',
            text: (el, s)=>el.call('polyglot', s.error)
        },
        DoneText: {
            if: (el, s)=>!!s.done,
            role: 'status',
            color: 'paragraph',
            text: '{{ workspace.signInSession.done | polyglot }}'
        },
        Ask: {
            if: (el, s)=>!s.loading && !s.error && !s.done,
            flow: 'y',
            gap: 'B',
            Lead: {
                tag: 'p',
                margin: '0',
                color: 'paragraph',
                text: '{{ workspace.signInSession.lead | polyglot }}'
            },
            Facts: {
                tag: 'dl',
                flow: 'y',
                gap: 'Z',
                margin: '0',
                StartedRow: {
                    flow: 'x',
                    gap: 'A',
                    Dt: {
                        tag: 'dt',
                        color: 'caption',
                        text: '{{ workspace.signInSession.started | polyglot }}'
                    },
                    Dd: {
                        tag: 'dd',
                        margin: '0',
                        color: 'title',
                        text: (el, s)=>s.createdAt ? el.call('localizedDate', s.createdAt, {
                                day: 'numeric',
                                month: 'short',
                                hour: 'numeric',
                                minute: '2-digit'
                            }) : "\u2014"
                    }
                },
                FromRow: {
                    flow: 'x',
                    gap: 'A',
                    Dt: {
                        tag: 'dt',
                        color: 'caption',
                        text: '{{ workspace.signInSession.from | polyglot }}'
                    },
                    Dd: {
                        tag: 'dd',
                        margin: '0',
                        color: 'title',
                        text: (el, s)=>s.requesterIp || "\u2014"
                    }
                },
                ClientRow: {
                    flow: 'x',
                    gap: 'A',
                    Dt: {
                        tag: 'dt',
                        color: 'caption',
                        text: '{{ workspace.signInSession.client | polyglot }}'
                    },
                    Dd: {
                        tag: 'dd',
                        margin: '0',
                        color: 'title',
                        text: (el, s)=>s.client === 'cli' ? el.call('polyglot', 'workspace.signInSession.clientCli') : s.client || el.call('polyglot', 'workspace.signInSession.clientUnknown')
                    }
                }
            },
            Warning: {
                tag: 'p',
                margin: '0',
                color: 'warningInk',
                text: '{{ workspace.signInSession.warning | polyglot }}'
            },
            CodeField: {
                if: (el, s)=>!!s.codeRequired,
                flow: 'y',
                gap: 'Z',
                Label: {
                    tag: 'label',
                    color: 'caption',
                    text: '{{ workspace.signInSession.codeLabel | polyglot }}'
                },
                Input: {
                    name: 'user_code',
                    autocomplete: 'off',
                    spellcheck: 'false',
                    maxlength: '12',
                    placeholder: 'XXXX-XXXX',
                    'aria-label': (el)=>el.call('polyglot', 'workspace.signInSession.codeLabel'),
                    value: (el, s)=>s.code,
                    onInput: (ev, el, s)=>{
                        s.update({
                            code: ev.target.value,
                            codeError: null
                        });
                    }
                },
                CodeError: {
                    if: (el, s)=>!!s.codeError,
                    role: 'alert',
                    color: 'warningInk',
                    text: (el, s)=>el.call('polyglot', s.codeError)
                }
            },
            Actions: {
                flow: 'x',
                gap: 'A',
                ContinueButton: {
                    extends: [
                        'Button',
                        'ClickableItem'
                    ],
                    text: '{{ workspace.signInSession.continue | polyglot }}',
                    disabled: (el, s)=>!!s.submitting,
                    onClick: async (ev, el)=>{
                        await el.call('confirmSignInSession');
                    }
                },
                CancelButton: {
                    extends: [
                        'Button',
                        'ClickableItem'
                    ],
                    theme: 'transparent',
                    text: '{{ workspace.signInSession.cancel | polyglot }}',
                    onClick: async (ev, el)=>{
                        await el.router('/', el.getRoot());
                    }
                }
            }
        }
    }
};

});

parcelRegister("9Hn8c", function(module, exports) {

$parcel$export(module.exports, "projectRedirect", () => $70fa129ac5696aa2$export$cb700b52382fb3c8);
// The shell's catch-all route (registered as `'/*'` — see pages/index.js +
// context.js). Replaces canvas's own `'/*': main` catch-all (dropped from
// the merged route map in context.js).
//
// History: 2026-07-28, per Nika, project CANVAS routes were served IN-SHELL.
// 2026-10-09 (CANVAS P0) reversed that and handed project paths to a separate
// canvas origin, because the editor's board frames were same-origin and
// unsandboxed. CANVAS H1 (62729615a and before) closed that reach at its root:
// every canvas user-code mount now runs in an opaque, sandboxed frame that
// boots its own runtime (shared functions/iframeApp/userCodeFrame.js, the
// runtime from this shell's `userCodeRuntimeText`), so no project code runs
// with the shell's origin (canvas/__tests__/boardFrameIsUserCodeOrigin.test.js).
// 2026-10-21, per Nika ("remove independent canvas deployments ... purely rely
// on workspace"): the shell is again the ONLY host of the editor. A project-
// shaped path (`/<owner>/<key>`, `/w/<org>/p/<key>`, classified by
// isCanvasProjectPath) mounts the full canvas editor here; the old canvas
// hosts answer a 308 to this same path on the shell (canvas/redirectWorker.js).
//
// The #15 bundle carve stays: the editor graph (canvas context barrels) stays
// OUT of the eager shell chunk and loads as a dynamic-import chunk only when a
// project path is visited. Mechanism: the same add-missing fold as
// lazySharedLibPage (pages/lazyPage.js — components, functions, seed state)
// PLUS the editor's element methods and globalScope — the editor's methods
// (activateSelected, getCanvasScope, …) live in canvas/methods and the shell's
// eager slice carries only a sliver.
//
// Anything NOT project-shaped keeps the plain not-found, still gated by the
// `_appRoutesSettled` latch so a hard load on a not-yet-injected app route
// (`/w/<org>/crm`) never flashes a false 404 (workspace 45ad2f40).

var $11nI2 = parcelRequire("11nI2");

var $9StQo = parcelRequire("9StQo");
const $70fa129ac5696aa2$var$_shellPath = ()=>typeof window !== 'undefined' ? window.location.pathname : '';
const $70fa129ac5696aa2$var$_foldMissing = (target, src)=>{
    if (!target || !src) return;
    for(const k in src)if (!(k in target)) target[k] = src[k];
};



// Mount the canvas editor page IN the shell. The imports are async, so the
// router can navigate away while they are in flight: the late-resolve guard of
// lazySharedLibPage applies (disposed -> never; not attached yet -> when it is).
const $70fa129ac5696aa2$var$_mountCanvasEditor = async (el)=>{
    const _place = (def)=>{
        if (!el.__ref) return;
        if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
        else el.set(def);
    };
    try {
        const [ctxMod, pageMod, smblsLib] = await Promise.all([
            (parcelRequire("3dQQl")),
            Promise.resolve((parcelRequire("5RS66"))),
            // DYNAMIC on purpose: a static smbls import would re-add smbls to the
            // EAGER shell chunk (the #15 carve). An smbls build without
            // refreshContextProto just skips the proto refresh below.
            Promise.resolve((parcelRequire("eY4Ct"))).catch(()=>null)
        ]);
        const lib = ctxMod && ctxMod.default || ctxMod;
        if (!lib || !lib.components && !lib.functions) throw new Error("canvas context resolved empty \u2014 stale/mismatched bundle (rebuild needed)");
        if (!pageMod || !pageMod.main) throw new Error('canvas editor page resolved empty');
        const root = el.getRoot?.() || el;
        const ctx = root.context;
        // Add-missing: the eager slice / an earlier fold always wins.
        $70fa129ac5696aa2$var$_foldMissing(ctx?.components, lib.components);
        $70fa129ac5696aa2$var$_foldMissing(ctx?.functions, lib.functions);
        $70fa129ac5696aa2$var$_foldMissing(ctx?.methods, lib.methods);
        // The per-context element prototype was CACHED at boot (smbls
        // getContextProto), so folded canvas methods (`canvas<Name>`, which
        // shared's same-named methods hand off to) reach `el.call('name')` (live
        // lookup) but not DIRECT `el.method()` calls until refreshContextProto
        // re-syncs the cached proto with the registry.
        if (typeof smblsLib?.refreshContextProto === 'function') smblsLib.refreshContextProto(ctx);
        if (lib.globalScope && ctx) {
            if (!ctx.globalScope) ctx.globalScope = {};
            $70fa129ac5696aa2$var$_foldMissing(ctx.globalScope, lib.globalScope);
        }
        if (lib.state) {
            const seed = {};
            for(const k in lib.state)if (root[k] === undefined) seed[k] = lib.state[k];
            if (Object.keys(seed).length) root.update?.(seed);
        }
        _place({
            ...pageMod.main,
            height: '100%',
            minHeight: '100%'
        });
    } catch (err) {
        console.error('[projectRedirect] canvas editor load failed:', err?.message || err);
        _place({
            tag: 'div',
            padding: 'B',
            color: 'caption',
            text: '{{ shell.errorState.lazyPage | polyglot }}'
        });
    }
};
const $70fa129ac5696aa2$export$cb700b52382fb3c8 = {
    // Placeholder title until the editor page applies its own project title
    // (canvas/pages/main.js metadata).
    //
    // The "Not found" title follows the SAME condition as NotFoundBody's copy
    // (`scope.notFoundShown`). It used to be claimed at mount, inside the very
    // window the copy stays hidden in, so a route that resolved a moment later
    // left the tab on "Not found" whenever its page had no title of its own
    // (vault.pr /vault-intel, PM close-audit of
    // WS-PREBOOT-NOT-FOUND-FLASH-ON-MODULE-ROUTE-1, 2026-09-25). An empty
    // claim leaves the tab as it is. Helmet re-runs this factory when a latch
    // it reads flips, so the tab turns "Not found" at the moment the copy does.
    metadata: (el, s)=>{
        if ((0, $9StQo.isCanvasProjectPath)($70fa129ac5696aa2$var$_shellPath())) return {
            title: el.call('polyglot', 'workspace.page.canvas')
        };
        if (!el.scope?.notFoundShown?.(s?.root || s, el)) return {};
        return {
            title: el.call('polyglot', 'workspace.page.notFound')
        };
    },
    tag: 'main',
    flow: 'y',
    align: 'center center',
    minHeight: '100vh',
    gap: 'Z1',
    background: 'canvas',
    color: 'title',
    textAlign: 'center',
    onCreate: (el)=>{
        if (el.__canvasEditorDispatched) return;
        if (!(0, $9StQo.isCanvasProjectPath)($70fa129ac5696aa2$var$_shellPath())) return;
        el.__canvasEditorDispatched = true;
        $70fa129ac5696aa2$var$_mountCanvasEditor(el);
    },
    // WS-PREBOOT-NOT-FOUND-FLASH-ON-MODULE-ROUTE-1: how long NotFoundBody stays
    // hidden for a route that has not settled yet, before it gives up and shows
    // a genuine 404 anyway. Bounds the wait for a visit with no session token
    // (the loaders that latch `_appRoutesSettled` never run, so that latch alone
    // would hide a truly dead link forever) — long enough to cover the measured
    // module-route injection race (2-3s live on vault.pr.symbols.app), short
    // enough that a dead link still 404s promptly.
    scope: {
        NOT_FOUND_GRACE_MS: 3000,
        // HALF ONE — the route table is FINAL: nothing still loading can add the
        // path. A signed-in member's app registry has a real "done" signal, the
        // `_appRoutesSettled` latch (the module/apps loaders set it on success, on
        // a definitive failure and on the converge give-up), so a signed-in visit
        // waits for THAT and never for the timer. The grace window bounds only a
        // visit with NO session, where those loaders never run. Measured
        // 2026-09-30 on dev c9f65a38d: a cold load of /w/unreal/default/crm
        // mounted the shell at 7.8 s and injected /crm at 26.8 s, and the 3 s
        // timer had put "Not found" in the tab (and, once the loader lifted, on
        // screen) at ~11 s, for a route the loader re-dispatched 16 s later.
        // A session that lands after the window turns the wait back on.
        routeTableFinal: (root)=>!!(root && (root._appRoutesSettled || !root.signedIn && root._notFoundGraceElapsed)),
        // HALF TWO — a route in the LIVE table claims this URL, so this page is
        // only stranded: the loader injected the route after the router had
        // resolved, and its re-dispatch (functions/workspaceProjects.js
        // `_rerouteIfStranded`, the same own-key test) is on the way. The latch
        // is published one beat BEFORE that re-dispatch, and in a visible tab the
        // router fades this page out before it mounts the next (app.js
        // `onRouteExit`), so without this half "Not found" painted over a route
        // that had just resolved. The URL is read prefix-stripped, like the
        // router matches it (`/w/<org>/<ws>/crm` → `/crm`).
        routeClaimsUrl: (el)=>{
            const raw = $70fa129ac5696aa2$var$_shellPath();
            const stripped = el && typeof el.call === 'function' && el.call('stripWorkspacePrefix', raw) || raw;
            const path = String(stripped).split(/[?#]/)[0] || '/';
            if (path === '/*') return false;
            const own = (bag)=>!!bag && typeof bag === 'object' && Object.prototype.hasOwnProperty.call(bag, path);
            const root = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
            return own(el && el.context && el.context.pages) || own(root && root.routes);
        },
        // THE ONE CONDITION for "Not found is on screen": the table is final AND
        // no route in it claims this URL. NotFoundBody's `hide` and the tab title
        // (`metadata`) both read it, so the copy and the tab cannot disagree.
        notFoundShown: (root, el)=>!!(el && el.scope && el.scope.routeTableFinal(root) && !el.scope.routeClaimsUrl(el))
    },
    onInit: (el)=>{
        el.scope.notFoundGraceTimer = null;
        // A project path hosts the canvas editor (onCreate), never a 404.
        el.scope.hostsNotFound = !(0, $9StQo.isCanvasProjectPath)($70fa129ac5696aa2$var$_shellPath());
        if (!el.scope.hostsNotFound) return;
        el.scope.notFoundGraceTimer = setTimeout(()=>{
            // The ROOT STATE — the store NotFoundBody's `hide` reads as `s.root`.
            // Never `el.getRoot()` alone: that is the root ELEMENT, and an element
            // update() keeps the key as an element prop that no `hide` reads. A
            // smbls mount measured exactly that: the flag landed on the element
            // and the body stayed hidden for good.
            const root = el.state?.root || el.state || el.getRoot?.()?.state;
            root?.update?.({
                _notFoundGraceElapsed: true
            }, {
                preventFetch: true
            });
        }, el.scope.NOT_FOUND_GRACE_MS);
    },
    onRemove: (el)=>{
        clearTimeout(el.scope.notFoundGraceTimer);
        // Hand the tab back. The router removes this page BEFORE it mounts the
        // next one, and a page with no title of its own keeps whatever the tab
        // shows — so a "Not found" claimed here outlived the catch-all onto the
        // page that resolved (a module route injected after the grace window).
        // The neutral brand title goes in first; the next page's own title, when
        // it has one, replaces it as that page mounts. Half one only: the route
        // replacing this page claims the URL by now, so the full condition reads
        // false exactly when a claimed tab is owed back.
        if (!el.scope.hostsNotFound || !el.scope.routeTableFinal(el.state?.root || el.state)) return;
        const doc = el.context?.document || (typeof document !== 'undefined' ? document : null);
        if (doc) (0, $11nI2.applyMetadata)({
            title: el.call('brandName')
        }, doc);
    },
    NotFoundBody: {
        flow: 'y',
        align: 'center center',
        gap: 'Z1',
        // Never show not-found CONTENT for a path that might still resolve:
        //  - project-shaped paths are the editor dispatch above (never a 404);
        //  - injected app/module routes don't exist at router boot, so a hard
        //    load lands here before `_ensureWorkspaceModule` has injected them —
        //    `_appRoutesSettled` latches once the loaders finish (success OR
        //    failure), so a genuinely nonexistent path still 404s after settle.
        //    A "pending" flag was tried first and RACED `_authReady` — the latch
        //    is absent-until-done, so it has no gap (workspace 45ad2f40).
        //  - a signed-out visit never runs those loaders, so `_appRoutesSettled`
        //    alone would hide this forever for it — `onInit` above ALSO releases
        //    it once `_notFoundGraceElapsed` fires, bounding the wait instead of
        //    reading a same-instant session-token snapshot (which reads exactly
        //    as "signed out" during the very race this fix targets, live on a
        //    custom domain host — WS-PREBOOT-NOT-FOUND-FLASH-ON-MODULE-ROUTE-1).
        subscribeTo: [
            '_appRoutesSettled',
            '_notFoundGraceElapsed',
            'signedIn'
        ],
        // The page's `scope` (borrowed here) holds the shared predicate.
        hide: (el, s)=>(0, $9StQo.isCanvasProjectPath)($70fa129ac5696aa2$var$_shellPath()) || !el.scope.notFoundShown(s.root || s, el),
        Heading: {
            tag: 'h1',
            margin: '0',
            fontSize: 'B1',
            fontWeight: '700',
            color: 'title',
            text: '{{ workspace.notFound.title | polyglot }}'
        },
        Caption: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            color: 'caption',
            text: '{{ workspace.notFound.caption | polyglot }}'
        },
        HomeLink: {
            extends: 'Link',
            href: '/',
            // `blue` is a raw HUE token — one fixed value, no light/dark pair — so it
            // measured 3.62:1 on the light shell (brand #0085FF on white), under the
            // 4.5 floor for this 700-weight Z2 text. `accentInk` is the same hue
            // re-toned per theme (symbols-mcp Rule 69). Found by the aa-contrast
            // sweep on /main and /system, 2026-08-09.
            color: 'accentInk',
            fontSize: 'Z2',
            fontWeight: '700',
            text: '{{ workspace.notFound.goHome | polyglot }}'
        }
    }
};

});
parcelRegister("5RS66", function(module, exports) {

$parcel$export(module.exports, "main", () => $445bdd9f2de908f8$export$f22da7240b7add18);
// The project page route. Hosts Canvas (the scene) + CanvasEditor
// (the overlay chrome). When the bootstrap in canvas/index.js sets
// `root.projectNotFound`, the NotFoundPage sibling takes over inline
// so the URL stays on the project path for retry-by-reload.

var $1G1eN = parcelRequire("1G1eN");
// Derive a human-readable project label from current state.
// Falls back to the URL slug so the title is never blank during load.
const $445bdd9f2de908f8$var$projectTitle = (s)=>{
    const root = s.root || s;
    const data = root.data;
    if (data && !root.projectNotFound) return (data.name || data.key || '').trim() || null;
    // Fallback: the project key from the URL — workspace-scoped form
    // (`/w/<org>[/<ws>]/p/<key>`) first, else the second segment of the legacy
    // `/:owner/:projectSlug` shape (which also covers the stripped `/p/<key>`
    // matchPath: segment 2 IS the key there).
    const path = root.currentPath || (typeof window !== 'undefined' ? window.location.pathname : '');
    const wsForm = (0, $1G1eN.parseWorkspaceProjectPath)(path);
    if (wsForm) return wsForm.key;
    const segs = path.split('/').filter(Boolean);
    return segs[1] || segs[0] || null;
};

const $445bdd9f2de908f8$export$f22da7240b7add18 = {
    tag: 'main',
    id: 'main-content',
    // The shell root grid is a single `1fr` row now that the AppHeader is an
    // absolute overlay (2026-06 app-page header-clearance change). The legacy
    // `gridRow: '2'` stranded this project-canvas page in an implicit, 0-height
    // row 2 — so #main-content collapsed and the board was invisible. Row 1 is
    // the content track (verified live: row 1 → full height). Chrome routes
    // (dashboard / account / studio) keep their own AppPage 2-row grid.
    gridRow: '1',
    gridColumn: '1 / -1',
    position: 'relative',
    width: '100%',
    minHeight: '0',
    overflow: 'hidden',
    // Flag the project-canvas surface for the GLOBAL CanvasPromptTextarea
    // (shell-root mount in workspace/app.js): its Inspect (sf cursor)
    // button only shows while a canvas page is open.
    onInit: (el, s)=>{
        (s?.root || s)?.update?.({
            _projectCanvasOpen: true
        });
    },
    onRemove: (el, s)=>{
        (s?.root || s)?.update?.({
            _projectCanvasOpen: false
        });
    },
    metadata: (el, s)=>{
        const root = s.root || s;
        if (root?.projectNotFound) return {
            title: el.call('polyglot', 'canvas.page.notFound.title')
        };
        // Dead single-segment routes (e.g. /notFound, /foo) land on this `/*`
        // handler before the async ensureProjectLoaded sets projectNotFound.
        // Detect them eagerly so the title is correct from the first paint.
        const path = typeof window !== 'undefined' ? window.location.pathname : root.currentPath || '';
        const segs = path.split('/').filter(Boolean);
        if (segs.length === 1) return {
            title: el.call('polyglot', 'canvas.page.notFound.title')
        };
        const label = $445bdd9f2de908f8$var$projectTitle(s);
        // Pure product names around the project label — nothing translatable.
        const title = label ? `${label} / Canvas / Symbols.app` : 'Canvas / Symbols.app';
        return {
            title: title
        };
    },
    // Right-click is owned by CanvasSurface.onContextmenu (empty canvas) +
    // CanvasItem.onContextmenu (item) → canvasStageContextmenu, which
    // stopPropagates — a page-root listener here would never fire, so it's gone
    // (it was the source of the double menu). (2026-06-17 per Nika.)
    // `ensureProjectLoaded` lives in the canvas EDITOR's function graph, which
    // the workspace shell deliberately does not register: it imports the slim
    // `functions/eagerSlice.js` to keep that graph out of the eager chunk (#15).
    // `el.call` on a missing function silently no-ops, so on the shell host a
    // project route (`/<owner>/<project>`) mounted the canvas and then sat on the
    // loading state forever — not one project fetch was ever issued.
    //
    // Load it on demand rather than importing it at module scope: this page IS in
    // the eager chunk (canvas/pages/index.js imports it statically), so a static
    // import here would pull the whole editor graph back in and undo the carve.
    onRender: (el, s)=>{
        if (typeof el.context?.functions?.ensureProjectLoaded === 'function') return el.call('ensureProjectLoaded', el, s);
        return (parcelRequire("ksjMK")).then((m)=>m.ensureProjectLoaded(el, s)).catch((err)=>console.warn('[canvas] project loader unavailable:', err?.message || err));
    },
    GridstackStyles: {
        tag: 'style',
        html: (el)=>el.context.gridstackCss || ''
    },
    NotFoundPage: {
        // Rendered inside this <main>, so strip the duplicate <main> tag and id
        // that notFound.js declares for its standalone /404 route usage.
        tag: 'div',
        id: null,
        if: (el, s)=>!!s.root?.projectNotFound
    },
    // THE APP SPLIT (docs/APP_SPLIT.md §5.4, Nika 2026-10-19 "they should not
    // go to the same canvas"): a workspace app (a manifest-2 module, an AI-built
    // app) never opens in this WEBSITE editor — the guard takes the editor's
    // place and leads to the app's own flow; every editor part below steps aside
    // for it.
    WorkspaceAppGuard: {
        if: (el, s)=>el.call('canvasProjectDecided', s.root) && el.call('canvasIsWorkspaceApp', s.root)
    },
    // Until the URL's project has loaded, neither the editor (its Publish) nor
    // the guard can know the project's kind: a neutral page skeleton holds the
    // place (production 2026-10-21, the editor showed on a workspace app first).
    PageSkeleton: {
        if: (el, s)=>!s.root?.projectNotFound && !el.call('canvasProjectDecided', s.root)
    },
    // The scene keeps mounting with the page, as before the guard: its own
    // pre-load guard holds it empty until root.data is the URL's project, and
    // its first seed + viewport fit depend on that mount order (a scene mounted
    // after the data landed opened unfitted). It carries no Publish; it steps
    // aside once the project is known to be a workspace app.
    Canvas: {
        if: (el, s)=>!s.root?.projectNotFound && !(el.call('canvasProjectDecided', s.root) && el.call('canvasIsWorkspaceApp', s.root))
    },
    CanvasEditor: {
        if: (el, s)=>el.call('canvasEditorOpen', s.root)
    },
    // Project-internal floating "+" navbar — pages, components, integrations,
    // shared libraries. StudioNavbar (the new-project creator) is reserved
    // for /studio. See components/CanvasNavbar.js + StudioNavbar.js.
    CanvasNavbar: {
        if: (el, s)=>el.call('canvasEditorOpen', s.root)
    },
    // The project rail — filter canvas items, switch environment, publish (same
    // glass shell as the /infra sidebar; 2026-06-17 per Nika). On the
    // page-sidebar rule (Nika 2026-10-29; shared functions/pageSidebar.js): the
    // side the navbar does not take, the one hide button, the choice kept per
    // page. Opted in HERE, on the desktop mount: the phone sheet below shows the
    // same rail inline.
    ProjectCanvasSidebar: {
        if: (el, s)=>el.call('canvasEditorOpen', s.root),
        pageSidebar: true,
        '@mobileL': {
            display: 'none'
        }
    },
    CanvasControlsSheet: {
        if: (el, s)=>el.call('canvasEditorOpen', s.root),
        Card: {
            Content: {
                CanvasViewNavGroup: null,
                // The rail inline in the phone sheet: no hide button and no reopen tab
                // (the sheet itself opens and closes), and the sheet's full width in
                // a narrow app surface too.
                ProjectCanvasSidebar: {
                    SidebarToggle: null,
                    SidebarReopen: null,
                    position: 'relative',
                    left: 'auto',
                    top: 'auto',
                    bottom: 'auto',
                    width: '100%',
                    minWidth: '0',
                    maxWidth: 'none',
                    '@mobileL': {
                        width: '100%',
                        maxWidth: 'none',
                        maxHeight: 'none'
                    },
                    '@appMobile': {
                        width: '100%',
                        minWidth: '0',
                        maxWidth: 'none',
                        maxHeight: 'none'
                    }
                }
            }
        }
    },
    // Right rail — project Version History (list / preview / restore; the
    // legacy platform's Versions aside rebuilt). Reactively hidden unless
    // root._versionsOpen — toggled from the ProjectCanvasSidebar row, the
    // canvas right-click menu, /versions in the command bar, and the dashboard
    // project-card menu (which seeds the flag before navigating here).
    VersionHistoryPanel: {
        if: (el, s)=>el.call('canvasEditorOpen', s.root)
    },
    // Floating per-version detail card, docked LEFT of the history rail —
    // opens on timeline selection, X clears it (2026-08-07 per Nika).
    VersionDetailPanel: {
        if: (el, s)=>el.call('canvasEditorOpen', s.root)
    },
    // Right-side floating island navbar — temporarily hidden until the
    // Pages/Modes/Envs/Publish surface is finalised. Keep the slot in place so
    // re-enabling is one-line.
    // THE OPEN PROJECT FOLLOWS ITS AI WRITES (functions/canvas/remoteUpdates.js
    // syncRemoteUpdateWatch): invisible. It runs on mount, on a project switch
    // (the canvas swaps root.data WITHOUT remounting) and on every AI project
    // write the shell records (`_aiProjectWrite`) — a write to this project
    // lands in place, or raises the Reload banner below. Mounted here, on the
    // editor page, so the shell's editor has it (it lived on the retired
    // standalone app shell, where the shell never mounted it).
    RemoteUpdateWatcher: {
        display: 'none',
        stateDeps: [
            (el, s)=>s.root && s.root.data && s.root.data._id,
            (el, s)=>s.root && s.root._aiProjectWrite
        ],
        onRender: (el)=>el.call('syncRemoteUpdateWatch', el),
        onStateUpdate: (el)=>el.call('syncRemoteUpdateWatch', el)
    },
    // Non-destructive remote-update affordance — shown when an AI write lands
    // for the open project and could not apply in place. The card lives in
    // components/RemoteUpdateBanner.js; this is its plain positioning dock (no
    // Navbar ancestry to fight — see that file).
    RemoteUpdateBanner: {
        position: 'fixed',
        bottom: 'B',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '10002',
        display: 'flex',
        width: 'auto',
        maxWidth: 'none',
        RemoteUpdateBannerCard: {}
    },
    CanvasMainNavbar: {
        if: ()=>false
    },
    // Floating top-center MainNavbar retired — AppHeader now mounts MainNavbar
    // (which folds in AppWorkspaceSwitcher) on the left, so duplicating it
    // here showed two stacked navbars. `null` removes the slot entirely.
    MainNavbar: null
};

});
parcelRegister("ksjMK", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("kFdrj"))) : import("kFdrj")).then(()=>parcelRequire('kV1Ea'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});



parcelRegister("dGGl7", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("ekrJ3"))) : import("ekrJ3")).then(()=>parcelRequire('14YFe'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("8C37J", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("2ISqp"))) : import("2ISqp")).then(()=>parcelRequire('7PFVl'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("9M6jj", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("cF36q"))) : import("cF36q")).then(()=>parcelRequire('hD3oy'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1rG13", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("g274q"))) : import("g274q")).then(()=>parcelRequire('6spa0'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("jnBqo", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("kMMax"))) : import("kMMax")).then(()=>parcelRequire('71Wie'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("6OfOT", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("41OtR"))) : import("41OtR")).then(()=>parcelRequire('bVZ16'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7u3aP", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("jXosz"))) : import("jXosz")).then(()=>parcelRequire('ln0bH'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("3KjYC", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("deUkj"))) : import("deUkj")).then(()=>parcelRequire('9nhsL'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("033np", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9oB9f"))) : import("9oB9f")).then(()=>parcelRequire('5Bj8k'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("eGYKs", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("575tl"))) : import("575tl")).then(()=>parcelRequire('cFl8n'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("9yYCT", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6m4wf"))) : import("6m4wf")).then(()=>parcelRequire('jQ33B'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("avtTh", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("6YMSE"))) : import("6YMSE")).then(()=>parcelRequire('lDrAi'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("lge8j", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("fZaxe"))) : import("fZaxe")).then(()=>parcelRequire('2UxZC'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("jZGDx", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("h3Loj"))) : import("h3Loj")).then(()=>parcelRequire('3CTy1'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hI6RD", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("bLaCc"))) : import("bLaCc")).then(()=>parcelRequire('8CH96'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("7Hnzg", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("3bJC3"))) : import("3bJC3")).then(()=>parcelRequire('5BhHK'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("8H9Jz", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hzRbt"))) : import("hzRbt")).then(()=>parcelRequire('5sH49'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("hLdDq", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("kiobw"))) : import("kiobw")).then(()=>parcelRequire('f40Vo'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("h7Pna", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("ltbyX"))) : import("ltbyX")).then(()=>parcelRequire('jnp49'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("6LoKu", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("PDjTL"))) : import("PDjTL")).then(()=>parcelRequire('esi6D'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("8NLYd", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("gsUa5"))) : import("gsUa5")).then(()=>parcelRequire('kLmmu'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("g26qD", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("1vcRc"))) : import("1vcRc")).then(()=>parcelRequire('NlGMa'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("9s1tM", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("8dyaq"))) : import("8dyaq")).then(()=>parcelRequire('1Brdx'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("eeN3I", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("bK8ca"))) : import("bK8ca")).then(()=>parcelRequire('alcLe'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("k5PUf", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9Lpj7"))) : import("9Lpj7")).then(()=>parcelRequire('1cAL2'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("9oaOM", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("fjJzA"))) : import("fjJzA")).then(()=>parcelRequire('1bNxh'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1EWCl", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("aCnuh"))) : import("aCnuh")).then(()=>parcelRequire('ahGrN'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("2DXB7", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("aiwvk"))) : import("aiwvk")).then(()=>parcelRequire('F2Efp'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1unLs", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("2cJcz"))) : import("2cJcz")).then(()=>parcelRequire('l8hY4'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("il7jP", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("afI8l"))) : import("afI8l")).then(()=>parcelRequire('8efIU'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("kEufJ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("aftkZ"))) : import("aftkZ")).then(()=>parcelRequire('kSqQ9'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("bKIrz", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("ecwWu"))) : import("ecwWu")).then(()=>parcelRequire('hOyZE'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("3DNhV", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("aFfIE"))) : import("aFfIE")).then(()=>parcelRequire('cqt4T'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("22ZiX", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("dkGoy"))) : import("dkGoy")).then(()=>parcelRequire('cL2WK'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("bP5E4", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9mxlk"))) : import("9mxlk")).then(()=>parcelRequire('jUQMx'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("1icb6", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("7GDIw"))) : import("7GDIw")).then(()=>parcelRequire('4yUel'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("gKYCm", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("eHoJN"))) : import("eHoJN")).then(()=>parcelRequire('ghE3G'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("rFUTx", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("cZuTc"))) : import("cZuTc")).then(()=>parcelRequire('enZOm'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("fLrKQ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("lEyeI"))) : import("lEyeI")).then(()=>parcelRequire('dJVTp'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("c6pcc", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hzJXU"))) : import("hzJXU")).then(()=>parcelRequire('dI19Y'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("jMY48", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("7BccZ"))) : import("7BccZ")).then(()=>parcelRequire('eFApy'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("ePXwE", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("bRI2V"))) : import("bRI2V")).then(()=>parcelRequire('k5Ukm'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("kG8Bn", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("k6zda"))) : import("k6zda")).then(()=>parcelRequire('jF3D2'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("f426L", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("1eR7a"))) : import("1eR7a")).then(()=>parcelRequire('kFSxO'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("lj0dP", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("kTJKR"))) : import("kTJKR")).then(()=>parcelRequire('hbokV'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("4JxxM", function(module, exports) {

$parcel$export(module.exports, "signin", () => $3725627b77536685$export$54f63e0bb65a6adc);
$parcel$export(module.exports, "signup", () => $3725627b77536685$export$7200a869094fec36);
$parcel$export(module.exports, "signupConfirmation", () => $3725627b77536685$export$9c079914996cc79c);
$parcel$export(module.exports, "resetPassword", () => $3725627b77536685$export$dc726c8e334dd814);
$parcel$export(module.exports, "waitlist", () => $3725627b77536685$export$4fd09d08b607c3f1);
$parcel$export(module.exports, "profile", () => $3725627b77536685$export$4882ae973e0491e);
$parcel$export(module.exports, "rootRedirect", () => $3725627b77536685$export$d7e406d79a809aeb);
$parcel$export(module.exports, "dashboardRedirect", () => $3725627b77536685$export$4b49b685a3384339);
$parcel$export(module.exports, "studioRoute", () => $3725627b77536685$export$7d5b4a1b76e6c9ef);
$parcel$export(module.exports, "studioBoardRoute", () => $3725627b77536685$export$f16cd9ed4c0e5dc3);
$parcel$export(module.exports, "canvasRoute", () => $3725627b77536685$export$3f35a7b711b00c13);
$parcel$export(module.exports, "default", () => $3725627b77536685$export$2e2bcd8739ae039);
$parcel$export(module.exports, "main", () => (parcelRequire("5RS66")).main);
$parcel$export(module.exports, "account", () => (parcelRequire("iRHtA")).account);
$parcel$export(module.exports, "marketplace", () => (parcelRequire("3k2Ws")).marketplace);
$parcel$export(module.exports, "sessionBridge", () => (parcelRequire("c6sCx")).sessionBridge);
$parcel$export(module.exports, "notFound", () => (parcelRequire("aGxtr")).notFound);

var $5RS66 = parcelRequire("5RS66");

var $1X0Je = parcelRequire("1X0Je");

var $kchJU = parcelRequire("kchJU");

var $bgOfo = parcelRequire("bgOfo");

var $7lWOZ = parcelRequire("7lWOZ");

var $iRHtA = parcelRequire("iRHtA");

var $3k2Ws = parcelRequire("3k2Ws");

var $c6sCx = parcelRequire("c6sCx");

var $aGxtr = parcelRequire("aGxtr");
const $3725627b77536685$export$54f63e0bb65a6adc = (0, $kchJU.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.signin), (el)=>({
        title: el.call('polyglot', 'canvas.page.signin.title')
    }));
const $3725627b77536685$export$7200a869094fec36 = (0, $kchJU.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.signup), (el)=>({
        title: el.call('polyglot', 'canvas.page.signup.title')
    }));
const $3725627b77536685$export$9c079914996cc79c = (0, $kchJU.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.signupConfirmation), (el)=>({
        title: el.call('polyglot', 'canvas.page.signupConfirmation.title')
    }));
const $3725627b77536685$export$dc726c8e334dd814 = (0, $kchJU.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.resetPassword), (el)=>({
        title: el.call('polyglot', 'canvas.page.resetPassword.title')
    }));
const $3725627b77536685$export$4fd09d08b607c3f1 = (0, $kchJU.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.waitlist), (el)=>({
        title: el.call('polyglot', 'canvas.page.waitlist.title')
    }));
const $3725627b77536685$export$4882ae973e0491e = (0, $kchJU.lazyPage)(()=>Promise.resolve((0, $1X0Je.default).pages.profile), (el)=>({
        title: el.call('polyglot', 'canvas.page.account.title')
    }));
const $3725627b77536685$export$d7e406d79a809aeb = {
    onRender: (el)=>{
        const ctx = el.context || {};
        const decide = ()=>{
            // after the boot the LIVE session decides (root._authReady): an
            // in-place sign-in or a soft sign-out (one-boot review D4)
            const st = el.state && (el.state.root || el.state);
            const live = st && st._authReady === true && typeof st.signedIn === 'boolean';
            const signedIn = typeof ctx.bootSignedIn === 'boolean' ? live ? st.signedIn : ctx.bootSignedIn : !!ctx.methods?.sdk?.getAuthToken?.();
            el.router(signedIn ? '/studio' : '/signin', el.getRoot());
        };
        if (typeof ctx.bootSignedIn !== 'boolean' && ctx.bootReady) return ctx.bootReady.then(decide);
        decide();
    }
};
const $3725627b77536685$export$4b49b685a3384339 = {
    onRender: (el)=>el.router('/', el.getRoot())
};
const $3725627b77536685$export$7d5b4a1b76e6c9ef = (0, $kchJU.lazyStudioDashboardPage)((el)=>({
        title: el.call('polyglot', 'canvas.page.dashboard.title')
    }));
const $3725627b77536685$export$f16cd9ed4c0e5dc3 = (0, $kchJU.lazyStudiosBoardPage)((el)=>({
        title: el.call('polyglot', 'canvas.page.workspaces.fallbackTitle')
    }));
const $3725627b77536685$export$3f35a7b711b00c13 = (0, $kchJU.lazyCanvasDashboardPage)({
    title: 'Canvas / Symbols.app'
});
var $3725627b77536685$export$2e2bcd8739ae039 = {
    '/': $3725627b77536685$export$d7e406d79a809aeb,
    '/dashboard': $3725627b77536685$export$4b49b685a3384339,
    '/account': (0, $iRHtA.account),
    // SETTINGS-IA-1 (tickets/sonnet.md) found the routing bug — the
    // avatar-menu "Settings" action (shared/functions/accountMenu.js
    // accountMenuAction) does a plain `this.router('/settings', …)`, and
    // canvas had no matching entry so the click fell through to the `/*`
    // catch-all (the project-canvas route). That bug was fixed by pointing
    // this entry at canvas's own self-contained account.js (workspace
    // 436b0772). It's since been superseded: MemberProfile (the shell's
    // fuller canonical account page — profile fields, availability, equity,
    // notifications, sessions, danger zone, language/timezone/avatar-upload)
    // moved into `shared` (tickets/opus.md, 2026-08-15 Nika ruling), so
    // canvas now reaches the SAME implementation the shell does instead of
    // maintaining a second, parallel one. account.js itself stays for now —
    // still reachable at /account.
    '/settings': $3725627b77536685$export$4882ae973e0491e,
    '/marketplace': (0, $3k2Ws.marketplace),
    '/_session-bridge': (0, $c6sCx.sessionBridge),
    // Bare `/studio` mounts the dashboard surface directly (the project picker) —
    // the canonical entry-point the nav link points at (#2212). lazySharedLibPage
    // (not lazyPage): the dashboard embeds the studios board (`StudiosEmbed: {}`)
    // and resolves studios-only components, so studios' 19 self-registered
    // components (its default export) must fold into the live context BEFORE the
    // dashboard mounts. Both the studios chunk (context) and the dashboard chunk
    // load on first /studio nav; the eager bundle carries neither (#11 Stage 2 —
    // studios' 19 components self-register via its default export on lazy load).
    '/studio': $3725627b77536685$export$7d5b4a1b76e6c9ef,
    // The studios board itself (project canvas). lazySharedLibPage folds studios'
    // component registry (default export) then mounts the `studios` board page, so
    // its childExtends 'ProjectNode' / 'IntegrationNode' / … resolve against the
    // now-populated context. The board's own dynamic metadata re-applies on mount;
    // this static title is the pre-resolve placeholder helmet shows.
    '/studio/*': $3725627b77536685$export$f16cd9ed4c0e5dc3,
    // /canvas — duplicate of the /studio dashboard surface. Same lazySharedLibPage
    // shape as /studio (folds the studios component registry so the embedded
    // StudiosEmbed board resolves); only the tab title diverges.
    // Pure product names — nothing in this title is translatable.
    '/canvas': $3725627b77536685$export$3f35a7b711b00c13,
    '/signin': $3725627b77536685$export$54f63e0bb65a6adc,
    '/signup': $3725627b77536685$export$7200a869094fec36,
    '/signup-confirmation': $3725627b77536685$export$9c079914996cc79c,
    '/reset-password': $3725627b77536685$export$dc726c8e334dd814,
    '/waitlist': $3725627b77536685$export$4fd09d08b607c3f1,
    '/404': (0, $aGxtr.notFound),
    '/*': (0, $5RS66.main)
};

});
parcelRegister("kchJU", function(module, exports) {

$parcel$export(module.exports, "lazyPage", () => $eb42b0521e567bc0$export$f0824772714954c5);
$parcel$export(module.exports, "lazyStudioDashboardPage", () => $eb42b0521e567bc0$export$b31d109a9269b5ec);
$parcel$export(module.exports, "lazyStudiosBoardPage", () => $eb42b0521e567bc0$export$c4939cc45cc39fc2);
$parcel$export(module.exports, "lazyCanvasDashboardPage", () => $eb42b0521e567bc0$export$1ccd0ea6509e8945);
// Route-based code-splitting helpers — LOCAL implementation, not a re-export.
//
// The canonical logic lives in `@symbo-ls/workspace-shared/pages/lazyPage.js`
// (full usage docs + the detached-node-race rationale are there). This
// package used to read `_wsShared.pages.X` directly at module scope (auth
// pages) or delegate a whole call through `_wsShared.pages.lazySharedLibPage(
// ...args) : ''` (the /studio, /studio/*, /canvas routes) — both are
// stub-phantom-values under frank's publish serializer: ANY top-level value
// that is a property read off, or the RESULT OF CALLING a function obtained
// through, a stubbed `@symbo-ls/*` import is tainted, even when the loader
// argument is this project's own code (WS-SHARED-LAZYPAGE-HOLLOW-ROUTES-SWITCH-1,
// same defect class fixed for workspace-shell + marketplace; this file closes
// the canvas half, WS-CANVAS-HOLLOW-SHARED-PAGES-BLOCK-PUSH-1). Frank's own
// test proves the fix shape
// (smbls/plugins/frank/__tests__/stubPhantomValueGate.test.js test (ix)): a
// route value must be a LOCAL object literal, defined in this project's own
// source, whose `onCreate` dynamic-`import()`s (or resolves) the shared page
// at RUNTIME — never a property read or a call routed through an external
// stub at module-eval time. So this file carries the real implementation
// locally instead of delegating, mirroring workspace-shell's and
// marketplace's `pages/lazyPage.js` byte-for-byte.
const $eb42b0521e567bc0$export$8b6a79f7f2463a89 = (root, lib)=>{
    const ctx = root.context;
    if (lib?.components && ctx?.components) {
        for(const k in lib.components)if (!ctx.components[k]) ctx.components[k] = lib.components[k];
    }
    if (lib?.functions && ctx?.functions) {
        for(const k in lib.functions)if (!ctx.functions[k]) ctx.functions[k] = lib.functions[k];
    }
    if (lib?.state) {
        const seed = {};
        for(const k in lib.state)if (root[k] === undefined) seed[k] = lib.state[k];
        if (Object.keys(seed).length) root.update?.(seed);
    }
};
const $eb42b0521e567bc0$export$604000340aeeb4dd = (def, host)=>{
    if (!def || typeof def !== 'object' || !host) return def;
    let held = host.role === 'main';
    for(let p = host.parent, i = 0; !held && p && i < 4; p = p.parent, i++)if (p._slotPaneKey) held = true;
    if (!held) return def;
    const own = {};
    if (def.tag === 'main') own.tag = 'div';
    if (def.role === 'main') own.role = null;
    if (def.id === 'main-content') own.id = null;
    if (def.attr && typeof def.attr === 'object' && def.attr.id === 'main-content') own.attr = {
        ...def.attr,
        id: null
    };
    return {
        ...def,
        ...own
    };
};
const $eb42b0521e567bc0$export$f0824772714954c5 = (loader, metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        // Factory-closure capture (FA205) — `loader` is a parameter of this
        // factory: a closure doesn't survive frank's serialization step, so a
        // published route with no `scope:` here reads a guaranteed-undefined
        // loader and no-ops instead of rendering
        // (WS-CANVAS-LAZYPAGE-SCOPE-LOADER-UNDEFINED-1). `scope: { loader }`
        // travels the value with the emitted page. Read it as `el.scope.loader`
        // explicitly, never a bare `loader()` — `element.scope` is populated by
        // DOMQL's own element constructor for EVERY element with a declared
        // `scope:` (smbls/packages/element/src/create.js, unconditional, dev and
        // published alike), so this is the one form guaranteed to resolve both
        // ways; frank's bare-identifier rewrite to `__scope.loader` is a build-time
        // heuristic that measurably does not fire on every pass over this file.
        scope: {
            loader: loader
        },
        onCreate: async (el)=>{
            if (el.__lazyLoaded) return;
            el.__lazyLoaded = true;
            // Late-resolve guard: the loader can resolve after the router (or the
            // AppWindow PageSlot) navigated away and DISPOSED this placeholder —
            // dispose() clears el.__ref (and el.node); never swap then. NOT
            // connected YET is not gone: smbls 3.14.84x builds an app's whole first
            // view detached and attaches it in one insertion (firstRender), and the
            // old `!el.node.isConnected` guard read that as gone and left the route
            // on its skeleton (the workspace shell's signed-out /login, 2026-10-21).
            // el.whenConnected swaps now when connected, else in the task that
            // inserts the node, and never for a disposed element.
            const _place = (def)=>{
                if (!el.__ref) return;
                if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
                else el.set(def);
            };
            try {
                const page = await el.scope.loader();
                if (!page) throw new Error('loader resolved empty');
                _place($eb42b0521e567bc0$export$604000340aeeb4dd({
                    ...page,
                    height: '100%',
                    minHeight: '100%'
                }, el));
            } catch (err) {
                console.error('[lazyPage] failed to load route module:', err && err.message);
                _place({
                    tag: 'div',
                    padding: 'B',
                    color: 'caption',
                    text: '{{ canvas.lazyPage.loadFailed | polyglot }}'
                });
            }
        }
    });
const $eb42b0521e567bc0$export$c6a50505b6cc05a = async (el, ctxPromise, pagePromise)=>{
    // The late-resolve guard of lazyPage above (disposed → never; not
    // attached yet → when it is).
    const _place = (def)=>{
        if (!el.__ref) return;
        if (typeof el.whenConnected === 'function') el.whenConnected(()=>el.set(def));
        else el.set(def);
    };
    try {
        const mod = await ctxPromise;
        const lib = mod && mod.default ? mod.default : mod;
        const root = el.getRoot?.() || el;
        $eb42b0521e567bc0$export$8b6a79f7f2463a89(root, lib);
        const page = await pagePromise;
        if (!page) throw new Error('page loader resolved empty');
        _place($eb42b0521e567bc0$export$604000340aeeb4dd({
            ...page,
            height: '100%',
            minHeight: '100%'
        }, el));
    } catch (err) {
        console.error('[lazySharedLibPage] load failed:', err && err.message);
        _place({
            tag: 'div',
            padding: 'B',
            color: 'caption',
            text: '{{ canvas.lazyPage.loadFailed | polyglot }}'
        });
    }
};



const $eb42b0521e567bc0$export$b31d109a9269b5ec = (metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        onCreate: (el)=>{
            if (el.__lazyLibPageLoaded) return;
            el.__lazyLibPageLoaded = true;
            return $eb42b0521e567bc0$export$c6a50505b6cc05a(el, Promise.all([
                (parcelRequire("3lR5Z")),
                (parcelRequire("kLMVv"))
            ]).then(([m, f])=>({
                    components: m.studiosContext.components,
                    functions: {
                        ...f
                    }
                })), (parcelRequire("iuCDG")).then((m)=>m.dashboard));
        }
    });



const $eb42b0521e567bc0$export$c4939cc45cc39fc2 = (metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        onCreate: (el)=>{
            if (el.__lazyLibPageLoaded) return;
            el.__lazyLibPageLoaded = true;
            return $eb42b0521e567bc0$export$c6a50505b6cc05a(el, Promise.all([
                (parcelRequire("3lR5Z")),
                (parcelRequire("kLMVv"))
            ]).then(([m, f])=>({
                    components: m.studiosContext.components,
                    functions: {
                        ...f
                    }
                })), (parcelRequire("3lR5Z")).then((m)=>m.studios));
        }
    });



const $eb42b0521e567bc0$export$1ccd0ea6509e8945 = (metadata)=>({
        height: '100%',
        minHeight: '100%',
        metadata: metadata,
        onCreate: (el)=>{
            if (el.__lazyLibPageLoaded) return;
            el.__lazyLibPageLoaded = true;
            return $eb42b0521e567bc0$export$c6a50505b6cc05a(el, Promise.all([
                (parcelRequire("3lR5Z")),
                (parcelRequire("kLMVv"))
            ]).then(([m, f])=>({
                    components: m.studiosContext.components,
                    functions: {
                        ...f
                    }
                })), (parcelRequire("iuCDG")).then((m)=>({
                    ...m.dashboard,
                    metadata: {
                        title: 'Canvas / Symbols.app'
                    }
                })));
        }
    });

});

parcelRegister("iRHtA", function(module, exports) {

$parcel$export(module.exports, "account", () => $dbbee6b59843ad7e$export$6b501c78a3684162);
parcelRequire("lUr30");
var $1NxyO = parcelRequire("1NxyO");
var $lUr30 = parcelRequire("lUr30");
async function $dbbee6b59843ad7e$var$loadProfile(root) {
    try {
        const profile = await (0, $lUr30.getUserProfileCached)();
        root.update({
            accountProfile: profile || null,
            accountError: null,
            accountLoading: false
        });
    } catch (err) {
        root.update({
            accountProfile: null,
            accountError: err?.message || 'Failed to load profile',
            accountLoading: false
        });
    }
}
async function $dbbee6b59843ad7e$var$saveProfile(root) {
    const { accountDraft: accountDraft } = root;
    if (!accountDraft) return;
    root.update({
        accountSaving: true,
        accountSaveError: null,
        accountSaveOk: false
    });
    try {
        const sdk = (0, $1NxyO.getSDK)();
        await sdk.updateUser?.({
            name: accountDraft.name,
            email: accountDraft.email
        });
        (0, $lUr30.invalidateUserDataCache)?.();
        root.update({
            accountSaving: false,
            accountSaveOk: true,
            accountProfile: {
                ...root.accountProfile || {},
                ...accountDraft
            }
        });
        // Clear success banner after 3 s
        setTimeout(()=>root.update({
                accountSaveOk: false
            }), 3000);
    } catch (err) {
        root.update({
            accountSaving: false,
            accountSaveError: err?.message || 'canvas.account.saveFailed'
        });
    }
}
async function $dbbee6b59843ad7e$var$changePassword(root) {
    const { accountCurrentPassword: accountCurrentPassword, accountNewPassword: accountNewPassword } = root;
    if (!accountCurrentPassword || !accountNewPassword) return;
    root.update({
        passwordSaving: true,
        passwordError: null,
        passwordOk: false
    });
    try {
        const sdk = (0, $1NxyO.getSDK)();
        await sdk.updatePassword?.({
            currentPassword: accountCurrentPassword,
            newPassword: accountNewPassword
        });
        root.update({
            passwordSaving: false,
            passwordOk: true,
            accountCurrentPassword: '',
            accountNewPassword: ''
        });
        setTimeout(()=>root.update({
                passwordOk: false
            }), 3000);
    } catch (err) {
        root.update({
            passwordSaving: false,
            passwordError: err?.message || 'canvas.account.passwordFailed'
        });
    }
}
const $dbbee6b59843ad7e$var$fieldRow = (labelText, inputConfig)=>{
    const inputId = inputConfig.id || 'account-' + (inputConfig.autocomplete || labelText).replace(/\s+/g, '-').replace(/[^a-z0-9-]/gi, '').toLowerCase();
    return {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'label',
            text: labelText,
            fontSize: 'Z',
            color: 'caption',
            fontWeight: '500',
            attr: {
                for: inputId
            }
        },
        Input: {
            tag: 'input',
            id: inputId,
            theme: 'field',
            minHeight: 'controlH',
            padding: '0 Z2',
            round: 'radiusControl',
            border: 'hairline solid line',
            color: 'title',
            fontSize: 'Z2',
            width: '100%',
            ...inputConfig
        }
    };
};
const $dbbee6b59843ad7e$export$6b501c78a3684162 = {
    tag: 'main',
    id: 'main-content',
    extends: 'Flex',
    flow: 'y',
    align: 'start center',
    // Single `1fr` shell row — `gridRow: '1'` fills the content track; the legacy
    // `'2'` strands the page in an implicit 0-height row 2. See main.js.
    gridRow: '1',
    gridColumn: '1 / -1',
    minHeight: '0',
    height: '100%',
    overflowY: 'auto',
    background: 'document',
    padding: 'D C',
    metadata: (el)=>({
            title: el.call('polyglot', 'canvas.page.account.title')
        }),
    onRender: (el, s)=>{
        if (el.__accountLoaded) return;
        el.__accountLoaded = true;
        const root = s.root || s;
        const sdk = (0, $1NxyO.getSDK)();
        const token = sdk?.getAuthToken?.();
        if (!token) {
            el.router('/signin', el.getRoot());
            return;
        }
        root.update({
            accountLoading: true
        });
        $dbbee6b59843ad7e$var$loadProfile(root);
    },
    Container: {
        flow: 'y',
        gap: 'C',
        width: '100%',
        maxWidth: '540px',
        TopBar: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Y',
            BackBtn: {
                tag: 'button',
                type: 'button',
                minHeight: 'controlHCompact',
                padding: '0 Z',
                round: 'radiusPill',
                border: '0',
                background: 'overlay',
                color: 'caption',
                fontSize: 'Z',
                cursor: 'pointer',
                ':hover': {
                    background: 'selected',
                    color: 'title'
                },
                text: '{{ canvas.account.backToDashboard | polyglot }}',
                onClick: (e, el, s)=>el.router('/', el.getRoot())
            }
        },
        PageHeading: {
            flow: 'y',
            gap: 'V',
            H1: {
                // One title per host (workspace design-direction.md §3): "Account" is
                // the PageSlot pane bar word for word, so the heading yields under
                // one. The subtitle says more and stays.
                hide: (el, s)=>el.call('paneTitleBarShown', s),
                tag: 'h1',
                text: '{{ canvas.account.heading | polyglot }}',
                fontSize: 'C',
                fontWeight: '700',
                margin: '0',
                color: 'title',
                letterSpacing: '-0.02em'
            },
            Subtitle: {
                tag: 'p',
                text: '{{ canvas.account.subtitle | polyglot }}',
                fontSize: 'Z1',
                color: 'caption',
                margin: '0'
            }
        },
        LoadingState: {
            if: (el, s)=>!!s.root?.accountLoading,
            flow: 'y',
            gap: 'Z',
            width: '100%',
            Row_1: {
                extends: 'SkeletonRow',
                width: '40%'
            },
            Row_2: {
                extends: 'SkeletonRow',
                width: '100%'
            },
            Row_3: {
                extends: 'SkeletonRow',
                width: '70%'
            }
        },
        ErrorState: {
            if: (el, s)=>!!s.root?.accountError && !s.root?.accountLoading,
            tag: 'p',
            // Key-in-state — see accountSaveError below.
            text: (el, s)=>s.root?.accountError ? el.call('polyglot', s.root.accountError) : '',
            color: 'red',
            fontSize: 'Z'
        },
        ProfileSection: {
            if: (el, s)=>!!s.root?.accountProfile && !s.root?.accountLoading,
            flow: 'y',
            gap: 'B',
            padding: 'B',
            round: 'radiusCard',
            border: 'hairline solid line',
            background: 'overlay',
            ProfileSectionTitle: {
                tag: 'h2',
                text: '{{ canvas.account.profileSection | polyglot }}',
                fontSize: 'A',
                fontWeight: '700',
                margin: '0',
                color: 'title'
            },
            NameRow: {
                ...$dbbee6b59843ad7e$var$fieldRow('{{ canvas.account.fullName | polyglot }}', {
                    type: 'text',
                    autocomplete: 'name',
                    placeholder: (el)=>el.call('polyglot', 'canvas.account.fullNamePlaceholder'),
                    'aria-label': (el)=>el.call('polyglot', 'canvas.account.fullName'),
                    value: (el, s)=>s.root?.accountDraft?.name ?? s.root?.accountProfile?.name ?? '',
                    onInput: (e, el, s)=>{
                        const root = s.root || s;
                        const draft = root.accountDraft || {
                            ...root.accountProfile
                        };
                        root.update({
                            accountDraft: {
                                ...draft,
                                name: e.target.value
                            }
                        });
                    }
                })
            },
            EmailRow: {
                ...$dbbee6b59843ad7e$var$fieldRow('{{ canvas.account.emailAddress | polyglot }}', {
                    type: 'email',
                    autocomplete: 'email',
                    // An example address, not copy — glossary rule 6 (source formatting).
                    placeholder: 'you@example.com',
                    'aria-label': (el)=>el.call('polyglot', 'canvas.account.emailAddress'),
                    value: (el, s)=>s.root?.accountDraft?.email ?? s.root?.accountProfile?.email ?? '',
                    onInput: (e, el, s)=>{
                        const root = s.root || s;
                        const draft = root.accountDraft || {
                            ...root.accountProfile
                        };
                        root.update({
                            accountDraft: {
                                ...draft,
                                email: e.target.value
                            }
                        });
                    }
                })
            },
            SaveFeedback: {
                if: (el, s)=>!!s.root?.accountSaveOk,
                tag: 'p',
                text: '{{ canvas.account.changesSaved | polyglot }}',
                color: 'green',
                fontSize: 'Z',
                margin: '0',
                role: 'status'
            },
            SaveError: {
                if: (el, s)=>!!s.root?.accountSaveError,
                tag: 'p',
                // Key-in-state — a raw SDK message passes through polyglot unchanged.
                text: (el, s)=>s.root?.accountSaveError ? el.call('polyglot', s.root.accountSaveError) : '',
                color: 'red',
                fontSize: 'Z',
                margin: '0',
                role: 'alert'
            },
            SaveBtn: {
                tag: 'button',
                type: 'submit',
                text: (el, s)=>el.call('polyglot', s.root?.accountSaving ? 'canvas.account.saving' : 'canvas.account.saveChanges'),
                minHeight: 'controlH',
                // §8.4 width floor — 'Saving…' must not resize the button mid-save.
                minWidth: 'E1',
                padding: '0 A',
                round: 'radiusPill',
                border: '0',
                // §1/§6.2 primary = ink capsule (21:1 both themes). White-on-blue
                // measured 3.62:1 — under the 4.5 small-text floor (2026-08-08 walk).
                background: 'highlight',
                color: 'highlight-reversed',
                fontSize: 'Z2',
                fontWeight: '700',
                cursor: 'pointer',
                alignSelf: 'start',
                ':hover': {
                    background: 'blue+8'
                },
                disabled: (el, s)=>!!s.root?.accountSaving,
                onClick: (e, el, s)=>$dbbee6b59843ad7e$var$saveProfile(s.root || s)
            }
        },
        PasswordSection: {
            if: (el, s)=>!!s.root?.accountProfile && !s.root?.accountLoading,
            flow: 'y',
            gap: 'B',
            padding: 'B',
            round: 'radiusCard',
            border: 'hairline solid line',
            background: 'overlay',
            PasswordSectionTitle: {
                tag: 'h2',
                text: '{{ canvas.account.passwordSection | polyglot }}',
                fontSize: 'A',
                fontWeight: '700',
                margin: '0',
                color: 'title'
            },
            CurrentPasswordRow: {
                ...$dbbee6b59843ad7e$var$fieldRow('{{ canvas.account.currentPassword | polyglot }}', {
                    type: 'password',
                    autocomplete: 'current-password',
                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                    'aria-label': (el)=>el.call('polyglot', 'canvas.account.currentPassword'),
                    value: (el, s)=>s.root?.accountCurrentPassword || '',
                    onInput: (e, el, s)=>(s.root || s).update({
                            accountCurrentPassword: e.target.value
                        })
                })
            },
            NewPasswordRow: {
                ...$dbbee6b59843ad7e$var$fieldRow('{{ canvas.account.newPassword | polyglot }}', {
                    type: 'password',
                    autocomplete: 'new-password',
                    placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                    'aria-label': (el)=>el.call('polyglot', 'canvas.account.newPassword'),
                    value: (el, s)=>s.root?.accountNewPassword || '',
                    onInput: (e, el, s)=>(s.root || s).update({
                            accountNewPassword: e.target.value
                        })
                })
            },
            PasswordFeedback: {
                if: (el, s)=>!!s.root?.passwordOk,
                tag: 'p',
                text: '{{ canvas.account.passwordUpdated | polyglot }}',
                color: 'green',
                fontSize: 'Z',
                margin: '0',
                role: 'status'
            },
            PasswordError: {
                if: (el, s)=>!!s.root?.passwordError,
                tag: 'p',
                // Key-in-state — see accountSaveError above.
                text: (el, s)=>s.root?.passwordError ? el.call('polyglot', s.root.passwordError) : '',
                color: 'red',
                fontSize: 'Z',
                margin: '0',
                role: 'alert'
            },
            PasswordBtn: {
                tag: 'button',
                type: 'submit',
                text: (el, s)=>el.call('polyglot', s.root?.passwordSaving ? 'canvas.account.updating' : 'canvas.account.updatePassword'),
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                border: 'hairline solid line',
                background: 'overlay',
                color: 'title',
                fontSize: 'Z2',
                fontWeight: '500',
                cursor: 'pointer',
                alignSelf: 'start',
                ':hover': {
                    background: 'selected'
                },
                disabled: (el, s)=>!!s.root?.passwordSaving,
                onClick: (e, el, s)=>$dbbee6b59843ad7e$var$changePassword(s.root || s)
            }
        },
        SignOutSection: {
            if: (el, s)=>!!s.root?.accountProfile && !s.root?.accountLoading,
            flow: 'y',
            gap: 'B',
            padding: 'B',
            round: 'radiusCard',
            border: 'hairline solid line',
            background: 'overlay',
            SignOutTitle: {
                tag: 'h2',
                text: '{{ canvas.account.signOutSection | polyglot }}',
                fontSize: 'A',
                fontWeight: '700',
                margin: '0',
                color: 'title'
            },
            SignOutHint: {
                tag: 'p',
                text: '{{ canvas.account.signOutHint | polyglot }}',
                fontSize: 'Z',
                color: 'caption',
                margin: '0'
            },
            SignOutBtn: {
                tag: 'button',
                type: 'button',
                text: '{{ canvas.account.signOut | polyglot }}',
                minHeight: 'controlH',
                padding: '0 A',
                round: 'radiusPill',
                border: 'hairline solid line',
                background: 'transparent',
                color: 'title',
                fontSize: 'Z2',
                fontWeight: '500',
                cursor: 'pointer',
                alignSelf: 'start',
                ':hover': {
                    background: 'hover',
                    color: 'red'
                },
                onClick: (e, el, s)=>{
                    const sdk = (0, $1NxyO.getSDK)();
                    sdk?.logout?.();
                    el.router('/signin', el.getRoot());
                }
            }
        }
    }
};

});

parcelRegister("3k2Ws", function(module, exports) {

$parcel$export(module.exports, "marketplace", () => $26b5858a69036a25$export$be74dea0232279db);
// Canvas marketplace page — mounts the real `MarketplaceIsland`, the same
// self-contained unit the standalone `marketplace.localhost` app
// (marketplace/pages/main.js) and the public `symbols.app/marketplace`
// landing pages (company/packages/landing + no-code-landing) mount, wrapped
// in the same AppSidebar + AppMain chrome as /dashboard so the layout stays
// consistent across canvas routes.
//
// WS-APPS ticket (tickets/workspace.md "marketplace canvas fork drift"):
// this page used to hand-fork Island's composition — its own state shape
// (missing signinModal/_signedIn/_installScopeOpen/gallery+template-view
// state, missing live-catalog + installed/sort/recent/density/pinned
// localStorage hydration) and its own legacy MarketplaceGrid +
// MarketplaceDetail side-panel layout instead of Island's per-kind section
// grid + MarketplaceDetailModal overlay — so every new kind/section
// (Templates/Libraries/Integrations/Prompts/Agents/Skills, the Workspace
// Apps headline rail, the "Featured today" strip, …) had to be added
// twice. Island already sets its own `_marketplaceHost: true` and owns its
// full state + hydration + URL-sync + Esc-handling internally (see
// MarketplaceIsland.js's own doc comment + `onCreate`/`onUpdate`), so
// mounting it bare here satisfies its state contract with zero extra wiring
// — exactly the pattern `marketplace/pages/main.js` and the landing
// `/marketplace` pages already use. One edit (Island) now reaches every
// surface, canvas included.
//
// Deep-link filters (`?kind=…&categories=…&q=…&sort=…&pricing=…&item=…`)
// keep working via Island's own `hydrateFiltersFromLocation` +
// `bindPopstateFilters` + `writeFiltersToUrl` (marketplace/functions/index.js)
// — all three read/write `window.location` directly, so they behave
// identically whether canvas's pushState patch fired or not (this page no
// longer needs its own `currentSearch`-reading fork of that logic).
const $26b5858a69036a25$export$be74dea0232279db = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    metadata: (el)=>({
            title: el.call('polyglot', 'canvas.page.marketplace.title')
        }),
    // Single `1fr` shell row — `gridRow: '1'` fills the content track; the legacy
    // `'2'` strands the page in an implicit 0-height row 2. See main.js.
    gridRow: '1',
    gridColumn: '1 / -1',
    minHeight: '0',
    height: '100%',
    overflow: 'hidden',
    color: 'title',
    // Marketplace sidebar removed — its kind / pinned / recent groups live
    // in Island's own top filter row (MarketplaceFilters).
    AppSidebar: null,
    AppMain: {
        padding: '0',
        overflow: 'hidden',
        minHeight: '0',
        Body: {
            padding: '0',
            overflow: 'hidden',
            // Bare mount — Island supplies its own state defaults, sizing
            // (flex:'1', width/height:'100%', minHeight:'0', overflowY:'auto')
            // and `_marketplaceHost: true` flag, so `marketplaceHostOf` binds
            // every marketplace component to the Island, not canvas's app root.
            MarketplaceIsland: {}
        }
    }
};

});

parcelRegister("c6sCx", function(module, exports) {

$parcel$export(module.exports, "sessionBridge", () => $8cfc3f00424b79c6$export$11ed4ec5dc76a106);
// Canvas-side postMessage endpoint. Lets peer Symbols origins iframe
// this page and read the SDK tokens held in canvas's localStorage so a
// user signed in on canvas doesn't have to sign in again on workspace /
// marketplace / preview. Whitelisted origins only; page has no UI.
// Imported through the shared package's DISCOVERED BAG, not as a named
// import from a deep file path. A named deep import emits as an
// `import_crossAppAuth.collectSdkTokens` alias that frank's emitted
// `onRender` cannot resolve (unresolvable-identifier — a guaranteed
// ReferenceError in the published payload). frank rewrites the bag import
// inside a handler into a runtime lookup of the shared package — the same
// idiom the workspace shell's own session-bridge page uses.

var $1X0Je = parcelRequire("1X0Je");
const $8cfc3f00424b79c6$export$11ed4ec5dc76a106 = {
    metadata: (el)=>({
            title: el.call('polyglot', 'canvas.page.sessionBridge.title')
        }),
    // Fixed near-black regardless of theme — this is a headless postMessage
    // bridge with no visible UI (mirrors the workspace-side session-bridge).
    background: '#0f1116',
    // Raw rgba(255,255,255,0.35) measured 3.20:1 on this ground (needs 4.5) —
    // fable.md AA sweep. white.55 clears the floor with real margin (~6.22:1,
    // matching the sibling workspace-side session-bridge fix) while staying
    // visibly dimmer than a normal caption.
    color: 'white.55',
    fontFamily: 'system-ui',
    fontSize: 'Z2',
    padding: 'A',
    text: '{{ canvas.sessionBridge.body | polyglot }}',
    // The handshake listener is DECLARED, not armed imperatively (FA503).
    // It used to be a `window.addEventListener('message', …)` fired from
    // `onRender` behind an `el.__bridgeInit` latch with no removal anywhere —
    // so every mount of this page added one more permanent window listener,
    // each holding this element (and its whole subtree) reachable from
    // `window` forever. DOMQL registers this once when the element takes its
    // node and tears it down in dispose(); the latch is gone with it.
    //
    // The registration moved; the POLICY did not, and it lives in ONE place —
    // shared functions/sessionBridgeResponder.js, which the workspace shell's
    // page and its light bridge entry answer with too: a foreign origin is
    // rejected before anything is read, a message of the wrong type is ignored,
    // and the answer is the ACCESS token + expiry only, never the refresh token
    // (the server rotates refresh tokens, so a copy on the peer origin signed one
    // of the two origins out on every rotation). The SDK (when this page has
    // one) is reached only when this origin's own token must rotate first, so
    // the peer never gets a dying token.
    onWindowMessage: (ev, el)=>(0, $1X0Je.default).functions.answerSessionBridgeRequest(ev, {
            getSdk: ()=>el?.call?.('getSDK')
        }),
    onRender: (el)=>{
        if (el.__bridgeReady) return;
        el.__bridgeReady = true;
        // Parent waits for this before sending its request so the handshake
        // can't race a listener that armed after postMessage. The declared
        // `onWindowMessage` above registers with the element's node — which the
        // framework takes BEFORE it runs onRender — so the listener is already
        // live when this ready-ping goes out.
        (0, $1X0Je.default).functions.announceSessionBridgeReady();
    }
};

});

parcelRegister("aGxtr", function(module, exports) {

$parcel$export(module.exports, "notFound", () => $7c77cad40cc4d3f0$export$a33e918cb4258370);

const $7c77cad40cc4d3f0$export$a33e918cb4258370 = {
    tag: 'main',
    id: 'main-content',
    extends: 'AppPage',
    flow: 'y',
    // Installed workspace APPS inject their pages after boot, so this page is
    // rendered first for any app route and then replaced once the module lands
    // (_rerouteIfStranded). Stamping "Not found" into the tab title during that
    // window makes a perfectly good app look broken while it loads — the title
    // flashed "Not found" on every cold load of an installed app's route.
    // A neutral title while apps are still activating; the real one only once
    // the route is genuinely unresolvable.
    //
    // The BODY needs the same treatment, not just the title. Gating the tab
    // stopped the browser tab from lying while the page still shouted "404 —
    // Page not found" at a route that was merely still loading, which is the
    // "sometimes it does not render" report. Below: the status code and the
    // recovery actions hide while activation is in flight, and the copy says
    // what is actually happening.
    //
    // `hide:` and `text:` on purpose — the two mechanisms that re-fire reliably
    // here. A state-driven STYLE prop would not (see tickets/smbls.md,
    // "css-in-props: a state-driven style prop is silently one-shot"), and `if:`
    // creates the element in an update pass, where it can miss its lifecycle.
    metadata: (el, s)=>s.root && s.root._wsAppsActivating ? {
            title: 'Symbols'
        } // the product name
         : {
            title: el.call('polyglot', 'canvas.page.notFound.title')
        },
    align: 'center center',
    height: '100%',
    width: '100%',
    padding: 'C',
    color: 'title',
    textAlign: 'center',
    gap: 'A',
    StatusCode: {
        tag: 'h1',
        hide: (el, s)=>!!s.root?._wsAppsActivating,
        text: (el, s)=>String(s.root?.notFoundStatus || 404),
        fontSize: 'E',
        fontWeight: '700',
        letterSpacing: '-0.04em',
        margin: '0',
        color: 'title'
    },
    // §9: "Loading…" strings are illegal. This is the legal full-surface
    // indeterminate case (waiting on a workspace app module to activate) —
    // the house Spinner replaces the retired text. Key matches the extended
    // component (Rule: key-based auto-extend) so no `extends:` is needed.
    LoadingSpinner: {
        hide: (el, s)=>!s.root?._wsAppsActivating,
        boxSize: 'iconXl'
    },
    Title: {
        tag: 'h2',
        hide: (el, s)=>!!s.root?._wsAppsActivating,
        text: (el, s)=>s.root?.notFoundTitle || 'Page not found',
        fontSize: 'B',
        fontWeight: '700',
        margin: '0',
        color: 'title'
    },
    Message: {
        tag: 'p',
        text: (el, s)=>s.root?._wsAppsActivating ? 'Opening this workspace app.' : s.root?.notFoundMessage || "The page you're looking for doesn't exist. It may have been moved or the URL may be incorrect.",
        maxWidth: 'I',
        margin: '0 auto',
        color: 'caption',
        fontSize: 'Z1',
        lineHeight: '1.5em'
    },
    Actions: {
        // Offering "Back to dashboard" mid-load invites the user to leave a page
        // that was about to work.
        hide: (el, s)=>!!s.root?._wsAppsActivating,
        flow: 'x',
        gap: 'Y',
        align: 'center',
        marginTop: 'A',
        // Shown only when the blocker is auth — the recovery is to sign in.
        SignIn: {
            extends: 'Button',
            if: (el, s)=>s.root?.notFoundStatus === 401,
            text: '{{ canvas.notFound.signIn | polyglot }}',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            border: '0',
            background: 'brand',
            color: 'title',
            ':hover': {
                background: 'brand+10'
            },
            onClick: (e, el)=>el.router('/signin', el.getRoot())
        },
        // Shown for any retryable error (5xx, 429, network). SPA-RELOAD-1: this
        // used to call `reloadPage` (a raw `window.location.reload()`), which tore
        // down the whole workspace shell — every loaded app module, the editor
        // graph and the session-scoped state — to re-issue ONE project fetch that
        // `ensureProjectLoaded` can re-issue in place. Clearing `projectNotFound`
        // first swaps this page out for the canvas loading chrome; a second
        // failure re-sets it from the loader's own error classification.
        Retry: {
            extends: 'Button',
            if: (el, s)=>{
                const code = s.root?.notFoundStatus;
                return code === 429 || code >= 500 && code < 600;
            },
            text: '{{ canvas.notFound.retry | polyglot }}',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            cursor: 'pointer',
            border: '0',
            background: 'overlayStrong',
            color: 'title',
            ':hover': {
                background: 'hover'
            },
            // `ensureProjectLoaded` lives in the canvas EDITOR's function graph,
            // which the workspace shell deliberately does not register (it imports
            // the slim `functions/eagerSlice.js`). `el.call` on a missing function
            // silently no-ops, so mirror pages/main.js's on-demand import fallback
            // rather than a static import — this page IS in the eager chunk.
            onClick: (e, el, s)=>{
                if (s.root && typeof s.root.update === 'function') s.root.update({
                    projectNotFound: null
                });
                if (typeof el.context?.functions?.ensureProjectLoaded === 'function') return el.call('ensureProjectLoaded', el, s, {
                    force: true
                });
                return (parcelRequire("ksjMK")).then((m)=>m.ensureProjectLoaded(el, s, {
                        force: true
                    })).catch((err)=>console.warn('[canvas] project loader unavailable:', err?.message || err));
            }
        },
        Back: {
            extends: 'Link',
            href: '/',
            text: '{{ canvas.notFound.backToDashboard | polyglot }}',
            display: 'inline-flex',
            align: 'center center',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            cursor: 'pointer',
            border: '0',
            background: 'overlayStrong',
            color: 'title',
            ':hover': {
                background: 'hover'
            }
        }
    }
};

});


parcelRegister("a1kes", function(module, exports) {

$parcel$export(module.exports, "AdminSidebar", () => (parcelRequire("36JmD")).AdminSidebar);
$parcel$export(module.exports, "AdminSidebarGroup", () => (parcelRequire("36JmD")).AdminSidebarGroup);
$parcel$export(module.exports, "AdminSidebarLinks", () => (parcelRequire("36JmD")).AdminSidebarLinks);
$parcel$export(module.exports, "AdminSidebarLink", () => (parcelRequire("36JmD")).AdminSidebarLink);
$parcel$export(module.exports, "AdminUserGroupHeader", () => (parcelRequire("36JmD")).AdminUserGroupHeader);
$parcel$export(module.exports, "AdminUserRow", () => (parcelRequire("36JmD")).AdminUserRow);
$parcel$export(module.exports, "AdminActivityScoringRow", () => (parcelRequire("36JmD")).AdminActivityScoringRow);
$parcel$export(module.exports, "AdminLogDay", () => (parcelRequire("36JmD")).AdminLogDay);
$parcel$export(module.exports, "AdminLogGroup", () => (parcelRequire("36JmD")).AdminLogGroup);
$parcel$export(module.exports, "AdminLogRow", () => (parcelRequire("36JmD")).AdminLogRow);
$parcel$export(module.exports, "AdminLogCalendar", () => (parcelRequire("36JmD")).AdminLogCalendar);
$parcel$export(module.exports, "AdminLogCalendarCell", () => (parcelRequire("36JmD")).AdminLogCalendarCell);
$parcel$export(module.exports, "AttrMemberRow", () => (parcelRequire("36JmD")).AttrMemberRow);
$parcel$export(module.exports, "AttrMachineChip", () => (parcelRequire("36JmD")).AttrMachineChip);
$parcel$export(module.exports, "AdminLedgerRow", () => (parcelRequire("36JmD")).AdminLedgerRow);
$parcel$export(module.exports, "AdminUsageRow", () => (parcelRequire("36JmD")).AdminUsageRow);
$parcel$export(module.exports, "_shortDate", () => (parcelRequire("36JmD"))._shortDate);
$parcel$export(module.exports, "_dayKey", () => (parcelRequire("36JmD"))._shellDayKey);
$parcel$export(module.exports, "_isRowDirty", () => (parcelRequire("36JmD"))._isRowDirty);
$parcel$export(module.exports, "_fmtCredits", () => (parcelRequire("36JmD"))._fmtCredits);
$parcel$export(module.exports, "_fmtCreditsUnit", () => (parcelRequire("36JmD"))._fmtCreditsUnit);
$parcel$export(module.exports, "_humanizeSystemCause", () => (parcelRequire("36JmD"))._humanizeSystemCause);
$parcel$export(module.exports, "_fmtDateOnly", () => (parcelRequire("36JmD"))._fmtDateOnly);
$parcel$export(module.exports, "_attrMembers", () => (parcelRequire("36JmD"))._attrMembers);
$parcel$export(module.exports, "_attrSystem", () => (parcelRequire("36JmD"))._attrSystem);
$parcel$export(module.exports, "_attrMachines", () => (parcelRequire("36JmD"))._attrMachines);
$parcel$export(module.exports, "_attrUnattributed", () => (parcelRequire("36JmD"))._attrUnattributed);
$parcel$export(module.exports, "_attrTotal", () => (parcelRequire("36JmD"))._attrTotal);
$parcel$export(module.exports, "_humanizeKey", () => (parcelRequire("36JmD"))._humanizeKey);
$parcel$export(module.exports, "_tierPerks", () => (parcelRequire("36JmD"))._tierPerks);
$parcel$export(module.exports, "_planIdForTier", () => (parcelRequire("36JmD"))._planIdForTier);
$parcel$export(module.exports, "AdminUsageSummary", () => (parcelRequire("Rs24k")).AdminUsageSummary);
$parcel$export(module.exports, "AdminUsageMetric", () => (parcelRequire("Rs24k")).AdminUsageMetric);
$parcel$export(module.exports, "AdminUsageViewButton", () => (parcelRequire("Rs24k")).AdminUsageViewButton);
$parcel$export(module.exports, "AdminUsageLegend", () => (parcelRequire("Rs24k")).AdminUsageLegend);
$parcel$export(module.exports, "AdminUsageBreakdownRow", () => (parcelRequire("Rs24k")).AdminUsageBreakdownRow);

var $fZjcS = parcelRequire("fZjcS");

var $63OT7 = parcelRequire("63OT7");

var $isgkc = parcelRequire("isgkc");

var $cBxSM = parcelRequire("cBxSM");

var $7zTnr = parcelRequire("7zTnr");

var $f04Jo = parcelRequire("f04Jo");

var $9nj5Y = parcelRequire("9nj5Y");

var $3jIl9 = parcelRequire("3jIl9");

var $5kkuE = parcelRequire("5kkuE");

var $4xA9n = parcelRequire("4xA9n");

var $apzqS = parcelRequire("apzqS");

var $i5Ges = parcelRequire("i5Ges");

var $h9Qog = parcelRequire("h9Qog");

var $aMCzl = parcelRequire("aMCzl");

var $9q0G9 = parcelRequire("9q0G9");

var $ezqR5 = parcelRequire("ezqR5");

var $8k01n = parcelRequire("8k01n");

var $011rZ = parcelRequire("011rZ");

var $iJPAg = parcelRequire("iJPAg");

var $3NFxw = parcelRequire("3NFxw");

var $5nfbw = parcelRequire("5nfbw");

var $lbFkS = parcelRequire("lbFkS");

var $ef7L5 = parcelRequire("ef7L5");

var $frBvJ = parcelRequire("frBvJ");

var $lrPYd = parcelRequire("lrPYd");

var $5ngQ7 = parcelRequire("5ngQ7");

var $dttSx = parcelRequire("dttSx");

var $d4xAj = parcelRequire("d4xAj");

var $5eDxS = parcelRequire("5eDxS");

var $2zGnL = parcelRequire("2zGnL");

var $l96Ck = parcelRequire("l96Ck");

var $g7yQw = parcelRequire("g7yQw");

var $81nXb = parcelRequire("81nXb");

var $bwthf = parcelRequire("bwthf");

var $1wELc = parcelRequire("1wELc");

var $hsKFd = parcelRequire("hsKFd");

var $8GnCH = parcelRequire("8GnCH");

var $6EThr = parcelRequire("6EThr");

var $4uXAm = parcelRequire("4uXAm");

var $eUlT5 = parcelRequire("eUlT5");

var $fx5hY = parcelRequire("fx5hY");

var $5uOS7 = parcelRequire("5uOS7");

var $5bIQI = parcelRequire("5bIQI");

var $fhEHO = parcelRequire("fhEHO");

var $3kf69 = parcelRequire("3kf69");

var $eDffN = parcelRequire("eDffN");

var $a3jen = parcelRequire("a3jen");

var $5fEMD = parcelRequire("5fEMD");

var $5bBlL = parcelRequire("5bBlL");

var $g9M9q = parcelRequire("g9M9q");

var $lnEiO = parcelRequire("lnEiO");

var $armQq = parcelRequire("armQq");

var $hpTyi = parcelRequire("hpTyi");

var $fB7aj = parcelRequire("fB7aj");

var $lk7ed = parcelRequire("lk7ed");

var $dZ7nF = parcelRequire("dZ7nF");

var $h44jx = parcelRequire("h44jx");

var $6duEr = parcelRequire("6duEr");

var $5jkyk = parcelRequire("5jkyk");

var $4UOvu = parcelRequire("4UOvu");

var $hTYKj = parcelRequire("hTYKj");

var $khfDK = parcelRequire("khfDK");

var $cWCor = parcelRequire("cWCor");

var $cChHa = parcelRequire("cChHa");

var $4dmlM = parcelRequire("4dmlM");

var $36JmD = parcelRequire("36JmD");

var $j4AOm = parcelRequire("j4AOm");

var $ci5oN = parcelRequire("ci5oN");

var $5PXM6 = parcelRequire("5PXM6");

var $d6RZo = parcelRequire("d6RZo");

var $gXaNm = parcelRequire("gXaNm");

var $13xHG = parcelRequire("13xHG");

var $6qGP7 = parcelRequire("6qGP7");

var $aL82M = parcelRequire("aL82M");

var $cN8n4 = parcelRequire("cN8n4");

var $eV3Sc = parcelRequire("eV3Sc");

var $3MXUr = parcelRequire("3MXUr");

var $d6kmW = parcelRequire("d6kmW");

var $23ker = parcelRequire("23ker");

var $dS9Zz = parcelRequire("dS9Zz");

var $lAJsX = parcelRequire("lAJsX");

var $ahEnG = parcelRequire("ahEnG");

var $b5NRZ = parcelRequire("b5NRZ");

var $6RJxn = parcelRequire("6RJxn");

var $imvgE = parcelRequire("imvgE");

var $193j2 = parcelRequire("193j2");

var $30PMN = parcelRequire("30PMN");

var $b4j4k = parcelRequire("b4j4k");

var $b4KYc = parcelRequire("b4KYc");

var $ebATa = parcelRequire("ebATa");

var $6QuJi = parcelRequire("6QuJi");

var $8n5aH = parcelRequire("8n5aH");

var $4F5uB = parcelRequire("4F5uB");

var $cHGCQ = parcelRequire("cHGCQ");

var $7JDzv = parcelRequire("7JDzv");

var $WlLEt = parcelRequire("WlLEt");

var $bndqJ = parcelRequire("bndqJ");

var $jIzVU = parcelRequire("jIzVU");

var $9idOF = parcelRequire("9idOF");

var $gWEhr = parcelRequire("gWEhr");

var $b0JcV = parcelRequire("b0JcV");

var $kGfCC = parcelRequire("kGfCC");

var $2iwV7 = parcelRequire("2iwV7");

var $bsjx9 = parcelRequire("bsjx9");

var $lGHBq = parcelRequire("lGHBq");

var $2ryNq = parcelRequire("2ryNq");

var $8hI2P = parcelRequire("8hI2P");

var $34R2l = parcelRequire("34R2l");

var $lBdaZ = parcelRequire("lBdaZ");

var $6Yw6V = parcelRequire("6Yw6V");

var $lDFKp = parcelRequire("lDFKp");

var $kL51S = parcelRequire("kL51S");

var $j5cJe = parcelRequire("j5cJe");

var $5lBo0 = parcelRequire("5lBo0");

var $dG0YH = parcelRequire("dG0YH");

var $6QQog = parcelRequire("6QQog");

var $kdD0n = parcelRequire("kdD0n");

var $fB8Yp = parcelRequire("fB8Yp");

var $80Tpq = parcelRequire("80Tpq");

var $kiYNh = parcelRequire("kiYNh");

var $ecRFe = parcelRequire("ecRFe");

var $5VNvD = parcelRequire("5VNvD");

var $3ScYq = parcelRequire("3ScYq");

var $lpuFp = parcelRequire("lpuFp");

var $9k193 = parcelRequire("9k193");

var $gAM3x = parcelRequire("gAM3x");

var $kHpof = parcelRequire("kHpof");

var $8Z2iB = parcelRequire("8Z2iB");

var $c8onO = parcelRequire("c8onO");

var $2qltX = parcelRequire("2qltX");

var $8a5bZ = parcelRequire("8a5bZ");

var $fx4Qn = parcelRequire("fx4Qn");

var $lxNZr = parcelRequire("lxNZr");

var $8Pafq = parcelRequire("8Pafq");

var $gCjMr = parcelRequire("gCjMr");

var $ewwLp = parcelRequire("ewwLp");

var $c9akr = parcelRequire("c9akr");

var $jcUdR = parcelRequire("jcUdR");

var $b67FM = parcelRequire("b67FM");

var $4Fs5n = parcelRequire("4Fs5n");

var $gvLr9 = parcelRequire("gvLr9");

var $519y5 = parcelRequire("519y5");

var $1L56l = parcelRequire("1L56l");

var $dwFge = parcelRequire("dwFge");

var $aewVc = parcelRequire("aewVc");

var $5Qn9t = parcelRequire("5Qn9t");

var $cnATX = parcelRequire("cnATX");

var $cv2QW = parcelRequire("cv2QW");

var $gFIOG = parcelRequire("gFIOG");

var $9VHfZ = parcelRequire("9VHfZ");

var $5xAyL = parcelRequire("5xAyL");

var $bAk8Z = parcelRequire("bAk8Z");

var $Rs24k = parcelRequire("Rs24k");

var $fDUXx = parcelRequire("fDUXx");

var $HQCRr = parcelRequire("HQCRr");

var $gVnLp = parcelRequire("gVnLp");

var $kc5p7 = parcelRequire("kc5p7");

var $iI84d = parcelRequire("iI84d");

var $caPbm = parcelRequire("caPbm");

var $equEq = parcelRequire("equEq");
$parcel$exportWildcard(module.exports, $fZjcS);
$parcel$exportWildcard(module.exports, $63OT7);
$parcel$exportWildcard(module.exports, $isgkc);
$parcel$exportWildcard(module.exports, $cBxSM);
$parcel$exportWildcard(module.exports, $7zTnr);
$parcel$exportWildcard(module.exports, $f04Jo);
$parcel$exportWildcard(module.exports, $9nj5Y);
$parcel$exportWildcard(module.exports, $3jIl9);
$parcel$exportWildcard(module.exports, $5kkuE);
$parcel$exportWildcard(module.exports, $4xA9n);
$parcel$exportWildcard(module.exports, $apzqS);
$parcel$exportWildcard(module.exports, $i5Ges);
$parcel$exportWildcard(module.exports, $h9Qog);
$parcel$exportWildcard(module.exports, $aMCzl);
$parcel$exportWildcard(module.exports, $9q0G9);
$parcel$exportWildcard(module.exports, $ezqR5);
$parcel$exportWildcard(module.exports, $8k01n);
$parcel$exportWildcard(module.exports, $011rZ);
$parcel$exportWildcard(module.exports, $iJPAg);
$parcel$exportWildcard(module.exports, $3NFxw);
$parcel$exportWildcard(module.exports, $5nfbw);
$parcel$exportWildcard(module.exports, $lbFkS);
$parcel$exportWildcard(module.exports, $ef7L5);
$parcel$exportWildcard(module.exports, $frBvJ);
$parcel$exportWildcard(module.exports, $lrPYd);
$parcel$exportWildcard(module.exports, $5ngQ7);
$parcel$exportWildcard(module.exports, $dttSx);
$parcel$exportWildcard(module.exports, $d4xAj);
$parcel$exportWildcard(module.exports, $5eDxS);
$parcel$exportWildcard(module.exports, $2zGnL);
$parcel$exportWildcard(module.exports, $l96Ck);
$parcel$exportWildcard(module.exports, $g7yQw);
$parcel$exportWildcard(module.exports, $81nXb);
$parcel$exportWildcard(module.exports, $bwthf);
$parcel$exportWildcard(module.exports, $1wELc);
$parcel$exportWildcard(module.exports, $hsKFd);
$parcel$exportWildcard(module.exports, $8GnCH);
$parcel$exportWildcard(module.exports, $6EThr);
$parcel$exportWildcard(module.exports, $4uXAm);
$parcel$exportWildcard(module.exports, $eUlT5);
$parcel$exportWildcard(module.exports, $fx5hY);
$parcel$exportWildcard(module.exports, $5uOS7);
$parcel$exportWildcard(module.exports, $5bIQI);
$parcel$exportWildcard(module.exports, $fhEHO);
$parcel$exportWildcard(module.exports, $3kf69);
$parcel$exportWildcard(module.exports, $eDffN);
$parcel$exportWildcard(module.exports, $a3jen);
$parcel$exportWildcard(module.exports, $5fEMD);
$parcel$exportWildcard(module.exports, $5bBlL);
$parcel$exportWildcard(module.exports, $g9M9q);
$parcel$exportWildcard(module.exports, $lnEiO);
$parcel$exportWildcard(module.exports, $armQq);
$parcel$exportWildcard(module.exports, $hpTyi);
$parcel$exportWildcard(module.exports, $fB7aj);
$parcel$exportWildcard(module.exports, $lk7ed);
$parcel$exportWildcard(module.exports, $dZ7nF);
$parcel$exportWildcard(module.exports, $h44jx);
$parcel$exportWildcard(module.exports, $6duEr);
$parcel$exportWildcard(module.exports, $5jkyk);
$parcel$exportWildcard(module.exports, $4UOvu);
$parcel$exportWildcard(module.exports, $hTYKj);
$parcel$exportWildcard(module.exports, $khfDK);
$parcel$exportWildcard(module.exports, $cWCor);
$parcel$exportWildcard(module.exports, $cChHa);
$parcel$exportWildcard(module.exports, $4dmlM);
$parcel$exportWildcard(module.exports, $j4AOm);
$parcel$exportWildcard(module.exports, $ci5oN);
$parcel$exportWildcard(module.exports, $5PXM6);
$parcel$exportWildcard(module.exports, $d6RZo);
$parcel$exportWildcard(module.exports, $gXaNm);
$parcel$exportWildcard(module.exports, $13xHG);
$parcel$exportWildcard(module.exports, $6qGP7);
$parcel$exportWildcard(module.exports, $aL82M);
$parcel$exportWildcard(module.exports, $cN8n4);
$parcel$exportWildcard(module.exports, $eV3Sc);
$parcel$exportWildcard(module.exports, $3MXUr);
$parcel$exportWildcard(module.exports, $d6kmW);
$parcel$exportWildcard(module.exports, $23ker);
$parcel$exportWildcard(module.exports, $dS9Zz);
$parcel$exportWildcard(module.exports, $lAJsX);
$parcel$exportWildcard(module.exports, $ahEnG);
$parcel$exportWildcard(module.exports, $b5NRZ);
$parcel$exportWildcard(module.exports, $6RJxn);
$parcel$exportWildcard(module.exports, $imvgE);
$parcel$exportWildcard(module.exports, $193j2);
$parcel$exportWildcard(module.exports, $30PMN);
$parcel$exportWildcard(module.exports, $b4j4k);
$parcel$exportWildcard(module.exports, $b4KYc);
$parcel$exportWildcard(module.exports, $ebATa);
$parcel$exportWildcard(module.exports, $6QuJi);
$parcel$exportWildcard(module.exports, $8n5aH);
$parcel$exportWildcard(module.exports, $4F5uB);
$parcel$exportWildcard(module.exports, $cHGCQ);
$parcel$exportWildcard(module.exports, $7JDzv);
$parcel$exportWildcard(module.exports, $WlLEt);
$parcel$exportWildcard(module.exports, $bndqJ);
$parcel$exportWildcard(module.exports, $jIzVU);
$parcel$exportWildcard(module.exports, $9idOF);
$parcel$exportWildcard(module.exports, $gWEhr);
$parcel$exportWildcard(module.exports, $b0JcV);
$parcel$exportWildcard(module.exports, $kGfCC);
$parcel$exportWildcard(module.exports, $2iwV7);
$parcel$exportWildcard(module.exports, $bsjx9);
$parcel$exportWildcard(module.exports, $lGHBq);
$parcel$exportWildcard(module.exports, $2ryNq);
$parcel$exportWildcard(module.exports, $8hI2P);
$parcel$exportWildcard(module.exports, $34R2l);
$parcel$exportWildcard(module.exports, $lBdaZ);
$parcel$exportWildcard(module.exports, $6Yw6V);
$parcel$exportWildcard(module.exports, $lDFKp);
$parcel$exportWildcard(module.exports, $kL51S);
$parcel$exportWildcard(module.exports, $j5cJe);
$parcel$exportWildcard(module.exports, $5lBo0);
$parcel$exportWildcard(module.exports, $dG0YH);
$parcel$exportWildcard(module.exports, $6QQog);
$parcel$exportWildcard(module.exports, $kdD0n);
$parcel$exportWildcard(module.exports, $fB8Yp);
$parcel$exportWildcard(module.exports, $80Tpq);
$parcel$exportWildcard(module.exports, $kiYNh);
$parcel$exportWildcard(module.exports, $ecRFe);
$parcel$exportWildcard(module.exports, $5VNvD);
$parcel$exportWildcard(module.exports, $3ScYq);
$parcel$exportWildcard(module.exports, $lpuFp);
$parcel$exportWildcard(module.exports, $9k193);
$parcel$exportWildcard(module.exports, $gAM3x);
$parcel$exportWildcard(module.exports, $kHpof);
$parcel$exportWildcard(module.exports, $8Z2iB);
$parcel$exportWildcard(module.exports, $c8onO);
$parcel$exportWildcard(module.exports, $2qltX);
$parcel$exportWildcard(module.exports, $8a5bZ);
$parcel$exportWildcard(module.exports, $fx4Qn);
$parcel$exportWildcard(module.exports, $lxNZr);
$parcel$exportWildcard(module.exports, $8Pafq);
$parcel$exportWildcard(module.exports, $gCjMr);
$parcel$exportWildcard(module.exports, $ewwLp);
$parcel$exportWildcard(module.exports, $c9akr);
$parcel$exportWildcard(module.exports, $jcUdR);
$parcel$exportWildcard(module.exports, $b67FM);
$parcel$exportWildcard(module.exports, $4Fs5n);
$parcel$exportWildcard(module.exports, $gvLr9);
$parcel$exportWildcard(module.exports, $519y5);
$parcel$exportWildcard(module.exports, $1L56l);
$parcel$exportWildcard(module.exports, $dwFge);
$parcel$exportWildcard(module.exports, $aewVc);
$parcel$exportWildcard(module.exports, $5Qn9t);
$parcel$exportWildcard(module.exports, $cnATX);
$parcel$exportWildcard(module.exports, $cv2QW);
$parcel$exportWildcard(module.exports, $gFIOG);
$parcel$exportWildcard(module.exports, $9VHfZ);
$parcel$exportWildcard(module.exports, $5xAyL);
$parcel$exportWildcard(module.exports, $bAk8Z);
$parcel$exportWildcard(module.exports, $fDUXx);
$parcel$exportWildcard(module.exports, $HQCRr);
$parcel$exportWildcard(module.exports, $gVnLp);
$parcel$exportWildcard(module.exports, $kc5p7);
$parcel$exportWildcard(module.exports, $iI84d);
$parcel$exportWildcard(module.exports, $caPbm);
$parcel$exportWildcard(module.exports, $equEq);

});
parcelRegister("fZjcS", function(module, exports) {

$parcel$export(module.exports, "PageHeader", () => $ba3b739548730b1a$export$53f1cd6809577fc5);
$parcel$export(module.exports, "PageHeaderTitle", () => $ba3b739548730b1a$export$7f365262018175ea);
const $ba3b739548730b1a$export$53f1cd6809577fc5 = {
    flow: 'x',
    flexWrap: 'wrap',
    align: 'center space-between',
    padding: 'Z A',
    // BORDERLESS (DESIGN_LANGUAGE.md §2.5/§7.2 — the PageBar contract, which
    // this component IS for in-shell surfaces; ChatPaneHeader proved it by
    // zeroing the old hairline): a sticky bar separates from the content that
    // scrolls beneath it by an opaque stage fill, never a stroke. This was the
    // last hairline in shell chrome — 31 consumers converge on this line.
    // THE SHEET COLOUR (Nika 2026-09-24, Q2 (B) — the sheet is flat): the bar
    // paints the sheet pair under it — gray2 dark / gray16 light, the pair of
    // AppMain.js and of an app route's content element (app.js); the three
    // sites move together — so the bar,
    // the sheet and the frame are one colour in both schemes, and only the
    // cards and the rail step off them. It painted the retired `common-card`
    // theme: white in light over the gray16 frame (1.04:1, a white bar over a
    // grey sheet). `color: 'title'` is the ink.
    background: 'gray2',
    '@light': {
        background: 'gray16'
    },
    minHeight: 'D',
    gap: 'A',
    color: 'title',
    position: 'sticky',
    top: '0',
    zIndex: '20',
    boxSizing: 'border-box',
    minWidth: '0',
    maxWidth: '100%',
    '@mobileL': {
        flow: 'y',
        align: 'stretch flex-start',
        minHeight: 'auto',
        gap: 'Z',
        padding: 'Z A'
    },
    '@appMobile': {
        flow: 'y',
        align: 'stretch flex-start',
        minHeight: 'auto',
        gap: 'Z',
        padding: 'Z A'
    },
    LeftGroup: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        flex: '1 1 auto',
        flexWrap: 'wrap',
        minWidth: '0',
        maxWidth: '100%',
        ':empty': {
            display: 'none'
        },
        '@mobileL': {
            width: '100%',
            maxWidth: '100%'
        },
        '@appMobile': {
            width: '100%',
            maxWidth: '100%'
        }
    },
    CenterGroup: {
        // PageSlot can be narrow while the viewport is wide. Keeping all three
        // groups in flow lets their actual content decide when to wrap, instead
        // of centering tabs over the title and actions at a viewport breakpoint.
        flow: 'x',
        align: 'center',
        position: 'static',
        flex: '0 1 auto',
        minWidth: '0',
        maxWidth: '100%',
        overflowX: 'auto',
        overscrollBehaviorX: 'contain',
        ':empty': {
            display: 'none'
        },
        '@mobileL': {
            position: 'relative',
            left: 'auto',
            top: 'auto',
            transform: 'none',
            width: '100%',
            maxWidth: '100%',
            overflowX: 'auto',
            justifyContent: 'flex-start'
        },
        '@appMobile': {
            width: '100%',
            maxWidth: '100%',
            justifyContent: 'flex-start'
        }
    },
    RightGroup: {
        flow: 'x',
        align: 'center right',
        gap: 'Z1',
        flex: '0 1 auto',
        flexWrap: 'wrap',
        minWidth: '0',
        maxWidth: '100%',
        marginLeft: 'auto',
        ':empty': {
            display: 'none'
        },
        '@mobileL': {
            width: '100%',
            maxWidth: '100%',
            justifyContent: 'flex-start',
            flexWrap: 'wrap'
        },
        '@appMobile': {
            width: '100%',
            maxWidth: '100%',
            justifyContent: 'flex-start'
        }
    }
};
const $ba3b739548730b1a$export$7f365262018175ea = {
    tag: (el, s)=>el.call('pageTitleTag', s) || 'h1',
    margin: '0',
    minWidth: '0',
    fontSize: 'B',
    fontWeight: '700'
};

});

parcelRegister("63OT7", function(module, exports) {

$parcel$export(module.exports, "ReminderMentionOption", () => $469a7f2b1fba03cc$export$f0055a4f00a72116);
$parcel$export(module.exports, "ReminderComposer", () => $469a7f2b1fba03cc$export$5f0eb3c525bcfa4f);
// Quick-add composer for /reminders (pages/reminders.js): a focused title/
// submit row followed by compact due-date and visibility controls. All state lives on root
// (_reminderDraft / _reminderDraftDue) so Enter and the Add button share the
// exact same submit path (el.call('submitReminderDraft') — functions/reminders.js).
// Shared look for the three quick-set chips — a plain style object (not a
// registered component), spread into each declaration below. Mirrors the
// `_widgetCardSurface` convention in pages/main.js.
const $469a7f2b1fba03cc$var$_chipStyle = {
    tag: 'button',
    type: 'button',
    flexShrink: '0',
    minHeight: 'controlHCompact',
    padding: '0 Z1',
    fontSize: 'Z1',
    fontWeight: '700',
    color: 'title',
    background: 'overlay',
    border: 'none',
    round: 'radiusPill',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    // `overlayStrong` is a near-opaque sheet wash, not a state fill (§4.1) —
    // the hover wash is the shared `hover` token (§4.3).
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    ':focus-visible': {
        background: 'selected'
    },
    '@coarse': {
        minHeight: 'controlH'
    }
};
const $469a7f2b1fba03cc$export$f0055a4f00a72116 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Y1 Z',
    minHeight: 'controlH',
    width: '100%',
    minWidth: '0',
    border: 'none',
    background: 'transparent',
    textAlign: 'left',
    round: 'radiusControl',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    ':focus-visible': {
        background: 'selected'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        el.call('applyReminderMention', {
            name: s.name,
            email: s.email
        });
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'avatarXs avatarXs',
        src: (el, s)=>el.call('avatarUrl', s.name || s.email)
    },
    MName: {
        tag: 'span',
        fontSize: 'Z1',
        color: 'title',
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.name || s.email
    },
    MEmail: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'inactive',
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.email
    }
};
const $469a7f2b1fba03cc$export$5f0eb3c525bcfa4f = {
    extends: 'CommonCard',
    flow: 'y',
    gap: 'Z1',
    padding: '0',
    position: 'relative',
    // The draft stays intentionally two-tiered: a clear title/action row, then
    // a compact control tray. This keeps the add path stable as the column
    // narrows instead of interleaving date, scope, and submit controls.
    '@tabletS': {
        gap: 'Z'
    },
    '@appMobile': {
        gap: 'Z'
    },
    DraftRow: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        minWidth: '0',
        flexWrap: 'wrap',
        Input: {
            flex: '1 1 var(--spacing-G)',
            // A preferred input width makes the Add action wrap naturally inside
            // a narrow pane. A zero minimum lets the input itself fit a phone.
            minWidth: '0',
            maxWidth: '100%',
            minHeight: 'controlH',
            theme: 'field',
            background: 'hover',
            round: 'radiusControl',
            fontSize: 'Z2',
            padding: '0 A',
            'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.addAria'),
            placeholder: (el)=>el.call('polyglot', 'workspace.reminders.composer.placeholder'),
            value: (el, s)=>s.root?._reminderDraft || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    _reminderDraft: e.target.value
                });
                el.call('setReminderMentionQuery', e.target.value);
            },
            onKeydown: (e, el, s)=>{
                if (e.key === 'Escape' && s.root?._reminderMentionQuery != null) {
                    e.preventDefault();
                    return s.root.update({
                        _reminderMentionQuery: null
                    });
                }
                if (e.key !== 'Enter') return;
                e.preventDefault();
                // Enter with the mention menu armed picks the top match; plain Enter
                // submits.
                const matches = el.call('reminderMentionMatches', s.root);
                if (s.root?._reminderMentionQuery != null && matches.length) return el.call('applyReminderMention', matches[0]);
                el.call('submitReminderDraft');
            }
        },
        AddBtn: {
            tag: 'button',
            type: 'button',
            flexShrink: '0',
            theme: 'primary',
            border: 'none',
            minHeight: 'controlH',
            round: 'radiusPill',
            padding: '0 A',
            fontSize: 'Z2',
            fontWeight: '700',
            cursor: 'pointer',
            ':disabled': {
                opacity: '.55',
                cursor: 'not-allowed'
            },
            disabled: (el, s)=>!(s.root?._reminderDraft || '').trim(),
            text: '{{ workspace.reminders.composer.add | polyglot }}',
            onClick: (e, el)=>el.call('submitReminderDraft')
        }
    },
    // @mention autocomplete — anchored under the input, driven entirely by
    // root._reminderMentionQuery (null = closed). Rows are static-per-render
    // via childrenAs:'state' but their CLICK rides the row's own onClick,
    // which is safe here because the menu re-renders per keystroke anyway
    // (fresh mount each open — not the long-lived kanban-row shape the v3.14
    // binding quirk bites).
    MentionMenu: {
        hide: (el, s)=>s.root?._reminderMentionQuery == null || !el.call('reminderMentionMatches', s.root).length,
        position: 'absolute',
        top: '100%',
        left: 'Z',
        right: 'Z',
        marginTop: 'W',
        zIndex: '1200',
        flow: 'y',
        minWidth: '0',
        maxWidth: 'H',
        maxHeight: 'F',
        overflow: 'auto',
        padding: 'X',
        round: 'radiusControl',
        // Real bug: `background: 'dialog'` referenced a THEME name in a colour
        // slot — `dialog` is registered in designSystem/theme.js, not color.js
        // (zero matches), so the value emitted invalid CSS silently and this
        // floating menu had NO actual fill, relying on the border alone to read
        // (same class of bug as the tickets sweep's `background: 'surface'`
        // find). `theme: 'dialog'` is the real opaque fill.
        theme: 'common-box',
        shadow: 'overlay',
        childrenAs: 'state',
        children: (el, s)=>el.call('reminderMentionMatches', s.root),
        childExtends: 'ReminderMentionOption'
    },
    ControlTray: {
        flow: 'x',
        align: 'center',
        gap: 'V',
        flexWrap: 'wrap',
        DueGroup: {
            flow: 'x',
            align: 'center',
            gap: 'V',
            flexWrap: 'wrap',
            TodayChip: {
                ...$469a7f2b1fba03cc$var$_chipStyle,
                text: '{{ workspace.reminders.composer.today | polyglot }}',
                onClick: (e, el, s)=>s.root.update({
                        _reminderDraftDue: el.call('reminderQuickDue', 'today')
                    })
            },
            TomorrowChip: {
                ...$469a7f2b1fba03cc$var$_chipStyle,
                text: '{{ workspace.reminders.composer.tomorrow | polyglot }}',
                onClick: (e, el, s)=>s.root.update({
                        _reminderDraftDue: el.call('reminderQuickDue', 'tomorrow')
                    })
            },
            NextWeekChip: {
                ...$469a7f2b1fba03cc$var$_chipStyle,
                text: '{{ workspace.reminders.composer.nextWeek | polyglot }}',
                onClick: (e, el, s)=>s.root.update({
                        _reminderDraftDue: el.call('reminderQuickDue', 'nextWeek')
                    })
            },
            // Native picker styled as a chip — clicking it opens the browser's own
            // date/time UI directly (the "reveal" the quick chips don't need JS for).
            Input: {
                type: 'datetime-local',
                flexShrink: '0',
                minHeight: 'controlHCompact',
                fontSize: 'Z1',
                color: 'title',
                background: 'overlay',
                border: 'none',
                round: 'radiusPill',
                padding: '0 Z1',
                cursor: 'pointer',
                'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.composer.pickDate'),
                title: (el)=>el.call('polyglot', 'workspace.reminders.composer.pickDate'),
                value: (el, s)=>el.call('reminderDraftDueInputValue', s.root),
                onChange: (e, el, s)=>el.call('setReminderDraftDue', e.target.value)
            },
            PendingDueChip: {
                hide: (el, s)=>!s.root?._reminderDraftDue,
                flow: 'x',
                align: 'center',
                gap: 'W',
                flexShrink: '0',
                minHeight: 'controlHCompact',
                fontSize: 'Z1',
                fontWeight: '700',
                color: 'title',
                background: 'selected',
                round: 'radiusPill',
                padding: '0 Z1',
                Label: {
                    tag: 'span',
                    text: (el, s)=>el.call('reminderDueLabel', s.root?._reminderDraftDue) || ''
                },
                RemoveBtn: {
                    tag: 'button',
                    type: 'button',
                    flow: 'x',
                    align: 'center center',
                    background: 'transparent',
                    border: 'none',
                    padding: '0',
                    minWidth: 'controlHCompact',
                    minHeight: 'controlHCompact',
                    round: 'radiusPill',
                    cursor: 'pointer',
                    color: 'title',
                    ':hover': {
                        background: 'hover'
                    },
                    ':active': {
                        background: 'selected'
                    },
                    ':focus-visible': {
                        background: 'selected'
                    },
                    'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.removeDueAria'),
                    onClick: (e, el)=>{
                        e.stopPropagation();
                        el.call('clearReminderDraftDue');
                    },
                    Icon: {
                        name: 'crossmark',
                        boxSize: 'iconXs'
                    }
                }
            }
        },
        // Private ⇄ Shared visibility toggle — the same capsule language as the
        // schedule controls, with its state made explicit by both icon and text.
        VisibilityChip: {
            ...$469a7f2b1fba03cc$var$_chipStyle,
            flow: 'x',
            align: 'center',
            gap: 'W',
            color: 'title',
            background: (el, s)=>s.root?._reminderDraftShared ? 'selected' : 'overlay',
            'aria-pressed': (el, s)=>s.root?._reminderDraftShared ? 'true' : 'false',
            'aria-label': (el, s)=>el.call('polyglot', s.root?._reminderDraftShared ? 'workspace.reminders.sharedChip' : 'workspace.reminders.visibility.private'),
            title: (el, s)=>el.call('polyglot', s.root?._reminderDraftShared ? 'workspace.reminders.sharedChip' : 'workspace.reminders.visibility.private'),
            onClick: (e, el)=>el.call('toggleReminderDraftShared'),
            Icon: {
                icon: (el, s)=>s.root?._reminderDraftShared ? 'globeOutline' : 'lockOutline',
                boxSize: 'iconXs'
            },
            VisLabel: {
                tag: 'span',
                text: (el, s)=>el.call('polyglot', s.root?._reminderDraftShared ? 'workspace.reminders.visibility.shared' : 'workspace.reminders.visibility.private')
            }
        }
    }
};

});

parcelRegister("isgkc", function(module, exports) {

$parcel$export(module.exports, "ReminderRow", () => $d6f7814b577e7866$export$fe96bade21f14120);
$parcel$export(module.exports, "ReminderGroupSection", () => $d6f7814b577e7866$export$288c9701abc2ee88);
// Shared recipe for the row's three action buttons — a plain style object
// (not a registered component), spread into each declaration below. Same
// convention as `_chipStyle` in components/ReminderComposer.js. All three
// inherit IconButton; `icon:` overrides SquareButton's default ('smile' —
// the stray smiley that shipped next to the trash glyph, 2026-08-01 per
// Nika "fix delete icon"; never add a second Icon child on IconButton).
//
// Visible at full contrast, with the shared control-size tap target. Hover
// changes the surface without fading the action's icon.
const $d6f7814b577e7866$var$_actionBtnStyle = {
    extends: 'IconButton',
    flexShrink: '0',
    color: 'inactive',
    width: 'controlHCompact',
    height: 'controlHCompact',
    minWidth: 'controlHCompact',
    minHeight: 'controlHCompact',
    padding: '0',
    boxSizing: 'border-box',
    ':hover': {
        background: 'hover'
    },
    '@coarse': {
        width: 'controlH',
        height: 'controlH',
        minWidth: 'controlH',
        minHeight: 'controlH'
    }
};
const $d6f7814b577e7866$export$fe96bade21f14120 = {
    flow: 'x',
    align: 'center',
    gap: 'Z1',
    padding: 'Z A',
    round: 'radiusCard',
    ':hover': {
        background: 'hover'
    },
    onRender: (el)=>el.call('armLongPress'),
    onContextmenu: (event, el, s)=>el.call('openAppContextMenu', event, {
            kind: 'reminder',
            id: s.id
        }),
    // A dedicated button key avoids auto-extending Checkbox, whose hidden
    // Input would otherwise create a second, unnamed keyboard target here.
    CompletionButton: {
        extends: 'IconButton',
        icon: 'checkmark',
        type: 'button',
        flexShrink: '0',
        width: 'controlHCompact',
        height: 'controlHCompact',
        minWidth: 'controlHCompact',
        minHeight: 'controlHCompact',
        padding: '0',
        boxSizing: 'border-box',
        '@coarse': {
            width: 'controlH',
            height: 'controlH',
            minWidth: 'controlH'
        },
        round: 'radiusPill',
        borderWidth: 'hairline2',
        borderStyle: 'dashed',
        borderColor: (el, s)=>s.done ? 'transparent' : 'inactive',
        cursor: 'pointer',
        // The theme supplies BOTH ink and fill. A flat transparent background
        // overrode the completed fill, making its reversed checkmark invisible.
        theme: (el, s)=>s.done ? 'primary' : 'tertiary',
        'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.toggleAria2'),
        ariaPressed: (el, s)=>s.done ? 'true' : 'false',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('toggleReminder', s.id);
        },
        Icon: {
            width: 'iconXs',
            height: 'iconXs',
            flexShrink: '0',
            color: 'currentColor',
            pointerEvents: 'none',
            opacity: (el, s)=>s.done ? '1' : '0'
        }
    },
    Title: {
        tag: 'span',
        flex: '1',
        minWidth: '0',
        fontSize: 'A',
        lineHeight: '1.4',
        color: (el, s)=>s.done ? 'caption' : 'title',
        textDecoration: (el, s)=>s.done ? 'line-through' : 'none',
        // Primary text wraps — never cut behind an ellipsis (the overflow law).
        overflowWrap: 'anywhere',
        text: (el, s)=>s.title || el.call('polyglot', 'workspace.reminders.untitled')
    },
    DueChip: {
        hide: (el, s)=>s.done || !el.call('reminderDueLabel', s.dueAt),
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        fontWeight: '700',
        lineHeight: '1',
        padding: 'V Y',
        round: 'radiusPill',
        whiteSpace: 'nowrap',
        color: (el, s)=>el.call('reminderIsOverdue', s.dueAt, s.done) ? 'red' : 'caption',
        background: (el, s)=>el.call('reminderIsOverdue', s.dueAt, s.done) ? 'red.15' : 'overlay',
        text: (el, s)=>el.call('reminderDueLabel', s.dueAt) || ''
    },
    // Shared-visibility marker + owner attribution for teammates' shared rows.
    SharedChip: {
        hide: (el, s)=>s.visibility !== 'shared',
        flow: 'x',
        align: 'center',
        gap: 'W',
        flexShrink: '0',
        fontSize: 'Y2',
        color: 'caption',
        title: (el)=>el.call('polyglot', 'workspace.reminders.sharedChip'),
        GlobeIcon: {
            extends: 'Icon',
            name: 'globeOutline',
            boxSize: 'iconXs'
        },
        Owner: {
            tag: 'span',
            hide: (el, s)=>el.call('reminderIsMine', s.root, s),
            text: (el, s)=>{
                const p = (s.root?.people || []).find((x)=>(x.email || '').toLowerCase() === (s.ownerEmail || '').toLowerCase());
                return p && (p.name || '').split(/\s+/)[0] || (s.ownerEmail || '').split('@')[0];
            }
        }
    },
    // Action cluster — see `_actionBtnStyle` above for the shared recipe.
    // Convert MOVES the item (a ticket is made, the reminder is deleted): owner-
    // only like the delete, and it asks first — the same ask as the ⋯ menu's
    // (functions/reminders.js confirmConvertReminderToTask).
    ConvertTaskBtn: {
        ...$d6f7814b577e7866$var$_actionBtnStyle,
        icon: 'checkOval',
        title: (el)=>el.call('polyglot', 'workspace.reminders.convertToTask'),
        'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.convertToTask'),
        hide: (el, s)=>!el.call('reminderIsMine', s.root, s),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('confirmConvertReminderToTask', s.id);
        }
    },
    ConvertEventBtn: {
        ...$d6f7814b577e7866$var$_actionBtnStyle,
        icon: 'dateOutline',
        title: (el)=>el.call('polyglot', 'workspace.reminders.convertToEvent'),
        'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.convertToEvent'),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('convertReminderToEvent', s.id);
        }
    },
    DeleteBtn: {
        ...$d6f7814b577e7866$var$_actionBtnStyle,
        icon: 'trash',
        // Destructive action reads red on hover instead of the neutral tint.
        ':hover': {
            background: 'red.1',
            color: 'red'
        },
        title: (el)=>el.call('polyglot', 'workspace.reminders.delete'),
        'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.delete'),
        // Owner-only — teammates can complete a shared reminder but not delete it.
        hide: (el, s)=>!el.call('reminderIsMine', s.root, s),
        // The house confirm first — the same one the ⋯ menu's Delete opens
        // (functions/reminders.js confirmDeleteReminder).
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('confirmDeleteReminder', s.id);
        }
    },
    More: {
        extends: 'AppContextMenuButton',
        'aria-label': (el)=>el.call('polyglot', 'workspace.reminders.moreAria'),
        onClick: (event, el, s)=>el.call('openAppContextMenu', event, {
                kind: 'reminder',
                id: s.id
            }, {
                anchor: true
            })
    }
};
const $d6f7814b577e7866$export$288c9701abc2ee88 = {
    flow: 'y',
    gap: 'Z',
    GroupHead: {
        flow: 'x',
        align: 'baseline',
        // `V` collided the count with the label ("NO DATE1") — the label's own
        // 0.08em letter-spacing already eats most of a V gap.
        gap: 'X',
        Label: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: (el, s)=>s.tone === 'error' ? 'red' : 'caption',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        Count: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>String((s.items || []).length)
        }
    },
    Rows: {
        flow: 'y',
        gap: 'V',
        childExtends: 'ReminderRow',
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    }
};

});

parcelRegister("cBxSM", function(module, exports) {

$parcel$export(module.exports, "AppContextMenuButton", () => $92d33919c2236045$export$60d7a4255cafe0ef);
// Visible, keyboard-reachable counterpart to a native app's right-click menu.
// Each consumer supplies its own onClick descriptor via openAppContextMenu.
const $92d33919c2236045$export$60d7a4255cafe0ef = {
    tag: 'button',
    type: 'button',
    minWidth: 'controlHCompact',
    minHeight: 'controlHCompact',
    padding: '0 Z',
    round: 'radiusPill',
    borderWidth: '0',
    background: 'transparent',
    color: 'caption',
    cursor: 'pointer',
    fontSize: 'A',
    fontWeight: '700',
    letterSpacing: '.08em',
    transition: '120ms defaultBezier background, 120ms defaultBezier color',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    ':focus-visible': {
        background: 'selected',
        color: 'title'
    },
    '@coarse': {
        minWidth: 'C',
        minHeight: 'C'
    },
    // Flat and in the FUNCTION form: a name inside `attr:` cannot follow the
    // language (I18N-CONVENTION §1). A mount site that names a narrower action
    // overrides this same flat prop.
    'aria-label': (el)=>el.call('polyglot', 'workspace.sidebar.moreActions'),
    text: "\xb7\xb7\xb7"
};

});

parcelRegister("7zTnr", function(module, exports) {

$parcel$export(module.exports, "AppsHubCard", () => $5846c2085de91465$export$ca53cc7b8fc19f30);
// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.
// One app: its glyph (the launcher's plate), its name (the store's resolver —
// one app, one name everywhere), where it comes from, its channel, and the
// actions that lead to its OWN flow (open in the workspace, change in /add-app,
// manage in the App Store). The card itself is not a button.
const $5846c2085de91465$export$ca53cc7b8fc19f30 = {
    tag: 'div',
    flow: 'x',
    // The actions wrap under the name when the card is narrow — the name keeps
    // its words whole ("Excalidr aw" broke mid-word on dev, 2026-10-21).
    flexWrap: 'wrap',
    align: 'center flex-start',
    gap: 'A',
    padding: 'A',
    minWidth: '0',
    round: 'radiusCard',
    // A surface, never a stroke (the brand law: no painted border on anything
    // but a form field).
    background: 'overlay',
    dataAppId: (el, s)=>s.id,
    // The launcher's plate, on this page's surface: its hairline gives way to a
    // fill for the same reason.
    AppGlyphPlate: {
        borderWidth: '0',
        background: 'overlayStrong'
    },
    AhText: {
        flow: 'y',
        gap: 'Y',
        minWidth: 'F',
        flex: '1 1 0',
        AhName: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            overflowWrap: 'break-word',
            text: (el, s)=>el.call('storeItemText', {
                    key: s.appKey,
                    name: s.title
                }, 'name')
        },
        AhChips: {
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Y',
            AppStatusChip_source: {
                label: (el, s)=>s.source === 'ai' ? 'workspace.appsHub.source.ai' : s.source === 'custom' ? 'workspace.appsHub.source.custom' : 'workspace.appsHub.source.store'
            },
            AppStatusChip_channel: {
                hide: (el, s)=>!s.installed,
                status: (el, s)=>s.channel === 'development' ? 'warning' : null,
                label: (el, s)=>s.channel === 'development' ? 'workspace.appsHub.channel.development' : 'workspace.appsHub.channel.production'
            },
            AppStatusChip_state: {
                hide: (el, s)=>!!s.installed,
                label: 'workspace.appsHub.state.notInstalled'
            }
        }
    },
    AhActions: {
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Y',
        flexShrink: '0',
        AhOpen: {
            extends: 'AppCapsuleBtnPrimary',
            compact: true,
            hide: (el, s)=>!s.installed || !s.route,
            text: '{{ workspace.appsHub.action.open | polyglot }}',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('appsHubOpen', s.parse ? s.parse() : s);
            }
        },
        AhEdit: {
            extends: 'AppCapsuleBtnGhost',
            compact: true,
            hide: (el, s)=>s.source !== 'ai' || !s.projectId,
            text: '{{ workspace.appsHub.action.edit | polyglot }}',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('appsHubEdit', s.parse ? s.parse() : s);
            }
        },
        AhManage: {
            extends: 'AppCapsuleBtnGhost',
            compact: true,
            hide: (el, s)=>s.source === 'ai' || !s.owner || !s.appKey,
            text: '{{ workspace.appsHub.action.manage | polyglot }}',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('appsHubManage', s.parse ? s.parse() : s);
            }
        }
    }
};

});

parcelRegister("f04Jo", function(module, exports) {

$parcel$export(module.exports, "AppsHubSection", () => $aeba869875edfa50$export$cd624ded71032825);
// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.
// One section: a heading and a grid of AppsHubCard rows. `sectionKey` names
// the model list it shows; the section hides when that list is empty.
const $aeba869875edfa50$export$cd624ded71032825 = {
    tag: 'section',
    flow: 'y',
    gap: 'Z2',
    minWidth: '0',
    sectionKey: 'installed',
    hideDeps: [
        'workspaceApps',
        'workspaceProject',
        'workspace',
        '_userApps',
        '_wsAppsCatalog',
        '_projectsForActiveOrg',
        '_workspacePresets'
    ],
    hide: (el, s)=>!(el.call('appsHubModel', s.root)[el.sectionKey] || []).length,
    AhHeading: {
        tag: 'h2',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'caption',
        text: (el)=>el.call('polyglot', el.parent.sectionKey === 'team' ? 'workspace.appsHub.section.team' : el.parent.sectionKey === 'store' ? 'workspace.appsHub.section.store' : 'workspace.appsHub.section.installed')
    },
    AhGrid: {
        display: 'grid',
        gap: 'Z2',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-G)), 1fr))',
        childExtends: 'AppsHubCard',
        childrenAs: 'state',
        childrenDeps: [
            'workspaceApps',
            'workspaceProject',
            'workspace',
            '_userApps',
            '_wsAppsCatalog',
            '_projectsForActiveOrg',
            '_workspacePresets'
        ],
        children: (el, s)=>el.call('appsHubModel', s.root)[el.parent.sectionKey] || []
    }
};

});

parcelRegister("9nj5Y", function(module, exports) {

$parcel$export(module.exports, "AppsHubMain", () => $6d3512f86590a186$export$f6a36c4d800a7a68);
// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.
// The page body: lede, the three sections, the empty state, the way to the
// Websites view.
const $6d3512f86590a186$export$f6a36c4d800a7a68 = {
    flow: 'y',
    gap: 'B',
    padding: 'A',
    minWidth: '0',
    overflow: 'auto',
    onRender: (el)=>{
        if (el.__appsHubLoaded) return;
        el.__appsHubLoaded = true;
        el.call('appsHubLoad');
    },
    // THE ONE CATALOGUE's row (Nika's decision 7, "one catalogue": /apps + an
    // App Store tab; persona audit round 1, ledger AS-3): this page is its
    // "Workspace apps" tab, /apps/store its App Store tab — the store draws the
    // same row, so the two read as one place.
    AppsCatalogueTabs: {
        current: 'apps'
    },
    AhLede: {
        tag: 'p',
        margin: '0',
        color: 'caption',
        fontSize: 'Z2',
        text: '{{ workspace.appsHub.lede | polyglot }}'
    },
    AppsHubSection_installed: {
        sectionKey: 'installed'
    },
    AppsHubSection_team: {
        sectionKey: 'team'
    },
    AppsHubSection_store: {
        sectionKey: 'store'
    },
    AhEmpty: {
        flow: 'y',
        align: 'flex-start',
        gap: 'Z',
        hideDeps: [
            'workspaceApps',
            'workspaceProject',
            'workspace',
            '_userApps',
            '_wsAppsCatalog',
            '_projectsForActiveOrg',
            '_workspacePresets'
        ],
        hide: (el, s)=>{
            const m = el.call('appsHubModel', s.root);
            return m.installed.length + m.team.length > 0;
        },
        AhEmptyTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: '{{ workspace.appsHub.empty.title | polyglot }}'
        },
        AhEmptyBody: {
            tag: 'p',
            margin: '0',
            color: 'caption',
            fontSize: 'Z2',
            text: '{{ workspace.appsHub.empty.body | polyglot }}'
        }
    },
    AhToWebsites: {
        extends: 'Link',
        href: '/studio',
        alignSelf: 'flex-start',
        fontSize: 'Z2',
        color: 'caption',
        textDecoration: 'underline',
        ':hover': {
            color: 'title'
        },
        ':active': {
            color: 'title'
        },
        text: '{{ workspace.appsHub.toWebsites | polyglot }}',
        onClick: (e, el)=>{
            e.preventDefault();
            el.call('openAppPage', '/studio');
        }
    }
};

});

parcelRegister("3jIl9", function(module, exports) {

$parcel$export(module.exports, "AppsHubActions", () => $26a58a7af74b1d2b$export$942aca70cc8e43);
// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.
// The header's two actions — the two ways a workspace app comes to be.
const $26a58a7af74b1d2b$export$942aca70cc8e43 = {
    flow: 'x',
    flexWrap: 'wrap',
    gap: 'Y',
    AhBuild: {
        extends: 'AppCapsuleBtnPrimary',
        compact: true,
        text: '{{ workspace.appsHub.buildWithAi | polyglot }}',
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('openAppPage', '/add-app');
        }
    },
    AhStore: {
        extends: 'AppCapsuleBtnGhost',
        compact: true,
        text: '{{ workspace.appsHub.browseStore | polyglot }}',
        onClick: (e, el)=>{
            e.stopPropagation();
            // The catalogue's App Store tab (decision 7), in the shell's pane like
            // the navbar's Apps — /apps/store is no app-window route.
            el.call('openAppPage', '/apps/store', {
                preferSlot: true
            });
        }
    }
};

});

parcelRegister("5kkuE", function(module, exports) {

$parcel$export(module.exports, "AppsCatalogueTab", () => $3e0eb78d05a29e60$export$fd5656bf1a03d501);
$parcel$export(module.exports, "AppsCatalogueTabs", () => $3e0eb78d05a29e60$export$a05bda4c06737a0c);
// THE ONE CATALOGUE's two places (Nika's decision 7, "one catalogue": /apps +
// an App Store tab; persona audit round 1, ledger AS-3 — tomas pressed "Apps"
// and met a developer studio, elena met three names for one store). The
// workspace's own apps live at /apps, the App Store at /apps/store; the
// shell's /apps page and the App Store both draw this row, so the two read as
// one catalogue with two tabs.
//
// Links between two PAGES — a `nav` with `aria-current="page"` on the place
// shown, not a tablist (a tablist's panels share one page; these do not). The
// row's `current` ('apps' | 'store') names the place it is drawn on. The words
// are the two places' own nav labels — the Apps views card's "Workspace apps"
// and the launcher's "App Store" (`shell` is a boot namespace, so both resolve
// on the first paint) — so the bar, the menu and this row say the same words.
//
// A SHELL component (the shell owns /apps and the `shell.*` words). The App
// Store borrows it by bare key only in catalogue mode, which is in-shell only
// (marketplace `initMarketplaceCatalogueMode`). Its look is the store's
// `MarketplaceSegment`, an eager marketplace component (marketplace
// components/eagerSlice.js), so it resolves on the shell's /apps page before
// any store route folds the marketplace context.
// One place. A real `Link` (Rule 41) with the store's segment look. Inside the
// shell a press opens the place in the shell's pane, as the navbar's Apps does
// (`preferSlot`): neither /apps nor /apps/store is an app-window route, so a
// plain openAppPage left the pane for a full page (live on dev, 2026-10-25).
const $3e0eb78d05a29e60$export$fd5656bf1a03d501 = {
    extends: [
        'Link',
        'MarketplaceSegment'
    ],
    href: (el, s)=>s.href,
    isActive: (el, s)=>!!s.current,
    aria: {
        current: (el, s)=>s.current ? 'page' : null
    },
    onClick: (e, el, s)=>{
        if (s.current) {
            e.preventDefault();
            return;
        }
        if (typeof el.context?.functions?.openAppPage !== 'function') return;
        e.preventDefault();
        el.call('openAppPage', s.href, {
            preferSlot: true
        });
    }
};
const $3e0eb78d05a29e60$export$a05bda4c06737a0c = {
    tag: 'nav',
    flow: 'x',
    align: 'center',
    gap: 'X',
    padding: 'X',
    alignSelf: 'center',
    // Never squeezed: the row clips its overflow (overflowY hidden), so in a
    // height-bound column — the Apps page scrolls — a shrinkable row collapsed
    // to a sliver and cut its words in half (live on dev, 2026-10-25).
    flexShrink: '0',
    // Radius token clamps to a true stadium shape (the house trick the surface
    // switcher's track uses).
    round: 'radiusPill',
    background: 'overlay',
    minWidth: '0',
    maxWidth: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    aria: {
        label: (el)=>el.call('polyglot', 'shell.app.studio')
    },
    childrenAs: 'state',
    childExtends: 'AppsCatalogueTab',
    children: (el)=>[
            {
                key: 'catalogue-apps',
                href: '/apps',
                label: 'shell.viewNav.workspaceApps',
                current: el.current === 'apps'
            },
            {
                key: 'catalogue-store',
                href: '/apps/store',
                label: 'shell.launcher.appStore',
                current: el.current === 'store'
            }
        ]
};

});

parcelRegister("4xA9n", function(module, exports) {

$parcel$export(module.exports, "HistoryRailRow", () => $34e6493048183402$export$9309102eb74c1c94);
$parcel$export(module.exports, "HistoryRailCount", () => $34e6493048183402$export$233b43edfc05a014);
$parcel$export(module.exports, "HistoryEveryoneRow", () => $34e6493048183402$export$25bf8bc78ecc7ad5);
$parcel$export(module.exports, "HistoryPersonRow", () => $34e6493048183402$export$5d0f15d36db28f27);
$parcel$export(module.exports, "HistoryAllTypesRow", () => $34e6493048183402$export$25ab1bdc242f2beb);
$parcel$export(module.exports, "HistoryTypeRow", () => $34e6493048183402$export$cea73f0c98bc3990);
$parcel$export(module.exports, "HistoryRail", () => $34e6493048183402$export$60cb93c4adcee489);
$parcel$export(module.exports, "HistoryStepBtn", () => $34e6493048183402$export$d9c6a6ed74fb3d55);
$parcel$export(module.exports, "HistoryRailIsland", () => $34e6493048183402$export$d2f6460f24a8bee2);
$parcel$export(module.exports, "HistoryNotice", () => $34e6493048183402$export$6e81875d9660133c);
$parcel$export(module.exports, "HistoryEventCard", () => $34e6493048183402$export$4faa09127b79c1f4);
$parcel$export(module.exports, "HistoryAuthorGroup", () => $34e6493048183402$export$792f6a2d7f660445);
$parcel$export(module.exports, "HistoryStation", () => $34e6493048183402$export$ac36aaef144fbbcf);
$parcel$export(module.exports, "HistoryHalf", () => $34e6493048183402$export$b7b4c4f7d34e1e93);
$parcel$export(module.exports, "HistoryHalfLabel", () => $34e6493048183402$export$4d77db84666dfba5);
$parcel$export(module.exports, "HistoryHalfCards", () => $34e6493048183402$export$c4c53e35f4ba89c4);
$parcel$export(module.exports, "HistoryDensity", () => $34e6493048183402$export$914fd22257ba2a89);
$parcel$export(module.exports, "HistoryDay", () => $34e6493048183402$export$9b30bb5eea83fedc);
$parcel$export(module.exports, "HistoryStage", () => $34e6493048183402$export$c6ef82e42332e3d5);
// History — the workspace activity log as a horizontal timeline (Nika
// 2026-09-26: "a very beautiful timeline experience that scrolls
// horizontally and shows histories of activities made by everyone"). The
// stage scrolls sideways through DAYS, newest first: one station per day on
// one axis, and under each station a card per person active that day with
// their events, newest first. The rail beside it filters by person and by
// activity type; the header steps the stage a day at a time.
//
// Chrome register: the sheet is flat, the person cards are the branded
// `card` a step above it, no strokes anywhere — the axis is a painted
// hairline, not a border. Every shaping call is functions/history.js; these
// components hold no logic of their own.
// ── The rail ─────────────────────────────────────────────────────────────
// One filter row of the rail: the compact control height, the house hover
// and press washes, the pressed state as the `selected` step (monochrome —
// hue never marks selection). The person and type rows extend it and declare
// their own pressed predicate.
const $34e6493048183402$export$9309102eb74c1c94 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    width: '100%',
    minHeight: 'controlHCompact',
    padding: 'X Z1',
    round: 'radiusPill',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    // The rail already reads at `Z` (AppSidebar); em tokens compound, so the
    // row keeps the rail's size and its count steps down once.
    fontSize: 'A',
    fontWeight: '500',
    color: 'inactive',
    transition: 'Z defaultBezier background, Z defaultBezier color',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    ':active': {
        background: 'selected',
        color: 'title'
    },
    ':focus-visible': {
        background: 'selected',
        color: 'title'
    },
    '@coarse': {
        minHeight: 'controlH'
    }
};
const $34e6493048183402$export$233b43edfc05a014 = {
    tag: 'span',
    flexShrink: '0',
    fontSize: 'Z1',
    fontFamily: 'Code',
    color: 'caption'
};
const $34e6493048183402$export$25bf8bc78ecc7ad5 = {
    extends: 'HistoryRailRow',
    background: (el, s)=>s.root && s.root.historyPerson ? 'transparent' : 'selected',
    color: (el, s)=>s.root && s.root.historyPerson ? 'inactive' : 'title',
    fontWeight: (el, s)=>s.root && s.root.historyPerson ? '500' : '700',
    'aria-pressed': (el, s)=>s.root && s.root.historyPerson ? 'false' : 'true',
    onClick: (e, el)=>{
        e.preventDefault();
        el.call('setHistoryPerson', null);
    },
    Glyph: {
        boxSize: 'A1',
        round: 'radiusPill',
        flexShrink: '0',
        background: 'widgetPlate',
        flow: 'x',
        align: 'center center',
        Icon: {
            name: 'people',
            boxSize: 'Z2',
            color: 'caption'
        }
    },
    Name: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        text: '{{ workspace.history.rail.everyone | polyglot }}'
    },
    HistoryRailCount: {
        text: (el, s)=>String(el.call('historyRows', s.root, {
                person: null
            }).length)
    }
};
const $34e6493048183402$export$5d0f15d36db28f27 = {
    extends: 'HistoryRailRow',
    background: (el, s)=>s.root && s.root.historyPerson === s._email ? 'selected' : 'transparent',
    color: (el, s)=>s.root && s.root.historyPerson === s._email ? 'title' : 'inactive',
    fontWeight: (el, s)=>s.root && s.root.historyPerson === s._email ? '700' : '500',
    'aria-pressed': (el, s)=>s.root && s.root.historyPerson === s._email ? 'true' : 'false',
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('setHistoryPerson', s._email);
    },
    // A background-image circle, not a bare `Avatar` key: that key extends the
    // framework built-in, an <img> that takes no `background` fill.
    Monogram: {
        boxSize: 'A1',
        round: 'radiusPill',
        flexShrink: '0',
        background: (el, s)=>el.call('historyPersonAvatar', s._email)
    },
    Name: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>el.call('historyPersonName', s._email)
    },
    HistoryRailCount: {
        text: (el, s)=>String(s._count || 0)
    }
};
const $34e6493048183402$export$25ab1bdc242f2beb = {
    extends: 'HistoryRailRow',
    background: (el, s)=>s.root && s.root.historyType ? 'transparent' : 'selected',
    color: (el, s)=>s.root && s.root.historyType ? 'inactive' : 'title',
    fontWeight: (el, s)=>s.root && s.root.historyType ? '500' : '700',
    'aria-pressed': (el, s)=>s.root && s.root.historyType ? 'false' : 'true',
    onClick: (e, el)=>{
        e.preventDefault();
        el.call('setHistoryType', null);
    },
    Glyph: {
        boxSize: 'A1',
        round: 'radiusPill',
        flexShrink: '0',
        background: 'widgetPlate',
        flow: 'x',
        align: 'center center',
        Icon: {
            name: 'sfHistory',
            boxSize: 'Z2',
            color: 'caption'
        }
    },
    Name: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        text: '{{ workspace.history.rail.allTypes | polyglot }}'
    },
    HistoryRailCount: {
        text: (el, s)=>String(el.call('historyRows', s.root, {
                type: null
            }).length)
    }
};
const $34e6493048183402$export$cea73f0c98bc3990 = {
    extends: 'HistoryRailRow',
    background: (el, s)=>s.root && s.root.historyType === s._type ? 'selected' : 'transparent',
    color: (el, s)=>s.root && s.root.historyType === s._type ? 'title' : 'inactive',
    fontWeight: (el, s)=>s.root && s.root.historyType === s._type ? '700' : '500',
    'aria-pressed': (el, s)=>s.root && s.root.historyType === s._type ? 'true' : 'false',
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('setHistoryType', s._type);
    },
    Glyph: {
        boxSize: 'A1',
        round: 'radiusPill',
        flexShrink: '0',
        background: 'widgetPlate',
        flow: 'x',
        align: 'center center',
        Icon: {
            name: (el, s)=>el.call('historyTypeIcon', s._type),
            boxSize: 'Z2',
            color: 'caption'
        }
    },
    Name: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>el.call('polyglot', el.call('historyTypeLabelKey', s._type))
    },
    HistoryRailCount: {
        text: (el, s)=>String(s._count || 0)
    }
};
const $34e6493048183402$export$60cb93c4adcee489 = {
    flow: 'y',
    gap: 'A',
    People: {
        flow: 'y',
        gap: 'Y',
        // `Z1`, not the brand's `Y1`: inside the `Z` rail that compounds to 11px.
        CaptionTitle: {
            fontSize: 'Z1',
            Text: {
                text: '{{ workspace.history.rail.people | polyglot }}'
            }
        },
        HistoryEveryoneRow: {},
        Rows: {
            flow: 'y',
            gap: 'V',
            childExtends: 'HistoryPersonRow',
            childrenAs: 'state',
            children: (el, s)=>el.call('historyPeople', s.root)
        }
    },
    Activity: {
        flow: 'y',
        gap: 'Y',
        CaptionTitle: {
            fontSize: 'Z1',
            Text: {
                text: '{{ workspace.history.rail.activity | polyglot }}'
            }
        },
        HistoryAllTypesRow: {},
        Rows: {
            flow: 'y',
            gap: 'V',
            childExtends: 'HistoryTypeRow',
            childrenAs: 'state',
            children: (el, s)=>el.call('historyTypes', s.root)
        }
    }
};
const $34e6493048183402$export$d9c6a6ed74fb3d55 = {
    extends: 'AdminIconBtn',
    stepDirection: 1,
    stepIcon: 'chevronRight',
    stepLabelKey: 'workspace.history.step.older',
    'aria-label': (el)=>el.call('polyglot', el.stepLabelKey),
    onClick: (e, el)=>{
        e.preventDefault();
        el.call('scrollHistoryStage', el.stepDirection);
    },
    Icon: {
        name: (el)=>el.parent.stepIcon,
        boxSize: 'A'
    }
};
const $34e6493048183402$export$d2f6460f24a8bee2 = {
    extends: 'AppSidebar',
    tag: 'nav',
    id: 'history-rail',
    'aria-label': (el)=>el.call('polyglot', 'workspace.history.rail.aria'),
    pageSidebar: true,
    position: 'absolute',
    top: 'Z1',
    left: 'Z1',
    bottom: 'Z1',
    zIndex: '20',
    padding: '0',
    minHeight: '0',
    pointerEvents: 'none',
    // THE MIRROR for a floating island: the same Z1 gutter at the right edge,
    // and none of the column recipe's turned padding or its step back over a
    // sheet gutter (the island is out of the flow). Stacked, it is static.
    '&[data-sidebar-side="right"]': {
        left: 'auto',
        right: 'Z1',
        padding: '0',
        marginLeft: '0',
        '@mobileL': {
            right: 'auto'
        },
        '@appMobile': {
            right: 'auto'
        }
    },
    '@tabletS': {
        width: 'F1',
        minWidth: 'F1'
    },
    '@mobileL': {
        position: 'static',
        top: 'auto',
        left: 'auto',
        bottom: 'auto',
        zIndex: 'auto',
        pointerEvents: 'auto'
    },
    '@appMobile': {
        position: 'static',
        top: 'auto',
        left: 'auto',
        bottom: 'auto',
        zIndex: 'auto',
        pointerEvents: 'auto'
    },
    // The hide button one Y inside the card's corner (the island has no
    // padding), and live: the island lets the pointer through, the button
    // takes it, like the card.
    SidebarToggle: {
        top: 'Y',
        right: 'Y',
        pointerEvents: 'auto',
        '&[data-side="right"]': {
            right: 'Y'
        }
    },
    // The card is the column's sidebar card (shared AppSidebar childExtends
    // AppSidebarCard, Nika 2026-10-30 "A: navbar glass"): the glass and the
    // `float` lift of every sidebar card come from there.
    HistoryRail: {
        flex: '0 1 auto',
        minHeight: '0',
        overflowY: 'auto',
        overscrollBehaviorY: 'contain',
        pointerEvents: 'auto'
    }
};
const $34e6493048183402$export$6e81875d9660133c = {
    tag: 'p',
    margin: '0',
    padding: 'A B',
    fontSize: 'Z2',
    color: 'caption'
};
const $34e6493048183402$export$4faa09127b79c1f4 = {
    extends: 'Link',
    href: (el, s)=>el.call('historyEventHref', s) || null,
    flow: 'x',
    align: 'flex-start left',
    gap: 'Z',
    padding: 'Y Z',
    round: 'radiusControl',
    minWidth: '0',
    textDecoration: 'none',
    color: 'title',
    transition: 'Z defaultBezier background',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    onClick: (e, el, s)=>{
        // A modified click is the browser's: a new tab or window.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        e.stopPropagation();
        el.call('openHistoryEvent', s);
    },
    Glyph: {
        flexShrink: '0',
        boxSize: 'B',
        round: 'radiusPill',
        background: 'widgetPlate',
        flow: 'x',
        align: 'center center',
        Icon: {
            name: (el, s)=>el.call('historyTypeIcon', s.activity_type),
            boxSize: 'Z2',
            color: 'caption'
        }
    },
    Copy: {
        flow: 'y',
        gap: 'V',
        minWidth: '0',
        flex: '1 1 auto',
        // Not `Line`: that key is the brand's divider component.
        MetaLine: {
            flow: 'x',
            align: 'baseline space-between',
            gap: 'Z',
            Type: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '500',
                color: 'caption',
                whiteSpace: 'nowrap',
                text: (el, s)=>el.call('polyglot', el.call('historyTypeLabelKey', s.activity_type))
            },
            // On the workspace calendar's clock (historyDays stamps its zone on
            // every event) — the one the card's half was chosen by.
            Time: {
                tag: 'span',
                fontSize: 'Y2',
                fontFamily: 'Code',
                color: 'caption',
                whiteSpace: 'nowrap',
                text: (el, s)=>el.call('historyTime', s.created_at, s._timeZone)
            }
        },
        // Two lines at most; a long ticket title ends in an ellipsis.
        Title: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '500',
            lineHeight: '1.4',
            color: 'title',
            overflow: 'hidden',
            display: '-webkit-box',
            lineClamp: '2',
            overflowWrap: 'anywhere',
            text: (el, s)=>el.call('historyEventTitle', s)
        },
        Ref: {
            hide: (el, s)=>!el.call('historyEventRef', s),
            tag: 'span',
            fontSize: 'Y2',
            fontFamily: 'Code',
            color: 'caption',
            text: (el, s)=>el.call('historyEventRef', s)
        }
    }
};
const $34e6493048183402$export$792f6a2d7f660445 = {
    extends: 'CommonCard',
    padding: 'Z1',
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    Person: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        minWidth: '0',
        padding: '0 Y',
        Monogram: {
            boxSize: 'B',
            round: 'radiusPill',
            flexShrink: '0',
            background: (el, s)=>el.call('historyPersonAvatar', s._email)
        },
        Copy: {
            flow: 'y',
            gap: '0',
            minWidth: '0',
            // The person is the third heading level: page title, day, person.
            Name: {
                tag: 'h3',
                margin: '0',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>el.call('historyPersonName', s._email)
            },
            Meta: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>el.call('polyglot', s._count === 1 ? 'workspace.history.group.statsOne' : 'workspace.history.group.stats').replace('{count}', String(s._count || 0)).replace('{score}', String(s._score || 0))
            }
        }
    },
    Events: {
        flow: 'y',
        gap: 'X',
        childExtends: 'HistoryEventCard',
        childrenAs: 'state',
        children: (el, s)=>el.call('historyGroupEvents', s)
    },
    MoreBtn: {
        extends: 'AdminActionBtnCompact',
        alignSelf: 'flex-start',
        hide: (el, s)=>(s._count || 0) <= 3,
        'aria-expanded': (el, s)=>s.root && s.root._historyExpanded && s.root._historyExpanded[s._groupKey] ? 'true' : 'false',
        text: (el, s)=>s.root && s.root._historyExpanded && s.root._historyExpanded[s._groupKey] ? el.call('polyglot', 'workspace.history.group.less') : el.call('polyglot', 'workspace.history.group.more').replace('{count}', String(s._count || 0)),
        onClick: (e, el, s)=>{
            e.preventDefault();
            el.call('toggleHistoryGroup', s._groupKey);
        }
    }
};
const $34e6493048183402$export$ac36aaef144fbbcf = {
    position: 'relative',
    zIndex: '1',
    flow: 'y',
    gap: 'Y',
    paddingBottom: 'Y',
    minWidth: '0',
    HistoryDensity: {},
    Axis: {
        position: 'relative',
        height: 'A',
        // The axis: from the column's left edge (back across the column's `A`
        // inset, under the previous column's right inset) to its right edge,
        // so neighbouring stations meet in one line. On the row's top edge —
        // the station's — so the range under it starts exactly at the line.
        '::before': {
            content: '""',
            position: 'absolute',
            left: '-A',
            right: '0',
            top: '0',
            height: 'hairline',
            background: 'line'
        },
        // The crossing: centred on the day's vertical hairline, which runs on
        // this row's left edge (the column's `A` inset, where HistoryDay paints it).
        Dot: {
            position: 'absolute',
            left: '0',
            top: '0',
            transform: 'translate(-50%, -50%)',
            boxSize: 'Z',
            round: 'radiusPill',
            background: 'title'
        }
    },
    // The heading resets to the station's size: the type letters are em steps
    // and compound on a heading's own size (the day read as a 73px numeral
    // next to a 33px "micro-label", and "25 Sept YESTERDAY" ran into the next
    // column). The day is the poster numeral (`I`, the reference's big years),
    // the month a step above body, the weekday the micro-label. A day the
    // workspace calendar does not work (a weekend, a holiday) reads its numeral
    // a step quieter, in the caption ink — the week's shape at a glance.
    Date: {
        tag: 'h2',
        margin: '0',
        fontSize: 'A',
        paddingLeft: 'Y',
        paddingRight: 'A',
        flow: 'x',
        align: 'baseline left',
        gap: 'Y',
        minWidth: '0',
        Day: {
            tag: 'span',
            fontSize: 'I',
            fontWeight: '700',
            lineHeight: '1',
            color: (el, s)=>s._workday === false ? 'caption' : 'title',
            text: (el, s)=>el.call('historyStation', s._day, s._timeZone).day
        },
        Month: {
            tag: 'span',
            fontSize: 'C',
            fontWeight: '500',
            color: 'caption',
            text: (el, s)=>{
                const at = el.call('historyStation', s._day, s._timeZone);
                return at.year ? `${at.month} ${at.year}` : at.month;
            }
        },
        // The weekday as a tracked micro-label; today and yesterday say so.
        // `caption`, not `inactive`: the station sits on the sheet, not on a
        // raised card.
        Weekday: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '500',
            fontFamily: 'Code',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: 'caption',
            text: (el, s)=>{
                const at = el.call('historyStation', s._day, s._timeZone);
                return at.relative || at.weekday;
            }
        }
    },
    Meta: {
        tag: 'span',
        paddingLeft: 'Y',
        paddingRight: 'A',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>[
                el.call('historyCountText', 'workspace.history.count.events', 'workspace.history.count.eventsOne', s._count),
                el.call('historyCountText', 'workspace.history.count.people', 'workspace.history.count.peopleOne', s._people)
            ].join(" \xb7 ")
    }
};
const $34e6493048183402$export$b7b4c4f7d34e1e93 = {
    position: 'relative',
    zIndex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Y',
    minHeight: '0',
    minWidth: '0',
    paddingLeft: 'Y',
    paddingRight: 'A',
    HistoryHalfLabel: {},
    HistoryHalfCards: {}
};
const $34e6493048183402$export$4d77db84666dfba5 = {
    tag: 'span',
    flexShrink: '0',
    fontSize: 'Y2',
    fontFamily: 'Code',
    whiteSpace: 'nowrap',
    color: (el, s)=>s._workday === false ? 'inactive' : 'caption'
};
const $34e6493048183402$export$c4c53e35f4ba89c4 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    flex: '1 1 0',
    minHeight: '0',
    minWidth: '0',
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehaviorY: 'contain',
    'data-history-scroll': 'y',
    childExtends: 'HistoryAuthorGroup',
    childrenAs: 'state'
};
const $34e6493048183402$export$914fd22257ba2a89 = {
    position: 'absolute',
    zIndex: '-1',
    left: '-A',
    right: '0',
    top: '0',
    bottom: '0',
    background: 'widgetPlate',
    clipPath: (el, s)=>s._densityClip || 'none',
    pointerEvents: 'none'
};
const $34e6493048183402$export$9b30bb5eea83fedc = {
    tag: 'article',
    position: 'relative',
    display: 'grid',
    gridTemplateRows: 'minmax(0, 1fr) auto minmax(0, 1fr)',
    minWidth: '0',
    minHeight: '0',
    paddingLeft: 'A',
    '::before': {
        content: '""',
        position: 'absolute',
        left: 'A',
        top: '0',
        bottom: '0',
        width: 'hairline',
        background: 'line'
    },
    // The station comes first in the DOM — the day's h2 before its people's
    // h3s, so the heading order holds — and the grid rows place the halves
    // around it: the first half above, the station, the second half below.
    HistoryStation: {
        gridRow: '2'
    },
    // The first half of the working day, above the axis.
    HistoryHalf: {
        gridRow: '1',
        flexDirection: 'column-reverse',
        paddingTop: 'Z',
        paddingBottom: 'Y',
        HistoryHalfLabel: {
            text: (el, s)=>el.call('historyHalfRange', s._firstRange)
        },
        HistoryHalfCards: {
            flexDirection: 'column-reverse',
            children: (el, s)=>s._firstHalf
        }
    },
    // The second half, under it.
    HistoryHalf_1: {
        gridRow: '3',
        paddingTop: 'Y',
        paddingBottom: 'Z',
        HistoryHalfLabel: {
            text: (el, s)=>el.call('historyHalfRange', s._secondRange)
        },
        HistoryHalfCards: {
            children: (el, s)=>s._secondHalf
        }
    }
};
const $34e6493048183402$export$c6ef82e42332e3d5 = {
    tag: 'section',
    'aria-label': (el)=>el.call('polyglot', 'workspace.history.stage.aria'),
    tabindex: '0',
    flex: '1 1 0',
    minHeight: '0',
    minWidth: '0',
    overflowX: 'auto',
    overflowY: 'hidden',
    overscrollBehaviorX: 'contain',
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'G',
    gridTemplateRows: '100%',
    alignItems: 'stretch',
    paddingTop: '0',
    paddingBottom: '0',
    // The island's width plus the gutter on each side of it, on the island's
    // side; the stage's own gutter on the other side and while the island is
    // hidden. A phone stacks the island above the stage instead, so the inset
    // is the stage's gutter there whatever the island does. The island's side
    // and the hidden choice are the page sidebar's (shared
    // functions/pageSidebar.js — page chrome outside the island asks for its
    // page): attributes with static rules. An attribute rule outranks a
    // single class's media rule, so each rule restates the narrow gutter.
    paddingRight: 'B',
    paddingLeft: 'G+B',
    'data-sidebar-side': (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).side,
    'data-sidebar-hidden': (el, s)=>(el.call('pageSidebarRead', s.root, el) || {}).hidden ? 'true' : null,
    '&[data-sidebar-side="right"]': {
        paddingLeft: 'B',
        paddingRight: 'G+B',
        '@mobileL': {
            paddingLeft: 'A',
            paddingRight: 'A'
        },
        '@appMobile': {
            paddingLeft: 'A',
            paddingRight: 'A'
        }
    },
    '&[data-sidebar-hidden]': {
        paddingLeft: 'B',
        '@mobileL': {
            paddingLeft: 'A'
        },
        '@appMobile': {
            paddingLeft: 'A'
        }
    },
    '&[data-sidebar-hidden][data-sidebar-side="right"]': {
        paddingRight: 'B',
        '@mobileL': {
            paddingRight: 'A'
        },
        '@appMobile': {
            paddingRight: 'A'
        }
    },
    boxSizing: 'border-box',
    '@mobileL': {
        paddingLeft: 'A',
        paddingRight: 'A'
    },
    '@appMobile': {
        paddingLeft: 'A',
        paddingRight: 'A'
    },
    childExtends: 'HistoryDay',
    childrenAs: 'state',
    children: (el, s)=>el.call('historyDays', s.root),
    onKeydown: (e, el)=>{
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        el.call('scrollHistoryStage', e.key === 'ArrowRight' ? 1 : -1);
    },
    onWheel: (e, el)=>el.call('panHistoryStage', e)
};

});

parcelRegister("apzqS", function(module, exports) {

$parcel$export(module.exports, "GettingStartedPersonRow", () => $01f4c50db6dda7ce$export$2a40fe2189023bd6);
// GettingStartedPersonRow — one person the onboarding research found on the
// company's own team page (POB S9, pages/gettingStartedTeam.js): the invite
// switch, the name and job title, the e-mail field the OWNER types into
// (never prefilled) and "Remove".
//
// The row state is the found person (functions/gettingStartedTeam.js
// gettingStartedTeamRows — `person*` fields, so no field falls back to a root
// key). The owner's draft is a separate root key read per prop through
// `gettingStartedDraft`: a typed letter re-runs this row's props and never
// rebuilds the list, so the field keeps its caret.
//
// The switch is the consent: it stays OFF until the owner turns it on, and it
// is disabled until the field holds a valid address (typing never flips it).
// An invited person keeps the row with "Invited" in place of the field.
// Phone and a narrow pane: one card per person; the switch and the field
// stack.
const $01f4c50db6dda7ce$export$2a40fe2189023bd6 = {
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    '@mobileL': {
        flow: 'y',
        align: 'stretch',
        gap: 'Z'
    },
    '@appMobile': {
        flow: 'y',
        align: 'stretch',
        gap: 'Z'
    },
    GsprHead: {
        flow: 'x',
        align: 'center',
        gap: 'A',
        flex: '1 1 0',
        minWidth: '0',
        GsprSwitch: {
            extends: 'SwitchInput',
            onCheck: (el, s)=>el.call('gettingStartedDraft', s.root, s.personId).on,
            // Disabled until the owner typed a valid address; an invited person
            // keeps the box (no shift) with the switch out of reach.
            disabled: (el, s)=>{
                const draft = el.call('gettingStartedDraft', s.root, s.personId);
                return s.invitedAt || !el.call('gettingStartedEmailOk', draft.email) ? true : undefined;
            },
            visibility: (el, s)=>s.invitedAt ? 'hidden' : 'visible',
            'aria-label': (el, s)=>{
                s.root?.lang;
                return el.call('polyglot', 'workspace.gettingStarted.team.switchAria').replace('{name}', s.personName);
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                el.call('toggleGettingStartedInvite', s.root, s.personId);
            }
        },
        GsprWho: {
            flow: 'y',
            gap: 'X',
            minWidth: '0',
            GsprName: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '500',
                color: 'title',
                overflowWrap: 'anywhere',
                text: (el, s)=>s.personName
            },
            GsprRole: {
                tag: 'span',
                fontSize: 'Z',
                color: 'caption',
                overflowWrap: 'anywhere',
                hide: (el, s)=>!s.personRole,
                text: (el, s)=>s.personRole
            }
        }
    },
    GsprEmail: {
        flow: 'y',
        gap: 'X',
        flex: '0 1 G',
        minWidth: '0',
        '@mobileL': {
            flex: 'none',
            width: '100%'
        },
        '@appMobile': {
            flex: 'none',
            width: '100%'
        },
        AppInputCompact: {
            type: 'email',
            inputmode: 'email',
            autocomplete: 'off',
            spellcheck: 'false',
            // Typed addresses are a draft the page keeps, not unsaved work to
            // guard: a pane close keeps them, so no "Discard changes?".
            dirty: false,
            hide: (el, s)=>!!s.invitedAt,
            value: (el, s)=>el.call('gettingStartedDraft', s.root, s.personId).email,
            placeholder: '{{ workspace.gettingStarted.team.emailPlaceholder | polyglot }}',
            ariaLabel: (el, s)=>{
                s.root?.lang;
                return el.call('polyglot', 'workspace.gettingStarted.team.emailAria').replace('{name}', s.personName);
            },
            onInput: (e, el, s)=>el.call('setGettingStartedEmail', s.root, s.personId, el.node.value)
        },
        GsprInvited: {
            tag: 'span',
            flow: 'x',
            align: 'center',
            gap: 'X',
            minHeight: 'controlHCompact',
            fontSize: 'Z',
            fontWeight: '500',
            color: 'title',
            hide: (el, s)=>!s.invitedAt,
            Icon: {
                name: 'check',
                boxSize: 'A',
                color: 'title'
            },
            Text: {
                text: '{{ workspace.gettingStarted.team.invited | polyglot }}'
            }
        },
        // One reserved line under the field (Rule 66): the company tick, or why
        // this row did not go out. A live region from mount, so a change is read.
        GsprNote: {
            tag: 'span',
            role: 'status',
            minHeight: 'Z1',
            fontSize: 'Y1',
            fontWeight: '500',
            color: (el, s)=>el.call('gettingStartedDraft', s.root, s.personId).status === 'failed' ? 'dangerInk' : 'caption',
            text: (el, s)=>{
                s.root?.lang;
                const draft = el.call('gettingStartedDraft', s.root, s.personId);
                if (draft.status === 'failed') return el.call('polyglot', draft.error === 'invalid_email' ? 'workspace.gettingStarted.team.invalidEmail' : draft.error === 'removeFailed' ? 'workspace.gettingStarted.team.removeFailed' : 'workspace.gettingStarted.team.failed');
                if (s.invitedAt) return '';
                return el.call('gettingStartedOnDomain', s.root, draft.email) ? el.call('polyglot', 'workspace.gettingStarted.team.company') : '';
            }
        }
    },
    GsprRemove: {
        extends: 'AppCapsuleBtnGhost',
        compact: true,
        flexShrink: '0',
        '@mobileL': {
            alignSelf: 'flex-start'
        },
        '@appMobile': {
            alignSelf: 'flex-start'
        },
        disabled: (el, s)=>el.call('gettingStartedDraft', s.root, s.personId).status === 'removing' ? true : undefined,
        'aria-label': (el, s)=>{
            s.root?.lang;
            return el.call('polyglot', 'workspace.gettingStarted.team.removeAria').replace('{name}', s.personName);
        },
        text: '{{ workspace.gettingStarted.team.remove | polyglot }}',
        onClick: (e, el, s)=>{
            // markPageSaved: opt-out — a removal writes at once; the row's e-mail field is a draft (dirty: false), no kit field holds an edit
            e.preventDefault();
            // markPageSaved: opt-out — the server drops a researched row; no kit field holds an edit (the e-mail drafts are dirty: false)
            // A plain id, read before the await: the row state re-binds when the
            // list shrinks.
            const personId = s.personId;
            el.call('removeGettingStartedPerson', s.root, personId);
        }
    }
};

});

parcelRegister("i5Ges", function(module, exports) {

$parcel$export(module.exports, "GettingStartedSourceRow", () => $d2b9740e6b6a98f8$export$c2706b0d52863ce4);
// GettingStartedSourceRow — one import connector other than the owner's own
// file (POB S10, pages/gettingStartedImports.js): its name, and "Coming soon"
// until the server can use it — then "Preview", which reads it by its id.
//
// The row state is the connector (functions/gettingStartedImports.js
// gettingStartedImportRows — `source*` fields, so no field falls back to a
// root key; both names, so a language switch needs no new list). Phone and a
// narrow pane: the button goes under the name.
const $d2b9740e6b6a98f8$export$c2706b0d52863ce4 = {
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    '@mobileL': {
        flow: 'y',
        align: 'stretch',
        gap: 'Z'
    },
    '@appMobile': {
        flow: 'y',
        align: 'stretch',
        gap: 'Z'
    },
    GssrHead: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        flex: '1 1 0',
        minWidth: '0',
        Icon: {
            name: 'database',
            boxSize: 'A',
            color: 'caption',
            flexShrink: '0',
            'aria-hidden': true
        },
        GssrName: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s.root?.lang === 'ka' ? s.sourceNameKa : s.sourceNameEn
        }
    },
    // Not live yet: said, with nothing to press (plan §7b-2: no dead buttons).
    // The control's own height, so a row keeps its size when it turns live.
    GssrSoon: {
        tag: 'span',
        flow: 'x',
        align: 'center',
        flexShrink: '0',
        minHeight: 'controlHCompact',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'caption',
        hide: (el, s)=>!!s.sourceLive,
        text: '{{ common.state.coming_soon | polyglot }}'
    },
    GssrPreview: {
        extends: 'AppCapsuleBtnToolbar',
        compact: true,
        flexShrink: '0',
        '@mobileL': {
            alignSelf: 'flex-start'
        },
        '@appMobile': {
            alignSelf: 'flex-start'
        },
        hide: (el, s)=>!s.sourceLive,
        // One preview at a time: the read is a server job.
        disabled: (el, s)=>s.root.gettingStartedUploading ? true : undefined,
        'aria-label': (el, s)=>el.call('polyglot', 'workspace.gettingStarted.imports.previewAria').replace('{name}', s.root?.lang === 'ka' ? s.sourceNameKa : s.sourceNameEn),
        text: '{{ workspace.gettingStarted.imports.preview | polyglot }}',
        onClick: (e, el, s)=>{
            e.preventDefault();
            // A plain id, read before the await: the row state re-binds when the
            // list is read again.
            const sourceId = s.sourceId;
            el.call('reviewGettingStartedSource', s.root, sourceId);
        }
    }
};

});

parcelRegister("h9Qog", function(module, exports) {

$parcel$export(module.exports, "GettingStartedColumnRow", () => $c7dbea96e20fd079$export$f45185e8c408c505);
// GettingStartedColumnRow — one column of the open import preview (POB S10,
// pages/gettingStartedImports.js): its name, a few of its values, and the
// field of the chosen app it goes into ("Skip this column" when nothing
// matched it) — or, for a collection with no fields declared, "Add as a new
// field".
//
// The row state is the column (functions/gettingStartedImports.js
// gettingStartedImportColumns — `column*` fields, so no field falls back to a
// root key). The pick lives in its own root key (`gettingStartedMapping`) and
// is read per prop: a pick re-runs this row's select and never rebuilds the
// list, so the select keeps focus. Phone and a narrow pane: the select goes
// under the name.
const $c7dbea96e20fd079$export$f45185e8c408c505 = {
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    '@mobileL': {
        flow: 'y',
        align: 'stretch',
        gap: 'Z'
    },
    '@appMobile': {
        flow: 'y',
        align: 'stretch',
        gap: 'Z'
    },
    GscrWho: {
        flow: 'y',
        gap: 'X',
        flex: '1 1 0',
        minWidth: '0',
        GscrName: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s.columnLabel
        },
        GscrSamples: {
            tag: 'span',
            fontSize: 'Z',
            color: 'caption',
            overflowWrap: 'anywhere',
            hide: (el, s)=>!s.columnSampleText,
            text: (el, s)=>s.columnSampleText
        }
    },
    GscrField: {
        flex: '0 1 G',
        minWidth: '0',
        '@mobileL': {
            flex: 'none',
            width: '100%'
        },
        '@appMobile': {
            flex: 'none',
            width: '100%'
        },
        AppSelectCompact: {
            // The mapping is a draft the page keeps, not unsaved work to guard: a
            // pane close keeps it, so no "Discard changes?".
            dirty: false,
            ariaLabel: (el, s)=>{
                s.root?.lang;
                return el.call('polyglot', 'workspace.gettingStarted.imports.fieldAria').replace('{column}', s.columnLabel);
            },
            value: (el, s)=>{
                s.root.gettingStartedMapping;
                return el.call('gettingStartedImportPick', s.root, s.columnKey);
            },
            onChange: (e, el, s)=>el.call('setGettingStartedImportMapping', s.root, s.columnKey, e.target.value),
            childExtends: 'AppOption',
            children: (el, s)=>{
                s.root?.lang;
                s.root.gettingStartedMapping;
                s.root.gettingStartedTargets;
                return el.call('gettingStartedImportFieldOptions', s.root, s.columnKey, {
                    skip: el.call('polyglot', 'workspace.gettingStarted.imports.skip'),
                    required: el.call('polyglot', 'workspace.gettingStarted.imports.required'),
                    newField: el.call('polyglot', 'workspace.gettingStarted.imports.newField')
                });
            }
        }
    }
};

});

parcelRegister("aMCzl", function(module, exports) {

$parcel$export(module.exports, "SystemStatusLegendItem", () => $7d9c4e198e5813d2$export$c670aadf64272952);
// System Health's status legend is a registered component because the matrix
// page is lazy-loaded. `childExtends` resolves component names through the
// workspace registry, rather than through a page module's local exports.
//
// `s.color` is the status's dot INK (pages/system.js STATUS: the AA-safe
// successInk / warningInk / dangerInk, or a quiet neutral) — the same ink the
// matrix cell's chip paints, so the legend and the cells agree.
const $7d9c4e198e5813d2$export$c670aadf64272952 = {
    flow: 'x',
    align: 'center left',
    gap: 'Y',
    Dot: {
        width: 'X2',
        height: 'X2',
        round: 'radiusPill',
        flexShrink: '0',
        background: (el, s)=>s.color
    },
    // `s.label` is a bundle KEY (pages/system.js STATUS) — the KEY-IN-STATE form.
    Label: {
        tag: 'span',
        fontSize: 'Z',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', s.label || '')
    }
};

});

parcelRegister("9q0G9", function(module, exports) {

$parcel$export(module.exports, "AppAssistantDecisionCard", () => $6db7118e3fb2f9bb$export$20e85662c829a53b);
$parcel$export(module.exports, "AppAssistantDecisionBanner", () => $6db7118e3fb2f9bb$export$d5e59a0c50bcc4a8);
// AIAssistantDecisions — ASK-USER decision cards for the AI assistant panel.
//
// Surfaces `type=decision` / ASK-USER-labelled tickets that require Nika's
// input before agents can proceed. Mounted as `AppAssistant.Panel.DecisionBanner`
// via the app.js shell override.
//
// Functions called via `el.call`:
//   - fetchAskUserDecisions(root)      — seeds root.askUserDecisions on mount
//   - subscribeAskUserDecisions(root)  — opens realtime channel
//   - unsubscribeAskUserDecisions()    — tears down channel on panel removal
//   - approveDecisionTicket(id, root)  — PATCH state=in_progress + nika_decision=approved
//   - rejectDecisionTicket(id, reason, root) — PATCH state=cancelled + reason
//   - clarifyDecisionTicket(id, text, root)  — PATCH metadata.clarification
//
// All action handlers go through SDK (no raw fetch / direct Supabase).
// Design system tokens only — no raw px/hex.
// v3.14 flat props: `el.X` not `el.props.X`, `onClick` not `on: { click }`.
//
// Root state keys used here (all declared in state.js):
//   root.askUserDecisions       — Array of open ASK-USER ticket rows
//   root._dismissedDecisionIds  — Array of ticket ids dismissed this session
//   root._decisionClarifyId     — ticket id currently in clarify/reject mode (null = none)
//   root._decisionClarifyText   — text typed in the clarify/reject textarea
//   root._decisionClarifyIntent — 'clarify' | 'reject' | null
// ─── Helpers ─────────────────────────────────────────────────────────────────
// Body excerpt — strip light markdown and truncate to 200 chars.
const $6db7118e3fb2f9bb$var$_excerpt = (body, max = 200)=>{
    if (!body) return '';
    const plain = body.replace(/[#*`[\]]/g, '').replace(/\n+/g, ' ').trim();
    return plain.length <= max ? plain : plain.slice(0, max) + "\u2026";
};
// Priority badge color token.
const $6db7118e3fb2f9bb$var$_priorityColor = (p)=>{
    if (p === 'P0') return 'red';
    if (p === 'P1') return 'orange';
    if (p === 'P2') return 'yellow';
    return 'caption';
};
// Read root state from the element in a v3.14-safe way.
// When a component is a child in `childrenAs: 'state'`, `s` is the individual
// item row — NOT the root state. Use `el.getRoot().state` to reach root.
const $6db7118e3fb2f9bb$var$_root = (el)=>el.getRoot?.()?.state;
const $6db7118e3fb2f9bb$export$20e85662c829a53b = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'radiusControl',
    // Borderless law (design-direction.md §91) — `background: 'purple.05'`
    // already separates this card from the panel via fill contrast, same
    // idiom as shared/AiActionConfirmCard's Header/Footer + marketplace's
    // NoOrgWarning ("the hairline was redundant"). The hairline dropped here too.
    background: 'purple.05',
    CardHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        TicketMeta: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            DecisionBadge: {
                tag: 'span',
                text: '{{ workspace.decision.badge | polyglot }}',
                fontSize: 'Y1',
                fontWeight: '700',
                letterSpacing: '.04em',
                textTransform: 'uppercase',
                color: 'purple',
                padding: 'V Z1',
                round: 'radiusPill',
                // Fill only — matches the sibling PriorityBadge two lines below,
                // which never carried a border; the hairline here was the habit.
                background: 'purple.1'
            },
            PriorityBadge: {
                hide: (el, s)=>!s?.priority,
                tag: 'span',
                text: (el, s)=>s?.priority || '',
                fontSize: 'Y1',
                fontWeight: '700',
                color: (el, s)=>$6db7118e3fb2f9bb$var$_priorityColor(s?.priority),
                padding: 'V Z1',
                round: 'radiusPill',
                background: (el, s)=>`${$6db7118e3fb2f9bb$var$_priorityColor(s?.priority)}.1`
            }
        },
        TicketNumber: {
            hide: (el, s)=>!s?.number && !s?.id,
            tag: 'span',
            text: (el, s)=>s?.number ? `#${s.number}` : `#${s?.id}`,
            fontSize: 'Y2',
            color: 'caption',
            flexShrink: '0'
        }
    },
    CardTitle: {
        tag: 'h4',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        lineHeight: '1.4',
        text: (el, s)=>s?.title || el.call('polyglot', 'workspace.aiDecisions.untitled')
    },
    CardBody: {
        hide: (el, s)=>!s?.body,
        tag: 'p',
        margin: '0',
        fontSize: 'Y2',
        color: 'caption',
        lineHeight: '1.55',
        text: (el, s)=>$6db7118e3fb2f9bb$var$_excerpt(s?.body)
    },
    // Options from metadata.options (e.g. ['a', 'b', 'c'])
    OptionsList: {
        hide: (el, s)=>{
            const opts = s?.metadata?.options;
            return !Array.isArray(opts) || opts.length === 0;
        },
        flow: 'y',
        gap: 'V',
        marginTop: 'V',
        OptionsLabel: {
            tag: 'span',
            text: '{{ workspace.decision.options | polyglot }}',
            fontSize: 'Y1',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '.04em',
            color: 'caption'
        },
        OptionsItems: {
            flow: 'y',
            gap: 'V',
            childExtends: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'title',
                padding: 'V Z',
                round: 'radiusControl',
                // Fill only — the hairline was redundant against the surface's own
                // `overlay` fill (same class as canvas/DashboardRows' WorkspaceRow).
                background: 'overlay',
                text: (el, s)=>`\u{2022} ${s?.text ?? ''}`
            },
            childrenAs: 'state',
            children: (el, s)=>{
                const opts = s?.metadata?.options;
                if (!Array.isArray(opts)) return [];
                return opts.map((o, i)=>({
                        key: i,
                        text: o
                    }));
            }
        }
    },
    // ── Action buttons — shown when NOT in clarify/reject mode for this ticket ──
    CardActions: {
        if: (el, s)=>$6db7118e3fb2f9bb$var$_root(el)?._decisionClarifyId !== s?.id,
        flow: 'x',
        gap: 'Z',
        marginTop: 'Z',
        ApproveBtn: {
            tag: 'button',
            type: 'button',
            padding: 'Z A',
            round: 'radiusControl',
            fontSize: 'Z2',
            fontWeight: '700',
            background: 'green',
            color: 'document',
            borderWidth: '0',
            cursor: 'pointer',
            fontFamily: 'inherit',
            text: '{{ workspace.decision.approve | polyglot }}',
            ':hover': {
                background: 'green+10'
            },
            onClick: async (e, el, s)=>{
                const root = $6db7118e3fb2f9bb$var$_root(el);
                if (!root) return;
                await el.call('approveDecisionTicket', s?.id, root);
            }
        },
        RejectBtn: {
            tag: 'button',
            type: 'button',
            padding: 'Z A',
            round: 'radiusControl',
            fontSize: 'Z2',
            fontWeight: '700',
            // Ghost fill (was transparent + `red.3` outline — the outlined-button
            // habit). Same idiom as shared/AiActionConfirmCard.RejectBtn /
            // marketplace/MarketplaceInstallModal's red-wash convention.
            background: 'red.1',
            color: 'red',
            borderWidth: '0',
            cursor: 'pointer',
            fontFamily: 'inherit',
            text: '{{ workspace.decision.reject | polyglot }}',
            ':hover': {
                background: 'red.15'
            },
            onClick: (e, el, s)=>{
                const root = $6db7118e3fb2f9bb$var$_root(el);
                if (!root) return;
                root.update({
                    _decisionClarifyId: s?.id,
                    _decisionClarifyText: '',
                    _decisionClarifyIntent: 'reject'
                });
            }
        },
        ClarifyBtn: {
            tag: 'button',
            type: 'button',
            padding: 'Z A',
            round: 'radiusControl',
            fontSize: 'Z2',
            fontWeight: '500',
            // Ghost fill (was transparent + `line` outline — the outlined-button
            // habit). Rest = overlay, hover = the house hover wash, matching
            // shared/AiActionConfirmCard.RejectBtn exactly.
            background: 'overlay',
            color: 'caption',
            borderWidth: '0',
            cursor: 'pointer',
            fontFamily: 'inherit',
            text: '{{ workspace.decision.clarify | polyglot }}',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            onClick: (e, el, s)=>{
                const root = $6db7118e3fb2f9bb$var$_root(el);
                if (!root) return;
                root.update({
                    _decisionClarifyId: s?.id,
                    _decisionClarifyText: '',
                    _decisionClarifyIntent: 'clarify'
                });
            }
        }
    },
    // ── Clarify form — shown when this card is in 'clarify' mode ────────────────
    ClarifyForm: {
        if: (el, s)=>{
            const root = $6db7118e3fb2f9bb$var$_root(el);
            return root?._decisionClarifyId === s?.id && root?._decisionClarifyIntent === 'clarify';
        },
        flow: 'y',
        gap: 'Z',
        marginTop: 'Z',
        ClarifyLabel: {
            tag: 'span',
            text: '{{ workspace.decision.clarifyLabel | polyglot }}',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption'
        },
        ClarifyInput: {
            tag: 'textarea',
            placeholder: (el)=>el.call('polyglot', 'workspace.decision.clarifyPlaceholder'),
            rows: '3',
            fontSize: 'Z2',
            color: 'title',
            background: 'document',
            padding: 'Z A',
            round: 'radiusControl',
            // KEPT — field-affordance exception (design-direction.md §91 only
            // bans borders as a row/card separation device; an editable
            // `<textarea>` legitimately needs its own boundary).
            borderWidth: 'hairline',
            borderStyle: 'solid',
            borderColor: 'blue.3',
            resize: 'vertical',
            fontFamily: 'inherit',
            lineHeight: '1.5',
            ':focus': {
                borderColor: 'blue',
                outline: 'none'
            },
            onInput: (e, el)=>{
                const root = $6db7118e3fb2f9bb$var$_root(el);
                if (root) root.update({
                    _decisionClarifyText: e.target.value
                });
            }
        },
        ClarifyActions: {
            flow: 'x',
            gap: 'Z',
            align: 'center left',
            SubmitClarifyBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z A',
                round: 'radiusControl',
                fontSize: 'Z2',
                fontWeight: '700',
                background: 'blue',
                color: 'document',
                borderWidth: '0',
                cursor: 'pointer',
                fontFamily: 'inherit',
                text: '{{ workspace.decision.sendClarification | polyglot }}',
                ':hover': {
                    background: 'blue+10'
                },
                onClick: async (e, el, s)=>{
                    const root = $6db7118e3fb2f9bb$var$_root(el);
                    if (!root) return;
                    const text = (root._decisionClarifyText || '').trim();
                    if (!text) return;
                    await el.call('clarifyDecisionTicket', s?.id, text, root);
                    root.update({
                        _decisionClarifyId: null,
                        _decisionClarifyText: '',
                        _decisionClarifyIntent: null
                    });
                }
            },
            CancelClarifyBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z A',
                round: 'radiusControl',
                fontSize: 'Z2',
                fontWeight: '500',
                background: 'transparent',
                color: 'caption',
                borderWidth: '0',
                cursor: 'pointer',
                fontFamily: 'inherit',
                text: '{{ workspace.decision.cancel | polyglot }}',
                ':hover': {
                    color: 'title'
                },
                onClick: (e, el)=>{
                    const root = $6db7118e3fb2f9bb$var$_root(el);
                    if (root) root.update({
                        _decisionClarifyId: null,
                        _decisionClarifyText: '',
                        _decisionClarifyIntent: null
                    });
                }
            }
        }
    },
    // ── Reject form — shown when this card is in 'reject' mode ──────────────────
    RejectForm: {
        if: (el, s)=>{
            const root = $6db7118e3fb2f9bb$var$_root(el);
            return root?._decisionClarifyId === s?.id && root?._decisionClarifyIntent === 'reject';
        },
        flow: 'y',
        gap: 'Z',
        marginTop: 'Z',
        RejectLabel: {
            tag: 'span',
            text: '{{ workspace.decision.rejectLabel | polyglot }}',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption'
        },
        RejectInput: {
            tag: 'textarea',
            placeholder: (el)=>el.call('polyglot', 'workspace.decision.rejectPlaceholder'),
            rows: '2',
            fontSize: 'Z2',
            color: 'title',
            background: 'document',
            padding: 'Z A',
            round: 'radiusControl',
            // KEPT — field-affordance exception, same as ClarifyInput above.
            borderWidth: 'hairline',
            borderStyle: 'solid',
            borderColor: 'red.3',
            resize: 'vertical',
            fontFamily: 'inherit',
            lineHeight: '1.5',
            ':focus': {
                borderColor: 'red',
                outline: 'none'
            },
            onInput: (e, el)=>{
                const root = $6db7118e3fb2f9bb$var$_root(el);
                if (root) root.update({
                    _decisionClarifyText: e.target.value
                });
            }
        },
        RejectConfirmActions: {
            flow: 'x',
            gap: 'Z',
            align: 'center left',
            ConfirmRejectBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z A',
                round: 'radiusControl',
                fontSize: 'Z2',
                fontWeight: '700',
                background: 'red',
                color: 'document',
                borderWidth: '0',
                cursor: 'pointer',
                fontFamily: 'inherit',
                text: '{{ workspace.decision.confirmReject | polyglot }}',
                ':hover': {
                    background: 'red+10'
                },
                onClick: async (e, el, s)=>{
                    const root = $6db7118e3fb2f9bb$var$_root(el);
                    if (!root) return;
                    const reason = root._decisionClarifyText || '';
                    await el.call('rejectDecisionTicket', s?.id, reason, root);
                    root.update({
                        _decisionClarifyId: null,
                        _decisionClarifyText: '',
                        _decisionClarifyIntent: null
                    });
                }
            },
            CancelRejectBtn: {
                tag: 'button',
                type: 'button',
                padding: 'Z A',
                round: 'radiusControl',
                fontSize: 'Z2',
                fontWeight: '500',
                background: 'transparent',
                color: 'caption',
                borderWidth: '0',
                cursor: 'pointer',
                fontFamily: 'inherit',
                text: '{{ workspace.decision.cancel | polyglot }}',
                ':hover': {
                    color: 'title'
                },
                onClick: (e, el)=>{
                    const root = $6db7118e3fb2f9bb$var$_root(el);
                    if (root) root.update({
                        _decisionClarifyId: null,
                        _decisionClarifyText: '',
                        _decisionClarifyIntent: null
                    });
                }
            }
        }
    }
};
const $6db7118e3fb2f9bb$export$d5e59a0c50bcc4a8 = {
    hide: (el, s)=>{
        const decisions = s?.root?.askUserDecisions;
        return !Array.isArray(decisions) || decisions.length === 0;
    },
    onInit: (el, s)=>{
        const root = s?.root;
        if (!root) return;
        if (typeof el?.context?.functions?.fetchAskUserDecisions === 'function') el.call('fetchAskUserDecisions', root).then((decisions)=>{
            if (Array.isArray(decisions) && decisions.length > 0) root.update({
                askUserDecisions: decisions
            });
        }).catch((err)=>{
            console.warn('[AppAssistantDecisionBanner] fetchAskUserDecisions failed:', err?.message || err);
        });
        if (typeof el?.context?.functions?.subscribeAskUserDecisions === 'function') el.call('subscribeAskUserDecisions', root);
    },
    // WS-SWITCH-MEMO-PLANE-1 — re-arm on every root update. The subscribe is
    // keyed by the workspace the stream was opened for, so this is a no-op
    // while the tenant is unchanged and re-opens the stream for the new tenant
    // after an in-app workspace switch (the banner stays mounted across it, so
    // onInit alone would leave the previous workspace's stream in place).
    onUpdate: (el, s)=>{
        const root = s?.root;
        if (!root) return;
        if (typeof el?.context?.functions?.subscribeAskUserDecisions === 'function') el.call('subscribeAskUserDecisions', root);
    },
    onRemove: (el)=>{
        if (typeof el?.context?.functions?.unsubscribeAskUserDecisions === 'function') el.call('unsubscribeAskUserDecisions');
    },
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    // Borderless law — `background: 'purple.03'` already separates this
    // banner from the thread panel below via fill contrast (same reasoning
    // as shared/AiActionConfirmCard's Header/Footer divider removal).
    background: 'purple.03',
    overflow: 'auto',
    maxHeight: 'J',
    BannerTitle: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        marginBottom: 'V',
        BannerIcon: {
            extends: 'Icon',
            icon: 'star',
            boxSize: 'A A',
            color: 'purple'
        },
        BannerLabel: {
            tag: 'h4',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'purple',
            text: (el, s)=>{
                const count = (s?.root?.askUserDecisions || []).length;
                return count === 1 ? el.call('polyglot', 'workspace.aiDecisions.neededOne') : el.call('polyglot', 'workspace.aiDecisions.needed').replace('{count}', count);
            }
        }
    },
    DecisionCards: {
        flow: 'y',
        gap: 'A',
        childExtends: 'AppAssistantDecisionCard',
        childrenAs: 'state',
        children: (el, s)=>s?.root?.askUserDecisions || []
    }
};

});

parcelRegister("ezqR5", function(module, exports) {

$parcel$export(module.exports, "HomeSidebar", () => $a9b92a752ecfcdcd$export$ca9234edb7cd994c);
$parcel$export(module.exports, "SidebarChatRow", () => $a9b92a752ecfcdcd$export$db46dd49849da009);
$parcel$export(module.exports, "SidebarAgentRow", () => $a9b92a752ecfcdcd$export$5db5eefa21f66ed1);
$parcel$export(module.exports, "SidebarEventRow", () => $a9b92a752ecfcdcd$export$4c5de00fa0bec744);
// PeopleGroup + AppPersonRow used to be redefined here, shadowing the
// canonical versions in packages/shared/components/AppSidebar.js under the
// shell's project-barrel-wins precedence (this file is barrelled at
// components/index.js, shared is merged in first). Removed 2026-07-27 —
// see tickets/workspace.md (AppPersonRow/PeopleGroup duplicate-name
// collision). The single remaining definition (shared/components/
// AppSidebar.js) now carries the union of both: the `|| []` null-safe
// guard + `s.user?.*` wrapped-row fallbacks that used to live only here,
// AND the onClick popover that used to live only in this copy.
// ── Home left rail (HomeSidebar) ────────────────────────────────────────────
// A labelled-list sidebar for the home page: chat channels, members, agents
// and upcoming events. Each row is compact and routes into its app on click.
// Members reuse AppPersonRow (shared/components/AppSidebar.js). Channels
// come from root.channels (loaded by the home page's onCreate); members
// from activeMembers; events from root.intranetEvents (loaded by
// loadPrivateData); agents from the small roster below.
const $a9b92a752ecfcdcd$var$SIDEBAR_AGENTS = [
    {
        name: 'Simone',
        caption: 'workspace.sidebar.agent.simone'
    },
    {
        name: 'Temo',
        caption: 'workspace.sidebar.agent.temo'
    },
    {
        name: 'Watcher',
        caption: 'workspace.sidebar.agent.watcher'
    },
    {
        name: 'Caesar',
        caption: 'workspace.sidebar.agent.caesar'
    }
];
// Upcoming intranet events (loaded by loadPrivateData), soonest first.
const $a9b92a752ecfcdcd$var$_sidebarEvents = (s)=>{
    const now = Date.now();
    return (s.root.intranetEvents || []).filter((e)=>!e.startAt || new Date(e.startAt).getTime() >= now - 36e5).sort((a, b)=>new Date(a.startAt || 0) - new Date(b.startAt || 0)).slice(0, 6);
};
// Labelled group = caption title + a childExtends list. `list` supplies
// childExtends + children; childrenAs:'state' is fixed.
const $a9b92a752ecfcdcd$var$_sidebarGroup = (label, list)=>({
        flow: 'y',
        gap: 'Z',
        CaptionTitle: {
            Text: {
                text: label
            }
        },
        List: {
            flow: 'y',
            gap: 'V',
            childrenAs: 'state',
            ...list
        }
    });
// Measure the app rail ([data-app-rail]) so the chat drawer can dock flush
// beside it as an inset card. Returns the dock rect (stashed in state, so the
// ChatDrawer slot's reactive position factories survive its re-renders), or
// null when no rail is on screen. GAP ≈ the rail's 'Z' inter-card gap.
const $a9b92a752ecfcdcd$var$_measureDock = (el)=>{
    const GAP = 8;
    const rail = el && el.node && el.node.ownerDocument && el.node.ownerDocument.querySelector('[data-app-rail]');
    if (!rail) return null;
    const r = rail.getBoundingClientRect();
    return {
        left: Math.round(r.right + GAP),
        top: Math.round(r.top + GAP),
        height: Math.round(r.height - GAP * 2)
    };
};
const $a9b92a752ecfcdcd$export$ca9234edb7cd994c = {
    // Same chrome as the /chat, /tickets, /calendar … rails: extends the shared
    // base AppSidebar (width G, full-height, childExtends CommonCard). Each
    // section is a direct child, so it renders as its own CommonCard with a
    // CaptionTitle header — sections read as cards separated by the rail gap.
    // (Must NOT be named AppSidebar — that name is the shared base every other
    // rail extends; shadowing it breaks chat/tickets/calendar/meet/data/admin.)
    extends: 'AppSidebar',
    overflow: 'auto',
    gap: 'A',
    // Marker so the ChatDrawer can dock itself flush to this rail's right edge
    // (see _alignToRail in chat/collab/drawer.js).
    attr: {
        'data-app-rail': 'true'
    },
    // Unified chat card: CHANNELS up top, then a DIRECT MESSAGES sub-caption
    // (reuses /chat's CaptionTitle section-header style) over the people. Clicking
    // a channel opens its conversation; clicking a person opens a 1:1 DM — both in
    // the chat window docked beside the rail. One card (unified) with the two
    // /chat-style captions inside.
    ChatGroup: {
        flow: 'y',
        gap: 'Z',
        CaptionTitle: {
            Text: {
                text: '{{ workspace.sidebar.channels | polyglot }}'
            }
        },
        ChannelsList: {
            flow: 'y',
            gap: 'V',
            childrenAs: 'state',
            childExtends: 'SidebarChatRow',
            children: (el, s)=>(s.root.channels || []).filter((c)=>c.name && c.kind !== 'dm').slice(0, 10)
        },
        // Reuse the same CaptionTitle as the /chat sidebar's section headers.
        DmCaption: {
            extends: 'CaptionTitle',
            marginTop: 'Z',
            hide: (el)=>!(el.call('activeMembers') || []).length,
            Text: {
                text: '{{ workspace.sidebar.directMessages | polyglot }}'
            }
        },
        MembersList: {
            flow: 'y',
            gap: 'V',
            childrenAs: 'state',
            childExtends: 'SidebarChatRow',
            children: (el, s)=>(el.call('activeMembers') || []).slice(0, 10)
        }
    },
    AgentsGroup: $a9b92a752ecfcdcd$var$_sidebarGroup('AGENTS', {
        childExtends: 'SidebarAgentRow',
        children: ()=>$a9b92a752ecfcdcd$var$SIDEBAR_AGENTS
    }),
    EventsGroup: $a9b92a752ecfcdcd$var$_sidebarGroup('EVENTS', {
        childExtends: 'SidebarEventRow',
        children: (el, s)=>$a9b92a752ecfcdcd$var$_sidebarEvents(s)
    })
};
// Shared compact-row chrome — a borderless, hover-fill button.
const $a9b92a752ecfcdcd$var$_sidebarRow = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    width: '100%',
    padding: 'V Z',
    round: 'radiusControl',
    border: 'none',
    background: 'transparent',
    textAlign: 'left',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    }
};
const $a9b92a752ecfcdcd$export$db46dd49849da009 = {
    ...$a9b92a752ecfcdcd$var$_sidebarRow,
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const dock = $a9b92a752ecfcdcd$var$_measureDock(el);
        if (s && s.kind === 'channel') {
            s.root.update({
                _chatDrawerOpen: true,
                activeChannelId: s.id,
                _chatDockRect: dock
            });
            // Bundle-fold: the overlay mounts once the fold latch flips (reactive
            // `if:` in app.js) — kick the fold so the flag above takes effect.
            Promise.resolve(el.call('ensureChatContext')).catch(()=>{});
        } else if (s && s.email) {
            // Open the drawer now; messageUser resolves/creates the DM and sets
            // activeChannelId, which the open drawer then loads. messageUser lives
            // in the lazily-folded chat context — sequence it behind the fold.
            s.root.update({
                _chatDrawerOpen: true,
                _chatDockRect: dock
            });
            Promise.resolve(el.call('ensureChatContext')).then((ok)=>{
                if (ok !== false) el.call('messageUser', s.email);
            }).catch(()=>{});
        }
    },
    Hash: {
        tag: 'span',
        display: (el, s)=>s && s.kind === 'channel' ? 'flex' : 'none',
        boxSize: 'A1 A1',
        flexShrink: '0',
        align: 'center center',
        color: 'caption',
        fontSize: 'Z1',
        text: '#'
    },
    Avatar: {
        display: (el, s)=>s && s.kind === 'channel' ? 'none' : 'flex',
        avatarType: 'initials',
        boxSize: 'A1 A1',
        flexShrink: '0',
        src: (el, s)=>el.call('avatarUrl', s && s.name)
    },
    Name: {
        tag: 'span',
        flex: '1',
        minWidth: '0',
        fontSize: 'Z1',
        color: (el, s)=>s && s.kind === 'channel' ? 'paragraph' : 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s && (s.name || (s.kind === 'channel' ? 'channel' : '')) || ''
    }
};
const $a9b92a752ecfcdcd$export$5db5eefa21f66ed1 = {
    ...$a9b92a752ecfcdcd$var$_sidebarRow,
    onClick: (e, el)=>el.router('/team-and-agents', el.getRoot()),
    Glyph: {
        tag: 'span',
        color: 'caption',
        fontSize: 'Z1',
        text: "\u25C6"
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Name: {
            tag: 'span',
            fontSize: 'Z1',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name
        },
        Caption: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.call('polyglot', s.caption || '')
        }
    }
};
const $a9b92a752ecfcdcd$export$4c5de00fa0bec744 = {
    ...$a9b92a752ecfcdcd$var$_sidebarRow,
    // Open the event detail modal in place (CalEventDetailModal, mounted in
    // workspace/app.js) instead of redirecting to /calendar. Mirrors the
    // calendar Week/Month views, which set selectedEvent + showEventDetail.
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (!s) return;
        el.call('openEventDetailModal', {
            id: s.id,
            title: s.title,
            startAt: s.startAt,
            endAt: s.endAt,
            // intranetEvents carry the guest list in `attendees` (r.invitees) and a
            // description snippet in `location`; the detail modal reads `invitees` +
            // `description`. Map them so guests render immediately instead of
            // stalling on fetchEventDetails (no calendar-page context on /).
            invitees: Array.isArray(s.attendees) ? s.attendees : [],
            creatorEmail: s.organizerEmail,
            description: s.location || ''
        });
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        overflow: 'hidden',
        Title: {
            tag: 'span',
            fontSize: 'Z1',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.title || s.name || el.call('polyglot', 'workspace.sidebar.event.untitled')
        },
        When: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>{
                if (!s.startAt) return '';
                const d = new Date(s.startAt);
                if (Number.isNaN(d.getTime())) return '';
                return el.call('localizedDate', d, {
                    month: 'short',
                    day: 'numeric'
                }) + " \xb7 " + el.call('localizedDate', d, {
                    hour: 'numeric',
                    minute: '2-digit'
                });
            }
        }
    }
};

});

parcelRegister("8k01n", function(module, exports) {

$parcel$export(module.exports, "AppSidebarLink", () => $60f035355770e5c8$export$9315b0446c78d51c);
const $60f035355770e5c8$export$9315b0446c78d51c = {
    extends: 'Link',
    href: (el)=>el.href || '#',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    minHeight: 'controlH',
    padding: 'Z A',
    round: 'radiusPill',
    cursor: 'pointer',
    fontSize: 'Z2',
    textDecoration: 'none',
    isActive: (el, s)=>el.call('stripWorkspacePrefix', s.root?.route || s.root?.currentPath || '/') === el.href,
    'aria-current': (el, s)=>el.call('stripWorkspacePrefix', s.root?.route || s.root?.currentPath || '/') === el.href ? 'page' : undefined,
    fontWeight: '500',
    color: 'inactive',
    '.isActive': {
        background: 'selected',
        color: 'title',
        fontWeight: '700'
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    ':active': {
        background: 'selected',
        color: 'title'
    },
    ':focus-visible': {
        background: 'selected',
        color: 'title'
    },
    Icon: {
        icon: (el)=>el.parent.icon || 'state',
        boxSize: 'A',
        color: 'currentColor',
        'aria-hidden': true
    },
    Label: {
        tag: 'span',
        text: (el)=>el.parent.label || ''
    },
    onClick: (e, el)=>{
        // Keep standard link affordances: modified clicks can open a new tab.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button != null && e.button !== 0) return;
        e.preventDefault();
        el.router(el.href, el.getRoot());
    }
};

});

parcelRegister("011rZ", function(module, exports) {

$parcel$export(module.exports, "OnlineMember", () => $0031382466db6743$export$2fcac1987154296f);
$parcel$export(module.exports, "OnlineMembers", () => $0031382466db6743$export$727da92769d65b26);
$parcel$export(module.exports, "OnlineMembersDock", () => $0031382466db6743$export$67fed98531b707f4);
$parcel$export(module.exports, "CalOnlineUsersBar", () => $0031382466db6743$export$7e81fd04cf684b73);
$parcel$export(module.exports, "CalOnlineAvatar", () => $0031382466db6743$export$e0031349d40660d7);
// Avatar-row presence widget. Renamed from CalOnlineUsersBar /
// CalOnlineAvatar (2026-05-14) — it isn't calendar-specific; it shows
// every signed-in member of the current org that the SDK presence
// channel reports as online.
//
// Source of truth: `root.onlineUsers` is the synced list maintained by
// `useOnlinePresence` (shared/functions/presence.js), subscribed at
// shell scope in workspace/app.js so the widget works on every route.
//
// Scoping: the presence channel itself is org-agnostic
// (`scope: 'symbols'`), so we intersect with `root.people` (the active
// org's roster, loaded by workspace-project's loadPrivateData). Only
// emails that exist in peopleByEmail render — strangers from other
// orgs and unverified emails are dropped.
//
// Render contract:
//   - Self is filtered out (you don't need to see your own dot).
//   - Up to 5 avatars render inline.
//   - When more than 5 are online, the 5th slot becomes a "+N" chip
//     that opens a dropdown listing the rest.
//   - When the visible list is empty, the entire widget hides — no
//     vacant chrome / phantom padding next to Messenger.
// Avatars use the shared built-in Avatar (DiceBear image via
// el.call('avatarUrlFor', email)) — no local initials helper needed.
// Pure projection so OnlineMembers (avatar list) + OnlineMembersOverflow
// (dropdown list) share the same source-of-truth filter. Order: alpha
// by display name so the avatar strip is stable across syncs.
// Memoized on (onlineUsers, people, me) identity. This projection is read from
// ~6 factories per render (if / Avatars.children / OverflowChip if+title+text /
// Dropdown.children); onlineUsers + people are stable within a render tick, so
// without a cache the reduce+filter+sort ran 6× per presence sync. Now it runs
// once and the 6 reads share the result.
let $0031382466db6743$var$_vmCache = null;
const $0031382466db6743$var$_visibleMembers = (root)=>{
    const online = root?.onlineUsers || [];
    const people = root?.people || [];
    const me = root?.currentUserEmail;
    if ($0031382466db6743$var$_vmCache && $0031382466db6743$var$_vmCache.online === online && $0031382466db6743$var$_vmCache.people === people && $0031382466db6743$var$_vmCache.me === me) return $0031382466db6743$var$_vmCache.result;
    // Emails are matched CASE-INSENSITIVELY on both sides: presence keys come
    // from the auth email while the roster rows come from invites/imports, and
    // a single case mismatch silently dropped a genuinely-online member from
    // the bar ("doesn't show all online users").
    const meLc = String(me || '').toLowerCase();
    const byEmail = people.reduce((acc, p)=>{
        if (p?.email) acc[String(p.email).toLowerCase()] = p;
        return acc;
    }, {});
    const result = online.filter((u)=>{
        const email = String(u?.email || '').toLowerCase();
        return email && email !== meLc && byEmail[email];
    }).map((u)=>{
        const person = byEmail[String(u.email).toLowerCase()];
        return {
            email: u.email,
            name: person?.name || u.email,
            avatar: person?.avatar || null
        };
    }).sort((a, b)=>(a.name || '').localeCompare(b.name || ''));
    $0031382466db6743$var$_vmCache = {
        online: online,
        people: people,
        me: me,
        result: result
    };
    return result;
};
const $0031382466db6743$var$MAX_INLINE = 5;
const $0031382466db6743$export$2fcac1987154296f = {
    extends: 'Avatar',
    position: 'relative',
    // B1 + the 2px ring each side lands the avatar's OUTER height just under
    // the CanvasPromptTextarea's ~39px pill, so the bottom-left dock reads as
    // one line with the prompt bar. B2 measured ~40px WITH the ring — still
    // taller than the pill (2026-07-29 per Nika "online avatars are bigger in
    // height than CanvasPromptArea navbar"). Was C → B2 → B1.
    boxSize: 'B1',
    round: '50%',
    // KEPT — avatar-stack ring (docks the presence chip so it reads as a
    // distinct circle). Retokenized `'2px'` → `hairline2`.
    borderWidth: 'hairline2',
    borderStyle: 'solid',
    flexShrink: '0',
    marginLeft: '-Z',
    theme: 'dialog',
    align: 'center center',
    cursor: 'pointer',
    title: (el, s)=>s.name || s.email || '',
    src: (el, s)=>el.call('avatarUrlFor', s.email || ''),
    // Anchored mini-profile + quick actions (Chat/Call/Book a meeting/Profile/
    // Assign Ticket/Ping) — replaces the old direct-to-modal openProfileModal
    // jump (2026-07-30 per Nika "on bottom left avatars click - open popover").
    // The popover's own Profile button is what opens the full profile page now.
    onClick: (e, el, s)=>{
        if (s.email) el.call('openPersonPopover', s.email, el);
    },
    OnlineDot: {
        position: 'absolute',
        bottom: '-1px',
        right: '-1px',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'green',
        // KEPT — punched-out presence-dot ring. Retokenized `'2px'` → `hairline2`.
        borderWidth: 'hairline2',
        borderStyle: 'solid',
        theme: 'dialog'
    }
};
const $0031382466db6743$export$727da92769d65b26 = {
    // Hide the entire widget when no one else is online (after self-filter +
    // org-roster intersect). `hide:` (not `if:`) — v3.14's `if` is a
    // mount-time gate that never re-creates the element when presence later
    // syncs someone online, which left the dock permanently empty for a user
    // who booted alone. `hide` keeps the element mounted and toggles
    // reactively with the dock's onlineUsers subscription.
    hide: (el, s)=>$0031382466db6743$var$_visibleMembers(s.root).length === 0,
    position: 'relative',
    flow: 'x',
    align: 'center right',
    paddingLeft: 'Z',
    // Inline avatar strip. When length > MAX_INLINE we reserve the last
    // slot for the +N overflow chip; otherwise show all up to MAX_INLINE.
    Avatars: {
        flow: 'x',
        align: 'center right',
        childExtends: 'OnlineMember',
        childrenAs: 'state',
        children: (el, s)=>{
            const list = $0031382466db6743$var$_visibleMembers(s.root);
            const cap = list.length > $0031382466db6743$var$MAX_INLINE ? $0031382466db6743$var$MAX_INLINE - 1 : $0031382466db6743$var$MAX_INLINE;
            return list.slice(0, cap);
        }
    },
    OverflowChip: {
        // `hide:` for the same reason as the widget root — `if` is mount-time
        // only and would never reveal the chip when the 6th member comes online.
        hide: (el, s)=>$0031382466db6743$var$_visibleMembers(s.root).length <= $0031382466db6743$var$MAX_INLINE,
        tag: 'button',
        type: 'button',
        position: 'relative',
        // Tracks OnlineMember.boxSize — the chip is the strip's fifth slot.
        width: 'B1',
        height: 'B1',
        round: '50%',
        marginLeft: '-Z',
        // KEPT — same avatar-stack ring as OnlineMember. Retokenized `'2px'` →
        // `hairline2`.
        border: 'hairline2 solid',
        theme: 'dialog',
        // Was a fixed dark 'gray3' + 'white' pair — always rendered as a
        // dark-mode chip even under `theme: 'dialog'`'s light-mode branch
        // (workspace/shared designSystem/theme.js: dialog.@light already gives
        // background:'gray16', color:'title'). 'overlayStrong' is the solid-
        // looking adaptive equivalent of that fixed dark chip (matches
        // ButtonTitle.js's `:hover > div` precedent) — 'overlay' (the mapping
        // table's literal gray3→overlay entry) is a 5%-opacity wash, too faint
        // to read as a bounded avatar-stack chip.
        background: 'overlayStrong',
        color: 'title',
        fontSize: 'Y2',
        fontWeight: '700',
        cursor: 'pointer',
        flexShrink: '0',
        align: 'center center',
        flow: 'x',
        title: (el, s)=>el.call('polyglot', 'workspace.onlineMembers.more').replace('{count}', $0031382466db6743$var$_visibleMembers(s.root).length - ($0031382466db6743$var$MAX_INLINE - 1)),
        // `overlayStrong` is a sheet wash, not a state fill — banned as a hover
        // value outright (§4.3/§10), tone-shifted or not. A translucent `hover`
        // wash also wouldn't read stacked over this already-near-opaque fill
        // (§4.3 "washes don't read" case) — `filter: brightness()` is the
        // documented portable hover form for solid/imagery surfaces (Rule 65),
        // same precedent as MarketplaceDetailGallery's thumbnail hover.
        ':hover': {
            filter: 'brightness(1.12)'
        },
        text: (el, s)=>`+${$0031382466db6743$var$_visibleMembers(s.root).length - ($0031382466db6743$var$MAX_INLINE - 1)}`,
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.root.update({
                _onlineMembersOpen: !s.root._onlineMembersOpen
            });
        }
    },
    Dropdown: {
        display: (el, s)=>s.root?._onlineMembersOpen ? 'flex' : 'none',
        position: 'absolute',
        top: '120%',
        right: '0',
        zIndex: '1200',
        minWidth: 'G',
        maxHeight: '60vh',
        overflowY: 'auto',
        padding: 'V',
        round: 'radiusControl',
        // Fill only — matches the house `MenuPanel` primitive (`theme` +
        // `shadow: 'overlay'` + no border); `dialog-elevated` is already a
        // near-opaque themed fill, so the hairline was redundant.
        theme: 'dialog-elevated',
        shadow: 'overlay',
        flow: 'y',
        gap: 'V',
        // Outside-press dismissal — declared, so DOMQL owns the registration and
        // the teardown (FA503). Was an `onCreate` add + `onRemove` remove pair
        // around an `el._close` stamp.
        onDocumentMousedown: (ev, el, s)=>{
            if (!el.node || !el.node.parentElement) return;
            if (el.node.parentElement.contains(ev.target)) return;
            s.root.update({
                _onlineMembersOpen: false
            });
        },
        Row: {
            childExtends: {
                flow: 'x',
                align: 'center left',
                gap: 'Z',
                padding: 'V Z',
                round: 'radiusControl',
                cursor: 'pointer',
                ':hover': {
                    background: 'hover'
                },
                onClick: (e, el, s)=>{
                    if (s.email) {
                        // Close the overflow list FIRST — openPersonPopover snapshots the
                        // clicked row's anchor rect synchronously, so this ordering (vs.
                        // opening then closing) can't race the row's own unmount.
                        el.state.root.update({
                            _onlineMembersOpen: false
                        });
                        el.call('openPersonPopover', s.email, el);
                    }
                },
                Avatar: {
                    boxSize: 'C',
                    round: '50%',
                    flexShrink: '0',
                    align: 'center center',
                    src: (el, s)=>el.call('avatarUrlFor', s.email || '')
                },
                Name: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    flex: '1',
                    minWidth: '0',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>s.name || s.email || ''
                }
            },
            childrenAs: 'state',
            // Show only the overflow members in the dropdown — the first
            // MAX_INLINE - 1 are already visible as inline avatars.
            children: (el, s)=>$0031382466db6743$var$_visibleMembers(s.root).slice($0031382466db6743$var$MAX_INLINE - 1)
        }
    }
};
const $0031382466db6743$export$67fed98531b707f4 = {
    position: 'fixed',
    left: 'A',
    // Same bottom inset as the CanvasPromptTextarea composer (its fixed
    // `bottom: 'X2'`), so the dock and the prompt bar share one baseline
    // (2026-07-29 per Nika "position it at bottom same as prompt navbar").
    // Was 'A' (16px), which floated the dock ~10px above the pill.
    bottom: 'X2',
    zIndex: '1150',
    flow: 'x',
    align: 'center left',
    // The dock is otherwise inert (nothing else re-renders it), so the inner
    // OnlineMembers `if:` — false at boot when nobody else is online — would
    // never re-evaluate when presence syncs arrive. In the old AppHeader
    // placement the header's constant re-renders masked this; here the
    // subscription IS the re-render source.
    subscribeTo: [
        'onlineUsers',
        'people',
        '_onlineMembersOpen',
        'workspaceProject'
    ],
    // Same gates the header placement had: signed-in, active member, not an
    // auth route (the shell hides chrome there), plus OnlineMembers' own
    // nobody-else-online self-hide.
    hide: (el, s)=>{
        const root = s?.root;
        if (!root?.signedIn || !root?.currentUserEmail) return true;
        // Immersive module chrome hides the presence dock with the rest of the
        // shell chrome (manifest chrome.immersive; admins keep it). Reactive via
        // subscribeTo 'workspaceProject' above. el.call — this file is a pure
        // DOMQL component (no imports); the fn is registered in functions/index.js.
        const immersiveFn = el?.context?.methods?.moduleImmersiveActive || el?.context?.functions?.moduleImmersiveActive;
        if (typeof immersiveFn === 'function' && immersiveFn(root)) return true;
        const isActiveFn = el?.context?.methods?.isActiveMember;
        if (typeof isActiveFn === 'function' && !isActiveFn.call(el, s)) return true;
        const path = root?.currentPath || '/';
        return /^\/(login|register|signup|auth|reset|forgot|_session-bridge)/.test(path);
    },
    '@mobileL': {
        display: 'none'
    },
    OnlineMembers: {
        paddingLeft: '0',
        // Open the overflow list UPWARD — the dock sits at the viewport bottom.
        Dropdown: {
            top: 'auto',
            bottom: '120%',
            right: 'auto',
            left: '0'
        }
    }
};
const $0031382466db6743$export$7e81fd04cf684b73 = $0031382466db6743$export$727da92769d65b26;
const $0031382466db6743$export$e0031349d40660d7 = $0031382466db6743$export$2fcac1987154296f;

});

parcelRegister("iJPAg", function(module, exports) {

$parcel$export(module.exports, "IconSection", () => $da4471722f10eb2a$export$5a1355295af96385);
const $da4471722f10eb2a$export$5a1355295af96385 = {
    flow: 'x',
    align: 'flex-start',
    gap: 'A',
    IconCol: {
        align: 'flex-start center',
        color: 'caption',
        SectionIcon: {
            extends: 'Icon',
            margin: 'W2 - -',
            icon: (el)=>el.parent.parent.icon || 'state'
        }
    },
    Right: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        minWidth: '0',
        Intro: {
            flow: 'x',
            gap: 'Z',
            align: 'baseline',
            flexWrap: 'wrap',
            childExtends: 'IntroRun',
            childrenAs: 'state',
            // Host (Working/Requested/...) supplies `introBuilder: (el, s) => [...]`
            // for the chip array. The earlier prop name `intro` collided with
            // DOMQL v3.14's auto-factory pass — DOMQL invokes function-valued
            // element props at create-time and stores the result on the element.
            // Consumer functions were declared `(s) => ...` while DOMQL calls
            // them as `(el, state)`, so the body received `el` as `s`, threw on
            // `s.root.myTickets`, and the property settled at `undefined` — that
            // produced the "Intro lacks text" UX bug. Renaming to `introBuilder`
            // + fixing the consumer signature to `(el, s)` lets DOMQL invoke
            // the factory cleanly so the resolved array lands directly on the
            // host element. Walk-up tolerates Working/Requested's `Right`
            // overrides (which splice in their own Body/Empty).
            children: (el, s)=>{
                let n = el.parent;
                while(n && typeof n.introBuilder === 'undefined')n = n.parent;
                if (!n) return [];
                const ib = n.introBuilder;
                if (Array.isArray(ib)) return ib;
                if (typeof ib === 'function') try {
                    const r = ib(el, s);
                    return Array.isArray(r) ? r : [];
                } catch (_) {
                    return [];
                }
                return [];
            }
        }
    }
} // `IntroRun` (used by `childExtends: 'IntroRun'` above) is defined ONCE, in
 // IntranetRows.js. It used to be duplicated here byte-for-byte, and because
 // components/index.js star-exports BOTH files the name became an ambiguous
 // re-export — which ESM resolves by omitting it from the namespace entirely,
 // so the shared context could end up with no `IntroRun` at all. The string
 // reference resolves through the merged context, so nothing needs importing.
;

});

parcelRegister("3NFxw", function(module, exports) {

$parcel$export(module.exports, "StoryCard", () => $2c462b9b2112e2c6$export$a4842f11451d38bd);
$parcel$export(module.exports, "StoryCardSegment", () => $2c462b9b2112e2c6$export$4570288c49f54f14);
const $2c462b9b2112e2c6$var$_isTicket = (s)=>!!(s && s.name && typeof s.name === 'string' && s.name.charAt(0) === '#');
const $2c462b9b2112e2c6$var$_isEpic = (s)=>!!(s && (s.name || s._counts) && !$2c462b9b2112e2c6$var$_isTicket(s));
const $2c462b9b2112e2c6$var$_storyHref = (s)=>$2c462b9b2112e2c6$var$_isEpic(s) ? `/tasks/board?epic=${encodeURIComponent(s.id || '')}` : '/tasks/stories';
let $2c462b9b2112e2c6$var$_shellCssInjected = false;
const $2c462b9b2112e2c6$var$_injectTicketCSS = ()=>{
    if ($2c462b9b2112e2c6$var$_shellCssInjected) return;
    $2c462b9b2112e2c6$var$_shellCssInjected = true;
    const style = document.createElement('style');
    style.textContent = '[data-card-type="ticket"] [data-story-only] { display: none !important; }';
    document.head.appendChild(style);
};
const $2c462b9b2112e2c6$export$a4842f11451d38bd = {
    extends: 'Link',
    href: (el, s)=>$2c462b9b2112e2c6$var$_storyHref(s),
    attr: {
        'data-card-type': (el, s)=>$2c462b9b2112e2c6$var$_isTicket(s) ? 'ticket' : $2c462b9b2112e2c6$var$_isEpic(s) ? 'epic' : 'story'
    },
    onCreate: ()=>$2c462b9b2112e2c6$var$_injectTicketCSS(),
    flow: 'y',
    round: 'radiusSheet',
    // Fill only — the hairline was redundant against this card's own
    // `overlay` fill. Hover already carries `theme`+`background` emphasis;
    // added `shadow:'float'` matches tickets/Cards.js's "card outlines →
    // fill + float on hover" conversion in this same sweep.
    background: 'overlay',
    backdropFilter: 'blur(8px)',
    overflow: 'hidden',
    textDecoration: 'none',
    cursor: 'pointer',
    position: 'relative',
    transition: 'transform 200ms cubic-bezier(.2,.8,.2,1), background 200ms ease',
    ':hover': {
        theme: 'dialog',
        background: 'hover',
        shadow: 'float',
        transform: 'translateY(-3px)'
    },
    onClick: (e, el, s)=>{
        if ($2c462b9b2112e2c6$var$_isTicket(s)) return;
        e.preventDefault();
        el.router($2c462b9b2112e2c6$var$_storyHref(s), el.getRoot(), {}, {
            pushState: true,
            scrollToTop: true
        });
    },
    ScHeader: {
        padding: 'B B1 A B1',
        flow: 'y',
        gap: 'Z',
        ScHeaderTitle: {
            tag: 'h3',
            margin: '0',
            fontSize: 'B1',
            fontWeight: '700',
            letterSpacing: '-.01em',
            lineHeight: '1.2',
            color: 'title',
            text: (el, s)=>s.title || s.name || ''
        },
        ScHeaderDescription: {
            display: (el, s)=>s.description ? '-webkit-box' : 'none',
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            lineHeight: '1.45',
            color: 'caption',
            lineClamp: '2',
            text: (el, s)=>s.description || ''
        }
    },
    ScBody: {
        flow: 'y',
        gap: 'A',
        padding: '0 B1 B1 B1',
        EpicStats: {
            hide: (el, s)=>!$2c462b9b2112e2c6$var$_isEpic(s) || $2c462b9b2112e2c6$var$_isTicket(s),
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            Total: {
                flow: 'y',
                gap: 'V',
                Number: {
                    tag: 'span',
                    fontSize: 'D',
                    fontWeight: '700',
                    letterSpacing: '-.02em',
                    lineHeight: '1',
                    color: 'title',
                    text: (el, s)=>String(s._counts?.total || 0)
                },
                Label: {
                    tag: 'span',
                    fontSize: 'V',
                    fontWeight: '700',
                    letterSpacing: '.1em',
                    color: 'caption',
                    text: '{{ workspace.story.tickets | polyglot }}'
                }
            },
            DoneBadge: {
                display: (el, s)=>{
                    const tot = s._counts?.total || 0;
                    return tot > 0 ? 'inline-flex' : 'none';
                },
                tag: 'span',
                padding: 'V Z1',
                round: 'radiusPill',
                fontSize: 'Y2',
                fontWeight: '700',
                letterSpacing: '.04em',
                color: 'green',
                background: 'color-mix(in srgb, var(--color-green) 16%, transparent)',
                text: (el, s)=>{
                    const c = s._counts?.byColumn || {};
                    const tot = s._counts?.total || 0;
                    const done = c.eede5560 || 0;
                    return tot ? `${Math.round(done / tot * 100)}% DONE` : '';
                }
            }
        },
        EpicBreakdown: {
            display: (el, s)=>$2c462b9b2112e2c6$var$_isEpic(s) && (s._counts?.total || 0) > 0 ? 'flex' : 'none',
            flow: 'x',
            width: '100%',
            height: 'Z',
            round: 'radiusPill',
            overflow: 'hidden',
            background: 'overlay',
            childExtends: 'StoryCardSegment',
            childrenAs: 'state',
            children: (el, s)=>{
                // `el.parent.parent` is the card element whose state is the epic row.
                // During the first reactive pass the parent chain may not be fully
                // attached yet — DOMQL runs `children:` factories eagerly so it can
                // diff on the next pass, and at that moment `el.parent` can be null.
                // Guard with optional chaining instead of assuming a two-hop walk.
                const epic = el?.parent?.parent?.state;
                if (!epic) return [];
                const counts = epic._counts?.byColumn || {};
                const total = epic._counts?.total || 0;
                if (!total) return [];
                const cols = el?.state?.root?.columns || [];
                return cols.filter((c)=>counts[c.key] > 0).map((c)=>({
                        key: c.key,
                        label: c.label,
                        color: c.color,
                        count: counts[c.key],
                        pct: counts[c.key] / total * 100
                    }));
            }
        },
        TicketInfo: {
            display: 'none',
            onRender: (el, s)=>{
                if (el.node && $2c462b9b2112e2c6$var$_isTicket(s)) el.node.style.display = 'flex';
            },
            flow: 'y',
            gap: 'Z',
            TicketDescription: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                lineHeight: '1.45',
                color: 'caption',
                text: (el, s)=>s.description || ''
            }
        },
        ScMembers: {
            attr: {
                'data-story-only': 'true'
            },
            flow: 'y',
            gap: 'Z',
            ScStack: {
                extends: 'AvatarBundle',
                emails: (el, s)=>s.members || []
            },
            ScCaption: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>el.call('polyglot', 'workspace.story.joined').replace('{count}', (s.members || []).length)
            }
        },
        ScMeeting: {
            attr: {
                'data-story-only': 'true'
            },
            flow: 'y',
            gap: 'Y',
            ScMeetingTitle: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                ScMeetingIcon: {
                    extends: 'Icon',
                    icon: 'date',
                    boxSize: 'A',
                    color: 'green'
                },
                ScMeetingText: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'green',
                    text: (el, s)=>s.meeting_title || s.meetingTitle
                }
            },
            ScWhen: {
                flow: 'x',
                gap: 'Z',
                align: 'baseline',
                ScWhenSub: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: '{{ workspace.story.plannedFor | polyglot }}'
                },
                ScWhenDay: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'title',
                    fontWeight: '700',
                    text: (el, s)=>s.meeting_date || s.meetingDate || ''
                },
                ScWhenAt: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: (el, s)=>el.call('polyglot', 'workspace.story.meetingAt').replace('{time}', s.meeting_time || s.meetingTime || '')
                }
            }
        }
    }
};
const $2c462b9b2112e2c6$export$4570288c49f54f14 = {
    tag: 'span',
    height: '100%',
    background: (el, s)=>`var(--color-${el.call('githubColorTokenFromName', s.color)})`,
    opacity: '.85',
    width: (el, s)=>`${s.pct || 0}%`,
    title: (el, s)=>`${s.label || ''} \xb7 ${s.count || 0}`,
    // Hued-surface exception (§4.3) — segment color is per-data (var(--color-…)),
    // so a neutral wash can't sit on top consistently; brighten instead.
    ':hover': {
        filter: 'brightness(1.12)'
    }
};

});

parcelRegister("5nfbw", function(module, exports) {

$parcel$export(module.exports, "StoriesSection", () => $01027f8078b0a762$export$2f43d8b2b67d66dc);
const $01027f8078b0a762$export$2f43d8b2b67d66dc = {
    extends: 'IconSection',
    Right: {
        Body: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 320px), 1fr))',
            gap: 'B',
            childExtends: 'StoryCard',
            childrenAs: 'state',
            children: (el, s)=>{
                let n = el.parent;
                while(n && typeof n.items !== 'function')n = n.parent;
                if (!n) return [];
                return n.items(s) || [];
            }
        }
    }
};

});

parcelRegister("lbFkS", function(module, exports) {

$parcel$export(module.exports, "AgentCard", () => $f6cab07aef81a6d3$export$4bb3d93416a668a2);
'use strict';
const $f6cab07aef81a6d3$export$4bb3d93416a668a2 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'A',
    round: 'radiusControl',
    padding: 'B',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    background: 'transparent',
    transition: '160ms defaultBezier background',
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el)=>el.router('/team-and-agents', el.getRoot()),
    AgentGlyph: {
        width: 'C',
        height: 'C',
        minWidth: 'C',
        round: 'radiusControl',
        align: 'center center',
        fontSize: 'B',
        fontWeight: '700',
        background: 'overlay',
        color: 'title',
        text: (el, s)=>s.placeholder ? '+' : "\u25C6"
    },
    Head: {
        flow: 'x',
        gap: 'V',
        align: 'center',
        flexWrap: 'wrap',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.name
        },
        // Role chip (e.g. Temo → "PM"). Hidden when the agent has no role.
        Role: {
            hide: (el, s)=>!s.role,
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Z',
            round: 'X',
            color: 'caption',
            background: 'overlay',
            text: (el, s)=>s.role
        }
    },
    Caption: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y',
        lineHeight: '1.4',
        color: 'caption',
        text: (el, s)=>s.caption
    }
};

});

parcelRegister("ef7L5", function(module, exports) {

$parcel$export(module.exports, "AgentHeroCard", () => $a5e87c16ee0152a7$export$3dd20bf63f3ad5a7);
'use strict';
const $a5e87c16ee0152a7$export$3dd20bf63f3ad5a7 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'A',
    round: 'radiusSheet',
    padding: 'C',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    background: 'overlay',
    border: 'none',
    transition: '160ms defaultBezier background, 160ms defaultBezier transform',
    ':hover': {
        theme: 'dialog',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el)=>el.router('/team-and-agents', el.getRoot()),
    // Identity tile — the agent's accent color filled with their initial
    // letter. Replaces the previous "everyone gets a ◆" glyph so the four
    // agents read as distinct characters at a glance.
    Glyph: {
        width: 'D',
        height: 'D',
        minWidth: 'D',
        round: 'radiusCard',
        align: 'center center',
        fontSize: 'C',
        fontWeight: '700',
        // The placeholder tile sits on the adaptive 'overlay' wash and takes the
        // adaptive `title` ink. A real agent sits on an opaque hue that comes from
        // DATA (s.color — 'blue' / 'purple' / 'green' / 'orange' from _homeAgents).
        // Fixed white read 3.62 on blue and 2.81 on green; fixed near-black would
        // read 3.0 on purple. `inkOnPlate` measures the plate and picks.
        color: (el, s)=>s.placeholder ? 'title' : el.call('inkOnPlate', s.color || 'blue'),
        background: (el, s)=>s.placeholder ? 'overlay' : s.color || 'blue',
        text: (el, s)=>s.placeholder ? '+' : (s.name || '?').trim().charAt(0).toUpperCase()
    },
    Head: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        flexWrap: 'wrap',
        Name: {
            tag: 'span',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.name
        },
        Role: {
            hide: (el, s)=>!s.role,
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Z',
            round: 'X',
            color: 'caption',
            background: 'overlay',
            text: (el, s)=>s.role
        }
    },
    // Live status row — small dot + short caption. Placeholder cards
    // (the trailing "More agents coming soon") hide the dot but still
    // render the caption.
    Status: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        minHeight: 'A',
        Dot: {
            hide: (el, s)=>s.placeholder || !s.status,
            width: 'Y',
            height: 'Y',
            minWidth: 'Y',
            round: '50%',
            background: (el, s)=>s.statusColor || 'green'
        },
        Text: {
            tag: 'span',
            fontSize: 'Y',
            lineHeight: '1.4',
            color: 'caption',
            text: (el, s)=>s.status || s.caption || ''
        }
    }
};

});

parcelRegister("frBvJ", function(module, exports) {

$parcel$export(module.exports, "YourAgentCard", () => $b3e6797d797746ee$export$c9be510a9389f444);

var $lAJsX = parcelRequire("lAJsX");

var $dS9Zz = parcelRequire("dS9Zz");
'use strict';
const $b3e6797d797746ee$export$c9be510a9389f444 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'A',
    align: 'center',
    round: 'radiusControl',
    padding: 'B',
    textAlign: 'left',
    cursor: 'pointer',
    // The card sits INSIDE the agents poster (a fixed, theme-invariant hue), so
    // the shell's adaptive `title` token is wrong in one theme by construction —
    // measured rgb(4,4,4) on posterAgents #7345AF = 3.12:1 in light
    // (HOME-POSTER-NEUTRAL-INK-ON-HUE-1). `HomePosterInk` returns the poster's
    // own binary ink here and the adaptive `title` token on any neutral mount.
    color: (0, $lAJsX.HomePosterInk).color,
    background: 'transparent',
    border: 'none',
    width: '100%',
    transition: '160ms defaultBezier background',
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        if (s._create) {
            s.root.update({
                _createAgentOpen: true,
                _createAgentError: null
            });
            return;
        }
        // Talk to this agent — open the shell assistant drawer on THIS agent's own
        // thread, resumed if it has one (AI-TALK-TO-AGENT-REUSES-OPEN-THREAD-1,
        // answer C). The server resolves its persona from _targetAgentId, which
        // `openAgentThread` sets along with the thread. Falls back to the general
        // assistant's thread when the agent has no Mongo user id.
        s.root.update({
            assistantOpen: true
        });
        el.call('openAgentThread', s.userId ? {
            userId: s.userId,
            id: s.id,
            name: s.name
        } : null);
    },
    Glyph: {
        position: 'relative',
        width: 'C',
        height: 'C',
        minWidth: 'C',
        round: 'radiusControl',
        align: 'center center',
        fontSize: 'A',
        fontWeight: '700',
        // Was fixed 'white' — BOTH branches are translucent washes that reveal
        // the adaptive page/card backdrop behind them ('overlay' is a 5% wash;
        // 'purple.3' is only 30% opacity purple over whatever sits behind), so
        // the effective composited color shifts with theme: a light lavender
        // tint in light mode (white text nearly invisible) vs. a dark muted
        // purple in dark mode (white text fine). Outside a poster `title` tracks
        // that shift; inside one the backdrop is the FIXED poster hue showing
        // through the wash, so the poster's own ink is what tracks it there.
        color: (0, $lAJsX.HomePosterInk).color,
        background: (el, s)=>s._create ? 'overlay' : 'purple.3',
        text: (el, s)=>s._create ? '+' : "\u25C6",
        // Presence dot (board §2 "agents/youragents: agent grid (exists) +
        // presence dot per agent"). Same visual contract as OnlineMembers'
        // OnlineDot (shared/components/OnlineMembers.js) — reused here, not
        // reinvented. Deliberately STATIC 'green' rather than a live
        // heartbeat: agents carry no online/offline field anywhere in root
        // state (verified — root._agents rows are { id, userId, email, name,
        // avatar, kind } only, no presence key), and an AI agent genuinely
        // has no "offline" state in this product's data model — every agent
        // that exists IS reachable to chat. Hidden on the trailing create
        // tile (not a real agent yet).
        PresenceDot: {
            hide: (el, s)=>!!s._create,
            position: 'absolute',
            // '-X' corner-offset token — same convention NotificationBell's
            // UnreadBadge uses (shared/components/NotificationBell.js), not a
            // raw px nudge.
            bottom: '-X',
            right: '-X',
            width: 'Z',
            height: 'Z',
            round: '50%',
            background: 'green',
            borderWidth: 'hairline2',
            borderStyle: 'solid',
            theme: 'dialog',
            'aria-label': (el)=>el.call('polyglot', 'workspace.agents.available')
        }
    },
    Body: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Title: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            color: (0, $lAJsX.HomePosterInk).color,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s._create ? el.call('polyglot', 'workspace.agents.createTitle') : el.call('polyglot', s.name || s.id || 'workspace.agents.fallbackName')
        },
        Caption: {
            tag: 'span',
            // Hidden on agent rows (per Nika — "remove label from
            // YourAgentsWidget") so the cards read as a clean glyph + name. Kept
            // on the trailing create tile so its CTA copy still shows.
            hide: (el, s)=>!s._create,
            fontSize: 'Y',
            lineHeight: '1.4',
            // Secondary step of the SAME poster (measured `inkSoft`), not the
            // adaptive `caption` token — 2.36:1 on posterAgents before the move.
            color: (0, $dS9Zz.HomePosterSoftInk).color,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s._create ? el.call('polyglot', 'workspace.agents.createCaption') : el.call('polyglot', s.caption || s.kind || 'workspace.agents.fallbackName')
        }
    }
};

});

parcelRegister("lrPYd", function(module, exports) {

$parcel$export(module.exports, "CreateAgentModal", () => $f9d46ec6340ec5f8$export$7b53fbc18a298f69);
'use strict';
const $f9d46ec6340ec5f8$export$7b53fbc18a298f69 = {
    extends: 'Modal',
    stateKey: '_createAgentOpen',
    // Escape/backdrop close also clears the draft — the shared Modal merges
    // extraClose into its close update.
    extraClose: {
        _createAgentName: '',
        _createAgentRole: '',
        _createAgentAccess: 'editor',
        _createAgentProjectId: '',
        _createAgentPending: false,
        _createAgentError: null
    },
    // `Window` matches the shared Modal's slot key so this merges onto its
    // child (which already extends ModalWindow + stops click propagation) —
    // re-declaring the extends here would duplicate the chain (FA806).
    Window: {
        // The centre sheet (DESIGN_SPEC §6.1): the `overlayMd` width token, capped
        // by the veil's inset box — the shared Modal owns the veil, the sheet
        // motion, the phone sheet and the focus/Escape contract.
        width: 'overlayMd',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'auto',
        flow: 'y',
        gap: 'A',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: '{{ workspace.createAgent.title | polyglot }}'
                },
                P: {
                    text: '{{ workspace.createAgent.subtitle | polyglot }}'
                }
            }
        },
        Form: {
            tag: 'form',
            novalidate: true,
            flow: 'y',
            gap: 'A',
            onSubmit: async (e, el, s)=>{
                e.preventDefault();
                // submitCreateAgent resolves true only when the agent is created
                if (await el.call('submitCreateAgent', el, s.root)) el.call('markPageSaved', el);
            },
            // Every field is the shared field kit (shared/components/AppField.js):
            // AppField owns the caption label and the hint line, AppInput /
            // AppSelect own the control surface; this form keeps the behaviour
            // only. `label` / `hint` are FUNCTION props — the kit also names the
            // control with `label`, and an attribute never resolves a `{{ }}`
            // template.
            NameField: {
                extends: 'AppField',
                label: (el)=>el.call('polyglot', 'workspace.createAgent.name'),
                AppInput: {
                    placeholder: (el)=>el.call('polyglot', 'workspace.createAgent.namePlaceholder'),
                    value: (el, s)=>s.root?._createAgentName || '',
                    onInput: (e, el, s)=>s.root.update({
                            _createAgentName: e.target.value
                        })
                }
            },
            RoleField: {
                extends: 'AppField',
                label: (el)=>el.call('polyglot', 'workspace.createAgent.role'),
                AppInput: {
                    placeholder: (el)=>el.call('polyglot', 'workspace.createAgent.rolePlaceholder'),
                    value: (el, s)=>s.root?._createAgentRole || '',
                    onInput: (e, el, s)=>s.root.update({
                            _createAgentRole: e.target.value
                        })
                }
            },
            AccessField: {
                extends: 'AppField',
                label: (el)=>el.call('polyglot', 'workspace.createAgent.access'),
                // The implied permission set, on the kit's hint line under the select.
                hint: (el, s)=>el.call('polyglot', el.call('agentAccessHint', s.root)),
                // Native <select> (the kit's AppSelect), CONTROLLED: `value` comes
                // from state, and the framework re-applies a declared select value
                // after the options mount and after every option reconcile (smbls
                // element create.js, syncSelectValue). The `el.node.value` pins this
                // replaced ran only on render/update, so an option reconcile left the
                // select showing another level than the one the create request sends.
                AppSelect: {
                    name: 'agent-access',
                    value: (el, s)=>s.root?._createAgentAccess || 'editor',
                    onChange: (e, el, s)=>s.root.update({
                            _createAgentAccess: e.target.value
                        }),
                    // A STATIC list — the one AGENT_ACCESS_ROLES vocabulary — and each
                    // option resolves its words on its own text effect, so a language
                    // or workspace signal never re-emits the options (translate() walks
                    // `state.workspace` for a `workspace.*` key).
                    childrenAs: 'props',
                    children: (el)=>el.call('agentAccessOptions').map((o)=>({
                                value: o.value,
                                labelKey: o.text
                            })),
                    childProps: {
                        tag: 'option',
                        text: (el)=>el.call('polyglot', el.labelKey)
                    }
                }
            },
            ProjectField: {
                extends: 'AppField',
                label: (el)=>el.call('polyglot', 'workspace.createAgent.runsIn'),
                hint: (el, s)=>el.call('polyglot', s.root?._createAgentProjectId ? 'workspace.createAgent.runsInProjectHint' : 'workspace.createAgent.runsInWorkspaceHint'),
                // CONTROLLED like the Access select. This list is DATA — the
                // workspace's projects load and change at any time — so it re-emits
                // by design; the declared `value` is what the framework re-applies
                // after every one of those reconciles.
                AppSelect: {
                    name: 'agent-project',
                    value: (el, s)=>s.root?._createAgentProjectId || '',
                    onChange: (e, el, s)=>s.root.update({
                            _createAgentProjectId: e.target.value
                        }),
                    childrenAs: 'props',
                    children: (el, s)=>el.call('agentProjectOptions', s.root).map((o)=>({
                                ...o,
                                text: el.call('polyglot', o.text)
                            })),
                    childProps: {
                        tag: 'option'
                    }
                }
            },
            ErrorNote: {
                tag: 'p',
                role: 'alert',
                hide: (el, s)=>!s.root?._createAgentError,
                margin: '0',
                fontSize: 'Y',
                lineHeight: '1.4',
                // The AA-safe danger pair (the raw brand `red` read under 4.5:1 as
                // text in light).
                color: 'dangerInk',
                text: (el, s)=>s.root?._createAgentError || ''
            },
            ModalFooter: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                justifyContent: 'flex-end',
                // The kit footer (DESIGN_SPEC §6.9, L68): Cancel ghost · primary ink.
                // The kit owns the scale, the washes and the disabled step — never
                // an opacity (Rule 65).
                AppCapsuleBtnGhost: {
                    text: '{{ workspace.createAgent.cancel | polyglot }}',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        el.call('closeCreateAgent', s.root);
                    }
                },
                // Create — type:submit so Enter in any field submits the form.
                AppCapsuleBtnPrimary: {
                    type: 'submit',
                    // The house floor for a primary whose label changes while it works
                    // ("Create agent" → "Creating…"), W1's CRM footers alike.
                    minWidth: 'E',
                    disabled: (el, s)=>!(s.root?._createAgentName || '').trim() || !!s.root?._createAgentPending,
                    text: (el, s)=>el.call('polyglot', s.root?._createAgentPending ? 'workspace.createAgent.submitting' : 'workspace.createAgent.submit')
                }
            }
        }
    }
};

});

parcelRegister("5ngQ7", function(module, exports) {

$parcel$export(module.exports, "CreateMemberModal", () => $3e9c29c0eb175beb$export$3f119d6617adea45);
'use strict';
// Create / invite a new human team member — opened from the Team & agents
// canvas "+" menu (root._createMemberOpen). Mirrors CreateAgentModal: the
// shared Modal chrome (backdrop, Escape-to-close, stateKey contract, URL
// restore) with a ModalWindow body.
//
// Fields:
//   Email — required; the invitee's address. They receive an org invitation
//           and, once accepted, appear on the Team & agents canvas.
//   Role  — org role preset (member | admin), passed straight to the
//           invitation.
//
// Submit invites via el.sdk.createOrgInvitation(orgId, { email, role }) —
// the org-level invitation API (OrganizationService). orgId is the active
// org from the JWT claims, the same source the canvas + assignments use.
const $3e9c29c0eb175beb$var$_resetMember = {
    _createMemberOpen: false,
    _createMemberEmail: '',
    _createMemberRole: 'member',
    _createMemberPending: false,
    _createMemberError: null
};
const $3e9c29c0eb175beb$export$3f119d6617adea45 = {
    extends: 'Modal',
    stateKey: '_createMemberOpen',
    // Escape/backdrop close also clears the draft (shared Modal merges
    // extraClose into its close update).
    extraClose: {
        _createMemberEmail: '',
        _createMemberRole: 'member',
        _createMemberPending: false,
        _createMemberError: null
    },
    Window: {
        // The centre sheet (DESIGN_SPEC §6.1): the `overlayMd` width token, capped
        // by the veil's inset box — the shared Modal owns the veil, the sheet
        // motion, the phone sheet and the focus/Escape contract.
        width: 'overlayMd',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'auto',
        flow: 'y',
        gap: 'A',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: '{{ workspace.createMember.title | polyglot }}'
                },
                P: {
                    text: '{{ workspace.createMember.subtitle | polyglot }}'
                }
            }
        },
        Form: {
            tag: 'form',
            novalidate: true,
            flow: 'y',
            gap: 'A',
            onSubmit: async (e, el, s)=>{
                e.preventDefault();
                const root = s.root;
                const email = String(root?._createMemberEmail || '').trim();
                const role = root?._createMemberRole || 'member';
                if (!email) return;
                const orgId = root?.jwtClaims?.workspace_org_id || root?.jwtClaims?.orgs && root.jwtClaims.orgs[0]?.id || null;
                if (!orgId) {
                    root.update({
                        _createMemberError: el.call('polyglot', 'workspace.createMember.noOrg')
                    });
                    return;
                }
                root.update({
                    _createMemberPending: true,
                    _createMemberError: null
                });
                try {
                    await el.sdk.createOrgInvitation(orgId, {
                        email: email,
                        role: role
                    });
                    el.call('openNotification', {
                        title: el.call('polyglot', 'workspace.createMember.sent'),
                        message: el.call('polyglot', 'workspace.createMember.sentBody').replace('{email}', email),
                        type: 'success'
                    });
                    root.update({
                        ...$3e9c29c0eb175beb$var$_resetMember
                    });
                    // the invite form's fields are saved (kit dirty clears)
                    el.call('markPageSaved', el);
                } catch (err) {
                    console.warn('[CreateMemberModal] invite failed', err);
                    root.update({
                        _createMemberPending: false,
                        _createMemberError: err && err.message || el.call('polyglot', 'workspace.createMember.inviteFailed')
                    });
                }
            },
            // Both fields are the shared field kit (shared/components/AppField.js)
            // — the kit owns the label and the control surface; this form keeps
            // the behaviour only. `label` is a FUNCTION prop: the kit also names
            // the control with it, and an attribute never resolves a template.
            EmailField: {
                extends: 'AppField',
                label: (el)=>el.call('polyglot', 'workspace.createMember.email'),
                AppInput: {
                    type: 'email',
                    placeholder: (el)=>el.call('polyglot', 'workspace.createMember.emailPlaceholder'),
                    value: (el, s)=>s.root?._createMemberEmail || '',
                    onInput: (e, el, s)=>s.root.update({
                            _createMemberEmail: e.target.value
                        })
                }
            },
            RoleField: {
                extends: 'AppField',
                label: (el)=>el.call('polyglot', 'workspace.createMember.role'),
                // Native <select> (the kit's AppSelect), CONTROLLED: `value` comes
                // from state, and the framework re-applies a declared select value
                // after the options mount and after every option reconcile (smbls
                // element create.js, syncSelectValue). The node pins this replaced
                // ran only on render/update, so a reconcile left the browser showing
                // ADMIN while the invite carried MEMBER (live on dev, 2026-09-24).
                AppSelect: {
                    name: 'member-role',
                    value: (el, s)=>s.root?._createMemberRole || 'member',
                    onChange: (e, el, s)=>s.root.update({
                            _createMemberRole: e.target.value
                        }),
                    // A STATIC list: each option's words are a text template, which
                    // switches language on its own text effect. A list built with
                    // polyglot inside `children` re-ran on every workspace signal
                    // (translate() walks `state.workspace` for a `workspace.*` key).
                    childrenAs: 'props',
                    children: ()=>[
                            {
                                value: 'member',
                                text: '{{ workspace.createMember.roleMember | polyglot }}'
                            },
                            {
                                value: 'admin',
                                text: '{{ workspace.createMember.roleAdmin | polyglot }}'
                            }
                        ],
                    childProps: {
                        tag: 'option'
                    }
                }
            },
            ErrorNote: {
                tag: 'p',
                role: 'alert',
                hide: (el, s)=>!s.root?._createMemberError,
                margin: '0',
                fontSize: 'Y',
                lineHeight: '1.4',
                // The AA-safe danger pair (the raw brand `red` read under 4.5:1 as
                // text in light).
                color: 'dangerInk',
                text: (el, s)=>s.root?._createMemberError || ''
            },
            ModalFooter: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                justifyContent: 'flex-end',
                // The kit footer (DESIGN_SPEC §6.9, L68): Cancel ghost · primary ink.
                // The kit owns the scale, the washes and the disabled step — never
                // an opacity (Rule 65).
                AppCapsuleBtnGhost: {
                    text: '{{ workspace.createMember.cancel | polyglot }}',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        s.root.update({
                            ...$3e9c29c0eb175beb$var$_resetMember
                        });
                    }
                },
                AppCapsuleBtnPrimary: {
                    type: 'submit',
                    // The house floor for a primary whose label changes while it works
                    // ("Send invite" → "Inviting…"), W1's CRM footers alike.
                    minWidth: 'E',
                    disabled: (el, s)=>!(s.root?._createMemberEmail || '').trim() || !!s.root?._createMemberPending,
                    text: (el, s)=>el.call('polyglot', s.root?._createMemberPending ? 'workspace.createMember.submitting' : 'workspace.createMember.submit')
                }
            }
        }
    }
};

});

parcelRegister("dttSx", function(module, exports) {

$parcel$export(module.exports, "AppCard", () => $9cf52911edca6613$export$c9a3a2530ed8cf9b);
'use strict';
const $9cf52911edca6613$export$c9a3a2530ed8cf9b = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'Z',
    round: 'radiusControl',
    padding: 'B',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    background: 'transparent',
    transition: '160ms defaultBezier background',
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        if (s.route) el.router(s.route, el.getRoot());
    },
    // Bare icon (no tile wrapper, default size) — inherits the card's neutral
    // `color: 'title'` via the Icon's `fill: currentColor`.
    Icon: {
        icon: (el, s)=>s.icon
    },
    AppName: {
        tag: 'span',
        fontSize: 'A',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>s.title
    },
    AppCaption: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y',
        lineHeight: '1.4',
        color: 'caption',
        text: (el, s)=>s.caption
    }
};

});

parcelRegister("d4xAj", function(module, exports) {

$parcel$export(module.exports, "AppHeroCard", () => $9845b34fd121b459$export$6aa73b81881fc663);
'use strict';
const $9845b34fd121b459$export$6aa73b81881fc663 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'A',
    round: 'radiusSheet',
    padding: 'C',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    background: 'overlay',
    border: 'none',
    transition: '160ms defaultBezier background, 160ms defaultBezier transform',
    ':hover': {
        theme: 'dialog',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        if (s.route) el.router(s.route, el.getRoot());
    },
    // Bigger icon than AppCard's bare-glyph treatment — sits in a small
    // tile so the Build cards have a focal point and stand apart from the
    // compact cluster items below.
    IconTile: {
        width: 'D',
        height: 'D',
        minWidth: 'D',
        round: 'radiusCard',
        align: 'center center',
        background: 'background',
        color: 'title',
        Icon: {
            name: (el, s)=>s.icon,
            boxSize: 'C'
        }
    },
    Title: {
        tag: 'span',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        letterSpacing: '-0.005em',
        text: (el, s)=>s.title
    },
    Caption: {
        tag: 'p',
        margin: '0',
        fontSize: 'A',
        lineHeight: '1.4',
        color: 'caption',
        text: (el, s)=>s.caption
    }
};

});

parcelRegister("5eDxS", function(module, exports) {

$parcel$export(module.exports, "AppListItem", () => $3cfcef752f003b2e$export$13aed80196cc8c75);
'use strict';
const $3cfcef752f003b2e$export$13aed80196cc8c75 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    gap: 'A',
    align: 'center',
    round: 'radiusCard',
    padding: 'Z A',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    background: 'transparent',
    border: 'none',
    width: '100%',
    // No transition — this row renders inside the SearchAppsMenu dropdown
    // (a MenuPanel-family surface): the runtime re-applies background per
    // tick there, which restarts a CSS transition every frame (§7.7 framework
    // constraint). `overlayStrong` is a near-opaque sheet wash, not a state
    // fill (§4.1) — the hover wash is the shared `hover` token (§4.3).
    ':hover': {
        background: 'hover'
    },
    onClick: (e, el, s)=>{
        if (!s.route) return;
        el.call('closeDropdown', 'searchApps');
        el.call('openAppPage', s.route);
    },
    IconTile: {
        width: 'C',
        height: 'C',
        minWidth: 'C',
        round: 'radiusControl',
        align: 'center center',
        background: 'overlay',
        color: 'title',
        Icon: {
            name: (el, s)=>s.icon,
            boxSize: 'A'
        }
    },
    Body: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        // Primary text: wraps, never cut (overflow law §3b rule 8).
        Title: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            overflowWrap: 'anywhere',
            // i18n — resolved through THE store-copy resolver
            // (shared/functions/storeItemText.js), the call the apps launcher's own
            // tile (SearchAppsMenu) and the navbar tab make, so an app has one name
            // on every surface (Nika 2026-10-23: "app names = what a person sees in
            // the workspace App Store"). Its source order serves every row kind with
            // no branch here:
            //   • an INSTALLED APP's tile and an App Store row carry `appKey` and
            //     read the store's name ("Insights", not the manifest's "Analytics");
            //   • a HOUSE tile's title is a polyglot key and resolves at the
            //     resolver's last source, which is polyglot;
            //   • a customer's own words resolve nothing and pass through unchanged.
            text: (el, s)=>el.call('storeItemText', {
                    key: s.appKey,
                    name: s.title || ''
                }, 'name')
        },
        Caption: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y',
            lineHeight: '1.4',
            color: 'caption',
            // Secondary meta: one line, the whole caption on hover (rule 8).
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            // i18n — a shipped caption is a polyglot key, an app's or a customer's
            // own caption is their words (polyglot returns them unchanged). An App
            // Store row's caption is the RECORD's one line, English only, so the row
            // names its record (`captionAppKey`) and the caption reads THE
            // store-copy resolver — the App Store card's own call: the store's line
            // in the session language (lane DESC, gap 3). Not `appKey`: an
            // installed app's tile carries that for its name, with its own caption.
            title: (el, s)=>s.captionAppKey ? el.call('storeItemText', {
                    key: s.captionAppKey,
                    description: s.caption || ''
                }, 'description') : el.call('polyglot', s.caption || ''),
            text: (el, s)=>s.captionAppKey ? el.call('storeItemText', {
                    key: s.captionAppKey,
                    description: s.caption || ''
                }, 'description') : el.call('polyglot', s.caption || '')
        }
    }
};

});

parcelRegister("2zGnL", function(module, exports) {

$parcel$export(module.exports, "AppGroupColumn", () => $1dffb9ebaaa921d3$export$2d8a5b11a1e222b8);
'use strict';
const $1dffb9ebaaa921d3$export$2d8a5b11a1e222b8 = {
    flow: 'y',
    gap: 'B',
    GcHeader: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: (el, s)=>s.accent || 'caption',
        // i18n — same one call as AppListItem's Title: a shipped group label is a
        // polyglot key, a workspace's own group name passes through unchanged.
        text: (el, s)=>el.call('polyglot', s.title || '')
    },
    GcItems: {
        flow: 'y',
        gap: 'V',
        childExtends: 'AppListItem',
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    }
};

});

parcelRegister("l96Ck", function(module, exports) {

$parcel$export(module.exports, "ExtendCard", () => $f64f92494ebf799f$export$3aad13d24be99636);
'use strict';
const $f64f92494ebf799f$export$3aad13d24be99636 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'A',
    round: 'radiusSheet',
    padding: 'C',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    background: 'transparent',
    // KEPT — design-direction.md §8's sanctioned dashed CTA-tile stroke (this
    // file's own header comment). `borderColor` was `'separator'`, which is
    // NOT a registered design-system colour token (zero matches in
    // company/packages/brand/designSystem/color.js — same class of bug as the
    // `background: 'surface'` find in the tickets sweep): the shorthand's
    // color position fell through to CSS's invalid-value behavior instead of
    // the intended muted divider hue. Retokenized to `line`, the token every
    // sibling divider in this package actually uses.
    border: 'hairline dashed',
    borderColor: 'line',
    transition: '160ms defaultBezier background, 160ms defaultBezier border-color, 160ms defaultBezier transform',
    ':hover': {
        borderColor: 'title',
        background: 'hover',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el)=>el.router('/add-app', el.getRoot()),
    PlusTile: {
        width: 'D',
        height: 'D',
        minWidth: 'D',
        round: 'radiusCard',
        align: 'center center',
        background: 'overlay',
        color: 'green',
        Icon: {
            name: 'plus',
            boxSize: 'C'
        }
    },
    Title: {
        tag: 'span',
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        letterSpacing: '-0.005em',
        text: '{{ workspace.extend.title | polyglot }}'
    },
    Caption: {
        tag: 'p',
        margin: '0',
        fontSize: 'A',
        lineHeight: '1.4',
        color: 'caption',
        text: '{{ workspace.extend.caption | polyglot }}'
    }
};

});

parcelRegister("g7yQw", function(module, exports) {

$parcel$export(module.exports, "DayCard", () => $bbc854857cb90fbf$export$58c704b98267cab1);
'use strict';
const $bbc854857cb90fbf$export$58c704b98267cab1 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'Z',
    round: 'radiusCard',
    padding: 'B',
    textAlign: 'left',
    cursor: 'pointer',
    color: 'title',
    background: 'overlay',
    border: 'none',
    transition: '160ms defaultBezier background, 160ms defaultBezier transform',
    ':hover': {
        theme: 'dialog',
        transform: 'translateY(-1px)'
    },
    onClick: (e, el, s)=>{
        if (s.route) el.router(s.route, el.getRoot());
    },
    Head: {
        flow: 'x',
        gap: 'Z',
        align: 'center',
        Dot: {
            hide: (el, s)=>!s.dot,
            width: 'Y',
            height: 'Y',
            minWidth: 'Y',
            round: '50%',
            background: (el, s)=>s.dot || 'green'
        },
        Label: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            color: 'caption',
            text: (el, s)=>s.label
        }
    },
    Value: {
        tag: 'span',
        fontSize: 'C',
        fontWeight: '700',
        lineHeight: '1.05',
        color: 'title',
        text: (el, s)=>s.value
    },
    Sub: {
        tag: 'p',
        margin: '0',
        fontSize: 'Y',
        lineHeight: '1.4',
        color: 'caption',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.sub
    }
};

});

parcelRegister("81nXb", function(module, exports) {

$parcel$export(module.exports, "SharedViewSwitcher", () => $5d70ff66be70ce7a$export$1954168d8cb01f0a);
$parcel$export(module.exports, "SharedViewSwitcherBtn", () => $5d70ff66be70ce7a$export$ad0cfc6a1b938cb0);
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).

var $7iFOV = parcelRequire("7iFOV");
const $5d70ff66be70ce7a$export$1954168d8cb01f0a = {
    flow: 'x',
    borderWidth: 'hairline',
    borderColor: 'line',
    borderStyle: 'solid',
    round: 'radiusPill',
    overflow: 'hidden',
    stateKey: 'viewMode',
    mode: 'state'
};
const $5d70ff66be70ce7a$var$_stateKey = (el)=>el.parent && el.parent.stateKey || 'viewMode';
const $5d70ff66be70ce7a$var$_mode = (el)=>el.parent && el.parent.mode || 'state';
// Named distinctly, not `_isActive` — two bundled shared libraries
// (marketplace/components/MarketplaceSurfaceTabs.js,
// shared/components/AppNavbar.js) each declare their own module-scope
// `_isActive`; esbuild's bundler disambiguates the collision by renaming
// this file's copy to `_isActive2`, which frank's classifier then can't
// map back to source (`unresolvable-identifier`). A distinct name sidesteps
// the collision instead of depending on a specific bundler's renaming
// scheme. See tickets/fable.md "decompose workspace-shell's 507 defects".
const $5d70ff66be70ce7a$var$_sharedViewIsActive = (el, s)=>{
    const root = s && s.root;
    if (!root) return false;
    if ($5d70ff66be70ce7a$var$_mode(el) === 'route') return (0, $7iFOV.shellStripWorkspacePrefix)(root.route) === el.value;
    return root[$5d70ff66be70ce7a$var$_stateKey(el)] === el.value;
};
const $5d70ff66be70ce7a$export$ad0cfc6a1b938cb0 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center center',
    gap: 'Z',
    minHeight: 'controlHCompact',
    padding: '0 Z',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z',
    theme: 'dialog',
    background: (el, s)=>$5d70ff66be70ce7a$var$_sharedViewIsActive(el, s) ? undefined : 'transparent',
    color: (el, s)=>$5d70ff66be70ce7a$var$_sharedViewIsActive(el, s) ? 'title' : 'caption',
    fontWeight: (el, s)=>$5d70ff66be70ce7a$var$_sharedViewIsActive(el, s) ? '700' : '400',
    ':hover': {
        color: 'title',
        background: 'hover'
    },
    Icon: {
        display: (el)=>el.parent && el.parent.icon ? 'inline-flex' : 'none',
        icon: (el)=>el.parent && el.parent.icon || 'state',
        boxSize: 'Z2'
    },
    // Longer multi-word labels (calendar's "Team Now") wrap onto two lines and
    // grow taller than their siblings when the switcher is squeezed — no
    // `flexShrink` guard on the button either, so the label is the first thing
    // to give. Every sibling control in the SAME headers (CalHeader's
    // TodayBtn/CalRailBtn/NewBookingBtn Labels) already declares
    // `whiteSpace: 'nowrap'`; this was the one control in the family without
    // it (fable CAT-5 #3, live-confirmed on the 3-consumer shared switcher:
    // calendar/chat/tickets all extend this same component).
    Label: {
        tag: 'span',
        whiteSpace: 'nowrap',
        text: (el)=>el.parent && el.parent.label || ''
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        if (!s || !s.root) return;
        if ($5d70ff66be70ce7a$var$_mode(el) === 'route') {
            el.router(el.value, el.getRoot(), {}, {
                pushState: true,
                scrollToTop: true
            });
            return;
        }
        s.root.update({
            [$5d70ff66be70ce7a$var$_stateKey(el)]: el.value
        });
    }
};

});

parcelRegister("bwthf", function(module, exports) {

$parcel$export(module.exports, "PageHero", () => $863964b1bbccab11$export$4b2976b57d220ac6);
const $863964b1bbccab11$export$4b2976b57d220ac6 = {
    flow: 'y',
    gap: 'A',
    padding: 'C',
    maxWidth: 'L+L',
    width: '100%',
    margin: '0 auto',
    position: 'relative',
    borderBottomWidth: 'hairline',
    borderBottomColor: 'line',
    borderBottomStyle: 'solid',
    Eyebrow: {
        flow: 'x',
        align: 'center left',
        gap: 'Z',
        fontSize: 'V',
        fontWeight: '700',
        letterSpacing: '.18em',
        // §8.5 rule 2 — this eyebrow is the single most-repeated accent-ink site
        // in the shell (19 measured instances across ~10 routes: /tasks*,
        // /resolutions, /tickets*, …), and brand blue as bold ink on the
        // gray14-class page wash measured 2.77:1. The leading Dot keeps the raw
        // hue — a shape carries no contrast floor.
        color: 'accentInk',
        Dot: {
            width: 'V',
            height: 'V',
            round: '50%',
            background: 'blue'
        },
        Text: {
            tag: 'span',
            text: (el)=>el.parent.parent.eyebrow || ''
        }
    },
    Headline: {
        // One title per host (design-direction.md §3): every consumer's headline
        // is its view name, which a pane title bar already shows. The eyebrow and
        // the lede (the live counts) stay.
        hide: (el, s)=>el.call('paneTitleBarShown', s),
        tag: 'h1',
        margin: '0',
        fontSize: 'F1',
        fontWeight: '700',
        letterSpacing: '-.025em',
        lineHeight: '0.95',
        color: 'title',
        text: (el, s)=>{
            const h = el.parent.headline;
            return typeof h === 'function' ? h(el, s) : h || '';
        }
    },
    Lede: {
        tag: 'p',
        margin: '0',
        maxWidth: 'L',
        fontSize: 'B',
        lineHeight: '1.5',
        fontWeight: '400',
        color: 'subtitle',
        text: (el, s)=>{
            const l = el.parent.lede;
            return typeof l === 'function' ? l(el, s) : l || '';
        }
    }
};

});

parcelRegister("1wELc", function(module, exports) {

$parcel$export(module.exports, "AppAssistantThreadPicker", () => $11c865be121bc389$export$ce69cdac2cf81ca2);
// Thread picker for AppAssistant — slim Select-like dropdown sitting in
// the panel header. Lists the user's recent ai-chat threads + a
// "+ New thread" footer. Selecting a thread calls
// `el.call('aiChatLoadThread', threadId)` to swap `root.assistantMessages`
// to that thread's history; "+ New thread" calls `aiChatCreateThread`.
//
// All data flows through the workspace `aiChat` SDK service
// (sdk/src/services/AiChatService.js → aiChat.threads.*). The picker
// itself owns no auth/network — handlers in
// workspace/functions/aiAssistantThreads.js do the IO.
//
// Reactivity: reads `root._aiThreads` (array) + `root._aiThreadId`
// (active thread id). Both are populated on first open by
// aiChatListThreads's onInit + stay in sync via the same handler.
//
// Frankability: `(el, s)` factories only, no destructure, no
// sibling-imports, all icons by bare name. Auto-extends nothing; it
// sits as a regular Flex with a button + an absolute menu.
// Active workspace id — same resolution order + priority as chat's
// `getActiveWorkspaceId` (workspace/packages/chat/functions/chatUtils.js):
// the onWorkspaceChange-mirrored `root.activeWorkspaceId` outranks the JWT
// claim, which can lag a federated re-mint indefinitely. Inlined (not
// imported) — component files call project functions via `el.call`, never
// cross-file imports; this is cheap enough to keep local.
const $11c865be121bc389$var$_pickerActiveWorkspaceId = (root)=>root?.activeWorkspaceId || root?.workspace?.id || root?.jwtClaims?.active_workspace_id || null;
// Belt-and-suspenders filter vs a stale-JWT race — the server is the real
// scoping gate (AiChatController.listThreads → resolveAiChatScope,
// server@22ff64d4, 2026-07-14 WORKSPACE-scoping decision). Rows that
// predate the AiChatThread.workspace backfill normalize to
// `workspaceId: null` in aiAssistantThreads.js's `_normalizeThread` and
// pass through here unfiltered (a null isn't evidence of a cross-tenant
// row, just an unbackfilled one) — only an EXPLICIT mismatch is dropped.
const $11c865be121bc389$var$_scopedThreads = (root)=>{
    const list = root?._aiThreads || [];
    const wsId = $11c865be121bc389$var$_pickerActiveWorkspaceId(root);
    if (!wsId) return list;
    return list.filter((t)=>!t?.workspaceId || t.workspaceId === wsId);
};
const $11c865be121bc389$var$_activeLabel = (el, root)=>{
    const id = root?._aiThreadId;
    if (!id) return el.call('polyglot', 'workspace.simone.newChat');
    const t = $11c865be121bc389$var$_scopedThreads(root).find((x)=>x?.id === id || x?._id === id);
    if (!t) return el.call('polyglot', 'workspace.threadPicker.thread');
    return t.title || t.subject || el.call('polyglot', 'workspace.threadPicker.thread');
};
const $11c865be121bc389$export$ce69cdac2cf81ca2 = {
    position: 'relative',
    flow: 'x',
    align: 'center left',
    // Load threads on mount — keeps the dropdown populated by the time the
    // user clicks it. Root-state guard (NOT an element-local flag): threads
    // are WORKSPACE-scoped (2026-07-14 per Nika) and PHASE 1 of
    // onWorkspaceChange (loadPrivateData.js) wipes `root._aiThreads` +
    // `root._aiThreadsLoadAttempted` back to their schema-empty state on
    // every switch, but this drawer is gated by `hide` (never unmounted —
    // see app.js AssistantDrawer), so onInit only ever fires once per shell
    // lifetime. An `el._loadedThreads` instance flag would therefore
    // permanently suppress every future list call from this component,
    // including any the picker itself needs to issue post-switch.
    // aiChatListThreads is idempotent (bails on its own `_aiThreadsLoading`
    // in-flight guard), so bailing here only on the ROOT's loading/attempted
    // state — not an instance flag — is what lets a re-list actually reach
    // the network after a workspace switch.
    onInit: (el, s)=>{
        if (typeof el?.context?.functions?.aiChatListThreads !== 'function') return;
        if (s.root?._aiThreadsLoading || s.root?._aiThreadsLoadAttempted) return;
        el.call('aiChatListThreads', s.root);
    },
    // Trigger: shows current thread label + chevron. Styling mirrors the
    // header's CloseBtn (lightweight chrome) so the picker reads as part
    // of the header rather than a heavy dropdown control.
    Trigger: {
        tag: 'button',
        type: 'button',
        flow: 'x',
        align: 'center',
        gap: 'V',
        padding: 'V Z',
        round: 'radiusControl',
        border: 'none',
        background: 'transparent',
        color: 'caption',
        fontSize: 'Z2',
        fontWeight: '500',
        cursor: 'pointer',
        maxWidth: 'F',
        ':hover': {
            background: 'hover',
            color: 'title'
        },
        title: (el)=>el.call('polyglot', 'workspace.threadPicker.switch'),
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            s.root.update({
                _aiThreadMenuOpen: !s.root?._aiThreadMenuOpen
            });
        },
        Label: {
            tag: 'span',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>$11c865be121bc389$var$_activeLabel(el, s.root)
        },
        Chevron: {
            tag: 'span',
            fontSize: 'Y2',
            opacity: '.6',
            text: "\u25BE"
        }
    },
    Menu: {
        hide: (el, s)=>!s.root?._aiThreadMenuOpen,
        position: 'absolute',
        top: '110%',
        left: '0',
        zIndex: '20000',
        minWidth: 'G',
        maxHeight: 'I',
        overflow: 'auto',
        // Don't chain this overlay picker's edge-bounce to the surface behind (iPad P2).
        overscrollBehavior: 'contain',
        flow: 'y',
        padding: 'V',
        round: 'radiusControl',
        // Fill only — matches the house `MenuPanel` primitive exactly
        // (`theme: 'dialog'` + `shadow: 'overlay'` + `borderWidth: '0'`); the
        // hairline here was the habit.
        theme: 'dialog',
        borderWidth: '0',
        shadow: 'overlay',
        // Outside-press dismissal. This was an `onCreate` that stamped `el._close`
        // and called `document.addEventListener('mousedown', …)`, paired with an
        // `onRemove` that took it off again. The pair was correct, but it could
        // drift out of step with a later edit and `onCreate` firing twice would
        // have added a second listener while overwriting the only reference to the
        // first. Declared, DOMQL registers it once and disposes it (FA503).
        onDocumentMousedown: (ev, el, s)=>{
            if (!el.node?.parentElement) return;
            if (el.node.parentElement.contains(ev.target)) return;
            s.root.update({
                _aiThreadMenuOpen: false
            });
        },
        Items: {
            flow: 'y',
            gap: 'V',
            childrenAs: 'state',
            children: (el, s)=>$11c865be121bc389$var$_scopedThreads(s.root),
            childExtends: {
                tag: 'button',
                type: 'button',
                flow: 'x',
                align: 'center space-between',
                gap: 'V',
                width: '100%',
                padding: 'Z A',
                round: 'radiusControl',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: 'Z2',
                background: (el, s)=>{
                    const active = s.root?._aiThreadId === (s.id || s._id);
                    return active ? 'overlay' : 'transparent';
                },
                color: 'title',
                ':hover': {
                    background: 'hover'
                },
                Label: {
                    tag: 'span',
                    flex: '1',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>el.call('polyglot', s.title || s.subject || 'workspace.assistant.threadFallback')
                },
                Check: {
                    tag: 'span',
                    color: 'green',
                    text: (el, s)=>{
                        const active = s.root?._aiThreadId === (s.id || s._id);
                        return active ? "\u2713" : '';
                    }
                },
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    s.root.update({
                        _aiThreadMenuOpen: false
                    });
                    el.call('aiChatLoadThread', s.root, s.id || s._id);
                }
            }
        },
        Empty: {
            hide: (el, s)=>$11c865be121bc389$var$_scopedThreads(s.root).length > 0,
            tag: 'span',
            padding: 'Z A',
            fontSize: 'Z2',
            color: 'caption',
            text: '{{ workspace.threadPicker.empty | polyglot }}'
        },
        Divider: {
            height: 'hairline',
            background: 'line',
            margin: 'V 0'
        },
        NewBtn: {
            tag: 'button',
            type: 'button',
            width: '100%',
            textAlign: 'left',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            padding: 'Z A',
            round: 'radiusControl',
            fontSize: 'Z2',
            color: 'caption',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            text: '{{ workspace.threadPicker.new | polyglot }}',
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                s.root.update({
                    _aiThreadMenuOpen: false
                });
                el.call('aiChatCreateThread', s.root);
            }
        }
    }
};

});

parcelRegister("hsKFd", function(module, exports) {

$parcel$export(module.exports, "AppCreateOrgModal", () => $0347e41f99060541$export$e14deba0eaefc4fa);
// "Create organization" modal — single unified component used by BOTH:
//   • AppWorkspaceSwitcher's "+ Create organization" footer button
//     (workspace-project/components/AppWorkspaceSwitcher.js)
//   • Canvas dashboard sidebar's "+ New organization" button
//     (canvas/pages/dashboard.js — NewOrgButton)
//
// Replaces the previous split: a simple variant here + a feature-rich
// inline variant (NewOrgModal) inside dashboard.js. The dashboard path
// already had live slug-availability checking + auto-suggested suffix
// + one-click "Use <slug-N>" recovery on conflict; the switcher path
// trusted the user and let the POST be the final arbiter. The two
// flows were never structurally different — just two evolutionary
// stages — so we keep the better UX (live check) and apply it to
// both call sites.
//
// State key namespace: `_createOrg*` (matches the existing stateKey
// the switcher already writes). The `newOrg*` namespace previously
// used by dashboard.js is retired; dashboard's NewOrgButton now writes
// the same `_createOrgModalOpen` flag.
//
// Mount: shell-root (workspace/app.js shellApp.AppCreateOrgModal) so
// the modal renders regardless of which sub-app's page is active. The
// previous mount inside workspace-project/app.js never rendered
// because smbls 3.14's auto-router mounts pages directly into Slot —
// the wp wrapper never instantiates.
// Bare shared-library import, not a deep sdk.js subpath — see app.js's
// identical fix note (tickets/catalog-fixall.md P0). Deferred-call wrapper,
// not a module-scope destructure — see app.js's circular-init note.

var $1X0Je = parcelRequire("1X0Je");
const $0347e41f99060541$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
// Local slug helper. Intentionally differs from
// shared/functions/slugify.js: no length truncation (org slugs allow
// up to 60 chars server-side) and no random `slot-xxxx` fallback —
// empty input must stay empty so the live availability check no-ops.
const $0347e41f99060541$var$_slugifyLocal = (name)=>(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
// Module-level debounce timer so rapid name input coalesces into one
// /organizations?slug=X check. Resets on every keystroke.
let $0347e41f99060541$var$_slugDebounceTimer = null;
// Returns true = available, false = taken, null = check failed.
// Routes through `sdk.checkOrganizationSlug` so the call honors the
// channel-resolved workspaceApiBase + SDK auth header.
const $0347e41f99060541$var$_checkSlugAvailable = async (slug)=>{
    if (!slug) return null;
    try {
        return await $0347e41f99060541$var$shellGetSDK().checkOrganizationSlug(slug);
    } catch  {
        return null;
    }
};
// Find the first available slug: tries base, then base-2, base-3 …
// up to N. Returns null on full exhaustion (vanishingly rare with
// N=20).
const $0347e41f99060541$var$_findAvailableSlug = async (base, maxAttempts = 20)=>{
    for(let n = 0; n < maxAttempts; n++){
        const candidate = n === 0 ? base : `${base}-${n + 1}`;
        if (await $0347e41f99060541$var$_checkSlugAvailable(candidate) === true) return candidate;
    }
    return null;
};
// Debounced live slug check. On taken, auto-advances to the first
// free -2/-3/-N suffix and surfaces it as `_createOrgSlugSuggestion`
// so the UI can show a one-click "Use <slug>" button.
const $0347e41f99060541$var$_scheduleSlugCheck = (rawSlug, root)=>{
    if ($0347e41f99060541$var$_slugDebounceTimer) clearTimeout($0347e41f99060541$var$_slugDebounceTimer);
    const base = $0347e41f99060541$var$_slugifyLocal(rawSlug);
    if (!base) {
        root.update({
            _createOrgSlug: '',
            _createOrgSlugChecking: false,
            _createOrgSlugStatus: null,
            _createOrgSlugSuggestion: null
        });
        return;
    }
    root.update({
        _createOrgSlugChecking: true,
        _createOrgSlugStatus: null
    });
    $0347e41f99060541$var$_slugDebounceTimer = setTimeout(async ()=>{
        $0347e41f99060541$var$_slugDebounceTimer = null;
        const available = await $0347e41f99060541$var$_checkSlugAvailable(base);
        if (available === true) root.update({
            _createOrgSlug: base,
            _createOrgSlugChecking: false,
            _createOrgSlugStatus: 'available',
            _createOrgSlugSuggestion: null
        });
        else if (available === false) {
            const suggestion = await $0347e41f99060541$var$_findAvailableSlug(base);
            root.update({
                _createOrgSlug: suggestion || base,
                _createOrgSlugChecking: false,
                _createOrgSlugStatus: suggestion ? 'suggested' : 'taken',
                _createOrgSlugSuggestion: suggestion
            });
        } else // Network error — let the user proceed; server is the final arbiter.
        root.update({
            _createOrgSlugChecking: false,
            _createOrgSlugStatus: 'error'
        });
    }, 350);
};
// Submit handler — POSTs through sdk.createOrganization, handles
// race-condition 409 (slug taken between live-check and POST) by
// surfacing the auto-suffix suggestion, refreshes JWT claims so the
// new org appears in `_orgs(root)`, then hard-reloads so every
// `method: 'select'` query re-keys under the new active org. Same
// recovery convention as the NoOrgOverlay first-time setup.
// `el` is the form element: every refusal below is a bundle sentence
// resolved through it, and a server's own message passes through as-is.
const $0347e41f99060541$var$_submitCreate = async (root, el)=>{
    const name = (root?._createOrgName || '').trim();
    const slug = (root?._createOrgSlug || $0347e41f99060541$var$_slugifyLocal(name)).trim();
    if (!name || !slug) {
        root.update({
            _createOrgError: el.call('polyglot', 'workspace.createOrg.errorRequired')
        });
        return;
    }
    root.update({
        _createOrgBusy: true,
        _createOrgError: null,
        _createOrgSlugConflict: null
    });
    try {
        const created = await $0347e41f99060541$var$shellGetSDK().createOrganization({
            name: name,
            slug: slug,
            type: 'team'
        });
        // Make the brand-new org the ACTIVE one before reloading. The server's
        // createOrganization creates the org + its HQ workspace but does NOT move
        // the creator's persisted `activeOrganization`/`activeWorkspace` — so
        // without this, `getMe`/claims still resolve the OLD org after the reload.
        // The user lands back in their previous org, and because the new org and
        // the old one then collapse onto the same `workspace_org_id`, a later
        // switch between them computes `_orgChanged === false` and takes the no-op
        // `switchWorkspace` branch — the "create an org, then can't switch
        // org / stuck" bug (#2347). switchOrg persists the active org in Mongo AND
        // federates the workspace, so the post-reload claims resolve the new org.
        const newOrgId = created?.organization?._id || created?.organization?.id || null;
        const newHomeWorkspaceId = created?.workspace?._id || created?.workspace?.id || null;
        if (newOrgId) try {
            await $0347e41f99060541$var$shellGetSDK().switchOrg(newOrgId, {
                homeWorkspaceId: newHomeWorkspaceId || undefined
            });
        } catch (switchErr) {
            // Non-fatal: the org was created. Fall back to a claims refresh so it at
            // least appears in the list; the user can switch into it manually.
            console.warn('[AppCreateOrgModal] activate new org failed:', switchErr?.message || switchErr);
        }
        // Active org is persisted in Mongo by switchOrg above; the hard reload
        // below re-derives claims from Mongo via getMe (no gov refreshClaims hop).
        if (typeof window !== 'undefined') window.location.href = '/';
    } catch (err) {
        const msg = err?.message || '';
        const isSlugTaken = msg === 'slug_taken' || msg.includes('slug_taken') || msg.toLowerCase().includes('slug') && msg.toLowerCase().includes('taken');
        if (isSlugTaken) {
            const suggestion = await $0347e41f99060541$var$_findAvailableSlug(slug);
            root.update({
                _createOrgBusy: false,
                _createOrgError: el.call('polyglot', 'workspace.createOrg.errorSlugTaken').replace('{slug}', slug),
                _createOrgSlugConflict: slug,
                _createOrgSlug: suggestion || slug,
                _createOrgSlugSuggestion: suggestion,
                _createOrgSlugStatus: suggestion ? 'suggested' : 'taken'
            });
            return;
        }
        root.update({
            _createOrgBusy: false,
            _createOrgError: err?.message || el.call('polyglot', 'workspace.createOrg.errorFailed')
        });
    }
};
const $0347e41f99060541$export$e14deba0eaefc4fa = {
    // Fill the @symbo.ls/windows custom-template modal slot rather than forcing a
    // fixed 'H' (524px) width — the slot is ~466px, so the fixed width overflowed
    // the card and pushed the inputs/buttons past its right edge (the "inputs
    // overlapping" bug). 100% conforms to whatever width the slot provides.
    width: '100%',
    maxWidth: '90vw',
    flow: 'y',
    gap: 'A',
    // MODAL-X-OVERFLOW-1: @symbo.ls/windows' ModalLayer.js deliberately sets
    // `overflow:'visible'` + a null-default `maxHeight` on the outer
    // ModalWindow chrome (2026-06-03, to stop the rounded-corner clip eating
    // the Close X — see that file's comment) — so a custom-template body gets
    // NO scroll containment unless it caps its own height. Without this, tall
    // content (or a short viewport) pushes the box past the top of the
    // screen, taking ModalHeader — and its X — off-screen with it: reads as
    // "lost the close button" even though CloseButton itself renders fine.
    // Capping the ROOT directly (not relying on ancestor flex-shrink through
    // the vendored CustomTemplate/Slot chain, which this component doesn't
    // own) guarantees containment regardless of viewport height. Paired with
    // openCreateOrgModal's own `maxHeight` ceiling (workspace/functions/
    // createOrgModal.js) so the two agree.
    maxHeight: '80vh',
    // No `overflow` here: the Form's Fields region is the one scroller (below),
    // and a clip on this root cut the brand ModalHeader's Close X — pulled into
    // the window's padding by a negative margin — by 13px (live on dev
    // 2026-09-26). `minHeight: 0` lets the column shrink to the cap.
    minHeight: '0',
    // Brand ModalWindow always renders a ModalHeader with H + P
    // placeholder slots ('Heading' / 'Paragraph'). Populate them
    // instead of mounting a custom Title + Hint sibling — otherwise
    // both render and the modal shows leftover 'Heading / Paragraph'
    // text above the real content (same bug as AgentModal in
    // canvas/pages/team-and-agents.js).
    ModalHeader: {
        Hgroup: {
            H: {
                text: '{{ workspace.createOrg.title | polyglot }}'
            },
            P: {
                text: '{{ workspace.createOrg.subtitle | polyglot }}'
            }
        },
        // Override the brand's inherited `Icons.Close.onClick` (which
        // dispatches the stateKey-walker closeModal — would no-op now
        // that this component lost its stateKey).
        Icons: {
            Close: {
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('closeCreateOrgModal');
                }
            }
        }
    },
    Form: {
        tag: 'form',
        flow: 'y',
        gap: 'Z1',
        novalidate: true,
        // Header/footer pin, fields scroll (canonical shape — see
        // ChannelSettingsModal.js's Header/Content/Footer split): Form itself
        // shrinks to whatever height ROOT's `maxHeight` leaves it, and Fields
        // is the ONLY region that scrolls (`flex:1, minHeight:0, overflow:
        // auto`) — Actions stays pinned below it instead of scrolling away
        // with the inputs.
        minHeight: '0',
        flex: '1',
        onSubmit: (e, el, s)=>{
            e.preventDefault();
            if (s.root?._createOrgBusy) return;
            $0347e41f99060541$var$_submitCreate(s.root, el);
        },
        Fields: {
            flow: 'y',
            gap: 'Z1',
            flex: '1',
            minHeight: '0',
            overflowY: 'auto',
            // The shared field kit (shared/components/AppField.js): AppField owns
            // the caption label, AppInput the control surface (the brand `field`
            // fill, control scale, hairline edge, global focus ring) — this form
            // keeps the behaviour only. `label` is a FUNCTION prop: an attribute
            // never resolves a `{{ }}` template.
            NameField: {
                extends: 'AppField',
                label: (el)=>el.call('polyglot', 'workspace.createOrg.nameLabel'),
                AppInput: {
                    type: 'text',
                    name: 'name',
                    // A company NAME, not a shape the field enforces — a Georgian
                    // visitor gets a Georgian example. Its SLUG sibling below stays
                    // literal: that field only accepts ASCII.
                    placeholder: (el)=>el.call('polyglot', 'workspace.createOrg.namePlaceholder'),
                    // The kit's own `ariaLabel` key, so ONE effect owns aria-label.
                    ariaLabel: (el)=>el.call('polyglot', 'workspace.createOrg.nameLabel'),
                    autofocus: true,
                    required: true,
                    maxlength: 60,
                    value: (el, s)=>s.root?._createOrgName || '',
                    // `autofocus` doesn't fire on a dynamic (modal) mount — focus the field
                    // once on render so keyboard + screen-reader users land inside the
                    // dialog instead of on the page behind it. (a11y, 2026-06-17)
                    // After the modal root's own focus move (one frame), so the field —
                    // not the header's Close — holds the keyboard.
                    onRender: (el)=>{
                        if (el.__autoFocused) return;
                        el.__autoFocused = true;
                        setTimeout(()=>el.call('focusCreateOrgName', el), 60);
                    },
                    // The onboarding gate can open this dialog under the boot screen's
                    // `inert` lock, where the focus above is a no-op (persona audit
                    // WL-9): ask again the moment the lock lifts.
                    'onWindowSmbls:boot-ready': (e, el)=>el.call('focusCreateOrgName', el),
                    onInput: (e, el, s)=>{
                        const name = e.target.value;
                        const wasSlugDirty = !!s.root?._createOrgSlugDirty;
                        const patch = {
                            _createOrgName: name,
                            _createOrgError: null,
                            _createOrgSlugConflict: null
                        };
                        if (!wasSlugDirty) {
                            patch._createOrgSlug = $0347e41f99060541$var$_slugifyLocal(name);
                            patch._createOrgSlugDirty = false;
                        }
                        // `_createOrgSlug` in the patch flows to the slug Input's reactive
                        // `value:` factory, so the field re-renders with the derived slug
                        // automatically — no DOM querySelector/value write needed.
                        s.root.update(patch);
                        if (!wasSlugDirty) $0347e41f99060541$var$_scheduleSlugCheck(name, s.root);
                    }
                }
            },
            // Workspace URL — the slug auto-generates from the name and shows as a
            // live `my.symbols.app/<slug>` preview (per Nika 2026-06-17). The slug
            // stays inline-editable for conflict recovery; status + auto-adjust ride
            // the same _createOrgSlug* logic.
            //
            // The kit's prefix field (shared/components/AppField.js AppFieldPrefix):
            // the caption, then ONE field surface that holds the fixed host and the
            // slug input — one edge, one hover step, one focus ring, the same
            // control scale as the name field above. A click on the caption or on
            // the host focuses the slug. A taken slug takes the kit's danger edge
            // (`hasError` on the group, a class rule — never a reactive border
            // factory); the status word at the end of the row carries the verdict in
            // its own ink. An available slug keeps the plain edge: the word says it.
            UrlField: {
                extends: 'AppFieldPrefix',
                label: (el)=>el.call('polyglot', 'workspace.createOrg.urlLabel'),
                prefixText: 'my.symbols.app/',
                AppInputPrefix: {
                    class: {
                        hasError: (el, s)=>s.root?._createOrgSlugStatus === 'taken'
                    },
                    AppInputBare: {
                        name: '_createOrgSlug',
                        type: 'text',
                        placeholder: 'acme',
                        maxlength: 60,
                        // The kit's own key, so ONE effect owns aria-label. The slug's own
                        // name ("Workspace URL slug") is more exact than the caption.
                        ariaLabel: (el)=>el.call('polyglot', 'workspace.createOrg.slugAria'),
                        // Reactive controlled value — the auto-derived slug (and any
                        // auto-adjusted / suggested slug) flows straight from root state into
                        // the field. `value:` is a framework-reactive prop, so this replaces
                        // the old onRender el.node.value DOM write (FA511/FA501).
                        value: (el, s)=>s.root?._createOrgSlug || '',
                        onInput: (e, el, s)=>{
                            const val = $0347e41f99060541$var$_slugifyLocal(e.target.value);
                            e.target.value = val;
                            s.root.update({
                                _createOrgSlug: val,
                                _createOrgSlugDirty: true,
                                _createOrgError: null,
                                _createOrgSlugConflict: null
                            });
                            $0347e41f99060541$var$_scheduleSlugCheck(val, s.root);
                        }
                    },
                    SlugStatus: {
                        tag: 'span',
                        fontSize: 'Y2',
                        whiteSpace: 'nowrap',
                        // The group sets the host flush against the slug (gap 0); the
                        // status word keeps its own space from the typed text.
                        margin: '- - - Z',
                        'aria-live': 'polite',
                        hide: (el, s)=>!s.root?._createOrgSlug,
                        // Semantic ink pairs (Rule 69): a raw hue fails its contrast floor
                        // in one of the two schemes.
                        color: (el, s)=>{
                            if (s.root?._createOrgSlugChecking) return 'caption';
                            const st = s.root?._createOrgSlugStatus;
                            if (st === 'available') return 'successInk';
                            if (st === 'taken') return 'dangerInk';
                            if (st === 'suggested') return 'warningInk';
                            return 'caption';
                        },
                        text: (el, s)=>{
                            if (s.root?._createOrgSlugChecking) return el.call('polyglot', 'workspace.createOrg.slugStatusChecking');
                            const st = s.root?._createOrgSlugStatus;
                            if (st === 'available') return el.call('polyglot', 'workspace.createOrg.slugStatusAvailable');
                            if (st === 'taken') return el.call('polyglot', 'workspace.createOrg.slugStatusTaken');
                            if (st === 'suggested') return el.call('polyglot', 'workspace.createOrg.slugStatusAdjusted');
                            return '';
                        }
                    }
                },
                SlugHint: {
                    hide: (el, s)=>{
                        const st = s.root?._createOrgSlugStatus;
                        const conflict = s.root?._createOrgSlugConflict;
                        return st !== 'suggested' && st !== 'taken' && !conflict;
                    },
                    flow: 'x',
                    align: 'center left',
                    gap: 'Z',
                    margin: 'V 0 0',
                    HintText: {
                        tag: 'span',
                        fontSize: 'Y2',
                        color: 'caption',
                        flex: '1',
                        text: (el, s)=>{
                            const sug = s.root?._createOrgSlugSuggestion;
                            const conflict = s.root?._createOrgSlugConflict;
                            if (conflict && sug) return el.call('polyglot', 'workspace.createOrg.slugTakenTry').replace('{slug}', conflict).replace('{suggestion}', sug);
                            if (conflict) return el.call('polyglot', 'workspace.createOrg.slugTakenEdit').replace('{slug}', conflict);
                            if (sug) return el.call('polyglot', 'workspace.createOrg.slugAdjusted').replace('{suggestion}', sug);
                            return el.call('polyglot', 'workspace.createOrg.slugTaken');
                        }
                    },
                    // Reuse the house Button (secondary theme) instead of a bespoke
                    // styled `tag:'button'` — the previous hand-rolled version had a no-op
                    // `:hover` (overlay → overlay, no change) and duplicated padding/round/
                    // border styling. `display: null` is paired with `hide` because brand
                    // Button ships a static inline `display:inline-flex` that a bare
                    // `hide` (display:none) loses to. (Rule 63 reuse-first.)
                    // The kit's tonal capsule in its compact step (controlHCompact, the
                    // kit's own inset) — was the brand Button with a hand-set scale and
                    // a `display: null` to let `hide` beat its inline display.
                    UseSlugBtn: {
                        extends: 'AppCapsuleBtnToolbar',
                        compact: true,
                        hide: (el, s)=>!s.root?._createOrgSlugSuggestion,
                        text: (el, s)=>{
                            const sug = s.root?._createOrgSlugSuggestion;
                            return sug ? el.call('polyglot', 'workspace.createOrg.useSlug').replace('{slug}', sug) : '';
                        },
                        onClick: (e, el, s)=>{
                            e.preventDefault();
                            const sug = s.root?._createOrgSlugSuggestion;
                            if (!sug) return;
                            // Updating `_createOrgSlug` re-renders the slug Input via its
                            // reactive `value:` factory — no DOM querySelector/value write.
                            s.root.update({
                                _createOrgSlug: sug,
                                _createOrgSlugDirty: true,
                                _createOrgSlugStatus: 'available',
                                _createOrgSlugSuggestion: null,
                                _createOrgSlugConflict: null,
                                _createOrgError: null
                            });
                        }
                    }
                }
            },
            Error: {
                hide: (el, s)=>!s.root?._createOrgError,
                tag: 'p',
                role: 'alert',
                'aria-live': 'assertive',
                // The AA-safe danger pair (the raw brand `red` read under 4.5:1 as
                // text in light).
                color: 'dangerInk',
                fontSize: 'Y2',
                margin: 'Z 0 0',
                text: (el, s)=>s.root?._createOrgError || ''
            }
        },
        Actions: {
            flow: 'x',
            gap: 'Z1',
            margin: 'A 0 0',
            justifyContent: 'flex-end',
            align: 'center right',
            // Onboarding-only escape hatch (NoOrgOverlay replacement): keep using
            // the personal org instead of creating a team workspace. Hidden in the
            // normal (switcher) flow, where Cancel is shown instead. Per Nika
            // 2026-06-17 "add one more option 'Use personal workspace'".
            // The kit footer (DESIGN_SPEC §6.9, L68): the quiet actions are ghost
            // capsules, the primary is the ink capsule — the kit owns the scale, the
            // washes and the disabled step (was the brand Button with a hand-set
            // scale and a `display: null` to let `hide` beat its inline display).
            UsePersonalBtn: {
                extends: 'AppCapsuleBtnGhost',
                hide: (el, s)=>!s.root?._createOrgOnboarding,
                disabled: (el, s)=>!!s.root?._createOrgBusy,
                text: '{{ workspace.createOrg.usePersonal | polyglot }}',
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.call('usePersonalWorkspace');
                }
            },
            CancelBtn: {
                extends: 'AppCapsuleBtnGhost',
                hide: (el, s)=>!!s.root?._createOrgOnboarding,
                disabled: (el, s)=>!!s.root?._createOrgBusy,
                text: '{{ workspace.createOrg.cancel | polyglot }}',
                onClick: (e, el)=>{
                    e.preventDefault();
                    // closeCreateOrgModal also handles the field reset that used
                    // to live inline here + in `extraClose`.
                    el.call('closeCreateOrgModal');
                }
            },
            SubmitBtn: {
                extends: 'AppCapsuleBtnPrimary',
                type: 'submit',
                // The house floor for a primary whose label changes while it works.
                minWidth: 'E',
                // Disabled while a slug check is in flight so the user can't
                // race-submit before the server's verdict lands. Also
                // disabled when slug is known-taken (no point hitting POST).
                disabled: (el, s)=>!!s.root?._createOrgBusy || !!s.root?._createOrgSlugChecking || s.root?._createOrgSlugStatus === 'taken' || !((s.root?._createOrgName || '').trim() && (s.root?._createOrgSlug || '').trim()),
                text: (el, s)=>el.call('polyglot', s.root?._createOrgBusy ? 'workspace.createOrg.submitting' : 'workspace.createOrg.submit')
            }
        }
    }
};

});

parcelRegister("8GnCH", function(module, exports) {

$parcel$export(module.exports, "ShareLinkModal", () => $6524920dc9256977$export$eb64062c68bca198);
$parcel$export(module.exports, "ShareLinkRow", () => $6524920dc9256977$export$5ee386cafbe6311c);
// ShareLinkModal — the "Share publicly" dialog for a file or a note
// (PUBLIC-SHARE-LINKS-1). Body-only: backdrop, ESC and dismiss-on-backdrop
// belong to @symbo.ls/windows' ModalLayer, exactly like AppCreateOrgModal.
//
// Opened from ANY surface with:
//   el.call('openShareModal', { targetType: 'file'|'note', targetId, name })
// All behaviour lives in workspace/functions/shareLinks.js — this file is
// the surface, and every action is one `el.call`.
//
// ⚠️ THE DIALOG IS THE ONLY PLACE THE URL EVER EXISTS
// The server keeps sha256(token), never the token. `_shareNewUrl` holds the
// freshly-minted link for the life of this dialog and nothing persists it,
// so the copy field is shown ONCE, right after minting. The list below it
// can show a link's state and revoke it, but can never show its URL again.
//
// What the dialog must make unmissable, because a public link is a security
// act and not a convenience: WHO can open it (anyone with the link), that
// the content is LIVE (Nika Q1 — it keeps serving future edits), and WHEN it
// stops (Nika Q2 — 30 days by default).
const $6524920dc9256977$export$eb64062c68bca198 = {
    width: '100%',
    maxWidth: '90vw',
    flow: 'y',
    gap: 'A',
    // Cap the body height directly (not via an ancestor) so a short viewport
    // can never push ModalHeader — and its close X — off-screen. Same
    // reasoning as AppCreateOrgModal's root cap.
    maxHeight: '80vh',
    // No `overflow` here: Body is the one scroller (below), and a clip on this
    // root cut the brand ModalHeader's Close X — pulled into the window's
    // padding by a negative margin — by 13px (live on dev 2026-09-26).
    minHeight: '0',
    ModalHeader: {
        Hgroup: {
            H: {
                text: '{{ workspace.share.modal.title | polyglot }}'
            },
            P: {
                text: (el, s)=>{
                    const t = s.root?._shareTarget;
                    const name = t?.name ? `\u{201C}${t.name}\u{201D}` : el.call('polyglot', t?.targetType === 'note' ? 'workspace.share.modal.thisNote' : 'workspace.share.modal.thisFile');
                    return el.call('polyglot', 'workspace.share.modal.subtitle').replace('{what}', name);
                }
            }
        },
        Icons: {
            Close: {
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('closeShareModal');
                }
            }
        }
    },
    Body: {
        flow: 'y',
        gap: 'Z1',
        flex: '1',
        minHeight: '0',
        overflowY: 'auto',
        // The two facts a person must have BEFORE they mint the link, not after.
        LiveNotice: {
            tag: 'p',
            fontSize: 'Y2',
            color: 'caption',
            margin: '0',
            text: '{{ workspace.share.modal.liveNotice | polyglot }}'
        },
        // The shared field kit (shared/components/AppField.js): AppField owns the
        // caption, AppSelect the control surface; this field keeps the behaviour
        // only. `label` is a FUNCTION prop — an attribute never resolves a
        // template.
        ExpiryField: {
            extends: 'AppField',
            label: (el)=>el.call('polyglot', 'workspace.share.modal.expiryLabel'),
            AppSelect: {
                // The select's own accessible name stays its own key, as the flat
                // `ariaLabel` — the one form that replaces the kit's function, so ONE
                // effect owns aria-label.
                ariaLabel: (el)=>el.call('polyglot', 'workspace.shareLink.expiryLabel'),
                value: (el, s)=>s.root?._shareExpiryKey || '30',
                onChange: (e, el, s)=>{
                    s.root.update({
                        _shareExpiryKey: e.target.value
                    });
                },
                // Static options — the four choices are a product decision, not data.
                // 30 days leads because the SAFE option must be the one a user gets
                // without choosing anything (Nika Q2).
                Days30: {
                    tag: 'option',
                    value: '30',
                    text: '{{ workspace.share.modal.opt30 | polyglot }}'
                },
                Days7: {
                    tag: 'option',
                    value: '7',
                    text: '{{ workspace.share.modal.opt7 | polyglot }}'
                },
                Days90: {
                    tag: 'option',
                    value: '90',
                    text: '{{ workspace.share.modal.opt90 | polyglot }}'
                },
                Never: {
                    tag: 'option',
                    value: 'never',
                    text: '{{ workspace.share.modal.optNever | polyglot }}'
                }
            }
        },
        // The kit's ink primary (was the brand Button with a hand-set scale), with
        // the house floor for a label that changes while it works.
        CreateBtn: {
            extends: 'AppCapsuleBtnPrimary',
            minWidth: 'E',
            alignSelf: 'flex-start',
            disabled: (el, s)=>!!s.root?._shareBusy,
            text: (el, s)=>el.call('polyglot', s.root?._shareBusy ? 'workspace.shareLink.creating' : 'workspace.shareLink.create'),
            onClick: (e, el)=>{
                // markPageSaved: opt-out — the expiry pick is a mint option the dialog keeps for the next link
                e.preventDefault();
                el.call('createShareLinkNow');
            }
        },
        // Shown ONCE, immediately after minting. There is no way back to this
        // value — the server stores only the hash.
        // The kit field: its caption is the copy-once warning; the control sits
        // in a row beside the Copy button.
        NewLink: {
            extends: 'AppField',
            label: (el)=>el.call('polyglot', 'workspace.share.modal.copyOnce'),
            display: null,
            hide: (el, s)=>!s.root?._shareNewUrl,
            Row: {
                flow: 'x',
                gap: 'Z',
                align: 'center left',
                // The kit's control. Its parent is this Row, not the field, so it
                // names itself with its own key (the flat `ariaLabel`).
                AppInput: {
                    type: 'text',
                    readonly: true,
                    ariaLabel: (el)=>el.call('polyglot', 'workspace.shareLink.publicLinkLabel'),
                    // Layout, not look: the link takes the row, the Copy button keeps
                    // its own width.
                    flex: '1',
                    value: (el, s)=>s.root?._shareNewUrl || '',
                    onClick: (e)=>e.target.select()
                },
                // The kit's tonal capsule at the field's own height (controlH).
                CopyBtn: {
                    extends: 'AppCapsuleBtnToolbar',
                    flexShrink: '0',
                    text: '{{ workspace.share.modal.copy | polyglot }}',
                    onClick: (e, el, s)=>{
                        e.preventDefault();
                        el.call('copyShareLink', s.root?._shareNewUrl);
                    }
                }
            }
        },
        // Everything already shared for this resource — the list that makes a
        // revoke an informed act rather than a guess.
        // A section head — the kit's mono micro-label.
        ExistingTitle: {
            extends: 'AppMicroLabel',
            tag: 'p',
            margin: 'Z 0 0',
            text: '{{ workspace.share.modal.existing | polyglot }}'
        },
        Empty: {
            tag: 'p',
            fontSize: 'Y2',
            color: 'caption',
            margin: '0',
            hide: (el, s)=>!!(s.root?._shareLinks || []).length || !!s.root?._shareLoading,
            text: '{{ workspace.share.modal.empty | polyglot }}'
        },
        Links: {
            flow: 'y',
            gap: 'V',
            childExtends: 'ShareLinkRow',
            childrenAs: 'state',
            children: (el, s)=>s.root?._shareLinks || []
        },
        Error: {
            hide: (el, s)=>!s.root?._shareError,
            tag: 'p',
            role: 'alert',
            'aria-live': 'assertive',
            // The kit's AA-safe danger pair (designSystem/color.js §4.2) — this is
            // TEXT ink; brand red measures 2.82:1 on the light stage.
            color: 'dangerInk',
            fontSize: 'Y2',
            margin: 'Z 0 0',
            text: (el, s)=>s.root?._shareError || ''
        }
    }
};
const $6524920dc9256977$export$5ee386cafbe6311c = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    padding: 'V 0',
    Status: {
        tag: 'span',
        flex: '1',
        fontSize: 'Y2',
        // A dead link reads as caption grey; a live one is the thing that still
        // exposes content, so it keeps the foreground colour.
        color: (el, s)=>s.live ? 'title' : 'caption',
        text: (el, s)=>el.call('shareLinkStatusLabel', s)
    },
    Uses: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        whiteSpace: 'nowrap',
        text: (el, s)=>{
            const n = s.accessCount || 0;
            if (!n) return el.call('polyglot', 'workspace.share.uses.never');
            return n === 1 ? el.call('polyglot', 'workspace.share.uses.once') : el.call('polyglot', 'workspace.share.uses.many').replace('{count}', n);
        }
    },
    // Revoking a public link is destructive — the kit's danger capsule in its
    // compact step (was the brand Button with a hand-set scale and a
    // `display: null` to let `hide` beat its inline display).
    RevokeBtn: {
        extends: 'AppCapsuleBtnDanger',
        compact: true,
        flexShrink: '0',
        // A revoked or expired link has nothing left to revoke.
        hide: (el, s)=>!s.live,
        disabled: (el, s)=>!!s.root?._shareBusy,
        text: '{{ workspace.share.modal.revoke | polyglot }}',
        // Asks first (functions/shareLinks.js confirmRevokeShareLink).
        onClick: (e, el, s)=>{
            e.preventDefault();
            el.call('confirmRevokeShareLink', s.id);
        }
    }
};

});

parcelRegister("6EThr", function(module, exports) {

$parcel$export(module.exports, "NoOrgOverlay", () => $4d915c0b08170fff$export$9063c4d52ea90fec);
// Onboarding gate — signed-in user with no team org.
//
// Per MODEL.md, workspace is an org-level feature: a user with no team org has
// nothing to scope to (empty workspace_id claim → RLS returns zero rows on
// every tenant table), so the workspace has nothing to render.
//
// This USED to render a full-page fixed overlay with an inline create-org form.
// It's now a HIDDEN gate that opens the shared `AppCreateOrgModal` (in
// onboarding mode) through @symbo.ls/windows when the condition holds (2026-06-17
// per Nika "NoOrgOverlay should be moved as @symbo.ls/windows modal"). The modal
// offers two choices: "Create workspace" or "Use personal workspace" (the escape
// that persists a skip so the gate never re-opens). All form / slug / submit
// logic now lives in `AppCreateOrgModal.js` + `createOrgModal.js` — single
// source, no duplicate inline form.

var $11oY6 = parcelRequire("11oY6");

var $kKK1U = parcelRequire("kKK1U");

var $gOQVi = parcelRequire("gOQVi");

var $lb2Ei = parcelRequire("lb2Ei");
// "Does the signed-in user belong to any team org?" — checked against BOTH
// sources: `root.orgs` (SDK Mongo /auth/me, canonical) and `jwtClaims.orgs`
// (federated Supabase JWT). SDK-Mongo tokens never carry orgs[] in the JWT, so
// checking only jwtClaims gave a false negative for every Mongo-authed user.
// Personal-only users return false → the gate fires.
const $4d915c0b08170fff$var$_hasTeamOrg = (root)=>{
    const fromState = Array.isArray(root?.orgs) ? root.orgs : null;
    const fromClaims = Array.isArray(root?.jwtClaims?.orgs) ? root.jwtClaims.orgs : null;
    const orgs = fromState && fromState.length ? fromState : fromClaims || [];
    if (!orgs.length) return false;
    return orgs.some((o)=>o?.type == null || o.type === 'team');
};
// Gate predicate. `_authReady` / `signedIn` / `jwtClaims` keep the modal from
// opening before the auth snapshot has seeded (else it would flash for every
// signed-in user between mount and subscribeAuthSession's first fire).
// INVITE SUPPRESSION (INVITE-ONBOARDING-USERNAME-NOT-ORG-1): a user inside
// an invite-acceptance flow must NEVER meet org creation — they are joining
// an existing org, and the no-team-org condition is merely the acceptance
// not having landed yet. `_inviteFlowActive` covers the accept page's
// window; the username-prompt pending markers cover the post-accept beat
// (their own gate shows the light username nudge instead).
const $4d915c0b08170fff$var$_shouldGate = (el, root)=>{
    if (!(0, $gOQVi.USE_ONBOARDING_GATE)) return false;
    // WHITELABEL SUPPRESSION (Nika 2026-08-30: "if I'm joining bellforge —
    // it should not ask me to create workspace"). On a white-label host the
    // visitor is by definition joining the HOST org — offering to found a
    // Symbols org there is the platform's onboarding leaking into a
    // customer's own domain. Same category as the invite suppression below:
    // the no-team-org condition is real, but org creation is never the
    // answer on this host. Platform hosts are untouched (isCustomDomainHost
    // is false on my.symbols.app / localhost / SSR).
    if ((0, $lb2Ei.isCustomDomainHost)()) return false;
    if (!root?._authReady || !root?.signedIn || !root?.jwtClaims) return false;
    // THE MODAL HOST FIRST (WS-SHELL-MOUNT-TREE-BUILD-2700MS-1): `ModalRoot`
    // mounts behind the `_modalHostReady` latch, flipped after the first paint.
    // A cold boot whose auth is already seeded (a hand-over arrival:
    // magic-callback → the workspace) reached this gate before the latch
    // flipped, pushed the layer onto a host not built yet, and the modal's
    // custom content mounted DETACHED — a blank, non-dismissable veil over the
    // home, no way out (measured on dev 2026-10-24, workspace e96e3b234, a Fly
    // sign-up's first arrival; reopened after boot the same modal renders).
    if (!root?._modalHostReady) return false;
    if (root?._orgOnboardingSkipped || (0, $11oY6.isOrgOnboardingSkipped)()) return false;
    if (root?._inviteFlowActive || root?._usernamePromptPending || (0, $kKK1U.isUsernamePromptPendingPersisted)()) return false;
    // ARRIVED FROM FLY (fly docs/FUNNEL.md §4 G5: the shell never repeats what
    // Fly already did). Make it real on fly.symbols.app made this person's
    // workspace — the personal one, or a new one they chose — and wrote
    // `user_preferences.onboarding = { via: 'fly' }` before the hand-over;
    // asking them again to found a team org or keep the personal workspace is
    // Fly's own question twice. The record loads AFTER the boot loader (a
    // non-blocking read), so the gate waits for it rather than flash at a Fly
    // arrival; a read that answered nothing is `{}` (functions/loadPrivateData.js).
    const prefs = root?.userPrefs;
    if (!prefs || typeof prefs !== 'object') return false;
    // Fly's record says so while its welcome is pending or done (`via: 'fly'`);
    // once the person took the tour from the ready screen the decision says
    // `via: 'tour'` and keeps `origin: 'fly'` (functions/onboarding.js
    // onboardingDecide) — the org question stays Fly's either way.
    const welcome = prefs.onboarding;
    if (welcome && (welcome.via === 'fly' || welcome.origin === 'fly')) return false;
    // THE WELCOME OWNS THE FIRST WORKSPACE (round 2 BLOCKER #5, elena-r2 +
    // sam-r2): a direct sign-up's one personal workspace holds the sign-up
    // credits and the new-account welcome opens on it. This modal opened by
    // itself over the welcome (on a step, on a reload); the person founded a
    // second organisation with an empty, 0-credit workspace. For a new account,
    // or anyone the welcome already met, the welcome names and sets up THAT
    // workspace (functions/createOrgModal.js orgOnboardingOwnedByWelcome).
    if (el.call('orgOnboardingOwnedByWelcome', root)) return false;
    return !$4d915c0b08170fff$var$_hasTeamOrg(root);
};
// Open the onboarding modal at most once per mount. With the modal
// non-dismissable (dismissOnBackdrop:false + ESC blocked), it can only leave
// via "Create workspace" (hard reload) or "Use personal workspace" (persists
// the skip), so a single open is correct.
const $4d915c0b08170fff$var$_maybeOpen = (el, s)=>{
    if (el.__onboardingOpened) return;
    if (!$4d915c0b08170fff$var$_shouldGate(el, s.root)) return;
    el.__onboardingOpened = true;
    el.call('openOnboardingWorkspaceModal');
};
const $4d915c0b08170fff$export$9063c4d52ea90fec = {
    tag: 'div',
    display: 'none',
    // Auth claims / org list often land AFTER mount on SDK-only sessions — watch
    // them (+ the skip flag) so the gate re-evaluates when they arrive.
    subscribeTo: [
        'jwtClaims',
        'orgs',
        'signedIn',
        '_authReady',
        '_orgOnboardingSkipped',
        '_inviteFlowActive',
        '_usernamePromptPending',
        // the modal host's latch and the person's record (see _shouldGate)
        '_modalHostReady',
        'userPrefs',
        // the welcome's own facts (see orgOnboardingOwnedByWelcome)
        'user',
        '_onboardingDecision'
    ],
    onCreate: (el, s)=>$4d915c0b08170fff$var$_maybeOpen(el, s),
    onUpdate: (el, s)=>$4d915c0b08170fff$var$_maybeOpen(el, s)
};

});

parcelRegister("4uXAm", function(module, exports) {

$parcel$export(module.exports, "AppUsernamePrompt", () => $34682f3849d36154$export$4151939ae28f7145);
// AppUsernamePrompt — the light "pick your username" nudge shown once
// after joining via an invite (INVITE-ONBOARDING-USERNAME-NOT-ORG-1).
// Deliberately SMALL and dismissable — the anti-pattern it replaces was a
// non-dismissable org-creation modal shown to people who had just joined
// an existing org. Opened through functions/usernamePrompt.js
// (openCustomModal layer, same mechanics as AppCreateOrgModal); all draft
// state lives on root (_unamePrompt*) so reactive reads survive the
// custom-template mount.
//
// Availability feedback is FEATURE-DETECTED: when the SDK exposes a
// username-availability method it runs debounced on input; otherwise the
// save path alone reports a taken name (server-side uniqueness). Never a
// hard dependency — older SDK builds keep the prompt fully usable.
const $34682f3849d36154$var$_checkAvailability = async (el, s, draft)=>{
    const sdk = el.sdk;
    const fn = typeof sdk?.checkUsernameAvailable === 'function' && sdk.checkUsernameAvailable || typeof sdk?.usernameAvailable === 'function' && sdk.usernameAvailable || null;
    if (!fn) return;
    try {
        const res = await fn.call(sdk, {
            username: draft
        });
        const available = res?.available ?? res?.data?.available;
        // `reason` explains a refusal the retry advice depends on: a RESERVED word
        // is never going to free up, a taken one might. The endpoint sends it for
        // both the reserved list and a `validateUsername` format error
        // (server UserController.checkUsernameAvailability —
        // `{ success, data: { available, username, reason?, suggestion? } }`), so
        // it is carried through verbatim rather than re-worded here. Same
        // dual-envelope read as `available`: the SDK unwraps `data`, older builds
        // do not.
        const reason = res?.reason ?? res?.data?.reason;
        // Stale-response guard: only apply if the draft is unchanged.
        if ((s.root?._unamePromptDraft || '').trim().toLowerCase() !== draft) return;
        if (available === false) s.root.update({
            _unamePromptStatus: 'taken',
            _unamePromptReason: typeof reason === 'string' && reason ? reason : null
        });
        else if (available === true) s.root.update({
            _unamePromptStatus: 'available',
            _unamePromptReason: null
        });
    } catch  {
    /* availability is advisory — save still validates server-side */ }
};
const $34682f3849d36154$export$4151939ae28f7145 = {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    width: '100%',
    maxWidth: 'H',
    ModalHeader: {
        Hgroup: {
            H: {
                text: '{{ workspace.username.title | polyglot }}'
            },
            P: {
                text: '{{ workspace.username.subtitle | polyglot }}'
            }
        },
        Icons: {
            Close: {
                onClick: (e, el)=>{
                    e.stopPropagation();
                    // Backdrop-family close = "not now", not "never" — no DONE key.
                    el.call('closeUsernamePrompt');
                }
            }
        }
    },
    Form: {
        tag: 'form',
        flow: 'y',
        gap: 'Z1',
        novalidate: true,
        onSubmit: (e, el, s)=>{
            e.preventDefault();
            el.call('saveUsernamePrompt');
        },
        Field: {
            flow: 'y',
            gap: 'V',
            Label: {
                tag: 'label',
                text: '{{ workspace.username.label | polyglot }}',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption'
            },
            Input: {
                tag: 'input',
                type: 'text',
                name: 'username',
                'aria-label': (el)=>el.call('polyglot', 'workspace.usernamePrompt.fieldLabel'),
                maxlength: 39,
                theme: 'field',
                round: 'radiusControl',
                minHeight: 'controlH',
                fontSize: 'Z2',
                padding: '0 A',
                width: '100%',
                value: (el, s)=>s.root?._unamePromptDraft || '',
                onRender: (el)=>{
                    setTimeout(()=>el.node?.focus?.(), 60);
                },
                onInput: (e, el, s)=>{
                    const draft = String(e.target?.value || '');
                    s.root.update({
                        _unamePromptDraft: draft,
                        _unamePromptError: null,
                        // The previous answer's reason belongs to the previous draft.
                        _unamePromptReason: null,
                        _unamePromptStatus: draft.trim() ? 'checking' : 'idle'
                    });
                    clearTimeout(el.__unameCheckT);
                    const normalized = draft.trim().toLowerCase();
                    if (!normalized) return;
                    el.__unameCheckT = setTimeout(()=>$34682f3849d36154$var$_checkAvailability(el, s, normalized), 450);
                }
            },
            Hint: {
                tag: 'p',
                minHeight: 'Z2',
                fontSize: 'Y2',
                lineHeight: '1.4em',
                color: (el, s)=>s.root?._unamePromptError || s.root?._unamePromptStatus === 'taken' ? 'red' : 'inactive',
                text: (el, s)=>{
                    // A bundle key from functions/usernamePrompt.js, or the server's own
                    // message — polyglot returns a non-key verbatim.
                    if (s.root?._unamePromptError) return el.call('polyglot', s.root._unamePromptError);
                    if (s.root?._unamePromptStatus === 'taken') // The server's own words when it sent them — a reserved handle and
                    // a taken one need different advice. Fallback for the plain
                    // uniqueness refusal, which carries no reason.
                    return s.root?._unamePromptReason || el.call('polyglot', 'workspace.username.taken');
                    if (s.root?._unamePromptStatus === 'available') return el.call('polyglot', 'workspace.username.available');
                    return el.call('polyglot', 'workspace.username.rules');
                }
            }
        },
        Actions: {
            flow: 'x',
            gap: 'Z1',
            align: 'center end',
            SkipButton: {
                extends: 'Button',
                type: 'button',
                text: '{{ workspace.username.keepCurrent | polyglot }}',
                background: 'hover',
                color: 'paragraph',
                minHeight: 'controlHCompact',
                padding: '0 A',
                round: 'radiusPill',
                fontSize: 'Z',
                onClick: (e, el)=>{
                    e.preventDefault();
                    el.call('skipUsernamePrompt');
                }
            },
            SaveButton: {
                extends: 'Button',
                theme: 'primary',
                type: 'submit',
                minHeight: 'controlHCompact',
                padding: '0 A2',
                round: 'radiusPill',
                fontSize: 'Z',
                fontWeight: '700',
                text: (el, s)=>el.call('polyglot', s.root?._unamePromptBusy ? 'workspace.usernamePrompt.saving' : 'workspace.usernamePrompt.save'),
                disabled: (el, s)=>!!s.root?._unamePromptBusy,
                opacity: (el, s)=>s.root?._unamePromptBusy ? '.55' : '1',
                cursor: (el, s)=>s.root?._unamePromptBusy ? 'not-allowed' : 'pointer'
            }
        }
    }
};

});

parcelRegister("eUlT5", function(module, exports) {

$parcel$export(module.exports, "UsernamePromptGate", () => $ada7460d879fa6bb$export$14a6252fe2a8d7ce);
// Username-prompt gate — the hidden watcher that opens AppUsernamePrompt
// exactly once for a freshly-joined invitee (INVITE-ONBOARDING-USERNAME-
// NOT-ORG-1). Sibling of NoOrgOverlay in shape and mount point: a
// display:none div whose only job is a reactive predicate.
//
// Fires when EITHER trigger holds:
//   • root._usernamePromptPending — raised by accept-invite's live
//     (no-reload) path right after the committed switch;
//   • the persisted PENDING key — written before accept-invite's
//     hard-reload fallback, so the nudge survives the reboot.
// Never fires once the DONE key exists (saved or explicitly kept), and
// never before the auth snapshot has seeded (same guard rationale as
// NoOrgOverlay's).

var $kKK1U = parcelRequire("kKK1U");
const $ada7460d879fa6bb$var$_shouldPrompt = (root)=>{
    if (!root?._authReady || !root?.signedIn) return false;
    if ((0, $kKK1U.isUsernamePromptDone)()) return false;
    // NEVER during a workspace/org switch: the accept flow raises the flag
    // right after sdk.switchOrg resolves, and the switch pipeline's state
    // rebuild (PHASE-1 wipe + refetch behind the loader) runs AFTER that —
    // a modal opened in that window is destroyed with the rebuild while the
    // flag has already been consumed (measured 2026-08-27: nudge never seen
    // after a live accept; opens fine once the switch settles). Wait for
    // the switch to finish; the subscription below re-evaluates then.
    if (root?._wsSwitching || root?._wpSwitching || root?._dataLoading) return false;
    return !!root?._usernamePromptPending || (0, $kKK1U.isUsernamePromptPendingPersisted)();
};
const $ada7460d879fa6bb$var$_maybeOpen = (el, s)=>{
    if (el.__usernamePromptOpened) return;
    if (!$ada7460d879fa6bb$var$_shouldPrompt(s.root)) return;
    el.__usernamePromptOpened = true;
    el.call('openUsernamePrompt');
};
const $ada7460d879fa6bb$export$14a6252fe2a8d7ce = {
    tag: 'div',
    display: 'none',
    subscribeTo: [
        '_usernamePromptPending',
        'signedIn',
        '_authReady',
        '_wsSwitching',
        '_wpSwitching',
        '_dataLoading'
    ],
    onCreate: (el, s)=>$ada7460d879fa6bb$var$_maybeOpen(el, s),
    onUpdate: (el, s)=>$ada7460d879fa6bb$var$_maybeOpen(el, s)
};

});

parcelRegister("fx5hY", function(module, exports) {

$parcel$export(module.exports, "CreditBlocker", () => $b4ee0a571e96e944$export$2bc36784a2699a3a);
// CreditBlocker — the full-viewport stop when the workspace has spent every
// credit (tickets/fable.md, Nika 2026-08-13: "beautiful workspace-blocker
// when workspace runs out of credits").
//
// Condition (all through functions/creditGuard.js's derivation — the data
// is sdk.getCreditBalance, never a literal): guard loaded, no error, status
// 'exhausted', a workspace resolved, and the route is NOT one of the
// recovery/identity surfaces (/admin/usage to top up, auth + profile so
// nobody is locked out of their own account chrome). A metering ERROR never
// blocks — a billing outage must not take the product down with it.
//
// Shape: geex poster grammar — one giant thin Code-family numeral (the
// Reminders "Alarm archetype": G/'200' is the thin register's legal floor),
// a mixed-weight identity line, whisper captions, ONE primary action. Calm
// adaptive `dialog` surface, not an alarm bar: the state is a hard fact,
// the surface stays composed. Admins get the top-up CTA (→ /admin/usage,
// the real usage page — tickets/opus.md "credits-exhausted UX": `/credits`
// was never a registered route, so the CTA silently bootShell-replaceState'd
// back to `/` — pages/index.js only ever registered `/admin/usage`); members
// get told who can fix it instead of a dead button (house rule: no fake
// affordances).
//
// Mounted at the shell root beside NoOrgOverlay/PersonaPill — same
// `display:'contents'` wrapper + fixed descendant idiom (a shell-root
// sibling with a real box becomes a static child of the shell's `1fr` grid
// row and pushes routed content into a collapsed implicit row — the
// DemoClaimBanner lesson PersonaPill documents).
//
// zIndex 10300: above the dropdown layers (DropdownRoot 10010, context menu
// 10100) — a leftover open menu must not float over the gate — and below
// ModalRoot (10500) so account/auth modals stay reachable above it.
//
// Blurred-overlay shape (Nika 2026-08-13: "make workspace blocker page on 0
// credit nice blurred overlay") — the DESIGN_LANGUAGE.md §7.5 Modal/Sheet
// chassis, applied here: a full-viewport `scrim` + `backdropFilter: blur`
// backdrop (byte-identical treatment to `Modal.js`/`AiActionConfirmCard.js` —
// the canonical veil, never a theme-invariant opaque fill) with the actual
// copy living in a floating `Card` (`background: 'document'`, `round:
// 'radiusSheet'`, `shadow: 'overlay'` — §2.3's two-shadow budget, never a
// bespoke boxShadow string). The workspace underneath stays visible-but-
// blurred rather than fully occluded — this is the §9 depleted state
// designed as a floating moment, not a second full page. `role: 'dialog'` +
// `ariaModal` move onto the Card itself (the actual dialog surface), not the
// backdrop, matching the Modal/ModalWindow split.
// DISMISSIBILITY + SCOPE (CREDIT-BLOCK-1 defect #3, tickets/opus.md). This
// gate shipped with NO close affordance, no Escape, no backdrop dismissal —
// its only interactive descendant was "Top up credits" — while covering
// 100% of the viewport on every route. Its own copy promised that "AI,
// builds and metered actions are paused", but the implementation also blocked
// pure reads that cost nothing (viewing a channel, a calendar, a teammate),
// and three independent lanes reproduced it as an inescapable trap.
//
// It is now a NOTICE, not a trap: Escape, the ✕, and a backdrop click each
// dismiss it for the session (`_creditBlockerDismissed` — workspace-scoped
// in state.js, so a switch re-announces for the new tenant; deliberately NOT
// a pref cookie — a `smbls_pref_*` cookie's one-year, cross-app, cross-tab
// scope would outlive the tab and suppress the notice for a genuinely new
// session too). CREDITS-GATE-UI-BREAK-1: that in-memory state alone meant
// any remount — including ordinary dev-server HMR/live-reload churn, not
// just a hard reload — wiped the dismissal and re-armed the gate on every
// single page mount, measured live re-showing on every navigation all
// session. `scope.close` below now ALSO mirrors the dismissal into
// per-workspace sessionStorage (`writeCreditBlockerDismissed`,
// functions/creditGuard.js), and `Overlay.hide` seeds it back on the next
// mount (`readCreditBlockerDismissed`) — sessionStorage dies with the tab,
// so a genuinely new tab still sees the gate once; only a remount WITHIN
// the same tab is now silent.
//
// Metered actions stay gated where they are actually spent — the server throws
// INSUFFICIENT_CREDITS / SPEND_CAP_EXCEEDED / ALLOCATION_EXCEEDED at the
// point of use and notifyCreditsExhaustedFromMessage surfaces it — so
// nothing is un-gated by letting the user read past this card. Once
// dismissed, CreditBanner carries the state persistently, so the two still
// never co-render.
//
// It also no longer fires on an UNKNOWN balance: `creditGuardState` returns
// `'unknown'` (never `'exhausted'`) when the balance could not be read, and
// only `'exhausted'` reaches the gate below. Nothing may be blocked on a
// value nobody positively confirmed.
//
// THE NOTICE IS A MODAL LAYER (persona audit round 1, elena, a direct sign-up):
// the first screen of a new account was this notice drawn over the welcome
// steps, and its ✕, Escape and the veil did nothing while Tab walked to "Skip
// setup" BEHIND it. Nothing in the handlers was broken — the welcome surface
// (OnboardingWizard) is a modal layer too: its `inertOutside` puts `inert` on
// every element outside it, and this notice, a sibling at the shell root, is
// outside it. An inert element takes no pointer, no focus, no keyboard, so the
// notice was painted above (z-index) and dead beneath (inert); in a workspace
// with no welcome open the same ✕ closed it. The framework's contract is
// "a dialog that opens over a layer must itself be a layer", and the
// `Overlay` below now is one: `inertOutside` on the same predicate that
// paints it (`creditBlockerShown`), so while it is up the page behind — the
// welcome included — is the inert one, focus moves in, Tab stays in (the
// Card's own trap, as AppDialog does), and closing hands the page, and the
// focus, back exactly as they were. The other order — the welcome opening AFTER
// the notice — is the welcome's to yield: components/OnboardingWizard.js
// `inertOutside` asks this same `creditBlockerShown`, so the notice stays the
// newest layer and the welcome waits under it. Locked by
// CreditBlocker.render.test.js (both orders).
const $b4ee0a571e96e944$export$2bc36784a2699a3a = {
    tag: 'div',
    display: 'contents',
    subscribeTo: [
        '_creditGuard',
        'currentPath',
        'workspace',
        'signedIn',
        'roles',
        '_creditBlockerDismissed'
    ],
    // Escape-to-dismiss now routes through the SAME chassis `shared/Modal.js`
    // uses (2026-08-15 — `packages/shared/**` write access granted, see
    // Modal.js's own header comment for the full FA409/FA503 fix): no
    // document-level listener, no `window`/context-flag once-guard at all —
    // just a declarative `onKeydown` on `Overlay` (the gate's dialog root,
    // below), fed by moving focus onto `Card` when the gate opens
    // (`scope.manageFocus` below; `Card` already carries
    // `role="dialog"`/`ariaModal`, and now `tabindex: '-1'` so it's
    // programmatically focusable). Escape bubbles from whichever descendant
    // holds focus up to `Overlay`'s `onKeydown` exactly like `AppDialog.js`
    // and the fixed `Modal.js` already prove live. This directly replaces the
    // FA503 divergence this file used to carry (a document-level keydown
    // listener bound via a context-scoped flag, justified at the time by "the
    // gate is not a focusable element" — it is, now, via `Card`'s own
    // `tabindex`).
    scope: {
        manageFocus (el, isOpen) {
            if (typeof document === 'undefined') return;
            if (isOpen === el._focusWasOpen) return;
            el._focusWasOpen = isOpen;
            if (isOpen) {
                el._returnFocusTo = document.activeElement;
                const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (fn)=>fn();
                raf(()=>{
                    const card = el.lookdown && el.lookdown('Card');
                    if (card && card.node && typeof card.node.focus === 'function') card.node.focus();
                });
            } else {
                if (el._returnFocusTo && el._returnFocusTo.focus) el._returnFocusTo.focus();
                el._returnFocusTo = null;
            }
        },
        // `close(el, s)` — el first, matching shared/Modal.js's own `close(el,
        // s)` (the chassis this Escape/backdrop handling mirrors) and this same
        // scope's `manageFocus(el, isOpen)` above. `scope` methods are plain
        // properties called off `el.scope.X(...)` — `this` inside resolves to
        // `el.scope`, not the element, so `el` must travel in explicitly to
        // reach `el.call` below (same reason `manageFocus` already takes it).
        close (el, s) {
            const root = s?.root;
            if (!root || !root.update) return;
            root.update({
                _creditBlockerDismissed: true
            });
            // Mirror the dismissal into per-workspace sessionStorage so it
            // survives a remount within this tab (CREDITS-GATE-UI-BREAK-1 — see
            // functions/creditGuard.js's `writeCreditBlockerDismissed` header for
            // the full rationale). Best-effort: a storage failure must never
            // block the in-memory dismiss above.
            const wsId = root.workspace?.id || root.workspace?._id || null;
            if (wsId && el && typeof el.call === 'function') el.call('writeCreditBlockerDismissed', wsId, true);
        }
    },
    // ONE threshold-notification driver for the whole guard family (the
    // banner deliberately has none — two drivers would race the pref write).
    // notifyCreditThreshold derives status itself, early-returns for
    // non-admins and already-announced levels, so firing on every
    // `_creditGuard` change is idempotent.
    onUpdate: (el, s)=>{
        if (s.root && s.root._creditGuard) el.call('notifyCreditThreshold', el, s.root);
    },
    Overlay: {
        hide: (el, s)=>{
            // The ONE predicate for "the notice is up" (functions/creditGuard.js
            // creditBlockerShown) — seeding a sessionStorage dismissal into ROOT
            // STATE on this paint path, so CreditBanner's CreditWarningPill (which
            // reads `root._creditBlockerDismissed` directly) takes over as the
            // persistent indicator exactly like an in-session dismissal — the two
            // still never co-render.
            const blocked = !!el.call('creditBlockerShown', el, s.root, true);
            // Piggy-back on this reactive read (re-evaluated every render, same
            // technique `shared/Modal.js`'s `isOpen` and `AppDialog.js`'s `hide`
            // use) to move focus onto `Card` on open / restore it on close — see
            // the root `scope.manageFocus` comment above.
            el.scope.manageFocus(el, blocked);
            return !blocked;
        },
        // THE LAYER. While the notice is up, everything OUTSIDE it is inert — the
        // welcome surface, the shell, a toast — exactly as outside a modal
        // <dialog>, and the layer moves focus in and gives it back (the framework's
        // `inertOutside`, smbls element/src/inertOutside.js). Gated on the SAME
        // predicate as `hide` above, never on visibility: a layer hidden with
        // `hide:` stays modal, so a different predicate would leave the page dead
        // under an invisible notice. No state write here — a prop that decides
        // modality is a pure read.
        inertOutside: (el, s)=>!!el.call('creditBlockerShown', el, s.root, false),
        inertOutsideDeps: [
            'signedIn',
            'currentPath',
            'workspace',
            '_creditGuard',
            '_creditBlockerDismissed'
        ],
        // Escape bubbles here from `Card` (focused by `manageFocus` above) and
        // STOPS here, as the AppDialog chassis does: the one Escape that closes the
        // notice must not also close whatever listens above it.
        onKeydown: (e, el, s)=>{
            if (e.key !== 'Escape') return;
            e.stopPropagation();
            el.scope.close(el, s);
        },
        // Backdrop click dismisses. `e.target !== el.node` means the click
        // landed on the veil itself, not on anything inside the Card — the same
        // discrimination shared/Modal.js's maybeDismiss makes.
        onClick: (e, el, s)=>{
            if (e.target !== el.node) return;
            el.scope.close(el, s);
        },
        position: 'fixed',
        inset: '0',
        zIndex: '10300',
        // The veil, not the surface — byte-identical grammar to Modal.js /
        // AiActionConfirmCard.js: `scrim` is the adaptive theme-mirrored dim
        // (white-tinted on light, ink on dark — DESIGN_LANGUAGE §4.1), and
        // `blur(4px)` matches the canonical Modal chassis exactly (§7.5) so the
        // workspace behind the gate reads as blurred-but-present, not a second
        // opaque page.
        background: 'scrim',
        backdropFilter: 'blur(4px)',
        align: 'center center',
        padding: 'C',
        overflow: 'auto',
        overscrollBehavior: 'contain',
        '@mobileL': {
            padding: 'B'
        },
        // The floating card — the ONLY opaque surface in this gate. `document`
        // (opaque, adaptive both themes, §2.2) + `radiusSheet` + the `overlay`
        // elevation shadow (§2.3's two-shadow budget — never a bespoke
        // boxShadow string). `role`/`ariaModal` live here (the real dialog
        // surface), not on the backdrop, matching Modal/ModalWindow's split.
        Card: {
            position: 'relative',
            background: 'document',
            round: 'radiusSheet',
            shadow: 'overlay',
            flow: 'y',
            align: 'center center',
            gap: 'A',
            padding: 'C',
            maxWidth: 'I',
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'center',
            role: 'dialog',
            ariaModal: 'true',
            ariaLabel: (el)=>el.call('polyglot', 'workspace.creditBlocker.aria'),
            // Programmatically focusable, not tab-reachable — `scope.manageFocus`
            // moves focus here on open so Escape (declared on `Overlay`, above)
            // has a focused descendant to bubble from. Same idiom as brand's
            // `ModalWindow` (`tabindex: '-1'`).
            tabindex: '-1',
            // Tab / Shift+Tab cycle between the ✕ and the action and never leave —
            // the same scoped trap every AppDialog panel and the welcome surface
            // run (appDialogTrapTab), so keyboard focus stays in the notice while
            // it is up (the layer above keeps the page behind out of reach).
            onKeydown: (e, el)=>el.call('appDialogTrapTab', e),
            '@mobileL': {
                padding: 'B'
            },
            // The close affordance this gate shipped without. Absolute inside the
            // Card's own relative box so it never enters the centred content flow
            // (zero shift). THE house close X (brand CloseButton — F2, one X for
            // every panel).
            Close: {
                extends: 'CloseButton',
                position: 'absolute',
                top: 'Y',
                right: 'Y',
                ariaLabel: (el)=>el.call('polyglot', 'workspace.creditBlocker.dismissAria'),
                title: (el)=>el.call('polyglot', 'workspace.creditBlocker.dismissTitle'),
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.scope.close(el, s);
                }
            },
            Overline: {
                tag: 'span',
                fontSize: 'Y2',
                fontWeight: '700',
                textTransform: 'uppercase',
                letterSpacing: '.08em',
                color: 'dangerInk',
                text: '{{ workspace.creditBlocker.eyebrow | polyglot }}'
            },
            // The Alarm-archetype numeral — the state IS the number. φ letters are
            // EM-RELATIVE (live-measured here: 'G' ≈ 51px, 'I' ≈ 73px against this
            // card's 17px chain), so a single letter can't reach poster scale.
            // Hero compounds two ladder steps — wrapper 'D' × numeral 'I' ≈ 160px —
            // staying token-pure instead of hardcoding a px size.
            Hero: {
                fontSize: 'D',
                lineHeight: '1',
                Zero: {
                    tag: 'span',
                    fontFamily: 'Code',
                    fontSize: 'I',
                    fontWeight: '200',
                    lineHeight: '0.9',
                    color: 'title',
                    ariaHidden: 'true',
                    text: '0',
                    '@mobileL': {
                        fontSize: 'G'
                    }
                }
            },
            // Mixed-weight identity line: thin context, heavy fact.
            Headline: {
                tag: 'h1',
                margin: '0',
                fontSize: 'C',
                color: 'title',
                lineHeight: '1.15',
                Lead: {
                    tag: 'span',
                    fontWeight: '300',
                    // The light half of the two-weight headline. `{name}` is the
                    // workspace's own record name; the bold half (`LeadStrong`) carries
                    // the rest of the sentence, so the two keys must be translated as a
                    // PAIR — Georgian puts the case marker on this half.
                    text: (el, s)=>el.call('polyglot', 'workspace.creditBlocker.lead').replace('{name}', s.root?.workspace?.name || el.call('polyglot', 'workspace.creditBlocker.thisWorkspace'))
                },
                LeadStrong: {
                    tag: 'span',
                    fontWeight: '700',
                    text: '{{ workspace.creditBlocker.headline | polyglot }}'
                }
            },
            Sub: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                lineHeight: '1.5',
                maxWidth: 'H',
                // Says exactly what is paused and what is not. The old copy promised
                // only metered actions were paused while the gate blocked the whole
                // product — the copy was right and the implementation was wrong, so
                // the implementation moved.
                text: '{{ workspace.creditBlocker.body | polyglot }}'
            },
            // Admins act; members learn who can. Both branches read live role
            // state, so a role change flips the affordance without a reload.
            Cta: {
                hide: (el, s)=>!el.call('currentUserIsAdmin', s.root),
                marginTop: 'Z',
                // House primary: inverse fill (title plate, reversed ink) — the
                // DashboardSidebar onboarding CTA pairing. The bare Button base is
                // chromeless, so the fill is declared here.
                Button: {
                    text: '{{ workspace.creditBlocker.topUp | polyglot }}',
                    minHeight: 'controlH',
                    padding: '0 B',
                    fontWeight: '700',
                    round: 'radiusPill',
                    background: 'title',
                    color: 'title-reversed',
                    cursor: 'pointer',
                    border: 'none',
                    ':hover': {
                        opacity: '0.85'
                    },
                    onClick: (e, el, s)=>el.router('/admin/usage', el.getRoot())
                }
            },
            MemberNote: {
                hide: (el, s)=>!!el.call('currentUserIsAdmin', s.root),
                tag: 'p',
                margin: '0',
                marginTop: 'Z',
                fontSize: 'Z2',
                color: 'caption',
                text: '{{ workspace.creditBlocker.askAdmin | polyglot }}'
            },
            // The grant context, from the record — never a literal.
            GrantNote: {
                hide: (el, s)=>{
                    const guard = el.call('creditGuardState', s.root);
                    return !(guard && guard.grantSize > 0);
                },
                tag: 'span',
                marginTop: 'A',
                fontSize: 'Y',
                fontFamily: 'Code',
                color: 'caption',
                // One key per form — Georgian keeps the noun singular after a
                // number. The digits keep their source formatting (glossary rule 6).
                text: (el, s)=>{
                    const guard = el.call('creditGuardState', s.root);
                    const n = Number(guard?.grantSize || 0);
                    return el.call('polyglot', n === 1 ? 'workspace.creditBlocker.grantNoteOne' : 'workspace.creditBlocker.grantNote').replace('{count}', n.toLocaleString('en-US'));
                }
            }
        }
    }
};

});

parcelRegister("5uOS7", function(module, exports) {

$parcel$export(module.exports, "CreditWarningPill", () => $40073731eab7b717$export$bc20ae39e8a163bc);
$parcel$export(module.exports, "CreditBanner", () => $40073731eab7b717$export$c60981955dc91f37);
// CreditBanner — the admin early-warning pill for a workspace approaching
// zero credits (tickets/fable.md, Nika 2026-08-13: "notifications + banner
// to admin when its approaching to end - that links to credit usage page").
//
// Shows for admins only, at guard status LOW or CRITICAL (fractions of the
// monthly grant — functions/creditGuard.js; the figures themselves come
// from sdk.getCreditBalance, never literals). EXHAUSTED belongs to
// CreditBlocker while that notice is on screen — but it is dismissible now
// (CREDIT-BLOCK-1 defect #3), so once dismissed this pill takes over as the
// persistent exhausted indicator. Exactly one of the two is ever visible, so
// "they never co-render" still holds. Status UNKNOWN shows nothing at all:
// a balance nobody could read must not warn any more than it may block.
// Hidden on /admin/usage
// itself (the page IS the destination — tickets/opus.md "credits-exhausted
// UX": the CTA below used to route to the never-registered `/credits`, a
// silent no-op redirect to `/`) and after a per-(workspace, month, level)
// dismissal — an escalation from low → critical re-surfaces it.
//
// Chrome: the house bottom-left glass pill (CanvasHelpCard — the
// DemoClaimBanner/PersonaPill corner idiom), zero layout shift by
// construction (`display:'contents'` wrapper + fixed descendant). When a
// persona session is active the pill lifts one step up so it never overlaps
// PersonaPill's own bottom-left slot.
//
// UI-TUTORIAL-NOTIFICATION-FAMILY-1: CreditWarningPill (below) extends
// TutorialNotification (same canvas-card-glass surface CanvasHelpCard
// already gave it) so the "Top up" CTA goes through the shared
// TutorialNotificationButtons row instead of a hand-rolled button.
// `useCookie: false` — this pill's OWN escalation-aware
// `_creditBannerDismissed`/`credit_banner_${wsId}` logic (below) is its
// entire dismiss contract; it must not also gate behind the family's
// generic tutorial-cookie. The dismiss-X stays its own sibling, keyed
// `CloseButton` (bare-key auto-extend, dropped the explicit `extends`
// audit_component's FA806 flagged) rather than folding into the action
// row — TutorialNotificationButtons is for labeled text+icon CTAs, not a
// bare close-X. `CreditWarningPill` is a real top-level component, not a
// nested child with an `extends` audit_component would flag (FA806) — same
// fix RemoteUpdateBanner/InfraDemoBanner already use, both top-level
// exports with their own differently-named `extends`. Named
// `CreditWarningPill`, not the generic `CanvasHelpCard` it used to extend
// (would collide at the DOM level with the real, separate CanvasHelpCard
// instances elsewhere — MEMORY project_two_elements_share_one_data_key) and
// not `DemoClaimBanner`'s own pill's name either — the two can legitimately
// be on screen at once (a demo admin low on credits).
//
// NO `position`/inset props on this element — deliberately. `extends:
// 'TutorialNotification' extends 'Navbar'` (company/packages/brand/
// components/Navbar.js), whose OWN base bakes in `position:'sticky',
// top:'0'` as its identity. Overriding `position:'fixed'` here does not
// reliably cancel Navbar's `top:'0'` (measured live on the identical
// DemoClaimBanner pattern: rendered as a near-fullscreen box instead of a
// compact pill, even with an explicit `top:'auto'` override attempted).
// Fix: positioning lives on `CreditBanner`'s own `CreditPillDock` wrapper
// below instead — a plain box with no Navbar ancestry to fight.
const $40073731eab7b717$export$bc20ae39e8a163bc = {
    extends: 'TutorialNotification',
    useCookie: false,
    // The predicate itself moved to `functions/creditGuard.js`
    // (`creditPillVisible`) — the DOCK wrapper below has to ask the very same
    // question before it may claim any geometry, and two copies of a
    // visibility rule is exactly how the wrapper ended up covering a live AI
    // thread with an empty panel
    // (WS-ASSISTANT-DRAWER-COVERED-BY-EMPTY-CREDIT-DOCK-1). One source of
    // truth, reached through the registry so it survives the frank lift.
    //
    // FA515: the predicate reads its state keys behind short-circuiting
    // conditionals, so the dependency tracker cannot see them from the factory
    // body alone — declared explicitly. The list mirrors CreditBanner's own
    // `subscribeTo` below: the wrapper's subscription covers whether IT
    // re-renders, this element's reactive factory needs its own declaration
    // regardless, and an under-declared list is what leaves a stale gate on
    // screen.
    hideDeps: [
        'signedIn',
        'currentPath',
        'roles',
        'workspace',
        '_creditGuard',
        '_creditsShort',
        '_creditBannerDismissed',
        '_creditBlockerDismissed'
    ],
    hide: (el, s)=>!el.call('creditPillVisible', el, s.root),
    flow: 'x',
    align: 'center',
    gap: 'Z1',
    padding: 'Z A',
    round: 'radiusControl',
    boxShadow: 'none',
    width: 'auto',
    // Hgroup nulled too: single-line horizontal pill (own Dot/Label below),
    // not TutorialNotification's default vertical icon+title+descr card.
    Lottie: null,
    Hgroup: null,
    Dot: {
        tag: 'span',
        width: 'Y',
        height: 'Y',
        minWidth: 'Y',
        round: '50%',
        ariaHidden: 'true',
        background: (el, s)=>{
            // A shortfall is a warning, not an emergency: the workspace still has
            // credits, it is the one request that does not fit.
            if (el.call('creditShortState', el, s.root)) return 'warningInk';
            const guard = el.call('creditGuardState', s.root);
            const st = guard?.status;
            return st === 'critical' || st === 'exhausted' ? 'dangerInk' : 'warningInk';
        }
    },
    Label: {
        tag: 'span',
        fontSize: 'Z1',
        color: 'title',
        // The sentence is the whole message — for a held shortfall what the
        // request needs and, for a member, who to ask — so it wraps rather than
        // being cut off behind an ellipsis. The short low/critical/exhausted lines
        // fit on one row either way.
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        text: (el, s)=>{
            // A held SHORTFALL (functions/creditGuard.js creditShortState): what the
            // last refused request needs against what the workspace has. The figures
            // are formatted like every other credit count here; the way out is the
            // button beside it (below), which depends on who is looking.
            const short = el.call('creditShortState', el, s.root);
            if (short) return el.call('polyglot', 'workspace.creditBanner.short').replace('{needed}', ()=>Number(short.needed).toLocaleString('en-US')).replace('{available}', ()=>Number(short.available).toLocaleString('en-US'));
            const guard = el.call('creditGuardState', s.root);
            if (guard?.status === 'exhausted') return el.call('polyglot', 'workspace.creditBanner.exhausted');
            const n = Number(guard?.total || 0).toLocaleString('en-US');
            return el.call('polyglot', guard?.status === 'critical' ? 'workspace.creditBanner.critical' : 'workspace.creditBanner.low').replace('{count}', n);
        }
    },
    // Real Button/CanvasButton semantics via the shared action row instead
    // of a hand-rolled `tag:'button'` — one button, so `children` is
    // length-1, same as the family's own single-CTA precedent.
    TutorialNotificationButtons: {
        height: 'auto',
        childProps: {
            background: 'transparent',
            border: 'none',
            padding: 'V Y',
            round: 'radiusControl',
            flex: '0 0 auto',
            cursor: 'pointer',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            whiteSpace: 'nowrap',
            ':hover': {
                background: 'hover'
            },
            // CanvasButton/Button default to `aspect-ratio: 1/1` (an icon-only
            // square/circle button). This CTA has text and no icon, so without
            // this override it renders near-square with border-radius:999px
            // rounding it into a circle instead of a pill (measured live on the
            // identical DemoClaimBanner pattern).
            aspectRatio: 'auto'
        },
        children: [
            {
                // The way out, by role. An ADMIN holding a shortfall adds credits (the
                // credit page); a MEMBER, who has no such page (house rule: no fake
                // affordances), asks the admins — a real in-app request, once per
                // refusal (functions/creditGuard.js askAdminsForCredits), after which
                // the button says so. Without a shortfall it is the usual Top up.
                text: (el, s)=>{
                    const short = el.call('creditShortState', el, s.root);
                    return el.call('polyglot', !short ? 'workspace.creditBanner.topUp' : short.admin ? 'workspace.creditBanner.addCredits' : short.asked ? 'workspace.creditBanner.asked' : 'workspace.creditBanner.askAdmin');
                },
                disabled: (el, s)=>{
                    const short = el.call('creditShortState', el, s.root);
                    return !!short && !short.admin && short.asked ? true : null;
                },
                title: (el, s)=>{
                    const short = el.call('creditShortState', el, s.root);
                    return el.call('polyglot', short && !short.admin ? 'workspace.creditBanner.askAdminTitle' : 'workspace.creditBanner.topUpTitle');
                },
                onClick: (e, el, s)=>{
                    const short = el.call('creditShortState', el, s.root);
                    if (short && !short.admin) return el.call('askAdminsForCredits', el, s.root);
                    el.router('/admin/usage', el.getRoot());
                }
            }
        ]
    },
    // THE house close X (brand CloseButton — F2, one X for every panel).
    // Bare-key auto-extend (key matches CloseButton exactly) — no `extends`
    // needed, and CloseButton is meant to be interchangeable everywhere it's
    // used, so there's no meaningful-name reason to alias it the way
    // CanvasHelpCard needed one.
    CloseButton: {
        title: (el)=>el.call('polyglot', 'workspace.creditBanner.dismissTitle'),
        'aria-label': (el)=>el.call('polyglot', 'workspace.creditBanner.dismissAria'),
        // X position fix (same ask): the 36px house circle inflated this slim
        // one-line pill's height and floated in the full `A` right-padding air
        // pocket. Negative margins tuck it — the hit circle overhangs the
        // pill's vertical padding instead of growing it, and sits flush toward
        // the right edge; the 44pt coarse-pointer slop is untouched.
        margin: '-Y2 -Z1 -Y2 0',
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const root = s.root;
            // A shortfall closes itself, not the month's low-credit ladder below:
            // the record stays (the usage page keeps telling the truth about it),
            // only the pill is closed, until a NEW refusal opens it again.
            if (el.call('creditShortState', el, root)) {
                root.update({
                    _creditsShort: {
                        ...root._creditsShort,
                        dismissed: true
                    }
                }, {
                    preventFetch: true
                });
                return;
            }
            const guard = el.call('creditGuardState', root);
            const wsId = root.workspace?.id || root.workspace?._id || 'ws';
            const period = new Date().toISOString().slice(0, 7);
            // Same ladder as `hide:` above (exhausted:3 / critical:2 / low:1) —
            // writing a lower level than the state being dismissed leaves the
            // hide unsatisfied and renders the X a no-op (measured: the exhausted
            // takeover pill could never be dismissed while this wrote 1).
            const level = guard?.status === 'exhausted' ? 3 : guard?.status === 'critical' ? 2 : 1;
            const seen = `${period}:${level}`;
            el.call('setPref', `credit_banner_${wsId}`, seen);
            root.update({
                _creditBannerDismissed: seen
            }, {
                preventFetch: true
            });
        }
    }
};
const $40073731eab7b717$export$c60981955dc91f37 = {
    tag: 'div',
    display: 'contents',
    subscribeTo: [
        '_creditGuard',
        '_creditsShort',
        'currentPath',
        'roles',
        'workspace',
        'signedIn',
        '_creditBannerDismissed',
        '_creditBlockerDismissed'
    ],
    // Plain positioning wrapper — NOT extending TutorialNotification/Navbar,
    // so it carries none of Navbar's baked-in `position:'sticky', top:'0'`
    // to fight (see CreditWarningPill's own comment above for why this split
    // exists).
    CreditPillDock: {
        // WS-ASSISTANT-DRAWER-COVERED-BY-EMPTY-CREDIT-DOCK-1 — the dock is a
        // POSITIONING wrapper for the pill, so it must not exist as a box when
        // there is no pill to position. It used to render unconditionally (the
        // visibility gate lived only on the child), and shellApp's docked-
        // assistant stylesheet then gave that always-present, EMPTY wrapper the
        // drawer's whole rect at z-index 10001 with an opaque background: on
        // every workspace that is not out of credits — the common case — an
        // invisible panel covered the entire AI thread (answer, source chips,
        // confidence pill). Same predicate as the pill, same source
        // (`creditPillVisible`), so the two can never disagree.
        hideDeps: [
            'signedIn',
            'currentPath',
            'roles',
            'workspace',
            '_creditGuard',
            '_creditsShort',
            '_creditBannerDismissed',
            '_creditBlockerDismissed'
        ],
        hide: (el, s)=>!el.call('creditPillVisible', el, s.root),
        // …and PUBLISH what it is carrying, so the shell stylesheet can key the
        // docked-assistant geometry on credit state instead of on the mere
        // presence of this element. 'cover' (out of credits — the drawer is a
        // dead surface, the notice takes its box), 'pill' (low/critical — the
        // assistant still works, so the warning must never cover a live thread),
        // absent (no pill: no geometry, nothing to paint, nothing to hit-test).
        // The reacts-in-CSS idiom the shell already uses for <html
        // data-assistant-dock>; see app.js for the rules that consume it.
        attrDeps: {
            'data-credit-dock': [
                'signedIn',
                'currentPath',
                'roles',
                'workspace',
                '_creditGuard',
                '_creditsShort',
                '_creditBannerDismissed',
                '_creditBlockerDismissed'
            ]
        },
        attr: {
            'data-credit-dock': (el, s)=>el.call('creditDockMode', el, s.root)
        },
        position: 'fixed',
        // Toast-anchor family (2026-09-02 per Nika "move CreditWarningPill
        // above AI textarea ... if its out of credits AI is obviously blocked
        // so its good UI decision") — the same centered above-composer slot
        // CallInvitationBanner took: the pill now reads as a status OF the
        // composer it gates. Replaces the old bottom-LEFT corner dock (and its
        // PersonaPill step — the persona pill keeps that corner; no collision
        // from the center slot). If the call banner and this pill ever
        // co-render they share the anchor — accepted: both are transient, and
        // the call banner outranks visually by size.
        left: '50%',
        transform: 'translateX(-50%)',
        right: 'auto',
        bottom: 'C1',
        zIndex: '1500',
        display: 'flex',
        width: 'auto',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        '@mobileL': {
            left: 'A',
            right: 'A',
            transform: 'none',
            justifyContent: 'center'
        },
        // Bare-key auto-extend resolves CreditWarningPill (this file, above) —
        // no `extends` needed since the key name matches exactly.
        CreditWarningPill: {}
    }
};

});

parcelRegister("5bIQI", function(module, exports) {

$parcel$export(module.exports, "DemoClaimBar", () => $3c70c4fad764a7a3$export$e4afdaa3c61d592e);
$parcel$export(module.exports, "DemoClaimBanner", () => $3c70c4fad764a7a3$export$f039ec43916f029e);

var $7iFOV = parcelRequire("7iFOV");
'use strict';
// DemoClaimBanner — in-product conversion for demo sandbox sessions.
//
// When the signed-in user is a demo account (`root.isDemo` — seeded from
// getMe()'s `isDemo` flag by bootShell._resolveAuthSnapshot), a slim
// persistent bar pins to the bottom-left inviting them to claim/keep the
// workspace. Clicking "Claim this workspace" opens the brand Modal whose body
// is the SAME sign-in window the /login page renders (LoginWindow from
// @symbo-ls/workspace-shared) — REUSED, not rebuilt — supporting BOTH paths
// the /login chrome already ships:
//
//   • SIGN UP (new account): slot `SignupForm`. Submit calls
//     `el.sdk.claimDemoAccount({ email, password, name })` — the server
//     upgrades the current demo account IN PLACE (sets the password + real
//     email, clears `isDemo` on the user and their org so the sandbox stops
//     resetting). The workspace is KEPT. The demo tokens stay valid (same
//     account row), so we hand them off straight to my.symbols.app.
//
//     PENDING EMAIL (server core/auth-takeover-paths B-5): the server no
//     longer switches the account to the new email at claim time. It parks
//     the address on `pendingEmail`, mails a verification link to it, and
//     answers `{ user, pendingEmail, emailVerificationSent }`. The window then
//     swaps the forms for a PENDING panel (`root._demoClaimPendingEmail`): the
//     new email stays pending until the link is clicked, and sign-in with it
//     does not work before that. "Go to workspace" runs the handoff. A server
//     that predates the change sends no `pendingEmail` → the handoff runs at
//     once, as before.
//
//   • LOG IN (existing account): slot `LoginForm`. Submit calls
//     `el.sdk.login(identifier, password)` to authenticate the user's REAL
//     account, then `el.sdk.cloneDemoWorkspace({ demoOrgId })` to copy the
//     CURRENT demo session's workspace into a fresh real org owned by that
//     account, then hands the (now real-account) tokens off to my.symbols.app.
//
// Both paths end in `el.call('demoHandoff')` — the cross-origin token hop
// (functions/demoHandoff.js) that redirects to the shell's hash-token
// consumer (/auth/magic-callback on my.symbols.app) authed with the fresh
// tokens, so the user lands signed-in on their (converted or cloned)
// workspace. demo.symbols.app and my.symbols.app are different origins, so a
// plain redirect would drop the session — the handoff is what carries it.
//
// Mode toggle: `root._demoClaimMode` ('signup' | 'login', default 'signup')
// flips which form is slotted + which submit path runs. A link in the window
// switches between the two. The email field starts EMPTY in both modes — the
// demo account's email is a `demo-anon-…@demo.symbols.app` placeholder, never
// prefilled.
//
// CHROME REUSE:
//   - The BAR (`DemoClaimBar`, its own top-level component below) extends
//     the shared `TutorialNotification` card (UI-TUTORIAL-NOTIFICATION-
//     FAMILY-1) — same glassy canvas-card surface CanvasHelpCard gave it,
//     plus the family's shared TutorialNotificationButtons action row — and
//     overrides it for the banner look. It renders only on `/` (home) —
//     `hide` gates on `currentPath` — and the wrapper is `display: contents`
//     so it never participates in the shell-root grid.
//   - The MODAL body is `LoginWindow` (the /login window) slotted into the
//     brand `Modal`'s `Window` slot, with `SignupForm` / `LoginForm` slotted
//     into its `Flex` — REUSED verbatim, retargeted from login to claim/clone.
//
// Mounted ONCE at the shell root (workspace/app.js) as a sibling of AppHeader.
// Invisible to every real user: bar + Modal short-circuit on `!root.isDemo`.
// Draft + UI flags reset shape — cleared on close, on success, and on cancel
// so a reopen always starts blank.
const $3c70c4fad764a7a3$var$_resetClaim = {
    _demoClaimOpen: null,
    _demoClaimMode: 'signup',
    _demoClaimError: null
};
// Resolve the CURRENT demo session's active org id — the source workspace the
// clone path copies. Layered the same way functions/auth.js resolveActiveOrgId
// + the studio canvas notes read it: the resolved org on root, then the JWT
// pointer, then the SDK's ambient context, then the first org in the list.
const $3c70c4fad764a7a3$var$_demoOrgId = (root, sdk)=>root?.org?.id || root?.jwtClaims?.workspace_org_id || sdk?._context?.activeOrgId || root?.orgs?.[0]?.id || null;
const $3c70c4fad764a7a3$export$e4afdaa3c61d592e = {
    extends: 'TutorialNotification',
    useCookie: false,
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    round: 'radiusControl',
    boxShadow: 'none',
    width: 'auto',
    // TutorialNotification's base caps the card at `maxWidth: 'H2'` (~646px)
    // for its vertical onboarding card. This is a single-line horizontal pill:
    // under that cap the lead sentence ellipsized at ~383px of 487px (measured
    // live, UI-TUTORIAL-NOTIFICATION-FAMILY-1). The viewport cap lives on
    // `ClaimBarDock` below, so the card itself is uncapped.
    maxWidth: 'none',
    Lottie: null,
    Hgroup: null,
    Lead: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        minWidth: '0',
        Icon: {
            name: 'clock',
            boxSize: 'A',
            color: 'caption'
        },
        Text: {
            tag: 'span',
            fontSize: 'Z2',
            lineHeight: '1.35',
            color: 'title',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            '@mobileL': {
                whiteSpace: 'normal'
            },
            text: '{{ workspace.demoClaim.banner | polyglot }}'
        }
    },
    TutorialNotificationButtons: {
        height: 'auto',
        childProps: {
            round: 'radiusPill',
            flex: '0 0 auto',
            minHeight: 'controlH',
            padding: '0 A',
            gap: 'X2',
            // CanvasButton/Button default to `aspect-ratio: 1/1` (an icon-only
            // square/circle button, the right default when every family sibling
            // provides an `icon`). This button has text and no icon — measured
            // live, without this override it renders 183×153px (near-square,
            // border-radius:999px rounds that into a circle) instead of a
            // 183×44px pill. Any text-only button in this family needs the same
            // override — see InfraDemoBanner/CreditWarningPill/RemoteUpdateBanner.
            aspectRatio: 'auto'
        },
        children: [
            {
                text: '{{ workspace.demoClaim.cta | polyglot }}',
                // Button law (design-direction.md §6/geex amendment): ONE
                // solid-ink primary capsule per screen, never a raw hue fill —
                // was `background:'blue', color:'white'` (fixed hue) before this
                // migration; InfraDemoBanner already established `theme:'primary'`
                // as the correct pattern for the same tier of CTA, adopted here
                // for real consistency, not just structural reuse.
                theme: 'primary',
                fontWeight: '700',
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    // Open in SIGN-UP mode with a blank draft. The anonymous demo
                    // account's email is a `demo-anon-…@demo.symbols.app` placeholder
                    // — never prefill it; the user types their REAL email (sign up)
                    // or their existing account email (log in, after toggling).
                    s.root.update({
                        ...$3c70c4fad764a7a3$var$_resetClaim,
                        _demoClaimOpen: true
                    });
                }
            }
        ]
    }
};
const $3c70c4fad764a7a3$export$f039ec43916f029e = {
    tag: 'div',
    // `display: contents` so this shell-root wrapper generates NO box of its own
    // and never becomes an in-flow grid item. Its only visible child (the
    // DemoClaimBar pill) and the claim Modal are both position:fixed, so
    // the wrapper has nothing to lay out. Without this the wrapper was a STATIC
    // grid child of the shell-root grid (every other shell overlay — ModalRoot,
    // DropdownRoot, TooltipRoot, AssistantDrawer, … — is position:fixed); on the
    // demo (isDemo true) it claimed the grid's 1fr content row and pushed the
    // router's `content` page-mount into a collapsed 0-height implicit row, which
    // rendered /tickets (and every non-home route) blank — the canvas was there
    // but ~60px below the viewport.
    display: 'contents',
    // Demo-only AND home-only (per Nika "only keep it on / page"): the claim bar
    // shows on `/` and is hidden on every other route. `subscribeTo` makes the
    // reactive `hide` re-run on SPA navigation (`currentPath`) and on the claim →
    // `isDemo:false` transition. `hide:` (not `if:`) keeps the node in the DOM so
    // the claim transition animates the bar out instead of destroying/recreating
    // it.
    subscribeTo: [
        'isDemo',
        'currentPath'
    ],
    hide: (el, s)=>!s.root?.isDemo || (0, $7iFOV.shellStripWorkspacePrefix)(s.root?.currentPath || '/') !== '/',
    // Plain positioning wrapper — NOT extending TutorialNotification/Navbar,
    // so it carries none of Navbar's baked-in `position:'sticky', top:'0'`
    // to fight. All the fixed/inset/z-index/responsive props that used to
    // live on DemoClaimBar itself now live here instead (see DemoClaimBar's
    // own comment above for why).
    ClaimBarDock: {
        position: 'fixed',
        right: 'auto',
        left: 'A',
        bottom: 'A',
        zIndex: '1500',
        // A bare `position:'fixed'` block defaults to `display:'block'` in this
        // setup — `display:'flex'` shrink-wraps this wrapper to DemoClaimBar's
        // own content width instead. (The pill's measured width, ~650px, is
        // correct as-is — that's the description sentence's real single-line
        // length at `whiteSpace:'nowrap'`, not a bug.)
        display: 'flex',
        width: 'auto',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        '@mobileL': {
            display: 'flex',
            left: 'Z',
            right: 'Z',
            bottom: 'Z',
            maxWidth: 'none'
        },
        // Bare-key auto-extend resolves DemoClaimBar (this file, above) — no
        // `extends` needed since the key name matches exactly.
        DemoClaimBar: {}
    },
    // Claim dialog — the brand Modal (backdrop, Escape, URL restore via the
    // stateKey contract) whose BODY is the REUSED /login window, supporting BOTH
    // sign-up (claim in place) and log-in (clone into the real account).
    //
    // The child key `Modal` auto-extends the brand Modal; `stateKey` makes this
    // instance driven by `_demoClaimOpen`.
    Modal: {
        stateKey: '_demoClaimOpen',
        // Escape/backdrop close resets the draft (shared Modal merges extraClose
        // into its close update).
        extraClose: {
            _demoClaimMode: 'signup',
            _demoClaimError: null
        },
        // Replace the brand Modal's default ModalWindow body with the /login
        // LoginWindow — same backdrop/stopPropagation wiring stays on this `Window`
        // key (Modal puts it there), the body chrome comes from LoginWindow.
        // Slot key MUST stay `Window` — the brand Modal places its backdrop /
        // stopPropagation wiring on the child literally keyed `Window` (renaming to
        // `LoginWindow` would break that slot resolution). The body chrome comes
        // from `extends: 'LoginWindow'`.
        Window: {
            extends: 'LoginWindow',
            // LoginWindow owns its isolated state. Seed every field BOTH forms read
            // EMPTY (static literal — SSR-safe, no param factory) so the demo
            // placeholder email never prefills; the user types their real address.
            // SignupForm mirrors into email/name/password, LoginForm into
            // identifier/password.
            state: {
                loading: false,
                email: '',
                name: '',
                identifier: '',
                password: ''
            },
            width: 'H1',
            maxWidth: '92vw',
            minHeight: 'auto',
            // Retarget the header copy per mode (sign up vs log in).
            ModalHeader: {
                Hgroup: {
                    H: {
                        text: (el, s)=>s.root?._demoClaimPendingEmail ? el.call('polyglot', 'workspace.demoClaim.pending.title') : s.root?._demoClaimMode === 'login' ? el.call('polyglot', 'workspace.demoClaim.titleLogIn') : el.call('polyglot', 'workspace.demoClaim.titleSignUp')
                    },
                    P: {
                        tag: 'p',
                        // Pending: the bundle sentence carries the address as {email};
                        // `_demoClaimPendingSent === false` means the server could not
                        // mail the link, and the sentence says so instead of "we sent".
                        // `_demoClaimPendingSent` is read only behind the pending branch
                        // (FA515): declare both keys so the sentence re-fires on either.
                        textDeps: [
                            (el, s)=>s.root && s.root._demoClaimPendingEmail,
                            (el, s)=>s.root && s.root._demoClaimPendingSent
                        ],
                        text: (el, s)=>s.root?._demoClaimPendingEmail ? el.call('polyglot', s.root._demoClaimPendingSent === false ? 'workspace.demoClaim.pending.notSent' : 'workspace.demoClaim.pending.body').replace('{email}', s.root._demoClaimPendingEmail) : s.root?._demoClaimMode === 'login' ? el.call('polyglot', 'workspace.demoClaim.ledeLogIn') : el.call('polyglot', 'workspace.demoClaim.ledeSignUp')
                    }
                }
            },
            Flex: {
                // OAuth has no role in claiming/cloning a demo workspace — drop the
                // Google/GitHub column the /login window ships.
                RequestAccessButtons: null,
                // SIGN-UP form — visible in signup mode. Reuses the /signup SignupForm
                // (Email + Name + Password + CheckButton); we retarget the submit
                // button label + add an inline error note + a mode-toggle link below.
                SignupForm: {
                    hide: (el, s)=>s.root?._demoClaimMode === 'login' || !!s.root?._demoClaimPendingEmail,
                    Email: {
                        Title: {
                            text: '{{ workspace.demoClaim.email | polyglot }}'
                        },
                        Input: {
                            placeholder: (el)=>el.call('polyglot', 'workspace.demoClaim.emailPlaceholder')
                        }
                    },
                    Password: {
                        Input: {
                            autocomplete: 'new-password',
                            placeholder: (el)=>el.call('polyglot', 'workspace.demoClaim.createPassword')
                        }
                    },
                    ModalFooter: {
                        // Inline error note — surfaces a failed claim in the window.
                        ClaimError: {
                            tag: 'p',
                            hide: (el, s)=>!s.root?._demoClaimError,
                            role: 'alert',
                            order: '-1',
                            margin: '0',
                            width: '100%',
                            fontSize: 'Y',
                            lineHeight: '1.4',
                            // Raw brand red as INK measured 2.45:1 (DESIGN_LANGUAGE §8.5 rule
                            // 2); `dangerInk` is the scheme pair that clears the floor.
                            color: 'dangerInk',
                            // `_demoClaimError` carries a bundle KEY for our own sentences and
                            // the server's words for its own; polyglot echoes what is no key.
                            text: (el, s)=>s.root?._demoClaimError ? el.call('polyglot', s.root._demoClaimError) : ''
                        },
                        CheckButton: {
                            text: (el, s)=>el.call('polyglot', s.loading ? 'workspace.demoClaim.signingUp' : 'workspace.demoClaim.signUp'),
                            disabled: (el, s)=>!!s.loading || (s.password || '').length < 8
                        },
                        // Toggle to LOG IN.
                        ModeToggle: {
                            tag: 'button',
                            type: 'button',
                            order: '1',
                            margin: '- - - auto',
                            padding: '0',
                            background: 'transparent',
                            borderWidth: '0',
                            cursor: 'pointer',
                            fontSize: 'Z2',
                            fontWeight: '400',
                            color: 'caption',
                            ':hover': {
                                color: 'title'
                            },
                            text: '{{ workspace.demoClaim.haveAccount | polyglot }}',
                            onClick: (e, el, s)=>{
                                e.preventDefault();
                                s.root.update({
                                    _demoClaimMode: 'login',
                                    _demoClaimError: null
                                });
                            }
                        }
                    }
                },
                // PENDING panel — after a claim whose new email awaits verification.
                // The header above carries the title + "we sent a link to {email}";
                // this panel adds the sign-in warning and the way forward.
                ClaimPending: {
                    hide: (el, s)=>!s.root?._demoClaimPendingEmail,
                    flow: 'y',
                    gap: 'A',
                    width: '100%',
                    SignInNote: {
                        tag: 'p',
                        role: 'note',
                        margin: '0',
                        fontSize: 'Z2',
                        lineHeight: '1.4',
                        color: 'caption',
                        text: '{{ workspace.demoClaim.pending.signInNote | polyglot }}'
                    },
                    ClaimError: {
                        tag: 'p',
                        hide: (el, s)=>!s.root?._demoClaimError,
                        role: 'alert',
                        margin: '0',
                        width: '100%',
                        fontSize: 'Y',
                        lineHeight: '1.4',
                        color: 'dangerInk',
                        textDeps: [
                            (el, s)=>s.root && s.root._demoClaimError
                        ],
                        text: (el, s)=>s.root?._demoClaimError ? el.call('polyglot', s.root._demoClaimError) : ''
                    },
                    Button: {
                        type: 'button',
                        theme: 'primary',
                        width: '100%',
                        minHeight: 'controlH',
                        round: 'radiusPill',
                        fontWeight: '700',
                        text: '{{ workspace.demoClaim.pending.continue | polyglot }}',
                        disabled: (el, s)=>!!s.loading,
                        onClick: async (e, el, s)=>{
                            e.preventDefault();
                            s.root.update({
                                _demoClaimError: null
                            });
                            s.update({
                                loading: true
                            });
                            const hopped = await el.call('demoHandoff');
                            if (!hopped) {
                                s.update({
                                    loading: false
                                });
                                s.root.update({
                                    _demoClaimError: 'workspace.demoClaim.error.signUpHandoff'
                                });
                            }
                        }
                    }
                },
                // LOG-IN form — visible in login mode. Reuses the /login LoginForm
                // (Identifier + Password + CheckButton); we retarget the submit label
                // + add the same inline error + a mode-toggle link back to sign up.
                LoginForm: {
                    hide: (el, s)=>s.root?._demoClaimMode !== 'login' || !!s.root?._demoClaimPendingEmail,
                    Flex: {
                        // This reuses the SAME shared LoginForm as the /login page's
                        // LoginWindow, which now carries fixed `data-testid` strings for
                        // the Playwright smoke harness (qa-automation/pages/signin.page.ts).
                        // Left inherited, this always-mounted-but-hidden claim modal would
                        // duplicate every one of those testids on every page (DemoClaimBanner
                        // is mounted unconditionally at the shell root — see its own
                        // `hide`-not-`if` note above — and Modal keeps its content in the DOM
                        // even while closed), so `getByTestId` would hit Playwright's strict-
                        // mode "resolved to 2 elements" error for every real (non-demo) user
                        // too. Null the testid on this instance so the /login-page one stays
                        // the sole match.
                        Identifier: {
                            Title: {
                                text: '{{ workspace.demoClaim.email | polyglot }}'
                            },
                            Input: {
                                type: 'email',
                                autocomplete: 'email',
                                placeholder: (el)=>el.call('polyglot', 'workspace.demoClaim.emailPlaceholder'),
                                'data-testid': null
                            }
                        },
                        Password: {
                            Input: {
                                autocomplete: 'current-password',
                                placeholder: (el)=>el.call('polyglot', 'workspace.demoClaim.yourPassword'),
                                'data-testid': null
                            }
                        }
                    },
                    ModalFooter: {
                        // Drop the /login "Forgot your password?" deep-link — it routes off
                        // to /reset-password which has no place in this claim flow.
                        DocsLink: null,
                        ClaimError: {
                            tag: 'p',
                            hide: (el, s)=>!s.root?._demoClaimError,
                            role: 'alert',
                            order: '-1',
                            margin: '0',
                            width: '100%',
                            fontSize: 'Y',
                            lineHeight: '1.4',
                            // Raw brand red as INK measured 2.45:1 (DESIGN_LANGUAGE §8.5 rule
                            // 2); `dangerInk` is the scheme pair that clears the floor.
                            color: 'dangerInk',
                            // `_demoClaimError` carries a bundle KEY for our own sentences and
                            // the server's words for its own; polyglot echoes what is no key.
                            text: (el, s)=>s.root?._demoClaimError ? el.call('polyglot', s.root._demoClaimError) : ''
                        },
                        CheckButton: {
                            text: (el, s)=>el.call('polyglot', s.loading ? 'workspace.demoClaim.loggingIn' : 'workspace.demoClaim.logIn'),
                            disabled: (el, s)=>!!s.loading,
                            // See the Flex.Identifier/Password note above — same testid
                            // collision, same fix.
                            'data-testid': null
                        },
                        // Toggle back to SIGN UP.
                        ModeToggle: {
                            tag: 'button',
                            type: 'button',
                            margin: '- - - auto',
                            padding: '0',
                            background: 'transparent',
                            borderWidth: '0',
                            cursor: 'pointer',
                            fontSize: 'Z2',
                            fontWeight: '400',
                            color: 'caption',
                            ':hover': {
                                color: 'title'
                            },
                            text: '{{ workspace.demoClaim.newHere | polyglot }}',
                            onClick: (e, el, s)=>{
                                e.preventDefault();
                                s.root.update({
                                    _demoClaimMode: 'signup',
                                    _demoClaimError: null
                                });
                            }
                        }
                    }
                }
            },
            // Submit — LoginWindow ships no onSubmit (the /login page adds one); this
            // is the claim/clone equivalent. Branches on the active mode. Reads the
            // (mirrored) field state — never a DOM read — so Chrome's password manager
            // clearing type=password at submit time can't strand the value.
            onSubmit: async (ev, el, s)=>{
                ev.preventDefault();
                const root = s.root;
                const mode = root?._demoClaimMode === 'login' ? 'login' : 'signup';
                if (mode === 'signup') {
                    // SIGN UP → convert the demo account in place, keep the workspace.
                    const email = (s.email || '').trim().toLowerCase();
                    const password = s.password || '';
                    const name = (s.name || '').trim();
                    if (!email) {
                        root.update({
                            _demoClaimError: 'workspace.demoClaim.error.emailRequired'
                        });
                        return;
                    }
                    if (password.length < 8) {
                        root.update({
                            _demoClaimError: 'workspace.demoClaim.error.passwordShort'
                        });
                        return;
                    }
                    s.update({
                        loading: true
                    });
                    root.update({
                        _demoClaimError: null
                    });
                    try {
                        // SDK owns transport — claimDemoAccount POSTs /demo/claim; the server
                        // sets the password + real email + clears isDemo on the user and org.
                        const claimed = await el.sdk.claimDemoAccount({
                            email: email,
                            password: password,
                            name: name
                        });
                        // New email parked on pendingEmail (server B-5): say so before
                        // leaving — the user must click the verification link, and sign-in
                        // with the new email fails until then. The pending panel's
                        // "Go to workspace" runs the handoff.
                        if (claimed && claimed.pendingEmail) {
                            s.update({
                                loading: false
                            });
                            root.update({
                                _demoClaimPendingEmail: claimed.pendingEmail,
                                _demoClaimPendingSent: claimed.emailVerificationSent !== false
                            });
                            return;
                        }
                        // Hand the (still-valid) tokens off to my.symbols.app authed. Leaves
                        // loading true — the page is navigating away.
                        const hopped = await el.call('demoHandoff');
                        if (!hopped) {
                            s.update({
                                loading: false
                            });
                            root.update({
                                _demoClaimError: 'workspace.demoClaim.error.signUpHandoff'
                            });
                        }
                    } catch (err) {
                        console.warn('[DemoClaimBanner] sign-up failed', err);
                        s.update({
                            loading: false
                        });
                        root.update({
                            _demoClaimError: err && err.message || 'workspace.demoClaim.error.signUpFailed'
                        });
                    }
                    return;
                }
                // LOG IN → authenticate the real account, clone the demo workspace into
                // it, then hand off.
                const identifier = (s.identifier || '').trim().toLowerCase();
                const password = s.password || '';
                if (!identifier) {
                    root.update({
                        _demoClaimError: 'workspace.demoClaim.error.emailRequired'
                    });
                    return;
                }
                if (!password) {
                    root.update({
                        _demoClaimError: 'workspace.demoClaim.error.passwordRequired'
                    });
                    return;
                }
                // Capture the CURRENT demo session's active org BEFORE login swaps the
                // session out — that's the workspace we clone into the real account.
                const demoOrgId = $3c70c4fad764a7a3$var$_demoOrgId(root, el.sdk);
                if (!demoOrgId) {
                    root.update({
                        _demoClaimError: 'workspace.demoClaim.error.noDemoWorkspace'
                    });
                    return;
                }
                s.update({
                    loading: true
                });
                root.update({
                    _demoClaimError: null
                });
                try {
                    // Authenticate the real account — the SDK TokenManager swaps the demo
                    // tokens for the real-account tokens on success.
                    await el.sdk.login(identifier, password);
                    // A sign-in on this origin: its refresh token is its own (review D1).
                    el.call('markOwnSession');
                    // Copy the demo workspace into a fresh real org owned by this account.
                    await el.sdk.cloneDemoWorkspace({
                        demoOrgId: demoOrgId
                    });
                    // Hand the real-account tokens off to my.symbols.app authed.
                    const hopped = await el.call('demoHandoff');
                    if (!hopped) {
                        s.update({
                            loading: false
                        });
                        root.update({
                            _demoClaimError: 'workspace.demoClaim.error.logInHandoff'
                        });
                    }
                } catch (err) {
                    console.warn('[DemoClaimBanner] log-in + clone failed', err);
                    s.update({
                        loading: false
                    });
                    const msg = err && (err.message || err.cause?.message) || '';
                    const isCredential = err?.cause?.status === 401 || /password is incorrect/i.test(msg) || /invalid credentials/i.test(msg) || /user not found/i.test(msg);
                    root.update({
                        _demoClaimError: isCredential ? 'workspace.demoClaim.error.badCredentials' : msg || 'workspace.demoClaim.error.logInFailed'
                    });
                }
            }
        }
    }
};

});

parcelRegister("fhEHO", function(module, exports) {

$parcel$export(module.exports, "CallInvitationBanner", () => $b20804d1ab07b061$export$282201a9a858a6ae);
// CallInvitationBanner — CALL-INVITATION (tickets/fable.md, Nika
// 2026-08-13: "add notification/beautiful banner when its call invitation
// on given scdheduled time or calendar meeting"). A beautiful, app-wide,
// actionable banner that appears when a scheduled meeting reaches its
// scheduled moment — not a passive card buried on one page.
//
// DATA: functions/notifications/meetingInviteBanner.js's
// `activeMeetingInvite(root)` — a pure view over the durable
// `meeting_starting` notifications the SERVER writes (see
// server/src/domains/notifications/services/meetingStartingScheduler.js
// for the time trigger + server/.../meetingStartingNotifier.js for the
// event -> room design decision). No client-side fetch/poll needed for the
// "appear" moment: subscribeNotifications.js's existing realtime socket
// push already lands new rows straight into `root.notifs`, which this
// component subscribes to directly.
//
// JOIN: reuses the calendar package's OWN join dispatch verbatim
// (functions/eventMeetJoin.js joinEventCall, via the
// functions/notifications/meetingInviteBanner.js joinMeetingInvite
// wrapper) — find-or-create a meet_rooms row keyed by calendarEventId,
// then hand off activeRoomId/meetView + connectCall. No window.location,
// no el.router hard-navigation needed either: connectCall works from any
// route, and MeetCallWidget (already mounted at the shell root) surfaces
// the live call as a floating PiP the instant the user isn't on /meet.
//
// DISMISS: markNotificationRead on the underlying row (durable, no
// separate pref/cookie) — "stays dismissed" for good, cross-device, with
// exactly one dismissal mechanism to keep in sync.
//
// CHROME: the elevated-card family CreditBlocker.js / AiActionConfirmCard.js
// already established (`background:'document'`, `round:'radiusSheet'`,
// `shadow:'overlay'` — DESIGN_LANGUAGE.md §2.3's two-shadow budget, never a
// bespoke boxShadow string) — "should feel related" per the ticket. Unlike
// CreditBlocker this is NOT a full-viewport blocker (a meeting starting
// should never stop you from working): no scrim, just the floating card
// itself, bottom-center above the AI composer — the GlobalNotification
// toast family's own anchor (bottom C1, centered), one consistent home
// for transient shell messages (2026-09-01 per Nika; it was fixed
// top-right before). Other corners stay claimed as they were
// (bottom-left: CreditBanner/DemoClaimBanner/PersonaPill; bottom-right:
// MeetCallWidget's own PiP dock).
//
// ZERO-SHIFT (DESIGN_LANGUAGE.md §8.4): position:fixed overlay, never
// inserted in-flow — the shell-root wrapper is `display:'contents'` so it
// never becomes a static grid child (the DemoClaimBanner/CreditBlocker
// lesson: a real box here pushes routed content into a collapsed implicit
// grid row). `hide:` (not `if:`) keeps the Card mounted in the DOM at all
// times so it can be found/announced the instant it should appear, rather
// than being freshly created.
//
// TIME-TRIGGERING ON THE CLIENT: appearing needs no client timer (the
// server sweep + realtime push does that). Self-expiring while ALREADY
// showing (an event's endAt quietly passing with no other app activity in
// between) does — `_meetingInviteTick`, nudged every 30s from the shell's
// onCreate (app.js), visibility-gated so a backgrounded tab does no
// needless work (browsers throttle hidden-tab timers heavily regardless;
// this is a deliberate skip, not a hope). See app.js's own comment beside
// `el._meetingInviteTickTimer`.
const $b20804d1ab07b061$export$282201a9a858a6ae = {
    tag: 'div',
    display: 'contents',
    subscribeTo: [
        'notifs',
        'rooms',
        'activeRoomId',
        'signedIn',
        'workspace',
        '_meetingInviteTick'
    ],
    Card: {
        hide: (el, s)=>!el.call('activeMeetingInvite', s.root),
        // Bottom-center, ABOVE the AI composer — the GlobalNotification toast
        // family's exact anchor (bottom C1, centered), so transient shell
        // messages share ONE consistent home (Nika 2026-09-01 "make
        // CallInvitationBanner above ai textarea so we make it consistent").
        // Was fixed top-right; that corner rationale is retired with it.
        position: 'fixed',
        bottom: 'C1',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '1600',
        background: 'document',
        round: 'radiusSheet',
        shadow: 'overlay',
        flow: 'y',
        gap: 'Z1',
        padding: 'B',
        width: 'H1',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        boxSizing: 'border-box',
        role: 'status',
        ariaLive: 'polite',
        'aria-label': (el)=>el.call('polyglot', 'workspace.callInvite.aria'),
        '@mobileL': {
            left: 'Z',
            right: 'Z',
            transform: 'none',
            width: 'auto',
            maxWidth: 'none'
        },
        Header: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z1',
            Lead: {
                flow: 'x',
                align: 'center',
                gap: 'Y1',
                minWidth: '0',
                Icon: {
                    name: 'video',
                    boxSize: 'A',
                    color: 'caption'
                },
                Eyebrow: {
                    tag: 'span',
                    fontSize: 'Y',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '.07em',
                    color: 'caption',
                    text: '{{ workspace.callInvite.eyebrow | polyglot }}'
                }
            },
            // THE house close X (brand CloseButton — F2, one X for every panel);
            // same control as CreditBanner.Dismiss.
            Dismiss: {
                extends: 'CloseButton',
                title: (el)=>el.call('polyglot', 'workspace.callInvite.dismiss'),
                'aria-label': (el)=>el.call('polyglot', 'workspace.callInvite.dismissAria'),
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const notif = el.call('activeMeetingInvite', s.root);
                    if (notif) el.call('markNotificationRead', notif.id);
                }
            }
        },
        Title: {
            tag: 'p',
            margin: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            lineHeight: '1.3',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                const notif = el.call('activeMeetingInvite', s.root);
                const meta = notif && notif.metadata;
                return meta && meta.eventTitle || notif && notif.title || el.call('polyglot', 'workspace.callInvite.untitled');
            }
        },
        // Coarse, honest lead-time label — re-evaluated on every
        // `_meetingInviteTick` (never a live per-second countdown, which would
        // be a fake-precision affordance nothing here can actually promise).
        // The Card has a fixed token width (not shrink-to-fit), so this text
        // changing length over time never shifts any sibling or the card's own
        // box — no separate minWidth floor needed for DESIGN_LANGUAGE §8.4.
        Meta: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>{
                const notif = el.call('activeMeetingInvite', s.root);
                const startAt = notif && notif.metadata && notif.metadata.startAt;
                if (!startAt) return el.call('polyglot', 'workspace.callInvite.startingNow');
                const diffMs = new Date(startAt).getTime() - Date.now();
                if (!Number.isFinite(diffMs) || diffMs <= 60000) return el.call('polyglot', 'workspace.callInvite.startingNow');
                const mins = Math.round(diffMs / 60000);
                return el.call('polyglot', 'workspace.callInvite.startsIn').replace('{count}', mins);
            }
        },
        Actions: {
            flow: 'x',
            gap: 'Z1',
            marginTop: 'V',
            // The one place a strong affordance is justified (DESIGN_LANGUAGE.md
            // §4.4: accent hue is for links/badges, NEVER a primary button fill —
            // "ink does"). Same house primary as CreditBlocker.Cta.Button: a
            // solid ink capsule (`title` / `title-reversed`), not a hue fill.
            // Hover uses `filter:brightness()` per §4.3's own prescription for
            // filled/ink surfaces (a `background:'hover'` wash doesn't read on
            // top of an already-opaque fill) rather than dimming with `opacity`
            // (§8.1/§8.5: "never dim with opacity — the composite silently
            // halves the contrast ratio").
            Join: {
                tag: 'button',
                type: 'button',
                flex: '1',
                minHeight: 'controlH',
                padding: '0 B',
                fontWeight: '700',
                fontSize: 'Z2',
                round: 'radiusPill',
                background: 'title',
                color: 'title-reversed',
                border: 'none',
                cursor: 'pointer',
                transition: '150ms defaultBezier filter',
                ':hover': {
                    filter: 'brightness(1.1)'
                },
                text: '{{ workspace.callInvite.join | polyglot }}',
                onClick: async (e, el, s)=>{
                    e.stopPropagation();
                    const notif = el.call('activeMeetingInvite', s.root);
                    if (notif) await el.call('joinMeetingInvite', notif);
                }
            }
        }
    }
};

});

parcelRegister("3kf69", function(module, exports) {

$parcel$export(module.exports, "IncomingCallBanner", () => $26bef389f519a39c$export$6d93215539817f9e);
// THE PERSON CALLED RINGS (functions/incomingCall.js; Nika 2026-10-23: "add
// calling mode into fly so you can call to anyone in workspace"). The meeting
// invite's own card (components/CallInvitationBanner.js — one card for both
// ways a call reaches someone): "Incoming call", the caller's name, Join call
// and Decline. Its scan runs on its own updates — rooms landing through meet's
// realtime and the invite banner's 30 s tick, which lets a ring expire.
const $26bef389f519a39c$export$6d93215539817f9e = {
    extends: 'CallInvitationBanner',
    subscribeTo: [
        'rooms',
        'activeRoomId',
        '_callRing',
        'people',
        '_meetingInviteTick'
    ],
    onRender: (el, s)=>el.call('incomingCallScan', el, s),
    onUpdate: (el, s)=>el.call('incomingCallScan', el, s),
    Card: {
        hide: (el, s)=>!el.call('incomingCallOf', s.root),
        'aria-label': (el)=>el.call('polyglot', 'workspace.callPanel.incoming'),
        Header: {
            Lead: {
                Icon: {
                    name: 'phone'
                },
                Eyebrow: {
                    text: '{{ workspace.callPanel.incoming | polyglot }}'
                }
            },
            Dismiss: {
                title: (el)=>el.call('polyglot', 'workspace.callPanel.action.decline'),
                'aria-label': (el)=>el.call('polyglot', 'workspace.callPanel.action.decline'),
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('incomingCallDecline');
                }
            }
        },
        Title: {
            text: (el, s)=>(el.call('incomingCallOf', s.root) || {}).callerName || ''
        },
        Meta: {
            text: (el)=>el.call('polyglot', 'workspace.callPanel.calling')
        },
        Actions: {
            Join: {
                text: '{{ workspace.callInvite.join | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('incomingCallJoin');
                }
            }
        }
    }
};

});

parcelRegister("eDffN", function(module, exports) {

$parcel$export(module.exports, "WorkspaceCallPanel", () => $aa708a48cd98d1c3$export$6ed3b92cfa610f94);
// WorkspaceCallPanel — THE shell call panel (comms-phone v2, "calls inside the
// workspace"; Nika 2026-10-01). Mounted ONCE at the shell root (app.js), so a
// call survives every route change, like MeetCallWidget's PiP dock.
//
// DATA: one root key, `_callPanel` (null = idle = hidden), written ONLY by
// functions/calls/workspaceCall.js from the SDK voice client's events (the
// per-member call stream + the call handle). `_callPanelTick` re-renders the
// in-call timer once a second while a call is answered.
//
// STATES (`_callPanel.phase`): outgoing (calling / ringing) · incoming
// (accept / decline) · active (timer, mute, hold, keypad, hang up) · ended
// (the duration, or a missed call with the bell glyph). Hold and keypad show
// only when the call handle offers them (`canHold` / `canKeypad`).
//
// CHROME: the toast island's own look (GlobalNotification: the `dialog`
// surface on the `float` elevation), docked bottom-right on the composer
// stack's line (`--stack-line`: the composer's top and its docked rows + the
// gap) so it never covers the composer or the bottom-centre toast stack.
// Above the credit gate's scrim (10300) so a ringing call can always be
// answered; below the toast stack. ZERO-SHIFT: position fixed, the
// shell-root wrapper is `display: contents` (the CallInvitationBanner rule).
//
// A11Y: role=dialog with a name; the phase line is a live region (assertive
// while ringing). On a ring, focus moves into the card (scope.manageFocus,
// the CreditBlocker technique) and returns when the panel closes. Escape asks
// first, then hangs up or declines (requestEndWorkspaceCall); on an ended call
// it dismisses. Escape acts only while focus is inside the card.
const $aa708a48cd98d1c3$export$6ed3b92cfa610f94 = {
    tag: 'div',
    display: 'contents',
    subscribeTo: [
        '_callPanel',
        '_callPanelTick'
    ],
    scope: {
        manageFocus (el, ringKey) {
            if (typeof document === 'undefined') return;
            if (ringKey === el._callFocusKey) return;
            el._callFocusKey = ringKey;
            // design-d2: never take focus from a field the member is typing in;
            // the ring is announced (assertive phase line) and Tab reaches the card.
            if (ringKey && !el.call('workspaceCallRingMayTakeFocus', document.activeElement)) return;
            if (ringKey) {
                el._returnFocusTo = document.activeElement;
                // A bounded poll of tasks, not one frame (the focusContextMenu shape):
                // the card is still `display: none` until its `hide` effect paints,
                // and a background tab never runs requestAnimationFrame. Measured live:
                // one timeout lost the first ring after a page load.
                let tries = 0;
                const tick = ()=>{
                    if (el._callFocusKey !== ringKey || !el.node) return;
                    if (typeof el.node.focus === 'function') el.node.focus();
                    if (document.activeElement !== el.node && ++tries < 12) setTimeout(tick, 50);
                };
                setTimeout(tick, 0);
            } else if (el._returnFocusTo) {
                if (el._returnFocusTo.isConnected && el._returnFocusTo.focus) el._returnFocusTo.focus();
                el._returnFocusTo = null;
            }
        },
        // `--call-clear` on the root while the card shows: its height + the gap
        // to the toast; removed while hidden (the toast's fallback is 0%).
        // The shell's toast stack docks on --stack-line and holds --call-clear
        // under its toasts (design-d2 35bf386a1; app.js GlobalNotification), so a
        // toast never covers Accept / Decline. offsetHeight, not the rect: the
        // entry animation translates the card (measured live).
        // Read after the card paints (a task: the hide effect lands first).
        syncClear (el, shown) {
            if (typeof document === 'undefined') return;
            setTimeout(()=>{
                const node = el.node;
                const value = el.call('workspaceCallClear', shown && node && node.offsetHeight ? {
                    height: node.offsetHeight
                } : null);
                const style = document.documentElement.style;
                if (value) style.setProperty('--call-clear', value);
                else style.removeProperty('--call-clear');
            }, 0);
        }
    },
    Card: {
        hide: (el, s)=>{
            const panel = (s.root || s)._callPanel;
            el.scope.manageFocus(el, panel && panel.phase === 'incoming' ? panel.callId || 'ring' : null);
            el.scope.syncClear(el, !!panel);
            return !panel;
        },
        onKeydown: (e, el)=>{
            if (e.key !== 'Escape') return;
            e.stopPropagation();
            el.call('requestEndWorkspaceCall');
        },
        position: 'fixed',
        bottom: 'var(--stack-line, var(--spacing-C1))',
        right: 'A',
        zIndex: '10400',
        theme: 'dialog',
        shadow: 'float',
        round: 'radiusSheet',
        flow: 'y',
        gap: 'Z1',
        padding: 'A',
        width: 'G1',
        maxWidth: 'calc(100dvw - var(--spacing-B))',
        boxSizing: 'border-box',
        animationName: 'fadeInUpShort',
        animationDuration: 'C',
        animationTimingFunction: 'springBezier',
        animationFillMode: 'both',
        role: 'dialog',
        tabindex: '-1',
        outline: 'none',
        'aria-label': (el)=>el.call('polyglot', 'workspace.callPanel.aria'),
        // The phase line and the caller (design-d2). One panel per shell, so
        // the two ids are unique.
        ariaDescribedby: 'workspaceCallPanelPhase workspaceCallPanelTitle',
        '@mobileL': {
            left: 'Z',
            right: 'Z',
            width: 'auto',
            maxWidth: 'none'
        },
        Header: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z1',
            Lead: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                minWidth: '0',
                Glyph: {
                    align: 'center center',
                    boxSize: 'controlH',
                    minWidth: 'controlH',
                    // A tint of its own ink, not the retired `layer` theme (design-d2):
                    // the ground follows the ink per scheme (Rule 67).
                    round: 'radiusPill',
                    background: 'color-mix(in srgb, currentColor 14%, var(--color-tintBase))',
                    color: (el, s)=>{
                        const panel = (s.root || s)._callPanel;
                        return el.call('workspaceCallMissed', panel) ? 'dangerInk' : 'title';
                    },
                    Icon: {
                        name: (el, s)=>el.call('workspaceCallMissed', (s.root || s)._callPanel) ? 'bell' : 'phone',
                        boxSize: 'iconSm'
                    }
                },
                Text: {
                    flow: 'y',
                    gap: 'W',
                    minWidth: '0',
                    // The house eyebrow (design-d2): AppMicroLabel.
                    Eyebrow: {
                        extends: 'AppMicroLabel',
                        id: 'workspaceCallPanelPhase',
                        role: 'status',
                        ariaLive: (el, s)=>{
                            const panel = (s.root || s)._callPanel;
                            return panel && panel.phase === 'incoming' ? 'assertive' : 'polite';
                        },
                        text: (el, s)=>el.call('workspaceCallEyebrow', (s.root || s)._callPanel)
                    },
                    Title: {
                        tag: 'p',
                        id: 'workspaceCallPanelTitle',
                        margin: '0',
                        fontSize: 'A',
                        fontWeight: '700',
                        color: 'title',
                        lineHeight: '1.3',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        text: (el, s)=>el.call('workspaceCallTitle', (s.root || s)._callPanel)
                    },
                    Meta: {
                        tag: 'span',
                        fontSize: 'Z2',
                        color: 'caption',
                        fontVariantNumeric: 'tabular-nums',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        hide: (el, s)=>!el.call('workspaceCallMeta', (s.root || s)._callPanel),
                        text: (el, s)=>el.call('workspaceCallMeta', (s.root || s)._callPanel)
                    }
                }
            },
            // THE house close X — only on an ended call (a live call ends with the
            // hang-up control, never with an X).
            CloseButton: {
                hide: (el, s)=>{
                    const panel = (s.root || s)._callPanel;
                    return !panel || panel.phase !== 'ended';
                },
                title: (el)=>el.call('polyglot', 'workspace.callPanel.action.dismiss'),
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('dismissWorkspaceCall');
                }
            }
        },
        // Question above its two answers: Georgian labels do not fit beside the
        // question at the dock width (measured live), so the answers get their own
        // row and wrap rather than overflow.
        Confirm: {
            flow: 'y',
            gap: 'Z',
            hide: (el, s)=>{
                const panel = (s.root || s)._callPanel;
                return !panel || !panel.confirmEnd;
            },
            Question: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'title',
                text: (el, s)=>{
                    const panel = (s.root || s)._callPanel;
                    return el.call('polyglot', panel && panel.phase === 'incoming' ? 'workspace.callPanel.confirm.decline' : 'workspace.callPanel.confirm.end');
                }
            },
            Choices: {
                flow: 'x',
                align: 'center flex-end',
                flexWrap: 'wrap',
                gap: 'Y',
                // The house tonal secondary (design-d2), not the retired `layer`.
                Keep: {
                    extends: 'CancelButton',
                    type: 'button',
                    text: '{{ workspace.callPanel.confirm.keep | polyglot }}',
                    onClick: (e, el)=>el.call('cancelEndWorkspaceCall')
                },
                // Two capsules, not one with a reactive label: a Button's `text` is
                // read once (measured live), and the template form keeps each label
                // static and reactive to the language.
                End: {
                    extends: 'WorkspaceCallAction',
                    theme: 'error',
                    hide: (el, s)=>((s.root || s)._callPanel || {}).phase === 'incoming',
                    text: '{{ workspace.callPanel.confirm.yes | polyglot }}',
                    onClick: (e, el)=>el.call('requestEndWorkspaceCall')
                },
                DeclineCall: {
                    extends: 'WorkspaceCallAction',
                    theme: 'error',
                    hide: (el, s)=>((s.root || s)._callPanel || {}).phase !== 'incoming',
                    text: '{{ workspace.callPanel.action.decline | polyglot }}',
                    onClick: (e, el)=>el.call('requestEndWorkspaceCall')
                }
            }
        },
        Keypad: {
            hide: (el, s)=>{
                const panel = (s.root || s)._callPanel;
                return !panel || !panel.keypadOpen;
            },
            flow: 'y',
            gap: 'Y',
            role: 'group',
            'aria-label': (el)=>el.call('polyglot', 'workspace.callPanel.keypad'),
            Digits: {
                tag: 'span',
                fontSize: 'A',
                color: 'title',
                textAlign: 'center',
                minHeight: 'A',
                fontVariantNumeric: 'tabular-nums',
                letterSpacing: '.1em',
                text: (el, s)=>((s.root || s)._callPanel || {}).digits || ''
            },
            Keys: {
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: 'Y',
                justifyItems: 'center',
                childExtends: 'IconButton',
                childrenAs: 'state',
                children: ()=>[
                        {
                            digit: '1'
                        },
                        {
                            digit: '2'
                        },
                        {
                            digit: '3'
                        },
                        {
                            digit: '4'
                        },
                        {
                            digit: '5'
                        },
                        {
                            digit: '6'
                        },
                        {
                            digit: '7'
                        },
                        {
                            digit: '8'
                        },
                        {
                            digit: '9'
                        },
                        {
                            digit: '*'
                        },
                        {
                            digit: '0'
                        },
                        {
                            digit: '#'
                        }
                    ],
                childProps: {
                    large: true,
                    round: '50%',
                    fontSize: 'A',
                    fontVariantNumeric: 'tabular-nums',
                    text: (el, s)=>s.digit,
                    onClick: (e, el, s)=>el.call('pressWorkspaceCallDigit', s.digit)
                }
            }
        },
        Problem: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'dangerInk',
            role: 'alert',
            hide: (el, s)=>!((s.root || s)._callPanel || {}).errorKey,
            text: (el, s)=>{
                const panel = (s.root || s)._callPanel;
                return panel && panel.errorKey ? el.call('polyglot', panel.errorKey) : '';
            }
        },
        Controls: {
            flow: 'x',
            align: 'center flex-end',
            gap: 'Z',
            hide: (el, s)=>{
                const panel = (s.root || s)._callPanel;
                return !panel || panel.phase === 'ended' || panel.confirmEnd;
            },
            Mute: {
                extends: 'IconButton',
                large: true,
                round: '50%',
                hide: (el, s)=>{
                    const panel = (s.root || s)._callPanel || {};
                    return panel.phase !== 'active' || !panel.canMute;
                },
                icon: (el, s)=>((s.root || s)._callPanel || {}).muted ? 'micOff' : 'mic',
                'aria-pressed': (el, s)=>String(!!((s.root || s)._callPanel || {}).muted),
                // A FIXED name; aria-pressed says the state (design-d2).
                'aria-label': (el)=>el.call('polyglot', 'workspace.callPanel.action.mute'),
                title: (el)=>el.call('polyglot', 'workspace.callPanel.action.mute'),
                onClick: (e, el)=>el.call('toggleWorkspaceCallMute')
            },
            Hold: {
                extends: 'IconButton',
                large: true,
                round: '50%',
                icon: 'pause',
                hide: (el, s)=>{
                    const panel = (s.root || s)._callPanel || {};
                    return panel.phase !== 'active' || !panel.canHold;
                },
                'aria-pressed': (el, s)=>String(!!((s.root || s)._callPanel || {}).held),
                'aria-label': (el)=>el.call('polyglot', 'workspace.callPanel.action.hold'),
                title: (el)=>el.call('polyglot', 'workspace.callPanel.action.hold'),
                onClick: (e, el)=>el.call('toggleWorkspaceCallHold')
            },
            KeypadToggle: {
                extends: 'IconButton',
                large: true,
                round: '50%',
                icon: 'grid',
                hide: (el, s)=>{
                    const panel = (s.root || s)._callPanel || {};
                    return panel.phase !== 'active' || !panel.canKeypad;
                },
                'aria-expanded': (el, s)=>String(!!((s.root || s)._callPanel || {}).keypadOpen),
                title: (el)=>el.call('polyglot', 'workspace.callPanel.action.keypad'),
                onClick: (e, el)=>el.call('toggleWorkspaceCallKeypad')
            },
            Decline: {
                extends: 'WorkspaceCallAction',
                theme: 'error',
                icon: 'phone',
                hide: (el, s)=>((s.root || s)._callPanel || {}).phase !== 'incoming',
                Icon: {
                    transform: 'rotate(135deg)'
                },
                Label: {
                    tag: 'span',
                    text: '{{ workspace.callPanel.action.decline | polyglot }}'
                },
                onClick: (e, el)=>el.call('declineWorkspaceCall')
            },
            Accept: {
                extends: 'WorkspaceCallAction',
                theme: 'success',
                icon: 'phone',
                hide: (el, s)=>((s.root || s)._callPanel || {}).phase !== 'incoming',
                disabled: (el, s)=>!!((s.root || s)._callPanel || {}).busy,
                Label: {
                    tag: 'span',
                    text: '{{ workspace.callPanel.action.accept | polyglot }}'
                },
                onClick: (e, el)=>el.call('acceptWorkspaceCall')
            },
            HangUp: {
                extends: 'IconButton',
                large: true,
                round: '50%',
                theme: 'error',
                icon: 'phone',
                hide: (el, s)=>{
                    const phase = ((s.root || s)._callPanel || {}).phase;
                    return phase !== 'active' && phase !== 'outgoing';
                },
                disabled: (el, s)=>!!((s.root || s)._callPanel || {}).busy,
                title: (el)=>el.call('polyglot', 'workspace.callPanel.action.hangUp'),
                Icon: {
                    transform: 'rotate(135deg)'
                },
                ':hover': {
                    filter: 'brightness(1.08)'
                },
                ':active': {
                    transform: 'scale(0.94)'
                },
                onClick: (e, el)=>el.call('hangUpWorkspaceCall')
            }
        }
    }
};

});

parcelRegister("a3jen", function(module, exports) {

$parcel$export(module.exports, "WorkspaceCallAction", () => $75191a0b2d5d8335$export$dd50a269ec0937d6);
// WorkspaceCallAction — the call panel's labelled capsule (Accept, Decline,
// Keep, End call). A filled status plate (`theme: 'success' | 'error' |
// 'layer'` at the call site) on the house Button capsule; its interaction
// states live HERE, once (Rule 65): a filled plate takes a brightness lift on
// hover (DESIGN_LANGUAGE §4.3 — a `hover` wash does not read on an opaque
// fill, and opacity would halve the contrast), sinks on press, and dims only
// while disabled (an action in flight).
//
// A glyph-led capsule puts its label in a `Label` child AFTER the icon: the
// framework emits a `text` prop's node BEFORE the Icon child (measured live:
// "Accept" then the glyph), and the house order is glyph first.
const $75191a0b2d5d8335$export$dd50a269ec0937d6 = {
    extends: 'Button',
    cursor: 'pointer',
    gap: 'Y',
    // A LABELLED capsule: every call site gives it a label (a `text`, or a
    // `Label` child after the glyph). Declaring the label's line behaviour here
    // also tells the icon-button census (shared iconButtonSquare.test.js) that
    // this base is a capsule, not an icon-only square.
    whiteSpace: 'nowrap',
    transitionProperty: 'filter, transform',
    transition: 'A defaultBezier',
    ':hover': {
        filter: 'brightness(1.08)'
    },
    ':active': {
        transform: 'scale(0.96)'
    },
    ':disabled': {
        cursor: 'default',
        filter: 'saturate(0.6)'
    },
    Icon: {
        boxSize: 'iconSm'
    }
};

});

parcelRegister("5fEMD", function(module, exports) {

$parcel$export(module.exports, "AppLightbox", () => $3d2dfd34918eaa27$export$7013195ddf256f4e);
// AppLightbox — image / video preview overlay. Migrated 2026-06-01
// from a per-state-field shell-root mount to @symbo.ls/windows. Body-
// only now: backdrop, click-to-dismiss, ESC-to-close are owned by
// ModalLayer. Opened via `el.call('openLightbox', { url, mime, name })`
// — the helper writes the descriptor to `root.lightbox` (preserved as
// data carrier so this component's reactive reads stay unchanged) and
// pushes a custom-template layer onto ModalRoot.
//
// The body fills the layer (90vw / 85vh constraint on the media element)
// and includes a centred filename caption. The CloseBtn at top-right
// stops propagation so it doesn't trigger backdrop dismiss.
const $3d2dfd34918eaa27$export$7013195ddf256f4e = {
    flow: 'y',
    align: 'center center',
    // WS-MODAL-X-HORIZONTAL-OVERFLOW-1: fill the custom-template slot instead
    // of forcing 90vw inside it. The window itself is sized 90vw by the
    // `openLightbox` layer descriptor, so a 90vw body inside it overflowed the
    // window by its padding and pushed the absolute CloseBtn past the right
    // viewport edge (ModalWindow is `overflow: 'visible'`, so nothing clipped
    // or scrolled it back).
    width: '100%',
    maxWidth: '100%',
    height: '85vh',
    position: 'relative',
    // THE house close X (brand CloseButton — F2, one X for every panel);
    // geometry + glyph inherited, only the scrim ink below is local.
    CloseBtn: {
        extends: 'CloseButton',
        position: 'absolute',
        top: 'A',
        right: 'A',
        // Deliberately FIXED: floats over arbitrary preview media (photo/video)
        // on ModalLayer's own fixed 'black.45' scrim (@symbo.ls/windows —
        // ModalLayer.js) — same "scrim over arbitrary imagery" contract as a
        // lightbox chrome everywhere else; must not flip with site theme.
        background: 'white.15',
        color: 'white',
        ':hover': {
            background: 'white.3',
            color: 'white'
        },
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('closeLightbox');
        }
    },
    Image: {
        tag: 'img',
        hide: (el, s)=>!(s.root.lightbox?.mime || '').startsWith('image/'),
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        round: 'radiusControl',
        cursor: 'default',
        // No `|| ''` — the lightbox is mounted on every page and closed most of
        // the time, and an empty `src` is a REAL request for the document URL
        // (2 failed requests per mount, served catalog 2026-09-20). smbls
        // removes the attribute when the factory answers undefined; `hide:`
        // above is CSS and never stopped the request. See
        // __tests__/lightboxEmptyMediaSrc.test.js.
        src: (el, s)=>s.root.lightbox?.url || undefined,
        alt: (el, s)=>s.root.lightbox?.name || 'preview',
        onClick: (e)=>e.stopPropagation()
    },
    Video: {
        tag: 'video',
        hide: (el, s)=>!(s.root.lightbox?.mime || '').startsWith('video/'),
        maxWidth: '100%',
        maxHeight: '100%',
        round: 'radiusControl',
        cursor: 'default',
        // Same as the Image slot above — an empty `src` on a media element is
        // the same document-URL request, and it ends in a decode error on a
        // resource that is an HTML page.
        src: (el, s)=>s.root.lightbox?.url || undefined,
        controls: 'true',
        autoplay: 'true',
        onClick: (e)=>e.stopPropagation()
    },
    FileName: {
        position: 'absolute',
        bottom: '-A',
        left: '50%',
        transform: 'translateX(-50%)',
        // Deliberately FIXED — same lightbox-chrome-over-arbitrary-media
        // contract as CloseBtn above.
        color: 'white.7',
        fontSize: 'Z2',
        textAlign: 'center',
        pointerEvents: 'none',
        text: (el, s)=>s.root.lightbox?.name || ''
    }
};

});

parcelRegister("5bBlL", function(module, exports) {

$parcel$export(module.exports, "SidebarItemMore", () => $3c6af3c28cfb79c9$export$1f5f275d1c461668);
$parcel$export(module.exports, "SidebarItemMenuItem", () => $3c6af3c28cfb79c9$export$5c545371b4b68de9);
// Three-dot sidebar menu button. Opens a shared dropdown via root state.
// The dropdown itself lives on the page level (ChatSidebarDropdown) to
// avoid parent opacity/overflow clipping issues.
const $3c6af3c28cfb79c9$export$1f5f275d1c461668 = {
    tag: 'button',
    type: 'button',
    'aria-label': (el)=>el.call('polyglot', 'workspace.sidebar.moreOptions'),
    text: "\xb7\xb7\xb7",
    fontSize: 'A',
    fontWeight: '700',
    letterSpacing: '.1em',
    padding: '0 V',
    background: 'transparent',
    borderWidth: '0',
    color: 'caption',
    cursor: 'pointer',
    transition: 'opacity 120ms ease',
    flexShrink: '0',
    ':hover': {
        color: 'title'
    },
    onCreate: (el)=>{
        if (!el.node) return;
        el.node.style.opacity = '0';
        const row = el.node.closest('[data-sidebar-row]') || el.node.closest('[data-cid]');
        if (!row) return;
        el._row = row;
        el._onEnter = ()=>{
            if (el.node) el.node.style.opacity = '1';
        };
        el._onLeave = ()=>{
            if (!el.node) return;
            // Don't hide if dropdown is open for this row
            const root = el.state?.root;
            if (root?.contextDropdown?.open) return;
            el.node.style.opacity = '0';
        };
        row.addEventListener('mouseenter', el._onEnter);
        row.addEventListener('mouseleave', el._onLeave);
    },
    onRemove: (el)=>{
        if (el._row) {
            el._row.removeEventListener('mouseenter', el._onEnter);
            el._row.removeEventListener('mouseleave', el._onLeave);
        }
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        const root = s?.root;
        if (!root) return;
        // Get the channel id from the row
        const row = el.node.closest('[data-cid]');
        const cid = row?.getAttribute('data-cid');
        // Teammate rows (ChatDMPersonRow) have no channel yet — only
        // `data-person-email` — so fall back to the person items/dispatch
        // instead of bailing out (the button rendered + hovered on these rows
        // but was inert because `cid` was always null).
        if (!cid) {
            const personRow = el.node.closest('[data-person-email]');
            const email = personRow?.getAttribute('data-person-email');
            if (!email) return;
            const rect = el.node.getBoundingClientRect();
            const dd = root.contextDropdown;
            if (dd?.open && dd?.personEmail === email) root.update({
                contextDropdown: null
            });
            else {
                const items = el.call('personContextItems', root, email);
                root.update({
                    contextDropdown: {
                        open: true,
                        x: rect.right,
                        y: rect.bottom + 2,
                        personEmail: email,
                        items: items,
                        actionFn: 'personContextDispatch',
                        ...el.dropdownZ ? {
                            z: el.dropdownZ
                        } : {}
                    }
                });
            }
            return;
        }
        const rect = el.node.getBoundingClientRect();
        // Toggle — close if already open for this row, open otherwise. Opens the
        // global shared ContextDropdown (same as the right-click menu) anchored
        // under the button, with the per-kind items from chatContextItems.
        const dd = root.contextDropdown;
        if (dd?.open && dd?.channelId === cid) root.update({
            contextDropdown: null
        });
        else {
            const items = el.call('chatContextItems', root, cid);
            root.update({
                contextDropdown: {
                    open: true,
                    x: rect.right,
                    y: rect.bottom + 2,
                    channelId: cid,
                    items: items,
                    actionFn: 'chatContextDispatch',
                    ...el.dropdownZ ? {
                        z: el.dropdownZ
                    } : {}
                }
            });
        }
    },
    // Items render into the global shared ContextDropdown.
    Dropdown: {
        display: 'none'
    }
};
const $3c6af3c28cfb79c9$export$5c545371b4b68de9 = {
    tag: 'button',
    type: 'button',
    padding: 'Z A',
    round: 'V',
    background: 'transparent',
    borderWidth: '0',
    cursor: 'pointer',
    fontSize: 'Z2',
    fontWeight: '500',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    color: (el, s)=>s.color || 'title',
    ':hover': {
        background: 'hover'
    },
    text: (el, s)=>s.label || ''
};

});

parcelRegister("g9M9q", function(module, exports) {

$parcel$export(module.exports, "SidebarRow", () => $bc32d65f8428b9fe$export$dd577a7f84c0384e);
const $bc32d65f8428b9fe$export$dd577a7f84c0384e = {
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    minHeight: 'controlHCompact',
    padding: 'Z Z1',
    round: 'radiusControl',
    cursor: (el)=>el.onClick ? 'pointer' : 'default',
    background: 'transparent',
    color: 'inactive',
    // Keyboard-operable when a consumer makes the row interactive (attaches
    // onClick). role + tabindex make it focusable so the global :focus-visible ring
    // engages; onKeydown mirrors the click on Enter/Space. Rows with no onClick
    // (display-only) stay plain (role/tabindex resolve to null).
    'data-sidebar-row': 'true',
    role: (el)=>el.onClick ? 'button' : null,
    tabindex: (el)=>el.onClick ? '0' : null,
    onKeydown: (e, el, s, ctx)=>{
        // A nested More button owns its keyboard activation. Letting its key
        // bubble into the row also opened the section behind the menu.
        if (e.target !== el.node || e.defaultPrevented) return;
        if ((e.key === 'Enter' || e.key === ' ') && el.onClick) {
            e.preventDefault();
            el.onClick(e, el, s, ctx);
        }
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    ':active': {
        background: 'selected',
        color: 'title'
    },
    ':focus-visible': {
        background: 'selected',
        color: 'title'
    },
    '@coarse': {
        minHeight: 'controlH'
    },
    Icon: {
        icon: (el)=>el.parent?.icon || 'state',
        'aria-hidden': true,
        boxSize: 'A1 A1'
    },
    Label: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '500',
        flex: '1',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el)=>el.parent?.label || ''
    },
    MoreBtn: {
        extends: 'SidebarItemMore'
    }
};

});

parcelRegister("lnEiO", function(module, exports) {

$parcel$export(module.exports, "PersonDetailModal", () => $f90b022a9a65dc51$export$39fbae7e980d8fab);
// PersonDetailModal — shared "who is this person, what can they do, why" surface.
//
// §unified-perms PR #8 (2026-05-23). Opens by writing the person object to
// `root._personDetail`. Reads canonical state already loaded by the shell:
//   • root.teams           — full list with category + permissions[]
//   • root.teamsByEmail    — { [email]: [{ id, slug, role, ... }] }
//   • root.orgMembersByOrgId[orgId] — { [email]: { role } | true } (legacy = true)
//   • root.jwtClaims       — for action gating via hasPerm
//
// The same modal opens from /admin row click (this PR) and later from
// /team-and-agents node click (PR #9). Effective-permission math mirrors
// `server/src/core/utils/effectivePermissions.js unionEffectivePermissions`:
// owner short-circuits; otherwise org-role baseline ∪ per-team permissions,
// with passive memberships intersected against CATEGORY_PERMISSION_TEMPLATES.passive.
// Only `effectiveCategory` remains in scope — used by the IdentityRow's
// CategoryBadge to label the person's overall team category. The other
// permission helpers (PERMISSION_KEYS, PERMISSIONS_BY_GROUP, permLabel,
// hasPerm, etc.) were removed when the permission UI was stripped
// 2026-06-03.

var $eb4QA = parcelRequire("eb4QA");
const $f90b022a9a65dc51$var$_detailPerson = (root)=>root?._personDetail || null;
const $f90b022a9a65dc51$var$_activeOrgId = (root)=>root?.jwtClaims?.workspace_org_id || null;
// Org role for this person in the active org. Searches three sources
// in priority order:
//   1. `root.roles.byUser[userId]` — the authoritative roles map filled
//      in by loadPrivateData._loadRoles via sdk.listOrgMembers. This
//      is the only source that distinguishes owner / admin / member.
//   2. `orgMembersByOrgId[orgId][email]` as an object `{ role }` —
//      future-proof shape; not currently written but handled if/when it
//      lands.
//   3. Membership existence in `orgMembersByOrgId` — falls through to
//      'member' (the legacy boolean-`true` shape is just a presence
//      marker, never carried a role).
//
// Before this rewrite the function only handled shape (2) and returned
// 'member' for the boolean shape — meaning any OTHER person who was
// actually the org owner appeared as a plain member in the modal's
// Effective Permissions panel.
const $f90b022a9a65dc51$var$_orgRoleFor = (root, email)=>{
    if (!email) return 'member';
    const norm = String(email).toLowerCase();
    const person = (root?.people || []).find((p)=>String(p?.email || '').toLowerCase() === norm);
    if (person?.userId && root?.roles?.byUser?.[person.userId]) return String(root.roles.byUser[person.userId]).toLowerCase();
    const orgId = $f90b022a9a65dc51$var$_activeOrgId(root);
    const entry = orgId && root?.orgMembersByOrgId?.[orgId]?.[norm];
    if (entry && typeof entry === 'object' && entry.role) return String(entry.role).toLowerCase();
    return 'member';
};
// Resolve the canonical team rows for a person — joins `teamsByEmail[email]`
// against `root.teams` so we get category + permissions[] (the per-email
// index only carries identity, not the perms).
const $f90b022a9a65dc51$var$_teamsFor = (root, personOrEmail)=>{
    // Accept a person-like { userId, email } (preferred) or a bare email.
    // id-first: a non-mgmt viewer's rows carry no email (server projection), so
    // resolve via the stable userId before the email fallback (fable.md P0).
    const p = typeof personOrEmail === 'string' ? {
        email: personOrEmail
    } : personOrEmail || {};
    const uid = p.userId != null ? String(p.userId) : '';
    const email = String(p.email || '').toLowerCase();
    if (!uid && !email) return [];
    const byUid = uid && root?.teamsByUserId?.[uid] || null;
    const memberships = (byUid && byUid.length ? byUid : email && root?.teamsByEmail?.[email]) || [];
    const byId = new Map((root?.teams || []).map((t)=>[
            t.id,
            t
        ]));
    return memberships.map((m)=>{
        const full = byId.get(m.id) || {};
        return {
            id: m.id,
            name: m.name || full.name || '',
            slug: m.slug || full.slug || '',
            orgId: m.orgId || full.orgId || null,
            role: m.role || 'member',
            // `status` lives on TeamMember (per-member overlay, PR #1). Until the
            // workspace data layer threads it through teamsByEmail, infer from
            // the team's category — passive teams contribute only passive perms.
            status: m.status || (full.category === 'passive' ? 'passive' : 'active'),
            category: full.category || 'active',
            permissions: Array.isArray(full.permissions) ? full.permissions : []
        };
    });
};
// (Removed 2026-06-03: _computeEffective — owner short-circuit + org
// role baseline ∪ team perms math powered the EffectiveSection panel.
// Server-side unionEffectivePermissions is still authoritative; the
// client mirror retires with the UI.)
const $f90b022a9a65dc51$var$_categoryColor = (cat)=>{
    if (cat === 'manager') return 'purple';
    if (cat === 'active') return 'blue';
    if (cat === 'passive') return 'gray';
    if (cat === 'external') return 'orange';
    if (cat === 'archived') return 'red';
    return 'gray';
};
// Every key is a LITERAL — a key built by template is invisible to grep, to
// the parity test and to every extraction tool (docs/I18N-CONVENTION.md §1.3).
const $f90b022a9a65dc51$var$CATEGORY_KEY = {
    manager: 'workspace.people.category.manager',
    active: 'workspace.people.filter.active',
    passive: 'workspace.people.category.passive',
    external: 'workspace.people.category.external',
    archived: 'workspace.people.category.archived'
};
const $f90b022a9a65dc51$var$_categoryLabel = (el, cat)=>el.call('polyglot', $f90b022a9a65dc51$var$CATEGORY_KEY[cat] || 'workspace.person.categoryUnassigned');
// (Removed 2026-06-03: _orgRoleRank + _alreadyMaintainerOrAbove +
// _navigateTeams. They gated the Promote-to-Manager button + Manage-
// Teams shortcut, both stripped with the rest of the admin UI.)
// Close the person-detail modal layer via the registered windows API
// helper. Pre-migration this set `_personDetail: null` directly; now
// closePersonDetailModal handles state + layer pop.
const $f90b022a9a65dc51$var$_closePersonDetail = (el)=>el.call('closePersonDetailModal');
const $f90b022a9a65dc51$var$_navigateProfile = (el, root)=>{
    const p = $f90b022a9a65dc51$var$_detailPerson(root);
    if (!p?.email) return;
    $f90b022a9a65dc51$var$_closePersonDetail(el);
    const routeRoot = el.call('findRouteRoot', el);
    if (routeRoot) el.router(el.call('profilePath', p.email), routeRoot);
};
const $f90b022a9a65dc51$export$39fbae7e980d8fab = {
    // WS-MODAL-X-HORIZONTAL-OVERFLOW-1: fill the custom-template slot rather
    // than forcing the 'I' width inside it — same class as AppCreateOrgModal's
    // fixed-'H'-in-a-narrower-slot bug. The window width now comes from the
    // `openPersonDetailModal` layer descriptor; a body wider than the slot
    // overflowed the window (`overflow: 'visible'`) and pushed the ModalHeader
    // Close X outside both the window and the viewport.
    width: '100%',
    maxWidth: '100%',
    maxHeight: '85vh',
    // A COLUMN whose MIDDLE scrolls (Body, below): the head and the footer stay
    // pinned, and nothing on this root clips. The brand ModalHeader pulls its
    // Close X into the window's padding with a negative margin; an `overflow`
    // on this root cut that X by 12px and the footer's Open profile by 4px
    // (live on dev 2026-09-26, 1440 x 813).
    flow: 'y',
    minWidth: '0',
    ModalHeader: {
        // WS-MODAL-X-HORIZONTAL-OVERFLOW-1 (local override, brand chrome stays
        // untouched): the shared ModalHeader gives Hgroup `flex: 1` with no
        // `minWidth`, and its `P` a fixed `maxWidth: 'I_default'`. A long email
        // therefore sets a min-content floor for the title block, the row cannot
        // shrink to a narrow window, and the Close X — last item in the row — is
        // the first thing pushed out of the window. `minWidth: '0'` + a
        // percentage cap + `overflowWrap` let the block shrink instead.
        Hgroup: {
            minWidth: '0',
            H: {
                overflowWrap: 'anywhere',
                text: (el, s)=>$f90b022a9a65dc51$var$_detailPerson(s.root)?.name || $f90b022a9a65dc51$var$_detailPerson(s.root)?.email || el.call('polyglot', 'workspace.person.fallbackName')
            },
            P: {
                maxWidth: '100%',
                overflowWrap: 'anywhere',
                text: (el, s)=>$f90b022a9a65dc51$var$_detailPerson(s.root)?.email || ''
            }
        },
        // Override the brand's inherited Close — dispatch the windows-layer
        // close instead of the stateKey walker.
        Icons: {
            Close: {
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('closePersonDetailModal');
                }
            }
        }
    },
    Body: {
        flow: 'y',
        gap: 'B',
        padding: 'A B B B',
        // THE scroll region of the sheet (the root no longer clips).
        flex: '1 1 auto',
        minHeight: '0',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        // ── Identity row ──
        // Straight on the sheet (DESIGN_SPEC §6.2, the no-wrapper law) — it was a
        // box on an `overlay` tint inside the rounded window. The avatar is the
        // fixed `avatarMd` circle.
        IdentityRow: {
            flow: 'x',
            align: 'center',
            gap: 'A',
            Avatar: {
                align: 'center center',
                boxSize: 'avatarMd',
                round: 'radiusPill',
                src: (el, s)=>el.call('avatarUrlFor', $f90b022a9a65dc51$var$_detailPerson(s.root)?.email)
            },
            Info: {
                flow: 'y',
                gap: 'V',
                flex: '1',
                minWidth: '0',
                Name: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>$f90b022a9a65dc51$var$_detailPerson(s.root)?.name || "\u2014"
                },
                Sub: {
                    tag: 'div',
                    flow: 'x',
                    align: 'center',
                    gap: 'Z',
                    fontSize: 'Z2',
                    color: 'caption',
                    Role: {
                        text: (el, s)=>el.call('polyglot', 'workspace.person.orgRole').replace('{role}', $f90b022a9a65dc51$var$_orgRoleFor(s.root, $f90b022a9a65dc51$var$_detailPerson(s.root)?.email))
                    },
                    Dot: {
                        text: "\xb7"
                    },
                    Category: {
                        text: (el, s)=>{
                            const cat = (0, $eb4QA.effectiveCategory)($f90b022a9a65dc51$var$_teamsFor(s.root, $f90b022a9a65dc51$var$_detailPerson(s.root)));
                            return $f90b022a9a65dc51$var$_categoryLabel(el, cat);
                        }
                    }
                }
            },
            // The category is a STATUS: a tint of its hue under the neutral title
            // ink (DESIGN_LANGUAGE §4.2 / §8.5 rule 3 — wash + neutral ink). It was
            // white on the raw hue: 3.6:1 on blue, 3.2:1 on red, under the 4.5 floor
            // in both schemes.
            CategoryBadge: {
                tag: 'span',
                padding: 'V Z1',
                round: 'radiusPill',
                fontSize: 'Z2',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                color: 'title',
                background: (el, s)=>$f90b022a9a65dc51$var$_categoryColor((0, $eb4QA.effectiveCategory)($f90b022a9a65dc51$var$_teamsFor(s.root, $f90b022a9a65dc51$var$_detailPerson(s.root)))) + '.12',
                text: (el, s)=>$f90b022a9a65dc51$var$_categoryLabel(el, (0, $eb4QA.effectiveCategory)($f90b022a9a65dc51$var$_teamsFor(s.root, $f90b022a9a65dc51$var$_detailPerson(s.root))))
            }
        },
        // ── Teams section ──
        TeamsSection: {
            flow: 'y',
            gap: 'Z',
            // The section head is the kit's mono micro-label (a heading element).
            Heading: {
                extends: 'AppMicroLabel',
                tag: 'h3',
                margin: '0',
                text: (el, s)=>{
                    const n = $f90b022a9a65dc51$var$_teamsFor(s.root, $f90b022a9a65dc51$var$_detailPerson(s.root)).length;
                    return el.call('polyglot', 'workspace.personModal.teams').replace('{count}', String(n));
                }
            },
            Empty: {
                hide: (el, s)=>$f90b022a9a65dc51$var$_teamsFor(s.root, $f90b022a9a65dc51$var$_detailPerson(s.root)).length > 0,
                padding: 'Z A',
                fontSize: 'Z1',
                color: 'caption',
                fontStyle: 'italic',
                text: '{{ workspace.personModal.noTeams | polyglot }}'
            },
            // Teams list — read-only after 2026-06-03 simplification. Each
            // row shows team name + category pill. Per-member perms count,
            // active/passive toggle and Remove-from-team button were
            // stripped per Nika's "no permission UI in user profile" ask;
            // team admin actions live at /team-and-agents and /admin.
            List: {
                flow: 'y',
                gap: 'V',
                childExtends: {
                    flow: 'x',
                    align: 'center',
                    gap: 'Z',
                    // Flat rows on the sheet — no `overlay` box per row (§6.2); the
                    // list's own gap separates them.
                    padding: 'Y 0',
                    TeamName: {
                        tag: 'span',
                        flex: '1',
                        minWidth: '0',
                        fontSize: 'Z1',
                        fontWeight: '700',
                        color: 'title',
                        text: (el, s)=>s.name
                    },
                    // Same status treatment as the CategoryBadge above.
                    CategoryPill: {
                        tag: 'span',
                        padding: 'V Z',
                        round: 'radiusPill',
                        fontSize: 'Y2',
                        fontWeight: '500',
                        whiteSpace: 'nowrap',
                        color: 'title',
                        background: (el, s)=>$f90b022a9a65dc51$var$_categoryColor(s.category) + '.12',
                        text: (el, s)=>$f90b022a9a65dc51$var$_categoryLabel(el, s.category)
                    }
                },
                childrenAs: 'state',
                children: (el, s)=>$f90b022a9a65dc51$var$_teamsFor(s.root, $f90b022a9a65dc51$var$_detailPerson(s.root))
            }
        }
    },
    // The kit footer (DESIGN_SPEC §6.9): the quiet dismiss is the ghost
    // capsule, the one action — Open profile — is the ink primary, last. (It
    // was the reverse: a filled "Close" as the primary and the real action as
    // the ghost.)
    ModalFooter: {
        flow: 'x',
        gap: 'Z1',
        align: 'center end',
        // (Removed 2026-06-03: AddToTeamBtn, ManageTeamsBtn,
        // PromoteToManagerBtn — every permission/admin action button in
        // the footer is gone. Profile modal is read-only now; admin
        // surfaces own promote/add/manage actions.)
        CloseBtn: {
            extends: 'AppCapsuleBtnGhost',
            text: '{{ workspace.personModal.close | polyglot }}',
            onClick: (e, el)=>$f90b022a9a65dc51$var$_closePersonDetail(el)
        },
        OpenProfileBtn: {
            extends: 'AppCapsuleBtnPrimary',
            text: '{{ workspace.personModal.openProfile | polyglot }}',
            hide: (el, s)=>!$f90b022a9a65dc51$var$_detailPerson(s.root)?.email,
            onClick: (e, el, s)=>$f90b022a9a65dc51$var$_navigateProfile(el, s.root)
        }
    }
};

});

parcelRegister("armQq", function(module, exports) {

$parcel$export(module.exports, "PersonPopoverCard", () => $799e25763f169c83$export$d64a294c4f19ac58);
$parcel$export(module.exports, "PersonPopoverAction", () => $799e25763f169c83$export$593755896239a5ed);
// PersonPopoverCard — the click-anchored popover opened by
// el.call('openPersonPopover', email, anchorEl) (functions/personPopover.js).
// Renders inside the shared @symbo.ls/dropdown DropdownRoot panel (same layer
// AppOrgSwitcherMenu / AppNavbarMoreMenu use) — positioning, auto-flip,
// outside-click and ESC dismiss all come free from that shell-mounted layer.
//
// Content only: a mini profile header (bigger avatar, name, role/title or
// email, presence dot when known) plus a 3x2 grid of icon quick-actions —
// Chat, Call, Book a meeting, Profile, Assign Ticket, Ping. Every action
// reuses an existing registered function via el.call; see _dispatchAction
// below for the reuse + the documented choice behind each one.
//
// Target person travels on `root._personPopoverEmail` (see
// functions/personPopover.js for the full rationale) — read back live via
// findPerson so the card always reflects current roster/presence state
// rather than a frozen snapshot.

var $4SiPM = parcelRequire("4SiPM");
const $799e25763f169c83$var$_popoverPerson = (el, s)=>{
    const email = s.root?._personPopoverEmail;
    return email ? el.call('findPerson', email) : null;
};
const $799e25763f169c83$var$_isOnline = (s)=>{
    const email = s.root?._personPopoverEmail;
    if (!email) return false;
    return !!(s.root?.presenceById || {})[String(email).toLowerCase()];
};
// §3.7 Directory — the party-by-email cache partyLookup.js fills for an
// address outside the member roster: an object is the match summary,
// `false` is resolved-with-no-match (the Add-to-directory gate), absent is
// never-asked (the popover open fires the resolve).
const $799e25763f169c83$var$_partyOf = (root)=>{
    const email = String(root?._personPopoverEmail || '').trim().toLowerCase();
    const v = email ? (root?._partyByEmail || {})[email] : undefined;
    return v && typeof v === 'object' ? v : null;
};
const $799e25763f169c83$var$_canAddToDirectory = (root, el)=>{
    const email = root?._personPopoverEmail;
    if (!email || email === root?.currentUserEmail) return false;
    // `typeof el.call`, not just `el`: a children factory can re-run against a
    // half-detached element while the dropdown layer tears down, and there the
    // element object still exists but its `call` is already gone.
    if (el && typeof el.call === 'function' && el.call('findPerson', email)) return false;
    return (root?._partyByEmail || {})[String(email).trim().toLowerCase()] === false;
};
const $799e25763f169c83$var$_ACTIONS = [
    {
        key: 'chat',
        icon: 'chat',
        label: 'workspace.person.action.chat'
    },
    {
        key: 'email',
        icon: 'email',
        label: 'workspace.person.action.email'
    },
    {
        key: 'call',
        icon: 'phone',
        label: 'workspace.person.action.call'
    },
    {
        key: 'meeting',
        icon: 'date outline',
        label: 'workspace.person.action.meet'
    },
    {
        key: 'profile',
        icon: 'user',
        label: 'workspace.person.action.profile'
    },
    {
        key: 'assign',
        icon: 'check',
        label: 'workspace.person.action.assign'
    },
    {
        key: 'ping',
        icon: 'bell',
        label: 'workspace.person.action.ping'
    },
    {
        key: 'addDirectory',
        icon: 'people',
        label: 'workspace.person.addDirectory'
    }
];
// Ping doesn't apply to your own card — not reachable through the bottom-left
// dock today (OnlineMembers filters self out already) but kept defensive
// since this popover is meant to be reusable from anywhere with an email.
// Email drops on your own card too (a mail-yourself button is chrome), and
// whenever the `mail` module flag is off — the same gate the header
// envelope reads (architecture/MAIL.md §3.2a entry points).
const $799e25763f169c83$var$_actionsFor = (root, el)=>{
    const email = root?._personPopoverEmail;
    const isSelf = !!email && email === root?.currentUserEmail;
    return $799e25763f169c83$var$_ACTIONS.filter((a)=>{
        if (a.key === 'ping' && isSelf) return false;
        if (a.key === 'email' && (isSelf || !(0, $4SiPM.featureEnabled)(root, 'mail'))) return false;
        // Only an OUTSIDE address the party resolve answered "no match" for —
        // a member never needs a Party minted off their own card.
        if (a.key === 'addDirectory' && !$799e25763f169c83$var$_canAddToDirectory(root, el)) return false;
        return true;
    });
};
// One dispatcher for every action row — see the per-branch comments for the
// reuse decision behind each. `s` here is the ACTION row's state (its own
// {key,icon,label}), so `s.root` is the real app root throughout.
async function $799e25763f169c83$var$_dispatchAction(key, el, s) {
    const root = s.root;
    const email = root?._personPopoverEmail;
    if (!email) return;
    el.call('closeDropdown');
    if (key === 'email') {
        // THE §3.2a compose entry point — openMailCompose folds the mail context
        // itself and runs the setup gate, so this branch only shapes the intent
        // (prefilled `to`, with the roster name when the address resolves).
        const person = el.call('findPerson', email);
        el.call('openMailCompose', {
            to: [
                {
                    name: person?.name || '',
                    email: email
                }
            ]
        });
        return;
    }
    if (key === 'chat') {
        // Same open-drawer + resolve-or-create-DM shape as AppSidebar's
        // SidebarChatRow — messageUser (packages/chat) finds/creates the 1:1 and
        // sets activeChannelId; MessengerOverlay (mounted at the shell root,
        // gated on _chatDrawerOpen) picks it up and floats the DM open.
        // Fold the chat context first (bundle-fold) — messageUser AND the
        // MessengerOverlay itself live in the lazy chunk.
        const okFold = await el.call('ensureChatContext');
        if (okFold === false) return;
        root.update({
            _chatDrawerOpen: true
        });
        try {
            const channelId = await el.call('messageUser', email);
            if (!channelId) throw new Error('messageUser returned no channel');
        } catch (err) {
            console.warn('[PersonPopover] messageUser failed', err);
            el.call('openNotification', {
                type: 'error',
                title: el.call('polyglot', 'workspace.person.chatFailed'),
                message: err?.message || el.call('polyglot', 'workspace.person.tryAgain')
            });
        }
        return;
    }
    if (key === 'call') {
        // THE one call (functions/callPerson.js, shared with Fly): a private room,
        // the person made its member, this person joined on /meet, the join link
        // in our DM.
        await el.call('callPerson', el.call('findPerson', email) || email);
        return;
    }
    if (key === 'meeting') {
        // CalNewBookingModal is a global @symbo.ls/windows layer now (see
        // workspace/functions/newBookingModal.js) — no more navigating to
        // /calendar first to get a mount for it.
        //
        // The prefilled title is carried over from the calendar rail's own Book
        // button, which this action replaced when the rail stopped mounting its
        // own person card: the key moved from `calendar.person.meetingWith` to
        // this namespace with it, so no copy was lost.
        const person = el.call('findPerson', email);
        el.call('openNewBookingModal', {
            title: el.call('polyglot', 'workspace.person.meetingWith').replace('{name}', person?.name || email),
            invitees: email,
            date: el.call('todayISO'),
            type: 'meeting'
        });
        return;
    }
    if (key === 'profile') {
        // profilePath is the SAME /profile?u=<email> route PersonCard,
        // PersonDetailModal's "Open profile" and the People page all link to.
        // A card opened in the Messenger (a mention, a member) would open the page
        // UNDER it: the Messenger closes first, the rule a link in a message keeps
        // (chat functions/chatLinkClick.js).
        if (root?._chatDrawerOpen) root.update({
            _chatDrawerOpen: false
        });
        el.router(el.call('profilePath', email), el.getRoot());
        return;
    }
    if (key === 'assign') {
        // Simplest-correct choice per spec: jump to the tickets board
        // pre-filtered to this person (the SAME ?assignee= URL-filter contract
        // RoadmapMain's cycle links use) so the user can open or create a
        // ticket and set the assignee themselves — NOT a one-click auto-assign.
        // A fuller "list their open tickets, pick one, sdk.tickets.update(...)"
        // flow is possible later but trades this for two real risks the spec
        // flagged: the tickets metadata-REPLACE trap (must spread existing
        // metadata on every write) and an unresolved "whose open tickets"
        // question (assigner's? assignee's? reporter=me?). This gets the user
        // to the right context with zero write-risk. The Messenger closes first,
        // as for Profile above.
        if (root?._chatDrawerOpen) root.update({
            _chatDrawerOpen: false
        });
        el.router(`/tasks/board?assignee=${encodeURIComponent(email)}`, el.getRoot());
        return;
    }
    if (key === 'addDirectory') {
        // partyLookup.js owns the create, the cache write and both toasts; the
        // stashed display name (a mail sender header) beats the bare address as
        // the party's name.
        await el.call('addPartyFromEmail', email, root?._personPopoverName || '');
        return;
    }
    if (key === 'ping') {
        // createNotification (shared/functions/notifications/createNotification.js)
        // is the existing SDK-backed creation path — reused as-is, no SDK change
        // needed. Click-through reuses the SAME deep-link shape chat's own
        // @mention notifications already use (chat/functions/subscribeRealtime.js
        // _handleMentionInsert → `/chat#channel=<id>`), which chat's page already
        // parses on mount — so the generic NotificationPanel row click (shared,
        // unmodified) just works: no shared-component edit needed for click-
        // through. Resolving/creating the DM channel up front (before the
        // notification even exists) is what makes that href possible.
        const person = el.call('findPerson', email);
        const me = el.call('findPerson', root?.currentUserEmail);
        // No name to put in `{name}` → the sentence without it. A translated
        // "someone" cannot fill the slot: the Georgian template glues a case
        // ending onto it (glossary rule 7).
        const senderName = me?.name || root?.currentUserEmail || '';
        try {
            // Same lazy-chunk caveat as the 'call' branch: createChannel is folded,
            // not eager. Un-folded it returns undefined, which silently degrades the
            // ping's click-through href from `/chat#channel=<id>` to a bare `/chat`.
            // The fold is best-effort here — a failed fold must NOT block the ping
            // itself, so we carry on with the fallback href rather than returning.
            await el.call('ensureChatContext');
            const channelId = await el.call('createChannel', {
                kind: 'dm',
                memberEmails: [
                    email
                ]
            });
            const notifId = await el.call('createNotification', {
                userEmail: email,
                type: 'ping',
                title: senderName ? el.call('polyglot', 'workspace.person.pingedYou').replace('{name}', senderName) : el.call('polyglot', 'workspace.person.pingedYouAnon'),
                href: channelId ? `/chat#channel=${channelId}` : '/chat'
            });
            // createNotification resolves `null` (not a throw) on a server-side
            // failure — an unchecked await here is exactly how a previous version
            // of this code showed "Ping sent" even when nothing was created.
            // Treat a falsy id as failure, matching the createRoom check above.
            if (!notifId) {
                el.call('openNotification', {
                    title: el.call('polyglot', 'workspace.person.pingFailedSend'),
                    message: el.call('polyglot', 'workspace.person.tryAgain'),
                    type: 'error'
                });
                return;
            }
            el.call('openNotification', {
                title: el.call('polyglot', 'workspace.person.pingSent'),
                message: el.call('polyglot', 'workspace.person.pingSentBody').replace('{name}', person?.name || email),
                type: 'success'
            });
        } catch (err) {
            console.warn('[PersonPopover] ping failed', err);
            el.call('openNotification', {
                title: el.call('polyglot', 'workspace.person.pingFailed'),
                message: err?.message || el.call('polyglot', 'workspace.person.tryAgain'),
                type: 'error'
            });
        }
    }
}
const $799e25763f169c83$export$d64a294c4f19ac58 = {
    // House dropdown-body chrome (round/theme/shadow/padding) — same recipe
    // AppOrgSwitcherMenu / AppNavbarMoreMenu extend; the DropdownRoot panel
    // wrapper itself is a chromeless positioning shell (menu bodies own their
    // own card look).
    extends: 'MenuPanel',
    tag: 'div',
    flow: 'y',
    gap: 'A',
    padding: 'A',
    width: 'H',
    textAlign: 'left',
    subscribeTo: [
        '_personPopoverEmail',
        '_personPopoverName',
        '_partyByEmail',
        'people',
        'presenceById'
    ],
    // An anchored surface is placed from a rect SNAPSHOT (openDropdown captures
    // the trigger's getBoundingClientRect once), so the coordinate goes stale
    // the moment the page, an inner scroller or the window moves. The house
    // behaviour for that is to DISMISS, not to chase the anchor — the retired
    // SharedPersonCard did neither and stayed put while its row scrolled away.
    //
    // `onDocumentScroll` / `onWindowResize` are the framework-owned primitives
    // (raw document listeners are banned, FA503): registered when this card
    // mounts — i.e. exactly while the popover is open — and torn down with it.
    // Capture phase because scroll events do NOT bubble: a chat message list or
    // any other inner scroller only reaches a capture listener on the document.
    // `passive` because a dismissal must never block scrolling.
    //
    // Bare `closeDropdown` with no id, the same convention the action buttons
    // below use: this card only exists while THIS popover is the open layer.
    onDocumentScroll: {
        capture: true,
        passive: true,
        handler: (ev, el)=>{
            const t = ev && ev.target;
            // Never dismiss on a scroll inside the card itself — the plugin Panel
            // brings its own maxHeight scroller.
            if (t && t.nodeType === 1 && el.node && el.node.contains(t)) return;
            el.call('closeDropdown');
        }
    },
    onWindowResize: (ev, el)=>el.call('closeDropdown'),
    Header: {
        flow: 'x',
        align: 'center left',
        gap: 'Z1',
        Avatar: {
            boxSize: 'avatarXl',
            round: 'radiusPill',
            flexShrink: '0',
            align: 'center center',
            src: (el, s)=>el.call('avatarUrlFor', s.root?._personPopoverEmail || '')
        },
        Info: {
            flow: 'y',
            gap: 'V',
            flex: '1',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>$799e25763f169c83$var$_popoverPerson(el, s)?.name || $799e25763f169c83$var$_partyOf(s.root)?.name || s.root?._personPopoverName || s.root?._personPopoverEmail || el.call('polyglot', 'workspace.person.unknown')
            },
            Sub: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>$799e25763f169c83$var$_popoverPerson(el, s)?.position || s.root?._personPopoverEmail || ''
            },
            Presence: {
                // `hide:` (not `if:`) — presence syncs after mount; `if` would freeze
                // this hidden forever for a person who comes online while the
                // popover happens to already be open (same trap OnlineMembers'
                // header comment documents for its own widget-level hide).
                hide: (el, s)=>!$799e25763f169c83$var$_isOnline(s),
                flow: 'x',
                align: 'center left',
                gap: 'V',
                marginTop: 'X',
                Dot: {
                    width: 'Y',
                    height: 'Y',
                    round: '50%',
                    background: 'green'
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: '{{ workspace.person.online | polyglot }}'
                }
            },
            // §3.7 Directory — the resolved-party tag for an outside address
            // (same `hide:`-not-`if:` reasoning as Presence: the resolve lands
            // AFTER the popover opened).
            Directory: {
                hide: (el, s)=>!$799e25763f169c83$var$_partyOf(s.root),
                flow: 'x',
                align: 'center left',
                gap: 'V',
                marginTop: 'X',
                Icon: {
                    name: 'people',
                    boxSize: 'Z',
                    color: 'caption',
                    flexShrink: '0'
                },
                Label: {
                    tag: 'span',
                    fontSize: 'Y2',
                    color: 'caption',
                    text: '{{ workspace.person.inDirectory | polyglot }}'
                }
            }
        }
    },
    // The actions are set apart by space, not a hairline — no rules inside a
    // rounded surface (the workspace switcher's footer does the same).
    Divider: {
        height: '1px',
        flexShrink: '0',
        margin: 'V 0'
    },
    Actions: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 'V',
        childExtends: 'PersonPopoverAction',
        childrenAs: 'state',
        childrenDeps: [
            (el, s)=>s.root && s.root._personPopoverEmail,
            (el, s)=>s.root && s.root._partyByEmail,
            (el, s)=>s.root && s.root.people
        ],
        children: (el, s)=>$799e25763f169c83$var$_actionsFor(s.root, el)
    }
};
const $799e25763f169c83$export$593755896239a5ed = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    align: 'center center',
    gap: 'V',
    padding: 'Z A',
    round: 'radiusControl',
    borderWidth: '0',
    background: 'transparent',
    cursor: 'pointer',
    color: 'title',
    fontSize: 'Y2',
    // Labels are 500 (the weight law).
    fontWeight: '500',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    title: (el, s)=>el.call('polyglot', s.label || ''),
    'aria-label': (el, s)=>el.call('polyglot', s.label || ''),
    // The glyph on the neutral widget plate (was the `overlayStrong` wash).
    IconWrap: {
        width: 'C1',
        height: 'C1',
        round: 'radiusPill',
        align: 'center center',
        background: 'widgetPlate',
        flexShrink: '0',
        Icon: {
            name: (el, s)=>s.icon,
            boxSize: 'A'
        }
    },
    Label: {
        tag: 'span',
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        $799e25763f169c83$var$_dispatchAction(s.key, el, s);
    }
};

});

parcelRegister("hpTyi", function(module, exports) {

$parcel$export(module.exports, "OrgChartModal", () => $cadfdcf69573cd4b$export$e52dd33955dd5cf1);
// Org chart — bulk manager editor + minimal chart view. tickets/sonnet.md
// "org chart: UI (admin editor screen + chart view)". Opened from the
// /people page header (pages/people.js). Server half already shipped
// (bulk-read + admin bulk-write on PartyRelationship); this is the
// remaining UI. Data/state logic lives in functions/orgChart.js.
//
// Chart tab (view = 'chart', default) is open to any workspace member —
// GET /core/parties/relationships is member-gated server-side, matching
// "anyone can see who reports to whom". Edit tab is admin-only: the tab
// button is hidden for non-admins, and the edit view's own content is
// ALSO gated (defense in depth against a stale/forced view state) — the
// server enforces the real boundary (POST .../reports-to is
// requireWorkspaceManager), this is belt-and-suspenders on the client.
const $cadfdcf69573cd4b$var$_reset = {
    _orgChartView: 'chart',
    _orgChartParties: [],
    _orgChartEdges: [],
    _orgChartWorking: {},
    _orgChartLoading: false,
    _orgChartSaving: false,
    _orgChartLoadError: null,
    _orgChartSaveError: null
};
const $cadfdcf69573cd4b$export$e52dd33955dd5cf1 = {
    extends: 'Modal',
    stateKey: '_orgChartOpen',
    extraClose: $cadfdcf69573cd4b$var$_reset,
    Window: {
        // The centre sheet (DESIGN_SPEC §6.1) at `overlayLg` — a tree and a
        // row editor, wider than a form; capped by the veil's inset box. The
        // shared Modal owns the veil, the sheet motion, the phone sheet and the
        // focus/Escape contract.
        width: 'overlayLg',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'auto',
        flow: 'y',
        gap: 'A',
        ModalHeader: {
            Hgroup: {
                H: {
                    text: '{{ workspace.orgChart.title | polyglot }}'
                },
                P: {
                    text: '{{ workspace.orgChart.subtitle | polyglot }}'
                }
            }
        },
        // Chart · Edit is a VIEW switch — the kit's segmented control in its
        // `view` strength (the raised thumb), not two hand-made tabs on raw
        // `overlayStrong` washes. Edit is admin-only, and one segment is no
        // choice at all, so the whole bar shows to admins only (a member sees the
        // chart and nothing to switch).
        TabBar: {
            extends: 'AppSegmented',
            variant: 'view',
            hide: (el, s)=>!el.call('canAdmin', s),
            options: [
                {
                    value: 'chart',
                    label: 'workspace.orgChart.tabChart'
                },
                {
                    value: 'edit',
                    label: 'workspace.orgChart.tabEdit'
                }
            ],
            childProps: {
                isActive: (el, s)=>(s.root?._orgChartView === 'edit' ? 'edit' : 'chart') === el.optionValue,
                ariaPressed: (el, s)=>(s.root?._orgChartView === 'edit' ? 'edit' : 'chart') === el.optionValue ? 'true' : 'false',
                text: (el)=>el.call('polyglot', el.optionLabel || ''),
                onClick: (e, el, s)=>s.root.update({
                        _orgChartView: el.optionValue
                    })
            }
        },
        // §9 loading law (DESIGN-LOCKS-RED-1): geometry-reserving skeleton rows,
        // never a renderable "Loading…" string.
        LoadingRows: {
            hide: (el, s)=>!s.root?._orgChartLoading,
            flow: 'y',
            gap: 'V',
            Row_1: {
                extends: 'SkeletonRow',
                width: '60%'
            },
            Row_2: {
                extends: 'SkeletonRow',
                width: '90%'
            },
            Row_3: {
                extends: 'SkeletonRow',
                width: '75%'
            }
        },
        LoadErrorNote: {
            hide: (el, s)=>!s.root?._orgChartLoadError,
            tag: 'p',
            role: 'alert',
            margin: '0',
            fontSize: 'Z2',
            color: 'dangerInk',
            text: (el, s)=>s.root?._orgChartLoadError || ''
        },
        // ── Chart tab — read-only tree, open to any member ─────────────────────
        ChartView: {
            hide: (el, s)=>s.root?._orgChartView === 'edit' || s.root?._orgChartLoading || !!s.root?._orgChartLoadError,
            flow: 'y',
            gap: 'Z',
            overflow: 'auto',
            maxHeight: '52vh',
            EmptyNote: {
                hide: (el, s)=>!!el.call('orgChartDirectory').length,
                tag: 'p',
                margin: '0',
                fontSize: 'Z2',
                color: 'caption',
                text: '{{ workspace.orgChart.empty | polyglot }}'
            },
            Tree: {
                flow: 'y',
                gap: 'A',
                childExtends: 'OrgChartTreeNode',
                childrenAs: 'state',
                children: (el, s)=>{
                    const byId = new Map(el.call('orgChartDirectory').map((p)=>[
                            p.partyId,
                            p
                        ]));
                    const rootIds = el.call('orgChartChildrenOf').get('root') || [];
                    return rootIds.map((id)=>byId.get(id)).filter(Boolean).map((p)=>({
                            ...p,
                            depth: 0
                        }));
                }
            }
        },
        // ── Edit tab — admin-only bulk manager editor ───────────────────────────
        EditView: {
            hide: (el, s)=>s.root?._orgChartView !== 'edit' || s.root?._orgChartLoading || !!s.root?._orgChartLoadError || !el.call('canAdmin', s),
            flow: 'y',
            gap: 'Z',
            RowList: {
                flow: 'y',
                gap: '-',
                overflow: 'auto',
                maxHeight: '46vh',
                childExtends: 'OrgChartEditRow',
                childrenAs: 'state',
                children: (el)=>el.call('orgChartDirectory')
            },
            SaveErrorNote: {
                hide: (el, s)=>!s.root?._orgChartSaveError,
                tag: 'p',
                role: 'alert',
                margin: '0',
                fontSize: 'Z2',
                color: 'dangerInk',
                text: (el, s)=>s.root?._orgChartSaveError || ''
            },
            Footer: {
                flow: 'x',
                gap: 'Z',
                align: 'center',
                justifyContent: 'flex-end',
                // The kit's ink primary (DESIGN_SPEC §6.9, L68): the `primary` theme,
                // its own washes and the disabled step — never an opacity (Rule 65);
                // the house floor for a label that changes while it works.
                AppCapsuleBtnPrimary: {
                    minWidth: 'E',
                    disabled: (el, s)=>!el.call('orgChartIsDirty') || !!s.root?._orgChartSaving,
                    text: (el, s)=>el.call('polyglot', s.root?._orgChartSaving ? 'workspace.orgChart.saving' : 'workspace.orgChart.save'),
                    onClick: async (e, el, s)=>{
                        e.preventDefault();
                        const ok = await el.call('orgChartSave', s);
                        if (ok) el.call('openNotification', {
                            title: el.call('polyglot', 'workspace.orgChart.saved'),
                            message: el.call('polyglot', 'workspace.orgChart.savedBody'),
                            type: 'success'
                        });
                    }
                }
            }
        }
    }
};

});

parcelRegister("fB7aj", function(module, exports) {

$parcel$export(module.exports, "OrgChartTreeNode", () => $b5afde9a377cfce3$export$93b34ef6a078fab5);
// One row of the org-chart tree view (components/OrgChartModal.js Chart
// tab) — a person + their direct reports, indented one level further.
// Recursive by self-reference: Children.childExtends: 'OrgChartTreeNode'.
// Seeded per-instance via childrenAs: 'state' (see OrgChartModal.js and the
// Children block below), so `s` here is the row's own {partyId, name,
// avatar, depth}, and `s.root` still reaches the shared app state.
const $b5afde9a377cfce3$export$93b34ef6a078fab5 = {
    flow: 'y',
    gap: 'Y',
    Row: {
        flow: 'x',
        align: 'center',
        gap: 'Y',
        // Built-in Avatar is a bare `<img>` (extends smbls.Avatar) — an empty
        // `src` renders the browser's broken-image glyph rather than falling
        // back gracefully. Most Party rows have no avatar image, so this needs
        // the same image-or-initials treatment PersonCard.js's PcAvatar uses
        // (without its presence-dot overlay, not relevant here).
        PersonAvatar: {
            align: 'center center',
            boxSize: 'C',
            round: '50%',
            color: 'title',
            fontSize: 'Y2',
            fontWeight: '700',
            position: 'relative',
            overflow: 'hidden',
            background: 'overlayStrong',
            AvatarImg: {
                tag: 'img',
                // `if:`, never `hide:` — a display:none <img> still FETCHES its src;
                // non-URL avatar values 404ed against the origin (same class as the
                // IntranetRows plate, fixed 2026-09-01). Guarded src as the belt.
                if: (el, s)=>typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
                position: 'absolute',
                inset: '0',
                width: '100%',
                height: '100%',
                src: (el, s)=>typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar) ? s.avatar : null,
                alt: (el, s)=>s.name || '',
                style: {
                    objectFit: 'cover'
                }
            },
            Initials: {
                tag: 'span',
                hide: (el, s)=>typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
                text: (el, s)=>{
                    const parts = String(s.name || '').trim().split(/\s+/).filter(Boolean);
                    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
                    return String(s.name || '?').slice(0, 2).toUpperCase();
                }
            }
        },
        Name: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: (el, s)=>s.depth ? '500' : '700',
            color: 'title',
            text: (el, s)=>s.name || ''
        }
    },
    Children: {
        paddingLeft: 'C',
        flow: 'y',
        gap: 'Y',
        hide: (el, s)=>!(el.call('orgChartChildrenOf').get(s.partyId) || []).length,
        childExtends: 'OrgChartTreeNode',
        childrenAs: 'state',
        children: (el, s)=>{
            const byId = new Map(el.call('orgChartDirectory').map((p)=>[
                    p.partyId,
                    p
                ]));
            const kidIds = el.call('orgChartChildrenOf').get(s.partyId) || [];
            return kidIds.map((id)=>byId.get(id)).filter(Boolean).map((p)=>({
                    ...p,
                    depth: (s.depth || 0) + 1
                }));
        }
    }
};

});

parcelRegister("lk7ed", function(module, exports) {

$parcel$export(module.exports, "OrgChartEditRow", () => $f861129c97e4fc54$export$19cc5e2d348f1a15);
// One row of the org-chart bulk editor (components/OrgChartModal.js Edit
// tab) — a person + a native "reports to" select. Seeded per-instance via
// childrenAs: 'state' (see OrgChartModal.js), so `s` here is the row's own
// {partyId, name, avatar, email}, and `s.root` still reaches the shared
// app state (_orgChartWorking lives there, not on the row).
const $f861129c97e4fc54$export$19cc5e2d348f1a15 = {
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Y -',
    // Built-in Avatar is a bare `<img>` (extends smbls.Avatar) — an empty
    // `src` renders the browser's broken-image glyph rather than falling
    // back gracefully. Most Party rows have no avatar image, so this needs
    // the same image-or-initials treatment PersonCard.js's PcAvatar uses
    // (without its presence-dot overlay, not relevant here).
    PersonAvatar: {
        align: 'center center',
        boxSize: 'C',
        round: '50%',
        color: 'title',
        fontSize: 'Y2',
        fontWeight: '700',
        position: 'relative',
        overflow: 'hidden',
        background: 'overlayStrong',
        AvatarImg: {
            tag: 'img',
            // `if:`, never `hide:` — a display:none <img> still FETCHES its src;
            // non-URL avatar values 404ed against the origin (same class as the
            // IntranetRows plate, fixed 2026-09-01). Guarded src as the belt.
            if: (el, s)=>typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
            position: 'absolute',
            inset: '0',
            width: '100%',
            height: '100%',
            src: (el, s)=>typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar) ? s.avatar : null,
            alt: (el, s)=>s.name || '',
            style: {
                objectFit: 'cover'
            }
        },
        Initials: {
            tag: 'span',
            hide: (el, s)=>typeof s.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
            text: (el, s)=>{
                const parts = String(s.name || '').trim().split(/\s+/).filter(Boolean);
                if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
                return String(s.name || '?').slice(0, 2).toUpperCase();
            }
        }
    },
    Name: {
        flex: '1',
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>s.name || ''
    },
    SelectField: {
        minWidth: 'F',
        padding: 'V A',
        round: 'D',
        // Native <select>. `value:` is the reactive, diffed DOMQL prop (FA511 —
        // el.node writes bypass diffing and get overwritten by the next
        // render); `childProps.attr.selected` below keeps each generated
        // <option> in sync too, since a native select's displayed value can
        // depend on both.
        Select: {
            name: (el, s)=>`org-chart-manager-${s.partyId}`,
            value: (el, s)=>(s.root?._orgChartWorking || {})[s.partyId] || '',
            onChange: (e, el, s)=>el.call('orgChartSetWorking', s, s.partyId, e.target.value || null),
            childrenAs: 'props',
            children: (el, s)=>{
                const options = [
                    {
                        value: '',
                        text: el.call('polyglot', 'workspace.orgChart.noManager')
                    }
                ];
                for (const p of el.call('orgChartDirectory')){
                    if (p.partyId === s.partyId) continue;
                    options.push({
                        value: p.partyId,
                        text: p.name
                    });
                }
                return options;
            },
            childProps: {
                tag: 'option',
                attr: {
                    selected: (el, s)=>((s.root?._orgChartWorking || {})[s.partyId] || '') === el.value
                }
            }
        }
    }
};

});

parcelRegister("dZ7nF", function(module, exports) {

$parcel$export(module.exports, "LinkedResources", () => $a2e6b2880538bd24$export$e574f09dbdb296dd);
$parcel$export(module.exports, "LinkedResourcePill", () => $a2e6b2880538bd24$export$3107e033991c94e4);
// Inline pill row that surfaces linked cross-resource references for the
// current chat channel / calendar event / meet room. Clicking a pill
// navigates to the linked resource so users can hop between the
// conversation, the meeting, and the event that tied them together.
//
// Usage: mount inside the header/detail area of a resource view and set
// local state `type` + `id`:
//
//   LinkedResources: { state: { type: 'chat_channel', id: root.activeChannelId } }
//
// Renders nothing when there are no links (collapses to `display: none`).
const $a2e6b2880538bd24$var$SHELL_TYPE_META = {
    chat_channel: {
        icon: 'chat',
        label: (root, id, el)=>{
            const ch = (root.channels || []).find((c)=>String(c.id) === String(id));
            if (!ch) return el.call('polyglot', 'workspace.linked.conversation');
            if (ch.kind === 'channel') return '# ' + (ch.name || '');
            if (ch.kind === 'group_dm') return el.call('polyglot', 'workspace.linked.group');
            return el.call('polyglot', 'workspace.linked.dm');
        }
    },
    meet_room: {
        icon: 'video',
        label: (root, id, el)=>{
            const r = (root.rooms || []).find((x)=>String(x.id) === String(id));
            return r?.name || el.call('polyglot', 'workspace.linked.call');
        }
    },
    calendar_event: {
        icon: 'clock',
        label: (root, id, el)=>{
            const ev = (root.events || []).find((e)=>String(e.id) === String(id));
            return ev?.title || el.call('polyglot', 'workspace.linked.event');
        }
    }
};
const $a2e6b2880538bd24$var$_shellNavigateTo = (el, type, id)=>{
    const root = el.state?.root;
    if (!root) return;
    let rootEl = el;
    while(rootEl && !rootEl.routes)rootEl = rootEl.parent;
    if (type === 'chat_channel') {
        root.update({
            activeChannelId: id,
            activeThreadRootId: null
        });
        if (rootEl) el.router('/chat', rootEl);
    } else if (type === 'meet_room') {
        root.update({
            activeRoomId: id,
            meetView: 'call'
        });
        if (typeof window !== 'undefined') window.location.hash = `room=${id}&view=call`;
        if (rootEl) el.router('/meet', rootEl);
    } else if (type === 'calendar_event') {
        const ev = (root.events || []).find((e)=>String(e.id) === String(id));
        if (ev) el.call('openEventDetailModal', ev);
        if (rootEl) el.router('/calendar', rootEl);
    }
};
const $a2e6b2880538bd24$export$e574f09dbdb296dd = {
    flow: 'x',
    gap: 'Z',
    align: 'center left',
    flexWrap: 'wrap',
    display: (el, s)=>{
        const root = s?.root;
        if (!root || !el.type || el.id == null) return 'none';
        return el.call('getLinkedResources', root, el.type, el.id).length ? 'flex' : 'none';
    },
    Label: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: '{{ workspace.linked.label | polyglot }}'
    },
    childExtends: 'LinkedResourcePill',
    childrenAs: 'state',
    children: (el, s)=>{
        const root = s?.root;
        if (!root || !el.type || el.id == null) return [];
        return el.call('getLinkedResources', root, el.type, el.id);
    }
};
const $a2e6b2880538bd24$export$3107e033991c94e4 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Y',
    padding: 'Y Z',
    round: 'radiusPill',
    border: 'none',
    background: 'overlay',
    color: 'title',
    cursor: 'pointer',
    fontSize: 'Y2',
    fontWeight: '500',
    ':hover': {
        theme: 'dialog'
    },
    transition: 'background 120ms ease',
    Icon: {
        name: (el, s)=>$a2e6b2880538bd24$var$SHELL_TYPE_META[s.type]?.icon || 'link'
    },
    Text: {
        tag: 'span',
        text: (el, s)=>{
            const root = el.state?.root;
            const meta = $a2e6b2880538bd24$var$SHELL_TYPE_META[s.type];
            if (!root || !meta) return '';
            return meta.label(root, s.id, el);
        }
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        $a2e6b2880538bd24$var$_shellNavigateTo(el, s.type, s.id);
    }
};

});

parcelRegister("h44jx", function(module, exports) {

$parcel$export(module.exports, "NavSearchResultGroup", () => $c6c628160194c80a$export$6364b8b5fb4fcb45);
$parcel$export(module.exports, "NavSearchLoading", () => $c6c628160194c80a$export$291485472eaf989b);
$parcel$export(module.exports, "NavSearchNoResults", () => $c6c628160194c80a$export$16bb5cb98a4e2171);
$parcel$export(module.exports, "NavSearchResultItem", () => $c6c628160194c80a$export$445f2ee16b8daca7);
$parcel$export(module.exports, "NavSearchAppItem", () => $c6c628160194c80a$export$8e78ac7e2288ec8b);
$parcel$export(module.exports, "NavSearchCommandItem", () => $c6c628160194c80a$export$f15edf0c07c866a7);
$parcel$export(module.exports, "NavSearchActionItem", () => $c6c628160194c80a$export$13248b58191d5ecf);
// NavSearchDropdown — populates SearchBar > Dropdown with grouped global
// search results. The parent SearchBar extends DropdownParentFocus, which
// shows [dropdown] children on :focus-within via CSS.
const $c6c628160194c80a$export$6364b8b5fb4fcb45 = {
    flow: 'y',
    GroupHeader: {
        flow: 'x',
        align: 'center left',
        gap: 'Y',
        padding: 'Y1 A',
        Icon: {
            name: (el, s)=>s.icon || 'search',
            boxSize: 'Z2 Z2',
            color: 'caption'
        },
        // The mono micro-label that heads every group of the redesign
        // (DESIGN_SPEC §5.7) — the launcher's section heads wear the same.
        GroupLabel: {
            extends: 'AppMicroLabel',
            // KEY-IN-STATE: `_groupResults` carries the CATEGORY_META key; an
            // unmapped server surface falls back to its own name, which polyglot
            // returns verbatim.
            text: (el, s)=>el.call('polyglot', s.label || '')
        }
    },
    // RECORD rows — tickets, notes, files, people, every server surface. The
    // default: `_groupResults` stamps `kind: 'record'` on any category with no
    // explicit kind (functions/search/globalSearch.js CATEGORY_META).
    Items: {
        flow: 'y',
        // Every kind with its own slot below stays out — an ACTION group rendered
        // here too showed each chip and action twice (once as a dead record
        // link), live on dev ec09e4e87 (2026-10-07).
        if: (el, s)=>s.kind !== 'apps' && s.kind !== 'commands' && s.kind !== 'actions',
        children: (el, s)=>s.items || [],
        childExtends: 'NavSearchResultItem',
        childrenAs: 'state'
    },
    // APP rows — the apps group (built-in + installed apps matching the query)
    // and every zero-result suggestion group (App Store / Integrations /
    // browse). Rendered with the LAUNCHER's own row so an app reads identically
    // wherever it is offered; `flow`/`gap` mirror AppGroupColumn's GcItems, the
    // other AppListItem list in this package.
    //
    // A SECOND slot rather than a per-group `childExtends` because
    // `childExtends` is a registry key read as a raw value — never a
    // `(el, s) =>` factory — so one group component cannot pick its row
    // renderer from state any other way. `if:` (unmount), not `hide:`: a
    // group's kind is fixed for its whole life, so the unused branch is dead
    // weight, never a toggled view. Both branches are declared HERE, inside the
    // component, so neither can be clobbered by a mount-site `if:`.
    AppItems: {
        flow: 'y',
        gap: 'V',
        if: (el, s)=>s.kind === 'apps',
        children: (el, s)=>s.items || [],
        childExtends: 'NavSearchAppItem',
        childrenAs: 'state'
    },
    // COMMAND rows — the shell keyboard registry's rows, the ⌘K palette's
    // (DESIGN-WL-SHELL-KEYBOARD-MOTION-1; functions/search/
    // searchCommandResults.js). The third branch, declared here beside the
    // other two for the same reason: no mount-site `if:` can clobber it.
    CommandItems: {
        flow: 'y',
        if: (el, s)=>s.kind === 'commands',
        children: (el, s)=>s.items || [],
        childExtends: 'NavSearchCommandItem',
        childrenAs: 'state'
    },
    // ACTION rows — the ⌘K filter chips and what to do with the chipped result
    // (CMDK-05 / CMDK-08; functions/search/searchAppRecordResults.js): the
    // active chips, the values to filter by, the app hand-off, the ask, the
    // clear. The fourth branch, declared here for the same reason as the three
    // above.
    ActionItems: {
        flow: 'y',
        if: (el, s)=>s.kind === 'actions',
        children: (el, s)=>s.items || [],
        childExtends: 'NavSearchActionItem',
        childrenAs: 'state'
    }
};
const $c6c628160194c80a$export$291485472eaf989b = {
    subscribeTo: [
        '_navSearchLoading'
    ],
    hide: (el, s)=>!s.root._navSearchLoading,
    padding: 'Y1 A',
    fontSize: 'Z2',
    color: 'caption',
    role: 'status',
    text: '{{ shell.headerSearch.loading | polyglot }}'
};
const $c6c628160194c80a$export$16bb5cb98a4e2171 = {
    subscribeTo: [
        '_navSearchLoading',
        '_navSearchGrouped',
        'navSearchQuery'
    ],
    hide: (el, s)=>!!s.root._navSearchLoading || !(s.root.navSearchQuery || '').trim() || !!(s.root._navSearchGrouped && s.root._navSearchGrouped.length),
    padding: 'Y1 A',
    fontSize: 'Z2',
    color: 'caption',
    role: 'status',
    text: (el, s)=>el.call('polyglot', 'shell.headerSearch.noResults').replace('{query}', (s.root.navSearchQuery || '').trim())
};
// SEARCH-1 (2026-08-14) — the keyboard-selected row. `s._flatIndex` is
// stamped onto every item by globalSearch.js's `_groupResults` (a running
// index across the WHOLE grouped set, group order then item order), so this
// stays in perfect agreement with moveNavSearchSelection's wrap arithmetic
// without either side re-deriving the flatten order.
const $c6c628160194c80a$var$_isKeyboardActive = (s)=>typeof s._flatIndex === 'number' && s.root?._navSearchActiveIndex === s._flatIndex;
const $c6c628160194c80a$export$445f2ee16b8daca7 = {
    extends: 'Link',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    padding: 'Y1 A',
    cursor: 'pointer',
    textDecoration: 'none',
    round: 'radiusControl',
    subscribeTo: [
        '_navSearchActiveIndex'
    ],
    // House "selected" token (never overlayStrong — that's a wash, not a
    // state fill), same as every other keyboard/click-active row in this repo
    // (AppNavbar, AiMenu, CanvasViewNav, …).
    background: (el, s)=>$c6c628160194c80a$var$_isKeyboardActive(s) ? 'selected' : undefined,
    // The house pointer wash (a raw `gray.05` never flipped for the dark
    // sheet) and the press step.
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    // A keyboard reaches this link: the inset ring the command rows of the same list wear (the row sits inside
    // a scroll box, where an outer ring is clipped) — dropdowns spec §5 / D1.
    ':focus-visible': {
        shadow: 'focusRingInset'
    },
    href: (el, s)=>s._href || '#',
    // The row's words are its two child nodes (ResultTitle, ResultSubtitle),
    // so it has no text of its own, and says so. `Link` is a BARE key: it
    // resolves through the linked libraries too, and system/default's `Link`
    // carries the demo text "Link", which every result row painted before its
    // title (dev, system/hq, 2026-10-28). `text: null` cancels an inherited
    // text — the shared markdown renderer's rule (25f0dcec5).
    text: null,
    // Read back inside onContextmenu (below) instead of trusting a second,
    // later read of the reactive `s._title` — see that handler's comment.
    // Same declarative-attribute idiom HeaderTab uses for `data-tab-path`.
    attr: {
        'data-result-title': (el, s)=>s._title || '',
        'aria-selected': (el, s)=>String($c6c628160194c80a$var$_isKeyboardActive(s))
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('navigateSearchResult', s._href);
    },
    // Right-click → Pin to navbar / Unpin (rows + dispatch in
    // functions/navSearchResultMenu.js — same house ContextDropdown contract
    // as HeaderTab/SearchAppTile's own context menus). 2026-08-02 per Nika.
    // stopPropagation so this never falls through to an ancestor's own
    // onContextmenu (none today, but matches the sibling menus' convention).
    //
    // Identity is read off the RENDERED DOM NODE (native `href` attribute +
    // the `data-result-title` companion above), NOT the reactive `s` state —
    // live-verified 2026-08-02: `s._href`/`s._title` arrived empty inside this
    // handler on a real right-click even though the SAME row's `href:`/`text:`
    // factories had rendered correctly moments earlier (globalSearch's own
    // debounced round-trip can still be in flight when a menu opens and
    // resolve afterward, rewriting the live search state the reactive `s` this
    // handler receives is bound to — see globalSearch.js's _navSearchMenuOpen
    // guard, which stops it from clobbering the ROWS but doesn't change how
    // an individual row's captured `s` behaves for this handler on the SAME
    // tick). DOM attributes were already committed by the render that put this
    // exact node under the cursor, so they can't go stale within the event —
    // `s._href`/`s._title` stay as a defensive fallback only.
    onContextmenu: (e, el, s)=>{
        const node = el.node;
        const path = node && node.getAttribute('href') || s._href;
        const title = node && node.getAttribute('data-result-title') || s._title;
        if (!path || path === '#') return;
        // A title that is a bundle KEY (an app tile, a fallback label) pins as its KEY plus the resolved text, so the
        // navbar tab re-resolves on a language switch (shared navbarTabMenu.js `labelKey`, 301c03021); a title named
        // by data (a ticket, a file, a person) resolves to itself and pins as its own name, with no key.
        const resolved = el.call('polyglot', title || '');
        const labelKey = title && resolved && resolved !== title ? title : '';
        const pin = labelKey ? {
            path: path,
            label: resolved,
            labelKey: labelKey
        } : {
            path: path,
            label: title
        };
        e.preventDefault();
        e.stopPropagation();
        s.root.update({
            contextDropdown: {
                open: true,
                x: e.clientX,
                y: e.clientY,
                itemsFn: 'navSearchResultMenuItems',
                actionFn: 'navSearchResultMenuAction',
                // Read by HeaderSearch's onBlur (shared/components/HeaderSearch.js)
                // and IntranetAppHeader's own Input.onBlur to keep the search
                // dropdown open while THIS menu is up — see those files' comments.
                fromNavSearch: true,
                searchResult: pin
            }
        }, {
            preventFetch: true
        });
    },
    // The result's NAME — primary text, never cut (overflow law,
    // HOME_AMBIENT_SKIN_SPEC §3b rule 8): it wraps, a long unbroken word breaks
    // anywhere, and the subtitle keeps its place beside it.
    ResultTitle: {
        flex: '1',
        minWidth: '0',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'title',
        overflowWrap: 'anywhere',
        // KEY-IN-STATE — functions/search/globalSearch.js's row builders are
        // plain (root, ql) helpers with no element to resolve through, so their
        // FALLBACK labels travel as bundle keys and land here. A real document /
        // file / ticket name passes through polyglot untranslated.
        text: (el, s)=>el.call('polyglot', s._title || '')
    },
    // Secondary meta: one line, the whole subtitle on hover (rule 8).
    ResultSubtitle: {
        fontSize: 'Y2',
        color: 'caption',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'F',
        title: (el, s)=>el.call('polyglot', s._subtitle || ''),
        text: (el, s)=>el.call('polyglot', s._subtitle || ''),
        hide: (el, s)=>!s._subtitle
    }
};
const $c6c628160194c80a$export$8e78ac7e2288ec8b = {
    extends: 'AppListItem',
    subscribeTo: [
        '_navSearchActiveIndex'
    ],
    background: (el, s)=>$c6c628160194c80a$var$_isKeyboardActive(s) ? 'selected' : 'transparent',
    attr: {
        'aria-selected': (el, s)=>String($c6c628160194c80a$var$_isKeyboardActive(s))
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('navigateSearchApp', s.route);
    }
};
const $c6c628160194c80a$export$f15edf0c07c866a7 = {
    extends: 'ShortcutsSheetRow',
    tag: 'button',
    type: 'button',
    width: '100%',
    align: 'center left',
    gap: 'Z',
    padding: 'Y1 A',
    round: 'radiusControl',
    borderWidth: '0',
    color: 'title',
    textAlign: 'left',
    cursor: 'pointer',
    subscribeTo: [
        '_navSearchActiveIndex'
    ],
    background: (el, s)=>$c6c628160194c80a$var$_isKeyboardActive(s) ? 'selected' : 'transparent',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    // The inset ring (MenuPanelItem's reason): the results panel scrolls, and
    // an outer spread would be clipped at its edge.
    ':focus-visible': {
        shadow: 'focusRingInset'
    },
    '&:hover [data-keycap]': {
        background: 'raised',
        color: 'title',
        boxShadow: 'var(--shadow-float)'
    },
    '&[aria-selected="true"] [data-keycap]': {
        background: 'raised',
        color: 'title',
        boxShadow: 'var(--shadow-float)'
    },
    ariaKeyshortcuts: (el, s)=>s.ariaKeys || null,
    attr: {
        'aria-selected': (el, s)=>String($c6c628160194c80a$var$_isKeyboardActive(s))
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('runSearchCommand', s._shortcutId);
    },
    // What the command does — primary text, wraps (overflow law rule 8), at
    // the search rows' size.
    ShortcutsRowLabel: {
        flex: '1',
        fontSize: 'Z2',
        overflowWrap: 'anywhere'
    },
    // Its group — secondary meta: one line, the whole of it on hover.
    CommandGroup: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'F',
        title: (el, s)=>el.call('polyglot', s.group || ''),
        text: (el, s)=>el.call('polyglot', s.group || ''),
        hide: (el, s)=>!s.group
    },
    ShortcutsRowKeys: {
        order: '1',
        ariaHidden: 'true'
    }
};
const $c6c628160194c80a$export$13248b58191d5ecf = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    width: '100%',
    align: 'center left',
    gap: 'Z',
    padding: 'Y1 A',
    round: 'radiusControl',
    borderWidth: '0',
    color: 'title',
    textAlign: 'left',
    cursor: 'pointer',
    subscribeTo: [
        '_navSearchActiveIndex'
    ],
    background: (el, s)=>$c6c628160194c80a$var$_isKeyboardActive(s) ? 'selected' : 'transparent',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    // The inset ring: the results panel scrolls, and an outer spread would be
    // clipped at its edge.
    ':focus-visible': {
        shadow: 'focusRingInset'
    },
    // Which lists a value spans ("Bills 1 · Invoices 1") — only on a value that
    // spans two or more (searchAppRecordResults.js facetSpanHint): the hover
    // tooltip, and the same words as the accessible description.
    title: (el, s)=>s._hint || undefined,
    attr: {
        'aria-selected': (el, s)=>String($c6c628160194c80a$var$_isKeyboardActive(s)),
        'aria-description': (el, s)=>s._hint || undefined
    },
    // The press must not take focus from the search field: a chip or a clear
    // keeps the palette open, and a blur ends the search 200 ms later
    // (HeaderSearch onBlur) — live on dev ec09e4e87 (2026-10-07) a real click
    // on "Customer · Pinecrest Custody" closed the palette and added no chip.
    // The launcher's own filter line does the same (SearchAppsMenu SamFilter).
    onMousedown: (e)=>{
        e.preventDefault();
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('runSearchAction', s._searchAction);
    },
    Icon: {
        name: (el, s)=>s._icon || 'search',
        boxSize: 'Z2 Z2',
        flexShrink: '0',
        color: 'caption'
    },
    ActionLabel: {
        tag: 'span',
        flex: '1',
        minWidth: '0',
        fontSize: 'Z2',
        fontWeight: '500',
        overflowWrap: 'anywhere',
        text: (el, s)=>el.call('navSearchRowText', s._title, s._titleKey, s._titleParams)
    },
    ActionMeta: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Y2',
        color: 'caption',
        whiteSpace: 'nowrap',
        text: (el, s)=>el.call('navSearchRowText', s._meta, s._metaKey, s._metaParams),
        hide: (el, s)=>!s._meta && !s._metaKey
    }
};

});

parcelRegister("6duEr", function(module, exports) {

$parcel$export(module.exports, "IntranetAppHeader", () => $486bbba8628767f0$export$53f67462767adfc9);

var $4CrGc = parcelRequire("4CrGc");

var $1X0Je = parcelRequire("1X0Je");

var $7iFOV = parcelRequire("7iFOV");
const $486bbba8628767f0$var$shellCheckActiveMember = (...args)=>(0, $1X0Je.default).functions.checkActiveMember(...args);
const $486bbba8628767f0$var$isIntranetRoute = (...args)=>(0, $1X0Je.default).functions.isIntranetRoute(...args);
// Local page-title map for all /tickets/* (and other) routes that
// IntranetAppHeader must label correctly. Mirrors the TITLES map in
// editor/packages/shared/components/AppHeader.js — kept here so the
// intranet bundle is self-sufficient regardless of how Parcel resolves
// the shared AppHeader at build time.
const $486bbba8628767f0$var$INTRANET_TITLES = {
    '/calendar': 'workspace.pageTitle.calendar',
    '/chat': 'workspace.pageTitle.chat',
    // Canonical /tasks keys + legacy /tickets aliases (tickets→tasks rename
    // 2026-08-06 per Nika) — alias URLs stay reachable, so both key sets label.
    '/tasks': 'workspace.pageTitle.myView',
    '/tasks/my': 'workspace.pageTitle.myView',
    '/tasks/general': 'workspace.pageTitle.general',
    '/tasks/feed': 'workspace.pageTitle.feed',
    '/tasks/canvas': 'workspace.pageTitle.canvas',
    '/tasks/stories': 'workspace.pageTitle.stories',
    '/tasks/epics': 'workspace.pageTitle.epics',
    '/tasks/board': 'workspace.pageTitle.board',
    '/tasks/standups': 'workspace.pageTitle.standups',
    '/tasks/release': 'workspace.pageTitle.release',
    '/tasks/roadmap': 'workspace.pageTitle.roadmap',
    '/tickets': 'workspace.pageTitle.myView',
    '/tickets/my': 'workspace.pageTitle.myView',
    '/tickets/general': 'workspace.pageTitle.general',
    '/tickets/feed': 'workspace.pageTitle.feed',
    '/tickets/canvas': 'workspace.pageTitle.canvas',
    '/tickets/stories': 'workspace.pageTitle.stories',
    '/tickets/epics': 'workspace.pageTitle.epics',
    '/tickets/board': 'workspace.pageTitle.board',
    '/tickets/standups': 'workspace.pageTitle.standups',
    '/tickets/requests': 'workspace.pageTitle.requests',
    '/tickets/requests/inbound': 'workspace.pageTitle.inbound',
    '/tickets/requests/outbound': 'workspace.pageTitle.outbound',
    '/tickets/requests/audit': 'workspace.pageTitle.audit',
    '/tickets/resolutions': 'workspace.pageTitle.resolutions',
    '/tickets/release': 'workspace.pageTitle.release',
    '/tickets/roadmap': 'workspace.pageTitle.roadmap',
    '/meet': 'workspace.pageTitle.meet',
    '/system-status': 'workspace.pageTitle.systemHealth'
};
const $486bbba8628767f0$var$INTRANET_PREFIX_TITLES = [
    [
        '/tickets/requests',
        'workspace.pageTitle.requests'
    ],
    [
        '/tickets/resolutions',
        'workspace.pageTitle.resolutions'
    ],
    [
        '/tasks',
        'workspace.pageTitle.tasks'
    ],
    [
        '/task/',
        'workspace.pageTitle.tasks'
    ],
    [
        '/tickets',
        'workspace.pageTitle.tasks'
    ],
    [
        '/meet/',
        'workspace.pageTitle.call'
    ],
    [
        '/notes/',
        'workspace.pageTitle.notes'
    ],
    [
        '/notes',
        'workspace.pageTitle.notes'
    ],
    // Legacy alias — documents→notes rename (2026-08-06 per Nika); '/documents'
    // stays reachable so a stale deep link still titles correctly.
    [
        '/documents/',
        'workspace.pageTitle.notes'
    ],
    [
        '/documents',
        'workspace.pageTitle.notes'
    ],
    [
        '/workspaces',
        'workspace.pageTitle.workspaces'
    ],
    [
        '/admin',
        'workspace.pageTitle.admin'
    ]
];
// Every entry of the two tables above is a bundle KEY; this is the one place
// they are resolved, so the header title follows a language switch through the
// element's own reactive effect.
const $486bbba8628767f0$var$intranetPageTitle = (el, path)=>{
    path = (0, $7iFOV.shellStripWorkspacePrefix)(path);
    if (!path) return '';
    if ($486bbba8628767f0$var$INTRANET_TITLES[path]) return el.call('polyglot', $486bbba8628767f0$var$INTRANET_TITLES[path]);
    if (path.startsWith('/meet/') && path.endsWith('/transcript')) return el.call('polyglot', 'workspace.pageTitle.transcript');
    for (const [prefix, label] of $486bbba8628767f0$var$INTRANET_PREFIX_TITLES){
        if (path.startsWith(prefix)) return el.call('polyglot', label);
    }
    return el.call('polyglot', 'workspace.pageTitle.canvas');
};
// The rail rows carry bundle KEYS; `AppNavLink` lives in the shared package
// and renders `s.label` verbatim, so the labels are resolved where the list
// is PRODUCED (below) rather than at that render site.
const $486bbba8628767f0$var$NAV_LINKS = [
    {
        label: 'workspace.nav.main',
        href: '/'
    },
    {
        label: 'workspace.nav.teamMembers',
        href: '/team-members'
    },
    // Contacts moved to the system/crm-app marketplace module (correct
    // Manifest v2 shape — see /add-app) — no longer a local nav pill.
    {
        label: 'workspace.nav.my',
        href: '/my'
    },
    {
        label: 'workspace.nav.announcements',
        href: '/announcements'
    },
    {
        label: 'workspace.nav.company',
        href: '/company'
    }
];
const $486bbba8628767f0$var$totalUnread = (root)=>{
    if (!root) return 0;
    const me = root.currentUserEmail;
    const members = root.channelMembers || [];
    let total = 0;
    for (const mm of members){
        if (mm.member_email !== me) continue;
        const msgs = root.messagesByChannel?.[mm.channel_id] || [];
        total += (0, $4CrGc.unreadCount)(msgs, mm.last_read_at, me);
    }
    return total;
};
const $486bbba8628767f0$export$53f67462767adfc9 = {
    extends: 'AppHeader',
    onRender: (el, s)=>{
        if (!el._notifInit && s.root?.currentUserEmail) {
            el._notifInit = true;
            el.call('requestBrowserPermission');
            el.call('subscribeNotifications');
            el.call('fetchNotifications');
        }
    },
    // Global Cmd+K / Ctrl+K handler. Registered once on first render so it
    // persists across SPA route changes and covers every workspace page.
    // On /chat the chat page owns searchOpen; on all other routes we focus
    // the SearchBar input that lives in the header.
    // Cmd/Ctrl+K focuses the header SearchBar. CAPTURE phase, so the header wins
    // the shortcut before a page-level handler can take it.
    //
    // This was an `onCreate` that stamped `el._cmdKHandler` and called
    // `document.addEventListener('keydown', …, true)` behind an `el._cmdKBound`
    // latch, undone by an `onRemove`. The latch is the tell: `onCreate` CAN fire
    // twice on one element, and without it the second pass would have added a
    // second capture listener and orphaned the first. Declared, the framework
    // registers exactly once and disposes it — the latch is unnecessary (FA503).
    onDocumentKeydown: {
        capture: true,
        handler: (ev, el, s)=>{
            if (!(ev.metaKey || ev.ctrlKey) || ev.key.toLowerCase() !== 'k') return;
            // A shell layer above the page (shared functions/shellOverlayOpen.js —
            // a dialog, a menu, the assistant's main thread) owns the shortcut: this
            // capture handler would focus a search nobody sees and spend the key.
            if (typeof el.context?.functions?.shellOverlayOpen === 'function' && el.call('shellOverlayOpen')) return;
            const root = s.root;
            if (!root) return;
            // Agent mode's frame takes ⌘K for its own palette (WS-AGENT-MODE-1).
            if (root.agentMode === true || root._agentModeLink === true) return;
            const path = (0, $7iFOV.shellStripWorkspacePrefix)(root.currentPath || root.route || '/');
            // /chat owns its own search panel; let the chat page handle it.
            if (path === '/chat') return;
            ev.preventDefault();
            // Focus the global SearchBar input in the header.
            const inp = el.node && el.node.querySelector('[data-key="SearchBar"] input, [data-key="SearchBar"] [contenteditable]');
            if (inp) {
                inp.focus();
                inp.select?.();
                return;
            }
            // Fallback: open the nav search via root state.
            root.update({
                _navSearchOpen: true,
                navSearchQuery: ''
            });
        }
    },
    // Recompute chat unread only when the underlying data changed — otherwise
    // every unrelated root update would loop through all memberships.
    onUpdate: (el, s)=>{
        const root = s.root;
        const members = root.channelMembers;
        const msgs = root.messagesByChannel;
        if (el._lastMembers === members && el._lastMsgs === msgs) return;
        el._lastMembers = members;
        el._lastMsgs = msgs;
        const next = $486bbba8628767f0$var$totalUnread(root);
        const cur = root.navUnreadCounts?.chat || 0;
        if (next !== cur) root.update({
            navUnreadCounts: {
                ...root.navUnreadCounts || {},
                chat: next
            }
        });
    },
    // Override the shared AppHeader PageTitle so the intranet bundle resolves
    // the correct sub-page label from its own TITLES map rather than the
    // shared one (which may not reflect the latest keys when Parcel caches
    // an older build of AppHeader.js). All /tickets/* routes that were
    // previously falling through to the PREFIX_TITLES catch-all are handled
    // by INTRANET_TITLES above.
    PageTitle: {
        text: (el, s)=>$486bbba8628767f0$var$intranetPageTitle(el, s.root?.currentPath || s.root?.route || '')
    },
    Links: {
        hide: (el, s)=>!$486bbba8628767f0$var$shellCheckActiveMember(el) || !$486bbba8628767f0$var$isIntranetRoute(s),
        role: 'navigation',
        'aria-label': (el)=>el.call('polyglot', 'workspace.header.primaryNav'),
        theme: 'dialog',
        round: 'radiusPill',
        flow: 'x',
        gap: 'X',
        padding: 'X',
        align: 'center center',
        margin: '- auto',
        // Overflow/truncation source (P3 clip): a bounded-width ancestor (a
        // catalog cell, a narrow viewport) let this 5-pill row overflow its own
        // box and get cut off by that ancestor's `overflow:hidden` — nothing
        // here previously bounded the row's own width. Reuses the EXACT already-
        // shipped recipe for this same "row of nav pills in a header might not
        // fit" problem: HeaderTabs.Tabs (shared/components/HeaderTabs.js,
        // 2026-08-07 per Nika "instead of ... on each item, just show them and
        // fade away with shadow whats not fitting"). Scrolls instead of clipping;
        // scrollbar chrome suppressed (InstallableRail idiom); the cut-off edge
        // fades via mask instead of a hard crop.
        minWidth: '0',
        maxWidth: '100%',
        flexShrink: '1',
        overflowX: 'auto',
        overflowY: 'hidden',
        overscrollBehaviorX: 'contain',
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': {
            display: 'none'
        },
        maskImage: 'linear-gradient(to right, transparent, black calc(var(--spacing-V)), black calc(100% - var(--spacing-V)), transparent)',
        childExtends: 'AppNavLink',
        childrenAs: 'state',
        children: (el)=>$486bbba8628767f0$var$NAV_LINKS.map((n)=>({
                    ...n,
                    label: el.call('polyglot', n.label)
                }))
    },
    SearchBar: {
        hide: (el, s)=>!$486bbba8628767f0$var$shellCheckActiveMember(el) || $486bbba8628767f0$var$isIntranetRoute(s),
        Form: {
            Input: {
                placeholder: (el)=>el.call('polyglot', 'workspace.nav.searchPlaceholder'),
                onInput: (e, el)=>el.call('globalSearch', e.target.value),
                // Close on blur — same ~200ms grace + context-menu guard as the
                // canvas-header SearchBar input (shared/components/HeaderSearch.js
                // onBlur, the OTHER NavSearchResultGroup mount point): a
                // right-clicked result's "Pin to navbar" menu (NavSearchResultItem.
                // onContextmenu, opened with `fromNavSearch: true`) blurs this input
                // by design — the house ContextDropdown is a global portal, never a
                // descendant of this pill, so it can't be caught by a `contains`
                // check. Skip the close while it's up; resume the instant it closes
                // (Escape / outside click / the Pin action all null out
                // `contextDropdown` — nothing to separately track here either).
                onBlur: (e, el)=>{
                    const pill = el.parent?.parent;
                    setTimeout(()=>{
                        if (pill?.node && pill.node.contains(document.activeElement)) return;
                        const dd = el.state?.root?.contextDropdown;
                        if (dd && dd.open && dd.fromNavSearch) return;
                        el.call('closeNavSearch');
                    }, 200);
                },
                onKeydown: (e, el)=>{
                    if (e.key === 'Escape') {
                        el.call('closeNavSearch');
                        el.node.blur();
                    }
                }
            }
        },
        Dropdown: {
            // Explicit state gate — matches HeaderSearch.js's own Dropdown exactly
            // (the base Dropdown's `:focus-within` reveal, inherited via SearchBar
            // → DropdownParentFocus, is the wrong gate for a QUERY-driven panel:
            // focus ≠ has results, and it can never survive focus moving to the
            // "Pin to navbar" context menu — a portal outside this pill's subtree —
            // the way this flag does).
            subscribeTo: [
                '_navSearchOpen'
            ],
            hide: (el, s)=>!s.root?._navSearchOpen,
            opacity: '1',
            visibility: 'visible',
            transform: 'translate3d(0,0,0)',
            ResultGroups: {
                flow: 'y',
                if: (el, s)=>!!s.root?._navSearchGrouped?.length,
                children: (el, s)=>s.root?._navSearchGrouped || [],
                childExtends: 'NavSearchResultGroup',
                childrenAs: 'state'
            }
        }
    },
    // Shared AppHeader now groups the right cluster (AppOrgSwitcher,
    // OnlineMembers, MeWrapper) into the HeaderRight glass island — intranet
    // gates that whole island on membership and customises the avatar menu.
    // Re-pathed from the old `UserActions` slot to `HeaderRight` for the
    // 2026-06-08 glass-island grouping (the AppHeader flatten had left this
    // override targeting the now-removed `UserActions`, so the Admin item +
    // membership gate had silently stopped applying).
    HeaderRight: {
        hide: (el)=>!$486bbba8628767f0$var$shellCheckActiveMember(el)
    }
};

});

parcelRegister("5jkyk", function(module, exports) {

$parcel$export(module.exports, "ContentPage", () => $3ddeab695788c2e1$export$4b236baf42ce0734);
$parcel$export(module.exports, "ContentPageSectionLink", () => $3ddeab695788c2e1$export$7c310db2033cd93b);
// ContentPage — the account/company page skeleton, on the SAME parts the
// documents pages use (2026-09-02 per Nika "fix ui of /profile page. it
// should match all other pageslots (take settings and notes as example).
// make all layouts pages consistent"):
//   • rail   = AppSidebar (the docs DocsSidebar base): width G, Z/X2 inset,
//              a CommonCard Middle holding SidebarRow links — the notes rail.
//   • main   = AppMain: a sticky PageHeader (title + eyebrow, actions slot)
//              over a scrolling Body with the docs' 'B C' inset.
// Before: its own skeleton — a D C outer inset (72/44px), a sticky 305px
// rail with eyebrow / h1 / hairline / pill links, no header bar — so the
// profile sheet sat beside the notes sheet as a different language.
// Consumers (profile, my, company) mount their content at
// `PageMain.Body.PageBody`; `eyebrow` / `title` / `sections` stay page props.
const $3ddeab695788c2e1$export$4b236baf42ce0734 = {
    extends: 'Page',
    flow: 'x',
    align: 'stretch',
    gap: '0',
    padding: '0',
    margin: '0',
    width: '100%',
    height: '100%',
    minHeight: '0',
    minWidth: '0',
    maxWidth: 'none',
    boxSizing: 'border-box',
    overflow: 'hidden',
    '@mobileL': {
        flow: 'y',
        overflowX: 'clip'
    },
    // The pane twin. This page extends `Page`, not `AppPage`, so the shared
    // shell's `@appMobile` posture never reached it: in a 715px pane the rail
    // took AppSidebar's stacked width (100%) while this row stayed a row, and
    // PageMain collapsed to 0px past the pane's right edge — /my showed its
    // section list and nothing else (measured live 2026-09-22;
    // __tests__/contentPagePanePosture.test.js).
    '@appMobile': {
        flow: 'y',
        overflowX: 'clip'
    },
    PageRail: {
        extends: 'AppSidebar',
        tag: 'nav',
        // On the page-sidebar rule (shared functions/pageSidebar.js) for every
        // content page (/my, /company, /profile): opposite a rail navbar,
        // hideable per page.
        pageSidebar: true,
        ViewSwitcher: null,
        Top: null,
        PeopleSection: null,
        // The section links — one CommonCard (AppSidebar's childExtends), the
        // notes rail's Middle. Rows are per-section child STATES. They start at
        // the card's top: the head band keeps the hide button off the first link.
        Middle: {
            'data-sidebar-band': 'true',
            SectionNav: {
                flow: 'y',
                gap: 'V',
                padding: 'X2',
                '@mobileL': {
                    flow: 'x',
                    overflowX: 'auto'
                },
                '@appMobile': {
                    flow: 'x',
                    overflowX: 'auto'
                },
                childExtends: 'ContentPageSectionLink',
                childrenAs: 'state',
                children: (el, s)=>{
                    // SectionNav → Middle → PageRail → the page
                    const page = el.parent?.parent?.parent;
                    if (!page) return [];
                    const sections = page.sections;
                    const list = typeof sections === 'function' ? sections(el, s) : sections || [];
                    // `__i` only — the row decides ACTIVE itself, from the root key, on
                    // its `aria-current` factory (the one channel that re-runs here; the
                    // paint hangs off that attribute in the shell sheet). A flag stamped
                    // at create would be frozen: nothing re-renders these rows, and a
                    // `subscribeTo` on this list did not change that (measured live).
                    return list.map((sec, i)=>({
                            ...sec,
                            __i: i
                        }));
                }
            }
        }
    },
    PageMain: {
        extends: 'AppMain',
        Header: {
            extends: 'PageHeader',
            LeftGroup: {
                flow: 'y',
                gap: 'V',
                align: 'flex-start left',
                // The notes header's title/count pair: the page title, and the eyebrow
                // ("Account") as the caption line under it. The title is the page's
                // one `h1` at its dedicated URL and an `h2` under a pane bar
                // (design-direction.md §3) — it was a literal `h2`, so /my, /company
                // and /profile had no `h1` at all.
                Title: {
                    tag: (el, s)=>el.call('pageTitleTag', s) || 'h1',
                    margin: '0',
                    fontSize: 'C',
                    fontWeight: '700',
                    color: 'title',
                    // Title → LeftGroup → Header → PageMain → the page (the one
                    // `title`-as-content read this package keeps — I18N-CONVENTION §1.2).
                    text: (el)=>el.parent.parent.parent.parent.title || ''
                },
                Eyebrow: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    hide: (el)=>!el.parent.parent.parent.parent.eyebrow,
                    text: (el)=>el.parent.parent.parent.parent.eyebrow || ''
                }
            },
            RightGroup: {}
        },
        Body: {
            padding: 'B C',
            overflow: 'auto',
            '@mobileL': {
                padding: 'A'
            },
            '@appMobile': {
                padding: 'A'
            },
            PageBody: {
                flow: 'y',
                minWidth: '0',
                maxWidth: '100%'
            }
        }
    }
};
const $3ddeab695788c2e1$export$7c310db2033cd93b = {
    extends: 'SidebarRow',
    fontWeight: '700',
    // ACTIVE STATE TRAVELS ON THE ATTRIBUTE, THE PAINT LIVES IN THE SHELL SHEET.
    // Measured live 2026-09-02 on /w/natali/…/profile: on these
    // `childrenAs: 'state'` rows every STYLE channel is frozen at create — an
    // `isActive` conditional class never re-attached, `background`/`color`
    // prop factories never re-ran, `subscribeTo: ['contentSection']` on the row
    // AND on the list changed nothing (root.contentSection reads correctly the
    // whole time, and the row nodes are never replaced). The `aria-current`
    // ATTRIBUTE on the same element followed every single click. A component-
    // level `&[aria-current="true"]` selector block did not paint either — an
    // atomic class beat it even at higher specificity — so the rule lives in
    // the shell's injected stylesheet (app.js), the same reacts-in-CSS idiom as
    // `html[data-chat-drawer="open"] …`, which does outrank atomic classes.
    'aria-current': (el, s)=>{
        const current = s.root?.contentSection || null;
        const active = current ? current === (s.sectionKey || s.label || null) : s.__i === 0;
        return active ? 'true' : undefined;
    },
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    '@mobileL': {
        flex: '0 0 auto',
        whiteSpace: 'nowrap'
    },
    Icon: {
        hide: (el, s)=>!s.icon,
        icon: (el, s)=>s.icon || 'state'
    },
    Label: {
        text: (el, s)=>s.label || ''
    },
    MoreBtn: null,
    onClick: (e, el, s)=>{
        e.preventDefault();
        s.root.update({
            contentSection: s.sectionKey || s.label
        });
        setTimeout(()=>{
            try {
                const target = document.querySelector(`[data-content-section="${(s.sectionKey || s.label || '').replace(/"/g, '\\"')}"]`);
                if (!target) return;
                // Skip scroll when the target section is hidden (display:none sets
                // offsetHeight to 0). This happens when a section is conditionally
                // excluded for the current user (e.g. Availability for non-members).
                if (!target.offsetHeight) return;
                let scroller = target.parentElement;
                while(scroller){
                    const cs = getComputedStyle(scroller);
                    if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && scroller.scrollHeight > scroller.clientHeight + 5) break;
                    scroller = scroller.parentElement;
                }
                if (scroller) {
                    const offset = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
                    scroller.scrollTop = scroller.scrollTop + offset - 16;
                } else target.scrollIntoView({
                    block: 'start'
                });
            } catch  {}
        }, 0);
    }
};

});

parcelRegister("4UOvu", function(module, exports) {

$parcel$export(module.exports, "FlagSwitch", () => $3943920084411224$export$7e70ce7d6be27a89);
$parcel$export(module.exports, "FlagAlwaysOnPill", () => $3943920084411224$export$20160921af077ec3);
$parcel$export(module.exports, "FlagDisclosure", () => $3943920084411224$export$5b63853feb58c47b);
$parcel$export(module.exports, "SubFlagRow", () => $3943920084411224$export$bedd233f0d91fdb9);
$parcel$export(module.exports, "FlagRow", () => $3943920084411224$export$7c3a3d2417d12c4f);
$parcel$export(module.exports, "FlagGroupSection", () => $3943920084411224$export$e1285edcc39cae);
// Settings-row + iOS-style switch primitives for the /flags page.
// Rows are fed as `childrenAs: 'state'` from the FEATURE_FLAGS registry,
// so `s.key/label/description/core/subs` is the flag def. Rows with
// `subs` expand ("detail down") into an indented SubFlagRow list —
// expansion lives on root._flagsOpen (session-only). The switch reads
// and writes through featureEnabled/setFeatureFlag — overrides persist
// to localStorage and mirror onto root._featureFlags, which every
// factory below reads, so toggles repaint reactively. Core flags render
// an "Always on" pill; their SUBS stay toggleable (parent locked,
// details tunable). A sub's switch disables while its parent is off.

var $gOQVi = parcelRequire("gOQVi");
const $3943920084411224$var$_toggleOpen = (s)=>{
    if (!(s.subs && s.subs.length)) return;
    const root = s.root;
    if (!root) return;
    const cur = root._flagsOpen || {};
    root.update({
        _flagsOpen: {
            ...cur,
            [s.key]: !cur[s.key]
        }
    });
};
const $3943920084411224$export$7e70ce7d6be27a89 = {
    extends: 'SwitchInput',
    onCheck: (el, s)=>(0, $gOQVi.shellFeatureEnabled)(s.root, s.key),
    'aria-label': (el, s)=>el.call('polyglot', 'admin.flags.toggleAria').replace('{flag}', el.call('polyglot', s.label || s.key)),
    title: (el, s)=>el.call('polyglot', (0, $gOQVi.shellFeatureEnabled)(s.root, s.key) ? 'admin.flags.turnOff' : 'admin.flags.turnOn'),
    // Sub-switches sleep while the parent feature is off — the parent gate
    // already forces them off, so flipping one would be a silent no-show.
    disabled: (el, s)=>s.parentKey && !(0, $gOQVi.shellFeatureEnabled)(s.root, s.parentKey) ? true : undefined,
    onClick: (e, el, s)=>{
        // The switch never doubles as the disclosure: one press, one flip.
        // `el` rides along so setFeatureFlag reaches the SDK (el.sdk) and
        // persists the flip to workspace.settings.featureFlags in Mongo.
        e.preventDefault();
        e.stopPropagation();
        (0, $gOQVi.setFeatureFlag)(s.root, s.key, !(0, $gOQVi.shellFeatureEnabled)(s.root, s.key), el);
    }
};
const $3943920084411224$export$20160921af077ec3 = {
    extends: 'AppStatusChip',
    status: 'neutral',
    label: 'admin.flags.alwaysOn',
    Dot: null,
    flexShrink: '0',
    title: (el)=>el.call('polyglot', 'admin.flags.coreTitle')
};
const $3943920084411224$export$5b63853feb58c47b = {
    tag: 'button',
    type: 'button',
    'aria-expanded': (el, s)=>s.root?._flagsOpen?.[s.key] ? 'true' : 'false',
    'aria-label': (el, s)=>el.call('polyglot', 'admin.flags.disclosureAria').replace('{flag}', el.call('polyglot', s.label || s.key)),
    // The compact control (controlHCompact square): it measured 38.5px from
    // its padding, neither control height.
    display: 'inline-flex',
    align: 'center center',
    minWidth: 'controlHCompact',
    minHeight: 'controlHCompact',
    padding: '0',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    round: 'radiusControl',
    color: 'caption',
    flexShrink: '0',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        $3943920084411224$var$_toggleOpen(s);
    },
    Icon: {
        name: 'arrowAngleDown',
        boxSize: 'Z2 Z2',
        transition: 'Z defaultBezier transform',
        transform: (el, s)=>s.root?._flagsOpen?.[s.key] ? 'rotate(180deg)' : 'none'
    }
};
const $3943920084411224$export$bedd233f0d91fdb9 = {
    // Declared (as on FlagRow): the key is `<flag>.<sub>`, DATA.
    tag: 'div',
    flow: 'x',
    align: 'center space-between',
    gap: 'B',
    padding: 'Z1 0',
    // Row-separator-as-stroke, banned by design-direction.md §8 / DESIGN_
    // LANGUAGE §2.5 (mirrors SettingRow.js's identical fix) — each row's own
    // top+bottom `Z1` padding already spaces adjacent rows, so dropping the
    // line is geometry-preserving; the hover wash is the replacement cue.
    ':hover': {
        background: 'hover'
    },
    transition: 'Z defaultBezier background',
    Info: {
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        // One level under its row's h3.
        Name: {
            tag: 'h4',
            margin: '0',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>el.call('polyglot', s.label || s.key)
        },
        Desc: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            lineHeight: '1.45',
            text: (el, s)=>el.call('polyglot', s.description || '')
        }
    },
    FlagSwitch: {}
};
const $3943920084411224$export$7c3a3d2417d12c4f = {
    // Declared, never inferred: the row key is the FLAG key, and DOMQL renders a
    // key named after an HTML tag as that tag — the `search` flag was a <search>
    // landmark, the `data` flag a <data> element (render census, 2026-09-24).
    tag: 'div',
    flow: 'y',
    padding: 'A 0',
    // Row-separator-as-stroke, banned by design-direction.md §8 / DESIGN_
    // LANGUAGE §2.5 (mirrors SettingRow.js's identical fix) — each row's own
    // top+bottom `A` padding already spaces adjacent rows, so dropping the
    // line is geometry-preserving.
    //
    // The row line is NOT a click target. It toggled the sub list on click,
    // which a keyboard never reached — and on a row without subs (a core flag:
    // the Always-on chip, no switch, no disclosure) the handler did nothing at
    // all (live census, 2026-09-24: "Profile & account", a click target no
    // keyboard reaches). The disclosure button is the one way to open the subs.
    //
    // NOT `Main`: DOMQL renders a key named after an HTML tag AS that tag, so
    // the row's line was a <main> landmark — 33 of them on /admin/flags (live
    // census, 2026-09-24), each one a "main content" stop for a screen reader.
    Top: {
        flow: 'x',
        align: 'center space-between',
        gap: 'B',
        Info: {
            flow: 'y',
            gap: 'V',
            minWidth: '0',
            // Under the group's h2 — h3 (it was h4, a skipped level on every row).
            Name: {
                tag: 'h3',
                margin: '0',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>el.call('polyglot', s.label || s.key)
            },
            Desc: {
                tag: 'p',
                margin: '0',
                fontSize: 'Y2',
                color: 'caption',
                lineHeight: '1.45',
                text: (el, s)=>el.call('polyglot', s.description || '')
            }
        },
        Right: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            flexShrink: '0',
            SubCount: {
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                whiteSpace: 'nowrap',
                hide: (el, s)=>!(s.subs && s.subs.length),
                text: (el, s)=>{
                    const n = (s.subs || []).length;
                    return el.call('polyglot', n === 1 ? 'admin.flags.subCountOne' : 'admin.flags.subCount').replace('{count}', n);
                }
            },
            FlagAlwaysOnPill: {
                hide: (el, s)=>!s.core
            },
            FlagSwitch: {
                hide: (el, s)=>!!s.core
            },
            FlagDisclosure: {
                hide: (el, s)=>!(s.subs && s.subs.length)
            }
        }
    },
    // Sub-feature list — an inset plate inside the card reads as a level of
    // hierarchy. The neutral `widgetPlate` (it reads on a card; the `overlay`
    // wash it replaced composited to the card's own colour).
    SubList: {
        hide: (el, s)=>!(s.subs && s.subs.length) || !s.root?._flagsOpen?.[s.key],
        flow: 'y',
        marginTop: 'A',
        background: 'widgetPlate',
        round: 'radiusCard',
        padding: 'Y A2',
        childExtends: 'SubFlagRow',
        childrenAs: 'state',
        children: (el, s)=>(s.subs || []).map((sub)=>({
                    ...sub,
                    key: `${s.key}.${sub.key}`,
                    parentKey: s.key
                }))
    }
};
const $3943920084411224$export$e1285edcc39cae = {
    // Declared (as on FlagRow): the section key is the registry GROUP key.
    tag: 'div',
    flow: 'y',
    gap: 'A',
    Head: {
        flow: 'y',
        gap: 'V',
        // The section heading — one step under the page title (it was B1, larger
        // than the page's own h1).
        GroupTitle: {
            extends: 'AdminCardTitle',
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        GroupCaption: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', s.description || '')
        }
    },
    // The admin section card: the branded `card` step off the sheet —
    // CommonCard is the sheet's OWN fill (an invisible card).
    Card: {
        extends: 'AdminCard',
        gap: '0',
        padding: 'Y B',
        childExtends: 'FlagRow',
        childrenAs: 'state',
        children: (el, s)=>s.flags || []
    }
};

});

parcelRegister("hTYKj", function(module, exports) {

$parcel$export(module.exports, "SettingRow", () => $d086b199c4d8bce4$export$7b6897bc2abeabb0);
// The admin settings-row language — ONE row anatomy for every toggle /
// config surface (/admin/flags, dashboard-defaults, analytics, module
// panels, activity-scoring, teams permissions): name + optional
// sub-line on the left, the control cluster on the right, hairline
// dividers between rows inside a card. (2026-07-25 per Nika
// "/dashboard-defaults and /flags should have similar ui and all other
// toggled pages".)
//
// Text resolution: rows are usually fed as childrenAs:'state' — Name
// reads s.label (then s.title/el.label), Sub reads s.description (then
// el.description) and hides when empty. Consumers put controls in
// `Right` (SwitchInput, inputs, captions) and may override Name/Sub
// factories freely.
//
// Both strings go through polyglot, so a row may carry a bundle KEY in
// `label` / `description` (the KEY-IN-STATE form — /admin/dashboard-defaults
// and /admin/analytics feed the catalog that way). polyglot returns anything
// that is not a key verbatim, so a module's own declared widget name, a
// feature-flag registry label and a person's name all pass straight through
// untouched.
const $d086b199c4d8bce4$export$7b6897bc2abeabb0 = {
    flow: 'x',
    align: 'center space-between',
    gap: 'B',
    padding: 'A 0',
    // Was a `borderBottom: 'hairline solid line'` + `:last-child` clear —
    // row-separator-as-stroke, banned by design-direction.md §8 / DESIGN_
    // LANGUAGE §2.5 ("row separators inside rounded cards stay banned — gap +
    // hover tint instead"). Each row's own top+bottom `A` padding already
    // gives adjacent rows a full 2×A whitespace gap (flex padding never
    // collapses between siblings), so removing the line changes the geometry
    // not at all; the hover wash below is the fill-contrast replacement for
    // the boundary cue the border used to carry.
    transition: 'Z defaultBezier background',
    ':hover': {
        background: 'hover'
    },
    '@mobileL': {
        flexWrap: 'wrap',
        gap: 'Z'
    },
    Info: {
        flow: 'y',
        gap: 'V',
        minWidth: '0',
        flex: '1',
        Name: {
            tag: 'h4',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>el.call('polyglot', el.parent?.parent?.label || s.label || s.title || '')
        },
        Sub: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            color: 'caption',
            lineHeight: '1.45',
            hide: (el, s)=>!(el.parent?.parent?.description || s.description),
            text: (el, s)=>el.call('polyglot', el.parent?.parent?.description || s.description || '')
        }
    },
    Right: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        flexShrink: '0'
    }
};

});

parcelRegister("khfDK", function(module, exports) {

$parcel$export(module.exports, "AdminActionBtn", () => $ec3186f608a8e639$export$3d372290cc16a1e8);
$parcel$export(module.exports, "AdminActionBtnCompact", () => $ec3186f608a8e639$export$cfe877e9687e5f1d);
$parcel$export(module.exports, "AdminIconBtn", () => $ec3186f608a8e639$export$ca78365b0b0a14bf);
$parcel$export(module.exports, "AdminActionBtnDanger", () => $ec3186f608a8e639$export$6b9320df5abcaf70);
$parcel$export(module.exports, "AdminActionBtnPrimary", () => $ec3186f608a8e639$export$f67e73a25dd13deb);
$parcel$export(module.exports, "AdminCard", () => $ec3186f608a8e639$export$18fecf03fc6331dc);
$parcel$export(module.exports, "AdminCardTitle", () => $ec3186f608a8e639$export$1e7b0e231f64ab53);
$parcel$export(module.exports, "AdminCardDesc", () => $ec3186f608a8e639$export$4b93b0bab0933e4f);
// Shared admin controls — ONE button language and ONE section card across
// the admin area (2026-07-25 per Nika "check all buttons … fix the whole
// admin area"). Every admin page hand-rolled its own tag:'button' with the
// same padding/round/border/hover triple, and its own card; these recipes
// replace them (module.js's own ghost / primary buttons, card and tab were
// folded into these on 2026-09-24).
// The quiet secondary action. Rest = the `overlay` wash, hover = the house
// hover wash, press = the selected step, matching shared/AiActionConfirmCard
// .RejectBtn — the same "ONE button language" reasoning this file's own
// header comment already applies to spacing.
//
// DISABLED — the brand's one disabled law (brand-language skill, company
// 282deae): the real `disabled` attribute, `cursor: not-allowed` and the
// `field-disabled` pair (the `disabled` ink on the neutral disabled plate).
// Never opacity: `.5` dragged the label under 4.5:1 on both themes.
const $ec3186f608a8e639$export$3d372290cc16a1e8 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center',
    gap: 'V',
    minHeight: 'controlH',
    padding: '0 A',
    round: 'radiusPill',
    border: 'none',
    background: 'overlay',
    color: 'title',
    fontSize: 'Z2',
    fontWeight: '500',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'Z defaultBezier background',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    ':disabled': {
        theme: 'field-disabled'
    }
};
const $ec3186f608a8e639$export$cfe877e9687e5f1d = {
    extends: 'AdminActionBtn',
    minHeight: 'controlHCompact',
    padding: '0 Z1',
    fontSize: 'Z'
};
const $ec3186f608a8e639$export$ca78365b0b0a14bf = {
    extends: 'AdminActionBtnCompact',
    justifyContent: 'center',
    minWidth: 'controlHCompact',
    padding: '0',
    background: 'transparent',
    color: 'caption',
    ':hover': {
        background: 'hover',
        color: 'title'
    }
};
const $ec3186f608a8e639$export$6b9320df5abcaf70 = {
    extends: 'AdminActionBtnCompact',
    color: 'dangerInk'
};
const $ec3186f608a8e639$export$f67e73a25dd13deb = {
    extends: 'AdminActionBtn',
    theme: 'primary',
    background: null,
    color: null,
    fontWeight: '700',
    ':hover': {
        background: null
    },
    ':active': {
        background: null
    },
    ':disabled': {
        theme: 'field-disabled'
    }
};
const $ec3186f608a8e639$export$18fecf03fc6331dc = {
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'radiusCard',
    theme: 'card',
    // Admin content sits on an opaque AppMain sheet, not the ambient canvas.
    background: 'cardSolid',
    backdropFilter: 'none',
    minWidth: '0'
};
const $ec3186f608a8e639$export$1e7b0e231f64ab53 = {
    tag: 'h2',
    margin: '0',
    fontSize: 'A2',
    fontWeight: '700',
    color: 'title'
};
const $ec3186f608a8e639$export$4b93b0bab0933e4f = {
    tag: 'p',
    margin: '0',
    fontSize: 'Z2',
    color: 'caption'
};

});

parcelRegister("cWCor", function(module, exports) {

$parcel$export(module.exports, "PersonCard", () => $96c8aeef015b52fb$export$4c094c8f61edecb4);
$parcel$export(module.exports, "RoleManagerRow", () => $96c8aeef015b52fb$export$881ee33189e5d697);
$parcel$export(module.exports, "DocumentRow", () => $96c8aeef015b52fb$export$161a5fbbcd1ed67f);
$parcel$export(module.exports, "PeopleFilterLink", () => $96c8aeef015b52fb$export$9092f9bddf899731);
$parcel$export(module.exports, "CompanyInfoRow", () => $96c8aeef015b52fb$export$85b9fbf91bef48b4);
$parcel$export(module.exports, "PeopleGrid", () => $96c8aeef015b52fb$export$4ca250b27810017e);
$parcel$export(module.exports, "PeopleGroupBlock", () => $96c8aeef015b52fb$export$c9af2366c191bfef);
$parcel$export(module.exports, "PendingInviteCard", () => $96c8aeef015b52fb$export$c14d6292d7cbc9f8);
$parcel$export(module.exports, "PendingInvitesBlock", () => $96c8aeef015b52fb$export$ada374a594c66c02);
parcelRequire("8BRyL");
var $k3hwI = parcelRequire("k3hwI");

var $kg2OA = parcelRequire("kg2OA");
// UUID and Mongo-ObjectId detection — protects every PersonCard text
// factory from rendering raw IDs when `s.name` ends up unexpectedly
// holding a foreign-key value (incomplete row hydration, schema drift).
const $96c8aeef015b52fb$var$_idLike = (v)=>typeof v === 'string' && (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v) || /^[0-9a-f]{24}$/i.test(v));
const $96c8aeef015b52fb$var$_personLabel = (s)=>{
    const name = s?.name;
    if (name && !$96c8aeef015b52fb$var$_idLike(name)) return name;
    const username = s?.username;
    if (username && !$96c8aeef015b52fb$var$_idLike(username)) return username;
    const email = s?.email;
    if (email && typeof email === 'string') return email.split('@')[0];
    return null;
};
const $96c8aeef015b52fb$export$4c094c8f61edecb4 = {
    extends: 'Link',
    href: (el, s)=>`/profile?u=${encodeURIComponent(s.email || '')}`,
    flow: 'y',
    gap: 'B',
    padding: 'B',
    round: 'radiusSheet',
    // A card inside a sheet is the brand `card` (DESIGN_LANGUAGE §2.1): one
    // step off the pane. `common-box` IS the pane's own ground (dark gray2,
    // light white) and read 1.00:1 live (dev /team-members, 2026-10-02); the
    // `overlay` fill before it did the same. Hover still lifts with a shadow.
    // (__tests__/personCardSurfaceStep.test.js)
    theme: 'card',
    position: 'relative',
    overflow: 'hidden',
    // Browser-native viewport culling — /people PgGrid mounts every member card
    // unwindowed; `auto` skips painting off-screen cards and `contain-intrinsic-size`
    // holds a stable slot (last-known size, 160px fallback) so the grid + scrollbar
    // don't jump as cards scroll into view.
    contentVisibility: 'auto',
    containIntrinsicSize: 'auto 160px',
    cursor: 'pointer',
    textDecoration: 'none',
    color: 'title',
    ':hover': {
        shadow: 'float'
    },
    PcHeader: {
        flow: 'x',
        align: 'center',
        gap: 'A',
        marginTop: 'Z',
        // Built-in `Avatar` is `tag: 'img'` — void element, no children
        // allowed (PcOnlineDot can't nest), no `text` fallback. We need a
        // div-based avatar that hosts both the initials fallback AND the
        // online-dot overlay. Renders an inner <img> only when `s.avatar`
        // is a real URL (starts with http or /), otherwise falls back to
        // initials text on the colored background. This is the same shape
        // PersonPopoverCard's avatar uses.
        // House identity plate (§4.3 — permanent plates keep overlayStrong with
        // neutral ink; the WhCodeChip/ComAvatar/PicAvatar carve-out). The old
        // per-email hue plate stamped white ink on 7 brand hues — 5 of 7 failed
        // AA (1.55:1 on indigo, 2.18:1 on cerulean, measured 2026-08-08), and a
        // rainbow roster grid fights §4.4's one-hue law. colorFromEmail retired.
        // `theme: 'field'` at `glyphPlate`: the `overlayStrong` plate measured
        // 1.00:1 on the card (the initials floated), dev 2026-10-01.
        PcAvatar: {
            align: 'center center',
            boxSize: 'glyphPlate',
            minWidth: 'glyphPlate',
            round: '50%',
            color: 'title',
            fontSize: 'B',
            fontWeight: '700',
            position: 'relative',
            overflow: 'hidden',
            theme: 'field',
            // Image layer — MOUNTED only when `s.avatar` is a URL-like string:
            // `if:`, never `hide:` (display:none leaves the <img> fetching its
            // src, so non-URL values 404ed against the origin — fixed 2026-09-01,
            // same class as the IntranetRows plate). Guarded src as the belt.
            AvatarImg: {
                tag: 'img',
                if: (el, s)=>{
                    const v = s?.avatar;
                    return typeof v === 'string' && /^(https?:|\/)/.test(v);
                },
                position: 'absolute',
                inset: '0',
                width: '100%',
                height: '100%',
                src: (el, s)=>{
                    const v = s?.avatar;
                    return typeof v === 'string' && /^(https?:|\/)/.test(v) ? v : null;
                },
                alt: (el, s)=>$96c8aeef015b52fb$var$_personLabel(s) || el.call('polyglot', 'workspace.person.unknown'),
                style: {
                    objectFit: 'cover'
                }
            },
            // Initials fallback — visible only when AvatarImg is hidden.
            // _personLabel collapses to initials via the JSX-side helper
            // below, capped at 2 chars.
            Initials: {
                tag: 'span',
                hide: (el, s)=>{
                    const v = s?.avatar;
                    return typeof v === 'string' && /^(https?:|\/)/.test(v);
                },
                text: (el, s)=>{
                    const label = $96c8aeef015b52fb$var$_personLabel(s) || el.call('polyglot', 'workspace.person.unknown');
                    const parts = String(label).trim().split(/\s+/).filter(Boolean);
                    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
                    return String(label).slice(0, 2).toUpperCase();
                }
            },
            PcOnlineDot: {
                // O(1) lookup on the canonical per-id presenceById map (populated by
                // syncPresenceById) instead of an O(n) .some() scan of the broad
                // onlineUsers array per card — same "is this email present" semantics.
                if: (el, s)=>!!(s.root?.presenceById || {})[String(s.email || '').toLowerCase()],
                position: 'absolute',
                bottom: '0',
                right: '0',
                width: 'Z',
                height: 'Z',
                round: '50%',
                background: 'green',
                // KEPT — punched-out presence-dot ring. Retokenized `'2px'` →
                // `hairline2`.
                borderWidth: 'hairline2',
                borderStyle: 'solid',
                borderColor: 'overlay'
            }
        },
        PcName: {
            flow: 'y',
            gap: 'Y',
            flex: '1',
            // Title falls back through name → email username → 'Unknown'.
            // Previously `text: (el, s) => s.name` rendered raw UUID strings
            // for partially-hydrated rows (no `name`, only `userId`/`_id`).
            // Same chain in PcMail/PcPosition below — never expose raw IDs.
            PcTitle: {
                tag: 'span',
                fontSize: 'B',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>$96c8aeef015b52fb$var$_personLabel(s) || el.call('polyglot', 'workspace.person.unknown')
            },
            PcPosition: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                hide: (el, s)=>!s.position,
                text: (el, s)=>s.position || ''
            }
        }
    },
    PcDept: {
        tag: 'span',
        alignSelf: 'flex-start',
        padding: 'Y A',
        round: 'radiusCard',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'title',
        theme: 'dialog',
        border: 'none',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        text: (el, s)=>{
            // When the People page groups by team, `groupFilteredPeople`
            // stamps each card copy with `_groupTeamName` — the team of the
            // SECTION it's listed under. A multi-team member appears in
            // several sections, so the badge MUST reflect the section, not
            // the member's arbitrary primary team (which mislabelled e.g.
            // someone under "Class B" as "Class C"). `null` = the "No team"
            // section → "Member"; `undefined` = a non-team lens / other
            // consumer → fall back to the primary real team below.
            if (s._groupTeamName !== undefined) {
                const g = s._groupTeamName;
                return g && !$96c8aeef015b52fb$var$_idLike(g) ? g : el.call('polyglot', 'workspace.person.member');
            }
            // Org-scoped + deduped (teams.js personTeams), REAL teams only —
            // system permission groups (Admin / Members / …) are not teams;
            // without the filter every member's badge read "MEMBERS".
            const teams = (0, $kg2OA.personTeams)({
                userId: s.userId,
                email: s.email
            }, s.root).filter((t)=>!t.isSystem);
            const name = teams[0]?.name;
            return name && !$96c8aeef015b52fb$var$_idLike(name) ? name : el.call('polyglot', 'workspace.person.member');
        }
    },
    PcMeta: {
        flow: 'y',
        gap: 'Z',
        fontSize: 'Z2',
        color: 'paragraph',
        PcLoc: {
            tag: 'span',
            text: (el, s)=>`${s.location || "\u2014"}`
        },
        PcTz: {
            tag: 'span',
            color: 'caption',
            text: (el, s)=>s.timezone || ''
        },
        PcMail: {
            tag: 'span',
            color: 'caption',
            text: (el, s)=>s.email
        }
    },
    // Read-only role badge. Editing happens in the dedicated Role manager
    // panel on the People page (superadmin only).
    PcRole: {
        hide: (el)=>!el.call('isSuperAdmin'),
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        paddingTop: 'A',
        PcRoleLabel: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            text: '{{ workspace.person.role | polyglot }}'
        },
        // Role hue survives as a DOT, ink stays neutral — the RmDot pattern from
        // RoleManagerRow below. White ink on the server-driven role hue failed AA
        // for most hues (2.9:1 on green), and the hue set is user-configured so
        // no static ink pairing can be proven safe.
        PcRoleBadge: {
            tag: 'span',
            flow: 'x',
            align: 'center',
            gap: 'Y',
            padding: 'Y A',
            round: 'radiusPill',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'title',
            background: 'overlayStrong',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            PcRoleDot: {
                tag: 'span',
                width: 'Y',
                height: 'Y',
                round: '50%',
                flex: '0 0 auto',
                background: (el, s)=>(0, $k3hwI.roleColor)(s, (0, $k3hwI.roleOf)(s, s.userId) || 'member')
            },
            PcRoleText: {
                tag: 'span',
                // A system role resolves through the bundle; a tenant role keeps the
                // label its admin wrote (functions/roles.js roleLabelKey).
                text: (el, s)=>{
                    const role = (0, $k3hwI.roleOf)(s, s.userId) || 'member';
                    const key = (0, $k3hwI.roleLabelKey)(role);
                    return key ? el.call('polyglot', key) : (0, $k3hwI.roleLabel)(s, role);
                }
            }
        }
    }
};
const $96c8aeef015b52fb$export$881ee33189e5d697 = {
    flow: 'x',
    align: 'center space-between',
    gap: 'B',
    padding: 'Z A',
    round: 'radiusSheet',
    ':hover': {
        theme: 'dialog'
    },
    RmLeft: {
        flow: 'x',
        align: 'center',
        gap: 'A',
        flex: '1',
        minWidth: '0',
        RmDot: {
            width: 'Z',
            height: 'Z',
            round: '50%',
            flex: '0 0 auto',
            background: (el, s)=>(0, $k3hwI.roleColor)(s, (0, $k3hwI.roleOf)(s, s.userId) || 'member')
        },
        RmName: {
            flow: 'y',
            gap: 'Y',
            flex: '1',
            minWidth: '0',
            RmNameTitle: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>s.name
            },
            RmNameSub: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                text: (el, s)=>s.email
            }
        }
    },
    RmSelect: {
        tag: 'select',
        minHeight: 'controlH',
        padding: '0 A',
        round: 'radiusControl',
        theme: 'dialog',
        border: 'none',
        color: 'title',
        fontSize: 'Z2',
        fontWeight: '700',
        cursor: 'pointer',
        // Your own row: the server refuses an own-role write, so the select is
        // off and says why (CRUD standard rule 6).
        disabled: (el, s)=>el.call('isOwnPersonRow', s),
        title: (el, s)=>el.call('isOwnPersonRow', s) ? el.call('polyglot', 'workspace.person.roleChange.self') : null,
        // Asks first. The select shows the stored role again on Cancel, on the
        // own-row refusal and on a failed write, and the new one once it is stored.
        onChange: (ev, el, s)=>{
            el.call('confirmPersonRoleChange', s, ev.target.value, (role)=>el.update({
                    value: role
                }));
        },
        onRender: (el, s)=>{
            if (!el.node) return;
            const fill = ()=>{
                el.node.innerHTML = '';
                const current = (0, $k3hwI.roleOf)(s, s.userId) || 'member';
                const roles = (0, $k3hwI.allRoles)(s);
                const list = roles.length ? roles : [
                    {
                        name: 'member',
                        label: el.call('polyglot', 'workspace.person.member')
                    }
                ];
                for (const r of list){
                    const opt = document.createElement('option');
                    opt.value = r.name;
                    opt.textContent = r.label || r.name;
                    if (r.name === current) opt.selected = true;
                    el.node.appendChild(opt);
                }
            };
            fill();
            // The roles fetch may resolve after first render. Re-fill once
            // more when the data lands.
            let tries = 0;
            const t = setInterval(()=>{
                if ((0, $k3hwI.allRoles)(s).length) {
                    fill();
                    clearInterval(t);
                    return;
                }
                if (++tries > 10) clearInterval(t);
            }, 200);
            el._rmTimer = t;
        },
        onRemove: (el)=>{
            if (el._rmTimer) clearInterval(el._rmTimer);
        }
    }
};
const $96c8aeef015b52fb$export$161a5fbbcd1ed67f = {
    extends: 'Link',
    href: (el, s)=>s.url || '/notes',
    textDecoration: 'none',
    color: 'inherit',
    flow: 'x',
    align: 'center',
    gap: 'B',
    padding: 'B 0',
    // Row-separator-as-stroke, banned by design-direction.md §8 / DESIGN_
    // LANGUAGE §2.5 — same fix as the house SettingRow.js; the `:hover`
    // theme fill already carries the row-boundary cue.
    cursor: 'pointer',
    ':hover': {
        theme: 'dialog'
    },
    DrIcon: {
        extends: 'Icon',
        icon: 'document',
        boxSize: 'C',
        color: 'blue'
    },
    DrBody: {
        flow: 'y',
        gap: 'Y',
        flex: '1',
        minWidth: '0',
        DrTitle: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.title
        },
        DrMeta: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>{
                const parts = [];
                if (s.type) parts.push(s.type);
                if (s.size) parts.push(s.size);
                if (s.signedAt) parts.push(`signed ${s.signedAt}`);
                return parts.join(" \xb7 ");
            }
        }
    },
    DrAction: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'blue',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        text: '{{ workspace.person.open | polyglot }}'
    }
};
// Sidebar filter row on the People page. State carries `kind` ('group' |
// 'role'), `name` (the value to filter by, null = clear), `label`, and
// optional `count`. Click toggles the matching root-state filter.
// Resolves which `root.selected*` field corresponds to a given filter kind.
const $96c8aeef015b52fb$var$_selField = (kind)=>{
    if (kind === 'role') return 'selectedRole';
    if (kind === 'category') return 'selectedTeamCategory';
    return 'selectedGroup';
};
const $96c8aeef015b52fb$export$9092f9bddf899731 = {
    tag: 'button',
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    padding: 'Z A',
    round: 'radiusPill',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    background: (el, s)=>s.root[$96c8aeef015b52fb$var$_selField(s.kind)] === s.name ? 'blue.2' : 'transparent',
    color: (el, s)=>s.root[$96c8aeef015b52fb$var$_selField(s.kind)] === s.name ? 'title' : 'caption',
    fontWeight: (el, s)=>s.root[$96c8aeef015b52fb$var$_selField(s.kind)] === s.name ? '700' : '500',
    ':hover': {
        color: 'title'
    },
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        s.root.update({
            [$96c8aeef015b52fb$var$_selField(s.kind)]: s.name
        });
    },
    PflLabel: {
        tag: 'span',
        fontSize: 'Z2',
        // KEY-IN-STATE: the rail rows carry a bundle key (peopleGroups.js), a real
        // TEAM row carries the team's own name — polyglot returns a non-key
        // verbatim, so both shapes render correctly through one call.
        text: (el, s)=>s.label && !$96c8aeef015b52fb$var$_idLike(s.label) ? el.call('polyglot', s.label) : el.call('polyglot', 'workspace.people.filter.other')
    },
    PflCount: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>s.count != null ? String(s.count) : ''
    }
};
const $96c8aeef015b52fb$export$85b9fbf91bef48b4 = {
    flow: 'y',
    gap: 'Z',
    // Row-separator-as-stroke, banned by design-direction.md §8 / DESIGN_
    // LANGUAGE §2.5 — same fix as the house SettingRow.js (each row's own
    // padding already gives adjacent rows a full whitespace gap).
    padding: 'B 0',
    CiLabel: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'caption',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        text: (el, s)=>s.label || s.key
    },
    CiValue: {
        tag: 'span',
        fontSize: 'B',
        color: 'title',
        lineHeight: '1.55',
        text: (el, s)=>s.value
    }
};
const $96c8aeef015b52fb$export$4ca250b27810017e = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-G1)), 1fr))',
    gap: 'B'
};
const $96c8aeef015b52fb$export$c9af2366c191bfef = {
    flow: 'y',
    gap: 'B',
    PgHead: {
        flow: 'x',
        align: 'baseline',
        gap: 'A',
        // Borderless law — the bold H2 title + the extra `paddingBottom`
        // already separate this header from the grid below.
        paddingBottom: 'Z',
        PgTitle: {
            tag: 'h2',
            fontSize: 'C',
            fontWeight: '700',
            color: 'title',
            letterSpacing: '-0.01em',
            // A group header is either a bundle KEY (the category / no-team buckets)
            // or a real team name — polyglot returns a non-key verbatim.
            text: (el, s)=>s.name && !$96c8aeef015b52fb$var$_idLike(s.name) ? el.call('polyglot', s.name) : el.call('polyglot', 'workspace.people.filter.other')
        },
        PgCount: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>`${(s.people || []).length}`
        }
    },
    PgGrid: {
        extends: 'PeopleGrid',
        childExtends: 'PersonCard',
        childrenAs: 'state',
        children: (el, s)=>s.people || []
    }
};
const $96c8aeef015b52fb$export$c14d6292d7cbc9f8 = {
    flow: 'y',
    gap: 'B',
    padding: 'B',
    round: 'radiusSheet',
    // Fill only — matches PersonCard's card-shell fix above (the hairline was
    // redundant against this card's own `overlay` fill).
    background: 'overlay',
    // Stacked like PersonCard (avatar row on top, text below) — the roster grid
    // columns are ~230px, so a single avatar+email+badge row overflowed: the
    // email box collapsed to ~33px and the text ran under the badge. Top row is
    // avatar ⟷ badge (space-between); the email truncates with a native title
    // tooltip carrying the full address.
    PicHeader: {
        flow: 'y',
        gap: 'A',
        PicTop: {
            flow: 'x',
            align: 'center space-between',
            gap: 'A',
            PicAvatar: {
                align: 'center center',
                width: 'D',
                height: 'D',
                round: '50%',
                color: 'caption',
                background: 'overlayStrong',
                flex: '0 0 auto',
                Icon: {
                    name: 'email',
                    boxSize: 'A'
                }
            },
            // "Pending" badge — caption text on an overlay-strong chip (house
            // neutral-status pattern, matches pages/system.js STATUS.pending).
            PicBadge: {
                tag: 'span',
                padding: 'Y A',
                round: 'radiusCard',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'caption',
                background: 'overlayStrong',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                flex: '0 0 auto',
                text: '{{ workspace.person.pending | polyglot }}'
            }
        },
        PicName: {
            flow: 'y',
            gap: 'Y',
            minWidth: '0',
            PicEmail: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                title: (el, s)=>s.email,
                text: (el, s)=>s.email
            },
            PicRole: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                whiteSpace: 'nowrap',
                // `{role}` is the server's own role id, capitalised by
                // functions/pendingInvitations.js `_label` — a machine identifier the
                // invite API matches on, not copy. Only the FRAME is translated.
                text: (el, s)=>el.call('polyglot', 'workspace.person.invitedAs').replace('{role}', s.roleLabel || '')
            }
        }
    },
    // Revoke affordance — admin/owner only (the server 403s the revoke
    // endpoint for anyone else, same gate as loadPendingInvitations).
    PicFooter: {
        hide: (el)=>!el.call('currentUserIsAdmin'),
        flow: 'x',
        align: 'center flex-end',
        PicRevoke: {
            tag: 'button',
            type: 'button',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            minHeight: 'controlHCompact',
            padding: '0 Z',
            round: 'radiusPill',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'red',
            ':hover': {
                theme: 'dialog'
            },
            text: '{{ workspace.person.revoke | polyglot }}',
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                // Capture PLAIN values before the async confirm: `s` is the keyed
                // child-state proxy, and the optimistic list update after the revoke
                // re-binds it to whichever row shifts into this slot — reading
                // s.email inside onConfirm named the WRONG invite in the success
                // toast (observed live: revoked iva@…, toast said bacho@…).
                const email = s.email;
                const inviteId = s.id;
                const root = s.root;
                // The D1 house shape. In Georgian the Revoke button and Cancel share
                // the word გაუქმება, so the other button says "Keep" (D13).
                el.call('confirmDialog', {
                    title: el.call('polyglot', 'workspace.person.revokeConfirm'),
                    message: el.call('polyglot', 'workspace.person.revokeConfirmBody').replace('{email}', ()=>email),
                    confirmText: el.call('polyglot', 'workspace.person.revokeCta'),
                    cancelText: el.call('polyglot', 'shell.invite.link.keep'),
                    confirmTheme: 'primary',
                    icon: null,
                    onConfirm: async ()=>{
                        try {
                            await el.call('revokePendingInvitation', root, inviteId);
                            el.call('openNotification', {
                                title: el.call('polyglot', 'workspace.person.revoked'),
                                message: el.call('polyglot', 'workspace.person.revokedBody').replace('{email}', email),
                                type: 'success'
                            });
                        } catch (err) {
                            el.call('openNotification', {
                                title: el.call('polyglot', 'workspace.person.revokeFailed'),
                                message: String(err && err.message ? err.message : err),
                                type: 'error'
                            });
                            console.warn('[PendingInviteCard] revoke failed:', err);
                        }
                    }
                });
            }
        }
    }
};
const $96c8aeef015b52fb$export$ada374a594c66c02 = {
    flow: 'y',
    gap: 'B',
    hide: (el, s)=>!el.call('currentUserIsAdmin') || !(s.root?.pendingInvitations || []).length,
    // Direct URL loads mount this block BEFORE the workspace is hydrated, and
    // loadPendingInvitations no-ops (clears the list) without an active
    // workspace id — onInit alone left the section permanently empty on a hard
    // load. Subscribe to the workspace key and re-fire the (deduped,
    // TTL-cached) loader when it lands or changes — the same subscribeTo +
    // onUpdate pattern as TicketsKanban's _colCount.
    subscribeTo: [
        'workspace'
    ],
    onInit: (el, s)=>{
        if (el.call('currentUserIsAdmin')) el.call('loadPendingInvitations', s.root);
    },
    onUpdate: (el, s)=>{
        if (el.call('currentUserIsAdmin')) el.call('loadPendingInvitations', s.root);
    },
    PgHead: {
        flow: 'x',
        align: 'baseline',
        gap: 'A',
        // Borderless law — the bold H2 title + the extra `paddingBottom`
        // already separate this header from the grid below.
        paddingBottom: 'Z',
        PgTitle: {
            tag: 'h2',
            fontSize: 'C',
            fontWeight: '700',
            color: 'title',
            letterSpacing: '-0.01em',
            text: '{{ workspace.person.pendingInvites | polyglot }}'
        },
        PgCount: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>`${(s.root?.pendingInvitations || []).length}`
        }
    },
    PgGrid: {
        extends: 'PeopleGrid',
        childExtends: 'PendingInviteCard',
        childrenAs: 'state',
        children: (el, s)=>s.root?.pendingInvitations || []
    }
};

});

parcelRegister("cChHa", function(module, exports) {

$parcel$export(module.exports, "AnnouncementCard", () => $92f6c29118a96147$export$fc09cf535d7ce857);
$parcel$export(module.exports, "ReactionPill", () => $92f6c29118a96147$export$44ce21f6a88f8431);
$parcel$export(module.exports, "AddReactionPicker", () => $92f6c29118a96147$export$2d4705842fbee2a6);
$parcel$export(module.exports, "ArpPopoverMenu", () => $92f6c29118a96147$export$f18ca06e856b2217);
$parcel$export(module.exports, "AddReactionEmoji", () => $92f6c29118a96147$export$9acb05c432b24cc1);
$parcel$export(module.exports, "AnnouncementDetailModal", () => $92f6c29118a96147$export$9bf24fc3bca1c6e);
$parcel$export(module.exports, "AdmParagraph", () => $92f6c29118a96147$export$e38ab6dfda165f43);
$parcel$export(module.exports, "IntroRun", () => $92f6c29118a96147$export$30f83fb4ef98f83e);
$parcel$export(module.exports, "AvatarBundle", () => $92f6c29118a96147$export$5822eaed382932db);
$parcel$export(module.exports, "AvatarBundleItem", () => $92f6c29118a96147$export$c76390ffeae9f71c);
$parcel$export(module.exports, "BirthdayItem", () => $92f6c29118a96147$export$63066481d0925ed3);
$parcel$export(module.exports, "UpcomingEventCard", () => $92f6c29118a96147$export$e688e868b522f98c);
$parcel$export(module.exports, "CityMemberRow", () => $92f6c29118a96147$export$29f8b3e07f09ff4c);
$parcel$export(module.exports, "TzCluster", () => $92f6c29118a96147$export$f2823c40f8f4d14b);
$parcel$export(module.exports, "TzAvatarItem", () => $92f6c29118a96147$export$8db9e541def169d4);
$parcel$export(module.exports, "HomeMailRow", () => $92f6c29118a96147$export$855a8e3278086aed);
// Reactions used to be a local-only visual toggle. The announcements SDK
// already has a scoped react endpoint; every card and detail picker calls
// `el.call('toggleBroadcastReaction', postId, emoji)` — Broadcast's
// optimistic/persisted mutation — directly at the handler (a module-scope
// `_toggleReaction` delegate used to sit between them: FA204/frank trap,
// bare module consts read as undefined post-toJSON).
// (The reaction picker renders in the shell-root DropdownRoot since
// 2026-06-06 — no per-card popover to keep unclipped anymore. The cover
// gradient block has its own `overflow: hidden` for rounded corners.)
const $92f6c29118a96147$export$fc09cf535d7ce857 = {
    tag: 'article',
    flow: 'y',
    round: 'radiusSheet',
    // Fill only — the hairline was redundant against this card's own
    // `overlay` fill. Hover emphasis moves from a border-color swap to a
    // shadow lift (matching tickets/Cards.js's "card outlines → fill + float
    // on hover" conversion in this same sweep).
    background: 'overlay',
    overflow: 'visible',
    position: 'relative',
    cursor: 'pointer',
    transition: 'all 220ms ease',
    ':hover': {
        shadow: 'float',
        transform: 'translateY(-3px)'
    },
    onClick: (e, el, s)=>{
        // Ignore clicks that originated inside an interactive child (reactions, buttons, links)
        const t = e.target;
        if (t && (t.closest('button') || t.closest('a'))) return;
        // `selectedAnnouncement` stays as the data carrier the detail body
        // reads from; visibility moved to the @symbo.ls/windows layer
        // (2026-06-06) — ModalRoot owns backdrop, ESC and dismiss.
        s.root.update({
            selectedAnnouncement: s
        });
        el.call('openModal', {
            id: 'announcement-detail',
            template: 'custom',
            width: 'overlayXl',
            maxHeight: '85vh',
            content: {
                extends: 'AnnouncementDetailModal'
            }
        });
    },
    AcCover: {
        height: 'F',
        background: (el, s)=>s.cover || 'linear-gradient(135deg, #0085FF 0%, #50E1FF 100%)',
        position: 'relative',
        overflow: 'hidden',
        borderTopLeftRadius: 'radiusSheet',
        borderTopRightRadius: 'radiusSheet',
        AcTagPill: {
            position: 'absolute',
            top: 'A',
            left: 'A',
            padding: 'Z A',
            round: 'radiusCard',
            fontSize: 'Y2',
            fontWeight: '700',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            // AMBIGUOUS (left): #0a0a0b has no exact token match (gray1 is #040404,
            // close but not byte-identical) — needs a fixed near-black regardless
            // of theme since it sits on an arbitrary cover image, not page bg.
            color: '#0a0a0b',
            // Deliberately FIXED — pairs with the near-black text above; both
            // must stay fixed so the pill reads over ANY arbitrary cover image.
            background: 'white',
            // A loaded post with no topic carries the default-topic KEY
            // (functions/broadcast.js broadcastFromWire); a real topic passes
            // through polyglot verbatim.
            text: (el, s)=>el.call('polyglot', s.tag || 'workspace.broadcastStudio.preview.tagDefault')
        }
    },
    AcBody: {
        flow: 'y',
        gap: 'B',
        padding: 'C',
        AcHeader: {
            flow: 'y',
            gap: 'A',
            AcTitle: {
                tag: 'h2',
                fontSize: 'D',
                fontWeight: '700',
                color: 'title',
                letterSpacing: '-0.025em',
                lineHeight: '1.15',
                text: (el, s)=>s.title
            },
            AcExcerpt: {
                tag: 'p',
                color: 'paragraph',
                fontSize: 'A',
                lineHeight: '1.55',
                text: (el, s)=>s.excerpt
            }
        },
        AcAuthor: {
            flow: 'x',
            align: 'center',
            gap: 'A',
            // Borderless law — the extra `paddingTop` + the byline's own
            // typography already separate it from AcExcerpt above (same reasoning
            // as shared/AiActionConfirmCard's Header/Footer divider removal).
            paddingTop: 'A',
            AcAvatar: {
                extends: 'Avatar',
                align: 'center center',
                boxSize: 'C',
                round: '50%',
                src: (el, s)=>el.call('avatarUrlFor', s.author)
            },
            AcMeta: {
                flow: 'y',
                gap: 'Y',
                flex: '1',
                AcName: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>s.author
                },
                AcSub: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: (el, s)=>{
                        const parts = [];
                        if (s.authorRole) parts.push(s.authorRole);
                        if (s.date) try {
                            parts.push(el.call('localizedDate', s.date, {
                                month: 'short',
                                day: 'numeric'
                            }));
                        } catch  {}
                        const readTime = el.call('broadcastReadTime', s);
                        if (readTime) parts.push(readTime);
                        return parts.join(" \xb7 ");
                    }
                }
            }
        },
        AcReactions: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            flexWrap: 'wrap',
            AcExisting: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                flexWrap: 'wrap',
                ':empty': {
                    display: 'none'
                },
                childExtends: 'ReactionPill',
                childrenAs: 'state',
                children: (el, s)=>Object.entries(s.reactions || {}).map(([emoji, names])=>({
                            emoji: emoji,
                            names: names,
                            postId: s.id
                        }))
            },
            AcAddReaction: {
                extends: 'AddReactionPicker'
            }
        }
    }
};
const $92f6c29118a96147$export$44ce21f6a88f8431 = {
    tag: 'button',
    flow: 'x',
    align: 'center',
    gap: 'Z',
    padding: 'Y A',
    round: 'radiusPill',
    theme: 'dialog',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    fontSize: 'Z2',
    fontWeight: '700',
    color: 'title',
    cursor: 'pointer',
    title: (el, s)=>(s.names || []).join(', '),
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        el.call('toggleBroadcastReaction', s.postId, s.emoji);
    },
    // Border highlights when the signed-in user has reacted with this emoji.
    borderColor: (el, s)=>{
        const myName = el.call('findMe', s)?.name;
        return myName && (s.names || []).includes(myName) ? 'blue' : 'transparent';
    },
    RpEmoji: {
        tag: 'span',
        fontSize: 'A',
        text: (el, s)=>s.emoji
    },
    RpCount: {
        tag: 'span',
        text: (el, s)=>String((s.names || []).length)
    }
};
// FA204 / frank trap — these tables are captured BY VALUE into
// ArpPopoverMenu's `scope` below (module-eval-time snapshot, serialized as
// data by frank.toJSON) and the grid factories read `el.scope.*`. A factory
// body reading the bare module const at CALL time would be undefined after
// a platform push and both grids would mount empty.
const $92f6c29118a96147$var$POPULAR_EMOJIS = [
    "\uD83D\uDC4D",
    "\u2764\uFE0F",
    "\uD83C\uDF89",
    "\uD83D\uDE80",
    "\uD83D\uDD25",
    "\uD83D\uDC4F",
    "\uD83D\uDC40",
    "\uD83D\uDE02"
];
const $92f6c29118a96147$var$ALL_EMOJIS = [
    "\uD83D\uDC4D",
    "\uD83D\uDC4E",
    "\u2764\uFE0F",
    "\uD83E\uDDE1",
    "\uD83D\uDC9B",
    "\uD83D\uDC9A",
    "\uD83D\uDC99",
    "\uD83D\uDC9C",
    "\uD83C\uDF89",
    "\uD83C\uDF8A",
    "\uD83D\uDE80",
    "\uD83D\uDD25",
    "\u26A1",
    "\u2728",
    "\uD83D\uDCAF",
    "\u2B50",
    "\uD83D\uDC4F",
    "\uD83D\uDE4C",
    "\uD83E\uDD1D",
    "\uD83D\uDCAA",
    "\uD83D\uDE4F",
    "\uD83D\uDC40",
    "\uD83D\uDE02",
    "\uD83D\uDE05",
    "\uD83D\uDE0D",
    "\uD83E\uDD29",
    "\uD83D\uDE0E",
    "\uD83E\uDD2F",
    "\uD83E\uDD73",
    "\uD83E\uDD14",
    "\uD83D\uDE22",
    "\uD83D\uDE21",
    "\u2705",
    "\u274C",
    "\u26A0\uFE0F",
    "\uD83D\uDCA1",
    "\uD83D\uDCC8",
    "\uD83D\uDCC9",
    "\uD83D\uDCFA",
    "\uD83C\uDF55"
];
const $92f6c29118a96147$export$2d4705842fbee2a6 = {
    position: 'relative',
    ArpButton: {
        tag: 'button',
        align: 'center center',
        padding: 'Y A',
        round: 'radiusPill',
        theme: 'dialog',
        border: 'none',
        fontSize: 'A',
        fontWeight: '700',
        color: 'caption',
        cursor: 'pointer',
        text: '+',
        'aria-label': (el)=>el.call('polyglot', 'workspace.announcements.addReaction'),
        ':hover': {
            color: 'title'
        },
        onClick: (ev, el, s)=>{
            ev.preventDefault();
            ev.stopPropagation();
            s.root.update({
                _arpPostId: s.id
            });
            el.call('openDropdown', {
                anchorEl: el,
                id: 'arpPicker',
                placement: 'bottom-end',
                minWidth: '360px',
                // Shell paint opt-in — ArpPopoverMenu is body-only ("the panel
                // supplies theme/round/shadow"); the plugin Panel is chromeless
                // by default (FW-DROPDOWN-PANEL-STALE-SHELL-PAINT-1).
                theme: 'canvas-card-glass',
                shadow: 'overlay',
                content: {
                    extends: 'ArpPopoverMenu'
                }
            });
        }
    }
};
const $92f6c29118a96147$export$f18ca06e856b2217 = {
    scope: {
        POPULAR_EMOJIS: $92f6c29118a96147$var$POPULAR_EMOJIS,
        ALL_EMOJIS: $92f6c29118a96147$var$ALL_EMOJIS
    },
    tag: 'div',
    flow: 'y',
    gap: 'A',
    padding: 'Z',
    role: 'menu',
    ArpPopular: {
        flow: 'y',
        gap: 'Z',
        ArpPopHead: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            text: '{{ workspace.reaction.popular | polyglot }}'
        },
        ArpPopGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(8, 1fr)',
            gap: 'Z',
            childExtends: 'AddReactionEmoji',
            childrenAs: 'state',
            children: (el, s)=>el.scope.POPULAR_EMOJIS.map((e)=>({
                        emoji: e,
                        postId: s.root?._arpPostId
                    }))
        }
    },
    ArpAll: {
        flow: 'y',
        gap: 'Z',
        // Borderless law — the "Popular"/"All" uppercase caption labels + the
        // extra `paddingTop` already separate the two emoji groups.
        paddingTop: 'A',
        ArpAllHead: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            text: '{{ workspace.reaction.all | polyglot }}'
        },
        ArpAllGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(8, 1fr)',
            gap: 'Z',
            childExtends: 'AddReactionEmoji',
            childrenAs: 'state',
            children: (el, s)=>el.scope.ALL_EMOJIS.map((e)=>({
                        emoji: e,
                        postId: s.root?._arpPostId
                    }))
        }
    }
};
const $92f6c29118a96147$export$9acb05c432b24cc1 = {
    tag: 'button',
    align: 'center center',
    width: 'C',
    height: 'C',
    round: 'radiusCard',
    background: 'transparent',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'transparent',
    fontSize: 'B',
    cursor: 'pointer',
    text: (el, s)=>s.emoji,
    ':hover': {
        background: 'hover',
        borderColor: 'line'
    },
    onClick: (ev, el, s)=>{
        ev.preventDefault();
        ev.stopPropagation();
        el.call('toggleBroadcastReaction', s.postId, s.emoji);
        el.call('closeDropdown', 'arpPicker');
    }
};
const $92f6c29118a96147$export$9bf24fc3bca1c6e = {
    // Window chrome owns the outer sizing — the openModal call passes
    // width overlayXl / maxHeight 85vh on the layer descriptor. The body
    // just fills it and scrolls.
    width: '100%',
    maxHeight: '85vh',
    overflow: 'auto',
    flow: 'y',
    position: 'relative',
    // Close X — the brand ModalWindow used to supply this; body-only
    // content brings its own. Floats over the cover image top-right.
    // THE house close X (brand CloseButton — F2, one X for every panel);
    // geometry + glyph inherited, only the scrim ink below is local.
    AdmClose: {
        extends: 'CloseButton',
        position: 'absolute',
        top: 'Y2',
        right: 'Y2',
        zIndex: '2',
        // Deliberately FIXED: floats over AdmCover's arbitrary announcement
        // cover image/gradient below — same scrim-over-arbitrary-imagery
        // contract as ModalLayer's own fixed 'black.45' backdrop.
        color: 'white',
        background: 'black.45',
        ':hover': {
            background: 'black.7',
            color: 'white'
        },
        'aria-label': (el)=>el.call('polyglot', 'workspace.announcements.closeLabel'),
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('closeModal', 'announcement-detail');
        }
    },
    AdmCover: {
        hide: (el, s)=>!s.root?.selectedAnnouncement?.cover,
        height: 'G',
        flexShrink: '0',
        background: (el, s)=>s.root?.selectedAnnouncement?.cover || 'linear-gradient(135deg, #0085FF 0%, #50E1FF 100%)',
        borderTopLeftRadius: 'radiusSheet',
        borderTopRightRadius: 'radiusSheet'
    },
    AdmBody: {
        flow: 'y',
        gap: 'B',
        padding: 'D',
        AdmTagPill: {
            tag: 'span',
            alignSelf: 'flex-start',
            padding: 'Y A',
            round: 'radiusPill',
            fontSize: 'Y2',
            fontWeight: '700',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: 'blue',
            background: 'blue.2',
            text: (el, s)=>s.root?.selectedAnnouncement?.tag || ''
        },
        AdmTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'E',
            fontWeight: '700',
            letterSpacing: '-0.025em',
            lineHeight: '1.1',
            color: 'title',
            text: (el, s)=>s.root?.selectedAnnouncement?.title || ''
        },
        AdmAuthor: {
            flow: 'x',
            align: 'center',
            gap: 'A',
            // Borderless law — the extra `paddingBottom` + byline typography
            // already separate this from AdmExcerpt below.
            paddingBottom: 'B',
            AdmAvatar: {
                extends: 'Avatar',
                align: 'center center',
                boxSize: 'C',
                round: '50%',
                src: (el, s)=>el.call('avatarUrlFor', s.root?.selectedAnnouncement?.author)
            },
            AdmMeta: {
                flow: 'y',
                gap: 'Y',
                flex: '1',
                AdmAuthorName: {
                    tag: 'span',
                    fontSize: 'A',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>s.root?.selectedAnnouncement?.author || ''
                },
                AdmAuthorSub: {
                    tag: 'span',
                    fontSize: 'Z2',
                    color: 'caption',
                    text: (el, s)=>{
                        const a = s.root?.selectedAnnouncement;
                        if (!a) return '';
                        const parts = [];
                        if (a.authorRole) parts.push(a.authorRole);
                        if (a.date) try {
                            parts.push(el.call('localizedDate', a.date, {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric'
                            }));
                        } catch  {}
                        const readTime = el.call('broadcastReadTime', a);
                        if (readTime) parts.push(readTime);
                        return parts.join(" \xb7 ");
                    }
                }
            }
        },
        AdmExcerpt: {
            tag: 'p',
            margin: '0',
            fontSize: 'B',
            lineHeight: '1.55',
            color: 'paragraph',
            fontWeight: '500',
            text: (el, s)=>s.root?.selectedAnnouncement?.excerpt || ''
        },
        AdmExternalLink: {
            extends: 'Link',
            hide: (el, s)=>{
                const post = s.root?.selectedAnnouncement;
                return post?.audience !== 'external' || !post?.externalUrl;
            },
            href: (el, s)=>s.root?.selectedAnnouncement?.externalUrl || '#',
            target: '_blank',
            rel: 'noreferrer',
            alignSelf: 'flex-start',
            padding: 'Z A',
            round: 'radiusPill',
            background: 'overlay',
            color: 'title',
            fontSize: 'Z1',
            fontWeight: '700',
            textDecoration: 'none',
            text: '{{ workspace.rows.openExternal | polyglot }}'
        },
        AdmContent: {
            flow: 'y',
            gap: 'A',
            childExtends: 'AdmParagraph',
            childrenAs: 'state',
            children: (el, s)=>{
                const body = s.root?.selectedAnnouncement?.body;
                if (!body) return [];
                if (Array.isArray(body)) return body.map((p)=>({
                        text: p
                    }));
                if (typeof body === 'string') return [
                    {
                        text: body
                    }
                ];
                return [];
            }
        }
    }
};
const $92f6c29118a96147$export$e38ab6dfda165f43 = {
    tag: 'p',
    margin: '0',
    fontSize: 'A',
    lineHeight: '1.65',
    color: 'paragraph',
    text: (el, s)=>s.text || ''
};
const $92f6c29118a96147$export$30f83fb4ef98f83e = {
    tag: 'span',
    fontSize: 'A',
    color: (el, s)=>s.color || 'caption',
    fontWeight: (el, s)=>s.weight || '500',
    text: (el, s)=>s.text
};
const $92f6c29118a96147$export$5822eaed382932db = {
    display: 'flex',
    flexFlow: 'row',
    align: 'center',
    childExtends: 'AvatarBundleItem',
    childrenAs: 'state',
    // The overlap stack pulls each item's right edge under its neighbor via a
    // negative margin — the LAST item must not bleed that margin into the next
    // flex sibling (it was shoving the "N people" caption under the stack).
    childProps: {
        ':last-child': {
            marginInlineEnd: '0'
        }
    },
    children: (el, s)=>{
        let emails = el.emails || [];
        if (typeof emails === 'function') emails = emails(el, s) || [];
        const lookup = el.call('peopleByEmail');
        const out = [];
        for (const e of emails){
            const p = lookup[e];
            if (p) out.push(p);
            if (out.length === 3) break;
        }
        return out;
    }
};
const $92f6c29118a96147$export$c76390ffeae9f71c = {
    // ONE URL predicate for the plate's readers (AvatarImg if/src + Initials
    // hide) so the three cannot drift — in `scope`, not a module const
    // (FA204: a bare module const reads as undefined post-frank.toJSON).
    scope: {
        avatarUrlOf: (s)=>{
            const v = s && s.avatar;
            return typeof v === 'string' && /^(https?:|\/)/.test(v) ? v : null;
        }
    },
    position: 'relative',
    zIndex: '1',
    marginInlineEnd: '-Z1',
    cursor: 'default',
    // KEPT — avatar-stack ring, the sanctioned separator so overlapping
    // avatars read as distinct circles. Retokenized `'2px'` → `hairline2`.
    borderWidth: 'hairline2',
    borderStyle: 'solid',
    borderColor: 'overlay',
    round: '50%',
    // Native title as identification (consumers that layer a custom tooltip —
    // TzAvatarItem — override with `title: ''`). Declarative, replacing the
    // former onRender setAttribute + addEventListener block (v3-era raw DOM;
    // the hover z-index bump is pure CSS).
    title: (el, s)=>s && s.name || s && s.email || '',
    ':hover': {
        zIndex: '50'
    },
    // House identity plate (PersonCard.PcAvatar precedent, 2026-08-08 §4.3):
    // neutral `overlayStrong` wash + `title` ink initials, real photo only when
    // `s.avatar` is a URL. Replaces the dicebear per-seed rainbow plates —
    // 5 of those 7 hues failed AA under white ink, and a multicolor stack
    // fights the one-hue-per-screen law on every poster widget.
    BundlePlate: {
        align: 'center center',
        width: 'B1',
        height: 'B1',
        round: '50%',
        overflow: 'hidden',
        position: 'relative',
        background: 'overlayStrong',
        color: 'title',
        fontSize: 'Z2',
        fontWeight: '700',
        AvatarImg: {
            tag: 'img',
            // `if:`, never `hide:` — a display:none <img> still FETCHES its src
            // ('N'/'HL'-style letters 404ed against the origin on every load,
            // measured live 2026-09-01). No node, no request.
            if: (el, s)=>!!el.scope.avatarUrlOf(s),
            position: 'absolute',
            inset: '0',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            // Belt on top of the if: gate — null emits no src attribute at all
            // (src:'' is itself a request of the page URL in some engines).
            src: (el, s)=>el.scope.avatarUrlOf(s),
            alt: (el, s)=>s && (s.name || s.email) || 'member'
        },
        Initials: {
            tag: 'span',
            hide: (el, s)=>!!el.scope.avatarUrlOf(s),
            // Georgian stays as typed: String#toUpperCase maps Mkhedruli to
            // MTAVRULI capitals (Unicode 11) — the home face stack showed ᲒᲑ over
            // rows reading გბ for the same people (crm-w1 twin QA, F6). Every
            // cased script is still upper-cased (crmInitials, the eyebrow rule).
            text: (el, s)=>{
                const label = s && (s.name || s.email) || '?';
                const parts = String(label).trim().split(/\s+/).filter(Boolean);
                const pair = parts.length >= 2 ? parts[0][0] + parts[1][0] : String(label).slice(0, 2);
                return /\p{Script=Georgian}/u.test(pair) ? pair : pair.toUpperCase();
            }
        }
    }
};
const $92f6c29118a96147$export$63066481d0925ed3 = {
    scope: {
        emailByName: (s, name)=>{
            if (!name) return null;
            const list = s && s.root && s.root.people || [];
            const lc = String(name).toLowerCase();
            for (const p of list){
                if ((p.name || '').toLowerCase() === lc) return p.email;
            }
            return null;
        }
    },
    flow: 'x',
    align: 'center',
    gap: 'A',
    cursor: 'pointer',
    transition: 'transform 160ms ease',
    ':hover': {
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        const email = el.scope.emailByName(s, s.name);
        if (email) el.call('openProfileModal', email);
    },
    BdAvatar: {
        align: 'center center',
        width: 'C',
        height: 'C',
        round: '50%',
        // Opaque identity tile whose hue comes from DATA (s.color). One fixed ink
        // cannot serve every hue (white 3.62 on blue, near-black 3.0 on purple), so
        // `inkOnPlate` measures the plate and picks — same as AgentHeroCard's Glyph.
        color: (el, s)=>el.call('inkOnPlate', s.color || 'blue'),
        fontSize: 'Z2',
        fontWeight: '700',
        background: (el, s)=>s.color || 'blue',
        text: (el, s)=>s.initials || '',
        // Flat v3.14 title prop — was a v3-era onRender setAttribute (same
        // migration as AvatarBundleItem above).
        title: (el, s)=>s.name || ''
    },
    BdName: {
        tag: 'span',
        fontSize: 'A',
        color: 'title',
        fontWeight: '700',
        text: (el, s)=>s.name
    }
};
const $92f6c29118a96147$export$e688e868b522f98c = {
    // Plain button (was `extends: 'Link'` with href `/calendar#event=…`,
    // which redirected the user to the full calendar page). Now opens
    // the CalEventDetailModal in place via @symbo.ls/windows so the
    // user stays on the dashboard — same dispatch the calendar's own
    // WeekView / MonthView event cells use (`openEventDetailModal`).
    tag: 'button',
    type: 'button',
    textAlign: 'left',
    color: 'inherit',
    cursor: 'pointer',
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    round: 'radiusSheet',
    background: 'overlay',
    border: 'none',
    transition: 'all 200ms ease',
    ':hover': {
        theme: 'dialog',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        // Open the event detail modal via @symbo.ls/windows (CalEventDetailModal
        // is a windows-body component, not a Modal). Same dispatch the
        // calendar's WeekView / MonthView event cells use.
        el.call('openEventDetailModal', s);
    },
    // Ink-wash date tile — was `background: 'blue.2'` + `color: 'blue'`, a
    // SECOND accent hue (lavender/purple) landing on the "Coming up" widget's
    // single red-orange poster (homeWidgetHue's 'events' entry), violating
    // design-direction.md §6 "one accent hue per surface" (2026-08-12 per
    // Fable's live walk). The card's own ink is fixed 'white' (poster.ink for
    // 'events' — this component only ever mounts inside that ONE poster, same
    // fixed-ink convention as CityMemberRow above), so the tile is now a plain
    // white ink-wash fill instead of a borrowed hue.
    UeDate: {
        flow: 'y',
        align: 'center center',
        width: 'C',
        minWidth: 'C',
        padding: 'Z',
        round: 'radiusSheet',
        background: 'white.12',
        UeDay: {
            tag: 'span',
            fontSize: 'B',
            fontWeight: '700',
            color: 'white',
            lineHeight: '1',
            text: (el, s)=>{
                try {
                    return String(new Date(s.startAt).getDate());
                } catch  {
                    return '';
                }
            }
        },
        UeMonth: {
            // MEASURED secondary step, not an opacity floor — white `.75` on the
            // 'events' poster read 3.58:1, under the 4.5:1 AA floor for normal
            // text (HOME-POSTER-EMPTYSTATE-INK-1, live 2026-08-22).
            extends: 'HomePosterSoftInk',
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            textTransform: 'uppercase',
            text: (el, s)=>{
                try {
                    return el.call('localizedDate', s.startAt, {
                        month: 'short'
                    });
                } catch  {
                    return '';
                }
            }
        }
    },
    UeBody: {
        flow: 'y',
        gap: 'Y',
        flex: '1',
        minWidth: '0',
        UeTitle: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            // Fixed 'white' ink, not adaptive 'title' — this card only ever mounts
            // inside the EventsWidget's ONE red-orange poster (homeWidgetHue's
            // 'events' entry: ink 'white'). Adaptive 'title' flips to near-black in
            // light theme (color.js title:['gray1','gray15']), which would read
            // fine in dark theme by coincidence but put near-black text on the red
            // poster in light theme — same theme-invariant-poster bug UeDate/
            // UeMonth below and CityMemberRow were fixed for (2026-08-12).
            color: 'white',
            // Explicit wrap rules — the card sits in a narrow grid column so a
            // long title (e.g. "Launching plans for Q3") must wrap at spaces,
            // never get cut mid-word. Prevents the "launching pla" truncation
            // the home brief flagged.
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            wordBreak: 'normal',
            text: (el, s)=>s.title
        },
        UeMeta: {
            // The poster's MEASURED secondary step, resolved off the card's own
            // poster (HomePosterSoftInk). The old form was fixed 'white' at the
            // blanket `.55` opacity floor — the geex ink language's grammar
            // default, never measured: it read 2.58:1 on the 'events' poster,
            // under the 4.5:1 AA floor for normal text
            // (HOME-POSTER-EMPTYSTATE-INK-1, live 2026-08-22). The resolver keeps
            // the fixed-ink poster rationale of UeTitle above (it returns the
            // poster's OWN binary ink, never the adaptive 'caption', inside a
            // poster) and follows a branded workspace's override at paint time.
            extends: 'HomePosterSoftInk',
            tag: 'span',
            fontSize: 'Z2',
            // Single line with ellipsis — the source data sometimes stuffs a
            // long description into `location`, so without a clamp the meta
            // wraps and gets visually cut mid-word ("…launching pla") by the
            // grid row. One-line ellipsis keeps the card height predictable
            // and the truncation honest (a real "…", not a mid-word slice).
            display: 'block',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                let t = '';
                try {
                    t = el.call('localizedDate', s.startAt, {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                } catch  {}
                return `${t}${t && s.location ? " \xb7 " : ''}${s.location || ''}`;
            }
        },
        // JoinBtn — board §2 "next events with JOIN button for meet-linked
        // ones". `s` here IS the raw event object (childrenAs:'state' in the
        // widget's own `children` builder — same contract onClick above
        // already relies on for openEventDetailModal), so el.call passes it
        // straight through to functions/eventMeetJoin.js's eventHasMeetLink /
        // joinEventCall, which reuse the calendar package's OWN join dispatch
        // (EventDetailModal's "Join call" SaveBtn) verbatim.
        //
        // `tag: 'span'` + role/tabindex, NOT a real `<button>` — this card's
        // OWN root is already `tag: 'button'`, and a `<button>` nested inside
        // a `<button>` is invalid HTML5 (the parser auto-closes the outer tag
        // and silently pulls every sibling after this one out of the card —
        // same documented trap BroadcastNewsRow's Star button works around).
        // stopPropagation so Join doesn't ALSO trigger the card's own onClick
        // (open the full detail modal) on the same click.
        JoinBtn: {
            hide: (el, s)=>!el.call('eventHasMeetLink', s),
            tag: 'span',
            role: 'button',
            tabindex: '0',
            flow: 'x',
            align: 'center',
            gap: 'V',
            alignSelf: 'flex-start',
            marginTop: 'V',
            padding: 'V Z',
            round: 'radiusPill',
            fontSize: 'Y2',
            fontWeight: '700',
            cursor: 'pointer',
            // Inverted-pill CTA, same fixed-poster-ink convention as UeDate/
            // UeTitle/UeMeta above (white 'title'/'caption' would flip with the
            // shell theme on this theme-invariant red-orange poster) — solid
            // white fill + the poster's own red as the text, mirroring
            // _taskQuickAddRow's AddBtn (hue.ink bg / hue.bg text) one level up
            // in fixed-value form since this card has no hue object passed in.
            background: 'white',
            color: 'red',
            transition: '120ms defaultBezier opacity',
            ':hover': {
                opacity: '.85'
            },
            'aria-label': (el)=>el.call('polyglot', 'workspace.rows.joinCall'),
            onClick: (e, el, s)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('joinEventCall', s);
            },
            onKeydown: (e, el, s)=>{
                if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
                e.preventDefault();
                e.stopPropagation();
                el.call('joinEventCall', s);
            },
            Icon: {
                name: 'video',
                boxSize: 'Y1',
                color: 'red'
            },
            JoinLabel: {
                tag: 'span',
                text: '{{ workspace.rows.join | polyglot }}'
            }
        }
    }
};
const $92f6c29118a96147$export$29f8b3e07f09ff4c = {
    scope: {
        hourFraction: (timezone)=>{
            try {
                const parts = new Intl.DateTimeFormat('en-US', {
                    timeZone: timezone,
                    hour: 'numeric',
                    minute: 'numeric',
                    hourCycle: 'h23'
                }).formatToParts(new Date());
                const h = Number(parts.find((p)=>p.type === 'hour')?.value);
                const m = Number(parts.find((p)=>p.type === 'minute')?.value);
                if (Number.isNaN(h)) return 0;
                return (h + (Number.isNaN(m) ? 0 : m / 60)) / 24;
            } catch  {
                return 0;
            }
        },
        isWorkingHours: (timezone)=>{
            let hour = 0;
            try {
                const parts = new Intl.DateTimeFormat('en-US', {
                    timeZone: timezone,
                    hour: 'numeric',
                    minute: 'numeric',
                    hourCycle: 'h23'
                }).formatToParts(new Date());
                const h = Number(parts.find((p)=>p.type === 'hour')?.value);
                const m = Number(parts.find((p)=>p.type === 'minute')?.value);
                if (!Number.isNaN(h)) hour = h + (Number.isNaN(m) ? 0 : m / 60);
            } catch  {
                hour = 0;
            }
            return hour >= 9 && hour < 18;
        }
    },
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Z A',
    round: 'radiusControl',
    // Ink-wash row separation, no hairline borders (house convention: rounded
    // list rows separate via a gap + tint, never a border) — deepens on hover.
    background: 'black.06',
    transition: '120ms defaultBezier background',
    ':hover': {
        background: 'black.12'
    },
    // Key-based auto-extend (bare 'Avatar' key resolves to the built-in — same
    // convention AvatarBundleItem.Avatar above uses), not an aliased extends.
    Avatar: {
        avatarType: 'initials',
        boxSize: 'B B',
        flexShrink: '0',
        src: (el, s)=>el.call('avatarUrl', s.name || s.email)
    },
    CmBody: {
        flow: 'y',
        gap: '0',
        flex: '1',
        minWidth: '0',
        CmName: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'black',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || s.email || ''
        },
        CmCity: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'black',
            opacity: '0.55',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.location || el.call('polyglot', 'workspace.teamTime.remote')
        }
    },
    // Live local time, Code-family numerals (matches the giant-numeral
    // register the other posters on this board use for their headline digits).
    CmTime: {
        tag: 'span',
        fontSize: 'B',
        fontWeight: '700',
        fontFamily: 'Code',
        color: 'black',
        flexShrink: '0',
        text: (el, s)=>{
            try {
                return new Date().toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    timeZone: s.timezone,
                    hour12: true
                }).toLowerCase().replace(' ', '');
            } catch  {
                return '';
            }
        }
    },
    // Working-hours bar — a plain 24h track with the conventional 9am-6pm
    // band lit and a marker at the teammate's current local hour (solid =
    // in hours, faded = outside). left/width percentages are DATA-derived
    // fractions of a day (same convention as the analytics/agents widgets'
    // SegBar `flex` fractions elsewhere in this project), not stand-ins for
    // a spacing token.
    CmHours: {
        flexShrink: '0',
        width: 'E',
        CmHoursTrack: {
            position: 'relative',
            height: 'V',
            round: 'radiusPill',
            overflow: 'hidden',
            background: 'black.12',
            CmHoursBand: {
                position: 'absolute',
                top: '0',
                bottom: '0',
                left: '37.5%',
                width: '37.5%',
                background: 'black.15'
            },
            CmHoursMark: {
                position: 'absolute',
                top: '0',
                bottom: '0',
                width: 'V',
                round: 'radiusPill',
                background: (el, s)=>el.scope.isWorkingHours(s.timezone) ? 'black' : 'black.35',
                left: (el, s)=>`${Math.min(96, Math.max(0, el.scope.hourFraction(s.timezone) * 100))}%`
            }
        },
        CmHoursLabel: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'black',
            opacity: '0.45',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.call('polyglot', el.scope.isWorkingHours(s.timezone) ? 'workspace.teamTime.workingHours' : 'workspace.teamTime.offHours')
        }
    }
};
const $92f6c29118a96147$export$f2823c40f8f4d14b = {
    scope: {
        // Live local time — same format CityMemberRow's CmTime above used: one
        // Code-mono reading, lowercase, no space ("4:32pm"). '—' when the zone
        // can't be resolved — reserves the slot instead of collapsing it
        // (zero-shift status UI, product-UI brief §8).
        zoneTime: (timezone)=>{
            if (!timezone) return "\u2014";
            try {
                return new Date().toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    timeZone: timezone,
                    hour12: true
                }).toLowerCase().replace(' ', '');
            } catch  {
                return "\u2014";
            }
        }
    },
    flow: 'y',
    gap: 'Y',
    padding: 'Z A',
    round: 'radiusControl',
    // Ink-wash row separation, no hairline borders — the same house
    // convention CityMemberRow used above (gap + tint, deepens on hover;
    // design-direction.md §8 borderless law).
    background: 'black.06',
    transition: '120ms defaultBezier background',
    ':hover': {
        background: 'black.12'
    },
    TzHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'A',
        TzZone: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'black',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.call('zoneLabel', s.timezone)
        },
        // Giant focal numeral — Code mono, heavy, fixed black ink (this
        // poster is theme-invariant cerulean+30/black — homeWidgetHue's
        // HOUSE_HUE_MAP — same reasoning CmTime/CmHours above documented for
        // hardcoding ink on this exact card).
        TzTime: {
            tag: 'span',
            fontSize: 'D',
            fontWeight: '700',
            fontFamily: 'Code',
            lineHeight: '1',
            color: 'black',
            flexShrink: '0',
            // Zero-shift: the '—' placeholder keeps the numeral slot reserved for
            // the no-timezone bucket, but at full ink a giant em-dash reads as
            // window chrome (a minimize glyph) — drop it to the §6 inactive
            // alpha; live readings render at full ink.
            opacity: (el, s)=>s.timezone ? '1' : '0.35',
            text: (el, s)=>el.scope.zoneTime(s.timezone)
        }
    },
    TzFoot: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        // House usage — bare AvatarBundle (key-based auto-extend, Rule 63) +
        // `emails:` (StoryCard.ScStack's exact pattern), capped at 3 with the
        // remainder covered by TzCount below (same as ScStack + ScCaption).
        // `childExtends` overridden to a registered item that layers click +
        // tooltip + presence on top of the shared AvatarBundleItem chrome
        // (avatar image, overlap, hover z-index bump all inherited unchanged).
        AvatarBundle: {
            flexShrink: '0',
            emails: (el, s)=>(s.members || []).map((m)=>m.email),
            childExtends: 'TzAvatarItem'
        },
        TzCount: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'black',
            opacity: '0.55',
            text: (el, s)=>{
                const n = (s.members || []).length;
                return `${n} ${n === 1 ? 'person' : 'people'}`;
            }
        }
    }
};
const $92f6c29118a96147$export$8db9e541def169d4 = {
    extends: 'AvatarBundleItem',
    // Self-contained copy of TzCluster.scope.zoneTime (NOT a module-scope
    // helper — FA204/frank trap; and not a reach into the ancestor's scope,
    // so this item stays mountable outside a TzCluster). Same self-contained
    // posture as shared/functions/peopleUtils.js documents in its header.
    scope: {
        zoneTime: (timezone)=>{
            if (!timezone) return "\u2014";
            try {
                return new Date().toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    timeZone: timezone,
                    hour12: true
                }).toLowerCase().replace(' ', '');
            } catch  {
                return "\u2014";
            }
        }
    },
    cursor: 'pointer',
    // Custom tooltip (openTooltip below) owns the hover surface — blank the
    // native title AvatarBundleItem declares so the browser tooltip doesn't
    // double up over it.
    title: '',
    // Poster-invariant plate: this widget's surface is the fixed
    // cerulean+30 poster (theme-invariant), so the adaptive
    // overlayStrong/title pair would flip to light-on-light in dark mode —
    // pin the plate to the poster's OWN derived ink system (homeWidgetHue's
    // {fill, ink} contract — same source TzOnlineDot's ring already reads,
    // same reasoning as TzZone/TzTime's fixed ink above).
    // 2026-09-02: resolved through `homeWidgetSurfaceHue` (the widget's colour
    // is now the USER's choice, neutral by default), and the fallbacks moved
    // from the fixed `black.15` / `black` pair to the shell's ADAPTIVE tokens —
    // a fixed black ink was right only while this card was guaranteed to carry
    // the pale cerulean poster, and reads black-on-dark the moment it does not.
    BundlePlate: {
        background: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'teamtime') || {}).fill || 'overlay',
        color: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'teamtime') || {}).ink || 'title'
    },
    // Adaptive 'overlay' would collide with this fixed-ink poster the same
    // way the home-board "Team & agents" widget's Avatars row documents for
    // its own borderColor override (pages/main.js) — ring matches the
    // poster's own bg so it reads as a punched-out seam instead.
    borderColor: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'teamtime') || {}).bg || 'dialog',
    role: 'button',
    tabindex: '0',
    aria: {
        label: (el, s)=>el.call('polyglot', 'workspace.teamTime.openAria').replace('{name}', s.name || s.email || el.call('polyglot', 'workspace.teamTime.profile'))
    },
    // Focus ring comes free from app.js's global
    // `:where([role="button"],[tabindex]):focus-visible` floor — no
    // per-component outline needed here.
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('closeTooltip');
        if (s.email) el.call('openProfileModal', s.email);
    },
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        e.preventDefault();
        el.node.click();
    },
    onMouseenter: (e, el, s)=>{
        if (!s.email) return;
        const zone = el.scope.zoneTime(s.timezone);
        const bits = [
            s.name || s.email,
            s.position,
            zone !== "\u2014" ? zone : null
        ].filter(Boolean);
        el.call('openTooltip', {
            anchorEl: el,
            text: bits.join(" \xb7 "),
            placement: 'top'
        });
    },
    onMouseleave: (e, el)=>el.call('closeTooltip'),
    TzOnlineDot: {
        // Same per-id presence map PersonCard's PcOnlineDot reads. `hide:`
        // (not `if:`) so a LATER presence sync can still light the dot up
        // without a remount — `if:` is a mount-time-only gate (see
        // OnlineMembers.js's file-header note: the documented "dock stayed
        // empty forever" bug this avoids).
        hide: (el, s)=>!(s.root?.presenceById || {})[String(s.email || '').toLowerCase()],
        position: 'absolute',
        bottom: '0',
        right: '0',
        width: 'Z',
        height: 'Z',
        round: '50%',
        background: 'green',
        // KEPT — punched-out-seam presence ring (see this file's own comment
        // above). Retokenized `'2px'` → `hairline2`.
        borderWidth: 'hairline2',
        borderStyle: 'solid',
        borderColor: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'teamtime') || {}).bg || 'dialog'
    }
};
const $92f6c29118a96147$export$855a8e3278086aed = {
    flow: 'x',
    align: 'center',
    gap: 'A',
    padding: 'Y 0',
    minWidth: '0',
    HmrBody: {
        flow: 'y',
        gap: '0',
        flex: '1',
        minWidth: '0',
        HmrFrom: {
            tag: 'span',
            fontSize: 'Z1',
            // The unread signal is WEIGHT, not a second colour: the card may carry
            // any user-picked hue, and a fixed accent would read as a second one.
            fontWeight: (el, s)=>Number(s?.unreadCount || 0) > 0 ? '700' : '500',
            color: 'inherit',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                const list = s && s.participants || [];
                const from = list.find((p)=>p && p.role === 'from') || list[0] || {};
                const email = String(from.email || '');
                return (from.name || '').split(' ')[0] || email.split('@')[0] || '';
            }
        },
        HmrSubject: {
            extends: 'HomePosterSoftInk',
            tag: 'span',
            fontSize: 'Z1',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            // An empty subject is a real mail, not an error — mail's own list shows
            // the same placeholder rather than a blank line.
            text: (el, s)=>s && s.subject || el.call('polyglot', 'workspace.widget.mailInbox.noSubject')
        }
    },
    // Gmail-scale: today reads as a clock, older reads as a date. `shortDate` is
    // the shell's own formatter, so the row needs no date code of its own.
    HmrTime: {
        extends: 'HomePosterSoftInk',
        tag: 'span',
        fontSize: 'Y2',
        whiteSpace: 'nowrap',
        flexShrink: '0',
        text: (el, s)=>s && s.lastMessageAt ? el.call('shortDate', s.lastMessageAt) : ''
    }
};

});

parcelRegister("4dmlM", function(module, exports) {

$parcel$export(module.exports, "WysiwygToolbar", () => $3119b6a475768cac$export$255a85f258b25a1b);
// Reusable WYSIWYG formatting toolbar for contenteditable editors.
// Uses document.execCommand for bold, italic, strike, underline, code, link, lists.
// Usage: WysiwygToolbar: {} — place near a contenteditable element.
// smbls 3.14.x — FA-L11 fix landed; top-level `title` + `aria: { label }`
// now reach the <button>. No more `attr: { ... }` wrapper needed for
// icon-only buttons.
// `value` is an optional second argument to execCommand — required for
// `formatBlock` (e.g. 'blockquote', 'h1') but absent for toggle commands
// like 'bold', 'insertUnorderedList', etc. (#2193)
//
// `titleKey` is a LITERAL bundle key at every call site; the tooltip and the
// accessible name are one word, resolved where they are painted.
const $3119b6a475768cac$var$_btn = (icon, titleKey, cmd, value)=>({
        extends: 'NavbarButton',
        padding: 'Y2',
        title: (el)=>el.call('polyglot', titleKey),
        aria: {
            label: (el)=>el.call('polyglot', titleKey)
        },
        color: 'caption',
        ':hover': {
            color: 'title',
            background: 'hover'
        },
        Icon: {
            name: icon
        },
        onMouseDown: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            document.execCommand(cmd, false, value || null);
        },
        onClick: (e)=>e.preventDefault()
    });
const $3119b6a475768cac$export$255a85f258b25a1b = {
    flow: 'x',
    gap: 'V',
    align: 'center left',
    Bold: $3119b6a475768cac$var$_btn('bold', 'workspace.wysiwyg.bold', 'bold'),
    Italic: $3119b6a475768cac$var$_btn('italic', 'workspace.wysiwyg.italic', 'italic'),
    Strike: $3119b6a475768cac$var$_btn('strikethrough', 'workspace.wysiwyg.strikethrough', 'strikeThrough'),
    Underline: $3119b6a475768cac$var$_btn('underline', 'workspace.wysiwyg.underline', 'underline'),
    Code: {
        extends: 'NavbarButton',
        padding: 'Y2',
        title: (el)=>el.call('polyglot', 'workspace.wysiwyg.code'),
        'aria-label': (el)=>el.call('polyglot', 'workspace.wysiwyg.code'),
        color: 'caption',
        ':hover': {
            color: 'title',
            background: 'hover'
        },
        Icon: {
            name: 'code'
        },
        onMouseDown: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const sel = window.getSelection();
            if (!sel || !sel.rangeCount || sel.isCollapsed) return;
            try {
                const code = document.createElement('code');
                code.style.cssText = 'font-family:monospace;background:rgba(255,255,255,0.08);padding:1px 4px;border-radius:3px';
                sel.getRangeAt(0).surroundContents(code);
                sel.collapseToEnd();
            } catch  {}
        },
        onClick: (e)=>e.preventDefault()
    },
    Link: {
        extends: 'NavbarButton',
        padding: 'Y2',
        title: (el)=>el.call('polyglot', 'workspace.wysiwyg.link'),
        'aria-label': (el)=>el.call('polyglot', 'workspace.wysiwyg.link'),
        color: 'caption',
        ':hover': {
            color: 'title',
            background: 'hover'
        },
        Icon: {
            name: 'link'
        },
        onMouseDown: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const sel = window.getSelection();
            const saved = sel?.rangeCount ? sel.getRangeAt(0).cloneRange() : null;
            const url = prompt('URL:');
            if (!url) return;
            if (saved) {
                sel.removeAllRanges();
                sel.addRange(saved);
            }
            document.execCommand('createLink', false, url);
        },
        onClick: (e)=>e.preventDefault()
    },
    Quote: $3119b6a475768cac$var$_btn('quote', 'workspace.wysiwyg.blockquote', 'formatBlock', 'blockquote'),
    BulletList: $3119b6a475768cac$var$_btn('listBulleted', 'workspace.wysiwyg.bulletList', 'insertUnorderedList'),
    NumberList: $3119b6a475768cac$var$_btn('listNumbered', 'workspace.wysiwyg.numberedList', 'insertOrderedList'),
    Divider: $3119b6a475768cac$var$_btn('minus', 'workspace.wysiwyg.divider', 'insertHorizontalRule')
};

});

parcelRegister("36JmD", function(module, exports) {

$parcel$export(module.exports, "AdminUserGroupHeader", () => $24351f04b05a1d15$export$2fd14c10a20f4a15);
$parcel$export(module.exports, "AdminUserRow", () => $24351f04b05a1d15$export$a95ea0363e7aded2);
$parcel$export(module.exports, "AdminSidebar", () => $24351f04b05a1d15$export$f645866abb13e87f);
$parcel$export(module.exports, "AdminSidebarGroup", () => $24351f04b05a1d15$export$3750d6e54fb3ad6d);
$parcel$export(module.exports, "AdminSidebarLinks", () => $24351f04b05a1d15$export$4637161c8abc2e14);
$parcel$export(module.exports, "AdminSidebarLink", () => $24351f04b05a1d15$export$235cac2b64fb3140);
$parcel$export(module.exports, "_shortDate", () => $24351f04b05a1d15$export$203b6caa044f0483);
$parcel$export(module.exports, "_shellDayKey", () => $24351f04b05a1d15$export$f6390cf72abaae20);
$parcel$export(module.exports, "AdminLogDay", () => $24351f04b05a1d15$export$95dc47629e2e2358);
$parcel$export(module.exports, "AdminLogGroup", () => $24351f04b05a1d15$export$caaadaa1b04c1a9a);
$parcel$export(module.exports, "AdminLogCalendar", () => $24351f04b05a1d15$export$59c0ad645191b1dc);
$parcel$export(module.exports, "AdminLogCalendarCell", () => $24351f04b05a1d15$export$9dfad21e541a2731);
$parcel$export(module.exports, "AdminLogRow", () => $24351f04b05a1d15$export$d0ed67ec38d5b0e0);
$parcel$export(module.exports, "_isRowDirty", () => $24351f04b05a1d15$export$9f287ab0c9aa508f);
$parcel$export(module.exports, "AdminActivityScoringRow", () => $24351f04b05a1d15$export$16673c9d28d07522);
$parcel$export(module.exports, "_humanizeSystemCause", () => $24351f04b05a1d15$export$a75a2d6017b2383e);
$parcel$export(module.exports, "_fmtDateOnly", () => $24351f04b05a1d15$export$b1bd09d39bcad15);
$parcel$export(module.exports, "_attrMembers", () => $24351f04b05a1d15$export$e9514352a9faa14f);
$parcel$export(module.exports, "_attrSystem", () => $24351f04b05a1d15$export$4d272662f0226dda);
$parcel$export(module.exports, "_attrMachines", () => $24351f04b05a1d15$export$2689b344f0ba5c7d);
$parcel$export(module.exports, "_attrUnattributed", () => $24351f04b05a1d15$export$d9bcc17ed2e8385d);
$parcel$export(module.exports, "_attrTotal", () => $24351f04b05a1d15$export$4dbc9f957e02818d);
$parcel$export(module.exports, "_humanizeKey", () => $24351f04b05a1d15$export$dbe4c25474b0ee24);
$parcel$export(module.exports, "_tierPerks", () => $24351f04b05a1d15$export$5e16b17e9ff90170);
$parcel$export(module.exports, "_planIdForTier", () => $24351f04b05a1d15$export$fefd3c3b5a2d0f1);
$parcel$export(module.exports, "_captureSignupCheckout", () => $24351f04b05a1d15$export$3ad805742cb9361);
$parcel$export(module.exports, "_takeSignupCheckoutFor", () => $24351f04b05a1d15$export$5a1c4fd014840ca5);
$parcel$export(module.exports, "_fmtCredits", () => $24351f04b05a1d15$export$617184298645dd57);
$parcel$export(module.exports, "_fmtCreditsUnit", () => $24351f04b05a1d15$export$f907c7510f8a2601);
$parcel$export(module.exports, "AttrMemberRow", () => $24351f04b05a1d15$export$e8ee4e9abcff9583);
$parcel$export(module.exports, "AttrMachineChip", () => $24351f04b05a1d15$export$6da80ab6c1c731be);
$parcel$export(module.exports, "AdminLedgerRow", () => $24351f04b05a1d15$export$500d0f7b9db1b30e);
$parcel$export(module.exports, "AdminUsageRow", () => $24351f04b05a1d15$export$c9d7fbe9166ed6c1);
// AdminChrome — the admin surface's chrome components (Users & Roles rows,
// admin sidebar, activity-log day/group/row + mini calendar, activity-scoring
// row), extracted verbatim from the pages/admin/{admin,logs,activity-scoring}.js
// PAGE modules (bundle-split T1b).
//
// WHY THIS FILE EXISTS: eager component registries (components/index.js here +
// shared/components/IdentityAdminComponents.js) must never import PAGE modules —
// a static `export { X } from '../pages/admin/admin.js'` pins the whole page
// body (route def, fetch, onCreate loaders) into the eager shell/boot chunk
// even though the routes themselves lazy-load via the pages/index.js lazyPage
// folds. Page trees resolve these components by bare key / string `extends`
// through the registry, so moving the defs here is transparent to the pages;
// the page modules keep compat re-exports so their public API is unchanged.
// Helpers shared by BOTH a moved component AND remaining page code (_shortDate,
// _shellDayKey, _isRowDirty) are exported from here and imported back by the pages —
// single source, never duplicated.
// Leaf module, NOT the functions barrel: this component is reachable from
// the workspace-shared components barrel (IdentityAdminComponents), which
// loads during shared's own init — importing the shell functions barrel
// from here re-entered the still-initializing shared barrel and crashed
// the shell boot (2026-08-12).

var $k3hwI = parcelRequire("k3hwI");
const $24351f04b05a1d15$export$2fd14c10a20f4a15 = {
    // The shared table kit's header row (design brief 4.5 item 2): a tonal
    // plate, eyebrow labels (`Y`, 500, uppercase, the quiet ink), no stroke.
    // It replaced a 2px `line` underline and 700 `caption` labels. The
    // columns and the responsive steps stay this table's own.
    extends: 'AppTableHead',
    columns: '2fr 1fr auto',
    // The scroll floor of the table, a spacing token (it was a raw 520px — the
    // /admin/teams member table uses the same `H`).
    minWidth: 'H',
    H01: {
        text: '{{ admin.users.col.name | polyglot }}'
    },
    H02: {
        text: '{{ admin.users.col.role | polyglot }}'
    },
    H03: {
        text: '',
        width: 'C2'
    },
    // iPad (≤1024): drop the floor so the header shrinks to fit the panel;
    // ≤768 it hides entirely (below). @tabletS precedes @mobileL so ≤768 wins.
    '@tabletS': {
        minWidth: '0'
    },
    '@mobileL': {
        display: 'none'
    }
};
const $24351f04b05a1d15$export$a95ea0363e7aded2 = {
    // The shared table kit's record row (design brief 4.5 item 3): `controlH`
    // tall, the `hover` fill, no stroke — rows separate by the table's gap.
    // It replaced a hairline `line` divider under every row and a `dialog`
    // theme hover.
    extends: 'AppTableRow',
    columns: '2fr 1fr auto',
    minWidth: 'H',
    cursor: 'pointer',
    // iPad (≤1024): drop the floor so the 3-col row shrinks to fit; ≤768 it
    // restacks (below). @tabletS precedes @mobileL so the stacked layout wins ≤768.
    '@tabletS': {
        minWidth: '0'
    },
    '@mobileL': {
        gridTemplateColumns: 'minmax(0, 1fr) auto',
        gridTemplateAreas: '"person person" "role action"',
        minWidth: '0',
        gap: 'Z1',
        padding: 'A',
        round: 'radiusControl',
        // A phone card per person: the `dialog` fill separates the cards, with
        // no stroke (§2.5).
        background: 'dialog'
    },
    // §unified-perms PR #8 — row click opens PersonDetailModal (effective
    // perms drill-down). EditBtn keeps its profile-navigation behavior so
    // operators can still jump to the canonical profile page.
    // Spread the explicit row fields the modal needs — NOT the smbls
    // state proxy `s`. Spreading the proxy enumerates whatever accessors
    // smbls happens to expose (root / parent / signal handles), and any
    // future minor-version bump that surfaces a new enumerable accessor
    // would silently capture a back-ref into root, breaking the next
    // state-clone path. Mirror the canvas peer at
    // team-and-agents.js _onNodeClick which spreads the underlying
    // person object for the same reason.
    onClick: (e, el, s)=>{
        if (!s.email) return;
        el.call('openPersonDetailModal', {
            email: s.email,
            name: s.name,
            avatar: s.avatar,
            userId: s.userId
        });
    },
    Left: {
        flow: 'x',
        align: 'center',
        gap: 'Z1',
        minWidth: '0',
        '@mobileL': {
            gridArea: 'person'
        },
        // House identity plate — `Monogram` key, NOT `Avatar`: the bare `Avatar`
        // key auto-extends the built-in (tag img), and initials text inside an
        // <img> is invalid. White-on-blue also measured 3.62:1 (needs 4.5).
        //
        // Two honest fields since the 2026-09-01 split (loadPrivateData.js
        // `_person`): `s.avatar` is a photo URL or EMPTY, `s.initials` carries
        // the letters. The old single overloaded field caused BOTH failure
        // modes in turn: painted a raw photo URL as garbled circle text
        // (AVATAR-URL-LEAK-1, tickets/sonnet.md) and, guarded the other way,
        // 404-fetched the letters as a path on every load — `hide:` is
        // display:none only, and a hidden <img> still requests its src.
        Monogram: {
            align: 'center center',
            width: 'B1',
            height: 'B1',
            round: '50%',
            color: 'title',
            fontSize: 'Z',
            fontWeight: '700',
            overflow: 'hidden',
            background: 'overlayStrong',
            flex: '0 0 auto',
            position: 'relative',
            MonogramImg: {
                tag: 'img',
                // `if:`, never `hide:` — a display:none <img> still FETCHES its
                // src, so a non-URL value 404ed against the origin on every load.
                // No node, no request.
                if: (el, s)=>typeof s?.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
                position: 'absolute',
                inset: '0',
                width: '100%',
                height: '100%',
                // Belt on top of the if: gate — a non-URL value never reaches src
                // (an absent src fires no request; src:'' can fetch the page URL).
                src: (el, s)=>typeof s?.avatar === 'string' && /^(https?:|\/)/.test(s.avatar) ? s.avatar : null,
                alt: (el, s)=>s?.name || '',
                style: {
                    objectFit: 'cover'
                }
            },
            MonogramText: {
                tag: 'span',
                hide: (el, s)=>typeof s?.avatar === 'string' && /^(https?:|\/)/.test(s.avatar),
                text: (el, s)=>s?.initials || ''
            }
        },
        Info: {
            flow: 'y',
            gap: 'V',
            flex: '1',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.name
            },
            Email: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'caption',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.email
            }
        }
    },
    // Role hue as a DOT + neutral ink (RmDot pattern) — white ink on the
    // user-configured role hue cannot be proven AA for arbitrary hues.
    RoleBadge: {
        tag: 'span',
        flow: 'x',
        align: 'center',
        gap: 'Y',
        padding: 'V Z1',
        round: 'radiusPill',
        alignSelf: 'center',
        justifySelf: 'flex-start',
        width: 'fit-content',
        background: 'overlayStrong',
        color: 'title',
        fontSize: 'Z2',
        fontWeight: '700',
        '@mobileL': {
            gridArea: 'role',
            justifySelf: 'start'
        },
        // `s.root.roles` stays undefined until `_loadRoles` resolves at least
        // once (functions/loadPrivateData.js) — before that, `roleOf` always
        // misses and the old unconditional `|| 'member'` fallback painted a
        // confident, WRONG "Member" for every row (including the signed-in
        // admin's own Owner row) that then flipped to the real role once the
        // fetch landed. A reader watching that transition on their OWN row sees
        // it as "my access just changed" (tickets/sonnet.md ROLE-FLIP-1). Render
        // a neutral loading state instead of a specific-but-unproven role until
        // `roles.byUser` genuinely exists — after that, an unmatched userId is a
        // real "member" default, not a loading gap.
        RoleDot: {
            tag: 'span',
            width: 'Y',
            height: 'Y',
            round: '50%',
            flex: '0 0 auto',
            background: (el, s)=>{
                if (!s.root?.roles?.byUser) return 'caption';
                return (0, $k3hwI.roleColor)(s, s.userId ? (0, $k3hwI.roleOf)(s, s.userId) || 'member' : 'member');
            }
        },
        RoleText: {
            tag: 'span',
            text: (el, s)=>{
                s.root.roles && s.root.roles.version;
                if (!s.root?.roles?.byUser) return "\u2026";
                const cur = s.userId ? (0, $k3hwI.roleOf)(s, s.userId) || 'member' : 'member';
                // A system role resolves through the bundle (roles.js roleLabelKey).
                const key = (0, $k3hwI.roleLabelKey)(cur);
                return key ? el.call('polyglot', key) : (0, $k3hwI.roleLabel)(s, cur);
            }
        }
    },
    // The row action sits INSIDE a cell: the table kit gives every DIRECT
    // child of a row role="cell", and a <button> with role="cell" is no longer
    // a button to assistive tech (admin fix lane C, 2026-09-24). The button is
    // the admin compact control — it measured 26.7px (V Z1 padding), neither
    // control height, on all 79 rows of the live roster.
    Action: {
        alignSelf: 'center',
        '@mobileL': {
            gridArea: 'action',
            justifySelf: 'end'
        },
        EditBtn: {
            extends: 'AdminActionBtnCompact',
            text: '{{ common.action.edit | polyglot }}',
            // Seventy-nine buttons that all say "Edit" — the name says whose.
            ariaLabel: (el, s)=>el.call('polyglot', 'admin.users.editAria').replace('{name}', s.name || s.email || ''),
            onClick: (e, el, s)=>{
                if (!s.email) return;
                // Row click opens the perm-detail modal; the Edit button is the
                // explicit "navigate to profile" affordance. Stop propagation so
                // this click doesn't also fire the row's modal handler.
                if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
                const root = el.call('findRouteRoot', el);
                if (root) el.router(el.call('profilePath', s.email), root);
            }
        }
    }
};
const $24351f04b05a1d15$export$f645866abb13e87f = {
    extends: 'AppSidebar',
    tag: 'nav',
    ariaLabel: (el)=>el.call('polyglot', 'admin.nav.ariaLabel'),
    // On the page-sidebar rule (shared functions/pageSidebar.js) for every
    // /admin page — one page key, `admin`: opposite a rail navbar, hideable.
    // The first group opens with its heading, so the button's corner is free.
    pageSidebar: true,
    PeopleSection: null,
    width: 'G',
    minWidth: 'G',
    '@mobileL': {
        width: '100%',
        minWidth: '0'
    },
    Top: null,
    // Admin is its own destination, not a canvas-view context — drop the shared
    // AppSidebar global view switcher (Frontend / Infra / Tasks / Agents) so the
    // admin rail shows only the admin sections (per Nika "remove Views section").
    ViewSwitcher: null,
    // THE GROUPS (persona audit WH-8): the rail's 19 entries ran as one list, a
    // business owner read "Client Module" and "Feature Flags" beside "Users &
    // Roles", and at 1366x768 the last entries sat cut off below the screen. The
    // entries now come in four named groups (functions/adminRail.js — the ONE
    // table, and the rule that folds the developer group on a business
    // workspace), and the list scrolls inside the rail (`flex` + `minHeight: 0`
    // + `overflowY`, the house rail shape — AppSidebar: "each rail's Middle has
    // its own overflow: auto").
    Middle: {
        flow: 'y',
        gap: 'Z',
        flex: '1',
        minHeight: '0',
        overflowY: 'auto',
        childExtends: 'AdminSidebarGroup',
        childrenAs: 'state',
        children: (el, s)=>el.call('adminRailGroups', s.root)
    }
};
const $24351f04b05a1d15$export$3750d6e54fb3ad6d = {
    tag: 'section',
    flow: 'y',
    gap: 'V',
    Heading: {
        if: (el, s)=>!s.foldable,
        tag: 'h2',
        margin: '0',
        padding: 'Z Z1 0',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'caption',
        // KEY-IN-STATE: the group carries a bundle key.
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    AdminSidebarLinks: {
        if: (el, s)=>!s.foldable
    },
    Fold: {
        if: (el, s)=>!!s.foldable,
        tag: 'details',
        flow: 'y',
        gap: 'V',
        // Open unless the rule folds it (functions/adminRail.js); the person's own
        // toggle stands until that answer changes.
        open: (el, s)=>s.folded ? null : true,
        // A `summary` keeps its native list-item box, so the open / closed marker
        // is the browser's own (a flex box would drop it); the vertical padding
        // centres one line in the compact control height.
        // (the key names the base: FA806 — the house focus ring of `Focusable`)
        Focusable: {
            tag: 'summary',
            minHeight: 'controlHCompact',
            padding: 'Z Z1',
            boxSizing: 'border-box',
            round: 'radiusControl',
            fontSize: 'Z',
            fontWeight: '500',
            color: 'caption',
            cursor: 'pointer',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            ':active': {
                background: 'selected',
                color: 'title'
            },
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        AdminSidebarLinks: {}
    }
};
const $24351f04b05a1d15$export$4637161c8abc2e14 = {
    flow: 'y',
    gap: 'V',
    childExtends: 'AdminSidebarLink',
    childrenAs: 'state',
    children: (el, s)=>s.rows || []
};
const $24351f04b05a1d15$export$235cac2b64fb3140 = {
    extends: 'Link',
    attr: {
        // s.href, not el.href — el.href is the declared factory, so the
        // comparison could never match (same trap as the onClick fix below).
        'aria-current': (el, s)=>(s.root?.route || s.root?.currentPath || '/') === s.href ? 'page' : undefined
    },
    Icon: {
        name: (el, s)=>s.icon || 'settings',
        boxSize: 'Z1',
        flexShrink: '0',
        ariaHidden: 'true'
    },
    // KEY-IN-STATE: the rail's rows carry bundle keys.
    Label: {
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    // The compact control (`controlHCompact`, 36px): the `Z A` padding made
    // every rail row 38.75px — neither control height — on all 19 rows of all
    // 23 admin pages (the largest row of the admin audit, 2026-09-24). Compact,
    // not 44: nineteen rows at 44 would push the rail past a laptop screen.
    flow: 'x',
    align: 'center flex-start',
    minHeight: 'controlHCompact',
    padding: '0 Z1',
    gap: 'Z',
    round: 'radiusControl',
    fontSize: 'Z2',
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    cursor: 'pointer',
    href: (el, s)=>s.href,
    // Slot-aware navigation. Admin is a full-page destination now
    // (searchApps.isFullPageRoute), but if an admin page is EVER mounted
    // inside a PageSlot pane, a plain Link would fire a shell navigation
    // that leaves the slot open over a stale page (same-section, so
    // _dismissStaleSlot won't close it). When inside a pane, re-point that
    // pane's route instead; otherwise normal full-page routing.
    // (2026-07-25 per Nika "fix sidebar nav clicks when its in pageslot".)
    onClick: (e, el, s)=>{
        // `el.href` is the FACTORY here ((el,s)=>s.href), not the resolved
        // string — v3.14 keeps declared factories on the element, so routing it
        // handed the router a function, matched nothing, and fell back to '/'
        // (the "every admin sidebar click lands on the dashboard" bug,
        // 2026-08-01 per Nika — broke the PageSlot branches identically via a
        // function in _canvasSlot). Read the state value the factory resolves
        // from, with the rendered attr as the fallback.
        const href = s && s.href || el.node?.getAttribute?.('href');
        if (!href || e.metaKey || e.ctrlKey) return; // let cmd/ctrl-click open a real tab
        e.preventDefault();
        const inPrimary = el.node?.closest?.('[data-key="PanePrimary"]');
        const inSecond = el.node?.closest?.('[data-key="PaneSecond"]');
        if (inPrimary) return s.root.update({
            _canvasSlot: href
        });
        if (inSecond) return s.root.update({
            _canvasSlotSecond: href
        });
        const root = el.call('findRouteRoot', el) || el.getRoot();
        if (root) el.router(href, root);
    },
    // Active state via .isActive class (not reactive bg/color factories, which emit
    // inline styles that clobber :hover) so the hover wash actually renders.
    isActive: (el, s)=>(s.root?.currentPath || '/') === s.href,
    color: 'subtitle',
    // Match the house sidebar rows (InfraSidebar / TicketsSidebar / FilesSidebar):
    // the shared `hover`/`selected` washes (§4.3) — a frosted wash on hover, a
    // slightly stronger wash + 700 weight when active. The old `overlay` token
    // rendered as a flat near-opaque fill that didn't read as a hover/active pill.
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    '.isActive': {
        background: 'selected',
        color: 'title',
        fontWeight: '700'
    }
};
// ── /admin/logs chrome — formatting helpers ────────────────────────────
const $24351f04b05a1d15$var$_shellTypeLabel = {
    standup: 'admin.activity.type.standup',
    ticket_update: 'admin.activity.type.ticketUpdate',
    note_edit: 'admin.activity.type.noteEdit',
    kb_edit: 'admin.activity.type.kbEdit',
    meet_call: 'admin.activity.type.meetCall'
};
// `el` (optional, last): with it the clock reads the way the SESSION language
// writes one — `hour12: true` forced `4:05 PM` onto a Georgian log, which
// reads the 24-hour clock. English keeps its 12-hour form through the locale.
const $24351f04b05a1d15$var$_shortTime = (ts, el)=>{
    try {
        const d = new Date(ts);
        const out = el && typeof el.call === 'function' ? el.call('localizedDate', d, {
            hour: 'numeric',
            minute: '2-digit'
        }) : '';
        return typeof out === 'string' && out ? out : d.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    } catch  {
        return '';
    }
};
const $24351f04b05a1d15$export$203b6caa044f0483 = (ts, el)=>{
    try {
        const d = new Date(ts);
        const today = new Date();
        // `el` may be a bare object (a specimen, a test): only a real element
        // carries `call`, and without one the old English output stays.
        const host = el && typeof el.call === 'function' ? el : null;
        const word = (key, fallback)=>{
            const text = host ? host.call('polyglot', key) : null;
            return typeof text === 'string' && text && text !== key ? text : fallback;
        };
        const sameDay = d.toDateString() === today.toDateString();
        if (sameDay) return word('common.time.today', 'Today');
        const yest = new Date();
        yest.setDate(today.getDate() - 1);
        if (d.toDateString() === yest.toDateString()) return word('common.time.yesterday', 'Yesterday');
        const sameYear = d.getFullYear() === today.getFullYear();
        const opts = sameYear ? {
            month: 'short',
            day: 'numeric'
        } : {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        };
        const out = host ? host.call('localizedDate', d, opts) : '';
        return typeof out === 'string' && out ? out : d.toLocaleDateString(undefined, opts);
    } catch  {
        return '';
    }
};
const $24351f04b05a1d15$export$f6390cf72abaae20 = (r)=>r.occurred_on || (r.created_at ? r.created_at.slice(0, 10) : '');
const $24351f04b05a1d15$export$95dc47629e2e2358 = {
    flow: 'y',
    gap: 'Z1',
    DayHeader: {
        flow: 'x',
        align: 'baseline space-between',
        gap: 'Z',
        paddingBottom: 'V',
        // Borderless law — bold H3 Title + caption Stats already read as the
        // section head via typographic hierarchy + padding, same reasoning as
        // shared/AiActionConfirmCard's Header divider removal.
        // The day is the page's second heading level, under the page title (h1).
        // It was an h3 straight under the h1 — a skipped level (admin census,
        // 2026-09-24).
        Title: {
            tag: 'h2',
            margin: '0',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>$24351f04b05a1d15$export$203b6caa044f0483(s._day, el)
        },
        Stats: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', s._totalEvents === 1 ? 'admin.logs.day.eventCountOne' : 'admin.logs.day.eventCount').replace('{count}', s._totalEvents)
        }
    },
    Authors: {
        flow: 'y',
        gap: 'Z1',
        childExtends: 'AdminLogGroup',
        childrenAs: 'state',
        children: (el, s)=>s._authors
    }
};
const $24351f04b05a1d15$export$caaadaa1b04c1a9a = {
    extends: 'AdminCard',
    gap: 'Y',
    padding: 'Z1',
    // Not `Header`: a key that names an HTML element renders as that element.
    AuthorBar: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z1',
        // The rows below inset their cells by `A`; the bar lines up with them.
        padding: 'Y A',
        '@mobileL': {
            flow: 'y',
            align: 'stretch'
        },
        LeftGroup: {
            flow: 'x',
            align: 'center left',
            gap: 'Z',
            minWidth: '0',
            '@mobileL': {
                flexWrap: 'wrap'
            },
            // A background-image circle, not a bare `Avatar` key: that key extends
            // the framework built-in, an <img> that takes no `background` fill.
            // A member with no photo gets the generated avatar the /admin/usage
            // member rows use, not a raw `--color-blue` disc.
            Monogram: {
                boxSize: 'A',
                round: 'radiusPill',
                flexShrink: '0',
                background: (el, s)=>{
                    const me = el.call('findPerson', s._email);
                    return `url(${me?.avatar || el.call('avatarUrl', me?.name || s._email || '?')}) center/cover`;
                }
            },
            Name: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const me = el.call('findPerson', s._email);
                    return me?.name || s._email;
                }
            },
            Email: {
                hide: (el, s)=>{
                    const me = el.call('findPerson', s._email);
                    return !me?.name;
                },
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>s._email
            }
        },
        Stats: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', s._count === 1 ? 'admin.logs.author.statsOne' : 'admin.logs.author.stats').replace('{count}', s._count).replace('{score}', s._totalScore)
        }
    },
    // The shared table kit (design brief 4.5): the events are an AppTable —
    // stroke-free rows that separate by its gap. The card's own inset keeps
    // the row hover capsule inside the card.
    Events: {
        extends: 'AppTable',
        childExtends: 'AdminLogRow',
        childrenAs: 'state',
        children: (el, s)=>s._events
    }
};
// ── Calendar (mini month view) ─────────────────────────────────────────
const $24351f04b05a1d15$var$_monthGrid = (year, month)=>{
    // Returns 6×7 = 42 cells for the month view (leading/trailing days included).
    const first = new Date(year, month, 1);
    const startDow = (first.getDay() + 6) % 7 // Monday-first
    ;
    const start = new Date(year, month, 1 - startDow);
    const cells = [];
    for(let i = 0; i < 42; i++){
        const d = new Date(start);
        d.setDate(start.getDate() + i);
        cells.push({
            _date: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`,
            _day: d.getDate(),
            _inMonth: d.getMonth() === month
        });
    }
    return cells;
};
const $24351f04b05a1d15$var$_stepMonth = (s, by)=>{
    const y = s.root?._adminLogsCalYear ?? new Date().getFullYear();
    const m = s.root?._adminLogsCalMonth ?? new Date().getMonth();
    const next = new Date(y, m + by, 1);
    s.root?.update({
        _adminLogsCalYear: next.getFullYear(),
        _adminLogsCalMonth: next.getMonth()
    });
};
const $24351f04b05a1d15$export$59c0ad645191b1dc = {
    flow: 'y',
    gap: 'Y',
    onCreate: (el, s)=>{
        const root = s.root;
        if (!root) return;
        const today = new Date();
        if (root._adminLogsCalYear == null || root._adminLogsCalMonth == null) root.update({
            _adminLogsCalYear: today.getFullYear(),
            _adminLogsCalMonth: today.getMonth()
        });
    },
    Nav: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        // The admin icon-only control: a named 36px square with the house hover
        // and press steps. The arrows were the text glyphs ‹ › in a 16.39px box.
        Prev: {
            extends: 'AdminIconBtn',
            ariaLabel: (el)=>el.call('polyglot', 'common.action.previous'),
            Icon: {
                name: 'chevronLeft',
                boxSize: 'Z1'
            },
            onClick: (e, el, s)=>$24351f04b05a1d15$var$_stepMonth(s, -1)
        },
        Label: {
            tag: 'span',
            flex: '1',
            textAlign: 'center',
            fontSize: 'Z2',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>{
                const y = s.root?._adminLogsCalYear ?? new Date().getFullYear();
                const m = s.root?._adminLogsCalMonth ?? new Date().getMonth();
                // The interface language, through polyglot's OWN resolver — never
                // `undefined` (which asks Intl for the BROWSER's locale, not the
                // language this member picked) and never a second hand-written
                // `root.lang > default > 'en'` chain.
                return el.call('localizedDate', new Date(y, m, 1), {
                    month: 'long',
                    year: 'numeric'
                });
            }
        },
        Next: {
            extends: 'AdminIconBtn',
            ariaLabel: (el)=>el.call('polyglot', 'common.action.next'),
            Icon: {
                name: 'chevronRight',
                boxSize: 'Z1'
            },
            onClick: (e, el, s)=>$24351f04b05a1d15$var$_stepMonth(s, 1)
        }
    },
    // The weekday heads read the bundle's short names (they were the literal
    // letters M T W T F S S — English on a Georgian log). Decorative for
    // assistive tech: every day cell names its full date.
    Dows: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        gap: 'W',
        aria: {
            hidden: 'true'
        },
        // `Z`, never smaller: tokens are em, and `Y` read 9.7px in the rail.
        childProps: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '500',
            color: 'caption',
            textAlign: 'center',
            whiteSpace: 'nowrap'
        },
        DowMon: {
            text: '{{ common.weekdayShort.mon | polyglot }}'
        },
        DowTue: {
            text: '{{ common.weekdayShort.tue | polyglot }}'
        },
        DowWed: {
            text: '{{ common.weekdayShort.wed | polyglot }}'
        },
        DowThu: {
            text: '{{ common.weekdayShort.thu | polyglot }}'
        },
        DowFri: {
            text: '{{ common.weekdayShort.fri | polyglot }}'
        },
        DowSat: {
            text: '{{ common.weekdayShort.sat | polyglot }}'
        },
        DowSun: {
            text: '{{ common.weekdayShort.sun | polyglot }}'
        }
    },
    // One choice among the days: a named group, each day a toggle button
    // (aria-pressed) — the chosen one is the brand's choice inversion.
    Grid: {
        role: 'group',
        ariaLabel: (el)=>el.call('polyglot', 'admin.logs.filterByDate'),
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        gap: 'W',
        childExtends: 'AdminLogCalendarCell',
        childrenAs: 'state',
        children: (el, s)=>{
            const y = s.root?._adminLogsCalYear ?? new Date().getFullYear();
            const m = s.root?._adminLogsCalMonth ?? new Date().getMonth();
            return $24351f04b05a1d15$var$_monthGrid(y, m);
        }
    }
};
const $24351f04b05a1d15$export$9dfad21e541a2731 = {
    tag: 'button',
    type: 'button',
    minHeight: 'controlHCompact',
    minWidth: '0',
    padding: '0',
    round: 'radiusControl',
    border: 'none',
    background: 'transparent',
    color: 'caption',
    // The surrounding size (`A` is 1em of the parent).
    fontSize: 'A',
    fontWeight: '400',
    fontFamily: 'inherit',
    cursor: 'pointer',
    transition: 'Z defaultBezier background',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    hasLogs: (el, s)=>s._inMonth && (s.root?.adminLogs || []).some((r)=>$24351f04b05a1d15$export$f6390cf72abaae20(r) === s._date),
    isSelected: (el, s)=>s._inMonth && s.root?._adminLogsSelectedDate === s._date,
    isOutside: (el, s)=>!s._inMonth,
    '.hasLogs': {
        color: 'title',
        fontWeight: '700'
    },
    '.isSelected': {
        background: 'highlight',
        color: 'highlight-reversed',
        fontWeight: '700'
    },
    '.isOutside': {
        visibility: 'hidden'
    },
    disabled: (el, s)=>!s._inMonth,
    aria: {
        pressed: (el, s)=>s._inMonth ? String(s.root?._adminLogsSelectedDate === s._date) : null,
        hidden: (el, s)=>s._inMonth ? null : 'true'
    },
    ariaLabel: (el, s)=>el.call('localizedDate', new Date(`${s._date}T00:00:00`), {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        }),
    text: (el, s)=>String(s._day),
    onClick: (e, el, s)=>{
        if (!s._inMonth) return;
        const cur = s.root?._adminLogsSelectedDate;
        s.root?.update({
            _adminLogsSelectedDate: cur === s._date ? null : s._date
        });
    }
};
const $24351f04b05a1d15$export$d0ed67ec38d5b0e0 = {
    // The shared table kit's record row (design brief 4.5 item 3): `controlH`,
    // the `hover` fill, no stroke — it replaced a hairline `line` rule over
    // every row. The cells sit in NAMED areas, so a row whose `Ref` is hidden
    // keeps `Detail` in its own column instead of letting auto-placement pull
    // it into the ref slot. The first four tracks are CONTENT-sized (`auto`)
    // and each cell keeps the minimum width it had in the old flex row: fixed
    // tracks at those minimums wrapped "Ticket update" onto two lines and ran
    // the ref id into the detail text (measured live on dev, 2026-09-24). The
    // row font is the house sans: `fontFamily: 'mono'` named no token, so it
    // never painted a mono face; the score is the kit's numeric cell.
    extends: 'AppTableRow',
    columns: 'auto auto auto auto minmax(0, 1fr)',
    templateAreas: '"when type score ref detail"',
    alignItems: 'baseline',
    // The brand's compact size, `Z`. At `Y2` the tokens under it compounded
    // (em) below the smallest step: the time read 9.9px, the score 11.0px.
    fontSize: 'Z',
    lineHeight: '1.55',
    '@mobileL': {
        gridTemplateColumns: 'minmax(0, 1fr) auto',
        gridTemplateAreas: '"type score" "when when" "ref ref" "detail detail"',
        alignItems: 'start',
        gap: 'V Z',
        padding: 'Z1 A'
    },
    When: {
        gridArea: 'when',
        flow: 'y',
        gap: '0',
        minWidth: 'D',
        '@mobileL': {
            flow: 'x',
            gap: 'Z',
            minWidth: '0'
        },
        Date: {
            tag: 'span',
            color: 'subtitle',
            fontWeight: '700',
            text: (el, s)=>$24351f04b05a1d15$export$203b6caa044f0483(s.occurred_on || s.created_at, el)
        },
        Time: {
            tag: 'span',
            color: 'caption',
            text: (el, s)=>$24351f04b05a1d15$var$_shortTime(s.created_at, el)
        }
    },
    // The event type in the neutral ink. It was a per-type HUE (green, purple,
    // cerulean, accentInk) at 700: hue marks a status in the chrome register,
    // never a category, and purple read 2.5:1 on the card in dark.
    Type: {
        gridArea: 'type',
        tag: 'span',
        minWidth: 'C1',
        whiteSpace: 'nowrap',
        fontWeight: '500',
        color: 'title',
        '@mobileL': {
            minWidth: '0'
        },
        text: (el, s)=>el.call('polyglot', $24351f04b05a1d15$var$_shellTypeLabel[s.activity_type] || s.activity_type || '')
    },
    Score: {
        extends: 'AppTableNum',
        gridArea: 'score',
        tag: 'span',
        minWidth: 'A2',
        '@mobileL': {
            minWidth: '0'
        },
        color: 'caption',
        fontWeight: '700',
        text: (el, s)=>`+${s.score || 0}`
    },
    // The source reference. The cell WRAPS the control: the table kit gives
    // every DIRECT child of a row role="cell", and a <button role="cell"> is
    // no longer a button to assistive tech. The reference is a LINK to where
    // the event happened (a ticket, a note, a room) — an inline link, exempt
    // from the control heights like any link in running text; it was a 20.55px
    // <button> on all 200 rows (admin census, 2026-09-24). It keeps the
    // neutral ink and marks itself by its underline: the accent ink read
    // 3.92:1 on a hovered dark row. A reference with no destination is plain
    // text, never a dead control.
    Ref: {
        hide: (el, s)=>!el.call('historyEventRef', s),
        gridArea: 'ref',
        minWidth: 'B1',
        whiteSpace: 'nowrap',
        '@mobileL': {
            minWidth: '0'
        },
        RefLink: {
            extends: 'Link',
            hide: (el, s)=>!el.call('historyEventHref', s),
            href: (el, s)=>el.call('historyEventHref', s),
            color: 'title',
            fontWeight: '700',
            textDecoration: 'underline',
            textDecorationColor: 'caption',
            transition: 'Z defaultBezier text-decoration-color',
            ':hover': {
                textDecorationColor: 'currentColor'
            },
            text: (el, s)=>el.call('historyEventRef', s),
            onClick: (e, el, s)=>{
                // A modified click is the browser's: a new tab or window.
                if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
                e.preventDefault();
                e.stopPropagation();
                el.call('openHistoryEvent', s);
            }
        },
        RefText: {
            hide: (el, s)=>!!el.call('historyEventHref', s),
            tag: 'span',
            color: 'caption',
            fontWeight: '700',
            text: (el, s)=>el.call('historyEventRef', s)
        }
    },
    Detail: {
        gridArea: 'detail',
        tag: 'span',
        minWidth: '0',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%',
        '@mobileL': {
            whiteSpace: 'normal',
            wordBreak: 'break-word'
        },
        text: (el, s)=>el.call('historyEventTitle', s)
    }
};
const $24351f04b05a1d15$export$9f287ab0c9aa508f = (r)=>r._draftEnabled !== r.enabled || r._draftScore !== r.score;
const $24351f04b05a1d15$var$_patchRow = (rows, type, patch)=>rows.map((r)=>r.activity_type === type ? {
            ...r,
            ...patch
        } : r);
const $24351f04b05a1d15$var$_commitDraft = (root, rows)=>root?.update({
        activityScoring: rows,
        activityScoringDirty: rows.some($24351f04b05a1d15$export$9f287ab0c9aa508f),
        // A fresh edit supersedes whatever the last save attempt reported —
        // the stale "wasn't saved" banner must not survive the user acting on
        // it (tickets/sonnet.md P2).
        _activityScoringSaveError: null
    });
const $24351f04b05a1d15$export$16673c9d28d07522 = {
    // The shared table kit's record row (design brief 4.5 item 3): `controlH`,
    // the `hover` fill, no stroke — it replaced a hairline `line` divider
    // under every row. The four flex ratios became the table's column track,
    // shared with the header (pages/admin/activity-scoring.js).
    extends: 'AppTableRow',
    columns: '2fr 3fr 1fr 1fr',
    // No opacity: `.5` on the whole row faded every label under the floor. An
    // activity that is switched off reads by its switch and by the quiet
    // caption ink on its name (Activity.Label below).
    '@mobileL': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        rowGap: 'Z',
        padding: 'Z1 A'
    },
    Activity: {
        flow: 'y',
        gap: 'V',
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '700',
            // Live-derived like the switch: the row's state is a snapshot.
            color: (el, s)=>{
                const live = (s.root?.activityScoring || []).find((r)=>r.activity_type === s.activity_type);
                return (live ? live._draftEnabled : s._draftEnabled) ? 'title' : 'caption';
            },
            text: (el, s)=>el.call('polyglot', s.label || s.activity_type || '')
        },
        // An id: the `Code` face (`mono` is no font token and painted the
        // default face).
        Slug: {
            tag: 'code',
            fontSize: 'Y1',
            color: 'caption',
            fontFamily: 'Code',
            text: (el, s)=>s.activity_type || ''
        }
    },
    Description: {
        fontSize: 'Y2',
        color: 'caption',
        lineHeight: '1.4',
        text: (el, s)=>s.description || ''
    },
    EnabledCell: {
        align: 'center center',
        // House SwitchInput (one switch language across admin — the old
        // hidden-checkbox + ':checked + div' green toggle was the last
        // divergent recipe, 2026-07-25 admin consistency pass).
        Toggle: {
            extends: 'SwitchInput',
            // Named by its row: a bare role=switch reads "switch, on" with no subject.
            ariaLabel: (el, s)=>el.call('polyglot', s.label || s.activity_type || ''),
            // Live-derive from root.activityScoring — the childrenAs:'state' row
            // snapshot goes stale after _commitDraft (v3.14; the native checkbox
            // this replaced masked it by holding checked state in the DOM).
            onCheck: (el, s)=>{
                const live = (s.root?.activityScoring || []).find((r)=>r.activity_type === s.activity_type);
                return !!(live ? live._draftEnabled : s._draftEnabled);
            },
            onClick: (e, el, s)=>{
                const live = (s.root?.activityScoring || []).find((r)=>r.activity_type === s.activity_type);
                const cur = live ? live._draftEnabled : s._draftEnabled;
                const rows = $24351f04b05a1d15$var$_patchRow(s.root?.activityScoring || [], s.activity_type, {
                    _draftEnabled: !cur
                });
                $24351f04b05a1d15$var$_commitDraft(s.root, rows);
            }
        }
    },
    ScoreCell: {
        align: 'center right',
        // The shared field kit's control (AppInput: `controlH`, the control
        // radius, `Z2`, the `field` plate with its one hairline edge, the quiet
        // placeholder ink, the global focus ring). It was a hand-rolled 32.16px
        // input on the `overlay` wash with no name (admin census, 2026-09-24).
        // The key names the kit control itself: a key `Input` also extends the
        // framework's Input atom (whose default `type: 'input'` is invalid).
        AppInput: {
            type: 'number',
            min: '0',
            max: '100',
            step: '1',
            width: 'D',
            textAlign: 'right',
            ariaLabel: (el, s)=>`${el.call('polyglot', s.label || s.activity_type || '')} \xb7 ${el.call('polyglot', 'admin.activityScoring.col.score')}`,
            // The reactive `value` alone: an onCreate that wrote `el.node.value`
            // was a direct DOM write (Rule 30, frank FA511) for what this prop does.
            value: (el, s)=>String(s._draftScore ?? s.score ?? 0),
            onInput: (e, el, s)=>{
                const n = parseInt(el.node.value, 10);
                const next = Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : 0;
                const rows = $24351f04b05a1d15$var$_patchRow(s.root?.activityScoring || [], s.activity_type, {
                    _draftScore: next
                });
                $24351f04b05a1d15$var$_commitDraft(s.root, rows);
            }
        }
    }
};
// ── /admin/usage — usage-by-actor pure helpers (CREDITS-ATTR-3) ───────────
//
// Same bundle-split-T1b reason as every other export in this file EXPLICITLY
// SHARPENED: these are pure, no-DOM shaping functions with no `pages/`
// dependency of their own, but `pages/admin/usage.js` cannot be imported
// bare in Node/bun for direct unit testing — it (transitively, via
// shared/pages/identity-index.js's barrel) hits the SAME pre-existing
// circular-import TDZ crash ("Cannot access 'adminUsage' before
// initialization") that motivated this file's split in the first place.
// Defined here instead so __tests__/creditsAttribution.test.js can import
// them directly; `usage.js` imports them back (same shape as this file's
// `_shellDayKey`/`_shortDate`/`_isRowDirty` re-imports for logs.js/
// activity-scoring.js) and uses them exactly like its other local pure
// helpers (never via el.call — these aren't registered functions, matching
// this page's existing `_fmtCredits`/`_ledgerRows`/`_tierList` convention).
//
// tickets/fable.md CREDITS-ATTR-3, standing on the actor/liability contract
// CREDITS-ATTR-1 landed server-side (server `b99f86b0`,
// server/src/core/constants/creditActors.js). Three constraints, in order
// of how badly the page lies if violated:
//  1. A member ABSENT from the response is not "0" — `_attrMembers` only
//     ever returns rows the query actually reported; nothing here backfills
//     a workspace member roster with fabricated zeros.
//  2. `createdBy`/member attribution is never liability — every member row
//     is credits the WORKSPACE spent because that person caused it, never a
//     personal balance.
//  3. `systemCause` is groupable, not a display string — `_attrSystem`
//     resolves it through `_SYSTEM_CAUSE_LABELS` (never prints the raw enum
//     token).
// Bounded SYSTEM_CAUSES enum (server creditActors.js) → a human label. Real
// words, never the raw underscore token.
const $24351f04b05a1d15$var$_SYSTEM_CAUSE_LABELS = {
    deploy: 'Deploys',
    build: 'Builds',
    github_workflow: 'admin.usage.cause.githubWorkflow',
    cdn_egress: 'admin.usage.cause.cdnEgress',
    storage_snapshot: 'admin.usage.cause.storageSnapshot',
    webhook_delivery: 'admin.usage.cause.webhookDelivery',
    template_install: 'admin.usage.cause.templateInstall',
    scheduled_reindex: 'admin.usage.cause.scheduledReindex',
    retention_sweep: 'admin.usage.cause.retentionSweep',
    policy_eval: 'admin.usage.cause.policyEval',
    scim_sync: 'admin.usage.cause.scimSync',
    admin_adjustment: 'admin.usage.cause.adminAdjustment',
    other: 'admin.usage.cause.other'
};
// Self-contained fallback humanizer for a cause the table above doesn't
// know yet (the server can add a new SYSTEM_CAUSES member before this map
// is updated) — deliberately NOT sharing usage.js's `_humanizeKey` (that
// one's acronym table is tier-governance-specific and unrelated here).
const $24351f04b05a1d15$var$_humanizeSystemFallback = (key)=>{
    if (!key) return '';
    return String(key).split(/[_-]+/).filter(Boolean).map((w)=>w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ');
};
const $24351f04b05a1d15$export$a75a2d6017b2383e = (cause)=>$24351f04b05a1d15$var$_SYSTEM_CAUSE_LABELS[cause] || $24351f04b05a1d15$var$_humanizeSystemFallback(cause) || 'admin.usage.cause.other';
const $24351f04b05a1d15$export$b1bd09d39bcad15 = (d, elOrLang)=>{
    if (!d) return '';
    try {
        const opts = {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        };
        const el = elOrLang && typeof elOrLang.call === 'function' ? elOrLang : null;
        const out = el ? el.call('localizedDate', d, opts) : '';
        if (typeof out === 'string' && out) return out;
        const lang = typeof elOrLang === 'string' && elOrLang ? elOrLang : 'en';
        return new Date(d).toLocaleDateString(lang, opts);
    } catch  {
        return String(d);
    }
};
const $24351f04b05a1d15$var$_attrCreditsSum = (rows)=>rows.reduce((n, r)=>n + (Number(r.credits) || 0), 0);
const $24351f04b05a1d15$export$e9514352a9faa14f = (data)=>{
    const rows = Array.isArray(data?.members) ? data.members : [];
    const total = $24351f04b05a1d15$var$_attrCreditsSum(rows);
    return rows.slice().sort((a, b)=>(Number(b.credits) || 0) - (Number(a.credits) || 0)).map((r)=>{
        const credits = Number(r.credits) || 0;
        return {
            userId: r.userId,
            name: r.name || r.email || 'admin.usage.unknownMember',
            email: r.email || '',
            avatar: r.avatar || '',
            credits: credits,
            events: r.eventCount ?? r.events ?? 0,
            share: total > 0 ? credits / total : 0
        };
    });
};
const $24351f04b05a1d15$export$4d272662f0226dda = (data)=>{
    const rows = Array.isArray(data?.system) ? data.system : [];
    return rows.slice().sort((a, b)=>(Number(b.credits) || 0) - (Number(a.credits) || 0)).map((r)=>({
            cause: r.cause || 'other',
            label: $24351f04b05a1d15$export$a75a2d6017b2383e(r.cause),
            credits: Number(r.credits) || 0,
            events: r.eventCount ?? r.events ?? 0
        }));
};
const $24351f04b05a1d15$export$2689b344f0ba5c7d = (data)=>{
    const rows = Array.isArray(data?.machines) ? data.machines : [];
    return rows.slice().sort((a, b)=>(Number(b.credits) || 0) - (Number(a.credits) || 0)).map((r)=>({
            label: r.machineLabel || r.label || 'admin.usage.unlabeledMachine',
            credits: Number(r.credits) || 0,
            events: r.eventCount ?? r.events ?? 0
        }));
};
const $24351f04b05a1d15$export$d9bcc17ed2e8385d = (data)=>{
    const u = data?.unattributed || {};
    return {
        credits: Number(u.credits) || 0,
        events: u.eventCount ?? u.events ?? 0,
        before: u.before || null
    };
};
const $24351f04b05a1d15$export$4dbc9f957e02818d = (data)=>{
    const explicit = Number(data?.totalCredits);
    if (Number.isFinite(explicit)) return explicit;
    const members = Array.isArray(data?.members) ? data.members : [];
    const system = Array.isArray(data?.system) ? data.system : [];
    const machines = Array.isArray(data?.machines) ? data.machines : [];
    return $24351f04b05a1d15$var$_attrCreditsSum(members) + $24351f04b05a1d15$var$_attrCreditsSum(system) + $24351f04b05a1d15$var$_attrCreditsSum(machines);
};
// ── subscription-tier perk breakdown (PRICE-3/PRICE-4, "clear breakdown
// whats included in each plan") — extracted here (bundle-split T1b's
// established convention, per this file's header note) SPECIFICALLY so it
// is a real, importable, behaviorally-testable pure function:
// pages/admin/usage.js cannot be imported bare in Node/bun for direct unit
// testing (see the block comment above `_humanizeSystemCause` for the
// circular-import TDZ this file already works around). `_tierPerks` is
// consumed by pages/admin/usage.js's Section_Tiers card grid.
// tickets/sonnet.md BILLING-TRUST-1 #5 (2026-08-14): `gb`/`csm`/`pdf` added
// — `_humanizeKey` is now ALSO reused by pages/admin/usage.js's rate-card
// rows (`_ratesToRows`), not just tier governance/support, so it needs to
// cover the rate-card's own vocabulary (`egress_gb`, `storage_gb_month`,
// `brandbook_pdf`, and `support: 'dedicated_csm'` → the "Dedicated Csm
// support" bug — `csm` fell through to plain capitalize-first-letter).
const $24351f04b05a1d15$var$_TIER_ACRONYMS = {
    sso: 'SSO',
    rbac: 'RBAC',
    sla: 'SLA',
    saml: 'SAML',
    scim: 'SCIM',
    gb: 'GB',
    csm: 'CSM',
    pdf: 'PDF'
};
const $24351f04b05a1d15$export$dbe4c25474b0ee24 = (key)=>{
    if (key == null) return '';
    return String(key).split(/[_-]+/).filter(Boolean).map((w)=>{
        const lc = w.toLowerCase();
        return $24351f04b05a1d15$var$_TIER_ACRONYMS[lc] || lc.charAt(0).toUpperCase() + lc.slice(1);
    }).join(' ');
};
const $24351f04b05a1d15$export$5e16b17e9ff90170 = (t, el)=>{
    if (!t || typeof t !== 'object') return [];
    const say = (key)=>el && typeof el.call === 'function' ? el.call('polyglot', key) : key;
    const perks = [];
    (Array.isArray(t.governance) ? t.governance : []).slice(0, 4).forEach((g)=>perks.push($24351f04b05a1d15$export$dbe4c25474b0ee24(g)));
    if (Array.isArray(t.envs) && t.envs.length) {
        const n = t.envs.length;
        const label = n === 1 ? say('admin.usage.perk.environmentOne') : say('admin.usage.perk.environments').replace('{count}', n);
        perks.push(t.customEnvsAllowed ? say('admin.usage.perk.customEnvs').replace('{label}', label) : label);
    }
    if (t.includedStorageGb != null) perks.push(say('admin.usage.perk.storageIncluded').replace('{gb}', Number(t.includedStorageGb).toLocaleString('en-US')));
    if (t.rateLimitPerMin != null) perks.push(say('admin.usage.perk.rateLimit').replace('{count}', Number(t.rateLimitPerMin).toLocaleString('en-US')));
    else perks.push(say('admin.usage.perk.customRateLimit'));
    if (t.workspaceCap != null) perks.push(t.workspaceCap === 1 ? say('admin.usage.perk.workspaceOne') : say('admin.usage.perk.workspaces').replace('{count}', t.workspaceCap));
    else perks.push(say('admin.usage.perk.unlimitedWorkspaces'));
    if (t.projectCap != null) perks.push(t.projectCap === 1 ? say('admin.usage.perk.projectOne') : say('admin.usage.perk.projects').replace('{count}', t.projectCap));
    else perks.push(say('admin.usage.perk.unlimitedProjects'));
    if (Array.isArray(t.capabilities) && t.capabilities.length) {
        const n = t.capabilities.length;
        perks.push(n === 1 ? say('admin.usage.perk.capabilityOne') : say('admin.usage.perk.capabilities').replace('{count}', n));
    }
    if (t.support) perks.push(say('admin.usage.perk.support').replace('{name}', $24351f04b05a1d15$export$dbe4c25474b0ee24(t.support)));
    return perks;
};
const $24351f04b05a1d15$export$fefd3c3b5a2d0f1 = (tierKey, plansResponse)=>{
    if (!tierKey) return null;
    const list = Array.isArray(plansResponse) ? plansResponse : Array.isArray(plansResponse?.data) ? plansResponse.data : null;
    if (!list) return null;
    const match = list.find((p)=>p && (p.tierKey === tierKey || p.tier === tierKey));
    return match?._id || match?.id || null;
};
const $24351f04b05a1d15$export$3ad805742cb9361 = ()=>{
    if (typeof window === 'undefined') return null;
    try {
        const url = new URL(window.location.href);
        const want = url.searchParams.get('checkout');
        if (!want) return null;
        url.searchParams.delete('checkout');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        if (want !== 'pro' && want !== 'scale') return null;
        window.sessionStorage.setItem('signup_checkout_want', want);
        return want;
    } catch (_) {
        return null;
    }
};
const $24351f04b05a1d15$export$5a1c4fd014840ca5 = (tierKey)=>{
    if (typeof window === 'undefined' || !tierKey) return false;
    try {
        if (window.sessionStorage.getItem('signup_checkout_want') !== tierKey) return false;
        window.sessionStorage.removeItem('signup_checkout_want');
        return true;
    } catch (_) {
        return false;
    }
};
const $24351f04b05a1d15$export$617184298645dd57 = (n)=>{
    if (n == null || Number.isNaN(Number(n))) return "\u2014";
    return Number(n).toLocaleString('en-US', {
        maximumFractionDigits: 2
    });
};
const $24351f04b05a1d15$export$f907c7510f8a2601 = (el, n)=>el.call('polyglot', 'admin.usage.unit.credits').replace('{credits}', $24351f04b05a1d15$export$617184298645dd57(n));
const $24351f04b05a1d15$export$e8ee4e9abcff9583 = {
    // The shared table kit's record row (design brief 4.5 item 3): `controlH`,
    // no stroke, identity on the left and the amount in its own column. The
    // hover fill stays off for the empty-state line below — it is not a
    // record, so it must not answer the pointer like one.
    extends: 'AppTableRow',
    columns: 'minmax(0, 1fr) auto',
    '@mobileL': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        rowGap: 'V'
    },
    ':hover': {
        background: (el, s)=>s._empty ? 'transparent' : 'hover'
    },
    // Empty-state sentinel — MembersCard.Rows returns this ONE row shape when
    // the query reported zero attributed members. A plain caption line, no
    // avatar, no value column, so it can never be mistaken for a real row
    // (constraint #1: never the same glyph as someone who genuinely spent 0).
    EmptyText: {
        hide: (el, s)=>!s._empty,
        gridColumn: '1 / -1',
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', s.label || 'admin.usage.noRecordedUsage')
    },
    Left: {
        hide: (el, s)=>!!s._empty,
        flow: 'x',
        align: 'center',
        gap: 'Z',
        minWidth: '0',
        // Background-image circle, NOT a bare `Avatar:` key — the bare `Avatar`
        // key auto-extends the framework built-in (tag img), which cannot take
        // a `background: url(...)` fill (same trap AdminChrome.js's Monogram
        // comment documents for the /admin Users & Roles row).
        Monogram: {
            width: 'B1',
            height: 'B1',
            round: '50%',
            flexShrink: '0',
            background: (el, s)=>`url(${s.avatar || el.call('avatarUrl', s.name || s.email || '?')}) center/cover`
        },
        Info: {
            flow: 'y',
            gap: 'V',
            minWidth: '0',
            Name: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                // KEY-IN-STATE: a real member's NAME, or the bundle key the
                // attribution mapper substitutes when the server has neither.
                text: (el, s)=>el.call('polyglot', s.name || '')
            },
            // `widgetPlate`: the brand's neutral plate for a track — it reads on a
            // card in both schemes (`overlayStrong` is a sheet wash).
            ShareTrack: {
                width: 'D',
                maxWidth: '100%',
                height: 'X',
                round: 'radiusPill',
                background: 'widgetPlate',
                overflow: 'hidden',
                ShareFill: {
                    height: '100%',
                    round: 'radiusPill',
                    background: 'title.35',
                    transition: 'A defaultBezier width',
                    width: (el, s)=>`${Math.max(Math.round((s.share || 0) * 100), s.credits > 0 ? 3 : 0)}%`
                }
            }
        }
    },
    Right: {
        hide: (el, s)=>!!s._empty,
        flow: 'y',
        align: 'flex-end',
        gap: 'V',
        '@mobileL': {
            justifySelf: 'end'
        },
        // The amount is the kit's numeric cell: the Code face at Z, right-
        // aligned; figures are tabular by the brand's html default (D-7).
        Credits: {
            extends: 'AppTableNum',
            tag: 'span',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>$24351f04b05a1d15$export$f907c7510f8a2601(el, s.credits)
        },
        Share: {
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            text: (el, s)=>s.share > 0 ? `${Math.round(s.share * 100)}%` : ''
        }
    }
};
const $24351f04b05a1d15$export$6da80ab6c1c731be = {
    flow: 'x',
    align: 'center',
    gap: 'V',
    padding: 'V1 Z',
    round: 'radiusPill',
    // The neutral plate that reads on a card (`overlayStrong` is a sheet wash).
    background: 'widgetPlate',
    maxWidth: '100%',
    Icon: {
        name: 'terminal',
        boxSize: 'Y1',
        color: 'caption',
        flexShrink: '0'
    },
    Label: {
        tag: 'span',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'title',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'E',
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    // The quiet ink alone — `.5` opacity faded it under the floor.
    Dot: {
        tag: 'span',
        fontSize: 'Y2',
        color: 'caption',
        text: "\xb7"
    },
    Credits: {
        tag: 'span',
        fontFamily: 'Code',
        fontSize: 'Y2',
        fontWeight: '700',
        color: 'title',
        fontVariantNumeric: 'tabular-nums',
        flexShrink: '0',
        text: (el, s)=>$24351f04b05a1d15$export$f907c7510f8a2601(el, s.credits)
    }
};
const $24351f04b05a1d15$export$500d0f7b9db1b30e = {
    extends: 'AppTableRow',
    columns: 'minmax(0, 1fr) auto',
    '@mobileL': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        rowGap: 'Z'
    },
    Left: {
        flow: 'x',
        align: 'center',
        gap: 'Z1',
        minWidth: '0',
        IconChip: {
            boxSize: 'C',
            round: '50%',
            flexShrink: '0',
            align: 'center center',
            background: 'widgetPlate',
            Icon: {
                name: (el, s)=>s.tone === 'red' ? 'arrowDown' : s.tone === 'green' ? 'arrowUp' : 'minus',
                boxSize: 'A',
                color: 'title'
            }
        },
        Text: {
            flow: 'y',
            gap: 'V',
            minWidth: '0',
            Hint: {
                hide: (el, s)=>!s.hint,
                tag: 'span',
                fontSize: 'Y2',
                color: 'caption',
                // KEY-IN-STATE, like the sibling `Label` below: a producer may hand
                // this a bundle key, an already-interpolated sentence, or plain data.
                // polyglot resolves the first and returns the other two verbatim.
                text: (el, s)=>el.call('polyglot', s.hint || '')
            },
            Label: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '700',
                color: 'title',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>el.call('polyglot', s.label || '')
            }
        }
    },
    Value: {
        extends: 'AppTableNum',
        tag: 'span',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>s.value
    }
};
const $24351f04b05a1d15$export$c9d7fbe9166ed6c1 = {
    extends: 'AppTableRow',
    columns: 'minmax(0, 1fr) auto',
    '@mobileL': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        rowGap: 'V'
    },
    Left: {
        flow: 'y',
        gap: 'V',
        minWidth: '0',
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            overflowWrap: 'anywhere',
            // KEY-IN-STATE: a bundle key or a server-supplied name; polyglot
            // returns anything that is not a key verbatim.
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        Hint: {
            hide: (el, s)=>!s.hint,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', s.hint || '')
        }
    },
    Value: {
        extends: 'AppTableNum',
        hide: (el, s)=>!!s.word,
        tag: 'span',
        fontWeight: '500',
        color: (el, s)=>s.tone === 'red' ? 'dangerInk' : s.tone === 'caption' ? 'caption' : 'title',
        '@mobileL': {
            justifySelf: 'start',
            textAlign: 'left'
        },
        text: (el, s)=>s.value
    },
    Word: {
        hide: (el, s)=>!s.word,
        tag: 'span',
        justifySelf: 'end',
        textAlign: 'right',
        fontSize: 'Z2',
        fontWeight: '500',
        color: (el, s)=>s.tone === 'red' ? 'dangerInk' : s.tone === 'caption' ? 'caption' : 'title',
        '@mobileL': {
            justifySelf: 'start',
            textAlign: 'left'
        },
        text: (el, s)=>s.value
    }
};

});

parcelRegister("j4AOm", function(module, exports) {

$parcel$export(module.exports, "IntegrationCategoryGroup", () => $de2af1fde02aa217$export$c3b8a057805aa327);
$parcel$export(module.exports, "IntegrationCategoryCard", () => $de2af1fde02aa217$export$27ff713fca413d8d);
// Integration hub card primitives. Keep this file independent of the lazy
// /admin/integrations route so shell component registration does not load
// the route body.
const $de2af1fde02aa217$export$c3b8a057805aa327 = {
    flow: 'y',
    gap: 'Z1',
    CategoryHeader: {
        tag: 'h2',
        fontSize: 'A1',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    Cards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-G)), 1fr))',
        gap: 'A',
        childExtends: 'IntegrationCategoryCard',
        childrenAs: 'state',
        children: (el, s)=>s.items || []
    }
};
const $de2af1fde02aa217$export$27ff713fca413d8d = {
    extends: 'Link',
    // Everything maps 1:1 except the legacy google_workspace slug.
    href: (el, s)=>`/admin/integrations/${s.kind === 'google_workspace' ? 'google' : s.kind}`,
    flow: 'y',
    gap: 'Z1',
    padding: 'A',
    round: 'radiusCard',
    theme: 'card',
    background: 'cardSolid',
    backdropFilter: 'none',
    textDecoration: 'none',
    fontWeight: '400',
    transition: 'Z defaultBezier box-shadow',
    ':hover': {
        shadow: 'float'
    },
    Mark: {
        tag: 'div',
        boxSize: 'C1',
        round: 'radiusPill',
        background: 'widgetPlate',
        align: 'center center',
        ariaHidden: 'true',
        Icon: {
            name: (el, s)=>({
                    google_workspace: 'googleLogoNormal',
                    github: 'github',
                    npm: 'npm',
                    mcp: 'api',
                    slack: 'slack',
                    figma: 'figma'
                })[s.kind] || 'sfPlugin',
            boxSize: 'A1',
            color: 'title'
        }
    },
    TopRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>s.label
        },
        Pill: {
            padding: 'W2 Y1',
            round: 'radiusPill',
            fontSize: 'Y1',
            fontWeight: '500',
            whiteSpace: 'nowrap',
            // DESIGN_LANGUAGE §8.5 rule 3 — the hue carries in the WASH, the ink stays
            // neutral. White on solid `green` measured 2.81:1 live; see
            // __tests__/statusPillInkContrast.test.js.
            background: 'green.2',
            color: 'title',
            text: (el, s)=>s.allows_multiple ? el.call('polyglot', 'admin.integrations.card.connected').replace('{count}', s.count) : el.call('polyglot', 'admin.integrations.card.configured')
        }
    },
    Description: {
        tag: 'p',
        fontSize: 'Z2',
        color: 'caption',
        margin: '0',
        text: (el, s)=>s.description || ''
    }
};

});

parcelRegister("ci5oN", function(module, exports) {

$parcel$export(module.exports, "AdminStatusSection", () => $8f2b5a9a5f3a9572$export$54cc9c3be24f7836);
$parcel$export(module.exports, "AdminStatusRow", () => $8f2b5a9a5f3a9572$export$61dbfd7ac2d74eaf);
// Admin status primitives. Keep this file independent of the lazy
// /admin/status route so shell component registration does not load the
// route body.
// A section: a card on the branded `card` theme at the card radius.
const $8f2b5a9a5f3a9572$export$54cc9c3be24f7836 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'radiusCard',
    theme: 'card',
    maxWidth: '100%',
    boxSizing: 'border-box',
    Title: {
        tag: 'h2',
        fontSize: 'A1',
        fontWeight: '700',
        color: 'title',
        margin: '0',
        // The heading is OVERRIDDEN on this child by every consumer
        // (`Section_X: { extends: 'AdminStatusSection', Title: { text: '{{ … }}' } }`).
        // It used to be a `title:` prop on the wrapper read here as
        // `el.parent.title` — the one shape with NO working polyglot rewrite
        // (docs/I18N-CONVENTION.md §1.2): a template is resolved to '' by the
        // static attribute pass, and a function is never auto-invoked because
        // `title` is a valid attribute on every tag. Overriding the child needs
        // no custom prop at all, and drops the stray native tooltip the wrapper
        // used to grow.
        text: '{{ admin.section.untitled | polyglot }}'
    },
    // A real list: every row is a list item, so a screen reader hears "list,
    // N items" and each row's own Copy button.
    Rows: {
        tag: 'ul',
        flow: 'y',
        gap: 'X',
        margin: '0',
        padding: '0',
        listStyle: 'none'
    }
};
const $8f2b5a9a5f3a9572$export$61dbfd7ac2d74eaf = {
    tag: 'li',
    flow: 'x',
    align: 'center space-between',
    gap: 'Z1',
    width: '100%',
    padding: 'Y 0 Y Z',
    boxSizing: 'border-box',
    '@mobileL': {
        flow: 'y',
        align: 'start',
        gap: 'V'
    },
    Left: {
        flow: 'y',
        gap: 'V',
        minWidth: '0',
        Label: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            overflowWrap: 'anywhere',
            // KEY-IN-STATE: a row's `label` / `hint` may be a bundle key or a
            // server-supplied identifier (`public.profiles`, `symbols_user_id`).
            // polyglot returns anything that is not a key verbatim, so both shapes
            // render correctly through one call site.
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        Hint: {
            hide: (el, s)=>!s.hint,
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', s.hint || '')
        }
    },
    Right: {
        flow: 'x',
        align: 'center',
        gap: 'Y',
        minWidth: '0',
        '@mobileL': {
            width: '100%',
            align: 'center space-between'
        },
        Value: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            // §8.5 rule 2 — every row above passes a raw brand hue as `tone`, which
            // as small ink measured 2.15:1 (green) / 2.45:1 (red) on the
            // gray14-class wash. Map the status hues onto the AA-safe ink pairs at
            // the single consumer; neutral tones ('title', 'caption') pass through.
            color: (el, s)=>({
                    green: 'successInk',
                    red: 'dangerInk',
                    orange: 'warningInk'
                })[s.tone] || s.tone || 'title',
            wordBreak: 'break-word',
            textAlign: 'right',
            '@mobileL': {
                textAlign: 'left'
            },
            text: (el, s)=>s.value
        },
        // The row's one action: copy "label: value (hint)" for a bug report. A
        // quiet compact control: no fill at rest, the brand washes on hover and
        // press, 36 px square, named for its row.
        CopyBtn: {
            extends: 'Button',
            type: 'button',
            flexShrink: '0',
            minHeight: 'controlHCompact',
            minWidth: 'controlHCompact',
            padding: '0',
            background: 'transparent',
            color: 'caption',
            ':hover': {
                background: 'hover',
                color: 'title'
            },
            ':active': {
                background: 'selected'
            },
            'aria-label': (el, s)=>el.call('polyglot', 'admin.status.copyRow').replace('{label}', el.call('polyglot', s.label || '')),
            title: (el, s)=>el.call('polyglot', 'admin.status.copyRow').replace('{label}', el.call('polyglot', s.label || '')),
            Icon: {
                name: 'copy',
                boxSize: 'Z1'
            },
            onClick: (e, el, s)=>{
                const label = el.call('polyglot', s.label || '');
                const hint = s.hint ? el.call('polyglot', s.hint) : '';
                const line = `${label}: ${s.value}${hint ? ` (${hint})` : ''}`;
                const clip = typeof navigator !== 'undefined' ? navigator.clipboard : null;
                if (!clip || typeof clip.writeText !== 'function') return;
                // The write is a promise: a refused clipboard must not throw unhandled,
                // and "Copied" is said only after it lands.
                clip.writeText(line).then(()=>el.call('openNotification', {
                        title: el.call('polyglot', 'admin.status.copied'),
                        message: line,
                        type: 'success'
                    }), ()=>{});
            }
        }
    }
};

});

parcelRegister("5PXM6", function(module, exports) {

$parcel$export(module.exports, "ExtSourceRow", () => $4400153955ee4e55$export$6dcaaafba65ad0cb);
$parcel$export(module.exports, "ExtCapChip", () => $4400153955ee4e55$export$1cc8e56b191ca3ef);
$parcel$export(module.exports, "ExtFieldPill", () => $4400153955ee4e55$export$4538e889ceabae92);
// Shared row shapes for the lazy external-data page. Keep this file independent
// of the page so shell component registration does not load the route body.
// makeRemoteUrl resolves the canonical empty-selection path through the existing
// function registry; handlers therefore need no page-module closure.
// ── Rail row — one workspace collection or connected backend ──
const $4400153955ee4e55$export$6dcaaafba65ad0cb = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'Z',
    width: '100%',
    textAlign: 'left',
    padding: 'Y Z',
    round: 'radiusControl',
    borderWidth: '0',
    background: 'transparent',
    color: 'subtitle',
    cursor: 'pointer',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    isActive: (el, s)=>(s.root?._extPath || el.call('makeRemoteUrl')) === s.target,
    '.isActive': {
        background: 'selected',
        color: 'title'
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        el.call('extSelectSource', {
            slug: s.slug,
            table: s.table || undefined
        });
    },
    Chip: {
        align: 'center center',
        width: 'A1',
        height: 'A1',
        minWidth: 'A1',
        round: 'radiusControl',
        background: 'overlayStrong',
        color: 'title',
        overflow: 'hidden',
        Icon: {
            hide: (el, s)=>!s.kindIcon || !el.call('hasIntegrationLogo', s.kindIcon),
            name: (el, s)=>s.kindIcon || 'settings',
            width: '60%',
            height: '60%'
        },
        Letter: {
            hide: (el, s)=>!!(s.kindIcon && el.call('hasIntegrationLogo', s.kindIcon)),
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            text: (el, s)=>((s.label || '?')[0] || '?').toUpperCase()
        }
    },
    Meta: {
        flow: 'y',
        gap: 'V',
        flex: '1 1 0',
        minWidth: '0',
        Label: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'currentColor',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: (el, s)=>s.label || ''
        },
        Sub: {
            hide: (el, s)=>!s.sub,
            tag: 'span',
            fontSize: 'Y1',
            color: 'caption',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: (el, s)=>s.sub || ''
        }
    },
    Count: {
        hide: (el, s)=>typeof s.count !== 'number',
        tag: 'span',
        padding: 'V Z',
        round: 'radiusPill',
        background: 'overlayStrong',
        color: 'caption',
        fontSize: 'Y1',
        fontWeight: '700',
        text: (el, s)=>String(s.count ?? '')
    },
    // Dispatchable dot — green when the server can actually run capability
    // calls for this kind today, dim when it's connect-only.
    Dot: {
        hide: (el, s)=>!s.showDot,
        width: 'Y',
        height: 'Y',
        minWidth: 'Y',
        round: '100%',
        background: (el, s)=>s.dispatchable ? 'green' : 'caption',
        opacity: (el, s)=>s.dispatchable ? '1' : '0.4',
        title: (el, s)=>el.call('polyglot', s.dispatchable ? 'data.external.dot.live' : 'data.external.dot.connected')
    }
};
const $4400153955ee4e55$export$1cc8e56b191ca3ef = {
    tag: 'span',
    padding: 'V Z',
    round: 'radiusPill',
    background: 'overlayStrong',
    color: 'caption',
    fontSize: 'Y1',
    fontWeight: '700',
    fontFamily: 'mono',
    text: (el, s)=>s.cap || ''
};
const $4400153955ee4e55$export$4538e889ceabae92 = {
    flow: 'x',
    align: 'center left',
    gap: 'Y',
    padding: 'V Z',
    round: 'radiusPill',
    // Redundant border removed (border-habit sweep, design-direction.md §8) —
    // matches this same file's ScopePill/StatusPill/ExtCapChip, all fill-only
    // pill chips with no border.
    background: 'overlay',
    fontSize: 'Y1',
    Name: {
        tag: 'span',
        fontFamily: 'mono',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>s.name || ''
    },
    Kind: {
        tag: 'span',
        color: 'caption',
        text: (el, s)=>{
            const base = s.format || s.type || '';
            if (s.is_primary_key) return base ? `${base} \xb7 PK` : 'PK';
            return s.nullable === false ? `${base} *` : base;
        }
    }
};

});

parcelRegister("d6RZo", function(module, exports) {

$parcel$export(module.exports, "SearchAppsMenu", () => $98b5b7041d99fb8e$export$7c9a004134a8ecc3);
$parcel$export(module.exports, "SamHeaderGhostBtn", () => $98b5b7041d99fb8e$export$40a045f65cb11bc5);
$parcel$export(module.exports, "SearchAppsSection", () => $98b5b7041d99fb8e$export$88b98af00a662709);
$parcel$export(module.exports, "SearchAppTile", () => $98b5b7041d99fb8e$export$d84509a864fd6d53);
$parcel$export(module.exports, "SearchAppCategory", () => $98b5b7041d99fb8e$export$b70567e21af4e83d);
// Apps dropdown body — rendered inside the @symbo.ls/dropdown panel
// when the global search gains focus or hover (see
// functions/searchApps.js openSearchAppsDropdown). iOS-springboard
// layout (2026-06-06 per Nika), divided by category sections (Work /
// Team / Insights — SEARCH_APP_GROUPS): calm glyph tiles (AppGlyphTile)
// with labels beneath. The panel itself carries the dashboard-card
// surface (background 'document' + round 'C' via the dropdown
// plugin's layer overrides).
//
// The enter/leave handlers keep the hover-open path's 200ms
// close-debounce alive while the cursor is over the panel (same
// bridge pattern as AppNavbarMoreMenu).

var $D8RKl = parcelRequire("D8RKl");
const $98b5b7041d99fb8e$export$7c9a004134a8ecc3 = {
    // ── keyboard (A2-06) ────────────────────────────────────────────────────
    // The launcher was pointer-only: with the panel visibly open, Tab walked
    // the BACKGROUND page (org switcher → invite → dashboard cards) and a
    // keyboard user could never reach a tile. It now implements the house menu
    // contract (shared/functions/menuKeyboard.js) like every other dropdown:
    // `role="menu"` + `tabindex="-1"` on the panel, `role="menuitem"` on every
    // actionable row, arrow/Home/End cycling, Tab kept INSIDE while the panel
    // is up, Escape closing it and handing focus back.
    //
    // The ONE thing this panel does differently, and why: it opens BOTH from a
    // trigger (the header chevron) AND as a companion to the focused search
    // field. Pulling focus into the panel in the second case would blur the
    // input the user is about to type into — and, worse, that blur is what
    // arms `scheduleSearchAppsClose`, so an unconditional focus-on-open closed
    // the launcher it had just opened. `armIfOutside` therefore takes focus
    // only when the search field does NOT already hold it, which is exactly
    // the chevron/keyboard case the audit reported.
    //
    // `scope` carries ONLY what this file declares. Every shared helper is an
    // `el.call` — see the keyboard-model note at the top of this file.
    scope: {
        // Does the header search field hold focus right now? Its own onBlur owns
        // the launcher's close, so it must keep focus while it has it.
        searchHasFocus () {
            if (typeof document === 'undefined') return false;
            const a = document.activeElement;
            return !!(a && a.closest && a.closest('[data-key="HeaderSearch"]'));
        },
        // The panel node this body is mounted INTO. The dropdown plugin mounts a
        // layer body with `el.set(content)`, so the body's own key is `content` —
        // never `SearchAppsMenu`. The plugin's Panel marker is the stable handle.
        panelNode (el) {
            const n = el && el.node;
            return n && n.closest && n.closest('[data-smbls-dropdown="panel"]') || n;
        },
        armIfOutside (el) {
            if (this.searchHasFocus()) return;
            el.call('armMenuFocus', el, {
                when: (node)=>!this.searchHasFocus() && el.call('menuNodeVisible', node),
                // A TRIGGER-opened panel (`_launcherMode`, functions/searchApps.js)
                // puts the caret in its own filter field, so typing filters at once.
                // Not on a touch screen: there the focus would raise the keyboard
                // over the tiles; a tap on the field does that when it is wanted.
                ...el.state && el.state.root && el.state.root._launcherMode === 'trigger' && !el.call('isCoarsePointer') ? {
                    selector: '[data-launcher-filter]'
                } : {}
            });
        },
        // Tab must not walk the page behind an open overlay. Cycle the same rows
        // the arrows do; wrap at both ends.
        tabCycle (e, el) {
            if (!e || e.key !== 'Tab') return false;
            // The trigger mode's own filter field is a stop too (first in DOM
            // order); hidden in the companion, it drops out with getClientRects.
            const rows = [
                ...this.panelNode(el).querySelectorAll('[data-launcher-filter], [role="menuitem"], [data-launcher-category]')
            ].filter((n)=>!n.hasAttribute('disabled') && n.getClientRects().length);
            if (!rows.length) return false;
            const idx = rows.indexOf(typeof document !== 'undefined' ? document.activeElement : null);
            const next = e.shiftKey ? (idx <= 0 ? rows.length : idx) - 1 : idx < 0 ? 0 : (idx + 1) % rows.length;
            e.preventDefault();
            e.stopPropagation();
            rows[next].focus();
            return true;
        },
        // EVERY close this component owns stamps the dismissal FIRST. The
        // plugin's closeDropdown restores focus to the layer's restoreEl —
        // this launcher's is the search INPUT (A2-08) — and the input's onFocus
        // opens the launcher, so an unstamped close re-opened the panel it had
        // just closed and Escape looked inert (measured live: layerId stayed
        // 'searchApps' through an Escape). The panel's own onRemove also stamps,
        // but DOMQL disposes the body AFTER closeDropdown has already moved
        // focus, so the stamp has to be here, at the call site.
        dismiss (el) {
            try {
                el.call('noteSearchAppsDismissed');
            } catch (_) {}
            try {
                el.call('closeDropdown', 'searchApps');
            } catch (_) {}
        },
        closeMenu (el) {
            this.dismiss(el);
            el.call('restoreMenuFocus', el);
        }
    },
    role: 'menu',
    tabindex: '-1',
    'aria-label': (el)=>el.call('polyglot', 'shell.headerSearch.openDropdown'),
    onKeydown: (e, el, s)=>{
        // Vertical first, then horizontal — the springboard is a grid, and both
        // axes walk the same DOM-ordered row list.
        if (el.call('menuArrowNav', e, el.node)) return;
        if (el.call('menuArrowNav', e, el.node, {
            orientation: 'x'
        })) return;
        if (el.scope.tabCycle(e, el)) return;
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            // A trigger-opened panel's own filter (SamFilterField): Escape clears
            // the typed text first and puts the caret back in the field, from the
            // field or from a tile; the next Escape closes the panel.
            if (s && s.root && s.root._launcherMode === 'trigger' && s.root._launcherFilter) {
                s.root.update({
                    _launcherFilter: ''
                }, {
                    preventFetch: true
                });
                const field = el.SamFilterField && el.SamFilterField.AppInputBare;
                if (field && field.node) field.node.focus();
                return;
            }
            el.scope.closeMenu(el);
        }
    },
    // Plugin-hosted: this body is MOUNTED only while the layer is open, so the
    // mount IS the open edge and the unmount IS the close edge.
    onRemove: (el)=>{
        // Stamp the dismissal BEFORE the plugin's focus restore lands on the
        // search input — that restore would otherwise re-open this very panel and
        // make Escape / outside-click look inert. See noteSearchAppsDismissed in
        // functions/searchApps.js.
        try {
            el.call('noteSearchAppsDismissed');
        } catch (_) {}
        // Typing closes the launcher while the search input still owns focus.
        // Cancel the menu's pending poll without taking the caret back to its
        // original trigger; an actual menu dismissal still restores focus.
        if (el.scope.searchHasFocus()) el.call('releaseMenuFocus', el);
        else el.call('restoreMenuFocus', el);
    },
    // House MenuPanel chrome — the one house dropdown surface, relayed, never
    // repainted here (Nika 2026-09-02: "keep them consistent and
    // default-relayed"); the springboard layout keeps its roomier padding/gap.
    extends: 'MenuPanel',
    // THE ONE GLASS RECIPE (dropdowns spec §1, defect D5) — Nika 2026-09-30 "make searchdropdon bg blur": the
    // dropdown's own VISIBLE glass (shared designSystem theme.js `search-glass`: the card-glass alpha, the house
    // blur), idle tiles and typed results alike. The recipe sits on the dropdown LAYER, not here
    // (functions/searchApps.js openSearchAppsDropdown passes theme + shadow + round to the plugin Panel): the
    // Panel is a backdrop root while it is open, so a backdrop-filter on this body sampled only the Panel's own
    // empty surface and the page showed sharp through the fill (measured live on dev 3efc1eace). This body
    // therefore paints NOTHING: MenuPanel's opaque `dialog` surface and its `overlay` elevation are dropped —
    // `theme: null` plus the transparency pair, the way AppHeader drops the navbar glass — and the keyboard
    // model, the role and the focus arming MenuPanel relays stay.
    theme: null,
    background: 'transparent',
    backdropFilter: 'none',
    shadow: 'none',
    // MenuPanel repaints its elevation when the panel itself holds focus (the brand reset would draw a ring on
    // the container instead). The elevation is the layer's now; the container still takes no ring. Same key as
    // MenuPanel's (`boxShadow`) — a second shadow prop beside it would leave the winner to emission order.
    ':focus-visible': {
        boxShadow: 'none'
    },
    // DESIGN_SPEC 6.5: under reduced transparency the glass popover is the opaque `dialog` surface — this body
    // covers the Panel edge to edge (same rect, same radius), so the layer's glass is never seen.
    '@reduceTransparency': {
        theme: 'dialog'
    },
    borderWidth: '0',
    tag: 'div',
    gap: 'A',
    padding: 'A1',
    // 9A (Nika 2026-09-28: "make it more wider and add maxWidth also … make it
    // a bit taller"): the brand's wide overlay, never wider than the panel the
    // viewport allows (functions/searchApps.js bounds the positioned panel);
    // three quarters of the viewport tall (the shell's `searchPanelMaxH`), and
    // the filter row and toolbar stay put while the tiles or the results
    // scroll INSIDE (SamSections / SamResults are the scrollers).
    width: 'overlayXl',
    dataLauncherRail: (el)=>el.railLauncher ? 'true' : null,
    // Beside a sidebar the launcher is a compact app directory. The same
    // tiles keep their routes, drag behavior and keyboard actions. Its width
    // is the brand's floating side panel (`overlayLg`, one step over the form
    // width it wore; Nika 2026-10-29: "little bit increase widtg of sidebar of
    // more apps"); functions/searchApps.js still bounds the positioned panel
    // by the room beside the rail.
    '&[data-launcher-rail]': {
        width: 'overlayLg',
        // Match the dropdown positioner's viewport gutters. The header stays
        // visible while SamSections / SamResults own the remaining scroll area.
        height: '100dvh',
        maxHeight: 'inherit',
        padding: 'A',
        gap: 'A'
    },
    '&[data-launcher-rail] [data-key="SamHeader"]': {
        justifyContent: 'flex-start',
        gap: 'Y'
    },
    '&[data-launcher-rail] [data-key="SamTitle"]': {
        flex: '1 0 100%',
        padding: '0 Z Y'
    },
    '&[data-launcher-rail] [data-key="SamSections"]': {
        gap: 'A',
        paddingBottom: 'A'
    },
    '&[data-launcher-rail] [data-key="SasGrid"]': {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 'Y'
    },
    '&[data-launcher-rail] [data-launcher-tile]': {
        flow: 'x',
        justifyContent: 'flex-start',
        width: '100%',
        minWidth: '0',
        minHeight: 'controlH',
        padding: 'Y Z',
        gap: 'Z',
        round: 'radiusControl',
        gridColumn: 'auto'
    },
    '&[data-launcher-rail] [data-key="IconTile"]': {
        boxSize: 'glyphPlateSm',
        minWidth: 'glyphPlateSm',
        border: 'none',
        flexShrink: '0'
    },
    '&[data-launcher-rail] [data-key="IconTile"] [data-key="Icon"]': {
        boxSize: 'iconMd'
    },
    '&[data-launcher-rail] [data-launcher-tile] [data-key="Label"]': {
        textAlign: 'left',
        minWidth: '0',
        fontWeight: '400'
    },
    maxWidth: '100%',
    maxHeight: 'searchPanelMaxH',
    boxSizing: 'border-box',
    '@mobileL': {
        gap: 'A',
        padding: 'A'
    },
    // Re-entering the panel both cancels the pending close AND lifts the
    // dismiss-inert armed by scheduleSearchAppsClose (searchApps.js) — an
    // open, hovered panel must stay fully interactive so a tile click still
    // lands (setDropdownInert(false) restores the @symbo.ls/dropdown Panel's
    // pointer-events).
    onMouseenter: (ev, el)=>{
        el.call('cancelSearchAppsClose');
        el.call('setDropdownInert', false);
    },
    onMouseleave: (ev, el)=>el.call('scheduleSearchAppsClose'),
    // A SECONDARY press — the right button, or Control + the primary button
    // (the Mac context click) — never moves focus: the header search input
    // stays the one focus owner (9A), so the press cannot blur it and start the
    // search's close while a tile's own menu is opening. MEASURED LIVE (dev
    // 147be4dd4, 2026-09-29): the tile took focus on the right button's
    // mousedown, the input's blur timer closed the launcher 200 ms later, and a
    // contextmenu that came after that landed on the home grid underneath
    // (__tests__/launcherTileContextMenu.test.js). A primary press is left
    // alone: it still focuses, clicks and starts a tile drag.
    onMousedown: (e)=>{
        if (e && (e.button === 2 || e.button === 0 && e.ctrlKey)) e.preventDefault();
    },
    // iPad: the per-tile context menu (SearchAppTile.onContextmenu) is
    // unreachable by touch — arm the shared long-press shim at the panel root;
    // the synthetic contextmenu bubbles from the touched tile. Re-arms per
    // dropdown open (fresh node), idempotent per node, no-op on fine pointers.
    onRender: (el)=>{
        el.call('armLongPress');
        el.scope.armIfOutside(el);
    },
    // THE FILTER ROW (9A — Nika: "add search"; the picks page: "one filter
    // field … the header field keeps focus while you type"). A MIRROR of the
    // header search input, which stays the ONE focus owner: it shows what is
    // typed there (or what typing does), and a press on it puts the caret back
    // in that input — it is never a second field with its own focus. Hidden
    // from assistive technology for the same reason: the header input is the
    // labelled control, and a duplicate would read the query twice.
    // The COMPANION's row only (`_launcherMode`, functions/searchApps.js): a
    // panel a trigger opened has no header field to mirror, and owns a real
    // one instead (SamFilterField below).
    SamFilter: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        flexShrink: '0',
        padding: 'Z A',
        round: 'radiusControl',
        theme: 'field',
        color: 'caption',
        cursor: 'text',
        'aria-hidden': 'true',
        hide: (el, s)=>s.root._launcherMode === 'trigger',
        subscribeTo: [
            'navSearchQuery',
            '_navSearchChips'
        ],
        // Mousedown, not click: the press must not take focus from the input it
        // hands the caret back to.
        onMousedown: (e, el)=>{
            e.preventDefault();
            el.call('focusHeaderSearch');
        },
        Icon: {
            name: 'pxSearch',
            boxSize: 'iconSm',
            flexShrink: '0'
        },
        SamFilterText: {
            tag: 'span',
            flex: '1',
            minWidth: '0',
            overflowWrap: 'anywhere',
            fontSize: 'Z1',
            color: (el, s)=>(s.root.navSearchQuery || '').trim() || (s.root._navSearchChips || []).length ? 'title' : 'caption',
            // The typed text, after the active ⌘K chips (CMDK-05) when there are
            // any — the field reads what the results are filtered by.
            text: (el, s)=>[
                    ...(s.root._navSearchChips || []).map((c)=>`${c.fieldLabel || c.field}: ${c.label || c.value}`),
                    (s.root.navSearchQuery || '').trim()
                ].filter(Boolean).join(" \xb7 ") || el.call('polyglot', 'shell.launcher.filterPlaceholder')
        }
    },
    // THE OWN FILTER — the TRIGGER mode's field (`_launcherMode`, functions/
    // searchApps.js; Nika 2026-10-28: "in more apps sidebar search is not
    // functioning" … "ok lets keep it for apps filtering, and main search will
    // also stay as is"). Opened from a navbar chevron or the home App strip,
    // the panel had only the mirror above, and the header field it mirrored
    // was not in use: a press moved the caret there and nothing filtered. This
    // is a real field the panel owns. Typing narrows the tiles in place
    // (SamSections, by the name in the current language) inside the chosen
    // category, and never writes `navSearchQuery` or runs the header search.
    // The house leading-icon field (shared AppInputWithIcon): one surface, one
    // edge, the brand ring on the group while the input is focus-visible.
    SamFilterField: {
        extends: 'AppInputWithIcon',
        icon: 'pxSearch',
        flexShrink: '0',
        hide: (el, s)=>s.root._launcherMode !== 'trigger',
        AppInputBare: {
            type: 'text',
            autocomplete: 'off',
            spellcheck: 'false',
            // The keyboard model's handle: the stop armIfOutside focuses on open and
            // the first stop of tabCycle.
            dataLauncherFilter: true,
            placeholder: '{{ workspace.launcher.filterPlaceholder | polyglot }}',
            ariaLabel: '{{ workspace.launcher.filterPlaceholder | polyglot }}',
            // A filter is not unsaved work: the field kit's `dirty` would make a
            // pick from a typed filter ask "Discard changes?" (functions/
            // hasUnsavedInput.js walks the root, and this panel mounts under it).
            dirty: false,
            subscribeTo: [
                '_launcherFilter'
            ],
            value: (el, s)=>s.root._launcherFilter || '',
            onInput: (e, el, s)=>{
                s.root.update({
                    _launcherFilter: e.target.value
                }, {
                    preventFetch: true
                });
            },
            onKeydown: (e, el, s)=>{
                // The caret keys belong to the text: without this the panel's grid
                // walk (menuArrowNav, both axes) took them to the tiles. The vertical
                // arrows, Tab and Escape go on to the panel's own keyboard model.
                if ([
                    'ArrowLeft',
                    'ArrowRight',
                    'Home',
                    'End'
                ].includes(e.key)) {
                    e.stopPropagation();
                    return;
                }
                if (e.key !== 'Enter') return;
                // Enter opens the first tile the filter keeps, the way a press on it
                // does (SearchAppTile onClick: stamp, close, open).
                e.preventDefault();
                if (!(s.root._launcherFilter || '').trim()) return;
                const groups = el.call('launcherTileGroups', s.root);
                const first = groups.length ? groups[0].apps[0] : null;
                if (!first || !first.route) return;
                try {
                    el.call('noteSearchAppsDismissed');
                } catch (_) {}
                el.call('closeDropdown', 'searchApps');
                el.call('selectAppFromSwitcher', first.route, {
                    metaKey: !!e.metaKey,
                    ctrlKey: !!e.ctrlKey
                });
            }
        }
    },
    // Header bar (2026-07-30 per Nika "improve navbar of search dropdown"):
    // "Apps" caption on the left; App Store (the renamed Marketplace entry —
    // its tile left the grid), Following (the community feed, where the follow
    // graph lives) and the primary New app action on the right.
    // The launcher's toolbar WRAPS (the overflow law, HOME_AMBIENT_SKIN_SPEC
    // §3b rule 5 — a toolbar wraps or overflows into a menu, nothing is cut at
    // the edge). Measured at 390 in ka (dev 2c2b6d978): the row needed 562 px
    // in a 326 px head, so "Following" was cut and "New app" sat 204 px past
    // the panel. Wrapped, the buttons take a second line under the title, at
    // the end edge; the title keeps the free width of the first.
    SamHeader: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        justifyContent: 'flex-end',
        gap: 'Z',
        flexShrink: '0',
        // The apps view's toolbar: typed text — or an active ⌘K chip (CMDK-05) —
        // turns the companion panel into the results (SamResults), where the
        // groups carry their own heads.
        subscribeTo: [
            'navSearchQuery',
            '_navSearchChips',
            '_launcherGroup',
            '_featureFlags',
            'workspaceSettings',
            'workspaceProject'
        ],
        hide: (el, s)=>s.root._launcherMode !== 'trigger' && (!!(s.root.navSearchQuery || '').trim() || !!(s.root._navSearchChips || []).length),
        // The mono micro-label of the redesign (DESIGN_SPEC §5.7), the same
        // label every section head below wears.
        SamTitle: {
            extends: 'AppMicroLabel',
            flex: '1',
            // D1: in the wrapping row a `flex: 1` label with overflowWrap anywhere shrank to one letter beside
            // the capsules (the ka title as a tower at 390). On the phone step it takes its own row.
            '@mobileL': {
                flex: '1 0 100%'
            },
            paddingLeft: 'Z',
            text: '{{ shell.launcher.heading | polyglot }}'
        },
        AppStoreBtn: {
            extends: 'SamHeaderGhostBtn',
            title: (el)=>el.call('polyglot', 'shell.launcher.appStoreTooltip'),
            'aria-label': (el)=>el.call('polyglot', 'shell.launcher.appStore'),
            Icon: {
                extends: 'Icon',
                name: 'pxAppStore',
                boxSize: 'iconSm'
            },
            Label: {
                tag: 'span',
                text: '{{ shell.launcher.appStore | polyglot }}'
            },
            onClick: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('closeDropdown', 'searchApps');
                // Land on the App Store SURFACE, not the marketplace one — the
                // island's own deep-link (`?surface=appstore`, MarketplaceIsland
                // activeSurface) selects it (2026-08-06 per Nika "appstore button
                // click should go to appstore active - not marketplace").
                el.call('openAppPage', '/marketplace?surface=appstore');
            }
        },
        FollowingBtn: {
            extends: 'SamHeaderGhostBtn',
            title: (el)=>el.call('polyglot', 'shell.launcher.followingTooltip'),
            'aria-label': (el)=>el.call('polyglot', 'shell.launcher.following'),
            Icon: {
                extends: 'Icon',
                name: 'pxFollowing',
                boxSize: 'iconSm'
            },
            Label: {
                tag: 'span',
                text: '{{ shell.launcher.following | polyglot }}'
            },
            onClick: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('closeDropdown', 'searchApps');
                el.call('openAppPage', '/marketplace/feed');
            }
        },
        // The one primary of the panel — the INK capsule (DESIGN_SPEC §9: an
        // accent never fills a primary, §4.4), compact on the header row. It
        // joins the keyboard cycle with the ghost actions beside it (A2-06).
        NewAppBtn: {
            extends: 'AppCapsuleBtnPrimary',
            compact: true,
            role: 'menuitem',
            title: (el)=>el.call('polyglot', 'shell.launcher.newAppTooltip'),
            'aria-label': (el)=>el.call('polyglot', 'shell.launcher.newApp'),
            Icon: {
                extends: 'Icon',
                name: 'pxPlus',
                boxSize: 'iconSm'
            },
            Label: {
                tag: 'span',
                text: '{{ shell.launcher.newApp | polyglot }}'
            },
            onClick: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('closeDropdown', 'searchApps');
                el.call('openAppPage', '/add-app');
            }
        }
    },
    CategoryNav: {
        role: 'group',
        'aria-label': (el)=>el.call('polyglot', 'shell.launcher.categories'),
        flow: 'x',
        gap: 'Y',
        flexShrink: '0',
        flexWrap: 'wrap',
        subscribeTo: [
            'navSearchQuery',
            '_navSearchChips',
            '_launcherGroup',
            'workspaceSettings',
            'workspaceProject',
            '_featureFlags'
        ],
        hide: (el, s)=>s.root._launcherMode !== 'trigger' && (!!(s.root.navSearchQuery || '').trim() || !!(s.root._navSearchChips || []).length),
        childExtends: 'SearchAppCategory',
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    key: 'all',
                    label: 'shell.launcher.allApps'
                },
                ...(0, $D8RKl.searchAppGroupsFor)(s.root).map((g)=>({
                        key: g.key,
                        label: g.label
                    }))
            ]
    },
    SamSections: {
        flow: 'y',
        // A cut row reads as "more below": the grid fades at its scroll edge (dropdowns spec §6). The fade spans
        // exactly the bottom padding (B), so at the end of the list it lies over empty padding and the last row
        // is never dimmed; only rows that continue below pass under it (design-d2 review of 45934c56d).
        // `black` is a brand colour, so the var always resolves (a missing var would void the gradient silently).
        maskImage: 'linear-gradient(to bottom, var(--color-black) calc(100% - var(--spacing-B)), transparent)',
        paddingBottom: 'B',
        gap: 'B',
        // THE INNER SCROLLER of the apps view (9A "taller" + the toolbar stays).
        flex: '1 1 auto',
        minHeight: '0',
        overflow: 'auto',
        overscrollBehavior: 'contain',
        subscribeTo: [
            'navSearchQuery',
            '_navSearchChips',
            '_launcherGroup',
            '_launcherFilter',
            'workspaceSettings',
            'workspaceProject',
            '_featureFlags'
        ],
        hide: (el, s)=>s.root._launcherMode !== 'trigger' && (!!(s.root.navSearchQuery || '').trim() || !!(s.root._navSearchChips || []).length),
        childExtends: 'SearchAppsSection',
        childrenAs: 'state',
        // Workspace-scoped: prepends the GreenIG section when the active workspace
        // runs the GreenIG module set (resolved at open time — the dropdown mounts
        // fresh each open with root.workspaceSettings already hydrated). The
        // chosen category's groups, narrowed by the trigger mode's own filter; a
        // section the filter empties is dropped (functions/searchApps.js
        // launcherTileGroups).
        children: (el, s)=>el.call('launcherTileGroups', s.root)
    },
    // The trigger mode's quiet line when the typed filter keeps no tile: the
    // sections are gone, and an empty panel would read as broken. It wears the
    // header search's own empty row (NavSearchNoResults), which the companion
    // shows in this same panel. Its own key: the glossary's "No matches" is
    // შესატყვისი არ არის, and the common one reads otherwise in ka.
    SamNoMatch: {
        padding: 'Y1 A',
        fontSize: 'Z2',
        color: 'caption',
        role: 'status',
        subscribeTo: [
            '_launcherFilter',
            '_launcherGroup',
            'workspaceSettings',
            'workspaceProject',
            '_featureFlags'
        ],
        hide: (el, s)=>s.root._launcherMode !== 'trigger' || !(s.root._launcherFilter || '').trim() || el.call('launcherTileGroups', s.root).length > 0,
        text: '{{ workspace.launcher.noMatches | polyglot }}'
    },
    // THE RESULTS, in the same panel (9A — the ONE search dropdown): with text
    // in the header search the launcher shows what globalSearch found — the
    // same groups and rows the header's own panel renders (NavSearchResultGroup
    // and its three row kinds), keyboard highlight included — instead of
    // closing. The header search keeps the panel open while typing (the shared
    // HeaderSearch half, design-d2); until that half lands, typing closes the
    // launcher exactly as before and this block never shows. The companion's
    // view only: a trigger-opened panel keeps its tiles whatever the header
    // holds (`_launcherMode`).
    SamResults: {
        flow: 'y',
        flex: '1 1 auto',
        minHeight: '0',
        overflow: 'auto',
        overscrollBehavior: 'contain',
        subscribeTo: [
            'navSearchQuery',
            '_navSearchChips'
        ],
        hide: (el, s)=>s.root._launcherMode === 'trigger' || !(s.root.navSearchQuery || '').trim() && !(s.root._navSearchChips || []).length,
        NavSearchLoading: {},
        NavSearchNoResults: {},
        SamResultGroups: {
            flow: 'y',
            subscribeTo: [
                '_navSearchGrouped',
                '_navSearchLoading'
            ],
            if: (el, s)=>!!(s.root._navSearchGrouped && s.root._navSearchGrouped.length),
            // The stale rows dim while the next query fetches — the header panel's
            // own rule, so a row never masquerades as the answer to the new text.
            opacity: (el, s)=>s.root._navSearchLoading ? '0.45' : '1',
            transition: 'opacity A defaultBezier',
            children: (el, s)=>s.root._navSearchGrouped || [],
            childExtends: 'NavSearchResultGroup',
            childrenAs: 'state'
        }
    }
};
const $98b5b7041d99fb8e$export$40a045f65cb11bc5 = {
    extends: 'AppCapsuleBtnGhost',
    compact: true,
    // A2-06 — the header actions join the same keyboard cycle as the tiles.
    role: 'menuitem',
    // THE STATE LOGIC (dropdowns spec §5): a hairline capsule at rest; under the pointer and the keyboard the
    // capsule INVERTS (`highlight` fill, `title-reversed` ink) — the same answer the tiles give.
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    color: 'title',
    ':hover': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    ':focus-visible': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight',
        shadow: 'focusRing'
    }
};
const $98b5b7041d99fb8e$export$88b98af00a662709 = {
    flow: 'y',
    gap: 'Z1',
    SasHead: {
        extends: 'AppMicroLabel',
        paddingLeft: 'Z',
        // i18n — the group head is DATA (searchAppGroupsFor), and it arrives from
        // two kinds of source at once: shipped house groups, which carry polyglot
        // KEYS, and the workspace's own group, whose label is the customer's
        // workspace NAME. Both go through the one call: `translate()` resolves a
        // shipped key and returns anything else unchanged, so a tenant's name is
        // never mangled by a lookup that was never meant for it.
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    SasGrid: {
        display: 'grid',
        // ONE column grid for every section, so every tile aligns to the same
        // column across sections (2026-06-14 per Nika "fix layout in
        // SamSections" — `auto-FILL` keeps the empty tracks of a short section,
        // never an `auto-fit` stretch).
        //
        // THE TRACK FLOOR IS THE LONGEST NAME (the overflow law, HOME_AMBIENT_
        // SKIN_SPEC §3b; CLIP_AUDIT_2026-09-26 #2/#3, the launcher twin). The
        // fixed six columns left a 64 px label at 1440 (measured on dev
        // 2c2b6d978, ka): twelve names were cut to an ellipsis, and with the
        // ellipsis gone they broke mid-word ("პროდუქტებ / ი") and ran to three
        // lines. The floor is `E3` (151.5 px at the 16 px panel, measured): with
        // the tile's `Y` side padding it leaves a 139 px label, where the longest
        // shipped word ("ადმინისტრირების", "ინფრასტრუქტურა") measures 134 px at
        // the label's `Z` — so no house name breaks inside a word and every one
        // fits two lines. Both are em-based, so the ratio holds at every root.
        // The `max()` caps the grid at six columns on a wide panel (1/6 of the
        // row), so a 2560 screen keeps today's six; a 1440 panel shows four, a
        // phone two. The breakpoint overrides this replaces are gone.
        gridTemplateColumns: 'repeat(auto-fill, minmax(max(var(--spacing-E3), calc((100% - 5 * var(--spacing-Z)) / 6)), 1fr))',
        justifyItems: 'center',
        gap: 'Z',
        childExtends: 'SearchAppTile',
        childrenAs: 'state',
        children: (el, s)=>s.apps || []
    }
};
const $98b5b7041d99fb8e$export$d84509a864fd6d53 = {
    extends: 'AppControl',
    dataLauncherTile: true,
    tag: 'button',
    type: 'button',
    // A2-06 — the row marker the house menu walker collects.
    role: 'menuitem',
    flow: 'y',
    align: 'center center',
    gap: 'Z',
    // `Y` at the sides (it was `Z`): the name gets the track's width less a
    // thin inset — the floor above is measured against it.
    padding: 'A Y',
    // A NAME LONGER THAN TWO LINES GETS THE ROOM (the widget law, HOME_AMBIENT_
    // SKIN_SPEC §3: primary text wraps to at most two lines, or the layout gives
    // it room; CLIP_AUDIT round 3 (D)). One track at the grid's floor holds two
    // lines of about 28 characters: the name box is 139px (E3 less the Y
    // sides) and a Georgian glyph averages 9.1px at the name's Z (measured:
    // "ადმინისტრირების", 15 characters, 136px); every shipped name fits, the
    // longest being 25 ("სამუშაო სივრცის მოხმარება"). A customer's longer name
    // spans two tracks — a name box of at least 300px, where the measured
    // round-3 string (38 characters, 333px on one line) breaks as it did live
    // at 2560, "ამ თვის გაყიდვები — დეტალური" / "მიმოხილვა" — and a name past
    // twice that takes the whole row. Keyed on the RESOLVED name (the store's
    // word for an installed app), counted in characters, so the span never
    // depends on a font having loaded. Static rules on the attribute, never a
    // factory on `gridColumn`.
    dataSpan: (el, s)=>{
        const name = String(el.call('storeItemText', {
            key: s.appKey,
            name: s.title
        }, 'name') || '');
        const n = [
            ...name
        ].length;
        return n > 56 ? 'row' : n > 28 ? '2' : null;
    },
    '&[data-span="2"]': {
        gridColumn: 'span 2'
    },
    '&[data-span="row"]': {
        gridColumn: '1 / -1'
    },
    // Long custom-app names used to run sideways over the neighbouring tile's
    // label ("This Week's Revenue (Jul 27 – Aug 2)" rendered ~275px wide in a
    // 106px grid track, colliding with "Jobs").
    //
    // `min-width: 0` alone does NOT fix it here: this tile is a <button>, and
    // Chrome keeps a button's internal layout at its min-content width
    // regardless of min-width, so the item still overflowed its `minmax(0, 1fr)`
    // track. `max-width: 100%` clamps against the track itself, which the button
    // does honour; min-width 0 stays as the standard grid-item companion.
    //
    // No `overflow: hidden` since the overflow law (HOME_AMBIENT_SKIN_SPEC §3b
    // rules 1 and 8): the name is the tile's PRIMARY text, so it WRAPS inside
    // the track (Label below) instead of being cut to an ellipsis, and a clip
    // on the tile would only cut what the wrap already fits.
    minWidth: '0',
    maxWidth: '100%',
    round: 'radiusCard',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    // Drag-to-navbar pin source (2026-08-06 per Nika "I should be able to
    // drag and drop items from searchDropwon to navbar"): a native drag
    // stamped with the house entity-ref wire format — HeaderTabs' strip
    // accepts it as a PIN at the pointer position; the chat composer and the
    // AI prompt accept the same drag as a page reference for free (one MIME,
    // shared/functions/dragRef.js). Supported Home shortcuts add one narrow
    // MIME alongside that ref, so the SAME drag can copy an app onto Home
    // without changing any existing navbar/drop-target behavior.
    draggable: 'true',
    onDragstart: (e, el, s)=>{
        // i18n — the ref's `title` is stamped RESOLVED, never as the key, because
        // this ref leaves the launcher and gets WRITTEN somewhere permanent: the
        // chat composer and the AI prompt serialize it into a message body
        // (`dragRefToText` → `[title](href)`), and HeaderTabs turns it into a
        // custom navbar pin stored in userPrefs. A key in a sent message is
        // garbage nobody can clean up. Words are the right payload for a wire
        // format read by humans; the tile's own DISPLAY still runs off the key.
        // Resolved through the SAME store-copy resolver the tile label uses, so a
        // pin or a chat mention of an installed app carries the app's real name
        // ("ინვენტარი"), never its manifest's English literal ("Warehouse").
        el.call('setDragRef', e, {
            kind: 'page',
            id: s.route || '',
            title: el.call('storeItemText', {
                key: s.appKey,
                name: s.title
            }, 'name'),
            href: s.route || '',
            meta: {
                navPin: true,
                icon: s.icon || ''
            }
        });
        el.call('stampLauncherDashboardDrag', e, s.route);
    },
    // Belt-and-suspenders for CODEX-V8 row 5 (tickets/sonnet.md 2026-08-13):
    // live QA instrumented document-level capture listeners and proved a
    // clean, correctly-payloaded native `drop` can land squarely on
    // GridContainer (the element GridContainer.onDrop is declared on) and
    // still produce zero observable effect — no state flip, no toast, no
    // console error. A scratch, isolated regression harness against
    // `@symbo.ls/element`'s own `registerEvents`/delegate.js (create an
    // element with byte-identical onDragover/onDrop handlers, dispatch a
    // dragover+drop with `e.target === node` and a fake DataTransfer) fired
    // both handlers correctly — so this isn't a delegation defect
    // reproducible outside a real trusted-drag browser session; the gap is
    // environment/timing specific and wasn't independently re-creatable
    // without live Chrome access. `dropEffect !== 'none'` means the browser's
    // own DnD state machine confirms SOME target genuinely accepted the drop
    // (GridContainer is the only element on Home that ever calls
    // preventDefault for this MIME); if the widget still isn't showing
    // afterward, GridContainer's own onDrop silently no-oped. Replay through
    // the independently keyboard-verified `addLauncherAppToDashboard` path
    // instead of leaving the user's drag with no visible result. Idempotent +
    // no duplicate toast: `isHomeWidgetVisibleOnGrid` reads the LIVE grid DOM
    // (not the `_homeHiddenWidgets` map, which a successful "already visible"
    // onDrop branch never touches), so a drop that DID work is correctly
    // skipped.
    onDragend: (e, el, s)=>{
        const widgetId = el.call('dashboardWidgetForRoute', s.route);
        if (!widgetId) return;
        if (!e.dataTransfer || e.dataTransfer.dropEffect === 'none') return;
        if (el.call('isHomeWidgetVisibleOnGrid', widgetId)) return; // the drop already worked
        // markPageSaved: opt-out — a dropped tile adds a home widget at once; the panel's one kit field is the apps filter (dirty: false)
        el.call('addLauncherAppToDashboard', s.route);
    },
    color: 'title',
    // Hover is the wash, nothing moves; the press is the card press (spec §6,
    // overflow law rule 7 — a tile that lifted and grew 3 % was cut by the
    // menu's own scroll edge).
    transition: 'background-color B defaultBezier, transform Z defaultBezier',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        transform: 'scale(0.98)'
    },
    // THE STATE LOGIC (dropdowns spec §5): hover, keyboard focus and the app you are in INVERT the glyph plate;
    // the app you are in also shows the orange dot. Declared here, on the holder, through the plate's hook.
    ':focus-visible': {
        shadow: 'focusRing'
    },
    '&:hover [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    '&:focus-visible [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    '&[aria-current="page"] [data-glyph-plate]': {
        background: 'highlight',
        color: 'title-reversed',
        borderColor: 'highlight'
    },
    '&[aria-current="page"] [data-glyph-dot]': {
        display: 'block'
    },
    // the app you are in (shared/functions/glyphNames.js appRouteIsCurrent — the App strip asks the same)
    'aria-current': (el, s)=>el.call('appRouteIsCurrent', s.route, s.root) ? 'page' : null,
    // Both take the FUNCTION form: each composes the tile's own data (caption,
    // store name, route) with a bundle key, which no static template can. (A
    // static `{{ … | polyglot }}` on an attribute switches language only from
    // element 3.14.788; before it, it rendered empty — I18N-CONVENTION.md §1.1.)
    // The hint is a SEPARATE key appended after the label rather than an
    // English sentence with the label interpolated into it — §1.3.
    // The caption keeps its preference here — it is the tile's own SUBTITLE, a
    // different string from the store's long blurb, and swapping one for the
    // other would change what the tooltip says, not just its language. Only the
    // FALLBACK changed: a tile with no caption now names the app through the
    // store-copy resolver instead of printing its manifest literal.
    title: (el, s)=>{
        const label = s.caption ? el.call('polyglot', s.caption) : el.call('storeItemText', {
            key: s.appKey,
            name: s.title
        }, 'name');
        if (!el.call('dashboardWidgetForRoute', s.route)) return label;
        return `${label} \u{2014} ${el.call('polyglot', 'shell.launcher.dragToHomeHint')}`;
    },
    'aria-label': (el, s)=>{
        const label = el.call('storeItemText', {
            key: s.appKey,
            name: s.title
        }, 'name');
        if (!el.call('dashboardWidgetForRoute', s.route)) return label;
        return `${label}. ${el.call('polyglot', 'shell.launcher.dragToHomeAria')}`;
    },
    'aria-keyshortcuts': 'Alt+Enter',
    // Native drag has no keyboard equivalent. Alt+Enter uses the same launcher
    // intent as the context-menu action; unsupported routes remain ordinary app
    // buttons and never manufacture a dashboard widget.
    onKeydown: (e, el, s)=>{
        if (!e.altKey || e.key !== 'Enter') return;
        if (!el.call('dashboardWidgetForRoute', s.route)) return;
        e.preventDefault();
        e.stopPropagation();
        // markPageSaved: opt-out — Alt+Enter adds a home widget at once; the panel's one kit field is the apps filter (dirty: false)
        el.call('addLauncherAppToDashboard', s.route);
    },
    // Warm the app's chunk while the pointer rests on the tile or keyboard focus
    // reaches it (functions/slotPrefetch.js) — the pick then opens at once.
    onPointerenter: (e, el, s)=>el.call('prefetchSlotRoute', s.route),
    onFocus: (e, el, s)=>el.call('prefetchSlotRoute', s.route),
    onClick: (e, el, s)=>{
        if (!s.route) return;
        // Stamp before the close, same reason as SearchAppsMenu.scope.dismiss:
        // the close hands focus back to the search input, whose onFocus would
        // re-open the launcher over the app the user just picked.
        try {
            el.call('noteSearchAppsDismissed');
        } catch (_) {}
        el.call('closeDropdown', 'searchApps');
        // Save the current Simone thread + open chat history, then open the app
        // (2026-06-14 per Nika). See functions/searchApps.js selectAppFromSwitcher.
        // Keep the same split gesture as navbar links. Pass only the intent,
        // not the native event; the route opener owns pane targeting and width.
        el.call('selectAppFromSwitcher', s.route, {
            metaKey: !!e.metaKey,
            ctrlKey: !!e.ctrlKey
        });
    },
    // Right-click → Open / Open in side view / Add to dashboard (rows + dispatch
    // in functions/searchAppTileMenu.js — same ContextDropdown contract as the
    // navbar tab menu). 2026-07-30 per Nika.
    onContextmenu: (e, el, s)=>{
        if (!s.route) return;
        e.preventDefault();
        e.stopPropagation();
        s.root.update({
            contextDropdown: {
                open: true,
                x: e.clientX,
                y: e.clientY,
                itemsFn: 'searchAppTileMenuItems',
                actionFn: 'searchAppTileMenuAction',
                // The launcher is the search's one dropdown (9A), so its tile menu
                // belongs to the search exactly like a result row's menu
                // (NavSearchDropdown.js): the header's blur guard keeps the search
                // open while it is up, and scheduleSearchAppsClose (searchApps.js)
                // keeps the launcher behind it.
                fromNavSearch: true,
                // `projectId`/`kind` ride along so the menu can offer "Edit" on a
                // custom, AI-built app (workspaceProjects.js stamps them onto
                // extension tiles). House tiles carry neither and get no Edit row.
                //
                // i18n — RESOLVED title, for the same reason the drag ref stamps
                // resolved words: the menu's "Pin to navbar" row writes this string
                // into the user's own prefs as a custom pin label, and a pin is
                // durable. A house tile pinned from a Georgian session should read
                // Georgian, not `shell.launcher.studio.title`.
                appTile: {
                    title: el.call('storeItemText', {
                        key: s.appKey,
                        name: s.title
                    }, 'name'),
                    icon: s.icon,
                    iconBg: s.iconBg,
                    route: s.route,
                    projectId: s.projectId,
                    kind: s.kind
                }
            }
        }, {
            preventFetch: true
        });
    },
    // The CALM glyph (9A — "calm glyph tiles instead of bright gradients"):
    // THE app glyph plate the home App strip wears (components/AppGlyphTile.js)
    // — neutral, title ink — so an app reads the same in the strip and here.
    IconTile: {
        extends: 'AppGlyphPlate'
    },
    // The app's NAME — primary text, never cut: it wraps under the glyph.
    // A shipped name never needs more than two lines at the grid's floor (see
    // SasGrid); `anywhere` is the safety net for a customer's own name with a
    // word longer than any track.
    Label: {
        tag: 'span',
        fontSize: 'Z',
        fontWeight: '500',
        color: 'title',
        textAlign: 'center',
        overflowWrap: 'anywhere',
        width: '100%',
        // i18n — resolved through THE store-copy resolver, which is the same
        // function the App Store and the navbar tabs use, so one app has one name
        // everywhere. Its source order carries all three kinds of tile with no
        // branch here (see shared/functions/storeItemText.js):
        //   • an INSTALLED APP's tile carries `appKey` and resolves to the name
        //     the store shows for that record — it printed the app manifest's
        //     English literal before ("Warehouse" against the store's "ინვენტარი");
        //   • a HOUSE tile's title is a polyglot key (the VIEWS tiles come from
        //     CanvasViewNav's VIEW_NAV, and this site NEEDED that: it was printing
        //     `shell.viewNav.apps` / `.infra` / `.agents` on screen) and resolves
        //     at the resolver's last source, which IS polyglot;
        //   • an EXTENSION's or a customer's own title resolves nothing anywhere
        //     and passes through unchanged.
        text: (el, s)=>el.call('storeItemText', {
                key: s.appKey,
                name: s.title
            }, 'name')
    }
};
const $98b5b7041d99fb8e$export$b70567e21af4e83d = {
    role: 'menuitemradio',
    extends: 'AppCapsuleBtnToolbar',
    compact: true,
    dataLauncherCategory: true,
    subscribeTo: [
        '_launcherGroup'
    ],
    background: 'widgetPlate',
    color: 'caption',
    isActive: (el, s)=>(s.root._launcherGroup || 'all') === s.key,
    '.isActive': {
        background: 'highlight',
        color: 'highlight-reversed'
    },
    'aria-checked': (el, s)=>(s.root._launcherGroup || 'all') === s.key ? 'true' : 'false',
    Text: {
        text: (el, s)=>el.call('polyglot', s.label)
    },
    onClick: (e, el, s)=>{
        e.preventDefault();
        e.stopPropagation();
        s.root.update({
            _launcherGroup: s.key
        }, {
            preventFetch: true
        });
    }
};

});

parcelRegister("gXaNm", function(module, exports) {

$parcel$export(module.exports, "AddAppCatalogCard", () => $c57a87b66ea1f753$export$642a86aba45d0b38);
// AddAppCatalogCard — one ready-made workspace app on the /add-app catalog
// rail (WORKSPACE_APPS.md "Discovery"). Rendered from root._wsAppsCatalog rows
// via childrenAs:'state' — child state carries { id, owner, projectKey, name,
// category, description } (project key rides as `projectKey`; `key` is the
// diff key). Install is shown to org admins only — the server enforces
// workspace owner/admin on the settings write; the shell just doesn't offer
// the button to everyone else. "Details" deep-links the marketplace item.
// Fable 2026-08-09 P1 — the card never flipped to "Active"/hid its Install
// button for a PLURAL (additive) install: loadWorkspaceApps composes
// `root.workspaceProject` via `_composeAiStash(takeover, apps, …)`, whose
// `id` is `(takeover && takeover.id) || null` — for a workspace with no
// single-takeover module (the common case: excalidraw and every other
// /add-app catalog app installs into the ADDITIVE `settings.workspaceApps[]`
// list, never the legacy takeover slot) that `id` is ALWAYS null, so
// `workspaceProject.id === owner/key` could never be true no matter how long
// you waited — not even after a reload. The plural install's real signature
// is membership in `root.workspaceApps` (loadWorkspaceApps, keyed by
// `appId` = lowercased `owner/key`). Check both so a legacy takeover module
// AND a plural additive app both read correctly.
const $c57a87b66ea1f753$var$_isInstalled = (s)=>{
    const root = s.root;
    if (!root) return false;
    const wp = root.workspaceProject;
    if (wp && wp.id === `${s.owner}/${s.projectKey}`) return true;
    const appId = `${String(s.owner).toLowerCase()}/${String(s.projectKey).toLowerCase()}`;
    return (Array.isArray(root.workspaceApps) ? root.workspaceApps : []).some((a)=>a && String(a.appId).toLowerCase() === appId);
};
const $c57a87b66ea1f753$export$642a86aba45d0b38 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'radiusCard',
    minWidth: '0',
    height: '100%',
    boxSizing: 'border-box',
    textAlign: 'left',
    // An opaque card keeps the canvas texture out of the reading surface.
    background: 'var(--color-cardSolid, var(--theme-card-background))',
    TitleRow: {
        flow: 'x',
        gap: 'Z',
        align: 'center space-between',
        flexWrap: 'wrap',
        rowGap: 'Y',
        Name: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '700',
            color: 'title',
            overflowWrap: 'anywhere',
            // THE store-copy resolver (shared/functions/storeItemText.js) — the App
            // Store's own call — so a card says what the store says, in the session
            // language ("კომერცია", where the record's English `name` read
            // "Commerce" in a Georgian session). Nika 2026-10-23: "app names = what
            // a person sees in the workspace App Store". A third party's record
            // resolves no shipped name and keeps its own.
            text: (el, s)=>el.call('storeItemText', {
                    key: s.projectKey,
                    name: s.name
                }, 'name')
        },
        Category: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            textTransform: 'uppercase',
            letterSpacing: '.05em',
            text: (el, s)=>s.category
        }
    },
    Description: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        color: 'caption',
        lineHeight: '1.5',
        overflowWrap: 'anywhere',
        flex: '1',
        // Root cause (was rendering the literal "undefined/undefined"): this
        // fallback built an owner/projectKey path WITHOUT checking that either
        // field actually resolved first — any consumer that doesn't populate
        // both (e.g. a bare catalog-sample mount with no child state) got the
        // concatenation of two `undefined`s as visible text. Check the SOURCE
        // fields before building the string (never emit the literal word), and
        // hide the row entirely rather than leave an empty line when a card
        // truly has no description AND no owner/projectKey to fall back to.
        hide: (el, s)=>!s.description && !(s.owner && s.projectKey),
        // The app's one line, through THE store-copy resolver
        // (shared/functions/storeItemText.js) — the App Store card's own call —
        // so the card says what the store says, in the session language: the
        // app's App Store listing tagline (the catalogue row with this key
        // carries it), else the record's own `metadata.description`. That record
        // line is English only, and the raw read gave a Georgian session English
        // on every card (lane DESC, gap 2). A record with no listing keeps its own.
        text: (el, s)=>el.call('storeItemText', {
                key: s.projectKey,
                description: s.description
            }, 'description') || (s.owner && s.projectKey ? `${s.owner}/${s.projectKey}` : '')
    },
    Actions: {
        flow: 'x',
        gap: 'Z',
        align: 'center flex-start',
        marginTop: 'Z',
        flexWrap: 'wrap',
        // Already the active module on this workspace — house active treatment.
        ActiveChip: {
            hide: (el, s)=>!$c57a87b66ea1f753$var$_isInstalled(s),
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            padding: 'V Y',
            round: 'radiusPill',
            background: 'selected',
            color: 'title',
            text: '{{ workspace.catalogCard.active | polyglot }}'
        },
        Button: {
            extends: 'AppCapsuleBtnPrimary',
            hide: (el, s)=>{
                const role = s.root?.org?.role;
                if (![
                    'owner',
                    'co-owner',
                    'admin',
                    'maintainer'
                ].includes(role)) return true;
                return $c57a87b66ea1f753$var$_isInstalled(s);
            },
            // Installs share one pending request. Keep every install control in
            // sync with that lock, and announce activity on the app being added.
            disabled: (el, s)=>!!s.root?._wsAppsInstalling,
            ariaBusy: (el, s)=>s.root && s.root._wsAppsInstalling === `${s.owner}/${s.projectKey}` ? 'true' : 'false',
            type: 'button',
            flow: 'x',
            align: 'center center',
            gap: 'Y',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            fontWeight: '700',
            theme: 'primary',
            Label: {
                tag: 'span',
                text: (el, s)=>s.root?._wsAppsInstalling === `${s.owner}/${s.projectKey}` ? el.call('polyglot', 'workspace.catalogCard.installing') : el.call('polyglot', 'workspace.catalogCard.install')
            },
            onClick: (e, el, s)=>{
                e.preventDefault();
                if (s.root && s.root._wsAppsInstalling) return;
                el.call('installWorkspaceAppRef', {
                    owner: s.owner,
                    key: s.projectKey,
                    name: s.name
                });
            }
        },
        // The app's App Store page, from the App Store's one builder
        // (marketplace functions/appStoreItemLink.js, registered at boot).
        Link: {
            href: (el, s)=>el.call('appStoreItemLink', s.owner, s.projectKey),
            minHeight: 'controlH',
            display: 'inline-flex',
            align: 'center center',
            fontSize: 'Z2',
            color: 'caption',
            ':hover': {
                color: 'title'
            },
            ':active': {
                color: 'title'
            },
            text: '{{ workspace.catalogCard.details | polyglot }}'
        }
    }
};

});

parcelRegister("13xHG", function(module, exports) {

$parcel$export(module.exports, "BroadcastNewsRow", () => $0c503713b3afc088$export$6f30bd9e48140474);
// BroadcastNewsRow — one full-bleed, hue-rotated announcement row inside the
// home BroadcastWidget (2026-06-12 per Nika "BroadcastWidget does not show
// news"). Recolored 2026-08-09 per the geex reference frame 11
// (workspace/design-refs/geex/11-cards-mail-colored-rows.png,
// tickets/brief-product-ui-direction.md "colored mail rows"): muted-hue row
// rotation, avatar circle, dashed-ring star, name+time on one baseline,
// subject+date at the ink.55 secondary floor. NAMED component on purpose:
// inline `childExtends: { ... }` does not bind onClick in DOMQL v3.14 (same
// gotcha the meet TranscriptPage documents) — rows must extend a registered
// component. Opens the same windows detail layer IntranetRows uses
// (selectedAnnouncement carrier + 'announcement-detail').
//
// Row is a DIV with role="button"/tabindex (not a native <button>) because it
// hosts a genuinely interactive nested control (the favorite Star, a real
// <button>) — nesting <button> inside <button> is invalid HTML5 (the parser
// auto-closes the outer tag, silently pulling every sibling after the inner
// button OUT of the row). Same recipe as SidebarRow.js (role/tabindex +
// onKeydown mirroring Enter/Space).
//
// Hue = the BroadcastWidget's OWN card colour, resolved through
// `homeWidgetSurfaceHue(root, 'broadcast')`. The row is an ink-alpha plate on
// that colour (`.fill` = ink.12), its text the colour's ink / inkSoft — the
// "one hue per widget, ink-alpha secondary system" contract in
// functions/homeWidgetHue.js.
// It used to rotate a SECOND hue family per row (`rowHueRotation(rowIndex,
// 'muted')`: brown/green/orange/red, white ink — the geex colored-mail rows,
// which sit on a NEUTRAL card in the reference) INSIDE the pink poster, so
// the first row painted opaque brown-on-pink and read as mud (Nika
// 2026-08-15 "fix colors on widgets"; design-direction.md §6 multicolor
// lives ACROSS the set, never within one card — the tickets pills already
// dropped their second hue for the same reason). `s.rowIndex` still arrives
// from pages/main.js BroadcastWidget.News for AdminChrome-style consumers;
// this row no longer reads it. Called inline everywhere (no module-scope
// helper) — a closure over a module-local const does not survive frank JSON
// serialization.
//
// ⚠️ EVERY read below is NULL-GUARDED with an ADAPTIVE neutral fallback
// (2026-09-02, "make solid - a default color for all of them"). The widget's
// colour is now OPT-IN, so `homeWidgetSurfaceHue` returns null on a board
// where nobody picked one — which used to be impossible for 'broadcast' and
// is now the default. An unguarded `.ink` would throw and kill the row's
// whole paint effect; a poster ink kept as the fallback would paint black
// text on the neutral card in dark mode (the HOME-POSTER-NEUTRAL-INK-ON-HUE-1
// failure, mirrored). The fallbacks are the shell's own adaptive tokens.
const $0c503713b3afc088$export$6f30bd9e48140474 = {
    flow: 'y',
    gap: 'Z1',
    padding: 'A A1',
    round: 'radiusCard',
    textAlign: 'left',
    cursor: 'pointer',
    position: 'relative',
    transition: '160ms defaultBezier transform',
    color: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'broadcast') || {}).ink || 'title',
    background: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'broadcast') || {}).fill || 'overlay',
    ':hover': {
        transform: 'translateY(-2px)'
    },
    // No `:focus-visible` outline here, deliberately. This row is keyboard-
    // reachable (`role: 'button'` + `tabindex: '0'`) and gets its ring from the
    // GLOBAL brand one — DESIGN_LANGUAGE §8.2: components never re-implement
    // focus. The two rules removed here were `outline: 'W solid blue'` +
    // `outlineOffset: 'W'`, which rendered NOTHING: the outline family is in
    // css-in-props' DEFAULT_CSS_PROPERTIES_LIST, whose branch emits values
    // verbatim with no token lookup, so the browser received the literal
    // `outline: solid W blue` and dropped it. Removing them changes zero
    // pixels and lets the global ring through unambiguously. Same defect
    // already removed from infra/ServiceNode.js (workspace 4ccaa333).
    role: 'button',
    tabindex: '0',
    Top: {
        flow: 'x',
        align: 'flex-start space-between',
        Avatar: {
            boxSize: 'C',
            round: '50%',
            src: (el, s)=>el.call('avatarUrlFor', s.author)
        },
        // Dashed-ring star — design-direction.md §8's ONLY sanctioned stroke:
        // dashed ink.35 = inactive/selectable, solid ink fill = active. Local
        // toggle only (workspaceProject.announcements has no starred field to
        // persist to) — still genuinely wired (not a fake affordance): it
        // flips s.starred and repaints immediately.
        Star: {
            tag: 'button',
            type: 'button',
            boxSize: 'B1',
            round: '50%',
            align: 'center center',
            padding: '0',
            cursor: 'pointer',
            background: (el, s)=>s.starred ? (el.call('homeWidgetSurfaceHue', s.root, 'broadcast') || {}).ink || 'title' : 'transparent',
            borderWidth: 'hairline',
            borderStyle: (el, s)=>s.starred ? 'solid' : 'dashed',
            borderColor: (el, s)=>{
                const hue = el.call('homeWidgetSurfaceHue', s.root, 'broadcast');
                if (!hue) return s.starred ? 'title' : 'line';
                return s.starred ? hue.ink : hue.ink + '.35';
            },
            transition: '120ms defaultBezier background, 120ms defaultBezier border-color',
            'aria-label': (el)=>el.call('polyglot', 'workspace.newsRow.toggleFavorite'),
            'aria-pressed': (el, s)=>!!s.starred,
            Icon: {
                icon: (el, s)=>s.starred ? 'star' : 'starOutline',
                boxSize: 'Y1',
                color: (el, s)=>{
                    const hue = el.call('homeWidgetSurfaceHue', s.root, 'broadcast');
                    // A STARRED glyph sits on the filled ink disc, so it must be the
                    // ink's counterpart: the colour's own bg on a picked colour, and
                    // `title-reversed` (the shell's inverted-ink token) on the neutral
                    // card, where the disc is `title`.
                    if (!hue) return s.starred ? 'title-reversed' : 'title';
                    return s.starred ? hue.bg : hue.ink;
                }
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.update({
                    starred: !s.starred
                });
            }
        }
    },
    NameLine: {
        flow: 'x',
        align: 'baseline space-between',
        gap: 'Z',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.author || ''
        },
        Time: {
            tag: 'span',
            fontFamily: 'Code',
            fontSize: 'A',
            fontWeight: '700',
            flexShrink: '0',
            text: (el, s)=>el.call('formatTime', s.date)
        }
    },
    SubjectLine: {
        flow: 'x',
        align: 'baseline space-between',
        gap: 'Z',
        Subject: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '400',
            color: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'broadcast') || {}).inkSoft || 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: '1',
            minWidth: '0',
            text: (el, s)=>s.title || ''
        },
        Date: {
            tag: 'span',
            fontFamily: 'Code',
            fontSize: 'Z1',
            fontWeight: '400',
            color: (el, s)=>(el.call('homeWidgetSurfaceHue', s.root, 'broadcast') || {}).inkSoft || 'caption',
            flexShrink: '0',
            text: (el, s)=>el.call('formatShortDate', s.date)
        }
    },
    onKeydown: (e, el, s, ctx)=>{
        if ((e.key === 'Enter' || e.key === ' ') && el.onClick) {
            const t = e.target;
            if (t && t.closest && t.closest('button')) return;
            e.preventDefault();
            el.onClick(e, el, s, ctx);
        }
    },
    onClick: (e, el, s)=>{
        const t = e.target;
        if (t && t.closest && t.closest('button')) return;
        s.root.update({
            selectedAnnouncement: s
        });
        el.call('openModal', {
            id: 'announcement-detail',
            template: 'custom',
            width: 'overlayXl',
            maxHeight: '85vh',
            content: {
                extends: 'AnnouncementDetailModal'
            }
        });
    }
};

});

parcelRegister("6qGP7", function(module, exports) {

$parcel$export(module.exports, "BroadcastAudienceSegment", () => $4ae663a1f0adb517$export$77db9ef7e237dafa);
$parcel$export(module.exports, "BroadcastTagFilter", () => $4ae663a1f0adb517$export$b81208843152784);
$parcel$export(module.exports, "BroadcastStoryCard", () => $4ae663a1f0adb517$export$64978e83b32d4614);
$parcel$export(module.exports, "BroadcastComposerModal", () => $4ae663a1f0adb517$export$a353feee47ae298b);
$parcel$export(module.exports, "BroadcastComposerAudienceButton", () => $4ae663a1f0adb517$export$29382afd6087e870);
// Broadcast Studio — a compact newsroom surface for internal updates and
// external release notes. The page supplies data/state; cards and the composer
// stay deliberately editorial rather than imitating a generic blog grid.
const $4ae663a1f0adb517$export$77db9ef7e237dafa = {
    tag: 'button',
    type: 'button',
    flex: '1 1 0',
    minHeight: 'controlHCompact',
    padding: 'Y Z1',
    round: 'radiusPill',
    border: 'none',
    cursor: 'pointer',
    fontSize: 'Z1',
    fontWeight: (el, s)=>(s.root?._broadcastScope || 'internal') === el.value ? '700' : '500',
    background: (el, s)=>(s.root?._broadcastScope || 'internal') === el.value ? 'selected' : 'transparent',
    color: (el, s)=>(s.root?._broadcastScope || 'internal') === el.value ? 'title' : 'caption',
    ariaPressed: (el, s)=>(s.root?._broadcastScope || 'internal') === el.value ? 'true' : 'false',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    text: (el)=>el.call('polyglot', el.label),
    onClick: (event, el)=>{
        event.preventDefault();
        el.call('setBroadcastScope', el.value);
    }
};
const $4ae663a1f0adb517$export$b81208843152784 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    width: '100%',
    padding: 'Z A',
    round: 'radiusCard',
    border: 'none',
    background: (el, s)=>(s.root?._broadcastTag || 'all') === s.key ? 'selected' : 'transparent',
    color: (el, s)=>(s.root?._broadcastTag || 'all') === s.key ? 'title' : 'caption',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: 'Z1',
    fontWeight: (el, s)=>(s.root?._broadcastTag || 'all') === s.key ? '700' : '500',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    onClick: (event, el, s)=>{
        event.preventDefault();
        el.call('setBroadcastTag', s.key);
    },
    // KEY-IN-STATE for the built-in "all" row; a real TOPIC name is a
    // non-key and polyglot returns it verbatim.
    Label: {
        tag: 'span',
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    Count: {
        tag: 'span',
        fontFamily: 'Code',
        fontSize: 'Y2',
        text: (el, s)=>String(s.count || 0)
    }
};
const $4ae663a1f0adb517$export$64978e83b32d4614 = {
    tag: 'article',
    flow: 'y',
    gap: 'B',
    padding: 'C',
    round: 'radiusSheet',
    background: (el, s)=>s.audience === 'external' ? 'purple+30' : 'green+30',
    color: 'black',
    position: 'relative',
    cursor: 'pointer',
    transition: '120ms defaultBezier transform, 120ms defaultBezier background',
    role: 'button',
    tabindex: '0',
    ':hover': {
        transform: 'translateY(-W)'
    },
    onRender: (el)=>el.call('armLongPress'),
    onContextmenu: (event, el, s)=>el.call('openAppContextMenu', event, {
            kind: 'broadcast',
            id: s.id
        }),
    onClick: (event, el, s)=>{
        const target = event.target;
        if (target && target.closest && target.closest('button, a')) return;
        el.call('openBroadcastDetail', s);
    },
    onKeydown: (event, el, s, context)=>{
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const target = event.target;
        if (target && target.closest && target.closest('button, a')) return;
        event.preventDefault();
        el.onClick(event, el, s, context);
    },
    CardHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'A',
        Audience: {
            tag: 'span',
            fontSize: 'Y2',
            fontWeight: '700',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            text: (el, s)=>el.call('polyglot', s.audience === 'external' ? 'workspace.broadcastStudio.preview.audienceExternal' : 'workspace.broadcastStudio.preview.audienceWorkspace')
        },
        Tools: {
            flow: 'x',
            align: 'center',
            gap: 'V',
            Edit: {
                tag: 'button',
                type: 'button',
                hide: (el, s)=>!el.call('canEditBroadcast', s, s.root),
                padding: 'V Z',
                minHeight: 'controlHCompact',
                round: 'radiusPill',
                border: 'none',
                color: 'black',
                background: 'black.1',
                fontSize: 'Y2',
                fontWeight: '700',
                cursor: 'pointer',
                text: '{{ workspace.broadcastStudio.card.edit | polyglot }}',
                onClick: (event, el, s)=>{
                    event.stopPropagation();
                    el.call('openBroadcastComposer', s);
                }
            },
            Delete: {
                tag: 'button',
                type: 'button',
                hide: (el, s)=>!el.call('canEditBroadcast', s, s.root),
                minWidth: 'controlHCompact',
                minHeight: 'controlHCompact',
                padding: 'V Z',
                round: '50%',
                border: 'none',
                color: 'black',
                background: 'transparent',
                cursor: 'pointer',
                ariaLabel: (el)=>el.call('polyglot', 'workspace.broadcastStudio.card.deleteAria'),
                fontSize: 'A',
                fontWeight: '700',
                text: "\xd7",
                onClick: (event, el, s)=>{
                    event.stopPropagation();
                    el.call('confirmDeleteBroadcast', s);
                }
            },
            More: {
                extends: 'AppContextMenuButton',
                ariaLabel: (el)=>el.call('polyglot', 'workspace.broadcastStudio.card.moreAria'),
                onClick: (event, el, s)=>el.call('openAppContextMenu', event, {
                        kind: 'broadcast',
                        id: s.id
                    }, {
                        anchor: true
                    })
            }
        }
    },
    Copy: {
        flow: 'y',
        gap: 'Z',
        Tag: {
            tag: 'span',
            fontSize: 'Z1',
            fontWeight: '700',
            opacity: '.55',
            text: (el, s)=>s.tag || el.call('polyglot', 'workspace.broadcastStudio.preview.tagDefault')
        },
        Title: {
            tag: 'h2',
            margin: '0',
            fontSize: 'D',
            fontWeight: '700',
            lineHeight: '1.08',
            letterSpacing: '-0.02em',
            text: (el, s)=>s.title || el.call('polyglot', 'workspace.broadcastStudio.preview.untitled')
        },
        Excerpt: {
            tag: 'p',
            margin: '0',
            maxWidth: 'H',
            fontSize: 'A',
            lineHeight: '1.45',
            opacity: '.7',
            text: (el, s)=>s.excerpt || (s.body || [])[0] || ''
        }
    },
    ExternalLink: {
        extends: 'Link',
        hide: (el, s)=>s.audience !== 'external' || !s.externalUrl,
        href: (el, s)=>s.externalUrl,
        target: '_blank',
        rel: 'noreferrer',
        alignSelf: 'flex-start',
        padding: 'V Z',
        round: 'radiusPill',
        background: 'black',
        color: 'white',
        fontSize: 'Y2',
        fontWeight: '700',
        textDecoration: 'none',
        text: '{{ workspace.broadcastStudio.card.openExternal | polyglot }}',
        onClick: (event)=>event.stopPropagation()
    },
    CardFoot: {
        flow: 'x',
        align: 'center space-between',
        gap: 'A',
        flexWrap: 'wrap',
        Byline: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            Avatar: {
                boxSize: 'A1',
                round: '50%',
                src: (el, s)=>s.authorAvatar || el.call('avatarUrlFor', s.author)
            },
            Name: {
                tag: 'span',
                fontSize: 'Z1',
                fontWeight: '700',
                text: (el, s)=>s.author || ''
            },
            Meta: {
                tag: 'span',
                fontFamily: 'Code',
                fontSize: 'Y2',
                opacity: '.55',
                text: (el, s)=>[
                        el.call('formatShortDate', s.date),
                        el.call('broadcastReadTime', s)
                    ].filter(Boolean).join(" \xb7 ")
            }
        },
        Reactions: {
            flow: 'x',
            align: 'center',
            gap: 'V',
            flexWrap: 'wrap',
            Existing: {
                flow: 'x',
                align: 'center',
                gap: 'V',
                flexWrap: 'wrap',
                childExtends: 'ReactionPill',
                childrenAs: 'state',
                children: (el, s)=>Object.entries(s.reactions || {}).map(([emoji, names])=>({
                            emoji: emoji,
                            names: names,
                            postId: s.id
                        }))
            },
            Add: {
                extends: 'AddReactionPicker'
            }
        }
    }
};
const $4ae663a1f0adb517$export$a353feee47ae298b = {
    tag: 'form',
    flow: 'y',
    gap: 'B',
    // The modal WINDOW owns the inset at every width. This body only keeps the
    // room its fields' focus ring (3 px out) needs inside its own scroll box.
    // It was 'C' on top of the window's padding: at 390 the field column was
    // 215 px of a 351 px window and the Summary placeholder was cut (dev
    // 99aaab353, 2026-10-02).
    padding: 'X',
    width: '100%',
    maxHeight: '85vh',
    overflow: 'auto',
    // Publish asks first (functions/broadcast.js submitBroadcastDraft); the
    // callback runs only once the post is stored.
    onSubmit: (event, el)=>{
        event.preventDefault();
        el.call('submitBroadcastDraft', ()=>el.call('markPageSaved', el));
    },
    Header: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'B',
        Intro: {
            flow: 'y',
            gap: 'V',
            Title: {
                tag: 'h2',
                margin: '0',
                fontSize: 'D',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>el.call('polyglot', s.root?._broadcastDraft?.id ? 'workspace.broadcastStudio.composer.titleEdit' : 'workspace.broadcastStudio.composer.titleNew')
            },
            Caption: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z1',
                color: 'caption',
                text: '{{ workspace.broadcastStudio.composer.caption | polyglot }}'
            }
        },
        // THE house close X (brand CloseButton — F2, one X for every panel).
        Close: {
            extends: 'CloseButton',
            ariaLabel: (el)=>el.call('polyglot', 'workspace.broadcastStudio.composer.closeAria'),
            onClick: (event, el)=>{
                event.preventDefault();
                el.call('closeModal', 'broadcast-compose');
            }
        }
    },
    Audience: {
        flow: 'x',
        gap: 'Y',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.broadcastStudio.composer.audienceAria'),
        Internal: {
            extends: 'BroadcastComposerAudienceButton',
            value: 'internal',
            label: 'workspace.broadcastStudio.audience.workspace'
        },
        External: {
            extends: 'BroadcastComposerAudienceButton',
            value: 'external',
            label: 'workspace.broadcastStudio.audience.external'
        }
    },
    // Keep this directly under the audience choice. A destination is the
    // defining extra piece of an external release, so it should not be hidden
    // beneath a long update field.
    //
    // Every composer field is the shared field kit (shared/components/
    // AppField.js): AppField owns the caption label, AppInput / AppTextarea
    // the control surface; the fields keep the behaviour only. The wrapper
    // stays a <label> so a click on the caption still focuses the control.
    // `label` is a FUNCTION prop — the kit also names the control with it,
    // and an attribute never resolves a `{{ }}` template.
    ExternalDestination: {
        extends: 'AppField',
        tag: 'label',
        hide: (el, s)=>s.root?._broadcastDraft?.audience !== 'external',
        label: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.destination'),
        AppInput: {
            type: 'url',
            name: 'external-url',
            inputmode: 'url',
            autocomplete: 'url',
            placeholder: "https://\u2026",
            value: (el, s)=>s.root?._broadcastDraft?.externalUrl || '',
            onInput: (event, el)=>el.call('setBroadcastDraft', 'externalUrl', event.target.value)
        }
    },
    Fields: {
        flow: 'y',
        gap: 'A',
        // `Headline` names a registered component (brand + default-config); the
        // explicit `extends` switches the key's auto-extend off, so the field is
        // the kit's AppField only.
        Headline: {
            extends: 'AppField',
            tag: 'label',
            label: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.headline'),
            AppInput: {
                type: 'text',
                name: 'headline',
                autocomplete: 'off',
                required: true,
                placeholder: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.headlinePlaceholder'),
                value: (el, s)=>s.root?._broadcastDraft?.title || '',
                onInput: (event, el)=>el.call('setBroadcastDraft', 'title', event.target.value)
            }
        },
        Summary: {
            extends: 'AppField',
            tag: 'label',
            label: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.summary'),
            AppInput: {
                type: 'text',
                name: 'summary',
                autocomplete: 'off',
                placeholder: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.summaryPlaceholder'),
                value: (el, s)=>s.root?._broadcastDraft?.excerpt || '',
                onInput: (event, el)=>el.call('setBroadcastDraft', 'excerpt', event.target.value)
            }
        },
        Body: {
            extends: 'AppField',
            tag: 'label',
            label: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.update'),
            AppTextarea: {
                name: 'body',
                required: true,
                // The update is the long part of a release — the box opens tall
                // instead of at the kit's one-line control height.
                minHeight: 'F',
                placeholder: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.updatePlaceholder'),
                value: (el, s)=>s.root?._broadcastDraft?.body || '',
                onInput: (event, el)=>el.call('setBroadcastDraft', 'body', event.target.value)
            }
        },
        Details: {
            tag: 'div',
            flow: 'x',
            gap: 'A',
            '@mobileL': {
                flow: 'y'
            },
            Topic: {
                extends: 'AppField',
                tag: 'label',
                flex: '1',
                label: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.topic'),
                AppInput: {
                    type: 'text',
                    name: 'topic',
                    autocomplete: 'off',
                    placeholder: (el)=>el.call('polyglot', 'workspace.broadcastStudio.field.topicPlaceholder'),
                    value: (el, s)=>s.root?._broadcastDraft?.tag || '',
                    onInput: (event, el)=>el.call('setBroadcastDraft', 'tag', event.target.value)
                }
            }
        }
    },
    Error: {
        hide: (el, s)=>!s.root?._broadcastSaveError,
        tag: 'p',
        margin: '0',
        padding: 'Z A',
        round: 'radiusControl',
        background: 'red.15',
        color: 'dangerInk',
        fontSize: 'Z1',
        role: 'status',
        ariaLive: 'polite',
        text: (el, s)=>s.root?._broadcastSaveError || ''
    },
    Footer: {
        flow: 'x',
        align: 'center space-between',
        gap: 'A',
        flexWrap: 'wrap',
        Hint: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', s.root?._broadcastDraft?.audience === 'external' ? 'workspace.broadcastStudio.composer.externalHint' : 'workspace.broadcastStudio.composer.workspaceHint')
        },
        Publish: {
            tag: 'button',
            type: 'submit',
            minHeight: 'controlH',
            padding: '0 A',
            round: 'radiusPill',
            border: 'none',
            background: 'primary',
            color: 'primary-content',
            fontSize: 'Z1',
            fontWeight: '700',
            cursor: (el, s)=>s.root?._broadcastSaving ? 'not-allowed' : 'pointer',
            disabled: (el, s)=>!!s.root?._broadcastSaving,
            ariaBusy: (el, s)=>s.root?._broadcastSaving ? 'true' : 'false',
            ':disabled': {
                opacity: '.5'
            },
            text: (el, s)=>el.call('polyglot', s.root?._broadcastSaving ? 'workspace.broadcastStudio.composer.publishing' : s.root?._broadcastDraft?.id ? 'workspace.broadcastStudio.composer.saveChanges' : 'workspace.broadcastStudio.composer.publish')
        }
    }
};
const $4ae663a1f0adb517$export$29382afd6087e870 = {
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center',
    gap: 'Z',
    flex: '1 1 0',
    minHeight: 'controlH',
    padding: '0 A',
    round: 'radiusControl',
    border: 'none',
    background: (el, s)=>s.root?._broadcastDraft?.audience === el.value ? 'selected' : 'overlay',
    color: (el, s)=>s.root?._broadcastDraft?.audience === el.value ? 'title' : 'caption',
    fontSize: 'Z1',
    fontWeight: (el, s)=>s.root?._broadcastDraft?.audience === el.value ? '700' : '500',
    cursor: 'pointer',
    ariaPressed: (el, s)=>s.root?._broadcastDraft?.audience === el.value ? 'true' : 'false',
    ':hover': {
        background: 'hover',
        color: 'title'
    },
    Label: {
        tag: 'span',
        text: (el)=>el.call('polyglot', el.parent.label)
    },
    onClick: (event, el)=>{
        event.preventDefault();
        el.call('setBroadcastDraft', 'audience', el.value);
    }
};

});

parcelRegister("aL82M", function(module, exports) {

$parcel$export(module.exports, "WorkspaceHubCard", () => $7d5488867775b763$export$32308885c1e61ba3);
// One workspace card on the bare-`/w` hub page (pages/workspaceHub.js).
// Bare shared-library import, not a deep workspacePrefix.js subpath — see
// app.js's identical fix note (tickets/catalog-fixall.md P0).

var $1X0Je = parcelRequire("1X0Je");
const $7d5488867775b763$var$shellWithWorkspacePrefix = (...args)=>(0, $1X0Je.default).functions.withWorkspacePrefix(...args);
const $7d5488867775b763$export$32308885c1e61ba3 = {
    extends: 'CommonCard',
    tag: 'button',
    type: 'button',
    flow: 'x',
    align: 'center left',
    gap: 'A',
    padding: 'A1',
    round: 'radiusCard',
    borderWidth: '0',
    cursor: 'pointer',
    textAlign: 'left',
    color: 'title',
    transition: '120ms ease background, 120ms ease transform',
    ':hover': {
        background: 'hover',
        transform: 'translateY(-2px)'
    },
    onClick: (e, el, s)=>{
        const slug = s.slug || s.username;
        if (!slug) return;
        el.router($7d5488867775b763$var$shellWithWorkspacePrefix(slug, '/'), el.getRoot());
    },
    Avatar: {
        avatarType: 'initials',
        boxSize: 'C',
        round: 'radiusCard',
        flexShrink: '0',
        src: (el, s)=>el.call('avatarUrl', s.name || s.slug || '')
    },
    Info: {
        flow: 'y',
        gap: 'V',
        flex: '1',
        minWidth: '0',
        Name: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '700',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s.name || s.slug || ''
        },
        Role: {
            tag: 'span',
            fontSize: 'Y2',
            color: 'caption',
            text: (el, s)=>s.role || s.membership?.role || 'member'
        }
    },
    Icon: {
        name: 'chevronRight',
        color: 'caption',
        flexShrink: '0'
    }
};

});

parcelRegister("cN8n4", function(module, exports) {

$parcel$export(module.exports, "AppHueTile", () => $95008df659f32d84$export$af0a3e91de2eec1f);
// The ONE app-tile primitive — the geex squircle every launcher surface
// shares: home-board icon mode, the header search-dropdown springboard, and
// anything that lists apps. Radius sits on the B1 squircle step, the board's
// smoothness scale.
//
// ── TWO SURFACES, TWO RESOLVERS ──────────────────────────────────────────
// Nika 2026-09-02: "on / page widgets, make solid - a default color for all
// of them", then, on the first pass: "pipeline still has color and set to no
// color also does not change it. fix it fundamentally for also all app-store
// related apps and widgets too".
//
// A home-board tile is part of a WIDGET, so it follows that widget's colour:
// NEUTRAL until the user picks one — for every plane, including an app-store
// module widget that declares its own manifest hue. A launcher row is not a
// widget; it is the app's identity inside a menu, so it keeps the house
// catalog (and a module's manifest hue) exactly as before.
//
// The two are told apart by which prop the mount site passes, which is how
// they already differed and needs no new flag:
//   • `hueId` (a widget id, or a module widget's open route) → HOME BOARD →
//     `homeWidgetSurfaceHue`: the user's pick, or neutral. NOTHING else.
//   • `s.route` only (SearchAppsMenu's springboard rows) → LAUNCHER →
//     `homeWidgetHue`: the house catalog ▸ manifest hue ▸ neutral.
//
// ⚠️ The board branch no longer forwards `s.hue`/`s.iconBg` as a fallback.
// That forward was the defect: it repainted a module widget's manifest hue
// the moment the user cleared their colour, so "Default (no color)" looked
// inert on exactly the widgets an installed app contributes. The manifest hue
// is still reachable — the palette offers it as its first swatch ("App
// color", `homeWidgetAppColorOption`) — it is just no longer a default.
//
// `colorId` — OPTIONAL, home board only. The widget id the USER's colour is
// keyed by, when that differs from `hueId`. A module widget resolves its
// manifest hue by OPEN ROUTE (`hueId`) but is colour-picked by WIDGET ID, and
// without this the picked colour would be written under one key and looked up
// under another. Static widgets pass `hueId: spec.id` — already the widget id
// — so they need nothing.
//
// Unmapped and un-picked tiles fall back to the adaptive overlayStrong/title
// pair — never a gradient or dead literal (the search menu's raw-hex
// TILE_GRADIENTS were this tile's predecessor and are gone).
//
// `el.context.designSystem` is threaded to both resolvers so a RAW hue — a
// manifest hue on the launcher, or one the user picked from the "App color"
// row on the board — gets a MEASURED binary ink (tickets/fable.md) instead of
// the historical white-ink guess.
const $95008df659f32d84$export$af0a3e91de2eec1f = {
    align: 'center center',
    width: 'D1',
    height: 'D1',
    minWidth: 'D1',
    round: 'B1',
    background: (el, s)=>{
        const h = el.hueId ? el.call('homeWidgetSurfaceHue', el.state?.root, el.colorId || el.hueId, el.context.designSystem) : el.call('homeWidgetHue', s.route, s.hue || s.iconBg || s.spec?.iconBg, el.context.designSystem);
        return h && h.bg || 'overlayStrong';
    },
    color: (el, s)=>{
        const h = el.hueId ? el.call('homeWidgetSurfaceHue', el.state?.root, el.colorId || el.hueId, el.context.designSystem) : el.call('homeWidgetHue', s.route, s.hue || s.iconBg || s.spec?.iconBg, el.context.designSystem);
        return h && h.ink || 'title';
    },
    Icon: {
        icon: (el, s)=>el.parent.icon || s.icon || 'star',
        boxSize: 'B',
        color: (el, s)=>{
            const h = el.parent.hueId ? el.call('homeWidgetSurfaceHue', el.state?.root, el.parent.colorId || el.parent.hueId, el.context.designSystem) : el.call('homeWidgetHue', s.route, s.hue || s.iconBg || s.spec?.iconBg, el.context.designSystem);
            return h && h.ink || 'title';
        }
    }
};

});

parcelRegister("eV3Sc", function(module, exports) {

$parcel$export(module.exports, "AppGlyphTile", () => $adc964ae93ba25c4$export$76f9b7c469a193e8);
// THE CALM APP GLYPH — one neutral plate with the app's glyph in title ink:
// the home App strip's tile (components/HomeAppStrip.js) and the search
// dropdown's app tiles (components/SearchAppsMenu.js) wear the same one, so an
// app looks the same wherever it is offered (9A — Nika 2026-09-28: "improve
// icons design"; the picks page: "calm glyph tiles instead of bright
// gradients").
//
// Neutral by construction: the `layer` theme (the house wash of the ground,
// both schemes) and `title` ink — no per-app hue, no gradient squircle. The
// hover and press of the tile belong to the control that holds it (the strip
// item, the launcher tile), which steps this plate's wash; the plate declares
// the transition those steps ride.
//
//   AppGlyphTile: {}                    — the glyph reads `s.icon`
//   AppGlyphTile: { Icon: { name: … } } — or a caller names it
const $adc964ae93ba25c4$export$76f9b7c469a193e8 = {
    theme: 'layer',
    color: 'title',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: '0',
    boxSize: 'controlH',
    minWidth: 'controlH',
    round: 'radiusControl',
    transition: 'background-color A defaultBezier, transform Z defaultBezier',
    Icon: {
        name: (el, s)=>s && s.icon || 'star',
        boxSize: 'iconMd'
    }
} // THE GLYPH PLATE of the new glyph language moved to the shared kit (shared/components/AppGlyphPlate.js): the
 // navbar tabs are shared code and wear it too (dropdowns spec 2026-09-30 §12).
;

});

parcelRegister("3MXUr", function(module, exports) {

$parcel$export(module.exports, "AmbientBackdrop", () => $2c24538e71ad2e3c$export$7c8fb78fbb8bf095);
// The ambient sky (DESIGN-WL-AMBIENT-SKIN-BACKDROP-1, HOME_AMBIENT_SKIN_SPEC §2).
//
// A decorative frame under the page stage: fixed, inset 0, no pointer events,
// hidden from assistive tech. The dots are a 1-bit mask (files/ambient/<sky>.png,
// through the files plane); the layers paint the brand ink `stageInk` and the
// mask decides where it shows.
//
// THE DRIFT (DESIGN-WL-BOOT-LOADER-MOTION-1, Nika 2026-09-28 "make clouds
// animation too"). The frame itself stays still and carries the FADE (the
// horizon never moves); the art rides on layers inside it. A sky whose mask
// tiles without a seam (`ambientSkyDrifts` — the clouds) gets two layers
// twice the viewport wide that repeat the tile across and slide left by one
// tile per loop: SkyNear at the dashboard's own scale (one tile per viewport
// width, 90 s) and SkyFar at half the scale and half the ink, slower (150 s),
// for depth. Only `transform` moves (the `ambientDrift` keyframes) — no mask
// position, no layout. Every other sky is one still layer (SkyStill), exactly
// the art the horizon always showed. Reduced motion stands the drift still:
// the OS query here (`@reducedMotion`), the app's own Settings choice in the
// shell sheet (<html data-motion="reduced">).
//
// THE SKIN is never read here (the kit's skin contract: a component never
// branches on the skin). The frame is display none; the SHELL shows it — one
// rule in app.js's injected sheet, beside the skin stamp, for the ambient
// skin only. No stamp or the solid skin = no sky, and a sheet that never
// loaded fails closed. On top of that the sky's own off switches (hide:
// inline display none, beats the shell rule) — the record's sky is 'none',
// prefers-reduced-transparency matches, the workspace paints its own ground,
// the record has not arrived, or the sky has no files-plane record — live in
// functions/ambientBackdrop.js (`ambientSkyState`).
//
// Placement (the frame's fade): 'horizon' (default — Nika 2026-09-27 "move
// clouds illustration at bottom") caps the art to the lower band of the
// viewport and fades it out upward, so the header, greeting and App strip sit
// on clean ground (functions/ambientBackdrop.js ambientFadeMask has the
// numbers). 'top' (the shell's mount — DESIGN-WL-HOME-SKY-TOP-GROUND-1, Nika
// 2026-10-01 "maybe we move moving clouds at the top side … clouds and
// moutain should be the default") is the SAME horizon band on a frame
// mirrored vertically (`ambientSkyFlip`): the cloud mass hangs from the top
// edge and fades out downward; the bottom belongs to the ground
// (AmbientGround), which rises at the end of the home scroll. Its band stops
// at the CLEAR EDGE — the top of the `fadeAnchor` (the greeting's summary),
// measured — so the summary sits on clean ground, and on the home it slides
// away with the page top (the shell sheet). The person can keep the bottom
// band instead (Personalise → Background, `homeLook.skyLayout: 'bottom'`):
// `ambientSkyPlacement` then answers 'horizon', today's geometry exactly, and
// the ground stays off. 'none' is the whole art with no fade;
// 'grid' fades the sky out at the top edge of the `fadeAnchor` node (the home
// grid), measured on render and on window resize.
//
// Stacking: zIndex -1 paints the frame above its parent's own background and
// below every in-flow child — so the MOUNT parent must be a stacking context
// and the grounds between it and the page content must not repaint the stage
// over the sky (docs/patches/ambient-mount.app.js.patch).
const $2c24538e71ad2e3c$export$7c8fb78fbb8bf095 = {
    fadeTo: 'horizon',
    fadeAnchor: 'GridContainer',
    state: {
        fadeTop: null,
        skyAway: false
    },
    aria: {
        hidden: 'true'
    },
    // The EFFECTIVE placement (`ambientSkyPlacement`: 'top' turns back into
    // 'horizon' when the person chose the bottom layout) for the shell sheet's
    // scroll-away rule, and the fallback's "the home left its top" flag.
    attr: {
        'data-sky-layout': (el, s)=>el.call('ambientSkyPlacement', el.fadeTo, s),
        'data-sky-away': (el, s)=>s.skyAway ? 'true' : null
    },
    display: 'none',
    position: 'fixed',
    inset: '0',
    zIndex: '-1',
    pointerEvents: 'none',
    overflow: 'hidden',
    hide: (el, s)=>!el.call('ambientSkyState', s).enabled,
    // The fade belongs to the still frame, so the horizon stays put while the
    // art drifts under it.
    maskImage: (el, s)=>{
        const placement = el.call('ambientSkyPlacement', el.fadeTo, s);
        const measured = placement === 'grid' || placement === 'top';
        return el.call('ambientFadeMask', measured ? s.fadeTop : null, placement);
    },
    maskSize: '100% 100%',
    maskRepeat: 'no-repeat',
    // 'top' mirrors the frame (fade and art together) onto the top edge; the
    // drift layers keep their own translateX.
    transform: (el, s)=>el.call('ambientSkyFlip', el.call('ambientSkyPlacement', el.fadeTo, s)),
    // The art layers. Each is the stageInk masked by the sky's art on the
    // bottom edge: the ink is STATIC (a class rule, so a per-skin
    // `--color-stageInk` override reaches it), the art URL reactive (inline),
    // the drift static too (class rules the @reducedMotion block can win over).
    // Every factory stands alone (frank serializes each one by itself).
    SkyFar: {
        hide: (el, s)=>!el.call('ambientSkyDrifts', el.call('ambientSkyState', s).sky),
        position: 'absolute',
        left: '0',
        bottom: '0',
        height: '100%',
        pointerEvents: 'none',
        background: 'stageInk',
        maskImage: (el, s)=>el.call('ambientMaskImage', el.call('ambientSkyState', s).url),
        width: '200%',
        opacity: '0.5',
        maskSize: '25% auto',
        maskRepeat: 'repeat-x',
        maskPosition: 'left bottom',
        animation: 'ambientDrift',
        animationDuration: '150s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        '@reducedMotion': {
            animation: 'none'
        }
    },
    SkyNear: {
        hide: (el, s)=>!el.call('ambientSkyDrifts', el.call('ambientSkyState', s).sky),
        position: 'absolute',
        left: '0',
        bottom: '0',
        height: '100%',
        pointerEvents: 'none',
        background: 'stageInk',
        maskImage: (el, s)=>el.call('ambientMaskImage', el.call('ambientSkyState', s).url),
        width: '200%',
        maskSize: '50% auto',
        maskRepeat: 'repeat-x',
        maskPosition: 'left bottom',
        animation: 'ambientDrift',
        animationDuration: '90s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        '@reducedMotion': {
            animation: 'none'
        }
    },
    SkyStill: {
        hide: (el, s)=>!!el.call('ambientSkyDrifts', el.call('ambientSkyState', s).sky),
        position: 'absolute',
        left: '0',
        bottom: '0',
        height: '100%',
        pointerEvents: 'none',
        background: 'stageInk',
        maskImage: (el, s)=>el.call('ambientMaskImage', el.call('ambientSkyState', s).url),
        width: '100%',
        maskSize: '100% auto',
        maskRepeat: 'no-repeat',
        maskPosition: 'center bottom'
    },
    onRender: (el, s)=>el.call('ambientScheduleFade', el, s),
    onWindowResize: (e, el, s)=>el.call('ambientScheduleFade', el, s),
    onRemove: (el)=>el.call('ambientCancelFade', el)
};

});

parcelRegister("d6kmW", function(module, exports) {

$parcel$export(module.exports, "AmbientGround", () => $989ba2c388cf155a$export$7a1fcd6c98b8e8af);
// The ambient GROUND (DESIGN-WL-HOME-SKY-TOP-GROUND-1, Nika 2026-10-01: "very
// end of scroll we show some bottom part revealing with smooth scroll in
// homepage").
//
// A decorative band along the bottom edge of the screen: fixed, no pointer
// events, hidden from assistive tech, under the page stage like the sky
// (zIndex -1 in the shell root's stacking context). The art is the loader's
// mountain range (files/ambient/mountains.png, the same 1-bit dot language)
// in the loader's own ink (`loaderInk`), so the home ENDS where the loader
// began. `groundSky` names another mask from the catalogue (e.g. 'clouds').
//
// THE RISE. At rest the band sits one band-height below the edge (Rise's
// translateY(100%)), so nothing shows while the home is scrolled above its
// end. The shell's injected sheet (app.js) moves Rise:
//   * scroll-driven (CSS `animation-timeline` on the home scroller's named
//     timeline, scoped to the shell root): Rise climbs to translateY(0) over
//     the last stretch of the home scroll (40vh), scroll-linked;
//   * no scroll-driven animations: the home's end sentinel toggles
//     `groundIn` here (functions/ambientBackdrop.js ambientGroundWatch) and
//     the sheet runs a transform transition on `data-ground="in"`;
//   * reduced motion (the OS query, or <html data-motion="reduced">): no
//     motion — the band simply shows at the end.
// Transforms only: no layout, no mask position. A short home (no scroll) has
// no end to reach, so the ground stays down (ambientGroundProgress).
//
// THE SKIN and THE ROUTE are never read here: the frame is display none; the
// sheet shows it for the ambient skin on the home route only. Its own off
// switches are the sky's (`ambientGroundState` asks `ambientSkyState`), plus
// its art's files-plane record. Every factory stands alone (frank).
const $989ba2c388cf155a$export$7a1fcd6c98b8e8af = {
    groundSky: 'mountains',
    state: {
        groundIn: false
    },
    aria: {
        hidden: 'true'
    },
    attr: {
        'data-ground': (el, s)=>s.groundIn ? 'in' : 'out'
    },
    display: 'none',
    position: 'fixed',
    left: '0',
    right: '0',
    bottom: '0',
    height: 'groundBand',
    zIndex: '-1',
    pointerEvents: 'none',
    overflow: 'hidden',
    hide: (el, s)=>!el.call('ambientGroundState', s, el.groundSky).enabled,
    Rise: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        transform: 'translateY(100%)',
        Art: {
            position: 'absolute',
            inset: '0',
            pointerEvents: 'none',
            background: 'loaderInk',
            maskImage: (el, s)=>el.call('ambientMaskImage', el.call('ambientGroundState', s, el.parent.parent.groundSky).url),
            maskSize: 'auto 100%',
            maskRepeat: 'repeat-x',
            maskPosition: 'center bottom'
        }
    }
};

});

parcelRegister("23ker", function(module, exports) {

$parcel$export(module.exports, "HomePosterCaption", () => $17eb8e3bcf27df05$export$127b13b6c1ca02d1);

var $dS9Zz = parcelRequire("dS9Zz");
const $17eb8e3bcf27df05$export$127b13b6c1ca02d1 = {
    tag: 'span',
    fontSize: 'Z',
    fontWeight: '400',
    color: (0, $dS9Zz.HomePosterSoftInk).color
};

});

parcelRegister("ahEnG", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetColorPicker", () => $77cad0c36a1967b5$export$2ea6e953cac2f921);
$parcel$export(module.exports, "HomeWidgetColorSwatch", () => $77cad0c36a1967b5$export$f202b0870c1a4a7f);
// HomeWidgetColorPicker — the swatch palette behind the home widget context
// menu's "Add color" / "Change color" row (2026-09-02, Nika: "on / page
// widgets, make solid - a default color for all of them. but add in context
// menu 'Add color' option so users can customize widget colors + suggested
// colors").
//
// ── Why this is not a second ContextDropdown ─────────────────────────────
// The chained-menu shape would be the cheaper build, and it is the wrong one:
// a `ContextDropdownItem` cannot carry a colour. Its ink is a two-value
// branch — `(el, s) => (s?.danger || s?.color === 'red' ? 'red' : 'title')` —
// and its only leading slots are an `Icon` painted by that same ink and an
// `Avatar` fed a `src` URL. Fourteen suggested colours rendered as fourteen
// identically-black word rows is a list of app names, not a colour picker,
// and the word rows would also be the wrong label: the user is colouring an
// arbitrary widget, so "Electric blue" is the honest name and "Studio" is a
// category error. Widening the shared row is a change in packages/shared,
// which this work does not own. So the palette is its own surface — and it
// still reuses the house chrome (`MenuPanel`, the same panel every context
// menu paints) rather than inventing a second one.
//
// ── Contract ─────────────────────────────────────────────────────────────
// Driven by `root._homeColorPicker`: `{ widgetId, x, y }`, written by
// `functions/homeContextMenu.js` when the menu row is clicked (`x`/`y` are
// the cursor coords the OPENER stamped on that row — the dispatcher has no
// event of its own). Cleared on select, on Escape, and on any outside click.
//
// Writing goes through `root._homeOps.setWidgetColor(widgetId, familyKey)` —
// the same hook bag the menu's refresh / hide / autolayout actions already
// use, so the persistence stays in pages/main.js beside the hidden-widget
// writer it mirrors, and this component owns no storage.
//
// The rows come from `el.call('homeWidgetColorOptions', root, widgetId)`, not
// from an imported table: a component that closes over a module-scope const
// reads it as undefined after `frank.toJSON` (FA201–204), which would render
// an empty palette on the platform and a full one locally.
const $77cad0c36a1967b5$export$2ea6e953cac2f921 = {
    scope: {
        // Viewport clamp — the same idea as ContextDropdown's `ddMenuPos`, with a
        // FIXED worst-case size instead of a measured one: this panel's content
        // is a constant 7×2 swatch grid plus two rows of chrome, so its size does
        // not depend on the data and there is nothing to settle for. Padding of 8
        // keeps it off the viewport edge.
        pickerPos (el) {
            const p = el.state && el.state.root && el.state.root._homeColorPicker || {};
            const pad = 8;
            const vw = typeof window !== 'undefined' ? window.innerWidth : 1200;
            const vh = typeof window !== 'undefined' ? window.innerHeight : 800;
            const w = el.node && el.node.offsetWidth || 320;
            const h = el.node && el.node.offsetHeight || 190;
            return {
                left: Math.max(pad, Math.min(p.x || 0, vw - w - pad)),
                top: Math.max(pad, Math.min(p.y || 0, vh - h - pad))
            };
        },
        // Move DOM focus into the panel once it has painted, for the SAME reason
        // `functions/homeContextMenu.js:focusHomeContextMenu` exists: DOMQL's
        // keydown delegate walks the ancestor chain of `event.target`, so an
        // Escape keypress never reaches this panel's `onKeydown` unless focus is
        // inside it. Bounded poll, not one microtask check — the panel is
        // `display: none` until this render commits.
        focusPicker (el) {
            if (typeof window === 'undefined' || !el) return;
            el.__hwcFocusGen = (el.__hwcFocusGen || 0) + 1;
            const gen = el.__hwcFocusGen;
            let ticks = 0;
            const tick = ()=>{
                if (gen !== el.__hwcFocusGen || !el.node) return;
                if (!(el.state && el.state.root && el.state.root._homeColorPicker)) return;
                if (el.node.offsetWidth > 0 && el.node.offsetHeight > 0) {
                    const first = el.node.querySelector('button');
                    if (first && first.focus) first.focus();
                    else if (el.node.focus) el.node.focus();
                    return;
                }
                if (++ticks < 10) window.setTimeout(tick, 20);
            };
            tick();
        },
        closePicker (s) {
            if (s && s.root) s.root.update({
                _homeColorPicker: null
            }, {
                preventFetch: true
            });
        },
        // The "App color" row's data, or null when this widget declares no
        // manifest hue (or declares one that does not resolve). Resolved through
        // the registered function rather than inline so the swatch, the tick and
        // the click handler all read ONE derivation — and so nothing here closes
        // over a module-scope table (FA201–204).
        appOption (el, s) {
            const p = s && s.root && s.root._homeColorPicker;
            if (!p) return null;
            return el.call('homeWidgetAppColorOption', s.root, p.widgetId, p.appHue, el.context && el.context.designSystem);
        }
    },
    position: 'fixed',
    inset: '0',
    // Above the shell's DropdownRoot layer, in the same band ContextDropdown
    // uses (app.js: DropdownRoot 10010, ContextDropdown 10100, ModalRoot
    // 10500). Flat, not a `style` bag: this one is a CONSTANT, and only
    // ContextDropdown's dynamic per-open `z` needs the reactive style channel.
    zIndex: '10150',
    // FA515 — the `s.root &&` guard short-circuits before the key is read on a
    // run with no root, so the signal is declared explicitly rather than left
    // to the auto-tracker: a missed subscription here means the palette never
    // appears at all.
    hideDeps: [
        '_homeColorPicker'
    ],
    hide: (el, s)=>!(s.root && s.root._homeColorPicker),
    // Transparent backdrop — clicking (or right-clicking) anywhere off the
    // palette closes it. Sibling of the panel, so swatch clicks never hit it.
    HwcBackdrop: {
        position: 'absolute',
        inset: '0',
        onPointerdown: (e, el, s)=>el.scope.closePicker(s),
        onContextmenu: (e, el, s)=>{
            e.preventDefault();
            el.scope.closePicker(s);
        }
    },
    HwcPanel: {
        extends: 'MenuPanel',
        position: 'absolute',
        flow: 'y',
        gap: 'Z',
        padding: 'Z1',
        width: 'max-content',
        // Programmatic focus target only — kept out of normal Tab order, the
        // standard ARIA menu-container idiom (same as ContextDropdown's Menu).
        tabindex: '-1',
        role: 'menu',
        'aria-label': (el)=>el.call('polyglot', 'workspace.widgetColor.pickerAria'),
        style: {
            left: (el, s)=>el.scope.pickerPos(el).left + 'px',
            top: (el, s)=>el.scope.pickerPos(el).top + 'px'
        },
        // subscribeTo + onUpdate is this app's established re-arm pattern
        // (CanvasPageSlot, GridContainer, ContextDropdown): onRender alone does
        // not reliably re-fire per open in v3.14.
        subscribeTo: [
            '_homeColorPicker'
        ],
        onRender: (el)=>el.scope.focusPicker(el),
        onUpdate: (el)=>el.scope.focusPicker(el),
        onKeydown: (e, el, s)=>{
            if (e.key !== 'Escape') return;
            e.preventDefault();
            el.scope.closePicker(s);
        },
        // ── The module's OWN colour, offered first ────────────────────────────
        // An app-store / module widget's manifest hue stopped PAINTING by default
        // on 2026-09-02 (Nika: "pipeline still has color and set to no color also
        // does not change it. fix it fundamentally for also all app-store related
        // apps and widgets too"). Demoting it to a suggestion is what makes
        // "Default (no color)" genuinely neutralise every widget — but the app's
        // identity must not become unreachable, so it sits at the TOP of the
        // palette, one click away.
        //
        // Shaped like the "Default" row rather than dropped into the swatch grid:
        // the grid is a row of interchangeable suggestions, while this one is a
        // named, widget-specific choice that deserves its label on screen instead
        // of only in a tooltip. Hidden — and structurally inert — for every
        // widget with no manifest hue, which is the whole static plane.
        HwcApp: {
            hide: (el, s)=>!el.scope.appOption(el, s),
            hideDeps: [
                '_homeColorPicker',
                '_homeWidgetColors'
            ],
            extends: 'MenuPanelItem',
            tag: 'button',
            type: 'button',
            role: 'menuitemradio',
            flow: 'x',
            align: 'center left',
            gap: 'Z1',
            color: 'title',
            'aria-label': (el)=>el.call('polyglot', 'workspace.widgetColor.appColor'),
            'aria-checked': (el, s)=>(el.scope.appOption(el, s) || {}).active ? 'true' : 'false',
            HwcAppDot: {
                width: 'B',
                height: 'B',
                minWidth: 'B',
                round: 'radiusControl',
                align: 'center center',
                // The hue itself, resolved through the SAME `_rawHueEntry` the card
                // will use — the swatch can never preview a colour the card then
                // paints differently.
                background: (el, s)=>(el.scope.appOption(el, s) || {}).bg || 'overlayStrong',
                color: (el, s)=>(el.scope.appOption(el, s) || {}).ink || 'title',
                Icon: {
                    icon: 'check',
                    boxSize: 'Z1',
                    display: (el, s)=>(el.scope.appOption(el, s) || {}).active ? 'inline-flex' : 'none'
                }
            },
            HwcAppLabel: {
                tag: 'span',
                flex: '1',
                whiteSpace: 'nowrap',
                text: '{{ workspace.widgetColor.appColor | polyglot }}'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const opt = el.scope.appOption(el, s);
                const picker = s.root && s.root._homeColorPicker;
                const ops = s.root && s.root._homeOps || {};
                if (opt && picker && typeof ops.setWidgetColor === 'function') // Stores the RAW hue, never a "use the manifest" sentinel: a widget
                // the user deliberately coloured must not silently repaint when the
                // module ships a new manifest.
                ops.setWidgetColor(picker.widgetId, opt.key);
                el.scope.closePicker(s);
            }
        },
        HwcHeading: {
            tag: 'span',
            fontSize: 'Y',
            fontWeight: '700',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: 'caption',
            padding: '0 Y',
            text: '{{ workspace.widgetColor.suggested | polyglot }}'
        },
        HwcGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, auto)',
            gap: 'Y',
            padding: '0 Y',
            childExtends: 'HomeWidgetColorSwatch',
            childrenAs: 'state',
            // FA515 — same reason as `hideDeps` above; plus `_homeWidgetColors`,
            // which `homeWidgetColorOptions` reads to flag the ACTIVE swatch, so
            // the tick moves when the pick changes while the palette is open.
            childrenDeps: [
                '_homeColorPicker',
                '_homeWidgetColors'
            ],
            children: (el, s)=>el.call('homeWidgetColorOptions', s.root, s.root && s.root._homeColorPicker ? s.root._homeColorPicker.widgetId : null)
        },
        // Clear back to the board's neutral solid. Reuses the house context-menu
        // row so this reads as one family with the menu it came from.
        HwcDefault: {
            extends: 'MenuPanelItem',
            tag: 'button',
            type: 'button',
            role: 'menuitem',
            flow: 'x',
            align: 'center left',
            gap: 'Z1',
            color: 'title',
            HwcDefaultDot: {
                // The neutral solid itself, drawn at swatch size so "Default" reads
                // as one more option in the same row of choices rather than as a
                // detached command.
                width: 'B',
                height: 'B',
                minWidth: 'B',
                round: 'radiusControl',
                background: 'overlayStrong',
                borderWidth: 'hairline',
                borderStyle: 'solid',
                borderColor: 'line'
            },
            HwcDefaultLabel: {
                tag: 'span',
                flex: '1',
                whiteSpace: 'nowrap',
                text: '{{ workspace.widgetColor.default | polyglot }}'
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const picker = s.root && s.root._homeColorPicker;
                const ops = s.root && s.root._homeOps || {};
                if (picker && typeof ops.setWidgetColor === 'function') ops.setWidgetColor(picker.widgetId, null);
                el.scope.closePicker(s);
            }
        }
    }
};
const $77cad0c36a1967b5$export$f202b0870c1a4a7f = {
    tag: 'button',
    type: 'button',
    role: 'menuitemradio',
    width: 'B',
    height: 'B',
    minWidth: 'B',
    round: 'radiusControl',
    padding: '0',
    border: 'none',
    cursor: 'pointer',
    align: 'center center',
    background: (el, s)=>s && s.bg || 'overlayStrong',
    color: (el, s)=>s && s.ink || 'title',
    transition: '120ms defaultBezier transform',
    ':hover': {
        transform: 'scale(1.12)'
    },
    ':active': {
        transform: 'scale(0.96)'
    },
    '@media (prefers-reduced-motion: reduce)': {
        ':hover': {
            transform: 'none'
        },
        ':active': {
            transform: 'none'
        }
    },
    title: (el, s)=>s && s.label || '',
    aria: {
        label: (el, s)=>s && s.label || '',
        checked: (el, s)=>s && s.active ? 'true' : 'false'
    },
    // The tick is painted in the family's OWN binary ink, which is the one ink
    // measured legible on that background (functions/homeWidgetHue.js) — a
    // fixed white or black tick would vanish on half the palette.
    Icon: {
        icon: 'check',
        boxSize: 'Z1',
        display: (el, s)=>s && s.active ? 'inline-flex' : 'none'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        const picker = s.root && s.root._homeColorPicker;
        const ops = s.root && s.root._homeOps || {};
        if (picker && typeof ops.setWidgetColor === 'function') ops.setWidgetColor(picker.widgetId, s.key);
        if (s.root) s.root.update({
            _homeColorPicker: null
        }, {
            preventFetch: true
        });
    }
};

});

parcelRegister("b5NRZ", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetBody", () => $8136d876def89bfc$export$e2d34377ad3c3f28);
// The SLOT GRID of a home widget body (HOME_WIDGETS_SPEC.md §2). A body root
// extends it — `CrmRecentWidgetBody: { extends: 'HomeWidgetBody', … }` — and
// fills it with the slot components (HomeWidgetHero, HomeWidgetDelta, one
// visual, HomeWidgetList, HomeWidgetFooter, HomeWidgetEmpty); each slot names
// its own `gridArea`, so a body never places anything itself.
//
// The areas follow the SIZE of the grid cell the widget sits in. The board
// stamps `data-widget-size="s|m|l|xl"` on every grid item (pages/main.js,
// functions/homeGridMetrics.js), and the size blocks below are ancestor
// selectors on it:
//   S  hero · delta · visual (a progress only) · footer
//   M  hero + delta left, the visual right, footer under both
//   L  hero · delta · visual · list (takes the rest) · footer
//   XL hero + delta | visual | list, footer under all three
// A slot the size does not show hides itself (display none) and an `auto`
// track collapses, so a body without a delta or a list leaves no hole. The
// footer's row takes the rest, and the footer pins itself to its bottom edge.
//
// WHY `:is([data-widget-size="m"]) &` and not a media token: the element layer
// compiles every registered `@token` to `@media <value>`, so a selector-valued
// token emits a dead `@media [data-widget-size…]` block (measured in jsdom,
// 2026-09-26). `:is()` also carries the attribute's specificity, (0,2,0), so a
// size block beats the base declaration by weight, never by insertion order —
// `:where()` would tie at (0,1,0).
//
// EMPTY: a body declares `empty` ONCE on its root — true when its data has
// answered and there is nothing to show — and this grid swaps every data slot
// for the one HomeWidgetEmpty sentence (spec §2: never "0", "0.00" or an
// empty tall card). While the data is unread `empty` stays false, so the
// slots keep their skeletons; the sentence never shows without the flag.
//
//   CrmRecentWidgetBody: {
//     extends: 'HomeWidgetBody',
//     empty: (el, s) => !!s.root.crmContactsLoaded && !(s.root.crmContacts || []).length,
//     …
//     HomeWidgetEmpty: { Text: { text: '{{ apps.widget.crmRecent.empty | polyglot }}' } }
//   }
//
// NARROW BOARDS: a size does not always get its width (spec §1: on one
// column every size is one cell wide, on two columns XL is two wide). The
// board stylesheet then gives the body the arrangement of the width it really
// spans (functions/homeGridMetrics.js `homeBodyFit` + `HOME_BODY_LAYOUTS`,
// pages/main.js `_injectWidgetStyles`). HOME_BODY_LAYOUTS is the same four
// blocks as below — a component cannot import it, so
// __tests__/homeSlotBodyArrangement.test.js pins the two copies equal.
// The `home-widget-body` class is what that sheet selects, and what keeps the
// two-tier bodies' flex filler off a slot grid.
//
// The frame owns the surface, padding and radius; this grid only lays out.
const $8136d876def89bfc$export$e2d34377ad3c3f28 = {
    class: 'home-widget-body',
    display: 'grid',
    flex: '1 1 auto',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gridTemplateAreas: '"hero" "delta" "visual" "footer"',
    gridTemplateRows: 'auto auto auto minmax(0, 1fr)',
    rowGap: 'Z',
    columnGap: 'A',
    alignContent: 'stretch',
    height: '100%',
    minHeight: '0',
    minWidth: '0',
    empty: false,
    attr: {
        'data-empty': (el)=>el.empty ? 'true' : null
    },
    '&[data-empty] > :not(.home-widget-empty)': {
        display: 'none'
    },
    '&:not([data-empty]) > .home-widget-empty': {
        display: 'none'
    },
    ':is([data-widget-size="m"]) &': {
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
        gridTemplateAreas: '"hero visual" "delta visual" "footer footer"',
        gridTemplateRows: 'auto minmax(0, 1fr) auto'
    },
    // L packs: every slot keeps its own height, the list takes the rest (its
    // rows at its top), the footer stays on the bottom edge — one band at most,
    // under the rows (crm-w1 twin QA F5: a face stack centred in a 2fr band and
    // rows in a 3fr band left three empty bands in a 280×572 card).
    ':is([data-widget-size="l"]) &': {
        gridTemplateAreas: '"hero" "delta" "visual" "list" "footer"',
        gridTemplateRows: 'auto auto auto minmax(0, 1fr) auto'
    },
    ':is([data-widget-size="xl"]) &': {
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.25fr) minmax(0, 1.25fr)',
        gridTemplateAreas: '"hero visual list" "delta visual list" "footer footer footer"',
        gridTemplateRows: 'auto minmax(0, 1fr) auto'
    }
};

});

parcelRegister("6RJxn", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetHero", () => $4ffb0415b2a11e49$export$5bdba57cbe556772);
// The HERO slot of a home widget (HOME_WIDGETS_SPEC.md §2): one display
// numeral with its unit as a grey word on the same line — "34 contacts",
// "USD 12.4K", "7 out".
//
//   HomeWidgetHero: {
//     Value: { text: (el, s) => el.call('crmContactCount', s.root) },
//     Unit: { text: '{{ apps.widget.crmRecent.unit | polyglot }}' },
//     unitFirst: true    // money: the ISO code word leads ("USD 12.4K")
//   }
//
// The numeral is the sans face at weight 300, tabular, tracked −0.03em, `E` at
// S/M and `F` at L/XL; the unit (and the optional trailing `Tail` word) is
// `A` 400 `inactive`. Text stays neutral — the widget hue lives on the plate
// and the visual only (spec §3).
//
// QUALITY LAW (HOME_AMBIENT_SKIN_SPEC §3): the hero is PRIMARY text and never
// truncates — the numeral is compact by contract (the body's formatter:
// 12.4K, 86.9M) and the unit words wrap under it instead of an ellipsis.
//
// LOADING — `Value.text` (a string, or an `(el, s)` factory returning one)
// null/undefined means "not read yet": a skeleton bar
// one numeral-line tall stands in and the unit words hide, so the row keeps
// the height the numeral will have (zero shift when the number lands). An
// empty string is a real answer, not a load state.
const $4ffb0415b2a11e49$export$5bdba57cbe556772 = {
    class: 'widget-hero',
    gridArea: 'hero',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'baseline',
    columnGap: 'Y',
    minWidth: '0',
    unitFirst: false,
    Value: {
        tag: 'span',
        fontSize: 'E',
        fontWeight: '300',
        lineHeight: '1',
        letterSpacing: '-0.03em',
        fontVariantNumeric: 'tabular-nums',
        color: 'title',
        whiteSpace: 'nowrap',
        ':is([data-widget-size="l"]) &': {
            fontSize: 'F'
        },
        ':is([data-widget-size="xl"]) &': {
            fontSize: 'F'
        }
    },
    Unit: {
        tag: 'span',
        order: (el)=>el.parent.unitFirst ? '-1' : '0',
        fontSize: 'A',
        fontWeight: '400',
        lineHeight: '1.3',
        color: 'inactive',
        overflowWrap: 'anywhere',
        minWidth: '0',
        hide: (el)=>el.call('homeSlotText', el.parent.Value) == null
    },
    Tail: {
        tag: 'span',
        fontSize: 'A',
        fontWeight: '400',
        lineHeight: '1.3',
        color: 'inactive',
        overflowWrap: 'anywhere',
        hide: (el)=>!el.call('homeSlotText', el) || el.call('homeSlotText', el.parent.Value) == null
    },
    Skeleton: {
        fontSize: 'E',
        width: '2.4em',
        height: '1em',
        ':is([data-widget-size="l"]) &': {
            fontSize: 'F'
        },
        ':is([data-widget-size="xl"]) &': {
            fontSize: 'F'
        },
        hide: (el)=>el.call('homeSlotText', el.parent.Value) != null
    }
};

});

parcelRegister("imvgE", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetDelta", () => $d5e28921a73c3d81$export$8ae249e9bf773235);
// The DELTA chip of a home widget (HOME_WIDGETS_SPEC.md §2): a `layer`
// capsule with a status dot and a mono value — "↑ 12% · 7d".
//
//   HomeWidgetDelta: {
//     Text: { text: (el, s) => el.call('biDeltaLabel', s.root) },
//     bad: (el, s) => el.call('biDeltaIsDown', s.root),   // red dot
//     hide: (el, s) => !el.call('biHasComparison', s.root)
//   }
//
// The dot takes the widget hue for a trend and `dangerInk` only when the
// message is bad (overdue, low, out). With no comparison the body hides the
// chip — never a fake "0%".
const $d5e28921a73c3d81$export$8ae249e9bf773235 = {
    tag: 'span',
    class: 'home-widget-delta',
    gridArea: 'delta',
    display: 'flex',
    alignItems: 'center',
    gap: 'X2',
    justifySelf: 'start',
    alignSelf: 'start',
    width: 'fit-content',
    maxWidth: '100%',
    padding: 'W2 Y1',
    round: 'radiusPill',
    theme: 'layer',
    bad: false,
    Dot: {
        tag: 'span',
        'aria-hidden': 'true',
        boxSize: 'Y',
        flexShrink: '0',
        round: 'radiusPill',
        background: (el)=>el.parent.bad ? 'dangerInk' : '--home-widget-accent'
    },
    Text: {
        tag: 'span',
        fontFamily: 'Code',
        fontSize: 'Y',
        lineHeight: '1.4',
        fontVariantNumeric: 'tabular-nums',
        color: 'caption',
        whiteSpace: 'nowrap',
        minWidth: '0',
        overflow: 'hidden',
        // secondary text: an ellipsis is allowed only with the full text in `title`
        textOverflow: 'ellipsis',
        title: (el)=>el.call('homeSlotText', el) || null
    }
};

});

parcelRegister("193j2", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetProgress", () => $0d59323a9595b830$export$6d6b87a97157b844);
// The UNDERLINE PROGRESS visual of a home widget (HOME_WIDGETS_SPEC.md §2):
// a 4 px capsule, the widget hue on a `layer` track. The one visual an S
// widget keeps.
//
//   HomeWidgetProgress: { ratio: (el, s) => el.call('pgCoverageRatio', s.root) }
//
// `ratio` is 0..1 (clamped). Null/undefined = not read yet: the empty track
// pulses as its own skeleton, same box, zero shift.
const $0d59323a9595b830$export$6d6b87a97157b844 = {
    class: 'home-widget-visual',
    gridArea: 'visual',
    alignSelf: 'center',
    width: '100%',
    height: 'X',
    round: 'radiusPill',
    theme: 'layer',
    overflow: 'hidden',
    role: 'progressbar',
    'aria-valuemin': '0',
    'aria-valuemax': '100',
    'aria-valuenow': (el)=>el.ratio == null ? null : String(Math.round(Math.min(1, Math.max(0, Number(el.ratio) || 0)) * 100)),
    animation: (el)=>el.ratio == null ? 'pulse 1.5s ease-in-out infinite' : 'none',
    ratio: null,
    Fill: {
        height: '100%',
        round: 'radiusPill',
        background: '--home-widget-accent',
        transition: 'width C defaultBezier',
        width: (el)=>{
            const r = el.parent.ratio;
            const v = r == null ? 0 : Math.min(1, Math.max(0, Number(r) || 0));
            return Math.round(v * 1000) / 10 + '%';
        }
    }
};

});

parcelRegister("30PMN", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetSpark", () => $23198acfee5416f8$export$30697ca589280299);
// The SPARKLINE visual of a home widget (HOME_WIDGETS_SPEC.md §2): a 2 px
// stroke in the widget hue over an 8% area. Data-driven, so an inline SVG —
// a chart, not an icon (Rule 62 is about icons; the BI revenue body draws its
// trend the same way).
//
//   HomeWidgetSpark: { points: (el, s) => el.call('comRevenueByHour', s.root) }
//
// Geometry comes from `homeSparkGeom` (functions/homeWidgetVisuals.js). Fewer
// than two points = not read yet: a skeleton block fills the same box. Hidden
// at S (spec: an S widget keeps only a progress as its visual).
const $23198acfee5416f8$export$30697ca589280299 = {
    class: 'home-widget-visual',
    gridArea: 'visual',
    display: 'none',
    ':is([data-widget-size]:not([data-widget-size="s"])) &': {
        display: 'block'
    },
    position: 'relative',
    alignSelf: 'stretch',
    minHeight: 'C',
    minWidth: '0',
    // L stacks the slots and its visual track is `auto` (the list takes the
    // rest): the chart is absolutely placed, so it keeps its OWN height there —
    // a 3:1 box, never less than C — instead of filling a track that has none.
    ':is([data-widget-size="l"]) &': {
        alignSelf: 'start',
        aspectRatio: '3 / 1'
    },
    color: '--home-widget-accent',
    points: null,
    Chart: {
        // frank-allow FA601 — data sparkline (non-icon viewBox), not an icon
        tag: 'svg',
        viewBox: '0 0 120 36',
        attr: {
            preserveAspectRatio: 'none',
            'aria-hidden': 'true'
        },
        position: 'absolute',
        inset: '0',
        width: '100%',
        height: '100%',
        display: 'block',
        overflow: 'visible',
        hide: (el)=>!el.call('homeSparkGeom', el.parent.points, 120, 36, 3),
        Area: {
            // frank-allow FA602 — computed sparkline area, not an icon
            tag: 'path',
            attr: {
                d: (el)=>(el.call('homeSparkGeom', el.parent.parent.points, 120, 36, 3) || {}).areaPath || null,
                fill: 'currentColor',
                'fill-opacity': '0.08',
                stroke: 'none'
            }
        },
        Line: {
            // frank-allow FA602 — computed sparkline stroke, not an icon
            tag: 'path',
            attr: {
                d: (el)=>(el.call('homeSparkGeom', el.parent.parent.points, 120, 36, 3) || {}).linePath || null,
                fill: 'none',
                stroke: 'currentColor',
                'stroke-width': '2',
                'stroke-linejoin': 'round',
                'stroke-linecap': 'round',
                'vector-effect': 'non-scaling-stroke'
            }
        }
    },
    Skeleton: {
        position: 'absolute',
        inset: '0',
        width: 'auto',
        height: 'auto',
        round: 'radiusControl',
        hide: (el)=>!!el.call('homeSparkGeom', el.parent.points, 120, 36, 3)
    }
};

});

parcelRegister("b4j4k", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetDots", () => $80eedc1e6828bc7c$export$da91986f7f371de6);
$parcel$export(module.exports, "HomeWidgetDot", () => $80eedc1e6828bc7c$export$96b92a38dd3f5071);
// The DOT CHART visual of a home widget (HOME_WIDGETS_SPEC.md §2): past /
// filled units in the widget hue, the rest on the `layer` wash — the days of
// a month, the products that are healthy, the hours already booked.
//
//   HomeWidgetDots: { dots: (el, s) => el.call('biStockDots', s.root) }
//
// `dots` is an array of booleans (true = hue). Null = not read yet: fourteen
// resting dots pulse as the skeleton. Hidden at S.
const $80eedc1e6828bc7c$export$da91986f7f371de6 = {
    class: 'home-widget-visual',
    gridArea: 'visual',
    display: 'none',
    ':is([data-widget-size]:not([data-widget-size="s"])) &': {
        display: 'flex'
    },
    flexWrap: 'wrap',
    alignContent: 'center',
    gap: 'X2',
    minWidth: '0',
    dots: null,
    animation: (el)=>Array.isArray(el.dots) ? 'none' : 'pulse 1.5s ease-in-out infinite',
    childExtends: 'HomeWidgetDot',
    childrenAs: 'state',
    children: (el)=>(Array.isArray(el.dots) ? el.dots : Array.from({
            length: 14
        }, ()=>false)).map((on, i)=>({
                key: 'dot' + i,
                on: !!on
            }))
};
const $80eedc1e6828bc7c$export$96b92a38dd3f5071 = {
    tag: 'span',
    boxSize: 'Z',
    flexShrink: '0',
    round: 'radiusPill',
    background: (el, s)=>s && s.on ? '--home-widget-accent' : '--theme-layer-background'
};

});

parcelRegister("b4KYc", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetAvatars", () => $810480a9c980462a$export$dc62f930bcedcd31);
$parcel$export(module.exports, "HomeWidgetFace", () => $810480a9c980462a$export$f74afea6052e57e7);
// The AVATAR STACK visual of a home widget (HOME_WIDGETS_SPEC.md §2): up to
// four 24 px faces overlapping by 6 px, then a "+N" `layer` chip.
//
//   HomeWidgetAvatars: {
//     people: (el, s) => el.call('hrOutNowPeople', s.root)  // [{ key, name, email?, src? }]
//   }
//
// Each face is the house AvatarBundleItem (photo, else initials) at the
// `avatarXs` size. Null = not read yet: one skeleton circle. Hidden at S.
const $810480a9c980462a$export$dc62f930bcedcd31 = {
    class: 'home-widget-visual',
    gridArea: 'visual',
    display: 'none',
    ':is([data-widget-size]:not([data-widget-size="s"])) &': {
        display: 'flex'
    },
    alignItems: 'center',
    alignSelf: 'center',
    minWidth: '0',
    people: null,
    Faces: {
        display: 'flex',
        alignItems: 'center',
        childExtends: 'HomeWidgetFace',
        childrenAs: 'state',
        children: (el)=>(Array.isArray(el.parent.people) ? el.parent.people : []).slice(0, 4).map((p, i)=>({
                    key: String(p && (p.key || p.email || p.name) || 'face' + i),
                    name: p && p.name || '',
                    email: p && p.email || '',
                    avatar: p && (p.src || p.avatar) || null
                }))
    },
    More: {
        tag: 'span',
        theme: 'layer',
        round: 'radiusPill',
        padding: 'W2 Y',
        marginInlineStart: 'Y',
        fontFamily: 'Code',
        fontSize: 'Y',
        fontVariantNumeric: 'tabular-nums',
        color: 'caption',
        hide: (el)=>!(Array.isArray(el.parent.people) && el.parent.people.length > 4),
        text: (el)=>'+' + Math.max(0, ((el.parent.people || []).length || 0) - 4)
    },
    SkeletonCircle: {
        boxSize: 'avatarXs',
        hide: (el)=>Array.isArray(el.parent.people)
    }
};
const $810480a9c980462a$export$f74afea6052e57e7 = {
    extends: 'AvatarBundleItem',
    marginInlineEnd: '-Y',
    borderColor: 'var(--home-card-bg, var(--theme-card-background))',
    BundlePlate: {
        width: 'avatarXs',
        height: 'avatarXs',
        fontSize: 'Y',
        background: '--home-widget-hue',
        color: '--home-widget-hue-ink'
    }
};

});

parcelRegister("ebATa", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetList", () => $a53eb5183c6df9d1$export$b84256e273e27a46);
$parcel$export(module.exports, "HomeWidgetRow", () => $a53eb5183c6df9d1$export$12721a76aefbabdc);
// The 3-ROW LIST of a home widget (HOME_WIDGETS_SPEC.md §2): a 24 px plate
// (initials / icon / photo), a `Z` 500 title and a right-hand mono meta; an
// optional underline progress under the row and a red dot for a bad row. No
// hairlines — rows separate by gap. The row title is PRIMARY text (quality
// law, HOME_AMBIENT_SKIN_SPEC §3): it wraps and the row grows — never a
// clamp, never an ellipsis (a two-line design, not a two-line cap); the meta
// is short and carries its full text in `title`.
//
//   HomeWidgetList: {
//     items: (el, s) => el.call('crmRecentRows', s.root)
//     // [{ key, title, meta?, metaTail?, initials? | icon? | src?,
//     //    progress? (0..1), bad?, href? | open?: { call, arg } }]
//   }
//
// `metaTail` is the meta's last part when its END names the thing — a host's
// domain ending (".example"). The meta's head then takes the ellipsis and the
// tail never shrinks: "docs.larkf….example", never "docs.larkfield.examp…"
// (the medium Bookmarks widget, media lane on dev 2026-10-25).
//
// A row OPENS ITS RECORD when it says how: `href` makes it a real link to an
// outside page (a new tab), `open: { call, arg }` a real button that runs the
// body's registered function with `arg`; a row with neither stays plain text.
// The frame never answers a click inside the body, so the row's own action is
// the only one. Every row states its tag, so a data id like "b" or "i" is
// never inferred as an HTML element.
//
// The data prop is `items`, NEVER `rows`: `rows` is the smbls grid shorthand
// (grid-template-rows, css-in-props GRID_PROPS), so a `rows` factory is run
// as CSS and the element keeps the function — the list would show skeletons
// forever (measured 2026-09-27).
//
// `items` null = not read yet: three skeleton rows in the same geometry. At
// most `max` rows show — three, the recipe's list; a body whose list is its
// whole content (Next up's day list) may raise it. Shown at L and XL; a list that is the body's ONLY
// visual sets `asVisual: true` and then also takes the visual slot at M (and
// spans the visual + list tracks at L/XL, so no empty track is left).
const $a53eb5183c6df9d1$export$b84256e273e27a46 = {
    class: 'home-widget-list',
    gridArea: 'list',
    display: 'none',
    flexDirection: 'column',
    gap: 'Y',
    alignSelf: 'start',
    minWidth: '0',
    minHeight: '0',
    asVisual: false,
    items: null,
    max: 3,
    attr: {
        'data-as-visual': (el)=>el.asVisual ? 'true' : null
    },
    '&[data-as-visual]': {
        gridArea: 'visual'
    },
    ':is([data-widget-size="l"]) &': {
        display: 'flex'
    },
    ':is([data-widget-size="xl"]) &': {
        display: 'flex'
    },
    ':is([data-widget-size="m"]) &[data-as-visual]': {
        display: 'flex'
    },
    ':is([data-widget-size="l"]) &[data-as-visual]': {
        gridRow: 'visual-start / list-end'
    },
    ':is([data-widget-size="xl"]) &[data-as-visual]': {
        gridColumn: 'visual-start / list-end'
    },
    childExtends: 'HomeWidgetRow',
    childrenAs: 'state',
    children: (el)=>{
        const max = Math.max(1, Math.floor(Number(el.max)) || 3);
        return Array.isArray(el.items) ? el.items.slice(0, max).map((r, i)=>({
                ...r,
                key: String(r && r.key || 'row' + i)
            })) : [
            {
                key: 'skel1',
                skel: true
            },
            {
                key: 'skel2',
                skel: true
            },
            {
                key: 'skel3',
                skel: true
            }
        ];
    }
};
const $a53eb5183c6df9d1$export$12721a76aefbabdc = {
    tag: (el, s)=>s && s.href ? 'a' : s && s.open && s.open.call ? 'button' : 'div',
    href: (el, s)=>s && s.href || null,
    target: (el, s)=>s && s.href ? '_blank' : null,
    rel: (el, s)=>s && s.href ? 'noreferrer' : null,
    type: (el, s)=>s && !s.href && s.open && s.open.call ? 'button' : null,
    onClick: (e, el, s)=>{
        if (!s || s.href || !s.open || !s.open.call) return;
        e.stopPropagation();
        el.call(s.open.call, s.open.arg, e);
    },
    // A link or a button: the house row wash on hover, the global ring on focus.
    width: '100%',
    padding: '0',
    border: 'none',
    background: 'transparent',
    color: 'inherit',
    textAlign: 'left',
    textDecoration: 'none',
    round: 'radiusControl',
    cursor: 'default',
    // Static selectors, not factories: a pseudo block does not re-evaluate.
    '&[href]': {
        cursor: 'pointer'
    },
    '&[type="button"]': {
        cursor: 'pointer'
    },
    '&[href]:hover': {
        background: 'hover'
    },
    '&[type="button"]:hover': {
        background: 'hover'
    },
    // A ROW YOU CAN TAP IS 44pt TALL ON A TOUCH SCREEN (DESIGN-SHELL-RESPONSIVE-
    // IOS-SAFARI-1): a widget's list rows measured 23-24px on dev DFI (touch
    // simulated). A pseudo slop would overlap the next row's — a list needs
    // real height — so a row that opens something grows to `controlH`; a
    // static row (no link, no action) keeps the desktop density.
    '@coarse': {
        '&[href]': {
            minHeight: 'controlH'
        },
        '&[type="button"]': {
            minHeight: 'controlH'
        }
    },
    display: 'grid',
    // The meta column fits its value up to half the row; past that its text
    // ends in an ellipsis (the full value is its tooltip). An `auto` meta
    // grew before the title's 1fr: a bio as meta ("[QA-E] profile bio
    // persistence test", 242px of a 287px row) left the title 0px wide, one
    // letter per line (Fly QA on dev, hr-recent, 2026-10-18).
    gridTemplateColumns: 'auto minmax(0, 1fr) fit-content(50%)',
    gridTemplateAreas: '"lead title meta" "lead bar bar"',
    columnGap: 'Z',
    rowGap: 'X',
    alignItems: 'center',
    minWidth: '0',
    Lead: {
        gridArea: 'lead',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSize: 'avatarXs',
        flexShrink: '0',
        round: 'radiusPill',
        overflow: 'hidden',
        theme: 'layer',
        fontSize: 'Y',
        fontWeight: '500',
        color: 'caption',
        hide: (el, s)=>!s || !(s.initials || s.icon || s.src || s.skel),
        Initials: {
            tag: 'span',
            text: (el, s)=>s && s.initials || '',
            hide: (el, s)=>!s || !s.initials || !!s.src
        },
        Icon: {
            name: (el, s)=>s && s.icon || 'star',
            boxSize: 'iconSm',
            hide: (el, s)=>!s || !s.icon || !!s.src
        },
        Photo: {
            tag: 'img',
            src: (el, s)=>s && s.src || null,
            alt: (el, s)=>s && s.title || '',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            hide: (el, s)=>!s || !s.src
        }
    },
    // A `mark` row leads with a short bar in the widget hue instead of a plate —
    // Next up's day list (HOME_AMBIENT_SKIN_SPEC.md §4 "hue bar + title + mono
    // time"). The bar is the row's height, the underline progress's thickness.
    Mark: {
        tag: 'span',
        'aria-hidden': 'true',
        gridArea: 'lead',
        alignSelf: 'stretch',
        width: 'W',
        minHeight: 'A',
        round: 'radiusPill',
        background: '--home-widget-accent',
        hide: (el, s)=>!s || !s.mark || !!s.skel
    },
    Title: {
        tag: 'span',
        class: 'widget-row-title',
        gridArea: 'title',
        fontSize: 'Z',
        fontWeight: '500',
        lineHeight: '1.35',
        color: 'title',
        minWidth: '0',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.title || '',
        hide: (el, s)=>!!(s && s.skel)
    },
    SkeletonRow: {
        gridArea: 'title',
        width: '60%',
        hide: (el, s)=>!(s && s.skel)
    },
    Meta: {
        gridArea: 'meta',
        display: 'flex',
        alignItems: 'center',
        minWidth: '0',
        // The dot keeps its own space: the meta's head and tail are ONE value, so
        // no gap may fall between them.
        Dot: {
            tag: 'span',
            'aria-hidden': 'true',
            boxSize: 'Y',
            flexShrink: '0',
            marginInlineEnd: 'X2',
            round: 'radiusPill',
            background: 'dangerInk',
            hide: (el, s)=>!(s && s.bad)
        },
        Text: {
            tag: 'span',
            fontFamily: 'Code',
            fontSize: 'Y',
            fontVariantNumeric: 'tabular-nums',
            color: 'inactive',
            whiteSpace: 'nowrap',
            minWidth: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            title: (el, s)=>s && s.meta != null ? String(s.meta) + String(s && s.metaTail || '') : null,
            text: (el, s)=>s && s.meta != null ? String(s.meta) : '',
            hide: (el, s)=>!s || s.meta == null || s.meta === ''
        },
        Tail: {
            tag: 'span',
            fontFamily: 'Code',
            fontSize: 'Y',
            fontVariantNumeric: 'tabular-nums',
            color: 'inactive',
            whiteSpace: 'nowrap',
            flexShrink: '0',
            text: (el, s)=>s && s.metaTail ? String(s.metaTail) : '',
            hide: (el, s)=>!s || !s.metaTail
        }
    },
    Bar: {
        gridArea: 'bar',
        height: 'W',
        round: 'radiusPill',
        theme: 'layer',
        overflow: 'hidden',
        hide: (el, s)=>!s || s.progress == null,
        Fill: {
            height: '100%',
            round: 'radiusPill',
            background: '--home-widget-accent',
            width: (el, s)=>Math.round(Math.min(1, Math.max(0, Number(s && s.progress) || 0)) * 1000) / 10 + '%'
        }
    }
};

});

parcelRegister("6QuJi", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetFooter", () => $4fbf6fa37c0b1f61$export$41aae8b05b6004f8);
// The FOOTER of a home widget (HOME_WIDGETS_SPEC.md §2): the house mono
// micro-label (AppMicroLabel: `Code`, `Y`, uppercase by CSS, 0.06em,
// `inactive`) pinned to the bottom edge — "LAST 7 DAYS", "3 OVERDUE".
//
//   HomeWidgetFooter: { text: '{{ apps.widget.biRevenue.footer | polyglot }}' }
const $4fbf6fa37c0b1f61$export$41aae8b05b6004f8 = {
    extends: 'AppMicroLabel',
    class: 'home-widget-footer',
    gridArea: 'footer',
    alignSelf: 'end',
    justifySelf: 'start',
    maxWidth: '100%',
    overflow: 'hidden',
    // secondary text: an ellipsis only with the full label in `title`
    textOverflow: 'ellipsis',
    title: (el)=>el.call('homeSlotText', el) || null
};

});

parcelRegister("8n5aH", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetEmpty", () => $61847baee90c19c8$export$907c0f55c1eb87c8);
// The EMPTY state of a home widget (HOME_WIDGETS_SPEC.md §2): a DESIGNED
// empty state, never "0", "0.00" or a large card holding one lone line (the
// peer's qa round 9: the Stores widget with no sales in the period). Centred in
// the card:
//   • the widget's own icon on a quiet `layer` disc, in the widget hue — not at
//     S, where a small card keeps its words;
//   • ONE sentence (`A` 500 `title`, balanced);
//   • ONE next action: the body's own (record a sale, add a contact …), else
//     the widget's app — "Open <widget>", the same open as the card and its ↗
//     (functions/homeWidgetFrame.js homeWidgetOpen) — and none when the widget
//     has nowhere to go.
// The plate and the title stay. The BODY decides when it shows: `empty` on the
// body root (components/HomeWidgetBody.js) swaps every data slot for this
// block; without it the block stays hidden.
//
//   HomeWidgetEmpty: {
//     Text: { text: '{{ apps.widget.storeRevenueToday.emptySentence | polyglot }}' },
//     Action: { text: '{{ apps.widget.storeRevenueToday.recordSale | polyglot }}', onClick: … }
//   }
//
// Both actions are the kit's quiet control (`layer` wash, `title` ink, hover
// `selected`), the same pair EmptyState uses for its secondary action.
const $61847baee90c19c8$export$907c0f55c1eb87c8 = {
    class: 'home-widget-empty',
    gridArea: '1 / 1 / -1 / -1',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: 'Z',
    minWidth: '0',
    Glyph: {
        tag: 'span',
        ariaHidden: 'true',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        boxSize: 'avatarMd',
        round: 'radiusPill',
        theme: 'layer',
        ':is([data-widget-size="s"]) &': {
            display: 'none'
        },
        Icon: {
            name: (el, s)=>s && s.icon || 'star',
            boxSize: 'iconLg',
            color: '--home-widget-accent'
        }
    },
    Text: {
        tag: 'p',
        margin: '0',
        maxWidth: '100%',
        fontSize: 'A',
        fontWeight: '500',
        lineHeight: '1.35',
        color: 'title',
        overflowWrap: 'anywhere',
        textWrap: 'balance'
    },
    Action: {
        extends: 'AppControl',
        compact: true,
        tag: 'button',
        type: 'button',
        theme: 'layer',
        color: 'title',
        padding: '0 A',
        round: 'radiusPill',
        fontSize: 'Z2',
        fontWeight: '500',
        border: 'none',
        cursor: 'pointer',
        ':hover': {
            background: 'selected'
        },
        ':active': {
            background: 'selected'
        },
        hide: (el)=>!el.call('homeSlotText', el)
    },
    Open: {
        extends: 'AppControl',
        compact: true,
        tag: 'button',
        type: 'button',
        theme: 'layer',
        color: 'title',
        padding: '0 A',
        round: 'radiusPill',
        fontSize: 'Z2',
        fontWeight: '500',
        border: 'none',
        cursor: 'pointer',
        ':hover': {
            background: 'selected'
        },
        ':active': {
            background: 'selected'
        },
        text: (el, s)=>String(el.call('polyglot', 'workspace.menu.openApp')).replace('{app}', String(el.call('polyglot', s && (s.title || s.id) || ''))),
        hide: (el, s)=>!!el.call('homeSlotText', el.parent.Action) || !el.call('homeWidgetOpenRoute', s),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('homeWidgetOpen', s, e);
        }
    }
};

});

parcelRegister("4F5uB", function(module, exports) {

$parcel$export(module.exports, "HomeNextUpBody", () => $364f4077c40f4d37$export$1840a3df3dc0f216);
// NEXT UP — the shell's calendar widget (HOME_AMBIENT_SKIN_SPEC.md §4;
// DESIGN-WL-HOME-WIDGETS-1). Size M by default, never smaller (its hero, the
// event line and the day list need two cells); L gives the day list the
// height for five rows.
//
//   hero      "in 42 min" · "now" (under way) · "in 3 h" · the weekday
//   delta     the next event: its title (Z 500, wraps — never cut), the mono
//             "14:30 – 15:00 · Tbilisi", and ONE capsule: Join when it has a
//             meeting room or a call link, else Open (its detail sheet)
//   visual    the events after it — a hue mark, the title, the mono start
//             (the weekday when it is not today); two at M, five at L
//   empty     "Nothing coming up" + New booking, once the calendar window
//             has answered (never while it is unread); a failed read says
//             so ("Couldn't load the calendar.") — never a false "nothing"
//             and never a skeleton that waits forever
//
// Data: the shell's own calendar window (`root.intranetEvents`,
// `root.intranetEventsLoaded`) AND the installed apps' own upcoming items —
// the CRM's viewings first (Nika, 2026-09-28) — through the `homeUpcoming`
// provider contract (functions/homeNextUp.js header). One merged list,
// soonest first: the hero and the event line are the next ITEM (an event or
// a viewing), the rows the ones after it; an app item's Open takes its route
// through openInSlot. The provider pass lives on this body's own state
// (`upcoming`), so "nothing" waits until the calendar AND the providers
// answered. The body keeps its own `now` and a minute clock
// (homeNextUpClock), so the countdown moves, a finished item leaves and the
// providers refresh without a reload.
const $364f4077c40f4d37$export$1840a3df3dc0f216 = {
    extends: 'HomeWidgetBody',
    state: {
        now: 0,
        upcoming: null
    },
    // The installed apps publish after the first paint on a cold load: the body
    // re-renders when they do, and the pass re-runs for a new provider.
    subscribeTo: [
        'workspaceApps',
        'workspaceProject'
    ],
    onRender: (el)=>{
        el.call('homeNextUpClock');
        el.call('homeNextUpCollect');
    },
    onUpdate: (el)=>el.call('homeNextUpCollect'),
    onRemove: (el)=>el.call('homeNextUpClockStop'),
    // "Nothing" only once the calendar (loaded or failed), the installed apps
    // (known) AND every provider of them answered — never while a viewing may
    // still be on its way.
    empty: (el, s)=>{
        s.root.intranetEvents;
        s.root.workspaceApps;
        s.root.workspaceProject;
        s.upcoming;
        if (!s.root.intranetEventsLoaded && !s.root.intranetEventsError) return false;
        if (!el.call('homeNextUpAppsKnown', s.root)) return false;
        const sig = el.call('homeNextUpProviderSig', s.root);
        if (sig && !(s.upcoming && s.upcoming.answered && s.upcoming.sig === sig)) return false;
        return !el.call('homeNextUpItems', s.root, s.now, s.upcoming).length;
    },
    HomeWidgetHero: {
        unitFirst: true,
        Value: {
            text: (el, s)=>{
                s.root.intranetEvents;
                s.upcoming;
                const [next] = el.call('homeNextUpItems', s.root, s.now, s.upcoming);
                const hero = next ? el.call('homeNextUpHero', next, s.now) : null;
                return hero ? hero.value : null;
            }
        },
        Unit: {
            text: (el, s)=>{
                s.root.intranetEvents;
                s.upcoming;
                const [next] = el.call('homeNextUpItems', s.root, s.now, s.upcoming);
                const hero = next ? el.call('homeNextUpHero', next, s.now) : null;
                return hero ? hero.before : '';
            },
            hide: (el)=>!el.call('homeSlotText', el) || el.call('homeSlotText', el.parent.Value) == null
        },
        Tail: {
            text: (el, s)=>{
                s.root.intranetEvents;
                s.upcoming;
                const [next] = el.call('homeNextUpItems', s.root, s.now, s.upcoming);
                const hero = next ? el.call('homeNextUpHero', next, s.now) : null;
                return hero ? hero.after : '';
            }
        }
    },
    NextUpEvent: {
        gridArea: 'delta',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 'X2',
        minWidth: '0',
        hide: (el, s)=>{
            s.root.intranetEvents;
            s.upcoming;
            return !el.call('homeNextUpItems', s.root, s.now, s.upcoming).length;
        },
        NextUpTitle: {
            tag: 'span',
            class: 'widget-row-title',
            fontSize: 'Z',
            fontWeight: '500',
            lineHeight: '1.35',
            color: 'title',
            maxWidth: '100%',
            overflowWrap: 'anywhere',
            text: (el, s)=>{
                s.root.intranetEvents;
                s.upcoming;
                const [next] = el.call('homeNextUpItems', s.root, s.now, s.upcoming);
                return next ? next.title || '' : '';
            }
        },
        NextUpTime: {
            tag: 'span',
            fontFamily: 'Code',
            fontSize: 'Y',
            fontVariantNumeric: 'tabular-nums',
            color: 'inactive',
            maxWidth: '100%',
            overflowWrap: 'anywhere',
            text: (el, s)=>{
                s.root.intranetEvents;
                s.upcoming;
                const [next] = el.call('homeNextUpItems', s.root, s.now, s.upcoming);
                return next ? el.call('homeNextUpTime', next) : '';
            }
        },
        NextUpGo: {
            tag: 'button',
            type: 'button',
            marginTop: 'X',
            theme: 'layer',
            color: 'title',
            minHeight: 'controlHCompact',
            padding: '0 A',
            round: 'radiusPill',
            fontSize: 'Z2',
            fontWeight: '500',
            border: 'none',
            cursor: 'pointer',
            ':hover': {
                background: 'selected'
            },
            ':active': {
                background: 'selected'
            },
            text: (el, s)=>{
                s.root.intranetEvents;
                s.upcoming;
                const [next] = el.call('homeNextUpItems', s.root, s.now, s.upcoming);
                const action = next ? el.call('homeNextUpAction', next) : null;
                return action ? el.call('polyglot', action.label) : '';
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                const [next] = el.call('homeNextUpItems', s.root, s.now, s.upcoming);
                const action = next ? el.call('homeNextUpAction', next) : null;
                if (action) el.call(action.call, el.call('homeNextUpActionArg', next));
            }
        }
    },
    HomeWidgetList: {
        asVisual: true,
        max: 5,
        items: (el, s)=>{
            s.root.intranetEvents;
            s.upcoming;
            const up = s.upcoming && Array.isArray(s.upcoming.items) ? s.upcoming.items : [];
            if (!s.root.intranetEventsLoaded && !(s.root.intranetEvents || []).length && !up.length) return null;
            return el.call('homeNextUpRows', s.root, s.now, s.upcoming);
        }
    },
    // Two rows fit beside the event at M; L gives the list the height for five.
    ':is([data-widget-size="m"]) & .home-widget-list > :nth-child(n+3)': {
        display: 'none'
    },
    HomeWidgetEmpty: {
        Text: {
            text: (el, s)=>el.call('polyglot', s.root.intranetEventsError ? 'workspace.widget.nextUp.error' : 'workspace.widget.nextUp.empty')
        },
        Action: {
            hide: (el, s)=>!!s.root.intranetEventsError,
            text: '{{ workspace.widget.nextUp.newBooking | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('openNewBookingModal', {
                    date: el.call('todayISO')
                });
            }
        }
    }
};

});

parcelRegister("cHGCQ", function(module, exports) {

$parcel$export(module.exports, "HomeAppStrip", () => $93fa90b71b05ca19$export$647d631dd4ada918);
$parcel$export(module.exports, "HomeAppStripAll", () => $93fa90b71b05ca19$export$7ee0f1aa5f651b48);
$parcel$export(module.exports, "HomeAppStripItem", () => $93fa90b71b05ca19$export$e1d517c9940b8548);
// THE APP STRIP — the Dock (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1; Nika's pick
// 2026-09-28 row 1 "A or C": both ship as a personal option, this file is A).
// ONE quiet glass capsule of calm glyph tiles between the greeting and the
// board: one line, the names on hover and focus (or under the glyphs when the
// person turns names on), scrolling sideways with an edge fade when the apps
// outgrow it, closing with "All apps" (the search launcher). App icons are
// never grid items (HOME_WIDGETS_SPEC §1, decision H1 A).
//
// THE PERSON'S LOOK (functions/homeLook.js, the Personalise panel): the strip
// hides when it is off; in the Rail style the Rail (components/HomeAppRail.js)
// stands beside the board and this row steps aside — except on a phone, where
// the Rail steps aside and this row stays (a static rule keyed on
// `data-strip-style`, never a width read in code).
//
// The page supplies the items (pages/main.js `_appStripRows`): the app
// shortcuts in the saved layout order, the user's hides kept, each a state row
// `{ id, title, icon, openRoute, … }` — the frame's descriptor shape, so an
// item opens through the SAME path a card does (`homeWidgetOpen`). With no
// app left to show the page hides the whole strip (`_appStripHidden`) — never
// a capsule holding "All apps" alone.
//
// CALM GLYPHS: a neutral `layer` tile with the app's glyph in the title ink —
// no per-app hue on the strip (the launcher keeps its colours). The capsule is
// the skin's `pill` (glass on the ambient ground, the header glass on solid);
// the component never reads the skin.
//
// NAMES NEVER CUT (quality law, HOME_AMBIENT_SKIN_SPEC §3): a shown name breaks
// only between words, never inside one; an item is as wide as its name on one
// line up to a cap, and never narrower than its longest word (min-content
// beats the cap). A hidden name is the button's accessible name and its
// tooltip — never a clipped label.
//
// Motion: the strip enters as ONE unit (fadeInUpShort, C) — never item by
// item; the brand reset lands it at once under reduced motion.
//
// Edit mode (`root._homeCustomizeMode`): an item opens nothing; its remove
// button hides it (the same hide pref as a card); the arrow keys move it in
// the order (homeWidgetKeyMove).
const $93fa90b71b05ca19$export$647d631dd4ada918 = {
    tag: 'nav',
    class: 'home-app-strip',
    'aria-label': (el)=>el.call('polyglot', 'workspace.home.appStrip'),
    // The row is the board's width (the board stylesheet's `.home-app-strip`);
    // it scrolls the capsule sideways and fades only an edge that hides apps
    // (the kit's one edge-fade row).
    extends: 'AppScrollRow',
    display: 'flex',
    alignItems: 'flex-start',
    flexShrink: '0',
    // Room for the focus ring above and below the items (the row scrolls, so
    // its box clips): the ring is never cut.
    padding: 'X',
    hide: (el, s)=>el.call('homeAppStripLookHidden', s.root, 'dock'),
    attr: {
        'data-strip-style': (el, s)=>(el.call('homeLookRead', s.root) || {}).stripStyle,
        'data-strip-labels': (el, s)=>(el.call('homeLookRead', s.root) || {}).stripLabels ? 'true' : null
    },
    // The Rail stands beside the board instead — above the phone step only.
    // ONE rule inside the media block (the shell's `aboveMobileL`, the exact
    // complement of the Rail's own `mobileL` step-aside): a base rule plus a
    // phone override would leave the winner to the atomic engine's sheet order,
    // and a media query nested INSIDE a selector block compiles to nothing.
    '@aboveMobileL': {
        '&[data-strip-style="rail"]': {
            display: 'none'
        }
    },
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'backwards',
    DockCapsule: {
        class: 'home-app-dock',
        theme: 'pill',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'Y',
        flexShrink: '0',
        width: 'fit-content',
        padding: 'Y',
        round: 'radiusPill',
        // Names under the glyphs make the capsule taller: a card radius then (yesterday's look, Nika 2026-10-02:
        // "yesterdays version of DockCapsule was better" — __tests__/dockYesterdayLook.test.js pins it). The one
        // later fix kept: with names ON the gap steps to Z1, because at Y two Georgian names touched (a defect, not a
        // look); the default (names off) is exactly yesterday's.
        ':is(.home-app-strip[data-strip-labels]) &': {
            round: 'radiusCard',
            padding: 'Y Z',
            gap: 'Z1'
        },
        Items: {
            tag: 'fragment',
            childExtends: 'HomeAppStripItem',
            childrenAs: 'state',
            children: []
        },
        // The last item: the whole catalogue (the header's search launcher).
        HomeAppStripAll: {}
    }
};
const $93fa90b71b05ca19$export$7ee0f1aa5f651b48 = {
    extends: 'HomeAppStripItem',
    // its own class beside the item's (a declared class REPLACES the inherited one): the Rail's index skips it
    class: 'home-app-strip-item home-app-strip-all',
    state: {
        all: true
    },
    Open: {
        'aria-label': (el)=>el.call('polyglot', 'workspace.home.allApps'),
        tooltipText: (el, s)=>(el.call('homeLookRead', s.root) || {}).stripLabels ? '' : el.call('polyglot', 'workspace.home.allApps'),
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('toggleSearchAppsDropdown', {
                anchorEl: el,
                restoreEl: el
            });
        },
        Glyph: {
            Icon: {
                name: 'grid'
            }
        },
        RailGlyph: {
            Icon: {
                name: 'lnGrid'
            }
        },
        Label: {
            text: '{{ workspace.home.allApps | polyglot }}'
        }
    },
    CloseButton: {
        hide: true
    }
};
const $93fa90b71b05ca19$export$e1d517c9940b8548 = {
    class: 'home-app-strip-item',
    attr: {
        'data-widget-id': (el, s)=>s && s.id || null
    },
    position: 'relative',
    flex: '0 0 auto',
    scrollSnapAlign: 'start',
    display: 'flex',
    width: 'fit-content',
    minWidth: 'min-content',
    maxWidth: 'thumbnailLg',
    // In the Rail (components/HomeAppRail.js) an item is a row: the glyph, and
    // the name beside it when names are on.
    // The Rail widens by its index column (the item cap F plus B), so a Georgian name never meets its number.
    ':is(.home-app-rail) &': {
        maxWidth: 'F+B',
        width: '100%'
    },
    // THE RAIL INDEX (dropdowns spec §12.1 N1): the first nine apps carry 01…09 — the 1-9 shortcut, read in the
    // same capsule order (closer 6449a5ab7). "All apps" is not numbered.
    ':is(.home-app-rail) &:not(.home-app-strip-all)': {
        counterIncrement: 'rail-app'
    },
    Open: {
        // The name on hover and focus while names are off (the shell's one
        // tooltip root, @symbo.ls/tooltip).
        // the one state logic of the glyph plate (shared/components/AppGlyphPlate.js GlyphPlateHolder)
        extends: [
            'TooltipTrigger',
            'GlyphPlateHolder'
        ],
        tag: 'button',
        type: 'button',
        class: 'home-app-strip-open',
        'aria-label': (el, s)=>s && s.id ? el.call('polyglot', 'workspace.menu.openApp').replace('{app}', el.call('polyglot', s.title || s.id)) : null,
        tooltipText: (el, s)=>s && s.id && !(el.call('homeLookRead', s.root) || {}).stripLabels ? el.call('polyglot', s.title || s.id) : '',
        // Inside the Rail (an ANCESTOR whose class is the rail's — a key lookup
        // would also find the page's Rail beside the Dock) the name shows to the
        // right; in the Dock, below.
        tooltipPlacement: (el)=>el.lookup((p)=>p.class === 'home-app-rail') ? 'right' : 'bottom',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ':is(.home-app-rail) &': {
            flexDirection: 'row',
            justifyContent: 'flex-start',
            gap: 'Z'
        },
        gap: 'X',
        width: '100%',
        minWidth: 'min-content',
        padding: '0',
        border: 'none',
        background: 'transparent',
        color: 'inherit',
        cursor: 'pointer',
        round: 'radiusControl',
        // THE DOCK (yesterday's look, Nika 2026-10-02): the tile's wash steps up under the pointer and on press; the
        // house focus ring (the reset) draws on the button. THE RAIL's plate (its own class) takes the one state logic
        // of the glyph plate from GlyphPlateHolder above. The app you are in says so to assistive tech in both.
        ':hover .home-app-strip-tile': {
            background: 'selected'
        },
        ':active .home-app-strip-tile': {
            background: 'selected',
            transform: 'scale(0.96)'
        },
        'aria-current': (el, s)=>s && s.openRoute && el.call('appRouteIsCurrent', s.openRoute, s.root) ? 'page' : null,
        // The Rail's index: a mono number at the row's end (aria-hidden by being generated content with an empty
        // alternative text — `/ ""`), only for the first nine apps.
        ':is(.home-app-rail) &::after': {
            content: 'counter(rail-app, decimal-leading-zero) / ""',
            fontFamily: 'Code',
            fontSize: 'Y',
            color: 'inactive',
            marginLeft: 'auto',
            paddingLeft: 'Z'
        },
        ':is(.home-app-rail) .home-app-strip-item:nth-child(n+10) &::after': {
            content: 'none'
        },
        ':is(.home-app-rail) .home-app-strip-all &::after': {
            content: 'none'
        },
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if (s && s.root && s.root._homeCustomizeMode) return;
            el.call('homeWidgetOpen', s, e);
        },
        // Warm the app's chunk while the pointer rests on the tile or focus
        // reaches it — the click then opens without the network round trip
        // (functions/slotPrefetch.js).
        onPointerenter: (e, el, s)=>el.call('prefetchSlotRoute', el.call('homeWidgetOpenRoute', s)),
        onFocus: (e, el, s)=>el.call('prefetchSlotRoute', el.call('homeWidgetOpenRoute', s)),
        // Edit mode: the arrow keys move an app in the order.
        onKeydown: (e, el, s)=>{
            if (s && s.id) el.call('homeWidgetKeyMove', e, s);
        },
        // THE DOCK's glyph — yesterday's calm tile (components/AppGlyphTile.js: the `layer` wash, `title` ink, the
        // app's own icon), the strip's hover / press hook class (the item's rules above step its wash). Nika
        // 2026-10-02: "yesterdays version of DockCapsule was better". Not in the Rail (the RailGlyph below).
        Glyph: {
            extends: 'AppGlyphTile',
            class: 'home-app-strip-tile',
            if: (el)=>!el.lookup((p)=>p.class === 'home-app-rail')
        },
        // THE RAIL's glyph (dropdowns spec §12.3 N1): the shared plate at the strip's 44 px, the app's LINE glyph at
        // 24 by the item's open route through the one resolver; inverted by GlyphPlateHolder; its own class, so the
        // Dock's hover hook never reaches it.
        RailGlyph: {
            extends: 'AppGlyphPlate',
            class: 'home-app-rail-tile',
            if: (el)=>!!el.lookup((p)=>p.class === 'home-app-rail'),
            boxSize: 'controlH',
            minWidth: 'controlH',
            Icon: {
                name: (el, s)=>el.call('glyphNameFor', {
                        route: s && s.openRoute,
                        icon: s && s.icon,
                        glyph: s && s.glyph
                    }, 'ln'),
                boxSize: 'iconLg'
            }
        },
        Label: {
            tag: 'span',
            class: 'home-app-strip-label',
            hide: (el, s)=>!(el.call('homeLookRead', s.root) || {}).stripLabels,
            maxWidth: '100%',
            fontSize: 'Z',
            fontWeight: '500',
            // the house leading: TBCContractica's Georgian descenders need 1.5
            lineHeight: '1.5',
            // ADAPTIVE `title` ink (measured 14.38:1 light, 8.44:1 dark on the board)
            color: 'title',
            textAlign: 'center',
            ':is(.home-app-rail) &': {
                textAlign: 'start'
            },
            overflowWrap: 'normal',
            wordBreak: 'normal',
            textWrap: 'balance',
            text: (el, s)=>el.call('polyglot', s && (s.title || s.id) || '')
        }
    },
    // Edit mode — an overlay, so entering edit mode moves nothing (Rule 66):
    // the same hide as a card's remove button.
    CloseButton: {
        class: 'home-app-strip-remove',
        // The edit flag is read FIRST, on every run, so the factory tracks it
        // whatever the row, and it is declared (FA515); "All apps" (no id) never
        // shows it.
        hideDeps: [
            (el, s)=>s.root._homeCustomizeMode
        ],
        hide: (el, s)=>{
            const editing = !!(s && s.root && s.root._homeCustomizeMode);
            return !editing || !(s && s.id);
        },
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '2',
        theme: 'layer',
        // Named for ITS app — "Hide “{title}”" (homeWidgetHideLabel), never one
        // shared "Hide this widget" for every shortcut.
        title: (el, s)=>el.call('homeWidgetHideLabel', s),
        'aria-label': (el, s)=>el.call('homeWidgetHideLabel', s),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            const ops = s && s.root && s.root._homeOps;
            if (ops && typeof ops.hideWidget === 'function') ops.hideWidget(s.id);
        }
    }
};

});

parcelRegister("7JDzv", function(module, exports) {

$parcel$export(module.exports, "HomeAppRail", () => $5a1b6e7be27df21b$export$35e4e7765cbff8b9);
// THE APP STRIP — the Rail (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1; Nika's pick
// 2026-09-28 row 1 "A or C": both ship as a personal option, this file is C).
// A slim vertical rail BESIDE the board: the same calm glyph tiles as the Dock
// (components/HomeAppStrip.js `HomeAppStripItem`), the names on hover and
// focus, or beside the glyphs when the person turns names on. It frees the top
// of the home for the greeting and the summary.
//
// PLACEMENT: a child of the home page itself (the page is the full-bleed
// flow-x AppPage), before the scrolling main column — so it takes its own box
// and the board narrows to the room that is left (the board's columns follow
// its own width, a container query), never an overlay over the cards
// (Rule 66). It does not scroll with the board. Its top matches the page
// head's (the main column's `D1` top inset under the floating header).
//
// ON A PHONE (the brand's `mobileL` step) the Rail steps aside and the Dock
// row stays in its place (the Dock's rule is keyed on the exact complement,
// the shell's `aboveMobileL`) — a vertical rail would take a fifth of a
// phone's width.
//
// The page supplies the items (pages/main.js `_appStripRows`, the same rows as
// the Dock) and, like the Dock, hides the Rail when no app is left to show
// (`_appStripHidden`). The capsule is the skin's `pill`; the component never
// reads the skin.
const $5a1b6e7be27df21b$export$35e4e7765cbff8b9 = {
    tag: 'nav',
    class: 'home-app-rail',
    'aria-label': (el)=>el.call('polyglot', 'workspace.home.appStrip'),
    hide: (el, s)=>el.call('homeAppStripLookHidden', s.root, 'rail'),
    '@mobileL': {
        display: 'none'
    },
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    flexShrink: '0',
    minHeight: '0',
    maxHeight: 'calc(100% - var(--spacing-D1) * 2)',
    // The page head's top (the main column's D1 inset), the board's gutter.
    margin: 'D1 0 0 C',
    // Room for the focus ring around the capsule's scroll box.
    padding: 'X',
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'backwards',
    RailCapsule: {
        class: 'home-app-rail-capsule',
        theme: 'pill',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 'Y',
        minHeight: '0',
        padding: 'Y',
        round: 'radiusCard',
        // the Rail index (HomeAppStripItem): numbers restart per capsule
        counterReset: 'rail-app',
        overflowY: 'auto',
        overflowX: 'hidden',
        overscrollBehavior: 'contain',
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': {
            display: 'none'
        },
        Items: {
            tag: 'fragment',
            childExtends: 'HomeAppStripItem',
            childrenAs: 'state',
            children: []
        },
        // The last item: the whole catalogue (the header's search launcher).
        HomeAppStripAll: {}
    }
};

});

parcelRegister("WlLEt", function(module, exports) {

$parcel$export(module.exports, "HomeSignalLink", () => $0af64d7b469c8149$export$e0d6b6bb3dc81ab4);
$parcel$export(module.exports, "HomeSignalChip", () => $0af64d7b469c8149$export$f047689ba7353623);
$parcel$export(module.exports, "HomeSignalTile", () => $0af64d7b469c8149$export$c59908165ccfe8eb);
$parcel$export(module.exports, "HomeSignalGlyph", () => $0af64d7b469c8149$export$9f68f362ba939d5f);
$parcel$export(module.exports, "HomeSignalNone", () => $0af64d7b469c8149$export$233a57cabfb3196c);
$parcel$export(module.exports, "HomeSignalSkeletonTile", () => $0af64d7b469c8149$export$8e79421c8b931766);
$parcel$export(module.exports, "HomeSignalsLine", () => $0af64d7b469c8149$export$1bcdfaab9ce8c713);
$parcel$export(module.exports, "HomeTopSummary", () => $0af64d7b469c8149$export$ac0c51112cc016ac);
$parcel$export(module.exports, "HomeSummaryBrief", () => $0af64d7b469c8149$export$567aeb87182ded98);
$parcel$export(module.exports, "HomeSummaryTiles", () => $0af64d7b469c8149$export$a85a62b37fb1ac1);
// THE TOP OF THE HOME — the greeting's sub-line and the summary
// (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1; HOME_SIGNALS_CONTRACT v1 §2.6; Nika's
// pick 2026-09-28 row 2 "A or B": the Brief and the Signals both ship as a
// personal option).
//
// Everything here renders from ONE model — `el.call('homeSummaryCompose',
// root)` (functions/homeSummaryCompose.js): today the signals with
// deterministic sentences, later the AI source with the same shape. No
// component computes a number: every count on screen is a signal's own.
//
//   HomeSignalsLine   the greeting's sub-line — the top two signals joined by
//                     " · ", each a link to its list; "Nothing needs you right
//                     now" only when every installed provider answered empty;
//                     a skeleton line while they answer (no flash of nothing).
//                     ONE VOICE: it steps aside whenever the summary shows the
//                     signals (homeSummaryShowsSignals) — never the same fact
//                     twice on screen.
//   HomeTopSummary    the summary under it, in the person's style
//                     (functions/homeLook.js `summaryStyle`):
//     HomeSummaryBrief   two calm sentences, each fact a link inline in the
//                        sentence (a heavier weight, no space of its own) that
//                        opens its list, then "Updated · Refresh · Open as board";
//     HomeSummaryTiles   up to four compact signal tiles — the kind's glyph on
//                        a round plate (a severity dot on it), the count, the
//                        words; the calm "nothing" tile; their skeleton.
//
// A signal opens its list through `homeSignalsOpen` → the shell's
// `openInSlot` (slot vs page is its decision); a modified click is the
// browser's (a new tab).
//
// Quality law (HOME_AMBIENT_SKIN_SPEC §3/§3b): no text here is cut, clamped or
// ellipsised — words wrap between words, a tile is never narrower than its
// longest word.
// A signal as a link: its words in the title ink, the urgent ones in the
// danger ink (a static rule keyed on `data-severity` — the state reaches the
// CSS as an attribute, never a create-only case block).
const $0af64d7b469c8149$export$e0d6b6bb3dc81ab4 = {
    extends: 'Link',
    class: 'home-signal-link',
    href: (el, s)=>s && s.href || null,
    text: (el, s)=>el.call('homeSignalsText', s),
    dataSeverity: (el, s)=>s && s.severity || null,
    color: 'title',
    fontWeight: '500',
    textDecoration: 'none',
    round: 'X',
    cursor: 'pointer',
    transition: 'background-color A defaultBezier',
    '&[data-severity="urgent"]': {
        color: 'dangerInk'
    },
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        background: 'selected'
    },
    onClick: (e, el, s)=>el.call('homeSignalsOpen', e, s)
};
const $0af64d7b469c8149$export$f047689ba7353623 = {
    extends: 'HomeSignalLink',
    class: 'home-signal-chip',
    display: 'inline',
    fontWeight: '700'
};
const $0af64d7b469c8149$export$c59908165ccfe8eb = {
    extends: 'Link',
    class: 'home-signal-tile',
    href: (el, s)=>s && s.href || null,
    aria: {
        label: (el, s)=>el.call('homeSignalsLabel', s)
    },
    dataSeverity: (el, s)=>s && s.severity || null,
    dataKind: (el, s)=>s && s.kind || null,
    theme: 'card',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    // An item of the Signals row (HomeSummaryTiles TilesRow, a wrapping flex
    // row): it starts at the F step, grows to share its line, and is never
    // narrower than its longest word — a tile that does not fit moves to the next
    // line instead of lying over its neighbour. F, not E: at E two tiles shared a
    // 390 px line and a label wrapped to three lines; at F a phone stacks the
    // tiles (1-2 lines each) and 1440 / 2560 keep one row.
    width: 'F',
    flexGrow: '1',
    minWidth: 'min-content',
    padding: 'Y Z Y Y',
    round: 'radiusCard',
    color: 'title',
    fontWeight: '400',
    textDecoration: 'none',
    cursor: 'pointer',
    // the wash lies under the words (its own stacking context, the layer at -1)
    isolation: 'isolate',
    '::after': {
        content: '""',
        position: 'absolute',
        inset: '0',
        zIndex: '-1',
        borderRadius: 'inherit',
        background: 'cardHover',
        opacity: '0',
        pointerEvents: 'none',
        transition: 'opacity A defaultBezier'
    },
    ':hover::after': {
        opacity: '1'
    },
    ':active::after': {
        opacity: '1',
        background: 'cardPress'
    },
    // The house focus ring (the `focusRing` shadow: a document gap, then the
    // highlight) — the Link base only takes the outline away.
    ':focus-visible': {
        shadow: 'focusRing'
    },
    onClick: (e, el, s)=>el.call('homeSignalsOpen', e, s),
    HomeSignalGlyph: {},
    Numeral: {
        tag: 'span',
        class: 'home-signal-numeral',
        flexShrink: '0',
        fontSize: 'C',
        fontWeight: '700',
        lineHeight: '1',
        fontVariantNumeric: 'tabular-nums',
        text: (el, s)=>String(s && s.count || '')
    },
    Words: {
        tag: 'span',
        class: 'home-signal-words',
        fontSize: 'Z',
        lineHeight: '1.35',
        color: 'caption',
        overflowWrap: 'normal',
        wordBreak: 'normal',
        text: (el, s)=>el.call('homeSignalsText', s, {
                bare: true
            })
    }
};
const $0af64d7b469c8149$export$9f68f362ba939d5f = {
    extends: 'AppGlyphTile',
    class: 'home-signal-glyph',
    position: 'relative',
    round: 'radiusPill',
    ':is(.home-signal-tile[data-severity="urgent"]) &': {
        background: 'red.15'
    },
    ':is(.home-signal-tile[data-severity="attention"]) &': {
        background: 'yellow.15'
    },
    Icon: {
        name: (el, s)=>el.call('homeSignalIcon', s),
        boxSize: 'iconMd'
    },
    Dot: {
        tag: 'span',
        class: 'home-signal-dot',
        ariaHidden: 'true',
        display: 'none',
        position: 'absolute',
        top: '0',
        right: '0',
        boxSize: 'Y',
        round: 'radiusPill',
        ':is(.home-signal-tile[data-severity="urgent"]) &': {
            display: 'block',
            background: 'dangerInk'
        },
        ':is(.home-signal-tile[data-severity="attention"]) &': {
            display: 'block',
            border: 'hairline2 solid warningInk'
        }
    }
};
const $0af64d7b469c8149$export$233a57cabfb3196c = {
    class: 'home-signal-none',
    role: 'status',
    theme: 'card',
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    width: 'F',
    flexGrow: '1',
    minWidth: 'min-content',
    padding: 'Y Z Y Y',
    round: 'radiusCard',
    color: 'title',
    AppGlyphTile: {
        round: 'radiusPill',
        Icon: {
            name: (el, s)=>(el.call('homeSummaryCompose', s.root) || {}).status === 'unavailable' ? 'sfInfoOval' : 'check',
            boxSize: 'iconMd'
        }
    },
    Words: {
        tag: 'span',
        fontSize: 'Z',
        lineHeight: '1.35',
        color: 'caption',
        overflowWrap: 'normal',
        wordBreak: 'normal',
        // The words only in their state: the hidden tile never carries "Nothing
        // needs you right now." for a page-text reader. With zero items while an
        // installed app will not come, the loader's own words.
        text: (el, s)=>{
            const status = (el.call('homeSummaryCompose', s.root) || {}).status;
            if (status === 'nothing') return el.call('polyglot', 'workspace.home.summary.none');
            if (status === 'unavailable') return el.call('polyglot', 'workspace.activation.partialTitle');
            return '';
        }
    }
};
const $0af64d7b469c8149$export$8e79421c8b931766 = {
    theme: 'card',
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    width: 'F',
    flexGrow: '1',
    minWidth: 'min-content',
    padding: 'Y Z Y Y',
    round: 'radiusCard',
    SkeletonCircle: {
        boxSize: 'controlH',
        flexShrink: '0'
    },
    SkeletonRow: {
        width: 'D',
        maxWidth: '100%'
    }
};
const $0af64d7b469c8149$export$1bcdfaab9ce8c713 = {
    class: 'home-signals-line',
    hide: (el, s)=>el.call('homeSummaryShowsSignals', s.root),
    // This line sits above the summary — the top sky's clear edge
    // (functions/ambientBackdrop.js). Showing it, hiding it or swapping its
    // skeleton for words moves the summary, so the edge re-measures here, after
    // the change is on the page (measured on dev, Vault 2560: the edge stayed at
    // the waiting-time 149 px while the summary settled at 181 px). Not a
    // ResizeObserver: it never fires in a hidden tab.
    stateDeps: [
        (el, s)=>!!el.call('homeSummaryShowsSignals', s.root),
        (el, s)=>(el.call('homeSummaryCompose', s.root) || {}).status || null
    ],
    onStateUpdate: (el)=>el.call('ambientSkySync', el),
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    SignalsText: {
        tag: 'p',
        margin: '0',
        fontSize: 'A',
        lineHeight: '1.5',
        color: 'inactive',
        overflowWrap: 'normal',
        hide: (el, s)=>(el.call('homeSummaryCompose', s.root) || {}).status === 'waiting',
        children: (el, s)=>{
            const model = el.call('homeSummaryCompose', s.root) || {};
            if (model.status === 'nothing') return [
                {
                    key: 'none',
                    tag: 'span',
                    text: el.call('polyglot', 'workspace.home.summary.none')
                }
            ];
            // Zero items, but an installed app will not come: never "nothing" —
            // the loader's own words for it.
            if (model.status === 'unavailable') return [
                {
                    key: 'unavailable',
                    tag: 'span',
                    text: el.call('polyglot', 'workspace.activation.partialTitle')
                }
            ];
            const out = [];
            const line = model.line || [];
            line.forEach((sig, i)=>{
                if (i) out.push({
                    key: 'dot' + i,
                    tag: 'span',
                    text: " \xb7 ",
                    ariaHidden: 'true'
                });
                out.push({
                    key: sig.id,
                    extends: 'HomeSignalLink',
                    state: {
                        ...sig
                    }
                });
            });
            return out;
        }
    },
    SkeletonRow: {
        width: 'H',
        maxWidth: '60%',
        height: 'A',
        margin: 'Y 0',
        hide: (el, s)=>(el.call('homeSummaryCompose', s.root) || {}).status !== 'waiting'
    }
};
const $0af64d7b469c8149$export$ac0c51112cc016ac = {
    tag: 'section',
    class: 'home-top-summary',
    'aria-label': (el)=>el.call('polyglot', 'workspace.home.brief.label'),
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    // The ambient sky's clear edge is this section's top (app.js mounts the
    // sky with `fadeAnchor: ['HomeTopSummary', …]`): re-measure it once this has a
    // box (functions/ambientBackdrop.js ambientSkySync).
    onRender: (el)=>el.call('ambientSkySync', el),
    HomeSummaryBrief: {
        hide: (el, s)=>(el.call('homeLookRead', s.root) || {}).summaryStyle !== 'brief'
    },
    HomeSummaryTiles: {
        hide: (el, s)=>(el.call('homeLookRead', s.root) || {}).summaryStyle !== 'signals'
    }
};
const $0af64d7b469c8149$export$567aeb87182ded98 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'Y',
    minWidth: '0',
    // The AI source (functions/homeSummaryAi.js): asked once the signals settle,
    // again when they, the language or the style change.
    subscribeTo: [
        '_homeSignals',
        'lang',
        '_homeLook'
    ],
    onRender: (el, s)=>el.call('homeSummaryAiEnsure', s.root),
    onUpdate: (el, s)=>el.call('homeSummaryAiEnsure', s.root),
    BriefText: {
        tag: 'p',
        margin: '0',
        maxWidth: 'I',
        fontSize: 'A',
        lineHeight: '1.75',
        color: 'caption',
        overflowWrap: 'normal',
        hide: (el, s)=>{
            const m = el.call('homeSummaryCompose', s.root) || {};
            return (m.briefStatus || m.status) !== 'ready';
        },
        children: (el, s)=>{
            const out = [];
            const brief = (el.call('homeSummaryCompose', s.root) || {}).brief || [];
            brief.forEach((runs, i)=>{
                if (i) out.push({
                    key: 'gap' + i,
                    tag: 'span',
                    text: ' '
                });
                for (const run of runs){
                    if (run.chip) out.push({
                        key: run.key,
                        extends: 'HomeSignalChip',
                        state: {
                            ...run.chip
                        }
                    });
                    else if (run.time) out.push({
                        key: run.key,
                        tag: 'span',
                        color: 'title',
                        text: run.time
                    });
                    else out.push({
                        key: run.key,
                        tag: 'span',
                        text: run.text
                    });
                }
            });
            return out;
        }
    },
    // The AI sentence's signals — their OWN row under the sentence (design-d2,
    // 2026-10-01: the deploy-11 sweep read them running on after the answer's
    // last full stop; the sentence stays alone as the paragraph). One chip per
    // signal, gap Z, wrapping chip by chip: a chip keeps its longest word whole
    // (a flex item's min-content) and breaks only between words. The template's
    // facts are words of its own sentences, so this row is the AI answer's only.
    BriefChips: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline',
        gap: 'Z',
        maxWidth: 'I',
        hide: (el, s)=>{
            const m = el.call('homeSummaryCompose', s.root) || {};
            return (m.briefStatus || m.status) !== 'ready' || !(m.briefChips || []).length;
        },
        children: (el, s)=>((el.call('homeSummaryCompose', s.root) || {}).briefChips || []).map((sig)=>({
                    key: 'chip-' + sig.id,
                    extends: 'HomeSignalChip',
                    state: {
                        ...sig
                    }
                }))
    },
    BriefSkeleton: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Y',
        padding: 'Y 0',
        hide: (el, s)=>{
            const m = el.call('homeSummaryCompose', s.root) || {};
            return (m.briefStatus || m.status) !== 'waiting';
        },
        SkeletonRow_1: {
            width: 'I',
            maxWidth: '100%',
            height: 'A'
        },
        SkeletonRow_2: {
            width: 'H',
            maxWidth: '80%',
            height: 'A'
        }
    },
    BriefMeta: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 'Y Z',
        hide: (el, s)=>(el.call('homeSummaryCompose', s.root) || {}).status === 'waiting',
        // "Updated 06:12" — the time the last answer landed.
        // Only a real time of THIS summary: with none, the label is hidden AND
        // empty — a hidden node never carries a formatted zero ("Updated 04:00
        // AM") for a page-text reader.
        AppMicroLabel: {
            // `caption` on the home stage (the DateLabel's reason, pages/main.js).
            color: 'caption',
            hide: (el, s)=>!(el.call('homeSummaryCompose', s.root) || {}).updatedAt,
            text: (el, s)=>{
                const at = (el.call('homeSummaryCompose', s.root) || {}).updatedAt;
                if (!at) return '';
                return el.call('polyglot', 'workspace.home.brief.updated').replace('{time}', el.call('localizedDate', at, {
                    hour: '2-digit',
                    minute: '2-digit'
                }));
            }
        },
        // The row WRAPS on a phone: at 390 px "Open as board" opens line 2. A
        // ghost button's label sits one inset (Z2) inside its box, so that line
        // began ~12 px right of the UPDATED label's edge. The board button hangs
        // its inset into the gutter (InlineSelect's optical pull: a host fact, so
        // a margin at the call site) and Refresh gives the same inset back after
        // itself. Both are the compact size (font Z), so the pull and the
        // give-back are one length: the one-line row (1440 / 2560) keeps every
        // distance and every wrap point. The label and Refresh always share line
        // 1 (even at 320 px), so only the board button opens a line.
        AppCapsuleBtnGhost: {
            compact: true,
            marginInlineEnd: 'Z2',
            text: '{{ common.action.refresh | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('homeSignalsInvalidate');
            }
        },
        AppCapsuleBtnGhost_board: {
            compact: true,
            marginInlineStart: '-Z2',
            hide: (el, s)=>!el.call('assistantBoardPageOnHome', s.root),
            text: '{{ workspace.home.brief.openAsBoard | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('homeSummaryOpenAsBoard');
            }
        }
    }
};
const $0af64d7b469c8149$export$a85a62b37fb1ac1 = {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    TilesRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'Z',
        hide: (el, s)=>(el.call('homeSummaryCompose', s.root) || {}).status !== 'ready',
        childExtends: 'HomeSignalTile',
        childrenAs: 'state',
        children: (el, s)=>((el.call('homeSummaryCompose', s.root) || {}).tiles || []).map((sig)=>({
                    ...sig,
                    key: sig.id
                }))
    },
    // Nothing needs the person: the row's own calm tile.
    NoneRow: {
        display: 'flex',
        hide: (el, s)=>{
            const status = (el.call('homeSummaryCompose', s.root) || {}).status;
            return status !== 'nothing' && status !== 'unavailable';
        },
        HomeSignalNone: {}
    },
    // The providers are answering: three tiles' geometry, wrapping as the row
    // does.
    TilesSkeleton: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'Z',
        hide: (el, s)=>(el.call('homeSummaryCompose', s.root) || {}).status !== 'waiting',
        HomeSignalSkeletonTile_1: {},
        HomeSignalSkeletonTile_2: {},
        HomeSignalSkeletonTile_3: {}
    }
};

});

parcelRegister("bndqJ", function(module, exports) {

$parcel$export(module.exports, "HomePersonalizeGroup", () => $847c42a4f9a28d28$export$f8a1f0f8922bddf9);
$parcel$export(module.exports, "HomePersonalizeSwitch", () => $847c42a4f9a28d28$export$734c98414c5dcb62);
$parcel$export(module.exports, "HomePersonalizeChoice", () => $847c42a4f9a28d28$export$5686abc74257152c);
$parcel$export(module.exports, "HomePersonalizeApp", () => $847c42a4f9a28d28$export$362b6c14b13f8d62);
$parcel$export(module.exports, "HomeSkyTile", () => $847c42a4f9a28d28$export$28c7e24281d0b0bd);
$parcel$export(module.exports, "HomePersonalize", () => $847c42a4f9a28d28$export$b6d32d89b30dec5e);
// PERSONALISE — the grouped rows of the home's one customize panel
// (DESIGN-WL-HOME-TOP-STRIP-SUMMARY-1; Nika's pick 2026-09-28 row 4 "A, one
// panel, grouped"). They mount INSIDE the existing Customize drawer
// (pages/main.js `CustomizeDrawer`) above its widget list — one panel, never a
// second one:
//
//   App strip   on / off · the style (Dock | Rail) · names on / off · the apps
//               in their order (drag, or the arrow buttons)
//   Theme       Auto | Light | Dark — the existing `themeMode` preference, the
//               same explicit-theme path the account menu takes
//   Background  every sky of the ambient files index (Clouds · Dunes · Hills
//               · Lake · Window …) and None — the person's own sky over the
//               workspace's (None = no sky on the ambient ground), and a way
//               back to the workspace's
//   Sky layout  its own group, captioned like the others: Sky and mountains
//               (the sky at the top, the mountain ground at the end of the
//               scroll — the default) |
//               Clouds below (the bottom band, as before). The shorter pair:
//               "Clouds and mountains | Clouds at the bottom" overflowed the
//               355 px drawer (344 px of segments in 323 px)
//   Summary     Brief | Signals
//   Getting started   the new-account welcome on demand: the setup wizard,
//               the assistant's setup conversation and the quick tour
//               (functions/onboarding.js onboardingReplay — a replay writes
//               no decision)
//   (Widgets)   the drawer's own show / hide list stays under these groups
//
// Every change is a decision written at once (functions/homeLook.js) and the
// board behind the panel re-renders with it — the live preview is the board.
// The controls are the kit's: SwitchInput, AppSegmented, CompactIconButton.
// A group: its caption, then its rows.
const $847c42a4f9a28d28$export$f8a1f0f8922bddf9 = {
    tag: 'section',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    minWidth: '0',
    CaptionTitle: {
        fontSize: 'Y2',
        margin: '0',
        align: 'center flex-start',
        Text: {
            text: ''
        }
    }
};
const $847c42a4f9a28d28$export$734c98414c5dcb62 = {
    tag: 'label',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'Z',
    minWidth: '0',
    cursor: 'pointer',
    RowLabel: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        fontSize: 'Z2',
        lineHeight: '1.4',
        color: 'title',
        overflowWrap: 'normal',
        text: ''
    },
    SwitchInput: {}
};
const $847c42a4f9a28d28$export$5686abc74257152c = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'Y',
    minWidth: '0',
    RowLabel: {
        tag: 'span',
        fontSize: 'Z2',
        lineHeight: '1.4',
        color: 'title',
        overflowWrap: 'normal',
        text: ''
    },
    AppSegmented: {}
};
const $847c42a4f9a28d28$export$362b6c14b13f8d62 = {
    class: 'home-personalize-app',
    draggable: 'true',
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    minWidth: '0',
    padding: 'X Y',
    round: 'radiusControl',
    cursor: 'grab',
    transition: 'background-color A defaultBezier',
    ':hover': {
        background: 'hover'
    },
    '&[data-drop-target]': {
        background: 'selected'
    },
    attr: {
        'data-drop-target': (el, s)=>s && s.dropTarget ? '' : null
    },
    onDragstart: (e, el, s)=>{
        if (!e.dataTransfer || !s || !s.id) return;
        e.dataTransfer.setData('text/plain', s.id);
        e.dataTransfer.effectAllowed = 'move';
    },
    onDragover: (e, el, s)=>{
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
        if (s && !s.dropTarget && typeof s.update === 'function') s.update({
            dropTarget: true
        });
    },
    onDragleave: (e, el, s)=>{
        if (s && s.dropTarget && typeof s.update === 'function') s.update({
            dropTarget: false
        });
    },
    onDrop: (e, el, s)=>{
        e.preventDefault();
        if (s && typeof s.update === 'function') s.update({
            dropTarget: false
        });
        const from = e.dataTransfer ? e.dataTransfer.getData('text/plain') : '';
        if (from && s && s.id) el.call('homeLookMoveApp', from, s.id);
    },
    AppGlyph: {
        theme: 'layer',
        color: 'title',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        boxSize: 'avatarXs',
        round: 'radiusControl',
        Icon: {
            name: (el, s)=>s && s.icon || 'star',
            boxSize: 'iconSm'
        }
    },
    AppName: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        fontSize: 'Z2',
        lineHeight: '1.4',
        color: 'title',
        overflowWrap: 'normal',
        text: (el, s)=>el.call('polyglot', s && (s.title || s.id) || '')
    },
    CompactIconButton: {
        icon: 'chevronUp',
        disabled: (el, s)=>!(s && s.prevId) || null,
        'aria-label': (el, s)=>el.call('polyglot', 'workspace.personalize.moveUp').replace('{app}', el.call('polyglot', s && (s.title || s.id) || '')),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if (s && s.prevId) el.call('homeLookMoveApp', s.id, s.prevId);
        }
    },
    CompactIconButton_down: {
        icon: 'chevronDown',
        disabled: (el, s)=>!(s && s.nextId) || null,
        'aria-label': (el, s)=>el.call('polyglot', 'workspace.personalize.moveDown').replace('{app}', el.call('polyglot', s && (s.title || s.id) || '')),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if (s && s.nextId) el.call('homeLookMoveApp', s.id, s.nextId);
        }
    }
};
const $847c42a4f9a28d28$export$28c7e24281d0b0bd = {
    tag: 'button',
    type: 'button',
    class: 'home-sky-tile',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 'X',
    minWidth: '0',
    padding: 'X',
    border: 'none',
    round: 'radiusControl',
    background: 'transparent',
    color: 'caption',
    cursor: 'pointer',
    transition: 'background-color A defaultBezier, color A defaultBezier',
    ariaPressed: (el, s)=>el.call('homeSkyActive', s) === (s && s.value) ? 'true' : 'false',
    '&[aria-pressed="true"]': {
        background: 'selected',
        color: 'title'
    },
    '&:not([aria-pressed="true"]):hover': {
        background: 'hover',
        color: 'title'
    },
    ':active': {
        background: 'selected'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s && s.value) el.call('homeLookSet', {
            sky: s.value
        });
    },
    SkyPreview: {
        position: 'relative',
        display: 'block',
        width: '100%',
        height: 'C',
        theme: 'layer',
        round: 'radiusControl',
        SkyArt: {
            position: 'absolute',
            inset: '0',
            background: 'caption',
            hide: (el, s)=>!s || s.value === 'none',
            maskImage: (el, s)=>el.call('ambientMaskImage', s && s.value !== 'none' ? el.call('ambientSkyUrl', s.value) : null, null, 'none'),
            maskSize: 'cover',
            maskPosition: 'center bottom',
            maskRepeat: 'no-repeat'
        }
    },
    SkyName: {
        tag: 'span',
        fontSize: 'Z',
        lineHeight: '1.4',
        textAlign: 'start',
        overflowWrap: 'normal',
        text: (el, s)=>el.call('polyglot', s && s.label || '')
    }
};
const $847c42a4f9a28d28$export$b6d32d89b30dec5e = {
    class: 'home-personalize',
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    minWidth: '0',
    // ── App strip ──────────────────────────────────────────────────────────
    HomePersonalizeGroup_strip: {
        CaptionTitle: {
            Text: {
                text: '{{ workspace.personalize.appStrip | polyglot }}'
            }
        },
        HomePersonalizeSwitch_strip: {
            RowLabel: {
                text: '{{ workspace.personalize.showStrip | polyglot }}'
            },
            SwitchInput: {
                onCheck: (el, s)=>(el.call('homeLookRead', s.root) || {}).stripShown,
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    el.call('homeLookSet', {
                        stripShown: !(el.call('homeLookRead', s.root) || {}).stripShown
                    });
                }
            }
        },
        HomePersonalizeChoice_style: {
            RowLabel: {
                text: '{{ workspace.personalize.style | polyglot }}'
            },
            AppSegmented: {
                compact: true,
                ariaLabel: (el)=>el.call('polyglot', 'workspace.personalize.style'),
                current: (el, s)=>(el.call('homeLookRead', s.root) || {}).stripStyle,
                select: 'homeLookSetStripStyle',
                childrenAs: 'state',
                children: ()=>[
                        {
                            key: 'dock',
                            text: 'workspace.personalize.styleDock',
                            value: 'dock'
                        },
                        {
                            key: 'rail',
                            text: 'workspace.personalize.styleRail',
                            value: 'rail'
                        }
                    ]
            }
        },
        HomePersonalizeSwitch_labels: {
            RowLabel: {
                text: '{{ workspace.personalize.showLabels | polyglot }}'
            },
            SwitchInput: {
                onCheck: (el, s)=>(el.call('homeLookRead', s.root) || {}).stripLabels,
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    el.call('homeLookSet', {
                        stripLabels: !(el.call('homeLookRead', s.root) || {}).stripLabels
                    });
                }
            }
        },
        // Nika 2026-10-02: "on navbar make icons optional from personalize default to off" — the navbar tabs'
        // glyph plates (and the phone strip's), off by default (functions/homeLook.js `navbarIcons`).
        HomePersonalizeSwitch_navbarIcons: {
            RowLabel: {
                text: '{{ workspace.personalize.navbarIcons | polyglot }}'
            },
            SwitchInput: {
                onCheck: (el, s)=>!!(el.call('homeLookRead', s.root) || {}).navbarIcons,
                onClick: (e, el, s)=>{
                    e.preventDefault();
                    el.call('homeLookSet', {
                        navbarIcons: !(el.call('homeLookRead', s.root) || {}).navbarIcons
                    });
                }
            }
        },
        AppsHint: {
            tag: 'p',
            margin: '0',
            fontSize: 'Y2',
            lineHeight: '1.5',
            color: 'caption',
            overflowWrap: 'normal',
            text: '{{ workspace.personalize.appsHint | polyglot }}'
        },
        // The page supplies the rows (pages/main.js: the App strip's own rows,
        // each with its neighbours' ids).
        AppsList: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'W',
            minWidth: '0',
            childExtends: 'HomePersonalizeApp',
            childrenAs: 'state',
            children: []
        }
    },
    // ── Theme ──────────────────────────────────────────────────────────────
    HomePersonalizeGroup_theme: {
        CaptionTitle: {
            Text: {
                text: '{{ workspace.personalize.theme | polyglot }}'
            }
        },
        AppSegmented: {
            compact: true,
            ariaLabel: (el)=>el.call('polyglot', 'workspace.personalize.theme'),
            current: (el, s)=>s.root.themeMode || 'auto',
            select: 'homeLookSetTheme',
            childrenAs: 'state',
            children: ()=>[
                    {
                        key: 'auto',
                        text: 'workspace.personalize.themeAuto',
                        value: 'auto'
                    },
                    {
                        key: 'light',
                        text: 'workspace.personalize.themeLight',
                        value: 'light'
                    },
                    {
                        key: 'dark',
                        text: 'workspace.personalize.themeDark',
                        value: 'dark'
                    }
                ]
        }
    },
    // ── Background ─────────────────────────────────────────────────────────
    HomePersonalizeGroup_background: {
        CaptionTitle: {
            Text: {
                text: '{{ workspace.personalize.background | polyglot }}'
            }
        },
        SkyGrid: {
            role: 'group',
            'aria-label': (el)=>el.call('polyglot', 'workspace.personalize.background'),
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            gap: 'Y',
            childExtends: 'HomeSkyTile',
            childrenAs: 'state',
            // Every sky the ambient files index holds, then None
            // (functions/homeLook.js homeSkyChoices).
            children: (el)=>el.call('homeSkyChoices') || []
        },
        // The way back to the workspace's own sky — only while the person has one.
        AppCapsuleBtnGhost: {
            compact: true,
            alignSelf: 'flex-start',
            hide: (el, s)=>(el.call('homeLookRead', s.root) || {}).sky == null,
            text: '{{ workspace.personalize.skyFollow | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('homeLookSet', {
                    sky: null
                });
            }
        }
    },
    // ── Sky layout ─────────────────────────────────────────────────────────
    // Where the sky sits (DESIGN-WL-HOME-SKY-TOP-GROUND-1, Nika 2026-10-01:
    // "keep bottom moving clouds as one of the options … clouds and moutain
    // should be the default"). `homeLook.skyLayout` — the same decision path
    // as every row here (functions/homeLook.js homeLookSetSkyLayout).
    // A GROUP of its own, captioned like Summary style and Widgets (live look on
    // dev e38425a28, 2026-10-02: as a row its title-case label sat between
    // those uppercase captions).
    HomePersonalizeGroup_skyLayout: {
        CaptionTitle: {
            Text: {
                text: '{{ workspace.personalize.skyLayout | polyglot }}'
            }
        },
        AppSegmented: {
            compact: true,
            ariaLabel: (el)=>el.call('polyglot', 'workspace.personalize.skyLayout'),
            current: (el, s)=>(el.call('homeLookRead', s.root) || {}).skyLayout || 'top',
            select: 'homeLookSetSkyLayout',
            childrenAs: 'state',
            children: ()=>[
                    {
                        key: 'top',
                        text: 'workspace.personalize.skyLayoutTop',
                        value: 'top'
                    },
                    {
                        key: 'bottom',
                        text: 'workspace.personalize.skyLayoutBottom',
                        value: 'bottom'
                    }
                ]
        }
    },
    // ── Summary ────────────────────────────────────────────────────────────
    HomePersonalizeGroup_summary: {
        CaptionTitle: {
            Text: {
                text: '{{ workspace.personalize.summary | polyglot }}'
            }
        },
        AppSegmented: {
            compact: true,
            ariaLabel: (el)=>el.call('polyglot', 'workspace.personalize.summary'),
            current: (el, s)=>(el.call('homeLookRead', s.root) || {}).summaryStyle,
            select: 'homeLookSetSummaryStyle',
            childrenAs: 'state',
            children: ()=>[
                    {
                        key: 'brief',
                        text: 'workspace.personalize.summaryBrief',
                        value: 'brief'
                    },
                    {
                        key: 'signals',
                        text: 'workspace.personalize.summarySignals',
                        value: 'signals'
                    }
                ]
        }
    },
    // ── Getting started ────────────────────────────────────────────────────
    // The new-account welcome on demand (Nika 2026-10-18: the assistant, the
    // tour, and a skip that is never a dead end): the setup conversation and
    // the quick tour, each one press away. Edit mode closes first — the drawer
    // would cover what the tour points at.
    HomePersonalizeGroup_start: {
        CaptionTitle: {
            Text: {
                text: '{{ workspace.onboarding.replayCaption | polyglot }}'
            }
        },
        StartActions: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 'Y',
            minWidth: '0',
            AppCapsuleBtnToolbar_wizard: {
                compact: true,
                Icon: {
                    extends: 'Icon',
                    name: 'displayPreferences',
                    boxSize: 'iconSm'
                },
                Label: {
                    tag: 'span',
                    text: '{{ workspace.onboarding.replayWizard | polyglot }}'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('onboardingReplay', 'wizard');
                }
            },
            AppCapsuleBtnToolbar_assistant: {
                compact: true,
                Icon: {
                    extends: 'Icon',
                    name: 'magicstar',
                    boxSize: 'iconSm'
                },
                Label: {
                    tag: 'span',
                    text: '{{ workspace.onboarding.replayAssistant | polyglot }}'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('onboardingReplay', 'assistant');
                }
            },
            AppCapsuleBtnToolbar_tour: {
                compact: true,
                Icon: {
                    extends: 'Icon',
                    name: 'playOval',
                    boxSize: 'iconSm'
                },
                Label: {
                    tag: 'span',
                    text: '{{ workspace.onboarding.replayTour | polyglot }}'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('onboardingReplay', 'tour');
                }
            }
        }
    }
};

});

parcelRegister("jIzVU", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetPlate", () => $e5adffedf17450dc$export$c5c545c432028816);
// The ICON PLATE of a home widget header (HOME_WIDGETS_SPEC.md §2): a 32 px
// squircle (`iconXl`, `radiusControl`) filled with the widget hue, the glyph
// `iconSm` in the hue's measured ink. Opaque by design — it is the one place
// the hue meets the header. The frame publishes `--home-widget-hue` /
// `--home-widget-hue-ink` on the card (pages/main.js), so the plate reads the
// same colour in the shell and inside a module body.
//
// THIS PAIR IS THE PLATE CONTRACT AND ONLY THE PLATE'S (the squircle here, the
// avatar faces in HomeWidgetAvatars): a background with the ink that reads ON
// it. A visual drawn on the CARD surface — a bar, a fill, a spark, a dot, a
// stat — reads `--home-widget-accent` instead, which the frame derives against
// the card's own surface per theme. Reading the plate there is what made a dark
// plate family invisible (HOME-WIDGET-ACCENT-DARK-PLATE-INVISIBLE-1).
//
//   HomeWidgetPlate: { Icon: { name: 'people' } }
const $e5adffedf17450dc$export$c5c545c432028816 = {
    class: 'widget-header-icon',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSize: 'iconXl',
    minWidth: 'iconXl',
    flexShrink: '0',
    round: 'radiusControl',
    background: '--home-widget-hue',
    color: '--home-widget-hue-ink',
    Icon: {
        boxSize: 'iconSm'
    }
};

});

parcelRegister("9idOF", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetAction", () => $6c40831f579c87d6$export$b9d2ac9775ec8f8b);
// The ONE square button of a home widget header (HOME_WIDGETS_SPEC.md §2 +
// §6): 32 × 32 (1:1 — Nika: "all icon buttons should have 1/1 aspect ratio"),
// `layer` fill, hover `selected`, glyph `iconSm`, an aria-label that is its
// verb. It is the widget's primary verb (＋ Add / New) or ↗ Open — decision
// H3 A. The card around it is itself the open link; the card's click handler
// skips buttons, so this control never also opens the widget.
//
//   HomeWidgetAction: { Icon: { name: 'plus' }, 'aria-label': …, onClick: … }
//
// The house IconButton (SquareButton) keeps it square; the global focus ring
// is the reset's.
const $6c40831f579c87d6$export$b9d2ac9775ec8f8b = {
    extends: 'IconButton',
    class: 'gs-no-drag widget-header-action',
    boxSize: 'iconXl',
    minWidth: 'iconXl',
    minHeight: 'iconXl',
    padding: '0',
    flexShrink: '0',
    round: 'radiusControl',
    theme: 'layer',
    color: 'title',
    border: 'none',
    cursor: 'pointer',
    align: 'center center',
    ':hover': {
        background: 'selected'
    },
    ':active': {
        background: 'selected'
    },
    Icon: {
        boxSize: 'iconSm'
    }
};

});

parcelRegister("gWEhr", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetFormHost", () => $c5614ef8c07311d3$export$e236b8aeb576f4ef);
// THE HOME WIDGET FORM HOST — a widget's "+" opens ONLY its create form, as a
// modal sheet over the board, never the whole app page (Nika's pick 10 C,
// 2026-09-28: "when widget invokes modal (for example +) it … can just open +
// modal"; the picks page: "'+' on Recent contacts opens the create form only.
// No full app page; the new contact appears in the widget at once").
//
// THE CONTRACT (a module's manifest, the widget's one square button):
//
//   action: { icon: 'plus', label: '<key>', call: '<fn>', form: '<Component>' }
//
// `form` names a component the MODULE registers — an AppDialog sheet whose
// `stateKey` opens it (the CRM's CrmContactCreateModal / CrmDealCreateModal).
// The frame's button (functions/homeWidgetFrame.js homeWidgetRunAction) asks
// this host to mount that form first, then runs the module's `call` with
// `{ form: true }` so the module only SEEDS its draft (the dialog opens on
// it) instead of routing to its page. The host mounts the form with the
// module's OWN context — its components, functions, design system and state
// scope (root._moduleDsCtxGet, the context a module widget body mounts with)
// — so the form reads and writes exactly the draft its module seeded.
//
// AN AI ANSWER'S FORM CARD (functions/assistantAppForms.js) asks the same
// way, and hands the app's `open` with the request: the host runs it ON the
// mounted form, so the seed lands in the scope the form reads.
//
// ITS OWN STATE. `state: {}` gives the host a state of its own, which
// mountHomeWidgetForm points at the scope of each form BEFORE mounting it
// (moduleStateScope.js scopeHostState): the module's state root, or the shell
// root for a shell form. A form's `if:` runs before the module scope's plugin
// does, so without this its first read — and an open made while it is parked
// — reached the SHELL root, and the app's own close then shadowed every later
// seed (WS-ASSISTANT-APP-FORM-OPEN-SHELL-SCOPE-1). The host itself reads only
// `_homeWidgetForm`, a shell-owned key every module store shares.
//
// GEOMETRY. AppDialog fills its frame (`absolute`, inset 0) and floats its
// panel inside it; this host IS that frame: fixed over the whole viewport, at
// the house modal layer (DESIGN_SPEC §6.8 — Modal.js 2000: over the header,
// the composer and a PageSlot window), and click-through: AppDialog takes the
// pointer itself while it is open (its `&[data-open]` rule) and none at rest.
// A closed dialog stays mounted and inert until another form replaces it —
// nothing to tear down.
const $c5614ef8c07311d3$export$e236b8aeb576f4ef = {
    position: 'fixed',
    inset: '0',
    zIndex: '2000',
    pointerEvents: 'none',
    state: {},
    subscribeTo: [
        '_homeWidgetForm'
    ],
    // A FIRST-NEED LATCH owned by the component (the shell's boot budget,
    // __tests__/shellStageLadder.test.js): no subtree at boot — the host builds
    // the first time a widget asks for a form, and stays for the next one.
    if: (el, s)=>!!(s.root._homeWidgetForm && s.root._homeWidgetForm.form),
    // `onMounted`, not onCreate: a late `if:` activation (the first "+") runs
    // Init, AttachNode and Mounted — never Create — so the first form mounts
    // here; every later request (a fresh `seq`) arrives through onUpdate. Both
    // are idempotent per request (mountHomeWidgetForm's signature).
    onMounted: (el, s)=>el.call('mountHomeWidgetForm', el, s.root._homeWidgetForm),
    onUpdate: (el, s)=>el.call('mountHomeWidgetForm', el, s.root._homeWidgetForm)
};

});

parcelRegister("b0JcV", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetFrame", () => $8042c30c29760259$export$868e81bafe110204);
// THE home widget FRAME (HOME_WIDGETS_SPEC.md §2, §3, §6) — one definition
// for BOTH widget planes: the page's own widgets (pages/main.js `_widget`)
// and module / app / AI widgets (`HomeModuleWidget`). The two planes used to
// carry two hand-mirrored copies of this chrome ("change both together");
// now each only supplies its state row and its Body.
//
// The element IS the grid item and the card (no wrapper): the board's CSS
// grid places it by `data-widget-size` and CSS `order`, and it paints the one
// `card` surface — `var(--home-card-bg, var(--theme-card-background))`, the
// brand card fill behind the existing re-tint channel (a workspace record or a
// module's chrome.card). No literal fill, ring or blur here: the ambient skin
// re-values the card token (HOME_AMBIENT_SKIN_SPEC).
//
// Its STATE ROW is the widget descriptor (functions/homeWidgetFrame.js):
//   { id, title, icon, kind: 'widget', size, minSize, hue,
//     openRoute, openCall?, action?, help?, moduleId?, spec? }
//
// Anatomy — header: the hue plate, the title (a real button: the widget's
// keyboard entry), the optional (?) and ONE square button (1:1, the widget's
// primary verb or ↗ Open); then the body. App shortcuts are never frames:
// they live in the App strip above the grid (components/HomeAppStrip.js).
//
// Quality + overflow laws (HOME_AMBIENT_SKIN_SPEC §3, §3b): the card never
// clips — no overflow hidden; the title wraps (overflow-wrap anywhere),
// never an ellipsis; hover is an inset wash on the card, nothing scales.
//
// Edit mode (`root._homeCustomizeMode`): the card is draggable — a drag moves
// the widget in the ORDER and the grid reflows (functions/homeWidgetDrag.js);
// a remove button and a size picker (S · M · L · XL, never below the widget's
// minimum) overlay the card, so entering edit mode moves nothing. A drag
// starts anywhere but a control; `.gs-no-drag` (the class bodies already
// carry, named in the GridStack era) marks an area that is never a handle.
//
// Resize (DESIGN-WL-HOME-WIDTH-RESIZE-1): the corner handle
// (`HomeWidgetResizeHandle`, components/HomeWidgetResizeHandle.js, bottom-right — shown on hover and focus-within, and
// always in edit mode) drags a dashed outline (`WidgetResizeGhost`) that snaps
// to the four sizes, never below the minimum; the release writes the size
// through the same durable layout write as the picker
// (functions/homeWidgetResize.js). Both are overlays: showing them moves
// nothing.
//
// Motion (functions/homeWidgetMotion.js): the card declares the transitions a
// move plays — `translate` (a reflow glide) and `clip-path` (a grow reveal) at
// `C`, `scale` (the drag lift) at `A`, all `defaultBezier`. Code only ever
// writes the START value inline and clears it; the brand reset lands every one
// at once under reduced motion.
const $8042c30c29760259$export$868e81bafe110204 = {
    class: 'home-grid-item',
    attr: {
        'data-widget-id': (el, s)=>s && s.id || null,
        'data-widget-size': (el, s)=>el.call('homeWidgetFrameSize', s),
        // The steps where the manifest's per-step span changes the width the body
        // spans ("5:m"; functions/homeWidgetFrame.js homeWidgetSpanFit).
        'data-span-fit': (el, s)=>el.call('homeWidgetSpanFit', s),
        'data-widget-kind': (el, s)=>s && s.kind || 'widget',
        'data-editing': (el, s)=>s.root._homeCustomizeMode ? 'true' : null,
        'data-dragging': (el, s)=>s.root._homeDragId === s.id ? 'true' : null,
        // This card's (?) panel is open (functions/homeWidgetHelpTip.js).
        'data-help-open': (el, s)=>el.call('homeWidgetHelpOpen', s) ? 'true' : null,
        // Under the assistant's generated board (functions/homeWidgetFrame.js
        // homeWidgetUnderView): inert, hidden from assistive tech, faded out.
        'data-under-view': (el, s)=>el.call('homeWidgetUnderView', s) ? 'true' : null,
        inert: (el, s)=>el.call('homeWidgetUnderView', s) ? '' : null,
        'aria-hidden': (el, s)=>el.call('homeWidgetUnderView', s) ? 'true' : null
    },
    hide: (el, s)=>el.call('homeWidgetFrameHidden', s),
    onRemove: (el)=>{
        if (el.__homeClipTimer != null) clearTimeout(el.__homeClipTimer);
        el.__homeClipTimer = null;
    },
    order: (el, s)=>String(el.call('homeWidgetFrameOrder', s)),
    // The accent variables, plus the card's own per-step span variables
    // (`--home-span-c-5` …) the board's size rules read.
    style: (el, s)=>el.call('homeWidgetFrameStyle', s, el.context && el.context.designSystem),
    // THE ACCENT SELECTOR (HOME-WIDGET-ACCENT-DARK-PLATE-INVISIBLE-1). The style
    // above publishes BOTH halves of the on-surface accent
    // (`--home-widget-accent-light` / `--home-widget-accent-dark`,
    // functions/homeWidgetFrame.js) because which one reads on the card depends
    // on the theme, not just on the hue — `analytics` measures 15.88:1 on the
    // light card and 1.19:1 on the dark one. These two lines are what collapses
    // them into the single `--home-widget-accent` every visual slot reads, and
    // they have to be a RULE, not an inline value: an inline style is computed
    // once at render and nothing re-renders a card on a `data-theme` flip, while
    // `[data-theme="dark"] .<card>` follows the flip for free.
    '--home-widget-accent': 'var(--home-widget-accent-light)',
    '@dark': {
        '--home-widget-accent': 'var(--home-widget-accent-dark)'
    },
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    minWidth: '0',
    minHeight: '0',
    boxSizing: 'border-box',
    padding: 'A',
    fontSize: 'A',
    round: 'B1',
    background: 'var(--home-card-bg, var(--theme-card-background))',
    color: 'title',
    cursor: (el, s)=>s.root._homeCustomizeMode ? 'grab' : 'default',
    // Enter: one fade-up per card, staggered by flow position — opacity and
    // transform only; the brand reset lands the final frame at once under
    // reduced motion. `backwards` holds the start frame through the delay, so a
    // card never flashes before its turn.
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'backwards',
    // The timing scale has no step below Z, so the 40 ms stagger is literal
    // (HOME_WIDGETS_SPEC §5).
    animationDelay: (el, s)=>Math.min(Number(el.call('homeWidgetFrameOrder', s)) || 0, 8) * 40 + 'ms',
    // The crossfade under the generated board (spec §5: `C`, opacity only): the
    // card keeps its cell — nothing on the board moves — and its visibility
    // drops after the fade, so it takes no pointer while hidden.
    transition: 'opacity C defaultBezier, visibility 0s linear 0s, translate C defaultBezier, clip-path C defaultBezier, scale A defaultBezier',
    '&[data-under-view]': {
        opacity: '0',
        visibility: 'hidden',
        pointerEvents: 'none',
        transition: 'opacity C defaultBezier, visibility 0s linear C'
    },
    // Hover: an inset wash over the card — nothing moves, nothing scales.
    '::after': {
        content: '""',
        position: 'absolute',
        inset: '0',
        borderRadius: 'inherit',
        background: 'cardHover',
        opacity: '0',
        pointerEvents: 'none',
        transition: 'opacity A defaultBezier'
    },
    ':hover::after': {
        opacity: '1'
    },
    // The title button is the card's keyboard entry; the global ring draws on
    // the whole card while it has focus.
    ':has(.widget-title:focus-visible)': {
        shadow: 'focusRing'
    },
    '&[data-editing]': {
        touchAction: 'none',
        userSelect: 'none'
    },
    // The lifted card (DESIGN_SPEC §6.4): above its neighbours on the `float`
    // shadow — the elevation a dragged card takes (DESIGN_SPEC P1).
    '&[data-dragging]': {
        zIndex: '3',
        shadow: 'float'
    },
    // A card with its help panel open sits over its neighbours: a long help on a
    // short card runs past the card, and the next card's header (z 2, later in
    // the page) painted over it. Still far below every dialog.
    '&[data-help-open]': {
        zIndex: '3'
    },
    // The resize handle shows where the card is being looked at or worked on;
    // hidden, it takes no pointer, so a tap on the corner still opens the card.
    // It rises into place as it fades in (the edit controls' own entrance).
    ':hover .widget-resize-handle': {
        opacity: '1',
        pointerEvents: 'auto',
        translate: '0 0'
    },
    ':focus-within .widget-resize-handle': {
        opacity: '1',
        pointerEvents: 'auto',
        translate: '0 0'
    },
    '&[data-editing] .widget-resize-handle': {
        opacity: '1',
        pointerEvents: 'auto',
        translate: '0 0'
    },
    // Edit mode's controls (remove, size picker) are always mounted — entering
    // and leaving edit mode FADES them with a slight lift instead of popping
    // them in (Nika 2026-09-28 "smoother edit mode"); at rest they are `inert`
    // (no pointer, no focus, no reading) and they never move the card's content
    // (Rule 66: overlays).
    '&[data-editing] .widget-remove': {
        opacity: '1',
        pointerEvents: 'auto',
        translate: '0 0'
    },
    '&[data-editing] .widget-size-picker': {
        opacity: '1',
        pointerEvents: 'auto',
        translate: '0 0'
    },
    // A click on the card's chrome (the plate, the header, the padding) opens
    // the app. A click inside the BODY belongs to the body: its rows open their
    // own records, so the card never answers it too (one click, one action —
    // the contract both planes had before the frame).
    onClick: (e, el, s)=>{
        if (s && s.root && s.root._homeCustomizeMode) return;
        const t = e.target;
        if (t && t.closest && t.closest('button, a, input, textarea, select, [contenteditable], .gs-no-drag')) return;
        const body = el.Body && el.Body.node;
        if (body && t && body.contains && body.contains(t)) return;
        el.call('homeWidgetOpen', s, e);
    },
    // A pointer resting on the card — or focus reaching it — starts the chunk
    // load of the app it opens, so the click finds it warm and the window fills
    // in at once (functions/slotPrefetch.js; nothing mounts, nothing is written).
    onPointerenter: (e, el, s)=>el.call('prefetchSlotRoute', el.call('homeWidgetOpenRoute', s)),
    onFocusin: (e, el, s)=>el.call('prefetchSlotRoute', el.call('homeWidgetOpenRoute', s)),
    onPointerdown: (e, el, s)=>el.call('homeWidgetDragStart', e, s),
    onPointermove: (e, el, s)=>el.call('homeWidgetDragMove', e, s),
    onPointerup: (e, el, s)=>el.call('homeWidgetDragEnd', e, s, false),
    onPointercancel: (e, el, s)=>el.call('homeWidgetDragEnd', e, s, true),
    onContextmenu: (e, el, s)=>{
        if (!el.call('homeContextMenuAllowed', e, s.root)) return;
        e.preventDefault();
        e.stopPropagation();
        const title = el.call('polyglot', s && s.title || 'workspace.menu.thisWidget');
        const aiRef = {
            id: s.id,
            title: title
        };
        const canEditAi = !!s.aiGenerated && !!s.viewerCanEdit;
        const canDeleteAi = !!s.aiGenerated && !!s.viewerCanDelete;
        const items = [
            {
                label: 'common.action.refresh',
                action: 'refresh'
            },
            {
                label: s.root && s.root._homeWidgetColors && s.root._homeWidgetColors[s.id] ? 'workspace.menu.changeColor' : 'workspace.menu.addColor',
                action: 'widgetColor',
                widgetId: s.id,
                x: e.clientX,
                y: e.clientY,
                appHue: s.hue || s.iconBg || s.spec && s.spec.iconBg || null
            },
            {
                label: el.call('homeWidgetHideLabel', s),
                action: 'hideWidget',
                widgetId: s.id
            }
        ];
        // "Change with AI…" — an app's widget, a pinned one, or an AI-made widget
        // this member may edit (functions/homeContextMenu.js homeWidgetAiTarget);
        // second, after Refresh. HOME-WIDGET-CHANGE-WITH-AI-1.
        const aiTarget = el.call('homeWidgetAiTarget', s, title);
        if (aiTarget) items.splice(1, 0, {
            label: 'workspace.menu.changeWithAi',
            action: 'changeWidgetWithAi',
            widget: aiTarget
        });
        // "Widget size" — a touch screen's way to the size (a long press opens
        // this menu): the edit-mode picker's rows, without edit mode. Before the
        // hide row; absent for a mouse (functions/homeWidgetFrame.js
        // homeWidgetSizeMenuRow).
        const sizeRow = el.call('homeWidgetSizeMenuRow', s);
        if (sizeRow) {
            const at = items.findIndex((it)=>it.action === 'hideWidget');
            items.splice(at === -1 ? items.length : at, 0, sizeRow);
        }
        if (canEditAi) items.push({
            label: s.visibility === 'workspace' ? 'workspace.menu.makePersonal' : 'workspace.menu.shareToWorkspace',
            action: s.visibility === 'workspace' ? 'unshareAiWidget' : 'shareAiWidget',
            widget: aiRef
        });
        items.push({
            label: 'workspace.menu.customize',
            action: 'customize'
        });
        // The destructive row takes the menu's `danger` flag (ContextDropdown row
        // states: `dangerInk` + `data-danger`), never a raw hue, and it is the
        // last item (CRUD confirm standard rule 7), after Customize.
        if (canDeleteAi) items.push({
            label: el.call('polyglot', 'workspace.menu.deleteWidget').replace('{title}', title),
            action: 'deleteAiWidget',
            widget: aiRef,
            danger: true
        });
        s.root.update({
            contextDropdown: {
                open: true,
                x: e.clientX,
                y: e.clientY,
                items: items,
                actionFn: 'homeContextAction'
            }
        }, {
            preventFetch: true
        });
        el.call('focusHomeContextMenu');
    },
    Header: {
        class: 'widget-header',
        cursor: (el, s)=>!s.root._homeCustomizeMode && el.call('homeWidgetOpenRoute', s) ? 'pointer' : 'inherit',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'Z',
        minWidth: '0',
        flexShrink: '0',
        // The (?) panel's containing block (measured 2026-09-10): anchored to the
        // glyph, the panel tracked the title's length and hung 64px outside the
        // card, and its `100%` cap measured a 17px button. The header gives it the
        // card's width; the bump paints it over the body and the next card.
        position: 'relative',
        zIndex: '2',
        HomeWidgetPlate: {
            Icon: {
                name: (el, s)=>s && s.icon || 'star'
            }
        },
        TitleRow: {
            display: 'flex',
            alignItems: 'center',
            gap: 'X',
            flex: '1',
            minWidth: '0',
            minHeight: 'iconXl',
            Title: {
                tag: 'button',
                type: 'button',
                class: 'widget-title',
                minWidth: '0',
                padding: '0',
                border: 'none',
                background: 'transparent',
                color: 'title',
                fontSize: 'Z',
                fontWeight: '500',
                // 1.5, the house body leading: Georgian glyphs carry descenders 0.31em
                // under the baseline, and a tighter box crowds a two-line title.
                lineHeight: '1.5',
                textAlign: 'left',
                overflowWrap: 'anywhere',
                cursor: 'inherit',
                // A finger's target: the title is 19-22px tall (dev DFI, touch
                // simulated, DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1) — the 44pt floor
                // (the shared kit's `touchFloor`, shared/components/_touchTarget.js),
                // stated inline: this frame is closure-free and imports nothing
                // (widgetHelp.test.js).
                '@coarse': {
                    position: 'relative',
                    ':after': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '100%',
                        height: '100%',
                        minWidth: 'controlH',
                        minHeight: 'controlH',
                        transform: 'translate(-50%, -50%)'
                    }
                },
                text: (el, s)=>el.call('polyglot', s && (s.title || s.id) || ''),
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    if (s && s.root && s.root._homeCustomizeMode) return;
                    el.call('homeWidgetOpen', s, e);
                },
                // Edit mode: the arrow keys move the widget in the order — the
                // keyboard path of drag-to-reorder.
                onKeydown: (e, el, s)=>el.call('homeWidgetKeyMove', e, s)
            },
            // The OPTIONAL (?) beside the name (functions/widgetHelp.js contract).
            QuestionMarkTooltip: {
                class: 'gs-no-drag widget-header-help',
                hide: (el, s)=>!el.call('homeWidgetHelpOf', s),
                // Not the panel's containing block — the header is (see above).
                position: 'static',
                margin: '0',
                flexShrink: '0',
                lineHeight: '1',
                height: 'fit-content',
                // The panel's place is measured on the pointer's approach (before the
                // brand's hover/tap open), never in render; any other open (keyboard,
                // code) measures once at that open (functions/homeWidgetHelpTip.js).
                onPointerenter: (e, el)=>el.call('homeWidgetHelpTipMeasure'),
                // …and goes stale when the pointer or focus leaves (never shown open
                // again; the next approach measures afresh).
                onPointerleave: (e, el)=>el.call('homeWidgetHelpTipForget'),
                onFocusout: (e, el)=>el.call('homeWidgetHelpTipForget'),
                tip: (el, s)=>{
                    const h = el.call('homeWidgetHelpOf', s);
                    return h && h.tip ? el.call('polyglot', h.tip) : '';
                },
                ariaLabel: (el, s)=>{
                    const h = el.call('homeWidgetHelpOf', s);
                    return h && h.ariaLabel ? el.call('polyglot', h.ariaLabel) : '';
                },
                Icon: {
                    boxSize: 'A',
                    color: 'currentColor',
                    opacity: '.5'
                },
                TooltipHidden: {
                    shapeDirection: 'top',
                    maxWidth: 'min(var(--spacing-G1), 100%, 92vw)',
                    // PLACED AT ITS (?) (WS-WIDGET-HELP-TOOLTIP-ANCHOR-1): the header
                    // above stays the clamp; the panel opens from the glyph, shifted
                    // inward only as far as the card and the app frame need, and flips
                    // above the (?) when there is no room below
                    // (functions/homeWidgetHelpTip.js). Replaces the brand's centring.
                    style: (el)=>el.call('homeWidgetHelpTipStyle'),
                    // It renders from the place stored on THIS card's state, so it re-runs
                    // when that lands (no root write: other cards never re-run).
                    styleDeps: [
                        (el, s)=>s.root.helpTooltipOpenId,
                        (el, s)=>s._helpTipPlace
                    ],
                    // Its place was measured for this window size — a resize closes it.
                    onWindowResize: (e, el)=>el.call('homeWidgetHelpTipClose'),
                    description: (el, s)=>{
                        const h = el.call('homeWidgetHelpOf', s);
                        return h && h.tip ? el.call('polyglot', h.tip) : '';
                    }
                }
            }
        },
        HomeWidgetAction: {
            hide: (el, s)=>!el.call('homeWidgetActionOf', s),
            title: (el, s)=>{
                const a = el.call('homeWidgetActionOf', s);
                if (!a) return null;
                const name = el.call('polyglot', s && (s.title || s.id) || '');
                return el.call('polyglot', a.label).replace('{app}', name);
            },
            'aria-label': (el, s)=>{
                const a = el.call('homeWidgetActionOf', s);
                if (!a) return null;
                const name = el.call('polyglot', s && (s.title || s.id) || '');
                return el.call('polyglot', a.label).replace('{app}', name);
            },
            Icon: {
                name: (el, s)=>{
                    const a = el.call('homeWidgetActionOf', s);
                    return a && a.icon || 'arrowUpRight';
                }
            },
            onClick: (e, el, s)=>{
                e.stopPropagation();
                e.preventDefault();
                if (s && s.root && s.root._homeCustomizeMode) return;
                const card = el.parent && el.parent.parent;
                const body = card && card.Body;
                el.call('homeWidgetRunAction', s, e, body && body.content ? body.content : body);
            }
        }
    },
    Body: {
        class: 'widget-body',
        flex: '1',
        minHeight: '0',
        minWidth: '0',
        display: 'flex',
        flexDirection: 'column',
        // above the card's hover wash, under the header's bump (2): a hover
        // darkens the card's fill, never its words. The card itself makes no
        // stacking context (the resize outline paints over the neighbours).
        position: 'relative',
        zIndex: '1'
    },
    // Edit mode — overlays, so entering edit mode moves nothing (Rule 66).
    CloseButton: {
        class: 'gs-no-drag widget-remove',
        // Shown by the card's `[data-editing]` rule above (a fade with a lift);
        // at rest: invisible and inert — no pointer, no focus, no reading.
        opacity: '0',
        pointerEvents: 'none',
        translate: '0 var(--spacing-X)',
        transition: 'opacity A defaultBezier, translate A defaultBezier',
        attr: {
            inert: (el, s)=>s.root._homeCustomizeMode ? null : ''
        },
        position: 'absolute',
        top: 'X',
        left: 'X',
        zIndex: '4',
        theme: 'layer',
        // Named for ITS widget — "Hide “{title}”" (homeWidgetHideLabel), never one
        // shared "Hide this widget" for every card.
        title: (el, s)=>el.call('homeWidgetHideLabel', s),
        'aria-label': (el, s)=>el.call('homeWidgetHideLabel', s),
        onPointerdown: (e)=>e.stopPropagation(),
        onClick: (e, el, s)=>{
            e.stopPropagation();
            if (s && s.root && s.root._homeOps && s.root._homeOps.hideWidget) s.root._homeOps.hideWidget(s.id);
        }
    },
    AppSegmented: {
        class: 'gs-no-drag widget-size-picker',
        compact: true,
        // Shown by the card's `[data-editing]` rule above, like the remove button.
        opacity: '0',
        pointerEvents: 'none',
        translate: '0 var(--spacing-X)',
        transition: 'opacity A defaultBezier, translate A defaultBezier',
        attr: {
            inert: (el, s)=>s.root._homeCustomizeMode ? null : ''
        },
        position: 'absolute',
        bottom: 'Z',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: '4',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.widget.size.label'),
        current: (el, s)=>el.call('homeWidgetFrameSize', s),
        select: 'homeWidgetSetSize',
        onPointerdown: (e)=>e.stopPropagation(),
        childrenAs: 'state',
        children: (el, s)=>el.call('homeWidgetSizeRows', s)
    },
    // The box a resize will give — the dashed outline from the card's top-left
    // corner, painted over the neighbours (the card makes no stacking context,
    // so the outline's z-index lifts it above them). Its own state `{ size, w,
    // h }` is written by functions/homeWidgetResize.js while the pointer moves;
    // `size: null` = no resize in flight. The box glides between sizes at `A`.
    WidgetResizeGhost: {
        class: 'widget-resize-ghost',
        state: {
            size: null,
            w: 0,
            h: 0
        },
        hide: (el, s)=>!s.size,
        ariaHidden: 'true',
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '5',
        boxSizing: 'border-box',
        pointerEvents: 'none',
        round: 'B1',
        borderWidth: 'hairline2',
        borderStyle: 'dashed',
        borderColor: 'caption',
        background: 'hover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'width A defaultBezier, height A defaultBezier',
        style: (el, s)=>({
                width: `${Number(s.w) || 0}px`,
                height: `${Number(s.h) || 0}px`
            }),
        WidgetResizeGhostSize: {
            tag: 'span',
            theme: 'layer',
            padding: 'X Z',
            round: 'radiusControl',
            fontSize: 'Z',
            fontWeight: '500',
            color: 'title',
            // the size codes are symbols, the same in every language (the picker's)
            text: (el, s)=>({
                    s: 'S',
                    m: 'M',
                    l: 'L',
                    xl: 'XL'
                })[s.size] || ''
        }
    },
    // The corner handle (components/HomeWidgetResizeHandle.js): drag to resize,
    // arrows step the size while it has focus, Escape cancels a drag.
    HomeWidgetResizeHandle: {}
};

});

parcelRegister("kGfCC", function(module, exports) {

$parcel$export(module.exports, "HomeWidgetResizeHandle", () => $f0e3d9128215e3ed$export$7838287a6d238254);
// The corner RESIZE handle of a home widget frame (components/HomeWidgetFrame.js
// mounts it as its `HomeWidgetResizeHandle` child; DESIGN-WL-HOME-WIDTH-RESIZE-1,
// HOME_WIDGETS_SPEC §1 dated line + §6).
//
// A square icon button (1:1 — Nika: "all icon buttons should have 1/1 aspect
// ratio") at the card's bottom-right corner, over the card (an overlay:
// showing it moves nothing). The CARD reveals it — hover, focus-within, edit
// mode — through its `.widget-resize-handle` rules; at rest it is invisible
// and takes no pointer, so a tap on the corner still opens the card.
//
// Drag: pointer down captures the pointer on the handle, so every move and the
// release land here (no document listener); the frame's dashed outline
// (`WidgetResizeGhost`) shows the size the release will give; Escape on the
// focused handle cancels (functions/homeWidgetResize.js). Arrows on the
// focused handle step the size. Focusable only in edit mode — outside it the
// handle is a pointer affordance; the keyboard path there is Shift + an arrow.
const $f0e3d9128215e3ed$export$7838287a6d238254 = {
    extends: 'IconButton',
    class: 'gs-no-drag widget-resize-handle',
    hide: (el, s)=>el.call('homeWidgetIsApp', s),
    position: 'absolute',
    right: 'X',
    bottom: 'X',
    zIndex: '4',
    boxSize: 'iconLg',
    minWidth: 'iconLg',
    minHeight: 'iconLg',
    padding: '0',
    round: 'radiusControl',
    theme: 'layer',
    color: 'caption',
    border: 'none',
    align: 'center center',
    cursor: 'nwse-resize',
    touchAction: 'none',
    opacity: '0',
    pointerEvents: 'none',
    translate: '0 var(--spacing-X)',
    transition: 'opacity A defaultBezier, translate A defaultBezier',
    ':hover': {
        background: 'selected',
        color: 'title'
    },
    ':active': {
        background: 'selected',
        color: 'title'
    },
    tabindex: (el, s)=>s.root._homeCustomizeMode ? '0' : '-1',
    title: (el, s)=>el.call('homeWidgetResizeTitle', s),
    'aria-label': (el)=>el.call('polyglot', 'workspace.widget.size.label'),
    'aria-keyshortcuts': 'Shift+ArrowLeft Shift+ArrowRight Shift+ArrowUp Shift+ArrowDown',
    Icon: {
        name: 'arrowAngleDownRight',
        boxSize: 'iconSm'
    },
    onPointerdown: (e, el, s)=>el.call('homeWidgetResizeStart', e, s),
    onPointermove: (e, el, s)=>el.call('homeWidgetResizeMove', e, s),
    onPointerup: (e, el, s)=>el.call('homeWidgetResizeEnd', e, s, false),
    onPointercancel: (e, el, s)=>el.call('homeWidgetResizeEnd', e, s, true),
    onLostpointercapture: (e, el, s)=>el.call('homeWidgetResizeEnd', e, s, true),
    // the card never also opens from a press on its handle
    onClick: (e)=>{
        e.stopPropagation();
        e.preventDefault();
    },
    onKeydown: (e, el, s)=>el.call('homeWidgetResizeKey', e, s)
};

});

parcelRegister("2iwV7", function(module, exports) {

$parcel$export(module.exports, "WidgetRenderer", () => $1ac6cc78cf2af76e$export$bac6ca00840ef02b);
// WidgetRenderer — the body of an AI-CREATED home widget (tickets/opus.md
// "Per-workspace AI-CREATED widgets"), the second half of Nika's mandate
// "new apps should be able to have their own widgets from appstore or created
// by user ai".
//
// It hosts inside the EXACT same chrome an app-store widget gets — the
// `HomeModuleWidget` Card/Header/IconTile/Body/IconMode shell, the 2×2 icon
// floor + maxW/maxH ceiling, `homeWidgetHue`, the gs-clamps, the Customize
// drawer, the context menu (pages/main.js). Nothing visual is designed twice;
// this component draws ONLY what goes inside the Body, exactly like a module's
// own `Bi*WidgetBody`.
//
// ─── Why this component exists at all ────────────────────────────────────────
// A module widget's `body` is a component KEY that resolves inside a real,
// reviewed, published module. An AI-created widget has no module behind it, so
// there is nothing to point at — and the tempting shortcut (store an
// `(el, s) => …` factory as a string and eval/new Function it here) would be a
// client-side RCE surface in every OTHER member's session. So the body is
// DATA: a fixed vocabulary of block types whose fields are PATHS into that
// widget's own resolved dataRecipe result, drawn by the reviewed interpreters
// in AiWidgetBlock.js. Nothing here evaluates a stored string, ever.
//
// ─── The render-time capability check ────────────────────────────────────────
// The server stamps `viewerCapability` on every listed row, resolved for the
// CALLING user (never the creator). Two consequences, both here:
//   * a denied viewer renders the inert notice below and NO fetch is made;
//   * the fetch itself still goes through `el.sdk.execute(...)` (functions/
//     aiWidgets.js `loadAiWidgetData`), so the real entity route authorizes the
//     viewer independently — a permission failure degrades to the same notice.
// A shared widget can therefore never render the creator's data to someone who
// could not have asked for it themselves.
const $1ac6cc78cf2af76e$export$bac6ca00840ef02b = {
    flow: 'y',
    gap: 'Z',
    minHeight: '0',
    minWidth: '0',
    padding: 'Z B B B',
    // Kick the per-viewer resolve. Imperative-fetch-in-a-component is banned
    // (Rule 47); the SDK call lives in `functions/aiWidgets.js` and is invoked by
    // name, and it is idempotent per (widget, workspace, updatedAt) so these
    // re-fires (hosts re-render on every root update) do not loop.
    onRender: (el, s)=>el.call('loadAiWidgetData', s.root, el.sdk, s),
    onUpdate: (el, s)=>el.call('loadAiWidgetData', s.root, el.sdk, s),
    // Degraded, never broken and never silently over-privileged.
    Denied: {
        if: (el, s)=>!el.call('aiWidgetCapability', s, el.call('aiWidgetState', s.root, s.id)).allowed,
        flow: 'y',
        gap: 'Y',
        align: 'flex-start center',
        flex: '1',
        minHeight: '0',
        padding: 'Z',
        Icon: {
            icon: 'lockOutline',
            boxSize: 'B',
            color: 'caption'
        },
        Note: {
            tag: 'span',
            fontSize: 'Z2',
            lineHeight: '1.35',
            color: 'caption',
            textAlign: 'center',
            text: (el, s)=>el.call('aiWidgetCapability', s, el.call('aiWidgetState', s.root, s.id)).notice
        }
    },
    Blocks: {
        if: (el, s)=>el.call('aiWidgetCapability', s, el.call('aiWidgetState', s.root, s.id)).allowed,
        flow: 'y',
        gap: 'Z',
        minHeight: '0',
        minWidth: '0',
        // One child per declared block, keyed by position+type so an edited body
        // (a block whose type changed at the same index) re-creates rather than
        // re-skinning the wrong interpreter. `widgetId` rides along because the
        // resolved data lives on root (the hosts' own state is reassigned from the
        // widget-set factory on every recompute — see functions/aiWidgets.js).
        children: (el, s)=>{
            const blocks = s.body && Array.isArray(s.body.blocks) ? s.body.blocks : [];
            return blocks.map((block, i)=>({
                    ...block,
                    key: `${i}-${block && block.type}`,
                    widgetId: s.id
                }));
        },
        childExtends: 'AiWidgetBlock',
        childrenAs: 'state'
    }
};

});

parcelRegister("bsjx9", function(module, exports) {

$parcel$export(module.exports, "AiWidgetBlock", () => $85717639eb2b748f$export$424086535ae90a39);
$parcel$export(module.exports, "AiWidgetNumeral", () => $85717639eb2b748f$export$277c7e3965e0e57d);
$parcel$export(module.exports, "AiWidgetTextBlock", () => $85717639eb2b748f$export$f11f1950789b85cd);
$parcel$export(module.exports, "AiWidgetList", () => $85717639eb2b748f$export$278b5213bfd2d4e4);
$parcel$export(module.exports, "AiWidgetListRow", () => $85717639eb2b748f$export$a1ac2464ea065639);
$parcel$export(module.exports, "AiWidgetChipRow", () => $85717639eb2b748f$export$8b61d534070e2da6);
$parcel$export(module.exports, "AiWidgetChip", () => $85717639eb2b748f$export$2acc616df357ef2f);
$parcel$export(module.exports, "AiWidgetProgressBars", () => $85717639eb2b748f$export$a32983d1edef9fc4);
$parcel$export(module.exports, "AiWidgetBarChart", () => $85717639eb2b748f$export$a1fd07d525df3764);
$parcel$export(module.exports, "AiWidgetBarRow", () => $85717639eb2b748f$export$61033c80c1f62601);
// AiWidgetBlock — the reviewed interpreters for the AI-widget block VOCABULARY
// (tickets/opus.md "Per-workspace AI-CREATED widgets"). One component per block
// type, chosen by the block's own `type`; nothing here is generated, generic,
// or eval'd, and a body can only ever ask for one of these six shapes.
//
// The vocabulary was derived by reading the four real shipped module-widget
// bodies (`workspace/apps/bi/symbols/components/Bi*WidgetBody.js`): every one
// of them is a numeral, a caption, a bounded row list, or a labelled bar list.
// The bar treatment below is the house one — the same capsule track + inset
// hairline + proportional fill BiBarRow already uses (DESIGN_LANGUAGE §3,
// "gauges/tracks are pills") — so an AI widget sits in the same visual family
// as an app-store one rather than inventing a second language.
//
// State per block (childrenAs: 'state' from WidgetRenderer): the validated
// block object — `{ type, …bound fields, widgetId }`. The resolved data lives
// on root under the widget's id; every read goes through the registered
// path/format helpers in functions/aiWidgets.js, which walk own-properties only
// and return undefined on any miss.
const $85717639eb2b748f$export$424086535ae90a39 = {
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    AiWidgetNumeral: {
        if: (el, s)=>s.type === 'numeral'
    },
    AiWidgetTextBlock: {
        if: (el, s)=>s.type === 'text-block'
    },
    AiWidgetList: {
        if: (el, s)=>s.type === 'list'
    },
    AiWidgetChipRow: {
        if: (el, s)=>s.type === 'chip-row'
    },
    AiWidgetProgressBars: {
        if: (el, s)=>s.type === 'progress-bars'
    },
    AiWidgetBarChart: {
        if: (el, s)=>s.type === 'bar-chart'
    }
};
const $85717639eb2b748f$export$277c7e3965e0e57d = {
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    // HomeWidgetHero's row (flex row that wraps, baseline, column gap `Y`). The
    // hero itself is not extended: its Value carries the hero's numeral (`E` /
    // `F` by cell size, weight 300, tracked −0.03em, no ellipsis), its class and
    // grid area, a Tail and a Skeleton — this number keeps its own look.
    Quantity: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'baseline',
        columnGap: 'Y',
        minWidth: '0',
        Value: {
            tag: 'span',
            fontSize: 'D',
            fontWeight: '200',
            lineHeight: '0.95',
            color: 'title',
            fontFamily: 'monospace',
            fontVariantNumeric: 'tabular-nums',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            text: (el, s)=>{
                const fetched = el.call('aiWidgetState', s.root, s.widgetId);
                if (!fetched.settled) return "\u2014";
                const value = el.call('resolveWidgetPath', fetched.data, s.valuePath);
                return el.call('formatWidgetValue', value, s.format, {
                    prefix: s.prefix,
                    suffix: s.suffix
                });
            }
        },
        // The unit word in the look of HomeWidgetHero's Unit (its tokens: `A`,
        // 400, `inactive`, line height 1.3, `overflowWrap: 'anywhere'`): it wraps
        // and is never cut. Hidden with no unit, and while the value is not read
        // yet: the number shows its em dash alone, as the hero hides its unit
        // while it loads. The data read comes first, so it is always subscribed.
        Unit: {
            tag: 'span',
            fontSize: 'A',
            fontWeight: '400',
            lineHeight: '1.3',
            color: 'inactive',
            overflowWrap: 'anywhere',
            minWidth: '0',
            hide: (el, s)=>!el.call('aiWidgetState', s.root, s.widgetId).settled || !s.unit,
            text: (el, s)=>s.unit || ''
        }
    },
    Caption: {
        tag: 'span',
        hide: (el, s)=>!s.label && !s.caption && !s.captionPath,
        fontSize: 'Z',
        color: 'caption',
        lineHeight: '1.3',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>{
            if (s.captionPath) {
                const fetched = el.call('aiWidgetState', s.root, s.widgetId);
                const bound = el.call('resolveWidgetPath', fetched.data, s.captionPath);
                if (bound != null) return String(bound);
            }
            return s.caption || s.label || '';
        }
    }
};
const $85717639eb2b748f$export$f11f1950789b85cd = {
    tag: 'span',
    dataAiText: true,
    dataTextStyle: (el, s)=>el.call('aiWidgetTextStyle', s),
    flow: 'x',
    align: 'center',
    gap: 'Y',
    fontSize: (el, s)=>el.call('aiWidgetTextStyle', s) === 'caption' ? 'Y2' : 'Z2',
    color: (el, s)=>el.call('aiWidgetTextStyle', s) === 'caption' ? 'caption' : 'title',
    lineHeight: '1.35',
    minWidth: '0',
    ToneDot: {
        tag: 'span',
        dataAiToneDot: true,
        if: (el, s)=>{
            if (!s.tonePath) return false;
            const fetched = el.call('aiWidgetState', s.root, s.widgetId);
            return !!el.call('aiWidgetToneInk', el.call('resolveWidgetPath', fetched.data, s.tonePath));
        },
        dataTone: (el, s)=>{
            const fetched = el.call('aiWidgetState', s.root, s.widgetId);
            return el.call('aiWidgetToneInk', el.call('resolveWidgetPath', fetched.data, s.tonePath));
        },
        boxSize: 'Y',
        flexShrink: '0',
        round: 'radiusPill',
        background: (el, s)=>{
            const fetched = el.call('aiWidgetState', s.root, s.widgetId);
            return el.call('aiWidgetToneInk', el.call('resolveWidgetPath', fetched.data, s.tonePath));
        }
    },
    Words: {
        tag: 'span',
        minWidth: '0',
        text: (el, s)=>{
            if (s.textPath) {
                const fetched = el.call('aiWidgetState', s.root, s.widgetId);
                const bound = el.call('resolveWidgetPath', fetched.data, s.textPath);
                if (bound != null) return String(bound);
                return s.text || '';
            }
            return s.text || '';
        }
    }
};
const $85717639eb2b748f$export$278b5213bfd2d4e4 = {
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    Label: {
        tag: 'span',
        hide: (el, s)=>!s.label,
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>s.label || ''
    },
    Rows: {
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        children: (el, s)=>el.call('widgetListItems', el.call('aiWidgetState', s.root, s.widgetId).data, s),
        childExtends: 'AiWidgetListRow',
        childrenAs: 'state'
    },
    Empty: {
        tag: 'span',
        hide: (el, s)=>!!el.call('widgetListItems', el.call('aiWidgetState', s.root, s.widgetId).data, s).length,
        fontSize: 'Z2',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', s.emptyText || 'workspace.aiWidget.empty')
    }
};
const $85717639eb2b748f$export$a1ac2464ea065639 = {
    flow: 'x',
    flexWrap: 'wrap',
    rowGap: 'X',
    columnGap: 'Z',
    align: 'center space-between',
    minWidth: '0',
    Name: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'title',
        minWidth: '0',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.label
    },
    Meta: {
        tag: 'span',
        hide: (el, s)=>!s.meta,
        fontSize: 'Y2',
        color: 'caption',
        minWidth: '0',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontVariantNumeric: 'tabular-nums',
        text: (el, s)=>s.meta
    }
};
const $85717639eb2b748f$export$8b61d534070e2da6 = {
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    Label: {
        tag: 'span',
        hide: (el, s)=>!s.label,
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>s.label || ''
    },
    Chips: {
        flow: 'x',
        gap: 'X',
        flexWrap: 'wrap',
        minWidth: '0',
        children: (el, s)=>el.call('widgetListItems', el.call('aiWidgetState', s.root, s.widgetId).data, s),
        childExtends: 'AiWidgetChip',
        childrenAs: 'state'
    },
    Empty: {
        tag: 'span',
        hide: (el, s)=>!!el.call('widgetListItems', el.call('aiWidgetState', s.root, s.widgetId).data, s).length,
        fontSize: 'Z2',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', s.emptyText || 'workspace.aiWidget.empty')
    }
};
const $85717639eb2b748f$export$2acc616df357ef2f = {
    tag: 'span',
    padding: 'X Y',
    round: 'radiusPill',
    background: 'overlay',
    color: 'title',
    fontSize: 'Y2',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    text: (el, s)=>s.label
};
const $85717639eb2b748f$export$a32983d1edef9fc4 = {
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    Label: {
        tag: 'span',
        hide: (el, s)=>!s.label,
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>s.label || ''
    },
    Rows: {
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        children: (el, s)=>{
            const items = el.call('widgetListItems', el.call('aiWidgetState', s.root, s.widgetId).data, s);
            const peak = el.call('widgetListPeak', items);
            return items.map((item)=>({
                    ...item,
                    pct: peak > 0 ? Math.max(2, Math.round(item.value / peak * 100)) : 0,
                    display: el.call('formatWidgetValue', item.rawValue, s.format),
                    showValue: s.type === 'bar-chart'
                }));
        },
        childExtends: 'AiWidgetBarRow',
        childrenAs: 'state'
    },
    Empty: {
        tag: 'span',
        hide: (el, s)=>!!el.call('widgetListItems', el.call('aiWidgetState', s.root, s.widgetId).data, s).length,
        fontSize: 'Z2',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', s.emptyText || 'workspace.aiWidget.empty')
    }
};
const $85717639eb2b748f$export$a1fd07d525df3764 = {
    extends: 'AiWidgetProgressBars'
};
const $85717639eb2b748f$export$61033c80c1f62601 = {
    display: 'grid',
    gridTemplateColumns: (el, s)=>s.showValue ? 'minmax(4em, 8em) 1fr auto' : 'minmax(4em, 8em) 1fr',
    gap: 'Z',
    align: 'center',
    minWidth: '0',
    BarLabel: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '500',
        color: 'title',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>s.label
    },
    Track: {
        position: 'relative',
        height: 'Y',
        round: 'radiusPill',
        background: 'overlay',
        boxShadow: 'inset 0 hairline hairline black.12',
        overflow: 'hidden',
        Fill: {
            position: 'absolute',
            top: '0',
            bottom: '0',
            left: '0',
            round: 'radiusPill',
            transitionProperty: 'width',
            transition: 'C defaultBezier',
            width: (el, s)=>s.pct + '%',
            background: 'title'
        }
    },
    BarValue: {
        tag: 'span',
        hide: (el, s)=>!s.showValue,
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        whiteSpace: 'nowrap',
        textAlign: 'right',
        fontVariantNumeric: 'tabular-nums',
        text: (el, s)=>s.display
    }
};

});

parcelRegister("lGHBq", function(module, exports) {

$parcel$export(module.exports, "AssistantBoardView", () => $fc9f57d092e865ac$export$b976e8aae32b3ba5);
$parcel$export(module.exports, "AssistantBoardFact", () => $fc9f57d092e865ac$export$79b9d40d4a5897e8);
$parcel$export(module.exports, "AssistantBoardCard", () => $fc9f57d092e865ac$export$c96e2e7c860ff941);
// THE GENERATED BOARD — the assistant's answer as a VIEW of the home grid area
// (DESIGN-WL-ASSISTANT-MAIN-VIEW-1, ASSISTANT_BOARD_MODE_SPEC.md §4–§5). Nika,
// 2026-09-26: "ai assistant can directly render in main dashboard. it can make
// generative dashboards using all apps installed in workspace on fly."
//
// It REPLACES the grid area with a crossfade — the saved board is untouched
// underneath and returns on Esc, Dismiss or the "Home" segment; nothing on the
// page moves (Rule 66: the view keeps its box while closed, only opacity and
// visibility change). Every value it paints comes from functions/
// assistantBoard.js through `el.call` — the component holds no logic of its own:
//
//   head      the board's title (the greeting type; `tabindex -1`, focused
//             after generation) · the summary, facts in `title` ink, a polite
//             live region · the micro-label "GENERATED · 3 WIDGETS · JUST NOW"
//             (never the app list) · Pin all · Save as board · ONE square
//             Dismiss (brand CloseButton) · the status line (a failure + Try
//             again, an empty board, a pin/save notice)
//   refine    the model's refine suggestions as kit capsules
//   grid      ws-home's metrics (functions/homeGridMetrics.js): square cells,
//             sizes S · M · L · XL spanning by the column count, cells stamped
//             `data-size` + `data-widget-size` (the size vocabulary the home
//             slot components key on) — skeletons first, at their final size
//
// Cards (AssistantBoardCard): a WIDGET card mounts the installed app's own home
// body with its `params`, under the module's design-system context; a BLOCK
// card draws the AI-widget block interpreters (WidgetRenderer / AiWidgetBlock)
// and says where its numbers came from: "AI · FROM BI REVENUE". Both skins and
// both themes come from the tokens alone — nothing here reads the skin.
//
// Mounted by pages/main.js (docs/patches/assistant-board-mount.main.js.patch,
// ws-home's fence); shown in Page mode on the home — the answers set to Page
// (`assistantDock === 'main'`) while the board service answers
// (`_aiBoardsAvailable`, which this view's mount asks) — or under the
// `_aiBoardPreview` UI mode. The composer's send reaches
// `assistantBoardGenerate` in the same mode (functions/homeAiSend.js).
const $fc9f57d092e865ac$export$b976e8aae32b3ba5 = {
    tag: 'section',
    role: 'region',
    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantBoard.region'),
    // The measured grid metrics — geometry of THIS element, so its own state,
    // never root state. 0 = not measured yet (the widest table step applies).
    state: {
        cols: 0,
        gutter: 0,
        cell: 0,
        square: true
    },
    dataOpen: (el, s)=>el.call('assistantBoardShown', s.root) ? 'true' : 'false',
    dataStatus: (el, s)=>{
        const vm = el.call('assistantBoardViewModel', s.root);
        return vm && vm.status || 'idle';
    },
    ariaHidden: (el, s)=>el.call('assistantBoardShown', s.root) ? null : 'true',
    ariaBusy: (el, s)=>{
        const vm = el.call('assistantBoardViewModel', s.root);
        return vm && (vm.status === 'loading' || vm.status === 'streaming') ? 'true' : null;
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    // ONE column with the board (DESIGN-WL-HOME-WIDTH-RESIZE-1 (a)): the head,
    // the actions, the refine chips and the grid all sit on the home grid's own
    // width (`--home-grid-w`, the board stylesheet's — pages/main.js
    // _injectWidgetStyles), centred. Measured before: the head started at the
    // page edge and the actions ended at the other while the cards sat in the
    // centred column (2560 px, dev 8f18b1cb4). Outside the board (no variable)
    // the view keeps its full width.
    width: '100%',
    maxWidth: 'var(--home-grid-w, 100%)',
    marginInline: 'auto',
    minWidth: '0',
    boxSizing: 'border-box',
    // CLEAR OF THE COMPOSER'S STACK (fly-onboarding, ai-nino 2026-10-28: the
    // saved board's name chip covered its last cards). On the home the board
    // lies over the grid OUT of the flow (absolute), so the page column's end
    // padding never reaches it: a scroller's padding follows its in-flow
    // content only (measured in Chrome: a 1000px absolute child of a scroller
    // with 100px end padding scrolls to 1000). Its own bottom inset is the
    // shell's bottom line (`--slot-bottom`: the composer, its docked rows, a
    // toast while one shows, + the gap), the phone chip row (`--chip-row`, 0
    // off phones) and one spacing step. Over a page the layer's band already
    // ends above the stack (components/AssistantMainLayer.js zeroes this).
    paddingBottom: 'calc(var(--slot-bottom) + var(--chip-row) + var(--spacing-A))',
    // brought to the top as a new board (below), it stays clear of the shell's
    // floating header — the Fly page's own margin
    scrollMarginTop: 'calc(var(--shell-top) + var(--spacing-A))',
    // The crossfade (spec §5): `C`, opacity only. Closed keeps the box and hides
    // after the fade; open shows at once and fades in. A static rule on the
    // `data-open` stamp — never `hide:` (display none cannot transition, and the
    // grid behind it must not move).
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open="true"]': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    // Mounted: measure the grid, ask whether Page mode exists in this workspace
    // (`_aiBoardsAvailable`), list its saved boards — and again after a
    // workspace switch (`subscribeTo` re-runs onUpdate; the function acts once
    // per workspace). Esc and P join the shell keyboard registry while the view
    // is on the page — registered on mount, taken out on remove
    // (functions/assistantBoard.js assistantBoardShortcuts).
    // The installed apps publishing their widgets (`workspaceApps`,
    // `workspaceProject`) re-derive the board on screen: a cold `?board=` load
    // shows it before they land (qa round 11 F1, assistantBoardRederive — no
    // write unless its rows changed). The project list and the App Store list
    // name the links of the site cards (a row's ↗), and they too can land after
    // the board (MISSING-NAMES-2).
    subscribeTo: [
        'workspace',
        'workspaceApps',
        'workspaceProject',
        '_projectsForActiveOrg',
        '_wsAppsCatalog'
    ],
    onMounted: (el, s)=>{
        el.call('assistantBoardMounted', el, s);
        el.call('assistantBoardShortcuts', el);
    },
    onUpdate: (el, s)=>{
        el.call('assistantBoardMounted', el, s);
        el.call('assistantBoardRederive', s && s.root);
    },
    onWindowResize: (e, el, s)=>el.call('assistantBoardSyncGrid', el, s),
    onRemove: (el)=>{
        if (typeof el.__boardShortcutsOff === 'function') el.__boardShortcutsOff();
        el.call('assistantBoardGridReadOff', el);
    },
    // A NEW BOARD — an ask, a refine, a saved board opened — comes to the top of
    // the view, once per request (Nika 2026-10-23: "when answering in new
    // section always scroll top of that section"; functions/assistantReveal.js).
    // A board shorter than the scroller takes the room it needs (its
    // `minHeight`), while it is on screen.
    minHeight: (el, s)=>el.call('assistantRevealRoom', el, s.root, el.call('assistantBoardShown', s.root)),
    stateDeps: [
        (el, s)=>{
            const b = s.root && s.root._aiBoard;
            return b && (b.requestId || b.id) ? String(b.requestId || b.id) : null;
        }
    ],
    onStateUpdate: (el, s, ctx, change)=>{
        const next = (change && change.next || [])[0];
        if (next && el.call('assistantBoardShown', s.root)) el.call('assistantRevealTop', el, null, 'board' + next);
    },
    BoardHead: {
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        BoardHeading: {
            flow: 'x',
            align: 'flex-start',
            gap: 'A',
            minWidth: '0',
            BoardIdentity: {
                flow: 'y',
                gap: 'Z',
                minWidth: '0',
                flex: '1',
                // The greeting line's type (HOME_WIDGETS_SPEC §4.1): `C` 700, `title`.
                // The title never truncates — it wraps (HOME_AMBIENT_SKIN_SPEC §3b).
                BoardTitle: {
                    tag: 'h2',
                    dataBoardTitle: true,
                    tabindex: '-1',
                    hide: (el, s)=>{
                        const vm = el.call('assistantBoardViewModel', s.root);
                        return !!(vm && vm.rename);
                    },
                    margin: '0',
                    fontSize: 'C',
                    '@mobileL': {
                        fontSize: 'B'
                    },
                    '@appMobile': {
                        fontSize: 'B'
                    },
                    fontWeight: '700',
                    lineHeight: '1.2',
                    color: 'title',
                    minWidth: '0',
                    overflowWrap: 'anywhere',
                    // The title takes focus after a board lands (spec §5) so a screen reader
                    // reads from it — a reading position, not a control: `tabindex -1`,
                    // never in the tab order, so no ring either. A programmatic focus after
                    // a keystroke counts as :focus-visible, and the ring used to paint the
                    // whole width after every generation.
                    ':focus': {
                        outline: 'none'
                    },
                    ':focus-visible': {
                        outline: 'none',
                        boxShadow: 'none'
                    },
                    TitleText: {
                        tag: 'span',
                        text: (el, s)=>{
                            const vm = el.call('assistantBoardViewModel', s.root);
                            return vm && vm.spec && vm.spec.title || '';
                        }
                    },
                    // While the title is on its way: an inline bar one line box tall, so the
                    // head keeps its height when the words land.
                    Skeleton: {
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        width: 'F',
                        height: '1em',
                        hide: (el, s)=>{
                            const vm = el.call('assistantBoardViewModel', s.root);
                            return !vm || !!(vm.spec && vm.spec.title) || vm.status === 'failed';
                        }
                    }
                },
                // RENAME (D4): the title as the kit field, the same line; Enter or Save
                // keeps the name, Esc or Cancel leaves it (Esc stays in the field — the
                // board's own Esc does not close the view from here).
                BoardRename: {
                    if: (el, s)=>{
                        const vm = el.call('assistantBoardViewModel', s.root);
                        return !!(vm && vm.rename);
                    },
                    flow: 'x',
                    flexWrap: 'wrap',
                    align: 'center',
                    gap: 'Y',
                    minWidth: '0',
                    AppInput: {
                        dataBoardRenameField: true,
                        maxlength: '60',
                        width: 'auto',
                        flex: '1',
                        minWidth: 'F',
                        ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantBoard.renameField'),
                        value: (el, s)=>{
                            const vm = el.call('assistantBoardViewModel', s.root);
                            return vm && vm.rename && vm.rename.draft || '';
                        },
                        onRender: (el)=>{
                            if (el.node && typeof el.node.focus === 'function') el.node.focus();
                        },
                        onInput: (e, el)=>el.call('assistantBoardRenameDraft', e.target.value),
                        onKeydown: (e, el)=>{
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                el.call('assistantBoardRename');
                            } else if (e.key === 'Escape') {
                                e.preventDefault();
                                e.stopPropagation();
                                el.call('assistantBoardRenameCancel');
                            }
                        }
                    },
                    AppCapsuleBtnPrimary: {
                        compact: true,
                        dataBoardRenameSave: true,
                        text: '{{ common.action.save | polyglot }}',
                        onClick: (e, el)=>el.call('assistantBoardRename')
                    },
                    AppCapsuleBtnToolbar: {
                        compact: true,
                        dataBoardRenameCancel: true,
                        text: '{{ common.action.cancel | polyglot }}',
                        onClick: (e, el)=>el.call('assistantBoardRenameCancel')
                    }
                }
            },
            // The ONE square button of the head: 1:1, the brand close. Its name is
            // this view's verb, not the brand's default "Close": the brand declares
            // that default in its `attr` block, and a flat `ariaLabel` beside it
            // races it (measured: the brand's word won) — only the same `attr` key
            // replaces it, by the shallow merge `attr` blocks get.
            CloseButton: {
                flexShrink: '0',
                alignSelf: 'flex-start',
                dataBoardDismiss: true,
                attr: {
                    'aria-label': (el)=>el.call('polyglot', 'workspace.assistantBoard.dismiss')
                },
                onClick: (e, el)=>el.call('assistantBoardDismiss', {
                        focusComposer: true
                    })
            }
        },
        // Facts in `title` 500, the words between in `inactive` (spec §4); the
        // live region exists before its content changes, so the answer is read.
        BoardSummary: {
            tag: 'p',
            dataBoardSummary: true,
            ariaLive: 'polite',
            margin: '0',
            fontSize: 'A',
            lineHeight: '1.45',
            maxWidth: 'H',
            minWidth: '0',
            overflowWrap: 'anywhere',
            // CLS 0 (spec §6.1): the head holds TWO lines of summary from the first
            // paint, so the cards do not fall when the sentences land. Measured on
            // dev 2026-10-02: the busy head was 33 px and the complete head 146 px,
            // and all three cards dropped dy +113 px at that moment. `2.9em` is
            // 2 × this element's own `lineHeight` 1.45, so the reservation tracks the
            // type rather than a pixel. The clamp is the other half of the same law —
            // a summary longer than two lines is cut INSIDE the reservation instead
            // of growing past it. Both from answer A.
            minHeight: (el, s)=>el.call('assistantBoardSummaryReserved', el.call('assistantBoardViewModel', s.root)) ? '2.9em' : '0',
            lineClamp: '2',
            children: (el, s)=>el.call('assistantBoardSummaryRows', el.call('assistantBoardViewModel', s.root)),
            childrenAs: 'state',
            childExtends: 'AssistantBoardFact'
        },
        BoardBar: {
            flow: 'y',
            align: 'stretch',
            gap: 'Z',
            minWidth: '0',
            AppMicroLabel: {
                dataBoardMicro: true,
                whiteSpace: 'normal',
                text: (el, s)=>el.call('assistantBoardMicro', el.call('assistantBoardViewModel', s.root))
            },
            BoardActions: {
                minWidth: '0',
                maxWidth: '100%',
                width: '100%',
                flow: 'x',
                flexWrap: 'wrap',
                align: 'center',
                gap: 'Y',
                AppCapsuleBtnPrimary: {
                    compact: true,
                    dataBoardPinAll: true,
                    disabled: (el, s)=>el.call('assistantBoardActionsIdle', el.call('assistantBoardViewModel', s.root)) || null,
                    onClick: (e, el, s)=>el.call('pinAllBoardItems', el, s),
                    AppLabelStack: {
                        labels: [
                            'workspace.assistantBoard.pinAll',
                            'workspace.assistantBoard.pinning',
                            'workspace.assistantBoard.pinnedAll'
                        ],
                        shown: (el, s)=>el.call('assistantBoardPinAllLabel', el.call('assistantBoardViewModel', s.root))
                    }
                },
                AppCapsuleBtnToolbar: {
                    compact: true,
                    dataBoardSave: true,
                    disabled: (el, s)=>el.call('assistantBoardActionsIdle', el.call('assistantBoardViewModel', s.root)) || null,
                    onClick: (e, el, s)=>el.call('saveBoard', el, s),
                    AppLabelStack: {
                        labels: [
                            'workspace.assistantBoard.saveAsBoard',
                            'workspace.assistantBoard.saving',
                            'workspace.assistantBoard.saved'
                        ],
                        shown: (el, s)=>el.call('assistantBoardSaveLabel', el.call('assistantBoardViewModel', s.root))
                    }
                },
                // REFRESH DATA (D3; Pulse's Refresh): every records card reads again
                // and every app widget body re-mounts. Rests while a card is reading.
                AppCapsuleBtnToolbar_refresh: {
                    compact: true,
                    dataBoardRefresh: true,
                    disabled: (el, s)=>el.call('assistantBoardActionsIdle', el.call('assistantBoardViewModel', s.root)) || el.call('assistantBoardRefreshing', s.root) || null,
                    text: '{{ workspace.assistantBoard.refresh | polyglot }}',
                    onClick: (e, el)=>el.call('assistantBoardRefresh')
                },
                // SHARE — the record's link for the workspace (saved first when it is
                // not yet a record) — and OPEN IN SIDEBAR — the board moves to the
                // docked panel's thread (functions/assistantBoard.js).
                AppCapsuleBtnToolbar_share: {
                    compact: true,
                    dataBoardShare: true,
                    disabled: (el, s)=>el.call('assistantBoardActionsIdle', el.call('assistantBoardViewModel', s.root)) || null,
                    onClick: (e, el, s)=>el.call('assistantBoardShare', el, s),
                    AppLabelStack: {
                        labels: [
                            'workspace.assistantBoard.share',
                            'workspace.assistantBoard.sharing',
                            'workspace.assistantBoard.shared'
                        ],
                        shown: (el, s)=>el.call('assistantBoardShareLabel', el.call('assistantBoardViewModel', s.root))
                    }
                },
                AppCapsuleBtnToolbar_sidebar: {
                    compact: true,
                    dataBoardToSidebar: true,
                    disabled: (el, s)=>el.call('assistantBoardActionsIdle', el.call('assistantBoardViewModel', s.root)) || null,
                    text: '{{ workspace.assistantThread.openInSidebar | polyglot }}',
                    onClick: (e, el)=>el.call('assistantBoardToSidebar')
                },
                BoardManage: {
                    flow: 'x',
                    flexWrap: 'wrap',
                    align: 'center',
                    gap: 'Y',
                    minWidth: '0',
                    maxWidth: '100%',
                    marginLeft: 'auto',
                    '@mobileL': {
                        width: '100%',
                        marginLeft: '0'
                    },
                    '@appMobile': {
                        width: '100%',
                        marginLeft: '0'
                    },
                    // SAVED BOARDS (D4; Pulse's boards store): Rename (a saved board the
                    // viewer may edit, or any unsaved one), Duplicate and Delete (a saved
                    // record; Delete asks first through the house confirm).
                    AppCapsuleBtnGhost_rename: {
                        compact: true,
                        dataBoardRename: true,
                        if: (el, s)=>el.call('assistantBoardManage', s.root).canRename,
                        text: '{{ common.action.rename | polyglot }}',
                        onClick: (e, el)=>el.call('assistantBoardRenameStart')
                    },
                    AppCapsuleBtnGhost_duplicate: {
                        compact: true,
                        dataBoardDuplicate: true,
                        if: (el, s)=>el.call('assistantBoardManage', s.root).canDuplicate,
                        text: '{{ common.action.duplicate | polyglot }}',
                        onClick: (e, el)=>el.call('assistantBoardDuplicate')
                    },
                    AppCapsuleBtnGhost_delete: {
                        compact: true,
                        dataBoardDelete: true,
                        if: (el, s)=>el.call('assistantBoardManage', s.root).canDelete,
                        text: '{{ common.action.delete | polyglot }}',
                        onClick: (e, el)=>el.call('assistantBoardDeleteAsk')
                    }
                }
            }
        },
        // A failure (with Try again), an empty board, the last pin / save notice.
        // Always mounted — a status region must exist before it speaks.
        BoardStatus: {
            dataBoardStatus: true,
            role: 'status',
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center',
            gap: 'Z',
            minWidth: '0',
            StatusText: {
                tag: 'span',
                dataBoardStatusText: true,
                fontSize: 'A',
                fontWeight: '500',
                color: 'title',
                minWidth: '0',
                overflowWrap: 'anywhere',
                text: (el, s)=>el.call('assistantBoardStatus', el.call('assistantBoardViewModel', s.root))
            },
            AppCapsuleBtnToolbar: {
                compact: true,
                dataBoardRetry: true,
                hide: (el, s)=>{
                    const vm = el.call('assistantBoardViewModel', s.root);
                    return !vm || vm.status !== 'failed';
                },
                text: '{{ workspace.assistantBoard.tryAgain | polyglot }}',
                onClick: (e, el)=>el.call('assistantBoardRetry')
            }
        }
    },
    // THE PERIOD (D3; Pulse's window): the kit's segmented choice over the
    // six records presets. The board's one shared period is chosen (none when
    // the cards differ); a choice re-asks every dated records card. Only on a
    // ready board with a dated records card.
    AppSegmented: {
        dataBoardPeriod: true,
        if: (el, s)=>el.call('assistantBoardPeriodShown', el.call('assistantBoardViewModel', s.root)),
        variant: 'choice',
        compact: true,
        ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantBoard.period'),
        current: (el, s)=>el.call('assistantBoardPeriod', el.call('assistantBoardViewModel', s.root)),
        select: 'assistantBoardSetPeriod',
        childrenAs: 'state',
        children: (el)=>el.call('assistantBoardPeriodOptions')
    },
    // The model's refine suggestions — one tap asks again, against this board.
    BoardRefine: {
        dataBoardRefine: true,
        role: 'group',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantBoard.refine'),
        flow: 'x',
        flexWrap: 'wrap',
        gap: 'Y',
        minWidth: '0',
        // CLS 0 (spec §6.1): the group holds ONE chip row from the first paint, so
        // the grid does not fall when the suggestions land. Measured on dev
        // 2026-10-02: the landed cards dropped a further dy +36 px, which is
        // exactly `controlHCompact` — one compact capsule, what these chips are.
        // Reserved only while chips are coming or present (answer A).
        minHeight: (el, s)=>el.call('assistantBoardRefineReserved', el.call('assistantBoardViewModel', s.root)) ? 'controlHCompact' : '0',
        children: (el, s)=>{
            const vm = el.call('assistantBoardViewModel', s.root);
            return (vm && vm.spec && vm.spec.refine || []).map((r, i)=>({
                    key: 'refine' + i,
                    ...r
                }));
        },
        childrenAs: 'state',
        childExtends: 'AppCapsuleBtnToolbar',
        childProps: {
            compact: true,
            whiteSpace: 'normal',
            text: (el, s)=>s && s.label || '',
            onClick: (e, el, s)=>el.call('assistantBoardRefine', {
                    label: s.label,
                    prompt: s.prompt
                })
        }
    },
    BoardGrid: {
        dataBoardGrid: true,
        display: 'grid',
        gridAutoFlow: 'row dense',
        justifyContent: 'center',
        minWidth: '0',
        style: (el, s)=>el.call('assistantBoardGridStyle', s),
        children: (el, s)=>el.call('assistantBoardCells', el.call('assistantBoardViewModel', s.root), el.call('assistantBoardMetrics', s).cols),
        childrenAs: 'state',
        childExtends: 'AssistantBoardCard'
    }
};
const $fc9f57d092e865ac$export$79b9d40d4a5897e8 = {
    tag: 'span',
    dataFact: (el, s)=>s && s.fact ? 'true' : null,
    color: (el, s)=>s && s.fact ? 'title' : 'inactive',
    fontWeight: (el, s)=>s && s.fact ? '500' : '400',
    text: (el, s)=>s && s.text || ''
};
const $fc9f57d092e865ac$export$c96e2e7c860ff941 = {
    tag: 'article',
    dataBoardItem: (el, s)=>s && s.key || null,
    dataKind: (el, s)=>s && s.kind || null,
    dataSize: (el, s)=>s && s.size || 's',
    dataWidgetSize: (el, s)=>s && s.size || 's',
    ariaBusy: (el, s)=>s && s.kind === 'skeleton' ? 'true' : null,
    style: (el, s)=>el.call('assistantBoardCardStyle', s, el.context && el.context.designSystem),
    // THE ACCENT SELECTOR — the same two lines as the home frame
    // (components/HomeWidgetFrame.js), and the same reason: the style above
    // publishes both halves of the on-surface accent because the DECISION is
    // theme-dependent, and only a `[data-theme]` rule follows a theme flip
    // without a re-render. Goes when this view mounts through ws-home's frame,
    // together with `assistantBoardHueVars`.
    '--home-widget-accent': 'var(--home-widget-accent-light)',
    '@dark': {
        '--home-widget-accent': 'var(--home-widget-accent-dark)'
    },
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    minWidth: '0',
    minHeight: '0',
    boxSizing: 'border-box',
    padding: 'A',
    fontSize: 'A',
    round: 'B1',
    background: 'var(--home-card-bg, var(--theme-card-background))',
    color: 'title',
    // First paint: one fade per card, staggered by position — opacity only.
    // The timing scale has no step below Z, so the 40 ms stagger is literal
    // (HOME_WIDGETS_SPEC §5); the brand reset lands it at once under reduced
    // motion.
    animation: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'backwards',
    animationDelay: (el, s)=>Math.min(s && s.index || 0, 8) * 40 + 'ms',
    // the wash lies under the card's words (its own stacking context, the layer
    // at -1): a hover darkens the fill, never the text — nothing in a board card
    // paints over its neighbours
    isolation: 'isolate',
    '::after': {
        content: '""',
        position: 'absolute',
        inset: '0',
        zIndex: '-1',
        borderRadius: 'inherit',
        background: 'cardHover',
        opacity: '0',
        pointerEvents: 'none',
        transition: 'opacity A defaultBezier'
    },
    ':hover::after': {
        opacity: '1'
    },
    CardHead: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        minWidth: '0',
        HomeWidgetPlate: {
            if: (el, s)=>!!s && s.kind !== 'skeleton',
            Icon: {
                name: (el, s)=>s && s.icon || 'star'
            }
        },
        SkeletonCircle: {
            if: (el, s)=>!!s && s.kind === 'skeleton',
            boxSize: 'iconXl',
            minWidth: 'iconXl'
        },
        // Primary text: it wraps and is never cut — no clamp, no ellipsis
        // (HOME_AMBIENT_SKIN_SPEC §3 / §3b); validation caps a title at 60
        // characters, so two lines hold it at every cell width.
        CardTitle: {
            tag: 'h3',
            dataBoardCardTitle: true,
            if: (el, s)=>!!s && s.kind !== 'skeleton',
            flex: '1',
            margin: '0',
            minWidth: '0',
            fontSize: 'Z',
            fontWeight: '500',
            lineHeight: '1.3',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.title ? el.call('polyglot', s.title) : ''
        },
        SkeletonRow: {
            if: (el, s)=>!!s && s.kind === 'skeleton',
            width: '50%'
        },
        // The card's ONE square button = Pin (spec §4): 1:1, named by its verb and
        // the card's title; a card pinned (or on a preview board) is done.
        HomeWidgetAction: {
            dataBoardPin: true,
            // A records card pins too (WIDGET-TOOLS-RECORDS-SHAPE-1); a skeleton
            // has nothing to pin.
            if: (el, s)=>!!s && s.kind !== 'skeleton',
            disabled: (el, s)=>{
                const vm = el.call('assistantBoardViewModel', s && s.root);
                const state = el.call('assistantBoardPinState', s && s.root, s && s.key);
                return !vm || vm.preview || vm.status !== 'ready' || state === 'pinned' || state === 'pinning' ? true : null;
            },
            ariaLabel: (el, s)=>el.call('assistantBoardPinLabel', s, el.call('assistantBoardPinState', s && s.root, s && s.key) === 'pinned'),
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('pinBoardItem', el, s, s && s.parse ? s.parse() : s);
            },
            Icon: {
                name: (el, s)=>el.call('assistantBoardPinState', s && s.root, s && s.key) === 'pinned' ? 'pin' : 'pinOutline'
            }
        },
        // A DRILL card's ONE square button is Close (D2 drill-down): the card
        // leaves the board, its source stays. A records card has no Pin, so the
        // head still holds one square button.
        HomeWidgetAction_close: {
            extends: 'HomeWidgetAction',
            dataBoardDrillClose: true,
            if: (el, s)=>!!(s && s.kind === 'records' && s.drill),
            ariaLabel: (el, s)=>String(el.call('polyglot', 'workspace.assistantRecords.drillClose')).replace('{title}', s && s.title || ''),
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('assistantBoardDrillClose', s && s.key);
            },
            Icon: {
                name: 'x'
            }
        }
    },
    // The mount host: a module body (with its params), the block renderer, or a
    // Fly UI section's result (the chat's own answer-UI renderers) once it is in.
    CardBody: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        minWidth: '0',
        minHeight: '0',
        isRecords: (el, s)=>!!s && s.kind === 'records',
        '.isRecords': {
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        },
        // A read's rows can outgrow the card: they scroll inside it.
        isUi: (el, s)=>!!s && s.kind === 'ui',
        '.isUi': {
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        },
        if: (el, s)=>!!s && s.kind !== 'skeleton',
        hide: (el, s)=>!s || s.kind === 'block' && !!s.empty || s.kind === 'ui' && el.call('assistantFlyUiState', s) !== 'ready',
        onRender: (el, s)=>el.call('assistantBoardMountBody', el, s),
        onUpdate: (el, s)=>el.call('assistantBoardMountBody', el, s),
        // A Fly UI section's result lands on the SAME card (`fly.ui` — the card
        // keeps its key): a state value of the card, so its own selector — a
        // parent's write never runs this element's onUpdate.
        stateDeps: [
            (el, s)=>s && s.kind === 'ui' ? s.ui || null : null
        ],
        onStateUpdate: (el, s)=>el.call('assistantBoardMountBody', el, s)
    },
    // Skeleton: a hero bar and a visual block at the body's place — also while a
    // Fly UI section's read is out, with the line that says what it reads.
    CardSkeleton: {
        if: (el, s)=>!!s && (s.kind === 'skeleton' || s.kind === 'ui'),
        hide: (el, s)=>!s || s.kind !== 'skeleton' && !(s.kind === 'ui' && el.call('assistantFlyUiState', s) === 'reading'),
        flex: '1',
        flow: 'y',
        gap: 'Z',
        minHeight: '0',
        Skeleton_1: {
            width: '40%',
            height: 'B'
        },
        Skeleton_2: {
            flex: '1',
            minHeight: 'B',
            round: 'radiusControl'
        },
        CardReading: {
            tag: 'p',
            dataFlyReading: true,
            if: (el, s)=>!!s && s.kind === 'ui',
            role: 'status',
            margin: '0',
            fontSize: 'Z',
            color: 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>el.call('assistantFlyUiNote', s)
        }
    },
    // A block with no data: one sentence WITH its params and the board's first
    // refine suggestion as the one quiet action — never a zero, never a tall
    // empty card. A Fly UI section whose read found nothing or did not come
    // back says its one sentence here too (functions/assistantFlyUi.js).
    HomeWidgetEmpty: {
        if: (el, s)=>!!s && (s.kind === 'block' || s.kind === 'ui'),
        hide: (el, s)=>{
            if (!s) return true;
            if (s.kind === 'ui') {
                const state = el.call('assistantFlyUiState', s);
                return state !== 'empty' && state !== 'error';
            }
            return !s.empty;
        },
        flex: '1',
        Text: {
            text: (el, s)=>{
                if (s && s.kind === 'ui') return el.call('assistantFlyUiNote', s);
                return s && s.empty ? el.call('assistantBoardEmptyItem', s) : '';
            }
        },
        Action: {
            text: (el, s)=>{
                const vm = el.call('assistantBoardViewModel', s && s.root);
                const first = vm && vm.spec && (vm.spec.refine || [])[0];
                return first && first.label || '';
            },
            onClick: (e, el, s)=>{
                const vm = el.call('assistantBoardViewModel', s && s.root);
                const first = vm && vm.spec && (vm.spec.refine || [])[0];
                if (first) el.call('assistantBoardRefine', first);
            }
        }
    },
    // A block says where its numbers came from (spec §2); a widget body carries
    // its own footer.
    HomeWidgetFooter: {
        if: (el, s)=>!!s && (s.kind === 'block' || s.kind === 'records'),
        alignSelf: 'flex-start',
        marginTop: 'auto',
        text: (el, s)=>s && (s.kind === 'block' || s.kind === 'records') ? el.call('assistantBoardBlockFooter', s) : ''
    }
};

});

parcelRegister("2ryNq", function(module, exports) {

$parcel$export(module.exports, "AssistantThreadChips", () => $1c79182ad76f6a48$export$78f3f1f0f5847d04);
// RECENT PROMPTS above the composer (DESIGN-WL-ASSISTANT-MAIN-VIEW-1,
// ASSISTANT_BOARD_MODE_SPEC.md §4 decision 23): the boards this workspace asked
// for lately, as the kit's choice chips — the board's SHORT title on the chip,
// the full prompt in its `title`, at most five, one row that scrolls sideways
// with snap (never wraps into a second line over the composer, never clips a
// chip). Tapping one re-renders that board (functions/assistantBoard.js
// `assistantBoardShow`); the chip of the board on screen reads pressed.
//
// Shown in Page mode on the home (or under the `_aiBoardPreview` UI mode) once
// a board exists. Mounted above the composer by the send-routing patch
// (docs/patches/assistant-board-send-routing.patch, the composer's owner).
//
// THE PLATE (design-d2's relay, 2026-09-27; ws-w2's live finding on served
// 80eefe852: the kit chip fill — currentColor at 14% — let the home widgets
// read through the chips, and the row was hard-cropped at its right edge).
// The row sits on the composer's OWN plate: the skins' `pill` theme (the solid
// pill, or the card glass in the ambient skin — the composer's theme since
// 61f7a2c91), the capsule round, a small inset. The plate is what hides.
//
// THE ROW is the kit's ONE edge-fade row (shared AppScrollRow, 48ca71188):
// sideways scroll with no scrollbar, only an edge that hides a chip fades, the
// current child stays whole. The fade stays on this INNER row: a mask on the
// plate would fade the plate's own fill too.

var $gSI3w = parcelRequire("gSI3w");
const $1c79182ad76f6a48$export$78f3f1f0f5847d04 = {
    theme: 'pill',
    round: 'radiusPill',
    padding: 'X',
    maxWidth: '100%',
    minWidth: '0',
    hide: (el, s)=>!el.call('assistantBoardChipsOpen', s.root),
    // The group row: the kit's choice chips (auto-extended by key) as the
    // shared edge-fade row.
    AppChoiceChips: {
        ...(0, $gSI3w.AppScrollRow),
        ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantBoard.threads'),
        flexWrap: 'nowrap',
        maxWidth: '100%',
        scrollSnapType: 'x proximity',
        // AppChoiceGroup's row shape (optionValue / optionLabel), read straight from
        // root state so the row follows every new board.
        children: (el, s)=>el.call('assistantBoardChips', s.root).map((c)=>({
                    key: 'opt-' + c.value,
                    optionValue: c.value,
                    optionLabel: c.label,
                    optionPrompt: c.prompt
                })),
        childProps: {
            flexShrink: '0',
            scrollSnapAlign: 'start',
            title: (el)=>el.optionPrompt || null,
            isActive: (el, s)=>{
                const vm = el.call('assistantBoardViewModel', s.root);
                return !!vm && !vm.dismissed && vm.boardId === el.optionValue;
            },
            ariaPressed: (el, s)=>{
                const vm = el.call('assistantBoardViewModel', s.root);
                return vm && !vm.dismissed && vm.boardId === el.optionValue ? 'true' : 'false';
            },
            onClick: (e, el)=>el.call('assistantBoardShow', el.optionValue)
        }
    }
};

});

parcelRegister("8hI2P", function(module, exports) {

$parcel$export(module.exports, "AssistantMainThread", () => $608213999d66a03c$export$265c6c4bec8f4673);
$parcel$export(module.exports, "AssistantThreadRow", () => $608213999d66a03c$export$5087aeda78a2d201);
// THE MAIN THREAD — the assistant's conversation as a VIEW of the main area
// (AI_ASSISTANT_SPEC v1 §1 + §8, v1.1 §12.2; Nika's pick 6 A "reading column +
// wide blocks", the DEFAULT placement — everywhere since 2026-09-29).
//
// It is the SAME thread the sidebar shows — the general-scope conversation
// (`root.chatMessages`), rendered by the shared chat's own row (ChatMessage,
// reused by bare key) — laid over the main area like the generated board: on
// the HOME over the grid area (pages/main.js mounts it as the grid's last
// child; the cards step under the view — inert, faded, functions/
// assistantBoard.js `assistantBoardOpen`), on EVERY OTHER route over the page
// sheet (components/AssistantMainLayer.js mounts the same view; the page stays
// mounted underneath). Nothing on the page moves (Rule 66: closed keeps the
// box, only opacity and visibility change). Text reads in a column
// (`maxWidth: 'I'`, about 750 px) centred on the area; the WIDE blocks — an
// answer view, a records block, a board, an app preview — take the full width
// in their own row (functions/assistantMainThread.js `assistantThreadRows`).
// Follow-ups append below. An opener with nothing in the conversation yet
// shows the empty thread's one-line hint above the composer. "Open in
// sidebar" moves the SAME thread to the docked panel.
//
// Every value comes from functions/assistantMainThread.js through `el.call`;
// the component holds no logic of its own.
const $608213999d66a03c$export$265c6c4bec8f4673 = {
    tag: 'section',
    role: 'region',
    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantThread.region'),
    // The shared chat rows resolve their thread by walking up for `chatScope`.
    chatScope: 'general',
    dataOpen: (el, s)=>el.call('assistantMainThreadOpen', s.root) ? 'true' : 'false',
    ariaHidden: (el, s)=>el.call('assistantMainThreadOpen', s.root) ? null : 'true',
    ariaBusy: (el, s)=>s.root && s.root.chatTyping ? 'true' : null,
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    // ONE column with the board: the head and the rows sit on the home grid's
    // own width (`--home-grid-w`, pages/main.js _injectWidgetStyles), centred.
    width: '100%',
    maxWidth: 'var(--home-grid-w, 100%)',
    marginInline: 'auto',
    minWidth: '0',
    boxSizing: 'border-box',
    // CLEAR OF THE COMPOSER (Nika 2026-09-30: "give bottom padding so it can
    // have spacing and canvas promptarea does not overlap"). On the home the
    // thread lies over the grid area and scrolls with the page column down to
    // the viewport bottom, where the composer floats: the bottom inset is the
    // composer's LIVE clearance (`--prompt-clear`, the shell's ONE measurement —
    // a ResizeObserver on CanvasPromptTextarea, app.js: autoGrow, the expanded
    // floor, multi-line drafts and the minimize all move it), the phone chip
    // row above it (`--chip-row`, 0 off phones) and one row gap, so at the end
    // of the scroll the last message stands one gap above the composer at any
    // composer height. Over a page the layer's band already ends above the
    // composer (components/AssistantMainLayer.js), which zeroes this there.
    paddingBottom: 'calc(var(--prompt-clear) + var(--chip-row) + var(--spacing-B))',
    // The crossfade (the board's recipe): `C`, opacity only; closed keeps the
    // box and hides after the fade, open shows at once and fades in.
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open="true"]': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    // The flag can only be up with the main placement, on the route the thread
    // opened on: a placement change or a navigation clears it
    // (assistantMainThreadSync), the home going away clears it on the way out.
    // Esc joins the shell keyboard registry while the view is on the page.
    // SPLIT VIEW: a page sheet that opens over the thread on a wide screen
    // moves the conversation beside it (functions/assistantAskRoute.js
    // assistantThreadBesidePane) — never under it, closed by the next ask.
    subscribeTo: [
        'assistantDock',
        'currentPath',
        '_mainThreadPath',
        '_canvasSlot',
        '_canvasSlotSecond'
    ],
    onMounted: (el)=>el.call('assistantMainThreadShortcuts', el),
    onUpdate: (el, s)=>{
        el.call('assistantMainThreadSync', s.root);
        el.call('assistantThreadBesidePane', s.root);
    },
    // A NEW QUESTION comes to the top of the view, once (Nika 2026-10-23: "when
    // answering in new section always scroll top of that section"): its row
    // lands under the header and the answer reads down from it — never a chase
    // of the stream's bottom (functions/assistantReveal.js). The question is
    // the thread's last row, so the view takes the room it needs below it (its
    // `minHeight` here) and keeps it while the answer fills it in. Only a
    // question ASKED now counts — the count grows with a turn starting (the
    // send writes both at once); opening a conversation moves nothing, and
    // another conversation, a new chat or a deleted one gives the room back.
    minHeight: (el, s)=>el.call('assistantRevealRoom', el, s.root, el.call('assistantMainThreadOpen', s.root)),
    stateDeps: [
        (el, s)=>(el.call('assistantThreadAsks', s.root) || {}).count || 0,
        (el, s)=>(el.call('assistantThreadAsks', s.root) || {}).first || null
    ],
    onStateUpdate: (el, s, ctx, change)=>{
        const prev = change && change.prev || [];
        const next = change && change.next || [];
        const asked = (Number(next[0]) || 0) > (Number(prev[0]) || 0) && !!(s.root && s.root.chatTyping);
        if (asked && el.call('assistantMainThreadOpen', s.root)) {
            const ask = el.call('assistantThreadAsks', s.root) || {};
            if (ask.key) el.call('assistantRevealTop', el, ask.key, 'ask:' + ask.key);
            return;
        }
        if (prev[0] !== next[0] || prev[1] !== next[1]) el.call('assistantRevealRoomClear', el);
    },
    onBeforeRemove: (el, s)=>{
        if (typeof el.__threadShortcutsOff === 'function') el.__threadShortcutsOff();
        const root = s && s.root;
        if (root && root._homeThreadOpen === true && typeof root.update === 'function') root.update({
            _homeThreadOpen: false,
            _mainThreadPath: null
        }, {
            preventFetch: true
        });
    },
    ThreadHead: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        // ON THE CONVERSATION'S COLUMN: the reading column's width and centring
        // (ThreadReading below). Across the whole grid the label stood 561px left
        // of the first message on a wide view (measured live 2026-10-18).
        width: '100%',
        maxWidth: 'I',
        marginInline: 'auto',
        AppMicroLabel: {
            dataThreadMicro: true,
            whiteSpace: 'normal',
            text: (el, s)=>el.call('assistantThreadMicro', s.root)
        },
        ThreadActions: {
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center',
            gap: 'Y',
            // Ends on the column's end where the bubbles end — also when a phone
            // wraps it under the label (design-direction §3: a lone action in a
            // space-between row takes `marginLeft: 'auto'`).
            marginLeft: 'auto',
            AppCapsuleBtnToolbar: {
                compact: true,
                dataThreadToSidebar: true,
                text: '{{ workspace.assistantThread.openInSidebar | polyglot }}',
                onClick: (e, el)=>el.call('assistantThreadToSidebar')
            },
            // The ONE square button of the head: back to the home board, or to the
            // page under the thread. Its name is this view's verb: only the brand's
            // own `attr` key replaces the brand default (the board view's measured
            // note).
            CloseButton: {
                dataThreadClose: true,
                attr: {
                    'aria-label': (el, s)=>el.call('polyglot', el.call('assistantMainHost', s && s.root) === 'over' ? 'workspace.assistantThread.closeToPage' : 'workspace.assistantThread.close')
                },
                onClick: (e, el)=>el.call('assistantMainThreadClose', {
                        focusComposer: true
                    })
            }
        }
    },
    // A link to a conversation this person cannot read: the view says so
    // (components/AssistantThreadUnavailable.js; the thread URL, `?ai=<id>`).
    AssistantThreadUnavailable: {},
    // CHAT'S START (the home's Chat tab, Nika 2026-10-23: "draw related
    // experience for each tab aligning AI mode"): the empty conversation
    // offers the workspace's own starters (components/HomeTabStart.js, tab
    // 'chat'); the one line below still points at the composer.
    HomeTabStart_chat: {
        tab: 'chat'
    },
    // The empty thread (an opener in Page mode with nothing asked yet): one
    // line that points at the composer below — never a made-up question.
    ThreadEmpty: {
        tag: 'p',
        dataThreadEmpty: true,
        hide: (el, s)=>{
            const list = s && s.root && s.root.chatMessages;
            return Array.isArray(list) && list.length > 0;
        },
        margin: '0',
        maxWidth: 'I',
        marginInline: 'auto',
        fontSize: 'A',
        color: 'caption',
        textAlign: 'center',
        text: '{{ workspace.assistantThread.emptyHint | polyglot }}'
    },
    ThreadRows: {
        scope: {
            threadRows: []
        },
        dataThreadRows: true,
        flow: 'y',
        gap: 'B',
        minWidth: '0',
        // Declared (FA515): the rows re-derive on every thread write — a send, a
        // streamed delta, a card attached.
        childrenDeps: [
            'chatMessages'
        ],
        children: (el, s)=>el.call('assistantThreadRows', s.root.chatMessages, el.scope),
        childrenAs: 'state',
        childExtends: 'AssistantThreadRow'
    }
};
const $608213999d66a03c$export$5087aeda78a2d201 = {
    tag: 'article',
    dataThreadRow: (el, s)=>s && s.key || null,
    dataRole: (el, s)=>s && s.role || null,
    flow: 'y',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    // brought to the top as a new question (AssistantMainThread's reveal), it
    // stays clear of the shell's floating header — the Fly page's own margin
    scrollMarginTop: 'calc(var(--shell-top) + var(--spacing-A))',
    ThreadReading: {
        width: '100%',
        maxWidth: 'I',
        marginInline: 'auto',
        minWidth: '0',
        // the first workspace thread's plan, above the summary it rides with
        // (functions/workspaceSetup.js): no card on any other row
        WorkspaceSetupPlanSlot: {
            planOf: 'row',
            marginBottom: 'Z'
        },
        ChatMessage: {}
    },
    ThreadWide: {
        dataThreadWide: true,
        hide: (el, s)=>!(s && Array.isArray(s._wide) && s._wide.length),
        flow: 'y',
        gap: 'Z',
        width: '100%',
        minWidth: '0',
        childExtends: 'ChatCard',
        childrenAs: 'state',
        children: (el, s)=>s && Array.isArray(s._wide) ? s._wide : []
    }
};

});

parcelRegister("34R2l", function(module, exports) {

$parcel$export(module.exports, "AssistantMainLayer", () => $23dae2d7a2201f94$export$fbe4a22cbba9c933);
// THE MAIN AREA OVER A PAGE (AI_ASSISTANT_SPEC v1.1 §12.2; Nika 2026-09-29
// "make main thread ai as default" — main thread = "Everywhere").
//
// With the main placement, a send on ANY route opens the answer in the main
// area. On the home that area is the widget grid (pages/main.js mounts the
// views there). On every other route it is THIS layer: one sheet over the
// page's own sheet — the same band (`--slot-top` to `--slot-bottom`, the X2
// gutters, clear of the module rail), the same ground and the same float the
// PageSlot pane wears — holding the SAME views: the main thread, a
// generated board, a live deck, the fly canvas. ONE view at a time, like on
// the home.
//
// The page stays MOUNTED underneath and keeps its state (its scroll, its open
// panes, its drafts); while the layer is up the shell's stylesheet hides the
// page sheet from the eye, the pointer, the Tab order and assistive
// technology (app.js, the `AssistantMainLayer` rule), and the shell's overlay
// reader names the layer as the top layer (`shellOverlayOpen` → 'mainThread'),
// so a page's own Escape stands down: ONE Escape closes the thread and the
// page is back — a second one reaches the page. A page SHEET opened in the
// PageSlot sits above the layer (z 1300 over 1250); the composer stays above
// both (1400).
//
// The layer holds no logic: its gate is functions/assistantMainThread.js
// `assistantMainLayerShown`; each view gates, crossfades and closes itself.
// Rule 66: closed keeps the box — only opacity and visibility change.
const $23dae2d7a2201f94$export$fbe4a22cbba9c933 = {
    dataMainLayer: true,
    dataOpen: (el, s)=>el.call('assistantMainLayerShown', s.root) ? 'true' : 'false',
    ariaHidden: (el, s)=>el.call('assistantMainLayerShown', s.root) ? null : 'true',
    // The page sheet's band: the live-measured gaps to the header and to the
    // composer, the X2 gutters, beside the module rail when one renders. The
    // bottom edge also clears the phone suggestion chip row (`--chip-row`, 0
    // off phones — the shell's other bottom-docked islands do the same), so the
    // band's foot is never under the chips or the composer at any composer
    // height: `--slot-bottom` is the composer's live clearance + the nav gap.
    position: 'fixed',
    zIndex: '1250',
    top: '--slot-top',
    bottom: 'calc(var(--slot-bottom) + var(--chip-row))',
    // `--module-rail-clear` is registered with a 0 initial value (app.js).
    left: 'calc(var(--module-rail-clear) + var(--spacing-X2))',
    right: 'X2',
    // The page sheet's ground and elevation: the content-surface pair (the
    // frame pair AppMain paints — gray2 dark, gray16 light), the brand
    // `pane-ground` theme for the inks, the one float shadow, the sheet radius.
    // `--stage-bg` dissolves inside, like in the PageSlot pane: a view's own
    // `var(--stage-bg, …)` paint is the layer's ground, never a second sheet.
    background: 'gray2',
    '@light': {
        background: 'gray16'
    },
    style: {
        '--stage-bg': 'transparent'
    },
    theme: 'pane-ground',
    borderWidth: '0',
    shadow: 'float',
    round: 'radiusSheet',
    display: 'flex',
    flexDirection: 'column',
    padding: 'C B',
    overflow: 'auto',
    overscrollBehavior: 'contain',
    boxSizing: 'border-box',
    // The views' crossfade: `C`, opacity only; closed keeps the box and hides
    // after the fade, open shows at once and fades in.
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open="true"]': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    // Phones: the page sheet's own posture — full-bleed sides, only the top
    // corners round; the composer below stays reachable.
    '@mobileL': {
        left: '0',
        right: '0',
        padding: 'B A',
        round: 'radiusSheet radiusSheet 0 0'
    },
    subscribeTo: [
        'currentPath',
        'assistantDock',
        '_homeThreadOpen',
        '_mainThreadPath',
        '_aiBoard',
        '_aiDeck',
        '_aiFly',
        // the call's theater (meet functions/meetFly.js)
        'meetFly',
        'meetView',
        'livekitConnected'
    ],
    // The same views the home mounts in its grid area — each gates,
    // crossfades and closes itself. ONE view holds the layer at a time, so a
    // closed view takes no height here (the open one is the scroll height; on
    // the home the grid below keeps its own box instead).
    childProps: {
        flexShrink: '0',
        '&:not([data-open="true"])': {
            height: '0',
            minHeight: '0',
            overflow: 'hidden'
        }
    },
    // `mainHost: 'over'` — each view's keyboard rows keep their own ids here
    // (functions/assistantMainThread.js assistantMainThreadShortcuts). The
    // views exist here only OFF the home (`if:` — none of them declares its own,
    // so this gate replaces nothing): on the home the grid area's views are the
    // ones on screen, and a second copy would mount the same widget bodies and
    // rows twice behind a closed layer.
    // The thread's own composer inset is the HOME's (it scrolls with the page
    // column there); here the band already ends above the composer and the
    // layer's padding is the gap, so a second inset would only push the last
    // message away from the composer.
    AssistantMainThread: {
        mainHost: 'over',
        paddingBottom: '0',
        if: (el, s)=>el.call('assistantMainHost', s.root) === 'over'
    },
    // The board's own stack inset is the home's too (it lies over the grid, out
    // of the flow); here the band ends above the stack, as for the thread.
    AssistantBoardView: {
        mainHost: 'over',
        paddingBottom: '0',
        if: (el, s)=>el.call('assistantMainHost', s.root) === 'over'
    },
    AssistantDeckView: {
        mainHost: 'over',
        if: (el, s)=>el.call('assistantMainHost', s.root) === 'over'
    },
    // FLY MODE's canvas (functions/assistantFly.js) over the page.
    AssistantFlyView: {
        mainHost: 'over',
        if: (el, s)=>el.call('assistantMainHost', s.root) === 'over'
    },
    // A CALL's theater (components/AssistantFlyCallView.js): the call's Fly
    // pages over the call itself, which minimizes into the dock.
    AssistantFlyCallView: {
        mainHost: 'over',
        if: (el, s)=>el.call('assistantMainHost', s.root) === 'over'
    }
};

});

parcelRegister("lBdaZ", function(module, exports) {

$parcel$export(module.exports, "AssistantThreadUrlSync", () => $fb974639fab85c8b$export$2c26a518376149ae);
// AssistantThreadUrlSync — the invisible shell-root sentinel that keeps the
// address bar and the main thread in step: every main-thread conversation has
// its own URL, `?ai=<conversationId>` (Nika 2026-09-30; the whole rule lives in
// functions/assistantThreadUrl.js).
//
// It holds no logic. It names the keys the reconcile reads and runs it when
// one of them moves — `subscribeTo` + `onUpdate`, the shell's reliable
// route-reactive path (the ShellRouteSync / ShellSkinSync sentinels in app.js
// are the same shape):
//   • the thread — its flag, the route it opened on, its conversation;
//   • the placement, and the page sheet that covers the main area;
//   • the route — `_routeNudge` moves on EVERY navigation the router makes, a
//     query-only one and Back / Forward included;
//   • the AI service and the workspace a link waits for.
// One instance, mounted at the shell root (app.js), so it lives on every route
// and across a workspace switch — the reconcile keeps the thread it last saw
// open on THIS element (`el.__aiThreadAgreed`), where no state wipe reaches.
const $fb974639fab85c8b$export$2c26a518376149ae = {
    tag: 'div',
    display: 'none',
    subscribeTo: [
        '_homeThreadOpen',
        '_mainThreadPath',
        'activeSessionId',
        'assistantDock',
        '_canvasSlot',
        '_canvasSlotSecond',
        'currentPath',
        '_routeNudge',
        '_aiSvcReady',
        'workspace'
    ],
    onCreate: (el)=>el.call('assistantThreadUrlReconcile'),
    onUpdate: (el)=>el.call('assistantThreadUrlReconcile')
};

});

parcelRegister("6Yw6V", function(module, exports) {

$parcel$export(module.exports, "AssistantThreadUnavailable", () => $51414132c56531ea$export$68401f254feb553b);
// AssistantThreadUnavailable — the thread view's "not available" line. The
// address bar names a conversation this person cannot read (private, deleted,
// another workspace's — the server answers the same 404 for each), so the
// view shows NO rows and says so. It stands in the empty thread's reading
// column, above the hint that points at the composer: the next question
// starts a new conversation, and takes this line away with the hint.
//
// Mounted by bare key in components/AssistantMainThread.js. Kept mounted and
// only hidden (Rule 66); an alert, so the state is announced when it shows.
// functions/assistantThreadUrl.js `assistantThreadUnavailable` holds the rule.
const $51414132c56531ea$export$68401f254feb553b = {
    tag: 'p',
    role: 'alert',
    dataThreadUnavailable: true,
    hide: (el, s)=>!el.call('assistantThreadUnavailable', s && s.root),
    margin: '0',
    maxWidth: 'I',
    marginInline: 'auto',
    fontSize: 'A',
    color: 'title',
    textAlign: 'center',
    text: '{{ workspace.simone.threadUnavailable | polyglot }}'
};

});

parcelRegister("lDFKp", function(module, exports) {

$parcel$export(module.exports, "WorkspaceSetupGate", () => $fc0d9fa8e001a239$export$5154fdd7766a63cb);
// THE SETUP'S GATE on the app builder (functions/workspaceSetup.js — the
// workspace builds itself in front of the person, lane WS1). A display:none
// div whose job is a reactive check, the shape of OnboardingGate: on mount it
// reads Fly's hand-over mark, then every change it follows runs the setup's
// prime — the read and its poll, the navigation refresh as apps land, the
// first thread, the first build. A tab that comes back from hidden asks again
// at once (the poll asks nothing while the tab is hidden).
//
// It sits on the builder PAGE (pages/add-app.js), so its scope is the page's:
// `addAppThreadInUrl: false` says the builder is the home's Build tab, not the
// route (functions/homeBuild.js).
const $fc0d9fa8e001a239$export$5154fdd7766a63cb = {
    tag: 'div',
    display: 'none',
    ariaHidden: 'true',
    subscribeTo: [
        'workspace',
        'workspaceReady',
        'user',
        'userPrefs',
        'bridgeStatus',
        '_workspaceSetup',
        '_ax_activeSessionId',
        '_addAppProjectId',
        '_creditGuard',
        '_wsAppsCatalog'
    ],
    onCreate: (el, s)=>el.call('workspaceSetupPrime', el, s),
    onUpdate: (el, s)=>el.call('workspaceSetupPrime', el, s),
    onDocumentVisibilityChange: (e, el, s)=>el.call('workspaceSetupPrime', el, s, {
            wake: true
        })
};

});

parcelRegister("kL51S", function(module, exports) {

$parcel$export(module.exports, "WorkspaceSetupThread", () => $f1cc19227a4614a2$export$2dbf587a3c960d17);
// THE WORKSPACE BUILDS ITSELF — the head of the first workspace thread on the
// app builder (functions/workspaceSetup.js; lane WS1, Nika's decisions 9 and
// 11). It stands above the thread's messages (pages/add-app.js Chat.Messages):
//
//   the plan card   the plan note, in the shell's language
//                   (components/WorkspaceSetupPlan.js)
//   the setup       one line per step as it lands — the apps in install
//                   order, each in the navigation once done — the reason of a
//                   failed line in words and one Try again (owner / admin),
//                   the website card, the credits, the first build, and one
//                   way back to the site the person came from
//
// The summary note is the thread's first message under it (plain text, the
// shared chat's own row), then the person's first build.
//
// It holds no logic: every value comes from workspaceSetupView /
// workspaceSetupPlanView through `el.call`. Hidden on any other thread.
// Kept mounted and only hidden (Rule 66): the block appears once, when the
// thread opens, and its lines grow in place.
const $f1cc19227a4614a2$export$2dbf587a3c960d17 = {
    tag: 'section',
    dataSetupThread: true,
    flow: 'y',
    gap: 'A',
    minWidth: '0',
    marginBottom: 'A',
    hideDeps: [
        (el, s)=>s.root && s.root._workspaceSetup,
        (el, s)=>s.root && s.root._ax_activeSessionId,
        (el, s)=>s.root && s.root._ax_chatMessages
    ],
    hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).show && !el.call('workspaceSetupPlanOf', s.root && s.root._ax_chatMessages),
    WorkspaceSetupPlanSlot: {
        planOf: 'thread'
    },
    SetupBlock: {
        role: 'status',
        ariaLive: 'polite',
        dataSetupStatus: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).status || null,
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        boxSizing: 'border-box',
        padding: 'A',
        round: 'radiusCard',
        theme: 'layer',
        color: 'title',
        hideDeps: [
            (el, s)=>s.root && s.root._workspaceSetup,
            (el, s)=>s.root && s.root._ax_activeSessionId
        ],
        hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).show,
        SetupTitle: {
            tag: 'h3',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '700',
            lineHeight: '1.3',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).title || ''
        },
        // the wizard's own setup lines (components/OnboardingStackStep.js
        // OnboardingSetupLine): the glyph, the name, then what happened to it
        SetupLines: {
            tag: 'ul',
            margin: '0',
            padding: '0',
            listStyle: 'none',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F2)), 1fr))',
            gap: 'Y Z',
            minWidth: '0',
            childExtends: 'OnboardingSetupLine',
            childrenAs: 'state',
            childrenDeps: [
                (el, s)=>s.root && s.root._workspaceSetup,
                (el, s)=>s.root && s.root._wsAppsCatalog
            ],
            children: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).lines || []
        },
        SetupFail: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z',
            lineHeight: '1.5',
            color: 'dangerInk',
            hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).failText,
            text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).failText || ''
        },
        AppCapsuleBtnGhost: {
            dataSetupAction: 'retry',
            compact: true,
            alignSelf: 'flex-start',
            hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).retryable,
            disabled: (el, s)=>!!(el.call('workspaceSetupView', s.root) || {}).retrying,
            text: '{{ marketplace.preset.tryAgain | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('workspaceSetupRetry');
            }
        },
        // the website card: its name, and the canvas where Publish is
        SetupSite: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            minWidth: '0',
            boxSizing: 'border-box',
            padding: 'Z Z Z A',
            round: 'radiusCard',
            theme: 'layer',
            hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).siteShow,
            SetupSiteName: {
                flow: 'x',
                align: 'center',
                gap: 'Y',
                minWidth: '0',
                Icon: {
                    ariaHidden: 'true',
                    name: 'globe',
                    boxSize: 'iconSm',
                    flexShrink: '0'
                },
                SetupSiteTitle: {
                    tag: 'span',
                    minWidth: '0',
                    fontSize: 'Z2',
                    fontWeight: '500',
                    lineHeight: '1.3',
                    overflowWrap: 'anywhere',
                    text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).siteTitle || ''
                }
            },
            AppCapsuleBtnToolbar: {
                dataSetupAction: 'site',
                compact: true,
                flexShrink: '0',
                text: '{{ workspace.firstRun.publish.action | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('workspaceSetupOpenSite', el);
                }
            }
        },
        SetupCredits: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z',
            lineHeight: '1.5',
            color: 'caption',
            hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).creditsShow,
            text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).creditsText || ''
        },
        // the first build: what happens next, and the one press it waits on —
        // Build (credits, no waiver) or the claim / top-up page (no credits; the
        // build then goes once they arrive)
        SetupBuild: {
            flow: 'x',
            align: 'center',
            flexWrap: 'wrap',
            gap: 'Z',
            minWidth: '0',
            hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).buildShow,
            SetupBuildText: {
                tag: 'p',
                margin: '0',
                flex: '1 1 auto',
                minWidth: '0',
                fontSize: 'Z2',
                lineHeight: '1.5',
                color: 'title',
                text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).buildText || ''
            },
            AppCapsuleBtnPrimary: {
                dataSetupAction: 'build',
                compact: true,
                hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).buildAction,
                text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).buildAction || '',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('workspaceSetupBuildPress', s.root);
                }
            },
            AppCapsuleBtnToolbar: {
                dataSetupAction: 'claim',
                compact: true,
                hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).claimShow,
                text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).claimText || '',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('workspaceSetupBuildPress', s.root);
                    el.call('openInSlot', '/admin/usage', el);
                }
            }
        },
        // the way back: the site the person came from (a platform host), in a
        // new tab — the workspace stays where it is
        Link: {
            dataSetupAction: 'back',
            alignSelf: 'flex-start',
            flow: 'x',
            align: 'center',
            gap: 'X',
            fontSize: 'Z',
            lineHeight: '1.5',
            color: 'caption',
            textDecoration: 'none',
            target: '_blank',
            rel: 'noopener',
            ':hover': {
                color: 'title',
                textDecoration: 'underline'
            },
            ':active': {
                color: 'title'
            },
            hide: (el, s)=>!(el.call('workspaceSetupView', s.root) || {}).backShow,
            href: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).backHref || null,
            Icon: {
                ariaHidden: 'true',
                name: 'arrowUpRight',
                boxSize: 'iconXs',
                flexShrink: '0'
            },
            SetupBackText: {
                tag: 'span',
                text: (el, s)=>(el.call('workspaceSetupView', s.root) || {}).backText || ''
            }
        }
    }
};

});

parcelRegister("j5cJe", function(module, exports) {

$parcel$export(module.exports, "WorkspaceSetupPlan", () => $de485b932091b96b$export$be8e1470bc462afe);
$parcel$export(module.exports, "WorkspaceSetupPlanApp", () => $de485b932091b96b$export$5a85fe5c274d90d0);
$parcel$export(module.exports, "WorkspaceSetupPlanSlot", () => $de485b932091b96b$export$12920f77a7d935c3);
// THE PLAN CARD — the first workspace thread's plan note (server lane S1: an
// assistant note with `metadata: { kind: 'note', note: 'plan', plan }`, the
// Blueprint snapshot, no words of its own). The shell writes the card in its
// own language: the company and its line, the industry and the team, the apps
// by the App Store's names, the website, the idea (functions/workspaceSetup.js
// workspaceSetupPlanView). Nika 2026-10-25 decision 11: the first thread
// holds the plan, the summary of the site conversation and the first build.
//
// Two places draw it, through one slot (WorkspaceSetupPlanSlot):
//   planOf: 'thread'  the app builder's thread — the plan of the rows it holds
//                     (components/WorkspaceSetupThread.js, above the messages)
//   planOf: 'row'     one main-thread row — the row's own note
//                     (components/AssistantMainThread.js)
// The card itself reads only its own state (every key always present).
// One card: a quiet kicker, the company's name and line, the facts, the apps
// as a row of named chips, the website and the idea.
const $de485b932091b96b$export$be8e1470bc462afe = {
    tag: 'article',
    dataSetupPlan: true,
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'A',
    round: 'radiusCard',
    theme: 'layer',
    color: 'title',
    ariaLabel: (el, s)=>s && s.title || null,
    SetupPlanKicker: {
        tag: 'span',
        fontSize: 'Z',
        fontWeight: '500',
        lineHeight: '1.3',
        color: 'caption',
        text: (el, s)=>s && s.title || ''
    },
    SetupPlanName: {
        tag: 'h3',
        margin: '0',
        fontSize: 'A',
        fontWeight: '700',
        lineHeight: '1.3',
        color: 'title',
        overflowWrap: 'anywhere',
        hide: (el, s)=>!(s && s.name),
        text: (el, s)=>s && s.name || ''
    },
    SetupPlanTagline: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        overflowWrap: 'anywhere',
        hide: (el, s)=>!(s && s.tagline),
        text: (el, s)=>s && s.tagline || ''
    },
    SetupPlanFacts: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'caption',
        hide: (el, s)=>!(s && s.facts),
        text: (el, s)=>s && s.facts || ''
    },
    SetupPlanAppsLabel: {
        tag: 'span',
        fontSize: 'Z',
        fontWeight: '500',
        lineHeight: '1.3',
        color: 'caption',
        hide: (el, s)=>!(s && s.appsText),
        text: (el, s)=>s && s.appsText || ''
    },
    SetupPlanApps: {
        tag: 'ul',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'Y',
        minWidth: '0',
        hide: (el, s)=>!(s && Array.isArray(s.apps) && s.apps.length),
        childExtends: 'WorkspaceSetupPlanApp',
        childrenAs: 'state',
        children: (el, s)=>s && Array.isArray(s.apps) ? s.apps : []
    },
    SetupPlanSite: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'title',
        overflowWrap: 'anywhere',
        hide: (el, s)=>!(s && s.siteText),
        text: (el, s)=>s && s.siteText || ''
    },
    SetupPlanIdea: {
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        hide: (el, s)=>!(s && s.idea),
        SetupPlanIdeaLabel: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '500',
            lineHeight: '1.3',
            color: 'caption',
            text: (el, s)=>s && s.ideaLabel || ''
        },
        SetupPlanIdeaText: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z2',
            lineHeight: '1.5',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.idea || ''
        }
    }
};
const $de485b932091b96b$export$5a85fe5c274d90d0 = {
    tag: 'li',
    display: 'flex',
    alignItems: 'center',
    gap: 'X',
    minWidth: '0',
    padding: 'X Z',
    round: 'radiusPill',
    theme: 'layer',
    color: 'title',
    fontSize: 'Z',
    lineHeight: '1.3',
    Icon: {
        ariaHidden: 'true',
        name: (el, s)=>s && s.icon || 'blocks',
        boxSize: 'iconXs',
        flexShrink: '0'
    },
    SetupPlanAppName: {
        tag: 'span',
        minWidth: '0',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.title || ''
    }
};
const $de485b932091b96b$export$12920f77a7d935c3 = {
    flow: 'y',
    minWidth: '0',
    planOf: 'thread',
    hideDeps: [
        (el, s)=>el.planOf === 'row' ? s && s.metadata : s.root && s.root._ax_chatMessages
    ],
    hide: (el, s)=>!(el.planOf === 'row' ? s && s.metadata && s.metadata.kind === 'note' && s.metadata.plan : el.call('workspaceSetupPlanOf', s.root && s.root._ax_chatMessages)),
    childExtends: 'WorkspaceSetupPlan',
    childrenAs: 'state',
    childrenDeps: [
        (el, s)=>el.planOf === 'row' ? s && s.metadata : s.root && s.root._ax_chatMessages,
        (el, s)=>s.root && s.root._wsAppsCatalog,
        (el, s)=>s.root && s.root._wsAppsCatalogLoaded
    ],
    children: (el, s)=>{
        const plan = el.planOf === 'row' ? s && s.metadata && s.metadata.kind === 'note' && s.metadata.plan ? s.metadata.plan : null : el.call('workspaceSetupPlanOf', s.root && s.root._ax_chatMessages);
        const view = plan ? el.call('workspaceSetupPlanView', plan) : null;
        return view && view.show ? [
            {
                key: 'setup-plan-card',
                ...view
            }
        ] : [];
    }
};

});

parcelRegister("5lBo0", function(module, exports) {

$parcel$export(module.exports, "AssistantDeckView", () => $3e4bea06de1fda1c$export$93080e922aa4d50d);
$parcel$export(module.exports, "AssistantDeckSlide", () => $3e4bea06de1fda1c$export$f0d5b770a2f31fec);
$parcel$export(module.exports, "AssistantDeckCard", () => $3e4bea06de1fda1c$export$a5fe3c1b1cb7b98b);
$parcel$export(module.exports, "AssistantDeckPresenter", () => $3e4bea06de1fda1c$export$4c33b000b619fa07);
// THE LIVE DECK — Presentation mode's answer as a VIEW of the main area
// (AI_ASSISTANT_SPEC v1.1 §12.1–§12.2; the ai.boards DECK contract v1). Nika
// 2026-09-29: Presentation = "Live deck in thread".
//
// A title slide, then the content slides — ONE slide on the stage at a time,
// Previous / Next under it (and ← / → while the view shows), a counter, and
// three verbs in the head: Present (the full-viewport presenter,
// AssistantDeckPresenter below), Save (the saved boards row, kind 'deck') and
// the ONE square close. A content slide is a headline (+ subtitle) and one or
// two LIVE cards — the board's own card (AssistantBoardCard, reused through
// AssistantDeckCard), so a slide mounts an installed app's widget with its
// params or a records block whose rows come from the SDK, never a number the
// model wrote — and the speaker notes under it.
//
// It lays over the main area like the generated board: on the home over the
// grid area (pages/main.js), on every other route in the page layer
// (components/AssistantMainLayer.js). It gates and crossfades itself (Rule 66:
// closed keeps the box, only opacity and visibility change); the slide on the
// stage fades in when it changes. States: building (a skeleton slide, the
// slides join as they stream), ready, failed (one sentence + Try again), not
// available here (an older SDK or server — one sentence, no call made), an
// empty slide (its items cannot be mounted here — one sentence).
//
// Every value comes from functions/assistantDeck.js through `el.call`.
const $3e4bea06de1fda1c$export$93080e922aa4d50d = {
    tag: 'section',
    role: 'region',
    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantDeck.region'),
    ariaRoledescription: (el)=>el.call('polyglot', 'workspace.assistantDeck.roleDescription'),
    dataOpen: (el, s)=>el.call('assistantDeckShown', s.root) ? 'true' : 'false',
    dataStatus: (el, s)=>{
        const vm = el.call('assistantDeckViewModel', s.root);
        return vm && vm.status || 'idle';
    },
    ariaHidden: (el, s)=>el.call('assistantDeckShown', s.root) ? null : 'true',
    ariaBusy: (el, s)=>{
        const vm = el.call('assistantDeckViewModel', s.root);
        return vm && (vm.status === 'loading' || vm.status === 'streaming') ? 'true' : null;
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    // ONE column with the board: the home grid's own width on the home, the
    // layer's width over a page.
    width: '100%',
    maxWidth: 'var(--home-grid-w, 100%)',
    marginInline: 'auto',
    minWidth: '0',
    boxSizing: 'border-box',
    // brought to the top as a new deck (below), it stays clear of the shell's
    // floating header — the Fly page's own margin
    scrollMarginTop: 'calc(var(--shell-top) + var(--spacing-A))',
    // The crossfade (the board's recipe): `C`, opacity only.
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open="true"]': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    // Esc and ← / → join the shell keyboard registry while the view is on the
    // page; the installed apps publishing re-derive the slides.
    subscribeTo: [
        'workspace',
        'workspaceApps',
        'workspaceProject'
    ],
    onMounted: (el)=>el.call('assistantDeckShortcuts', el),
    onUpdate: (el, s)=>el.call('assistantDeckRederive', s && s.root),
    // A NEW DECK — an ask, a refine, a saved deck opened — comes to the top of
    // the view, once per request (Nika 2026-10-23: "when answering in new
    // section always scroll top of that section"; functions/assistantReveal.js).
    // A view shorter than the scroller takes the room it needs (its
    // `minHeight`), while it is on screen.
    minHeight: (el, s)=>el.call('assistantRevealRoom', el, s.root, el.call('assistantDeckShown', s.root)),
    stateDeps: [
        (el, s)=>{
            const d = s.root && s.root._aiDeck;
            return d && (d.requestId || d.id) ? String(d.requestId || d.id) : null;
        }
    ],
    onStateUpdate: (el, s, ctx, change)=>{
        const next = (change && change.next || [])[0];
        if (next && el.call('assistantDeckShown', s.root)) el.call('assistantRevealTop', el, null, 'deck' + next);
    },
    onRemove: (el)=>{
        if (typeof el.__deckShortcutsOff === 'function') el.__deckShortcutsOff();
    },
    DeckHead: {
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        // The greeting line's type, like the board's title; a reading position
        // after the deck lands (`tabindex -1`, no ring).
        DeckTitle: {
            tag: 'h2',
            dataDeckTitle: true,
            tabindex: '-1',
            margin: '0',
            fontSize: 'C',
            fontWeight: '700',
            lineHeight: '1.2',
            color: 'title',
            minWidth: '0',
            overflowWrap: 'anywhere',
            ':focus': {
                outline: 'none'
            },
            ':focus-visible': {
                outline: 'none',
                boxShadow: 'none'
            },
            TitleText: {
                tag: 'span',
                text: (el, s)=>{
                    const vm = el.call('assistantDeckViewModel', s.root);
                    return vm && vm.title || '';
                }
            },
            Skeleton: {
                display: 'inline-block',
                verticalAlign: 'middle',
                width: 'F',
                height: '1em',
                hide: (el, s)=>{
                    const vm = el.call('assistantDeckViewModel', s.root);
                    return !vm || !!vm.title || vm.status === 'failed';
                }
            }
        },
        DeckBar: {
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center space-between',
            gap: 'Z',
            minWidth: '0',
            AppMicroLabel: {
                dataDeckMicro: true,
                whiteSpace: 'normal',
                text: (el, s)=>el.call('assistantDeckMicro', el.call('assistantDeckViewModel', s.root))
            },
            DeckActions: {
                flow: 'x',
                flexWrap: 'wrap',
                align: 'center',
                gap: 'Y',
                AppCapsuleBtnPrimary: {
                    compact: true,
                    dataDeckPresent: true,
                    disabled: (el, s)=>{
                        const vm = el.call('assistantDeckViewModel', s.root);
                        return !vm || !(vm.slides || []).length || vm.status === 'loading' ? true : null;
                    },
                    text: '{{ workspace.assistantDeck.present | polyglot }}',
                    onClick: (e, el)=>el.call('assistantDeckPresent')
                },
                AppCapsuleBtnToolbar: {
                    compact: true,
                    dataDeckSave: true,
                    disabled: (el, s)=>el.call('assistantDeckActionsIdle', el.call('assistantDeckViewModel', s.root)) || null,
                    onClick: (e, el, s)=>el.call('saveDeck', el, s),
                    AppLabelStack: {
                        labels: [
                            'workspace.assistantDeck.save',
                            'workspace.assistantDeck.saving',
                            'workspace.assistantDeck.saved'
                        ],
                        shown: (el, s)=>el.call('assistantDeckSaveLabel', el.call('assistantDeckViewModel', s.root))
                    }
                },
                // The ONE square button of the head, named by this view's verb (only
                // the brand's own `attr` key replaces the brand default).
                CloseButton: {
                    dataDeckDismiss: true,
                    attr: {
                        'aria-label': (el)=>el.call('polyglot', 'workspace.assistantDeck.dismiss')
                    },
                    onClick: (e, el)=>el.call('assistantDeckDismiss', {
                            focusComposer: true
                        })
                }
            }
        },
        // A failure (with Try again) or a save notice. Always mounted — a status
        // region must exist before it speaks.
        DeckStatus: {
            dataDeckStatus: true,
            role: 'status',
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center',
            gap: 'Z',
            minWidth: '0',
            StatusText: {
                tag: 'span',
                fontSize: 'A',
                fontWeight: '500',
                color: 'title',
                minWidth: '0',
                overflowWrap: 'anywhere',
                text: (el, s)=>el.call('assistantDeckStatus', el.call('assistantDeckViewModel', s.root))
            },
            AppCapsuleBtnToolbar: {
                compact: true,
                dataDeckRetry: true,
                hide: (el, s)=>{
                    const vm = el.call('assistantDeckViewModel', s.root);
                    return !vm || vm.status !== 'failed' || vm.error === 'unavailable';
                },
                text: '{{ workspace.assistantBoard.tryAgain | polyglot }}',
                onClick: (e, el)=>el.call('assistantDeckRetry')
            }
        }
    },
    // The stage: the ONE slide on screen, keyed by the slide — a new slide is a
    // new element, so it fades in; the stage keeps its height floor.
    DeckStage: {
        dataDeckStage: true,
        ariaLive: 'polite',
        minWidth: '0',
        children: (el, s)=>{
            const slide = el.call('assistantDeckSlide', el.call('assistantDeckViewModel', s.root));
            return slide ? [
                slide
            ] : [];
        },
        childrenAs: 'state',
        childExtends: 'AssistantDeckSlide'
    },
    // Previous · 3 / 6 · Next — under the stage, centred.
    DeckNav: {
        dataDeckNav: true,
        flow: 'x',
        align: 'center center',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>{
            const vm = el.call('assistantDeckViewModel', s.root);
            return !vm || (vm.slides || []).length < 2;
        },
        AppCapsuleBtnToolbar_prev: {
            compact: true,
            dataDeckPrev: true,
            disabled: (el, s)=>el.call('assistantDeckCanGo', el.call('assistantDeckViewModel', s.root), -1) ? null : true,
            text: '{{ workspace.assistantDeck.previous | polyglot }}',
            onClick: (e, el)=>el.call('assistantDeckGo', -1)
        },
        DeckCounter: {
            tag: 'span',
            dataDeckCounter: true,
            fontSize: 'Z',
            fontWeight: '500',
            color: 'caption',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>el.call('assistantDeckCounter', el.call('assistantDeckViewModel', s.root))
        },
        AppCapsuleBtnToolbar_next: {
            compact: true,
            dataDeckNext: true,
            disabled: (el, s)=>el.call('assistantDeckCanGo', el.call('assistantDeckViewModel', s.root), 1) ? null : true,
            text: '{{ workspace.assistantDeck.next | polyglot }}',
            onClick: (e, el)=>el.call('assistantDeckGo', 1)
        }
    }
};
const $3e4bea06de1fda1c$export$f0d5b770a2f31fec = {
    tag: 'article',
    dataSlide: (el, s)=>s && s.key || null,
    dataKind: (el, s)=>s && s.kind || null,
    ariaBusy: (el, s)=>s && s.kind === 'skeleton' ? 'true' : null,
    flow: 'y',
    gap: 'B',
    minWidth: '0',
    minHeight: 'H',
    boxSizing: 'border-box',
    padding: 'C',
    round: 'B1',
    background: 'var(--home-card-bg, var(--theme-card-background))',
    color: 'title',
    animation: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'backwards',
    '@mobileL': {
        padding: 'B',
        minHeight: 'G'
    },
    // The title slide: the deck's title as the page's largest type, centred.
    '.isTitleSlide': {
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    },
    isTitleSlide: (el, s)=>!!(s && s.kind === 'title'),
    SlideTitle: {
        tag: 'h3',
        dataSlideTitle: true,
        hide: (el, s)=>!s || s.kind === 'skeleton',
        margin: '0',
        fontSize: (el, s)=>s && s.kind === 'title' ? 'D' : 'C',
        fontWeight: '700',
        lineHeight: '1.2',
        color: 'title',
        minWidth: '0',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.title || ''
    },
    SlideSubtitle: {
        tag: 'p',
        hide: (el, s)=>!s || !s.subtitle,
        margin: '0',
        fontSize: 'A',
        color: 'caption',
        minWidth: '0',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.subtitle || ''
    },
    // One or two live cards: the board's own card (AssistantDeckCard) — a
    // widget with its params, or a records block whose rows the SDK brings.
    SlideItems: {
        dataSlideItems: true,
        hide: (el, s)=>!s || s.kind !== 'content' || !(s.items || []).length,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'A',
        minWidth: '0',
        children: (el, s)=>s && Array.isArray(s.items) ? s.items : [],
        childrenAs: 'state',
        childExtends: 'AssistantDeckCard'
    },
    // A content slide whose items cannot be mounted here: one sentence, never
    // a made-up value.
    SlideEmpty: {
        tag: 'p',
        dataSlideEmpty: true,
        hide: (el, s)=>!s || s.kind !== 'content' || (s.items || []).length > 0,
        margin: '0',
        fontSize: 'A',
        color: 'caption',
        text: '{{ workspace.assistantDeck.emptySlide | polyglot }}'
    },
    // While the deck builds: a headline bar and a card-sized block.
    SlideSkeleton: {
        hide: (el, s)=>!s || s.kind !== 'skeleton',
        flow: 'y',
        gap: 'A',
        flex: '1',
        minHeight: '0',
        Skeleton_1: {
            width: '50%',
            height: 'C'
        },
        Skeleton_2: {
            flex: '1',
            minHeight: 'F',
            round: 'radiusControl'
        }
    },
    // The speaker notes: qualitative lines for the presenter.
    SlideNotes: {
        tag: 'aside',
        dataSlideNotes: true,
        hide: (el, s)=>!s || !s.notes,
        marginTop: 'auto',
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        AppMicroLabel: {
            text: '{{ workspace.assistantDeck.notes | polyglot }}'
        },
        NotesText: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z',
            color: 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.notes || ''
        }
    }
};
const $3e4bea06de1fda1c$export$a5fe3c1b1cb7b98b = {
    extends: 'AssistantBoardCard',
    flex: '1 1 0',
    minWidth: 'G',
    minHeight: 'G',
    '@mobileL': {
        minWidth: '100%'
    },
    CardHead: {
        HomeWidgetAction: {
            hide: ()=>true
        }
    }
};
const $3e4bea06de1fda1c$export$4c33b000b619fa07 = {
    tabindex: '0',
    role: 'group',
    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantDeck.presenterLabel'),
    ariaRoledescription: (el)=>el.call('polyglot', 'workspace.assistantDeck.roleDescription'),
    flow: 'y',
    gap: 'B',
    width: '100%',
    height: 'calc(100dvh - 2 * var(--spacing-A))',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'C',
    round: 'radiusSheet',
    background: 'gray2',
    '@light': {
        background: 'gray16'
    },
    outline: 'none',
    ':focus-visible': {
        outline: 'none'
    },
    '@mobileL': {
        padding: 'A'
    },
    onRender: (el)=>{
        const node = el.node;
        if (node && typeof node.focus === 'function' && node.ownerDocument && node.ownerDocument.activeElement !== node) node.focus({
            preventScroll: true
        });
    },
    onKeydown: (e, el)=>el.call('assistantDeckPresenterKey', e),
    PresenterStage: {
        flex: '1',
        minHeight: '0',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        children: (el, s)=>{
            const slide = el.call('assistantDeckSlide', el.call('assistantDeckViewModel', s.root));
            return slide ? [
                slide
            ] : [];
        },
        childrenAs: 'state',
        childExtends: 'AssistantDeckSlide',
        childProps: {
            flex: '1',
            fontSize: 'B'
        }
    },
    PresenterBar: {
        flow: 'x',
        align: 'center center',
        gap: 'Z',
        minWidth: '0',
        AppCapsuleBtnToolbar_prev: {
            compact: true,
            disabled: (el, s)=>el.call('assistantDeckCanGo', el.call('assistantDeckViewModel', s.root), -1) ? null : true,
            text: '{{ workspace.assistantDeck.previous | polyglot }}',
            onClick: (e, el)=>el.call('assistantDeckGo', -1)
        },
        PresenterCounter: {
            tag: 'span',
            fontSize: 'Z',
            fontWeight: '500',
            color: 'caption',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>el.call('assistantDeckCounter', el.call('assistantDeckViewModel', s.root))
        },
        AppCapsuleBtnToolbar_next: {
            compact: true,
            disabled: (el, s)=>el.call('assistantDeckCanGo', el.call('assistantDeckViewModel', s.root), 1) ? null : true,
            text: '{{ workspace.assistantDeck.next | polyglot }}',
            onClick: (e, el)=>el.call('assistantDeckGo', 1)
        },
        AppCapsuleBtnToolbar_exit: {
            compact: true,
            text: '{{ workspace.assistantDeck.exitPresent | polyglot }}',
            onClick: (e, el)=>el.call('assistantDeckPresentExit')
        }
    }
};

});

parcelRegister("dG0YH", function(module, exports) {

$parcel$export(module.exports, "AssistantFlyView", () => $9f4ff4d06fa4f84e$export$7fac095aa7602485);
$parcel$export(module.exports, "AssistantFlyRailMarks", () => $9f4ff4d06fa4f84e$export$8cd36e3ae3e938);
$parcel$export(module.exports, "AssistantFlyRailMark", () => $9f4ff4d06fa4f84e$export$e8c1cb50b0405087);
$parcel$export(module.exports, "AssistantFlyRail", () => $9f4ff4d06fa4f84e$export$500495e85d467176);
$parcel$export(module.exports, "AssistantFlyRailLine", () => $9f4ff4d06fa4f84e$export$acbae332ca089caf);
$parcel$export(module.exports, "AssistantFlyRailFoot", () => $9f4ff4d06fa4f84e$export$37e0c754cdf61e23);
$parcel$export(module.exports, "AssistantFlyPageBody", () => $9f4ff4d06fa4f84e$export$a20360560c46525c);
$parcel$export(module.exports, "AssistantFlyRow", () => $9f4ff4d06fa4f84e$export$12a58347b4cfb3e7);
$parcel$export(module.exports, "AssistantFlyCard", () => $9f4ff4d06fa4f84e$export$ee8e85fa889d4e9a);
// THE FLY CANVAS — Fly mode's view of the main area (docs/FLY_MODE.md; Nika
// 2026-10-17: "runs just like fly keepz", "make that flow easy, beautiful,
// clean, simple"). Every value comes from functions/assistantFly.js through
// `el.call`; the components hold no logic of their own.
//
// ONE column, top to bottom:
//   the bar      the Fly mark, the session's page count, New · Close
//   rows before  the session's earlier pages, folded into compact cards (Nika
//                2026-10-23: "add collapseable history when asking new fly
//                question in same thread like we have in fly keepz") — the
//                nearest three, the older ones behind one quiet line
//   THE PAGE     the open page (AssistantFlyPageBody): eyebrow · title · who
//                made it (or what it is doing now) · Ask again · Share · Save ·
//                the OPENING (streams; skeleton lines until its first
//                sentence) · the sections (the home grid's cells, the same
//                card bodies as a generated board) · the next asks
//   rows after   the pages after it, folded
// ONE page is open; a row opens its page (the others fold), and the open
// page's Fold folds it too — the thread then reads as its rows. The composer
// below is the shell's own: a send in Fly mode adds the next page.
//
// It replaces the main area the way a generated board does: a crossfade,
// opacity + visibility only (Rule 66 — closed keeps the box). Mounted on the
// home grid area (pages/main.js) and in the page layer over every other route
// (components/AssistantMainLayer.js, `mainHost: 'over'`). A CALL shows the same
// AssistantFlyPageBody on its stage (meet components/MeetFlyStage.js).
const $9f4ff4d06fa4f84e$export$7fac095aa7602485 = {
    tag: 'section',
    role: 'region',
    dataFly: true,
    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.region'),
    // The grid metrics — geometry of THIS element, so its own state (`start`:
    // the page is left-aligned beside the rail; every key declared, so a read
    // never falls back to a root key of the same name).
    // `older`: the thread's older rows shown (FlyOlder).
    state: {
        cols: 0,
        gutter: 0,
        cell: 0,
        square: true,
        start: false,
        older: false
    },
    dataOpen: (el, s)=>el.call('assistantFlyShown', s.root) ? 'true' : 'false',
    ariaHidden: (el, s)=>el.call('assistantFlyShown', s.root) ? null : 'true',
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    width: '100%',
    // THE DASHBOARD'S WIDTH (Nika 2026-10-22: "make fly same width as
    // dashboard"): the view is the grid's own width, and its pages lay their
    // sections on the dashboard's grid (functions/assistantFly.js
    // assistantFlyMeasure). The conversation rail at the right edge (fixed, the
    // drawers' place) takes its room from the page alone: beside it the page
    // keeps the dashboard's left edge and ends a gutter before the rail —
    // measured, so a docked module rail at the left (bellforge's sidebar) and
    // the page layer over a route are measured too, never assumed.
    maxWidth: 'var(--home-grid-w, 100%)',
    marginInline: 'auto',
    minWidth: '0',
    boxSizing: 'border-box',
    paddingBottom: 'C',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open="true"]': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    subscribeTo: [
        'workspace',
        'workspaceApps',
        'workspaceProject'
    ],
    onMounted: (el, s)=>{
        el.call('assistantFlyMounted', el, s);
        el.call('assistantFlyShortcuts', el);
    },
    onUpdate: (el, s)=>el.call('assistantFlyMounted', el, s),
    onWindowResize: (e, el, s)=>el.call('assistantFlySyncGrid', el, s),
    onRemove: (el)=>{
        if (typeof el.__flyShortcutsOff === 'function') el.__flyShortcutsOff();
        el.call('assistantBoardGridReadOff', el);
    },
    // The open page comes to the top of the view once, when it opens; the grid
    // is read again whenever the rail shows or leaves (the page takes its room
    // or gives it back — read a tick later, once the rail's box has changed).
    // A new page is the view's last part: the view takes the room it needs
    // below it (its `minHeight`, functions/assistantReveal.js) while it is on
    // screen, and gives it back when the session has no page open (New).
    minHeight: (el, s)=>el.call('assistantRevealRoom', el, s.root, el.call('assistantFlyShown', s.root)),
    stateDeps: [
        (el, s)=>s.root && s.root._aiFly ? s.root._aiFly.focus : null,
        (el, s)=>!!el.call('assistantFlyRailShown', s.root)
    ],
    onStateUpdate: (el, s, ctx, change)=>{
        const prev = change && change.prev || [];
        const next = change && change.next || [];
        if (prev[1] !== next[1]) el.call('assistantBoardGridRead', el, s, 'assistantFlySyncGrid');
        const key = next[0] || null;
        if (key && prev[0] !== key && el.call('assistantFlyShown', s.root)) el.call('assistantFlyReveal', el, key);
        else if (!key && prev[0]) el.call('assistantRevealRoomClear', el);
    },
    // ── The bar ────────────────────────────────────────────────────────────────
    // On the home the switch above names the view and is the way out
    // (components/HomeViewSwitch.js): the bar keeps the count, the "Section
    // added" note and New, and steps aside while the start screen shows. No
    // tools here (Nika 2026-10-23): the top menu opens every app, and Add
    // section is a row of the composer's "+" menu.
    FlyBar: {
        hide: (el, s)=>!!el.call('assistantFlyOnHome', el) && !!el.call('assistantFlyStartShown', s.root),
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        minHeight: 'controlHCompact',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        FlyMark: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            color: 'title',
            Icon: {
                name: 'pxFly',
                boxSize: 'iconSm',
                flexShrink: '0',
                hide: (el)=>!!el.call('assistantFlyOnHome', el)
            },
            FlyName: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '500',
                hide: (el)=>!!el.call('assistantFlyOnHome', el),
                text: (el)=>el.call('polyglot', 'ai.assistantMode.fly')
            },
            FlyCount: {
                tag: 'span',
                fontSize: 'Z2',
                color: 'inactive',
                text: (el, s)=>{
                    const n = (el.call('assistantFlyPages', s.root) || []).length;
                    return n > 1 ? String(el.call('polyglot', 'workspace.assistantFly.pageCount')).replace('{n}', String(n)) : '';
                }
            }
        },
        FlyBarActions: {
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            AssistantFlyWorkspace: {},
            AppCapsuleBtnToolbar: {
                dataFlyNew: true,
                compact: true,
                // "New" goes back to the start screen (functions/assistantFlyStart.js)
                // — worth a button from the first page on. On a wide screen the
                // rail's head holds it.
                visibility: (el, s)=>(el.call('assistantFlyPages', s.root) || []).length > 0 ? 'visible' : 'hidden',
                '@tabletS<': {
                    hide: true
                },
                text: (el)=>el.call('polyglot', 'workspace.assistantFly.new'),
                onClick: (e, el)=>el.call('assistantFlyWorkspaceNew')
            },
            // The canvas's own controls are the assistant's quiet icon button —
            // one geometry with the page's actions.
            AssistantIconButton: {
                dataFlyClose: true,
                // On the home the switch's Dashboard is the way out.
                hide: (el)=>!!el.call('assistantFlyOnHome', el),
                ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.close'),
                title: (el)=>el.call('polyglot', 'workspace.assistantFly.close'),
                onClick: (e, el)=>el.call('assistantFlyWorkspaceDismiss', {
                        focusComposer: true
                    }),
                Icon: {
                    name: 'x'
                }
            }
        }
    },
    // ── An empty session: the workspace's start screen ─────────────────────────
    // (components/AssistantFlyStart.js — its headline, its live figures and its
    // own asks, one tap from a page).
    AssistantFlyStart: {},
    // ── The thread's history: a wrapping shelf of the nearest three pages;
    // older pages wait behind one quiet line. Narrow surfaces keep one track.
    FlyOlder: {
        extends: 'AppControl',
        compact: true,
        tag: 'button',
        type: 'button',
        dataFlyOlder: true,
        hide: (el, s)=>(el.call('assistantFlyRows', s.root, 'before') || []).length <= 3,
        ariaExpanded: (el, s)=>s.older === true ? 'true' : 'false',
        flow: 'x',
        align: 'center',
        gap: 'Y',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        padding: '0',
        border: 'none',
        background: 'transparent',
        fontFamily: 'inherit',
        fontSize: 'Z2',
        color: 'inactive',
        textAlign: 'left',
        cursor: 'pointer',
        ':hover': {
            color: 'title'
        },
        ':active': {
            color: 'title'
        },
        ':focus-visible': {
            shadow: 'focusRing'
        },
        onClick: (e, el, s)=>s.update({
                older: s.older !== true
            }),
        Icon: {
            name: (el, s)=>s.older === true ? 'chevronUp' : 'chevronDown',
            boxSize: 'iconSm',
            flexShrink: '0'
        },
        OlderText: {
            tag: 'span',
            text: (el, s)=>{
                if (s.older === true) return el.call('polyglot', 'workspace.assistantFly.fewer');
                const n = (el.call('assistantFlyRows', s.root, 'before') || []).length - 3;
                return String(el.call('polyglot', 'workspace.assistantFly.earlier')).replace('{n}', String(Math.max(0, n)));
            }
        }
    },
    FlyBefore: {
        tag: 'ol',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        // A wrapping shelf keeps nearby pages in reach without pushing the
        // active page down by a full row for every item. Tracks fit the actual
        // page width, including a narrow PageSlot or the conversation rail.
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F)), 1fr))',
        gap: 'Z',
        '@mobileL': {
            gridTemplateColumns: 'none',
            gridAutoFlow: 'column',
            gridAutoColumns: 'minmax(85%, 1fr)',
            overflowX: 'auto',
            overscrollBehaviorX: 'contain',
            scrollSnapType: 'x proximity',
            paddingBottom: 'X'
        },
        minWidth: '0',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        children: (el, s)=>{
            const rows = el.call('assistantFlyRows', s.root, 'before') || [];
            return s.older === true ? rows : rows.slice(-3);
        },
        childrenAs: 'state',
        childExtends: 'AssistantFlyRow'
    },
    // ── The open page — ONE child keyed by its page: a newly opened page is a
    // new element (it rises in), its sections new cards. The child's state is
    // the page + where it lives (`source`) + this view's grid metrics.
    FlyOpen: {
        minWidth: '0',
        children: (el, s)=>{
            // the thread folded: every page is its row (FlyBefore)
            if (el.call('assistantFlyFolded', s.root)) return [];
            const p = el.call('assistantFlyPage', s.root);
            if (!p) return [];
            const m = el.call('assistantBoardMetrics', s);
            // On the page layer over a route the ground is the layer's sheet, not
            // the home's sky: its cards take the solid card fill.
            const onLayer = !!(el.parent && el.parent.mainHost === 'over');
            return [
                {
                    ...p,
                    source: 'session',
                    cols: m.cols,
                    gutter: m.gutter,
                    cell: m.cell,
                    square: m.square,
                    // beside the rail: the dashboard's left edge (assistantFlyPageStyle)
                    start: s.start === true,
                    onLayer: onLayer
                }
            ];
        },
        childrenAs: 'state',
        childExtends: 'AssistantFlyPageBody'
    },
    // ── The later pages, folded ───────────────────────────────────────────────
    FlyAfter: {
        tag: 'ol',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F)), 1fr))',
        gap: 'Z',
        '@mobileL': {
            gridTemplateColumns: 'none',
            gridAutoFlow: 'column',
            gridAutoColumns: 'minmax(85%, 1fr)',
            overflowX: 'auto',
            overscrollBehaviorX: 'contain',
            scrollSnapType: 'x proximity',
            paddingBottom: 'X'
        },
        minWidth: '0',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        children: (el, s)=>el.call('assistantFlyRows', s.root, 'after'),
        childrenAs: 'state',
        childExtends: 'AssistantFlyRow'
    },
    // ── The conversation, at the right — or, put away, its lines ─────────────
    AssistantFlyRail: {},
    AssistantFlyRailMarks: {}
};
const $9f4ff4d06fa4f84e$export$8cd36e3ae3e938 = {
    tag: 'nav',
    dataFlyRailMarks: true,
    ariaLabel: (el)=>el.call('polyglot', 'ai.chat.history'),
    hide: (el, s)=>!el.call('assistantFlyRailMarksShown', s.root),
    '@tabletS': {
        hide: true
    },
    position: 'fixed',
    right: 'X2',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: '3',
    flow: 'y',
    align: 'flex-end',
    gap: 'Y',
    maxHeight: 'calc(100vh - var(--shell-top) - var(--spacing-D1))',
    animation: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    // A new chat, as the rail's head offers it — with the rail put away a wide
    // screen had no way back to the start screen (its bar's New is the narrow
    // screens'; dev 2026-10-22).
    AssistantIconButton_new: {
        dataFlyMarksNew: true,
        ariaLabel: (el)=>el.call('polyglot', 'ai.chat.newChat'),
        title: (el)=>el.call('polyglot', 'ai.chat.newChat'),
        onClick: (e, el)=>{
            el.call('assistantFlyWorkspaceNew');
            el.call('assistantBoardFocus', 'composer');
        },
        Icon: {
            name: 'plus'
        }
    },
    AssistantIconButton: {
        dataFlyRailShow: true,
        ariaLabel: (el)=>el.call('polyglot', 'ai.chat.history'),
        ariaExpanded: 'false',
        title: (el)=>el.call('polyglot', 'ai.chat.history'),
        onClick: (e, el)=>el.call('assistantFlyRailToggle', false),
        Icon: {
            name: 'chevronLeft'
        }
    },
    MarksList: {
        tag: 'ol',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        align: 'flex-end',
        minHeight: '0',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        children: (el, s)=>el.call('assistantFlyRailMarks', s.root),
        childrenAs: 'state',
        childExtends: 'AssistantFlyRailMark'
    }
};
const $9f4ff4d06fa4f84e$export$e8c1cb50b0405087 = {
    tag: 'li',
    display: 'flex',
    justifyContent: 'flex-end',
    MarkButton: {
        extends: 'TitleTooltipTrigger',
        tag: 'button',
        type: 'button',
        dataFlyMark: (el, s)=>s && s.pageKey || null,
        dataOpen: (el, s)=>s && s.open ? 'true' : null,
        dataBusy: (el, s)=>s && s.busy ? 'true' : null,
        ariaCurrent: (el, s)=>s && s.open ? 'page' : null,
        ariaLabel: (el, s)=>s && s.title || null,
        title: (el, s)=>s && s.title || '',
        display: 'flex',
        align: 'center flex-end',
        width: 'controlHCompact',
        minHeight: 'B',
        padding: '0',
        border: 'none',
        background: 'transparent',
        color: 'inactive',
        cursor: 'pointer',
        round: 'radiusControl',
        transition: 'A defaultBezier',
        transitionProperty: 'color',
        ':hover': {
            color: 'title'
        },
        ':focus-visible': {
            shadow: 'focusRing'
        },
        '&[data-open="true"]': {
            color: 'title'
        },
        onClick: (e, el, s)=>el.call('assistantFlyFocus', s && s.pageKey),
        MarkLine: {
            tag: 'span',
            ariaHidden: 'true',
            display: 'block',
            width: 'Z',
            height: 'hairline2',
            round: 'radiusPill',
            background: 'currentColor',
            transition: 'A defaultBezier',
            transitionProperty: 'width',
            ':is([data-fly-mark]:hover) &': {
                width: 'A'
            },
            ':is([data-fly-mark][data-open="true"]) &': {
                width: 'B'
            },
            ':is([data-fly-mark][data-busy="true"]) &': {
                animation: 'pulse',
                animationDuration: 'E',
                animationIterationCount: 'infinite'
            }
        }
    }
};
const $9f4ff4d06fa4f84e$export$500495e85d467176 = {
    tag: 'aside',
    dataFlyRail: true,
    ariaLabel: (el)=>el.call('polyglot', 'ai.chat.history'),
    hide: (el, s)=>!el.call('assistantFlyRailShown', s.root),
    '@tabletS': {
        hide: true
    },
    position: 'fixed',
    top: '--shell-top',
    right: 'X2',
    bottom: 'D1',
    width: 'G1',
    minWidth: 'G1',
    maxWidth: 'G1',
    zIndex: '3',
    theme: 'canvas-card-glass',
    borderWidth: '0',
    round: 'radiusCard',
    flow: 'y',
    overflow: 'hidden',
    boxSizing: 'border-box',
    animation: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    RailHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        flexShrink: '0',
        minHeight: 'controlH',
        padding: 'Y Z Y A',
        RailTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'Z2',
            fontWeight: '500',
            color: 'title',
            text: (el)=>el.call('polyglot', 'ai.chat.history')
        },
        RailHeadActions: {
            flow: 'x',
            align: 'center',
            gap: 'X',
            flexShrink: '0',
            AssistantIconButton: {
                dataFlyRailNew: true,
                ariaLabel: (el)=>el.call('polyglot', 'ai.chat.newChat'),
                title: (el)=>el.call('polyglot', 'ai.chat.newChat'),
                onClick: (e, el)=>{
                    el.call('assistantFlyWorkspaceNew');
                    el.call('assistantBoardFocus', 'composer');
                },
                Icon: {
                    name: 'plus'
                }
            },
            // Put the rail away — the session stays at the edge as lines
            // (AssistantFlyRailMarks). One toggle, named by what it shows; its
            // state is `aria-expanded`.
            AssistantIconButton_hide: {
                dataFlyRailHide: true,
                ariaLabel: (el)=>el.call('polyglot', 'ai.chat.history'),
                ariaExpanded: 'true',
                title: (el)=>el.call('polyglot', 'ai.chat.history'),
                onClick: (e, el)=>el.call('assistantFlyRailToggle', true),
                Icon: {
                    name: 'chevronRight'
                }
            }
        }
    },
    // The lines stand at the bottom (the newest above the composer's line of
    // sight) and scroll up into the older ones: a REVERSED column scroller
    // keeps its end in view by itself — a new line, a growing answer — and a
    // person who scrolled up to read stays where they are.
    RailScroll: {
        flex: '1 1 auto',
        minHeight: '0',
        display: 'flex',
        flexDirection: 'column-reverse',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        padding: '0 Z A',
        RailLines: {
            tag: 'ol',
            margin: '0',
            padding: '0',
            listStyle: 'none',
            flow: 'y',
            gap: 'Z1',
            flexShrink: '0',
            boxSizing: 'border-box',
            children: (el, s)=>el.call('assistantFlyRailLines', s.root),
            childrenAs: 'state',
            childExtends: 'AssistantFlyRailLine'
        }
    }
};
const $9f4ff4d06fa4f84e$export$acbae332ca089caf = {
    tag: 'li',
    minWidth: '0',
    dataFlyLine: (el, s)=>s && s.key || null,
    ChatMessage: {
        if: (el, s)=>!!s && s.kind === 'message' && (s.role !== 'assistant' || !!s.text || !!s.streaming)
    },
    AssistantFlyRailFoot: {
        if: (el, s)=>!!s && s.kind === 'foot'
    }
};
const $9f4ff4d06fa4f84e$export$37e0c754cdf61e23 = {
    flow: 'x',
    align: 'center',
    gap: 'Z',
    minWidth: '0',
    paddingLeft: 'A',
    marginTop: '-Y',
    fontSize: 'Z1',
    color: 'inactive',
    FootShow: {
        tag: 'button',
        type: 'button',
        dataFlyShow: (el, s)=>s && s.pageKey || null,
        hide: (el, s)=>!s || !!s.open || !!s.failed,
        flow: 'x',
        align: 'center',
        gap: 'X',
        padding: '0',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        color: 'title',
        fontSize: 'Z1',
        fontWeight: '500',
        textDecoration: 'underline',
        textUnderlineOffset: '0.2em',
        ':hover': {
            color: 'highlight'
        },
        ':active': {
            opacity: '.7'
        },
        onClick: (e, el, s)=>el.call('assistantFlyFocus', s.pageKey),
        FootShowLabel: {
            tag: 'span',
            text: (el)=>el.call('polyglot', 'workspace.assistantFly.showPage')
        },
        Icon: {
            name: 'arrowRight',
            boxSize: 'Z'
        }
    },
    FootMeta: {
        tag: 'span',
        text: (el, s)=>el.call('assistantFlyRailMeta', s)
    }
};
const $9f4ff4d06fa4f84e$export$a20360560c46525c = {
    tag: 'article',
    dataFlyPage: (el, s)=>s && s.key || null,
    // Its sections' width, centred (functions/assistantFly.js
    // assistantFlyPageStyle); brought into view, its head stays clear of the
    // shell's floating header.
    width: '100%',
    marginInline: 'auto',
    style: (el, s)=>el.call('assistantFlyPageStyle', s),
    scrollMarginTop: 'calc(var(--shell-top) + var(--spacing-A))',
    ariaBusy: (el, s)=>s && (s.status === 'loading' || s.status === 'streaming') ? 'true' : null,
    ariaLabel: (el, s)=>s && (s.title || s.prompt) || '',
    flow: 'y',
    gap: 'B',
    minWidth: '0',
    // A page rises in once (opacity + the brand's short travel).
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    FlyHead: {
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        boxSizing: 'border-box',
        padding: 'A1 B',
        round: 'radiusCard',
        background: (el, s)=>s && s.onLayer ? 'cardSolid' : 'var(--home-card-bg, var(--theme-card-background))',
        '@mobileL': {
            padding: 'A'
        },
        FlyEyebrow: {
            tag: 'p',
            // The line keeps its room while the head is on its way; a head without
            // one (or a page made from a board) gives the room back.
            hide: (el, s)=>!s || !s.eyebrow && (!!s.title || !!s.fallback),
            margin: '0',
            maxWidth: 'var(--spacing-I)',
            minHeight: '1.3em',
            fontSize: 'Z',
            fontWeight: '500',
            lineHeight: '1.3',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'inactive',
            text: (el, s)=>s && s.eyebrow || ''
        },
        // The title: the page's own once it comes; until then the ask itself, in
        // the quiet ink — the page has its words from the first frame.
        FlyTitle: {
            tag: 'h2',
            margin: '0',
            maxWidth: 'var(--spacing-I)',
            fontSize: 'D',
            fontWeight: '700',
            lineHeight: '1.15',
            textWrap: 'balance',
            overflowWrap: 'anywhere',
            '@mobileL': {
                fontSize: 'C'
            },
            color: (el, s)=>s && s.title ? 'title' : 'inactive',
            transition: 'color C defaultBezier',
            text: (el, s)=>s && (s.title || s.prompt) || ''
        },
        // ONE line: what the page is doing now (a breathing dot), then — the
        // same box — who composed it and when. The actions sit at its end and
        // keep their box while the page is made (Rule 66).
        FlyMeta: {
            flow: 'x',
            align: 'center space-between',
            flexWrap: 'wrap',
            gap: 'Z',
            minWidth: '0',
            minHeight: 'controlHCompact',
            FlyByline: {
                role: 'status',
                flow: 'x',
                align: 'center',
                gap: 'Y',
                minWidth: '0',
                fontSize: 'Z2',
                color: 'inactive',
                FlyDot: {
                    boxSize: 'Y',
                    round: 'radiusPill',
                    background: 'currentColor',
                    flexShrink: '0',
                    animation: 'pulse',
                    animationDuration: 'E',
                    animationIterationCount: 'infinite',
                    hide: (el, s)=>!s || s.status !== 'loading' && s.status !== 'streaming'
                },
                FlyBylineText: {
                    tag: 'span',
                    text: (el, s)=>{
                        if (!s) return '';
                        const key = el.call('assistantFlyStatusKey', s);
                        if (key && s.status !== 'failed') return el.call('polyglot', key);
                        return s.status === 'ready' ? el.call('assistantFlyByline', s) : '';
                    }
                }
            },
            FlyActions: {
                flow: 'x',
                align: 'center',
                gap: 'X',
                flexShrink: '0',
                visibility: (el, s)=>s && s.status === 'ready' ? 'visible' : 'hidden',
                // Fold: the open page folds into its row too (keepz--fly's fold)
                AssistantIconButton_fold: {
                    dataFlyFold: true,
                    hide: (el, s)=>!s || s.source !== 'session',
                    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.fold'),
                    title: (el)=>el.call('polyglot', 'workspace.assistantFly.fold'),
                    onClick: (e, el)=>el.call('assistantFlyFold'),
                    Icon: {
                        name: 'chevronUp'
                    }
                },
                AssistantIconButton: {
                    dataFlyAgain: true,
                    hide: (el, s)=>!s || !s.prompt,
                    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.again'),
                    title: (el)=>el.call('polyglot', 'workspace.assistantFly.again'),
                    onClick: (e, el, s)=>el.call('assistantFlyPageAct', s, 'again'),
                    Icon: {
                        name: 'refresh'
                    }
                },
                AssistantIconButton_share: {
                    dataFlyShare: true,
                    hide: (el, s)=>!s || !s.prompt || s.source === 'call',
                    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.share'),
                    title: (el)=>el.call('polyglot', 'workspace.assistantFly.share'),
                    onClick: (e, el, s)=>el.call('assistantFlyPageAct', s, 'share'),
                    Icon: {
                        name: 'share'
                    }
                },
                AssistantIconButton_save: {
                    dataFlySave: true,
                    // A page of only UI sections (one read's result each) has nothing
                    // a board could read again (functions/assistantFly.js).
                    disabled: (el, s)=>!s || !el.call('assistantFlySavable', s) || s.save === 'saving' || s.save === 'saved' ? true : null,
                    ariaLabel: (el, s)=>el.call('polyglot', s && s.save === 'saved' ? 'workspace.assistantFly.saved' : 'workspace.assistantFly.save'),
                    title: (el, s)=>el.call('polyglot', s && s.save === 'saved' ? 'workspace.assistantFly.saved' : 'workspace.assistantFly.save'),
                    onClick: (e, el, s)=>el.call('assistantFlyPageAct', s, 'save'),
                    Icon: {
                        name: (el, s)=>s && s.save === 'saved' ? 'check' : 'bookmark'
                    }
                }
            }
        }
    },
    // THE OPENING — the page's answer in a few sentences, every number from the
    // page's own data. Two skeleton lines hold its place until the first
    // sentence; a caret blinks while it is still being written.
    FlyOpening: {
        tag: 'p',
        dataFlyOpening: true,
        ariaLive: 'polite',
        margin: '0',
        maxWidth: 'I',
        fontSize: 'B',
        lineHeight: '1.5',
        color: 'paragraph',
        hide: (el, s)=>!s || s.status === 'failed' || s.status === 'ready' && !s.opening,
        FlyOpeningText: {
            tag: 'span',
            text: (el, s)=>s && s.opening || ''
        },
        FlyCaret: {
            tag: 'span',
            ariaHidden: 'true',
            display: 'inline-block',
            width: 'X',
            height: '1em',
            marginLeft: 'X',
            verticalAlign: 'text-bottom',
            background: 'currentColor',
            animation: 'blinking',
            animationDuration: 'E',
            animationIterationCount: 'infinite',
            hide: (el, s)=>!s || !s.opening || s.status === 'ready' || s.status === 'failed'
        },
        FlySkeleton: {
            flow: 'y',
            gap: 'Y',
            paddingTop: 'X',
            hide: (el, s)=>!s || !!s.opening || s.status === 'ready' || s.status === 'failed',
            Skeleton_1: {
                width: '100%',
                height: 'A'
            },
            Skeleton_2: {
                width: '62%',
                height: 'A'
            }
        }
    },
    // A CHANGE the ask asks for: the sentence and ONE action — the assistant
    // does it with its confirm cards (functions/assistantFly.js
    // assistantFlyHandoff). The page above it shows what the change touches.
    //
    // When the change is one an app's OWN FORM makes (the page's `form`), the
    // one action opens that form, prefilled (assistantFlyFormOpen — the
    // answer's form path; nothing is written until the member saves there).
    // A form the workspace cannot open says so in one plain line instead
    // (assistantFlyFormNote) — no dead button, no blank panel.
    FlyAction: {
        role: 'group',
        dataFlyAction: true,
        ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.actionLabel'),
        hide: (el, s)=>!s || s.status !== 'ready' || !(s.action || s.form && s.form.form) || s.source === 'call',
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center space-between',
        gap: 'Z',
        padding: 'Z A',
        round: 'radiusCard',
        background: 'var(--home-card-bg, var(--theme-card-background))',
        ActionText: {
            tag: 'span',
            flex: '1 1 F',
            minWidth: '0',
            fontSize: 'Z2',
            color: 'title',
            text: (el, s)=>{
                s && s.form;
                const note = el.call('assistantFlyFormNote', s);
                return note || s && s.action || '';
            }
        },
        AppCapsuleBtnPrimary: {
            dataFlyDoIt: true,
            hide: (el, s)=>!!(s && s.form && s.form.form),
            text: (el)=>el.call('polyglot', 'workspace.assistantFly.doIt'),
            onClick: (e, el, s)=>el.call('assistantFlyHandoff', s)
        },
        AppCapsuleBtnPrimary_form: {
            dataFlyFormOpen: true,
            hide: (el, s)=>{
                const root = s && s.root || {};
                root.workspaceApps;
                root.workspaceProject;
                return el.call('assistantFlyFormStatus', s) !== 'ready';
            },
            text: (el)=>el.call('polyglot', 'workspace.assistantBlock.formReview'),
            onClick: (e, el, s)=>el.call('assistantFlyFormOpen', s)
        }
    },
    // A failure: one sentence and Try again; the session's pages stay.
    //
    // A failure for CREDITS is not a fault, and Try again cannot mend it — the
    // server says "retrying will not help" — so that button never shows for it
    // (a Georgian visitor met exactly that: the sentence, and a "try again"
    // that returned the same one; persona audit round 1). In its place an admin
    // gets the way out (Add credits → the credit page) and a member gets who to
    // ask. Every other failure is unchanged.
    FlyFailure: {
        role: 'alert',
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        gap: 'Z',
        hide: (el, s)=>!s || s.status !== 'failed',
        FailureText: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'paragraph',
            text: (el, s)=>{
                const key = el.call('assistantFlyStatusKey', s);
                if (!key) return '';
                const text = el.call('polyglot', key);
                return s && s.error === 'credits' && !el.call('currentUserIsAdmin', s.root) ? `${text} ${el.call('polyglot', 'workspace.credits.chat.balanceMember')}` : text;
            }
        },
        AppCapsuleBtnToolbar: {
            compact: true,
            hide: (el, s)=>!!s && s.error === 'credits',
            text: (el)=>el.call('polyglot', 'workspace.assistantFly.retry'),
            onClick: (e, el, s)=>el.call('assistantFlyPageAct', s, 'again')
        },
        AppCapsuleBtnToolbar_1: {
            compact: true,
            hide: (el, s)=>!s || s.error !== 'credits' || !el.call('currentUserIsAdmin', s.root),
            text: (el)=>el.call('polyglot', 'workspace.creditBanner.addCredits'),
            onClick: (e, el)=>el.router('/admin/usage', el.getRoot())
        }
    },
    // THE SECTIONS — the home grid's cells (the same metrics, the same card
    // bodies as a generated board); skeletons hold the sections still coming.
    FlyGrid: {
        dataFlyGrid: true,
        display: 'grid',
        gridAutoFlow: 'row dense',
        justifyContent: 'center',
        minWidth: '0',
        style: (el, s)=>el.call('assistantFlyGridStyle', s),
        children: (el, s)=>el.call('assistantFlyStableCells', s, s && s.root, s && s.cols),
        childrenAs: 'state',
        childExtends: 'AssistantFlyCard'
    },
    // THE NEXT ASKS — one tap is the next page (of the session, or of the call);
    // on a page about what Symbols is or where to start, the quick tour too —
    // one tap starts it (functions/assistantFlyFollow.js).
    FlyFollow: {
        role: 'group',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.next'),
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        gap: 'Y',
        minWidth: '0',
        animation: 'fadeIn',
        animationDuration: 'C',
        animationTimingFunction: 'defaultBezier',
        hide: (el, s)=>!(el.call('assistantFlyFollowChips', s) || []).length,
        FollowLabel: {
            tag: 'span',
            fontSize: 'Z2',
            color: 'inactive',
            marginRight: 'X',
            text: (el)=>el.call('polyglot', 'workspace.assistantFly.next')
        },
        FollowChips: {
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Y',
            minWidth: '0',
            // Each chip carries where its page lives, so its ask goes to the same
            // place (the session, or the call and its agent); the tour chip runs
            // the tour.
            children: (el, s)=>el.call('assistantFlyFollowChips', s),
            childrenAs: 'state',
            childExtends: 'AppCapsuleBtnToolbar',
            childProps: {
                compact: true,
                whiteSpace: 'normal',
                title: (el, s)=>s && s.prompt || '',
                text: (el, s)=>s && s.label || '',
                onClick: (e, el, s)=>el.call('assistantFlyFollowPress', s)
            }
        }
    }
};
const $9f4ff4d06fa4f84e$export$12a58347b4cfb3e7 = {
    tag: 'li',
    minWidth: '0',
    scrollSnapAlign: 'start',
    FlyRowButton: {
        extends: 'AssistantFlyStartPress',
        dataFlyRow: (el, s)=>s && s.key || null,
        ariaLabel: (el, s)=>s && (s.title || s.prompt) || null,
        title: (el, s)=>s && (s.title || s.prompt) || null,
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr) auto',
        alignItems: 'center',
        gap: 'Z',
        height: '100%',
        minHeight: 'controlH',
        padding: 'Z',
        round: 'radiusCard',
        animation: 'fadeIn',
        ':focus-visible': {
            shadow: 'focusRingInset'
        },
        animationDuration: 'C',
        animationTimingFunction: 'defaultBezier',
        onClick: (e, el, s)=>el.call('assistantFlyPageAct', s, 'focus'),
        // its place in the thread: 1, 2, 3 …
        RowMark: {
            tag: 'span',
            ariaHidden: 'true',
            theme: 'layer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: '0',
            boxSize: 'controlHCompact',
            round: 'radiusControl',
            fontSize: 'Z2',
            fontWeight: '700',
            fontVariantNumeric: 'tabular-nums',
            color: 'title',
            text: (el, s)=>s && Number.isFinite(Number(s.index)) ? String(Number(s.index) + 1) : ''
        },
        RowText: {
            flow: 'y',
            gap: 'X',
            minWidth: '0',
            RowEyebrow: {
                tag: 'span',
                hide: (el, s)=>!s || !s.eyebrow,
                minWidth: '0',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 'Z',
                fontWeight: '500',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'inactive',
                text: (el, s)=>s && s.eyebrow || ''
            },
            RowTitle: {
                tag: 'span',
                minWidth: '0',
                lineClamp: '2',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                overflowWrap: 'anywhere',
                fontSize: 'Z2',
                fontWeight: '500',
                lineHeight: '1.25',
                text: (el, s)=>s && (s.title || s.prompt) || ''
            },
            RowMeta: {
                flow: 'x',
                align: 'center',
                gap: 'Y',
                minWidth: '0',
                fontSize: 'Z',
                color: 'inactive',
                RowDot: {
                    boxSize: 'Y',
                    round: 'radiusPill',
                    background: 'currentColor',
                    flexShrink: '0',
                    animation: 'pulse',
                    animationDuration: 'E',
                    animationIterationCount: 'infinite',
                    hide: (el, s)=>!s || s.status !== 'loading' && s.status !== 'streaming'
                },
                RowWhen: {
                    tag: 'span',
                    minWidth: '0',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    text: (el, s)=>el.call('assistantFlyRowMeta', s) || ''
                }
            }
        },
        // "Open ⌄" — the row unfolds into its page
        RowOpen: {
            tag: 'span',
            flow: 'x',
            align: 'center',
            gap: 'Y',
            flexShrink: '0',
            padding: 'X',
            round: 'radiusPill',
            background: 'selected',
            fontSize: 'Z',
            fontWeight: '500',
            RowOpenText: {
                tag: 'span',
                '@tabletS': {
                    hide: true
                },
                text: '{{ common.action.open | polyglot }}'
            },
            Icon: {
                name: 'chevronDown',
                boxSize: 'iconSm',
                flexShrink: '0'
            }
        }
    }
};
const $9f4ff4d06fa4f84e$export$ee8e85fa889d4e9a = {
    extends: 'AssistantBoardCard',
    dataFlySection: (el, s)=>s && s.key || null,
    // A widget or view section is a widget REGION for Inspect & ask
    // (functions/aiInspect.js): its id, app and params ride the ask.
    dataFlyWidget: (el, s)=>s && s.kind === 'widget' && s.id ? s.id : null,
    // The board card's span — until the section is known to be EMPTY: then the
    // same columns and one row, never one line over a blank square (functions/
    // assistantFly.js assistantFlyCardStyle).
    style: (el, s)=>el.call('assistantFlyCardStyle', el, s),
    animation: 'fadeInUpShort',
    // On a sheet (the page layer over a route, a call's stage) the default glass
    // card is near-white on a near-white ground in the light theme: there the
    // card is the SOLID skin's (`cardSolid`, a step darker than the sheet in
    // light, the solid dark card in dark). On the home it keeps the house card
    // over the sky.
    background: (el, s)=>s && s.onLayer ? 'cardSolid' : 'var(--home-card-bg, var(--theme-card-background))',
    CardHead: {
        // The title opens the section's app, as a home card's does — a view's
        // own page with the filters the view resolved, a widget's route, a
        // records card's collection (assistantBoardCardOpen).
        CardTitle: {
            cursor: (el, s)=>el.call('homeWidgetOpenRoute', s) ? 'pointer' : 'inherit',
            onClick: (e, el, s)=>{
                if (!el.call('homeWidgetOpenRoute', s)) return;
                e.stopPropagation();
                el.call('assistantBoardCardOpen', s, e);
            }
        },
        // The ONE square button is the home card's (a page is read-only, so never
        // a Pin): the widget's own verb when it declares one — "+ New deal" opens
        // the deal form, "Open follow-ups" the follow-ups view — else ↗ Open, the
        // section's app (a view's own page with the filters the view resolved, a
        // records card's collection) in the sheet; with ⌘/Ctrl, in a split
        // (functions/assistantFly.js assistantFlyCardAct).
        HomeWidgetAction: {
            dataBoardPin: null,
            dataFlyOpen: (el, s)=>el.call('assistantFlyCardVerb', s) ? null : true,
            // `data-fly-verb`, never `data-fly-action`: that names the page's own
            // change-and-Do-it group (FlyAction above).
            dataFlyVerb: (el, s)=>el.call('assistantFlyCardVerb', s) ? true : null,
            hide: (el, s)=>!el.call('assistantFlyCardActionLabel', s),
            disabled: null,
            ariaLabel: (el, s)=>el.call('assistantFlyCardActionLabel', s),
            title: (el, s)=>el.call('assistantFlyCardActionLabel', s),
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('assistantFlyCardAct', s, e);
            },
            Icon: {
                name: (el, s)=>{
                    const a = s && s.kind !== 'skeleton' ? el.call('homeWidgetActionOf', s) : null;
                    return a && a.icon || 'arrowUpRight';
                }
            }
        },
        // The section's close: a drill section closes (its source stays), a
        // hand-made page's section leaves it (assistantFlyCardCloses).
        HomeWidgetAction_close: {
            if: (el, s)=>!!el.call('assistantFlyCardCloses', s),
            dataBoardRemove: null,
            dataBoardDrillClose: (el, s)=>el.call('assistantFlyCardCloses', s) === 'drill' ? true : null,
            dataFlyRemove: (el, s)=>el.call('assistantFlyCardCloses', s) === 'remove' ? true : null,
            ariaLabel: (el, s)=>el.call('assistantFlyCardCloseLabel', s),
            title: (el, s)=>el.call('assistantFlyCardCloseLabel', s),
            disabled: (el, s)=>(el.call('assistantFlyPages', s.root) || []).some((page)=>page.key === s.page && page.save === 'saving'),
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('assistantFlyCardClose', s);
            },
            Icon: {
                name: 'x'
            }
        }
    },
    HomeWidgetEmpty: {
        Action: {
            hide: ()=>true
        }
    }
};

});

parcelRegister("6QQog", function(module, exports) {

$parcel$export(module.exports, "AssistantFlyStart", () => $4fd03d0625785188$export$5b3595c2cce0ae71);
$parcel$export(module.exports, "AssistantFlyStartPress", () => $4fd03d0625785188$export$521152a3fdf7733a);
$parcel$export(module.exports, "AssistantFlyStartTile", () => $4fd03d0625785188$export$c4050243badb1c3a);
$parcel$export(module.exports, "AssistantFlyStartPartTitle", () => $4fd03d0625785188$export$50323e4b1887e4ae);
$parcel$export(module.exports, "AssistantFlyStartEvent", () => $4fd03d0625785188$export$5726e0bba77e5f9b);
$parcel$export(module.exports, "AssistantFlyStartRecentPage", () => $4fd03d0625785188$export$84b3660ed93ef09b);
$parcel$export(module.exports, "AssistantFlyStartRecentCard", () => $4fd03d0625785188$export$df4f596dc951733a);
// THE FLY START SCREEN — an empty session's first screen, made from the
// workspace on screen (functions/assistantFlyStart.js; Nika 2026-10-22: "give
// fly initial screen to start from based on each workspace", then "make fly
// same width as dashboard. fly should first show current summary when its
// empty on each workspace according to their data").
//
//   the summary  FIRST: the day and the workspace · the home's greeting ·
//                where the workspace stands — the dashboard's own summary
//                (HomeSummaryBrief: the signals' sentences, AI or template,
//                each fact a link to its list; Updated · Refresh), or one calm
//                line when nothing needs the person
//   the asks     "Ask <workspace> for the page you need." · one line on what
//                Fly does · the tiles — live FIGURES (what needs the person,
//                from the installed apps' signals) and the workspace's own
//                ASKS (its starters), the first the large one, as many as fill
//                whole rows on the dashboard's columns
//   the more     Next up · Recent — what comes next, the pages put away (an
//                empty part leaves no gap)
//   first run    on a NEW workspace only: "Get started", four steps that
//                mirror the activation rule (components/AssistantFlyFirstRun.js;
//                last, so its late read moves nothing above it)
//
// No tools row (Nika 2026-10-23: "open workspace tools is already in top menu
// so whats the point?"): the top menu opens every app, and Add section is a
// row of the composer's "+" menu (functions/assistantFlyWorkspace.js
// assistantFlySectionOffered).
//
// As wide as the dashboard: the view's grid (functions/assistantFly.js
// assistantFlyMeasure) gives the tiles their tracks; text keeps its reading
// measure. It holds no logic: every value comes from functions/
// assistantFlyStart.js through `el.call`. It shows while the canvas is open
// with no page; the first ask replaces it with the page (the view's own
// crossfade). It never moves a tile it already shows: the slots hold
// skeletons until the first signals pass has answered (Rule 66).
const $4fd03d0625785188$export$5b3595c2cce0ae71 = {
    tag: 'section',
    dataFlyStart: true,
    hide: (el, s)=>!el.call('assistantFlyStartShown', s.root),
    flow: 'y',
    gap: 'C',
    width: '100%',
    marginInline: 'auto',
    minWidth: '0',
    boxSizing: 'border-box',
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    // What the screen needs is asked only while it SHOWS (it stays mounted,
    // hidden, on every home): at mount when it shows at once, then whenever it
    // comes back, the workspace becomes ready, its apps land or the member's
    // preferences row is read — the cached starter set lives there, so it is
    // judged only once the row has landed (STARTERS-ONCE). The framework's
    // declarative effect never fires on the first render, hence onRender.
    onRender: (el, s)=>el.call('assistantFlyStartPrime', s.root),
    stateDeps: [
        (el, s)=>!!el.call('assistantFlyStartShown', s.root),
        (el, s)=>!!(s.root && s.root.workspaceReady),
        (el, s)=>s.root && Array.isArray(s.root.workspaceApps) ? s.root.workspaceApps.length : -1,
        (el, s)=>!!(s.root && s.root.userPrefs && typeof s.root.userPrefs === 'object')
    ],
    onStateUpdate: (el, s)=>el.call('assistantFlyStartPrime', s.root),
    // ── THE SUMMARY — where this workspace stands, before anything is asked ───
    FlyStartHead: {
        tag: 'header',
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        boxSizing: 'border-box',
        padding: 'B',
        round: 'radiusCard',
        background: (el)=>el.call('assistantFlyOnHome', el) ? 'var(--home-card-bg, var(--theme-card-background))' : 'cardSolid',
        '@mobileL': {
            padding: 'A'
        },
        // The day and the workspace, in the page eyebrow's voice.
        FlyStartEyebrow: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z',
            fontWeight: '500',
            lineHeight: '1.3',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'inactive',
            text: (el, s)=>{
                const day = el.call('localizedDate', Date.now(), {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long'
                });
                const scope = String(el.call('assistantScopeName', s.root) || '');
                return scope ? day + " \xb7 " + scope : String(day || '');
            }
        },
        // The workspace greeting anchors the summary before the adaptive asks.
        // A line, not a heading (the page's one h1 is the shell's).
        FlyStartGreeting: {
            tag: 'p',
            margin: '0',
            fontSize: 'C',
            fontWeight: '400',
            lineHeight: '1.25',
            color: 'title',
            overflowWrap: 'anywhere',
            GreetingLead: {
                tag: 'span',
                text: (el, s)=>(el.call('assistantFlyStartGreeting', s) || {}).lead || ''
            },
            GreetingName: {
                tag: 'span',
                fontWeight: '700',
                text: (el, s)=>(el.call('assistantFlyStartGreeting', s) || {}).name || ''
            }
        },
        // Nothing to summarise: the calm line (the summary keeps its Updated ·
        // Refresh row under it).
        FlyStartCalm: {
            tag: 'p',
            dataFlyStartCalm: true,
            margin: '0',
            maxWidth: 'I',
            fontSize: 'A',
            lineHeight: '1.5',
            color: 'caption',
            hide: (el, s)=>!el.call('assistantFlyStartCalm', s.root),
            text: (el, s)=>el.call('assistantFlyStartCalm', s.root)
        },
        // The dashboard's own summary: the same model, the same sentences and
        // links, its skeleton while the signals answer. Its figures are the tiles
        // below (each one a page), so the AI sentence's own chip row and the
        // board's "Open as board" stay on the dashboard.
        HomeSummaryBrief: {
            dataFlyStartSummary: true,
            BriefChips: {
                hide: ()=>true
            },
            BriefMeta: {
                AppCapsuleBtnGhost_board: {
                    hide: ()=>true
                }
            }
        }
    },
    // ── THEN WHAT TO ASK ──────────────────────────────────────────────────────
    FlyStartAsks: {
        flow: 'y',
        gap: 'A',
        minWidth: '0',
        FlyStartIntro: {
            flow: 'y',
            gap: 'Y',
            minWidth: '0',
            // One text node keeps the word boundary in both the DOM and spoken name.
            FlyStartTitle: {
                tag: 'h2',
                margin: '0',
                fontSize: 'B',
                fontWeight: '700',
                lineHeight: '1.3',
                color: 'title',
                overflowWrap: 'anywhere',
                text: (el, s)=>String(el.call('polyglot', 'workspace.flyStart.titleLead')).replace('{workspace}', String(el.call('assistantScopeName', s.root) || '')) + ' ' + String(el.call('polyglot', 'workspace.flyStart.titleRest'))
            },
            FlyStartLead: {
                tag: 'p',
                margin: '0',
                maxWidth: 'H',
                fontSize: 'Z2',
                lineHeight: '1.5',
                color: 'caption',
                text: '{{ workspace.flyStart.lead | polyglot }}'
            }
        },
        // The tiles: the dashboard's columns (three to six; two on a phone), the
        // large tile two by two beside the smaller ones, packed densely. Every
        // row is as tall as the tallest (`1fr` in a grid of no set height), so the
        // tiles line up in even rows whatever their words.
        FlyStartTiles: {
            role: 'group',
            dataFlyStartTiles: true,
            ariaLabel: (el)=>el.call('polyglot', 'workspace.flyStart.tilesLabel'),
            display: 'grid',
            style: (el, s)=>({
                    '--fly-start-cols': String(el.call('assistantFlyStartTracks', s))
                }),
            gridTemplateColumns: 'repeat(var(--fly-start-cols, 3), minmax(0, 1fr))',
            gridAutoRows: 'minmax(var(--spacing-E), 1fr)',
            gridAutoFlow: 'row dense',
            gap: 'A',
            minWidth: '0',
            '@mobileL': {
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
            },
            children: (el, s)=>el.call('assistantFlyStartTiles', s.root, el.call('assistantFlyStartTracks', s)),
            childrenAs: 'state',
            childExtends: 'AssistantFlyStartTile'
        }
    },
    // ── WHAT IS NEXT, WHAT YOU ASKED (Nika 2026-10-23: "make fly starter screen
    // more advanced", "expand fly empty screen functionality", then "remove
    // members from init fly. make better design for recent") ─────────────────
    //   Next up  what is next for the person — the dashboard's Next up: their
    //            events and the installed apps' upcoming items (a viewing, …):
    //            when, what, its times; one press joins a call, or opens it
    //            (functions/assistantFlyStart.js assistantFlyStartNext)
    //   Recent   the pages a fresh Fly put away (the logo, the home icon, New),
    //            newest first, as cards of the tiles' family: a press asks
    //            again — a new page on live data
    // Side by side where they fit, one under the other on a narrow screen; a
    // part with nothing in it leaves no gap. (Members left the screen: a call
    // is still one ask away — "call Nika", functions/assistantFlyPeople.js.)
    FlyStartMore: {
        dataFlyStartMore: true,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-H)), 1fr))',
        gap: 'B',
        minWidth: '0',
        // the apps' upcoming items (Next up's providers' pass,
        // assistantFlyStartNextCollect) — every key declared, so a read never
        // falls back to a root key of the same name
        state: {
            upcoming: null
        },
        onRender: (el, s)=>el.call('assistantFlyStartNextCollect', el, s),
        stateDeps: [
            (el, s)=>s.root ? s.root._meetingInviteTick : null,
            (el, s)=>!!el.call('assistantFlyStartShown', s.root),
            (el, s)=>s.root && Array.isArray(s.root.workspaceApps) ? s.root.workspaceApps.length : -1
        ],
        onStateUpdate: (el, s)=>el.call('assistantFlyStartNextCollect', el, s),
        hide: (el, s)=>!(el.call('assistantFlyStartNext', s.root, 3, s.upcoming) || []).length && !(el.call('assistantFlyStartRecent', s.root) || []).length,
        FlyStartNext: {
            tag: 'section',
            dataFlyStartNext: true,
            flow: 'y',
            gap: 'Z',
            minWidth: '0',
            ariaLabel: (el)=>el.call('polyglot', 'workspace.widget.nextUp.title'),
            hide: (el, s)=>!(el.call('assistantFlyStartNext', s.root, 3, s.upcoming) || []).length,
            AssistantFlyStartPartTitle: {
                text: '{{ workspace.widget.nextUp.title | polyglot }}'
            },
            FlyStartNextList: {
                role: 'list',
                flow: 'y',
                gap: 'X',
                minWidth: '0',
                // "in 12 min" moves with the shell's 30 s tick; the calendar window
                // brings new events
                childrenDeps: [
                    'intranetEvents',
                    '_meetingInviteTick'
                ],
                children: (el, s)=>el.call('assistantFlyStartNext', s.root, 3, s.upcoming),
                childrenAs: 'state',
                childExtends: 'AssistantFlyStartEvent'
            }
        },
        FlyStartRecent: {
            tag: 'section',
            dataFlyStartRecent: true,
            flow: 'y',
            gap: 'Z',
            minWidth: '0',
            ariaLabel: (el)=>el.call('polyglot', 'workspace.aiScope.group.recent'),
            hide: (el, s)=>!(el.call('assistantFlyStartRecent', s.root) || []).length,
            AssistantFlyStartPartTitle: {
                text: '{{ workspace.aiScope.group.recent | polyglot }}'
            },
            // Cards of one width on the part's own tracks — as many as fit, a few
            // pages never stretch across the screen (empty tracks stay empty); two
            // on a phone, like the tiles. Every row as tall as its tallest card.
            FlyStartRecentList: {
                role: 'list',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-G)), 1fr))',
                gridAutoRows: '1fr',
                gap: 'Z',
                minWidth: '0',
                '@mobileL': {
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
                },
                children: (el, s)=>el.call('assistantFlyStartRecent', s.root),
                childrenAs: 'state',
                childExtends: 'AssistantFlyStartRecentCard'
            }
        }
    },
    // ── A PERSONALIZED SIGN-UP'S FIRST THREAD (POB S7) ───────────────────────
    // what research read and from where, the three offers (Website · Team ·
    // Imports) and "Getting started" — only in the workspace of a personalized
    // sign-up (functions/assistantFlyResearch.js); the generic first steps
    // below step aside there
    AssistantFlyResearch: {},
    // ── A NEW WORKSPACE'S FIRST STEPS (fly docs/FUNNEL.md §4 G5) ──────────────
    // "Get started": invite · records · website · ask, from the server's
    // activation read; hidden everywhere else (functions/assistantFlyFirstRun.js)
    AssistantFlyFirstRun: {}
};
const $4fd03d0625785188$export$521152a3fdf7733a = {
    tag: 'button',
    type: 'button',
    position: 'relative',
    minWidth: '0',
    boxSizing: 'border-box',
    borderWidth: '0',
    background: (el)=>el.call('assistantFlyOnHome', el) ? 'var(--home-card-bg, var(--theme-card-background))' : 'cardSolid',
    color: 'title',
    textAlign: 'left',
    fontFamily: 'inherit',
    cursor: 'pointer',
    touchAction: 'manipulation',
    // the wash lies UNDER the words (its own stacking context, the layer at -1):
    // a hover darkens the card's fill, never its text — a press holds no layer
    // that must paint over its neighbours
    isolation: 'isolate',
    '::after': {
        content: '""',
        position: 'absolute',
        inset: '0',
        zIndex: '-1',
        borderRadius: 'inherit',
        background: 'cardHover',
        opacity: '0',
        pointerEvents: 'none',
        transition: 'opacity A defaultBezier'
    },
    '@fine': {
        ':hover:not([disabled])::after': {
            opacity: '1'
        }
    },
    ':active:not([disabled])::after': {
        opacity: '1',
        background: 'cardPress'
    },
    ':focus-visible': {
        shadow: 'focusRing'
    }
};
const $4fd03d0625785188$export$c4050243badb1c3a = {
    extends: 'AssistantFlyStartPress',
    dataFlyStartTile: (el, s)=>s && s.kind || null,
    dataHero: (el, s)=>s && s.hero ? 'true' : null,
    dataTall: (el, s)=>s && s.tall ? 'true' : null,
    dataSeverity: (el, s)=>s && s.kind === 'figure' && s.severity || null,
    disabled: (el, s)=>!s || s.kind === 'skeleton' ? true : null,
    ariaBusy: (el, s)=>!s || s.kind === 'skeleton' ? 'true' : null,
    ariaLabel: (el, s)=>el.call('assistantFlyStartLabel', s) || null,
    title: (el, s)=>s && s.kind !== 'skeleton' && s.prompt !== s.text ? s.prompt : null,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 'Z',
    padding: 'A1',
    round: 'radiusCard',
    // WHOLE ROWS (functions/assistantFlyStart.js `shape`): a tile spans the
    // tracks its row gives it — the large tile two (a lone one the row), the
    // last one what its row has left — and the large tile is two rows tall
    // (`tall`) only beside a full first row, from the tablet step up: on a phone
    // it fills its row, and two even rows made it a 416 px block (dev, 390 px).
    // A phone's two tracks span nothing else.
    style: (el, s)=>({
            '--fly-tile-span': String(s && s.span || 1)
        }),
    gridColumn: 'span var(--fly-tile-span, 1)',
    '@mobileL<': {
        '&[data-tall="true"]': {
            gridRow: 'span 2'
        }
    },
    '@mobileL': {
        gridColumn: 'auto',
        '&[data-hero="true"]': {
            gridColumn: 'span 2'
        }
    },
    '&[data-fly-start-tile="skeleton"]': {
        cursor: 'default'
    },
    onClick: (e, el, s)=>el.call('assistantFlyStartAsk', s),
    // ── The figure (a figure tile) or the app (an ask tile) ───────────────────
    TileHead: {
        flow: 'x',
        align: 'center',
        flexWrap: 'wrap',
        gap: 'Y',
        minWidth: '0',
        hide: (el, s)=>!s || s.kind === 'skeleton',
        // A figure reads as one line — the count and its words on one baseline.
        ':is([data-fly-start-tile="figure"]) &': {
            alignItems: 'baseline'
        },
        TileNumeral: {
            tag: 'span',
            hide: (el, s)=>!s || s.kind !== 'figure',
            flexShrink: '0',
            fontSize: 'C',
            fontWeight: '700',
            lineHeight: '1',
            fontVariantNumeric: 'tabular-nums',
            // The large tile's count is the screen's headline figure.
            ':is([data-fly-start-tile][data-hero="true"]) &': {
                fontSize: 'H'
            },
            text: (el, s)=>s && s.count || ''
        },
        TileWords: {
            tag: 'span',
            hide: (el, s)=>!s || s.kind !== 'figure',
            minWidth: '0',
            fontSize: 'Z2',
            lineHeight: '1.35',
            color: 'caption',
            text: (el, s)=>s && s.words || ''
        },
        AppGlyphTile: {
            hide: (el, s)=>!s || s.kind !== 'ask'
        },
        TileApp: {
            tag: 'span',
            hide: (el, s)=>!s || s.kind !== 'ask' || !s.app,
            minWidth: '0',
            fontSize: 'Z2',
            color: 'caption',
            text: (el, s)=>s && s.app || ''
        }
    },
    // A figure's app, with its severity: a dot in the danger ink (urgent), the
    // warning ink (attention) or the caption ink (information) — the words of
    // the severity are in the tile's name.
    TileMeta: {
        flow: 'x',
        align: 'center',
        gap: 'Y',
        minWidth: '0',
        hide: (el, s)=>!s || s.kind !== 'figure' || !s.app && !s.more,
        fontSize: 'Z',
        color: 'caption',
        TileDot: {
            tag: 'span',
            ariaHidden: 'true',
            boxSize: 'Y',
            flexShrink: '0',
            round: 'radiusPill',
            background: 'currentColor',
            ':is([data-fly-start-tile][data-severity="urgent"]) &': {
                background: 'dangerInk'
            },
            ':is([data-fly-start-tile][data-severity="attention"]) &': {
                background: 'warningInk'
            }
        },
        TileMetaText: {
            tag: 'span',
            minWidth: '0',
            text: (el, s)=>{
                if (!s) return '';
                return [
                    s.app,
                    s.more
                ].filter(Boolean).join(" \xb7 ");
            }
        }
    },
    // ── The ask ────────────────────────────────────────────────────────────────
    TileFoot: {
        flow: 'x',
        align: 'flex-end space-between',
        gap: 'Z',
        minWidth: '0',
        marginTop: 'auto',
        // A phone's half-row tile left the ask 116px beside the arrow, and a long
        // Georgian word (გასაკეთებელი? — 128px) broke in the middle (390px, dev
        // 2026-10-23): there the arrow steps under the ask, which takes the tile's
        // whole width.
        '@mobileL': {
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: 'Y'
        },
        hide: (el, s)=>!s || s.kind === 'skeleton',
        TileAsk: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'A',
            fontWeight: '500',
            lineHeight: '1.3',
            overflowWrap: 'anywhere',
            ':is([data-fly-start-tile][data-hero="true"]) &': {
                fontSize: 'C',
                fontWeight: '700'
            },
            '@mobileL': {
                alignSelf: 'stretch'
            },
            text: (el, s)=>s && s.text || ''
        },
        Icon: {
            name: 'arrowRight',
            boxSize: 'iconSm',
            flexShrink: '0'
        }
    },
    TileSkeleton: {
        flow: 'y',
        gap: 'Y',
        width: '100%',
        hide: (el, s)=>!!s && s.kind !== 'skeleton',
        Skeleton_1: {
            width: '38%',
            height: 'B'
        },
        Skeleton_2: {
            width: '86%',
            height: 'A'
        },
        Skeleton_3: {
            width: '58%',
            height: 'A'
        }
    }
};
const $4fd03d0625785188$export$50323e4b1887e4ae = {
    tag: 'h3',
    margin: '0',
    fontSize: 'Z',
    fontWeight: '500',
    lineHeight: '1.3',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'inactive'
};
const $4fd03d0625785188$export$5726e0bba77e5f9b = {
    extends: 'AssistantFlyStartPress',
    role: 'listitem',
    dataFlyStartEvent: (el, s)=>s && s.key || null,
    ariaLabel: (el, s)=>s ? [
            s.when,
            s.title,
            s.time
        ].filter(Boolean).join(" \xb7 ") + " \u2014 " + String(el.call('polyglot', s.label || 'common.action.open')) : null,
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    padding: 'Z A',
    round: 'radiusCard',
    onClick: (e, el, s)=>el.call('assistantFlyStartEventOpen', s),
    EventWhen: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Z2',
        fontWeight: '700',
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
        text: (el, s)=>s && s.when || ''
    },
    EventText: {
        flow: 'y',
        gap: 'X',
        flex: '1',
        minWidth: '0',
        EventTitle: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s && s.title || ''
        },
        EventTime: {
            tag: 'span',
            fontSize: 'Z',
            color: 'inactive',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>s && s.time || ''
        }
    },
    EventAction: {
        tag: 'span',
        flexShrink: '0',
        padding: 'X Z',
        round: 'radiusPill',
        background: 'selected',
        fontSize: 'Z',
        fontWeight: '500',
        text: (el, s)=>String(el.call('polyglot', s && s.label || 'common.action.open'))
    }
};
const $4fd03d0625785188$export$84b3660ed93ef09b = {
    extends: 'AssistantFlyStartPress',
    role: 'listitem',
    ariaLabel: (el, s)=>String(el.call('polyglot', 'workspace.assistantFly.again')) + ': ' + (s && s.title || ''),
    title: (el, s)=>s && s.prompt && s.prompt !== s.title ? s.prompt : null,
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    padding: 'Z A',
    round: 'radiusCard',
    onClick: (e, el, s)=>el.call('assistantFlyStartAsk', s),
    RecentTitle: {
        tag: 'span',
        flex: '1',
        minWidth: '0',
        fontSize: 'Z2',
        fontWeight: '500',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s && s.title || ''
    },
    RecentWhen: {
        tag: 'span',
        flexShrink: '0',
        fontSize: 'Z',
        color: 'inactive',
        text: (el, s)=>s && s.at ? String(el.call('timeAgo', s.at) || '') : ''
    },
    Icon: {
        name: 'arrowRight',
        boxSize: 'iconSm',
        flexShrink: '0',
        color: 'caption'
    }
};
const $4fd03d0625785188$export$df4f596dc951733a = {
    extends: 'AssistantFlyStartRecentPage',
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr) auto',
    gridTemplateRows: 'auto 1fr',
    gridTemplateAreas: '"mark when ." "title title go"',
    alignItems: 'center',
    columnGap: 'Y',
    rowGap: 'B',
    padding: 'A',
    round: 'radiusCard',
    RecentTitle: {
        gridArea: 'title',
        alignSelf: 'end',
        fontSize: 'A',
        lineHeight: '1.35',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        lineClamp: '2'
    },
    RecentWhen: {
        gridArea: 'when',
        minWidth: '0',
        color: 'caption',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    Icon: {
        gridArea: 'go',
        alignSelf: 'end'
    },
    Icon_history: {
        gridArea: 'mark',
        ariaHidden: 'true',
        name: 'sfHistory',
        boxSize: 'iconSm',
        color: 'caption'
    }
};

});

parcelRegister("kdD0n", function(module, exports) {

$parcel$export(module.exports, "AssistantFlyFirstRun", () => $eb83472a9a092a01$export$42826ae29db5d30c);
$parcel$export(module.exports, "AssistantFlyFirstRunStep", () => $eb83472a9a092a01$export$700600f709856c91);
$parcel$export(module.exports, "AssistantFlyFirstRunPress", () => $eb83472a9a092a01$export$74adb684d98c318);
$parcel$export(module.exports, "AssistantFlyFirstRunFace", () => $eb83472a9a092a01$export$9a2725e883dd83a6);
$parcel$export(module.exports, "AssistantFlyFirstRunLeadIn", () => $eb83472a9a092a01$export$265ee2a7dfaabf32);
// THE FIRST RUN — "Get started", the Fly start screen's last part on a NEW
// workspace (functions/assistantFlyFirstRun.js; fly docs/FUNNEL.md §4 G5).
// Four steps that mirror the activation rule — invite your team · add your
// first records · publish your website · ask your workspace — each a card of
// the tiles' family with its live progress and ONE action; a done step wears
// the plain tick and is no control. The head names the part, says one line
// (what Fly already made, when the person came from Fly) and hides it for this
// workspace (the X).
//
// THE START SCREEN'S LAST PART, on purpose: the read lands after the screen
// paints, so a part ABOVE the tiles would push them down under the person's
// pointer (Rule 66); last, it moves nothing when it comes or goes. While the
// steps are on screen an activation shows the done state in the same box.
//
// It holds no logic: every value comes from functions/assistantFlyFirstRun.js
// through `el.call`. Hidden — and it asks nothing — while the start screen is
// hidden, until the shell's SDK has the activation read, and wherever the
// answer says the workspace is activated or out of its window.
const $eb83472a9a092a01$export$42826ae29db5d30c = {
    tag: 'section',
    dataFlyFirstRun: (el, s)=>el.call('assistantFlyFirstRunView', s.root).mode || null,
    ariaLabel: (el, s)=>el.call('assistantFlyFirstRunView', s.root).title || null,
    hide: (el, s)=>!el.call('assistantFlyFirstRunView', s.root).show,
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    // asked while the start screen SHOWS: at mount, then whenever it comes
    // back, the workspace changes or becomes ready, and on the shell's 30 s
    // tick (the read itself keeps a minute between asks)
    onRender: (el, s)=>el.call('assistantFlyFirstRunPrime', el, s),
    stateDeps: [
        (el, s)=>!!el.call('assistantFlyStartShown', s.root),
        (el, s)=>!!(s.root && s.root.workspaceReady),
        (el, s)=>s.root && s.root.workspace ? String(s.root.workspace.id || s.root.workspace._id || '') : '',
        (el, s)=>s.root ? s.root._meetingInviteTick : null
    ],
    onStateUpdate: (el, s)=>el.call('assistantFlyFirstRunPrime', el, s),
    FirstRunHead: {
        flow: 'x',
        align: 'flex-start space-between',
        gap: 'A',
        minWidth: '0',
        FirstRunIntro: {
            flow: 'y',
            gap: 'X',
            minWidth: '0',
            AssistantFlyStartPartTitle: {
                text: (el, s)=>el.call('assistantFlyFirstRunView', s.root).title
            },
            FirstRunLead: {
                tag: 'p',
                dataFlyFirstRunLead: true,
                margin: '0',
                maxWidth: 'H',
                fontSize: 'Z2',
                lineHeight: '1.5',
                color: 'caption',
                text: (el, s)=>el.call('assistantFlyFirstRunView', s.root).lead
            }
        },
        // the person's own choice for THIS workspace, kept on their record (the
        // brand CloseButton takes a flat name before its own default)
        CloseButton: {
            dataFlyFirstRunHide: true,
            ariaLabel: (el, s)=>el.call('assistantFlyFirstRunView', s.root).hideLabel || null,
            onClick: (e, el)=>el.call('assistantFlyFirstRunDismiss')
        }
    },
    // THE PRESETS' LEAD-IN — one line, not a step (AssistantFlyFirstRunLeadIn).
    AssistantFlyFirstRunLeadIn: {},
    // The cards on whole rows, never a hole: as many abreast as there are steps
    // (four in a team workspace, three in a personal one — the answer's
    // `applies`); from the tablet step four become two by two and three stay
    // one row; one on a small phone. Every row as tall as its tallest card.
    FirstRunSteps: {
        role: 'list',
        dataFlyFirstRunSteps: true,
        display: 'grid',
        style: (el, s)=>{
            const n = el.call('assistantFlyFirstRunView', s.root).cols || 4;
            return {
                '--fly-first-run-cols': String(n),
                '--fly-first-run-cols-mid': String(n === 4 ? 2 : n)
            };
        },
        gridTemplateColumns: 'repeat(var(--fly-first-run-cols, 4), minmax(0, 1fr))',
        gridAutoRows: '1fr',
        gap: 'Z',
        minWidth: '0',
        '@tabletS': {
            gridTemplateColumns: 'repeat(var(--fly-first-run-cols-mid, 2), minmax(0, 1fr))'
        },
        '@mobileS': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        },
        children: (el, s)=>el.call('assistantFlyFirstRunView', s.root).steps,
        childrenAs: 'state',
        childExtends: 'AssistantFlyFirstRunStep'
    }
};
const $eb83472a9a092a01$export$700600f709856c91 = {
    role: 'listitem',
    display: 'flex',
    minWidth: '0',
    dataFlyFirstRunStep: (el, s)=>s && s.step || null,
    dataDone: (el, s)=>s && s.done ? 'true' : null,
    AssistantFlyFirstRunPress: {
        hide: (el, s)=>!s || !!s.done,
        onClick: (e, el, s)=>el.call('assistantFlyFirstRunOpen', s, el)
    },
    AssistantFlyFirstRunFace: {
        hide: (el, s)=>!s || !s.done
    }
};
const $eb83472a9a092a01$export$74adb684d98c318 = {
    extends: [
        'AssistantFlyStartPress',
        'AssistantFlyFirstRunFace'
    ]
};
const $eb83472a9a092a01$export$9a2725e883dd83a6 = {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 'A',
    minWidth: '0',
    padding: 'A',
    round: 'radiusCard',
    boxSizing: 'border-box',
    background: (el)=>el.call('assistantFlyOnHome', el) ? 'var(--home-card-bg, var(--theme-card-background))' : 'cardSolid',
    color: 'title',
    textAlign: 'left',
    FaceHead: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        FaceTitleRow: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            Icon: {
                ariaHidden: 'true',
                name: (el, s)=>s && s.icon || 'magicstar',
                boxSize: 'iconSm',
                flexShrink: '0',
                color: (el, s)=>s && s.done ? 'title' : 'caption'
            },
            FaceTitle: {
                tag: 'span',
                minWidth: '0',
                fontSize: 'A',
                fontWeight: '500',
                lineHeight: '1.3',
                overflowWrap: 'anywhere',
                text: (el, s)=>s && s.title || ''
            }
        },
        FaceHint: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'Z2',
            lineHeight: '1.45',
            color: 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.hint || ''
        }
    },
    FaceFoot: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        FaceProgress: {
            tag: 'span',
            dataFlyFirstRunProgress: true,
            flexShrink: '0',
            fontSize: 'Z',
            color: 'caption',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>s && s.progress || ''
        },
        FaceAction: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            marginLeft: 'auto',
            fontSize: 'Z2',
            fontWeight: '500',
            FaceActionText: {
                tag: 'span',
                minWidth: '0',
                overflowWrap: 'anywhere',
                text: (el, s)=>s && s.action || ''
            },
            Icon: {
                ariaHidden: 'true',
                name: 'arrowRight',
                boxSize: 'iconSm',
                flexShrink: '0',
                hide: (el, s)=>!s || !!s.done
            }
        }
    }
};
const $eb83472a9a092a01$export$265ee2a7dfaabf32 = {
    extends: 'AssistantFlyStartPress',
    dataFlyFirstRunPreset: true,
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    padding: 'Z A',
    round: 'radiusCard',
    hide: (el, s)=>!el.call('assistantFlyFirstRunPresetLine', s.root),
    // the registry is read while the start screen shows (the read settles
    // whether this host can apply presets at all)
    onRender: (el, s)=>el.call('assistantFlyFirstRunPresetPrime', el, s),
    stateDeps: [
        (el, s)=>!!el.call('assistantFlyStartShown', s.root),
        (el, s)=>s.root && s.root.workspace ? String(s.root.workspace.id || s.root.workspace._id || '') : ''
    ],
    onStateUpdate: (el, s)=>el.call('assistantFlyFirstRunPresetPrime', el, s),
    onClick: (e, el)=>el.call('assistantFlyFirstRunPresetOpen'),
    Icon: {
        ariaHidden: 'true',
        name: 'layers',
        boxSize: 'iconSm',
        flexShrink: '0',
        color: 'caption'
    },
    LeadInText: {
        tag: 'span',
        flex: '1',
        minWidth: '0',
        fontSize: 'Z2',
        fontWeight: '500',
        lineHeight: '1.4',
        overflowWrap: 'anywhere',
        text: '{{ workspace.firstRun.presetLine | polyglot }}'
    },
    Icon_1: {
        ariaHidden: 'true',
        name: 'arrowRight',
        boxSize: 'iconSm',
        flexShrink: '0',
        color: 'caption'
    }
};

});

parcelRegister("fB8Yp", function(module, exports) {

$parcel$export(module.exports, "AssistantFlyResearch", () => $b5b145a68302fe61$export$7ec8b4bd1fb0153);
$parcel$export(module.exports, "AssistantFlyResearchSummary", () => $b5b145a68302fe61$export$7e50253b79884b4a);
$parcel$export(module.exports, "AssistantFlyResearchLine", () => $b5b145a68302fe61$export$8549516aaa49efb8);
$parcel$export(module.exports, "AssistantFlyOffers", () => $b5b145a68302fe61$export$127594c8dc6580d4);
$parcel$export(module.exports, "AssistantFlyOfferCard", () => $b5b145a68302fe61$export$122a2b56586e83d7);
$parcel$export(module.exports, "AssistantFlyChecklist", () => $b5b145a68302fe61$export$c71654a2336eaffd);
$parcel$export(module.exports, "AssistantFlyChecklistItem", () => $b5b145a68302fe61$export$f929ce016c17e599);
// THE FIRST THREAD of a personalized sign-up (POB S7) — the Fly start
// screen's last part for the person who signed up with their website read
// (functions/assistantFlyResearch.js tells who, what it reads and from where;
// decision 11 of 2026-10-25). Three parts, in order:
//
//   AssistantFlyResearchSummary  what was read and from where — a line per
//                                fact with its page as a link (and, with the
//                                next SDK, its own delete); Review what I
//                                read, with Done to confirm it; Delete all
//                                research (every delete: confirm first)
//   AssistantFlyOffers           Website · Team · Imports (AssistantFlyOfferCard):
//                                nothing acts on its own; an offer whose read
//                                or sheet is not there yet says "Soon"
//   AssistantFlyChecklist        Getting started (AssistantFlyChecklistItem):
//                                the server's ticks only; one line on a phone
//
// The block holds its reads in its OWN state (every key declared, so no read
// falls back to a root key of the same name — and the checklist never reads
// a flag another surface set). It asks when the start screen shows, when it
// comes back, the workspace changes or the person's record arrives
// (stateDeps), and when the window gets the focus back (the checklist's
// "re-read when focus returns"). It appears once its first read is in,
// whole, as the screen's last part: it moves nothing above it (Rule 66).
// Kept mounted, only hidden.
const $b5b145a68302fe61$export$7ec8b4bd1fb0153 = {
    tag: 'section',
    dataFlyResearch: true,
    state: {
        pobWs: '',
        pobReadAt: 0,
        pobResearch: null,
        pobPeopleOk: false,
        pobPeople: [],
        pobSourcesOk: false,
        pobSources: [],
        pobReviewOpen: false,
        pobDeleting: false,
        pobDeleted: null,
        pobDeleteFailed: false,
        pobChecklistOpen: false,
        // the board's checklist as the block last read it; what this SDK can do
        pobBoardChecklist: null,
        pobCanReview: false,
        pobCanDeleteLine: false,
        // Done on the review; one line's delete
        pobReviewing: false,
        pobReviewFailed: false,
        pobDeletingLine: '',
        pobLineDeleted: ''
    },
    hide: (el, s)=>!el.call('assistantFlyResearchShown', s.root, s),
    flow: 'y',
    gap: 'B',
    minWidth: '0',
    onRender: (el, s)=>el.call('assistantFlyResearchPrime', el, s),
    stateDeps: [
        (el, s)=>!!el.call('assistantFlyStartShown', s.root),
        (el, s)=>!!(s.root && s.root.workspaceReady),
        (el, s)=>s.root && s.root.workspace ? String(s.root.workspace.id || s.root.workspace._id || '') : '',
        (el, s)=>s.root && s.root._pobBuild ? s.root._pobBuild.status : '',
        // the person's record: it arrives after the first paint (the preferences
        // load late) or changes its kind — POB or Fly, the board is asked then
        (el, s)=>{
            const p = s.root && s.root.userPrefs;
            const ob = p && p.onboarding && typeof p.onboarding === 'object' ? p.onboarding : null;
            return ob ? String(ob.via || '') + '/' + String(ob.origin || '') : '';
        }
    ],
    // the screen opened again, the workspace changed or the record arrived:
    // the reads again
    onStateUpdate: (el, s)=>el.call('assistantFlyResearchPrime', el, s, {
            force: true
        }),
    // the focus came back (an invite sent, an import run in another tab): the
    // checklist is the server's, so it is read again
    onWindowFocus: (e, el, s)=>el.call('assistantFlyResearchPrime', el, s, {
            force: true
        }),
    AssistantFlyResearchSummary: {},
    AssistantFlyOffers: {},
    AssistantFlyChecklist: {}
};
const $b5b145a68302fe61$export$7e50253b79884b4a = {
    tag: 'section',
    dataFlyResearchSummary: true,
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'B',
    round: 'radiusCard',
    background: (el)=>el.call('assistantFlyOnHome', el) ? 'var(--home-card-bg, var(--theme-card-background))' : 'cardSolid',
    '@mobileL': {
        padding: 'A'
    },
    hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).show,
    ResearchLead: {
        tag: 'p',
        margin: '0',
        fontSize: 'A',
        fontWeight: '500',
        lineHeight: '1.4',
        color: 'title',
        overflowWrap: 'anywhere',
        hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).lead,
        text: (el, s)=>el.call('assistantFlyResearchView', s.root, s).lead
    },
    ResearchLines: {
        tag: 'ul',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).lines.length,
        children: (el, s)=>el.call('assistantFlyResearchView', s.root, s).lines,
        childrenAs: 'state',
        childExtends: 'AssistantFlyResearchLine'
    },
    // Review what I read — the pages, in place
    ResearchPages: {
        tag: 'ul',
        dataFlyResearchPages: true,
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        hide: (el, s)=>{
            const v = el.call('assistantFlyResearchView', s.root, s);
            return !v.reviewOpen || !v.pages.length;
        },
        children: (el, s)=>el.call('assistantFlyResearchView', s.root, s).pages,
        childrenAs: 'state',
        childExtends: 'AssistantFlyResearchLine'
    },
    // Done — the owner read the pages: the server ticks "Review your profile"
    // (owners and admins, with an SDK that has the method)
    ResearchReviewDone: {
        flow: 'x',
        align: 'center',
        minWidth: '0',
        hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).reviewDoneShown,
        AppCapsuleBtnPrimary: {
            dataFlyResearchAction: 'reviewed',
            compact: true,
            disabled: (el, s)=>!!el.call('assistantFlyResearchView', s.root, s).reviewing,
            text: (el, s)=>el.call('assistantFlyResearchView', s.root, s).reviewDoneText,
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('assistantFlyResearchReviewDone', el);
            }
        }
    },
    ResearchDone: {
        tag: 'p',
        role: 'status',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).deletedText,
        text: (el, s)=>el.call('assistantFlyResearchView', s.root, s).deletedText
    },
    ResearchFailed: {
        tag: 'p',
        role: 'alert',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'dangerInk',
        hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).failedText,
        text: (el, s)=>el.call('assistantFlyResearchView', s.root, s).failedText
    },
    ResearchActions: {
        flow: 'x',
        align: 'center',
        flexWrap: 'wrap',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).lines.length,
        AppCapsuleBtnToolbar: {
            dataFlyResearchAction: 'review',
            compact: true,
            ariaExpanded: (el, s)=>el.call('assistantFlyResearchView', s.root, s).reviewOpen ? 'true' : 'false',
            hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).pages.length,
            text: (el, s)=>el.call('assistantFlyResearchView', s.root, s).reviewText,
            onClick: (e, el, s)=>{
                e.stopPropagation();
                s.update({
                    pobReviewOpen: s.pobReviewOpen !== true
                });
            }
        },
        // destructive: the kit's danger capsule (the confirm comes first)
        AppCapsuleBtnDanger: {
            dataFlyResearchAction: 'delete',
            compact: true,
            hide: (el, s)=>!el.call('assistantFlyResearchView', s.root, s).deleteShown,
            disabled: (el, s)=>!!el.call('assistantFlyResearchView', s.root, s).deleting,
            text: '{{ workspace.pobThread.delete | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('assistantFlyResearchDelete', el);
            }
        }
    }
};
const $b5b145a68302fe61$export$8549516aaa49efb8 = {
    tag: 'li',
    flow: 'x',
    align: 'baseline',
    gap: 'Z',
    minWidth: '0',
    isActionRow: (el, s)=>!!(s && s.actionRow === true),
    '.isActionRow': {
        alignItems: 'center',
        minHeight: 'controlHCompact'
    },
    LineBody: {
        flow: 'x',
        align: 'baseline',
        flexWrap: 'wrap',
        gap: 'X Z',
        flex: '1 1 auto',
        minWidth: '0',
        LineText: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'Z2',
            lineHeight: '1.5',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.text || ''
        },
        Link: {
            flow: 'x',
            align: 'center',
            gap: 'X',
            minWidth: '0',
            fontSize: 'Z',
            lineHeight: '1.5',
            color: 'caption',
            textDecoration: 'none',
            target: '_blank',
            rel: 'noopener',
            ':hover': {
                color: 'title',
                textDecoration: 'underline'
            },
            ':active': {
                color: 'title'
            },
            hide: (el, s)=>!(s && s.href),
            href: (el, s)=>s && s.href || null,
            LinkText: {
                tag: 'span',
                overflowWrap: 'anywhere',
                text: (el, s)=>s && s.linkText || ''
            },
            Icon: {
                ariaHidden: 'true',
                name: 'arrowUpRight',
                boxSize: 'iconXs',
                flexShrink: '0'
            }
        }
    },
    // this one fact only — the kit's quiet icon square (the confirm says what)
    CompactIconButton: {
        dataFlyResearchAction: 'deleteLine',
        icon: 'trash',
        hide: (el, s)=>!(s && s.deleteShown === true),
        disabled: (el, s)=>!!(s && s.deleting === true),
        ariaLabel: (el, s)=>s && s.deleteLabel || null,
        title: (el, s)=>s && s.deleteLabel || null,
        onClick: (e, el, s)=>{
            e.stopPropagation();
            el.call('assistantFlyResearchDeleteLine', el, s && s.deleteLine, s && s.text);
        }
    }
};
const $b5b145a68302fe61$export$127594c8dc6580d4 = {
    tag: 'section',
    dataFlyOffers: true,
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    hide: (el, s)=>!el.call('assistantFlyOffersView', s.root, s).show,
    OffersLead: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'caption',
        text: (el, s)=>el.call('assistantFlyOffersView', s.root, s).lead
    },
    OffersRow: {
        role: 'list',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gridAutoRows: '1fr',
        gap: 'Z',
        minWidth: '0',
        '@mobileL': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        },
        children: (el, s)=>el.call('assistantFlyOffersView', s.root, s).rows,
        childrenAs: 'state',
        childExtends: 'AssistantFlyOfferCard'
    }
};
const $b5b145a68302fe61$export$122a2b56586e83d7 = {
    role: 'listitem',
    dataFlyOffer: (el, s)=>s && s.offer || null,
    dataSoon: (el, s)=>s && s.soon === true ? 'true' : null,
    flow: 'y',
    justifyContent: 'space-between',
    gap: 'A',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'A',
    round: 'radiusCard',
    background: (el)=>el.call('assistantFlyOnHome', el) ? 'var(--home-card-bg, var(--theme-card-background))' : 'cardSolid',
    color: 'title',
    OfferHead: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        OfferTitle: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            Icon: {
                ariaHidden: 'true',
                name: (el, s)=>s && s.icon || 'magicstar',
                boxSize: 'iconSm',
                flexShrink: '0',
                color: 'caption'
            },
            OfferName: {
                tag: 'span',
                minWidth: '0',
                fontSize: 'A',
                fontWeight: '500',
                lineHeight: '1.3',
                overflowWrap: 'anywhere',
                text: (el, s)=>s && s.title || ''
            }
        },
        OfferLead: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'Z2',
            lineHeight: '1.45',
            color: 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.lead || ''
        }
    },
    OfferFoot: {
        flow: 'x',
        align: 'center',
        minWidth: '0',
        // not there yet: the kit's status cell, the label carries the meaning.
        // 'neutral', never null: a nullish status falls through to the row's
        // `s.status` inside AppStatusChip (pages/admin/analytics.js, the same)
        AppStatusChip: {
            status: 'neutral',
            label: 'workspace.pobThread.soon',
            hide: (el, s)=>!s || s.soon !== true
        },
        AppCapsuleBtnToolbar: {
            dataFlyOfferAction: (el, s)=>s && s.offer || null,
            compact: true,
            hide: (el, s)=>!s || s.soon === true || !s.href,
            text: (el, s)=>s && s.actionText || '',
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('assistantFlyOfferOpen', s, el);
            }
        }
    }
};
const $b5b145a68302fe61$export$c71654a2336eaffd = {
    tag: 'section',
    dataFlyChecklist: true,
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    hide: (el, s)=>!el.call('assistantFlyChecklistView', s.root, s).show,
    ChecklistHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'A',
        minWidth: '0',
        hide: (el, s)=>el.call('assistantFlyChecklistView', s.root, s).folded,
        AssistantFlyStartPartTitle: {
            text: (el, s)=>el.call('assistantFlyChecklistView', s.root, s).title
        },
        ChecklistCount: {
            tag: 'span',
            fontSize: 'Z',
            color: 'caption',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>el.call('assistantFlyChecklistView', s.root, s).progressText
        }
    },
    // the phone's one line: the count, and the items on demand (function text
    // on its own span beside the chevron — a `{{ }}` label on the button would
    // drop the Icon on a language switch)
    AppCapsuleBtnGhost: {
        dataFlyChecklistFold: true,
        compact: true,
        alignSelf: 'flex-start',
        ariaExpanded: 'false',
        hide: (el, s)=>!el.call('assistantFlyChecklistView', s.root, s).folded,
        onClick: (e, el, s)=>{
            e.stopPropagation();
            s.update({
                pobChecklistOpen: true
            });
        },
        FoldText: {
            tag: 'span',
            text: (el, s)=>el.call('assistantFlyChecklistView', s.root, s).foldText
        },
        Icon: {
            ariaHidden: 'true',
            name: 'chevronDown',
            boxSize: 'iconXs',
            flexShrink: '0'
        }
    },
    ChecklistItems: {
        tag: 'ul',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'Y A',
        minWidth: '0',
        hide: (el, s)=>el.call('assistantFlyChecklistView', s.root, s).folded,
        children: (el, s)=>el.call('assistantFlyChecklistView', s.root, s).rows,
        childrenAs: 'state',
        childExtends: 'AssistantFlyChecklistItem'
    }
};
const $b5b145a68302fe61$export$f929ce016c17e599 = {
    tag: 'li',
    dataChecked: (el, s)=>s && s.ticked === true ? 'true' : null,
    flow: 'x',
    align: 'center',
    gap: 'Y',
    minWidth: '0',
    fontSize: 'Z2',
    color: (el, s)=>s && s.ticked === true ? 'title' : 'caption',
    ItemMark: {
        role: 'img',
        ariaLabel: (el, s)=>s && s.stateText || null,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        boxSize: 'iconSm',
        round: 'radiusPill',
        border: (el, s)=>s && s.ticked === true ? 'none' : 'hairline solid line',
        Icon: {
            ariaHidden: 'true',
            hide: (el, s)=>!s || s.ticked !== true,
            name: 'checkmark',
            boxSize: 'iconXs'
        }
    },
    ItemName: {
        tag: 'span',
        minWidth: '0',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.title || ''
    }
};

});

parcelRegister("80Tpq", function(module, exports) {

$parcel$export(module.exports, "WorkspaceModeSwitch", () => $5d594de91adb4cb3$export$9a352fc33fb959bd);
// THE WORKSPACE OR ITS CLI — one switch, "Workspace · CLI"
// (functions/workspaceMode.js; Nika 2026-10-23: "add switcher so we can switch
// between normal and CLI-like workspace easily"). The same switch in both
// shells: at the top of the home (components/HomeViewSwitch.js) and in the
// Agent frame's header (components/AgentModeFrame.js) — the kit's view switch
// (AppSegmented variant 'view'), no look of its own. Ctrl+` flips it.
const $5d594de91adb4cb3$export$9a352fc33fb959bd = {
    class: 'workspace-mode-switch',
    dataWorkspaceMode: true,
    display: 'flex',
    minWidth: '0',
    flexShrink: '0',
    subscribeTo: [
        'agentMode',
        '_agentModeLink',
        'signedIn',
        '_homeCustomizeMode'
    ],
    hide: (el, s)=>!el.call('workspaceModeShown', s.root),
    title: (el)=>el.call('polyglot', 'workspace.agentMode.toggle'),
    AppSegmented: {
        variant: 'view',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.agentMode.switchLabel'),
        current: (el, s)=>el.call('workspaceModeOf', s.root),
        select: 'workspaceModeSelect',
        childrenAs: 'state',
        children: (el)=>el.call('workspaceModeSegments')
    }
};

});

parcelRegister("kiYNh", function(module, exports) {

$parcel$export(module.exports, "AssistantFlyCallView", () => $ec84a57dfaacf8de$export$7470a973335bc0b5);
// THE CALL'S THEATER — Fly in a call, on the main area (docs/FLY_MODE.md
// §3.3; Nika 2026-10-18: "minimize call and show it in main mode … main mode
// is theater in different modes"). The call's pages (meet functions/
// meetFly.js — anyone's ask, by voice or typed, made by the asker's own
// client and shared with everyone) take the main layer OVER the call: the
// call stays mounted underneath (its audio keeps playing) and minimizes into
// the dock (meet components/CallWidget.js); "Back to call" — or the dock's
// own button — gives it back.
//
// The SAME page as a person's own Fly canvas (AssistantFlyPageBody: eyebrow,
// title, who asked, the opening, the live sections, the next asks — a next ask
// stays in the call), the same folded rows for the call's other pages. The
// call's conversation is its chat; the theater keeps no rail of its own.
//
// Every value comes from the meet package through `el.call` (registered once
// the call's meet context is folded — the theater only ever shows on the
// call's own view, so they are there). Mounted in the main layer
// (components/AssistantMainLayer.js) like the other main-area views.
const $ec84a57dfaacf8de$export$7470a973335bc0b5 = {
    tag: 'section',
    role: 'region',
    dataFlyCall: true,
    ariaLabel: (el)=>el.call('polyglot', 'workspace.assistantFly.callLabel'),
    // The grid metrics — geometry of THIS element, so its own state.
    state: {
        cols: 0,
        gutter: 0,
        cell: 0,
        square: true
    },
    dataOpen: (el, s)=>el.call('assistantFlyCallDo', 'meetFlyTheaterShown', s.root) ? 'true' : 'false',
    ariaHidden: (el, s)=>el.call('assistantFlyCallDo', 'meetFlyTheaterShown', s.root) ? null : 'true',
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    width: '100%',
    maxWidth: 'var(--home-grid-w, 100%)',
    marginInline: 'auto',
    minWidth: '0',
    boxSizing: 'border-box',
    paddingBottom: 'C',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open="true"]': {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    // The meet functions are reached through one guarded door
    // (functions/assistantFlyCall.js assistantFlyCallDo): this view can render
    // before the call's meet context is folded. Every part that shows the call
    // DECLARES `meetFly` as its dependency (childrenDeps / textDeps / …): its
    // first run may read nothing through an unregistered name, and a factory
    // that read no signal never re-runs.
    subscribeTo: [
        'meetFly',
        'currentPath',
        'meetView',
        'livekitConnected'
    ],
    onMounted: (el, s)=>{
        el.call('assistantBoardSyncGrid', el, s);
        // Escape gives the call back (functions/assistantFlyCall.js).
        el.call('assistantFlyCallShortcuts', el);
    },
    onUpdate: (el, s)=>el.call('assistantBoardGridRead', el, s),
    onWindowResize: (e, el, s)=>el.call('assistantBoardSyncGrid', el, s),
    onRemove: (el)=>{
        if (typeof el.__flyCallShortcutsOff === 'function') el.__flyCallShortcutsOff();
        el.call('assistantBoardGridReadOff', el);
    },
    // ── The bar IS the call while the theater covers it (Nika 2026-10-23: "when
    // fly is running in call, keep some call ui/ux so we understand its the
    // call"): the live dot, the room, who is in it and the mic, the live
    // caption, then Stop or Hide · mic · Back to call · Leave. A glass island,
    // like the dock it stands in for here (meet components/CallWidget.js hides
    // while the theater shows). The call's values come from the meet package
    // (functions/meetCallStrip.js) through the one door, each part declaring
    // the root signal it reads.
    CallBar: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center space-between',
        gap: 'Z1',
        minWidth: '0',
        minHeight: 'controlHCompact',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        padding: 'Z Z1',
        round: 'radiusSheet',
        theme: 'canvas-card-glass',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        CallMark: {
            flow: 'x',
            align: 'center',
            gap: 'Y1',
            minWidth: '0',
            color: 'title',
            // Live; it rings while someone talks.
            LiveDot: {
                tag: 'span',
                boxSize: 'X2',
                minWidth: 'X2',
                round: '100%',
                // the success ink pair (one green per scheme), never a raw hue
                background: 'successInk',
                transition: 'box-shadow B defaultBezier',
                isSpeakingDeps: [
                    (el, s)=>s.root && s.root.livekitSpeakers
                ],
                isSpeaking: (el, s)=>!!el.call('assistantFlyCallDo', 'meetCallSpeaking', s.root),
                '.isSpeaking': {
                    boxShadow: '0 0 0 X1 color-mix(in srgb, var(--color-green) 30%, transparent)'
                }
            },
            Icon: {
                name: 'pxFly',
                boxSize: 'iconSm',
                flexShrink: '0'
            },
            CallName: {
                tag: 'span',
                fontSize: 'Z2',
                fontWeight: '500',
                minWidth: '0',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>{
                    const r = s.root || {};
                    const room = (r.rooms || []).find((x)=>x && x.id === r.activeRoomId);
                    return room && room.name ? String(el.call('polyglot', 'workspace.assistantFly.callTitle')).replace('{room}', room.name) : el.call('polyglot', 'workspace.assistantFly.callTitleBare');
                }
            },
            // "2 in call · mic on" (meet.widget.participantLine, the dock's line).
            CallPeople: {
                tag: 'span',
                textDeps: [
                    (el, s)=>s.root && s.root.livekitParticipants
                ],
                fontSize: 'Z2',
                color: 'caption',
                whiteSpace: 'nowrap',
                text: (el, s)=>el.call('assistantFlyCallDo', 'meetCallStripLine', s.root) || ''
            },
            CallCount: {
                tag: 'span',
                textDeps: [
                    'meetFly'
                ],
                fontSize: 'Z2',
                color: 'inactive',
                whiteSpace: 'nowrap',
                text: (el, s)=>{
                    const n = (el.call('assistantFlyCallDo', 'meetFlyPages', s.root) || []).length;
                    return n > 1 ? String(el.call('polyglot', 'workspace.assistantFly.pageCount')).replace('{n}', String(n)) : '';
                }
            }
        },
        // The call's live line: who talks and what they said, while it is still
        // "now". It takes the free middle of the bar, so a line arriving or
        // ending moves nothing.
        CallCaption: {
            tag: 'span',
            textDeps: [
                (el, s)=>s.root && s.root.utterances,
                (el, s)=>s.root && s.root._meetingInviteTick
            ],
            flex: '1',
            minWidth: '0',
            fontSize: 'Z2',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.call('assistantFlyCallDo', 'meetCallStripCaption', s.root) || ''
        },
        CallActions: {
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            // The open page off the theater: its asker stops showing it for
            // everyone, anyone else hides it for themselves.
            AssistantIconButton: {
                dataFlyCallStop: true,
                ariaLabelDeps: [
                    'meetFly'
                ],
                titleDeps: [
                    'meetFly'
                ],
                ariaLabel: (el, s)=>{
                    const p = el.call('assistantFlyCallDo', 'meetFlyPage', s.root);
                    return el.call('polyglot', p && p.mine ? 'workspace.assistantFly.callStop' : 'workspace.assistantFly.callHide');
                },
                title: (el, s)=>{
                    const p = el.call('assistantFlyCallDo', 'meetFlyPage', s.root);
                    return el.call('polyglot', p && p.mine ? 'workspace.assistantFly.callStop' : 'workspace.assistantFly.callHide');
                },
                onClick: (e, el, s)=>{
                    const p = el.call('assistantFlyCallDo', 'meetFlyPage', s.root);
                    if (p) el.call('assistantFlyCallDo', 'meetFlyDismiss', p.key);
                },
                Icon: {
                    name: 'x'
                }
            },
            // The mic, without leaving the pages.
            AssistantIconButton_mic: {
                dataFlyCallMic: true,
                isOffDeps: [
                    (el, s)=>s.root && s.root.livekitParticipants
                ],
                isOff: (el, s)=>!el.call('assistantFlyCallDo', 'meetCallMicOn', s.root),
                ariaPressedDeps: [
                    (el, s)=>s.root && s.root.livekitParticipants
                ],
                ariaPressed: (el, s)=>el.call('assistantFlyCallDo', 'meetCallMicOn', s.root) ? 'true' : 'false',
                ariaLabel: (el)=>el.call('polyglot', 'meet.widget.toggleMic'),
                title: (el)=>el.call('polyglot', 'meet.widget.toggleMic'),
                '.isOff': {
                    color: 'dangerInk'
                },
                onClick: (e, el)=>el.call('assistantFlyCallDo', 'meetCallMicToggle'),
                Icon: {
                    nameDeps: [
                        (el, s)=>s.root && s.root.livekitParticipants
                    ],
                    name: (el, s)=>el.call('assistantFlyCallDo', 'meetCallMicOn', s.root) ? 'mic' : 'micOff'
                }
            },
            AppCapsuleBtnToolbar: {
                dataFlyCallBack: true,
                compact: true,
                text: (el)=>el.call('polyglot', 'meet.fly.backToCall'),
                onClick: (e, el)=>el.call('assistantFlyCallDo', 'meetFlyTheater', false)
            },
            // Leave from the pages: the call ends for me, and its theater with it.
            AppCapsuleBtnDanger: {
                dataFlyCallLeave: true,
                compact: true,
                text: (el)=>el.call('polyglot', 'meet.widget.leaveCall'),
                onClick: async (e, el, s)=>{
                    await el.call('assistantFlyCallDo', 'disconnectCall');
                    s.root?.update({
                        meetView: 'list'
                    });
                }
            }
        }
    },
    // ── The call's earlier pages, folded ──────────────────────────────────────
    CallBefore: {
        childrenDeps: [
            'meetFly'
        ],
        tag: 'ol',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        children: (el, s)=>{
            const pages = el.call('assistantFlyCallDo', 'meetFlyPages', s.root) || [];
            const at = pages.findIndex((p)=>p.open);
            return pages.filter((p, i)=>i < at).slice(-5);
        },
        childrenAs: 'state',
        childExtends: 'AssistantFlyRow'
    },
    // ── The open page — ONE child keyed by its page (a new page rises in). It
    // lies on the layer's sheet: its cards take the solid card fill.
    CallOpen: {
        childrenDeps: [
            'meetFly'
        ],
        minWidth: '0',
        children: (el, s)=>{
            const p = el.call('assistantFlyCallDo', 'meetFlyPage', s.root);
            // Slides take their own stage (CallDeck below).
            if (!p || p.kind === 'deck') return [];
            const m = el.call('assistantBoardMetrics', s);
            return [
                {
                    ...p,
                    cols: m.cols,
                    gutter: m.gutter,
                    cell: m.cell,
                    square: m.square,
                    onLayer: true
                }
            ];
        },
        childrenAs: 'state',
        childExtends: 'AssistantFlyPageBody'
    },
    // ── The open page when it is SLIDES (a Presentation ask in the call): the
    // deck's own slide on the layer, Previous / Next — the asker presents.
    CallDeck: {
        childrenDeps: [
            'meetFly'
        ],
        minWidth: '0',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        children: (el, s)=>{
            const vm = el.call('assistantFlyCallDeck', s.root);
            return vm ? [
                vm
            ] : [];
        },
        childrenAs: 'state',
        childExtends: 'AssistantFlyCallDeck'
    },
    // ── The call's later pages, folded ────────────────────────────────────────
    CallAfter: {
        childrenDeps: [
            'meetFly'
        ],
        tag: 'ol',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        flow: 'y',
        gap: 'X',
        minWidth: '0',
        width: '100%',
        marginInline: 'auto',
        boxSizing: 'border-box',
        style: (el, s)=>el.call('assistantFlyPageStyle', s),
        children: (el, s)=>{
            const pages = el.call('assistantFlyCallDo', 'meetFlyPages', s.root) || [];
            const at = pages.findIndex((p)=>p.open);
            return at < 0 ? [] : pages.filter((p, i)=>i > at);
        },
        childrenAs: 'state',
        childExtends: 'AssistantFlyRow'
    },
    // ── The call so far, under its pages: the live summary — what was said,
    // what it caught (each applied with a press), what changed in the
    // workspace while it ran (meet components/LiveRecap.js) — as a card on the
    // layer's sheet. Made once the theater shows: the meet context is folded by
    // then, and the framework merges a part named before its component was
    // registered when its `if` turns true (`ifDeps`: the call's state, read
    // through the guarded door, so the condition re-runs).
    MeetLiveRecap: {
        if: (el, s)=>!!el.call('assistantFlyCallDo', 'meetFlyTheaterShown', s.root),
        ifDeps: [
            'meetFly',
            'meetView',
            'currentPath'
        ],
        width: '100%',
        maxHeight: 'none',
        overflowY: 'visible',
        marginInline: 'auto',
        boxSizing: 'border-box',
        padding: 'A',
        round: 'radiusCard',
        background: 'cardSolid',
        borderBottomWidth: '0',
        style: (el, s)=>el.call('assistantFlyPageStyle', s)
    }
};

});

parcelRegister("ecRFe", function(module, exports) {

$parcel$export(module.exports, "AssistantFlyCallDeck", () => $a57bd03d2024d2f6$export$5f550b55f5328afc);
// AssistantFlyCallDeck — SLIDES on a call's theater (a Presentation ask in the
// call: meet functions/meetFly.js kind 'deck'; docs/FLY_MODE.md §3.3). Nika
// 2026-10-18: "main mode is theater in different modes". The deck view's own
// parts — the title, ONE slide on the stage (AssistantDeckSlide: its live
// cards read under this member's grants), Previous · 3 / 6 · Next — on the
// layer's sheet. The asker presents: their move goes to everyone; anyone else
// peeks for themselves until the asker moves again. State = the model
// functions/assistantFlyCall.js assistantFlyCallDeck derives.
const $a57bd03d2024d2f6$export$5f550b55f5328afc = {
    tag: 'section',
    dataFlyCallDeck: true,
    dataStatus: (el, s)=>s && s.status || 'loading',
    ariaBusy: (el, s)=>s && (s.status === 'loading' || s.status === 'streaming') ? 'true' : null,
    flow: 'y',
    gap: 'B',
    minWidth: '0',
    width: '100%',
    boxSizing: 'border-box',
    DeckTitle: {
        tag: 'h2',
        dataDeckTitle: true,
        margin: '0',
        fontSize: 'C',
        fontWeight: '700',
        lineHeight: '1.2',
        color: 'title',
        minWidth: '0',
        overflowWrap: 'anywhere',
        hide: (el, s)=>!s || !s.title,
        text: (el, s)=>s && s.title || ''
    },
    // A failure's one sentence (the deck's own words).
    DeckStatus: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!s || !s.statusText,
        text: (el, s)=>s && s.statusText || ''
    },
    // The stage: the ONE slide on screen, keyed by the slide (a new slide is a
    // new element); a skeleton slide while nothing has landed.
    DeckStage: {
        dataDeckStage: true,
        ariaLive: 'polite',
        minWidth: '0',
        childrenAs: 'state',
        children: (el, s)=>s && s.slide ? [
                s.slide
            ] : [],
        childExtends: 'AssistantDeckSlide'
    },
    // Previous · 3 / 6 · Next — under the stage, centred.
    DeckNav: {
        dataDeckNav: true,
        flow: 'x',
        align: 'center center',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>!s || (Number(s.count) || 0) < 2,
        AppCapsuleBtnToolbar_prev: {
            compact: true,
            dataDeckPrev: true,
            disabled: (el, s)=>s && s.canPrev ? null : true,
            text: '{{ workspace.assistantDeck.previous | polyglot }}',
            onClick: (e, el, s)=>el.call('assistantFlyCallDo', 'meetFlyDeckGo', -1, s && s.key)
        },
        DeckCounter: {
            tag: 'span',
            dataDeckCounter: true,
            fontSize: 'Z',
            fontWeight: '500',
            color: 'caption',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>s && s.counter || ''
        },
        AppCapsuleBtnToolbar_next: {
            compact: true,
            dataDeckNext: true,
            disabled: (el, s)=>s && s.canNext ? null : true,
            text: '{{ workspace.assistantDeck.next | polyglot }}',
            onClick: (e, el, s)=>el.call('assistantFlyCallDo', 'meetFlyDeckGo', 1, s && s.key)
        }
    }
};

});

parcelRegister("5VNvD", function(module, exports) {

$parcel$export(module.exports, "AssistantFlyWorkspace", () => $4518ae1c141a48e3$export$298b49dd064dc33a);
// One shell-only composition, three presentations (functions/
// assistantFlyWorkspace.js holds every value): the canvas bar's note, the
// return control over an open pane, and the section picker, mounted once at
// the shell root. No toolbar (Nika 2026-10-23: "open workspace tools is already
// in top menu so whats the point?"): "Add section" opens this picker from the
// composer's "+" menu (canvas CanvasPromptTextarea AttachMenu FlySectionRow).
const $4518ae1c141a48e3$export$298b49dd064dc33a = {
    presentation: 'status',
    display: 'contents',
    // "Section added" — said in the canvas's bar, where the page shows, and to a
    // screen reader (a live region, always mounted so the announcement lands).
    FlyWorkspaceStatus: {
        if: (el)=>el.parent.presentation === 'status',
        tag: 'span',
        role: 'status',
        ariaLive: 'polite',
        fontSize: 'Z',
        color: 'caption',
        text: (el, s)=>{
            const state = el.call('assistantFlyWorkspaceState', s.root) || {};
            return state.status === 'added' ? el.call('polyglot', 'shell.flyWorkspace.added') : '';
        }
    },
    FlyWorkspaceReturn: {
        if: (el)=>el.parent.presentation === 'return',
        hide: (el, s)=>!el.call('assistantFlyWorkspaceReturnShown', s.root),
        display: 'flex',
        flow: 'x wrap',
        alignItems: 'center',
        gap: 'Y',
        minWidth: '0',
        position: 'fixed',
        zIndex: '1340',
        bottom: 'calc(var(--slot-bottom) + var(--chip-row) + var(--spacing-Z))',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'max-content',
        maxWidth: 'calc(100% - var(--spacing-B))',
        padding: 'Y Z',
        theme: 'common-box',
        shadow: 'float',
        round: 'radiusControl',
        AppCapsuleBtnGhost: {
            text: '{{ shell.flyWorkspace.return | polyglot }}',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            disabled: (el, s)=>(el.call('assistantFlyWorkspaceState', s.root) || {}).status === 'returning',
            ariaBusy: (el, s)=>(el.call('assistantFlyWorkspaceState', s.root) || {}).status === 'returning',
            onClick: (e, el)=>el.call('assistantFlyWorkspaceReturn')
        },
        FlyWorkspaceReturnError: {
            tag: 'span',
            role: 'alert',
            fontSize: 'Z',
            color: 'caption',
            text: (el, s)=>{
                const state = el.call('assistantFlyWorkspaceState', s.root) || {};
                return state.status === 'failed' && !state.picker ? el.call('polyglot', el.call('assistantFlyWorkspaceErrorKey', state.error)) : '';
            }
        }
    },
    AppDialog: {
        if: (el)=>el.parent.presentation === 'picker',
        closeCall: 'assistantFlyWorkspaceClose',
        presentation: 'center',
        panelSize: 'md',
        initialFocus: 'field',
        position: 'fixed',
        zIndex: '2000',
        isOpen: (el, s)=>{
            const open = !!(el.call('assistantFlyWorkspaceState', s.root) || {}).picker;
            el.call('appDialogSync', open);
            return open;
        },
        Panel: {
            AppDialogHead: {
                titleId: 'flyWorkspacePickerTitle',
                heading: 'shell.flyWorkspace.section',
                subtitle: 'shell.flyWorkspace.sectionHint'
            },
            AppDialogBody: {
                AppCombobox: {
                    limit: 30,
                    ariaLabel: (el)=>el.call('polyglot', 'shell.flyWorkspace.search'),
                    placeholder: 'shell.flyWorkspace.search',
                    options: (el, s)=>(el.call('assistantFlyWorkspaceState', s.root) || {}).picker ? el.call('assistantFlyWorkspaceOptions', s.root) : [],
                    select: 'assistantFlyWorkspaceSelect'
                },
                FlyWorkspaceEmpty: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'Z1',
                    color: 'caption',
                    hide: (el)=>!!el.parent.AppCombobox.options.length,
                    text: '{{ shell.flyWorkspace.emptySections | polyglot }}'
                },
                FlyWorkspaceError: {
                    tag: 'span',
                    role: 'alert',
                    fontSize: 'Z1',
                    color: 'title',
                    text: (el, s)=>{
                        const state = el.call('assistantFlyWorkspaceState', s.root) || {};
                        return state.error ? el.call('polyglot', el.call('assistantFlyWorkspaceErrorKey', state.error)) : '';
                    }
                }
            }
        }
    }
};

});

parcelRegister("3ScYq", function(module, exports) {

$parcel$export(module.exports, "HomeViewSwitch", () => $2d207a8172446309$export$8a0480ff18975d11);
// Home · Ask · Create in one row. A destination opens its last view; its
// chevron (or ArrowDown) opens the contextual modes. Human / Agent lives in
// the avatar menu, with the same switch retained in the Agent frame.
const $2d207a8172446309$export$8a0480ff18975d11 = {
    class: 'home-view-switch',
    display: 'flex',
    justifyContent: 'center',
    minWidth: '0',
    flexShrink: '0',
    subscribeTo: [
        '_aiFly',
        '_aiDeck',
        'assistantMode',
        'currentPath',
        '_homeCustomizeMode',
        '_homeThreadOpen',
        'assistantDock',
        'workspace',
        '_featureFlags',
        'signedIn',
        'contextDropdown'
    ],
    hide: (el, s)=>!el.call('homeViewShown', s.root),
    AppSegmented: {
        dataHomeNav: 'primary',
        variant: 'view',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.homeView.label'),
        current: (el, s)=>el.call('homeViewGroupOf', s.root),
        select: 'homeViewGroupSelect',
        childrenAs: 'state',
        children: (el)=>el.call('homeViewGroups'),
        childProps: {
            text: null,
            gap: 'Y',
            ariaHaspopup: (el, s)=>s.value === 'home' ? null : 'menu',
            ariaExpanded: (el, s)=>s.value === 'home' ? null : String(!!s.root.contextDropdown?.open && s.root.contextDropdown?.homeViewGroup === s.value),
            onClick: (e, el, s)=>{
                const menu = s.value !== 'home' && (el.call('homeViewGroupOf', s.root) === s.value || e.target?.closest?.('[data-home-mode-trigger]'));
                return menu ? el.call('homeViewMenuOpen', el, s.value) : el.call('homeViewGroupSelect', s.value);
            },
            onKeydown: (e, el)=>el.call('homeViewNavigationKeydown', e, el),
            onPointerenter: (e, el, s)=>el.call('homeBuildPrefetch', s.value === 'create' ? 'build' : null),
            onFocus: (e, el, s)=>el.call('homeBuildPrefetch', s.value === 'create' ? 'build' : null),
            Text: {
                text: (el, s)=>el.call('polyglot', s.text)
            },
            Icon: {
                name: 'chevronDown',
                size: 'Z',
                dataHomeModeTrigger: true,
                ariaHidden: 'true',
                hide: (el, s)=>s.value === 'home'
            }
        }
    }
};

});

parcelRegister("lpuFp", function(module, exports) {

$parcel$export(module.exports, "HomeTabStart", () => $f963b890b17b46b1$export$e36f3b78a4b723cd);
$parcel$export(module.exports, "HomeTabStartTile", () => $f963b890b17b46b1$export$ddfaf668c4304f74);
$parcel$export(module.exports, "HomeTabStartItem", () => $f963b890b17b46b1$export$3c56dda9b38951ad);
// THE HOME TABS' START SCREEN — Chat, Present (functions/homeTabStart.js;
// Nika 2026-10-23: "instead of [fly,dashboard,agent] rename [Main, Dashboard,
// Chat, Present, Build] and draw related experience for each tab aligning AI
// mode"). The Fly start screen's shape (components/AssistantFlyStart.js), the
// tab's own asks:
//   the head   the day and the workspace · one heading — whom you
//              ask, then what the tab makes · one line on how it works
//   the asks   tiles in the tab's mode — the Fly start tile; a press asks it
//              through the composer's own send (homeTabStartAsk)
//   the kept   what the person already has of that kind — Present's decks;
//              a press opens it. A part with nothing leaves no gap.
// Build's tab is the app builder itself (components/HomeBuildView.js), not a
// start screen. The mount names its tab (`tab: 'present' | 'chat'` —
// pages/main.js mounts Present's in the home's grid area, the conversation
// view mounts Chat's as its empty state). It holds no logic: every value comes from
// functions/homeTabStart.js through `el.call`. Shown only while its tab has
// nothing on screen yet; it never moves a tile it already shows.
const $f963b890b17b46b1$export$e36f3b78a4b723cd = {
    tag: 'section',
    tab: 'chat',
    dataHomeTabStart: true,
    dataTab: (el)=>el.tab,
    dataOpen: (el, s)=>el.call('homeTabStartShown', s.root, el.tab) ? 'true' : 'false',
    ariaLabel: (el, s)=>{
        const copy = el.call('homeTabStartCopy', s.root, el.tab) || {};
        return [
            copy.lead,
            copy.rest
        ].filter(Boolean).join(' ') || null;
    },
    hide: (el, s)=>!el.call('homeTabStartShown', s.root, el.tab),
    flow: 'y',
    gap: 'D',
    width: '100%',
    maxWidth: 'var(--home-grid-w, 100%)',
    marginInline: 'auto',
    minWidth: '0',
    boxSizing: 'border-box',
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    // FA204 / frank: the one helper the parts share travels with the screen.
    scope: {
        // The mount's tab, read off the screen element (the parts sit under it).
        homeTab (el) {
            let node = el;
            for(let i = 0; node && i < 12; i++){
                if (node.dataHomeTabStart === true && typeof node.tab === 'string') return node.tab;
                node = node.parent;
            }
            return 'chat';
        }
    },
    // ── THE HEAD ──────────────────────────────────────────────────────────────
    TabStartHead: {
        tag: 'header',
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        // The day and the workspace, in the page eyebrow's voice (Fly's own).
        TabStartEyebrow: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z',
            fontWeight: '500',
            lineHeight: '1.3',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: 'inactive',
            text: (el, s)=>{
                const day = el.call('localizedDate', Date.now(), {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long'
                });
                const scope = String(el.call('assistantScopeName', s.root) || '');
                return scope ? day + " \xb7 " + scope : String(day || '');
            }
        },
        // One text node keeps the word boundary in both the DOM and spoken name.
        TabStartTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            lineHeight: '1.3',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>{
                const copy = el.call('homeTabStartCopy', s.root, el.scope.homeTab(el)) || {};
                return [
                    copy.lead,
                    copy.rest
                ].filter(Boolean).join(' ');
            }
        },
        // Chat's line is the conversation's own empty hint, under the tiles.
        TabStartLead: {
            tag: 'p',
            margin: '0',
            maxWidth: 'H',
            fontSize: 'Z2',
            lineHeight: '1.5',
            color: 'caption',
            hide: (el, s)=>!(el.call('homeTabStartCopy', s.root, el.scope.homeTab(el)) || {}).line,
            text: (el, s)=>(el.call('homeTabStartCopy', s.root, el.scope.homeTab(el)) || {}).line || ''
        }
    },
    // ── THE ASKS — three tracks (two on a phone), every row as tall as the
    // tallest, so the tiles line up whatever their words ──────────────────────
    TabStartTiles: {
        role: 'group',
        dataHomeTabTiles: true,
        ariaLabel: (el, s)=>(el.call('homeTabStartCopy', s.root, el.scope.homeTab(el)) || {}).tiles || null,
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gridAutoRows: 'minmax(var(--spacing-E), 1fr)',
        gap: 'Z',
        minWidth: '0',
        '@mobileL': {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
        },
        hide: (el, s)=>!(el.call('homeTabStartTiles', s.root, el.scope.homeTab(el)) || []).length,
        children: (el, s)=>el.call('homeTabStartTiles', s.root, el.scope.homeTab(el)),
        childrenAs: 'state',
        childExtends: 'HomeTabStartTile'
    },
    // ── WHAT THE PERSON ALREADY HAS of the tab's kind ──────────────────────────
    TabStartKept: {
        tag: 'section',
        dataHomeTabKept: true,
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        maxWidth: 'I',
        ariaLabel: (el, s)=>(el.call('homeTabStartCopy', s.root, el.scope.homeTab(el)) || {}).kept || null,
        hide: (el, s)=>!(el.call('homeTabStartItems', s.root, el.scope.homeTab(el)) || []).length,
        AssistantFlyStartPartTitle: {
            text: (el, s)=>(el.call('homeTabStartCopy', s.root, el.scope.homeTab(el)) || {}).kept || ''
        },
        TabStartKeptList: {
            role: 'list',
            flow: 'y',
            gap: 'X',
            minWidth: '0',
            children: (el, s)=>el.call('homeTabStartItems', s.root, el.scope.homeTab(el)),
            childrenAs: 'state',
            childExtends: 'HomeTabStartItem'
        }
    }
};
const $f963b890b17b46b1$export$ddfaf668c4304f74 = {
    extends: 'AssistantFlyStartTile',
    background: (el)=>el.call('homeTabStartCard', el),
    onClick: (e, el, s)=>el.call('homeTabStartAsk', s)
};
const $f963b890b17b46b1$export$3c56dda9b38951ad = {
    extends: 'AssistantFlyStartRecentPage',
    background: (el)=>el.call('homeTabStartCard', el),
    ariaLabel: (el, s)=>s && s.title || null,
    title: null,
    onClick: (e, el, s)=>el.call('homeTabStartOpen', s),
    RecentWhen: {
        text: (el, s)=>{
            if (s && s.meta) return s.meta;
            return s && s.at ? String(el.call('timeAgo', s.at) || '') : '';
        }
    }
};

});

parcelRegister("9k193", function(module, exports) {

$parcel$export(module.exports, "HomeBuildView", () => $6c96deaef4a63daf$export$62a677c700fa41ae);
// THE HOME'S BUILD TAB — the app builder itself (functions/homeBuild.js; Nika
// 2026-10-23: "build tab should reuse ui/ux of /add-apps"). pages/main.js
// mounts it in the home's grid area as Build's view part; it holds the
// /add-app page (the build conversation, the build canvas, the person's apps),
// mounted on the tab's first show and kept from then on: a tab away puts it
// away, so a built app, a half-written ask and the canvas are where they were
// when the person comes back.
//
// IN PLACE (Nika 2026-10-23: "when switching to build transit page to canvas
// without switching the page or layout"): the route, the header and the tabs
// stay; only the main area changes, in the house crossfade of the home's views
// (the board's recipe, `C`, opacity only): closed it keeps no room — the mount
// lays it out of the flow like the other views, and it has no height — open it
// takes its band at once and fades in.
//
// THE BAND: the builder is a two-pane surface — the conversation and the
// canvas scroll inside their own panes — so it takes the viewport below its
// own top (`--home-build-top`, read by homeBuildFit) down to the shell's
// bottom gap (`--home-build-bottom`): `--nav-gap` (the global composer stands
// down here — the builder's own is the prompt, as on /add-app), `--slot-bottom`
// on a phone (the dock). The fallback before the first read is the usual top,
// `F`.
//
// ONE BUILDER AT A TIME (functions/homeBuild.js): a pane over the home that
// holds /add-app takes the builder — this one leaves the tree meanwhile and
// mounts again on the tab's next show.
//
// It holds no logic: every value comes from functions/homeBuild.js through
// `el.call`.
const $6c96deaef4a63daf$export$62a677c700fa41ae = {
    tag: 'section',
    dataHomeBuild: true,
    ariaLabel: (el)=>el.call('polyglot', 'workspace.homeView.build'),
    dataOpen: (el, s)=>el.call('homeBuildShown', s.root) ? 'true' : 'false',
    ariaHidden: (el, s)=>el.call('homeBuildShown', s.root) ? null : 'true',
    flow: 'y',
    width: '100%',
    minWidth: '0',
    boxSizing: 'border-box',
    '--home-build-bottom': 'var(--nav-gap)',
    '@mobileL': {
        '--home-build-bottom': 'var(--slot-bottom)'
    },
    // closed: no room, nothing to see, nothing to reach
    height: '0',
    overflow: 'hidden',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open="true"]': {
        height: 'calc(100dvh - var(--home-build-top, var(--spacing-F)) - var(--home-build-bottom))',
        minHeight: 'G',
        overflow: 'visible',
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'auto',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    // While the builder's chunk loads: the house page skeleton (the lazy page's
    // own placeholder); homeBuildMount sets the page over it.
    content: {
        extends: 'PageSkeleton'
    },
    // The first show mounts the builder; every show reads the band. The view
    // opens in the same update, so both run a microtask later, once it has. A
    // pane that takes the builder unmounts this one.
    stateDeps: [
        (el, s)=>!!el.call('homeBuildShown', s.root),
        (el, s)=>!!el.call('homeBuildInPane', s.root)
    ],
    onStateUpdate: (el, s, ctx, change)=>{
        const next = change && change.next || [];
        if (next[1]) {
            el.call('homeBuildUnmount', el);
            return;
        }
        if (!next[0]) return;
        queueMicrotask(()=>{
            el.call('homeBuildFit', el);
            el.call('homeBuildMount', el);
        });
    },
    onRender: (el, s)=>{
        if (!el.call('homeBuildShown', s.root)) return;
        queueMicrotask(()=>{
            el.call('homeBuildFit', el);
            el.call('homeBuildMount', el);
        });
    },
    onWindowResize: (e, el)=>el.call('homeBuildFit', el)
};

});

parcelRegister("gAM3x", function(module, exports) {

$parcel$export(module.exports, "AddAppSidebarRow", () => $c145490bffc100e9$export$96de1c9bb4212948);
// ONE OF THE PERSON'S APPS in the builder's sidebar (pages/add-app.js; Nika
// 2026-10-23: "make sidebar more appealing and beautiful"): the house rail row
// (AppSidebarRow — its washes, its active row, its meta in the right ink on
// every wash) for an app — its glyph, its name, when it last changed. The app
// the conversation is building is the active row (and the current one for
// assistive technology). A press opens that app's thread and its build
// (functions/addAppSidebar.js addAppSidebarPick). The row's state is
// addAppSidebarRows' row; it holds no logic of its own.
const $c145490bffc100e9$export$96de1c9bb4212948 = {
    extends: 'AppSidebarRow',
    isActive: (el, s)=>!!s && !!s.id && String(s.root && s.root._addAppProjectId || '') === String(s.id),
    ariaCurrent: (el, s)=>s && s.id && String(s.root && s.root._addAppProjectId || '') === String(s.id) ? 'true' : null,
    title: (el, s)=>s && s.label || null,
    onClick: (e, el, s)=>el.call('addAppSidebarPick', s && s.id)
};

});

parcelRegister("kHpof", function(module, exports) {

$parcel$export(module.exports, "BuildCreditLink", () => $f11b84b8e6d47404$export$605078085acaf17b);
// THE QUIET LINK TO THE CREDIT PAGE in the builder's composer lines
// (pages/add-app.js): the balance line's "Usage & billing" and the estimate
// line's admin way out ("Add credits to keep going.", functions/
// addAppEstimate.js). One look for both — the line's own caption ink,
// underlined, the title ink under the pointer and on press — and one address,
// the page's own route. The words are the caller's.
const $f11b84b8e6d47404$export$605078085acaf17b = {
    extends: 'Link',
    href: '/admin/usage',
    color: 'caption',
    textDecoration: 'underline',
    ':hover': {
        color: 'title'
    },
    ':active': {
        color: 'title'
    }
};

});

parcelRegister("8Z2iB", function(module, exports) {

$parcel$export(module.exports, "BuildCreditBadge", () => $68a5cdcc29d2595c$export$b621eb30ae9d644f);
// Compact balance, with the allowance explained on hover or keyboard focus.
// AppCapsuleBtnGhost owns geometry, focus and shared coarse-pointer targets.
// The number includes top-ups; the pie is only the known monthly allowance.
const $68a5cdcc29d2595c$export$b621eb30ae9d644f = {
    extends: [
        'AppCapsuleBtnGhost',
        'TooltipTrigger'
    ],
    tag: 'span',
    type: null,
    tabIndex: '0',
    compact: true,
    maxWidth: '100%',
    gap: 'Y',
    color: 'caption',
    cursor: 'default',
    tooltipPlacement: 'top',
    tooltipId: 'build-credit-balance',
    tooltipTextDeps: [
        (el, s)=>s.root?._creditGuard,
        (el, s)=>s.root?.lang,
        (el, s)=>s.root?.roles
    ],
    tooltipText: (el, s)=>(el.call('addAppBalanceLine', s.root) || {}).tooltip || '',
    ariaLabel: (el, s)=>(el.call('addAppBalanceLine', s.root) || {}).tooltip || '',
    Pie: {
        boxSize: 'iconXs',
        flexShrink: '0',
        round: 'radiusPill',
        ariaHidden: 'true',
        hide: (el, s)=>(el.call('addAppBalanceLine', s.root) || {}).fraction == null,
        background: (el, s)=>{
            const fraction = (el.call('addAppBalanceLine', s.root) || {}).fraction || 0;
            return `conic-gradient(var(--color-caption) ${fraction * 360}deg, var(--color-widgetPlate) 0deg)`;
        }
    },
    Count: {
        tag: 'span',
        fontVariantNumeric: 'tabular-nums',
        textDeps: [
            (el, s)=>s.root?._creditGuard,
            (el, s)=>s.root?.lang
        ],
        text: (el, s)=>(el.call('addAppBalanceLine', s.root) || {}).count || ''
    }
};

});

parcelRegister("c8onO", function(module, exports) {

$parcel$export(module.exports, "AgentModeFrame", () => $8d592560b7719d81$export$b131502ebd756476);
$parcel$export(module.exports, "AgentModeHeader", () => $8d592560b7719d81$export$cf5f5c091cbd0507);
$parcel$export(module.exports, "AgentModeTab", () => $8d592560b7719d81$export$644c5b3913f510d5);
$parcel$export(module.exports, "AgentModeLeave", () => $8d592560b7719d81$export$27302acd3d3a4574);
$parcel$export(module.exports, "AgentModeSidebar", () => $8d592560b7719d81$export$4e85accac0c3dc41);
$parcel$export(module.exports, "AgentModeSideRow", () => $8d592560b7719d81$export$9ec9e655be03fd06);
$parcel$export(module.exports, "AgentModeFooter", () => $8d592560b7719d81$export$cb13265ccd51013c);
$parcel$export(module.exports, "AgentModeHint", () => $8d592560b7719d81$export$740ab3b055c4bd6);
$parcel$export(module.exports, "AgentModeField", () => $8d592560b7719d81$export$b4a605184071f199);
$parcel$export(module.exports, "AgentModeStartError", () => $8d592560b7719d81$export$941b67e5c6e15022);
// AGENT MODE — the workspace TUI as the whole shell (WS-AGENT-MODE-1).
//
// Nika 2026-10-23: "we have workspace and tui. now we need to add workspace
// agent-mode which is exact replication of TUI in real workspace ui". A real
// DOMQL replica of the TUI frame (smbls cli/tui shell/frame.js — the Mock
// panel of symbols.app/apps): every row, card and field is a real element,
// in brand tokens and the brand's mono face (`Code`):
//
//   ╭──────────────────────────────────────────────────────────────╮
//   │ org.workspace  Tasks  Board  Mine  All               status ⏻ │  header
//   ├────────────────┬─────────────────────────────────────────────┤
//   │ WORKSPACE      │                                             │
//   │ ⌂ Home       1 │   the view: board, list, detail, dashboard, │  sidebar │ content
//   │ ▦ Tasks      2 │   chat or Ask AI                            │
//   ├────────────────┴─────────────────────────────────────────────┤
//   │ ASK AI  Plan next week…                     ? help  q quit    │  footer
//   ╰──────────────────────────────────────────────────────────────╯
//
// THE FRAME DRAWS THE SNAPSHOT AND NOTHING ELSE. What shows, what is
// selected, what a key does: all of it is the shared runtime's
// (`@symbo.ls/workspace-model`, functions/agentModeRuntime.js). Every factory
// below reads `agentModeSnapshot(s.root)` (through functions/agentModeView.js),
// which reads the root's `_agentModeRev` first — one runtime render re-runs
// the factories that read it.
//
// WHOLE SHELL. The frame is fixed over the whole viewport, opaque, above the
// shell's chrome and sheets (the header, the rail, the home stay mounted under
// it and take no keys: the frame's keydown stops every key it hands the
// runtime). It is a modal surface to assistive tech (`aria-modal`).
//
// AGENT-READABLE. Regions carry `data-agent-region`, apps `data-agent-app`,
// views `data-agent-view`, records `data-agent-id`; the tabs are a `tablist`,
// the sidebar and lists are `listbox`es whose cursor row is
// `aria-selected="true"`, overlays are `dialog`s.
//
// The leave control and `q` leave Agent mode (functions/agentMode.js); the
// mount is app.js (`AgentModeFrame`, gated on agentModeShown).
const $8d592560b7719d81$export$b131502ebd756476 = {
    tag: 'section',
    role: 'dialog',
    aria: {
        modal: 'true',
        label: (el)=>el.call('polyglot', 'workspace.agentMode.frameLabel')
    },
    data: {
        agentRegion: 'frame'
    },
    tabindex: '-1',
    position: 'fixed',
    inset: '0',
    zIndex: '1900',
    display: 'flex',
    flexDirection: 'column',
    padding: 'Z',
    boxSizing: 'border-box',
    background: 'document',
    color: 'paragraph',
    fontFamily: 'Code',
    fontSize: 'Z1',
    lineHeight: '1.5',
    outline: 'none',
    // The one keydown bridge (functions/agentModeRuntime.js agentModeKeydown).
    onKeydown: (e, el)=>el.call('agentModeKeydown', e),
    // A key no element holds (the focus fell to the page body: the boot
    // screen's inert lock, a removed field) is the frame's too.
    onDocumentKeydown: (e, el)=>el.call('agentModeDocumentKeydown', e),
    // The runtime follows Agent mode, the workspace and the language: started
    // at mount, re-created on a workspace switch, told a new language, stopped
    // on the way out.
    onRender: (el)=>{
        el.call('agentModeRuntimeEnsure');
        el.call('agentModeFocusFrame', el);
    },
    stateDeps: [
        (el, s)=>String(s.root.workspace && (s.root.workspace.id || s.root.workspace._id) || ''),
        // the list entry becomes the full record: the runtime starts then
        (el, s)=>String(s.root.workspace && s.root.workspace._shape || ''),
        (el, s)=>s.root.agentMode === true,
        (el, s)=>s.root._agentModeLink === true,
        (el, s)=>Number(s.root._agentModeRev) || 0,
        // a language switch: the runtime follows it (agentModeRuntimeEnsure)
        (el, s)=>String(s.root.lang || '')
    ],
    onStateUpdate: (el)=>{
        el.call('agentModeRuntimeEnsure');
        el.call('agentModeFocusFrame', el);
    },
    onBeforeRemove: (el)=>el.call('agentModeRuntimeStop'),
    AgentModeBox: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        minHeight: '0',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'line',
        round: 'radiusCard',
        overflow: 'hidden',
        AgentModeHeader: {},
        AgentModeBody: {
            display: 'flex',
            flex: '1',
            minHeight: '0',
            borderTopWidth: 'hairline',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            borderBottomWidth: 'hairline',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            AgentModeSidebar: {},
            AgentModeContent: {}
        },
        AgentModeFooter: {}
    },
    AgentModeOverlay: {},
    AgentModeStartError: {}
};
const $8d592560b7719d81$export$cf5f5c091cbd0507 = {
    tag: 'header',
    data: {
        agentRegion: 'header'
    },
    display: 'flex',
    alignItems: 'center',
    gap: 'A',
    minWidth: '0',
    padding: 'Y A',
    AgentModeHost: {
        color: 'caption',
        whiteSpace: 'nowrap',
        flexShrink: '0',
        text: (el, s)=>el.call('agentModeHeaderOf', el.call('agentModeSnapshot', s.root)).host
    },
    AgentModeTitle: {
        tag: 'h1',
        margin: '0',
        fontSize: 'inherit',
        fontWeight: '700',
        color: 'title',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '0',
        text: (el, s)=>el.call('agentModeHeaderOf', el.call('agentModeSnapshot', s.root)).title
    },
    AgentModeTabs: {
        role: 'tablist',
        data: {
            agentRegion: 'tabs'
        },
        aria: {
            label: (el)=>el.call('polyglot', 'workspace.agentMode.views')
        },
        display: 'flex',
        gap: 'A',
        minWidth: '0',
        overflow: 'hidden',
        childExtends: 'AgentModeTab',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeHeaderOf', el.call('agentModeSnapshot', s.root)).tabs
    },
    AgentModeStatus: {
        marginLeft: 'auto',
        whiteSpace: 'nowrap',
        flexShrink: '0',
        role: 'status',
        data: {
            agentRegion: 'status'
        },
        color: (el, s)=>el.call('agentModeHeaderOf', el.call('agentModeSnapshot', s.root)).statusInk,
        // A spinner while the runtime works (status kind 'busy'), else its text.
        text: (el, s)=>{
            const h = el.call('agentModeHeaderOf', el.call('agentModeSnapshot', s.root));
            return h.busy ? "\u2026" : h.statusText;
        }
    },
    // the workspace or its CLI — the same switch as the home's (Nika
    // 2026-10-23: "add switcher so we can switch between normal and CLI-like
    // workspace easily"); `q` and Ctrl+` still leave
    WorkspaceModeSwitch: {}
};
const $8d592560b7719d81$export$644c5b3913f510d5 = {
    tag: 'button',
    type: 'button',
    role: 'tab',
    data: {
        agentTab: (el, s)=>s.tab
    },
    aria: {
        selected: (el, s)=>s.active ? 'true' : 'false'
    },
    tabindex: '-1',
    background: 'transparent',
    border: 'none',
    padding: '0',
    font: 'inherit',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    color: (el, s)=>s.active ? 'title' : 'caption',
    fontWeight: (el, s)=>s.active ? '700' : '400',
    ':hover': {
        color: 'title'
    },
    ':focus-visible': {
        outline: 'hairline2 solid accentInk'
    },
    text: (el, s)=>s.label,
    onClick: (e, el, s)=>el.call('agentModeClick', s.click, {
            double: e.detail > 1
        })
};
const $8d592560b7719d81$export$27302acd3d3a4574 = {
    tag: 'button',
    type: 'button',
    data: {
        agentAction: 'leave'
    },
    aria: {
        label: (el)=>el.call('polyglot', 'workspace.agentMode.leave')
    },
    title: (el)=>el.call('polyglot', 'workspace.agentMode.leave'),
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'Y',
    flexShrink: '0',
    background: 'transparent',
    border: 'none',
    padding: 'X Y',
    round: 'radiusControl',
    font: 'inherit',
    color: 'caption',
    cursor: 'pointer',
    ':hover': {
        color: 'title',
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    ':focus-visible': {
        outline: 'hairline2 solid accentInk'
    },
    Icon: {
        name: 'terminal',
        boxSize: 'iconSm'
    },
    AgentModeLeaveText: {
        tag: 'span',
        text: (el)=>el.call('polyglot', 'workspace.agentMode.leaveShort')
    },
    onClick: (e, el)=>{
        e.stopPropagation();
        el.call('setAgentMode', false);
    }
};
const $8d592560b7719d81$export$4e85accac0c3dc41 = {
    tag: 'nav',
    data: {
        agentRegion: 'sidebar'
    },
    aria: {
        label: (el)=>el.call('polyglot', 'workspace.agentMode.apps')
    },
    display: 'flex',
    flexDirection: 'column',
    width: 'F1',
    flexShrink: '0',
    overflowY: 'auto',
    padding: 'Z 0',
    borderRightWidth: 'hairline',
    borderRightStyle: 'solid',
    borderRightColor: 'line',
    '@mobileL': {
        display: 'none'
    },
    AgentModeSideList: {
        role: 'listbox',
        aria: {
            label: (el)=>el.call('polyglot', 'workspace.agentMode.apps')
        },
        display: 'flex',
        flexDirection: 'column',
        childExtends: 'AgentModeSideRow',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeSidebarRowsOf', el.call('agentModeSnapshot', s.root))
    }
};
const $8d592560b7719d81$export$9ec9e655be03fd06 = {
    tag: 'div',
    role: (el, s)=>s.kind === 'item' ? 'option' : 'presentation',
    data: {
        agentApp: (el, s)=>s.kind === 'item' ? s.app : null
    },
    aria: {
        selected: (el, s)=>s.kind === 'item' ? s.cursor || s.active ? 'true' : 'false' : null,
        current: (el, s)=>s.kind === 'item' && s.active ? 'page' : null
    },
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    minWidth: '0',
    padding: (el, s)=>s.kind === 'item' ? 'X A' : s.gap ? 'A A X' : 'X A Z',
    cursor: (el, s)=>s.kind === 'item' ? 'pointer' : 'default',
    background: (el, s)=>s.cursor ? 'selected' : 'transparent',
    color: (el, s)=>s.kind === 'label' ? 'caption' : s.cursor || s.active ? 'title' : 'caption',
    textTransform: (el, s)=>s.kind === 'label' ? 'uppercase' : 'none',
    fontWeight: (el, s)=>s.kind === 'item' && s.active ? '700' : '400',
    ':hover': {
        background: 'hover'
    },
    // The app's house glyph — the one the navbar and the App strip wear.
    Icon: {
        aria: {
            hidden: 'true'
        },
        boxSize: 'iconSm',
        flexShrink: '0',
        // A row's kind never changes under its key (the key names the kind).
        if: (el, s)=>s.kind === 'item',
        color: (el, s)=>s.active ? 'accentInk' : 'caption',
        name: (el, s)=>el.call('glyphNameFor', {
                route: s.route,
                name: s.text
            }, 'ln')
    },
    AgentModeSideLabel: {
        tag: 'span',
        flex: '1',
        minWidth: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>s.text
    },
    AgentModeSideBadge: {
        tag: 'span',
        aria: {
            hidden: 'true'
        },
        color: 'accentInk',
        visibility: (el, s)=>s.badge ? 'visible' : 'hidden',
        text: "\u2022"
    },
    AgentModeSideNumber: {
        tag: 'span',
        aria: {
            hidden: 'true'
        },
        color: 'caption',
        hide: (el, s)=>s.kind !== 'item' || !s.number,
        text: (el, s)=>s.number
    },
    onClick: (e, el, s)=>{
        if (s.kind !== 'item') return;
        el.call('agentModeClick', s.click, {
            double: e.detail > 1
        });
    }
};
const $8d592560b7719d81$export$cb13265ccd51013c = {
    tag: 'footer',
    data: {
        agentRegion: 'footer'
    },
    display: 'flex',
    alignItems: 'center',
    gap: 'A',
    minWidth: '0',
    padding: 'Y A',
    AgentModeAskLabel: {
        tag: 'label',
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
        fontWeight: (el, s)=>el.call('agentModeFooterOf', el.call('agentModeSnapshot', s.root)).focused ? '700' : '400',
        color: (el, s)=>el.call('agentModeFooterOf', el.call('agentModeSnapshot', s.root)).focused ? 'accentInk' : 'caption',
        text: (el)=>el.call('polyglot', 'workspace.agentMode.askAi'),
        onClick: (e, el, s)=>el.call('agentModeClick', el.call('agentModeFooterOf', el.call('agentModeSnapshot', s.root)).click, {
                double: false
            })
    },
    // One field, as a one-row list: the row's state follows the snapshot.
    AgentModeAsk: {
        flex: '1',
        minWidth: '0',
        display: 'flex',
        childExtends: 'AgentModeField',
        childrenAs: 'state',
        children: (el, s)=>[
                el.call('agentModeFooterOf', el.call('agentModeSnapshot', s.root)).field
            ]
    },
    AgentModeHints: {
        display: 'flex',
        gap: 'A',
        flexShrink: '0',
        whiteSpace: 'nowrap',
        '@mobileL': {
            display: 'none'
        },
        childExtends: 'AgentModeHint',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeFooterOf', el.call('agentModeSnapshot', s.root)).hints
    }
};
const $8d592560b7719d81$export$740ab3b055c4bd6 = {
    tag: 'span',
    AgentModeHintKey: {
        tag: 'kbd',
        font: 'inherit',
        color: 'caption',
        text: (el, s)=>s.k
    },
    AgentModeHintText: {
        tag: 'span',
        color: 'caption',
        text: (el, s)=>` ${s.v}`
    }
};
const $8d592560b7719d81$export$b4a605184071f199 = {
    tag: 'input',
    type: 'text',
    autocomplete: 'off',
    spellcheck: 'false',
    data: {
        agentTarget: (el, s)=>s.target
    },
    flex: '1',
    minWidth: '0',
    background: 'transparent',
    border: 'none',
    padding: '0',
    font: 'inherit',
    color: 'title',
    outline: 'none',
    '::placeholder': {
        color: 'caption'
    },
    aria: {
        label: (el, s)=>s.labelKey ? el.call('polyglot', s.labelKey) : s.labelText || s.placeholder || null
    },
    placeholder: (el, s)=>s.placeholder,
    value: (el, s)=>s.value,
    onInput: (e, el, s)=>{
        if (el.scope) el.scope.agentModeCaret = e.target.selectionStart;
        el.call('agentModeInput', s.target, e.target.value, e.target.selectionStart);
    },
    // A pointer into a field the model has not focused moves the model's focus
    // there first (the zone the TUI would hit: ask, write, a form field).
    onFocus: (e, el, s)=>{
        if (!s.focused && s.focusPayload) el.call('agentModeClick', s.focusPayload, {
            double: false
        });
    },
    onRender: (el, s)=>el.call('agentModeFocusField', el, s),
    stateDeps: [
        (el, s)=>!!s.focused,
        (el, s)=>Number(s.root._agentModeRev) || 0
    ],
    onStateUpdate: (el, s)=>el.call('agentModeFocusField', el, s)
};
const $8d592560b7719d81$export$941b67e5c6e15022 = {
    role: 'alert',
    position: 'absolute',
    inset: 'auto 0 0 0',
    margin: 'auto',
    padding: 'B',
    hide: (el, s)=>!s.root._agentModeError,
    color: 'dangerInk',
    textAlign: 'center',
    text: (el)=>el.call('polyglot', 'workspace.agentMode.startFailed')
};

});

parcelRegister("2qltX", function(module, exports) {

$parcel$export(module.exports, "AgentModeContent", () => $1c3eac66a51258f2$export$cabbddc88ed258e5);
$parcel$export(module.exports, "AgentModeBoard", () => $1c3eac66a51258f2$export$527748ccc1f5ca30);
$parcel$export(module.exports, "AgentModeBoardEmpty", () => $1c3eac66a51258f2$export$2ec5c804455c25a9);
$parcel$export(module.exports, "AgentModeBoardColumn", () => $1c3eac66a51258f2$export$5a0b934fd5e58bf6);
$parcel$export(module.exports, "AgentModeCard", () => $1c3eac66a51258f2$export$ae2ea1b20a5334e5);
$parcel$export(module.exports, "AgentModeVisual", () => $1c3eac66a51258f2$export$b8568abc4b736c66);
$parcel$export(module.exports, "AgentModeInitial", () => $1c3eac66a51258f2$export$bbead3edc051fea2);
$parcel$export(module.exports, "AgentModeBar", () => $1c3eac66a51258f2$export$3b5eac69e265a258);
$parcel$export(module.exports, "AgentModeList", () => $1c3eac66a51258f2$export$d51c2409d5539bcf);
$parcel$export(module.exports, "AgentModeListHeadCell", () => $1c3eac66a51258f2$export$4b3128d7507f8c33);
$parcel$export(module.exports, "AgentModeListRow", () => $1c3eac66a51258f2$export$23d19cf26647d938);
$parcel$export(module.exports, "AgentModeListCell", () => $1c3eac66a51258f2$export$df2eabcf6574db82);
$parcel$export(module.exports, "AgentModeDetail", () => $1c3eac66a51258f2$export$1686481ca050b64d);
$parcel$export(module.exports, "AgentModeDetailField", () => $1c3eac66a51258f2$export$8b7a65d65d21552c);
$parcel$export(module.exports, "AgentModeDetailSection", () => $1c3eac66a51258f2$export$1d9078f22a99433b);
$parcel$export(module.exports, "AgentModeSectionItem", () => $1c3eac66a51258f2$export$8da6e105437b6acb);
$parcel$export(module.exports, "AgentModeDashboard", () => $1c3eac66a51258f2$export$68a288d59ccca99f);
$parcel$export(module.exports, "AgentModeTile", () => $1c3eac66a51258f2$export$54ac47480d869d92);
$parcel$export(module.exports, "AgentModeChat", () => $1c3eac66a51258f2$export$2faee64a59ba2add);
$parcel$export(module.exports, "AgentModeChannelRow", () => $1c3eac66a51258f2$export$37b581120cc7a4d8);
$parcel$export(module.exports, "AgentModeMessage", () => $1c3eac66a51258f2$export$4737e5e17654e2ee);
$parcel$export(module.exports, "AgentModeAssistant", () => $1c3eac66a51258f2$export$5ee77eeeab6d2cbf);
$parcel$export(module.exports, "AgentModeSuggestion", () => $1c3eac66a51258f2$export$140225a969457ad5);
$parcel$export(module.exports, "AgentModeTurn", () => $1c3eac66a51258f2$export$4deacaae3b6519ed);
$parcel$export(module.exports, "AgentModeMarkdown", () => $1c3eac66a51258f2$export$9a23cdd9ef9bd148);
// AGENT MODE — the content views (WS-AGENT-MODE-1): board, list, detail,
// dashboard, chat and Ask AI, as real DOM. Each copies its TUI view's layout
// and words (smbls cli/tui views/*.js); none decides anything — selection,
// filtering, paging and what a key does are the shared runtime's. Every
// factory reads the snapshot through functions/agentModeView.js.
//
// The view that shows is the snapshot's content type (`hide`, Rule 18).
// Clicks hand the runtime the payload the TUI's hit zones carry
// (functions/agentModeRuntime.js agentModeClick); a second click of a pair is
// the TUI's double click — open.
const $1c3eac66a51258f2$export$cabbddc88ed258e5 = {
    tag: 'main',
    data: {
        agentRegion: 'content',
        agentView: (el, s)=>el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root)).type
    },
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    minWidth: '0',
    minHeight: '0',
    overflow: 'auto',
    padding: 'Z A',
    // The scroller and the model's rows agree (functions/agentModeScroll.js):
    // sizes for the page keys after every render, the model's row → scrollTop,
    // a native scroll → the model's row.
    onRender: (el)=>{
        el.call('agentModeReportScroll', el);
        el.call('agentModeSyncScroll', el);
    },
    stateDeps: [
        (el, s)=>Number(s.root._agentModeRev) || 0
    ],
    onStateUpdate: (el)=>{
        el.call('agentModeReportScroll', el);
        el.call('agentModeSyncScroll', el);
    },
    onScroll: (e, el)=>el.call('agentModeReportScroll', el, {
            top: true
        }),
    AgentModeLoading: {
        role: 'status',
        color: 'caption',
        hide: (el, s)=>el.call('agentModeContentState', el.call('agentModeSnapshot', s.root)) !== 'loading',
        text: (el, s)=>{
            const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
            return el.call('polyglot', 'workspace.agentMode.loading').replace('{view}', c.label.toLowerCase());
        }
    },
    AgentModeError: {
        role: 'alert',
        flow: 'y',
        gap: 'Y',
        hide: (el, s)=>el.call('agentModeContentState', el.call('agentModeSnapshot', s.root)) !== 'error',
        AgentModeErrorText: {
            color: 'dangerInk',
            text: (el, s)=>{
                const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
                return c.error && c.error.message || '';
            }
        },
        AgentModeErrorHint: {
            color: 'caption',
            text: (el, s)=>{
                const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
                return c.error && c.error.hint || '';
            }
        },
        AgentModeErrorKeys: {
            marginTop: 'Z',
            color: 'caption',
            text: (el)=>el.call('polyglot', 'workspace.agentMode.retryKeys')
        }
    },
    AgentModeBoardView: {
        hide: (el, s)=>!el.call('agentModeViewShown', s.root, 'board'),
        flex: '1',
        minHeight: '0',
        display: 'flex',
        AgentModeBoard: {}
    },
    AgentModeListView: {
        hide: (el, s)=>!el.call('agentModeViewShown', s.root, 'list'),
        AgentModeList: {}
    },
    AgentModeDetailView: {
        hide: (el, s)=>!el.call('agentModeViewShown', s.root, 'detail'),
        AgentModeDetail: {}
    },
    AgentModeDashboardView: {
        hide: (el, s)=>!el.call('agentModeViewShown', s.root, 'dashboard'),
        flex: '1',
        minHeight: '0',
        display: 'flex',
        AgentModeDashboard: {}
    },
    AgentModeChatView: {
        hide: (el, s)=>!el.call('agentModeViewShown', s.root, 'chat'),
        flex: '1',
        minHeight: '0',
        display: 'flex',
        AgentModeChat: {}
    },
    AgentModeAssistantView: {
        hide: (el, s)=>!el.call('agentModeViewShown', s.root, 'assistant'),
        AgentModeAssistant: {}
    }
};
const $1c3eac66a51258f2$export$527748ccc1f5ca30 = {
    role: 'group',
    data: {
        agentBoard: true
    },
    display: 'flex',
    gap: 'B',
    flex: '1',
    minWidth: '0',
    minHeight: '0',
    overflowX: 'auto',
    childExtends: 'AgentModeBoardColumn',
    childrenAs: 'state',
    children: (el, s)=>{
        const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
        return c.type === 'board' ? el.call('agentModeBoardModel', s.root) : [];
    }
};
const $1c3eac66a51258f2$export$2ec5c804455c25a9 = {
    color: 'caption',
    hide: (el, s)=>{
        const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
        return c.type !== 'board' || el.call('agentModeBoardModel', s.root).length > 0;
    },
    text: (el, s)=>{
        const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
        return c.empty || el.call('polyglot', 'workspace.agentMode.nothingHere');
    }
};
const $1c3eac66a51258f2$export$5a0b934fd5e58bf6 = {
    tag: 'section',
    data: {
        agentColumn: (el, s)=>s.column
    },
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    minWidth: 'F',
    minHeight: '0',
    aria: {
        label: (el, s)=>s.label
    },
    AgentModeColumnHead: {
        display: 'flex',
        gap: 'Y',
        paddingBottom: 'Y',
        borderBottomWidth: 'hairline',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        AgentModeColumnLabel: {
            tag: 'h2',
            margin: '0',
            fontSize: 'inherit',
            fontWeight: '400',
            textTransform: 'uppercase',
            color: (el, s)=>s.active && s.focused ? 'title' : 'caption',
            text: (el, s)=>s.label
        },
        AgentModeColumnCount: {
            tag: 'span',
            color: 'caption',
            hide: (el, s)=>!s.count,
            text: (el, s)=>String(s.count)
        }
    },
    AgentModeColumnEmpty: {
        padding: 'Z 0',
        color: 'caption',
        hide: (el, s)=>s.cards.length > 0,
        text: (el, s)=>s.empty || "\u2014"
    },
    AgentModeCards: {
        role: 'listbox',
        aria: {
            label: (el, s)=>s.label
        },
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        minHeight: '0',
        childExtends: 'AgentModeCard',
        childrenAs: 'state',
        children: (el, s)=>s.cards
    }
};
const $1c3eac66a51258f2$export$ae2ea1b20a5334e5 = {
    tag: 'div',
    role: 'option',
    data: {
        agentId: (el, s)=>s.id || null
    },
    aria: {
        selected: (el, s)=>s.selected ? 'true' : 'false'
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 'X',
    padding: 'Y Z',
    borderLeftWidth: 'hairline2',
    borderLeftStyle: 'solid',
    borderLeftColor: (el, s)=>s.selected ? s.focused ? 'accentInk' : 'caption' : 'transparent',
    borderBottomWidth: 'hairline',
    borderBottomStyle: 'solid',
    borderBottomColor: 'line',
    background: (el, s)=>s.selected && s.focused ? 'selected' : 'transparent',
    cursor: 'pointer',
    ':hover': {
        background: 'hover'
    },
    stateDeps: [
        (el, s)=>!!s.selected
    ],
    onStateUpdate: (el, s)=>el.call('agentModeRevealSelected', el, s),
    onRender: (el, s)=>el.call('agentModeRevealSelected', el, s),
    onClick: (e, el, s)=>el.call('agentModeClick', s.click, {
            double: e.detail > 1
        }),
    AgentModeCardTitle: {
        color: 'title',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>s.title
    },
    AgentModeCardMeta: {
        display: 'flex',
        alignItems: 'center',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>!s.visual && !s.right,
        AgentModeVisualSlot: {
            flex: '1',
            minWidth: '0',
            display: 'flex',
            childExtends: 'AgentModeVisual',
            childrenAs: 'state',
            children: (el, s)=>s.visual ? [
                    {
                        key: 'visual',
                        ...s.visual
                    }
                ] : []
        },
        AgentModeCardRight: {
            tag: 'span',
            whiteSpace: 'nowrap',
            color: (el, s)=>s.rightInk,
            hide: (el, s)=>!s.right,
            text: (el, s)=>s.right
        }
    }
};
const $1c3eac66a51258f2$export$b8568abc4b736c66 = {
    tag: 'span',
    data: {
        agentVisual: (el, s)=>s.kind
    },
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'X',
    minWidth: '0',
    AgentModeVisualDot: {
        tag: 'span',
        aria: {
            hidden: 'true'
        },
        hide: (el, s)=>s.kind !== 'dot',
        color: (el, s)=>s.ink,
        text: "\u2022"
    },
    AgentModeVisualText: {
        tag: 'span',
        hide: (el, s)=>s.kind !== 'text',
        color: (el, s)=>s.ink,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>s.text
    },
    AgentModeVisualPeople: {
        tag: 'span',
        display: 'inline-flex',
        gap: 'X',
        hide: (el, s)=>s.kind !== 'people',
        childExtends: 'AgentModeInitial',
        childrenAs: 'state',
        children: (el, s)=>s.kind === 'people' ? s.people : []
    },
    AgentModeVisualProgress: {
        tag: 'span',
        role: 'progressbar',
        aria: {
            valuemin: '0',
            valuemax: '100',
            valuenow: (el, s)=>String(Math.round((Number(s.value) || 0) * 100))
        },
        hide: (el, s)=>s.kind !== 'progress',
        display: 'inline-block',
        width: 'D',
        height: 'X',
        round: 'radiusPill',
        background: 'line',
        overflow: 'hidden',
        AgentModeVisualFill: {
            tag: 'span',
            display: 'block',
            height: '100%',
            background: 'accentInk',
            width: (el, s)=>`${Math.round((Number(s.value) || 0) * 100)}%`
        }
    },
    AgentModeVisualBars: {
        tag: 'span',
        aria: {
            hidden: 'true'
        },
        hide: (el, s)=>s.kind !== 'bars',
        display: 'inline-flex',
        alignItems: 'flex-end',
        gap: 'X',
        height: 'Z',
        childExtends: 'AgentModeBar',
        childrenAs: 'state',
        children: (el, s)=>s.kind === 'bars' ? s.bars.map((b)=>({
                    ...b,
                    ink: s.ink
                })) : []
    }
};
const $1c3eac66a51258f2$export$bbead3edc051fea2 = {
    tag: 'span',
    title: (el, s)=>s.name,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 'A',
    padding: '0 X',
    round: 'radiusControl',
    background: 'selected',
    color: 'title',
    text: (el, s)=>s.initial
};
const $1c3eac66a51258f2$export$3b5eac69e265a258 = {
    tag: 'span',
    display: 'inline-block',
    width: 'X',
    background: (el, s)=>s.ink,
    height: (el, s)=>`${Math.round(s.share * 100)}%`
};
const $1c3eac66a51258f2$export$d51c2409d5539bcf = {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    AgentModeFilterLine: {
        display: 'flex',
        gap: 'Z',
        marginBottom: 'Z',
        hide: (el, s)=>!el.call('agentModeListModel', s.root).filter,
        AgentModeFilterSlash: {
            tag: 'span',
            color: 'accentInk',
            text: '/'
        },
        AgentModeFilterField: {
            flex: '1',
            display: 'flex',
            childExtends: 'AgentModeField',
            childrenAs: 'state',
            children: (el, s)=>{
                const f = el.call('agentModeListModel', s.root).filter;
                return f ? [
                    f
                ] : [];
            }
        }
    },
    AgentModeListHead: {
        display: 'grid',
        columnGap: 'A',
        paddingBottom: 'Y',
        borderBottomWidth: 'hairline',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        aria: {
            hidden: 'true'
        },
        hide: (el, s)=>{
            const m = el.call('agentModeListModel', s.root);
            return !m.hasHead || !m.rows.length;
        },
        gridTemplateColumns: (el, s)=>el.call('agentModeListModel', s.root).template,
        childExtends: 'AgentModeListHeadCell',
        childrenAs: 'state',
        children: (el, s)=>{
            const m = el.call('agentModeListModel', s.root);
            return [
                {
                    key: 'hc-marker',
                    label: '',
                    align: 'left'
                },
                ...m.hasMark ? [
                    {
                        key: 'hc-mark',
                        label: '',
                        align: 'left'
                    }
                ] : [],
                ...m.columns
            ];
        }
    },
    AgentModeListRows: {
        role: 'listbox',
        data: {
            agentList: true
        },
        aria: {
            label: (el, s)=>el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root)).label
        },
        display: 'flex',
        flexDirection: 'column',
        childExtends: 'AgentModeListRow',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeListModel', s.root).rows
    },
    AgentModeListEmpty: {
        color: 'caption',
        hide: (el, s)=>{
            const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
            return c.type !== 'list' || el.call('agentModeListModel', s.root).rows.length > 0;
        },
        text: (el, s)=>{
            const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
            const f = el.call('agentModeListModel', s.root).filter;
            return f && f.value ? el.call('polyglot', 'workspace.agentMode.nothingMatches').replace('{query}', f.value) : c.empty || el.call('polyglot', 'workspace.agentMode.nothingHere');
        }
    }
};
const $1c3eac66a51258f2$export$4b3128d7507f8c33 = {
    tag: 'span',
    textTransform: 'uppercase',
    color: 'caption',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: (el, s)=>s.align || 'left',
    text: (el, s)=>s.label
};
const $1c3eac66a51258f2$export$23d19cf26647d938 = {
    tag: 'div',
    role: (el, s)=>s.kind === 'row' ? 'option' : 'presentation',
    data: {
        agentId: (el, s)=>s.kind === 'row' && s.id || null
    },
    aria: {
        selected: (el, s)=>s.kind === 'row' ? s.selected ? 'true' : 'false' : null
    },
    display: 'grid',
    columnGap: 'A',
    alignItems: 'center',
    padding: (el, s)=>s.kind === 'group' ? 'Z 0 X' : 'X 0',
    // A zero-width first track holds the cursor marker (the TUI's ▎).
    gridTemplateColumns: (el, s)=>s.kind === 'group' ? '1fr' : s.template,
    background: (el, s)=>s.selected && s.focused ? 'selected' : 'transparent',
    cursor: (el, s)=>s.kind === 'row' ? 'pointer' : 'default',
    ':hover': {
        background: 'hover'
    },
    stateDeps: [
        (el, s)=>!!s.selected
    ],
    onStateUpdate: (el, s)=>el.call('agentModeRevealSelected', el, s),
    onRender: (el, s)=>el.call('agentModeRevealSelected', el, s),
    onClick: (e, el, s)=>{
        if (s.kind !== 'row') return;
        el.call('agentModeClick', s.click, {
            double: e.detail > 1
        });
    },
    AgentModeRowMarker: {
        tag: 'span',
        aria: {
            hidden: 'true'
        },
        hide: (el, s)=>s.kind !== 'row',
        width: '0',
        height: '100%',
        borderLeftWidth: 'hairline2',
        borderLeftStyle: 'solid',
        borderLeftColor: (el, s)=>s.selected ? s.focused ? 'accentInk' : 'caption' : 'transparent'
    },
    AgentModeRowGroup: {
        tag: 'span',
        hide: (el, s)=>s.kind !== 'group',
        color: 'caption',
        text: (el, s)=>s.text
    },
    AgentModeRowMark: {
        tag: 'span',
        aria: {
            hidden: 'true'
        },
        hide: (el, s)=>s.kind !== 'row' || !s.mark,
        color: (el, s)=>s.mark && s.mark.ink || 'title',
        text: (el, s)=>s.mark ? s.mark.text : ''
    },
    AgentModeRowCells: {
        display: 'contents',
        hide: (el, s)=>s.kind !== 'row',
        childExtends: 'AgentModeListCell',
        childrenAs: 'state',
        children: (el, s)=>s.kind === 'row' ? s.cells : []
    }
};
const $1c3eac66a51258f2$export$df2eabcf6574db82 = {
    tag: 'span',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '0',
    textAlign: (el, s)=>s.align || 'left',
    color: (el, s)=>s.main ? 'title' : 'caption',
    fontWeight: (el, s)=>s.main && s.strong ? '700' : '400',
    text: (el, s)=>s.text
};
const $1c3eac66a51258f2$export$1686481ca050b64d = {
    tag: 'article',
    data: {
        agentId: (el, s)=>el.call('agentModeDetailModel', s.root).id || null
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    maxWidth: 'I',
    AgentModeDetailTitle: {
        tag: 'h2',
        margin: '0',
        fontSize: 'inherit',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>el.call('agentModeDetailModel', s.root).title
    },
    AgentModeDetailMeta: {
        textTransform: 'uppercase',
        color: 'caption',
        hide: (el, s)=>!el.call('agentModeDetailModel', s.root).meta,
        text: (el, s)=>el.call('agentModeDetailModel', s.root).meta
    },
    AgentModeDetailFields: {
        tag: 'dl',
        margin: '0',
        display: 'grid',
        columnGap: 'B',
        rowGap: 'X',
        padding: 'Z 0',
        borderTopWidth: 'hairline',
        borderTopStyle: 'solid',
        borderTopColor: 'line',
        borderBottomWidth: 'hairline',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 22em), 1fr))',
        hide: (el, s)=>!el.call('agentModeDetailModel', s.root).fields.length,
        childExtends: 'AgentModeDetailField',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeDetailModel', s.root).fields
    },
    AgentModeDetailBody: {
        childExtends: 'AgentModeMarkdown',
        childrenAs: 'state',
        children: (el, s)=>{
            const body = el.call('agentModeDetailModel', s.root).body;
            return body ? [
                {
                    key: `md-${el.call('agentModeTextKey', body)}`,
                    text: body
                }
            ] : [];
        }
    },
    AgentModeDetailSections: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Z',
        childExtends: 'AgentModeDetailSection',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeDetailModel', s.root).sections
    }
};
const $1c3eac66a51258f2$export$8b7a65d65d21552c = {
    display: 'flex',
    gap: 'Z',
    minWidth: '0',
    AgentModeFieldLabel: {
        tag: 'dt',
        // The TUI's label column: up to 12 cells (detail.js labelW).
        width: 'E',
        flexShrink: '0',
        textTransform: 'uppercase',
        color: 'caption',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>s.label
    },
    AgentModeFieldValue: {
        tag: 'dd',
        margin: '0',
        minWidth: '0',
        color: 'paragraph',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.value
    }
};
const $1c3eac66a51258f2$export$1d9078f22a99433b = {
    tag: 'section',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Y',
    paddingTop: 'Z',
    borderTopWidth: 'hairline',
    borderTopStyle: 'solid',
    borderTopColor: 'line',
    AgentModeSectionTitle: {
        tag: 'h3',
        margin: '0',
        fontSize: 'inherit',
        fontWeight: '400',
        textTransform: 'uppercase',
        color: 'caption',
        text: (el, s)=>s.title
    },
    AgentModeSectionEmpty: {
        color: 'caption',
        hide: (el, s)=>s.items.length > 0,
        text: (el, s)=>s.empty || el.call('polyglot', 'workspace.agentMode.nothingYet')
    },
    AgentModeSectionItems: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Z',
        childExtends: 'AgentModeSectionItem',
        childrenAs: 'state',
        children: (el, s)=>s.items
    }
};
const $1c3eac66a51258f2$export$8da6e105437b6acb = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'X',
    AgentModeItemByline: {
        AgentModeItemAuthor: {
            tag: 'strong',
            color: 'title',
            text: (el, s)=>s.author
        },
        AgentModeItemTime: {
            tag: 'span',
            color: 'caption',
            text: (el, s)=>s.time ? ` \xb7 ${s.time}` : ''
        }
    },
    AgentModeItemText: {
        paddingLeft: 'Z',
        childExtends: 'AgentModeMarkdown',
        childrenAs: 'state',
        children: (el, s)=>s.text ? [
                {
                    key: `md-${el.call('agentModeTextKey', s.text)}`,
                    text: s.text
                }
            ] : []
    }
};
const $1c3eac66a51258f2$export$68a288d59ccca99f = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    flex: '1',
    minWidth: '0',
    minHeight: '0',
    AgentModeGreetingRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: 'A',
        hide: (el, s)=>!el.call('agentModeDashboardModel', s.root).greeting,
        AgentModeGreeting: {
            tag: 'h2',
            margin: '0',
            fontSize: 'inherit',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>el.call('agentModeDashboardModel', s.root).greeting
        },
        AgentModeSubtitle: {
            marginLeft: 'auto',
            color: 'caption',
            whiteSpace: 'nowrap',
            text: (el, s)=>el.call('agentModeDashboardModel', s.root).subtitle
        }
    },
    AgentModeTiles: {
        display: 'grid',
        gap: 'B',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 14ch), 1fr))',
        hide: (el, s)=>!el.call('agentModeDashboardModel', s.root).tiles.length,
        childExtends: 'AgentModeTile',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeDashboardModel', s.root).tiles
    },
    AgentModePartsFailed: {
        role: 'status',
        color: 'warningInk',
        hide: (el, s)=>!el.call('agentModeDashboardModel', s.root).errors,
        text: (el, s)=>el.call('polyglot', 'workspace.agentMode.partsFailed').replace('{count}', String(el.call('agentModeDashboardModel', s.root).errors))
    },
    AgentModeDashboardBoard: {
        display: 'flex',
        gap: 'B',
        flex: '1',
        minWidth: '0',
        minHeight: '0',
        overflowX: 'auto',
        childExtends: 'AgentModeBoardColumn',
        childrenAs: 'state',
        children: (el, s)=>{
            const c = el.call('agentModeContentOf', el.call('agentModeSnapshot', s.root));
            return c.type === 'dashboard' ? el.call('agentModeBoardModel', s.root) : [];
        }
    }
};
const $1c3eac66a51258f2$export$54ac47480d869d92 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'X',
    minWidth: '0',
    AgentModeTileLabel: {
        textTransform: 'uppercase',
        color: 'caption',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>s.label
    },
    AgentModeTileValue: {
        display: 'flex',
        alignItems: 'center',
        gap: 'Y',
        AgentModeTileNumber: {
            tag: 'strong',
            color: 'title',
            text: (el, s)=>s.value
        },
        AgentModeTileDot: {
            tag: 'span',
            aria: {
                hidden: 'true'
            },
            hide: (el, s)=>!s.dot,
            color: (el, s)=>s.dot,
            text: "\u2022"
        }
    },
    AgentModeTileHint: {
        color: 'caption',
        hide: (el, s)=>s.progress != null || !s.hint,
        text: (el, s)=>s.hint
    },
    AgentModeTileProgress: {
        hide: (el, s)=>s.progress == null,
        childExtends: 'AgentModeVisual',
        childrenAs: 'state',
        children: (el, s)=>s.progress == null ? [] : [
                {
                    key: 'progress',
                    kind: 'progress',
                    value: s.progress
                }
            ]
    }
};
const $1c3eac66a51258f2$export$2faee64a59ba2add = {
    display: 'flex',
    flex: '1',
    minWidth: '0',
    minHeight: '0',
    gap: 'A',
    AgentModeChannels: {
        tag: 'nav',
        // The TUI's channel rail: 20 cells (chat.js RAIL).
        width: 'F',
        flexShrink: '0',
        display: 'flex',
        flexDirection: 'column',
        gap: 'X',
        paddingRight: 'Z',
        borderRightWidth: 'hairline',
        borderRightStyle: 'solid',
        borderRightColor: 'line',
        overflowY: 'auto',
        '@tabletSm': {
            display: 'none'
        },
        aria: {
            label: (el)=>el.call('polyglot', 'workspace.agentMode.channels')
        },
        AgentModeChannelsLabel: {
            textTransform: 'uppercase',
            color: 'caption',
            marginBottom: 'Y',
            text: (el)=>el.call('polyglot', 'workspace.agentMode.channels')
        },
        AgentModeChannelList: {
            role: 'listbox',
            aria: {
                label: (el)=>el.call('polyglot', 'workspace.agentMode.channels')
            },
            display: 'flex',
            flexDirection: 'column',
            childExtends: 'AgentModeChannelRow',
            childrenAs: 'state',
            children: (el, s)=>el.call('agentModeChatModel', s.root).channels
        }
    },
    AgentModeChatPane: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        minWidth: '0',
        minHeight: '0',
        AgentModeChatEmpty: {
            color: 'caption',
            hide: (el, s)=>!!el.call('agentModeChatModel', s.root).active,
            text: (el, s)=>el.call('polyglot', el.call('agentModeChatModel', s.root).channels.length ? 'workspace.agentMode.pickChannel' : 'workspace.agentMode.noChannels')
        },
        AgentModeChatHead: {
            display: 'flex',
            gap: 'Z',
            paddingBottom: 'Y',
            borderBottomWidth: 'hairline',
            borderBottomStyle: 'solid',
            borderBottomColor: 'line',
            hide: (el, s)=>!el.call('agentModeChatModel', s.root).active,
            AgentModeChatTitle: {
                tag: 'h2',
                margin: '0',
                fontSize: 'inherit',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>(el.call('agentModeChatModel', s.root).active || {}).label || ''
            },
            AgentModeChatTopic: {
                color: 'caption',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                text: (el, s)=>el.call('agentModeChatModel', s.root).topic
            }
        },
        AgentModeMessages: {
            role: 'log',
            aria: {
                label: (el, s)=>(el.call('agentModeChatModel', s.root).active || {}).label || ''
            },
            flex: '1',
            minHeight: '0',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 'Z',
            padding: 'Z 0',
            hide: (el, s)=>!el.call('agentModeChatModel', s.root).active,
            AgentModeNoMessages: {
                color: 'caption',
                hide: (el, s)=>el.call('agentModeChatModel', s.root).messages.length > 0,
                text: (el)=>el.call('polyglot', 'workspace.agentMode.noMessages')
            },
            AgentModeMessageList: {
                display: 'flex',
                flexDirection: 'column',
                gap: 'Z',
                childExtends: 'AgentModeMessage',
                childrenAs: 'state',
                children: (el, s)=>el.call('agentModeChatModel', s.root).messages
            }
        },
        AgentModeComposer: {
            display: 'flex',
            alignItems: 'center',
            gap: 'Z',
            paddingTop: 'Y',
            borderTopWidth: 'hairline',
            borderTopStyle: 'solid',
            borderTopColor: 'line',
            hide: (el, s)=>!el.call('agentModeChatModel', s.root).active,
            AgentModePrompt: {
                tag: 'span',
                aria: {
                    hidden: 'true'
                },
                color: (el, s)=>el.call('agentModeChatModel', s.root).writing ? 'accentInk' : 'caption',
                text: "\u203A"
            },
            AgentModeComposerIdle: {
                tag: 'button',
                type: 'button',
                flex: '1',
                textAlign: 'left',
                background: 'transparent',
                border: 'none',
                padding: '0',
                font: 'inherit',
                color: 'caption',
                cursor: 'text',
                ':hover': {
                    color: 'title'
                },
                ':focus-visible': {
                    outline: 'hairline2 solid accentInk'
                },
                hide: (el, s)=>el.call('agentModeChatModel', s.root).writing,
                text: (el, s)=>el.call('polyglot', 'workspace.agentMode.writeIn').replace('{channel}', (el.call('agentModeChatModel', s.root).active || {}).label || ''),
                onClick: (e, el, s)=>el.call('agentModeClick', el.call('agentModeChatModel', s.root).writeClick, {
                        double: false
                    })
            },
            AgentModeComposerField: {
                flex: '1',
                display: 'flex',
                hide: (el, s)=>!el.call('agentModeChatModel', s.root).writing,
                childExtends: 'AgentModeField',
                childrenAs: 'state',
                children: (el, s)=>{
                    const m = el.call('agentModeChatModel', s.root);
                    return [
                        {
                            ...m.composer,
                            placeholder: m.composer.placeholder || el.call('polyglot', 'workspace.agentMode.writeMessage')
                        }
                    ];
                }
            }
        }
    }
};
const $1c3eac66a51258f2$export$37b581120cc7a4d8 = {
    tag: 'div',
    role: 'option',
    data: {
        agentId: (el, s)=>s.id
    },
    aria: {
        selected: (el, s)=>s.selected ? 'true' : 'false'
    },
    padding: 'X Z',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderLeftWidth: 'hairline2',
    borderLeftStyle: 'solid',
    borderLeftColor: (el, s)=>s.selected ? 'accentInk' : 'transparent',
    color: (el, s)=>s.selected ? 'title' : 'caption',
    ':hover': {
        background: 'hover'
    },
    text: (el, s)=>s.label,
    onClick: (e, el, s)=>el.call('agentModeClick', s.click, {
            double: e.detail > 1
        })
};
const $1c3eac66a51258f2$export$4737e5e17654e2ee = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'X',
    AgentModeMessageByline: {
        AgentModeMessageAuthor: {
            tag: 'strong',
            color: (el, s)=>s.mine ? 'accentInk' : 'title',
            text: (el, s)=>s.author
        },
        AgentModeMessageTime: {
            tag: 'span',
            color: 'caption',
            text: (el, s)=>s.time ? ` \xb7 ${s.time}` : ''
        }
    },
    AgentModeMessageText: {
        paddingLeft: 'Z',
        childExtends: 'AgentModeMarkdown',
        childrenAs: 'state',
        children: (el, s)=>s.text ? [
                {
                    key: `md-${el.call('agentModeTextKey', s.text)}`,
                    text: s.text
                }
            ] : []
    }
};
const $1c3eac66a51258f2$export$5ee77eeeab6d2cbf = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'A',
    maxWidth: 'I',
    AgentModeAssistantEmpty: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Y',
        hide: (el, s)=>el.call('agentModeAssistantModel', s.root).turns.length > 0,
        AgentModeAssistantTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'inherit',
            fontWeight: '700',
            color: 'title',
            text: (el)=>el.call('polyglot', 'workspace.agentMode.assistantTitle')
        },
        AgentModeAssistantHint: {
            color: 'caption',
            text: (el)=>el.call('polyglot', 'workspace.agentMode.assistantHint')
        },
        AgentModeSuggestions: {
            tag: 'ul',
            margin: 'Z 0 0',
            padding: '0',
            listStyle: 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: 'X',
            childExtends: 'AgentModeSuggestion',
            childrenAs: 'state',
            children: (el, s)=>el.call('agentModeAssistantModel', s.root).suggestions
        }
    },
    AgentModeTurns: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'A',
        childExtends: 'AgentModeTurn',
        childrenAs: 'state',
        children: (el, s)=>el.call('agentModeAssistantModel', s.root).turns
    }
};
const $1c3eac66a51258f2$export$140225a969457ad5 = {
    tag: 'li',
    color: 'caption',
    text: (el, s)=>`\u{2022} ${s.text}`
};
const $1c3eac66a51258f2$export$4deacaae3b6519ed = {
    data: {
        agentTurn: (el, s)=>s.role
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 'X',
    AgentModeTurnWho: {
        textTransform: 'uppercase',
        fontWeight: (el, s)=>s.role === 'user' ? '400' : '700',
        color: (el, s)=>s.role === 'user' ? 'caption' : 'accentInk',
        text: (el, s)=>el.call('polyglot', s.role === 'user' ? 'workspace.agentMode.you' : 'workspace.agentMode.ai')
    },
    AgentModeTurnUser: {
        color: 'title',
        whiteSpace: 'pre-wrap',
        hide: (el, s)=>s.role !== 'user',
        text: (el, s)=>s.text
    },
    AgentModeTurnAnswer: {
        hide: (el, s)=>s.role === 'user',
        childExtends: 'AgentModeMarkdown',
        childrenAs: 'state',
        children: (el, s)=>// Parsed ONCE when the answer ends (the chat bubble's rule): a growing
            // half-finished markdown text renders as artefacts.
            s.role !== 'user' && s.text && s.status !== 'streaming' ? [
                {
                    key: `md-${el.call('agentModeTextKey', s.text)}`,
                    text: s.text
                }
            ] : []
    },
    AgentModeTurnStreamText: {
        color: 'paragraph',
        whiteSpace: 'pre-wrap',
        hide: (el, s)=>s.role === 'user' || s.status !== 'streaming',
        text: (el, s)=>s.text
    },
    AgentModeTurnStreaming: {
        role: 'status',
        color: 'accentInk',
        hide: (el, s)=>s.status !== 'streaming',
        text: "\u2026"
    },
    AgentModeTurnError: {
        role: 'alert',
        color: 'dangerInk',
        hide: (el, s)=>s.status !== 'error',
        text: (el, s)=>s.error || el.call('polyglot', 'workspace.agentMode.assistantFailed')
    },
    AgentModeTurnHint: {
        color: 'caption',
        hide: (el, s)=>s.status !== 'error' || !s.hint,
        text: (el, s)=>s.hint
    },
    AgentModeTurnStopped: {
        color: 'caption',
        hide: (el, s)=>s.status !== 'stopped',
        text: (el)=>el.call('polyglot', 'workspace.agentMode.stopped')
    }
};
const $1c3eac66a51258f2$export$9a23cdd9ef9bd148 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'Y',
    minWidth: '0',
    color: 'paragraph',
    // Every block the renderer returns keeps the frame's size: a heading is
    // the line's weight, not a display size (the TUI draws one cell height).
    childProps: {
        fontSize: 'inherit',
        lineHeight: 'inherit',
        margin: '0'
    },
    children: (el, s)=>el.call('renderAssistantMarkdown', s.text || '')
};

});

parcelRegister("8a5bZ", function(module, exports) {

$parcel$export(module.exports, "AgentModeOverlay", () => $5f134905d9d41b90$export$563156e3603240a8);
$parcel$export(module.exports, "AgentModePicker", () => $5f134905d9d41b90$export$974c97c04cde37e2);
$parcel$export(module.exports, "AgentModePickerRow", () => $5f134905d9d41b90$export$1745eb101e8d8cfa);
$parcel$export(module.exports, "AgentModeForm", () => $5f134905d9d41b90$export$88e2cb4e3e77e7a5);
$parcel$export(module.exports, "AgentModeFormRow", () => $5f134905d9d41b90$export$199529c1ffab0b2d);
$parcel$export(module.exports, "AgentModeTextarea", () => $5f134905d9d41b90$export$b2c873f340da0ac1);
$parcel$export(module.exports, "AgentModeConfirm", () => $5f134905d9d41b90$export$c960d7bb157995a5);
$parcel$export(module.exports, "AgentModeChoice", () => $5f134905d9d41b90$export$397170b6ac6b0a6c);
$parcel$export(module.exports, "AgentModeHelp", () => $5f134905d9d41b90$export$54a76287bc0f31bc);
$parcel$export(module.exports, "AgentModeHelpSection", () => $5f134905d9d41b90$export$cc13ae4e6f9fb433);
$parcel$export(module.exports, "AgentModeHelpRow", () => $5f134905d9d41b90$export$b91e5ea93afadbe8);
// AGENT MODE — the overlays (WS-AGENT-MODE-1): the command palette with
// workspace search, pickers, forms, confirmations and the key help, as real
// DOM dialogs over the frame (smbls cli/tui shell/overlays.js: a titled box
// with its key hint on the bottom edge). The top overlay takes every key in
// the runtime; the DOM shows it and forwards clicks: a row `{ pick }`, a form
// field `{ field }`, the submit button `{ submit }`, yes / no `{ ok }`.
const $5f134905d9d41b90$export$563156e3603240a8 = {
    data: {
        agentRegion: 'overlay'
    },
    position: 'absolute',
    inset: '0',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 'D A A',
    background: 'scrim',
    hide: (el, s)=>!el.call('agentModeOverlayModel', s.root),
    AgentModeDialog: {
        tag: 'section',
        role: 'dialog',
        aria: {
            modal: 'true',
            label: (el, s)=>{
                const o = el.call('agentModeOverlayModel', s.root);
                if (!o) return null;
                return o.title;
            }
        },
        data: {
            agentOverlay: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).kind || null
        },
        display: 'flex',
        flexDirection: 'column',
        gap: 'Z',
        width: 'overlayXl',
        maxWidth: '100%',
        maxHeight: '100%',
        boxSizing: 'border-box',
        padding: 'Z A',
        background: 'document',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'line',
        round: 'radiusCard',
        overflow: 'hidden',
        AgentModeDialogTitle: {
            tag: 'h2',
            margin: '0',
            fontSize: 'inherit',
            fontWeight: '400',
            textTransform: 'uppercase',
            color: 'caption',
            text: (el, s)=>{
                const o = el.call('agentModeOverlayModel', s.root);
                return o ? o.title : '';
            }
        },
        AgentModePicker: {},
        AgentModeForm: {},
        AgentModeConfirm: {},
        AgentModeHelp: {},
        AgentModeDialogHint: {
            alignSelf: 'flex-end',
            color: 'caption',
            text: (el, s)=>{
                const o = el.call('agentModeOverlayModel', s.root);
                const key = {
                    picker: 'workspace.agentMode.hintPicker',
                    form: 'workspace.agentMode.hintForm',
                    confirm: 'workspace.agentMode.hintConfirm',
                    help: 'workspace.agentMode.hintHelp'
                }[o && o.kind || ''];
                return key ? el.call('polyglot', key) : '';
            }
        }
    }
};
const $5f134905d9d41b90$export$974c97c04cde37e2 = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '0',
    hide: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).kind !== 'picker',
    AgentModePickerQuery: {
        display: 'flex',
        gap: 'Z',
        paddingBottom: 'Y',
        borderBottomWidth: 'hairline',
        borderBottomStyle: 'solid',
        borderBottomColor: 'line',
        AgentModePickerPrompt: {
            tag: 'span',
            aria: {
                hidden: 'true'
            },
            color: 'accentInk',
            text: "\u203A"
        },
        AgentModePickerField: {
            flex: '1',
            display: 'flex',
            childExtends: 'AgentModeField',
            childrenAs: 'state',
            children: (el, s)=>{
                const o = el.call('agentModeOverlayModel', s.root);
                return o && o.kind === 'picker' ? [
                    o.query
                ] : [];
            }
        }
    },
    AgentModePickerEmpty: {
        padding: 'Y 0',
        color: 'caption',
        hide: (el, s)=>{
            const o = el.call('agentModeOverlayModel', s.root);
            return !o || o.kind !== 'picker' || o.items.length > 0;
        },
        text: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).emptyText || el.call('polyglot', 'workspace.agentMode.noMatches')
    },
    AgentModePickerRows: {
        role: 'listbox',
        aria: {
            label: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).title || ''
        },
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        minHeight: '0',
        maxHeight: 'G',
        paddingTop: 'Y',
        childExtends: 'AgentModePickerRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const o = el.call('agentModeOverlayModel', s.root);
            return o && o.kind === 'picker' ? o.items : [];
        }
    }
};
const $5f134905d9d41b90$export$1745eb101e8d8cfa = {
    tag: 'div',
    role: 'option',
    aria: {
        selected: (el, s)=>s.selected ? 'true' : 'false'
    },
    display: 'flex',
    gap: 'A',
    padding: 'X Z',
    cursor: 'pointer',
    background: (el, s)=>s.selected ? 'selected' : 'transparent',
    ':hover': {
        background: 'hover'
    },
    stateDeps: [
        (el, s)=>!!s.selected
    ],
    onStateUpdate: (el, s)=>el.call('agentModeRevealSelected', el, s),
    opacity: (el, s)=>s.enabled ? null : '0.6',
    onClick: (e, el, s)=>el.call('agentModeClick', s.click, {
            double: e.detail > 1
        }),
    AgentModePickerLabel: {
        flex: '1',
        minWidth: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: (el, s)=>s.selected ? 'title' : s.ink,
        text: (el, s)=>s.label
    },
    AgentModePickerHint: {
        color: 'caption',
        whiteSpace: 'nowrap',
        hide: (el, s)=>!s.hint,
        text: (el, s)=>s.hint
    }
};
const $5f134905d9d41b90$export$88e2cb4e3e77e7a5 = {
    tag: 'form',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    hide: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).kind !== 'form',
    // Enter in a field steers through the keydown bridge; never a page submit.
    onSubmit: (e)=>e.preventDefault(),
    AgentModeFormFields: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Z',
        childExtends: 'AgentModeFormRow',
        childrenAs: 'state',
        children: (el, s)=>{
            const o = el.call('agentModeOverlayModel', s.root);
            return o && o.kind === 'form' ? o.fields : [];
        }
    },
    AgentModeFormSubmit: {
        tag: 'button',
        type: 'button',
        alignSelf: 'flex-start',
        padding: 'X Z',
        font: 'inherit',
        cursor: 'pointer',
        round: 'radiusControl',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'line',
        background: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).submitFocused ? 'title' : 'transparent',
        color: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).submitFocused ? 'document' : 'title',
        ':hover': {
            background: 'hover'
        },
        ':focus-visible': {
            outline: 'hairline2 solid accentInk'
        },
        text: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).submitLabel || '',
        onClick: (e, el, s)=>el.call('agentModeClick', (el.call('agentModeOverlayModel', s.root) || {}).submitClick, {
                double: false
            })
    }
};
const $5f134905d9d41b90$export$199529c1ffab0b2d = {
    data: {
        agentFormField: (el, s)=>s.field
    },
    display: 'grid',
    // The TUI's label column: one width for every row (14 cells at most).
    gridTemplateColumns: '1ch 14ch minmax(0, 1fr)',
    columnGap: 'Z',
    rowGap: 'X',
    alignItems: 'start',
    AgentModeFormMarker: {
        tag: 'span',
        aria: {
            hidden: 'true'
        },
        color: 'accentInk',
        text: (el, s)=>s.focused ? "\u203A" : ''
    },
    AgentModeFormLabel: {
        tag: 'span',
        color: (el, s)=>s.focused ? 'title' : 'caption',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        text: (el, s)=>s.label
    },
    AgentModeFormValue: {
        display: 'flex',
        minWidth: '0',
        AgentModeFormText: {
            flex: '1',
            display: 'flex',
            hide: (el, s)=>s.type !== 'text',
            childExtends: 'AgentModeField',
            childrenAs: 'state',
            children: (el, s)=>s.type === 'text' ? [
                    s.input
                ] : []
        },
        AgentModeFormEditor: {
            flex: '1',
            display: 'flex',
            hide: (el, s)=>s.type !== 'editor',
            childExtends: 'AgentModeTextarea',
            childrenAs: 'state',
            children: (el, s)=>s.type === 'editor' ? [
                    s.input
                ] : []
        },
        AgentModeFormSelect: {
            tag: 'button',
            type: 'button',
            hide: (el, s)=>s.type !== 'select',
            background: (el, s)=>s.focused ? 'selected' : 'transparent',
            border: 'none',
            padding: '0 X',
            font: 'inherit',
            color: 'title',
            cursor: 'pointer',
            round: 'radiusControl',
            ':hover': {
                background: 'hover'
            },
            ':focus-visible': {
                outline: 'hairline2 solid accentInk'
            },
            text: (el, s)=>`\u{2039} ${s.optionLabel || "\u2014"} \u{203A}`,
            onClick: (e, el, s)=>el.call('agentModeClick', s.click, {
                    double: e.detail > 1
                })
        }
    },
    AgentModeFormError: {
        role: 'alert',
        gridColumn: '3',
        color: 'dangerInk',
        hide: (el, s)=>!s.error,
        text: (el, s)=>s.error
    }
};
const $5f134905d9d41b90$export$b2c873f340da0ac1 = {
    extends: 'AgentModeField',
    tag: 'textarea',
    type: null,
    rows: '4',
    resize: 'vertical',
    lineHeight: '1.5',
    padding: 'X Y',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    round: 'radiusControl'
};
const $5f134905d9d41b90$export$c960d7bb157995a5 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'A',
    hide: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).kind !== 'confirm',
    AgentModeConfirmMessage: {
        color: 'title',
        whiteSpace: 'pre-wrap',
        text: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).message || ''
    },
    AgentModeConfirmButtons: {
        display: 'flex',
        gap: 'Z',
        AgentModeChoice: {
            data: {
                agentAction: 'yes'
            },
            isChosen: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).choice === 0,
            isDanger: (el, s)=>!!(el.call('agentModeOverlayModel', s.root) || {}).danger,
            text: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).yes || '',
            onClick: (e, el, s)=>el.call('agentModeClick', (el.call('agentModeOverlayModel', s.root) || {}).yesClick, {
                    double: false
                })
        },
        AgentModeChoice_1: {
            data: {
                agentAction: 'no'
            },
            isChosen: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).choice === 1,
            text: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).no || '',
            onClick: (e, el, s)=>el.call('agentModeClick', (el.call('agentModeOverlayModel', s.root) || {}).noClick, {
                    double: false
                })
        }
    }
};
const $5f134905d9d41b90$export$397170b6ac6b0a6c = {
    tag: 'button',
    type: 'button',
    padding: 'X Z',
    font: 'inherit',
    cursor: 'pointer',
    round: 'radiusControl',
    borderWidth: 'hairline',
    borderStyle: 'solid',
    borderColor: 'line',
    background: 'transparent',
    color: 'title',
    ':hover': {
        background: 'hover'
    },
    ':focus-visible': {
        outline: 'hairline2 solid accentInk'
    },
    '.isChosen': {
        background: 'title',
        color: 'document'
    },
    '.isDanger': {
        color: 'dangerInk'
    }
};
const $5f134905d9d41b90$export$54a76287bc0f31bc = {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    minHeight: '0',
    flex: '0 1 auto',
    hide: (el, s)=>(el.call('agentModeOverlayModel', s.root) || {}).kind !== 'help',
    childExtends: 'AgentModeHelpSection',
    childrenAs: 'state',
    children: (el, s)=>{
        const o = el.call('agentModeOverlayModel', s.root);
        return o && o.kind === 'help' ? o.sections : [];
    },
    onRender: (el)=>el.call('agentModeSyncHelpScroll', el),
    stateDeps: [
        (el, s)=>Number(s.root._agentModeRev) || 0
    ],
    onStateUpdate: (el)=>el.call('agentModeSyncHelpScroll', el),
    onScroll: (e, el)=>el.call('agentModeReportHelpScroll', el)
};
const $5f134905d9d41b90$export$cc13ae4e6f9fb433 = {
    tag: 'section',
    display: 'flex',
    flexDirection: 'column',
    AgentModeHelpTitle: {
        tag: 'h3',
        margin: '0',
        fontSize: 'inherit',
        fontWeight: '400',
        textTransform: 'uppercase',
        color: 'caption',
        text: (el, s)=>s.title
    },
    AgentModeHelpRows: {
        tag: 'dl',
        margin: '0',
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr)',
        columnGap: 'A',
        childExtends: 'AgentModeHelpRow',
        childrenAs: 'state',
        children: (el, s)=>s.rows
    },
    // The blank line after each section (drawHelp pushes one).
    AgentModeHelpBlank: {
        aria: {
            hidden: 'true'
        },
        text: '\u00a0'
    }
};
const $5f134905d9d41b90$export$b91e5ea93afadbe8 = {
    display: 'contents',
    AgentModeHelpKey: {
        tag: 'dt',
        color: 'accentInk',
        text: (el, s)=>s.k
    },
    // One line, cut like the TUI's truncate(): a long label never wraps.
    AgentModeHelpLabel: {
        tag: 'dd',
        margin: '0',
        minWidth: '0',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: 'paragraph',
        text: (el, s)=>s.label
    }
};

});

parcelRegister("fx4Qn", function(module, exports) {

$parcel$export(module.exports, "PhoneNavigation", () => $b4edb1f18d52aa8a$export$89683fc9287db041);
$parcel$export(module.exports, "PhoneNavButton", () => $b4edb1f18d52aa8a$export$cd960919ba4b5eb6);
$parcel$export(module.exports, "PhoneSheetAction", () => $b4edb1f18d52aa8a$export$f6c3bd1d05f683c4);
$parcel$export(module.exports, "PhoneAppSection", () => $b4edb1f18d52aa8a$export$7ba4c7c8f3fb7e92);
$parcel$export(module.exports, "PhoneAppTile", () => $b4edb1f18d52aa8a$export$810a92740ae846ca);
// The phone keeps one navigation row. The existing dialog, launcher tiles,
// account menu and workspace switcher own their behavior and accessibility
// contracts.
const $b4edb1f18d52aa8a$export$89683fc9287db041 = {
    display: 'contents',
    canCompose: true,
    dataPhoneNav: (el, s)=>el.call('phoneNavigationAvailable', s.root) ? 'true' : null,
    subscribeTo: [
        'workspace',
        'currentPath',
        '_canvasSlot',
        '_canvasSlotSecond',
        'workspaceProject',
        '_projectCanvasOpen',
        'data',
        '_moduleChromePref',
        '_moduleComposerHidden',
        'assistantOpen',
        'assistantDock',
        'voiceOpen',
        'voiceHost'
    ],
    onMounted: (el, s)=>el.call('phoneNavigationSync', el, s),
    onUpdate: (el, s)=>el.call('phoneNavigationSync', el, s),
    onWindowResize: (e, el, s)=>el.call('phoneNavigationSync', el, s),
    // Back on a full-page app route (Nika 2026-10-31, POB S11c2 option B): an
    // installed app opened from Apps is a page, not a pane, and the phone folds
    // the header away — the dock was its only way out. The pane header's own
    // Back (canvas components/PageSlot.js _histBtn): the same button, glyph and
    // words. Hidden here; the phone rule in functions/phoneNavigation.js
    // (phoneNavigationStyles) shows it on an 'app' route with no pane open and
    // keeps its row clear of the page.
    PhoneBack: {
        extends: 'PageSlotHeaderBtn',
        dataPhoneBack: true,
        display: 'none',
        position: 'fixed',
        top: 'var(--slot-top)',
        left: 'calc(var(--spacing-Z) + env(safe-area-inset-left))',
        zIndex: '1100',
        ':active': {
            background: 'selected',
            color: 'title'
        },
        ariaLabel: (el)=>el.call('polyglot', 'canvas.pageSlot.back'),
        title: (el)=>el.call('polyglot', 'canvas.pageSlot.back'),
        Icon: {
            name: 'chevronLeft'
        },
        onClick: (e, el)=>{
            e.preventDefault();
            el.call('phoneNavigationBack');
        }
    },
    Dock: {
        hide: (el, s)=>!el.call('phoneNavigationAvailable', s.root),
        display: 'none',
        '@mobileL': {
            display: 'flex'
        },
        tag: 'nav',
        ariaLabel: (el)=>el.call('polyglot', 'shell.headerTabs.primaryNav'),
        dataPhoneDock: true,
        position: 'fixed',
        left: 'calc(var(--spacing-Z) + env(safe-area-inset-left))',
        right: 'calc(var(--spacing-Z) + env(safe-area-inset-right))',
        bottom: 'calc(var(--spacing-Z) + env(safe-area-inset-bottom))',
        maxWidth: 'overlayLg',
        margin: '0 auto',
        zIndex: '1100',
        flow: 'x',
        gap: 'X',
        padding: 'X',
        theme: 'common-box',
        shadow: 'float',
        round: 'radiusSheet',
        borderWidth: 'hairline',
        borderStyle: 'solid',
        borderColor: 'line',
        boxSizing: 'border-box',
        PhoneNavButton_home: {
            icon: 'home',
            label: 'shell.app.home',
            ariaCurrent: (el, s)=>el.call('stripWorkspacePrefix', s.root.currentPath || '/').split(/[?#]/)[0] === '/' ? 'page' : null,
            // A fresh Fly on the home in Fly mode, like the header's logo
            // (functions/assistantFlyWorkspace.js assistantFlyHomeFresh); the dock
            // navigates itself.
            onClick: (e, el)=>{
                el.call('assistantFlyHomeFresh', {
                    navigate: false
                });
                el.call('phoneNavigationOpen', '/');
            }
        },
        PhoneNavButton_apps: {
            icon: 'grid',
            // The dock's own short name: the header's `apps` reads "აპლიკაციები",
            // which takes two lines in a 320px dock.
            label: 'shell.phoneNav.apps',
            ariaHaspopup: 'dialog',
            ariaExpanded: (el, s)=>s.root._phoneNavPanel === 'apps' ? 'true' : 'false',
            onClick: (e, el)=>el.call('phoneNavigationPanel', 'apps')
        },
        PhoneNavButton_page: {
            icon: 'sidebarLeft',
            label: 'shell.phoneNav.page',
            hide: (el, s)=>!el.call('phoneNavigationPageRail', s.root),
            ariaLabel: (el)=>el.call('polyglot', 'shell.phoneNav.pageMenu'),
            ariaHaspopup: 'dialog',
            ariaExpanded: (el, s)=>s.root[el.call('phoneNavigationPageRail', s.root)] ? 'true' : 'false',
            onClick: (e, el)=>el.call('phoneNavigationBrowse')
        },
        PhoneNavButton_ai: {
            icon: 'chat',
            label: 'shell.phoneNav.assistant',
            ariaLabel: (el)=>el.call('polyglot', 'shell.phoneNav.assistantAction'),
            AppGlyphPlate: {
                background: 'highlight',
                color: 'title-reversed'
            },
            hide: (el, s)=>!el.call('featureEnabled', s.root, 'aiAssistant') || !el.call('featureEnabled', s.root, 'aiAssistant.composer'),
            ariaPressed: (el, s)=>s.root._phoneComposerOpen || s.root.assistantOpen && s.root.assistantDock !== 'minimized' ? 'true' : 'false',
            onClick: (e, el)=>el.call('phoneNavigationAssistant', el.parent.parent.canCompose)
        },
        PhoneNavButton_menu: {
            icon: 'burgerMenu',
            label: 'shell.phoneNav.menu',
            ariaHaspopup: 'dialog',
            ariaExpanded: (el, s)=>s.root._phoneNavPanel === 'menu' ? 'true' : 'false',
            // The phone hides the header bell (functions/phoneNavigation.js
            // phoneNavigationStyles). The menu holds the inbox, so this button
            // carries the unread signal: a dot for the eye, the count for a screen
            // reader. The realtime push writes `notifs` after the dock mounted:
            // each element that reads it subscribes to it, as the header bell and
            // the mail dot do.
            subscribeTo: [
                'notifs'
            ],
            ariaDescription: (el, s)=>{
                const n = el.call('phoneNavigationUnread', s.root);
                return n ? el.call('polyglot', 'shell.notifications.tab.unreadCount').replace('{count}', n) : null;
            },
            AppGlyphPlate: {
                // The unread dot: the shell's dot geometry (the navbar's and the mail
                // button's) on the brand's alert plate, the one the comm inbox tab's
                // count wears (comm/components.js CommNavTab), never a raw hue.
                UnreadBadge: {
                    tag: 'span',
                    subscribeTo: [
                        'notifs'
                    ],
                    hide: (el, s)=>!el.call('phoneNavigationUnread', s.root),
                    position: 'absolute',
                    top: '0',
                    right: '0',
                    width: 'Y',
                    height: 'Y',
                    round: 'radiusPill',
                    theme: 'alert',
                    pointerEvents: 'none'
                }
            },
            onClick: (e, el)=>el.call('phoneNavigationPanel', 'menu')
        }
    },
    AppDialog: {
        stateKey: '_phoneNavPanel',
        closeCall: 'phoneNavigationClose',
        position: 'fixed',
        zIndex: '2000',
        // The panel takes focus, never a field: a focused field raises the
        // phone keyboard over the tiles the member came to pick from.
        initialFocus: 'panel',
        panelSize: 'sm',
        Panel: {
            dataPhonePanel: (el, s)=>s.root._phoneNavPanel || null,
            '&[data-phone-panel="apps"]': {
                height: '88dvh',
                maxHeight: 'calc(100dvh - env(safe-area-inset-top) - var(--spacing-A))'
            },
            AppDialogHead: {
                titleId: 'phoneNavigationTitle',
                heading: (el, s)=>s.root._phoneNavPanel === 'apps' ? 'shell.phoneNav.appsTitle' : 'shell.phoneNav.menuTitle',
                subtitle: (el, s)=>s.root._phoneNavPanel === 'apps' ? 'shell.phoneNav.appsHint' : 'shell.phoneNav.menuHint'
            },
            // Search stays within reach while the directory scrolls. Opening the
            // sheet itself never focuses a field or raises the phone keyboard.
            PhoneSheetAction_search: {
                hide: (el, s)=>s.root._phoneNavPanel !== 'apps',
                icon: 'search',
                label: 'shell.headerSearch.placeholder',
                margin: '0 A A',
                flexShrink: '0',
                onClick: (e, el)=>el.call('phoneNavigationSearch')
            },
            AppDialogBody: {
                Apps: {
                    hide: (el, s)=>s.root._phoneNavPanel !== 'apps',
                    flow: 'y',
                    gap: 'A',
                    minWidth: '0',
                    Sections: {
                        flow: 'y',
                        gap: 'B',
                        minWidth: '0',
                        childExtends: 'PhoneAppSection',
                        childrenAs: 'state',
                        children: (el, s)=>s.root._phoneNavPanel === 'apps' ? el.call('phoneNavigationAppGroups', s.root) : []
                    }
                },
                Menu: {
                    tag: 'div',
                    hide: (el, s)=>s.root._phoneNavPanel !== 'menu',
                    flow: 'y',
                    gap: 'X',
                    minWidth: '0',
                    AppOrgSwitcher: {
                        hide: (el, s)=>!!s.root.isDemo,
                        marginBottom: 'Z'
                    },
                    PhoneSheetAction_search: {
                        icon: 'search',
                        label: 'shell.headerSearch.placeholder',
                        onClick: (e, el)=>el.call('phoneNavigationSearch')
                    },
                    // The header bell's place on a phone (persona round 4, marcus at
                    // 390 px, dev 2026-10-28: a new notification left no trace). The
                    // row opens the inbox where the bell's "View all" opens it: the
                    // shell's window (`preferSlot`); a host without one (comm) opens
                    // it as the page.
                    PhoneSheetAction_inbox: {
                        icon: 'bell',
                        label: 'shell.app.inbox',
                        // The row's meta count (AppSidebarRow), the bell's own number.
                        Meta: {
                            subscribeTo: [
                                'notifs'
                            ],
                            text: (el, s)=>{
                                const n = el.call('phoneNavigationUnread', s.root);
                                return n > 99 ? '99+' : String(n);
                            },
                            hide: (el, s)=>!el.call('phoneNavigationUnread', s.root)
                        },
                        onClick: (e, el)=>{
                            el.call('phoneNavigationClose');
                            el.call('openAppPage', '/inbox', {
                                preferSlot: true
                            });
                        }
                    },
                    PhoneSheetAction_account: {
                        icon: 'user',
                        label: 'shell.phoneNav.account',
                        onClick: (e, el)=>{
                            const trigger = el.lookup('PhoneNavigation')?.Dock?.PhoneNavButton_menu || el;
                            el.call('phoneNavigationClose');
                            el.call('openAccountMenu', trigger);
                        }
                    },
                    FlyTools: {
                        subscribeTo: [
                            'assistantMode',
                            '_aiFly'
                        ],
                        hide: (el, s)=>s.root.assistantMode !== 'fly' || !s.root._aiFly || !s.root._aiFly.open,
                        flow: 'y',
                        gap: 'X',
                        // Fly's canvas actions as rows of this menu (the menu closes
                        // first). Add section lives in the composer's "+" menu, on a phone
                        // as everywhere (Nika 2026-10-23); the apps are this menu's own
                        // rows.
                        PhoneSheetAction_new: {
                            icon: 'plus',
                            label: 'workspace.assistantFly.new',
                            onClick: (e, el)=>{
                                el.call('phoneNavigationClose');
                                el.call('assistantFlyWorkspaceNew');
                            }
                        },
                        PhoneSheetAction_close: {
                            icon: 'x',
                            label: 'workspace.assistantFly.close',
                            onClick: (e, el)=>{
                                el.call('phoneNavigationClose');
                                el.call('assistantFlyWorkspaceDismiss');
                            }
                        }
                    }
                },
                Error: {
                    role: 'alert',
                    color: 'caption',
                    fontSize: 'Z',
                    text: (el, s)=>s.root._phoneNavError ? el.call('polyglot', 'shell.flyWorkspace.error.navigation') : ''
                }
            }
        }
    }
};
const $b4edb1f18d52aa8a$export$cd960919ba4b5eb6 = {
    extends: 'AppCapsuleBtnGhost',
    flex: '1 1 0%',
    minWidth: '0',
    '&[data-control-size="regular"]': {
        minHeight: 'thumbnailXs'
    },
    touchAction: 'manipulation',
    flow: 'y',
    justifyContent: 'flex-start',
    gap: 'X',
    // Keep the full track for the name, including on a narrow five-action dock.
    padding: 'X 0',
    fontSize: 'A',
    round: 'radiusControl',
    color: 'caption',
    '&[aria-current="page"],&[aria-expanded="true"],&[aria-pressed="true"]': {
        background: 'selected',
        color: 'title'
    },
    Icon: null,
    AppGlyphPlate: {
        boxSize: 'avatarSm',
        minWidth: 'avatarSm',
        borderWidth: '0',
        color: 'inherit',
        round: 'radiusPill',
        ariaHidden: true,
        Icon: {
            name: (el)=>el.parent.parent.icon,
            boxSize: 'iconMd'
        },
        Dot: null
    },
    // Names can grow with the member's text preference. The glyphs stay on
    // one baseline while the dock's measured clearance follows a wrapped name.
    Label: {
        tag: 'span',
        text: (el)=>el.call('polyglot', el.parent.label),
        fontSize: 'Y',
        lineHeight: '1.1',
        maxWidth: '100%',
        overflow: 'visible',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere'
    }
};
const $b4edb1f18d52aa8a$export$f6c3bd1d05f683c4 = {
    extends: 'AppSidebarRow',
    minHeight: 'thumbnailXs',
    '@mobileL': {
        minHeight: 'thumbnailXs'
    },
    '@coarse': {
        minHeight: 'thumbnailXs'
    },
    padding: 'Z A',
    gap: 'A',
    background: 'widgetPlate',
    color: 'title',
    Icon: {
        boxSize: 'iconMd'
    },
    Label: {
        whiteSpace: 'normal',
        overflow: 'visible',
        lineHeight: '1.4'
    },
    Icon_next: {
        name: 'chevronRight',
        boxSize: 'iconSm',
        flexShrink: '0',
        color: 'caption',
        ariaHidden: true
    }
};
const $b4edb1f18d52aa8a$export$7ba4c7c8f3fb7e92 = {
    extends: 'SearchAppsSection',
    SasGrid: {
        childExtends: 'PhoneAppTile',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 'Y',
        justifyItems: 'stretch',
        '@mobileXS': {
            gridTemplateColumns: 'minmax(0, 1fr)',
            '& [data-launcher-tile]': {
                gridColumn: '1 / -1'
            }
        }
    }
};
const $b4edb1f18d52aa8a$export$810a92740ae846ca = {
    extends: 'SearchAppTile',
    // A dialog row, not a menu item: the sheet is no menu.
    role: null,
    // A row has less label room than the desktop springboard. Long names and
    // long single words take the full line instead of splitting into fragments.
    dataSpan: (el, s)=>{
        const name = String(el.call('storeItemText', {
            key: s.appKey,
            name: s.title
        }, 'name') || '');
        return [
            ...name
        ].length > 28 || name.split(/\s+/).some((word)=>[
                ...word
            ].length > 12) ? 'row' : null;
    },
    // No desktop drag/context-menu hints on a touch directory. A long press
    // stays native scrolling/selection, and a tap uses the guarded opener.
    draggable: false,
    title: null,
    'aria-keyshortcuts': null,
    'aria-label': (el, s)=>el.call('storeItemText', {
            key: s.appKey,
            name: s.title
        }, 'name'),
    onDragstart: null,
    onDragend: null,
    onContextmenu: null,
    onKeydown: null,
    flow: 'x',
    justifyContent: 'flex-start',
    width: '100%',
    minHeight: 'thumbnailSm',
    '&[data-control-size="regular"]': {
        minHeight: 'thumbnailSm'
    },
    padding: 'Z',
    gap: 'Z',
    background: 'widgetPlate',
    round: 'radiusControl',
    IconTile: {
        boxSize: 'avatarSm',
        minWidth: 'avatarSm',
        borderWidth: '0',
        Icon: {
            boxSize: 'iconMd'
        }
    },
    Label: {
        flex: '1',
        textAlign: 'left',
        fontSize: 'Z',
        lineHeight: '1.35'
    },
    // One open at a time: the tiles rest while the guarded opener runs.
    disabled: (el, s)=>!!s.root?._phoneNavOperation,
    onClick: (e, el, s)=>{
        if (s.route) el.call('phoneNavigationOpen', s.route);
    }
};

});

parcelRegister("lxNZr", function(module, exports) {

$parcel$export(module.exports, "AssistantThreadBlock", () => $faf37504de05f516$export$b2bb4558df423b12);
// AN INLINE GENERATIVE BLOCK of the assistant's thread (AI_ASSISTANT_SPEC v1
// §3; DESIGN-WL-ASSISTANT-MAIN-VIEW-1). The shared chat card dispatcher
// (shared/_simone/ChatCard.js) renders a card of type 'view' | 'records' |
// 'board' | 'widget' | 'form' | 'sources' through this component, in the sidebar AND in the main thread (there
// as a full-board-width row — components/AssistantMainThread.js).
//
// Anatomy: a head (the app's calm glyph for a records or widget block, the
// title, the actions that mean something for it: Open in split · Save as app ·
// Save as board · Refine), a body — the answer view mounted inline (bounded,
// scrolls inside), the records block, an installed app's widget (embed_widget:
// its own body with the card's params), or a board's summary — and a foot:
// where the block comes from, in the house micro-label (the home widget's
// footer). The card's surface comes from the dispatcher (the chat's posture);
// every value from functions/assistantThreadBlocks.js through `el.call`.
const $faf37504de05f516$export$b2bb4558df423b12 = {
    extends: 'CommonCard',
    tag: 'section',
    role: 'group',
    ariaLabel: (el, s)=>el.call('assistantBlockTitle', s),
    dataBlockType: (el, s)=>s && s.type || null,
    // A widget card waits for the installed apps before it can mount its body.
    ariaBusy: (el, s)=>el.call('assistantEmbedWidgetStatus', s) === 'loading' ? 'true' : null,
    flow: 'y',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    boxSizing: 'border-box',
    BlockHead: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        // The app's calm glyph (the home App strip's tile): a records or widget
        // block only — a view or a board has no app of its own. `if`, not `hide`:
        // a hidden tile still builds its Icon, and an Icon whose name is empty is
        // read by its KEY — "[Icon] Unknown icon name 'Icon'" under every view and
        // board answer (dev DFI 2026-10-05, the chains lane). No glyph → no tile.
        // The name never goes empty: a tile that showed and then lost its app
        // (if → false keeps the element live) re-reads AppGlyphTile's own default.
        AppGlyphTile: {
            'aria-hidden': 'true',
            if: (el, s)=>!!el.call('assistantBlockIcon', s),
            Icon: {
                name: (el, s)=>el.call('assistantBlockIcon', s) || 'star'
            }
        },
        BlockTitles: {
            flow: 'y',
            gap: 'X',
            minWidth: '0',
            flex: '1 1 auto',
            BlockTitle: {
                tag: 'h3',
                margin: '0',
                fontSize: 'A',
                fontWeight: '500',
                lineHeight: '1.3',
                color: 'title',
                overflowWrap: 'anywhere',
                text: (el, s)=>el.call('assistantBlockTitle', s)
            }
        },
        BlockActions: {
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center',
            gap: 'Y',
            childProps: {
                compact: true
            },
            AppCapsuleBtnToolbar_open: {
                dataBlockOpen: true,
                hide: (el, s)=>!el.call('assistantBlockCan', s, 'open'),
                text: '{{ workspace.assistantBlock.openInSplit | polyglot }}',
                onClick: (e, el, s)=>el.call('assistantBlockOpen', s)
            },
            // Save as app — an answer view becomes an app; a BUILT app (Apps mode)
            // is installed, and reads "Added to workspace" once it is.
            AppCapsuleBtnToolbar_app: {
                dataBlockSaveApp: true,
                hide: (el, s)=>!el.call('assistantBlockCan', s, 'saveApp'),
                subscribeTo: [
                    'workspace'
                ],
                disabled: (el, s)=>el.call('assistantBlockSaveAppState', s) !== 'save' ? true : null,
                text: (el, s)=>{
                    const state = el.call('assistantBlockSaveAppState', s);
                    return el.call('polyglot', state === 'added' ? 'workspace.addApp.install.added' : state === 'checking' ? 'workspace.addApp.install.checking' : 'workspace.assistantBlock.saveAsApp');
                },
                onClick: (e, el, s)=>el.call('assistantBlockSaveApp', s)
            },
            AppCapsuleBtnToolbar_board: {
                dataBlockSaveBoard: true,
                hide: (el, s)=>!el.call('assistantBlockCan', s, 'saveBoard'),
                disabled: (el, s)=>el.call('assistantBlockSaveLabel', s && s.root, s) ? true : null,
                onClick: (e, el, s)=>el.call('assistantBlockSaveBoard', el, s),
                AppLabelStack: {
                    labels: [
                        'workspace.assistantBoard.saveAsBoard',
                        'workspace.assistantBoard.saving',
                        'workspace.assistantBoard.saved'
                    ],
                    shown: (el, s)=>el.call('assistantBlockSaveLabel', s && s.root, s)
                }
            },
            AppCapsuleBtnToolbar_refine: {
                dataBlockRefine: true,
                hide: (el, s)=>!el.call('assistantBlockCan', s, 'refine'),
                text: '{{ workspace.assistantBlock.refine | polyglot }}',
                onClick: (e, el, s)=>el.call('assistantBlockRefine', s)
            }
        }
    },
    // An answer view, inline: bounded, it scrolls inside — the thread never
    // grows a page tall. Mounted once per route (assistantBlockMountView).
    BlockView: {
        dataBlockView: true,
        hide: (el, s)=>!s || s.type !== 'view' || el.call('assistantBlockViewGone', s),
        maxHeight: 'H',
        overflow: 'auto',
        minWidth: '0',
        round: 'radiusControl',
        onRender: (el, s)=>el.call('assistantBlockMountView', el, s),
        onUpdate: (el, s)=>el.call('assistantBlockMountView', el, s)
    },
    BlockViewGone: {
        tag: 'p',
        hide: (el, s)=>!el.call('assistantBlockViewGone', s),
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        text: '{{ workspace.assistantBlock.viewGone | polyglot }}'
    },
    AssistantRecordsBlock: {
        hide: (el, s)=>!s || s.type !== 'records'
    },
    // "What can you do here?" — the capabilities catalogue (functions/
    // aiCapabilities.js): Ask · Do · Build · Inspect, each row tappable.
    AssistantCapabilities: {
        hide: (el, s)=>!s || s.type !== 'capabilities'
    },
    // An installed app's WIDGET (embed_widget): the app's own body mounted
    // inline with the card's params — the mount the home and the generated board
    // use (assistantEmbedWidgetMount → assistantBoardMountBody). The installed
    // apps publish after a cold load; the card re-mounts when they land
    // (`subscribeTo`). While they load: a skeleton; a widget not installed here:
    // one sentence.
    BlockWidget: {
        dataBlockWidget: true,
        hide: (el, s)=>el.call('assistantEmbedWidgetStatus', s) !== 'ready',
        display: 'flex',
        flexDirection: 'column',
        minWidth: '0',
        minHeight: '0',
        subscribeTo: [
            'workspaceApps',
            'workspaceProject'
        ],
        onRender: (el, s)=>el.call('assistantEmbedWidgetMount', el, s),
        onUpdate: (el, s)=>el.call('assistantEmbedWidgetMount', el, s)
    },
    BlockWidgetSkeleton: {
        hide: (el, s)=>el.call('assistantEmbedWidgetStatus', s) !== 'loading',
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        Skeleton_1: {
            width: '40%',
            height: 'B'
        },
        Skeleton_2: {
            minHeight: 'C',
            round: 'radiusControl'
        }
    },
    // Its app did not load here, or it is not installed here — one sentence.
    BlockWidgetNote: {
        tag: 'p',
        dataBlockWidgetNote: true,
        hide: (el, s)=>!el.call('assistantEmbedWidgetNote', s),
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        overflowWrap: 'anywhere',
        text: (el, s)=>el.call('assistantEmbedWidgetNote', s)
    },
    // An app's own FORM, prefilled from the assistant's proposal (U3,
    // functions/assistantAppForms.js): the proposal as labelled fields, ONE
    // action that opens the app's form (nothing is written until the member
    // saves there), and — once the app reports it — the saved row, which opens
    // the record. Re-reads when the request moves (`_aiForms`) or the apps
    // publish.
    BlockForm: {
        dataBlockForm: true,
        hide: (el, s)=>el.call('assistantFormStatus', s) !== 'ready',
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        subscribeTo: [
            '_aiForms',
            'workspaceApps',
            'workspaceProject'
        ],
        BlockFormFields: {
            tag: 'dl',
            margin: '0',
            flow: 'y',
            gap: 'Y',
            minWidth: '0',
            childExtends: 'AssistantFormField',
            childrenAs: 'state',
            children: (el, s)=>el.call('assistantFormFields', s) || []
        },
        BlockFormSaved: {
            flow: 'y',
            gap: 'Y',
            minWidth: '0',
            hide: (el, s)=>!(el.call('assistantFormSavedRows', s) || []).length,
            childExtends: 'HomeWidgetRow',
            childrenAs: 'state',
            children: (el, s)=>el.call('assistantFormSavedRows', s) || []
        },
        BlockFormFoot: {
            flow: 'x',
            flexWrap: 'wrap',
            align: 'center flex-start',
            gap: 'Z',
            minWidth: '0',
            AppCapsuleBtnPrimary: {
                dataBlockFormOpen: true,
                compact: true,
                hide: (el, s)=>!el.call('assistantFormAction', s),
                text: (el, s)=>el.call('assistantFormAction', s),
                onClick: (e, el, s)=>el.call('assistantFormOpen', s)
            },
            BlockFormStatus: {
                tag: 'p',
                dataBlockFormStatus: true,
                margin: '0',
                fontSize: 'Z',
                color: 'caption',
                overflowWrap: 'anywhere',
                ariaLive: 'polite',
                text: (el, s)=>el.call('assistantFormStatusText', s)
            }
        }
    },
    // WEB SOURCES (U4, functions/assistantSources.js): search results as source
    // cards — each a real link to its page, in a new tab — and a fetched page as
    // a quote with its source.
    BlockSources: {
        dataBlockSources: true,
        hide: (el, s)=>!s || s.type !== 'sources',
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        BlockQuote: {
            tag: 'figure',
            margin: '0',
            flow: 'y',
            gap: 'Y',
            minWidth: '0',
            hide: (el, s)=>!el.call('assistantSourcesQuote', s),
            Quote: {
                tag: 'blockquote',
                margin: '0',
                padding: 'Z A',
                round: 'radiusControl',
                theme: 'layer',
                fontSize: 'Z1',
                lineHeight: '1.5',
                color: 'title',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'anywhere',
                text: (el, s)=>(el.call('assistantSourcesQuote', s) || {}).text || ''
            },
            Cite: {
                tag: 'figcaption',
                fontSize: 'Z',
                color: 'caption',
                Link: {
                    dataSourceQuote: true,
                    href: (el, s)=>(el.call('assistantSourcesQuote', s) || {}).url || null,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    color: 'caption',
                    overflowWrap: 'anywhere',
                    text: (el, s)=>{
                        const q = el.call('assistantSourcesQuote', s) || {};
                        return q.title && q.title !== q.domain ? q.title + " \xb7 " + q.domain : q.domain || '';
                    }
                }
            }
        },
        BlockSourceCards: {
            flow: 'y',
            gap: 'Y',
            minWidth: '0',
            childExtends: 'AssistantSourceCard',
            childrenAs: 'state',
            children: (el, s)=>el.call('assistantSourcesRows', s) || []
        }
    },
    // A form this member may not use, or one not here: one sentence.
    BlockFormNote: {
        tag: 'p',
        dataBlockFormNote: true,
        hide: (el, s)=>!el.call('assistantFormNote', s),
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        overflowWrap: 'anywhere',
        text: (el, s)=>el.call('assistantFormNote', s)
    },
    BlockBoardSummary: {
        tag: 'p',
        hide: (el, s)=>!s || s.type !== 'board' || !s.summary,
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.summary || ''
    },
    // The foot: where the block comes from ("From CRM · Deals"), the home
    // widget's footer voice — out of the head, so the head reads glyph + title.
    AppMicroLabel: {
        dataBlockSource: true,
        whiteSpace: 'normal',
        text: (el, s)=>el.call('assistantBlockSource', s)
    }
};

});

parcelRegister("8Pafq", function(module, exports) {

$parcel$export(module.exports, "AssistantFormField", () => $66cb091fff50c3d2$export$6656203b6f060b2d);
// One field of an AI answer's FORM proposal (components/AssistantThreadBlock.js
// BlockForm; functions/assistantAppForms.js assistantFormFields): the field's
// label in the house micro-label over the proposed value. Read-only — the
// member edits and saves in the app's own form.
const $66cb091fff50c3d2$export$6656203b6f060b2d = {
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    AppMicroLabel: {
        tag: 'dt',
        text: (el, s)=>s && s.label || ''
    },
    FieldValue: {
        tag: 'dd',
        margin: '0',
        fontSize: 'Z1',
        color: 'title',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.value || ''
    }
};

});

parcelRegister("gCjMr", function(module, exports) {

$parcel$export(module.exports, "AssistantSourceCard", () => $c18f89e93a46c914$export$adf9311fd7dd8864);
// ONE WEB SOURCE in an AI answer (U4; functions/assistantSources.js): a real
// link to its page, opened in a new tab — the title (wraps, never cut), the
// domain in the house micro-label, the snippet. The home kit's quiet row
// wash under the pointer; the global focus ring.
const $c18f89e93a46c914$export$adf9311fd7dd8864 = {
    extends: 'Link',
    dataSourceCard: true,
    href: (el, s)=>s && s.url || null,
    target: '_blank',
    rel: 'noopener noreferrer',
    flow: 'y',
    gap: 'Y',
    padding: 'A',
    minWidth: '0',
    maxWidth: '100%',
    boxSizing: 'border-box',
    round: 'radiusCard',
    theme: 'layer',
    color: 'title',
    textDecoration: 'none',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    SourceMeta: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        color: 'caption',
        AppMicroLabel: {
            color: 'caption',
            minWidth: '0',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.domain || ''
        },
        Icon: {
            name: 'arrowUpRight',
            ariaHidden: true,
            boxSize: 'Z',
            flexShrink: '0'
        }
    },
    SourceTitle: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '500',
        lineHeight: '1.45',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.title || ''
    },
    SourceSnippet: {
        tag: 'span',
        fontSize: 'Z1',
        fontWeight: '400',
        lineHeight: '1.5',
        color: 'caption',
        overflowWrap: 'anywhere',
        hide: (el, s)=>!(s && s.snippet),
        text: (el, s)=>s && s.snippet || ''
    }
};

});

parcelRegister("ewwLp", function(module, exports) {

$parcel$export(module.exports, "AssistantRecordsBlock", () => $a92d7808c40adb9c$export$95e1019e4ff5fa50);
$parcel$export(module.exports, "AssistantRecordsHero", () => $a92d7808c40adb9c$export$66d3d237bf691195);
$parcel$export(module.exports, "AssistantRecordsRow", () => $a92d7808c40adb9c$export$e2d6c7aa68d76dfd);
$parcel$export(module.exports, "AssistantRecordsHeadCell", () => $a92d7808c40adb9c$export$923df486bf246342);
$parcel$export(module.exports, "AssistantRecordsTableRow", () => $a92d7808c40adb9c$export$b243c6136ca67ff6);
$parcel$export(module.exports, "AssistantRecordsCell", () => $a92d7808c40adb9c$export$36b86915e7bc7dc5);
$parcel$export(module.exports, "AssistantRecordsDrillTarget", () => $a92d7808c40adb9c$export$8d428d0bdf3a576c);
$parcel$export(module.exports, "AssistantRecordsBar", () => $a92d7808c40adb9c$export$4e13a74e079a73ff);
$parcel$export(module.exports, "AssistantRecordsChip", () => $a92d7808c40adb9c$export$50fdadcf95c43d19);
$parcel$export(module.exports, "AssistantRecordsSlice", () => $a92d7808c40adb9c$export$4941d7968d6b8c3e);
$parcel$export(module.exports, "AssistantRecordsLine", () => $a92d7808c40adb9c$export$b6edb47e245008a6);
// THE RECORDS BLOCK — one renderer for a RECORDS BLOCK v1 wherever it lands:
// a generated board's card (AssistantBoardView, kind 'records') and an inline
// thread block (AssistantThreadBlock, `{ type: 'records', block }`).
// AI_ASSISTANT_SPEC v1 §2–§3; DESIGN-WL-ASSISTANT-MAIN-VIEW-1.
//
// The block is declarative; its rows come from `ai.boards.records` under the
// member's grants (functions/assistantRecords.js). Four views — a STAT (one
// number, the period and the count under it), a LIST (title + two facts per
// row), a TABLE (up to five columns), a CHART (one bar per group) — and the
// honest states: a skeleton while loading, one sentence when nothing matches,
// when the service is not there yet, when the read is refused, and when it
// fails (with Try again). A row opens its record through openInSlot. Tokens
// only; the component reads its block from its state (`records` on a board
// row, `block` on a thread card) and holds no logic of its own.
const $a92d7808c40adb9c$export$95e1019e4ff5fa50 = {
    // The view it renders as: the server's own when the answer names one (a
    // list grouped by a field comes back as a chart), else the block's.
    dataRecordsView: (el, s)=>{
        const b = el.call('recordsBlockOf', s);
        if (!b) return null;
        return el.call('assistantRecordsViewOf', b, el.call('assistantRecordsEntry', s && s.root, b));
    },
    dataRecordsStatus: (el, s)=>{
        const e = el.call('assistantRecordsEntry', s && s.root, el.call('recordsBlockOf', s));
        return e && e.status || 'idle';
    },
    ariaBusy: (el, s)=>{
        const e = el.call('assistantRecordsEntry', s && s.root, el.call('recordsBlockOf', s));
        return !e || e.status === 'loading' ? 'true' : null;
    },
    flow: 'y',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    // Read once the node exists; again when the block or the workspace changes
    // (the cache is per workspace + block, so a repeat costs nothing).
    onRender: (el, s)=>el.call('assistantRecordsEnsure', el, s),
    onUpdate: (el, s)=>el.call('assistantRecordsEnsure', el, s),
    // Loading: the stat's hero bar and three row bars, in the view's place.
    RecordsSkeleton: {
        hide: (el, s)=>{
            const e = el.call('assistantRecordsEntry', s && s.root, el.call('recordsBlockOf', s));
            return !!e && e.status !== 'loading';
        },
        flow: 'y',
        gap: 'Y',
        Skeleton_1: {
            width: '40%',
            height: 'B'
        },
        Skeleton_2: {
            width: '100%',
            height: 'A'
        },
        Skeleton_3: {
            width: '80%',
            height: 'A'
        }
    },
    // THE VIEW. Only the one the answer draws EXISTS (`if:`, never a hidden
    // twin): a card carries its stat OR its list OR its table OR its chart —
    // a board of twelve cards does not build forty-eight views to show twelve.
    // The holder itself stays mounted, so the view keeps its place above the
    // lines under it whenever the answer lands.
    RecordsView: {
        hide: (el, s)=>!el.call('assistantRecordsShows', s),
        minWidth: '0',
        childrenAs: 'state',
        children: (el, s)=>{
            if (!el.call('assistantRecordsShows', s)) return [];
            // Derive once in this reactive effect. All nested data and language
            // reads stay tracked; no identity cache can retain a stale answer.
            const model = el.call('assistantRecordsViewFor', s);
            // A bar or a chip opens its records only where a drill lands (a ready
            // board, the person's own done Fly page — functions/assistantRecords.js
            // assistantRecordsDrillFrom); anywhere else it only reads.
            const drill = model.bars || model.chips ? el.call('assistantRecordsDrillFrom', s) : null;
            if (drill && model.bars) model.bars = model.bars.map((bar)=>({
                    ...bar,
                    ...drill
                }));
            if (drill && model.chips) model.chips = model.chips.map((chip)=>({
                    ...chip,
                    ...drill
                }));
            return [
                {
                    key: 'records-content',
                    records: el.call('recordsBlockOf', s),
                    hue: s && s.hue,
                    recordsViewModel: model,
                    recordsGeometry: model.line ? el.call('homeSparkGeom', model.line.points, 240, 64, 4) : null
                }
            ];
        },
        // One stable child owns the current render model. Its children share
        // this state without adding a public component to the registry.
        childProps: {
            tag: 'div',
            flow: 'y',
            gap: 'Z',
            minWidth: '0',
            // STAT — the home widget's own parts, so an answer's number reads like
            // its home twin (render step 2): the HERO numeral with its unit word (the
            // money code leads: "GEL" · "64.6K"), a split per currency when the set
            // mixes currencies, the TREND chip against the span before
            // (aggregate.previous; absent without one — never a fake 0%), the SPARK of
            // the period (series, two points or more), then the period and the count.
            // The accent (the chip's dot, the spark) is the board card's app hue, else
            // the text ink. BOTH halves of that rule now live in the card's own
            // `--home-widget-accent` (functions/homeWidgetFrame.js): a hue that reads
            // on the card surface resolves to the hue, and a hue-less card — or a hue
            // with no readable accent in its family — resolves to the title ink. So
            // this slot reads ONE variable instead of re-deciding, and the var's CSS
            // fallback carries the one host that publishes no card vars at all: the
            // thread (AssistantThreadBlock), where the block renders outside a widget
            // card. It must never read `--home-widget-hue` again — that is the PLATE,
            // a surface, and on a dark plate family it drew the bars all but invisible
            // (dev 2026-10-04: WIDGET-TOOLS-RECORDS-SHAPE-1 for the hue-less case,
            // HOME-WIDGET-ACCENT-DARK-PLATE-INVISIBLE-1 for the hued one).
            RecordsStat: {
                if: (el, s)=>s.recordsViewModel && s.recordsViewModel.view === 'stat',
                flow: 'y',
                gap: 'Y',
                minWidth: '0',
                color: 'var(--home-widget-accent, var(--color-title))',
                AssistantRecordsHero: {
                    Value: {
                        dataRecordsValue: true
                    }
                },
                StatCurrencies: {
                    flow: 'x',
                    flexWrap: 'wrap',
                    gap: 'Z',
                    childrenAs: 'state',
                    children: (el, s)=>s.recordsViewModel.currencies || [],
                    childExtends: 'AppMicroLabel',
                    childProps: {
                        text: (el, s)=>s && s.text || ''
                    }
                },
                HomeWidgetDelta: {
                    if: (el, s)=>!!(s.recordsViewModel && s.recordsViewModel.delta),
                    Dot: {
                        background: (el)=>el.parent.bad ? 'dangerInk' : 'currentColor'
                    },
                    Text: {
                        text: (el, s)=>s.recordsViewModel.delta || ''
                    }
                },
                HomeWidgetSpark: {
                    if: (el, s)=>!!(s.recordsViewModel && s.recordsViewModel.spark),
                    // shown at every card size — the home hides it only in an S cell
                    display: 'block',
                    points: (el, s)=>s.recordsViewModel.spark
                },
                StatSub: {
                    tag: 'span',
                    fontSize: 'Z',
                    color: 'caption',
                    text: (el, s)=>el.call('assistantRecordsSub', s)
                }
            },
            // LIST: one row per record — its title, then up to two facts.
            RecordsList: {
                if: (el, s)=>s.recordsViewModel && s.recordsViewModel.view === 'list',
                tag: 'ul',
                margin: '0',
                padding: '0',
                listStyle: 'none',
                flow: 'y',
                gap: 'Y',
                childrenAs: 'state',
                children: (el, s)=>s.recordsViewModel.rows || [],
                childExtends: 'AssistantRecordsRow'
            },
            // TABLE: up to five columns; the row opens its record.
            RecordsTable: {
                if: (el, s)=>s.recordsViewModel && s.recordsViewModel.view === 'table',
                overflowX: 'auto',
                minWidth: '0',
                RecordsTableEl: {
                    tag: 'table',
                    width: '100%',
                    minWidth: (el, s)=>s.recordsViewModel?.columns?.length > 2 ? 'H' : '100%',
                    borderCollapse: 'collapse',
                    fontSize: 'Z',
                    RecordsHead: {
                        tag: 'thead',
                        RecordsHeadRow: {
                            tag: 'tr',
                            childrenAs: 'state',
                            children: (el, s)=>s.recordsViewModel.columns || [],
                            childExtends: 'AssistantRecordsHeadCell'
                        }
                    },
                    RecordsBody: {
                        tag: 'tbody',
                        childrenAs: 'state',
                        children: (el, s)=>s.recordsViewModel.rows || [],
                        childExtends: 'AssistantRecordsTableRow'
                    }
                }
            },
            // How many of all that match the list or table holds ("20 of 46 shown").
            RecordsMore: {
                tag: 'p',
                dataRecordsMore: true,
                if: (el, s)=>!!(s.recordsViewModel && s.recordsViewModel.more),
                margin: '0',
                fontSize: 'Z',
                color: 'caption',
                text: (el, s)=>s.recordsViewModel && s.recordsViewModel.more || ''
            },
            // CHART — drawn by the data's shape (render step 2): groups over TIME are
            // a line with its newest value at the accent dot (AssistantRecordsLine);
            // categories are bars, largest first, each with its value, at most eight
            // (the rest folds into "Others" when the numbers add up). The accent is
            // the board card's app hue, else the text ink (as RecordsStat).
            RecordsChart: {
                if: (el, s)=>s.recordsViewModel && s.recordsViewModel.view === 'chart',
                flow: 'y',
                gap: 'Y',
                minWidth: '0',
                color: 'var(--home-widget-accent, var(--color-title))',
                RecordsBars: {
                    if: (el, s)=>s.recordsViewModel && s.recordsViewModel.chart === 'bars',
                    dataRecordsBars: true,
                    flow: 'y',
                    gap: 'Y',
                    minWidth: '0',
                    childrenAs: 'state',
                    // Where a drill lands (a board card, a done Fly section) a bar opens
                    // its records (D2 drill-down): the card's key rides the bar as
                    // `from`, a Fly section's page as `page`. A thread card has nowhere
                    // to take the drill card, so its bars stay plain.
                    children: (el, s)=>s.recordsViewModel.bars || [],
                    childExtends: 'AssistantRecordsBar'
                },
                // D5 THE DONUT — parts of a whole: the ring (a track + one slice per
                // group, the card hue at one opacity step per slice), the total in the
                // hole, and beside it the legend: the bar rows with a dot for the
                // track and the share after the value (drillable like a bar).
                RecordsDonut: {
                    if: (el, s)=>s.recordsViewModel && s.recordsViewModel.chart === 'donut',
                    dataRecordsDonut: true,
                    flow: 'x',
                    flexWrap: 'wrap',
                    align: 'center',
                    gap: 'A',
                    minWidth: '0',
                    DonutPlot: {
                        position: 'relative',
                        boxSize: 'E',
                        flexShrink: '0',
                        Ring: {
                            // frank-allow FA601 — data plot (non-icon viewBox), not an icon
                            tag: 'svg',
                            viewBox: '0 0 42 42',
                            ariaHidden: 'true',
                            width: '100%',
                            height: '100%',
                            display: 'block',
                            DonutTrack: {
                                tag: 'circle',
                                attr: {
                                    cx: '21',
                                    cy: '21',
                                    r: '15.9155',
                                    fill: 'none',
                                    stroke: 'currentColor',
                                    'stroke-opacity': '0.08',
                                    'stroke-width': '6'
                                }
                            },
                            DonutSlices: {
                                tag: 'g',
                                childrenAs: 'state',
                                children: (el, s)=>{
                                    const d = s.recordsViewModel.donut;
                                    return d && d.slices || [];
                                },
                                childExtends: 'AssistantRecordsSlice'
                            }
                        },
                        DonutTotal: {
                            dataDonutTotal: true,
                            position: 'absolute',
                            inset: '0',
                            flow: 'x',
                            align: 'center center',
                            fontSize: 'A',
                            fontWeight: '500',
                            color: 'title',
                            fontVariantNumeric: 'tabular-nums',
                            text: (el, s)=>{
                                const d = s.recordsViewModel.donut;
                                return d && d.total || '';
                            }
                        }
                    },
                    DonutLegend: {
                        dataRecordsBars: true,
                        flex: '1',
                        flow: 'y',
                        gap: 'X',
                        minWidth: 'D',
                        maxWidth: '100%',
                        childrenAs: 'state',
                        children: (el, s)=>s.recordsViewModel.bars || [],
                        childExtends: 'AssistantRecordsBar'
                    }
                },
                AssistantRecordsLine: {
                    if: (el, s)=>s.recordsViewModel && s.recordsViewModel.chart === 'line'
                },
                // CHIPS — the display hint 'chips' (board binding A′) on categories:
                // one wrapped row of pills, each its group's label and its count, in
                // the bars' order and fold. Where a drill lands a chip opens its
                // records like a bar (D2 drill-down).
                RecordsChips: {
                    if: (el, s)=>s.recordsViewModel && s.recordsViewModel.chart === 'chips',
                    dataRecordsChips: true,
                    flow: 'x',
                    flexWrap: 'wrap',
                    gap: 'X',
                    minWidth: '0',
                    childrenAs: 'state',
                    children: (el, s)=>s.recordsViewModel.chips || [],
                    childExtends: 'AssistantRecordsChip'
                }
            }
        }
    },
    // A DRILL card (D2) names the filter it came from, in the WHY line's
    // voice: "Stage: Proposal · from Deals by stage".
    RecordsDrill: {
        tag: 'p',
        dataRecordsDrill: true,
        if: (el, s)=>!!el.call('assistantRecordsDrillWords', s),
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        overflowWrap: 'anywhere',
        text: (el, s)=>el.call('assistantRecordsDrillWords', s)
    },
    // How the answer was read, when the reader must know it — one quiet line
    // under the rows: a value the server read as the real one ("Read “tower a”
    // as “Tower A”"), a money sort that stays inside each currency.
    RecordsWarning: {
        tag: 'p',
        dataRecordsWarning: true,
        hide: (el, s)=>!el.call('assistantRecordsWarning', s),
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        overflowWrap: 'anywhere',
        text: (el, s)=>el.call('assistantRecordsWarning', s)
    },
    // Every other state is ONE sentence (never a bare zero); a failure offers
    // Try again. A status region exists before it speaks.
    RecordsNote: {
        role: 'status',
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        gap: 'Z',
        minWidth: '0',
        NoteText: {
            tag: 'span',
            fontSize: 'Z',
            color: 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>el.call('assistantRecordsNote', s)
        },
        AppCapsuleBtnToolbar: {
            compact: true,
            dataRecordsRetry: true,
            hide: (el, s)=>{
                const e = el.call('assistantRecordsEntry', s && s.root, el.call('recordsBlockOf', s));
                return !e || e.status !== 'failed';
            },
            text: '{{ workspace.assistantBoard.tryAgain | polyglot }}',
            onClick: (e, el, s)=>el.call('assistantRecordsEnsure', el, s, true)
        }
    }
};
const $a92d7808c40adb9c$export$66d3d237bf691195 = {
    extends: 'HomeWidgetHero',
    unitFirst: true,
    Value: {
        text: (el, s)=>{
            const v = s && s.recordsViewModel || el.call('assistantRecordsViewFor', s);
            const hero = v.hero || v.line;
            return hero ? hero.number : '';
        }
    },
    Unit: {
        hide: (el, s)=>{
            const v = s && s.recordsViewModel || el.call('assistantRecordsViewFor', s);
            const hero = v.hero || v.line;
            return !(hero && hero.unit);
        },
        text: (el, s)=>{
            const v = s && s.recordsViewModel || el.call('assistantRecordsViewFor', s);
            const hero = v.hero || v.line;
            return hero && hero.unit || '';
        }
    }
};
const $a92d7808c40adb9c$export$e2d6c7aa68d76dfd = {
    tag: 'li',
    AssistantRecordsRowBtn: {
        tag: 'button',
        type: 'button',
        width: '100%',
        flow: 'y',
        gap: 'X',
        align: 'flex-start',
        padding: 'Y Z',
        round: 'radiusControl',
        border: 'none',
        background: 'transparent',
        color: 'title',
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'background A defaultBezier',
        ':not(:disabled):hover': {
            background: 'hover'
        },
        ':not(:disabled):active': {
            background: 'selected'
        },
        // A row opens its record only where a page names it (functions/
        // assistantRecords.js assistantRecordsHref: the record route, else the
        // app's page). One that opens nothing is no control: no pointer, no
        // hover, out of the tab order.
        ':disabled': {
            cursor: 'default'
        },
        disabled: (el, s)=>el.call('assistantRecordsHref', s, s && s.row) ? null : true,
        // A FINGER'S TARGET (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): on a touch screen a row
        // that opens something is 44pt tall — the generated 'open incidents by
        // severity' widget's bars read 39px at 393 and 34px at 834 on dev DFI (the
        // Finances lane's shell check). Real height, not a slop: stacked rows' slops
        // would overlap their neighbours.
        '@coarse': {
            minHeight: 'controlH',
            justifyContent: 'center'
        },
        ariaLabel: (el, s)=>String(el.call('polyglot', 'workspace.assistantRecords.openRow')).replace('{title}', s && s.title || ''),
        onClick: (e, el, s)=>el.call('assistantRecordsOpen', s, s && s.row),
        RowTitle: {
            tag: 'span',
            hide: (el, s)=>!!(s && s.appRow),
            fontSize: 'A',
            fontWeight: '500',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.title || ''
        },
        RowMeta: {
            tag: 'span',
            hide: (el, s)=>!(s && s.meta) || !!(s && s.appRow),
            fontSize: 'Z',
            color: 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.meta || ''
        },
        // THE STATUS (D5, Pulse's incidents): a dot in the row's semantic ink
        // (successInk / warningInk / dangerInk / accentInk; caption when the
        // status names no tone) and the status words in caption.
        RowStatus: {
            tag: 'span',
            dataRecordsRowStatus: true,
            if: (el, s)=>!!(s && s.status) && !(s && s.appRow),
            flow: 'x',
            align: 'center',
            gap: 'X',
            fontSize: 'Z',
            color: 'caption',
            StatusDot: {
                tag: 'span',
                dataStatusDot: true,
                dataTone: (el, s)=>s && s.tone || 'caption',
                boxSize: 'Y',
                flexShrink: '0',
                round: 'radiusPill',
                background: (el, s)=>s && s.tone || 'caption'
            },
            StatusText: {
                tag: 'span',
                overflowWrap: 'anywhere',
                text: (el, s)=>s && s.status || ''
            }
        },
        // The app's own row, mounted under the app's context with scope
        // { record, fields } (functions/assistantRecords.js
        // assistantRecordsRowMount). Absent without an app row, so the generic
        // row keeps exactly its two lines.
        RowApp: {
            if: (el, s)=>!!(s && s.appRow),
            alignSelf: 'stretch',
            minWidth: '0',
            onRender: (el, s)=>el.call('assistantRecordsRowMount', el, s),
            onUpdate: (el, s)=>el.call('assistantRecordsRowMount', el, s)
        }
    }
};
const $a92d7808c40adb9c$export$923df486bf246342 = {
    tag: 'th',
    attr: {
        scope: 'col'
    },
    textAlign: 'left',
    padding: 'Y Z',
    fontWeight: '500',
    color: 'caption',
    overflowWrap: 'anywhere',
    text: (el, s)=>s && s.label || ''
};
const $a92d7808c40adb9c$export$b243c6136ca67ff6 = {
    tag: 'tr',
    dataRecordsOpen: (el, s)=>el.call('assistantRecordsHref', s, s && s.row) ? true : null,
    tabindex: (el, s)=>el.call('assistantRecordsHref', s, s && s.row) ? '0' : null,
    cursor: 'default',
    // A FINGER'S TARGET (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): on a touch screen a row
    // that opens something is 44pt tall — the generated 'open incidents by
    // severity' widget's bars read 39px at 393 and 34px at 834 on dev DFI (the
    // Finances lane's shell check). Real height, not a slop: stacked rows' slops
    // would overlap their neighbours.
    // A table row's `height` is its floor.
    '@coarse': {
        height: 'controlH'
    },
    transition: 'background A defaultBezier',
    '&[data-records-open]': {
        cursor: 'pointer'
    },
    '&[data-records-open]:hover': {
        background: 'hover'
    },
    '&[data-records-open]:active': {
        background: 'selected'
    },
    onClick: (e, el, s)=>el.call('assistantRecordsOpen', s, s && s.row),
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        el.call('assistantRecordsOpen', s, s && s.row);
    },
    childrenAs: 'state',
    children: (el, s)=>s && Array.isArray(s.cells) ? s.cells : [],
    childExtends: 'AssistantRecordsCell'
};
const $a92d7808c40adb9c$export$36b86915e7bc7dc5 = {
    tag: 'td',
    padding: 'Y Z',
    color: 'title',
    overflowWrap: 'anywhere',
    text: (el, s)=>s && s.text || ''
};
const $a92d7808c40adb9c$export$8d428d0bdf3a576c = {
    role: (el, s)=>s && s.drillable && s.from ? 'button' : null,
    tabindex: (el, s)=>s && s.drillable && s.from ? '0' : null,
    ariaLabel: (el, s)=>s && s.drillable && s.from ? String(el.call('polyglot', 'workspace.assistantRecords.drillOpen')).replace('{value}', s.label || '') : null,
    transition: 'background A defaultBezier',
    '&[role="button"]': {
        cursor: 'pointer'
    },
    '&[role="button"]:hover': {
        background: 'hover'
    },
    '&[role="button"]:active': {
        background: 'selected'
    },
    onClick: (e, el, s)=>el.call('assistantRecordsDrill', s),
    onKeydown: (e, el, s)=>{
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (!(s && s.drillable && s.from)) return;
        e.preventDefault();
        el.call('assistantRecordsDrill', s);
    }
};
const $a92d7808c40adb9c$export$4e13a74e079a73ff = {
    extends: 'AssistantRecordsDrillTarget',
    tag: 'div',
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    padding: 'X Y',
    round: 'radiusControl',
    // A FINGER'S TARGET (DESIGN-SHELL-RESPONSIVE-IOS-SAFARI-1): on a touch screen a row
    // that opens something is 44pt tall — the generated 'open incidents by
    // severity' widget's bars read 39px at 393 and 34px at 834 on dev DFI (the
    // Finances lane's shell check). Real height, not a slop: stacked rows' slops
    // would overlap their neighbours.
    // A bar that only reads (not drillable) keeps the desktop density.
    '@coarse': {
        '&[role="button"]': {
            minHeight: 'controlH',
            justifyContent: 'center'
        }
    },
    BarHead: {
        flow: 'x',
        flexWrap: 'wrap',
        align: 'center',
        gap: 'Z',
        fontSize: 'Z',
        // A donut's legend row (D5): the slice's dot — the card hue at the
        // slice's step — for the track.
        BarDot: {
            tag: 'span',
            if: (el, s)=>!!(s && s.dot != null),
            boxSize: 'Y',
            flexShrink: '0',
            round: 'radiusPill',
            background: 'currentColor',
            opacity: (el, s)=>s && s.dot != null ? String(s.dot) : undefined
        },
        BarLabel: {
            tag: 'span',
            flex: '1',
            minWidth: '0',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.label || ''
        },
        BarValue: {
            tag: 'span',
            color: 'title',
            fontWeight: '500',
            maxWidth: '100%',
            overflowWrap: 'anywhere',
            textAlign: 'right',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>s && s.shareText ? (s.value || '') + " \xb7 " + s.shareText : s && s.value || ''
        }
    },
    BarTrack: {
        if: (el, s)=>!(s && s.dot != null),
        height: 'Y',
        round: 'radiusPill',
        background: 'overlay',
        overflow: 'hidden',
        BarFill: {
            height: '100%',
            round: 'radiusPill',
            background: 'currentColor',
            opacity: '0.55',
            style: (el, s)=>({
                    width: Math.round((s && s.share || 0) * 100) + '%'
                })
        }
    }
};
const $a92d7808c40adb9c$export$50fdadcf95c43d19 = {
    extends: [
        'AiWidgetChip',
        'AssistantRecordsDrillTarget'
    ],
    tag: 'span',
    flow: 'x',
    align: 'center',
    gap: 'X',
    minWidth: '0',
    maxWidth: '100%',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    // A finger's target, as a bar's: a chip that opens something is controlH
    // tall on a touch screen; a chip that only reads keeps the pill's density.
    '@coarse': {
        '&[role="button"]': {
            minHeight: 'controlH'
        }
    },
    ChipCount: {
        tag: 'span',
        dataRecordsChipCount: true,
        flexShrink: '0',
        color: 'caption',
        whiteSpace: 'nowrap',
        fontVariantNumeric: 'tabular-nums',
        text: (el, s)=>s && s.value || ''
    }
};
const $a92d7808c40adb9c$export$4941d7968d6b8c3e = {
    tag: 'circle',
    attr: {
        cx: '21',
        cy: '21',
        r: '15.9155',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '6',
        'stroke-dasharray': (el, s)=>s && s.dash || '0 100',
        'stroke-dashoffset': (el, s)=>s && s.offset || '25',
        'stroke-opacity': (el, s)=>s && s.opacity != null ? String(s.opacity) : '1'
    }
};
const $a92d7808c40adb9c$export$b6edb47e245008a6 = {
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    role: 'img',
    ariaLabel: (el, s)=>{
        const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
        return line ? line.first + " \u2013 " + line.last + " \xb7 " + line.value : null;
    },
    AssistantRecordsHero: {
        Tail: {
            text: (el, s)=>{
                const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                return line && line.last || '';
            }
        }
    },
    LinePlot: {
        position: 'relative',
        height: 'D',
        minWidth: '0',
        Chart: {
            // frank-allow FA601 — data plot (non-icon viewBox), not an icon
            tag: 'svg',
            viewBox: '0 0 240 64',
            preserveAspectRatio: 'none',
            ariaHidden: 'true',
            position: 'absolute',
            inset: '0',
            width: '100%',
            height: '100%',
            display: 'block',
            overflow: 'visible',
            Area: {
                // frank-allow FA602 — computed area, not an icon
                tag: 'path',
                attr: {
                    d: (el, s)=>{
                        const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                        const g = s && s.recordsViewModel ? s.recordsGeometry : line ? el.call('homeSparkGeom', line.points, 240, 64, 4) : null;
                        return g ? g.areaPath : null;
                    },
                    fill: 'currentColor',
                    'fill-opacity': '0.08',
                    stroke: 'none'
                }
            },
            Line: {
                // frank-allow FA602 — computed stroke, not an icon
                tag: 'path',
                attr: {
                    d: (el, s)=>{
                        const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                        const g = s && s.recordsViewModel ? s.recordsGeometry : line ? el.call('homeSparkGeom', line.points, 240, 64, 4) : null;
                        return g ? g.linePath : null;
                    },
                    fill: 'none',
                    stroke: 'currentColor',
                    'stroke-width': '2',
                    'stroke-linejoin': 'round',
                    'stroke-linecap': 'round',
                    'vector-effect': 'non-scaling-stroke'
                }
            }
        },
        LineDot: {
            dataLineDot: true,
            position: 'absolute',
            boxSize: 'Y',
            round: 'radiusPill',
            background: 'currentColor',
            transform: 'translate(-50%, -50%)',
            hide: (el, s)=>{
                const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                return !(s && s.recordsViewModel ? s.recordsGeometry : line && el.call('homeSparkGeom', line.points, 240, 64, 4));
            },
            left: (el, s)=>{
                const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                const g = s && s.recordsViewModel ? s.recordsGeometry : line ? el.call('homeSparkGeom', line.points, 240, 64, 4) : null;
                return g ? Math.round(g.end.x / 240 * 1000) / 10 + '%' : null;
            },
            top: (el, s)=>{
                const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                const g = s && s.recordsViewModel ? s.recordsGeometry : line ? el.call('homeSparkGeom', line.points, 240, 64, 4) : null;
                return g ? Math.round(g.end.y / 64 * 1000) / 10 + '%' : null;
            }
        }
    },
    LineAxis: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        fontSize: 'Y',
        color: 'caption',
        minWidth: '0',
        LineFirst: {
            tag: 'span',
            text: (el, s)=>{
                const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                return line && line.first || '';
            }
        },
        LineLast: {
            tag: 'span',
            text: (el, s)=>{
                const line = (s && s.recordsViewModel || el.call('assistantRecordsViewFor', s)).line;
                return line && line.last || '';
            }
        }
    }
};

});

parcelRegister("c9akr", function(module, exports) {

$parcel$export(module.exports, "AssistantViewList", () => $8d7e565d0f679a73$export$d68a49d8bc4ab7ae);
$parcel$export(module.exports, "AssistantViewGroup", () => $8d7e565d0f679a73$export$5d51a4ab5109009);
// THE LIST FRAME OF A BUILT-IN VIEW — the read-only frame the team, the
// notifications, the reminders, the calls, a call's transcript, a chat
// channel, the mail and a note mount in an AI answer and on a Fly page
// (functions/assistantAppViews.js, the views contract; scope { params,
// embedded }). One frame, so every view reads, waits, says "nothing" and
// cuts the same way:
//
//   MeetRoomsAnswerView: {
//     extends: 'AssistantViewList',
//     viewLoad: 'meetRoomsAnswerLoad',    async (el, params) → { data, failed }
//     viewModel: 'meetRoomsAnswerModel'   (data, params, failed) → model | null
//   }
//
// The read lands in the frame's OWN state (`viewData`, never a root list),
// once per params (functions/assistantViewList.js). The model is
//   { lead, groups: [{ key, groupLabel, groupRows }], body, note, more }
//   lead   one plain paragraph before the rows (a call's summary)
//   groups labelled lists of the home widget kit's rows (HomeWidgetRow) — a
//          row opens the item where it lives
//   body   markdown after the rows (a note's words)
//   note   the one sentence when there is nothing to show (a bundle key)
//   more   { shown, total } or { shown, open: true } — a cut list says so
// The model is derived on every read, so a view follows the root data it
// reads (who is online, a live call, the language). No write control: an
// answer shows the app read-only, so `embedded` changes nothing here.
//
// EMPTY (the views contract): the read answered and the frame shows only its
// one sentence — a Fly page gives the card one row. null while reading.
const $8d7e565d0f679a73$export$d68a49d8bc4ab7ae = {
    flow: 'y',
    gap: 'A',
    flex: '1',
    minWidth: '0',
    minHeight: '0',
    // A long list scrolls inside its card, never past it (a Fly card's grid row
    // has a fixed height).
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    state: {
        viewData: null,
        viewFailed: false
    },
    viewLoad: '',
    viewModel: '',
    empty: (el, s)=>el.call('assistantViewListEmpty', el, s),
    onRender: (el)=>el.call('assistantViewListLoad', el),
    ViewSkeleton: {
        flow: 'y',
        gap: 'Y',
        ariaBusy: 'true',
        hide: (el, s)=>el.call('assistantViewListModel', el.parent, s) !== null,
        Skeleton_1: {
            height: 'B',
            round: 'radiusControl'
        },
        Skeleton_2: {
            height: 'B',
            round: 'radiusControl'
        },
        Skeleton_3: {
            height: 'B',
            round: 'radiusControl',
            width: '60%'
        }
    },
    ViewNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return !m || !m.note;
        },
        text: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return m && m.note ? String(el.call('polyglot', m.note)) : '';
        }
    },
    ViewLead: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z1',
        lineHeight: '1.6',
        color: 'title',
        whiteSpace: 'pre-line',
        overflowWrap: 'anywhere',
        hide: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return !m || !m.lead;
        },
        text: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return m && m.lead || '';
        }
    },
    ViewGroups: {
        flow: 'y',
        gap: 'A',
        minWidth: '0',
        hide: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return !m || !m.groups.length;
        },
        childExtends: 'AssistantViewGroup',
        childrenAs: 'state',
        children: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return m ? m.groups : [];
        }
    },
    // Markdown words (a note): the shared renderer's children, re-derived with
    // the model — a reactive `text` factory would fight MarkdownPreview's own
    // imperative render.
    ViewBody: {
        flow: 'y',
        gap: 'Z',
        minWidth: '0',
        fontSize: 'Z1',
        lineHeight: '1.6',
        color: 'paragraph',
        overflowWrap: 'anywhere',
        hide: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return !m || !m.body;
        },
        children: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return m && m.body ? el.call('markdownToChildren', m.body, {
                demoteHeadings: true
            }) : [];
        }
    },
    // The first N of more: says so, never a silent cut.
    ViewMore: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            return !m || !m.more;
        },
        text: (el, s)=>{
            const m = el.call('assistantViewListModel', el.parent, s);
            if (!m || !m.more) return '';
            // A known total says "N of M"; a list with a next page and no total
            // says the rest is in the app.
            if (m.more.total == null) return String(el.call('polyglot', 'workspace.answer.moreOpen')).replace('{n}', String(m.more.shown));
            return String(el.call('polyglot', 'workspace.answer.more')).replace('{n}', String(m.more.shown)).replace('{total}', String(m.more.total));
        }
    }
};
const $8d7e565d0f679a73$export$5d51a4ab5109009 = {
    tag: 'section',
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    ariaLabel: (el, s)=>s && s.groupLabel || null,
    AppMicroLabel: {
        hide: (el, s)=>!(s && s.groupLabel),
        text: (el, s)=>s && s.groupLabel || ''
    },
    AssistantViewRows: {
        flow: 'y',
        gap: 'Y',
        minWidth: '0',
        childExtends: 'HomeWidgetRow',
        childrenAs: 'state',
        children: (el, s)=>s && Array.isArray(s.groupRows) ? s.groupRows : []
    }
};

});

parcelRegister("jcUdR", function(module, exports) {

$parcel$export(module.exports, "TeamPeopleAnswerView", () => $039bc94a2b3d43e3$export$b14d36f43ca2d2a);
// THE TEAM IN AN AI ANSWER — the `team-people` view (functions/
// workspaceAnswer.js workspaceAiViews): the workspace's members, who is
// online now, and its AI agents, in the shared list frame
// (components/AssistantViewList.js). A member opens their profile; an agent,
// Team & agents. Read-only.
const $039bc94a2b3d43e3$export$b14d36f43ca2d2a = {
    extends: 'AssistantViewList',
    dataAnswerView: 'team-people',
    viewLoad: 'teamPeopleAnswerLoad',
    viewModel: 'teamPeopleAnswerModel'
};

});

parcelRegister("b67FM", function(module, exports) {

$parcel$export(module.exports, "NotificationsAnswerView", () => $814634e6ea929b85$export$dfaad1295efbded8);
// THE NOTIFICATIONS IN AN AI ANSWER — the `notifications` view (functions/
// workspaceAnswer.js workspaceAiViews): the bell's list, unread first, in the
// shared list frame (components/AssistantViewList.js). A row opens what the
// bell row opens; nothing is marked read here.
const $814634e6ea929b85$export$dfaad1295efbded8 = {
    extends: 'AssistantViewList',
    dataAnswerView: 'notifications',
    viewLoad: 'notificationsAnswerLoad',
    viewModel: 'notificationsAnswerModel'
};

});

parcelRegister("4Fs5n", function(module, exports) {

$parcel$export(module.exports, "RemindersAnswerView", () => $3660c6fca589f60f$export$a2e7dd7d5224b8e0);
// THE REMINDERS IN AN AI ANSWER — the `reminders` view (functions/
// workspaceAnswer.js workspaceAiViews): the reminders app's own groups
// (overdue, today, tomorrow, upcoming, no date, completed) in the shared list
// frame (components/AssistantViewList.js). A row opens Reminders. Read-only.
const $3660c6fca589f60f$export$a2e7dd7d5224b8e0 = {
    extends: 'AssistantViewList',
    dataAnswerView: 'reminders',
    viewLoad: 'remindersAnswerLoad',
    viewModel: 'remindersAnswerModel'
};

});

parcelRegister("gvLr9", function(module, exports) {

$parcel$export(module.exports, "AiInspectLayer", () => $c05456985b3196a1$export$1ff039724b7b82f6);
// INSPECT & ASK — the layer over the page while inspecting
// (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1; the engine is
// functions/aiInspect.js). Mounted at the shell root (app.js) and only while
// the mode is on (`if:` — its document listeners exist only then):
//
//   InspectBox   the outline around the region under the pointer (or the one
//                the arrow keys reached): the house focus ring on a `hover`
//                wash, the card radius, and a tag with the region's name
//   InspectHint  what a click does and the way out — the composer's own glass
//                capsule above the composer, role=status, focused on entry so
//                the keys reach the mode; Cancel leaves
//
// It never moves the page: a fixed overlay that takes no pointer itself (the
// hint excepted). Every press on the page while inspecting belongs to the
// mode (aiInspectSwallow in the capture phase), so a widget never starts a
// drag and a row never opens its record. Motion: the outline glides between
// regions at the house step — and lands at once under reduced motion (the
// brand reset).
const $c05456985b3196a1$export$1ff039724b7b82f6 = {
    if: (el, s)=>!!(s.root && s.root._aiInspect),
    // FA515: the gate and the outline read root keys behind a guard — declared,
    // so a short-circuited run still re-fires when they change.
    ifDeps: [
        (el, s)=>s.root && s.root._aiInspect
    ],
    position: 'fixed',
    inset: '0',
    // Over the composer (1400) and the page sheet (1300), under every modal
    // (2000) and dropdown layer.
    zIndex: '1450',
    pointerEvents: 'none',
    onDocumentPointermove: {
        passive: true,
        handler: (e, el)=>el.call('aiInspectHover', e)
    },
    onDocumentPointerdown: {
        capture: true,
        handler: (e, el)=>el.call('aiInspectSwallow', e)
    },
    onDocumentClick: {
        capture: true,
        handler: (e, el)=>el.call('aiInspectClick', e)
    },
    onDocumentKeydown: {
        capture: true,
        handler: (e, el)=>el.call('aiInspectKey', e)
    },
    onDocumentScroll: {
        capture: true,
        passive: true,
        handler: (e, el)=>el.call('aiInspectRefresh')
    },
    onWindowResize: (e, el)=>el.call('aiInspectRefresh'),
    InspectBox: {
        hide: (el, s)=>!(s.root && s.root._aiInspectBox),
        hideDeps: [
            (el, s)=>s.root && s.root._aiInspectBox
        ],
        styleDeps: [
            (el, s)=>s.root && s.root._aiInspectBox
        ],
        position: 'absolute',
        boxSizing: 'border-box',
        round: 'radiusCard',
        background: 'hover',
        shadow: 'focusRing',
        pointerEvents: 'none',
        transition: 'top A defaultBezier, left A defaultBezier, width A defaultBezier, height A defaultBezier',
        // The region's measured box (viewport px — a measurement, not a design
        // value).
        style: (el, s)=>{
            const b = s.root && s.root._aiInspectBox || {};
            return {
                top: (b.y || 0) + 'px',
                left: (b.x || 0) + 'px',
                width: (b.w || 0) + 'px',
                height: (b.h || 0) + 'px'
            };
        },
        // The region's name over its top edge — inside the box when the region
        // starts at the top of the screen.
        InspectTag: {
            position: 'absolute',
            left: '0',
            flow: 'x',
            align: 'center',
            gap: 'X',
            maxWidth: '100%',
            boxSizing: 'border-box',
            padding: 'X Z',
            round: 'radiusPill',
            background: 'highlight',
            color: 'highlight-reversed',
            fontSize: 'Z',
            fontWeight: '500',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            transformDeps: [
                (el, s)=>s.root && s.root._aiInspectBox
            ],
            transform: (el, s)=>{
                const b = s.root && s.root._aiInspectBox || {};
                return (b.y || 0) < 48 ? 'translateY(var(--spacing-Y))' : 'translateY(-115%)';
            },
            Icon: {
                name: 'lnInspect',
                boxSize: 'iconSm',
                flexShrink: '0',
                ariaHidden: 'true'
            },
            TagText: {
                tag: 'span',
                textDeps: [
                    (el, s)=>s.root && s.root._aiInspectBox
                ],
                minWidth: '0',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                text: (el, s)=>{
                    const b = s.root && s.root._aiInspectBox || {};
                    const ask = el.call('polyglot', 'workspace.aiInspect.pick');
                    return b.label ? b.label + " \xb7 " + ask : ask;
                }
            }
        }
    },
    // The way out, said once and always reachable. Above the composer (its
    // measured top, --prompt-clear), centred.
    InspectHint: {
        role: 'status',
        ariaLive: 'polite',
        tabindex: '-1',
        position: 'absolute',
        left: '50%',
        // --prompt-clear is the shell's registered measure of the composer's top
        // (app.js @property, always defined): the hint sits one Z above it.
        bottom: 'calc(var(--prompt-clear) + var(--spacing-Z))',
        transform: 'translateX(-50%)',
        pointerEvents: 'auto',
        flow: 'x',
        align: 'center',
        gap: 'Z',
        maxWidth: 'calc(100vw - var(--spacing-B))',
        boxSizing: 'border-box',
        padding: 'Y Y Y Z1',
        round: 'radiusPill',
        theme: 'search-glass',
        borderWidth: '0',
        shadow: 'overlay',
        fontSize: 'Z1',
        color: 'title',
        animation: 'fadeInUpShort',
        animationDuration: 'B',
        '@reduceTransparency': {
            theme: 'dialog',
            backdropFilter: 'none'
        },
        ':focus-visible': {
            shadow: 'focusRing'
        },
        Plate: {
            ariaHidden: 'true',
            display: 'flex',
            align: 'center center',
            flexShrink: '0',
            boxSize: 'glyphPlateXs',
            round: 'radiusPill',
            background: 'highlight',
            color: 'title-reversed',
            Icon: {
                name: 'lnInspect',
                boxSize: 'iconSm'
            }
        },
        HintText: {
            tag: 'span',
            minWidth: '0',
            text: (el)=>el.call('polyglot', 'workspace.aiInspect.hint')
        },
        Keys: {
            flow: 'x',
            align: 'center',
            gap: 'X',
            flexShrink: '0',
            ariaHidden: 'true',
            '@mobileL': {
                display: 'none'
            },
            AppKeycap: {
                text: 'Esc'
            }
        },
        AppCapsuleBtnGhost: {
            compact: true,
            flexShrink: '0',
            text: (el)=>el.call('polyglot', 'common.action.cancel'),
            onClick: (e, el)=>{
                e.preventDefault();
                e.stopPropagation();
                el.call('aiInspectStop');
            }
        }
    }
};

});

parcelRegister("519y5", function(module, exports) {

$parcel$export(module.exports, "AssistantCapabilities", () => $3a7473edb3e4641a$export$e7c2b17165ff2509);
$parcel$export(module.exports, "AssistantCapabilityGroup", () => $3a7473edb3e4641a$export$4a5310270bfd81dc);
$parcel$export(module.exports, "AssistantCapabilityItem", () => $3a7473edb3e4641a$export$cbba78a856b5d09e);
// "WHAT CAN YOU DO HERE?" — the answer as a card of four groups
// (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1; the catalogue is
// functions/aiCapabilities.js). Drawn inside the assistant's block
// (AssistantThreadBlock, card type 'capabilities') in the sidebar and in the
// main thread's reading column.
//
// Each group: the line glyph on the house plate, its name and one line on
// what it means ("Changes I prepare for you — nothing runs until you approve
// it"); then its rows — the house menu row's look (MenuPanelItem) as plain
// buttons, each one a real ask, an action to prepare, a board to build or the
// start of Inspect & ask. A row's second line is its own description (an
// action's `describe`, a widget's), in the quiet ink. Groups are separated by
// rhythm, never strokes.
const $3a7473edb3e4641a$export$e7c2b17165ff2509 = {
    // One column in the sidebar, two side by side at the main thread's board
    // width — the groups flow, nothing is cut.
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(18em, 100%), 1fr))',
    gap: 'A',
    minWidth: '0',
    childExtends: 'AssistantCapabilityGroup',
    childrenAs: 'state',
    children: (el, s)=>{
        const g = s && s.groups;
        const list = g && typeof g.parse === 'function' ? g.parse() : g;
        return Array.isArray(list) ? list : [];
    }
};
const $3a7473edb3e4641a$export$4a5310270bfd81dc = {
    tag: 'section',
    ariaLabel: (el, s)=>s && s.title || null,
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    CapHead: {
        flow: 'x',
        align: 'flex-start',
        gap: 'Z',
        minWidth: '0',
        padding: '0 X',
        CapPlate: {
            ariaHidden: 'true',
            display: 'flex',
            align: 'center center',
            flexShrink: '0',
            boxSize: 'glyphPlateXs',
            round: 'radiusPill',
            background: 'highlight',
            color: 'title-reversed',
            Icon: {
                name: (el, s)=>s && s.glyph || 'lnAssistant',
                boxSize: 'iconSm'
            }
        },
        CapTitles: {
            flow: 'y',
            gap: 'W',
            minWidth: '0',
            CapTitle: {
                tag: 'h4',
                margin: '0',
                fontSize: 'Z1',
                fontWeight: '500',
                lineHeight: '1.3',
                color: 'title',
                text: (el, s)=>s && s.title || ''
            },
            CapExplain: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z',
                lineHeight: '1.35',
                color: 'caption',
                overflowWrap: 'anywhere',
                text: (el, s)=>s && s.explain || ''
            }
        }
    },
    CapItems: {
        tag: 'ul',
        role: 'list',
        margin: '0',
        padding: '0',
        flow: 'y',
        gap: 'W',
        minWidth: '0',
        childExtends: 'AssistantCapabilityItem',
        childrenAs: 'state',
        children: (el, s)=>{
            const it = s && s.items;
            const list = it && typeof it.parse === 'function' ? it.parse() : it;
            return Array.isArray(list) ? list : [];
        }
    }
};
const $3a7473edb3e4641a$export$cbba78a856b5d09e = {
    tag: 'li',
    listStyle: 'none',
    minWidth: '0',
    MenuPanelItem: {
        role: null,
        flow: 'y',
        align: 'flex-start',
        gap: 'W',
        lineHeight: '1.35',
        CapLabel: {
            tag: 'span',
            minWidth: '0',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.label || ''
        },
        CapDescribe: {
            tag: 'span',
            hide: (el, s)=>!(s && s.describe),
            minWidth: '0',
            fontSize: 'Z',
            color: 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.describe || ''
        },
        onClick: (e, el, s)=>{
            e.preventDefault();
            e.stopPropagation();
            const row = s && typeof s.parse === 'function' ? s.parse() : s;
            el.call('aiCapabilityRun', row);
        }
    }
};

});

parcelRegister("1L56l", function(module, exports) {

$parcel$export(module.exports, "WorkspaceActivationStatus", () => $147e2344194cb056$export$893501e09cfd7b23);
const $147e2344194cb056$export$893501e09cfd7b23 = {
    if: (el, s)=>el.call('workspaceActivationView', s.root || s).visible,
    role: 'status',
    ariaLive: 'polite',
    ariaAtomic: true,
    position: 'fixed',
    right: 'B',
    bottom: 'B',
    zIndex: 9990101,
    width: 'G2',
    maxWidth: '90vw',
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    // A THEME name in a COLOUR slot paints NOTHING. `common-box` is registered
    // in designSystem/theme.js, never in color.js, so scratch's
    // `resolveMissingColor` passed the bare word through untouched (it must —
    // `currentColor` and `borderStyle: 'solid'` take the same route) and
    // css-in-props emitted the literal `background: common-box`. No parser
    // accepts that; every browser drops it and nothing warns. Measured 2026-09-22
    // on the real pipeline: `._bg-common-box {background: common-box;}` with
    // `getComputedStyle(...).backgroundColor === 'rgba(0, 0, 0, 0)'` — the banner
    // read as bare floating text on the page (Nika, my.symbols.app). `theme:` is
    // the slot that resolves this token, to `var(--theme-common-box-background)`.
    theme: 'common-box',
    color: 'title',
    borderRadius: 'radiusCard',
    // Same class of miss on the elevation: `float` is a SHADOW family name, and
    // the raw `boxShadow` slot resolves letter tokens against SPACING — it
    // emitted `box-shadow: var(--spacing-FLOAT)`, a custom property nothing
    // defines, so the plate had no lift either. `shadow:` is the design-system
    // prop and emits `var(--shadow-float)`.
    shadow: 'float',
    '@mobileL': {
        left: 'Z',
        right: 'Z',
        bottom: 'Z',
        width: 'auto',
        maxWidth: 'none'
    },
    Title: {
        fontSize: 'Z2',
        fontWeight: '700',
        text: (el, s)=>{
            const view = el.call('workspaceActivationView', s.root || s);
            return view.titleKey ? el.call('polyglot', view.titleKey) : '';
        }
    },
    Text: {
        fontSize: 'Z',
        color: 'inactive',
        text: (el, s)=>{
            const view = el.call('workspaceActivationView', s.root || s);
            if (!view.bodyKey) return '';
            return el.call('polyglot', view.bodyKey).replace('{loaded}', String(view.values.loaded)).replace('{total}', String(view.values.total)).replace('{blocked}', String(view.values.blocked || ''));
        }
    },
    Button: {
        // A blocked verdict is settled — the payload arrived and the shell refused
        // it on content grounds. Offering Retry there promises an outcome no retry
        // can deliver, so the button is not rendered at all.
        if: (el, s)=>el.call('workspaceActivationView', s.root || s).retryable,
        type: 'button',
        theme: 'primary',
        minHeight: 'controlH',
        borderRadius: 'radiusPill',
        alignSelf: 'flex-start',
        disabled: (el, s)=>el.call('workspaceActivationView', s.root || s).busy,
        text: (el, s)=>el.call('polyglot', el.call('workspaceActivationView', s.root || s).busy ? 'workspace.activation.retrying' : 'workspace.activation.retry'),
        onClick: (event, el)=>el.call('retryWorkspaceActivation')
    }
};

});

parcelRegister("dwFge", function(module, exports) {

$parcel$export(module.exports, "ShortcutsOverlay", () => $9d8e450990ecaafd$export$767686fa5e2dd4ad);
$parcel$export(module.exports, "ShortcutsSheetGroup", () => $9d8e450990ecaafd$export$6d2499ecfed76319);
$parcel$export(module.exports, "ShortcutsSheetRow", () => $9d8e450990ecaafd$export$dac43dbfe2c5b60d);
$parcel$export(module.exports, "ShortcutsSheetJoiner", () => $9d8e450990ecaafd$export$f9344c04866f707d);
// THE ? SHEET — every live keyboard shortcut, grouped (HOME_AMBIENT_SKIN_SPEC
// §5 "Sheet" · DESIGN-WL-SHELL-KEYBOARD-MOTION-1).
//
// Built from the D2 kit, nothing hand-rolled: AppDialog v2 as a CENTRE sheet,
// AppDialogHead "Keyboard" (its Close is the brand CloseButton, square, through
// the brand ModalHeader), AppMicroLabel group heads, AppKeycap keys. Weights
// 500 / 700 only (the head's title is the kit's 700; everything here is 500).
//
// THE ROWS are the registry's (functions/shortcuts.js `shortcutSheetGroups`):
// only rows whose KEYSTROKE works right now — the person's single-key switch
// and the workspace flag are honoured, because a keycap for a dead key is a
// lie (AppKeycap's own rule). The command palette (ws-w2) lists the same rows
// through `listShortcuts`.
//
// OPEN STATE: the AppDialog `stateKey` convention, on `root._shortcutsSheetOpen`
// — written by `?` (`openShortcutsSheet`) or by the palette's row, cleared by
// the dialog's own close paths (Esc, the veil, the head's Close). The key's
// declaration in state.js (STATE_DEFAULTS + WORKSPACE_UNSCOPED_KEYS) is handed
// to the state.js owner as docs/patches/shortcuts-state-key.patch; the sheet's
// mount test proves it opens on a root that does NOT declare the key.
//
// MOUNT: once, at the shell root (app.js — ws-w2's file), handed over as
// docs/patches/shortcuts-overlay-mount.patch. Shell-level, so the root is
// `fixed` to the viewport (AppDialog's `absolute` is for a module frame) and
// sits in the Modal.js band (DESIGN_SPEC §6.8: over PageSlot 1300, under the
// dropdown and modal roots).
const $9d8e450990ecaafd$export$767686fa5e2dd4ad = {
    extends: 'AppDialog',
    stateKey: '_shortcutsSheetOpen',
    presentation: 'center',
    panelSize: 'md',
    initialFocus: 'panel',
    position: 'fixed',
    zIndex: '2000',
    Panel: {
        AppDialogHead: {
            heading: 'shell.shortcuts.title',
            titleId: 'shellShortcutsTitle'
        },
        AppDialogBody: {
            ShortcutsSheetGroups: {
                flow: 'y',
                gap: 'B',
                childExtends: 'ShortcutsSheetGroup',
                childrenAs: 'state',
                children: (el)=>el.call('shortcutSheetGroups')
            }
        }
    }
};
const $9d8e450990ecaafd$export$6d2499ecfed76319 = {
    flow: 'y',
    gap: 'Y',
    AppMicroLabel: {
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    ShortcutsSheetRows: {
        flow: 'y',
        childExtends: 'ShortcutsSheetRow',
        childrenAs: 'state',
        children: (el, s)=>Array.from(s.rows || [])
    }
};
const $9d8e450990ecaafd$export$dac43dbfe2c5b60d = {
    tag: 'div',
    flow: 'x',
    align: 'center space-between',
    gap: 'A',
    padding: 'Y2 0',
    minWidth: '0',
    ShortcutsRowLabel: {
        tag: 'span',
        minWidth: '0',
        fontSize: 'Z1',
        fontWeight: '500',
        color: 'title',
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    ShortcutsRowKeys: {
        flow: 'x',
        align: 'center',
        gap: 'X',
        flexShrink: '0',
        children: (el, s)=>{
            const caps = Array.from(s.keycaps || []);
            const out = [];
            caps.forEach((cap, i)=>{
                if (i && s.joiner === 'then') out.push({
                    key: 'then' + i,
                    extends: 'ShortcutsSheetJoiner',
                    text: '{{ shell.shortcuts.then | polyglot }}'
                });
                if (i && s.joiner === 'range') out.push({
                    key: 'range' + i,
                    extends: 'ShortcutsSheetJoiner',
                    text: "\u2013"
                });
                out.push({
                    key: 'cap' + i,
                    extends: 'AppKeycap',
                    text: String(cap)
                });
            });
            return out;
        }
    }
};
const $9d8e450990ecaafd$export$f9344c04866f707d = {
    tag: 'span',
    fontSize: 'Y',
    fontWeight: '500',
    color: 'caption'
};

});

parcelRegister("aewVc", function(module, exports) {

$parcel$export(module.exports, "OnboardingGate", () => $7734bfba47fc687e$export$7529421a05049227);
$parcel$export(module.exports, "OnboardingWizard", () => $7734bfba47fc687e$export$6dee1ad9de59f3da);
$parcel$export(module.exports, "OnboardingWizardStep", () => $7734bfba47fc687e$export$41ed7fe07bd1f169);
$parcel$export(module.exports, "OnboardingWelcomeStep", () => $7734bfba47fc687e$export$bce7a3866da3d379);
$parcel$export(module.exports, "OnboardingAppsStep", () => $7734bfba47fc687e$export$d507c8febf01c1aa);
$parcel$export(module.exports, "OnboardingLookStep", () => $7734bfba47fc687e$export$21121ac047072882);
$parcel$export(module.exports, "OnboardingHomeStep", () => $7734bfba47fc687e$export$5252df6f32753c5b);
$parcel$export(module.exports, "OnboardingDoneStep", () => $7734bfba47fc687e$export$567caf671b2a8e15);
$parcel$export(module.exports, "OnboardingWizardGroup", () => $7734bfba47fc687e$export$1a4e212492829621);
$parcel$export(module.exports, "OnboardingTileGrid", () => $7734bfba47fc687e$export$a5cc7f6f44dcd0ee);
$parcel$export(module.exports, "OnboardingTile", () => $7734bfba47fc687e$export$30a12c51cd1cfd02);
$parcel$export(module.exports, "OnboardingChoiceTile", () => $7734bfba47fc687e$export$694043c3c399ddec);
$parcel$export(module.exports, "OnboardingAppTile", () => $7734bfba47fc687e$export$82a60b95313f8937);
$parcel$export(module.exports, "OnboardingWizardSky", () => $7734bfba47fc687e$export$4d5cd0a48c6fc43f);
$parcel$export(module.exports, "OnboardingPreview", () => $7734bfba47fc687e$export$da4d4165de906dde);
$parcel$export(module.exports, "OnboardingPreviewPane", () => $7734bfba47fc687e$export$c02e9401787e0c9f);
$parcel$export(module.exports, "OnboardingPreviewCell", () => $7734bfba47fc687e$export$ccf309feb0b41ea0);
$parcel$export(module.exports, "OnboardingPreviewDot", () => $7734bfba47fc687e$export$83f3acb9fdbd6170);
$parcel$export(module.exports, "OnboardingWay", () => $7734bfba47fc687e$export$f7a0b0f3ac9c429c);
$parcel$export(module.exports, "OnboardingJourney", () => $7734bfba47fc687e$export$1edf552dd5f182a9);
$parcel$export(module.exports, "OnboardingJourneyStop", () => $7734bfba47fc687e$export$e139857aa9d40197);
$parcel$export(module.exports, "OnboardingLesson", () => $7734bfba47fc687e$export$c8ff14cb2d77ebd2);
$parcel$export(module.exports, "OnboardingPresetTile", () => $7734bfba47fc687e$export$85475e5fd2dd6);
$parcel$export(module.exports, "OnboardingRecap", () => $7734bfba47fc687e$export$f8f16878ff6c7e21);
$parcel$export(module.exports, "OnboardingRecapItem", () => $7734bfba47fc687e$export$ffc279c8be1210a7);
$parcel$export(module.exports, "OnboardingStudio", () => $7734bfba47fc687e$export$9e0155ab5c2b30b8);
$parcel$export(module.exports, "OnboardingPreviewLine", () => $7734bfba47fc687e$export$5b129e9870bf7c88);
$parcel$export(module.exports, "OnboardingPreviewCard", () => $7734bfba47fc687e$export$7ec3e321dd6ed58a);
$parcel$export(module.exports, "OnboardingPreviewApp", () => $7734bfba47fc687e$export$86718d9d3f8f01e3);
// THE SETUP SURFACE of the new-account welcome — a full-screen first run
// (functions/onboarding.js tells who sees it and what a close decides;
// functions/onboardingWizard.js drives its steps). Nika 2026-10-18: "it should
// be wizard like onboarding and click based onboarding could be possible. this
// will help to personalize the view and avoid showing complex ui at first
// load".
//
// ONE SURFACE, opaque (`document`, the page's own ground): the busy shell is
// never behind a veil, it is simply not on screen until the person has shaped
// it. While a new account's record is read the same surface holds the screen
// with nothing but the workspace's name (`root._onboardingHold`), and the
// wizard opens on it without a flash. Steps: the welcome (Get started, or the
// assistant, or the tour), then click steps on TWO SIDES, never mixed — the
// WORKSPACE side first, the three choices Your work, Your apps and Your idea
// (owners and admins, written for the whole workspace; components/
// OnboardingWorkStep.js, OnboardingStackStep.js, OnboardingIdeaStep.js), then
// the PERSONAL side, this person's own apps, look and home — then done. The
// assistant's conversation draws here too (components/OnboardingChat.js). A
// person who signed up through Fly meets none of those: Fly asked the three
// questions, so the surface holds ONE step for them, "Your workspace is
// ready" (components/OnboardingReadyStep.js, functions/onboardingReady.js). A
// personalized sign-up (POB) meets ONE step too: the build board, a card per
// server step and "Open my workspace" in the foot once every step has an
// outcome (components/OnboardingBuildStep.js, functions/onboardingBuild.js).
//
// THE KIT'S MECHANICS, as AppDialog does them: the root is ALWAYS mounted once
// built; open is a DATA ATTRIBUTE published by a flat factory (`dataOpen`) and
// every state rule is a static `&[data-open]` block (a factory CSS value is
// written inline and beats the `@mobileL` rules; `.isX` blocks apply at create
// only); closed = `visibility: hidden` + `pointer-events: none` after the
// exit. The page behind is inert while the surface is up (`inertOutside`) —
// except while the out-of-credits notice is up: the notice is the layer then,
// and the surface waits under it (see `inertOutside` below).
// Escape is Skip; Tab cycles inside (appDialogTrapTab).
//
// Tiles are buttons with `aria-pressed` (the Personalise panel's own sky tile,
// HomeSkyTile, is the model); surfaces differ by fill, never by a border.
// The hidden watcher — holds the surface for a new account's first load and
// opens the wizard once (functions/onboarding.js onboardingTick). Sibling of
// UsernamePromptGate in shape and mount point: a display:none div whose job is
// a reactive check.
const $7734bfba47fc687e$export$7529421a05049227 = {
    tag: 'div',
    display: 'none',
    subscribeTo: [
        'signedIn',
        '_authReady',
        'user',
        'userPrefs',
        'workspace',
        'org',
        'currentPath',
        '_wsSwitching',
        '_wpSwitching',
        '_dataLoading',
        '_inviteFlowActive',
        '_usernamePromptPending',
        '_homeCustomizeMode',
        '_canvasSlot',
        '_onboardingDecision',
        '_onboardingFlyArrival',
        '_onboardingTour',
        // the workspace building itself (functions/workspaceSetup.js): the ready
        // screen waits while it holds
        '_workspaceSetup'
    ],
    onCreate: (el)=>el.call('onboardingTick'),
    onUpdate: (el)=>el.call('onboardingTick'),
    onBeforeRemove: (el)=>el.call('onboardingGateStop')
};
const $7734bfba47fc687e$export$6dee1ad9de59f3da = {
    role: 'dialog',
    ariaModal: 'true',
    ariaLabelledby: 'onboardingWizardTitle',
    // While the record is read, the surface says it is busy.
    ariaBusyDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    ariaBusy: (el, s)=>s.root && s.root._onboardingHold && !s.root._onboardingFlow ? 'true' : null,
    dataOpenDeps: [
        (el, s)=>s.root && (s.root._onboardingOpen || s.root._onboardingHold)
    ],
    dataOpen: (el, s)=>!!(s.root && (s.root._onboardingOpen || s.root._onboardingHold)),
    // THE LAYER, with one yield. The framework stacks modal layers in the order
    // they went live ("the newest open layer defines what is interactive"), so a
    // surface that opens AFTER the out-of-credits notice (components/
    // CreditBlocker.js, a layer too) would become the top layer and put `inert`
    // on the notice: its ✕, Escape and Tab dead. The surface therefore is no layer
    // while the notice is up — on the notice's own predicate (`creditBlockerShown`,
    // the one source of truth the notice paints with, on the layer path: it writes
    // nothing). It waits under the notice, drawn as before and inert like the rest
    // of the page, and is the layer again, with the focus, the moment the notice
    // goes. A surface that is not open asks nothing.
    inertOutside: (el, s)=>!!(s.root && (s.root._onboardingOpen || s.root._onboardingHold)) && !el.call('creditBlockerShown', el, s.root, false),
    // Shell-level, above every page layer, in the Modal band.
    position: 'fixed',
    inset: '0',
    zIndex: '2000',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    minWidth: '0',
    theme: 'document',
    color: 'paragraph',
    visibility: 'hidden',
    pointerEvents: 'none',
    opacity: '0',
    transition: 'opacity C defaultBezier, visibility 0s linear C',
    '&[data-open]': {
        visibility: 'visible',
        pointerEvents: 'auto',
        opacity: '1',
        transition: 'opacity C defaultBezier, visibility 0s linear 0s'
    },
    // Escape is Skip (the decision is closeOnboarding's); Tab stays inside.
    onKeydown: (e, el)=>{
        if (e.key === 'Escape') {
            e.stopPropagation();
            el.call('closeOnboarding', 'close');
            return;
        }
        el.call('appDialogTrapTab', e);
    },
    // …and the same two keys when the focus fell to the page body: the boot
    // screen keeps the page inert for ~3 s, every focus() in that time is a
    // no-op, and the surface can open inside it (functions/onboarding.js
    // onboardingDocumentKeydown — the shell's declared document listener, never
    // a raw one).
    onDocumentKeydown: (e, el)=>el.call('onboardingDocumentKeydown', e),
    // THE TOP — the workspace's name, and Skip at every step but the last.
    WizardTop: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'A',
        flexShrink: '0',
        minWidth: '0',
        boxSizing: 'border-box',
        padding: 'A C',
        '@mobileL': {
            padding: 'Z A'
        },
        AppMicroLabel: {
            color: 'title',
            text: (el, s)=>el.call('onboardingWorkspaceName', s.root) || ''
        },
        AppCapsuleBtnGhost: {
            hideDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            // nothing to skip on the last step, Fly's ready screen or the build
            // board (the board's way on is its own foot)
            hide: (el, s)=>{
                const flow = s.root && s.root._onboardingFlow;
                return !flow || flow.step === 'done' || flow.step === 'ready' || flow.step === 'build';
            },
            text: '{{ workspace.onboarding.chat.skipSetup | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingSkip');
            }
        }
    },
    // THE STAGE — the one scroll area; the step's column sits in its middle.
    WizardStage: {
        flex: '1 1 auto',
        minHeight: '0',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 'C',
        boxSizing: 'border-box',
        padding: 'A C B',
        '@tabletS': {
            gap: '0',
            padding: 'A B B'
        },
        '@mobileL': {
            padding: 'Z A B'
        },
        OnboardingStudio: {},
        WizardColumn: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'B',
            width: '100%',
            flex: '1 1 0',
            maxWidth: 'overlayLg',
            minWidth: '0',
            // centred while it is shorter than the stage, scrolling from the top
            // once it is taller (auto margins never clip the start)
            margin: 'auto 0',
            OnboardingJourney: {},
            // The record is still being read: the name and one calm line.
            WizardHold: {
                hideDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow
                ],
                hide: (el, s)=>!!(s.root && s.root._onboardingFlow),
                tag: 'p',
                margin: '0',
                textAlign: 'center',
                fontSize: 'Z2',
                color: 'inactive',
                text: '{{ workspace.onboarding.wizard.preparing | polyglot }}'
            },
            WizardHead: {
                hideDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow
                ],
                hide: (el, s)=>!(s.root && s.root._onboardingFlow),
                display: 'flex',
                flexDirection: 'column',
                gap: 'Z',
                minWidth: '0',
                MobileMark: {
                    display: 'none',
                    '@tabletS': {
                        display: 'flex'
                    },
                    hideDeps: [
                        (el, s)=>s.root && s.root._onboardingFlow
                    ],
                    hide: (el, s)=>![
                            'welcome',
                            'done',
                            'ready',
                            'build'
                        ].includes(s.root?._onboardingFlow?.step),
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxSize: 'avatarLg',
                    round: 'radiusCard',
                    marginBottom: 'Y',
                    theme: 'common-box',
                    backgroundImage: 'linear-gradient(135deg, color-mix(in srgb, var(--color-blue) 20%, transparent), color-mix(in srgb, var(--color-purple) 20%, transparent))',
                    ariaHidden: 'true',
                    Icon: {
                        name: 'magicstar',
                        boxSize: 'avatarXs',
                        color: 'title'
                    }
                },
                AppMicroLabel: {
                    hideDeps: [
                        (el, s)=>s.root && s.root._onboardingFlow
                    ],
                    hide: (el, s)=>!(el.call('onboardingWizardAt', s.root) || {}).n,
                    textDeps: [
                        (el, s)=>s.root && s.root._onboardingFlow
                    ],
                    text: (el, s)=>{
                        const at = el.call('onboardingWizardAt', s.root) || {};
                        return String(el.call('polyglot', 'workspace.onboarding.wizard.progress') || '').replace('{n}', String(at.n)).replace('{total}', String(at.total));
                    }
                },
                // The step's name — the dialog's title, an `h2` like the kit's
                // AppDialogTitle (the surface is a modal over the page; it never sits
                // in a pane). It takes the focus when the surface opens (the layer
                // focuses its `[autofocus]` first — the first control would be Skip)
                // and on every step change (onboardingWizardFocus), so a screen
                // reader reads where the person is. A heading is not a control: it
                // wears no focus ring (the kit's ring is a box-shadow on
                // `[tabindex]:focus-visible`).
                WizardTitle: {
                    tag: 'h2',
                    id: 'onboardingWizardTitle',
                    tabindex: '-1',
                    autofocus: true,
                    margin: '0',
                    fontSize: 'E',
                    '@mobileL': {
                        fontSize: 'F'
                    },
                    fontWeight: '500',
                    lineHeight: '1.1',
                    color: 'title',
                    overflowWrap: 'break-word',
                    ':focus': {
                        outline: 'none',
                        boxShadow: 'none'
                    },
                    textDeps: [
                        (el, s)=>s.root && s.root._onboardingFlow
                    ],
                    text: (el, s)=>{
                        const flow = s.root && s.root._onboardingFlow || {};
                        const KEYS = {
                            work: 'workspace.onboarding.wizard.workTitle',
                            stack: 'workspace.onboarding.wizard.stackTitle',
                            idea: 'workspace.onboarding.wizard.ideaTitle',
                            apps: 'workspace.onboarding.wizard.appsTitle',
                            look: 'workspace.onboarding.wizard.lookTitle',
                            home: 'workspace.onboarding.wizard.homeTitle',
                            done: 'workspace.onboarding.wizard.doneTitle',
                            ready: 'workspace.onboarding.ready.title',
                            assistant: 'workspace.onboarding.chat.title'
                        };
                        // the build board names the workspace it sets up
                        if (flow.step === 'build') return el.call('onboardingText', el.call('onboardingWorkspaceName', s.root) ? 'workspace.pobBuild.title' : 'workspace.pobBuild.titleNoName');
                        if (KEYS[flow.step]) return el.call('onboardingText', KEYS[flow.step]);
                        return el.call('onboardingFirstName', s.root) ? el.call('onboardingText', 'workspace.onboarding.welcomeTitle') : el.call('onboardingText', 'workspace.onboarding.welcomeTitleNoName');
                    }
                },
                WizardLead: {
                    tag: 'p',
                    margin: '0',
                    fontSize: 'A',
                    '@mobileL': {
                        fontSize: 'Z2'
                    },
                    lineHeight: '1.5',
                    color: 'inactive',
                    overflowWrap: 'break-word',
                    textDeps: [
                        (el, s)=>s.root && s.root._onboardingFlow
                    ],
                    text: (el, s)=>{
                        const flow = s.root && s.root._onboardingFlow || {};
                        if (flow.step === 'assistant') return el.call('onboardingProgress', s.root) || '';
                        // the build board: each card is a step the sign-up really did
                        if (flow.step === 'build') return el.call('onboardingText', 'workspace.pobBuild.lead');
                        // Fly's ready screen: Fly set up the workspace WITH the person
                        if (flow.step === 'ready') return el.call('onboardingText', el.call('onboardingWorkspaceName', s.root) ? 'workspace.onboarding.ready.lead' : 'workspace.onboarding.ready.leadNoName');
                        // Your apps speaks of the picked preset, or of the person's own
                        // apps for Something else
                        const custom = (flow.picks && flow.picks.work || '') === 'custom';
                        const KEYS = {
                            work: 'workspace.onboarding.wizard.workLead',
                            stack: custom ? 'workspace.onboarding.wizard.stackLeadCustom' : 'workspace.onboarding.wizard.stackLead',
                            idea: 'workspace.onboarding.wizard.ideaLead',
                            apps: 'workspace.onboarding.wizard.appsLead',
                            look: 'workspace.onboarding.wizard.lookLead',
                            home: 'workspace.onboarding.wizard.homeLead',
                            done: 'workspace.onboarding.wizard.doneLead'
                        };
                        return el.call('onboardingText', KEYS[flow.step] || 'workspace.onboarding.welcomeLead');
                    }
                }
            },
            OnboardingLesson: {},
            OnboardingWelcomeStep: {},
            OnboardingWorkStep: {},
            OnboardingStackStep: {},
            OnboardingIdeaStep: {},
            OnboardingAppsStep: {},
            OnboardingLookStep: {},
            OnboardingHomeStep: {},
            OnboardingDoneStep: {},
            OnboardingReadyStep: {},
            OnboardingBuildStep: {},
            OnboardingChat: {
                hideDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow
                ],
                hide: (el, s)=>{
                    const flow = s.root && s.root._onboardingFlow;
                    return !(flow && flow.step === 'assistant');
                }
            }
        }
    },
    // THE FOOT — Back and Continue on the click steps (Skip where a step can be
    // passed by: Your work with no pick, Your idea with no sentence); the
    // conversation's Start working — Build my app with an idea — once its last
    // question is answered. The foot stays on
    // screen (the stage scrolls above it); its row lines up with the step's
    // column, so on a wide screen the buttons sit under the tiles they act on,
    // not in the screen's far corners.
    // On the build board the foot is its way on — "Open my workspace", once
    // every step has an outcome (or the board's poll window passed): a bar that
    // stays on screen while the cards scroll (the phone's sticky bar).
    WizardFoot: {
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow,
            (el, s)=>s.root && s.root._pobBuild
        ],
        hide: (el, s)=>{
            const flow = s.root && s.root._onboardingFlow;
            if (!flow) return true;
            if (flow.step === 'assistant') return false;
            if (flow.step === 'build') return !(el.call('onboardingBuildView', s.root) || {}).ctaShown;
            return [
                'work',
                'stack',
                'idea',
                'apps',
                'look',
                'home'
            ].indexOf(flow.step) === -1;
        },
        display: 'flex',
        justifyContent: 'center',
        gap: 'C',
        flexShrink: '0',
        boxSizing: 'border-box',
        padding: 'A C',
        '@tabletS': {
            gap: '0',
            padding: 'A B'
        },
        '@mobileL': {
            padding: 'Z A'
        },
        FootSpacer: {
            flex: '1 1 0',
            width: '100%',
            maxWidth: 'overlayMd',
            ariaHidden: 'true',
            '@tabletS': {
                display: 'none'
            }
        },
        FootRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'A',
            width: '100%',
            flex: '1 1 0',
            maxWidth: 'overlayLg',
            minWidth: '0',
            AppCapsuleBtnGhost: {
                // the build board has no step to go back to
                hideDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow
                ],
                hide: (el, s)=>(s.root && s.root._onboardingFlow || {}).step === 'build',
                text: '{{ workspace.onboarding.wizard.back | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('onboardingWizardGo', -1);
                }
            },
            // the build board's line beside its way on: "Your workspace is ready",
            // or that some steps still run (its poll window passed)
            FootReady: {
                tag: 'p',
                role: 'status',
                flex: '1 1 auto',
                minWidth: '0',
                margin: '0',
                fontSize: 'Z2',
                fontWeight: '500',
                lineHeight: '1.4',
                color: 'title',
                overflowWrap: 'break-word',
                hideDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow,
                    (el, s)=>s.root && s.root._pobBuild
                ],
                hide: (el, s)=>(s.root && s.root._onboardingFlow || {}).step !== 'build' || !(el.call('onboardingBuildView', s.root) || {}).footText,
                textDeps: [
                    (el, s)=>s.root && s.root._pobBuild,
                    (el, s)=>s.root && s.root.lang
                ],
                text: (el, s)=>(el.call('onboardingBuildView', s.root) || {}).footText || ''
            },
            AppCapsuleBtnPrimary: {
                hideDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow
                ],
                hide: (el, s)=>{
                    const flow = s.root && s.root._onboardingFlow || {};
                    // the conversation shows its finish only after its last question
                    return flow.step === 'assistant' && !!(flow.ask || !(flow.turns && flow.turns.length));
                },
                textDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow,
                    (el, s)=>s.root && s.root._workspacePresets
                ],
                text: (el, s)=>{
                    const flow = s.root && s.root._onboardingFlow || {};
                    if (flow.step === 'build') return el.call('polyglot', 'workspace.pobBuild.open');
                    if (flow.step === 'assistant') return el.call('polyglot', el.call('onboardingIdeaOf', s.root) ? 'workspace.onboarding.wizard.buildIdea' : 'workspace.onboarding.chat.finish');
                    return el.call('polyglot', el.call('onboardingFootNext', s.root) || 'workspace.onboarding.wizard.next');
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const flow = s.root && s.root._onboardingFlow || {};
                    // the build board's way on: a plain close (it decides done, via
                    // 'pob', because the board settled)
                    if (flow.step === 'build') el.call('closeOnboarding', 'close');
                    else if (flow.step !== 'assistant') el.call('onboardingWizardGo', 1);
                    else if (el.call('onboardingIdeaOf', s.root)) el.call('onboardingWizardFinish', 'build');
                    else el.call('closeOnboarding', 'close');
                }
            }
        }
    }
};
const $7734bfba47fc687e$export$41ed7fe07bd1f169 = {
    wizardStep: '',
    display: 'flex',
    flexDirection: 'column',
    gap: 'B',
    minWidth: '0',
    hideDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    hide: (el, s)=>{
        const flow = s.root && s.root._onboardingFlow;
        return !(flow && flow.step === el.wizardStep);
    }
};
const $7734bfba47fc687e$export$bce7a3866da3d379 = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'welcome',
    WelcomeStart: {
        display: 'flex',
        minWidth: '0',
        AppCapsuleBtnPrimary: {
            width: '100%',
            padding: 'A B',
            text: '{{ workspace.onboarding.wizard.start | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingChoose', 'wizard');
            }
        }
    },
    WelcomeWays: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Y',
        minWidth: '0',
        AppMicroLabel: {
            text: '{{ workspace.onboarding.wizard.otherWays | polyglot }}'
        },
        OnboardingWay_assistant: {
            way: 'assistant',
            icon: 'magicstar',
            heading: 'workspace.onboarding.wayAssistant',
            hint: 'workspace.onboarding.wayAssistantHint'
        },
        OnboardingWay_tour: {
            way: 'tour',
            icon: 'playOval',
            heading: 'workspace.onboarding.wayTour',
            hint: 'workspace.onboarding.wayTourHint'
        }
    },
    WelcomeLanguage: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        text: (el, s)=>{
            const lang = el.call('onboardingLanguage', s.root) || {};
            const choice = (lang.choices || []).find((c)=>c.value === lang.current);
            return el.call('onboardingText', 'workspace.onboarding.chat.languageSet', {
                language: choice ? choice.label : lang.current || ''
            });
        }
    },
    WelcomeReplay: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        text: '{{ workspace.onboarding.replayHint | polyglot }}'
    }
};
const $7734bfba47fc687e$export$d507c8febf01c1aa = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'apps',
    AppsBar: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'Z',
        minWidth: '0',
        AppsCount: {
            tag: 'span',
            fontSize: 'Z1',
            color: 'inactive',
            textDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            text: (el, s)=>{
                const apps = el.call('onboardingWizardApps', s.root) || [];
                return String(el.call('polyglot', 'workspace.onboarding.wizard.appsCount') || '').replace('{n}', String(apps.filter((a)=>a.picked).length)).replace('{total}', String(apps.length));
            }
        },
        AppsActions: {
            display: 'flex',
            gap: 'Y',
            AppCapsuleBtnGhost_all: {
                extends: 'AppCapsuleBtnGhost',
                text: '{{ workspace.onboarding.wizard.appsAll | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('onboardingWizardAllApps', true);
                }
            },
            AppCapsuleBtnGhost_none: {
                extends: 'AppCapsuleBtnGhost',
                text: '{{ workspace.onboarding.wizard.appsNone | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('onboardingWizardAllApps', false);
                }
            }
        }
    },
    // Rows wide enough for an app's whole name ("Infrastructure", or longer in
    // Georgian): two columns in the column, one on a phone.
    OnboardingTileGrid: {
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F2)), 1fr))',
        childExtends: 'OnboardingAppTile',
        childrenDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        children: (el, s)=>el.call('onboardingWizardApps', s.root) || []
    }
};
const $7734bfba47fc687e$export$21121ac047072882 = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'look',
    OnboardingWizardGroup: {
        caption: 'workspace.personalize.theme',
        OnboardingTileGrid: {
            childExtends: 'OnboardingChoiceTile',
            children: ()=>[
                    {
                        key: 'theme-light',
                        question: 'theme',
                        value: 'light',
                        label: 'workspace.personalize.themeLight',
                        preview: 'light'
                    },
                    {
                        key: 'theme-dark',
                        question: 'theme',
                        value: 'dark',
                        label: 'workspace.personalize.themeDark',
                        preview: 'dark'
                    },
                    {
                        key: 'theme-auto',
                        question: 'theme',
                        value: 'auto',
                        label: 'workspace.personalize.themeAuto',
                        hint: 'workspace.onboarding.wizard.themeAutoHint',
                        preview: 'auto'
                    }
                ]
        }
    },
    OnboardingWizardGroup_1: {
        caption: 'workspace.personalize.background',
        if: (el)=>(el.call('homeSkyChoices') || []).some((c)=>c && c.value !== 'none'),
        OnboardingTileGrid: {
            childExtends: 'OnboardingWizardSky',
            children: (el)=>(el.call('homeSkyChoices') || []).map((c)=>({
                        key: 'sky-' + c.key,
                        value: c.value,
                        label: c.label
                    }))
        }
    }
};
const $7734bfba47fc687e$export$5252df6f32753c5b = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'home',
    OnboardingWizardGroup_preset: {
        caption: 'workspace.onboarding.preset.caption',
        OnboardingTileGrid: {
            childExtends: 'OnboardingPresetTile',
            children: ()=>[
                    {
                        key: 'focus',
                        value: 'focus',
                        summary: 'brief',
                        preview: 'brief',
                        label: 'workspace.onboarding.preset.focus',
                        hint: 'workspace.onboarding.preset.focusHint'
                    },
                    {
                        key: 'overview',
                        value: 'overview',
                        summary: 'signals',
                        preview: 'signals',
                        label: 'workspace.onboarding.preset.overview',
                        hint: 'workspace.onboarding.preset.overviewHint'
                    }
                ]
        }
    },
    OnboardingWizardGroup_1: {
        caption: 'workspace.personalize.appStrip',
        OnboardingTileGrid: {
            childExtends: 'OnboardingChoiceTile',
            children: ()=>[
                    {
                        key: 'strip-dock',
                        question: 'strip',
                        value: 'dock',
                        label: 'workspace.onboarding.chat.stripDock',
                        hint: 'workspace.onboarding.chat.stripDockHint',
                        preview: 'dock'
                    },
                    {
                        key: 'strip-rail',
                        question: 'strip',
                        value: 'rail',
                        label: 'workspace.onboarding.chat.stripRail',
                        hint: 'workspace.onboarding.chat.stripRailHint',
                        preview: 'rail'
                    },
                    {
                        key: 'strip-off',
                        question: 'strip',
                        value: 'off',
                        label: 'workspace.onboarding.chat.stripOff',
                        hint: 'workspace.onboarding.chat.stripOffHint',
                        preview: 'off'
                    }
                ]
        }
    }
};
const $7734bfba47fc687e$export$567caf671b2a8e15 = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'done',
    OnboardingSetupLines: {},
    DoneIdea: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'paragraph',
        overflowWrap: 'break-word',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        hide: (el, s)=>!el.call('onboardingIdeaOf', s.root),
        textDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        text: (el, s)=>String(el.call('polyglot', 'workspace.onboarding.wizard.doneIdea') || '').replace('{idea}', el.call('onboardingIdeaOf', s.root) || '')
    },
    OnboardingRecap: {},
    DoneStart: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'Z',
        minWidth: '0',
        AppCapsuleBtnPrimary: {
            width: '100%',
            padding: 'A B',
            textDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            text: (el, s)=>el.call('polyglot', el.call('onboardingIdeaOf', s.root) ? 'workspace.onboarding.wizard.buildIdea' : 'workspace.onboarding.chat.finish'),
            onClick: (e, el, s)=>{
                e.stopPropagation();
                el.call('onboardingWizardFinish', el.call('onboardingIdeaOf', s.root) ? 'build' : 'home');
            }
        },
        AppCapsuleBtnGhost: {
            width: '100%',
            hideDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            hide: (el, s)=>!el.call('onboardingIdeaOf', s.root),
            text: '{{ workspace.onboarding.chat.finish | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingWizardFinish', 'home');
            }
        }
    },
    DoneWays: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Y',
        minWidth: '0',
        OnboardingWay_tour: {
            icon: 'playOval',
            heading: 'workspace.onboarding.wayTour',
            hint: 'workspace.onboarding.wayTourHint',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingWizardFinish', 'tour');
            }
        },
        OnboardingWay_assistant: {
            icon: 'magicstar',
            heading: 'workspace.onboarding.chat.askLabel',
            hint: 'workspace.onboarding.tour.composerText',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingWizardFinish', 'assistant');
            }
        }
    }
};
const $7734bfba47fc687e$export$1a4e212492829621 = {
    tag: 'section',
    caption: '',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    minWidth: '0',
    GroupCaption: {
        tag: 'h3',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        text: (el)=>el.call('polyglot', el.parent.caption || '')
    }
};
const $7734bfba47fc687e$export$a5cc7f6f44dcd0ee = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-E1)), 1fr))',
    gap: 'Z',
    minWidth: '0',
    childrenAs: 'state'
};
const $7734bfba47fc687e$export$30a12c51cd1cfd02 = {
    tag: 'button',
    type: 'button',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 'Z',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'A',
    border: 'none',
    round: 'radiusCard',
    theme: 'common-box',
    color: 'title',
    textAlign: 'start',
    cursor: 'pointer',
    transition: 'background-color A defaultBezier, transform Z defaultBezier',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        transform: 'scale(0.98)'
    },
    '&[aria-pressed="true"]': {
        background: 'selected'
    },
    '&[aria-pressed="true"] .onboarding-tile-check': {
        opacity: '1',
        transform: 'none'
    },
    TileCheck: {
        class: 'onboarding-tile-check',
        position: 'absolute',
        top: 'Y',
        right: 'Y',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSize: 'B',
        round: 'radiusPill',
        theme: 'primary',
        opacity: '0',
        transform: 'scale(0.6)',
        transition: 'opacity A defaultBezier, transform A defaultBezier',
        ariaHidden: 'true',
        Icon: {
            name: 'checkmark',
            boxSize: 'iconSm'
        }
    },
    TileWords: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'W',
        minWidth: '0',
        TileLabel: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            lineHeight: '1.35',
            color: 'title',
            overflowWrap: 'break-word',
            text: (el, s)=>el.call('polyglot', s && s.label || s && s.title || '')
        },
        TileHint: {
            tag: 'span',
            hide: (el, s)=>!(s && s.hint),
            fontSize: 'Z',
            lineHeight: '1.45',
            color: 'inactive',
            overflowWrap: 'break-word',
            text: (el, s)=>el.call('polyglot', s && s.hint || '')
        }
    }
};
const $7734bfba47fc687e$export$694043c3c399ddec = {
    extends: 'OnboardingTile',
    ariaPressedDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    ariaPressed: (el, s)=>s && el.call('onboardingWizardCurrent', s.question) === s.value ? 'true' : 'false',
    // The Rail steps aside on a phone (components/HomeAppRail.js), so a phone
    // is never offered it.
    '@mobileL': {
        '&[data-preview="rail"]': {
            display: 'none'
        }
    },
    dataPreview: (el, s)=>s && s.preview || null,
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s && s.question) el.call('onboardingWizardPick', s.question, s.value);
    },
    OnboardingPreview: {
        order: '-1'
    }
};
const $7734bfba47fc687e$export$82a60b95313f8937 = {
    extends: 'OnboardingTile',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'Z',
    ariaPressedDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    ariaPressed: (el, s)=>s && s.picked ? 'true' : 'false',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s && s.id) el.call('onboardingWizardToggleApp', s.id);
    },
    AppGlyphTile: {
        order: '-1'
    },
    TileWords: {
        flex: '1 1 auto'
    },
    TileCheck: {
        position: 'static',
        order: '1',
        flexShrink: '0',
        theme: 'transparent'
    }
};
const $7734bfba47fc687e$export$4d5cd0a48c6fc43f = {
    extends: 'HomeSkyTile',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s && s.value) el.call('onboardingWizardPick', 'sky', s.value);
    }
};
const $7734bfba47fc687e$export$da4d4165de906dde = {
    position: 'relative',
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: 'D',
    overflow: 'hidden',
    round: 'radiusControl',
    theme: 'document',
    ariaHidden: 'true',
    // THEME — a window: a bar on top, two lines; Auto is half each.
    PreviewWindow: {
        if: (el, s)=>!!s && [
                'light',
                'dark',
                'auto'
            ].indexOf(s.preview) !== -1,
        display: 'flex',
        flex: '1 1 auto',
        minWidth: '0',
        OnboardingPreviewPane: {
            if: (el, s)=>s.preview !== 'dark',
            background: 'white',
            Bar: {
                background: 'black.06'
            },
            LineA: {
                background: 'black.12'
            },
            LineB: {
                background: 'black.06'
            }
        },
        OnboardingPreviewPane_1: {
            if: (el, s)=>s.preview !== 'light',
            background: 'black',
            Bar: {
                background: 'white.12'
            },
            LineA: {
                background: 'white.18'
            },
            LineB: {
                background: 'white.12'
            }
        }
    },
    // SUMMARY — the Brief's two calm lines, or the Signals' four tiles.
    PreviewBrief: {
        if: (el, s)=>!!s && s.preview === 'brief',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 'Y',
        flex: '1 1 auto',
        padding: 'Z A',
        LineA: {
            height: 'Y',
            width: '80%',
            round: 'radiusPill',
            background: 'line'
        },
        LineB: {
            height: 'Y',
            width: '55%',
            round: 'radiusPill',
            background: 'line'
        }
    },
    PreviewSignals: {
        if: (el, s)=>!!s && s.preview === 'signals',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        alignItems: 'center',
        gap: 'Y',
        flex: '1 1 auto',
        padding: 'Z',
        childExtends: 'OnboardingPreviewCell',
        Cell_1: {},
        Cell_2: {},
        Cell_3: {},
        Cell_4: {}
    },
    // STRIP — the apps in a row above the board, in a column beside it, or
    // not at all.
    PreviewStrip: {
        if: (el, s)=>!!s && [
                'dock',
                'rail',
                'off'
            ].indexOf(s.preview) !== -1,
        display: 'flex',
        flexDirection: (el, s)=>s.preview === 'rail' ? 'row' : 'column',
        gap: 'Y',
        flex: '1 1 auto',
        padding: 'Y',
        StripCapsule: {
            if: (el, s)=>s.preview !== 'off',
            display: 'flex',
            flexDirection: (el, s)=>s.preview === 'rail' ? 'column' : 'row',
            alignItems: 'center',
            alignSelf: (el, s)=>s.preview === 'rail' ? 'stretch' : 'center',
            gap: 'X',
            padding: 'X',
            round: 'radiusPill',
            background: 'selected',
            childExtends: 'OnboardingPreviewDot',
            Dot_1: {},
            Dot_2: {},
            Dot_3: {},
            Dot_4: {}
        },
        StripBoard: {
            flex: '1 1 auto',
            minWidth: '0',
            round: 'radiusControl',
            background: 'line'
        }
    }
};
const $7734bfba47fc687e$export$c02e9401787e0c9f = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'X',
    flex: '1 1 0',
    minWidth: '0',
    padding: 'Y',
    Bar: {
        height: 'Y',
        width: '100%',
        round: 'radiusPill'
    },
    LineA: {
        height: 'X',
        width: '70%',
        round: 'radiusPill'
    },
    LineB: {
        height: 'X',
        width: '45%',
        round: 'radiusPill'
    }
};
const $7734bfba47fc687e$export$ccf309feb0b41ea0 = {
    height: 'B',
    round: 'radiusControl',
    background: 'line'
};
const $7734bfba47fc687e$export$83f3acb9fdbd6170 = {
    boxSize: 'Y',
    round: 'radiusPill',
    background: 'caption'
};
const $7734bfba47fc687e$export$f7a0b0f3ac9c429c = {
    tag: 'button',
    type: 'button',
    way: '',
    icon: '',
    heading: '',
    hint: '',
    display: 'flex',
    alignItems: 'center',
    gap: 'A',
    width: '100%',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'Z1 A',
    border: 'none',
    round: 'radiusCard',
    theme: 'layer',
    color: 'title',
    textAlign: 'start',
    cursor: 'pointer',
    transition: 'background-color A defaultBezier, transform Z defaultBezier',
    ':hover': {
        background: 'selected'
    },
    ':active': {
        background: 'selected',
        transform: 'scale(0.99)'
    },
    onClick: (e, el)=>{
        e.stopPropagation();
        el.call('onboardingChoose', el.way);
    },
    WayGlyph: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        boxSize: 'avatarSm',
        round: 'radiusControl',
        theme: 'dialog',
        color: 'title',
        Icon: {
            name: (el)=>el.parent.parent.icon || 'star',
            boxSize: 'iconMd'
        }
    },
    WayWords: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'W',
        flex: '1 1 auto',
        minWidth: '0',
        WayName: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            lineHeight: '1.4',
            color: 'title',
            overflowWrap: 'break-word',
            text: (el)=>el.call('polyglot', el.parent.parent.heading || '')
        },
        WayHint: {
            tag: 'span',
            fontSize: 'Z',
            lineHeight: '1.45',
            color: 'inactive',
            overflowWrap: 'break-word',
            text: (el)=>el.call('polyglot', el.parent.parent.hint || '')
        }
    },
    Icon: {
        name: 'chevronRight',
        boxSize: 'iconSm',
        flexShrink: '0',
        color: 'caption'
    }
};
const $7734bfba47fc687e$export$1edf552dd5f182a9 = {
    tag: 'ol',
    class: 'onboarding-journey',
    ariaLabel: (el)=>el.call('polyglot', 'workspace.onboarding.journey.label'),
    hideDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    hide: (el, s)=>!s.root?._onboardingFlow || [
            'assistant',
            'ready',
            'build'
        ].includes(s.root._onboardingFlow.step),
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'Y A',
    padding: '0',
    margin: '0',
    listStyle: 'none',
    childrenAs: 'state',
    childExtends: 'OnboardingJourneyStop',
    childrenDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    children: (el, s)=>el.call('onboardingWizardJourney', s.root) || []
};
const $7734bfba47fc687e$export$e139857aa9d40197 = {
    tag: 'li',
    display: 'flex',
    alignItems: 'center',
    gap: 'Y',
    fontSize: 'Z',
    color: 'caption',
    ariaCurrent: (el, s)=>s.status === 'current' ? 'step' : null,
    '&[aria-current="step"]': {
        color: 'title',
        fontWeight: '700'
    },
    // the side this stop opens — "For the workspace" before the three choices,
    // "For you" before the person's own steps (onboardingWizardJourney)
    JourneySide: {
        tag: 'span',
        hide: (el, s)=>!s.sideLabel,
        fontSize: 'Z',
        fontWeight: '500',
        color: 'title',
        text: (el, s)=>s.sideLabel ? el.call('polyglot', s.sideLabel) : ''
    },
    Number: {
        tag: 'span',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSize: 'avatarXs',
        round: 'radiusPill',
        theme: (el, s)=>s.status === 'current' ? 'primary' : 'layer',
        text: (el, s)=>s.status === 'complete' ? '' : String(s.number),
        Icon: {
            if: (el, s)=>s.status === 'complete',
            name: 'checkmark',
            boxSize: 'iconXs'
        }
    },
    Text: {
        text: (el, s)=>el.call('polyglot', s.label)
    }
};
const $7734bfba47fc687e$export$c8ff14cb2d77ebd2 = {
    hideDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    hide: (el, s)=>{
        const step = s.root?._onboardingFlow?.step;
        return !step || step === 'work' || step === 'stack' || step === 'idea' || step === 'ready' || step === 'build';
    },
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'Z',
    minWidth: '0',
    Icon: {
        boxSize: 'iconMd',
        flexShrink: '0',
        color: 'caption',
        nameDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        name: (el, s)=>el.call('onboardingWizardLesson', s.root).icon
    },
    Text: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z1',
        lineHeight: '1.5',
        color: 'caption',
        textDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        text: (el, s)=>{
            const key = el.call('onboardingWizardLesson', s.root).text;
            return key ? el.call('polyglot', key) : '';
        }
    }
};
const $7734bfba47fc687e$export$85475e5fd2dd6 = {
    extends: 'OnboardingTile',
    ariaPressedDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    ariaPressed: (el, s)=>el.call('onboardingWizardCurrent', 'summary') === s.summary && el.call('onboardingWizardCurrent', 'strip') === 'dock' ? 'true' : 'false',
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('onboardingWizardPreset', s.value);
    },
    OnboardingPreview: {
        order: '-1'
    }
};
const $7734bfba47fc687e$export$f8f16878ff6c7e21 = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'Y',
    childrenAs: 'state',
    childExtends: 'OnboardingRecapItem',
    childrenDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    children: (el)=>{
        const theme = el.call('onboardingWizardCurrent', 'theme');
        const summary = el.call('onboardingWizardCurrent', 'summary');
        const strip = el.call('onboardingWizardCurrent', 'strip');
        return [
            {
                key: 'theme',
                label: theme === 'light' ? 'workspace.personalize.themeLight' : theme === 'dark' ? 'workspace.personalize.themeDark' : 'workspace.personalize.themeAuto'
            },
            {
                key: 'summary',
                label: summary === 'signals' ? 'workspace.personalize.summarySignals' : 'workspace.personalize.summaryBrief'
            },
            {
                key: 'strip',
                label: strip === 'off' ? 'workspace.onboarding.chat.stripOff' : strip === 'rail' ? 'workspace.onboarding.chat.stripRail' : 'workspace.onboarding.chat.stripDock'
            }
        ];
    }
};
const $7734bfba47fc687e$export$ffc279c8be1210a7 = {
    display: 'flex',
    alignItems: 'center',
    gap: 'Y',
    padding: 'Y Z',
    round: 'radiusPill',
    theme: 'layer',
    color: 'title',
    fontSize: 'Z1',
    Icon: {
        name: 'checkmark',
        boxSize: 'iconXs'
    },
    Text: {
        text: (el, s)=>el.call('polyglot', s.label)
    }
};
const $7734bfba47fc687e$export$9e0155ab5c2b30b8 = {
    hideDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    hide: (el, s)=>!s.root?._onboardingFlow || s.root._onboardingFlow.step === 'build',
    class: 'onboarding-studio',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 'B',
    flex: '1 1 0',
    width: '100%',
    maxWidth: 'overlayMd',
    minWidth: '0',
    margin: 'auto 0',
    padding: 'B',
    boxSizing: 'border-box',
    round: 'radiusSheet',
    theme: 'common-box',
    position: 'relative',
    overflow: 'hidden',
    '@tabletS': {
        display: 'none'
    },
    Aura: {
        position: 'absolute',
        inset: '0',
        pointerEvents: 'none',
        ariaHidden: 'true',
        backgroundImage: 'radial-gradient(ellipse at 10% 0%, color-mix(in srgb, var(--color-blue) 24%, transparent), transparent 65%), radial-gradient(ellipse at 100% 40%, color-mix(in srgb, var(--color-purple) 24%, transparent), transparent 65%)'
    },
    Intro: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 'Z',
        AppMicroLabel: {
            text: '{{ workspace.onboarding.studio.eyebrow | polyglot }}',
            color: 'title'
        },
        Title: {
            text: '{{ workspace.onboarding.studio.title | polyglot }}',
            whiteSpace: 'pre-line',
            fontSize: 'E',
            fontWeight: '500',
            lineHeight: '1.1',
            color: 'title',
            maxWidth: '100%'
        }
    },
    Preview: {
        position: 'relative',
        class: 'onboarding-live-preview',
        ariaHidden: 'true',
        display: 'flex',
        flexDirection: 'column',
        gap: 'A',
        padding: 'A',
        round: 'radiusCard',
        theme: 'document',
        minWidth: '0',
        dataSummaryDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        dataSummary: (el)=>el.call('onboardingWizardCurrent', 'summary'),
        dataStripDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        dataStrip: (el)=>el.call('onboardingWizardCurrent', 'strip'),
        '&[data-summary="signals"] .onboarding-preview-brief': {
            display: 'none'
        },
        '&[data-summary="brief"] .onboarding-preview-signals': {
            display: 'none'
        },
        '&[data-strip="off"] .onboarding-preview-apps': {
            display: 'none'
        },
        '&[data-strip="rail"] .onboarding-preview-board': {
            flexDirection: 'row'
        },
        '&[data-strip="rail"] .onboarding-preview-apps': {
            flexDirection: 'column'
        },
        Header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'Z',
            Text: {
                text: (el, s)=>el.call('onboardingWorkspaceName', s.root),
                fontSize: 'Z',
                color: 'caption',
                overflowWrap: 'anywhere'
            },
            Icon: {
                name: 'search',
                boxSize: 'iconSm',
                color: 'caption',
                flexShrink: '0'
            }
        },
        Greeting: {
            text: (el, s)=>el.call('onboardingText', el.call('onboardingFirstName', s.root) ? 'workspace.onboarding.welcomeTitle' : 'workspace.onboarding.welcomeTitleNoName'),
            fontSize: 'A',
            fontWeight: '500',
            color: 'title'
        },
        Brief: {
            class: 'onboarding-preview-brief',
            display: 'flex',
            flexDirection: 'column',
            gap: 'Y',
            OnboardingPreviewLine: {
                width: '90%'
            },
            OnboardingPreviewLine_1: {
                width: '65%'
            }
        },
        Signals: {
            class: 'onboarding-preview-signals',
            display: 'grid',
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            gap: 'Y',
            OnboardingPreviewCell: {},
            OnboardingPreviewCell_1: {},
            OnboardingPreviewCell_2: {},
            OnboardingPreviewCell_3: {}
        },
        Board: {
            class: 'onboarding-preview-board',
            display: 'flex',
            flexDirection: 'column',
            gap: 'Z',
            minWidth: '0',
            Apps: {
                class: 'onboarding-preview-apps',
                display: 'flex',
                gap: 'Y',
                minWidth: '0',
                childrenAs: 'state',
                childExtends: 'OnboardingPreviewApp',
                childrenDeps: [
                    (el, s)=>s.root && s.root._onboardingFlow
                ],
                children: (el, s)=>(el.call('onboardingWizardApps', s.root) || []).filter((a)=>a.picked).slice(0, 4)
            },
            Cards: {
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                gap: 'Y',
                flex: '1 1 auto',
                minWidth: '0',
                OnboardingPreviewCard: {},
                OnboardingPreviewCard_1: {}
            }
        },
        Prompt: {
            display: 'flex',
            alignItems: 'center',
            gap: 'Y',
            theme: 'common-box',
            padding: 'Z',
            round: 'radiusPill',
            Icon: {
                name: 'magicstar',
                boxSize: 'iconSm',
                color: 'caption'
            },
            Text: {
                text: '{{ workspace.onboarding.studio.prompt | polyglot }}',
                fontSize: 'Z',
                color: 'caption'
            }
        }
    },
    Caption: {
        tag: 'div',
        textAlign: 'start',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: 'Y',
        Title: {
            fontSize: 'A',
            fontWeight: '500',
            color: 'title',
            textDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            text: (el, s)=>el.call('polyglot', el.call('onboardingWizardLesson', s.root).title)
        },
        Text: {
            text: '{{ workspace.onboarding.studio.caption | polyglot }}',
            fontSize: 'Z1',
            lineHeight: '1.5',
            color: 'caption'
        }
    }
};
const $7734bfba47fc687e$export$5b129e9870bf7c88 = {
    height: 'Y',
    width: '75%',
    round: 'radiusPill',
    background: 'line'
};
const $7734bfba47fc687e$export$7ec3e321dd6ed58a = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    padding: 'Z',
    round: 'radiusControl',
    theme: 'common-box',
    OnboardingPreviewLine: {
        width: '55%'
    },
    OnboardingPreviewLine_1: {},
    OnboardingPreviewLine_2: {
        width: '90%'
    }
};
const $7734bfba47fc687e$export$86718d9d3f8f01e3 = {
    extends: 'AppGlyphTile',
    boxSize: 'avatarSm',
    minWidth: 'avatarSm'
};

});

parcelRegister("5Qn9t", function(module, exports) {

$parcel$export(module.exports, "OnboardingWorkStep", () => $4413c486e76c2266$export$d23d20404f71ec06);
$parcel$export(module.exports, "OnboardingWorkTile", () => $4413c486e76c2266$export$2fd8d52e4858602f);
$parcel$export(module.exports, "OnboardingAppGlyph", () => $4413c486e76c2266$export$7ef530c4d49bc805);
$parcel$export(module.exports, "OnboardingWorkStatus", () => $4413c486e76c2266$export$8e6e9fa7e356bb3d);
// YOUR WORK — the first of the welcome's three choices on the setup surface
// (components/OnboardingWizard.js; functions/onboardingPresets.js; wt/presets
// CONTRACT §1: "At most ONE screen per choice; every choice has a visible
// default; plain words + app icons, never a feature table"). An industry IS a
// Workspace Preset; "Something else" is a custom workspace.
//
// The wizard's own parts: the step extends OnboardingWizardStep, the tiles
// OnboardingTile (toggle buttons with `aria-pressed`, the plain tick when
// pressed). Surfaces differ by fill, never by a border. Every value comes
// from functions/onboardingPresets.js through `el.call`; every factory names
// the root keys it follows (`…Deps`), so it re-runs when the registry, the
// catalog or the apply lands.
// YOUR WORK — the featured presets and Something else. While the registry is
// read: one calm line; after a failed read: the line and Try again (Something
// else stays). A workspace set up already, or this flow's own apply, shows ONE
// row instead — what it is set up for, ✓ once done — and Continue.
const $4413c486e76c2266$export$d23d20404f71ec06 = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'work',
    // THE FIRST WORKSPACE'S NAME (round 2 BLOCKER #5, elena-r2 + sam-r2): a
    // direct sign-up names the workspace it already has — the one with the
    // sign-up credits — instead of a "Create team's workspace" dialog that made
    // a second, empty one. Shows the stored name until the person types; the
    // name is written when Your work is left forward or the welcome closes
    // (functions/onboardingPresets.js onboardingNameSave). Enter goes on, like
    // the idea field.
    AppField: {
        label: (el)=>el.call('polyglot', 'workspace.createOrg.nameLabel'),
        AppInput: {
            type: 'text',
            name: 'onboardingWorkspaceName',
            autocomplete: 'organization',
            maxlength: 60,
            enterkeyhint: 'next',
            ariaLabel: (el)=>el.call('polyglot', 'workspace.createOrg.nameLabel'),
            valueDeps: [
                (el, s)=>s.root && s.root._onboardingFlow,
                (el, s)=>s.root && s.root.workspace
            ],
            value: (el, s)=>el.call('onboardingNameOf', s.root) || '',
            onInput: (e, el)=>el.call('onboardingNameSet', e.target && e.target.value || ''),
            onKeydown: (e, el)=>{
                if (e.key !== 'Enter' || e.isComposing) return;
                e.preventDefault();
                e.stopPropagation();
                el.call('onboardingWizardGo', 1);
            }
        }
    },
    OnboardingWorkStatus: {
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow,
            (el, s)=>s.root && s.root._presetApply,
            (el, s)=>s.root && s.root.workspace
        ],
        hide: (el, s)=>(el.call('onboardingWorkView', s.root) || {}).state === 'tiles'
    },
    WorkNote: {
        tag: 'p',
        role: 'status',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        hideDeps: [
            (el, s)=>s.root && s.root._workspacePresets,
            (el, s)=>s.root && s.root._workspacePresetsError
        ],
        hide: (el, s)=>{
            const view = el.call('onboardingWorkView', s.root) || {};
            return view.state !== 'tiles' || !(view.loading || view.failed);
        },
        textDeps: [
            (el, s)=>s.root && s.root._workspacePresetsError
        ],
        text: (el, s)=>el.call('polyglot', (el.call('onboardingWorkView', s.root) || {}).failed ? 'marketplace.preset.loadFailed' : 'workspace.onboarding.work.loading')
    },
    AppCapsuleBtnGhost: {
        compact: true,
        alignSelf: 'flex-start',
        hideDeps: [
            (el, s)=>s.root && s.root._workspacePresets,
            (el, s)=>s.root && s.root._workspacePresetsError
        ],
        hide: (el, s)=>!(el.call('onboardingWorkView', s.root) || {}).failed,
        text: '{{ marketplace.preset.tryAgain | polyglot }}',
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('workspacePresetsLoad', true);
        }
    },
    // Two columns (2 × 2: three featured presets and Something else, then the
    // more tile across both) — wide enough for a name on one line, symmetric;
    // one column on a phone. "More kinds of work" opens the rest of the
    // registry in the same grid (an even count again: the registry's ten).
    OnboardingTileGrid: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        '@mobileL': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        },
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        hide: (el, s)=>(el.call('onboardingWorkView', s.root) || {}).state !== 'tiles',
        childExtends: 'OnboardingWorkTile',
        childrenDeps: [
            (el, s)=>s.root && s.root._onboardingFlow,
            (el, s)=>s.root && s.root._workspacePresets
        ],
        children: (el, s)=>el.call('onboardingWorkTiles', s.root) || []
    }
};
const $4413c486e76c2266$export$2fd8d52e4858602f = {
    extends: 'OnboardingTile',
    isMore: (el, s)=>!!(s && s.more),
    '.isMore': {
        gridColumn: '1 / -1'
    },
    ariaPressedDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    ariaPressed: (el, s)=>s && s.more ? null : s && s.picked ? 'true' : 'false',
    ariaExpanded: (el, s)=>s && s.more ? 'false' : null,
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s && s.more) el.call('onboardingWorkMore');
        else if (s && s.value) el.call('onboardingWorkPick', s.value, {
            toggle: true
        });
    },
    // The icon row ends before the pick mark's corner (OnboardingTile's
    // TileCheck: `right: 'Y'`, `boxSize: 'B'`, over the tile's `A` padding), so
    // no icon sits under the mark — reserved always, pressed or not.
    WorkGlyphs: {
        order: '-1',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'X',
        minWidth: '0',
        paddingRight: 'B',
        ariaHidden: 'true',
        childExtends: 'OnboardingAppGlyph',
        childrenAs: 'state',
        childrenDeps: [
            (el, s)=>s.root && s.root._wsAppsCatalog,
            (el, s)=>s.root && s.root._workspacePresets
        ],
        children: (el, s)=>el.call('onboardingWorkGlyphs', s && s.value, s && s.root) || []
    }
};
const $4413c486e76c2266$export$7ef530c4d49bc805 = {
    extends: 'AppGlyphTile',
    boxSize: 'avatarXs',
    minWidth: 'avatarXs',
    ariaHidden: 'true',
    title: (el, s)=>s && s.title || null,
    Icon: {
        boxSize: 'iconSm'
    }
};
const $4413c486e76c2266$export$8e6e9fa7e356bb3d = {
    role: 'status',
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'A',
    round: 'radiusCard',
    theme: 'layer',
    color: 'title',
    StatusMark: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        boxSize: 'B',
        round: 'radiusPill',
        theme: 'primary',
        ariaHidden: 'true',
        hideDeps: [
            (el, s)=>s.root && s.root._presetApply,
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        hide: (el, s)=>!(el.call('onboardingWorkView', s.root) || {}).done,
        Icon: {
            name: 'checkmark',
            boxSize: 'iconSm'
        }
    },
    StatusWords: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'W',
        minWidth: '0',
        StatusTitle: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            lineHeight: '1.35',
            color: 'title',
            overflowWrap: 'break-word',
            textDeps: [
                (el, s)=>s.root && s.root._presetApply,
                (el, s)=>s.root && s.root._onboardingFlow,
                (el, s)=>s.root && s.root.workspace
            ],
            text: (el, s)=>(el.call('onboardingWorkView', s.root) || {}).title || ''
        },
        StatusHint: {
            tag: 'span',
            fontSize: 'Z',
            lineHeight: '1.45',
            color: 'inactive',
            overflowWrap: 'break-word',
            hideDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            hide: (el, s)=>!(el.call('onboardingWorkView', s.root) || {}).hint,
            textDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            text: (el, s)=>(el.call('onboardingWorkView', s.root) || {}).hint || ''
        }
    }
};

});

parcelRegister("cnATX", function(module, exports) {

$parcel$export(module.exports, "OnboardingStackStep", () => $903441e8245c90dc$export$1918ade03703fbbd);
$parcel$export(module.exports, "OnboardingStackTile", () => $903441e8245c90dc$export$88596af901aa1b3);
$parcel$export(module.exports, "OnboardingSetupLines", () => $903441e8245c90dc$export$3debef94aac6ad05);
$parcel$export(module.exports, "OnboardingLineList", () => $903441e8245c90dc$export$e6871364cfbd3ea3);
$parcel$export(module.exports, "OnboardingSetupLine", () => $903441e8245c90dc$export$28c3a779a93a92f7);
// YOUR APPS — the second of the welcome's three choices on the setup surface
// (components/OnboardingWizard.js; functions/onboardingPresets.js; wt/presets
// CONTRACT §1: "Every step that writes shows its own line, and every failure
// is a line with a retry") — and those lines: OnboardingSetupLines, also on
// the done step and in the conversation.
//
// The app rows are the wizard's own (OnboardingAppTile: the calm glyph, the
// name, the plain tick once picked). Every value comes from
// functions/onboardingPresets.js through `el.call`; every factory names the
// root keys it follows (`…Deps`).
// YOUR APPS — before the apply is sent: the apps as toggle rows (two columns
// wide enough for a whole name, one on a phone), their count, the apps the
// catalog does not carry yet counted under the grid, and a quiet link to find
// more in the App Store. Once sent: the apply's own lines.
const $903441e8245c90dc$export$1918ade03703fbbd = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'stack',
    StackBar: {
        display: 'flex',
        alignItems: 'center',
        minWidth: '0',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow,
            (el, s)=>s.root && s.root._wsAppsCatalog
        ],
        hide: (el, s)=>{
            const flow = s.root && s.root._onboardingFlow || {};
            return !!flow.stackSent || !(el.call('onboardingStackView', s.root) || {}).total;
        },
        StackCount: {
            tag: 'span',
            fontSize: 'Z1',
            color: 'inactive',
            textDeps: [
                (el, s)=>s.root && s.root._onboardingFlow,
                (el, s)=>s.root && s.root._wsAppsCatalog
            ],
            text: (el, s)=>(el.call('onboardingStackView', s.root) || {}).countText || ''
        }
    },
    StackNote: {
        tag: 'p',
        role: 'status',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow,
            (el, s)=>s.root && s.root._wsAppsCatalogLoaded
        ],
        hide: (el, s)=>{
            const flow = s.root && s.root._onboardingFlow || {};
            const view = el.call('onboardingStackView', s.root) || {};
            return !!flow.stackSent || !!view.total || view.ready && !view.custom;
        },
        textDeps: [
            (el, s)=>s.root && s.root._wsAppsCatalogLoaded
        ],
        text: (el, s)=>el.call('polyglot', (el.call('onboardingStackView', s.root) || {}).ready ? 'workspace.onboarding.stack.none' : 'workspace.onboarding.stack.loading')
    },
    OnboardingTileGrid: {
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F2)), 1fr))',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        hide: (el, s)=>!!(s.root && s.root._onboardingFlow || {}).stackSent,
        childExtends: 'OnboardingStackTile',
        childrenDeps: [
            (el, s)=>s.root && s.root._onboardingFlow,
            (el, s)=>s.root && s.root._wsAppsCatalog,
            (el, s)=>s.root && s.root.workspace
        ],
        children: (el, s)=>(el.call('onboardingStackView', s.root) || {}).rows || []
    },
    StackSoon: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow,
            (el, s)=>s.root && s.root._wsAppsCatalog
        ],
        hide: (el, s)=>{
            const flow = s.root && s.root._onboardingFlow || {};
            return !!flow.stackSent || !(el.call('onboardingStackView', s.root) || {}).soon;
        },
        textDeps: [
            (el, s)=>s.root && s.root._wsAppsCatalog
        ],
        text: (el, s)=>(el.call('onboardingStackView', s.root) || {}).soonText || ''
    },
    // the quiet way to more apps — a preset's or your own (it ends the welcome:
    // what is picked here is sent first)
    AppCapsuleBtnGhost: {
        compact: true,
        alignSelf: 'flex-start',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        hide: (el, s)=>!!(s.root && s.root._onboardingFlow || {}).stackSent,
        text: '{{ workspace.onboarding.stack.browse | polyglot }}',
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('onboardingWizardFinish', 'store');
        }
    },
    OnboardingSetupLines: {}
};
const $903441e8245c90dc$export$88596af901aa1b3 = {
    extends: 'OnboardingAppTile',
    ariaPressedDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    ariaPressed: (el, s)=>s && s.picked ? 'true' : 'false',
    ariaDisabled: (el, s)=>s && !s.toggleable ? 'true' : null,
    '&[aria-disabled="true"]': {
        cursor: 'default'
    },
    '&[aria-disabled="true"]:hover': {
        background: 'selected'
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s && s.toggleable) el.call('onboardingStackToggle', s.id);
    },
    // The app's one line from its listing, under its name (persona round 3,
    // W3: elena — "22 app tiles show one word only, no description"); its mark
    // (Installed / Suggested) after it.
    TileWords: {
        TileHint: {
            order: '2'
        },
        TileDescr: {
            tag: 'span',
            order: '1',
            hide: (el, s)=>!(s && s.descr),
            fontSize: 'Z',
            lineHeight: '1.45',
            color: 'caption',
            overflowWrap: 'break-word',
            text: (el, s)=>s && s.descr || ''
        }
    }
};
const $903441e8245c90dc$export$3debef94aac6ad05 = {
    tag: 'section',
    ariaLive: 'polite',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    minWidth: '0',
    hideDeps: [
        (el, s)=>s.root && s.root._onboardingFlow,
        (el, s)=>s.root && s.root._presetApply,
        (el, s)=>s.root && s.root._wsAppsCatalog
    ],
    hide: (el, s)=>!(el.call('onboardingSetupView', s.root) || {}).show,
    SetupTitle: {
        tag: 'h3',
        margin: '0',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'title',
        textDeps: [
            (el, s)=>s.root && s.root._presetApply,
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        text: (el, s)=>(el.call('onboardingSetupView', s.root) || {}).title || ''
    },
    OnboardingLineList: {
        childrenDeps: [
            (el, s)=>s.root && s.root._presetApply,
            (el, s)=>s.root && s.root._wsAppsCatalog
        ],
        children: (el, s)=>(el.call('onboardingSetupView', s.root) || {}).lines || []
    },
    SetupSoon: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        hideDeps: [
            (el, s)=>s.root && s.root._presetApply
        ],
        hide: (el, s)=>!(el.call('onboardingSetupView', s.root) || {}).soonText,
        textDeps: [
            (el, s)=>s.root && s.root._presetApply
        ],
        text: (el, s)=>(el.call('onboardingSetupView', s.root) || {}).soonText || ''
    },
    SetupMade: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        hideDeps: [
            (el, s)=>s.root && s.root._presetApply
        ],
        hide: (el, s)=>!(el.call('onboardingSetupView', s.root) || {}).setupText,
        textDeps: [
            (el, s)=>s.root && s.root._presetApply
        ],
        text: (el, s)=>(el.call('onboardingSetupView', s.root) || {}).setupText || ''
    },
    SetupError: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'dangerInk',
        hideDeps: [
            (el, s)=>s.root && s.root._presetApply
        ],
        hide: (el, s)=>!(el.call('onboardingSetupView', s.root) || {}).errorText,
        textDeps: [
            (el, s)=>s.root && s.root._presetApply
        ],
        text: (el, s)=>(el.call('onboardingSetupView', s.root) || {}).errorText || ''
    },
    AppCapsuleBtnGhost: {
        compact: true,
        alignSelf: 'flex-start',
        hideDeps: [
            (el, s)=>s.root && s.root._presetApply
        ],
        hide: (el, s)=>!(el.call('onboardingSetupView', s.root) || {}).retryable,
        text: '{{ marketplace.preset.tryAgain | polyglot }}',
        onClick: (e, el)=>{
            e.stopPropagation();
            el.call('onboardingStackRetry');
        }
    }
};
const $903441e8245c90dc$export$e6871364cfbd3ea3 = {
    tag: 'ul',
    margin: '0',
    padding: '0',
    listStyle: 'none',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F2)), 1fr))',
    gap: 'Y Z',
    minWidth: '0',
    childExtends: 'OnboardingSetupLine',
    childrenAs: 'state'
};
const $903441e8245c90dc$export$28c3a779a93a92f7 = {
    tag: 'li',
    display: 'flex',
    alignItems: 'center',
    gap: 'Z',
    minWidth: '0',
    minHeight: 'controlHCompact',
    OnboardingAppGlyph: {},
    LineName: {
        tag: 'span',
        flex: '1 1 auto',
        minWidth: '0',
        fontSize: 'Z2',
        fontWeight: '500',
        lineHeight: '1.3',
        color: 'title',
        overflowWrap: 'anywhere',
        text: (el, s)=>s && s.title || ''
    },
    LineState: {
        tag: 'span',
        display: 'flex',
        alignItems: 'center',
        gap: 'X',
        flexShrink: '0',
        fontSize: 'Z1',
        lineHeight: '1.3',
        color: (el, s)=>s && s.failed ? 'dangerInk' : 'caption',
        Icon: {
            name: 'checkmark',
            boxSize: 'iconXs',
            hide: (el, s)=>!(s && s.done)
        },
        LineStateText: {
            tag: 'span',
            text: (el, s)=>s && s.stateKey ? el.call('polyglot', s.stateKey) : ''
        }
    }
};

});

parcelRegister("cv2QW", function(module, exports) {

$parcel$export(module.exports, "OnboardingIdeaStep", () => $919a97d04576a72f$export$e8c20dbf596d8aec);
$parcel$export(module.exports, "OnboardingIdeaChip", () => $919a97d04576a72f$export$1676466282773909);
// YOUR IDEA — the third of the welcome's three choices on the setup surface
// (components/OnboardingWizard.js; functions/onboardingPresets.js; wt/presets
// CONTRACT §1): one optional sentence that becomes an app built by the
// workspace's app builder (`/add-app`, the idea waiting in the builder's park —
// never in the URL) once the welcome ends.
// YOUR IDEA — one optional sentence for the app builder (the field: Enter
// goes on, a new line is a space), three examples that fill it, and one line
// on what happens next. With no sentence the foot's forward word is Skip.
const $919a97d04576a72f$export$e8c20dbf596d8aec = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'idea',
    AppTextarea: {
        name: 'onboardingIdea',
        rows: '2',
        maxlength: '200',
        autocomplete: 'off',
        enterkeyhint: 'next',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.onboarding.idea.label'),
        placeholder: (el)=>el.call('polyglot', 'workspace.onboarding.idea.placeholder'),
        valueDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        value: (el, s)=>{
            const flow = s.root && s.root._onboardingFlow || {};
            return flow.picks && flow.picks.idea || '';
        },
        onInput: (e, el)=>el.call('onboardingIdeaSet', e.target && e.target.value || ''),
        onKeydown: (e, el)=>{
            if (e.key !== 'Enter' || e.shiftKey || e.isComposing) return;
            e.preventDefault();
            e.stopPropagation();
            el.call('onboardingWizardGo', 1);
        }
    },
    IdeaExamples: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Y',
        minWidth: '0',
        AppMicroLabel: {
            text: '{{ workspace.onboarding.idea.examples | polyglot }}'
        },
        IdeaChips: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 'Y',
            minWidth: '0',
            childExtends: 'OnboardingIdeaChip',
            childrenAs: 'state',
            children: (el)=>el.call('onboardingIdeaExamples') || []
        }
    },
    IdeaNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        text: '{{ workspace.onboarding.idea.note | polyglot }}'
    }
};
const $919a97d04576a72f$export$1676466282773909 = {
    extends: 'AppCapsuleBtnToolbar',
    compact: true,
    onClick: (e, el, s)=>{
        e.stopPropagation();
        if (s && s.label) el.call('onboardingIdeaSet', el.call('polyglot', s.label));
    },
    ChipLabel: {
        tag: 'span',
        text: (el, s)=>el.call('polyglot', s && s.label || '')
    }
};

});

parcelRegister("gFIOG", function(module, exports) {

$parcel$export(module.exports, "OnboardingReadyStep", () => $c2333d4baadea539$export$d7fc7885b21d1bc);
$parcel$export(module.exports, "OnboardingReadyMade", () => $c2333d4baadea539$export$4a40bc73761c51a1);
// FLY'S READY SCREEN — the one step a person who signed up through Fly meets on
// the welcome's setup surface (components/OnboardingWizard.js;
// functions/onboardingReady.js tells who, what and when it writes; Nika
// 2026-10-25: "Short ready screen (Recommended)"). Fly asked the three
// questions already, so this is not a wizard: the surface's title says the
// workspace is ready, its lead says Fly set it up with the person, and the
// step lists what is ready — the workspace's apps and its website project —
// then the two ways on: Start working (a plain close) and the quick tour.
//
// All of it is the wizard's own: the shell, the studio beside it, the title
// and lead, the setup lines (OnboardingSetupLine — the apply's lines of Your
// apps, here a name and a tick), the way row (OnboardingWay — the welcome's tour
// offer) and the brand's primary capsule. Every value comes from
// functions/onboardingReady.js through `el.call`; every factory names the root
// key it follows (`…Deps`). The facts are frozen in the flow when the surface
// opens, so nothing arrives under a reading person (Rule 66).
// THE STEP — what is ready, Start working, the tour.
const $c2333d4baadea539$export$d7fc7885b21d1bc = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'ready',
    OnboardingReadyMade: {},
    // A plain close: Escape's own path (closeOnboarding 'close' decides done,
    // via 'fly', because the screen showed).
    ReadyStart: {
        display: 'flex',
        minWidth: '0',
        AppCapsuleBtnPrimary: {
            width: '100%',
            padding: 'A B',
            text: '{{ workspace.onboarding.chat.finish | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('closeOnboarding', 'close');
            }
        }
    },
    // The tour offer — the welcome's own row (OnboardingWay → onboardingChoose
    // 'tour': decides done, via 'tour', closes, starts the tour).
    ReadyWays: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'Y',
        minWidth: '0',
        OnboardingWay_tour: {
            way: 'tour',
            icon: 'playOval',
            heading: 'workspace.onboarding.wayTour',
            hint: 'workspace.onboarding.wayTourHint'
        }
    }
};
const $c2333d4baadea539$export$4a40bc73761c51a1 = {
    extends: 'OnboardingWizardGroup',
    caption: 'workspace.onboarding.ready.made',
    hideDeps: [
        (el, s)=>s.root && s.root._onboardingFlow
    ],
    hide: (el, s)=>!(el.call('onboardingReadyView', s.root) || {}).show,
    OnboardingLineList: {
        childrenDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        children: (el, s)=>(el.call('onboardingReadyView', s.root) || {}).rows || []
    },
    ReadyMore: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.5',
        color: 'inactive',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        hide: (el, s)=>!(el.call('onboardingReadyView', s.root) || {}).moreText,
        textDeps: [
            (el, s)=>s.root && s.root._onboardingFlow
        ],
        text: (el, s)=>(el.call('onboardingReadyView', s.root) || {}).moreText || ''
    }
};

});

parcelRegister("9VHfZ", function(module, exports) {

$parcel$export(module.exports, "OnboardingBuildStep", () => $73aafdd601e65184$export$9f021a35e6d92c01);
$parcel$export(module.exports, "OnboardingBuildList", () => $73aafdd601e65184$export$467da13d01f69be6);
$parcel$export(module.exports, "OnboardingBuildCard", () => $73aafdd601e65184$export$a1b79a239d82cf48);
// THE BUILD BOARD — the one step a personalized sign-up (POB) meets on the
// welcome's setup surface (components/OnboardingWizard.js;
// functions/onboardingBuild.js tells who, what and when it writes; PLAN §7b-2,
// decision 9 of 2026-10-25: the setup steps show IN the workspace). The
// surface's title says which workspace is set up, its lead says each card is a
// real step, and the step lists the cards: one per server step, each with its
// state (the plain tick once done, a spinner while it runs, a warning when it
// failed, a dash when it was skipped), its name, one result line — a skipped
// step says why — and, when it made something, the way to it. A failed step
// says "Not done" and offers Try again (owner / admin). The way on, "Open my
// workspace", is the surface's foot.
//
// A live region: each card's change is read out as it lands. Kept mounted and
// only hidden (Rule 66): the cards grow in place, the list never jumps. Every
// value comes from functions/onboardingBuild.js through `el.call`; every
// factory names the root key it follows (`…Deps`).
// THE STEP — the cards, then one plain note (a refused Try again, or the poll
// window passed while a step still runs).
const $73aafdd601e65184$export$9f021a35e6d92c01 = {
    extends: 'OnboardingWizardStep',
    wizardStep: 'build',
    gap: 'A',
    OnboardingBuildList: {},
    BuildNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z1',
        lineHeight: '1.5',
        color: 'caption',
        overflowWrap: 'break-word',
        hideDeps: [
            (el, s)=>s.root && s.root._pobBuild
        ],
        hide: (el, s)=>!(el.call('onboardingBuildView', s.root) || {}).noteText,
        textDeps: [
            (el, s)=>s.root && s.root._pobBuild,
            (el, s)=>s.root && s.root.lang
        ],
        text: (el, s)=>(el.call('onboardingBuildView', s.root) || {}).noteText || ''
    }
};
const $73aafdd601e65184$export$467da13d01f69be6 = {
    tag: 'ul',
    ariaLive: 'polite',
    margin: '0',
    padding: '0',
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    minWidth: '0',
    childExtends: 'OnboardingBuildCard',
    childrenAs: 'state',
    childrenDeps: [
        (el, s)=>s.root && s.root._pobBuild,
        (el, s)=>s.root && s.root.lang
    ],
    children: (el, s)=>(el.call('onboardingBuildView', s.root) || {}).rows || []
};
const $73aafdd601e65184$export$a1b79a239d82cf48 = {
    tag: 'li',
    dataBuildStep: (el, s)=>s && s.step || null,
    dataBuildStatus: (el, s)=>s && s.status || null,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'Z',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'Z1 A',
    round: 'radiusCard',
    theme: 'layer',
    color: 'title',
    BuildMark: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        boxSize: 'avatarXs',
        ariaHidden: 'true',
        Icon: {
            hide: (el, s)=>!s || s.running === true,
            name: (el, s)=>s && s.icon || 'clock',
            boxSize: 'iconSm',
            color: (el, s)=>s && s.failed === true ? 'dangerInk' : s && s.done === true ? 'title' : 'caption'
        },
        LoadingSpinner: {
            hide: (el, s)=>!s || s.running !== true,
            boxSize: 'iconSm',
            color: 'caption'
        }
    },
    BuildWords: {
        display: 'flex',
        flexDirection: 'column',
        gap: 'X',
        flex: '1 1 auto',
        minWidth: '0',
        BuildName: {
            tag: 'span',
            fontSize: 'Z2',
            fontWeight: '500',
            lineHeight: '1.3',
            color: 'title',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.title || ''
        },
        BuildResult: {
            tag: 'span',
            fontSize: 'Z1',
            lineHeight: '1.45',
            color: (el, s)=>s && s.failed === true ? 'dangerInk' : 'caption',
            overflowWrap: 'anywhere',
            text: (el, s)=>s && s.resultText || ''
        },
        BuildPart: {
            tag: 'span',
            fontSize: 'Z1',
            lineHeight: '1.45',
            color: 'caption',
            overflowWrap: 'anywhere',
            hide: (el, s)=>!(s && s.partText),
            text: (el, s)=>s && s.partText || ''
        },
        BuildActions: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 'Z',
            minWidth: '0',
            hide: (el, s)=>!s || !(s.retryable === true || s.linkHref),
            AppCapsuleBtnGhost: {
                dataBuildAction: 'retry',
                compact: true,
                hide: (el, s)=>!s || s.retryable !== true,
                disabled: (el, s)=>!!(s && s.retrying === true),
                text: '{{ marketplace.preset.tryAgain | polyglot }}',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('onboardingBuildRetry', s && s.step);
                }
            },
            AppCapsuleBtnToolbar: {
                dataBuildAction: 'open',
                compact: true,
                hide: (el, s)=>!(s && s.linkHref),
                text: (el, s)=>s && s.linkText || '',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('onboardingBuildGo', s && s.linkHref);
                }
            }
        }
    }
};

});

parcelRegister("5xAyL", function(module, exports) {

$parcel$export(module.exports, "OnboardingChat", () => $408c64cd3a7eda9d$export$4580ced8d2d60e66);
$parcel$export(module.exports, "OnboardingTurn", () => $408c64cd3a7eda9d$export$f720b14719f55987);
$parcel$export(module.exports, "OnboardingChoice", () => $408c64cd3a7eda9d$export$90452cc58c092a3b);
$parcel$export(module.exports, "OnboardingOption", () => $408c64cd3a7eda9d$export$454b51a236c210d8);
$parcel$export(module.exports, "OnboardingSkyChoice", () => $408c64cd3a7eda9d$export$87f406df0ee4df3b);
$parcel$export(module.exports, "OnboardingAsk", () => $408c64cd3a7eda9d$export$33be872bec0cea2b);
// THE SETUP CONVERSATION — the new-account welcome's assistant path, drawn on
// the setup surface (components/OnboardingWizard.js shows it at the
// 'assistant' step; functions/onboarding.js onboardingChat* drive it). The
// same choices as the wizard's click steps (one plan, `onboardingPlan`), asked
// one at a time; every answer applies at once.
//
// Built from the D2 kit: the tonal capsule answers (AppCapsuleBtnToolbar), the
// Personalise panel's own sky tile (HomeSkyTile), the kit's input group for
// the ask field. Surfaces differ by fill, never by a border.
// ── The conversation ────────────────────────────────────────────────────────
// THE SHEET'S BUDGET: the answers and the ask field keep their size and the
// thread is the part that gives way — on a short window the sky grid pushed
// the ask field below the sheet's fold (live on dev 57290d93f at 757px).
const $408c64cd3a7eda9d$export$4580ced8d2d60e66 = {
    display: 'flex',
    flexDirection: 'column',
    gap: 'A',
    flex: '1 1 auto',
    minWidth: '0',
    minHeight: '0',
    // The lines so far. A reversed column keeps the newest line in view with no
    // scrolling code (the fly rail's scroller). It is as tall as its lines, up
    // to a cap, then scrolls — a fixed block size left an empty band above the
    // first two lines (live on dev 76305a52b) — and it shrinks before anything
    // else in the sheet does, down to two lines.
    OnboardingThread: {
        role: 'log',
        ariaLive: 'polite',
        ariaLabel: (el)=>el.call('polyglot', 'workspace.onboarding.chat.title'),
        display: 'flex',
        flexDirection: 'column-reverse',
        flex: '0 1 auto',
        maxHeight: '40dvh',
        minHeight: 'D',
        minWidth: '0',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        ThreadLines: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'Z1',
            minWidth: '0',
            childExtends: 'OnboardingTurn',
            childrenAs: 'state',
            childrenDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            children: (el, s)=>{
                const flow = s.root && s.root._onboardingFlow;
                return (flow && flow.turns || []).map((t)=>({
                        ...t,
                        key: t.id
                    }));
            }
        }
    },
    // What Your work's answer sets up — the apply's own lines, while it runs and
    // after (components/OnboardingStackStep.js).
    OnboardingSetupLines: {
        flexShrink: '0'
    },
    // The answers to the question being asked: chips, described options or the
    // skies, then the question's own skip.
    OnboardingAnswers: {
        hide: (el, s)=>!el.call('onboardingQuestion', s.root),
        display: 'flex',
        flexDirection: 'column',
        gap: 'Z',
        flexShrink: '0',
        minWidth: '0',
        AnswerChips: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 'Y',
            minWidth: '0',
            childExtends: 'OnboardingChoice',
            childrenAs: 'state',
            children: (el, s)=>{
                const q = el.call('onboardingQuestion', s.root);
                if (!q || q.kind) return [];
                return (q.choices || []).map((c)=>({
                        ...c,
                        key: q.id + '-' + c.value
                    }));
            }
        },
        AnswerOptions: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F)), 1fr))',
            gap: 'Y',
            minWidth: '0',
            childExtends: 'OnboardingOption',
            childrenAs: 'state',
            children: (el, s)=>{
                const q = el.call('onboardingQuestion', s.root);
                if (!q || q.kind !== 'option') return [];
                return (q.choices || []).map((c)=>({
                        ...c,
                        key: q.id + '-' + c.value
                    }));
            }
        },
        AnswerSkies: {
            role: 'group',
            ariaLabel: (el)=>el.call('polyglot', 'workspace.personalize.background'),
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            gap: 'Y',
            minWidth: '0',
            childExtends: 'OnboardingSkyChoice',
            childrenAs: 'state',
            children: (el, s)=>{
                const q = el.call('onboardingQuestion', s.root);
                if (!q || q.kind !== 'sky') return [];
                return (q.choices || []).map((c)=>({
                        ...c,
                        key: 'sky-' + c.value
                    }));
            }
        },
        AppCapsuleBtnGhost: {
            compact: true,
            alignSelf: 'flex-start',
            hide: (el, s)=>{
                const q = el.call('onboardingQuestion', s.root);
                return !q || !q.skip;
            },
            text: (el, s)=>{
                const q = el.call('onboardingQuestion', s.root);
                return el.call('polyglot', q && q.skip || 'workspace.onboarding.chat.skipQuestion');
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingChatSkip');
            }
        }
    },
    OnboardingAsk: {}
};
const $408c64cd3a7eda9d$export$f720b14719f55987 = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'Z',
    minWidth: '0',
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationFillMode: 'backwards',
    isMine: (el, s)=>s.from === 'me',
    '.isMine': {
        justifyContent: 'flex-end'
    },
    TurnGlyph: {
        hide: (el, s)=>s.from === 'me',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        boxSize: 'avatarXs',
        round: 'radiusPill',
        theme: 'layer',
        color: 'title',
        ariaHidden: 'true',
        Icon: {
            name: 'magicstar',
            boxSize: 'iconXs'
        }
    },
    TurnWords: {
        tag: 'p',
        margin: '0',
        minWidth: '0',
        maxWidth: '100%',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'title',
        overflowWrap: 'break-word',
        lang: (el, s)=>s.lang || null,
        text: (el, s)=>el.call('onboardingText', s.line),
        isMine: (el, s)=>s.from === 'me',
        '.isMine': {
            maxWidth: '80%',
            padding: 'Y2 Z2',
            round: 'B B Y B',
            background: 'selected',
            color: 'title'
        }
    }
};
const $408c64cd3a7eda9d$export$90452cc58c092a3b = {
    extends: 'AppCapsuleBtnToolbar',
    gap: 'Y',
    onRender: (el)=>el.call('onboardingFocusAnswer', el),
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('onboardingChatAnswer', s.value);
    },
    Icon: {
        if: (el, s)=>!!s.icon,
        name: (el, s)=>s.icon || 'star',
        boxSize: 'iconSm'
    },
    ChoiceLabel: {
        tag: 'span',
        lang: (el, s)=>s.lang || null,
        text: (el, s)=>el.call('polyglot', s.label || '')
    }
};
const $408c64cd3a7eda9d$export$454b51a236c210d8 = {
    tag: 'button',
    type: 'button',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'W',
    minWidth: '0',
    boxSizing: 'border-box',
    padding: 'Z A',
    border: 'none',
    round: 'radiusCard',
    theme: 'layer',
    color: 'title',
    textAlign: 'start',
    cursor: 'pointer',
    transition: 'background-color A defaultBezier, transform Z defaultBezier',
    ':hover': {
        background: 'selected'
    },
    ':active': {
        background: 'selected',
        transform: 'scale(0.99)'
    },
    onRender: (el)=>el.call('onboardingFocusAnswer', el),
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('onboardingChatAnswer', s.value);
    },
    OptionName: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '500',
        lineHeight: '1.4',
        overflowWrap: 'break-word',
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    OptionHint: {
        tag: 'span',
        fontSize: 'Z',
        lineHeight: '1.45',
        color: 'caption',
        overflowWrap: 'break-word',
        text: (el, s)=>el.call('polyglot', s.hint || '')
    }
};
const $408c64cd3a7eda9d$export$87f406df0ee4df3b = {
    extends: 'HomeSkyTile',
    onRender: (el)=>el.call('onboardingFocusAnswer', el),
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('onboardingChatAnswer', s.value);
    }
};
const $408c64cd3a7eda9d$export$33be872bec0cea2b = {
    tag: 'form',
    novalidate: true,
    state: {
        draft: ''
    },
    display: 'flex',
    alignItems: 'center',
    gap: 'Y',
    flexShrink: '0',
    minWidth: '0',
    onSubmit: (e, el, s)=>{
        e.preventDefault();
        const text = String(s.draft || '').trim();
        if (!text) return;
        s.update({
            draft: ''
        });
        el.call('onboardingChatTyped', text);
    },
    AppInputGroup: {
        flex: '1 1 auto',
        AppInputBare: {
            type: 'text',
            name: 'onboardingAsk',
            autocomplete: 'off',
            enterkeyhint: 'send',
            ariaLabelDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            ariaLabel: (el, s)=>{
                const q = el.call('onboardingQuestion', s.root);
                return el.call('polyglot', q && q.typed ? 'workspace.onboarding.idea.label' : 'workspace.onboarding.chat.askLabel');
            },
            placeholderDeps: [
                (el, s)=>s.root && s.root._onboardingFlow
            ],
            placeholder: (el, s)=>{
                const q = el.call('onboardingQuestion', s.root);
                return el.call('onboardingText', q && q.typed ? 'workspace.onboarding.idea.placeholder' : 'workspace.onboarding.chat.askPlaceholder');
            },
            value: (el, s)=>s.draft || '',
            onInput: (e, el, s)=>s.update({
                    draft: String(e.target && e.target.value || '')
                })
        }
    },
    CompactIconButton: {
        type: 'submit',
        theme: 'primary',
        icon: 'arrowRight',
        disabled: (el, s)=>!String(s.draft || '').trim() || null,
        ariaLabel: (el)=>el.call('polyglot', 'workspace.onboarding.chat.askSend'),
        title: (el)=>el.call('polyglot', 'workspace.onboarding.chat.askSend')
    }
};

});

parcelRegister("bAk8Z", function(module, exports) {

$parcel$export(module.exports, "OnboardingTour", () => $86f2aeb0136abec2$export$b315d9fb3d4e3c88);
$parcel$export(module.exports, "OnboardingTourShade", () => $86f2aeb0136abec2$export$ead14fb78d9004bb);
$parcel$export(module.exports, "OnboardingTourCard", () => $86f2aeb0136abec2$export$1228c02709edce51);
// THE QUICK TOUR's layer (functions/onboardingTour.js has the stops and the
// state). Mounted by app.js only while `root._onboardingTour` is set.
//
// A modal layer in place (`inertOutside`): the page behind is inert and dims,
// a window over the current stop's element lets it show through, and a card
// beside it says what it is — counter, name, one line, then Skip tour / Back /
// Next (Done on the closing card). Escape and Close end the tour; the arrow
// keys walk it. The card is a named dialog (role, aria-modal, labelled by its
// name, described by its line) and keeps the focus on its Next button.
//
// GEOMETRY. The layer publishes the stop's box as custom properties
// (onboardingTourVars) and every position is CSS over them: four sides of the
// house veil (`backdrop`) round the box plus a gap, a ring on the gap; the
// card sits below a target in the upper half of the viewport and above one in
// the lower half (`data-side`), its left edge clamped to the viewport so it
// never spills. Nothing is measured but the target. THE GAP is `Y`, or the
// box's room to the nearest screen edge when that is less (`--tour-gap`): the
// header tabs sit 5px under the top edge, and a `Y` ring there lost most of
// its top border off screen.
const $86f2aeb0136abec2$export$b315d9fb3d4e3c88 = {
    position: 'fixed',
    inset: '0',
    zIndex: '2100',
    inertOutside: true,
    styleDeps: [
        (el, s)=>s.root && s.root._onboardingTour
    ],
    style: (el, s)=>{
        const tour = s.root && s.root._onboardingTour;
        return {
            ...el.call('onboardingTourVars', tour ? tour.rect : null) || {},
            '--tour-gap': 'min(var(--spacing-Y), var(--tour-room, var(--spacing-Y)))'
        };
    },
    onWindowResize: (e, el)=>el.call('onboardingTourMeasure'),
    onDocumentScroll: {
        capture: true,
        passive: true,
        handler: (e, el)=>el.call('onboardingTourMeasure')
    },
    onDocumentKeydown: (e, el)=>{
        if (e.defaultPrevented) return;
        if (e.key === 'Escape') {
            e.preventDefault();
            el.call('onboardingTourEnd');
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            el.call('onboardingTourGo', 1);
        } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            el.call('onboardingTourGo', -1);
        }
    },
    // The closing card has no stop: the whole page takes the veil behind it.
    OnboardingTourVeil: {
        position: 'absolute',
        inset: '0',
        theme: 'backdrop',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingTour
        ],
        hide: (el, s)=>{
            const tour = s.root && s.root._onboardingTour;
            return !!(tour && tour.rect);
        }
    },
    // A stop: the house veil (the `backdrop` theme — scrim and blur, the one
    // behind every dialog) on the four sides of the stop, so the stop itself
    // shows through sharp and undimmed. The gap around it is the window's.
    OnboardingTourShade_top: {
        top: '0',
        left: '0',
        right: '0',
        height: 'calc(var(--tour-y) - var(--tour-gap))'
    },
    OnboardingTourShade_bottom: {
        top: 'calc(var(--tour-y) + var(--tour-h) + var(--tour-gap))',
        left: '0',
        right: '0',
        bottom: '0'
    },
    OnboardingTourShade_left: {
        top: 'calc(var(--tour-y) - var(--tour-gap))',
        left: '0',
        width: 'calc(var(--tour-x) - var(--tour-gap))',
        height: 'calc(var(--tour-h) + 2 * var(--tour-gap))'
    },
    OnboardingTourShade_right: {
        top: 'calc(var(--tour-y) - var(--tour-gap))',
        left: 'calc(var(--tour-x) + var(--tour-w) + var(--tour-gap))',
        right: '0',
        height: 'calc(var(--tour-h) + 2 * var(--tour-gap))'
    },
    // The window's ring — the one outline of the layer, in the ink that marks a
    // focused control, drawn round the stop.
    OnboardingTourRing: {
        position: 'absolute',
        boxSizing: 'border-box',
        round: 'radiusCard',
        borderWidth: 'hairline2',
        borderStyle: 'solid',
        borderColor: 'highlight',
        pointerEvents: 'none',
        ariaHidden: 'true',
        hideDeps: [
            (el, s)=>s.root && s.root._onboardingTour
        ],
        hide: (el, s)=>{
            const tour = s.root && s.root._onboardingTour;
            return !(tour && tour.rect);
        },
        top: 'calc(var(--tour-y) - var(--tour-gap))',
        left: 'calc(var(--tour-x) - var(--tour-gap))',
        width: 'calc(var(--tour-w) + 2 * var(--tour-gap))',
        height: 'calc(var(--tour-h) + 2 * var(--tour-gap))'
    },
    OnboardingTourCard: {}
};
const $86f2aeb0136abec2$export$ead14fb78d9004bb = {
    position: 'absolute',
    theme: 'backdrop',
    ariaHidden: 'true',
    hideDeps: [
        (el, s)=>s.root && s.root._onboardingTour
    ],
    hide: (el, s)=>{
        const tour = s.root && s.root._onboardingTour;
        return !(tour && tour.rect);
    }
};
const $86f2aeb0136abec2$export$1228c02709edce51 = {
    role: 'dialog',
    ariaModal: 'true',
    ariaLabelledby: 'onboardingTourTitle',
    ariaDescribedby: 'onboardingTourText',
    tabindex: '-1',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    gap: 'Z',
    boxSizing: 'border-box',
    padding: 'A',
    theme: 'dialog',
    color: 'paragraph',
    round: 'radiusSheet',
    shadow: 'overlay',
    animation: 'fadeInUpShort',
    animationDuration: 'C',
    animationFillMode: 'backwards',
    dataSide: (el, s)=>{
        const tour = s.root && s.root._onboardingTour;
        return el.call('onboardingTourSide', tour ? tour.rect : null);
    },
    // The card's width as a property, so its left edge can clamp to the
    // viewport in CSS: a spacing-token wide, never past the screen.
    style: {
        '--tour-card-w': 'min(var(--spacing-G1), calc(100vw - 2 * var(--spacing-A)))'
    },
    width: 'var(--tour-card-w)',
    maxHeight: 'calc(100dvh - 2 * var(--spacing-A))',
    overflowY: 'auto',
    '&[data-side="below"]': {
        top: 'min(calc(var(--tour-bottom) + var(--spacing-A)), calc(100dvh - var(--spacing-A)))',
        left: 'clamp(var(--spacing-A), calc(var(--tour-cx) - var(--tour-card-w) / 2), calc(100vw - var(--tour-card-w) - var(--spacing-A)))'
    },
    '&[data-side="above"]': {
        bottom: 'calc(100dvh - var(--tour-y) + var(--spacing-A))',
        left: 'clamp(var(--spacing-A), calc(var(--tour-cx) - var(--tour-card-w) / 2), calc(100vw - var(--tour-card-w) - var(--spacing-A)))'
    },
    // Centred by insets, never by a transform: the entrance animation owns
    // `transform`.
    '&[data-side="center"]': {
        inset: '0',
        margin: 'auto',
        height: 'fit-content'
    },
    // Tab cycles the card's own controls (the kit's trap; the page behind is
    // inert as well).
    onKeydown: (e, el)=>el.call('appDialogTrapTab', e),
    TourHead: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'Z',
        minWidth: '0',
        AppMicroLabel: {
            text: (el, s)=>{
                const cur = el.call('onboardingTourCurrent', s.root);
                if (!cur || cur.last) return el.call('polyglot', 'workspace.onboarding.tour.endEyebrow');
                return String(el.call('polyglot', 'workspace.onboarding.tour.counter') || '').replace('{n}', String(cur.index + 1)).replace('{total}', String(cur.total));
            }
        },
        CloseButton: {
            ariaLabel: (el)=>el.call('polyglot', 'workspace.onboarding.tour.close'),
            title: (el)=>el.call('polyglot', 'workspace.onboarding.tour.close'),
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingTourEnd');
            }
        }
    },
    TourTitle: {
        tag: 'h2',
        id: 'onboardingTourTitle',
        margin: '0',
        fontSize: 'A',
        fontWeight: '700',
        lineHeight: '1.3',
        color: 'title',
        text: (el, s)=>{
            const cur = el.call('onboardingTourCurrent', s.root);
            const key = cur && cur.stop ? cur.stop.title : 'workspace.onboarding.tour.endTitle';
            return el.call('polyglot', key);
        }
    },
    TourText: {
        tag: 'p',
        id: 'onboardingTourText',
        margin: '0',
        fontSize: 'Z2',
        lineHeight: '1.5',
        color: 'paragraph',
        text: (el, s)=>{
            const cur = el.call('onboardingTourCurrent', s.root);
            const key = cur && cur.stop ? cur.text : 'workspace.onboarding.tour.endText';
            return el.call('onboardingText', key);
        }
    },
    TourFoot: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'Y',
        marginTop: 'Y',
        minWidth: '0',
        AppCapsuleBtnGhost: {
            compact: true,
            // The closing card has nothing left to skip: the box stays (Rule 66).
            visibility: (el, s)=>{
                const cur = el.call('onboardingTourCurrent', s.root);
                return cur && cur.last ? 'hidden' : 'visible';
            },
            text: '{{ workspace.onboarding.tour.skip | polyglot }}',
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('onboardingTourEnd');
            }
        },
        TourSteps: {
            display: 'flex',
            alignItems: 'center',
            gap: 'Y',
            marginLeft: 'auto',
            AppCapsuleBtnGhost_back: {
                compact: true,
                visibility: (el, s)=>{
                    const cur = el.call('onboardingTourCurrent', s.root);
                    return cur && cur.index > 0 ? 'visible' : 'hidden';
                },
                text: '{{ common.action.back | polyglot }}',
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('onboardingTourGo', -1);
                }
            },
            AppCapsuleBtnPrimary: {
                compact: true,
                // The layer moves the focus in on open — here, so Enter walks on.
                autofocus: true,
                text: (el, s)=>{
                    const cur = el.call('onboardingTourCurrent', s.root);
                    return el.call('polyglot', cur && cur.last ? 'workspace.onboarding.tour.done' : 'common.action.next');
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const cur = el.call('onboardingTourCurrent', s.root);
                    if (!cur || cur.last) el.call('onboardingTourEnd');
                    else el.call('onboardingTourGo', 1);
                }
            }
        }
    }
};

});

parcelRegister("Rs24k", function(module, exports) {

$parcel$export(module.exports, "AdminUsageSummary", () => $0a0ab1ff130d3b87$export$2df97a0ddb5e5f70);
$parcel$export(module.exports, "AdminUsageMetric", () => $0a0ab1ff130d3b87$export$927c6fc890be27b8);
$parcel$export(module.exports, "AdminUsageViewButton", () => $0a0ab1ff130d3b87$export$3e5a60600f05bfa6);
$parcel$export(module.exports, "AdminUsageBreakdownRow", () => $0a0ab1ff130d3b87$export$18f0e87fcb441d56);
$parcel$export(module.exports, "AdminUsageLegend", () => $0a0ab1ff130d3b87$export$b86b0179d710b4ee);
// Credit status derives from the balance, never from the public plan allowance.
// A saved subscription can have a different grant from today's catalog.
//
// One more fact outranks a comfortable forecast: the last AI request the server
// REFUSED for credits (`root._creditsShort`, held by functions/creditGuard.js
// notifyCreditsExhaustedFromMessage — "needed 222, available 100"). While the
// balance read here is still below what that request needed, the page says so —
// it must never print "Healthy balance" / "No top-up needed now" under a thread
// that has just said the workspace cannot afford the person's request (persona
// audit round 1: all four new accounts saw both at once).
const $0a0ab1ff130d3b87$export$2df97a0ddb5e5f70 = {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)',
    gap: 'A',
    '@tabletS': {
        gridTemplateColumns: 'minmax(0, 1fr)'
    },
    '@appMobile': {
        gridTemplateColumns: 'minmax(0, 1fr)'
    },
    scope: {
        balance: (root)=>root?._usageBalance?.data || root?._usageBalance || {},
        available: (root)=>{
            const data = root?._usageBalance?.data || root?._usageBalance;
            return !!data && !data.error && Number.isFinite(Number(data.total)) && data.total != null;
        },
        usedFraction: (root)=>{
            const data = root?._usageBalance?.data || root?._usageBalance || {};
            const size = Number(data.grantSize);
            if (!Number.isFinite(size) || !(size > 0) || data.grantRemaining == null || !Number.isFinite(Number(data.grantRemaining))) return null;
            return Math.min(1, Math.max(0, 1 - Number(data.grantRemaining) / size));
        },
        // Forecasts use the server's observed window, never an invented allowance.
        // Organization pools cannot use one workspace's spend as their burn rate.
        health: (root)=>{
            const balance = root?._usageBalance?.data || root?._usageBalance || {};
            const usage = root?._usageByActor?.data || root?._usageByActor || {};
            const total = Number(balance.total);
            const available = balance.total != null && Number.isFinite(total) && !balance.error;
            const pooled = balance.scope === 'organization';
            const spent = !pooled && !root?._usageLoadingAt && !usage.error && usage.totalCredits != null && Number.isFinite(Number(usage.totalCredits)) ? Math.max(0, Number(usage.totalCredits)) : null;
            const elapsed = (Date.parse(usage.to) - Date.parse(usage.from)) / 86400000;
            const daily = spent > 0 && usage.period === 'month' && elapsed >= 1 ? spent / elapsed : null;
            const days = available && daily ? Math.max(0, total) / daily : null;
            const size = Number(balance.grantSize);
            const hasGrant = !pooled && size > 0 && Number.isFinite(size) && balance.grantRemaining != null && Number.isFinite(Number(balance.grantRemaining));
            const ratio = hasGrant ? Math.max(0, total) / size : null;
            const resetInDays = (Date.parse(balance.nextResetAt) - Date.parse(usage.to)) / 86400000;
            const resetBeforeEmpty = hasGrant && days != null && resetInDays > 0 && resetInDays <= days;
            // The refused request's need, while this page's own (fresh) balance is
            // still below it. An EMPTY balance is the next branch's, not this one's.
            const heldNeed = Number(root?._creditsShort?.needed);
            const shortNeeded = available && total > 0 && Number.isFinite(heldNeed) && heldNeed > total ? heldNeed : null;
            const status = !available ? 'unknown' : total <= 0 ? 'empty' : shortNeeded != null ? 'short' : resetBeforeEmpty ? 'healthy' : days != null ? days <= 3 ? 'critical' : days <= 7 ? 'low' : 'healthy' : ratio != null ? ratio <= 0.1 ? 'critical' : ratio <= 0.3 ? 'low' : 'healthy' : 'available';
            const tone = status === 'empty' || status === 'critical' ? 'dangerInk' : status === 'low' || status === 'short' ? 'warningInk' : status === 'unknown' ? 'inactive' : 'successInk';
            const fill = status === 'empty' || status === 'critical' ? 'red' : status === 'low' || status === 'short' ? 'yellow' : 'green';
            const kind = hasGrant ? 'grant' : spent != null ? 'balance' : 'allocation';
            const remaining = Math.max(0, Number(balance.grantRemaining) || 0);
            const chartLeft = kind === 'grant' ? Math.min(size, remaining) : kind === 'balance' ? Math.max(0, total || 0) : remaining;
            const chartRight = kind === 'grant' ? Math.max(0, size - remaining) : kind === 'balance' ? spent : Math.max(0, Number(balance.topupRemaining) || 0);
            const fraction = chartLeft + chartRight > 0 ? chartLeft / (chartLeft + chartRight) : 0;
            const statusKey = {
                healthy: 'admin.usage.health.healthy',
                low: 'admin.usage.health.low',
                critical: 'admin.usage.health.critical',
                empty: 'admin.usage.health.empty',
                available: 'admin.usage.health.available',
                short: 'admin.usage.health.short',
                unknown: 'admin.usage.summary.loading'
            }[status];
            const guideKey = {
                healthy: 'admin.usage.guide.healthy',
                low: 'admin.usage.guide.low',
                critical: 'admin.usage.guide.critical',
                empty: 'admin.usage.guide.empty',
                available: 'admin.usage.guide.available',
                short: 'admin.usage.guide.short',
                unknown: 'admin.usage.summary.loading'
            }[status];
            const graphKey = {
                grant: 'admin.usage.graph.grant',
                balance: 'admin.usage.graph.balance',
                allocation: 'admin.usage.graph.allocation'
            }[kind];
            return {
                statusKey: statusKey,
                guideKey: guideKey,
                graphKey: graphKey,
                shortNeeded: shortNeeded,
                available: available,
                total: total,
                spent: spent,
                daily: daily,
                days: days,
                resetBeforeEmpty: resetBeforeEmpty,
                status: status,
                tone: tone,
                fill: fill,
                kind: kind,
                chartLeft: chartLeft,
                chartRight: chartRight,
                fraction: fraction,
                refillAt: resetBeforeEmpty ? null : daily ? Math.ceil(daily * 7) : hasGrant ? Math.ceil(size * 0.3) : null
            };
        },
        formatCredits: (value)=>value == null ? "\u2014" : Number(value).toLocaleString('en-US', {
                maximumFractionDigits: 2
            }),
        plan: (root)=>{
            const balance = root?._usageBalance?.data || root?._usageBalance || {};
            const rates = root?._usageRates?.data || root?._usageRates || {};
            return Object.values(rates.tiers || {}).find((tier)=>tier.key === balance.tier);
        }
    },
    AdminCard: {
        padding: 'A1',
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) auto',
        alignContent: 'start',
        alignItems: 'center',
        childProps: {
            gridColumn: '1 / -1'
        },
        gap: 'A',
        minWidth: '0',
        Header: {
            flow: 'x',
            align: 'center space-between',
            gap: 'Z',
            flexWrap: 'wrap',
            Label: {
                text: (el)=>el.call('polyglot', 'admin.usage.balance.total'),
                color: 'inactive',
                fontSize: 'Z'
            },
            Status: {
                role: 'status',
                round: 'radiusPill',
                padding: 'Y Z',
                background: 'selected',
                fontSize: 'Y2',
                fontWeight: '700',
                color: 'title',
                text: (el, s)=>{
                    const health = el.scope.health(s.root);
                    if (!health.available) return el.call('polyglot', el.scope.balance(s.root).error ? 'admin.usage.error.balance' : 'admin.usage.summary.loading');
                    const text = el.call('polyglot', health.statusKey);
                    return health.shortNeeded == null ? text : text.replace('{needed}', ()=>el.scope.formatCredits(health.shortNeeded)).replace('{available}', ()=>el.scope.formatCredits(health.total));
                }
            }
        },
        Total: {
            gridColumn: '1',
            gridRow: '2',
            minWidth: '0',
            overflowWrap: 'anywhere',
            fontSize: 'F',
            '@mobileL': {
                fontSize: 'E'
            },
            '@appMobile': {
                fontSize: 'E'
            },
            fontWeight: '700',
            lineHeight: '1',
            color: 'title',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>el.scope.available(s.root) ? el.scope.formatCredits(el.scope.balance(s.root).total) : "\u2014"
        },
        Gauge: {
            hide: (el, s)=>!el.scope.available(s.root),
            gridColumn: '2',
            gridRow: '2',
            boxSize: 'F',
            padding: 'Z',
            '@mobileL': {
                boxSize: 'D',
                padding: 'Y'
            },
            '@appMobile': {
                boxSize: 'D',
                padding: 'Y'
            },
            boxSizing: 'border-box',
            round: 'radiusPill',
            ariaHidden: 'true',
            background: (el, s)=>{
                const h = el.scope.health(s.root);
                return `conic-gradient(var(--color-${h.fill}) ${h.fraction * 360}deg, var(--color-widgetPlate) 0deg)`;
            },
            Center: {
                width: '100%',
                height: '100%',
                round: 'radiusPill',
                background: 'cardSolid',
                align: 'center center',
                fontSize: 'C',
                '@mobileL': {
                    fontSize: 'Z2'
                },
                '@appMobile': {
                    fontSize: 'Z2'
                },
                fontWeight: '700',
                color: 'title',
                fontVariantNumeric: 'tabular-nums',
                text: (el, s)=>`${Math.round(el.scope.health(s.root).fraction * 100)}%`
            }
        },
        LimitBar: {
            hide: (el, s)=>!el.scope.available(s.root),
            flow: 'y',
            gap: 'Z',
            padding: 'A',
            background: 'widgetPlate',
            round: 'radiusControl',
            LabelRow: {
                flow: 'x',
                align: 'center space-between',
                flexWrap: 'wrap',
                gap: 'Y',
                Label: {
                    text: (el, s)=>el.call('polyglot', el.scope.health(s.root).graphKey),
                    fontSize: 'Z',
                    color: 'title',
                    fontWeight: '500'
                },
                Value: {
                    fontSize: 'Z',
                    fontWeight: '700',
                    color: (el, s)=>el.scope.health(s.root).tone,
                    text: (el, s)=>{
                        const health = el.scope.health(s.root);
                        return health.kind === 'grant' ? el.call('polyglot', 'admin.usage.graph.percentLeft').replace('{percent}', Math.round(health.fraction * 100)) : el.call('polyglot', 'admin.usage.graph.available').replace('{credits}', el.scope.formatCredits(health.total));
                    }
                }
            },
            ProgressBar: {
                height: 'A',
                background: 'cardSolid',
                'aria-label': (el, s)=>el.call('polyglot', el.scope.health(s.root).graphKey),
                'aria-valuetext': (el, s)=>el.call('polyglot', 'admin.usage.graph.available').replace('{credits}', el.scope.formatCredits(el.scope.health(s.root).total)),
                value: (el, s)=>el.scope.health(s.root).fraction,
                'aria-valuenow': (el, s)=>String(Math.round(el.scope.health(s.root).fraction * 100)),
                Fill: {
                    transition: 'none',
                    width: (el, s)=>`${el.scope.health(s.root).fraction * 100}%`,
                    background: (el, s)=>el.scope.health(s.root).fill
                }
            },
            Scale: {
                // The axis clarifies the meter without inventing a usage history.
                flow: 'x',
                align: 'start space-between',
                ariaHidden: 'true',
                childExtends: 'Text',
                childrenAs: 'state',
                children: [
                    {
                        value: 0
                    },
                    {
                        value: 25
                    },
                    {
                        value: 50
                    },
                    {
                        value: 75
                    },
                    {
                        value: 100
                    }
                ],
                childProps: {
                    flow: 'y',
                    gap: 'Y',
                    color: 'caption',
                    fontSize: 'Y',
                    fontVariantNumeric: 'tabular-nums',
                    text: (el, s)=>`${s.value}%`,
                    ':before': {
                        content: '""',
                        width: 'hairline',
                        height: 'Y',
                        background: 'inactive'
                    },
                    ':last-child': {
                        alignItems: 'end'
                    }
                }
            },
            Legend: {
                tag: 'div',
                flow: 'x',
                align: 'center space-between',
                flexWrap: 'wrap',
                gap: 'Z',
                childExtends: 'AdminUsageLegend',
                childrenAs: 'state',
                children: (el, s)=>{
                    const health = el.scope.health(s.root);
                    return [
                        {
                            color: health.fill,
                            label: health.kind === 'allocation' ? 'admin.usage.balance.fromGrant' : 'admin.usage.graph.left',
                            value: el.scope.formatCredits(health.chartLeft)
                        },
                        {
                            color: 'inactive',
                            label: health.kind === 'allocation' ? 'admin.usage.balance.fromTopups' : health.kind === 'grant' ? 'admin.usage.graph.used' : 'admin.usage.graph.spent',
                            value: el.scope.formatCredits(health.chartRight)
                        }
                    ];
                }
            },
            Remaining: {
                fontSize: 'Y2',
                color: 'caption',
                text: (el, s)=>{
                    const balance = el.scope.balance(s.root);
                    const health = el.scope.health(s.root);
                    return health.kind === 'grant' ? el.call('polyglot', 'admin.usage.amountOf').replace('{remaining}', el.scope.formatCredits(balance.grantRemaining)).replace('{total}', el.scope.formatCredits(balance.grantSize)) : el.call('polyglot', health.kind === 'balance' ? 'admin.usage.graph.comparisonHint' : 'admin.usage.graph.allocationHint');
                }
            }
        },
        Outlook: {
            hide: (el, s)=>!el.scope.available(s.root),
            display: 'grid',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            gap: 'A',
            '@mobileL': {
                gridTemplateColumns: 'minmax(0, 1fr)'
            },
            '@appMobile': {
                gridTemplateColumns: 'minmax(0, 1fr)'
            },
            childExtends: 'AdminUsageMetric',
            childProps: {
                paddingLeft: 'Z',
                borderLeft: 'hairline solid line'
            },
            childrenAs: 'state',
            children: (el, s)=>{
                const health = el.scope.health(s.root);
                const days = health.days;
                return [
                    {
                        label: 'admin.usage.guide.cover',
                        value: days == null ? "\u2014" : el.call('polyglot', days >= 30 ? 'admin.usage.guide.days30' : days < 1 ? 'admin.usage.guide.lessDay' : 'admin.usage.guide.days').replace('{days}', Math.floor(days))
                    },
                    {
                        label: 'admin.usage.guide.daily',
                        value: health.daily == null ? "\u2014" : el.scope.formatCredits(Math.round(health.daily))
                    },
                    {
                        label: 'admin.usage.guide.refillAt',
                        value: health.refillAt == null ? "\u2014" : el.scope.formatCredits(health.refillAt)
                    }
                ];
            }
        },
        Guidance: {
            hide: (el, s)=>!el.scope.available(s.root),
            background: 'selected',
            round: 'radiusControl',
            padding: 'A',
            flow: 'x',
            align: 'center space-between',
            flexWrap: 'wrap',
            gap: 'A',
            Copy: {
                flex: '1',
                minWidth: '0',
                flow: 'y',
                gap: 'Y',
                Title: {
                    fontSize: 'Z2',
                    fontWeight: '700',
                    color: 'title',
                    text: (el, s)=>el.call('polyglot', el.scope.health(s.root).guideKey)
                },
                Detail: {
                    fontSize: 'Y2',
                    color: 'caption',
                    text: (el, s)=>{
                        const health = el.scope.health(s.root);
                        const text = el.call('polyglot', health.shortNeeded != null ? 'admin.usage.guide.shortHint' : health.resetBeforeEmpty ? 'admin.usage.guide.resetHint' : health.daily != null ? 'admin.usage.guide.forecastHint' : health.refillAt != null ? 'admin.usage.guide.allowanceHint' : 'admin.usage.guide.unavailableHint');
                        return health.shortNeeded == null ? text : text.replace('{needed}', ()=>el.scope.formatCredits(health.shortNeeded)).replace('{available}', ()=>el.scope.formatCredits(health.total));
                    }
                }
            },
            Button: {
                theme: 'primary',
                text: (el)=>el.call('polyglot', 'admin.usage.nav.topup'),
                onClick: (event, el, s)=>s.update({
                        usageView: 'topup'
                    })
            }
        },
        Allocation: {
            hide: (el, s)=>!el.scope.available(s.root) || el.scope.health(s.root).kind === 'allocation',
            display: 'grid',
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            gap: 'A',
            childExtends: 'AdminUsageMetric',
            childrenAs: 'state',
            children: (el, s)=>{
                const balance = el.scope.balance(s.root);
                return [
                    {
                        label: el.call('polyglot', 'admin.usage.balance.fromGrant'),
                        value: el.scope.formatCredits(balance.grantRemaining)
                    },
                    {
                        label: el.call('polyglot', 'admin.usage.balance.fromTopups'),
                        value: el.scope.formatCredits(balance.topupRemaining)
                    }
                ];
            }
        }
    },
    AdminCard_1: {
        padding: 'A',
        flow: 'y',
        gap: 'Z1',
        minWidth: '0',
        Label: {
            text: (el)=>el.call('polyglot', 'admin.usage.tiers.current'),
            fontSize: 'Z',
            color: 'inactive'
        },
        Name: {
            fontSize: 'D',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>el.scope.plan(s.root)?.displayName || el.scope.balance(s.root).tier || "\u2014"
        },
        Price: {
            color: 'inactive',
            fontSize: 'Z',
            text: (el, s)=>{
                const plan = el.scope.plan(s.root);
                if (!plan) return el.call('polyglot', 'admin.usage.summary.priceUnavailable');
                if (plan.priceMonthlyUsd == null) return el.call('polyglot', 'admin.usage.summary.customPrice');
                if (plan.priceMonthlyUsd === 0) return el.call('polyglot', 'admin.usage.summary.free');
                const amount = Number(plan.priceMonthlyUsd).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    maximumFractionDigits: 2
                });
                const price = el.call('polyglot', plan.priceIsFloor ? 'admin.usage.tier.priceFrom' : 'admin.usage.tier.priceMonthly').replace('{price}', amount);
                return el.call('polyglot', 'admin.usage.summary.catalogPrice').replace('{price}', price);
            }
        },
        Reset: {
            padding: 'Z',
            background: 'widgetPlate',
            round: 'radiusControl',
            color: 'caption',
            fontSize: 'Y2',
            text: (el, s)=>{
                const balance = el.scope.balance(s.root);
                if (balance.scope === 'organization') return el.call('polyglot', 'admin.usage.balance.poolOrgHint');
                if (!balance.nextResetAt) return el.call('polyglot', 'admin.usage.summary.noReset');
                const date = new Date(balance.nextResetAt);
                if (Number.isNaN(date.getTime())) return el.call('polyglot', 'admin.usage.summary.noReset');
                return el.call('polyglot', 'admin.usage.balance.nextReset').replace('{date}', el.call('localizedDate', date, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                }));
            }
        },
        SavedGrant: {
            hide: (el, s)=>!el.scope.balance(s.root).grantDivergesFromTierDefault,
            color: 'inactive',
            fontSize: 'Y2',
            text: (el)=>el.call('polyglot', 'admin.usage.summary.saved')
        },
        TopupPrice: {
            flow: 'y',
            gap: 'Y',
            padding: 'A',
            round: 'radiusControl',
            background: 'title',
            hide: (el, s)=>{
                const rates = s.root._usageRates?.data || s.root._usageRates || {};
                return !(rates.centsPerCredit > 0 && rates.topupMinCents > 0);
            },
            Label: {
                fontSize: 'Z',
                fontWeight: '500',
                color: 'title-reversed',
                text: '{{ admin.usage.nav.topup | polyglot }}'
            },
            Price: {
                fontSize: 'B',
                fontWeight: '700',
                color: 'title-reversed',
                text: (el, s)=>{
                    const rates = s.root._usageRates?.data || s.root._usageRates || {};
                    const price = (Number(rates.topupMinCents) / 100).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    });
                    return el.call('polyglot', 'admin.usage.summary.topupPrice').replace('{price}', price).replace('{credits}', el.scope.formatCredits(Math.floor(rates.topupMinCents / rates.centsPerCredit)));
                }
            },
            Note: {
                fontSize: 'Y2',
                color: 'title-reversed',
                text: '{{ admin.usage.summary.topupNote | polyglot }}'
            }
        },
        Actions: {
            marginTop: 'auto',
            paddingTop: 'A',
            flow: 'x',
            flexWrap: 'wrap',
            gap: 'Y',
            Button: {
                theme: 'primary',
                text: (el)=>el.call('polyglot', 'admin.usage.summary.compare'),
                onClick: (event, el, s)=>s.update({
                        usageView: 'plans'
                    })
            },
            Button_2: {
                theme: 'transparent',
                text: (el)=>el.call('polyglot', 'admin.usage.nav.topup'),
                onClick: (event, el, s)=>s.update({
                        usageView: 'topup'
                    })
            }
        }
    }
};
const $0a0ab1ff130d3b87$export$927c6fc890be27b8 = {
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    Label: {
        fontSize: 'Y2',
        color: 'inactive',
        text: (el, s)=>el.call('polyglot', s.label || '')
    },
    Value: {
        fontSize: 'B',
        fontWeight: '700',
        color: 'title',
        fontVariantNumeric: 'tabular-nums',
        overflowWrap: 'anywhere',
        text: (el, s)=>s.value
    }
};
const $0a0ab1ff130d3b87$export$3e5a60600f05bfa6 = {
    extends: 'Button',
    theme: 'transparent',
    minHeight: 'controlHCompact',
    round: 'radiusPill',
    fontSize: 'Z',
    whiteSpace: 'nowrap',
    flexShrink: '0',
    'aria-pressed': (el, s)=>s.usageView === el.view,
    background: (el, s)=>s.usageView === el.view ? 'selected' : 'transparent',
    color: (el, s)=>s.usageView === el.view ? 'title' : 'inactive',
    fontWeight: (el, s)=>s.usageView === el.view ? '700' : '400',
    onClick: (event, el, s)=>s.update({
            usageView: el.view
        })
};
const $0a0ab1ff130d3b87$export$18f0e87fcb441d56 = {
    flow: 'y',
    gap: 'Y',
    padding: 'Z 0',
    LabelRow: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Label: {
            fontSize: 'Z',
            color: 'title',
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        Value: {
            fontSize: 'Z',
            fontVariantNumeric: 'tabular-nums',
            color: 'title',
            text: (el, s)=>s.value
        }
    },
    ProgressBar: {
        hide: (el, s)=>s.share == null,
        height: 'Y',
        background: 'selected',
        'aria-label': (el, s)=>el.call('polyglot', s.label || ''),
        'aria-valuetext': (el, s)=>`${s.value} \xb7 ${Math.round(s.share * 100)}%`,
        'aria-valuenow': (el, s)=>String(Math.round((s.share || 0) * 100)),
        value: (el, s)=>s.share || 0,
        Fill: {
            transition: 'none',
            width: (el, s)=>`${Math.min(1, Math.max(0, s.share || 0)) * 100}%`
        }
    },
    Hint: {
        fontSize: 'Y2',
        color: 'inactive',
        text: (el, s)=>s.hint
    }
};
const $0a0ab1ff130d3b87$export$b86b0179d710b4ee = {
    flow: 'x',
    align: 'center',
    gap: 'Y',
    Dot: {
        boxSize: 'Y',
        round: 'radiusPill',
        background: (el, s)=>s.color,
        'aria-hidden': 'true'
    },
    Label: {
        fontSize: 'Y2',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', s.label)
    },
    Value: {
        fontSize: 'Z',
        fontWeight: '700',
        color: 'title',
        text: (el, s)=>s.value
    }
};

});

parcelRegister("fDUXx", function(module, exports) {

$parcel$export(module.exports, "AdminPageHeader", () => $b636ae7ce772c355$export$e47503f05082112);
$parcel$export(module.exports, "AdminPageBody", () => $b636ae7ce772c355$export$a1dd500f9d2f8048);
$parcel$export(module.exports, "AdminSettingsBody", () => $b636ae7ce772c355$export$bbcec747898d81a9);
$parcel$export(module.exports, "AdminMetricGrid", () => $b636ae7ce772c355$export$b3941b60c054fdd);
$parcel$export(module.exports, "AdminMetricCard", () => $b636ae7ce772c355$export$a356d875e2443df2);
$parcel$export(module.exports, "AdminPricingCard", () => $b636ae7ce772c355$export$2a5d7eccfffc87f0);
$parcel$export(module.exports, "AdminPlanBenefit", () => $b636ae7ce772c355$export$c257c5512cd04b28);
// Local admin visual language. Page data and actions stay with each route.
const $b636ae7ce772c355$export$e47503f05082112 = {
    extends: 'PageHeader',
    padding: 'A B',
    LeftGroup: {
        Emblem: {
            hide: (el, s)=>el.call('paneTitleBarShown', s),
            boxSize: 'controlH',
            flexShrink: '0',
            round: 'radiusPill',
            background: 'title',
            align: 'center center',
            ariaHidden: 'true',
            Icon: {
                name: (el)=>el.lookup('Header')?.adminIcon || 'settings',
                boxSize: 'A1',
                color: 'title-reversed'
            }
        },
        Title: {
            fontSize: 'C',
            lineHeight: '1.2',
            '@mobileL': {
                fontSize: 'B'
            },
            '@appMobile': {
                fontSize: 'B'
            }
        }
    },
    '@mobileL': {
        padding: 'A'
    },
    '@appMobile': {
        padding: 'A'
    }
};
const $b636ae7ce772c355$export$a1dd500f9d2f8048 = {
    flow: 'y',
    gap: 'A',
    padding: 'Z B B',
    overflow: 'auto',
    minWidth: '0',
    minHeight: '0',
    maxWidth: '100%',
    boxSizing: 'border-box',
    childProps: {
        flexShrink: '0'
    },
    '@mobileL': {
        padding: 'Z A A'
    },
    '@appMobile': {
        padding: 'Z A A'
    }
};
const $b636ae7ce772c355$export$bbcec747898d81a9 = {
    extends: 'AdminPageBody',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-H)), 1fr))',
    alignItems: 'start',
    alignContent: 'start',
    width: '100%',
    maxWidth: 'J'
};
const $b636ae7ce772c355$export$b3941b60c054fdd = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-G)), 1fr))',
    gap: 'Z',
    minWidth: '0',
    width: '100%',
    maxWidth: 'J',
    gridColumn: '1 / -1',
    childExtends: 'AdminMetricCard',
    childrenAs: 'state'
};
const $b636ae7ce772c355$export$a356d875e2443df2 = {
    extends: 'AdminCard',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    alignItems: 'center',
    childProps: {
        gridColumn: '1 / -1'
    },
    gap: 'Z',
    Header: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        Label: {
            fontSize: 'Z1',
            fontWeight: '500',
            color: 'caption',
            text: (el, s)=>el.call('polyglot', s.label || '')
        },
        Icon: {
            name: (el, s)=>s.icon || 'analytics',
            boxSize: 'B',
            padding: 'Y',
            boxSizing: 'border-box',
            round: 'radiusPill',
            background: 'widgetPlate',
            color: 'title',
            ariaHidden: 'true'
        }
    },
    Value: {
        gridColumn: '1',
        gridRow: '2',
        fontSize: 'E',
        fontWeight: '700',
        lineHeight: '1.1',
        color: 'title',
        fontVariantNumeric: 'tabular-nums',
        overflowWrap: 'anywhere',
        text: (el, s)=>s.value ?? "\u2014"
    },
    Gauge: {
        hide: (el, s)=>!(Number(s.limit) > 0) || s.value == null,
        gridColumn: '2',
        gridRow: '2',
        boxSize: 'D',
        padding: 'Y',
        boxSizing: 'border-box',
        round: 'radiusPill',
        ariaHidden: 'true',
        background: (el, s)=>{
            const percent = Math.max(0, Math.min(100, Number(s.value) / Number(s.limit) * 100)) || 0;
            return `conic-gradient(var(--color-title) ${percent * 3.6}deg, var(--color-widgetPlate) 0deg)`;
        },
        Center: {
            width: '100%',
            height: '100%',
            background: 'cardSolid',
            round: 'radiusPill',
            align: 'center center',
            fontSize: 'Z',
            fontWeight: '700',
            color: 'title',
            text: (el, s)=>`${Math.round(Math.max(0, Math.min(100, Number(s.value) / Number(s.limit) * 100)) || 0)}%`
        }
    },
    ProgressBar: {
        hide: (el, s)=>!(Number(s.limit) > 0) || s.value == null,
        height: 'Y',
        background: 'widgetPlate',
        ariaLabel: (el, s)=>el.call('polyglot', s.label || ''),
        role: 'progressbar',
        value: (el, s)=>Math.max(0, Math.min(1, Number(s.value) / Number(s.limit))) || 0,
        'aria-valuemin': '0',
        'aria-valuemax': (el, s)=>String(Number(s.limit) || 0),
        'aria-valuenow': (el, s)=>String(Math.max(0, Math.min(Number(s.limit), Number(s.value)))),
        Fill: {
            width: (el, s)=>`${Math.max(0, Math.min(100, Number(s.value) / Number(s.limit) * 100)) || 0}%`,
            background: 'title'
        }
    }
};
const $b636ae7ce772c355$export$2a5d7eccfffc87f0 = {
    flow: 'y',
    gap: 'A',
    minWidth: '0',
    padding: 'A',
    round: 'radiusCard',
    background: 'raised',
    isCurrent: (el, s)=>!!s._isCurrent,
    '.isCurrent': {
        shadow: 'float'
    },
    Identity: {
        flow: 'x',
        align: 'center space-between',
        Mark: {
            tag: 'div',
            boxSize: 'C',
            round: 'radiusPill',
            background: (el, s)=>s._isCurrent ? 'title' : 'widgetPlate',
            align: 'center center',
            ariaHidden: 'true',
            Icon: {
                name: (el, s)=>s._isCurrent ? 'check' : s.salesLed ? 'network' : 'layers',
                boxSize: 'A1',
                color: (el, s)=>s._isCurrent ? 'title-reversed' : 'title'
            }
        },
        AppStatusChip: {
            hide: (el, s)=>!s._isCurrent,
            label: 'admin.usage.tiers.current'
        }
    },
    Top: {
        Name: {
            tag: 'h3',
            margin: '0',
            fontSize: 'B',
            fontWeight: '700',
            color: 'title',
            lineHeight: '1.2'
        }
    },
    Price: {
        fontSize: 'D',
        fontWeight: '700',
        color: 'title-reversed',
        background: 'title',
        padding: 'A',
        round: 'radiusControl',
        lineHeight: '1.1',
        fontVariantNumeric: 'tabular-nums',
        overflowWrap: 'anywhere'
    },
    Billing: {
        fontSize: 'Y2',
        color: 'caption',
        text: '{{ admin.usage.tiers.billing | polyglot }}'
    },
    Credits: {
        fontSize: 'Z1',
        fontWeight: '500',
        color: 'title',
        padding: '0 0 Z',
        borderBottom: 'hairline solid line',
        fontVariantNumeric: 'tabular-nums'
    },
    Perks: {
        tag: 'ul',
        flex: '1',
        flow: 'y',
        gap: 'Z1',
        margin: '0',
        padding: '0',
        listStyle: 'none',
        childExtends: 'AdminPlanBenefit',
        childrenAs: 'state'
    },
    Current: {
        hide: (el, s)=>!s._isCurrent,
        minHeight: 'controlH',
        align: 'center center',
        gap: 'Y',
        background: 'selected',
        round: 'radiusControl',
        color: 'title',
        fontSize: 'Z2',
        fontWeight: '500',
        Icon: {
            name: 'check',
            boxSize: 'Z1',
            ariaHidden: 'true'
        },
        Label: {
            text: '{{ admin.usage.tiers.current | polyglot }}'
        }
    }
};
const $b636ae7ce772c355$export$c257c5512cd04b28 = {
    tag: 'li',
    flow: 'x',
    align: 'start',
    gap: 'Y',
    Icon: {
        name: 'check',
        boxSize: 'Z1',
        color: 'title',
        flexShrink: '0',
        ariaHidden: 'true'
    },
    Label: {
        fontSize: 'Z',
        color: 'caption',
        lineHeight: '1.5',
        text: (el, s)=>s.value
    }
};

});

parcelRegister("HQCRr", function(module, exports) {

$parcel$export(module.exports, "AdminAutoTopup", () => $083cd6a71f33ad49$export$8310670912ac165d);
$parcel$export(module.exports, "AdminAutoTopupMetric", () => $083cd6a71f33ad49$export$235a05c207db0d97);
$parcel$export(module.exports, "AdminAutoTopupField", () => $083cd6a71f33ad49$export$24a64aa20432beb5);
const $083cd6a71f33ad49$export$8310670912ac165d = {
    scope: {
        statusLabels: {
            loading: 'admin.usage.auto.statusLoading',
            unavailable: 'admin.usage.auto.statusUnavailable',
            off: 'admin.usage.auto.statusOff',
            active: 'admin.usage.auto.statusActive',
            setup_required: 'admin.usage.auto.statusSetupRequired',
            processing: 'admin.usage.auto.statusProcessing',
            limit_reached: 'admin.usage.auto.statusLimitReached',
            payment_failed: 'admin.usage.auto.statusPaymentFailed',
            authentication_required: 'admin.usage.auto.statusAuthenticationRequired',
            reconcile_required: 'admin.usage.auto.statusReconcileRequired',
            unsupported: 'admin.usage.auto.statusUnsupported'
        },
        noticeLabels: {
            loading: 'admin.usage.auto.noticeLoading',
            unavailable: 'admin.usage.auto.noticeUnavailable',
            off: 'admin.usage.auto.noticeOff',
            active: 'admin.usage.auto.noticeActive',
            setup_required: 'admin.usage.auto.noticeSetupRequired',
            processing: 'admin.usage.auto.noticeProcessing',
            limit_reached: 'admin.usage.auto.noticeLimitReached',
            payment_failed: 'admin.usage.auto.noticePaymentFailed',
            authentication_required: 'admin.usage.auto.noticeAuthenticationRequired',
            reconcile_required: 'admin.usage.auto.noticeReconcileRequired',
            unsupported: 'admin.usage.auto.noticeUnsupported'
        },
        validationLabels: {
            rates: 'admin.usage.auto.validationRates',
            amount: 'admin.usage.auto.validationAmount',
            threshold: 'admin.usage.auto.validationThreshold',
            limit: 'admin.usage.auto.validationLimit'
        },
        errorLabels: {
            unavailable: 'admin.usage.auto.errorUnavailable',
            forbidden: 'admin.usage.auto.errorForbidden',
            inProgress: 'admin.usage.auto.errorInProgress',
            failed: 'admin.usage.auto.errorFailed'
        }
    },
    extends: 'AdminCard',
    gap: 'A',
    Header: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        flexWrap: 'wrap',
        TitleGroup: {
            flow: 'x',
            align: 'center',
            gap: 'Z',
            Emblem: {
                boxSize: 'controlH',
                round: 'radiusPill',
                background: 'title',
                align: 'center center',
                ariaHidden: 'true',
                Icon: {
                    name: 'refresh',
                    color: 'title-reversed',
                    boxSize: 'A'
                }
            },
            AdminCardTitle: {
                text: '{{ admin.usage.auto.title | polyglot }}'
            }
        },
        Status: {
            padding: 'Y Z',
            round: 'radiusPill',
            background: 'overlay',
            fontSize: 'Z',
            fontWeight: '500',
            role: 'status',
            color: (el, s)=>[
                    'payment_failed',
                    'authentication_required',
                    'reconcile_required'
                ].includes(el.call('autoTopupData', s.root)?.status) ? 'dangerInk' : 'title',
            text: (el, s)=>{
                const data = el.call('autoTopupData', s.root);
                const status = !data ? 'loading' : data.error ? 'unavailable' : data.status || 'off';
                return el.call('polyglot', el.scope.statusLabels[status] || el.scope.statusLabels.unavailable);
            }
        }
    },
    AdminCardDesc: {
        text: '{{ admin.usage.auto.description | polyglot }}'
    },
    AdminCardDesc_1: {
        role: 'status',
        text: (el, s)=>{
            const data = el.call('autoTopupData', s.root);
            const status = !data ? 'loading' : data.error ? 'unavailable' : data.status || 'off';
            return el.call('polyglot', el.scope.noticeLabels[status] || el.scope.noticeLabels.unavailable);
        }
    },
    Rule: {
        hide: (el, s)=>!s.root._autoTopupDraft && !el.call('autoTopupData', s.root)?.amountCents,
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gap: '0',
        padding: 'A',
        round: 'radiusControl',
        background: 'widgetPlate',
        '@mobileL': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        },
        '@appMobile': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        },
        childExtends: 'AdminAutoTopupMetric',
        childrenAs: 'state',
        children: (el, s)=>{
            const rule = el.call('autoTopupRule', s.root);
            return [
                {
                    step: '01',
                    label: 'threshold',
                    value: el.call('autoTopupNumber', rule.thresholdCredits),
                    detail: el.call('polyglot', 'admin.usage.auto.below')
                },
                {
                    step: '02',
                    label: 'refill',
                    value: el.call('autoTopupMoney', rule.amountCents),
                    detail: el.call('polyglot', 'admin.usage.auto.credits').replace('{credits}', el.call('autoTopupNumber', rule.credits))
                },
                {
                    step: '03',
                    label: 'cap',
                    value: el.call('autoTopupMoney', rule.monthlyLimitCents),
                    detail: el.call('polyglot', 'admin.usage.auto.perMonth')
                }
            ];
        }
    },
    Budget: {
        hideDeps: [
            '_autoTopupDraft',
            '_autoTopup'
        ],
        hide: (el, s)=>!el.call('autoTopupData', s.root)?.monthlyLimitCents || !!s.root._autoTopupDraft,
        flow: 'y',
        gap: 'Y',
        Label: {
            fontSize: 'Z',
            color: 'caption',
            text: (el, s)=>{
                const data = el.call('autoTopupData', s.root);
                return el.call('polyglot', 'admin.usage.auto.spent').replace('{spent}', el.call('autoTopupMoney', data?.spentCents)).replace('{limit}', el.call('autoTopupMoney', data?.monthlyLimitCents));
            }
        },
        ProgressBar: {
            height: 'Y',
            round: 'radiusPill',
            value: (el, s)=>{
                const data = el.call('autoTopupData', s.root);
                return data?.monthlyLimitCents > 0 ? Math.min(1, data.spentCents / data.monthlyLimitCents) : 0;
            },
            'aria-label': '{{ admin.usage.auto.budget | polyglot }}',
            'aria-valuemin': 0,
            'aria-valuemax': (el, s)=>el.call('autoTopupData', s.root)?.monthlyLimitCents / 100 || 0,
            'aria-valuenow': (el, s)=>{
                const data = el.call('autoTopupData', s.root);
                return Math.min(data?.monthlyLimitCents || 0, data?.spentCents || 0) / 100;
            },
            Fill: {
                round: 'radiusPill',
                background: 'title',
                width: (el, s)=>{
                    const data = el.call('autoTopupData', s.root);
                    return `${data?.monthlyLimitCents > 0 ? Math.min(100, Math.max(0, data.spentCents / data.monthlyLimitCents * 100)) : 0}%`;
                }
            }
        },
        Card: {
            fontSize: 'Z',
            color: 'caption',
            text: (el, s)=>{
                const data = el.call('autoTopupData', s.root);
                return data?.card ? el.call('polyglot', 'admin.usage.auto.card').replace('{brand}', data.card.brand).replace('{last4}', data.card.last4) : '';
            }
        }
    },
    Editor: {
        hide: (el, s)=>s.root._autoTopupStep !== 'edit',
        flow: 'y',
        gap: 'Z',
        Fields: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, var(--spacing-F)), 1fr))',
            gap: 'Z',
            childExtends: 'AdminAutoTopupField',
            childrenAs: 'state',
            children: [
                {
                    field: 'thresholdCredits',
                    label: 'triggerLabel',
                    step: '1'
                },
                {
                    field: 'amountUsd',
                    label: 'amountLabel',
                    step: '0.01'
                },
                {
                    field: 'limitUsd',
                    label: 'limitLabel',
                    step: '0.01'
                }
            ]
        },
        AdminCardDesc: {
            text: (el, s)=>{
                const rates = s.root._usageRates?.data || s.root._usageRates || {};
                return el.call('polyglot', 'admin.usage.auto.rateHint').replace('{rate}', el.call('autoTopupMoney', rates.centsPerCredit)).replace('{min}', el.call('autoTopupMoney', rates.topupMinCents)).replace('{max}', el.call('autoTopupMoney', rates.topupMaxCents));
            }
        },
        Validation: {
            role: 'alert',
            color: 'dangerInk',
            fontSize: 'Z',
            hide: (el, s)=>!s.root._autoTopupTouched || !el.call('autoTopupValidation', s.root),
            text: (el, s)=>el.call('polyglot', el.scope.validationLabels[el.call('autoTopupValidation', s.root)] || el.scope.validationLabels.rates)
        },
        Actions: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            AdminActionBtnPrimary: {
                text: '{{ admin.usage.auto.review | polyglot }}',
                onClick: (e, el, s)=>el.call('autoTopupReview', s.root)
            },
            AdminActionBtn: {
                text: '{{ admin.usage.auto.cancel | polyglot }}',
                onClick: (e, el, s)=>el.call('autoTopupClose', s.root)
            }
        }
    },
    Review: {
        hide: (el, s)=>s.root._autoTopupStep !== 'review',
        flow: 'y',
        gap: 'Z',
        AdminCardTitle: {
            tag: 'h3',
            text: '{{ admin.usage.auto.reviewTitle | polyglot }}'
        },
        AdminCardDesc: {
            text: '{{ admin.usage.auto.reviewDescription | polyglot }}'
        },
        CheckboxField: {
            minHeight: 'controlH',
            align: 'start',
            gap: 'Z',
            Input: {
                checked: (el, s)=>!!s.root._autoTopupConsent,
                disabled: (el, s)=>!!s.root._autoTopupBusy,
                onChange: (e, el, s)=>s.root.update({
                        _autoTopupConsent: e.target.checked
                    })
            },
            Span: {
                opacity: '1',
                color: 'paragraph',
                fontSize: 'Z2',
                text: '{{ admin.usage.auto.consent | polyglot }}'
            }
        },
        Actions: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            AdminActionBtnPrimary: {
                text: (el, s)=>el.call('polyglot', s.root._autoTopupBusy ? 'admin.usage.auto.wait' : 'admin.usage.auto.prepare'),
                disabled: (el, s)=>!!s.root._autoTopupBusy || !s.root._autoTopupConsent,
                onClick: (e, el, s)=>el.call('autoTopupAction', s.root, 'setup')
            },
            AdminActionBtn: {
                text: '{{ admin.usage.auto.back | polyglot }}',
                disabled: (el, s)=>!!s.root._autoTopupBusy,
                onClick: (e, el, s)=>s.root.update({
                        _autoTopupStep: 'edit',
                        _autoTopupConsent: false
                    })
            }
        }
    },
    SecureCard: {
        hide: (el, s)=>s.root._autoTopupStep !== 'card',
        flow: 'y',
        gap: 'Z',
        AdminCardDesc: {
            text: '{{ admin.usage.auto.secureHint | polyglot }}'
        },
        Actions: {
            flow: 'x',
            gap: 'Z',
            flexWrap: 'wrap',
            AdminActionBtnPrimary: {
                tag: 'a',
                type: null,
                href: (el, s)=>s.root._autoTopupCheckoutUrl || undefined,
                textDecoration: 'none',
                align: 'center center',
                text: '{{ admin.usage.auto.continue | polyglot }}'
            },
            AdminActionBtn: {
                text: '{{ admin.usage.auto.cancel | polyglot }}',
                disabled: (el, s)=>!!s.root._autoTopupBusy,
                onClick: (e, el, s)=>el.call('autoTopupAction', s.root, 'pause')
            }
        }
    },
    Error: {
        hide: (el, s)=>!s.root._autoTopupError,
        role: 'alert',
        fontSize: 'Z',
        color: 'dangerInk',
        text: (el, s)=>el.call('polyglot', el.scope.errorLabels[s.root._autoTopupError] || el.scope.errorLabels.failed)
    },
    Actions: {
        hide: (el, s)=>!!s.root._autoTopupStep,
        flow: 'x',
        gap: 'Z',
        flexWrap: 'wrap',
        AdminActionBtnPrimary: {
            hide: (el, s)=>{
                const data = el.call('autoTopupData', s.root);
                return !data || data.error || data.supported === false || [
                    'processing',
                    'reconcile_required'
                ].includes(data.status);
            },
            disabled: (el, s)=>!!s.root._autoTopupBusy,
            text: (el, s)=>el.call('polyglot', el.call('autoTopupData', s.root)?.enabled ? 'admin.usage.auto.edit' : 'admin.usage.auto.setup'),
            onClick: (e, el, s)=>el.call('autoTopupEdit', s.root)
        },
        AdminActionBtn: {
            hide: (el, s)=>{
                const data = el.call('autoTopupData', s.root);
                return !data?.enabled && data?.status !== 'setup_required';
            },
            disabled: (el, s)=>!!s.root._autoTopupBusy,
            text: '{{ admin.usage.auto.pause | polyglot }}',
            onClick: (e, el, s)=>el.call('autoTopupAction', s.root, 'pause')
        },
        AdminActionBtn_1: {
            disabled: (el, s)=>!!s.root._autoTopupBusy,
            text: (el, s)=>el.call('polyglot', s.root._autoTopupBusy ? 'admin.usage.auto.wait' : 'admin.usage.auto.refresh'),
            onClick: (e, el, s)=>el.call('autoTopupAction', s.root, el.call('autoTopupData', s.root)?.status === 'setup_required' ? 'refresh' : 'load')
        }
    }
};
const $083cd6a71f33ad49$export$235a05c207db0d97 = {
    scope: {
        metricLabels: {
            threshold: 'admin.usage.auto.metricThreshold',
            refill: 'admin.usage.auto.metricRefill',
            cap: 'admin.usage.auto.metricCap'
        }
    },
    flow: 'y',
    gap: 'Z',
    padding: '0 A 0 0',
    minWidth: '0',
    '@mobileL': {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr)',
        padding: '0 0 A'
    },
    '@appMobile': {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr)',
        padding: '0 0 A'
    },
    ':last-child': {
        padding: '0'
    },
    Header: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        '@mobileL': {
            flow: 'y',
            gridRow: '1 / 4'
        },
        '@appMobile': {
            flow: 'y',
            gridRow: '1 / 4'
        },
        Step: {
            boxSize: 'B',
            round: 'radiusPill',
            background: 'title',
            color: 'title-reversed',
            align: 'center center',
            fontSize: 'Y',
            flexShrink: '0',
            fontVariantNumeric: 'tabular-nums',
            text: (el, s)=>s.step
        },
        Connector: {
            flex: '1',
            height: 'hairline',
            background: 'line',
            ariaHidden: 'true',
            visibility: (el, s)=>s.step === '03' ? 'hidden' : 'visible',
            '@mobileL': {
                width: 'hairline',
                height: 'auto'
            },
            '@appMobile': {
                width: 'hairline',
                height: 'auto'
            }
        }
    },
    Label: {
        fontSize: 'Z',
        fontWeight: '500',
        color: 'caption',
        text: (el, s)=>el.call('polyglot', el.scope.metricLabels[s.label] || el.scope.metricLabels.threshold)
    },
    Value: {
        fontSize: 'D',
        fontWeight: '700',
        color: 'title',
        lineHeight: '1.1',
        fontVariantNumeric: 'tabular-nums',
        overflowWrap: 'anywhere',
        text: (el, s)=>s.value
    },
    Detail: {
        fontSize: 'Z',
        color: 'caption',
        text: (el, s)=>s.detail
    }
};
const $083cd6a71f33ad49$export$24a64aa20432beb5 = {
    scope: {
        fieldLabels: {
            triggerLabel: 'admin.usage.auto.triggerLabel',
            amountLabel: 'admin.usage.auto.amountLabel',
            limitLabel: 'admin.usage.auto.limitLabel'
        }
    },
    extends: 'AppField',
    minWidth: '0',
    label: (el, s)=>el.call('polyglot', el.scope.fieldLabels[s.label] || el.scope.fieldLabels.triggerLabel),
    AppInput: {
        type: 'number',
        inputMode: 'decimal',
        step: (el, s)=>s.step,
        value: (el, s)=>s.root._autoTopupDraft?.[s.field] ?? '',
        onInput: (e, el, s)=>el.call('autoTopupChange', s.root, s.field, e.target.value)
    }
};

});

parcelRegister("gVnLp", function(module, exports) {

$parcel$export(module.exports, "GeneratedAppBlocked", () => $c5246729145877ce$export$6bd91ed5565935a3);
// GeneratedAppBlocked — what a viewer mounts IN PLACE of an AI-generated app
// the containment gate refused (functions/generatedAppContainment.js; Nika
// 2026-10-01 "Cut access now"). None of the app's own code runs: the builder
// (functions/index.js parseGeneratedAppSource) refused it before evaluation,
// and this page is the whole mount.
//
// The house error state (shared ErrorState, kind 'forbidden') with one action:
// ask the AI to rebuild the app with the allowed features. The request names
// the app and what the gate refused, so the model can fix exactly that.
// State (set by functions/index.js generatedAppBlockedDef): appName,
// blockedReasons (rule: detail strings).
const $c5246729145877ce$export$6bd91ed5565935a3 = {
    extends: 'ErrorState',
    kind: 'forbidden',
    heading: 'workspace.appBlocked.heading',
    hintText: 'workspace.appBlocked.hint',
    action: {
        text: 'workspace.appBlocked.rebuild',
        onClick: (e, el, s)=>{
            const reasons = Array.isArray(s.blockedReasons) ? s.blockedReasons : [];
            const prompt = el.call('polyglot', 'workspace.appBlocked.rebuildPrompt').replace('{name}', s.appName || el.call('polyglot', 'workspace.apps.nameFallback')).replace('{reasons}', reasons.join('; '));
            el.call('homeAiSend', prompt);
        }
    }
};

});

parcelRegister("kc5p7", function(module, exports) {

$parcel$export(module.exports, "SandboxedApp", () => $eb391ec4b88b1e5e$export$83b866b898e4ceac);
// SandboxedApp — what a viewer mounts for an AI-generated app with the
// `appsSandbox` flag on (ISOLATED-RUNTIME-PLAN §8.2). The app runs in an
// OPAQUE-ORIGIN frame (sandbox="allow-scripts", nothing else): it cannot reach
// the member's session, storage, SDK or the shell DOM. Its only line to the
// shell is the port functions/sandboxHost.js serves.
//
// The label above the frame marks the area as app content (§3.5): the frame
// cannot draw over it, so a fake "sign in again" form inside the app is never
// mistaken for the shell's own.
//
// Data (set by functions/generatedAppSandbox.js sandboxAppDef): sandboxApp
// { name, expr, jsonAuthored, entities, stateSeed } — plain data.
// State written by functions/mountSandboxedApp.js: sandboxHeight (the frame's
// measured height), sandboxStopped (the teardown reason).
const $eb391ec4b88b1e5e$export$83b866b898e4ceac = {
    flow: 'y',
    gap: 'Z',
    state: {
        sandboxHeight: 0,
        sandboxStopped: ''
    },
    SandboxLabel: {
        fontSize: 'Z1',
        color: 'caption',
        text: (el)=>el.call('polyglot', 'workspace.sandbox.marker')
    },
    SandboxStopped: {
        if: (el, s)=>!!s.sandboxStopped,
        color: 'caption',
        text: (el)=>el.call('polyglot', 'workspace.sandbox.stopped')
    },
    Iframe: {
        if: (el, s)=>!s.sandboxStopped,
        attr: {
            sandbox: 'allow-scripts'
        },
        title: (el)=>el.call('polyglot', 'workspace.sandbox.frameTitle'),
        width: '100%',
        border: 'none',
        // Two real branches, never null: a null CSS prop is a tombstone (it
        // emits nothing AND deletes the inherited declaration). Unmeasured, the
        // frame keeps its intrinsic height.
        height: (el, s)=>s.sandboxHeight ? s.sandboxHeight + 'px' : 'auto',
        onRender: (el)=>el.call('mountSandboxedApp', el.node, el.parent.sandboxApp),
        onRemove: (el)=>{
            const app = el.scope && el.scope.sandboxApp;
            if (app && typeof app.teardown === 'function') app.teardown('removed');
        }
    }
};

});

parcelRegister("iI84d", function(module, exports) {

$parcel$export(module.exports, "InviteDropdown", () => $d9f297f7feb769b1$export$eefca90c663865f2);
// The invite panel the shell header opens — the SHELL's layout of it.
//
// Nika 2026-10-09: "fix ui and layout of invite dropdown, make it clean,
// beautiful" + "make clear ux, imagine human using ... on daily basis". The
// admin who invites people every week: open → pick Email or Magic link → one
// action → a clear "Invited …" / "Link copied …" line.
//
// WHY A SHELL OVERRIDE. The panel's parts live in the shared library
// (shared/components/InviteDropdown.js, InviteFormInDropdown.js,
// MagicLinkInInvite.js, MembersInInvite.js — READ-ONLY here). The shell's
// components merge over the library's (context.js), so this `InviteDropdown`
// is the one the header's `openDropdown({ content: { extends:
// 'InviteDropdown' } })` mounts in the shell. It is a FULL definition, never
// `{ extends: 'InviteDropdown' }` (that resolves to itself once the shell's
// key replaces the library's, and renders with no children). The canvas
// MembersNavbar still mounts the library's panel.
//
// Every BEHAVIOUR stays in the shared parts — sending, the invite policy, the
// magic-link create / copy / revoke, the member list. This file only lays them
// out and restyles them through per-instance overrides on their bare keys
// (DOMQL deep-merges an instance object into the component it names); the
// children it ADDS land after the part's own children.
//
// THE SHAPE (top to bottom, one A gap, one A padding all round):
//   InviteHead      title + one short line
//   InviteMode      Email | Magic link — the kit's segmented control, ink
//                   thumb on a light track (only when a link may be shared)
//   InviteFormInDropdown   (Email) address · role + "Send invite" · the
//                   status line · the invite's link in a pill + Copy
//   MagicLinkInInvite      (Magic link) role + "Create and copy link" · the
//                   plain-words line (who joins, at which role, once, until
//                   when) · "Active links": role chip, ENDS date, SINGLE USE,
//                   Revoke with an in-place confirm · an empty state
//   NoInviteNote    why a caller cannot invite here
//   MembersInInvite the first members and "All members"
//
// Revoke never uses a browser dialog: the first press turns the row into
// "Revoke this link?" with Revoke (danger) and Keep. Keep takes the spot the
// first Revoke held (and gets focus), so a double click or a second fast
// Enter lands on the safe choice; both answers ignore activations for 300 ms
// after the swap. Only the confirm calls the server. Escape cancels the
// question without closing the panel. `revokeAsk` (this panel's state) names
// the row asking; `revokeAskAt` is when it asked.
//
// The status-line "Revoke" of the shared part is OFF here: the link just
// made is the first row of "Active links", with the same safe revoke. (This
// also carries the fix of shell branch feat/invite-link-join-unverified: that
// button showed before any link and after a revoke — `visibility` lost to the
// capsule's CSS; `hide` takes it out of the layout.)
const $d9f297f7feb769b1$export$eefca90c663865f2 = {
    extends: 'MenuPanel',
    role: 'dialog',
    ariaLabel: (el)=>el.call('polyglot', 'members.inviteDropdown.title'),
    // The shared form writes into THIS store (it owns no state), so every key
    // it writes is declared here, plus the panel's own three:
    //   mode       'email' | 'link' — the segmented control
    //   revokeAsk  the inviteId of the active-link row asking "Revoke this
    //              link?" ('' = none)
    //   revokeAskAt  when it asked (ms) — the confirm's double-activation guard
    state: {
        email: '',
        role: '',
        status: 'idle',
        error: '',
        failure: '',
        sentEmail: '',
        sentUrl: '',
        sentNoEmail: false,
        copied: false,
        mode: 'email',
        revokeAsk: '',
        revokeAskAt: 0
    },
    width: 'G2',
    padding: 'A',
    gap: 'A',
    textAlign: 'start',
    onClick: null,
    // Focus INTO the dialog, onto the email field (or the first link for a
    // caller with no form) — only when the dropdown layer hosts the panel.
    // Escape during "Revoke this link?" answers the question (Keep) and keeps
    // the panel open: the dropdown layer closes on an Escape nobody spent, so
    // this one is spent (preventDefault). Every other key keeps MenuPanel's
    // arrow-key model.
    onKeydown: (ev, el, s)=>{
        if (ev.key === 'Escape' && s.revokeAsk) {
            ev.preventDefault();
            el.call('inviteLinkKeep', s.revokeAsk);
            return;
        }
        el.call('menuArrowNav', ev, el.node);
    },
    onRender: (el)=>{
        if (typeof el.lookup !== 'function' || !el.lookup('DropdownRoot')) return;
        el.call('armMenuFocus', el, {
            selector: 'input[type="email"], a[href]',
            when: (node)=>el.call('menuNodeVisible', node)
        });
    },
    InviteHead: {
        flow: 'y',
        gap: 'X2',
        Title: {
            tag: 'h2',
            margin: '0',
            fontSize: 'A',
            fontWeight: '500',
            lineHeight: '1.25',
            color: 'title',
            text: '{{ members.inviteDropdown.title | polyglot }}'
        },
        InviteSub: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z1',
            color: 'caption',
            hide: (el, s)=>!el.call('invitePolicy', s).mayInvite,
            text: (el, s)=>el.call('polyglot', el.call('magicLinkOffered', s) ? 'shell.invite.sub' : 'shell.invite.subEmail')
        }
    },
    // Email | Magic link. Full width, two equal segments.
    InviteMode: {
        extends: 'AppSegmented',
        variant: 'choice',
        width: '100%',
        ariaLabel: (el)=>el.call('polyglot', 'shell.invite.mode.label'),
        hide: (el, s)=>!el.call('magicLinkOffered', s),
        current: (el, s)=>s.mode,
        select: 'inviteDropdownMode',
        // Each row carries the mode it was derived at: a change of `mode` re-derives
        // the rows, so every segment re-reads its own choice (a static row list
        // never re-evaluated `isActive` on a panel-state change).
        childrenAs: 'state',
        children: (el, s)=>[
                {
                    key: 'modeEmail',
                    text: 'shell.invite.mode.email',
                    value: 'email',
                    mode: s.mode
                },
                {
                    key: 'modeLink',
                    text: 'shell.invite.mode.link',
                    value: 'link',
                    mode: s.mode
                }
            ],
        childProps: {
            flex: '1',
            isActive: (el, s)=>!!s && s.value === s.mode
        }
    },
    // ── Email ────────────────────────────────────────────────────────────────
    InviteFormInDropdown: {
        gap: 'Z',
        hide: (el, s)=>!el.call('invitePolicy', s).mayInvite || s.mode === 'link' && el.call('magicLinkOffered', s),
        // The row keeps the shared wrap law (a long Georgian role or label wraps
        // the button under the select; a control never clips its own label).
        Actions: {
            // The link moves to its own pill below (SentLink).
            CompactIconButton: {
                hide: ()=>true
            }
        },
        // One line keeps the main answer: "Invited ana@…", and after Copy
        // "Invited ana@… · Link copied" (the shared line swapped the whole
        // sentence for "Link copied").
        Note: {
            minHeight: 'auto',
            fontSize: 'Z1',
            text: (el, s)=>{
                if (s.failure) return s.failure;
                if (!s.sentEmail) return '';
                const key = s.sentNoEmail ? 'members.inviteDropdown.sentNoEmail' : 'members.inviteSent.person';
                const sent = el.call('polyglot', key).replace('{who}', s.sentEmail).replace('{email}', s.sentEmail);
                return s.copied ? sent + " \xb7 " + el.call('polyglot', 'members.inviteDropdown.linkCopied.title') : sent;
            }
        },
        // The accept link of the invitation just sent, in a pill, with Copy.
        // A project invite has no link: no pill.
        SentLink: {
            flow: 'x',
            align: 'center',
            gap: 'Y',
            minWidth: '0',
            padding: 'X X X Z1',
            round: 'radiusPill',
            theme: 'segmentTrack',
            hide: (el, s)=>!s.sentUrl,
            SentLinkText: {
                tag: 'span',
                flex: '1',
                minWidth: '0',
                fontFamily: 'Code',
                fontSize: 'Z',
                color: 'caption',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                text: (el, s)=>s.sentUrl || ''
            },
            CompactIconButton: {
                icon: (el, s)=>s.copied ? 'check' : 'copy outline',
                aria: {
                    label: (el, s)=>el.call('polyglot', s.copied ? 'members.inviteDropdown.linkCopied.title' : 'members.inviteDropdown.copyLink')
                },
                title: (el, s)=>el.call('polyglot', s.copied ? 'members.inviteDropdown.linkCopied.title' : 'members.inviteDropdown.copyLink'),
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    if (!s.sentUrl) return;
                    el.call('copyStringToClipboard', s.sentUrl);
                    s.update({
                        copied: true
                    });
                }
            }
        }
    },
    // ── Magic link ───────────────────────────────────────────────────────────
    // The section owns its state; `s.parent` is this panel's.
    MagicLinkInInvite: {
        gap: 'Z',
        hide: (el, s)=>!el.call('magicLinkOffered', s) || (s.parent && s.parent.mode) !== 'link',
        // The mode switch names the section.
        CaptionTitle_link: {
            hide: ()=>true
        },
        LinkActions: {
            // In this mode the link is the ONE action: the primary capsule below
            // replaces the shared secondary one (same handler, same busy label).
            AppCapsuleBtnToolbar: {
                hide: ()=>true
            },
            AppCapsuleBtnPrimary: {
                flexShrink: '0',
                disabled: (el, s)=>s.status === 'creating',
                ariaBusy: (el, s)=>s.status === 'creating' ? 'true' : null,
                AppLabelStack: {
                    labels: [
                        'shell.invite.link.create',
                        'members.inviteDropdown.magicLink.creating'
                    ],
                    shown: (el, s)=>s.status === 'creating' ? 1 : 0
                },
                onClick: (ev, el, s)=>{
                    ev.preventDefault();
                    const host = el.lookup('MagicLinkInInvite');
                    if (host) host.scope.magicLinkCreate(host, s);
                }
            }
        },
        // The plain-words line BEFORE a link exists (role, once, days) and the
        // "Link copied …" result after — the shared text, in a readable size.
        LinkStatusRow: {
            LinkStatus: {
                LinkStatusText: {
                    fontSize: 'Z1',
                    color: (el, s)=>s.failure ? 'dangerInk' : s.createdId ? 'title' : 'caption'
                },
                LinkHintSizer: {
                    fontSize: 'Z1'
                },
                LinkResultSizer: {
                    fontSize: 'Z1'
                }
            },
            AppCapsuleBtnGhost: {
                hide: ()=>true
            }
        },
        ActiveLinks: {
            gap: 'Y',
            // Once loaded the list always shows — rows, or the empty line.
            hide: (el, s)=>s.linksStatus !== 'ready' && s.linksStatus !== 'error',
            CaptionTitle_active: {},
            LinkList: {
                gap: 'X',
                childProps: {
                    gap: 'Y',
                    padding: 'X 0',
                    round: 'radiusControl',
                    // Quiet rows: the role chip carries the fill; the asking row reads by
                    // its words and its red Revoke. The row's own words are its chips now.
                    LinkWhen: {
                        hide: ()=>true
                    },
                    // Asking row: Revoke this link? ........ Revoke  Keep
                    // Normal row (two lines by design, never by wrap):
                    //   [ROLE]                                  Revoke
                    //   ENDS OCT 16 · SINGLE USE
                    LinkInfo: {
                        flow: 'y',
                        align: 'start',
                        gap: 'X',
                        flex: '1',
                        minWidth: '0',
                        hide: (el, s)=>el.call('inviteLinkRowAsking', s),
                        AppStatusChip_role: {
                            color: 'title',
                            Dot: {
                                hide: ()=>true
                            },
                            label: (el, s)=>el.call('inviteLinkRowRole', s)
                        },
                        // One line at any width: the meta has the row to itself, and
                        // the ellipsis guards a language longer than the room.
                        AppMicroLabel_meta: {
                            maxWidth: '100%',
                            color: 'caption',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            text: (el, s)=>el.call('polyglot', 'shell.invite.link.ends').replace('{date}', el.call('inviteLinkRowDate', s)) + " \xb7 " + el.call('polyglot', 'shell.invite.link.singleUse')
                        }
                    },
                    LinkAsk: {
                        tag: 'span',
                        flex: '1',
                        minWidth: '0',
                        fontSize: 'Z1',
                        fontWeight: '500',
                        color: 'title',
                        hide: (el, s)=>!el.call('inviteLinkRowAsking', s),
                        text: (el)=>el.call('polyglot', 'shell.invite.link.revokeAsk')
                    },
                    // Asking: [Revoke this link?] [Revoke (danger)] [Keep] — Keep is the
                    // LAST button, the spot the first Revoke held.
                    AppCapsuleBtnGhost_confirm: {
                        compact: true,
                        flexShrink: '0',
                        color: 'dangerInk',
                        hide: (el, s)=>!el.call('inviteLinkRowAsking', s),
                        aria: {
                            label: (el, s)=>el.call('polyglot', 'shell.invite.link.revokeConfirmLabel').replace('{role}', el.call('inviteLinkRowRole', s)).replace('{date}', el.call('inviteLinkRowDate', s))
                        },
                        AppLabelStack: {
                            labels: [
                                'members.inviteDropdown.magicLink.revoke',
                                'members.inviteDropdown.magicLink.revoking'
                            ],
                            shown: (el, s)=>s.busy ? 1 : 0
                        },
                        onClick: (ev, el, s)=>{
                            ev.preventDefault();
                            if (el.call('inviteLinkGuarded')) return;
                            el.call('inviteLinkConfirm', s);
                        }
                    },
                    AppCapsuleBtnGhost_keep: {
                        compact: true,
                        flexShrink: '0',
                        hide: (el, s)=>!el.call('inviteLinkRowAsking', s),
                        text: '{{ shell.invite.link.keep | polyglot }}',
                        onClick: (ev, el, s)=>{
                            ev.preventDefault();
                            if (el.call('inviteLinkGuarded')) return;
                            el.call('inviteLinkKeep', s.inviteId);
                        }
                    },
                    // The shared row button gives way to AppCapsuleBtnGhost_revoke.
                    AppCapsuleBtnGhost: {
                        hide: ()=>true
                    },
                    // Not asking: [ROLE / meta] [Revoke]. The first press only asks; it
                    // also shows "Revoking…" while the confirmed revoke runs.
                    AppCapsuleBtnGhost_revoke: {
                        compact: true,
                        flexShrink: '0',
                        color: 'caption',
                        hide: (el, s)=>el.call('inviteLinkRowAsking', s),
                        disabled: (el, s)=>!!s.busy,
                        ariaBusy: (el, s)=>s.busy ? 'true' : null,
                        aria: {
                            label: (el, s)=>el.call('polyglot', 'members.inviteDropdown.magicLink.revokeLabel').replace('{role}', el.call('inviteLinkRowRole', s)).replace('{date}', el.call('inviteLinkRowDate', s))
                        },
                        AppLabelStack: {
                            labels: [
                                'members.inviteDropdown.magicLink.revoke',
                                'members.inviteDropdown.magicLink.revoking'
                            ],
                            shown: (el, s)=>s.busy ? 1 : 0
                        },
                        onClick: (ev, el, s)=>{
                            ev.preventDefault();
                            el.call('inviteLinkAsk', s);
                        }
                    }
                }
            },
            LinkEmpty: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z1',
                color: 'caption',
                hide: (el, s)=>s.linksStatus !== 'ready' || (s.links || []).length > 0,
                text: (el)=>el.call('polyglot', 'shell.invite.link.empty')
            }
        }
    },
    // A caller the form is hidden from learns why, in one line.
    NoInviteNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z1',
        color: 'caption',
        hide: (el, s)=>!el.call('invitePolicy', s).reason,
        text: (el, s)=>{
            const reason = el.call('invitePolicy', s).reason;
            if (!reason) return '';
            return el.call('polyglot', reason === 'personalOrg' ? 'members.inviteDropdown.personalOrg' : 'members.inviteDropdown.noPermission');
        }
    },
    MembersInInvite: {}
};

});

parcelRegister("caPbm", function(module, exports) {

$parcel$export(module.exports, "ShellModalRoot", () => $8dce1eedbf04d490$export$8b15004b36d120b7);
// ShellModalRoot — the dialog host's five-layer stack (@symbo.ls/windows
// ModalRoot): a layer shows only while its slot of the stack holds a dialog —
// hidden, invisible and click-through otherwise. One definition for every
// root that hosts dialogs: the workspace shell (app.js `ModalRoot`) and the
// comm app (comm/app.js). Each root keeps its own mount props (zIndex,
// pointer-events, its mount latch).
const $8dce1eedbf04d490$export$8b15004b36d120b7 = {
    extends: 'ModalRoot',
    // The windows base reads `el.layer` for visibility. On a cold DOMQL
    // construction that property can still be the reactive factory itself,
    // which is truthy before its return value has been installed. The result
    // is a visible, content-less ModalWindow on every page refresh. Read the
    // owning ModalRoot state directly in each preallocated slot; this is also
    // the subscription source the windows package documents for v3.14.
    ModalLayer_0: {
        display: (el, s)=>s?.stack?.[0] ? 'flex' : 'none',
        opacity: (el, s)=>s?.stack?.[0] ? '1' : '0',
        visibility: (el, s)=>s?.stack?.[0] ? 'visible' : 'hidden',
        pointerEvents: (el, s)=>s?.stack?.[0] ? 'auto' : 'none'
    },
    ModalLayer_1: {
        display: (el, s)=>s?.stack?.[1] ? 'flex' : 'none',
        opacity: (el, s)=>s?.stack?.[1] ? '1' : '0',
        visibility: (el, s)=>s?.stack?.[1] ? 'visible' : 'hidden',
        pointerEvents: (el, s)=>s?.stack?.[1] ? 'auto' : 'none'
    },
    ModalLayer_2: {
        display: (el, s)=>s?.stack?.[2] ? 'flex' : 'none',
        opacity: (el, s)=>s?.stack?.[2] ? '1' : '0',
        visibility: (el, s)=>s?.stack?.[2] ? 'visible' : 'hidden',
        pointerEvents: (el, s)=>s?.stack?.[2] ? 'auto' : 'none'
    },
    ModalLayer_3: {
        display: (el, s)=>s?.stack?.[3] ? 'flex' : 'none',
        opacity: (el, s)=>s?.stack?.[3] ? '1' : '0',
        visibility: (el, s)=>s?.stack?.[3] ? 'visible' : 'hidden',
        pointerEvents: (el, s)=>s?.stack?.[3] ? 'auto' : 'none'
    },
    ModalLayer_4: {
        display: (el, s)=>s?.stack?.[4] ? 'flex' : 'none',
        opacity: (el, s)=>s?.stack?.[4] ? '1' : '0',
        visibility: (el, s)=>s?.stack?.[4] ? 'visible' : 'hidden',
        pointerEvents: (el, s)=>s?.stack?.[4] ? 'auto' : 'none'
    }
};

});

parcelRegister("equEq", function(module, exports) {

$parcel$export(module.exports, "ShellTooltipRoot", () => $a80b4510c88059a4$export$80296056d1358697);
// ShellTooltipRoot — the tooltip layer's panel skin: the brand's floating
// chrome, the same recipe as the brand QuestionMarkTooltip panel — the branded
// `card` fill (opaque, one fill step above the pane sheet) with `title` ink,
// the one `overlay` elevation, `radiusControl`, the absolute `tooltipText`
// size (the Z step in rem, so it never compounds with the trigger's font), em
// padding, weight 500 (a label), one line at most. `card .background` takes
// only the card's FILL, so the `title` ink has no theme colour to race on
// emission order. The plugin's own default ('tooltip .quaternary' until smbls
// cab7004d9) named a theme no design system defines: the panel painted no
// surface at all and its label ran straight over the controls under it
// (measured live 2026-09-24). One definition for every root that hosts
// tooltips: the workspace shell (app.js `TooltipRoot`) and the comm app
// (comm/app.js); each root keeps its own mount props (zIndex, its stage).
const $a80b4510c88059a4$export$80296056d1358697 = {
    extends: 'TooltipRoot',
    Panel: {
        theme: 'card .background',
        color: 'title',
        shadow: 'overlay',
        round: 'radiusControl',
        fontSize: 'tooltipText',
        fontWeight: '500',
        lineHeight: '1.45',
        padding: 'Y Z1',
        maxWidth: 'G1',
        // Credit details are a short breakdown, not a one-line control label.
        whiteSpace: (el)=>el.tip?.id === 'build-credit-balance' ? 'pre-line' : 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
};

});


parcelRegister("fxtVu", function(module, exports) {
// White-label component overrides — WHITE-LABEL HOSTS ONLY.
//
// ⚠️ Nika, 2026-08-19: "do not change anything for symbols — this is for
// bellforge workspace gate only." Nothing in this folder is exported from
// `components/index.js`. `context.js` spreads this barrel into
// `context.components` ONLY when `isCustomDomainHost()` is true, so on every
// platform host (my.symbols.app, canvas, preview, marketplace, *.localhost)
// the component graph never sees these keys at all.
//
// Both overrides use the same-name library-override pattern already proven
// in this package by `components/AppSidebar.js`, and both read their content
// from the org's `branding` record (functions/whitelabelBrand.js) — never a
// hardcoded customer value.

var $8WF9w = parcelRequire("8WF9w");

var $92P67 = parcelRequire("92P67");
$parcel$exportWildcard(module.exports, $8WF9w);
$parcel$exportWildcard(module.exports, $92P67);

});
parcelRegister("8WF9w", function(module, exports) {

$parcel$export(module.exports, "MainLoader", () => $6833a98fe019c107$export$d330003798a27f99);
// MainLoader — shell override of the brand loader, for white-label hosts
// (WHITELABEL-BRANDED-BOOT-1, tickets/opus.md).
//
// Nika, via relman 2026-08-19: "Symbols loader first, then Bellforge
// branding" (accepted — no edge injection, no per-host index.html), and the
// second stage should be "a rotating Bellforge SVG logo", NOT the spiral.
//
// So the sequence a white-label visitor sees is deliberately two-stage:
//   1. the inline #boot-spiral in index.html — Symbols, pre-bundle, before
//      any JS can know whose host this is. Unchanged.
//   2. THIS loader, once the bundle is live: the org's own mark, rotating,
//      on the org's own ground.
//
// ── Additive by construction ─────────────────────────────────────────────
// Every branded prop is a factory gated on `s.root.whitelabelBrand`, which
// is null on every platform host and for any custom domain without a record
// (functions/whitelabelBrand.js). Unbranded, this component contributes
// nothing but a hidden empty child — the brand MainLoader renders exactly as
// it does today. The self-name `extends` is the documented library-override
// pattern, already proven in this package by components/AppSidebar.js.
//
// ── Why the Symbols marks are HIDDEN rather than replaced ────────────────
// `LogoLoader.html` / `LoaderRatio.Spinner.html` are static strings on the
// brand components. Overriding them with a factory means owning the
// unbranded value too — a factory that returns null on the platform path
// would blank the Symbols mark for everyone (and a null return is a no-op on
// an UPDATE render, so it would fail asymmetrically). Hiding the two Symbols
// marks and rendering the brand mark as a SIBLING keeps the platform path
// byte-identical and needs no copy of the brand's own markup.
//
// ── `hide` AND an explicit `display` ─────────────────────────────────────
// Both gates on purpose, same as ContextDropdown's Avatar slot: `if:` is
// inert in this v3.14 build, and published element builds up to 3.14.779
// carry FW-HIDE-UNAPPLIED-1 (a `hide` factory that is true from its first
// run is clobbered by the explicit-display pass; fixed in smbls 7031e3d60,
// unpublished while the npm publish chain is billing-locked). The explicit
// display is the pass that wins on every runtime, old and fixed.

var $bh6kd = parcelRequire("bh6kd");
const $6833a98fe019c107$export$d330003798a27f99 = {
    extends: 'MainLoader',
    // The org's ground, resolved by the SAME rule the branded sign-in uses —
    // one scheme decision for the whole white-label surface, LIGHT BY DEFAULT
    // (Nika 2026-08-19: "make both versions - light by default"). Importing the
    // helper rather than re-deriving it is deliberate: two copies of a
    // precedence rule drift, and this one already has a subtle case (an
    // explicit 'auto' must follow the OS, not the brand).
    background: (el, s)=>{
        const brand = s.root && s.root.whitelabelBrand;
        return brand ? (0, $bh6kd.whitelabelGround)(s) : null;
    },
    LoaderRatio: {
        Spinner: {
            // The Symbols swirl IS the Symbols identity — it has no place on a
            // customer's own domain. This is the "not the spiral" half of the ask.
            hide: (el, s)=>!!(s.root && s.root.whitelabelBrand),
            // TWO REAL BRANCHES. This was `: null`, and here that was a genuine
            // TOMBSTONE: the base declares `display: 'flex'` with
            // `align: 'center center'`
            // (company/packages/brand/components/LoaderRatio.js:67), so on the
            // ORDINARY non-white-label path — every platform user, at boot — the
            // null erased it and dropped the spiral to `block`, losing its
            // centring. `'flex'` restates the base value rather than inventing one.
            display: (el, s)=>s.root && s.root.whitelabelBrand ? 'none' : 'flex'
        }
    },
    LogoLoader: {
        hide: (el, s)=>!!(s.root && s.root.whitelabelBrand),
        // DELIBERATELY still `null`, and allowlisted in the tombstone lock.
        // Checked rather than assumed: the brand's LogoLoader
        // (company/packages/brand/components/LogoLoader.js) declares NO `display`
        // at all, and neither does the MainLoader slot it sits in — it is
        // positioned with `position`/`top`/`left`/`transform`. With nothing
        // inherited to erase, this null deletes nothing. Giving it a real branch
        // would ADD a display this node has never had, which is the riskier edit.
        display: (el, s)=>s.root && s.root.whitelabelBrand ? 'none' : null
    },
    // The branded mark. Sits in the same centred slot the LogoLoader occupies
    // (the brand MainLoader positions LogoLoader absolutely at 50%/50%; this
    // mirrors it rather than depending on it).
    //
    // ── TWO MOTIONS, CHOSEN BY THE RECORD ────────────────────────────────────
    // Nika 2026-09-10: "change loading spinner only for vault - keep bellforge
    // and gita as was". So the motion is a per-tenant RECORD decision, not a
    // shell decision: `branding.loaderMotion === 'dial'` opts an org into the
    // combination-dial lockup; every other value, and the absent key, keep the
    // `flipY` coin flip this loader has shipped since 2026-08-20. The key is
    // read off the SAME public brand object the mark itself comes from, so a
    // tenant changes its own boot motion by changing its own record — no
    // deploy, no per-host branch in the shell.
    //
    // ── The lockup: HOST → RING + DIAL ───────────────────────────────────────
    // Three elements, one for each job, because one element cannot hold two
    // transforms:
    //   BrandMark (this host) — the box, margin-centred. In dial mode it owns
    //                           the ONE-SHOT arrival (scale-in + ink fade); in
    //                           flip mode it owns the flip itself. Owns the ink.
    //   DialRing              — the progress ring. DIAL MODE ONLY.
    //   Dial                  — the 56px inner wrapper that TURNS in dial mode,
    //                           inert in flip mode, and the only element that
    //                           carries the org's markup in BOTH.
    // The turn is on `Dial`, never on this host: keyframe transforms REPLACE
    // the base transform, and the host's own arrival keyframes already own the
    // property in dial mode. In flip mode the wrapper is a plain 56px box
    // inside the 56px host and changes nothing — the flip still runs on the
    // host exactly as it always did, and the mark rides it.
    // One shape for both modes on purpose: two DOM shapes behind a flag drift,
    // and the flip is the path 100% of today's tenants take.
    BrandMark: {
        hide: (el, s)=>!(s.root && s.root.whitelabelBrand),
        display: (el, s)=>s.root && s.root.whitelabelBrand ? 'flex' : 'none',
        // ⚠️ ABOVE THE RATIO PANEL, not above the LogoLoader. Measured live
        // 2026-09-10 on the shell: brand's `LoaderRatio` is itself a FIXED
        // full-screen panel at `zIndex: 9990099` whose `:after` paints a
        // rgba(5,5,5,.98) vignette over the centre of the screen — and the shell's
        // MainLoader root computes `position: static`, so it opens no stacking
        // context of its own and the two are ordered against each other directly.
        // At the inherited `zIndex: 2` the branded mark rendered UNDERNEATH that
        // 98%-opaque vignette: present in the DOM, hit-testable, invisible on
        // screen. One step above the panel is all it takes, and nothing else is on
        // screen at boot to collide with.
        zIndex: 9990100,
        position: 'absolute',
        top: '50%',
        left: '50%',
        // Margin centering, NOT transform — the animations own the `transform`
        // property outright (keyframe transforms REPLACE the base transform, they
        // do not compose), so a translate3d here would be dropped for the whole
        // animation and the mark would be anchored at its top-left corner, half a
        // mark off-centre. The box is knowable, so the offsets are knowable too:
        // the margin is a FACTORY that reads the box back (`el.boxSize`) and
        // returns its negative half on the two start edges, so the size and the
        // centring are ONE number — resize the box here and the mark stays
        // centred. Same technique the boot screen's .boot-logo uses in index.html.
        // History: before smbls 3.14.800 a `margin` FACTORY emitted nothing (a
        // multi-part spacing result is an array the reactive style effect could
        // not apply — FW-MARGIN-FACTORY-PROP-DROPPED-SILENTLY-1). Measured live
        // 2026-09-10 on this shell: the computed margin was `0px` and the mark sat
        // exactly half a box down and right of centre, so the pair was typed twice
        // as literals. This shell locks smbls 3.14.807, which carries the fix, and
        // __tests__/whitelabelMainLoaderCentring.test.js reads the resolved margin
        // back through the real engine — an engine that drops it again fails there
        // instead of shipping an off-centre mark.
        // The box is ONE size for both motions: 88px, with the 56px mark centred
        // in it by flex. In flip mode the extra air is invisible (the host paints
        // nothing) and the mark flips about the same centre, at the same size, as
        // it always has — only the box around it is bigger.
        // ⚠️ WHY 88 AND NOT 80: the mark TURNS. A tenant whose ink reaches the
        // corners of its own viewBox sweeps a circle of 56·√2 ≈ 79.2px, i.e. 39.6px
        // from the centre, so a ring whose inner edge sat at 37px would be crossed
        // by that mark twice per turn. At 88px the inner edge is 41px and NO mark,
        // whatever its shape, can ever touch the ring.
        boxSize: '88px',
        margin: (el, s)=>{
            const half = parseFloat(el.boxSize) / 2;
            return `${-half}px 0 0 ${-half}px`;
        },
        align: 'center center',
        // `accent` tints BOTH the mark and the ring through `currentColor`, which
        // is how both brand loader marks already take their colour.
        color: (el, s)=>{
            const brand = s.root && s.root.whitelabelBrand;
            return brand && brand.accent || 'title';
        },
        // DIAL MODE: the arrival, once — scale-in from 0.85 with the ink fading up
        // over one timing step (`A` = 150ms). Deliberately NOT part of the turn
        // cycle; see the `dialEnter` note in designSystem/animation.js.
        // FLIP MODE (the default): the unchanged 3D coin flip — `flipY`, 2.4s,
        // linear, forever, on this host. Byte-for-byte the motion bellforge and
        // gita have today.
        animation: (el, s)=>{
            const brand = s.root && s.root.whitelabelBrand;
            return brand && brand.loaderMotion === 'dial' ? 'dialEnter' : 'flipY';
        },
        animationDuration: (el, s)=>{
            const brand = s.root && s.root.whitelabelBrand;
            return brand && brand.loaderMotion === 'dial' ? 'A' : '2.4s';
        },
        animationTimingFunction: (el, s)=>{
            const brand = s.root && s.root.whitelabelBrand;
            return brand && brand.loaderMotion === 'dial' ? 'defaultBezier' : 'linear';
        },
        animationIterationCount: (el, s)=>{
            const brand = s.root && s.root.whitelabelBrand;
            return brand && brand.loaderMotion === 'dial' ? 1 : 'infinite';
        },
        transformOrigin: '50% 50%',
        aria: {
            hidden: 'true'
        },
        // The ring. Not an `Icon` and not a border: it has to FILL clockwise, and
        // the only property that draws a partial circle without a gradient, a
        // mask or a second painted layer is `stroke-dashoffset` on a stroked
        // circle. Rule 62 is about ICONS (sprite-resolved, theme-swapped, reused);
        // this is a one-off decorative meter that belongs to this loader alone and
        // could not resolve through the shell's icon set anyway. Same declarative
        // svg form the /infra edge layer already uses in this package.
        // Geometry is viewBox math: an 88-unit box, r=42 leaves the 2-unit stroke
        // inside the box, circumference 2·π·42 ≈ 264 = the dash period.
        // `rotate(-90 44 44)` starts the fill at twelve o'clock. It is an SVG
        // attribute, not a CSS transform, so it can never collide with the
        // keyframes.
        DialRing: {
            // DIAL MODE ONLY. Same belt-and-braces gate the Symbols marks above use:
            // `hide` for the fixed runtimes, an explicit `display` for the published
            // ones (FW-HIDE-UNAPPLIED-1).
            hide: (el, s)=>{
                const brand = s.root && s.root.whitelabelBrand;
                return !(brand && brand.loaderMotion === 'dial');
            },
            display: (el, s)=>{
                const brand = s.root && s.root.whitelabelBrand;
                return brand && brand.loaderMotion === 'dial' ? 'block' : 'none';
            },
            tag: 'svg',
            position: 'absolute',
            top: '0',
            left: '0',
            boxSize: '100% 100%',
            // Width/height as INLINE ATTRS as well: the same published-build trap
            // the mark below documents — if the emitted class is ever dropped, the
            // svg still lays out at its intrinsic 88×88 instead of 0×0.
            attr: {
                width: '88',
                height: '88',
                viewBox: '0 0 88 88',
                fill: 'none'
            },
            RingArc: {
                tag: 'circle',
                attr: {
                    cx: '44',
                    cy: '44',
                    r: '42',
                    fill: 'none',
                    stroke: 'currentColor',
                    'stroke-width': '2',
                    // The accent at ~35% — `stroke-opacity` rather than a colour token
                    // because the ink here is `currentColor` (a per-tenant record value,
                    // not a design-system colour), and only the stroke should soften.
                    'stroke-opacity': '0.35',
                    'stroke-linecap': 'round',
                    'stroke-dasharray': '264',
                    // The RESTING state, and the reduced-motion state: a whole ring.
                    'stroke-dashoffset': '0',
                    transform: 'rotate(-90 44 44)'
                },
                animation: 'dialRingFill',
                animationDuration: 'K1',
                animationTimingFunction: 'defaultBezier',
                animationIterationCount: 'infinite',
                // ⚠️ Load-bearing. css-in-props defaults a non-neutral last keyframe
                // to `both`; this animation ends transparent, so the default would
                // leave a reduced-motion visitor staring at an invisible ring. `none`
                // hands the resting state back to the attributes above.
                animationFillMode: 'none'
            }
        },
        // The dial itself: the org's mark. It TURNS in dial mode and is a plain
        // inert 56px box in flip mode (where the host does the flipping and this
        // wrapper simply rides it). The size is applied to THIS element and the
        // svg is sized by INLINE ATTRS injected into the markup below — NOT via
        // an `& svg` selector block. Measured 2026-08-19: such blocks are dropped
        // by published css-in-props builds (the trap LogoLoader.js documents), so
        // an earlier version rendered a 0x0, un-animated mark — i.e. the branded
        // loader showed NOTHING once the Symbols spiral was hidden.
        // The global prefers-reduced-motion rule in brand/designSystem/reset.js
        // collapses the turn for users who ask; the mark then rests at 0°.
        Dial: {
            display: 'flex',
            align: 'center center',
            boxSize: '56px',
            animation: (el, s)=>{
                const brand = s.root && s.root.whitelabelBrand;
                return brand && brand.loaderMotion === 'dial' ? 'dialTurn' : 'none';
            },
            animationDuration: 'K1',
            animationTimingFunction: 'defaultBezier',
            animationIterationCount: 'infinite',
            transformOrigin: '50% 50%',
            // Raw record markup: a published white-label logo is an inline SVG
            // string on the org record, sanitized server-side before it is ever
            // projected into the public payload. It cannot be an `Icon` — a sprite
            // reference resolves against the SHELL's icon set, which by definition
            // does not carry a customer's mark.
            html: (el, s)=>{
                const brand = s.root && s.root.whitelabelBrand;
                if (!brand) return '';
                const markup = brand.loaderLogoSvg || brand.logoSvg || '';
                if (typeof markup !== 'string' || !markup) return '';
                if (!/^\s*<svg\b/i.test(markup)) return markup;
                // The stored markup carries only a `viewBox` — without explicit
                // width/height it lays out at 0x0.
                return markup.replace(/\s(width|height)\s*=\s*(".*?"|'.*?')/gi, '').replace(/^\s*<svg\b/i, '<svg width="56" height="56" preserveAspectRatio="xMidYMid meet"');
            }
        }
    }
};

});

parcelRegister("92P67", function(module, exports) {

$parcel$export(module.exports, "_isNonMember", () => $695befe8942c698a$export$573aba1a3de0f87a);
$parcel$export(module.exports, "WhitelabelRequestAccess", () => $695befe8942c698a$export$8bd9664a408b1fec);
// WhitelabelRequestAccess — the SIGNED-IN non-member gate for a customer
// host (Nika 2026-08-30, option A: "a branded Request-an-invitation
// screen — no stranger enters the workspace").
//
// A visitor who signs in on app.<customer> with an account that is NOT a
// member of the host org used to land on the plain Symbols home (after
// NoOrgOverlay's whitelabel suppression removed the create-workspace ask).
// This full-viewport surface replaces that dead end with the SAME
// invitation contract the logged-out signup pane carries: the org's own
// published role list, one request, "we review every request".
//
// ── What it reuses, deliberately ─────────────────────────────────────────
// · scheme/accent/ground/mark — imported from WhitelabelSignin.js
//   (schemeOf/accentOf/whitelabelGround/sizedSvg), never re-derived: two
//   copies of the scheme precedence drift (MainLoader.js's argument).
// · WhitelabelRoleRow — the shared row component; its contract reads
//   `s.parent.suRole` and writes `s.parent.update({ suRole })`, so this
//   component's state key MUST stay `suRole`.
// · fetchWhitelabelOnboarding / submitWhitelabelOnboarding — the same
//   context functions the logged-out pane calls; the server matches the
//   role against the org's OWN allowlist and mints the invitation there.
//   The signed-in user's email is submitted VERBATIM (read-only in the
//   UI) — the invitation must land on the account that asked.
//
// ── Gating (fail closed on every unknown) ────────────────────────────────
// Shows ONLY when ALL of: auth ready + signed in; the host resolved a
// brand (root.whitelabelBrand); the host scope pin holds an org id
// (hostScopePin.js — null means "no opinion", so no gate); root.orgs is a
// LOADED array; and the pinned org is not among the user's orgs. Members,
// platform hosts, logged-out visitors and half-booted states all hide it.
// The mount site in app.js additionally gates on isCustomDomainHost(), so
// platform hosts never even mount the element.

var $bh6kd = parcelRequire("bh6kd");

var $fAXoF = parcelRequire("fAXoF");
const $695befe8942c698a$var$_brandOf = (s)=>s && s.root && s.root.whitelabelBrand || null;
const $695befe8942c698a$var$_userOf = (root)=>root && root.user || null;
const $695befe8942c698a$export$573aba1a3de0f87a = (0, $fAXoF.isWhitelabelNonMember);
// Fetch the org's published role list at most once per mount, and only
// while the gate is actually visible — a member must not cost the extra
// round-trip. Guarded through state so a remount re-reads (same shape as
// kickOnboarding in WhitelabelSignin.js).
const $695befe8942c698a$var$_kickRoles = (el, s)=>{
    if (!$695befe8942c698a$export$573aba1a3de0f87a(s.root)) return;
    const b = $695befe8942c698a$var$_brandOf(s);
    if (!b || !b.workspaceKey || s.onboardingKicked) return;
    s.update({
        onboardingKicked: true
    }, {
        preventUpdate: true
    });
    Promise.resolve(el.call('fetchWhitelabelOnboarding', {
        workspaceKey: b.workspaceKey
    })).then((cfg)=>{
        // `captcha` rides on the SAME response as the roles and is present
        // only when this org requires one — so it is parked, never guessed,
        // and a later config change needs no redeploy.
        const captcha = cfg && cfg.captcha || null;
        if (cfg && cfg.roles && cfg.roles.length) s.update({
            onboardingRoles: cfg.roles,
            onboardingCaptcha: captcha
        });
        else s.update({
            onboardingRoles: [],
            onboardingCaptcha: null
        });
    }).catch(()=>s.update({
            onboardingRoles: [],
            onboardingCaptcha: null
        }));
};
// Prefill the name from the signed-in account exactly once — typing must
// never be overwritten by a later auth refresh.
const $695befe8942c698a$var$_seedName = (el, s)=>{
    if (s.wraNameSeeded) return;
    const u = $695befe8942c698a$var$_userOf(s.root);
    if (!u) return;
    s.update({
        wraNameSeeded: true,
        wraName: u.name && String(u.name) || ''
    }, {
        preventUpdate: true
    });
};
const $695befe8942c698a$export$8bd9664a408b1fec = {
    tag: 'section',
    position: 'fixed',
    inset: '0',
    zIndex: 1200,
    overflowY: 'auto',
    flow: 'y',
    align: 'center center',
    padding: 'C A',
    hide: (el, s)=>!$695befe8942c698a$export$573aba1a3de0f87a(s.root),
    display: (el, s)=>$695befe8942c698a$export$573aba1a3de0f87a(s.root) ? 'flex' : 'none',
    background: (el, s)=>(0, $bh6kd.whitelabelGround)(s),
    color: (el, s)=>(0, $bh6kd.schemeOf)(s).ink,
    // Same reactive contract as NoOrgOverlay: the pieces of the predicate
    // land at different moments (auth snapshot, orgs, the late-applied
    // brand), and each write must re-evaluate the gate.
    subscribeTo: [
        'orgs',
        'signedIn',
        '_authReady',
        'whitelabelBrand',
        'user',
        '_hostScopeOrgId'
    ],
    state: {
        // WhitelabelRoleRow's binding contract — do not rename.
        suRole: '',
        onboardingKicked: false,
        onboardingRoles: null,
        onboardingCaptcha: null,
        // Written by WhitelabelTurnstile, read by Submit. Single-use: cleared
        // after every attempt.
        captchaToken: '',
        captchaWidgetId: null,
        wraName: '',
        wraNameSeeded: false,
        wraBusy: false,
        wraStatus: '',
        wraOk: false,
        wraSent: false
    },
    onRender: (el, s)=>{
        $695befe8942c698a$var$_kickRoles(el, s);
        $695befe8942c698a$var$_seedName(el, s);
    },
    onUpdate: (el, s)=>{
        $695befe8942c698a$var$_kickRoles(el, s);
        $695befe8942c698a$var$_seedName(el, s);
    },
    Lockup: {
        display: 'flex',
        flow: 'y',
        align: 'center center',
        gap: 'X',
        margin: '0 0 B',
        BrandGlyph: {
            tag: 'div',
            display: 'flex',
            align: 'center center',
            color: (el, s)=>(0, $bh6kd.accentOf)(s),
            html: (el, s)=>{
                const b = $695befe8942c698a$var$_brandOf(s);
                return (0, $bh6kd.sizedSvg)(b && b.logoSvg || '', 44);
            },
            aria: {
                hidden: 'true'
            }
        },
        Wordmark: {
            tag: 'h1',
            fontSize: 'A2',
            fontWeight: '700',
            letterSpacing: '0.24em',
            textTransform: 'uppercase',
            lineHeight: '1',
            textAlign: 'center',
            margin: '0',
            color: (el, s)=>(0, $bh6kd.accentOf)(s),
            text: (el, s)=>{
                const b = $695befe8942c698a$var$_brandOf(s);
                return b && b.name || '';
            }
        },
        Tagline: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z',
            color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
            display: (el, s)=>$695befe8942c698a$var$_brandOf(s) && $695befe8942c698a$var$_brandOf(s).tagline ? 'block' : 'none',
            text: (el, s)=>$695befe8942c698a$var$_brandOf(s) && $695befe8942c698a$var$_brandOf(s).tagline || ''
        }
    },
    Card: {
        width: '100%',
        // The width the login card collapses to on one column — same surface
        // family, same measure.
        maxWidth: '440px',
        flow: 'y',
        gap: 'Y',
        padding: 'A B',
        round: 'radiusCard',
        background: (el, s)=>(0, $bh6kd.schemeOf)(s).card,
        boxShadow: (el, s)=>(0, $bh6kd.schemeOf)(s).hairline,
        Heading: {
            display: 'flex',
            align: 'center flex-start',
            gap: 'Y',
            AccentBar: {
                tag: 'span',
                width: '3px',
                height: '15px',
                round: 'radiusPill',
                background: (el, s)=>(0, $bh6kd.accentOf)(s)
            },
            H: {
                tag: 'h2',
                margin: '0',
                fontSize: 'Z3',
                fontWeight: '700',
                text: '{{ workspace.requestAccess.title | polyglot }}'
            }
        },
        // ── The request form (until the request is accepted by the server) ──
        Intro: {
            tag: 'p',
            margin: '0',
            fontSize: 'Z1',
            color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
            hide: (el, s)=>!!s.wraSent,
            display: (el, s)=>s.wraSent ? 'none' : 'block',
            // Two written-out sentences: with the brand's own name, and without
            // one. A translated "this workspace" in the `{workspace}` slot would
            // need a case form the Georgian sentence cannot give it.
            text: (el, s)=>{
                const b = $695befe8942c698a$var$_brandOf(s);
                const u = $695befe8942c698a$var$_userOf(s.root);
                const who = u && u.email || el.call('polyglot', 'workspace.requestAccess.yourAccount');
                return b && b.name ? el.call('polyglot', 'workspace.requestAccess.intro').replace('{who}', who).replace('{workspace}', b.name) : el.call('polyglot', 'workspace.requestAccess.introNoName').replace('{who}', who);
            }
        },
        FormPane: {
            flow: 'y',
            gap: 'Y',
            hide: (el, s)=>!!s.wraSent,
            display: (el, s)=>s.wraSent ? 'none' : 'flex',
            RoleCaption: {
                tag: 'label',
                fontSize: 'Y',
                color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
                hide: (el, s)=>!(s.onboardingRoles && s.onboardingRoles.length),
                display: (el, s)=>s.onboardingRoles && s.onboardingRoles.length ? 'block' : 'none',
                text: '{{ workspace.requestAccess.question | polyglot }}'
            },
            RoleList: {
                display: 'flex',
                flow: 'y',
                gap: 'V',
                hide: (el, s)=>!(s.onboardingRoles && s.onboardingRoles.length),
                childExtends: 'WhitelabelRoleRow',
                childrenAs: 'state',
                children: (el, s)=>s.onboardingRoles || []
            },
            // The org published no self-serve roles — the request endpoint would
            // refuse, so say the honest thing instead of rendering a dead form.
            NoRolesNote: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z',
                color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
                hide: (el, s)=>s.onboardingRoles === null || s.onboardingRoles.length > 0,
                display: (el, s)=>s.onboardingRoles !== null && s.onboardingRoles.length === 0 ? 'block' : 'none',
                text: '{{ workspace.requestAccess.closed | polyglot }}'
            },
            NameCaption: {
                tag: 'label',
                fontSize: 'Y',
                color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
                hide: (el, s)=>!(s.onboardingRoles && s.onboardingRoles.length),
                display: (el, s)=>s.onboardingRoles && s.onboardingRoles.length ? 'block' : 'none',
                text: '{{ workspace.requestAccess.yourName | polyglot }}'
            },
            NameInput: {
                tag: 'input',
                type: 'text',
                autocomplete: 'name',
                width: '100%',
                padding: 'Y Z',
                round: 'radiusControl',
                background: (el, s)=>(0, $bh6kd.schemeOf)(s).field,
                color: (el, s)=>(0, $bh6kd.schemeOf)(s).ink,
                boxShadow: (el, s)=>(0, $bh6kd.schemeOf)(s).hairline,
                fontSize: 'Z1',
                borderWidth: '0',
                hide: (el, s)=>!(s.onboardingRoles && s.onboardingRoles.length),
                display: (el, s)=>s.onboardingRoles && s.onboardingRoles.length ? 'block' : 'none',
                value: (el, s)=>s.wraName,
                onInput: (e, el, s)=>s.update({
                        wraName: e.target.value
                    }, {
                        preventUpdate: true
                    })
            },
            Status: {
                tag: 'div',
                fontSize: 'Y',
                minHeight: 'X',
                color: (el, s)=>s.wraOk ? (0, $bh6kd.schemeOf)(s).ink : (0, $bh6kd.schemeOf)(s).danger,
                text: (el, s)=>s.wraStatus || ''
            },
            // The same shared slot the logged-out signup pane mounts, below the
            // status line for the same reason: the server's `captcha_failed`
            // message points "below". Absent captcha config → nothing renders.
            WhitelabelTurnstile: {},
            Submit: {
                tag: 'button',
                type: 'button',
                padding: 'Y A',
                round: 'radiusControl',
                borderWidth: '0',
                cursor: 'pointer',
                fontSize: 'Z1',
                fontWeight: '700',
                color: (el, s)=>(0, $bh6kd.schemeOf)(s).onAccent,
                background: (el, s)=>(0, $bh6kd.accentOf)(s),
                opacity: (el, s)=>s.wraBusy ? '0.6' : '1',
                hide: (el, s)=>!(s.onboardingRoles && s.onboardingRoles.length),
                display: (el, s)=>s.onboardingRoles && s.onboardingRoles.length ? 'block' : 'none',
                text: (el, s)=>el.call('polyglot', s.wraBusy ? 'workspace.requestAccess.sending' : 'workspace.requestAccess.submit'),
                onClick: async (e, el, s)=>{
                    if (s.wraBusy) return;
                    const b = $695befe8942c698a$var$_brandOf(s);
                    const u = $695befe8942c698a$var$_userOf(s.root);
                    s.update({
                        wraBusy: true,
                        wraStatus: '',
                        wraOk: false
                    });
                    const res = await el.call('submitWhitelabelOnboarding', {
                        workspaceKey: b && b.workspaceKey,
                        name: s.wraName,
                        email: u && u.email || '',
                        role: s.suRole,
                        captchaToken: s.captchaToken
                    });
                    // One token, one attempt — reset before a second press can replay
                    // a spent one.
                    el.call('resetWhitelabelTurnstile', {
                        state: s
                    });
                    s.update({
                        wraBusy: false,
                        wraOk: !!(res && res.ok),
                        wraSent: !!(res && res.ok),
                        wraStatus: res && res.message || ''
                    });
                }
            },
            FinePrint: {
                tag: 'div',
                fontSize: 'Y',
                color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
                hide: (el, s)=>!(s.onboardingRoles && s.onboardingRoles.length),
                display: (el, s)=>s.onboardingRoles && s.onboardingRoles.length ? 'block' : 'none',
                text: '{{ workspace.requestAccess.reviewNote | polyglot }}'
            }
        },
        // ── The sent state ──────────────────────────────────────────────────
        SentPane: {
            flow: 'y',
            gap: 'Y',
            hide: (el, s)=>!s.wraSent,
            display: (el, s)=>s.wraSent ? 'flex' : 'none',
            SentTitle: {
                tag: 'h3',
                margin: '0',
                fontSize: 'Z2',
                fontWeight: '700',
                text: '{{ workspace.requestAccess.sent | polyglot }}'
            },
            SentBody: {
                tag: 'p',
                margin: '0',
                fontSize: 'Z1',
                color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
                text: (el, s)=>el.call('polyglot', s.wraStatus || 'workspace.requestAccess.sentBody')
            }
        }
    },
    // The one escape: this account, on this host, has nothing else to do.
    Session: {
        display: 'flex',
        align: 'center center',
        gap: 'V',
        margin: 'A 0 0',
        Who: {
            tag: 'span',
            fontSize: 'Y',
            color: (el, s)=>(0, $bh6kd.schemeOf)(s).inkSoft,
            text: (el, s)=>{
                const u = $695befe8942c698a$var$_userOf(s.root);
                return u && u.email ? el.call('polyglot', 'workspace.requestAccess.signedInAs').replace('{email}', u.email) : '';
            }
        },
        SignOut: {
            tag: 'button',
            type: 'button',
            padding: '0',
            borderWidth: '0',
            cursor: 'pointer',
            fontSize: 'Y',
            fontWeight: '500',
            background: 'none',
            color: (el, s)=>(0, $bh6kd.accentOf)(s),
            text: '{{ workspace.requestAccess.signOut | polyglot }}',
            onClick: (e, el, s)=>el.call('signoutAndRedirect', {
                    sdk: el.sdk
                })
        }
    }
};

});


parcelRegister("1LN0i", function(module, exports) {

});

parcelRegister("eUYHx", function(module, exports) {
// Eager slim slice of the marketplace component barrel (#16).
//
// The full `./index.js` barrel `export *`s all 45 marketplace component files
// (the whole MarketplaceIsland UI tree, MarketplaceDetailModal, MarketplaceGrid,
// every *Section, the community feed, prompt gallery, …) — ~274KB that the
// unified shell dragged into its EAGER chunk via
// `import * from '../marketplace/components/index.js'` in workspace/context.js.
//
// Marketplace is now a lazy sub-app: the `/marketplace*` routes fold the FULL
// marketplace context into the live shell context on first mount
// (workspace/pages/index.js → lazySharedLib). So every marketplace UI key those
// routes reference resolves against the folded context — none of it needs to be
// eager.
//
// The shell's ONLY eager reference into the marketplace component barrel is the
// shell-root install modal: app.js polls `root.installModal` and, when set,
// opens a windows-API layer whose content is `{ extends: 'MarketplaceInstallModal' }`
// (~app.js:1156). That extends must resolve at the shell root regardless of fold
// state, so MarketplaceInstallModal + its transitive bare-key deps live here:
//   MarketplaceInstallModal.js also exports MarketplaceInstallConfigField,
//     MarketplaceInstallScopeStep, MarketplaceInstallConfigStep,
//     MarketplaceInstallCatalogError (one file, self-contained).
//   MarketplaceInstallModal `extends: 'IntegrationLogo'` for its header icon.
// Every function these components el.call (marketplaceHostOf, closeInstallModal,
// submitInstallModal, selectItemFresh, getKindAccent, hasIntegrationLogo, …)
// fires only at mount/interaction — the modal is only ever opened AFTER a
// marketplace surface folds the context — so those resolve via the fold (with
// closeInstallModal also carried in functions/eagerSlice.js as a direct backstop).
//
// marketplace/package.json has no `sideEffects: false`, so a re-export through
// `./index.js` would NOT tree-shake (referencing it evaluates every sibling
// source file). Each key below is therefore `export *`-ed from its SOURCE file
// directly, so only these two light modules ride the eager chunk.

var $44thE = parcelRequire("44thE");

var $TJLZY = parcelRequire("TJLZY");

var $iulQU = parcelRequire("iulQU");
$parcel$exportWildcard(module.exports, $44thE);
$parcel$exportWildcard(module.exports, $TJLZY);
$parcel$exportWildcard(module.exports, $iulQU);

});
parcelRegister("44thE", function(module, exports) {

$parcel$export(module.exports, "MarketplaceInstallConfigField", () => $2f6e4040a0e304f8$export$322c305f07beb9e);
$parcel$export(module.exports, "MarketplaceInstallCatalogError", () => $2f6e4040a0e304f8$export$a516a07bb949ae10);
$parcel$export(module.exports, "MarketplaceInstallScopeStep", () => $2f6e4040a0e304f8$export$29686b5965d79c5);
$parcel$export(module.exports, "MarketplaceInstallConfigStep", () => $2f6e4040a0e304f8$export$23944cfbd6ba6614);
$parcel$export(module.exports, "MarketplaceInstallModal", () => $2f6e4040a0e304f8$export$851b556ef3d420d2);
// Install modal for marketplace integration / registrar kinds.
//
// Triggered by clicking "Install" on any integration or registrar tile,
// or by `el.call('openInstallableModal', opts)` from any surface.
// Keeps the user on the current page (no full-page navigation) and
// walks through:
//
//   Step 1 — Scope selection (org / workspace / project). Auto-skips
//   steps when the user has a single org or the chosen org has a single
//   workspace. Project selection is always optional. Skipped entirely
//   when `defaultScope` is pre-filled by the caller.
//
//   Step 2 — Configuration form (integration-specific fields + API key).
//   Uses IntegrationScopePicker (shared) for scope and mirrors the
//   GenericIntNewForm field pattern for config fields.
//
// Phase 4 extensibility props (NEW):
//   preselectedKind   – string slug — opens modal pre-selected on this kind,
//                       skipping the browse step. Validated against live
//                       catalogue at mount; error shown when not found.
//   defaultScope      – { type: 'org'|'workspace'|'project', id: string } —
//                       pre-fills the scope picker, skipping manual selection.
//   catalogFilter     – { category?, applicable_to_types?, applicable_to_scopes? }
//                       — constrains which catalogue kinds the user can pick.
//                       If preselectedKind violates catalogFilter, error is shown.
//   onInstalled       – (instance) => void — callback fired after a successful
//                       install (optimistic). The instance is the raw API
//                       response body. Roll-back happens if the server later
//                       rejects.
//   domain            – 'integration'|'library'|'mcp'|'plugin'|'template' —
//                       used by domain-aware write target selection in
//                       `submitInstallModal`.
//
// State lives on the marketplace host (island or canvas page):
//   host.installModal: null | { item, step:'scope'|'config', draft:{},
//                               preselectedKind?, defaultScope?,
//                               catalogFilter?, onInstalled?, domain? }
//   host._installModalSaving: bool
//   host._installModalError: string | null
//
// The modal is gated by `host.installModal` (null → hidden) via a root
// reactive `display:` predicate on MarketplaceInstallModal itself — the
// SAME house overlay pattern MarketplaceSigninModal / MarketplaceDetailModal
// use (fixed inset, black.45 backdrop, centered flex, Esc + backdrop-click
// close). NOTE: this deliberately uses `display:` (returns 'flex' | 'none'),
// NOT `hide:`. An earlier revision gated with `hide:`, but a `hide:`d root
// is short-circuited out of the render tree and never re-evaluates its own
// predicate, so once mounted-closed it stuck at `display: none !important`
// forever — the backdrop + card never painted and the subtree stayed
// frozen (the "no background, unstyled floating block" bug). A `display:`
// predicate is a plain reactive style prop that always re-fires on host
// state changes, so the overlay shows/hides reliably. `display: 'none'`
// when closed also prevents any un-gated ModalTop/ModalName/CancelBtn
// fragment from leaking at rest — nothing inside can paint while the root
// is `none`, full stop.
//
// All functions are accessed via el.call('fnName', ...) per CLAUDE.md
// rule — no imports between project files.
// ── Scope wizard helpers ────────────────────────────────────────────────
// Resolve the org list. Marketplace mirrors _authClaims; governance
// exposes jwtClaims.orgs. Try both.
const $2f6e4040a0e304f8$var$_getOrgs = (host)=>{
    const claims = host?._authClaims || host?.root?._authClaims || {};
    const jwtOrgs = host?.root?.jwtClaims?.orgs || [];
    const metaOrg = claims.workspace_org_id ? [
        {
            id: claims.workspace_org_id,
            name: claims.workspace_org_id
        }
    ] : [];
    return jwtOrgs.length ? jwtOrgs : metaOrg;
};
// Resolve workspace list — the island host's own hydrated list first
// (ensureWorkspacesForAppPicker writes it for kind='app' installs), then
// the legacy root/claims sources (IntegrationScopePicker parity).
const $2f6e4040a0e304f8$var$_getWorkspaces = (host)=>{
    const orgId = host?._authClaims?.workspace_org_id || host?.root?.jwtClaims?.workspace_org_id;
    const list = Array.isArray(host?.workspaces) && host.workspaces.length ? host.workspaces : Array.isArray(host?.root?.workspaces) ? host.root.workspaces : host?.root?.jwtClaims?.workspaces || [];
    return orgId ? list.filter((w)=>!w.org_id || w.org_id === orgId) : list;
};
// Resolve project list — same dual-source as IntegrationScopePicker.
const $2f6e4040a0e304f8$var$_getProjects = (host)=>{
    const orgId = host?._authClaims?.workspace_org_id || host?.root?.jwtClaims?.workspace_org_id;
    if (Array.isArray(host?.root?.projects) && host.root.projects.length) return host.root.projects.map((p)=>({
            id: p.id || p._id || p.key,
            key: p.key || p.slug,
            name: p.name || p.displayName || p.key
        }));
    if (orgId) {
        const cache = (host?.root?._scopeProjectsByOrg || {})[orgId];
        if (Array.isArray(cache)) return cache;
    }
    return [];
};
const $2f6e4040a0e304f8$export$322c305f07beb9e = {
    extends: 'AppField',
    label: (el, s)=>{
        const req = s.required ? ' *' : '';
        return (s.label || s.key || '') + req;
    },
    AppInput: {
        type: (el, s)=>s.key && (s.key.includes('secret') || s.key.includes('key') || s.key.includes('token')) ? 'password' : 'text',
        placeholder: (el, s)=>s.placeholder || '',
        value: (el, s)=>{
            const host = el.call('marketplaceHostOf');
            return host?.installModal?.draft?.[s.key] || '';
        },
        onInput: (e, el, s)=>{
            const host = el.call('marketplaceHostOf');
            if (!host?.installModal) return;
            host.update?.({
                installModal: {
                    ...host.installModal,
                    draft: {
                        ...host.installModal.draft || {},
                        [s.key]: e.target.value
                    }
                }
            });
        }
    }
};
const $2f6e4040a0e304f8$export$a516a07bb949ae10 = {
    flow: 'y',
    gap: 'Z',
    padding: 'A',
    round: 'radiusControl',
    color: 'dangerInk',
    background: 'color-mix(in srgb, currentColor 10%, transparent)',
    role: 'alert',
    hide: (el)=>{
        const host = el.call('marketplaceHostOf');
        return !host?.installModal?._catalogError;
    },
    ErrorIcon: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        color: 'currentColor',
        text: '!'
    },
    ErrorText: {
        tag: 'p',
        fontSize: 'Y',
        color: 'currentColor',
        margin: '0',
        text: (el)=>{
            const host = el.call('marketplaceHostOf');
            return host?.installModal?._catalogError || '';
        }
    }
};
const $2f6e4040a0e304f8$export$29686b5965d79c5 = {
    flow: 'y',
    gap: 'A',
    ScopeTitle: {
        tag: 'h4',
        text: (el)=>{
            const host = el.call('marketplaceHostOf');
            return el.call('polyglot', host?.installModal?.item?.kind === 'app' ? 'marketplace.install.scopeTitleApp' : 'marketplace.install.scopeTitle');
        },
        fontSize: 'Z',
        fontWeight: '700',
        color: 'title',
        margin: '0'
    },
    ScopeHint: {
        tag: 'p',
        fontSize: 'Y',
        color: 'caption',
        margin: '0',
        text: (el)=>{
            const host = el.call('marketplaceHostOf');
            return el.call('polyglot', host?.installModal?.item?.kind === 'app' ? 'marketplace.install.scopeHintApp' : 'marketplace.install.scopeHint');
        }
    },
    // Org-missing guard: user has no org → block with message.
    NoOrgWarning: {
        flow: 'y',
        gap: 'Z',
        padding: 'A',
        round: 'radiusControl',
        // The danger surface: the `dangerInk` pair on a wash of itself (it was
        // a raw `red.1` fill under raw `red` ink).
        color: 'dangerInk',
        background: 'color-mix(in srgb, currentColor 10%, transparent)',
        role: 'alert',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf');
            const orgs = $2f6e4040a0e304f8$var$_getOrgs(host);
            return orgs.length > 0;
        },
        NoOrgText: {
            tag: 'p',
            fontSize: 'Y',
            color: 'currentColor',
            margin: '0',
            text: '{{ marketplace.install.noOrg | polyglot }}'
        }
    },
    ScopeForm: {
        flow: 'y',
        gap: 'A',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf');
            const orgs = $2f6e4040a0e304f8$var$_getOrgs(host);
            return orgs.length === 0;
        },
        // Scope mode buttons (org / workspace / project) — mirrors IntegrationScopePicker.Modes.
        // 3 independent pill buttons (not a joined segmented track), so wrapping
        // onto a second line is a clean reflow rather than a broken shape —
        // "Project (optional)" alone pushed this row past a narrow modal step.
        ScopeModes: {
            flow: 'x',
            gap: 'Z',
            wrap: 'wrap',
            rowGap: 'Z',
            ScopeModeOrg: {
                extends: 'Button',
                text: '{{ marketplace.install.scopeOrg | polyglot }}',
                minHeight: 'controlHCompact',
                padding: '0 A',
                round: 'radiusPill',
                // Workspace apps install directly into a workspace — never org
                // scope (WORKSPACE_APPS.md "Install": "scope constrained to
                // workspace").
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    return host?.installModal?.item?.kind === 'app';
                },
                // Active-mode fill converges on the house pattern (`selected` +
                // title — DESIGN_LANGUAGE.md §4.3, non-negotiable) instead of a
                // saturated blue fill.
                background: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'org' ? 'selected' : 'transparent';
                },
                color: 'title',
                borderColor: 'line',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            draft: {
                                ...host.installModal.draft || {},
                                scopeType: 'org',
                                scopeId: null
                            }
                        },
                        _scopeWsQuery: '',
                        _scopeProjQuery: ''
                    });
                }
            },
            ScopeModeWorkspace: {
                extends: 'Button',
                text: '{{ marketplace.install.scopeWorkspace | polyglot }}',
                minHeight: 'controlHCompact',
                padding: '0 A',
                round: 'radiusPill',
                background: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'workspace' ? 'selected' : 'transparent';
                },
                color: 'title',
                borderColor: 'line',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            draft: {
                                ...host.installModal.draft || {},
                                scopeType: 'workspace',
                                scopeId: (()=>{
                                    const ws = $2f6e4040a0e304f8$var$_getWorkspaces(host);
                                    return ws.length === 1 ? ws[0].id || ws[0].workspace_id || ws[0]._id : null;
                                })()
                            }
                        },
                        _scopeWsQuery: ''
                    });
                }
            },
            ScopeModeProject: {
                extends: 'Button',
                text: '{{ marketplace.install.scopeProject | polyglot }}',
                minHeight: 'controlHCompact',
                padding: '0 A',
                round: 'radiusPill',
                // Same constraint as ScopeModeOrg above — apps never scope to
                // a project.
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    return host?.installModal?.item?.kind === 'app';
                },
                background: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const scopeType = host?.installModal?.draft?.scopeType || 'org';
                    return scopeType === 'project' ? 'selected' : 'transparent';
                },
                color: 'title',
                borderColor: 'line',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            draft: {
                                ...host.installModal.draft || {},
                                scopeType: 'project',
                                scopeId: null
                            }
                        },
                        _scopeProjQuery: ''
                    });
                }
            }
        },
        // Workspace picker — visible when scopeType === 'workspace'.
        WorkspacePicker: {
            flow: 'y',
            gap: 'Z',
            hide: (el)=>{
                const host = el.call('marketplaceHostOf');
                return (host?.installModal?.draft?.scopeType || 'org') !== 'workspace';
            },
            WorkspacePickerLabel: {
                tag: 'label',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '700',
                text: '{{ marketplace.install.selectWorkspace | polyglot }}'
            },
            // A listbox on the kit's FIELD surface (it is an input); the rows sit
            // on it flat, apart by a gap — no hairlines inside a rounded box.
            WorkspaceList: {
                flow: 'y',
                gap: 'V',
                padding: 'X',
                maxHeight: 'E',
                overflowY: 'auto',
                overscrollBehavior: 'contain',
                round: 'radiusControl',
                theme: 'field',
                childrenAs: 'state',
                // Flat rows on the listbox (the gap separates them — no hairlines
                // inside the rounded box), the selected row on the `selected` wash
                // with the ink check (WsCheck below).
                childExtends: {
                    tag: 'button',
                    type: 'button',
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: 'Z',
                    align: 'center left',
                    width: '100%',
                    padding: 'Y Z1',
                    round: 'radiusControl',
                    border: 'none',
                    // Selected-row fill converges on the house active pattern
                    // (`selected` + title, DESIGN_LANGUAGE.md §4.3) — hover on the
                    // already-selected row stays `selected` too (not the neutral
                    // `hover` wash) so a selected row still doesn't change appearance
                    // on hover.
                    background: (el, s)=>s._selected ? 'selected' : 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    textAlign: 'left',
                    ':hover': {
                        background: (el, s)=>s._selected ? 'selected' : 'hover'
                    },
                    // The workspace's NAME — primary text, never cut (the overflow
                    // law, HOME_AMBIENT_SKIN_SPEC §3b rule 8): it wraps beside the check.
                    WsLabel: {
                        tag: 'span',
                        minWidth: '0',
                        overflowWrap: 'anywhere',
                        text: (el, s)=>s._label || ''
                    },
                    // House `Icon` replaces the old ✓ text glyph (Rule 29).
                    WsCheck: {
                        extends: 'Icon',
                        name: 'check',
                        fontSize: 'Y1',
                        // Selection is monochrome (P5) — the check in ink.
                        color: 'title',
                        hide: (el, s)=>!s._selected
                    },
                    onClick: (e, el, s)=>{
                        const host = el.call('marketplaceHostOf');
                        if (!host?.installModal) return;
                        host.update?.({
                            installModal: {
                                ...host.installModal,
                                draft: {
                                    ...host.installModal.draft || {},
                                    scopeType: 'workspace',
                                    scopeId: s._value || null
                                }
                            }
                        });
                    }
                },
                children: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const curId = host?.installModal?.draft?.scopeId || '';
                    const ws = $2f6e4040a0e304f8$var$_getWorkspaces(host).map((w)=>({
                            id: w.id || w.workspace_id || w._id,
                            name: w.name || w.id || w.workspace_id
                        }));
                    if (!ws.length) return [];
                    return ws.map((w)=>({
                            _value: w.id,
                            _label: w.name,
                            _selected: w.id === curId
                        }));
                },
                WorkspaceEmpty: {
                    tag: 'span',
                    padding: 'V Z1',
                    fontSize: 'Z2',
                    color: 'caption',
                    fontStyle: 'italic',
                    hide: (el)=>{
                        const host = el.call('marketplaceHostOf');
                        return $2f6e4040a0e304f8$var$_getWorkspaces(host).length > 0;
                    },
                    text: '{{ marketplace.install.noWorkspaces | polyglot }}'
                }
            }
        },
        // Project picker — visible when scopeType === 'project'.
        ProjectPicker: {
            flow: 'y',
            gap: 'Z',
            hide: (el)=>{
                const host = el.call('marketplaceHostOf');
                return (host?.installModal?.draft?.scopeType || 'org') !== 'project';
            },
            ProjectPickerLabel: {
                tag: 'label',
                fontSize: 'Y2',
                color: 'caption',
                fontWeight: '700',
                text: '{{ marketplace.install.selectProject | polyglot }}'
            },
            // A listbox on the kit's FIELD surface (it is an input); the rows sit
            // on it flat, apart by a gap — no hairlines inside a rounded box.
            ProjectList: {
                flow: 'y',
                gap: 'V',
                padding: 'X',
                maxHeight: 'E',
                overflowY: 'auto',
                overscrollBehavior: 'contain',
                round: 'radiusControl',
                theme: 'field',
                childrenAs: 'state',
                // The same flat-row + ink-check pattern as WorkspaceList above.
                childExtends: {
                    tag: 'button',
                    type: 'button',
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: 'Z',
                    align: 'center left',
                    width: '100%',
                    padding: 'Y Z1',
                    round: 'radiusControl',
                    border: 'none',
                    // Selected-row fill converges on the house active pattern
                    // (`selected` + title, DESIGN_LANGUAGE.md §4.3) — hover on the
                    // already-selected row stays `selected` too (not the neutral
                    // `hover` wash) so a selected row still doesn't change appearance
                    // on hover.
                    background: (el, s)=>s._selected ? 'selected' : 'transparent',
                    color: 'title',
                    cursor: 'pointer',
                    fontSize: 'Z2',
                    textAlign: 'left',
                    ':hover': {
                        background: (el, s)=>s._selected ? 'selected' : 'hover'
                    },
                    // The project's NAME — primary text, never cut (overflow law
                    // rule 8): it wraps beside the check.
                    ProjLabel: {
                        tag: 'span',
                        minWidth: '0',
                        overflowWrap: 'anywhere',
                        text: (el, s)=>s._label || ''
                    },
                    // House `Icon` replaces the old ✓ text glyph (Rule 29).
                    ProjCheck: {
                        extends: 'Icon',
                        name: 'check',
                        fontSize: 'Y1',
                        // Selection is monochrome (P5) — the check in ink.
                        color: 'title',
                        hide: (el, s)=>!s._selected
                    },
                    onClick: (e, el, s)=>{
                        const host = el.call('marketplaceHostOf');
                        if (!host?.installModal) return;
                        const curId = host.installModal.draft?.scopeId || '';
                        // Clicking the already-selected project deselects (no project).
                        const nextId = s._value === curId ? null : s._value || null;
                        host.update?.({
                            installModal: {
                                ...host.installModal,
                                draft: {
                                    ...host.installModal.draft || {},
                                    scopeType: 'project',
                                    scopeId: nextId
                                }
                            }
                        });
                    }
                },
                children: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const curId = host?.installModal?.draft?.scopeId || '';
                    const projects = $2f6e4040a0e304f8$var$_getProjects(host);
                    if (!projects.length) return [];
                    return projects.map((p)=>({
                            _value: p.id || p.key,
                            _label: p.name || p.key || p.id,
                            _selected: (p.id || p.key) === curId
                        }));
                },
                ProjectEmpty: {
                    tag: 'span',
                    padding: 'V Z1',
                    fontSize: 'Z2',
                    color: 'caption',
                    fontStyle: 'italic',
                    hide: (el)=>{
                        const host = el.call('marketplaceHostOf');
                        return $2f6e4040a0e304f8$var$_getProjects(host).length > 0;
                    },
                    text: '{{ marketplace.install.noProjects | polyglot }}'
                }
            }
        }
    }
};
const $2f6e4040a0e304f8$export$23944cfbd6ba6614 = {
    flow: 'y',
    gap: 'A',
    ConfigTitle: {
        tag: 'h4',
        text: (el)=>{
            const host = el.call('marketplaceHostOf');
            const item = host?.installModal?.item;
            return el.call('polyglot', 'marketplace.install.configureTitle').replace('{name}', el.call('storeItemText', item, 'name') || el.call('polyglot', 'marketplace.install.genericIntegration'));
        },
        fontSize: 'Z',
        fontWeight: '700',
        color: 'title',
        margin: '0'
    },
    // Display name field — only shown when allows_multiple. The shared field
    // kit, like the config fields above; `label` is a FUNCTION prop — the kit
    // also names the control with it, and an attribute never resolves a
    // `{{ }}` template.
    DisplayNameField: {
        extends: 'AppField',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf');
            const item = host?.installModal?.item;
            return !item?._liveKind?.allows_multiple;
        },
        label: (el)=>el.call('polyglot', 'marketplace.install.displayName'),
        AppInput: {
            type: 'text',
            // The kind record's own label first; the bundle only as the fallback.
            placeholder: (el)=>{
                const host = el.call('marketplaceHostOf');
                return host?.installModal?.item?._liveKind?.label || el.call('polyglot', 'marketplace.install.displayNamePlaceholder');
            },
            value: (el)=>{
                const host = el.call('marketplaceHostOf');
                return host?.installModal?.draft?.displayName || '';
            },
            onInput: (e, el)=>{
                const host = el.call('marketplaceHostOf');
                if (!host?.installModal) return;
                host.update?.({
                    installModal: {
                        ...host.installModal,
                        draft: {
                            ...host.installModal.draft || {},
                            displayName: e.target.value
                        }
                    }
                });
            }
        }
    },
    // Dynamic config fields from config_schema.fields. Belt-and-braces gate
    // (WS-APPS ticket "audit inner hide-gates for at-rest leakage"): the
    // enclosing MarketplaceInstallConfigStep already hides for
    // `step !== 'config'` at its own call site, but this container now also
    // checks the step directly so MarketplaceInstallConfigField never
    // renders (with a blank draft) outside the config step even if this
    // component is ever mounted somewhere that doesn't wrap it that way.
    DynamicConfigFields: {
        flow: 'y',
        gap: 'A',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf');
            const modal = host?.installModal;
            if (!modal || (modal.step || 'scope') !== 'config') return true;
            const item = modal.item;
            const fields = (item?._liveKind?.config_schema?.fields || []).filter((f)=>f.key !== 'display_name');
            return fields.length === 0;
        },
        childrenAs: 'state',
        childExtends: 'MarketplaceInstallConfigField',
        children: (el)=>{
            const host = el.call('marketplaceHostOf');
            const item = host?.installModal?.item;
            return (item?._liveKind?.config_schema?.fields || []).filter((f)=>f.key !== 'display_name');
        }
    },
    // API key / secret field — hidden for oauth2 / webhook / none auth models.
    // The shared field kit: the kind record's own secret label is the field
    // label, and its secret hint rides the kit's hint line under the control
    // (the kit hides the line while the hint is empty).
    SecretField: {
        extends: 'AppField',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf');
            const item = host?.installModal?.item;
            const kr = item?._liveKind;
            if (!kr || kr.auth_model === 'none') return true;
            const flow = kr.ui_flow || 'credential';
            return flow === 'oauth2' || flow === 'webhook';
        },
        label: (el)=>{
            const host = el.call('marketplaceHostOf');
            const item = host?.installModal?.item;
            return item?._liveKind?.secret_label || el.call('polyglot', 'marketplace.install.secretLabel');
        },
        hint: (el)=>{
            const host = el.call('marketplaceHostOf');
            const item = host?.installModal?.item;
            return item?._liveKind?.secret_hint || '';
        },
        AppInput: {
            type: 'password',
            placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
            value: (el)=>{
                const host = el.call('marketplaceHostOf');
                return host?.installModal?.draft?.secret || '';
            },
            onInput: (e, el)=>{
                const host = el.call('marketplaceHostOf');
                if (!host?.installModal) return;
                host.update?.({
                    installModal: {
                        ...host.installModal,
                        draft: {
                            ...host.installModal.draft || {},
                            secret: e.target.value
                        }
                    }
                });
            }
        }
    },
    // No-config notice for integrations that need no configuration.
    NoConfigNotice: {
        tag: 'p',
        fontSize: 'Y',
        color: 'caption',
        margin: '0',
        fontStyle: 'italic',
        hide: (el)=>{
            const host = el.call('marketplaceHostOf');
            const item = host?.installModal?.item;
            const kr = item?._liveKind;
            if (!kr) return false;
            const fields = (kr.config_schema?.fields || []).filter((f)=>f.key !== 'display_name');
            const authModel = kr.auth_model || 'none';
            const flow = kr.ui_flow || 'credential';
            const needsSecret = authModel !== 'none' && flow !== 'oauth2' && flow !== 'webhook';
            return fields.length > 0 || needsSecret;
        },
        text: '{{ marketplace.install.noConfig | polyglot }}'
    }
};
const $2f6e4040a0e304f8$export$851b556ef3d420d2 = {
    // House overlay pattern — a REACTIVE `display:` predicate, exactly like
    // the two working siblings (MarketplaceSigninModal / MarketplaceDetailModal),
    // NOT `hide:`. Root cause of the "no backdrop, unstyled floating block"
    // report: `hide:` short-circuits the root out of the render tree while
    // `installModal` is null, and a hidden root never re-evaluates its OWN
    // `hide` predicate — so it stayed `display: none !important` forever once
    // mounted-closed, and the whole subtree stayed frozen even after
    // `installModal` was set. `display` is a plain reactive style prop that
    // re-fires on every host-state change regardless of current visibility
    // (the siblings prove it opens/closes reliably), so the overlay paints
    // and the subtree goes live. When shown it is `flex`, which activates the
    // `align: 'center center'` centering below.
    display: (el)=>{
        const host = el.call('marketplaceHostOf');
        return host?.installModal ? 'flex' : 'none';
    },
    position: 'fixed',
    inset: '0',
    // Above MarketplaceDetailModal (1900) — the install flow can open on
    // top of an already-open detail sheet (dispatchInstallWithScope /
    // ActionGroup's ScopeMenu don't close the detail modal first) — and
    // below MarketplaceSigninModal (2001), which supersedes it entirely
    // when a logged-out visitor needs to authenticate first.
    zIndex: '1950',
    align: 'center center',
    // THE one blocking veil (DESIGN_SPEC §6.3) — the `backdrop` theme, fading
    // in as the root flips to flex; same as MarketplaceDetailModal (it was a
    // raw theme-invariant `black.45` + a 4px blur of its own).
    theme: 'backdrop',
    animationName: 'fadeIn',
    animationDuration: 'C',
    animationTimingFunction: 'defaultBezier',
    animationFillMode: 'both',
    // THE EXIT (closeInstallModal -> marketplaceCloseWithExit), same as
    // MarketplaceDetailModal: the veil fades out, the window leaves on
    // `modalOut`, then the state clears.
    dataClosing: (el)=>!!el.call('marketplaceHostOf')?._installModalClosing,
    '&[data-closing]': {
        animationName: 'fadeOut',
        animationDuration: 'B',
        pointerEvents: 'none'
    },
    padding: 'A',
    onKeydown: (e, el)=>{
        if (e.key !== 'Escape') return;
        const host = el.call('marketplaceHostOf');
        el.call('closeInstallModal', host);
        e.preventDefault();
    },
    onClick: (e, el)=>{
        if (e.target !== el.node) return;
        const host = el.call('marketplaceHostOf');
        el.call('closeInstallModal', host);
    },
    ModalWindow: {
        // Brand's ModalWindow auto-mounts a `ModalHeader: {}` slot (an empty
        // Hgroup/H/P + a redundant second close X) — same fix
        // MarketplaceDetailModal.js's Window already applies; this file was
        // missing it, which doubled up on top of the ModalTop header below.
        ModalHeader: null,
        // The overlay SHEET (DESIGN_SPEC §6.2): the opaque `dialog` THEME (never
        // `background: 'dialog'` — a theme name in a colour slot paints nothing),
        // `radiusSheet`, the `overlay` elevation, which carries the ring — so no
        // hairline border (borderless law). It rises on the spring as the veil
        // fades in (`modalIn`, D springBezier).
        theme: 'dialog',
        flow: 'y',
        gap: 'A',
        padding: 'B',
        round: 'radiusSheet',
        minWidth: 'G',
        // The form width of the overlay scale (`overlayMd`, 480px — fixed, never
        // em: the sheet must not scale with the font of what it floats over).
        maxWidth: 'overlayMd',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        // Vertical scroll only. The full-bleed ModalFooter
        // (negative `margin: 0 -B` to reach the card edges) otherwise bleed a
        // hair past the box and raise a spurious horizontal scrollbar at this
        // width — clip it so the card never scrolls sideways.
        overflowX: 'hidden',
        shadow: 'overlay',
        animationName: 'modalIn',
        animationDuration: 'D',
        animationTimingFunction: 'springBezier',
        animationFillMode: 'both',
        dataClosing: (el)=>!!el.call('marketplaceHostOf')?._installModalClosing,
        '&[data-closing]': {
            animationName: 'modalOut',
            animationDuration: 'C',
            animationTimingFunction: 'defaultBezier'
        },
        // Tab-trapping for a11y — focus stays inside the modal.
        tabindex: '-1',
        // Header: integration logo + name + close button.
        ModalTop: {
            flow: 'x',
            align: 'center space-between',
            gap: 'A',
            ModalTitleRow: {
                flow: 'x',
                align: 'center',
                gap: 'Z',
                ModalIcon: {
                    extends: 'IntegrationLogo',
                    width: 'C',
                    height: 'C',
                    minWidth: 'C',
                    fontSize: 'B',
                    logo: (el)=>el.call('marketplaceHostOf')?.installModal?.item?.logo,
                    name: (el)=>el.call('storeItemText', el.call('marketplaceHostOf')?.installModal?.item, 'name'),
                    kind: (el)=>el.call('marketplaceHostOf')?.installModal?.item?.kind
                },
                ModalTitle: {
                    flow: 'y',
                    gap: 'V',
                    ModalName: {
                        tag: 'h3',
                        text: (el)=>{
                            const host = el.call('marketplaceHostOf');
                            return el.call('polyglot', 'marketplace.install.title').replace('{name}', el.call('storeItemText', host?.installModal?.item, 'name'));
                        },
                        fontSize: 'B',
                        fontWeight: '700',
                        color: 'title',
                        margin: '0'
                    },
                    // "STEP 1 OF 2" — the mono micro-label of the redesign (r044).
                    ModalStepLabel: {
                        extends: 'AppMicroLabel',
                        text: (el)=>{
                            const host = el.call('marketplaceHostOf');
                            const modal = host?.installModal;
                            const step = modal?.step || 'scope';
                            // Apps have NO config step (NextBtn is hidden, InstallBtn shows on
                            // the scope step) — so the "Step 1 of 2" label lied. A one-step
                            // flow gets a plain label, not a fake 2-step counter.
                            if (modal?.item?.kind === 'app') return el.call('polyglot', 'marketplace.install.stepChooseWorkspace');
                            // When defaultScope is pre-filled, we skip scope step — show single-step label
                            if (modal?.defaultScope && step === 'config') return el.call('polyglot', 'marketplace.install.stepConfigure');
                            if (modal?._catalogError) return el.call('polyglot', 'marketplace.install.stepError');
                            return el.call('polyglot', step === 'scope' ? 'marketplace.install.stepOneOfTwo' : 'marketplace.install.stepTwoOfTwo');
                        }
                    }
                }
            },
            ModalCloseBtn: {
                extends: 'CloseButton',
                aria: {
                    label: (el)=>el.call('polyglot', 'marketplace.install.closeAria')
                },
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    el.call('closeInstallModal', host);
                }
            }
        },
        // (No divider: the head and the step are set apart by the sheet's `A`
        // gap, not a full-bleed hairline — no rules inside a rounded surface.)
        // Step body — swaps between scope and config.
        ModalBody: {
            flow: 'y',
            gap: 'A',
            flex: '1',
            // Catalog validation error — shown when preselectedKind doesn't exist
            // in catalogue or violates catalogFilter. Replaces both steps.
            MarketplaceInstallCatalogError: {},
            // Step 1: scope selection. Hidden when defaultScope is pre-filled
            // (openInstallableModal pre-validates the scope) or catalog error exists.
            MarketplaceInstallScopeStep: {
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    if (modal.defaultScope) return true // scope step skipped when pre-filled
                    ;
                    return modal.step !== 'scope';
                }
            },
            // Step 2: configuration form.
            MarketplaceInstallConfigStep: {
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    // When defaultScope pre-fills scope, skip directly to config
                    if (modal.defaultScope) return modal.step !== 'config';
                    return modal.step !== 'config';
                }
            },
            // Error display — shown on any step when an error exists.
            ModalError: {
                tag: 'p',
                padding: 'Y A',
                round: 'radiusControl',
                // The danger surface: `dangerInk` on a wash of itself (was a raw
                // `red.1` fill under raw `red` ink), announced.
                color: 'dangerInk',
                background: 'color-mix(in srgb, currentColor 10%, transparent)',
                role: 'alert',
                fontSize: 'Y',
                margin: '0',
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    return !host?._installModalError;
                },
                text: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    return host?._installModalError || '';
                }
            }
        },
        // Footer with navigation / action buttons.
        // The actions (DESIGN_SPEC §5.1): ghost secondaries, the ink primary —
        // the capsule kit's own geometry, never a call-site copy of it (Rule 68).
        // Set apart by the sheet's gap, not a full-bleed hairline.
        ModalFooter: {
            flow: 'x',
            align: 'center flex-end',
            gap: 'Z',
            paddingTop: 'Z',
            // Preview button — opens the gallery detail view for the modal's
            // current item. Moved here from the integration tile rows so the
            // preview action lives alongside the install flow, not duplicated
            // on every row in the list.
            PreviewBtn: {
                extends: 'AppCapsuleBtnGhost',
                text: '{{ marketplace.install.preview | polyglot }}',
                title: (el)=>el.call('polyglot', 'marketplace.install.previewTooltip'),
                aria: {
                    label: (el)=>el.call('polyglot', 'marketplace.install.previewAria')
                },
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    return !host?.installModal?.item;
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    const host = el.call('marketplaceHostOf');
                    const item = host?.installModal?.item;
                    if (!item) return;
                    el.call('closeInstallModal', host);
                    el.call('selectItemFresh', host, item);
                }
            },
            // Cancel button — always visible.
            CancelBtn: {
                extends: 'AppCapsuleBtnGhost',
                text: '{{ marketplace.install.cancel | polyglot }}',
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    el.call('closeInstallModal', host);
                }
            },
            // Back button — config step only; hidden when defaultScope pre-fills
            // scope (nowhere to go back to) or when catalog error is shown.
            BackBtn: {
                extends: 'AppCapsuleBtnGhost',
                text: '{{ marketplace.install.back | polyglot }}',
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    if (modal.defaultScope) return true // no scope step to go back to
                    ;
                    return modal.step !== 'config';
                },
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            step: 'scope'
                        },
                        _installModalError: null
                    });
                }
            },
            // Next button — scope step → config step. Hidden when defaultScope
            // is pre-filled (modal opens directly on config step) or catalog error shown.
            NextBtn: {
                extends: 'AppCapsuleBtnPrimary',
                text: '{{ marketplace.install.next | polyglot }}',
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    // Workspace apps carry no config step (no API keys / config fields)
                    // — they install directly from the scope step, so there's no
                    // "Next: Configure" to show (the one-click in-shell path).
                    if (modal.item?.kind === 'app') return true;
                    if (modal.defaultScope) return true // scope step is skipped entirely
                    ;
                    if (modal.step !== 'scope') return true;
                    // Hide if org list is empty (blocked).
                    const orgs = $2f6e4040a0e304f8$var$_getOrgs(host);
                    return orgs.length === 0;
                },
                onClick: (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    if (!host?.installModal) return;
                    host.update?.({
                        installModal: {
                            ...host.installModal,
                            step: 'config'
                        },
                        _installModalError: null
                    });
                }
            },
            // Install button — config step only; submits the form.
            // When defaultScope is pre-filled we open directly to config, so
            // this button is visible from the moment the modal opens.
            InstallBtn: {
                extends: 'AppCapsuleBtnPrimary',
                text: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    return el.call('polyglot', host?._installModalSaving ? 'marketplace.action.installing' : 'marketplace.action.install');
                },
                disabled: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    return !!host?._installModalSaving;
                },
                hide: (el)=>{
                    const host = el.call('marketplaceHostOf');
                    const modal = host?.installModal;
                    if (!modal || modal._catalogError) return true;
                    // Workspace apps install straight from the scope step (no config
                    // step) — the one-click in-shell path the open-flow sets up.
                    if (modal.item?.kind === 'app') return false;
                    if (modal.defaultScope) return modal.step !== 'config';
                    return modal.step !== 'config';
                },
                onClick: async (e, el)=>{
                    const host = el.call('marketplaceHostOf');
                    await el.call('submitInstallModal', host, el);
                }
            }
        }
    }
};

});

parcelRegister("TJLZY", function(module, exports) {

$parcel$export(module.exports, "IntegrationLogo", () => $0a78a4c479b098bf$export$5bcb1db9226425b);
'use strict';
const $0a78a4c479b098bf$export$5bcb1db9226425b = {
    align: 'center center',
    overflow: 'hidden',
    fontWeight: '700',
    width: 'B',
    height: 'B',
    minWidth: 'B',
    borderRadius: 'radiusControl',
    fontSize: 'A',
    background: (el)=>el.call('getKindAccent', el.kind, 'bg'),
    color: (el)=>el.call('getKindAccent', el.kind, 'fg'),
    // Brand glyph — shown only when a local logo exists for the slug. Inherits
    // `color` (the kind accent fg) via the Icon's `fill: currentColor`.
    Icon: {
        if: (el)=>!!(el.parent.logo && el.call('hasIntegrationLogo', el.parent.logo)),
        name: (el)=>el.parent.logo,
        width: '60%',
        height: '60%'
    },
    // Letter fallback — first character of the name, shown when there's no
    // local logo for the slug (or no slug at all).
    LogoLetter: {
        hide: (el)=>!!(el.parent.logo && el.call('hasIntegrationLogo', el.parent.logo)),
        tag: 'span',
        // The initial comes from the RESOLVED name — a row whose name is a bundle
        // key would otherwise render "a" from `apps.catalog.…`.
        text: (el)=>(el.call('storeItemText', el.parent, 'name') || '')[0]?.toUpperCase() || '?'
    }
};

});

parcelRegister("iulQU", function(module, exports) {

$parcel$export(module.exports, "MarketplaceSegment", () => $d75bfac8abe228f4$export$5bb1c7d4bbc9420a);
// One segment of the store's segmented controls — the look only. Two
// controls share it: the surface switcher (MarketplaceSurfaceTabs — App Store
// · Marketplace · Integrations, buttons inside one page) and the catalogue
// row (AppsCatalogueTabs — Workspace apps · App Store, links between
// two pages). Each extends this and adds its own role, element and click; the
// segment reads its state from `el.isActive` and its words from `s.label` (a
// polyglot KEY).
//
// Visual: an iOS/App-Store segmented control segment — the active one lifted
// to the house active pattern (`selected` fill + `title` text) over the
// track's own tint, never a one-off accent fill.
const $d75bfac8abe228f4$export$5bb1c7d4bbc9420a = {
    flow: 'x',
    align: 'center',
    gap: 'X',
    // Roomier than a filter chip — this is the page's primary switch, not
    // another filter, so it carries a full type step more presence.
    minHeight: 'controlH',
    padding: '0 B',
    // The labels are `nowrap` by design, so below `mobileL` a trio's
    // max-content width (~384px plus the bar's own B inset) outgrew a 390px
    // viewport and the track clipped "Integrations" at the right edge (measured
    // 2026-09-02). Trading the B side inset for A on each segment (and A on the
    // bar) brings the whole control back inside the line, so it needs no scroll
    // gesture and no scroll affordance at all.
    '@mobileL': {
        padding: '0 Z',
        fontSize: 'Z'
    },
    round: 'radiusPill',
    border: 'none',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    fontSize: 'Z2',
    fontWeight: '700',
    letterSpacing: '-0.01em',
    // House active pattern — `selected` + `title`; the resting segment stays
    // transparent over the track's own tint.
    background: (el)=>el.isActive ? 'selected' : 'transparent',
    color: (el)=>el.isActive ? 'title' : 'inactive',
    ':hover': {
        color: 'title'
    },
    ':active': {
        color: 'title'
    },
    text: (el, s)=>el.call('polyglot', s.label || '')
};

});


parcelRegister("7m21X", function(module, exports) {
// Eager slim slice of the marketplace function barrel (#16).
//
// The full `./index.js` barrel is a single ~116KB module (catalog hydration,
// community feed, install dispatch, filter/URL sync, …) that the unified shell
// dragged into its EAGER chunk via
// `import * from '../marketplace/functions/index.js'` in workspace/context.js.
//
// Marketplace is now a lazy sub-app: the `/marketplace*` routes fold the FULL
// marketplace context (components + functions) into the live shell context on
// first mount (workspace/pages/index.js → lazySharedLib). So the eager chunk
// only needs the marketplace functions the shell references BEFORE any
// marketplace route mounts.
//
// A grep of the whole eager surface (workspace app.js/pages/components/
// functions, shared/**, preview) found exactly ONE such reference:
//   • closeInstallModal — app.js's shell-root install-modal watcher calls
//     `el.call('closeInstallModal', s.root)` in its onCancel (~app.js:1160).
// Every other marketplace function (marketplaceHostOf, submitInstallModal,
// selectItemFresh, hydrate*, dispatch*, …) is only ever el.call'd from a
// marketplace-mounted component, i.e. AFTER a `/marketplace*` fold registers
// it — so it rides the lazy chunk, not this one.
//
// marketplace/package.json has no `sideEffects: false`, so re-exporting through
// `./index.js` would NOT tree-shake (it would evaluate the whole barrel). The
// key below is therefore `export *`-ed from its light SOURCE file directly.

var $2zydf = parcelRequire("2zydf");

var $41u0Q = parcelRequire("41u0Q");

var $7rFiJ = parcelRequire("7rFiJ");
$parcel$exportWildcard(module.exports, $2zydf);
$parcel$exportWildcard(module.exports, $41u0Q);
$parcel$exportWildcard(module.exports, $7rFiJ);

});
parcelRegister("2zydf", function(module, exports) {

$parcel$export(module.exports, "marketplaceCloseWithExit", () => $1df96393d1b881e4$export$94c3104968810b6);
$parcel$export(module.exports, "closeInstallModal", () => $1df96393d1b881e4$export$148922b34a27bd3d);
// Install-modal control helpers — the marketplace-function subset the unified
// shell references EAGERLY, split out of the heavy `functions/index.js` barrel
// (#16 marketplace half).
//
// `functions/index.js` is a single ~116KB module (catalog hydration, community
// feed, install dispatch, URL sync, …). The shell keeps it OUT of its eager
// chunk by importing `functions/eagerSlice.js` instead — and the eager slice
// `export *`s from THIS light source file, never from `./index.js` (marketplace
// has no `sideEffects: false`, so re-referencing index.js would evaluate the
// whole barrel). Only the genuinely eager-referenced control(s) live here.
//
// `closeInstallModal` is the one marketplace function the eager shell references
// outside a marketplace-mounted component: `app.js`'s shell-root install-modal
// watcher calls `el.call('closeInstallModal', s.root)` in its `onCancel`
// (app.js ~1160). It is also re-exported from `index.js` (single source of
// truth) so the marketplace island / detail / Esc-handler keep resolving it,
// and so the fold's add-missing merge sees the same binding.
// THE EXIT of a display-gated App Store window (white-label redesign, lane
// W2 — DESIGN_SPEC §6.4: the veil fades out on B, the sheet leaves on
// `modalOut`, C defaultBezier). The window must play its exit BEFORE its
// state clears — clearing first empties it mid-fade. So a close:
//   1. flags the exit (`closingKey: true`); the window keys its exit
//      animations on a `data-closing` rule — a close already running is not
//      restarted;
//   2. clears the state after the exit's length. A TIMER, never
//      `animationend`: animation events are frame-gated and never fire in a
//      hidden tab (canvas PageSlot's FRAME-INDEPENDENCE note).
// The finish leaves a REOPENED window alone: an opener writes
// `closingKey: false`, and a window whose content changed during the exit was
// reopened by a writer that knows nothing of the flag. It can never strand a
// window open: a host that drops the flag write still closes — only an
// explicit `false` cancels. Nothing open → the plain clear, as before.
// `after` runs once the state is clear (focus return).
const $1df96393d1b881e4$export$94c3104968810b6 = (host, key, closingKey, clearPatch, after)=>{
    if (!host) return;
    const done = ()=>{
        host.update?.({
            ...clearPatch,
            [closingKey]: false
        });
        if (typeof after === 'function') after();
    };
    if (!host[key]) return done();
    if (host[closingKey] === true) return;
    const read = ()=>{
        try {
            return JSON.stringify(host[key]);
        } catch (_) {
            return '';
        }
    };
    const snapshot = read();
    host.update?.({
        [closingKey]: true
    });
    // The exit's length: the sheet's C (≈266ms) and a frame of slack.
    setTimeout(()=>{
        if (host[closingKey] === false) return;
        if (read() !== snapshot) return host.update?.({
            [closingKey]: false
        });
        done();
    }, 280);
};
const $1df96393d1b881e4$export$148922b34a27bd3d = (host)=>$1df96393d1b881e4$export$94c3104968810b6(host, 'installModal', '_installModalClosing', {
        installModal: null,
        _installModalSaving: false,
        _installModalError: null,
        _scopeWsQuery: '',
        _scopeProjQuery: ''
    });

});

parcelRegister("41u0Q", function(module, exports) {

$parcel$export(module.exports, "workspacePresetsLoad", () => $2ede894b84faf778$export$36cc40eed3eae61c);
$parcel$export(module.exports, "workspacePresetsFeatured", () => $2ede894b84faf778$export$83a3ed94ab376261);
$parcel$export(module.exports, "workspacePresetByKey", () => $2ede894b84faf778$export$e109be2d376ef34f);
$parcel$export(module.exports, "workspacePresetApplied", () => $2ede894b84faf778$export$13669beb36a9731c);
$parcel$export(module.exports, "workspacePresetCanApply", () => $2ede894b84faf778$export$a76b3572de9196e3);
$parcel$export(module.exports, "workspacePresetText", () => $2ede894b84faf778$export$6a49acd905d43345);
$parcel$export(module.exports, "workspacePresetApply", () => $2ede894b84faf778$export$979bad162f4ed107);
// workspacePresets.js — THE preset data layer of the Workspace Presets program
// (wt/presets/CONTRACT.md §5): the registry read, the questions every surface
// asks of it, and the ONE apply. The App Store "Workspace presets" row and its
// sheet (this package) and the new-account wizard (packages/workspace) call
// these BY NAME:
//
//   el.call('workspacePresetsLoad', force)      → Promise<preset[]>
//   el.call('workspacePresetsFeatured', root)    → featured presets, registry order
//   el.call('workspacePresetByKey', key, root)   → preset | null
//   el.call('workspacePresetApplied', root)      → the active workspace's
//                                                  settings.preset | null
//   el.call('workspacePresetCanApply', root)     → owner/admin of the active workspace
//   el.call('workspacePresetApply', key, opts)   → Promise<result> — opts
//                                                  { include, exclude, setup }
//   el.call('workspacePresetText', key, field)   → the store's name / line /
//                                                  summary of a preset ('' when
//                                                  this surface has none)
//
// WHERE THEY ARE REGISTERED. The shell registers this file at BOOT through
// marketplace/functions/eagerSlice.js (workspace/context.js merges that slice),
// so the wizard reaches every name before any /marketplace route folds the
// store in. The store's own barrel (functions/index.js) exports it too: the
// standalone store and the lazy fold read it there. The fold is add-missing,
// so the shell never holds two copies. The comm host registers no store
// function and runs no wizard, so it does not carry these.
//
// ROOT STATE — declared in packages/workspace/state-app.js (classified in
// state.js / state-app.js for the workspace switch) and in this package's
// state.js for the standalone store:
//   _workspacePresets            null until the first good read, then preset[]
//                                (GET /core/presets, the v2 wire)
//   _workspacePresetsAt          ms of the last good read; 0 = never
//   _workspacePresetsUnsupported true when this host's SDK has no
//                                `listWorkspacePresets` (an older SDK pin): every
//                                surface hides its preset UI — a capability
//                                check, not an error
//   _workspacePresetsError       null | 'failed' — the last read failed; the list
//                                keeps its last good value
//   _presetApply                 null | { key, workspaceId, status:
//                                'running'|'done'|'error', lines: [{ appId,
//                                state: 'pending'|'installed'|'skipped'|'failed',
//                                error }], result, error, cause? } — `cause`
//                                ('offline' | 'server') only on a failed call
//                                whose cause is known
//
// BACKEND: SDK only (`sdk.listWorkspacePresets()`, `sdk.applyWorkspacePreset
// (workspaceId, key, { include, exclude, setup })`) — never a raw fetch.
//
// FRANK: every export is self-contained (FA204) — no module-scope helper or
// constant is read from inside one; siblings and shared helpers are reached
// through `this.call`, the receiver `el.call` hands every function.
// el.call('workspacePresetsLoad', force) — read the preset registry into
// root._workspacePresets. A held list younger than five minutes (the server
// caches the route for 300 s) answers without a request unless `force`. One
// read runs at a time per app: the root ELEMENT's scope holds the in-flight
// promise (per-instance, non-reactive storage — never module state). Resolves
// the list — the last good one when a read fails — and never rejects.
async function $2ede894b84faf778$export$36cc40eed3eae61c(force) {
    const el = this;
    const root = el && el.state && el.state.root || null;
    if (!root || typeof root.update !== 'function') return [];
    const held = Array.isArray(root._workspacePresets) ? root._workspacePresets : null;
    const heldAt = Number(root._workspacePresetsAt) || 0;
    if (!force) {
        if (root._workspacePresetsUnsupported === true) return [];
        if (held && Date.now() - heldAt < 300000) return held;
    }
    const sdk = el && el.sdk || el && el.context && el.context.methods && el.context.methods.sdk || (el && typeof el.call === 'function' ? el.call('getSDK') : null) || null;
    if (!sdk || sdk.isNullClient === true || typeof sdk.listWorkspacePresets !== 'function') {
        if (root._workspacePresetsUnsupported !== true) root.update({
            _workspacePresetsUnsupported: true
        });
        return [];
    }
    const rootEl = el && typeof el.getRoot === 'function' ? el.getRoot() : null;
    const bag = rootEl && rootEl.scope && typeof rootEl.scope === 'object' ? rootEl.scope : null;
    if (bag && bag.workspacePresetsInFlight) return bag.workspacePresetsInFlight;
    // The v2 wire, copied into plain rows: app ids lower-cased (the matching
    // rule every catalog read uses), the setup lists filtered to their shape.
    const toPreset = (p)=>{
        const ids = (list)=>(Array.isArray(list) ? list : []).map((id)=>String(id || '').trim().toLowerCase()).filter((id)=>id.indexOf('/') > 0);
        const setup = p.setup && typeof p.setup === 'object' ? p.setup : {};
        const channels = (Array.isArray(setup.channels) ? setup.channels : []).filter((c)=>c && typeof c.name === 'string' && c.name.trim()).map((c)=>({
                name: c.name.trim(),
                topic: typeof c.topic === 'string' ? c.topic : '',
                // P1: the channel's words per language ({ en, ka }) — the apply seeds
                // the workspace-language one, so the sheet names that one too
                words: c.words && typeof c.words === 'object' ? c.words : null
            }));
        const folders = (Array.isArray(setup.folders) ? setup.folders : []).filter((f)=>typeof f === 'string' && f.trim()).map((f)=>f.trim());
        const folderWords = Array.isArray(setup.folderWords) ? setup.folderWords : [];
        // The preset's own line for each of its apps, per language
        // (`{ '<owner>/<key>': { en, ka } }`): the welcome's Your apps reads it
        // before the store's generic line. Ids lower-cased like `apps`; only
        // string lines kept.
        const appWords = {};
        const said = setup.appWords && typeof setup.appWords === 'object' ? setup.appWords : {};
        for (const raw of Array.isArray(said) ? [] : Object.keys(said)){
            const id = String(raw || '').trim().toLowerCase();
            const per = said[raw];
            if (id.indexOf('/') <= 0 || !per || typeof per !== 'object') continue;
            const words = {};
            for (const lang of Object.keys(per))if (typeof per[lang] === 'string' && per[lang].trim()) words[lang] = per[lang].trim();
            if (Object.keys(words).length) appWords[id] = words;
        }
        // The apps' industry words (server `setup.crm` / `setup.scheduling`): an
        // app reads them here when its workspace holds no copy (the CRM's
        // crmPresetWords.js, Scheduling's schPreset.js). Plain copies; a block
        // that is not an object stays out.
        const industryWords = {};
        for (const k of [
            'crm',
            'scheduling'
        ]){
            const b = setup[k];
            if (b && typeof b === 'object' && !Array.isArray(b)) industryWords[k] = JSON.parse(JSON.stringify(b));
        }
        const order = Number(p.order);
        return {
            key: p.key,
            apps: ids(p.apps),
            suggested: ids(p.suggested),
            setup: {
                channels: channels,
                folders: folders,
                folderWords: folderWords,
                appWords: appWords,
                ...industryWords
            },
            featured: p.featured === true,
            order: Number.isFinite(order) ? order : 999
        };
    };
    const run = (async ()=>{
        try {
            const res = await sdk.listWorkspacePresets();
            const rows = Array.isArray(res) ? res : res && Array.isArray(res.presets) ? res.presets : null;
            if (!rows) throw new Error('the preset registry answered no list');
            const presets = rows.filter((p)=>p && typeof p.key === 'string' && p.key && Array.isArray(p.apps)).map(toPreset);
            root.update({
                _workspacePresets: presets,
                _workspacePresetsAt: Date.now(),
                _workspacePresetsUnsupported: false,
                _workspacePresetsError: null
            });
            return presets;
        } catch (err) {
            console.warn('[workspacePresets] the registry read failed:', err && err.message || err);
            root.update({
                _workspacePresetsError: 'failed'
            });
            return held || [];
        } finally{
            if (bag) bag.workspacePresetsInFlight = null;
        }
    })();
    if (bag) bag.workspacePresetsInFlight = run;
    return run;
}
function $2ede894b84faf778$export$83a3ed94ab376261(root) {
    const r = root || this && this.state && this.state.root || null;
    const list = r && Array.isArray(r._workspacePresets) ? r._workspacePresets : [];
    const rank = (p)=>Number.isFinite(Number(p.order)) ? Number(p.order) : 999;
    return list.filter((p)=>p && p.featured === true).sort((a, b)=>rank(a) - rank(b));
}
function $2ede894b84faf778$export$e109be2d376ef34f(key, root) {
    const r = root || this && this.state && this.state.root || null;
    const list = r && Array.isArray(r._workspacePresets) ? r._workspacePresets : [];
    if (typeof key !== 'string' || !key) return null;
    return list.find((p)=>p && p.key === key) || null;
}
function $2ede894b84faf778$export$13669beb36a9731c(root) {
    const r = root || this && this.state && this.state.root || null;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const settings = ws && ws.settings && typeof ws.settings === 'object' ? ws.settings : null;
    const preset = settings && settings.preset;
    if (!preset || typeof preset !== 'object') return null;
    return typeof preset.key === 'string' && preset.key ? preset : null;
}
function $2ede894b84faf778$export$a76b3572de9196e3(root) {
    const r = root || this && this.state && this.state.root || null;
    const ws = r && r.workspace && typeof r.workspace === 'object' ? r.workspace : null;
    const org = r && r.org && typeof r.org === 'object' ? r.org : null;
    if (!ws || !(ws._id || ws.id)) return false;
    const access = ws.access && typeof ws.access === 'object' ? ws.access : null;
    const role = access && typeof access.role === 'string' ? access.role.trim().toLowerCase() : '';
    if (role) return role === 'owner' || role === 'admin' || role === 'superadmin';
    const orgRole = org && typeof org.role === 'string' ? org.role.trim().toLowerCase() : '';
    return [
        'owner',
        'co-owner',
        'admin',
        'maintainer'
    ].indexOf(orgRole) !== -1;
}
function $2ede894b84faf778$export$6a49acd905d43345(key, field) {
    const el = this;
    const KEYS = {
        'virtual-assistance': {
            name: 'marketplace.preset.virtualAssistance.name',
            line: 'marketplace.preset.virtualAssistance.line',
            summary: 'marketplace.preset.virtualAssistance.summary'
        },
        'real-estate': {
            name: 'marketplace.preset.realEstate.name',
            line: 'marketplace.preset.realEstate.line',
            summary: 'marketplace.preset.realEstate.summary'
        },
        ecommerce: {
            name: 'marketplace.preset.ecommerce.name',
            line: 'marketplace.preset.ecommerce.line',
            summary: 'marketplace.preset.ecommerce.summary'
        },
        // The rest of the registry — the welcome's "More kinds of work" (persona
        // round 3, W3): a name and a line each; no summary, because no store sheet
        // shows them (the store lists the featured presets only).
        hospitality: {
            name: 'marketplace.preset.hospitality.name',
            line: 'marketplace.preset.hospitality.line'
        },
        medical: {
            name: 'marketplace.preset.medical.name',
            line: 'marketplace.preset.medical.line'
        },
        finance: {
            name: 'marketplace.preset.finance.name',
            line: 'marketplace.preset.finance.line'
        },
        education: {
            name: 'marketplace.preset.education.name',
            line: 'marketplace.preset.education.line'
        },
        logistics: {
            name: 'marketplace.preset.logistics.name',
            line: 'marketplace.preset.logistics.line'
        },
        manufacturing: {
            name: 'marketplace.preset.manufacturing.name',
            line: 'marketplace.preset.manufacturing.line'
        },
        media: {
            name: 'marketplace.preset.media.name',
            line: 'marketplace.preset.media.line'
        },
        services: {
            name: 'marketplace.preset.services.name',
            line: 'marketplace.preset.services.line'
        },
        agro: {
            name: 'marketplace.preset.agro.name',
            line: 'marketplace.preset.agro.line'
        },
        aerial: {
            name: 'marketplace.preset.aerial.name',
            line: 'marketplace.preset.aerial.line'
        }
    };
    const set = typeof key === 'string' && Object.prototype.hasOwnProperty.call(KEYS, key) ? KEYS[key] : null;
    const bundleKey = set && typeof field === 'string' ? set[field] : null;
    if (!bundleKey || !el || typeof el.call !== 'function') return '';
    const text = el.call('polyglot', bundleKey);
    return typeof text === 'string' && text && text !== bundleKey ? text : '';
}
async function $2ede894b84faf778$export$979bad162f4ed107(key, opts) {
    const el = this;
    const root = el && el.state && el.state.root || null;
    const o = opts && typeof opts === 'object' ? opts : {};
    if (!root || typeof root.update !== 'function' || typeof key !== 'string' || !key) return {
        ok: false,
        error: 'invalid'
    };
    const current = root._presetApply;
    if (current && current.status === 'running') return {
        ok: false,
        error: 'busy'
    };
    const ws = root.workspace && typeof root.workspace === 'object' ? root.workspace : null;
    const wsId = ws ? String(ws._id || ws.id || '') : '';
    // A refusal: the error line's state, and the caller's answer. `cause` rides
    // along only when it is known (a failed call: 'offline' | 'server').
    const refuse = (error, cause)=>{
        const known = cause ? {
            cause: cause
        } : {};
        root.update({
            _presetApply: {
                key: key,
                workspaceId: wsId,
                status: 'error',
                lines: [],
                result: null,
                error: error,
                ...known
            }
        });
        return {
            ok: false,
            error: error,
            ...known
        };
    };
    const sdk = el && el.sdk || el && el.context && el.context.methods && el.context.methods.sdk || (el && typeof el.call === 'function' ? el.call('getSDK') : null) || null;
    if (!sdk || sdk.isNullClient === true || typeof sdk.applyWorkspacePreset !== 'function') return refuse('unsupported');
    if (!wsId) return refuse('noWorkspace');
    const custom = key === 'custom';
    let preset = custom ? {
        key: key,
        apps: [],
        suggested: [],
        setup: {
            channels: [],
            folders: []
        }
    } : el.call('workspacePresetByKey', key, root);
    if (!preset) {
        await el.call('workspacePresetsLoad');
        preset = el.call('workspacePresetByKey', key, root);
    }
    if (!preset) return refuse('unknownPreset');
    // The plan, in install order: the preset's apps minus `exclude`, then the
    // picked extras. An id is `owner/key`, lower-cased; at most 20 extras (the
    // server's cap). A custom workspace has no preset apps to exclude.
    const norm = (id)=>String(id || '').trim().toLowerCase();
    const valid = (id)=>/^[a-z0-9][a-z0-9_.-]*\/[a-z0-9][a-z0-9_.-]*$/.test(id);
    const exclude = custom ? [] : (Array.isArray(o.exclude) ? o.exclude : []).map(norm).filter(valid);
    const include = (Array.isArray(o.include) ? o.include : []).map(norm).filter(valid).slice(0, 20);
    const plan = [];
    for (const id of (preset.apps || []).map(norm))if (valid(id) && exclude.indexOf(id) === -1 && plan.indexOf(id) === -1) plan.push(id);
    for (const id of include)if (plan.indexOf(id) === -1) plan.push(id);
    const pending = plan.map((appId)=>({
            appId: appId,
            state: 'pending',
            error: null
        }));
    root.update({
        _presetApply: {
            key: key,
            workspaceId: wsId,
            status: 'running',
            lines: pending,
            result: null,
            error: null
        }
    });
    // A workspace switch while the call runs wipes `_presetApply` (a scoped key)
    // and makes another workspace active: from then on nothing here writes, so
    // the NEW workspace never inherits this apply's lines, its "busy" status or
    // its refresh. The server applied the preset to the workspace it was asked
    // about; the caller still gets that answer.
    const stillHere = ()=>{
        const now = root.workspace;
        return !!now && String(now._id || now.id || '') === wsId;
    };
    let res;
    try {
        const body = custom ? {
            include: include
        } : {
            setup: o.setup !== false
        };
        if (!custom && include.length) body.include = include;
        if (!custom && exclude.length) body.exclude = exclude;
        res = await sdk.applyWorkspacePreset(wsId, key, body);
    } catch (err) {
        // A refused call installed nothing this read can name: the lines go, the
        // error says what happened. 403 — not an owner/admin. The server's own
        // `unknown_preset` (its body's `error`, on a 404 or a 400) — no such
        // preset on this server. Anything else is a FAILED call, and the sheet
        // offers the retry: the network, a 5xx, a timeout, a server without the
        // apply route yet (a bare 404 — it says nothing about the preset). A
        // failed call names its cause when it is known: 'offline' (the request
        // never reached the server — the SDK's NETWORK_UNREACHABLE, or the
        // browser's own fetch failure) or 'server' (a 5xx or a 408).
        const status = err && Number(err.status);
        if (!(custom && status === 404 && typeof sdk.installWorkspaceApps === 'function')) {
            const body = err && err.cause && typeof err.cause === 'object' ? err.cause : null;
            const said = body && typeof body.error === 'string' ? body.error : '';
            const code = status === 403 ? 'forbidden' : said === 'unknown_preset' ? 'unknownPreset' : 'failed';
            const offline = !status && (err && err.code === 'NETWORK_UNREACHABLE' || /failed to fetch|networkerror|load failed/i.test(String(err && err.message || '')));
            const cause = code !== 'failed' ? '' : offline ? 'offline' : status >= 500 || status === 408 ? 'server' : '';
            if (stillHere()) return refuse(code, cause);
            return cause ? {
                ok: false,
                error: code,
                cause: cause
            } : {
                ok: false,
                error: code
            };
        }
        // An older server: no `custom` key. The custom workspace's apps go in
        // through the store's own install call — atomic, so every app installs or
        // every app is a failed line with the retry.
        const none = {
            ok: true,
            preset: key,
            installed: [],
            skipped: [],
            failed: []
        };
        if (!include.length) res = {
            ...none,
            setup: null,
            workspacePreset: null
        };
        else try {
            const out = await sdk.installWorkspaceApps(wsId, {
                appId: include[0],
                alsoInstall: include.slice(1)
            });
            res = {
                ...none,
                installed: out && Array.isArray(out.installed) && out.installed || [],
                skipped: out && Array.isArray(out.alreadyInstalled) && out.alreadyInstalled || [],
                setup: null,
                workspacePreset: null
            };
        } catch (installErr) {
            console.warn('[workspacePresets] the custom install failed:', installErr && installErr.message || installErr);
            res = {
                ...none,
                ok: false,
                failed: include.map((appId)=>({
                        appId: appId,
                        error: 'failed'
                    })),
                setup: null,
                workspacePreset: null
            };
        }
    }
    const result = res && typeof res === 'object' ? res : {};
    if (result.ok === false && result.error) {
        const code = result.error === 'unknown_preset' ? 'unknownPreset' : 'failed';
        return stillHere() ? refuse(code) : {
            ok: false,
            error: code
        };
    }
    // Each planned app takes the server's answer. An app the server installed
    // beyond the plan (a dependency the atomic install brought) gets its own
    // line. `workspacePreset.apps` lists every app present after the apply, so a
    // planned app no list names reads present (skipped) or absent (failed).
    const idOf = (x)=>norm(typeof x === 'string' ? x : x && (x.appId || (x.owner && x.key ? x.owner + '/' + x.key : '')));
    const installed = (Array.isArray(result.installed) ? result.installed : []).map(idOf);
    const skipped = (Array.isArray(result.skipped) ? result.skipped : []).map(idOf);
    const failed = {};
    for (const f of Array.isArray(result.failed) ? result.failed : []){
        const id = idOf(f);
        if (id) failed[id] = f && (f.error || f.code) || 'failed';
    }
    // When nothing landed (`ok: false`) the server answers the EARLIER record,
    // which may name another preset — its apps say nothing about this plan.
    const wp = result.workspacePreset && typeof result.workspacePreset === 'object';
    const present = wp && result.workspacePreset.key === key && Array.isArray(result.workspacePreset.apps) ? result.workspacePreset.apps.map(idOf) : [];
    const lineFor = (appId)=>{
        if (installed.indexOf(appId) !== -1) return {
            appId: appId,
            state: 'installed',
            error: null
        };
        if (skipped.indexOf(appId) !== -1) return {
            appId: appId,
            state: 'skipped',
            error: null
        };
        if (failed[appId]) return {
            appId: appId,
            state: 'failed',
            error: failed[appId]
        };
        if (present.indexOf(appId) !== -1) return {
            appId: appId,
            state: 'skipped',
            error: null
        };
        return {
            appId: appId,
            state: 'failed',
            error: 'failed'
        };
    };
    const lines = plan.map(lineFor);
    for (const id of installed)if (id && plan.indexOf(id) === -1) lines.push({
        appId: id,
        state: 'installed',
        error: null
    });
    const setupResult = result.setup && typeof result.setup === 'object' ? result.setup : null;
    const plain = {
        ok: result.ok !== false,
        preset: result.preset || key,
        installed: installed,
        skipped: skipped,
        failed: Object.keys(failed).map((appId)=>({
                appId: appId,
                error: failed[appId]
            })),
        setup: setupResult ? JSON.parse(JSON.stringify(setupResult)) : null,
        workspacePreset: wp ? JSON.parse(JSON.stringify(result.workspacePreset)) : null
    };
    if (!stillHere()) return {
        ...plain,
        lines: lines,
        switched: true
    };
    root.update({
        _presetApply: {
            key: key,
            workspaceId: wsId,
            status: 'running',
            lines: lines,
            result: plain,
            error: null
        }
    });
    // THE REFRESH — the active workspace record, read again: `settings.preset`
    // shows and the shell loads the new apps (navbar tabs, pages, widgets), so
    // "Open <app>" finds its route. The shell loader is waited for at most 20 s:
    // it keeps running past that, but the apply is done and says so — a slow
    // loader must never leave the status "running" (that would read "busy" to
    // the next apply).
    try {
        const full = await el.call('fetchFullWorkspaceRecord', sdk, wsId);
        if (full && stillHere()) {
            el.call('setActiveWorkspaceRecord', root, full, {
                sdk: sdk,
                reason: 'workspacePresetApply'
            });
            const fns = el.context && el.context.functions || {};
            if (typeof fns.reactivateWorkspaceModule === 'function') {
                const settings = full.settings && typeof full.settings === 'object' && full.settings || {};
                // QUIET (R2c-m2): this reload follows the person's own apply — the
                // welcome sends it in the background while the person goes on, and a
                // "Retrying workspace loading" strip then sat over the welcome's
                // Continue (elena-r2c, sam-r2). A failure still shows.
                const loading = Promise.resolve(el.call('reactivateWorkspaceModule', null, {
                    workspaceApps: Array.isArray(settings.workspaceApps) ? settings.workspaceApps : []
                }, {
                    quiet: true
                }));
                let timer = null;
                const bound = new Promise((resolve)=>{
                    timer = setTimeout(resolve, 20000);
                });
                try {
                    await Promise.race([
                        loading,
                        bound
                    ]);
                } finally{
                    clearTimeout(timer);
                }
            }
        }
    } catch (err) {
        console.warn('[workspacePresets] the workspace refresh failed:', err && err.message || err);
    }
    if (!stillHere()) return {
        ...plain,
        lines: lines,
        switched: true
    };
    root.update({
        _presetApply: {
            key: key,
            workspaceId: wsId,
            status: 'done',
            lines: lines,
            result: plain,
            error: null
        }
    });
    return {
        ...plain,
        lines: lines
    };
}

});

parcelRegister("7rFiJ", function(module, exports) {

$parcel$export(module.exports, "appStoreItemId", () => $56bb1795c8ab4eed$export$c833e077d32ac1f5);
$parcel$export(module.exports, "appStoreItemLink", () => $56bb1795c8ab4eed$export$dc8997886394ff75);
// THE APP STORE ITEM — its id and its link, built in ONE place.
//
// A workspace app's App Store item is `app.<owner>.<key>`: the id of the
// store's own row (functions/index.js `_projectToCatalogItem`, kind 'app') and
// the `?item=` of every link to the app's page. The store reads the id back
// from the address (`?item=app.*` opens the App Store surface and selects the
// row with that id), so a link built anywhere else must spell it exactly as
// the row does. Every builder asks this file: the store's rows, the /add-app
// catalog card's Details link and the search suggestion's App Store row
// (workspace), an AI card's App Store link (canvas canvasAnswerStoreLink) and
// the apps hub's Manage, which keeps its own route (the concierge,
// 2026-10-31: "one builder, with no tech debt left").
//
// Light and self-contained: the shell's surfaces call it before any
// /marketplace route mounts, so the shell's eager slice registers this file
// (functions/eagerSlice.js), and functions/index.js imports it for the
// store's rows and re-exports it for every context that folds the full
// barrel in. Called the DOMQL way: `el.call('appStoreItemLink', owner, key)`.
// el.call('appStoreItemId', owner, key) -> 'app.<owner>.<key>'. null when the
// owner or the key is not a slug (a letter or a digit first, then letters,
// digits, `_` and `-`): a dot, a space, a slash, a `?` or an empty or
// non-string part names no item the store can read back.
function $56bb1795c8ab4eed$export$c833e077d32ac1f5(owner, key) {
    const slug = (v)=>typeof v === 'string' && /^[A-Za-z0-9][A-Za-z0-9_-]*$/.test(v);
    if (!slug(owner) || !slug(key)) return null;
    return 'app.' + owner + '.' + key;
}
function $56bb1795c8ab4eed$export$dc8997886394ff75(owner, key, route) {
    const id = this.call('appStoreItemId', owner, key);
    if (!id) return null;
    return (typeof route === 'string' && route ? route : '/marketplace') + '?item=' + id;
}

});


parcelRegister("1HN7r", function(module, exports) {

$parcel$export(module.exports, "togglePick", () => (parcelRequire("6Lu55")).togglePick);
$parcel$export(module.exports, "inspectSelected", () => (parcelRequire("6Lu55")).inspectSelected);
$parcel$export(module.exports, "previewPickArmedOn", () => (parcelRequire("6Lu55")).previewPickArmedOn);
$parcel$export(module.exports, "setModelMode", () => (parcelRequire("3idzb")).setModelMode);
// Eager slim slice of the preview function barrel (#16 preview half).
//
// The full `./index.js` barrel re-exports the whole preview function surface —
// the Scene iframe boot (`renderProject` + `renderDesignSystem`), the Simone
// assistant transport (`bootPreviewAssistant` / `installPreviewAiTransport` /
// `reloadPreviewProject` / `newSession` / `setModelMode`), `sendPrompt`, and the
// element picker (`togglePick` / `inspectSelected`) — that the unified shell
// dragged into its EAGER chunk via `import * from '../preview/functions/index.js'`
// in workspace/context.js.
//
// Preview is now a lazy sub-app: the `/preview` ROUTE (workspace/pages/index.js
// → lazySharedLib) and the `/preview` PageSlot (home AppWindow + canvas
// `_canvasSlot`, resolved through _APP_WINDOW_PAGES._previewPage in
// workspace/pages/main.js → lazySharedLibPage) both FOLD the full preview
// context (components + functions) into the live shell context on first mount.
// So every preview function reached from INSIDE the preview page — chiefly
// `renderProject` + `renderDesignSystem`, whose only callers are preview-internal
// (Scene.js el.call('renderProject') + previewAiTransport.js reloadPreviewProject)
// — rides the fold: caller (Scene) and callee (renderProject) both arrive together,
// registered BEFORE the page mounts. None of that needs to be eager.
//
// The eager chunk only needs the preview functions the shell references BEFORE any
// /preview fold. A grep of the whole eager surface (workspace app.js/state/pages/
// components/functions + shared/**) found these referenced ONLY by the shared
// Simone `Chat.js` (mounted by the shell's AssistantDrawer on every route):
//   • togglePick / inspectSelected — Chat's PickBtn/InspectZeroBtn el.call these.
//   • setModelMode — Chat's model-mode dropdown el.calls this (best-effort).
//   (fetchAiProviderDiagnostics is shared's own registration, not preview's.)
// `sendPrompt` and `newSession` are NOT here: the shell defines its OWN
// (workspace/functions/_simone/sendPrompt.js + sessions.js), spread LAST into
// context.functions so they win — preview's same-named exports are shadowed both
// before and after this carve (add-missing fold never overrides them).
//
// preview/package.json has no `sideEffects: false`, so re-exporting through
// `./index.js` would NOT tree-shake (it would evaluate the whole barrel, pulling
// the Scene/renderProject boot code back in). Each key below is therefore
// `export *`-ed from its SOURCE file directly. Both source files are light:
// pickElement.js has ZERO imports; previewAiTransport.js's only top-level import
// is aiService.js (already eager — the shell's simoneAiTransport/homeAiSend use
// it), and its `renderProject` reference is a runtime `this.call`, not a static
// import edge — so neither drags the preview render pipeline into the eager chunk.

var $6Lu55 = parcelRequire("6Lu55");

var $3idzb = parcelRequire("3idzb");

var $99l6A = parcelRequire("99l6A");

var $kxX7m = parcelRequire("kxX7m");

var $eDtcO = parcelRequire("eDtcO");
$parcel$exportWildcard(module.exports, $99l6A);
$parcel$exportWildcard(module.exports, $kxX7m);
$parcel$exportWildcard(module.exports, $eDtcO);

});
parcelRegister("6Lu55", function(module, exports) {

$parcel$export(module.exports, "togglePick", () => $4ece7753d85b60ac$export$4c8e0206660ce67a);
$parcel$export(module.exports, "previewPickArmedOn", () => $4ece7753d85b60ac$export$15eff527ae061c30);
$parcel$export(module.exports, "inspectSelected", () => $4ece7753d85b60ac$export$2b13acde7fbe3dad);
// Preview element inspection — arms a picker INSIDE the project iframe
// (#preview-app-iframe) and resolves each clicked node back to its DOMQL
// component key-path.
//
// USER-CODE-ORIGIN (canvas H1, 2026-10-09): the project iframe is an OPAQUE
// user-code frame (shared userCodeFrame.js) — its document is not readable
// from here. The picker therefore runs INSIDE the frame as an editor tool
// (`handle.runTool`): `framePicker` below is sent as TEXT, so it must stay
// SELF-CONTAINED (no module-scope helper, no import, ES2017 syntax) and it
// reports the picked node as plain data over the frame's port.
//
// Identity: smbls stamps every rendered node with a `data-key` attribute and, in
// most builds, a `node.ref` DOMQL back-reference whose `__ref.path` is the
// canonical key-path array. We read `ref.__ref.path` first and fall back to the
// `data-key` ancestor chain — so the picked chip shows the project path (e.g.
// Hero › Title) the assistant can act on, not the raw DOM tag path.
//
// Vendored/adapted from extensions/packages/simone/symbols/functions/pickElement.js
// (its standalone in-page picker, `startLocalPick`). Keep the describe shape in
// sync with that source so PickedContextChip + the transport consume picks
// identically across surfaces.
// The active picker's handles live on `globalThis` rather than a module-scope
// `let` — frank's globalScope-lift promotes `_stopPick` / `_startPick` into
// independently-serialized functions, which strips the shared module closure;
// a plain `let` free var then revives as a guaranteed `ReferenceError`. See
// tickets/opus.md "canvas serialization defects blocking the authorised
// production push".
// The frame to pick in: the one the caller NAMES (an <iframe> node, or the
// DOMQL element that renders it — several frames can stand on one page: a Fly
// page's site-preview cards, functions/previewAnswer.js), else /preview's own
// Scene frame by its fixed id (the Chat composer's Pick button names none).
const $4ece7753d85b60ac$var$_getIframe = (frame)=>{
    if (frame) {
        const node = frame.node && frame.node.nodeType === 1 ? frame.node : frame;
        return node && node.nodeType === 1 && String(node.tagName).toLowerCase() === 'iframe' ? node : null;
    }
    return typeof document !== 'undefined' ? document.getElementById('preview-app-iframe') : null;
};
function $4ece7753d85b60ac$export$9cb02cb322d71fd2(api) {
    var win = api.win;
    var doc = api.doc;
    var emit = api.emit;
    function segment(n) {
        var tag = n.tagName.toLowerCase();
        var id = n.id ? '#' + n.id : '';
        var cls = n.className && typeof n.className === 'string' ? '.' + n.className.trim().split(/\s+/).slice(0, 2).join('.') : '';
        return tag + id + (cls === '.' ? '' : cls);
    }
    function describe(node) {
        if (!node || node.nodeType !== 1) return null;
        var el = null;
        var cur = node;
        while(cur){
            if (cur.ref) {
                el = cur.ref;
                break;
            }
            cur = cur.parentElement;
        }
        var elRef = el && el.__ref;
        var keyPath = elRef && Array.isArray(elRef.path) ? elRef.path.slice() : [];
        if (!keyPath.length) {
            var dk = [];
            var p = node;
            while(p && p.nodeType === 1 && p !== doc.documentElement){
                var k = p.getAttribute && p.getAttribute('data-key');
                if (k) dk.unshift(k);
                p = p.parentNode;
            }
            if (dk.length) keyPath = dk;
        }
        var tagPath = [];
        var n = node;
        while(n && n.nodeType === 1 && n !== doc.documentElement){
            tagPath.unshift(segment(n));
            n = n.parentNode;
        }
        var rect = node.getBoundingClientRect();
        var attrs = {};
        if (node.attributes) for(var i = 0; i < node.attributes.length; i++)attrs[node.attributes[i].name] = node.attributes[i].value;
        return {
            tag: node.tagName.toLowerCase(),
            key: el && (el.key || elRef && (elRef.key || elRef.__name)) || node.getAttribute && (node.getAttribute('data-key') || node.getAttribute('key')) || (keyPath.length ? keyPath[keyPath.length - 1] : null) || null,
            component: el && typeof el.component === 'string' && el.component || elRef && elRef.__name || null,
            keyPath: keyPath.map(String),
            tagPath: tagPath,
            path: keyPath.map(String),
            text: (node.innerText || node.textContent || '').slice(0, 200),
            rect: {
                x: rect.left,
                y: rect.top,
                w: rect.width,
                h: rect.height
            },
            // The previewed project's own route + title, so the assistant knows
            // which page the element lives on.
            url: win.location && win.location.href || null,
            title: doc && doc.title || null,
            attrs: attrs,
            pickedAt: Date.now()
        };
    }
    // Imperative highlight overlay — lives inside the frame document (outside
    // the DOMQL tree), so it scales with the project content under device
    // presets and raw styles are the only option. pointer-events:none keeps it
    // from being the elementFromPoint hit / a pick target.
    var overlay = doc.createElement('div');
    overlay.style.cssText = "position:fixed;pointer-events:none;z-index:2147483647;border:2px solid #2a72ff;background:rgba(42,114,255,0.15);transition:all 60ms ease;display:none;";
    doc.documentElement.appendChild(overlay);
    var hover = null;
    function onMove(ev) {
        var target = doc.elementFromPoint(ev.clientX, ev.clientY);
        if (!target || target === hover || target === overlay) return;
        hover = target;
        var r = target.getBoundingClientRect();
        overlay.style.display = 'block';
        overlay.style.left = r.left + 'px';
        overlay.style.top = r.top + 'px';
        overlay.style.width = r.width + 'px';
        overlay.style.height = r.height + 'px';
    }
    function onClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        emit({
            picked: describe(ev.target)
        });
    }
    function onKey(ev) {
        if (ev.key === 'Escape') emit({
            cancel: true
        });
    }
    doc.addEventListener('mousemove', onMove, true);
    doc.addEventListener('click', onClick, true);
    doc.addEventListener('keydown', onKey, true);
    return function stop() {
        doc.removeEventListener('mousemove', onMove, true);
        doc.removeEventListener('click', onClick, true);
        doc.removeEventListener('keydown', onKey, true);
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    };
}
const $4ece7753d85b60ac$var$_errorMsg = (root, text)=>{
    const list = (root.chatMessages || []).concat({
        id: `err-${Date.now()}`,
        role: 'system',
        text: text,
        ts: Date.now()
    });
    root.update({
        chatMessages: list
    });
};
const $4ece7753d85b60ac$export$7df44377a1a1508e = (raw)=>{
    if (!raw || typeof raw !== 'object') return null;
    const str = (v, max)=>typeof v === 'string' ? v.replace(/[\u0000-\u001f\u007f]/g, ' ').slice(0, max) : null;
    const list = (v, n, max)=>Array.isArray(v) ? v.slice(0, n).map((x)=>str(x, max)).filter((x)=>x !== null) : [];
    const num = (v)=>typeof v === 'number' && Number.isFinite(v) ? Math.round(v) : 0;
    const tag = str(raw.tag, 32);
    if (!tag || !/^[a-z][a-z0-9-]*$/.test(tag)) return null;
    const attrs = {};
    const ra = raw.attrs && typeof raw.attrs === 'object' && !Array.isArray(raw.attrs) ? raw.attrs : {};
    for (const k of Object.keys(ra).slice(0, 20)){
        if (!/^[A-Za-z_:][\w:.-]{0,39}$/.test(k)) continue;
        const v = str(ra[k], 200);
        if (v !== null) attrs[k] = v;
    }
    const keyPath = list(raw.keyPath, 24, 120);
    const r = raw.rect && typeof raw.rect === 'object' ? raw.rect : {};
    return {
        tag: tag,
        key: str(raw.key, 120),
        component: str(raw.component, 120),
        keyPath: keyPath,
        path: keyPath,
        tagPath: list(raw.tagPath, 40, 160),
        text: str(raw.text, 200) || '',
        rect: {
            x: num(r.x),
            y: num(r.y),
            w: num(r.w),
            h: num(r.h)
        },
        url: str(raw.url, 300),
        title: str(raw.title, 200),
        attrs: attrs,
        pickedAt: num(raw.pickedAt) || Date.now(),
        untrusted: true
    };
};
const $4ece7753d85b60ac$var$recordPicked = (root, picked)=>{
    const info = $4ece7753d85b60ac$export$7df44377a1a1508e(picked);
    if (!info) {
        $4ece7753d85b60ac$var$_errorMsg(root, "Could not read that element \u2014 try a different one.");
        return;
    }
    const sig = (info.tagPath || []).join('>');
    const list = (root.pickedElements || []).slice();
    if (!list.some((p)=>(p.tagPath || []).join('>') === sig)) list.push(info);
    root.update({
        pickedElements: list
    });
};
const $4ece7753d85b60ac$var$_stopPick = ()=>{
    if (!globalThis.__previewPicker) return;
    const { handle: handle, parentKey: parentKey } = globalThis.__previewPicker;
    try {
        if (handle) handle.stopTool('pick');
        if (typeof document !== 'undefined') document.removeEventListener('keydown', parentKey, true);
    } catch (err) {
        console.warn('[preview] stop picker:', err);
    }
    globalThis.__previewPicker = null;
};
// `frame`: the iframe node it arms on (kept beside the handle, so a caller can
// ask where the picker is — previewPickArmedOn). `quiet`: a caller that names
// its frame says a failure in its own place, never as a chat line.
const $4ece7753d85b60ac$var$_startPick = (root, handle, frame, quiet)=>{
    if (globalThis.__previewPicker) return true;
    if (!handle || !handle.alive) {
        if (!quiet) $4ece7753d85b60ac$var$_errorMsg(root, 'Open a project preview first, then pick an element.');
        return false;
    }
    const done = ()=>{
        $4ece7753d85b60ac$var$_stopPick();
        root.update({
            picking: false
        });
    };
    // Esc may be pressed while focus sits in the parent (the chat panel), so
    // listen here too; the frame reports its own Escape as `{ cancel }`.
    const parentKey = (ev)=>{
        if (ev.key === 'Escape') done();
    };
    globalThis.__previewPicker = {
        handle: handle,
        parentKey: parentKey,
        frame: frame || null
    };
    const armed = handle.runTool('pick', $4ece7753d85b60ac$export$9cb02cb322d71fd2, (data)=>{
        if (!data) return;
        if (data.picked !== undefined) {
            $4ece7753d85b60ac$var$recordPicked(root, data.picked);
            // Single-shot: a successful pick disarms the picker (parity with the
            // simone page-agent picker). User can re-arm via the Pick button.
            done();
        } else if (data.cancel) done();
        else if (data.error) {
            if (!quiet) $4ece7753d85b60ac$var$_errorMsg(root, 'Could not start the element picker.');
            done();
        }
    });
    if (!armed) {
        globalThis.__previewPicker = null;
        if (!quiet) $4ece7753d85b60ac$var$_errorMsg(root, 'Open a project preview first, then pick an element.');
        return false;
    }
    if (typeof document !== 'undefined') document.addEventListener('keydown', parentKey, true);
    return true;
};
const $4ece7753d85b60ac$export$4c8e0206660ce67a = function(frame) {
    const root = this.state.root;
    const named = frame ? $4ece7753d85b60ac$var$_getIframe(frame) : null;
    if (frame && !named) return false;
    if (root.picking) {
        const armedOn = globalThis.__previewPicker ? globalThis.__previewPicker.frame : null;
        $4ece7753d85b60ac$var$_stopPick();
        root.update({
            picking: false
        });
        if (!named || armedOn === named) return false;
    }
    const iframe = named || $4ece7753d85b60ac$var$_getIframe();
    if (!iframe) {
        $4ece7753d85b60ac$var$_errorMsg(root, 'Open a project preview first, then pick an element.');
        return false;
    }
    // the frame's live handle, through the shared accessor (the registry stays
    // private to the frame host)
    const handle = this.call('getUserCodeHandle', iframe);
    if ($4ece7753d85b60ac$var$_startPick(root, handle, iframe, !!named)) {
        root.update({
            picking: true
        });
        return true;
    }
    return false;
};
const $4ece7753d85b60ac$export$15eff527ae061c30 = function(frame) {
    const node = $4ece7753d85b60ac$var$_getIframe(frame || null);
    const armed = globalThis.__previewPicker;
    return !!(frame && node && armed && armed.frame === node);
};
const $4ece7753d85b60ac$export$2b13acde7fbe3dad = function() {
    return $4ece7753d85b60ac$export$4c8e0206660ce67a.call(this);
};

});

parcelRegister("3idzb", function(module, exports) {

$parcel$export(module.exports, "installPreviewAiTransport", () => $265d938c2203c79f$export$87b774147ceda3fc);
$parcel$export(module.exports, "bootPreviewAssistant", () => $265d938c2203c79f$export$3b60cea472c320c1);
$parcel$export(module.exports, "reloadPreviewProject", () => $265d938c2203c79f$export$b64233fcc79c8345);
$parcel$export(module.exports, "newSession", () => $265d938c2203c79f$export$43c80672febddad8);
$parcel$export(module.exports, "setModelMode", () => $265d938c2203c79f$export$f802181667c0c6dc);
// installPreviewAiTransport(el) — wires the preview AI panel (the shared simone
// Chat component) to dispatch through sdk.ai, mirroring the bridge protocol the
// Chat surface expects. Adapted from workspace/functions/simoneAiTransport.js,
// slimmed to the preview surface: workspace-scoped (no /add-app, no local
// ws-bridge), and — the preview-specific bit — it targets the PREVIEWED project
// so the assistant's server-side `commit_project_changes` edits THAT project,
// then re-renders the iframe to reflect any committed changes.
//
// sendPrompt snapshots the user message into root.chatMessages, flips
// chatTyping:true, and calls window.__simoneSendOverBridge(envelope, { stateRoot }).
// We own that handle and route it to sdk.ai.dispatch.
// Bare shared-library import, not a deep functions/aiService.js subpath — a
// per-file deep specifier into @symbo-ls/workspace-shared cannot resolve
// through the platform's public importmap (tickets/execution-board.md §1,
// same fix as workspace/app.js — this file rides the workspace-shell EAGER
// chunk via preview/functions/eagerSlice.js, so it is a reached path).
// Deferred call wrapper, not a module-scope destructure, per the a5d0a2aa
// barrel-cycle lesson.

var $1X0Je = parcelRequire("1X0Je");
const $265d938c2203c79f$var$previewGetAiService = (...args)=>(0, $1X0Je.default).functions.getAiService(...args);
let $265d938c2203c79f$var$_previewInstalled = false;
// Resolve the LIVE root. The auth/shell boot can remount the tree, so a root
// captured at install goes stale (patches no-op → empty bubbles). Prefer the
// root the sender passed alongside the envelope (resolved fresh at send time).
// The installer element handle lives on `globalThis` rather than a
// module-scope `let` — frank's globalScope-lift promotes `installPreviewAiTransport`
// / `_previewResolveRoot` into independently-serialized functions (referenced as
// string handlers elsewhere), which strips the shared module closure; a
// plain `let` free var then revives as a guaranteed `ReferenceError`. A
// `globalThis` property read/write needs no closure — it resolves the same
// inside every independently-serialized function. See tickets/opus.md
// "canvas serialization defects blocking the authorised production push".
const $265d938c2203c79f$var$_previewResolveRoot = (extra)=>{
    if (extra && extra.stateRoot && typeof extra.stateRoot.update === 'function') return extra.stateRoot;
    const el = globalThis.__previewAiInstallerEl;
    return el && el.state && el.state.root || el && typeof el.getRoot === 'function' && el.getRoot()?.state?.root || null;
};
// Same precedence as workspace scopedClient.activeWorkspaceId, plus the previewed
// project's own workspace and the localStorage fallback sdk.ai itself reads
// (preview.* is a separate origin with no session activeWorkspace, so the
// project's workspace — pinned by bootPreviewAssistant — is the reliable source).
const $265d938c2203c79f$var$_previewActiveWorkspaceId = (root)=>{
    const fromState = root && root.workspace && root.workspace.id || root?.jwtClaims?.active_workspace_id || root?._previewProject?.workspaceId;
    if (fromState) return fromState;
    try {
        if (typeof window !== 'undefined') return window.localStorage.getItem('activeWorkspace') || null;
    } catch (err) {
        console.warn('[preview] read activeWorkspace:', err);
    }
    return null;
};
const $265d938c2203c79f$var$_previewPatchAssistantMessage = (root, id, patch)=>{
    if (!root?.update) return;
    const list = root.chatMessages || [];
    root.update({
        chatMessages: list.map((m)=>m.id === id ? {
                ...m,
                ...patch
            } : m)
    });
};
const $265d938c2203c79f$var$_previewPushSystemMessage = (root, text)=>{
    if (!root?.update) return;
    root.update({
        chatMessages: (root.chatMessages || []).concat({
            id: `sys-${Date.now()}`,
            role: 'system',
            text: text,
            ts: Date.now()
        })
    });
};
function $265d938c2203c79f$export$87b774147ceda3fc(el) {
    if (typeof window === 'undefined') return;
    // Refresh the handle on every call so re-installs (remounts) point at the
    // current tree; the window handler installs once.
    globalThis.__previewAiInstallerEl = el;
    const initRoot = $265d938c2203c79f$var$_previewResolveRoot(null);
    // simone's composer disables Send while bridgeStatus !== 'open'; the AI
    // service does the real round-trip, so we look healthy once installed.
    if (initRoot?.update) initRoot.update({
        bridgeStatus: 'open',
        agent: 'sdk-ai'
    });
    if ($265d938c2203c79f$var$_previewInstalled) return;
    $265d938c2203c79f$var$_previewInstalled = true;
    window.__simoneSendOverBridge = (envelope, extra)=>{
        if (!envelope || envelope.type !== 'user_message') return;
        const root = $265d938c2203c79f$var$_previewResolveRoot(extra);
        const text = String(envelope.text || '').trim();
        if (!text) return;
        const ai = $265d938c2203c79f$var$previewGetAiService();
        if (!ai) {
            $265d938c2203c79f$var$_previewPushSystemMessage(root, "AI service not ready \u2014 please retry in a moment.");
            if (root?.update) root.update({
                chatTyping: false
            });
            return;
        }
        // Route through the DEFAULT (workspace-scoped) Simone AI endpoint — the same
        // backend the workspace assistant uses. We deliberately do NOT pass a
        // projectId: the project-scoped conversation endpoint returned no assistant
        // response. The previewed project rides along in `context` instead, so the
        // agent's commit_project_changes still targets it. The active workspace is
        // the project's own workspace, pinned into localStorage 'activeWorkspace' by
        // bootPreviewAssistant (which sdk.ai reads via _readActiveWorkspace).
        const proj = root && root._previewProject || null;
        const wsId = $265d938c2203c79f$var$_previewActiveWorkspaceId(root);
        if (!wsId) {
            $265d938c2203c79f$var$_previewPushSystemMessage(root, 'Sign in and open this project in your workspace to use the assistant here.');
            if (root?.update) root.update({
                chatTyping: false
            });
            return;
        }
        const assistantId = `a-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
        if (root?.update) root.update({
            chatMessages: (root.chatMessages || []).concat({
                id: assistantId,
                role: 'assistant',
                text: '',
                ts: Date.now(),
                streaming: true
            }),
            currentAssistantId: assistantId
        });
        // Picked elements are POINTERS: the user aimed at something in the preview to
        // talk about / edit it. Compact one-liners prefixed to the dispatched text so
        // the agent always sees them even if it ignores structured context.
        const picked = Array.isArray(envelope.context?.pickedElements) ? envelope.context.pickedElements : [];
        const pointing = picked.length ? picked.map((p)=>{
            const path = (p?.keyPath || []).join(" \u203A ");
            const name = path || p?.component || p?.key || p?.tag || 'element';
            const snippet = (p?.text || '').trim().slice(0, 80);
            return `[user is pointing at: ${name}${snippet ? ` \u{2014} "${snippet}"` : ''}]`;
        }).join('\n') + '\n\n' : '';
        const dispatchContext = {
            surface: 'preview',
            // Which project the user is looking at — so the agent edits the right one
            // even though the conversation is workspace-scoped (the default endpoint).
            previewProject: proj ? {
                id: proj.id,
                owner: proj.owner,
                key: proj.key,
                env: proj.env,
                workspaceId: proj.workspaceId
            } : null,
            pickedElements: picked.length ? picked : null
        };
        // Continue the active thread when its id is a real server id.
        const activeConvId = (()=>{
            const id = root.activeSessionId;
            return id && !String(id).startsWith('s-') ? id : null;
        })();
        let buffered = '';
        ai.dispatch({
            text: pointing + text,
            conversationId: activeConvId,
            context: dispatchContext
        }, {
            onChunk: (delta)=>{
                buffered += delta;
                $265d938c2203c79f$var$_previewPatchAssistantMessage(root, assistantId, {
                    text: buffered
                });
            },
            onDone: (result)=>{
                const finalText = result?.text || buffered || '';
                $265d938c2203c79f$var$_previewPatchAssistantMessage(root, assistantId, {
                    text: finalText,
                    streaming: false
                });
                if (root?.update) {
                    const patch = {
                        chatTyping: false,
                        currentAssistantId: null
                    };
                    if (result?.conversationId) patch.activeSessionId = result.conversationId;
                    root.update(patch);
                }
                // Reflect any server-side project edits the agent committed this turn:
                // re-fetch the current env's data and re-render the iframe if it changed.
                // Best-effort — chat stays usable even if the refresh fails.
                try {
                    const callEl = globalThis.__previewAiInstallerEl;
                    if (callEl && typeof callEl.call === 'function') callEl.call('reloadPreviewProject');
                } catch (err) {
                    console.warn('[preview] post-turn project reload:', err);
                }
            },
            onError: (err)=>{
                const msg = err?.message || String(err);
                const el = globalThis.__previewAiInstallerEl;
                const template = el && typeof el.call === 'function' ? el.call('polyglot', 'preview.assistant.requestFailed') : null;
                $265d938c2203c79f$var$_previewPatchAssistantMessage(root, assistantId, {
                    text: template ? template.replace('{message}', msg) : msg,
                    streaming: false
                });
                if (root?.update) root.update({
                    chatTyping: false,
                    currentAssistantId: null
                });
            },
            // The preview surface runs no client (browser) platform tools — project
            // edits run server-side via commit_project_changes. Answer gracefully so
            // a loop that asks for a client tool can continue with text instead of
            // hanging.
            onToolCall: ()=>({
                    ok: false,
                    error: 'Client tools are not available in the preview surface.'
                })
        });
    };
}

const $265d938c2203c79f$export$3b60cea472c320c1 = async function() {
    if (typeof window === 'undefined') return;
    const el = this;
    try {
        const { resolveAiService: resolveAiService } = await Promise.resolve((parcelRequire("kANrO")));
        await resolveAiService();
    } catch (err) {
        // Anonymous / no-SDK boot — install anyway; sendPrompt surfaces a clear
        // "sign in to edit" / "AI not ready" message rather than failing silently.
        console.warn('[preview] resolveAiService:', err);
    }
    // ONE SHELL ASSISTANT (Nika, 2026-10-03): inside the shell the shell's
    // transport owns the bridge on every page — preview's own sender is for
    // preview STANDALONE only. The shell is detected through the element's own
    // context (the shell registers shellSendPrompt), not a DOM/window probe.
    const inShell = !!(el && el.context && el.context.functions && typeof el.context.functions.shellSendPrompt === 'function');
    if (!inShell) $265d938c2203c79f$export$87b774147ceda3fc(el);
};

const $265d938c2203c79f$export$b64233fcc79c8345 = async function(opts = {}) {
    const root = this.state && this.state.root;
    if (!root) return;
    const force = !!(opts && opts.force);
    // SPA-RELOAD-1: swallowing failures is right for the automatic post-turn
    // reload, and wrong for an explicit user-invoked retry — the caller cannot
    // tell a recovered project from a still-broken one. `throwOnError` lets
    // `retryPreviewProjectLoad` re-raise and re-render the error boundary with
    // the CURRENT error instead of leaving the stale boot one on screen.
    const throwOnError = !!(opts && opts.throwOnError);
    // THE SITE BUILDER (the shell's /preview, functions/previewSite.js): the
    // site ON SCREEN — never the address bar's project (a pane's site is not in
    // it) — at its LATEST SAVED version, never an environment's cached
    // published pin. A version pin on the builder's own address (Version
    // History "Preview this version") holds on Refresh; `opts.latest` (an AI
    // write landed) drops it. Preview standalone keeps its address-bar read.
    const fns = this.context && this.context.functions || {};
    const builder = typeof fns.shellSendPrompt === 'function' && typeof fns.previewSiteFetch === 'function';
    if (force) root.update({
        _previewRefreshing: true
    });
    try {
        let data = null;
        let sitePatch = null;
        if (builder) {
            const shown = this.call('previewSiteInView', root) || (root._previewSite && root._previewSite.owner ? root._previewSite : null) || this.call('previewPageTarget', root);
            if (shown && shown.owner && shown.key) {
                const pin = opts && opts.latest ? null : this.call('previewPageTarget', root);
                const version = pin && pin.owner === shown.owner && pin.key === shown.key ? pin.version : undefined;
                const got = await this.call('previewSiteFetch', {
                    owner: shown.owner,
                    key: shown.key,
                    version: version
                });
                data = got && got.data;
                const prev = root._previewSite || {};
                const same = prev.owner === shown.owner && prev.key === shown.key;
                sitePatch = {
                    env: null,
                    _previewSiteDraft: !!(got && got.draft),
                    _previewSite: {
                        owner: shown.owner,
                        key: shown.key,
                        projectId: got && got.projectId || same && prev.projectId || null,
                        env: null,
                        page: same && prev.page || '/'
                    }
                };
            }
        } else {
            const { getProjectData: getProjectData } = await Promise.resolve((parcelRequire("3BQmv")));
            const env = root.env;
            data = await getProjectData(env ? {
                env: env,
                raw: true
            } : {
                raw: true
            });
        }
        if (!data) {
            if (throwOnError) throw new Error('Project data unavailable');
            return;
        }
        // Cheap structural signature — skip the (expensive) iframe teardown when a
        // pure-Q&A turn didn't actually change the project. A forced (manual
        // button) reload always proceeds regardless.
        let sig = '';
        try {
            sig = JSON.stringify({
                c: data.components,
                p: data.pages,
                a: data.app,
                d: data.designSystem
            });
        } catch (err) {
            console.warn('[preview] sign project data:', err);
        }
        if (sitePatch) root.update(sitePatch);
        if (!force && sig && root._previewDataSig && root._previewDataSig === sig) return;
        root.update({
            data: data,
            _previewDataSig: sig
        });
        const iframe = typeof document !== 'undefined' ? document.getElementById('preview-app-iframe') : null;
        if (!iframe) return;
        let snapshot = data;
        try {
            snapshot = JSON.parse(JSON.stringify(data));
        } catch (err) {
            console.warn('[preview] snapshot project data:', err);
        }
        // A live user-code frame is REMOUNTED over its port with the new data.
        await this.call('renderProject', iframe, snapshot, {
            reset: true
        });
    } catch (err) {
        if (throwOnError) throw err;
        console.warn('[preview] reloadPreviewProject failed:', err);
    } finally{
        if (force) root.update({
            _previewRefreshing: false
        });
    }
};
const $265d938c2203c79f$export$43c80672febddad8 = function() {
    const root = this.state && this.state.root;
    if (!root?.update) return;
    root.update({
        chatMessages: [],
        currentAssistantId: null,
        activeSessionId: null,
        chatTyping: false,
        showSessionMenu: false
    });
};
const $265d938c2203c79f$export$f802181667c0c6dc = function(mode) {
    try {
        const ai = $265d938c2203c79f$var$previewGetAiService();
        if (ai && typeof ai.setModelMode === 'function') ai.setModelMode(mode);
    } catch (err) {
        console.warn('[preview] setModelMode:', err);
    }
} // el.call('fetchAiProviderDiagnostics') is shared's own registration
 // (shared/functions/aiProviderDiagnostics.js). shared is a declared library
 // of preview, so its functions bag already answers the key here; a preview
 // delegate under the same key was a second definition of one name in a
 // catalog that merges both libraries.
;

});

parcelRegister("99l6A", function(module, exports) {

$parcel$export(module.exports, "previewAiViews", () => $6a9553662762ab47$export$87719899ebc9adfe);
$parcel$export(module.exports, "previewEnvLabel", () => $6a9553662762ab47$export$5f9eb39a810b6643);
$parcel$export(module.exports, "previewAnswerPath", () => $6a9553662762ab47$export$c33428f70ee6a6b5);
$parcel$export(module.exports, "previewAnswerUrl", () => $6a9553662762ab47$export$7509c9c90ce9ad3d);
$parcel$export(module.exports, "previewSiteRead", () => $6a9553662762ab47$export$6afde7f1513e737b);
$parcel$export(module.exports, "previewSiteHosting", () => $6a9553662762ab47$export$61014a007173f9ba);
$parcel$export(module.exports, "previewEnvServes", () => $6a9553662762ab47$export$d051e760454ef3a3);
$parcel$export(module.exports, "previewAnswerPages", () => $6a9553662762ab47$export$d46b74a6d030e3d5);
$parcel$export(module.exports, "previewAnswerHasContent", () => $6a9553662762ab47$export$a308a203e8df5bed);
$parcel$export(module.exports, "previewAnswerResolve", () => $6a9553662762ab47$export$c930384f53e8e8e6);
$parcel$export(module.exports, "previewAnswerEmptyText", () => $6a9553662762ab47$export$ebef3df1baadf4bb);
$parcel$export(module.exports, "previewAnswerInputs", () => $6a9553662762ab47$export$fd445f6202b8f9a9);
$parcel$export(module.exports, "previewAnswerLoad", () => $6a9553662762ab47$export$8991523522df6d59);
$parcel$export(module.exports, "previewAnswerNote", () => $6a9553662762ab47$export$4f01b85107d728e5);
$parcel$export(module.exports, "previewAnswerDevice", () => $6a9553662762ab47$export$24ccfdd85c50cc9f);
$parcel$export(module.exports, "previewAnswerFrameLoaded", () => $6a9553662762ab47$export$3c2306064d29ace2);
$parcel$export(module.exports, "previewAnswerFrameTimer", () => $6a9553662762ab47$export$d3ba7dcc1f358c4c);
$parcel$export(module.exports, "previewDeviceSize", () => $6a9553662762ab47$export$8d4980c50b696452);
$parcel$export(module.exports, "previewAnswerMeasure", () => $6a9553662762ab47$export$a939b02b44b0f803);
$parcel$export(module.exports, "previewAnswerFrameStyle", () => $6a9553662762ab47$export$9c12ecb7ed605e01);
$parcel$export(module.exports, "previewAnswerLink", () => $6a9553662762ab47$export$5f188a5cbe2de03a);
$parcel$export(module.exports, "previewPageTarget", () => $6a9553662762ab47$export$8b39f2739b9753b9);
$parcel$export(module.exports, "previewPagePatch", () => $6a9553662762ab47$export$bddb79e5781c14e0);
$parcel$export(module.exports, "previewAnswerOpenSite", () => $6a9553662762ab47$export$a88c80b3ced0ab38);
$parcel$export(module.exports, "previewAnswerView", () => $6a9553662762ab47$export$aa55a9065fef0656);
$parcel$export(module.exports, "previewAnswerInspectNode", () => $6a9553662762ab47$export$c12c37ccd32ad712);
$parcel$export(module.exports, "previewAnswerInspect", () => $6a9553662762ab47$export$58e6d26eb0d45ec7);
$parcel$export(module.exports, "previewAnswerPickToggle", () => $6a9553662762ab47$export$a20c69aa465bdf26);
$parcel$export(module.exports, "previewAnswerReload", () => $6a9553662762ab47$export$14afc9b24b379e18);
$parcel$export(module.exports, "previewSiteForget", () => $6a9553662762ab47$export$8b01a29af9e8e0f3);
$parcel$export(module.exports, "previewAnswerRemoved", () => $6a9553662762ab47$export$f0d7221afe8b93df);
// A WEBSITE IN AN AI ANSWER — the preview package's views the assistant
// mounts in its thread and a Fly page places as sections (workspace
// functions/assistantAppViews.js, the `views[]` contract). Nika 2026-10-18:
// "test workspaces with more data, live websites, live previews … inspect
// modes" — "fly should cover all functionality that would be possible
// otherwise".
//
// previewAiViews() is the view PROVIDER. The components (SitePreviewView,
// ProjectPagesView, PreviewDesignSystemView) and these functions ride the
// preview EAGER slice, so a view mounts with no fold of the preview app; the
// one step that needs the app's render pipeline — INSPECT, the project in the
// sandboxed user-code frame with element picking — folds the preview context
// first (workspace ensureAppViewContext('preview')).
//
//   site-preview    one of the workspace's websites, live: `project` (an enum
//                   of the WEBSITES — never an installed module or a shared
//                   library — labelled by name), `path`, `env` (the project
//                   environment: its own published address, never another
//                   one silently), `device` (the preview's own device widths),
//                   `inspect`. In the card: env pills (the environments the
//                   project has on), a page switcher, inspect + pick, reload,
//                   open in the preview app, open the site in a new tab.
//   project-pages   a website's pages (and components) as screenshot tiles
//                   (functions/previewPagesAnswer.js); a tile swaps in the
//                   live page.
//   design-system   a website's tokens, type and icons through the design-
//                   system embed (functions/previewPagesAnswer.js).
//
// The projects are the canvas package's read (canvasAnswerRead — the home
// Projects widget's list) and its website rules (canvasAnswerSites,
// canvasAnswerNamed, canvasAnswerOnScreen). The addresses are the ones the
// preview's own "Open in new tab" builds: the project's mermaid address on
// THIS shell's channel (the host's channel, else the build's), per project
// environment. Nothing here writes project data.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
function $6a9553662762ab47$export$87719899ebc9adfe() {
    const el = this && typeof this.call === 'function' ? this : null;
    const root = el && el.state && el.state.root || null;
    // The site: one of the workspace's websites, an enum of their names once
    // the list is known (canvasAnswerProjectParam), a name-or-key before.
    let project = {
        type: 'string',
        describe: 'a website (project) name or key; the project on screen, else the newest website'
    };
    if (el && root) try {
        const own = el.call('canvasAnswerProjectParam', root);
        if (own && typeof own === 'object') project = own;
    } catch (_) {
    /* the string form stays */ }
    const env = {
        type: 'enum',
        values: [
            'production',
            'staging',
            'development'
        ],
        labels: {
            production: 'preview.navbar.env.production',
            staging: 'preview.navbar.env.staging',
            development: 'preview.navbar.env.development'
        },
        default: 'production',
        describe: 'the project environment shown'
    };
    const open = {
        route: '/preview',
        call: 'previewAnswerLink'
    };
    return {
        app: {
            id: 'system/preview',
            navbar: [
                {
                    label: 'shell.app.studio',
                    route: '/studio',
                    icon: 'eye'
                }
            ],
            apps: [
                {
                    icon: 'eye'
                }
            ]
        },
        fold: null,
        views: [
            {
                id: 'site-preview',
                title: 'preview.answer.title',
                describe: "One of the workspace's websites, live: project, path = a page like /pricing, env, device; inspect = point at its elements.",
                component: 'SitePreviewView',
                icon: 'eye',
                hue: 'cerulean',
                // Half the width and tall (`l`, 6 × 6 of 12): a site at 16:10 reads
                // in it. `xl` (12 × 3) was a full-width strip of ~190 px on a Fly
                // page (QA on dev, 2026-10-18).
                size: 'l',
                params: {
                    project: project,
                    path: {
                        type: 'string',
                        describe: 'a page path, like / or /pricing'
                    },
                    env: env,
                    device: {
                        type: 'enum',
                        values: [
                            'desktop',
                            'tablet',
                            'mobile'
                        ],
                        labels: {
                            desktop: 'preview.answer.device.desktop',
                            tablet: 'preview.answer.device.tablet',
                            mobile: 'preview.answer.device.mobile'
                        },
                        default: 'desktop'
                    },
                    inspect: {
                        type: 'boolean',
                        default: false,
                        describe: 'open with element inspect on (the person points at parts of the page)'
                    }
                },
                link: open
            },
            {
                id: 'project-pages',
                title: 'preview.pagesView.title',
                describe: "A website's pages (or its components) as screenshot tiles; a tile opens that page live in the card.",
                component: 'ProjectPagesView',
                icon: 'pages',
                hue: 'cerulean',
                size: 'l',
                params: {
                    project: project,
                    env: env,
                    show: {
                        type: 'enum',
                        values: [
                            'pages',
                            'components'
                        ],
                        labels: {
                            pages: 'preview.sidebar.category.pages',
                            components: 'preview.sidebar.category.components'
                        },
                        default: 'pages'
                    },
                    limit: {
                        type: 'number',
                        min: 1,
                        max: 24,
                        default: 12
                    }
                },
                link: open
            },
            {
                id: 'design-system',
                title: 'preview.dsView.title',
                describe: "A website's design system: its colors, typography, spacing, icons, transitions and layout tokens.",
                component: 'PreviewDesignSystemView',
                icon: 'color',
                hue: 'cerulean',
                size: 'l',
                params: {
                    project: project,
                    env: env,
                    section: {
                        type: 'enum',
                        values: [
                            'colors',
                            'typography',
                            'spacing',
                            'icons',
                            'transitions',
                            'layout'
                        ],
                        labels: {
                            colors: 'preview.sidebar.ds.colors',
                            typography: 'preview.sidebar.ds.typography',
                            spacing: 'preview.sidebar.ds.spacing',
                            icons: 'preview.sidebar.ds.icons',
                            transitions: 'preview.sidebar.ds.transitions',
                            layout: 'preview.sidebar.ds.layout'
                        },
                        default: 'colors'
                    }
                },
                link: open
            }
        ]
    };
}
function $6a9553662762ab47$export$5f9eb39a810b6643(env) {
    const LABELS = {
        production: 'preview.navbar.env.production',
        staging: 'preview.navbar.env.staging',
        development: 'preview.navbar.env.development'
    };
    return LABELS[env] || LABELS.production;
}
function $6a9553662762ab47$export$c33428f70ee6a6b5(path) {
    const raw = String(path == null ? '' : path).trim();
    if (!raw || /^[a-z][a-z0-9+.-]*:/i.test(raw) || raw.startsWith('//')) return '/';
    const clean = raw.split(/[?#]/)[0].replace(/\/{2,}/g, '/');
    if (!/^[\w\-./~%]*$/.test(clean)) return '/';
    return clean.startsWith('/') ? clean : '/' + clean;
}

async function $6a9553662762ab47$export$7509c9c90ce9ad3d(project, path, env) {
    const el = this;
    const p = project && typeof project === 'object' ? project : null;
    if (!p) return null;
    const slugOf = (v)=>{
        if (!v) return '';
        if (typeof v === 'string') return /^[a-f0-9]{24}$/i.test(v) ? '' : v;
        return v.slug || v.key || '';
    };
    const owner = slugOf(p.owner) || slugOf(p.workspace && p.workspace.organization);
    const key = String(p.key || '').split('.')[0];
    if (!owner || !key) return null;
    let channels = null;
    try {
        channels = await Promise.resolve((parcelRequire("hmkNw")));
    } catch (_) {
        channels = null;
    }
    if (!channels || typeof channels.mermaidUrl !== 'function') return null;
    let channel = null;
    try {
        channel = el.call('currentChannelFromHost');
    } catch (_) {
        channel = null;
    }
    const name = channel || (typeof channels.currentChannel === 'function' ? channels.currentChannel() : undefined);
    const ENVS = [
        'production',
        'staging',
        'development'
    ];
    const base = channels.mermaidUrl({
        owner: owner,
        key: key,
        env: ENVS.includes(env) ? env : 'production'
    }, name);
    if (!base) return null;
    const page = el.call('previewAnswerPath', path);
    return page === '/' ? base + '/' : base + page;
}

async function $6a9553662762ab47$export$6afde7f1513e737b(req) {
    const host = this;
    const r = req && typeof req === 'object' ? req : {};
    const owner = typeof r.owner === 'string' ? r.owner.trim() : '';
    const key = String(r.key || '').split('.')[0];
    const env = [
        'production',
        'staging',
        'development'
    ].includes(r.env) ? r.env : 'production';
    const kind = r.auth ? 'auth' : 'public';
    if (!owner || !key) return {
        published: null,
        visibility: null,
        data: null,
        error: 'no_site'
    };
    let rootEl = null;
    try {
        rootEl = typeof host.getRoot === 'function' ? host.getRoot() : null;
    } catch (_) {
        rootEl = null;
    }
    const memo = rootEl && rootEl.scope && typeof rootEl.scope === 'object' ? rootEl.scope : null;
    if (memo && !(memo.previewSiteReads instanceof Map)) memo.previewSiteReads = new Map();
    const bag = memo ? memo.previewSiteReads : null;
    const id = kind + ':' + owner + '/' + key + '/' + env;
    const now = Date.now();
    const hit = bag && bag.get(id);
    if (hit && now - hit.at < 60000) return hit.promise;
    const sdk = host.sdk || host.call('getSDK');
    const run = async ()=>{
        if (kind === 'auth') {
            const mod = await Promise.resolve((parcelRequire("3BQmv")));
            const data = await mod.getProjectData({
                raw: true,
                owner: owner,
                key: key,
                env: env
            });
            return {
                published: null,
                visibility: null,
                data: data || null,
                error: null
            };
        }
        if (!sdk || typeof sdk.getPublicProjectDataByKey !== 'function') return {
            published: null,
            visibility: null,
            data: null,
            error: 'no_sdk'
        };
        let data = null;
        try {
            data = await sdk.getPublicProjectDataByKey({
                owner: owner,
                key: key
            }, {
                envKey: env
            });
        } catch (err) {
            if (err && err.code === 'password_required') return {
                published: false,
                visibility: 'password-protected',
                data: null,
                error: null
            };
            // The server's own answer rides the error's cause: an environment whose
            // mode is `published` on a project never published (`no_published_
            // version`, measured on dev 2026-10-19: system/bi-app production). The
            // public route fails closed while the site's address still serves the
            // latest saved version — `never`, not a failed read.
            const body = err && err.cause && (err.cause.cause || err.cause) || null;
            if (body && typeof body === 'object' && body.error === 'no_published_version') return {
                published: false,
                never: true,
                visibility: 'public',
                data: null,
                error: null
            };
            throw err;
        }
        if (data && typeof data === 'object') return {
            published: true,
            visibility: 'public',
            data: data,
            error: null
        };
        let visibility = null;
        try {
            visibility = typeof sdk.getPublicProjectVisibility === 'function' ? await sdk.getPublicProjectVisibility({
                owner: owner,
                key: key
            }) : null;
        } catch (_) {
            visibility = null;
        }
        return {
            published: false,
            visibility: visibility || null,
            data: null,
            error: null
        };
    };
    const promise = run().catch((err)=>{
        if (bag && bag.get(id) && bag.get(id).promise === promise) bag.delete(id);
        return {
            published: null,
            visibility: null,
            data: null,
            error: String(err && err.message || err || 'failed')
        };
    });
    if (bag) {
        bag.set(id, {
            at: now,
            promise: promise
        });
        while(bag.size > 8)bag.delete(bag.keys().next().value);
    }
    return promise;
}
async function $6a9553662762ab47$export$61014a007173f9ba(req) {
    const host = this;
    const r = req && typeof req === 'object' ? req : {};
    const ALL = [
        'production',
        'staging',
        'development'
    ];
    const owner = typeof r.owner === 'string' ? r.owner.trim() : '';
    const key = String(r.key || '').split('.')[0];
    const unknown = {
        id: r.id || null,
        known: false,
        environments: null,
        on: ALL,
        published: null
    };
    const data = (v)=>v && typeof v === 'object' && 'data' in v && v.success ? v.data : v;
    let rootEl = null;
    try {
        rootEl = typeof host.getRoot === 'function' ? host.getRoot() : null;
    } catch (_) {
        rootEl = null;
    }
    const memo = rootEl && rootEl.scope && typeof rootEl.scope === 'object' ? rootEl.scope : null;
    if (memo && !(memo.previewSiteReads instanceof Map)) memo.previewSiteReads = new Map();
    const bag = memo ? memo.previewSiteReads : null;
    const slot = 'hosting:' + owner + '/' + key;
    const hit = bag && bag.get(slot);
    if (hit && Date.now() - hit.at < 60000) return hit.promise;
    const run = async ()=>{
        const sdk = host.sdk || host.call('getSDK');
        if (!sdk || !owner || !key) return unknown;
        let id = r.id || null;
        let published = null;
        if (typeof sdk.getProjectByKey === 'function') try {
            const p = data(await sdk.getProjectByKey({
                owner: owner,
                key: key
            }));
            if (p && typeof p === 'object' && (p._id || p.id)) {
                id = p._id || p.id;
                const pv = p.publishedVersion;
                published = !!(pv && (typeof pv === 'string' || pv.value || pv._id));
            }
        } catch (_) {
            published = null;
        }
        if (!id || typeof sdk.listEnvironments !== 'function') return {
            ...unknown,
            id: id,
            published: published
        };
        let map = null;
        try {
            const res = data(await sdk.listEnvironments(id));
            map = res && res.environments && typeof res.environments === 'object' ? res.environments : null;
        } catch (_) {
            map = null;
        }
        if (!map) return {
            ...unknown,
            id: id,
            published: published
        };
        const on = ALL.filter((k)=>map[k] && typeof map[k] === 'object' && map[k].enabled !== false);
        return {
            id: id,
            known: true,
            environments: map,
            on: on,
            published: published
        };
    };
    // An answer that knows nothing is not kept: the next read asks again.
    const promise = run().catch(()=>unknown).then((out)=>{
        if (!out.known && bag && bag.get(slot) && bag.get(slot).promise === promise) bag.delete(slot);
        return out;
    });
    if (bag) {
        bag.set(slot, {
            at: Date.now(),
            promise: promise
        });
        while(bag.size > 8)bag.delete(bag.keys().next().value);
    }
    return promise;
}
function $6a9553662762ab47$export$d051e760454ef3a3(hosting, env) {
    const h = hosting && typeof hosting === 'object' ? hosting : null;
    if (!h || !h.known || !h.environments || typeof h.environments !== 'object') return null;
    const cfg = h.environments[env];
    if (!cfg || typeof cfg !== 'object' || cfg.enabled === false) return 'off';
    if (cfg.mode === 'published') return h.published === false ? 'never' : 'published';
    if (cfg.mode === 'version' && typeof cfg.version === 'string' && cfg.version) return 'version';
    if (cfg.mode === 'branch') return 'branch';
    return 'latest';
}
function $6a9553662762ab47$export$d46b74a6d030e3d5(data) {
    const pages = data && data.pages && typeof data.pages === 'object' ? data.pages : null;
    if (!pages) return [];
    const shell = (v)=>v != null && typeof v === 'object' && Object.keys(v).some((k)=>k !== 'metadata');
    return Object.keys(pages).filter((k)=>k.startsWith('/') && !/[:*]/.test(k) && shell(pages[k])).sort((a, b)=>a === '/' ? -1 : b === '/' ? 1 : a.localeCompare(b)).slice(0, 60);
}
function $6a9553662762ab47$export$a308a203e8df5bed(data) {
    if (!data || typeof data !== 'object') return false;
    const shell = (v)=>v != null && typeof v === 'object' && Object.keys(v).some((k)=>k !== 'metadata');
    if (shell(data.app)) return true;
    const pages = data.pages && typeof data.pages === 'object' ? data.pages : {};
    return Object.keys(pages).some((k)=>shell(pages[k]));
}
async function $6a9553662762ab47$export$c930384f53e8e8e6(el) {
    const host = el || this;
    const s = host && host.state || {};
    const params = host && host.scope && host.scope.params || {};
    const root = s.root || {};
    const ENVS = [
        'production',
        'staging',
        'development'
    ];
    const env = ENVS.includes(s.env) ? s.env : ENVS.includes(params.env) ? params.env : 'production';
    const path = host.call('previewAnswerPath', typeof s.page === 'string' && s.page ? s.page : params.path);
    const installed = host.call('canvasAnswerInstalled', root);
    const read = await host.call('canvasAnswerRead', host);
    const sites = host.call('canvasAnswerSites', read && read.projects, installed);
    const meant = await host.call('canvasAnswerNamedRead', sites, read && !read.failed ? read.projects : null, params.project, host.call('canvasAnswerOnScreen', root), root) || {};
    const site = meant.kind === 'website' ? meant.site : null;
    return {
        site: site ? {
            ...site,
            env: env,
            path: path
        } : null,
        sites: sites,
        read: read,
        notWebsite: meant.kind === 'project' ? meant.name : null,
        storeApp: meant.kind === 'storeApp' ? meant.name : null
    };
}
function $6a9553662762ab47$export$ebef3df1baadf4bb(s) {
    const st = s && typeof s === 'object' ? s : {};
    const say = (key, name)=>String(this.call('polyglot', key)).replace('{name}', ()=>name);
    if (st.notWebsite) return say('preview.answer.notWebsite', st.notWebsite);
    if (st.storeApp) return say('preview.answer.storeApp', st.storeApp);
    return String(this.call('polyglot', st.none ? 'preview.answer.none' : 'preview.answer.missing'));
}
function $6a9553662762ab47$export$fd445f6202b8f9a9(el) {
    const host = el || this;
    const s = host && host.state || {};
    const params = host && host.scope && host.scope.params || {};
    const root = s.root || {};
    const on = host.call('canvasAnswerOnScreen', root);
    return JSON.stringify([
        params.project || '',
        params.path || '',
        params.env || '',
        s.env || '',
        s.page || '',
        host.call('canvasAnswerInstalled', root),
        on ? on.owner + '/' + on.key : '',
        Number(host && host.__canvasNamedEpoch) || 0
    ]);
}
async function $6a9553662762ab47$export$8991523522df6d59(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const params = host.scope && host.scope.params || {};
    host.call('canvasAnswerNamedMoved', host, params.project);
    const sig = host.call('previewAnswerInputs', host);
    if (host.__previewAnswerSig === sig) return null;
    host.__previewAnswerSig = sig;
    const res = await host.call('previewAnswerResolve', host);
    if (host.__previewAnswerSig !== sig) return null;
    const site = res.site;
    const url = site ? await host.call('previewAnswerUrl', site, site.path, site.env) : null;
    if (host.__previewAnswerSig !== sig) return null;
    if (!site || !url) {
        // A name that is a project of this workspace but not a website, or an App
        // Store app that is no project here: say so, with its name
        // (previewAnswerResolve), never "no match".
        host.state.update({
            site: null,
            failed: true,
            // No name asked and no website at all: say so, never "no match".
            none: !params.project && !!res.read && !res.read.failed && !res.sites.length,
            notWebsite: res.notWebsite || null,
            storeApp: res.storeApp || null
        });
        return null;
    }
    const before = host.state.site;
    const same = !!before && before.url === url;
    host.state.update({
        site: {
            key: site.key,
            name: site.name,
            owner: site.owner,
            id: site.id || null,
            env: site.env,
            path: site.path,
            url: url,
            serves: same ? before.serves : null,
            never: same ? before.never : false,
            pages: same ? before.pages : null,
            envs: same ? before.envs : null,
            content: same ? before.content : true
        },
        failed: false,
        none: false,
        notWebsite: null,
        storeApp: null,
        ...same ? {} : {
            frameReady: null,
            frameSlow: null
        }
    });
    // An inspect the model asked for (`inspect: true`) starts once, when the
    // site is known.
    if (params.inspect === true && !host.__previewAnswerInspected) {
        host.__previewAnswerInspected = true;
        host.call('previewAnswerInspect', host, true);
    }
    const [pub, hosting] = await Promise.all([
        host.call('previewSiteRead', {
            owner: site.owner,
            key: site.key,
            env: site.env
        }),
        host.call('previewSiteHosting', {
            owner: site.owner,
            key: site.key,
            id: site.id
        })
    ]);
    if (host.__previewAnswerSig !== sig) return null;
    const serves = host.call('previewEnvServes', hosting, site.env);
    // The page switcher: the public data, else (a private project, read as a
    // member) the editor's — the preview's own member read (previewSiteRead
    // `auth`); none for an environment that serves nothing.
    const view = pub && pub.data ? pub : serves === 'off' ? null : await host.call('previewSiteRead', {
        owner: site.owner,
        key: site.key,
        env: site.env,
        auth: true
    });
    if (host.__previewAnswerSig !== sig) return null;
    const now = host.state.site;
    if (!now || now.url !== url) return null;
    host.state.update({
        site: {
            ...now,
            serves: // 'off': the address serves nothing — said in place of the frame.
            serves,
            // Never published: the address still serves the latest saved version,
            // so the frame stays and one line says so (previewAnswerNote). The
            // record says it for a member; the public route for a public project.
            never: serves === 'never' || !!(pub && pub.never),
            pages: view && view.data ? host.call('previewAnswerPages', view.data) : null,
            // "No pages" only from the data the address serves — the public data.
            content: pub && pub.data ? host.call('previewAnswerHasContent', pub.data) : true,
            envs: hosting && Array.isArray(hosting.on) ? hosting.on : null
        }
    });
    return url;
}
function $6a9553662762ab47$export$4f01b85107d728e5(s) {
    const el = this;
    const st = s && typeof s === 'object' ? s : {};
    const site = st.site;
    if (!site) return {
        text: '',
        cover: false
    };
    const say = (key)=>String(el.call('polyglot', key)).replace('{name}', ()=>site.name || site.key || '').replace('{env}', ()=>String(el.call('polyglot', el.call('previewEnvLabel', site.env))));
    if (st.inspect) {
        if (st.inspectError) return {
            text: say('preview.answer.inspectFailed'),
            cover: true
        };
        if (!st.inspectReady) return {
            text: say('preview.answer.inspectLoading'),
            cover: true
        };
        const root = st.root || {};
        const node = el.call('previewAnswerInspectNode', el);
        if (root.picking && el.call('previewPickArmedOn', node)) return {
            text: say('preview.answer.picking'),
            cover: false
        };
        return {
            text: say('preview.answer.inspectReady'),
            cover: false
        };
    }
    if (site.serves === 'off') return {
        text: say('preview.answer.envOff'),
        cover: true
    };
    if (site.content === false) return {
        text: say('preview.answer.noContent'),
        cover: true
    };
    const frameKey = site.url + '#' + (Number(st.reload) || 0);
    if (site.never && st.frameReady === frameKey) return {
        text: say('preview.answer.neverPublished'),
        cover: false
    };
    if (st.frameReady === frameKey) return {
        text: '',
        cover: false
    };
    if (st.frameSlow === frameKey) return {
        text: say('preview.answer.slow'),
        cover: false
    };
    return {
        text: say('preview.answer.loading'),
        cover: true
    };
}
function $6a9553662762ab47$export$24ccfdd85c50cc9f(s) {
    const st = s && typeof s === 'object' ? s : {};
    const params = this && this.scope && this.scope.params || {};
    const DEVICES = [
        'desktop',
        'tablet',
        'mobile'
    ];
    return DEVICES.includes(st.device) ? st.device : DEVICES.includes(params.device) ? params.device : 'desktop';
}
function $6a9553662762ab47$export$3c2306064d29ace2(el) {
    const frame = el || this;
    const s = frame && frame.state;
    if (!s || typeof s.update !== 'function' || !frame.frameKey) return false;
    if (s.frameReady !== frame.frameKey) s.update({
        frameReady: frame.frameKey
    });
    return true;
}
function $6a9553662762ab47$export$d3ba7dcc1f358c4c(el) {
    const frame = el || this;
    if (!frame || !frame.frameKey) return false;
    clearTimeout(frame.__previewSlowTimer);
    frame.__previewSlowTimer = setTimeout(()=>{
        const s = frame.state;
        if (!s || typeof s.update !== 'function' || s.frameReady === frame.frameKey) return;
        if (frame.node && frame.node.isConnected === false) return;
        s.update({
            frameSlow: frame.frameKey
        });
    }, 12000);
    return true;
}
function $6a9553662762ab47$export$8d4980c50b696452(device) {
    const DEVICES = {
        screenL: [
            1920,
            1024
        ],
        screenM: [
            1680,
            1024
        ],
        tabletL: [
            1366,
            926
        ],
        tabletS: [
            1024,
            768
        ],
        mobileXS: [
            375,
            768
        ]
    };
    const ALIASES = {
        desktop: 'screenM',
        tablet: 'tabletS',
        mobile: 'mobileXS'
    };
    const size = DEVICES[ALIASES[device] || device];
    return size ? size.slice() : null;
}
function $6a9553662762ab47$export$a939b02b44b0f803(el) {
    const box = el || this;
    const node = box && box.node;
    const s = box && box.state;
    if (!node || !s || typeof s.update !== 'function') return false;
    const read = ()=>{
        if (node.isConnected === false || typeof node.getBoundingClientRect !== 'function') return;
        const r = node.getBoundingClientRect();
        const w = Math.round(r.width);
        const h = Math.round(r.height);
        if (!w || !h || s.boxW === w && s.boxH === h) return;
        s.update({
            boxW: w,
            boxH: h
        });
    };
    read();
    clearTimeout(box.__previewMeasureTimer);
    box.__previewMeasureTimer = setTimeout(read, 60);
    return true;
}
function $6a9553662762ab47$export$9c12ecb7ed605e01(s) {
    const st = s && typeof s === 'object' ? s : {};
    const size = this.call('previewDeviceSize', this.call('previewAnswerDevice', st)) || [
        1680,
        1024
    ];
    const bw = Number(st.boxW) || 0;
    const bh = Number(st.boxH) || 0;
    if (!bw || !bh) return {
        width: '100%',
        height: '100%',
        left: '0',
        transform: 'none'
    };
    const scale = Math.min(1, bw / size[0]);
    return {
        width: size[0] + 'px',
        height: Math.max(1, Math.round(bh / scale)) + 'px',
        left: scale < 1 ? '0' : Math.round((bw - size[0]) / 2) + 'px',
        transform: scale < 1 ? 'scale(' + scale.toFixed(4) + ')' : 'none'
    };
}
function $6a9553662762ab47$export$5f188a5cbe2de03a(params, root) {
    const r = root && typeof root === 'object' ? root : {};
    const p = params && typeof params === 'object' ? params : {};
    const list = this.call('canvasAnswerProjects', r);
    if (!Array.isArray(list)) return null;
    const sites = this.call('canvasAnswerSites', list, this.call('canvasAnswerInstalled', r));
    // The card's own rule (canvasAnswerNamed): a project that is not a website
    // links nowhere, as its card shows no site; an App Store app that is no
    // project here links to its App Store page (canvasAnswerStoreLink).
    const meant = this.call('canvasAnswerNamed', sites, list, p.project, this.call('canvasAnswerOnScreen', r), r) || {};
    if (meant.kind === 'storeApp') return this.call('canvasAnswerStoreLink', meant.app);
    const site = meant.kind === 'website' ? meant.site : null;
    if (!site || !site.owner || !site.key) return null;
    const env = [
        'production',
        'staging',
        'development'
    ].includes(p.env) ? p.env : 'production';
    return '/preview?owner=' + encodeURIComponent(site.owner) + '&key=' + encodeURIComponent(site.key.split('.')[0]) + '&env=' + encodeURIComponent(env);
}
function $6a9553662762ab47$export$8b39f2739b9753b9(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : {};
    const clean = (v)=>typeof v === 'string' && v.trim() ? v.trim() : undefined;
    let q = null;
    try {
        q = new URLSearchParams(typeof window !== 'undefined' && window.location ? window.location.search : '');
    } catch (_) {
        q = null;
    }
    const shellRead = !!el && !!el.context && !!el.context.functions && typeof el.context.functions.readPageParam === 'function';
    const param = (name)=>{
        let v = null;
        try {
            v = shellRead ? el.call('readPageParam', name) : null;
        } catch (_) {
            v = null;
        }
        return clean(v) || clean(q ? q.get(name) : null);
    };
    const owner = param('owner');
    const key = param('key');
    if (owner && key) // Version-pinned preview (canvas Version History → "Preview this
    // version") rides the same address.
    return {
        owner: owner,
        key: key,
        env: param('env'),
        version: param('version')
    };
    const p = r._previewParams;
    if (p && clean(p.owner) && clean(p.key)) return {
        owner: clean(p.owner),
        key: clean(p.key),
        env: clean(p.env),
        version: clean(p.version)
    };
    return null;
}
function $6a9553662762ab47$export$bddb79e5781c14e0(data, target) {
    const d = data && typeof data === 'object' ? data : null;
    const t = target && typeof target === 'object' ? target : {};
    const ENVS = [
        'production',
        'staging',
        'development'
    ];
    const asked = ENVS.includes(t.env) ? t.env : null;
    return {
        data: d,
        env: d && d._resolvedEnv || asked,
        ...d && d._resolvedEnv ? {
            resolvedEnv: d._resolvedEnv,
            requestedEnv: d._requestedEnv || d._resolvedEnv,
            usedFallback: !!d._usedFallback
        } : {}
    };
}
function $6a9553662762ab47$export$a88c80b3ced0ab38(target, event) {
    const el = this;
    const t = target && typeof target === 'object' ? target : {};
    const owner = typeof t.owner === 'string' ? t.owner.trim() : '';
    const key = String(t.key || '').split('.')[0];
    const root = el && el.state && el.state.root;
    if (!owner || !key || !root || typeof root.update !== 'function') return false;
    const env = [
        'production',
        'staging',
        'development'
    ].includes(t.env) ? t.env : null;
    root.update({
        _previewParams: {
            owner: owner,
            key: key,
            ...env ? {
                env: env
            } : {}
        }
    });
    const route = '/preview?owner=' + encodeURIComponent(owner) + '&key=' + encodeURIComponent(key) + (env ? '&env=' + encodeURIComponent(env) : '');
    const split = !!(event && (event.metaKey || event.ctrlKey));
    el.call('openAppPage', route, split ? {
        split: true
    } : undefined);
    return true;
}
function $6a9553662762ab47$export$aa55a9065fef0656(el) {
    const from = el || this;
    if (!from) return null;
    if (from.dataSitePreview === true) return from;
    return typeof from.lookup === 'function' ? from.lookup((e)=>e.dataSitePreview === true) : null;
}
function $6a9553662762ab47$export$c12c37ccd32ad712(el) {
    const view = this.call('previewAnswerView', el);
    const frameEl = view && typeof view.lookdown === 'function' ? view.lookdown('SitePreviewInspectFrame') : null;
    return frameEl && frameEl.node || null;
}
async function $6a9553662762ab47$export$58e6d26eb0d45ec7(el, on) {
    const view = this.call('previewAnswerView', el);
    const s = view && view.state;
    if (!view || !s || typeof s.update !== 'function') return false;
    const node = view.call('previewAnswerInspectNode', view);
    if (!on) {
        if (node && s.root && s.root.picking && view.call('previewPickArmedOn', node)) view.call('togglePick', node);
        s.update({
            inspect: false
        });
        return true;
    }
    const site = s.site;
    if (!site || !node) return false;
    s.update({
        inspect: true,
        inspectReady: false,
        inspectError: null
    });
    const token = view.__previewInspectToken = (view.__previewInspectToken || 0) + 1;
    const fail = (code)=>{
        if (view.__previewInspectToken !== token) return false;
        s.update({
            inspectError: code || 'failed'
        });
        return false;
    };
    // The render pipeline is the preview app's: fold its context once.
    const fns = view.context && view.context.functions;
    if (!fns || typeof fns.renderProject !== 'function') {
        const ok = await view.call('ensureAppViewContext', 'preview');
        if (!ok) return fail('fold');
    }
    const read = await view.call('previewSiteRead', {
        owner: site.owner,
        key: site.key,
        env: site.env,
        auth: true
    });
    if (view.__previewInspectToken !== token) return false;
    if (!read || read.error || !read.data) return fail('data');
    let out = null;
    try {
        out = await view.call('renderProject', node, read.data, {
            path: site.path
        });
    } catch (_) {
        out = null;
    }
    if (view.__previewInspectToken !== token) return false;
    if (!out || out.bootError) return fail('boot');
    s.update({
        inspectReady: true
    });
    view.call('previewAnswerPickToggle', view, true);
    return true;
}
function $6a9553662762ab47$export$a20c69aa465bdf26(el, want) {
    const view = this.call('previewAnswerView', el);
    const s = view && view.state;
    const node = view ? view.call('previewAnswerInspectNode', view) : null;
    if (!s || !node || !s.inspectReady) return false;
    const armed = !!(s.root && s.root.picking) && !!view.call('previewPickArmedOn', node);
    if (want === true && armed) return true;
    if (want === false && !armed) return false;
    return !!view.call('togglePick', node);
}
function $6a9553662762ab47$export$14afc9b24b379e18(el) {
    const view = this.call('previewAnswerView', el);
    const s = view && view.state;
    if (!s || typeof s.update !== 'function' || !s.site) return false;
    view.call('previewSiteForget', {
        owner: s.site.owner,
        key: s.site.key
    });
    view.__previewAnswerSig = null;
    s.update({
        reload: (Number(s.reload) || 0) + 1,
        frameReady: null,
        frameSlow: null
    });
    if (s.inspect) view.call('previewAnswerInspect', view, true);
    return true;
}
function $6a9553662762ab47$export$8b01a29af9e8e0f3(req) {
    const r = req && typeof req === 'object' ? req : {};
    const id = String(r.owner || '') + '/' + String(r.key || '').split('.')[0];
    let rootEl = null;
    try {
        rootEl = typeof this.getRoot === 'function' ? this.getRoot() : null;
    } catch (_) {
        rootEl = null;
    }
    const bag = rootEl && rootEl.scope ? rootEl.scope.previewSiteReads : null;
    if (!(bag instanceof Map)) return 0;
    let n = 0;
    for (const k of [
        ...bag.keys()
    ]){
        const rest = k.slice(k.indexOf(':') + 1);
        if (rest === id || rest.startsWith(id + '/')) {
            bag.delete(k);
            n++;
        }
    }
    return n;
}
function $6a9553662762ab47$export$f0d7221afe8b93df(el) {
    const view = el || this;
    const node = view && typeof view.call === 'function' ? view.call('previewAnswerInspectNode', view) : null;
    const root = view && view.state && view.state.root;
    if (node && root && root.picking && view.call('previewPickArmedOn', node)) {
        view.call('togglePick', node);
        return true;
    }
    return false;
}

});

parcelRegister("kxX7m", function(module, exports) {

$parcel$export(module.exports, "previewViewData", () => $ef54bf448611ecc6$export$a7d0781a58412611);
$parcel$export(module.exports, "previewPagesTiles", () => $ef54bf448611ecc6$export$253badbd0274e260);
$parcel$export(module.exports, "previewPagesLoad", () => $ef54bf448611ecc6$export$97d6ee38117257b6);
$parcel$export(module.exports, "previewPagesOpen", () => $ef54bf448611ecc6$export$28532ae079ecb601);
$parcel$export(module.exports, "previewPagesBack", () => $ef54bf448611ecc6$export$85f48d745c9186a0);
$parcel$export(module.exports, "previewPagesLiveNote", () => $ef54bf448611ecc6$export$48d2c11256179ae9);
$parcel$export(module.exports, "previewDsLoad", () => $ef54bf448611ecc6$export$fb0e38eb1ca0ea11);
// A WEBSITE'S PAGES AND DESIGN SYSTEM IN AN AI ANSWER — the `project-pages`
// and `design-system` views (functions/previewAnswer.js previewAiViews;
// components/ProjectPagesView.js, PreviewDesignSystemView.js).
//
//   project-pages   the pages a site's data declares (or its components) as
//                   screenshot tiles — the screenshot CDN's capture of the
//                   environment (`screenshotCdnUrl`, shared functions/
//                   projects.js projectScreenshotUrl's address); a tile swaps
//                   in the LIVE thing: a page is the published page itself, a
//                   component the project's component in the sandboxed
//                   user-code frame (shared embedComponent).
//   design-system   the site's tokens, type and icons: the design-system
//                   showcase over the site's own data in the sandboxed
//                   user-code frame (shared embedDesignSystem — the embed the
//                   preview's own sidebar mounts).
//
// The site and its data are the site-preview view's (previewAnswerResolve,
// previewSiteRead — one read per site and environment for the whole page):
// the published data when the environment is published, else the editor's.
// Nothing here writes project data.
//
// Frank note: el.call serializes each export on its own (FA204) — every export
// is self-contained.
// The data a view shows for a site: the published data, else (a private
// site, an environment not published) the editor's. `{ data, published }` —
// data null when neither answers.
async function $ef54bf448611ecc6$export$a7d0781a58412611(site) {
    const host = this;
    const s = site && typeof site === 'object' ? site : null;
    if (!s) return {
        data: null,
        published: null
    };
    const pub = await host.call('previewSiteRead', {
        owner: s.owner,
        key: s.key,
        env: s.env
    });
    if (pub && pub.data) return {
        data: pub.data,
        published: true
    };
    const auth = await host.call('previewSiteRead', {
        owner: s.owner,
        key: s.key,
        env: s.env,
        auth: true
    });
    return {
        data: auth && auth.data || null,
        published: pub && !pub.error ? pub.published : null
    };
}

async function $ef54bf448611ecc6$export$253badbd0274e260(site, data, show) {
    const s = site && typeof site === 'object' ? site : null;
    if (!s || !data) return [];
    let channels = null;
    try {
        channels = await Promise.resolve((parcelRequire("hmkNw")));
    } catch (_) {
        channels = null;
    }
    const shot = (extra)=>channels && typeof channels.screenshotCdnUrl === 'function' ? channels.screenshotCdnUrl({
            owner: s.owner,
            key: String(s.key).split('.')[0],
            env: s.env,
            width: 480,
            ...extra
        }) : null;
    if (show === 'components') {
        const comps = data.components && typeof data.components === 'object' ? data.components : {};
        return Object.keys(comps).filter((k)=>/^[A-Z][A-Za-z0-9_]*$/.test(k) && comps[k] && typeof comps[k] === 'object').sort((a, b)=>a.localeCompare(b)).map((k)=>({
                key: 'comp-' + k,
                kind: 'component',
                target: k,
                title: k,
                image: shot({
                    componentKey: k
                })
            }));
    }
    return this.call('previewAnswerPages', data).map((p, i)=>({
            key: 'page-' + i,
            kind: 'page',
            target: p,
            title: p,
            image: shot({
                page: p
            })
        }));
}
async function $ef54bf448611ecc6$export$97d6ee38117257b6(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const params = host.scope && host.scope.params || {};
    const show = host.state.show || (params.show === 'components' ? 'components' : 'pages');
    const limit = Math.max(1, Math.min(24, Math.floor(Number(params.limit)) || 12));
    host.call('canvasAnswerNamedMoved', host, params.project);
    const sig = host.call('previewAnswerInputs', host) + '|' + show + '|' + limit;
    if (host.__previewPagesSig === sig) return null;
    host.__previewPagesSig = sig;
    const res = await host.call('previewAnswerResolve', host);
    if (host.__previewPagesSig !== sig) return null;
    const site = res.site;
    if (!site) {
        // The one sentence (previewAnswerEmptyText): a name that is no website
        // says what it is, with its name — never "no match".
        host.state.update({
            site: null,
            tiles: null,
            failed: true,
            none: !params.project && !!res.read && !res.read.failed && !res.sites.length,
            notWebsite: res.notWebsite || null,
            storeApp: res.storeApp || null
        });
        return null;
    }
    host.state.update({
        site: {
            key: site.key,
            name: site.name,
            owner: site.owner,
            env: site.env,
            path: site.path
        },
        tiles: null,
        total: 0,
        show: show,
        failed: false,
        none: false,
        notWebsite: null,
        storeApp: null
    });
    // The tiles come from the data; what a page's ADDRESS serves (a switched-off
    // environment serves nothing) from the project's environments — the site
    // card's own read (previewSiteHosting, memoized for the page).
    const [view, hosting] = await Promise.all([
        host.call('previewViewData', site),
        host.call('previewSiteHosting', {
            owner: site.owner,
            key: site.key,
            id: site.id || null
        })
    ]);
    if (host.__previewPagesSig !== sig) return null;
    const tiles = view.data ? await host.call('previewPagesTiles', site, view.data, show) : [];
    if (host.__previewPagesSig !== sig) return null;
    host.state.update({
        tiles: tiles.slice(0, limit),
        total: tiles.length,
        published: view.published,
        serves: host.call('previewEnvServes', hosting, site.env),
        unread: !view.data
    });
    return tiles;
}
async function $ef54bf448611ecc6$export$28532ae079ecb601(el, row) {
    const view = el && el.dataProjectPages === true ? el : el && typeof el.lookup === 'function' ? el.lookup((e)=>e.dataProjectPages === true) : null;
    const s = view && view.state;
    const t = row && typeof row === 'object' ? row : null;
    if (!s || !t || !s.site || typeof s.update !== 'function') return false;
    if (t.kind === 'page') {
        if (s.serves === 'off') {
            s.update({
                live: {
                    kind: 'page',
                    target: t.target,
                    title: t.title,
                    url: null
                },
                frameReady: null,
                frameSlow: null,
                liveError: 'off'
            });
            return true;
        }
        const url = await view.call('previewAnswerUrl', s.site, t.target, s.site.env);
        if (!url) return false;
        s.update({
            live: {
                kind: 'page',
                target: t.target,
                title: t.title,
                url: url
            },
            frameReady: null,
            frameSlow: null,
            liveError: null
        });
        return true;
    }
    s.update({
        live: {
            kind: 'component',
            target: t.target,
            title: t.title,
            url: null
        },
        liveError: null,
        liveReady: false
    });
    const frameEl = view.lookdown('ProjectPagesComponentFrame');
    const node = frameEl && frameEl.node;
    const data = await view.call('previewViewData', s.site);
    if (!node || !data.data) {
        s.update({
            liveError: 'data'
        });
        return false;
    }
    try {
        const out = await view.call('embedComponent', node, data.data, {
            key: t.target,
            fullsize: true,
            el: view
        });
        if (out && out.bootError) {
            s.update({
                liveError: 'boot'
            });
            return false;
        }
    } catch (_) {
        s.update({
            liveError: 'boot'
        });
        return false;
    }
    if (!s.live || s.live.target !== t.target) return false;
    s.update({
        liveReady: true
    });
    return true;
}
function $ef54bf448611ecc6$export$85f48d745c9186a0(el) {
    const view = el && el.dataProjectPages === true ? el : el && typeof el.lookup === 'function' ? el.lookup((e)=>e.dataProjectPages === true) : null;
    const s = view && view.state;
    if (!s || typeof s.update !== 'function' || !s.live) return false;
    s.update({
        live: null,
        liveReady: false,
        liveError: null,
        frameReady: null,
        frameSlow: null
    });
    return true;
}
function $ef54bf448611ecc6$export$48d2c11256179ae9(s) {
    const st = s && typeof s === 'object' ? s : {};
    const live = st.live;
    if (!live) return '';
    const say = (key)=>String(this.call('polyglot', key)).replace('{name}', ()=>live.title || '');
    if (live.kind === 'page' && st.liveError === 'off') {
        const site = st.site || {};
        return String(this.call('polyglot', 'preview.answer.envOff')).replace('{name}', ()=>site.name || site.key || '').replace('{env}', ()=>String(this.call('polyglot', this.call('previewEnvLabel', site.env))));
    }
    if (live.kind === 'component') {
        if (st.liveError) return say('preview.pagesView.componentFailed');
        return st.liveReady ? '' : say('preview.answer.loadingPart');
    }
    const frameKey = (live.url || '') + '#0';
    if (st.frameReady === frameKey) return '';
    return st.frameSlow === frameKey ? say('preview.answer.slow') : say('preview.answer.loadingPart');
}



async function $ef54bf448611ecc6$export$fb0e38eb1ca0ea11(el) {
    const host = el || this;
    if (!host || !host.state || typeof host.state.update !== 'function') return null;
    const params = host.scope && host.scope.params || {};
    const SECTIONS = [
        'colors',
        'typography',
        'spacing',
        'icons',
        'transitions',
        'layout'
    ];
    const section = SECTIONS.includes(host.state.section) ? host.state.section : SECTIONS.includes(params.section) ? params.section : 'colors';
    host.call('canvasAnswerNamedMoved', host, params.project);
    const sig = host.call('previewAnswerInputs', host) + '|' + section;
    if (host.__previewDsSig === sig) return null;
    host.__previewDsSig = sig;
    const res = await host.call('previewAnswerResolve', host);
    if (host.__previewDsSig !== sig) return null;
    const site = res.site;
    if (!site) {
        // The one sentence (previewAnswerEmptyText), as the pages card's.
        host.state.update({
            site: null,
            failed: true,
            none: !params.project && !!res.read && !res.read.failed && !res.sites.length,
            notWebsite: res.notWebsite || null,
            storeApp: res.storeApp || null
        });
        return null;
    }
    const same = host.state.site && host.state.site.key === site.key && host.state.site.env === site.env;
    host.state.update({
        site: {
            key: site.key,
            name: site.name,
            owner: site.owner,
            env: site.env
        },
        current: section,
        failed: false,
        none: false,
        notWebsite: null,
        storeApp: null,
        ...same ? {} : {
            ready: false
        },
        error: null
    });
    const frameEl = host.lookdown('PreviewDsFrame');
    const node = frameEl && frameEl.node;
    const view = await host.call('previewViewData', site);
    if (host.__previewDsSig !== sig) return null;
    if (!node || !view.data) {
        host.state.update({
            error: 'data'
        });
        return null;
    }
    const ds = view.data.designSystem;
    if (!ds || typeof ds !== 'object' || !Object.keys(ds).length) {
        host.state.update({
            error: 'empty'
        });
        return null;
    }
    let mods = null;
    try {
        mods = await Promise.all([
            (parcelRequire("5Tqi4")),
            (parcelRequire("aVs4r")),
            (parcelRequire("cAheZ"))
        ]);
    } catch (_) {
        mods = null;
    }
    if (host.__previewDsSig !== sig) return null;
    if (!mods) {
        host.state.update({
            error: 'fold'
        });
        return null;
    }
    const [dsComponents, dsPagesMod, kit] = mods;
    try {
        const out = await host.call('embedDesignSystem', node, view.data, {
            dsPage: '/' + section
        }, {
            ...dsComponents
        }, {
            dsPages: dsPagesMod.default || dsPagesMod,
            dsFrameKit: kit.designSystemFrameKit(),
            el: host
        });
        if (out && out.bootError) {
            host.state.update({
                error: 'boot'
            });
            return null;
        }
    } catch (_) {
        host.state.update({
            error: 'boot'
        });
        return null;
    }
    if (host.__previewDsSig !== sig) return null;
    host.state.update({
        ready: true
    });
    return section;
}

});
parcelRegister("5Tqi4", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("kK8bR"))) : import("kK8bR")).then(()=>parcelRequire('ibsaH'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("aVs4r", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("dfnNm"))) : import("dfnNm")).then(()=>parcelRequire('8YiDA'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("cAheZ", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("1EXNb"))) : import("1EXNb")).then(()=>parcelRequire('3r6q5'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});


parcelRegister("eDtcO", function(module, exports) {

$parcel$export(module.exports, "previewBuilderOnScreen", () => $aa7b5cd7e364a495$export$1843652e0e555f86);
$parcel$export(module.exports, "previewSiteInView", () => $aa7b5cd7e364a495$export$fed4f0cca9b08ea5);
$parcel$export(module.exports, "previewSiteFetch", () => $aa7b5cd7e364a495$export$b59baa4e96f88599);
$parcel$export(module.exports, "previewSiteShow", () => $aa7b5cd7e364a495$export$2fe4852561913fa1);
$parcel$export(module.exports, "previewSiteGoTo", () => $aa7b5cd7e364a495$export$62cf9779e554734f);
$parcel$export(module.exports, "previewSiteAdopt", () => $aa7b5cd7e364a495$export$63e1fe047907bb08);
$parcel$export(module.exports, "previewAfterAiWrite", () => $aa7b5cd7e364a495$export$372b36771adff8e);
$parcel$export(module.exports, "previewSiteRelease", () => $aa7b5cd7e364a495$export$350fc88e63973ea7);
$parcel$export(module.exports, "previewSiteError", () => $aa7b5cd7e364a495$export$2e6d9ba32da68cc5);
$parcel$export(module.exports, "previewAiAvailable", () => $aa7b5cd7e364a495$export$fcedc85e3f34dcbe);
// THE SITE BUILDER — the shell's /preview as a builder (Nika 2026-10-28:
// "website preview mode AI is broken. It should work like lovable").
//
// One chat (the shell assistant, docked beside the builder), one frame that
// shows the LATEST SAVED version of the site, and a frame that follows the
// assistant's project writes DURING the turn. Every function here is
// registered on the shell's EAGER registry (functions/eagerSlice.js): the
// shell transport resolves the site on screen per send and hands every tool
// frame to `previewAfterAiWrite`, before any /preview fold.
//
// Root keys (declared + scoped in workspace state-app.js, "Site builder"):
//   _previewSite        the builder's record `{ owner, key, projectId, env, page }`
//   _previewSiteStatus  null | 'setup' | 'updating'
//   _previewSiteStep    the running project write's label, or null
//   _previewSiteDraft   the version on screen is not the published one
//   _aiProjectWrite     the last AI project write `{ projectId, tool, at }`
// The builder on screen: a PageSlot pane showing /preview (primary pane
// first), else the live route when it is /preview. `{ owner, key, env }`
// from that surface's own address, the Studio carrier (`_previewParams`)
// filling a builder that names no site; `{}` for a builder that shows no
// site yet (a new site being set up). null when no builder is on screen —
// a closed pane or another route is never the site on screen, whatever a
// kept-alive builder last recorded.
function $aa7b5cd7e364a495$export$1843652e0e555f86(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : el && el.state && el.state.root || null;
    if (!r) return null;
    const clean = (v)=>typeof v === 'string' && v.trim() ? v.trim() : '';
    const pathOf = (href)=>{
        const path = String(href || '').split('#')[0].split('?')[0];
        let out = null;
        try {
            out = el && typeof el.call === 'function' ? el.call('stripWorkspacePrefix', path) : null;
        } catch (_) {
            out = null;
        }
        return typeof out === 'string' ? out : path.replace(/^\/w\/[^/]+(?=\/|$)/, '');
    };
    const isBuilder = (href)=>{
        const p = pathOf(href);
        return p === '/preview' || p.indexOf('/preview/') === 0;
    };
    const queryOf = (href)=>{
        const raw = String(href || '').split('#')[0];
        const at = raw.indexOf('?');
        return new URLSearchParams(at === -1 ? '' : raw.slice(at + 1));
    };
    let q = null;
    for (const paneKey of [
        '_canvasSlot',
        '_canvasSlotSecond'
    ]){
        const href = r[paneKey];
        if (typeof href === 'string' && href && isBuilder(href)) {
            q = queryOf(href);
            break;
        }
    }
    if (!q) {
        let route = '';
        try {
            route = el && typeof el.call === 'function' ? el.call('readPageRoute') : '';
        } catch (_) {
            route = '';
        }
        if (typeof route !== 'string' || !route) route = r.currentPath || '';
        if (!isBuilder(route)) return null;
        let params = null;
        try {
            params = el.call('readPageParams');
        } catch (_) {
            params = null;
        }
        q = params instanceof URLSearchParams ? params : new URLSearchParams();
    }
    let owner = clean(q.get('owner'));
    let key = clean(q.get('key')).split('.')[0];
    let env = clean(q.get('env'));
    if (!owner || !key) {
        const p = r._previewParams && typeof r._previewParams === 'object' ? r._previewParams : {};
        owner = clean(p.owner);
        key = clean(String(p.key || '')).split('.')[0];
        env = clean(p.env);
    }
    if (!owner || !key) return {};
    return env ? {
        owner: owner,
        key: key,
        env: env
    } : {
        owner: owner,
        key: key
    };
}
function $aa7b5cd7e364a495$export$fed4f0cca9b08ea5(root) {
    const el = this;
    const r = root && typeof root === 'object' ? root : el && el.state && el.state.root || null;
    if (!r || !el || typeof el.call !== 'function') return null;
    const shown = el.call('previewBuilderOnScreen', r);
    if (!shown || !shown.owner || !shown.key) return null;
    const ENVS = [
        'production',
        'staging',
        'development'
    ];
    const site = r._previewSite && typeof r._previewSite === 'object' ? r._previewSite : null;
    const same = !!site && site.owner === shown.owner && site.key === shown.key;
    const out = {
        owner: shown.owner,
        key: shown.key
    };
    if (same && typeof site.projectId === 'string' && site.projectId) out.projectId = site.projectId;
    const env = same ? site.env : shown.env;
    if (ENVS.includes(env)) out.env = env;
    // The page on screen: the builder's own pick (its page picker or its
    // sidebar, `activePage`), else the page it recorded.
    const page = same ? typeof r.activePage === 'string' && r.activePage || site.page : '';
    if (typeof page === 'string' && page.charAt(0) === '/') out.page = page;
    return out;
}

async function $aa7b5cd7e364a495$export$b59baa4e96f88599(target) {
    const el = this;
    const t = target && typeof target === 'object' ? target : {};
    const clean = (v)=>typeof v === 'string' && v.trim() ? v.trim() : '';
    const owner = clean(t.owner);
    const key = clean(String(t.key || '')).split('.')[0];
    const version = clean(t.version);
    if (!owner || !key) throw new Error('Provide both owner and key');
    const fns = el && el.context && el.context.functions || {};
    const read = typeof fns.getProjectData === 'function' ? (opts)=>el.call('getProjectData', opts) : async (opts)=>(await Promise.resolve((parcelRequire("3BQmv")))).getProjectData(opts);
    // `env: ''`, not null: the shared read falls back to the ADDRESS BAR's
    // env for a nullish one, and a /preview address names the env a Fly card
    // opened (always production) — that pinned the published version.
    const data = await read({
        raw: true,
        owner: owner,
        key: key,
        env: '',
        branch: 'main',
        version: version || 'latest'
    });
    let projectId = data && (data._id || data.id) ? String(data._id || data.id) : '';
    let draft = false;
    if (!version) try {
        const sdk = el.sdk || el.call('getSDK');
        if (sdk && typeof sdk.getProjectByKey === 'function') {
            const res = await sdk.getProjectByKey({
                owner: owner,
                key: key
            });
            const p = res && typeof res === 'object' && 'data' in res && res.success ? res.data : res;
            if (p && typeof p === 'object') {
                if (!projectId && (p._id || p.id)) projectId = String(p._id || p.id);
                const pv = p.publishedVersion;
                const pvValue = pv && typeof pv === 'object' ? clean(String(pv.value || '')) : '';
                const v = data && data.version;
                const latest = clean(String((v && typeof v === 'object' ? v.value : v) || ''));
                if (!pv) draft = true;
                else if (pvValue && latest) draft = pvValue !== latest;
            }
        }
    } catch (_) {
        draft = false;
    }
    return {
        data: data,
        projectId: projectId || null,
        draft: draft
    };
}
async function $aa7b5cd7e364a495$export$2fe4852561913fa1(target) {
    const el = this;
    const root = el && el.state && el.state.root;
    const t = target && typeof target === 'object' ? target : {};
    if (!root || typeof root.update !== 'function') return null;
    const got = await el.call('previewSiteFetch', t);
    const data = got && got.data;
    if (!data) return null;
    const prev = root._previewSite && typeof root._previewSite === 'object' ? root._previewSite : null;
    const same = !!prev && prev.owner === t.owner && prev.key === t.key;
    root.update({
        ...el.call('previewPagePatch', data, {
            owner: t.owner,
            key: t.key
        }),
        // A different site opens on its home (a previous site's page would name
        // a page this one does not have).
        ...same ? {} : {
            activePage: '/'
        },
        _previewSite: {
            owner: t.owner,
            key: String(t.key).split('.')[0],
            projectId: got && got.projectId || null,
            env: null,
            page: same && prev.page || '/'
        },
        _previewSiteDraft: !!(got && got.draft),
        _previewSiteStatus: null,
        fetchError: null
    });
    return data;
}
function $aa7b5cd7e364a495$export$62cf9779e554734f(path) {
    const el = this;
    const root = el && el.state && el.state.root;
    const p = typeof path === 'string' && path.charAt(0) === '/' ? path : '';
    if (!root || typeof root.update !== 'function' || !p) return false;
    const site = root._previewSite && typeof root._previewSite === 'object' ? root._previewSite : null;
    root.update({
        activePage: p,
        ...site ? {
            _previewSite: {
                ...site,
                page: p
            }
        } : {}
    });
    const page = typeof el.lookup === 'function' ? el.lookup((e)=>!!(e && e.AppPage && e.PreviewNavbar)) : null;
    const frame = page && typeof page.lookdown === 'function' ? page.lookdown('AppIframe') : null;
    const handle = frame && frame.node ? el.call('getUserCodeHandle', frame.node) : null;
    if (handle && typeof handle.post === 'function') handle.post('navigate', {
        path: p
    });
    return true;
}
async function $aa7b5cd7e364a495$export$63e1fe047907bb08(projectId) {
    const el = this;
    const root = el && el.state && el.state.root;
    const id = typeof projectId === 'string' ? projectId.trim() : '';
    if (!root || typeof root.update !== 'function' || !id) return false;
    const sdk = el.sdk || el.call('getSDK');
    if (!sdk || typeof sdk.getProject !== 'function') return false;
    let p = null;
    try {
        const res = await sdk.getProject(id);
        p = res && typeof res === 'object' && 'data' in res && res.success ? res.data : res;
    } catch (_) {
        p = null;
    }
    // The owner's SLUG — an org-owned project names `{ slug }`, a user-owned
    // one `{ username }`; a bare id is no slug (the canvas site cards read the
    // same way, canvas functions/canvasAnswer.js canvasAnswerCards).
    const slugOf = (v)=>{
        if (!v) return '';
        if (typeof v === 'string') return /^[a-f0-9]{24}$/i.test(v) ? '' : v;
        return v.slug || v.username || '';
    };
    const claims = root.jwtClaims || {};
    const orgs = Array.isArray(claims.orgs) ? claims.orgs : [];
    const org = orgs.find((x)=>x && x.id === claims.workspace_org_id);
    const owner = slugOf(p && p.owner) || slugOf(p && p.workspace && p.workspace.organization) || (p && typeof p.ownerUsername === 'string' ? p.ownerUsername : '') || org && org.slug || '';
    const key = p && typeof p.key === 'string' ? p.key.split('.')[0] : '';
    if (!owner || !key) return false;
    root.update({
        _previewParams: {
            owner: owner,
            key: key
        }
    });
    await el.call('previewSiteShow', {
        owner: owner,
        key: key
    });
    return true;
}
function $aa7b5cd7e364a495$export$372b36771adff8e(evt, root) {
    const el = this;
    const e = evt && typeof evt === 'object' ? evt : null;
    const r = root && typeof root.update === 'function' ? root : el && el.state && el.state.root || null;
    if (!e || !r || !e.tool || !el || typeof el.call !== 'function') return false;
    const tool = String(e.tool);
    if (/^(get|list|read|search|find|fetch|describe|count)_/.test(tool)) return false;
    // The started frame carries the call's arguments, the completed one only
    // its id: remember them per call, beside the shell's other per-root memos.
    let rootEl = null;
    try {
        rootEl = typeof el.getRoot === 'function' ? el.getRoot() : el;
    } catch (_) {
        rootEl = el;
    }
    const memo = rootEl && rootEl.scope && typeof rootEl.scope === 'object' ? rootEl.scope : null;
    if (memo && !(memo.previewSiteCalls instanceof Map)) memo.previewSiteCalls = new Map();
    const calls = memo ? memo.previewSiteCalls : new Map();
    const callId = e.callId ? String(e.callId) : '';
    if (e.phase === 'started' && callId) {
        calls.set(callId, {
            args: e.args && typeof e.args === 'object' ? e.args : {}
        });
        while(calls.size > 40)calls.delete(calls.keys().next().value);
    }
    const known = callId ? calls.get(callId) : null;
    const args = known && known.args || (e.args && typeof e.args === 'object' ? e.args : {});
    const named = typeof args.projectId === 'string' ? args.projectId.trim() : '';
    const builder = el.call('previewBuilderOnScreen', r);
    const site = el.call('previewSiteInView', r);
    const setup = !!builder && !site && r._previewSiteStatus === 'setup';
    const projectWrite = tool === 'commit_project_changes' || tool === 'create_project' || tool === 'update_project';
    if (!projectWrite && !named) return false;
    // Does this write change the site on screen?
    let forSite = false;
    if (tool === 'create_project') forSite = setup;
    else if (site) forSite = named ? !site.projectId || named === site.projectId : projectWrite;
    else forSite = setup && !!named;
    const done = e.phase === 'completed';
    if (done && callId) calls.delete(callId);
    if (done && e.ok !== false && named) r.update({
        _aiProjectWrite: {
            projectId: named,
            tool: tool,
            at: Date.now()
        }
    });
    if (!forSite) return false;
    if (e.phase === 'started') {
        const label = typeof e.label === 'string' && e.label.trim() ? e.label.trim() : null;
        r.update({
            _previewSiteStep: label || el.call('polyglot', 'preview.builder.working')
        });
        return true;
    }
    if (!done) return false;
    // A failed write changed nothing; a new site's create_project names no
    // project yet (the server's frame carries only a summary) — the builder
    // keeps waiting, quietly, for the first write that names it.
    if (e.ok === false || setup && !named) {
        r.update({
            _previewSiteStep: null
        });
        return true;
    }
    r.update({
        _previewSiteStep: null,
        _previewSiteStatus: 'updating'
    });
    const settle = ()=>{
        if (r._previewSiteStatus === 'updating') r.update({
            _previewSiteStatus: null
        });
    };
    // A new site: the first write that names its project points the builder
    // at it (create_project's own frame names no id — the commit after it does).
    const run = setup && named ? el.call('previewSiteAdopt', named) : el.call('reloadPreviewProject', {
        latest: true
    });
    Promise.resolve(run).catch((err)=>console.warn('[preview] reload after an AI write:', err?.message || err)).then(settle);
    return true;
}
function $aa7b5cd7e364a495$export$350fc88e63973ea7(target) {
    const el = this;
    const root = el && el.state && el.state.root;
    if (!root || typeof root.update !== 'function') return;
    const t = target && typeof target === 'object' ? target : null;
    const site = root._previewSite;
    const mine = !t || !site || site.owner === t.owner && site.key === t.key;
    if (!mine) return;
    root.update({
        _previewSite: null,
        _previewSiteStatus: null,
        _previewSiteStep: null,
        _previewSiteDraft: false
    });
}
function $aa7b5cd7e364a495$export$2e6d9ba32da68cc5(err) {
    const e = err || {};
    return {
        code: e.code || 'unknown',
        message: e.message || 'Unknown error',
        visibility: e.visibility || null,
        triedEnvs: Array.isArray(e.triedEnvs) ? e.triedEnvs : [],
        owner: e.owner || null,
        key: e.key || null,
        passwordEnv: e.passwordEnv || null,
        signedIn: !!e.signedIn,
        status: typeof e.status === 'number' ? e.status : null
    };
}
function $aa7b5cd7e364a495$export$fcedc85e3f34dcbe() {
    const fns = this && this.context && this.context.functions || {};
    return typeof fns.shellSendPrompt === 'function';
}

});


parcelRegister("gA6L3", function(module, exports) {
// Eager slim slice of the preview component barrel (#16 preview half).
//
// The full `./index.js` barrel `export *`s the entire preview UI tree — Scene,
// SceneTemplate, SceneNavbar, PreviewNavbar, PreviewSidebar, PreviewAssistant,
// PreviewErrorBoundary (~121KB with the page module) — that the unified shell
// dragged into its EAGER chunk via
// `import * from '../preview/components/index.js'` in workspace/context.js.
//
// Preview is now a lazy sub-app: the `/preview` ROUTE (workspace/pages/index.js
// → lazySharedLib) and the `/preview` PageSlot (workspace/pages/main.js
// _previewPage → lazySharedLibPage) both FOLD the full preview context
// (components + functions) into the live shell context on first mount, THEN
// el.set the preview page — so every one of the components above, bare-keyed
// ONLY from inside that page tree, resolves against the now-populated registry.
// None of it is reached before the fold.
//
// This slice is intentionally EMPTY: an exhaustive grep of the whole eager
// surface (workspace app.js/state/pages/components/functions + shared/** +
// the canvas/marketplace eager slices) found NO non-preview eager surface that
// bare-keys or `extends` any preview component before a /preview fold —
//   • app.js has ZERO preview references (unlike marketplace, whose shell-root
//     install-modal watcher forced MarketplaceInstallModal to stay eager);
//   • the only `Scene` / `SceneNavbar` hits outside preview are CANVAS's own
//     components, which export a DIFFERENTLY-KEYED `CanvasScene` (+ a canvas
//     `SceneNavbar` child) — no key collision with preview's `Scene`;
//   • every other hit (PreviewNavbar, PreviewSidebar, …) is a code comment or a
//     local variable, never a component bare-key/extend.
//
// So preview contributes NOTHING to the shell's eager component chunk. This file
// exists as the documented seam (imported by workspace/context.js in place of the
// full barrel) — if a future eager surface ever references a preview component,
// add its `export * from './<Component>.js'` here (source file, not the barrel:
// preview has no `sideEffects: false`, so a barrel re-export would evaluate the
// whole UI tree and defeat the carve).
//
// The AI-answer views (functions/previewAnswer.js) are such keys: the
// assistant's thread and a Fly page mount them on ANY route, never folding the
// preview app — the site live (`site-preview`), its pages as tiles
// (`project-pages`), its design system (`design-system`). Zero imports; the
// one step that needs the preview app (inspect) folds it on demand.

var $23pqP = parcelRequire("23pqP");

var $awAPF = parcelRequire("awAPF");

var $ajsgS = parcelRequire("ajsgS");
$parcel$exportWildcard(module.exports, $23pqP);
$parcel$exportWildcard(module.exports, $awAPF);
$parcel$exportWildcard(module.exports, $ajsgS);

});
parcelRegister("23pqP", function(module, exports) {

$parcel$export(module.exports, "SitePreviewView", () => $17ef96c63eb373d5$export$9dcf9c39ac3f5bcc);
// A WEBSITE IN AN AI ANSWER — the `site-preview` view (functions/
// previewAnswer.js previewAiViews; the shell mounts it in the assistant's
// thread and on a Fly page with scope { params, embedded }). Read-only:
//
//   head    the site and its page; Inspect, Pick (in inspect), Reload, Open in
//           the preview app (the sheet; ⌘ / Ctrl: a split), the site in a new
//           tab
//   bar     the environments the project has on (env pills — each its own
//           address), the page switcher (the pages the site's data declares),
//           the device (the preview's own device widths)
//   frame   the published site in a sandboxed frame at the device's width,
//           scaled down to the card — or, in INSPECT, the project in the
//           preview's sandboxed user-code frame with element picking (a pick
//           lands in the composer). Until the frame loads: a cover; an
//           environment that is switched off (its address serves nothing) or a
//           site with no pages: that sentence in place of the frame (QA
//           2026-10-18). Never the project's visibility: a private project
//           still serves its site to every visitor.
//
// A published frame is made ONCE per address — its `src` is a plain value of
// a keyed child, so an update never reloads it; a new address (environment,
// page, Reload) is a new child. While reading: one frame-sized stand-in; no
// such site, or a failed read: one sentence (previewAnswerEmptyText) — for a
// name that is a project of the workspace but not a website, or an App Store
// app that is no project here, the sentence says so with its name.
const $17ef96c63eb373d5$export$9dcf9c39ac3f5bcc = {
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    // In a box of fixed height (a Fly page's card) the view fills it and the
    // frame takes the room left under the head and the bar — measured on dev: a
    // 1562×976 frame clipped to a ~115 px strip. In a box of auto height (the
    // assistant's thread) these resolve to nothing and the frame keeps 16:10.
    height: '100%',
    minHeight: '0',
    dataSitePreview: true,
    state: {
        site: null,
        failed: false,
        none: false,
        // The asked name when it is no website (functions/previewAnswer.js
        // previewAnswerResolve): a project of this workspace that is not a
        // website (an app, a module, a library), or an App Store app that is no
        // project here.
        notWebsite: null,
        storeApp: null,
        env: null,
        page: null,
        device: null,
        inspect: false,
        inspectReady: false,
        inspectError: null,
        reload: 0,
        frameReady: null,
        frameSlow: null,
        boxW: 0,
        boxH: 0
    },
    // EMPTY (the views contract, workspace functions/assistantAppViews.js): no
    // such site (or no website at all) — the one sentence is all the view
    // shows, and a Fly page gives its card one row. false with a site (its
    // head, controls and frame — or the sentence that stands in for the frame
    // beside the environments that do serve it); null while reading.
    empty: (el, s)=>s.site ? false : s.failed ? true : null,
    // RESOLVED PARAMS (the views contract): the site, environment and page the
    // card SHOWS — a Fly page's next ask carries them, so a follow-up stays on
    // this site when the model named none. null while reading.
    resolvedParams: (el, s)=>s.site ? {
            project: s.site.key,
            env: s.site.env,
            ...s.site.path && s.site.path !== '/' ? {
                path: s.site.path
            } : {}
        } : null,
    onRender: (el)=>el.call('previewAnswerLoad', el),
    // The installed apps decide which projects are websites (a module is not),
    // the project list and the project on screen can land after the view: the
    // read runs again when they change — its own signature keeps it to once per
    // inputs. The card's own choices (env, page) re-run it the same way. The
    // App Store list can land after the view too: when it (or the project list)
    // changes what the asked name means, the read runs again
    // (canvasAnswerNamedMoved).
    subscribeTo: [
        'workspaceApps',
        '_projectsForActiveOrg',
        '_previewParams',
        '_wsAppsCatalog'
    ],
    onUpdate: (el)=>el.call('previewAnswerLoad', el),
    // A picker armed on this card's inspect frame stops with the card.
    onBeforeRemove: (el)=>el.call('previewAnswerRemoved', el),
    Skeleton: {
        width: '100%',
        aspectRatio: '16 / 10',
        round: 'radiusControl',
        ariaBusy: 'true',
        hide: (el, s)=>!!s.site || !!s.failed
    },
    SitePreviewNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!s.failed,
        text: (el, s)=>{
            s.root.lang;
            return el.call('previewAnswerEmptyText', s);
        }
    },
    SitePreviewHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>!s.site,
        SitePreviewName: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'Z',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                const site = s.site;
                if (!site) return '';
                return site.path && site.path !== '/' ? site.name + " \xb7 " + site.path : site.name;
            }
        },
        SitePreviewTools: {
            flow: 'x',
            align: 'center',
            gap: 'X',
            flexShrink: '0',
            childExtends: 'CompactIconButton',
            SitePreviewInspect: {
                icon: 'inspect',
                ariaPressed: (el, s)=>s.inspect ? 'true' : 'false',
                ariaLabel: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.inspect');
                },
                title: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.inspect');
                },
                isOn: (el, s)=>!!s.inspect,
                '.isOn': {
                    background: 'selected',
                    color: 'title'
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    el.call('previewAnswerInspect', el, !s.inspect);
                }
            },
            SitePreviewPick: {
                icon: 'cursor',
                hide: (el, s)=>!s.inspect || !s.inspectReady,
                ariaPressed: (el, s)=>s.root.picking && el.call('previewPickArmedOn', el.call('previewAnswerInspectNode', el)) ? 'true' : 'false',
                ariaLabel: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.pick');
                },
                title: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.pick');
                },
                isOn: (el, s)=>!!s.root.picking && el.call('previewPickArmedOn', el.call('previewAnswerInspectNode', el)),
                '.isOn': {
                    background: 'selected',
                    color: 'title'
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('previewAnswerPickToggle', el);
                }
            },
            SitePreviewReload: {
                icon: 'reload',
                ariaLabel: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.reload');
                },
                title: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.reload');
                },
                onClick: (e, el)=>{
                    e.stopPropagation();
                    el.call('previewAnswerReload', el);
                }
            },
            SitePreviewOpenApp: {
                icon: 'fullscreen',
                ariaLabel: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.openInPreview');
                },
                title: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.openInPreview');
                },
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    const site = s.site;
                    if (!site) return;
                    el.call('previewAnswerOpenSite', {
                        owner: site.owner,
                        key: site.key,
                        env: site.env
                    }, e);
                }
            },
            // The published site itself, in a new tab — a real link (the browser
            // keeps a click on a `_blank` link; QA 2026-10-18: the old text link
            // was missed).
            SitePreviewOpenTab: {
                extends: [
                    'CompactIconButton',
                    'Link'
                ],
                icon: 'arrowUpRight',
                href: (el, s)=>s.site ? s.site.url : null,
                target: '_blank',
                rel: 'noopener noreferrer',
                ariaLabel: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.open');
                },
                title: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', 'preview.answer.open');
                },
                onClick: (e)=>e.stopPropagation()
            }
        }
    },
    SitePreviewBar: {
        flow: 'x',
        align: 'center',
        gap: 'Z',
        flexWrap: 'wrap',
        minWidth: '0',
        hide: (el, s)=>!s.site,
        // The environments the project has on — each its own address. The
        // pressed one is the environment the frame shows.
        AppSegmented: {
            compact: true,
            ariaLabel: (el, s)=>{
                s.root.lang;
                return el.call('polyglot', 'preview.answer.envs');
            },
            hide: (el, s)=>!s.site || !Array.isArray(s.site.envs) || s.site.envs.length < 2,
            children: (el, s)=>(s.site && Array.isArray(s.site.envs) ? s.site.envs : []).map((k)=>({
                        key: 'opt-' + k,
                        optionValue: k,
                        optionLabel: el.call('previewEnvLabel', k)
                    })),
            childProps: {
                isActive: (el, s)=>!!s.site && s.site.env === el.optionValue,
                ariaPressed: (el, s)=>!!s.site && s.site.env === el.optionValue ? 'true' : 'false',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    if (!s.site || s.site.env === el.optionValue) return;
                    s.update({
                        env: el.optionValue
                    });
                }
            }
        },
        // The pages the site's data declares (and the page on screen).
        InlineSelect_page: {
            hide: (el, s)=>!s.site || !Array.isArray(s.site.pages) || s.site.pages.length < 2,
            ariaLabel: (el, s)=>{
                s.root.lang;
                return el.call('polyglot', 'preview.answer.page');
            },
            value: (el, s)=>s.site ? s.site.path : '/',
            onClick: (e)=>e.stopPropagation(),
            onChange: (ev, el, s)=>{
                const next = ev.target.value;
                if (!s.site || !next || next === s.site.path) return;
                s.update({
                    page: next
                });
            },
            childProps: {
                tag: 'option',
                selected: (el, s)=>s.site && el.value === s.site.path ? true : null
            },
            children: (el, s)=>{
                const site = s.site;
                const pages = site && Array.isArray(site.pages) ? site.pages.slice() : [];
                if (site && site.path && !pages.includes(site.path)) pages.unshift(site.path);
                return pages.map((p, i)=>({
                        key: 'page-' + i,
                        value: p,
                        text: p
                    }));
            }
        },
        // The device: the site's media queries see its width.
        InlineSelect_device: {
            ariaLabel: (el, s)=>{
                s.root.lang;
                return el.call('polyglot', 'preview.answer.deviceLabel');
            },
            value: (el, s)=>el.call('previewAnswerDevice', s),
            onClick: (e)=>e.stopPropagation(),
            onChange: (ev, el, s)=>{
                const next = ev.target.value;
                if (next) s.update({
                    device: next
                });
            },
            childProps: {
                tag: 'option',
                text: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', el.labelKey);
                },
                selected: (el, s)=>el.value === el.call('previewAnswerDevice', s) ? true : null
            },
            children: ()=>[
                    {
                        key: 'device-desktop',
                        value: 'desktop',
                        labelKey: 'preview.answer.device.desktop'
                    },
                    {
                        key: 'device-tablet',
                        value: 'tablet',
                        labelKey: 'preview.answer.device.tablet'
                    },
                    {
                        key: 'device-mobile',
                        value: 'mobile',
                        labelKey: 'preview.answer.device.mobile'
                    }
                ]
        }
    },
    // The frame's box: 16:10 of the width, shrinking to the room a fixed-height
    // card leaves (never growing past 16:10). Its size, read on mount and on a
    // resize, scales the device viewport into it.
    SitePreviewFrameBox: {
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        aspectRatio: '16 / 10',
        flex: '0 1 auto',
        minHeight: '0',
        round: 'radiusControl',
        background: 'overlay',
        hide: (el, s)=>!s.site,
        onRender: (el)=>el.call('previewAnswerMeasure', el),
        // The box shows once the site is known: its first real size is then.
        stateDeps: [
            (el, s)=>!!s.site
        ],
        onStateUpdate: (el)=>el.call('previewAnswerMeasure', el),
        onWindowResize: (e, el)=>el.call('previewAnswerMeasure', el),
        SitePreviewFrame: {
            position: 'absolute',
            inset: '0',
            hide: (el, s)=>!s.site || !!s.inspect || s.site.serves === 'off',
            children: (el, s)=>{
                const site = s.site;
                if (!site || !site.url || site.serves === 'off') return [];
                // The child's key IS its address (and the Reload count): the same
                // address keeps its frame.
                const frameKey = site.url + '#' + (Number(s.reload) || 0);
                const id = Array.from(frameKey).reduce((h, c)=>h * 31 + c.charCodeAt(0) >>> 0, 7).toString(36);
                const label = String(el.call('polyglot', 'preview.answer.frameTitle'));
                return [
                    {
                        extends: 'Iframe',
                        key: 'site-' + id,
                        frameKey: frameKey,
                        src: site.url,
                        title: label.replace('{name}', ()=>site.name),
                        sandbox: 'allow-scripts allow-same-origin allow-forms allow-popups',
                        referrerpolicy: 'no-referrer',
                        loading: 'lazy',
                        display: 'block',
                        position: 'absolute',
                        top: '0',
                        transformOrigin: '0 0',
                        border: 'none',
                        style: (el, s)=>el.call('previewAnswerFrameStyle', s),
                        onLoad: (e, el)=>el.call('previewAnswerFrameLoaded', el),
                        onRender: (el)=>el.call('previewAnswerFrameTimer', el),
                        onBeforeRemove: (el)=>clearTimeout(el.__previewSlowTimer)
                    }
                ];
            }
        },
        // INSPECT: the preview's sandboxed user-code frame — the project boots in
        // it on demand (functions/previewAnswer.js previewAnswerInspect).
        SitePreviewInspectFrame: {
            tag: 'iframe',
            position: 'absolute',
            top: '0',
            transformOrigin: '0 0',
            border: 'none',
            display: 'block',
            background: 'white',
            '@dark': {
                background: 'black'
            },
            hide: (el, s)=>!s.inspect,
            title: (el, s)=>{
                s.root.lang;
                return String(el.call('polyglot', 'preview.answer.inspectFrameTitle')).replace('{name}', ()=>s.site ? s.site.name : '');
            },
            sandbox: (el)=>el.call('userCodeSandbox'),
            style: (el, s)=>el.call('previewAnswerFrameStyle', s)
        },
        // A sentence IN PLACE of the frame (loading, an environment switched off,
        // no pages, the inspect steps) — the frame's live region.
        SitePreviewCover: {
            position: 'absolute',
            inset: '0',
            flow: 'y',
            align: 'center center',
            padding: 'A',
            background: 'overlay',
            hide: (el, s)=>!el.call('previewAnswerNote', s).cover,
            SitePreviewCoverText: {
                tag: 'p',
                role: 'status',
                margin: '0',
                maxWidth: 'G',
                fontSize: 'Z',
                color: 'caption',
                textAlign: 'center',
                text: (el, s)=>{
                    s.root.lang;
                    s.root.picking;
                    const note = el.call('previewAnswerNote', s);
                    return note.cover ? note.text : '';
                }
            }
        },
        // One quiet line over the frame's foot (a slow site, the picker's hint).
        SitePreviewHint: {
            tag: 'p',
            role: 'status',
            position: 'absolute',
            left: 'Z',
            right: 'Z',
            bottom: 'Z',
            margin: '0',
            padding: 'Y Z',
            round: 'radiusControl',
            theme: 'dialog',
            fontSize: 'Z',
            textAlign: 'center',
            pointerEvents: 'none',
            hide: (el, s)=>{
                const note = el.call('previewAnswerNote', s);
                return note.cover || !note.text;
            },
            text: (el, s)=>{
                s.root.lang;
                s.root.picking;
                const note = el.call('previewAnswerNote', s);
                return note.cover ? '' : note.text;
            }
        }
    }
};

});

parcelRegister("awAPF", function(module, exports) {

$parcel$export(module.exports, "ProjectPagesView", () => $7a9976ad05d71c8f$export$62df06885997ce42);
$parcel$export(module.exports, "ProjectPagesTile", () => $7a9976ad05d71c8f$export$c3d1e7aa13ebae6);
// A WEBSITE'S PAGES IN AN AI ANSWER — the `project-pages` view (functions/
// previewAnswer.js previewAiViews, functions/previewPagesAnswer.js; the shell
// mounts it in the assistant's thread and on a Fly page with scope
// { params, embedded }). Read-only: the site's pages — or its components — as
// screenshot tiles (Pages · Components switch the set); a tile swaps in the
// live thing (the published page, or the component in the sandboxed
// user-code frame) with a way back. While reading: tile stand-ins; no such
// site, or no website at all: one sentence (previewAnswerEmptyText) — a name
// that is no website says what it is, with its name.
const $7a9976ad05d71c8f$export$62df06885997ce42 = {
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    height: '100%',
    minHeight: '0',
    dataProjectPages: true,
    state: {
        site: null,
        failed: false,
        none: false,
        // The asked name when it is no website (functions/previewAnswer.js
        // previewAnswerResolve): a project of this workspace, or an App Store app.
        notWebsite: null,
        storeApp: null,
        show: null,
        tiles: null,
        total: 0,
        published: null,
        serves: null,
        unread: false,
        live: null,
        liveReady: false,
        liveError: null,
        frameReady: null,
        frameSlow: null,
        boxW: 0,
        boxH: 0
    },
    // EMPTY (the views contract, workspace functions/assistantAppViews.js): no
    // such site, or no website at all — the one sentence is all the view shows.
    // A site with no pages keeps its head (the Pages · Components switch).
    empty: (el, s)=>s.failed ? true : s.site ? false : null,
    // RESOLVED PARAMS (the views contract): the site and environment the card
    // SHOWS — a follow-up stays on this site. null while reading.
    resolvedParams: (el, s)=>s.site ? {
            project: s.site.key,
            env: s.site.env
        } : null,
    onRender: (el)=>el.call('previewPagesLoad', el),
    // The site card's own inputs (SitePreviewView): the App Store list too —
    // a late list can change what the asked name means (canvasAnswerNamedMoved).
    subscribeTo: [
        'workspaceApps',
        '_projectsForActiveOrg',
        '_previewParams',
        '_wsAppsCatalog'
    ],
    onUpdate: (el)=>el.call('previewPagesLoad', el),
    ProjectPagesSkeleton: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-E2)), 1fr))',
        gap: 'Z',
        ariaBusy: 'true',
        hide: (el, s)=>Array.isArray(s.tiles) || !!s.failed,
        Skeleton_1: {
            aspectRatio: '16 / 10',
            round: 'radiusControl'
        },
        Skeleton_2: {
            aspectRatio: '16 / 10',
            round: 'radiusControl'
        },
        Skeleton_3: {
            aspectRatio: '16 / 10',
            round: 'radiusControl'
        }
    },
    ProjectPagesNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!s.failed && !(Array.isArray(s.tiles) && !s.tiles.length),
        text: (el, s)=>{
            s.root.lang;
            if (s.failed) return el.call('previewAnswerEmptyText', s);
            const key = s.unread ? 'preview.pagesView.unread' : s.show === 'components' ? 'preview.pagesView.noComponents' : 'preview.pagesView.noPages';
            return String(el.call('polyglot', key)).replace('{name}', ()=>s.site ? s.site.name : '');
        }
    },
    ProjectPagesHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>!s.site,
        ProjectPagesName: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'Z',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                s.root.lang;
                const site = s.site;
                if (!site) return '';
                const env = String(el.call('polyglot', el.call('previewEnvLabel', site.env)));
                return s.live ? site.name + " \xb7 " + s.live.title : site.name + " \xb7 " + env;
            }
        },
        // Pages · Components — the set the tiles show.
        AppSegmented: {
            compact: true,
            hide: (el, s)=>!!s.live,
            ariaLabel: (el, s)=>{
                s.root.lang;
                return el.call('polyglot', 'preview.pagesView.show');
            },
            children: ()=>[
                    {
                        key: 'opt-pages',
                        optionValue: 'pages',
                        optionLabel: 'preview.sidebar.category.pages'
                    },
                    {
                        key: 'opt-components',
                        optionValue: 'components',
                        optionLabel: 'preview.sidebar.category.components'
                    }
                ],
            childProps: {
                isActive: (el, s)=>(s.show || 'pages') === el.optionValue,
                ariaPressed: (el, s)=>(s.show || 'pages') === el.optionValue ? 'true' : 'false',
                onClick: (e, el, s)=>{
                    e.stopPropagation();
                    if ((s.show || 'pages') === el.optionValue) return;
                    s.update({
                        show: el.optionValue
                    });
                }
            }
        },
        CompactIconButton: {
            icon: 'arrowLeft',
            hide: (el, s)=>!s.live,
            ariaLabel: (el, s)=>{
                s.root.lang;
                return el.call('polyglot', 'preview.pagesView.back');
            },
            title: (el, s)=>{
                s.root.lang;
                return el.call('polyglot', 'preview.pagesView.back');
            },
            onClick: (e, el)=>{
                e.stopPropagation();
                el.call('previewPagesBack', el);
            }
        }
    },
    ProjectPagesGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-E2)), 1fr))',
        gap: 'Z',
        minWidth: '0',
        minHeight: '0',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
        hide: (el, s)=>!!s.live || !Array.isArray(s.tiles) || !s.tiles.length,
        childExtends: 'ProjectPagesTile',
        childrenAs: 'state',
        children: (el, s)=>Array.isArray(s.tiles) ? s.tiles : []
    },
    // The first N of more: says so, never a silent cut.
    ProjectPagesMore: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!!s.live || !Array.isArray(s.tiles) || !(s.total > s.tiles.length),
        text: (el, s)=>{
            s.root.lang;
            return String(el.call('polyglot', 'preview.pagesView.more')).replace('{n}', String(Array.isArray(s.tiles) ? s.tiles.length : 0)).replace('{total}', String(s.total || 0));
        }
    },
    // The live thing: the published page (its address, at a desktop's width,
    // scaled to the card) or the component in the user-code frame.
    ProjectPagesLive: {
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        aspectRatio: '16 / 10',
        flex: '0 1 auto',
        minHeight: '0',
        round: 'radiusControl',
        background: 'overlay',
        hide: (el, s)=>!s.live,
        stateDeps: [
            (el, s)=>!!s.live
        ],
        onStateUpdate: (el)=>el.call('previewAnswerMeasure', el),
        onWindowResize: (e, el)=>el.call('previewAnswerMeasure', el),
        ProjectPagesPageFrame: {
            position: 'absolute',
            inset: '0',
            hide: (el, s)=>!s.live || s.live.kind !== 'page',
            children: (el, s)=>{
                const live = s.live;
                if (!live || live.kind !== 'page' || !live.url) return [];
                const frameKey = live.url + '#0';
                const id = Array.from(frameKey).reduce((h, c)=>h * 31 + c.charCodeAt(0) >>> 0, 7).toString(36);
                return [
                    {
                        extends: 'Iframe',
                        key: 'page-' + id,
                        frameKey: frameKey,
                        src: live.url,
                        title: String(el.call('polyglot', 'preview.answer.frameTitle')).replace('{name}', ()=>s.site ? s.site.name + " \xb7 " + live.title : live.title),
                        sandbox: 'allow-scripts allow-same-origin allow-forms allow-popups',
                        referrerpolicy: 'no-referrer',
                        display: 'block',
                        position: 'absolute',
                        top: '0',
                        transformOrigin: '0 0',
                        border: 'none',
                        style: (el, s)=>el.call('previewAnswerFrameStyle', s),
                        onLoad: (e, el)=>el.call('previewAnswerFrameLoaded', el),
                        onRender: (el)=>el.call('previewAnswerFrameTimer', el),
                        onBeforeRemove: (el)=>clearTimeout(el.__previewSlowTimer)
                    }
                ];
            }
        },
        ProjectPagesComponentFrame: {
            tag: 'iframe',
            position: 'absolute',
            inset: '0',
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block',
            background: 'white',
            '@dark': {
                background: 'black'
            },
            hide: (el, s)=>!s.live || s.live.kind !== 'component',
            title: (el, s)=>s.live ? s.live.title : '',
            sandbox: (el)=>el.call('userCodeSandbox')
        },
        ProjectPagesLiveNote: {
            tag: 'p',
            role: 'status',
            position: 'absolute',
            left: 'Z',
            right: 'Z',
            bottom: 'Z',
            margin: '0',
            padding: 'Y Z',
            round: 'radiusControl',
            theme: 'dialog',
            fontSize: 'Z',
            textAlign: 'center',
            pointerEvents: 'none',
            hide: (el, s)=>!s.live || !el.call('previewPagesLiveNote', s),
            text: (el, s)=>{
                s.root.lang;
                return el.call('previewPagesLiveNote', s);
            }
        }
    }
};
const $7a9976ad05d71c8f$export$c3d1e7aa13ebae6 = {
    tag: 'button',
    type: 'button',
    flow: 'y',
    gap: 'X',
    minWidth: '0',
    padding: 'X',
    border: 'none',
    background: 'transparent',
    color: 'title',
    textAlign: 'left',
    cursor: 'pointer',
    round: 'radiusControl',
    transition: 'background-color A defaultBezier',
    ':hover': {
        background: 'hover'
    },
    ':active': {
        background: 'selected'
    },
    ariaLabel: (el, s)=>{
        s.root.lang;
        return String(el.call('polyglot', 'preview.pagesView.openTile')).replace('{name}', ()=>s.title || '');
    },
    onClick: (e, el, s)=>{
        e.stopPropagation();
        el.call('previewPagesOpen', el, s.parse ? s.parse() : s);
    },
    ProjectPagesTileShot: {
        width: '100%',
        aspectRatio: '16 / 10',
        round: 'radiusControl',
        overflow: 'hidden',
        background: 'overlay',
        Img: {
            src: (el, s)=>s.image || null,
            alt: (el, s)=>s.title || '',
            loading: 'lazy',
            boxSize: '100%',
            objectFit: 'cover',
            display: 'block',
            hide: (el, s)=>!s.image,
            // No capture on the CDN for this page: the plate, never a broken image.
            onError: (e, el, s)=>s.update({
                    image: null
                })
        }
    },
    ProjectPagesTileTitle: {
        tag: 'span',
        minWidth: '0',
        fontSize: 'Z',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        text: (el, s)=>s.title || ''
    }
};

});

parcelRegister("ajsgS", function(module, exports) {

$parcel$export(module.exports, "PreviewDesignSystemView", () => $78219bc825c01946$export$a5dc464f46a846b2);
// A WEBSITE'S DESIGN SYSTEM IN AN AI ANSWER — the `design-system` view
// (functions/previewAnswer.js previewAiViews, functions/previewPagesAnswer.js
// previewDsLoad; the shell mounts it in the assistant's thread and on a Fly
// page with scope { params, embedded }). Read-only: the design-system
// showcase the preview's own sidebar embeds — colors, typography, spacing,
// icons, transitions, layout — over the site's own data, in the sandboxed
// user-code frame; a section switch remounts it over the frame's port. While
// reading: one frame-sized stand-in; no such site, no website at all, or a
// site with no design system: one sentence — a name that is no website says
// what it is, with its name (previewAnswerEmptyText).
const $78219bc825c01946$export$a5dc464f46a846b2 = {
    flow: 'y',
    gap: 'Z',
    minWidth: '0',
    height: '100%',
    minHeight: '0',
    dataPreviewDs: true,
    state: {
        site: null,
        failed: false,
        none: false,
        // The asked name when it is no website (functions/previewAnswer.js
        // previewAnswerResolve): a project of this workspace, or an App Store app.
        notWebsite: null,
        storeApp: null,
        section: null,
        current: null,
        ready: false,
        error: null
    },
    // EMPTY (the views contract, workspace functions/assistantAppViews.js): no
    // such site, or no website at all — the one sentence is all the view shows.
    empty: (el, s)=>s.failed ? true : s.site ? false : null,
    // RESOLVED PARAMS (the views contract): the site and environment the card
    // SHOWS — a follow-up stays on this site. null while reading.
    resolvedParams: (el, s)=>s.site ? {
            project: s.site.key,
            env: s.site.env
        } : null,
    onRender: (el)=>el.call('previewDsLoad', el),
    // The site card's own inputs (SitePreviewView): the App Store list too —
    // a late list can change what the asked name means (canvasAnswerNamedMoved).
    subscribeTo: [
        'workspaceApps',
        '_projectsForActiveOrg',
        '_previewParams',
        '_wsAppsCatalog'
    ],
    onUpdate: (el)=>el.call('previewDsLoad', el),
    Skeleton: {
        width: '100%',
        aspectRatio: '16 / 10',
        round: 'radiusControl',
        ariaBusy: 'true',
        hide: (el, s)=>!!s.site || !!s.failed
    },
    PreviewDsNote: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        color: 'caption',
        hide: (el, s)=>!s.failed,
        text: (el, s)=>{
            s.root.lang;
            return el.call('previewAnswerEmptyText', s);
        }
    },
    PreviewDsHead: {
        flow: 'x',
        align: 'center space-between',
        gap: 'Z',
        minWidth: '0',
        hide: (el, s)=>!s.site,
        PreviewDsName: {
            tag: 'span',
            minWidth: '0',
            fontSize: 'Z',
            color: 'caption',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            text: (el, s)=>{
                s.root.lang;
                const site = s.site;
                if (!site) return '';
                return site.name + " \xb7 " + String(el.call('polyglot', el.call('previewEnvLabel', site.env)));
            }
        },
        // The section — the preview sidebar's design-system pages.
        InlineSelect: {
            ariaLabel: (el, s)=>{
                s.root.lang;
                return el.call('polyglot', 'preview.dsView.section');
            },
            value: (el, s)=>s.current || 'colors',
            onClick: (e)=>e.stopPropagation(),
            onChange: (ev, el, s)=>{
                const next = ev.target.value;
                if (next && next !== s.current) s.update({
                    section: next
                });
            },
            childProps: {
                tag: 'option',
                text: (el, s)=>{
                    s.root.lang;
                    return el.call('polyglot', el.labelKey);
                },
                selected: (el, s)=>el.value === (s.current || 'colors') ? true : null
            },
            children: ()=>[
                    {
                        key: 'ds-colors',
                        value: 'colors',
                        labelKey: 'preview.sidebar.ds.colors'
                    },
                    {
                        key: 'ds-typography',
                        value: 'typography',
                        labelKey: 'preview.sidebar.ds.typography'
                    },
                    {
                        key: 'ds-spacing',
                        value: 'spacing',
                        labelKey: 'preview.sidebar.ds.spacing'
                    },
                    {
                        key: 'ds-icons',
                        value: 'icons',
                        labelKey: 'preview.sidebar.ds.icons'
                    },
                    {
                        key: 'ds-transitions',
                        value: 'transitions',
                        labelKey: 'preview.sidebar.ds.transitions'
                    },
                    {
                        key: 'ds-layout',
                        value: 'layout',
                        labelKey: 'preview.sidebar.ds.layout'
                    }
                ]
        }
    },
    PreviewDsBox: {
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        flex: '1 1 auto',
        minHeight: 'F',
        round: 'radiusControl',
        background: 'overlay',
        hide: (el, s)=>!s.site,
        PreviewDsFrame: {
            tag: 'iframe',
            position: 'absolute',
            inset: '0',
            width: '100%',
            height: '100%',
            border: 'none',
            display: 'block',
            background: 'white',
            '@dark': {
                background: 'black'
            },
            title: (el, s)=>{
                s.root.lang;
                return String(el.call('polyglot', 'preview.dsView.frameTitle')).replace('{name}', ()=>s.site ? s.site.name : '');
            },
            sandbox: (el)=>el.call('userCodeSandbox')
        },
        // A sentence in place of the showcase while it mounts, or when it cannot.
        PreviewDsCover: {
            position: 'absolute',
            inset: '0',
            flow: 'y',
            align: 'center center',
            padding: 'A',
            background: 'overlay',
            hide: (el, s)=>!!s.ready && !s.error,
            PreviewDsCoverText: {
                tag: 'p',
                role: 'status',
                margin: '0',
                maxWidth: 'G',
                fontSize: 'Z',
                color: 'caption',
                textAlign: 'center',
                text: (el, s)=>{
                    s.root.lang;
                    const key = !s.error ? 'preview.answer.loadingPart' : s.error === 'empty' ? 'preview.dsView.empty' : 'preview.dsView.failed';
                    return String(el.call('polyglot', key)).replace('{name}', ()=>s.site ? s.site.name : '');
                }
            }
        }
    }
};

});


parcelRegister("7Hxs6", function(module, exports) {

$parcel$export(module.exports, "stateDefaults", () => (parcelRequire("MygIX")).STATE_DEFAULTS);
$parcel$export(module.exports, "appRules", () => (parcelRequire("cmUBA")));
// Project globalScope — the canonical home for module-level values that an
// EMITTED function body reads by bare name.
//
// frank serializes every function to a string and revives it with a bare
// indirect eval: nothing module-level is in scope there. A free identifier is
// only reachable if frank can classify it and lift it into the emitted
// `globalScope` bag. A value frank cannot statically evaluate (an object built
// with a spread, an IIFE result, a mutable `let`) falls through to the
// last-resort `constant: null` classification and the read becomes a
// guaranteed ReferenceError in the published payload.
//
// Every named export of THIS file is reachable to that lifter by name
// (toJSON.js CONTEXT_MODULES — `globalScope` is imported as a namespace and
// walked by `gatherModuleValues`), so declaring the value here — and importing
// it from here at the read site — is the supported fix.
// (WORKSPACE-SHELL-FRANK-GATE-BLOCKS-REPUBLISH-1)
// The resolved shell state defaults. `scopes.js`'s `workspaceScopedWipe` reads
// them to build each workspace-scoped key's typed empty. state.js builds the
// object with a `...appState` spread, so frank cannot evaluate it statically.

var $MygIX = parcelRequire("MygIX");

var $cmUBA = parcelRequire("cmUBA");

});

parcelRegister("gzF45", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10fc4dd470a6ad9$export$2e2bcd8739ae039);
// The CALENDAR_SYNC_* / GITHUB_SYNC_* exports are gone. They addressed the
// `calendar-sync` and `github-sync` Supabase edge functions, which were deleted
// with that plane — every consumer was POSTing into a void behind its own
// catch. Calendar sync is now sdk.calendarSync() → POST /core/calendar/sync;
// GitHub sync is a server-side cron worker with no client trigger at all.
//
// They were also evaluated at MODULE LOAD (`restHeaders()` at import time), so
// the captured header was whatever the token was before sign-in.
// Pure SDK fetch adapter — every `fetch:` decl in this app routes through
// sdk.execute(). registerSdkAdapter() in bootShell binds the SDK instance
// at boot, so `{ adapter: 'sdk' }` here is sufficient — no per-decl sdk
// argument needed. The previous metaFetchConfig (per-decl Supabase fallback
// for unmigrated decls) is no longer required because every consumer now
// uses an SDK entity route prefix (workspaceProject.*, auth.*, organization,
// workspace, project, marketplace.*, file, screenshot, i18n.*).
//
// No per-decl `sdk`: the boot binds the SDK (shared bootPrepare →
// registerSdkAdapter({ sdk })) before anything mounts, in BOTH builds. A
// module-scope getSDK() here published as `"sdk": ""`, and the adapter
// merges the decl OVER the bound options, so the published shell's adapter
// had no SDK at all.
//
// `themeStorageKey`: the stored theme choice paints BEFORE the first frame
// in both builds — the published page's inline theme script and smbls
// create() both read `context.themeStorageKey` (the parcel boot also passes
// it to create()). Without it a published shell painted the OS scheme and
// never the person's stored choice.
var $c10fc4dd470a6ad9$export$2e2bcd8739ae039 = {
    useReset: true,
    useVariable: true,
    useFontImport: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDefaultConfig: true,
    useDocumentTheme: true,
    verbose: false,
    globalTheme: 'auto',
    themeStorageKey: 'themeMode',
    fetch: {
        adapter: 'sdk'
    }
};

});

parcelRegister("bO8z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $898b01e83f820924$export$2e2bcd8739ae039);
// The shell's files plane (context.files). Records keep the platform shape
// `{ content: { src } }`; keys resolve like an Img `src: '/files/<key>'`.

var $9xoLz = parcelRequire("9xoLz");
var $898b01e83f820924$export$2e2bcd8739ae039 = {
    ...(0, $9xoLz.default)
};

});
parcelRegister("9xoLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f1a68344e6324b9$export$2e2bcd8739ae039);
// Files-plane records for the ambient sky masks
// (DESIGN-WL-AMBIENT-SKIN-BACKDROP-1, HOME_AMBIENT_SKIN_SPEC §2).
//
// Keys are `ambientSkyFileKey(sky)` ('ambient/<sky>.png') and each record has
// the shape every `context.files` entry has (`{ content: { src, … } }`), so
// AmbientBackdrop resolves a sky the way an Img resolves `src: '/files/<key>'`.
// Licences: ./SOURCES.md. Never inline a data URI here (spec §2).
//
// Two build paths read this module:
//   * Parcel (the shell bundle): each literal `new URL('./<sky>.png',
//     import.meta.url)` is a URL dependency — Parcel emits the PNG with a
//     content hash and returns its served, same-origin URL (mask-image loads
//     in CORS mode, so same-origin matters).
//   * frank (esbuild to CJS for `smbls push`): `import.meta` is empty there,
//     the URL constructor throws, `_src` keeps the throw local and the record
//     is dropped — the platform JSON never carries a dead URL.
const $6f1a68344e6324b9$var$_src = (resolve)=>{
    try {
        return resolve();
    } catch (e) {
        return null;
    }
};






const $6f1a68344e6324b9$var$_masks = {
    'ambient/clouds.png': $6f1a68344e6324b9$var$_src(()=>new URL((parcelRequire("kBVPs"))).href),
    'ambient/dunes.png': $6f1a68344e6324b9$var$_src(()=>new URL((parcelRequire("ccoAV"))).href),
    'ambient/hills.png': $6f1a68344e6324b9$var$_src(()=>new URL((parcelRequire("1Jhxo"))).href),
    'ambient/lake.png': $6f1a68344e6324b9$var$_src(()=>new URL((parcelRequire("bqblw"))).href),
    'ambient/window.png': $6f1a68344e6324b9$var$_src(()=>new URL((parcelRequire("d46sT"))).href),
    'ambient/mountains.png': $6f1a68344e6324b9$var$_src(()=>new URL((parcelRequire("a3zUA"))).href)
};
var $6f1a68344e6324b9$export$2e2bcd8739ae039 = Object.fromEntries(Object.entries($6f1a68344e6324b9$var$_masks).filter((entry)=>typeof entry[1] === 'string' && entry[1].length > 0).map((entry)=>[
        entry[0],
        {
            content: {
                src: entry[1],
                mimeType: 'image/png',
                originalName: entry[0].slice(8)
            }
        }
    ]));

});
parcelRegister("kBVPs", function(module, exports) {
module.exports = import.meta.resolve("WdORs");

});

parcelRegister("ccoAV", function(module, exports) {
module.exports = import.meta.resolve("aIHbk");

});

parcelRegister("1Jhxo", function(module, exports) {
module.exports = import.meta.resolve("bI2dT");

});

parcelRegister("bqblw", function(module, exports) {
module.exports = import.meta.resolve("B9rkD");

});

parcelRegister("d46sT", function(module, exports) {
module.exports = import.meta.resolve("9CVx6");

});

parcelRegister("a3zUA", function(module, exports) {
module.exports = import.meta.resolve("4oAeT");

});



parcelRegister("6WQZS", function(module, exports) {

$parcel$export(module.exports, "anchorMainContent", () => $50f144eff38fd166$export$7c23a82df4e59825);
// Route-def transform applied to EVERY entry in context.js's merged `pages`
// map — stamps the landmark the shell's SkipToMain link (app.js) needs to be
// a real accessibility skip-link rather than a dead keyboard-only jump.
//
// Split into its own dependency-free file (rather than staying inline in
// context.js) so it's unit-testable: context.js's own import chain pulls in
// the entire canvas/marketplace/preview eager slice + sharedLibraries.js,
// which drags in CSS imports plain `node --test` can't resolve — importing
// context.js itself in a test fails on "Unknown file extension .css" before
// a single assertion runs (verified live). This file has zero imports, so it
// tests in isolation.
//
// Two stamps, both merge-safe (a route def's own value always wins):
//   - `attr.id = 'main-content'` — the skip link's `href="#main-content"`
//     fragment target. Without a resolvable id the link is inert for
//     keyboard users AND axe's `region` skip-link exemption doesn't apply
//     (MARKETPLACE-AUDIT residue, tickets/fable.md 2026-08-09).
//   - `role: 'main'` (A11Y-1 item 3, tickets/sonnet.md 2026-08-14) — the
//     `id` alone resolved the *jump*, but landed on whatever plain tag the
//     route rendered as (a `<div>`), not a semantic landmark, so a screen
//     reader's "jump to main region" navigation never found it even though
//     the visual/keyboard jump worked.
//
// The natural home for both — declaring `content: { attr: { id }, role }` on
// the app root — WIPES the shell's sibling children at boot (live-verified:
// root renders only `content`; framework bug, ticketed in tickets/smbls.md
// 2026-08-10), so the route map is the clean project-side choke point
// instead of 80+ individual page defs each remembering a landmark role.
const $50f144eff38fd166$export$7c23a82df4e59825 = (def)=>def && typeof def === 'object' ? {
        role: 'main',
        ...def,
        attr: {
            id: 'main-content',
            ...def.attr || {}
        }
    } : def;

});

parcelRegister("9QZBF", function(module, exports) {

$parcel$export(module.exports, "authRouteGuard", () => $72c8c22aceb22831$export$b89c56796eb19f84);
// The shell's AUTH router guard — the gate before mount, on every navigation.
//
// Registered in context.js `router.guards` (smbls runs guards inside the
// router before pushState / content mount: `true` allows, a string
// redirects). The decision is functions/auth.js authRedirectTarget — the SAME
// predicate the parcel cold boot runs in redirectIfUnauthed — with THE public
// path list the boot gate reads too (shared guestRoutes.js isGuestAllowedPath,
// reached through the element so a published library function gets its own
// receiver). On the published shell (mermaid
// runs Smbls.create(app, context) and never index.js) this guard IS the auth
// gate: an anonymous visitor to a protected path lands on /login?next=… and
// the protected page never mounts. The session test is the token in storage
// (hasSessionToken) — synchronous, no SDK, so it holds before SDK init.
// REVIEW FIXES (2026-10-09, ws crm one-boot delta review):
//  · D5 — the wait for the gate is BOUNDED (context.bootGuardWaitMs, else
//    30 s). Past it the guard fails CLOSED: treated as signed out, so a
//    protected path bounces to /login?next=… and never mounts. Nothing is
//    purged — the stored session is kept, the next load signs straight in.
//  · D9 — a gate that SETTLED without a verdict (a failed boot) is signed
//    out. The stored token answers only on a host with no boot gate at all.
//  · Warm early mount (2026-10-10) — a gated host whose gate does not exist
//    yet (bootMode set, no bootReady) waits for the gate to appear, inside the
//    same bound, instead of deciding "no verdict = signed out" at once.
//  · Published shell — the router calls a guard with NO receiver, so frank's
//    `__scope.<import>` rewrite of a module-scope read resolved on `{}`
//    (`__scope.hasSessionToken is not a function` on every boot; the receiver
//    rule in smbls frank getElementRef does not see a DESTRUCTURED `element`
//    param). The guard therefore reads NO module binding: every helper is
//    reached through `element.call` (all five are registry functions), and
//    the bound is an inline literal.
const $72c8c22aceb22831$export$b89c56796eb19f84 = ({ pathname: pathname, query: query, element: element })=>{
    const path = pathname || '/';
    const call = (name, ...args)=>element && typeof element.call === 'function' ? element.call(name, ...args) : undefined;
    const isPublicPath = (p)=>!!call('isGuestAllowedPath', p);
    const ctx = element && element.context || null;
    // a boot gate exists on this host (parcel bootShell or the published plugin)
    const gated = !!(ctx && (ctx.bootReady || ctx.bootMode));
    const decide = ()=>{
        let authed;
        if (ctx && typeof ctx.bootSignedIn === 'boolean') {
            const st = element.state && (element.state.root || element.state);
            authed = st && st._authReady === true && typeof st.signedIn === 'boolean' ? st.signedIn : ctx.bootSignedIn;
        } else if (gated) // D5 / D9: no verdict (the gate failed or never answered) — fail closed
        authed = false;
        else authed = !!call('hasSessionToken');
        const target = call('authRedirectTarget', {
            path: path,
            search: call('queryHashTail', query, '') || '',
            authed: authed,
            demoHost: !!call('isDemoHost'),
            isPublicPath: isPublicPath
        });
        return target || true;
    };
    // A gated host with no verdict WAITS (never decides early) — on a protected
    // path only. The gate may not exist yet: the parcel warm start mounts EARLY
    // (bootResolve → mountEarly → create → router → here) on a context COPY that
    // carries bootMode but neither bootSignedIn nor bootReady; bootApply writes
    // both onto the mounted context later. So the guard watches for the gate to
    // APPEAR, then waits on it — all inside the ONE bound (D5). Settled with no
    // verdict, or past the bound → decide() fails closed (D9).
    if (ctx && gated && typeof ctx.bootSignedIn !== 'boolean' && !isPublicPath(path)) {
        const waitMs = Number(ctx.bootGuardWaitMs) > 0 ? Number(ctx.bootGuardWaitMs) : 30000;
        return new Promise((resolve)=>{
            let done = false;
            let timer = null;
            let poll = null;
            const finish = ()=>{
                if (done) return;
                done = true;
                if (timer !== null) clearTimeout(timer);
                if (poll !== null) clearTimeout(poll);
                resolve(decide());
            };
            const watch = ()=>{
                poll = null;
                if (done) return;
                if (typeof ctx.bootSignedIn === 'boolean') return finish();
                if (ctx.bootReady) return void Promise.resolve(ctx.bootReady).then(finish, finish);
                poll = setTimeout(watch, 25);
            };
            timer = setTimeout(finish, waitMs);
            watch();
        });
    }
    return decide();
};

});

parcelRegister("bOd1d", function(module, exports) {

$parcel$export(module.exports, "windowsComponents", () => $898e766f56f66a9b$export$dac359806b307a0b);

var $hrr1s = parcelRequire("hrr1s");

var $lCaUQ = parcelRequire("lCaUQ");

var $5lkGX = parcelRequire("5lkGX");

var $dlWOr = parcelRequire("dlWOr");

var $3IRuE = parcelRequire("3IRuE");

var $gVLmO = parcelRequire("gVLmO");

var $6LFN5 = parcelRequire("6LFN5");

var $Xlxhy = parcelRequire("Xlxhy");

var $itrCN = parcelRequire("itrCN");
const $898e766f56f66a9b$export$dac359806b307a0b = {
    ModalRoot: (0, $hrr1s.ModalRoot),
    ModalLayer: (0, $lCaUQ.ModalLayer),
    ConfirmTemplate: (0, $5lkGX.ConfirmTemplate),
    AlertTemplate: (0, $dlWOr.AlertTemplate),
    PromptTemplate: (0, $3IRuE.PromptTemplate),
    CustomTemplate: (0, $gVLmO.CustomTemplate),
    "smbls.CancelButton": (0, $6LFN5.CancelButton),
    "smbls.ModalWindow": (0, $Xlxhy.ModalWindow),
    "smbls.ModalHeader": (0, $Xlxhy.ModalHeader),
    "smbls.ModalPhoneSheet": (0, $itrCN.ModalPhoneSheet)
};

});
parcelRegister("hrr1s", function(module, exports) {

$parcel$export(module.exports, "ModalRoot", () => $cb29eb64dafec947$export$76630a3be18d4dc4);

var $4qCA4 = parcelRequire("4qCA4");

var $baSp1 = parcelRequire("baSp1");
const $cb29eb64dafec947$var$b = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
].join(","), $cb29eb64dafec947$var$v = (e)=>{
    if (!e?.querySelectorAll) return [];
    const t = e.querySelectorAll($cb29eb64dafec947$var$b), o = [];
    for(let i = 0; i < t.length; i++){
        const a = t[i];
        (a.offsetParent !== null || a === document.activeElement) && o.push(a);
    }
    return o;
}, $cb29eb64dafec947$var$m = (e)=>{
    if (!e?.querySelectorAll) return !1;
    const t = e.querySelectorAll("[autofocus]");
    for(let o = 0; o < t.length; o++){
        const i = t[o];
        if (!(i.offsetParent === null || i.matches(":disabled") || typeof i.focus != "function")) {
            try {
                i.focus();
            } catch  {
                continue;
            }
            if (document.activeElement === i) return !0;
        }
    }
    return !1;
}, $cb29eb64dafec947$var$h = (e)=>{
    const t = e.state?.stack || [];
    if (!t.length) return null;
    const o = e["ModalLayer_" + (t.length - 1)];
    return o?.node || o?.__ref?.node || null;
}, $cb29eb64dafec947$export$76630a3be18d4dc4 = {
    tag: "div",
    position: "fixed",
    inset: "0",
    zIndex: "2000",
    pointerEvents: "none",
    state: {
        stack: [],
        leaving: []
    },
    subscribeTo: [
        "stack"
    ],
    ModalLayer_0: {
        __slotIndex: 0,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (e, t)=>t?.stack?.[0] || t?.leaving?.[0] || null,
        layerExiting: (e, t)=>!t?.stack?.[0] && !!t?.leaving?.[0],
        opacity: (e)=>e.layer && !e.layerExiting ? "1" : "0",
        visibility: (e)=>e.layer ? "visible" : "hidden",
        pointerEvents: (e)=>e.layer && !e.layerExiting ? "auto" : "none"
    },
    ModalLayer_1: {
        __slotIndex: 1,
        deferUntil: (e, t)=>(t?.stack?.length || 0) >= 1,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (e, t)=>t?.stack?.[1] || t?.leaving?.[1] || null,
        layerExiting: (e, t)=>!t?.stack?.[1] && !!t?.leaving?.[1],
        opacity: (e)=>e.layer && !e.layerExiting ? "1" : "0",
        visibility: (e)=>e.layer ? "visible" : "hidden",
        pointerEvents: (e)=>e.layer && !e.layerExiting ? "auto" : "none"
    },
    ModalLayer_2: {
        __slotIndex: 2,
        deferUntil: (e, t)=>(t?.stack?.length || 0) >= 2,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (e, t)=>t?.stack?.[2] || t?.leaving?.[2] || null,
        layerExiting: (e, t)=>!t?.stack?.[2] && !!t?.leaving?.[2],
        opacity: (e)=>e.layer && !e.layerExiting ? "1" : "0",
        visibility: (e)=>e.layer ? "visible" : "hidden",
        pointerEvents: (e)=>e.layer && !e.layerExiting ? "auto" : "none"
    },
    ModalLayer_3: {
        __slotIndex: 3,
        deferUntil: (e, t)=>(t?.stack?.length || 0) >= 3,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (e, t)=>t?.stack?.[3] || t?.leaving?.[3] || null,
        layerExiting: (e, t)=>!t?.stack?.[3] && !!t?.leaving?.[3],
        opacity: (e)=>e.layer && !e.layerExiting ? "1" : "0",
        visibility: (e)=>e.layer ? "visible" : "hidden",
        pointerEvents: (e)=>e.layer && !e.layerExiting ? "auto" : "none"
    },
    ModalLayer_4: {
        __slotIndex: 4,
        deferUntil: (e, t)=>(t?.stack?.length || 0) >= 4,
        subscribeTo: [
            "stack",
            "leaving"
        ],
        layer: (e, t)=>t?.stack?.[4] || t?.leaving?.[4] || null,
        layerExiting: (e, t)=>!t?.stack?.[4] && !!t?.leaving?.[4],
        opacity: (e)=>e.layer && !e.layerExiting ? "1" : "0",
        visibility: (e)=>e.layer ? "visible" : "hidden",
        pointerEvents: (e)=>e.layer && !e.layerExiting ? "auto" : "none"
    },
    onInit: (e, t)=>{
        if (typeof window > "u") return;
        globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ = e;
        const o = e.context;
        if (o) {
            o.functions || (o.functions = {});
            for(const n in 0, $4qCA4.windowsFunctions)n in o.functions || (o.functions[n] = (0, $4qCA4.windowsFunctions)[n]);
        }
        e.__modalOpeners = e.__modalOpeners || [], e.__prevStackLen = e.state && e.state.stack && e.state.stack.length || 0;
        const i = (n)=>{
            if (typeof n?.onCancel == "function") try {
                n.onCancel();
            } catch (s) {
                console.warn("[windows] onCancel threw:", s);
            }
            if (typeof n?.onClose == "function") try {
                n.onClose();
            } catch (s) {
                console.warn("[windows] onClose threw:", s);
            }
        }, a = ()=>{
            const n = (e.state?.stack || []).length - 1;
            if (!(n < 0)) for (const s of (0, $baSp1.removeLayers)(e, (l, r)=>r !== n))i(s);
        }, u = (n)=>{
            const s = e.state?.stack;
            if (s?.length) {
                if (n.key === "Tab") {
                    const l = $cb29eb64dafec947$var$h(e);
                    if (!l) return;
                    const r = $cb29eb64dafec947$var$v(l);
                    if (!r.length) {
                        n.preventDefault();
                        const y = l.querySelector?.('[role="dialog"]') || l;
                        try {
                            y.focus?.();
                        } catch  {}
                        return;
                    }
                    const c = r[0], f = r[r.length - 1], _ = document.activeElement;
                    if (!l.contains(_)) {
                        n.preventDefault();
                        try {
                            c.focus();
                        } catch  {}
                        return;
                    }
                    if (n.shiftKey && _ === c) {
                        n.preventDefault();
                        try {
                            f.focus();
                        } catch  {}
                    } else if (!n.shiftKey && _ === f) {
                        n.preventDefault();
                        try {
                            c.focus();
                        } catch  {}
                    }
                    return;
                }
                n.key !== "Escape" || n.defaultPrevented || s[s.length - 1]?.dismissOnBackdrop !== !1 && (n.preventDefault(), a());
            }
        };
        window.addEventListener("keydown", u), e.__escHandler = u;
        const d = (n)=>{
            const s = e.state?.stack || [];
            if (!(n < 0 || n >= s.length)) for (const l of (0, $baSp1.removeLayers)(e, (r, c)=>c !== n))i(l);
        }, p = (n)=>{
            const s = e.state?.stack || [];
            if (!s.length) return;
            const l = n.target?.closest?.('[data-key="Close"]');
            if (l) {
                for(let r = s.length - 1; r >= 0; r--){
                    const c = e["ModalLayer_" + r], f = c?.node || c?.__ref?.node;
                    if (f && f.contains(l)) {
                        n.preventDefault(), n.stopPropagation(), d(r);
                        return;
                    }
                }
                return;
            }
            for(let r = s.length - 1; r >= 0; r--){
                const c = e["ModalLayer_" + r];
                if ((c?.node || c?.__ref?.node) === n.target) {
                    if (s[r]?.dismissOnBackdrop === !1) return;
                    n.preventDefault(), n.stopPropagation(), d(r);
                    return;
                }
            }
        };
        document.addEventListener("click", p, !0), e.__clickDelegate = p;
    },
    onUpdate: (e)=>{
        if (typeof window > "u") return;
        const o = (e.state && e.state.stack || []).length, i = e.__prevStackLen || 0;
        if (o !== i) {
            if (e.__prevStackLen = o, e.__modalOpeners = e.__modalOpeners || [], o > i) e.__modalOpeners[o] = document.activeElement && document.activeElement !== document.body ? document.activeElement : e.__modalOpeners[o] || null, typeof requestAnimationFrame == "function" && requestAnimationFrame(()=>{
                const a = $cb29eb64dafec947$var$h(e);
                if (!a || $cb29eb64dafec947$var$m(a)) return;
                const d = $cb29eb64dafec947$var$v(a)[0] || a.querySelector && a.querySelector('[role="dialog"]') || a;
                try {
                    d.focus && d.focus();
                } catch  {}
            });
            else {
                let a = null;
                for(let u = i; u > o; u--)e.__modalOpeners[u] && (a = a || e.__modalOpeners[u]), e.__modalOpeners[u] = null;
                if (a && typeof a.focus == "function" && a.isConnected !== !1) try {
                    a.focus();
                } catch  {}
            }
        }
    },
    onDestroy: (e)=>{
        typeof window > "u" || (globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ === e && (globalThis.__SMBLS_WINDOWS_MODAL_ROOT__ = null), e.__escHandler && (window.removeEventListener("keydown", e.__escHandler), delete e.__escHandler), e.__clickDelegate && (document.removeEventListener("click", e.__clickDelegate, !0), delete e.__clickDelegate));
    }
};

});

parcelRegister("lCaUQ", function(module, exports) {

$parcel$export(module.exports, "ModalLayer", () => $fbc59d3edf3e5e1f$export$ced21ef13149a301);

var $jtcLi = parcelRequire("jtcLi");
const $fbc59d3edf3e5e1f$export$ced21ef13149a301 = {
    tag: "div",
    position: "fixed",
    inset: "0",
    alignItems: "center",
    justifyContent: "center",
    padding: "A",
    "@mobileL": {
        padding: "0",
        alignItems: "flex-end"
    },
    childExtends: "ModalPhoneSheet",
    theme: "backdrop",
    transition: "opacity C defaultBezier",
    zIndex: (e, i)=>`${2e3 + (e.__slotIndex || 0) * 10}`,
    display: (e, i)=>e.layer ? "flex" : "none",
    opacity: (e, i)=>e.layer && !e.layerExiting ? "1" : "0",
    visibility: (e, i)=>e.layer ? "visible" : "hidden",
    pointerEvents: (e, i)=>e.layer && !e.layerExiting ? "auto" : "none",
    inert: (e)=>!!e.layerExiting,
    ModalWindow: {
        attr: {
            role: "dialog",
            "aria-modal": "true",
            tabindex: "-1",
            "aria-labelledby": (e)=>{
                const i = (0, $jtcLi.walkToLayer)(e);
                return (0, $jtcLi.layerTitleId)(i, i?.template);
            }
        },
        width: (e)=>(0, $jtcLi.walkToLayer)(e)?.width || "H",
        maxWidth: (e)=>(0, $jtcLi.walkToLayer)(e)?.maxWidth || "90vw",
        flow: "y",
        maxHeight: (e)=>(0, $jtcLi.walkToLayer)(e)?.maxHeight || "100%",
        animation: "modalIn",
        animationDuration: "D",
        animationTimingFunction: "springBezier",
        isLayerExiting: (e)=>(0, $jtcLi.walkToLayerExiting)(e),
        ".isLayerExiting": {
            animationName: "modalOut",
            animationDuration: "C",
            animationTimingFunction: "defaultBezier",
            animationFillMode: "forwards",
            "@mobileL": {
                animationName: "modalOutDown"
            }
        },
        onClick: (e)=>e.stopPropagation(),
        onMousedown: (e)=>e.stopPropagation(),
        ModalHeader: {
            display: "none"
        },
        overflow: "visible",
        ConfirmTemplate: {
            hide: (e)=>(0, $jtcLi.walkToLayer)(e)?.template !== "confirm"
        },
        AlertTemplate: {
            hide: (e)=>(0, $jtcLi.walkToLayer)(e)?.template !== "alert"
        },
        PromptTemplate: {
            hide: (e)=>(0, $jtcLi.walkToLayer)(e)?.template !== "prompt"
        },
        CustomTemplate: {
            hide: (e)=>(0, $jtcLi.walkToLayer)(e)?.template !== "custom"
        }
    }
};
function $fbc59d3edf3e5e1f$var$p(e, i, r) {
    if (e.target !== i.node) return;
    const a = i.layer;
    if (a && a.dismissOnBackdrop !== !1) {
        if (r && typeof window < "u") {
            const n = (o)=>{
                o.preventDefault(), o.stopPropagation(), window.removeEventListener("click", n, !0);
            };
            window.addEventListener("click", n, !0), setTimeout(()=>window.removeEventListener("click", n, !0), 0);
        }
        i.call("closeModal", a.id);
    }
}

});

parcelRegister("5lkGX", function(module, exports) {

$parcel$export(module.exports, "ConfirmTemplate", () => $3e3ef6e84d50b612$export$38d1cecaf8daf559);

var $jtcLi = parcelRequire("jtcLi");

var $eY4Ct = parcelRequire("eY4Ct");
const $3e3ef6e84d50b612$var$f = (o, n, t)=>(0, $jtcLi.walkToLayer)(o)?.[n] || t, $3e3ef6e84d50b612$var$a = (o, n, t)=>(0, $jtcLi.walkToLayer)(o)?.[n] || (0, $eY4Ct.resolveDialogCopy)(o, t), $3e3ef6e84d50b612$var$d = (o)=>{
    const n = (0, $jtcLi.walkToLayer)(o)?.icon;
    return n === null || n === !1;
}, $3e3ef6e84d50b612$export$38d1cecaf8daf559 = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    ModalHeader: {
        Hgroup: {
            H: {
                text: (o)=>(0, $jtcLi.layerTitle)((0, $jtcLi.walkToLayer)(o)) || (0, $eY4Ct.resolveDialogCopy)(o, "dialog.confirmTitle"),
                attr: {
                    id: (o)=>(0, $jtcLi.layerTitleId)((0, $jtcLi.walkToLayer)(o), "confirm")
                }
            },
            P: {
                if: ()=>!1
            }
        },
        Icons: {
            hide: (o)=>$3e3ef6e84d50b612$var$d(o),
            Indicator: {
                extends: "Icon",
                opacity: ".7",
                icon: (o)=>$3e3ef6e84d50b612$var$f(o, "icon", "warning")
            }
        }
    },
    ModalBody: {
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        P: {
            tag: "p",
            margin: "0",
            text: (o)=>$3e3ef6e84d50b612$var$a(o, "message", "dialog.confirmMessage"),
            color: "inactive"
        }
    },
    ModalFooter: {
        flow: "x",
        gap: "Z1",
        align: "center end",
        flexShrink: "0",
        CancelBtn: {
            extends: "CancelButton",
            text: (o)=>$3e3ef6e84d50b612$var$a(o, "cancelText", "dialog.cancel"),
            onClick: (o, n, t)=>{
                if ((0, $jtcLi.walkToLayerExiting)(n)) return;
                const e = (0, $jtcLi.walkToLayer)(n);
                if (e?.onCancel) try {
                    e.onCancel();
                } catch (i) {
                    console.warn("[windows] confirm.onCancel threw:", i);
                }
                n.call("closeModal", e?.id);
            }
        },
        ConfirmBtn: {
            extends: "Button",
            theme: (o)=>$3e3ef6e84d50b612$var$f(o, "confirmTheme", "primary"),
            text: (o)=>$3e3ef6e84d50b612$var$a(o, "confirmText", "dialog.confirm"),
            onClick: (o, n, t)=>{
                if ((0, $jtcLi.walkToLayerExiting)(n)) return;
                const e = (0, $jtcLi.walkToLayer)(n);
                if (e?.onConfirm) try {
                    e.onConfirm();
                } catch (i) {
                    console.warn("[windows] confirm.onConfirm threw:", i);
                }
                n.call("closeModal", e?.id);
            }
        }
    }
};

});

parcelRegister("dlWOr", function(module, exports) {

$parcel$export(module.exports, "AlertTemplate", () => $9b8adb80d5cc898d$export$64742e462a67f0b5);

var $jtcLi = parcelRequire("jtcLi");

var $eY4Ct = parcelRequire("eY4Ct");
const $9b8adb80d5cc898d$var$i = (o, e, a)=>(0, $jtcLi.walkToLayer)(o)?.[e] || a, $9b8adb80d5cc898d$var$g = (o, e, a)=>(0, $jtcLi.walkToLayer)(o)?.[e] || (0, $eY4Ct.resolveDialogCopy)(o, a), $9b8adb80d5cc898d$export$64742e462a67f0b5 = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    ModalHeader: {
        Hgroup: {
            H: {
                text: (o)=>(0, $jtcLi.layerTitle)((0, $jtcLi.walkToLayer)(o)) || (0, $eY4Ct.resolveDialogCopy)(o, "dialog.alertTitle"),
                attr: {
                    id: (o)=>(0, $jtcLi.layerTitleId)((0, $jtcLi.walkToLayer)(o), "alert")
                }
            },
            P: {
                if: ()=>!1
            }
        },
        Icons: {
            Indicator: {
                extends: "Icon",
                opacity: ".7",
                icon: (o)=>$9b8adb80d5cc898d$var$i(o, "icon", "info")
            }
        }
    },
    ModalBody: {
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        hide: (o)=>!$9b8adb80d5cc898d$var$i(o, "message", ""),
        P: {
            tag: "p",
            margin: "0",
            text: (o)=>$9b8adb80d5cc898d$var$i(o, "message", ""),
            color: "inactive"
        }
    },
    ModalFooter: {
        flow: "x",
        align: "center end",
        flexShrink: "0",
        OkBtn: {
            extends: "Button",
            theme: "primary",
            text: (o)=>$9b8adb80d5cc898d$var$g(o, "okText", "dialog.ok"),
            onClick: (o, e, a)=>{
                if ((0, $jtcLi.walkToLayerExiting)(e)) return;
                const r = (0, $jtcLi.walkToLayer)(e);
                if (r?.onOk) try {
                    r.onOk();
                } catch (n) {
                    console.warn("[windows] alert.onOk threw:", n);
                }
                e.call("closeModal", r?.id);
            }
        }
    }
};

});

parcelRegister("3IRuE", function(module, exports) {

$parcel$export(module.exports, "PromptTemplate", () => $2b5ef9d781175bf3$export$c91635164d2f162d);

var $jtcLi = parcelRequire("jtcLi");

var $eY4Ct = parcelRequire("eY4Ct");
const $2b5ef9d781175bf3$var$l = (e, o, t)=>(0, $jtcLi.walkToLayer)(e)?.[o] || t, $2b5ef9d781175bf3$var$p = (e, o, t)=>(0, $jtcLi.walkToLayer)(e)?.[o] || (0, $eY4Ct.resolveDialogCopy)(e, t), $2b5ef9d781175bf3$export$c91635164d2f162d = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    scope: {
        value: ""
    },
    onRender: (e, o)=>{
        const t = (0, $jtcLi.walkToLayer)(e);
        if (!t || e.scope._seededLayerId === t.id) return;
        e.scope._seededLayerId = t.id, e.scope.value = t.defaultValue || "";
        const n = e.InputRow && e.InputRow.node;
        n && (n.value = e.scope.value);
    },
    onUpdate: (e, o)=>{
        const t = (0, $jtcLi.walkToLayer)(e);
        if (!t || e.scope._seededLayerId === t.id) return;
        e.scope._seededLayerId = t.id, e.scope.value = t.defaultValue || "";
        const n = e.InputRow && e.InputRow.node;
        n && (n.value = e.scope.value);
    },
    ModalHeader: {
        Hgroup: {
            H: {
                text: (e)=>(0, $jtcLi.layerTitle)((0, $jtcLi.walkToLayer)(e)) || (0, $eY4Ct.resolveDialogCopy)(e, "dialog.promptTitle"),
                attr: {
                    id: (e)=>(0, $jtcLi.layerTitleId)((0, $jtcLi.walkToLayer)(e), "prompt")
                }
            },
            P: {
                if: ()=>!1
            }
        }
    },
    ModalBody: {
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        hide: (e)=>!$2b5ef9d781175bf3$var$l(e, "message", ""),
        P: {
            tag: "p",
            margin: "0",
            text: (e)=>$2b5ef9d781175bf3$var$l(e, "message", ""),
            color: "inactive"
        }
    },
    InputRow: {
        extends: "Input",
        flexShrink: "0",
        autofocus: !0,
        placeholder: (e)=>$2b5ef9d781175bf3$var$l(e, "placeholder", ""),
        value: (e, o)=>e.parent.scope?.value || "",
        onInput: (e, o, t)=>{
            o.parent.scope.value = e.target.value;
        },
        onKeydown: (e, o, t)=>{
            if (e.key !== "Enter" || (0, $jtcLi.walkToLayerExiting)(o)) return;
            e.preventDefault();
            const n = (0, $jtcLi.walkToLayer)(o), a = o.parent.scope?.value || "";
            if (n?.onConfirm) try {
                n.onConfirm(a);
            } catch (i) {
                console.warn("[windows] prompt.onConfirm threw:", i);
            }
            o.call("closeModal", n?.id);
        }
    },
    ModalFooter: {
        flow: "x",
        gap: "Z1",
        align: "center end",
        flexShrink: "0",
        CancelBtn: {
            extends: "CancelButton",
            text: (e)=>$2b5ef9d781175bf3$var$p(e, "cancelText", "dialog.cancel"),
            onClick: (e, o, t)=>{
                if ((0, $jtcLi.walkToLayerExiting)(o)) return;
                const n = (0, $jtcLi.walkToLayer)(o);
                if (n?.onCancel) try {
                    n.onCancel();
                } catch (a) {
                    console.warn("[windows] prompt.onCancel threw:", a);
                }
                o.call("closeModal", n?.id);
            }
        },
        ConfirmBtn: {
            extends: "Button",
            theme: "primary",
            text: (e)=>$2b5ef9d781175bf3$var$p(e, "confirmText", "dialog.ok"),
            onClick: (e, o, t)=>{
                if ((0, $jtcLi.walkToLayerExiting)(o)) return;
                const n = (0, $jtcLi.walkToLayer)(o), a = o.parent.parent.scope?.value || "";
                if (n?.onConfirm) try {
                    n.onConfirm(a);
                } catch (i) {
                    console.warn("[windows] prompt.onConfirm threw:", i);
                }
                o.call("closeModal", n?.id);
            }
        }
    }
};

});

parcelRegister("gVLmO", function(module, exports) {

$parcel$export(module.exports, "CustomTemplate", () => $c536b6490f47d842$export$7ac430bfe1ca9024);

var $eY4Ct = parcelRequire("eY4Ct");

var $jtcLi = parcelRequire("jtcLi");

var $4qCA4 = parcelRequire("4qCA4");
const $c536b6490f47d842$export$7ac430bfe1ca9024 = {
    tag: "div",
    flow: "y",
    gap: "B",
    flex: "1 1 auto",
    minHeight: "0",
    Title: {
        tag: "h2",
        text: (t)=>(0, $jtcLi.layerTitle)((0, $jtcLi.walkToLayer)(t)),
        hide: (t)=>!(0, $jtcLi.layerTitle)((0, $jtcLi.walkToLayer)(t)),
        position: "absolute",
        width: "1px",
        height: "1px",
        margin: "-1px",
        padding: "0",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        border: "0",
        attr: {
            id: (t)=>(0, $jtcLi.layerTitleId)((0, $jtcLi.walkToLayer)(t), "custom")
        }
    },
    Slot: {
        tag: "div",
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overscrollBehavior: "contain",
        onInit: (t)=>{
            const s = (0, $eY4Ct.createEffect)(()=>{
                const i = (0, $jtcLi.walkToLayer)(t), r = i?.content || null, a = i?.id || null;
                if (!r) {
                    t.__lastLayerId != null && (t.removeContent(), t.__lastLayerId = null);
                    return;
                }
                if (t.__lastLayerId !== a) {
                    t.__lastLayerId = a;
                    try {
                        t.set(r);
                        const o = t.content?.context;
                        if (o) {
                            o.functions || (o.functions = {});
                            for(const e in 0, $4qCA4.windowsFunctions)e in o.functions || (o.functions[e] = (0, $4qCA4.windowsFunctions)[e]);
                        }
                    } catch (o) {
                        console.warn("[windows] custom.content set failed:", o);
                    }
                }
            });
            t.__ref && t.__ref.__effects.push(s);
        }
    }
};

});

parcelRegister("6LFN5", function(module, exports) {

$parcel$export(module.exports, "CancelButton", () => $4ed78c9b87002a91$export$488fee190faedb43);
const $4ed78c9b87002a91$export$488fee190faedb43 = {
    extends: "Button",
    theme: "tertiary"
};

});

parcelRegister("Xlxhy", function(module, exports) {

$parcel$export(module.exports, "ModalWindow", () => $0b26375d95417ec2$export$bb6ccfada3e7d0f7);
$parcel$export(module.exports, "ModalHeader", () => $0b26375d95417ec2$export$f50a68e3694789ee);
const $0b26375d95417ec2$export$bb6ccfada3e7d0f7 = {
    theme: "dialog",
    padding: "B",
    round: "radiusSheet"
}, $0b26375d95417ec2$export$f50a68e3694789ee = {
    flow: "x",
    align: "start space-between",
    gap: "A"
};

});

parcelRegister("itrCN", function(module, exports) {

$parcel$export(module.exports, "ModalPhoneSheet", () => $d7305d2224af9d15$export$145609ed3b2f048e);
const $d7305d2224af9d15$export$145609ed3b2f048e = {
    "@mobileL": {
        position: "relative",
        boxSizing: "border-box",
        minWidth: "100%",
        maxHeight: "92%",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        borderBottomWidth: "env(safe-area-inset-bottom)",
        borderBottomStyle: "solid",
        borderBottomColor: "transparent",
        animationName: "modalInUp",
        transformOrigin: "bottom center"
    },
    SheetGrabber: {
        "aria-hidden": "true",
        display: "none",
        position: "absolute",
        top: "Y",
        left: "50%",
        width: "grabberW",
        height: "grabberH",
        round: "radiusPill",
        background: "line",
        transform: "translateX(-50%)",
        pointerEvents: "none",
        "@mobileL": {
            display: "block"
        }
    }
};

});


parcelRegister("jg30I", function(module, exports) {

$parcel$export(module.exports, "tooltipComponents", () => $e051d8c44c748f5a$export$b40c11887242d394);

var $7x69X = parcelRequire("7x69X");

var $3Bl0e = parcelRequire("3Bl0e");

var $4WQ3w = parcelRequire("4WQ3w");
const $e051d8c44c748f5a$export$b40c11887242d394 = {
    TooltipRoot: (0, $7x69X.TooltipRoot),
    TooltipTrigger: (0, $3Bl0e.TooltipTrigger),
    Tooltip: (0, $4WQ3w.Tooltip),
    TooltipHidden: (0, $4WQ3w.TooltipHidden),
    TooltipParent: (0, $4WQ3w.TooltipParent)
};

});
parcelRegister("7x69X", function(module, exports) {

$parcel$export(module.exports, "TooltipRoot", () => $016a54341be00705$export$c21697e1ea9173ed);

var $3CEp6 = parcelRequire("3CEp6");

var $1ApNM = parcelRequire("1ApNM");
const $016a54341be00705$var$n = (t)=>{
    const e = t.tip;
    return e?.anchor ? (0, $3CEp6.computeTooltipPosition)(e.anchor, e.size || {
        width: 0,
        height: 0
    }, e.placement) : null;
}, $016a54341be00705$var$i = (t)=>(0, $1ApNM.isTipShown)(t.tip), $016a54341be00705$var$s = (t)=>{
    const e = t.tip;
    return !e || e.open === !1 ? "Z opacity defaultBezier, Z translate defaultBezier, Z visibility defaultBezier, Z transform defaultBezier" : e.size ? e.glide ? "A transform defaultBezier, A translate defaultBezier, A opacity defaultBezier, A visibility defaultBezier" : "A opacity defaultBezier, A translate defaultBezier, A visibility defaultBezier" : "Z opacity defaultBezier, Z visibility defaultBezier";
}, $016a54341be00705$var$o = (t)=>{
    const e = typeof window < "u" && window.devicePixelRatio || 1;
    return Math.round(t * e) / e;
}, $016a54341be00705$export$c21697e1ea9173ed = {
    tag: "div",
    attr: {
        "data-smbls-tooltip-root": "true"
    },
    position: "fixed",
    inset: "0",
    zIndex: "2500",
    pointerEvents: "none",
    state: {
        tip: null
    },
    onDocumentKeydown: (t, e)=>{
        t.key !== "Escape" || t.defaultPrevented || !e.state?.tip || e.state.tip.open === !1 || (t.preventDefault(), e.call("closeTooltip"));
    },
    onDocumentClick: {
        capture: !0,
        handler: (t, e)=>e.call("closeTooltip")
    },
    onWindowResize: (t, e)=>e.call("closeTooltip"),
    Panel: {
        tag: "div",
        attr: {
            "data-smbls-tooltip": "panel"
        },
        role: "tooltip",
        position: "fixed",
        left: "0",
        top: "0",
        tip: (t, e)=>e?.tip || null,
        transform: (t)=>{
            const e = $016a54341be00705$var$n(t);
            return e ? `translate3d(${$016a54341be00705$var$o(e.left)}px, ${$016a54341be00705$var$o(e.top)}px, 0)` : "translate3d(-9999px, -9999px, 0)";
        },
        translate: (t)=>{
            if ($016a54341be00705$var$i(t)) return "0 0";
            const e = $016a54341be00705$var$n(t);
            return (0, $3CEp6.entranceOffset)(e ? e.side : "bottom");
        },
        text: (t)=>t.tip?.text || "",
        theme: (t)=>t.tip?.theme || (0, $1ApNM.TOOLTIP_DEFAULTS).theme,
        width: "max-content",
        maxWidth: "280px",
        padding: "Y2 Z",
        round: "Z",
        fontSize: "Y2",
        lineHeight: "1.35",
        whiteSpace: "normal",
        pointerEvents: "none",
        opacity: (t)=>$016a54341be00705$var$i(t) ? "1" : "0",
        visibility: (t)=>$016a54341be00705$var$i(t) ? "visible" : "hidden",
        transition: (t)=>$016a54341be00705$var$s(t)
    }
};

});
parcelRegister("3CEp6", function(module, exports) {

$parcel$export(module.exports, "computeTooltipPosition", () => $2a344319cc97bf1c$export$f6247ccfc3caa762);
$parcel$export(module.exports, "entranceOffset", () => $2a344319cc97bf1c$export$708043aba5a9c916);
const $2a344319cc97bf1c$var$w = 6, $2a344319cc97bf1c$var$h = (t, o, i)=>({
        bottom: i - t.bottom,
        top: t.top,
        right: o - t.right,
        left: t.left
    }), $2a344319cc97bf1c$var$_ = (t, o, i, m, f)=>{
    const s = $2a344319cc97bf1c$var$h(o, m, f), D = t === "top" || t === "bottom" ? i.height + 6 : i.width + 6;
    if (s[t] >= D) return t;
    const n = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
    }[t];
    return n && s[n] >= D ? n : t;
}, $2a344319cc97bf1c$var$e = (t, o, i)=>Math.max(o, Math.min(i, t)), $2a344319cc97bf1c$export$f6247ccfc3caa762 = (t, o, i = "bottom")=>{
    if (!t) return {
        left: 0,
        top: 0,
        side: "bottom"
    };
    const m = typeof window < "u" ? window.innerWidth : 1024, f = typeof window < "u" ? window.innerHeight : 768, s = $2a344319cc97bf1c$var$_(i, t, o, m, f);
    let D, n;
    return s === "bottom" || s === "top" ? (D = t.left + (t.width - o.width) / 2, n = s === "bottom" ? t.bottom + 6 : t.top - o.height - 6) : (n = t.top + (t.height - o.height) / 2, D = s === "right" ? t.right + 6 : t.left - o.width - 6), D = $2a344319cc97bf1c$var$e(D, 6, m - o.width - 6), n = $2a344319cc97bf1c$var$e(n, 6, f - o.height - 6), {
        left: D,
        top: n,
        side: s
    };
}, $2a344319cc97bf1c$var$b = {
    bottom: [
        "0",
        "-10%"
    ],
    top: [
        "0",
        "10%"
    ],
    left: [
        "10%",
        "0"
    ],
    right: [
        "-10%",
        "0"
    ]
}, $2a344319cc97bf1c$export$708043aba5a9c916 = (t)=>($2a344319cc97bf1c$var$b[t] || $2a344319cc97bf1c$var$b.bottom).join(" "), $2a344319cc97bf1c$export$a70b3e3f26af624b = (t)=>{
    const [o, i] = $2a344319cc97bf1c$var$b[t] || $2a344319cc97bf1c$var$b.bottom;
    return `translate3d(${o}, ${i}, 0)`;
};

});

parcelRegister("1ApNM", function(module, exports) {

$parcel$export(module.exports, "TOOLTIP_DEFAULTS", () => $127d2af3b4e93f66$export$751f94e03659412);
$parcel$export(module.exports, "isTipShown", () => $127d2af3b4e93f66$export$a126b40a9cda2821);
$parcel$export(module.exports, "isTooltipWarm", () => $127d2af3b4e93f66$export$53e28ee9e9e4cb92);
$parcel$export(module.exports, "openTooltip", () => $127d2af3b4e93f66$export$61f4b11807206216);
$parcel$export(module.exports, "closeTooltip", () => $127d2af3b4e93f66$export$6108d95d641a81fb);
const $127d2af3b4e93f66$export$751f94e03659412 = {
    placement: "bottom",
    theme: "dialog",
    delay: 250,
    hideDelay: 100,
    warmWindow: 300
}, $127d2af3b4e93f66$var$p = (t)=>{
    if (!t || typeof t != "object") return null;
    const e = Number(t.left), o = Number(t.top), n = Number(t.width ?? t.right - t.left), i = Number(t.height ?? t.bottom - t.top), r = {
        left: e,
        top: o,
        right: Number(t.right ?? e + n),
        bottom: Number(t.bottom ?? o + i),
        width: n,
        height: i
    };
    for(const l in r)if (!Number.isFinite(r[l])) return null;
    return r;
}, $127d2af3b4e93f66$var$d = (t)=>!t || typeof t.getBoundingClientRect != "function" ? null : $127d2af3b4e93f66$var$p(t.getBoundingClientRect()), $127d2af3b4e93f66$var$s = (t)=>t?.getRoot?.()?.TooltipRoot || null, $127d2af3b4e93f66$var$u = (t)=>{
    const e = t?.state?.tip;
    return e ? typeof e.$parse == "function" ? e.$parse() : {
        ...e
    } : null;
}, $127d2af3b4e93f66$export$a126b40a9cda2821 = (t)=>!!(t && t.open !== !1 && t.size), $127d2af3b4e93f66$export$53e28ee9e9e4cb92 = (t, e = Date.now())=>{
    const o = $127d2af3b4e93f66$var$s(t)?.state?.tip;
    return o ? o.open !== !1 ? !0 : typeof o.closedAt == "number" && e - o.closedAt < $127d2af3b4e93f66$export$751f94e03659412.warmWindow : !1;
}, $127d2af3b4e93f66$var$h = (t, e, o = 0)=>{
    const n = $127d2af3b4e93f66$var$u(t);
    if (!n || n.id !== e || n.open === !1) return;
    const i = t.Panel?.node;
    if (!i || typeof i.getBoundingClientRect != "function") return;
    if (i.textContent !== (n.text || "")) {
        o < 3 && setTimeout(()=>$127d2af3b4e93f66$var$h(t, e, o + 1), 0);
        return;
    }
    const r = i.getBoundingClientRect();
    t.state.update({
        tip: {
            ...n,
            size: {
                width: r.width,
                height: r.height
            }
        }
    });
}, $127d2af3b4e93f66$var$_ = (t)=>{
    typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t);
};
let $127d2af3b4e93f66$var$w = 0;
const $127d2af3b4e93f66$var$g = ()=>`tooltip_${++$127d2af3b4e93f66$var$w}_${Date.now().toString(36)}`;
function $127d2af3b4e93f66$export$61f4b11807206216(t = {}) {
    const e = $127d2af3b4e93f66$var$s(this);
    if (!e) return null;
    const o = t.anchorEl?.node || t.anchorEl, n = $127d2af3b4e93f66$var$p(t.anchorRect);
    t.anchorRect != null && n;
    const i = n || $127d2af3b4e93f66$var$d(o);
    if (!i) return null;
    const r = t.id || $127d2af3b4e93f66$var$g(), l = $127d2af3b4e93f66$var$u(e), a = $127d2af3b4e93f66$export$a126b40a9cda2821(l), f = {
        id: r,
        owner: t.owner || null,
        text: t.text || "",
        anchor: i,
        placement: t.placement || $127d2af3b4e93f66$export$751f94e03659412.placement,
        theme: t.theme || $127d2af3b4e93f66$export$751f94e03659412.theme,
        open: !0,
        glide: a,
        size: a ? l.size : null
    };
    return e.state.update({
        tip: f
    }), $127d2af3b4e93f66$var$_(()=>$127d2af3b4e93f66$var$h(e, r)), r;
}
function $127d2af3b4e93f66$export$6108d95d641a81fb(t) {
    const e = $127d2af3b4e93f66$var$s(this);
    if (!e) return;
    const o = $127d2af3b4e93f66$var$u(e);
    if (!o || o.open === !1) return;
    const n = typeof t == "string" ? t : t?.id;
    if (n && o.id && n !== o.id) return;
    const i = typeof t == "object" ? t?.owner : null;
    i && o.owner && i !== o.owner || e.state.update({
        tip: {
            ...o,
            open: !1,
            closedAt: Date.now()
        }
    });
}

});


parcelRegister("3Bl0e", function(module, exports) {

$parcel$export(module.exports, "TooltipTrigger", () => $29f51e83b96d5555$export$8c610744efcf8a1d);

var $1ApNM = parcelRequire("1ApNM");
const $29f51e83b96d5555$var$e = (o)=>{
    if (!o.tooltipText) return;
    const t = o.node;
    t && t.hasAttribute && t.hasAttribute("title") && t.removeAttribute("title");
};
let $29f51e83b96d5555$var$_ = 0;
const $29f51e83b96d5555$var$r = (o)=>o._tooltipOwner || (o._tooltipOwner = `tooltip_trigger_${++$29f51e83b96d5555$var$_}`), $29f51e83b96d5555$var$p = (o)=>{
    o.tooltipText && o.node?.isConnected !== !1 && ($29f51e83b96d5555$var$e(o), o.call("openTooltip", {
        anchorEl: o,
        anchorRect: o.tooltipAnchorRect || void 0,
        text: o.tooltipText,
        placement: o.tooltipPlacement || "bottom",
        theme: o.tooltipTheme,
        id: o.tooltipId || o.key,
        owner: $29f51e83b96d5555$var$r(o)
    }));
}, $29f51e83b96d5555$var$l = (o)=>{
    if (o._tooltipHideTimer && (clearTimeout(o._tooltipHideTimer), o._tooltipHideTimer = null), (0, $1ApNM.isTooltipWarm)(o)) {
        o._tooltipShowTimer && (clearTimeout(o._tooltipShowTimer), o._tooltipShowTimer = null), $29f51e83b96d5555$var$p(o);
        return;
    }
    o._tooltipShowTimer || (o._tooltipShowTimer = setTimeout(()=>{
        o._tooltipShowTimer = null, $29f51e83b96d5555$var$p(o);
    }, o.tooltipDelay ?? (0, $1ApNM.TOOLTIP_DEFAULTS).delay));
}, $29f51e83b96d5555$var$T = (o)=>{
    o._tooltipShowTimer && (clearTimeout(o._tooltipShowTimer), o._tooltipShowTimer = null), !o._tooltipHideTimer && (o._tooltipHideTimer = setTimeout(()=>{
        o._tooltipHideTimer = null, o.call("closeTooltip", {
            id: o.tooltipId || o.key,
            owner: $29f51e83b96d5555$var$r(o)
        });
    }, o.tooltipHideDelay ?? (0, $1ApNM.TOOLTIP_DEFAULTS).hideDelay));
}, $29f51e83b96d5555$var$m = (o)=>{
    o._tooltipShowTimer && clearTimeout(o._tooltipShowTimer), o._tooltipHideTimer && clearTimeout(o._tooltipHideTimer), o._tooltipShowTimer = null, o._tooltipHideTimer = null, o.call("closeTooltip", {
        id: o.tooltipId || o.key,
        owner: $29f51e83b96d5555$var$r(o)
    });
}, $29f51e83b96d5555$export$8c610744efcf8a1d = {
    onMouseenter: (o, t)=>$29f51e83b96d5555$var$l(t),
    onMouseleave: (o, t)=>$29f51e83b96d5555$var$T(t),
    onFocus: (o, t)=>$29f51e83b96d5555$var$l(t),
    onBlur: (o, t)=>$29f51e83b96d5555$var$T(t),
    onKeydown: (o, t)=>{
        if (o.key !== "Escape" || o.defaultPrevented) return;
        const i = t.getRoot()?.TooltipRoot?.state?.tip;
        !t._tooltipShowTimer && !(i && i.open !== !1 && i.owner === t._tooltipOwner) || (o.preventDefault(), $29f51e83b96d5555$var$m(t));
    },
    onRemove: {
        always: !0,
        handler: $29f51e83b96d5555$var$m
    },
    onMouseover: (o, t)=>$29f51e83b96d5555$var$e(t),
    onFocusin: (o, t)=>$29f51e83b96d5555$var$e(t)
};

});

parcelRegister("4WQ3w", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $39a4f56d134c5c75$export$28c660c63b792dea);
$parcel$export(module.exports, "TooltipHidden", () => $39a4f56d134c5c75$export$92ba62bde414cbb2);
$parcel$export(module.exports, "TooltipParent", () => $39a4f56d134c5c75$export$1d54d90a050b9c15);
const $39a4f56d134c5c75$export$28c660c63b792dea = {
    display: "flex",
    theme: "dialog",
    flow: "column",
    shape: "tooltip",
    shapeDirection: "left",
    padding: "Z1 A",
    round: "Y2",
    width: "fit-content",
    minWidth: "D2",
    maxWidth: "F2",
    gap: "X",
    textAlign: "center",
    attr: {
        tooltip: !0
    },
    Title: {
        if: (t)=>t.call("isDefined", t.parent.title) || t.parent.title,
        width: "fit-content",
        fontWeight: 500,
        color: "currentColor",
        text: (t)=>t.parent.title
    },
    P: {
        if: (t, i)=>t.call("isDefined", t.call("exec", t.parent.description, t)) || t.text,
        width: "fit-content",
        fontSize: "Z2",
        margin: "0",
        color: "currentColor",
        fontWeight: "400",
        text: (t, i)=>t.call("exec", t.parent.description, t)
    }
}, $39a4f56d134c5c75$export$92ba62bde414cbb2 = {
    extends: "Tooltip",
    position: "absolute",
    pointerEvents: "none",
    opacity: "0",
    visibility: "hidden",
    transition: "C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform",
    onInit: (t)=>{
        const i = !t.shapeDirection || t.shapeDirection === "top" ? {
            top: "112%",
            left: "50%",
            transform: "translate3d(-50%,10%,0)",
            ".isActive": {
                transform: "translate3d(-50%,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "right" ? {
            transform: "translate3d(10%,-50%,0)",
            left: "112%",
            top: "50%",
            ".isActive": {
                transform: "translate3d(0%,-50%,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "bottom" ? {
            transform: "translate3d(-50%,-10%,0)",
            bottom: "112%",
            left: "50%",
            ".isActive": {
                transform: "translate3d(-50%,0,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : t.shapeDirection === "left" ? {
            transform: "translate3d(10%,-50%,0)",
            right: "112%",
            top: "50%",
            ".isActive": {
                transform: "translate3d(0%,-50%,0)",
                opacity: 1,
                visibility: "visible"
            }
        } : {};
        Object.assign(t, i);
    },
    style: (t)=>{
        if (!t.scope || !t.scope.tooltipOpen) return {
            opacity: "",
            visibility: "",
            transform: ""
        };
        const i = t.shapeDirection;
        return {
            opacity: "1",
            visibility: "visible",
            transform: i === "left" || i === "right" ? "translate3d(0%,-50%,0)" : "translate3d(-50%,0,0)"
        };
    },
    styleDeps: [
        (t)=>t.scope && t.scope.tooltipOpen
    ]
}, $39a4f56d134c5c75$export$1d54d90a050b9c15 = {
    position: "relative",
    zIndex: 999,
    scope: {
        tooltipOpen: !1
    },
    onInit: (t)=>{
        const { Tooltip: i, TooltipHidden: e } = t, o = i || e;
        if (!o) return;
        const n = o && o[".isActive"];
        Object.assign(t, {
            ":hover, &:focus-visible": {
                zIndex: 1e3,
                "& [tooltip]": n || {
                    transform: "translate3d(-50%, 0, 0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        });
    },
    onPointerdown: (t, i)=>{
        t.pointerType !== "touch" || !i.scope || (i.scope.tooltipOpen = !i.scope.tooltipOpen);
    },
    onDocumentKeydown: (t, i)=>{
        t.key !== "Escape" || !i.scope || !i.scope.tooltipOpen || (i.scope.tooltipOpen = !1);
    },
    onDocumentPointerdown: (t, i)=>{
        !i.scope || !i.scope.tooltipOpen || i.node && i.node.contains(t.target) || (i.scope.tooltipOpen = !1);
    }
};

});


parcelRegister("kFXIL", function(module, exports) {

$parcel$export(module.exports, "tooltipFunctions", () => $f0d5f652c83bf80a$export$26dadd89fe543861);

var $1ApNM = parcelRequire("1ApNM");

const $f0d5f652c83bf80a$export$26dadd89fe543861 = {
    openTooltip: (0, $1ApNM.openTooltip),
    closeTooltip: (0, $1ApNM.closeTooltip)
};

});


parcelRegister("ljS9v", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("hXwmN"))) : import("hXwmN")).then(()=>parcelRequire('8qjQy'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("3waBY", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("ePbub"))) : import("ePbub")).then(()=>parcelRequire('9UXwK'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

parcelRegister("6Qr8E", function(module, exports) {
// smbls: a failed load is asked for again, under a fresh address (XMA round 6, item 6)
var $smblsAttempt = 0;
var $smblsLoading = null;
var $smblsAddress = function(url) {
    return $smblsAttempt ? url + (url.indexOf('?') === -1 ? '?' : '&') + 'smbls-retry=' + $smblsAttempt : url;
};
Object.defineProperty(module, "exports", {
    configurable: true,
    enumerable: true,
    get: function() {
        if ($smblsLoading) return $smblsLoading;
        var loading = $smblsLoading = ($smblsAttempt ? import($smblsAddress(import.meta.resolve("9sMJI"))) : import("9sMJI")).then(()=>parcelRequire('9uVnS'));
        loading.catch(function() {
            if ($smblsLoading === loading) {
                $smblsLoading = null;
                $smblsAttempt++;
            }
        });
        return loading;
    }
});

});

/**
 * Workspace shell — unified Parcel entry.
 *
 * Boot sequence (mirrors RUNNER_ARCHITECTURE.md §Boot sequence):
 *  1. Early lang/theme from localStorage (synchronous, first-paint)
 *  2. bootShell: polyglot init → ensureSDKInit → registerSdkAdapter
 *     → auth gate → eager USER/ORG/WORKSPACE/WP fetch → mount shell
 *  3. dispatchUrl: initial route → lazy-load sub-app or shared page into Slot
 *  4. wireGlobalListeners: popstate + cross-tab storage events
 *
 * Phase 8: app manifests imported from each sub-app package.
 * Each manifest declares key, routes, i18nNamespaces, app/context lazy
 * imports, and optional fetchOnMount / onParamsChange lifecycle hooks.
 */ // WHITELABEL-1 layer 4 (tickets/opus.md) — MUST stay the very first import
// in this file. It forces MWT off (no `/w/<org>` prefix, ever) on a
// host-resolved (custom-domain) boot, before anything else in the boot
// graph can read+cache the MWT flag. See rootMappedBoot.js's own header for
// the full ordering rationale — do not reorder this above the imports it
// currently sits above; it must stay above them.
// WHITELABEL-1 layer 4 — root-mapped boot (the shell half of "serve the
// bellforge workspace at app.bellforge.eu"). Ticket: tickets/opus.md
// WHITELABEL-1. Server half (layers 1+3) shipped in `server 4fbe1ba0` and is
// consumed here, not re-derived — see functions/customDomainHost.js's
// header for the exact boundary.
//
// Deliberately a ROOT-level shell file (sibling to index.js/app.js/
// config.js), NOT inside functions/ — this package's owning charter splits
// "Shell" (index.js, app.js, config.js, routes.js, …) from "Frank-discovered
// folders only: components/, pages/, functions/, methods/, snippets/, …".
// This file's whole job is a bare MODULE-TOP-LEVEL side effect (see below),
// which is exactly the FA514 "module-side-effect bridge" pattern frank
// strips when it serializes a functions/*.js file's exports to JSON. Living
// at the package root instead keeps it in the same bucket as index.js's own
// existing top-level side effects (`const _redirecting = redirectIfUnauthed(
// …)`, the top-level `void import('smbls')`, the boot IIFE) — literal
// Parcel-bundled JS, never round-tripped through frank's JSON schema.
//
// On a host-resolved boot (custom domain, not a `/w/<org>` URL path) `/` IS
// the workspace: no Scheme-A `/w/<org>` prefix anywhere, ever. The cleanest
// way to guarantee that is to make sure Scheme-A NEVER ACTIVATES on this
// host at all, rather than adding a second "strip the prefix on the way out"
// mechanism — MWT (multi-workspace-tabs, shared/functions/mwtFlag.js) is the
// ONE thing that emits/consumes the `/w/<org>` prefix (mwtRouter.js
// `planMwtNav` returns null — a transparent pass-through — whenever
// `isMwtEnabled()` is false), and it already ships a supported, documented
// per-origin opt-out: `localStorage.setItem('mwt', 'off')`. Because a custom
// domain is a SEPARATE browser origin from my.symbols.app, writing that key
// here can never bleed into (or be bled into by) the platform host's own
// localStorage — this is purely additive to my.symbols.app/w/<org>, which
// this file never touches (isCustomDomainHost() is false there).
//
// MUST run before the first `isMwtEnabled()` call anywhere in the boot
// (its resolved value is cached for the life of the tab — mwtFlag.js
// `globalThis.__mwtFlagCache`). That is the ONLY reason this is its own
// file: index.js imports it as the very first import statement, ahead of
// the `@symbo-ls/workspace-shared` import whose module graph is what
// actually calls `isMwtEnabled()` (via context.js → mwtRouter registration)
// during bootShell/create(). ES module imports execute in the order their
// import declarations appear when there's no cross-dependency forcing
// otherwise, so this side effect lands first. Self-contained (no sibling
// imports) is deliberate too — the earlier this can execute, the safer.
//
// An explicit per-load `?mwt=1`/`?mwt=on` still wins for THAT tab
// (mwtFlag.js checks the query string before localStorage), so a debug
// session can still force MWT on over this default without fighting it —
// this only sets the DEFAULT a fresh load with no override resolves to.

var $lb2Ei = parcelRequire("lb2Ei");
try {
    if (typeof window !== 'undefined' && (0, $lb2Ei.isCustomDomainHost)() && window.localStorage?.getItem('mwt') !== 'off') window.localStorage.setItem('mwt', 'off');
} catch (_) {
// localStorage may throw in sandboxed contexts — worst case MWT stays on
// and a host-resolved boot could compose a `/w/<org>` URL; never let this
// module crash the boot over it.
}


// Dev-only API-channel pin — MUST stay the SECOND import of index.js
// (right after rootMappedBoot.js, which owns slot 1 for the whitelabel MWT
// contract and never reads @symbo.ls/channels), so it runs before anything
// in the @symbo-ls/workspace-shared graph can memoize currentChannel().
//
// Replaces the old inline <script> pin in index.html. That script could not
// read the launcher's SYMBOLS_API_CHANNEL — Parcel does NOT substitute
// process.env inside classic inline scripts (probed 2026-08-26: the literal
// survives into the built HTML) — so it defaulted to 'local' and PERSISTED
// it into localStorage.symbols_api_channel on every param-less load. That
// stale 'local' pin is why channels-direct consumers kept dialing
// http://localhost:8080 (connection refused on machines with no local
// server) even when ?channel=development and the env pin had the SDK
// correctly on dev.api.
//
// Precedence — mirrors workspaceApiBase.js rungs 1/2/5 exactly:
//   1. ?channel=<name>       per-tab choice; the ONLY thing we persist
//   2. SYMBOLS_API_CHANNEL   launcher env, inlined by Parcel ('dev' aliases
//                            to 'development'); per-process, never persisted
//   3. stored localStorage   an earlier explicit per-tab choice
//   4. 'development'         the team default (Nika, 2026-08-25)
// Non-local hosts never enter this block — deployed surfaces keep resolving
// by hostname. setChannel() also invalidates channels' memo, so ordering
// bugs fail soft instead of pinning a stale read.

var $hmkNw = parcelRequire("hmkNw");
try {
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    const isLocalHost = host === 'localhost' || host.endsWith('.localhost');
    if (isLocalHost) {
        const urlChannel = new URLSearchParams(window.location.search).get('channel');
        let envChannel = null;
        try {
            envChannel = null;
        } catch (_) {
        /* no bundler substitution — leave null */ }
        if (envChannel === 'dev') envChannel = 'development';
        let stored = null;
        try {
            stored = window.localStorage.getItem('symbols_api_channel');
        } catch (_) {
        /* sandboxed storage — ignore */ }
        const pick = (name)=>name && (0, $hmkNw.isKnownChannel)(name) ? name : null;
        const channel = pick(urlChannel) || pick(envChannel) || pick(stored) || 'development';
        (0, $hmkNw.setChannel)(channel);
        if (pick(urlChannel)) try {
            window.localStorage.setItem('symbols_api_channel', urlChannel);
        } catch (_) {
        /* sandboxed storage — the per-tab pin still applied above */ }
    }
} catch (_) {
/* the dev pin must never block boot */ }



var $1X0Je = parcelRequire("1X0Je");
/**
 * wireGlobalListeners — popstate handler + cross-tab storage events.
 *
 * Called once after the shell mounts and the initial dispatch has run.
 *
 * Handles:
 *   - popstate: re-dispatch on browser back/forward
 *   - storage 'activeOrg': switchOrg (cross-tab)
 *   - storage 'activeWorkspace': switchWorkspace (cross-tab)
 *   - storage 'activeWorkspaceProject': switchWorkspaceProject (cross-tab)
 *   - storage 'logout': clear all state + redirect to /login
 *   - storage 'themeMode': update <html data-theme> + state
 *   - storage 'lang': call setLang with skipPersist (avoid echo loop)
 *
 * Not here: the keyboard and mailto: clicks. The shell's one keydown listener
 * is the shell root's declared `onDocumentKeydown`, and the in-app mail
 * composer for a plain mailto: click is its declared `onDocumentClick`
 * (app.js, functions/mailtoComposeDefault.js) — never a raw listener (FA503).
 */ // APP_DISPATCH table — flat URL → page lookup. First match wins, ordered
// most-specific to most-general.
//
// Sub-app pages live in the unified `pages` map (built in context.js) and
// the smbls auto-router mounts the matched page directly into Slot via
// `customRouterElement: ['Slot']`. Cross-cutting chrome (AppAssistant,
// ChatDrawer, InstallableModalStub) lives on the shell's app.js so it's
// available regardless of which sub-app's page is active.
//
// `page:` entries here cover shell-direct surfaces (auth/account/admin)
// that aren't in any sub-app's pages map.
const $aa459d7429e990ae$export$1cb272df1e4c0433 = [
    // Shell-direct pages — these aren't in sub-app pages maps because
    // they're shared chrome surfaces (login, account settings, admin).
    {
        match: [
            '/login',
            '/signup',
            '/forgot-password',
            '/verify-email'
        ],
        page: 'auth'
    },
    {
        match: [
            '/profile',
            '/orgs'
        ],
        page: 'account'
    },
    {
        match: /^\/account(\/|$)/,
        page: 'account'
    },
    {
        match: /^\/admin(\/|$)/,
        page: 'admin'
    },
    // WORKSPACE-ROUTING-PROJECTS-404: `/projects` previously mapped to a
    // bogus `profile` import that rendered the user profile page (and
    // titled the tab "Not found / Symbols.app" once the auto-router fell
    // through). The canonical projects list lives at `/data/projects` —
    // redirect there so any leftover `/projects` link reaches the right
    // surface. `/workspaces` had the same wrong-page bug; collapse both
    // onto `/data/projects` (workspace = the canonical org-level
    // container, projects = the rows shown in that view).
    {
        match: [
            '/projects',
            '/workspaces'
        ],
        redirect: '/data/projects'
    }
];
const $aa459d7429e990ae$export$127cac04d022610d = (path, table = $aa459d7429e990ae$export$1cb272df1e4c0433)=>{
    for (const entry of table){
        const m = entry.match;
        if (Array.isArray(m) && m.includes(path)) return entry;
        if (typeof m === 'string' && m === path) return entry;
        if (m instanceof RegExp && m.test(path)) return entry;
    }
    return null;
};



const $aa459d7429e990ae$export$ccd9f85f09e2ee22 = {
    auth: ()=>Promise.resolve((parcelRequire("1X0Je"))).then((m)=>m.default.pages.login),
    account: ()=>Promise.resolve((parcelRequire("1X0Je"))).then((m)=>m.default.pages.account),
    admin: ()=>(parcelRequire("6BQ98")).then((m)=>m.admin)
};
const $aa459d7429e990ae$export$4edaf5fea8e0a2d4 = async (shell, path)=>{
    const target = $aa459d7429e990ae$export$127cac04d022610d(path);
    if (!target) return;
    if (target.redirect) {
        // replaceState alone doesn't trigger smbls's auto-router; dispatch a
        // synthetic popstate so it re-evaluates against the canonical path.
        if (typeof window !== 'undefined' && window.history?.replaceState) {
            try {
                window.history.replaceState(null, '', target.redirect);
            } catch (_) {}
            try {
                window.dispatchEvent(new PopStateEvent('popstate'));
            } catch (_) {}
        }
        return;
    }
    if (target.page) {
        const importFn = $aa459d7429e990ae$export$ccd9f85f09e2ee22[target.page];
        if (importFn) {
            const page = await importFn().catch(()=>null);
            if (page && shell.Slot) shell.Slot.set?.(page);
        }
    }
};



var $lb2Ei = parcelRequire("lb2Ei");

var $1X0Je = parcelRequire("1X0Je");
const $51ae01d34a94b835$var$switchOrg = (...args)=>(0, $1X0Je.default).functions.switchOrg(...args);
const $51ae01d34a94b835$var$switchWorkspace = (...args)=>(0, $1X0Je.default).functions.switchWorkspace(...args);
const $51ae01d34a94b835$var$switchWorkspaceProject = (...args)=>(0, $1X0Je.default).functions.switchWorkspaceProject(...args);
const $51ae01d34a94b835$var$logout = (...args)=>(0, $1X0Je.default).functions.logout(...args);
const $51ae01d34a94b835$var$normalizeThemeMode = (...args)=>(0, $1X0Je.default).functions.normalizeThemeMode(...args);
const $51ae01d34a94b835$var$shellIsMwtEnabled = (...args)=>(0, $1X0Je.default).functions.isMwtEnabled(...args);

const $51ae01d34a94b835$export$65f3055c61a76812 = (shell, { apps: apps, fallbackRoute: fallbackRoute = '/' } = {})=>{
    // --- popstate ---
    window.addEventListener('popstate', async ()=>{
        const path = window.location.pathname + window.location.search;
        await (0, $aa459d7429e990ae$export$4edaf5fea8e0a2d4)(shell, path);
    });
    // The keyboard is NOT wired here: the shell's one keydown listener is the
    // shell root's declared `onDocumentKeydown` (app.js — registry + guard in
    // functions/shortcuts.js), so DOMQL owns its lifecycle (FA503).
    // mailto: clicks are NOT wired here: the in-app composer is the DEFAULT
    // action of a plain mailto click, the shell root's declared
    // `onDocumentClick` (app.js — functions/mailtoComposeDefault.js). The raw
    // CAPTURE listener that lived here ran before every surface's own handler
    // and stopped the click, so a surface could never keep its mailto link.
    // --- cross-tab storage events ---
    window.addEventListener('storage', async (e)=>{
        // Null new value means the key was removed — ignore.
        if (e.newValue === null) return;
        const state = shell.state?.root || shell.state;
        // Lazy-resolve SDK + queryClient from context so we don't need to pass
        // them as parameters. The shell's context is attached by bootShell.
        const sdk = shell.context?.sdk || null;
        const queryClient = shell.context?.queryClient || null;
        // Note: no `activeOrg` cross-tab branch — active org is sourced
        // from Mongo (`User.activeOrganization`) and synced cross-tab via
        // socket.io `active-org-changed` in `subscribeUserEvents` (wired
        // by `workspace/app.js shellApp.onCreate`), not localStorage.
        if (e.key === 'activeWorkspace' && state?.workspace?.id !== e.newValue) {
            // I6 (§6c): under MWT this tab is PINNED to its own workspace from boot —
            // never let another tab's switch (a shared-key `storage` event) drag it off.
            // Gate on the flag itself, NOT the URL: the `/w/<slug>` prefix is absent
            // during the pre-canonicalize boot window, so a URL check would leave that
            // window unguarded (the boot-window race). No-op while the flag is off.
            if ($51ae01d34a94b835$var$shellIsMwtEnabled()) return;
            // WHITELABEL-STRICT-TENANT-SCOPE-1 — a white-label host serves ONE
            // workspace; no other tab may switch this one to a different workspace.
            if ((0, $lb2Ei.isCustomDomainHost)()) return;
            if (sdk && queryClient) await $51ae01d34a94b835$var$switchWorkspace(state, sdk, queryClient, e.newValue);
        }
        if (e.key === 'activeWorkspaceProject' && state?.workspaceProject?.id !== e.newValue) {
            if (sdk && queryClient) await $51ae01d34a94b835$var$switchWorkspaceProject(state, sdk, queryClient, e.newValue);
        }
        if (e.key === 'logout') {
            // Another tab signed out — mirror the logout locally.
            if (sdk && queryClient) await $51ae01d34a94b835$var$logout(state, sdk, queryClient);
            else window.history.replaceState(null, '', '/login');
        }
        if (e.key === 'themeMode') {
            // changeGlobalTheme flips data-theme (scratch resolves 'auto' and
            // attaches its prefers-color-scheme listener). Theme visuals are
            // '@dark'/'@light' CSS, and the canvas-bg cookie var re-syncs via
            // the document-level data-theme watcher — nothing else to do here.
            //
            // Dynamic-imported: this only fires on a cross-tab 'storage' event
            // (another tab flipped the theme), never on the boot path, so a
            // static top-level `import { changeGlobalTheme } from 'smbls'` here
            // would drag the whole framework bundle into the eager entry chunk
            // for a listener branch that may never fire in a session. index.js
            // already warms this exact chunk (`void import('smbls')`) at entry,
            // so this resolves instantly once it's actually needed.
            const mode = $51ae01d34a94b835$var$normalizeThemeMode(e.newValue);
            const { changeGlobalTheme: changeGlobalTheme } = await Promise.resolve((parcelRequire("eY4Ct")));
            changeGlobalTheme(mode);
            if (state) state.themeMode = mode;
        }
        if (e.key === 'lang' && e.newValue && state?.lang !== e.newValue) {
            // Cross-tab language sync. This read used to be
            // `shell.context?.methods?.setLang`, and it NEVER resolved: `setLang`
            // is exported from the shared `functions/` barrel, never from
            // `methods/`, so the branch always fell through to the bare
            // `state.lang = …` below. That assignment changes the state field and
            // nothing else — no bundle load, no <html lang>/dir, no polyglot
            // switch — so a language change in one tab left every other tab
            // rendering the old language with the new code in its state.
            //
            // `el.call` is the right resolver: smbls's methods.js `call()` walks
            // context.methods -> context.functions -> context.utils and invokes
            // with `this` bound to the element. That binding is now REQUIRED —
            // `setLang` reads the element to reach `context.polyglot` and the root
            // state, and it is a function declaration precisely so it can.
            if (typeof shell?.call === 'function') await shell.call('setLang', e.newValue, {
                skipPersist: true
            });
            else if (state) state.lang = e.newValue;
        }
    });
};


/**
 * armAuthShellModalHost — arm the deferred modal host on the SIGNED-OUT shell.
 *
 * The shell mounts `ModalRoot` behind `if: s.root._modalHostReady` (app.js),
 * and the only writer of that key is the shared `bootApply`, which runs after
 * a SIGNED-IN `bootResolve`. A signed-out boot aborts before it, and index.js
 * mounts its own auth shell instead — so that shell's `ModalRoot` never
 * mounted. Sign-up and sign-in then continue in the SAME shell as a SPA (no
 * reboot), and every `confirmDialog` / `openModal` pushed its layer onto a host
 * with no node: no dialog, no message, no request (persona round 5, elena:
 * "Add to Workspace" on a fresh account's first built app did nothing).
 *
 * The arm keeps bootApply's rules: the host builds OUTSIDE the mount task, on
 * one macrotask after `create()` returns, so the login's first paint does not
 * pay for it. A macrotask, never a frame: a hidden tab has no frame to wait
 * for. A hidden tab also clamps its timers (1 s, then 1/min), so it arms on a
 * MessageChannel tick — a macrotask that is not throttled.
 *
 * Returns true when an arm was scheduled.
 */ const $0a18f1a5e29a0bc7$export$17fa4bc1739d7bd = (shell, win = typeof window !== 'undefined' ? window : null)=>{
    const root = shell && shell.state ? shell.state.root || shell.state : null;
    if (!root || typeof root.update !== 'function') return false;
    if (root._modalHostReady) return false;
    const arm = ()=>{
        if (root._modalHostReady) return;
        root.update({
            _modalHostReady: true
        }, {
            preventFetch: true
        });
    };
    const doc = win && win.document;
    const Channel = win && win.MessageChannel;
    if (doc && doc.visibilityState === 'hidden' && typeof Channel === 'function') {
        const ch = new Channel();
        ch.port1.onmessage = ()=>{
            ch.port1.close();
            arm();
        };
        ch.port2.postMessage(0);
    } else if (win && typeof win.setTimeout === 'function') win.setTimeout(arm, 0);
    else arm();
    return true;
};



var $qJ3f5 = parcelRequire("qJ3f5");
var $kuISg = parcelRequire("kuISg");

var $1nnHq = parcelRequire("1nnHq");

var $cKmtB = parcelRequire("cKmtB");

var $7muxD = parcelRequire("7muxD");
// After bootShell returns: converge a workspace record that is still
// LIST-shaped to the full record.
//
// On a warm boot the first auth tick no longer upgrades the snapshot's list
// placeholder (functions/auth.js, `_warmPlaceholderHeld`) - bootShell's
// `boot-warm-reconcile` writes the composite boot's full record instead. When
// that reconcile resolved nothing (boot failed, no scope), the placeholder
// would stay list-shaped with nobody scheduled to complete it, so index.js
// calls this once bootShell has returned. On the common path the record is
// already full and this does nothing (no request); otherwise it hands the held
// record to the guarded setter, whose list->full upgrade goes through the
// shared getWorkspaceCached (one request at most, coalesced).
const $8a3905e28d3faf89$export$a29a8784ed1ae6cf = (root, { sdk: sdk, getWorkspaceCached: getWorkspaceCached, setActiveWorkspaceRecord: setActiveWorkspaceRecord } = {})=>{
    const ws = root && root.workspace;
    if (!ws || ws._shape === 'full' || ws._completionUnreachable) return false;
    if (typeof setActiveWorkspaceRecord !== 'function') return false;
    setActiveWorkspaceRecord(root, ws, {
        reason: 'boot-returned-converge',
        sdk: sdk,
        getWorkspaceCached: getWorkspaceCached
    });
    return true;
};


// Boot module prefetch gate (perf/shell-boot, 2026-10-09).
//
// The composite /core/boot answer carries the tab's FULL workspace record —
// settings.workspaceModule included — long before the shell has mounted and
// the workspace turned authoritative (measured live on staging
// /w/vault/default: boot answered at ~4.0 s, the module's first read went out
// at 9.6 s). bootShell hands every boot row to `primeWorkspaceCache`; the hook
// below keeps that contract and, for the ONE record this boot resolves for the
// tab, starts `prefetchWorkspaceModule` (workspaceProjects.js) — fetch only,
// nothing injected. loadWorkspaceProject later joins the same flight.
//
// Imported by index.js only (like convergeBootWorkspace.js) — never through
// the functions barrel, so nothing can `el.call` it.
// Can this record be proven to be the workspace this boot resolves for the
// tab? Mirrors the first rungs of shared resolveActiveWorkspace: the pointer
// the /core/boot request carried, and the URL scope, which wins over the
// pointer. Anything it cannot prove is a "no" — the regular takeover pass then
// loads the module exactly as before.
//   wsId      the id the record is primed under
//   record    the full workspace record
//   pointer   the active-workspace pointer (what sdk.boot was asked for)
//   segments  { orgSlug, seg2 } — shared getWorkspaceRawSegments(pathname)
//   orgs      [{ id|_id, slug }] — the session's orgs, to resolve the URL org
const $329083d02ed20916$export$850b21233092caac = ({ wsId: wsId, record: record, pointer: pointer, segments: segments, orgs: orgs } = {})=>{
    if (!wsId || !record || !pointer) return false;
    if (String(wsId) !== String(pointer)) return false;
    const orgSlug = segments && segments.orgSlug;
    const seg2 = segments && segments.seg2;
    // No `/w/<org>` scope: the pointer IS this boot's workspace.
    if (!orgSlug) return true;
    // `/w/<org>` alone resolves HQ-or-pointer from lists the hook does not hold.
    if (!seg2) return false;
    // Review D4: a handle is not unique across orgs (each org may have a
    // "default"), so the URL's ORG must be this record's org first.
    const idOf = (v)=>v && typeof v === 'object' ? v._id || v.id : v;
    const org = Array.isArray(orgs) ? orgs.find((o)=>o && String(o.slug || '').toLowerCase() === String(orgSlug).toLowerCase()) : null;
    const recOrg = idOf(record.organization || record.organizationId || record.org_id || record.org);
    if (!org || !idOf(org) || !recOrg || String(idOf(org)) !== String(recOrg)) return false;
    // `/w/<org>/<handle>`: the handle must name this record (the same
    // slug → key → id precedence the URL canonicalizer writes). A route
    // segment on the org's HQ also lands here and is a "no".
    const want = String(seg2).toLowerCase();
    return [
        record.slug,
        record.key,
        record._id,
        record.id
    ].some((v)=>v !== undefined && v !== null && v !== '' && String(v).toLowerCase() === want);
};
const $329083d02ed20916$export$dc91c4118c799088 = (prime, deps)=>(wsId, record)=>{
        const primed = prime(wsId, record);
        if (!primed) return primed;
        try {
            const allowed = $329083d02ed20916$export$850b21233092caac({
                wsId: wsId,
                record: record,
                pointer: deps.getPointer(),
                segments: deps.getSegments(),
                orgs: deps.getOrgs ? deps.getOrgs() : null
            });
            if (allowed) deps.prefetch(deps.getSdk(), wsId, record);
        } catch (err) {
            console.warn('[workspace] boot module prefetch skipped', err && err.message);
        }
        return primed;
    };



var $7ytvD = parcelRequire("7ytvD");

var $ly0mS = parcelRequire("ly0mS");

var $hkFDz = parcelRequire("hkFDz");
// whitelabelBrand.js — the PRE-AUTH half of the white-label chain
// (WHITELABEL-BRANDED-BOOT-1, tickets/opus.md).
//
// ── Why this is separate from customDomainBoot.js ────────────────────────
// `bootCustomDomainScope` (customDomainBoot.js) answers "which /w/<org>/<ws>
// URL does this host mean" and is POST-AUTH by construction: it waits for
// `root.orgs`, which `loadPrivateData` only populates once a user is signed
// in. Branding has the opposite requirement — the branded LOADER paints
// during boot and the branded LOGIN paints for a logged-OUT visitor, so it
// must resolve before any authenticated fetch exists. Same endpoint, same
// fail-closed contract, different moment; merging them would deadlock one or
// the other. The scope route is deliberately public and unauthenticated for
// exactly this reason (server organizations.js:31).
//
// ── Never hardcode ───────────────────────────────────────────────────────
// Every visual here comes from the org's `branding` record returned by that
// endpoint. Nothing in this file (or its consumers) knows what "bellforge"
// is — the same code serves the next white-label org with a record and no
// deploy. Contract, all display-only (the server projects away persona user
// ids and omits `personaSignins` unless the org enables them):
//   { name, tagline, logoSvg, loaderLogoSvg, accent, background, theme,
//     personaSignins: [{ key, label }] }
//
// Plus the SIBLING scope fields this lookup carries through so consumers need
// no second request: `workspaceKey`, `organizationId`, `workspaceId`, and
// `workspaceLanguage: { language, languagePolicy }` — the workspace's
// enforced-language pair, read by `enforcedWorkspaceLang`.
//
// ⚠️ A host with an enforced language but NO presentational branding gets
// `null` from the guard below and therefore no pre-auth enforcement. That is
// the pre-existing "a record with nothing to show is not a brand" contract,
// and it costs nothing real: a branded host has branding by definition, and
// the live workspace record enforces the same language a step later.
//
// ── Bounded, and never a boot gate ───────────────────────────────────────
// `seedWhitelabelBrand` races a short timeout so a slow/dead lookup can
// never delay the mount — the exact hazard themeMode.js's `resolveBootThemeMode`
// documents (trading a cosmetic default for a blank page). Whatever misses
// the race still lands via `applyWhitelabelBrandLate` on the live root, and
// every consumer reads it reactively, so a late brand simply swaps in.
// Platform hosts never fetch at all: byte-identical to today.

var $1X0Je = parcelRequire("1X0Je");

var $lb2Ei = parcelRequire("lb2Ei");

var $gNttC = parcelRequire("gNttC");
// Read through the shared package at CALL time, never captured at module
// scope (customDomainBoot.js's idiom): the barrel's default is not safe to
// destructure while the shared-barrel init cycle runs.
const $604bacc76c5090c8$var$shellSetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspacePointer(...args);
const $604bacc76c5090c8$var$shellResolveLang = (...args)=>(0, $1X0Je.default).functions.resolveLang(...args);
const $604bacc76c5090c8$var$shellEnforcedWorkspaceLang = (...args)=>(0, $1X0Je.default).functions.enforcedWorkspaceLang(...args);
// One in-flight request per page load. The brand and the host's TENANT are
// two halves of the SAME response, so every consumer below (the brand seed,
// the late apply, the tenant seed) shares this one promise.
let $604bacc76c5090c8$var$_lookupPromise = null;
// The brand half, with its once-per-load side effects (boot identity cache,
// favicon) applied exactly once however many consumers ask.
let $604bacc76c5090c8$var$_brandPromise = null;
const $604bacc76c5090c8$var$NO_LOOKUP = Object.freeze({
    scope: null,
    brand: null
});
/**
 * The TENANT a white-label host is bound to, from the scope payload, or null.
 *
 * WHITELABEL-STRICT-TENANT-SCOPE-1 — why this is NOT read off the brand.
 * The tenant ids used to ride along on the brand object only, and the brand
 * is null for an org with no presentational record ("a record with nothing to
 * show is not a brand", below). So every UNBRANDED white-label host lost its
 * tenant: nothing scoped the boot snapshot or the auth tick, and the shell
 * booted the account's ambient org under the customer's domain. Measured on
 * unreal.pr.symbols.app 2026-10-15: the Unreal org has `branding: {}`, the
 * signed-in account's stored active org was Keepz, and /studio drew Keepz's
 * projects. Branding is presentation; the tenant is isolation. One must never
 * depend on the other.
 *
 * Both ids are required: the server resolves a host only through a verified
 * row that names a workspace, so a payload without both is not a binding.
 */ const $604bacc76c5090c8$var$scopeFromPayload = (data)=>{
    if (!data || typeof data !== 'object') return null;
    if (!data.organizationId || !data.workspaceId) return null;
    return {
        organizationId: String(data.organizationId),
        workspaceId: String(data.workspaceId),
        workspaceKey: data.workspaceKey ? String(data.workspaceKey) : null,
        domain: data.domain ? String(data.domain) : null
    };
};
const $604bacc76c5090c8$export$8b507e2cf4ece2c6 = async (opts = {})=>{
    const hostname = opts.hostname;
    const apiBase = String(opts.apiBase || '').replace(/\/+$/, '');
    const fetchImpl = opts.fetchImpl;
    if (!hostname || !apiBase || typeof fetchImpl !== 'function') return $604bacc76c5090c8$var$NO_LOOKUP;
    try {
        const url = `${apiBase}/core/organizations/custom-domain-scope?host=${encodeURIComponent(hostname)}`;
        // `credentials: 'omit'` — this runs for logged-out visitors and must not
        // depend on (or leak) a session. Same call shape customDomainBoot uses.
        const res = await fetchImpl(url, {
            credentials: 'omit'
        });
        if (!res || !res.ok) return $604bacc76c5090c8$var$NO_LOOKUP;
        const body = await res.json();
        const data = body && body.data;
        return {
            scope: $604bacc76c5090c8$var$scopeFromPayload(data),
            brand: $604bacc76c5090c8$var$brandFromPayload(data)
        };
    } catch (_) {
        return $604bacc76c5090c8$var$NO_LOOKUP;
    }
};
const $604bacc76c5090c8$export$15f1463251669f33 = async (opts = {})=>(await $604bacc76c5090c8$export$8b507e2cf4ece2c6(opts)).brand;
// The scope payload's `data` → the brand bag, or null. Pure; never throws
// past its own guard.
const $604bacc76c5090c8$var$brandFromPayload = (data)=>{
    try {
        const brand = data && data.branding;
        if (!brand || typeof brand !== 'object') return null;
        // A record with nothing to show is not a brand — treat it as none so
        // consumers can gate on truthiness alone.
        if (!brand.name && !brand.logoSvg && !brand.loaderLogoSvg) return null;
        // Carry the resolved workspace key alongside the brand. It is a sibling
        // of `branding` in the scope payload, and the branded surfaces need it to
        // name a workspace to the public onboarding endpoint — without it they
        // would have to re-request the very response we already hold. Attached
        // only when the server sent one, so an older server (or any payload
        // without it) yields exactly the brand object it always did.
        const wsKey = data.workspaceKey;
        // WS-WHITELABEL-TENANT-SCOPE-1 — carry the resolved TENANT ids too.
        //
        // `organizationId` / `workspaceId` are already in this very response (they
        // are what `resolveCustomDomainScope` reads from it), and this lookup is
        // already awaited before bootShell runs. Passing them through turns the
        // host's tenant into something the BOOT SNAPSHOT can be scoped by, with no
        // second request and no ladder to race — which is the difference between
        // preventing the wrong-tenant render and correcting it afterwards.
        //
        // Attached only when the server sent them, so an older server yields
        // exactly the brand object it always did, and `scopeSnapshotToWhitelabelHost`
        // treats a missing `organizationId` as "no scope, change nothing".
        const orgId = data.organizationId;
        const wsId = data.workspaceId;
        // WORKSPACE-ENFORCED LANGUAGE, PRE-AUTH — `{ language, languagePolicy }`,
        // another sibling of `branding` in this same response. It is the ONLY way
        // a branded host can honour an enforced language from FIRST PAINT: the
        // workspace record itself does not exist until after sign-in, so without
        // this the page boots into the visitor's own language and re-languages
        // itself a step later. Read by `enforcedWorkspaceLang` (workspace-shared
        // functions/languages.js), the same function that reads a live
        // `workspace.settings` — the shapes match on purpose.
        //
        // NOT the same thing as `brand.lang`, which is the ORG's language and the
        // WEAKEST signal in the resolver. This one is a rule; that one is a
        // fallback for a visitor nothing else can speak for.
        //
        // Carried verbatim (an object, not a derived code) so the one decision
        // stays in one function rather than being half-made here.
        const wsLang = data.workspaceLanguage;
        const extra = {};
        if (wsKey) extra.workspaceKey = String(wsKey);
        if (orgId) extra.organizationId = String(orgId);
        if (wsId) extra.workspaceId = String(wsId);
        if (wsLang && typeof wsLang === 'object') extra.workspaceLanguage = wsLang;
        return Object.keys(extra).length ? {
            ...brand,
            ...extra
        } : brand;
    } catch (_) {
        return null;
    }
};
/**
 * Start (once) the ONE lookup for THIS page load. Safe to call at module-eval
 * time from the entry: it kicks the request off in parallel with SDK init
 * and the auth round-trip instead of behind them. Resolves `{ scope, brand }`
 * and never rejects.
 */ const $604bacc76c5090c8$var$kickWhitelabelLookup = (opts = {})=>{
    if ($604bacc76c5090c8$var$_lookupPromise) return $604bacc76c5090c8$var$_lookupPromise;
    const win = opts.win || (typeof window !== 'undefined' ? window : null);
    if (!win || !win.location) return $604bacc76c5090c8$var$_lookupPromise = Promise.resolve($604bacc76c5090c8$var$NO_LOOKUP);
    // The canonical host test, with its documented local overrides
    // (`localStorage.symbols_force_custom_domain='1'` / `?customDomain=1`) so a
    // brand can be exercised against a local shell — customDomainHost.js.
    const onCustomDomain = opts.forceCustomDomain === true || (0, $lb2Ei.isCustomDomainHost)();
    if (!onCustomDomain) return $604bacc76c5090c8$var$_lookupPromise = Promise.resolve($604bacc76c5090c8$var$NO_LOOKUP);
    $604bacc76c5090c8$var$_lookupPromise = $604bacc76c5090c8$export$8b507e2cf4ece2c6({
        hostname: win.location.hostname,
        apiBase: opts.apiBase,
        fetchImpl: opts.fetchImpl || (typeof win.fetch === 'function' ? win.fetch.bind(win) : null)
    }).catch(()=>$604bacc76c5090c8$var$NO_LOOKUP);
    return $604bacc76c5090c8$var$_lookupPromise;
};
const $604bacc76c5090c8$export$2e843c3e69374547 = (opts = {})=>{
    if ($604bacc76c5090c8$var$_brandPromise) return $604bacc76c5090c8$var$_brandPromise;
    const win = opts.win || (typeof window !== 'undefined' ? window : null);
    $604bacc76c5090c8$var$_brandPromise = $604bacc76c5090c8$var$kickWhitelabelLookup(opts).then(({ brand: brand })=>{
        $604bacc76c5090c8$export$b64be051a2c9a683(brand, win);
        // The one place BOTH consumers (seed and late apply) share, so the
        // tab icon lands exactly once per page load, however the race went.
        $604bacc76c5090c8$export$7a9959a303cf0cf3(brand, win);
        return brand;
    }).catch(()=>null);
    return $604bacc76c5090c8$var$_brandPromise;
};
const $604bacc76c5090c8$export$f627287f88b08089 = (opts = {})=>$604bacc76c5090c8$var$kickWhitelabelLookup(opts).then((lookup)=>lookup && lookup.scope || null).catch(()=>null);
const $604bacc76c5090c8$export$17fffbe51f2c9fb1 = async (contextState, opts = {})=>{
    const win = opts.win || (typeof window !== 'undefined' ? window : null);
    const onCustomDomain = opts.forceCustomDomain === true || (0, $lb2Ei.isCustomDomainHost)();
    if (!win || !win.location || !onCustomDomain) return null;
    const timeoutMs = opts.timeoutMs != null ? opts.timeoutMs : 15000;
    const TIMED_OUT = Symbol('whitelabelHostScopeTimeout');
    let timer = null;
    const raced = await Promise.race([
        $604bacc76c5090c8$export$f627287f88b08089(opts),
        new Promise((resolve)=>{
            timer = setTimeout(()=>resolve(TIMED_OUT), timeoutMs);
        })
    ]);
    if (timer) clearTimeout(timer);
    const scope = raced && raced !== TIMED_OUT ? raced : null;
    const realCustomerHost = !(0, $lb2Ei.isPlatformHost)(win.location.hostname || '');
    if (!scope && !realCustomerHost) return null;
    if (contextState) {
        contextState.whitelabelHostScope = scope || false;
        contextState._hostScopeOrgId = scope ? scope.organizationId : null;
    }
    (0, $gNttC.setHostScopeOrgId)(scope && scope.organizationId);
    if (scope && scope.workspaceId) try {
        $604bacc76c5090c8$var$shellSetActiveWorkspacePointer(scope.workspaceId);
    } catch (_) {}
    return scope;
};
const $604bacc76c5090c8$export$10a6c9097c4a3a30 = (icon, brand)=>{
    if (typeof icon !== 'string' || !/^\s*<svg\b/i.test(icon)) return icon;
    const lightGlyph = brand && brand.background || '#18181b';
    const darkGlyph = brand && brand.backgroundLight || '#f4f4f5';
    const style = `<style>:root{color:${lightGlyph}}` + `@media (prefers-color-scheme: dark){:root{color:${darkGlyph}}}</style>`;
    return icon.replace(/(<svg\b[^>]*>)/i, `$1${style}`);
};
const $604bacc76c5090c8$export$7a9959a303cf0cf3 = (brand, win = typeof window !== 'undefined' ? window : null)=>{
    try {
        if (!win || !win.document) return false;
        const icon = brand && (brand.logoSvg || brand.loaderLogoSvg);
        if (!icon || typeof icon !== 'string' || !/^\s*<svg\b/i.test(icon)) return false;
        const doc = win.document;
        const stale = doc.querySelectorAll('link[rel="icon"]');
        for(let i = 0; i < stale.length; i++){
            const l = stale[i];
            if (l && l.parentNode) l.parentNode.removeChild(l);
        }
        const link = doc.createElement('link');
        link.rel = 'icon';
        link.type = 'image/svg+xml';
        link.href = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent($604bacc76c5090c8$export$10a6c9097c4a3a30(icon, brand));
        (doc.head || doc.documentElement).appendChild(link);
        return true;
    } catch (_) {
        return false;
    }
};
const $604bacc76c5090c8$export$b64be051a2c9a683 = (brand, win = typeof window !== 'undefined' ? window : null)=>{
    try {
        if (!brand || !win || !win.location || !win.localStorage) return false;
        const isLight = brand.theme === 'light';
        // Ink is chosen here rather than stored per-tenant: the boot screen shows
        // a mark and nothing else, so it only needs to be legible on the ground,
        // and these are the same two values the non-branded boot screen uses.
        const payload = {
            theme: brand.theme === 'light' || brand.theme === 'dark' ? brand.theme : null,
            bg: (isLight ? brand.backgroundLight : brand.background) || null,
            ink: isLight ? '#18181b' : '#f4f4f5',
            // The loader mark first — it is the one drawn for exactly this purpose.
            logo: brand.loaderLogoSvg || brand.logoSvg || null,
            // The tab icon wants the COMPACT mark, so precedence flips: logoSvg
            // (the mark the sign-in card draws) before the loader variant.
            // Cached ALREADY THEMED (themedFaviconSvg) so index.html's head
            // script stays a dumb applier — one transform site, no drift.
            icon: $604bacc76c5090c8$export$10a6c9097c4a3a30(brand.logoSvg || brand.loaderLogoSvg || null, brand),
            name: brand.name || null,
            // THE BOOT MOTION, same OPT-IN law the in-app MainLoader applies
            // (components/whitelabel/MainLoader.js): only `loaderMotion === 'dial'`
            // takes the combination-dial lockup, every other value and the absent
            // key keep the coin flip (Nika 2026-09-10: "change loading spinner only
            // for vault - keep bellforge and gita as was"). Normalised to
            // 'dial' | null HERE so index.html's head script stays a dumb applier:
            // one branch on a cached string, no logic beyond a class toggle.
            // Written on EVERY boot, so a cache left by an older shell, or by a
            // record whose motion has since changed, heals on the next load.
            motion: brand.loaderMotion === 'dial' ? 'dial' : null,
            // THE BOOT LANGUAGE for this HOST (WS-BOOT-LOADER-PAINTS-ENGLISH-ONLY-
            // BEFORE-THE-BUNDLE-1). Same reason as `theme` above: the pre-bundle
            // overlay in index.html cannot await a lookup without painting the
            // wrong language first, so it reads back what this boot learned.
            //
            // RESOLVED here, not raw, so the decision stays in ONE function —
            // `resolveLang` (workspace-shared functions/languages.js), fed the two
            // signals this record carries: the host's pre-auth workspace pair
            // (`workspaceLanguage`, the strong one) and the org's own `lang` (the
            // weakest level). index.html stays a dumb applier, exactly like it is
            // for the theme, the motion and the icon.
            //
            // Host-keyed, so one tenant's language can never paint another's
            // domain — and this is the HOST's level of the precedence, below the
            // per-workspace entry functions/bootLang.js writes. A workspace that
            // sets its own language still wins there.
            lang: (()=>{
                const pair = brand.workspaceLanguage || null;
                const resolved = $604bacc76c5090c8$var$shellResolveLang({
                    workspaceEnforced: $604bacc76c5090c8$var$shellEnforcedWorkspaceLang(pair),
                    workspaceDefault: pair && pair.language || null,
                    brandDefault: brand.lang || null
                });
                return resolved || null;
            })()
        };
        win.localStorage.setItem('wlBoot:' + win.location.hostname, JSON.stringify(payload));
        return true;
    } catch (_) {
        return false;
    }
};
const $604bacc76c5090c8$export$15f0b87cc12aecbf = async (contextState, opts = {})=>{
    const timeoutMs = opts.timeoutMs != null ? opts.timeoutMs : 600;
    const promise = $604bacc76c5090c8$export$2e843c3e69374547(opts);
    const TIMED_OUT = Symbol('whitelabelBrandTimeout');
    const brand = await Promise.race([
        promise,
        new Promise((resolve)=>setTimeout(()=>resolve(TIMED_OUT), timeoutMs))
    ]);
    if (brand === TIMED_OUT || !brand) return null;
    if (contextState) contextState.whitelabelBrand = brand;
    return brand;
};
const $604bacc76c5090c8$export$a6b662327df962e3 = (root, opts = {})=>{
    if (!root || typeof root.update !== 'function') return Promise.resolve(null);
    return $604bacc76c5090c8$export$2e843c3e69374547(opts).then((brand)=>{
        if (!brand) {
            // SETTLED WITHOUT A BRAND, on a custom-domain host: `false`, not
            // `null`, so a reader can tell "no brand here" from "still loading"
            // (functions/authWrapperTitle.js gives the sign-in wrappers their own
            // title back instead of waiting for a brand that never comes). Every
            // existing reader tests truthiness, so false reads like null to them.
            const onCustom = opts.forceCustomDomain === true || (0, $lb2Ei.isCustomDomainHost)();
            if (onCustom && root.whitelabelBrand == null) root.update({
                whitelabelBrand: false
            }, {
                preventFetch: true
            });
            return null;
        }
        if (root.whitelabelBrand) return root.whitelabelBrand;
        root.update({
            whitelabelBrand: brand
        }, {
            preventFetch: true
        });
        return brand;
    }).catch(()=>null);
};
const $604bacc76c5090c8$export$6fb0a8d8ddc48ead = ()=>{
    $604bacc76c5090c8$var$_lookupPromise = null;
    $604bacc76c5090c8$var$_brandPromise = null;
};



var $lb2Ei = parcelRequire("lb2Ei");

var $hssOO = parcelRequire("hssOO");


var $57be949adfa18b6d$export$2e2bcd8739ae039 = {
    key: 'system--canvas',
    routes: [
        /^\/dashboard$/,
        /^\/profile$/,
        /^\/studio$/,
        /^\/[^/]+\/[^/]+/
    ],
    i18nNamespaces: [
        'canvas'
    ],
    app: ()=>(parcelRequire("ljS9v")).then((m)=>m.default),
    context: ()=>(parcelRequire("3dQQl")).then((m)=>m.default),
    // NOTE: these lifecycle hooks are currently NOT invoked by bootShell or
    // wireGlobalListeners (no fetchOnMount caller exists — verified 2026-07-28);
    // the editor page's own ensureProjectLoaded does the real fetch. Kept for the
    // Phase-8 dispatcher, but corrected: the SDK facade is FLAT
    // (sdk.getProjectByKey — SERVICE_METHODS maps it to the project service);
    // `sdk.project.getProjectByKey` was a dead namespace that would have thrown,
    // the same class of bug bootShell's own comment calls out for
    // `sdk.organization?.get?.()`.
    fetchOnMount: ({ state: state, sdk: sdk, params: params })=>{
        if (params?.owner && params?.project) return sdk.getProjectByKey({
            owner: params.owner,
            key: params.project
        }).then((p)=>{
            state.project = p;
        });
    },
    onParamsChange: ({ newParams: newParams, oldParams: oldParams, state: state, sdk: sdk })=>{
        if (newParams?.project !== oldParams?.project && newParams?.owner && newParams?.project) {
            state.project = null;
            state.projectComponents = null;
            state.projectPages = null;
            state.projectState = null;
            return sdk.getProjectByKey({
                owner: newParams.owner,
                key: newParams.project
            }).then((p)=>{
                state.project = p;
            });
        }
    }
};


// THE CANVAS WAITS FOR THE SESSION BRIDGE'S VERDICT BEFORE IT BOOTS.
//
// Measured by relman (ms after navigation, a clean profile — the ORDER, not
// the outcome): the canvas host creates the session-bridge frame, then routes
// to /login ~300 ms later, BEFORE the peer's symbols-session-ready /
// -response arrive —
//   canvas.dev            frame   753  /login 1,047  response 2,414
//   canvas.staging        frame 1,967  /login 2,275  response 4,460
//   edit.symbols.app      frame   559  /login   936  response 2,759
// The requester (the SDK's hydrateAuthFromIframeBridge, started by getSDK)
// writes the bridged tokens into this host's storage when the answer
// arrives; nothing waited for it, so the shared boot's auth gate read an empty
// storage and decided "signed out". A signed-in user with no canvas-local
// session on that host saw sign-in on a cold load; a reload worked because
// the late answer had been stored.
//
// So the canvas boot waits for that verdict first — and ONLY for it:
//   • only on a protected path — a guest / public path never waits
//     (isGuestAllowedPath, the one public-path list the boot gate reads);
//   • only as long as the verdict takes: the requester resolves on the
//     response, at once on `ok:false`, and false after its own 8 s (cold ask); this gate
//     adds a ceiling above that (CEILING_MS) so the boot can never hang;
//   • it decides NOTHING: the shared boot then reads storage exactly as
//     before, so a timeout or `ok:false` (no token written) still fails
//     closed to /login. A fresh local session resolves the requester at once
//     (it never creates a frame), so a signed-in reload does not wait.
// The token itself is handled only by the requester, after its origin check
// (`ev.origin !== origin` → ignored) — this gate never reads a message.
//
// Same pattern as the shell guard (workspace 99389ba6a): wait while gated
// with no verdict, bounded, then decide.
// Above the cold bridge ask's own 8 s (shared sdkClient: staging answered
// at 4,202 / 4,460 ms, past the old 4 s — 2026-10-11).
const $f687282e682952bb$export$a8329a9758e0dcfd = 9000;
const $f687282e682952bb$export$e233cfb11ea81b5a = async ({ pathname: pathname, isGuestPath: isGuestPath, startHydration: startHydration, ceilingMs: ceilingMs = $f687282e682952bb$export$a8329a9758e0dcfd } = {})=>{
    const path = typeof pathname === 'string' && pathname ? pathname : '/';
    if (typeof isGuestPath === 'function' && isGuestPath(path)) return {
        waited: false,
        verdict: 'guest'
    };
    if (typeof startHydration !== 'function') return {
        waited: false,
        verdict: 'none'
    };
    let hydration;
    try {
        hydration = startHydration();
    } catch (_) {
        return {
            waited: false,
            verdict: 'none'
        };
    }
    if (!hydration || typeof hydration.then !== 'function') return {
        waited: false,
        verdict: 'none'
    };
    let timer = null;
    const ceiling = new Promise((resolve)=>{
        timer = setTimeout(()=>resolve('ceiling'), ceilingMs);
    });
    try {
        const verdict = await Promise.race([
            hydration.then((v)=>!!v, ()=>false),
            ceiling
        ]);
        return {
            waited: true,
            verdict: verdict
        };
    } finally{
        if (timer !== null) clearTimeout(timer);
    }
};




var $916cbd39e9286c74$export$2e2bcd8739ae039 = {
    key: 'system--workspace-project',
    // Keep in sync with the page dispatch table in
    // packag./pages/index.js. bootShell._singleAppDispatch
    // (shared/functions/bootShell.js:78) silently history.replaceState()s
    // any path that doesn't match one of these regexes back to
    // fallbackRoute ('/'), so a missing entry presents as "URL flashes
    // /admin/usage then snaps to /" and the home page renders instead.
    routes: [
        /^\/$/,
        // Auth routes — keep in sync with functions/auth.js AUTH_PATHS (importing
        // it here would pull auth.js into the eager boot manifest). forgot-password
        // + verify-email were missing, so bootShell replaceState'd those two auth
        // pages to '/' before they could render.
        /^\/(login|signin|signup|signup-confirmation|reset-password|forgot-password|verify-email)(\/|$)/,
        /^\/auth\/callback(\/|\?|$)/,
        /^\/auth\/magic-callback(\/|\?|#|$)/,
        /^\/github-auth-callback(\/|\?|$)/,
        // Emailed invitation landings (P0 invite-flow fix, 2026-08-06) — keep in
        // sync with pages/index.js accept routes + guestRoutes.js. Without these
        // a single-app boot replaceStates the ?token= link back to '/'.
        /^\/(accept-invite|accept-org-invite|accept-team-invite|accept-workspace-invite|waitlist-invite)(\/|\?|$)/,
        /^\/(tickets|chat|chats|mail|terminal|calendar|inbox|epics|teams|meet|meet-guest|documents|docs)(\/|$)/,
        /^\/(admin|people|my|announcements|company|settings|profile|data|system-status|integrations|features|reminders|bookmarks|history|files|_session-bridge)(\/|$)/,
        /^\/(user|u)\/[^/]+/
    ],
    // The namespaces this shell's surfaces ACTUALLY read. It said
    // `['workspace-project']` until 2026-09-02 — a bundle nobody has written and
    // nobody plans: bootShell intersects a manifest's declaration against the
    // loader registry (packages/shared/functions/i18nLoader.js, derived from
    // packages/shared/i18n/ by scripts/gen-i18n-registry.mjs), so the whole
    // declaration was dropped, in silence, and the shell loaded `common` alone in
    // every non-English language. Measured on the GITA workspace: a member with
    // the workspace default `ka` got a correctly-resolved Georgian session with
    // 50 keys of `common` and an English page. bootShell now WARNS on a dropped
    // namespace instead of swallowing it.
    //
    // The three below are counted, not guessed — every key of each bundle grepped
    // against this package's and @symbo-ls/workspace-shared's sources:
    //   common   — 8 keys (action/state verbs in the shared chrome)
    //   account  — 11 keys (the profile surface, which mounts inside this shell)
    //   settings — 8 keys (the language section; `settings.language.*` renders on
    //              /admin/*, which the deleted path-prefix regex never matched —
    //              a Georgian admin read raw dotted keys across that surface)
    // `auth` is added by bootShell's guest branch, which is a STATE condition (no
    // user resolved yet), not a route guess — so it is not listed here.
    // `canvas` (606 keys) belongs to packages/canvas and is declared there.
    //
    // The routes array above already covers `/admin/*`, so every admin page is a
    // route of THIS app and needs no declaration of its own. That is the whole
    // mechanism now: a surface declares, nothing infers from a URL.
    // `workspace` / `admin` / `data` were added by LANE EXTRACT-WORKSPACE
    // (2026-09-02): the shell's own three surfaces, split by the route tree a
    // reader is actually on — the home board + app-window chrome (`workspace`),
    // the /admin console (`admin`), and /data + /data/external (`data`). One
    // manifest serves all of them because every one of those routes is a route
    // of THIS app (see the `routes` array above), so bootShell loads the three
    // together; the split is what keeps each bundle auditable by reading it, and
    // what lets a future route-scoped loader drop two of the three.
    // `shell` is declared because this package READS it: the launcher tiles, the
    // tile context menu and the default navbar labels are shell chrome whose
    // strings live in the shared package's own bundle (57 launcher keys, 7
    // `shell.app.*`, 6 tile-menu keys). They load today only because `shell` is
    // in bootShell's BOOT_NAMESPACES; naming it here makes the dependency
    // DECLARED rather than incidental, so a future route-scoped loader cannot
    // drop it and leave those labels rendering raw keys.
    i18nNamespaces: [
        'common',
        'account',
        'settings',
        'workspace',
        'admin',
        'data',
        'shell',
        // `ai` — the assistant's chrome that the shell's OWN composer mount
        // (app.js) names: the Page-mode placeholder and the PAGE mode word are the
        // same strings the shared AI settings panel's "Answers" choice shows
        // (ASSISTANT_BOARD_MODE_SPEC §1, §4) — one word per concept on every
        // surface, never a second copy under `workspace.*`.
        'ai',
        // `members` — the header's invite panel (components/InviteDropdown.js, the
        // shell's layout of the shared invite parts) names the same invite copy
        // the shared parts render: title, role names, sent / copied lines, the
        // magic-link revoke words. One string per concept, never a second copy
        // under `shell.*`.
        'members',
        'tickets',
        'flags',
        // The five apps the shell routes but that carry no manifest of their own
        // (chat, meet, calendar, documents, files live in their own packages with
        // no `manifest.js`). Their bundles exist and the registry has them; without
        // this line bootShell loads none of the five and every one of those
        // surfaces renders English inside a Georgian session.
        'chat',
        // `mail` — the built-in email client (architecture/MAIL.md), routed here
        // as `/mail` with no manifest of its own, exactly like the five above.
        'mail',
        'meet',
        'calendar',
        'documents',
        'files',
        // `marketplace` is declared because this shell's own CHROME resolves store
        // copy on EVERY route, not because it routes `/marketplace`. An installed
        // app's navbar tab and launcher tile carry the app's identity, and their
        // label is resolved through the ONE store-copy resolver
        // (`shared/functions/storeItemText.js` → `marketplace.app.<slug>.name`), so
        // an app has the same name in the navbar as in the store it was installed
        // from. Undeclared, those 15 tabs printed their manifest's English literal
        // inside a Georgian session — "Warehouse" against the store's "ინვენტარი".
        // It is in bootShell's BOOT_NAMESPACES too: the navbar paints before the
        // per-route widening runs, so the manifest line alone would still flash
        // English. Cost, measured: the ka chunk is 51 KB against the 573 KB a
        // Georgian shell boot already loads.
        'marketplace',
        // `analytics` — /analytics, /workspace-analytics and the logs suite. The
        // package is a lazily merged shared library with a manifest of its own, but
        // its pages also open in a PageSlot pane from ANY route, where no route
        // match can add the namespace; and its own manifest is matched against the
        // browser path only at boot. Declared here, the dashboards read Georgian
        // wherever they are opened. Until 2026-09-21 the package had no bundle at
        // all and every one of its ~250 strings was an English literal.
        'analytics',
        // `infra` — /infra and /infra/status. The package is a HARD LEAF that
        // this shell's own `pages/index.js` loads through `lazySharedLib`; it
        // carries no manifest of its own, so this line is the only place that can
        // declare its bundle. `/infra/status` also opens in a CanvasPageSlot pane
        // from the infra rail, where no route match could widen the set. Until
        // 2026-09-22 the package had no bundle at all and every one of its
        // strings was an English literal.
        'infra',
        // `preview` — the `site-preview` AI-answer view (preview/components/
        // SitePreviewView.js) mounts in the assistant's thread and on a Fly page on
        // ANY route, and the /preview pane opens in a PageSlot from any route too;
        // its own manifest is matched against the browser path only at boot. 65
        // keys; declared here, both read Georgian wherever they open.
        'preview',
        // `canvas` — the `canvas-projects` AI-answer view (canvas/components/
        // CanvasProjectsView.js, its provider in the canvas eager slice) mounts in
        // the assistant's thread and on a Fly page on ANY route, and the home's own
        // canvas chrome (the composer's canvas strings) reads it too. Without it a
        // Georgian session shows those lines in English. The dependency is
        // declared, never copied into `workspace.*` (the ownership gate's rule).
        'canvas'
    ],
    app: ()=>Promise.resolve((parcelRequire("9c3uh"))).then((m)=>m.default),
    context: ()=>Promise.resolve((parcelRequire("hssOO"))).then((m)=>m.default)
};




var $c87f1e11520c5fdc$export$2e2bcd8739ae039 = {
    key: 'system--marketplace',
    // `/user/:slug` and `/u/:slug` are public-facing community profile
    // pages — same-origin navigation from the feed click stays on the
    // marketplace surface so we don't cross-domain to us-at.symbols.app.
    routes: [
        /^\/marketplace(\/|$)/,
        /^\/feed(\/|$)/,
        /^\/user\/[^/]+/,
        /^\/u\/[^/]+/
    ],
    // `apps` is declared because the SEED CATALOG this surface renders lives in
    // the shared package and carries polyglot keys in its rows
    // (`apps.catalog.<id>.descr` — packages/shared/functions/marketplaceCatalog.js).
    // Without the namespace those 31 descriptions would resolve to nothing and
    // ship the raw dotted key to the card.
    // `account` is declared for the member-role names (`account.member.role.*`)
    // the App Store page's notify row reads (appStoreNotifyRoleKey): a role an
    // app may notify prints as its name in the viewer's language.
    i18nNamespaces: [
        'marketplace',
        'apps',
        'account'
    ],
    app: ()=>(parcelRequire("3waBY")).then((m)=>m.default),
    context: ()=>(parcelRequire("17dat")).then((m)=>m.default)
};




var $04b58effbd108291$export$2e2bcd8739ae039 = {
    key: 'system--preview',
    // Two URL shapes both serve the preview:
    //   - production wildcard host `<owner>--<key>.preview.symbols.app/`
    //     lands on the bare `/` route — no path prefix.
    //   - workspace-shell mount + bootShell `fallbackRoute: '/preview'`
    //     rewrites the URL to `/preview` so the shell's mount-routing
    //     picks this manifest up.
    // Matching both shapes here prevents bootShell from rewriting `/`
    // to `/preview` on the production wildcard — that rewrite stripped
    // the inbound `?owner=…&key=…` query and showed an empty viewport.
    routes: [
        /^\/$/,
        /^\/preview(\/|$)/
    ],
    i18nNamespaces: [
        'preview'
    ],
    app: ()=>(parcelRequire("6Qr8E")).then((m)=>m.default),
    context: ()=>(parcelRequire("hRfYg")).then((m)=>m.default)
};


const $dad545c909cfec2d$var$bootShell = (...args)=>(0, $1X0Je.default).functions.bootShell(...args);
const $dad545c909cfec2d$var$shellGetSDK = (...args)=>(0, $1X0Je.default).functions.getSDK(...args);
const $dad545c909cfec2d$var$workspaceApiBaseForBrand = (...args)=>(0, $1X0Je.default).functions.workspaceApiBase(...args);
const $dad545c909cfec2d$var$shellGetActiveWorkspacePointer = (...args)=>(0, $1X0Je.default).functions.getActiveWorkspacePointer(...args);
const $dad545c909cfec2d$var$shellSetActiveWorkspaceRecord = (...args)=>(0, $1X0Je.default).functions.setActiveWorkspaceRecord(...args);
const $dad545c909cfec2d$var$shellGetWorkspaceRawSegments = (...args)=>(0, $1X0Je.default).functions.getWorkspaceRawSegments(...args);
var $9d7d5972606fe2c3$exports = {};
$9d7d5972606fe2c3$exports = import.meta.resolve("bfJMF");


// /analytics (project) + /workspace-analytics (+ /workspace-analytics/map
// + /workspace-analytics/logs) are owned by the
// @symbo-ls/workspace-analytics package — consumed as a SHARED LIBRARY
// (registered in sharedLibraries.js) so its components, functions, and
// state register globally in the shell scope. Its pages flow through
// workspace/pages/index.js, which imports them directly from the
// analytics package.
// A comm host installs as its own app (comm.webmanifest: its name, start_url
// /chat). The browser reads the manifest link lazily (install, app menu), so
// pointing it here at module load is in time. The `new URL` is also what makes
// the build emit the file beside app.webmanifest.
if ((0, $1X0Je.default).functions.isCommHost()) {
    const manifestLink = document.querySelector('link[rel="manifest"]');
    if (manifestLink) manifestLink.href = new URL($9d7d5972606fe2c3$exports).href;
}
// Run the bidirectional auth-route gate at shell entry — BEFORE
// bootShell, sub-app manifests, or any page component load. This
// guarantees the redirect fires for every route, not just routes that
// activate the workspace-project sub-app. The wp sub-app's own
// `app.js` also calls `redirectIfUnauthed` (kept as defense-in-depth),
// but routes like /reset-password / /signup-confirmation are handled
// by shared pages that mount directly via the unified pages map
// without ever importing wp/app.js — so this top-level call is what
// catches them.
//
// `publicPathPrefixes` matches the wp sub-app's allowlist so guest-
// reachable surfaces (/meet-guest, /_session-bridge, /user/:slug,
// /u/:slug) keep rendering for both authed and unauthed visitors.
// Capture whether the gate issued a hard redirect. When it did, the page is
// already navigating away (unauthed → /demo on the demo host, → /login on
// my.symbols.app; or authed-on-/demo → /), so we must NOT run the boot below:
// bootShell would burn a full SDK-init + getMe round-trip on the doomed page AND
// fire its own soft `replaceState('/login')`, which races the hard redirect —
// the demo's "/ → flash /login → /demo" multi-bounce. Skipping it makes the
// bounce a single clean redirect.
// The public paths and the decision are functions/auth.js's
// THE public-path list (shared guestRoutes.js isGuestAllowedPath, the boot
// gate's own) + authRedirectTarget — the SAME predicate the
// router's authRouteGuard runs on every navigation (and the published shell's
// only gate, since mermaid never runs this file).
// A comm host (docs/COMM_HOST.md) borrows the session of its workspace host
// through the session bridge — and the bridge answers AFTER this gate used to
// decide, so a person signed in on my.symbols.app was bounced to
// comm.symbols.app/login. With no session of its own, a comm host's protected
// path waits for the bridge's verdict first (the canvas boot's bounded
// awaitBridgeVerdict) and runs this same gate after it, in the boot below.
const $dad545c909cfec2d$var$_commBridgeWait = (0, $1X0Je.default).functions.isCommHost() && !(0, $kuISg.hasSessionToken)() && !(0, $1X0Je.default).functions.isGuestAllowedPath(window.location.pathname || '/');
const $dad545c909cfec2d$var$_redirecting = $dad545c909cfec2d$var$_commBridgeWait ? false : (0, $qJ3f5.redirectIfUnauthed)({
    isPublicPath: (p)=>(0, $1X0Je.default).functions.isGuestAllowedPath(p)
});
// Legacy SDKs prime the roster in parallel with auth+mount so members do
// not wait behind getMe → scope → create(). Composite boot already returns
// those rows through context.bootPayload; another prime would fetch and
// retain a duplicate roster on every authenticated load. Missing or failed
// composite sections still fall back to a scoped read in loadPrivateData.
if (!$dad545c909cfec2d$var$_redirecting && (0, $kuISg.hasSessionToken)()) {
    try {
        const sdk = $dad545c909cfec2d$var$shellGetSDK();
        if (typeof sdk.boot !== 'function') (0, $cKmtB.primePeople)(sdk);
    } catch (err) {
        console.warn('[workspace] roster prime skipped', err?.message || err);
    }
    // Legacy boot shares this early workspace request with bootShell's scope
    // fetch and loadWorkspaceProject through getWorkspaceCached. Composite
    // boot already returns the full record and bootShell adopts it directly.
    // Missing, failed, or mismatched composite records use bootShell's scoped
    // fallback through the same cache after the client resolves its workspace.
    try {
        const sdk = $dad545c909cfec2d$var$shellGetSDK();
        if (typeof sdk.boot !== 'function') {
            const _pointerWs = $dad545c909cfec2d$var$shellGetActiveWorkspacePointer();
            // perf/shell-boot: the same record starts the takeover module's
            // channel + payload read (see the composite hook below).
            if (_pointerWs) (0, $7muxD.getWorkspaceCached)(sdk, _pointerWs).then((rec)=>{
                if ((0, $329083d02ed20916$export$850b21233092caac)({
                    wsId: _pointerWs,
                    record: rec,
                    pointer: $dad545c909cfec2d$var$shellGetActiveWorkspacePointer(),
                    segments: $dad545c909cfec2d$var$shellGetWorkspaceRawSegments(window.location.pathname),
                    orgs: $dad545c909cfec2d$var$_bootOrgsForPrefetch()
                })) (0, $7ytvD.prefetchWorkspaceModule)(sdk, _pointerWs, rec);
            }).catch(()=>{});
        }
    } catch (err) {
        console.warn('[workspace] workspace prime skipped', err?.message || err);
    }
}
// True when this page load IS the public share-link viewer (/s/<token>,
// optionally behind a /w/<org>[/<workspace>] prefix when a signed-in member
// opens their own link from inside the app). Read once, at entry, from the
// URL the browser actually loaded — the router has not run yet.
const $dad545c909cfec2d$var$_isPublicShareView = typeof window !== 'undefined' && (0, $1nnHq.isPublicShareViewPath)(window.location.pathname);
// perf/shell-boot (2026-10-09): the composite /core/boot answer carries the
// tab's full workspace record — settings.workspaceModule included — long
// before the shell mounts and the workspace turns authoritative. Measured live
// on staging /w/vault/default: boot answered at ~4.0 s, the module's first read
// went out at 9.6 s and its payload at 13.5 s. bootShell primes the record
// cache with every boot row; this primer keeps that contract and starts the
// takeover module's channel + payload read for the ONE row the boot resolves
// for this tab (functions/bootModulePrefetch.js). Fetch only — the takeover
// pass still decides and injects, and joins this flight instead of a new one.
// The session's orgs, to resolve a `/w/<org>` slug (review D4): the
// pre-resolved auth (warm boot), else the root's list, else the SIGNED-IN
// user's warm snapshot under one day old (review Delta 2 N8 — never the
// unkeyed shared org cache). None → no prefetch.
const $dad545c909cfec2d$var$_bootOrgsForPrefetch = ()=>(0, $hssOO.default).preResolvedAuth?.orgs || (0, $hssOO.default).state?.orgs || (0, $ly0mS.readSessionBootOrgs)({
        workspaceId: $dad545c909cfec2d$var$shellGetActiveWorkspacePointer()
    }) || null;
const $dad545c909cfec2d$var$_primeAndPrefetchModule = (0, $329083d02ed20916$export$dc91c4118c799088)((0, $7muxD.primeWorkspaceCache), {
    getPointer: ()=>$dad545c909cfec2d$var$shellGetActiveWorkspacePointer(),
    getSegments: ()=>$dad545c909cfec2d$var$shellGetWorkspaceRawSegments(window.location.pathname),
    getOrgs: ()=>$dad545c909cfec2d$var$_bootOrgsForPrefetch(),
    getSdk: ()=>$dad545c909cfec2d$var$shellGetSDK(),
    prefetch: (sdk, wsId, record)=>(0, $7ytvD.prefetchWorkspaceModule)(sdk, wsId, record)
});

// Warm the smbls framework chunk NOW — bootShell dynamic-imports it only
// AFTER its whole network phase (SDK init → getMe → scope fetches), so the
// chunk download + parse/eval sat serially inside the measured ~1.5s silent
// gap before mount (tickets/workspace.md boot ticket #1). Starting it at
// entry overlaps it with the auth round-trips; bootShell's own import()
// then resolves from the module registry instantly.
Promise.resolve((parcelRequire("eY4Ct"))).catch(()=>{});
// White-label branding (WHITELABEL-BRANDED-BOOT-1).
//
// ⚠️ Nika, 2026-08-19: "do not change anything for symbols — this is for
// bellforge workspace gate only." Hence the explicit host gate on all three
// call sites below rather than relying on the resolver's own internal
// no-op: on a platform host this branch is never entered, so the Symbols
// boot has no extra call, no extra await, and no extra microtask.
//
// On a white-label host it is kicked HERE, at entry, for the same reason the
// framework chunk and the roster are: the branded loader and the branded
// login both want it at first paint, and starting it behind SDK-init → getMe
// would guarantee it arrives after. One public, credential-less GET; the
// awaited seed and the late apply below consume THIS one request.
const $dad545c909cfec2d$var$_isWhitelabelHost = (0, $lb2Ei.isCustomDomainHost)();
if ($dad545c909cfec2d$var$_isWhitelabelHost) (0, $604bacc76c5090c8$export$2e843c3e69374547)({
    apiBase: $dad545c909cfec2d$var$workspaceApiBaseForBrand()
});
// Phase 8: full manifests replace Phase 7 stubs.
// Keyed by the app identifier used in APP_DISPATCH ('app' field).
// (cms/inspect/gazer packages aren't on disk in this branch — re-add the
// imports when those sub-apps land.)
const $dad545c909cfec2d$var$apps = {
    workspaceProject: (0, $916cbd39e9286c74$export$2e2bcd8739ae039),
    canvas: (0, $57be949adfa18b6d$export$2e2bcd8739ae039),
    marketplace: (0, $c87f1e11520c5fdc$export$2e2bcd8739ae039),
    preview: (0, $04b58effbd108291$export$2e2bcd8739ae039)
};

(async ()=>{
    // A hard redirect is already in flight (see `_redirecting` above) — bail
    // before bootShell so the doomed page doesn't burn an SDK-init + getMe
    // round-trip and bootShell's own soft /login replaceState can't race the
    // redirect. The pending navigation tears this page down momentarily.
    if ($dad545c909cfec2d$var$_redirecting) return;
    // The comm host's bridge wait (see `_commBridgeWait` above): bounded, then
    // the same gate decides from storage — a borrowed token passes, none bounces.
    if ($dad545c909cfec2d$var$_commBridgeWait) {
        await (0, $f687282e682952bb$export$e233cfb11ea81b5a)({
            pathname: window.location.pathname,
            isGuestPath: (p)=>(0, $1X0Je.default).functions.isGuestAllowedPath(p),
            startHydration: ()=>{
                $dad545c909cfec2d$var$shellGetSDK();
                return (0, $1X0Je.default).functions.awaitCrossAppHydration();
            }
        });
        if ((0, $qJ3f5.redirectIfUnauthed)({
            isPublicPath: (p)=>(0, $1X0Je.default).functions.isGuestAllowedPath(p)
        })) return;
    }
    // WHITELABEL-STRICT-TENANT-SCOPE-1 — bind this tab to the host's tenant
    // FIRST, before anything reads a scope. The seed stamps the tab-side
    // workspace pointer, and the warm-start read just below is keyed by that
    // pointer: resolving it before the seed handed a white-label tab the cached
    // chrome (and member roster) of whatever workspace the account last used on
    // this origin. Awaited, not raced: see seedWhitelabelHostScope. Same single
    // request the brand seed below consumes. Platform hosts skip it entirely.
    if ($dad545c909cfec2d$var$_isWhitelabelHost) await (0, $604bacc76c5090c8$export$17fffbe51f2c9fb1)((0, $hssOO.default).state, {
        apiBase: $dad545c909cfec2d$var$workspaceApiBaseForBrand()
    });
    // Warm-start (tickets/opus.md "boot: the scope-keyed warm-start snapshot's
    // PAINT half was never built"). Resolved HERE, at the entry — before
    // bootShell's own network phase starts — and passed straight through as
    // an already-validated row; bootShell does no scope judgment of its own
    // (see bootSnapshot.js's resolveWarmBootSnapshot for the full isolation +
    // URL-scope-match contract, and bootShell.js's warm-start block for what
    // it does with a valid one). Null on every cold boot / first-ever visit /
    // just-switched tenant — those fall through to today's behavior unchanged.
    // A white-label host whose tenant could not be established (`false`) gets
    // no warm row at all: the row is keyed by a pointer the host never
    // confirmed, so it may be another tenant's.
    const warmSnapshot = (0, $hssOO.default).state.whitelabelHostScope === false ? null : (0, $ly0mS.resolveWarmBootSnapshot)();
    // THE SKIN BEFORE FIRST PAINT (DESIGN-WL-SKINS-AMBIENT-DEFAULT-SOLID-
    // WHITELABEL-1): the warm row carries the skin the shell stamped for this
    // exact scope, so <html data-skin> is right before the shell's first frame
    // — the header pills and the composer are drawn in their skin, never eased
    // into it when the record lands. A cold boot (no row) leaves the attribute
    // to the shell's own stamp, as before.
    (0, $ly0mS.applyWarmBootSkin)(warmSnapshot);
    // Seed the brand onto `context.state` BEFORE the mount so a white-label
    // visitor's FIRST paint is already branded (the loader and, on the auth
    // bounce, the login both read `s.root.whitelabelBrand`). Bounded — see
    // whitelabelBrand.js: a slow lookup must never delay the mount, so this
    // resolves null on timeout and `applyWhitelabelBrandLate` (below, on
    // whichever root actually mounts) swaps the brand in when it lands.
    // Platform hosts skip the await entirely (see the gate at entry).
    if ($dad545c909cfec2d$var$_isWhitelabelHost) {
        // The same single request the seed races below, handed to boot as a
        // promise: step 7b (interface language) awaits it — bounded — when the
        // seed lost the race, so a branded host's `branding.lang` still reaches
        // the first language resolution instead of only the late re-render.
        (0, $hssOO.default).state.whitelabelBrandLookup = (0, $604bacc76c5090c8$export$2e843c3e69374547)({
            apiBase: $dad545c909cfec2d$var$workspaceApiBaseForBrand()
        });
        await (0, $604bacc76c5090c8$export$15f0b87cc12aecbf)((0, $hssOO.default).state, {
            apiBase: $dad545c909cfec2d$var$workspaceApiBaseForBrand()
        });
    }
    const shell = await $dad545c909cfec2d$var$bootShell({
        // the ONE boot sequence's steps (shared bootPrepare / bootResolve /
        // bootApply), reached through the registry — see bootShell.js
        steps: (0, $1X0Je.default).functions,
        apps: $dad545c909cfec2d$var$apps,
        defaultApp: 'workspaceProject',
        fallbackRoute: '/',
        context: $hssOO.default,
        // /s/<token> — the public share-link viewer (PUBLIC-SHARE-LINKS-1).
        // `redirectIfUnauthed` above already lets this path through, but
        // bootShell runs a SECOND gate of its own (the canonical guest-route
        // regex in shared/functions/guestRoutes.js) and would replaceState an
        // anonymous visitor to /login — the exact "guest link asks for signup"
        // failure meet-guest hit in 2026-06. `publicSurface` is that gate's
        // documented opt-out (the preview app uses it for the same reason:
        // a visibility-gated public surface that must render logged-out), and
        // it is set by the CALLER — so the shell opts itself in here instead
        // of the share feature editing the shared allowlist it does not own.
        // Every other route is unaffected: the flag is false unless the entry
        // URL is a share link.
        publicSurface: $dad545c909cfec2d$var$_isPublicShareView,
        getWorkspaceCached: // #17: share the getWorkspace in-flight-dedup + TTL cache with
        // loadWorkspaceProject/onWorkspaceChange so the eager boot scope-fetch and the
        // module-load fetch collapse to one round-trip (was a duplicate getWorkspace).
        $7muxD.getWorkspaceCached,
        // the boot's full-projection rows seed that cache: zero record reads on a
        // cold load (shared bootShell.bootListServesActiveOrg.test.js) — and the
        // tab's own row starts its takeover module (perf/shell-boot, above)
        primeWorkspaceCache: $dad545c909cfec2d$var$_primeAndPrefetchModule,
        // The warm row, with the language the loader painted from for THIS
        // arrival's scope (`loaderLang`): shared bootPrepare paints a row that
        // carries no language pair in it, as the loader did (functions/bootLang.js
        // withBootLangHint). A row's own pair still wins; no row stays null.
        warmSnapshot: (0, $hkFDz.withBootLangHint)(warmSnapshot)
    });
    // Boot segment G (BOOT-8S.md): bootShell resolved (its scope fetch, the
    // shell create and the first route are behind this point).
    try {
        performance.mark('wsboot:shell:returned');
    } catch (_) {
    /* no Performance API */ }
    // THE BOOT DEADLINE (bootDeadline.js): the session check never answered.
    // The loader already shows its error line + reload button and the stored
    // session is kept — mount nothing (no login shell over a valid session).
    if (!shell && (0, $hssOO.default).bootFailed) return;
    if (!shell) {
        // Auth gate bounced — bootShell already set URL to /login (soft
        // replaceState) and returned null. SDK init + adapter registration +
        // `context.methods.sdk` assignment + `context.state.notifications`
        // seeding ALL ran inside bootShell before it returned, so this block
        // just needs to mount the shell. The smbls router fires
        // onRenderRouter during create() and auto-routes to /login (which is
        // in context.pages via wpPages), so no manual dispatchUrl call is
        // needed.
        const { create: create } = await Promise.resolve((parcelRequire("eY4Ct")));
        const authShell = await create((0, $hssOO.default).app, {
            ...(0, $hssOO.default),
            globalTheme: (0, $hssOO.default).state?.themeMode || 'auto',
            themeStorageKey: 'themeMode'
        });
        (0, $51ae01d34a94b835$export$65f3055c61a76812)(authShell, {
            apps: $dad545c909cfec2d$var$apps,
            fallbackRoute: '/login'
        });
        // bootApply never runs on this path, so it never arms the deferred modal
        // host — and sign-up / sign-in continue in THIS shell. Without the arm,
        // every confirm dialog after sign-up opened onto an unmounted host.
        (0, $0a18f1a5e29a0bc7$export$17fa4bc1739d7bd)(authShell);
        // The branded LOGIN is this path: a logged-out white-label visitor.
        // If the brand lost the pre-mount race it lands here instead — the
        // login's own factories re-render on the reactive write.
        if ($dad545c909cfec2d$var$_isWhitelabelHost) (0, $604bacc76c5090c8$export$a6b662327df962e3)(authShell?.state?.root || authShell?.state, {
            apiBase: $dad545c909cfec2d$var$workspaceApiBaseForBrand()
        });
        return;
    }
    // A warm boot's first auth tick leaves the snapshot's list placeholder to
    // bootShell's reconcile (functions/auth.js); converge it here if that
    // reconcile resolved nothing. No request when the record is already full.
    try {
        (0, $8a3905e28d3faf89$export$a29a8784ed1ae6cf)(shell.state, {
            sdk: $dad545c909cfec2d$var$shellGetSDK(),
            getWorkspaceCached: $7muxD.getWorkspaceCached,
            setActiveWorkspaceRecord: $dad545c909cfec2d$var$shellSetActiveWorkspaceRecord
        });
    } catch (err) {
        console.warn('[workspace] post-boot workspace converge skipped', err?.message || err);
    }
    // An AUTHED shell booted — ARM the login-bounce breaker reset on the
    // first trusted user gesture (functions/auth.js). Clearing directly here
    // reset the counter on every lap of any loop whose cycle contains a
    // successful boot (boot OK → post-boot guard bounces back to /login), so
    // the breaker never tripped on exactly those loops and the tab froze
    // (Nika 2026-09-02, /login?next=/w/gita/… report). A machine loop never
    // produces a trusted pointerdown/keydown; a human does within seconds.
    (0, $qJ3f5.armLoginBounceClearOnGesture)();
    // Same second chance for the signed-in path — the branded LOADER is still
    // on screen while boot finishes, so a brand arriving now still shows.
    if ($dad545c909cfec2d$var$_isWhitelabelHost) (0, $604bacc76c5090c8$export$a6b662327df962e3)(shell?.state?.root || shell?.state, {
        apiBase: $dad545c909cfec2d$var$workspaceApiBaseForBrand()
    });
    (0, $51ae01d34a94b835$export$65f3055c61a76812)(shell, {
        apps: $dad545c909cfec2d$var$apps,
        fallbackRoute: '/'
    });
})();
// Dev only (Parcel strips `module.hot` from production builds). Parcel's HMR
// client marks an update "handled" without reloading when the changed module
// has not executed yet or lives in a bundle this page has not loaded — the
// common case here, since sub-apps and pages are lazy-loaded. Nothing in the
// shell hot-applies modules, so always fall back to a full reload.
if (null) window.addEventListener('parcelhmraccept', ()=>location.reload());


//# sourceMappingURL=workspace.76318504.js.map
